
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7c62"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7c62"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ih19M", function(module, exports) {
"use strict";

module.exports = (parcelRequire("0qhf8"));

});
parcelRegister("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRegister("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cCfq4"));

});
parcelRegister("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
"use strict";
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("10WBQ", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $0bd3411f2ec14e23$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $0bd3411f2ec14e23$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("99w1R")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("99w1R")).useNavigate; });
/**
 * React Router DOM v6.22.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");

var $fSADM = parcelRequire("fSADM");
var $99w1R = parcelRequire("99w1R");

var $fSADM = parcelRequire("fSADM");
function $0bd3411f2ec14e23$var$_extends() {
    $0bd3411f2ec14e23$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0bd3411f2ec14e23$var$_extends.apply(this, arguments);
}
function $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0bd3411f2ec14e23$var$defaultMethod = "get";
const $0bd3411f2ec14e23$var$defaultEncType = "application/x-www-form-urlencoded";
function $0bd3411f2ec14e23$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0bd3411f2ec14e23$var$isButtonElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0bd3411f2ec14e23$var$isFormElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0bd3411f2ec14e23$var$isInputElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0bd3411f2ec14e23$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0bd3411f2ec14e23$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0bd3411f2ec14e23$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0bd3411f2ec14e23$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = null;
function $0bd3411f2ec14e23$var$isFormDataSubmitterSupported() {
    if ($0bd3411f2ec14e23$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = true;
    }
    return $0bd3411f2ec14e23$var$_formDataSupportsSubmitter;
}
const $0bd3411f2ec14e23$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0bd3411f2ec14e23$var$getFormEncType(encType) {
    if (encType != null && !$0bd3411f2ec14e23$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($0bd3411f2ec14e23$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $fSADM.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $0bd3411f2ec14e23$var$defaultMethod;
        encType = $0bd3411f2ec14e23$var$getFormEncType(target.getAttribute("enctype")) || $0bd3411f2ec14e23$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0bd3411f2ec14e23$var$isButtonElement(target) || $0bd3411f2ec14e23$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $fSADM.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0bd3411f2ec14e23$var$defaultMethod;
        encType = $0bd3411f2ec14e23$var$getFormEncType(target.getAttribute("formenctype")) || $0bd3411f2ec14e23$var$getFormEncType(form.getAttribute("enctype")) || $0bd3411f2ec14e23$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0bd3411f2ec14e23$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0bd3411f2ec14e23$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0bd3411f2ec14e23$var$defaultMethod;
        action = null;
        encType = $0bd3411f2ec14e23$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $0bd3411f2ec14e23$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $0bd3411f2ec14e23$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $0bd3411f2ec14e23$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $0bd3411f2ec14e23$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $0bd3411f2ec14e23$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $0bd3411f2ec14e23$export$1f3f55432a00e06d(routes, opts) {
    return (0, $fSADM.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0bd3411f2ec14e23$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fSADM.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0bd3411f2ec14e23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $99w1R.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0bd3411f2ec14e23$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $fSADM.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0bd3411f2ec14e23$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fSADM.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0bd3411f2ec14e23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $99w1R.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0bd3411f2ec14e23$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0bd3411f2ec14e23$var$_extends({}, state, {
        errors: $0bd3411f2ec14e23$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0bd3411f2ec14e23$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $fSADM.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $0bd3411f2ec14e23$export$7ad602f0e94e62d1 = /*#__PURE__*/ $bh6RR.createContext({
    isTransitioning: false
});
const $0bd3411f2ec14e23$export$148fd98d095596d4 = /*#__PURE__*/ $bh6RR.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0bd3411f2ec14e23$var$START_TRANSITION = "startTransition";
const $0bd3411f2ec14e23$var$startTransitionImpl = $bh6RR[$0bd3411f2ec14e23$var$START_TRANSITION];
const $0bd3411f2ec14e23$var$FLUSH_SYNC = "flushSync";
const $0bd3411f2ec14e23$var$flushSyncImpl = $6afFj[$0bd3411f2ec14e23$var$FLUSH_SYNC];
const $0bd3411f2ec14e23$var$USE_ID = "useId";
const $0bd3411f2ec14e23$var$useIdImpl = $bh6RR[$0bd3411f2ec14e23$var$USE_ID];
function $0bd3411f2ec14e23$var$startTransitionSafe(cb) {
    if ($0bd3411f2ec14e23$var$startTransitionImpl) $0bd3411f2ec14e23$var$startTransitionImpl(cb);
    else cb();
}
function $0bd3411f2ec14e23$var$flushSyncSafe(cb) {
    if ($0bd3411f2ec14e23$var$flushSyncImpl) $0bd3411f2ec14e23$var$flushSyncImpl(cb);
    else cb();
}
class $0bd3411f2ec14e23$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0bd3411f2ec14e23$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $bh6RR.useState(router.state);
    let [pendingState, setPendingState] = $bh6RR.useState();
    let [vtContext, setVtContext] = $bh6RR.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $bh6RR.useState();
    let [transition, setTransition] = $bh6RR.useState();
    let [interruption, setInterruption] = $bh6RR.useState();
    let fetcherData = $bh6RR.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $bh6RR.useCallback((cb)=>{
        if (v7_startTransition) $0bd3411f2ec14e23$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $bh6RR.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $0bd3411f2ec14e23$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $0bd3411f2ec14e23$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $0bd3411f2ec14e23$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $0bd3411f2ec14e23$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $0bd3411f2ec14e23$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $bh6RR.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $bh6RR.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $0bd3411f2ec14e23$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $bh6RR.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $bh6RR.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $0bd3411f2ec14e23$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $99w1R.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0bd3411f2ec14e23$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fSADM.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0bd3411f2ec14e23$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fSADM.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0bd3411f2ec14e23$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $0bd3411f2ec14e23$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $0bd3411f2ec14e23$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $0bd3411f2ec14e23$export$a6c7ac8248d6e38a = /*#__PURE__*/ $bh6RR.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref7, $0bd3411f2ec14e23$var$_excluded);
    let { basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $0bd3411f2ec14e23$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0bd3411f2ec14e23$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $fSADM.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $99w1R.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $0bd3411f2ec14e23$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $bh6RR.createElement("a", $0bd3411f2ec14e23$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $0bd3411f2ec14e23$export$b0d92dbee9b5b60d = /*#__PURE__*/ $bh6RR.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref8, $0bd3411f2ec14e23$var$_excluded2);
    let path = (0, $99w1R.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $99w1R.useLocation)();
    let routerState = $bh6RR.useContext((0, $99w1R.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $0bd3411f2ec14e23$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $fSADM.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$a6c7ac8248d6e38a, $0bd3411f2ec14e23$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $0bd3411f2ec14e23$export$a7fed597f4b8afd8 = /*#__PURE__*/ $bh6RR.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $0bd3411f2ec14e23$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref9, $0bd3411f2ec14e23$var$_excluded3);
    let submit = $0bd3411f2ec14e23$export$47c85c6e3a081d3();
    let formAction = $0bd3411f2ec14e23$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $bh6RR.createElement("form", $0bd3411f2ec14e23$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0bd3411f2ec14e23$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $0bd3411f2ec14e23$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0bd3411f2ec14e23$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($0bd3411f2ec14e23$var$DataRouterHook || ($0bd3411f2ec14e23$var$DataRouterHook = {}));
var $0bd3411f2ec14e23$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0bd3411f2ec14e23$var$DataRouterStateHook || ($0bd3411f2ec14e23$var$DataRouterStateHook = {}));
// Internal hooks
function $0bd3411f2ec14e23$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $0bd3411f2ec14e23$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext((0, $99w1R.UNSAFE_DataRouterContext));
    !ctx && (0, $fSADM.UNSAFE_invariant)(false);
    return ctx;
}
function $0bd3411f2ec14e23$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext((0, $99w1R.UNSAFE_DataRouterStateContext));
    !state && (0, $fSADM.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0bd3411f2ec14e23$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $99w1R.useNavigate)();
    let location = (0, $99w1R.useLocation)();
    let path = (0, $99w1R.useResolvedPath)(to, {
        relative: relative
    });
    return $bh6RR.useCallback((event)=>{
        if ($0bd3411f2ec14e23$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $fSADM.createPath)(location) === (0, $fSADM.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0bd3411f2ec14e23$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $bh6RR.useRef($0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $bh6RR.useRef(false);
    let location = (0, $99w1R.useLocation)();
    let searchParams = $bh6RR.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0bd3411f2ec14e23$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $99w1R.useNavigate)();
    let setSearchParams = $bh6RR.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0bd3411f2ec14e23$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $0bd3411f2ec14e23$var$fetcherId = 0;
let $0bd3411f2ec14e23$var$getUniqueFetcherId = ()=>"__" + String(++$0bd3411f2ec14e23$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0bd3411f2ec14e23$export$47c85c6e3a081d3() {
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    let currentRouteId = (0, $99w1R.UNSAFE_useRouteId)();
    return $bh6RR.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0bd3411f2ec14e23$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $0bd3411f2ec14e23$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0bd3411f2ec14e23$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    let routeContext = $bh6RR.useContext((0, $99w1R.UNSAFE_RouteContext));
    !routeContext && (0, $fSADM.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $0bd3411f2ec14e23$var$_extends({}, (0, $99w1R.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $99w1R.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $fSADM.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $fSADM.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0bd3411f2ec14e23$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseFetcher);
    let state = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $bh6RR.useContext($0bd3411f2ec14e23$export$148fd98d095596d4);
    let route = $bh6RR.useContext((0, $99w1R.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $fSADM.UNSAFE_invariant)(false);
    !route && (0, $fSADM.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $fSADM.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $0bd3411f2ec14e23$var$useIdImpl ? $0bd3411f2ec14e23$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $bh6RR.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($0bd3411f2ec14e23$var$getUniqueFetcherId());
    // Registration/cleanup
    $bh6RR.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $bh6RR.useCallback((href, opts)=>{
        !routeId && (0, $fSADM.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $0bd3411f2ec14e23$export$47c85c6e3a081d3();
    let submit = $bh6RR.useCallback((target, opts)=>{
        submitImpl(target, $0bd3411f2ec14e23$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $bh6RR.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $bh6RR.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$a7fed597f4b8afd8, $0bd3411f2ec14e23$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $fSADM.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $bh6RR.useMemo(()=>$0bd3411f2ec14e23$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0bd3411f2ec14e23$export$fa996778a3a31087() {
    let state = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $0bd3411f2ec14e23$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $0bd3411f2ec14e23$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0bd3411f2ec14e23$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    let location = (0, $99w1R.useLocation)();
    let matches = (0, $99w1R.useMatches)();
    let navigation = (0, $99w1R.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $bh6RR.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0bd3411f2ec14e23$var$usePageHide($bh6RR.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $0bd3411f2ec14e23$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0bd3411f2ec14e23$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0bd3411f2ec14e23$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($0bd3411f2ec14e23$var$_extends({}, location, {
                    pathname: (0, $fSADM.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0bd3411f2ec14e23$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0bd3411f2ec14e23$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0bd3411f2ec14e23$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0bd3411f2ec14e23$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $99w1R.useBlocker)(when);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $0bd3411f2ec14e23$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $bh6RR.useContext($0bd3411f2ec14e23$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $fSADM.UNSAFE_invariant)(false);
    let { basename: basename } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.useViewTransitionState);
    let path = (0, $99w1R.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $fSADM.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $fSADM.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $fSADM.matchPath)(path.pathname, nextPath) != null || (0, $fSADM.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("6afFj", function(module, exports) {
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

module.exports = (parcelRequire("foRq4"));

});
parcelRegister("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $b36288e2db101ba3$var$Mg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Ng = null, $b36288e2db101ba3$var$Og = null, $b36288e2db101ba3$var$Pg = null;
function $b36288e2db101ba3$var$Qg() {
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Ng = null;
}
function $b36288e2db101ba3$var$Rg(a) {
    var b = $b36288e2db101ba3$var$Mg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Mg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$Tg(a, b) {
    $b36288e2db101ba3$var$Ng = a;
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$Ug = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$Vg(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Og) {
            if (null === $b36288e2db101ba3$var$Ng) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Og = a;
            $b36288e2db101ba3$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Og.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$Wg = null;
function $b36288e2db101ba3$var$Xg(a) {
    null === $b36288e2db101ba3$var$Wg ? $b36288e2db101ba3$var$Wg = [
        a
    ] : $b36288e2db101ba3$var$Wg.push(a);
}
function $b36288e2db101ba3$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$Zg(a, d);
}
function $b36288e2db101ba3$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$$g = !1;
function $b36288e2db101ba3$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$Zg(a, c);
}
function $b36288e2db101ba3$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$jh = (new $bh6RR.Component).refs;
function $b36288e2db101ba3$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$L(), d = $b36288e2db101ba3$var$lh(a), e = $b36288e2db101ba3$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$dh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, d, c), $b36288e2db101ba3$var$eh(b, a, d));
    }
};
function $b36288e2db101ba3$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$ph(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$Vg(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$nh.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $b36288e2db101ba3$var$jh;
    $b36288e2db101ba3$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$Vg(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$nh.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $b36288e2db101ba3$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$sh(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$sh(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$zh(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Ah(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Bh = $b36288e2db101ba3$var$vh(!0), $b36288e2db101ba3$var$Ch = $b36288e2db101ba3$var$vh(!1), $b36288e2db101ba3$var$Dh = {}, $b36288e2db101ba3$var$Eh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh);
function $b36288e2db101ba3$var$Hh(a) {
    if (a === $b36288e2db101ba3$var$Dh) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$Ih(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Gh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, $b36288e2db101ba3$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, b);
}
function $b36288e2db101ba3$var$Jh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Gh);
}
function $b36288e2db101ba3$var$Kh(a) {
    $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
    var b = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, c));
}
function $b36288e2db101ba3$var$Lh(a) {
    $b36288e2db101ba3$var$Fh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh));
}
var $b36288e2db101ba3$var$M = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nh = [];
function $b36288e2db101ba3$var$Oh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Nh.length; a++)$b36288e2db101ba3$var$Nh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Nh.length = 0;
}
var $b36288e2db101ba3$var$Ph = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Qh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Rh = 0, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$P = null, $b36288e2db101ba3$var$Sh = !1, $b36288e2db101ba3$var$Th = !1, $b36288e2db101ba3$var$Uh = 0, $b36288e2db101ba3$var$Vh = 0;
function $b36288e2db101ba3$var$Q() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Xh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Rh = f;
    $b36288e2db101ba3$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Ph.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Yh : $b36288e2db101ba3$var$Zh;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Th) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$$h;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Th);
    }
    $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
    b = null !== $b36288e2db101ba3$var$O && null !== $b36288e2db101ba3$var$O.next;
    $b36288e2db101ba3$var$Rh = 0;
    $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
    $b36288e2db101ba3$var$Sh = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$bi() {
    var a = 0 !== $b36288e2db101ba3$var$Uh;
    $b36288e2db101ba3$var$Uh = 0;
    return a;
}
function $b36288e2db101ba3$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$di() {
    if (null === $b36288e2db101ba3$var$O) {
        var a = $b36288e2db101ba3$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$O.next;
    var b = null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState : $b36288e2db101ba3$var$P.next;
    if (null !== b) $b36288e2db101ba3$var$P = b, $b36288e2db101ba3$var$O = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$O = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$O.memoizedState,
            baseState: $b36288e2db101ba3$var$O.baseState,
            baseQueue: $b36288e2db101ba3$var$O.baseQueue,
            queue: $b36288e2db101ba3$var$O.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    }
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$N.lanes |= m;
                $b36288e2db101ba3$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$N.lanes |= f, $b36288e2db101ba3$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$gi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$hi() {}
function $b36288e2db101ba3$var$ii(a, b) {
    var c = $b36288e2db101ba3$var$N, d = $b36288e2db101ba3$var$di(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$Ug = !0);
    d = d.queue;
    $b36288e2db101ba3$var$ji($b36288e2db101ba3$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$P && $b36288e2db101ba3$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
}
function $b36288e2db101ba3$var$ki(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
    });
}
function $b36288e2db101ba3$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$pi(a) {
    var b = $b36288e2db101ba3$var$Zg(a, 1);
    null !== b && $b36288e2db101ba3$var$mh(b, a, 1, -1);
}
function $b36288e2db101ba3$var$qi(a) {
    var b = $b36288e2db101ba3$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ri.bind(null, $b36288e2db101ba3$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$si() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$ti(a, b, c, d) {
    var e = $b36288e2db101ba3$var$ci();
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$ui(a, b, c, d) {
    var e = $b36288e2db101ba3$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$O) {
        var g = $b36288e2db101ba3$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Wh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$li(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$vi(a, b) {
    return $b36288e2db101ba3$var$ti(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$ji(a, b) {
    return $b36288e2db101ba3$var$ui(2048, 8, a, b);
}
function $b36288e2db101ba3$var$wi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 2, a, b);
}
function $b36288e2db101ba3$var$xi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 4, a, b);
}
function $b36288e2db101ba3$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$ui(4, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$Ai() {}
function $b36288e2db101ba3$var$Bi(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Ci(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Di(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Rh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$Ug = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$N.lanes |= c, $b36288e2db101ba3$var$hh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$Ei(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Qh.transition;
    $b36288e2db101ba3$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Qh.transition = d;
    }
}
function $b36288e2db101ba3$var$Fi() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, c);
    else if (c = $b36288e2db101ba3$var$Yg(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$L();
        $b36288e2db101ba3$var$mh(c, a, d, e);
        $b36288e2db101ba3$var$Ji(c, b, d);
    }
}
function $b36288e2db101ba3$var$ri(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$Yg(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$L(), $b36288e2db101ba3$var$mh(c, a, d, e), $b36288e2db101ba3$var$Ji(c, b, d));
    }
}
function $b36288e2db101ba3$var$Hi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$N || null !== b && b === $b36288e2db101ba3$var$N;
}
function $b36288e2db101ba3$var$Ii(a, b) {
    $b36288e2db101ba3$var$Th = $b36288e2db101ba3$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$ai = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Q,
    useContext: $b36288e2db101ba3$var$Q,
    useEffect: $b36288e2db101ba3$var$Q,
    useImperativeHandle: $b36288e2db101ba3$var$Q,
    useInsertionEffect: $b36288e2db101ba3$var$Q,
    useLayoutEffect: $b36288e2db101ba3$var$Q,
    useMemo: $b36288e2db101ba3$var$Q,
    useReducer: $b36288e2db101ba3$var$Q,
    useRef: $b36288e2db101ba3$var$Q,
    useState: $b36288e2db101ba3$var$Q,
    useDebugValue: $b36288e2db101ba3$var$Q,
    useDeferredValue: $b36288e2db101ba3$var$Q,
    useTransition: $b36288e2db101ba3$var$Q,
    useMutableSource: $b36288e2db101ba3$var$Q,
    useSyncExternalStore: $b36288e2db101ba3$var$Q,
    useId: $b36288e2db101ba3$var$Q,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Yh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ti(4194308, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$Gi.bind(null, $b36288e2db101ba3$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$qi,
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$qi(!1), b = a[0];
        a = $b36288e2db101ba3$var$Ei.bind(null, a[1]);
        $b36288e2db101ba3$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$N, e = $b36288e2db101ba3$var$ci();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$vi($b36288e2db101ba3$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$ci(), b = $b36288e2db101ba3$var$R.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Zh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$fi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$$h = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$gi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return null === $b36288e2db101ba3$var$O ? b.memoizedState = a : $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Oi(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Pi || ($b36288e2db101ba3$var$Pi = !0, $b36288e2db101ba3$var$Qi = d);
        $b36288e2db101ba3$var$Mi(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Ri(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Mi(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Si ? $b36288e2db101ba3$var$Si = new Set([
            this
        ]) : $b36288e2db101ba3$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$ch(-1, 1), b.tag = 2, $b36288e2db101ba3$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Xi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$Ug = !1;
function $b36288e2db101ba3$var$Yi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Ch(b, null, c, d) : $b36288e2db101ba3$var$Bh(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$Tg(b, e);
    d = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$cj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$Ug = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$$i(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$dj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj);
            $b36288e2db101ba3$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= d;
    $b36288e2db101ba3$var$Yi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$dj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$Tg(b, e);
    c = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$Tg(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$jj(a, b), $b36288e2db101ba3$var$ph(b, c, d), $b36288e2db101ba3$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$Vg(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$qh(b, g, d, l);
        $b36288e2db101ba3$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof m && ($b36288e2db101ba3$var$kh(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$Vg(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$qh(b, g, d, k);
        $b36288e2db101ba3$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof y && ($b36288e2db101ba3$var$kh(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$kj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$kj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$$i(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Bh(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Bh(b, null, h, f)) : $b36288e2db101ba3$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$Ih(a, b.containerInfo);
}
function $b36288e2db101ba3$var$mj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Yi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$pj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$qj(g, d, 0, null), a = $b36288e2db101ba3$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$oj(c), b.memoizedState = $b36288e2db101ba3$var$nj, a) : $b36288e2db101ba3$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$wh(h, f) : (f = $b36288e2db101ba3$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$rj(a, b) {
    b = $b36288e2db101ba3$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$tj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Bh(b, a.child, null, c);
    a = $b36288e2db101ba3$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$oj(g);
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Li(f, d, void 0);
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$Ug || h) {
        d = $b36288e2db101ba3$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$Zg(a, e), $b36288e2db101ba3$var$mh(d, a, e, -1));
        }
        $b36288e2db101ba3$var$uj();
        d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$Sg(a.return, b, c);
}
function $b36288e2db101ba3$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Yi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$wj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$lj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Kh(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$pj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
                a = $b36288e2db101ba3$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$ej(a, b, c);
    }
    return $b36288e2db101ba3$var$$i(a, b, c);
}
var $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj, $b36288e2db101ba3$var$Dj;
$b36288e2db101ba3$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Bj = function() {};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Ej(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$Jh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Bj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Lh(b);
            var e = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
                $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$M.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$Bj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Ej(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Hj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$M.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$gj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Jj(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Lh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M), null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Kj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Oj = !1;
function $b36288e2db101ba3$var$Pj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Oj;
    $b36288e2db101ba3$var$Oj = !1;
    return n;
}
function $b36288e2db101ba3$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Yj = !1;
function $b36288e2db101ba3$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$ak(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$ak(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Mj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Yj = !0;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Nj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Zj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Zj(a, b, c);
    }
}
function $b36288e2db101ba3$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Lj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Yj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$ak(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$ek(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Qj(3, a, a.return), $b36288e2db101ba3$var$Rj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Qj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            break;
        case 13:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$gk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$fk(a);
    }
}
function $b36288e2db101ba3$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$jk(a, b, c);
}
function $b36288e2db101ba3$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Kj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Kj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$kk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$kk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$jk(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Kj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$lk(a, b, c);
    }
}
function $b36288e2db101ba3$var$lk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Sj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$hk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$mk = Math.ceil, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$pk = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$gj = 0, $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$qk = null, $b36288e2db101ba3$var$hh = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = 0, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$gk = 0, $b36288e2db101ba3$var$Hj = Infinity, $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Pi = !1, $b36288e2db101ba3$var$Qi = null, $b36288e2db101ba3$var$Si = null, $b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = null, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, $b36288e2db101ba3$var$Bk = -1, $b36288e2db101ba3$var$Ck = 0;
function $b36288e2db101ba3$var$L() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Bk ? $b36288e2db101ba3$var$Bk : $b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Ck && ($b36288e2db101ba3$var$Ck = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Ck;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$mh(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$zk) throw $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$R) a === $b36288e2db101ba3$var$R && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$rk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Ek(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Ek(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Fk.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Fk.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Gk(c, $b36288e2db101ba3$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Hk(a, b) {
    $b36288e2db101ba3$var$Bk = -1;
    $b36288e2db101ba3$var$Ck = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Ik() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Jk(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Kk();
        if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Lk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Mk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Nk(a, h);
        }
        $b36288e2db101ba3$var$Qg();
        $b36288e2db101ba3$var$nk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Ok(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Pk(e) && (b = $b36288e2db101ba3$var$Jk(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Ok(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$gk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Hk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Ok(a, b) {
    var c = $b36288e2db101ba3$var$tk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Lk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Jk(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$uk = c, null !== b && $b36288e2db101ba3$var$Gj(b));
    return a;
}
function $b36288e2db101ba3$var$Gj(a) {
    null === $b36288e2db101ba3$var$uk ? $b36288e2db101ba3$var$uk = a : $b36288e2db101ba3$var$uk.push.apply($b36288e2db101ba3$var$uk, a);
}
function $b36288e2db101ba3$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Dk(a, b) {
    b &= ~$b36288e2db101ba3$var$sk;
    b &= ~$b36288e2db101ba3$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Fk(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Ok(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, b), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Rk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Sk(a) {
    null !== $b36288e2db101ba3$var$xk && 0 === $b36288e2db101ba3$var$xk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$pk.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$pk.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Ij() {
    $b36288e2db101ba3$var$gj = $b36288e2db101ba3$var$fj.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$fj);
}
function $b36288e2db101ba3$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$Jh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Oh();
                break;
            case 5:
                $b36288e2db101ba3$var$Lh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$Jh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 10:
                $b36288e2db101ba3$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Ij();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$R = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$wh(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$gj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$qk = null;
    $b36288e2db101ba3$var$sk = $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$hh = 0;
    $b36288e2db101ba3$var$uk = $b36288e2db101ba3$var$tk = null;
    if (null !== $b36288e2db101ba3$var$Wg) {
        for(b = 0; b < $b36288e2db101ba3$var$Wg.length; b++)if (c = $b36288e2db101ba3$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$Wg = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$Qg();
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
            if ($b36288e2db101ba3$var$Sh) {
                for(var d = $b36288e2db101ba3$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Sh = !1;
            }
            $b36288e2db101ba3$var$Rh = 0;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            $b36288e2db101ba3$var$ok.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$qk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Ti(f, l, b);
                            $b36288e2db101ba3$var$uj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Wi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ki(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = [
                    f
                ] : $b36288e2db101ba3$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Oi(f, k, b);
                            $b36288e2db101ba3$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Ri(f, h, b);
                                $b36288e2db101ba3$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Tk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Kk() {
    var a = $b36288e2db101ba3$var$nk.current;
    $b36288e2db101ba3$var$nk.current = $b36288e2db101ba3$var$ai;
    return null === a ? $b36288e2db101ba3$var$ai : a;
}
function $b36288e2db101ba3$var$uj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$R || 0 === ($b36288e2db101ba3$var$hh & 268435455) && 0 === ($b36288e2db101ba3$var$rk & 268435455) || $b36288e2db101ba3$var$Dk($b36288e2db101ba3$var$R, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Jk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Kk();
    if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Lk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Uk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Nk(a, e);
    }
    $b36288e2db101ba3$var$Qg();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$nk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$R = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Uk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Mk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Vk(a) {
    var b = $b36288e2db101ba3$var$Wk(a.alternate, a, $b36288e2db101ba3$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Tk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$ok.current = null;
}
function $b36288e2db101ba3$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Fj(c, b, $b36288e2db101ba3$var$gj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Qk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$pk.transition;
    try {
        $b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Xk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$pk.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Xk(a, b, c, d) {
    do $b36288e2db101ba3$var$Ik();
    while (null !== $b36288e2db101ba3$var$xk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$R && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$wk || ($b36288e2db101ba3$var$wk = !0, $b36288e2db101ba3$var$Gk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$pk.transition;
        $b36288e2db101ba3$var$pk.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$ok.current = null;
        $b36288e2db101ba3$var$Pj(a, c);
        $b36288e2db101ba3$var$ek(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$ik(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$pk.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$wk && ($b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = a, $b36288e2db101ba3$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Si = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Pi) throw $b36288e2db101ba3$var$Pi = !1, a = $b36288e2db101ba3$var$Qi, $b36288e2db101ba3$var$Qi = null, a;
    0 !== ($b36288e2db101ba3$var$yk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$zk++ : ($b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = a) : $b36288e2db101ba3$var$zk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Ik() {
    if (null !== $b36288e2db101ba3$var$xk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$yk), b = $b36288e2db101ba3$var$pk.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$pk.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$xk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$xk;
                $b36288e2db101ba3$var$xk = null;
                $b36288e2db101ba3$var$yk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Tj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Rj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$pk.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Yk(a, b, c) {
    b = $b36288e2db101ba3$var$Ki(c, b);
    b = $b36288e2db101ba3$var$Oi(a, b, 1);
    a = $b36288e2db101ba3$var$dh(a, b, 1);
    b = $b36288e2db101ba3$var$L();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Ek(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(d))) {
                a = $b36288e2db101ba3$var$Ki(c, a);
                a = $b36288e2db101ba3$var$Ri(b, a, 1);
                b = $b36288e2db101ba3$var$dh(b, a, 1);
                a = $b36288e2db101ba3$var$L();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$R === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$gk ? $b36288e2db101ba3$var$Lk(a, 0) : $b36288e2db101ba3$var$sk |= c);
    $b36288e2db101ba3$var$Ek(a, b);
}
function $b36288e2db101ba3$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$L();
    a = $b36288e2db101ba3$var$Zg(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Ek(a, c));
}
function $b36288e2db101ba3$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Zk(a, c);
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Zk(a, c);
}
var $b36288e2db101ba3$var$Wk;
$b36288e2db101ba3$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$zj(a, b, c);
            $b36288e2db101ba3$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$jj(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$Tg(b, c);
            e = $b36288e2db101ba3$var$Xh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$ah(b), e.updater = $b36288e2db101ba3$var$nh, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$rh(b, d, a, c), b = $b36288e2db101ba3$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$$k(d);
                a = $b36288e2db101ba3$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$aj(null, b, d, $b36288e2db101ba3$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$lj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$bh(a, b);
                $b36288e2db101ba3$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$$i(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Kh(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$hj(a, b), $b36288e2db101ba3$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$pj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Bh(b, null, d, c) : $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$Zi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$Tg(b, c), e = $b36288e2db101ba3$var$Vg(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Lg(d, b.pendingProps), e = $b36288e2db101ba3$var$Lg(d.type, e), $b36288e2db101ba3$var$aj(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$jj(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$Tg(b, c), $b36288e2db101ba3$var$ph(b, d, e), $b36288e2db101ba3$var$rh(b, d, e, c), $b36288e2db101ba3$var$kj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$yj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$ej(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Gk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$al(a, b, c, d);
}
function $b36288e2db101ba3$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$$k(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Ah(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Ah(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$qj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$xh(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$zh(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$ah(f);
    return a;
}
function $b36288e2db101ba3$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$el(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$el(null);
    c = a.current;
    d = $b36288e2db101ba3$var$L();
    e = $b36288e2db101ba3$var$lh(c);
    f = $b36288e2db101ba3$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$dh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Ek(a, d);
    return a;
}
function $b36288e2db101ba3$var$gl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$L(), g = $b36288e2db101ba3$var$lh(e);
    c = $b36288e2db101ba3$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$dh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$mh(a, e, g, f), $b36288e2db101ba3$var$eh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$jl(a, b) {
    $b36288e2db101ba3$var$il(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$il(a, b);
}
function $b36288e2db101ba3$var$kl() {
    return null;
}
var $b36288e2db101ba3$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.render = $b36288e2db101ba3$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$gl(a, b, null, null);
};
$b36288e2db101ba3$var$nl.prototype.unmount = $b36288e2db101ba3$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Sk(function() {
            $b36288e2db101ba3$var$gl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$nl(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$ql() {}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$fl(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$ql);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$hl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$cl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$ql);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$gl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$gl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$rl(c, b, a, e, d);
    return $b36288e2db101ba3$var$hl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Ek(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Sk(function() {
                var b = $b36288e2db101ba3$var$Zg(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$L();
                    $b36288e2db101ba3$var$mh(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$jl(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$jl(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$lh(a), c = $b36288e2db101ba3$var$Zg(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(c, a, b, d);
        }
        $b36288e2db101ba3$var$jl(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Sk;
var $b36288e2db101ba3$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Rk
    ]
}, $b36288e2db101ba3$var$ul = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$vl = {
    bundleType: $b36288e2db101ba3$var$ul.bundleType,
    version: $b36288e2db101ba3$var$ul.version,
    rendererPackageName: $b36288e2db101ba3$var$ul.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$ul.findFiberByHostInstance || $b36288e2db101ba3$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$wl.isDisabled && $b36288e2db101ba3$var$wl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$wl.inject($b36288e2db101ba3$var$vl), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$wl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$tl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$dl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Sk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$nl(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$pl(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$pl(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$sl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8BKFp"));

});
parcelRegister("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
"use strict";
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});




parcelRegister("fSADM", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $b8f852338811df1a$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $b8f852338811df1a$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $b8f852338811df1a$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $b8f852338811df1a$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $b8f852338811df1a$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $b8f852338811df1a$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $b8f852338811df1a$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $b8f852338811df1a$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $b8f852338811df1a$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $b8f852338811df1a$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $b8f852338811df1a$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $b8f852338811df1a$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $b8f852338811df1a$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $b8f852338811df1a$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $b8f852338811df1a$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $b8f852338811df1a$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $b8f852338811df1a$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $b8f852338811df1a$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $b8f852338811df1a$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $b8f852338811df1a$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.15.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $b8f852338811df1a$var$_extends() {
    $b8f852338811df1a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b8f852338811df1a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $b8f852338811df1a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($b8f852338811df1a$export$e19cd5f9376f8cee || ($b8f852338811df1a$export$e19cd5f9376f8cee = {}));
const $b8f852338811df1a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $b8f852338811df1a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $b8f852338811df1a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $b8f852338811df1a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $b8f852338811df1a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $b8f852338811df1a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
    }
    return $b8f852338811df1a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $b8f852338811df1a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $b8f852338811df1a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $b8f852338811df1a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $b8f852338811df1a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $b8f852338811df1a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $b8f852338811df1a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $b8f852338811df1a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $b8f852338811df1a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $b8f852338811df1a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $b8f852338811df1a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $b8f852338811df1a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $b8f852338811df1a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $b8f852338811df1a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $b8f852338811df1a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $b8f852338811df1a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($b8f852338811df1a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        let location = $b8f852338811df1a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $b8f852338811df1a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        let location = $b8f852338811df1a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $b8f852338811df1a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $b8f852338811df1a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($b8f852338811df1a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($b8f852338811df1a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $b8f852338811df1a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($b8f852338811df1a$var$ResultType || ($b8f852338811df1a$var$ResultType = {}));
const $b8f852338811df1a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $b8f852338811df1a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $b8f852338811df1a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $b8f852338811df1a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $b8f852338811df1a$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($b8f852338811df1a$var$isIndexRoute(route)) {
            let indexRoute = $b8f852338811df1a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $b8f852338811df1a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $b8f852338811df1a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $b8f852338811df1a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $b8f852338811df1a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $b8f852338811df1a$var$flattenRoutes(routes);
    $b8f852338811df1a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $b8f852338811df1a$var$decodePath(pathname);
        matches = $b8f852338811df1a$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $b8f852338811df1a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $b8f852338811df1a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $b8f852338811df1a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $b8f852338811df1a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $b8f852338811df1a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $b8f852338811df1a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $b8f852338811df1a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $b8f852338811df1a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $b8f852338811df1a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $b8f852338811df1a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $b8f852338811df1a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $b8f852338811df1a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $b8f852338811df1a$var$paramRe = /^:[\w-]+$/;
const $b8f852338811df1a$var$dynamicSegmentValue = 3;
const $b8f852338811df1a$var$indexRouteValue = 2;
const $b8f852338811df1a$var$emptySegmentValue = 1;
const $b8f852338811df1a$var$staticSegmentValue = 10;
const $b8f852338811df1a$var$splatPenalty = -2;
const $b8f852338811df1a$var$isSplat = (s)=>s === "*";
function $b8f852338811df1a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($b8f852338811df1a$var$isSplat)) initialScore += $b8f852338811df1a$var$splatPenalty;
    if (index) initialScore += $b8f852338811df1a$var$indexRouteValue;
    return segments.filter((s)=>!$b8f852338811df1a$var$isSplat(s)).reduce((score, segment)=>score + ($b8f852338811df1a$var$paramRe.test(segment) ? $b8f852338811df1a$var$dynamicSegmentValue : segment === "" ? $b8f852338811df1a$var$emptySegmentValue : $b8f852338811df1a$var$staticSegmentValue), initialScore);
}
function $b8f852338811df1a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $b8f852338811df1a$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $b8f852338811df1a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $b8f852338811df1a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $b8f852338811df1a$export$a5c6d149b50c1d86($b8f852338811df1a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $b8f852338811df1a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $b8f852338811df1a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $b8f852338811df1a$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $b8f852338811df1a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $b8f852338811df1a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $b8f852338811df1a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $b8f852338811df1a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $b8f852338811df1a$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $b8f852338811df1a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $b8f852338811df1a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $b8f852338811df1a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $b8f852338811df1a$var$normalizeSearch(search),
        hash: $b8f852338811df1a$var$normalizeHash(hash)
    };
}
function $b8f852338811df1a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $b8f852338811df1a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $b8f852338811df1a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $b8f852338811df1a$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $b8f852338811df1a$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $b8f852338811df1a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $b8f852338811df1a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $b8f852338811df1a$var$_extends({}, toArg);
        $b8f852338811df1a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $b8f852338811df1a$var$getInvalidPathError("?", "pathname", "search", to));
        $b8f852338811df1a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $b8f852338811df1a$var$getInvalidPathError("#", "pathname", "hash", to));
        $b8f852338811df1a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $b8f852338811df1a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $b8f852338811df1a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $b8f852338811df1a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $b8f852338811df1a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $b8f852338811df1a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $b8f852338811df1a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $b8f852338811df1a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $b8f852338811df1a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $b8f852338811df1a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $b8f852338811df1a$export$42a99a7a4bc0e76a extends Error {
}
class $b8f852338811df1a$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $b8f852338811df1a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $b8f852338811df1a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $b8f852338811df1a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $b8f852338811df1a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $b8f852338811df1a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $b8f852338811df1a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $b8f852338811df1a$var$unwrapTrackedPromise(value) {
    if (!$b8f852338811df1a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $b8f852338811df1a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $b8f852338811df1a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $b8f852338811df1a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $b8f852338811df1a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $b8f852338811df1a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $b8f852338811df1a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $b8f852338811df1a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $b8f852338811df1a$var$validMutationMethods = new Set($b8f852338811df1a$var$validMutationMethodsArr);
const $b8f852338811df1a$var$validRequestMethodsArr = [
    "get",
    ...$b8f852338811df1a$var$validMutationMethodsArr
];
const $b8f852338811df1a$var$validRequestMethods = new Set($b8f852338811df1a$var$validRequestMethodsArr);
const $b8f852338811df1a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $b8f852338811df1a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $b8f852338811df1a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b8f852338811df1a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b8f852338811df1a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $b8f852338811df1a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $b8f852338811df1a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $b8f852338811df1a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $b8f852338811df1a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b8f852338811df1a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $b8f852338811df1a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $b8f852338811df1a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $b8f852338811df1a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $b8f852338811df1a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $b8f852338811df1a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$b8f852338811df1a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($b8f852338811df1a$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $b8f852338811df1a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $b8f852338811df1a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $b8f852338811df1a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $b8f852338811df1a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $b8f852338811df1a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($b8f852338811df1a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $b8f852338811df1a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $b8f852338811df1a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $b8f852338811df1a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $b8f852338811df1a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $b8f852338811df1a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $b8f852338811df1a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $b8f852338811df1a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $b8f852338811df1a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $b8f852338811df1a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $b8f852338811df1a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$b8f852338811df1a$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $b8f852338811df1a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $b8f852338811df1a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $b8f852338811df1a$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $b8f852338811df1a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $b8f852338811df1a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $b8f852338811df1a$var$ResultType.error,
            error: $b8f852338811df1a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $b8f852338811df1a$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($b8f852338811df1a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($b8f852338811df1a$var$isDeferredResult(result)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $b8f852338811df1a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $b8f852338811df1a$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $b8f852338811df1a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $b8f852338811df1a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $b8f852338811df1a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($b8f852338811df1a$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $b8f852338811df1a$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $b8f852338811df1a$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $b8f852338811df1a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $b8f852338811df1a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $b8f852338811df1a$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $b8f852338811df1a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b8f852338811df1a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $b8f852338811df1a$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($b8f852338811df1a$var$isRedirectResult(actionResult) || $b8f852338811df1a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($b8f852338811df1a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $b8f852338811df1a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($b8f852338811df1a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($b8f852338811df1a$var$isDeferredResult(actionResult)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $b8f852338811df1a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $b8f852338811df1a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $b8f852338811df1a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $b8f852338811df1a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $b8f852338811df1a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $b8f852338811df1a$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $b8f852338811df1a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $b8f852338811df1a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b8f852338811df1a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $b8f852338811df1a$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($b8f852338811df1a$var$isDeferredResult(result)) result = await $b8f852338811df1a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($b8f852338811df1a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $b8f852338811df1a$export$3e9cee6b33872309(!$b8f852338811df1a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $b8f852338811df1a$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $b8f852338811df1a$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $b8f852338811df1a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $b8f852338811df1a$export$e19cd5f9376f8cee.Replace : $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $b8f852338811df1a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($b8f852338811df1a$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $b8f852338811df1a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $b8f852338811df1a$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $b8f852338811df1a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$b8f852338811df1a$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $b8f852338811df1a$var$callLoaderOrAction("loader", $b8f852338811df1a$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $b8f852338811df1a$var$ResultType.error,
                        error: $b8f852338811df1a$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $b8f852338811df1a$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $b8f852338811df1a$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $b8f852338811df1a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $b8f852338811df1a$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $b8f852338811df1a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $b8f852338811df1a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $b8f852338811df1a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $b8f852338811df1a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $b8f852338811df1a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $b8f852338811df1a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $b8f852338811df1a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$b8f852338811df1a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $b8f852338811df1a$export$4d0306f8f6a4585b = Symbol("deferred");
function $b8f852338811df1a$export$3336b097a6fbc59a(routes, opts) {
    $b8f852338811df1a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b8f852338811df1a$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $b8f852338811df1a$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b8f852338811df1a$var$createLocation("", $b8f852338811df1a$export$fe53371bee54353d(url), null, "default");
        let matches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b8f852338811df1a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($b8f852338811df1a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $b8f852338811df1a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b8f852338811df1a$var$createLocation("", $b8f852338811df1a$export$fe53371bee54353d(url), null, "default");
        let matches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b8f852338811df1a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $b8f852338811df1a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $b8f852338811df1a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $b8f852338811df1a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($b8f852338811df1a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$b8f852338811df1a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $b8f852338811df1a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($b8f852338811df1a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $b8f852338811df1a$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $b8f852338811df1a$var$isResponse(result) ? result : $b8f852338811df1a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($b8f852338811df1a$var$isQueryRouteResponse(e)) {
                if (e.type === $b8f852338811df1a$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($b8f852338811df1a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b8f852338811df1a$var$ResultType.error,
                error: error
            };
        } else {
            result = await $b8f852338811df1a$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $b8f852338811df1a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($b8f852338811df1a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($b8f852338811df1a$var$isDeferredResult(result)) {
            let error = $b8f852338811df1a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b8f852338811df1a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($b8f852338811df1a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $b8f852338811df1a$var$_extends({}, context, {
                statusCode: $b8f852338811df1a$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $b8f852338811df1a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $b8f852338811df1a$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $b8f852338811df1a$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$b8f852338811df1a$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $b8f852338811df1a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $b8f852338811df1a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $b8f852338811df1a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $b8f852338811df1a$export$fec11da027c70692(routes, context, error) {
    let newContext = $b8f852338811df1a$var$_extends({}, context, {
        statusCode: $b8f852338811df1a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $b8f852338811df1a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $b8f852338811df1a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $b8f852338811df1a$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $b8f852338811df1a$export$cae722b0cc860f13(to ? to : ".", $b8f852338811df1a$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $b8f852338811df1a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$b8f852338811df1a$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $b8f852338811df1a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $b8f852338811df1a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $b8f852338811df1a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$b8f852338811df1a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$b8f852338811df1a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $b8f852338811df1a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $b8f852338811df1a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $b8f852338811df1a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$b8f852338811df1a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$b8f852338811df1a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $b8f852338811df1a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $b8f852338811df1a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $b8f852338811df1a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($b8f852338811df1a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $b8f852338811df1a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $b8f852338811df1a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $b8f852338811df1a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $b8f852338811df1a$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($b8f852338811df1a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $b8f852338811df1a$var$shouldRevalidateLoader(match, $b8f852338811df1a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $b8f852338811df1a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $b8f852338811df1a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $b8f852338811df1a$var$shouldRevalidateLoader(fetcherMatch, $b8f852338811df1a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $b8f852338811df1a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $b8f852338811df1a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $b8f852338811df1a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $b8f852338811df1a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $b8f852338811df1a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $b8f852338811df1a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$b8f852338811df1a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $b8f852338811df1a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $b8f852338811df1a$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $b8f852338811df1a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $b8f852338811df1a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $b8f852338811df1a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $b8f852338811df1a$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $b8f852338811df1a$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $b8f852338811df1a$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($b8f852338811df1a$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($b8f852338811df1a$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $b8f852338811df1a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(location)) location = $b8f852338811df1a$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $b8f852338811df1a$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $b8f852338811df1a$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $b8f852338811df1a$var$ResultType.error ? $b8f852338811df1a$var$ResultType.error : $b8f852338811df1a$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $b8f852338811df1a$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $b8f852338811df1a$var$ResultType.error) return {
            type: resultType,
            error: new $b8f852338811df1a$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $b8f852338811df1a$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($b8f852338811df1a$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $b8f852338811df1a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $b8f852338811df1a$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $b8f852338811df1a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($b8f852338811df1a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $b8f852338811df1a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $b8f852338811df1a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $b8f852338811df1a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $b8f852338811df1a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $b8f852338811df1a$export$3e9cee6b33872309(!$b8f852338811df1a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $b8f852338811df1a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($b8f852338811df1a$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $b8f852338811df1a$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $b8f852338811df1a$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($b8f852338811df1a$var$isErrorResult(result)) {
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $b8f852338811df1a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($b8f852338811df1a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $b8f852338811df1a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($b8f852338811df1a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $b8f852338811df1a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $b8f852338811df1a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $b8f852338811df1a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $b8f852338811df1a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $b8f852338811df1a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $b8f852338811df1a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $b8f852338811df1a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $b8f852338811df1a$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($b8f852338811df1a$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $b8f852338811df1a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(path) : path;
    return $b8f852338811df1a$export$fe53371bee54353d($b8f852338811df1a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $b8f852338811df1a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $b8f852338811df1a$var$isDeferredResult(result) {
    return result.type === $b8f852338811df1a$var$ResultType.deferred;
}
function $b8f852338811df1a$var$isErrorResult(result) {
    return result.type === $b8f852338811df1a$var$ResultType.error;
}
function $b8f852338811df1a$var$isRedirectResult(result) {
    return (result && result.type) === $b8f852338811df1a$var$ResultType.redirect;
}
function $b8f852338811df1a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $b8f852338811df1a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $b8f852338811df1a$var$isRedirectResponse(result) {
    if (!$b8f852338811df1a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $b8f852338811df1a$var$isQueryRouteResponse(obj) {
    return obj && $b8f852338811df1a$var$isResponse(obj.response) && (obj.type === $b8f852338811df1a$var$ResultType.data || obj.type === $b8f852338811df1a$var$ResultType.error);
}
function $b8f852338811df1a$var$isValidMethod(method) {
    return $b8f852338811df1a$var$validRequestMethods.has(method.toLowerCase());
}
function $b8f852338811df1a$var$isMutationMethod(method) {
    return $b8f852338811df1a$var$validMutationMethods.has(method.toLowerCase());
}
async function $b8f852338811df1a$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$b8f852338811df1a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($b8f852338811df1a$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $b8f852338811df1a$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $b8f852338811df1a$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $b8f852338811df1a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $b8f852338811df1a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $b8f852338811df1a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $b8f852338811df1a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $b8f852338811df1a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $b8f852338811df1a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $b8f852338811df1a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $b8f852338811df1a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $b8f852338811df1a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $b8f852338811df1a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $b8f852338811df1a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $b8f852338811df1a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $b8f852338811df1a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $b8f852338811df1a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $b8f852338811df1a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $b8f852338811df1a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("99w1R", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $6a9dcc96d11bcd0d$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $6a9dcc96d11bcd0d$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $6a9dcc96d11bcd0d$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $6a9dcc96d11bcd0d$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $6a9dcc96d11bcd0d$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $6a9dcc96d11bcd0d$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $6a9dcc96d11bcd0d$export$9770f232ac06a008; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $6a9dcc96d11bcd0d$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $6a9dcc96d11bcd0d$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $6a9dcc96d11bcd0d$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useBlocker", function () { return $6a9dcc96d11bcd0d$export$b273b3273281a049; });
$parcel$export(module.exports, "Router", function () { return $6a9dcc96d11bcd0d$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Navigate", function () { return $6a9dcc96d11bcd0d$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Route", function () { return $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $6a9dcc96d11bcd0d$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $6a9dcc96d11bcd0d$export$52b333d321859367; });
/**
 * React Router v6.22.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");

var $fSADM = parcelRequire("fSADM");
function $6a9dcc96d11bcd0d$var$_extends() {
    $6a9dcc96d11bcd0d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a9dcc96d11bcd0d$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $6a9dcc96d11bcd0d$export$3add0d5dce533e2e = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$145dfa71566a64dc = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$var$AwaitContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $6a9dcc96d11bcd0d$export$26749e8557646306 = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$c7914228fb69b0f5 = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$9072aa6dd1f93057 = /*#__PURE__*/ $bh6RR.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $6a9dcc96d11bcd0d$var$RouteErrorContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $6a9dcc96d11bcd0d$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $fSADM.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $6a9dcc96d11bcd0d$export$45d76561a5302f2b() {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $6a9dcc96d11bcd0d$export$1b3f31771c5d07c() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $6a9dcc96d11bcd0d$export$6c330e8992e8a295(pattern) {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let { pathname: pathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    return $bh6RR.useMemo(()=>(0, $fSADM.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $6a9dcc96d11bcd0d$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $bh6RR.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $6a9dcc96d11bcd0d$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $6a9dcc96d11bcd0d$var$useNavigateStable() : $6a9dcc96d11bcd0d$var$useNavigateUnstable();
}
function $6a9dcc96d11bcd0d$var$useNavigateUnstable() {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let dataRouterContext = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $fSADM.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $bh6RR.useRef(false);
    $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $fSADM.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $fSADM.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $6a9dcc96d11bcd0d$var$OutletContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $6a9dcc96d11bcd0d$export$4138103a3ae699cc() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $6a9dcc96d11bcd0d$export$a3be3530d8e40d0b(context) {
    let outlet = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $6a9dcc96d11bcd0d$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $fSADM.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $bh6RR.useMemo(()=>(0, $fSADM.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $6a9dcc96d11bcd0d$export$5d3fca4a98652595(routes, locationArg) {
    return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let { navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: parentMatches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $fSADM.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $fSADM.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $fSADM.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $6a9dcc96d11bcd0d$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $fSADM.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $fSADM.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $6a9dcc96d11bcd0d$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $fSADM.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $6a9dcc96d11bcd0d$var$DefaultErrorComponent() {
    let error = $6a9dcc96d11bcd0d$export$ed527bf60f6e05f2();
    let message = (0, $fSADM.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $bh6RR.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $bh6RR.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $6a9dcc96d11bcd0d$var$defaultErrorElement = /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$DefaultErrorComponent, null);
class $6a9dcc96d11bcd0d$var$RenderErrorBoundary extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $6a9dcc96d11bcd0d$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $6a9dcc96d11bcd0d$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $fSADM.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $6a9dcc96d11bcd0d$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $6a9dcc96d11bcd0d$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $bh6RR.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $6a9dcc96d11bcd0d$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($6a9dcc96d11bcd0d$var$DataRouterHook || {});
var $6a9dcc96d11bcd0d$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($6a9dcc96d11bcd0d$var$DataRouterStateHook || {});
function $6a9dcc96d11bcd0d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $6a9dcc96d11bcd0d$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    !ctx && (0, $fSADM.UNSAFE_invariant)(false);
    return ctx;
}
function $6a9dcc96d11bcd0d$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext($6a9dcc96d11bcd0d$export$145dfa71566a64dc);
    !state && (0, $fSADM.UNSAFE_invariant)(false);
    return state;
}
function $6a9dcc96d11bcd0d$var$useRouteContext(hookName) {
    let route = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    !route && (0, $fSADM.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $6a9dcc96d11bcd0d$var$useCurrentRouteId(hookName) {
    let route = $6a9dcc96d11bcd0d$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $fSADM.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $6a9dcc96d11bcd0d$export$5fc8298006ad9e58() {
    return $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $6a9dcc96d11bcd0d$export$d0fd4b7106de2769() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $6a9dcc96d11bcd0d$export$600dc272ed516c15() {
    let dataRouterContext = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseRevalidator);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRevalidator);
    return $bh6RR.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $6a9dcc96d11bcd0d$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseMatches);
    return $bh6RR.useMemo(()=>matches.map((m)=>(0, $fSADM.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $6a9dcc96d11bcd0d$export$1448a5050d252c4d() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $6a9dcc96d11bcd0d$export$fd5d37484eab868d(routeId) {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $6a9dcc96d11bcd0d$export$fdc00f3f26066d5e() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseActionData);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $6a9dcc96d11bcd0d$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $bh6RR.useContext($6a9dcc96d11bcd0d$var$RouteErrorContext);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteError);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $6a9dcc96d11bcd0d$export$78a72ddb39bdd145() {
    let value = $bh6RR.useContext($6a9dcc96d11bcd0d$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $6a9dcc96d11bcd0d$export$17f53340677d5831() {
    let value = $bh6RR.useContext($6a9dcc96d11bcd0d$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $6a9dcc96d11bcd0d$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $6a9dcc96d11bcd0d$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseBlocker);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $bh6RR.useState("");
    let blockerFunction = $bh6RR.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $6a9dcc96d11bcd0d$var$_extends({}, currentLocation, {
                pathname: (0, $fSADM.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $6a9dcc96d11bcd0d$var$_extends({}, nextLocation, {
                pathname: (0, $fSADM.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $bh6RR.useEffect(()=>{
        let key = String(++$6a9dcc96d11bcd0d$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $bh6RR.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $fSADM.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $6a9dcc96d11bcd0d$var$useNavigateStable() {
    let { router: router } = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseNavigateStable);
    let id = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $bh6RR.useRef(false);
    $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $6a9dcc96d11bcd0d$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $6a9dcc96d11bcd0d$var$alreadyWarned = {};
function $6a9dcc96d11bcd0d$var$warningOnce(key, cond, message) {
    if (!cond && !$6a9dcc96d11bcd0d$var$alreadyWarned[key]) $6a9dcc96d11bcd0d$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $6a9dcc96d11bcd0d$var$START_TRANSITION = "startTransition";
const $6a9dcc96d11bcd0d$var$startTransitionImpl = $bh6RR[$6a9dcc96d11bcd0d$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $6a9dcc96d11bcd0d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $bh6RR.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        if (v7_startTransition && $6a9dcc96d11bcd0d$var$startTransitionImpl) $6a9dcc96d11bcd0d$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $bh6RR.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $bh6RR.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $6a9dcc96d11bcd0d$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $6a9dcc96d11bcd0d$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fSADM.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $6a9dcc96d11bcd0d$var$startTransitionImpl ? $6a9dcc96d11bcd0d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $6a9dcc96d11bcd0d$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let navigate = $6a9dcc96d11bcd0d$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $fSADM.resolveTo)(to, (0, $fSADM.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $bh6RR.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $6a9dcc96d11bcd0d$export$910ae8079b2c2852(props) {
    return $6a9dcc96d11bcd0d$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6(_props) {
    (0, $fSADM.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $6a9dcc96d11bcd0d$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $fSADM.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $bh6RR.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $6a9dcc96d11bcd0d$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $fSADM.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $bh6RR.useMemo(()=>{
        let trailingPathname = (0, $fSADM.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $6a9dcc96d11bcd0d$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $6a9dcc96d11bcd0d$export$5d3fca4a98652595($6a9dcc96d11bcd0d$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $6a9dcc96d11bcd0d$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$ResolveAwait, null, children));
}
var $6a9dcc96d11bcd0d$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($6a9dcc96d11bcd0d$var$AwaitRenderStatus || {});
const $6a9dcc96d11bcd0d$var$neverSettledPromise = new Promise(()=>{});
class $6a9dcc96d11bcd0d$var$AwaitErrorBoundary extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error : promise._data !== undefined ? $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success : $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error && promise._error instanceof (0, $fSADM.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $6a9dcc96d11bcd0d$var$neverSettledPromise;
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $6a9dcc96d11bcd0d$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $6a9dcc96d11bcd0d$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $6a9dcc96d11bcd0d$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $bh6RR.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $bh6RR.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $bh6RR.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $6a9dcc96d11bcd0d$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6) && (0, $fSADM.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $fSADM.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $6a9dcc96d11bcd0d$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $6a9dcc96d11bcd0d$export$daf73786167a7f72(matches) {
    return $6a9dcc96d11bcd0d$var$_renderMatches(matches);
}
function $6a9dcc96d11bcd0d$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $bh6RR.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $bh6RR.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $bh6RR.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $6a9dcc96d11bcd0d$export$f30f7e456d254e83(routes, opts) {
    return (0, $fSADM.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $6a9dcc96d11bcd0d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fSADM.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $6a9dcc96d11bcd0d$export$52b333d321859367
    }).initialize();
}

});


parcelRegister("bu31C", function(module, exports) {

$parcel$export(module.exports, "AppContext", function () { return $f0a561af89af7017$export$122994dc05ba4308; });
$parcel$export(module.exports, "AppProvider", function () { return $f0a561af89af7017$export$c7dacf3845253dcf; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $evXqp = parcelRequire("evXqp");

var $hWTCN = parcelRequire("hWTCN");
const $f0a561af89af7017$export$438a7c8d9ddf8079 = {
    user: {
        data: null,
        token: null
    },
    message: {
        open: false,
        text: null,
        severity: null,
        autoHide: 3000
    },
    confirmation: {
        open: false
    },
    selectedCompany: {
        name: null,
        address_name: null
    },
    selectedContact: {
        name: null,
        company_name: null
    },
    routes: (0, $hWTCN.getRoutes)(),
    selectedProduct: null,
    selectedMembership: null,
    selectedInvoice: null,
    selectedRecipientList: null,
    selectedUser: null
};
const $f0a561af89af7017$export$122994dc05ba4308 = /*#__PURE__*/ (0, $bh6RR.createContext)({
    state: $f0a561af89af7017$export$438a7c8d9ddf8079,
    dispatch: ()=>null
});
const $f0a561af89af7017$export$c7dacf3845253dcf = ({ children: children })=>{
    const [state, dispatch] = (0, $bh6RR.useReducer)((0, $evXqp.mainReducer), $f0a561af89af7017$export$438a7c8d9ddf8079);
    return /*#__PURE__*/ (0, $ih19M.jsx)($f0a561af89af7017$export$122994dc05ba4308.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};

});
parcelRegister("evXqp", function(module, exports) {

$parcel$export(module.exports, "mainReducer", function () { return $116ee0efed7055d2$export$f39c97fbaf02c23c; });

var $hLDkf = parcelRequire("hLDkf");

var $5GHwk = parcelRequire("5GHwk");

var $jhEmF = parcelRequire("jhEmF");

var $2QybG = parcelRequire("2QybG");

var $1u9MW = parcelRequire("1u9MW");

var $9OfKy = parcelRequire("9OfKy");

var $71HJg = parcelRequire("71HJg");

var $5HMh1 = parcelRequire("5HMh1");

var $31HrA = parcelRequire("31HrA");
const $116ee0efed7055d2$export$f39c97fbaf02c23c = ({ user: user, message: message, confirmation: confirmation, routes: routes, selectedContact: selectedContact, selectedMembership: selectedMembership, selectedInvoice: selectedInvoice, selectedUser: selectedUser, selectedCompany: selectedCompany, selectedProduct: selectedProduct, selectedRecipientList: selectedRecipientList }, action)=>({
        message: (0, $9OfKy.messageReducer)(message, action),
        confirmation: (0, $5GHwk.confirmationReducer)(confirmation, action),
        user: (0, $31HrA.userReducer)(user, action),
        selectedMembership: (0, $1u9MW.membershipReducer)(selectedMembership, action),
        selectedContact: (0, $jhEmF.contactReducer)(selectedContact, action),
        selectedInvoice: (0, $2QybG.invoiceReducer)(selectedInvoice, action),
        selectedUser: (0, $31HrA.selectedUserReducer)(selectedUser, action),
        selectedCompany: (0, $hLDkf.companyReducer)(selectedCompany, action),
        selectedProduct: (0, $71HJg.productReducer)(selectedProduct, action),
        selectedRecipientList: (0, $5HMh1.recipientListReducer)(selectedRecipientList, action),
        routes: routes
    });

});
parcelRegister("hLDkf", function(module, exports) {

$parcel$export(module.exports, "companyReducer", function () { return $36d2f0dbb523c7ee$export$47bb069d1d0bac70; });

var $ayVxz = parcelRequire("ayVxz");
const $36d2f0dbb523c7ee$export$47bb069d1d0bac70 = (state, action)=>{
    switch(action.type){
        case (0, $ayVxz.Actions).SetSelectedCompany:
            return {
                name: action.payload.name,
                address_name: action.payload.address_name
            };
        case (0, $ayVxz.Actions).ResetSelectedCompany:
            return {
                name: null,
                address_name: null
            };
        default:
            return state;
    }
};

});
parcelRegister("ayVxz", function(module, exports) {

$parcel$export(module.exports, "Actions", function () { return $9a542af0f584bd3c$export$b52183d5cfb26dc9; });
var $9a542af0f584bd3c$export$b52183d5cfb26dc9;
(function(Actions) {
    Actions["ShowMessage"] = "show_message";
    Actions["HideMessage"] = "hide_message";
    Actions["ShowConfirmation"] = "show_confirmation";
    Actions["HideConfirmation"] = "hide_confirmation";
    Actions["SetUser"] = "set_user";
    Actions["RemoveUser"] = "remove_user";
    Actions["SetSelectedCompany"] = "set_selected_company";
    Actions["ResetSelectedCompany"] = "reset_selected_company";
    Actions["SetSelectedContact"] = "set_selected_contact";
    Actions["ResetSelectedContact"] = "reset_selected_contact";
    Actions["SetSelectedProduct"] = "set_selected_product";
    Actions["ResetSelectedProduct"] = "reset_selected_product";
    Actions["SetSelectedMembership"] = "set_selected_membership";
    Actions["ResetSelectedMembership"] = "reset_selected_membership";
    Actions["SetInvoice"] = "set_invoice";
    Actions["ResetInvoice"] = "reset_invoice";
    Actions["SetInvoiceClientDetails"] = "set_invoice_client_details";
    Actions["SetInvoiceErrors"] = "set_invoice_errors";
    Actions["ResetInvoiceErrors"] = "reset_invoice_errors";
    Actions["SetInvoiceProductInfo"] = "set_invoice_product_info";
    Actions["ResetInvoiceProductInfo"] = "reset_invoice_product_info";
    Actions["SetInvoicePaymentDetails"] = "set_invoice_payment_details";
    Actions["SetInvoicePaymentDetailsMode"] = "set_invoice_payment_details_mode";
    Actions["SetSelectedUser"] = "set_selected_user";
    Actions["ResetSelectedUser"] = "reset_selected_user";
    Actions["SetRecipientList"] = "set_recipient_list";
    Actions["ResetRecipientList"] = "reset_recipient_list";
    Actions["SetRecipientListContactTitles"] = "set_recipient_list_contact_titles";
    Actions["SetRecipientListCompanyTypes"] = "set_recipient_list_company_types";
    Actions["SetRecipientListName"] = "set_recipient_list_name";
    Actions["SetRecipientListMemberships"] = "set_recipient_list_memberships";
    Actions["SetRecipientListInterests"] = "set_recipient_list_interests";
    Actions["SetRecipientListCountries"] = "set_recipient_list_countries";
    Actions["SetRecipientListExcludedContacts"] = "set_recipient_list_excluded_contacts";
    Actions["RecipientListIncludeContact"] = "recipient_list_include_contact";
    Actions["RecipientListRemoveIncludedContact"] = "recipient_list_remove_included_contact";
    Actions["SetInvoiceNotes"] = "set_invoice_notes";
    Actions["SetInvoicePoNumber"] = "set_invoice_po_number";
    Actions["SetMembershipStartDate"] = "set_membership_start_date";
})($9a542af0f584bd3c$export$b52183d5cfb26dc9 || ($9a542af0f584bd3c$export$b52183d5cfb26dc9 = {}));

});


parcelRegister("5GHwk", function(module, exports) {

$parcel$export(module.exports, "confirmationReducer", function () { return $29acf07da4bb1126$export$5afaea876d500dd5; });

var $ayVxz = parcelRequire("ayVxz");
const $29acf07da4bb1126$export$5afaea876d500dd5 = (state, action)=>{
    switch(action.type){
        case (0, $ayVxz.Actions).ShowConfirmation:
            return {
                open: true,
                title: action.payload.title,
                text: action.payload.text,
                agreeAction: action.payload.agreeAction,
                params: action.payload.params
            };
        case (0, $ayVxz.Actions).HideConfirmation:
            return {
                open: false,
                title: null,
                text: null
            };
        default:
            return state;
    }
};

});

parcelRegister("jhEmF", function(module, exports) {

$parcel$export(module.exports, "contactReducer", function () { return $b4d310203df9ba60$export$b1029c1261af732b; });

var $ayVxz = parcelRequire("ayVxz");
const $b4d310203df9ba60$export$b1029c1261af732b = (state, action)=>{
    switch(action.type){
        case (0, $ayVxz.Actions).SetSelectedContact:
            return {
                name: action.payload.name,
                company_name: action.payload.company_name
            };
        case (0, $ayVxz.Actions).ResetSelectedContact:
            return {
                name: null,
                company_name: null
            };
        default:
            return state;
    }
};

});

parcelRegister("2QybG", function(module, exports) {

$parcel$export(module.exports, "invoiceReducer", function () { return $a77f85ed438870c3$export$d1c1e1b4113e6b33; });

var $ayVxz = parcelRequire("ayVxz");

var $2glCg = parcelRequire("2glCg");

var $e2ibc = parcelRequire("e2ibc");
const $a77f85ed438870c3$export$d1c1e1b4113e6b33 = (state, action)=>{
    switch(action.type){
        case (0, $ayVxz.Actions).SetInvoice:
            const { invoice: invoice, productInfo: productInfo } = action.payload;
            return {
                id: invoice?.id,
                company: invoice ? {
                    name: invoice.details.company_name,
                    main_address: {
                        complete_vat_number: invoice.details.company_address_vat
                    }
                } : null,
                contact: invoice ? {
                    fullName: invoice.details.fullName,
                    email: action.payload.invoice?.details.contact_email
                } : null,
                address: invoice ? {
                    name: invoice?.details.address_name
                } : null,
                status: $a77f85ed438870c3$var$setInvoiceStatus(action.payload.invoice),
                // email: action.payload.invoice?.details.contact_email,
                errors: {},
                invoice_full: invoice,
                productInfo: productInfo ?? null,
                paymentDetails: invoice?.paymentDetails,
                isPaymentDetailsInEditMode: false,
                notes: invoice?.notes ?? null,
                membership: invoice?.membership ?? null,
                po_nr: invoice?.po_nr ?? null,
                remarks: invoice?.remarks ?? null
            };
        case (0, $ayVxz.Actions).SetInvoiceClientDetails:
            return {
                ...state,
                ...action.payload
            };
        case (0, $ayVxz.Actions).SetInvoiceProductInfo:
            return {
                ...state,
                productInfo: {
                    ...action.payload
                }
            };
        case (0, $ayVxz.Actions).SetInvoiceErrors:
            return {
                ...state,
                errors: {
                    ...action.payload
                }
            };
        case (0, $ayVxz.Actions).ResetInvoiceErrors:
            return {
                ...state,
                errors: {}
            };
        case (0, $ayVxz.Actions).SetInvoicePaymentDetails:
            return {
                ...state,
                paymentDetails: {
                    ...action.payload
                }
            };
        case (0, $ayVxz.Actions).SetInvoicePaymentDetailsMode:
            return {
                ...state,
                isPaymentDetailsInEditMode: action.payload
            };
        case (0, $ayVxz.Actions).ResetInvoice:
            return null;
        case (0, $ayVxz.Actions).ResetInvoiceProductInfo:
            return {
                ...state,
                productInfo: null
            };
        case (0, $ayVxz.Actions).SetInvoiceNotes:
            return {
                ...state,
                notes: action.payload.text
            };
        case (0, $ayVxz.Actions).SetInvoicePoNumber:
            return {
                ...state,
                po_nr: action.payload.text
            };
        case (0, $ayVxz.Actions).SetMembershipStartDate:
            return {
                ...state,
                remarks: action.payload.text
            };
        default:
            return state;
    }
};
const $a77f85ed438870c3$var$setInvoiceStatus = (invoice)=>{
    if (invoice) {
        if (invoice.is_credit) return invoice.status.name === (0, $e2ibc.INVOICE_STATUS_CONFIRMED) ? (0, $2glCg.InvoiceStatus).ConfirmedCredit : (0, $2glCg.InvoiceStatus).PendingCredit;
        else return invoice.status.name === (0, $e2ibc.INVOICE_STATUS_CONFIRMED) ? (0, $2glCg.InvoiceStatus).Confirmed : (0, $2glCg.InvoiceStatus).Pending;
    }
    return (0, $2glCg.InvoiceStatus).New;
};

});
parcelRegister("2glCg", function(module, exports) {

$parcel$export(module.exports, "InvoiceStatus", function () { return $18f7c930f19a10b4$export$d5c1d4491a804016; });
var $18f7c930f19a10b4$export$d5c1d4491a804016;
(function(InvoiceStatus) {
    InvoiceStatus["New"] = "new";
    InvoiceStatus["Pending"] = "pending";
    InvoiceStatus["Confirmed"] = "confirmed";
    InvoiceStatus["PendingCredit"] = "pending_credit";
    InvoiceStatus["ConfirmedCredit"] = "confirmed_credit";
})($18f7c930f19a10b4$export$d5c1d4491a804016 || ($18f7c930f19a10b4$export$d5c1d4491a804016 = {}));

});

parcelRegister("e2ibc", function(module, exports) {

$parcel$export(module.exports, "INVOICE_STATUS_CONFIRMED", function () { return $2d3b1f203286667f$export$e9840605b8c161a; });
$parcel$export(module.exports, "DATE_TIME_FORMATS", function () { return $2d3b1f203286667f$export$8efc56d5c85ee8e7; });
$parcel$export(module.exports, "ValueListNames", function () { return $2d3b1f203286667f$export$7df16d7ec185e3bb; });

var $fmUFE = parcelRequire("fmUFE");
const $2d3b1f203286667f$export$e9840605b8c161a = "Confirmed";
const $2d3b1f203286667f$export$8efc56d5c85ee8e7 = {
    DATE_AND_TIME: "DD/MM/YYYY  HH:mm",
    DATE: "DD/MM/YYYY",
    DATE_DASHED: "YYYY-MM-DD",
    DATE_AND_TIME_AM_PM: "DD/MM/YYYY hh:mm A"
};
const $2d3b1f203286667f$export$7df16d7ec185e3bb = {
    [(0, $fmUFE.ValueLists).CompanyType]: "CompanyTypes",
    [(0, $fmUFE.ValueLists).MarketActivity]: "MarketActivities",
    [(0, $fmUFE.ValueLists).MembershipType]: "MembershipTypes",
    [(0, $fmUFE.ValueLists).ProductCode]: "ProductCodes",
    [(0, $fmUFE.ValueLists).TitleInternal]: "TitlesInternal"
};

});
parcelRegister("fmUFE", function(module, exports) {

$parcel$export(module.exports, "ValueLists", function () { return $37609ced546a1884$export$4a70a1c1d396d5d6; });
var $37609ced546a1884$export$4a70a1c1d396d5d6;
(function(ValueLists) {
    ValueLists["CompanyType"] = "CompanyType";
    ValueLists["MarketActivity"] = "MarketActivity";
    ValueLists["MembershipType"] = "MembershipType";
    ValueLists["ProductCode"] = "ProductCode";
    ValueLists["TitleInternal"] = "TitleInternal";
})($37609ced546a1884$export$4a70a1c1d396d5d6 || ($37609ced546a1884$export$4a70a1c1d396d5d6 = {}));

});



parcelRegister("1u9MW", function(module, exports) {

$parcel$export(module.exports, "membershipReducer", function () { return $04b94ce4ee3493e2$export$e3d5869fd902d2e9; });

var $ayVxz = parcelRequire("ayVxz");
const $04b94ce4ee3493e2$export$e3d5869fd902d2e9 = (state, action)=>{
    switch(action.type){
        case (0, $ayVxz.Actions).SetSelectedMembership:
            return {
                ...action.payload
            };
        case (0, $ayVxz.Actions).ResetSelectedMembership:
            return null;
        default:
            return state;
    }
};

});

parcelRegister("9OfKy", function(module, exports) {

$parcel$export(module.exports, "messageReducer", function () { return $66f810c6b81dcd54$export$92b32209294d1a49; });

var $ayVxz = parcelRequire("ayVxz");
const $66f810c6b81dcd54$export$92b32209294d1a49 = (state, action)=>{
    switch(action.type){
        case (0, $ayVxz.Actions).ShowMessage:
            return {
                open: true,
                text: action.payload.text,
                severity: action.payload.severity,
                autoHide: action.payload.autoHide ?? 3000
            };
        case (0, $ayVxz.Actions).HideMessage:
            return {
                ...state,
                open: false
            };
        default:
            return state;
    }
};

});

parcelRegister("71HJg", function(module, exports) {

$parcel$export(module.exports, "productReducer", function () { return $3c0faf9da7e4d040$export$fc0afeb73dd76c1a; });

var $ayVxz = parcelRequire("ayVxz");
const $3c0faf9da7e4d040$export$fc0afeb73dd76c1a = (state, action)=>{
    switch(action.type){
        case (0, $ayVxz.Actions).SetSelectedProduct:
            return action.payload.name;
        case (0, $ayVxz.Actions).ResetSelectedProduct:
            return null;
        default:
            return state;
    }
};

});

parcelRegister("5HMh1", function(module, exports) {

$parcel$export(module.exports, "recipientListReducer", function () { return $b3b87b4abd05411e$export$7bdc9a967ea71d32; });

var $ayVxz = parcelRequire("ayVxz");
const $b3b87b4abd05411e$export$7bdc9a967ea71d32 = (state, action)=>{
    switch(action.type){
        case (0, $ayVxz.Actions).SetRecipientList:
            const { recipientList: recipientList } = action.payload;
            return {
                id: recipientList?.id,
                contactTitleIds: recipientList?.contactTitleIds || [],
                companyTypeIds: recipientList?.companyTypeIds || [],
                name: recipientList?.name,
                membershipTypeIds: recipientList?.membershipTypeIds || [],
                interestIds: recipientList?.interestIds || [],
                countryIds: recipientList?.countryIds || [],
                excludedContactIds: recipientList?.excludedContactIds || [],
                includedContactIds: recipientList?.includedContactIds || []
            };
        case (0, $ayVxz.Actions).SetRecipientListContactTitles:
            const { contactTitleIds: contactTitleIds } = action.payload;
            return {
                ...state,
                contactTitleIds: contactTitleIds
            };
        case (0, $ayVxz.Actions).SetRecipientListCompanyTypes:
            const { companyTypeIds: companyTypeIds } = action.payload;
            return {
                ...state,
                companyTypeIds: companyTypeIds
            };
        case (0, $ayVxz.Actions).SetRecipientListName:
            const { name: name } = action.payload;
            return {
                ...state,
                name: name
            };
        case (0, $ayVxz.Actions).SetRecipientListMemberships:
            const { membershipTypeIds: membershipTypeIds } = action.payload;
            return {
                ...state,
                membershipTypeIds: membershipTypeIds
            };
        case (0, $ayVxz.Actions).SetRecipientListInterests:
            const { interestIds: interestIds } = action.payload;
            return {
                ...state,
                interestIds: interestIds
            };
        case (0, $ayVxz.Actions).SetRecipientListCountries:
            const { countryIds: countryIds } = action.payload;
            return {
                ...state,
                countryIds: countryIds
            };
        case (0, $ayVxz.Actions).SetRecipientListExcludedContacts:
            const { excludedContactIds: excludedContactIds } = action.payload;
            return {
                ...state,
                excludedContactIds: excludedContactIds
            };
        case (0, $ayVxz.Actions).RecipientListIncludeContact:
            const { contactId: contactId } = action.payload;
            return {
                ...state,
                includedContactIds: [
                    contactId,
                    ...state?.includedContactIds
                ]
            };
        case (0, $ayVxz.Actions).RecipientListRemoveIncludedContact:
            return {
                ...state,
                includedContactIds: (state?.includedContactIds).filter((c)=>c !== action.payload.contactId)
            };
        case (0, $ayVxz.Actions).ResetRecipientList:
            return null;
        default:
            return state;
    }
};

});

parcelRegister("31HrA", function(module, exports) {

$parcel$export(module.exports, "userReducer", function () { return $b3c2f2d90de74899$export$c80d1fc788ac90f9; });
$parcel$export(module.exports, "selectedUserReducer", function () { return $b3c2f2d90de74899$export$97f757c370e1d89c; });

var $ayVxz = parcelRequire("ayVxz");
const $b3c2f2d90de74899$export$c80d1fc788ac90f9 = (state, action)=>{
    switch(action.type){
        case (0, $ayVxz.Actions).SetUser:
            return {
                data: action.payload.data,
                token: action.payload.token
            };
        case (0, $ayVxz.Actions).RemoveUser:
            return {
                data: null,
                token: null
            };
        default:
            return state;
    }
};
const $b3c2f2d90de74899$export$97f757c370e1d89c = (state, action)=>{
    switch(action.type){
        case (0, $ayVxz.Actions).SetSelectedUser:
            return action.payload.user;
        case (0, $ayVxz.Actions).ResetSelectedUser:
            return null;
        default:
            return state;
    }
};

});


parcelRegister("hWTCN", function(module, exports) {

$parcel$export(module.exports, "getRoutes", function () { return $2d1a5495c083dbe0$export$2f7745f2f5ab3897; });

var $bh6RR = parcelRequire("bh6RR");

var $b1v75 = parcelRequire("b1v75");

var $eBeqV = parcelRequire("eBeqV");

var $8TSey = parcelRequire("8TSey");

var $9lt9Y = parcelRequire("9lt9Y");

var $lC26g = parcelRequire("lC26g");

var $gsaCA = parcelRequire("gsaCA");

var $edHg5 = parcelRequire("edHg5");

var $j5zPy = parcelRequire("j5zPy");

var $1EALQ = parcelRequire("1EALQ");

var $gduAv = parcelRequire("gduAv");

var $jqVnU = parcelRequire("jqVnU");
var $8QeQV = parcelRequire("8QeQV");
var $hXcYG = parcelRequire("hXcYG");
var $bc6Ci = parcelRequire("bc6Ci");
var $aeLGi = parcelRequire("aeLGi");
var $4Uy8o = parcelRequire("4Uy8o");
var $bOZ0B = parcelRequire("bOZ0B");
var $2xkbE = parcelRequire("2xkbE");
var $gZWM8 = parcelRequire("gZWM8");
var $bwbWe = parcelRequire("bwbWe");
var $5FZaQ = parcelRequire("5FZaQ");
var $ihmL0 = parcelRequire("ihmL0");
var $hyMYB = parcelRequire("hyMYB");
var $lM6pF = parcelRequire("lM6pF");
var $7OO4z = parcelRequire("7OO4z");
var $iR1LU = parcelRequire("iR1LU");
var $dgmqH = parcelRequire("dgmqH");
var $8AYU5 = parcelRequire("8AYU5");
var $jnNNx = parcelRequire("jnNNx");
var $bDeQg = parcelRequire("bDeQg");
var $8EfWV = parcelRequire("8EfWV");

var $1RKRu = parcelRequire("1RKRu");

var $8Oiq1 = parcelRequire("8Oiq1");

var $9pjPY = parcelRequire("9pjPY");

var $5lpiZ = parcelRequire("5lpiZ");

var $1TRYK = parcelRequire("1TRYK");

var $9Vnzc = parcelRequire("9Vnzc");

var $izFem = parcelRequire("izFem");

var $lWrBs = parcelRequire("lWrBs");

var $gEbRq = parcelRequire("gEbRq");

var $6mUJD = parcelRequire("6mUJD");

var $jbIBu = parcelRequire("jbIBu");

var $auZDP = parcelRequire("auZDP");

var $hySdq = parcelRequire("hySdq");

var $ISRgu = parcelRequire("ISRgu");

var $7btlA = parcelRequire("7btlA");

var $fL4Kw = parcelRequire("fL4Kw");

var $H2UE0 = parcelRequire("H2UE0");

var $4GxAn = parcelRequire("4GxAn");

// Lazy load MeetingList to avoid circular dependency with AppContext
const $2d1a5495c083dbe0$var$MeetingList = /*#__PURE__*/ (0, $bh6RR.lazy)(()=>(parcelRequire("lB0Ec")));

// Lazy load ContactList
const $2d1a5495c083dbe0$var$Contacts = /*#__PURE__*/ (0, $bh6RR.lazy)(()=>(parcelRequire("1C9E3")));

// Lazy load MembershipList
const $2d1a5495c083dbe0$var$Memberships = /*#__PURE__*/ (0, $bh6RR.lazy)(()=>(parcelRequire("hWn17")));

// Lazy load CompanyList
const $2d1a5495c083dbe0$var$Companies = /*#__PURE__*/ (0, $bh6RR.lazy)(()=>(parcelRequire("e7VFN")));

// Lazy load InvoiceList
const $2d1a5495c083dbe0$var$Invoices = /*#__PURE__*/ (0, $bh6RR.lazy)(()=>Promise.resolve((parcelRequire("2OHqK"))));

// Lazy load DocumentsList
const $2d1a5495c083dbe0$var$Documents = /*#__PURE__*/ (0, $bh6RR.lazy)(()=>(parcelRequire("ew2iK")));
const $2d1a5495c083dbe0$export$3565eb3d00ca5a74 = [
    {
        name: (0, $b1v75.RouteNames).Home,
        path: (0, $b1v75.AuthRoutes).Home,
        icon: (0, $aeLGi.default),
        isPublic: false,
        Component: (0, $eBeqV.default),
        exact: true,
        showInNav: true,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).Memberships,
        path: (0, $b1v75.AuthRoutes).Memberships,
        icon: (0, $8QeQV.default),
        isPublic: false,
        Component: $2d1a5495c083dbe0$var$Memberships,
        exact: true,
        showInNav: true,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).MembershipDetails,
        path: (0, $b1v75.AuthRoutes).MembershipDetails,
        isPublic: false,
        Component: (0, $gsaCA.default),
        exact: false,
        showInNav: false,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).Login,
        path: (0, $b1v75.PublicRoutes).Login,
        isPublic: true,
        exact: false,
        Component: (0, $9lt9Y.default),
        showInNav: false,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).EtfValues,
        path: (0, $b1v75.AuthRoutes).EtfValues,
        isPublic: false,
        Component: (0, $4GxAn.default),
        exact: false,
        showInNav: false,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).CompanyDetails,
        path: (0, $b1v75.AuthRoutes).CompanyDetails,
        isPublic: false,
        Component: (0, $auZDP.default),
        exact: false,
        showInNav: false,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).Companies,
        path: (0, $b1v75.AuthRoutes).Companies,
        icon: (0, $bwbWe.default),
        isPublic: false,
        Component: $2d1a5495c083dbe0$var$Companies,
        exact: false,
        showInNav: true,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).Contacts,
        path: (0, $b1v75.AuthRoutes).Contacts,
        icon: (0, $5FZaQ.default),
        isPublic: false,
        Component: $2d1a5495c083dbe0$var$Contacts,
        exact: true,
        showInNav: true,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).ContactDetails,
        path: (0, $b1v75.AuthRoutes).ContactDetails,
        isPublic: false,
        Component: (0, $jbIBu.default),
        exact: false,
        showInNav: false,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).Event,
        path: (0, $b1v75.AuthRoutes).Event,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1RKRu))),
        isPublic: false,
        Component: (0, $gduAv.default),
        exact: false,
        showInNav: true,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).Calendar,
        path: (0, $b1v75.AuthRoutes).Calendar,
        icon: (0, $4Uy8o.default),
        isPublic: false,
        Component: (0, $8TSey.default),
        exact: false,
        showInNav: true,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).Invoices,
        path: (0, $b1v75.AuthRoutes).Invoices,
        icon: (0, $dgmqH.default),
        isPublic: false,
        Component: $2d1a5495c083dbe0$var$Invoices,
        exact: true,
        showInNav: true,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).Products,
        path: (0, $b1v75.AuthRoutes).Products,
        icon: (0, $hyMYB.default),
        isPublic: false,
        Component: (0, $lC26g.default),
        exact: true,
        showInNav: true,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).ProductDetails,
        path: (0, $b1v75.AuthRoutes).ProductDetails,
        isPublic: false,
        Component: (0, $edHg5.default),
        exact: false,
        showInNav: false,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).Meetings,
        path: (0, $b1v75.AuthRoutes).Meetings,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1RKRu))),
        isPublic: false,
        Component: $2d1a5495c083dbe0$var$MeetingList,
        exact: true,
        showInNav: true,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).MassMail,
        path: (0, $b1v75.AuthRoutes).MassMail,
        icon: (0, $lM6pF.default),
        isPublic: false,
        Component: (0, $hySdq.default),
        exact: true,
        showInNav: true,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).AdminUserDetails,
        showInNav: false,
        Component: (0, $izFem.default),
        exact: true,
        isPublic: false,
        path: (0, $b1v75.AdminRoutes).UserDetails,
        requiredRole: (0, $8Oiq1.Roles).Admin,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).Stocks,
        path: (0, $b1v75.AuthRoutes).Stocks,
        showInNav: true,
        Component: (0, $1EALQ.default),
        exact: true,
        icon: (0, $jnNNx.default),
        isPublic: false,
        // requiredRole: Roles.Admin,
        type: (0, $b1v75.NavElements).Item,
        svgIconName: "stockSvg"
    },
    {
        name: (0, $b1v75.RouteNames).StockDetails,
        path: (0, $b1v75.AuthRoutes).StockDetails,
        isPublic: false,
        Component: (0, $ISRgu.default),
        exact: false,
        showInNav: false,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).Indices,
        path: (0, $b1v75.AuthRoutes).Indices,
        icon: (0, $gZWM8.default),
        isPublic: false,
        Component: (0, $j5zPy.default),
        exact: true,
        showInNav: true,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).Etfs,
        path: (0, $b1v75.AuthRoutes).Etfs,
        icon: (0, $hXcYG.default),
        isPublic: false,
        Component: (0, $H2UE0.default),
        exact: true,
        showInNav: true,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).Ftse,
        path: (0, $b1v75.AuthRoutes).Ftse,
        icon: (0, $ihmL0.default),
        isPublic: false,
        Component: (0, $fL4Kw.default),
        exact: true,
        showInNav: true,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).Documents,
        path: (0, $b1v75.AuthRoutes).Documents,
        icon: (0, $bOZ0B.default),
        isPublic: false,
        Component: $2d1a5495c083dbe0$var$Documents,
        exact: true,
        showInNav: true,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).Msb,
        path: (0, $b1v75.AuthRoutes).Msb,
        icon: (0, $bDeQg.default),
        isPublic: false,
        Component: (0, $7btlA.default),
        exact: true,
        showInNav: true,
        type: (0, $b1v75.NavElements).Item
    },
    {
        name: (0, $b1v75.RouteNames).Admin,
        showInNav: true,
        icon: (0, $jqVnU.default),
        requiredRole: (0, $8Oiq1.Roles).Admin,
        type: (0, $b1v75.NavElements).Group,
        subRoutes: [
            {
                name: (0, $b1v75.RouteNames).AdminUsers,
                showInNav: true,
                Component: (0, $9Vnzc.default),
                exact: true,
                icon: (0, $iR1LU.default),
                isPublic: false,
                path: (0, $b1v75.AdminRoutes).Users,
                requiredRole: (0, $8Oiq1.Roles).Admin,
                type: (0, $b1v75.NavElements).Item
            },
            {
                name: (0, $b1v75.RouteNames).AdminUserGroups,
                showInNav: true,
                Component: (0, $lWrBs.default),
                exact: true,
                icon: (0, $7OO4z.default),
                isPublic: false,
                path: (0, $b1v75.AdminRoutes).UserGroups,
                requiredRole: (0, $8Oiq1.Roles).Admin,
                type: (0, $b1v75.NavElements).Item
            },
            {
                name: (0, $b1v75.RouteNames).AdminCustomization,
                showInNav: true,
                Component: (0, $gEbRq.default),
                exact: true,
                icon: (0, $bc6Ci.default),
                isPublic: false,
                path: (0, $b1v75.AdminRoutes).Customization,
                requiredRole: (0, $8Oiq1.Roles).Admin,
                type: (0, $b1v75.NavElements).Item
            },
            {
                name: (0, $b1v75.RouteNames).AdminInterests,
                showInNav: true,
                Component: (0, $6mUJD.default),
                exact: true,
                icon: (0, $2xkbE.default),
                isPublic: false,
                path: (0, $b1v75.AdminRoutes).Interests,
                requiredRole: (0, $8Oiq1.Roles).Admin,
                type: (0, $b1v75.NavElements).Item
            },
            {
                name: (0, $b1v75.RouteNames).AdminFtseConfig,
                showInNav: true,
                Component: (0, $9pjPY.default),
                exact: true,
                icon: (0, $8AYU5.default),
                isPublic: false,
                path: (0, $b1v75.AdminRoutes).FTSEConfig,
                requiredRole: (0, $8Oiq1.Roles).Admin,
                type: (0, $b1v75.NavElements).Item
            },
            {
                name: (0, $b1v75.RouteNames).AdminSiteSections,
                showInNav: true,
                Component: (0, $5lpiZ.default),
                exact: true,
                icon: (0, $8EfWV.default),
                isPublic: false,
                path: (0, $b1v75.AdminRoutes).SiteSections,
                requiredRole: (0, $8Oiq1.Roles).Admin,
                type: (0, $b1v75.NavElements).Item
            },
            {
                name: (0, $b1v75.RouteNames).AdminMeetingTypes,
                showInNav: true,
                Component: (0, $1TRYK.default),
                exact: true,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1RKRu))),
                isPublic: false,
                path: (0, $b1v75.AdminRoutes).MeetingTypes,
                requiredRole: (0, $8Oiq1.Roles).Admin,
                type: (0, $b1v75.NavElements).Item
            }
        ]
    }
];
const $2d1a5495c083dbe0$export$2f7745f2f5ab3897 = ()=>{
    let index = 0;
    const result = [];
    $2d1a5495c083dbe0$export$3565eb3d00ca5a74.forEach((r)=>{
        if (r.type === (0, $b1v75.NavElements).Item) result.push({
            id: index++,
            ...r
        });
        else {
            const sRoutes = $2d1a5495c083dbe0$var$getSubroutes(r, index);
            result.push({
                ...r,
                id: index,
                subRoutes: sRoutes
            });
            index = r.subRoutes ? index + r.subRoutes.length + 1 : index + 1;
        }
    });
    return result;
};
const $2d1a5495c083dbe0$var$getSubroutes = (route, index)=>{
    const result = [];
    route.subRoutes?.forEach((sr)=>{
        result.push({
            id: ++index,
            ...sr
        });
    });
    return result;
};

});
parcelRegister("b1v75", function(module, exports) {

$parcel$export(module.exports, "AuthRoutes", function () { return $0f61036523fa4b5e$export$497d3dafd4dc9b7c; });
$parcel$export(module.exports, "PublicRoutes", function () { return $0f61036523fa4b5e$export$b7f74e73bfead856; });
$parcel$export(module.exports, "AdminRoutes", function () { return $0f61036523fa4b5e$export$6ceee8b279e57709; });
$parcel$export(module.exports, "RouteNames", function () { return $0f61036523fa4b5e$export$f4bfbadc8ccd5fbc; });
$parcel$export(module.exports, "NavElements", function () { return $0f61036523fa4b5e$export$e65c88f8e9056ee0; });
var $0f61036523fa4b5e$export$497d3dafd4dc9b7c;
(function(AuthRoutes) {
    AuthRoutes["Home"] = "/";
    AuthRoutes["Admin"] = "/admin";
    AuthRoutes["Test"] = "/test";
    AuthRoutes["Contacts"] = "/contacts";
    AuthRoutes["Companies"] = "/companies";
    AuthRoutes["Calendar"] = "/calendar";
    AuthRoutes["CompanyDetails"] = "/companies/:id";
    AuthRoutes["ContactDetails"] = "/contacts/:id";
    AuthRoutes["MembershipDetails"] = "/memberships/:id";
    AuthRoutes["Products"] = "/products";
    AuthRoutes["ProductDetails"] = "/products/:id";
    AuthRoutes["Meetings"] = "/meetings";
    AuthRoutes["Memberships"] = "/memberships";
    AuthRoutes["Invoices"] = "/invoices";
    AuthRoutes["MassMail"] = "/mail";
    AuthRoutes["Stocks"] = "/stocks";
    AuthRoutes["StockDetails"] = "/stocks/:id";
    AuthRoutes["Indices"] = "/indexes";
    AuthRoutes["Etfs"] = "/etfs";
    AuthRoutes["EtfValues"] = "/etfs/:id";
    AuthRoutes["Ftse"] = "/ftse";
    AuthRoutes["Msb"] = "/msb";
    AuthRoutes["Documents"] = "/documents";
    AuthRoutes["Event"] = "/event";
})($0f61036523fa4b5e$export$497d3dafd4dc9b7c || ($0f61036523fa4b5e$export$497d3dafd4dc9b7c = {}));
var $0f61036523fa4b5e$export$b7f74e73bfead856;
(function(PublicRoutes) {
    PublicRoutes["Login"] = "/login";
})($0f61036523fa4b5e$export$b7f74e73bfead856 || ($0f61036523fa4b5e$export$b7f74e73bfead856 = {}));
var $0f61036523fa4b5e$export$6ceee8b279e57709;
(function(AdminRoutes) {
    AdminRoutes["Users"] = "/users";
    AdminRoutes["UserDetails"] = "/users/:id";
    AdminRoutes["UserGroups"] = "/groups";
    AdminRoutes["Customization"] = "/customization";
    AdminRoutes["Interests"] = "/interests";
    AdminRoutes["FTSEConfig"] = "/ftse-config";
    AdminRoutes["SiteSections"] = "/site-sections";
    AdminRoutes["MeetingTypes"] = "/meeting-types";
})($0f61036523fa4b5e$export$6ceee8b279e57709 || ($0f61036523fa4b5e$export$6ceee8b279e57709 = {}));
var $0f61036523fa4b5e$export$f4bfbadc8ccd5fbc;
(function(RouteNames) {
    RouteNames["Login"] = "login";
    RouteNames["Admin"] = "Admin";
    RouteNames["AdminUsers"] = "Users";
    RouteNames["AdminUserDetails"] = "User Details";
    RouteNames["AdminUserGroups"] = "User Groups";
    RouteNames["AdminCustomization"] = "Customization";
    RouteNames["AdminInterests"] = "Interests";
    RouteNames["AdminFtseConfig"] = "FTSE Config";
    RouteNames["AdminSiteSections"] = "Site Sections";
    RouteNames["AdminMeetingTypes"] = "Meeting Types";
    RouteNames["Home"] = "Overview";
    RouteNames["Companies"] = "Companies";
    RouteNames["Calendar"] = "Calendar";
    RouteNames["Contacts"] = "Contacts";
    RouteNames["Products"] = "Products";
    RouteNames["Meetings"] = "Meetings";
    RouteNames["CompanyDetails"] = "Company Details";
    RouteNames["ContactDetails"] = "Contact Details";
    RouteNames["ProductDetails"] = "Product Details";
    RouteNames["MembershipDetails"] = "Membership Details";
    RouteNames["Memberships"] = "Memberships";
    RouteNames["Invoices"] = "Invoices";
    RouteNames["MassMail"] = "Mass Mail";
    RouteNames["Stocks"] = "Stocks";
    RouteNames["StockDetails"] = "Stock Details";
    RouteNames["Indices"] = "Indexes";
    RouteNames["Etfs"] = "ETF Data";
    RouteNames["EtfValues"] = "ETF Data";
    RouteNames["Ftse"] = "FTSE";
    RouteNames["Msb"] = "Msb";
    RouteNames["Documents"] = "Documents";
    RouteNames["Event"] = "Event";
})($0f61036523fa4b5e$export$f4bfbadc8ccd5fbc || ($0f61036523fa4b5e$export$f4bfbadc8ccd5fbc = {}));
var $0f61036523fa4b5e$export$e65c88f8e9056ee0;
(function(NavElements) {
    NavElements["Item"] = "Item";
    NavElements["Group"] = "Group";
})($0f61036523fa4b5e$export$e65c88f8e9056ee0 || ($0f61036523fa4b5e$export$e65c88f8e9056ee0 = {}));

});

parcelRegister("eBeqV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5b67cf4c4e11527$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $hsjD5 = parcelRequire("hsjD5");

var $7rjIK = parcelRequire("7rjIK");

var $k3DeF = parcelRequire("k3DeF");

var $6L9uu = parcelRequire("6L9uu");

var $ePCTs = parcelRequire("ePCTs");
const $b5b67cf4c4e11527$var$PALETTE_FOR_MEMBERSHIP_STATISTICS_CHART = [
    (0, $6L9uu.DashboardColors).light_blue,
    (0, $6L9uu.Colors).main,
    (0, $6L9uu.Colors).green
];
const $b5b67cf4c4e11527$var$PALETTE_FOR_INVOICE_CHART = [
    (0, $6L9uu.Colors).purple,
    (0, $6L9uu.Colors).green,
    (0, $6L9uu.Colors).third,
    (0, $6L9uu.Colors).purple,
    (0, $6L9uu.Colors).green,
    (0, $6L9uu.Colors).third
];
const $b5b67cf4c4e11527$var$Dashboard = ()=>{
    const { data: data } = (0, $hjfla.useDashboardDoughnutQueryQuery)();
    const membershipData = (0, $hjfla.useDashboardMembershipsInfoForTheLastThreeYearsQuery)();
    const mailStats = (0, $hjfla.useGetSendGridStatisticsQuery)();
    const [doughnutData, setDoughnutData] = (0, $bh6RR.useState)([]);
    const [mailData, setMailData] = (0, $bh6RR.useState)([]);
    const [membershipsForLastThreeYears, setMembershipsForLastThreeYears] = (0, $bh6RR.useState)([]);
    const invoicesData = (0, $hjfla.useDashboardInvoicesInfoQuery)();
    const [invoicesPayment, setInvoicesPayment] = (0, $bh6RR.useState)([]);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setDoughnutData(data.result);
    });
    (0, $bh6RR.useEffect)(()=>{
        if (membershipData.data && membershipData.data.result) setMembershipsForLastThreeYears(membershipData.data.result);
    });
    (0, $bh6RR.useEffect)(()=>{
        if (invoicesData.data && invoicesData.data.result) setInvoicesPayment(invoicesData.data.result);
    });
    (0, $bh6RR.useEffect)(()=>{
        if (mailStats.data && mailStats.data.result) setMailData(mailStats.data.result);
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const doughnutTooltip = (arg)=>{
        //arg = props from Series
        return {
            text: arg.argument
        };
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const doughnutConnector = (arg)=>{
        const text = arg.argumentText.trim().split(" ");
        text.pop();
        return `${text.join(" ")} ${(arg.percent * 100).toFixed(2)}%`;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const membershipStatistics = (arg)=>{
        return {
            text: `${arg.originalValue} ${arg.seriesName}`
        };
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invoiceData = (arg)=>{
        if (arg.seriesName.indexOf("count") > -1) {
            if (arg.seriesName.indexOf("issued") > -1) return {
                text: `${arg.originalValue} issued invoices`
            };
            else return {
                text: `${arg.originalValue} paid invoices`
            };
        } else return {
            text: `\u{20AC} ${arg.originalValue}`
        };
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customizeTooltip = (arg)=>{
        return {
            text: `${arg.value} ${arg.seriesName}`
        };
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
        container: true,
        style: {
            height: "438px"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                item: true,
                md: 4,
                sm: 12,
                style: {
                    marginTop: "31px",
                    boxShadow: `0px 3px 15px ${(0, $6L9uu.Colors).lightBlue}`
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($7rjIK))), {
                        id: "doughnutChart",
                        type: "doughnut",
                        palette: (0, $hsjD5.getMembershipColors)(doughnutData),
                        dataSource: doughnutData,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Size), {}),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Margin), {
                                bottom: 0
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Title), {
                                text: "Number Of Members Split By Type",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Font), {
                                    color: (0, $6L9uu.DashboardColors).title,
                                    size: "16"
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Series), {
                                argumentField: "label",
                                valueField: "count",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Label), {
                                    visible: true,
                                    customizeText: doughnutConnector,
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Connector), {
                                        visible: true
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Export), {
                                enabled: true
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Legend), {
                                horizontalAlignment: "center",
                                verticalAlignment: "bottom"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Tooltip), {
                                enabled: true,
                                customizeTooltip: doughnutTooltip
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                item: true,
                md: 8,
                sm: 12,
                style: {
                    marginTop: "31px",
                    paddingLeft: "21px",
                    boxShadow: `0px 3px 15px ${(0, $6L9uu.Colors).lightBlue}`
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $k3DeF.Chart), {
                        id: "membershipChart",
                        dataSource: membershipsForLastThreeYears,
                        palette: $b5b67cf4c4e11527$var$PALETTE_FOR_MEMBERSHIP_STATISTICS_CHART,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Margin), {
                                bottom: 0
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Title), {
                                text: "Memberships Statistics L3Y",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Font), {
                                    color: (0, $6L9uu.DashboardColors).title,
                                    size: "16"
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.CommonSeriesSettings), {
                                type: "bar",
                                barPadding: 0,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Label), {
                                    visible: false
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Series), {
                                argumentField: "quarters_date",
                                valueField: "started_memberships_count",
                                name: "New"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Series), {
                                argumentField: "quarters_date",
                                valueField: "ended_memberships_count",
                                name: "Ended"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Series), {
                                argumentField: "quarters_date",
                                valueField: "renewed_memberships_count",
                                name: "Renewed"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Export), {
                                enabled: true
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Legend), {
                                margin: {
                                    top: 35
                                },
                                horizontalAlignment: "center",
                                verticalAlignment: "botom"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Tooltip), {
                                enabled: true,
                                customizeTooltip: membershipStatistics
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                item: true,
                md: 6,
                sm: 12,
                style: {
                    marginTop: "31px",
                    paddingLeft: "21px",
                    boxShadow: `0px 3px 15px ${(0, $6L9uu.Colors).lightBlue}`
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $k3DeF.Chart), {
                        id: "invoiceChart",
                        dataSource: invoicesPayment,
                        palette: $b5b67cf4c4e11527$var$PALETTE_FOR_INVOICE_CHART,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Margin), {
                                bottom: 0
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Title), {
                                text: "Invoice Statistics",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Font), {
                                    color: (0, $6L9uu.DashboardColors).title,
                                    size: "16"
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.CommonSeriesSettings), {
                                type: "bar",
                                barPadding: 0,
                                argumentField: "date",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Label), {
                                    visible: false
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Series), {
                                valueField: "total_issued_invoices_count",
                                name: "issued-count",
                                axis: "number-of-invoices",
                                showInLegend: false
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Series), {
                                valueField: "total_paid_invoices_count",
                                name: "paid-count",
                                axis: "number-of-invoices",
                                showInLegend: false
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Series), {
                                valueField: "outstanding\u0433",
                                name: "outstanding-count",
                                axis: "number-of-invoices",
                                showInLegend: false
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Series), {
                                argumentField: "date",
                                valueField: "issued_invoices",
                                name: "Issued",
                                type: "spline",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Point), {
                                    visible: false
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Series), {
                                argumentField: "date",
                                valueField: "paid_invoices",
                                name: "Paid",
                                type: "spline",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Point), {
                                    visible: false
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Series), {
                                argumentField: "date",
                                valueField: "outstanding",
                                name: "Outstanding",
                                type: "spline",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Point), {
                                    visible: false
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Export), {
                                enabled: true
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.Legend), {
                                margin: {
                                    top: 35
                                },
                                horizontalAlignment: "center",
                                verticalAlignment: "botom"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.ValueAxis), {
                                name: "sum-in-millions",
                                position: "right"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.ValueAxis), {
                                name: "number-of-invoices",
                                position: "left"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Tooltip), {
                                enabled: true,
                                shared: false,
                                customizeTooltip: invoiceData
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                item: true,
                md: 6,
                sm: 12,
                style: {
                    marginTop: "31px",
                    paddingLeft: "21px",
                    boxShadow: `0px 3px 15px ${(0, $6L9uu.Colors).lightBlue}`
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $k3DeF.Chart), {
                        id: "massMailStatistics",
                        dataSource: mailData,
                        palette: (0, $hsjD5.getMassMailColors)(mailData),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Title), {
                                text: "Mass Mail Statistics",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Font), {
                                    color: (0, $6L9uu.DashboardColors).title,
                                    size: "16"
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $k3DeF.CommonSeriesSettings), {
                                argumentField: "month",
                                type: "stackedBar"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Series), {
                                valueField: "sent",
                                name: "Sent"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Series), {
                                valueField: "delivered",
                                name: "Delivered"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Series), {
                                valueField: "read",
                                name: "Read"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Series), {
                                valueField: "blocks",
                                name: "Blocks"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Series), {
                                valueField: "bounces",
                                name: "Bounces"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Series), {
                                valueField: "spam_reports",
                                name: "Spam Reports"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Legend), {
                                margin: {
                                    top: 35
                                },
                                verticalAlignment: "bottom",
                                horizontalAlignment: "center"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Tooltip), {
                                enabled: true,
                                customizeTooltip: customizeTooltip
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7rjIK.Export), {
                                enabled: true
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $b5b67cf4c4e11527$export$2e2bcd8739ae039 = $b5b67cf4c4e11527$var$Dashboard;

});
parcelRegister("hjfla", function(module, exports) {

$parcel$export(module.exports, "useCompanyAddressesQuery", function () { return $00d97f6f0e186a01$export$948d0bace3ef9cf5; });
$parcel$export(module.exports, "useCompanyAddressesLazyQuery", function () { return $00d97f6f0e186a01$export$99ecd69ab881ded; });
$parcel$export(module.exports, "useAddAddressMutation", function () { return $00d97f6f0e186a01$export$bd00e7740b567a9d; });
$parcel$export(module.exports, "useUpdateAddressMutation", function () { return $00d97f6f0e186a01$export$acd2b75cb433a7db; });
$parcel$export(module.exports, "useDeleteAddressMutation", function () { return $00d97f6f0e186a01$export$60cc172872792d7d; });
$parcel$export(module.exports, "useAddValueMutation", function () { return $00d97f6f0e186a01$export$c780883d61dbb54; });
$parcel$export(module.exports, "useDeleteValueMutation", function () { return $00d97f6f0e186a01$export$6160b57eeb853cb7; });
$parcel$export(module.exports, "useGetAllocationSectorsQuery", function () { return $00d97f6f0e186a01$export$da79a7c0a79470af; });
$parcel$export(module.exports, "useCreateAllocationSectorMutation", function () { return $00d97f6f0e186a01$export$8b84740dc6ddb1d; });
$parcel$export(module.exports, "useUpdateAllocationSectorMutation", function () { return $00d97f6f0e186a01$export$aec7dccbd159706f; });
$parcel$export(module.exports, "useDeleteAllocationSectorMutation", function () { return $00d97f6f0e186a01$export$b06e93899a9cacc3; });
$parcel$export(module.exports, "useAllocationSectorCreatedSubscription", function () { return $00d97f6f0e186a01$export$266443c88aedb2e6; });
$parcel$export(module.exports, "useAllocationSectorUpdatedSubscription", function () { return $00d97f6f0e186a01$export$295c553c37464018; });
$parcel$export(module.exports, "useAllocationSectorDeletedSubscription", function () { return $00d97f6f0e186a01$export$d94076d4d218fb74; });
$parcel$export(module.exports, "EventsDocument", function () { return $00d97f6f0e186a01$export$573ba9c2cbf31e2d; });
$parcel$export(module.exports, "useEventsQuery", function () { return $00d97f6f0e186a01$export$f264892194843ef2; });
$parcel$export(module.exports, "useCalendarTypesQuery", function () { return $00d97f6f0e186a01$export$d2394cc879ba0765; });
$parcel$export(module.exports, "useAddEventMutation", function () { return $00d97f6f0e186a01$export$c381a7e1362c5fbd; });
$parcel$export(module.exports, "useDeleteEventMutation", function () { return $00d97f6f0e186a01$export$257c69caab61b878; });
$parcel$export(module.exports, "useUpdateEventMutation", function () { return $00d97f6f0e186a01$export$d624085c29681b0a; });
$parcel$export(module.exports, "useEventCreatedSubscription", function () { return $00d97f6f0e186a01$export$b8ddc131170f86d7; });
$parcel$export(module.exports, "useEventDeletedSubscription", function () { return $00d97f6f0e186a01$export$68a84a913c319bb9; });
$parcel$export(module.exports, "useEventUpdatedSubscription", function () { return $00d97f6f0e186a01$export$907e7d633ded2a78; });
$parcel$export(module.exports, "useGetClosePricesQuery", function () { return $00d97f6f0e186a01$export$8b0f85ab3a2b5c02; });
$parcel$export(module.exports, "useHistoryIndicesByIdAndPeriodLazyQuery", function () { return $00d97f6f0e186a01$export$a11d582d8eac6325; });
$parcel$export(module.exports, "useCreateHistoryStocksMutation", function () { return $00d97f6f0e186a01$export$2adb5728c168eda2; });
$parcel$export(module.exports, "useCreateHistoryIndicesMutation", function () { return $00d97f6f0e186a01$export$861a9940a4339576; });
$parcel$export(module.exports, "useMembershipCommentsQuery", function () { return $00d97f6f0e186a01$export$fa79fb7bda2b15bf; });
$parcel$export(module.exports, "useAddCommentMutation", function () { return $00d97f6f0e186a01$export$950e3195c77fb453; });
$parcel$export(module.exports, "useDeleteCommentMutation", function () { return $00d97f6f0e186a01$export$91bcd2720f6c2c6; });
$parcel$export(module.exports, "useCommentAddedSubscription", function () { return $00d97f6f0e186a01$export$13af509fa5d6ebc8; });
$parcel$export(module.exports, "useCommentDeletedSubscription", function () { return $00d97f6f0e186a01$export$87398996bb560cdc; });
$parcel$export(module.exports, "CompaniesDocument", function () { return $00d97f6f0e186a01$export$6746277e7878d46b; });
$parcel$export(module.exports, "useCompaniesQuery", function () { return $00d97f6f0e186a01$export$cc20ea60737f9b0c; });
$parcel$export(module.exports, "CompaniesNamesDocument", function () { return $00d97f6f0e186a01$export$134e43ba31e88e97; });
$parcel$export(module.exports, "useCompaniesNamesQuery", function () { return $00d97f6f0e186a01$export$680f18b8879b3ad6; });
$parcel$export(module.exports, "useCompaniesNamesLazyQuery", function () { return $00d97f6f0e186a01$export$5ff9fbef64819121; });
$parcel$export(module.exports, "useCompanyLazyQuery", function () { return $00d97f6f0e186a01$export$4a17e28283151ba8; });
$parcel$export(module.exports, "CompaniesFilteredDocument", function () { return $00d97f6f0e186a01$export$ab84cea386e3d93c; });
$parcel$export(module.exports, "useCompaniesFilteredLazyQuery", function () { return $00d97f6f0e186a01$export$a59a9625f3100a69; });
$parcel$export(module.exports, "useAddCompanyMutation", function () { return $00d97f6f0e186a01$export$908b0e424e1aa730; });
$parcel$export(module.exports, "useUpdateCompanyMutation", function () { return $00d97f6f0e186a01$export$fa89acc2cdf44ad8; });
$parcel$export(module.exports, "useUpdateCompanyMembershipMutation", function () { return $00d97f6f0e186a01$export$811736e65a26849e; });
$parcel$export(module.exports, "useDeleteCompanyMutation", function () { return $00d97f6f0e186a01$export$2fb90047bdebe6fb; });
$parcel$export(module.exports, "useAddCompanyToMembershipMutation", function () { return $00d97f6f0e186a01$export$fbde7b74cd84e3d5; });
$parcel$export(module.exports, "useUpdateCompanyMainMemberForMembershipMutation", function () { return $00d97f6f0e186a01$export$8b77557e39a37a11; });
$parcel$export(module.exports, "useUpdateCompanyMainContactMutation", function () { return $00d97f6f0e186a01$export$7444174f642e0612; });
$parcel$export(module.exports, "useCompanyCreatedSubscription", function () { return $00d97f6f0e186a01$export$87abaebe8b175796; });
$parcel$export(module.exports, "useCompanyDeletedSubscription", function () { return $00d97f6f0e186a01$export$93a63d6bf5e32a63; });
$parcel$export(module.exports, "useCompanyUpdatedSubscription", function () { return $00d97f6f0e186a01$export$ca616a9a9340d29; });
$parcel$export(module.exports, "CompanyTypesDocument", function () { return $00d97f6f0e186a01$export$b211573a2acce67c; });
$parcel$export(module.exports, "useCompanyTypesQuery", function () { return $00d97f6f0e186a01$export$5cc89c9d8186016; });
$parcel$export(module.exports, "useCompanyTypesLazyQuery", function () { return $00d97f6f0e186a01$export$5a172ce6f9931466; });
$parcel$export(module.exports, "useCompanyContactsQuery", function () { return $00d97f6f0e186a01$export$e475eb7a4886aa70; });
$parcel$export(module.exports, "ContactsDocument", function () { return $00d97f6f0e186a01$export$b127912377ac22e9; });
$parcel$export(module.exports, "useContactsQuery", function () { return $00d97f6f0e186a01$export$2c260f9f327fbdbc; });
$parcel$export(module.exports, "ContactsFilteredDocument", function () { return $00d97f6f0e186a01$export$2c802e062f813bd3; });
$parcel$export(module.exports, "useContactsFilteredLazyQuery", function () { return $00d97f6f0e186a01$export$c0dad8b91225639a; });
$parcel$export(module.exports, "useContactByEmailAndFullNameQuery", function () { return $00d97f6f0e186a01$export$9623462de32577e4; });
$parcel$export(module.exports, "useContactQuery", function () { return $00d97f6f0e186a01$export$e73af2330ae77132; });
$parcel$export(module.exports, "useContactDetailsQuery", function () { return $00d97f6f0e186a01$export$423de2676ae8d7eb; });
$parcel$export(module.exports, "useContactBasicDataQuery", function () { return $00d97f6f0e186a01$export$b96558b58e974053; });
$parcel$export(module.exports, "useAssistantContactsFromSameCompanyLazyQuery", function () { return $00d97f6f0e186a01$export$b6fe6fcd895ea941; });
$parcel$export(module.exports, "useContactInterestsQuery", function () { return $00d97f6f0e186a01$export$3ab4f899641398ba; });
$parcel$export(module.exports, "useContactsByInterestsQuery", function () { return $00d97f6f0e186a01$export$84e0f38fd0b59a6b; });
$parcel$export(module.exports, "useRecipientListContactsQuery", function () { return $00d97f6f0e186a01$export$80e7c5bff9486ef0; });
$parcel$export(module.exports, "useDeleteContactMutation", function () { return $00d97f6f0e186a01$export$2ebd21a5eb675d89; });
$parcel$export(module.exports, "useCreateContactMutation", function () { return $00d97f6f0e186a01$export$53a2be496701405e; });
$parcel$export(module.exports, "useUpdateContactDetailsMutation", function () { return $00d97f6f0e186a01$export$85c6fc1c9d18b5f9; });
$parcel$export(module.exports, "useUpdateContactAddressMutation", function () { return $00d97f6f0e186a01$export$a0f1ab69b28d68df; });
$parcel$export(module.exports, "useUpdateContactAssistantMutation", function () { return $00d97f6f0e186a01$export$3953cb133faa91c7; });
$parcel$export(module.exports, "useSetInvoiceToContactMutation", function () { return $00d97f6f0e186a01$export$17bba5cf9d251204; });
$parcel$export(module.exports, "useUpdateContactInterestsMutation", function () { return $00d97f6f0e186a01$export$1aa472d78be1ac2f; });
$parcel$export(module.exports, "useContactDeletedSubscription", function () { return $00d97f6f0e186a01$export$4064c5bb2fbf4d99; });
$parcel$export(module.exports, "useContactCreatedSubscription", function () { return $00d97f6f0e186a01$export$442e7a390e59f3c5; });
$parcel$export(module.exports, "useContactUpdatedSubscription", function () { return $00d97f6f0e186a01$export$b77d5b1c309be11e; });
$parcel$export(module.exports, "useCountriesQuery", function () { return $00d97f6f0e186a01$export$30acda5e65e8ffe1; });
$parcel$export(module.exports, "useCountryNamesQuery", function () { return $00d97f6f0e186a01$export$39ab25f56fd368c8; });
$parcel$export(module.exports, "useCurrenciesQuery", function () { return $00d97f6f0e186a01$export$c2bec37b8f24999d; });
$parcel$export(module.exports, "useGetAllCventEventsQuery", function () { return $00d97f6f0e186a01$export$19fb136105f4be25; });
$parcel$export(module.exports, "useGetAllCventRolesQuery", function () { return $00d97f6f0e186a01$export$cb9bef9e78b92574; });
$parcel$export(module.exports, "useGetAllCventContactsForLocationLazyQuery", function () { return $00d97f6f0e186a01$export$9826d01e399fd033; });
$parcel$export(module.exports, "useGetAllLocationsForEventLazyQuery", function () { return $00d97f6f0e186a01$export$7eeb6dc5bb56edbe; });
$parcel$export(module.exports, "useGetMatchedDbContactsByEmailQuery", function () { return $00d97f6f0e186a01$export$4aeb34405477065c; });
$parcel$export(module.exports, "useCreateCventContactMutation", function () { return $00d97f6f0e186a01$export$2afec89b6bd5ff3d; });
$parcel$export(module.exports, "useUpdateCventContactMutation", function () { return $00d97f6f0e186a01$export$5081f8a3c9b39e6b; });
$parcel$export(module.exports, "useDeleteCventContactMutation", function () { return $00d97f6f0e186a01$export$3b53c66cd721baa1; });
$parcel$export(module.exports, "useLinkContactMutation", function () { return $00d97f6f0e186a01$export$ecbf0d19256d2a; });
$parcel$export(module.exports, "useUnLinkContactMutation", function () { return $00d97f6f0e186a01$export$8485c007549ac860; });
$parcel$export(module.exports, "useToggleIsApprovedMutation", function () { return $00d97f6f0e186a01$export$627aa582cc1a7174; });
$parcel$export(module.exports, "useUploadCventContactsMutation", function () { return $00d97f6f0e186a01$export$e365e22d6cb57046; });
$parcel$export(module.exports, "useDashboardDoughnutQueryQuery", function () { return $00d97f6f0e186a01$export$9d3c6cf3b6b298fe; });
$parcel$export(module.exports, "useDashboardMembershipsInfoForTheLastThreeYearsQuery", function () { return $00d97f6f0e186a01$export$3a801f09e9b8bd93; });
$parcel$export(module.exports, "useDashboardInvoicesInfoQuery", function () { return $00d97f6f0e186a01$export$9ae0eba6dd59e530; });
$parcel$export(module.exports, "useGetDividendsGrossQuery", function () { return $00d97f6f0e186a01$export$7be861d3bf8fb6d6; });
$parcel$export(module.exports, "useCreateDividendMutation", function () { return $00d97f6f0e186a01$export$ee84a415d81426e2; });
$parcel$export(module.exports, "useUpdateDividendMutation", function () { return $00d97f6f0e186a01$export$48efb717a74b5a53; });
$parcel$export(module.exports, "useDeleteDividendMutation", function () { return $00d97f6f0e186a01$export$23a85e4e9432b04; });
$parcel$export(module.exports, "useDividendCreatedSubscription", function () { return $00d97f6f0e186a01$export$ca1491b9c4dcc72f; });
$parcel$export(module.exports, "useDividendUpdatedSubscription", function () { return $00d97f6f0e186a01$export$592f6f15d6a10154; });
$parcel$export(module.exports, "useDividendDeletedSubscription", function () { return $00d97f6f0e186a01$export$30849f9b09454be6; });
$parcel$export(module.exports, "DocumentsDocument", function () { return $00d97f6f0e186a01$export$f75860313b413655; });
$parcel$export(module.exports, "useDocumentsFilteredLazyQuery", function () { return $00d97f6f0e186a01$export$ba9cab5884e2f62d; });
$parcel$export(module.exports, "useCreateDocumentMutation", function () { return $00d97f6f0e186a01$export$cbe541f8c16813d9; });
$parcel$export(module.exports, "useUpdateDocumentMutation", function () { return $00d97f6f0e186a01$export$27fcba640b9d64a1; });
$parcel$export(module.exports, "useDeleteDocumentMutation", function () { return $00d97f6f0e186a01$export$d3195cfd812c44cf; });
$parcel$export(module.exports, "useDeleteDocumentFromSiteSectionMutation", function () { return $00d97f6f0e186a01$export$d376833610cd8e83; });
$parcel$export(module.exports, "useUpdateDescriptionMutation", function () { return $00d97f6f0e186a01$export$e881fa78b0d6ec1c; });
$parcel$export(module.exports, "useDocumentDeletedSubscription", function () { return $00d97f6f0e186a01$export$a3884f9363f409d6; });
$parcel$export(module.exports, "useDocumentUpdatedSubscription", function () { return $00d97f6f0e186a01$export$2967f4cb7c10f456; });
$parcel$export(module.exports, "useDocumentCreatedSubscription", function () { return $00d97f6f0e186a01$export$794e4c4c95140d9; });
$parcel$export(module.exports, "GetEtfsDocument", function () { return $00d97f6f0e186a01$export$a8bcbc70c85c90cb; });
$parcel$export(module.exports, "useGetEtfsQuery", function () { return $00d97f6f0e186a01$export$2b2eea9ead661b19; });
$parcel$export(module.exports, "useGetEtfValuesQuery", function () { return $00d97f6f0e186a01$export$f0498b0df538f9c1; });
$parcel$export(module.exports, "useGetEtfLazyQuery", function () { return $00d97f6f0e186a01$export$e2735e948b8e8f8; });
$parcel$export(module.exports, "useAddEtfMutation", function () { return $00d97f6f0e186a01$export$a213f769e12aee78; });
$parcel$export(module.exports, "useUpdateEtfMutation", function () { return $00d97f6f0e186a01$export$5ba67e5b0a3149d0; });
$parcel$export(module.exports, "useDeleteEtfMutation", function () { return $00d97f6f0e186a01$export$6484f049bc57a39e; });
$parcel$export(module.exports, "useAddEtfValueMutation", function () { return $00d97f6f0e186a01$export$8e5e38b7fd16c285; });
$parcel$export(module.exports, "useUpdateEtfValueMutation", function () { return $00d97f6f0e186a01$export$b791056ef9b636e1; });
$parcel$export(module.exports, "useEtfCreatedSubscription", function () { return $00d97f6f0e186a01$export$445cd6d91b3f18e6; });
$parcel$export(module.exports, "useEtfUpdatedSubscription", function () { return $00d97f6f0e186a01$export$28ee9deea439cdb; });
$parcel$export(module.exports, "useEtfDeletedSubscription", function () { return $00d97f6f0e186a01$export$7ea6272d58d06ac3; });
$parcel$export(module.exports, "useEtfValueCreatedSubscription", function () { return $00d97f6f0e186a01$export$b1c1bd886f367d13; });
$parcel$export(module.exports, "useEtfValueUpdatedSubscription", function () { return $00d97f6f0e186a01$export$e599d97b814147c7; });
$parcel$export(module.exports, "useGetEtfsWithValuesLazyQuery", function () { return $00d97f6f0e186a01$export$265780726f9501c9; });
$parcel$export(module.exports, "GetFtseFilesDocument", function () { return $00d97f6f0e186a01$export$437ea2a8383dda7a; });
$parcel$export(module.exports, "useGetFtseFilesQuery", function () { return $00d97f6f0e186a01$export$70704029d733a80e; });
$parcel$export(module.exports, "useGetFtseTypesQuery", function () { return $00d97f6f0e186a01$export$8047f728cd7bb9f0; });
$parcel$export(module.exports, "GetFtseConfigurationsDocument", function () { return $00d97f6f0e186a01$export$1c09fbb2a4da964; });
$parcel$export(module.exports, "useGetFtseConfigurationsQuery", function () { return $00d97f6f0e186a01$export$de6a4a17e4bb6822; });
$parcel$export(module.exports, "useDeleteFtseFileMutation", function () { return $00d97f6f0e186a01$export$f5e2156276d04a76; });
$parcel$export(module.exports, "useCreateFtseFileMutation", function () { return $00d97f6f0e186a01$export$65023ac5d20cd20a; });
$parcel$export(module.exports, "useUpdateFtseMutation", function () { return $00d97f6f0e186a01$export$9b830a578189f88e; });
$parcel$export(module.exports, "useUpdateFtseConfigurationMutation", function () { return $00d97f6f0e186a01$export$3e260e4bdb2e765a; });
$parcel$export(module.exports, "useFtseFileCreatedSubscription", function () { return $00d97f6f0e186a01$export$664db6aae072c044; });
$parcel$export(module.exports, "useFtseFileUpdatedSubscription", function () { return $00d97f6f0e186a01$export$2f3b2766e4269b4d; });
$parcel$export(module.exports, "useFtseConfigurationUpdatedSubscription", function () { return $00d97f6f0e186a01$export$a3c293a6630df2d5; });
$parcel$export(module.exports, "useFtseFileDeletedSubscription", function () { return $00d97f6f0e186a01$export$8bbe34b14544d839; });
$parcel$export(module.exports, "useGetLatestFxDataLazyQuery", function () { return $00d97f6f0e186a01$export$a3f909b7845dbc67; });
$parcel$export(module.exports, "useGetHistoryAllocationCountriesQuery", function () { return $00d97f6f0e186a01$export$fbdb3958f2df0a0; });
$parcel$export(module.exports, "useCreateAllocationCountryMutation", function () { return $00d97f6f0e186a01$export$84228c29c0adcf9f; });
$parcel$export(module.exports, "useUpdateAllocationCountryMutation", function () { return $00d97f6f0e186a01$export$1bf85f06d0a02fb8; });
$parcel$export(module.exports, "useDeleteAllocationCountryMutation", function () { return $00d97f6f0e186a01$export$d4a9e2da13045083; });
$parcel$export(module.exports, "useAllocationCountryCreatedSubscription", function () { return $00d97f6f0e186a01$export$fa40a5ee96584435; });
$parcel$export(module.exports, "useAllocationCountryUpdatedSubscription", function () { return $00d97f6f0e186a01$export$5a1d447550e9bc43; });
$parcel$export(module.exports, "useAllocationCountryDeletedSubscription", function () { return $00d97f6f0e186a01$export$22fc559b83592be9; });
$parcel$export(module.exports, "useGetHistoryAwardsQuery", function () { return $00d97f6f0e186a01$export$43d0b5079c27daf8; });
$parcel$export(module.exports, "useGetAwardTypesQuery", function () { return $00d97f6f0e186a01$export$f2c09acdbbe18ab4; });
$parcel$export(module.exports, "useCreateAwardMutation", function () { return $00d97f6f0e186a01$export$7d8f9790a518858e; });
$parcel$export(module.exports, "useUpdateAwardMutation", function () { return $00d97f6f0e186a01$export$74e92962de4bbe97; });
$parcel$export(module.exports, "useDeleteAwardMutation", function () { return $00d97f6f0e186a01$export$bf5ab944176c55be; });
$parcel$export(module.exports, "useAwardCreatedSubscription", function () { return $00d97f6f0e186a01$export$2abd0de3705b7141; });
$parcel$export(module.exports, "useAwardUpdatedSubscription", function () { return $00d97f6f0e186a01$export$3ef792d6d4638beb; });
$parcel$export(module.exports, "useAwardDeletedSubscription", function () { return $00d97f6f0e186a01$export$fdeaa2e0ac266062; });
$parcel$export(module.exports, "useGetHistoryConstituentsLazyQuery", function () { return $00d97f6f0e186a01$export$852b7b2dc7bc531f; });
$parcel$export(module.exports, "useGetHistoryConstituentsByIndexLazyQuery", function () { return $00d97f6f0e186a01$export$b84f923b9e32fb01; });
$parcel$export(module.exports, "useGetHistoryKpisQuery", function () { return $00d97f6f0e186a01$export$74ab90aa145689db; });
$parcel$export(module.exports, "useCreateKpiMutation", function () { return $00d97f6f0e186a01$export$fa8cbc2cf2ef2942; });
$parcel$export(module.exports, "useUpdateKpiMutation", function () { return $00d97f6f0e186a01$export$18cc6c59969b5ab1; });
$parcel$export(module.exports, "useDeleteKpiMutation", function () { return $00d97f6f0e186a01$export$1351df3c97550e47; });
$parcel$export(module.exports, "useKpiCreatedSubscription", function () { return $00d97f6f0e186a01$export$59e9bc4c65a91f11; });
$parcel$export(module.exports, "useKpiUpdatedSubscription", function () { return $00d97f6f0e186a01$export$e56860371ea92b7f; });
$parcel$export(module.exports, "useKpiDeletedSubscription", function () { return $00d97f6f0e186a01$export$46fc175d81ab2bdd; });
$parcel$export(module.exports, "useGetHistoryLtvsQuery", function () { return $00d97f6f0e186a01$export$17036708e4202907; });
$parcel$export(module.exports, "useCreateLtvMutation", function () { return $00d97f6f0e186a01$export$c552f006ee5724a0; });
$parcel$export(module.exports, "useUpdateLtvMutation", function () { return $00d97f6f0e186a01$export$dac975094093afb6; });
$parcel$export(module.exports, "useDeleteLtvMutation", function () { return $00d97f6f0e186a01$export$7af9b7ae2cd8dd0; });
$parcel$export(module.exports, "useLtvCreatedSubscription", function () { return $00d97f6f0e186a01$export$93721d97a530041d; });
$parcel$export(module.exports, "useLtvUpdatedSubscription", function () { return $00d97f6f0e186a01$export$3c621b94beddb1bb; });
$parcel$export(module.exports, "useLtvDeletedSubscription", function () { return $00d97f6f0e186a01$export$35cb9480e8d6a264; });
$parcel$export(module.exports, "useGetHistoryRecalcsQuery", function () { return $00d97f6f0e186a01$export$a1f6070305f31784; });
$parcel$export(module.exports, "useGetRecalcOperatorsQuery", function () { return $00d97f6f0e186a01$export$d2c5da6f0019bcac; });
$parcel$export(module.exports, "useCreateHistoryRecalcMutation", function () { return $00d97f6f0e186a01$export$eb57b7cf9e4742fc; });
$parcel$export(module.exports, "useRecalcRollbackMutation", function () { return $00d97f6f0e186a01$export$3e28bd2e2e7103ce; });
$parcel$export(module.exports, "useUpdateHistoryRecalcMutation", function () { return $00d97f6f0e186a01$export$90a707bd8108b5ff; });
$parcel$export(module.exports, "useHistoryRecalcCreatedSubscription", function () { return $00d97f6f0e186a01$export$acaf1c0bf24e385d; });
$parcel$export(module.exports, "useHistoryRecalcUpdatedSubscription", function () { return $00d97f6f0e186a01$export$82e03c38c7a6f4ec; });
$parcel$export(module.exports, "IndexSeriesDocument", function () { return $00d97f6f0e186a01$export$3d96807b97820b5f; });
$parcel$export(module.exports, "useIndexSeriesQuery", function () { return $00d97f6f0e186a01$export$fa84934778d61bd0; });
$parcel$export(module.exports, "useDeleteIndexSerieMutation", function () { return $00d97f6f0e186a01$export$cf8502d0d3d1ed7a; });
$parcel$export(module.exports, "useCreateIndexSerieMutation", function () { return $00d97f6f0e186a01$export$53b1a5820a101797; });
$parcel$export(module.exports, "useUpdateIndexSerieMutation", function () { return $00d97f6f0e186a01$export$5030801834d393fb; });
$parcel$export(module.exports, "useIndexSerieDeletedSubscription", function () { return $00d97f6f0e186a01$export$e0d1895253b440f; });
$parcel$export(module.exports, "useIndexSerieCreatedSubscription", function () { return $00d97f6f0e186a01$export$b450ae495a1fb754; });
$parcel$export(module.exports, "useIndexSerieUpdatedSubscription", function () { return $00d97f6f0e186a01$export$665426d12c6e62b6; });
$parcel$export(module.exports, "IndicesDocument", function () { return $00d97f6f0e186a01$export$64d0ca6328b6b1cf; });
$parcel$export(module.exports, "useIndicesQuery", function () { return $00d97f6f0e186a01$export$d366e44db33b356b; });
$parcel$export(module.exports, "useCreateIndexMutation", function () { return $00d97f6f0e186a01$export$b7d54083d7b8fd97; });
$parcel$export(module.exports, "useDeleteIndexMutation", function () { return $00d97f6f0e186a01$export$9aa401bb339c7ecd; });
$parcel$export(module.exports, "useUpdateIndexMutation", function () { return $00d97f6f0e186a01$export$b84a905039363cbb; });
$parcel$export(module.exports, "useIndexCreatedSubscription", function () { return $00d97f6f0e186a01$export$f00959f982677bc9; });
$parcel$export(module.exports, "useIndexDeletedSubscription", function () { return $00d97f6f0e186a01$export$e2ae948504034d2; });
$parcel$export(module.exports, "useIndexUpdatedSubscription", function () { return $00d97f6f0e186a01$export$45782f55c255d50f; });
$parcel$export(module.exports, "GetInterestGroupsDocument", function () { return $00d97f6f0e186a01$export$879d22849d084a6d; });
$parcel$export(module.exports, "useGetInterestGroupsQuery", function () { return $00d97f6f0e186a01$export$bfb5c18a763c143d; });
$parcel$export(module.exports, "useAddInterestToGroupMutation", function () { return $00d97f6f0e186a01$export$c1fe6cc74da09bf0; });
$parcel$export(module.exports, "useDeleteInterestMutation", function () { return $00d97f6f0e186a01$export$33fe92a210a94b9d; });
$parcel$export(module.exports, "useInterestDeletedSubscription", function () { return $00d97f6f0e186a01$export$fd62661b2284a712; });
$parcel$export(module.exports, "useGetInterestsQuery", function () { return $00d97f6f0e186a01$export$678ba770cae0ed70; });
$parcel$export(module.exports, "useInvestmentFocusesQuery", function () { return $00d97f6f0e186a01$export$74fde999ec163b47; });
$parcel$export(module.exports, "useInvoicesForMembershipQuery", function () { return $00d97f6f0e186a01$export$2850e1d1b57047fa; });
$parcel$export(module.exports, "InvoicesDocument", function () { return $00d97f6f0e186a01$export$7f07e1c830f66920; });
$parcel$export(module.exports, "useInvoicesFilteredLazyQuery", function () { return $00d97f6f0e186a01$export$4db0382bcea66fb8; });
$parcel$export(module.exports, "useInvoiceClientOptionsLazyQuery", function () { return $00d97f6f0e186a01$export$89d6e8dd3997e505; });
$parcel$export(module.exports, "usePaymentDetailsQuery", function () { return $00d97f6f0e186a01$export$dba7c0249afdeeaa; });
$parcel$export(module.exports, "usePaymentDetailsLazyQuery", function () { return $00d97f6f0e186a01$export$408f32d90d710888; });
$parcel$export(module.exports, "useAddPaymentDetailsMutation", function () { return $00d97f6f0e186a01$export$4da9caba6b82a50f; });
$parcel$export(module.exports, "useDeleteInvoiceMutation", function () { return $00d97f6f0e186a01$export$fa837f5905a8351b; });
$parcel$export(module.exports, "usePayInvoiceMutation", function () { return $00d97f6f0e186a01$export$e97623b65eeab7f6; });
$parcel$export(module.exports, "useCreateInvoiceMutation", function () { return $00d97f6f0e186a01$export$27ac8574606723ab; });
$parcel$export(module.exports, "useUpdateInvoiceMutation", function () { return $00d97f6f0e186a01$export$e0ecd277c9011226; });
$parcel$export(module.exports, "useCreateCreditNoteMutation", function () { return $00d97f6f0e186a01$export$66f1c3849b5547d5; });
$parcel$export(module.exports, "useConfirmInvoiceMutation", function () { return $00d97f6f0e186a01$export$c8be67382b5dab1c; });
$parcel$export(module.exports, "useInvoiceDeletedSubscription", function () { return $00d97f6f0e186a01$export$b36f8522cf19520d; });
$parcel$export(module.exports, "useInvoiceUpdatedSubscription", function () { return $00d97f6f0e186a01$export$e09ffcd06d9e4659; });
$parcel$export(module.exports, "useInvoiceCreatedSubscription", function () { return $00d97f6f0e186a01$export$5de8fb7c39a8f9d5; });
$parcel$export(module.exports, "useSinginMutation", function () { return $00d97f6f0e186a01$export$1818c732788eb79b; });
$parcel$export(module.exports, "useSendInvoiceForApprovalMutation", function () { return $00d97f6f0e186a01$export$ef7addfe1c61901; });
$parcel$export(module.exports, "useSendInvoiceToCustomerMutation", function () { return $00d97f6f0e186a01$export$826b582162d880b1; });
$parcel$export(module.exports, "MarketActivitiesDocument", function () { return $00d97f6f0e186a01$export$544bae422c427ec1; });
$parcel$export(module.exports, "useMarketActivitiesQuery", function () { return $00d97f6f0e186a01$export$6f6fccd9b686ad3a; });
$parcel$export(module.exports, "useMarketActivitiesLazyQuery", function () { return $00d97f6f0e186a01$export$95c63529d0c24bdc; });
$parcel$export(module.exports, "MeetingsMeetingTypeDocument", function () { return $00d97f6f0e186a01$export$371078b1afd73c80; });
$parcel$export(module.exports, "useMeetingsMeetingTypeQuery", function () { return $00d97f6f0e186a01$export$91c770586b9c8a77; });
$parcel$export(module.exports, "GetMeetingTypesDocument", function () { return $00d97f6f0e186a01$export$17be11849ea22011; });
$parcel$export(module.exports, "useGetMeetingTypesQuery", function () { return $00d97f6f0e186a01$export$c773cae8fd9148fc; });
$parcel$export(module.exports, "useCreateMeetingTypeMutation", function () { return $00d97f6f0e186a01$export$c6b09494d3b40b91; });
$parcel$export(module.exports, "useUpdateMeetingTypeMutation", function () { return $00d97f6f0e186a01$export$8ba6f7c8cd831f0; });
$parcel$export(module.exports, "useDeleteMeetingTypeMutation", function () { return $00d97f6f0e186a01$export$87a4e58070b80f78; });
$parcel$export(module.exports, "useAllMeetingsForContactQuery", function () { return $00d97f6f0e186a01$export$d00126cd38837751; });
$parcel$export(module.exports, "MeetingsFilteredDocument", function () { return $00d97f6f0e186a01$export$cb9fafddce062ac9; });
$parcel$export(module.exports, "useMeetingsFilteredLazyQuery", function () { return $00d97f6f0e186a01$export$d3b3c987dc5eb9ae; });
$parcel$export(module.exports, "useCreateMeetingMutation", function () { return $00d97f6f0e186a01$export$e42e06cb075a5b93; });
$parcel$export(module.exports, "useUpdateMeetingMutation", function () { return $00d97f6f0e186a01$export$601199388383f903; });
$parcel$export(module.exports, "useDeleteMeetingMutation", function () { return $00d97f6f0e186a01$export$6714ee0b7598692d; });
$parcel$export(module.exports, "useMeetingCreatedSubscription", function () { return $00d97f6f0e186a01$export$823f49c0b4e1d185; });
$parcel$export(module.exports, "useMeetingUpdatedSubscription", function () { return $00d97f6f0e186a01$export$cf43db5de81e2780; });
$parcel$export(module.exports, "useMeetingDeletedSubscription", function () { return $00d97f6f0e186a01$export$dc9137be82916959; });
$parcel$export(module.exports, "MembershipTypesDocument", function () { return $00d97f6f0e186a01$export$bc0dc4b4d8495bef; });
$parcel$export(module.exports, "useMembershipTypesQuery", function () { return $00d97f6f0e186a01$export$3a029e1998613bf9; });
$parcel$export(module.exports, "MembershipsDocument", function () { return $00d97f6f0e186a01$export$c958065228ef6751; });
$parcel$export(module.exports, "useMembershipsQuery", function () { return $00d97f6f0e186a01$export$896b15c4ea6f87fa; });
$parcel$export(module.exports, "useMembershipsFilteredLazyQuery", function () { return $00d97f6f0e186a01$export$666f3eba04b42893; });
$parcel$export(module.exports, "useMembershipQuery", function () { return $00d97f6f0e186a01$export$826cc983ec8893c4; });
$parcel$export(module.exports, "useMembershipCompaniesQuery", function () { return $00d97f6f0e186a01$export$7f242fc6dc8ed2dc; });
$parcel$export(module.exports, "useMembershipTypeOptionsQuery", function () { return $00d97f6f0e186a01$export$e5a203b33eaaba47; });
$parcel$export(module.exports, "useMembershipContactsQuery", function () { return $00d97f6f0e186a01$export$e2231e66afd9ab3d; });
$parcel$export(module.exports, "useCreateMembershipMutation", function () { return $00d97f6f0e186a01$export$cfd2bb20c23f9640; });
$parcel$export(module.exports, "useUpdateMembershipMutation", function () { return $00d97f6f0e186a01$export$ff83b3bdca2bca42; });
$parcel$export(module.exports, "useDeleteMembershipMutation", function () { return $00d97f6f0e186a01$export$71d1179593621e0a; });
$parcel$export(module.exports, "useMembershipCreatedSubscription", function () { return $00d97f6f0e186a01$export$49a8645946470740; });
$parcel$export(module.exports, "useMembershipUpdatedSubscription", function () { return $00d97f6f0e186a01$export$d545506e8c7ad764; });
$parcel$export(module.exports, "useMembershipDeletedSubscription", function () { return $00d97f6f0e186a01$export$5604af14ea8d620a; });
$parcel$export(module.exports, "MsbReportsDocument", function () { return $00d97f6f0e186a01$export$aef4235add5005fd; });
$parcel$export(module.exports, "useMsbReportsQuery", function () { return $00d97f6f0e186a01$export$6853a7b86efb7bd6; });
$parcel$export(module.exports, "useScheduleReportMutation", function () { return $00d97f6f0e186a01$export$8ae9b6ce9c45a88d; });
$parcel$export(module.exports, "useGetNavsLazyQuery", function () { return $00d97f6f0e186a01$export$6acfb5176cde4ad1; });
$parcel$export(module.exports, "useCreateNavMutation", function () { return $00d97f6f0e186a01$export$d48e254c68cac26b; });
$parcel$export(module.exports, "useUpdateNavMutation", function () { return $00d97f6f0e186a01$export$28b6188f0186a6c4; });
$parcel$export(module.exports, "useDeleteNavMutation", function () { return $00d97f6f0e186a01$export$fb096e172ca478c4; });
$parcel$export(module.exports, "useNavCreatedSubscription", function () { return $00d97f6f0e186a01$export$bf3303de32ff50ce; });
$parcel$export(module.exports, "useNavUpdatedSubscription", function () { return $00d97f6f0e186a01$export$ab77759bfab6937c; });
$parcel$export(module.exports, "useNavDeletedSubscription", function () { return $00d97f6f0e186a01$export$3f64ce7bdeaa4ba2; });
$parcel$export(module.exports, "ProductCodesDocument", function () { return $00d97f6f0e186a01$export$a51af0646e3f1c0; });
$parcel$export(module.exports, "useProductCodesQuery", function () { return $00d97f6f0e186a01$export$e1078143adbe3183; });
$parcel$export(module.exports, "useProductCodesLazyQuery", function () { return $00d97f6f0e186a01$export$912f563cd32fadbc; });
$parcel$export(module.exports, "ProductsDocument", function () { return $00d97f6f0e186a01$export$1c4c73e876f07373; });
$parcel$export(module.exports, "useProductsQuery", function () { return $00d97f6f0e186a01$export$b692723449dab17d; });
$parcel$export(module.exports, "useProductsLazyQuery", function () { return $00d97f6f0e186a01$export$b4c38fb01dd0421; });
$parcel$export(module.exports, "useProductQuery", function () { return $00d97f6f0e186a01$export$87f61a051b89a3b8; });
$parcel$export(module.exports, "useMembershipProductsQuery", function () { return $00d97f6f0e186a01$export$9fc3917262e2f32f; });
$parcel$export(module.exports, "useMembershipProductsLazyQuery", function () { return $00d97f6f0e186a01$export$d92b3c65c635d1c6; });
$parcel$export(module.exports, "useDeleteProductMutation", function () { return $00d97f6f0e186a01$export$d23a23f70f82a6af; });
$parcel$export(module.exports, "useCreateProductMutation", function () { return $00d97f6f0e186a01$export$d9ac3918452bd061; });
$parcel$export(module.exports, "useUpdateProductGeneralInfoMutation", function () { return $00d97f6f0e186a01$export$2fe11c6c89d0cf; });
$parcel$export(module.exports, "useUpdateProductEmailInfoMutation", function () { return $00d97f6f0e186a01$export$efc5b85d67a73d90; });
$parcel$export(module.exports, "useProductCreatedSubscription", function () { return $00d97f6f0e186a01$export$541d7baba335a7d1; });
$parcel$export(module.exports, "useProductUpdatedSubscription", function () { return $00d97f6f0e186a01$export$80b0ba5c1117c0f4; });
$parcel$export(module.exports, "useProductDeletedSubscription", function () { return $00d97f6f0e186a01$export$aadcfa67839628c3; });
$parcel$export(module.exports, "RecipientListsDocument", function () { return $00d97f6f0e186a01$export$25f390f932130bec; });
$parcel$export(module.exports, "useRecipientListsQuery", function () { return $00d97f6f0e186a01$export$2c73cc4bd50a0276; });
$parcel$export(module.exports, "useExcludedContactsQuery", function () { return $00d97f6f0e186a01$export$34dd7a09095133bd; });
$parcel$export(module.exports, "useRecipientsQuery", function () { return $00d97f6f0e186a01$export$7b020b2e62387525; });
$parcel$export(module.exports, "useRecipientsLazyQuery", function () { return $00d97f6f0e186a01$export$ef7860ce773e7d79; });
$parcel$export(module.exports, "useDeleteRecipientListMutation", function () { return $00d97f6f0e186a01$export$e6716f7b70ba565c; });
$parcel$export(module.exports, "useExcludeRecipientMutation", function () { return $00d97f6f0e186a01$export$e98e118fa2693082; });
$parcel$export(module.exports, "useCreateRecipientListMutation", function () { return $00d97f6f0e186a01$export$d2dd538123521ffd; });
$parcel$export(module.exports, "useUpdateRecipientListMutation", function () { return $00d97f6f0e186a01$export$8c5393fa17435518; });
$parcel$export(module.exports, "useRecipientListDeletedSubscription", function () { return $00d97f6f0e186a01$export$4c166dbff8775822; });
$parcel$export(module.exports, "useRecipientListCreatedSubscription", function () { return $00d97f6f0e186a01$export$b804d49cb2b2ba2f; });
$parcel$export(module.exports, "useRecipientListUpdatedSubscription", function () { return $00d97f6f0e186a01$export$873a5b56fda3aa1c; });
$parcel$export(module.exports, "useRegionsQuery", function () { return $00d97f6f0e186a01$export$42ec9ac117960359; });
$parcel$export(module.exports, "GetRolesDocument", function () { return $00d97f6f0e186a01$export$b62111fff37cc3e3; });
$parcel$export(module.exports, "useGetRolesQuery", function () { return $00d97f6f0e186a01$export$df99cc263e9b1304; });
$parcel$export(module.exports, "useRemoveRoleFromUserMutation", function () { return $00d97f6f0e186a01$export$6b7ad7851c93ac84; });
$parcel$export(module.exports, "GetAllScheduledDocument", function () { return $00d97f6f0e186a01$export$f33292eaf98940d1; });
$parcel$export(module.exports, "useGetAllScheduledQuery", function () { return $00d97f6f0e186a01$export$17207a1e28102cd1; });
$parcel$export(module.exports, "useCreateSchedulerMutation", function () { return $00d97f6f0e186a01$export$588f16e17eb9bba4; });
$parcel$export(module.exports, "useUpdateSchedulerMutation", function () { return $00d97f6f0e186a01$export$181c179823b5391d; });
$parcel$export(module.exports, "useDeleteSchedulerMutation", function () { return $00d97f6f0e186a01$export$6854ac67322915d9; });
$parcel$export(module.exports, "useDeleteRecipientListFromSchedulerMutation", function () { return $00d97f6f0e186a01$export$cc4d921bd698f376; });
$parcel$export(module.exports, "useSendTestEmailMutation", function () { return $00d97f6f0e186a01$export$985ae6c53979543d; });
$parcel$export(module.exports, "useSchedulerDeletedSubscription", function () { return $00d97f6f0e186a01$export$e2fc1cd24a8bc645; });
$parcel$export(module.exports, "useSchedulerCreatedSubscription", function () { return $00d97f6f0e186a01$export$d2560e4569627d9e; });
$parcel$export(module.exports, "useSchedulerUpdatedSubscription", function () { return $00d97f6f0e186a01$export$3693e162327ca581; });
$parcel$export(module.exports, "useSectorsQuery", function () { return $00d97f6f0e186a01$export$a9e0e073b38a8273; });
$parcel$export(module.exports, "useGetAllSendersQuery", function () { return $00d97f6f0e186a01$export$d526626820489b1e; });
$parcel$export(module.exports, "useGetSendGridStatisticsQuery", function () { return $00d97f6f0e186a01$export$34da4ee2c1b4782f; });
$parcel$export(module.exports, "useGetSendGridMessagesQuery", function () { return $00d97f6f0e186a01$export$2fd7e277e776d8fb; });
$parcel$export(module.exports, "useGetSendGridDataForExcelLazyQuery", function () { return $00d97f6f0e186a01$export$1fb0333a205f463f; });
$parcel$export(module.exports, "useGetSendGridEventsQuery", function () { return $00d97f6f0e186a01$export$4eed6eb9def71298; });
$parcel$export(module.exports, "GetSiteSectionsDocument", function () { return $00d97f6f0e186a01$export$ccadce76c20ed202; });
$parcel$export(module.exports, "useGetSiteSectionsQuery", function () { return $00d97f6f0e186a01$export$12ac977f6b3f54f; });
$parcel$export(module.exports, "useCreateSiteSectionMutation", function () { return $00d97f6f0e186a01$export$caddd0ff7455e7fa; });
$parcel$export(module.exports, "useDeleteSiteSectionMutation", function () { return $00d97f6f0e186a01$export$69f81879f3542d2c; });
$parcel$export(module.exports, "useUpdateSiteSectionMutation", function () { return $00d97f6f0e186a01$export$1c0f5b770443802f; });
$parcel$export(module.exports, "useSiteSectionCreatedSubscription", function () { return $00d97f6f0e186a01$export$e589680df09a92b2; });
$parcel$export(module.exports, "useSiteSectionDeletedSubscription", function () { return $00d97f6f0e186a01$export$c74f5e2f76ae8c85; });
$parcel$export(module.exports, "useSiteSectionUpdatedSubscription", function () { return $00d97f6f0e186a01$export$e035d7f6eac7001c; });
$parcel$export(module.exports, "StocksDocument", function () { return $00d97f6f0e186a01$export$9cfce6e6adef03a2; });
$parcel$export(module.exports, "useStockQuery", function () { return $00d97f6f0e186a01$export$efdbd6b4c695483d; });
$parcel$export(module.exports, "useStocksFilteredLazyQuery", function () { return $00d97f6f0e186a01$export$22be134025270a3d; });
$parcel$export(module.exports, "useCreateStockMutation", function () { return $00d97f6f0e186a01$export$42642354ae3e1c8c; });
$parcel$export(module.exports, "useUpdateStockMutation", function () { return $00d97f6f0e186a01$export$af2923a7b78add58; });
$parcel$export(module.exports, "useDeleteHsDataMutation", function () { return $00d97f6f0e186a01$export$f5ed10a711d3ffd4; });
$parcel$export(module.exports, "useStockCreatedSubscription", function () { return $00d97f6f0e186a01$export$ee88ccf91f084964; });
$parcel$export(module.exports, "useStockUpdatedSubscription", function () { return $00d97f6f0e186a01$export$68da1be0eb588744; });
$parcel$export(module.exports, "TemplatesDocument", function () { return $00d97f6f0e186a01$export$4692fa3348fcef1b; });
$parcel$export(module.exports, "useTemplatesQuery", function () { return $00d97f6f0e186a01$export$da007814ffd3091b; });
$parcel$export(module.exports, "useDeleteTemplateMutation", function () { return $00d97f6f0e186a01$export$9fb6b54e960a872e; });
$parcel$export(module.exports, "useCreateTemplateMutation", function () { return $00d97f6f0e186a01$export$c85e821f5dded8f2; });
$parcel$export(module.exports, "useUpdateTemplateMutation", function () { return $00d97f6f0e186a01$export$3e6250bf8c15acd5; });
$parcel$export(module.exports, "useTemplateDeletedSubscription", function () { return $00d97f6f0e186a01$export$93ef53b5f86e5ef7; });
$parcel$export(module.exports, "useTemplateCreatedSubscription", function () { return $00d97f6f0e186a01$export$617c6de886edaadf; });
$parcel$export(module.exports, "useTemplateUpdatedSubscription", function () { return $00d97f6f0e186a01$export$746640a877fa6583; });
$parcel$export(module.exports, "TitlesInternalDocument", function () { return $00d97f6f0e186a01$export$88830faefcac6cfb; });
$parcel$export(module.exports, "useTitlesInternalQuery", function () { return $00d97f6f0e186a01$export$d9473be9334a5d10; });
$parcel$export(module.exports, "useTitlesInternalLazyQuery", function () { return $00d97f6f0e186a01$export$c7a5cc0fdcf16032; });
$parcel$export(module.exports, "useAddRoleToUserMutation", function () { return $00d97f6f0e186a01$export$ca04abdf3a48704a; });
$parcel$export(module.exports, "GetUsersDocument", function () { return $00d97f6f0e186a01$export$7343f2a1df7c2c44; });
$parcel$export(module.exports, "useGetUsersQuery", function () { return $00d97f6f0e186a01$export$2f5355ee4596e5a; });
$parcel$export(module.exports, "useGetUserLazyQuery", function () { return $00d97f6f0e186a01$export$7df562623c42db5; });
$parcel$export(module.exports, "useCreateUserMutation", function () { return $00d97f6f0e186a01$export$989d55af39b135f7; });
$parcel$export(module.exports, "useUpdatePasswordMutation", function () { return $00d97f6f0e186a01$export$1d1fc52b8c6fcaca; });
$parcel$export(module.exports, "useUpdateUserDetailsMutation", function () { return $00d97f6f0e186a01$export$5651788cb661bcc9; });
$parcel$export(module.exports, "useDeleteUserMutation", function () { return $00d97f6f0e186a01$export$2e519bb6ce31dd11; });
$parcel$export(module.exports, "useUserCreatedSubscription", function () { return $00d97f6f0e186a01$export$4b7d160bbcc0215c; });
$parcel$export(module.exports, "useUserUpdatedSubscription", function () { return $00d97f6f0e186a01$export$2c58b7db3c5b4049; });
$parcel$export(module.exports, "useUserDeletedSubscription", function () { return $00d97f6f0e186a01$export$2273306a6936a721; });
$parcel$export(module.exports, "useUserRoleRemovedSubscription", function () { return $00d97f6f0e186a01$export$6c922ee123f65fa3; });

var $cwNRj = parcelRequire("cwNRj");
var $1r7sc = parcelRequire("1r7sc");
var $jCAzD = parcelRequire("jCAzD");
var $4OEi8 = parcelRequire("4OEi8");
var $fnLzi = parcelRequire("fnLzi");
const $00d97f6f0e186a01$var$defaultOptions = {};
var $00d97f6f0e186a01$export$6891ec2f98ff7f6b;
(function(ICacheControlScope) {
    ICacheControlScope["Private"] = "PRIVATE";
    ICacheControlScope["Public"] = "PUBLIC";
})($00d97f6f0e186a01$export$6891ec2f98ff7f6b || ($00d97f6f0e186a01$export$6891ec2f98ff7f6b = {}));
var $00d97f6f0e186a01$export$a9f1cde122429797;
(function(IRoles) {
    IRoles["Admin"] = "admin";
    IRoles["EsgOperator"] = "esg_operator";
    IRoles["IndexOperator"] = "index_operator";
    IRoles["InvoiceEditor"] = "invoice_editor";
    IRoles["MarketingOperator"] = "marketing_operator";
    IRoles["Operator"] = "operator";
})($00d97f6f0e186a01$export$a9f1cde122429797 || ($00d97f6f0e186a01$export$a9f1cde122429797 = {}));
const $00d97f6f0e186a01$export$101bd8a2cd0909 = (0, $cwNRj.gql)`
    fragment AddressProps on Address {
  id
  name
  street
  city
  country {
    id
    name
    region {
      id
      name
    }
  }
  vat_number
  phone
  email
  is_main
  is_nav
  is_website
  fax
  zip
  complete_vat_number
  vat_country_code
}
    `;
const $00d97f6f0e186a01$export$8591fc91c21edae6 = (0, $cwNRj.gql)`
    fragment AllocationSectorDetails on AllocationSector {
  id
  stock_id
  sector_id
  year
  value
}
    `;
const $00d97f6f0e186a01$export$f95a418acd73890f = (0, $cwNRj.gql)`
    fragment eventMeetingDetails on CalendarEvent {
  id
  title
  location
  description
  creator {
    id
    fullName
  }
  company {
    id
    name
  }
  type {
    id
    type
  }
  start_date
  end_date
}
    `;
const $00d97f6f0e186a01$export$41bfd144d226c415 = (0, $cwNRj.gql)`
    fragment HistoryStocksDetails on HistoryStock {
  id
  stock_id
  date
  close_price
  engl_mkt_cap
  epra_shares
  nav_epra
  nav_ifrs
  price_discount
  gross_div_yield
  div_gross
  div_net
  free_float_market_cap
  nra
  nta
  ndv
  average
}
    `;
const $00d97f6f0e186a01$export$f0c7321334917bb0 = (0, $cwNRj.gql)`
    fragment HistoryIndexDetails on HistoryIndex {
  id
  index_id
  date
  mkt_cap_eur
  mkt_cap_usd
  mkt_cap_gbp
  mkt_cap_jpy
  mkt_cap_aud
  price_close_eur
  price_close_usd
  price_close_gbp
  price_close_jpy
  price_close_aud
  price_return_eur
  price_return_usd
  price_return_gbp
  price_return_jpy
  price_return_aud
  price_net_eur
  price_net_usd
  price_net_gbp
  price_net_jpy
  price_net_aud
}
    `;
const $00d97f6f0e186a01$export$811cd0e1117ea9ab = (0, $cwNRj.gql)`
    fragment HistoryIndexExtendedDetails on HistoryIndex {
  id
  index_id
  date
  file_name
  dividend_yield
  mkt_cap_eur
  mkt_cap_usd
  mkt_cap_gbp
  mkt_cap_jpy
  mkt_cap_aud
  mkt_cap_hkd
  mkt_cap_local
  price_close_eur
  price_close_usd
  price_close_gbp
  price_close_jpy
  price_close_aud
  price_close_local
  price_close_hkd
  price_return_eur
  price_return_usd
  price_return_gbp
  price_return_jpy
  price_return_aud
  price_return_hkd
  price_return_local
  price_net_eur
  price_net_usd
  price_net_gbp
  price_net_jpy
  price_net_aud
  price_net_hkd
  price_net_local
  dividend_net_yield
  price_return_epra_local
  price_close_epra_local
}
    `;
const $00d97f6f0e186a01$export$d7bc6096322b0575 = (0, $cwNRj.gql)`
    fragment CommentDetails on Comment {
  id
  text
  date
  author {
    id
    first_name
    last_name
  }
}
    `;
const $00d97f6f0e186a01$export$ae68447942c469fb = (0, $cwNRj.gql)`
    fragment CompanyDetails on Company {
  id
  name
  company_type {
    id
    name
  }
  market_activity {
    id
    name
  }
  membership {
    id
    name
    start_date
    end_date
    product {
      id
      name
      membership_type {
        id
        name
      }
    }
  }
  main_contacts {
    id
    fullName
  }
  market_second_specialty
  website
  unique_stock_code
  info
  member_index
  is_main_member
  main_address {
    complete_vat_number
    id
    name
    street
    city
    country {
      id
      name
    }
  }
}
    `;
const $00d97f6f0e186a01$export$80ea9b1585c00fb9 = (0, $cwNRj.gql)`
    fragment ContactDetails on Contact {
  id
  email
  fullName
  first_name
  last_name
  is_main
  title_external
  prefix
  address {
    id
    zip
    name
    street
    city
    country {
      name
      region {
        name
      }
    }
  }
  titleInternal {
    id
    name
  }
  linkedin
}
    `;
const $00d97f6f0e186a01$export$c377c029b0ef8a86 = (0, $cwNRj.gql)`
    fragment ContactDetailsInvoicePreview on Contact {
  id
  title_external
  prefix
  suffix
}
    `;
const $00d97f6f0e186a01$export$8559e1f2a2728599 = (0, $cwNRj.gql)`
    fragment ContactFullScope on Contact {
  id
  prefix
  first_name
  middle_name
  last_name
  suffix
  fullName
  informal_name
  titleInternal {
    id
    name
  }
  title_external
  company {
    id
    name
  }
  notes
  phone_direct
  phone_mobile
  fax
  email
  location_of_contact
  address {
    id
    name
    phone
    address_name
    fax
    street
    email
    country {
      id
      name
    }
    city
    zip
  }
  assistant {
    id
    fullName
    email
    phone_direct
    phone_mobile
  }
  contactMeetings {
    id
    name
    subject
    contacts {
      id
      fullName
    }
    meeting_type {
      id
      name
    }
    meeting_details
    location
    start_time
    end_time
  }
  linkedin
}
    `;
const $00d97f6f0e186a01$export$78d0e333dc9c5872 = (0, $cwNRj.gql)`
    fragment Recipients on Contact {
  id
  first_name
  last_name
  fullName
  email
  titleInternal {
    id
    name
  }
}
    `;
const $00d97f6f0e186a01$export$ef421f8864c2a330 = (0, $cwNRj.gql)`
    fragment CventEventDetails on CventEvent {
  id
  name
  created_by
  update_by
  date_insert
  date_edit
  url_landing_page
  event_stub
  is_active
  pk_email_payment_reminder
  pk_email_registration
  pk_product_registration
  pk_email_networking
  is_paid_event
}
    `;
const $00d97f6f0e186a01$export$36f3b7eb3774445d = (0, $cwNRj.gql)`
    fragment CventContactDetails on CventContact {
  id
  date_created
  role {
    id
    name
    name_short
  }
  first_name
  last_name
  company_name
  email
  is_approved
  invoice {
    id
    number
    date_paid
    email_sent_date
  }
  fullName
  contact_id
  is_linked
}
    `;
const $00d97f6f0e186a01$export$1e2a63bd0314da2b = (0, $cwNRj.gql)`
    fragment DbContactDetails on Contact {
  id
  email
  fullName
}
    `;
const $00d97f6f0e186a01$export$95b237684e1cef80 = (0, $cwNRj.gql)`
    fragment CventLocationDetails on CventLocation {
  id
  name
}
    `;
const $00d97f6f0e186a01$export$940e38cbf6b1fe7e = (0, $cwNRj.gql)`
    fragment CventRolesDetails on CventRole {
  id
  name
  name_short
}
    `;
const $00d97f6f0e186a01$export$5ce0d26dec7e4866 = (0, $cwNRj.gql)`
    fragment DividendDetails on DividendGross {
  id
  start_date
  stock_id
  value
}
    `;
const $00d97f6f0e186a01$export$2b8217b18cb6fb06 = (0, $cwNRj.gql)`
    fragment DocumentDetails on Document {
  id
  display_name
  file_name
  visible_from
  protected_until
  company {
    id
    name
  }
  country {
    id
    name
  }
  description
  destination_url
  site_sections {
    id
    name
  }
  downloads
}
    `;
const $00d97f6f0e186a01$export$84b5ed1aec9806d6 = (0, $cwNRj.gql)`
    fragment EtfDetails on Etf {
  id
  launch_date
  name
  provider
  identifier
  is_deleted
}
    `;
const $00d97f6f0e186a01$export$ab45010cd7fca607 = (0, $cwNRj.gql)`
    fragment EtfValueDetails on EtfValue {
  id
  etf {
    id
    name
    provider
    identifier
    launch_date
  }
  date
  aum
  total_return_one_year
  index_total_return_one_year
  total_return_three_year
  index_total_return_three_year
}
    `;
const $00d97f6f0e186a01$export$eab67a80655f45e8 = (0, $cwNRj.gql)`
    fragment FtseDetails on FtseFile {
  id
  name
  type {
    id
    name
  }
  file_location
  last_import
  last_get
  attempt
}
    `;
const $00d97f6f0e186a01$export$88d96b3ce3ff91a4 = (0, $cwNRj.gql)`
    fragment FtseConfigurationDetails on FtseConfiguration {
  id
  property
  value
}
    `;
const $00d97f6f0e186a01$export$21bc218bb28f6f06 = (0, $cwNRj.gql)`
    fragment FtseFxDetails on FtseFx {
  id
  rate
  date
  currency {
    id
    code
  }
}
    `;
const $00d97f6f0e186a01$export$741694164477991 = (0, $cwNRj.gql)`
    fragment HistoryAllocationCountryDetails on HistoryAllocationCountry {
  id
  stock_id
  value
  year
  country {
    id
    name
  }
}
    `;
const $00d97f6f0e186a01$export$58f8b1230d63a6ea = (0, $cwNRj.gql)`
    fragment HistoryAwardDetails on HistoryAward {
  id
  stock_id
  date
  type {
    id
    name
  }
}
    `;
const $00d97f6f0e186a01$export$490cd67d0d1b1483 = (0, $cwNRj.gql)`
    fragment HistoryConstituentDetails on HistoryConstituent {
  id
  weight_perc
  weighting
  date
  index {
    id
    name
  }
  history_index {
    id
    dividend_yield
  }
  stock {
    id
    name
    historyStock {
      id
      free_float_market_cap
      engl_mkt_cap
    }
  }
}
    `;
const $00d97f6f0e186a01$export$438604d7d904e8df = (0, $cwNRj.gql)`
    fragment HistoryKpiDetails on HistoryKpi {
  id
  stock_id
  date
  eps
  nav
  nnnav
  niy
  vacancy
  cost_ratio_incl
  cost_ratio_excl
  nra
  nta
  ndv
  average
}
    `;
const $00d97f6f0e186a01$export$edaf0cc1d443e75 = (0, $cwNRj.gql)`
    fragment HistoryLtvDetails on HistoryLtv {
  id
  stock_id
  value
  start_date
}
    `;
const $00d97f6f0e186a01$export$4a84cfbf9d8b7ff4 = (0, $cwNRj.gql)`
    fragment HistoryRecalcDetails on HistoryRecalc {
  id
  value_to_calc_with
  column_to_recalc
  start_date
  end_date
  operator {
    id
    value
  }
  is_rollbacked
}
    `;
const $00d97f6f0e186a01$export$b0aa95306257aa0e = (0, $cwNRj.gql)`
    fragment indexSeriesDetails on IndexSerie {
  id
  name
  indices {
    id
    name
  }
}
    `;
const $00d97f6f0e186a01$export$7adf6aa5121db3ba = (0, $cwNRj.gql)`
    fragment IndiceDetails on Index {
  id
  name
  code
  net_code
  country {
    id
    name
  }
  currency {
    id
    code
  }
  identifier
  is_online
}
    `;
const $00d97f6f0e186a01$export$9daeed32eeaf06c1 = (0, $cwNRj.gql)`
    fragment InvoiceDetails on InvoiceDetails {
  fullName
  company_name
  company_address_vat
  contact_first_name
  contact_last_name
  contact_email
  address_name
  street
  city
  zip
  country
  region
  prefix
  title_external
  vat_countrycode
}
    `;
const $00d97f6f0e186a01$export$8b686b21c1301b53 = (0, $cwNRj.gql)`
    fragment PaymentDetails on PaymentDetails {
  id
  contact_address_name
  contact_address
  contact_phone
  contact_fax
  contact_vat
  bank_name
  bank_affiliate
  bank_address
  bank_bic
  bank_iban
}
    `;
const $00d97f6f0e186a01$export$7bc87ff5408ebfce = (0, $cwNRj.gql)`
    fragment InvoiceDtoFull on Invoice {
  id
  number
  created_date
  date_paid
  due_date
  total
  vat
  discount
  is_credit
  email_sent_date
  debit_invoice_nr
  debit_invoice_nr
  membership {
    id
    name
    start_date
    end_date
  }
  status {
    id
    name
  }
  product {
    id
    name
    price
    membership_type {
      id
      name
    }
    bottom_notes
    product_code {
      id
      name
    }
  }
  details {
    ...InvoiceDetails
  }
  paymentDetails {
    ...PaymentDetails
  }
  notes
  po_nr
  remarks
}
    ${$00d97f6f0e186a01$export$9daeed32eeaf06c1}
${$00d97f6f0e186a01$export$8b686b21c1301b53}`;
const $00d97f6f0e186a01$export$c116230faac64614 = (0, $cwNRj.gql)`
    fragment MeetingContactDetails on MeetingContact {
  id
  meeting {
    id
    name
  }
  contacts {
    id
    fullName
  }
  company {
    id
    name
  }
}
    `;
const $00d97f6f0e186a01$export$228700246cddc540 = (0, $cwNRj.gql)`
    fragment MeetingsMeetingTypeDetails on MeetingsMeetingType {
  id
  name
}
    `;
const $00d97f6f0e186a01$export$c278385bdf2bdb47 = (0, $cwNRj.gql)`
    fragment MeetingDetails on Meeting {
  id
  name
  subject
  contacts {
    id
    fullName
  }
  meeting_type {
    id
    name
  }
  meeting_details
  location
  start_time
  end_time
}
    `;
const $00d97f6f0e186a01$export$25f96825690302a3 = (0, $cwNRj.gql)`
    fragment MembershipDetails on Membership {
  id
  name
  product {
    id
    price
    membership_type {
      id
      name
    }
  }
  is_bad_debtor
  discount
  total
  start_date
  end_date
  renewable_date
  comments_count
}
    `;
const $00d97f6f0e186a01$export$4c49b749d3f62a21 = (0, $cwNRj.gql)`
    fragment MembershipOverview on Membership {
  id
  name
  product {
    id
    price
    membership_type {
      id
      name
    }
  }
  is_bad_debtor
  discount
  total
  start_date
  end_date
  renewable_date
  comments_count
  last_invoice {
    id
    number
    email_sent_date
    date_paid
    total
  }
}
    `;
const $00d97f6f0e186a01$export$3f55cf4321b2b1f0 = (0, $cwNRj.gql)`
    fragment MsbReportOverview on MsbReport {
  id
  report_date
  generation_start
  generation_end
  clear_cache
}
    `;
const $00d97f6f0e186a01$export$d18a0e7b1e5710da = (0, $cwNRj.gql)`
    fragment NavDetails on Nav {
  id
  created_date
  start_date
  stock_id
  ta
  tl
  nav
  nav_epra
  nav_epra_history
  nra
  nta
  ndv
  average
}
    `;
const $00d97f6f0e186a01$export$7717e2e3782f50c8 = (0, $cwNRj.gql)`
    fragment ProductDetailsFull on Product {
  id
  name
  product_code {
    id
    name
  }
  price
  vat
  membership_type {
    id
    name
  }
  bottom_notes
  email_subject
  email_body
  email_banner
}
    `;
const $00d97f6f0e186a01$export$9be0f94e3f4d06bf = (0, $cwNRj.gql)`
    fragment ProductDetails on Product {
  id
  name
  product_code {
    id
    name
  }
  price
  vat
  membership_type {
    id
    name
  }
  bottom_notes
}
    `;
const $00d97f6f0e186a01$export$ad888413148071ed = (0, $cwNRj.gql)`
    fragment RecipientListProps on RecipientList {
  id
  name
  contact_titles {
    id
    name
  }
  company_types {
    id
    name
  }
  membership_types {
    id
    name
  }
  interests {
    id
    name
  }
  countries {
    id
    name
  }
  excluded_contact_ids
  included_contact_ids
}
    `;
const $00d97f6f0e186a01$export$407c4ef238d4f687 = (0, $cwNRj.gql)`
    fragment SchedulerDetails on Scheduler {
  id
  name
  is_success
  scheduled_date
  created_date
  sender {
    id
    email
  }
  recipient_lists {
    id
    name
  }
  template {
    id
    title
  }
  mails_sent
}
    `;
const $00d97f6f0e186a01$export$cd6a622404de518a = (0, $cwNRj.gql)`
    fragment SiteSectionDetails on SiteSection {
  id
  name
}
    `;
const $00d97f6f0e186a01$export$dad84f302e118744 = (0, $cwNRj.gql)`
    fragment StockOverviewMini on Stock {
  id
  name
  country {
    id
    name
    code
  }
  isin_code
  bloomberg_ticker
  exchange_code
  currency {
    id
    code
  }
  code
  sector {
    id
    name
  }
  subsector {
    id
    name
  }
}
    `;
const $00d97f6f0e186a01$export$30c69ca4bcfcd232 = (0, $cwNRj.gql)`
    fragment StockOverview on Stock {
  ...StockOverviewMini
  historyStock {
    id
    close_price
    engl_mkt_cap
    epra_shares
    nav_epra
    nav_ifrs
    price_discount
  }
}
    ${$00d97f6f0e186a01$export$dad84f302e118744}`;
const $00d97f6f0e186a01$export$917484d2d9809683 = (0, $cwNRj.gql)`
    fragment StockDetails on Stock {
  id
  name
  code
  currency {
    id
    code
  }
  cusip
  bloomberg_ticker
  isin_code
  exchange_code
  reuters_code
  snl_code
  icb_industry_code
  icb_supersector_code
  icb_sector_code
  icb_subsector_code
  country {
    id
    code
  }
  sector {
    id
    name
  }
  subsector {
    id
    name
  }
  sedol
  company {
    id
    name
  }
  start_date
  is_reit
  investment_focus {
    id
    name
  }
}
    `;
const $00d97f6f0e186a01$export$d86e77836fe22a2b = (0, $cwNRj.gql)`
    fragment TemplateDetails on Template {
  id
  title
  subject
  content
}
    `;
const $00d97f6f0e186a01$export$b2dbb4d61e0c0725 = (0, $cwNRj.gql)`
    fragment UserDetails on User {
  id
  username
  first_name
  last_name
  roles
  password
}
    `;
const $00d97f6f0e186a01$export$47851d63889269bf = (0, $cwNRj.gql)`
    query companyAddresses($company_id: Int!) {
  result: companyAddresses(company_id: $company_id) {
    ...AddressProps
    address_name
  }
}
    ${$00d97f6f0e186a01$export$101bd8a2cd0909}`;
function $00d97f6f0e186a01$export$948d0bace3ef9cf5(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$47851d63889269bf, options);
}
function $00d97f6f0e186a01$export$99ecd69ab881ded(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$47851d63889269bf, options);
}
const $00d97f6f0e186a01$export$9fad07b8e723ee0d = (0, $cwNRj.gql)`
    mutation addAddress($company_id: Int!, $input: AddressInput!) {
  result: addAddress(company_id: $company_id, input: $input) {
    ...AddressProps
  }
}
    ${$00d97f6f0e186a01$export$101bd8a2cd0909}`;
function $00d97f6f0e186a01$export$bd00e7740b567a9d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$9fad07b8e723ee0d, options);
}
const $00d97f6f0e186a01$export$7ddf2b771a765d93 = (0, $cwNRj.gql)`
    mutation updateAddress($id: Int!, $input: AddressInput!) {
  result: updateAddress(id: $id, input: $input) {
    ...AddressProps
  }
}
    ${$00d97f6f0e186a01$export$101bd8a2cd0909}`;
function $00d97f6f0e186a01$export$acd2b75cb433a7db(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$7ddf2b771a765d93, options);
}
const $00d97f6f0e186a01$export$2da9538732282cad = (0, $cwNRj.gql)`
    mutation deleteAddress($id: Int!) {
  result: deleteAddress(id: $id)
}
    `;
function $00d97f6f0e186a01$export$60cc172872792d7d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$2da9538732282cad, options);
}
const $00d97f6f0e186a01$export$edfdb551b2428d20 = (0, $cwNRj.gql)`
    mutation addValue($input: NewValueInput!) {
  result: addValue(input: $input) {
    id
    name
  }
}
    `;
function $00d97f6f0e186a01$export$c780883d61dbb54(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$edfdb551b2428d20, options);
}
const $00d97f6f0e186a01$export$143597445e87343a = (0, $cwNRj.gql)`
    mutation deleteValue($value_list_name: String!, $value_id: Int!) {
  result: deleteValue(value_list_name: $value_list_name, value_id: $value_id)
}
    `;
function $00d97f6f0e186a01$export$6160b57eeb853cb7(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$143597445e87343a, options);
}
const $00d97f6f0e186a01$export$88b4fcb9abbb71d0 = (0, $cwNRj.gql)`
    query getAllocationSectors($stock_id: Int!) {
  result: allocationSectors(stock_id: $stock_id) {
    ...AllocationSectorDetails
  }
}
    ${$00d97f6f0e186a01$export$8591fc91c21edae6}`;
function $00d97f6f0e186a01$export$da79a7c0a79470af(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$88b4fcb9abbb71d0, options);
}
function $00d97f6f0e186a01$export$97474f7b5491c876(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$88b4fcb9abbb71d0, options);
}
const $00d97f6f0e186a01$export$14b9da66f3d59403 = (0, $cwNRj.gql)`
    mutation createAllocationSector($stock_id: ID!, $input: AllocationSectorInput!) {
  result: createAllocationSector(stock_id: $stock_id, input: $input) {
    ...AllocationSectorDetails
  }
}
    ${$00d97f6f0e186a01$export$8591fc91c21edae6}`;
function $00d97f6f0e186a01$export$8b84740dc6ddb1d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$14b9da66f3d59403, options);
}
const $00d97f6f0e186a01$export$f0cb0948c9d7899b = (0, $cwNRj.gql)`
    mutation updateAllocationSector($id: ID!, $input: AllocationSectorInput!) {
  result: updateAllocationSector(id: $id, input: $input) {
    ...AllocationSectorDetails
  }
}
    ${$00d97f6f0e186a01$export$8591fc91c21edae6}`;
function $00d97f6f0e186a01$export$aec7dccbd159706f(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$f0cb0948c9d7899b, options);
}
const $00d97f6f0e186a01$export$1679412244530f58 = (0, $cwNRj.gql)`
    mutation deleteAllocationSector($id: ID!) {
  result: deleteAllocationSector(id: $id)
}
    `;
function $00d97f6f0e186a01$export$b06e93899a9cacc3(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$1679412244530f58, options);
}
const $00d97f6f0e186a01$export$ff97b985bdb0fda5 = (0, $cwNRj.gql)`
    subscription allocationSectorCreated($stock_id: ID!) {
  result: allocationSectorCreated(stock_id: $stock_id) {
    ...AllocationSectorDetails
  }
}
    ${$00d97f6f0e186a01$export$8591fc91c21edae6}`;
function $00d97f6f0e186a01$export$266443c88aedb2e6(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$ff97b985bdb0fda5, options);
}
const $00d97f6f0e186a01$export$8a2654e6a74b628 = (0, $cwNRj.gql)`
    subscription allocationSectorUpdated($stock_id: ID!) {
  result: allocationSectorUpdated(stock_id: $stock_id) {
    ...AllocationSectorDetails
  }
}
    ${$00d97f6f0e186a01$export$8591fc91c21edae6}`;
function $00d97f6f0e186a01$export$295c553c37464018(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$8a2654e6a74b628, options);
}
const $00d97f6f0e186a01$export$a11fe4b512d68a31 = (0, $cwNRj.gql)`
    subscription allocationSectorDeleted($stock_id: ID!) {
  result: allocationSectorDeleted(stock_id: $stock_id) {
    ...AllocationSectorDetails
  }
}
    ${$00d97f6f0e186a01$export$8591fc91c21edae6}`;
function $00d97f6f0e186a01$export$d94076d4d218fb74(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$a11fe4b512d68a31, options);
}
const $00d97f6f0e186a01$export$573ba9c2cbf31e2d = (0, $cwNRj.gql)`
    query events {
  result: events {
    ...eventMeetingDetails
  }
}
    ${$00d97f6f0e186a01$export$f95a418acd73890f}`;
function $00d97f6f0e186a01$export$f264892194843ef2(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$573ba9c2cbf31e2d, options);
}
function $00d97f6f0e186a01$export$a8b5904f74a5a7a2(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$573ba9c2cbf31e2d, options);
}
const $00d97f6f0e186a01$export$f58401daf74c60ca = (0, $cwNRj.gql)`
    query calendarTypes {
  result: calendarTypes {
    id
    type
    color_code
  }
}
    `;
function $00d97f6f0e186a01$export$d2394cc879ba0765(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$f58401daf74c60ca, options);
}
function $00d97f6f0e186a01$export$627ddf037597d97d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$f58401daf74c60ca, options);
}
const $00d97f6f0e186a01$export$fe72fcfd2d5899a4 = (0, $cwNRj.gql)`
    mutation addEvent($input: AddNewEventInput!) {
  result: addEvent(input: $input) {
    ...eventMeetingDetails
  }
}
    ${$00d97f6f0e186a01$export$f95a418acd73890f}`;
function $00d97f6f0e186a01$export$c381a7e1362c5fbd(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$fe72fcfd2d5899a4, options);
}
const $00d97f6f0e186a01$export$b490574f29263ac0 = (0, $cwNRj.gql)`
    mutation deleteEvent($id: Int!) {
  result: deleteEvent(id: $id)
}
    `;
function $00d97f6f0e186a01$export$257c69caab61b878(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$b490574f29263ac0, options);
}
const $00d97f6f0e186a01$export$629c7ca71c17ab3d = (0, $cwNRj.gql)`
    mutation updateEvent($id: Int!, $input: AddNewEventInput!) {
  result: updateEvent(id: $id, input: $input) {
    ...eventMeetingDetails
  }
}
    ${$00d97f6f0e186a01$export$f95a418acd73890f}`;
function $00d97f6f0e186a01$export$d624085c29681b0a(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$629c7ca71c17ab3d, options);
}
const $00d97f6f0e186a01$export$f1eb09fee46bb83f = (0, $cwNRj.gql)`
    subscription eventCreated {
  result: eventCreated {
    id
    title
    location
    description
    creator {
      id
      fullName
    }
    company {
      id
      name
    }
    type {
      id
      type
    }
    start_date
    end_date
  }
}
    `;
function $00d97f6f0e186a01$export$b8ddc131170f86d7(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$f1eb09fee46bb83f, options);
}
const $00d97f6f0e186a01$export$a434faeb05a40524 = (0, $cwNRj.gql)`
    subscription eventDeleted {
  result: eventDeleted {
    id
  }
}
    `;
function $00d97f6f0e186a01$export$68a84a913c319bb9(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$a434faeb05a40524, options);
}
const $00d97f6f0e186a01$export$ac3a8622b6b66942 = (0, $cwNRj.gql)`
    subscription eventUpdated {
  result: eventUpdated {
    ...eventMeetingDetails
  }
}
    ${$00d97f6f0e186a01$export$f95a418acd73890f}`;
function $00d97f6f0e186a01$export$907e7d633ded2a78(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$ac3a8622b6b66942, options);
}
const $00d97f6f0e186a01$export$ac53b8c23d6f317e = (0, $cwNRj.gql)`
    query getClosePrices($stock_id: Int!) {
  result: historyStocks(stock_id: $stock_id) {
    ...HistoryStocksDetails
  }
}
    ${$00d97f6f0e186a01$export$41bfd144d226c415}`;
function $00d97f6f0e186a01$export$8b0f85ab3a2b5c02(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$ac53b8c23d6f317e, options);
}
function $00d97f6f0e186a01$export$f938abfffc71b40d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$ac53b8c23d6f317e, options);
}
const $00d97f6f0e186a01$export$55d126ce7cda9a13 = (0, $cwNRj.gql)`
    query historyIndicesByIdAndPeriod($input: HistoryIndicesByIdAndPeriodInput!) {
  result: historyIndicesByIdAndPeriod(input: $input) {
    ...HistoryIndexExtendedDetails
  }
}
    ${$00d97f6f0e186a01$export$811cd0e1117ea9ab}`;
function $00d97f6f0e186a01$export$67b9f134c8a1e910(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$55d126ce7cda9a13, options);
}
function $00d97f6f0e186a01$export$a11d582d8eac6325(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$55d126ce7cda9a13, options);
}
const $00d97f6f0e186a01$export$f0446fe099d7b3ec = (0, $cwNRj.gql)`
    mutation createHistoryStocks($input: [HistoryStockInput!]!) {
  result: createHistoryStocks(input: $input) {
    ...HistoryStocksDetails
  }
}
    ${$00d97f6f0e186a01$export$41bfd144d226c415}`;
function $00d97f6f0e186a01$export$2adb5728c168eda2(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$f0446fe099d7b3ec, options);
}
const $00d97f6f0e186a01$export$add9e3e65961fef6 = (0, $cwNRj.gql)`
    mutation createHistoryIndices($input: [HistoryIndexInput!]!) {
  result: createHistoryIndices(input: $input) {
    ...HistoryIndexDetails
  }
}
    ${$00d97f6f0e186a01$export$f0c7321334917bb0}`;
function $00d97f6f0e186a01$export$861a9940a4339576(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$add9e3e65961fef6, options);
}
const $00d97f6f0e186a01$export$5ae2072321ab5e2a = (0, $cwNRj.gql)`
    query membershipComments($membership_id: Int!) {
  result: membershipComments(membership_id: $membership_id) {
    ...CommentDetails
  }
}
    ${$00d97f6f0e186a01$export$d7bc6096322b0575}`;
function $00d97f6f0e186a01$export$fa79fb7bda2b15bf(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$5ae2072321ab5e2a, options);
}
function $00d97f6f0e186a01$export$d72fcbefa2354eb2(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$5ae2072321ab5e2a, options);
}
const $00d97f6f0e186a01$export$b97cc9278da8dfbb = (0, $cwNRj.gql)`
    mutation addComment($membership_id: Int!, $text: String!) {
  result: addComment(membership_id: $membership_id, text: $text) {
    comment {
      ...CommentDetails
    }
    membership {
      ...MembershipOverview
    }
  }
}
    ${$00d97f6f0e186a01$export$d7bc6096322b0575}
${$00d97f6f0e186a01$export$4c49b749d3f62a21}`;
function $00d97f6f0e186a01$export$950e3195c77fb453(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$b97cc9278da8dfbb, options);
}
const $00d97f6f0e186a01$export$bb823def2c2179d0 = (0, $cwNRj.gql)`
    mutation deleteComment($id: Int!, $membership_id: Int!) {
  result: deleteComment(id: $id, membership_id: $membership_id) {
    ...MembershipOverview
  }
}
    ${$00d97f6f0e186a01$export$4c49b749d3f62a21}`;
function $00d97f6f0e186a01$export$91bcd2720f6c2c6(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$bb823def2c2179d0, options);
}
const $00d97f6f0e186a01$export$9758c3d454d53149 = (0, $cwNRj.gql)`
    subscription CommentAdded {
  result: commentAdded {
    ...MembershipOverview
  }
}
    ${$00d97f6f0e186a01$export$4c49b749d3f62a21}`;
function $00d97f6f0e186a01$export$13af509fa5d6ebc8(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$9758c3d454d53149, options);
}
const $00d97f6f0e186a01$export$3d91efdf0498aa07 = (0, $cwNRj.gql)`
    subscription CommentDeleted {
  result: commentDeleted {
    ...MembershipOverview
  }
}
    ${$00d97f6f0e186a01$export$4c49b749d3f62a21}`;
function $00d97f6f0e186a01$export$87398996bb560cdc(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$3d91efdf0498aa07, options);
}
const $00d97f6f0e186a01$export$6746277e7878d46b = (0, $cwNRj.gql)`
    query companies {
  result: companies {
    ...CompanyDetails
  }
}
    ${$00d97f6f0e186a01$export$ae68447942c469fb}`;
function $00d97f6f0e186a01$export$cc20ea60737f9b0c(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$6746277e7878d46b, options);
}
function $00d97f6f0e186a01$export$465c505c28ca5fc3(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$6746277e7878d46b, options);
}
const $00d97f6f0e186a01$export$134e43ba31e88e97 = (0, $cwNRj.gql)`
    query companiesNames {
  result: companies {
    id
    name
  }
}
    `;
function $00d97f6f0e186a01$export$680f18b8879b3ad6(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$134e43ba31e88e97, options);
}
function $00d97f6f0e186a01$export$5ff9fbef64819121(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$134e43ba31e88e97, options);
}
const $00d97f6f0e186a01$export$606864e73427ce83 = (0, $cwNRj.gql)`
    query company($id: Int!) {
  result: company(id: $id) {
    ...CompanyDetails
  }
}
    ${$00d97f6f0e186a01$export$ae68447942c469fb}`;
function $00d97f6f0e186a01$export$995719cf3819fc33(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$606864e73427ce83, options);
}
function $00d97f6f0e186a01$export$4a17e28283151ba8(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$606864e73427ce83, options);
}
const $00d97f6f0e186a01$export$ab84cea386e3d93c = (0, $cwNRj.gql)`
    query companiesFiltered($filter: CompanyFilterInput) {
  result: companiesFiltered(filter: $filter) {
    total
    companies {
      ...CompanyDetails
    }
  }
}
    ${$00d97f6f0e186a01$export$ae68447942c469fb}`;
function $00d97f6f0e186a01$export$ba4e399af9f068f6(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$ab84cea386e3d93c, options);
}
function $00d97f6f0e186a01$export$a59a9625f3100a69(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$ab84cea386e3d93c, options);
}
const $00d97f6f0e186a01$export$d127933587e91455 = (0, $cwNRj.gql)`
    mutation addCompany($input: AddCompanyInput!) {
  result: addCompany(input: $input) {
    success
    errors
    company {
      ...CompanyDetails
    }
  }
}
    ${$00d97f6f0e186a01$export$ae68447942c469fb}`;
function $00d97f6f0e186a01$export$908b0e424e1aa730(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$d127933587e91455, options);
}
const $00d97f6f0e186a01$export$48e47b1dd80b2382 = (0, $cwNRj.gql)`
    mutation updateCompany($id: Int!, $input: NewCompanyInput!) {
  result: updateCompany(id: $id, input: $input) {
    ...CompanyDetails
  }
}
    ${$00d97f6f0e186a01$export$ae68447942c469fb}`;
function $00d97f6f0e186a01$export$fa89acc2cdf44ad8(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$48e47b1dd80b2382, options);
}
const $00d97f6f0e186a01$export$3aa2622437600ac8 = (0, $cwNRj.gql)`
    mutation updateCompanyMembership($id: Int!, $membershipId: Int!) {
  result: updateCompanyMembership(id: $id, membershipId: $membershipId) {
    id
    name
    membership {
      id
      name
      start_date
      end_date
      product {
        id
        name
        membership_type {
          id
          name
        }
      }
    }
  }
}
    `;
function $00d97f6f0e186a01$export$811736e65a26849e(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$3aa2622437600ac8, options);
}
const $00d97f6f0e186a01$export$c68b303ba235a155 = (0, $cwNRj.gql)`
    mutation deleteCompany($id: Int!) {
  result: deleteCompany(id: $id)
}
    `;
function $00d97f6f0e186a01$export$2fb90047bdebe6fb(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$c68b303ba235a155, options);
}
const $00d97f6f0e186a01$export$5c467407b0b7cb88 = (0, $cwNRj.gql)`
    mutation addCompanyToMembership($id: Int!, $membership_id: Int!) {
  result: addCompanyToMembership(id: $id, membership_id: $membership_id) {
    ...CompanyDetails
  }
}
    ${$00d97f6f0e186a01$export$ae68447942c469fb}`;
function $00d97f6f0e186a01$export$fbde7b74cd84e3d5(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$5c467407b0b7cb88, options);
}
const $00d97f6f0e186a01$export$f9189539bcbe3fe4 = (0, $cwNRj.gql)`
    mutation updateCompanyMainMemberForMembership($id: Int!, $membership_id: Int!, $is_main_member: Boolean!) {
  result: updateCompanyMainMemberForMembership(
    id: $id
    membership_id: $membership_id
    is_main_member: $is_main_member
  )
}
    `;
function $00d97f6f0e186a01$export$8b77557e39a37a11(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$f9189539bcbe3fe4, options);
}
const $00d97f6f0e186a01$export$37d9e54db0ce4df3 = (0, $cwNRj.gql)`
    mutation updateCompanyMainContact($id: Int!, $contact_id: Int!, $is_main: Boolean!) {
  result: updateCompanyMainContact(
    id: $id
    contact_id: $contact_id
    is_main: $is_main
  )
}
    `;
function $00d97f6f0e186a01$export$7444174f642e0612(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$37d9e54db0ce4df3, options);
}
const $00d97f6f0e186a01$export$b26fa961c8f95261 = (0, $cwNRj.gql)`
    subscription CompanyCreated {
  result: companyCreated {
    ...CompanyDetails
  }
}
    ${$00d97f6f0e186a01$export$ae68447942c469fb}`;
function $00d97f6f0e186a01$export$87abaebe8b175796(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$b26fa961c8f95261, options);
}
const $00d97f6f0e186a01$export$c0e3fe9d7f6312bf = (0, $cwNRj.gql)`
    subscription CompanyDeleted {
  result: companyDeleted {
    ...CompanyDetails
  }
}
    ${$00d97f6f0e186a01$export$ae68447942c469fb}`;
function $00d97f6f0e186a01$export$93a63d6bf5e32a63(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$c0e3fe9d7f6312bf, options);
}
const $00d97f6f0e186a01$export$cfe6b7113670ecc7 = (0, $cwNRj.gql)`
    subscription CompanyUpdated {
  result: companyUpdated {
    ...CompanyDetails
  }
}
    ${$00d97f6f0e186a01$export$ae68447942c469fb}`;
function $00d97f6f0e186a01$export$ca616a9a9340d29(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$cfe6b7113670ecc7, options);
}
const $00d97f6f0e186a01$export$b211573a2acce67c = (0, $cwNRj.gql)`
    query companyTypes {
  result: companyTypes {
    id
    name
  }
}
    `;
function $00d97f6f0e186a01$export$5cc89c9d8186016(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$b211573a2acce67c, options);
}
function $00d97f6f0e186a01$export$5a172ce6f9931466(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$b211573a2acce67c, options);
}
const $00d97f6f0e186a01$export$e54f1fd8726f40b5 = (0, $cwNRj.gql)`
    query companyContacts($company_id: Int!) {
  result: companyContacts(company_id: $company_id) {
    ...ContactDetails
    phone_direct
    company {
      id
      name
    }
  }
}
    ${$00d97f6f0e186a01$export$80ea9b1585c00fb9}`;
function $00d97f6f0e186a01$export$e475eb7a4886aa70(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$e54f1fd8726f40b5, options);
}
function $00d97f6f0e186a01$export$eb630f4f2a1714c9(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$e54f1fd8726f40b5, options);
}
const $00d97f6f0e186a01$export$b127912377ac22e9 = (0, $cwNRj.gql)`
    query contacts {
  result: contacts {
    ...ContactDetails
    phone_direct
    company {
      id
      name
    }
  }
}
    ${$00d97f6f0e186a01$export$80ea9b1585c00fb9}`;
function $00d97f6f0e186a01$export$2c260f9f327fbdbc(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$b127912377ac22e9, options);
}
function $00d97f6f0e186a01$export$ff78fbc4c0749e81(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$b127912377ac22e9, options);
}
const $00d97f6f0e186a01$export$2c802e062f813bd3 = (0, $cwNRj.gql)`
    query contactsFiltered($filter: ContactFilterInput) {
  result: contactsFiltered(filter: $filter) {
    total
    contacts {
      ...ContactDetails
      phone_direct
      phone_mobile
      company {
        id
        name
      }
    }
  }
}
    ${$00d97f6f0e186a01$export$80ea9b1585c00fb9}`;
function $00d97f6f0e186a01$export$502975e802225222(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$2c802e062f813bd3, options);
}
function $00d97f6f0e186a01$export$c0dad8b91225639a(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$2c802e062f813bd3, options);
}
const $00d97f6f0e186a01$export$a39a34b2b2f150cb = (0, $cwNRj.gql)`
    query contactByEmailAndFullName($fullName: String!, $email: String!) {
  result: contactByEmailAndFullName(fullName: $fullName, email: $email) {
    ...ContactDetailsInvoicePreview
  }
}
    ${$00d97f6f0e186a01$export$c377c029b0ef8a86}`;
function $00d97f6f0e186a01$export$9623462de32577e4(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$a39a34b2b2f150cb, options);
}
function $00d97f6f0e186a01$export$d5f81806168bc8c2(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$a39a34b2b2f150cb, options);
}
const $00d97f6f0e186a01$export$455f2e965f1c9f9e = (0, $cwNRj.gql)`
    query contact($id: Int!) {
  result: contact(id: $id) {
    ...ContactDetails
    company {
      id
      name
      membership {
        id
        name
      }
      main_address {
        complete_vat_number
      }
    }
    contactMeetings {
      id
      name
      subject
      contacts {
        id
        fullName
      }
      meeting_type {
        id
        name
      }
      meeting_details
      location
      start_time
      end_time
    }
  }
}
    ${$00d97f6f0e186a01$export$80ea9b1585c00fb9}`;
function $00d97f6f0e186a01$export$e73af2330ae77132(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$455f2e965f1c9f9e, options);
}
function $00d97f6f0e186a01$export$564318d15e165bfa(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$455f2e965f1c9f9e, options);
}
const $00d97f6f0e186a01$export$29becbb86a320853 = (0, $cwNRj.gql)`
    query contactDetails($id: Int!) {
  result: contact(id: $id) {
    ...ContactFullScope
  }
}
    ${$00d97f6f0e186a01$export$8559e1f2a2728599}`;
function $00d97f6f0e186a01$export$423de2676ae8d7eb(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$29becbb86a320853, options);
}
function $00d97f6f0e186a01$export$5d7ff30ab76a3756(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$29becbb86a320853, options);
}
const $00d97f6f0e186a01$export$176e287f50a3fdf9 = (0, $cwNRj.gql)`
    query contactBasicData {
  result: contacts {
    id
    fullName
  }
}
    `;
function $00d97f6f0e186a01$export$b96558b58e974053(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$176e287f50a3fdf9, options);
}
function $00d97f6f0e186a01$export$9c867257d9f24ad0(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$176e287f50a3fdf9, options);
}
const $00d97f6f0e186a01$export$d941ed6cc6c130b2 = (0, $cwNRj.gql)`
    query assistantContactsFromSameCompany($id: Int!, $company_id: Int!) {
  result: assistantContactsFromSameCompany(id: $id, company_id: $company_id) {
    id
    fullName
    email
    phone_direct
    phone_mobile
  }
}
    `;
function $00d97f6f0e186a01$export$6499ff4c5254a854(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$d941ed6cc6c130b2, options);
}
function $00d97f6f0e186a01$export$b6fe6fcd895ea941(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$d941ed6cc6c130b2, options);
}
const $00d97f6f0e186a01$export$5067be11e658e7cc = (0, $cwNRj.gql)`
    query contactInterests($contact_id: Int!) {
  result: contactInterests(contact_id: $contact_id) {
    interest_id
  }
}
    `;
function $00d97f6f0e186a01$export$3ab4f899641398ba(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$5067be11e658e7cc, options);
}
function $00d97f6f0e186a01$export$b721c559547970b0(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$5067be11e658e7cc, options);
}
const $00d97f6f0e186a01$export$621fad26a3a021dd = (0, $cwNRj.gql)`
    query contactsByInterests($interestIds: [Int!]!) {
  result: contactsByInterests(interestIds: $interestIds) {
    ...Recipients
  }
}
    ${$00d97f6f0e186a01$export$78d0e333dc9c5872}`;
function $00d97f6f0e186a01$export$84e0f38fd0b59a6b(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$621fad26a3a021dd, options);
}
function $00d97f6f0e186a01$export$ade7987f13e8a068(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$621fad26a3a021dd, options);
}
const $00d97f6f0e186a01$export$4f6fbee2f55ed050 = (0, $cwNRj.gql)`
    query recipientListContacts($contactTitleIds: [Int]!, $companyTypeIds: [Int]!, $membershipTypeIds: [Int]!, $interestIds: [Int]!, $countryIds: [Int]!, $recipientListId: Int) {
  result: recipientListContacts(
    contactTitleIds: $contactTitleIds
    companyTypeIds: $companyTypeIds
    membershipTypeIds: $membershipTypeIds
    interestIds: $interestIds
    countryIds: $countryIds
    recipientListId: $recipientListId
  ) {
    ...Recipients
  }
}
    ${$00d97f6f0e186a01$export$78d0e333dc9c5872}`;
function $00d97f6f0e186a01$export$80e7c5bff9486ef0(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$4f6fbee2f55ed050, options);
}
function $00d97f6f0e186a01$export$b7ccc34b3ed3686b(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$4f6fbee2f55ed050, options);
}
const $00d97f6f0e186a01$export$fca6ca0eef2eae8c = (0, $cwNRj.gql)`
    mutation deleteContact($id: Int!, $can_delete_last: Boolean) {
  result: deleteContact(id: $id, can_delete_last: $can_delete_last)
}
    `;
function $00d97f6f0e186a01$export$2ebd21a5eb675d89(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$fca6ca0eef2eae8c, options);
}
const $00d97f6f0e186a01$export$9468c1b6fc8c4524 = (0, $cwNRj.gql)`
    mutation createContact($input: ContactCreateInput!) {
  result: createContact(input: $input) {
    ...ContactDetails
    phone_direct
    company {
      id
      name
    }
  }
}
    ${$00d97f6f0e186a01$export$80ea9b1585c00fb9}`;
function $00d97f6f0e186a01$export$53a2be496701405e(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$9468c1b6fc8c4524, options);
}
const $00d97f6f0e186a01$export$26339f12b5babd5a = (0, $cwNRj.gql)`
    mutation updateContactDetails($id: Int!, $input: ContactInput!) {
  result: updateContactDetails(id: $id, input: $input) {
    ...ContactFullScope
  }
}
    ${$00d97f6f0e186a01$export$8559e1f2a2728599}`;
function $00d97f6f0e186a01$export$85c6fc1c9d18b5f9(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$26339f12b5babd5a, options);
}
const $00d97f6f0e186a01$export$2f5163f8e424023e = (0, $cwNRj.gql)`
    mutation updateContactAddress($id: Int!, $company_id: Int!, $address_id: Int) {
  result: updateContactAddress(
    id: $id
    company_id: $company_id
    address_id: $address_id
  ) {
    ...ContactFullScope
  }
}
    ${$00d97f6f0e186a01$export$8559e1f2a2728599}`;
function $00d97f6f0e186a01$export$a0f1ab69b28d68df(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$2f5163f8e424023e, options);
}
const $00d97f6f0e186a01$export$cd82ade5ad6d427e = (0, $cwNRj.gql)`
    mutation updateContactAssistant($id: Int!, $assistantId: Int) {
  result: updateContactAssistant(id: $id, assistantId: $assistantId) {
    ...ContactFullScope
  }
}
    ${$00d97f6f0e186a01$export$8559e1f2a2728599}`;
function $00d97f6f0e186a01$export$3953cb133faa91c7(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$cd82ade5ad6d427e, options);
}
const $00d97f6f0e186a01$export$2743c9fb40d1636a = (0, $cwNRj.gql)`
    mutation setInvoiceToContact($id: Int!, $is_main: Boolean!) {
  result: setInvoiceToContact(id: $id, is_main: $is_main) {
    id
    is_main
    fullName
    email
    titleInternal {
      id
      name
    }
    address {
      id
      street
    }
    company {
      id
      name
    }
  }
}
    `;
function $00d97f6f0e186a01$export$17bba5cf9d251204(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$2743c9fb40d1636a, options);
}
const $00d97f6f0e186a01$export$bfe3661b71005969 = (0, $cwNRj.gql)`
    mutation updateContactInterests($id: Int!, $interest_ids: [Int]!) {
  result: updateContactInterests(contact_id: $id, interest_ids: $interest_ids)
}
    `;
function $00d97f6f0e186a01$export$1aa472d78be1ac2f(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$bfe3661b71005969, options);
}
const $00d97f6f0e186a01$export$31c682bf6561747b = (0, $cwNRj.gql)`
    subscription ContactDeleted {
  result: contactDeleted {
    id
  }
}
    `;
function $00d97f6f0e186a01$export$4064c5bb2fbf4d99(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$31c682bf6561747b, options);
}
const $00d97f6f0e186a01$export$50b37f69a9d98be = (0, $cwNRj.gql)`
    subscription ContactCreated {
  result: contactCreated {
    ...ContactDetails
    phone_direct
    company {
      id
      name
    }
  }
}
    ${$00d97f6f0e186a01$export$80ea9b1585c00fb9}`;
function $00d97f6f0e186a01$export$442e7a390e59f3c5(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$50b37f69a9d98be, options);
}
const $00d97f6f0e186a01$export$bcb41751a13336ff = (0, $cwNRj.gql)`
    subscription ContactUpdated {
  result: contactUpdated {
    ...ContactDetails
    phone_direct
    company {
      id
      name
    }
  }
}
    ${$00d97f6f0e186a01$export$80ea9b1585c00fb9}`;
function $00d97f6f0e186a01$export$b77d5b1c309be11e(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$bcb41751a13336ff, options);
}
const $00d97f6f0e186a01$export$6b3631230f0d76b7 = (0, $cwNRj.gql)`
    query countries {
  result: countries {
    id
    name
    code
    region {
      id
    }
  }
}
    `;
function $00d97f6f0e186a01$export$30acda5e65e8ffe1(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$6b3631230f0d76b7, options);
}
function $00d97f6f0e186a01$export$f3471ac93924b697(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$6b3631230f0d76b7, options);
}
const $00d97f6f0e186a01$export$e78372ddaac52917 = (0, $cwNRj.gql)`
    query countryNames {
  result: countries {
    id
    name
  }
}
    `;
function $00d97f6f0e186a01$export$39ab25f56fd368c8(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$e78372ddaac52917, options);
}
function $00d97f6f0e186a01$export$688ebbf32c83b70(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$e78372ddaac52917, options);
}
const $00d97f6f0e186a01$export$644170d0b8bf5cb2 = (0, $cwNRj.gql)`
    query currencies {
  result: currencies {
    id
    name
    code
  }
}
    `;
function $00d97f6f0e186a01$export$c2bec37b8f24999d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$644170d0b8bf5cb2, options);
}
function $00d97f6f0e186a01$export$2dd130070eca4cfb(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$644170d0b8bf5cb2, options);
}
const $00d97f6f0e186a01$export$ca81c2f543ec4564 = (0, $cwNRj.gql)`
    query getAllCventEvents {
  result: getAllCventEvents {
    ...CventEventDetails
  }
}
    ${$00d97f6f0e186a01$export$ef421f8864c2a330}`;
function $00d97f6f0e186a01$export$19fb136105f4be25(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$ca81c2f543ec4564, options);
}
function $00d97f6f0e186a01$export$cf385566cd74f541(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$ca81c2f543ec4564, options);
}
const $00d97f6f0e186a01$export$c7f2bf5c9e9eacfc = (0, $cwNRj.gql)`
    query getAllCventRoles {
  result: getAllCventRoles {
    ...CventRolesDetails
  }
}
    ${$00d97f6f0e186a01$export$940e38cbf6b1fe7e}`;
function $00d97f6f0e186a01$export$cb9bef9e78b92574(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$c7f2bf5c9e9eacfc, options);
}
function $00d97f6f0e186a01$export$4984911c14d6b43f(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$c7f2bf5c9e9eacfc, options);
}
const $00d97f6f0e186a01$export$fc2140c4a56c6e89 = (0, $cwNRj.gql)`
    query getAllCventContacts {
  result: getAllCventContacts {
    ...CventContactDetails
  }
}
    ${$00d97f6f0e186a01$export$36f3b7eb3774445d}`;
function $00d97f6f0e186a01$export$c3c74bc81962360b(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$fc2140c4a56c6e89, options);
}
function $00d97f6f0e186a01$export$28bcfd808f5f12a1(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$fc2140c4a56c6e89, options);
}
const $00d97f6f0e186a01$export$181a29c43a7889bd = (0, $cwNRj.gql)`
    query getAllCventContactsForLocation($id: ID!) {
  result: getAllCventContactsForLocation(id: $id) {
    ...CventContactDetails
  }
}
    ${$00d97f6f0e186a01$export$36f3b7eb3774445d}`;
function $00d97f6f0e186a01$export$5379be960d464258(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$181a29c43a7889bd, options);
}
function $00d97f6f0e186a01$export$9826d01e399fd033(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$181a29c43a7889bd, options);
}
const $00d97f6f0e186a01$export$e99a4fa75647b6d1 = (0, $cwNRj.gql)`
    query getAllLocationsForEvent($event_id: ID!) {
  result: getAllLocationsForEvent(event_id: $event_id) {
    ...CventLocationDetails
  }
}
    ${$00d97f6f0e186a01$export$95b237684e1cef80}`;
function $00d97f6f0e186a01$export$658b6a24ef84ac92(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$e99a4fa75647b6d1, options);
}
function $00d97f6f0e186a01$export$7eeb6dc5bb56edbe(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$e99a4fa75647b6d1, options);
}
const $00d97f6f0e186a01$export$9e859c3c3be9bce7 = (0, $cwNRj.gql)`
    query getMatchedDbContactsByEmail($id: ID!, $input: LinkContact!) {
  result: getMatchedDbContactsByEmail(id: $id, input: $input) {
    ...DbContactDetails
  }
}
    ${$00d97f6f0e186a01$export$1e2a63bd0314da2b}`;
function $00d97f6f0e186a01$export$4aeb34405477065c(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$9e859c3c3be9bce7, options);
}
function $00d97f6f0e186a01$export$f7ac0d9606490bef(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$9e859c3c3be9bce7, options);
}
const $00d97f6f0e186a01$export$7bc2e66ebff90783 = (0, $cwNRj.gql)`
    mutation createCventContact($input: AddCventContact!) {
  result: createCventContact(input: $input) {
    ...CventContactDetails
  }
}
    ${$00d97f6f0e186a01$export$36f3b7eb3774445d}`;
function $00d97f6f0e186a01$export$2afec89b6bd5ff3d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$7bc2e66ebff90783, options);
}
const $00d97f6f0e186a01$export$8cb0246d89f085 = (0, $cwNRj.gql)`
    mutation updateCventContact($id: ID!, $input: AddCventContact!) {
  result: updateCventContact(id: $id, input: $input) {
    ...CventContactDetails
  }
}
    ${$00d97f6f0e186a01$export$36f3b7eb3774445d}`;
function $00d97f6f0e186a01$export$5081f8a3c9b39e6b(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$8cb0246d89f085, options);
}
const $00d97f6f0e186a01$export$c5727aca54a1b9a4 = (0, $cwNRj.gql)`
    mutation deleteCventContact($id: Int!) {
  result: deleteCventContact(id: $id)
}
    `;
function $00d97f6f0e186a01$export$3b53c66cd721baa1(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$c5727aca54a1b9a4, options);
}
const $00d97f6f0e186a01$export$d0109343655ddb7 = (0, $cwNRj.gql)`
    mutation linkContact($id: ID!, $input: LinkContact!) {
  result: linkContact(id: $id, input: $input) {
    ...CventContactDetails
  }
}
    ${$00d97f6f0e186a01$export$36f3b7eb3774445d}`;
function $00d97f6f0e186a01$export$ecbf0d19256d2a(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$d0109343655ddb7, options);
}
const $00d97f6f0e186a01$export$aabf952acb813649 = (0, $cwNRj.gql)`
    mutation unLinkContact($id: ID!) {
  result: unLinkContact(id: $id) {
    ...CventContactDetails
  }
}
    ${$00d97f6f0e186a01$export$36f3b7eb3774445d}`;
function $00d97f6f0e186a01$export$8485c007549ac860(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$aabf952acb813649, options);
}
const $00d97f6f0e186a01$export$10fdab0022d2a1f9 = (0, $cwNRj.gql)`
    mutation toggleIsApproved($id: ID!, $input: IsApproved!) {
  result: toggleIsApproved(id: $id, input: $input) {
    ...CventContactDetails
  }
}
    ${$00d97f6f0e186a01$export$36f3b7eb3774445d}`;
function $00d97f6f0e186a01$export$627aa582cc1a7174(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$10fdab0022d2a1f9, options);
}
const $00d97f6f0e186a01$export$e21350264651bcf0 = (0, $cwNRj.gql)`
    mutation uploadCventContacts($location: String!, $input: [cventFileInput]) {
  result: uploadCventContacts(location: $location, input: $input) {
    event {
      ...CventEventDetails
    }
    location {
      ...CventLocationDetails
    }
  }
}
    ${$00d97f6f0e186a01$export$ef421f8864c2a330}
${$00d97f6f0e186a01$export$95b237684e1cef80}`;
function $00d97f6f0e186a01$export$e365e22d6cb57046(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$e21350264651bcf0, options);
}
const $00d97f6f0e186a01$export$c2ef9d3284815789 = (0, $cwNRj.gql)`
    query dashboardDoughnutQuery {
  result: dashboardDoughnutQuery {
    count
    membership_type
    label
  }
}
    `;
function $00d97f6f0e186a01$export$9d3c6cf3b6b298fe(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$c2ef9d3284815789, options);
}
function $00d97f6f0e186a01$export$f62c479f6be48906(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$c2ef9d3284815789, options);
}
const $00d97f6f0e186a01$export$791c263e80ac0435 = (0, $cwNRj.gql)`
    query dashboardMembershipsInfoForTheLastThreeYears {
  result: dashboardMembershipsInfoForTheLastThreeYears {
    quarters_date
    started_memberships_count
    renewed_memberships_count
    ended_memberships_count
    startedLegend
    renewedLegend
    endedLegend
  }
}
    `;
function $00d97f6f0e186a01$export$3a801f09e9b8bd93(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$791c263e80ac0435, options);
}
function $00d97f6f0e186a01$export$18174fb3bf4402df(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$791c263e80ac0435, options);
}
const $00d97f6f0e186a01$export$f6f94a2182d4797 = (0, $cwNRj.gql)`
    query dashboardInvoicesInfo {
  result: dashboardInvoicesInfo {
    date
    issued_invoices
    paid_invoices
    outstanding
    total_issued_invoices_count
    total_paid_invoices_count
  }
}
    `;
function $00d97f6f0e186a01$export$9ae0eba6dd59e530(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$f6f94a2182d4797, options);
}
function $00d97f6f0e186a01$export$86939417db0a1a2c(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$f6f94a2182d4797, options);
}
const $00d97f6f0e186a01$export$fd49ce0c73a5e879 = (0, $cwNRj.gql)`
    query getDividendsGross($stock_id: Int!) {
  result: getDividendsGross(stock_id: $stock_id) {
    ...DividendDetails
  }
}
    ${$00d97f6f0e186a01$export$5ce0d26dec7e4866}`;
function $00d97f6f0e186a01$export$7be861d3bf8fb6d6(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$fd49ce0c73a5e879, options);
}
function $00d97f6f0e186a01$export$f0178fa517eaec2d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$fd49ce0c73a5e879, options);
}
const $00d97f6f0e186a01$export$4a90e6c313121de = (0, $cwNRj.gql)`
    mutation createDividend($stock_id: ID!, $input: DividendInput!) {
  result: createDividend(stock_id: $stock_id, input: $input) {
    ...DividendDetails
  }
}
    ${$00d97f6f0e186a01$export$5ce0d26dec7e4866}`;
function $00d97f6f0e186a01$export$ee84a415d81426e2(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$4a90e6c313121de, options);
}
const $00d97f6f0e186a01$export$35e7fee8994a10a6 = (0, $cwNRj.gql)`
    mutation updateDividend($id: ID!, $input: DividendInput!) {
  result: updateDividend(id: $id, input: $input) {
    ...DividendDetails
  }
}
    ${$00d97f6f0e186a01$export$5ce0d26dec7e4866}`;
function $00d97f6f0e186a01$export$48efb717a74b5a53(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$35e7fee8994a10a6, options);
}
const $00d97f6f0e186a01$export$f9e575dd77edf09f = (0, $cwNRj.gql)`
    mutation deleteDividend($id: ID!) {
  result: deleteDividend(id: $id)
}
    `;
function $00d97f6f0e186a01$export$23a85e4e9432b04(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$f9e575dd77edf09f, options);
}
const $00d97f6f0e186a01$export$2f15142ee709b6d3 = (0, $cwNRj.gql)`
    subscription dividendCreated($stock_id: ID!) {
  result: dividendCreated(stock_id: $stock_id) {
    ...DividendDetails
  }
}
    ${$00d97f6f0e186a01$export$5ce0d26dec7e4866}`;
function $00d97f6f0e186a01$export$ca1491b9c4dcc72f(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$2f15142ee709b6d3, options);
}
const $00d97f6f0e186a01$export$a220b9ae89713e4e = (0, $cwNRj.gql)`
    subscription dividendUpdated($stock_id: ID!) {
  result: dividendUpdated(stock_id: $stock_id) {
    ...DividendDetails
  }
}
    ${$00d97f6f0e186a01$export$5ce0d26dec7e4866}`;
function $00d97f6f0e186a01$export$592f6f15d6a10154(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$a220b9ae89713e4e, options);
}
const $00d97f6f0e186a01$export$5a8ef167fa750ddd = (0, $cwNRj.gql)`
    subscription dividendDeleted($stock_id: ID!) {
  result: dividendDeleted(stock_id: $stock_id) {
    ...DividendDetails
  }
}
    ${$00d97f6f0e186a01$export$5ce0d26dec7e4866}`;
function $00d97f6f0e186a01$export$30849f9b09454be6(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$5a8ef167fa750ddd, options);
}
const $00d97f6f0e186a01$export$f75860313b413655 = (0, $cwNRj.gql)`
    query documents {
  result: documents {
    ...DocumentDetails
  }
}
    ${$00d97f6f0e186a01$export$2b8217b18cb6fb06}`;
function $00d97f6f0e186a01$export$ef537aa5a081c368(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$f75860313b413655, options);
}
function $00d97f6f0e186a01$export$e7aff1e8a0f0e4cb(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$f75860313b413655, options);
}
const $00d97f6f0e186a01$export$ad8f0f970c582786 = (0, $cwNRj.gql)`
    query documentsFiltered($filter: DocumentFilterInput) {
  result: documentsFiltered(filter: $filter) {
    documents {
      ...DocumentDetails
    }
    total
  }
}
    ${$00d97f6f0e186a01$export$2b8217b18cb6fb06}`;
function $00d97f6f0e186a01$export$b8dd71644771623d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$ad8f0f970c582786, options);
}
function $00d97f6f0e186a01$export$ba9cab5884e2f62d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$ad8f0f970c582786, options);
}
const $00d97f6f0e186a01$export$82c333417394f607 = (0, $cwNRj.gql)`
    mutation createDocument($input: DocumentInput!) {
  result: createDocument(input: $input) {
    ...DocumentDetails
  }
}
    ${$00d97f6f0e186a01$export$2b8217b18cb6fb06}`;
function $00d97f6f0e186a01$export$cbe541f8c16813d9(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$82c333417394f607, options);
}
const $00d97f6f0e186a01$export$99eb79c617aa6e50 = (0, $cwNRj.gql)`
    mutation updateDocument($id: ID!, $input: DocumentInput!) {
  result: updateDocument(id: $id, input: $input) {
    ...DocumentDetails
  }
}
    ${$00d97f6f0e186a01$export$2b8217b18cb6fb06}`;
function $00d97f6f0e186a01$export$27fcba640b9d64a1(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$99eb79c617aa6e50, options);
}
const $00d97f6f0e186a01$export$720408ff8e6e5a85 = (0, $cwNRj.gql)`
    mutation deleteDocument($id: ID!) {
  result: deleteDocument(id: $id)
}
    `;
function $00d97f6f0e186a01$export$d3195cfd812c44cf(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$720408ff8e6e5a85, options);
}
const $00d97f6f0e186a01$export$9fdc0c42506a5b3d = (0, $cwNRj.gql)`
    mutation deleteDocumentFromSiteSection($document_id: ID!, $site_section_id: ID!) {
  result: deleteDocumentFromSiteSection(
    document_id: $document_id
    site_section_id: $site_section_id
  )
}
    `;
function $00d97f6f0e186a01$export$d376833610cd8e83(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$9fdc0c42506a5b3d, options);
}
const $00d97f6f0e186a01$export$efe9b716623dcbb8 = (0, $cwNRj.gql)`
    mutation updateDescription($id: ID!, $description: String) {
  result: updateDescription(id: $id, description: $description) {
    ...DocumentDetails
  }
}
    ${$00d97f6f0e186a01$export$2b8217b18cb6fb06}`;
function $00d97f6f0e186a01$export$e881fa78b0d6ec1c(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$efe9b716623dcbb8, options);
}
const $00d97f6f0e186a01$export$3388a8c0d800eabf = (0, $cwNRj.gql)`
    subscription documentDeleted {
  result: documentDeleted {
    ...DocumentDetails
  }
}
    ${$00d97f6f0e186a01$export$2b8217b18cb6fb06}`;
function $00d97f6f0e186a01$export$a3884f9363f409d6(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$3388a8c0d800eabf, options);
}
const $00d97f6f0e186a01$export$3b07f9b6c8b6130c = (0, $cwNRj.gql)`
    subscription documentUpdated {
  result: documentUpdated {
    ...DocumentDetails
  }
}
    ${$00d97f6f0e186a01$export$2b8217b18cb6fb06}`;
function $00d97f6f0e186a01$export$2967f4cb7c10f456(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$3b07f9b6c8b6130c, options);
}
const $00d97f6f0e186a01$export$c453922bcbedebc6 = (0, $cwNRj.gql)`
    subscription documentCreated {
  result: documentCreated {
    ...DocumentDetails
  }
}
    ${$00d97f6f0e186a01$export$2b8217b18cb6fb06}`;
function $00d97f6f0e186a01$export$794e4c4c95140d9(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$c453922bcbedebc6, options);
}
const $00d97f6f0e186a01$export$a8bcbc70c85c90cb = (0, $cwNRj.gql)`
    query getEtfs {
  result: getEtfs {
    ...EtfDetails
  }
}
    ${$00d97f6f0e186a01$export$84b5ed1aec9806d6}`;
function $00d97f6f0e186a01$export$2b2eea9ead661b19(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$a8bcbc70c85c90cb, options);
}
function $00d97f6f0e186a01$export$6f8cc70591cb87fd(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$a8bcbc70c85c90cb, options);
}
const $00d97f6f0e186a01$export$a187155805c87e06 = (0, $cwNRj.gql)`
    query getEtfValues($etf_id: Int!) {
  result: getEtfValues(etf_id: $etf_id) {
    ...EtfValueDetails
  }
}
    ${$00d97f6f0e186a01$export$ab45010cd7fca607}`;
function $00d97f6f0e186a01$export$f0498b0df538f9c1(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$a187155805c87e06, options);
}
function $00d97f6f0e186a01$export$e24c8e2a2f167b98(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$a187155805c87e06, options);
}
const $00d97f6f0e186a01$export$9f7e474bd0f113fb = (0, $cwNRj.gql)`
    query getEtf($id: ID!) {
  result: getEtf(id: $id) {
    ...EtfDetails
  }
}
    ${$00d97f6f0e186a01$export$84b5ed1aec9806d6}`;
function $00d97f6f0e186a01$export$24e8c468849f551e(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$9f7e474bd0f113fb, options);
}
function $00d97f6f0e186a01$export$e2735e948b8e8f8(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$9f7e474bd0f113fb, options);
}
const $00d97f6f0e186a01$export$ab4dc8e5d1bbb9a7 = (0, $cwNRj.gql)`
    mutation addEtf($input: EtfInput!) {
  result: addEtf(input: $input) {
    ...EtfDetails
  }
}
    ${$00d97f6f0e186a01$export$84b5ed1aec9806d6}`;
function $00d97f6f0e186a01$export$a213f769e12aee78(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$ab4dc8e5d1bbb9a7, options);
}
const $00d97f6f0e186a01$export$2be80c33b1d0fa2f = (0, $cwNRj.gql)`
    mutation updateEtf($id: ID!, $input: EtfInput!) {
  result: updateEtf(id: $id, input: $input) {
    ...EtfDetails
  }
}
    ${$00d97f6f0e186a01$export$84b5ed1aec9806d6}`;
function $00d97f6f0e186a01$export$5ba67e5b0a3149d0(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$2be80c33b1d0fa2f, options);
}
const $00d97f6f0e186a01$export$3bf48747400391e4 = (0, $cwNRj.gql)`
    mutation deleteETF($id: ID!) {
  result: deleteETF(id: $id)
}
    `;
function $00d97f6f0e186a01$export$6484f049bc57a39e(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$3bf48747400391e4, options);
}
const $00d97f6f0e186a01$export$b3a7ea4569c6346a = (0, $cwNRj.gql)`
    mutation addEtfValue($etf_id: ID!, $input: EtfValueInput!) {
  result: addEtfValue(etf_id: $etf_id, input: $input) {
    ...EtfValueDetails
  }
}
    ${$00d97f6f0e186a01$export$ab45010cd7fca607}`;
function $00d97f6f0e186a01$export$8e5e38b7fd16c285(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$b3a7ea4569c6346a, options);
}
const $00d97f6f0e186a01$export$ea0e0917fc240c4 = (0, $cwNRj.gql)`
    mutation updateEtfValue($id: ID!, $input: EtfValueInput!) {
  result: updateEtfValue(id: $id, input: $input) {
    ...EtfValueDetails
  }
}
    ${$00d97f6f0e186a01$export$ab45010cd7fca607}`;
function $00d97f6f0e186a01$export$b791056ef9b636e1(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$ea0e0917fc240c4, options);
}
const $00d97f6f0e186a01$export$76cf0e71045977de = (0, $cwNRj.gql)`
    subscription etfCreated {
  result: etfCreated {
    ...EtfDetails
  }
}
    ${$00d97f6f0e186a01$export$84b5ed1aec9806d6}`;
function $00d97f6f0e186a01$export$445cd6d91b3f18e6(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$76cf0e71045977de, options);
}
const $00d97f6f0e186a01$export$684eec72dfa7bfe0 = (0, $cwNRj.gql)`
    subscription etfUpdated {
  result: etfUpdated {
    ...EtfDetails
  }
}
    ${$00d97f6f0e186a01$export$84b5ed1aec9806d6}`;
function $00d97f6f0e186a01$export$28ee9deea439cdb(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$684eec72dfa7bfe0, options);
}
const $00d97f6f0e186a01$export$f429dba331877a13 = (0, $cwNRj.gql)`
    subscription etfDeleted {
  result: etfDeleted {
    ...EtfDetails
  }
}
    ${$00d97f6f0e186a01$export$84b5ed1aec9806d6}`;
function $00d97f6f0e186a01$export$7ea6272d58d06ac3(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$f429dba331877a13, options);
}
const $00d97f6f0e186a01$export$2c5d1deee9362b22 = (0, $cwNRj.gql)`
    subscription etfValueCreated($etf_id: ID!) {
  result: etfValueCreated(etf_id: $etf_id) {
    ...EtfValueDetails
  }
}
    ${$00d97f6f0e186a01$export$ab45010cd7fca607}`;
function $00d97f6f0e186a01$export$b1c1bd886f367d13(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$2c5d1deee9362b22, options);
}
const $00d97f6f0e186a01$export$1ade88deabc99ecb = (0, $cwNRj.gql)`
    subscription etfValueUpdated($etf_id: ID!) {
  result: etfValueUpdated(etf_id: $etf_id) {
    ...EtfValueDetails
  }
}
    ${$00d97f6f0e186a01$export$ab45010cd7fca607}`;
function $00d97f6f0e186a01$export$e599d97b814147c7(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$1ade88deabc99ecb, options);
}
const $00d97f6f0e186a01$export$b4a8b95e70614121 = (0, $cwNRj.gql)`
    query getEtfsWithValues($date: String) {
  result: getEtfsWithValues(date: $date) {
    ...EtfValueDetails
  }
}
    ${$00d97f6f0e186a01$export$ab45010cd7fca607}`;
function $00d97f6f0e186a01$export$22b1bb32750dd06d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$b4a8b95e70614121, options);
}
function $00d97f6f0e186a01$export$265780726f9501c9(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$b4a8b95e70614121, options);
}
const $00d97f6f0e186a01$export$437ea2a8383dda7a = (0, $cwNRj.gql)`
    query getFtseFiles {
  result: getFtseFiles {
    ...FtseDetails
  }
}
    ${$00d97f6f0e186a01$export$eab67a80655f45e8}`;
function $00d97f6f0e186a01$export$70704029d733a80e(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$437ea2a8383dda7a, options);
}
function $00d97f6f0e186a01$export$29ebaba6c13b83c5(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$437ea2a8383dda7a, options);
}
const $00d97f6f0e186a01$export$be62a8e9d0d5524f = (0, $cwNRj.gql)`
    query getFtseTypes {
  result: getFtseTypes {
    id
    name
  }
}
    `;
function $00d97f6f0e186a01$export$8047f728cd7bb9f0(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$be62a8e9d0d5524f, options);
}
function $00d97f6f0e186a01$export$6581008cb1e2773a(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$be62a8e9d0d5524f, options);
}
const $00d97f6f0e186a01$export$1c09fbb2a4da964 = (0, $cwNRj.gql)`
    query getFtseConfigurations {
  result: getFtseConfigurations {
    ...FtseConfigurationDetails
  }
}
    ${$00d97f6f0e186a01$export$88d96b3ce3ff91a4}`;
function $00d97f6f0e186a01$export$de6a4a17e4bb6822(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$1c09fbb2a4da964, options);
}
function $00d97f6f0e186a01$export$fa7167b2c54639ee(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$1c09fbb2a4da964, options);
}
const $00d97f6f0e186a01$export$ca832de111fedc5a = (0, $cwNRj.gql)`
    mutation deleteFtseFile($id: ID!) {
  result: deleteFtseFile(id: $id)
}
    `;
function $00d97f6f0e186a01$export$f5e2156276d04a76(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$ca832de111fedc5a, options);
}
const $00d97f6f0e186a01$export$ca2699b92eeb5986 = (0, $cwNRj.gql)`
    mutation createFtseFile($input: ftseFileInput!) {
  result: createFtseFile(input: $input) {
    ...FtseDetails
  }
}
    ${$00d97f6f0e186a01$export$eab67a80655f45e8}`;
function $00d97f6f0e186a01$export$65023ac5d20cd20a(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$ca2699b92eeb5986, options);
}
const $00d97f6f0e186a01$export$da11af58445a4e4b = (0, $cwNRj.gql)`
    mutation updateFtse($id: ID!, $input: ftseFileInput!) {
  result: updateFtse(id: $id, input: $input) {
    ...FtseDetails
  }
}
    ${$00d97f6f0e186a01$export$eab67a80655f45e8}`;
function $00d97f6f0e186a01$export$9b830a578189f88e(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$da11af58445a4e4b, options);
}
const $00d97f6f0e186a01$export$7fdbf6250ae710f2 = (0, $cwNRj.gql)`
    mutation updateFtseConfiguration($id: ID!, $input: ftseConfigurationInput!) {
  result: updateFtseConfiguration(id: $id, input: $input) {
    ...FtseConfigurationDetails
  }
}
    ${$00d97f6f0e186a01$export$88d96b3ce3ff91a4}`;
function $00d97f6f0e186a01$export$3e260e4bdb2e765a(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$7fdbf6250ae710f2, options);
}
const $00d97f6f0e186a01$export$6c29a4c3b41431f7 = (0, $cwNRj.gql)`
    subscription ftseFileCreated {
  result: ftseFileCreated {
    ...FtseDetails
  }
}
    ${$00d97f6f0e186a01$export$eab67a80655f45e8}`;
function $00d97f6f0e186a01$export$664db6aae072c044(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$6c29a4c3b41431f7, options);
}
const $00d97f6f0e186a01$export$cea3cccb2a0db1e2 = (0, $cwNRj.gql)`
    subscription ftseFileUpdated {
  result: ftseFileUpdated {
    ...FtseDetails
  }
}
    ${$00d97f6f0e186a01$export$eab67a80655f45e8}`;
function $00d97f6f0e186a01$export$2f3b2766e4269b4d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$cea3cccb2a0db1e2, options);
}
const $00d97f6f0e186a01$export$11e7193b526b2c6b = (0, $cwNRj.gql)`
    subscription ftseConfigurationUpdated {
  result: ftseConfigurationUpdated {
    ...FtseConfigurationDetails
  }
}
    ${$00d97f6f0e186a01$export$88d96b3ce3ff91a4}`;
function $00d97f6f0e186a01$export$a3c293a6630df2d5(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$11e7193b526b2c6b, options);
}
const $00d97f6f0e186a01$export$94fa8fcde80c312d = (0, $cwNRj.gql)`
    subscription ftseFileDeleted {
  result: ftseFileDeleted {
    ...FtseDetails
  }
}
    ${$00d97f6f0e186a01$export$eab67a80655f45e8}`;
function $00d97f6f0e186a01$export$8bbe34b14544d839(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$94fa8fcde80c312d, options);
}
const $00d97f6f0e186a01$export$fa06f9dfa31f7df6 = (0, $cwNRj.gql)`
    query getFxData {
  result: getFxData {
    ...FtseFxDetails
  }
}
    ${$00d97f6f0e186a01$export$21bc218bb28f6f06}`;
function $00d97f6f0e186a01$export$b6c1fca476a1d237(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$fa06f9dfa31f7df6, options);
}
function $00d97f6f0e186a01$export$6e4af13cc02383c5(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$fa06f9dfa31f7df6, options);
}
const $00d97f6f0e186a01$export$dd27b5da800ac7d9 = (0, $cwNRj.gql)`
    query getLatestFxData($date: String) {
  result: getLatestFxData(date: $date) {
    ...FtseFxDetails
  }
}
    ${$00d97f6f0e186a01$export$21bc218bb28f6f06}`;
function $00d97f6f0e186a01$export$d6306da64902f737(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$dd27b5da800ac7d9, options);
}
function $00d97f6f0e186a01$export$a3f909b7845dbc67(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$dd27b5da800ac7d9, options);
}
const $00d97f6f0e186a01$export$b34c80f87ad8016e = (0, $cwNRj.gql)`
    query getHistoryAllocationCountries($stock_id: Int!) {
  result: getHistoryAllocationCountries(stock_id: $stock_id) {
    ...HistoryAllocationCountryDetails
  }
}
    ${$00d97f6f0e186a01$export$741694164477991}`;
function $00d97f6f0e186a01$export$fbdb3958f2df0a0(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$b34c80f87ad8016e, options);
}
function $00d97f6f0e186a01$export$898c9c4cd68193c4(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$b34c80f87ad8016e, options);
}
const $00d97f6f0e186a01$export$b0ae27fba7179ff4 = (0, $cwNRj.gql)`
    mutation createAllocationCountry($stock_id: ID!, $input: AllocationCountryInput!) {
  result: createAllocationCountry(stock_id: $stock_id, input: $input) {
    ...HistoryAllocationCountryDetails
  }
}
    ${$00d97f6f0e186a01$export$741694164477991}`;
function $00d97f6f0e186a01$export$84228c29c0adcf9f(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$b0ae27fba7179ff4, options);
}
const $00d97f6f0e186a01$export$a195a7825e3d8c00 = (0, $cwNRj.gql)`
    mutation updateAllocationCountry($id: ID!, $input: AllocationCountryInput!) {
  result: updateAllocationCountry(id: $id, input: $input) {
    ...HistoryAllocationCountryDetails
  }
}
    ${$00d97f6f0e186a01$export$741694164477991}`;
function $00d97f6f0e186a01$export$1bf85f06d0a02fb8(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$a195a7825e3d8c00, options);
}
const $00d97f6f0e186a01$export$bc9204aff0863c5 = (0, $cwNRj.gql)`
    mutation deleteAllocationCountry($id: ID!) {
  result: deleteAllocationCountry(id: $id)
}
    `;
function $00d97f6f0e186a01$export$d4a9e2da13045083(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$bc9204aff0863c5, options);
}
const $00d97f6f0e186a01$export$6bd706a149046b0e = (0, $cwNRj.gql)`
    subscription allocationCountryCreated($stock_id: ID!) {
  result: allocationCountryCreated(stock_id: $stock_id) {
    ...HistoryAllocationCountryDetails
  }
}
    ${$00d97f6f0e186a01$export$741694164477991}`;
function $00d97f6f0e186a01$export$fa40a5ee96584435(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$6bd706a149046b0e, options);
}
const $00d97f6f0e186a01$export$6fb6098f45e51374 = (0, $cwNRj.gql)`
    subscription allocationCountryUpdated($stock_id: ID!) {
  result: allocationCountryUpdated(stock_id: $stock_id) {
    ...HistoryAllocationCountryDetails
  }
}
    ${$00d97f6f0e186a01$export$741694164477991}`;
function $00d97f6f0e186a01$export$5a1d447550e9bc43(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$6fb6098f45e51374, options);
}
const $00d97f6f0e186a01$export$3170d3dd88fded77 = (0, $cwNRj.gql)`
    subscription allocationCountryDeleted($stock_id: ID!) {
  result: allocationCountryDeleted(stock_id: $stock_id) {
    ...HistoryAllocationCountryDetails
  }
}
    ${$00d97f6f0e186a01$export$741694164477991}`;
function $00d97f6f0e186a01$export$22fc559b83592be9(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$3170d3dd88fded77, options);
}
const $00d97f6f0e186a01$export$6c2f773b53b6bcfc = (0, $cwNRj.gql)`
    query getHistoryAwards($stock_id: Int!) {
  result: getHistoryAwards(stock_id: $stock_id) {
    ...HistoryAwardDetails
  }
}
    ${$00d97f6f0e186a01$export$58f8b1230d63a6ea}`;
function $00d97f6f0e186a01$export$43d0b5079c27daf8(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$6c2f773b53b6bcfc, options);
}
function $00d97f6f0e186a01$export$ffab6fa043d9aecd(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$6c2f773b53b6bcfc, options);
}
const $00d97f6f0e186a01$export$7d6758d4fc1c9aaa = (0, $cwNRj.gql)`
    query getAwardTypes {
  result: getAwardTypes {
    id
    name
  }
}
    `;
function $00d97f6f0e186a01$export$f2c09acdbbe18ab4(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$7d6758d4fc1c9aaa, options);
}
function $00d97f6f0e186a01$export$6ab50b8098584f5d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$7d6758d4fc1c9aaa, options);
}
const $00d97f6f0e186a01$export$52f626371f8c465c = (0, $cwNRj.gql)`
    mutation createAward($stock_id: ID!, $input: AwardInput!) {
  result: createAward(stock_id: $stock_id, input: $input) {
    ...HistoryAwardDetails
  }
}
    ${$00d97f6f0e186a01$export$58f8b1230d63a6ea}`;
function $00d97f6f0e186a01$export$7d8f9790a518858e(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$52f626371f8c465c, options);
}
const $00d97f6f0e186a01$export$84af36ba9ecb7194 = (0, $cwNRj.gql)`
    mutation updateAward($id: ID!, $input: AwardInput!) {
  result: updateAward(id: $id, input: $input) {
    ...HistoryAwardDetails
  }
}
    ${$00d97f6f0e186a01$export$58f8b1230d63a6ea}`;
function $00d97f6f0e186a01$export$74e92962de4bbe97(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$84af36ba9ecb7194, options);
}
const $00d97f6f0e186a01$export$a874fabdd04e547c = (0, $cwNRj.gql)`
    mutation deleteAward($id: ID!) {
  result: deleteAward(id: $id)
}
    `;
function $00d97f6f0e186a01$export$bf5ab944176c55be(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$a874fabdd04e547c, options);
}
const $00d97f6f0e186a01$export$5b92bf67fb00ae93 = (0, $cwNRj.gql)`
    subscription awardCreated($stock_id: ID!) {
  result: awardCreated(stock_id: $stock_id) {
    ...HistoryAwardDetails
  }
}
    ${$00d97f6f0e186a01$export$58f8b1230d63a6ea}`;
function $00d97f6f0e186a01$export$2abd0de3705b7141(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$5b92bf67fb00ae93, options);
}
const $00d97f6f0e186a01$export$b72dec13ff60bad6 = (0, $cwNRj.gql)`
    subscription awardUpdated($stock_id: ID!) {
  result: awardUpdated(stock_id: $stock_id) {
    ...HistoryAwardDetails
  }
}
    ${$00d97f6f0e186a01$export$58f8b1230d63a6ea}`;
function $00d97f6f0e186a01$export$3ef792d6d4638beb(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$b72dec13ff60bad6, options);
}
const $00d97f6f0e186a01$export$b7e9fb99666cad = (0, $cwNRj.gql)`
    subscription awardDeleted($stock_id: ID!) {
  result: awardDeleted(stock_id: $stock_id) {
    ...HistoryAwardDetails
  }
}
    ${$00d97f6f0e186a01$export$58f8b1230d63a6ea}`;
function $00d97f6f0e186a01$export$fdeaa2e0ac266062(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$b7e9fb99666cad, options);
}
const $00d97f6f0e186a01$export$aa99987da1462b7b = (0, $cwNRj.gql)`
    query getHistoryConstituents($stock_id: Int!, $date: String) {
  result: getHistoryConstituents(stock_id: $stock_id, date: $date) {
    id
    weight_perc
    date
    index {
      id
      name
    }
    history_index {
      id
      dividend_yield
    }
    rank
  }
}
    `;
function $00d97f6f0e186a01$export$e035777d885272dd(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$aa99987da1462b7b, options);
}
function $00d97f6f0e186a01$export$852b7b2dc7bc531f(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$aa99987da1462b7b, options);
}
const $00d97f6f0e186a01$export$307a58de735f9125 = (0, $cwNRj.gql)`
    query getHistoryConstituentsByIndex($index_id: Int!, $date: String) {
  result: getHistoryConstituentsByIndex(index_id: $index_id, date: $date) {
    ...HistoryConstituentDetails
  }
}
    ${$00d97f6f0e186a01$export$490cd67d0d1b1483}`;
function $00d97f6f0e186a01$export$ef62c5513ddb1d5a(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$307a58de735f9125, options);
}
function $00d97f6f0e186a01$export$b84f923b9e32fb01(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$307a58de735f9125, options);
}
const $00d97f6f0e186a01$export$328f10deb395d27b = (0, $cwNRj.gql)`
    query getHistoryKpis($stock_id: Int!) {
  result: historyKpis(stock_id: $stock_id) {
    ...HistoryKpiDetails
  }
}
    ${$00d97f6f0e186a01$export$438604d7d904e8df}`;
function $00d97f6f0e186a01$export$74ab90aa145689db(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$328f10deb395d27b, options);
}
function $00d97f6f0e186a01$export$4b68d4cccdc88a52(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$328f10deb395d27b, options);
}
const $00d97f6f0e186a01$export$8424c5ae1b434f10 = (0, $cwNRj.gql)`
    mutation createKpi($stock_id: ID!, $input: KpiInput!) {
  result: createKpi(stock_id: $stock_id, input: $input) {
    ...HistoryKpiDetails
  }
}
    ${$00d97f6f0e186a01$export$438604d7d904e8df}`;
function $00d97f6f0e186a01$export$fa8cbc2cf2ef2942(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$8424c5ae1b434f10, options);
}
const $00d97f6f0e186a01$export$6c2f6a24190dd59a = (0, $cwNRj.gql)`
    mutation updateKpi($id: ID!, $input: KpiInput!) {
  result: updateKpi(id: $id, input: $input) {
    ...HistoryKpiDetails
  }
}
    ${$00d97f6f0e186a01$export$438604d7d904e8df}`;
function $00d97f6f0e186a01$export$18cc6c59969b5ab1(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$6c2f6a24190dd59a, options);
}
const $00d97f6f0e186a01$export$a02c2ef6a2de972 = (0, $cwNRj.gql)`
    mutation deleteKpi($id: ID!) {
  return: deleteKpi(id: $id)
}
    `;
function $00d97f6f0e186a01$export$1351df3c97550e47(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$a02c2ef6a2de972, options);
}
const $00d97f6f0e186a01$export$bab876c184d5326 = (0, $cwNRj.gql)`
    subscription kpiCreated($stock_id: ID!) {
  result: kpiCreated(stock_id: $stock_id) {
    ...HistoryKpiDetails
  }
}
    ${$00d97f6f0e186a01$export$438604d7d904e8df}`;
function $00d97f6f0e186a01$export$59e9bc4c65a91f11(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$bab876c184d5326, options);
}
const $00d97f6f0e186a01$export$143f1d205a306bbe = (0, $cwNRj.gql)`
    subscription kpiUpdated($stock_id: ID!) {
  result: kpiUpdated(stock_id: $stock_id) {
    ...HistoryKpiDetails
  }
}
    ${$00d97f6f0e186a01$export$438604d7d904e8df}`;
function $00d97f6f0e186a01$export$e56860371ea92b7f(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$143f1d205a306bbe, options);
}
const $00d97f6f0e186a01$export$4ba2bbd56525e72e = (0, $cwNRj.gql)`
    subscription kpiDeleted($stock_id: ID!) {
  result: kpiDeleted(stock_id: $stock_id) {
    ...HistoryKpiDetails
  }
}
    ${$00d97f6f0e186a01$export$438604d7d904e8df}`;
function $00d97f6f0e186a01$export$46fc175d81ab2bdd(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$4ba2bbd56525e72e, options);
}
const $00d97f6f0e186a01$export$8b08543f0806bd18 = (0, $cwNRj.gql)`
    query getHistoryLtvs($stock_id: Int!) {
  result: getHistoryLtvs(stock_id: $stock_id) {
    ...HistoryLtvDetails
  }
}
    ${$00d97f6f0e186a01$export$edaf0cc1d443e75}`;
function $00d97f6f0e186a01$export$17036708e4202907(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$8b08543f0806bd18, options);
}
function $00d97f6f0e186a01$export$813c0e84b3cad8cb(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$8b08543f0806bd18, options);
}
const $00d97f6f0e186a01$export$9f094b145edf1b5a = (0, $cwNRj.gql)`
    mutation createLtv($stock_id: ID!, $input: LtvInput!) {
  result: createLtv(stock_id: $stock_id, input: $input) {
    ...HistoryLtvDetails
  }
}
    ${$00d97f6f0e186a01$export$edaf0cc1d443e75}`;
function $00d97f6f0e186a01$export$c552f006ee5724a0(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$9f094b145edf1b5a, options);
}
const $00d97f6f0e186a01$export$5d535b878266b0e7 = (0, $cwNRj.gql)`
    mutation updateLtv($id: ID!, $input: LtvInput!) {
  result: updateLtv(id: $id, input: $input) {
    ...HistoryLtvDetails
  }
}
    ${$00d97f6f0e186a01$export$edaf0cc1d443e75}`;
function $00d97f6f0e186a01$export$dac975094093afb6(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$5d535b878266b0e7, options);
}
const $00d97f6f0e186a01$export$14b4b61e48a89a79 = (0, $cwNRj.gql)`
    mutation deleteLtv($id: ID!) {
  result: deleteLtv(id: $id)
}
    `;
function $00d97f6f0e186a01$export$7af9b7ae2cd8dd0(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$14b4b61e48a89a79, options);
}
const $00d97f6f0e186a01$export$d0c4113656423fc6 = (0, $cwNRj.gql)`
    subscription ltvCreated($stock_id: ID!) {
  result: ltvCreated(stock_id: $stock_id) {
    ...HistoryLtvDetails
  }
}
    ${$00d97f6f0e186a01$export$edaf0cc1d443e75}`;
function $00d97f6f0e186a01$export$93721d97a530041d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$d0c4113656423fc6, options);
}
const $00d97f6f0e186a01$export$47562e24951d28c1 = (0, $cwNRj.gql)`
    subscription ltvUpdated($stock_id: ID!) {
  result: ltvUpdated(stock_id: $stock_id) {
    ...HistoryLtvDetails
  }
}
    ${$00d97f6f0e186a01$export$edaf0cc1d443e75}`;
function $00d97f6f0e186a01$export$3c621b94beddb1bb(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$47562e24951d28c1, options);
}
const $00d97f6f0e186a01$export$d11b0f1f7612850d = (0, $cwNRj.gql)`
    subscription ltvDeleted($stock_id: ID!) {
  result: ltvDeleted(stock_id: $stock_id) {
    ...HistoryLtvDetails
  }
}
    ${$00d97f6f0e186a01$export$edaf0cc1d443e75}`;
function $00d97f6f0e186a01$export$35cb9480e8d6a264(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$d11b0f1f7612850d, options);
}
const $00d97f6f0e186a01$export$122263b734f68e7e = (0, $cwNRj.gql)`
    query getHistoryRecalcs($stock_id: Int!) {
  result: getHistoryRecalcs(stock_id: $stock_id) {
    ...HistoryRecalcDetails
  }
}
    ${$00d97f6f0e186a01$export$4a84cfbf9d8b7ff4}`;
function $00d97f6f0e186a01$export$a1f6070305f31784(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$122263b734f68e7e, options);
}
function $00d97f6f0e186a01$export$6438ebeaf8b9f48b(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$122263b734f68e7e, options);
}
const $00d97f6f0e186a01$export$fa5eb3d1f44c3929 = (0, $cwNRj.gql)`
    query getRecalcOperators {
  result: getRecalcOperators {
    id
    value
  }
}
    `;
function $00d97f6f0e186a01$export$d2c5da6f0019bcac(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$fa5eb3d1f44c3929, options);
}
function $00d97f6f0e186a01$export$7bf475f44d4e7967(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$fa5eb3d1f44c3929, options);
}
const $00d97f6f0e186a01$export$ad06f443bde0c1aa = (0, $cwNRj.gql)`
    mutation createHistoryRecalc($stock_id: ID!, $input: HistoryRecalcInput!) {
  result: createHistoryRecalc(stock_id: $stock_id, input: $input) {
    ...HistoryRecalcDetails
  }
}
    ${$00d97f6f0e186a01$export$4a84cfbf9d8b7ff4}`;
function $00d97f6f0e186a01$export$eb57b7cf9e4742fc(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$ad06f443bde0c1aa, options);
}
const $00d97f6f0e186a01$export$f0bcb5eea335623d = (0, $cwNRj.gql)`
    mutation recalcRollback($id: ID!) {
  result: recalcRollback(id: $id) {
    ...HistoryRecalcDetails
  }
}
    ${$00d97f6f0e186a01$export$4a84cfbf9d8b7ff4}`;
function $00d97f6f0e186a01$export$3e28bd2e2e7103ce(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$f0bcb5eea335623d, options);
}
const $00d97f6f0e186a01$export$7a3abfdfa4560dc = (0, $cwNRj.gql)`
    mutation updateHistoryRecalc($id: ID!, $stock_id: ID!, $input: HistoryRecalcInput!) {
  result: updateHistoryRecalc(id: $id, stock_id: $stock_id, input: $input) {
    ...HistoryRecalcDetails
  }
}
    ${$00d97f6f0e186a01$export$4a84cfbf9d8b7ff4}`;
function $00d97f6f0e186a01$export$90a707bd8108b5ff(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$7a3abfdfa4560dc, options);
}
const $00d97f6f0e186a01$export$1d8d7e839df94f7a = (0, $cwNRj.gql)`
    subscription historyRecalcCreated($stock_id: ID!) {
  result: historyRecalcCreated(stock_id: $stock_id) {
    ...HistoryRecalcDetails
  }
}
    ${$00d97f6f0e186a01$export$4a84cfbf9d8b7ff4}`;
function $00d97f6f0e186a01$export$acaf1c0bf24e385d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$1d8d7e839df94f7a, options);
}
const $00d97f6f0e186a01$export$487540c05b69804e = (0, $cwNRj.gql)`
    subscription historyRecalcUpdated($stock_id: ID!) {
  result: historyRecalcUpdated(stock_id: $stock_id) {
    ...HistoryRecalcDetails
  }
}
    ${$00d97f6f0e186a01$export$4a84cfbf9d8b7ff4}`;
function $00d97f6f0e186a01$export$82e03c38c7a6f4ec(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$487540c05b69804e, options);
}
const $00d97f6f0e186a01$export$3d96807b97820b5f = (0, $cwNRj.gql)`
    query indexSeries {
  result: indexSeries {
    ...indexSeriesDetails
  }
}
    ${$00d97f6f0e186a01$export$b0aa95306257aa0e}`;
function $00d97f6f0e186a01$export$fa84934778d61bd0(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$3d96807b97820b5f, options);
}
function $00d97f6f0e186a01$export$bf1a5b93650d34e0(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$3d96807b97820b5f, options);
}
const $00d97f6f0e186a01$export$6eb6001b0e4985d = (0, $cwNRj.gql)`
    mutation deleteIndexSerie($id: ID!) {
  result: deleteIndexSerie(id: $id)
}
    `;
function $00d97f6f0e186a01$export$cf8502d0d3d1ed7a(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$6eb6001b0e4985d, options);
}
const $00d97f6f0e186a01$export$6f28dec7b3d24117 = (0, $cwNRj.gql)`
    mutation createIndexSerie($input: IndexSerieInput!) {
  result: createIndexSerie(input: $input) {
    ...indexSeriesDetails
  }
}
    ${$00d97f6f0e186a01$export$b0aa95306257aa0e}`;
function $00d97f6f0e186a01$export$53b1a5820a101797(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$6f28dec7b3d24117, options);
}
const $00d97f6f0e186a01$export$bfd32c6483f69d78 = (0, $cwNRj.gql)`
    mutation updateIndexSerie($id: ID!, $input: IndexSerieInput!) {
  result: updateIndexSerie(id: $id, input: $input) {
    ...indexSeriesDetails
  }
}
    ${$00d97f6f0e186a01$export$b0aa95306257aa0e}`;
function $00d97f6f0e186a01$export$5030801834d393fb(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$bfd32c6483f69d78, options);
}
const $00d97f6f0e186a01$export$b49250f8e77c5ecf = (0, $cwNRj.gql)`
    subscription indexSerieDeleted {
  result: indexSerieDeleted {
    id
    name
  }
}
    `;
function $00d97f6f0e186a01$export$e0d1895253b440f(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$b49250f8e77c5ecf, options);
}
const $00d97f6f0e186a01$export$dc2d366e2e790cfb = (0, $cwNRj.gql)`
    subscription indexSerieCreated {
  result: indexSerieCreated {
    ...indexSeriesDetails
  }
}
    ${$00d97f6f0e186a01$export$b0aa95306257aa0e}`;
function $00d97f6f0e186a01$export$b450ae495a1fb754(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$dc2d366e2e790cfb, options);
}
const $00d97f6f0e186a01$export$762f0528551aed44 = (0, $cwNRj.gql)`
    subscription indexSerieUpdated {
  result: indexSerieUpdated {
    ...indexSeriesDetails
  }
}
    ${$00d97f6f0e186a01$export$b0aa95306257aa0e}`;
function $00d97f6f0e186a01$export$665426d12c6e62b6(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$762f0528551aed44, options);
}
const $00d97f6f0e186a01$export$64d0ca6328b6b1cf = (0, $cwNRj.gql)`
    query indices {
  result: indices {
    ...IndiceDetails
  }
}
    ${$00d97f6f0e186a01$export$7adf6aa5121db3ba}`;
function $00d97f6f0e186a01$export$d366e44db33b356b(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$64d0ca6328b6b1cf, options);
}
function $00d97f6f0e186a01$export$8fd4213725f790f3(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$64d0ca6328b6b1cf, options);
}
const $00d97f6f0e186a01$export$2d82c7221e1cde9b = (0, $cwNRj.gql)`
    mutation createIndex($input: IndexInput!) {
  result: createIndex(input: $input) {
    ...IndiceDetails
  }
}
    ${$00d97f6f0e186a01$export$7adf6aa5121db3ba}`;
function $00d97f6f0e186a01$export$b7d54083d7b8fd97(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$2d82c7221e1cde9b, options);
}
const $00d97f6f0e186a01$export$b94baf0a798447b7 = (0, $cwNRj.gql)`
    mutation deleteIndex($id: ID!) {
  result: deleteIndex(id: $id)
}
    `;
function $00d97f6f0e186a01$export$9aa401bb339c7ecd(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$b94baf0a798447b7, options);
}
const $00d97f6f0e186a01$export$22719dd64b283ee6 = (0, $cwNRj.gql)`
    mutation updateIndex($id: ID!, $input: IndexInput!) {
  result: updateIndex(id: $id, input: $input) {
    ...IndiceDetails
  }
}
    ${$00d97f6f0e186a01$export$7adf6aa5121db3ba}`;
function $00d97f6f0e186a01$export$b84a905039363cbb(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$22719dd64b283ee6, options);
}
const $00d97f6f0e186a01$export$31c47f1416aaeb2b = (0, $cwNRj.gql)`
    subscription indexCreated {
  result: indexCreated {
    ...IndiceDetails
  }
}
    ${$00d97f6f0e186a01$export$7adf6aa5121db3ba}`;
function $00d97f6f0e186a01$export$f00959f982677bc9(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$31c47f1416aaeb2b, options);
}
const $00d97f6f0e186a01$export$5ade27463387cfd4 = (0, $cwNRj.gql)`
    subscription indexDeleted {
  result: indexDeleted {
    ...IndiceDetails
  }
}
    ${$00d97f6f0e186a01$export$7adf6aa5121db3ba}`;
function $00d97f6f0e186a01$export$e2ae948504034d2(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$5ade27463387cfd4, options);
}
const $00d97f6f0e186a01$export$2210847d4c6bbde6 = (0, $cwNRj.gql)`
    subscription indexUpdated {
  result: indexUpdated {
    ...IndiceDetails
  }
}
    ${$00d97f6f0e186a01$export$7adf6aa5121db3ba}`;
function $00d97f6f0e186a01$export$45782f55c255d50f(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$2210847d4c6bbde6, options);
}
const $00d97f6f0e186a01$export$879d22849d084a6d = (0, $cwNRj.gql)`
    query getInterestGroups {
  result: interestGroups {
    id
    name
    interests {
      name
      id
    }
  }
}
    `;
function $00d97f6f0e186a01$export$bfb5c18a763c143d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$879d22849d084a6d, options);
}
function $00d97f6f0e186a01$export$b752df7f8917906c(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$879d22849d084a6d, options);
}
const $00d97f6f0e186a01$export$7b885e36959da3d = (0, $cwNRj.gql)`
    mutation addInterestToGroup($input: NewInterestInput!) {
  result: addInterestToGroup(input: $input) {
    id
    name
  }
}
    `;
function $00d97f6f0e186a01$export$c1fe6cc74da09bf0(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$7b885e36959da3d, options);
}
const $00d97f6f0e186a01$export$98c57752dfba336b = (0, $cwNRj.gql)`
    mutation deleteInterest($id: Int!) {
  result: deleteInterest(id: $id)
}
    `;
function $00d97f6f0e186a01$export$33fe92a210a94b9d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$98c57752dfba336b, options);
}
const $00d97f6f0e186a01$export$70d57c6f9045db74 = (0, $cwNRj.gql)`
    subscription InterestDeleted {
  result: interestDeleted {
    id
    interest_group {
      id
    }
  }
}
    `;
function $00d97f6f0e186a01$export$fd62661b2284a712(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$70d57c6f9045db74, options);
}
const $00d97f6f0e186a01$export$4319bfbc58c6bb2e = (0, $cwNRj.gql)`
    query getInterests {
  result: interests {
    id
    name
    interest_group {
      id
    }
  }
}
    `;
function $00d97f6f0e186a01$export$678ba770cae0ed70(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$4319bfbc58c6bb2e, options);
}
function $00d97f6f0e186a01$export$113460bcfda3c523(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$4319bfbc58c6bb2e, options);
}
const $00d97f6f0e186a01$export$e8cd282acdb501c0 = (0, $cwNRj.gql)`
    query investmentFocuses {
  result: investmentFocuses {
    id
    name
  }
}
    `;
function $00d97f6f0e186a01$export$74fde999ec163b47(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$e8cd282acdb501c0, options);
}
function $00d97f6f0e186a01$export$7745dde5751e4450(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$e8cd282acdb501c0, options);
}
const $00d97f6f0e186a01$export$dae0cd87f0edc979 = (0, $cwNRj.gql)`
    query invoicesForMembership($membership_id: Int!) {
  result: invoicesForMembership(membership_id: $membership_id) {
    ...InvoiceDtoFull
  }
}
    ${$00d97f6f0e186a01$export$7bc87ff5408ebfce}`;
function $00d97f6f0e186a01$export$2850e1d1b57047fa(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$dae0cd87f0edc979, options);
}
function $00d97f6f0e186a01$export$2f7a854b947b4948(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$dae0cd87f0edc979, options);
}
const $00d97f6f0e186a01$export$7f07e1c830f66920 = (0, $cwNRj.gql)`
    query invoices {
  result: invoices {
    ...InvoiceDtoFull
  }
}
    ${$00d97f6f0e186a01$export$7bc87ff5408ebfce}`;
function $00d97f6f0e186a01$export$be1851eeb01b87b0(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$7f07e1c830f66920, options);
}
function $00d97f6f0e186a01$export$cd82e55942e985d8(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$7f07e1c830f66920, options);
}
const $00d97f6f0e186a01$export$f7933fb9f24d196 = (0, $cwNRj.gql)`
    query invoicesFiltered($filter: InvoiceFilterInput) {
  result: invoicesFiltered(filter: $filter) {
    invoices {
      ...InvoiceDtoFull
    }
    total
  }
}
    ${$00d97f6f0e186a01$export$7bc87ff5408ebfce}`;
function $00d97f6f0e186a01$export$9c52f7b788a2b940(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$f7933fb9f24d196, options);
}
function $00d97f6f0e186a01$export$4db0382bcea66fb8(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$f7933fb9f24d196, options);
}
const $00d97f6f0e186a01$export$fbc972d6231cc3b1 = (0, $cwNRj.gql)`
    query invoiceClientOptions($membership_id: Int!) {
  result: invoiceClientOptions(membership_id: $membership_id) {
    companies {
      id
      name
      main_address {
        id
        complete_vat_number
      }
    }
    contacts {
      id
      fullName
      first_name
      last_name
      email
      title_external
      prefix
      address {
        id
        name
        street
        city
        zip
        country {
          id
          name
          region {
            id
            name
          }
        }
      }
      company {
        id
        name
        main_address {
          id
          complete_vat_number
        }
      }
    }
  }
}
    `;
function $00d97f6f0e186a01$export$8301646daac75ba8(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$fbc972d6231cc3b1, options);
}
function $00d97f6f0e186a01$export$89d6e8dd3997e505(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$fbc972d6231cc3b1, options);
}
const $00d97f6f0e186a01$export$cbfcb2a4d19fb56e = (0, $cwNRj.gql)`
    query paymentDetails($id: Int) {
  result: paymentDetails(id: $id) {
    ...PaymentDetails
  }
}
    ${$00d97f6f0e186a01$export$8b686b21c1301b53}`;
function $00d97f6f0e186a01$export$dba7c0249afdeeaa(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$cbfcb2a4d19fb56e, options);
}
function $00d97f6f0e186a01$export$408f32d90d710888(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$cbfcb2a4d19fb56e, options);
}
const $00d97f6f0e186a01$export$417971753a16e487 = (0, $cwNRj.gql)`
    mutation addPaymentDetails($input: NewPaymentDetailsInput!) {
  result: createPaymentDetails(input: $input) {
    ...PaymentDetails
  }
}
    ${$00d97f6f0e186a01$export$8b686b21c1301b53}`;
function $00d97f6f0e186a01$export$4da9caba6b82a50f(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$417971753a16e487, options);
}
const $00d97f6f0e186a01$export$f4f6dff7424c836b = (0, $cwNRj.gql)`
    mutation deleteInvoice($id: Int!) {
  result: deleteInvoice(id: $id)
}
    `;
function $00d97f6f0e186a01$export$fa837f5905a8351b(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$f4f6dff7424c836b, options);
}
const $00d97f6f0e186a01$export$f0a0964356ed9061 = (0, $cwNRj.gql)`
    mutation payInvoice($id: Int!, $date_paid: String) {
  result: payInvoice(id: $id, date_paid: $date_paid) {
    ...InvoiceDtoFull
  }
}
    ${$00d97f6f0e186a01$export$7bc87ff5408ebfce}`;
function $00d97f6f0e186a01$export$e97623b65eeab7f6(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$f0a0964356ed9061, options);
}
const $00d97f6f0e186a01$export$b10d01a4b79e4b98 = (0, $cwNRj.gql)`
    mutation createInvoice($input: InvoiceInput!) {
  result: createInvoice(input: $input) {
    ...InvoiceDtoFull
  }
}
    ${$00d97f6f0e186a01$export$7bc87ff5408ebfce}`;
function $00d97f6f0e186a01$export$27ac8574606723ab(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$b10d01a4b79e4b98, options);
}
const $00d97f6f0e186a01$export$44d6c13db0f1a5b0 = (0, $cwNRj.gql)`
    mutation updateInvoice($id: Int!, $input: InvoiceInput!) {
  result: updateInvoice(id: $id, input: $input) {
    ...InvoiceDtoFull
  }
}
    ${$00d97f6f0e186a01$export$7bc87ff5408ebfce}`;
function $00d97f6f0e186a01$export$e0ecd277c9011226(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$44d6c13db0f1a5b0, options);
}
const $00d97f6f0e186a01$export$a35e8d2752f8fde4 = (0, $cwNRj.gql)`
    mutation createCreditNote($id: Int!) {
  result: createCreditNote(id: $id) {
    ...InvoiceDtoFull
  }
}
    ${$00d97f6f0e186a01$export$7bc87ff5408ebfce}`;
function $00d97f6f0e186a01$export$66f1c3849b5547d5(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$a35e8d2752f8fde4, options);
}
const $00d97f6f0e186a01$export$833fa19ddff2f12d = (0, $cwNRj.gql)`
    mutation confirmInvoice($id: Int!) {
  result: confirmInvoice(id: $id) {
    ...InvoiceDtoFull
  }
}
    ${$00d97f6f0e186a01$export$7bc87ff5408ebfce}`;
function $00d97f6f0e186a01$export$c8be67382b5dab1c(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$833fa19ddff2f12d, options);
}
const $00d97f6f0e186a01$export$73791d7cfef05a35 = (0, $cwNRj.gql)`
    subscription invoiceDeleted {
  result: invoiceDeleted {
    id
  }
}
    `;
function $00d97f6f0e186a01$export$b36f8522cf19520d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$73791d7cfef05a35, options);
}
const $00d97f6f0e186a01$export$beca3de72f465b9e = (0, $cwNRj.gql)`
    subscription invoiceUpdated {
  result: invoiceUpdated {
    ...InvoiceDtoFull
  }
}
    ${$00d97f6f0e186a01$export$7bc87ff5408ebfce}`;
function $00d97f6f0e186a01$export$e09ffcd06d9e4659(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$beca3de72f465b9e, options);
}
const $00d97f6f0e186a01$export$7c338f63b25e5eb0 = (0, $cwNRj.gql)`
    subscription invoiceCreated {
  result: invoiceCreated {
    ...InvoiceDtoFull
  }
}
    ${$00d97f6f0e186a01$export$7bc87ff5408ebfce}`;
function $00d97f6f0e186a01$export$5de8fb7c39a8f9d5(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$7c338f63b25e5eb0, options);
}
const $00d97f6f0e186a01$export$dddfbd4631c0b14f = (0, $cwNRj.gql)`
    mutation singin($input: SigninInput!) {
  result: signin(input: $input) {
    token
    user {
      id
      username
      roles
      first_name
      last_name
      password
    }
  }
}
    `;
function $00d97f6f0e186a01$export$1818c732788eb79b(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$dddfbd4631c0b14f, options);
}
const $00d97f6f0e186a01$export$ea8c5f3f452c7dcd = (0, $cwNRj.gql)`
    mutation sendInvoiceForApproval($id: Int!, $pdf_content: String!) {
  result: sendInvoiceForApproval(id: $id, pdf_content: $pdf_content)
}
    `;
function $00d97f6f0e186a01$export$ef7addfe1c61901(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$ea8c5f3f452c7dcd, options);
}
const $00d97f6f0e186a01$export$8e40b5c9fcc96bcd = (0, $cwNRj.gql)`
    mutation sendInvoiceToCustomer($id: Int!, $pdf_content: String!, $cc_emails: [String]) {
  result: sendInvoiceToCustomer(
    id: $id
    pdf_content: $pdf_content
    cc_emails: $cc_emails
  )
}
    `;
function $00d97f6f0e186a01$export$826b582162d880b1(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$8e40b5c9fcc96bcd, options);
}
const $00d97f6f0e186a01$export$544bae422c427ec1 = (0, $cwNRj.gql)`
    query marketActivities {
  result: marketActivities {
    id
    name
  }
}
    `;
function $00d97f6f0e186a01$export$6f6fccd9b686ad3a(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$544bae422c427ec1, options);
}
function $00d97f6f0e186a01$export$95c63529d0c24bdc(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$544bae422c427ec1, options);
}
const $00d97f6f0e186a01$export$371078b1afd73c80 = (0, $cwNRj.gql)`
    query meetingsMeetingType {
  result: meetingsMeetingType {
    ...MeetingsMeetingTypeDetails
  }
}
    ${$00d97f6f0e186a01$export$228700246cddc540}`;
function $00d97f6f0e186a01$export$91c770586b9c8a77(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$371078b1afd73c80, options);
}
function $00d97f6f0e186a01$export$1194f978eaf83cb3(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$371078b1afd73c80, options);
}
const $00d97f6f0e186a01$export$17be11849ea22011 = (0, $cwNRj.gql)`
    query getMeetingTypes {
  result: getMeetingTypes {
    ...MeetingsMeetingTypeDetails
  }
}
    ${$00d97f6f0e186a01$export$228700246cddc540}`;
function $00d97f6f0e186a01$export$c773cae8fd9148fc(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$17be11849ea22011, options);
}
function $00d97f6f0e186a01$export$3691f43bb928c7f(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$17be11849ea22011, options);
}
const $00d97f6f0e186a01$export$f7d85f1ff74e8ef9 = (0, $cwNRj.gql)`
    mutation createMeetingType($name: String!) {
  result: createMeetingType(name: $name) {
    ...MeetingsMeetingTypeDetails
  }
}
    ${$00d97f6f0e186a01$export$228700246cddc540}`;
function $00d97f6f0e186a01$export$c6b09494d3b40b91(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$f7d85f1ff74e8ef9, options);
}
const $00d97f6f0e186a01$export$65b22ded3df6d3be = (0, $cwNRj.gql)`
    mutation updateMeetingType($id: ID!, $name: String!) {
  result: updateMeetingType(id: $id, name: $name) {
    ...MeetingsMeetingTypeDetails
  }
}
    ${$00d97f6f0e186a01$export$228700246cddc540}`;
function $00d97f6f0e186a01$export$8ba6f7c8cd831f0(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$65b22ded3df6d3be, options);
}
const $00d97f6f0e186a01$export$e9832f6cd085e277 = (0, $cwNRj.gql)`
    mutation deleteMeetingType($id: ID!) {
  result: deleteMeetingType(id: $id)
}
    `;
function $00d97f6f0e186a01$export$87a4e58070b80f78(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$e9832f6cd085e277, options);
}
const $00d97f6f0e186a01$export$fa1ee9b509a2c063 = (0, $cwNRj.gql)`
    query meetings {
  result: meetings {
    ...MeetingDetails
  }
}
    ${$00d97f6f0e186a01$export$c278385bdf2bdb47}`;
function $00d97f6f0e186a01$export$7568619416422cf1(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$fa1ee9b509a2c063, options);
}
function $00d97f6f0e186a01$export$74cadba95755cec6(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$fa1ee9b509a2c063, options);
}
const $00d97f6f0e186a01$export$29a7d86b51c004bd = (0, $cwNRj.gql)`
    query meeting($id: Int!) {
  result: meeting(id: $id) {
    ...MeetingDetails
  }
}
    ${$00d97f6f0e186a01$export$c278385bdf2bdb47}`;
function $00d97f6f0e186a01$export$2f94150a3faeb5bc(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$29a7d86b51c004bd, options);
}
function $00d97f6f0e186a01$export$5e24c62bff9a82c5(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$29a7d86b51c004bd, options);
}
const $00d97f6f0e186a01$export$d7c9e3e2d74dcdf8 = (0, $cwNRj.gql)`
    query allMeetingsForContact($contact_id: Int!) {
  result: allMeetingsForContact(contact_id: $contact_id) {
    ...MeetingDetails
  }
}
    ${$00d97f6f0e186a01$export$c278385bdf2bdb47}`;
function $00d97f6f0e186a01$export$d00126cd38837751(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$d7c9e3e2d74dcdf8, options);
}
function $00d97f6f0e186a01$export$577c8c068f26f8f9(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$d7c9e3e2d74dcdf8, options);
}
const $00d97f6f0e186a01$export$cb9fafddce062ac9 = (0, $cwNRj.gql)`
    query meetingsFiltered($filter: MeetingFilterInput) {
  result: meetingsFiltered(filter: $filter) {
    meetings {
      ...MeetingDetails
    }
    total
  }
}
    ${$00d97f6f0e186a01$export$c278385bdf2bdb47}`;
function $00d97f6f0e186a01$export$520e6447ff0b372c(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$cb9fafddce062ac9, options);
}
function $00d97f6f0e186a01$export$d3b3c987dc5eb9ae(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$cb9fafddce062ac9, options);
}
const $00d97f6f0e186a01$export$b302dc24dde45630 = (0, $cwNRj.gql)`
    mutation createMeeting($input: AddMeetingInput!) {
  result: createMeeting(input: $input) {
    id
    name
  }
}
    `;
function $00d97f6f0e186a01$export$e42e06cb075a5b93(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$b302dc24dde45630, options);
}
const $00d97f6f0e186a01$export$c72187c566d55831 = (0, $cwNRj.gql)`
    mutation updateMeeting($id: ID!, $input: AddMeetingInput!) {
  result: updateMeeting(id: $id, input: $input) {
    id
    name
  }
}
    `;
function $00d97f6f0e186a01$export$601199388383f903(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$c72187c566d55831, options);
}
const $00d97f6f0e186a01$export$bb5c68b49dc5336d = (0, $cwNRj.gql)`
    mutation deleteMeeting($id: ID!) {
  result: deleteMeeting(id: $id)
}
    `;
function $00d97f6f0e186a01$export$6714ee0b7598692d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$bb5c68b49dc5336d, options);
}
const $00d97f6f0e186a01$export$e395b631ffb51d39 = (0, $cwNRj.gql)`
    subscription meetingCreated {
  result: meetingCreated {
    ...MeetingDetails
  }
}
    ${$00d97f6f0e186a01$export$c278385bdf2bdb47}`;
function $00d97f6f0e186a01$export$823f49c0b4e1d185(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$e395b631ffb51d39, options);
}
const $00d97f6f0e186a01$export$597a051a8ba926d4 = (0, $cwNRj.gql)`
    subscription meetingUpdated {
  result: meetingUpdated {
    ...MeetingDetails
  }
}
    ${$00d97f6f0e186a01$export$c278385bdf2bdb47}`;
function $00d97f6f0e186a01$export$cf43db5de81e2780(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$597a051a8ba926d4, options);
}
const $00d97f6f0e186a01$export$91f3c738195ca4a4 = (0, $cwNRj.gql)`
    subscription meetingDeleted {
  result: meetingDeleted {
    ...MeetingDetails
  }
}
    ${$00d97f6f0e186a01$export$c278385bdf2bdb47}`;
function $00d97f6f0e186a01$export$dc9137be82916959(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$91f3c738195ca4a4, options);
}
const $00d97f6f0e186a01$export$bc0dc4b4d8495bef = (0, $cwNRj.gql)`
    query membershipTypes {
  result: membershipTypes {
    id
    name
  }
}
    `;
function $00d97f6f0e186a01$export$3a029e1998613bf9(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$bc0dc4b4d8495bef, options);
}
function $00d97f6f0e186a01$export$ccbf9bc225cba63c(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$bc0dc4b4d8495bef, options);
}
const $00d97f6f0e186a01$export$c958065228ef6751 = (0, $cwNRj.gql)`
    query memberships {
  result: memberships {
    ...MembershipOverview
  }
}
    ${$00d97f6f0e186a01$export$4c49b749d3f62a21}`;
function $00d97f6f0e186a01$export$896b15c4ea6f87fa(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$c958065228ef6751, options);
}
function $00d97f6f0e186a01$export$8ba7138828e176be(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$c958065228ef6751, options);
}
const $00d97f6f0e186a01$export$4cbb3c0286e4bc73 = (0, $cwNRj.gql)`
    query membershipsFiltered($filter: MembershipFilterInput) {
  result: membershipsFiltered(filter: $filter) {
    total
    memberships {
      ...MembershipOverview
    }
  }
}
    ${$00d97f6f0e186a01$export$4c49b749d3f62a21}`;
function $00d97f6f0e186a01$export$4c5d63aeee13befa(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$4cbb3c0286e4bc73, options);
}
function $00d97f6f0e186a01$export$666f3eba04b42893(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$4cbb3c0286e4bc73, options);
}
const $00d97f6f0e186a01$export$81e81fa1592bea9b = (0, $cwNRj.gql)`
    query membership($id: Int!) {
  result: membership(id: $id) {
    ...MembershipDetails
  }
}
    ${$00d97f6f0e186a01$export$25f96825690302a3}`;
function $00d97f6f0e186a01$export$826cc983ec8893c4(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$81e81fa1592bea9b, options);
}
function $00d97f6f0e186a01$export$565847116d583af8(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$81e81fa1592bea9b, options);
}
const $00d97f6f0e186a01$export$7ca9c6dc936339af = (0, $cwNRj.gql)`
    query membershipCompanies($membership_id: Int!) {
  result: membershipCompanies(membership_id: $membership_id) {
    id
    name
    is_main_member
    main_address {
      id
      street
      city
      country {
        id
        name
      }
    }
  }
}
    `;
function $00d97f6f0e186a01$export$7f242fc6dc8ed2dc(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$7ca9c6dc936339af, options);
}
function $00d97f6f0e186a01$export$3290276ff76c605b(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$7ca9c6dc936339af, options);
}
const $00d97f6f0e186a01$export$e931d8d764f01fe6 = (0, $cwNRj.gql)`
    query membershipTypeOptions {
  result: membershipTypeOptions {
    membership_types {
      id
      name
    }
    taken_option_ids
  }
}
    `;
function $00d97f6f0e186a01$export$e5a203b33eaaba47(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$e931d8d764f01fe6, options);
}
function $00d97f6f0e186a01$export$c08096db09beeda8(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$e931d8d764f01fe6, options);
}
const $00d97f6f0e186a01$export$a53f5c1df410eed6 = (0, $cwNRj.gql)`
    query membershipContacts($id: Int!) {
  result: membershipContacts(id: $id) {
    id
    is_main
    fullName
    email
    titleInternal {
      id
      name
    }
    address {
      id
      street
    }
    company {
      id
      name
    }
  }
}
    `;
function $00d97f6f0e186a01$export$e2231e66afd9ab3d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$a53f5c1df410eed6, options);
}
function $00d97f6f0e186a01$export$648ad556eac72556(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$a53f5c1df410eed6, options);
}
const $00d97f6f0e186a01$export$f415e9557d7e509b = (0, $cwNRj.gql)`
    mutation createMembership($input: MembershipInput!) {
  result: createMembership(input: $input) {
    ...MembershipOverview
  }
}
    ${$00d97f6f0e186a01$export$4c49b749d3f62a21}`;
function $00d97f6f0e186a01$export$cfd2bb20c23f9640(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$f415e9557d7e509b, options);
}
const $00d97f6f0e186a01$export$fd14fb4dfaf28f3 = (0, $cwNRj.gql)`
    mutation updateMembership($id: Int!, $input: MembershipInput!) {
  result: updateMembership(id: $id, input: $input) {
    ...MembershipOverview
  }
}
    ${$00d97f6f0e186a01$export$4c49b749d3f62a21}`;
function $00d97f6f0e186a01$export$ff83b3bdca2bca42(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$fd14fb4dfaf28f3, options);
}
const $00d97f6f0e186a01$export$bbfc35b1fb7e6c7c = (0, $cwNRj.gql)`
    mutation deleteMembership($id: Int!) {
  result: deleteMembership(id: $id)
}
    `;
function $00d97f6f0e186a01$export$71d1179593621e0a(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$bbfc35b1fb7e6c7c, options);
}
const $00d97f6f0e186a01$export$dda2871af624cc9c = (0, $cwNRj.gql)`
    subscription MembershipCreated {
  result: membershipCreated {
    ...MembershipOverview
  }
}
    ${$00d97f6f0e186a01$export$4c49b749d3f62a21}`;
function $00d97f6f0e186a01$export$49a8645946470740(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$dda2871af624cc9c, options);
}
const $00d97f6f0e186a01$export$4b6cad67c28afa61 = (0, $cwNRj.gql)`
    subscription MembershipUpdated {
  result: membershipUpdated {
    ...MembershipOverview
  }
}
    ${$00d97f6f0e186a01$export$4c49b749d3f62a21}`;
function $00d97f6f0e186a01$export$d545506e8c7ad764(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$4b6cad67c28afa61, options);
}
const $00d97f6f0e186a01$export$27b67f6d19478142 = (0, $cwNRj.gql)`
    subscription MembershipDeleted {
  result: membershipDeleted {
    id
  }
}
    `;
function $00d97f6f0e186a01$export$5604af14ea8d620a(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$27b67f6d19478142, options);
}
const $00d97f6f0e186a01$export$aef4235add5005fd = (0, $cwNRj.gql)`
    query msbReports {
  result: msbReports {
    ...MsbReportOverview
  }
}
    ${$00d97f6f0e186a01$export$3f55cf4321b2b1f0}`;
function $00d97f6f0e186a01$export$6853a7b86efb7bd6(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$aef4235add5005fd, options);
}
function $00d97f6f0e186a01$export$a5336d5a9feb1e34(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$aef4235add5005fd, options);
}
const $00d97f6f0e186a01$export$77c2120b1a6abbb9 = (0, $cwNRj.gql)`
    mutation scheduleReport($input: ScheduleInput!) {
  result: scheduleReport(input: $input) {
    ...MsbReportOverview
  }
}
    ${$00d97f6f0e186a01$export$3f55cf4321b2b1f0}`;
function $00d97f6f0e186a01$export$8ae9b6ce9c45a88d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$77c2120b1a6abbb9, options);
}
const $00d97f6f0e186a01$export$46146b1a36e3198a = (0, $cwNRj.gql)`
    query getNavs($stock_id: Int!) {
  result: getNavs(stock_id: $stock_id) {
    ...NavDetails
  }
}
    ${$00d97f6f0e186a01$export$d18a0e7b1e5710da}`;
function $00d97f6f0e186a01$export$eb4860eb04d36cfc(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$46146b1a36e3198a, options);
}
function $00d97f6f0e186a01$export$6acfb5176cde4ad1(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$46146b1a36e3198a, options);
}
const $00d97f6f0e186a01$export$1a4f11c62e96d029 = (0, $cwNRj.gql)`
    mutation createNav($stock_id: ID!, $input: NavInput!) {
  result: createNav(stock_id: $stock_id, input: $input) {
    ...NavDetails
  }
}
    ${$00d97f6f0e186a01$export$d18a0e7b1e5710da}`;
function $00d97f6f0e186a01$export$d48e254c68cac26b(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$1a4f11c62e96d029, options);
}
const $00d97f6f0e186a01$export$45870ee817d5833a = (0, $cwNRj.gql)`
    mutation updateNav($id: ID!, $input: NavInput!) {
  result: updateNav(id: $id, input: $input) {
    ...NavDetails
  }
}
    ${$00d97f6f0e186a01$export$d18a0e7b1e5710da}`;
function $00d97f6f0e186a01$export$28b6188f0186a6c4(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$45870ee817d5833a, options);
}
const $00d97f6f0e186a01$export$76f15734466f9490 = (0, $cwNRj.gql)`
    mutation deleteNav($id: ID!) {
  result: deleteNav(id: $id)
}
    `;
function $00d97f6f0e186a01$export$fb096e172ca478c4(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$76f15734466f9490, options);
}
const $00d97f6f0e186a01$export$b6e80acee77dbf3b = (0, $cwNRj.gql)`
    subscription navCreated($stock_id: ID!) {
  result: navCreated(stock_id: $stock_id) {
    ...NavDetails
  }
}
    ${$00d97f6f0e186a01$export$d18a0e7b1e5710da}`;
function $00d97f6f0e186a01$export$bf3303de32ff50ce(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$b6e80acee77dbf3b, options);
}
const $00d97f6f0e186a01$export$b12172a36418ce19 = (0, $cwNRj.gql)`
    subscription navUpdated($stock_id: ID!) {
  result: navUpdated(stock_id: $stock_id) {
    ...NavDetails
  }
}
    ${$00d97f6f0e186a01$export$d18a0e7b1e5710da}`;
function $00d97f6f0e186a01$export$ab77759bfab6937c(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$b12172a36418ce19, options);
}
const $00d97f6f0e186a01$export$e490e73406dfac50 = (0, $cwNRj.gql)`
    subscription navDeleted($stock_id: ID!) {
  result: navDeleted(stock_id: $stock_id) {
    ...NavDetails
  }
}
    ${$00d97f6f0e186a01$export$d18a0e7b1e5710da}`;
function $00d97f6f0e186a01$export$3f64ce7bdeaa4ba2(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$e490e73406dfac50, options);
}
const $00d97f6f0e186a01$export$a51af0646e3f1c0 = (0, $cwNRj.gql)`
    query productCodes {
  result: productCodes {
    id
    name
  }
}
    `;
function $00d97f6f0e186a01$export$e1078143adbe3183(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$a51af0646e3f1c0, options);
}
function $00d97f6f0e186a01$export$912f563cd32fadbc(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$a51af0646e3f1c0, options);
}
const $00d97f6f0e186a01$export$1c4c73e876f07373 = (0, $cwNRj.gql)`
    query products {
  result: products {
    ...ProductDetails
  }
}
    ${$00d97f6f0e186a01$export$9be0f94e3f4d06bf}`;
function $00d97f6f0e186a01$export$b692723449dab17d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$1c4c73e876f07373, options);
}
function $00d97f6f0e186a01$export$b4c38fb01dd0421(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$1c4c73e876f07373, options);
}
const $00d97f6f0e186a01$export$abc22acd8c6cec42 = (0, $cwNRj.gql)`
    query product($id: Int!) {
  result: product(id: $id) {
    ...ProductDetailsFull
  }
}
    ${$00d97f6f0e186a01$export$7717e2e3782f50c8}`;
function $00d97f6f0e186a01$export$87f61a051b89a3b8(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$abc22acd8c6cec42, options);
}
function $00d97f6f0e186a01$export$61daec33a5209758(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$abc22acd8c6cec42, options);
}
const $00d97f6f0e186a01$export$13e14f64315555a2 = (0, $cwNRj.gql)`
    query membershipProducts {
  result: membershipProducts {
    id
    membership_type {
      id
      name
    }
    price
  }
}
    `;
function $00d97f6f0e186a01$export$9fc3917262e2f32f(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$13e14f64315555a2, options);
}
function $00d97f6f0e186a01$export$d92b3c65c635d1c6(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$13e14f64315555a2, options);
}
const $00d97f6f0e186a01$export$385f0558e14a2cb3 = (0, $cwNRj.gql)`
    mutation deleteProduct($id: Int!) {
  result: deleteProduct(id: $id)
}
    `;
function $00d97f6f0e186a01$export$d23a23f70f82a6af(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$385f0558e14a2cb3, options);
}
const $00d97f6f0e186a01$export$36d41f638d89dca2 = (0, $cwNRj.gql)`
    mutation createProduct($input: ProductInput!) {
  result: createProduct(input: $input) {
    ...ProductDetails
  }
}
    ${$00d97f6f0e186a01$export$9be0f94e3f4d06bf}`;
function $00d97f6f0e186a01$export$d9ac3918452bd061(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$36d41f638d89dca2, options);
}
const $00d97f6f0e186a01$export$c406d520b6fa2904 = (0, $cwNRj.gql)`
    mutation updateProductGeneralInfo($id: Int!, $input: ProductInput!) {
  result: updateProductGeneralInfo(id: $id, input: $input) {
    ...ProductDetailsFull
  }
}
    ${$00d97f6f0e186a01$export$7717e2e3782f50c8}`;
function $00d97f6f0e186a01$export$2fe11c6c89d0cf(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$c406d520b6fa2904, options);
}
const $00d97f6f0e186a01$export$fda5bea59221137c = (0, $cwNRj.gql)`
    mutation updateProductEmailInfo($id: Int!, $input: EmailInput!) {
  result: updateProductEmailInfo(id: $id, input: $input) {
    ...ProductDetailsFull
  }
}
    ${$00d97f6f0e186a01$export$7717e2e3782f50c8}`;
function $00d97f6f0e186a01$export$efc5b85d67a73d90(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$fda5bea59221137c, options);
}
const $00d97f6f0e186a01$export$c42eea2f64357e7a = (0, $cwNRj.gql)`
    subscription ProductCreated {
  result: productCreated {
    ...ProductDetails
  }
}
    ${$00d97f6f0e186a01$export$9be0f94e3f4d06bf}`;
function $00d97f6f0e186a01$export$541d7baba335a7d1(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$c42eea2f64357e7a, options);
}
const $00d97f6f0e186a01$export$61da7130b945aa2e = (0, $cwNRj.gql)`
    subscription ProductUpdated {
  result: productUpdated {
    ...ProductDetails
  }
}
    ${$00d97f6f0e186a01$export$9be0f94e3f4d06bf}`;
function $00d97f6f0e186a01$export$80b0ba5c1117c0f4(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$61da7130b945aa2e, options);
}
const $00d97f6f0e186a01$export$66f1499f07a9f7c5 = (0, $cwNRj.gql)`
    subscription ProductDeleted {
  result: productDeleted {
    id
  }
}
    `;
function $00d97f6f0e186a01$export$aadcfa67839628c3(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$66f1499f07a9f7c5, options);
}
const $00d97f6f0e186a01$export$25f390f932130bec = (0, $cwNRj.gql)`
    query recipientLists {
  result: recipientLists {
    ...RecipientListProps
  }
}
    ${$00d97f6f0e186a01$export$ad888413148071ed}`;
function $00d97f6f0e186a01$export$2c73cc4bd50a0276(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$25f390f932130bec, options);
}
function $00d97f6f0e186a01$export$9df48f210acb26b(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$25f390f932130bec, options);
}
const $00d97f6f0e186a01$export$db766d78e8bbf4eb = (0, $cwNRj.gql)`
    query excludedContacts($id: Int!) {
  result: excludedContacts(id: $id) {
    id
    first_name
    last_name
    titleInternal {
      id
      name
    }
    email
  }
}
    `;
function $00d97f6f0e186a01$export$34dd7a09095133bd(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$db766d78e8bbf4eb, options);
}
function $00d97f6f0e186a01$export$b99fbb1f4bf82ab9(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$db766d78e8bbf4eb, options);
}
const $00d97f6f0e186a01$export$b76f212192f6e86a = (0, $cwNRj.gql)`
    query recipients($id: Int!) {
  result: recipients(id: $id) {
    id
    first_name
    last_name
    titleInternal {
      id
      name
    }
    email
  }
}
    `;
function $00d97f6f0e186a01$export$7b020b2e62387525(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$b76f212192f6e86a, options);
}
function $00d97f6f0e186a01$export$ef7860ce773e7d79(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$b76f212192f6e86a, options);
}
const $00d97f6f0e186a01$export$793d775854c10262 = (0, $cwNRj.gql)`
    mutation deleteRecipientList($id: Int!) {
  result: deleteRecipientList(id: $id)
}
    `;
function $00d97f6f0e186a01$export$e6716f7b70ba565c(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$793d775854c10262, options);
}
const $00d97f6f0e186a01$export$da961144999aa27f = (0, $cwNRj.gql)`
    mutation excludeRecipient($recipient_list_id: Int!, $contact_id: Int!) {
  result: excludeRecipient(
    recipient_list_id: $recipient_list_id
    contact_id: $contact_id
  ) {
    ...RecipientListProps
  }
}
    ${$00d97f6f0e186a01$export$ad888413148071ed}`;
function $00d97f6f0e186a01$export$e98e118fa2693082(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$da961144999aa27f, options);
}
const $00d97f6f0e186a01$export$2dc6cc00f4da1cc6 = (0, $cwNRj.gql)`
    mutation createRecipientList($input: RecipientListInput!) {
  result: createRecipientList(input: $input) {
    ...RecipientListProps
  }
}
    ${$00d97f6f0e186a01$export$ad888413148071ed}`;
function $00d97f6f0e186a01$export$d2dd538123521ffd(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$2dc6cc00f4da1cc6, options);
}
const $00d97f6f0e186a01$export$8e233a3def21ac96 = (0, $cwNRj.gql)`
    mutation updateRecipientList($input: RecipientListInput!) {
  result: updateRecipientList(input: $input) {
    ...RecipientListProps
  }
}
    ${$00d97f6f0e186a01$export$ad888413148071ed}`;
function $00d97f6f0e186a01$export$8c5393fa17435518(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$8e233a3def21ac96, options);
}
const $00d97f6f0e186a01$export$74cb66a32c38e6b2 = (0, $cwNRj.gql)`
    subscription RecipientListDeleted {
  result: recipientListDeleted {
    id
  }
}
    `;
function $00d97f6f0e186a01$export$4c166dbff8775822(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$74cb66a32c38e6b2, options);
}
const $00d97f6f0e186a01$export$65c91a7f4f52b01a = (0, $cwNRj.gql)`
    subscription RecipientListCreated {
  result: recipientListCreated {
    ...RecipientListProps
  }
}
    ${$00d97f6f0e186a01$export$ad888413148071ed}`;
function $00d97f6f0e186a01$export$b804d49cb2b2ba2f(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$65c91a7f4f52b01a, options);
}
const $00d97f6f0e186a01$export$c3d2cb45fc590341 = (0, $cwNRj.gql)`
    subscription RecipientListUpdated {
  result: recipientListUpdated {
    ...RecipientListProps
  }
}
    ${$00d97f6f0e186a01$export$ad888413148071ed}`;
function $00d97f6f0e186a01$export$873a5b56fda3aa1c(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$c3d2cb45fc590341, options);
}
const $00d97f6f0e186a01$export$154031888e28d61e = (0, $cwNRj.gql)`
    query regions {
  result: regions {
    id
    name
  }
}
    `;
function $00d97f6f0e186a01$export$42ec9ac117960359(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$154031888e28d61e, options);
}
function $00d97f6f0e186a01$export$655a573bab529888(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$154031888e28d61e, options);
}
const $00d97f6f0e186a01$export$b62111fff37cc3e3 = (0, $cwNRj.gql)`
    query getRoles {
  result: roles {
    id
    name
    users {
      id
      username
      first_name
      last_name
    }
  }
}
    `;
function $00d97f6f0e186a01$export$df99cc263e9b1304(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$b62111fff37cc3e3, options);
}
function $00d97f6f0e186a01$export$9f273cfe25c4302a(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$b62111fff37cc3e3, options);
}
const $00d97f6f0e186a01$export$d7c20fe07e47464d = (0, $cwNRj.gql)`
    mutation removeRoleFromUser($input: UserRoleInput!) {
  result: removeRoleFromUser(input: $input)
}
    `;
function $00d97f6f0e186a01$export$6b7ad7851c93ac84(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$d7c20fe07e47464d, options);
}
const $00d97f6f0e186a01$export$f33292eaf98940d1 = (0, $cwNRj.gql)`
    query getAllScheduled {
  result: getAllScheduled {
    ...SchedulerDetails
  }
}
    ${$00d97f6f0e186a01$export$407c4ef238d4f687}`;
function $00d97f6f0e186a01$export$17207a1e28102cd1(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$f33292eaf98940d1, options);
}
function $00d97f6f0e186a01$export$5b8b7f806f82a985(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$f33292eaf98940d1, options);
}
const $00d97f6f0e186a01$export$e042b6f0debe12e2 = (0, $cwNRj.gql)`
    mutation createScheduler($input: SchedulerInput!) {
  result: createScheduler(input: $input) {
    ...SchedulerDetails
  }
}
    ${$00d97f6f0e186a01$export$407c4ef238d4f687}`;
function $00d97f6f0e186a01$export$588f16e17eb9bba4(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$e042b6f0debe12e2, options);
}
const $00d97f6f0e186a01$export$5ff0cc01f04bd292 = (0, $cwNRj.gql)`
    mutation updateScheduler($id: Int!, $input: SchedulerInput!) {
  result: updateScheduler(id: $id, input: $input) {
    ...SchedulerDetails
  }
}
    ${$00d97f6f0e186a01$export$407c4ef238d4f687}`;
function $00d97f6f0e186a01$export$181c179823b5391d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$5ff0cc01f04bd292, options);
}
const $00d97f6f0e186a01$export$70a35128a5436b43 = (0, $cwNRj.gql)`
    mutation deleteScheduler($id: Int!) {
  result: deleteScheduler(id: $id)
}
    `;
function $00d97f6f0e186a01$export$6854ac67322915d9(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$70a35128a5436b43, options);
}
const $00d97f6f0e186a01$export$65b377b3a0625772 = (0, $cwNRj.gql)`
    mutation deleteRecipientListFromScheduler($scheduler_id: ID!, $recipient_list_id: ID!) {
  result: deleteRecipientListFromScheduler(
    scheduler_id: $scheduler_id
    recipient_list_id: $recipient_list_id
  ) {
    ...SchedulerDetails
  }
}
    ${$00d97f6f0e186a01$export$407c4ef238d4f687}`;
function $00d97f6f0e186a01$export$cc4d921bd698f376(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$65b377b3a0625772, options);
}
const $00d97f6f0e186a01$export$a30bc047f4ffc8b7 = (0, $cwNRj.gql)`
    mutation sendTestEmail($template_id: Int!, $sender_id: String!, $recipient: String!) {
  result: sendTestEmail(
    template_id: $template_id
    sender_id: $sender_id
    recipient: $recipient
  )
}
    `;
function $00d97f6f0e186a01$export$985ae6c53979543d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$a30bc047f4ffc8b7, options);
}
const $00d97f6f0e186a01$export$b692e29f8ce447a9 = (0, $cwNRj.gql)`
    subscription schedulerDeleted {
  result: schedulerDeleted {
    id
  }
}
    `;
function $00d97f6f0e186a01$export$e2fc1cd24a8bc645(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$b692e29f8ce447a9, options);
}
const $00d97f6f0e186a01$export$9e548cb501b70fef = (0, $cwNRj.gql)`
    subscription schedulerCreated {
  result: schedulerCreated {
    ...SchedulerDetails
  }
}
    ${$00d97f6f0e186a01$export$407c4ef238d4f687}`;
function $00d97f6f0e186a01$export$d2560e4569627d9e(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$9e548cb501b70fef, options);
}
const $00d97f6f0e186a01$export$76c2a8e92c2fb5cb = (0, $cwNRj.gql)`
    subscription schedulerUpdated {
  result: schedulerUpdated {
    ...SchedulerDetails
  }
}
    ${$00d97f6f0e186a01$export$407c4ef238d4f687}`;
function $00d97f6f0e186a01$export$3693e162327ca581(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$76c2a8e92c2fb5cb, options);
}
const $00d97f6f0e186a01$export$42a1525e0d4bfa08 = (0, $cwNRj.gql)`
    query sectors {
  result: allSectors {
    id
    name
  }
}
    `;
function $00d97f6f0e186a01$export$a9e0e073b38a8273(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$42a1525e0d4bfa08, options);
}
function $00d97f6f0e186a01$export$450ce38e3ad32ffd(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$42a1525e0d4bfa08, options);
}
const $00d97f6f0e186a01$export$acba7628fd9b521a = (0, $cwNRj.gql)`
    query getAllSenders {
  result: getAllSenders {
    id
    email
  }
}
    `;
function $00d97f6f0e186a01$export$d526626820489b1e(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$acba7628fd9b521a, options);
}
function $00d97f6f0e186a01$export$61e68e80cfc48dca(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$acba7628fd9b521a, options);
}
const $00d97f6f0e186a01$export$d678738a3234d4bd = (0, $cwNRj.gql)`
    query getSendGridStatistics {
  result: getSendGridStatistics {
    month
    sent
    delivered
    read
    blocks
    bounces
    spam_reports
  }
}
    `;
function $00d97f6f0e186a01$export$34da4ee2c1b4782f(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$d678738a3234d4bd, options);
}
function $00d97f6f0e186a01$export$4dcec64272165ad0(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$d678738a3234d4bd, options);
}
const $00d97f6f0e186a01$export$6d50559ce3e1d12d = (0, $cwNRj.gql)`
    query getSendGridMessages($scheduler_id: Int!) {
  result: getSendGridMessages(scheduler_id: $scheduler_id) {
    id
    sg_message_id
    opens_count
    clicks_count
    email
    status
  }
}
    `;
function $00d97f6f0e186a01$export$2fd7e277e776d8fb(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$6d50559ce3e1d12d, options);
}
function $00d97f6f0e186a01$export$13affd53d6e60116(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$6d50559ce3e1d12d, options);
}
const $00d97f6f0e186a01$export$1f98186e6bb11ba2 = (0, $cwNRj.gql)`
    query getSendGridDataForExcel($scheduler_id: Int!) {
  result: getSendGridMessages(scheduler_id: $scheduler_id) {
    id
    scheduler {
      id
      name
    }
    opens_count
    clicks_count
    email
    status
  }
}
    `;
function $00d97f6f0e186a01$export$d14abd8bad876c28(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$1f98186e6bb11ba2, options);
}
function $00d97f6f0e186a01$export$1fb0333a205f463f(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$1f98186e6bb11ba2, options);
}
const $00d97f6f0e186a01$export$95f5706e3bde0ad2 = (0, $cwNRj.gql)`
    query getSendGridEvents($sg_message_id: String!) {
  result: getSendGridEvents(sg_message_id: $sg_message_id) {
    id
    name
    timestamp
    url
  }
}
    `;
function $00d97f6f0e186a01$export$4eed6eb9def71298(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$95f5706e3bde0ad2, options);
}
function $00d97f6f0e186a01$export$16a4f5c96cb3d37a(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$95f5706e3bde0ad2, options);
}
const $00d97f6f0e186a01$export$ccadce76c20ed202 = (0, $cwNRj.gql)`
    query getSiteSections {
  result: getSiteSections {
    ...SiteSectionDetails
  }
}
    ${$00d97f6f0e186a01$export$cd6a622404de518a}`;
function $00d97f6f0e186a01$export$12ac977f6b3f54f(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$ccadce76c20ed202, options);
}
function $00d97f6f0e186a01$export$81262f755c4abd2(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$ccadce76c20ed202, options);
}
const $00d97f6f0e186a01$export$e63a04225d10f155 = (0, $cwNRj.gql)`
    mutation createSiteSection($name: String!) {
  result: createSiteSection(name: $name) {
    ...SiteSectionDetails
  }
}
    ${$00d97f6f0e186a01$export$cd6a622404de518a}`;
function $00d97f6f0e186a01$export$caddd0ff7455e7fa(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$e63a04225d10f155, options);
}
const $00d97f6f0e186a01$export$6b91200ab7d4e0d4 = (0, $cwNRj.gql)`
    mutation deleteSiteSection($id: ID!) {
  result: deleteSiteSection(id: $id)
}
    `;
function $00d97f6f0e186a01$export$69f81879f3542d2c(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$6b91200ab7d4e0d4, options);
}
const $00d97f6f0e186a01$export$4ebfba7c81a81910 = (0, $cwNRj.gql)`
    mutation updateSiteSection($id: ID!, $name: String!) {
  result: updateSiteSection(id: $id, name: $name) {
    ...SiteSectionDetails
  }
}
    ${$00d97f6f0e186a01$export$cd6a622404de518a}`;
function $00d97f6f0e186a01$export$1c0f5b770443802f(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$4ebfba7c81a81910, options);
}
const $00d97f6f0e186a01$export$29a332b57bfad493 = (0, $cwNRj.gql)`
    subscription siteSectionCreated {
  result: siteSectionCreated {
    ...SiteSectionDetails
  }
}
    ${$00d97f6f0e186a01$export$cd6a622404de518a}`;
function $00d97f6f0e186a01$export$e589680df09a92b2(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$29a332b57bfad493, options);
}
const $00d97f6f0e186a01$export$b718792c80100afb = (0, $cwNRj.gql)`
    subscription siteSectionDeleted {
  result: siteSectionDeleted {
    ...SiteSectionDetails
  }
}
    ${$00d97f6f0e186a01$export$cd6a622404de518a}`;
function $00d97f6f0e186a01$export$c74f5e2f76ae8c85(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$b718792c80100afb, options);
}
const $00d97f6f0e186a01$export$630c972bfea2b4b7 = (0, $cwNRj.gql)`
    subscription siteSectionUpdated {
  result: siteSectionUpdated {
    ...SiteSectionDetails
  }
}
    ${$00d97f6f0e186a01$export$cd6a622404de518a}`;
function $00d97f6f0e186a01$export$e035d7f6eac7001c(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$630c972bfea2b4b7, options);
}
const $00d97f6f0e186a01$export$9cfce6e6adef03a2 = (0, $cwNRj.gql)`
    query stocks {
  result: stocks {
    ...StockOverview
  }
}
    ${$00d97f6f0e186a01$export$30c69ca4bcfcd232}`;
function $00d97f6f0e186a01$export$be674aa461a45cea(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$9cfce6e6adef03a2, options);
}
function $00d97f6f0e186a01$export$eaf43f844e6c85cf(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$9cfce6e6adef03a2, options);
}
const $00d97f6f0e186a01$export$a1d162d04b07bb2b = (0, $cwNRj.gql)`
    query stock($id: Int!) {
  result: stock(id: $id) {
    ...StockDetails
  }
}
    ${$00d97f6f0e186a01$export$917484d2d9809683}`;
function $00d97f6f0e186a01$export$efdbd6b4c695483d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$a1d162d04b07bb2b, options);
}
function $00d97f6f0e186a01$export$cfdecc17e8697fb4(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$a1d162d04b07bb2b, options);
}
const $00d97f6f0e186a01$export$ed23bb91d30b8d5e = (0, $cwNRj.gql)`
    query filteredStocks($date: String!, $stock_ids: [Int]) {
  result: filteredStocks(date: $date, stock_ids: $stock_ids) {
    ...StockOverview
  }
}
    ${$00d97f6f0e186a01$export$30c69ca4bcfcd232}`;
function $00d97f6f0e186a01$export$f97bb10400adddd6(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$ed23bb91d30b8d5e, options);
}
function $00d97f6f0e186a01$export$75bb17024ea34310(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$ed23bb91d30b8d5e, options);
}
const $00d97f6f0e186a01$export$e6cd7c29e22ae550 = (0, $cwNRj.gql)`
    query stocksFiltered($filter: StockFilterInput) {
  result: stocksFiltered(filter: $filter) {
    stocks {
      ...StockOverview
    }
    total
  }
}
    ${$00d97f6f0e186a01$export$30c69ca4bcfcd232}`;
function $00d97f6f0e186a01$export$2f904d0677049b28(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$e6cd7c29e22ae550, options);
}
function $00d97f6f0e186a01$export$22be134025270a3d(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$e6cd7c29e22ae550, options);
}
const $00d97f6f0e186a01$export$347a0d170b2a4f0a = (0, $cwNRj.gql)`
    mutation createStock($input: StockInput!) {
  result: createStock(input: $input) {
    ...StockOverview
  }
}
    ${$00d97f6f0e186a01$export$30c69ca4bcfcd232}`;
function $00d97f6f0e186a01$export$42642354ae3e1c8c(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$347a0d170b2a4f0a, options);
}
const $00d97f6f0e186a01$export$6de0937ea8597f01 = (0, $cwNRj.gql)`
    mutation updateStock($id: ID!, $input: StockInput!) {
  result: updateStock(id: $id, input: $input) {
    ...StockOverview
  }
}
    ${$00d97f6f0e186a01$export$30c69ca4bcfcd232}`;
function $00d97f6f0e186a01$export$af2923a7b78add58(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$6de0937ea8597f01, options);
}
const $00d97f6f0e186a01$export$653028c816364264 = (0, $cwNRj.gql)`
    mutation deleteHSData($id: ID!, $input: DeleteHistoryStocksDataInput!) {
  result: deleteHSData(id: $id, input: $input)
}
    `;
function $00d97f6f0e186a01$export$f5ed10a711d3ffd4(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$653028c816364264, options);
}
const $00d97f6f0e186a01$export$2229c2a13578ccac = (0, $cwNRj.gql)`
    subscription StockCreated {
  result: stockCreated {
    ...StockOverview
  }
}
    ${$00d97f6f0e186a01$export$30c69ca4bcfcd232}`;
function $00d97f6f0e186a01$export$ee88ccf91f084964(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$2229c2a13578ccac, options);
}
const $00d97f6f0e186a01$export$cd7346170a9376ce = (0, $cwNRj.gql)`
    subscription StockUpdated {
  result: stockUpdated {
    ...StockOverviewMini
  }
}
    ${$00d97f6f0e186a01$export$dad84f302e118744}`;
function $00d97f6f0e186a01$export$68da1be0eb588744(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$cd7346170a9376ce, options);
}
const $00d97f6f0e186a01$export$4692fa3348fcef1b = (0, $cwNRj.gql)`
    query templates {
  result: templates {
    ...TemplateDetails
  }
}
    ${$00d97f6f0e186a01$export$d86e77836fe22a2b}`;
function $00d97f6f0e186a01$export$da007814ffd3091b(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$4692fa3348fcef1b, options);
}
function $00d97f6f0e186a01$export$f9f779ebf28be1cf(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$4692fa3348fcef1b, options);
}
const $00d97f6f0e186a01$export$e8240074dcfc440 = (0, $cwNRj.gql)`
    mutation deleteTemplate($id: Int!) {
  result: deleteTemplate(id: $id)
}
    `;
function $00d97f6f0e186a01$export$9fb6b54e960a872e(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$e8240074dcfc440, options);
}
const $00d97f6f0e186a01$export$5aa9f5333fcef255 = (0, $cwNRj.gql)`
    mutation createTemplate($input: TemplateInput!) {
  result: createTemplate(input: $input) {
    ...TemplateDetails
  }
}
    ${$00d97f6f0e186a01$export$d86e77836fe22a2b}`;
function $00d97f6f0e186a01$export$c85e821f5dded8f2(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$5aa9f5333fcef255, options);
}
const $00d97f6f0e186a01$export$2f6bbe6c21799ddb = (0, $cwNRj.gql)`
    mutation updateTemplate($id: Int!, $input: TemplateInput!) {
  result: updateTemplate(id: $id, input: $input) {
    ...TemplateDetails
  }
}
    ${$00d97f6f0e186a01$export$d86e77836fe22a2b}`;
function $00d97f6f0e186a01$export$3e6250bf8c15acd5(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$2f6bbe6c21799ddb, options);
}
const $00d97f6f0e186a01$export$86f9f4a698c928e2 = (0, $cwNRj.gql)`
    subscription templateDeleted {
  result: templateDeleted {
    id
  }
}
    `;
function $00d97f6f0e186a01$export$93ef53b5f86e5ef7(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$86f9f4a698c928e2, options);
}
const $00d97f6f0e186a01$export$b823ba2ab3aaaa98 = (0, $cwNRj.gql)`
    subscription templateCreated {
  result: templateCreated {
    ...TemplateDetails
  }
}
    ${$00d97f6f0e186a01$export$d86e77836fe22a2b}`;
function $00d97f6f0e186a01$export$617c6de886edaadf(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$b823ba2ab3aaaa98, options);
}
const $00d97f6f0e186a01$export$c3b6aaff0cd0263 = (0, $cwNRj.gql)`
    subscription templateUpdated {
  result: templateUpdated {
    ...TemplateDetails
  }
}
    ${$00d97f6f0e186a01$export$d86e77836fe22a2b}`;
function $00d97f6f0e186a01$export$746640a877fa6583(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$c3b6aaff0cd0263, options);
}
const $00d97f6f0e186a01$export$88830faefcac6cfb = (0, $cwNRj.gql)`
    query titlesInternal {
  result: titlesInternal {
    id
    name
  }
}
    `;
function $00d97f6f0e186a01$export$d9473be9334a5d10(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$88830faefcac6cfb, options);
}
function $00d97f6f0e186a01$export$c7a5cc0fdcf16032(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$88830faefcac6cfb, options);
}
const $00d97f6f0e186a01$export$81144c6f7704af9 = (0, $cwNRj.gql)`
    mutation addRoleToUser($role_id: Int!, $user_ids: [Int]!) {
  result: addRoleToUser(role_id: $role_id, user_ids: $user_ids)
}
    `;
function $00d97f6f0e186a01$export$ca04abdf3a48704a(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$81144c6f7704af9, options);
}
const $00d97f6f0e186a01$export$7343f2a1df7c2c44 = (0, $cwNRj.gql)`
    query getUsers {
  result: users {
    id
    username
    first_name
    last_name
    roles
  }
}
    `;
function $00d97f6f0e186a01$export$2f5355ee4596e5a(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$7343f2a1df7c2c44, options);
}
function $00d97f6f0e186a01$export$d45f4ff617c61c75(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$7343f2a1df7c2c44, options);
}
const $00d97f6f0e186a01$export$7000cd62712c9956 = (0, $cwNRj.gql)`
    query getUser($id: Int!) {
  result: user(id: $id) {
    ...UserDetails
  }
}
    ${$00d97f6f0e186a01$export$b2dbb4d61e0c0725}`;
function $00d97f6f0e186a01$export$9beb97f355b95ab9(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $4OEi8.useQuery($00d97f6f0e186a01$export$7000cd62712c9956, options);
}
function $00d97f6f0e186a01$export$7df562623c42db5(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $1r7sc.useLazyQuery($00d97f6f0e186a01$export$7000cd62712c9956, options);
}
const $00d97f6f0e186a01$export$56bcb5d9ddeafe5e = (0, $cwNRj.gql)`
    mutation createUser($input: CreateUserInput!) {
  result: createUser(input: $input) {
    ...UserDetails
  }
}
    ${$00d97f6f0e186a01$export$b2dbb4d61e0c0725}`;
function $00d97f6f0e186a01$export$989d55af39b135f7(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$56bcb5d9ddeafe5e, options);
}
const $00d97f6f0e186a01$export$d62fe5465f3797bb = (0, $cwNRj.gql)`
    mutation updatePassword($id: Int!, $newPass: String!) {
  result: updatePassword(id: $id, newPass: $newPass)
}
    `;
function $00d97f6f0e186a01$export$1d1fc52b8c6fcaca(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$d62fe5465f3797bb, options);
}
const $00d97f6f0e186a01$export$33ef4be163a1b285 = (0, $cwNRj.gql)`
    mutation updateUserDetails($id: Int!, $input: UserInput!) {
  result: updateUserDetails(id: $id, input: $input) {
    ...UserDetails
  }
}
    ${$00d97f6f0e186a01$export$b2dbb4d61e0c0725}`;
function $00d97f6f0e186a01$export$5651788cb661bcc9(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$33ef4be163a1b285, options);
}
const $00d97f6f0e186a01$export$ea98dd21a39d1e2f = (0, $cwNRj.gql)`
    mutation deleteUser($id: Int!) {
  result: deleteUser(id: $id)
}
    `;
function $00d97f6f0e186a01$export$2e519bb6ce31dd11(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $jCAzD.useMutation($00d97f6f0e186a01$export$ea98dd21a39d1e2f, options);
}
const $00d97f6f0e186a01$export$f911efcb57ea99b = (0, $cwNRj.gql)`
    subscription userCreated {
  result: userCreated {
    ...UserDetails
  }
}
    ${$00d97f6f0e186a01$export$b2dbb4d61e0c0725}`;
function $00d97f6f0e186a01$export$4b7d160bbcc0215c(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$f911efcb57ea99b, options);
}
const $00d97f6f0e186a01$export$1596e1ba8440f811 = (0, $cwNRj.gql)`
    subscription userUpdated {
  result: userUpdated {
    ...UserDetails
  }
}
    ${$00d97f6f0e186a01$export$b2dbb4d61e0c0725}`;
function $00d97f6f0e186a01$export$2c58b7db3c5b4049(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$1596e1ba8440f811, options);
}
const $00d97f6f0e186a01$export$dcb7168e8d942a1d = (0, $cwNRj.gql)`
    subscription userDeleted {
  result: userDeleted {
    id
  }
}
    `;
function $00d97f6f0e186a01$export$2273306a6936a721(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$dcb7168e8d942a1d, options);
}
const $00d97f6f0e186a01$export$ddbbef1cda7ab95e = (0, $cwNRj.gql)`
    subscription userRoleRemoved {
  result: userRoleRemoved {
    ...UserDetails
  }
}
    ${$00d97f6f0e186a01$export$b2dbb4d61e0c0725}`;
function $00d97f6f0e186a01$export$6c922ee123f65fa3(baseOptions) {
    const options = {
        ...$00d97f6f0e186a01$var$defaultOptions,
        ...baseOptions
    };
    return $fnLzi.useSubscription($00d97f6f0e186a01$export$ddbbef1cda7ab95e, options);
}

});
parcelRegister("cwNRj", function(module, exports) {

$parcel$export(module.exports, "gql", function () { return $91ef261ec72afd33$export$72e4926bf8358653; });

var $l73V3 = parcelRequire("l73V3");

var $4ANmx = parcelRequire("4ANmx");
var $91ef261ec72afd33$var$docCache = new Map();
var $91ef261ec72afd33$var$fragmentSourceMap = new Map();
var $91ef261ec72afd33$var$printFragmentWarnings = true;
var $91ef261ec72afd33$var$experimentalFragmentVariables = false;
function $91ef261ec72afd33$var$normalize(string) {
    return string.replace(/[\s,]+/g, " ").trim();
}
function $91ef261ec72afd33$var$cacheKeyFromLoc(loc) {
    return $91ef261ec72afd33$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $91ef261ec72afd33$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === "FragmentDefinition") {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $91ef261ec72afd33$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $91ef261ec72afd33$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($91ef261ec72afd33$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $91ef261ec72afd33$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, ast), {
        definitions: definitions
    });
}
function $91ef261ec72afd33$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === "object") workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $91ef261ec72afd33$var$parseDocument(source) {
    var cacheKey = $91ef261ec72afd33$var$normalize(source);
    if (!$91ef261ec72afd33$var$docCache.has(cacheKey)) {
        var parsed = (0, $4ANmx.parse)(source, {
            experimentalFragmentVariables: $91ef261ec72afd33$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $91ef261ec72afd33$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== "Document") throw new Error("Not a valid GraphQL document.");
        $91ef261ec72afd33$var$docCache.set(cacheKey, $91ef261ec72afd33$var$stripLoc($91ef261ec72afd33$var$processFragments(parsed)));
    }
    return $91ef261ec72afd33$var$docCache.get(cacheKey);
}
function $91ef261ec72afd33$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === "string") literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === "Document") result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $91ef261ec72afd33$var$parseDocument(result);
}
function $91ef261ec72afd33$export$657554ef4dc7ac2d() {
    $91ef261ec72afd33$var$docCache.clear();
    $91ef261ec72afd33$var$fragmentSourceMap.clear();
}
function $91ef261ec72afd33$export$e4294e638636c6ab() {
    $91ef261ec72afd33$var$printFragmentWarnings = false;
}
function $91ef261ec72afd33$export$78cf889af350c840() {
    $91ef261ec72afd33$var$experimentalFragmentVariables = true;
}
function $91ef261ec72afd33$export$5290df9bbbd3cfa() {
    $91ef261ec72afd33$var$experimentalFragmentVariables = false;
}
var $91ef261ec72afd33$var$extras = {
    gql: $91ef261ec72afd33$export$72e4926bf8358653,
    resetCaches: $91ef261ec72afd33$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $91ef261ec72afd33$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $91ef261ec72afd33$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $91ef261ec72afd33$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $91ef261ec72afd33$var$extras.gql, gql_1.resetCaches = $91ef261ec72afd33$var$extras.resetCaches, gql_1.disableFragmentWarnings = $91ef261ec72afd33$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $91ef261ec72afd33$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $91ef261ec72afd33$var$extras.disableExperimentalFragmentVariables;
})($91ef261ec72afd33$export$72e4926bf8358653 || ($91ef261ec72afd33$export$72e4926bf8358653 = {}));
$91ef261ec72afd33$export$72e4926bf8358653["default"] = $91ef261ec72afd33$export$72e4926bf8358653;
var $91ef261ec72afd33$export$2e2bcd8739ae039 = $91ef261ec72afd33$export$72e4926bf8358653;

});
parcelRegister("l73V3", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $f5ed4ab2a4d1861b$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $f5ed4ab2a4d1861b$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $f5ed4ab2a4d1861b$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $f5ed4ab2a4d1861b$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__spreadArray", function () { return $f5ed4ab2a4d1861b$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $f5ed4ab2a4d1861b$var$extendStatics = function(d, b) {
    $f5ed4ab2a4d1861b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f5ed4ab2a4d1861b$var$extendStatics(d, b);
};
function $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f5ed4ab2a4d1861b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f5ed4ab2a4d1861b$export$18ce0697a983be9b = function() {
    $f5ed4ab2a4d1861b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5ed4ab2a4d1861b$export$18ce0697a983be9b.apply(this, arguments);
};
function $f5ed4ab2a4d1861b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f5ed4ab2a4d1861b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f5ed4ab2a4d1861b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f5ed4ab2a4d1861b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f5ed4ab2a4d1861b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f5ed4ab2a4d1861b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f5ed4ab2a4d1861b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f5ed4ab2a4d1861b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f5ed4ab2a4d1861b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f5ed4ab2a4d1861b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f5ed4ab2a4d1861b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f5ed4ab2a4d1861b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(o, m, p);
}
function $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f5ed4ab2a4d1861b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f5ed4ab2a4d1861b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f5ed4ab2a4d1861b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f5ed4ab2a4d1861b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f5ed4ab2a4d1861b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v) {
    return this instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? (this.v = v, this) : new $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v);
}
function $f5ed4ab2a4d1861b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f5ed4ab2a4d1861b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f5ed4ab2a4d1861b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f5ed4ab2a4d1861b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f5ed4ab2a4d1861b$export$19a8beecd37a4c45 === "function" ? $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f5ed4ab2a4d1861b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f5ed4ab2a4d1861b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $f5ed4ab2a4d1861b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(result, mod, k);
    }
    $f5ed4ab2a4d1861b$var$__setModuleDefault(result, mod);
    return result;
}
function $f5ed4ab2a4d1861b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f5ed4ab2a4d1861b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f5ed4ab2a4d1861b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f5ed4ab2a4d1861b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f5ed4ab2a4d1861b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f5ed4ab2a4d1861b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f5ed4ab2a4d1861b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f5ed4ab2a4d1861b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $f5ed4ab2a4d1861b$export$2e2bcd8739ae039 = {
    __extends: $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a,
    __assign: $f5ed4ab2a4d1861b$export$18ce0697a983be9b,
    __rest: $f5ed4ab2a4d1861b$export$3c9a16f847548506,
    __decorate: $f5ed4ab2a4d1861b$export$29e00dfd3077644b,
    __param: $f5ed4ab2a4d1861b$export$d5ad3fd78186038f,
    __metadata: $f5ed4ab2a4d1861b$export$f1db080c865becb9,
    __awaiter: $f5ed4ab2a4d1861b$export$1050f835b63b671e,
    __generator: $f5ed4ab2a4d1861b$export$67ebef60e6f28a6,
    __createBinding: $f5ed4ab2a4d1861b$export$45d3717a4c69092e,
    __exportStar: $f5ed4ab2a4d1861b$export$f33643c0debef087,
    __values: $f5ed4ab2a4d1861b$export$19a8beecd37a4c45,
    __read: $f5ed4ab2a4d1861b$export$8d051b38c9118094,
    __spread: $f5ed4ab2a4d1861b$export$afc72e2116322959,
    __spreadArrays: $f5ed4ab2a4d1861b$export$6388937ca91ccae8,
    __spreadArray: $f5ed4ab2a4d1861b$export$1216008129fb82ed,
    __await: $f5ed4ab2a4d1861b$export$10c90e4f7922046c,
    __asyncGenerator: $f5ed4ab2a4d1861b$export$e427f37a30a4de9b,
    __asyncDelegator: $f5ed4ab2a4d1861b$export$bbd80228419bb833,
    __asyncValues: $f5ed4ab2a4d1861b$export$e3b29a3d6162315f,
    __makeTemplateObject: $f5ed4ab2a4d1861b$export$4fb47efe1390b86f,
    __importStar: $f5ed4ab2a4d1861b$export$c21735bcef00d192,
    __importDefault: $f5ed4ab2a4d1861b$export$da59b14a69baef04,
    __classPrivateFieldGet: $f5ed4ab2a4d1861b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f5ed4ab2a4d1861b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f5ed4ab2a4d1861b$export$81fdc39f203e4e04,
    __addDisposableResource: $f5ed4ab2a4d1861b$export$88ac25d8e944e405,
    __disposeResources: $f5ed4ab2a4d1861b$export$8f076105dc360e92
};

});

parcelRegister("4ANmx", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $d33aa655b10500ba$export$98e6a39c04603d36; });

var $ki6wx = parcelRequire("ki6wx");

var $1oqsB = parcelRequire("1oqsB");

var $3l7g7 = parcelRequire("3l7g7");

var $kKcD5 = parcelRequire("kKcD5");

var $7lv8k = parcelRequire("7lv8k");

var $3IXjT = parcelRequire("3IXjT");

var $5EvGb = parcelRequire("5EvGb");
function $d33aa655b10500ba$export$98e6a39c04603d36(source, options) {
    const parser = new $d33aa655b10500ba$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $d33aa655b10500ba$export$5303528d1070ff6f(source, options) {
    const parser = new $d33aa655b10500ba$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $5EvGb.TokenKind).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $5EvGb.TokenKind).EOF);
    return value;
}
function $d33aa655b10500ba$export$e14c466bd0916f7a(source, options) {
    const parser = new $d33aa655b10500ba$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $5EvGb.TokenKind).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $5EvGb.TokenKind).EOF);
    return value;
}
function $d33aa655b10500ba$export$28b8f402ccc88182(source, options) {
    const parser = new $d33aa655b10500ba$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $5EvGb.TokenKind).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $5EvGb.TokenKind).EOF);
    return type;
}
class $d33aa655b10500ba$export$7acfa6ed01010e37 {
    constructor(source, options = {}){
        const sourceObj = (0, $3IXjT.isSource)(source) ? source : new (0, $3IXjT.Source)(source);
        this._lexer = new (0, $7lv8k.Lexer)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $5EvGb.TokenKind).NAME);
        return this.node(token, {
            kind: (0, $kKcD5.Kind).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $kKcD5.Kind).DOCUMENT,
            definitions: this.many((0, $5EvGb.TokenKind).SOF, this.parseDefinition, (0, $5EvGb.TokenKind).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $5EvGb.TokenKind).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $5EvGb.TokenKind).NAME) {
            switch(keywordToken.value){
                case "schema":
                    return this.parseSchemaDefinition();
                case "scalar":
                    return this.parseScalarTypeDefinition();
                case "type":
                    return this.parseObjectTypeDefinition();
                case "interface":
                    return this.parseInterfaceTypeDefinition();
                case "union":
                    return this.parseUnionTypeDefinition();
                case "enum":
                    return this.parseEnumTypeDefinition();
                case "input":
                    return this.parseInputObjectTypeDefinition();
                case "directive":
                    return this.parseDirectiveDefinition();
            }
            if (hasDescription) throw (0, $ki6wx.syntaxError)(this._lexer.source, this._lexer.token.start, "Unexpected description, descriptions are supported only on type definitions.");
            switch(keywordToken.value){
                case "query":
                case "mutation":
                case "subscription":
                    return this.parseOperationDefinition();
                case "fragment":
                    return this.parseFragmentDefinition();
                case "extend":
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $5EvGb.TokenKind).BRACE_L)) return this.node(start, {
            kind: (0, $kKcD5.Kind).OPERATION_DEFINITION,
            operation: (0, $1oqsB.OperationTypeNode).QUERY,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $5EvGb.TokenKind).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $5EvGb.TokenKind).NAME);
        switch(operationToken.value){
            case "query":
                return (0, $1oqsB.OperationTypeNode).QUERY;
            case "mutation":
                return (0, $1oqsB.OperationTypeNode).MUTATION;
            case "subscription":
                return (0, $1oqsB.OperationTypeNode).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $5EvGb.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $5EvGb.TokenKind).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $kKcD5.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $5EvGb.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $5EvGb.TokenKind).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $5EvGb.TokenKind).DOLLAR);
        return this.node(start, {
            kind: (0, $kKcD5.Kind).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $kKcD5.Kind).SELECTION_SET,
            selections: this.many((0, $5EvGb.TokenKind).BRACE_L, this.parseSelection, (0, $5EvGb.TokenKind).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $5EvGb.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $5EvGb.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $kKcD5.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $5EvGb.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $5EvGb.TokenKind).PAREN_L, item, (0, $5EvGb.TokenKind).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $5EvGb.TokenKind).COLON);
        return this.node(start, {
            kind: (0, $kKcD5.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $5EvGb.TokenKind).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, $5EvGb.TokenKind).NAME)) return this.node(start, {
            kind: (0, $kKcD5.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $kKcD5.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        this.expectKeyword("fragment"); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $kKcD5.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $kKcD5.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $5EvGb.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $5EvGb.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $5EvGb.TokenKind).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $kKcD5.Kind).INT,
                    value: token.value
                });
            case (0, $5EvGb.TokenKind).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $kKcD5.Kind).FLOAT,
                    value: token.value
                });
            case (0, $5EvGb.TokenKind).STRING:
            case (0, $5EvGb.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $5EvGb.TokenKind).NAME:
                this.advanceLexer();
                switch(token.value){
                    case "true":
                        return this.node(token, {
                            kind: (0, $kKcD5.Kind).BOOLEAN,
                            value: true
                        });
                    case "false":
                        return this.node(token, {
                            kind: (0, $kKcD5.Kind).BOOLEAN,
                            value: false
                        });
                    case "null":
                        return this.node(token, {
                            kind: (0, $kKcD5.Kind).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $kKcD5.Kind).ENUM,
                            value: token.value
                        });
                }
            case (0, $5EvGb.TokenKind).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $5EvGb.TokenKind).DOLLAR);
                    if (this._lexer.token.kind === (0, $5EvGb.TokenKind).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $ki6wx.syntaxError)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $kKcD5.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $5EvGb.TokenKind).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $kKcD5.Kind).LIST,
            values: this.any((0, $5EvGb.TokenKind).BRACKET_L, item, (0, $5EvGb.TokenKind).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $kKcD5.Kind).OBJECT,
            fields: this.any((0, $5EvGb.TokenKind).BRACE_L, item, (0, $5EvGb.TokenKind).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $5EvGb.TokenKind).COLON);
        return this.node(start, {
            kind: (0, $kKcD5.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $5EvGb.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $5EvGb.TokenKind).AT);
        return this.node(start, {
            kind: (0, $kKcD5.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $5EvGb.TokenKind).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $5EvGb.TokenKind).BRACKET_R);
            type = this.node(start, {
                kind: (0, $kKcD5.Kind).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $5EvGb.TokenKind).BANG)) return this.node(start, {
            kind: (0, $kKcD5.Kind).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $kKcD5.Kind).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $5EvGb.TokenKind).STRING) || this.peek((0, $5EvGb.TokenKind).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $5EvGb.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $5EvGb.TokenKind).BRACE_R);
        return this.node(start, {
            kind: (0, $kKcD5.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $5EvGb.TokenKind).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword("implements") ? this.delimitedMany((0, $5EvGb.TokenKind).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $5EvGb.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $5EvGb.TokenKind).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $5EvGb.TokenKind).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $5EvGb.TokenKind).PAREN_L, this.parseInputValueDef, (0, $5EvGb.TokenKind).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $5EvGb.TokenKind).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $5EvGb.TokenKind).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $5EvGb.TokenKind).EQUALS) ? this.delimitedMany((0, $5EvGb.TokenKind).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $5EvGb.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $5EvGb.TokenKind).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null") throw (0, $ki6wx.syntaxError)(this._lexer.source, this._lexer.token.start, `${$d33aa655b10500ba$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $5EvGb.TokenKind).BRACE_L, this.parseInputValueDef, (0, $5EvGb.TokenKind).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $5EvGb.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $5EvGb.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $5EvGb.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, $5EvGb.TokenKind).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $kKcD5.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $5EvGb.TokenKind).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $3l7g7.DirectiveLocation), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $1oqsB.Location)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $ki6wx.syntaxError)(this._lexer.source, token.start, `Expected ${$d33aa655b10500ba$var$getTokenKindDesc(kind)}, found ${$d33aa655b10500ba$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $5EvGb.TokenKind).NAME && token.value === value) this.advanceLexer();
        else throw (0, $ki6wx.syntaxError)(this._lexer.source, token.start, `Expected "${value}", found ${$d33aa655b10500ba$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $5EvGb.TokenKind).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $ki6wx.syntaxError)(this._lexer.source, token.start, `Unexpected ${$d33aa655b10500ba$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (maxTokens !== undefined && token.kind !== (0, $5EvGb.TokenKind).EOF) {
            ++this._tokenCounter;
            if (this._tokenCounter > maxTokens) throw (0, $ki6wx.syntaxError)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $d33aa655b10500ba$var$getTokenDesc(token) {
    const value = token.value;
    return $d33aa655b10500ba$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $d33aa655b10500ba$var$getTokenKindDesc(kind) {
    return (0, $7lv8k.isPunctuatorTokenKind)(kind) ? `"${kind}"` : kind;
}

});
parcelRegister("ki6wx", function(module, exports) {

$parcel$export(module.exports, "syntaxError", function () { return $0030658abef6f114$export$bbee0c6176c019d4; });

var $kNgyC = parcelRequire("kNgyC");
function $0030658abef6f114$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $kNgyC.GraphQLError)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}

});
parcelRegister("kNgyC", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", function () { return $18f059cfb722e939$export$92d6ed0888e7cb7f; });

var $4JpN4 = parcelRequire("4JpN4");

var $h4JF6 = parcelRequire("h4JF6");

var $115kX = parcelRequire("115kX");
function $18f059cfb722e939$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || "kind" in firstArg || "length" in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $18f059cfb722e939$export$92d6ed0888e7cb7f extends Error {
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $18f059cfb722e939$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = "GraphQLError";
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $18f059cfb722e939$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $18f059cfb722e939$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $h4JF6.getLocation)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $h4JF6.getLocation)(loc.source, loc.start));
        const originalExtensions = (0, $4JpN4.isObjectLike)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, "stack", {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $18f059cfb722e939$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    get [Symbol.toStringTag]() {
        return "GraphQLError";
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += "\n\n" + (0, $115kX.printLocation)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += "\n\n" + (0, $115kX.printSourceLocation)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function $18f059cfb722e939$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $18f059cfb722e939$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $18f059cfb722e939$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}

});
parcelRegister("4JpN4", function(module, exports) {

$parcel$export(module.exports, "isObjectLike", function () { return $7ea9807f94ef1500$export$c10d0b04eaa80a43; });
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $7ea9807f94ef1500$export$c10d0b04eaa80a43(value) {
    return typeof value == "object" && value !== null;
}

});

parcelRegister("h4JF6", function(module, exports) {

$parcel$export(module.exports, "getLocation", function () { return $65e98860272a437d$export$e7fd20fad3cf4b5f; });

var $afYsW = parcelRequire("afYsW");
const $65e98860272a437d$var$LineRegExp = /\r\n|[\n\r]/g;
function $65e98860272a437d$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($65e98860272a437d$var$LineRegExp)){
        typeof match.index === "number" || (0, $afYsW.invariant)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}

});
parcelRegister("afYsW", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $406c3a8331245574$export$f5708dca728d7177; });
function $406c3a8331245574$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}

});


parcelRegister("115kX", function(module, exports) {

$parcel$export(module.exports, "printLocation", function () { return $d98f7e5ac69bb4a4$export$96a9681e539deed; });
$parcel$export(module.exports, "printSourceLocation", function () { return $d98f7e5ac69bb4a4$export$867940333fd9f869; });

var $h4JF6 = parcelRequire("h4JF6");
function $d98f7e5ac69bb4a4$export$96a9681e539deed(location) {
    return $d98f7e5ac69bb4a4$export$867940333fd9f869(location.source, (0, $h4JF6.getLocation)(location.source, location.start));
}
function $d98f7e5ac69bb4a4$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = "".padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $d98f7e5ac69bb4a4$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    "|",
                    subLine
                ]),
            [
                "|",
                "^".padStart(subLineColumnNum)
            ],
            [
                "|",
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $d98f7e5ac69bb4a4$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            "|",
            "^".padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $d98f7e5ac69bb4a4$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? " " + line : "")).join("\n");
}

});



parcelRegister("1oqsB", function(module, exports) {

$parcel$export(module.exports, "Location", function () { return $24b377bf3d60d301$export$18a2be9195644f38; });
$parcel$export(module.exports, "Token", function () { return $24b377bf3d60d301$export$50792b0e93539fde; });
$parcel$export(module.exports, "QueryDocumentKeys", function () { return $24b377bf3d60d301$export$4fcd777a40ccf407; });
$parcel$export(module.exports, "isNode", function () { return $24b377bf3d60d301$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "OperationTypeNode", function () { return $24b377bf3d60d301$export$f58c50edb4aef9d4; });
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $24b377bf3d60d301$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return "Location";
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $24b377bf3d60d301$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return "Token";
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $24b377bf3d60d301$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
const $24b377bf3d60d301$var$kindValues = new Set(Object.keys($24b377bf3d60d301$export$4fcd777a40ccf407));
function $24b377bf3d60d301$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === "string" && $24b377bf3d60d301$var$kindValues.has(maybeKind);
}
/** Name */ var $24b377bf3d60d301$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})($24b377bf3d60d301$export$f58c50edb4aef9d4 || ($24b377bf3d60d301$export$f58c50edb4aef9d4 = {}));

});

parcelRegister("3l7g7", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", function () { return $5a1ec0c233acc040$export$b45ffd2948484c41; });
/**
 * The set of allowed directive location values.
 */ var $5a1ec0c233acc040$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation["QUERY"] = "QUERY";
    DirectiveLocation["MUTATION"] = "MUTATION";
    DirectiveLocation["SUBSCRIPTION"] = "SUBSCRIPTION";
    DirectiveLocation["FIELD"] = "FIELD";
    DirectiveLocation["FRAGMENT_DEFINITION"] = "FRAGMENT_DEFINITION";
    DirectiveLocation["FRAGMENT_SPREAD"] = "FRAGMENT_SPREAD";
    DirectiveLocation["INLINE_FRAGMENT"] = "INLINE_FRAGMENT";
    DirectiveLocation["VARIABLE_DEFINITION"] = "VARIABLE_DEFINITION";
    DirectiveLocation["SCHEMA"] = "SCHEMA";
    DirectiveLocation["SCALAR"] = "SCALAR";
    DirectiveLocation["OBJECT"] = "OBJECT";
    DirectiveLocation["FIELD_DEFINITION"] = "FIELD_DEFINITION";
    DirectiveLocation["ARGUMENT_DEFINITION"] = "ARGUMENT_DEFINITION";
    DirectiveLocation["INTERFACE"] = "INTERFACE";
    DirectiveLocation["UNION"] = "UNION";
    DirectiveLocation["ENUM"] = "ENUM";
    DirectiveLocation["ENUM_VALUE"] = "ENUM_VALUE";
    DirectiveLocation["INPUT_OBJECT"] = "INPUT_OBJECT";
    DirectiveLocation["INPUT_FIELD_DEFINITION"] = "INPUT_FIELD_DEFINITION";
})($5a1ec0c233acc040$export$b45ffd2948484c41 || ($5a1ec0c233acc040$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 
});

parcelRegister("kKcD5", function(module, exports) {

$parcel$export(module.exports, "Kind", function () { return $e26b1ac4b90eccca$export$a84bdc57c5122798; });
/**
 * The set of allowed kind values for AST nodes.
 */ var $e26b1ac4b90eccca$export$a84bdc57c5122798;
(function(Kind) {
    Kind["NAME"] = "Name";
    Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    Kind["DIRECTIVE"] = "Directive";
    Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})($e26b1ac4b90eccca$export$a84bdc57c5122798 || ($e26b1ac4b90eccca$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 
});

parcelRegister("7lv8k", function(module, exports) {

$parcel$export(module.exports, "Lexer", function () { return $4ffdd609857be646$export$6168dc8908a6c652; });
$parcel$export(module.exports, "isPunctuatorTokenKind", function () { return $4ffdd609857be646$export$59ac0f4da287406a; });

var $ki6wx = parcelRequire("ki6wx");

var $1oqsB = parcelRequire("1oqsB");

var $7M3sn = parcelRequire("7M3sn");

var $1OwXw = parcelRequire("1OwXw");

var $5EvGb = parcelRequire("5EvGb");
class $4ffdd609857be646$export$6168dc8908a6c652 {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $1oqsB.Token)((0, $5EvGb.TokenKind).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
        return "Lexer";
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $5EvGb.TokenKind).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $4ffdd609857be646$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $5EvGb.TokenKind).COMMENT);
        }
        return token;
    }
}
function $4ffdd609857be646$export$59ac0f4da287406a(kind) {
    return kind === (0, $5EvGb.TokenKind).BANG || kind === (0, $5EvGb.TokenKind).DOLLAR || kind === (0, $5EvGb.TokenKind).AMP || kind === (0, $5EvGb.TokenKind).PAREN_L || kind === (0, $5EvGb.TokenKind).PAREN_R || kind === (0, $5EvGb.TokenKind).SPREAD || kind === (0, $5EvGb.TokenKind).COLON || kind === (0, $5EvGb.TokenKind).EQUALS || kind === (0, $5EvGb.TokenKind).AT || kind === (0, $5EvGb.TokenKind).BRACKET_L || kind === (0, $5EvGb.TokenKind).BRACKET_R || kind === (0, $5EvGb.TokenKind).BRACE_L || kind === (0, $5EvGb.TokenKind).PIPE || kind === (0, $5EvGb.TokenKind).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $4ffdd609857be646$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $4ffdd609857be646$var$isSupplementaryCodePoint(body, location) {
    return $4ffdd609857be646$var$isLeadingSurrogate(body.charCodeAt(location)) && $4ffdd609857be646$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $4ffdd609857be646$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $4ffdd609857be646$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function $4ffdd609857be646$var$printCodePointAt(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $5EvGb.TokenKind).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return "U+" + code.toString(16).toUpperCase().padStart(4, "0");
}
/**
 * Create a token with line and column location information.
 */ function $4ffdd609857be646$var$createToken(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $1oqsB.Token)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $4ffdd609857be646$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $4ffdd609857be646$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).BANG, position, position + 1);
            case 0x0024:
                // $
                return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).AMP, position, position + 1);
            case 0x0028:
                // (
                return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).COLON, position, position + 1);
            case 0x003d:
                // =
                return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).AT, position, position + 1);
            case 0x005b:
                // [
                return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $4ffdd609857be646$var$readBlockString(lexer, position);
                return $4ffdd609857be646$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $1OwXw.isDigit)(code) || code === 0x002d) return $4ffdd609857be646$var$readNumber(lexer, position, code);
         // Name
        if ((0, $1OwXw.isNameStart)(code)) return $4ffdd609857be646$var$readName(lexer, position);
        throw (0, $ki6wx.syntaxError)(lexer.source, position, code === 0x0027 ? "Unexpected single quote character ('), did you mean to use a double quote (\")?" : $4ffdd609857be646$var$isUnicodeScalarValue(code) || $4ffdd609857be646$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$4ffdd609857be646$var$printCodePointAt(lexer, position)}.` : `Invalid character: ${$4ffdd609857be646$var$printCodePointAt(lexer, position)}.`);
    }
    return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $4ffdd609857be646$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($4ffdd609857be646$var$isUnicodeScalarValue(code)) ++position;
        else if ($4ffdd609857be646$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $4ffdd609857be646$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $1OwXw.isDigit)(code)) throw (0, $ki6wx.syntaxError)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$4ffdd609857be646$var$printCodePointAt(lexer, position)}.`);
    } else {
        position = $4ffdd609857be646$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $4ffdd609857be646$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $4ffdd609857be646$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $1OwXw.isNameStart)(code)) throw (0, $ki6wx.syntaxError)(lexer.source, position, `Invalid number, expected digit but got: ${$4ffdd609857be646$var$printCodePointAt(lexer, position)}.`);
    return $4ffdd609857be646$var$createToken(lexer, isFloat ? (0, $5EvGb.TokenKind).FLOAT : (0, $5EvGb.TokenKind).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $4ffdd609857be646$var$readDigits(lexer, start, firstCode) {
    if (!(0, $1OwXw.isDigit)(firstCode)) throw (0, $ki6wx.syntaxError)(lexer.source, start, `Invalid number, expected digit but got: ${$4ffdd609857be646$var$printCodePointAt(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $1OwXw.isDigit)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $4ffdd609857be646$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = "";
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $4ffdd609857be646$var$readEscapedUnicodeVariableWidth(lexer, position) : $4ffdd609857be646$var$readEscapedUnicodeFixedWidth(lexer, position) : $4ffdd609857be646$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($4ffdd609857be646$var$isUnicodeScalarValue(code)) ++position;
        else if ($4ffdd609857be646$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $ki6wx.syntaxError)(lexer.source, position, `Invalid character within String: ${$4ffdd609857be646$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $ki6wx.syntaxError)(lexer.source, position, "Unterminated string.");
} // The string value and lexed size of an escape sequence.
function $4ffdd609857be646$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$4ffdd609857be646$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $4ffdd609857be646$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $ki6wx.syntaxError)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $4ffdd609857be646$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $4ffdd609857be646$var$read16BitHexCode(body, position + 2);
    if ($4ffdd609857be646$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($4ffdd609857be646$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $4ffdd609857be646$var$read16BitHexCode(body, position + 8);
            if ($4ffdd609857be646$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $ki6wx.syntaxError)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $4ffdd609857be646$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $4ffdd609857be646$var$readHexDigit(body.charCodeAt(position)) << 12 | $4ffdd609857be646$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $4ffdd609857be646$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $4ffdd609857be646$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $4ffdd609857be646$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $4ffdd609857be646$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '"',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: "\\",
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: "/",
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: "\b",
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: "\f",
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: "\n",
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: "\r",
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: "	",
                size: 2
            };
    }
    throw (0, $ki6wx.syntaxError)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $4ffdd609857be646$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = "";
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).BLOCK_STRING, start, position + 3, (0, $7M3sn.dedentBlockStringLines)(blockLines).join("\n"));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = "";
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($4ffdd609857be646$var$isUnicodeScalarValue(code)) ++position;
        else if ($4ffdd609857be646$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $ki6wx.syntaxError)(lexer.source, position, `Invalid character within String: ${$4ffdd609857be646$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $ki6wx.syntaxError)(lexer.source, position, "Unterminated string.");
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function $4ffdd609857be646$var$readName(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $1OwXw.isNameContinue)(code)) ++position;
        else break;
    }
    return $4ffdd609857be646$var$createToken(lexer, (0, $5EvGb.TokenKind).NAME, start, position, body.slice(start, position));
}

});
parcelRegister("7M3sn", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringLines", function () { return $fe572da9ac9a2bab$export$d5ee19b441e8d2ae; });
$parcel$export(module.exports, "printBlockString", function () { return $fe572da9ac9a2bab$export$adb6ca997eeb1f45; });

var $1OwXw = parcelRequire("1OwXw");
function $fe572da9ac9a2bab$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $fe572da9ac9a2bab$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $fe572da9ac9a2bab$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $1OwXw.isWhiteSpace)(str.charCodeAt(i)))++i;
    return i;
}
function $fe572da9ac9a2bab$export$40862a63ef85e395(value) {
    if (value === "") return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $fe572da9ac9a2bab$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $1OwXw.isWhiteSpace)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith("\\");
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ""; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $1OwXw.isWhiteSpace)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += "\n";
    return '"""' + result + '"""';
}

});
parcelRegister("1OwXw", function(module, exports) {

$parcel$export(module.exports, "isWhiteSpace", function () { return $e52985f8ba811280$export$3c52dd84024ae72c; });
$parcel$export(module.exports, "isDigit", function () { return $e52985f8ba811280$export$727d9dbc4fbb948f; });
$parcel$export(module.exports, "isNameStart", function () { return $e52985f8ba811280$export$45a677ea7cb6d5c8; });
$parcel$export(module.exports, "isNameContinue", function () { return $e52985f8ba811280$export$d3f406ff46035894; });
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $e52985f8ba811280$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $e52985f8ba811280$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $e52985f8ba811280$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $e52985f8ba811280$export$45a677ea7cb6d5c8(code) {
    return $e52985f8ba811280$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $e52985f8ba811280$export$d3f406ff46035894(code) {
    return $e52985f8ba811280$export$79c5d5217943d6a7(code) || $e52985f8ba811280$export$727d9dbc4fbb948f(code) || code === 0x005f;
}

});


parcelRegister("5EvGb", function(module, exports) {

$parcel$export(module.exports, "TokenKind", function () { return $c0d02805800d4e63$export$8b9d26ab11394711; });
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $c0d02805800d4e63$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind["SOF"] = "<SOF>";
    TokenKind["EOF"] = "<EOF>";
    TokenKind["BANG"] = "!";
    TokenKind["DOLLAR"] = "$";
    TokenKind["AMP"] = "&";
    TokenKind["PAREN_L"] = "(";
    TokenKind["PAREN_R"] = ")";
    TokenKind["SPREAD"] = "...";
    TokenKind["COLON"] = ":";
    TokenKind["EQUALS"] = "=";
    TokenKind["AT"] = "@";
    TokenKind["BRACKET_L"] = "[";
    TokenKind["BRACKET_R"] = "]";
    TokenKind["BRACE_L"] = "{";
    TokenKind["PIPE"] = "|";
    TokenKind["BRACE_R"] = "}";
    TokenKind["NAME"] = "Name";
    TokenKind["INT"] = "Int";
    TokenKind["FLOAT"] = "Float";
    TokenKind["STRING"] = "String";
    TokenKind["BLOCK_STRING"] = "BlockString";
    TokenKind["COMMENT"] = "Comment";
})($c0d02805800d4e63$export$8b9d26ab11394711 || ($c0d02805800d4e63$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 
});


parcelRegister("3IXjT", function(module, exports) {

$parcel$export(module.exports, "Source", function () { return $99075040f9f75b7f$export$1d2df86270c81ecb; });
$parcel$export(module.exports, "isSource", function () { return $99075040f9f75b7f$export$75135ee9ed6e435b; });

var $hHpno = parcelRequire("hHpno");

var $1aask = parcelRequire("1aask");

var $id3Kr = parcelRequire("id3Kr");
class $99075040f9f75b7f$export$1d2df86270c81ecb {
    constructor(body, name = "GraphQL request", locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === "string" || (0, $hHpno.devAssert)(false, `Body must be a string. Received: ${(0, $1aask.inspect)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $hHpno.devAssert)(false, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, $hHpno.devAssert)(false, "column in locationOffset is 1-indexed and must be positive.");
    }
    get [Symbol.toStringTag]() {
        return "Source";
    }
}
function $99075040f9f75b7f$export$75135ee9ed6e435b(source) {
    return (0, $id3Kr.instanceOf)(source, $99075040f9f75b7f$export$1d2df86270c81ecb);
}

});
parcelRegister("hHpno", function(module, exports) {

$parcel$export(module.exports, "devAssert", function () { return $ebde78799810771e$export$b6cb5906f04696c8; });
function $ebde78799810771e$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("1aask", function(module, exports) {

$parcel$export(module.exports, "inspect", function () { return $95230ee149a60926$export$9dec5d1b3b6a130d; });
const $95230ee149a60926$var$MAX_ARRAY_LENGTH = 10;
const $95230ee149a60926$var$MAX_RECURSIVE_DEPTH = 2;
function $95230ee149a60926$export$9dec5d1b3b6a130d(value) {
    return $95230ee149a60926$var$formatValue(value, []);
}
function $95230ee149a60926$var$formatValue(value, seenValues) {
    switch(typeof value){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? `[function ${value.name}]` : "[function]";
        case "object":
            return $95230ee149a60926$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $95230ee149a60926$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($95230ee149a60926$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : $95230ee149a60926$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $95230ee149a60926$var$formatArray(value, seenValues);
    return $95230ee149a60926$var$formatObject(value, seenValues);
}
function $95230ee149a60926$var$isJSONable(value) {
    return typeof value.toJSON === "function";
}
function $95230ee149a60926$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > $95230ee149a60926$var$MAX_RECURSIVE_DEPTH) return "[" + $95230ee149a60926$var$getObjectTag(object) + "]";
    const properties = entries.map(([key, value])=>key + ": " + $95230ee149a60926$var$formatValue(value, seenValues));
    return "{ " + properties.join(", ") + " }";
}
function $95230ee149a60926$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $95230ee149a60926$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    const len = Math.min($95230ee149a60926$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($95230ee149a60926$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return "[" + items.join(", ") + "]";
}
function $95230ee149a60926$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        const name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}

});

parcelRegister("id3Kr", function(module, exports) {

$parcel$export(module.exports, "instanceOf", function () { return $2d71edb5aa3079c7$export$ca03416d6c9e029e; });

var $1aask = parcelRequire("1aask");
const $2d71edb5aa3079c7$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === "object" && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $1aask.inspect)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};

});




parcelRegister("1r7sc", function(module, exports) {

$parcel$export(module.exports, "useLazyQuery", function () { return $10be183ae0ad4dde$export$fd83eea6ecd2d8fa; });

var $l73V3 = parcelRequire("l73V3");

var $8Qw6M = parcelRequire("8Qw6M");

var $2ZAj9 = parcelRequire("2ZAj9");

var $4OEi8 = parcelRequire("4OEi8");

var $4VYKF = parcelRequire("4VYKF");
// The following methods, when called will execute the query, regardless of
// whether the useLazyQuery execute function was called before.
var $10be183ae0ad4dde$var$EAGER_METHODS = [
    "refetch",
    "reobserve",
    "fetchMore",
    "updateQuery",
    "startPolling",
    "subscribeToMore"
];
function $10be183ae0ad4dde$export$fd83eea6ecd2d8fa(query, options) {
    var _a;
    var execOptionsRef = $8Qw6M.useRef();
    var optionsRef = $8Qw6M.useRef();
    var queryRef = $8Qw6M.useRef();
    var merged = (0, $2ZAj9.mergeOptions)(options, execOptionsRef.current || {});
    var document = (_a = merged === null || merged === void 0 ? void 0 : merged.query) !== null && _a !== void 0 ? _a : query;
    // Use refs to track options and the used query to ensure the `execute`
    // function remains referentially stable between renders.
    optionsRef.current = options;
    queryRef.current = document;
    var internalState = (0, $4OEi8.useInternalState)((0, $4VYKF.useApolloClient)(options && options.client), document);
    var useQueryResult = internalState.useQuery((0, $l73V3.__assign)((0, $l73V3.__assign)({}, merged), {
        skip: !execOptionsRef.current
    }));
    var initialFetchPolicy = useQueryResult.observable.options.initialFetchPolicy || internalState.getDefaultFetchPolicy();
    var result = Object.assign(useQueryResult, {
        called: !!execOptionsRef.current
    });
    // We use useMemo here to make sure the eager methods have a stable identity.
    var eagerMethods = $8Qw6M.useMemo(function() {
        var eagerMethods = {};
        var _loop_1 = function(key) {
            var method = result[key];
            eagerMethods[key] = function() {
                if (!execOptionsRef.current) {
                    execOptionsRef.current = Object.create(null);
                    // Only the first time populating execOptionsRef.current matters here.
                    internalState.forceUpdateState();
                }
                // @ts-expect-error this is just too generic to type
                return method.apply(this, arguments);
            };
        };
        for(var _i = 0, EAGER_METHODS_1 = $10be183ae0ad4dde$var$EAGER_METHODS; _i < EAGER_METHODS_1.length; _i++){
            var key = EAGER_METHODS_1[_i];
            _loop_1(key);
        }
        return eagerMethods;
    }, []);
    Object.assign(result, eagerMethods);
    var execute = $8Qw6M.useCallback(function(executeOptions) {
        execOptionsRef.current = executeOptions ? (0, $l73V3.__assign)((0, $l73V3.__assign)({}, executeOptions), {
            fetchPolicy: executeOptions.fetchPolicy || initialFetchPolicy
        }) : {
            fetchPolicy: initialFetchPolicy
        };
        var options = (0, $2ZAj9.mergeOptions)(optionsRef.current, (0, $l73V3.__assign)({
            query: queryRef.current
        }, execOptionsRef.current));
        var promise = internalState.executeQuery((0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
            skip: false
        })).then(function(queryResult) {
            return Object.assign(queryResult, eagerMethods);
        });
        // Because the return value of `useLazyQuery` is usually floated, we need
        // to catch the promise to prevent unhandled rejections.
        promise.catch(function() {});
        return promise;
    }, []);
    return [
        execute,
        result
    ];
}

});
parcelRegister("8Qw6M", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bh6RR"));

});

parcelRegister("2ZAj9", function(module, exports) {

$parcel$export(module.exports, "mergeOptions", function () { return $22dd7146067d6d32$export$235b7fc70b9fc359; });

var $l73V3 = parcelRequire("l73V3");

var $am4bq = parcelRequire("am4bq");
function $22dd7146067d6d32$export$235b7fc70b9fc359(defaults, options) {
    return (0, $am4bq.compact)(defaults, options, options.variables && {
        variables: (0, $am4bq.compact)((0, $l73V3.__assign)((0, $l73V3.__assign)({}, defaults && defaults.variables), options.variables))
    });
}

});
parcelRegister("am4bq", function(module, exports) {

$parcel$export(module.exports, "compact", function () { return $789f3428da405372$export$8e16b83750b44988; });
/**
 * Merges the provided objects shallowly and removes
 * all properties with an `undefined` value
 */ function $789f3428da405372$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}

});


parcelRegister("4OEi8", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $381b16009ec5546b$export$dd0a697e1782aedd; });
$parcel$export(module.exports, "useInternalState", function () { return $381b16009ec5546b$export$6342ea8c555e49e5; });

var $l73V3 = parcelRequire("l73V3");
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $8Qw6M = parcelRequire("8Qw6M");

var $bEu9B = parcelRequire("bEu9B");

var $62dod = parcelRequire("62dod");

var $8L3vO = parcelRequire("8L3vO");
var $am4bq = parcelRequire("am4bq");
var $2emDS = parcelRequire("2emDS");
var $a7LxD = parcelRequire("a7LxD");
var $2ZAj9 = parcelRequire("2ZAj9");

var $lj0SF = parcelRequire("lj0SF");

var $408uN = parcelRequire("408uN");

var $8LKEl = parcelRequire("8LKEl");

var $kzepc = parcelRequire("kzepc");

var $4VYKF = parcelRequire("4VYKF");

var $f4NIL = parcelRequire("f4NIL");
var $381b16009ec5546b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $381b16009ec5546b$export$dd0a697e1782aedd(query, options) {
    if (options === void 0) options = Object.create(null);
    return (0, $f4NIL.wrapHook)("useQuery", $381b16009ec5546b$var$_useQuery, (0, $4VYKF.useApolloClient)(options && options.client))(query, options);
}
function $381b16009ec5546b$var$_useQuery(query, options) {
    return $381b16009ec5546b$export$6342ea8c555e49e5((0, $4VYKF.useApolloClient)(options.client), query).useQuery(options);
}
function $381b16009ec5546b$export$6342ea8c555e49e5(client, query) {
    var stateRef = $8Qw6M.useRef();
    if (!stateRef.current || client !== stateRef.current.client || query !== stateRef.current.query) stateRef.current = new $381b16009ec5546b$var$InternalState(client, query, stateRef.current);
    var state = stateRef.current;
    // By default, InternalState.prototype.forceUpdate is an empty function, but
    // we replace it here (before anyone has had a chance to see this state yet)
    // with a function that unconditionally forces an update, using the latest
    // setTick function. Updating this state by calling state.forceUpdate is the
    // only way we trigger React component updates (no other useState calls within
    // the InternalState class).
    state.forceUpdateState = $8Qw6M.useReducer(function(tick) {
        return tick + 1;
    }, 0)[1];
    return state;
}
var $381b16009ec5546b$var$InternalState = /** @class */ function() {
    function InternalState(client, query, previous) {
        var _this = this;
        this.client = client;
        this.query = query;
        /**
         * Will be overwritten by the `useSyncExternalStore` "force update" method
         * whenever it is available and reset to `forceUpdateState` when it isn't.
         */ this.forceUpdate = function() {
            return _this.forceUpdateState();
        };
        this.ssrDisabledResult = (0, $a7LxD.maybeDeepFreeze)({
            loading: true,
            data: void 0,
            error: void 0,
            networkStatus: (0, $8LKEl.NetworkStatus).loading
        });
        this.skipStandbyResult = (0, $a7LxD.maybeDeepFreeze)({
            loading: false,
            data: void 0,
            error: void 0,
            networkStatus: (0, $8LKEl.NetworkStatus).ready
        });
        // This cache allows the referential stability of this.result (as returned by
        // getCurrentResult) to translate into referential stability of the resulting
        // QueryResult object returned by toQueryResult.
        this.toQueryResultCache = new ((0, $8L3vO.canUseWeakMap) ? WeakMap : Map)();
        (0, $kzepc.verifyDocumentType)(query, (0, $kzepc.DocumentType).Query);
        // Reuse previousData from previous InternalState (if any) to provide
        // continuity of previousData even if/when the query or client changes.
        var previousResult = previous && previous.result;
        var previousData = previousResult && previousResult.data;
        if (previousData) this.previousData = previousData;
    }
    /**
     * Forces an update using local component state.
     * As this is not batched with `useSyncExternalStore` updates,
     * this is only used as a fallback if the `useSyncExternalStore` "force update"
     * method is not registered at the moment.
     * See https://github.com/facebook/react/issues/25191
     *  */ InternalState.prototype.forceUpdateState = function() {
        // Replaced (in useInternalState) with a method that triggers an update.
        globalThis.__DEV__ !== false && (0, $kJ26n.invariant).warn(51);
    };
    InternalState.prototype.executeQuery = function(options) {
        var _this = this;
        var _a;
        if (options.query) Object.assign(this, {
            query: options.query
        });
        this.watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var concast = this.observable.reobserveAsConcast(this.getObsQueryOptions());
        // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
        // but save the current data as this.previousData, just like setResult
        // usually does.
        this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
        this.result = void 0;
        this.forceUpdate();
        return new Promise(function(resolve) {
            var result;
            // Subscribe to the concast independently of the ObservableQuery in case
            // the component gets unmounted before the promise resolves. This prevents
            // the concast from terminating early and resolving with `undefined` when
            // there are no more subscribers for the concast.
            concast.subscribe({
                next: function(value) {
                    result = value;
                },
                error: function() {
                    resolve(_this.toQueryResult(_this.observable.getCurrentResult()));
                },
                complete: function() {
                    resolve(_this.toQueryResult(result));
                }
            });
        });
    };
    // Methods beginning with use- should be called according to the standard
    // rules of React hooks: only at the top level of the calling function, and
    // without any dynamic conditional logic.
    InternalState.prototype.useQuery = function(options) {
        var _this = this;
        // The renderPromises field gets initialized here in the useQuery method, at
        // the beginning of everything (for a given component rendering, at least),
        // so we can safely use this.renderPromises in other/later InternalState
        // methods without worrying it might be uninitialized. Even after
        // initialization, this.renderPromises is usually undefined (unless SSR is
        // happening), but that's fine as long as it has been initialized that way,
        // rather than left uninitialized.
        this.renderPromises = $8Qw6M.useContext((0, $lj0SF.getApolloContext)()).renderPromises;
        this.useOptions(options);
        var obsQuery = this.useObservableQuery();
        var result = (0, $bEu9B.useSyncExternalStore)($8Qw6M.useCallback(function(handleStoreChange) {
            if (_this.renderPromises) return function() {};
            _this.forceUpdate = handleStoreChange;
            var onNext = function() {
                var previousResult = _this.result;
                // We use `getCurrentResult()` instead of the onNext argument because
                // the values differ slightly. Specifically, loading results will have
                // an empty object for data instead of `undefined` for some reason.
                var result = obsQuery.getCurrentResult();
                // Make sure we're not attempting to re-render similar results
                if (previousResult && previousResult.loading === result.loading && previousResult.networkStatus === result.networkStatus && (0, $62dod.equal)(previousResult.data, result.data)) return;
                _this.setResult(result);
            };
            var onError = function(error) {
                subscription.unsubscribe();
                subscription = obsQuery.resubscribeAfterError(onNext, onError);
                if (!$381b16009ec5546b$var$hasOwnProperty.call(error, "graphQLErrors")) // The error is not a GraphQL error
                throw error;
                var previousResult = _this.result;
                if (!previousResult || previousResult && previousResult.loading || !(0, $62dod.equal)(error, previousResult.error)) _this.setResult({
                    data: previousResult && previousResult.data,
                    error: error,
                    loading: false,
                    networkStatus: (0, $8LKEl.NetworkStatus).error
                });
            };
            var subscription = obsQuery.subscribe(onNext, onError);
            // Do the "unsubscribe" with a short delay.
            // This way, an existing subscription can be reused without an additional
            // request if "unsubscribe"  and "resubscribe" to the same ObservableQuery
            // happen in very fast succession.
            return function() {
                setTimeout(function() {
                    return subscription.unsubscribe();
                });
                _this.forceUpdate = function() {
                    return _this.forceUpdateState();
                };
            };
        }, [
            // We memoize the subscribe function using useCallback and the following
            // dependency keys, because the subscribe function reference is all that
            // useSyncExternalStore uses internally as a dependency key for the
            // useEffect ultimately responsible for the subscription, so we are
            // effectively passing this dependency array to that useEffect buried
            // inside useSyncExternalStore, as desired.
            obsQuery,
            this.renderPromises,
            this.client.disableNetworkFetches
        ]), function() {
            return _this.getCurrentResult();
        }, function() {
            return _this.getCurrentResult();
        });
        // TODO Remove this method when we remove support for options.partialRefetch.
        this.unsafeHandlePartialRefetch(result);
        return this.toQueryResult(result);
    };
    InternalState.prototype.useOptions = function(options) {
        var _a;
        var watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        // Update this.watchQueryOptions, but only when they have changed, which
        // allows us to depend on the referential stability of
        // this.watchQueryOptions elsewhere.
        var currentWatchQueryOptions = this.watchQueryOptions;
        if (!(0, $62dod.equal)(watchQueryOptions, currentWatchQueryOptions)) {
            this.watchQueryOptions = watchQueryOptions;
            if (currentWatchQueryOptions && this.observable) {
                // Though it might be tempting to postpone this reobserve call to the
                // useEffect block, we need getCurrentResult to return an appropriate
                // loading:true result synchronously (later within the same call to
                // useQuery). Since we already have this.observable here (not true for
                // the very first call to useQuery), we are not initiating any new
                // subscriptions, though it does feel less than ideal that reobserve
                // (potentially) kicks off a network request (for example, when the
                // variables have changed), which is technically a side-effect.
                this.observable.reobserve(this.getObsQueryOptions());
                // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
                // but save the current data as this.previousData, just like setResult
                // usually does.
                this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
                this.result = void 0;
            }
        }
        // Make sure state.onCompleted and state.onError always reflect the latest
        // options.onCompleted and options.onError callbacks provided to useQuery,
        // since those functions are often recreated every time useQuery is called.
        // Like the forceUpdate method, the versions of these methods inherited from
        // InternalState.prototype are empty no-ops, but we can override them on the
        // base state object (without modifying the prototype).
        this.onCompleted = options.onCompleted || InternalState.prototype.onCompleted;
        this.onError = options.onError || InternalState.prototype.onError;
        if ((this.renderPromises || this.client.disableNetworkFetches) && this.queryHookOptions.ssr === false && !this.queryHookOptions.skip) // If SSR has been explicitly disabled, and this function has been called
        // on the server side, return the default loading state.
        this.result = this.ssrDisabledResult;
        else if (this.queryHookOptions.skip || this.watchQueryOptions.fetchPolicy === "standby") // When skipping a query (ie. we're not querying for data but still want to
        // render children), make sure the `data` is cleared out and `loading` is
        // set to `false` (since we aren't loading anything).
        //
        // NOTE: We no longer think this is the correct behavior. Skipping should
        // not automatically set `data` to `undefined`, but instead leave the
        // previous data in place. In other words, skipping should not mandate that
        // previously received data is all of a sudden removed. Unfortunately,
        // changing this is breaking, so we'll have to wait until Apollo Client 4.0
        // to address this.
        this.result = this.skipStandbyResult;
        else if (this.result === this.ssrDisabledResult || this.result === this.skipStandbyResult) this.result = void 0;
    };
    InternalState.prototype.getObsQueryOptions = function() {
        var toMerge = [];
        var globalDefaults = this.client.defaultOptions.watchQuery;
        if (globalDefaults) toMerge.push(globalDefaults);
        if (this.queryHookOptions.defaultOptions) toMerge.push(this.queryHookOptions.defaultOptions);
        // We use compact rather than mergeOptions for this part of the merge,
        // because we want watchQueryOptions.variables (if defined) to replace
        // this.observable.options.variables whole. This replacement allows
        // removing variables by removing them from the variables input to
        // useQuery. If the variables were always merged together (rather than
        // replaced), there would be no way to remove existing variables.
        // However, the variables from options.defaultOptions and globalDefaults
        // (if provided) should be merged, to ensure individual defaulted
        // variables always have values, if not otherwise defined in
        // observable.options or watchQueryOptions.
        toMerge.push((0, $am4bq.compact)(this.observable && this.observable.options, this.watchQueryOptions));
        return toMerge.reduce((0, $2ZAj9.mergeOptions));
    };
    // A function to massage options before passing them to ObservableQuery.
    InternalState.prototype.createWatchQueryOptions = function(_a) {
        var _b;
        if (_a === void 0) _a = {};
        var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, // The above options are useQuery-specific, so this ...otherOptions spread
        // makes otherOptions almost a WatchQueryOptions object, except for the
        // query property that we add below.
        otherOptions = (0, $l73V3.__rest)(_a, [
            "skip",
            "ssr",
            "onCompleted",
            "onError",
            "defaultOptions"
        ]);
        // This Object.assign is safe because otherOptions is a fresh ...rest object
        // that did not exist until just now, so modifications are still allowed.
        var watchQueryOptions = Object.assign(otherOptions, {
            query: this.query
        });
        if (this.renderPromises && (watchQueryOptions.fetchPolicy === "network-only" || watchQueryOptions.fetchPolicy === "cache-and-network")) // this behavior was added to react-apollo without explanation in this PR
        // https://github.com/apollographql/react-apollo/pull/1579
        watchQueryOptions.fetchPolicy = "cache-first";
        if (!watchQueryOptions.variables) watchQueryOptions.variables = {};
        if (skip) {
            var _c = watchQueryOptions.fetchPolicy, fetchPolicy = _c === void 0 ? this.getDefaultFetchPolicy() : _c, _d = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _d === void 0 ? fetchPolicy : _d;
            // When skipping, we set watchQueryOptions.fetchPolicy initially to
            // "standby", but we also need/want to preserve the initial non-standby
            // fetchPolicy that would have been used if not skipping.
            Object.assign(watchQueryOptions, {
                initialFetchPolicy: initialFetchPolicy,
                fetchPolicy: "standby"
            });
        } else if (!watchQueryOptions.fetchPolicy) watchQueryOptions.fetchPolicy = ((_b = this.observable) === null || _b === void 0 ? void 0 : _b.options.initialFetchPolicy) || this.getDefaultFetchPolicy();
        return watchQueryOptions;
    };
    InternalState.prototype.getDefaultFetchPolicy = function() {
        var _a, _b;
        return ((_a = this.queryHookOptions.defaultOptions) === null || _a === void 0 ? void 0 : _a.fetchPolicy) || ((_b = this.client.defaultOptions.watchQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "cache-first";
    };
    // Defining these methods as no-ops on the prototype allows us to call
    // state.onCompleted and/or state.onError without worrying about whether a
    // callback was provided.
    InternalState.prototype.onCompleted = function(data) {};
    InternalState.prototype.onError = function(error) {};
    InternalState.prototype.useObservableQuery = function() {
        // See if there is an existing observable that was used to fetch the same
        // data and if so, use it instead since it will contain the proper queryId
        // to fetch the result set. This is used during SSR.
        var obsQuery = this.observable = this.renderPromises && this.renderPromises.getSSRObservable(this.watchQueryOptions) || this.observable || // Reuse this.observable if possible (and not SSR)
        this.client.watchQuery(this.getObsQueryOptions());
        this.obsQueryFields = $8Qw6M.useMemo(function() {
            return {
                refetch: obsQuery.refetch.bind(obsQuery),
                reobserve: obsQuery.reobserve.bind(obsQuery),
                fetchMore: obsQuery.fetchMore.bind(obsQuery),
                updateQuery: obsQuery.updateQuery.bind(obsQuery),
                startPolling: obsQuery.startPolling.bind(obsQuery),
                stopPolling: obsQuery.stopPolling.bind(obsQuery),
                subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery)
            };
        }, [
            obsQuery
        ]);
        var ssrAllowed = !(this.queryHookOptions.ssr === false || this.queryHookOptions.skip);
        if (this.renderPromises && ssrAllowed) {
            this.renderPromises.registerSSRObservable(obsQuery);
            if (obsQuery.getCurrentResult().loading) // TODO: This is a legacy API which could probably be cleaned up
            this.renderPromises.addObservableQueryPromise(obsQuery);
        }
        return obsQuery;
    };
    InternalState.prototype.setResult = function(nextResult) {
        var previousResult = this.result;
        if (previousResult && previousResult.data) this.previousData = previousResult.data;
        this.result = nextResult;
        // Calling state.setResult always triggers an update, though some call sites
        // perform additional equality checks before committing to an update.
        this.forceUpdate();
        this.handleErrorOrCompleted(nextResult, previousResult);
    };
    InternalState.prototype.handleErrorOrCompleted = function(result, previousResult) {
        var _this = this;
        if (!result.loading) {
            var error_1 = this.toApolloError(result);
            // wait a tick in case we are in the middle of rendering a component
            Promise.resolve().then(function() {
                if (error_1) _this.onError(error_1);
                else if (result.data && (previousResult === null || previousResult === void 0 ? void 0 : previousResult.networkStatus) !== result.networkStatus && result.networkStatus === (0, $8LKEl.NetworkStatus).ready) _this.onCompleted(result.data);
            }).catch(function(error) {
                globalThis.__DEV__ !== false && (0, $kJ26n.invariant).warn(error);
            });
        }
    };
    InternalState.prototype.toApolloError = function(result) {
        return (0, $2emDS.isNonEmptyArray)(result.errors) ? new (0, $408uN.ApolloError)({
            graphQLErrors: result.errors
        }) : result.error;
    };
    InternalState.prototype.getCurrentResult = function() {
        // Using this.result as a cache ensures getCurrentResult continues returning
        // the same (===) result object, unless state.setResult has been called, or
        // we're doing server rendering and therefore override the result below.
        if (!this.result) this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult());
        return this.result;
    };
    InternalState.prototype.toQueryResult = function(result) {
        var queryResult = this.toQueryResultCache.get(result);
        if (queryResult) return queryResult;
        var data = result.data, partial = result.partial, resultWithoutPartial = (0, $l73V3.__rest)(result, [
            "data",
            "partial"
        ]);
        this.toQueryResultCache.set(result, queryResult = (0, $l73V3.__assign)((0, $l73V3.__assign)((0, $l73V3.__assign)({
            data: data
        }, resultWithoutPartial), this.obsQueryFields), {
            client: this.client,
            observable: this.observable,
            variables: this.observable.variables,
            called: !this.queryHookOptions.skip,
            previousData: this.previousData
        }));
        if (!queryResult.error && (0, $2emDS.isNonEmptyArray)(result.errors)) // Until a set naming convention for networkError and graphQLErrors is
        // decided upon, we map errors (graphQLErrors) to the error options.
        // TODO: Is it possible for both result.error and result.errors to be
        // defined here?
        queryResult.error = new (0, $408uN.ApolloError)({
            graphQLErrors: result.errors
        });
        return queryResult;
    };
    InternalState.prototype.unsafeHandlePartialRefetch = function(result) {
        // WARNING: SIDE-EFFECTS IN THE RENDER FUNCTION
        //
        // TODO: This code should be removed when the partialRefetch option is
        // removed. I was unable to get this hook to behave reasonably in certain
        // edge cases when this block was put in an effect.
        if (result.partial && this.queryHookOptions.partialRefetch && !result.loading && (!result.data || Object.keys(result.data).length === 0) && this.observable.options.fetchPolicy !== "cache-only") {
            Object.assign(result, {
                loading: true,
                networkStatus: (0, $8LKEl.NetworkStatus).refetch
            });
            this.observable.refetch();
        }
    };
    return InternalState;
}();

});
parcelRegister("cGdze", function(module, exports) {

$parcel$export(module.exports, "maybe", function () { return (parcelRequire("a3uyB")).maybe; });
$parcel$export(module.exports, "global", function () { return (parcelRequire("8tUce")).default; });
$parcel$export(module.exports, "invariant", function () { return (parcelRequire("kJ26n")).invariant; });
$parcel$export(module.exports, "newInvariantError", function () { return (parcelRequire("kJ26n")).newInvariantError; });

var $kJ26n = parcelRequire("kJ26n");

var $a3uyB = parcelRequire("a3uyB");

var $8tUce = parcelRequire("8tUce");
var $93b3ee6e12257aad$export$404582bc18fe4d9e = globalThis.__DEV__ !== false;

});
parcelRegister("kJ26n", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $f169a3fbe2960da4$export$f5708dca728d7177; });
$parcel$export(module.exports, "newInvariantError", function () { return $f169a3fbe2960da4$export$3991762405098ea; });

var $lhlbb = parcelRequire("lhlbb");

var $bE7kj = parcelRequire("bE7kj");

var $8tUce = parcelRequire("8tUce");

var $czO9u = parcelRequire("czO9u");
function $f169a3fbe2960da4$var$wrap(fn) {
    return function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (typeof message === "number") {
            var arg0 = message;
            message = $f169a3fbe2960da4$var$getHandledErrorMsg(arg0);
            if (!message) {
                message = $f169a3fbe2960da4$var$getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [
            message
        ].concat(args));
    };
}
var $f169a3fbe2960da4$export$f5708dca728d7177 = Object.assign(function invariant(condition, message) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (!condition) (0, $lhlbb.invariant)(condition, $f169a3fbe2960da4$var$getHandledErrorMsg(message, args) || $f169a3fbe2960da4$var$getFallbackErrorMsg(message, args));
}, {
    debug: $f169a3fbe2960da4$var$wrap((0, $lhlbb.invariant).debug),
    log: $f169a3fbe2960da4$var$wrap((0, $lhlbb.invariant).log),
    warn: $f169a3fbe2960da4$var$wrap((0, $lhlbb.invariant).warn),
    error: $f169a3fbe2960da4$var$wrap((0, $lhlbb.invariant).error)
});
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */ function $f169a3fbe2960da4$export$3991762405098ea(message) {
    var optionalParams = [];
    for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
    return new (0, $lhlbb.InvariantError)($f169a3fbe2960da4$var$getHandledErrorMsg(message, optionalParams) || $f169a3fbe2960da4$var$getFallbackErrorMsg(message, optionalParams));
}
var $f169a3fbe2960da4$export$b8ca975fa04efdf3 = Symbol.for("ApolloErrorMessageHandler_" + (0, $bE7kj.version));
function $f169a3fbe2960da4$var$stringify(arg) {
    return typeof arg == "string" ? arg : (0, $czO9u.stringifyForDisplay)(arg, 2).slice(0, 1000);
}
function $f169a3fbe2960da4$var$getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return (0, $8tUce.default)[$f169a3fbe2960da4$export$b8ca975fa04efdf3] && (0, $8tUce.default)[$f169a3fbe2960da4$export$b8ca975fa04efdf3](message, messageArgs.map($f169a3fbe2960da4$var$stringify));
}
function $f169a3fbe2960da4$var$getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: (0, $bE7kj.version),
        message: message,
        args: messageArgs.map($f169a3fbe2960da4$var$stringify)
    })));
}

});
parcelRegister("lhlbb", function(module, exports) {

$parcel$export(module.exports, "InvariantError", function () { return $f7db9d4d6e630980$export$cea12affaee22fe8; });
$parcel$export(module.exports, "invariant", function () { return $f7db9d4d6e630980$export$f5708dca728d7177; });

var $l73V3 = parcelRequire("l73V3");
var $f7db9d4d6e630980$var$genericMessage = "Invariant Violation";
var $f7db9d4d6e630980$var$_a = Object.setPrototypeOf, $f7db9d4d6e630980$var$setPrototypeOf = $f7db9d4d6e630980$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $f7db9d4d6e630980$var$_a;
var $f7db9d4d6e630980$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $l73V3.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $f7db9d4d6e630980$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $f7db9d4d6e630980$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $f7db9d4d6e630980$var$genericMessage;
        $f7db9d4d6e630980$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $f7db9d4d6e630980$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $f7db9d4d6e630980$export$cea12affaee22fe8(message);
}
var $f7db9d4d6e630980$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var $f7db9d4d6e630980$var$verbosityLevel = $f7db9d4d6e630980$var$verbosityLevels.indexOf("log");
function $f7db9d4d6e630980$var$wrapConsoleMethod(name) {
    return function() {
        if ($f7db9d4d6e630980$var$verbosityLevels.indexOf(name) >= $f7db9d4d6e630980$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = $f7db9d4d6e630980$var$wrapConsoleMethod("debug");
    invariant.log = $f7db9d4d6e630980$var$wrapConsoleMethod("log");
    invariant.warn = $f7db9d4d6e630980$var$wrapConsoleMethod("warn");
    invariant.error = $f7db9d4d6e630980$var$wrapConsoleMethod("error");
})($f7db9d4d6e630980$export$f5708dca728d7177 || ($f7db9d4d6e630980$export$f5708dca728d7177 = {}));
function $f7db9d4d6e630980$export$a80e09f2cd325fb8(level) {
    var old = $f7db9d4d6e630980$var$verbosityLevels[$f7db9d4d6e630980$var$verbosityLevel];
    $f7db9d4d6e630980$var$verbosityLevel = Math.max(0, $f7db9d4d6e630980$var$verbosityLevels.indexOf(level));
    return old;
}
var $f7db9d4d6e630980$export$2e2bcd8739ae039 = $f7db9d4d6e630980$export$f5708dca728d7177;

});

parcelRegister("bE7kj", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $87a91d0b35dcdcb4$export$83d89fbfd8236492; });
var $87a91d0b35dcdcb4$export$83d89fbfd8236492 = "3.9.6";

});

parcelRegister("8tUce", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62cc9f98832ab354$export$2e2bcd8739ae039; });

var $a3uyB = parcelRequire("a3uyB");
var $62cc9f98832ab354$export$2e2bcd8739ae039 = (0, $a3uyB.maybe)(function() {
    return globalThis;
}) || (0, $a3uyB.maybe)(function() {
    return window;
}) || (0, $a3uyB.maybe)(function() {
    return self;
}) || (0, $a3uyB.maybe)(function() {
    return $parcel$global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
(0, $a3uyB.maybe)(function() {
    return (0, $a3uyB.maybe).constructor("return this")();
});

});
parcelRegister("a3uyB", function(module, exports) {

$parcel$export(module.exports, "maybe", function () { return $7521e3305234e074$export$f8b8b9ce72e9ccbf; });
function $7521e3305234e074$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}

});


parcelRegister("czO9u", function(module, exports) {

$parcel$export(module.exports, "stringifyForDisplay", function () { return $927fa812e2d9c92a$export$f341b4883239463f; });

var $7AXen = parcelRequire("7AXen");
function $927fa812e2d9c92a$export$f341b4883239463f(value, space) {
    if (space === void 0) space = 0;
    var undefId = (0, $7AXen.makeUniqueId)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}

});
parcelRegister("7AXen", function(module, exports) {

$parcel$export(module.exports, "makeUniqueId", function () { return $5879d73dc2184116$export$d0c8ec0fe1b18b70; });
var $5879d73dc2184116$var$prefixCounts = new Map();
function $5879d73dc2184116$export$d0c8ec0fe1b18b70(prefix) {
    var count = $5879d73dc2184116$var$prefixCounts.get(prefix) || 1;
    $5879d73dc2184116$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}

});




parcelRegister("bEu9B", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $87bad20fc22f9452$export$306c0aa65ff9ec16; });
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $8Qw6M = parcelRequire("8Qw6M");

var $8L3vO = parcelRequire("8L3vO");
var $87bad20fc22f9452$var$didWarnUncachedGetSnapshot = false;
// Prevent webpack from complaining about our feature detection of the
// useSyncExternalStore property of the React namespace, which is expected not
// to exist when using React 17 and earlier, and that's fine.
var $87bad20fc22f9452$var$uSESKey = "useSyncExternalStore";
var $87bad20fc22f9452$var$realHook = $8Qw6M[$87bad20fc22f9452$var$uSESKey];
var $87bad20fc22f9452$export$306c0aa65ff9ec16 = $87bad20fc22f9452$var$realHook || function(subscribe, getSnapshot, getServerSnapshot) {
    // Read the current snapshot from the store on every render. Again, this
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    var value = getSnapshot();
    if (// DEVIATION: Using __DEV__
    globalThis.__DEV__ !== false && !$87bad20fc22f9452$var$didWarnUncachedGetSnapshot && // DEVIATION: Not using Object.is because we know our snapshots will never
    // be exotic primitive values like NaN, which is !== itself.
    value !== getSnapshot()) {
        $87bad20fc22f9452$var$didWarnUncachedGetSnapshot = true;
        // DEVIATION: Using invariant.error instead of console.error directly.
        globalThis.__DEV__ !== false && (0, $kJ26n.invariant).error(58);
    }
    // Because updates are synchronous, we don't queue them. Instead we force a
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    var _a = $8Qw6M.useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _a[0].inst, forceUpdate = _a[1];
    // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    if (0, $8L3vO.canUseLayoutEffect) // DEVIATION: We avoid calling useLayoutEffect when !canUseLayoutEffect,
    // which may seem like a conditional hook, but this code ends up behaving
    // unconditionally (one way or the other) because canUseLayoutEffect is
    // constant.
    $8Qw6M.useLayoutEffect(function() {
        Object.assign(inst, {
            value: value,
            getSnapshot: getSnapshot
        });
        // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($87bad20fc22f9452$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    else Object.assign(inst, {
        value: value,
        getSnapshot: getSnapshot
    });
    $8Qw6M.useEffect(function() {
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($87bad20fc22f9452$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        // Subscribe to the store and return a clean-up function.
        return subscribe(function handleStoreChange() {
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($87bad20fc22f9452$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    return value;
};
function $87bad20fc22f9452$var$checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    } catch (_b) {
        return true;
    }
}

});
parcelRegister("8L3vO", function(module, exports) {

$parcel$export(module.exports, "canUseWeakMap", function () { return $66056febcdc72439$export$772fbc04a0ad4ce9; });
$parcel$export(module.exports, "canUseWeakSet", function () { return $66056febcdc72439$export$7293b8a0b474028d; });
$parcel$export(module.exports, "canUseSymbol", function () { return $66056febcdc72439$export$23ba675b4b838b92; });
$parcel$export(module.exports, "canUseAsyncIteratorSymbol", function () { return $66056febcdc72439$export$c34f882e9f1c1637; });
$parcel$export(module.exports, "canUseLayoutEffect", function () { return $66056febcdc72439$export$4001f6cd4a62405b; });
parcelRequire("cGdze");
var $a3uyB = parcelRequire("a3uyB");
var $66056febcdc72439$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && !(0, $a3uyB.maybe)(function() {
    return navigator.product == "ReactNative" && !$parcel$global.HermesInternal;
});
var $66056febcdc72439$export$7293b8a0b474028d = typeof WeakSet === "function";
var $66056febcdc72439$export$23ba675b4b838b92 = typeof Symbol === "function" && typeof Symbol.for === "function";
var $66056febcdc72439$export$c34f882e9f1c1637 = $66056febcdc72439$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $66056febcdc72439$export$71594e8a50f746f4 = typeof (0, $a3uyB.maybe)(function() {
    return window.document.createElement;
}) === "function";
var $66056febcdc72439$var$usingJSDOM = // Following advice found in this comment from @domenic (maintainer of jsdom):
// https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
//
// Since we control the version of Jest and jsdom used when running Apollo
// Client tests, and that version is recent enought to include " jsdom/x.y.z"
// at the end of the user agent string, I believe this case is all we need to
// check. Testing for "Node.js" was recommended for backwards compatibility
// with older version of jsdom, but we don't have that problem.
(0, $a3uyB.maybe)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $66056febcdc72439$export$4001f6cd4a62405b = $66056febcdc72439$export$71594e8a50f746f4 && !$66056febcdc72439$var$usingJSDOM;

});


parcelRegister("62dod", function(module, exports) {

$parcel$export(module.exports, "equal", function () { return $464d50e117420d35$export$411ce8e5a71e3069; });
$parcel$export(module.exports, "default", function () { return $464d50e117420d35$export$2e2bcd8739ae039; });
const { toString: $464d50e117420d35$var$toString, hasOwnProperty: $464d50e117420d35$var$hasOwnProperty } = Object.prototype;
const $464d50e117420d35$var$fnToStr = Function.prototype.toString;
const $464d50e117420d35$var$previousComparisons = new Map();
function $464d50e117420d35$export$411ce8e5a71e3069(a, b) {
    try {
        return $464d50e117420d35$var$check(a, b);
    } finally{
        $464d50e117420d35$var$previousComparisons.clear();
    }
}
var // Allow default imports as well.
$464d50e117420d35$export$2e2bcd8739ae039 = $464d50e117420d35$export$411ce8e5a71e3069;
function $464d50e117420d35$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = $464d50e117420d35$var$toString.call(a);
    const bTag = $464d50e117420d35$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case "[object Array]":
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case "[object Object]":
            {
                if ($464d50e117420d35$var$previouslyCompared(a, b)) return true;
                const aKeys = $464d50e117420d35$var$definedKeys(a);
                const bKeys = $464d50e117420d35$var$definedKeys(b);
                // If `a` and `b` have a different number of enumerable keys, they
                // must be different.
                const keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                // Now make sure they have the same keys.
                for(let k = 0; k < keyCount; ++k){
                    if (!$464d50e117420d35$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                // Finally, check deep equality of all child properties.
                for(let k = 0; k < keyCount; ++k){
                    const key = aKeys[k];
                    if (!$464d50e117420d35$var$check(a[key], b[key])) return false;
                }
                return true;
            }
        case "[object Error]":
            return a.name === b.name && a.message === b.message;
        case "[object Number]":
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case "[object Boolean]":
        case "[object Date]":
            return +a === +b;
        case "[object RegExp]":
        case "[object String]":
            return a == `${b}`;
        case "[object Map]":
        case "[object Set]":
            {
                if (a.size !== b.size) return false;
                if ($464d50e117420d35$var$previouslyCompared(a, b)) return true;
                const aIterator = a.entries();
                const isMap = aTag === "[object Map]";
                while(true){
                    const info = aIterator.next();
                    if (info.done) break;
                    // If a instanceof Set, aValue === aKey.
                    const [aKey, aValue] = info.value;
                    // So this works the same way for both Set and Map.
                    if (!b.has(aKey)) return false;
                    // However, we care about deep equality of values only when dealing
                    // with Map structures.
                    if (isMap && !$464d50e117420d35$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
            }
        case "[object Uint16Array]":
        case "[object Uint8Array]":
        case "[object Uint32Array]":
        case "[object Int32Array]":
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object ArrayBuffer]":
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case "[object DataView]":
            {
                let len = a.byteLength;
                if (len === b.byteLength) {
                    while(len-- && a[len] === b[len]);
                }
                return len === -1;
            }
        case "[object AsyncFunction]":
        case "[object GeneratorFunction]":
        case "[object AsyncGeneratorFunction]":
        case "[object Function]":
            {
                const aCode = $464d50e117420d35$var$fnToStr.call(a);
                if (aCode !== $464d50e117420d35$var$fnToStr.call(b)) return false;
                // We consider non-native functions equal if they have the same code
                // (native functions require === because their code is censored).
                // Note that this behavior is not entirely sound, since !== function
                // objects with the same code can behave differently depending on
                // their closure scope. However, any function can behave differently
                // depending on the values of its input arguments (including this)
                // and its calling context (including its closure scope), even
                // though the function object is === to itself; and it is entirely
                // possible for functions that are not === to behave exactly the
                // same under all conceivable circumstances. Because none of these
                // factors are statically decidable in JavaScript, JS function
                // equality is not well-defined. This ambiguity allows us to
                // consider the best possible heuristic among various imperfect
                // options, and equating non-native functions that have the same
                // code has enormous practical benefits, such as when comparing
                // functions that are repeatedly passed as fresh function
                // expressions within objects that are otherwise deeply equal. Since
                // any function created from the same syntactic expression (in the
                // same code location) will always stringify to the same code
                // according to fnToStr.call, we can reasonably expect these
                // repeatedly passed function expressions to have the same code, and
                // thus behave "the same" (with all the caveats mentioned above),
                // even though the runtime function objects are !== to one another.
                return !$464d50e117420d35$var$endsWith(aCode, $464d50e117420d35$var$nativeCodeSuffix);
            }
    }
    // Otherwise the values are not equal.
    return false;
}
function $464d50e117420d35$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($464d50e117420d35$var$isDefinedKey, obj);
}
function $464d50e117420d35$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
const $464d50e117420d35$var$nativeCodeSuffix = "{ [native code] }";
function $464d50e117420d35$var$endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $464d50e117420d35$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = $464d50e117420d35$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $464d50e117420d35$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}

});

parcelRegister("2emDS", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $19fe73d501a42b98$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isNonEmptyArray", function () { return $19fe73d501a42b98$export$d307f5934e447d0e; });
// A version of Array.isArray that works better with readonly arrays.
var $19fe73d501a42b98$export$43bee75e5e14138e = Array.isArray;
function $19fe73d501a42b98$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}

});

parcelRegister("a7LxD", function(module, exports) {

$parcel$export(module.exports, "maybeDeepFreeze", function () { return $75ef6f90d97797e7$export$7f9c177735b71f18; });

var $dmNot = parcelRequire("dmNot");
function $75ef6f90d97797e7$var$deepFreeze(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ((0, $dmNot.isNonNullObject)(obj) && $75ef6f90d97797e7$var$shallowFreeze(obj) === obj) Object.getOwnPropertyNames(obj).forEach(function(name) {
            if ((0, $dmNot.isNonNullObject)(obj[name])) workSet.add(obj[name]);
        });
    });
    return value;
}
function $75ef6f90d97797e7$var$shallowFreeze(obj) {
    if (globalThis.__DEV__ !== false && !Object.isFrozen(obj)) try {
        Object.freeze(obj);
    } catch (e) {
        // Some types like Uint8Array and Node.js's Buffer cannot be frozen, but
        // they all throw a TypeError when you try, so we re-throw any exceptions
        // that are not TypeErrors, since that would be unexpected.
        if (e instanceof TypeError) return null;
        throw e;
    }
    return obj;
}
function $75ef6f90d97797e7$export$7f9c177735b71f18(obj) {
    if (globalThis.__DEV__ !== false) $75ef6f90d97797e7$var$deepFreeze(obj);
    return obj;
}

});
parcelRegister("dmNot", function(module, exports) {

$parcel$export(module.exports, "isNonNullObject", function () { return $9bb3a4fa5ddbcbb1$export$417207af72fad9c9; });
function $9bb3a4fa5ddbcbb1$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}
function $9bb3a4fa5ddbcbb1$export$53b83ca8eaab0383(obj) {
    return obj !== null && typeof obj === "object" && (Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null);
}

});


parcelRegister("lj0SF", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", function () { return $f82c0e363c65b7f7$export$a47505d961ee3a1; });

var $8Qw6M = parcelRequire("8Qw6M");

var $8L3vO = parcelRequire("8L3vO");
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");
// To make sure Apollo Client doesn't create more than one React context
// (which can lead to problems like having an Apollo Client instance added
// in one context, then attempting to retrieve it from another different
// context), a single Apollo context is created and tracked in global state.
var $f82c0e363c65b7f7$var$contextKey = (0, $8L3vO.canUseSymbol) ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function $f82c0e363c65b7f7$export$a47505d961ee3a1() {
    (0, $kJ26n.invariant)("createContext" in $8Qw6M, 45);
    var context = $8Qw6M.createContext[$f82c0e363c65b7f7$var$contextKey];
    if (!context) {
        Object.defineProperty($8Qw6M.createContext, $f82c0e363c65b7f7$var$contextKey, {
            value: context = $8Qw6M.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true
        });
        context.displayName = "ApolloContext";
    }
    return context;
}
var $f82c0e363c65b7f7$export$c2ee824bcc89ca6a = $f82c0e363c65b7f7$export$a47505d961ee3a1;

});

parcelRegister("408uN", function(module, exports) {

$parcel$export(module.exports, "PROTOCOL_ERRORS_SYMBOL", function () { return $2e9dc08f16582188$export$4995664c1b49842e; });
$parcel$export(module.exports, "graphQLResultHasProtocolErrors", function () { return $2e9dc08f16582188$export$345f95cc6b6b9b0b; });
$parcel$export(module.exports, "isApolloError", function () { return $2e9dc08f16582188$export$17f5e6bd290bb15d; });
$parcel$export(module.exports, "ApolloError", function () { return $2e9dc08f16582188$export$26a337512320b8c6; });

var $l73V3 = parcelRequire("l73V3");
parcelRequire("cGdze");

var $dmNot = parcelRequire("dmNot");
var $2e9dc08f16582188$export$4995664c1b49842e = Symbol();
function $2e9dc08f16582188$export$345f95cc6b6b9b0b(result) {
    if (result.extensions) return Array.isArray(result.extensions[$2e9dc08f16582188$export$4995664c1b49842e]);
    return false;
}
function $2e9dc08f16582188$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty("graphQLErrors");
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var $2e9dc08f16582188$var$generateErrorMessage = function(err) {
    var errors = (0, $l73V3.__spreadArray)((0, $l73V3.__spreadArray)((0, $l73V3.__spreadArray)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError) errors.push(err.networkError);
    return errors// The rest of the code sometimes unsafely types non-Error objects as GraphQLErrors
    .map(function(err) {
        return (0, $dmNot.isNonNullObject)(err) && err.message || "Error message not found.";
    }).join("\n");
};
var $2e9dc08f16582188$export$26a337512320b8c6 = /** @class */ function(_super) {
    (0, $l73V3.__extends)(ApolloError, _super);
    // Constructs an instance of ApolloError given a GraphQLError
    // or a network error. Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $2e9dc08f16582188$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        // We're not using `Object.setPrototypeOf` here as it isn't fully
        // supported on Android (see issue #3236).
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);

});

parcelRegister("8LKEl", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", function () { return $6626e62c176a8cd9$export$bd096ddbd246c79c; });
$parcel$export(module.exports, "isNetworkRequestInFlight", function () { return $6626e62c176a8cd9$export$37509604341a3464; });
/**
 * The current status of a query’s execution in our system.
 */ var $6626e62c176a8cd9$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */ NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */ NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */ NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */ NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */ NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */ NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */ NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($6626e62c176a8cd9$export$bd096ddbd246c79c || ($6626e62c176a8cd9$export$bd096ddbd246c79c = {}));
function $6626e62c176a8cd9$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
function $6626e62c176a8cd9$export$427e8a52ef0f96e2(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}

});

parcelRegister("kzepc", function(module, exports) {

$parcel$export(module.exports, "DocumentType", function () { return $ef924028609f658c$export$d1d99cf900472499; });
$parcel$export(module.exports, "verifyDocumentType", function () { return $ef924028609f658c$export$6dfb8732f737404c; });
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $7L6nN = parcelRequire("7L6nN");
var $iOXJM = parcelRequire("iOXJM");

var $3qXPo = parcelRequire("3qXPo");
var $ef924028609f658c$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($ef924028609f658c$export$d1d99cf900472499 || ($ef924028609f658c$export$d1d99cf900472499 = {}));
var $ef924028609f658c$var$cache;
function $ef924028609f658c$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $ef924028609f658c$export$d1d99cf900472499.Query:
            name = "Query";
            break;
        case $ef924028609f658c$export$d1d99cf900472499.Mutation:
            name = "Mutation";
            break;
        case $ef924028609f658c$export$d1d99cf900472499.Subscription:
            name = "Subscription";
            break;
    }
    return name;
}
function $ef924028609f658c$export$8f49e4af10703ce3(document) {
    if (!$ef924028609f658c$var$cache) $ef924028609f658c$var$cache = new (0, $7L6nN.AutoCleanedWeakCache)((0, $iOXJM.cacheSizes).parser || 1000 /* defaultCacheSizes.parser */ );
    var cached = $ef924028609f658c$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $kJ26n.invariant)(!!document && !!document.kind, 59, document);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for(var _i = 0, _a = document.definitions; _i < _a.length; _i++){
        var x = _a[_i];
        if (x.kind === "FragmentDefinition") {
            fragments.push(x);
            continue;
        }
        if (x.kind === "OperationDefinition") switch(x.operation){
            case "query":
                queries.push(x);
                break;
            case "mutation":
                mutations.push(x);
                break;
            case "subscription":
                subscriptions.push(x);
                break;
        }
    }
    (0, $kJ26n.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 60);
    (0, $kJ26n.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 61, document, queries.length, subscriptions.length, mutations.length);
    type = queries.length ? $ef924028609f658c$export$d1d99cf900472499.Query : $ef924028609f658c$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $ef924028609f658c$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $kJ26n.invariant)(definitions.length === 1, 62, document, definitions.length);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === "Name") name = definition.name.value;
    else name = "data"; // fallback to using data if no name
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $ef924028609f658c$var$cache.set(document, payload);
    return payload;
}
$ef924028609f658c$export$8f49e4af10703ce3.resetCache = function() {
    $ef924028609f658c$var$cache = undefined;
};
if (globalThis.__DEV__ !== false) (0, $3qXPo.registerGlobalCache)("parser", function() {
    return $ef924028609f658c$var$cache ? $ef924028609f658c$var$cache.size : 0;
});
function $ef924028609f658c$export$6dfb8732f737404c(document, type) {
    var operation = $ef924028609f658c$export$8f49e4af10703ce3(document);
    var requiredOperationName = $ef924028609f658c$export$5db520940cf00715(type);
    var usedOperationName = $ef924028609f658c$export$5db520940cf00715(operation.type);
    (0, $kJ26n.invariant)(operation.type === type, 63, requiredOperationName, requiredOperationName, usedOperationName);
}

});
parcelRegister("7L6nN", function(module, exports) {

$parcel$export(module.exports, "AutoCleanedWeakCache", function () { return $5a61dfb3a20b1d4b$export$8dbad6f439bb2331; });
$parcel$export(module.exports, "AutoCleanedStrongCache", function () { return $5a61dfb3a20b1d4b$export$5b4f745137d91413; });

var $komyO = parcelRequire("komyO");
var $9ouSO = parcelRequire("9ouSO");
var $5a61dfb3a20b1d4b$var$scheduledCleanup = new WeakSet();
function $5a61dfb3a20b1d4b$var$schedule(cache) {
    if (!$5a61dfb3a20b1d4b$var$scheduledCleanup.has(cache)) {
        $5a61dfb3a20b1d4b$var$scheduledCleanup.add(cache);
        setTimeout(function() {
            cache.clean();
            $5a61dfb3a20b1d4b$var$scheduledCleanup.delete(cache);
        }, 100);
    }
}
var $5a61dfb3a20b1d4b$export$8dbad6f439bb2331 = function(max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $9ouSO.WeakCache)(max, dispose);
    cache.set = function(key, value) {
        $5a61dfb3a20b1d4b$var$schedule(this);
        return (0, $9ouSO.WeakCache).prototype.set.call(this, key, value);
    };
    return cache;
};
var $5a61dfb3a20b1d4b$export$5b4f745137d91413 = function(max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $komyO.StrongCache)(max, dispose);
    cache.set = function(key, value) {
        $5a61dfb3a20b1d4b$var$schedule(this);
        return (0, $komyO.StrongCache).prototype.set.call(this, key, value);
    };
    return cache;
};

});
parcelRegister("komyO", function(module, exports) {

$parcel$export(module.exports, "StrongCache", function () { return $ed878c9226d6af1f$export$d3a0331d2c286dc8; });
function $ed878c9226d6af1f$var$defaultDispose() {}
class $ed878c9226d6af1f$export$d3a0331d2c286dc8 {
    constructor(max = Infinity, dispose = $ed878c9226d6af1f$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    get size() {
        return this.map.size;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}

});

parcelRegister("9ouSO", function(module, exports) {

$parcel$export(module.exports, "WeakCache", function () { return $6d6e4fb24809211d$export$87b462129af3b7d4; });
function $6d6e4fb24809211d$var$noop() {}
const $6d6e4fb24809211d$var$defaultDispose = $6d6e4fb24809211d$var$noop;
const $6d6e4fb24809211d$var$_WeakRef = typeof WeakRef !== "undefined" ? WeakRef : function(value) {
    return {
        deref: ()=>value
    };
};
const $6d6e4fb24809211d$var$_WeakMap = typeof WeakMap !== "undefined" ? WeakMap : Map;
const $6d6e4fb24809211d$var$_FinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : function() {
    return {
        register: $6d6e4fb24809211d$var$noop,
        unregister: $6d6e4fb24809211d$var$noop
    };
};
const $6d6e4fb24809211d$var$finalizationBatchSize = 10024;
class $6d6e4fb24809211d$export$87b462129af3b7d4 {
    constructor(max = Infinity, dispose = $6d6e4fb24809211d$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new $6d6e4fb24809211d$var$_WeakMap();
        this.newest = null;
        this.oldest = null;
        this.unfinalizedNodes = new Set();
        this.finalizationScheduled = false;
        this.size = 0;
        this.finalize = ()=>{
            const iterator = this.unfinalizedNodes.values();
            for(let i = 0; i < $6d6e4fb24809211d$var$finalizationBatchSize; i++){
                const node = iterator.next().value;
                if (!node) break;
                this.unfinalizedNodes.delete(node);
                const key = node.key;
                delete node.key;
                node.keyRef = new $6d6e4fb24809211d$var$_WeakRef(key);
                this.registry.register(key, node, node);
            }
            if (this.unfinalizedNodes.size > 0) queueMicrotask(this.finalize);
            else this.finalizationScheduled = false;
        };
        this.registry = new $6d6e4fb24809211d$var$_FinalizationRegistry(this.deleteNode.bind(this));
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.scheduleFinalization(node);
        this.map.set(key, node);
        this.size++;
        return node.value;
    }
    clean() {
        while(this.oldest && this.size > this.max)this.deleteNode(this.oldest);
    }
    deleteNode(node) {
        if (node === this.newest) this.newest = node.older;
        if (node === this.oldest) this.oldest = node.newer;
        if (node.newer) node.newer.older = node.older;
        if (node.older) node.older.newer = node.newer;
        this.size--;
        const key = node.key || node.keyRef && node.keyRef.deref();
        this.dispose(node.value, key);
        if (!node.keyRef) this.unfinalizedNodes.delete(node);
        else this.registry.unregister(node);
        if (key) this.map.delete(key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            this.deleteNode(node);
            return true;
        }
        return false;
    }
    scheduleFinalization(node) {
        this.unfinalizedNodes.add(node);
        if (!this.finalizationScheduled) {
            this.finalizationScheduled = true;
            queueMicrotask(this.finalize);
        }
    }
}

});


parcelRegister("iOXJM", function(module, exports) {

$parcel$export(module.exports, "cacheSizes", function () { return $db3b3c1d35fc6e16$export$f29926b23b28936b; });

var $l73V3 = parcelRequire("l73V3");
parcelRequire("cGdze");
var $8tUce = parcelRequire("8tUce");
var $db3b3c1d35fc6e16$var$cacheSizeSymbol = Symbol.for("apollo.cacheSize");
var $db3b3c1d35fc6e16$export$f29926b23b28936b = (0, $l73V3.__assign)({}, (0, $8tUce.default)[$db3b3c1d35fc6e16$var$cacheSizeSymbol]);

});

parcelRegister("3qXPo", function(module, exports) {

$parcel$export(module.exports, "registerGlobalCache", function () { return $28023565f65eaf76$export$a8fcd406d9e37621; });
$parcel$export(module.exports, "getApolloClientMemoryInternals", function () { return $28023565f65eaf76$export$dfdba94ce46d2ea5; });
$parcel$export(module.exports, "getInMemoryCacheMemoryInternals", function () { return $28023565f65eaf76$export$e95a5a2210e62466; });
$parcel$export(module.exports, "getApolloCacheMemoryInternals", function () { return $28023565f65eaf76$export$e7ed438e82606689; });

var $l73V3 = parcelRequire("l73V3");

var $iOXJM = parcelRequire("iOXJM");
var $28023565f65eaf76$var$globalCaches = {};
function $28023565f65eaf76$export$a8fcd406d9e37621(name, getSize) {
    $28023565f65eaf76$var$globalCaches[name] = getSize;
}
var $28023565f65eaf76$export$dfdba94ce46d2ea5 = globalThis.__DEV__ !== false ? $28023565f65eaf76$var$_getApolloClientMemoryInternals : undefined;
var $28023565f65eaf76$export$e95a5a2210e62466 = globalThis.__DEV__ !== false ? $28023565f65eaf76$var$_getInMemoryCacheMemoryInternals : undefined;
var $28023565f65eaf76$export$e7ed438e82606689 = globalThis.__DEV__ !== false ? $28023565f65eaf76$var$_getApolloCacheMemoryInternals : undefined;
function $28023565f65eaf76$var$getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    var defaults = {
        parser: 1000 /* defaultCacheSizes["parser"] */ ,
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */ ,
        print: 2000 /* defaultCacheSizes["print"] */ ,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */ ,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ ,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */ ,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */ ,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */ ,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */ ,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */ ,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ 
    };
    return Object.fromEntries(Object.entries(defaults).map(function(_a) {
        var k = _a[0], v = _a[1];
        return [
            k,
            (0, $iOXJM.cacheSizes)[k] || v
        ];
    }));
}
function $28023565f65eaf76$var$_getApolloClientMemoryInternals() {
    var _a, _b, _c, _d, _e;
    if (!(globalThis.__DEV__ !== false)) throw new Error("only supported in development mode");
    return {
        limits: $28023565f65eaf76$var$getCurrentCacheSizes(),
        sizes: (0, $l73V3.__assign)({
            print: (_a = $28023565f65eaf76$var$globalCaches.print) === null || _a === void 0 ? void 0 : _a.call($28023565f65eaf76$var$globalCaches),
            parser: (_b = $28023565f65eaf76$var$globalCaches.parser) === null || _b === void 0 ? void 0 : _b.call($28023565f65eaf76$var$globalCaches),
            canonicalStringify: (_c = $28023565f65eaf76$var$globalCaches.canonicalStringify) === null || _c === void 0 ? void 0 : _c.call($28023565f65eaf76$var$globalCaches),
            links: $28023565f65eaf76$var$linkInfo(this.link),
            queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: $28023565f65eaf76$var$transformInfo(this["queryManager"].documentTransform)
            }
        }, (_e = (_d = this.cache).getMemoryInternals) === null || _e === void 0 ? void 0 : _e.call(_d))
    };
}
function $28023565f65eaf76$var$_getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: $28023565f65eaf76$var$getWrapperInformation(this["getFragmentDoc"])
        }
    };
}
function $28023565f65eaf76$var$_getInMemoryCacheMemoryInternals() {
    var fragments = this.config.fragments;
    return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, $28023565f65eaf76$var$_getApolloCacheMemoryInternals.apply(this)), {
        addTypenameDocumentTransform: $28023565f65eaf76$var$transformInfo(this["addTypenameTransform"]),
        inMemoryCache: {
            executeSelectionSet: $28023565f65eaf76$var$getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: $28023565f65eaf76$var$getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: $28023565f65eaf76$var$getWrapperInformation(this["maybeBroadcastWatch"])
        },
        fragmentRegistry: {
            findFragmentSpreads: $28023565f65eaf76$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.findFragmentSpreads),
            lookup: $28023565f65eaf76$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.lookup),
            transform: $28023565f65eaf76$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.transform)
        }
    });
}
function $28023565f65eaf76$var$isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function $28023565f65eaf76$var$getWrapperInformation(f) {
    return $28023565f65eaf76$var$isWrapper(f) ? f.size : undefined;
}
function $28023565f65eaf76$var$isDefined(value) {
    return value != null;
}
function $28023565f65eaf76$var$transformInfo(transform) {
    return $28023565f65eaf76$var$recurseTransformInfo(transform).map(function(cache) {
        return {
            cache: cache
        };
    });
}
function $28023565f65eaf76$var$recurseTransformInfo(transform) {
    return transform ? (0, $l73V3.__spreadArray)((0, $l73V3.__spreadArray)([
        $28023565f65eaf76$var$getWrapperInformation(transform === null || transform === void 0 ? void 0 : transform["performWork"])
    ], $28023565f65eaf76$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["left"]), true), $28023565f65eaf76$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["right"]), true).filter($28023565f65eaf76$var$isDefined) : [];
}
function $28023565f65eaf76$var$linkInfo(link) {
    var _a;
    return link ? (0, $l73V3.__spreadArray)((0, $l73V3.__spreadArray)([
        (_a = link === null || link === void 0 ? void 0 : link.getMemoryInternals) === null || _a === void 0 ? void 0 : _a.call(link)
    ], $28023565f65eaf76$var$linkInfo(link === null || link === void 0 ? void 0 : link.left), true), $28023565f65eaf76$var$linkInfo(link === null || link === void 0 ? void 0 : link.right), true).filter($28023565f65eaf76$var$isDefined) : [];
}

});


parcelRegister("4VYKF", function(module, exports) {

$parcel$export(module.exports, "useApolloClient", function () { return $397b9c5280aadaf5$export$eb9a56e7a29e494; });
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $8Qw6M = parcelRequire("8Qw6M");

var $lj0SF = parcelRequire("lj0SF");
function $397b9c5280aadaf5$export$eb9a56e7a29e494(override) {
    var context = $8Qw6M.useContext((0, $lj0SF.getApolloContext)());
    var client = override || context.client;
    (0, $kJ26n.invariant)(!!client, 49);
    return client;
}

});

parcelRegister("f4NIL", function(module, exports) {

$parcel$export(module.exports, "wrapHook", function () { return $af9dcc44a125d093$export$7f12579c79e39619; });
var $af9dcc44a125d093$var$wrapperSymbol = Symbol.for("apollo.hook.wrappers");
function $af9dcc44a125d093$export$7f12579c79e39619(hookName, useHook, clientOrObsQuery) {
    var queryManager = clientOrObsQuery["queryManager"];
    var wrappers = queryManager && queryManager[$af9dcc44a125d093$var$wrapperSymbol];
    var wrapper = wrappers && wrappers[hookName];
    return wrapper ? wrapper(useHook) : useHook;
}

});



parcelRegister("jCAzD", function(module, exports) {

$parcel$export(module.exports, "useMutation", function () { return $e48defb66ba9fa8e$export$609860bf8b0084c; });

var $l73V3 = parcelRequire("l73V3");

var $8Qw6M = parcelRequire("8Qw6M");

var $2ZAj9 = parcelRequire("2ZAj9");

var $62dod = parcelRequire("62dod");

var $kzepc = parcelRequire("kzepc");

var $408uN = parcelRequire("408uN");

var $4VYKF = parcelRequire("4VYKF");
function $e48defb66ba9fa8e$export$609860bf8b0084c(mutation, options) {
    var client = (0, $4VYKF.useApolloClient)(options === null || options === void 0 ? void 0 : options.client);
    (0, $kzepc.verifyDocumentType)(mutation, (0, $kzepc.DocumentType).Mutation);
    var _a = $8Qw6M.useState({
        called: false,
        loading: false,
        client: client
    }), result = _a[0], setResult = _a[1];
    var ref = $8Qw6M.useRef({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options
    });
    Object.assign(ref.current, {
        client: client,
        options: options,
        mutation: mutation
    });
    var execute = $8Qw6M.useCallback(function(executeOptions) {
        if (executeOptions === void 0) executeOptions = {};
        var _a = ref.current, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
            mutation: mutation
        });
        var client = executeOptions.client || ref.current.client;
        if (!ref.current.result.loading && !baseOptions.ignoreResults && ref.current.isMounted) setResult(ref.current.result = {
            loading: true,
            error: void 0,
            data: void 0,
            called: true,
            client: client
        });
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0, $2ZAj9.mergeOptions)(baseOptions, executeOptions);
        return client.mutate(clientOptions).then(function(response) {
            var _a, _b;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ? new (0, $408uN.ApolloError)({
                graphQLErrors: errors
            }) : void 0;
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (error && onError) onError(error, clientOptions);
            if (mutationId === ref.current.mutationId && !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client
                };
                if (ref.current.isMounted && !(0, $62dod.equal)(ref.current.result, result_1)) setResult(ref.current.result = result_1);
            }
            var onCompleted = executeOptions.onCompleted || ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onCompleted);
            if (!error) onCompleted === null || onCompleted === void 0 || onCompleted(response.data, clientOptions);
            return response;
        }).catch(function(error) {
            var _a;
            if (mutationId === ref.current.mutationId && ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client
                };
                if (!(0, $62dod.equal)(ref.current.result, result_2)) setResult(ref.current.result = result_2);
            }
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (onError) {
                onError(error, clientOptions);
                // TODO(brian): why are we returning this here???
                return {
                    data: void 0,
                    errors: error
                };
            }
            throw error;
        });
    }, []);
    var reset = $8Qw6M.useCallback(function() {
        if (ref.current.isMounted) {
            var result_3 = {
                called: false,
                loading: false,
                client: client
            };
            Object.assign(ref.current, {
                mutationId: 0,
                result: result_3
            });
            setResult(result_3);
        }
    }, []);
    $8Qw6M.useEffect(function() {
        ref.current.isMounted = true;
        return function() {
            ref.current.isMounted = false;
        };
    }, []);
    return [
        execute,
        (0, $l73V3.__assign)({
            reset: reset
        }, result)
    ];
}

});

parcelRegister("fnLzi", function(module, exports) {

$parcel$export(module.exports, "useSubscription", function () { return $b32de70d80d1356a$export$368b4214baeb914c; });
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $8Qw6M = parcelRequire("8Qw6M");

var $62dod = parcelRequire("62dod");

var $kzepc = parcelRequire("kzepc");

var $4VYKF = parcelRequire("4VYKF");
function $b32de70d80d1356a$export$368b4214baeb914c(subscription, options) {
    var hasIssuedDeprecationWarningRef = $8Qw6M.useRef(false);
    var client = (0, $4VYKF.useApolloClient)(options === null || options === void 0 ? void 0 : options.client);
    (0, $kzepc.verifyDocumentType)(subscription, (0, $kzepc.DocumentType).Subscription);
    var _a = $8Qw6M.useState({
        loading: !(options === null || options === void 0 ? void 0 : options.skip),
        error: void 0,
        data: void 0,
        variables: options === null || options === void 0 ? void 0 : options.variables
    }), result = _a[0], setResult = _a[1];
    if (!hasIssuedDeprecationWarningRef.current) {
        hasIssuedDeprecationWarningRef.current = true;
        if (options === null || options === void 0 ? void 0 : options.onSubscriptionData) globalThis.__DEV__ !== false && (0, $kJ26n.invariant).warn(options.onData ? 52 : 53);
        if (options === null || options === void 0 ? void 0 : options.onSubscriptionComplete) globalThis.__DEV__ !== false && (0, $kJ26n.invariant).warn(options.onComplete ? 54 : 55);
    }
    var _b = $8Qw6M.useState(function() {
        if (options === null || options === void 0 ? void 0 : options.skip) return null;
        return client.subscribe({
            query: subscription,
            variables: options === null || options === void 0 ? void 0 : options.variables,
            fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
            context: options === null || options === void 0 ? void 0 : options.context
        });
    }), observable = _b[0], setObservable = _b[1];
    var canResetObservableRef = $8Qw6M.useRef(false);
    $8Qw6M.useEffect(function() {
        return function() {
            canResetObservableRef.current = true;
        };
    }, []);
    var ref = $8Qw6M.useRef({
        client: client,
        subscription: subscription,
        options: options
    });
    $8Qw6M.useEffect(function() {
        var _a, _b, _c, _d;
        var shouldResubscribe = options === null || options === void 0 ? void 0 : options.shouldResubscribe;
        if (typeof shouldResubscribe === "function") shouldResubscribe = !!shouldResubscribe(options);
        if (options === null || options === void 0 ? void 0 : options.skip) {
            if (!(options === null || options === void 0 ? void 0 : options.skip) !== !((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.skip) || canResetObservableRef.current) {
                setResult({
                    loading: false,
                    data: void 0,
                    error: void 0,
                    variables: options === null || options === void 0 ? void 0 : options.variables
                });
                setObservable(null);
                canResetObservableRef.current = false;
            }
        } else if (shouldResubscribe !== false && (client !== ref.current.client || subscription !== ref.current.subscription || (options === null || options === void 0 ? void 0 : options.fetchPolicy) !== ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || !(options === null || options === void 0 ? void 0 : options.skip) !== !((_c = ref.current.options) === null || _c === void 0 ? void 0 : _c.skip) || !(0, $62dod.equal)(options === null || options === void 0 ? void 0 : options.variables, (_d = ref.current.options) === null || _d === void 0 ? void 0 : _d.variables)) || canResetObservableRef.current) {
            setResult({
                loading: true,
                data: void 0,
                error: void 0,
                variables: options === null || options === void 0 ? void 0 : options.variables
            });
            setObservable(client.subscribe({
                query: subscription,
                variables: options === null || options === void 0 ? void 0 : options.variables,
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                context: options === null || options === void 0 ? void 0 : options.context
            }));
            canResetObservableRef.current = false;
        }
        Object.assign(ref.current, {
            client: client,
            subscription: subscription,
            options: options
        });
    }, [
        client,
        subscription,
        options,
        canResetObservableRef.current
    ]);
    $8Qw6M.useEffect(function() {
        if (!observable) return;
        var subscriptionStopped = false;
        var subscription = observable.subscribe({
            next: function(fetchResult) {
                var _a, _b;
                if (subscriptionStopped) return;
                var result = {
                    loading: false,
                    // TODO: fetchResult.data can be null but SubscriptionResult.data
                    // expects TData | undefined only
                    data: fetchResult.data,
                    error: void 0,
                    variables: options === null || options === void 0 ? void 0 : options.variables
                };
                setResult(result);
                if ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onData) ref.current.options.onData({
                    client: client,
                    data: result
                });
                else if ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onSubscriptionData) ref.current.options.onSubscriptionData({
                    client: client,
                    subscriptionData: result
                });
            },
            error: function(error) {
                var _a, _b;
                if (!subscriptionStopped) {
                    setResult({
                        loading: false,
                        data: void 0,
                        error: error,
                        variables: options === null || options === void 0 ? void 0 : options.variables
                    });
                    (_b = (_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError) === null || _b === void 0 || _b.call(_a, error);
                }
            },
            complete: function() {
                var _a, _b;
                if (!subscriptionStopped) {
                    if ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onComplete) ref.current.options.onComplete();
                    else if ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onSubscriptionComplete) ref.current.options.onSubscriptionComplete();
                }
            }
        });
        return function() {
            // immediately stop receiving subscription values, but do not unsubscribe
            // until after a short delay in case another useSubscription hook is
            // reusing the same underlying observable and is about to subscribe
            subscriptionStopped = true;
            setTimeout(function() {
                subscription.unsubscribe();
            });
        };
    }, [
        observable
    ]);
    return result;
}

});


parcelRegister("hsjD5", function(module, exports) {

$parcel$export(module.exports, "getTabStyle", function () { return $73108c43d0a15e12$export$5e1e69e164c91c77; });
$parcel$export(module.exports, "getOuterStyle", function () { return $73108c43d0a15e12$export$10606c91c68f8bb9; });
$parcel$export(module.exports, "getInfoWrapperTabStyle", function () { return $73108c43d0a15e12$export$370642e0ae0cafcc; });
$parcel$export(module.exports, "getRequiredFieldLabelColor", function () { return $73108c43d0a15e12$export$3922797c30fa07c9; });
$parcel$export(module.exports, "getLabelColor", function () { return $73108c43d0a15e12$export$627d17b212b38ee0; });
$parcel$export(module.exports, "getMembershipColors", function () { return $73108c43d0a15e12$export$c6c2f794da2d6be6; });
$parcel$export(module.exports, "getMassMailColors", function () { return $73108c43d0a15e12$export$e033f58a75b2c32f; });
$parcel$export(module.exports, "DATE_FORMAT", function () { return $73108c43d0a15e12$export$45c85543ba71221d; });
$parcel$export(module.exports, "renderDateString", function () { return $73108c43d0a15e12$export$3a6708e815f1ccd1; });
$parcel$export(module.exports, "renderDate", function () { return $73108c43d0a15e12$export$3ddec199482be5a9; });
$parcel$export(module.exports, "iconStyle", function () { return $73108c43d0a15e12$export$dcc3981cc6efe940; });
$parcel$export(module.exports, "renderNullableDate", function () { return $73108c43d0a15e12$export$83ab6fe37466fc13; });
$parcel$export(module.exports, "FormatTableData", function () { return $73108c43d0a15e12$export$c64b06579a9cfb05; });

var $6L9uu = parcelRequire("6L9uu");

var $2eJeT = parcelRequire("2eJeT");

var $aM783 = parcelRequire("aM783");
const $73108c43d0a15e12$var$tabStyle = {
    common: {
        color: (0, $6L9uu.Colors).skyBlue + "CC !important",
        fontSize: "22px",
        textTransform: "none"
    },
    default_tab: {
        backgroundColor: "#E4F1FF",
        borderBottom: "0.8px solid" + (0, $6L9uu.Colors).third
    },
    active_tab: {
        backgroundColor: "white",
        fontWeight: "bold"
    },
    leftBorder: {
        borderLeft: "2px solid" + (0, $6L9uu.Colors).third
    }
};
const $73108c43d0a15e12$var$membershipColorOptions = {
    FULL: {
        color: (0, $6L9uu.Colors).green
    },
    ASSOC: {
        color: (0, $6L9uu.Colors).warning
    },
    TRIAL: {
        color: (0, $6L9uu.Colors).main
    },
    ACAD: {
        color: (0, $6L9uu.Colors).gray
    },
    "BPR FULL": {
        color: (0, $6L9uu.Colors).purple
    }
};
const $73108c43d0a15e12$var$mailColorOptions = {
    sent: {
        color: (0, $6L9uu.DashboardColors).light_blue
    },
    delivered: {
        color: (0, $6L9uu.Colors).main
    },
    read: {
        color: (0, $6L9uu.Colors).green
    },
    blocks: {
        color: (0, $6L9uu.DashboardColors).dark_yellow
    },
    bounces: {
        color: (0, $6L9uu.Colors).purple
    },
    spam_reports: {
        color: (0, $6L9uu.Colors).red
    }
};
const $73108c43d0a15e12$var$outerTabStyle = {
    common: {
        textTransform: "none",
        fontSize: "20px",
        borderBottom: "1px solid " + (0, $6L9uu.Colors).main
    },
    default_tab: {
        color: (0, $6L9uu.Colors).main + "99"
    },
    active_tab: {
        color: (0, $6L9uu.Colors).main
    }
};
const $73108c43d0a15e12$var$infoWrapperTabStyle = {
    common: {
        height: "60px"
    },
    default_tab: {
        color: (0, $6L9uu.Colors).white + "99"
    },
    active_tab: {
        color: (0, $6L9uu.Colors).white
    }
};
const $73108c43d0a15e12$export$5e1e69e164c91c77 = (index, tabValue)=>{
    let result = index === tabValue ? {
        ...$73108c43d0a15e12$var$tabStyle.common,
        ...$73108c43d0a15e12$var$tabStyle.active_tab
    } : {
        ...$73108c43d0a15e12$var$tabStyle.common,
        ...$73108c43d0a15e12$var$tabStyle.default_tab
    };
    if (index > 0) result = {
        ...result,
        ...$73108c43d0a15e12$var$tabStyle.leftBorder
    };
    return result;
};
const $73108c43d0a15e12$export$10606c91c68f8bb9 = (index, tabValue)=>{
    const result = index === tabValue ? {
        ...$73108c43d0a15e12$var$outerTabStyle.common,
        ...$73108c43d0a15e12$var$outerTabStyle.active_tab
    } : {
        ...$73108c43d0a15e12$var$outerTabStyle.common,
        ...$73108c43d0a15e12$var$outerTabStyle.default_tab
    };
    return result;
};
const $73108c43d0a15e12$export$370642e0ae0cafcc = (index, tabValue)=>{
    const result = index === tabValue ? {
        ...$73108c43d0a15e12$var$infoWrapperTabStyle.common,
        ...$73108c43d0a15e12$var$infoWrapperTabStyle.active_tab
    } : {
        ...$73108c43d0a15e12$var$infoWrapperTabStyle.common,
        ...$73108c43d0a15e12$var$infoWrapperTabStyle.default_tab
    };
    return result;
};
const $73108c43d0a15e12$export$3922797c30fa07c9 = (isEditMode, prop)=>{
    return isEditMode ? prop !== null ? "red" : (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray;
};
const $73108c43d0a15e12$export$627d17b212b38ee0 = (isEditMode)=>{
    return isEditMode ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray;
};
const $73108c43d0a15e12$export$93ec50bc7b608371 = (isEditMode)=>{
    return $73108c43d0a15e12$export$627d17b212b38ee0(isEditMode);
};
const $73108c43d0a15e12$export$c6c2f794da2d6be6 = (input)=>{
    const result = input.map((i)=>$73108c43d0a15e12$var$membershipColorOptions[i.membership_type]?.color);
    return result;
};
const $73108c43d0a15e12$export$e033f58a75b2c32f = (input)=>{
    if (input.length > 0) {
        const props = Object.keys(input[0]);
        const colors = props.map((p)=>$73108c43d0a15e12$var$mailColorOptions[p]?.color);
        const result = colors.filter((c)=>c !== undefined);
        return result;
    }
    const props = Object.keys($73108c43d0a15e12$var$mailColorOptions);
    return props.map((p)=>$73108c43d0a15e12$var$mailColorOptions[p].color);
};
const $73108c43d0a15e12$export$45c85543ba71221d = "dd.MM.yyyy";
const $73108c43d0a15e12$export$3a6708e815f1ccd1 = (input)=>{
    const date = new Date(input).getTime().toString();
    return $73108c43d0a15e12$export$3ddec199482be5a9(date, (0, $aM783.DATE_TIME_FORMATS).DATE);
};
const $73108c43d0a15e12$export$3ddec199482be5a9 = (input, format)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(parseInt(input)).format(format ?? "DD-MM-yy");
};
const $73108c43d0a15e12$export$dcc3981cc6efe940 = {
    verticalAlign: "middle",
    marginBottom: "4px",
    marginRight: "2px"
};
const $73108c43d0a15e12$export$83ab6fe37466fc13 = (input, format)=>{
    if (input) return $73108c43d0a15e12$export$3ddec199482be5a9(input, format);
    else return null;
};
const $73108c43d0a15e12$export$c64b06579a9cfb05 = (data)=>{
    return data ? data.map((m)=>({
            ...m
        })) : [];
};

});
parcelRegister("6L9uu", function(module, exports) {

$parcel$export(module.exports, "DashboardColors", function () { return $3a18437a4c8f3324$export$b95467d0a7018d5; });
$parcel$export(module.exports, "Colors", function () { return $3a18437a4c8f3324$export$c537fa0d021d010b; });
$parcel$export(module.exports, "createMainButton", function () { return $3a18437a4c8f3324$export$8a396d23e625a4af; });
$parcel$export(module.exports, "buttons", function () { return $3a18437a4c8f3324$export$bbea856fdb3e3c5f; });
$parcel$export(module.exports, "shapes", function () { return $3a18437a4c8f3324$export$4ff7fc6f1af248b5; });
$parcel$export(module.exports, "buildTheme", function () { return $3a18437a4c8f3324$export$13bd1c7da1371a70; });

var $gcMmG = parcelRequire("gcMmG");

var $79Qyg = parcelRequire("79Qyg");
const $3a18437a4c8f3324$export$b95467d0a7018d5 = {
    title: "#6C6C6C",
    light_blue: "#1EE1CF",
    dark_yellow: "#DFDC1F"
};
const $3a18437a4c8f3324$export$c537fa0d021d010b = {
    main: "#12497F",
    secondary: "#2274BC",
    third: "#69AAF3",
    gradient: "transparent linear-gradient(270deg, #2274BC 0%, #12497F 100%) 0% 0% no-repeat padding-box",
    white: "#FFFFFF",
    gray: "#C6C5C2",
    dark_gray: "#8B8B8B",
    skyBlue: "#0EAEFF",
    lightBlue: "#E3F5FE",
    modalBackground: "#12497FCC 0% 0% no-repeat padding-box",
    green: "#82CD2B",
    red: "#F44336",
    orange: "#FF5722",
    warning: "#EBA61C",
    pink: "#ED2AED",
    purple: "#5507BD",
    dark_green: "#00BBA8",
    box_shadow_color: "#69AAF34D",
    input_background: "#EDF2F7",
    input_field_background: "#E0E8F294"
};
const $3a18437a4c8f3324$var$disabledProps = {
    "&:disabled": {
        background: $3a18437a4c8f3324$export$c537fa0d021d010b.gray,
        color: $3a18437a4c8f3324$export$c537fa0d021d010b.white,
        border: "none"
    }
};
const $3a18437a4c8f3324$export$8a396d23e625a4af = {
    ...(0, $79Qyg.predefinedFonts).semiBold14px22px,
    // width: '180px',
    height: "36px",
    // background: Colors.gradient,
    background: $3a18437a4c8f3324$export$c537fa0d021d010b.skyBlue,
    boxShadow: "0px 2px 10px #69AAF34D",
    zIndex: 1,
    opacity: "1",
    // borderRadius: '2px',
    borderRadius: "8px",
    "&:hover": {
        // background: Colors.gradient,
        background: $3a18437a4c8f3324$export$c537fa0d021d010b.skyBlue,
        boxShadow: "0px 2px 10px #69AAF34D",
        borderRadius: "8px"
    },
    ...$3a18437a4c8f3324$var$disabledProps
};
const $3a18437a4c8f3324$export$84c5f8ac4615b79f = {
    ...(0, $79Qyg.predefinedFonts).Bold["12px17px"],
    width: "126px",
    height: "30px",
    border: "1px solid " + $3a18437a4c8f3324$export$c537fa0d021d010b.secondary,
    // boxShadow: '0px 2px 10px #69AAF34D',
    color: $3a18437a4c8f3324$export$c537fa0d021d010b.secondary,
    zIndex: 1,
    opacity: "1",
    borderRadius: "2px",
    "&:hover": {
        boxShadow: "0px 2px 10px #69AAF34D",
        borderRadius: "2px"
    },
    ...$3a18437a4c8f3324$var$disabledProps
};
const $3a18437a4c8f3324$export$93e1a85926f756bf = {
    color: $3a18437a4c8f3324$export$c537fa0d021d010b.skyBlue + "CC",
    textDecoration: "underline"
};
const $3a18437a4c8f3324$var$saveButtonProps = {
    background: $3a18437a4c8f3324$export$c537fa0d021d010b.secondary + " 0% 0% no-repeat padding-box",
    opacity: "1",
    width: "125px",
    height: "36px",
    ...(0, $79Qyg.predefinedFonts).semiBold14px22px,
    color: $3a18437a4c8f3324$export$c537fa0d021d010b.white,
    marginLeft: "20px",
    textTransform: "uppercase",
    borderRadius: "10px"
};
const $3a18437a4c8f3324$export$3a57bbc0fbe4b744 = {
    ...$3a18437a4c8f3324$var$saveButtonProps,
    "&:hover": {
        ...$3a18437a4c8f3324$var$saveButtonProps
    }
};
const $3a18437a4c8f3324$var$cancelButtonProps = {
    width: "auto",
    minWidth: "125px",
    paddingX: "16px",
    height: "36px",
    border: "1px solid " + $3a18437a4c8f3324$export$c537fa0d021d010b.secondary,
    ...(0, $79Qyg.predefinedFonts).semiBold14px22px,
    color: $3a18437a4c8f3324$export$c537fa0d021d010b.secondary,
    textTransform: "uppercase",
    borderRadius: "10px"
};
const $3a18437a4c8f3324$export$4ededb8e5b56a6fb = {
    ...$3a18437a4c8f3324$var$cancelButtonProps,
    "&:hover": {
        ...$3a18437a4c8f3324$var$cancelButtonProps,
        background: $3a18437a4c8f3324$export$c537fa0d021d010b.secondary,
        color: $3a18437a4c8f3324$export$c537fa0d021d010b.white
    }
};
const $3a18437a4c8f3324$export$7abe78e1eda562aa = {
    ...(0, $79Qyg.predefinedFonts).semiBold14px22px,
    background: $3a18437a4c8f3324$export$c537fa0d021d010b.gradient,
    boxShadow: "none",
    color: $3a18437a4c8f3324$export$c537fa0d021d010b.white,
    textTransform: "uppercase",
    height: "36px",
    "&:hover": {
        ...(0, $79Qyg.predefinedFonts).semiBold14px22px,
        border: "solid 2px transparent",
        backgroundImage: "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), linear-gradient(101deg, " + $3a18437a4c8f3324$export$c537fa0d021d010b.main + " ," + $3a18437a4c8f3324$export$c537fa0d021d010b.secondary + ")",
        backgroundOrigin: "border-box",
        backgroundClip: "content-box, border-box",
        boxShadow: "2px 1000px 1px #fff inset",
        color: $3a18437a4c8f3324$export$c537fa0d021d010b.main,
        height: "36px"
    }
};
const $3a18437a4c8f3324$export$bf50a968cccf622e = {
    ...(0, $79Qyg.predefinedFonts).semiBold14px22px,
    ...$3a18437a4c8f3324$export$8a396d23e625a4af,
    width: "auto",
    margin: 0
};
const $3a18437a4c8f3324$var$selectedButtonProps = {
    ...(0, $79Qyg.fonts).Predefined.semiBold14px22px,
    textTransform: "none",
    boxShadow: "none",
    zIndex: 1,
    opacity: "1",
    width: "auto",
    height: "36px",
    background: $3a18437a4c8f3324$export$c537fa0d021d010b.skyBlue,
    color: $3a18437a4c8f3324$export$c537fa0d021d010b.white,
    border: `1px solid ${$3a18437a4c8f3324$export$c537fa0d021d010b.skyBlue}`,
    marginLeft: "10px"
};
const $3a18437a4c8f3324$export$e3b9e527d5a42b4e = {
    ...$3a18437a4c8f3324$var$selectedButtonProps,
    "&:hover": {
        boxShadow: "none",
        background: $3a18437a4c8f3324$export$c537fa0d021d010b.white,
        color: $3a18437a4c8f3324$export$c537fa0d021d010b.skyBlue
    }
};
const $3a18437a4c8f3324$var$deSelectedButtonProps = {
    ...(0, $79Qyg.fonts).Predefined.semiBold14px22px,
    textTransform: "none",
    boxShadow: "none",
    zIndex: 1,
    opacity: "1",
    width: "auto",
    height: "36px",
    background: $3a18437a4c8f3324$export$c537fa0d021d010b.white,
    color: $3a18437a4c8f3324$export$c537fa0d021d010b.skyBlue,
    border: `1px solid ${$3a18437a4c8f3324$export$c537fa0d021d010b.skyBlue}`,
    marginLeft: "10px"
};
const $3a18437a4c8f3324$export$746dd0c0ac3d180 = {
    ...$3a18437a4c8f3324$var$deSelectedButtonProps,
    "&:hover": {
        background: $3a18437a4c8f3324$export$c537fa0d021d010b.skyBlue,
        color: $3a18437a4c8f3324$export$c537fa0d021d010b.white,
        boxShadow: "none"
    }
};
const $3a18437a4c8f3324$export$bbea856fdb3e3c5f = {
    createMain: $3a18437a4c8f3324$export$8a396d23e625a4af,
    createSecondary: $3a18437a4c8f3324$export$84c5f8ac4615b79f,
    edit: $3a18437a4c8f3324$export$93e1a85926f756bf,
    save: $3a18437a4c8f3324$export$3a57bbc0fbe4b744,
    cancel: $3a18437a4c8f3324$export$4ededb8e5b56a6fb,
    loginButton: $3a18437a4c8f3324$export$7abe78e1eda562aa,
    overviewCreate: $3a18437a4c8f3324$export$bf50a968cccf622e,
    selected: $3a18437a4c8f3324$export$e3b9e527d5a42b4e,
    deSelected: $3a18437a4c8f3324$export$746dd0c0ac3d180
};
const $3a18437a4c8f3324$export$4ff7fc6f1af248b5 = {
    borderRadius: 8
};
const $3a18437a4c8f3324$export$13bd1c7da1371a70 = ()=>{
    const theme = (0, $gcMmG.default)({
        palette: {
            primary: {
                main: $3a18437a4c8f3324$export$c537fa0d021d010b.main,
                light: $3a18437a4c8f3324$export$c537fa0d021d010b.secondary
            },
            error: {
                main: $3a18437a4c8f3324$export$c537fa0d021d010b.red
            }
        },
        shape: {
            borderRadius: $3a18437a4c8f3324$export$4ff7fc6f1af248b5.borderRadius
        },
        typography: {
            button: {
                ...(0, $79Qyg.predefinedFonts).semiBold14px22px
            },
            h3: {
                ...(0, $79Qyg.predefinedFonts).regular14px16px
            }
        },
        components: {
            MuiDatePicker: {
                styleOverrides: {
                    root: {
                        backgroundColor: "red"
                    }
                }
            },
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        boxSizing: "border-box"
                    }
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        width: "125px",
                        height: "36px",
                        ...(0, $79Qyg.predefinedFonts).semiBold14px22px,
                        textTransform: "uppercase",
                        borderRadius: `${$3a18437a4c8f3324$export$4ff7fc6f1af248b5.borderRadius}px`
                    },
                    contained: {
                        background: $3a18437a4c8f3324$export$c537fa0d021d010b.secondary + " 0% 0% no-repeat padding-box",
                        opacity: "1",
                        color: $3a18437a4c8f3324$export$c537fa0d021d010b.white,
                        marginLeft: "20px",
                        boxShadow: "none",
                        "&:hover": {
                            background: $3a18437a4c8f3324$export$c537fa0d021d010b.secondary + " 0% 0% no-repeat padding-box",
                            opacity: "1"
                        }
                    },
                    outlined: {
                        border: "1px solid " + $3a18437a4c8f3324$export$c537fa0d021d010b.secondary,
                        color: $3a18437a4c8f3324$export$c537fa0d021d010b.secondary
                    }
                }
            },
            MuiSwitch: {
                styleOverrides: {
                    root: {
                        width: 46,
                        height: 24,
                        padding: 0,
                        display: "flex",
                        overflow: "visible",
                        marginLeft: 20,
                        marginTop: -5
                    },
                    switchBase: {
                        padding: 2,
                        paddingTop: 3,
                        transitionDuration: "300ms",
                        color: $3a18437a4c8f3324$export$c537fa0d021d010b.gray,
                        "&.Mui-disabled": {
                            "& + .MuiSwitch-track": {
                                backgroundColor: $3a18437a4c8f3324$export$c537fa0d021d010b.gray,
                                borderColor: $3a18437a4c8f3324$export$c537fa0d021d010b.gray
                            }
                        },
                        "&.Mui-checked": {
                            transform: "translateX(24px)",
                            color: "white",
                            "&.Mui-disabled": {
                                color: "white"
                            },
                            "& + .MuiSwitch-track": {
                                opacity: 1,
                                backgroundColor: $3a18437a4c8f3324$export$c537fa0d021d010b.green,
                                borderColor: $3a18437a4c8f3324$export$c537fa0d021d010b.green
                            }
                        }
                    },
                    thumb: {
                        width: 18,
                        height: 18,
                        boxShadow: "none"
                    },
                    track: {
                        border: `1px solid ${$3a18437a4c8f3324$export$c537fa0d021d010b.gray}`,
                        borderRadius: 11,
                        opacity: 1,
                        backgroundColor: "white"
                    },
                    checked: {}
                }
            }
        }
    });
    return theme;
};

});
parcelRegister("gcMmG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcc348908a7dde4d$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $2ZqBj = parcelRequire("2ZqBj");

var $cseKH = parcelRequire("cseKH");

var $f9NmP = parcelRequire("f9NmP");
var $8RAwN = parcelRequire("8RAwN");

var $1zcRx = parcelRequire("1zcRx");


var $c8wlJ = parcelRequire("c8wlJ");

var $cjMfd = parcelRequire("cjMfd");

var $aXVsf = parcelRequire("aXVsf");

var $jyjJu = parcelRequire("jyjJu");

var $4SKzm = parcelRequire("4SKzm");

var $cVDai = parcelRequire("cVDai");
const $bcc348908a7dde4d$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $bcc348908a7dde4d$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $hCIyK.default)(options, $bcc348908a7dde4d$var$_excluded);
    if (options.vars) throw new Error((0, $2ZqBj.default)(18));
    const palette = (0, $cjMfd.default)(paletteInput);
    const systemTheme = (0, $1zcRx.default)(options);
    let muiTheme = (0, $cseKH.default)(systemTheme, {
        mixins: (0, $c8wlJ.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $jyjJu.default).slice(),
        typography: (0, $aXVsf.default)(palette, typographyInput),
        transitions: (0, $4SKzm.default)(transitionsInput),
        zIndex: (0, $4WYaH.default)({}, (0, $cVDai.default))
    });
    muiTheme = (0, $cseKH.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $cseKH.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $4WYaH.default)({}, (0, $8RAwN.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $f9NmP.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $bcc348908a7dde4d$var$warnedOnce = false;
function $bcc348908a7dde4d$export$c469355549431d9b(...args) {
    return $bcc348908a7dde4d$var$createTheme(...args);
}
var $bcc348908a7dde4d$export$2e2bcd8739ae039 = $bcc348908a7dde4d$var$createTheme;

});
parcelRegister("4WYaH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39ab41060f0dd572$export$2e2bcd8739ae039; });
function $39ab41060f0dd572$export$2e2bcd8739ae039() {
    $39ab41060f0dd572$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $39ab41060f0dd572$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("hCIyK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd488cd9c287f883$export$2e2bcd8739ae039; });
function $cd488cd9c287f883$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("2ZqBj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22d5e99ed128d9c2$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $22d5e99ed128d9c2$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});

parcelRegister("cseKH", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $91138b09e882678e$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $91138b09e882678e$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");
function $91138b09e882678e$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $91138b09e882678e$var$deepClone(source) {
    if (!$91138b09e882678e$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $91138b09e882678e$var$deepClone(source[key]);
    });
    return output;
}
function $91138b09e882678e$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $4WYaH.default)({}, target) : target;
    if ($91138b09e882678e$export$53b83ca8eaab0383(target) && $91138b09e882678e$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($91138b09e882678e$export$53b83ca8eaab0383(source[key]) && key in target && $91138b09e882678e$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $91138b09e882678e$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $91138b09e882678e$export$53b83ca8eaab0383(source[key]) ? $91138b09e882678e$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("f9NmP", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $b08dfd925cd859a9$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $b08dfd925cd859a9$export$2e2bcd8739ae039; });

var $gNE2F = parcelRequire("gNE2F");

var $e4At2 = parcelRequire("e4At2");

var $8ZvsC = parcelRequire("8ZvsC");

var $eP4dZ = parcelRequire("eP4dZ");

var $8RAwN = parcelRequire("8RAwN");
function $b08dfd925cd859a9$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $b08dfd925cd859a9$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $b08dfd925cd859a9$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $8ZvsC.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $8ZvsC.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $8ZvsC.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $gNE2F.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $eP4dZ.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $8RAwN.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $eP4dZ.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $b08dfd925cd859a9$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $e4At2.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $eP4dZ.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($b08dfd925cd859a9$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $e4At2.default)(css, breakpointsValues);
                        }
                    } else css = (0, $e4At2.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $eP4dZ.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $b08dfd925cd859a9$var$styleFunctionSx = $b08dfd925cd859a9$export$7d53d8bf2911e013();
$b08dfd925cd859a9$var$styleFunctionSx.filterProps = [
    "sx"
];
var $b08dfd925cd859a9$export$2e2bcd8739ae039 = $b08dfd925cd859a9$var$styleFunctionSx;

});
parcelRegister("gNE2F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3b0487a0a59ffa8$export$2e2bcd8739ae039; });

var $2ZqBj = parcelRequire("2ZqBj");
function $c3b0487a0a59ffa8$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $2ZqBj.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});

parcelRegister("e4At2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3edba0f8fdbb817$export$2e2bcd8739ae039; });

var $cseKH = parcelRequire("cseKH");
function $a3edba0f8fdbb817$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $cseKH.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $a3edba0f8fdbb817$export$2e2bcd8739ae039 = $a3edba0f8fdbb817$var$merge;

});

parcelRegister("8ZvsC", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $68bc6cacc34785a6$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $68bc6cacc34785a6$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $68bc6cacc34785a6$export$2e2bcd8739ae039; });

var $gNE2F = parcelRequire("gNE2F");


var $eP4dZ = parcelRequire("eP4dZ");
function $68bc6cacc34785a6$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $68bc6cacc34785a6$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $68bc6cacc34785a6$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $68bc6cacc34785a6$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $68bc6cacc34785a6$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $68bc6cacc34785a6$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $68bc6cacc34785a6$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $gNE2F.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $eP4dZ.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $68bc6cacc34785a6$export$2e2bcd8739ae039 = $68bc6cacc34785a6$var$style;

});
parcelRegister("eP4dZ", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $aca91b02db9b460c$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $aca91b02db9b460c$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $aca91b02db9b460c$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $aca91b02db9b460c$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $aca91b02db9b460c$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $aca91b02db9b460c$export$980e6a259d807490; });

var $4WYaH = parcelRequire("4WYaH");


var $cseKH = parcelRequire("cseKH");

var $e4At2 = parcelRequire("e4At2");
const $aca91b02db9b460c$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $aca91b02db9b460c$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$aca91b02db9b460c$export$68c286be0e7e55b7[key]}px)`
};
function $aca91b02db9b460c$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $aca91b02db9b460c$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $aca91b02db9b460c$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $aca91b02db9b460c$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $aca91b02db9b460c$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $aca91b02db9b460c$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $4WYaH.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $e4At2.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $aca91b02db9b460c$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $aca91b02db9b460c$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $aca91b02db9b460c$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $aca91b02db9b460c$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $cseKH.default)(prev, next), {});
    return $aca91b02db9b460c$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $aca91b02db9b460c$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $aca91b02db9b460c$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $aca91b02db9b460c$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $aca91b02db9b460c$export$2e2bcd8739ae039 = $aca91b02db9b460c$var$breakpoints;

});


parcelRegister("8RAwN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $673f9bacc92f414a$export$2e2bcd8739ae039; });

var $lqJyU = parcelRequire("lqJyU");

var $iXKnY = parcelRequire("iXKnY");

var $huOLh = parcelRequire("huOLh");

var $3qBJk = parcelRequire("3qBJk");

var $dX7gg = parcelRequire("dX7gg");
const $673f9bacc92f414a$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $iXKnY.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $iXKnY.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $iXKnY.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $iXKnY.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $iXKnY.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $iXKnY.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $iXKnY.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $3qBJk.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $3qBJk.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $3qBJk.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $lqJyU.padding)
    },
    pt: {
        style: (0, $lqJyU.padding)
    },
    pr: {
        style: (0, $lqJyU.padding)
    },
    pb: {
        style: (0, $lqJyU.padding)
    },
    pl: {
        style: (0, $lqJyU.padding)
    },
    px: {
        style: (0, $lqJyU.padding)
    },
    py: {
        style: (0, $lqJyU.padding)
    },
    padding: {
        style: (0, $lqJyU.padding)
    },
    paddingTop: {
        style: (0, $lqJyU.padding)
    },
    paddingRight: {
        style: (0, $lqJyU.padding)
    },
    paddingBottom: {
        style: (0, $lqJyU.padding)
    },
    paddingLeft: {
        style: (0, $lqJyU.padding)
    },
    paddingX: {
        style: (0, $lqJyU.padding)
    },
    paddingY: {
        style: (0, $lqJyU.padding)
    },
    paddingInline: {
        style: (0, $lqJyU.padding)
    },
    paddingInlineStart: {
        style: (0, $lqJyU.padding)
    },
    paddingInlineEnd: {
        style: (0, $lqJyU.padding)
    },
    paddingBlock: {
        style: (0, $lqJyU.padding)
    },
    paddingBlockStart: {
        style: (0, $lqJyU.padding)
    },
    paddingBlockEnd: {
        style: (0, $lqJyU.padding)
    },
    m: {
        style: (0, $lqJyU.margin)
    },
    mt: {
        style: (0, $lqJyU.margin)
    },
    mr: {
        style: (0, $lqJyU.margin)
    },
    mb: {
        style: (0, $lqJyU.margin)
    },
    ml: {
        style: (0, $lqJyU.margin)
    },
    mx: {
        style: (0, $lqJyU.margin)
    },
    my: {
        style: (0, $lqJyU.margin)
    },
    margin: {
        style: (0, $lqJyU.margin)
    },
    marginTop: {
        style: (0, $lqJyU.margin)
    },
    marginRight: {
        style: (0, $lqJyU.margin)
    },
    marginBottom: {
        style: (0, $lqJyU.margin)
    },
    marginLeft: {
        style: (0, $lqJyU.margin)
    },
    marginX: {
        style: (0, $lqJyU.margin)
    },
    marginY: {
        style: (0, $lqJyU.margin)
    },
    marginInline: {
        style: (0, $lqJyU.margin)
    },
    marginInlineStart: {
        style: (0, $lqJyU.margin)
    },
    marginInlineEnd: {
        style: (0, $lqJyU.margin)
    },
    marginBlock: {
        style: (0, $lqJyU.margin)
    },
    marginBlockStart: {
        style: (0, $lqJyU.margin)
    },
    marginBlockEnd: {
        style: (0, $lqJyU.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $huOLh.gap)
    },
    rowGap: {
        style: (0, $huOLh.rowGap)
    },
    columnGap: {
        style: (0, $huOLh.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $dX7gg.sizingTransform)
    },
    maxWidth: {
        style: (0, $dX7gg.maxWidth)
    },
    minWidth: {
        transform: (0, $dX7gg.sizingTransform)
    },
    height: {
        transform: (0, $dX7gg.sizingTransform)
    },
    maxHeight: {
        transform: (0, $dX7gg.sizingTransform)
    },
    minHeight: {
        transform: (0, $dX7gg.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $673f9bacc92f414a$export$2e2bcd8739ae039 = $673f9bacc92f414a$var$defaultSxConfig;

});
parcelRegister("lqJyU", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $f99f5e5de94dd506$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $f99f5e5de94dd506$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $f99f5e5de94dd506$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $f99f5e5de94dd506$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $f99f5e5de94dd506$export$6f98e8eaf0be1996; });


var $eP4dZ = parcelRequire("eP4dZ");

var $8ZvsC = parcelRequire("8ZvsC");

var $e4At2 = parcelRequire("e4At2");

var $e2KKj = parcelRequire("e2KKj");
const $f99f5e5de94dd506$var$properties = {
    m: "margin",
    p: "padding"
};
const $f99f5e5de94dd506$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $f99f5e5de94dd506$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $f99f5e5de94dd506$var$getCssProperties = (0, $e2KKj.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($f99f5e5de94dd506$var$aliases[prop]) prop = $f99f5e5de94dd506$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $f99f5e5de94dd506$var$properties[a];
    const direction = $f99f5e5de94dd506$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $f99f5e5de94dd506$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $f99f5e5de94dd506$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $f99f5e5de94dd506$var$spacingKeys = [
    ...$f99f5e5de94dd506$export$aab52a0dde05ad8a,
    ...$f99f5e5de94dd506$export$f8397d44f03ab6ad
];
function $f99f5e5de94dd506$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $8ZvsC.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $f99f5e5de94dd506$export$1def6f833384e3d1(theme) {
    return $f99f5e5de94dd506$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $f99f5e5de94dd506$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $f99f5e5de94dd506$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $f99f5e5de94dd506$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $f99f5e5de94dd506$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $f99f5e5de94dd506$var$getCssProperties(prop);
    const styleFromPropValue = $f99f5e5de94dd506$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $eP4dZ.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $f99f5e5de94dd506$var$style(props, keys) {
    const transformer = $f99f5e5de94dd506$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$f99f5e5de94dd506$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $e4At2.default), {});
}
function $f99f5e5de94dd506$export$7ede87f9b603dd3c(props) {
    return $f99f5e5de94dd506$var$style(props, $f99f5e5de94dd506$export$aab52a0dde05ad8a);
}
$f99f5e5de94dd506$export$7ede87f9b603dd3c.propTypes = {};
$f99f5e5de94dd506$export$7ede87f9b603dd3c.filterProps = $f99f5e5de94dd506$export$aab52a0dde05ad8a;
function $f99f5e5de94dd506$export$6f98e8eaf0be1996(props) {
    return $f99f5e5de94dd506$var$style(props, $f99f5e5de94dd506$export$f8397d44f03ab6ad);
}
$f99f5e5de94dd506$export$6f98e8eaf0be1996.propTypes = {};
$f99f5e5de94dd506$export$6f98e8eaf0be1996.filterProps = $f99f5e5de94dd506$export$f8397d44f03ab6ad;
function $f99f5e5de94dd506$var$spacing(props) {
    return $f99f5e5de94dd506$var$style(props, $f99f5e5de94dd506$var$spacingKeys);
}
$f99f5e5de94dd506$var$spacing.propTypes = {};
$f99f5e5de94dd506$var$spacing.filterProps = $f99f5e5de94dd506$var$spacingKeys;
var $f99f5e5de94dd506$export$2e2bcd8739ae039 = $f99f5e5de94dd506$var$spacing;

});
parcelRegister("e2KKj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a39583580fc8bcb5$export$2e2bcd8739ae039; });
function $a39583580fc8bcb5$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("iXKnY", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $dce1b7e2b09bec12$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $dce1b7e2b09bec12$export$7a57f79000377ca2; });


var $8ZvsC = parcelRequire("8ZvsC");

var $4Nf9l = parcelRequire("4Nf9l");

var $lqJyU = parcelRequire("lqJyU");

var $eP4dZ = parcelRequire("eP4dZ");
function $dce1b7e2b09bec12$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $dce1b7e2b09bec12$var$createBorderStyle(prop, transform) {
    return (0, $8ZvsC.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $dce1b7e2b09bec12$export$1edee58a52776cd9 = $dce1b7e2b09bec12$var$createBorderStyle("border", $dce1b7e2b09bec12$export$34e2febe53ae29cc);
const $dce1b7e2b09bec12$export$f9a7b6bd24892946 = $dce1b7e2b09bec12$var$createBorderStyle("borderTop", $dce1b7e2b09bec12$export$34e2febe53ae29cc);
const $dce1b7e2b09bec12$export$5abca33e6be905d2 = $dce1b7e2b09bec12$var$createBorderStyle("borderRight", $dce1b7e2b09bec12$export$34e2febe53ae29cc);
const $dce1b7e2b09bec12$export$e2ce9f12a980a822 = $dce1b7e2b09bec12$var$createBorderStyle("borderBottom", $dce1b7e2b09bec12$export$34e2febe53ae29cc);
const $dce1b7e2b09bec12$export$47658cca1a909427 = $dce1b7e2b09bec12$var$createBorderStyle("borderLeft", $dce1b7e2b09bec12$export$34e2febe53ae29cc);
const $dce1b7e2b09bec12$export$e7fb0694ba2404fc = $dce1b7e2b09bec12$var$createBorderStyle("borderColor");
const $dce1b7e2b09bec12$export$126a92c968acdb85 = $dce1b7e2b09bec12$var$createBorderStyle("borderTopColor");
const $dce1b7e2b09bec12$export$85cc51cb8fbb8c0e = $dce1b7e2b09bec12$var$createBorderStyle("borderRightColor");
const $dce1b7e2b09bec12$export$340b0327727f6d1a = $dce1b7e2b09bec12$var$createBorderStyle("borderBottomColor");
const $dce1b7e2b09bec12$export$60beef91a985b4bf = $dce1b7e2b09bec12$var$createBorderStyle("borderLeftColor");
const $dce1b7e2b09bec12$export$f9258c55612cbed7 = $dce1b7e2b09bec12$var$createBorderStyle("outline", $dce1b7e2b09bec12$export$34e2febe53ae29cc);
const $dce1b7e2b09bec12$export$621fe586efeb64b9 = $dce1b7e2b09bec12$var$createBorderStyle("outlineColor");
const $dce1b7e2b09bec12$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $lqJyU.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $lqJyU.getValue)(transformer, propValue)
            });
        return (0, $eP4dZ.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$dce1b7e2b09bec12$export$7a57f79000377ca2.propTypes = {};
$dce1b7e2b09bec12$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $dce1b7e2b09bec12$var$borders = (0, $4Nf9l.default)($dce1b7e2b09bec12$export$1edee58a52776cd9, $dce1b7e2b09bec12$export$f9a7b6bd24892946, $dce1b7e2b09bec12$export$5abca33e6be905d2, $dce1b7e2b09bec12$export$e2ce9f12a980a822, $dce1b7e2b09bec12$export$47658cca1a909427, $dce1b7e2b09bec12$export$e7fb0694ba2404fc, $dce1b7e2b09bec12$export$126a92c968acdb85, $dce1b7e2b09bec12$export$85cc51cb8fbb8c0e, $dce1b7e2b09bec12$export$340b0327727f6d1a, $dce1b7e2b09bec12$export$60beef91a985b4bf, $dce1b7e2b09bec12$export$7a57f79000377ca2, $dce1b7e2b09bec12$export$f9258c55612cbed7, $dce1b7e2b09bec12$export$621fe586efeb64b9);
var $dce1b7e2b09bec12$export$2e2bcd8739ae039 = $dce1b7e2b09bec12$var$borders;

});
parcelRegister("4Nf9l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37d77d7211880bab$export$2e2bcd8739ae039; });

var $e4At2 = parcelRequire("e4At2");
function $37d77d7211880bab$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $e4At2.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $37d77d7211880bab$export$2e2bcd8739ae039 = $37d77d7211880bab$var$compose;

});


parcelRegister("huOLh", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $cbcc9d3026e306b1$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $cbcc9d3026e306b1$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $cbcc9d3026e306b1$export$8a833ffa5f5dbeda; });

var $8ZvsC = parcelRequire("8ZvsC");

var $4Nf9l = parcelRequire("4Nf9l");

var $lqJyU = parcelRequire("lqJyU");

var $eP4dZ = parcelRequire("eP4dZ");

const $cbcc9d3026e306b1$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $lqJyU.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $lqJyU.getValue)(transformer, propValue)
            });
        return (0, $eP4dZ.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$cbcc9d3026e306b1$export$5df9adcb0db95e1e.propTypes = {};
$cbcc9d3026e306b1$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $cbcc9d3026e306b1$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $lqJyU.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $lqJyU.getValue)(transformer, propValue)
            });
        return (0, $eP4dZ.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$cbcc9d3026e306b1$export$ec60d70ff941a580.propTypes = {};
$cbcc9d3026e306b1$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $cbcc9d3026e306b1$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $lqJyU.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $lqJyU.getValue)(transformer, propValue)
            });
        return (0, $eP4dZ.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$cbcc9d3026e306b1$export$8a833ffa5f5dbeda.propTypes = {};
$cbcc9d3026e306b1$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $cbcc9d3026e306b1$export$baf44164ca3a34e8 = (0, $8ZvsC.default)({
    prop: "gridColumn"
});
const $cbcc9d3026e306b1$export$8f7213a1cd01e832 = (0, $8ZvsC.default)({
    prop: "gridRow"
});
const $cbcc9d3026e306b1$export$b0e0abbc49ba668 = (0, $8ZvsC.default)({
    prop: "gridAutoFlow"
});
const $cbcc9d3026e306b1$export$bcd8b929d4b4142 = (0, $8ZvsC.default)({
    prop: "gridAutoColumns"
});
const $cbcc9d3026e306b1$export$e5039a674e14c828 = (0, $8ZvsC.default)({
    prop: "gridAutoRows"
});
const $cbcc9d3026e306b1$export$42bd9088661ffb03 = (0, $8ZvsC.default)({
    prop: "gridTemplateColumns"
});
const $cbcc9d3026e306b1$export$920682ae05b999bc = (0, $8ZvsC.default)({
    prop: "gridTemplateRows"
});
const $cbcc9d3026e306b1$export$1b88fbdd482fd33a = (0, $8ZvsC.default)({
    prop: "gridTemplateAreas"
});
const $cbcc9d3026e306b1$export$bdb486e40d52d26f = (0, $8ZvsC.default)({
    prop: "gridArea"
});
const $cbcc9d3026e306b1$var$grid = (0, $4Nf9l.default)($cbcc9d3026e306b1$export$5df9adcb0db95e1e, $cbcc9d3026e306b1$export$ec60d70ff941a580, $cbcc9d3026e306b1$export$8a833ffa5f5dbeda, $cbcc9d3026e306b1$export$baf44164ca3a34e8, $cbcc9d3026e306b1$export$8f7213a1cd01e832, $cbcc9d3026e306b1$export$b0e0abbc49ba668, $cbcc9d3026e306b1$export$bcd8b929d4b4142, $cbcc9d3026e306b1$export$e5039a674e14c828, $cbcc9d3026e306b1$export$42bd9088661ffb03, $cbcc9d3026e306b1$export$920682ae05b999bc, $cbcc9d3026e306b1$export$1b88fbdd482fd33a, $cbcc9d3026e306b1$export$bdb486e40d52d26f);
var $cbcc9d3026e306b1$export$2e2bcd8739ae039 = $cbcc9d3026e306b1$var$grid;

});

parcelRegister("3qBJk", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $27f1113b2e933e83$export$dbaffd4420ea0ac6; });

var $8ZvsC = parcelRequire("8ZvsC");

var $4Nf9l = parcelRequire("4Nf9l");
function $27f1113b2e933e83$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $27f1113b2e933e83$export$35e9368ef982300f = (0, $8ZvsC.default)({
    prop: "color",
    themeKey: "palette",
    transform: $27f1113b2e933e83$export$dbaffd4420ea0ac6
});
const $27f1113b2e933e83$export$2506f56c10355b33 = (0, $8ZvsC.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $27f1113b2e933e83$export$dbaffd4420ea0ac6
});
const $27f1113b2e933e83$export$8c5a050822fd698c = (0, $8ZvsC.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $27f1113b2e933e83$export$dbaffd4420ea0ac6
});
const $27f1113b2e933e83$var$palette = (0, $4Nf9l.default)($27f1113b2e933e83$export$35e9368ef982300f, $27f1113b2e933e83$export$2506f56c10355b33, $27f1113b2e933e83$export$8c5a050822fd698c);
var $27f1113b2e933e83$export$2e2bcd8739ae039 = $27f1113b2e933e83$var$palette;

});

parcelRegister("dX7gg", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $a2866b01e610646d$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $a2866b01e610646d$export$488fda99655ff65a; });

var $8ZvsC = parcelRequire("8ZvsC");

var $4Nf9l = parcelRequire("4Nf9l");

var $eP4dZ = parcelRequire("eP4dZ");
function $a2866b01e610646d$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $a2866b01e610646d$export$7e3df82ee760448c = (0, $8ZvsC.default)({
    prop: "width",
    transform: $a2866b01e610646d$export$8afece71750ec241
});
const $a2866b01e610646d$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $eP4dZ.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $a2866b01e610646d$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $eP4dZ.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$a2866b01e610646d$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $a2866b01e610646d$export$ee148fbbe8357dd2 = (0, $8ZvsC.default)({
    prop: "minWidth",
    transform: $a2866b01e610646d$export$8afece71750ec241
});
const $a2866b01e610646d$export$ac607276a8fe9f0a = (0, $8ZvsC.default)({
    prop: "height",
    transform: $a2866b01e610646d$export$8afece71750ec241
});
const $a2866b01e610646d$export$dc0d8bd0b94f8570 = (0, $8ZvsC.default)({
    prop: "maxHeight",
    transform: $a2866b01e610646d$export$8afece71750ec241
});
const $a2866b01e610646d$export$a43cf604e12f3b17 = (0, $8ZvsC.default)({
    prop: "minHeight",
    transform: $a2866b01e610646d$export$8afece71750ec241
});
const $a2866b01e610646d$export$ffed9f14fb65e276 = (0, $8ZvsC.default)({
    prop: "size",
    cssProperty: "width",
    transform: $a2866b01e610646d$export$8afece71750ec241
});
const $a2866b01e610646d$export$905076ed6620e671 = (0, $8ZvsC.default)({
    prop: "size",
    cssProperty: "height",
    transform: $a2866b01e610646d$export$8afece71750ec241
});
const $a2866b01e610646d$export$6ccc93f785106a58 = (0, $8ZvsC.default)({
    prop: "boxSizing"
});
const $a2866b01e610646d$var$sizing = (0, $4Nf9l.default)($a2866b01e610646d$export$7e3df82ee760448c, $a2866b01e610646d$export$488fda99655ff65a, $a2866b01e610646d$export$ee148fbbe8357dd2, $a2866b01e610646d$export$ac607276a8fe9f0a, $a2866b01e610646d$export$dc0d8bd0b94f8570, $a2866b01e610646d$export$a43cf604e12f3b17, $a2866b01e610646d$export$6ccc93f785106a58);
var $a2866b01e610646d$export$2e2bcd8739ae039 = $a2866b01e610646d$var$sizing;

});



parcelRegister("1zcRx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $124309933ba5fccb$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $cseKH = parcelRequire("cseKH");

var $9HQTC = parcelRequire("9HQTC");

var $8gTYU = parcelRequire("8gTYU");

var $b6RkN = parcelRequire("b6RkN");

var $f9NmP = parcelRequire("f9NmP");

var $8RAwN = parcelRequire("8RAwN");

var $cxNpU = parcelRequire("cxNpU");
const $124309933ba5fccb$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $124309933ba5fccb$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $hCIyK.default)(options, $124309933ba5fccb$var$_excluded);
    const breakpoints = (0, $9HQTC.default)(breakpointsInput);
    const spacing = (0, $b6RkN.default)(spacingInput);
    let muiTheme = (0, $cseKH.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $4WYaH.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $4WYaH.default)({}, (0, $8gTYU.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $cxNpU.default);
    muiTheme = args.reduce((acc, argument)=>(0, $cseKH.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $4WYaH.default)({}, (0, $8RAwN.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $f9NmP.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $124309933ba5fccb$export$2e2bcd8739ae039 = $124309933ba5fccb$var$createTheme;

});
parcelRegister("9HQTC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71112941b22e40ae$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");
const $71112941b22e40ae$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $71112941b22e40ae$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $71112941b22e40ae$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $4WYaH.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $71112941b22e40ae$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $hCIyK.default)(breakpoints, $71112941b22e40ae$var$_excluded);
    const sortedValues = $71112941b22e40ae$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $4WYaH.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("8gTYU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $605b3e14c17458d8$export$2e2bcd8739ae039; });
const $605b3e14c17458d8$var$shape = {
    borderRadius: 4
};
var $605b3e14c17458d8$export$2e2bcd8739ae039 = $605b3e14c17458d8$var$shape;

});

parcelRegister("b6RkN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8169a057809484de$export$2e2bcd8739ae039; });

var $lqJyU = parcelRequire("lqJyU");
function $8169a057809484de$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $lqJyU.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});

parcelRegister("cxNpU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $921ee6491134d507$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $921ee6491134d507$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("c8wlJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d5f535890108345$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");
function $8d5f535890108345$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $4WYaH.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("cjMfd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f7caeba5148dee4$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $2ZqBj = parcelRequire("2ZqBj");

var $cseKH = parcelRequire("cseKH");

var $cG3EF = parcelRequire("cG3EF");

var $7O7iL = parcelRequire("7O7iL");

var $8KKZ9 = parcelRequire("8KKZ9");

var $7KujM = parcelRequire("7KujM");

var $kJEL4 = parcelRequire("kJEL4");

var $bjzVt = parcelRequire("bjzVt");

var $gmWj5 = parcelRequire("gmWj5");

var $2hpx0 = parcelRequire("2hpx0");

var $bLCV4 = parcelRequire("bLCV4");
const $8f7caeba5148dee4$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $8f7caeba5148dee4$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $7O7iL.default).white,
        default: (0, $7O7iL.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $8f7caeba5148dee4$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $7O7iL.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $7O7iL.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $8f7caeba5148dee4$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $cG3EF.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $cG3EF.darken)(intent.main, tonalOffsetDark);
    }
}
function $8f7caeba5148dee4$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $gmWj5.default)[200],
        light: (0, $gmWj5.default)[50],
        dark: (0, $gmWj5.default)[400]
    };
    return {
        main: (0, $gmWj5.default)[700],
        light: (0, $gmWj5.default)[400],
        dark: (0, $gmWj5.default)[800]
    };
}
function $8f7caeba5148dee4$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $7KujM.default)[200],
        light: (0, $7KujM.default)[50],
        dark: (0, $7KujM.default)[400]
    };
    return {
        main: (0, $7KujM.default)[500],
        light: (0, $7KujM.default)[300],
        dark: (0, $7KujM.default)[700]
    };
}
function $8f7caeba5148dee4$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $kJEL4.default)[500],
        light: (0, $kJEL4.default)[300],
        dark: (0, $kJEL4.default)[700]
    };
    return {
        main: (0, $kJEL4.default)[700],
        light: (0, $kJEL4.default)[400],
        dark: (0, $kJEL4.default)[800]
    };
}
function $8f7caeba5148dee4$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $2hpx0.default)[400],
        light: (0, $2hpx0.default)[300],
        dark: (0, $2hpx0.default)[700]
    };
    return {
        main: (0, $2hpx0.default)[700],
        light: (0, $2hpx0.default)[500],
        dark: (0, $2hpx0.default)[900]
    };
}
function $8f7caeba5148dee4$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $bLCV4.default)[400],
        light: (0, $bLCV4.default)[300],
        dark: (0, $bLCV4.default)[700]
    };
    return {
        main: (0, $bLCV4.default)[800],
        light: (0, $bLCV4.default)[500],
        dark: (0, $bLCV4.default)[900]
    };
}
function $8f7caeba5148dee4$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $bjzVt.default)[400],
        light: (0, $bjzVt.default)[300],
        dark: (0, $bjzVt.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $bjzVt.default)[500],
        dark: (0, $bjzVt.default)[900]
    };
}
function $8f7caeba5148dee4$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $hCIyK.default)(palette, $8f7caeba5148dee4$var$_excluded);
    const primary = palette.primary || $8f7caeba5148dee4$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $8f7caeba5148dee4$var$getDefaultSecondary(mode);
    const error = palette.error || $8f7caeba5148dee4$var$getDefaultError(mode);
    const info = palette.info || $8f7caeba5148dee4$var$getDefaultInfo(mode);
    const success = palette.success || $8f7caeba5148dee4$var$getDefaultSuccess(mode);
    const warning = palette.warning || $8f7caeba5148dee4$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $cG3EF.getContrastRatio)(background, $8f7caeba5148dee4$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $8f7caeba5148dee4$export$55ce6f3a06c59543.text.primary : $8f7caeba5148dee4$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $4WYaH.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $2ZqBj.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $2ZqBj.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $8f7caeba5148dee4$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $8f7caeba5148dee4$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $8f7caeba5148dee4$export$55ce6f3a06c59543,
        light: $8f7caeba5148dee4$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $cseKH.default)((0, $4WYaH.default)({
        // A collection of common colors.
        common: (0, $4WYaH.default)({}, (0, $7O7iL.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $8KKZ9.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("cG3EF", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $93ac3e1027ed7a13$var$alpha;
module.exports.blend = $93ac3e1027ed7a13$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $93ac3e1027ed7a13$var$darken;
module.exports.decomposeColor = $93ac3e1027ed7a13$var$decomposeColor;
module.exports.emphasize = $93ac3e1027ed7a13$var$emphasize;
module.exports.getContrastRatio = $93ac3e1027ed7a13$var$getContrastRatio;
module.exports.getLuminance = $93ac3e1027ed7a13$var$getLuminance;
module.exports.hexToRgb = $93ac3e1027ed7a13$var$hexToRgb;
module.exports.hslToRgb = $93ac3e1027ed7a13$var$hslToRgb;
module.exports.lighten = $93ac3e1027ed7a13$var$lighten;
module.exports.private_safeAlpha = $93ac3e1027ed7a13$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $93ac3e1027ed7a13$var$private_safeDarken;
module.exports.private_safeEmphasize = $93ac3e1027ed7a13$var$private_safeEmphasize;
module.exports.private_safeLighten = $93ac3e1027ed7a13$var$private_safeLighten;
module.exports.recomposeColor = $93ac3e1027ed7a13$var$recomposeColor;
module.exports.rgbToHex = $93ac3e1027ed7a13$var$rgbToHex;

var $93ac3e1027ed7a13$var$_formatMuiErrorMessage2 = $2ZnTs((parcelRequire("66GqW")));

var $93ac3e1027ed7a13$var$_clamp = $2ZnTs((parcelRequire("40HcO")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $93ac3e1027ed7a13$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $93ac3e1027ed7a13$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $93ac3e1027ed7a13$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $93ac3e1027ed7a13$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $93ac3e1027ed7a13$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $93ac3e1027ed7a13$var$decomposeColor($93ac3e1027ed7a13$var$hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $93ac3e1027ed7a13$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $93ac3e1027ed7a13$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $93ac3e1027ed7a13$var$colorChannel = (color)=>{
    const decomposedColor = $93ac3e1027ed7a13$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
module.exports.colorChannel = $93ac3e1027ed7a13$var$colorChannel;
const $93ac3e1027ed7a13$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $93ac3e1027ed7a13$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $93ac3e1027ed7a13$var$private_safeColorChannel;
function $93ac3e1027ed7a13$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $93ac3e1027ed7a13$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $93ac3e1027ed7a13$var$decomposeColor(color);
    return `#${values.map((n, i)=>$93ac3e1027ed7a13$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $93ac3e1027ed7a13$var$hslToRgb(color) {
    color = $93ac3e1027ed7a13$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $93ac3e1027ed7a13$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $93ac3e1027ed7a13$var$getLuminance(color) {
    color = $93ac3e1027ed7a13$var$decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $93ac3e1027ed7a13$var$decomposeColor($93ac3e1027ed7a13$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $93ac3e1027ed7a13$var$getContrastRatio(foreground, background) {
    const lumA = $93ac3e1027ed7a13$var$getLuminance(foreground);
    const lumB = $93ac3e1027ed7a13$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $93ac3e1027ed7a13$var$alpha(color, value) {
    color = $93ac3e1027ed7a13$var$decomposeColor(color);
    value = $93ac3e1027ed7a13$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $93ac3e1027ed7a13$var$recomposeColor(color);
}
function $93ac3e1027ed7a13$var$private_safeAlpha(color, value, warning) {
    try {
        return $93ac3e1027ed7a13$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $93ac3e1027ed7a13$var$darken(color, coefficient) {
    color = $93ac3e1027ed7a13$var$decomposeColor(color);
    coefficient = $93ac3e1027ed7a13$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $93ac3e1027ed7a13$var$recomposeColor(color);
}
function $93ac3e1027ed7a13$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $93ac3e1027ed7a13$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $93ac3e1027ed7a13$var$lighten(color, coefficient) {
    color = $93ac3e1027ed7a13$var$decomposeColor(color);
    coefficient = $93ac3e1027ed7a13$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $93ac3e1027ed7a13$var$recomposeColor(color);
}
function $93ac3e1027ed7a13$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $93ac3e1027ed7a13$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $93ac3e1027ed7a13$var$emphasize(color, coefficient = 0.15) {
    return $93ac3e1027ed7a13$var$getLuminance(color) > 0.5 ? $93ac3e1027ed7a13$var$darken(color, coefficient) : $93ac3e1027ed7a13$var$lighten(color, coefficient);
}
function $93ac3e1027ed7a13$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $93ac3e1027ed7a13$var$private_safeEmphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $93ac3e1027ed7a13$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $93ac3e1027ed7a13$var$decomposeColor(background);
    const overlayColor = $93ac3e1027ed7a13$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $93ac3e1027ed7a13$var$recomposeColor({
        type: "rgb",
        values: rgb
    });
}

});
parcelRegister("2ZnTs", function(module, exports) {
function $22d3d00379a62cb8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $22d3d00379a62cb8$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("66GqW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("2ZqBj")).default; });

var $2ZqBj = parcelRequire("2ZqBj");

});

parcelRegister("40HcO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("b4ZRC")).default; });

var $b4ZRC = parcelRequire("b4ZRC");

});
parcelRegister("b4ZRC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81100e4f778bfc67$export$2e2bcd8739ae039; });
function $81100e4f778bfc67$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $81100e4f778bfc67$export$2e2bcd8739ae039 = $81100e4f778bfc67$var$clamp;

});



parcelRegister("7O7iL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5af2ddd86bb7d498$export$2e2bcd8739ae039; });
const $5af2ddd86bb7d498$var$common = {
    black: "#000",
    white: "#fff"
};
var $5af2ddd86bb7d498$export$2e2bcd8739ae039 = $5af2ddd86bb7d498$var$common;

});

parcelRegister("8KKZ9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65f710e911b7292d$export$2e2bcd8739ae039; });
const $65f710e911b7292d$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $65f710e911b7292d$export$2e2bcd8739ae039 = $65f710e911b7292d$var$grey;

});

parcelRegister("7KujM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a4458d5f7fc7bf6$export$2e2bcd8739ae039; });
const $5a4458d5f7fc7bf6$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $5a4458d5f7fc7bf6$export$2e2bcd8739ae039 = $5a4458d5f7fc7bf6$var$purple;

});

parcelRegister("kJEL4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f187a05573202cce$export$2e2bcd8739ae039; });
const $f187a05573202cce$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $f187a05573202cce$export$2e2bcd8739ae039 = $f187a05573202cce$var$red;

});

parcelRegister("bjzVt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83cd563b25e0fd36$export$2e2bcd8739ae039; });
const $83cd563b25e0fd36$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $83cd563b25e0fd36$export$2e2bcd8739ae039 = $83cd563b25e0fd36$var$orange;

});

parcelRegister("gmWj5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $beabedf7811f9d48$export$2e2bcd8739ae039; });
const $beabedf7811f9d48$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $beabedf7811f9d48$export$2e2bcd8739ae039 = $beabedf7811f9d48$var$blue;

});

parcelRegister("2hpx0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a90f95089dd0c31$export$2e2bcd8739ae039; });
const $1a90f95089dd0c31$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $1a90f95089dd0c31$export$2e2bcd8739ae039 = $1a90f95089dd0c31$var$lightBlue;

});

parcelRegister("bLCV4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $891246157fd9d9c5$export$2e2bcd8739ae039; });
const $891246157fd9d9c5$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $891246157fd9d9c5$export$2e2bcd8739ae039 = $891246157fd9d9c5$var$green;

});


parcelRegister("aXVsf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fbbfb5695036e2b$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $cseKH = parcelRequire("cseKH");
const $7fbbfb5695036e2b$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $7fbbfb5695036e2b$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $7fbbfb5695036e2b$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $7fbbfb5695036e2b$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $7fbbfb5695036e2b$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $7fbbfb5695036e2b$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $hCIyK.default)(_ref, $7fbbfb5695036e2b$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $4WYaH.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $7fbbfb5695036e2b$var$defaultFontFamily ? {
            letterSpacing: `${$7fbbfb5695036e2b$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $7fbbfb5695036e2b$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $7fbbfb5695036e2b$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $cseKH.default)((0, $4WYaH.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("jyjJu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3c07fd261e20251$export$2e2bcd8739ae039; });
const $e3c07fd261e20251$var$shadowKeyUmbraOpacity = 0.2;
const $e3c07fd261e20251$var$shadowKeyPenumbraOpacity = 0.14;
const $e3c07fd261e20251$var$shadowAmbientShadowOpacity = 0.12;
function $e3c07fd261e20251$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e3c07fd261e20251$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e3c07fd261e20251$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e3c07fd261e20251$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e3c07fd261e20251$var$shadows = [
    "none",
    $e3c07fd261e20251$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e3c07fd261e20251$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e3c07fd261e20251$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e3c07fd261e20251$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e3c07fd261e20251$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e3c07fd261e20251$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e3c07fd261e20251$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e3c07fd261e20251$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e3c07fd261e20251$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e3c07fd261e20251$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e3c07fd261e20251$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e3c07fd261e20251$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e3c07fd261e20251$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e3c07fd261e20251$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e3c07fd261e20251$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e3c07fd261e20251$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e3c07fd261e20251$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e3c07fd261e20251$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e3c07fd261e20251$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e3c07fd261e20251$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e3c07fd261e20251$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e3c07fd261e20251$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e3c07fd261e20251$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e3c07fd261e20251$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e3c07fd261e20251$export$2e2bcd8739ae039 = $e3c07fd261e20251$var$shadows;

});

parcelRegister("4SKzm", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $38e05443f54e4c38$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $38e05443f54e4c38$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");
const $38e05443f54e4c38$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $38e05443f54e4c38$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $38e05443f54e4c38$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $38e05443f54e4c38$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $38e05443f54e4c38$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $38e05443f54e4c38$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $4WYaH.default)({}, $38e05443f54e4c38$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $4WYaH.default)({}, $38e05443f54e4c38$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $hCIyK.default)(options, $38e05443f54e4c38$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $38e05443f54e4c38$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $38e05443f54e4c38$var$formatMs(delay)}`).join(",");
    };
    return (0, $4WYaH.default)({
        getAutoHeightDuration: $38e05443f54e4c38$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("cVDai", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9699304106843fdd$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $9699304106843fdd$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $9699304106843fdd$export$2e2bcd8739ae039 = $9699304106843fdd$var$zIndex;

});


parcelRegister("79Qyg", function(module, exports) {

$parcel$export(module.exports, "predefinedFonts", function () { return $c1b1acdc07076d00$export$52533a328f1d56ea; });
$parcel$export(module.exports, "fonts", function () { return $c1b1acdc07076d00$export$f45fbea8fe20ca8a; });
const $c1b1acdc07076d00$var$generalFonts = {
    fontFamily: "Overpass",
    FontWeights: {
        light: 300,
        regular: 400,
        semiBold: 600,
        bold: 700
    }
};
const $c1b1acdc07076d00$export$52533a328f1d56ea = {
    semiBold14px22px: {
        fontFamily: $c1b1acdc07076d00$var$generalFonts.fontFamily,
        fontSize: "14px",
        lineHeight: "22px",
        fontWeight: $c1b1acdc07076d00$var$generalFonts.FontWeights.semiBold,
        letterSpacing: "0px"
    },
    light14px22px: {
        fontFamily: $c1b1acdc07076d00$var$generalFonts.fontFamily,
        fontSize: "14px",
        lineHeight: "22px",
        fontWeight: $c1b1acdc07076d00$var$generalFonts.FontWeights.light,
        letterSpacing: "0px"
    },
    Bold: {
        "14px22px": {
            fontFamily: $c1b1acdc07076d00$var$generalFonts.fontFamily,
            fontSize: "14px",
            lineHeight: "22px",
            fontWeight: $c1b1acdc07076d00$var$generalFonts.FontWeights.bold,
            letterSpacing: "0px"
        },
        "12px17px": {
            fontFamily: $c1b1acdc07076d00$var$generalFonts.fontFamily,
            fontSize: "12px",
            lineHeight: "17px",
            fontWeight: $c1b1acdc07076d00$var$generalFonts.FontWeights.bold,
            letterSpacing: "0px"
        },
        "22px33px": {
            fontFamily: $c1b1acdc07076d00$var$generalFonts.fontFamily,
            fontSize: "22px",
            lineHeight: "33px",
            fontWeight: $c1b1acdc07076d00$var$generalFonts.FontWeights.bold,
            letterSpacing: "0px"
        }
    },
    regular14px16px: {
        fontFamily: $c1b1acdc07076d00$var$generalFonts.fontFamily,
        fontSize: "14px",
        lineHeight: "16px",
        fontWeight: $c1b1acdc07076d00$var$generalFonts.FontWeights.regular,
        letterSpacing: "0px"
    }
};
const $c1b1acdc07076d00$export$f45fbea8fe20ca8a = {
    General: $c1b1acdc07076d00$var$generalFonts,
    Predefined: $c1b1acdc07076d00$export$52533a328f1d56ea
};

});


parcelRegister("2eJeT", function(module, exports) {

var $1a0ffb1f7bb99ef8$var$moment = module.exports = (parcelRequire("dEjeT"));

$1a0ffb1f7bb99ef8$var$moment.tz.load((parcelRequire("fxcAT")));

});
parcelRegister("dEjeT", function(module, exports) {

//! moment-timezone.js
//! version : 0.5.45
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone
(function(root, factory) {
    "use strict";
    /*global define*/ if (0, module.exports) module.exports = factory((parcelRequire("cxTnx"))); // Node
    else if (typeof define === "function" && define.amd) define([
        "moment"
    ], factory); // AMD
    else factory(root.moment); // Browser
})(module.exports, function(moment) {
    "use strict";
    // Resolves es6 module loading issue
    if (moment.version === undefined && moment.default) moment = moment.default;
    // Do not load moment-timezone a second time.
    // if (moment.tz !== undefined) {
    // 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
    // 	return moment;
    // }
    var VERSION = "0.5.45", zones = {}, links = {}, countries = {}, names = {}, guesses = {}, cachedGuess;
    if (!moment || typeof moment.version !== "string") logError("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
    var momentVersion = moment.version.split("."), major = +momentVersion[0], minor = +momentVersion[1];
    // Moment.js version check
    if (major < 2 || major === 2 && minor < 6) logError("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + moment.version + ". See momentjs.com");
    /************************************
		Unpacking
	************************************/ function charCodeToInt(charCode) {
        if (charCode > 96) return charCode - 87;
        else if (charCode > 64) return charCode - 29;
        return charCode - 48;
    }
    function unpackBase60(string) {
        var i = 0, parts = string.split("."), whole = parts[0], fractional = parts[1] || "", multiplier = 1, num, out = 0, sign = 1;
        // handle negative numbers
        if (string.charCodeAt(0) === 45) {
            i = 1;
            sign = -1;
        }
        // handle digits before the decimal
        for(i; i < whole.length; i++){
            num = charCodeToInt(whole.charCodeAt(i));
            out = 60 * out + num;
        }
        // handle digits after the decimal
        for(i = 0; i < fractional.length; i++){
            multiplier = multiplier / 60;
            num = charCodeToInt(fractional.charCodeAt(i));
            out += num * multiplier;
        }
        return out * sign;
    }
    function arrayToInt(array) {
        for(var i = 0; i < array.length; i++)array[i] = unpackBase60(array[i]);
    }
    function intToUntil(array, length) {
        for(var i = 0; i < length; i++)array[i] = Math.round((array[i - 1] || 0) + array[i] * 60000); // minutes to milliseconds
        array[length - 1] = Infinity;
    }
    function mapIndices(source, indices) {
        var out = [], i;
        for(i = 0; i < indices.length; i++)out[i] = source[indices[i]];
        return out;
    }
    function unpack(string) {
        var data = string.split("|"), offsets = data[2].split(" "), indices = data[3].split(""), untils = data[4].split(" ");
        arrayToInt(offsets);
        arrayToInt(indices);
        arrayToInt(untils);
        intToUntil(untils, indices.length);
        return {
            name: data[0],
            abbrs: mapIndices(data[1].split(" "), indices),
            offsets: mapIndices(offsets, indices),
            untils: untils,
            population: data[5] | 0
        };
    }
    /************************************
		Zone object
	************************************/ function Zone(packedString) {
        if (packedString) this._set(unpack(packedString));
    }
    function closest(num, arr) {
        var len = arr.length;
        if (num < arr[0]) return 0;
        else if (len > 1 && arr[len - 1] === Infinity && num >= arr[len - 2]) return len - 1;
        else if (num >= arr[len - 1]) return -1;
        var mid;
        var lo = 0;
        var hi = len - 1;
        while(hi - lo > 1){
            mid = Math.floor((lo + hi) / 2);
            if (arr[mid] <= num) lo = mid;
            else hi = mid;
        }
        return hi;
    }
    Zone.prototype = {
        _set: function(unpacked) {
            this.name = unpacked.name;
            this.abbrs = unpacked.abbrs;
            this.untils = unpacked.untils;
            this.offsets = unpacked.offsets;
            this.population = unpacked.population;
        },
        _index: function(timestamp) {
            var target = +timestamp, untils = this.untils, i;
            i = closest(target, untils);
            if (i >= 0) return i;
        },
        countries: function() {
            var zone_name = this.name;
            return Object.keys(countries).filter(function(country_code) {
                return countries[country_code].zones.indexOf(zone_name) !== -1;
            });
        },
        parse: function(timestamp) {
            var target = +timestamp, offsets = this.offsets, untils = this.untils, max = untils.length - 1, offset, offsetNext, offsetPrev, i;
            for(i = 0; i < max; i++){
                offset = offsets[i];
                offsetNext = offsets[i + 1];
                offsetPrev = offsets[i ? i - 1 : i];
                if (offset < offsetNext && tz.moveAmbiguousForward) offset = offsetNext;
                else if (offset > offsetPrev && tz.moveInvalidForward) offset = offsetPrev;
                if (target < untils[i] - offset * 60000) return offsets[i];
            }
            return offsets[max];
        },
        abbr: function(mom) {
            return this.abbrs[this._index(mom)];
        },
        offset: function(mom) {
            logError("zone.offset has been deprecated in favor of zone.utcOffset");
            return this.offsets[this._index(mom)];
        },
        utcOffset: function(mom) {
            return this.offsets[this._index(mom)];
        }
    };
    /************************************
		Country object
	************************************/ function Country(country_name, zone_names) {
        this.name = country_name;
        this.zones = zone_names;
    }
    /************************************
		Current Timezone
	************************************/ function OffsetAt(at) {
        var timeString = at.toTimeString();
        var abbr = timeString.match(/\([a-z ]+\)/i);
        if (abbr && abbr[0]) {
            // 17:56:31 GMT-0600 (CST)
            // 17:56:31 GMT-0600 (Central Standard Time)
            abbr = abbr[0].match(/[A-Z]/g);
            abbr = abbr ? abbr.join("") : undefined;
        } else {
            // 17:56:31 CST
            // 17:56:31 GMT+0800 (台北標準時間)
            abbr = timeString.match(/[A-Z]{3,5}/g);
            abbr = abbr ? abbr[0] : undefined;
        }
        if (abbr === "GMT") abbr = undefined;
        this.at = +at;
        this.abbr = abbr;
        this.offset = at.getTimezoneOffset();
    }
    function ZoneScore(zone) {
        this.zone = zone;
        this.offsetScore = 0;
        this.abbrScore = 0;
    }
    ZoneScore.prototype.scoreOffsetAt = function(offsetAt) {
        this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
        if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, "") !== offsetAt.abbr) this.abbrScore++;
    };
    function findChange(low, high) {
        var mid, diff;
        while(diff = ((high.at - low.at) / 12e4 | 0) * 6e4){
            mid = new OffsetAt(new Date(low.at + diff));
            if (mid.offset === low.offset) low = mid;
            else high = mid;
        }
        return low;
    }
    function userOffsets() {
        var startYear = new Date().getFullYear() - 2, last = new OffsetAt(new Date(startYear, 0, 1)), lastOffset = last.offset, offsets = [
            last
        ], change, next, nextOffset, i;
        for(i = 1; i < 48; i++){
            nextOffset = new Date(startYear, i, 1).getTimezoneOffset();
            if (nextOffset !== lastOffset) {
                // Create OffsetAt here to avoid unnecessary abbr parsing before checking offsets
                next = new OffsetAt(new Date(startYear, i, 1));
                change = findChange(last, next);
                offsets.push(change);
                offsets.push(new OffsetAt(new Date(change.at + 6e4)));
                last = next;
                lastOffset = nextOffset;
            }
        }
        for(i = 0; i < 4; i++){
            offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
            offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
        }
        return offsets;
    }
    function sortZoneScores(a, b) {
        if (a.offsetScore !== b.offsetScore) return a.offsetScore - b.offsetScore;
        if (a.abbrScore !== b.abbrScore) return a.abbrScore - b.abbrScore;
        if (a.zone.population !== b.zone.population) return b.zone.population - a.zone.population;
        return b.zone.name.localeCompare(a.zone.name);
    }
    function addToGuesses(name, offsets) {
        var i, offset;
        arrayToInt(offsets);
        for(i = 0; i < offsets.length; i++){
            offset = offsets[i];
            guesses[offset] = guesses[offset] || {};
            guesses[offset][name] = true;
        }
    }
    function guessesForUserOffsets(offsets) {
        var offsetsLength = offsets.length, filteredGuesses = {}, out = [], checkedOffsets = {}, i, j, offset, guessesOffset;
        for(i = 0; i < offsetsLength; i++){
            offset = offsets[i].offset;
            if (checkedOffsets.hasOwnProperty(offset)) continue;
            guessesOffset = guesses[offset] || {};
            for(j in guessesOffset)if (guessesOffset.hasOwnProperty(j)) filteredGuesses[j] = true;
            checkedOffsets[offset] = true;
        }
        for(i in filteredGuesses)if (filteredGuesses.hasOwnProperty(i)) out.push(names[i]);
        return out;
    }
    function rebuildGuess() {
        // use Intl API when available and returning valid time zone
        try {
            var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (intlName && intlName.length > 3) {
                var name = names[normalizeName(intlName)];
                if (name) return name;
                logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
            }
        } catch (e) {
        // Intl unavailable, fall back to manual guessing.
        }
        var offsets = userOffsets(), offsetsLength = offsets.length, guesses = guessesForUserOffsets(offsets), zoneScores = [], zoneScore, i, j;
        for(i = 0; i < guesses.length; i++){
            zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
            for(j = 0; j < offsetsLength; j++)zoneScore.scoreOffsetAt(offsets[j]);
            zoneScores.push(zoneScore);
        }
        zoneScores.sort(sortZoneScores);
        return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
    }
    function guess(ignoreCache) {
        if (!cachedGuess || ignoreCache) cachedGuess = rebuildGuess();
        return cachedGuess;
    }
    /************************************
		Global Methods
	************************************/ function normalizeName(name) {
        return (name || "").toLowerCase().replace(/\//g, "_");
    }
    function addZone(packed) {
        var i, name, split, normalized;
        if (typeof packed === "string") packed = [
            packed
        ];
        for(i = 0; i < packed.length; i++){
            split = packed[i].split("|");
            name = split[0];
            normalized = normalizeName(name);
            zones[normalized] = packed[i];
            names[normalized] = name;
            addToGuesses(normalized, split[2].split(" "));
        }
    }
    function getZone(name, caller) {
        name = normalizeName(name);
        var zone = zones[name];
        var link;
        if (zone instanceof Zone) return zone;
        if (typeof zone === "string") {
            zone = new Zone(zone);
            zones[name] = zone;
            return zone;
        }
        // Pass getZone to prevent recursion more than 1 level deep
        if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
            zone = zones[name] = new Zone();
            zone._set(link);
            zone.name = names[name];
            return zone;
        }
        return null;
    }
    function getNames() {
        var i, out = [];
        for(i in names)if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) out.push(names[i]);
        return out.sort();
    }
    function getCountryNames() {
        return Object.keys(countries);
    }
    function addLink(aliases) {
        var i, alias, normal0, normal1;
        if (typeof aliases === "string") aliases = [
            aliases
        ];
        for(i = 0; i < aliases.length; i++){
            alias = aliases[i].split("|");
            normal0 = normalizeName(alias[0]);
            normal1 = normalizeName(alias[1]);
            links[normal0] = normal1;
            names[normal0] = alias[0];
            links[normal1] = normal0;
            names[normal1] = alias[1];
        }
    }
    function addCountries(data) {
        var i, country_code, country_zones, split;
        if (!data || !data.length) return;
        for(i = 0; i < data.length; i++){
            split = data[i].split("|");
            country_code = split[0].toUpperCase();
            country_zones = split[1].split(" ");
            countries[country_code] = new Country(country_code, country_zones);
        }
    }
    function getCountry(name) {
        name = name.toUpperCase();
        return countries[name] || null;
    }
    function zonesForCountry(country, with_offset) {
        country = getCountry(country);
        if (!country) return null;
        var zones = country.zones.sort();
        if (with_offset) return zones.map(function(zone_name) {
            var zone = getZone(zone_name);
            return {
                name: zone_name,
                offset: zone.utcOffset(new Date())
            };
        });
        return zones;
    }
    function loadData(data) {
        addZone(data.zones);
        addLink(data.links);
        addCountries(data.countries);
        tz.dataVersion = data.version;
    }
    function zoneExists(name) {
        if (!zoneExists.didShowError) {
            zoneExists.didShowError = true;
            logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
        }
        return !!getZone(name);
    }
    function needsOffset(m) {
        var isUnixTimestamp = m._f === "X" || m._f === "x";
        return !!(m._a && m._tzm === undefined && !isUnixTimestamp);
    }
    function logError(message) {
        if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    }
    /************************************
		moment.tz namespace
	************************************/ function tz(input) {
        var args = Array.prototype.slice.call(arguments, 0, -1), name = arguments[arguments.length - 1], out = moment.utc.apply(null, args), zone;
        if (!moment.isMoment(input) && needsOffset(out) && (zone = getZone(name))) out.add(zone.parse(out), "minutes");
        out.tz(name);
        return out;
    }
    tz.version = VERSION;
    tz.dataVersion = "";
    tz._zones = zones;
    tz._links = links;
    tz._names = names;
    tz._countries = countries;
    tz.add = addZone;
    tz.link = addLink;
    tz.load = loadData;
    tz.zone = getZone;
    tz.zoneExists = zoneExists; // deprecated in 0.1.0
    tz.guess = guess;
    tz.names = getNames;
    tz.Zone = Zone;
    tz.unpack = unpack;
    tz.unpackBase60 = unpackBase60;
    tz.needsOffset = needsOffset;
    tz.moveInvalidForward = true;
    tz.moveAmbiguousForward = false;
    tz.countries = getCountryNames;
    tz.zonesForCountry = zonesForCountry;
    /************************************
		Interface with Moment.js
	************************************/ var fn = moment.fn;
    moment.tz = tz;
    moment.defaultZone = null;
    moment.updateOffset = function(mom, keepTime) {
        var zone = moment.defaultZone, offset;
        if (mom._z === undefined) {
            if (zone && needsOffset(mom) && !mom._isUTC && mom.isValid()) {
                mom._d = moment.utc(mom._a)._d;
                mom.utc().add(zone.parse(mom), "minutes");
            }
            mom._z = zone;
        }
        if (mom._z) {
            offset = mom._z.utcOffset(mom);
            if (Math.abs(offset) < 16) offset = offset / 60;
            if (mom.utcOffset !== undefined) {
                var z = mom._z;
                mom.utcOffset(-offset, keepTime);
                mom._z = z;
            } else mom.zone(offset, keepTime);
        }
    };
    fn.tz = function(name, keepTime) {
        if (name) {
            if (typeof name !== "string") throw new Error("Time zone name must be a string, got " + name + " [" + typeof name + "]");
            this._z = getZone(name);
            if (this._z) moment.updateOffset(this, keepTime);
            else logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
            return this;
        }
        if (this._z) return this._z.name;
    };
    function abbrWrap(old) {
        return function() {
            if (this._z) return this._z.abbr(this);
            return old.call(this);
        };
    }
    function resetZoneWrap(old) {
        return function() {
            this._z = null;
            return old.apply(this, arguments);
        };
    }
    function resetZoneWrap2(old) {
        return function() {
            if (arguments.length > 0) this._z = null;
            return old.apply(this, arguments);
        };
    }
    fn.zoneName = abbrWrap(fn.zoneName);
    fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
    fn.utc = resetZoneWrap(fn.utc);
    fn.local = resetZoneWrap(fn.local);
    fn.utcOffset = resetZoneWrap2(fn.utcOffset);
    moment.tz.setDefault = function(name) {
        if (major < 2 || major === 2 && minor < 9) logError("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + moment.version + ".");
        moment.defaultZone = name ? getZone(name) : null;
        return moment;
    };
    // Cloning a moment should include the _z property.
    var momentProperties = moment.momentProperties;
    if (Object.prototype.toString.call(momentProperties) === "[object Array]") {
        // moment 2.8.1+
        momentProperties.push("_z");
        momentProperties.push("_a");
    } else if (momentProperties) // moment 2.7.0
    momentProperties._z = null;
    // INJECT DATA
    return moment;
});

});
parcelRegister("cxTnx", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});


parcelRegister("fxcAT", function(module, exports) {
module.exports = JSON.parse('{"version":"2024a","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5","America/Bahia_Banderas|LMT MST CST MDT PST CDT|71 70 60 60 80 50|0121312141313131313131313131313131313152525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5","America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4","America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|01213124242313131313131313131313131313131313131313131313131321313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST MDT PST|7n.Q 70 60 60 80|0121312141313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5","America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST MDT PST|75.E 70 60 60 80|0121312141313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4","America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5","America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mxUf.k 2LHcf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1qL0 11B0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|012132323232323232323232323232323232323232323232323232323232323232323232323232323232323232121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452","America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","Antarctica/Casey|-00 +08 +11|0 -80 -b0|012121212121212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4","Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +07 +05|0 -70 -50|01012|-tjA0 1rWh0 1Nj0 1aTv0|25","Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|0123232323232323232323212323232323232323232323232321|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 L4m0|15e5","Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4","Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5","Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5c0 aVX0 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 Mv90|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 XA0 Wou JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|LMT HMT -02 -01 +00 WET|1G.E 1S.w 20 10 0 0|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232343434343434343434343434343434345434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4","Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30","Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-10|+10|-a0|0||","Etc/GMT-11|+11|-b0|0||","Etc/GMT-12|+12|-c0|0||","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Etc/GMT-7|+07|-70|0||","Etc/GMT-8|+08|-80|0||","Etc/GMT-9|+09|-90|0||","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+2|-02|20|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5","Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5","Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5","Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4","Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5","Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6","Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4","Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4","Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2","Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3","Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56","Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/Reykjavik","Africa/Abidjan|Atlantic/St_Helena","Africa/Abidjan|Iceland","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|America/Yellowknife","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Iqaluit|America/Pangnirtung","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Phoenix|America/Creston","America/Phoenix|US/Arizona","America/Puerto_Rico|America/Anguilla","America/Puerto_Rico|America/Antigua","America/Puerto_Rico|America/Aruba","America/Puerto_Rico|America/Blanc-Sablon","America/Puerto_Rico|America/Curacao","America/Puerto_Rico|America/Dominica","America/Puerto_Rico|America/Grenada","America/Puerto_Rico|America/Guadeloupe","America/Puerto_Rico|America/Kralendijk","America/Puerto_Rico|America/Lower_Princes","America/Puerto_Rico|America/Marigot","America/Puerto_Rico|America/Montserrat","America/Puerto_Rico|America/Port_of_Spain","America/Puerto_Rico|America/St_Barthelemy","America/Puerto_Rico|America/St_Kitts","America/Puerto_Rico|America/St_Lucia","America/Puerto_Rico|America/St_Thomas","America/Puerto_Rico|America/St_Vincent","America/Puerto_Rico|America/Tortola","America/Puerto_Rico|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|America/Nassau","America/Toronto|America/Nipigon","America/Toronto|America/Thunder_Bay","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|America/Rainy_River","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Bangkok|Indian/Christmas","Asia/Brunei|Asia/Kuching","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Dubai|Indian/Mahe","Asia/Dubai|Indian/Reunion","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Rangoon|Indian/Cocos","Asia/Riyadh|Antarctica/Syowa","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Berlin|Arctic/Longyearbyen","Europe/Berlin|Atlantic/Jan_Mayen","Europe/Berlin|Europe/Copenhagen","Europe/Berlin|Europe/Oslo","Europe/Berlin|Europe/Stockholm","Europe/Brussels|Europe/Amsterdam","Europe/Brussels|Europe/Luxembourg","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Kiev|Europe/Kyiv","Europe/Kiev|Europe/Uzhgorod","Europe/Kiev|Europe/Zaporozhye","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Paris|Europe/Monaco","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Maldives|Indian/Kerguelen","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Enderbury|Pacific/Kanton","Pacific/Guadalcanal|Pacific/Pohnpei","Pacific/Guadalcanal|Pacific/Ponape","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Majuro","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Puerto_Rico America/Antigua","AI|America/Puerto_Rico America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Puerto_Rico America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Puerto_Rico America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Kuching Asia/Brunei","BO|America/La_Paz","BQ|America/Puerto_Rico America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Toronto America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston","CC|Asia/Yangon Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Puerto_Rico America/Curacao","CX|Asia/Bangkok Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Berlin Europe/Copenhagen","DM|America/Puerto_Rico America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Puerto_Rico America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Abidjan Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Puerto_Rico America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Africa/Abidjan Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Puerto_Rico America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Puerto_Rico America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Brussels Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Paris Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Puerto_Rico America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Puerto_Rico America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana","MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Brussels Europe/Amsterdam","NO|Europe/Berlin Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Asia/Dubai Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Asia/Dubai Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Berlin Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Berlin Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Puerto_Rico America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Asia/Dubai Indian/Maldives Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Puerto_Rico America/Port_of_Spain","TV|Pacific/Tarawa Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kyiv","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Puerto_Rico America/St_Vincent","VE|America/Caracas","VG|America/Puerto_Rico America/Tortola","VI|America/Puerto_Rico America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Tarawa Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}');

});


parcelRegister("aM783", function(module, exports) {

$parcel$export(module.exports, "AppConsts", function () { return $25aa9c33af19b12b$export$5b56affae6203cb3; });
$parcel$export(module.exports, "INVOICE_STATUS_CONFIRMED", function () { return $25aa9c33af19b12b$export$e9840605b8c161a; });
$parcel$export(module.exports, "DATE_TIME_FORMATS", function () { return $25aa9c33af19b12b$export$8efc56d5c85ee8e7; });

var $fmUFE = parcelRequire("fmUFE");
var $25aa9c33af19b12b$export$5b56affae6203cb3;
(function(AppConsts) {
    AppConsts["AccessToken"] = "access_token";
})($25aa9c33af19b12b$export$5b56affae6203cb3 || ($25aa9c33af19b12b$export$5b56affae6203cb3 = {}));
var $25aa9c33af19b12b$export$46919bad18fb2f76;
(function(Role) {
    Role["Admin"] = "Admin";
})($25aa9c33af19b12b$export$46919bad18fb2f76 || ($25aa9c33af19b12b$export$46919bad18fb2f76 = {}));
const $25aa9c33af19b12b$export$e9840605b8c161a = "Confirmed";
const $25aa9c33af19b12b$export$8efc56d5c85ee8e7 = {
    DATE_AND_TIME: "DD/MM/YYYY  HH:mm",
    DATE: "DD/MM/YYYY",
    DATE_AND_TIME_AM_PM: "DD/MM/YYYY hh:mm A"
};
const $25aa9c33af19b12b$export$7df16d7ec185e3bb = {
    [(0, $fmUFE.ValueLists).CompanyType]: "CompanyTypes",
    [(0, $fmUFE.ValueLists).MarketActivity]: "MarketActivities",
    [(0, $fmUFE.ValueLists).MembershipType]: "MembershipTypes",
    [(0, $fmUFE.ValueLists).ProductCode]: "ProductCodes",
    [(0, $fmUFE.ValueLists).TitleInternal]: "TitlesInternal"
};

});


parcelRegister("7rjIK", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
var $56aa5a26a67bad83$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TooltipBorder = module.exports.Tooltip = module.exports.Title = module.exports.Subtitle = module.exports.SmallValuesGrouping = module.exports.Size = module.exports.Shadow = module.exports.SeriesTemplate = module.exports.SeriesBorder = module.exports.Series = module.exports.SelectionStyle = module.exports.PieChartTitleSubtitle = module.exports.PieChartTitle = module.exports.Margin = module.exports.LoadingIndicator = module.exports.LegendTitleSubtitle = module.exports.LegendTitle = module.exports.Legend = module.exports.Label = module.exports.Image = module.exports.HoverStyle = module.exports.Hatching = module.exports.Format = module.exports.Font = module.exports.Export = module.exports.Connector = module.exports.CommonSeriesSettings = module.exports.CommonAnnotationSettings = module.exports.Border = module.exports.ArgumentFormat = module.exports.AnnotationBorder = module.exports.Annotation = module.exports.Animation = module.exports.AdaptiveLayout = module.exports.PieChart = void 0;

var $bDuoU = parcelRequire("bDuoU");

var $eCfBx = parcelRequire("eCfBx");

var $2qbeQ = parcelRequire("2qbeQ");

var $gkuLz = parcelRequire("gkuLz");
var $56aa5a26a67bad83$var$PieChart = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(PieChart, _super);
    function PieChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._WidgetClass = $bDuoU.default;
        _this.subscribableOptions = [
            "loadingIndicator",
            "loadingIndicator.show"
        ];
        _this.independentEvents = [
            "onDisposing",
            "onDone",
            "onDrawn",
            "onExported",
            "onExporting",
            "onFileSaving",
            "onIncidentOccurred",
            "onInitialized",
            "onLegendClick",
            "onPointClick",
            "onTooltipHidden",
            "onTooltipShown"
        ];
        _this._defaults = {
            defaultLoadingIndicator: "loadingIndicator"
        };
        _this._expectedChildren = {
            adaptiveLayout: {
                optionName: "adaptiveLayout",
                isCollectionItem: false
            },
            animation: {
                optionName: "animation",
                isCollectionItem: false
            },
            annotation: {
                optionName: "annotations",
                isCollectionItem: true
            },
            commonAnnotationSettings: {
                optionName: "commonAnnotationSettings",
                isCollectionItem: false
            },
            commonSeriesSettings: {
                optionName: "commonSeriesSettings",
                isCollectionItem: false
            },
            export: {
                optionName: "export",
                isCollectionItem: false
            },
            legend: {
                optionName: "legend",
                isCollectionItem: false
            },
            loadingIndicator: {
                optionName: "loadingIndicator",
                isCollectionItem: false
            },
            margin: {
                optionName: "margin",
                isCollectionItem: false
            },
            pieChartTitle: {
                optionName: "title",
                isCollectionItem: false
            },
            series: {
                optionName: "series",
                isCollectionItem: true
            },
            seriesTemplate: {
                optionName: "seriesTemplate",
                isCollectionItem: false
            },
            size: {
                optionName: "size",
                isCollectionItem: false
            },
            title: {
                optionName: "title",
                isCollectionItem: false
            },
            tooltip: {
                optionName: "tooltip",
                isCollectionItem: false
            }
        };
        _this._templateProps = [
            {
                tmplOption: "centerTemplate",
                render: "centerRender",
                component: "centerComponent",
                keyFn: "centerKeyFn"
            }
        ];
        return _this;
    }
    Object.defineProperty(PieChart.prototype, "instance", {
        get: function() {
            return this._instance;
        },
        enumerable: false,
        configurable: true
    });
    return PieChart;
}($2qbeQ.Component);
module.exports.PieChart = $56aa5a26a67bad83$var$PieChart;
$56aa5a26a67bad83$var$PieChart.propTypes = {
    adaptiveLayout: $eCfBx.object,
    animation: $eCfBx.oneOfType([
        $eCfBx.bool,
        $eCfBx.object
    ]),
    annotations: $eCfBx.array,
    commonAnnotationSettings: $eCfBx.object,
    customizeAnnotation: $eCfBx.func,
    customizeLabel: $eCfBx.func,
    customizePoint: $eCfBx.func,
    diameter: $eCfBx.number,
    disabled: $eCfBx.bool,
    elementAttr: $eCfBx.object,
    export: $eCfBx.object,
    innerRadius: $eCfBx.number,
    legend: $eCfBx.object,
    loadingIndicator: $eCfBx.object,
    margin: $eCfBx.object,
    minDiameter: $eCfBx.number,
    onDisposing: $eCfBx.func,
    onDone: $eCfBx.func,
    onDrawn: $eCfBx.func,
    onExported: $eCfBx.func,
    onExporting: $eCfBx.func,
    onFileSaving: $eCfBx.func,
    onIncidentOccurred: $eCfBx.func,
    onInitialized: $eCfBx.func,
    onLegendClick: $eCfBx.func,
    onOptionChanged: $eCfBx.func,
    onPointClick: $eCfBx.func,
    onPointHoverChanged: $eCfBx.func,
    onPointSelectionChanged: $eCfBx.func,
    onTooltipHidden: $eCfBx.func,
    onTooltipShown: $eCfBx.func,
    palette: $eCfBx.oneOfType([
        $eCfBx.array,
        $eCfBx.oneOfType([
            $eCfBx.string,
            $eCfBx.oneOf([
                "Bright",
                "Harmony Light",
                "Ocean",
                "Pastel",
                "Soft",
                "Soft Pastel",
                "Vintage",
                "Violet",
                "Carmine",
                "Dark Moon",
                "Dark Violet",
                "Green Mist",
                "Soft Blue",
                "Material",
                "Office"
            ])
        ])
    ]),
    paletteExtensionMode: $eCfBx.oneOfType([
        $eCfBx.string,
        $eCfBx.oneOf([
            "alternate",
            "blend",
            "extrapolate"
        ])
    ]),
    pathModified: $eCfBx.bool,
    pointSelectionMode: $eCfBx.oneOfType([
        $eCfBx.string,
        $eCfBx.oneOf([
            "single",
            "multiple"
        ])
    ]),
    redrawOnResize: $eCfBx.bool,
    resolveLabelOverlapping: $eCfBx.oneOfType([
        $eCfBx.string,
        $eCfBx.oneOf([
            "hide",
            "none",
            "shift"
        ])
    ]),
    rtlEnabled: $eCfBx.bool,
    segmentsDirection: $eCfBx.oneOfType([
        $eCfBx.string,
        $eCfBx.oneOf([
            "anticlockwise",
            "clockwise"
        ])
    ]),
    series: $eCfBx.oneOfType([
        $eCfBx.array,
        $eCfBx.object
    ]),
    seriesTemplate: $eCfBx.object,
    size: $eCfBx.object,
    sizeGroup: $eCfBx.string,
    startAngle: $eCfBx.number,
    theme: $eCfBx.oneOfType([
        $eCfBx.string,
        $eCfBx.oneOf([
            "generic.dark",
            "generic.light",
            "generic.contrast",
            "generic.carmine",
            "generic.darkmoon",
            "generic.darkviolet",
            "generic.greenmist",
            "generic.softblue",
            "material.blue.light",
            "material.lime.light",
            "material.orange.light",
            "material.purple.light",
            "material.teal.light"
        ])
    ]),
    title: $eCfBx.oneOfType([
        $eCfBx.object,
        $eCfBx.string
    ]),
    tooltip: $eCfBx.object,
    type: $eCfBx.oneOfType([
        $eCfBx.string,
        $eCfBx.oneOf([
            "donut",
            "doughnut",
            "pie"
        ])
    ])
};
var $56aa5a26a67bad83$var$AdaptiveLayout = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(AdaptiveLayout, _super);
    function AdaptiveLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdaptiveLayout.OptionName = "adaptiveLayout";
    return AdaptiveLayout;
}($gkuLz.default);
module.exports.AdaptiveLayout = $56aa5a26a67bad83$var$AdaptiveLayout;
var $56aa5a26a67bad83$var$Animation = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Animation, _super);
    function Animation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Animation.OptionName = "animation";
    return Animation;
}($gkuLz.default);
module.exports.Animation = $56aa5a26a67bad83$var$Animation;
var $56aa5a26a67bad83$var$Annotation = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Annotation, _super);
    function Annotation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Annotation.OptionName = "annotations";
    Annotation.IsCollectionItem = true;
    Annotation.ExpectedChildren = {
        annotationBorder: {
            optionName: "border",
            isCollectionItem: false
        },
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        font: {
            optionName: "font",
            isCollectionItem: false
        },
        image: {
            optionName: "image",
            isCollectionItem: false
        },
        shadow: {
            optionName: "shadow",
            isCollectionItem: false
        }
    };
    Annotation.TemplateProps = [
        {
            tmplOption: "template",
            render: "render",
            component: "component",
            keyFn: "keyFn"
        },
        {
            tmplOption: "tooltipTemplate",
            render: "tooltipRender",
            component: "tooltipComponent",
            keyFn: "tooltipKeyFn"
        }
    ];
    return Annotation;
}($gkuLz.default);
module.exports.Annotation = $56aa5a26a67bad83$var$Annotation;
var $56aa5a26a67bad83$var$AnnotationBorder = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(AnnotationBorder, _super);
    function AnnotationBorder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnnotationBorder.OptionName = "border";
    return AnnotationBorder;
}($gkuLz.default);
module.exports.AnnotationBorder = $56aa5a26a67bad83$var$AnnotationBorder;
var $56aa5a26a67bad83$var$ArgumentFormat = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(ArgumentFormat, _super);
    function ArgumentFormat() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArgumentFormat.OptionName = "argumentFormat";
    return ArgumentFormat;
}($gkuLz.default);
module.exports.ArgumentFormat = $56aa5a26a67bad83$var$ArgumentFormat;
var $56aa5a26a67bad83$var$Border = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Border, _super);
    function Border() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Border.OptionName = "border";
    return Border;
}($gkuLz.default);
module.exports.Border = $56aa5a26a67bad83$var$Border;
var $56aa5a26a67bad83$var$CommonAnnotationSettings = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(CommonAnnotationSettings, _super);
    function CommonAnnotationSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonAnnotationSettings.OptionName = "commonAnnotationSettings";
    CommonAnnotationSettings.TemplateProps = [
        {
            tmplOption: "template",
            render: "render",
            component: "component",
            keyFn: "keyFn"
        },
        {
            tmplOption: "tooltipTemplate",
            render: "tooltipRender",
            component: "tooltipComponent",
            keyFn: "tooltipKeyFn"
        }
    ];
    return CommonAnnotationSettings;
}($gkuLz.default);
module.exports.CommonAnnotationSettings = $56aa5a26a67bad83$var$CommonAnnotationSettings;
var $56aa5a26a67bad83$var$CommonSeriesSettings = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(CommonSeriesSettings, _super);
    function CommonSeriesSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonSeriesSettings.OptionName = "commonSeriesSettings";
    CommonSeriesSettings.ExpectedChildren = {
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        hoverStyle: {
            optionName: "hoverStyle",
            isCollectionItem: false
        },
        label: {
            optionName: "label",
            isCollectionItem: false
        },
        selectionStyle: {
            optionName: "selectionStyle",
            isCollectionItem: false
        },
        seriesBorder: {
            optionName: "border",
            isCollectionItem: false
        },
        smallValuesGrouping: {
            optionName: "smallValuesGrouping",
            isCollectionItem: false
        }
    };
    return CommonSeriesSettings;
}($gkuLz.default);
module.exports.CommonSeriesSettings = $56aa5a26a67bad83$var$CommonSeriesSettings;
var $56aa5a26a67bad83$var$Connector = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Connector, _super);
    function Connector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Connector.OptionName = "connector";
    return Connector;
}($gkuLz.default);
module.exports.Connector = $56aa5a26a67bad83$var$Connector;
var $56aa5a26a67bad83$var$Export = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Export, _super);
    function Export() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Export.OptionName = "export";
    return Export;
}($gkuLz.default);
module.exports.Export = $56aa5a26a67bad83$var$Export;
var $56aa5a26a67bad83$var$Font = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Font, _super);
    function Font() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Font.OptionName = "font";
    return Font;
}($gkuLz.default);
module.exports.Font = $56aa5a26a67bad83$var$Font;
var $56aa5a26a67bad83$var$Format = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Format, _super);
    function Format() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Format.OptionName = "format";
    return Format;
}($gkuLz.default);
module.exports.Format = $56aa5a26a67bad83$var$Format;
var $56aa5a26a67bad83$var$Hatching = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Hatching, _super);
    function Hatching() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Hatching.OptionName = "hatching";
    return Hatching;
}($gkuLz.default);
module.exports.Hatching = $56aa5a26a67bad83$var$Hatching;
var $56aa5a26a67bad83$var$HoverStyle = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(HoverStyle, _super);
    function HoverStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HoverStyle.OptionName = "hoverStyle";
    HoverStyle.ExpectedChildren = {
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        hatching: {
            optionName: "hatching",
            isCollectionItem: false
        },
        seriesBorder: {
            optionName: "border",
            isCollectionItem: false
        }
    };
    return HoverStyle;
}($gkuLz.default);
module.exports.HoverStyle = $56aa5a26a67bad83$var$HoverStyle;
var $56aa5a26a67bad83$var$Image = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Image, _super);
    function Image() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Image.OptionName = "image";
    return Image;
}($gkuLz.default);
module.exports.Image = $56aa5a26a67bad83$var$Image;
var $56aa5a26a67bad83$var$Label = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Label, _super);
    function Label() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Label.OptionName = "label";
    Label.ExpectedChildren = {
        argumentFormat: {
            optionName: "argumentFormat",
            isCollectionItem: false
        },
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        connector: {
            optionName: "connector",
            isCollectionItem: false
        },
        font: {
            optionName: "font",
            isCollectionItem: false
        },
        format: {
            optionName: "format",
            isCollectionItem: false
        },
        seriesBorder: {
            optionName: "border",
            isCollectionItem: false
        }
    };
    return Label;
}($gkuLz.default);
module.exports.Label = $56aa5a26a67bad83$var$Label;
var $56aa5a26a67bad83$var$Legend = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Legend, _super);
    function Legend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Legend.OptionName = "legend";
    Legend.ExpectedChildren = {
        annotationBorder: {
            optionName: "border",
            isCollectionItem: false
        },
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        font: {
            optionName: "font",
            isCollectionItem: false
        },
        legendTitle: {
            optionName: "title",
            isCollectionItem: false
        },
        margin: {
            optionName: "margin",
            isCollectionItem: false
        },
        title: {
            optionName: "title",
            isCollectionItem: false
        }
    };
    Legend.TemplateProps = [
        {
            tmplOption: "markerTemplate",
            render: "markerRender",
            component: "markerComponent",
            keyFn: "markerKeyFn"
        }
    ];
    return Legend;
}($gkuLz.default);
module.exports.Legend = $56aa5a26a67bad83$var$Legend;
var $56aa5a26a67bad83$var$LegendTitle = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(LegendTitle, _super);
    function LegendTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegendTitle.OptionName = "title";
    LegendTitle.ExpectedChildren = {
        font: {
            optionName: "font",
            isCollectionItem: false
        },
        legendTitleSubtitle: {
            optionName: "subtitle",
            isCollectionItem: false
        },
        margin: {
            optionName: "margin",
            isCollectionItem: false
        },
        subtitle: {
            optionName: "subtitle",
            isCollectionItem: false
        }
    };
    return LegendTitle;
}($gkuLz.default);
module.exports.LegendTitle = $56aa5a26a67bad83$var$LegendTitle;
var $56aa5a26a67bad83$var$LegendTitleSubtitle = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(LegendTitleSubtitle, _super);
    function LegendTitleSubtitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegendTitleSubtitle.OptionName = "subtitle";
    LegendTitleSubtitle.ExpectedChildren = {
        font: {
            optionName: "font",
            isCollectionItem: false
        }
    };
    return LegendTitleSubtitle;
}($gkuLz.default);
module.exports.LegendTitleSubtitle = $56aa5a26a67bad83$var$LegendTitleSubtitle;
var $56aa5a26a67bad83$var$LoadingIndicator = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(LoadingIndicator, _super);
    function LoadingIndicator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingIndicator.OptionName = "loadingIndicator";
    LoadingIndicator.DefaultsProps = {
        defaultShow: "show"
    };
    LoadingIndicator.ExpectedChildren = {
        font: {
            optionName: "font",
            isCollectionItem: false
        }
    };
    return LoadingIndicator;
}($gkuLz.default);
module.exports.LoadingIndicator = $56aa5a26a67bad83$var$LoadingIndicator;
var $56aa5a26a67bad83$var$Margin = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Margin, _super);
    function Margin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Margin.OptionName = "margin";
    return Margin;
}($gkuLz.default);
module.exports.Margin = $56aa5a26a67bad83$var$Margin;
var $56aa5a26a67bad83$var$PieChartTitle = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(PieChartTitle, _super);
    function PieChartTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PieChartTitle.OptionName = "title";
    PieChartTitle.ExpectedChildren = {
        font: {
            optionName: "font",
            isCollectionItem: false
        },
        margin: {
            optionName: "margin",
            isCollectionItem: false
        },
        pieChartTitleSubtitle: {
            optionName: "subtitle",
            isCollectionItem: false
        },
        subtitle: {
            optionName: "subtitle",
            isCollectionItem: false
        }
    };
    return PieChartTitle;
}($gkuLz.default);
module.exports.PieChartTitle = $56aa5a26a67bad83$var$PieChartTitle;
var $56aa5a26a67bad83$var$PieChartTitleSubtitle = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(PieChartTitleSubtitle, _super);
    function PieChartTitleSubtitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PieChartTitleSubtitle.OptionName = "subtitle";
    PieChartTitleSubtitle.ExpectedChildren = {
        font: {
            optionName: "font",
            isCollectionItem: false
        }
    };
    return PieChartTitleSubtitle;
}($gkuLz.default);
module.exports.PieChartTitleSubtitle = $56aa5a26a67bad83$var$PieChartTitleSubtitle;
var $56aa5a26a67bad83$var$SelectionStyle = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(SelectionStyle, _super);
    function SelectionStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectionStyle.OptionName = "selectionStyle";
    SelectionStyle.ExpectedChildren = {
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        hatching: {
            optionName: "hatching",
            isCollectionItem: false
        },
        seriesBorder: {
            optionName: "border",
            isCollectionItem: false
        }
    };
    return SelectionStyle;
}($gkuLz.default);
module.exports.SelectionStyle = $56aa5a26a67bad83$var$SelectionStyle;
var $56aa5a26a67bad83$var$Series = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Series, _super);
    function Series() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Series.OptionName = "series";
    Series.IsCollectionItem = true;
    return Series;
}($gkuLz.default);
module.exports.Series = $56aa5a26a67bad83$var$Series;
var $56aa5a26a67bad83$var$SeriesBorder = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(SeriesBorder, _super);
    function SeriesBorder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SeriesBorder.OptionName = "border";
    return SeriesBorder;
}($gkuLz.default);
module.exports.SeriesBorder = $56aa5a26a67bad83$var$SeriesBorder;
var $56aa5a26a67bad83$var$SeriesTemplate = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(SeriesTemplate, _super);
    function SeriesTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SeriesTemplate.OptionName = "seriesTemplate";
    return SeriesTemplate;
}($gkuLz.default);
module.exports.SeriesTemplate = $56aa5a26a67bad83$var$SeriesTemplate;
var $56aa5a26a67bad83$var$Shadow = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Shadow, _super);
    function Shadow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Shadow.OptionName = "shadow";
    return Shadow;
}($gkuLz.default);
module.exports.Shadow = $56aa5a26a67bad83$var$Shadow;
var $56aa5a26a67bad83$var$Size = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Size, _super);
    function Size() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Size.OptionName = "size";
    return Size;
}($gkuLz.default);
module.exports.Size = $56aa5a26a67bad83$var$Size;
var $56aa5a26a67bad83$var$SmallValuesGrouping = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(SmallValuesGrouping, _super);
    function SmallValuesGrouping() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SmallValuesGrouping.OptionName = "smallValuesGrouping";
    return SmallValuesGrouping;
}($gkuLz.default);
module.exports.SmallValuesGrouping = $56aa5a26a67bad83$var$SmallValuesGrouping;
var $56aa5a26a67bad83$var$Subtitle = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Subtitle, _super);
    function Subtitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Subtitle.OptionName = "subtitle";
    return Subtitle;
}($gkuLz.default);
module.exports.Subtitle = $56aa5a26a67bad83$var$Subtitle;
var $56aa5a26a67bad83$var$Title = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Title, _super);
    function Title() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Title.OptionName = "title";
    return Title;
}($gkuLz.default);
module.exports.Title = $56aa5a26a67bad83$var$Title;
var $56aa5a26a67bad83$var$Tooltip = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(Tooltip, _super);
    function Tooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tooltip.OptionName = "tooltip";
    Tooltip.ExpectedChildren = {
        argumentFormat: {
            optionName: "argumentFormat",
            isCollectionItem: false
        },
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        font: {
            optionName: "font",
            isCollectionItem: false
        },
        format: {
            optionName: "format",
            isCollectionItem: false
        },
        shadow: {
            optionName: "shadow",
            isCollectionItem: false
        },
        tooltipBorder: {
            optionName: "border",
            isCollectionItem: false
        }
    };
    Tooltip.TemplateProps = [
        {
            tmplOption: "contentTemplate",
            render: "contentRender",
            component: "contentComponent",
            keyFn: "contentKeyFn"
        }
    ];
    return Tooltip;
}($gkuLz.default);
module.exports.Tooltip = $56aa5a26a67bad83$var$Tooltip;
var $56aa5a26a67bad83$var$TooltipBorder = /** @class */ function(_super) {
    $56aa5a26a67bad83$var$__extends(TooltipBorder, _super);
    function TooltipBorder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TooltipBorder.OptionName = "border";
    return TooltipBorder;
}($gkuLz.default);
module.exports.TooltipBorder = $56aa5a26a67bad83$var$TooltipBorder;
module.exports.default = $56aa5a26a67bad83$var$PieChart;

});
parcelRegister("bDuoU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $878aeb330d86e612$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/pie_chart.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $9KHs6 = parcelRequire("9KHs6");
var $878aeb330d86e612$export$2e2bcd8739ae039 = (0, $9KHs6.default);

});
parcelRegister("9KHs6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $719a1da37d40e2ba$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/__internal/viz/m_pie_chart.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $9UmiO = parcelRequire("9UmiO");

var $gcp4g = parcelRequire("gcp4g");

var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $6ntMu = parcelRequire("6ntMu");

var $8LJ26 = parcelRequire("8LJ26");

var $cYTj1 = parcelRequire("cYTj1");

var $dw9tZ = parcelRequire("dw9tZ");

var $4jhWa = parcelRequire("4jhWa");

var $3oqfq = parcelRequire("3oqfq");

var $7MSPx = parcelRequire("7MSPx");
var { states: $719a1da37d40e2ba$var$states } = (0, $8LJ26.default);
var $719a1da37d40e2ba$var$seriesSpacing = (0, $8LJ26.default).pieSeriesSpacing;
var $719a1da37d40e2ba$var$OPTIONS_FOR_REFRESH_SERIES = [
    "startAngle",
    "innerRadius",
    "segmentsDirection",
    "type"
];
var $719a1da37d40e2ba$var$NORMAL_STATE = $719a1da37d40e2ba$var$states.normalMark;
var $719a1da37d40e2ba$var$HOVER_STATE = $719a1da37d40e2ba$var$states.hoverMark;
var $719a1da37d40e2ba$var$SELECTED_STATE = $719a1da37d40e2ba$var$states.selectedMark;
var $719a1da37d40e2ba$var$MAX_RESOLVE_ITERATION_COUNT = 5;
var $719a1da37d40e2ba$var$LEGEND_ACTIONS = [
    $719a1da37d40e2ba$var$states.resetItem,
    $719a1da37d40e2ba$var$states.applyHover,
    $719a1da37d40e2ba$var$states.applySelected,
    $719a1da37d40e2ba$var$states.applySelected
];
function $719a1da37d40e2ba$var$shiftInColumnFunction(box, length) {
    return {
        x: box.x,
        y: box.y - length
    };
}
function $719a1da37d40e2ba$var$dividePoints(series, points) {
    return series.getVisiblePoints().reduce((r, point)=>{
        var angle = (0, $dw9tZ.normalizeAngle)(point.middleAngle);
        (angle <= 90 || angle >= 270 ? r.right : r.left).push(point);
        return r;
    }, points || {
        left: [],
        right: []
    });
}
function $719a1da37d40e2ba$var$resolveOverlappedLabels(points, shiftCallback, inverseDirection, canvas) {
    var overlapped;
    if (inverseDirection) {
        points.left.reverse();
        points.right.reverse();
    }
    overlapped = (0, $7MSPx.overlapping).resolveLabelOverlappingInOneDirection(points.left, canvas, false, false, shiftCallback);
    return (0, $7MSPx.overlapping).resolveLabelOverlappingInOneDirection(points.right, canvas, false, false, shiftCallback) || overlapped;
}
function $719a1da37d40e2ba$var$getLegendItemAction(points) {
    var state = $719a1da37d40e2ba$var$NORMAL_STATE;
    points.forEach((point)=>{
        var _a;
        var seriesOptions = null === (_a = point.series) || void 0 === _a ? void 0 : _a.getOptions();
        var pointState = point.fullState;
        if ("none" === (null === seriesOptions || void 0 === seriesOptions ? void 0 : seriesOptions.hoverMode)) pointState &= ~$719a1da37d40e2ba$var$HOVER_STATE;
        if ("none" === (null === seriesOptions || void 0 === seriesOptions ? void 0 : seriesOptions.selectionMode)) pointState &= ~$719a1da37d40e2ba$var$SELECTED_STATE;
        state |= pointState;
    });
    return $719a1da37d40e2ba$var$LEGEND_ACTIONS[state];
}
function $719a1da37d40e2ba$var$correctPercentValue(value) {
    if ((0, $6ntMu.isNumeric)(value)) {
        if (value > 1) value = 1;
        else if (value < 0) value = 0;
    } else value = void 0;
    return value;
}
var $719a1da37d40e2ba$var$pieSizeEqualizer = function() {
    function removeFromList(list, item) {
        return list.filter((li)=>li !== item);
    }
    var pies = [];
    var timers = {};
    return {
        queue (pie) {
            var group = pie.getSizeGroup();
            pies = (list = pies, item = pie, removeFromList(list, item).concat(item));
            var list, item;
            clearTimeout(timers[group]);
            timers[group] = setTimeout(()=>{
                !function(group, allPies) {
                    var pies = allPies.filter((p)=>p._isVisible() && p.getSizeGroup() === group);
                    var minRadius = Math.min.apply(null, pies.map((p)=>p.getSizeGroupLayout().radius));
                    var minPie = pies.filter((p)=>p.getSizeGroupLayout().radius === minRadius);
                    pies.forEach((p)=>p.render({
                            force: true,
                            sizeGroupLayout: minPie.length ? minPie[0].getSizeGroupLayout() : {}
                        }));
                }(group, pies);
            });
        },
        remove (pie) {
            pies = removeFromList(pies, pie);
            if (!pies.length) timers = {};
        }
    };
}();
var $719a1da37d40e2ba$var$dxPieChart = (0, $7MSPx.BaseChart).inherit({
    _themeSection: "pie",
    _layoutManagerOptions () {
        return (0, $2oTOp.extend)(true, {}, this.callBase(), {
            piePercentage: $719a1da37d40e2ba$var$correctPercentValue(this._themeManager.getOptions("diameter")),
            minPiePercentage: $719a1da37d40e2ba$var$correctPercentValue(this._themeManager.getOptions("minDiameter"))
        });
    },
    _customChangesOrder: [
        "CENTER_TEMPLATE"
    ],
    _optionChangesMap: {
        diameter: "REINIT",
        minDiameter: "REINIT",
        sizeGroup: "REINIT",
        centerTemplate: "CENTER_TEMPLATE"
    },
    _change_CENTER_TEMPLATE () {
        this._renderCenterTemplate();
    },
    _disposeCore () {
        $719a1da37d40e2ba$var$pieSizeEqualizer.remove(this);
        this.callBase();
        this._centerTemplateGroup.linkOff().dispose();
    },
    _groupSeries () {
        var _a;
        var { series: series } = this;
        this._groupsData = {
            groups: [
                {
                    series: series,
                    valueOptions: {
                        valueType: "numeric"
                    }
                }
            ],
            argumentOptions: null === (_a = series[0]) || void 0 === _a ? void 0 : _a.getOptions()
        };
    },
    getArgumentAxis: ()=>null,
    _getValueAxis () {
        var translator = (new (0, $3oqfq.Translator1D)).setCodomain(360, 0);
        return {
            getTranslator: ()=>translator,
            setBusinessRange (range) {
                translator.setDomain(range.min, range.max);
            }
        };
    },
    _populateBusinessRange () {
        this.series.map((series)=>{
            var range = new (0, $4jhWa.Range);
            range.addRange(series.getRangeData().val);
            series.getValueAxis().setBusinessRange(range);
            return range;
        });
    },
    _specialProcessSeries () {
        (0, $8OLOW.each)(this.series, (_, singleSeries)=>{
            singleSeries.arrangePoints();
        });
    },
    _checkPaneName: ()=>true,
    _processSingleSeries (singleSeries) {
        this.callBase(singleSeries);
        singleSeries.arrangePoints();
    },
    _handleSeriesDataUpdated () {
        var maxPointCount = 0;
        this.series.forEach((s)=>{
            maxPointCount = Math.max(s.getPointsCount(), maxPointCount);
        });
        this.series.forEach((s)=>{
            s.setMaxPointsCount(maxPointCount);
        });
        this.callBase();
    },
    _getLegendOptions (item) {
        var legendItem = this.callBase(item);
        var { legendData: legendData } = legendItem;
        legendData.argument = item.argument;
        legendData.argumentIndex = item.argumentIndex;
        legendData.points = [
            item
        ];
        return legendItem;
    },
    _getLegendTargets () {
        var itemsByArgument = {};
        (this.series || []).forEach((series)=>{
            series.getPoints().forEach((point)=>{
                var argument = point.argument.valueOf();
                var index = series.getPointsByArg(argument).indexOf(point);
                var key = argument.valueOf().toString() + index;
                itemsByArgument[key] = itemsByArgument[key] || [];
                var argumentCount = itemsByArgument[key].push(point);
                point.index = itemsByArgument[key][argumentCount - 2] ? itemsByArgument[key][argumentCount - 2].index : Object.keys(itemsByArgument).length - 1;
                point.argumentIndex = index;
            });
        });
        var items = [];
        (0, $8OLOW.each)(itemsByArgument, (_, points)=>{
            points.forEach((point, index)=>{
                if (0 === index) {
                    items.push(this._getLegendOptions(point));
                    return;
                }
                var item = items[items.length - 1];
                item.legendData.points.push(point);
                if (!item.visible) item.visible = point.isVisible();
            });
        });
        return items;
    },
    _getLayoutTargets () {
        return [
            {
                canvas: this._canvas
            }
        ];
    },
    _getLayoutSeries (series, drawOptions) {
        var layout;
        var canvas = this._canvas;
        var drawnLabels = false;
        layout = this.layoutManager.applyPieChartSeriesLayout(canvas, series, true);
        series.forEach((singleSeries)=>{
            singleSeries.correctPosition(layout, canvas);
            drawnLabels = singleSeries.drawLabelsWOPoints() || drawnLabels;
        });
        if (drawnLabels) layout = this.layoutManager.applyPieChartSeriesLayout(canvas, series, drawOptions.hideLayoutLabels);
        series.forEach((singleSeries)=>{
            singleSeries.hideLabels();
        });
        this._sizeGroupLayout = {
            x: layout.centerX,
            y: layout.centerY,
            radius: layout.radiusOuter,
            drawOptions: drawOptions
        };
        return layout;
    },
    _getLayoutSeriesForEqualPies (series, sizeGroupLayout) {
        var canvas = this._canvas;
        var layout = this.layoutManager.applyEqualPieChartLayout(series, sizeGroupLayout);
        series.forEach((s)=>{
            s.correctPosition(layout, canvas);
            s.drawLabelsWOPoints();
        });
        this.layoutManager.correctPieLabelRadius(series, layout, canvas);
        return layout;
    },
    _updateSeriesDimensions (drawOptions) {
        var visibleSeries = this._getVisibleSeries();
        var lengthVisibleSeries = visibleSeries.length;
        var innerRad;
        var delta;
        var layout;
        var { sizeGroupLayout: sizeGroupLayout } = drawOptions;
        if (lengthVisibleSeries) {
            layout = sizeGroupLayout ? this._getLayoutSeriesForEqualPies(visibleSeries, sizeGroupLayout) : this._getLayoutSeries(visibleSeries, drawOptions);
            delta = (layout.radiusOuter - layout.radiusInner - $719a1da37d40e2ba$var$seriesSpacing * (lengthVisibleSeries - 1)) / lengthVisibleSeries;
            innerRad = layout.radiusInner;
            this._setGeometry(layout);
            visibleSeries.forEach((singleSeries)=>{
                singleSeries.correctRadius({
                    radiusInner: innerRad,
                    radiusOuter: innerRad + delta
                });
                innerRad += delta + $719a1da37d40e2ba$var$seriesSpacing;
            });
        }
    },
    _renderSeries (drawOptions, isRotated, isLegendInside) {
        this._calculateSeriesLayout(drawOptions, isRotated);
        if (!drawOptions.sizeGroupLayout && this.getSizeGroup()) {
            $719a1da37d40e2ba$var$pieSizeEqualizer.queue(this);
            this._clearCanvas();
            return;
        }
        this._renderSeriesElements(drawOptions, isLegendInside);
    },
    _createHtmlStructure () {
        this.callBase();
        this._centerTemplateGroup = this._renderer.g().attr({
            class: "dxc-hole-template"
        }).linkOn(this._renderer.root, "center-template").css((0, $dw9tZ.patchFontOptions)(this._themeManager._font)).linkAppend();
    },
    _renderExtraElements () {
        this._requestChange([
            "CENTER_TEMPLATE"
        ]);
    },
    _renderCenterTemplate () {
        var template = this.option("centerTemplate");
        var centerTemplateGroup = this._centerTemplateGroup.clear();
        if (!template) return;
        centerTemplateGroup.attr({
            visibility: "hidden"
        });
        template = this._getTemplate(template);
        template.render({
            model: this,
            container: centerTemplateGroup.element,
            onRendered: ()=>{
                var group = centerTemplateGroup;
                var bBox = group.getBBox();
                group.move(this._center.x - (bBox.x + bBox.width / 2), this._center.y - (bBox.y + bBox.height / 2));
                group.attr({
                    visibility: "visible"
                });
            }
        });
    },
    getInnerRadius () {
        return this._innerRadius;
    },
    _getLegendCallBack () {
        var legend = this._legend;
        var items = this._getLegendTargets().map((i)=>i.legendData);
        return (target)=>{
            items.forEach((data)=>{
                var points = [];
                var callback = legend.getActionCallback({
                    index: data.id
                });
                this.series.forEach((series)=>{
                    var seriesPoints = series.getPointsByKeys(data.argument, data.argumentIndex);
                    points.push.apply(points, seriesPoints);
                });
                if (target && target.argument === data.argument && target.argumentIndex === data.argumentIndex) points.push(target);
                callback($719a1da37d40e2ba$var$getLegendItemAction(points));
            });
        };
    },
    _locateLabels (resolveLabelOverlapping) {
        var iterationCount = 0;
        var labelsWereOverlapped;
        var wordWrapApplied;
        do {
            wordWrapApplied = this._adjustSeriesLabels("shift" === resolveLabelOverlapping);
            labelsWereOverlapped = this._resolveLabelOverlapping(resolveLabelOverlapping);
        }while ((labelsWereOverlapped || wordWrapApplied) && ++iterationCount < $719a1da37d40e2ba$var$MAX_RESOLVE_ITERATION_COUNT);
    },
    _adjustSeriesLabels (moveLabelsFromCenter) {
        return this.series.reduce((r, s)=>s.adjustLabels(moveLabelsFromCenter) || r, false);
    },
    _applyExtraSettings: (0, $gcp4g.noop),
    _resolveLabelOverlappingShift () {
        var inverseDirection = "anticlockwise" === this.option("segmentsDirection");
        var seriesByPosition = this.series.reduce((r, s)=>{
            (r[s.getOptions().label.position] || r.outside).push(s);
            return r;
        }, {
            inside: [],
            columns: [],
            outside: []
        });
        var labelsOverlapped = false;
        if (seriesByPosition.inside.length > 0) {
            var pointsToResolve = seriesByPosition.inside.reduce((r, singleSeries)=>{
                var visiblePoints = singleSeries.getVisiblePoints();
                return visiblePoints.reduce((r, point)=>{
                    r.left.push(point);
                    return r;
                }, r);
            }, {
                left: [],
                right: []
            });
            labelsOverlapped = $719a1da37d40e2ba$var$resolveOverlappedLabels(pointsToResolve, $719a1da37d40e2ba$var$shiftInColumnFunction, inverseDirection, this._canvas) || labelsOverlapped;
        }
        labelsOverlapped = seriesByPosition.columns.reduce((r, singleSeries)=>$719a1da37d40e2ba$var$resolveOverlappedLabels($719a1da37d40e2ba$var$dividePoints(singleSeries), $719a1da37d40e2ba$var$shiftInColumnFunction, inverseDirection, this._canvas) || r, labelsOverlapped);
        if (seriesByPosition.outside.length > 0) labelsOverlapped = $719a1da37d40e2ba$var$resolveOverlappedLabels(seriesByPosition.outside.reduce((r, singleSeries)=>$719a1da37d40e2ba$var$dividePoints(singleSeries, r), null), (box, length)=>(0, $dw9tZ.getVerticallyShiftedAngularCoords)(box, -length, this._center), inverseDirection, this._canvas) || labelsOverlapped;
        return labelsOverlapped;
    },
    _setGeometry (_ref) {
        var { centerX: x, centerY: y, radiusInner: radiusInner } = _ref;
        this._center = {
            x: x,
            y: y
        };
        this._innerRadius = radiusInner;
    },
    _disposeSeries () {
        this.callBase.apply(this, arguments);
        this._abstractSeries = null;
    },
    _legendDataField: "point",
    _legendItemTextField: "argument",
    _applyPointMarkersAutoHiding: (0, $gcp4g.noop),
    _renderTrackers: (0, $gcp4g.noop),
    _trackerType: "PieTracker",
    _createScrollBar: (0, $gcp4g.noop),
    _updateAxesLayout: (0, $gcp4g.noop),
    _applyClipRects: (0, $gcp4g.noop),
    _appendAdditionalSeriesGroups: (0, $gcp4g.noop),
    _prepareToRender: (0, $gcp4g.noop),
    _isLegendInside: (0, $gcp4g.noop),
    _renderAxes: (0, $gcp4g.noop),
    _shrinkAxes: (0, $gcp4g.noop),
    _isRotated: (0, $gcp4g.noop),
    _seriesPopulatedHandlerCore: (0, $gcp4g.noop),
    _reinitAxes: (0, $gcp4g.noop),
    _correctAxes: (0, $gcp4g.noop),
    _getExtraOptions () {
        return {
            startAngle: this.option("startAngle"),
            innerRadius: this.option("innerRadius"),
            segmentsDirection: this.option("segmentsDirection"),
            type: this.option("type")
        };
    },
    getSizeGroup () {
        return this._themeManager.getOptions("sizeGroup");
    },
    getSizeGroupLayout () {
        return this._sizeGroupLayout || {};
    }
});
(0, $8OLOW.each)($719a1da37d40e2ba$var$OPTIONS_FOR_REFRESH_SERIES, (_, name)=>{
    $719a1da37d40e2ba$var$dxPieChart.prototype._optionChangesMap[name] = "REFRESH_SERIES_DATA_INIT";
});
$719a1da37d40e2ba$var$dxPieChart.addPlugin((0, $cYTj1.plugins).core);
$719a1da37d40e2ba$var$dxPieChart.addPlugin((0, $cYTj1.plugins).pieChart);
(0, $9UmiO.default)("dxPieChart", $719a1da37d40e2ba$var$dxPieChart);
var $719a1da37d40e2ba$export$2e2bcd8739ae039 = $719a1da37d40e2ba$var$dxPieChart;

});
parcelRegister("9UmiO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $736aa4cfd50a0645$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/component_registrator.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $l5tfV = parcelRequire("l5tfV");

var $cvYFL = parcelRequire("cvYFL");

var $8irnY = parcelRequire("8irnY");
var $736aa4cfd50a0645$var$registerComponent = function(name, namespace, componentClass) {
    if (!componentClass) componentClass = namespace;
    else namespace[name] = componentClass;
    (0, $8irnY.name)(componentClass, name);
    (0, $l5tfV.default).fire(name, componentClass);
};
var $736aa4cfd50a0645$var$registerRendererComponent = function(name, componentClass) {
    (0, $2vlX8.default).fn[name] = function(options) {
        var isMemberInvoke = "string" === typeof options;
        var result;
        if (isMemberInvoke) {
            var memberName = options;
            var memberArgs = [].slice.call(arguments).slice(1);
            this.each(function() {
                var instance = componentClass.getInstance(this);
                if (!instance) throw (0, $cvYFL.default).Error("E0009", name);
                var member = instance[memberName];
                var memberValue = member.apply(instance, memberArgs);
                if (void 0 === result) result = memberValue;
            });
        } else {
            this.each(function() {
                var instance = componentClass.getInstance(this);
                if (instance) instance.option(options);
                else new componentClass(this, options);
            });
            result = this;
        }
        return result;
    };
};
(0, $l5tfV.default).add($736aa4cfd50a0645$var$registerRendererComponent);
var $736aa4cfd50a0645$export$2e2bcd8739ae039 = $736aa4cfd50a0645$var$registerComponent;

});
parcelRegister("2vlX8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d2f8162870ec36f$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/renderer.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $1hVlw = parcelRequire("1hVlw");
var $1d2f8162870ec36f$export$2e2bcd8739ae039 = (0, $1hVlw.default).get();

});
parcelRegister("1hVlw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f03dcbde37c418c$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/renderer_base.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $jc4XS = parcelRequire("jc4XS");

var $3yzYM = parcelRequire("3yzYM");

var $hYatw = parcelRequire("hYatw");

var $6ntMu = parcelRequire("6ntMu");

var $4jWiu = parcelRequire("4jWiu");

var $iE2yv = parcelRequire("iE2yv");

var $XxsMu = parcelRequire("XxsMu");
var $0f03dcbde37c418c$var$window = (0, $hYatw.getWindow)();
var $0f03dcbde37c418c$var$renderer;
var $0f03dcbde37c418c$var$initRender = function(selector, context) {
    if (!selector) {
        this.length = 0;
        return this;
    }
    if ("string" === typeof selector) {
        if ("body" === selector) {
            this[0] = context ? context.body : (0, $3yzYM.default).getBody();
            this.length = 1;
            return this;
        }
        context = context || (0, $3yzYM.default).getDocument();
        if ("<" === selector[0]) {
            this[0] = (0, $3yzYM.default).createElement(selector.slice(1, -1), context);
            this.length = 1;
            return this;
        }
        [].push.apply(this, (0, $3yzYM.default).querySelectorAll(context, selector));
        return this;
    } else if ((0, $3yzYM.default).isNode(selector) || (0, $6ntMu.isWindow)(selector)) {
        this[0] = selector;
        this.length = 1;
        return this;
    } else if (Array.isArray(selector)) {
        [].push.apply(this, selector);
        return this;
    }
    return $0f03dcbde37c418c$var$renderer(selector.toArray ? selector.toArray() : [
        selector
    ]);
};
$0f03dcbde37c418c$var$renderer = function(selector, context) {
    return new $0f03dcbde37c418c$var$initRender(selector, context);
};
$0f03dcbde37c418c$var$renderer.fn = {
    dxRenderer: true
};
$0f03dcbde37c418c$var$initRender.prototype = $0f03dcbde37c418c$var$renderer.fn;
var $0f03dcbde37c418c$var$repeatMethod = function(methodName, args) {
    for(var i = 0; i < this.length; i++){
        var item = $0f03dcbde37c418c$var$renderer(this[i]);
        item[methodName].apply(item, args);
    }
    return this;
};
var $0f03dcbde37c418c$var$setAttributeValue = function(element, attrName, value) {
    if (void 0 !== value && null !== value && false !== value) (0, $3yzYM.default).setAttribute(element, attrName, value);
    else (0, $3yzYM.default).removeAttribute(element, attrName);
};
$0f03dcbde37c418c$var$initRender.prototype.show = function() {
    return this.toggle(true);
};
$0f03dcbde37c418c$var$initRender.prototype.hide = function() {
    return this.toggle(false);
};
$0f03dcbde37c418c$var$initRender.prototype.toggle = function(value) {
    if (this[0]) this.toggleClass("dx-state-invisible", !value);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.attr = function(attrName, value) {
    if (this.length > 1 && arguments.length > 1) return $0f03dcbde37c418c$var$repeatMethod.call(this, "attr", arguments);
    if (!this[0]) {
        if ((0, $6ntMu.isObject)(attrName) || void 0 !== value) return this;
        else return;
    }
    if (!this[0].getAttribute) return this.prop(attrName, value);
    if ("string" === typeof attrName && 1 === arguments.length) {
        var result = this[0].getAttribute(attrName);
        return null == result ? void 0 : result;
    } else if ((0, $6ntMu.isPlainObject)(attrName)) for(var key in attrName)this.attr(key, attrName[key]);
    else $0f03dcbde37c418c$var$setAttributeValue(this[0], attrName, value);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.removeAttr = function(attrName) {
    this[0] && (0, $3yzYM.default).removeAttribute(this[0], attrName);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.prop = function(propName, value) {
    if (!this[0]) return this;
    if ("string" === typeof propName && 1 === arguments.length) return this[0][propName];
    else if ((0, $6ntMu.isPlainObject)(propName)) for(var key in propName)this.prop(key, propName[key]);
    else (0, $3yzYM.default).setProperty(this[0], propName, value);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.addClass = function(className) {
    return this.toggleClass(className, true);
};
$0f03dcbde37c418c$var$initRender.prototype.removeClass = function(className) {
    return this.toggleClass(className, false);
};
$0f03dcbde37c418c$var$initRender.prototype.hasClass = function(className) {
    if (!this[0] || void 0 === this[0].className) return false;
    var classNames = className.split(" ");
    for(var i = 0; i < classNames.length; i++)if (this[0].classList) {
        if (this[0].classList.contains(classNames[i])) return true;
    } else {
        var _className = (0, $6ntMu.isString)(this[0].className) ? this[0].className : (0, $3yzYM.default).getAttribute(this[0], "class");
        if ((_className || "").split(" ").indexOf(classNames[i]) >= 0) return true;
    }
    return false;
};
$0f03dcbde37c418c$var$initRender.prototype.toggleClass = function(className, value) {
    if (this.length > 1) return $0f03dcbde37c418c$var$repeatMethod.call(this, "toggleClass", arguments);
    if (!this[0] || !className) return this;
    value = void 0 === value ? !this.hasClass(className) : value;
    var classNames = className.split(" ");
    for(var i = 0; i < classNames.length; i++)(0, $3yzYM.default).setClass(this[0], classNames[i], value);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.html = function(value) {
    if (!arguments.length) return this[0].innerHTML;
    this.empty();
    if ("string" === typeof value && !(0, $XxsMu.isTablePart)(value) || "number" === typeof value) {
        this[0].innerHTML = value;
        return this;
    }
    return this.append((0, $XxsMu.parseHTML)(value));
};
var $0f03dcbde37c418c$var$appendElements = function(element, nextSibling) {
    if (!this[0] || !element) return;
    if ("string" === typeof element) element = (0, $XxsMu.parseHTML)(element);
    else if (element.nodeType) element = [
        element
    ];
    else if ((0, $6ntMu.isNumeric)(element)) element = [
        (0, $3yzYM.default).createTextNode(element)
    ];
    for(var i = 0; i < element.length; i++){
        var item = element[i];
        var container = this[0];
        var wrapTR = "TABLE" === container.tagName && "TR" === item.tagName;
        if (wrapTR && container.tBodies && container.tBodies.length) container = container.tBodies[0];
        (0, $3yzYM.default).insertElement(container, item.nodeType ? item : item[0], nextSibling);
    }
};
var $0f03dcbde37c418c$var$setCss = function(name, value) {
    if (!this[0] || !this[0].style) return;
    if (null === value || "number" === typeof value && isNaN(value)) return;
    name = (0, $4jWiu.styleProp)(name);
    for(var i = 0; i < this.length; i++)this[i].style[name] = (0, $4jWiu.normalizeStyleProp)(name, value);
};
$0f03dcbde37c418c$var$initRender.prototype.css = function(name, value) {
    if ((0, $6ntMu.isString)(name)) {
        if (2 === arguments.length) $0f03dcbde37c418c$var$setCss.call(this, name, value);
        else {
            if (!this[0]) return;
            name = (0, $4jWiu.styleProp)(name);
            var result = $0f03dcbde37c418c$var$window.getComputedStyle(this[0])[name] || this[0].style[name];
            return (0, $6ntMu.isNumeric)(result) ? result.toString() : result;
        }
    } else if ((0, $6ntMu.isPlainObject)(name)) for(var key in name)$0f03dcbde37c418c$var$setCss.call(this, key, name[key]);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.prepend = function(element) {
    if (arguments.length > 1) {
        for(var i = 0; i < arguments.length; i++)this.prepend(arguments[i]);
        return this;
    }
    $0f03dcbde37c418c$var$appendElements.apply(this, [
        element,
        this[0].firstChild
    ]);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.append = function(element) {
    if (arguments.length > 1) {
        for(var i = 0; i < arguments.length; i++)this.append(arguments[i]);
        return this;
    }
    $0f03dcbde37c418c$var$appendElements.apply(this, [
        element
    ]);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.prependTo = function(element) {
    if (this.length > 1) {
        for(var i = this.length - 1; i >= 0; i--)$0f03dcbde37c418c$var$renderer(this[i]).prependTo(element);
        return this;
    }
    element = $0f03dcbde37c418c$var$renderer(element);
    if (element[0]) (0, $3yzYM.default).insertElement(element[0], this[0], element[0].firstChild);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.appendTo = function(element) {
    if (this.length > 1) return $0f03dcbde37c418c$var$repeatMethod.call(this, "appendTo", arguments);
    (0, $3yzYM.default).insertElement($0f03dcbde37c418c$var$renderer(element)[0], this[0]);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.insertBefore = function(element) {
    if (element && element[0]) (0, $3yzYM.default).insertElement(element[0].parentNode, this[0], element[0]);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.insertAfter = function(element) {
    if (element && element[0]) (0, $3yzYM.default).insertElement(element[0].parentNode, this[0], element[0].nextSibling);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.before = function(element) {
    if (this[0]) (0, $3yzYM.default).insertElement(this[0].parentNode, element[0], this[0]);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.after = function(element) {
    if (this[0]) (0, $3yzYM.default).insertElement(this[0].parentNode, element[0], this[0].nextSibling);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.wrap = function(wrapper) {
    if (this[0]) {
        var wrap = $0f03dcbde37c418c$var$renderer(wrapper);
        wrap.insertBefore(this);
        wrap.append(this);
    }
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.wrapInner = function(wrapper) {
    var contents = this.contents();
    if (contents.length) contents.wrap(wrapper);
    else this.append(wrapper);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.replaceWith = function(element) {
    if (!(element && element[0])) return;
    if (element.is(this)) return this;
    element.insertBefore(this);
    this.remove();
    return element;
};
$0f03dcbde37c418c$var$initRender.prototype.remove = function() {
    if (this.length > 1) return $0f03dcbde37c418c$var$repeatMethod.call(this, "remove", arguments);
    (0, $jc4XS.cleanDataRecursive)(this[0], true);
    (0, $3yzYM.default).removeElement(this[0]);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.detach = function() {
    if (this.length > 1) return $0f03dcbde37c418c$var$repeatMethod.call(this, "detach", arguments);
    (0, $3yzYM.default).removeElement(this[0]);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.empty = function() {
    if (this.length > 1) return $0f03dcbde37c418c$var$repeatMethod.call(this, "empty", arguments);
    (0, $jc4XS.cleanDataRecursive)(this[0]);
    (0, $3yzYM.default).setText(this[0], "");
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.clone = function() {
    var result = [];
    for(var i = 0; i < this.length; i++)result.push(this[i].cloneNode(true));
    return $0f03dcbde37c418c$var$renderer(result);
};
$0f03dcbde37c418c$var$initRender.prototype.text = function(value) {
    if (!arguments.length) {
        var result = "";
        for(var i = 0; i < this.length; i++)result += this[i] && this[i].textContent || "";
        return result;
    }
    var text = (0, $6ntMu.isFunction)(value) ? value() : value;
    (0, $jc4XS.cleanDataRecursive)(this[0], false);
    (0, $3yzYM.default).setText(this[0], (0, $6ntMu.isDefined)(text) ? text : "");
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.val = function(value) {
    if (1 === arguments.length) return this.prop("value", (0, $6ntMu.isDefined)(value) ? value : "");
    return this.prop("value");
};
$0f03dcbde37c418c$var$initRender.prototype.contents = function() {
    if (!this[0]) return $0f03dcbde37c418c$var$renderer();
    var result = [];
    result.push.apply(result, this[0].childNodes);
    return $0f03dcbde37c418c$var$renderer(result);
};
$0f03dcbde37c418c$var$initRender.prototype.find = function(selector) {
    var result = $0f03dcbde37c418c$var$renderer();
    if (!selector) return result;
    var nodes = [];
    var i;
    if ("string" === typeof selector) {
        selector = selector.trim();
        for(i = 0; i < this.length; i++){
            var element = this[i];
            if ((0, $3yzYM.default).isElementNode(element)) {
                var elementId = element.getAttribute("id");
                var queryId = elementId || "dx-query-children";
                if (!elementId) $0f03dcbde37c418c$var$setAttributeValue(element, "id", queryId);
                queryId = "[id='" + queryId + "'] ";
                var querySelector = queryId + selector.replace(/([^\\])(,)/g, "$1, " + queryId);
                nodes.push.apply(nodes, (0, $3yzYM.default).querySelectorAll(element, querySelector));
                $0f03dcbde37c418c$var$setAttributeValue(element, "id", elementId);
            } else if ((0, $3yzYM.default).isDocument(element) || (0, $3yzYM.default).isDocumentFragment(element)) nodes.push.apply(nodes, (0, $3yzYM.default).querySelectorAll(element, selector));
        }
    } else for(i = 0; i < this.length; i++){
        selector = (0, $3yzYM.default).isNode(selector) ? selector : selector[0];
        if (this[i] !== selector && this[i].contains(selector)) nodes.push(selector);
    }
    return result.add(nodes);
};
var $0f03dcbde37c418c$var$isVisible = function(_, element) {
    var _element$host;
    element = null !== (_element$host = element.host) && void 0 !== _element$host ? _element$host : element;
    if (!element.nodeType) return true;
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
};
$0f03dcbde37c418c$var$initRender.prototype.filter = function(selector) {
    if (!selector) return $0f03dcbde37c418c$var$renderer();
    if (":visible" === selector) return this.filter($0f03dcbde37c418c$var$isVisible);
    else if (":hidden" === selector) return this.filter(function(_, element) {
        return !$0f03dcbde37c418c$var$isVisible(_, element);
    });
    var result = [];
    for(var i = 0; i < this.length; i++){
        var item = this[i];
        if ((0, $3yzYM.default).isElementNode(item) && "string" === (0, $6ntMu.type)(selector)) (0, $3yzYM.default).elementMatches(item, selector) && result.push(item);
        else if ((0, $3yzYM.default).isNode(selector) || (0, $6ntMu.isWindow)(selector)) selector === item && result.push(item);
        else if ((0, $6ntMu.isFunction)(selector)) selector.call(item, i, item) && result.push(item);
        else for(var j = 0; j < selector.length; j++)selector[j] === item && result.push(item);
    }
    return $0f03dcbde37c418c$var$renderer(result);
};
$0f03dcbde37c418c$var$initRender.prototype.not = function(selector) {
    var result = [];
    var nodes = this.filter(selector).toArray();
    for(var i = 0; i < this.length; i++)if (-1 === nodes.indexOf(this[i])) result.push(this[i]);
    return $0f03dcbde37c418c$var$renderer(result);
};
$0f03dcbde37c418c$var$initRender.prototype.is = function(selector) {
    return !!this.filter(selector).length;
};
$0f03dcbde37c418c$var$initRender.prototype.children = function(selector) {
    var result = [];
    for(var i = 0; i < this.length; i++){
        var nodes = this[i] ? this[i].childNodes : [];
        for(var j = 0; j < nodes.length; j++)if ((0, $3yzYM.default).isElementNode(nodes[j])) result.push(nodes[j]);
    }
    result = $0f03dcbde37c418c$var$renderer(result);
    return selector ? result.filter(selector) : result;
};
$0f03dcbde37c418c$var$initRender.prototype.siblings = function() {
    var element = this[0];
    if (!element || !element.parentNode) return $0f03dcbde37c418c$var$renderer();
    var result = [];
    var parentChildNodes = element.parentNode.childNodes || [];
    for(var i = 0; i < parentChildNodes.length; i++){
        var node = parentChildNodes[i];
        if ((0, $3yzYM.default).isElementNode(node) && node !== element) result.push(node);
    }
    return $0f03dcbde37c418c$var$renderer(result);
};
$0f03dcbde37c418c$var$initRender.prototype.each = function(callback) {
    for(var i = 0; i < this.length; i++){
        if (false === callback.call(this[i], i, this[i])) break;
    }
};
$0f03dcbde37c418c$var$initRender.prototype.index = function(element) {
    if (!element) return this.parent().children().index(this);
    element = $0f03dcbde37c418c$var$renderer(element);
    return this.toArray().indexOf(element[0]);
};
$0f03dcbde37c418c$var$initRender.prototype.get = function(index) {
    return this[index < 0 ? this.length + index : index];
};
$0f03dcbde37c418c$var$initRender.prototype.eq = function(index) {
    index = index < 0 ? this.length + index : index;
    return $0f03dcbde37c418c$var$renderer(this[index]);
};
$0f03dcbde37c418c$var$initRender.prototype.first = function() {
    return this.eq(0);
};
$0f03dcbde37c418c$var$initRender.prototype.last = function() {
    return this.eq(-1);
};
$0f03dcbde37c418c$var$initRender.prototype.select = function() {
    for(var i = 0; i < this.length; i += 1)this[i].select && this[i].select();
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.parent = function(selector) {
    if (!this[0]) return $0f03dcbde37c418c$var$renderer();
    var result = $0f03dcbde37c418c$var$renderer(this[0].parentNode);
    return !selector || result.is(selector) ? result : $0f03dcbde37c418c$var$renderer();
};
$0f03dcbde37c418c$var$initRender.prototype.parents = function(selector) {
    var result = [];
    var parent = this.parent();
    while(parent && parent[0] && !(0, $3yzYM.default).isDocument(parent[0])){
        if ((0, $3yzYM.default).isElementNode(parent[0])) {
            if (!selector || parent.is(selector)) result.push(parent.get(0));
        }
        parent = parent.parent();
    }
    return $0f03dcbde37c418c$var$renderer(result);
};
$0f03dcbde37c418c$var$initRender.prototype.closest = function(selector) {
    if (this.is(selector)) return this;
    var parent = this.parent();
    while(parent && parent.length){
        if (parent.is(selector)) return parent;
        parent = parent.parent();
    }
    return $0f03dcbde37c418c$var$renderer();
};
$0f03dcbde37c418c$var$initRender.prototype.next = function(selector) {
    if (!this[0]) return $0f03dcbde37c418c$var$renderer();
    var next = $0f03dcbde37c418c$var$renderer(this[0].nextSibling);
    if (!arguments.length) return next;
    while(next && next.length){
        if (next.is(selector)) return next;
        next = next.next();
    }
    return $0f03dcbde37c418c$var$renderer();
};
$0f03dcbde37c418c$var$initRender.prototype.prev = function() {
    if (!this[0]) return $0f03dcbde37c418c$var$renderer();
    return $0f03dcbde37c418c$var$renderer(this[0].previousSibling);
};
$0f03dcbde37c418c$var$initRender.prototype.add = function(selector) {
    var targets = $0f03dcbde37c418c$var$renderer(selector);
    var result = this.toArray();
    for(var i = 0; i < targets.length; i++){
        var target = targets[i];
        if (-1 === result.indexOf(target)) result.push(target);
    }
    return $0f03dcbde37c418c$var$renderer(result);
};
var $0f03dcbde37c418c$var$emptyArray = [];
$0f03dcbde37c418c$var$initRender.prototype.splice = function() {
    return $0f03dcbde37c418c$var$renderer($0f03dcbde37c418c$var$emptyArray.splice.apply(this, arguments));
};
$0f03dcbde37c418c$var$initRender.prototype.slice = function() {
    return $0f03dcbde37c418c$var$renderer($0f03dcbde37c418c$var$emptyArray.slice.apply(this, arguments));
};
$0f03dcbde37c418c$var$initRender.prototype.toArray = function() {
    return $0f03dcbde37c418c$var$emptyArray.slice.call(this);
};
$0f03dcbde37c418c$var$initRender.prototype.offset = function() {
    if (!this[0]) return;
    return (0, $iE2yv.getOffset)(this[0]);
};
$0f03dcbde37c418c$var$initRender.prototype.offsetParent = function() {
    if (!this[0]) return $0f03dcbde37c418c$var$renderer();
    var offsetParent = $0f03dcbde37c418c$var$renderer(this[0].offsetParent);
    while(offsetParent[0] && "static" === offsetParent.css("position"))offsetParent = $0f03dcbde37c418c$var$renderer(offsetParent[0].offsetParent);
    offsetParent = offsetParent[0] ? offsetParent : $0f03dcbde37c418c$var$renderer((0, $3yzYM.default).getDocumentElement());
    return offsetParent;
};
$0f03dcbde37c418c$var$initRender.prototype.position = function() {
    if (!this[0]) return;
    var offset;
    var marginTop = parseFloat(this.css("marginTop"));
    var marginLeft = parseFloat(this.css("marginLeft"));
    if ("fixed" === this.css("position")) {
        offset = this[0].getBoundingClientRect();
        return {
            top: offset.top - marginTop,
            left: offset.left - marginLeft
        };
    }
    offset = this.offset();
    var offsetParent = this.offsetParent();
    var parentOffset = {
        top: 0,
        left: 0
    };
    if ("HTML" !== offsetParent[0].nodeName) parentOffset = offsetParent.offset();
    parentOffset = {
        top: parentOffset.top + parseFloat(offsetParent.css("borderTopWidth")),
        left: parentOffset.left + parseFloat(offsetParent.css("borderLeftWidth"))
    };
    return {
        top: offset.top - parentOffset.top - marginTop,
        left: offset.left - parentOffset.left - marginLeft
    };
};
[
    {
        name: "scrollLeft",
        offsetProp: "pageXOffset",
        scrollWindow: function(win, value) {
            win.scrollTo(value, win.pageYOffset);
        }
    },
    {
        name: "scrollTop",
        offsetProp: "pageYOffset",
        scrollWindow: function(win, value) {
            win.scrollTo(win.pageXOffset, value);
        }
    }
].forEach(function(directionStrategy) {
    var propName = directionStrategy.name;
    $0f03dcbde37c418c$var$initRender.prototype[propName] = function(value) {
        if (!this[0]) return;
        var window = (0, $iE2yv.getWindowByElement)(this[0]);
        if (void 0 === value) return window ? window[directionStrategy.offsetProp] : this[0][propName];
        if (window) directionStrategy.scrollWindow(window, value);
        else this[0][propName] = value;
        return this;
    };
});
$0f03dcbde37c418c$var$initRender.prototype.data = function(key, value) {
    if (!this[0]) return;
    if (arguments.length < 2) return (0, $jc4XS.data).call($0f03dcbde37c418c$var$renderer, this[0], key);
    (0, $jc4XS.data).call($0f03dcbde37c418c$var$renderer, this[0], key, value);
    return this;
};
$0f03dcbde37c418c$var$initRender.prototype.removeData = function(key) {
    this[0] && (0, $jc4XS.removeData)(this[0], key);
    return this;
};
var $0f03dcbde37c418c$var$rendererWrapper = function() {
    return $0f03dcbde37c418c$var$renderer.apply(this, arguments);
};
Object.defineProperty($0f03dcbde37c418c$var$rendererWrapper, "fn", {
    enumerable: true,
    configurable: true,
    get: function() {
        return $0f03dcbde37c418c$var$renderer.fn;
    },
    set: function(value) {
        $0f03dcbde37c418c$var$renderer.fn = value;
    }
});
var $0f03dcbde37c418c$export$2e2bcd8739ae039 = {
    set: function(strategy) {
        $0f03dcbde37c418c$var$renderer = strategy;
    },
    get: function() {
        return $0f03dcbde37c418c$var$rendererWrapper;
    }
};

});
parcelRegister("jc4XS", function(module, exports) {

$parcel$export(module.exports, "data", function () { return $df92fd37e59b4cf5$export$4051a07651545597; });
$parcel$export(module.exports, "beforeCleanData", function () { return $df92fd37e59b4cf5$export$e3a86a7b5668951d; });
$parcel$export(module.exports, "removeData", function () { return $df92fd37e59b4cf5$export$33f1b464f736cf21; });
$parcel$export(module.exports, "cleanDataRecursive", function () { return $df92fd37e59b4cf5$export$767bfdaeab3dae01; });
/**
 * DevExtreme (esm/core/element_data.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $3yzYM = parcelRequire("3yzYM");

var $60GuF = parcelRequire("60GuF");

var $e1oup = parcelRequire("e1oup");
var $df92fd37e59b4cf5$var$dataMap = new WeakMap;
var $df92fd37e59b4cf5$var$strategy;
var $df92fd37e59b4cf5$export$e0ed1cba125eba32 = new (0, $e1oup.default);
var $df92fd37e59b4cf5$var$beforeCleanDataFunc = function() {};
var $df92fd37e59b4cf5$var$afterCleanDataFunc = function() {};
var $df92fd37e59b4cf5$export$19ac0b14569bcaea = function(value) {
    $df92fd37e59b4cf5$export$e0ed1cba125eba32.fire(value);
    $df92fd37e59b4cf5$var$strategy = value;
    var cleanData = $df92fd37e59b4cf5$var$strategy.cleanData;
    $df92fd37e59b4cf5$var$strategy.cleanData = function(nodes) {
        $df92fd37e59b4cf5$var$beforeCleanDataFunc(nodes);
        var result = cleanData.call(this, nodes);
        $df92fd37e59b4cf5$var$afterCleanDataFunc(nodes);
        return result;
    };
};
$df92fd37e59b4cf5$export$19ac0b14569bcaea({
    data: function() {
        var element = arguments[0];
        var key = arguments[1];
        var value = arguments[2];
        if (!element) return;
        var elementData = $df92fd37e59b4cf5$var$dataMap.get(element);
        if (!elementData) {
            elementData = {};
            $df92fd37e59b4cf5$var$dataMap.set(element, elementData);
        }
        if (void 0 === key) return elementData;
        if (2 === arguments.length) return elementData[key];
        elementData[key] = value;
        return value;
    },
    removeData: function(element, key) {
        if (!element) return;
        if (void 0 === key) $df92fd37e59b4cf5$var$dataMap.delete(element);
        else {
            var elementData = $df92fd37e59b4cf5$var$dataMap.get(element);
            if (elementData) delete elementData[key];
        }
    },
    cleanData: function(elements) {
        for(var i = 0; i < elements.length; i++){
            (0, $60GuF.default).off(elements[i]);
            $df92fd37e59b4cf5$var$dataMap.delete(elements[i]);
        }
    }
});
function $df92fd37e59b4cf5$export$da68e08875c2ed1d() {
    return $df92fd37e59b4cf5$var$strategy;
}
function $df92fd37e59b4cf5$export$4051a07651545597() {
    return $df92fd37e59b4cf5$var$strategy.data.apply(this, arguments);
}
function $df92fd37e59b4cf5$export$e3a86a7b5668951d(callback) {
    $df92fd37e59b4cf5$var$beforeCleanDataFunc = callback;
}
function $df92fd37e59b4cf5$export$f846ad5ef0792b38(callback) {
    $df92fd37e59b4cf5$var$afterCleanDataFunc = callback;
}
function $df92fd37e59b4cf5$export$a9069348538b0415(nodes) {
    return $df92fd37e59b4cf5$var$strategy.cleanData.call(this, nodes);
}
function $df92fd37e59b4cf5$export$33f1b464f736cf21(element, key) {
    return $df92fd37e59b4cf5$var$strategy.removeData.call(this, element, key);
}
function $df92fd37e59b4cf5$export$767bfdaeab3dae01(element, cleanSelf) {
    if (!(0, $3yzYM.default).isElementNode(element)) return;
    var childElements = element.getElementsByTagName("*");
    $df92fd37e59b4cf5$var$strategy.cleanData(childElements);
    if (cleanSelf) $df92fd37e59b4cf5$var$strategy.cleanData([
        element
    ]);
}

});
parcelRegister("3yzYM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $297074ce381f9350$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/dom_adapter.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $5Nras = parcelRequire("5Nras");

var $gcp4g = parcelRequire("gcp4g");

var $lINBx = parcelRequire("lINBx");
var $297074ce381f9350$var$ELEMENT_NODE = 1;
var $297074ce381f9350$var$TEXT_NODE = 3;
var $297074ce381f9350$var$DOCUMENT_NODE = 9;
var $297074ce381f9350$var$DOCUMENT_FRAGMENT_NODE = 11;
var $297074ce381f9350$var$nativeDOMAdapterStrategy = {
    querySelectorAll: (element, selector)=>element.querySelectorAll(selector),
    elementMatches (element, selector) {
        var matches = element.matches || element.matchesSelector || element.mozMatchesSelector || element.msMatchesSelector || element.oMatchesSelector || element.webkitMatchesSelector || ((selector)=>{
            var doc = element.document || element.ownerDocument;
            if (!doc) return false;
            var items = this.querySelectorAll(doc, selector);
            for(var i = 0; i < items.length; i++){
                if (items[i] === element) return true;
            }
        });
        return matches.call(element, selector);
    },
    createElement (tagName, context) {
        context = context || this._document;
        return context.createElement(tagName);
    },
    createElementNS (ns, tagName, context) {
        context = context || this._document;
        return context.createElementNS(ns, tagName);
    },
    createTextNode (text, context) {
        context = context || this._document;
        return context.createTextNode(text);
    },
    isNode: (element)=>element && "object" === typeof element && "nodeType" in element && "nodeName" in element,
    isElementNode: (element)=>element && element.nodeType === $297074ce381f9350$var$ELEMENT_NODE,
    isTextNode: (element)=>element && element.nodeType === $297074ce381f9350$var$TEXT_NODE,
    isDocument: (element)=>element && element.nodeType === $297074ce381f9350$var$DOCUMENT_NODE,
    isDocumentFragment: (element)=>element && element.nodeType === $297074ce381f9350$var$DOCUMENT_FRAGMENT_NODE,
    removeElement (element) {
        var parentNode = element && element.parentNode;
        if (parentNode) parentNode.removeChild(element);
    },
    insertElement (parentElement, newElement, nextSiblingElement) {
        if (parentElement && newElement && parentElement !== newElement) {
            if (nextSiblingElement) parentElement.insertBefore(newElement, nextSiblingElement);
            else parentElement.appendChild(newElement);
        }
    },
    getAttribute: (element, name)=>element.getAttribute(name),
    setAttribute (element, name, value) {
        element.setAttribute(name, value);
    },
    removeAttribute (element, name) {
        element.removeAttribute(name);
    },
    setProperty (element, name, value) {
        element[name] = value;
    },
    setText (element, text) {
        if (element) element.textContent = text;
    },
    setClass (element, className, isAdd) {
        if (1 === element.nodeType && className) isAdd ? element.classList.add(className) : element.classList.remove(className);
    },
    setStyle (element, name, value) {
        element.style[name] = value || "";
    },
    _document: "undefined" === typeof document ? void 0 : document,
    getDocument () {
        return this._document;
    },
    getActiveElement (element) {
        var activeElementHolder = this.getRootNode(element);
        return activeElementHolder.activeElement;
    },
    getRootNode (element) {
        var _element$getRootNode, _element$getRootNode2;
        return null !== (_element$getRootNode = null === element || void 0 === element ? void 0 : null === (_element$getRootNode2 = element.getRootNode) || void 0 === _element$getRootNode2 ? void 0 : _element$getRootNode2.call(element)) && void 0 !== _element$getRootNode ? _element$getRootNode : this._document;
    },
    getBody () {
        return this._document.body;
    },
    createDocumentFragment () {
        return this._document.createDocumentFragment();
    },
    getDocumentElement () {
        return this._document.documentElement;
    },
    getLocation () {
        return this._document.location;
    },
    getSelection () {
        return this._document.selection;
    },
    getReadyState () {
        return this._document.readyState;
    },
    getHead () {
        return this._document.head;
    },
    hasDocumentProperty (property) {
        return property in this._document;
    },
    listen (element, event, callback, options) {
        if (!element || !("addEventListener" in element)) return 0, $gcp4g.noop;
        element.addEventListener(event, callback, options);
        return ()=>{
            element.removeEventListener(event, callback);
        };
    },
    elementsFromPoint (x, y, element) {
        var activeElementHolder = this.getRootNode(element);
        if (activeElementHolder.host) return (0, $lINBx.getShadowElementsFromPoint)(x, y, activeElementHolder);
        return activeElementHolder.elementsFromPoint(x, y);
    }
};
var $297074ce381f9350$export$2e2bcd8739ae039 = (0, $5Nras.default)($297074ce381f9350$var$nativeDOMAdapterStrategy);

});
parcelRegister("5Nras", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43869a4817d130be$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/utils/dependency_injector.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $6ntMu = parcelRequire("6ntMu");

var $8OLOW = parcelRequire("8OLOW");

var $a2g7x = parcelRequire("a2g7x");
function $43869a4817d130be$export$2e2bcd8739ae039(object) {
    var BaseClass = (0, $a2g7x.default).inherit(object);
    var InjectedClass = BaseClass;
    var instance = new InjectedClass(object);
    var initialFields = {};
    var injectFields = function(injectionObject, initial) {
        (0, $8OLOW.each)(injectionObject, function(key) {
            if ((0, $6ntMu.isFunction)(instance[key])) {
                if (initial || !object[key]) object[key] = function() {
                    return instance[key].apply(object, arguments);
                };
            } else {
                if (initial) initialFields[key] = object[key];
                object[key] = instance[key];
            }
        });
    };
    injectFields(object, true);
    object.inject = function(injectionObject) {
        InjectedClass = InjectedClass.inherit(injectionObject);
        instance = new InjectedClass;
        injectFields(injectionObject);
    };
    object.resetInjection = function() {
        (0, $2oTOp.extend)(object, initialFields);
        InjectedClass = BaseClass;
        instance = new BaseClass;
    };
    return object;
}

});
parcelRegister("2oTOp", function(module, exports) {

$parcel$export(module.exports, "extendFromObject", function () { return $1bf91dc2f99473bb$export$65230a64bf15fbb5; });
$parcel$export(module.exports, "extend", function () { return $1bf91dc2f99473bb$export$8b58be045bf06082; });
/**
 * DevExtreme (esm/core/utils/extend.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");
var $1bf91dc2f99473bb$export$65230a64bf15fbb5 = function(target, source, overrideExistingValues) {
    target = target || {};
    for(var prop in source)if (Object.prototype.hasOwnProperty.call(source, prop)) {
        var value = source[prop];
        if (!(prop in target) || overrideExistingValues) target[prop] = value;
    }
    return target;
};
var $1bf91dc2f99473bb$export$8b58be045bf06082 = function extend(target) {
    target = target || {};
    var i = 1;
    var deep = false;
    if ("boolean" === typeof target) {
        deep = target;
        target = arguments[1] || {};
        i++;
    }
    for(; i < arguments.length; i++){
        var source = arguments[i];
        if (null == source) continue;
        for(var key in source){
            var targetValue = target[key];
            var sourceValue = source[key];
            var sourceValueIsArray = false;
            var clone = void 0;
            if ("__proto__" === key || "constructor" === key || target === sourceValue) continue;
            if (deep && sourceValue && ((0, $6ntMu.isPlainObject)(sourceValue) || (sourceValueIsArray = Array.isArray(sourceValue)))) {
                if (sourceValueIsArray) clone = targetValue && Array.isArray(targetValue) ? targetValue : [];
                else clone = targetValue && (0, $6ntMu.isPlainObject)(targetValue) ? targetValue : {};
                target[key] = extend(deep, clone, sourceValue);
            } else if (void 0 !== sourceValue) target[key] = sourceValue;
        }
    }
    return target;
};

});
parcelRegister("6ntMu", function(module, exports) {

$parcel$export(module.exports, "type", function () { return $4a4bfdf1e29cca4f$export$bf9fb029d174d554; });
$parcel$export(module.exports, "isBoolean", function () { return $4a4bfdf1e29cca4f$export$f9ce7b637dfbe238; });
$parcel$export(module.exports, "isExponential", function () { return $4a4bfdf1e29cca4f$export$cf027eaeece0ea06; });
$parcel$export(module.exports, "isNumeric", function () { return $4a4bfdf1e29cca4f$export$e90fb89750dba83f; });
$parcel$export(module.exports, "isDate", function () { return $4a4bfdf1e29cca4f$export$871608497c498473; });
$parcel$export(module.exports, "isDefined", function () { return $4a4bfdf1e29cca4f$export$4e62c701997796c1; });
$parcel$export(module.exports, "isFunction", function () { return $4a4bfdf1e29cca4f$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $4a4bfdf1e29cca4f$export$844ec244b1367d54; });
$parcel$export(module.exports, "isObject", function () { return $4a4bfdf1e29cca4f$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isEmptyObject", function () { return $4a4bfdf1e29cca4f$export$83b788b1a3698c03; });
$parcel$export(module.exports, "isPlainObject", function () { return $4a4bfdf1e29cca4f$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isWindow", function () { return $4a4bfdf1e29cca4f$export$5a096129d439f843; });
$parcel$export(module.exports, "isRenderer", function () { return $4a4bfdf1e29cca4f$export$e7e5fb26b3a31a43; });
$parcel$export(module.exports, "isPromise", function () { return $4a4bfdf1e29cca4f$export$4369c812aac99591; });
$parcel$export(module.exports, "isDeferred", function () { return $4a4bfdf1e29cca4f$export$2af51d8f0fd79769; });
/**
 * DevExtreme (esm/core/utils/type.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $4a4bfdf1e29cca4f$var$types = {
    "[object Array]": "array",
    "[object Date]": "date",
    "[object Object]": "object",
    "[object String]": "string"
};
var $4a4bfdf1e29cca4f$export$bf9fb029d174d554 = function(object) {
    if (null === object) return "null";
    var typeOfObject = Object.prototype.toString.call(object);
    return "object" === typeof object ? $4a4bfdf1e29cca4f$var$types[typeOfObject] || "object" : typeof object;
};
var $4a4bfdf1e29cca4f$export$f9ce7b637dfbe238 = function(object) {
    return "boolean" === typeof object;
};
var $4a4bfdf1e29cca4f$export$cf027eaeece0ea06 = function(value) {
    return $4a4bfdf1e29cca4f$export$e90fb89750dba83f(value) && -1 !== value.toString().indexOf("e");
};
var $4a4bfdf1e29cca4f$export$871608497c498473 = function(object) {
    return "date" === $4a4bfdf1e29cca4f$export$bf9fb029d174d554(object);
};
var $4a4bfdf1e29cca4f$export$4e62c701997796c1 = function(object) {
    return null !== object && void 0 !== object;
};
var $4a4bfdf1e29cca4f$export$f6e2535fb5126e54 = function(object) {
    return "function" === typeof object;
};
var $4a4bfdf1e29cca4f$export$844ec244b1367d54 = function(object) {
    return "string" === typeof object;
};
var $4a4bfdf1e29cca4f$export$e90fb89750dba83f = function(object) {
    return "number" === typeof object && isFinite(object) || !isNaN(object - parseFloat(object));
};
var $4a4bfdf1e29cca4f$export$a6cdc56e425d0d0a = function(object) {
    return "object" === $4a4bfdf1e29cca4f$export$bf9fb029d174d554(object);
};
var $4a4bfdf1e29cca4f$export$83b788b1a3698c03 = function(object) {
    var property;
    for(property in object)return false;
    return true;
};
var $4a4bfdf1e29cca4f$export$53b83ca8eaab0383 = function(object) {
    if (!object || "object" !== $4a4bfdf1e29cca4f$export$bf9fb029d174d554(object)) return false;
    var proto = Object.getPrototypeOf(object);
    var ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return "function" === typeof ctor && Object.toString.call(ctor) === Object.toString.call(Object);
};
var $4a4bfdf1e29cca4f$export$c3825b437cbdea5c = function(value) {
    return -1 === [
        "object",
        "array",
        "function"
    ].indexOf($4a4bfdf1e29cca4f$export$bf9fb029d174d554(value));
};
var $4a4bfdf1e29cca4f$export$5a096129d439f843 = function(object) {
    return null != object && object === object.window;
};
var $4a4bfdf1e29cca4f$export$e7e5fb26b3a31a43 = function(object) {
    return !!object && !!(object.jquery || object.dxRenderer);
};
var $4a4bfdf1e29cca4f$export$4369c812aac99591 = function(object) {
    return !!object && $4a4bfdf1e29cca4f$export$f6e2535fb5126e54(object.then);
};
var $4a4bfdf1e29cca4f$export$2af51d8f0fd79769 = function(object) {
    return !!object && $4a4bfdf1e29cca4f$export$f6e2535fb5126e54(object.done) && $4a4bfdf1e29cca4f$export$f6e2535fb5126e54(object.fail);
};
var $4a4bfdf1e29cca4f$export$9671ea99bd126ace = function(object) {
    return !!(object && object.preventDefault);
};

});


parcelRegister("8OLOW", function(module, exports) {

$parcel$export(module.exports, "map", function () { return $66b8166f7f172a03$export$871de8747c9eaa88; });
$parcel$export(module.exports, "each", function () { return $66b8166f7f172a03$export$79b2f7037acddd43; });
$parcel$export(module.exports, "reverseEach", function () { return $66b8166f7f172a03$export$c1dd39eaaee75f84; });
/**
 * DevExtreme (esm/core/utils/iterator.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $66b8166f7f172a03$export$871de8747c9eaa88 = (values, callback)=>{
    if (Array.isArray(values)) return values.map(callback);
    var result = [];
    for(var key in values)result.push(callback(values[key], key));
    return result;
};
var $66b8166f7f172a03$export$79b2f7037acddd43 = (values, callback)=>{
    if (!values) return;
    if ("length" in values) for(var i = 0; i < values.length; i++){
        if (false === callback.call(values[i], i, values[i])) break;
    }
    else for(var key in values){
        if (false === callback.call(values[key], key, values[key])) break;
    }
    return values;
};
var $66b8166f7f172a03$export$c1dd39eaaee75f84 = (array, callback)=>{
    if (!array || !("length" in array) || 0 === array.length) return;
    for(var i = array.length - 1; i >= 0; i--){
        if (false === callback.call(array[i], i, array[i])) break;
    }
};

});

parcelRegister("a2g7x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74e69885b39b42ed$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/class.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $cvYFL = parcelRequire("cvYFL");

var $6ntMu = parcelRequire("6ntMu");
var $74e69885b39b42ed$var$wrapOverridden = function(baseProto, methodName, method) {
    return function() {
        var prevCallBase = this.callBase;
        this.callBase = baseProto[methodName];
        try {
            return method.apply(this, arguments);
        } finally{
            this.callBase = prevCallBase;
        }
    };
};
var $74e69885b39b42ed$var$clonePrototype = function(obj) {
    var func = function() {};
    func.prototype = obj.prototype;
    return new func;
};
var $74e69885b39b42ed$var$redefine = function(members) {
    var overridden;
    var memberName;
    var member;
    if (!members) return this;
    for(memberName in members){
        member = members[memberName];
        overridden = "function" === typeof this.prototype[memberName] && "function" === typeof member;
        this.prototype[memberName] = overridden ? $74e69885b39b42ed$var$wrapOverridden(this.parent.prototype, memberName, member) : member;
    }
    return this;
};
var $74e69885b39b42ed$var$include = function() {
    var classObj = this;
    var argument;
    var name;
    var i;
    var hasClassObjOwnProperty = Object.prototype.hasOwnProperty.bind(classObj);
    var isES6Class = !hasClassObjOwnProperty("_includedCtors") && !hasClassObjOwnProperty("_includedPostCtors");
    if (isES6Class) {
        classObj._includedCtors = classObj._includedCtors.slice(0);
        classObj._includedPostCtors = classObj._includedPostCtors.slice(0);
    }
    for(i = 0; i < arguments.length; i++){
        argument = arguments[i];
        if (argument.ctor) classObj._includedCtors.push(argument.ctor);
        if (argument.postCtor) classObj._includedPostCtors.push(argument.postCtor);
        for(name in argument){
            if ("ctor" === name || "postCtor" === name || "default" === name) continue;
            classObj.prototype[name] = argument[name];
        }
    }
    return classObj;
};
var $74e69885b39b42ed$var$subclassOf = function(parentClass) {
    var hasParentProperty = Object.prototype.hasOwnProperty.bind(this)("parent");
    var isES6Class = !hasParentProperty && this.parent;
    if (isES6Class) {
        var baseClass = Object.getPrototypeOf(this);
        return baseClass === parentClass || baseClass.subclassOf(parentClass);
    } else {
        if (this.parent === parentClass) return true;
        if (!this.parent || !this.parent.subclassOf) return false;
        return this.parent.subclassOf(parentClass);
    }
};
var $74e69885b39b42ed$var$abstract = function() {
    throw (0, $cvYFL.default).Error("E0001");
};
var $74e69885b39b42ed$var$copyStatic = function() {
    var hasOwn = Object.prototype.hasOwnProperty;
    return function(source, destination) {
        for(var key in source){
            if (!hasOwn.call(source, key)) return;
            destination[key] = source[key];
        }
    };
}();
var $74e69885b39b42ed$var$classImpl = function() {};
$74e69885b39b42ed$var$classImpl.inherit = function(members) {
    var inheritor = function() {
        if (!this || (0, $6ntMu.isWindow)(this) || "function" !== typeof this.constructor) throw (0, $cvYFL.default).Error("E0003");
        var instance = this;
        var ctor = instance.ctor;
        var includedCtors = instance.constructor._includedCtors;
        var includedPostCtors = instance.constructor._includedPostCtors;
        var i;
        for(i = 0; i < includedCtors.length; i++)includedCtors[i].call(instance);
        if (ctor) ctor.apply(instance, arguments);
        for(i = 0; i < includedPostCtors.length; i++)includedPostCtors[i].call(instance);
    };
    inheritor.prototype = $74e69885b39b42ed$var$clonePrototype(this);
    $74e69885b39b42ed$var$copyStatic(this, inheritor);
    inheritor.inherit = this.inherit;
    inheritor.abstract = $74e69885b39b42ed$var$abstract;
    inheritor.redefine = $74e69885b39b42ed$var$redefine;
    inheritor.include = $74e69885b39b42ed$var$include;
    inheritor.subclassOf = $74e69885b39b42ed$var$subclassOf;
    inheritor.parent = this;
    inheritor._includedCtors = this._includedCtors ? this._includedCtors.slice(0) : [];
    inheritor._includedPostCtors = this._includedPostCtors ? this._includedPostCtors.slice(0) : [];
    inheritor.prototype.constructor = inheritor;
    inheritor.redefine(members);
    return inheritor;
};
$74e69885b39b42ed$var$classImpl.abstract = $74e69885b39b42ed$var$abstract;
var $74e69885b39b42ed$export$2e2bcd8739ae039 = $74e69885b39b42ed$var$classImpl;

});
parcelRegister("cvYFL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91c77198ee2c4609$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/errors.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $hCicl = parcelRequire("hCicl");
var $91c77198ee2c4609$export$2e2bcd8739ae039 = (0, $hCicl.default)({
    E0001: "Method is not implemented",
    E0002: "Member name collision: {0}",
    E0003: "A class must be instantiated using the 'new' keyword",
    E0004: "The NAME property of the component is not specified",
    E0005: "Unknown device",
    E0006: "Unknown endpoint key is requested",
    E0007: "'Invalidate' method is called outside the update transaction",
    E0008: "Type of the option name is not appropriate to create an action",
    E0009: "Component '{0}' has not been initialized for an element",
    E0010: "Animation configuration with the '{0}' type requires '{1}' configuration as {2}",
    E0011: "Unknown animation type '{0}'",
    E0012: "jQuery version is too old. Please upgrade jQuery to 1.10.0 or later",
    E0013: "KnockoutJS version is too old. Please upgrade KnockoutJS to 2.3.0 or later",
    E0014: "The 'release' method shouldn't be called for an unlocked Lock object",
    E0015: "Queued task returned an unexpected result",
    E0017: "Event namespace is not defined",
    E0018: "DevExpress.ui.DevExpressPopup widget is required",
    E0020: "Template engine '{0}' is not supported",
    E0021: "Unknown theme is set: {0}",
    E0022: "LINK[rel=DevExpress-theme] tags must go before DevExpress included scripts",
    E0023: "Template name is not specified",
    E0024: "DevExtreme bundle already included",
    E0025: "Unexpected argument type",
    E0100: "Unknown validation type is detected",
    E0101: "Misconfigured range validation rule is detected",
    E0102: "Misconfigured comparison validation rule is detected",
    E0103: "validationCallback of an asynchronous rule should return a jQuery or a native promise",
    E0110: "Unknown validation group is detected",
    E0120: "Adapter for a DevExpressValidator component cannot be configured",
    E0121: "The 'customItem' parameter of the 'onCustomItemCreating' function is empty or contains invalid data. Assign a custom object or a Promise that is resolved after the item is created.",
    W0000: "'{0}' is deprecated in {1}. {2}",
    W0001: "{0} - '{1}' option is deprecated in {2}. {3}",
    W0002: "{0} - '{1}' method is deprecated in {2}. {3}",
    W0003: "{0} - '{1}' property is deprecated in {2}. {3}",
    W0004: "Timeout for theme loading is over: {0}",
    W0005: "'{0}' event is deprecated in {1}. {2}",
    W0006: "Invalid recurrence rule: '{0}'",
    W0007: "'{0}' Globalize culture is not defined",
    W0008: "Invalid view name: '{0}'",
    W0009: "Invalid time zone name: '{0}'",
    W0010: "{0} is deprecated in {1}. {2}",
    W0011: "Number parsing is invoked while the parser is not defined",
    W0012: "Date parsing is invoked while the parser is not defined",
    W0013: "'{0}' file is deprecated in {1}. {2}",
    W0014: "{0} - '{1}' type is deprecated in {2}. {3}",
    W0015: "Instead of returning a value from the '{0}' function, write it into the '{1}' field of the function's parameter.",
    W0016: 'The "{0}" option does not accept the "{1}" value since v{2}. {3}.',
    W0017: 'Setting the "{0}" property with a function is deprecated since v21.2',
    W0018: 'Setting the "position" property with a function is deprecated since v21.2'
});

});
parcelRegister("hCicl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd341a0cdad02d6a$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/utils/error.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $9U2XG = parcelRequire("9U2XG");

var $9vHY4 = parcelRequire("9vHY4");

var $5gpMu = parcelRequire("5gpMu");
var $cd341a0cdad02d6a$var$ERROR_URL = "http://js.devexpress.com/error/" + (0, $5gpMu.version).split(".").slice(0, 2).join("_") + "/";
function $cd341a0cdad02d6a$export$2e2bcd8739ae039(baseErrors, errors) {
    var exports = {
        ERROR_MESSAGES: (0, $2oTOp.extend)(errors, baseErrors),
        Error: function() {
            return makeError([].slice.call(arguments));
        },
        log: function(id) {
            var method = "log";
            if (/^E\d+$/.test(id)) method = "error";
            else if (/^W\d+$/.test(id)) method = "warn";
            (0, $9U2XG.logger)[method]("log" === method ? id : combineMessage([].slice.call(arguments)));
        }
    };
    function combineMessage(args) {
        var id = args[0];
        args = args.slice(1);
        return formatMessage(id, formatDetails(id, args));
    }
    function formatDetails(id, args) {
        args = [
            exports.ERROR_MESSAGES[id]
        ].concat(args);
        return (0, $9vHY4.format).apply(this, args).replace(/\.*\s*?$/, "");
    }
    function formatMessage(id, details) {
        return (0, $9vHY4.format).apply(this, [
            "{0} - {1}. See:\n{2}",
            id,
            details,
            getErrorUrl(id)
        ]);
    }
    function makeError(args) {
        var id = args[0];
        args = args.slice(1);
        var details = formatDetails(id, args);
        var url = getErrorUrl(id);
        var message = formatMessage(id, details);
        return (0, $2oTOp.extend)(new Error(message), {
            __id: id,
            __details: details,
            url: url
        });
    }
    function getErrorUrl(id) {
        return $cd341a0cdad02d6a$var$ERROR_URL + id;
    }
    return exports;
}

});
parcelRegister("9U2XG", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $735ba41ccde47313$export$af88d00dbe7f521; });
/**
 * DevExtreme (esm/core/utils/console.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");
var $735ba41ccde47313$var$noop = function() {};
var $735ba41ccde47313$var$getConsoleMethod = function(method) {
    if ("undefined" === typeof console || !(0, $6ntMu.isFunction)(console[method])) return $735ba41ccde47313$var$noop;
    return console[method].bind(console);
};
var $735ba41ccde47313$export$af88d00dbe7f521 = {
    info: $735ba41ccde47313$var$getConsoleMethod("info"),
    warn: $735ba41ccde47313$var$getConsoleMethod("warn"),
    error: $735ba41ccde47313$var$getConsoleMethod("error")
};
var $735ba41ccde47313$export$1c9f709888824e05 = function() {
    function assert(condition, message) {
        if (!condition) throw new Error(message);
    }
    return {
        assert: assert,
        assertParam: function(parameter, message) {
            assert(null !== parameter && void 0 !== parameter, message);
        }
    };
}();

});

parcelRegister("9vHY4", function(module, exports) {

$parcel$export(module.exports, "encodeHtml", function () { return $6ec91d630081ab78$export$4db3f3504654268f; });
$parcel$export(module.exports, "format", function () { return $6ec91d630081ab78$export$d9468344d3651243; });
/**
 * DevExtreme (esm/core/utils/string.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");
var $6ec91d630081ab78$export$4db3f3504654268f = function() {
    var encodeRegExp = [
        new RegExp("&", "g"),
        new RegExp('"', "g"),
        new RegExp("'", "g"),
        new RegExp("<", "g"),
        new RegExp(">", "g")
    ];
    return function(str) {
        return String(str).replace(encodeRegExp[0], "&amp;").replace(encodeRegExp[1], "&quot;").replace(encodeRegExp[2], "&#39;").replace(encodeRegExp[3], "&lt;").replace(encodeRegExp[4], "&gt;");
    };
}();
var $6ec91d630081ab78$var$splitQuad = function(raw) {
    switch(typeof raw){
        case "string":
            return raw.split(/\s+/, 4);
        case "object":
            return [
                raw.x || raw.h || raw.left,
                raw.y || raw.v || raw.top,
                raw.x || raw.h || raw.right,
                raw.y || raw.v || raw.bottom
            ];
        case "number":
            return [
                raw
            ];
        default:
            return raw;
    }
};
var $6ec91d630081ab78$export$5f705bd4c44a1383 = function(raw) {
    var quad = $6ec91d630081ab78$var$splitQuad(raw);
    var left = parseInt(quad && quad[0], 10);
    var top = parseInt(quad && quad[1], 10);
    var right = parseInt(quad && quad[2], 10);
    var bottom = parseInt(quad && quad[3], 10);
    if (!isFinite(left)) left = 0;
    if (!isFinite(top)) top = left;
    if (!isFinite(right)) right = left;
    if (!isFinite(bottom)) bottom = top;
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
};
function $6ec91d630081ab78$export$d9468344d3651243(template) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ((0, $6ntMu.isFunction)(template)) return template(...values);
    values.forEach((value, index)=>{
        if ((0, $6ntMu.isString)(value)) value = value.replace(/\$/g, "$$$$");
        var placeholderReg = new RegExp("\\{" + index + "\\}", "gm");
        template = template.replace(placeholderReg, value);
    });
    return template;
}
var $6ec91d630081ab78$export$b8b3234b4edfc4c2 = function(text, searchToken, replacementToken) {
    var str;
    return text.replace(new RegExp("(" + (str = searchToken, (str + "").replace(/([\\+*?.[^\]$(){}><|=!:])/g, "\\$1")) + ")", "gi"), replacementToken);
};
var $6ec91d630081ab78$export$dd1bc94b04021eeb = function() {
    var SPACE_REGEXP = /\s/g;
    return function(text) {
        return !text || !text.replace(SPACE_REGEXP, "");
    };
}();

});

parcelRegister("5gpMu", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $3d5271f0276019f9$export$83d89fbfd8236492; });
/**
 * DevExtreme (esm/core/version.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $3d5271f0276019f9$export$83d89fbfd8236492 = "22.2.11";

});





parcelRegister("gcp4g", function(module, exports) {

$parcel$export(module.exports, "executeAsync", function () { return $bcb1363f7f7d8cf2$export$565669a538b226a6; });
$parcel$export(module.exports, "deferUpdate", function () { return $bcb1363f7f7d8cf2$export$5c2413d24bb6a40f; });
$parcel$export(module.exports, "findBestMatches", function () { return $bcb1363f7f7d8cf2$export$6a7738807e7f2c17; });
$parcel$export(module.exports, "escapeRegExp", function () { return $bcb1363f7f7d8cf2$export$7c57da42ce8e346f; });
$parcel$export(module.exports, "noop", function () { return $bcb1363f7f7d8cf2$export$8793edee2d425525; });
$parcel$export(module.exports, "grep", function () { return $bcb1363f7f7d8cf2$export$41ee50d8efec7aa7; });
$parcel$export(module.exports, "equalByValue", function () { return $bcb1363f7f7d8cf2$export$e45a697a0958a5f; });
/**
 * DevExtreme (esm/core/utils/common.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $4WYaH = parcelRequire("4WYaH");

var $8IERv = parcelRequire("8IERv");

var $kuGI3 = parcelRequire("kuGI3");

var $dDkff = parcelRequire("dDkff");

var $8Cgs4 = parcelRequire("8Cgs4");

var $8OLOW = parcelRequire("8OLOW");

var $6ntMu = parcelRequire("6ntMu");
var $bcb1363f7f7d8cf2$export$e700b866474dec26 = function(value, defaultValue) {
    return (0, $6ntMu.isDefined)(value) ? value : defaultValue;
};
var $bcb1363f7f7d8cf2$export$565669a538b226a6 = function(action, context) {
    var deferred = new (0, $dDkff.Deferred);
    var normalizedContext = context || this;
    var task = {
        promise: deferred.promise(),
        abort: function() {
            clearTimeout(timerId);
            deferred.rejectWith(normalizedContext);
        }
    };
    var callback = function() {
        var result = action.call(normalizedContext);
        if (result && result.done && (0, $6ntMu.isFunction)(result.done)) result.done(function() {
            deferred.resolveWith(normalizedContext);
        });
        else deferred.resolveWith(normalizedContext);
    };
    var timerId = (arguments[2] || setTimeout)(callback, "number" === typeof context ? context : 0);
    return task;
};
var $bcb1363f7f7d8cf2$var$delayedFuncs = [];
var $bcb1363f7f7d8cf2$var$delayedNames = [];
var $bcb1363f7f7d8cf2$var$delayedDeferreds = [];
var $bcb1363f7f7d8cf2$var$executingName;
var $bcb1363f7f7d8cf2$var$deferExecute = function(name, func, deferred) {
    if ($bcb1363f7f7d8cf2$var$executingName && $bcb1363f7f7d8cf2$var$executingName !== name) {
        $bcb1363f7f7d8cf2$var$delayedFuncs.push(func);
        $bcb1363f7f7d8cf2$var$delayedNames.push(name);
        deferred = deferred || new (0, $dDkff.Deferred);
        $bcb1363f7f7d8cf2$var$delayedDeferreds.push(deferred);
        return deferred;
    } else {
        var oldExecutingName = $bcb1363f7f7d8cf2$var$executingName;
        var currentDelayedCount = $bcb1363f7f7d8cf2$var$delayedDeferreds.length;
        $bcb1363f7f7d8cf2$var$executingName = name;
        var result = func();
        if (!result) {
            if ($bcb1363f7f7d8cf2$var$delayedDeferreds.length > currentDelayedCount) result = (0, $dDkff.when).apply(this, $bcb1363f7f7d8cf2$var$delayedDeferreds.slice(currentDelayedCount));
            else if (deferred) deferred.resolve();
        }
        $bcb1363f7f7d8cf2$var$executingName = oldExecutingName;
        if (deferred && result && result.done) result.done(deferred.resolve).fail(deferred.reject);
        if (!$bcb1363f7f7d8cf2$var$executingName && $bcb1363f7f7d8cf2$var$delayedFuncs.length) ("render" === $bcb1363f7f7d8cf2$var$delayedNames.shift() ? $bcb1363f7f7d8cf2$export$9f991a1dc8c2af5b : $bcb1363f7f7d8cf2$export$5c2413d24bb6a40f)($bcb1363f7f7d8cf2$var$delayedFuncs.shift(), $bcb1363f7f7d8cf2$var$delayedDeferreds.shift());
        return result || (0, $dDkff.when)();
    }
};
var $bcb1363f7f7d8cf2$export$9f991a1dc8c2af5b = function(func, deferred) {
    return $bcb1363f7f7d8cf2$var$deferExecute("render", func, deferred);
};
var $bcb1363f7f7d8cf2$export$5c2413d24bb6a40f = function(func, deferred) {
    return $bcb1363f7f7d8cf2$var$deferExecute("update", func, deferred);
};
var $bcb1363f7f7d8cf2$export$420e8e898c79212f = function(func) {
    return function() {
        var that = this;
        return $bcb1363f7f7d8cf2$var$deferExecute("render", function() {
            return func.call(that);
        });
    };
};
var $bcb1363f7f7d8cf2$export$e749563bae0b9d5c = function(func) {
    return function() {
        var that = this;
        return $bcb1363f7f7d8cf2$var$deferExecute("update", function() {
            return func.call(that);
        });
    };
};
var $bcb1363f7f7d8cf2$export$6a7738807e7f2c17 = function(targetFilter, items, mapFn) {
    var bestMatches = [];
    var maxMatchCount = 0;
    (0, $8OLOW.each)(items, (index, itemSrc)=>{
        var matchCount = 0;
        var item = mapFn ? mapFn(itemSrc) : itemSrc;
        (0, $8OLOW.each)(targetFilter, (paramName, targetValue)=>{
            var value = item[paramName];
            if (void 0 === value) return;
            if ($bcb1363f7f7d8cf2$var$match(value, targetValue)) {
                matchCount++;
                return;
            }
            matchCount = -1;
            return false;
        });
        if (matchCount < maxMatchCount) return;
        if (matchCount > maxMatchCount) {
            bestMatches.length = 0;
            maxMatchCount = matchCount;
        }
        bestMatches.push(itemSrc);
    });
    return bestMatches;
};
var $bcb1363f7f7d8cf2$var$match = function(value, targetValue) {
    if (Array.isArray(value) && Array.isArray(targetValue)) {
        var mismatch = false;
        (0, $8OLOW.each)(value, (index, valueItem)=>{
            if (valueItem !== targetValue[index]) {
                mismatch = true;
                return false;
            }
        });
        if (mismatch) return false;
        return true;
    }
    if (value === targetValue) return true;
    return false;
};
var $bcb1363f7f7d8cf2$export$430720914e9be270 = function(raw) {
    var _raw$x, _raw$y;
    switch((0, $6ntMu.type)(raw)){
        case "string":
            return raw.split(/\s+/, 2);
        case "object":
            return [
                null !== (_raw$x = raw.x) && void 0 !== _raw$x ? _raw$x : raw.h,
                null !== (_raw$y = raw.y) && void 0 !== _raw$y ? _raw$y : raw.v
            ];
        case "number":
            return [
                raw
            ];
        case "array":
            return raw;
        default:
            return null;
    }
};
var $bcb1363f7f7d8cf2$export$e0c709538cb8ae18 = function(id) {
    var key = (0, $6ntMu.isString)(id) ? id : id.toString();
    var arr = key.match(/[^a-zA-Z0-9_]/g);
    arr && (0, $8OLOW.each)(arr, (_, sign)=>{
        key = key.replace(sign, "__" + sign.charCodeAt() + "__");
    });
    return key;
};
var $bcb1363f7f7d8cf2$export$4f22be2962df6eb9 = function(key) {
    var arr = key.match(/__\d+__/g);
    arr && arr.forEach((char)=>{
        var charCode = parseInt(char.replace("__", ""));
        key = key.replace(char, String.fromCharCode(charCode));
    });
    return key;
};
var $bcb1363f7f7d8cf2$export$aa6ab5672b20676f = function(raw, preventRound) {
    var pair = $bcb1363f7f7d8cf2$export$430720914e9be270(raw);
    var h = preventRound ? parseFloat(pair && pair[0]) : parseInt(pair && pair[0], 10);
    var v = preventRound ? parseFloat(pair && pair[1]) : parseInt(pair && pair[1], 10);
    if (!isFinite(h)) h = 0;
    if (!isFinite(v)) v = h;
    return {
        h: h,
        v: v
    };
};
var $bcb1363f7f7d8cf2$export$ac5b0c7e11c08cd4 = function(key) {
    if (key instanceof (0, $kuGI3.default)) return key.toString();
    else if ((0, $6ntMu.isObject)(key) || Array.isArray(key)) try {
        var keyHash = JSON.stringify(key);
        return "{}" === keyHash ? key : keyHash;
    } catch (e) {
        return key;
    }
    return key;
};
var $bcb1363f7f7d8cf2$export$7c57da42ce8e346f = function(string) {
    return string.replace(/[[\]{}\-()*+?.\\^$|\s]/g, "\\$&");
};
var $bcb1363f7f7d8cf2$export$2ad35a62dfcae12a = function(value) {
    var separator = (0, $8IERv.default)().serverDecimalSeparator;
    if ((0, $6ntMu.isDefined)(value)) value = value.toString().replace(".", separator);
    return value;
};
var $bcb1363f7f7d8cf2$export$8793edee2d425525 = function() {};
var $bcb1363f7f7d8cf2$export$21e1ac03cdd918b0 = function() {
    return (new (0, $dDkff.Deferred)).resolve().promise();
};
var $bcb1363f7f7d8cf2$export$41ee50d8efec7aa7 = function(elements, checkFunction, invert) {
    var result = [];
    var check;
    var expectedCheck = !invert;
    for(var i = 0; i < elements.length; i++){
        check = !!checkFunction(elements[i], i);
        if (check === expectedCheck) result.push(elements[i]);
    }
    return result;
};
var $bcb1363f7f7d8cf2$var$compareArrays = (array1, array2, depth, options)=>{
    if (array1.length !== array2.length) return false;
    return !array1.some((item, idx)=>!$bcb1363f7f7d8cf2$var$compareByValue(item, array2[idx], depth + 1, (0, $4WYaH.default)({}, options, {
            strict: true
        })));
};
var $bcb1363f7f7d8cf2$var$compareObjects = (object1, object2, depth, options)=>{
    var keys1 = Object.keys(object1);
    var keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    var keys2Set = new Set(keys2);
    return !keys1.some((key)=>!keys2Set.has(key) || !$bcb1363f7f7d8cf2$var$compareByValue(object1[key], object2[key], depth + 1, options));
};
var $bcb1363f7f7d8cf2$var$DEFAULT_EQUAL_BY_VALUE_OPTS = {
    maxDepth: 3,
    strict: true
};
var $bcb1363f7f7d8cf2$var$compareByValue = (value1, value2, depth, options)=>{
    var { strict: strict, maxDepth: maxDepth } = options;
    var comparable1 = (0, $8Cgs4.toComparable)(value1, true);
    var comparable2 = (0, $8Cgs4.toComparable)(value2, true);
    var comparisonResult = strict ? comparable1 === comparable2 : comparable1 == comparable2;
    switch(true){
        case comparisonResult:
        case depth >= maxDepth:
            return true;
        case (0, $6ntMu.isObject)(comparable1) && (0, $6ntMu.isObject)(comparable2):
            return $bcb1363f7f7d8cf2$var$compareObjects(comparable1, comparable2, depth, options);
        case Array.isArray(comparable1) && Array.isArray(comparable2):
            return $bcb1363f7f7d8cf2$var$compareArrays(comparable1, comparable2, depth, options);
        default:
            return false;
    }
};
var $bcb1363f7f7d8cf2$export$e45a697a0958a5f = function(value1, value2) {
    var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : $bcb1363f7f7d8cf2$var$DEFAULT_EQUAL_BY_VALUE_OPTS;
    var compareOptions = (0, $4WYaH.default)({}, $bcb1363f7f7d8cf2$var$DEFAULT_EQUAL_BY_VALUE_OPTS, options);
    return $bcb1363f7f7d8cf2$var$compareByValue(value1, value2, 0, compareOptions);
};

});
parcelRegister("8IERv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65922120c96329ae$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/config.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $cvYFL = parcelRequire("cvYFL");
var $65922120c96329ae$var$config = {
    rtlEnabled: false,
    defaultCurrency: "USD",
    defaultUseCurrencyAccountingStyle: true,
    oDataFilterToLower: true,
    serverDecimalSeparator: ".",
    decimalSeparator: ".",
    thousandsSeparator: ",",
    forceIsoDateParsing: true,
    wrapActionsBeforeExecute: true,
    useLegacyStoreResult: false,
    useJQuery: void 0,
    editorStylingMode: void 0,
    useLegacyVisibleIndex: false,
    floatingActionButtonConfig: {
        icon: "add",
        closeIcon: "close",
        label: "",
        position: {
            at: "right bottom",
            my: "right bottom",
            offset: {
                x: -16,
                y: -16
            }
        },
        maxSpeedDialActionCount: 5,
        shading: false,
        direction: "auto"
    },
    optionsParser: (optionsString)=>{
        if ("{" !== optionsString.trim().charAt(0)) optionsString = "{" + optionsString + "}";
        try {
            return new Function("return " + optionsString)();
        } catch (ex) {
            throw (0, $cvYFL.default).Error("E3018", ex, optionsString);
        }
    }
};
var $65922120c96329ae$var$deprecatedFields = [
    "decimalSeparator",
    "thousandsSeparator"
];
var $65922120c96329ae$var$configMethod = function() {
    if (!arguments.length) return $65922120c96329ae$var$config;
    var newConfig = arguments.length <= 0 ? void 0 : arguments[0];
    $65922120c96329ae$var$deprecatedFields.forEach((deprecatedField)=>{
        if (newConfig[deprecatedField]) {
            var message = "Now, the ".concat(deprecatedField, " is selected based on the specified locale.");
            (0, $cvYFL.default).log("W0003", "config", deprecatedField, "19.2", message);
        }
    });
    (0, $2oTOp.extend)($65922120c96329ae$var$config, newConfig);
};
if ("undefined" !== typeof DevExpress && DevExpress.config) $65922120c96329ae$var$configMethod(DevExpress.config);
var $65922120c96329ae$export$2e2bcd8739ae039 = $65922120c96329ae$var$configMethod;

});

parcelRegister("kuGI3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eeb7bd3ceec7875e$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/guid.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $a2g7x = parcelRequire("a2g7x");
var $eeb7bd3ceec7875e$var$Guid = (0, $a2g7x.default).inherit({
    ctor: function(value) {
        if (value) value = String(value);
        this._value = this._normalize(value || this._generate());
    },
    _normalize: function(value) {
        value = value.replace(/[^a-f0-9]/gi, "").toLowerCase();
        while(value.length < 32)value += "0";
        return [
            value.substr(0, 8),
            value.substr(8, 4),
            value.substr(12, 4),
            value.substr(16, 4),
            value.substr(20, 12)
        ].join("-");
    },
    _generate: function() {
        var value = "";
        for(var i = 0; i < 32; i++)value += Math.round(15 * Math.random()).toString(16);
        return value;
    },
    toString: function() {
        return this._value;
    },
    valueOf: function() {
        return this._value;
    },
    toJSON: function() {
        return this._value;
    }
});
var $eeb7bd3ceec7875e$export$2e2bcd8739ae039 = $eeb7bd3ceec7875e$var$Guid;

});

parcelRegister("dDkff", function(module, exports) {

$parcel$export(module.exports, "fromPromise", function () { return $9ece9f14a0289621$export$60f45028237c39d1; });
$parcel$export(module.exports, "Deferred", function () { return $9ece9f14a0289621$export$85f6557964517f1a; });
$parcel$export(module.exports, "when", function () { return $9ece9f14a0289621$export$a55877ca9db47377; });
/**
 * DevExtreme (esm/core/utils/deferred.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $2oTOp = parcelRequire("2oTOp");

var $dYDfV = parcelRequire("dYDfV");
var $9ece9f14a0289621$var$deferredConfig = [
    {
        method: "resolve",
        handler: "done",
        state: "resolved"
    },
    {
        method: "reject",
        handler: "fail",
        state: "rejected"
    },
    {
        method: "notify",
        handler: "progress"
    }
];
var $9ece9f14a0289621$var$_DeferredObj = function() {
    var that = this;
    this._state = "pending";
    this._promise = {};
    $9ece9f14a0289621$var$deferredConfig.forEach((function(config) {
        var methodName = config.method;
        this[methodName + "Callbacks"] = (0, $dYDfV.default)();
        this[methodName] = (function() {
            return this[methodName + "With"](this._promise, arguments);
        }).bind(this);
        this._promise[config.handler] = function(handler) {
            if (!handler) return this;
            var callbacks = that[methodName + "Callbacks"];
            if (callbacks.fired()) handler.apply(that[methodName + "Context"], that[methodName + "Args"]);
            else callbacks.add((function(context, args) {
                handler.apply(context, args);
            }).bind(this));
            return this;
        };
    }).bind(this));
    this._promise.always = function(handler) {
        return this.done(handler).fail(handler);
    };
    this._promise.catch = function(handler) {
        return this.then(null, handler);
    };
    this._promise.then = function(resolve, reject) {
        var result = new $9ece9f14a0289621$var$_DeferredObj;
        [
            "done",
            "fail"
        ].forEach((function(method) {
            var callback = "done" === method ? resolve : reject;
            this[method](function() {
                if (!callback) {
                    result["done" === method ? "resolve" : "reject"].apply(this, arguments);
                    return;
                }
                var callbackResult = callback && callback.apply(this, arguments);
                if ((0, $6ntMu.isDeferred)(callbackResult)) callbackResult.done(result.resolve).fail(result.reject);
                else if ((0, $6ntMu.isPromise)(callbackResult)) callbackResult.then(result.resolve, result.reject);
                else result.resolve.apply(this, (0, $6ntMu.isDefined)(callbackResult) ? [
                    callbackResult
                ] : arguments);
            });
        }).bind(this));
        return result.promise();
    };
    this._promise.state = function() {
        return that._state;
    };
    this._promise.promise = function(args) {
        return args ? (0, $2oTOp.extend)(args, that._promise) : that._promise;
    };
    this._promise.promise(this);
};
$9ece9f14a0289621$var$deferredConfig.forEach(function(config) {
    var methodName = config.method;
    var state = config.state;
    $9ece9f14a0289621$var$_DeferredObj.prototype[methodName + "With"] = function(context, args) {
        var callbacks = this[methodName + "Callbacks"];
        if ("pending" === this.state()) {
            this[methodName + "Args"] = args;
            this[methodName + "Context"] = context;
            if (state) this._state = state;
            callbacks.fire(context, args);
        }
        return this;
    };
});
function $9ece9f14a0289621$export$60f45028237c39d1(promise, context) {
    if ((0, $6ntMu.isDeferred)(promise)) return promise;
    else if ((0, $6ntMu.isPromise)(promise)) {
        var d = new $9ece9f14a0289621$var$_DeferredObj;
        promise.then(function() {
            d.resolveWith.apply(d, [
                context
            ].concat([
                [].slice.call(arguments)
            ]));
        }, function() {
            d.rejectWith.apply(d, [
                context
            ].concat([
                [].slice.call(arguments)
            ]));
        });
        return d;
    }
    return (new $9ece9f14a0289621$var$_DeferredObj).resolveWith(context, [
        promise
    ]);
}
var $9ece9f14a0289621$var$whenFunc = function() {
    if (1 === arguments.length) return $9ece9f14a0289621$export$60f45028237c39d1(arguments[0]);
    var values = [].slice.call(arguments);
    var contexts = [];
    var resolvedCount = 0;
    var deferred = new $9ece9f14a0289621$var$_DeferredObj;
    var updateState = function(i) {
        return function(value) {
            contexts[i] = this;
            values[i] = arguments.length > 1 ? [].slice.call(arguments) : value;
            resolvedCount++;
            if (resolvedCount === values.length) deferred.resolveWith(contexts, values);
        };
    };
    for(var i = 0; i < values.length; i++)if ((0, $6ntMu.isDeferred)(values[i])) values[i].promise().done(updateState(i)).fail(deferred.reject);
    else resolvedCount++;
    if (resolvedCount === values.length) deferred.resolveWith(contexts, values);
    return deferred.promise();
};
function $9ece9f14a0289621$export$8dd000f7a8e65512(value) {
    $9ece9f14a0289621$var$_DeferredObj = value.Deferred;
    $9ece9f14a0289621$var$whenFunc = value.when;
}
function $9ece9f14a0289621$export$85f6557964517f1a() {
    return new $9ece9f14a0289621$var$_DeferredObj;
}
function $9ece9f14a0289621$export$a55877ca9db47377() {
    return $9ece9f14a0289621$var$whenFunc.apply(this, arguments);
}

});
parcelRegister("dYDfV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2cf5460cb42690f$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/utils/callbacks.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $a2cf5460cb42690f$var$Callback = function(options) {
    this._options = options || {};
    this._list = [];
    this._queue = [];
    this._firing = false;
    this._fired = false;
    this._firingIndexes = [];
};
$a2cf5460cb42690f$var$Callback.prototype._fireCore = function(context, args) {
    var firingIndexes = this._firingIndexes;
    var list = this._list;
    var stopOnFalse = this._options.stopOnFalse;
    var step = firingIndexes.length;
    for(firingIndexes[step] = 0; firingIndexes[step] < list.length; firingIndexes[step]++){
        var result = list[firingIndexes[step]].apply(context, args);
        if (false === result && stopOnFalse) break;
    }
    firingIndexes.pop();
};
$a2cf5460cb42690f$var$Callback.prototype.add = function(fn) {
    if ("function" === typeof fn && (!this._options.unique || !this.has(fn))) this._list.push(fn);
    return this;
};
$a2cf5460cb42690f$var$Callback.prototype.remove = function(fn) {
    var list = this._list;
    var firingIndexes = this._firingIndexes;
    var index = list.indexOf(fn);
    if (index > -1) {
        list.splice(index, 1);
        if (this._firing && firingIndexes.length) {
            for(var step = 0; step < firingIndexes.length; step++)if (index <= firingIndexes[step]) firingIndexes[step]--;
        }
    }
    return this;
};
$a2cf5460cb42690f$var$Callback.prototype.has = function(fn) {
    var list = this._list;
    return fn ? list.indexOf(fn) > -1 : !!list.length;
};
$a2cf5460cb42690f$var$Callback.prototype.empty = function(fn) {
    this._list = [];
    return this;
};
$a2cf5460cb42690f$var$Callback.prototype.fireWith = function(context, args) {
    var queue = this._queue;
    args = args || [];
    args = args.slice ? args.slice() : args;
    if (this._options.syncStrategy) {
        this._firing = true;
        this._fireCore(context, args);
    } else {
        queue.push([
            context,
            args
        ]);
        if (this._firing) return;
        this._firing = true;
        while(queue.length){
            var memory = queue.shift();
            this._fireCore(memory[0], memory[1]);
        }
    }
    this._firing = false;
    this._fired = true;
    return this;
};
$a2cf5460cb42690f$var$Callback.prototype.fire = function() {
    this.fireWith(this, arguments);
};
$a2cf5460cb42690f$var$Callback.prototype.fired = function() {
    return this._fired;
};
var $a2cf5460cb42690f$var$Callbacks = function(options) {
    return new $a2cf5460cb42690f$var$Callback(options);
};
var $a2cf5460cb42690f$export$2e2bcd8739ae039 = $a2cf5460cb42690f$var$Callbacks;

});


parcelRegister("8Cgs4", function(module, exports) {

$parcel$export(module.exports, "getPathParts", function () { return $645ea2556e631009$export$802ad9f577150014; });
$parcel$export(module.exports, "compileGetter", function () { return $645ea2556e631009$export$b94f2b067360ed6e; });
$parcel$export(module.exports, "compileSetter", function () { return $645ea2556e631009$export$41547815519095bf; });
$parcel$export(module.exports, "toComparable", function () { return $645ea2556e631009$export$6a23b1608a834d73; });
/**
 * DevExtreme (esm/core/utils/data.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $cvYFL = parcelRequire("cvYFL");

var $a2g7x = parcelRequire("a2g7x");

var $5VpUx = parcelRequire("5VpUx");

var $6ntMu = parcelRequire("6ntMu");

var $8OLOW = parcelRequire("8OLOW");

var $7nKKw = parcelRequire("7nKKw");
var $645ea2556e631009$var$unwrapVariable = (0, $7nKKw.default).unwrap;
var $645ea2556e631009$var$isWrapped = (0, $7nKKw.default).isWrapped;
var $645ea2556e631009$var$assign = (0, $7nKKw.default).assign;
var $645ea2556e631009$var$bracketsToDots = function(expr) {
    return expr.replace(/\[/g, ".").replace(/\]/g, "");
};
var $645ea2556e631009$export$802ad9f577150014 = function(name) {
    return $645ea2556e631009$var$bracketsToDots(name).split(".");
};
var $645ea2556e631009$var$readPropValue = function(obj, propName, options) {
    options = options || {};
    if ("this" === propName) return $645ea2556e631009$var$unwrap(obj, options);
    return $645ea2556e631009$var$unwrap(obj[propName], options);
};
var $645ea2556e631009$var$assignPropValue = function(obj, propName, value, options) {
    if ("this" === propName) throw new (0, $cvYFL.default).Error("E4016");
    var propValue = obj[propName];
    if (options.unwrapObservables && $645ea2556e631009$var$isWrapped(propValue)) $645ea2556e631009$var$assign(propValue, value);
    else obj[propName] = value;
};
var $645ea2556e631009$var$prepareOptions = function(options) {
    options = options || {};
    options.unwrapObservables = void 0 !== options.unwrapObservables ? options.unwrapObservables : true;
    return options;
};
function $645ea2556e631009$var$unwrap(value, options) {
    return options.unwrapObservables ? $645ea2556e631009$var$unwrapVariable(value) : value;
}
var $645ea2556e631009$export$b94f2b067360ed6e = function(expr) {
    if (arguments.length > 1) expr = [].slice.call(arguments);
    if (!expr || "this" === expr) return function(obj) {
        return obj;
    };
    if ("string" === typeof expr) {
        var path = $645ea2556e631009$export$802ad9f577150014(expr);
        return function(obj, options) {
            options = $645ea2556e631009$var$prepareOptions(options);
            var functionAsIs = options.functionsAsIs;
            var hasDefaultValue = "defaultValue" in options;
            var current = $645ea2556e631009$var$unwrap(obj, options);
            for(var i = 0; i < path.length; i++){
                if (!current) {
                    if (null == current && hasDefaultValue) return options.defaultValue;
                    break;
                }
                var pathPart = path[i];
                if (hasDefaultValue && (0, $6ntMu.isObject)(current) && !(pathPart in current)) return options.defaultValue;
                var next = $645ea2556e631009$var$unwrap(current[pathPart], options);
                if (!functionAsIs && (0, $6ntMu.isFunction)(next)) next = next.call(current);
                current = next;
            }
            return current;
        };
    }
    if (Array.isArray(expr)) return $645ea2556e631009$var$combineGetters(expr);
    if ((0, $6ntMu.isFunction)(expr)) return expr;
};
function $645ea2556e631009$var$combineGetters(getters) {
    var compiledGetters = {};
    for(var i = 0, l = getters.length; i < l; i++){
        var getter = getters[i];
        compiledGetters[getter] = $645ea2556e631009$export$b94f2b067360ed6e(getter);
    }
    return function(obj, options) {
        var result;
        (0, $8OLOW.each)(compiledGetters, function(name) {
            var value = this(obj, options);
            if (void 0 === value) return;
            var current = result || (result = {});
            var path = name.split(".");
            var last = path.length - 1;
            for(var _i = 0; _i < last; _i++){
                var pathItem = path[_i];
                if (!(pathItem in current)) current[pathItem] = {};
                current = current[pathItem];
            }
            current[path[last]] = value;
        });
        return result;
    };
}
var $645ea2556e631009$var$ensurePropValueDefined = function(obj, propName, value, options) {
    if ((0, $6ntMu.isDefined)(value)) return value;
    var newValue = {};
    $645ea2556e631009$var$assignPropValue(obj, propName, newValue, options);
    return newValue;
};
var $645ea2556e631009$export$41547815519095bf = function(expr) {
    expr = $645ea2556e631009$export$802ad9f577150014(expr || "this");
    var lastLevelIndex = expr.length - 1;
    return function(obj, value, options) {
        options = $645ea2556e631009$var$prepareOptions(options);
        var currentValue = $645ea2556e631009$var$unwrap(obj, options);
        expr.forEach(function(propertyName, levelIndex) {
            var propertyValue = $645ea2556e631009$var$readPropValue(currentValue, propertyName, options);
            var isPropertyFunc = !options.functionsAsIs && (0, $6ntMu.isFunction)(propertyValue) && !$645ea2556e631009$var$isWrapped(propertyValue);
            if (levelIndex === lastLevelIndex) {
                if (options.merge && (0, $6ntMu.isPlainObject)(value) && (!(0, $6ntMu.isDefined)(propertyValue) || (0, $6ntMu.isPlainObject)(propertyValue))) {
                    propertyValue = $645ea2556e631009$var$ensurePropValueDefined(currentValue, propertyName, propertyValue, options);
                    (0, $5VpUx.deepExtendArraySafe)(propertyValue, value, false, true);
                } else if (isPropertyFunc) currentValue[propertyName](value);
                else $645ea2556e631009$var$assignPropValue(currentValue, propertyName, value, options);
            } else {
                propertyValue = $645ea2556e631009$var$ensurePropValueDefined(currentValue, propertyName, propertyValue, options);
                if (isPropertyFunc) propertyValue = propertyValue.call(currentValue);
                currentValue = propertyValue;
            }
        });
    };
};
var $645ea2556e631009$export$6a23b1608a834d73 = function(value, caseSensitive) {
    if (value instanceof Date) return value.getTime();
    if (value && value instanceof (0, $a2g7x.default) && value.valueOf) return value.valueOf();
    if (!caseSensitive && "string" === typeof value) return value.toLowerCase();
    return value;
};

});
parcelRegister("5VpUx", function(module, exports) {

$parcel$export(module.exports, "clone", function () { return $45065ff903a66a5e$export$9cd59f9826255e47; });
$parcel$export(module.exports, "orderEach", function () { return $45065ff903a66a5e$export$bb2eef2b4cf75f1d; });
$parcel$export(module.exports, "deepExtendArraySafe", function () { return $45065ff903a66a5e$export$46d2b27597d35977; });
/**
 * DevExtreme (esm/core/utils/object.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $7nKKw = parcelRequire("7nKKw");
var $45065ff903a66a5e$export$9cd59f9826255e47 = function() {
    function Clone() {}
    return function(obj) {
        Clone.prototype = obj;
        return new Clone;
    };
}();
var $45065ff903a66a5e$export$bb2eef2b4cf75f1d = function(map, func) {
    var keys = [];
    var key;
    var i;
    for(key in map)if (Object.prototype.hasOwnProperty.call(map, key)) keys.push(key);
    keys.sort(function(x, y) {
        var isNumberX = (0, $6ntMu.isNumeric)(x);
        var isNumberY = (0, $6ntMu.isNumeric)(y);
        if (isNumberX && isNumberY) return x - y;
        if (isNumberX && !isNumberY) return -1;
        if (!isNumberX && isNumberY) return 1;
        if (x < y) return -1;
        if (x > y) return 1;
        return 0;
    });
    for(i = 0; i < keys.length; i++){
        key = keys[i];
        func(key, map[key]);
    }
};
var $45065ff903a66a5e$var$assignValueToProperty = function(target, property, value, assignByReference) {
    if (!assignByReference && (0, $7nKKw.default).isWrapped(target[property])) (0, $7nKKw.default).assign(target[property], value);
    else target[property] = value;
};
var $45065ff903a66a5e$export$46d2b27597d35977 = function deepExtendArraySafe(target, changes, extendComplexObject, assignByReference) {
    var prevValue;
    var newValue;
    for(var name in changes){
        prevValue = target[name];
        newValue = changes[name];
        if ("__proto__" === name || "constructor" === name || target === newValue) continue;
        if ((0, $6ntMu.isPlainObject)(newValue)) {
            var goDeeper = extendComplexObject ? (0, $6ntMu.isObject)(prevValue) : (0, $6ntMu.isPlainObject)(prevValue);
            newValue = deepExtendArraySafe(goDeeper ? prevValue : {}, newValue, extendComplexObject, assignByReference);
        }
        if (void 0 !== newValue && prevValue !== newValue) $45065ff903a66a5e$var$assignValueToProperty(target, name, newValue, assignByReference);
    }
    return target;
};

});
parcelRegister("7nKKw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55fef1d117bb6300$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/utils/variable_wrapper.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $9U2XG = parcelRequire("9U2XG");

var $5Nras = parcelRequire("5Nras");
var $55fef1d117bb6300$export$2e2bcd8739ae039 = (0, $5Nras.default)({
    isWrapped: function() {
        return false;
    },
    isWritableWrapped: function() {
        return false;
    },
    wrap: function(value) {
        return value;
    },
    unwrap: function(value) {
        return value;
    },
    assign: function() {
        (0, $9U2XG.logger).error("Method 'assign' should not be used for not wrapped variables. Use 'isWrapped' method for ensuring.");
    }
});

});




parcelRegister("lINBx", function(module, exports) {

$parcel$export(module.exports, "addShadowDomStyles", function () { return $0414b67168d30975$export$75e0743d3ebfee9e; });
$parcel$export(module.exports, "getShadowElementsFromPoint", function () { return $0414b67168d30975$export$da6b1a2fb5914903; });
/**
 * DevExtreme (esm/core/utils/shadow_dom.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $0414b67168d30975$var$DX_RULE_PREFIX = "dx-";
var $0414b67168d30975$var$ownerDocumentStyleSheet = null;
function $0414b67168d30975$var$createConstructedStyleSheet(rootNode) {
    try {
        return new CSSStyleSheet;
    } catch (err) {
        var styleElement = rootNode.ownerDocument.createElement("style");
        rootNode.appendChild(styleElement);
        return styleElement.sheet;
    }
}
function $0414b67168d30975$var$processRules(targetStyleSheet, styleSheets, needApplyAllStyles) {
    for(var i = 0; i < styleSheets.length; i++){
        var sheet = styleSheets[i];
        try {
            for(var j = 0; j < sheet.cssRules.length; j++)$0414b67168d30975$var$insertRule(targetStyleSheet, sheet.cssRules[j], needApplyAllStyles);
        } catch (err) {}
    }
}
function $0414b67168d30975$var$insertRule(targetStyleSheet, rule, needApplyAllStyles) {
    var _rule$selectorText, _rule$cssRules, _rule$cssRules$, _rule$cssRules$$selec, _rule$name, _rule$style;
    var isDxRule = needApplyAllStyles || (null === (_rule$selectorText = rule.selectorText) || void 0 === _rule$selectorText ? void 0 : _rule$selectorText.includes($0414b67168d30975$var$DX_RULE_PREFIX)) || (null === (_rule$cssRules = rule.cssRules) || void 0 === _rule$cssRules ? void 0 : null === (_rule$cssRules$ = _rule$cssRules[0]) || void 0 === _rule$cssRules$ ? void 0 : null === (_rule$cssRules$$selec = _rule$cssRules$.selectorText) || void 0 === _rule$cssRules$$selec ? void 0 : _rule$cssRules$$selec.includes($0414b67168d30975$var$DX_RULE_PREFIX)) || (null === (_rule$name = rule.name) || void 0 === _rule$name ? void 0 : _rule$name.startsWith($0414b67168d30975$var$DX_RULE_PREFIX)) || "DXIcons" === (null === (_rule$style = rule.style) || void 0 === _rule$style ? void 0 : _rule$style.fontFamily);
    if (isDxRule) targetStyleSheet.insertRule(rule.cssText, targetStyleSheet.cssRules.length);
}
function $0414b67168d30975$export$75e0743d3ebfee9e($element) {
    var _el$getRootNode;
    var el = $element.get(0);
    var root = null === (_el$getRootNode = el.getRootNode) || void 0 === _el$getRootNode ? void 0 : _el$getRootNode.call(el);
    if (!(null !== root && void 0 !== root && root.host)) return;
    if (!$0414b67168d30975$var$ownerDocumentStyleSheet) {
        $0414b67168d30975$var$ownerDocumentStyleSheet = $0414b67168d30975$var$createConstructedStyleSheet(root);
        $0414b67168d30975$var$processRules($0414b67168d30975$var$ownerDocumentStyleSheet, el.ownerDocument.styleSheets, false);
    }
    var currentShadowDomStyleSheet = $0414b67168d30975$var$createConstructedStyleSheet(root);
    $0414b67168d30975$var$processRules(currentShadowDomStyleSheet, root.styleSheets, true);
    root.adoptedStyleSheets = [
        $0414b67168d30975$var$ownerDocumentStyleSheet,
        currentShadowDomStyleSheet
    ];
}
function $0414b67168d30975$var$isPositionInElementRectangle(element, x, y) {
    var rect = element.getBoundingClientRect();
    return rect && x >= rect.left && x < rect.right && y >= rect.top && y < rect.bottom;
}
function $0414b67168d30975$var$createQueue() {
    var shiftIndex = 0;
    var items = [];
    return {
        push (item) {
            items.push(item);
            return this;
        },
        shift () {
            shiftIndex++;
            return items[shiftIndex - 1];
        },
        get length () {
            return items.length - shiftIndex;
        },
        get items () {
            return items;
        }
    };
}
function $0414b67168d30975$export$da6b1a2fb5914903(x, y, root) {
    var elementQueue = $0414b67168d30975$var$createQueue().push(root);
    while(elementQueue.length){
        var el = elementQueue.shift();
        for(var i = 0; i < el.childNodes.length; i++){
            var childNode = el.childNodes[i];
            if (childNode.nodeType === Node.ELEMENT_NODE && $0414b67168d30975$var$isPositionInElementRectangle(childNode, x, y) && "none" !== getComputedStyle(childNode).pointerEvents) elementQueue.push(childNode);
        }
    }
    var result = elementQueue.items.reverse();
    result.pop();
    return result;
}

});


parcelRegister("60GuF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4603b48205be46cf$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/events/core/events_engine.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $4WYaH = parcelRequire("4WYaH");

var $gsTRc = parcelRequire("gsTRc");

var $2oTOp = parcelRequire("2oTOp");

var $3yzYM = parcelRequire("3yzYM");

var $hYatw = parcelRequire("hYatw");

var $5Nras = parcelRequire("5Nras");

var $6ntMu = parcelRequire("6ntMu");

var $dYDfV = parcelRequire("dYDfV");

var $cvYFL = parcelRequire("cvYFL");

var $g6CMK = parcelRequire("g6CMK");

var $k2ifc = parcelRequire("k2ifc");
var $4603b48205be46cf$var$window = (0, $hYatw.getWindow)();
var $4603b48205be46cf$var$EMPTY_EVENT_NAME = "dxEmptyEventType";
var $4603b48205be46cf$var$NATIVE_EVENTS_TO_SUBSCRIBE = {
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    pointerenter: "pointerover",
    pointerleave: "pointerout"
};
var $4603b48205be46cf$var$NATIVE_EVENTS_TO_TRIGGER = {
    focusin: "focus",
    focusout: "blur"
};
var $4603b48205be46cf$var$NO_BUBBLE_EVENTS = [
    "blur",
    "focus",
    "load"
];
var $4603b48205be46cf$var$forcePassiveFalseEventNames = [
    "touchmove",
    "wheel",
    "mousewheel",
    "touchstart"
];
var $4603b48205be46cf$var$EVENT_PROPERTIES = [
    "target",
    "relatedTarget",
    "delegateTarget",
    "altKey",
    "bubbles",
    "cancelable",
    "changedTouches",
    "ctrlKey",
    "detail",
    "eventPhase",
    "metaKey",
    "shiftKey",
    "view",
    "char",
    "code",
    "charCode",
    "key",
    "keyCode",
    "button",
    "buttons",
    "offsetX",
    "offsetY",
    "pointerId",
    "pointerType",
    "targetTouches",
    "toElement",
    "touches"
];
function $4603b48205be46cf$var$matchesSafe(target, selector) {
    return !(0, $6ntMu.isWindow)(target) && "#document" !== target.nodeName && (0, $3yzYM.default).elementMatches(target, selector);
}
var $4603b48205be46cf$var$elementDataMap = new WeakMap;
var $4603b48205be46cf$var$guid = 0;
var $4603b48205be46cf$var$skipEvent;
var $4603b48205be46cf$var$special = function() {
    var specialData = {};
    (0, $gsTRc.default).add(function(eventName, eventObject) {
        specialData[eventName] = eventObject;
    });
    return {
        getField: function(eventName, field) {
            return specialData[eventName] && specialData[eventName][field];
        },
        callMethod: function(eventName, methodName, context, args) {
            return specialData[eventName] && specialData[eventName][methodName] && specialData[eventName][methodName].apply(context, args);
        }
    };
}();
var $4603b48205be46cf$var$eventsEngine = (0, $5Nras.default)({
    on: $4603b48205be46cf$var$getHandler($4603b48205be46cf$var$normalizeOnArguments($4603b48205be46cf$var$iterate(function(element, eventName, selector, data, handler) {
        var handlersController = $4603b48205be46cf$var$getHandlersController(element, eventName);
        handlersController.addHandler(handler, selector, data);
    }))),
    one: $4603b48205be46cf$var$getHandler($4603b48205be46cf$var$normalizeOnArguments(function(element, eventName, selector, data, handler) {
        $4603b48205be46cf$var$eventsEngine.on(element, eventName, selector, data, function oneTimeHandler() {
            $4603b48205be46cf$var$eventsEngine.off(element, eventName, selector, oneTimeHandler);
            handler.apply(this, arguments);
        });
    })),
    off: $4603b48205be46cf$var$getHandler($4603b48205be46cf$var$normalizeOffArguments($4603b48205be46cf$var$iterate(function(element, eventName, selector, handler) {
        var handlersController = $4603b48205be46cf$var$getHandlersController(element, eventName);
        handlersController.removeHandler(handler, selector);
    }))),
    trigger: $4603b48205be46cf$var$getHandler($4603b48205be46cf$var$normalizeTriggerArguments(function(element, event, extraParameters) {
        var eventName = event.type;
        var handlersController = $4603b48205be46cf$var$getHandlersController(element, event.type);
        $4603b48205be46cf$var$special.callMethod(eventName, "trigger", element, [
            event,
            extraParameters
        ]);
        handlersController.callHandlers(event, extraParameters);
        var noBubble = $4603b48205be46cf$var$special.getField(eventName, "noBubble") || event.isPropagationStopped() || -1 !== $4603b48205be46cf$var$NO_BUBBLE_EVENTS.indexOf(eventName);
        if (!noBubble) {
            var parents = [];
            !function getParents(element) {
                var _element$parentNode;
                var parent = null !== (_element$parentNode = element.parentNode) && void 0 !== _element$parentNode ? _element$parentNode : (0, $6ntMu.isObject)(element.host) ? element.host : null;
                if (parent) {
                    parents.push(parent);
                    getParents(parent);
                }
            }(element);
            parents.push($4603b48205be46cf$var$window);
            var i = 0;
            while(parents[i] && !event.isPropagationStopped()){
                var parentDataByEvent = $4603b48205be46cf$var$getHandlersController(parents[i], event.type);
                parentDataByEvent.callHandlers((0, $2oTOp.extend)(event, {
                    currentTarget: parents[i]
                }), extraParameters);
                i++;
            }
        }
        if (element.nodeType || (0, $6ntMu.isWindow)(element)) {
            $4603b48205be46cf$var$special.callMethod(eventName, "_default", element, [
                event,
                extraParameters
            ]);
            $4603b48205be46cf$var$callNativeMethod(eventName, element);
        }
    })),
    triggerHandler: $4603b48205be46cf$var$getHandler($4603b48205be46cf$var$normalizeTriggerArguments(function(element, event, extraParameters) {
        var handlersController = $4603b48205be46cf$var$getHandlersController(element, event.type);
        handlersController.callHandlers(event, extraParameters);
    }))
});
function $4603b48205be46cf$var$applyForEach(args, method) {
    var element = args[0];
    if (!element) return;
    if ((0, $3yzYM.default).isNode(element) || (0, $6ntMu.isWindow)(element)) method.apply($4603b48205be46cf$var$eventsEngine, args);
    else if (!(0, $6ntMu.isString)(element) && "length" in element) {
        var itemArgs = Array.prototype.slice.call(args, 0);
        Array.prototype.forEach.call(element, function(itemElement) {
            itemArgs[0] = itemElement;
            $4603b48205be46cf$var$applyForEach(itemArgs, method);
        });
    } else throw (0, $cvYFL.default).Error("E0025");
}
function $4603b48205be46cf$var$getHandler(method) {
    return function() {
        $4603b48205be46cf$var$applyForEach(arguments, method);
    };
}
function $4603b48205be46cf$var$detectPassiveEventHandlersSupport() {
    var isSupported = false;
    try {
        var options = Object.defineProperty({}, "passive", {
            get: function() {
                isSupported = true;
                return true;
            }
        });
        $4603b48205be46cf$var$window.addEventListener("test", null, options);
    } catch (e) {}
    return isSupported;
}
var $4603b48205be46cf$var$passiveEventHandlersSupported = (0, $k2ifc.default)($4603b48205be46cf$var$detectPassiveEventHandlersSupport);
var $4603b48205be46cf$var$contains = (container, element)=>{
    if ((0, $6ntMu.isWindow)(container)) return $4603b48205be46cf$var$contains(container.document, element);
    return container.contains ? container.contains(element) : !!(element.compareDocumentPosition(container) & element.DOCUMENT_POSITION_CONTAINS);
};
function $4603b48205be46cf$var$getHandlersController(element, eventName) {
    var elementData = $4603b48205be46cf$var$elementDataMap.get(element);
    eventName = eventName || "";
    var eventNameParts = eventName.split(".");
    var namespaces = eventNameParts.slice(1);
    var eventNameIsDefined = !!eventNameParts[0];
    eventName = eventNameParts[0] || $4603b48205be46cf$var$EMPTY_EVENT_NAME;
    if (!elementData) {
        elementData = {};
        $4603b48205be46cf$var$elementDataMap.set(element, elementData);
    }
    if (!elementData[eventName]) elementData[eventName] = {
        handleObjects: [],
        nativeHandler: null
    };
    var eventData = elementData[eventName];
    return {
        addHandler: function(handler, selector, data) {
            var callHandler = function(e, extraParameters) {
                var handlerArgs = [
                    e
                ];
                var target = e.currentTarget;
                var relatedTarget = e.relatedTarget;
                var secondaryTargetIsInside;
                var result;
                if (eventName in $4603b48205be46cf$var$NATIVE_EVENTS_TO_SUBSCRIBE) secondaryTargetIsInside = relatedTarget && target && (relatedTarget === target || $4603b48205be46cf$var$contains(target, relatedTarget));
                if (void 0 !== extraParameters) handlerArgs.push(extraParameters);
                $4603b48205be46cf$var$special.callMethod(eventName, "handle", element, [
                    e,
                    data
                ]);
                if (!secondaryTargetIsInside) result = handler.apply(target, handlerArgs);
                if (false === result) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            };
            var handleObject = {
                handler: handler,
                wrappedHandler: function(e, extraParameters) {
                    if ($4603b48205be46cf$var$skipEvent && e.type === $4603b48205be46cf$var$skipEvent) return;
                    e.data = data;
                    e.delegateTarget = element;
                    if (selector) {
                        var currentTarget = e.target;
                        while(currentTarget && currentTarget !== element){
                            if ($4603b48205be46cf$var$matchesSafe(currentTarget, selector)) {
                                e.currentTarget = currentTarget;
                                callHandler(e, extraParameters);
                            }
                            currentTarget = currentTarget.parentNode;
                        }
                    } else {
                        e.currentTarget = e.delegateTarget || e.target;
                        callHandler(e, extraParameters);
                    }
                },
                selector: selector,
                type: eventName,
                data: data,
                namespace: namespaces.join("."),
                namespaces: namespaces,
                guid: ++$4603b48205be46cf$var$guid
            };
            eventData.handleObjects.push(handleObject);
            var firstHandlerForTheType = 1 === eventData.handleObjects.length;
            var shouldAddNativeListener = firstHandlerForTheType && eventNameIsDefined;
            var nativeListenerOptions;
            if (shouldAddNativeListener) shouldAddNativeListener = !$4603b48205be46cf$var$special.callMethod(eventName, "setup", element, [
                data,
                namespaces,
                handler
            ]);
            if (shouldAddNativeListener) {
                eventData.nativeHandler = $4603b48205be46cf$var$getNativeHandler(eventName);
                if ($4603b48205be46cf$var$passiveEventHandlersSupported() && $4603b48205be46cf$var$forcePassiveFalseEventNames.indexOf(eventName) > -1) nativeListenerOptions = {
                    passive: false
                };
                eventData.removeListener = (0, $3yzYM.default).listen(element, $4603b48205be46cf$var$NATIVE_EVENTS_TO_SUBSCRIBE[eventName] || eventName, eventData.nativeHandler, nativeListenerOptions);
            }
            $4603b48205be46cf$var$special.callMethod(eventName, "add", element, [
                handleObject
            ]);
        },
        removeHandler: function(handler, selector) {
            var removeByEventName = function(eventName) {
                var eventData = elementData[eventName];
                if (!eventData.handleObjects.length) {
                    delete elementData[eventName];
                    return;
                }
                var removedHandler;
                eventData.handleObjects = eventData.handleObjects.filter(function(handleObject) {
                    var skip = namespaces.length && !$4603b48205be46cf$var$isSubset(handleObject.namespaces, namespaces) || handler && handleObject.handler !== handler || selector && handleObject.selector !== selector;
                    if (!skip) {
                        removedHandler = handleObject.handler;
                        $4603b48205be46cf$var$special.callMethod(eventName, "remove", element, [
                            handleObject
                        ]);
                    }
                    return skip;
                });
                var lastHandlerForTheType = !eventData.handleObjects.length;
                var shouldRemoveNativeListener = lastHandlerForTheType && eventName !== $4603b48205be46cf$var$EMPTY_EVENT_NAME;
                if (shouldRemoveNativeListener) {
                    $4603b48205be46cf$var$special.callMethod(eventName, "teardown", element, [
                        namespaces,
                        removedHandler
                    ]);
                    if (eventData.nativeHandler) eventData.removeListener();
                    delete elementData[eventName];
                }
            };
            if (eventNameIsDefined) removeByEventName(eventName);
            else for(var name in elementData)removeByEventName(name);
            var elementDataIsEmpty = 0 === Object.keys(elementData).length;
            if (elementDataIsEmpty) $4603b48205be46cf$var$elementDataMap.delete(element);
        },
        callHandlers: function(event, extraParameters) {
            var forceStop = false;
            var handleCallback = function(handleObject) {
                if (forceStop) return;
                if (!namespaces.length || $4603b48205be46cf$var$isSubset(handleObject.namespaces, namespaces)) {
                    handleObject.wrappedHandler(event, extraParameters);
                    forceStop = event.isImmediatePropagationStopped();
                }
            };
            eventData.handleObjects.forEach(handleCallback);
            if (namespaces.length && elementData[$4603b48205be46cf$var$EMPTY_EVENT_NAME]) elementData[$4603b48205be46cf$var$EMPTY_EVENT_NAME].handleObjects.forEach(handleCallback);
        }
    };
}
function $4603b48205be46cf$var$getNativeHandler(subscribeName) {
    return function(event, extraParameters) {
        var handlersController = $4603b48205be46cf$var$getHandlersController(this, subscribeName);
        event = $4603b48205be46cf$var$eventsEngine.Event(event);
        handlersController.callHandlers(event, extraParameters);
    };
}
function $4603b48205be46cf$var$isSubset(original, checked) {
    for(var i = 0; i < checked.length; i++){
        if (original.indexOf(checked[i]) < 0) return false;
    }
    return true;
}
function $4603b48205be46cf$var$normalizeOnArguments(callback) {
    return function(element, eventName, selector, data, handler) {
        if (!handler) {
            handler = data;
            data = void 0;
        }
        if ("string" !== typeof selector) {
            data = selector;
            selector = void 0;
        }
        if (!handler && "string" === typeof eventName) {
            handler = data || selector;
            selector = void 0;
            data = void 0;
        }
        callback(element, eventName, selector, data, handler);
    };
}
function $4603b48205be46cf$var$normalizeOffArguments(callback) {
    return function(element, eventName, selector, handler) {
        if ("function" === typeof selector) {
            handler = selector;
            selector = void 0;
        }
        callback(element, eventName, selector, handler);
    };
}
function $4603b48205be46cf$var$normalizeTriggerArguments(callback) {
    return function(element, src, extraParameters) {
        if ("string" === typeof src) src = {
            type: src
        };
        if (!src.target) src.target = element;
        src.currentTarget = element;
        if (!src.delegateTarget) src.delegateTarget = element;
        if (!src.type && src.originalEvent) src.type = src.originalEvent.type;
        callback(element, src instanceof $4603b48205be46cf$var$eventsEngine.Event ? src : $4603b48205be46cf$var$eventsEngine.Event(src), extraParameters);
    };
}
function $4603b48205be46cf$var$normalizeEventArguments(callback) {
    $4603b48205be46cf$var$eventsEngine.Event = function(src, config) {
        if (!(this instanceof $4603b48205be46cf$var$eventsEngine.Event)) return new $4603b48205be46cf$var$eventsEngine.Event(src, config);
        if (!src) src = {};
        if ("string" === typeof src) src = {
            type: src
        };
        if (!config) config = {};
        callback.call(this, src, config);
    };
    (0, $4WYaH.default)($4603b48205be46cf$var$eventsEngine.Event.prototype, {
        _propagationStopped: false,
        _immediatePropagationStopped: false,
        _defaultPrevented: false,
        isPropagationStopped: function() {
            return !!(this._propagationStopped || this.originalEvent && this.originalEvent.propagationStopped);
        },
        stopPropagation: function() {
            this._propagationStopped = true;
            this.originalEvent && this.originalEvent.stopPropagation();
        },
        isImmediatePropagationStopped: function() {
            return this._immediatePropagationStopped;
        },
        stopImmediatePropagation: function() {
            this.stopPropagation();
            this._immediatePropagationStopped = true;
            this.originalEvent && this.originalEvent.stopImmediatePropagation();
        },
        isDefaultPrevented: function() {
            return !!(this._defaultPrevented || this.originalEvent && this.originalEvent.defaultPrevented);
        },
        preventDefault: function() {
            this._defaultPrevented = true;
            this.originalEvent && this.originalEvent.preventDefault();
        }
    });
    return $4603b48205be46cf$var$eventsEngine.Event;
}
function $4603b48205be46cf$var$iterate(callback) {
    var iterateEventNames = function(element, eventName) {
        if (eventName && eventName.indexOf(" ") > -1) {
            var args = Array.prototype.slice.call(arguments, 0);
            eventName.split(" ").forEach(function(eventName) {
                args[1] = eventName;
                callback.apply(this, args);
            });
        } else callback.apply(this, arguments);
    };
    return function(element, eventName) {
        if ("object" === typeof eventName) {
            var args = Array.prototype.slice.call(arguments, 0);
            for(var name in eventName){
                args[1] = name;
                args[args.length - 1] = eventName[name];
                iterateEventNames.apply(this, args);
            }
        } else iterateEventNames.apply(this, arguments);
    };
}
function $4603b48205be46cf$var$callNativeMethod(eventName, element) {
    var nativeMethodName = $4603b48205be46cf$var$NATIVE_EVENTS_TO_TRIGGER[eventName] || eventName;
    if (function(eventName, element) {
        return "click" === eventName && "a" === element.localName;
    }(eventName, element)) return;
    if ((0, $6ntMu.isFunction)(element[nativeMethodName])) {
        $4603b48205be46cf$var$skipEvent = eventName;
        element[nativeMethodName]();
        $4603b48205be46cf$var$skipEvent = void 0;
    }
}
function $4603b48205be46cf$var$calculateWhich(event) {
    if (function(event) {
        return null == event.which && 0 === event.type.indexOf("key");
    }(event)) return null != event.charCode ? event.charCode : event.keyCode;
    if (function(event) {
        return !event.which && void 0 !== event.button && /^(?:mouse|pointer|contextmenu|drag|drop)|click/.test(event.type);
    }(event)) return ({
        1: 1,
        2: 3,
        3: 1,
        4: 2
    })[event.button];
    return event.which;
}
function $4603b48205be46cf$var$initEvent(EventClass) {
    if (EventClass) {
        $4603b48205be46cf$var$eventsEngine.Event = EventClass;
        $4603b48205be46cf$var$eventsEngine.Event.prototype = EventClass.prototype;
    }
}
$4603b48205be46cf$var$initEvent($4603b48205be46cf$var$normalizeEventArguments(function(src, config) {
    var _src$view;
    var srcIsEvent = src instanceof $4603b48205be46cf$var$eventsEngine.Event || (0, $hYatw.hasWindow)() && src instanceof $4603b48205be46cf$var$window.Event || (null === (_src$view = src.view) || void 0 === _src$view ? void 0 : _src$view.Event) && src instanceof src.view.Event;
    if (srcIsEvent) {
        this.originalEvent = src;
        this.type = src.type;
        this.currentTarget = void 0;
        if (Object.prototype.hasOwnProperty.call(src, "isTrusted")) this.isTrusted = src.isTrusted;
        this.timeStamp = src.timeStamp || Date.now();
    } else (0, $4WYaH.default)(this, src);
    $4603b48205be46cf$var$addProperty("which", $4603b48205be46cf$var$calculateWhich, this);
    if (0 === src.type.indexOf("touch")) {
        delete config.pageX;
        delete config.pageY;
    }
    (0, $4WYaH.default)(this, config);
    this.guid = ++$4603b48205be46cf$var$guid;
}));
function $4603b48205be46cf$var$addProperty(propName, hook, eventInstance) {
    Object.defineProperty(eventInstance || $4603b48205be46cf$var$eventsEngine.Event.prototype, propName, {
        enumerable: true,
        configurable: true,
        get: function() {
            return this.originalEvent && hook(this.originalEvent);
        },
        set: function(value) {
            Object.defineProperty(this, propName, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: value
            });
        }
    });
}
$4603b48205be46cf$var$EVENT_PROPERTIES.forEach((prop)=>$4603b48205be46cf$var$addProperty(prop, (event)=>event[prop]));
(0, $g6CMK.default)($4603b48205be46cf$var$addProperty);
var $4603b48205be46cf$var$beforeSetStrategy = (0, $dYDfV.default)();
var $4603b48205be46cf$var$afterSetStrategy = (0, $dYDfV.default)();
$4603b48205be46cf$var$eventsEngine.set = function(engine) {
    $4603b48205be46cf$var$beforeSetStrategy.fire();
    $4603b48205be46cf$var$eventsEngine.inject(engine);
    $4603b48205be46cf$var$initEvent(engine.Event);
    $4603b48205be46cf$var$afterSetStrategy.fire();
};
$4603b48205be46cf$var$eventsEngine.subscribeGlobal = function() {
    $4603b48205be46cf$var$applyForEach(arguments, $4603b48205be46cf$var$normalizeOnArguments(function() {
        var args = arguments;
        $4603b48205be46cf$var$eventsEngine.on.apply(this, args);
        $4603b48205be46cf$var$beforeSetStrategy.add(function() {
            var offArgs = Array.prototype.slice.call(args, 0);
            offArgs.splice(3, 1);
            $4603b48205be46cf$var$eventsEngine.off.apply(this, offArgs);
        });
        $4603b48205be46cf$var$afterSetStrategy.add(function() {
            $4603b48205be46cf$var$eventsEngine.on.apply(this, args);
        });
    }));
};
$4603b48205be46cf$var$eventsEngine.forcePassiveFalseEventNames = $4603b48205be46cf$var$forcePassiveFalseEventNames;
$4603b48205be46cf$var$eventsEngine.passiveEventHandlersSupported = $4603b48205be46cf$var$passiveEventHandlersSupported;
var $4603b48205be46cf$export$2e2bcd8739ae039 = $4603b48205be46cf$var$eventsEngine;

});
parcelRegister("gsTRc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfca96eb849413c1$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/events/core/event_registrator_callbacks.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $e1oup = parcelRequire("e1oup");
var $bfca96eb849413c1$export$2e2bcd8739ae039 = new (0, $e1oup.default);

});
parcelRegister("e1oup", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a35427cbfad1f79b$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/memorized_callbacks.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $8OLOW = parcelRequire("8OLOW");

var $dYDfV = parcelRequire("dYDfV");
class $a35427cbfad1f79b$export$2e2bcd8739ae039 {
    constructor(){
        this.memory = [];
        this.callbacks = (0, $dYDfV.default)();
    }
    add(fn) {
        (0, $8OLOW.each)(this.memory, (_, item)=>fn.apply(fn, item));
        this.callbacks.add(fn);
    }
    remove(fn) {
        this.callbacks.remove(fn);
    }
    fire() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        this.memory.push(args);
        this.callbacks.fire.apply(this.callbacks, args);
    }
}

});


parcelRegister("hYatw", function(module, exports) {

$parcel$export(module.exports, "hasWindow", function () { return $036042bfacd74618$export$fef62134eea24008; });
$parcel$export(module.exports, "getWindow", function () { return $036042bfacd74618$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "hasProperty", function () { return $036042bfacd74618$export$bf9617eaf5d2451; });
$parcel$export(module.exports, "getNavigator", function () { return $036042bfacd74618$export$a56241c767c1d89f; });
/**
 * DevExtreme (esm/core/utils/window.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $3yzYM = parcelRequire("3yzYM");
var $036042bfacd74618$var$hasWindowValue = "undefined" !== typeof window;
var $036042bfacd74618$export$fef62134eea24008 = ()=>$036042bfacd74618$var$hasWindowValue;
var $036042bfacd74618$var$windowObject = $036042bfacd74618$export$fef62134eea24008() ? window : void 0;
if (!$036042bfacd74618$var$windowObject) {
    $036042bfacd74618$var$windowObject = {};
    $036042bfacd74618$var$windowObject.window = $036042bfacd74618$var$windowObject;
}
var $036042bfacd74618$export$38b2d434cce3ea22 = ()=>$036042bfacd74618$var$windowObject;
var $036042bfacd74618$export$b4ab31529663b75b = (newWindowObject, hasWindow)=>{
    if (void 0 === hasWindow) $036042bfacd74618$var$hasWindowValue = "undefined" !== typeof window && window === newWindowObject;
    else $036042bfacd74618$var$hasWindowValue = hasWindow;
    $036042bfacd74618$var$windowObject = newWindowObject;
};
var $036042bfacd74618$export$bf9617eaf5d2451 = (prop)=>$036042bfacd74618$export$fef62134eea24008() && prop in $036042bfacd74618$var$windowObject;
var $036042bfacd74618$export$20797f16d8ce2f78 = (width)=>{
    if (width < 768) return "xs";
    else if (width < 992) return "sm";
    else if (width < 1200) return "md";
    else return "lg";
};
var $036042bfacd74618$export$44b91c763f5d66fc = (screenFactorCallback)=>{
    var screenFactorFunc = screenFactorCallback || $036042bfacd74618$export$20797f16d8ce2f78;
    var windowWidth = (0, $3yzYM.default).getDocumentElement().clientWidth;
    return screenFactorFunc(windowWidth);
};
var $036042bfacd74618$export$a56241c767c1d89f = ()=>$036042bfacd74618$export$fef62134eea24008() ? $036042bfacd74618$var$windowObject.navigator : {
        userAgent: ""
    };

});

parcelRegister("g6CMK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb9b4acd34e84254$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/events/core/hook_touch_props.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $bb9b4acd34e84254$var$touchPropsToHook = [
    "pageX",
    "pageY",
    "screenX",
    "screenY",
    "clientX",
    "clientY"
];
var $bb9b4acd34e84254$var$touchPropHook = function(name, event) {
    if (event[name] && !event.touches || !event.touches) return event[name];
    var touches = event.touches.length ? event.touches : event.changedTouches;
    if (!touches.length) return;
    return touches[0][name];
};
function $bb9b4acd34e84254$export$2e2bcd8739ae039(callback) {
    $bb9b4acd34e84254$var$touchPropsToHook.forEach(function(name) {
        callback(name, function(event) {
            return $bb9b4acd34e84254$var$touchPropHook(name, event);
        });
    }, this);
}

});

parcelRegister("k2ifc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9622570e37acee2$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/utils/call_once.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $e9622570e37acee2$var$callOnce = function(handler) {
    var result;
    var _wrappedHandler = function() {
        result = handler.apply(this, arguments);
        _wrappedHandler = function() {
            return result;
        };
        return result;
    };
    return function() {
        return _wrappedHandler.apply(this, arguments);
    };
};
var $e9622570e37acee2$export$2e2bcd8739ae039 = $e9622570e37acee2$var$callOnce;

});



parcelRegister("4jWiu", function(module, exports) {

$parcel$export(module.exports, "styleProp", function () { return $32562862a2400ef3$export$5d4cd24aaf68552c; });
$parcel$export(module.exports, "stylePropPrefix", function () { return $32562862a2400ef3$export$3dcfa7045287299; });
$parcel$export(module.exports, "normalizeStyleProp", function () { return $32562862a2400ef3$export$84da894514267528; });
/**
 * DevExtreme (esm/core/utils/style.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $lQCfZ = parcelRequire("lQCfZ");

var $k2ifc = parcelRequire("k2ifc");

var $6ntMu = parcelRequire("6ntMu");

var $3yzYM = parcelRequire("3yzYM");
var $32562862a2400ef3$var$jsPrefixes = [
    "",
    "Webkit",
    "Moz",
    "O",
    "Ms"
];
var $32562862a2400ef3$var$cssPrefixes = {
    "": "",
    Webkit: "-webkit-",
    Moz: "-moz-",
    O: "-o-",
    ms: "-ms-"
};
var $32562862a2400ef3$var$getStyles = (0, $k2ifc.default)(function() {
    return (0, $3yzYM.default).createElement("dx").style;
});
var $32562862a2400ef3$var$forEachPrefixes = function(prop, callBack) {
    prop = (0, $lQCfZ.camelize)(prop, true);
    var result;
    for(var i = 0, cssPrefixesCount = $32562862a2400ef3$var$jsPrefixes.length; i < cssPrefixesCount; i++){
        var jsPrefix = $32562862a2400ef3$var$jsPrefixes[i];
        var prefixedProp = jsPrefix + prop;
        var lowerPrefixedProp = (0, $lQCfZ.camelize)(prefixedProp);
        result = callBack(lowerPrefixedProp, jsPrefix);
        if (void 0 === result) result = callBack(prefixedProp, jsPrefix);
        if (void 0 !== result) break;
    }
    return result || "";
};
var $32562862a2400ef3$export$5d4cd24aaf68552c = function(name) {
    if (name in $32562862a2400ef3$var$getStyles()) return name;
    var originalName = name;
    name = name.charAt(0).toUpperCase() + name.substr(1);
    for(var i = 1; i < $32562862a2400ef3$var$jsPrefixes.length; i++){
        var prefixedProp = $32562862a2400ef3$var$jsPrefixes[i].toLowerCase() + name;
        if (prefixedProp in $32562862a2400ef3$var$getStyles()) return prefixedProp;
    }
    return originalName;
};
var $32562862a2400ef3$export$3dcfa7045287299 = function(prop) {
    return $32562862a2400ef3$var$forEachPrefixes(prop, function(specific, jsPrefix) {
        if (specific in $32562862a2400ef3$var$getStyles()) return $32562862a2400ef3$var$cssPrefixes[jsPrefix];
    });
};
var $32562862a2400ef3$var$pxExceptions = [
    "fillOpacity",
    "columnCount",
    "flexGrow",
    "flexShrink",
    "fontWeight",
    "lineHeight",
    "opacity",
    "zIndex",
    "zoom"
];
var $32562862a2400ef3$export$a9c979e9fb50cad5 = function(value) {
    if ((0, $6ntMu.isNumeric)(value)) return value;
    else if ((0, $6ntMu.isString)(value)) return Number(value.replace("px", ""));
    return NaN;
};
var $32562862a2400ef3$export$84da894514267528 = function(prop, value) {
    if ((0, $6ntMu.isNumeric)(value) && -1 === $32562862a2400ef3$var$pxExceptions.indexOf(prop)) value += "px";
    return value;
};
var $32562862a2400ef3$var$setDimensionProperty = function(elements, propertyName, value) {
    if (elements) {
        value = (0, $6ntMu.isNumeric)(value) ? value += "px" : value;
        for(var i = 0; i < elements.length; ++i)elements[i].style[propertyName] = value;
    }
};
var $32562862a2400ef3$export$67f48e0594af05d = function(elements, value) {
    $32562862a2400ef3$var$setDimensionProperty(elements, "width", value);
};
var $32562862a2400ef3$export$3f31360357be44e4 = function(elements, value) {
    $32562862a2400ef3$var$setDimensionProperty(elements, "height", value);
};

});
parcelRegister("lQCfZ", function(module, exports) {

$parcel$export(module.exports, "camelize", function () { return $fe7c2157180fd6b0$export$161d051f5dd25de7; });
$parcel$export(module.exports, "humanize", function () { return $fe7c2157180fd6b0$export$cfb8c2be79648c4; });
/**
 * DevExtreme (esm/core/utils/inflector.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $8OLOW = parcelRequire("8OLOW");
var $fe7c2157180fd6b0$var$_normalize = function(text) {
    if (void 0 === text || null === text) return "";
    return String(text);
};
var $fe7c2157180fd6b0$var$_upperCaseFirst = function(text) {
    return $fe7c2157180fd6b0$var$_normalize(text).charAt(0).toUpperCase() + text.substr(1);
};
var $fe7c2157180fd6b0$var$_chop = function(text) {
    return $fe7c2157180fd6b0$var$_normalize(text).replace(/([a-z\d])([A-Z])/g, "$1 $2").split(/[\s_-]+/);
};
var $fe7c2157180fd6b0$export$7e9152eee80b168f = function(text) {
    return (0, $8OLOW.map)($fe7c2157180fd6b0$var$_chop(text), function(p) {
        return p.toLowerCase();
    }).join("-");
};
var $fe7c2157180fd6b0$export$730f2a930033e8f0 = function(text) {
    return $fe7c2157180fd6b0$export$7e9152eee80b168f(text).replace(/-/g, "_");
};
var $fe7c2157180fd6b0$export$161d051f5dd25de7 = function(text, upperFirst) {
    return (0, $8OLOW.map)($fe7c2157180fd6b0$var$_chop(text), function(p, i) {
        p = p.toLowerCase();
        if (upperFirst || i > 0) p = $fe7c2157180fd6b0$var$_upperCaseFirst(p);
        return p;
    }).join("");
};
var $fe7c2157180fd6b0$export$cfb8c2be79648c4 = function(text) {
    return $fe7c2157180fd6b0$var$_upperCaseFirst($fe7c2157180fd6b0$export$7e9152eee80b168f(text).replace(/-/g, " "));
};
var $fe7c2157180fd6b0$export$29d0dd1cc36cee26 = function(text) {
    return (0, $8OLOW.map)($fe7c2157180fd6b0$var$_chop(text), function(p) {
        return $fe7c2157180fd6b0$var$_upperCaseFirst(p.toLowerCase());
    }).join(" ");
};
var $fe7c2157180fd6b0$var$DIGIT_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
];
var $fe7c2157180fd6b0$export$4f7dda9d0e7975d = function(name) {
    var captionList = [];
    var i;
    var char;
    var isPrevCharNewWord = false;
    var isNewWord = false;
    for(i = 0; i < name.length; i++){
        char = name.charAt(i);
        isNewWord = char === char.toUpperCase() && "-" !== char && ")" !== char && "/" !== char || char in $fe7c2157180fd6b0$var$DIGIT_CHARS;
        if ("_" === char || "." === char) {
            char = " ";
            isNewWord = true;
        } else if (0 === i) {
            char = char.toUpperCase();
            isNewWord = true;
        } else if (!isPrevCharNewWord && isNewWord) {
            if (captionList.length > 0) captionList.push(" ");
        }
        captionList.push(char);
        isPrevCharNewWord = isNewWord;
    }
    return captionList.join("");
};

});


parcelRegister("iE2yv", function(module, exports) {

$parcel$export(module.exports, "getWidth", function () { return $d92df1e655f3d39b$export$3c49c185de0c2bfc; });
$parcel$export(module.exports, "getHeight", function () { return $d92df1e655f3d39b$export$c08559766941f856; });
$parcel$export(module.exports, "getOuterHeight", function () { return $d92df1e655f3d39b$export$3ef1368fc1aa92de; });
$parcel$export(module.exports, "getWindowByElement", function () { return $d92df1e655f3d39b$export$6329ea14cf771439; });
$parcel$export(module.exports, "getOffset", function () { return $d92df1e655f3d39b$export$622cea445a1c5b7d; });
/**
 * DevExtreme (esm/core/utils/size.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $hYatw = parcelRequire("hYatw");

var $3yzYM = parcelRequire("3yzYM");

var $6ntMu = parcelRequire("6ntMu");
var $d92df1e655f3d39b$var$window = (0, $hYatw.getWindow)();
var $d92df1e655f3d39b$var$SPECIAL_HEIGHT_VALUES = [
    "auto",
    "none",
    "inherit",
    "initial"
];
var $d92df1e655f3d39b$var$getSizeByStyles = function(elementStyles, styles) {
    var result = 0;
    styles.forEach(function(style) {
        result += parseFloat(elementStyles[style]) || 0;
    });
    return result;
};
var $d92df1e655f3d39b$export$76eaf8e1f54207aa = function(name, elementStyles) {
    var beforeName = "width" === name ? "Left" : "Top";
    var afterName = "width" === name ? "Right" : "Bottom";
    return {
        padding: $d92df1e655f3d39b$var$getSizeByStyles(elementStyles, [
            "padding" + beforeName,
            "padding" + afterName
        ]),
        border: $d92df1e655f3d39b$var$getSizeByStyles(elementStyles, [
            "border" + beforeName + "Width",
            "border" + afterName + "Width"
        ]),
        margin: $d92df1e655f3d39b$var$getSizeByStyles(elementStyles, [
            "margin" + beforeName,
            "margin" + afterName
        ])
    };
};
var $d92df1e655f3d39b$var$getElementComputedStyle = function(element) {
    var _element$ownerDocumen;
    var view = (null === element || void 0 === element ? void 0 : null === (_element$ownerDocumen = element.ownerDocument) || void 0 === _element$ownerDocumen ? void 0 : _element$ownerDocumen.defaultView) || $d92df1e655f3d39b$var$window;
    return view.getComputedStyle && view.getComputedStyle(element);
};
var $d92df1e655f3d39b$var$getCSSProperty = function(element, styles, name, defaultValue) {
    var _element$style;
    return (null === styles || void 0 === styles ? void 0 : styles[name]) || (null === (_element$style = element.style) || void 0 === _element$style ? void 0 : _element$style[name]) || defaultValue;
};
var $d92df1e655f3d39b$var$boxIndices = {
    content: 0,
    padding: 1,
    border: 2,
    margin: 3,
    "content-box": 0,
    "border-box": 2
};
var $d92df1e655f3d39b$var$dimensionComponents = {
    width: [
        "left",
        "right"
    ],
    height: [
        "top",
        "bottom"
    ]
};
function $d92df1e655f3d39b$var$getComponentThickness(elem, dimension, component, styles) {
    var get = (elem, styles, field)=>parseFloat($d92df1e655f3d39b$var$getCSSProperty(elem, styles, field, "0")) || 0;
    var suffix = "border" === component ? "-width" : "";
    return get(elem, styles, "".concat(component, "-").concat($d92df1e655f3d39b$var$dimensionComponents[dimension][0]).concat(suffix)) + get(elem, styles, "".concat(component, "-").concat($d92df1e655f3d39b$var$dimensionComponents[dimension][1]).concat(suffix));
}
var $d92df1e655f3d39b$export$31b21d0167753bb4 = function(element, dimension, box) {
    var offsetFieldName = "width" === dimension ? "offsetWidth" : "offsetHeight";
    var styles = $d92df1e655f3d39b$var$getElementComputedStyle(element);
    var result = $d92df1e655f3d39b$var$getCSSProperty(element, styles, dimension);
    if ("" === result || "auto" === result) result = element[offsetFieldName];
    result = parseFloat(result) || 0;
    var currentBox = $d92df1e655f3d39b$var$getCSSProperty(element, styles, "boxSizing", "content-box");
    var targetBox = box || currentBox;
    var targetBoxIndex = $d92df1e655f3d39b$var$boxIndices[targetBox];
    var currentBoxIndex = $d92df1e655f3d39b$var$boxIndices[currentBox];
    if (void 0 === targetBoxIndex || void 0 === currentBoxIndex) throw new Error;
    if (currentBoxIndex === targetBoxIndex) return result;
    var coeff = Math.sign(targetBoxIndex - currentBoxIndex);
    var padding = false;
    var border = false;
    var margin = false;
    var scrollThickness = false;
    if (1 === coeff) {
        targetBoxIndex += 1;
        currentBoxIndex += 1;
    }
    for(var boxPart = currentBoxIndex; boxPart !== targetBoxIndex; boxPart += coeff)switch(boxPart){
        case $d92df1e655f3d39b$var$boxIndices.content:
            break;
        case $d92df1e655f3d39b$var$boxIndices.padding:
            padding = coeff * $d92df1e655f3d39b$var$getComponentThickness(element, dimension, "padding", styles);
            break;
        case $d92df1e655f3d39b$var$boxIndices.border:
            border = coeff * $d92df1e655f3d39b$var$getComponentThickness(element, dimension, "border", styles);
            break;
        case $d92df1e655f3d39b$var$boxIndices.margin:
            margin = coeff * $d92df1e655f3d39b$var$getComponentThickness(element, dimension, "margin", styles);
    }
    if (padding || border) {
        var paddingAndBorder = (false === padding ? coeff * $d92df1e655f3d39b$var$getComponentThickness(element, dimension, "padding", styles) : padding) + (false === border ? coeff * $d92df1e655f3d39b$var$getComponentThickness(element, dimension, "border", styles) : border);
        scrollThickness = coeff * Math.max(0, Math.floor(element[offsetFieldName] - result - coeff * paddingAndBorder)) || 0;
    }
    return result + margin + padding + border + scrollThickness;
};
var $d92df1e655f3d39b$var$getContainerHeight = function(container) {
    return (0, $6ntMu.isWindow)(container) ? container.innerHeight : container.offsetHeight;
};
var $d92df1e655f3d39b$export$8b327f0960504387 = function(value, container, element) {
    if (value.indexOf("px") > 0) value = parseInt(value.replace("px", ""));
    else if (value.indexOf("%") > 0) value = parseInt(value.replace("%", "")) * $d92df1e655f3d39b$var$getContainerHeight(container) / 100;
    else if (!isNaN(value)) value = parseInt(value);
    else if (value.indexOf("vh") > 0) value = $d92df1e655f3d39b$var$window.innerHeight / 100 * parseInt(value.replace("vh", ""));
    else if (element && value.indexOf("em") > 0) value = parseFloat(value.replace("em", "")) * parseFloat($d92df1e655f3d39b$var$window.getComputedStyle(element).fontSize);
    return value;
};
var $d92df1e655f3d39b$var$getHeightWithOffset = function(value, offset, container) {
    if (!value) return null;
    if ($d92df1e655f3d39b$var$SPECIAL_HEIGHT_VALUES.indexOf(value) > -1) return offset ? null : value;
    if ((0, $6ntMu.isString)(value)) value = $d92df1e655f3d39b$export$8b327f0960504387(value, container);
    if ((0, $6ntMu.isNumeric)(value)) return Math.max(0, value + offset);
    var operationString = offset < 0 ? " - " : " ";
    return "calc(" + value + operationString + Math.abs(offset) + "px)";
};
var $d92df1e655f3d39b$export$df512663f252527d = function(value, offset, container) {
    var maxHeight = $d92df1e655f3d39b$var$getHeightWithOffset(value, offset, container);
    return null !== maxHeight ? maxHeight : "none";
};
var $d92df1e655f3d39b$export$22d3535472655952 = function(value, offset, container) {
    var minHeight = $d92df1e655f3d39b$var$getHeightWithOffset(value, offset, container);
    return null !== minHeight ? minHeight : 0;
};
var $d92df1e655f3d39b$export$4a1cba5dfaf0ad4b = function(element, withMargins) {
    if (!element) return 0;
    var boxParams = $d92df1e655f3d39b$export$76eaf8e1f54207aa("height", $d92df1e655f3d39b$var$window.getComputedStyle(element));
    return boxParams.padding + boxParams.border + (withMargins ? boxParams.margin : 0);
};
var $d92df1e655f3d39b$export$777feb64bf8da9e0 = function(element) {
    if (element) {
        var boundingClientRect = element.getBoundingClientRect();
        if (boundingClientRect.height) return boundingClientRect.height;
    }
    return 0;
};
var $d92df1e655f3d39b$export$e2307ae795030fd3 = {
    getWidth: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return $d92df1e655f3d39b$var$elementSizeHelper("width", ...args);
    },
    setWidth: function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $d92df1e655f3d39b$var$elementSizeHelper("width", ...args);
    },
    getHeight: function() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return $d92df1e655f3d39b$var$elementSizeHelper("height", ...args);
    },
    setHeight: function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $d92df1e655f3d39b$var$elementSizeHelper("height", ...args);
    },
    getOuterWidth: function() {
        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
        return $d92df1e655f3d39b$var$elementSizeHelper("outerWidth", ...args);
    },
    setOuterWidth: function() {
        for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
        return $d92df1e655f3d39b$var$elementSizeHelper("outerWidth", ...args);
    },
    getOuterHeight: function() {
        for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
        return $d92df1e655f3d39b$var$elementSizeHelper("outerHeight", ...args);
    },
    setOuterHeight: function() {
        for(var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)args[_key8] = arguments[_key8];
        return $d92df1e655f3d39b$var$elementSizeHelper("outerHeight", ...args);
    },
    getInnerWidth: function() {
        for(var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++)args[_key9] = arguments[_key9];
        return $d92df1e655f3d39b$var$elementSizeHelper("innerWidth", ...args);
    },
    setInnerWidth: function() {
        for(var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++)args[_key10] = arguments[_key10];
        return $d92df1e655f3d39b$var$elementSizeHelper("innerWidth", ...args);
    },
    getInnerHeight: function() {
        for(var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++)args[_key11] = arguments[_key11];
        return $d92df1e655f3d39b$var$elementSizeHelper("innerHeight", ...args);
    },
    setInnerHeight: function() {
        for(var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++)args[_key12] = arguments[_key12];
        return $d92df1e655f3d39b$var$elementSizeHelper("innerHeight", ...args);
    }
};
function $d92df1e655f3d39b$var$elementSizeHelper(sizeProperty, el, value) {
    return 2 === arguments.length ? $d92df1e655f3d39b$var$elementSize(el, sizeProperty) : $d92df1e655f3d39b$var$elementSize(el, sizeProperty, value);
}
var $d92df1e655f3d39b$export$3c49c185de0c2bfc = (el)=>$d92df1e655f3d39b$export$e2307ae795030fd3.getWidth(el);
var $d92df1e655f3d39b$export$67f48e0594af05d = (el, value)=>$d92df1e655f3d39b$export$e2307ae795030fd3.setWidth(el, value);
var $d92df1e655f3d39b$export$c08559766941f856 = (el)=>$d92df1e655f3d39b$export$e2307ae795030fd3.getHeight(el);
var $d92df1e655f3d39b$export$3f31360357be44e4 = (el, value)=>$d92df1e655f3d39b$export$e2307ae795030fd3.setHeight(el, value);
var $d92df1e655f3d39b$export$18e9b0709c75d4c5 = (el, includeMargin)=>$d92df1e655f3d39b$export$e2307ae795030fd3.getOuterWidth(el, includeMargin || false);
var $d92df1e655f3d39b$export$786e5ec33f8fd7aa = (el, value)=>$d92df1e655f3d39b$export$e2307ae795030fd3.setOuterWidth(el, value);
var $d92df1e655f3d39b$export$3ef1368fc1aa92de = (el, includeMargin)=>$d92df1e655f3d39b$export$e2307ae795030fd3.getOuterHeight(el, includeMargin || false);
var $d92df1e655f3d39b$export$67fae5472315c46c = (el, value)=>$d92df1e655f3d39b$export$e2307ae795030fd3.setOuterHeight(el, value);
var $d92df1e655f3d39b$export$9674436b308e1474 = (el)=>$d92df1e655f3d39b$export$e2307ae795030fd3.getInnerWidth(el);
var $d92df1e655f3d39b$export$9de6c9926dca35b4 = (el, value)=>$d92df1e655f3d39b$export$e2307ae795030fd3.setInnerWidth(el, value);
var $d92df1e655f3d39b$export$5a2da8cd883b1f88 = (el)=>$d92df1e655f3d39b$export$e2307ae795030fd3.getInnerHeight(el);
var $d92df1e655f3d39b$export$8cb7a8f7588fda2c = (el, value)=>$d92df1e655f3d39b$export$e2307ae795030fd3.setInnerHeight(el, value);
var $d92df1e655f3d39b$var$elementSize = function elementSize(el, sizeProperty, value) {
    var partialName = sizeProperty.toLowerCase().indexOf("width") >= 0 ? "Width" : "Height";
    var propName = partialName.toLowerCase();
    var isOuter = 0 === sizeProperty.indexOf("outer");
    var isInner = 0 === sizeProperty.indexOf("inner");
    var isGetter = 2 === arguments.length || "boolean" === typeof value;
    if ((0, $6ntMu.isRenderer)(el)) {
        if (el.length > 1 && !isGetter) {
            for(var i = 0; i < el.length; i++)elementSize(el[i], sizeProperty, value);
            return;
        }
        el = el[0];
    }
    if (!el) return;
    if ((0, $6ntMu.isWindow)(el)) return isOuter ? el["inner" + partialName] : (0, $3yzYM.default).getDocumentElement()["client" + partialName];
    if ((0, $3yzYM.default).isDocument(el)) {
        var documentElement = (0, $3yzYM.default).getDocumentElement();
        var body = (0, $3yzYM.default).getBody();
        return Math.max(body["scroll" + partialName], body["offset" + partialName], documentElement["scroll" + partialName], documentElement["offset" + partialName], documentElement["client" + partialName]);
    }
    if (isGetter) {
        var box = "content";
        if (isOuter) box = value ? "margin" : "border";
        if (isInner) box = "padding";
        return $d92df1e655f3d39b$export$31b21d0167753bb4(el, propName, box);
    }
    if ((0, $6ntMu.isNumeric)(value)) {
        var elementStyles = $d92df1e655f3d39b$var$getElementComputedStyle(el);
        var sizeAdjustment = $d92df1e655f3d39b$export$76eaf8e1f54207aa(propName, elementStyles);
        var isBorderBox = "border-box" === elementStyles.boxSizing;
        value = Number(value);
        if (isOuter) value -= isBorderBox ? 0 : sizeAdjustment.border + sizeAdjustment.padding;
        else if (isInner) value += isBorderBox ? sizeAdjustment.border : -sizeAdjustment.padding;
        else if (isBorderBox) value += sizeAdjustment.border + sizeAdjustment.padding;
    }
    value += (0, $6ntMu.isNumeric)(value) ? "px" : "";
    (0, $3yzYM.default).setStyle(el, propName, value);
    return null;
};
var $d92df1e655f3d39b$export$6329ea14cf771439 = (el)=>(0, $6ntMu.isWindow)(el) ? el : el.defaultView;
var $d92df1e655f3d39b$export$622cea445a1c5b7d = (el)=>{
    if (!el.getClientRects().length) return {
        top: 0,
        left: 0
    };
    var rect = el.getBoundingClientRect();
    var win = $d92df1e655f3d39b$export$6329ea14cf771439(el.ownerDocument);
    var docElem = el.ownerDocument.documentElement;
    return {
        top: rect.top + win.pageYOffset - docElem.clientTop,
        left: rect.left + win.pageXOffset - docElem.clientLeft
    };
};

});

parcelRegister("XxsMu", function(module, exports) {

$parcel$export(module.exports, "parseHTML", function () { return $0b2f77e64eb253b0$export$8a49393be2d55148; });
$parcel$export(module.exports, "isTablePart", function () { return $0b2f77e64eb253b0$export$5ae0fa1c625cce34; });
/**
 * DevExtreme (esm/core/utils/html_parser.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $3yzYM = parcelRequire("3yzYM");
var $0b2f77e64eb253b0$var$isTagName = /<([a-z][^/\0>\x20\t\r\n\f]+)/i;
var $0b2f77e64eb253b0$var$tagWrappers = {
    default: {
        tagsCount: 0,
        startTags: "",
        endTags: ""
    },
    thead: {
        tagsCount: 1,
        startTags: "<table>",
        endTags: "</table>"
    },
    td: {
        tagsCount: 3,
        startTags: "<table><tbody><tr>",
        endTags: "</tr></tbody></table>"
    },
    col: {
        tagsCount: 2,
        startTags: "<table><colgroup>",
        endTags: "</colgroup></table>"
    },
    tr: {
        tagsCount: 2,
        startTags: "<table><tbody>",
        endTags: "</tbody></table>"
    }
};
$0b2f77e64eb253b0$var$tagWrappers.tbody = $0b2f77e64eb253b0$var$tagWrappers.colgroup = $0b2f77e64eb253b0$var$tagWrappers.caption = $0b2f77e64eb253b0$var$tagWrappers.tfoot = $0b2f77e64eb253b0$var$tagWrappers.thead;
$0b2f77e64eb253b0$var$tagWrappers.th = $0b2f77e64eb253b0$var$tagWrappers.td;
var $0b2f77e64eb253b0$export$8a49393be2d55148 = function(html) {
    if ("string" !== typeof html) return null;
    var fragment = (0, $3yzYM.default).createDocumentFragment();
    var container = fragment.appendChild((0, $3yzYM.default).createElement("div"));
    var tags = $0b2f77e64eb253b0$var$isTagName.exec(html);
    var firstRootTag = tags && tags[1].toLowerCase();
    var tagWrapper = $0b2f77e64eb253b0$var$tagWrappers[firstRootTag] || $0b2f77e64eb253b0$var$tagWrappers.default;
    container.innerHTML = tagWrapper.startTags + html + tagWrapper.endTags;
    for(var i = 0; i < tagWrapper.tagsCount; i++)container = container.lastChild;
    return [
        ...container.childNodes
    ];
};
var $0b2f77e64eb253b0$export$5ae0fa1c625cce34 = function(html) {
    var tags = $0b2f77e64eb253b0$var$isTagName.exec(html);
    return tags && tags[1] in $0b2f77e64eb253b0$var$tagWrappers;
};

});



parcelRegister("l5tfV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5a0c2388c387698$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/component_registrator_callbacks.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $e1oup = parcelRequire("e1oup");
var $f5a0c2388c387698$export$2e2bcd8739ae039 = new (0, $e1oup.default);

});

parcelRegister("8irnY", function(module, exports) {

$parcel$export(module.exports, "name", function () { return $60a53f5ff8fbac67$export$a8ff84c12d48cfa6; });
$parcel$export(module.exports, "attachInstanceToElement", function () { return $60a53f5ff8fbac67$export$9c372d83124e863f; });
$parcel$export(module.exports, "getInstanceByElement", function () { return $60a53f5ff8fbac67$export$d13f206d638c14c; });
/**
 * DevExtreme (esm/core/utils/public_component.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $jc4XS = parcelRequire("jc4XS");

var $60GuF = parcelRequire("60GuF");

var $6ntMu = parcelRequire("6ntMu");

var $1qDFW = parcelRequire("1qDFW");
var $60a53f5ff8fbac67$var$COMPONENT_NAMES_DATA_KEY = "dxComponents";
var $60a53f5ff8fbac67$var$ANONYMOUS_COMPONENT_DATA_KEY = "dxPrivateComponent";
var $60a53f5ff8fbac67$var$componentNames = new WeakMap;
var $60a53f5ff8fbac67$var$nextAnonymousComponent = 0;
var $60a53f5ff8fbac67$export$a8ff84c12d48cfa6 = function(componentClass, newName) {
    if ((0, $6ntMu.isDefined)(newName)) {
        $60a53f5ff8fbac67$var$componentNames.set(componentClass, newName);
        return;
    }
    if (!$60a53f5ff8fbac67$var$componentNames.has(componentClass)) {
        var generatedName = $60a53f5ff8fbac67$var$ANONYMOUS_COMPONENT_DATA_KEY + $60a53f5ff8fbac67$var$nextAnonymousComponent++;
        $60a53f5ff8fbac67$var$componentNames.set(componentClass, generatedName);
        return generatedName;
    }
    return $60a53f5ff8fbac67$var$componentNames.get(componentClass);
};
function $60a53f5ff8fbac67$export$9c372d83124e863f($element, componentInstance, disposeFn) {
    var data = (0, $jc4XS.data)($element.get(0));
    var name = $60a53f5ff8fbac67$export$a8ff84c12d48cfa6(componentInstance.constructor);
    data[name] = componentInstance;
    if (disposeFn) (0, $60GuF.default).one($element, (0, $1qDFW.removeEvent), function() {
        disposeFn.call(componentInstance);
    });
    if (!data[$60a53f5ff8fbac67$var$COMPONENT_NAMES_DATA_KEY]) data[$60a53f5ff8fbac67$var$COMPONENT_NAMES_DATA_KEY] = [];
    data[$60a53f5ff8fbac67$var$COMPONENT_NAMES_DATA_KEY].push(name);
}
function $60a53f5ff8fbac67$export$d13f206d638c14c($element, componentClass) {
    var name = $60a53f5ff8fbac67$export$a8ff84c12d48cfa6(componentClass);
    return (0, $jc4XS.data)($element.get(0), name);
}

});
parcelRegister("1qDFW", function(module, exports) {

$parcel$export(module.exports, "removeEvent", function () { return $10a6fedfa751da4d$export$b5ed465d99f3f1c3; });
/**
 * DevExtreme (esm/events/remove.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $jc4XS = parcelRequire("jc4XS");

var $60GuF = parcelRequire("60GuF");

var $jxLje = parcelRequire("jxLje");
var $10a6fedfa751da4d$export$b5ed465d99f3f1c3 = "dxremove";
var $10a6fedfa751da4d$var$eventPropName = "dxRemoveEvent";
(0, $jc4XS.beforeCleanData)(function(elements) {
    elements = [].slice.call(elements);
    for(var i = 0; i < elements.length; i++){
        var $element = (0, $2vlX8.default)(elements[i]);
        if ($element.prop($10a6fedfa751da4d$var$eventPropName)) {
            $element[0][$10a6fedfa751da4d$var$eventPropName] = null;
            (0, $60GuF.default).triggerHandler($element, $10a6fedfa751da4d$export$b5ed465d99f3f1c3);
        }
    }
});
(0, $jxLje.default)($10a6fedfa751da4d$export$b5ed465d99f3f1c3, {
    noBubble: true,
    setup: function(element) {
        (0, $2vlX8.default)(element).prop($10a6fedfa751da4d$var$eventPropName, true);
    }
});

});
parcelRegister("jxLje", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3a5cc03da512c67$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/events/core/event_registrator.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $8OLOW = parcelRequire("8OLOW");

var $gsTRc = parcelRequire("gsTRc");
var $e3a5cc03da512c67$var$registerEvent = function(name, eventObject) {
    var strategy = {};
    if ("noBubble" in eventObject) strategy.noBubble = eventObject.noBubble;
    if ("bindType" in eventObject) strategy.bindType = eventObject.bindType;
    if ("delegateType" in eventObject) strategy.delegateType = eventObject.delegateType;
    (0, $8OLOW.each)([
        "setup",
        "teardown",
        "add",
        "remove",
        "trigger",
        "handle",
        "_default",
        "dispose"
    ], function(_, methodName) {
        if (!eventObject[methodName]) return;
        strategy[methodName] = function() {
            var args = [].slice.call(arguments);
            args.unshift(this);
            return eventObject[methodName].apply(eventObject, args);
        };
    });
    (0, $gsTRc.default).fire(name, strategy);
};
$e3a5cc03da512c67$var$registerEvent.callbacks = (0, $gsTRc.default);
var $e3a5cc03da512c67$export$2e2bcd8739ae039 = $e3a5cc03da512c67$var$registerEvent;

});




parcelRegister("8LJ26", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6625a520e70fdbdf$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/components/consts.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $6625a520e70fdbdf$export$2e2bcd8739ae039 = {
    events: {
        mouseover: "mouseover",
        mouseout: "mouseout",
        mousemove: "mousemove",
        touchstart: "touchstart",
        touchmove: "touchmove",
        touchend: "touchend",
        mousedown: "mousedown",
        mouseup: "mouseup",
        click: "click",
        selectSeries: "selectseries",
        deselectSeries: "deselectseries",
        selectPoint: "selectpoint",
        deselectPoint: "deselectpoint",
        showPointTooltip: "showpointtooltip",
        hidePointTooltip: "hidepointtooltip"
    },
    states: {
        hover: "hover",
        normal: "normal",
        selection: "selection",
        normalMark: 0,
        hoverMark: 1,
        selectedMark: 2,
        applyHover: "applyHover",
        applySelected: "applySelected",
        resetItem: "resetItem"
    },
    radialLabelIndent: 30,
    pieLabelSpacing: 10,
    pieSeriesSpacing: 4
};

});

parcelRegister("cYTj1", function(module, exports) {

$parcel$export(module.exports, "plugins", function () { return $9735fd3669385d1c$export$8b3ca321c77fdea6; });
/**
 * DevExtreme (esm/viz/core/annotations.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $3yzYM = parcelRequire("3yzYM");

var $6ntMu = parcelRequire("6ntMu");

var $6NEbp = parcelRequire("6NEbp");

var $2oTOp = parcelRequire("2oTOp");

var $dw9tZ = parcelRequire("dw9tZ");

var $k8jJ6 = parcelRequire("k8jJ6");

var $cgnQR = parcelRequire("cgnQR");

var $bTgwK = parcelRequire("bTgwK");

var $bcOMe = parcelRequire("bcOMe");

var $60GuF = parcelRequire("60GuF");
var $9735fd3669385d1c$var$getDocument = (0, $3yzYM.default).getDocument;
var $9735fd3669385d1c$var$EVENT_NS = "annotations";
var $9735fd3669385d1c$var$DOT_EVENT_NS = "." + $9735fd3669385d1c$var$EVENT_NS;
var $9735fd3669385d1c$var$POINTER_ACTION = (0, $bcOMe.addNamespace)([
    (0, $cgnQR.default).down,
    (0, $cgnQR.default).move
], $9735fd3669385d1c$var$EVENT_NS);
var $9735fd3669385d1c$var$POINTER_UP_EVENT_NAME = (0, $bcOMe.addNamespace)((0, $cgnQR.default).up, $9735fd3669385d1c$var$EVENT_NS);
var $9735fd3669385d1c$var$DRAG_START_EVENT_NAME = (0, $bTgwK.start) + $9735fd3669385d1c$var$DOT_EVENT_NS;
var $9735fd3669385d1c$var$DRAG_EVENT_NAME = (0, $bTgwK.move) + $9735fd3669385d1c$var$DOT_EVENT_NS;
var $9735fd3669385d1c$var$DRAG_END_EVENT_NAME = (0, $bTgwK.end) + $9735fd3669385d1c$var$DOT_EVENT_NS;
function $9735fd3669385d1c$var$coreAnnotation(options, contentTemplate) {
    return {
        draw: function(widget, group) {
            var annotationGroup = widget._renderer.g().append(group).css((0, $dw9tZ.patchFontOptions)(options.font));
            if (this.plaque) this.plaque.clear();
            this.plaque = new (0, $k8jJ6.Plaque)((0, $2oTOp.extend)(true, {}, options, {
                cornerRadius: (options.border || {}).cornerRadius
            }), widget, annotationGroup, contentTemplate, widget._isAnnotationBounded(options));
            this.plaque.draw(widget._getAnnotationCoords(this));
            if (options.allowDragging) annotationGroup.on($9735fd3669385d1c$var$DRAG_START_EVENT_NAME, {
                immediate: true
            }, (e)=>{
                this._dragOffsetX = this.plaque.x - e.pageX;
                this._dragOffsetY = this.plaque.y - e.pageY;
            }).on($9735fd3669385d1c$var$DRAG_EVENT_NAME, (e)=>{
                this.plaque.move(e.pageX + this._dragOffsetX, e.pageY + this._dragOffsetY);
            }).on($9735fd3669385d1c$var$DRAG_END_EVENT_NAME, (e)=>{
                this.offsetX = (this.offsetX || 0) + e.offset.x;
                this.offsetY = (this.offsetY || 0) + e.offset.y;
            });
        },
        hitTest (x, y) {
            return this.plaque.hitTest(x, y);
        },
        showTooltip (tooltip, _ref) {
            var { x: x, y: y } = _ref;
            var that = this;
            var options = that.options;
            if (tooltip.annotation !== that) {
                tooltip.setTemplate(options.tooltipTemplate);
                var callback = (result)=>{
                    result && (tooltip.annotation = that);
                };
                callback(tooltip.show(options, {
                    x: x,
                    y: y
                }, {
                    target: options
                }, options.customizeTooltip, callback));
            } else if (!tooltip.isCursorOnTooltip(x, y)) tooltip.move(x, y);
        }
    };
}
function $9735fd3669385d1c$var$getTemplateFunction(options, widget) {
    var template;
    if ("text" === options.type) template = function(item, groupElement) {
        var text = widget._renderer.text(item.text).attr({
            class: item.cssClass
        }).append({
            element: groupElement
        });
        if (item.width > 0 || item.height > 0) text.setMaxSize(item.width, item.height, {
            wordWrap: item.wordWrap,
            textOverflow: item.textOverflow
        });
    };
    else if ("image" === options.type) template = function(item, groupElement) {
        var { width: width, height: height, url: url, location: location } = item.image || {};
        var { width: outerWidth, height: outerHeight } = item;
        var imageWidth = outerWidth > 0 ? Math.min(width, outerWidth) : width;
        var imageHeight = outerHeight > 0 ? Math.min(height, outerHeight) : height;
        widget._renderer.image(0, 0, imageWidth, imageHeight, url, location || "center").append({
            element: groupElement
        });
    };
    else if ("custom" === options.type) template = options.template;
    return template;
}
function $9735fd3669385d1c$var$getImageObject(image) {
    return "string" === typeof image ? {
        url: image
    } : image;
}
var $9735fd3669385d1c$export$dd4a4889e34a66f1 = function(widget, items) {
    var commonAnnotationSettings = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    var customizeAnnotation = arguments.length > 3 ? arguments[3] : void 0;
    var pullOptions = arguments.length > 4 ? arguments[4] : void 0;
    var commonImageOptions = $9735fd3669385d1c$var$getImageObject(commonAnnotationSettings.image);
    return items.reduce((arr, item)=>{
        var currentImageOptions = $9735fd3669385d1c$var$getImageObject(item.image);
        var customizedItem = (0, $6ntMu.isFunction)(customizeAnnotation) ? customizeAnnotation(item) : {};
        if (customizedItem) customizedItem.image = $9735fd3669385d1c$var$getImageObject(customizedItem.image);
        var options = (0, $2oTOp.extend)(true, {}, commonAnnotationSettings, item, {
            image: commonImageOptions
        }, {
            image: currentImageOptions
        }, customizedItem);
        var templateFunction = $9735fd3669385d1c$var$getTemplateFunction(options, widget);
        var annotation = templateFunction && (0, $2oTOp.extend)(true, pullOptions(options), $9735fd3669385d1c$var$coreAnnotation(options, widget._getTemplate(templateFunction)));
        annotation && arr.push(annotation);
        return arr;
    }, []);
};
var $9735fd3669385d1c$var$chartPlugin = {
    name: "annotations_chart",
    init () {},
    dispose () {},
    members: {
        _getAnnotationCoords (annotation) {
            var _axis, _axis2;
            var coords = {
                offsetX: annotation.offsetX,
                offsetY: annotation.offsetY
            };
            var argCoordName = this._options.silent("rotated") ? "y" : "x";
            var valCoordName = this._options.silent("rotated") ? "x" : "y";
            var argAxis = this.getArgumentAxis();
            var argument = argAxis.validateUnit(annotation.argument);
            var axis = this.getValueAxis(annotation.axis);
            var series;
            var pane = null === (_axis = axis) || void 0 === _axis ? void 0 : _axis.pane;
            if (annotation.series) {
                var _series;
                series = this.series.filter((s)=>s.name === annotation.series)[0];
                axis = null === (_series = series) || void 0 === _series ? void 0 : _series.getValueAxis();
                (0, $6ntMu.isDefined)(axis) && (pane = axis.pane);
            }
            if ((0, $6ntMu.isDefined)(argument)) {
                if (series) {
                    var center = series.getPointCenterByArg(argument);
                    center && (coords[argCoordName] = center[argCoordName]);
                } else coords[argCoordName] = argAxis.getTranslator().translate(argument);
                !(0, $6ntMu.isDefined)(pane) && (pane = argAxis.pane);
            }
            var value = null === (_axis2 = axis) || void 0 === _axis2 ? void 0 : _axis2.validateUnit(annotation.value);
            if ((0, $6ntMu.isDefined)(value)) {
                var _axis3;
                coords[valCoordName] = null === (_axis3 = axis) || void 0 === _axis3 ? void 0 : _axis3.getTranslator().translate(value);
                !(0, $6ntMu.isDefined)(pane) && (0, $6ntMu.isDefined)(axis) && (pane = axis.pane);
            }
            coords.canvas = this._getCanvasForPane(pane);
            if ((0, $6ntMu.isDefined)(coords[argCoordName]) && !(0, $6ntMu.isDefined)(value)) {
                var _series2;
                if (!(0, $6ntMu.isDefined)(axis) && !(0, $6ntMu.isDefined)(series)) coords[valCoordName] = argAxis.getAxisPosition();
                else if ((0, $6ntMu.isDefined)(axis) && !(0, $6ntMu.isDefined)(series)) coords[valCoordName] = this._argumentAxes.filter((a)=>a.pane === axis.pane)[0].getAxisPosition();
                else if (null !== (_series2 = series) && void 0 !== _series2 && _series2.checkSeriesViewportCoord(argAxis, coords[argCoordName])) coords[valCoordName] = series.getSeriesPairCoord(coords[argCoordName], true);
            }
            if (!(0, $6ntMu.isDefined)(argument) && (0, $6ntMu.isDefined)(coords[valCoordName])) {
                if ((0, $6ntMu.isDefined)(axis) && !(0, $6ntMu.isDefined)(series)) coords[argCoordName] = axis.getAxisPosition();
                else if ((0, $6ntMu.isDefined)(series)) {
                    if (series.checkSeriesViewportCoord(axis, coords[valCoordName])) coords[argCoordName] = series.getSeriesPairCoord(coords[valCoordName], false);
                }
            }
            return coords;
        },
        _annotationsPointerEventHandler (event) {
            if (this._disposed) return;
            var originalEvent = event.originalEvent || {};
            var touch = originalEvent.touches && originalEvent.touches[0] || {};
            var rootOffset = this._renderer.getRootOffset();
            var coords = {
                x: touch.pageX || originalEvent.pageX || event.pageX,
                y: touch.pageY || originalEvent.pageY || event.pageY
            };
            var annotation = this._annotations.items.filter((a)=>a.hitTest(coords.x - rootOffset.left, coords.y - rootOffset.top))[0];
            if (!annotation || !annotation.options.tooltipEnabled) {
                this._annotations.hideTooltip();
                return;
            }
            this._clear();
            if (annotation.options.allowDragging && event.type === (0, $cgnQR.default).down) this._annotations._hideToolTipForDrag = true;
            if (!this._annotations._hideToolTipForDrag) {
                annotation.showTooltip(this._annotations.tooltip, coords);
                event.stopPropagation();
            }
        },
        _isAnnotationBounded: (options)=>(0, $6ntMu.isDefined)(options.value) || (0, $6ntMu.isDefined)(options.argument),
        _pullOptions: (options)=>({
                type: options.type,
                name: options.name,
                x: options.x,
                y: options.y,
                value: options.value,
                argument: options.argument,
                axis: options.axis,
                series: options.series,
                options: options,
                offsetX: options.offsetX,
                offsetY: options.offsetY
            }),
        _forceAnnotationRender () {
            this._change([
                "FORCE_RENDER"
            ]);
        },
        _clear () {
            this.hideTooltip();
            this.clearHover();
        }
    }
};
var $9735fd3669385d1c$var$polarChartPlugin = {
    name: "annotations_polar_chart",
    init () {},
    dispose () {},
    members: {
        _getAnnotationCoords (annotation) {
            var coords = {
                offsetX: annotation.offsetX,
                offsetY: annotation.offsetY,
                canvas: this._calcCanvas()
            };
            var argAxis = this.getArgumentAxis();
            var argument = argAxis.validateUnit(annotation.argument);
            var value = this.getValueAxis().validateUnit(annotation.value);
            var radius = annotation.radius;
            var angle = annotation.angle;
            var pointCoords;
            var series;
            if (annotation.series) series = this.series.filter((s)=>s.name === annotation.series)[0];
            (0, $2oTOp.extend)(true, coords, this.getXYFromPolar(angle, radius, argument, value));
            if ((0, $6ntMu.isDefined)(series)) {
                if ((0, $6ntMu.isDefined)(coords.angle) && !(0, $6ntMu.isDefined)(value) && !(0, $6ntMu.isDefined)(radius)) {
                    if (!(0, $6ntMu.isDefined)(argument)) argument = argAxis.getTranslator().from(isFinite(angle) ? this.getActualAngle(angle) : coords.angle);
                    pointCoords = series.getSeriesPairCoord({
                        argument: argument,
                        angle: -coords.angle
                    }, true);
                } else if ((0, $6ntMu.isDefined)(coords.radius) && !(0, $6ntMu.isDefined)(argument) && !(0, $6ntMu.isDefined)(angle)) pointCoords = series.getSeriesPairCoord({
                    radius: coords.radius
                }, false);
                if ((0, $6ntMu.isDefined)(pointCoords)) {
                    coords.x = pointCoords.x;
                    coords.y = pointCoords.y;
                }
            }
            if (annotation.series && !(0, $6ntMu.isDefined)(pointCoords)) coords.x = coords.y = void 0;
            return coords;
        },
        _annotationsPointerEventHandler: $9735fd3669385d1c$var$chartPlugin.members._annotationsPointerEventHandler,
        _isAnnotationBounded: $9735fd3669385d1c$var$chartPlugin.members._isAnnotationBounded,
        _pullOptions (options) {
            var polarOptions = (0, $2oTOp.extend)({}, {
                radius: options.radius,
                angle: options.angle
            }, $9735fd3669385d1c$var$chartPlugin.members._pullOptions(options));
            delete polarOptions.axis;
            return polarOptions;
        },
        _forceAnnotationRender: $9735fd3669385d1c$var$chartPlugin.members._forceAnnotationRender,
        _clear: $9735fd3669385d1c$var$chartPlugin.members._clear
    }
};
var $9735fd3669385d1c$var$vectorMapPlugin = {
    name: "annotations_vector_map",
    init () {},
    dispose () {
        this._annotations._offTracker();
        this._annotations._offTracker = null;
    },
    members: {
        _getAnnotationCoords (annotation) {
            var coords = {
                offsetX: annotation.offsetX,
                offsetY: annotation.offsetY
            };
            coords.canvas = this._projection.getCanvas();
            if (annotation.coordinates) {
                var data = this._projection.toScreenPoint(annotation.coordinates);
                coords.x = data[0];
                coords.y = data[1];
            }
            return coords;
        },
        _annotationsPointerEventHandler: $9735fd3669385d1c$var$chartPlugin.members._annotationsPointerEventHandler,
        _isAnnotationBounded: (options)=>(0, $6ntMu.isDefined)(options.coordinates),
        _pullOptions (options) {
            var vectorMapOptions = (0, $2oTOp.extend)({}, {
                coordinates: options.coordinates
            }, $9735fd3669385d1c$var$chartPlugin.members._pullOptions(options));
            delete vectorMapOptions.axis;
            delete vectorMapOptions.series;
            delete vectorMapOptions.argument;
            delete vectorMapOptions.value;
            return vectorMapOptions;
        },
        _forceAnnotationRender () {
            this._change([
                "EXTRA_ELEMENTS"
            ]);
        },
        _getAnnotationStyles: ()=>({
                "text-anchor": "start"
            }),
        _clear () {}
    },
    extenders: {
        _prepareExtraElements () {
            var that = this;
            var renderElements = ()=>{
                that._renderExtraElements();
            };
            that._annotations._offTracker = that._tracker.on({
                move: renderElements,
                zoom: renderElements,
                end: renderElements
            });
        }
    }
};
var $9735fd3669385d1c$var$pieChartPlugin = {
    name: "annotations_pie_chart",
    init () {},
    dispose () {},
    members: {
        _getAnnotationCoords (annotation) {
            var series;
            var coords = {
                offsetX: annotation.offsetX,
                offsetY: annotation.offsetY,
                canvas: this._canvas
            };
            if (annotation.argument) {
                if (annotation.series) series = this.getSeriesByName(annotation.series);
                else series = this.series[0];
                var argument = series.getPointsByArg(annotation.argument)[0];
                var { x: x, y: y } = argument.getAnnotationCoords(annotation.location);
                coords.x = x;
                coords.y = y;
            }
            return coords;
        },
        _isAnnotationBounded: (options)=>options.argument,
        _annotationsPointerEventHandler: $9735fd3669385d1c$var$chartPlugin.members._annotationsPointerEventHandler,
        _pullOptions (options) {
            var pieChartOptions = (0, $2oTOp.extend)({}, {
                location: options.location
            }, $9735fd3669385d1c$var$chartPlugin.members._pullOptions(options));
            delete pieChartOptions.axis;
            return pieChartOptions;
        },
        _clear: $9735fd3669385d1c$var$chartPlugin.members._clear,
        _forceAnnotationRender: $9735fd3669385d1c$var$chartPlugin.members._forceAnnotationRender
    }
};
var $9735fd3669385d1c$var$corePlugin = {
    name: "annotations_core",
    init () {
        this._annotations = {
            items: [],
            _hideToolTipForDrag: false,
            tooltip: new (0, $6NEbp.Tooltip)({
                cssClass: "".concat(this._rootClassPrefix, "-annotation-tooltip"),
                eventTrigger: this._eventTrigger,
                widgetRoot: this.element(),
                widget: this
            }),
            hideTooltip () {
                this.tooltip.annotation = null;
                this.tooltip.hide();
            },
            clearItems () {
                this.items.forEach((i)=>i.plaque.clear());
                this.items = [];
            }
        };
        this._annotations.tooltip.setRendererOptions(this._getRendererOptions());
    },
    dispose () {
        this._annotationsGroup.linkRemove().linkOff();
        (0, $60GuF.default).off($9735fd3669385d1c$var$getDocument(), $9735fd3669385d1c$var$DOT_EVENT_NS);
        this._annotationsGroup.off($9735fd3669385d1c$var$DOT_EVENT_NS);
        this._annotations.tooltip && this._annotations.tooltip.dispose();
    },
    extenders: {
        _createHtmlStructure () {
            this._annotationsGroup = this._renderer.g().attr({
                class: "".concat(this._rootClassPrefix, "-annotations")
            }).css(this._getAnnotationStyles()).linkOn(this._renderer.root, "annotations").linkAppend();
            (0, $60GuF.default).on($9735fd3669385d1c$var$getDocument(), $9735fd3669385d1c$var$POINTER_ACTION, (e)=>{
                if (this._disposed) return;
                if (!this._annotations.tooltip.isCursorOnTooltip(e.pageX, e.pageY)) this._annotations.hideTooltip();
            });
            (0, $60GuF.default).on($9735fd3669385d1c$var$getDocument(), $9735fd3669385d1c$var$POINTER_UP_EVENT_NAME, (event)=>{
                this._annotations._hideToolTipForDrag = false;
                this._annotationsPointerEventHandler(event);
            });
            this._annotationsGroup.on($9735fd3669385d1c$var$POINTER_ACTION, this._annotationsPointerEventHandler.bind(this));
        },
        _renderExtraElements () {
            this._annotationsGroup.clear();
            this._annotations.items.forEach((item)=>item.draw(this, this._annotationsGroup));
        },
        _stopCurrentHandling () {
            this._annotations.hideTooltip();
        }
    },
    members: {
        _buildAnnotations () {
            this._annotations.clearItems();
            var items = this._getOption("annotations", true);
            if (!(null !== items && void 0 !== items && items.length)) return;
            this._annotations.items = $9735fd3669385d1c$export$dd4a4889e34a66f1(this, items, this._getOption("commonAnnotationSettings"), this._getOption("customizeAnnotation", true), this._pullOptions);
        },
        _setAnnotationTooltipOptions () {
            var tooltipOptions = (0, $2oTOp.extend)({}, this._getOption("tooltip"));
            tooltipOptions.contentTemplate = tooltipOptions.customizeTooltip = void 0;
            this._annotations.tooltip.update(tooltipOptions);
        },
        _getAnnotationCoords: ()=>({}),
        _pullOptions: ()=>({}),
        _getAnnotationStyles: ()=>({})
    },
    customize (constructor) {
        constructor.addChange({
            code: "ANNOTATIONITEMS",
            handler () {
                this._requestChange([
                    "ANNOTATIONS"
                ]);
            },
            isOptionChange: true,
            option: "annotations"
        });
        constructor.addChange({
            code: "ANNOTATIONSSETTINGS",
            handler () {
                this._requestChange([
                    "ANNOTATIONS"
                ]);
            },
            isOptionChange: true,
            option: "commonAnnotationSettings"
        });
        constructor.addChange({
            code: "ANNOTATIONS",
            handler () {
                this._buildAnnotations();
                this._setAnnotationTooltipOptions();
                this._forceAnnotationRender();
            },
            isThemeDependent: true,
            isOptionChange: true
        });
    },
    fontFields: [
        "commonAnnotationSettings.font"
    ]
};
var $9735fd3669385d1c$export$8b3ca321c77fdea6 = {
    core: $9735fd3669385d1c$var$corePlugin,
    chart: $9735fd3669385d1c$var$chartPlugin,
    polarChart: $9735fd3669385d1c$var$polarChartPlugin,
    vectorMap: $9735fd3669385d1c$var$vectorMapPlugin,
    pieChart: $9735fd3669385d1c$var$pieChartPlugin
};

});
parcelRegister("6NEbp", function(module, exports) {

$parcel$export(module.exports, "Tooltip", function () { return $4f367d302298cb9b$export$28c660c63b792dea; });
$parcel$export(module.exports, "plugin", function () { return $4f367d302298cb9b$export$ca524d3785e2543; });
/**
 * DevExtreme (esm/viz/core/tooltip.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $iE2yv = parcelRequire("iE2yv");

var $3yzYM = parcelRequire("3yzYM");

var $hYatw = parcelRequire("hYatw");

var $g3YTP = parcelRequire("g3YTP");

var $lQCfZ = parcelRequire("lQCfZ");

var $2vlX8 = parcelRequire("2vlX8");

var $fORY6 = parcelRequire("fORY6");

var $6ntMu = parcelRequire("6ntMu");

var $2oTOp = parcelRequire("2oTOp");

var $dw9tZ = parcelRequire("dw9tZ");

var $7UWPL = parcelRequire("7UWPL");

var $k8jJ6 = parcelRequire("k8jJ6");
var $4f367d302298cb9b$var$format = (0, $7UWPL.default).format;
var $4f367d302298cb9b$var$mathCeil = Math.ceil;
var $4f367d302298cb9b$var$mathMax = Math.max;
var $4f367d302298cb9b$var$mathMin = Math.min;
var $4f367d302298cb9b$var$window = (0, $hYatw.getWindow)();
var $4f367d302298cb9b$var$DEFAULT_HTML_GROUP_WIDTH = 3e3;
function $4f367d302298cb9b$var$hideElement($element) {
    $element.css({
        left: "-9999px"
    }).detach();
}
function $4f367d302298cb9b$var$getSpecialFormatOptions(options, specialFormat) {
    var result = options;
    switch(specialFormat){
        case "argument":
            result = {
                format: options.argumentFormat
            };
            break;
        case "percent":
            result = {
                format: {
                    type: "percent",
                    precision: options.format && options.format.percentPrecision
                }
            };
    }
    return result;
}
function $4f367d302298cb9b$var$createTextHtml() {
    return (0, $2vlX8.default)("<div>").css({
        position: "relative",
        display: "inline-block",
        padding: 0,
        margin: 0,
        border: "0px solid transparent"
    });
}
function $4f367d302298cb9b$var$removeElements(elements) {
    elements.forEach((el)=>el.remove());
}
var $4f367d302298cb9b$export$28c660c63b792dea = function(params) {
    this._eventTrigger = params.eventTrigger;
    this._widgetRoot = params.widgetRoot;
    this._widget = params.widget;
    this._textHtmlContainers = [];
    this._wrapper = (0, $2vlX8.default)("<div>").css({
        position: "absolute",
        overflow: "hidden",
        pointerEvents: "none"
    }).addClass(params.cssClass);
    var renderer = this._renderer = new (0, $fORY6.Renderer)({
        pathModified: params.pathModified,
        container: this._wrapper[0]
    });
    var root = renderer.root;
    root.attr({
        "pointer-events": "none"
    });
    this._text = renderer.text(void 0, 0, 0);
    this._textGroupHtml = (0, $2vlX8.default)("<div>").css({
        position: "absolute",
        padding: 0,
        margin: 0,
        border: "0px solid transparent"
    }).appendTo(this._wrapper);
    this._textHtml = $4f367d302298cb9b$var$createTextHtml().appendTo(this._textGroupHtml);
};
$4f367d302298cb9b$export$28c660c63b792dea.prototype = {
    constructor: $4f367d302298cb9b$export$28c660c63b792dea,
    dispose: function() {
        this._wrapper.remove();
        this._renderer.dispose();
        this._options = this._widgetRoot = null;
    },
    _getContainer: function() {
        var options = this._options;
        var container = (0, $2vlX8.default)(this._widgetRoot).closest(options.container);
        if (0 === container.length) container = (0, $2vlX8.default)(options.container);
        return (container.length ? container : (0, $2vlX8.default)("body")).get(0);
    },
    setTemplate (contentTemplate) {
        this._template = contentTemplate ? this._widget._getTemplate(contentTemplate) : null;
    },
    setOptions: function(options) {
        options = options || {};
        var that = this;
        that._options = options;
        that._textFontStyles = (0, $dw9tZ.patchFontOptions)(options.font);
        that._textFontStyles.color = that._textFontStyles.fill;
        that._wrapper.css({
            zIndex: options.zIndex
        });
        that._customizeTooltip = options.customizeTooltip;
        var textGroupHtml = that._textGroupHtml;
        if (this.plaque) this.plaque.clear();
        this.setTemplate(options.contentTemplate);
        var pointerEvents = options.interactive ? "auto" : "none";
        if (options.interactive) this._renderer.root.css({
            "-ms-user-select": "auto",
            "-moz-user-select": "auto",
            "-webkit-user-select": "auto"
        });
        this.plaque = new (0, $k8jJ6.Plaque)({
            opacity: that._options.opacity,
            color: that._options.color,
            border: that._options.border,
            paddingLeftRight: that._options.paddingLeftRight,
            paddingTopBottom: that._options.paddingTopBottom,
            arrowLength: that._options.arrowLength,
            arrowWidth: 20,
            shadow: that._options.shadow,
            cornerRadius: that._options.cornerRadius
        }, that, that._renderer.root, (_ref)=>{
            var { group: group, onRender: onRender, eventData: eventData, isMoving: isMoving, templateCallback: templateCallback = ()=>{} } = _ref;
            var state = that._state;
            if (!isMoving) {
                var template = that._template;
                var useTemplate = template && !state.formatObject.skipTemplate;
                if (state.html || useTemplate) {
                    textGroupHtml.css({
                        color: state.textColor,
                        width: $4f367d302298cb9b$var$DEFAULT_HTML_GROUP_WIDTH,
                        pointerEvents: pointerEvents
                    });
                    if (useTemplate) {
                        var htmlContainers = that._textHtmlContainers;
                        var containerToTemplateRender = $4f367d302298cb9b$var$createTextHtml().appendTo(that._textGroupHtml);
                        htmlContainers.push(containerToTemplateRender);
                        template.render({
                            model: state.formatObject,
                            container: containerToTemplateRender,
                            onRendered: ()=>{
                                $4f367d302298cb9b$var$removeElements(htmlContainers.splice(0, htmlContainers.length - 1));
                                that._textHtml = (0, $g3YTP.replaceWith)(that._textHtml, containerToTemplateRender);
                                state.html = that._textHtml.html();
                                if (0 === (0, $iE2yv.getWidth)(that._textHtml) && 0 === (0, $iE2yv.getHeight)(that._textHtml)) {
                                    this.plaque.clear();
                                    templateCallback(false);
                                    return;
                                }
                                onRender();
                                that._riseEvents(eventData);
                                that._moveWrapper();
                                that.plaque.customizeCloud({
                                    fill: state.color,
                                    stroke: state.borderColor,
                                    "pointer-events": pointerEvents
                                });
                                templateCallback(true);
                                that._textHtmlContainers = [];
                            }
                        });
                        return;
                    } else {
                        that._text.attr({
                            text: ""
                        });
                        that._textHtml.html(state.html);
                    }
                } else that._text.css({
                    fill: state.textColor
                }).attr({
                    text: state.text,
                    class: options.cssClass,
                    "pointer-events": pointerEvents
                }).append(group.attr({
                    align: options.textAlignment
                }));
                that._riseEvents(eventData);
                that.plaque.customizeCloud({
                    fill: state.color,
                    stroke: state.borderColor,
                    "pointer-events": pointerEvents
                });
            }
            onRender();
            that._moveWrapper();
            return true;
        }, true, (tooltip, g)=>{
            var state = tooltip._state;
            if (state.html) {
                var bBox = $4f367d302298cb9b$var$window.getComputedStyle(that._textHtml.get(0));
                bBox = {
                    x: 0,
                    y: 0,
                    width: $4f367d302298cb9b$var$mathCeil(parseFloat(bBox.width)),
                    height: $4f367d302298cb9b$var$mathCeil(parseFloat(bBox.height))
                };
                return bBox;
            }
            return g.getBBox();
        }, (tooltip, g, x, y)=>{
            var state = tooltip._state;
            if (state.html) that._textGroupHtml.css({
                left: x,
                top: y
            });
            else g.move(x, y);
        });
        return that;
    },
    _riseEvents: function(eventData) {
        this._eventData && this._eventTrigger("tooltipHidden", this._eventData);
        this._eventData = eventData;
        this._eventTrigger("tooltipShown", this._eventData);
    },
    setRendererOptions: function(options) {
        this._renderer.setOptions(options);
        this._textGroupHtml.css({
            direction: options.rtl ? "rtl" : "ltr"
        });
        return this;
    },
    update: function(options) {
        this.setOptions(options);
        $4f367d302298cb9b$var$hideElement(this._wrapper);
        var normalizedCSS = {};
        for(var name in this._textFontStyles)normalizedCSS[(0, $lQCfZ.camelize)(name)] = this._textFontStyles[name];
        this._textGroupHtml.css(normalizedCSS);
        this._text.css(this._textFontStyles);
        this._eventData = null;
        return this;
    },
    _prepare: function(formatObject, state) {
        var customizeTooltip = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this._customizeTooltip;
        var options = this._options;
        var customize = {};
        if ((0, $6ntMu.isFunction)(customizeTooltip)) {
            customize = customizeTooltip.call(formatObject, formatObject);
            customize = (0, $6ntMu.isPlainObject)(customize) ? customize : {};
            if ("text" in customize) state.text = (0, $6ntMu.isDefined)(customize.text) ? String(customize.text) : "";
            if ("html" in customize) state.html = (0, $6ntMu.isDefined)(customize.html) ? String(customize.html) : "";
        }
        if (!("text" in state) && !("html" in state)) state.text = formatObject.valueText || formatObject.description || "";
        state.color = customize.color || options.color;
        state.borderColor = customize.borderColor || (options.border || {}).color;
        state.textColor = customize.fontColor || (this._textFontStyles || {}).color;
        return !!state.text || !!state.html || !!this._template;
    },
    show: function(formatObject, params, eventData, customizeTooltip, templateCallback) {
        if (this._options.forceEvents) {
            eventData.x = params.x;
            eventData.y = params.y - params.offset;
            this._riseEvents(eventData);
            return true;
        }
        var state = {
            formatObject: formatObject,
            eventData: eventData,
            templateCallback: templateCallback
        };
        if (!this._prepare(formatObject, state, customizeTooltip)) return false;
        this._state = state;
        this._wrapper.appendTo(this._getContainer());
        this._clear();
        var parameters = (0, $2oTOp.extend)({}, this._options, {
            canvas: this._getCanvas()
        }, state, {
            x: params.x,
            y: params.y,
            offset: params.offset
        });
        return this.plaque.clear().draw(parameters);
    },
    isCursorOnTooltip: function(x, y) {
        if (this._options.interactive) {
            var box = this.plaque.getBBox();
            return x > box.x && x < box.x + box.width && y > box.y && y < box.y + box.height;
        }
        return false;
    },
    hide: function(isPointerOut) {
        $4f367d302298cb9b$var$hideElement(this._wrapper);
        if (this._eventData) {
            this._eventTrigger("tooltipHidden", this._options.forceEvents ? (0, $2oTOp.extend)({
                isPointerOut: isPointerOut
            }, this._eventData) : this._eventData);
            this._clear();
            this._eventData = null;
        }
    },
    _clear () {
        this._textHtml.empty();
    },
    move: function(x, y, offset) {
        this.plaque.draw({
            x: x,
            y: y,
            offset: offset,
            canvas: this._getCanvas(),
            isMoving: true
        });
    },
    _moveWrapper: function() {
        var plaqueBBox = this.plaque.getBBox();
        this._renderer.resize(plaqueBBox.width, plaqueBBox.height);
        var offset = this._wrapper.css({
            left: 0,
            top: 0
        }).offset();
        var left = plaqueBBox.x;
        var top = plaqueBBox.y;
        this._wrapper.css({
            left: left - offset.left,
            top: top - offset.top
        });
        this.plaque.moveRoot(-left, -top);
        if (this._state.html) {
            this._textHtml.css({
                left: -left,
                top: -top
            });
            this._textGroupHtml.css({
                width: $4f367d302298cb9b$var$mathCeil((0, $iE2yv.getWidth)(this._textHtml))
            });
        }
    },
    formatValue: function(value, _specialFormat) {
        var options = _specialFormat ? $4f367d302298cb9b$var$getSpecialFormatOptions(this._options, _specialFormat) : this._options;
        return $4f367d302298cb9b$var$format(value, options.format);
    },
    getOptions () {
        return this._options;
    },
    getLocation: function() {
        return (0, $dw9tZ.normalizeEnum)(this._options.location);
    },
    isEnabled: function() {
        return !!this._options.enabled || !!this._options.forceEvents;
    },
    isShared: function() {
        return !!this._options.shared;
    },
    _getCanvas: function() {
        var container = this._getContainer();
        var containerBox = container.getBoundingClientRect();
        var html = (0, $3yzYM.default).getDocumentElement();
        var document = (0, $3yzYM.default).getDocument();
        var left = $4f367d302298cb9b$var$window.pageXOffset || html.scrollLeft || 0;
        var top = $4f367d302298cb9b$var$window.pageYOffset || html.scrollTop || 0;
        var box = {
            left: left,
            top: top,
            width: $4f367d302298cb9b$var$mathMax(html.clientWidth, document.body.clientWidth) + left,
            height: $4f367d302298cb9b$var$mathMax(document.body.scrollHeight, html.scrollHeight, document.body.offsetHeight, html.offsetHeight, document.body.clientHeight, html.clientHeight),
            right: 0,
            bottom: 0
        };
        if (container !== (0, $3yzYM.default).getBody()) {
            left = $4f367d302298cb9b$var$mathMax(box.left, box.left + containerBox.left);
            top = $4f367d302298cb9b$var$mathMax(box.top, box.top + containerBox.top);
            box.width = $4f367d302298cb9b$var$mathMin(containerBox.width, box.width) + left + box.left;
            box.height = $4f367d302298cb9b$var$mathMin(containerBox.height, box.height) + top + box.top;
            box.left = left;
            box.top = top;
        }
        return box;
    }
};
var $4f367d302298cb9b$export$ca524d3785e2543 = {
    name: "tooltip",
    init: function() {
        this._initTooltip();
    },
    dispose: function() {
        this._disposeTooltip();
    },
    members: {
        _initTooltip: function() {
            this._tooltip = new $4f367d302298cb9b$export$28c660c63b792dea({
                cssClass: this._rootClassPrefix + "-tooltip",
                eventTrigger: this._eventTrigger,
                pathModified: this.option("pathModified"),
                widgetRoot: this.element(),
                widget: this
            });
        },
        _disposeTooltip: function() {
            this._tooltip.dispose();
            this._tooltip = null;
        },
        _setTooltipRendererOptions: function() {
            this._tooltip.setRendererOptions(this._getRendererOptions());
        },
        _setTooltipOptions: function() {
            this._tooltip.update(this._getOption("tooltip"));
        }
    },
    extenders: {
        _stopCurrentHandling () {
            this._tooltip && this._tooltip.hide();
        }
    },
    customize: function(constructor) {
        var proto = constructor.prototype;
        proto._eventsMap.onTooltipShown = {
            name: "tooltipShown"
        };
        proto._eventsMap.onTooltipHidden = {
            name: "tooltipHidden"
        };
        constructor.addChange({
            code: "TOOLTIP_RENDERER",
            handler: function() {
                this._setTooltipRendererOptions();
            },
            isThemeDependent: true,
            isOptionChange: true
        });
        constructor.addChange({
            code: "TOOLTIP",
            handler: function() {
                this._setTooltipOptions();
            },
            isThemeDependent: true,
            isOptionChange: true,
            option: "tooltip"
        });
    },
    fontFields: [
        "tooltip.font"
    ]
};

});
parcelRegister("g3YTP", function(module, exports) {

$parcel$export(module.exports, "resetActiveElement", function () { return $03049554a3c9d5f8$export$d3d8dd668187bb07; });
$parcel$export(module.exports, "clearSelection", function () { return $03049554a3c9d5f8$export$a3d02541b0ebf605; });
$parcel$export(module.exports, "extractTemplateMarkup", function () { return $03049554a3c9d5f8$export$14110de921d49c6a; });
$parcel$export(module.exports, "normalizeTemplateElement", function () { return $03049554a3c9d5f8$export$2d3a143ccafc685d; });
$parcel$export(module.exports, "contains", function () { return $03049554a3c9d5f8$export$2344b14b097df817; });
$parcel$export(module.exports, "replaceWith", function () { return $03049554a3c9d5f8$export$e6a6680780233a77; });
/**
 * DevExtreme (esm/core/utils/dom.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $3yzYM = parcelRequire("3yzYM");

var $2vlX8 = parcelRequire("2vlX8");

var $8OLOW = parcelRequire("8OLOW");

var $6ntMu = parcelRequire("6ntMu");

var $hYatw = parcelRequire("hYatw");
var $03049554a3c9d5f8$var$window = (0, $hYatw.getWindow)();
var $03049554a3c9d5f8$var$getRootNodeHost = (element)=>{
    if (!element.getRootNode) return;
    var host = element.getRootNode().host;
    if ((0, $6ntMu.isString)(host)) return;
    return host;
};
var $03049554a3c9d5f8$export$d3d8dd668187bb07 = ()=>{
    var activeElement = (0, $3yzYM.default).getActiveElement();
    if (activeElement && activeElement !== (0, $3yzYM.default).getBody()) {
        var _activeElement$blur;
        null === (_activeElement$blur = activeElement.blur) || void 0 === _activeElement$blur || _activeElement$blur.call(activeElement);
    }
};
var $03049554a3c9d5f8$export$a3d02541b0ebf605 = ()=>{
    var selection = $03049554a3c9d5f8$var$window.getSelection();
    if (!selection) return;
    if ("Caret" === selection.type) return;
    if (selection.empty) selection.empty();
    else if (selection.removeAllRanges) try {
        selection.removeAllRanges();
    } catch (e) {}
};
var $03049554a3c9d5f8$export$140fe369b75d9004 = (startTarget, endTarget)=>{
    var $startTarget = (0, $2vlX8.default)(startTarget);
    var $endTarget = (0, $2vlX8.default)(endTarget);
    if ($startTarget[0] === $endTarget[0]) return $startTarget[0];
    var $startParents = $startTarget.parents();
    var $endParents = $endTarget.parents();
    var startingParent = Math.min($startParents.length, $endParents.length);
    for(var i = -startingParent; i < 0; i++){
        if ($startParents.get(i) === $endParents.get(i)) return $startParents.get(i);
    }
};
var $03049554a3c9d5f8$export$14110de921d49c6a = (element)=>{
    element = (0, $2vlX8.default)(element);
    var templateTag = element.length && element.filter(function() {
        var $node = (0, $2vlX8.default)(this);
        return $node.is("script[type]") && $node.attr("type").indexOf("script") < 0;
    });
    if (templateTag.length) return templateTag.eq(0).html();
    else {
        element = (0, $2vlX8.default)("<div>").append(element);
        return element.html();
    }
};
var $03049554a3c9d5f8$export$2d3a143ccafc685d = (element)=>{
    var $element = (0, $6ntMu.isDefined)(element) && (element.nodeType || (0, $6ntMu.isRenderer)(element)) ? (0, $2vlX8.default)(element) : (0, $2vlX8.default)("<div>").html(element).contents();
    if (1 === $element.length) {
        if ($element.is("script")) $element = $03049554a3c9d5f8$export$2d3a143ccafc685d($element.html().trim());
        else if ($element.is("table")) $element = $element.children("tbody").contents();
    }
    return $element;
};
var $03049554a3c9d5f8$export$5e54d945e18a1366 = (event, text)=>{
    var clipboard = event.originalEvent && event.originalEvent.clipboardData || $03049554a3c9d5f8$var$window.clipboardData;
    if (!text) return clipboard && clipboard.getData("Text");
    clipboard && clipboard.setData("Text", text);
};
var $03049554a3c9d5f8$export$2344b14b097df817 = (container, element)=>{
    if (!element) return false;
    if ((0, $6ntMu.isWindow)(container)) return $03049554a3c9d5f8$export$2344b14b097df817(container.document, element);
    return container.contains(element) || $03049554a3c9d5f8$export$2344b14b097df817(container, $03049554a3c9d5f8$var$getRootNodeHost(element));
};
var $03049554a3c9d5f8$export$f83b94d14426d495 = (element, text, options)=>{
    var elementStyles = $03049554a3c9d5f8$var$window.getComputedStyle((0, $2vlX8.default)(element).get(0));
    var includePaddings = options && options.includePaddings;
    return (0, $2vlX8.default)("<div>").text(text).css({
        fontStyle: elementStyles.fontStyle,
        fontVariant: elementStyles.fontVariant,
        fontWeight: elementStyles.fontWeight,
        fontSize: elementStyles.fontSize,
        fontFamily: elementStyles.fontFamily,
        letterSpacing: elementStyles.letterSpacing,
        border: elementStyles.border,
        paddingTop: includePaddings ? elementStyles.paddingTop : "",
        paddingRight: includePaddings ? elementStyles.paddingRight : "",
        paddingBottom: includePaddings ? elementStyles.paddingBottom : "",
        paddingLeft: includePaddings ? elementStyles.paddingLeft : "",
        visibility: "hidden",
        whiteSpace: "pre",
        position: "absolute",
        float: "left"
    });
};
var $03049554a3c9d5f8$export$86b68c7dbeb53c22 = (element, newElement)=>{
    if (newElement) (0, $3yzYM.default).insertElement(element.parentNode, newElement, element);
    return element;
};
var $03049554a3c9d5f8$export$e6a6680780233a77 = (element, newElement)=>{
    if (!(newElement && newElement[0])) return;
    if (newElement.is(element)) return element;
    (0, $8OLOW.each)(newElement, (_, currentElement)=>{
        $03049554a3c9d5f8$export$86b68c7dbeb53c22(element[0], currentElement);
    });
    element.remove();
    return newElement;
};
var $03049554a3c9d5f8$export$649e8fc6cb528314 = ($element)=>{
    var element = null === $element || void 0 === $element ? void 0 : $element.get(0);
    var shadowHost = null === element || void 0 === element ? void 0 : element.getRootNode().host;
    return !!(0, $2vlX8.default)(shadowHost || element).closest((0, $hYatw.getWindow)().document).length;
};

});

parcelRegister("fORY6", function(module, exports) {

$parcel$export(module.exports, "getFuncIri", function () { return $b8456380a74d5389$export$c03995ed2cae8cc5; });
$parcel$export(module.exports, "processHatchingAttrs", function () { return $b8456380a74d5389$export$828fe33043bd14cb; });
$parcel$export(module.exports, "Renderer", function () { return $b8456380a74d5389$export$88530751e3977073; });
/**
 * DevExtreme (esm/viz/core/renderers/renderer.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $3yzYM = parcelRequire("3yzYM");

var $hYatw = parcelRequire("hYatw");

var $k2ifc = parcelRequire("k2ifc");

var $60GuF = parcelRequire("60GuF");

var $jmNgH = parcelRequire("jmNgH");

var $6jumB = parcelRequire("6jumB");

var $dw9tZ = parcelRequire("dw9tZ");

var $6ntMu = parcelRequire("6ntMu");
var $b8456380a74d5389$var$window = (0, $hYatw.getWindow)();
var { max: $b8456380a74d5389$var$max, min: $b8456380a74d5389$var$min, floor: $b8456380a74d5389$var$floor, round: $b8456380a74d5389$var$round, sin: $b8456380a74d5389$var$sin, cos: $b8456380a74d5389$var$cos, abs: $b8456380a74d5389$var$abs, PI: $b8456380a74d5389$var$PI } = Math;
var $b8456380a74d5389$var$PI_DIV_180 = $b8456380a74d5389$var$PI / 180;
var $b8456380a74d5389$var$SHARPING_CORRECTION = .5;
var $b8456380a74d5389$var$ARC_COORD_PREC = 5;
var $b8456380a74d5389$var$pxAddingExceptions = {
    "column-count": true,
    "fill-opacity": true,
    "flex-grow": true,
    "flex-shrink": true,
    "font-weight": true,
    "line-height": true,
    opacity: true,
    order: true,
    orphans: true,
    widows: true,
    "z-index": true,
    zoom: true
};
var $b8456380a74d5389$var$KEY_TEXT = "text";
var $b8456380a74d5389$var$KEY_STROKE = "stroke";
var $b8456380a74d5389$var$KEY_STROKE_WIDTH = "stroke-width";
var $b8456380a74d5389$var$KEY_STROKE_OPACITY = "stroke-opacity";
var $b8456380a74d5389$var$KEY_FONT_SIZE = "font-size";
var $b8456380a74d5389$var$KEY_FONT_STYLE = "font-style";
var $b8456380a74d5389$var$KEY_FONT_WEIGHT = "font-weight";
var $b8456380a74d5389$var$KEY_TEXT_DECORATION = "text-decoration";
var $b8456380a74d5389$var$KEY_TEXTS_ALIGNMENT = "textsAlignment";
var $b8456380a74d5389$var$NONE = "none";
var $b8456380a74d5389$var$DEFAULT_FONT_SIZE = 12;
var $b8456380a74d5389$var$ELLIPSIS = "...";
var $b8456380a74d5389$var$objectCreate = function() {
    if (!Object.create) return function(proto) {
        var F = function() {};
        F.prototype = proto;
        return new F;
    };
    else return function(proto) {
        return Object.create(proto);
    };
}();
var $b8456380a74d5389$var$DEFAULTS = {
    scaleX: 1,
    scaleY: 1,
    "pointer-events": null
};
var $b8456380a74d5389$var$getBackup = (0, $k2ifc.default)(function() {
    var backupContainer = (0, $3yzYM.default).createElement("div");
    backupContainer.style.left = "-9999px";
    backupContainer.style.position = "absolute";
    return {
        backupContainer: backupContainer,
        backupCounter: 0
    };
});
function $b8456380a74d5389$var$backupRoot(root) {
    if (0 === $b8456380a74d5389$var$getBackup().backupCounter) (0, $3yzYM.default).getBody().appendChild($b8456380a74d5389$var$getBackup().backupContainer);
    ++$b8456380a74d5389$var$getBackup().backupCounter;
    root.append({
        element: $b8456380a74d5389$var$getBackup().backupContainer
    });
}
function $b8456380a74d5389$var$restoreRoot(root, container) {
    root.append({
        element: container
    });
    --$b8456380a74d5389$var$getBackup().backupCounter;
    if (0 === $b8456380a74d5389$var$getBackup().backupCounter) (0, $3yzYM.default).getBody().removeChild($b8456380a74d5389$var$getBackup().backupContainer);
}
var $b8456380a74d5389$var$getNextDefsSvgId = function() {
    var numDefsSvgElements = 1;
    return function() {
        return "DevExpress_" + numDefsSvgElements++;
    };
}();
function $b8456380a74d5389$var$isObjectArgument(value) {
    return value && "string" !== typeof value;
}
function $b8456380a74d5389$var$createElement(tagName) {
    return (0, $3yzYM.default).createElementNS("http://www.w3.org/2000/svg", tagName);
}
function $b8456380a74d5389$export$c03995ed2cae8cc5(id, pathModified) {
    return null !== id ? "url(" + (pathModified ? $b8456380a74d5389$var$window.location.href.split("#")[0] : "") + "#" + id + ")" : id;
}
function $b8456380a74d5389$var$extend(target, source) {
    var key;
    for(key in source)target[key] = source[key];
    return target;
}
function $b8456380a74d5389$var$roundValue(value, exp) {
    value = value.toString().split("e");
    value = $b8456380a74d5389$var$round(+(value[0] + "e" + (value[1] ? +value[1] + exp : exp)));
    value = value.toString().split("e");
    return +(value[0] + "e" + (value[1] ? +value[1] - exp : -exp));
}
var $b8456380a74d5389$var$preserveAspectRatioMap = {
    full: $b8456380a74d5389$var$NONE,
    lefttop: "xMinYMin",
    leftcenter: "xMinYMid",
    leftbottom: "xMinYMax",
    centertop: "xMidYMin",
    center: "xMidYMid",
    centerbottom: "xMidYMax",
    righttop: "xMaxYMin",
    rightcenter: "xMaxYMid",
    rightbottom: "xMaxYMax"
};
function $b8456380a74d5389$export$828fe33043bd14cb(element, attrs) {
    if (attrs.hatching && "none" !== (0, $dw9tZ.normalizeEnum)(attrs.hatching.direction)) {
        attrs = $b8456380a74d5389$var$extend({}, attrs);
        attrs.fill = element._hatching = element.renderer.lockHatching(attrs.fill, attrs.hatching, element._hatching);
        delete attrs.hatching;
    } else if (element._hatching) {
        element.renderer.releaseHatching(element._hatching);
        element._hatching = null;
    }
    return attrs;
}
function $b8456380a74d5389$var$normalizeArcParams(x, y, innerR, outerR, startAngle, endAngle) {
    var isCircle;
    var noArc = true;
    var angleDiff = $b8456380a74d5389$var$roundValue(endAngle, 3) - $b8456380a74d5389$var$roundValue(startAngle, 3);
    if (angleDiff) {
        if ($b8456380a74d5389$var$abs(angleDiff) % 360 === 0) {
            startAngle = 0;
            endAngle = 360;
            isCircle = true;
            endAngle -= .01;
        }
        if (startAngle > 360) startAngle %= 360;
        if (endAngle > 360) endAngle %= 360;
        if (startAngle > endAngle) startAngle -= 360;
        noArc = false;
    }
    startAngle *= $b8456380a74d5389$var$PI_DIV_180;
    endAngle *= $b8456380a74d5389$var$PI_DIV_180;
    return [
        x,
        y,
        $b8456380a74d5389$var$min(outerR, innerR),
        $b8456380a74d5389$var$max(outerR, innerR),
        $b8456380a74d5389$var$cos(startAngle),
        $b8456380a74d5389$var$sin(startAngle),
        $b8456380a74d5389$var$cos(endAngle),
        $b8456380a74d5389$var$sin(endAngle),
        isCircle,
        $b8456380a74d5389$var$floor($b8456380a74d5389$var$abs(endAngle - startAngle) / $b8456380a74d5389$var$PI) % 2 ? "1" : "0",
        noArc
    ];
}
var $b8456380a74d5389$var$buildArcPath = function(x, y, innerR, outerR, startAngleCos, startAngleSin, endAngleCos, endAngleSin, isCircle, longFlag) {
    return [
        "M",
        (x + outerR * startAngleCos).toFixed($b8456380a74d5389$var$ARC_COORD_PREC),
        (y - outerR * startAngleSin).toFixed($b8456380a74d5389$var$ARC_COORD_PREC),
        "A",
        outerR.toFixed($b8456380a74d5389$var$ARC_COORD_PREC),
        outerR.toFixed($b8456380a74d5389$var$ARC_COORD_PREC),
        0,
        longFlag,
        0,
        (x + outerR * endAngleCos).toFixed($b8456380a74d5389$var$ARC_COORD_PREC),
        (y - outerR * endAngleSin).toFixed($b8456380a74d5389$var$ARC_COORD_PREC),
        isCircle ? "M" : "L",
        (x + innerR * endAngleCos).toFixed(5),
        (y - innerR * endAngleSin).toFixed($b8456380a74d5389$var$ARC_COORD_PREC),
        "A",
        innerR.toFixed($b8456380a74d5389$var$ARC_COORD_PREC),
        innerR.toFixed($b8456380a74d5389$var$ARC_COORD_PREC),
        0,
        longFlag,
        1,
        (x + innerR * startAngleCos).toFixed($b8456380a74d5389$var$ARC_COORD_PREC),
        (y - innerR * startAngleSin).toFixed($b8456380a74d5389$var$ARC_COORD_PREC),
        "Z"
    ].join(" ");
};
function $b8456380a74d5389$var$buildPathSegments(points, type) {
    var list = [
        [
            "M",
            0,
            0
        ]
    ];
    switch(type){
        case "line":
            list = $b8456380a74d5389$var$buildLineSegments(points);
            break;
        case "area":
            list = $b8456380a74d5389$var$buildLineSegments(points, true);
            break;
        case "bezier":
            list = $b8456380a74d5389$var$buildCurveSegments(points);
            break;
        case "bezierarea":
            list = $b8456380a74d5389$var$buildCurveSegments(points, true);
    }
    return list;
}
function $b8456380a74d5389$var$buildLineSegments(points, close) {
    return $b8456380a74d5389$var$buildSegments(points, $b8456380a74d5389$var$buildSimpleLineSegment, close);
}
function $b8456380a74d5389$var$buildCurveSegments(points, close) {
    return $b8456380a74d5389$var$buildSegments(points, $b8456380a74d5389$var$buildSimpleCurveSegment, close);
}
function $b8456380a74d5389$var$buildSegments(points, buildSimpleSegment, close) {
    var _points$;
    var i;
    var ii;
    var list = [];
    if (null !== (_points$ = points[0]) && void 0 !== _points$ && _points$.length) for(i = 0, ii = points.length; i < ii; ++i)buildSimpleSegment(points[i], close, list);
    else buildSimpleSegment(points, close, list);
    return list;
}
function $b8456380a74d5389$var$buildSimpleLineSegment(points, close, list) {
    var i = 0;
    var k0 = list.length;
    var k = k0;
    var ii = (points || []).length;
    if (ii) {
        if (void 0 !== points[0].x) for(; i < ii;)list[k++] = [
            "L",
            points[i].x,
            points[i++].y
        ];
        else for(; i < ii;)list[k++] = [
            "L",
            points[i++],
            points[i++]
        ];
        list[k0][0] = "M";
    } else list[k] = [
        "M",
        0,
        0
    ];
    close && list.push([
        "Z"
    ]);
    return list;
}
function $b8456380a74d5389$var$buildSimpleCurveSegment(points, close, list) {
    var i;
    var k = list.length;
    var ii = (points || []).length;
    if (ii) {
        if (void 0 !== points[0].x) {
            list[k++] = [
                "M",
                points[0].x,
                points[0].y
            ];
            for(i = 1; i < ii;)list[k++] = [
                "C",
                points[i].x,
                points[i++].y,
                points[i].x,
                points[i++].y,
                points[i].x,
                points[i++].y
            ];
        } else {
            list[k++] = [
                "M",
                points[0],
                points[1]
            ];
            for(i = 2; i < ii;)list[k++] = [
                "C",
                points[i++],
                points[i++],
                points[i++],
                points[i++],
                points[i++],
                points[i++]
            ];
        }
    } else list[k] = [
        "M",
        0,
        0
    ];
    close && list.push([
        "Z"
    ]);
    return list;
}
function $b8456380a74d5389$var$combinePathParam(segments) {
    var d = [];
    var k = 0;
    var i;
    var ii = segments.length;
    var segment;
    var j;
    var jj;
    for(i = 0; i < ii; ++i){
        segment = segments[i];
        for(j = 0, jj = segment.length; j < jj; ++j)d[k++] = segment[j];
    }
    return d.join(" ");
}
function $b8456380a74d5389$var$compensateSegments(oldSegments, newSegments, type) {
    var oldLength = oldSegments.length;
    var newLength = newSegments.length;
    var i;
    var originalNewSegments;
    var makeEqualSegments = -1 !== type.indexOf("area") ? $b8456380a74d5389$var$makeEqualAreaSegments : $b8456380a74d5389$var$makeEqualLineSegments;
    if (0 === oldLength) for(i = 0; i < newLength; i++)oldSegments.push(newSegments[i].slice(0));
    else if (oldLength < newLength) makeEqualSegments(oldSegments, newSegments, type);
    else if (oldLength > newLength) {
        originalNewSegments = newSegments.slice(0);
        makeEqualSegments(newSegments, oldSegments, type);
    }
    return originalNewSegments;
}
function $b8456380a74d5389$var$prepareConstSegment(constSeg, type) {
    var x = constSeg[constSeg.length - 2];
    var y = constSeg[constSeg.length - 1];
    switch(type){
        case "line":
        case "area":
            constSeg[0] = "L";
            break;
        case "bezier":
        case "bezierarea":
            constSeg[0] = "C";
            constSeg[1] = constSeg[3] = constSeg[5] = x;
            constSeg[2] = constSeg[4] = constSeg[6] = y;
    }
}
function $b8456380a74d5389$var$makeEqualLineSegments(short, long, type) {
    var constSeg = short[short.length - 1].slice();
    var i = short.length;
    $b8456380a74d5389$var$prepareConstSegment(constSeg, type);
    for(; i < long.length; i++)short[i] = constSeg.slice(0);
}
function $b8456380a74d5389$var$makeEqualAreaSegments(short, long, type) {
    var i;
    var head;
    var shortLength = short.length;
    var longLength = long.length;
    var constsSeg1;
    var constsSeg2;
    if ((shortLength - 1) % 2 === 0 && (longLength - 1) % 2 === 0) {
        i = (shortLength - 1) / 2 - 1;
        head = short.slice(0, i + 1);
        constsSeg1 = head[head.length - 1].slice(0);
        constsSeg2 = short.slice(i + 1)[0].slice(0);
        $b8456380a74d5389$var$prepareConstSegment(constsSeg1, type);
        $b8456380a74d5389$var$prepareConstSegment(constsSeg2, type);
        for(var j = i; j < (longLength - 1) / 2 - 1; j++){
            short.splice(j + 1, 0, constsSeg1);
            short.splice(j + 3, 0, constsSeg2);
        }
    }
}
function $b8456380a74d5389$var$baseCss(that, styles) {
    var elemStyles = that._styles;
    var key;
    var value;
    styles = styles || {};
    for(key in styles){
        value = styles[key];
        if ((0, $6ntMu.isDefined)(value)) {
            value += "number" === typeof value && !$b8456380a74d5389$var$pxAddingExceptions[key] ? "px" : "";
            elemStyles[key] = "" !== value ? value : null;
        }
    }
    for(key in elemStyles){
        value = elemStyles[key];
        if (value) that.element.style[key] = value;
        else if (null === value) that.element.style[key] = "";
    }
    return that;
}
function $b8456380a74d5389$var$fixFuncIri(wrapper, attribute) {
    var element = wrapper.element;
    var id = wrapper.attr(attribute);
    if (id && -1 !== id.indexOf("DevExpress")) {
        element.removeAttribute(attribute);
        element.setAttribute(attribute, $b8456380a74d5389$export$c03995ed2cae8cc5(id, wrapper.renderer.pathModified));
    }
}
function $b8456380a74d5389$var$baseAttr(that, attrs) {
    attrs = attrs || {};
    var settings = that._settings;
    var attributes = {};
    var key;
    var value;
    var elem = that.element;
    var renderer = that.renderer;
    var rtl = renderer.rtl;
    var hasTransformations;
    var recalculateDashStyle;
    var sw;
    var i;
    if (!$b8456380a74d5389$var$isObjectArgument(attrs)) {
        if (attrs in settings) return settings[attrs];
        if (attrs in $b8456380a74d5389$var$DEFAULTS) return $b8456380a74d5389$var$DEFAULTS[attrs];
        return 0;
    }
    $b8456380a74d5389$var$extend(attributes, attrs);
    for(key in attributes){
        value = attributes[key];
        if (void 0 === value) continue;
        settings[key] = value;
        if ("align" === key) {
            key = "text-anchor";
            value = ({
                left: rtl ? "end" : "start",
                center: "middle",
                right: rtl ? "start" : "end"
            })[value] || null;
        } else if ("dashStyle" === key) {
            recalculateDashStyle = true;
            continue;
        } else if (key === $b8456380a74d5389$var$KEY_STROKE_WIDTH) recalculateDashStyle = true;
        else if (value && ("fill" === key || "clip-path" === key || "filter" === key) && 0 === value.indexOf("DevExpress")) {
            that._addFixIRICallback();
            value = $b8456380a74d5389$export$c03995ed2cae8cc5(value, renderer.pathModified);
        } else if (/^(translate(X|Y)|rotate[XY]?|scale(X|Y)|sharp|sharpDirection)$/i.test(key)) {
            hasTransformations = true;
            continue;
        } else if (/^(x|y|d)$/i.test(key)) hasTransformations = true;
        if (null === value) elem.removeAttribute(key);
        else elem.setAttribute(key, value);
    }
    if (recalculateDashStyle && "dashStyle" in settings) {
        value = settings.dashStyle;
        sw = ("_originalSW" in that ? that._originalSW : settings[$b8456380a74d5389$var$KEY_STROKE_WIDTH]) || 1;
        key = "stroke-dasharray";
        value = null === value ? "" : (0, $dw9tZ.normalizeEnum)(value);
        if ("" === value || "solid" === value || value === $b8456380a74d5389$var$NONE) that.element.removeAttribute(key);
        else {
            value = value.replace(/longdash/g, "8,3,").replace(/dash/g, "4,3,").replace(/dot/g, "1,3,").replace(/,$/, "").split(",");
            i = value.length;
            while(i--)value[i] = parseInt(value[i]) * sw;
            that.element.setAttribute(key, value.join(","));
        }
    }
    if (hasTransformations) that._applyTransformation();
    return that;
}
function $b8456380a74d5389$var$pathAttr(attrs) {
    var segments;
    if ($b8456380a74d5389$var$isObjectArgument(attrs)) {
        attrs = $b8456380a74d5389$var$extend({}, attrs);
        segments = attrs.segments;
        if ("points" in attrs) {
            segments = $b8456380a74d5389$var$buildPathSegments(attrs.points, this.type);
            delete attrs.points;
        }
        if (segments) {
            attrs.d = $b8456380a74d5389$var$combinePathParam(segments);
            this.segments = segments;
            delete attrs.segments;
        }
    }
    return $b8456380a74d5389$var$baseAttr(this, attrs);
}
function $b8456380a74d5389$var$arcAttr(attrs) {
    var settings = this._settings;
    var x;
    var y;
    var innerRadius;
    var outerRadius;
    var startAngle;
    var endAngle;
    if ($b8456380a74d5389$var$isObjectArgument(attrs)) {
        attrs = $b8456380a74d5389$var$extend({}, attrs);
        if ("x" in attrs || "y" in attrs || "innerRadius" in attrs || "outerRadius" in attrs || "startAngle" in attrs || "endAngle" in attrs) {
            settings.x = x = "x" in attrs ? attrs.x : settings.x;
            delete attrs.x;
            settings.y = y = "y" in attrs ? attrs.y : settings.y;
            delete attrs.y;
            settings.innerRadius = innerRadius = "innerRadius" in attrs ? attrs.innerRadius : settings.innerRadius;
            delete attrs.innerRadius;
            settings.outerRadius = outerRadius = "outerRadius" in attrs ? attrs.outerRadius : settings.outerRadius;
            delete attrs.outerRadius;
            settings.startAngle = startAngle = "startAngle" in attrs ? attrs.startAngle : settings.startAngle;
            delete attrs.startAngle;
            settings.endAngle = endAngle = "endAngle" in attrs ? attrs.endAngle : settings.endAngle;
            delete attrs.endAngle;
            attrs.d = $b8456380a74d5389$var$buildArcPath.apply(null, $b8456380a74d5389$var$normalizeArcParams(x, y, innerRadius, outerRadius, startAngle, endAngle));
        }
    }
    return $b8456380a74d5389$var$baseAttr(this, attrs);
}
function $b8456380a74d5389$var$rectAttr(attrs) {
    var x;
    var y;
    var width;
    var height;
    var sw;
    var maxSW;
    var newSW;
    if ($b8456380a74d5389$var$isObjectArgument(attrs)) {
        attrs = $b8456380a74d5389$var$extend({}, attrs);
        if (void 0 !== attrs.x || void 0 !== attrs.y || void 0 !== attrs.width || void 0 !== attrs.height || void 0 !== attrs[$b8456380a74d5389$var$KEY_STROKE_WIDTH]) {
            void 0 !== attrs.x ? x = this._originalX = attrs.x : x = this._originalX || 0;
            void 0 !== attrs.y ? y = this._originalY = attrs.y : y = this._originalY || 0;
            void 0 !== attrs.width ? width = this._originalWidth = attrs.width : width = this._originalWidth || 0;
            void 0 !== attrs.height ? height = this._originalHeight = attrs.height : height = this._originalHeight || 0;
            void 0 !== attrs[$b8456380a74d5389$var$KEY_STROKE_WIDTH] ? sw = this._originalSW = attrs[$b8456380a74d5389$var$KEY_STROKE_WIDTH] : sw = this._originalSW;
            maxSW = ~~((width < height ? width : height) / 2);
            newSW = (sw || 0) < maxSW ? sw || 0 : maxSW;
            attrs.x = x + newSW / 2;
            attrs.y = y + newSW / 2;
            attrs.width = width - newSW;
            attrs.height = height - newSW;
            ((sw || 0) !== newSW || !(0 === newSW && void 0 === sw)) && (attrs[$b8456380a74d5389$var$KEY_STROKE_WIDTH] = newSW);
        }
        if ("sharp" in attrs) delete attrs.sharp;
    }
    return $b8456380a74d5389$var$baseAttr(this, attrs);
}
function $b8456380a74d5389$var$textAttr(attrs) {
    var isResetRequired;
    if (!$b8456380a74d5389$var$isObjectArgument(attrs)) return $b8456380a74d5389$var$baseAttr(this, attrs);
    attrs = $b8456380a74d5389$var$extend({}, attrs);
    var settings = this._settings;
    var wasStroked = (0, $6ntMu.isDefined)(settings[$b8456380a74d5389$var$KEY_STROKE]) && (0, $6ntMu.isDefined)(settings[$b8456380a74d5389$var$KEY_STROKE_WIDTH]);
    if (void 0 !== attrs[$b8456380a74d5389$var$KEY_TEXT]) {
        settings[$b8456380a74d5389$var$KEY_TEXT] = attrs[$b8456380a74d5389$var$KEY_TEXT];
        delete attrs[$b8456380a74d5389$var$KEY_TEXT];
        isResetRequired = true;
    }
    if (void 0 !== attrs[$b8456380a74d5389$var$KEY_STROKE]) {
        settings[$b8456380a74d5389$var$KEY_STROKE] = attrs[$b8456380a74d5389$var$KEY_STROKE];
        delete attrs[$b8456380a74d5389$var$KEY_STROKE];
    }
    if (void 0 !== attrs[$b8456380a74d5389$var$KEY_STROKE_WIDTH]) {
        settings[$b8456380a74d5389$var$KEY_STROKE_WIDTH] = attrs[$b8456380a74d5389$var$KEY_STROKE_WIDTH];
        delete attrs[$b8456380a74d5389$var$KEY_STROKE_WIDTH];
    }
    if (void 0 !== attrs[$b8456380a74d5389$var$KEY_STROKE_OPACITY]) {
        settings[$b8456380a74d5389$var$KEY_STROKE_OPACITY] = attrs[$b8456380a74d5389$var$KEY_STROKE_OPACITY];
        delete attrs[$b8456380a74d5389$var$KEY_STROKE_OPACITY];
    }
    if (void 0 !== attrs[$b8456380a74d5389$var$KEY_TEXTS_ALIGNMENT]) {
        $b8456380a74d5389$var$alignTextNodes(this, attrs[$b8456380a74d5389$var$KEY_TEXTS_ALIGNMENT]);
        delete attrs[$b8456380a74d5389$var$KEY_TEXTS_ALIGNMENT];
    }
    var isStroked = (0, $6ntMu.isDefined)(settings[$b8456380a74d5389$var$KEY_STROKE]) && (0, $6ntMu.isDefined)(settings[$b8456380a74d5389$var$KEY_STROKE_WIDTH]);
    $b8456380a74d5389$var$baseAttr(this, attrs);
    isResetRequired = isResetRequired || isStroked !== wasStroked && settings[$b8456380a74d5389$var$KEY_TEXT];
    if (isResetRequired) {
        $b8456380a74d5389$var$createTextNodes(this, settings.text, isStroked);
        this._hasEllipsis = false;
    }
    if (isResetRequired || void 0 !== attrs.x || void 0 !== attrs.y) $b8456380a74d5389$var$locateTextNodes(this);
    if (isStroked) $b8456380a74d5389$var$strokeTextNodes(this);
    return this;
}
function $b8456380a74d5389$var$textCss(styles) {
    styles = styles || {};
    $b8456380a74d5389$var$baseCss(this, styles);
    if ($b8456380a74d5389$var$KEY_FONT_SIZE in styles) $b8456380a74d5389$var$locateTextNodes(this);
    return this;
}
function $b8456380a74d5389$var$orderHtmlTree(list, line, node, parentStyle, parentClassName) {
    var style;
    var realStyle;
    var i;
    var ii;
    var nodes;
    if (void 0 !== node.wholeText) list.push({
        value: node.wholeText,
        style: parentStyle,
        className: parentClassName,
        line: line,
        height: parentStyle[$b8456380a74d5389$var$KEY_FONT_SIZE] || 0
    });
    else if ("BR" === node.tagName) ++line;
    else if ((0, $3yzYM.default).isElementNode(node)) {
        $b8456380a74d5389$var$extend(style = {}, parentStyle);
        switch(node.tagName){
            case "B":
            case "STRONG":
                style[$b8456380a74d5389$var$KEY_FONT_WEIGHT] = "bold";
                break;
            case "I":
            case "EM":
                style[$b8456380a74d5389$var$KEY_FONT_STYLE] = "italic";
                break;
            case "U":
                style[$b8456380a74d5389$var$KEY_TEXT_DECORATION] = "underline";
        }
        realStyle = node.style;
        realStyle.color && (style.fill = realStyle.color);
        realStyle.fontSize && (style[$b8456380a74d5389$var$KEY_FONT_SIZE] = realStyle.fontSize);
        realStyle.fontStyle && (style[$b8456380a74d5389$var$KEY_FONT_STYLE] = realStyle.fontStyle);
        realStyle.fontWeight && (style[$b8456380a74d5389$var$KEY_FONT_WEIGHT] = realStyle.fontWeight);
        realStyle.textDecoration && (style[$b8456380a74d5389$var$KEY_TEXT_DECORATION] = realStyle.textDecoration);
        for(i = 0, nodes = node.childNodes, ii = nodes.length; i < ii; ++i)line = $b8456380a74d5389$var$orderHtmlTree(list, line, nodes[i], style, node.className || parentClassName);
    }
    return line;
}
function $b8456380a74d5389$var$adjustLineHeights(items) {
    var i;
    var ii;
    var currentItem = items[0];
    var item;
    for(i = 1, ii = items.length; i < ii; ++i){
        item = items[i];
        if (item.line === currentItem.line) {
            currentItem.height = $b8456380a74d5389$var$maxLengthFontSize(currentItem.height, item.height);
            currentItem.inherits = currentItem.inherits || 0 === parseFloat(item.height);
            item.height = NaN;
        } else currentItem = item;
    }
}
function $b8456380a74d5389$var$removeExtraAttrs(html) {
    var findStyleAndClassAttrs = /(style|class)\s*=\s*(["'])(?:(?!\2).)*\2\s?/gi;
    return html.replace(/(?:(<[a-z0-9]+\s*))([\s\S]*?)(>|\/>)/gi, function(allTagAttrs, p1, p2, p3) {
        p2 = (p2 && p2.match(findStyleAndClassAttrs) || []).map(function(str) {
            return str;
        }).join(" ");
        return p1 + p2 + p3;
    });
}
function $b8456380a74d5389$var$parseHTML(text) {
    var items = [];
    var div = (0, $3yzYM.default).createElement("div");
    div.innerHTML = text.replace(/\r/g, "").replace(/\n/g, "<br/>");
    $b8456380a74d5389$var$orderHtmlTree(items, 0, div, {}, "");
    $b8456380a74d5389$var$adjustLineHeights(items);
    return items;
}
function $b8456380a74d5389$var$parseMultiline(text) {
    var texts = text.replace(/\r/g, "").split(/\n/g);
    var i = 0;
    var items = [];
    for(; i < texts.length; i++)items.push({
        value: texts[i].trim(),
        height: 0,
        line: i
    });
    return items;
}
function $b8456380a74d5389$var$createTspans(items, element, fieldName) {
    var i;
    var ii;
    var item;
    for(i = 0, ii = items.length; i < ii; ++i){
        item = items[i];
        item[fieldName] = $b8456380a74d5389$var$createElement("tspan");
        item[fieldName].appendChild((0, $3yzYM.default).createTextNode(item.value));
        item.style && $b8456380a74d5389$var$baseCss({
            element: item[fieldName],
            _styles: {}
        }, item.style);
        item.className && item[fieldName].setAttribute("class", item.className);
        element.appendChild(item[fieldName]);
    }
}
function $b8456380a74d5389$var$restoreText() {
    if (this._hasEllipsis) this.attr({
        text: this._settings.text
    });
}
function $b8456380a74d5389$var$applyEllipsis(maxWidth) {
    var lines;
    var hasEllipsis = false;
    var i;
    var ii;
    var lineParts;
    var j;
    var jj;
    var text;
    $b8456380a74d5389$var$restoreText.call(this);
    var ellipsis = this.renderer.text($b8456380a74d5389$var$ELLIPSIS).attr(this._styles).append(this.renderer.root);
    var ellipsisWidth = ellipsis.getBBox().width;
    if (this._getElementBBox().width > maxWidth) {
        if (maxWidth - ellipsisWidth < 0) maxWidth = 0;
        else maxWidth -= ellipsisWidth;
        lines = $b8456380a74d5389$var$prepareLines(this.element, this._texts, maxWidth);
        for(i = 0, ii = lines.length; i < ii; ++i){
            lineParts = lines[i].parts;
            if (1 === lines[i].commonLength) continue;
            for(j = 0, jj = lineParts.length; j < jj; ++j){
                text = lineParts[j];
                if ((0, $6ntMu.isDefined)(text.endIndex)) {
                    $b8456380a74d5389$var$setNewText(text, text.endIndex);
                    hasEllipsis = true;
                } else if (text.startBox > maxWidth) $b8456380a74d5389$var$removeTextSpan(text);
            }
        }
    }
    ellipsis.remove();
    this._hasEllipsis = hasEllipsis;
    return hasEllipsis;
}
function $b8456380a74d5389$var$cloneAndRemoveAttrs(node) {
    var clone;
    if (node) {
        clone = node.cloneNode();
        clone.removeAttribute("y");
        clone.removeAttribute("x");
    }
    return clone || node;
}
function $b8456380a74d5389$var$detachTitleElements(element) {
    var titleElements = (0, $3yzYM.default).querySelectorAll(element, "title");
    for(var i = 0; i < titleElements.length; i++)element.removeChild(titleElements[i]);
    return titleElements;
}
function $b8456380a74d5389$var$detachAndStoreTitleElements(element) {
    var titleElements = $b8456380a74d5389$var$detachTitleElements(element);
    return ()=>{
        for(var i = 0; i < titleElements.length; i++)element.appendChild(titleElements[i]);
    };
}
function $b8456380a74d5389$var$setMaxSize(maxWidth, maxHeight) {
    var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    var that = this;
    var lines = [];
    var textChanged = false;
    var textIsEmpty = false;
    var ellipsisMaxWidth = maxWidth;
    $b8456380a74d5389$var$restoreText.call(that);
    var restoreTitleElement = $b8456380a74d5389$var$detachAndStoreTitleElements(this.element);
    var ellipsis = that.renderer.text($b8456380a74d5389$var$ELLIPSIS).attr(that._styles).append(that.renderer.root);
    var ellipsisWidth = ellipsis.getBBox().width;
    var { width: width, height: height } = that._getElementBBox();
    if ((width || height) && (width > maxWidth || maxHeight && height > maxHeight)) {
        if (maxWidth - ellipsisWidth < 0) ellipsisMaxWidth = 0;
        else ellipsisMaxWidth -= ellipsisWidth;
        lines = $b8456380a74d5389$var$applyOverflowRules(that.element, that._texts, maxWidth, ellipsisMaxWidth, options);
        lines = $b8456380a74d5389$var$setMaxHeight(lines, ellipsisMaxWidth, options, maxHeight, parseFloat(this._getLineHeight()));
        this._texts = lines.reduce((texts, line)=>texts.concat(line.parts), []).filter((t)=>"" !== t.value).map((t)=>{
            t.stroke && t.tspan.parentNode.appendChild(t.stroke);
            return t;
        }).map((t)=>{
            t.tspan.parentNode.appendChild(t.tspan);
            return t;
        });
        !this._texts.length && (this._texts = null);
        textChanged = true;
        if (this._texts) $b8456380a74d5389$var$locateTextNodes(this);
        else {
            this.element.textContent = "";
            textIsEmpty = true;
        }
    }
    ellipsis.remove();
    that._hasEllipsis = textChanged;
    restoreTitleElement();
    return {
        rowCount: lines.length,
        textChanged: textChanged,
        textIsEmpty: textIsEmpty
    };
}
function $b8456380a74d5389$var$getIndexForEllipsis(text, maxWidth, startBox, endBox) {
    var k;
    var kk;
    if (startBox <= maxWidth && endBox > maxWidth) for(k = 1, kk = text.value.length; k <= kk; ++k){
        if (startBox + text.tspan.getSubStringLength(0, k) > maxWidth) return k - 1;
    }
}
function $b8456380a74d5389$var$getTextWidth(text) {
    return text.value.length ? text.tspan.getSubStringLength(0, text.value.length) : 0;
}
function $b8456380a74d5389$var$prepareLines(element, texts, maxWidth) {
    var lines = [];
    var i;
    var ii;
    var text;
    var startBox;
    var endBox;
    if (texts) for(i = 0, ii = texts.length; i < ii; ++i){
        text = texts[i];
        if (!lines[text.line]) {
            text.startBox = startBox = 0;
            lines.push({
                commonLength: text.value.length,
                parts: [
                    text
                ]
            });
        } else {
            text.startBox = startBox;
            lines[text.line].parts.push(text);
            lines[text.line].commonLength += text.value.length;
        }
        endBox = startBox + text.tspan.getSubStringLength(0, text.value.length);
        text.endIndex = $b8456380a74d5389$var$getIndexForEllipsis(text, maxWidth, startBox, endBox);
        startBox = endBox;
    }
    else {
        text = {
            value: element.textContent,
            tspan: element
        };
        text.startBox = startBox = 0;
        endBox = startBox + $b8456380a74d5389$var$getTextWidth(text);
        text.endIndex = $b8456380a74d5389$var$getIndexForEllipsis(text, maxWidth, startBox, endBox);
        lines = [
            {
                commonLength: element.textContent.length,
                parts: [
                    text
                ]
            }
        ];
    }
    return lines;
}
function $b8456380a74d5389$var$getSpaceBreakIndex(text, maxWidth) {
    var initialIndices = text.startBox > 0 ? [
        0
    ] : [];
    var spaceIndices = text.value.split("").reduce((indices, char, index)=>{
        if (" " === char) indices.push(index);
        return indices;
    }, initialIndices);
    var spaceIndex = 0;
    while(void 0 !== spaceIndices[spaceIndex + 1] && text.startBox + text.tspan.getSubStringLength(0, spaceIndices[spaceIndex + 1]) < maxWidth)spaceIndex++;
    return spaceIndices[spaceIndex];
}
function $b8456380a74d5389$var$getWordBreakIndex(text, maxWidth) {
    for(var i = 0; i < text.value.length - 1; i++){
        if (text.startBox + text.tspan.getSubStringLength(0, i + 1) > maxWidth) return i;
    }
}
function $b8456380a74d5389$var$getEllipsisString(ellipsisMaxWidth, _ref) {
    var { hideOverflowEllipsis: hideOverflowEllipsis } = _ref;
    return hideOverflowEllipsis && 0 === ellipsisMaxWidth ? "" : $b8456380a74d5389$var$ELLIPSIS;
}
function $b8456380a74d5389$var$setEllipsis(text, ellipsisMaxWidth, options) {
    var ellipsis = $b8456380a74d5389$var$getEllipsisString(ellipsisMaxWidth, options);
    if (text.value.length && text.tspan.parentNode) for(var i = text.value.length - 1; i >= 1; i--){
        if (text.startBox + text.tspan.getSubStringLength(0, i) < ellipsisMaxWidth) {
            $b8456380a74d5389$var$setNewText(text, i, ellipsis);
            break;
        } else if (1 === i) $b8456380a74d5389$var$setNewText(text, 0, ellipsis);
    }
}
function $b8456380a74d5389$var$wordWrap(text, maxWidth, ellipsisMaxWidth, options, lastStepBreakIndex) {
    var wholeText = text.value;
    var breakIndex;
    if ("none" !== options.wordWrap) breakIndex = "normal" === options.wordWrap ? $b8456380a74d5389$var$getSpaceBreakIndex(text, maxWidth) : $b8456380a74d5389$var$getWordBreakIndex(text, maxWidth);
    var restLines = [];
    var restText;
    if (isFinite(breakIndex) && !(0 === lastStepBreakIndex && 0 === breakIndex)) {
        $b8456380a74d5389$var$setNewText(text, breakIndex, "");
        var newTextOffset = " " === wholeText[breakIndex] ? 1 : 0;
        var restString = wholeText.slice(breakIndex + newTextOffset);
        if (restString.length) {
            var restTspan = $b8456380a74d5389$var$cloneAndRemoveAttrs(text.tspan);
            restTspan.textContent = restString;
            text.tspan.parentNode.appendChild(restTspan);
            restText = $b8456380a74d5389$var$extend($b8456380a74d5389$var$extend({}, text), {
                value: restString,
                startBox: 0,
                height: 0,
                tspan: restTspan,
                stroke: $b8456380a74d5389$var$cloneAndRemoveAttrs(text.stroke),
                endBox: restTspan.getSubStringLength(0, restString.length)
            });
            restText.stroke && (restText.stroke.textContent = restString);
            if (restText.endBox > maxWidth) {
                restLines = $b8456380a74d5389$var$wordWrap(restText, maxWidth, ellipsisMaxWidth, options, breakIndex);
                if (!restLines.length) return [];
            }
        }
    }
    if (text.value.length) {
        if ("ellipsis" === options.textOverflow && text.tspan.getSubStringLength(0, text.value.length) > maxWidth) $b8456380a74d5389$var$setEllipsis(text, ellipsisMaxWidth, options);
        if ("hide" === options.textOverflow && text.tspan.getSubStringLength(0, text.value.length) > maxWidth) return [];
    } else text.tspan.parentNode.removeChild(text.tspan);
    var parts = [];
    if (restText) parts.push(restText);
    return [
        {
            commonLength: wholeText.length,
            parts: parts
        }
    ].concat(restLines);
}
function $b8456380a74d5389$var$calculateLineHeight(line, lineHeight) {
    return line.parts.reduce((height, text)=>$b8456380a74d5389$var$max(height, $b8456380a74d5389$var$getItemLineHeight(text, lineHeight)), 0);
}
function $b8456380a74d5389$var$setMaxHeight(lines, ellipsisMaxWidth, options, maxHeight, lineHeight) {
    var textOverflow = options.textOverflow;
    if (!isFinite(maxHeight) || 0 === Number(maxHeight) || "none" === textOverflow) return lines;
    var result = lines.reduce((_ref2, l, index, arr)=>{
        var [lines, commonHeight] = _ref2;
        var height = $b8456380a74d5389$var$calculateLineHeight(l, lineHeight);
        commonHeight += height;
        if (commonHeight < maxHeight) lines.push(l);
        else {
            l.parts.forEach((item)=>{
                $b8456380a74d5389$var$removeTextSpan(item);
            });
            if ("ellipsis" === textOverflow) {
                var prevLine = arr[index - 1];
                if (prevLine) {
                    var text = prevLine.parts[prevLine.parts.length - 1];
                    if (!text.hasEllipsis) {
                        if (0 === ellipsisMaxWidth || text.endBox < ellipsisMaxWidth) $b8456380a74d5389$var$setNewText(text, text.value.length, $b8456380a74d5389$var$getEllipsisString(ellipsisMaxWidth, options));
                        else $b8456380a74d5389$var$setEllipsis(text, ellipsisMaxWidth, options);
                    }
                }
            }
        }
        return [
            lines,
            commonHeight
        ];
    }, [
        [],
        0
    ]);
    if ("hide" === textOverflow && result[1] > maxHeight) {
        result[0].forEach((l)=>{
            l.parts.forEach((item)=>{
                $b8456380a74d5389$var$removeTextSpan(item);
            });
        });
        return [];
    }
    return result[0];
}
function $b8456380a74d5389$var$applyOverflowRules(element, texts, maxWidth, ellipsisMaxWidth, options) {
    if (!texts) {
        var textValue = element.textContent;
        var text = {
            value: textValue,
            height: 0,
            line: 0
        };
        element.textContent = "";
        $b8456380a74d5389$var$createTspans([
            text
        ], element, "tspan");
        texts = [
            text
        ];
    }
    return texts.reduce((_ref3, text)=>{
        var [lines, startBox, endBox, stop, lineNumber] = _ref3;
        var line = lines[lines.length - 1];
        if (stop) return [
            lines,
            startBox,
            endBox,
            stop
        ];
        if (!line || text.line !== lineNumber) {
            text.startBox = startBox = 0;
            lines.push({
                commonLength: text.value.length,
                parts: [
                    text
                ]
            });
        } else {
            text.startBox = startBox;
            if (startBox > ellipsisMaxWidth && "none" === options.wordWrap && "ellipsis" === options.textOverflow) {
                $b8456380a74d5389$var$removeTextSpan(text);
                return [
                    lines,
                    startBox,
                    endBox,
                    stop,
                    lineNumber
                ];
            }
            line.parts.push(text);
            line.commonLength += text.value.length;
        }
        text.endBox = endBox = startBox + $b8456380a74d5389$var$getTextWidth(text);
        startBox = endBox;
        if ((0, $6ntMu.isDefined)(maxWidth) && endBox > maxWidth) {
            var wordWrapLines = $b8456380a74d5389$var$wordWrap(text, maxWidth, ellipsisMaxWidth, options);
            if (!wordWrapLines.length) {
                lines = [];
                stop = true;
            } else lines = lines.concat(wordWrapLines.filter((l)=>l.parts.length > 0));
        }
        return [
            lines,
            startBox,
            endBox,
            stop,
            text.line
        ];
    }, [
        [],
        0,
        0,
        false,
        0
    ])[0];
}
function $b8456380a74d5389$var$setNewText(text, index) {
    var insertString = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : $b8456380a74d5389$var$ELLIPSIS;
    var newText = text.value.substr(0, index) + insertString;
    text.value = text.tspan.textContent = newText;
    text.stroke && (text.stroke.textContent = newText);
    if (insertString === $b8456380a74d5389$var$ELLIPSIS) text.hasEllipsis = true;
}
function $b8456380a74d5389$var$removeTextSpan(text) {
    text.tspan.parentNode && text.tspan.parentNode.removeChild(text.tspan);
    text.stroke && text.stroke.parentNode && text.stroke.parentNode.removeChild(text.stroke);
}
function $b8456380a74d5389$var$createTextNodes(wrapper, text, isStroked) {
    var items;
    var parsedHtml;
    wrapper._texts = null;
    wrapper.clear();
    if (null === text) return;
    text = "" + text;
    if (!wrapper.renderer.encodeHtml && (/<[a-z][\s\S]*>/i.test(text) || -1 !== text.indexOf("&"))) {
        parsedHtml = $b8456380a74d5389$var$removeExtraAttrs(text);
        items = $b8456380a74d5389$var$parseHTML(parsedHtml);
    } else if (/\n/g.test(text)) items = $b8456380a74d5389$var$parseMultiline(text);
    else if (isStroked) items = [
        {
            value: text.trim(),
            height: 0
        }
    ];
    if (items) {
        if (items.length) {
            wrapper._texts = items;
            if (isStroked) $b8456380a74d5389$var$createTspans(items, wrapper.element, $b8456380a74d5389$var$KEY_STROKE);
            $b8456380a74d5389$var$createTspans(items, wrapper.element, "tspan");
        }
    } else wrapper.element.appendChild((0, $3yzYM.default).createTextNode(text));
}
function $b8456380a74d5389$var$setTextNodeAttribute(item, name, value) {
    item.tspan.setAttribute(name, value);
    item.stroke && item.stroke.setAttribute(name, value);
}
function $b8456380a74d5389$var$getItemLineHeight(item, defaultValue) {
    return item.inherits ? $b8456380a74d5389$var$maxLengthFontSize(item.height, defaultValue) : item.height || defaultValue;
}
function $b8456380a74d5389$var$locateTextNodes(wrapper) {
    if (!wrapper._texts) return;
    var items = wrapper._texts;
    var x = wrapper._settings.x;
    var lineHeight = wrapper._getLineHeight();
    var i;
    var ii;
    var item = items[0];
    $b8456380a74d5389$var$setTextNodeAttribute(item, "x", x);
    $b8456380a74d5389$var$setTextNodeAttribute(item, "y", wrapper._settings.y);
    for(i = 1, ii = items.length; i < ii; ++i){
        item = items[i];
        if (parseFloat(item.height) >= 0) {
            $b8456380a74d5389$var$setTextNodeAttribute(item, "x", x);
            var height = $b8456380a74d5389$var$getItemLineHeight(item, lineHeight);
            $b8456380a74d5389$var$setTextNodeAttribute(item, "dy", height);
        }
    }
}
function $b8456380a74d5389$var$alignTextNodes(wrapper, alignment) {
    if (!wrapper._texts || "center" === alignment) return;
    var items = wrapper._texts;
    var direction = "left" === alignment ? -1 : 1;
    var maxTextWidth = Math.max.apply(Math, items.map((t)=>$b8456380a74d5389$var$getTextWidth(t)));
    for(var i = 0; i < items.length; i++){
        var item = items[i];
        var textWidth = $b8456380a74d5389$var$getTextWidth(item);
        if (0 !== maxTextWidth && maxTextWidth !== textWidth) $b8456380a74d5389$var$setTextNodeAttribute(item, "dx", direction * $b8456380a74d5389$var$round((maxTextWidth - textWidth) / 2 * 10) / 10);
    }
}
function $b8456380a74d5389$var$maxLengthFontSize(fontSize1, fontSize2) {
    var parsedHeight1 = parseFloat(fontSize1);
    var parsedHeight2 = parseFloat(fontSize2);
    var height1 = parsedHeight1 || $b8456380a74d5389$var$DEFAULT_FONT_SIZE;
    var height2 = parsedHeight2 || $b8456380a74d5389$var$DEFAULT_FONT_SIZE;
    return height1 > height2 ? !isNaN(parsedHeight1) ? fontSize1 : height1 : !isNaN(parsedHeight2) ? fontSize2 : height2;
}
function $b8456380a74d5389$var$strokeTextNodes(wrapper) {
    if (!wrapper._texts) return;
    var items = wrapper._texts;
    var stroke = wrapper._settings[$b8456380a74d5389$var$KEY_STROKE];
    var strokeWidth = wrapper._settings[$b8456380a74d5389$var$KEY_STROKE_WIDTH];
    var strokeOpacity = wrapper._settings[$b8456380a74d5389$var$KEY_STROKE_OPACITY] || 1;
    var tspan;
    var i;
    var ii;
    for(i = 0, ii = items.length; i < ii; ++i){
        tspan = items[i].stroke;
        tspan.setAttribute($b8456380a74d5389$var$KEY_STROKE, stroke);
        tspan.setAttribute($b8456380a74d5389$var$KEY_STROKE_WIDTH, strokeWidth);
        tspan.setAttribute($b8456380a74d5389$var$KEY_STROKE_OPACITY, strokeOpacity);
        tspan.setAttribute("stroke-linejoin", "round");
    }
}
function $b8456380a74d5389$var$baseAnimate(that, params, options, complete) {
    options = options || {};
    var key;
    var value;
    var renderer = that.renderer;
    var settings = that._settings;
    var animationParams = {};
    var defaults = {
        translateX: 0,
        translateY: 0,
        scaleX: 1,
        scaleY: 1,
        rotate: 0,
        rotateX: 0,
        rotateY: 0
    };
    if (complete) options.complete = complete;
    if (renderer.animationEnabled()) {
        for(key in params){
            value = params[key];
            if (/^(translate(X|Y)|rotate[XY]?|scale(X|Y))$/i.test(key)) {
                animationParams.transform = animationParams.transform || {
                    from: {},
                    to: {}
                };
                animationParams.transform.from[key] = key in settings ? Number(settings[key].toFixed(3)) : defaults[key];
                animationParams.transform.to[key] = value;
            } else if ("arc" === key || "segments" === key) animationParams[key] = value;
            else animationParams[key] = {
                from: key in settings ? settings[key] : parseFloat(that.element.getAttribute(key) || 0),
                to: value
            };
        }
        renderer.animateElement(that, animationParams, $b8456380a74d5389$var$extend($b8456380a74d5389$var$extend({}, renderer._animation), options));
    } else {
        options.step && options.step.call(that, 1, 1);
        options.complete && options.complete.call(that);
        that.attr(params);
    }
    return that;
}
function $b8456380a74d5389$var$pathAnimate(params, options, complete) {
    var curSegments = this.segments || [];
    var newSegments;
    var endSegments;
    if (this.renderer.animationEnabled() && "points" in params) {
        newSegments = $b8456380a74d5389$var$buildPathSegments(params.points, this.type);
        endSegments = $b8456380a74d5389$var$compensateSegments(curSegments, newSegments, this.type);
        params.segments = {
            from: curSegments,
            to: newSegments,
            end: endSegments
        };
        delete params.points;
    }
    return $b8456380a74d5389$var$baseAnimate(this, params, options, complete);
}
function $b8456380a74d5389$var$arcAnimate(params, options, complete) {
    var settings = this._settings;
    var arcParams = {
        from: {},
        to: {}
    };
    if (this.renderer.animationEnabled() && ("x" in params || "y" in params || "innerRadius" in params || "outerRadius" in params || "startAngle" in params || "endAngle" in params)) {
        arcParams.from.x = settings.x || 0;
        arcParams.from.y = settings.y || 0;
        arcParams.from.innerRadius = settings.innerRadius || 0;
        arcParams.from.outerRadius = settings.outerRadius || 0;
        arcParams.from.startAngle = settings.startAngle || 0;
        arcParams.from.endAngle = settings.endAngle || 0;
        arcParams.to.x = "x" in params ? params.x : settings.x;
        delete params.x;
        arcParams.to.y = "y" in params ? params.y : settings.y;
        delete params.y;
        arcParams.to.innerRadius = "innerRadius" in params ? params.innerRadius : settings.innerRadius;
        delete params.innerRadius;
        arcParams.to.outerRadius = "outerRadius" in params ? params.outerRadius : settings.outerRadius;
        delete params.outerRadius;
        arcParams.to.startAngle = "startAngle" in params ? params.startAngle : settings.startAngle;
        delete params.startAngle;
        arcParams.to.endAngle = "endAngle" in params ? params.endAngle : settings.endAngle;
        delete params.endAngle;
        params.arc = arcParams;
    }
    return $b8456380a74d5389$var$baseAnimate(this, params, options, complete);
}
function $b8456380a74d5389$var$buildLink(target, parameters) {
    var obj = {
        is: false,
        name: parameters.name || parameters,
        after: parameters.after
    };
    if (target) obj.to = target;
    else obj.virtual = true;
    return obj;
}
var $b8456380a74d5389$export$6b4dd068c3198b62 = function(renderer, tagName, type) {
    this.renderer = renderer;
    this.element = $b8456380a74d5389$var$createElement(tagName);
    this._settings = {};
    this._styles = {};
    if ("path" === tagName) this.type = type || "line";
};
function $b8456380a74d5389$var$removeFuncIriCallback(callback) {
    $b8456380a74d5389$var$fixFuncIriCallbacks.remove(callback);
}
$b8456380a74d5389$export$6b4dd068c3198b62.prototype = {
    constructor: $b8456380a74d5389$export$6b4dd068c3198b62,
    _getJQElement: function() {
        return this._$element || (this._$element = (0, $2vlX8.default)(this.element));
    },
    _addFixIRICallback: function() {
        var that = this;
        var fn = function() {
            $b8456380a74d5389$var$fixFuncIri(that, "fill");
            $b8456380a74d5389$var$fixFuncIri(that, "clip-path");
            $b8456380a74d5389$var$fixFuncIri(that, "filter");
        };
        that.element._fixFuncIri = fn;
        fn.renderer = that.renderer;
        $b8456380a74d5389$var$fixFuncIriCallbacks.add(fn);
        that._addFixIRICallback = function() {};
    },
    _clearChildrenFuncIri: function() {
        !function clearChildren(element) {
            var i;
            for(i = 0; i < element.childNodes.length; i++){
                $b8456380a74d5389$var$removeFuncIriCallback(element.childNodes[i]._fixFuncIri);
                clearChildren(element.childNodes[i]);
            }
        }(this.element);
    },
    dispose: function() {
        $b8456380a74d5389$var$removeFuncIriCallback(this.element._fixFuncIri);
        this._clearChildrenFuncIri();
        this._getJQElement().remove();
        return this;
    },
    append: function(parent) {
        (parent || this.renderer.root).element.appendChild(this.element);
        return this;
    },
    remove: function() {
        var element = this.element;
        element.parentNode && element.parentNode.removeChild(element);
        return this;
    },
    enableLinks: function() {
        this._links = [];
        return this;
    },
    virtualLink: function(parameters) {
        $b8456380a74d5389$var$linkItem({
            _link: $b8456380a74d5389$var$buildLink(null, parameters)
        }, this);
        return this;
    },
    linkAfter: function(name) {
        this._linkAfter = name;
        return this;
    },
    linkOn: function(target, parameters) {
        this._link = $b8456380a74d5389$var$buildLink(target, parameters);
        $b8456380a74d5389$var$linkItem(this, target);
        return this;
    },
    linkOff: function() {
        $b8456380a74d5389$var$unlinkItem(this);
        this._link = null;
        return this;
    },
    linkAppend: function() {
        var link = this._link;
        var items = link.to._links;
        var i;
        var next;
        for(i = link.i + 1; (next = items[i]) && !next._link.is; ++i);
        this._insert(link.to, next);
        link.is = true;
        return this;
    },
    _insert: function(parent, next) {
        parent.element.insertBefore(this.element, next ? next.element : null);
    },
    linkRemove: function() {
        this.remove();
        this._link.is = false;
        return this;
    },
    clear: function() {
        this._clearChildrenFuncIri();
        this._getJQElement().empty();
        return this;
    },
    toBackground: function() {
        var elem = this.element;
        var parent = elem.parentNode;
        parent && parent.insertBefore(elem, parent.firstChild);
        return this;
    },
    toForeground: function() {
        var elem = this.element;
        var parent = elem.parentNode;
        parent && parent.appendChild(elem);
        return this;
    },
    attr: function(attrs) {
        return $b8456380a74d5389$var$baseAttr(this, attrs);
    },
    smartAttr: function(attrs) {
        return this.attr($b8456380a74d5389$export$828fe33043bd14cb(this, attrs));
    },
    css: function(styles) {
        return $b8456380a74d5389$var$baseCss(this, styles);
    },
    animate: function(params, options, complete) {
        return $b8456380a74d5389$var$baseAnimate(this, params, options, complete);
    },
    sharp (pos, sharpDirection) {
        return this.attr({
            sharp: pos || true,
            sharpDirection: sharpDirection
        });
    },
    _applyTransformation () {
        var tr = this._settings;
        var rotateX;
        var rotateY;
        var transformations = [];
        var sharpMode = tr.sharp;
        var trDirection = tr.sharpDirection || 1;
        var strokeOdd = tr[$b8456380a74d5389$var$KEY_STROKE_WIDTH] % 2;
        var correctionX = strokeOdd && ("h" === sharpMode || true === sharpMode) ? $b8456380a74d5389$var$SHARPING_CORRECTION * trDirection : 0;
        var correctionY = strokeOdd && ("v" === sharpMode || true === sharpMode) ? $b8456380a74d5389$var$SHARPING_CORRECTION * trDirection : 0;
        transformations.push("translate(" + ((tr.translateX || 0) + correctionX) + "," + ((tr.translateY || 0) + correctionY) + ")");
        if (tr.rotate) {
            if ("rotateX" in tr) rotateX = tr.rotateX;
            else rotateX = tr.x;
            if ("rotateY" in tr) rotateY = tr.rotateY;
            else rotateY = tr.y;
            transformations.push("rotate(" + tr.rotate + "," + (rotateX || 0) + "," + (rotateY || 0) + ")");
        }
        var scaleXDefined = (0, $6ntMu.isDefined)(tr.scaleX);
        var scaleYDefined = (0, $6ntMu.isDefined)(tr.scaleY);
        if (scaleXDefined || scaleYDefined) transformations.push("scale(" + (scaleXDefined ? tr.scaleX : 1) + "," + (scaleYDefined ? tr.scaleY : 1) + ")");
        if (transformations.length) this.element.setAttribute("transform", transformations.join(" "));
    },
    move: function(x, y, animate, animOptions) {
        var obj = {};
        (0, $6ntMu.isDefined)(x) && (obj.translateX = x);
        (0, $6ntMu.isDefined)(y) && (obj.translateY = y);
        if (!animate) this.attr(obj);
        else this.animate(obj, animOptions);
        return this;
    },
    rotate: function(angle, x, y, animate, animOptions) {
        var obj = {
            rotate: angle || 0
        };
        (0, $6ntMu.isDefined)(x) && (obj.rotateX = x);
        (0, $6ntMu.isDefined)(y) && (obj.rotateY = y);
        if (!animate) this.attr(obj);
        else this.animate(obj, animOptions);
        return this;
    },
    _getElementBBox: function() {
        var elem = this.element;
        var bBox;
        try {
            bBox = elem.getBBox && elem.getBBox();
        } catch (e) {}
        return bBox || {
            x: 0,
            y: 0,
            width: elem.offsetWidth || 0,
            height: elem.offsetHeight || 0
        };
    },
    getBBox: function() {
        var transformation = this._settings;
        var bBox = this._getElementBBox();
        if (transformation.rotate) bBox = (0, $dw9tZ.rotateBBox)(bBox, [
            ("rotateX" in transformation ? transformation.rotateX : transformation.x) || 0,
            ("rotateY" in transformation ? transformation.rotateY : transformation.y) || 0
        ], -transformation.rotate);
        else bBox = (0, $dw9tZ.normalizeBBox)(bBox);
        return bBox;
    },
    markup: function() {
        return (0, $jmNgH.getSvgMarkup)(this.element);
    },
    getOffset: function() {
        return this._getJQElement().offset();
    },
    stopAnimation: function(disableComplete) {
        var animation = this.animation;
        animation && animation.stop(disableComplete);
        return this;
    },
    setTitle: function(text) {
        var titleElem = $b8456380a74d5389$var$createElement("title");
        titleElem.textContent = text || "";
        this.element.appendChild(titleElem);
    },
    removeTitle () {
        $b8456380a74d5389$var$detachTitleElements(this.element);
    },
    data: function(obj, val) {
        var elem = this.element;
        var key;
        if (void 0 !== val) elem[obj] = val;
        else for(key in obj)elem[key] = obj[key];
        return this;
    },
    on: function() {
        var args = [
            this._getJQElement()
        ];
        args.push.apply(args, arguments);
        (0, $60GuF.default).on.apply((0, $60GuF.default), args);
        return this;
    },
    off: function() {
        var args = [
            this._getJQElement()
        ];
        args.push.apply(args, arguments);
        (0, $60GuF.default).off.apply((0, $60GuF.default), args);
        return this;
    },
    trigger: function() {
        var args = [
            this._getJQElement()
        ];
        args.push.apply(args, arguments);
        (0, $60GuF.default).trigger.apply((0, $60GuF.default), args);
        return this;
    }
};
var $b8456380a74d5389$export$bc0a0477be23e1a3 = function(renderer, type) {
    $b8456380a74d5389$export$6b4dd068c3198b62.call(this, renderer, "path", type);
};
$b8456380a74d5389$export$bc0a0477be23e1a3.prototype = $b8456380a74d5389$var$objectCreate($b8456380a74d5389$export$6b4dd068c3198b62.prototype);
$b8456380a74d5389$var$extend($b8456380a74d5389$export$bc0a0477be23e1a3.prototype, {
    constructor: $b8456380a74d5389$export$bc0a0477be23e1a3,
    attr: $b8456380a74d5389$var$pathAttr,
    animate: $b8456380a74d5389$var$pathAnimate
});
var $b8456380a74d5389$export$460a14aae81cf048 = function(renderer) {
    $b8456380a74d5389$export$6b4dd068c3198b62.call(this, renderer, "path", "arc");
};
$b8456380a74d5389$export$460a14aae81cf048.prototype = $b8456380a74d5389$var$objectCreate($b8456380a74d5389$export$6b4dd068c3198b62.prototype);
$b8456380a74d5389$var$extend($b8456380a74d5389$export$460a14aae81cf048.prototype, {
    constructor: $b8456380a74d5389$export$460a14aae81cf048,
    attr: $b8456380a74d5389$var$arcAttr,
    animate: $b8456380a74d5389$var$arcAnimate
});
var $b8456380a74d5389$export$5e0935cb660073ae = function(renderer) {
    $b8456380a74d5389$export$6b4dd068c3198b62.call(this, renderer, "rect");
};
$b8456380a74d5389$export$5e0935cb660073ae.prototype = $b8456380a74d5389$var$objectCreate($b8456380a74d5389$export$6b4dd068c3198b62.prototype);
$b8456380a74d5389$var$extend($b8456380a74d5389$export$5e0935cb660073ae.prototype, {
    constructor: $b8456380a74d5389$export$5e0935cb660073ae,
    attr: $b8456380a74d5389$var$rectAttr
});
var $b8456380a74d5389$export$133214577bbf3873 = function(renderer) {
    $b8456380a74d5389$export$6b4dd068c3198b62.call(this, renderer, "text");
    this.css({
        "white-space": "pre"
    });
};
$b8456380a74d5389$export$133214577bbf3873.prototype = $b8456380a74d5389$var$objectCreate($b8456380a74d5389$export$6b4dd068c3198b62.prototype);
$b8456380a74d5389$var$extend($b8456380a74d5389$export$133214577bbf3873.prototype, {
    constructor: $b8456380a74d5389$export$133214577bbf3873,
    attr: $b8456380a74d5389$var$textAttr,
    css: $b8456380a74d5389$var$textCss,
    applyEllipsis: $b8456380a74d5389$var$applyEllipsis,
    setMaxSize: $b8456380a74d5389$var$setMaxSize,
    restoreText: $b8456380a74d5389$var$restoreText,
    _getLineHeight () {
        return !isNaN(parseFloat(this._styles[$b8456380a74d5389$var$KEY_FONT_SIZE])) ? this._styles[$b8456380a74d5389$var$KEY_FONT_SIZE] : $b8456380a74d5389$var$DEFAULT_FONT_SIZE;
    }
});
function $b8456380a74d5389$var$updateIndexes(items, k) {
    var i;
    var item;
    for(i = k; item = items[i]; ++i)item._link.i = i;
}
function $b8456380a74d5389$var$linkItem(target, container) {
    var items = container._links;
    var key = target._link.after = target._link.after || container._linkAfter;
    var i;
    var item;
    if (key) {
        for(i = 0; (item = items[i]) && item._link.name !== key; ++i);
        if (item) {
            for(++i; (item = items[i]) && item._link.after === key; ++i);
        }
    } else i = items.length;
    items.splice(i, 0, target);
    $b8456380a74d5389$var$updateIndexes(items, i);
}
function $b8456380a74d5389$var$unlinkItem(target) {
    var i;
    var items = target._link.to._links;
    for(i = 0; items[i] !== target; ++i);
    items.splice(i, 1);
    $b8456380a74d5389$var$updateIndexes(items, i);
}
function $b8456380a74d5389$export$88530751e3977073(options) {
    this.root = this._createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        fill: $b8456380a74d5389$var$NONE,
        stroke: $b8456380a74d5389$var$NONE,
        "stroke-width": 0
    }).attr({
        class: options.cssClass
    }).css({
        "line-height": "normal",
        "-ms-user-select": $b8456380a74d5389$var$NONE,
        "-moz-user-select": $b8456380a74d5389$var$NONE,
        "-webkit-user-select": $b8456380a74d5389$var$NONE,
        "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)",
        display: "block",
        overflow: "hidden"
    });
    this._init();
    this.pathModified = !!options.pathModified;
    this._$container = (0, $2vlX8.default)(options.container);
    this.root.append({
        element: options.container
    });
    this._locker = 0;
    this._backed = false;
}
$b8456380a74d5389$export$88530751e3977073.prototype = {
    constructor: $b8456380a74d5389$export$88530751e3977073,
    _init: function() {
        this._defs = this._createElement("defs").append(this.root);
        this._animationController = new (0, $6jumB.AnimationController)(this.root.element);
        this._animation = {
            enabled: true,
            duration: 1e3,
            easing: "easeOutCubic"
        };
    },
    setOptions: function(options) {
        this.rtl = !!options.rtl;
        this.encodeHtml = !!options.encodeHtml;
        this.updateAnimationOptions(options.animation || {});
        this.root.attr({
            direction: this.rtl ? "rtl" : "ltr"
        });
        return this;
    },
    _createElement: function(tagName, attr, type) {
        var elem = new $b8456380a74d5389$export$6b4dd068c3198b62(this, tagName, type);
        attr && elem.attr(attr);
        return elem;
    },
    lock: function() {
        if (0 === this._locker) {
            this._backed = !this._$container.is(":visible");
            if (this._backed) $b8456380a74d5389$var$backupRoot(this.root);
        }
        ++this._locker;
        return this;
    },
    unlock: function() {
        --this._locker;
        if (0 === this._locker) {
            if (this._backed) $b8456380a74d5389$var$restoreRoot(this.root, this._$container[0]);
            this._backed = false;
        }
        return this;
    },
    resize: function(width, height) {
        if (width >= 0 && height >= 0) this.root.attr({
            width: width,
            height: height
        });
        return this;
    },
    dispose: function() {
        var key;
        this.root.dispose();
        this._defs.dispose();
        this._animationController.dispose();
        $b8456380a74d5389$var$fixFuncIriCallbacks.removeByRenderer(this);
        for(key in this)this[key] = null;
        return this;
    },
    animationEnabled: function() {
        return !!this._animation.enabled;
    },
    updateAnimationOptions: function(newOptions) {
        $b8456380a74d5389$var$extend(this._animation, newOptions);
        return this;
    },
    stopAllAnimations: function(lock) {
        this._animationController[lock ? "lock" : "stop"]();
        return this;
    },
    animateElement: function(element, params, options) {
        this._animationController.animateElement(element, params, options);
        return this;
    },
    svg: function() {
        return this.root.markup();
    },
    getRootOffset: function() {
        return this.root.getOffset();
    },
    onEndAnimation: function(endAnimation) {
        this._animationController.onEndAnimation(endAnimation);
    },
    rect: function(x, y, width, height) {
        var elem = new $b8456380a74d5389$export$5e0935cb660073ae(this);
        return elem.attr({
            x: x || 0,
            y: y || 0,
            width: width || 0,
            height: height || 0
        });
    },
    simpleRect: function() {
        return this._createElement("rect");
    },
    circle: function(x, y, r) {
        return this._createElement("circle", {
            cx: x || 0,
            cy: y || 0,
            r: r || 0
        });
    },
    g: function() {
        return this._createElement("g");
    },
    image: function(x, y, w, h, href, location) {
        var image = this._createElement("image", {
            x: x || 0,
            y: y || 0,
            width: w || 0,
            height: h || 0,
            preserveAspectRatio: $b8456380a74d5389$var$preserveAspectRatioMap[(0, $dw9tZ.normalizeEnum)(location)] || $b8456380a74d5389$var$NONE
        });
        image.element.setAttributeNS("http://www.w3.org/1999/xlink", "href", href || "");
        return image;
    },
    path: function(points, type) {
        var elem = new $b8456380a74d5389$export$bc0a0477be23e1a3(this, type);
        return elem.attr({
            points: points || []
        });
    },
    arc: function(x, y, innerRadius, outerRadius, startAngle, endAngle) {
        var elem = new $b8456380a74d5389$export$460a14aae81cf048(this);
        return elem.attr({
            x: x || 0,
            y: y || 0,
            innerRadius: innerRadius || 0,
            outerRadius: outerRadius || 0,
            startAngle: startAngle || 0,
            endAngle: endAngle || 0
        });
    },
    text: function(_text, x, y) {
        var elem = new $b8456380a74d5389$export$133214577bbf3873(this);
        return elem.attr({
            text: _text,
            x: x || 0,
            y: y || 0
        });
    },
    linearGradient: function(stops) {
        var id = $b8456380a74d5389$var$getNextDefsSvgId();
        var that = this;
        var gradient = that._createElement("linearGradient", {
            id: id
        }).append(that._defs);
        gradient.id = id;
        stops.forEach((stop)=>{
            that._createElement("stop", {
                offset: stop.offset,
                "stop-color": stop["stop-color"]
            }).append(gradient);
        });
        return gradient;
    },
    pattern: function(color, hatching, _id) {
        hatching = hatching || {};
        var step = hatching.step || 6;
        var stepTo2 = step / 2;
        var stepBy15 = 1.5 * step;
        var id = _id || $b8456380a74d5389$var$getNextDefsSvgId();
        var d = "right" === (0, $dw9tZ.normalizeEnum)(hatching.direction) ? "M " + stepTo2 + " " + -stepTo2 + " L " + -stepTo2 + " " + stepTo2 + " M 0 " + step + " L " + step + " 0 M " + stepBy15 + " " + stepTo2 + " L " + stepTo2 + " " + stepBy15 : "M 0 0 L " + step + " " + step + " M " + -stepTo2 + " " + stepTo2 + " L " + stepTo2 + " " + stepBy15 + " M " + stepTo2 + " " + -stepTo2 + " L " + stepBy15 + " " + stepTo2;
        var pattern = this._createElement("pattern", {
            id: id,
            width: step,
            height: step,
            patternUnits: "userSpaceOnUse"
        }).append(this._defs);
        pattern.id = id;
        this.rect(0, 0, step, step).attr({
            fill: color,
            opacity: hatching.opacity
        }).append(pattern);
        new $b8456380a74d5389$export$bc0a0477be23e1a3(this).attr({
            d: d,
            "stroke-width": hatching.width || 1,
            stroke: color
        }).append(pattern);
        return pattern;
    },
    _getPointsWithYOffset: function(points, offset) {
        return points.map(function(point, index) {
            if (index % 2 !== 0) return point + offset;
            return point;
        });
    },
    clipShape: function(method, methodArgs) {
        var id = $b8456380a74d5389$var$getNextDefsSvgId();
        var clipPath = this._createElement("clipPath", {
            id: id
        }).append(this._defs);
        var shape = method.apply(this, methodArgs).append(clipPath);
        shape.id = id;
        shape.remove = function() {
            throw "Not implemented";
        };
        shape.dispose = function() {
            clipPath.dispose();
            clipPath = null;
            return this;
        };
        return shape;
    },
    clipRect (x, y, width, height) {
        return this.clipShape(this.rect, arguments);
    },
    clipCircle (x, y, radius) {
        return this.clipShape(this.circle, arguments);
    },
    shadowFilter: function(x, y, width, height, offsetX, offsetY, blur, color, opacity) {
        var id = $b8456380a74d5389$var$getNextDefsSvgId();
        var filter = this._createElement("filter", {
            id: id,
            x: x || 0,
            y: y || 0,
            width: width || 0,
            height: height || 0
        }).append(this._defs);
        var gaussianBlur = this._createElement("feGaussianBlur", {
            in: "SourceGraphic",
            result: "gaussianBlurResult",
            stdDeviation: blur || 0
        }).append(filter);
        var offset = this._createElement("feOffset", {
            in: "gaussianBlurResult",
            result: "offsetResult",
            dx: offsetX || 0,
            dy: offsetY || 0
        }).append(filter);
        var flood = this._createElement("feFlood", {
            result: "floodResult",
            "flood-color": color || "",
            "flood-opacity": opacity
        }).append(filter);
        var composite = this._createElement("feComposite", {
            in: "floodResult",
            in2: "offsetResult",
            operator: "in",
            result: "compositeResult"
        }).append(filter);
        var finalComposite = this._createElement("feComposite", {
            in: "SourceGraphic",
            in2: "compositeResult",
            operator: "over"
        }).append(filter);
        filter.id = id;
        filter.gaussianBlur = gaussianBlur;
        filter.offset = offset;
        filter.flood = flood;
        filter.composite = composite;
        filter.finalComposite = finalComposite;
        filter.attr = function(attrs) {
            var filterAttrs = {};
            var offsetAttrs = {};
            var floodAttrs = {};
            "x" in attrs && (filterAttrs.x = attrs.x);
            "y" in attrs && (filterAttrs.y = attrs.y);
            "width" in attrs && (filterAttrs.width = attrs.width);
            "height" in attrs && (filterAttrs.height = attrs.height);
            $b8456380a74d5389$var$baseAttr(this, filterAttrs);
            "blur" in attrs && this.gaussianBlur.attr({
                stdDeviation: attrs.blur
            });
            "offsetX" in attrs && (offsetAttrs.dx = attrs.offsetX);
            "offsetY" in attrs && (offsetAttrs.dy = attrs.offsetY);
            this.offset.attr(offsetAttrs);
            "color" in attrs && (floodAttrs["flood-color"] = attrs.color);
            "opacity" in attrs && (floodAttrs["flood-opacity"] = attrs.opacity);
            this.flood.attr(floodAttrs);
            return this;
        };
        return filter;
    },
    brightFilter: function(type, slope) {
        var id = $b8456380a74d5389$var$getNextDefsSvgId();
        var filter = this._createElement("filter", {
            id: id
        }).append(this._defs);
        var componentTransferElement = this._createElement("feComponentTransfer").append(filter);
        var attrs = {
            type: type,
            slope: slope
        };
        filter.id = id;
        this._createElement("feFuncR", attrs).append(componentTransferElement);
        this._createElement("feFuncG", attrs).append(componentTransferElement);
        this._createElement("feFuncB", attrs).append(componentTransferElement);
        return filter;
    },
    getGrayScaleFilter: function() {
        if (this._grayScaleFilter) return this._grayScaleFilter;
        var id = $b8456380a74d5389$var$getNextDefsSvgId();
        var filter = this._createElement("filter", {
            id: id
        }).append(this._defs);
        this._createElement("feColorMatrix").attr({
            type: "matrix",
            values: "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 0.6 0"
        }).append(filter);
        filter.id = id;
        this._grayScaleFilter = filter;
        return filter;
    },
    initHatching: function() {
        var storage = this._hatchingStorage = this._hatchingStorage || {
            byHash: {},
            baseId: $b8456380a74d5389$var$getNextDefsSvgId()
        };
        var byHash = storage.byHash;
        var name;
        for(name in byHash)byHash[name].pattern.dispose();
        storage.byHash = {};
        storage.refToHash = {};
        storage.nextId = 0;
    },
    lockHatching: function(color, hatching, ref) {
        var storage = this._hatchingStorage;
        var hash = $b8456380a74d5389$var$getHatchingHash(color, hatching);
        var storageItem;
        var pattern;
        if (storage.refToHash[ref] !== hash) {
            if (ref) this.releaseHatching(ref);
            storageItem = storage.byHash[hash];
            if (!storageItem) {
                pattern = this.pattern(color, hatching, storage.baseId + "-hatching-" + storage.nextId++);
                storageItem = storage.byHash[hash] = {
                    pattern: pattern,
                    count: 0
                };
                storage.refToHash[pattern.id] = hash;
            }
            ++storageItem.count;
            ref = storageItem.pattern.id;
        }
        return ref;
    },
    releaseHatching: function(ref) {
        var storage = this._hatchingStorage;
        var hash = storage.refToHash[ref];
        var storageItem = storage.byHash[hash];
        if (storageItem && 0 === --storageItem.count) {
            storageItem.pattern.dispose();
            delete storage.byHash[hash];
            delete storage.refToHash[ref];
        }
    }
};
function $b8456380a74d5389$var$getHatchingHash(color, hatching) {
    return "@" + color + "::" + hatching.step + ":" + hatching.width + ":" + hatching.opacity + ":" + hatching.direction;
}
var $b8456380a74d5389$var$fixFuncIriCallbacks = function() {
    var callbacks = [];
    return {
        add: function(fn) {
            callbacks.push(fn);
        },
        remove: function(fn) {
            callbacks = callbacks.filter(function(el) {
                return el !== fn;
            });
        },
        removeByRenderer: function(renderer) {
            callbacks = callbacks.filter(function(el) {
                return el.renderer !== renderer;
            });
        },
        fire: function() {
            callbacks.forEach(function(fn) {
                fn();
            });
        }
    };
}();
var $b8456380a74d5389$export$2b1777ef4ef71559 = function() {
    $b8456380a74d5389$var$fixFuncIriCallbacks.fire();
};

});
parcelRegister("jmNgH", function(module, exports) {

$parcel$export(module.exports, "HIDDEN_FOR_EXPORT", function () { return $e1964a0988eeea8f$export$e8af8369f0b5a48a; });
$parcel$export(module.exports, "getSvgMarkup", function () { return $e1964a0988eeea8f$export$b5773b92cfd2efdb; });
$parcel$export(module.exports, "getSvgElement", function () { return $e1964a0988eeea8f$export$924fe7b4c497c463; });
/**
 * DevExtreme (esm/core/utils/svg.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $3yzYM = parcelRequire("3yzYM");

var $hYatw = parcelRequire("hYatw");

var $2vlX8 = parcelRequire("2vlX8");
var $e1964a0988eeea8f$var$window = (0, $hYatw.getWindow)();
function $e1964a0988eeea8f$var$getMarkup(element, backgroundColor) {
    var temp = (0, $3yzYM.default).createElement("div");
    var clone = element.cloneNode(true);
    if (backgroundColor) (0, $2vlX8.default)(clone).css("backgroundColor", backgroundColor);
    temp.appendChild(clone);
    return temp.innerHTML;
}
function $e1964a0988eeea8f$var$fixNamespaces(markup) {
    var first = true;
    if (-1 === markup.indexOf("xmlns:xlink")) markup = markup.replace("<svg", '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
    markup = markup.replace(/xmlns="[\s\S]*?"/gi, function(match) {
        if (!first) return "";
        first = false;
        return match;
    });
    return markup.replace(/xmlns:NS1="[\s\S]*?"/gi, "").replace(/NS1:xmlns:xlink="([\s\S]*?)"/gi, 'xmlns:xlink="$1"');
}
function $e1964a0988eeea8f$var$decodeHtmlEntities(markup) {
    return markup.replace(/&quot;/gi, "&#34;").replace(/&amp;/gi, "&#38;").replace(/&apos;/gi, "&#39;").replace(/&lt;/gi, "&#60;").replace(/&gt;/gi, "&#62;").replace(/&nbsp;/gi, "&#160;").replace(/&shy;/gi, "&#173;");
}
var $e1964a0988eeea8f$export$e8af8369f0b5a48a = "hidden-for-export";
function $e1964a0988eeea8f$export$b5773b92cfd2efdb(element, backgroundColor) {
    return $e1964a0988eeea8f$var$fixNamespaces($e1964a0988eeea8f$var$decodeHtmlEntities($e1964a0988eeea8f$var$getMarkup(element, backgroundColor)));
}
function $e1964a0988eeea8f$export$924fe7b4c497c463(markup) {
    return (0, $3yzYM.default).isNode(markup) ? markup : (new $e1964a0988eeea8f$var$window.DOMParser).parseFromString(markup, "image/svg+xml").childNodes[0];
}

});

parcelRegister("6jumB", function(module, exports) {

$parcel$export(module.exports, "AnimationController", function () { return $498c11fc039ba693$export$1f1fba5c4d5199c6; });
/**
 * DevExtreme (esm/viz/core/renderers/animation.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $9gxmQ = parcelRequire("9gxmQ");
var $498c11fc039ba693$var$noop = function() {};
var $498c11fc039ba693$export$742424a10dd87ed1 = {
    easeOutCubic: function(pos, start, end) {
        return 1 === pos ? end : (1 - Math.pow(1 - pos, 3)) * (end - start) + +start;
    },
    linear: function(pos, start, end) {
        return 1 === pos ? end : pos * (end - start) + +start;
    }
};
var $498c11fc039ba693$export$8f5e661f304f76ad = {
    segments: function(elem, params, progress, easing, currentParams) {
        var from = params.from;
        var to = params.to;
        var curSeg;
        var seg;
        var i;
        var j;
        var segments = [];
        for(i = 0; i < from.length; i++){
            curSeg = from[i];
            seg = [
                curSeg[0]
            ];
            if (curSeg.length > 1) for(j = 1; j < curSeg.length; j++)seg.push(easing(progress, curSeg[j], to[i][j]));
            segments.push(seg);
        }
        currentParams.segments = params.end && 1 === progress ? params.end : segments;
        elem.attr({
            segments: segments
        });
    },
    arc: function(elem, params, progress, easing) {
        var from = params.from;
        var to = params.to;
        var current = {};
        for(var i in from)current[i] = easing(progress, from[i], to[i]);
        elem.attr(current);
    },
    transform: function(elem, params, progress, easing, currentParams) {
        var from = params.from;
        var to = params.to;
        var current = {};
        for(var i in from)current[i] = currentParams[i] = easing(progress, from[i], to[i]);
        elem.attr(current);
    },
    base: function(elem, params, progress, easing, currentParams, attributeName) {
        var obj = {};
        obj[attributeName] = currentParams[attributeName] = easing(progress, params.from, params.to);
        elem.attr(obj);
    },
    _: $498c11fc039ba693$var$noop,
    complete: function(element, currentSettings) {
        element.attr(currentSettings);
    }
};
function $498c11fc039ba693$var$step(now) {
    var animateStep = this._animateStep;
    var attrName;
    this._progress = this._calcProgress(now);
    for(attrName in this.params){
        var anim = animateStep[attrName] || animateStep.base;
        anim(this.element, this.params[attrName], this._progress, this._easing, this._currentParams, attrName);
    }
    this.options.step && this.options.step(this._easing(this._progress, 0, 1), this._progress);
    if (1 === this._progress) return this.stop();
    return true;
}
function $498c11fc039ba693$var$delayTick(now) {
    if (now - this._startTime >= this.delay) this.tick = $498c11fc039ba693$var$step;
    return true;
}
function $498c11fc039ba693$var$start(now) {
    this._startTime = now;
    this.tick = this.delay ? $498c11fc039ba693$var$delayTick : $498c11fc039ba693$var$step;
    return true;
}
function $498c11fc039ba693$var$Animation(element, params, options) {
    this._progress = 0;
    this.element = element;
    this.params = params;
    this.options = options;
    this.duration = options.partitionDuration ? options.duration * options.partitionDuration : options.duration;
    this.delay = options.delay && options.duration * options.delay || 0;
    this._animateStep = options.animateStep || $498c11fc039ba693$export$8f5e661f304f76ad;
    this._easing = $498c11fc039ba693$export$742424a10dd87ed1[options.easing] || $498c11fc039ba693$export$742424a10dd87ed1.easeOutCubic;
    this._currentParams = {};
    this.tick = $498c11fc039ba693$var$start;
}
$498c11fc039ba693$var$Animation.prototype = {
    _calcProgress: function(now) {
        return Math.min(1, (now - this.delay - this._startTime) / this.duration);
    },
    stop: function(disableComplete) {
        var options = this.options;
        var animateStep = this._animateStep;
        this.stop = this.tick = $498c11fc039ba693$var$noop;
        animateStep.complete && animateStep.complete(this.element, this._currentParams);
        options.complete && !disableComplete && options.complete();
    }
};
function $498c11fc039ba693$export$1f1fba5c4d5199c6(element) {
    this._animationCount = 0;
    this._timerId = null;
    this._animations = {};
    this.element = element;
}
$498c11fc039ba693$export$1f1fba5c4d5199c6.prototype = {
    _loop: function() {
        var that = this;
        var animations = that._animations;
        var activeAnimation = 0;
        var now = (new Date).getTime();
        var an;
        var endAnimation = that._endAnimation;
        for(an in animations){
            if (!animations[an].tick(now)) delete animations[an];
            activeAnimation++;
        }
        if (0 === activeAnimation) {
            that.stop();
            that._endAnimationTimer = endAnimation && setTimeout(function() {
                if (0 === that._animationCount) {
                    endAnimation();
                    that._endAnimation = null;
                }
            });
            return;
        }
        that._timerId = (0, $9gxmQ.requestAnimationFrame).call(null, function() {
            that._loop();
        }, that.element);
    },
    addAnimation: function(animation) {
        var that = this;
        that._animations[that._animationCount++] = animation;
        clearTimeout(that._endAnimationTimer);
        if (!that._timerId) {
            clearTimeout(that._startDelay);
            that._startDelay = setTimeout(function() {
                that._timerId = 1;
                that._loop();
            }, 0);
        }
    },
    animateElement: function(elem, params, options) {
        if (elem && params && options) {
            elem.animation && elem.animation.stop();
            this.addAnimation(elem.animation = new $498c11fc039ba693$var$Animation(elem, params, options));
        }
    },
    onEndAnimation: function(endAnimation) {
        this._animationCount ? this._endAnimation = endAnimation : endAnimation();
    },
    dispose: function() {
        this.stop();
        this.element = null;
    },
    stop: function() {
        this._animations = {};
        this._animationCount = 0;
        (0, $9gxmQ.cancelAnimationFrame)(this._timerId);
        clearTimeout(this._startDelay);
        clearTimeout(this._endAnimationTimer);
        this._timerId = null;
    },
    lock: function() {
        var an;
        var animations = this._animations;
        var unstoppable;
        var hasUnstoppableInAnimations;
        for(an in animations){
            unstoppable = animations[an].options.unstoppable;
            hasUnstoppableInAnimations = hasUnstoppableInAnimations || unstoppable;
            if (!unstoppable) {
                animations[an].stop(true);
                delete animations[an];
            }
        }
        !hasUnstoppableInAnimations && this.stop();
    }
};

});
parcelRegister("9gxmQ", function(module, exports) {

$parcel$export(module.exports, "requestAnimationFrame", function () { return $01bdab518cf3e4a0$export$6cb2c4c0a22909c0; });
$parcel$export(module.exports, "cancelAnimationFrame", function () { return $01bdab518cf3e4a0$export$e00521de187a817a; });
/**
 * DevExtreme (esm/animation/frame.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $hYatw = parcelRequire("hYatw");

var $k2ifc = parcelRequire("k2ifc");
var $01bdab518cf3e4a0$var$window = (0, $hYatw.hasWindow)() ? (0, $hYatw.getWindow)() : {};
var $01bdab518cf3e4a0$var$FRAME_ANIMATION_STEP_TIME = 1e3 / 60;
var $01bdab518cf3e4a0$var$request = function(callback) {
    return setTimeout(callback, $01bdab518cf3e4a0$var$FRAME_ANIMATION_STEP_TIME);
};
var $01bdab518cf3e4a0$var$cancel = function(requestID) {
    clearTimeout(requestID);
};
var $01bdab518cf3e4a0$var$setAnimationFrameMethods = (0, $k2ifc.default)(function() {
    var nativeRequest = $01bdab518cf3e4a0$var$window.requestAnimationFrame || $01bdab518cf3e4a0$var$window.webkitRequestAnimationFrame || $01bdab518cf3e4a0$var$window.mozRequestAnimationFrame || $01bdab518cf3e4a0$var$window.oRequestAnimationFrame || $01bdab518cf3e4a0$var$window.msRequestAnimationFrame;
    var nativeCancel = $01bdab518cf3e4a0$var$window.cancelAnimationFrame || $01bdab518cf3e4a0$var$window.webkitCancelAnimationFrame || $01bdab518cf3e4a0$var$window.mozCancelAnimationFrame || $01bdab518cf3e4a0$var$window.oCancelAnimationFrame || $01bdab518cf3e4a0$var$window.msCancelAnimationFrame;
    if (nativeRequest && nativeCancel) {
        $01bdab518cf3e4a0$var$request = nativeRequest;
        $01bdab518cf3e4a0$var$cancel = nativeCancel;
    }
});
function $01bdab518cf3e4a0$export$6cb2c4c0a22909c0() {
    $01bdab518cf3e4a0$var$setAnimationFrameMethods();
    return $01bdab518cf3e4a0$var$request.apply($01bdab518cf3e4a0$var$window, arguments);
}
function $01bdab518cf3e4a0$export$e00521de187a817a() {
    $01bdab518cf3e4a0$var$setAnimationFrameMethods();
    $01bdab518cf3e4a0$var$cancel.apply($01bdab518cf3e4a0$var$window, arguments);
}

});


parcelRegister("dw9tZ", function(module, exports) {

$parcel$export(module.exports, "PANE_PADDING", function () { return $9d759e9c843dcecf$export$d76623ea710c7ef4; });
$parcel$export(module.exports, "getLog", function () { return $9d759e9c843dcecf$export$29ce6c7518aa120; });
$parcel$export(module.exports, "getAdjustedLog10", function () { return $9d759e9c843dcecf$export$efab1957ed4183d9; });
$parcel$export(module.exports, "raiseTo", function () { return $9d759e9c843dcecf$export$db748d98fe9116b0; });
$parcel$export(module.exports, "normalizeAngle", function () { return $9d759e9c843dcecf$export$e3df76cf4464bc81; });
$parcel$export(module.exports, "degreesToRadians", function () { return $9d759e9c843dcecf$export$c9fcf1a7df975d78; });
$parcel$export(module.exports, "getCosAndSin", function () { return $9d759e9c843dcecf$export$5a29bde0961391df; });
$parcel$export(module.exports, "getDistance", function () { return $9d759e9c843dcecf$export$79376507b09a66f; });
$parcel$export(module.exports, "getPower", function () { return $9d759e9c843dcecf$export$9e3e286bc86adab1; });
$parcel$export(module.exports, "map", function () { return $9d759e9c843dcecf$export$871de8747c9eaa88; });
$parcel$export(module.exports, "normalizeEnum", function () { return $9d759e9c843dcecf$export$6477141bf0c21c3; });
$parcel$export(module.exports, "setCanvasValues", function () { return $9d759e9c843dcecf$export$83fd4eca237a5102; });
$parcel$export(module.exports, "normalizeBBox", function () { return $9d759e9c843dcecf$export$8371a89a07196014; });
$parcel$export(module.exports, "rotateBBox", function () { return $9d759e9c843dcecf$export$d95c3218377632ec; });
$parcel$export(module.exports, "parseScalar", function () { return $9d759e9c843dcecf$export$7d7c25de1533d2be; });
$parcel$export(module.exports, "enumParser", function () { return $9d759e9c843dcecf$export$582b9b0b472ba4be; });
$parcel$export(module.exports, "patchFontOptions", function () { return $9d759e9c843dcecf$export$48111a094a22f378; });
$parcel$export(module.exports, "convertPolarToXY", function () { return $9d759e9c843dcecf$export$c70785f0b64b6e38; });
$parcel$export(module.exports, "convertXYToPolar", function () { return $9d759e9c843dcecf$export$3056fee568ab949b; });
$parcel$export(module.exports, "processSeriesTemplate", function () { return $9d759e9c843dcecf$export$125006affc5d5ba4; });
$parcel$export(module.exports, "getCategoriesInfo", function () { return $9d759e9c843dcecf$export$324a84b0bdb301f2; });
$parcel$export(module.exports, "isRelativeHeightPane", function () { return $9d759e9c843dcecf$export$87e7b77bbd65e07c; });
$parcel$export(module.exports, "normalizePanesHeight", function () { return $9d759e9c843dcecf$export$d0bf1282cca31d51; });
$parcel$export(module.exports, "updatePanesCanvases", function () { return $9d759e9c843dcecf$export$1a876d6dce9cce0f; });
$parcel$export(module.exports, "unique", function () { return $9d759e9c843dcecf$export$7a5d5c156e7dc406; });
$parcel$export(module.exports, "getVerticallyShiftedAngularCoords", function () { return $9d759e9c843dcecf$export$8a115f80deb97d6d; });
$parcel$export(module.exports, "mergeMarginOptions", function () { return $9d759e9c843dcecf$export$15411f25bc80d4c8; });
$parcel$export(module.exports, "getVizRangeObject", function () { return $9d759e9c843dcecf$export$b505dc781e07ac4e; });
$parcel$export(module.exports, "convertVisualRangeObject", function () { return $9d759e9c843dcecf$export$c443a7bc25af7150; });
$parcel$export(module.exports, "getAddFunction", function () { return $9d759e9c843dcecf$export$a15af90b344a0a9b; });
$parcel$export(module.exports, "getLogExt", function () { return $9d759e9c843dcecf$export$4523bf4b2e77435d; });
$parcel$export(module.exports, "raiseToExt", function () { return $9d759e9c843dcecf$export$52cbb36cac4c00d8; });
$parcel$export(module.exports, "adjustVisualRange", function () { return $9d759e9c843dcecf$export$93d7c9e6ef4c1a2a; });
$parcel$export(module.exports, "rangesAreEqual", function () { return $9d759e9c843dcecf$export$a724a797ec23e302; });
$parcel$export(module.exports, "valueOf", function () { return $9d759e9c843dcecf$export$7382f6d93b8122b1; });
$parcel$export(module.exports, "pointInCanvas", function () { return $9d759e9c843dcecf$export$8d11b3b7f3f68c2b; });
/**
 * DevExtreme (esm/viz/core/utils.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $gcp4g = parcelRequire("gcp4g");

var $6ntMu = parcelRequire("6ntMu");

var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $laqiS = parcelRequire("laqiS");

var $f38Z1 = parcelRequire("f38Z1");

var $lmWRz = parcelRequire("lmWRz");
var { PI: $9d759e9c843dcecf$var$PI, LN10: $9d759e9c843dcecf$var$LN10, abs: $9d759e9c843dcecf$var$abs, log: $9d759e9c843dcecf$var$log, floor: $9d759e9c843dcecf$var$floor, ceil: $9d759e9c843dcecf$var$ceil, pow: $9d759e9c843dcecf$var$pow, sqrt: $9d759e9c843dcecf$var$sqrt, atan2: $9d759e9c843dcecf$var$atan2 } = Math;
var $9d759e9c843dcecf$var$_min = Math.min;
var $9d759e9c843dcecf$var$_max = Math.max;
var $9d759e9c843dcecf$var$_cos = Math.cos;
var $9d759e9c843dcecf$var$_sin = Math.sin;
var $9d759e9c843dcecf$var$_round = Math.round;
var $9d759e9c843dcecf$var$dateToMilliseconds = (0, $f38Z1.default).dateToMilliseconds;
var $9d759e9c843dcecf$var$MAX_PIXEL_COUNT = 1e10;
var $9d759e9c843dcecf$var$PI_DIV_180 = $9d759e9c843dcecf$var$PI / 180;
var $9d759e9c843dcecf$var$_isNaN = isNaN;
var $9d759e9c843dcecf$var$_Number = Number;
var $9d759e9c843dcecf$var$_NaN = NaN;
var $9d759e9c843dcecf$export$d76623ea710c7ef4 = 10;
var $9d759e9c843dcecf$export$29ce6c7518aa120 = function(value, base) {
    if (!value) return $9d759e9c843dcecf$var$_NaN;
    return $9d759e9c843dcecf$var$log(value) / $9d759e9c843dcecf$var$log(base);
};
var $9d759e9c843dcecf$export$efab1957ed4183d9 = function(value) {
    return (0, $laqiS.adjust)($9d759e9c843dcecf$export$29ce6c7518aa120(value, 10));
};
var $9d759e9c843dcecf$export$db748d98fe9116b0 = function(power, base) {
    return $9d759e9c843dcecf$var$pow(base, power);
};
var $9d759e9c843dcecf$export$e3df76cf4464bc81 = function(angle) {
    return (angle % 360 + 360) % 360;
};
var $9d759e9c843dcecf$export$d7d072c016d8bdd8 = function(angle) {
    return 90 - angle;
};
var $9d759e9c843dcecf$export$c9fcf1a7df975d78 = function(value) {
    return $9d759e9c843dcecf$var$PI * value / 180;
};
var $9d759e9c843dcecf$export$5a29bde0961391df = function(angle) {
    var angleInRadians = $9d759e9c843dcecf$export$c9fcf1a7df975d78(angle);
    return {
        cos: $9d759e9c843dcecf$var$_cos(angleInRadians),
        sin: $9d759e9c843dcecf$var$_sin(angleInRadians)
    };
};
var $9d759e9c843dcecf$var$DECIMAL_ORDER_THRESHOLD = 1e-14;
var $9d759e9c843dcecf$export$79376507b09a66f = function(x1, y1, x2, y2) {
    var diffX = x2 - x1;
    var diffY = y2 - y1;
    return $9d759e9c843dcecf$var$sqrt(diffY * diffY + diffX * diffX);
};
var $9d759e9c843dcecf$export$58fe1760242815f2 = function(number) {
    var n = $9d759e9c843dcecf$var$abs(number);
    var cn;
    if (!$9d759e9c843dcecf$var$_isNaN(n)) {
        if (n > 0) {
            n = $9d759e9c843dcecf$var$log(n) / $9d759e9c843dcecf$var$LN10;
            cn = $9d759e9c843dcecf$var$ceil(n);
            return cn - n < $9d759e9c843dcecf$var$DECIMAL_ORDER_THRESHOLD ? cn : $9d759e9c843dcecf$var$floor(n);
        }
        return 0;
    }
    return $9d759e9c843dcecf$var$_NaN;
};
var $9d759e9c843dcecf$export$2d03b9f199a58a34 = function(start, end, count) {
    var order = $9d759e9c843dcecf$var$_max($9d759e9c843dcecf$export$58fe1760242815f2(start), $9d759e9c843dcecf$export$58fe1760242815f2(end));
    var precision = -$9d759e9c843dcecf$export$58fe1760242815f2($9d759e9c843dcecf$var$abs(end - start) / count);
    var format;
    if (!$9d759e9c843dcecf$var$_isNaN(order) && !$9d759e9c843dcecf$var$_isNaN(precision)) {
        if ($9d759e9c843dcecf$var$abs(order) <= 4) {
            format = "fixedPoint";
            precision < 0 && (precision = 0);
            precision > 4 && (precision = 4);
        } else {
            format = "exponential";
            precision += order - 1;
            precision > 3 && (precision = 3);
        }
        return {
            type: format,
            precision: precision
        };
    }
    return null;
};
var $9d759e9c843dcecf$export$6dc2969fe47f79f = function(value, precision) {
    if (precision > 20) precision = 20;
    if ((0, $6ntMu.isNumeric)(value)) {
        if ((0, $6ntMu.isExponential)(value)) return $9d759e9c843dcecf$var$_Number(value.toExponential(precision));
        else return $9d759e9c843dcecf$var$_Number(value.toFixed(precision));
    }
};
var $9d759e9c843dcecf$export$9e3e286bc86adab1 = function(value) {
    return value.toExponential().split("e")[1];
};
function $9d759e9c843dcecf$export$871de8747c9eaa88(array, callback) {
    var i = 0;
    var len = array.length;
    var result = [];
    var value;
    while(i < len){
        value = callback(array[i], i);
        if (null !== value) result.push(value);
        i++;
    }
    return result;
}
function $9d759e9c843dcecf$var$selectByKeys(object, keys) {
    return $9d759e9c843dcecf$export$871de8747c9eaa88(keys, (key)=>object[key] ? object[key] : null);
}
function $9d759e9c843dcecf$var$decreaseFields(object, keys, eachDecrease, decrease) {
    var dec = decrease;
    (0, $8OLOW.each)(keys, (_, key)=>{
        if (object[key]) {
            object[key] -= eachDecrease;
            dec -= eachDecrease;
        }
    });
    return dec;
}
function $9d759e9c843dcecf$export$6477141bf0c21c3(value) {
    return String(value).toLowerCase();
}
function $9d759e9c843dcecf$export$83fd4eca237a5102(canvas) {
    if (canvas) {
        canvas.originalTop = canvas.top;
        canvas.originalBottom = canvas.bottom;
        canvas.originalLeft = canvas.left;
        canvas.originalRight = canvas.right;
    }
    return canvas;
}
function $9d759e9c843dcecf$var$normalizeBBoxField(value) {
    return -$9d759e9c843dcecf$var$MAX_PIXEL_COUNT < value && value < +$9d759e9c843dcecf$var$MAX_PIXEL_COUNT ? value : 0;
}
function $9d759e9c843dcecf$export$8371a89a07196014(bBox) {
    var xl = $9d759e9c843dcecf$var$normalizeBBoxField($9d759e9c843dcecf$var$floor(bBox.x));
    var yt = $9d759e9c843dcecf$var$normalizeBBoxField($9d759e9c843dcecf$var$floor(bBox.y));
    var xr = $9d759e9c843dcecf$var$normalizeBBoxField($9d759e9c843dcecf$var$ceil(bBox.width + bBox.x));
    var yb = $9d759e9c843dcecf$var$normalizeBBoxField($9d759e9c843dcecf$var$ceil(bBox.height + bBox.y));
    var result = {
        x: xl,
        y: yt,
        width: xr - xl,
        height: yb - yt
    };
    result.isEmpty = !result.x && !result.y && !result.width && !result.height;
    return result;
}
function $9d759e9c843dcecf$export$d95c3218377632ec(bBox, center, angle) {
    var cos = $9d759e9c843dcecf$var$_Number($9d759e9c843dcecf$var$_cos(angle * $9d759e9c843dcecf$var$PI_DIV_180).toFixed(3));
    var sin = $9d759e9c843dcecf$var$_Number($9d759e9c843dcecf$var$_sin(angle * $9d759e9c843dcecf$var$PI_DIV_180).toFixed(3));
    var w2 = bBox.width / 2;
    var h2 = bBox.height / 2;
    var centerX = bBox.x + w2;
    var centerY = bBox.y + h2;
    var w2_ = $9d759e9c843dcecf$var$abs(w2 * cos) + $9d759e9c843dcecf$var$abs(h2 * sin);
    var h2_ = $9d759e9c843dcecf$var$abs(w2 * sin) + $9d759e9c843dcecf$var$abs(h2 * cos);
    var centerX_ = center[0] + (centerX - center[0]) * cos + (centerY - center[1]) * sin;
    var centerY_ = center[1] - (centerX - center[0]) * sin + (centerY - center[1]) * cos;
    return $9d759e9c843dcecf$export$8371a89a07196014({
        x: centerX_ - w2_,
        y: centerY_ - h2_,
        width: 2 * w2_,
        height: 2 * h2_
    });
}
var $9d759e9c843dcecf$export$4c232085fa2b7f2f = function(object, keys, decrease) {
    var arrayGaps;
    do {
        arrayGaps = $9d759e9c843dcecf$var$selectByKeys(object, keys);
        arrayGaps.push($9d759e9c843dcecf$var$ceil(decrease / arrayGaps.length));
        decrease = $9d759e9c843dcecf$var$decreaseFields(object, keys, $9d759e9c843dcecf$var$_min.apply(null, arrayGaps), decrease);
    }while (decrease > 0 && arrayGaps.length > 1);
    return decrease;
};
var $9d759e9c843dcecf$export$7d7c25de1533d2be = function(value, defaultValue) {
    return void 0 !== value ? value : defaultValue;
};
var $9d759e9c843dcecf$export$582b9b0b472ba4be = function(values) {
    var stored = {};
    var i;
    var ii;
    for(i = 0, ii = values.length; i < ii; ++i)stored[$9d759e9c843dcecf$export$6477141bf0c21c3(values[i])] = 1;
    return function(value, defaultValue) {
        var _value = $9d759e9c843dcecf$export$6477141bf0c21c3(value);
        return stored[_value] ? _value : defaultValue;
    };
};
var $9d759e9c843dcecf$export$48111a094a22f378 = function(options) {
    var fontOptions = {};
    (0, $8OLOW.each)(options || {}, function(key, value) {
        if (/^(cursor)$/i.test(key)) ;
        else if ("opacity" === key) value = null;
        else if ("color" === key) {
            key = "fill";
            if ("opacity" in options) {
                var color = new (0, $lmWRz.default)(value);
                value = "rgba(".concat(color.r, ",").concat(color.g, ",").concat(color.b, ",").concat(options.opacity, ")");
            }
        } else key = "font-" + key;
        fontOptions[key] = value;
    });
    return fontOptions;
};
function $9d759e9c843dcecf$export$c70785f0b64b6e38(centerCoords, startAngle, angle, radius) {
    var normalizedRadius = radius > 0 ? radius : 0;
    angle = (0, $6ntMu.isDefined)(angle) ? angle + startAngle - 90 : 0;
    var cosSin = $9d759e9c843dcecf$export$5a29bde0961391df(angle);
    return {
        x: $9d759e9c843dcecf$var$_round(centerCoords.x + normalizedRadius * cosSin.cos),
        y: $9d759e9c843dcecf$var$_round(centerCoords.y + normalizedRadius * cosSin.sin)
    };
}
var $9d759e9c843dcecf$export$3056fee568ab949b = function(centerCoords, x, y) {
    var radius = $9d759e9c843dcecf$export$79376507b09a66f(centerCoords.x, centerCoords.y, x, y);
    var angle = $9d759e9c843dcecf$var$atan2(y - centerCoords.y, x - centerCoords.x);
    return {
        phi: $9d759e9c843dcecf$var$_round($9d759e9c843dcecf$export$e3df76cf4464bc81(180 * angle / $9d759e9c843dcecf$var$PI)),
        r: $9d759e9c843dcecf$var$_round(radius)
    };
};
var $9d759e9c843dcecf$export$125006affc5d5ba4 = function(seriesTemplate, items) {
    var customizeSeries = (0, $6ntMu.isFunction)(seriesTemplate.customizeSeries) ? seriesTemplate.customizeSeries : (0, $gcp4g.noop);
    var nameField = seriesTemplate.nameField;
    var generatedSeries = {};
    var seriesOrder = [];
    var series;
    var i = 0;
    var length;
    var data;
    items = items || [];
    for(length = items.length; i < length; i++){
        data = items[i];
        if (nameField in data) {
            series = generatedSeries[data[nameField]];
            if (!series) {
                series = generatedSeries[data[nameField]] = {
                    name: data[nameField],
                    nameFieldValue: data[nameField]
                };
                seriesOrder.push(series.name);
            }
        }
    }
    return $9d759e9c843dcecf$export$871de8747c9eaa88(seriesOrder, function(orderedName) {
        var group = generatedSeries[orderedName];
        return (0, $2oTOp.extend)(group, customizeSeries.call(null, group.name));
    });
};
var $9d759e9c843dcecf$export$324a84b0bdb301f2 = function(categories, startValue, endValue) {
    if (0 === categories.length) return {
        categories: []
    };
    startValue = (0, $6ntMu.isDefined)(startValue) ? startValue : categories[0];
    endValue = (0, $6ntMu.isDefined)(endValue) ? endValue : categories[categories.length - 1];
    var categoriesValue = $9d759e9c843dcecf$export$871de8747c9eaa88(categories, (category)=>null === category || void 0 === category ? void 0 : category.valueOf());
    var indexStartValue = categoriesValue.indexOf(startValue.valueOf());
    var indexEndValue = categoriesValue.indexOf(endValue.valueOf());
    var swapBuf;
    var inverted = false;
    indexStartValue < 0 && (indexStartValue = 0);
    indexEndValue < 0 && (indexEndValue = categories.length - 1);
    if (indexEndValue < indexStartValue) {
        swapBuf = indexEndValue;
        indexEndValue = indexStartValue;
        indexStartValue = swapBuf;
        inverted = true;
    }
    var visibleCategories = categories.slice(indexStartValue, indexEndValue + 1);
    var lastIdx = visibleCategories.length - 1;
    return {
        categories: visibleCategories,
        start: visibleCategories[inverted ? lastIdx : 0],
        end: visibleCategories[inverted ? 0 : lastIdx],
        inverted: inverted
    };
};
function $9d759e9c843dcecf$export$87e7b77bbd65e07c(pane) {
    return !(pane.unit % 2);
}
function $9d759e9c843dcecf$export$d0bf1282cca31d51(panes) {
    panes.forEach((pane)=>{
        var height = pane.height;
        var unit = 0;
        var parsedHeight = parseFloat(height) || void 0;
        if ((0, $6ntMu.isString)(height) && height.indexOf("px") > -1 || (0, $6ntMu.isNumeric)(height) && height > 1) {
            parsedHeight = $9d759e9c843dcecf$var$_round(parsedHeight);
            unit = 1;
        }
        if (!unit && parsedHeight) {
            if ((0, $6ntMu.isString)(height) && height.indexOf("%") > -1) {
                parsedHeight /= 100;
                unit = 2;
            } else if (parsedHeight < 0) parsedHeight = parsedHeight < -1 ? 1 : $9d759e9c843dcecf$var$abs(parsedHeight);
        }
        pane.height = parsedHeight;
        pane.unit = unit;
    });
    var relativeHeightPanes = panes.filter($9d759e9c843dcecf$export$87e7b77bbd65e07c);
    var weightSum = relativeHeightPanes.reduce((prev, next)=>prev + (next.height || 0), 0);
    var weightHeightCount = relativeHeightPanes.length;
    var emptyHeightPanes = relativeHeightPanes.filter((pane)=>!pane.height);
    var emptyHeightCount = emptyHeightPanes.length;
    if (weightSum < 1 && emptyHeightCount) emptyHeightPanes.forEach((pane)=>pane.height = (1 - weightSum) / emptyHeightCount);
    else if (weightSum > 1 || weightSum < 1 && !emptyHeightCount || 1 === weightSum && emptyHeightCount) {
        if (emptyHeightCount) {
            var weightForEmpty = weightSum / weightHeightCount;
            var emptyWeightSum = emptyHeightCount * weightForEmpty;
            relativeHeightPanes.filter((pane)=>pane.height).forEach((pane)=>pane.height *= (weightSum - emptyWeightSum) / weightSum);
            emptyHeightPanes.forEach((pane)=>pane.height = weightForEmpty);
        }
        relativeHeightPanes.forEach((pane)=>pane.height *= 1 / weightSum);
    }
}
function $9d759e9c843dcecf$export$1a876d6dce9cce0f(panes, canvas, rotated) {
    var distributedSpace = 0;
    var padding = $9d759e9c843dcecf$export$d76623ea710c7ef4;
    var paneSpace = rotated ? canvas.width - canvas.left - canvas.right : canvas.height - canvas.top - canvas.bottom;
    var totalCustomSpace = panes.reduce((prev, cur)=>prev + (!$9d759e9c843dcecf$export$87e7b77bbd65e07c(cur) ? cur.height : 0), 0);
    var usefulSpace = paneSpace - padding * (panes.length - 1) - totalCustomSpace;
    var startName = rotated ? "left" : "top";
    var endName = rotated ? "right" : "bottom";
    panes.forEach((pane)=>{
        var calcLength = !$9d759e9c843dcecf$export$87e7b77bbd65e07c(pane) ? pane.height : $9d759e9c843dcecf$var$_round(pane.height * usefulSpace);
        pane.canvas = pane.canvas || {};
        (0, $2oTOp.extend)(pane.canvas, canvas);
        pane.canvas[startName] = canvas[startName] + distributedSpace;
        pane.canvas[endName] = canvas[endName] + (paneSpace - calcLength - distributedSpace);
        distributedSpace = distributedSpace + calcLength + padding;
        $9d759e9c843dcecf$export$83fd4eca237a5102(pane.canvas);
    });
}
var $9d759e9c843dcecf$export$7a5d5c156e7dc406 = function(array) {
    var values = {};
    return $9d759e9c843dcecf$export$871de8747c9eaa88(array, function(item) {
        var result = !values[item] ? item : null;
        values[item] = true;
        return result;
    });
};
var $9d759e9c843dcecf$export$8a115f80deb97d6d = function(bBox, dy, center) {
    var isPositive = bBox.x + bBox.width / 2 >= center.x;
    var horizontalOffset1 = (isPositive ? bBox.x : bBox.x + bBox.width) - center.x;
    var verticalOffset1 = bBox.y - center.y;
    var verticalOffset2 = verticalOffset1 + dy;
    var horizontalOffset2 = $9d759e9c843dcecf$var$_round($9d759e9c843dcecf$var$sqrt(horizontalOffset1 * horizontalOffset1 + verticalOffset1 * verticalOffset1 - verticalOffset2 * verticalOffset2));
    var dx = (isPositive ? +horizontalOffset2 : -horizontalOffset2) || horizontalOffset1;
    return {
        x: center.x + (isPositive ? dx : dx - bBox.width),
        y: bBox.y + dy
    };
};
function $9d759e9c843dcecf$export$15411f25bc80d4c8(opt1, opt2) {
    return {
        checkInterval: opt1.checkInterval || opt2.checkInterval,
        size: $9d759e9c843dcecf$var$_max(opt1.size || 0, opt2.size || 0),
        percentStick: opt1.percentStick || opt2.percentStick,
        sizePointNormalState: $9d759e9c843dcecf$var$_max(opt1.sizePointNormalState || 0, opt2.sizePointNormalState || 0)
    };
}
function $9d759e9c843dcecf$export$b505dc781e07ac4e(value) {
    if (Array.isArray(value)) return {
        startValue: value[0],
        endValue: value[1]
    };
    else return value || {};
}
function $9d759e9c843dcecf$export$c443a7bc25af7150(visualRange, convertToVisualRange) {
    if (convertToVisualRange) return visualRange;
    return [
        visualRange.startValue,
        visualRange.endValue
    ];
}
function $9d759e9c843dcecf$export$a15af90b344a0a9b(range, correctZeroLevel) {
    if ("datetime" === range.dataType) return function(rangeValue, marginValue) {
        var sign = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
        return new Date(rangeValue.getTime() + sign * marginValue);
    };
    if ("logarithmic" === range.axisType) return function(rangeValue, marginValue) {
        var sign = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
        var log = $9d759e9c843dcecf$export$4523bf4b2e77435d(rangeValue, range.base) + sign * marginValue;
        return $9d759e9c843dcecf$export$52cbb36cac4c00d8(log, range.base);
    };
    return function(rangeValue, marginValue) {
        var sign = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
        var newValue = rangeValue + sign * marginValue;
        return correctZeroLevel && newValue * rangeValue <= 0 ? 0 : newValue;
    };
}
function $9d759e9c843dcecf$export$93d7c9e6ef4c1a2a(options, visualRange, wholeRange, dataRange) {
    var minDefined = (0, $6ntMu.isDefined)(visualRange.startValue);
    var maxDefined = (0, $6ntMu.isDefined)(visualRange.endValue);
    var nonDiscrete = "discrete" !== options.axisType;
    dataRange = dataRange || wholeRange;
    var add = $9d759e9c843dcecf$export$a15af90b344a0a9b(options, false);
    var min = minDefined ? visualRange.startValue : dataRange.min;
    var max = maxDefined ? visualRange.endValue : dataRange.max;
    var rangeLength = visualRange.length;
    var categories = dataRange.categories;
    if (nonDiscrete && !(0, $6ntMu.isDefined)(min) && !(0, $6ntMu.isDefined)(max)) return {
        startValue: min,
        endValue: max
    };
    if ((0, $6ntMu.isDefined)(rangeLength)) {
        if (nonDiscrete) {
            if ("datetime" === options.dataType && !(0, $6ntMu.isNumeric)(rangeLength)) rangeLength = $9d759e9c843dcecf$var$dateToMilliseconds(rangeLength);
            if (maxDefined && !minDefined || !maxDefined && !minDefined) {
                (0, $6ntMu.isDefined)(wholeRange.max) && (max = max > wholeRange.max ? wholeRange.max : max);
                min = add(max, rangeLength, -1);
            } else if (minDefined && !maxDefined) {
                (0, $6ntMu.isDefined)(wholeRange.min) && (min = min < wholeRange.min ? wholeRange.min : min);
                max = add(min, rangeLength);
            }
        } else {
            rangeLength = parseInt(rangeLength);
            if (!isNaN(rangeLength) && isFinite(rangeLength)) {
                rangeLength--;
                if (!maxDefined && !minDefined) {
                    max = categories[categories.length - 1];
                    min = categories[categories.length - 1 - rangeLength];
                } else if (minDefined && !maxDefined) {
                    var categoriesInfo = $9d759e9c843dcecf$export$324a84b0bdb301f2(categories, min, void 0);
                    max = categoriesInfo.categories[rangeLength];
                } else if (!minDefined && maxDefined) {
                    var _categoriesInfo = $9d759e9c843dcecf$export$324a84b0bdb301f2(categories, void 0, max);
                    min = _categoriesInfo.categories[_categoriesInfo.categories.length - 1 - rangeLength];
                }
            }
        }
    }
    if (nonDiscrete) {
        if ((0, $6ntMu.isDefined)(wholeRange.max) && max > wholeRange.max) max = wholeRange.max;
        if ((0, $6ntMu.isDefined)(wholeRange.min) && min < wholeRange.min) min = wholeRange.min;
    }
    return {
        startValue: min,
        endValue: max
    };
}
function $9d759e9c843dcecf$export$4523bf4b2e77435d(value, base) {
    var allowNegatives = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : false;
    var linearThreshold = arguments.length > 3 ? arguments[3] : void 0;
    if (!allowNegatives) return $9d759e9c843dcecf$export$29ce6c7518aa120(value, base);
    if (0 === value) return 0;
    var transformValue = $9d759e9c843dcecf$export$29ce6c7518aa120($9d759e9c843dcecf$var$abs(value), base) - (linearThreshold - 1);
    if (transformValue < 0) return 0;
    return (0, $laqiS.adjust)((0, $laqiS.sign)(value) * transformValue, Number($9d759e9c843dcecf$var$pow(base, linearThreshold - 1).toFixed($9d759e9c843dcecf$var$abs(linearThreshold))));
}
function $9d759e9c843dcecf$export$52cbb36cac4c00d8(value, base) {
    var allowNegatives = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : false;
    var linearThreshold = arguments.length > 3 ? arguments[3] : void 0;
    if (!allowNegatives) return $9d759e9c843dcecf$export$db748d98fe9116b0(value, base);
    if (0 === value) return 0;
    var transformValue = $9d759e9c843dcecf$export$db748d98fe9116b0($9d759e9c843dcecf$var$abs(value) + (linearThreshold - 1), base);
    if (transformValue < 0) return 0;
    return (0, $laqiS.adjust)((0, $laqiS.sign)(value) * transformValue, Number($9d759e9c843dcecf$var$pow(base, linearThreshold).toFixed($9d759e9c843dcecf$var$abs(linearThreshold))));
}
function $9d759e9c843dcecf$export$a724a797ec23e302(range, rangeFromOptions) {
    if (Array.isArray(rangeFromOptions)) return range.length === rangeFromOptions.length && range.every((item, i)=>$9d759e9c843dcecf$export$7382f6d93b8122b1(item) === $9d759e9c843dcecf$export$7382f6d93b8122b1(rangeFromOptions[i]));
    else return $9d759e9c843dcecf$export$7382f6d93b8122b1(range.startValue) === $9d759e9c843dcecf$export$7382f6d93b8122b1(rangeFromOptions.startValue) && $9d759e9c843dcecf$export$7382f6d93b8122b1(range.endValue) === $9d759e9c843dcecf$export$7382f6d93b8122b1(rangeFromOptions.endValue);
}
function $9d759e9c843dcecf$export$7382f6d93b8122b1(value) {
    return value && value.valueOf();
}
function $9d759e9c843dcecf$export$8d11b3b7f3f68c2b(canvas, x, y) {
    return x >= canvas.left && x <= canvas.right && y >= canvas.top && y <= canvas.bottom;
}

});
parcelRegister("laqiS", function(module, exports) {

$parcel$export(module.exports, "sign", function () { return $f68eef7da525ce84$export$c5552dfdbc7cec71; });
$parcel$export(module.exports, "fitIntoRange", function () { return $f68eef7da525ce84$export$ea4b1ae06d86ed23; });
$parcel$export(module.exports, "getExponent", function () { return $f68eef7da525ce84$export$970c45b6c2d27918; });
$parcel$export(module.exports, "multiplyInExponentialForm", function () { return $f68eef7da525ce84$export$352ef1cd224a28dd; });
$parcel$export(module.exports, "adjust", function () { return $f68eef7da525ce84$export$2c0e788bcc82013; });
$parcel$export(module.exports, "getPrecision", function () { return $f68eef7da525ce84$export$e0c74b50bbd10f68; });
$parcel$export(module.exports, "solveCubicEquation", function () { return $f68eef7da525ce84$export$79ee1a1cd43cf60c; });
$parcel$export(module.exports, "trunc", function () { return $f68eef7da525ce84$export$1fe87bd59b089f0; });
/**
 * DevExtreme (esm/core/utils/math.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");
var $f68eef7da525ce84$export$c5552dfdbc7cec71 = function(value) {
    if (0 === value) return 0;
    return value / Math.abs(value);
};
var $f68eef7da525ce84$export$ea4b1ae06d86ed23 = function(value, minValue, maxValue) {
    var isMinValueUndefined = !minValue && 0 !== minValue;
    var isMaxValueUndefined = !maxValue && 0 !== maxValue;
    isMinValueUndefined && (minValue = !isMaxValueUndefined ? Math.min(value, maxValue) : value);
    isMaxValueUndefined && (maxValue = !isMinValueUndefined ? Math.max(value, minValue) : value);
    return Math.min(Math.max(value, minValue), maxValue);
};
var $f68eef7da525ce84$export$ddf89a9c5af38f94 = function(value, minValue, maxValue) {
    return value >= minValue && value <= maxValue;
};
function $f68eef7da525ce84$export$970c45b6c2d27918(value) {
    return Math.abs(parseInt(value.toExponential().split("e")[1]));
}
function $f68eef7da525ce84$var$getExponentialNotation(value) {
    var parts = value.toExponential().split("e");
    var mantissa = parseFloat(parts[0]);
    var exponent = parseInt(parts[1]);
    return {
        exponent: exponent,
        mantissa: mantissa
    };
}
function $f68eef7da525ce84$export$352ef1cd224a28dd(value, exponentShift) {
    var exponentialNotation = $f68eef7da525ce84$var$getExponentialNotation(value);
    return parseFloat("".concat(exponentialNotation.mantissa, "e").concat(exponentialNotation.exponent + exponentShift));
}
function $f68eef7da525ce84$var$_isEdgeBug() {
    return "0.000300" !== 3e-4.toPrecision(3);
}
function $f68eef7da525ce84$export$2c0e788bcc82013(value, interval) {
    var precision = $f68eef7da525ce84$export$e0c74b50bbd10f68(interval || 0) + 2;
    var separatedValue = value.toString().split(".");
    var sourceValue = value;
    var absValue = Math.abs(value);
    var separatedAdjustedValue;
    var isExponentValue = (0, $6ntMu.isExponential)(value);
    var integerPart = absValue > 1 ? 10 : 0;
    if (1 === separatedValue.length) return value;
    if (!isExponentValue) {
        if ((0, $6ntMu.isExponential)(interval)) precision = separatedValue[0].length + $f68eef7da525ce84$export$970c45b6c2d27918(interval);
        value = absValue;
        value = value - Math.floor(value) + integerPart;
    }
    precision = $f68eef7da525ce84$var$_isEdgeBug() && $f68eef7da525ce84$export$970c45b6c2d27918(value) > 6 || precision > 7 ? 15 : 7;
    if (!isExponentValue) {
        separatedAdjustedValue = parseFloat(value.toPrecision(precision)).toString().split(".");
        if (separatedAdjustedValue[0] === integerPart.toString()) return parseFloat(separatedValue[0] + "." + separatedAdjustedValue[1]);
    }
    return parseFloat(sourceValue.toPrecision(precision));
}
function $f68eef7da525ce84$export$e0c74b50bbd10f68(value) {
    var str = value.toString();
    if (str.indexOf(".") < 0) return 0;
    var mantissa = str.split(".");
    var positionOfDelimiter = mantissa[1].indexOf("e");
    return positionOfDelimiter >= 0 ? positionOfDelimiter : mantissa[1].length;
}
function $f68eef7da525ce84$export$31e4419873013369(x, n) {
    if (x < 0 && n % 2 !== 1) return NaN;
    var y = Math.pow(Math.abs(x), 1 / n);
    return n % 2 === 1 && x < 0 ? -y : y;
}
function $f68eef7da525ce84$export$79ee1a1cd43cf60c(a, b, c, d) {
    if (Math.abs(a) < 1e-8) {
        a = b;
        b = c;
        c = d;
        if (Math.abs(a) < 1e-8) {
            a = b;
            b = c;
            if (Math.abs(a) < 1e-8) return [];
            return [
                -b / a
            ];
        }
        var D2 = b * b - 4 * a * c;
        if (Math.abs(D2) < 1e-8) return [
            -b / (2 * a)
        ];
        else if (D2 > 0) return [
            (-b + Math.sqrt(D2)) / (2 * a),
            (-b - Math.sqrt(D2)) / (2 * a)
        ];
        return [];
    }
    var p = (3 * a * c - b * b) / (3 * a * a);
    var q = (2 * b * b * b - 9 * a * b * c + 27 * a * a * d) / (27 * a * a * a);
    var roots;
    var u;
    if (Math.abs(p) < 1e-8) roots = [
        $f68eef7da525ce84$export$31e4419873013369(-q, 3)
    ];
    else if (Math.abs(q) < 1e-8) roots = [
        0
    ].concat(p < 0 ? [
        Math.sqrt(-p),
        -Math.sqrt(-p)
    ] : []);
    else {
        var D3 = q * q / 4 + p * p * p / 27;
        if (Math.abs(D3) < 1e-8) roots = [
            -1.5 * q / p,
            3 * q / p
        ];
        else if (D3 > 0) {
            u = $f68eef7da525ce84$export$31e4419873013369(-q / 2 - Math.sqrt(D3), 3);
            roots = [
                u - p / (3 * u)
            ];
        } else {
            u = 2 * Math.sqrt(-p / 3);
            var t = Math.acos(3 * q / p / u) / 3;
            var k = 2 * Math.PI / 3;
            roots = [
                u * Math.cos(t),
                u * Math.cos(t - k),
                u * Math.cos(t - 2 * k)
            ];
        }
    }
    for(var i = 0; i < roots.length; i++)roots[i] -= b / (3 * a);
    return roots;
}
function $f68eef7da525ce84$export$1fe87bd59b089f0(value) {
    return Math.trunc ? Math.trunc(value) : value > 0 ? Math.floor(value) : Math.ceil(value);
}
function $f68eef7da525ce84$export$bd7565fe0de04f54(dividend, divider, digitsCount) {
    if (divider === parseInt(divider)) return dividend % divider;
    var quotient = $f68eef7da525ce84$export$2802338739aa3f35(dividend / divider, digitsCount);
    return (quotient - parseInt(quotient)) * divider;
}
function $f68eef7da525ce84$export$62085a5e8bb4ad19(value) {
    var _valueString$split$;
    var valueString = value.toString();
    return (null === (_valueString$split$ = valueString.split(".")[1]) || void 0 === _valueString$split$ ? void 0 : _valueString$split$.length) || parseInt(valueString.split("e-")[1]) || 0;
}
function $f68eef7da525ce84$export$2802338739aa3f35(value) {
    var digitsCount = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
    return parseFloat(value.toFixed(digitsCount));
}

});

parcelRegister("f38Z1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af4e1ab686b38b20$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/utils/date.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $laqiS = parcelRequire("laqiS");

var $8OLOW = parcelRequire("8OLOW");

var $lQCfZ = parcelRequire("lQCfZ");
parcelRequire("l0Pmt");
var $bQvSg = parcelRequire("bQvSg");
var $af4e1ab686b38b20$var$DAYS_IN_WEEK = 7;
var $af4e1ab686b38b20$var$THURSDAY_WEEK_NUMBER = 4;
var $af4e1ab686b38b20$var$SUNDAY_WEEK_NUMBER = 7;
var $af4e1ab686b38b20$var$USUAL_WEEK_COUNT_IN_YEAR = 52;
var $af4e1ab686b38b20$var$dateUnitIntervals = [
    "millisecond",
    "second",
    "minute",
    "hour",
    "day",
    "week",
    "month",
    "quarter",
    "year"
];
var $af4e1ab686b38b20$var$getDatesInterval = function(startDate, endDate, intervalUnit) {
    var delta = endDate.getTime() - startDate.getTime();
    var millisecondCount = (0, $bQvSg.toMilliseconds)(intervalUnit) || 1;
    return Math.floor(delta / millisecondCount);
};
var $af4e1ab686b38b20$var$getNextDateUnit = function(unit, withWeeks) {
    var interval = $af4e1ab686b38b20$var$getDateUnitInterval(unit);
    switch(interval){
        case "millisecond":
            return "second";
        case "second":
            return "minute";
        case "minute":
            return "hour";
        case "hour":
            return "day";
        case "day":
            return withWeeks ? "week" : "month";
        case "week":
            return "month";
        case "month":
            return "quarter";
        case "quarter":
        case "year":
            return "year";
        default:
            return 0;
    }
};
var $af4e1ab686b38b20$var$convertMillisecondsToDateUnits = function(value) {
    var i;
    var dateUnitCount;
    var dateUnitInterval;
    var dateUnitIntervals = [
        "millisecond",
        "second",
        "minute",
        "hour",
        "day",
        "month",
        "year"
    ];
    var result = {};
    for(i = dateUnitIntervals.length - 1; i >= 0; i--){
        dateUnitInterval = dateUnitIntervals[i];
        dateUnitCount = Math.floor(value / (0, $bQvSg.toMilliseconds)(dateUnitInterval));
        if (dateUnitCount > 0) {
            result[dateUnitInterval + "s"] = dateUnitCount;
            value -= $af4e1ab686b38b20$var$convertDateUnitToMilliseconds(dateUnitInterval, dateUnitCount);
        }
    }
    return result;
};
var $af4e1ab686b38b20$var$dateToMilliseconds = function(tickInterval) {
    var milliseconds = 0;
    if ((0, $6ntMu.isObject)(tickInterval)) (0, $8OLOW.each)(tickInterval, function(key, value) {
        milliseconds += $af4e1ab686b38b20$var$convertDateUnitToMilliseconds(key.substr(0, key.length - 1), value);
    });
    if ((0, $6ntMu.isString)(tickInterval)) milliseconds = $af4e1ab686b38b20$var$convertDateUnitToMilliseconds(tickInterval, 1);
    return milliseconds;
};
function $af4e1ab686b38b20$var$convertDateUnitToMilliseconds(dateUnit, count) {
    return (0, $bQvSg.toMilliseconds)(dateUnit) * count;
}
function $af4e1ab686b38b20$var$getDateUnitInterval(tickInterval) {
    var maxInterval = -1;
    var i;
    if ((0, $6ntMu.isString)(tickInterval)) return tickInterval;
    if ((0, $6ntMu.isObject)(tickInterval)) {
        (0, $8OLOW.each)(tickInterval, function(key, value) {
            for(i = 0; i < $af4e1ab686b38b20$var$dateUnitIntervals.length; i++)if (value && (key === $af4e1ab686b38b20$var$dateUnitIntervals[i] + "s" || key === $af4e1ab686b38b20$var$dateUnitIntervals[i]) && maxInterval < i) maxInterval = i;
        });
        return $af4e1ab686b38b20$var$dateUnitIntervals[maxInterval];
    }
    return "";
}
var $af4e1ab686b38b20$var$tickIntervalToFormatMap = {
    millisecond: "millisecond",
    second: "longtime",
    minute: "shorttime",
    hour: "shorttime",
    day: "day",
    week: "day",
    month: "month",
    quarter: "quarter",
    year: "year"
};
function $af4e1ab686b38b20$var$getDateFormatByTickInterval(tickInterval) {
    return $af4e1ab686b38b20$var$tickIntervalToFormatMap[$af4e1ab686b38b20$var$getDateUnitInterval(tickInterval)] || "";
}
var $af4e1ab686b38b20$var$getQuarter = function(month) {
    return Math.floor(month / 3);
};
var $af4e1ab686b38b20$var$getFirstQuarterMonth = function(month) {
    return 3 * $af4e1ab686b38b20$var$getQuarter(month);
};
function $af4e1ab686b38b20$var$correctDateWithUnitBeginning(date, dateInterval, withCorrection, firstDayOfWeek) {
    date = new Date(date.getTime());
    var oldDate = new Date(date.getTime());
    var firstQuarterMonth;
    var month;
    var dateUnitInterval = $af4e1ab686b38b20$var$getDateUnitInterval(dateInterval);
    switch(dateUnitInterval){
        case "second":
            date = new Date(1e3 * Math.floor(oldDate.getTime() / 1e3));
            break;
        case "minute":
            date = new Date(6e4 * Math.floor(oldDate.getTime() / 6e4));
            break;
        case "hour":
            date = new Date(36e5 * Math.floor(oldDate.getTime() / 36e5));
            break;
        case "year":
            date.setMonth(0);
        case "month":
            date.setDate(1);
        case "day":
            date.setHours(0, 0, 0, 0);
            break;
        case "week":
            date = $af4e1ab686b38b20$var$getFirstWeekDate(date, firstDayOfWeek || 0);
            date.setHours(0, 0, 0, 0);
            break;
        case "quarter":
            firstQuarterMonth = $af4e1ab686b38b20$var$getFirstQuarterMonth(date.getMonth());
            month = date.getMonth();
            date.setDate(1);
            date.setHours(0, 0, 0, 0);
            if (month !== firstQuarterMonth) date.setMonth(firstQuarterMonth);
    }
    if (withCorrection && "hour" !== dateUnitInterval && "minute" !== dateUnitInterval && "second" !== dateUnitInterval) $af4e1ab686b38b20$var$fixTimezoneGap(oldDate, date);
    return date;
}
function $af4e1ab686b38b20$var$trimTime(date) {
    return $af4e1ab686b38b20$var$correctDateWithUnitBeginning(date, "day");
}
var $af4e1ab686b38b20$var$setToDayEnd = function(date) {
    var result = $af4e1ab686b38b20$var$trimTime(date);
    result.setDate(result.getDate() + 1);
    return new Date(result.getTime() - 1);
};
var $af4e1ab686b38b20$var$getDatesDifferences = function(date1, date2) {
    var counter = 0;
    var differences = {
        year: date1.getFullYear() !== date2.getFullYear(),
        month: date1.getMonth() !== date2.getMonth(),
        day: date1.getDate() !== date2.getDate(),
        hour: date1.getHours() !== date2.getHours(),
        minute: date1.getMinutes() !== date2.getMinutes(),
        second: date1.getSeconds() !== date2.getSeconds(),
        millisecond: date1.getMilliseconds() !== date2.getMilliseconds()
    };
    (0, $8OLOW.each)(differences, function(key, value) {
        if (value) counter++;
    });
    if (0 === counter && 0 !== $af4e1ab686b38b20$var$getTimezonesDifference(date1, date2)) {
        differences.hour = true;
        counter++;
    }
    differences.count = counter;
    return differences;
};
function $af4e1ab686b38b20$var$addDateInterval(value, interval, dir) {
    var result = new Date(value.getTime());
    var intervalObject = (0, $6ntMu.isString)(interval) ? $af4e1ab686b38b20$var$getDateIntervalByString(interval.toLowerCase()) : (0, $6ntMu.isNumeric)(interval) ? $af4e1ab686b38b20$var$convertMillisecondsToDateUnits(interval) : interval;
    if (intervalObject.years) result.setFullYear(result.getFullYear() + intervalObject.years * dir);
    if (intervalObject.quarters) result.setMonth(result.getMonth() + 3 * intervalObject.quarters * dir);
    if (intervalObject.months) result.setMonth(result.getMonth() + intervalObject.months * dir);
    if (intervalObject.weeks) result.setDate(result.getDate() + 7 * intervalObject.weeks * dir);
    if (intervalObject.days) result.setDate(result.getDate() + intervalObject.days * dir);
    if (intervalObject.hours) result.setTime(result.getTime() + 36e5 * intervalObject.hours * dir);
    if (intervalObject.minutes) result.setTime(result.getTime() + 6e4 * intervalObject.minutes * dir);
    if (intervalObject.seconds) result.setTime(result.getTime() + 1e3 * intervalObject.seconds * dir);
    if (intervalObject.milliseconds) result.setTime(result.getTime() + intervalObject.milliseconds * dir);
    return result;
}
var $af4e1ab686b38b20$var$addInterval = function(value, interval, isNegative) {
    var dir = isNegative ? -1 : 1;
    return (0, $6ntMu.isDate)(value) ? $af4e1ab686b38b20$var$addDateInterval(value, interval, dir) : (0, $laqiS.adjust)(value + interval * dir, interval);
};
var $af4e1ab686b38b20$var$getSequenceByInterval = function(min, max, interval) {
    var intervals = [];
    var cur;
    intervals.push((0, $6ntMu.isDate)(min) ? new Date(min.getTime()) : min);
    cur = min;
    while(cur < max){
        cur = $af4e1ab686b38b20$var$addInterval(cur, interval);
        intervals.push(cur);
    }
    return intervals;
};
var $af4e1ab686b38b20$var$getViewFirstCellDate = function(viewType, date) {
    if ("month" === viewType) return $af4e1ab686b38b20$var$createDateWithFullYear(date.getFullYear(), date.getMonth(), 1);
    if ("year" === viewType) return $af4e1ab686b38b20$var$createDateWithFullYear(date.getFullYear(), 0, date.getDate());
    if ("decade" === viewType) return $af4e1ab686b38b20$var$createDateWithFullYear($af4e1ab686b38b20$var$getFirstYearInDecade(date), date.getMonth(), date.getDate());
    if ("century" === viewType) return $af4e1ab686b38b20$var$createDateWithFullYear($af4e1ab686b38b20$var$getFirstDecadeInCentury(date), date.getMonth(), date.getDate());
};
var $af4e1ab686b38b20$var$getViewLastCellDate = function(viewType, date) {
    if ("month" === viewType) return $af4e1ab686b38b20$var$createDateWithFullYear(date.getFullYear(), date.getMonth(), $af4e1ab686b38b20$var$getLastMonthDay(date));
    if ("year" === viewType) return $af4e1ab686b38b20$var$createDateWithFullYear(date.getFullYear(), 11, date.getDate());
    if ("decade" === viewType) return $af4e1ab686b38b20$var$createDateWithFullYear($af4e1ab686b38b20$var$getFirstYearInDecade(date) + 9, date.getMonth(), date.getDate());
    if ("century" === viewType) return $af4e1ab686b38b20$var$createDateWithFullYear($af4e1ab686b38b20$var$getFirstDecadeInCentury(date) + 90, date.getMonth(), date.getDate());
};
var $af4e1ab686b38b20$var$getViewMinBoundaryDate = function(viewType, date) {
    var resultDate = $af4e1ab686b38b20$var$createDateWithFullYear(date.getFullYear(), date.getMonth(), 1);
    if ("month" === viewType) return resultDate;
    resultDate.setMonth(0);
    if ("year" === viewType) return resultDate;
    if ("decade" === viewType) resultDate.setFullYear($af4e1ab686b38b20$var$getFirstYearInDecade(date));
    if ("century" === viewType) resultDate.setFullYear($af4e1ab686b38b20$var$getFirstDecadeInCentury(date));
    return resultDate;
};
var $af4e1ab686b38b20$var$getViewMaxBoundaryDate = function(viewType, date) {
    var resultDate = new Date(date);
    resultDate.setDate($af4e1ab686b38b20$var$getLastMonthDay(date));
    if ("month" === viewType) return resultDate;
    resultDate.setMonth(11);
    resultDate.setDate($af4e1ab686b38b20$var$getLastMonthDay(resultDate));
    if ("year" === viewType) return resultDate;
    if ("decade" === viewType) resultDate.setFullYear($af4e1ab686b38b20$var$getFirstYearInDecade(date) + 9);
    if ("century" === viewType) resultDate.setFullYear($af4e1ab686b38b20$var$getFirstDecadeInCentury(date) + 99);
    return resultDate;
};
function $af4e1ab686b38b20$var$getLastMonthDay(date) {
    var resultDate = $af4e1ab686b38b20$var$createDateWithFullYear(date.getFullYear(), date.getMonth() + 1, 0);
    return resultDate.getDate();
}
var $af4e1ab686b38b20$var$getViewUp = function(typeView) {
    switch(typeView){
        case "month":
            return "year";
        case "year":
            return "decade";
        case "decade":
            return "century";
    }
};
var $af4e1ab686b38b20$var$getViewDown = function(typeView) {
    switch(typeView){
        case "century":
            return "decade";
        case "decade":
            return "year";
        case "year":
            return "month";
    }
};
var $af4e1ab686b38b20$var$getDifferenceInMonth = function(typeView) {
    var difference = 1;
    if ("year" === typeView) difference = 12;
    if ("decade" === typeView) difference = 120;
    if ("century" === typeView) difference = 1200;
    return difference;
};
var $af4e1ab686b38b20$var$getDifferenceInMonthForCells = function(typeView) {
    var difference = 1;
    if ("decade" === typeView) difference = 12;
    if ("century" === typeView) difference = 120;
    return difference;
};
function $af4e1ab686b38b20$var$getDateIntervalByString(intervalString) {
    var result = {};
    switch(intervalString){
        case "year":
            result.years = 1;
            break;
        case "month":
            result.months = 1;
            break;
        case "quarter":
            result.months = 3;
            break;
        case "week":
            result.weeks = 1;
            break;
        case "day":
            result.days = 1;
            break;
        case "hour":
            result.hours = 1;
            break;
        case "minute":
            result.minutes = 1;
            break;
        case "second":
            result.seconds = 1;
            break;
        case "millisecond":
            result.milliseconds = 1;
    }
    return result;
}
function $af4e1ab686b38b20$var$sameDate(date1, date2) {
    return $af4e1ab686b38b20$var$sameMonthAndYear(date1, date2) && date1.getDate() === date2.getDate();
}
function $af4e1ab686b38b20$var$sameMonthAndYear(date1, date2) {
    return $af4e1ab686b38b20$var$sameYear(date1, date2) && date1.getMonth() === date2.getMonth();
}
function $af4e1ab686b38b20$var$sameYear(date1, date2) {
    return date1 && date2 && date1.getFullYear() === date2.getFullYear();
}
function $af4e1ab686b38b20$var$sameHoursAndMinutes(date1, date2) {
    return date1 && date2 && date1.getHours() === date2.getHours() && date1.getMinutes() === date2.getMinutes();
}
var $af4e1ab686b38b20$var$sameDecade = function(date1, date2) {
    if (!(0, $6ntMu.isDefined)(date1) || !(0, $6ntMu.isDefined)(date2)) return;
    var startDecadeDate1 = date1.getFullYear() - date1.getFullYear() % 10;
    var startDecadeDate2 = date2.getFullYear() - date2.getFullYear() % 10;
    return date1 && date2 && startDecadeDate1 === startDecadeDate2;
};
var $af4e1ab686b38b20$var$sameCentury = function(date1, date2) {
    if (!(0, $6ntMu.isDefined)(date1) || !(0, $6ntMu.isDefined)(date2)) return;
    var startCenturyDate1 = date1.getFullYear() - date1.getFullYear() % 100;
    var startCenturyDate2 = date2.getFullYear() - date2.getFullYear() % 100;
    return date1 && date2 && startCenturyDate1 === startCenturyDate2;
};
function $af4e1ab686b38b20$var$getFirstDecadeInCentury(date) {
    return date && date.getFullYear() - date.getFullYear() % 100;
}
function $af4e1ab686b38b20$var$getFirstYearInDecade(date) {
    return date && date.getFullYear() - date.getFullYear() % 10;
}
var $af4e1ab686b38b20$var$getShortDateFormat = function() {
    return "yyyy/MM/dd";
};
var $af4e1ab686b38b20$var$getFirstMonthDate = function(date) {
    if (!(0, $6ntMu.isDefined)(date)) return;
    return $af4e1ab686b38b20$var$createDateWithFullYear(date.getFullYear(), date.getMonth(), 1);
};
var $af4e1ab686b38b20$var$getLastMonthDate = function(date) {
    if (!(0, $6ntMu.isDefined)(date)) return;
    return $af4e1ab686b38b20$var$createDateWithFullYear(date.getFullYear(), date.getMonth() + 1, 0);
};
function $af4e1ab686b38b20$var$getFirstWeekDate(date, firstDayOfWeek) {
    var delta = (date.getDay() - firstDayOfWeek + $af4e1ab686b38b20$var$DAYS_IN_WEEK) % $af4e1ab686b38b20$var$DAYS_IN_WEEK;
    var result = new Date(date);
    result.setDate(date.getDate() - delta);
    return result;
}
function $af4e1ab686b38b20$var$getUTCTime(date) {
    return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
}
function $af4e1ab686b38b20$var$getDayNumber(date) {
    var ms = $af4e1ab686b38b20$var$getUTCTime(date) - $af4e1ab686b38b20$var$getUTCTime($af4e1ab686b38b20$var$getFirstDateInYear(date.getFullYear()));
    return 1 + Math.floor(ms / (0, $bQvSg.toMilliseconds)("day"));
}
function $af4e1ab686b38b20$var$getFirstDateInYear(year) {
    return new Date(year, 0, 1);
}
function $af4e1ab686b38b20$var$getLastDateInYear(year) {
    return new Date(year, 11, 31);
}
function $af4e1ab686b38b20$var$getDayWeekNumber(date, firstDayOfWeek) {
    var day = date.getDay() - firstDayOfWeek + 1;
    if (day <= 0) day += $af4e1ab686b38b20$var$DAYS_IN_WEEK;
    return day;
}
function $af4e1ab686b38b20$var$getWeekNumber(date, firstDayOfWeek, rule) {
    var firstWeekDayInYear = $af4e1ab686b38b20$var$getDayWeekNumber($af4e1ab686b38b20$var$getFirstDateInYear(date.getFullYear()), firstDayOfWeek);
    var lastWeekDayInYear = $af4e1ab686b38b20$var$getDayWeekNumber($af4e1ab686b38b20$var$getLastDateInYear(date.getFullYear()), firstDayOfWeek);
    var daysInFirstWeek = $af4e1ab686b38b20$var$DAYS_IN_WEEK - firstWeekDayInYear + 1;
    var weekNumber = Math.ceil(($af4e1ab686b38b20$var$getDayNumber(date) - daysInFirstWeek) / 7);
    switch(rule){
        case "fullWeek":
            if (daysInFirstWeek === $af4e1ab686b38b20$var$DAYS_IN_WEEK) weekNumber++;
            if (0 === weekNumber) {
                var lastDateInPreviousYear = $af4e1ab686b38b20$var$getLastDateInYear(date.getFullYear() - 1);
                return $af4e1ab686b38b20$var$getWeekNumber(lastDateInPreviousYear, firstDayOfWeek, rule);
            }
            return weekNumber;
        case "firstDay":
            if (daysInFirstWeek > 0) weekNumber++;
            var isSunday = firstWeekDayInYear === $af4e1ab686b38b20$var$SUNDAY_WEEK_NUMBER || lastWeekDayInYear === $af4e1ab686b38b20$var$SUNDAY_WEEK_NUMBER;
            if (weekNumber > $af4e1ab686b38b20$var$USUAL_WEEK_COUNT_IN_YEAR && !isSunday || 54 === weekNumber) weekNumber = 1;
            return weekNumber;
        case "firstFourDays":
            if (daysInFirstWeek > 3) weekNumber++;
            var isThursday = firstWeekDayInYear === $af4e1ab686b38b20$var$THURSDAY_WEEK_NUMBER || lastWeekDayInYear === $af4e1ab686b38b20$var$THURSDAY_WEEK_NUMBER;
            if (weekNumber > $af4e1ab686b38b20$var$USUAL_WEEK_COUNT_IN_YEAR && !isThursday) weekNumber = 1;
            if (0 === weekNumber) {
                var _lastDateInPreviousYear = $af4e1ab686b38b20$var$getLastDateInYear(date.getFullYear() - 1);
                return $af4e1ab686b38b20$var$getWeekNumber(_lastDateInPreviousYear, firstDayOfWeek, rule);
            }
            return weekNumber;
    }
}
var $af4e1ab686b38b20$var$normalizeDateByWeek = function(date, currentDate) {
    var differenceInDays = $af4e1ab686b38b20$var$dateUtils.getDatesInterval(date, currentDate, "day");
    var resultDate = new Date(date);
    if (differenceInDays >= 6) resultDate = new Date(resultDate.setDate(resultDate.getDate() + 7));
    return resultDate;
};
var $af4e1ab686b38b20$var$dateInRange = function(date, min, max, format) {
    if ("date" === format) {
        min = min && $af4e1ab686b38b20$var$dateUtils.correctDateWithUnitBeginning(min, "day");
        max = max && $af4e1ab686b38b20$var$dateUtils.correctDateWithUnitBeginning(max, "day");
        date = date && $af4e1ab686b38b20$var$dateUtils.correctDateWithUnitBeginning(date, "day");
    }
    return $af4e1ab686b38b20$var$normalizeDate(date, min, max) === date;
};
var $af4e1ab686b38b20$var$intervalsOverlap = function(options) {
    var { firstMin: firstMin, firstMax: firstMax, secondMin: secondMin, secondMax: secondMax } = options;
    return firstMin <= secondMin && secondMin <= firstMax || firstMin > secondMin && firstMin < secondMax || firstMin < secondMax && firstMax > secondMax;
};
var $af4e1ab686b38b20$var$dateTimeFromDecimal = function(number) {
    var hours = Math.floor(number);
    var minutes = number % 1 * 60;
    return {
        hours: hours,
        minutes: minutes
    };
};
var $af4e1ab686b38b20$var$roundDateByStartDayHour = function(date, startDayHour) {
    var startTime = this.dateTimeFromDecimal(startDayHour);
    var result = new Date(date);
    if (date.getHours() === startTime.hours && date.getMinutes() < startTime.minutes || date.getHours() < startTime.hours) result.setHours(startTime.hours, startTime.minutes, 0, 0);
    return result;
};
function $af4e1ab686b38b20$var$normalizeDate(date, min, max) {
    var normalizedDate = date;
    if (!(0, $6ntMu.isDefined)(date)) return date;
    if ((0, $6ntMu.isDefined)(min) && date < min) normalizedDate = min;
    if ((0, $6ntMu.isDefined)(max) && date > max) normalizedDate = max;
    return normalizedDate;
}
function $af4e1ab686b38b20$var$fixTimezoneGap(oldDate, newDate) {
    if (!(0, $6ntMu.isDefined)(oldDate)) return;
    var diff = newDate.getHours() - oldDate.getHours();
    if (0 === diff) return;
    var sign = 1 === diff || -23 === diff ? -1 : 1;
    var trial = new Date(newDate.getTime() + 36e5 * sign);
    if (sign > 0 || trial.getDate() === newDate.getDate()) newDate.setTime(trial.getTime());
}
var $af4e1ab686b38b20$var$roundToHour = function(date) {
    var result = new Date(date.getTime());
    result.setHours(result.getHours() + 1);
    result.setMinutes(0);
    return result;
};
function $af4e1ab686b38b20$var$getTimezonesDifference(min, max) {
    return 60 * (max.getTimezoneOffset() - min.getTimezoneOffset()) * 1e3;
}
var $af4e1ab686b38b20$var$makeDate = function(date) {
    return new Date(date);
};
var $af4e1ab686b38b20$var$getDatesOfInterval = function(startDate, endDate, step) {
    var result = [];
    var currentDate = new Date(startDate.getTime());
    while(currentDate < endDate){
        result.push(new Date(currentDate.getTime()));
        currentDate = this.addInterval(currentDate, step);
    }
    return result;
};
var $af4e1ab686b38b20$var$createDateWithFullYear = function(year) {
    var result = new Date(...arguments);
    result.setFullYear(year);
    return result;
};
var $af4e1ab686b38b20$var$getMachineTimezoneName = ()=>{
    var hasIntl = "undefined" !== typeof Intl;
    return hasIntl ? Intl.DateTimeFormat().resolvedOptions().timeZone : null;
};
var $af4e1ab686b38b20$var$dateUtils = {
    dateUnitIntervals: $af4e1ab686b38b20$var$dateUnitIntervals,
    convertMillisecondsToDateUnits: $af4e1ab686b38b20$var$convertMillisecondsToDateUnits,
    dateToMilliseconds: $af4e1ab686b38b20$var$dateToMilliseconds,
    getNextDateUnit: $af4e1ab686b38b20$var$getNextDateUnit,
    convertDateUnitToMilliseconds: $af4e1ab686b38b20$var$convertDateUnitToMilliseconds,
    getDateUnitInterval: $af4e1ab686b38b20$var$getDateUnitInterval,
    getDateFormatByTickInterval: $af4e1ab686b38b20$var$getDateFormatByTickInterval,
    getDatesDifferences: $af4e1ab686b38b20$var$getDatesDifferences,
    correctDateWithUnitBeginning: $af4e1ab686b38b20$var$correctDateWithUnitBeginning,
    trimTime: $af4e1ab686b38b20$var$trimTime,
    setToDayEnd: $af4e1ab686b38b20$var$setToDayEnd,
    roundDateByStartDayHour: $af4e1ab686b38b20$var$roundDateByStartDayHour,
    dateTimeFromDecimal: $af4e1ab686b38b20$var$dateTimeFromDecimal,
    addDateInterval: $af4e1ab686b38b20$var$addDateInterval,
    addInterval: $af4e1ab686b38b20$var$addInterval,
    getSequenceByInterval: $af4e1ab686b38b20$var$getSequenceByInterval,
    getDateIntervalByString: $af4e1ab686b38b20$var$getDateIntervalByString,
    sameHoursAndMinutes: $af4e1ab686b38b20$var$sameHoursAndMinutes,
    sameDate: $af4e1ab686b38b20$var$sameDate,
    sameMonthAndYear: $af4e1ab686b38b20$var$sameMonthAndYear,
    sameMonth: $af4e1ab686b38b20$var$sameMonthAndYear,
    sameYear: $af4e1ab686b38b20$var$sameYear,
    sameDecade: $af4e1ab686b38b20$var$sameDecade,
    sameCentury: $af4e1ab686b38b20$var$sameCentury,
    getDifferenceInMonth: $af4e1ab686b38b20$var$getDifferenceInMonth,
    getDifferenceInMonthForCells: $af4e1ab686b38b20$var$getDifferenceInMonthForCells,
    getFirstYearInDecade: $af4e1ab686b38b20$var$getFirstYearInDecade,
    getFirstDecadeInCentury: $af4e1ab686b38b20$var$getFirstDecadeInCentury,
    getShortDateFormat: $af4e1ab686b38b20$var$getShortDateFormat,
    getViewFirstCellDate: $af4e1ab686b38b20$var$getViewFirstCellDate,
    getViewLastCellDate: $af4e1ab686b38b20$var$getViewLastCellDate,
    getViewDown: $af4e1ab686b38b20$var$getViewDown,
    getViewUp: $af4e1ab686b38b20$var$getViewUp,
    getLastMonthDay: $af4e1ab686b38b20$var$getLastMonthDay,
    getLastMonthDate: $af4e1ab686b38b20$var$getLastMonthDate,
    getFirstMonthDate: $af4e1ab686b38b20$var$getFirstMonthDate,
    getFirstWeekDate: $af4e1ab686b38b20$var$getFirstWeekDate,
    getWeekNumber: $af4e1ab686b38b20$var$getWeekNumber,
    normalizeDateByWeek: $af4e1ab686b38b20$var$normalizeDateByWeek,
    getQuarter: $af4e1ab686b38b20$var$getQuarter,
    getFirstQuarterMonth: $af4e1ab686b38b20$var$getFirstQuarterMonth,
    dateInRange: $af4e1ab686b38b20$var$dateInRange,
    intervalsOverlap: $af4e1ab686b38b20$var$intervalsOverlap,
    roundToHour: $af4e1ab686b38b20$var$roundToHour,
    normalizeDate: $af4e1ab686b38b20$var$normalizeDate,
    getViewMinBoundaryDate: $af4e1ab686b38b20$var$getViewMinBoundaryDate,
    getViewMaxBoundaryDate: $af4e1ab686b38b20$var$getViewMaxBoundaryDate,
    fixTimezoneGap: $af4e1ab686b38b20$var$fixTimezoneGap,
    getTimezonesDifference: $af4e1ab686b38b20$var$getTimezonesDifference,
    makeDate: $af4e1ab686b38b20$var$makeDate,
    getDatesInterval: $af4e1ab686b38b20$var$getDatesInterval,
    getDatesOfInterval: $af4e1ab686b38b20$var$getDatesOfInterval,
    createDateWithFullYear: $af4e1ab686b38b20$var$createDateWithFullYear,
    getMachineTimezoneName: $af4e1ab686b38b20$var$getMachineTimezoneName
};
$af4e1ab686b38b20$var$dateUtils.sameView = function(view, date1, date2) {
    return $af4e1ab686b38b20$var$dateUtils[(0, $lQCfZ.camelize)("same " + view)](date1, date2);
};
var $af4e1ab686b38b20$export$2e2bcd8739ae039 = $af4e1ab686b38b20$var$dateUtils;

});
parcelRegister("l0Pmt", function(module, exports) {
$parcel$export(module.exports, "toMilliseconds", function () { return (parcelRequire("bQvSg")).toMilliseconds; });
/**
 * DevExtreme (esm/renovation/ui/common/utils/date/index.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ parcelRequire("bQvSg");

});
parcelRegister("bQvSg", function(module, exports) {

$parcel$export(module.exports, "toMilliseconds", function () { return $0239c334197f1ab5$export$8f767fa607839182; });
/**
 * DevExtreme (esm/renovation/ui/common/utils/date/toMilliseconds.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $0239c334197f1ab5$var$timeIntervals = {
    millisecond: 1,
    second: 1e3,
    minute: 6e4,
    hour: 36e5,
    day: 864e5,
    week: 6048e5,
    month: 2592e6,
    quarter: 7776e6,
    year: 31536e6
};
function $0239c334197f1ab5$export$8f767fa607839182(value) {
    return $0239c334197f1ab5$var$timeIntervals[value];
}

});



parcelRegister("lmWRz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8e9500650c0808b$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/color.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $f8e9500650c0808b$var$standardColorNames = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "00ffff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000000",
    blanchedalmond: "ffebcd",
    blue: "0000ff",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "00ffff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    feldspar: "d19275",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "ff00ff",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslateblue: "8470ff",
    lightslategray: "778899",
    lightslategrey: "778899",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "00ff00",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "ff00ff",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370d8",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "d87093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "ff0000",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    violetred: "d02090",
    wheat: "f5deb3",
    white: "ffffff",
    whitesmoke: "f5f5f5",
    yellow: "ffff00",
    yellowgreen: "9acd32"
};
var $f8e9500650c0808b$var$standardColorTypes = [
    {
        re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
        process: function(colorString) {
            return [
                parseInt(colorString[1], 10),
                parseInt(colorString[2], 10),
                parseInt(colorString[3], 10)
            ];
        }
    },
    {
        re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*(\d*\.*\d+)\)$/,
        process: function(colorString) {
            return [
                parseInt(colorString[1], 10),
                parseInt(colorString[2], 10),
                parseInt(colorString[3], 10),
                parseFloat(colorString[4])
            ];
        }
    },
    {
        re: /^#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})$/,
        process: function(colorString) {
            return [
                parseInt(colorString[1], 16),
                parseInt(colorString[2], 16),
                parseInt(colorString[3], 16)
            ];
        }
    },
    {
        re: /^#([a-f0-9]{1})([a-f0-9]{1})([a-f0-9]{1})$/,
        process: function(colorString) {
            return [
                parseInt(colorString[1] + colorString[1], 16),
                parseInt(colorString[2] + colorString[2], 16),
                parseInt(colorString[3] + colorString[3], 16)
            ];
        }
    },
    {
        re: /^hsv\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
        process: function(colorString) {
            var h = parseInt(colorString[1], 10);
            var s = parseInt(colorString[2], 10);
            var v = parseInt(colorString[3], 10);
            var rgb = $f8e9500650c0808b$var$hsvToRgb(h, s, v);
            return [
                rgb[0],
                rgb[1],
                rgb[2],
                1,
                [
                    h,
                    s,
                    v
                ]
            ];
        }
    },
    {
        re: /^hsl\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
        process: function(colorString) {
            var h = parseInt(colorString[1], 10);
            var s = parseInt(colorString[2], 10);
            var l = parseInt(colorString[3], 10);
            var rgb = $f8e9500650c0808b$var$hslToRgb(h, s, l);
            return [
                rgb[0],
                rgb[1],
                rgb[2],
                1,
                null,
                [
                    h,
                    s,
                    l
                ]
            ];
        }
    }
];
var $f8e9500650c0808b$var$_round = Math.round;
function $f8e9500650c0808b$var$Color(value) {
    this.baseColor = value;
    var color;
    if (value) {
        color = String(value).toLowerCase().replace(/ /g, "");
        color = $f8e9500650c0808b$var$standardColorNames[color] ? "#" + $f8e9500650c0808b$var$standardColorNames[color] : color;
        color = $f8e9500650c0808b$var$parseColor(color);
    }
    if (!color) this.colorIsInvalid = true;
    color = color || {};
    this.r = $f8e9500650c0808b$var$normalize(color[0]);
    this.g = $f8e9500650c0808b$var$normalize(color[1]);
    this.b = $f8e9500650c0808b$var$normalize(color[2]);
    this.a = $f8e9500650c0808b$var$normalize(color[3], 1, 1);
    if (color[4]) this.hsv = {
        h: color[4][0],
        s: color[4][1],
        v: color[4][2]
    };
    else this.hsv = $f8e9500650c0808b$var$toHsvFromRgb(this.r, this.g, this.b);
    if (color[5]) this.hsl = {
        h: color[5][0],
        s: color[5][1],
        l: color[5][2]
    };
    else this.hsl = $f8e9500650c0808b$var$toHslFromRgb(this.r, this.g, this.b);
}
function $f8e9500650c0808b$var$parseColor(color) {
    if ("transparent" === color) return [
        0,
        0,
        0,
        0
    ];
    var i = 0;
    var ii = $f8e9500650c0808b$var$standardColorTypes.length;
    var str;
    for(; i < ii; ++i){
        str = $f8e9500650c0808b$var$standardColorTypes[i].re.exec(color);
        if (str) return $f8e9500650c0808b$var$standardColorTypes[i].process(str);
    }
    return null;
}
function $f8e9500650c0808b$var$normalize(colorComponent, def, max) {
    def = def || 0;
    max = max || 255;
    return colorComponent < 0 || isNaN(colorComponent) ? def : colorComponent > max ? max : colorComponent;
}
function $f8e9500650c0808b$var$toHexFromRgb(r, g, b) {
    return "#" + (16777216 | r << 16 | g << 8 | b).toString(16).slice(1);
}
function $f8e9500650c0808b$var$toHsvFromRgb(r, g, b) {
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var delta = max - min;
    var H;
    var S;
    var V = max;
    S = 0 === max ? 0 : 1 - min / max;
    if (max === min) H = 0;
    else switch(max){
        case r:
            H = (g - b) / delta * 60;
            if (g < b) H += 360;
            break;
        case g:
            H = (b - r) / delta * 60 + 120;
            break;
        case b:
            H = (r - g) / delta * 60 + 240;
    }
    S *= 100;
    V *= 100 / 255;
    return {
        h: Math.round(H),
        s: Math.round(S),
        v: Math.round(V)
    };
}
function $f8e9500650c0808b$var$hsvToRgb(h, s, v) {
    var index = Math.floor(h % 360 / 60);
    var vMin = (100 - s) * v / 100;
    var a = h % 60 / 60 * (v - vMin);
    var vInc = vMin + a;
    var vDec = v - a;
    var r;
    var g;
    var b;
    switch(index){
        case 0:
            r = v;
            g = vInc;
            b = vMin;
            break;
        case 1:
            r = vDec;
            g = v;
            b = vMin;
            break;
        case 2:
            r = vMin;
            g = v;
            b = vInc;
            break;
        case 3:
            r = vMin;
            g = vDec;
            b = v;
            break;
        case 4:
            r = vInc;
            g = vMin;
            b = v;
            break;
        case 5:
            r = v;
            g = vMin;
            b = vDec;
    }
    return [
        Math.round(2.55 * r),
        Math.round(2.55 * g),
        Math.round(2.55 * b)
    ];
}
function $f8e9500650c0808b$var$calculateHue(r, g, b, delta) {
    var max = Math.max(r, g, b);
    switch(max){
        case r:
            return (g - b) / delta + (g < b ? 6 : 0);
        case g:
            return (b - r) / delta + 2;
        case b:
            return (r - g) / delta + 4;
    }
}
function $f8e9500650c0808b$var$toHslFromRgb(r, g, b) {
    r = $f8e9500650c0808b$var$convertTo01Bounds(r, 255);
    g = $f8e9500650c0808b$var$convertTo01Bounds(g, 255);
    b = $f8e9500650c0808b$var$convertTo01Bounds(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var maxMinSum = max + min;
    var h;
    var s;
    var l = maxMinSum / 2;
    if (max === min) h = s = 0;
    else {
        var delta = max - min;
        if (l > .5) s = delta / (2 - maxMinSum);
        else s = delta / maxMinSum;
        h = $f8e9500650c0808b$var$calculateHue(r, g, b, delta);
        h /= 6;
    }
    return {
        h: $f8e9500650c0808b$var$_round(360 * h),
        s: $f8e9500650c0808b$var$_round(100 * s),
        l: $f8e9500650c0808b$var$_round(100 * l)
    };
}
function $f8e9500650c0808b$var$makeColorTint(colorPart, h) {
    var colorTint = h;
    if ("r" === colorPart) colorTint = h + 1 / 3;
    if ("b" === colorPart) colorTint = h - 1 / 3;
    return colorTint;
}
function $f8e9500650c0808b$var$modifyColorTint(colorTint) {
    if (colorTint < 0) colorTint += 1;
    if (colorTint > 1) colorTint -= 1;
    return colorTint;
}
function $f8e9500650c0808b$var$hueToRgb(p, q, colorTint) {
    colorTint = $f8e9500650c0808b$var$modifyColorTint(colorTint);
    if (colorTint < 1 / 6) return p + 6 * (q - p) * colorTint;
    if (colorTint < .5) return q;
    if (colorTint < 2 / 3) return p + (q - p) * (2 / 3 - colorTint) * 6;
    return p;
}
function $f8e9500650c0808b$var$hslToRgb(h, s, l) {
    var r;
    var g;
    var b;
    h = $f8e9500650c0808b$var$convertTo01Bounds(h, 360);
    s = $f8e9500650c0808b$var$convertTo01Bounds(s, 100);
    l = $f8e9500650c0808b$var$convertTo01Bounds(l, 100);
    if (0 === s) r = g = b = l;
    else {
        var q = l < .5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = $f8e9500650c0808b$var$hueToRgb(p, q, $f8e9500650c0808b$var$makeColorTint("r", h));
        g = $f8e9500650c0808b$var$hueToRgb(p, q, $f8e9500650c0808b$var$makeColorTint("g", h));
        b = $f8e9500650c0808b$var$hueToRgb(p, q, $f8e9500650c0808b$var$makeColorTint("b", h));
    }
    return [
        $f8e9500650c0808b$var$_round(255 * r),
        $f8e9500650c0808b$var$_round(255 * g),
        $f8e9500650c0808b$var$_round(255 * b)
    ];
}
function $f8e9500650c0808b$var$convertTo01Bounds(n, max) {
    n = Math.min(max, Math.max(0, parseFloat(n)));
    if (Math.abs(n - max) < 1e-6) return 1;
    return n % max / parseFloat(max);
}
function $f8e9500650c0808b$var$isIntegerBetweenMinAndMax(number, min, max) {
    min = min || 0;
    max = max || 255;
    if (number % 1 !== 0 || number < min || number > max || "number" !== typeof number || isNaN(number)) return false;
    return true;
}
$f8e9500650c0808b$var$Color.prototype = {
    constructor: $f8e9500650c0808b$var$Color,
    highlight: function(step) {
        step = step || 10;
        return this.alter(step).toHex();
    },
    darken: function(step) {
        step = step || 10;
        return this.alter(-step).toHex();
    },
    alter: function(step) {
        var result = new $f8e9500650c0808b$var$Color;
        result.r = $f8e9500650c0808b$var$normalize(this.r + step);
        result.g = $f8e9500650c0808b$var$normalize(this.g + step);
        result.b = $f8e9500650c0808b$var$normalize(this.b + step);
        return result;
    },
    blend: function(blendColor, opacity) {
        var other = blendColor instanceof $f8e9500650c0808b$var$Color ? blendColor : new $f8e9500650c0808b$var$Color(blendColor);
        var result = new $f8e9500650c0808b$var$Color;
        result.r = $f8e9500650c0808b$var$normalize($f8e9500650c0808b$var$_round(this.r * (1 - opacity) + other.r * opacity));
        result.g = $f8e9500650c0808b$var$normalize($f8e9500650c0808b$var$_round(this.g * (1 - opacity) + other.g * opacity));
        result.b = $f8e9500650c0808b$var$normalize($f8e9500650c0808b$var$_round(this.b * (1 - opacity) + other.b * opacity));
        return result;
    },
    toHex: function() {
        return $f8e9500650c0808b$var$toHexFromRgb(this.r, this.g, this.b);
    },
    getPureColor: function() {
        var rgb = $f8e9500650c0808b$var$hsvToRgb(this.hsv.h, 100, 100);
        return new $f8e9500650c0808b$var$Color("rgb(" + rgb.join(",") + ")");
    },
    isValidHex: function(hex) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(hex);
    },
    isValidRGB: function(r, g, b) {
        if (!$f8e9500650c0808b$var$isIntegerBetweenMinAndMax(r) || !$f8e9500650c0808b$var$isIntegerBetweenMinAndMax(g) || !$f8e9500650c0808b$var$isIntegerBetweenMinAndMax(b)) return false;
        return true;
    },
    isValidAlpha: function(a) {
        if (isNaN(a) || a < 0 || a > 1 || "number" !== typeof a) return false;
        return true;
    },
    colorIsInvalid: false,
    fromHSL: function(hsl) {
        var color = new $f8e9500650c0808b$var$Color;
        var rgb = $f8e9500650c0808b$var$hslToRgb(hsl.h, hsl.s, hsl.l);
        color.r = rgb[0];
        color.g = rgb[1];
        color.b = rgb[2];
        return color;
    }
};
var $f8e9500650c0808b$export$2e2bcd8739ae039 = $f8e9500650c0808b$var$Color;

});



parcelRegister("7UWPL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c3b668b7927addb$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/format_helper.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $f38Z1 = parcelRequire("f38Z1");

var $8qyBL = parcelRequire("8qyBL");

var $8gWak = parcelRequire("8gWak");

var $5Nras = parcelRequire("5Nras");
parcelRequire("i9oc6");
var $5c3b668b7927addb$export$2e2bcd8739ae039 = (0, $5Nras.default)({
    format: function(value, _format) {
        var formatIsValid = (0, $6ntMu.isString)(_format) && "" !== _format || (0, $6ntMu.isPlainObject)(_format) || (0, $6ntMu.isFunction)(_format);
        var valueIsValid = (0, $6ntMu.isNumeric)(value) || (0, $6ntMu.isDate)(value);
        if (!formatIsValid || !valueIsValid) return (0, $6ntMu.isDefined)(value) ? value.toString() : "";
        if ((0, $6ntMu.isFunction)(_format)) return _format(value);
        if ((0, $6ntMu.isString)(_format)) _format = {
            type: _format
        };
        if ((0, $6ntMu.isNumeric)(value)) return (0, $8qyBL.default).format(value, _format);
        if ((0, $6ntMu.isDate)(value)) return (0, $8gWak.default).format(value, _format);
    },
    getTimeFormat: function(showSecond) {
        return showSecond ? "longtime" : "shorttime";
    },
    _normalizeFormat: function(format) {
        if (!Array.isArray(format)) return format;
        if (1 === format.length) return format[0];
        return function(date) {
            return format.map(function(formatPart) {
                return (0, $8gWak.default).format(date, formatPart);
            }).join(" ");
        };
    },
    getDateFormatByDifferences: function(dateDifferences, intervalFormat) {
        var resultFormat = [];
        var needSpecialSecondFormatter = intervalFormat && dateDifferences.millisecond && !(dateDifferences.year || dateDifferences.month || dateDifferences.day);
        if (needSpecialSecondFormatter) resultFormat.push(function(date) {
            return date.getSeconds() + date.getMilliseconds() / 1e3 + "s";
        });
        else if (dateDifferences.millisecond) resultFormat.push("millisecond");
        if (dateDifferences.hour || dateDifferences.minute || !needSpecialSecondFormatter && dateDifferences.second) resultFormat.unshift(this.getTimeFormat(dateDifferences.second));
        if (dateDifferences.year && dateDifferences.month && dateDifferences.day) {
            if (intervalFormat && "month" === intervalFormat) return "monthandyear";
            else {
                resultFormat.unshift("shortdate");
                return this._normalizeFormat(resultFormat);
            }
        }
        if (dateDifferences.year && dateDifferences.month) return "monthandyear";
        if (dateDifferences.year && dateDifferences.quarter) return "quarterandyear";
        if (dateDifferences.year) return "year";
        if (dateDifferences.quarter) return "quarter";
        if (dateDifferences.month && dateDifferences.day) {
            if (intervalFormat) resultFormat.unshift(function(date) {
                return (0, $8gWak.default).getMonthNames("abbreviated")[date.getMonth()] + " " + (0, $8gWak.default).format(date, "day");
            });
            else resultFormat.unshift("monthandday");
            return this._normalizeFormat(resultFormat);
        }
        if (dateDifferences.month) return "month";
        if (dateDifferences.day) {
            if (intervalFormat) resultFormat.unshift("day");
            else resultFormat.unshift(function(date) {
                return (0, $8gWak.default).format(date, "dayofweek") + ", " + (0, $8gWak.default).format(date, "day");
            });
            return this._normalizeFormat(resultFormat);
        }
        return this._normalizeFormat(resultFormat);
    },
    getDateFormatByTicks: function(ticks) {
        var maxDiff;
        var currentDiff;
        var i;
        if (ticks.length > 1) {
            maxDiff = (0, $f38Z1.default).getDatesDifferences(ticks[0], ticks[1]);
            for(i = 1; i < ticks.length - 1; i++){
                currentDiff = (0, $f38Z1.default).getDatesDifferences(ticks[i], ticks[i + 1]);
                if (maxDiff.count < currentDiff.count) maxDiff = currentDiff;
            }
        } else maxDiff = {
            year: true,
            month: true,
            day: true,
            hour: ticks[0].getHours() > 0,
            minute: ticks[0].getMinutes() > 0,
            second: ticks[0].getSeconds() > 0,
            millisecond: ticks[0].getMilliseconds() > 0
        };
        var resultFormat = this.getDateFormatByDifferences(maxDiff);
        return resultFormat;
    },
    getDateFormatByTickInterval: function(startValue, endValue, tickInterval) {
        var dateUnitInterval;
        var correctDateDifferences = function(dateDifferences, tickInterval, value) {
            switch(tickInterval){
                case "year":
                case "quarter":
                    dateDifferences.month = value;
                case "month":
                    dateDifferences.day = value;
                case "week":
                case "day":
                    dateDifferences.hour = value;
                case "hour":
                    dateDifferences.minute = value;
                case "minute":
                    dateDifferences.second = value;
                case "second":
                    dateDifferences.millisecond = value;
            }
        };
        tickInterval = (0, $6ntMu.isString)(tickInterval) ? tickInterval.toLowerCase() : tickInterval;
        var dateDifferences = (0, $f38Z1.default).getDatesDifferences(startValue, endValue);
        if (startValue !== endValue) !function(differences, minDate, maxDate) {
            if (!maxDate.getMilliseconds() && maxDate.getSeconds()) {
                if (maxDate.getSeconds() - minDate.getSeconds() === 1) {
                    differences.millisecond = true;
                    differences.second = false;
                }
            } else if (!maxDate.getSeconds() && maxDate.getMinutes()) {
                if (maxDate.getMinutes() - minDate.getMinutes() === 1) {
                    differences.second = true;
                    differences.minute = false;
                }
            } else if (!maxDate.getMinutes() && maxDate.getHours()) {
                if (maxDate.getHours() - minDate.getHours() === 1) {
                    differences.minute = true;
                    differences.hour = false;
                }
            } else if (!maxDate.getHours() && maxDate.getDate() > 1) {
                if (maxDate.getDate() - minDate.getDate() === 1) {
                    differences.hour = true;
                    differences.day = false;
                }
            } else if (1 === maxDate.getDate() && maxDate.getMonth()) {
                if (maxDate.getMonth() - minDate.getMonth() === 1) {
                    differences.day = true;
                    differences.month = false;
                }
            } else if (!maxDate.getMonth() && maxDate.getFullYear()) {
                if (maxDate.getFullYear() - minDate.getFullYear() === 1) {
                    differences.month = true;
                    differences.year = false;
                }
            }
        }(dateDifferences, startValue > endValue ? endValue : startValue, startValue > endValue ? startValue : endValue);
        dateUnitInterval = (0, $f38Z1.default).getDateUnitInterval(dateDifferences);
        correctDateDifferences(dateDifferences, dateUnitInterval, true);
        dateUnitInterval = (0, $f38Z1.default).getDateUnitInterval(tickInterval || "second");
        correctDateDifferences(dateDifferences, dateUnitInterval, false);
        dateDifferences[({
            week: "day"
        })[dateUnitInterval] || dateUnitInterval] = true;
        var resultFormat = this.getDateFormatByDifferences(dateDifferences);
        return resultFormat;
    }
});

});
parcelRegister("8qyBL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $622b98e4d40d3d44$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/localization/number.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $5Nras = parcelRequire("5Nras");

var $gcp4g = parcelRequire("gcp4g");

var $8OLOW = parcelRequire("8OLOW");

var $6ntMu = parcelRequire("6ntMu");

var $ja579 = parcelRequire("ja579");

var $8IERv = parcelRequire("8IERv");

var $cvYFL = parcelRequire("cvYFL");

var $dO6CD = parcelRequire("dO6CD");

var $i9oc6 = parcelRequire("i9oc6");

var $5FzJP = parcelRequire("5FzJP");
var $622b98e4d40d3d44$var$hasIntl = "undefined" !== typeof Intl;
var $622b98e4d40d3d44$var$MAX_LARGE_NUMBER_POWER = 4;
var $622b98e4d40d3d44$var$DECIMAL_BASE = 10;
var $622b98e4d40d3d44$var$NUMERIC_FORMATS = [
    "currency",
    "fixedpoint",
    "exponential",
    "percent",
    "decimal"
];
var $622b98e4d40d3d44$var$LargeNumberFormatPostfixes = {
    1: "K",
    2: "M",
    3: "B",
    4: "T"
};
var $622b98e4d40d3d44$var$LargeNumberFormatPowers = {
    largenumber: "auto",
    thousands: 1,
    millions: 2,
    billions: 3,
    trillions: 4
};
var $622b98e4d40d3d44$var$numberLocalization = (0, $5Nras.default)({
    engine: function() {
        return "base";
    },
    numericFormats: $622b98e4d40d3d44$var$NUMERIC_FORMATS,
    defaultLargeNumberFormatPostfixes: $622b98e4d40d3d44$var$LargeNumberFormatPostfixes,
    _parseNumberFormatString: function(formatType) {
        var formatObject = {};
        if (!formatType || "string" !== typeof formatType) return;
        var formatList = formatType.toLowerCase().split(" ");
        (0, $8OLOW.each)(formatList, (index, value)=>{
            if ($622b98e4d40d3d44$var$NUMERIC_FORMATS.includes(value)) formatObject.formatType = value;
            else if (value in $622b98e4d40d3d44$var$LargeNumberFormatPowers) formatObject.power = $622b98e4d40d3d44$var$LargeNumberFormatPowers[value];
        });
        if (formatObject.power && !formatObject.formatType) formatObject.formatType = "fixedpoint";
        if (formatObject.formatType) return formatObject;
    },
    _calculateNumberPower: function(value, base, minPower, maxPower) {
        var number = Math.abs(value);
        var power = 0;
        if (number > 1) while(number && number >= base && (void 0 === maxPower || power < maxPower)){
            power++;
            number /= base;
        }
        else if (number > 0 && number < 1) while(number < 1 && (void 0 === minPower || power > minPower)){
            power--;
            number *= base;
        }
        return power;
    },
    _getNumberByPower: function(number, power, base) {
        var result = number;
        while(power > 0){
            result /= base;
            power--;
        }
        while(power < 0){
            result *= base;
            power++;
        }
        return result;
    },
    _formatNumber: function(value, formatObject, formatConfig) {
        if ("auto" === formatObject.power) formatObject.power = this._calculateNumberPower(value, 1e3, 0, $622b98e4d40d3d44$var$MAX_LARGE_NUMBER_POWER);
        if (formatObject.power) value = this._getNumberByPower(value, formatObject.power, 1e3);
        var powerPostfix = this.defaultLargeNumberFormatPostfixes[formatObject.power] || "";
        var result = this._formatNumberCore(value, formatObject.formatType, formatConfig);
        result = result.replace(/(\d|.$)(\D*)$/, "$1" + powerPostfix + "$2");
        return result;
    },
    _formatNumberExponential: function(value, formatConfig) {
        var power = this._calculateNumberPower(value, $622b98e4d40d3d44$var$DECIMAL_BASE);
        var number = this._getNumberByPower(value, power, $622b98e4d40d3d44$var$DECIMAL_BASE);
        if (void 0 === formatConfig.precision) formatConfig.precision = 1;
        if (number.toFixed(formatConfig.precision || 0) >= $622b98e4d40d3d44$var$DECIMAL_BASE) {
            power++;
            number /= $622b98e4d40d3d44$var$DECIMAL_BASE;
        }
        var powString = (power >= 0 ? "+" : "") + power.toString();
        return this._formatNumberCore(number, "fixedpoint", formatConfig) + "E" + powString;
    },
    _addZeroes: function(value, precision) {
        var multiplier = Math.pow(10, precision);
        var sign = value < 0 ? "-" : "";
        value = (Math.abs(value) * multiplier >>> 0) / multiplier;
        var result = value.toString();
        while(result.length < precision)result = "0" + result;
        return sign + result;
    },
    _addGroupSeparators: function(value) {
        var parts = value.toString().split(".");
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, (0, $8IERv.default)().thousandsSeparator) + (parts[1] ? (0, $8IERv.default)().decimalSeparator + parts[1] : "");
    },
    _formatNumberCore: function(value, format, formatConfig) {
        if ("exponential" === format) return this._formatNumberExponential(value, formatConfig);
        if ("decimal" !== format && null !== formatConfig.precision) formatConfig.precision = formatConfig.precision || 0;
        if ("percent" === format) value *= 100;
        if (void 0 !== formatConfig.precision) {
            if ("decimal" === format) value = this._addZeroes(value, formatConfig.precision);
            else value = null === formatConfig.precision ? value.toPrecision() : (0, $dO6CD.toFixed)(value, formatConfig.precision);
        }
        if ("decimal" !== format) value = this._addGroupSeparators(value);
        else value = value.toString().replace(".", (0, $8IERv.default)().decimalSeparator);
        if ("percent" === format) value += "%";
        return value;
    },
    _normalizeFormat: function(format) {
        if (!format) return {};
        if ("function" === typeof format) return format;
        if (!(0, $6ntMu.isPlainObject)(format)) format = {
            type: format
        };
        return format;
    },
    _getSeparators: function() {
        return {
            decimalSeparator: this.getDecimalSeparator(),
            thousandsSeparator: this.getThousandsSeparator()
        };
    },
    getThousandsSeparator: function() {
        return this.format(1e4, "fixedPoint")[2];
    },
    getDecimalSeparator: function() {
        return this.format(1.2, {
            type: "fixedPoint",
            precision: 1
        })[1];
    },
    convertDigits: function(value, toStandard) {
        var digits = this.format(90, "decimal");
        if ("string" !== typeof value || "0" === digits[1]) return value;
        var fromFirstDigit = toStandard ? digits[1] : "0";
        var toFirstDigit = toStandard ? "0" : digits[1];
        var fromLastDigit = toStandard ? digits[0] : "9";
        var regExp = new RegExp("[" + fromFirstDigit + "-" + fromLastDigit + "]", "g");
        return value.replace(regExp, (char)=>String.fromCharCode(char.charCodeAt(0) + (toFirstDigit.charCodeAt(0) - fromFirstDigit.charCodeAt(0))));
    },
    getNegativeEtalonRegExp: function(format) {
        var separators = this._getSeparators();
        var digitalRegExp = new RegExp("[0-9" + (0, $gcp4g.escapeRegExp)(separators.decimalSeparator + separators.thousandsSeparator) + "]+", "g");
        var negativeEtalon = this.format(-1, format).replace(digitalRegExp, "1");
        [
            "\\",
            "(",
            ")",
            "[",
            "]",
            "*",
            "+",
            "$",
            "^",
            "?",
            "|",
            "{",
            "}"
        ].forEach((char)=>{
            negativeEtalon = negativeEtalon.replace(new RegExp("\\".concat(char), "g"), "\\".concat(char));
        });
        negativeEtalon = negativeEtalon.replace(/ /g, "\\s");
        negativeEtalon = negativeEtalon.replace(/1/g, ".*");
        return new RegExp(negativeEtalon, "g");
    },
    getSign: function(text, format) {
        if (!format) {
            if ("-" === text.replace(/[^0-9-]/g, "").charAt(0)) return -1;
            return 1;
        }
        var negativeEtalon = this.getNegativeEtalonRegExp(format);
        return text.match(negativeEtalon) ? -1 : 1;
    },
    format: function(value, _format) {
        if ("number" !== typeof value) return value;
        if ("number" === typeof _format) return value;
        _format = _format && _format.formatter || _format;
        if ("function" === typeof _format) return _format(value);
        _format = this._normalizeFormat(_format);
        if (!_format.type) _format.type = "decimal";
        var numberConfig = this._parseNumberFormatString(_format.type);
        if (!numberConfig) {
            var formatterConfig = this._getSeparators();
            formatterConfig.unlimitedIntegerDigits = _format.unlimitedIntegerDigits;
            return this.convertDigits((0, $ja579.getFormatter)(_format.type, formatterConfig)(value));
        }
        return this._formatNumber(value, numberConfig, _format);
    },
    parse: function(text, format) {
        if (!text) return;
        if (format && format.parser) return format.parser(text);
        text = this.convertDigits(text, true);
        if (format && "string" !== typeof format) (0, $cvYFL.default).log("W0011");
        var decimalSeparator = this.getDecimalSeparator();
        var regExp = new RegExp("[^0-9" + (0, $gcp4g.escapeRegExp)(decimalSeparator) + "]", "g");
        var cleanedText = text.replace(regExp, "").replace(decimalSeparator, ".").replace(/\.$/g, "");
        if ("." === cleanedText || "" === cleanedText) return null;
        if (this._calcSignificantDigits(cleanedText) > 15) return NaN;
        var parsed = +cleanedText * this.getSign(text, format);
        format = this._normalizeFormat(format);
        var formatConfig = this._parseNumberFormatString(format.type);
        var power = null === formatConfig || void 0 === formatConfig ? void 0 : formatConfig.power;
        if (power) {
            if ("auto" === power) {
                var match = text.match(/\d(K|M|B|T)/);
                if (match) power = Object.keys($622b98e4d40d3d44$var$LargeNumberFormatPostfixes).find((power)=>$622b98e4d40d3d44$var$LargeNumberFormatPostfixes[power] === match[1]);
            }
            parsed *= Math.pow(10, 3 * power);
        }
        if ("percent" === (null === formatConfig || void 0 === formatConfig ? void 0 : formatConfig.formatType)) parsed /= 100;
        return parsed;
    },
    _calcSignificantDigits: function(text) {
        var [integer, fractional] = text.split(".");
        var calcDigitsAfterLeadingZeros = (digits)=>{
            var index = -1;
            for(var i = 0; i < digits.length; i++)if ("0" !== digits[i]) {
                index = i;
                break;
            }
            return index > -1 ? digits.length - index : 0;
        };
        var result = 0;
        if (integer) result += calcDigitsAfterLeadingZeros(integer.split(""));
        if (fractional) result += calcDigitsAfterLeadingZeros(fractional.split("").reverse());
        return result;
    }
});
$622b98e4d40d3d44$var$numberLocalization.inject((0, $i9oc6.default));
if ($622b98e4d40d3d44$var$hasIntl) $622b98e4d40d3d44$var$numberLocalization.inject((0, $5FzJP.default));
var $622b98e4d40d3d44$export$2e2bcd8739ae039 = $622b98e4d40d3d44$var$numberLocalization;

});
parcelRegister("ja579", function(module, exports) {

$parcel$export(module.exports, "getFormatter", function () { return $df32eb1c50e80d0c$export$a7f9565e3c81cd54; });
/**
 * DevExtreme (esm/localization/ldml/number.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $laqiS = parcelRequire("laqiS");

var $dO6CD = parcelRequire("dO6CD");
var $df32eb1c50e80d0c$var$DEFAULT_CONFIG = {
    thousandsSeparator: ",",
    decimalSeparator: "."
};
var $df32eb1c50e80d0c$var$ESCAPING_CHAR = "'";
var $df32eb1c50e80d0c$var$MAXIMUM_NUMBER_LENGTH = 15;
var $df32eb1c50e80d0c$var$PERCENT_EXPONENT_SHIFT = 2;
function $df32eb1c50e80d0c$var$getGroupSizes(formatString) {
    return formatString.split(",").slice(1).map(function(str) {
        var singleQuotesLeft = 0;
        return str.split("").filter(function(char, index) {
            singleQuotesLeft += "'" === char;
            var isDigit = "#" === char || "0" === char;
            var isInStub = singleQuotesLeft % 2;
            return isDigit && !isInStub;
        }).length;
    });
}
function $df32eb1c50e80d0c$var$getSignParts(format) {
    var signParts = format.split(";");
    if (1 === signParts.length) signParts.push("-" + signParts[0]);
    return signParts;
}
function $df32eb1c50e80d0c$var$reverseString(str) {
    return str.toString().split("").reverse().join("");
}
function $df32eb1c50e80d0c$var$isPercentFormat(format) {
    return -1 !== format.indexOf("%") && !format.match(/'[^']*%[^']*'/g);
}
function $df32eb1c50e80d0c$var$removeStubs(str) {
    return str.replace(/'.+'/g, "");
}
function $df32eb1c50e80d0c$var$getNonRequiredDigitCount(floatFormat) {
    if (!floatFormat) return 0;
    var format = $df32eb1c50e80d0c$var$removeStubs(floatFormat);
    return format.length - format.replace(/[#]/g, "").length;
}
function $df32eb1c50e80d0c$var$getRequiredDigitCount(floatFormat) {
    if (!floatFormat) return 0;
    var format = $df32eb1c50e80d0c$var$removeStubs(floatFormat);
    return format.length - format.replace(/[0]/g, "").length;
}
function $df32eb1c50e80d0c$var$normalizeValueString(valuePart, minDigitCount, maxDigitCount) {
    if (!valuePart) return "";
    if (valuePart.length > maxDigitCount) valuePart = valuePart.substr(0, maxDigitCount);
    while(valuePart.length > minDigitCount && "0" === valuePart.slice(-1))valuePart = valuePart.substr(0, valuePart.length - 1);
    while(valuePart.length < minDigitCount)valuePart += "0";
    return valuePart;
}
function $df32eb1c50e80d0c$var$applyGroups(valueString, groupSizes, thousandsSeparator) {
    if (!groupSizes.length) return valueString;
    var groups = [];
    var index = 0;
    while(valueString){
        var groupSize = groupSizes[index];
        if (!groupSize) break;
        groups.push(valueString.slice(0, groupSize));
        valueString = valueString.slice(groupSize);
        if (index < groupSizes.length - 1) index++;
    }
    return groups.join(thousandsSeparator);
}
function $df32eb1c50e80d0c$var$formatNumberPart(format, valueString) {
    return format.split($df32eb1c50e80d0c$var$ESCAPING_CHAR).map(function(formatPart, escapeIndex) {
        var isEscape = escapeIndex % 2;
        if (!formatPart && isEscape) return $df32eb1c50e80d0c$var$ESCAPING_CHAR;
        return isEscape ? formatPart : formatPart.replace(/[,#0]+/, valueString);
    }).join("");
}
function $df32eb1c50e80d0c$var$getFloatPointIndex(format) {
    var isEscape = false;
    for(var index = 0; index < format.length; index++){
        if ("'" === format[index]) isEscape = !isEscape;
        if ("." === format[index] && !isEscape) return index;
    }
    return format.length;
}
function $df32eb1c50e80d0c$export$a7f9565e3c81cd54(format, config) {
    config = config || $df32eb1c50e80d0c$var$DEFAULT_CONFIG;
    return function(value) {
        if ("number" !== typeof value || isNaN(value)) return "";
        var signFormatParts = $df32eb1c50e80d0c$var$getSignParts(format);
        var isPositiveZero = 1 / value === 1 / 0;
        var isPositive = value > 0 || isPositiveZero;
        var numberFormat = signFormatParts[isPositive ? 0 : 1];
        var floatPointIndex = $df32eb1c50e80d0c$var$getFloatPointIndex(numberFormat);
        var floatFormatParts = [
            numberFormat.substr(0, floatPointIndex),
            numberFormat.substr(floatPointIndex + 1)
        ];
        var minFloatPrecision = $df32eb1c50e80d0c$var$getRequiredDigitCount(floatFormatParts[1]);
        var maxFloatPrecision = minFloatPrecision + $df32eb1c50e80d0c$var$getNonRequiredDigitCount(floatFormatParts[1]);
        if ($df32eb1c50e80d0c$var$isPercentFormat(numberFormat)) value = (0, $laqiS.multiplyInExponentialForm)(value, $df32eb1c50e80d0c$var$PERCENT_EXPONENT_SHIFT);
        if (!isPositive) value = -value;
        var minIntegerPrecision = $df32eb1c50e80d0c$var$getRequiredDigitCount(floatFormatParts[0]);
        var maxIntegerPrecision = $df32eb1c50e80d0c$var$getNonRequiredDigitCount(floatFormatParts[0]) || config.unlimitedIntegerDigits ? void 0 : minIntegerPrecision;
        var integerLength = Math.floor(value).toString().length;
        var floatPrecision = (0, $laqiS.fitIntoRange)(maxFloatPrecision, 0, $df32eb1c50e80d0c$var$MAXIMUM_NUMBER_LENGTH - integerLength);
        var groupSizes = $df32eb1c50e80d0c$var$getGroupSizes(floatFormatParts[0]).reverse();
        var valueParts = (0, $dO6CD.toFixed)(value, floatPrecision < 0 ? 0 : floatPrecision).split(".");
        var valueIntegerPart = $df32eb1c50e80d0c$var$normalizeValueString($df32eb1c50e80d0c$var$reverseString(valueParts[0]), minIntegerPrecision, maxIntegerPrecision);
        var valueFloatPart = $df32eb1c50e80d0c$var$normalizeValueString(valueParts[1], minFloatPrecision, maxFloatPrecision);
        valueIntegerPart = $df32eb1c50e80d0c$var$applyGroups(valueIntegerPart, groupSizes, config.thousandsSeparator);
        var integerString = $df32eb1c50e80d0c$var$reverseString($df32eb1c50e80d0c$var$formatNumberPart($df32eb1c50e80d0c$var$reverseString(floatFormatParts[0]), valueIntegerPart));
        var floatString = maxFloatPrecision ? $df32eb1c50e80d0c$var$formatNumberPart(floatFormatParts[1], valueFloatPart) : "";
        var result = integerString + (floatString.match(/\d/) ? config.decimalSeparator : "") + floatString;
        return result;
    };
}
function $df32eb1c50e80d0c$var$parseValue(text, isPercent, isNegative) {
    var value = (isPercent ? .01 : 1) * parseFloat(text) || 0;
    return isNegative ? -value : value;
}
function $df32eb1c50e80d0c$var$prepareValueText(valueText, formatter, isPercent, isIntegerPart) {
    var nextValueText = valueText;
    var char;
    var text;
    var nextText;
    do {
        if (nextText) {
            char = text.length === nextText.length ? "0" : "1";
            valueText = isIntegerPart ? char + valueText : valueText + char;
        }
        text = nextText || formatter($df32eb1c50e80d0c$var$parseValue(nextValueText, isPercent));
        nextValueText = isIntegerPart ? "1" + nextValueText : nextValueText + "1";
        nextText = formatter($df32eb1c50e80d0c$var$parseValue(nextValueText, isPercent));
    }while (text !== nextText && (isIntegerPart ? text.length === nextText.length : text.length <= nextText.length));
    if (isIntegerPart && nextText.length > text.length) {
        var hasGroups = -1 === formatter(12345).indexOf("12345");
        do valueText = "1" + valueText;
        while (hasGroups && $df32eb1c50e80d0c$var$parseValue(valueText, isPercent) < 1e5);
    }
    return valueText;
}
function $df32eb1c50e80d0c$var$getFormatByValueText(valueText, formatter, isPercent, isNegative) {
    var format = formatter($df32eb1c50e80d0c$var$parseValue(valueText, isPercent, isNegative));
    var valueTextParts = valueText.split(".");
    var valueTextWithModifiedFloat = valueTextParts[0] + ".3" + valueTextParts[1].slice(1);
    var valueWithModifiedFloat = $df32eb1c50e80d0c$var$parseValue(valueTextWithModifiedFloat, isPercent, isNegative);
    var decimalSeparatorIndex = formatter(valueWithModifiedFloat).indexOf("3") - 1;
    format = format.replace(/(\d)\D(\d)/g, "$1,$2");
    if (decimalSeparatorIndex >= 0) format = format.slice(0, decimalSeparatorIndex) + "." + format.slice(decimalSeparatorIndex + 1);
    format = format.replace(/1+/, "1").replace(/1/g, "#");
    if (!isPercent) format = format.replace(/%/g, "'%'");
    return format;
}
function $df32eb1c50e80d0c$export$f61ac8b6f1f46202(formatter) {
    var valueText = ".";
    var isPercent = formatter(1).indexOf("100") >= 0;
    valueText = $df32eb1c50e80d0c$var$prepareValueText(valueText, formatter, isPercent, true);
    valueText = $df32eb1c50e80d0c$var$prepareValueText(valueText, formatter, isPercent, false);
    var positiveFormat = $df32eb1c50e80d0c$var$getFormatByValueText(valueText, formatter, isPercent, false);
    var negativeFormat = $df32eb1c50e80d0c$var$getFormatByValueText(valueText, formatter, isPercent, true);
    return negativeFormat === "-" + positiveFormat ? positiveFormat : positiveFormat + ";" + negativeFormat;
}

});
parcelRegister("dO6CD", function(module, exports) {

$parcel$export(module.exports, "toFixed", function () { return $a0d514e68dc2080f$export$a81f732198733497; });
/**
 * DevExtreme (esm/localization/utils.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $laqiS = parcelRequire("laqiS");
var $a0d514e68dc2080f$var$DECIMAL_BASE = 10;
function $a0d514e68dc2080f$var$roundByAbs(value) {
    var valueSign = (0, $laqiS.sign)(value);
    return valueSign * Math.round(Math.abs(value));
}
function $a0d514e68dc2080f$var$adjustValue(value, precision) {
    var precisionMultiplier = Math.pow($a0d514e68dc2080f$var$DECIMAL_BASE, precision);
    var intermediateValue = (0, $laqiS.multiplyInExponentialForm)(value, precision);
    return $a0d514e68dc2080f$var$roundByAbs(intermediateValue) / precisionMultiplier;
}
function $a0d514e68dc2080f$export$a81f732198733497(value, precision) {
    var valuePrecision = precision || 0;
    var adjustedValue = valuePrecision > 0 ? $a0d514e68dc2080f$var$adjustValue(...arguments) : value;
    return adjustedValue.toFixed(valuePrecision);
}

});


parcelRegister("i9oc6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d36bd5b8c0ec270b$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/localization/currency.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");
var $d36bd5b8c0ec270b$export$2e2bcd8739ae039 = {
    _formatNumberCore: function(value, format, formatConfig) {
        if ("currency" === format) {
            formatConfig.precision = formatConfig.precision || 0;
            var result = this.format(value, (0, $2oTOp.extend)({}, formatConfig, {
                type: "fixedpoint"
            }));
            var currencyPart = this.getCurrencySymbol().symbol.replace(/\$/g, "$$$$");
            result = result.replace(/^(\D*)(\d.*)/, "$1" + currencyPart + "$2");
            return result;
        }
        return this.callBase.apply(this, arguments);
    },
    getCurrencySymbol: function() {
        return {
            symbol: "$"
        };
    },
    getOpenXmlCurrencyFormat: function() {
        return "$#,##0{0}_);\\($#,##0{0}\\)";
    }
};

});

parcelRegister("5FzJP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $420c80eebe0e8210$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/localization/intl/number.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $8IERv = parcelRequire("8IERv");

var $iTFn1 = parcelRequire("iTFn1");

var $4TuGF = parcelRequire("4TuGF");

var $fzTDU = parcelRequire("fzTDU");
var $420c80eebe0e8210$var$CURRENCY_STYLES = [
    "standard",
    "accounting"
];
var $420c80eebe0e8210$var$MAX_FRACTION_DIGITS = 20;
var $420c80eebe0e8210$var$detectCurrencySymbolRegex = /([^\s0]+)?(\s*)0*[.,]*0*(\s*)([^\s0]+)?/;
var $420c80eebe0e8210$var$formattersCache = {};
var $420c80eebe0e8210$var$getFormatter = (format)=>{
    var key = (0, $iTFn1.default).locale() + "/" + JSON.stringify(format);
    if (!$420c80eebe0e8210$var$formattersCache[key]) $420c80eebe0e8210$var$formattersCache[key] = new Intl.NumberFormat((0, $iTFn1.default).locale(), format).format;
    return $420c80eebe0e8210$var$formattersCache[key];
};
var $420c80eebe0e8210$var$getCurrencyFormatter = (currency)=>new Intl.NumberFormat((0, $iTFn1.default).locale(), {
        style: "currency",
        currency: currency
    });
var $420c80eebe0e8210$export$2e2bcd8739ae039 = {
    engine: function() {
        return "intl";
    },
    _formatNumberCore: function(value, format, formatConfig) {
        if ("exponential" === format) return this.callBase.apply(this, arguments);
        return $420c80eebe0e8210$var$getFormatter(this._normalizeFormatConfig(format, formatConfig, value))(value);
    },
    _normalizeFormatConfig: function(format, formatConfig, value) {
        var config;
        if ("decimal" === format) {
            var fractionDigits = String(value).split(".")[1];
            config = {
                minimumIntegerDigits: formatConfig.precision || void 0,
                useGrouping: false,
                maximumFractionDigits: fractionDigits && fractionDigits.length,
                round: value < 0 ? "ceil" : "floor"
            };
        } else config = this._getPrecisionConfig(formatConfig.precision);
        if ("percent" === format) config.style = "percent";
        else if ("currency" === format) {
            var _formatConfig$useCurr;
            var useAccountingStyle = null !== (_formatConfig$useCurr = formatConfig.useCurrencyAccountingStyle) && void 0 !== _formatConfig$useCurr ? _formatConfig$useCurr : (0, $8IERv.default)().defaultUseCurrencyAccountingStyle;
            config.style = "currency";
            config.currency = formatConfig.currency || (0, $8IERv.default)().defaultCurrency;
            config.currencySign = $420c80eebe0e8210$var$CURRENCY_STYLES[+useAccountingStyle];
        }
        return config;
    },
    _getPrecisionConfig: function(precision) {
        var config;
        if (null === precision) config = {
            minimumFractionDigits: 0,
            maximumFractionDigits: $420c80eebe0e8210$var$MAX_FRACTION_DIGITS
        };
        else config = {
            minimumFractionDigits: precision || 0,
            maximumFractionDigits: precision || 0
        };
        return config;
    },
    format: function(value, _format) {
        if ("number" !== typeof value) return value;
        _format = this._normalizeFormat(_format);
        if ("default" === _format.currency) _format.currency = (0, $8IERv.default)().defaultCurrency;
        if (!_format || "function" !== typeof _format && !_format.type && !_format.formatter) return $420c80eebe0e8210$var$getFormatter(_format)(value);
        return this.callBase.apply(this, arguments);
    },
    _getCurrencySymbolInfo: function(currency) {
        var formatter = $420c80eebe0e8210$var$getCurrencyFormatter(currency);
        return this._extractCurrencySymbolInfo(formatter.format(0));
    },
    _extractCurrencySymbolInfo: function(currencyValueString) {
        var match = $420c80eebe0e8210$var$detectCurrencySymbolRegex.exec(currencyValueString) || [];
        var position = match[1] ? "before" : "after";
        var symbol = match[1] || match[4] || "";
        var delimiter = match[2] || match[3] || "";
        return {
            position: position,
            symbol: symbol,
            delimiter: delimiter
        };
    },
    getCurrencySymbol: function(currency) {
        if (!currency) currency = (0, $8IERv.default)().defaultCurrency;
        var symbolInfo = this._getCurrencySymbolInfo(currency);
        return {
            symbol: symbolInfo.symbol
        };
    },
    getOpenXmlCurrencyFormat: function(currency) {
        var targetCurrency = currency || (0, $8IERv.default)().defaultCurrency;
        var currencySymbol = this._getCurrencySymbolInfo(targetCurrency).symbol;
        var closestAccountingFormat = (0, $iTFn1.default).getValueByClosestLocale((locale)=>(0, $fzTDU.default)[locale]);
        return (0, $4TuGF.default)(currencySymbol, closestAccountingFormat);
    }
};

});
parcelRegister("iTFn1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc1d74599ab6e4e4$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/localization/core.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $5Nras = parcelRequire("5Nras");

var $3n7JD = parcelRequire("3n7JD");

var $9O4Kz = parcelRequire("9O4Kz");
var $dc1d74599ab6e4e4$var$DEFAULT_LOCALE = "en";
var $dc1d74599ab6e4e4$export$2e2bcd8739ae039 = (0, $5Nras.default)({
    locale: (()=>{
        var currentLocale = $dc1d74599ab6e4e4$var$DEFAULT_LOCALE;
        return (locale)=>{
            if (!locale) return currentLocale;
            currentLocale = locale;
        };
    })(),
    getValueByClosestLocale: function(getter) {
        var locale = this.locale();
        var value = getter(locale);
        var isRootLocale;
        while(!value && !isRootLocale){
            locale = (0, $9O4Kz.default)((0, $3n7JD.default), locale);
            if (locale) value = getter(locale);
            else isRootLocale = true;
        }
        if (void 0 === value && locale !== $dc1d74599ab6e4e4$var$DEFAULT_LOCALE) return getter($dc1d74599ab6e4e4$var$DEFAULT_LOCALE);
        return value;
    }
});

});
parcelRegister("3n7JD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $274985166b0fa423$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/localization/cldr-data/parent_locales.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ // !!! AUTO-GENERATED FILE, DO NOT EDIT
var $274985166b0fa423$export$2e2bcd8739ae039 = {
    "en-150": "en-001",
    "en-AG": "en-001",
    "en-AI": "en-001",
    "en-AU": "en-001",
    "en-BB": "en-001",
    "en-BM": "en-001",
    "en-BS": "en-001",
    "en-BW": "en-001",
    "en-BZ": "en-001",
    "en-CC": "en-001",
    "en-CK": "en-001",
    "en-CM": "en-001",
    "en-CX": "en-001",
    "en-CY": "en-001",
    "en-DG": "en-001",
    "en-DM": "en-001",
    "en-ER": "en-001",
    "en-FJ": "en-001",
    "en-FK": "en-001",
    "en-FM": "en-001",
    "en-GB": "en-001",
    "en-GD": "en-001",
    "en-GG": "en-001",
    "en-GH": "en-001",
    "en-GI": "en-001",
    "en-GM": "en-001",
    "en-GY": "en-001",
    "en-HK": "en-001",
    "en-IE": "en-001",
    "en-IL": "en-001",
    "en-IM": "en-001",
    "en-IN": "en-001",
    "en-IO": "en-001",
    "en-JE": "en-001",
    "en-JM": "en-001",
    "en-KE": "en-001",
    "en-KI": "en-001",
    "en-KN": "en-001",
    "en-KY": "en-001",
    "en-LC": "en-001",
    "en-LR": "en-001",
    "en-LS": "en-001",
    "en-MG": "en-001",
    "en-MO": "en-001",
    "en-MS": "en-001",
    "en-MT": "en-001",
    "en-MU": "en-001",
    "en-MV": "en-001",
    "en-MW": "en-001",
    "en-MY": "en-001",
    "en-NA": "en-001",
    "en-NF": "en-001",
    "en-NG": "en-001",
    "en-NR": "en-001",
    "en-NU": "en-001",
    "en-NZ": "en-001",
    "en-PG": "en-001",
    "en-PK": "en-001",
    "en-PN": "en-001",
    "en-PW": "en-001",
    "en-RW": "en-001",
    "en-SB": "en-001",
    "en-SC": "en-001",
    "en-SD": "en-001",
    "en-SG": "en-001",
    "en-SH": "en-001",
    "en-SL": "en-001",
    "en-SS": "en-001",
    "en-SX": "en-001",
    "en-SZ": "en-001",
    "en-TC": "en-001",
    "en-TK": "en-001",
    "en-TO": "en-001",
    "en-TT": "en-001",
    "en-TV": "en-001",
    "en-TZ": "en-001",
    "en-UG": "en-001",
    "en-VC": "en-001",
    "en-VG": "en-001",
    "en-VU": "en-001",
    "en-WS": "en-001",
    "en-ZA": "en-001",
    "en-ZM": "en-001",
    "en-ZW": "en-001",
    "en-AT": "en-150",
    "en-BE": "en-150",
    "en-CH": "en-150",
    "en-DE": "en-150",
    "en-DK": "en-150",
    "en-FI": "en-150",
    "en-NL": "en-150",
    "en-SE": "en-150",
    "en-SI": "en-150",
    "hi-Latn": "en-IN",
    "es-AR": "es-419",
    "es-BO": "es-419",
    "es-BR": "es-419",
    "es-BZ": "es-419",
    "es-CL": "es-419",
    "es-CO": "es-419",
    "es-CR": "es-419",
    "es-CU": "es-419",
    "es-DO": "es-419",
    "es-EC": "es-419",
    "es-GT": "es-419",
    "es-HN": "es-419",
    "es-MX": "es-419",
    "es-NI": "es-419",
    "es-PA": "es-419",
    "es-PE": "es-419",
    "es-PR": "es-419",
    "es-PY": "es-419",
    "es-SV": "es-419",
    "es-US": "es-419",
    "es-UY": "es-419",
    "es-VE": "es-419",
    nb: "no",
    nn: "no",
    "pt-AO": "pt-PT",
    "pt-CH": "pt-PT",
    "pt-CV": "pt-PT",
    "pt-FR": "pt-PT",
    "pt-GQ": "pt-PT",
    "pt-GW": "pt-PT",
    "pt-LU": "pt-PT",
    "pt-MO": "pt-PT",
    "pt-MZ": "pt-PT",
    "pt-ST": "pt-PT",
    "pt-TL": "pt-PT",
    "az-Arab": "und",
    "az-Cyrl": "und",
    "bal-Latn": "und",
    "blt-Latn": "und",
    "bm-Nkoo": "und",
    "bs-Cyrl": "und",
    "byn-Latn": "und",
    "cu-Glag": "und",
    "dje-Arab": "und",
    "dyo-Arab": "und",
    "en-Dsrt": "und",
    "en-Shaw": "und",
    "ff-Adlm": "und",
    "ff-Arab": "und",
    "ha-Arab": "und",
    "iu-Latn": "und",
    "kk-Arab": "und",
    "ks-Deva": "und",
    "ku-Arab": "und",
    "ky-Arab": "und",
    "ky-Latn": "und",
    "ml-Arab": "und",
    "mn-Mong": "und",
    "mni-Mtei": "und",
    "ms-Arab": "und",
    "pa-Arab": "und",
    "sat-Deva": "und",
    "sd-Deva": "und",
    "sd-Khoj": "und",
    "sd-Sind": "und",
    "shi-Latn": "und",
    "so-Arab": "und",
    "sr-Latn": "und",
    "sw-Arab": "und",
    "tg-Arab": "und",
    "ug-Cyrl": "und",
    "uz-Arab": "und",
    "uz-Cyrl": "und",
    "vai-Latn": "und",
    "wo-Arab": "und",
    "yo-Arab": "und",
    "yue-Hans": "und",
    "zh-Hant": "und",
    "zh-Hant-MO": "zh-Hant-HK"
};

});

parcelRegister("9O4Kz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $723c77da450c3bb9$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/localization/parentLocale.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $723c77da450c3bb9$var$PARENT_LOCALE_SEPARATOR = "-";
var $723c77da450c3bb9$export$2e2bcd8739ae039 = (parentLocales, locale)=>{
    var parentLocale = parentLocales[locale];
    if (parentLocale) return "root" !== parentLocale && parentLocale;
    return locale.substr(0, locale.lastIndexOf($723c77da450c3bb9$var$PARENT_LOCALE_SEPARATOR));
};

});


parcelRegister("4TuGF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39041a4e581d9f4d$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/localization/open_xml_currency_format.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $39041a4e581d9f4d$export$2e2bcd8739ae039 = (currencySymbol, accountingFormat)=>{
    if (!accountingFormat) return;
    var encodedCurrencySymbol = currencySymbol;
    if ("string" === typeof currencySymbol) {
        encodedCurrencySymbol = "";
        for(var i = 0; i < currencySymbol.length; i++){
            if ("$" !== currencySymbol[i]) encodedCurrencySymbol += "\\";
            encodedCurrencySymbol += currencySymbol[i];
        }
    }
    var encodeSymbols = {
        ".00": "{0}",
        "'": "\\'",
        "\\(": "\\(",
        "\\)": "\\)",
        " ": "\\ ",
        '"': "&quot;",
        "\\\xa4": encodedCurrencySymbol
    };
    var result = accountingFormat.split(";");
    for(var _i = 0; _i < result.length; _i++){
        for(var symbol in encodeSymbols)if (Object.prototype.hasOwnProperty.call(encodeSymbols, symbol)) result[_i] = result[_i].replace(new RegExp(symbol, "g"), encodeSymbols[symbol]);
    }
    return 2 === result.length ? result[0] + "_);" + result[1] : result[0];
};

});

parcelRegister("fzTDU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5754966e7003676$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/localization/cldr-data/accounting_formats.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ // !!! AUTO-GENERATED FILE, DO NOT EDIT
var $b5754966e7003676$export$2e2bcd8739ae039 = {
    af: "\xa4#,##0.00;(\xa4#,##0.00)",
    "af-NA": "\xa4#,##0.00;(\xa4#,##0.00)",
    agq: "#,##0.00\xa4",
    ak: "\xa4#,##0.00",
    am: "\xa4#,##0.00;(\xa4#,##0.00)",
    ar: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-AE": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-BH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-DJ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-DZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-EG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-EH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-ER": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-IL": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-IQ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-JO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-KM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-KW": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-LB": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-LY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-MA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-MR": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-OM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-PS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-QA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-SA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-SD": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-SO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-SS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-SY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-TD": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-TN": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-YE": "\xa4#,##0.00;(\xa4#,##0.00)",
    as: "\xa4\xa0#,##,##0.00",
    asa: "#,##0.00\xa0\xa4",
    ast: "#,##0.00\xa0\xa4",
    az: "#,##0.00\xa0\xa4",
    "az-Cyrl": "#,##0.00\xa0\xa4",
    "az-Latn": "#,##0.00\xa0\xa4",
    bas: "#,##0.00\xa0\xa4",
    be: "#,##0.00\xa0\xa4",
    "be-tarask": "#,##0.00\xa0\xa4",
    bem: "\xa4#,##0.00;(\xa4#,##0.00)",
    bez: "#,##0.00\xa4",
    bg: "0.00\xa0\xa4;(0.00\xa0\xa4)",
    bm: "\xa4#,##0.00;(\xa4#,##0.00)",
    bn: "#,##,##0.00\xa4;(#,##,##0.00\xa4)",
    "bn-IN": "#,##,##0.00\xa4;(#,##,##0.00\xa4)",
    bo: "\xa4\xa0#,##0.00",
    "bo-IN": "\xa4\xa0#,##0.00",
    br: "#,##0.00\xa0\xa4",
    brx: "\xa4\xa0#,##,##0.00",
    bs: "#,##0.00\xa0\xa4",
    "bs-Cyrl": "#,##0.00\xa0\xa4",
    "bs-Latn": "#,##0.00\xa0\xa4",
    ca: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "ca-AD": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "ca-ES-valencia": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "ca-FR": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "ca-IT": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    ccp: "#,##,##0.00\xa4;(#,##,##0.00\xa4)",
    "ccp-IN": "#,##,##0.00\xa4;(#,##,##0.00\xa4)",
    ce: "#,##0.00\xa0\xa4",
    ceb: "\xa4#,##0.00;(\xa4#,##0.00)",
    cgg: "\xa4#,##0.00",
    chr: "\xa4#,##0.00;(\xa4#,##0.00)",
    ckb: "\xa4\xa0#,##0.00",
    "ckb-IR": "\xa4\xa0#,##0.00",
    cs: "#,##0.00\xa0\xa4",
    cy: "\xa4#,##0.00;(\xa4#,##0.00)",
    da: "#,##0.00\xa0\xa4",
    "da-GL": "#,##0.00\xa0\xa4",
    dav: "\xa4#,##0.00;(\xa4#,##0.00)",
    de: "#,##0.00\xa0\xa4",
    "de-AT": "#,##0.00\xa0\xa4",
    "de-BE": "#,##0.00\xa0\xa4",
    "de-CH": "#,##0.00\xa0\xa4",
    "de-IT": "#,##0.00\xa0\xa4",
    "de-LI": "#,##0.00\xa0\xa4",
    "de-LU": "#,##0.00\xa0\xa4",
    dje: "#,##0.00\xa4",
    doi: "\xa4#,##0.00",
    dsb: "#,##0.00\xa0\xa4",
    dua: "#,##0.00\xa0\xa4",
    dyo: "#,##0.00\xa0\xa4",
    dz: "\xa4#,##,##0.00",
    ebu: "\xa4#,##0.00;(\xa4#,##0.00)",
    ee: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ee-TG": "\xa4#,##0.00;(\xa4#,##0.00)",
    el: "#,##0.00\xa0\xa4",
    "el-CY": "#,##0.00\xa0\xa4",
    en: "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-001": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-150": "#,##0.00\xa0\xa4",
    "en-AE": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-AG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-AI": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-AS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-AT": "\xa4\xa0#,##0.00",
    "en-AU": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BB": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BE": "#,##0.00\xa0\xa4",
    "en-BI": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BW": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CC": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CH": "\xa4\xa0#,##0.00;\xa4-#,##0.00",
    "en-CK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CX": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-DE": "#,##0.00\xa0\xa4",
    "en-DG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-DK": "#,##0.00\xa0\xa4",
    "en-DM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-ER": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-FI": "#,##0.00\xa0\xa4",
    "en-FJ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-FK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-FM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GB": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GD": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GI": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GU": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-HK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-IE": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-IL": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-IM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-IN": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-IO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-JE": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-JM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-KE": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-KI": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-KN": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-KY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-LC": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-LR": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-LS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MP": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MT": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MU": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MV": "\xa4\xa0#,##0.00",
    "en-MW": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NF": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NL": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "en-NR": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NU": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PN": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PR": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PW": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-RW": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SB": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SC": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SD": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SE": "#,##0.00\xa0\xa4",
    "en-SG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SI": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "en-SL": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SX": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TC": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TT": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TV": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-UG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-UM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-VC": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-VG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-VI": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-VU": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-WS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-ZA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-ZM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-ZW": "\xa4#,##0.00;(\xa4#,##0.00)",
    eo: "\xa4\xa0#,##0.00",
    es: "#,##0.00\xa0\xa4",
    "es-419": "\xa4#,##0.00",
    "es-AR": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "es-BO": "\xa4#,##0.00",
    "es-BR": "\xa4#,##0.00",
    "es-BZ": "\xa4#,##0.00",
    "es-CL": "\xa4#,##0.00",
    "es-CO": "\xa4#,##0.00",
    "es-CR": "\xa4#,##0.00",
    "es-CU": "\xa4#,##0.00",
    "es-DO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "es-EA": "#,##0.00\xa0\xa4",
    "es-EC": "\xa4#,##0.00",
    "es-GQ": "#,##0.00\xa0\xa4",
    "es-GT": "\xa4#,##0.00",
    "es-HN": "\xa4#,##0.00",
    "es-IC": "#,##0.00\xa0\xa4",
    "es-MX": "\xa4#,##0.00",
    "es-NI": "\xa4#,##0.00",
    "es-PA": "\xa4#,##0.00",
    "es-PE": "\xa4#,##0.00",
    "es-PH": "#,##0.00\xa0\xa4",
    "es-PR": "\xa4#,##0.00",
    "es-PY": "\xa4#,##0.00",
    "es-SV": "\xa4#,##0.00",
    "es-US": "\xa4#,##0.00",
    "es-UY": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "es-VE": "\xa4#,##0.00",
    et: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    eu: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    ewo: "#,##0.00\xa0\xa4",
    fa: "\u200E\xa4\xa0#,##0.00;\u200E(\xa4\xa0#,##0.00)",
    "fa-AF": "\xa4\xa0#,##0.00;\u200E(\xa4\xa0#,##0.00)",
    ff: "#,##0.00\xa0\xa4",
    "ff-Adlm": "\xa4\xa0#,##0.00",
    "ff-Adlm-BF": "\xa4\xa0#,##0.00",
    "ff-Adlm-CM": "\xa4\xa0#,##0.00",
    "ff-Adlm-GH": "\xa4\xa0#,##0.00",
    "ff-Adlm-GM": "\xa4\xa0#,##0.00",
    "ff-Adlm-GW": "\xa4\xa0#,##0.00",
    "ff-Adlm-LR": "\xa4\xa0#,##0.00",
    "ff-Adlm-MR": "\xa4\xa0#,##0.00",
    "ff-Adlm-NE": "\xa4\xa0#,##0.00",
    "ff-Adlm-NG": "\xa4\xa0#,##0.00",
    "ff-Adlm-SL": "\xa4\xa0#,##0.00",
    "ff-Adlm-SN": "\xa4\xa0#,##0.00",
    "ff-Latn": "#,##0.00\xa0\xa4",
    "ff-Latn-BF": "#,##0.00\xa0\xa4",
    "ff-Latn-CM": "#,##0.00\xa0\xa4",
    "ff-Latn-GH": "#,##0.00\xa0\xa4",
    "ff-Latn-GM": "#,##0.00\xa0\xa4",
    "ff-Latn-GN": "#,##0.00\xa0\xa4",
    "ff-Latn-GW": "#,##0.00\xa0\xa4",
    "ff-Latn-LR": "#,##0.00\xa0\xa4",
    "ff-Latn-MR": "#,##0.00\xa0\xa4",
    "ff-Latn-NE": "#,##0.00\xa0\xa4",
    "ff-Latn-NG": "#,##0.00\xa0\xa4",
    "ff-Latn-SL": "#,##0.00\xa0\xa4",
    fi: "#,##0.00\xa0\xa4",
    fil: "\xa4#,##0.00;(\xa4#,##0.00)",
    fo: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fo-DK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    fr: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-BE": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-BF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-BI": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-BJ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-BL": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CD": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CG": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CH": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CI": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CM": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-DJ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-DZ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-GA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-GF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-GN": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-GP": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-GQ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-HT": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-KM": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-LU": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MC": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MG": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-ML": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MQ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MR": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MU": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-NC": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-NE": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-PF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-PM": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-RE": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-RW": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-SC": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-SN": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-SY": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-TD": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-TG": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-TN": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-VU": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-WF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-YT": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    fur: "\xa4\xa0#,##0.00",
    fy: "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    ga: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ga-GB": "\xa4#,##0.00;(\xa4#,##0.00)",
    gd: "\xa4#,##0.00;(\xa4#,##0.00)",
    gl: "#,##0.00\xa0\xa4",
    gsw: "#,##0.00\xa0\xa4",
    "gsw-FR": "#,##0.00\xa0\xa4",
    "gsw-LI": "#,##0.00\xa0\xa4",
    gu: "\xa4#,##,##0.00;(\xa4#,##,##0.00)",
    guz: "\xa4#,##0.00;(\xa4#,##0.00)",
    gv: "\xa4#,##0.00",
    ha: "\xa4\xa0#,##0.00",
    "ha-GH": "\xa4\xa0#,##0.00",
    "ha-NE": "\xa4\xa0#,##0.00",
    haw: "\xa4#,##0.00;(\xa4#,##0.00)",
    he: "#,##0.00\xa0\xa4",
    hi: "\xa4#,##,##0.00",
    "hi-Latn": "\xa4#,##,##0.00",
    hr: "#,##0.00\xa0\xa4",
    "hr-BA": "#,##0.00\xa0\xa4",
    hsb: "#,##0.00\xa0\xa4",
    hu: "#,##0.00\xa0\xa4",
    hy: "#,##0.00\xa0\xa4",
    ia: "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    id: "\xa4#,##0.00",
    ig: "\xa4#,##0.00;(\xa4#,##0.00)",
    ii: "\xa4\xa0#,##0.00",
    is: "#,##0.00\xa0\xa4",
    it: "#,##0.00\xa0\xa4",
    "it-CH": "#,##0.00\xa0\xa4",
    "it-SM": "#,##0.00\xa0\xa4",
    "it-VA": "#,##0.00\xa0\xa4",
    ja: "\xa4#,##0.00;(\xa4#,##0.00)",
    jgo: "\xa4\xa0#,##0.00",
    jmc: "\xa4#,##0.00",
    jv: "\xa4\xa0#,##0.00",
    ka: "#,##0.00\xa0\xa4",
    kab: "#,##0.00\xa4",
    kam: "\xa4#,##0.00;(\xa4#,##0.00)",
    kde: "\xa4#,##0.00;(\xa4#,##0.00)",
    kea: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    kgp: "\xa4\xa0#,##0.00",
    khq: "#,##0.00\xa4",
    ki: "\xa4#,##0.00;(\xa4#,##0.00)",
    kk: "#,##0.00\xa0\xa4",
    kkj: "\xa4\xa0#,##0.00",
    kl: "\xa4#,##0.00;\xa4-#,##0.00",
    kln: "\xa4#,##0.00;(\xa4#,##0.00)",
    km: "#,##0.00\xa4;(#,##0.00\xa4)",
    kn: "\xa4#,##0.00;(\xa4#,##0.00)",
    ko: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ko-KP": "\xa4#,##0.00;(\xa4#,##0.00)",
    kok: "\xa4#,##0.00;(\xa4#,##0.00)",
    ks: "\xa4#,##0.00",
    "ks-Arab": "\xa4#,##0.00",
    "ks-Deva": "\xa4\xa0#,##0.00",
    ksb: "#,##0.00\xa4",
    ksf: "#,##0.00\xa0\xa4",
    ksh: "#,##0.00\xa0\xa4",
    ku: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    kw: "\xa4#,##0.00",
    ky: "#,##0.00\xa0\xa4",
    lag: "\xa4\xa0#,##0.00",
    lb: "#,##0.00\xa0\xa4",
    lg: "#,##0.00\xa4",
    lkt: "\xa4\xa0#,##0.00",
    ln: "#,##0.00\xa0\xa4",
    "ln-AO": "#,##0.00\xa0\xa4",
    "ln-CF": "#,##0.00\xa0\xa4",
    "ln-CG": "#,##0.00\xa0\xa4",
    lo: "\xa4#,##0.00;\xa4-#,##0.00",
    lrc: "\xa4\xa0#,##0.00",
    "lrc-IQ": "\xa4\xa0#,##0.00",
    lt: "#,##0.00\xa0\xa4",
    lu: "#,##0.00\xa4",
    luo: "#,##0.00\xa4",
    luy: "\xa4#,##0.00;\xa4-\xa0#,##0.00",
    lv: "#,##0.00\xa0\xa4",
    mai: "\xa4\xa0#,##0.00",
    mas: "\xa4#,##0.00;(\xa4#,##0.00)",
    "mas-TZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    mer: "\xa4#,##0.00;(\xa4#,##0.00)",
    mfe: "\xa4\xa0#,##0.00",
    mg: "\xa4#,##0.00",
    mgh: "\xa4\xa0#,##0.00",
    mgo: "\xa4\xa0#,##0.00",
    mi: "\xa4\xa0#,##0.00",
    mk: "#,##0.00\xa0\xa4",
    ml: "\xa4#,##0.00;(\xa4#,##0.00)",
    mn: "\xa4\xa0#,##0.00",
    mni: "\xa4\xa0#,##0.00",
    "mni-Beng": "\xa4\xa0#,##0.00",
    mr: "\xa4#,##0.00;(\xa4#,##0.00)",
    ms: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ms-BN": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ms-ID": "\xa4#,##0.00",
    "ms-SG": "\xa4#,##0.00;(\xa4#,##0.00)",
    mt: "\xa4#,##0.00",
    mua: "\xa4#,##0.00;(\xa4#,##0.00)",
    my: "\xa4\xa0#,##0.00",
    mzn: "\xa4\xa0#,##0.00",
    naq: "\xa4#,##0.00",
    nb: "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nb-SJ": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    nd: "\xa4#,##0.00;(\xa4#,##0.00)",
    nds: "\xa4\xa0#,##0.00",
    "nds-NL": "\xa4\xa0#,##0.00",
    ne: "\xa4\xa0#,##,##0.00",
    "ne-IN": "\xa4\xa0#,##,##0.00",
    nl: "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-AW": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-BE": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-BQ": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-CW": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-SR": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-SX": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    nmg: "#,##0.00\xa0\xa4",
    nn: "#,##0.00\xa0\xa4",
    nnh: "\xa4\xa0#,##0.00",
    no: "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    nus: "\xa4#,##0.00;(\xa4#,##0.00)",
    nyn: "\xa4#,##0.00",
    om: "\xa4#,##0.00",
    "om-KE": "\xa4#,##0.00",
    or: "\xa4#,##0.00;(\xa4#,##0.00)",
    os: "\xa4\xa0#,##0.00",
    "os-RU": "\xa4\xa0#,##0.00",
    pa: "\xa4\xa0#,##0.00",
    "pa-Arab": "\xa4\xa0#,##0.00",
    "pa-Guru": "\xa4\xa0#,##0.00",
    pcm: "\xa4#,##0.00",
    pl: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    ps: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ps-PK": "\xa4#,##0.00;(\xa4#,##0.00)",
    pt: "\xa4\xa0#,##0.00",
    "pt-AO": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-CH": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-CV": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-GQ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-GW": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-LU": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-MO": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-MZ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-PT": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-ST": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-TL": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    qu: "\xa4\xa0#,##0.00",
    "qu-BO": "\xa4\xa0#,##0.00",
    "qu-EC": "\xa4\xa0#,##0.00",
    rm: "#,##0.00\xa0\xa4",
    rn: "#,##0.00\xa4",
    ro: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "ro-MD": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    rof: "\xa4#,##0.00",
    ru: "#,##0.00\xa0\xa4",
    "ru-BY": "#,##0.00\xa0\xa4",
    "ru-KG": "#,##0.00\xa0\xa4",
    "ru-KZ": "#,##0.00\xa0\xa4",
    "ru-MD": "#,##0.00\xa0\xa4",
    "ru-UA": "#,##0.00\xa0\xa4",
    rw: "\xa4\xa0#,##0.00",
    rwk: "#,##0.00\xa4",
    sa: "\xa4\xa0#,##0.00",
    sah: "#,##0.00\xa0\xa4",
    saq: "\xa4#,##0.00;(\xa4#,##0.00)",
    sat: "\xa4\xa0#,##0.00",
    "sat-Olck": "\xa4\xa0#,##0.00",
    sbp: "#,##0.00\xa4",
    sc: "#,##0.00\xa0\xa4",
    sd: "\xa4\xa0#,##0.00",
    "sd-Arab": "\xa4\xa0#,##0.00",
    "sd-Deva": "\xa4\xa0#,##0.00",
    se: "#,##0.00\xa0\xa4",
    "se-FI": "#,##0.00\xa0\xa4",
    "se-SE": "#,##0.00\xa0\xa4",
    seh: "#,##0.00\xa4",
    ses: "#,##0.00\xa4",
    sg: "\xa4#,##0.00;\xa4-#,##0.00",
    shi: "#,##0.00\xa4",
    "shi-Latn": "#,##0.00\xa4",
    "shi-Tfng": "#,##0.00\xa4",
    si: "\xa4#,##0.00;(\xa4#,##0.00)",
    sk: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    sl: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    smn: "#,##0.00\xa0\xa4",
    sn: "\xa4#,##0.00;(\xa4#,##0.00)",
    so: "\xa4#,##0.00;(\xa4#,##0.00)",
    "so-DJ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "so-ET": "\xa4#,##0.00;(\xa4#,##0.00)",
    "so-KE": "\xa4#,##0.00;(\xa4#,##0.00)",
    sq: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sq-MK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sq-XK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    sr: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Cyrl": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Cyrl-BA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Cyrl-ME": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Cyrl-XK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Latn": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Latn-BA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Latn-ME": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Latn-XK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    su: "\xa4#,##0.00",
    "su-Latn": "\xa4#,##0.00",
    sv: "#,##0.00\xa0\xa4",
    "sv-AX": "#,##0.00\xa0\xa4",
    "sv-FI": "#,##0.00\xa0\xa4",
    sw: "\xa4\xa0#,##0.00",
    "sw-CD": "\xa4\xa0#,##0.00",
    "sw-KE": "\xa4\xa0#,##0.00",
    "sw-UG": "\xa4\xa0#,##0.00",
    ta: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ta-LK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ta-MY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ta-SG": "\xa4#,##0.00;(\xa4#,##0.00)",
    te: "\xa4#,##0.00;(\xa4#,##0.00)",
    teo: "\xa4#,##0.00;(\xa4#,##0.00)",
    "teo-KE": "\xa4#,##0.00;(\xa4#,##0.00)",
    tg: "#,##0.00\xa0\xa4",
    th: "\xa4#,##0.00;(\xa4#,##0.00)",
    ti: "\xa4#,##0.00",
    "ti-ER": "\xa4#,##0.00",
    tk: "#,##0.00\xa0\xa4",
    to: "\xa4\xa0#,##0.00",
    tr: "\xa4#,##0.00;(\xa4#,##0.00)",
    "tr-CY": "\xa4#,##0.00;(\xa4#,##0.00)",
    tt: "#,##0.00\xa0\xa4",
    twq: "#,##0.00\xa4",
    tzm: "#,##0.00\xa0\xa4",
    ug: "\xa4#,##0.00;(\xa4#,##0.00)",
    uk: "#,##0.00\xa0\xa4",
    und: "\xa4\xa0#,##0.00",
    ur: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ur-IN": "\xa4#,##0.00;(\xa4#,##0.00)",
    uz: "#,##0.00\xa0\xa4",
    "uz-Arab": "\xa4\xa0#,##0.00",
    "uz-Cyrl": "#,##0.00\xa0\xa4",
    "uz-Latn": "#,##0.00\xa0\xa4",
    vai: "\xa4#,##0.00;(\xa4#,##0.00)",
    "vai-Latn": "\xa4#,##0.00;(\xa4#,##0.00)",
    "vai-Vaii": "\xa4#,##0.00;(\xa4#,##0.00)",
    vi: "#,##0.00\xa0\xa4",
    vun: "\xa4#,##0.00",
    wae: "\xa4\xa0#,##0.00",
    wo: "\xa4\xa0#,##0.00",
    xh: "\xa4#,##0.00",
    xog: "#,##0.00\xa0\xa4",
    yav: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    yi: "\xa4\xa0#,##0.00",
    yo: "\xa4#,##0.00;(\xa4#,##0.00)",
    "yo-BJ": "\xa4#,##0.00;(\xa4#,##0.00)",
    yrl: "\xa4\xa0#,##0.00",
    "yrl-CO": "\xa4\xa0#,##0.00",
    "yrl-VE": "\xa4\xa0#,##0.00",
    yue: "\xa4#,##0.00;(\xa4#,##0.00)",
    "yue-Hans": "\xa4#,##0.00;(\xa4#,##0.00)",
    "yue-Hant": "\xa4#,##0.00;(\xa4#,##0.00)",
    zgh: "#,##0.00\xa4",
    zh: "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hans": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hans-HK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hans-MO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hans-SG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hant": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hant-HK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hant-MO": "\xa4#,##0.00;(\xa4#,##0.00)",
    zu: "\xa4#,##0.00;(\xa4#,##0.00)"
};

});



parcelRegister("8gWak", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $605cefd85b19c95f$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/localization/date.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $5Nras = parcelRequire("5Nras");

var $6ntMu = parcelRequire("6ntMu");

var $8OLOW = parcelRequire("8OLOW");

var $cvYFL = parcelRequire("cvYFL");

var $3A7XW = parcelRequire("3A7XW");

var $9oJex = parcelRequire("9oJex");

var $1auIP = parcelRequire("1auIP");

var $kUXlT = parcelRequire("kUXlT");

var $8j1Hc = parcelRequire("8j1Hc");

var $iTFn1 = parcelRequire("iTFn1");

var $8qyBL = parcelRequire("8qyBL");

var $9LjxF = parcelRequire("9LjxF");
var $605cefd85b19c95f$var$DEFAULT_DAY_OF_WEEK_INDEX = 0;
var $605cefd85b19c95f$var$hasIntl = "undefined" !== typeof Intl;
var $605cefd85b19c95f$var$FORMATS_TO_PATTERN_MAP = {
    shortdate: "M/d/y",
    shorttime: "h:mm a",
    longdate: "EEEE, MMMM d, y",
    longtime: "h:mm:ss a",
    monthandday: "MMMM d",
    monthandyear: "MMMM y",
    quarterandyear: "QQQ y",
    day: "d",
    year: "y",
    shortdateshorttime: "M/d/y, h:mm a",
    longdatelongtime: "EEEE, MMMM d, y, h:mm:ss a",
    month: "LLLL",
    shortyear: "yy",
    dayofweek: "EEEE",
    quarter: "QQQ",
    hour: "HH",
    minute: "mm",
    second: "ss",
    millisecond: "SSS",
    "datetime-local": "yyyy-MM-ddTHH':'mm':'ss"
};
var $605cefd85b19c95f$var$possiblePartPatterns = {
    year: [
        "y",
        "yy",
        "yyyy"
    ],
    day: [
        "d",
        "dd"
    ],
    month: [
        "M",
        "MM",
        "MMM",
        "MMMM"
    ],
    hours: [
        "H",
        "HH",
        "h",
        "hh",
        "ah"
    ],
    minutes: [
        "m",
        "mm"
    ],
    seconds: [
        "s",
        "ss"
    ],
    milliseconds: [
        "S",
        "SS",
        "SSS"
    ]
};
var $605cefd85b19c95f$var$dateLocalization = (0, $5Nras.default)({
    engine: function() {
        return "base";
    },
    _getPatternByFormat: function(format) {
        return $605cefd85b19c95f$var$FORMATS_TO_PATTERN_MAP[format.toLowerCase()];
    },
    _expandPattern: function(pattern) {
        return this._getPatternByFormat(pattern) || pattern;
    },
    formatUsesMonthName: function(format) {
        return -1 !== this._expandPattern(format).indexOf("MMMM");
    },
    formatUsesDayName: function(format) {
        return -1 !== this._expandPattern(format).indexOf("EEEE");
    },
    getFormatParts: function(format) {
        var pattern = this._getPatternByFormat(format) || format;
        var result = [];
        (0, $8OLOW.each)(pattern.split(/\W+/), (_, formatPart)=>{
            (0, $8OLOW.each)($605cefd85b19c95f$var$possiblePartPatterns, (partName, possiblePatterns)=>{
                if (possiblePatterns.includes(formatPart)) result.push(partName);
            });
        });
        return result;
    },
    getMonthNames: function(format) {
        return (0, $kUXlT.default).getMonthNames(format);
    },
    getDayNames: function(format) {
        return (0, $kUXlT.default).getDayNames(format);
    },
    getQuarterNames: function(format) {
        return (0, $kUXlT.default).getQuarterNames(format);
    },
    getPeriodNames: function(format) {
        return (0, $kUXlT.default).getPeriodNames(format);
    },
    getTimeSeparator: function() {
        return ":";
    },
    is24HourFormat: function(format) {
        var amTime = new Date(2017, 0, 20, 11, 0, 0, 0);
        var pmTime = new Date(2017, 0, 20, 23, 0, 0, 0);
        var amTimeFormatted = this.format(amTime, format);
        var pmTimeFormatted = this.format(pmTime, format);
        for(var i = 0; i < amTimeFormatted.length; i++){
            if (amTimeFormatted[i] !== pmTimeFormatted[i]) return !isNaN(parseInt(amTimeFormatted[i]));
        }
    },
    format: function(date, _format) {
        if (!date) return;
        if (!_format) return date;
        var formatter;
        if ("function" === typeof _format) formatter = _format;
        else if (_format.formatter) formatter = _format.formatter;
        else {
            _format = _format.type || _format;
            if ((0, $6ntMu.isString)(_format)) {
                _format = $605cefd85b19c95f$var$FORMATS_TO_PATTERN_MAP[_format.toLowerCase()] || _format;
                return (0, $8qyBL.default).convertDigits((0, $3A7XW.getFormatter)(_format, this)(date));
            }
        }
        if (!formatter) return;
        return formatter(date);
    },
    parse: function(text, format) {
        var that = this;
        var ldmlFormat;
        var formatter;
        if (!text) return;
        if (!format) return this.parse(text, "shortdate");
        if (format.parser) return format.parser(text);
        if ("string" === typeof format && !$605cefd85b19c95f$var$FORMATS_TO_PATTERN_MAP[format.toLowerCase()]) ldmlFormat = format;
        else {
            formatter = (value)=>{
                var text = that.format(value, format);
                return (0, $8qyBL.default).convertDigits(text, true);
            };
            try {
                ldmlFormat = (0, $9oJex.getFormat)(formatter);
            } catch (e) {}
        }
        if (ldmlFormat) {
            text = (0, $8qyBL.default).convertDigits(text, true);
            return (0, $1auIP.getParser)(ldmlFormat, this)(text);
        }
        (0, $cvYFL.default).log("W0012");
        var result = new Date(text);
        if (!result || isNaN(result.getTime())) return;
        return result;
    },
    firstDayOfWeekIndex: function() {
        var index = (0, $iTFn1.default).getValueByClosestLocale((locale)=>(0, $8j1Hc.default)[locale]);
        return void 0 === index ? $605cefd85b19c95f$var$DEFAULT_DAY_OF_WEEK_INDEX : index;
    }
});
if ($605cefd85b19c95f$var$hasIntl) $605cefd85b19c95f$var$dateLocalization.inject((0, $9LjxF.default));
var $605cefd85b19c95f$export$2e2bcd8739ae039 = $605cefd85b19c95f$var$dateLocalization;

});
parcelRegister("3A7XW", function(module, exports) {

$parcel$export(module.exports, "getFormatter", function () { return $29bae9b86a358200$export$a7f9565e3c81cd54; });
/**
 * DevExtreme (esm/localization/ldml/date.formatter.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ function $29bae9b86a358200$var$leftPad(text, length) {
    while(text.length < length)text = "0" + text;
    return text;
}
var $29bae9b86a358200$var$FORMAT_TYPES = {
    3: "abbreviated",
    4: "wide",
    5: "narrow"
};
var $29bae9b86a358200$var$LDML_FORMATTERS = {
    y: function(date, count, useUtc) {
        var year = date[useUtc ? "getUTCFullYear" : "getFullYear"]();
        if (2 === count) year %= 100;
        return $29bae9b86a358200$var$leftPad(year.toString(), count);
    },
    M: function(date, count, useUtc, dateParts) {
        var month = date[useUtc ? "getUTCMonth" : "getMonth"]();
        var formatType = $29bae9b86a358200$var$FORMAT_TYPES[count];
        if (formatType) return dateParts.getMonthNames(formatType, "format")[month];
        return $29bae9b86a358200$var$leftPad((month + 1).toString(), Math.min(count, 2));
    },
    L: function(date, count, useUtc, dateParts) {
        var month = date[useUtc ? "getUTCMonth" : "getMonth"]();
        var formatType = $29bae9b86a358200$var$FORMAT_TYPES[count];
        if (formatType) return dateParts.getMonthNames(formatType, "standalone")[month];
        return $29bae9b86a358200$var$leftPad((month + 1).toString(), Math.min(count, 2));
    },
    Q: function(date, count, useUtc, dateParts) {
        var month = date[useUtc ? "getUTCMonth" : "getMonth"]();
        var quarter = Math.floor(month / 3);
        var formatType = $29bae9b86a358200$var$FORMAT_TYPES[count];
        if (formatType) return dateParts.getQuarterNames(formatType)[quarter];
        return $29bae9b86a358200$var$leftPad((quarter + 1).toString(), Math.min(count, 2));
    },
    E: function(date, count, useUtc, dateParts) {
        var day = date[useUtc ? "getUTCDay" : "getDay"]();
        var formatType = $29bae9b86a358200$var$FORMAT_TYPES[count < 3 ? 3 : count];
        return dateParts.getDayNames(formatType)[day];
    },
    a: function(date, count, useUtc, dateParts) {
        var hours = date[useUtc ? "getUTCHours" : "getHours"]();
        var period = hours < 12 ? 0 : 1;
        var formatType = $29bae9b86a358200$var$FORMAT_TYPES[count];
        return dateParts.getPeriodNames(formatType)[period];
    },
    d: function(date, count, useUtc) {
        return $29bae9b86a358200$var$leftPad(date[useUtc ? "getUTCDate" : "getDate"]().toString(), Math.min(count, 2));
    },
    H: function(date, count, useUtc) {
        return $29bae9b86a358200$var$leftPad(date[useUtc ? "getUTCHours" : "getHours"]().toString(), Math.min(count, 2));
    },
    h: function(date, count, useUtc) {
        var hours = date[useUtc ? "getUTCHours" : "getHours"]();
        return $29bae9b86a358200$var$leftPad((hours % 12 || 12).toString(), Math.min(count, 2));
    },
    m: function(date, count, useUtc) {
        return $29bae9b86a358200$var$leftPad(date[useUtc ? "getUTCMinutes" : "getMinutes"]().toString(), Math.min(count, 2));
    },
    s: function(date, count, useUtc) {
        return $29bae9b86a358200$var$leftPad(date[useUtc ? "getUTCSeconds" : "getSeconds"]().toString(), Math.min(count, 2));
    },
    S: function(date, count, useUtc) {
        return $29bae9b86a358200$var$leftPad(date[useUtc ? "getUTCMilliseconds" : "getMilliseconds"]().toString(), 3).substr(0, count);
    },
    x: function(date, count, useUtc) {
        var timezoneOffset = useUtc ? 0 : date.getTimezoneOffset();
        var signPart = timezoneOffset > 0 ? "-" : "+";
        var timezoneOffsetAbs = Math.abs(timezoneOffset);
        var hours = Math.floor(timezoneOffsetAbs / 60);
        var minutes = timezoneOffsetAbs % 60;
        var hoursPart = $29bae9b86a358200$var$leftPad(hours.toString(), 2);
        var minutesPart = $29bae9b86a358200$var$leftPad(minutes.toString(), 2);
        return signPart + hoursPart + (count >= 3 ? ":" : "") + (count > 1 || minutes ? minutesPart : "");
    },
    X: function(date, count, useUtc) {
        if (useUtc || !date.getTimezoneOffset()) return "Z";
        return $29bae9b86a358200$var$LDML_FORMATTERS.x(date, count, useUtc);
    },
    Z: function(date, count, useUtc) {
        return $29bae9b86a358200$var$LDML_FORMATTERS.X(date, count >= 5 ? 3 : 2, useUtc);
    }
};
var $29bae9b86a358200$export$a7f9565e3c81cd54 = function(format, dateParts) {
    return function(date) {
        var charIndex;
        var formatter;
        var char;
        var charCount = 0;
        var isEscaping = false;
        var isCurrentCharEqualsNext;
        var result = "";
        if (!date) return null;
        if (!format) return date;
        var useUtc = "Z" === format[format.length - 1] || "'Z'" === format.slice(-3);
        for(charIndex = 0; charIndex < format.length; charIndex++){
            char = format[charIndex];
            formatter = $29bae9b86a358200$var$LDML_FORMATTERS[char];
            isCurrentCharEqualsNext = char === format[charIndex + 1];
            charCount++;
            if (!isCurrentCharEqualsNext) {
                if (formatter && !isEscaping) result += formatter(date, charCount, useUtc, dateParts);
                charCount = 0;
            }
            if ("'" === char && !isCurrentCharEqualsNext) isEscaping = !isEscaping;
            else if (isEscaping || !formatter) result += char;
            if ("'" === char && isCurrentCharEqualsNext) charIndex++;
        }
        return result;
    };
};

});

parcelRegister("9oJex", function(module, exports) {

$parcel$export(module.exports, "getFormat", function () { return $6d7971622e243d12$export$f61ac8b6f1f46202; });
/**
 * DevExtreme (esm/localization/ldml/date.format.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $8qyBL = parcelRequire("8qyBL");
var $6d7971622e243d12$var$ARABIC_COMMA = "\u060C";
var $6d7971622e243d12$var$FORMAT_SEPARATORS = " .,:;/\\<>()-[]" + $6d7971622e243d12$var$ARABIC_COMMA;
var $6d7971622e243d12$var$AM_PM_PATTERN = ". m.";
var $6d7971622e243d12$var$checkDigit = function(char) {
    var code = char && (0, $8qyBL.default).convertDigits(char, false).charCodeAt(0);
    var zeroCode = (0, $8qyBL.default).convertDigits("0", false).charCodeAt(0);
    return zeroCode <= code && code < zeroCode + 10;
};
var $6d7971622e243d12$var$checkPatternContinue = function(text, patterns, index, isDigit) {
    var char = text[index];
    var nextChar = text[index + 1];
    if (!isDigit) {
        if ("." === char || " " === char && text.slice(index - 1, index + 3) === $6d7971622e243d12$var$AM_PM_PATTERN) return true;
        if ("-" === char && !$6d7971622e243d12$var$checkDigit(nextChar)) return true;
    }
    var isDigitChanged = isDigit && patterns.some((pattern)=>text[index] !== pattern[index]);
    return $6d7971622e243d12$var$FORMAT_SEPARATORS.indexOf(char) < 0 && isDigit === $6d7971622e243d12$var$checkDigit(char) && (!isDigit || isDigitChanged);
};
var $6d7971622e243d12$var$getPatternStartIndex = function(defaultPattern, index) {
    if (!$6d7971622e243d12$var$checkDigit(defaultPattern[index])) while(index > 0 && !$6d7971622e243d12$var$checkDigit(defaultPattern[index - 1]) && ("." === defaultPattern[index - 1] || $6d7971622e243d12$var$FORMAT_SEPARATORS.indexOf(defaultPattern[index - 1]) < 0))index--;
    return index;
};
var $6d7971622e243d12$var$getDifference = function(defaultPattern, patterns, processedIndexes, isDigit) {
    var i = 0;
    var result = [];
    var patternsFilter = function(pattern) {
        return defaultPattern[i] !== pattern[i] && (void 0 === isDigit || $6d7971622e243d12$var$checkDigit(defaultPattern[i]) === isDigit);
    };
    if (!Array.isArray(patterns)) patterns = [
        patterns
    ];
    for(i = 0; i < defaultPattern.length; i++)if (processedIndexes.indexOf(i) < 0 && patterns.filter(patternsFilter).length) {
        i = $6d7971622e243d12$var$getPatternStartIndex(defaultPattern, i);
        do {
            isDigit = $6d7971622e243d12$var$checkDigit(defaultPattern[i]);
            if (!result.length && !isDigit && $6d7971622e243d12$var$checkDigit(patterns[0][i])) break;
            result.push(i);
            processedIndexes.unshift(i);
            i++;
        }while (defaultPattern[i] && $6d7971622e243d12$var$checkPatternContinue(defaultPattern, patterns, i, isDigit));
        break;
    }
    if (1 === result.length && ("0" === defaultPattern[processedIndexes[0] - 1] || "\u0660" === defaultPattern[processedIndexes[0] - 1])) processedIndexes.unshift(processedIndexes[0] - 1);
    return result;
};
var $6d7971622e243d12$var$replaceCharsCore = function(pattern, indexes, char, patternPositions) {
    var baseCharIndex = indexes[0];
    var patternIndex = baseCharIndex < patternPositions.length ? patternPositions[baseCharIndex] : baseCharIndex;
    indexes.forEach(function(_, index) {
        pattern = pattern.substr(0, patternIndex + index) + (char.length > 1 ? char[index] : char) + pattern.substr(patternIndex + index + 1);
    });
    if (1 === indexes.length) {
        pattern = pattern.replace("0" + char, char + char);
        pattern = pattern.replace("\u0660" + char, char + char);
    }
    return pattern;
};
var $6d7971622e243d12$var$replaceChars = function(pattern, indexes, char, patternPositions) {
    var i;
    var index;
    var patternIndex;
    if (!$6d7971622e243d12$var$checkDigit(pattern[indexes[0]] || "0")) {
        var letterCount = Math.max(indexes.length <= 3 ? 3 : 4, char.length);
        while(indexes.length > letterCount){
            index = indexes.pop();
            patternIndex = patternPositions[index];
            patternPositions[index] = -1;
            for(i = index + 1; i < patternPositions.length; i++)patternPositions[i]--;
            pattern = pattern.substr(0, patternIndex) + pattern.substr(patternIndex + 1);
        }
        index = indexes[indexes.length - 1] + 1, patternIndex = index < patternPositions.length ? patternPositions[index] : index;
        while(indexes.length < letterCount){
            indexes.push(indexes[indexes.length - 1] + 1);
            for(i = index; i < patternPositions.length; i++)patternPositions[i]++;
            pattern = pattern.substr(0, patternIndex) + " " + pattern.substr(patternIndex);
        }
    }
    pattern = $6d7971622e243d12$var$replaceCharsCore(pattern, indexes, char, patternPositions);
    return pattern;
};
var $6d7971622e243d12$var$formatValue = function(value, formatter) {
    if (Array.isArray(value)) return value.map(function(value) {
        return (formatter(value) || "").toString();
    });
    return (formatter(value) || "").toString();
};
var $6d7971622e243d12$var$ESCAPE_CHARS_REGEXP = /[a-zA-Z]/g;
var $6d7971622e243d12$var$escapeChars = function(pattern, defaultPattern, processedIndexes, patternPositions) {
    var escapeIndexes = defaultPattern.split("").map(function(char, index) {
        if (processedIndexes.indexOf(index) < 0 && (char.match($6d7971622e243d12$var$ESCAPE_CHARS_REGEXP) || "'" === char)) return patternPositions[index];
        return -1;
    });
    pattern = pattern.split("").map(function(char, index) {
        var result = char;
        var isCurrentCharEscaped = escapeIndexes.indexOf(index) >= 0;
        var isPrevCharEscaped = index > 0 && escapeIndexes.indexOf(index - 1) >= 0;
        var isNextCharEscaped = escapeIndexes.indexOf(index + 1) >= 0;
        if (isCurrentCharEscaped) {
            if (!isPrevCharEscaped) result = "'" + result;
            if (!isNextCharEscaped) result += "'";
        }
        return result;
    }).join("");
    return pattern;
};
var $6d7971622e243d12$export$f61ac8b6f1f46202 = function(formatter) {
    var processedIndexes = [];
    var defaultPattern = $6d7971622e243d12$var$formatValue(new Date(2009, 8, 8, 6, 5, 4), formatter);
    var patternPositions = defaultPattern.split("").map(function(_, index) {
        return index;
    });
    var result = defaultPattern;
    var replacedPatterns = {};
    var datePatterns = [
        {
            date: new Date(2009, 8, 8, 6, 5, 4, 111),
            pattern: "S"
        },
        {
            date: new Date(2009, 8, 8, 6, 5, 2),
            pattern: "s"
        },
        {
            date: new Date(2009, 8, 8, 6, 2, 4),
            pattern: "m"
        },
        {
            date: new Date(2009, 8, 8, 18, 5, 4),
            pattern: "H",
            isDigit: true
        },
        {
            date: new Date(2009, 8, 8, 2, 5, 4),
            pattern: "h",
            isDigit: true
        },
        {
            date: new Date(2009, 8, 8, 18, 5, 4),
            pattern: "a",
            isDigit: false
        },
        {
            date: new Date(2009, 8, 1, 6, 5, 4),
            pattern: "d"
        },
        {
            date: [
                new Date(2009, 8, 2, 6, 5, 4),
                new Date(2009, 8, 3, 6, 5, 4),
                new Date(2009, 8, 4, 6, 5, 4)
            ],
            pattern: "E"
        },
        {
            date: new Date(2009, 9, 6, 6, 5, 4),
            pattern: "M"
        },
        {
            date: new Date(1998, 8, 8, 6, 5, 4),
            pattern: "y"
        }
    ];
    if (!result) return;
    datePatterns.forEach(function(test) {
        var diff = $6d7971622e243d12$var$getDifference(defaultPattern, $6d7971622e243d12$var$formatValue(test.date, formatter), processedIndexes, test.isDigit);
        var pattern = "M" === test.pattern && !replacedPatterns.d ? "L" : test.pattern;
        result = $6d7971622e243d12$var$replaceChars(result, diff, pattern, patternPositions);
        replacedPatterns[pattern] = diff.length;
    });
    result = $6d7971622e243d12$var$escapeChars(result, defaultPattern, processedIndexes, patternPositions);
    if (processedIndexes.length) return result;
};

});

parcelRegister("1auIP", function(module, exports) {

$parcel$export(module.exports, "getParser", function () { return $0d9e8e635975c5c3$export$d003a19ab753048; });
/**
 * DevExtreme (esm/localization/ldml/date.parser.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $gcp4g = parcelRequire("gcp4g");

var $9U2XG = parcelRequire("9U2XG");
var $0d9e8e635975c5c3$var$FORMAT_TYPES = {
    3: "abbreviated",
    4: "wide",
    5: "narrow"
};
var $0d9e8e635975c5c3$var$monthRegExpGenerator = function(count, dateParts) {
    if (count > 2) return Object.keys($0d9e8e635975c5c3$var$FORMAT_TYPES).map(function(count) {
        return [
            "format",
            "standalone"
        ].map(function(type) {
            return dateParts.getMonthNames($0d9e8e635975c5c3$var$FORMAT_TYPES[count], type).join("|");
        }).join("|");
    }).join("|");
    return 2 === count ? "1[012]|0?[1-9]" : "0??[1-9]|1[012]";
};
var $0d9e8e635975c5c3$var$PATTERN_REGEXPS = {
    ":": function(count, dateParts) {
        var countSuffix = count > 1 ? "{".concat(count, "}") : "";
        var timeSeparator = (0, $gcp4g.escapeRegExp)(dateParts.getTimeSeparator());
        ":" !== timeSeparator && (timeSeparator = "".concat(timeSeparator, "|:"));
        return "".concat(timeSeparator).concat(countSuffix);
    },
    y: function(count) {
        return 2 === count ? "[0-9]{".concat(count, "}") : "[0-9]+?";
    },
    M: $0d9e8e635975c5c3$var$monthRegExpGenerator,
    L: $0d9e8e635975c5c3$var$monthRegExpGenerator,
    Q: function(count, dateParts) {
        if (count > 2) return dateParts.getQuarterNames($0d9e8e635975c5c3$var$FORMAT_TYPES[count], "format").join("|");
        return "0?[1-4]";
    },
    E: function(count, dateParts) {
        return "\\D*";
    },
    a: function(count, dateParts) {
        return dateParts.getPeriodNames($0d9e8e635975c5c3$var$FORMAT_TYPES[count < 3 ? 3 : count], "format").join("|");
    },
    d: function(count) {
        return 2 === count ? "3[01]|[12][0-9]|0?[1-9]" : "0??[1-9]|[12][0-9]|3[01]";
    },
    H: function(count) {
        return 2 === count ? "2[0-3]|1[0-9]|0?[0-9]" : "0??[0-9]|1[0-9]|2[0-3]";
    },
    h: function(count) {
        return 2 === count ? "1[012]|0?[1-9]" : "0??[1-9]|1[012]";
    },
    m: function(count) {
        return 2 === count ? "[1-5][0-9]|0?[0-9]" : "0??[0-9]|[1-5][0-9]";
    },
    s: function(count) {
        return 2 === count ? "[1-5][0-9]|0?[0-9]" : "0??[0-9]|[1-5][0-9]";
    },
    S: function(count) {
        return "[0-9]{1,".concat(count, "}");
    },
    w: function(count) {
        return 2 === count ? "[1-5][0-9]|0?[0-9]" : "0??[0-9]|[1-5][0-9]";
    }
};
var $0d9e8e635975c5c3$var$parseNumber = Number;
var $0d9e8e635975c5c3$var$caseInsensitiveIndexOf = function(array, value) {
    return array.map((item)=>item.toLowerCase()).indexOf(value.toLowerCase());
};
var $0d9e8e635975c5c3$var$monthPatternParser = function(text, count, dateParts) {
    if (count > 2) return [
        "format",
        "standalone"
    ].map(function(type) {
        return Object.keys($0d9e8e635975c5c3$var$FORMAT_TYPES).map(function(count) {
            var monthNames = dateParts.getMonthNames($0d9e8e635975c5c3$var$FORMAT_TYPES[count], type);
            return $0d9e8e635975c5c3$var$caseInsensitiveIndexOf(monthNames, text);
        });
    }).reduce(function(a, b) {
        return a.concat(b);
    }).filter(function(index) {
        return index >= 0;
    })[0];
    return $0d9e8e635975c5c3$var$parseNumber(text) - 1;
};
var $0d9e8e635975c5c3$var$PATTERN_PARSERS = {
    y: function(text, count) {
        var year = $0d9e8e635975c5c3$var$parseNumber(text);
        if (2 === count) return year < 30 ? 2e3 + year : 1900 + year;
        return year;
    },
    M: $0d9e8e635975c5c3$var$monthPatternParser,
    L: $0d9e8e635975c5c3$var$monthPatternParser,
    Q: function(text, count, dateParts) {
        if (count > 2) return dateParts.getQuarterNames($0d9e8e635975c5c3$var$FORMAT_TYPES[count], "format").indexOf(text);
        return $0d9e8e635975c5c3$var$parseNumber(text) - 1;
    },
    E: function(text, count, dateParts) {
        var dayNames = dateParts.getDayNames($0d9e8e635975c5c3$var$FORMAT_TYPES[count < 3 ? 3 : count], "format");
        return $0d9e8e635975c5c3$var$caseInsensitiveIndexOf(dayNames, text);
    },
    a: function(text, count, dateParts) {
        var periodNames = dateParts.getPeriodNames($0d9e8e635975c5c3$var$FORMAT_TYPES[count < 3 ? 3 : count], "format");
        return $0d9e8e635975c5c3$var$caseInsensitiveIndexOf(periodNames, text);
    },
    d: $0d9e8e635975c5c3$var$parseNumber,
    H: $0d9e8e635975c5c3$var$parseNumber,
    h: $0d9e8e635975c5c3$var$parseNumber,
    m: $0d9e8e635975c5c3$var$parseNumber,
    s: $0d9e8e635975c5c3$var$parseNumber,
    S: function(text, count) {
        count = Math.max(count, 3);
        text = text.slice(0, 3);
        while(count < 3){
            text += "0";
            count++;
        }
        return $0d9e8e635975c5c3$var$parseNumber(text);
    }
};
var $0d9e8e635975c5c3$var$ORDERED_PATTERNS = [
    "y",
    "M",
    "d",
    "h",
    "m",
    "s",
    "S"
];
var $0d9e8e635975c5c3$var$PATTERN_SETTERS = {
    y: "setFullYear",
    M: "setMonth",
    L: "setMonth",
    a: function(date, value, datePartValues) {
        var hours = date.getHours();
        var hourPartValue = datePartValues.h;
        if (void 0 !== hourPartValue && hourPartValue !== hours) hours--;
        if (!value && 12 === hours) hours = 0;
        else if (value && 12 !== hours) hours += 12;
        date.setHours(hours);
    },
    d: "setDate",
    H: "setHours",
    h: "setHours",
    m: "setMinutes",
    s: "setSeconds",
    S: "setMilliseconds"
};
var $0d9e8e635975c5c3$var$getSameCharCount = function(text, index) {
    var char = text[index];
    if (!char) return 0;
    var count = 0;
    do {
        index++;
        count++;
    }while (text[index] === char);
    return count;
};
var $0d9e8e635975c5c3$var$createPattern = function(char, count) {
    var result = "";
    for(var i = 0; i < count; i++)result += char;
    return result;
};
var $0d9e8e635975c5c3$export$956ac88d5736f555 = function(format, dateParts) {
    var regexpText = "";
    var stubText = "";
    var isEscaping;
    var patterns = [];
    var addPreviousStub = function() {
        if (stubText) {
            patterns.push("'".concat(stubText, "'"));
            regexpText += "".concat((0, $gcp4g.escapeRegExp)(stubText), ")");
            stubText = "";
        }
    };
    for(var i = 0; i < format.length; i++){
        var char = format[i];
        var isEscapeChar = "'" === char;
        var regexpPart = $0d9e8e635975c5c3$var$PATTERN_REGEXPS[char];
        if (isEscapeChar) {
            isEscaping = !isEscaping;
            if ("'" !== format[i - 1]) continue;
        }
        if (regexpPart && !isEscaping) {
            var count = $0d9e8e635975c5c3$var$getSameCharCount(format, i);
            var pattern = $0d9e8e635975c5c3$var$createPattern(char, count);
            addPreviousStub();
            patterns.push(pattern);
            regexpText += "(".concat(regexpPart(count, dateParts), ")");
            i += count - 1;
        } else {
            if (!stubText) regexpText += "(";
            stubText += char;
        }
    }
    addPreviousStub();
    if (!$0d9e8e635975c5c3$export$386493b1161369a8(patterns)) (0, $9U2XG.logger).warn("The following format may be parsed incorrectly: ".concat(format, "."));
    return {
        patterns: patterns,
        regexp: new RegExp("^".concat(regexpText, "$"), "i")
    };
};
var $0d9e8e635975c5c3$var$digitFieldSymbols = [
    "d",
    "H",
    "h",
    "m",
    "s",
    "w",
    "M",
    "L",
    "Q"
];
var $0d9e8e635975c5c3$export$386493b1161369a8 = function(patterns) {
    var isDigitPattern = (pattern)=>{
        if (!pattern) return false;
        var char = pattern[0];
        return [
            "y",
            "S"
        ].includes(char) || $0d9e8e635975c5c3$var$digitFieldSymbols.includes(char) && pattern.length < 3;
    };
    var possibleForParsing = true;
    var ambiguousDigitPatternsCount = 0;
    return patterns.every((pattern, index, patterns)=>{
        if (isDigitPattern(pattern)) {
            if (((pattern)=>"S" !== pattern[0] && 2 !== pattern.length)(pattern)) possibleForParsing = ++ambiguousDigitPatternsCount < 2;
            if (!isDigitPattern(patterns[index + 1])) ambiguousDigitPatternsCount = 0;
        }
        return possibleForParsing;
    });
};
var $0d9e8e635975c5c3$export$7770e3ec51d24a30 = function() {
    return $0d9e8e635975c5c3$var$PATTERN_SETTERS;
};
var $0d9e8e635975c5c3$var$setPatternPart = function(date, pattern, text, dateParts, datePartValues) {
    var patternChar = pattern[0];
    var partSetter = $0d9e8e635975c5c3$var$PATTERN_SETTERS[patternChar];
    var partParser = $0d9e8e635975c5c3$var$PATTERN_PARSERS[patternChar];
    if (partSetter && partParser) {
        var value = partParser(text, pattern.length, dateParts);
        datePartValues[pattern] = value;
        if (date[partSetter]) date[partSetter](value);
        else partSetter(date, value, datePartValues);
    }
};
var $0d9e8e635975c5c3$var$setPatternPartFromNow = function(date, pattern, now) {
    var setterName = $0d9e8e635975c5c3$var$PATTERN_SETTERS[pattern];
    var getterName = "g" + setterName.substr(1);
    var value = now[getterName]();
    date[setterName](value);
};
var $0d9e8e635975c5c3$var$getShortPatterns = function(fullPatterns) {
    return fullPatterns.map(function(pattern) {
        if ("'" === pattern[0]) return "";
        else return "H" === pattern[0] ? "h" : pattern[0];
    });
};
var $0d9e8e635975c5c3$var$getMaxOrderedPatternIndex = function(patterns) {
    var indexes = patterns.map(function(pattern) {
        return $0d9e8e635975c5c3$var$ORDERED_PATTERNS.indexOf(pattern);
    });
    return Math.max.apply(Math, indexes);
};
var $0d9e8e635975c5c3$var$getOrderedFormatPatterns = function(formatPatterns) {
    var otherPatterns = formatPatterns.filter(function(pattern) {
        return $0d9e8e635975c5c3$var$ORDERED_PATTERNS.indexOf(pattern) < 0;
    });
    return $0d9e8e635975c5c3$var$ORDERED_PATTERNS.concat(otherPatterns);
};
var $0d9e8e635975c5c3$export$d003a19ab753048 = function(format, dateParts) {
    var regExpInfo = $0d9e8e635975c5c3$export$956ac88d5736f555(format, dateParts);
    return function(text) {
        var regExpResult = regExpInfo.regexp.exec(text);
        if (regExpResult) {
            var now = new Date;
            var date = new Date(now.getFullYear(), 0, 1);
            var formatPatterns = $0d9e8e635975c5c3$var$getShortPatterns(regExpInfo.patterns);
            var maxPatternIndex = $0d9e8e635975c5c3$var$getMaxOrderedPatternIndex(formatPatterns);
            var orderedFormatPatterns = $0d9e8e635975c5c3$var$getOrderedFormatPatterns(formatPatterns);
            var datePartValues = {};
            orderedFormatPatterns.forEach(function(pattern, index) {
                if (!pattern || index < $0d9e8e635975c5c3$var$ORDERED_PATTERNS.length && index > maxPatternIndex) return;
                var patternIndex = formatPatterns.indexOf(pattern);
                if (patternIndex >= 0) {
                    var regExpPattern = regExpInfo.patterns[patternIndex];
                    var regExpText = regExpResult[patternIndex + 1];
                    $0d9e8e635975c5c3$var$setPatternPart(date, regExpPattern, regExpText, dateParts, datePartValues);
                } else $0d9e8e635975c5c3$var$setPatternPartFromNow(date, pattern, now);
            });
            return date;
        }
        return null;
    };
};

});

parcelRegister("kUXlT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3a713b5210bd859$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/localization/default_date_names.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $8OLOW = parcelRequire("8OLOW");
var $f3a713b5210bd859$var$MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $f3a713b5210bd859$var$DAYS = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
var $f3a713b5210bd859$var$PERIODS = [
    "AM",
    "PM"
];
var $f3a713b5210bd859$var$QUARTERS = [
    "Q1",
    "Q2",
    "Q3",
    "Q4"
];
var $f3a713b5210bd859$var$cutCaptions = (captions, format)=>{
    var lengthByFormat = {
        abbreviated: 3,
        short: 2,
        narrow: 1
    };
    return (0, $8OLOW.map)(captions, (caption)=>caption.substr(0, lengthByFormat[format]));
};
var $f3a713b5210bd859$export$2e2bcd8739ae039 = {
    getMonthNames: function(format) {
        return $f3a713b5210bd859$var$cutCaptions($f3a713b5210bd859$var$MONTHS, format);
    },
    getDayNames: function(format) {
        return $f3a713b5210bd859$var$cutCaptions($f3a713b5210bd859$var$DAYS, format);
    },
    getQuarterNames: function(format) {
        return $f3a713b5210bd859$var$QUARTERS;
    },
    getPeriodNames: function(format) {
        return $f3a713b5210bd859$var$PERIODS;
    }
};

});

parcelRegister("8j1Hc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60c169ccb94b790e$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/localization/cldr-data/first_day_of_week_data.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ // !!! AUTO-GENERATED FILE, DO NOT EDIT
var $60c169ccb94b790e$export$2e2bcd8739ae039 = {
    "af-NA": 1,
    agq: 1,
    ak: 1,
    ar: 6,
    "ar-EH": 1,
    "ar-ER": 1,
    "ar-KM": 1,
    "ar-LB": 1,
    "ar-MA": 1,
    "ar-MR": 1,
    "ar-PS": 1,
    "ar-SO": 1,
    "ar-SS": 1,
    "ar-TD": 1,
    "ar-TN": 1,
    asa: 1,
    ast: 1,
    az: 1,
    "az-Cyrl": 1,
    bas: 1,
    be: 1,
    bem: 1,
    bez: 1,
    bg: 1,
    bm: 1,
    br: 1,
    bs: 1,
    "bs-Cyrl": 1,
    ca: 1,
    ce: 1,
    cgg: 1,
    ckb: 6,
    cs: 1,
    cy: 1,
    da: 1,
    de: 1,
    dje: 1,
    dsb: 1,
    dua: 1,
    dyo: 1,
    ee: 1,
    el: 1,
    "en-001": 1,
    "en-AE": 6,
    "en-BI": 1,
    "en-MP": 1,
    "en-MV": 5,
    "en-SD": 6,
    eo: 1,
    es: 1,
    et: 1,
    eu: 1,
    ewo: 1,
    fa: 6,
    ff: 1,
    "ff-Adlm": 1,
    fi: 1,
    fo: 1,
    fr: 1,
    "fr-DJ": 6,
    "fr-DZ": 6,
    "fr-SY": 6,
    fur: 1,
    fy: 1,
    ga: 1,
    gd: 1,
    gl: 1,
    gsw: 1,
    gv: 1,
    ha: 1,
    hr: 1,
    hsb: 1,
    hu: 1,
    hy: 1,
    ia: 1,
    ig: 1,
    is: 1,
    it: 1,
    jgo: 1,
    jmc: 1,
    ka: 1,
    kab: 6,
    kde: 1,
    kea: 1,
    khq: 1,
    kk: 1,
    kkj: 1,
    kl: 1,
    "ko-KP": 1,
    ksb: 1,
    ksf: 1,
    ksh: 1,
    ku: 1,
    kw: 1,
    ky: 1,
    lag: 1,
    lb: 1,
    lg: 1,
    ln: 1,
    lrc: 6,
    lt: 1,
    lu: 1,
    lv: 1,
    "mas-TZ": 1,
    mfe: 1,
    mg: 1,
    mgo: 1,
    mi: 1,
    mk: 1,
    mn: 1,
    ms: 1,
    mua: 1,
    mzn: 6,
    naq: 1,
    nds: 1,
    nl: 1,
    nmg: 1,
    nnh: 1,
    no: 1,
    nus: 1,
    nyn: 1,
    os: 1,
    pcm: 1,
    pl: 1,
    ps: 6,
    "pt-AO": 1,
    "pt-CH": 1,
    "pt-CV": 1,
    "pt-GQ": 1,
    "pt-GW": 1,
    "pt-LU": 1,
    "pt-ST": 1,
    "pt-TL": 1,
    "qu-BO": 1,
    "qu-EC": 1,
    rm: 1,
    rn: 1,
    ro: 1,
    rof: 1,
    ru: 1,
    rw: 1,
    rwk: 1,
    sah: 1,
    sbp: 1,
    sc: 1,
    se: 1,
    ses: 1,
    sg: 1,
    shi: 1,
    "shi-Latn": 1,
    si: 1,
    sk: 1,
    sl: 1,
    smn: 1,
    so: 1,
    "so-DJ": 6,
    sq: 1,
    sr: 1,
    "sr-Latn": 1,
    sv: 1,
    sw: 1,
    "ta-LK": 1,
    "ta-MY": 1,
    teo: 1,
    tg: 1,
    "ti-ER": 1,
    tk: 1,
    to: 1,
    tr: 1,
    tt: 1,
    twq: 1,
    tzm: 1,
    uk: 1,
    uz: 1,
    "uz-Arab": 6,
    "uz-Cyrl": 1,
    vai: 1,
    "vai-Latn": 1,
    vi: 1,
    vun: 1,
    wae: 1,
    wo: 1,
    xog: 1,
    yav: 1,
    yi: 1,
    yo: 1,
    zgh: 1
};

});

parcelRegister("9LjxF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71b7a97a77168e25$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/localization/intl/date.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $iTFn1 = parcelRequire("iTFn1");
var $71b7a97a77168e25$var$SYMBOLS_TO_REMOVE_REGEX = /[\u200E\u200F]/g;
var $71b7a97a77168e25$var$NARROW_NO_BREAK_SPACE_REGEX = /[\u202F]/g;
var $71b7a97a77168e25$var$getIntlFormatter = (format)=>(date)=>{
        if (!format.timeZoneName) {
            var year = date.getFullYear();
            var recognizableAsTwentyCentury = String(year).length < 3;
            var temporaryYearValue = recognizableAsTwentyCentury ? year + 400 : year;
            var utcDate = new Date(Date.UTC(temporaryYearValue, date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
            if (recognizableAsTwentyCentury) utcDate.setFullYear(year);
            var utcFormat = (0, $2oTOp.extend)({
                timeZone: "UTC"
            }, format);
            return $71b7a97a77168e25$var$formatDateTime(utcDate, utcFormat);
        }
        return $71b7a97a77168e25$var$formatDateTime(date, format);
    };
var $71b7a97a77168e25$var$formattersCache = {};
var $71b7a97a77168e25$var$getFormatter = (format)=>{
    var key = (0, $iTFn1.default).locale() + "/" + JSON.stringify(format);
    if (!$71b7a97a77168e25$var$formattersCache[key]) $71b7a97a77168e25$var$formattersCache[key] = new Intl.DateTimeFormat((0, $iTFn1.default).locale(), format).format;
    return $71b7a97a77168e25$var$formattersCache[key];
};
function $71b7a97a77168e25$var$formatDateTime(date, format) {
    return $71b7a97a77168e25$var$getFormatter(format)(date).replace($71b7a97a77168e25$var$SYMBOLS_TO_REMOVE_REGEX, "").replace($71b7a97a77168e25$var$NARROW_NO_BREAK_SPACE_REGEX, " ");
}
var $71b7a97a77168e25$var$formatNumber = (number)=>new Intl.NumberFormat((0, $iTFn1.default).locale()).format(number);
var $71b7a97a77168e25$var$getAlternativeNumeralsMap = (()=>{
    var numeralsMapCache = {};
    return (locale)=>{
        if (!(locale in numeralsMapCache)) {
            if ("0" === $71b7a97a77168e25$var$formatNumber(0)) {
                numeralsMapCache[locale] = false;
                return false;
            }
            numeralsMapCache[locale] = {};
            for(var i = 0; i < 10; ++i)numeralsMapCache[locale][$71b7a97a77168e25$var$formatNumber(i)] = i;
        }
        return numeralsMapCache[locale];
    };
})();
var $71b7a97a77168e25$var$normalizeNumerals = (dateString)=>{
    var alternativeNumeralsMap = $71b7a97a77168e25$var$getAlternativeNumeralsMap((0, $iTFn1.default).locale());
    if (!alternativeNumeralsMap) return dateString;
    return dateString.split("").map((sign)=>sign in alternativeNumeralsMap ? String(alternativeNumeralsMap[sign]) : sign).join("");
};
var $71b7a97a77168e25$var$removeLeadingZeroes = (str)=>str.replace(/(\D)0+(\d)/g, "$1$2");
var $71b7a97a77168e25$var$dateStringEquals = (actual, expected)=>$71b7a97a77168e25$var$removeLeadingZeroes(actual) === $71b7a97a77168e25$var$removeLeadingZeroes(expected);
var $71b7a97a77168e25$var$normalizeMonth = (text)=>text.replace("d\u2019", "de ");
var $71b7a97a77168e25$var$intlFormats = {
    day: {
        day: "numeric"
    },
    dayofweek: {
        weekday: "long"
    },
    longdate: {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
    },
    longdatelongtime: {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    },
    longtime: {
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    },
    month: {
        month: "long"
    },
    monthandday: {
        month: "long",
        day: "numeric"
    },
    monthandyear: {
        year: "numeric",
        month: "long"
    },
    shortdate: {},
    shorttime: {
        hour: "numeric",
        minute: "numeric"
    },
    shortyear: {
        year: "2-digit"
    },
    year: {
        year: "numeric"
    }
};
Object.defineProperty($71b7a97a77168e25$var$intlFormats, "shortdateshorttime", {
    get: function() {
        var defaultOptions = Intl.DateTimeFormat((0, $iTFn1.default).locale()).resolvedOptions();
        return {
            year: defaultOptions.year,
            month: defaultOptions.month,
            day: defaultOptions.day,
            hour: "numeric",
            minute: "numeric"
        };
    }
});
var $71b7a97a77168e25$var$getIntlFormat = (format)=>"string" === typeof format && $71b7a97a77168e25$var$intlFormats[format.toLowerCase()];
var $71b7a97a77168e25$var$monthNameStrategies = {
    standalone: function(monthIndex, monthFormat) {
        var date = new Date(1999, monthIndex, 13, 1);
        var dateString = $71b7a97a77168e25$var$getIntlFormatter({
            month: monthFormat
        })(date);
        return dateString;
    },
    format: function(monthIndex, monthFormat) {
        var date = new Date(0, monthIndex, 13, 1);
        var dateString = $71b7a97a77168e25$var$normalizeMonth($71b7a97a77168e25$var$getIntlFormatter({
            day: "numeric",
            month: monthFormat
        })(date));
        var parts = dateString.split(" ").filter((part)=>part.indexOf("13") < 0);
        if (1 === parts.length) return parts[0];
        else if (2 === parts.length) return parts[0].length > parts[1].length ? parts[0] : parts[1];
        return $71b7a97a77168e25$var$monthNameStrategies.standalone(monthIndex, monthFormat);
    }
};
var $71b7a97a77168e25$export$2e2bcd8739ae039 = {
    engine: function() {
        return "intl";
    },
    getMonthNames: function(format, type) {
        var monthFormat = {
            wide: "long",
            abbreviated: "short",
            narrow: "narrow"
        }[format || "wide"];
        type = "format" === type ? type : "standalone";
        return Array.apply(null, new Array(12)).map((_, monthIndex)=>$71b7a97a77168e25$var$monthNameStrategies[type](monthIndex, monthFormat));
    },
    getDayNames: function(format) {
        var result = ((format)=>Array.apply(null, new Array(7)).map((_, dayIndex)=>$71b7a97a77168e25$var$getIntlFormatter({
                    weekday: format
                })(new Date(0, 0, dayIndex))))({
            wide: "long",
            abbreviated: "short",
            short: "narrow",
            narrow: "narrow"
        }[format || "wide"]);
        return result;
    },
    getPeriodNames: function() {
        var hour12Formatter = $71b7a97a77168e25$var$getIntlFormatter({
            hour: "numeric",
            hour12: true
        });
        return [
            1,
            13
        ].map((hours)=>{
            var hourNumberText = $71b7a97a77168e25$var$formatNumber(1);
            var timeParts = hour12Formatter(new Date(0, 0, 1, hours)).split(hourNumberText);
            if (2 !== timeParts.length) return "";
            var biggerPart = timeParts[0].length > timeParts[1].length ? timeParts[0] : timeParts[1];
            return biggerPart.trim();
        });
    },
    format: function(date, _format) {
        if (!date) return;
        if (!_format) return date;
        if ("function" !== typeof _format && !_format.formatter) _format = _format.type || _format;
        var intlFormat = $71b7a97a77168e25$var$getIntlFormat(_format);
        if (intlFormat) return $71b7a97a77168e25$var$getIntlFormatter(intlFormat)(date);
        var formatType = typeof _format;
        if (_format.formatter || "function" === formatType || "string" === formatType) return this.callBase.apply(this, arguments);
        return $71b7a97a77168e25$var$getIntlFormatter(_format)(date);
    },
    parse: function(dateString, format) {
        var formatter;
        if (format && !format.parser && "string" === typeof dateString) {
            dateString = $71b7a97a77168e25$var$normalizeMonth(dateString);
            formatter = (date)=>$71b7a97a77168e25$var$normalizeMonth(this.format(date, format));
        }
        return this.callBase(dateString, formatter || format);
    },
    _parseDateBySimpleFormat: function(dateString, format) {
        dateString = $71b7a97a77168e25$var$normalizeNumerals(dateString);
        var formatParts = this.getFormatParts(format);
        var dateParts = dateString.split(/\D+/).filter((part)=>part.length > 0);
        if (formatParts.length !== dateParts.length) return;
        var dateArgs = this._generateDateArgs(formatParts, dateParts);
        var constructValidDate = (ampmShift)=>{
            var parsedDate = ((dateArgs, ampmShift)=>{
                var hoursShift = ampmShift ? 12 : 0;
                return new Date(dateArgs.year, dateArgs.month, dateArgs.day, (dateArgs.hours + hoursShift) % 24, dateArgs.minutes, dateArgs.seconds);
            })(dateArgs, ampmShift);
            if ($71b7a97a77168e25$var$dateStringEquals($71b7a97a77168e25$var$normalizeNumerals(this.format(parsedDate, format)), dateString)) return parsedDate;
        };
        return constructValidDate(false) || constructValidDate(true);
    },
    _generateDateArgs: function(formatParts, dateParts) {
        var currentDate = new Date;
        var dateArgs = {
            year: currentDate.getFullYear(),
            month: currentDate.getMonth(),
            day: currentDate.getDate(),
            hours: 0,
            minutes: 0,
            seconds: 0
        };
        formatParts.forEach((formatPart, index)=>{
            var datePart = dateParts[index];
            var parsed = parseInt(datePart, 10);
            if ("month" === formatPart) parsed -= 1;
            dateArgs[formatPart] = parsed;
        });
        return dateArgs;
    },
    formatUsesMonthName: function(format) {
        if ("object" === typeof format && !(format.type || format.format)) return "long" === format.month;
        return this.callBase.apply(this, arguments);
    },
    formatUsesDayName: function(format) {
        if ("object" === typeof format && !(format.type || format.format)) return "long" === format.weekday;
        return this.callBase.apply(this, arguments);
    },
    getTimeSeparator: function() {
        return $71b7a97a77168e25$var$normalizeNumerals($71b7a97a77168e25$var$formatDateTime(new Date(2001, 1, 1, 11, 11), {
            hour: "numeric",
            minute: "numeric",
            hour12: false
        })).replace(/\d/g, "");
    },
    getFormatParts: function(format) {
        if ("string" === typeof format) return this.callBase(format);
        var intlFormat = (0, $2oTOp.extend)({}, $71b7a97a77168e25$var$intlFormats[format.toLowerCase()]);
        var date = new Date(2001, 2, 4, 5, 6, 7);
        var formattedDate = $71b7a97a77168e25$var$getIntlFormatter(intlFormat)(date);
        formattedDate = $71b7a97a77168e25$var$normalizeNumerals(formattedDate);
        return [
            {
                name: "year",
                value: 1
            },
            {
                name: "month",
                value: 3
            },
            {
                name: "day",
                value: 4
            },
            {
                name: "hours",
                value: 5
            },
            {
                name: "minutes",
                value: 6
            },
            {
                name: "seconds",
                value: 7
            }
        ].map((part)=>({
                name: part.name,
                index: formattedDate.indexOf(part.value)
            })).filter((part)=>part.index > -1).sort((a, b)=>a.index - b.index).map((part)=>part.name);
    }
};

});



parcelRegister("k8jJ6", function(module, exports) {

$parcel$export(module.exports, "Plaque", function () { return $ea83db44c1b5114e$export$24784ef4e53a2bc4; });
/**
 * DevExtreme (esm/viz/core/plaque.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $2oTOp = parcelRequire("2oTOp");

var $6ntMu = parcelRequire("6ntMu");
var $ea83db44c1b5114e$var$_excluded = [
    "x",
    "y",
    "canvas",
    "offsetX",
    "offsetY",
    "offset"
];
var $ea83db44c1b5114e$var$math = Math;
var $ea83db44c1b5114e$var$round = $ea83db44c1b5114e$var$math.round;
var $ea83db44c1b5114e$var$max = $ea83db44c1b5114e$var$math.max;
var $ea83db44c1b5114e$var$min = $ea83db44c1b5114e$var$math.min;
var $ea83db44c1b5114e$var$sin = $ea83db44c1b5114e$var$math.sin;
var $ea83db44c1b5114e$var$cos = $ea83db44c1b5114e$var$math.cos;
var $ea83db44c1b5114e$var$asin = $ea83db44c1b5114e$var$math.asin;
var $ea83db44c1b5114e$var$PI = $ea83db44c1b5114e$var$math.PI;
var $ea83db44c1b5114e$var$buildPath = function() {
    for(var _len = arguments.length, points = new Array(_len), _key = 0; _key < _len; _key++)points[_key] = arguments[_key];
    return points.join("");
};
function $ea83db44c1b5114e$var$getArc(cornerRadius, xDirection, yDirection) {
    return "a ".concat(cornerRadius, " ").concat(cornerRadius, " 0 0 1 ").concat(xDirection * cornerRadius, " ").concat(yDirection * cornerRadius);
}
function $ea83db44c1b5114e$var$getAbsoluteArc(cornerRadius, x, y) {
    return "A ".concat(cornerRadius, " ").concat(cornerRadius, " 0 0 1 ").concat(x, " ").concat(y);
}
function $ea83db44c1b5114e$var$rotateX(x, y, angle, x0, y0) {
    return (x - x0) * $ea83db44c1b5114e$var$round($ea83db44c1b5114e$var$cos(angle)) + (y - y0) * $ea83db44c1b5114e$var$round($ea83db44c1b5114e$var$sin(angle)) + x0;
}
function $ea83db44c1b5114e$var$rotateY(x, y, angle, x0, y0) {
    return -(x - x0) * $ea83db44c1b5114e$var$round($ea83db44c1b5114e$var$sin(angle)) + (y - y0) * $ea83db44c1b5114e$var$round($ea83db44c1b5114e$var$cos(angle)) + y0;
}
function $ea83db44c1b5114e$var$rotateSize(options, angle) {
    if (angle % 90 === 0 && angle % 180 !== 0) return {
        width: options.height,
        height: options.width
    };
    return options;
}
function $ea83db44c1b5114e$var$getCloudAngle(_ref, x, y, anchorX, anchorY) {
    var { width: width, height: height } = _ref;
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var xr = Math.ceil(x + halfWidth);
    var xl = Math.floor(x - halfWidth);
    var yt = Math.floor(y - halfHeight);
    var yb = Math.ceil(y + halfHeight);
    if (anchorX < xl && anchorY < yt || anchorX >= xl && anchorX <= xr && anchorY < yt) return 270;
    if (anchorX > xr && anchorY > yb || anchorX >= xl && anchorX <= xr && anchorY > yb) return 90;
    else if (anchorX < xl && anchorY > yb || anchorX < xl && anchorY >= yt && anchorY <= yb) return 180;
    return 0;
}
function $ea83db44c1b5114e$var$getCloudPoints(_ref2, x, y, anchorX, anchorY, _ref3, bounded) {
    var { width: width, height: height } = _ref2;
    var { arrowWidth: arrowWidth, cornerRadius: cornerRadius = 0 } = _ref3;
    var halfArrowWidth = arrowWidth / 2;
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var xr = Math.ceil(x + halfWidth);
    var xl = Math.floor(x - halfWidth);
    var yt = Math.floor(y - halfHeight);
    var yb = Math.ceil(y + halfHeight);
    var leftTopCorner = [
        xl,
        yt
    ];
    var rightTopCorner = [
        xr,
        yt
    ];
    var rightBottomCorner = [
        xr,
        yb
    ];
    var leftBottomCorner = [
        xl,
        yb
    ];
    var arrowX = anchorX <= xl ? xl : xr <= anchorX ? xr : anchorX;
    var arrowY = anchorY <= yt ? yt : yb <= anchorY ? yb : anchorY;
    var arrowBaseBottom = $ea83db44c1b5114e$var$min(arrowY + halfArrowWidth, yb);
    var arrowBaseTop = $ea83db44c1b5114e$var$max(arrowY - halfArrowWidth, yt);
    var arrowBaseLeft = $ea83db44c1b5114e$var$max(arrowX - halfArrowWidth, xl);
    cornerRadius = Math.min(width / 2, height / 2, cornerRadius);
    var points;
    leftTopCorner[1] += cornerRadius;
    rightTopCorner[0] -= cornerRadius;
    rightBottomCorner[1] -= cornerRadius;
    leftBottomCorner[0] += cornerRadius;
    if (!bounded || xl <= anchorX && anchorX <= xr && yt <= anchorY && anchorY <= yb) points = $ea83db44c1b5114e$var$buildPath(leftTopCorner, $ea83db44c1b5114e$var$getArc(cornerRadius, 1, -1), "L", rightTopCorner, $ea83db44c1b5114e$var$getArc(cornerRadius, 1, 1), "L", rightBottomCorner, $ea83db44c1b5114e$var$getArc(cornerRadius, -1, 1), "L", leftBottomCorner, $ea83db44c1b5114e$var$getArc(cornerRadius, -1, -1));
    else if (anchorX > xr && anchorY < yt) {
        var arrowAngle = arrowWidth / cornerRadius || 0;
        var angle = $ea83db44c1b5114e$var$PI / 4 + arrowAngle / 2;
        var endAngle = $ea83db44c1b5114e$var$PI / 4 - arrowAngle / 2;
        var arrowEndPointX = rightTopCorner[0] + $ea83db44c1b5114e$var$cos(endAngle) * cornerRadius;
        var arrowEndPointY = rightTopCorner[1] + (1 - $ea83db44c1b5114e$var$sin(endAngle)) * cornerRadius;
        var arrowArc = $ea83db44c1b5114e$var$buildPath("L", rightTopCorner, $ea83db44c1b5114e$var$getArc(cornerRadius, $ea83db44c1b5114e$var$cos(angle), 1 - $ea83db44c1b5114e$var$sin(angle)), "L", [
            anchorX,
            anchorY,
            arrowEndPointX,
            arrowEndPointY
        ], $ea83db44c1b5114e$var$getAbsoluteArc(cornerRadius, rightTopCorner[0] + cornerRadius, rightTopCorner[1] + cornerRadius));
        if (Math.abs(angle) > $ea83db44c1b5114e$var$PI / 2) arrowArc = $ea83db44c1b5114e$var$buildPath("L", [
            arrowBaseLeft,
            yt,
            anchorX,
            anchorY,
            xr,
            arrowBaseBottom
        ]);
        points = $ea83db44c1b5114e$var$buildPath(leftTopCorner, $ea83db44c1b5114e$var$getArc(cornerRadius, 1, -1), arrowArc, "L", rightBottomCorner, $ea83db44c1b5114e$var$getArc(cornerRadius, -1, 1), "L", leftBottomCorner, $ea83db44c1b5114e$var$getArc(cornerRadius, -1, -1));
    } else if (anchorX > xr && anchorY >= yt && anchorY <= yb) {
        var _arrowArc;
        if (arrowBaseTop >= rightTopCorner[1] + cornerRadius && arrowBaseBottom <= rightBottomCorner[1]) _arrowArc = $ea83db44c1b5114e$var$buildPath($ea83db44c1b5114e$var$getArc(cornerRadius, 1, 1), "L", [
            xr,
            arrowBaseTop,
            anchorX,
            anchorY,
            xr,
            arrowBaseBottom
        ], "L", rightBottomCorner, $ea83db44c1b5114e$var$getArc(cornerRadius, -1, 1));
        else if (arrowBaseTop < rightTopCorner[1] + cornerRadius && arrowBaseBottom >= rightTopCorner[1] + cornerRadius && arrowBaseBottom <= rightBottomCorner[1]) {
            var arrowWidthRest = rightTopCorner[1] + cornerRadius - arrowBaseTop;
            var _angle = arrowWidthRest / cornerRadius;
            var arrowBaseTopX = rightTopCorner[0] + $ea83db44c1b5114e$var$cos(_angle) * cornerRadius;
            var arrowBaseTopY = rightTopCorner[1] + (1 - $ea83db44c1b5114e$var$sin(_angle)) * cornerRadius;
            _arrowArc = $ea83db44c1b5114e$var$buildPath($ea83db44c1b5114e$var$getArc(cornerRadius, $ea83db44c1b5114e$var$cos(_angle), 1 - $ea83db44c1b5114e$var$sin(_angle)), "L", [
                arrowBaseTopX,
                arrowBaseTopY,
                anchorX,
                anchorY,
                xr,
                arrowBaseBottom
            ], "L", rightBottomCorner, $ea83db44c1b5114e$var$getArc(cornerRadius, -1, 1));
        } else if (arrowBaseTop < rightTopCorner[1] + cornerRadius && arrowBaseBottom < rightTopCorner[1] + cornerRadius) {
            var _arrowWidthRest = rightTopCorner[1] + cornerRadius - arrowBaseTop;
            var _arrowAngle = _arrowWidthRest / cornerRadius;
            var _angle2 = _arrowAngle;
            var _arrowBaseTopX = rightTopCorner[0] + $ea83db44c1b5114e$var$cos(_angle2) * cornerRadius;
            var _arrowBaseTopY = rightTopCorner[1] + (1 - $ea83db44c1b5114e$var$sin(_angle2)) * cornerRadius;
            var bottomAngle = Math.sin((rightTopCorner[1] + cornerRadius - arrowBaseBottom) / cornerRadius);
            var arrowBaseBottomX = rightTopCorner[0] + cornerRadius * $ea83db44c1b5114e$var$cos(bottomAngle);
            var arrowBaseBottomY = rightTopCorner[1] + cornerRadius * (1 - $ea83db44c1b5114e$var$sin(bottomAngle));
            _arrowArc = $ea83db44c1b5114e$var$buildPath($ea83db44c1b5114e$var$getArc(cornerRadius, $ea83db44c1b5114e$var$cos(_angle2), 1 - $ea83db44c1b5114e$var$sin(_angle2)), "L", [
                _arrowBaseTopX,
                _arrowBaseTopY,
                anchorX,
                anchorY,
                arrowBaseBottomX,
                arrowBaseBottomY
            ], $ea83db44c1b5114e$var$getAbsoluteArc(cornerRadius, rightTopCorner[0] + cornerRadius, rightTopCorner[1] + cornerRadius), "L", rightBottomCorner, $ea83db44c1b5114e$var$getArc(cornerRadius, -1, 1));
        } else if (arrowBaseTop <= rightTopCorner[1] + cornerRadius && arrowBaseBottom >= rightBottomCorner[1]) {
            var topAngle = $ea83db44c1b5114e$var$asin((rightTopCorner[1] + cornerRadius - arrowBaseTop) / cornerRadius);
            var _arrowBaseTopX2 = rightTopCorner[0] + cornerRadius * $ea83db44c1b5114e$var$cos(topAngle);
            var _arrowBaseTopY2 = rightTopCorner[1] + cornerRadius * (1 - $ea83db44c1b5114e$var$sin(topAngle));
            var _bottomAngle = $ea83db44c1b5114e$var$asin((arrowBaseBottom - rightBottomCorner[1]) / cornerRadius);
            var _arrowBaseBottomX = rightBottomCorner[0] + cornerRadius * ($ea83db44c1b5114e$var$cos(_bottomAngle) - 1);
            var _arrowBaseBottomY = rightBottomCorner[1] + cornerRadius * $ea83db44c1b5114e$var$sin(_bottomAngle);
            _arrowArc = $ea83db44c1b5114e$var$buildPath($ea83db44c1b5114e$var$getArc(cornerRadius, $ea83db44c1b5114e$var$cos(topAngle), 1 - $ea83db44c1b5114e$var$sin(topAngle)), "L", [
                _arrowBaseTopX2,
                _arrowBaseTopY2,
                anchorX,
                anchorY,
                _arrowBaseBottomX,
                _arrowBaseBottomY
            ], $ea83db44c1b5114e$var$getAbsoluteArc(cornerRadius, rightBottomCorner[0] - cornerRadius, rightBottomCorner[1] + cornerRadius));
        } else if (arrowBaseTop > rightTopCorner[1] + cornerRadius && arrowBaseTop <= rightBottomCorner[1] && arrowBaseBottom > rightBottomCorner[1]) {
            var _bottomAngle2 = $ea83db44c1b5114e$var$asin((arrowBaseBottom - rightBottomCorner[1]) / cornerRadius);
            var _arrowBaseBottomX2 = rightBottomCorner[0] + cornerRadius * ($ea83db44c1b5114e$var$cos(_bottomAngle2) - 1);
            var _arrowBaseBottomY2 = rightBottomCorner[1] + cornerRadius * $ea83db44c1b5114e$var$sin(_bottomAngle2);
            _arrowArc = $ea83db44c1b5114e$var$buildPath($ea83db44c1b5114e$var$getArc(cornerRadius, 1, 1), "L", [
                xr,
                arrowBaseTop,
                anchorX,
                anchorY,
                _arrowBaseBottomX2,
                _arrowBaseBottomY2
            ], $ea83db44c1b5114e$var$getAbsoluteArc(cornerRadius, rightBottomCorner[0] - cornerRadius, rightBottomCorner[1] + cornerRadius));
        } else if (arrowBaseTop > rightTopCorner[1] + cornerRadius && arrowBaseBottom > rightBottomCorner[1]) {
            var _bottomAngle3 = $ea83db44c1b5114e$var$asin((arrowBaseBottom - rightBottomCorner[1]) / cornerRadius);
            var _arrowBaseBottomX3 = rightBottomCorner[0] + cornerRadius * ($ea83db44c1b5114e$var$cos(_bottomAngle3) - 1);
            var _arrowBaseBottomY3 = rightBottomCorner[1] + cornerRadius * $ea83db44c1b5114e$var$sin(_bottomAngle3);
            var _topAngle = $ea83db44c1b5114e$var$asin((arrowBaseTop - rightBottomCorner[1]) / cornerRadius);
            var _arrowBaseTopX3 = rightBottomCorner[0] + cornerRadius * ($ea83db44c1b5114e$var$cos(_topAngle) - 1);
            var _arrowBaseTopY3 = rightBottomCorner[1] + cornerRadius * $ea83db44c1b5114e$var$sin(_topAngle);
            _arrowArc = $ea83db44c1b5114e$var$buildPath($ea83db44c1b5114e$var$getArc(cornerRadius, 1, 1), "L", rightBottomCorner, $ea83db44c1b5114e$var$getArc(cornerRadius, $ea83db44c1b5114e$var$cos(_topAngle) - 1, $ea83db44c1b5114e$var$sin(_topAngle)), "L", [
                _arrowBaseTopX3,
                _arrowBaseTopY3,
                anchorX,
                anchorY,
                _arrowBaseBottomX3,
                _arrowBaseBottomY3
            ], $ea83db44c1b5114e$var$getAbsoluteArc(cornerRadius, rightBottomCorner[0] - cornerRadius, rightBottomCorner[1] + cornerRadius));
        }
        points = $ea83db44c1b5114e$var$buildPath(leftTopCorner, $ea83db44c1b5114e$var$getArc(cornerRadius, 1, -1), "L", rightTopCorner, _arrowArc, "L", leftBottomCorner, $ea83db44c1b5114e$var$getArc(cornerRadius, -1, -1));
    }
    return $ea83db44c1b5114e$var$buildPath("M", points, "Z");
}
class $ea83db44c1b5114e$export$24784ef4e53a2bc4 {
    constructor(options, widget, root, contentTemplate){
        var bounded = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : true;
        var measureContent = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : (_, g)=>g.getBBox();
        var moveContentGroup = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : (_, g, x, y)=>g.move(x, y);
        this.widget = widget;
        this.options = options;
        this.root = root;
        this.contentTemplate = contentTemplate;
        this.bonded = bounded;
        this.measureContent = measureContent;
        this.moveContentGroup = moveContentGroup;
    }
    draw(_ref4) {
        var { x: anchorX, y: anchorY, canvas: canvas = {}, offsetX: offsetX, offsetY: offsetY, offset: offset = 0 } = _ref4, restProps = (0, $hCIyK.default)(_ref4, $ea83db44c1b5114e$var$_excluded);
        var options = this.options;
        var { x: x, y: y } = options;
        var bounds_xl = canvas.left, bounds_xr = canvas.width - canvas.right, bounds_width = canvas.width - canvas.right - canvas.left, bounds_yt = canvas.top, bounds_yb = canvas.height - canvas.bottom, bounds_height = canvas.height - canvas.bottom - canvas.top;
        if (!((0, $6ntMu.isDefined)(anchorX) && (0, $6ntMu.isDefined)(anchorY)) && !((0, $6ntMu.isDefined)(x) && (0, $6ntMu.isDefined)(y))) return false;
        if ((0, $6ntMu.isDefined)(anchorX) && (anchorX < bounds_xl || bounds_xr < anchorX || anchorY < bounds_yt || bounds_yb < anchorY)) return false;
        if (!this._root) this._draw();
        var shadowSettings = (0, $2oTOp.extend)({
            x: "-50%",
            y: "-50%",
            width: "200%",
            height: "200%"
        }, options.shadow);
        var contentWidth = options.width > 0 ? options.width : null;
        var contentHeight = options.height > 0 ? options.height : null;
        var onRender = ()=>{
            var _this$_root;
            var bBox = this._contentBBox = this.measureContent(this.widget, this._contentGroup);
            var size = this._size = {
                width: $ea83db44c1b5114e$var$max(contentWidth, bBox.width) + 2 * options.paddingLeftRight,
                height: $ea83db44c1b5114e$var$max(contentHeight, bBox.height) + 2 * options.paddingTopBottom,
                offset: offset
            };
            var xOff = shadowSettings.offsetX;
            var yOff = shadowSettings.offsetY;
            var blur = 2 * shadowSettings.blur + 1;
            var lm = $ea83db44c1b5114e$var$max(blur - xOff, 0);
            var rm = $ea83db44c1b5114e$var$max(blur + xOff, 0);
            var tm = $ea83db44c1b5114e$var$max(blur - yOff, 0);
            var bm = $ea83db44c1b5114e$var$max(blur + yOff, 0);
            this.margins = {
                lm: lm,
                rm: rm,
                tm: tm,
                bm: bm
            };
            if (!(0, $6ntMu.isDefined)(x)) {
                if ((0, $6ntMu.isDefined)(offsetX)) x = anchorX + offsetX;
                else if (bounds_width < size.width) x = $ea83db44c1b5114e$var$round(bounds_xl + bounds_width / 2);
                else x = $ea83db44c1b5114e$var$min($ea83db44c1b5114e$var$max(anchorX, Math.ceil(bounds_xl + size.width / 2 + lm)), Math.floor(bounds_xr - size.width / 2 - rm));
            } else {
                x += offsetX || 0;
                if (!(0, $6ntMu.isDefined)(anchorX)) anchorX = x;
            }
            if (!(0, $6ntMu.isDefined)(y)) {
                if ((0, $6ntMu.isDefined)(offsetY)) y = anchorY + offsetY;
                else {
                    var y_top = anchorY - options.arrowLength - size.height / 2 - offset;
                    var y_bottom = anchorY + options.arrowLength + size.height / 2 + offset;
                    if (bounds_height < size.height + options.arrowLength) y = $ea83db44c1b5114e$var$round(bounds_yt + size.height / 2);
                    else if (y_top - size.height / 2 - tm < bounds_yt) {
                        if (y_bottom + size.height / 2 + bm < bounds_yb) {
                            y = y_bottom;
                            anchorY += offset;
                        } else y = $ea83db44c1b5114e$var$round(bounds_yt + size.height / 2);
                    } else {
                        y = y_top;
                        anchorY -= offset;
                    }
                }
            } else {
                y += offsetY || 0;
                if (!(0, $6ntMu.isDefined)(anchorY)) anchorY = y + size.height / 2;
            }
            this.anchorX = anchorX;
            this.anchorY = anchorY;
            this.move(x, y);
            null === (_this$_root = this._root) || void 0 === _this$_root || _this$_root.append(this.root);
        };
        if (this.contentTemplate.render) this.contentTemplate.render({
            model: options,
            container: this._contentGroup.element,
            onRendered: onRender
        });
        else return this.contentTemplate((0, $4WYaH.default)({
            group: this._contentGroup,
            onRender: onRender
        }, restProps));
        return true;
    }
    _draw() {
        var renderer = this.widget._renderer;
        var options = this.options;
        var shadowSettings = (0, $2oTOp.extend)({
            x: "-50%",
            y: "-50%",
            width: "200%",
            height: "200%"
        }, options.shadow);
        var shadow = this._shadow = renderer.shadowFilter().attr(shadowSettings);
        var cloudSettings = {
            opacity: options.opacity,
            "stroke-width": 0,
            fill: options.color
        };
        var borderOptions = options.border || {};
        if (borderOptions.visible) (0, $2oTOp.extend)(cloudSettings, {
            "stroke-width": borderOptions.width,
            stroke: borderOptions.color,
            "stroke-opacity": borderOptions.opacity,
            dashStyle: borderOptions.dashStyle
        });
        var group = this._root = renderer.g().append(this.root);
        if (options.type) group.attr({
            class: "dxc-".concat(options.type, "-annotation")
        });
        var cloudGroup = renderer.g().attr({
            filter: shadow.id
        }).append(group);
        this._cloud = renderer.path([], "area").attr(cloudSettings).sharp().append(cloudGroup);
        this._contentGroup = renderer.g().append(group);
    }
    getBBox() {
        var size = this._size || {};
        var margins = this.margins || {};
        var rotationAngle = $ea83db44c1b5114e$var$getCloudAngle(size, this.x, this.y, this.anchorX, this.anchorY);
        return {
            x: Math.floor(this.x - size.width / 2 - margins.lm),
            y: Math.floor(this.y - size.height / 2 - margins.tm - (270 === rotationAngle ? this.options.arrowLength : 0)),
            width: size.width + margins.lm + margins.rm,
            height: size.height + margins.tm + margins.bm + (90 === rotationAngle || 270 === rotationAngle ? this.options.arrowLength : 0)
        };
    }
    clear() {
        if (this._root) {
            this._root.remove();
            this._shadow.remove();
            this._root = null;
        }
        return this;
    }
    customizeCloud(attr) {
        if (this._cloud) this._cloud.attr(attr);
    }
    moveRoot(x, y) {
        if (this._root) this._root.move(x, y);
    }
    move(x, y) {
        x = $ea83db44c1b5114e$var$round(x);
        y = $ea83db44c1b5114e$var$round(y);
        this.x = x;
        this.y = y;
        var rotationAngle = $ea83db44c1b5114e$var$getCloudAngle(this._size, x, y, this.anchorX, this.anchorY);
        var radRotationAngle = rotationAngle * $ea83db44c1b5114e$var$PI / 180;
        this._cloud.attr({
            d: $ea83db44c1b5114e$var$getCloudPoints($ea83db44c1b5114e$var$rotateSize(this._size, rotationAngle), x, y, $ea83db44c1b5114e$var$rotateX(this.anchorX, this.anchorY, radRotationAngle, x, y), $ea83db44c1b5114e$var$rotateY(this.anchorX, this.anchorY, radRotationAngle, x, y), this.options, this.bonded)
        }).rotate(rotationAngle, x, y);
        this.moveContentGroup(this.widget, this._contentGroup, x - this._contentBBox.x - this._contentBBox.width / 2, y - this._contentBBox.y - this._contentBBox.height / 2);
    }
    hitTest(x, y) {
        var { width: width, height: height } = this._size || {};
        return Math.abs(x - this.x) <= width / 2 && Math.abs(y - this.y) <= height / 2;
    }
}

});


parcelRegister("cgnQR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ed97b1cd5a8045d$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/events/pointer.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2awHX = parcelRequire("2awHX");

var $8OLOW = parcelRequire("8OLOW");

var $jF0bZ = parcelRequire("jF0bZ");

var $jxLje = parcelRequire("jxLje");

var $kyXK8 = parcelRequire("kyXK8");

var $eVdLz = parcelRequire("eVdLz");

var $1ORBP = parcelRequire("1ORBP");
var $8ed97b1cd5a8045d$var$getStrategy = (support, device)=>{
    var { tablet: tablet, phone: phone } = device;
    if (support.touch && !(tablet || phone)) return 0, $1ORBP.default;
    if (support.touch) return 0, $kyXK8.default;
    return 0, $eVdLz.default;
};
var $8ed97b1cd5a8045d$var$EventStrategy = $8ed97b1cd5a8045d$var$getStrategy($2awHX, (0, $jF0bZ.default).real());
(0, $8OLOW.each)($8ed97b1cd5a8045d$var$EventStrategy.map, (pointerEvent, originalEvents)=>{
    (0, $jxLje.default)(pointerEvent, new $8ed97b1cd5a8045d$var$EventStrategy(pointerEvent, originalEvents));
});
var $8ed97b1cd5a8045d$var$pointer = {
    down: "dxpointerdown",
    up: "dxpointerup",
    move: "dxpointermove",
    cancel: "dxpointercancel",
    enter: "dxpointerenter",
    leave: "dxpointerleave",
    over: "dxpointerover",
    out: "dxpointerout"
};
var $8ed97b1cd5a8045d$export$2e2bcd8739ae039 = $8ed97b1cd5a8045d$var$pointer;

});
parcelRegister("2awHX", function(module, exports) {

$parcel$export(module.exports, "supportProp", function () { return $1945e30c1c1301bf$export$8fb65db1a1efa349; });
$parcel$export(module.exports, "inputType", function () { return $1945e30c1c1301bf$export$2611efed378f0f66; });
$parcel$export(module.exports, "touchEvents", function () { return $1945e30c1c1301bf$export$fa367689c659e65c; });
$parcel$export(module.exports, "pointerEvents", function () { return $1945e30c1c1301bf$export$c731eab7619e00a0; });
$parcel$export(module.exports, "touch", function () { return $1945e30c1c1301bf$export$d0b7ea69ab6056df; });
$parcel$export(module.exports, "transition", function () { return $1945e30c1c1301bf$export$66bb15e2994e6a26; });
$parcel$export(module.exports, "transitionEndEventName", function () { return $1945e30c1c1301bf$export$48b356d8c96d83a9; });
$parcel$export(module.exports, "animation", function () { return $1945e30c1c1301bf$export$ecad260a8a5fef4f; });
$parcel$export(module.exports, "nativeScrolling", function () { return $1945e30c1c1301bf$export$4259b5f542d10b5a; });
$parcel$export(module.exports, "styleProp", function () { return (parcelRequire("4jWiu")).styleProp; });
$parcel$export(module.exports, "stylePropPrefix", function () { return (parcelRequire("4jWiu")).stylePropPrefix; });
/**
 * DevExtreme (esm/core/utils/support.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $3yzYM = parcelRequire("3yzYM");

var $k2ifc = parcelRequire("k2ifc");

var $hYatw = parcelRequire("hYatw");

var $jF0bZ = parcelRequire("jF0bZ");

var $4jWiu = parcelRequire("4jWiu");
var { maxTouchPoints: $1945e30c1c1301bf$var$maxTouchPoints } = (0, $hYatw.getNavigator)();
var $1945e30c1c1301bf$var$transitionEndEventNames = {
    webkitTransition: "webkitTransitionEnd",
    MozTransition: "transitionend",
    OTransition: "oTransitionEnd",
    transition: "transitionend"
};
var $1945e30c1c1301bf$export$8fb65db1a1efa349 = function(prop) {
    return !!(0, $4jWiu.styleProp)(prop);
};
var $1945e30c1c1301bf$var$isNativeScrollingSupported = function() {
    var { platform: platform, mac: isMac } = (0, $jF0bZ.default).real();
    var isNativeScrollDevice = "ios" === platform || "android" === platform || isMac;
    return isNativeScrollDevice;
};
var $1945e30c1c1301bf$export$2611efed378f0f66 = function(type) {
    if ("text" === type) return true;
    var input = (0, $3yzYM.default).createElement("input");
    try {
        input.setAttribute("type", type);
        input.value = "wrongValue";
        return !input.value;
    } catch (e) {
        return false;
    }
};
var $1945e30c1c1301bf$var$detectTouchEvents = function(hasWindowProperty, maxTouchPoints) {
    return (hasWindowProperty("ontouchstart") || !!maxTouchPoints) && !hasWindowProperty("callPhantom");
};
var $1945e30c1c1301bf$var$detectPointerEvent = function(hasWindowProperty) {
    return hasWindowProperty("PointerEvent");
};
var $1945e30c1c1301bf$export$fa367689c659e65c = $1945e30c1c1301bf$var$detectTouchEvents((0, $hYatw.hasProperty), $1945e30c1c1301bf$var$maxTouchPoints);
var $1945e30c1c1301bf$export$c731eab7619e00a0 = $1945e30c1c1301bf$var$detectPointerEvent((0, $hYatw.hasProperty));
var $1945e30c1c1301bf$var$touchPointersPresent = !!$1945e30c1c1301bf$var$maxTouchPoints;
var $1945e30c1c1301bf$export$d0b7ea69ab6056df = $1945e30c1c1301bf$export$fa367689c659e65c || $1945e30c1c1301bf$export$c731eab7619e00a0 && $1945e30c1c1301bf$var$touchPointersPresent;
var $1945e30c1c1301bf$export$66bb15e2994e6a26 = (0, $k2ifc.default)(function() {
    return $1945e30c1c1301bf$export$8fb65db1a1efa349("transition");
});
var $1945e30c1c1301bf$export$48b356d8c96d83a9 = (0, $k2ifc.default)(function() {
    return $1945e30c1c1301bf$var$transitionEndEventNames[(0, $4jWiu.styleProp)("transition")];
});
var $1945e30c1c1301bf$export$ecad260a8a5fef4f = (0, $k2ifc.default)(function() {
    return $1945e30c1c1301bf$export$8fb65db1a1efa349("animation");
});
var $1945e30c1c1301bf$export$4259b5f542d10b5a = $1945e30c1c1301bf$var$isNativeScrollingSupported();

});
parcelRegister("jF0bZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e501fedf84ea7898$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/devices.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $iE2yv = parcelRequire("iE2yv");

var $2vlX8 = parcelRequire("2vlX8");

var $hYatw = parcelRequire("hYatw");

var $2oTOp = parcelRequire("2oTOp");

var $6ntMu = parcelRequire("6ntMu");

var $cvYFL = parcelRequire("cvYFL");

var $dYDfV = parcelRequire("dYDfV");

var $8n1m9 = parcelRequire("8n1m9");

var $2SbZF = parcelRequire("2SbZF");

var $dL2Eh = parcelRequire("dL2Eh");

var $d1nUm = parcelRequire("d1nUm");

var $3O5Oh = parcelRequire("3O5Oh");

var $8IERv = parcelRequire("8IERv");
var $e501fedf84ea7898$var$window = (0, $hYatw.getWindow)();
var $e501fedf84ea7898$var$KNOWN_UA_TABLE = {
    iPhone: "iPhone",
    iPhone5: "iPhone",
    iPhone6: "iPhone",
    iPhone6plus: "iPhone",
    iPad: "iPad",
    iPadMini: "iPad Mini",
    androidPhone: "Android Mobile",
    androidTablet: "Android",
    msSurface: "Windows ARM Tablet PC",
    desktop: "desktop"
};
var $e501fedf84ea7898$var$DEFAULT_DEVICE = {
    deviceType: "desktop",
    platform: "generic",
    version: [],
    phone: false,
    tablet: false,
    android: false,
    ios: false,
    generic: true,
    grade: "A",
    mac: false
};
var $e501fedf84ea7898$var$UA_PARSERS = {
    generic (userAgent) {
        var isPhone = /windows phone/i.test(userAgent) || userAgent.match(/WPDesktop/);
        var isTablet = !isPhone && /Windows(.*)arm(.*)Tablet PC/i.test(userAgent);
        var isDesktop = !isPhone && !isTablet && /msapphost/i.test(userAgent);
        var isMac = /((intel|ppc) mac os x)/.test(userAgent.toLowerCase());
        if (!(isPhone || isTablet || isDesktop || isMac)) return null;
        return {
            deviceType: isPhone ? "phone" : isTablet ? "tablet" : "desktop",
            platform: "generic",
            version: [],
            grade: "A",
            mac: isMac
        };
    },
    appleTouchDevice (userAgent) {
        var navigator = (0, $hYatw.getNavigator)();
        var isIpadOs = /Macintosh/i.test(userAgent) && (null === navigator || void 0 === navigator ? void 0 : navigator.maxTouchPoints) > 2;
        var isAppleDevice = /ip(hone|od|ad)/i.test(userAgent);
        if (!isAppleDevice && !isIpadOs) return null;
        var isPhone = /ip(hone|od)/i.test(userAgent);
        var matches = userAgent.match(/os\s{0,}X? (\d+)_(\d+)_?(\d+)?/i);
        var version = matches ? [
            parseInt(matches[1], 10),
            parseInt(matches[2], 10),
            parseInt(matches[3] || 0, 10)
        ] : [];
        var isIPhone4 = 480 === $e501fedf84ea7898$var$window.screen.height;
        var grade = isIPhone4 ? "B" : "A";
        return {
            deviceType: isPhone ? "phone" : "tablet",
            platform: "ios",
            version: version,
            grade: grade
        };
    },
    android (userAgent) {
        var isAndroid = /android|htc_|silk/i.test(userAgent);
        var isWinPhone = /windows phone/i.test(userAgent);
        if (!isAndroid || isWinPhone) return null;
        var isPhone = /mobile/i.test(userAgent);
        var matches = userAgent.match(/android (\d+)\.?(\d+)?\.?(\d+)?/i);
        var version = matches ? [
            parseInt(matches[1], 10),
            parseInt(matches[2] || 0, 10),
            parseInt(matches[3] || 0, 10)
        ] : [];
        var worseThan4_4 = version.length > 1 && (version[0] < 4 || 4 === version[0] && version[1] < 4);
        var grade = worseThan4_4 ? "B" : "A";
        return {
            deviceType: isPhone ? "phone" : "tablet",
            platform: "android",
            version: version,
            grade: grade
        };
    }
};
var $e501fedf84ea7898$var$UA_PARSERS_ARRAY = [
    $e501fedf84ea7898$var$UA_PARSERS.appleTouchDevice,
    $e501fedf84ea7898$var$UA_PARSERS.android,
    $e501fedf84ea7898$var$UA_PARSERS.generic
];
class $e501fedf84ea7898$var$Devices {
    constructor(options){
        this._window = (null === options || void 0 === options ? void 0 : options.window) || $e501fedf84ea7898$var$window;
        this._realDevice = this._getDevice();
        this._currentDevice = void 0;
        this._currentOrientation = void 0;
        this._eventsStrategy = new (0, $dL2Eh.EventsStrategy)(this);
        this.changed = (0, $dYDfV.default)();
        if ((0, $hYatw.hasWindow)()) {
            (0, $8n1m9.default).add(this._recalculateOrientation.bind(this));
            (0, $2SbZF.default).add(this._recalculateOrientation.bind(this));
        }
    }
    current(deviceOrName) {
        if (deviceOrName) {
            this._currentDevice = this._getDevice(deviceOrName);
            this._forced = true;
            this.changed.fire();
            return;
        }
        if (!this._currentDevice) {
            deviceOrName = void 0;
            try {
                deviceOrName = this._getDeviceOrNameFromWindowScope();
            } catch (e) {
                deviceOrName = this._getDeviceNameFromSessionStorage();
            } finally{
                if (!deviceOrName) deviceOrName = this._getDeviceNameFromSessionStorage();
                if (deviceOrName) this._forced = true;
            }
            this._currentDevice = this._getDevice(deviceOrName);
        }
        return this._currentDevice;
    }
    real(forceDevice) {
        return (0, $2oTOp.extend)({}, this._realDevice);
    }
    orientation() {
        return this._currentOrientation;
    }
    isForced() {
        return this._forced;
    }
    isRippleEmulator() {
        return !!this._window.tinyHippos;
    }
    _getCssClasses(device) {
        var result = [];
        var realDevice = this._realDevice;
        device = device || this.current();
        if (device.deviceType) {
            result.push("dx-device-".concat(device.deviceType));
            if ("desktop" !== device.deviceType) result.push("dx-device-mobile");
        }
        result.push("dx-device-".concat(realDevice.platform));
        if (realDevice.version && realDevice.version.length) result.push("dx-device-".concat(realDevice.platform, "-").concat(realDevice.version[0]));
        if (this.isSimulator()) result.push("dx-simulator");
        if ((0, $8IERv.default)().rtlEnabled) result.push("dx-rtl");
        return result;
    }
    attachCssClasses(element, device) {
        this._deviceClasses = this._getCssClasses(device).join(" ");
        (0, $2vlX8.default)(element).addClass(this._deviceClasses);
    }
    detachCssClasses(element) {
        (0, $2vlX8.default)(element).removeClass(this._deviceClasses);
    }
    isSimulator() {
        try {
            return this._isSimulator || (0, $hYatw.hasWindow)() && this._window.top !== this._window.self && this._window.top["dx-force-device"] || this.isRippleEmulator();
        } catch (e) {
            return false;
        }
    }
    forceSimulator() {
        this._isSimulator = true;
    }
    _getDevice(deviceName) {
        if ("genericPhone" === deviceName) deviceName = {
            deviceType: "phone",
            platform: "generic",
            generic: true
        };
        if ((0, $6ntMu.isPlainObject)(deviceName)) return this._fromConfig(deviceName);
        else {
            var ua;
            if (deviceName) {
                ua = $e501fedf84ea7898$var$KNOWN_UA_TABLE[deviceName];
                if (!ua) throw (0, $cvYFL.default).Error("E0005");
            } else {
                var navigator = (0, $hYatw.getNavigator)();
                ua = navigator.userAgent;
            }
            return this._fromUA(ua);
        }
    }
    _getDeviceOrNameFromWindowScope() {
        var result;
        if ((0, $hYatw.hasWindow)() && (this._window.top["dx-force-device-object"] || this._window.top["dx-force-device"])) result = this._window.top["dx-force-device-object"] || this._window.top["dx-force-device"];
        return result;
    }
    _getDeviceNameFromSessionStorage() {
        var sessionStorage = (0, $d1nUm.sessionStorage)();
        if (!sessionStorage) return;
        var deviceOrName = sessionStorage.getItem("dx-force-device");
        try {
            return JSON.parse(deviceOrName);
        } catch (ex) {
            return deviceOrName;
        }
    }
    _fromConfig(config) {
        var result = (0, $2oTOp.extend)({}, $e501fedf84ea7898$var$DEFAULT_DEVICE, this._currentDevice, config);
        var shortcuts = {
            phone: "phone" === result.deviceType,
            tablet: "tablet" === result.deviceType,
            android: "android" === result.platform,
            ios: "ios" === result.platform,
            generic: "generic" === result.platform
        };
        return (0, $2oTOp.extend)(result, shortcuts);
    }
    _fromUA(ua) {
        for(var idx = 0; idx < $e501fedf84ea7898$var$UA_PARSERS_ARRAY.length; idx += 1){
            var parser = $e501fedf84ea7898$var$UA_PARSERS_ARRAY[idx];
            var config = parser(ua);
            if (config) return this._fromConfig(config);
        }
        return $e501fedf84ea7898$var$DEFAULT_DEVICE;
    }
    _changeOrientation() {
        var $window = (0, $2vlX8.default)(this._window);
        var orientation = (0, $iE2yv.getHeight)($window) > (0, $iE2yv.getWidth)($window) ? "portrait" : "landscape";
        if (this._currentOrientation === orientation) return;
        this._currentOrientation = orientation;
        this._eventsStrategy.fireEvent("orientationChanged", [
            {
                orientation: orientation
            }
        ]);
    }
    _recalculateOrientation() {
        var windowWidth = (0, $iE2yv.getWidth)(this._window);
        if (this._currentWidth === windowWidth) return;
        this._currentWidth = windowWidth;
        this._changeOrientation();
    }
    on(eventName, eventHandler) {
        this._eventsStrategy.on(eventName, eventHandler);
        return this;
    }
    off(eventName, eventHandler) {
        this._eventsStrategy.off(eventName, eventHandler);
        return this;
    }
}
var $e501fedf84ea7898$var$devices = new $e501fedf84ea7898$var$Devices;
var $e501fedf84ea7898$var$viewPortElement = (0, $3O5Oh.value)();
if ($e501fedf84ea7898$var$viewPortElement) $e501fedf84ea7898$var$devices.attachCssClasses($e501fedf84ea7898$var$viewPortElement);
(0, $3O5Oh.changeCallback).add((viewPort, prevViewport)=>{
    $e501fedf84ea7898$var$devices.detachCssClasses(prevViewport);
    $e501fedf84ea7898$var$devices.attachCssClasses(viewPort);
});
var $e501fedf84ea7898$export$2e2bcd8739ae039 = $e501fedf84ea7898$var$devices;

});
parcelRegister("8n1m9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6181860d4216b959$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/utils/ready_callbacks.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $3yzYM = parcelRequire("3yzYM");

var $5Nras = parcelRequire("5Nras");

var $hYatw = parcelRequire("hYatw");

var $k2ifc = parcelRequire("k2ifc");
var $6181860d4216b959$var$callbacks = [];
var $6181860d4216b959$var$subscribeReady = (0, $k2ifc.default)(()=>{
    var removeListener = (0, $3yzYM.default).listen((0, $3yzYM.default).getDocument(), "DOMContentLoaded", ()=>{
        $6181860d4216b959$var$readyCallbacks.fire();
        removeListener();
    });
});
var $6181860d4216b959$var$readyCallbacks = {
    add: (callback)=>{
        var windowExists = (0, $hYatw.hasWindow)();
        if (windowExists && "loading" !== (0, $3yzYM.default).getReadyState()) callback();
        else {
            $6181860d4216b959$var$callbacks.push(callback);
            windowExists && $6181860d4216b959$var$subscribeReady();
        }
    },
    fire: ()=>{
        $6181860d4216b959$var$callbacks.forEach((callback)=>callback());
        $6181860d4216b959$var$callbacks = [];
    }
};
var $6181860d4216b959$export$2e2bcd8739ae039 = (0, $5Nras.default)($6181860d4216b959$var$readyCallbacks);

});

parcelRegister("2SbZF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2179ed9e8491d0ab$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/utils/resize_callbacks.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $hYatw = parcelRequire("hYatw");

var $3yzYM = parcelRequire("3yzYM");

var $dYDfV = parcelRequire("dYDfV");

var $8n1m9 = parcelRequire("8n1m9");

var $k2ifc = parcelRequire("k2ifc");
var $2179ed9e8491d0ab$var$resizeCallbacks = function() {
    var prevSize;
    var callbacks = (0, $dYDfV.default)();
    var originalCallbacksAdd = callbacks.add;
    var originalCallbacksRemove = callbacks.remove;
    if (!(0, $hYatw.hasWindow)()) return callbacks;
    var formatSize = function() {
        var window = (0, $hYatw.getWindow)();
        return {
            width: window.innerWidth,
            height: window.innerHeight
        };
    };
    var handleResize = function() {
        var now = formatSize();
        if (now.width === prevSize.width && now.height === prevSize.height) return;
        var changedDimension;
        if (now.width === prevSize.width) changedDimension = "height";
        if (now.height === prevSize.height) changedDimension = "width";
        prevSize = now;
        callbacks.fire(changedDimension);
    };
    var setPrevSize = (0, $k2ifc.default)(function() {
        prevSize = formatSize();
    });
    var removeListener;
    callbacks.add = function() {
        var result = originalCallbacksAdd.apply(callbacks, arguments);
        setPrevSize();
        (0, $8n1m9.default).add(function() {
            if (!removeListener && callbacks.has()) removeListener = (0, $3yzYM.default).listen((0, $hYatw.getWindow)(), "resize", handleResize);
        });
        return result;
    };
    callbacks.remove = function() {
        var result = originalCallbacksRemove.apply(callbacks, arguments);
        if (!callbacks.has() && removeListener) {
            removeListener();
            removeListener = void 0;
        }
        return result;
    };
    return callbacks;
}();
var $2179ed9e8491d0ab$export$2e2bcd8739ae039 = $2179ed9e8491d0ab$var$resizeCallbacks;

});

parcelRegister("dL2Eh", function(module, exports) {

$parcel$export(module.exports, "EventsStrategy", function () { return $a041b81dd8d3c375$export$99c7e755e73d8049; });
/**
 * DevExtreme (esm/core/events_strategy.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $dYDfV = parcelRequire("dYDfV");

var $8OLOW = parcelRequire("8OLOW");

var $6ntMu = parcelRequire("6ntMu");
class $a041b81dd8d3c375$export$99c7e755e73d8049 {
    constructor(owner){
        var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        this._events = {};
        this._owner = owner;
        this._options = options;
    }
    static create(owner, strategy) {
        if (strategy) return (0, $6ntMu.isFunction)(strategy) ? strategy(owner) : strategy;
        else return new $a041b81dd8d3c375$export$99c7e755e73d8049(owner);
    }
    hasEvent(eventName) {
        var callbacks = this._events[eventName];
        return callbacks ? callbacks.has() : false;
    }
    fireEvent(eventName, eventArgs) {
        var callbacks = this._events[eventName];
        if (callbacks) callbacks.fireWith(this._owner, eventArgs);
        return this._owner;
    }
    on(eventName, eventHandler) {
        if ((0, $6ntMu.isPlainObject)(eventName)) (0, $8OLOW.each)(eventName, (e, h)=>{
            this.on(e, h);
        });
        else {
            var callbacks = this._events[eventName];
            if (!callbacks) {
                callbacks = (0, $dYDfV.default)({
                    syncStrategy: this._options.syncStrategy
                });
                this._events[eventName] = callbacks;
            }
            var addFn = callbacks.originalAdd || callbacks.add;
            addFn.call(callbacks, eventHandler);
        }
    }
    off(eventName, eventHandler) {
        var callbacks = this._events[eventName];
        if (callbacks) {
            if ((0, $6ntMu.isFunction)(eventHandler)) callbacks.remove(eventHandler);
            else callbacks.empty();
        }
    }
    dispose() {
        (0, $8OLOW.each)(this._events, (eventName, event)=>{
            event.empty();
        });
    }
}

});

parcelRegister("d1nUm", function(module, exports) {

$parcel$export(module.exports, "sessionStorage", function () { return $97ade9fbc1918b13$export$f119d83aa936d634; });
/**
 * DevExtreme (esm/core/utils/storage.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $hYatw = parcelRequire("hYatw");
var $97ade9fbc1918b13$var$window = (0, $hYatw.getWindow)();
var $97ade9fbc1918b13$export$f119d83aa936d634 = function() {
    var sessionStorage;
    try {
        sessionStorage = $97ade9fbc1918b13$var$window.sessionStorage;
    } catch (e) {}
    return sessionStorage;
};

});

parcelRegister("3O5Oh", function(module, exports) {

$parcel$export(module.exports, "changeCallback", function () { return $2c5a8c5d205b43db$export$2004d4da319c8d66; });
$parcel$export(module.exports, "value", function () { return $2c5a8c5d205b43db$export$2ab9a8f9f1186f14; });
$parcel$export(module.exports, "originalViewPort", function () { return $2c5a8c5d205b43db$export$45c50885f51f0f9f; });
/**
 * DevExtreme (esm/core/utils/view_port.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $8n1m9 = parcelRequire("8n1m9");

var $dYDfV = parcelRequire("dYDfV");
var $2c5a8c5d205b43db$var$ready = (0, $8n1m9.default).add;
var $2c5a8c5d205b43db$export$2004d4da319c8d66 = (0, $dYDfV.default)();
var $2c5a8c5d205b43db$var$$originalViewPort = (0, $2vlX8.default)();
var $2c5a8c5d205b43db$export$2ab9a8f9f1186f14 = function() {
    var $current;
    return function(element) {
        if (!arguments.length) return $current;
        var $element = (0, $2vlX8.default)(element);
        $2c5a8c5d205b43db$var$$originalViewPort = $element;
        var isNewViewportFound = !!$element.length;
        var prevViewPort = $2c5a8c5d205b43db$export$2ab9a8f9f1186f14();
        $current = isNewViewportFound ? $element : (0, $2vlX8.default)("body");
        $2c5a8c5d205b43db$export$2004d4da319c8d66.fire(isNewViewportFound ? $2c5a8c5d205b43db$export$2ab9a8f9f1186f14() : (0, $2vlX8.default)(), prevViewPort);
    };
}();
$2c5a8c5d205b43db$var$ready(function() {
    $2c5a8c5d205b43db$export$2ab9a8f9f1186f14(".dx-viewport");
});
function $2c5a8c5d205b43db$export$45c50885f51f0f9f() {
    return $2c5a8c5d205b43db$var$$originalViewPort;
}

});



parcelRegister("kyXK8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef8553601edbef9f$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/events/pointer/touch.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $jF0bZ = parcelRequire("jF0bZ");

var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $1wYF9 = parcelRequire("1wYF9");
var $ef8553601edbef9f$var$eventMap = {
    dxpointerdown: "touchstart",
    dxpointermove: "touchmove",
    dxpointerup: "touchend",
    dxpointercancel: "touchcancel",
    dxpointerover: "",
    dxpointerout: "",
    dxpointerenter: "",
    dxpointerleave: ""
};
var $ef8553601edbef9f$var$normalizeTouchEvent = function(e) {
    var pointers = [];
    (0, $8OLOW.each)(e.touches, function(_, touch) {
        pointers.push((0, $2oTOp.extend)({
            pointerId: touch.identifier
        }, touch));
    });
    return {
        pointers: pointers,
        pointerId: e.changedTouches[0].identifier
    };
};
var $ef8553601edbef9f$var$skipTouchWithSameIdentifier = function(pointerEvent) {
    return "ios" === (0, $jF0bZ.default).real().platform && ("dxpointerdown" === pointerEvent || "dxpointerup" === pointerEvent);
};
var $ef8553601edbef9f$var$TouchStrategy = (0, $1wYF9.default).inherit({
    ctor: function() {
        this.callBase.apply(this, arguments);
        this._pointerId = 0;
    },
    _handler: function(e) {
        if ($ef8553601edbef9f$var$skipTouchWithSameIdentifier(this._eventName)) {
            var touch = e.changedTouches[0];
            if (this._pointerId === touch.identifier && 0 !== this._pointerId) return;
            this._pointerId = touch.identifier;
        }
        return this.callBase.apply(this, arguments);
    },
    _fireEvent: function(args) {
        return this.callBase((0, $2oTOp.extend)($ef8553601edbef9f$var$normalizeTouchEvent(args.originalEvent), args));
    }
});
$ef8553601edbef9f$var$TouchStrategy.map = $ef8553601edbef9f$var$eventMap;
$ef8553601edbef9f$var$TouchStrategy.normalize = $ef8553601edbef9f$var$normalizeTouchEvent;
var $ef8553601edbef9f$export$2e2bcd8739ae039 = $ef8553601edbef9f$var$TouchStrategy;

});
parcelRegister("1wYF9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11d7d5f54d0043c8$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/events/pointer/base.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $60GuF = parcelRequire("60GuF");

var $1fZ7c = parcelRequire("1fZ7c");

var $3yzYM = parcelRequire("3yzYM");

var $a2g7x = parcelRequire("a2g7x");

var $bcOMe = parcelRequire("bcOMe");
var $11d7d5f54d0043c8$var$POINTER_EVENTS_NAMESPACE = "dxPointerEvents";
var $11d7d5f54d0043c8$var$BaseStrategy = (0, $a2g7x.default).inherit({
    ctor: function(eventName, originalEvents) {
        this._eventName = eventName;
        this._originalEvents = (0, $bcOMe.addNamespace)(originalEvents, $11d7d5f54d0043c8$var$POINTER_EVENTS_NAMESPACE);
        this._handlerCount = 0;
        this.noBubble = this._isNoBubble();
    },
    _isNoBubble: function() {
        var eventName = this._eventName;
        return "dxpointerenter" === eventName || "dxpointerleave" === eventName;
    },
    _handler: function(e) {
        var _originalEvent$target;
        var delegateTarget = this._getDelegateTarget(e);
        var event = {
            type: this._eventName,
            pointerType: e.pointerType || (0, $bcOMe.eventSource)(e),
            originalEvent: e,
            delegateTarget: delegateTarget,
            timeStamp: (0, $1fZ7c.default).mozilla ? (new Date).getTime() : e.timeStamp
        };
        var originalEvent = e.originalEvent;
        if (null !== originalEvent && void 0 !== originalEvent && null !== (_originalEvent$target = originalEvent.target) && void 0 !== _originalEvent$target && _originalEvent$target.shadowRoot) {
            var _originalEvent$path, _originalEvent$compos;
            var path = null !== (_originalEvent$path = originalEvent.path) && void 0 !== _originalEvent$path ? _originalEvent$path : null === (_originalEvent$compos = originalEvent.composedPath) || void 0 === _originalEvent$compos ? void 0 : _originalEvent$compos.call(originalEvent);
            event.target = path[0];
        }
        return this._fireEvent(event);
    },
    _getDelegateTarget: function(e) {
        var delegateTarget;
        if (this.noBubble) delegateTarget = e.delegateTarget;
        return delegateTarget;
    },
    _fireEvent: function(args) {
        return (0, $bcOMe.fireEvent)(args);
    },
    _setSelector: function(handleObj) {
        this._selector = this.noBubble && handleObj ? handleObj.selector : null;
    },
    _getSelector: function() {
        return this._selector;
    },
    setup: function() {
        return true;
    },
    add: function(element, handleObj) {
        if (this._handlerCount <= 0 || this.noBubble) {
            element = this.noBubble ? element : (0, $3yzYM.default).getDocument();
            this._setSelector(handleObj);
            var that = this;
            (0, $60GuF.default).on(element, this._originalEvents, this._getSelector(), function(e) {
                that._handler(e);
            });
        }
        if (!this.noBubble) this._handlerCount++;
    },
    remove: function(handleObj) {
        this._setSelector(handleObj);
        if (!this.noBubble) this._handlerCount--;
    },
    teardown: function(element) {
        if (this._handlerCount && !this.noBubble) return;
        element = this.noBubble ? element : (0, $3yzYM.default).getDocument();
        if (this._originalEvents !== "." + $11d7d5f54d0043c8$var$POINTER_EVENTS_NAMESPACE) (0, $60GuF.default).off(element, this._originalEvents, this._getSelector());
    },
    dispose: function(element) {
        element = this.noBubble ? element : (0, $3yzYM.default).getDocument();
        (0, $60GuF.default).off(element, this._originalEvents);
    }
});
var $11d7d5f54d0043c8$export$2e2bcd8739ae039 = $11d7d5f54d0043c8$var$BaseStrategy;

});
parcelRegister("1fZ7c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ea69958bfb1f8a3$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/utils/browser.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $hYatw = parcelRequire("hYatw");
var $0ea69958bfb1f8a3$var$navigator = (0, $hYatw.getNavigator)();
var $0ea69958bfb1f8a3$var$webkitRegExp = /(webkit)[ /]([\w.]+)/;
var $0ea69958bfb1f8a3$var$mozillaRegExp = /(mozilla)(?:.*? rv:([\w.]+))/;
var $0ea69958bfb1f8a3$var$browserFromUA = (ua)=>{
    ua = ua.toLowerCase();
    var result = {};
    var matches = $0ea69958bfb1f8a3$var$webkitRegExp.exec(ua) || ua.indexOf("compatible") < 0 && $0ea69958bfb1f8a3$var$mozillaRegExp.exec(ua) || [];
    var browserName = matches[1];
    var browserVersion = matches[2];
    if ("webkit" === browserName) {
        result.webkit = true;
        if (ua.indexOf("chrome") >= 0 || ua.indexOf("crios") >= 0) {
            browserName = "chrome";
            browserVersion = /(?:chrome|crios)\/(\d+\.\d+)/.exec(ua);
            browserVersion = browserVersion && browserVersion[1];
        } else if (ua.indexOf("fxios") >= 0) {
            browserName = "mozilla";
            browserVersion = /fxios\/(\d+\.\d+)/.exec(ua);
            browserVersion = browserVersion && browserVersion[1];
        } else if (ua.indexOf("safari") >= 0 && /version|phantomjs/.test(ua)) {
            browserName = "safari";
            browserVersion = /(?:version|phantomjs)\/([0-9.]+)/.exec(ua);
            browserVersion = browserVersion && browserVersion[1];
        } else {
            browserName = "unknown";
            browserVersion = /applewebkit\/([0-9.]+)/.exec(ua);
            browserVersion = browserVersion && browserVersion[1];
        }
    }
    if (browserName) {
        result[browserName] = true;
        result.version = browserVersion;
    }
    return result;
};
var $0ea69958bfb1f8a3$export$2e2bcd8739ae039 = (0, $2oTOp.extend)({
    _fromUA: $0ea69958bfb1f8a3$var$browserFromUA
}, $0ea69958bfb1f8a3$var$browserFromUA($0ea69958bfb1f8a3$var$navigator.userAgent));

});

parcelRegister("bcOMe", function(module, exports) {

$parcel$export(module.exports, "eventSource", function () { return $828833ea7a7555e4$export$e7d04fea5cade03b; });
$parcel$export(module.exports, "isPointerEvent", function () { return $828833ea7a7555e4$export$1d0a87a519049f8c; });
$parcel$export(module.exports, "isMouseEvent", function () { return $828833ea7a7555e4$export$764db16956f554f8; });
$parcel$export(module.exports, "isDxMouseWheelEvent", function () { return $828833ea7a7555e4$export$379075400f699289; });
$parcel$export(module.exports, "isTouchEvent", function () { return $828833ea7a7555e4$export$c4dfce035d43d1e0; });
$parcel$export(module.exports, "eventData", function () { return $828833ea7a7555e4$export$882d6efd8e16e97a; });
$parcel$export(module.exports, "eventDelta", function () { return $828833ea7a7555e4$export$90751ced8b96ad34; });
$parcel$export(module.exports, "hasTouches", function () { return $828833ea7a7555e4$export$6df5851d4f8a2c38; });
$parcel$export(module.exports, "needSkipEvent", function () { return $828833ea7a7555e4$export$49cacaa9699ab169; });
$parcel$export(module.exports, "createEvent", function () { return $828833ea7a7555e4$export$c30017717ce2168e; });
$parcel$export(module.exports, "fireEvent", function () { return $828833ea7a7555e4$export$43835e9acf248a15; });
$parcel$export(module.exports, "normalizeKeyName", function () { return $828833ea7a7555e4$export$dfadd96f345d39fc; });
$parcel$export(module.exports, "addNamespace", function () { return $828833ea7a7555e4$export$4d393b9a14b8e6cb; });
/**
 * DevExtreme (esm/events/utils/index.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $6IMTb = parcelRequire("6IMTb");

var $60GuF = parcelRequire("60GuF");

var $8OLOW = parcelRequire("8OLOW");

var $2oTOp = parcelRequire("2oTOp");

var $gUEMS = parcelRequire("gUEMS");
var $828833ea7a7555e4$var$KEY_MAP = {
    backspace: "backspace",
    tab: "tab",
    enter: "enter",
    escape: "escape",
    pageup: "pageUp",
    pagedown: "pageDown",
    end: "end",
    home: "home",
    arrowleft: "leftArrow",
    arrowup: "upArrow",
    arrowright: "rightArrow",
    arrowdown: "downArrow",
    delete: "del",
    " ": "space",
    f: "F",
    a: "A",
    "*": "asterisk",
    "-": "minus",
    alt: "alt",
    control: "control",
    shift: "shift"
};
var $828833ea7a7555e4$var$LEGACY_KEY_CODES = {
    8: "backspace",
    9: "tab",
    13: "enter",
    27: "escape",
    33: "pageUp",
    34: "pageDown",
    35: "end",
    36: "home",
    37: "leftArrow",
    38: "upArrow",
    39: "rightArrow",
    40: "downArrow",
    46: "del",
    32: "space",
    70: "F",
    65: "A",
    106: "asterisk",
    109: "minus",
    189: "minus",
    173: "minus",
    16: "shift",
    17: "control",
    18: "alt"
};
var $828833ea7a7555e4$var$EVENT_SOURCES_REGEX = {
    dx: /^dx/i,
    mouse: /(mouse|wheel)/i,
    touch: /^touch/i,
    keyboard: /^key/i,
    pointer: /^(ms)?pointer/i
};
var $828833ea7a7555e4$var$fixMethod = (e)=>e;
var $828833ea7a7555e4$var$copyEvent = (originalEvent)=>$828833ea7a7555e4$var$fixMethod((0, $60GuF.default).Event(originalEvent, originalEvent), originalEvent);
var $828833ea7a7555e4$var$isDxEvent = (e)=>"dx" === $828833ea7a7555e4$export$e7d04fea5cade03b(e);
var $828833ea7a7555e4$var$isNativeMouseEvent = (e)=>"mouse" === $828833ea7a7555e4$export$e7d04fea5cade03b(e);
var $828833ea7a7555e4$var$isNativeTouchEvent = (e)=>"touch" === $828833ea7a7555e4$export$e7d04fea5cade03b(e);
var $828833ea7a7555e4$export$e7d04fea5cade03b = (_ref)=>{
    var { type: type } = _ref;
    var result = "other";
    (0, $8OLOW.each)($828833ea7a7555e4$var$EVENT_SOURCES_REGEX, function(key) {
        if (this.test(type)) {
            result = key;
            return false;
        }
    });
    return result;
};
var $828833ea7a7555e4$export$1d0a87a519049f8c = (e)=>"pointer" === $828833ea7a7555e4$export$e7d04fea5cade03b(e);
var $828833ea7a7555e4$export$764db16956f554f8 = (e)=>$828833ea7a7555e4$var$isNativeMouseEvent(e) || ($828833ea7a7555e4$export$1d0a87a519049f8c(e) || $828833ea7a7555e4$var$isDxEvent(e)) && "mouse" === e.pointerType;
var $828833ea7a7555e4$export$379075400f699289 = (e)=>e && "dxmousewheel" === e.type;
var $828833ea7a7555e4$export$c4dfce035d43d1e0 = (e)=>$828833ea7a7555e4$var$isNativeTouchEvent(e) || ($828833ea7a7555e4$export$1d0a87a519049f8c(e) || $828833ea7a7555e4$var$isDxEvent(e)) && "touch" === e.pointerType;
var $828833ea7a7555e4$export$130b789831072f4c = (e)=>"keyboard" === $828833ea7a7555e4$export$e7d04fea5cade03b(e);
var $828833ea7a7555e4$export$430a1dc914bd769d = (_ref2)=>{
    var { screenX: screenX, offsetX: offsetX, pageX: pageX } = _ref2;
    return 0 === screenX && !offsetX && 0 === pageX;
};
var $828833ea7a7555e4$export$882d6efd8e16e97a = (_ref3)=>{
    var { pageX: pageX, pageY: pageY, timeStamp: timeStamp } = _ref3;
    return {
        x: pageX,
        y: pageY,
        time: timeStamp
    };
};
var $828833ea7a7555e4$export$90751ced8b96ad34 = (from, to)=>({
        x: to.x - from.x,
        y: to.y - from.y,
        time: to.time - from.time || 1
    });
var $828833ea7a7555e4$export$6df5851d4f8a2c38 = (e)=>{
    var { originalEvent: originalEvent, pointers: pointers } = e;
    if ($828833ea7a7555e4$var$isNativeTouchEvent(e)) return (originalEvent.touches || []).length;
    if ($828833ea7a7555e4$var$isDxEvent(e)) return (pointers || []).length;
    return 0;
};
var $828833ea7a7555e4$var$skipEvents = false;
var $828833ea7a7555e4$export$9770cf8ac3db0cd1 = ()=>$828833ea7a7555e4$var$skipEvents = true;
var $828833ea7a7555e4$export$20ad8b0e50439eab = ()=>$828833ea7a7555e4$var$skipEvents = false;
var $828833ea7a7555e4$export$49cacaa9699ab169 = (e)=>{
    if ($828833ea7a7555e4$var$skipEvents) return true;
    var { target: target } = e;
    var $target = (0, $2vlX8.default)(target);
    var isContentEditable = (null === target || void 0 === target ? void 0 : target.isContentEditable) || (null === target || void 0 === target ? void 0 : target.hasAttribute("contenteditable"));
    var touchInEditable = $target.is("input, textarea, select") || isContentEditable;
    if ($828833ea7a7555e4$export$379075400f699289(e)) {
        var isTextArea = $target.is("textarea") && $target.hasClass("dx-texteditor-input");
        if (isTextArea || isContentEditable) return false;
        var isInputFocused = $target.is("input[type='number'], textarea, select") && $target.is(":focus");
        return isInputFocused;
    }
    if ($828833ea7a7555e4$export$764db16956f554f8(e)) return touchInEditable || e.which > 1;
    if ($828833ea7a7555e4$export$c4dfce035d43d1e0(e)) return touchInEditable && (0, $gUEMS.focused)($target);
};
var $828833ea7a7555e4$export$cdec9fb2bce39df7 = (func)=>$828833ea7a7555e4$var$fixMethod = func;
var $828833ea7a7555e4$export$c30017717ce2168e = (originalEvent, args)=>{
    var event = $828833ea7a7555e4$var$copyEvent(originalEvent);
    args && (0, $2oTOp.extend)(event, args);
    return event;
};
var $828833ea7a7555e4$export$43835e9acf248a15 = (props)=>{
    var { originalEvent: originalEvent, delegateTarget: delegateTarget } = props;
    var event = $828833ea7a7555e4$export$c30017717ce2168e(originalEvent, props);
    (0, $60GuF.default).trigger(delegateTarget || event.target, event);
    return event;
};
var $828833ea7a7555e4$export$dfadd96f345d39fc = (_ref4)=>{
    var { key: key, which: which } = _ref4;
    var normalizedKey = $828833ea7a7555e4$var$KEY_MAP[null === key || void 0 === key ? void 0 : key.toLowerCase()] || key;
    var normalizedKeyFromWhich = $828833ea7a7555e4$var$LEGACY_KEY_CODES[which];
    if (normalizedKeyFromWhich && normalizedKey === key) return normalizedKeyFromWhich;
    else if (!normalizedKey && which) return String.fromCharCode(which);
    return normalizedKey;
};
var $828833ea7a7555e4$export$267be9e82be145c = (_ref5)=>{
    var { key: key, which: which } = _ref5;
    return key || String.fromCharCode(which);
};
var $828833ea7a7555e4$export$4d393b9a14b8e6cb = (0, $6IMTb.default);
var $828833ea7a7555e4$export$e87ab1c7dd93fdc3 = (_ref6)=>{
    var { ctrlKey: ctrlKey, metaKey: metaKey } = _ref6;
    return ctrlKey || metaKey;
};

});
parcelRegister("6IMTb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e4cc675dada9dcf$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/events/utils/add_namespace.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $cvYFL = parcelRequire("cvYFL");
var $4e4cc675dada9dcf$var$addNamespace = (eventNames, namespace)=>{
    if (!namespace) throw (0, $cvYFL.default).Error("E0017");
    if (Array.isArray(eventNames)) return eventNames.map((eventName)=>$4e4cc675dada9dcf$var$addNamespace(eventName, namespace)).join(" ");
    if (-1 !== eventNames.indexOf(" ")) return $4e4cc675dada9dcf$var$addNamespace(eventNames.split(/\s+/g), namespace);
    return "".concat(eventNames, ".").concat(namespace);
};
var $4e4cc675dada9dcf$export$2e2bcd8739ae039 = $4e4cc675dada9dcf$var$addNamespace;

});

parcelRegister("gUEMS", function(module, exports) {

$parcel$export(module.exports, "focused", function () { return $c50183d083b5712c$export$4c2b230493b2b322; });
/**
 * DevExtreme (esm/ui/widget/selectors.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $3yzYM = parcelRequire("3yzYM");
var $c50183d083b5712c$var$focusableFn = function(element, tabIndex) {
    if (!$c50183d083b5712c$var$visible(element)) return false;
    var nodeName = element.nodeName.toLowerCase();
    var isTabIndexNotNaN = !isNaN(tabIndex);
    var isDisabled = element.disabled;
    var isDefaultFocus = /^(input|select|textarea|button|object|iframe)$/.test(nodeName);
    var isHyperlink = "a" === nodeName;
    var isFocusable;
    var isContentEditable = element.isContentEditable;
    if (isDefaultFocus || isContentEditable) isFocusable = !isDisabled;
    else if (isHyperlink) isFocusable = element.href || isTabIndexNotNaN;
    else isFocusable = isTabIndexNotNaN;
    return isFocusable;
};
function $c50183d083b5712c$var$visible(element) {
    var $element = (0, $2vlX8.default)(element);
    return $element.is(":visible") && "hidden" !== $element.css("visibility") && "hidden" !== $element.parents().css("visibility");
}
var $c50183d083b5712c$export$ecc6d1fcdff4f700 = function(index, element) {
    return $c50183d083b5712c$var$focusableFn(element, (0, $2vlX8.default)(element).attr("tabIndex"));
};
var $c50183d083b5712c$export$17100aea90429aa7 = function(index, element) {
    var tabIndex = (0, $2vlX8.default)(element).attr("tabIndex");
    return (isNaN(tabIndex) || tabIndex >= 0) && $c50183d083b5712c$var$focusableFn(element, tabIndex);
};
var $c50183d083b5712c$export$4c2b230493b2b322 = function($element) {
    var element = (0, $2vlX8.default)($element).get(0);
    return (0, $3yzYM.default).getActiveElement(element) === element;
};

});




parcelRegister("eVdLz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $add11143ed131ebc$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/events/pointer/mouse.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $1wYF9 = parcelRequire("1wYF9");

var $6ySDI = parcelRequire("6ySDI");
var $add11143ed131ebc$var$eventMap = {
    dxpointerdown: "mousedown",
    dxpointermove: "mousemove",
    dxpointerup: "mouseup",
    dxpointercancel: "",
    dxpointerover: "mouseover",
    dxpointerout: "mouseout",
    dxpointerenter: "mouseenter",
    dxpointerleave: "mouseleave"
};
var $add11143ed131ebc$var$normalizeMouseEvent = function(e) {
    e.pointerId = 1;
    return {
        pointers: $add11143ed131ebc$var$observer.pointers(),
        pointerId: 1
    };
};
var $add11143ed131ebc$var$observer;
var $add11143ed131ebc$var$activated = false;
var $add11143ed131ebc$var$activateStrategy = function() {
    if ($add11143ed131ebc$var$activated) return;
    $add11143ed131ebc$var$observer = new (0, $6ySDI.default)($add11143ed131ebc$var$eventMap, function() {
        return true;
    });
    $add11143ed131ebc$var$activated = true;
};
var $add11143ed131ebc$var$MouseStrategy = (0, $1wYF9.default).inherit({
    ctor: function() {
        this.callBase.apply(this, arguments);
        $add11143ed131ebc$var$activateStrategy();
    },
    _fireEvent: function(args) {
        return this.callBase((0, $2oTOp.extend)($add11143ed131ebc$var$normalizeMouseEvent(args.originalEvent), args));
    }
});
$add11143ed131ebc$var$MouseStrategy.map = $add11143ed131ebc$var$eventMap;
$add11143ed131ebc$var$MouseStrategy.normalize = $add11143ed131ebc$var$normalizeMouseEvent;
$add11143ed131ebc$var$MouseStrategy.activate = $add11143ed131ebc$var$activateStrategy;
$add11143ed131ebc$var$MouseStrategy.resetObserver = function() {
    $add11143ed131ebc$var$observer.reset();
};
var $add11143ed131ebc$export$2e2bcd8739ae039 = $add11143ed131ebc$var$MouseStrategy;

});
parcelRegister("6ySDI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c704d59b26130f6$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/events/pointer/observer.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $8OLOW = parcelRequire("8OLOW");

var $8n1m9 = parcelRequire("8n1m9");

var $3yzYM = parcelRequire("3yzYM");
var $4c704d59b26130f6$var$addEventsListener = function(events, handler) {
    (0, $8n1m9.default).add(function() {
        events.split(" ").forEach(function(event) {
            (0, $3yzYM.default).listen((0, $3yzYM.default).getDocument(), event, handler, true);
        });
    });
};
var $4c704d59b26130f6$var$Observer = function(eventMap, pointerEquals, onPointerAdding) {
    onPointerAdding = onPointerAdding || function() {};
    var pointers = [];
    var getPointerIndex = function(e) {
        var index = -1;
        (0, $8OLOW.each)(pointers, function(i, pointer) {
            if (!pointerEquals(e, pointer)) return true;
            index = i;
            return false;
        });
        return index;
    };
    var removePointer = function(e) {
        var index = getPointerIndex(e);
        if (index > -1) pointers.splice(index, 1);
    };
    $4c704d59b26130f6$var$addEventsListener(eventMap.dxpointerdown, function(e) {
        if (-1 === getPointerIndex(e)) {
            onPointerAdding(e);
            pointers.push(e);
        }
    });
    $4c704d59b26130f6$var$addEventsListener(eventMap.dxpointermove, function(e) {
        pointers[getPointerIndex(e)] = e;
    });
    $4c704d59b26130f6$var$addEventsListener(eventMap.dxpointerup, removePointer);
    $4c704d59b26130f6$var$addEventsListener(eventMap.dxpointercancel, removePointer);
    this.pointers = function() {
        return pointers;
    };
    this.reset = function() {
        pointers = [];
    };
};
var $4c704d59b26130f6$export$2e2bcd8739ae039 = $4c704d59b26130f6$var$Observer;

});


parcelRegister("1ORBP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15340ba0c93b62ac$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/events/pointer/mouse_and_touch.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $1wYF9 = parcelRequire("1wYF9");

var $eVdLz = parcelRequire("eVdLz");

var $kyXK8 = parcelRequire("kyXK8");

var $bcOMe = parcelRequire("bcOMe");
var $15340ba0c93b62ac$var$eventMap = {
    dxpointerdown: "touchstart mousedown",
    dxpointermove: "touchmove mousemove",
    dxpointerup: "touchend mouseup",
    dxpointercancel: "touchcancel",
    dxpointerover: "mouseover",
    dxpointerout: "mouseout",
    dxpointerenter: "mouseenter",
    dxpointerleave: "mouseleave"
};
var $15340ba0c93b62ac$var$activated = false;
var $15340ba0c93b62ac$var$activateStrategy = function() {
    if ($15340ba0c93b62ac$var$activated) return;
    (0, $eVdLz.default).activate();
    $15340ba0c93b62ac$var$activated = true;
};
var $15340ba0c93b62ac$var$MouseAndTouchStrategy = (0, $1wYF9.default).inherit({
    EVENT_LOCK_TIMEOUT: 100,
    ctor: function() {
        this.callBase.apply(this, arguments);
        $15340ba0c93b62ac$var$activateStrategy();
    },
    _handler: function(e) {
        var isMouse = (0, $bcOMe.isMouseEvent)(e);
        if (!isMouse) this._skipNextEvents = true;
        if (isMouse && this._mouseLocked) return;
        if (isMouse && this._skipNextEvents) {
            this._skipNextEvents = false;
            this._mouseLocked = true;
            clearTimeout(this._unlockMouseTimer);
            var that = this;
            this._unlockMouseTimer = setTimeout(function() {
                that._mouseLocked = false;
            }, this.EVENT_LOCK_TIMEOUT);
            return;
        }
        return this.callBase(e);
    },
    _fireEvent: function(args) {
        var normalizer = (0, $bcOMe.isMouseEvent)(args.originalEvent) ? (0, $eVdLz.default).normalize : (0, $kyXK8.default).normalize;
        return this.callBase((0, $2oTOp.extend)(normalizer(args.originalEvent), args));
    },
    dispose: function() {
        this.callBase();
        this._skipNextEvents = false;
        this._mouseLocked = false;
        clearTimeout(this._unlockMouseTimer);
    }
});
$15340ba0c93b62ac$var$MouseAndTouchStrategy.map = $15340ba0c93b62ac$var$eventMap;
$15340ba0c93b62ac$var$MouseAndTouchStrategy.resetObserver = (0, $eVdLz.default).resetObserver;
var $15340ba0c93b62ac$export$2e2bcd8739ae039 = $15340ba0c93b62ac$var$MouseAndTouchStrategy;

});


parcelRegister("bTgwK", function(module, exports) {

$parcel$export(module.exports, "start", function () { return $8a81a6bc6b0688af$export$b3571188c770cc5a; });
$parcel$export(module.exports, "move", function () { return $8a81a6bc6b0688af$export$d947e5f4f4c48d48; });
$parcel$export(module.exports, "end", function () { return $8a81a6bc6b0688af$export$bd5df0f255a350f8; });
/**
 * DevExtreme (esm/events/drag.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $jc4XS = parcelRequire("jc4XS");

var $d64MP = parcelRequire("d64MP");

var $8OLOW = parcelRequire("8OLOW");

var $g3YTP = parcelRequire("g3YTP");

var $jxLje = parcelRequire("jxLje");

var $bcOMe = parcelRequire("bcOMe");

var $3pQaG = parcelRequire("3pQaG");

var $gIBa7 = parcelRequire("gIBa7");
var $8a81a6bc6b0688af$export$b3571188c770cc5a = "dxdragstart";
var $8a81a6bc6b0688af$export$d947e5f4f4c48d48 = "dxdrag";
var $8a81a6bc6b0688af$export$bd5df0f255a350f8 = "dxdragend";
var $8a81a6bc6b0688af$export$e668df1bcd81e4d2 = "dxdragenter";
var $8a81a6bc6b0688af$export$33993f1ec7a2167a = "dxdragleave";
var $8a81a6bc6b0688af$export$663103110d94aac9 = "dxdrop";
var $8a81a6bc6b0688af$var$DX_DRAG_EVENTS_COUNT_KEY = "dxDragEventsCount";
var $8a81a6bc6b0688af$var$knownDropTargets = [];
var $8a81a6bc6b0688af$var$knownDropTargetSelectors = [];
var $8a81a6bc6b0688af$var$knownDropTargetConfigs = [];
var $8a81a6bc6b0688af$var$dropTargetRegistration = {
    setup: function(element, data) {
        var knownDropTarget = $8a81a6bc6b0688af$var$knownDropTargets.includes(element);
        if (!knownDropTarget) {
            $8a81a6bc6b0688af$var$knownDropTargets.push(element);
            $8a81a6bc6b0688af$var$knownDropTargetSelectors.push([]);
            $8a81a6bc6b0688af$var$knownDropTargetConfigs.push(data || {});
        }
    },
    add: function(element, handleObj) {
        var index = $8a81a6bc6b0688af$var$knownDropTargets.indexOf(element);
        this.updateEventsCounter(element, handleObj.type, 1);
        var selector = handleObj.selector;
        if (!$8a81a6bc6b0688af$var$knownDropTargetSelectors[index].includes(selector)) $8a81a6bc6b0688af$var$knownDropTargetSelectors[index].push(selector);
    },
    updateEventsCounter: function(element, event, value) {
        if ([
            $8a81a6bc6b0688af$export$e668df1bcd81e4d2,
            $8a81a6bc6b0688af$export$33993f1ec7a2167a,
            $8a81a6bc6b0688af$export$663103110d94aac9
        ].indexOf(event) > -1) {
            var eventsCount = (0, $jc4XS.data)(element, $8a81a6bc6b0688af$var$DX_DRAG_EVENTS_COUNT_KEY) || 0;
            (0, $jc4XS.data)(element, $8a81a6bc6b0688af$var$DX_DRAG_EVENTS_COUNT_KEY, Math.max(0, eventsCount + value));
        }
    },
    remove: function(element, handleObj) {
        this.updateEventsCounter(element, handleObj.type, -1);
    },
    teardown: function(element) {
        var handlersCount = (0, $jc4XS.data)(element, $8a81a6bc6b0688af$var$DX_DRAG_EVENTS_COUNT_KEY);
        if (!handlersCount) {
            var index = $8a81a6bc6b0688af$var$knownDropTargets.indexOf(element);
            $8a81a6bc6b0688af$var$knownDropTargets.splice(index, 1);
            $8a81a6bc6b0688af$var$knownDropTargetSelectors.splice(index, 1);
            $8a81a6bc6b0688af$var$knownDropTargetConfigs.splice(index, 1);
            (0, $jc4XS.removeData)(element, $8a81a6bc6b0688af$var$DX_DRAG_EVENTS_COUNT_KEY);
        }
    }
};
(0, $jxLje.default)($8a81a6bc6b0688af$export$e668df1bcd81e4d2, $8a81a6bc6b0688af$var$dropTargetRegistration);
(0, $jxLje.default)($8a81a6bc6b0688af$export$33993f1ec7a2167a, $8a81a6bc6b0688af$var$dropTargetRegistration);
(0, $jxLje.default)($8a81a6bc6b0688af$export$663103110d94aac9, $8a81a6bc6b0688af$var$dropTargetRegistration);
var $8a81a6bc6b0688af$var$getItemDelegatedTargets = function($element) {
    var dropTargetIndex = $8a81a6bc6b0688af$var$knownDropTargets.indexOf($element.get(0));
    var dropTargetSelectors = $8a81a6bc6b0688af$var$knownDropTargetSelectors[dropTargetIndex].filter((selector)=>selector);
    var $delegatedTargets = $element.find(dropTargetSelectors.join(", "));
    if ($8a81a6bc6b0688af$var$knownDropTargetSelectors[dropTargetIndex].includes(void 0)) $delegatedTargets = $delegatedTargets.add($element);
    return $delegatedTargets;
};
var $8a81a6bc6b0688af$var$getItemConfig = function($element) {
    var dropTargetIndex = $8a81a6bc6b0688af$var$knownDropTargets.indexOf($element.get(0));
    return $8a81a6bc6b0688af$var$knownDropTargetConfigs[dropTargetIndex];
};
var $8a81a6bc6b0688af$var$getItemPosition = function(dropTargetConfig, $element) {
    if (dropTargetConfig.itemPositionFunc) return dropTargetConfig.itemPositionFunc($element);
    else return $element.offset();
};
var $8a81a6bc6b0688af$var$getItemSize = function(dropTargetConfig, $element) {
    if (dropTargetConfig.itemSizeFunc) return dropTargetConfig.itemSizeFunc($element);
    return {
        width: $element.get(0).getBoundingClientRect().width,
        height: $element.get(0).getBoundingClientRect().height
    };
};
var $8a81a6bc6b0688af$var$DragEmitter = (0, $3pQaG.default).inherit({
    ctor: function(element) {
        this.callBase(element);
        this.direction = "both";
    },
    _init: function(e) {
        this._initEvent = e;
    },
    _start: function(e) {
        e = this._fireEvent($8a81a6bc6b0688af$export$b3571188c770cc5a, this._initEvent);
        this._maxLeftOffset = e.maxLeftOffset;
        this._maxRightOffset = e.maxRightOffset;
        this._maxTopOffset = e.maxTopOffset;
        this._maxBottomOffset = e.maxBottomOffset;
        if (e.targetElements || null === e.targetElements) {
            var dropTargets = (0, $d64MP.wrapToArray)(e.targetElements || []);
            this._dropTargets = $8OLOW.map(dropTargets, function(element) {
                return (0, $2vlX8.default)(element).get(0);
            });
        } else this._dropTargets = $8a81a6bc6b0688af$var$knownDropTargets;
    },
    _move: function(e) {
        var eventData = (0, $bcOMe.eventData)(e);
        var dragOffset = this._calculateOffset(eventData);
        e = this._fireEvent($8a81a6bc6b0688af$export$d947e5f4f4c48d48, e, {
            offset: dragOffset
        });
        this._processDropTargets(e);
        if (!e._cancelPreventDefault) e.preventDefault();
    },
    _calculateOffset: function(eventData) {
        return {
            x: this._calculateXOffset(eventData),
            y: this._calculateYOffset(eventData)
        };
    },
    _calculateXOffset: function(eventData) {
        if ("vertical" !== this.direction) {
            var offset = eventData.x - this._startEventData.x;
            return this._fitOffset(offset, this._maxLeftOffset, this._maxRightOffset);
        }
        return 0;
    },
    _calculateYOffset: function(eventData) {
        if ("horizontal" !== this.direction) {
            var offset = eventData.y - this._startEventData.y;
            return this._fitOffset(offset, this._maxTopOffset, this._maxBottomOffset);
        }
        return 0;
    },
    _fitOffset: function(offset, minOffset, maxOffset) {
        if (null != minOffset) offset = Math.max(offset, -minOffset);
        if (null != maxOffset) offset = Math.min(offset, maxOffset);
        return offset;
    },
    _processDropTargets: function(e) {
        var target = this._findDropTarget(e);
        var sameTarget = target === this._currentDropTarget;
        if (!sameTarget) {
            this._fireDropTargetEvent(e, $8a81a6bc6b0688af$export$33993f1ec7a2167a);
            this._currentDropTarget = target;
            this._fireDropTargetEvent(e, $8a81a6bc6b0688af$export$e668df1bcd81e4d2);
        }
    },
    _fireDropTargetEvent: function(event, eventName) {
        if (!this._currentDropTarget) return;
        var eventData = {
            type: eventName,
            originalEvent: event,
            draggingElement: this._$element.get(0),
            target: this._currentDropTarget
        };
        (0, $bcOMe.fireEvent)(eventData);
    },
    _findDropTarget: function(e) {
        var that = this;
        var result;
        $8OLOW.each($8a81a6bc6b0688af$var$knownDropTargets, function(_, target) {
            if (!that._checkDropTargetActive(target)) return;
            var $target = (0, $2vlX8.default)(target);
            $8OLOW.each($8a81a6bc6b0688af$var$getItemDelegatedTargets($target), function(_, delegatedTarget) {
                var $delegatedTarget = (0, $2vlX8.default)(delegatedTarget);
                if (that._checkDropTarget($8a81a6bc6b0688af$var$getItemConfig($target), $delegatedTarget, (0, $2vlX8.default)(result), e)) result = delegatedTarget;
            });
        });
        return result;
    },
    _checkDropTargetActive: function(target) {
        var active = false;
        $8OLOW.each(this._dropTargets, function(_, activeTarget) {
            active = active || activeTarget === target || (0, $g3YTP.contains)(activeTarget, target);
            return !active;
        });
        return active;
    },
    _checkDropTarget: function(config, $target, $prevTarget, e) {
        var isDraggingElement = $target.get(0) === (0, $2vlX8.default)(e.target).get(0);
        if (isDraggingElement) return false;
        var targetPosition = $8a81a6bc6b0688af$var$getItemPosition(config, $target);
        if (e.pageX < targetPosition.left) return false;
        if (e.pageY < targetPosition.top) return false;
        var targetSize = $8a81a6bc6b0688af$var$getItemSize(config, $target);
        if (e.pageX > targetPosition.left + targetSize.width) return false;
        if (e.pageY > targetPosition.top + targetSize.height) return false;
        if ($prevTarget.length && $prevTarget.closest($target).length) return false;
        if (config.checkDropTarget && !config.checkDropTarget($target, e)) return false;
        return $target;
    },
    _end: function(e) {
        var eventData = (0, $bcOMe.eventData)(e);
        this._fireEvent($8a81a6bc6b0688af$export$bd5df0f255a350f8, e, {
            offset: this._calculateOffset(eventData)
        });
        this._fireDropTargetEvent(e, $8a81a6bc6b0688af$export$663103110d94aac9);
        delete this._currentDropTarget;
    }
});
(0, $gIBa7.default)({
    emitter: $8a81a6bc6b0688af$var$DragEmitter,
    events: [
        $8a81a6bc6b0688af$export$b3571188c770cc5a,
        $8a81a6bc6b0688af$export$d947e5f4f4c48d48,
        $8a81a6bc6b0688af$export$bd5df0f255a350f8
    ]
});

});
parcelRegister("d64MP", function(module, exports) {

$parcel$export(module.exports, "wrapToArray", function () { return $988f8c6314b33830$export$210ae1b469bb1ff9; });
$parcel$export(module.exports, "groupBy", function () { return $988f8c6314b33830$export$3f063810d7bf01bd; });
/**
 * DevExtreme (esm/core/utils/array.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $5VpUx = parcelRequire("5VpUx");

var $8IERv = parcelRequire("8IERv");
function $988f8c6314b33830$var$createOccurrenceMap(array) {
    return array.reduce((map, value)=>{
        var _map$get;
        var count = (null !== (_map$get = map.get(value)) && void 0 !== _map$get ? _map$get : 0) + 1;
        map.set(value, count);
        return map;
    }, new Map);
}
var $988f8c6314b33830$export$210ae1b469bb1ff9 = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
var $988f8c6314b33830$export$d579bc26e95946b5 = function(values) {
    return [
        ...new Set(values)
    ];
};
var $988f8c6314b33830$export$72209efa88586d42 = function(firstArray, secondArray) {
    var toRemoveMap = $988f8c6314b33830$var$createOccurrenceMap(secondArray);
    return firstArray.filter((value)=>{
        var occurrencesCount = toRemoveMap.get(value);
        occurrencesCount && toRemoveMap.set(value, occurrencesCount - 1);
        return occurrencesCount;
    });
};
var $988f8c6314b33830$export$2e2262a44ac61957 = function() {
    var from = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
    var toRemove = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
    var toRemoveMap = $988f8c6314b33830$var$createOccurrenceMap(toRemove);
    return from.filter((value)=>{
        var occurrencesCount = toRemoveMap.get(value);
        occurrencesCount && toRemoveMap.set(value, occurrencesCount - 1);
        return !occurrencesCount;
    });
};
var $988f8c6314b33830$export$e9607c52c6889017 = function(items, indexPropName, currentItem, needIndexCallback) {
    var indexedItems = {};
    var { useLegacyVisibleIndex: useLegacyVisibleIndex } = (0, $8IERv.default)();
    var currentIndex = 0;
    var shouldUpdateIndex = (item)=>!(0, $6ntMu.isDefined)(item[indexPropName]) && (!needIndexCallback || needIndexCallback(item));
    items.forEach((item)=>{
        var index = item[indexPropName];
        if (index >= 0) {
            indexedItems[index] = indexedItems[index] || [];
            if (item === currentItem) indexedItems[index].unshift(item);
            else indexedItems[index].push(item);
        } else item[indexPropName] = void 0;
    });
    if (!useLegacyVisibleIndex) items.forEach((item)=>{
        if (shouldUpdateIndex(item)) {
            while(indexedItems[currentIndex])currentIndex++;
            indexedItems[currentIndex] = [
                item
            ];
            currentIndex++;
        }
    });
    currentIndex = 0;
    (0, $5VpUx.orderEach)(indexedItems, function(index, items) {
        items.forEach((item)=>{
            if (index >= 0) item[indexPropName] = currentIndex++;
        });
    });
    if (useLegacyVisibleIndex) items.forEach((item)=>{
        if (shouldUpdateIndex(item)) item[indexPropName] = currentIndex++;
    });
};
var $988f8c6314b33830$export$3f063810d7bf01bd = (array, getGroupName)=>array.reduce((groupedResult, item)=>{
        var _groupedResult$groupN;
        var groupName = getGroupName(item);
        groupedResult[groupName] = null !== (_groupedResult$groupN = groupedResult[groupName]) && void 0 !== _groupedResult$groupN ? _groupedResult$groupN : [];
        groupedResult[groupName].push(item);
        return groupedResult;
    }, {});

});

parcelRegister("3pQaG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27cc2d0a65eb8758$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/events/gesture/emitter.gesture.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $60GuF = parcelRequire("60GuF");

var $jF0bZ = parcelRequire("jF0bZ");

var $4jWiu = parcelRequire("4jWiu");

var $k2ifc = parcelRequire("k2ifc");

var $g3YTP = parcelRequire("g3YTP");

var $8n1m9 = parcelRequire("8n1m9");

var $laqiS = parcelRequire("laqiS");

var $gcp4g = parcelRequire("gcp4g");

var $6ntMu = parcelRequire("6ntMu");

var $bcOMe = parcelRequire("bcOMe");

var $1xoTt = parcelRequire("1xoTt");
var $27cc2d0a65eb8758$var$ready = (0, $8n1m9.default).add;
var $27cc2d0a65eb8758$var$abs = Math.abs;
var $27cc2d0a65eb8758$var$SLEEP = 0;
var $27cc2d0a65eb8758$var$INITED = 1;
var $27cc2d0a65eb8758$var$STARTED = 2;
var $27cc2d0a65eb8758$var$TOUCH_BOUNDARY = 10;
var $27cc2d0a65eb8758$var$IMMEDIATE_TOUCH_BOUNDARY = 0;
var $27cc2d0a65eb8758$var$IMMEDIATE_TIMEOUT = 180;
var $27cc2d0a65eb8758$var$supportPointerEvents = function() {
    return (0, $4jWiu.styleProp)("pointer-events");
};
var $27cc2d0a65eb8758$var$setGestureCover = (0, $k2ifc.default)(function() {
    var isDesktop = "desktop" === (0, $jF0bZ.default).real().deviceType;
    if (!$27cc2d0a65eb8758$var$supportPointerEvents() || !isDesktop) return 0, $gcp4g.noop;
    var $cover = (0, $2vlX8.default)("<div>").addClass("dx-gesture-cover").css("pointerEvents", "none");
    (0, $60GuF.default).subscribeGlobal($cover, "dxmousewheel", function(e) {
        e.preventDefault();
    });
    $27cc2d0a65eb8758$var$ready(function() {
        $cover.appendTo("body");
    });
    return function(toggle, cursor) {
        $cover.css("pointerEvents", toggle ? "all" : "none");
        toggle && $cover.css("cursor", cursor);
    };
});
var $27cc2d0a65eb8758$var$gestureCover = function(toggle, cursor) {
    var gestureCoverStrategy = $27cc2d0a65eb8758$var$setGestureCover();
    gestureCoverStrategy(toggle, cursor);
};
var $27cc2d0a65eb8758$var$GestureEmitter = (0, $1xoTt.default).inherit({
    gesture: true,
    configure: function(data) {
        this.getElement().css("msTouchAction", data.immediate ? "pinch-zoom" : "");
        this.callBase(data);
    },
    allowInterruptionByMouseWheel: function() {
        return this._stage !== $27cc2d0a65eb8758$var$STARTED;
    },
    getDirection: function() {
        return this.direction;
    },
    _cancel: function() {
        this.callBase.apply(this, arguments);
        this._toggleGestureCover(false);
        this._stage = $27cc2d0a65eb8758$var$SLEEP;
    },
    start: function(e) {
        if (e._needSkipEvent || (0, $bcOMe.needSkipEvent)(e)) {
            this._cancel(e);
            return;
        }
        this._startEvent = (0, $bcOMe.createEvent)(e);
        this._startEventData = (0, $bcOMe.eventData)(e);
        this._stage = $27cc2d0a65eb8758$var$INITED;
        this._init(e);
        this._setupImmediateTimer();
    },
    _setupImmediateTimer: function() {
        var _this$immediateTimeou;
        clearTimeout(this._immediateTimer);
        this._immediateAccepted = false;
        if (!this.immediate) return;
        if (0 === this.immediateTimeout) {
            this._immediateAccepted = true;
            return;
        }
        this._immediateTimer = setTimeout((function() {
            this._immediateAccepted = true;
        }).bind(this), null !== (_this$immediateTimeou = this.immediateTimeout) && void 0 !== _this$immediateTimeou ? _this$immediateTimeou : $27cc2d0a65eb8758$var$IMMEDIATE_TIMEOUT);
    },
    move: function(e) {
        if (this._stage === $27cc2d0a65eb8758$var$INITED && this._directionConfirmed(e)) {
            this._stage = $27cc2d0a65eb8758$var$STARTED;
            this._resetActiveElement();
            this._toggleGestureCover(true);
            this._clearSelection(e);
            this._adjustStartEvent(e);
            this._start(this._startEvent);
            if (this._stage === $27cc2d0a65eb8758$var$SLEEP) return;
            this._requestAccept(e);
            this._move(e);
            this._forgetAccept();
        } else if (this._stage === $27cc2d0a65eb8758$var$STARTED) {
            this._clearSelection(e);
            this._move(e);
        }
    },
    _directionConfirmed: function(e) {
        var touchBoundary = this._getTouchBoundary(e);
        var delta = (0, $bcOMe.eventDelta)(this._startEventData, (0, $bcOMe.eventData)(e));
        var deltaX = $27cc2d0a65eb8758$var$abs(delta.x);
        var deltaY = $27cc2d0a65eb8758$var$abs(delta.y);
        var horizontalMove = this._validateMove(touchBoundary, deltaX, deltaY);
        var verticalMove = this._validateMove(touchBoundary, deltaY, deltaX);
        var direction = this.getDirection(e);
        var bothAccepted = "both" === direction && (horizontalMove || verticalMove);
        var horizontalAccepted = "horizontal" === direction && horizontalMove;
        var verticalAccepted = "vertical" === direction && verticalMove;
        return bothAccepted || horizontalAccepted || verticalAccepted || this._immediateAccepted;
    },
    _validateMove: function(touchBoundary, mainAxis, crossAxis) {
        return mainAxis && mainAxis >= touchBoundary && (this.immediate ? mainAxis >= crossAxis : true);
    },
    _getTouchBoundary: function(e) {
        return this.immediate || (0, $bcOMe.isDxMouseWheelEvent)(e) ? $27cc2d0a65eb8758$var$IMMEDIATE_TOUCH_BOUNDARY : $27cc2d0a65eb8758$var$TOUCH_BOUNDARY;
    },
    _adjustStartEvent: function(e) {
        var touchBoundary = this._getTouchBoundary(e);
        var delta = (0, $bcOMe.eventDelta)(this._startEventData, (0, $bcOMe.eventData)(e));
        this._startEvent.pageX += (0, $laqiS.sign)(delta.x) * touchBoundary;
        this._startEvent.pageY += (0, $laqiS.sign)(delta.y) * touchBoundary;
    },
    _resetActiveElement: function() {
        if ("ios" === (0, $jF0bZ.default).real().platform && this.getElement().find(":focus").length) (0, $g3YTP.resetActiveElement)();
    },
    _toggleGestureCover: function(toggle) {
        this._toggleGestureCoverImpl(toggle);
    },
    _toggleGestureCoverImpl: function(toggle) {
        var isStarted = this._stage === $27cc2d0a65eb8758$var$STARTED;
        if (isStarted) $27cc2d0a65eb8758$var$gestureCover(toggle, this.getElement().css("cursor"));
    },
    _clearSelection: function(e) {
        if ((0, $bcOMe.isDxMouseWheelEvent)(e) || (0, $bcOMe.isTouchEvent)(e)) return;
        (0, $g3YTP.clearSelection)();
    },
    end: function(e) {
        this._toggleGestureCover(false);
        if (this._stage === $27cc2d0a65eb8758$var$STARTED) this._end(e);
        else if (this._stage === $27cc2d0a65eb8758$var$INITED) this._stop(e);
        this._stage = $27cc2d0a65eb8758$var$SLEEP;
    },
    dispose: function() {
        clearTimeout(this._immediateTimer);
        this.callBase.apply(this, arguments);
        this._toggleGestureCover(false);
    },
    _init: (0, $gcp4g.noop),
    _start: (0, $gcp4g.noop),
    _move: (0, $gcp4g.noop),
    _stop: (0, $gcp4g.noop),
    _end: (0, $gcp4g.noop)
});
$27cc2d0a65eb8758$var$GestureEmitter.initialTouchBoundary = $27cc2d0a65eb8758$var$TOUCH_BOUNDARY;
$27cc2d0a65eb8758$var$GestureEmitter.touchBoundary = function(newBoundary) {
    if ((0, $6ntMu.isDefined)(newBoundary)) {
        $27cc2d0a65eb8758$var$TOUCH_BOUNDARY = newBoundary;
        return;
    }
    return $27cc2d0a65eb8758$var$TOUCH_BOUNDARY;
};
var $27cc2d0a65eb8758$export$2e2bcd8739ae039 = $27cc2d0a65eb8758$var$GestureEmitter;

});
parcelRegister("1xoTt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11ec2edef32de456$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/events/core/emitter.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $gcp4g = parcelRequire("gcp4g");

var $a2g7x = parcelRequire("a2g7x");

var $dYDfV = parcelRequire("dYDfV");

var $2oTOp = parcelRequire("2oTOp");

var $bcOMe = parcelRequire("bcOMe");
var $11ec2edef32de456$var$Emitter = (0, $a2g7x.default).inherit({
    ctor: function(element) {
        this._$element = (0, $2vlX8.default)(element);
        this._cancelCallback = (0, $dYDfV.default)();
        this._acceptCallback = (0, $dYDfV.default)();
    },
    getElement: function() {
        return this._$element;
    },
    validate: function(e) {
        return !(0, $bcOMe.isDxMouseWheelEvent)(e);
    },
    validatePointers: function(e) {
        return 1 === (0, $bcOMe.hasTouches)(e);
    },
    allowInterruptionByMouseWheel: function() {
        return true;
    },
    configure: function(data) {
        (0, $2oTOp.extend)(this, data);
    },
    addCancelCallback: function(callback) {
        this._cancelCallback.add(callback);
    },
    removeCancelCallback: function() {
        this._cancelCallback.empty();
    },
    _cancel: function(e) {
        this._cancelCallback.fire(this, e);
    },
    addAcceptCallback: function(callback) {
        this._acceptCallback.add(callback);
    },
    removeAcceptCallback: function() {
        this._acceptCallback.empty();
    },
    _accept: function(e) {
        this._acceptCallback.fire(this, e);
    },
    _requestAccept: function(e) {
        this._acceptRequestEvent = e;
    },
    _forgetAccept: function() {
        this._accept(this._acceptRequestEvent);
        this._acceptRequestEvent = null;
    },
    start: (0, $gcp4g.noop),
    move: (0, $gcp4g.noop),
    end: (0, $gcp4g.noop),
    cancel: (0, $gcp4g.noop),
    reset: function() {
        if (this._acceptRequestEvent) this._accept(this._acceptRequestEvent);
    },
    _fireEvent: function(eventName, e, params) {
        var eventData = (0, $2oTOp.extend)({
            type: eventName,
            originalEvent: e,
            target: this._getEmitterTarget(e),
            delegateTarget: this.getElement().get(0)
        }, params);
        e = (0, $bcOMe.fireEvent)(eventData);
        if (e.cancel) this._cancel(e);
        return e;
    },
    _getEmitterTarget: function(e) {
        return (this.delegateSelector ? (0, $2vlX8.default)(e.target).closest(this.delegateSelector) : this.getElement()).get(0);
    },
    dispose: (0, $gcp4g.noop)
});
var $11ec2edef32de456$export$2e2bcd8739ae039 = $11ec2edef32de456$var$Emitter;

});


parcelRegister("gIBa7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2bd95100e01a7d4$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/events/core/emitter_registrator.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $8n1m9 = parcelRequire("8n1m9");

var $3yzYM = parcelRequire("3yzYM");

var $60GuF = parcelRequire("60GuF");

var $jc4XS = parcelRequire("jc4XS");

var $a2g7x = parcelRequire("a2g7x");

var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $jxLje = parcelRequire("jxLje");

var $bcOMe = parcelRequire("bcOMe");

var $cgnQR = parcelRequire("cgnQR");

var $fFYtV = parcelRequire("fFYtV");
var $c2bd95100e01a7d4$var$MANAGER_EVENT = "dxEventManager";
var $c2bd95100e01a7d4$var$EMITTER_DATA = "dxEmitter";
var $c2bd95100e01a7d4$var$EventManager = (0, $a2g7x.default).inherit({
    ctor: function() {
        this._attachHandlers();
        this.reset();
        this._proxiedCancelHandler = this._cancelHandler.bind(this);
        this._proxiedAcceptHandler = this._acceptHandler.bind(this);
    },
    _attachHandlers: function() {
        (0, $8n1m9.default).add((function() {
            var document = (0, $3yzYM.default).getDocument();
            (0, $60GuF.default).subscribeGlobal(document, (0, $bcOMe.addNamespace)((0, $cgnQR.default).down, $c2bd95100e01a7d4$var$MANAGER_EVENT), this._pointerDownHandler.bind(this));
            (0, $60GuF.default).subscribeGlobal(document, (0, $bcOMe.addNamespace)((0, $cgnQR.default).move, $c2bd95100e01a7d4$var$MANAGER_EVENT), this._pointerMoveHandler.bind(this));
            (0, $60GuF.default).subscribeGlobal(document, (0, $bcOMe.addNamespace)([
                (0, $cgnQR.default).up,
                (0, $cgnQR.default).cancel
            ].join(" "), $c2bd95100e01a7d4$var$MANAGER_EVENT), this._pointerUpHandler.bind(this));
            (0, $60GuF.default).subscribeGlobal(document, (0, $bcOMe.addNamespace)((0, $fFYtV.name), $c2bd95100e01a7d4$var$MANAGER_EVENT), this._mouseWheelHandler.bind(this));
        }).bind(this));
    },
    _eachEmitter: function(callback) {
        var activeEmitters = this._activeEmitters || [];
        var i = 0;
        while(activeEmitters.length > i){
            var emitter = activeEmitters[i];
            if (false === callback(emitter)) break;
            if (activeEmitters[i] === emitter) i++;
        }
    },
    _applyToEmitters: function(method, arg) {
        this._eachEmitter(function(emitter) {
            emitter[method].call(emitter, arg);
        });
    },
    reset: function() {
        this._eachEmitter(this._proxiedCancelHandler);
        this._activeEmitters = [];
    },
    resetEmitter: function(emitter) {
        this._proxiedCancelHandler(emitter);
    },
    _pointerDownHandler: function(e) {
        if ((0, $bcOMe.isMouseEvent)(e) && e.which > 1) return;
        this._updateEmitters(e);
    },
    _updateEmitters: function(e) {
        if (!this._isSetChanged(e)) return;
        this._cleanEmitters(e);
        this._fetchEmitters(e);
    },
    _isSetChanged: function(e) {
        var currentSet = this._closestEmitter(e);
        var previousSet = this._emittersSet || [];
        var setChanged = currentSet.length !== previousSet.length;
        (0, $8OLOW.each)(currentSet, function(index, emitter) {
            setChanged = setChanged || previousSet[index] !== emitter;
            return !setChanged;
        });
        this._emittersSet = currentSet;
        return setChanged;
    },
    _closestEmitter: function(e) {
        var that = this;
        var result = [];
        var $element = (0, $2vlX8.default)(e.target);
        function handleEmitter(_, emitter) {
            if (!!emitter && emitter.validatePointers(e) && emitter.validate(e)) {
                emitter.addCancelCallback(that._proxiedCancelHandler);
                emitter.addAcceptCallback(that._proxiedAcceptHandler);
                result.push(emitter);
            }
        }
        while($element.length){
            var emitters = (0, $jc4XS.data)($element.get(0), $c2bd95100e01a7d4$var$EMITTER_DATA) || [];
            (0, $8OLOW.each)(emitters, handleEmitter);
            $element = $element.parent();
        }
        return result;
    },
    _acceptHandler: function(acceptedEmitter, e) {
        var that = this;
        this._eachEmitter(function(emitter) {
            if (emitter !== acceptedEmitter) that._cancelEmitter(emitter, e);
        });
    },
    _cancelHandler: function(canceledEmitter, e) {
        this._cancelEmitter(canceledEmitter, e);
    },
    _cancelEmitter: function(emitter, e) {
        var activeEmitters = this._activeEmitters;
        if (e) emitter.cancel(e);
        else emitter.reset();
        emitter.removeCancelCallback();
        emitter.removeAcceptCallback();
        var emitterIndex = activeEmitters.indexOf(emitter);
        if (emitterIndex > -1) activeEmitters.splice(emitterIndex, 1);
    },
    _cleanEmitters: function(e) {
        this._applyToEmitters("end", e);
        this.reset(e);
    },
    _fetchEmitters: function(e) {
        this._activeEmitters = this._emittersSet.slice();
        this._applyToEmitters("start", e);
    },
    _pointerMoveHandler: function(e) {
        this._applyToEmitters("move", e);
    },
    _pointerUpHandler: function(e) {
        this._updateEmitters(e);
    },
    _mouseWheelHandler: function(e) {
        if (!this._allowInterruptionByMouseWheel()) return;
        e.pointers = [
            null
        ];
        this._pointerDownHandler(e);
        this._adjustWheelEvent(e);
        this._pointerMoveHandler(e);
        e.pointers = [];
        this._pointerUpHandler(e);
    },
    _allowInterruptionByMouseWheel: function() {
        var allowInterruption = true;
        this._eachEmitter(function(emitter) {
            allowInterruption = emitter.allowInterruptionByMouseWheel() && allowInterruption;
            return allowInterruption;
        });
        return allowInterruption;
    },
    _adjustWheelEvent: function(e) {
        var closestGestureEmitter = null;
        this._eachEmitter(function(emitter) {
            if (!emitter.gesture) return;
            var direction = emitter.getDirection(e);
            if ("horizontal" !== direction && !e.shiftKey || "vertical" !== direction && e.shiftKey) {
                closestGestureEmitter = emitter;
                return false;
            }
        });
        if (!closestGestureEmitter) return;
        var direction = closestGestureEmitter.getDirection(e);
        var verticalGestureDirection = "both" === direction && !e.shiftKey || "vertical" === direction;
        var prop = verticalGestureDirection ? "pageY" : "pageX";
        e[prop] += e.delta;
    },
    isActive: function(element) {
        var result = false;
        this._eachEmitter(function(emitter) {
            result = result || emitter.getElement().is(element);
        });
        return result;
    }
});
var $c2bd95100e01a7d4$var$eventManager = new $c2bd95100e01a7d4$var$EventManager;
var $c2bd95100e01a7d4$var$EMITTER_SUBSCRIPTION_DATA = "dxEmitterSubscription";
var $c2bd95100e01a7d4$var$registerEmitter = function(emitterConfig) {
    var emitterClass = emitterConfig.emitter;
    var emitterName = emitterConfig.events[0];
    var emitterEvents = emitterConfig.events;
    (0, $8OLOW.each)(emitterEvents, function(_, eventName) {
        (0, $jxLje.default)(eventName, {
            noBubble: !emitterConfig.bubble,
            setup: function(element) {
                var subscriptions = (0, $jc4XS.data)(element, $c2bd95100e01a7d4$var$EMITTER_SUBSCRIPTION_DATA) || {};
                var emitters = (0, $jc4XS.data)(element, $c2bd95100e01a7d4$var$EMITTER_DATA) || {};
                var emitter = emitters[emitterName] || new emitterClass(element);
                subscriptions[eventName] = true;
                emitters[emitterName] = emitter;
                (0, $jc4XS.data)(element, $c2bd95100e01a7d4$var$EMITTER_DATA, emitters);
                (0, $jc4XS.data)(element, $c2bd95100e01a7d4$var$EMITTER_SUBSCRIPTION_DATA, subscriptions);
            },
            add: function(element, handleObj) {
                var emitters = (0, $jc4XS.data)(element, $c2bd95100e01a7d4$var$EMITTER_DATA);
                var emitter = emitters[emitterName];
                emitter.configure((0, $2oTOp.extend)({
                    delegateSelector: handleObj.selector
                }, handleObj.data), handleObj.type);
            },
            teardown: function(element) {
                var subscriptions = (0, $jc4XS.data)(element, $c2bd95100e01a7d4$var$EMITTER_SUBSCRIPTION_DATA);
                var emitters = (0, $jc4XS.data)(element, $c2bd95100e01a7d4$var$EMITTER_DATA);
                var emitter = emitters[emitterName];
                delete subscriptions[eventName];
                var disposeEmitter = true;
                (0, $8OLOW.each)(emitterEvents, function(_, eventName) {
                    disposeEmitter = disposeEmitter && !subscriptions[eventName];
                    return disposeEmitter;
                });
                if (disposeEmitter) {
                    if ($c2bd95100e01a7d4$var$eventManager.isActive(element)) $c2bd95100e01a7d4$var$eventManager.resetEmitter(emitter);
                    emitter && emitter.dispose();
                    delete emitters[emitterName];
                }
            }
        });
    });
};
var $c2bd95100e01a7d4$export$2e2bcd8739ae039 = $c2bd95100e01a7d4$var$registerEmitter;

});
parcelRegister("fFYtV", function(module, exports) {

$parcel$export(module.exports, "name", function () { return $b69999c5987ca89b$export$a8ff84c12d48cfa6; });
/**
 * DevExtreme (esm/events/core/wheel.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $60GuF = parcelRequire("60GuF");

var $jxLje = parcelRequire("jxLje");

var $bcOMe = parcelRequire("bcOMe");
var $b69999c5987ca89b$export$a8ff84c12d48cfa6 = "dxmousewheel";
var $b69999c5987ca89b$var$EVENT_NAMESPACE = "dxWheel";
var $b69999c5987ca89b$var$NATIVE_EVENT_NAME = "wheel";
var $b69999c5987ca89b$var$PIXEL_MODE = 0;
var $b69999c5987ca89b$var$DELTA_MUTLIPLIER = 30;
var $b69999c5987ca89b$var$wheel = {
    setup: function(element) {
        var $element = (0, $2vlX8.default)(element);
        (0, $60GuF.default).on($element, (0, $bcOMe.addNamespace)($b69999c5987ca89b$var$NATIVE_EVENT_NAME, $b69999c5987ca89b$var$EVENT_NAMESPACE), $b69999c5987ca89b$var$wheel._wheelHandler.bind($b69999c5987ca89b$var$wheel));
    },
    teardown: function(element) {
        (0, $60GuF.default).off(element, ".".concat($b69999c5987ca89b$var$EVENT_NAMESPACE));
    },
    _wheelHandler: function(e) {
        var { deltaMode: deltaMode, deltaY: deltaY, deltaX: deltaX, deltaZ: deltaZ } = e.originalEvent;
        (0, $bcOMe.fireEvent)({
            type: $b69999c5987ca89b$export$a8ff84c12d48cfa6,
            originalEvent: e,
            delta: this._normalizeDelta(deltaY, deltaMode),
            deltaX: deltaX,
            deltaY: deltaY,
            deltaZ: deltaZ,
            deltaMode: deltaMode,
            pointerType: "mouse"
        });
        e.stopPropagation();
    },
    _normalizeDelta (delta) {
        var deltaMode = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : $b69999c5987ca89b$var$PIXEL_MODE;
        if (deltaMode === $b69999c5987ca89b$var$PIXEL_MODE) return -delta;
        else return -$b69999c5987ca89b$var$DELTA_MUTLIPLIER * delta;
    }
};
(0, $jxLje.default)($b69999c5987ca89b$export$a8ff84c12d48cfa6, $b69999c5987ca89b$var$wheel);

});




parcelRegister("4jhWa", function(module, exports) {

$parcel$export(module.exports, "Range", function () { return $3236d9ba7a06dd4d$export$9a58ef0d7ad3278c; });
/**
 * DevExtreme (esm/viz/translators/range.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $2oTOp = parcelRequire("2oTOp");

var $dw9tZ = parcelRequire("dw9tZ");
var $3236d9ba7a06dd4d$var$_isDefined = (0, $6ntMu.isDefined);
var $3236d9ba7a06dd4d$var$_isDate = (0, $6ntMu.isDate);
var $3236d9ba7a06dd4d$var$_isFunction = (0, $6ntMu.isFunction);
var $3236d9ba7a06dd4d$var$minSelector = "min";
var $3236d9ba7a06dd4d$var$maxSelector = "max";
var $3236d9ba7a06dd4d$var$minVisibleSelector = "minVisible";
var $3236d9ba7a06dd4d$var$maxVisibleSelector = "maxVisible";
var $3236d9ba7a06dd4d$var$baseSelector = "base";
var $3236d9ba7a06dd4d$var$axisTypeSelector = "axisType";
function $3236d9ba7a06dd4d$var$otherLessThan(thisValue, otherValue) {
    return otherValue < thisValue;
}
function $3236d9ba7a06dd4d$var$otherGreaterThan(thisValue, otherValue) {
    return otherValue > thisValue;
}
function $3236d9ba7a06dd4d$var$compareAndReplace(thisValue, otherValue, setValue, compare) {
    var otherValueDefined = $3236d9ba7a06dd4d$var$_isDefined(otherValue);
    if ($3236d9ba7a06dd4d$var$_isDefined(thisValue)) {
        if (otherValueDefined && compare(thisValue, otherValue)) setValue(otherValue);
    } else if (otherValueDefined) setValue(otherValue);
}
var $3236d9ba7a06dd4d$export$9a58ef0d7ad3278c = function(range) {
    range && (0, $2oTOp.extend)(this, range);
};
var $3236d9ba7a06dd4d$var$_Range = $3236d9ba7a06dd4d$export$9a58ef0d7ad3278c;
$3236d9ba7a06dd4d$var$_Range.prototype = {
    constructor: $3236d9ba7a06dd4d$var$_Range,
    addRange: function(otherRange) {
        var that = this;
        var categories = that.categories;
        var otherCategories = otherRange.categories;
        var isDiscrete = "discrete" === that[$3236d9ba7a06dd4d$var$axisTypeSelector];
        var compareAndReplaceByField = function(field, compare) {
            $3236d9ba7a06dd4d$var$compareAndReplace(that[field], otherRange[field], function(value) {
                that[field] = value;
            }, compare);
        };
        var controlValuesByVisibleBounds = function(valueField, visibleValueField, compare) {
            $3236d9ba7a06dd4d$var$compareAndReplace(that[valueField], that[visibleValueField], function(value) {
                $3236d9ba7a06dd4d$var$_isDefined(that[valueField]) && (that[valueField] = value);
            }, compare);
        };
        var checkField = function(field) {
            that[field] = that[field] || otherRange[field];
        };
        checkField("invert");
        checkField("containsConstantLine");
        checkField($3236d9ba7a06dd4d$var$axisTypeSelector);
        checkField("dataType");
        checkField("isSpacedMargin");
        if ("logarithmic" === that[$3236d9ba7a06dd4d$var$axisTypeSelector]) checkField($3236d9ba7a06dd4d$var$baseSelector);
        else that[$3236d9ba7a06dd4d$var$baseSelector] = void 0;
        compareAndReplaceByField($3236d9ba7a06dd4d$var$minSelector, $3236d9ba7a06dd4d$var$otherLessThan);
        compareAndReplaceByField($3236d9ba7a06dd4d$var$maxSelector, $3236d9ba7a06dd4d$var$otherGreaterThan);
        if (isDiscrete) {
            checkField($3236d9ba7a06dd4d$var$minVisibleSelector);
            checkField($3236d9ba7a06dd4d$var$maxVisibleSelector);
        } else {
            compareAndReplaceByField($3236d9ba7a06dd4d$var$minVisibleSelector, $3236d9ba7a06dd4d$var$otherLessThan);
            compareAndReplaceByField($3236d9ba7a06dd4d$var$maxVisibleSelector, $3236d9ba7a06dd4d$var$otherGreaterThan);
        }
        compareAndReplaceByField("interval", $3236d9ba7a06dd4d$var$otherLessThan);
        if (!isDiscrete) {
            controlValuesByVisibleBounds($3236d9ba7a06dd4d$var$minSelector, $3236d9ba7a06dd4d$var$minVisibleSelector, $3236d9ba7a06dd4d$var$otherLessThan);
            controlValuesByVisibleBounds($3236d9ba7a06dd4d$var$minSelector, $3236d9ba7a06dd4d$var$maxVisibleSelector, $3236d9ba7a06dd4d$var$otherLessThan);
            controlValuesByVisibleBounds($3236d9ba7a06dd4d$var$maxSelector, $3236d9ba7a06dd4d$var$maxVisibleSelector, $3236d9ba7a06dd4d$var$otherGreaterThan);
            controlValuesByVisibleBounds($3236d9ba7a06dd4d$var$maxSelector, $3236d9ba7a06dd4d$var$minVisibleSelector, $3236d9ba7a06dd4d$var$otherGreaterThan);
        }
        if (void 0 === categories) that.categories = otherCategories;
        else that.categories = otherCategories ? (0, $dw9tZ.unique)(categories.concat(otherCategories)) : categories;
        if ("logarithmic" === that[$3236d9ba7a06dd4d$var$axisTypeSelector]) {
            checkField("allowNegatives");
            compareAndReplaceByField("linearThreshold", $3236d9ba7a06dd4d$var$otherLessThan);
        }
        return that;
    },
    isEmpty: function() {
        return (!$3236d9ba7a06dd4d$var$_isDefined(this[$3236d9ba7a06dd4d$var$minSelector]) || !$3236d9ba7a06dd4d$var$_isDefined(this[$3236d9ba7a06dd4d$var$maxSelector])) && (!this.categories || 0 === this.categories.length);
    },
    correctValueZeroLevel: function() {
        var that = this;
        if ($3236d9ba7a06dd4d$var$_isDate(that[$3236d9ba7a06dd4d$var$maxSelector]) || $3236d9ba7a06dd4d$var$_isDate(that[$3236d9ba7a06dd4d$var$minSelector])) return that;
        function setZeroLevel(min, max) {
            that[min] < 0 && that[max] < 0 && (that[max] = 0);
            that[min] > 0 && that[max] > 0 && (that[min] = 0);
        }
        setZeroLevel($3236d9ba7a06dd4d$var$minSelector, $3236d9ba7a06dd4d$var$maxSelector);
        setZeroLevel($3236d9ba7a06dd4d$var$minVisibleSelector, $3236d9ba7a06dd4d$var$maxVisibleSelector);
        return that;
    },
    sortCategories (sort) {
        if (false === sort || !this.categories) return;
        if (Array.isArray(sort)) {
            var sortValues = sort.map((item)=>item.valueOf());
            var filteredSeriesCategories = this.categories.filter((item)=>-1 === sortValues.indexOf(item.valueOf()));
            this.categories = sort.concat(filteredSeriesCategories);
        } else {
            var notAFunction = !$3236d9ba7a06dd4d$var$_isFunction(sort);
            if (notAFunction && "string" !== this.dataType) sort = (a, b)=>a.valueOf() - b.valueOf();
            else if (notAFunction) sort = false;
            sort && this.categories.sort(sort);
        }
    }
};

});

parcelRegister("3oqfq", function(module, exports) {

$parcel$export(module.exports, "Translator1D", function () { return $2787f94694f22153$export$8c88e4b436683a5b; });
/**
 * DevExtreme (esm/viz/translators/translator1d.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $2787f94694f22153$var$_Number = Number;
function $2787f94694f22153$export$8c88e4b436683a5b() {
    this.setDomain(arguments[0], arguments[1]).setCodomain(arguments[2], arguments[3]).setInverted(false);
}
$2787f94694f22153$export$8c88e4b436683a5b.prototype = {
    constructor: $2787f94694f22153$export$8c88e4b436683a5b,
    setDomain: function(domain1, domain2) {
        this._domain1 = $2787f94694f22153$var$_Number(domain1);
        this._domain2 = $2787f94694f22153$var$_Number(domain2);
        this._domainDelta = this._domain2 - this._domain1;
        return this;
    },
    setCodomain: function(codomain1, codomain2) {
        this._codomain1 = $2787f94694f22153$var$_Number(codomain1);
        this._codomain2 = $2787f94694f22153$var$_Number(codomain2);
        this._codomainDelta = this._codomain2 - this._codomain1;
        return this;
    },
    setInverted (state) {
        this.inverted = state;
    },
    getDomain: function() {
        return [
            this._domain1,
            this._domain2
        ];
    },
    getCodomain: function() {
        return [
            this._codomain1,
            this._codomain2
        ];
    },
    getDomainStart: function() {
        return this._domain1;
    },
    getDomainEnd: function() {
        return this._domain2;
    },
    getCodomainStart: function() {
        return this._codomain1;
    },
    getCodomainEnd: function() {
        return this._codomain2;
    },
    getDomainRange: function() {
        return this._domainDelta;
    },
    getCodomainRange: function() {
        return this._codomainDelta;
    },
    translate: function(value) {
        var ratio = ($2787f94694f22153$var$_Number(value) - this._domain1) / this._domainDelta;
        this.inverted && (ratio = 1 - ratio);
        return 0 <= ratio && ratio <= 1 ? this._codomain1 + ratio * this._codomainDelta : NaN;
    },
    adjust: function(value) {
        var ratio = ($2787f94694f22153$var$_Number(value) - this._domain1) / this._domainDelta;
        var result = NaN;
        if (ratio < 0) result = this._domain1;
        else if (ratio > 1) result = this._domain2;
        else if (0 <= ratio && ratio <= 1) result = $2787f94694f22153$var$_Number(value);
        return result;
    }
};

});

parcelRegister("7MSPx", function(module, exports) {

$parcel$export(module.exports, "overlapping", function () { return $5ab78c3feee42cb7$export$7546c4d8416380f9; });
$parcel$export(module.exports, "BaseChart", function () { return $5ab78c3feee42cb7$export$ba89768bd61fb9ef; });
/**
 * DevExtreme (esm/__internal/viz/chart_components/m_base_chart.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $gcp4g = parcelRequire("gcp4g");

var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $6ntMu = parcelRequire("6ntMu");

var $60GuF = parcelRequire("60GuF");

var $bcOMe = parcelRequire("bcOMe");

var $e6jz0 = parcelRequire("e6jz0");

var $hHPaz = parcelRequire("hHPaz");

var $72UWv = parcelRequire("72UWv");

var $6Ztqs = parcelRequire("6Ztqs");

var $g3uKC = parcelRequire("g3uKC");

var $7AWWW = parcelRequire("7AWWW");

var $5Z13B = parcelRequire("5Z13B");

var $jM2K9 = parcelRequire("jM2K9");

var $a0Hpu = parcelRequire("a0Hpu");

var $6NEbp = parcelRequire("6NEbp");

var $dw9tZ = parcelRequire("dw9tZ");

var $2Vk35 = parcelRequire("2Vk35");

var $9wl6Q = parcelRequire("9wl6Q");

var $32RRa = parcelRequire("32RRa");
var { isArray: $5ab78c3feee42cb7$var$isArray } = Array;
var $5ab78c3feee42cb7$var$REINIT_REFRESH_ACTION = "_reinit";
var $5ab78c3feee42cb7$var$REINIT_DATA_SOURCE_REFRESH_ACTION = "_updateDataSource";
var $5ab78c3feee42cb7$var$DATA_INIT_REFRESH_ACTION = "_dataInit";
var $5ab78c3feee42cb7$var$FORCE_RENDER_REFRESH_ACTION = "_forceRender";
var $5ab78c3feee42cb7$var$RESIZE_REFRESH_ACTION = "_resize";
var $5ab78c3feee42cb7$var$ACTIONS_BY_PRIORITY = [
    $5ab78c3feee42cb7$var$REINIT_REFRESH_ACTION,
    $5ab78c3feee42cb7$var$REINIT_DATA_SOURCE_REFRESH_ACTION,
    $5ab78c3feee42cb7$var$DATA_INIT_REFRESH_ACTION,
    $5ab78c3feee42cb7$var$FORCE_RENDER_REFRESH_ACTION,
    $5ab78c3feee42cb7$var$RESIZE_REFRESH_ACTION
];
var $5ab78c3feee42cb7$var$DEFAULT_OPACITY = .3;
var $5ab78c3feee42cb7$var$REFRESH_SERIES_DATA_INIT_ACTION_OPTIONS = [
    "series",
    "commonSeriesSettings",
    "dataPrepareSettings",
    "seriesSelectionMode",
    "pointSelectionMode",
    "synchronizeMultiAxes",
    "resolveLabelsOverlapping"
];
var $5ab78c3feee42cb7$var$REFRESH_SERIES_FAMILIES_ACTION_OPTIONS = [
    "minBubbleSize",
    "maxBubbleSize",
    "barGroupPadding",
    "barGroupWidth",
    "negativesAsZeroes",
    "negativesAsZeros"
];
var $5ab78c3feee42cb7$var$FORCE_RENDER_REFRESH_ACTION_OPTIONS = [
    "adaptiveLayout",
    "crosshair",
    "resolveLabelOverlapping",
    "adjustOnZoom",
    "stickyHovering"
];
var $5ab78c3feee42cb7$var$FONT = "font";
function $5ab78c3feee42cb7$var$checkHeightRollingStock(rollingStocks, stubCanvas) {
    var canvasSize = stubCanvas.end - stubCanvas.start;
    var size = 0;
    rollingStocks.forEach((rollingStock)=>{
        size += rollingStock.getBoundingRect().width;
    });
    while(canvasSize < size)size -= $5ab78c3feee42cb7$var$findAndKillSmallValue(rollingStocks);
}
function $5ab78c3feee42cb7$var$findAndKillSmallValue(rollingStocks) {
    var smallestObject = rollingStocks.reduce((prev, rollingStock, index)=>{
        if (!rollingStock) return prev;
        var value = rollingStock.value();
        return value < prev.value ? {
            value: value,
            rollingStock: rollingStock,
            index: index
        } : prev;
    }, {
        rollingStock: void 0,
        value: 1 / 0,
        index: void 0
    });
    smallestObject.rollingStock.getLabels()[0].draw(false);
    var { width: width } = smallestObject.rollingStock.getBoundingRect();
    rollingStocks[smallestObject.index] = null;
    return width;
}
function $5ab78c3feee42cb7$var$checkStackOverlap(rollingStocks) {
    var i;
    var j;
    var iLength;
    var jLength;
    var overlap = false;
    for(i = 0, iLength = rollingStocks.length - 1; i < iLength; i++){
        for(j = i + 1, jLength = rollingStocks.length; j < jLength; j++)if (i !== j && $5ab78c3feee42cb7$var$checkStacksOverlapping(rollingStocks[i], rollingStocks[j], true)) {
            overlap = true;
            break;
        }
        if (overlap) break;
    }
    return overlap;
}
function $5ab78c3feee42cb7$var$resolveLabelOverlappingInOneDirection(points, canvas, isRotated, isInverted, shiftFunction) {
    var customSorting = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : ()=>0;
    var rollingStocks = [];
    var stubCanvas = {
        start: isRotated ? canvas.left : canvas.top,
        end: isRotated ? canvas.width - canvas.right : canvas.height - canvas.bottom
    };
    var hasStackedSeries = false;
    var sortRollingStocks;
    points.forEach((p)=>{
        if (!p) return;
        hasStackedSeries = hasStackedSeries || p.series.isStackedSeries() || p.series.isFullStackedSeries();
        p.getLabels().forEach((l)=>{
            if (l.isVisible()) rollingStocks.push(new (0, $32RRa.RollingStock)(l, isRotated, shiftFunction));
        });
    });
    if (hasStackedSeries) {
        if (Number(!isRotated) ^ Number(isInverted)) rollingStocks.reverse();
        sortRollingStocks = isInverted ? rollingStocks : $5ab78c3feee42cb7$var$sortRollingStocksByValue(rollingStocks);
    } else {
        var rollingStocksTmp = rollingStocks.slice();
        sortRollingStocks = rollingStocks.sort((a, b)=>customSorting(a, b) || a.getInitialPosition() - b.getInitialPosition() || rollingStocksTmp.indexOf(a) - rollingStocksTmp.indexOf(b));
    }
    if (!$5ab78c3feee42cb7$var$checkStackOverlap(sortRollingStocks)) return false;
    $5ab78c3feee42cb7$var$checkHeightRollingStock(sortRollingStocks, stubCanvas);
    $5ab78c3feee42cb7$var$prepareOverlapStacks(sortRollingStocks);
    sortRollingStocks.reverse();
    $5ab78c3feee42cb7$var$moveRollingStock(sortRollingStocks, stubCanvas);
    return true;
}
function $5ab78c3feee42cb7$var$checkStacksOverlapping(firstRolling, secondRolling, inTwoSides) {
    if (!firstRolling || !secondRolling) return;
    var firstRect = firstRolling.getBoundingRect();
    var secondRect = secondRolling.getBoundingRect();
    var oppositeOverlapping = inTwoSides ? firstRect.oppositeStart <= secondRect.oppositeStart && firstRect.oppositeEnd > secondRect.oppositeStart || secondRect.oppositeStart <= firstRect.oppositeStart && secondRect.oppositeEnd > firstRect.oppositeStart : true;
    return firstRect.end > secondRect.start && oppositeOverlapping;
}
function $5ab78c3feee42cb7$var$sortRollingStocksByValue(rollingStocks) {
    var positiveRollingStocks = [];
    var negativeRollingStocks = [];
    rollingStocks.forEach((stock)=>{
        if (stock.value() > 0) positiveRollingStocks.push(stock);
        else negativeRollingStocks.unshift(stock);
    });
    return positiveRollingStocks.concat(negativeRollingStocks);
}
function $5ab78c3feee42cb7$var$prepareOverlapStacks(rollingStocks) {
    var root;
    for(var i = 0; i < rollingStocks.length - 1; i += 1){
        var currentRollingStock = root || rollingStocks[i];
        if ($5ab78c3feee42cb7$var$checkStacksOverlapping(currentRollingStock, rollingStocks[i + 1])) {
            currentRollingStock.toChain(rollingStocks[i + 1]);
            rollingStocks[i + 1] = null;
            root = currentRollingStock;
        } else root = rollingStocks[i + 1] || currentRollingStock;
    }
}
function $5ab78c3feee42cb7$var$rollingStocksIsOut(rollingStock, canvas) {
    return rollingStock.getBoundingRect().end > canvas.end;
}
function $5ab78c3feee42cb7$var$moveRollingStock(rollingStocks, canvas) {
    for(var i = 0; i < rollingStocks.length; i += 1){
        var currentRollingStock = rollingStocks[i];
        var shouldSetCanvas = true;
        if (null !== currentRollingStock && $5ab78c3feee42cb7$var$rollingStocksIsOut(currentRollingStock, canvas)) {
            var currentBBox = currentRollingStock.getBoundingRect();
            for(var j = i + 1; j < rollingStocks.length; j += 1){
                var nextRollingStock = rollingStocks[j];
                if (nextRollingStock) {
                    var nextBBox = nextRollingStock.getBoundingRect();
                    if (nextBBox.end > currentBBox.start - (currentBBox.end - canvas.end)) {
                        nextRollingStock.toChain(currentRollingStock);
                        shouldSetCanvas = false;
                        break;
                    }
                }
            }
        }
        if (shouldSetCanvas) null === currentRollingStock || void 0 === currentRollingStock || currentRollingStock.setRollingStockInCanvas(canvas);
    }
}
function $5ab78c3feee42cb7$var$getLegendFields(name) {
    return {
        nameField: "".concat(name, "Name"),
        colorField: "".concat(name, "Color"),
        indexField: "".concat(name, "Index")
    };
}
function $5ab78c3feee42cb7$var$getLegendSettings(legendDataField) {
    var formatObjectFields = $5ab78c3feee42cb7$var$getLegendFields(legendDataField);
    return {
        getFormatObject (data) {
            var res = {};
            res[formatObjectFields.indexField] = data.id;
            res[formatObjectFields.colorField] = data.states.normal.fill;
            res[formatObjectFields.nameField] = data.text;
            return res;
        },
        textField: formatObjectFields.nameField
    };
}
function $5ab78c3feee42cb7$var$checkOverlapping(firstRect, secondRect) {
    return (firstRect.x <= secondRect.x && secondRect.x <= firstRect.x + firstRect.width || firstRect.x >= secondRect.x && firstRect.x <= secondRect.x + secondRect.width) && (firstRect.y <= secondRect.y && secondRect.y <= firstRect.y + firstRect.height || firstRect.y >= secondRect.y && firstRect.y <= secondRect.y + secondRect.height);
}
var $5ab78c3feee42cb7$export$7546c4d8416380f9 = {
    resolveLabelOverlappingInOneDirection: $5ab78c3feee42cb7$var$resolveLabelOverlappingInOneDirection
};
var $5ab78c3feee42cb7$export$ba89768bd61fb9ef = (0, $9wl6Q.default).inherit({
    _eventsMap: {
        onSeriesClick: {
            name: "seriesClick"
        },
        onPointClick: {
            name: "pointClick"
        },
        onArgumentAxisClick: {
            name: "argumentAxisClick"
        },
        onLegendClick: {
            name: "legendClick"
        },
        onSeriesSelectionChanged: {
            name: "seriesSelectionChanged"
        },
        onPointSelectionChanged: {
            name: "pointSelectionChanged"
        },
        onSeriesHoverChanged: {
            name: "seriesHoverChanged"
        },
        onPointHoverChanged: {
            name: "pointHoverChanged"
        },
        onDone: {
            name: "done",
            actionSettings: {
                excludeValidators: [
                    "disabled"
                ]
            }
        },
        onZoomStart: {
            name: "zoomStart"
        },
        onZoomEnd: {
            name: "zoomEnd"
        }
    },
    _fontFields: [
        "legend.".concat($5ab78c3feee42cb7$var$FONT),
        "legend.title.".concat($5ab78c3feee42cb7$var$FONT),
        "legend.title.subtitle.".concat($5ab78c3feee42cb7$var$FONT),
        "commonSeriesSettings.label.".concat($5ab78c3feee42cb7$var$FONT)
    ],
    _rootClassPrefix: "dxc",
    _rootClass: "dxc-chart",
    _initialChanges: [
        "INIT"
    ],
    _themeDependentChanges: [
        "REFRESH_SERIES_REINIT"
    ],
    _getThemeManagerOptions () {
        var themeOptions = this.callBase.apply(this, arguments);
        themeOptions.options = this.option();
        return themeOptions;
    },
    _createThemeManager () {
        var chartOption = this.option();
        var themeManager = new (0, $72UWv.ThemeManager)(this._getThemeManagerOptions());
        themeManager.setTheme(chartOption.theme, chartOption.rtlEnabled);
        return themeManager;
    },
    _initCore () {
        this._canvasClipRect = this._renderer.clipRect();
        this._createHtmlStructure();
        this._createLegend();
        this._createTracker();
        this._needHandleRenderComplete = true;
        this.layoutManager = new (0, $e6jz0.LayoutManager);
        this._createScrollBar();
        (0, $60GuF.default).on(this._$element, "contextmenu", (event)=>{
            if ((0, $bcOMe.isTouchEvent)(event) || (0, $bcOMe.isPointerEvent)(event)) event.preventDefault();
        });
        (0, $60GuF.default).on(this._$element, "MSHoldVisual", (event)=>{
            event.preventDefault();
        });
    },
    _getLayoutItems: (0, $gcp4g.noop),
    _layoutManagerOptions () {
        return this._themeManager.getOptions("adaptiveLayout");
    },
    _reinit () {
        (0, $dw9tZ.setCanvasValues)(this._canvas);
        this._reinitAxes();
        this._requestChange([
            "DATA_SOURCE",
            "DATA_INIT",
            "CORRECT_AXIS",
            "FULL_RENDER"
        ]);
    },
    _correctAxes: (0, $gcp4g.noop),
    _createHtmlStructure () {
        var renderer = this._renderer;
        var { root: root } = renderer;
        var createConstantLinesGroup = function() {
            return renderer.g().attr({
                class: "dxc-constant-lines-group"
            }).linkOn(root, "constant-lines");
        };
        this._constantLinesGroup = {
            dispose () {
                this.under.dispose();
                this.above.dispose();
            },
            linkOff () {
                this.under.linkOff();
                this.above.linkOff();
            },
            clear () {
                this.under.linkRemove().clear();
                this.above.linkRemove().clear();
            },
            linkAppend () {
                this.under.linkAppend();
                this.above.linkAppend();
            }
        };
        this._labelsAxesGroup = renderer.g().attr({
            class: "dxc-elements-axes-group"
        });
        var appendLabelsAxesGroup = ()=>{
            this._labelsAxesGroup.linkOn(root, "elements");
        };
        this._backgroundRect = renderer.rect().attr({
            fill: "gray",
            opacity: 1e-4
        }).append(root);
        this._panesBackgroundGroup = renderer.g().attr({
            class: "dxc-background"
        }).append(root);
        this._stripsGroup = renderer.g().attr({
            class: "dxc-strips-group"
        }).linkOn(root, "strips");
        this._gridGroup = renderer.g().attr({
            class: "dxc-grids-group"
        }).linkOn(root, "grids");
        this._panesBorderGroup = renderer.g().attr({
            class: "dxc-border"
        }).linkOn(root, "border");
        this._axesGroup = renderer.g().attr({
            class: "dxc-axes-group"
        }).linkOn(root, "axes");
        this._executeAppendBeforeSeries(appendLabelsAxesGroup);
        this._stripLabelAxesGroup = renderer.g().attr({
            class: "dxc-strips-labels-group"
        }).linkOn(root, "strips-labels");
        this._constantLinesGroup.under = createConstantLinesGroup();
        this._seriesGroup = renderer.g().attr({
            class: "dxc-series-group"
        }).linkOn(root, "series");
        this._executeAppendAfterSeries(appendLabelsAxesGroup);
        this._constantLinesGroup.above = createConstantLinesGroup();
        this._scaleBreaksGroup = renderer.g().attr({
            class: "dxc-scale-breaks"
        }).linkOn(root, "scale-breaks");
        this._labelsGroup = renderer.g().attr({
            class: "dxc-labels-group"
        }).linkOn(root, "labels");
        this._crosshairCursorGroup = renderer.g().attr({
            class: "dxc-crosshair-cursor"
        }).linkOn(root, "crosshair");
        this._legendGroup = renderer.g().attr({
            class: "dxc-legend",
            "clip-path": this._getCanvasClipRectID()
        }).linkOn(root, "legend").linkAppend(root).enableLinks();
        this._scrollBarGroup = renderer.g().attr({
            class: "dxc-scroll-bar"
        }).linkOn(root, "scroll-bar");
    },
    _executeAppendBeforeSeries () {},
    _executeAppendAfterSeries () {},
    _disposeObjectsInArray (propName, fieldNames) {
        (this[propName] || []).forEach((item)=>{
            if (fieldNames && item) fieldNames.forEach((field)=>{
                var _a;
                null === (_a = item[field]) || void 0 === _a || _a.dispose();
            });
            else null === item || void 0 === item || item.dispose();
        });
        this[propName] = null;
    },
    _disposeCore () {
        var disposeObject = (propName)=>{
            if (this[propName]) {
                this[propName].dispose();
                this[propName] = null;
            }
        };
        var unlinkGroup = (name)=>{
            this[name].linkOff();
        };
        var disposeObjectsInArray = this._disposeObjectsInArray;
        this._renderer.stopAllAnimations();
        disposeObjectsInArray.call(this, "series");
        disposeObject("_tracker");
        disposeObject("_crosshair");
        this.layoutManager = this._userOptions = this._canvas = this._groupsData = null;
        unlinkGroup("_stripsGroup");
        unlinkGroup("_gridGroup");
        unlinkGroup("_axesGroup");
        unlinkGroup("_constantLinesGroup");
        unlinkGroup("_stripLabelAxesGroup");
        unlinkGroup("_panesBorderGroup");
        unlinkGroup("_seriesGroup");
        unlinkGroup("_labelsGroup");
        unlinkGroup("_crosshairCursorGroup");
        unlinkGroup("_legendGroup");
        unlinkGroup("_scrollBarGroup");
        unlinkGroup("_scaleBreaksGroup");
        disposeObject("_canvasClipRect");
        disposeObject("_panesBackgroundGroup");
        disposeObject("_backgroundRect");
        disposeObject("_stripsGroup");
        disposeObject("_gridGroup");
        disposeObject("_axesGroup");
        disposeObject("_constantLinesGroup");
        disposeObject("_stripLabelAxesGroup");
        disposeObject("_panesBorderGroup");
        disposeObject("_seriesGroup");
        disposeObject("_labelsGroup");
        disposeObject("_crosshairCursorGroup");
        disposeObject("_legendGroup");
        disposeObject("_scrollBarGroup");
        disposeObject("_scaleBreaksGroup");
    },
    _getAnimationOptions () {
        return this._themeManager.getOptions("animation");
    },
    _getDefaultSize: ()=>({
            width: 400,
            height: 400
        }),
    _getOption (name) {
        return this._themeManager.getOptions(name);
    },
    _applySize (rect) {
        this._rect = rect.slice();
        if (!this._changes.has("FULL_RENDER")) this._processRefreshData($5ab78c3feee42cb7$var$RESIZE_REFRESH_ACTION);
    },
    _resize () {
        this._doRender(this.__renderOptions || {
            animate: false,
            isResize: true
        });
    },
    _trackerType: "ChartTracker",
    _createTracker () {
        this._tracker = new $hHPaz[this._trackerType]({
            seriesGroup: this._seriesGroup,
            renderer: this._renderer,
            tooltip: this._tooltip,
            legend: this._legend,
            eventTrigger: this._eventTrigger
        });
    },
    _getTrackerSettings () {
        return (0, $2oTOp.extend)({
            chart: this
        }, this._getSelectionModes());
    },
    _getSelectionModes () {
        var themeManager = this._themeManager;
        return {
            seriesSelectionMode: themeManager.getOptions("seriesSelectionMode"),
            pointSelectionMode: themeManager.getOptions("pointSelectionMode")
        };
    },
    _updateTracker (trackerCanvases) {
        this._tracker.update(this._getTrackerSettings());
        this._tracker.setCanvases({
            left: 0,
            right: this._canvas.width,
            top: 0,
            bottom: this._canvas.height
        }, trackerCanvases);
    },
    _createCanvasFromRect (rect) {
        var currentCanvas = this._canvas;
        return (0, $dw9tZ.setCanvasValues)({
            left: rect[0],
            top: rect[1],
            right: currentCanvas.width - rect[2],
            bottom: currentCanvas.height - rect[3],
            width: currentCanvas.width,
            height: currentCanvas.height
        });
    },
    _doRender (_options) {
        if (0 === this._canvas.width && 0 === this._canvas.height) return;
        this._resetIsReady();
        var drawOptions = this._prepareDrawOptions(_options);
        var { recreateCanvas: recreateCanvas } = drawOptions;
        this._preserveOriginalCanvas();
        if (recreateCanvas) this.__currentCanvas = this._canvas;
        else this._canvas = this.__currentCanvas;
        recreateCanvas && this._updateCanvasClipRect(this._canvas);
        this._canvas = this._createCanvasFromRect(this._rect);
        this._renderer.stopAllAnimations(true);
        this._cleanGroups();
        var startTime = new Date;
        this._renderElements(drawOptions);
        this._lastRenderingTime = Number(new Date) - Number(startTime);
    },
    _preserveOriginalCanvas () {
        this.__originalCanvas = this._canvas;
        this._canvas = (0, $2oTOp.extend)({}, this._canvas);
    },
    _layoutAxes: (0, $gcp4g.noop),
    _renderElements (drawOptions) {
        var preparedOptions = this._prepareToRender(drawOptions);
        var isRotated = this._isRotated();
        var isLegendInside = this._isLegendInside();
        var trackerCanvases = [];
        (0, $2oTOp.extend)({}, this._canvas);
        var argBusinessRange;
        var zoomMinArg;
        var zoomMaxArg;
        this._renderer.lock();
        if (drawOptions.drawLegend && this._legend) this._legendGroup.linkAppend();
        this.layoutManager.setOptions(this._layoutManagerOptions());
        var layoutTargets = this._getLayoutTargets();
        this._layoutAxes((needSpace)=>{
            var axisDrawOptions = needSpace ? (0, $2oTOp.extend)({}, drawOptions, {
                animate: false,
                recreateCanvas: true
            }) : drawOptions;
            var canvas = this._renderAxes(axisDrawOptions, preparedOptions);
            this._shrinkAxes(needSpace, canvas);
        });
        this._applyClipRects(preparedOptions);
        this._appendSeriesGroups();
        this._createCrosshairCursor();
        layoutTargets.forEach((_ref)=>{
            var { canvas: canvas } = _ref;
            trackerCanvases.push({
                left: canvas.left,
                right: canvas.width - canvas.right,
                top: canvas.top,
                bottom: canvas.height - canvas.bottom
            });
        });
        if (this._scrollBar) {
            argBusinessRange = this._argumentAxes[0].getTranslator().getBusinessRange();
            if ("discrete" === argBusinessRange.axisType && argBusinessRange.categories && argBusinessRange.categories.length <= 1 || "discrete" !== argBusinessRange.axisType && argBusinessRange.min === argBusinessRange.max) zoomMinArg = zoomMaxArg = void 0;
            else {
                zoomMinArg = argBusinessRange.minVisible;
                zoomMaxArg = argBusinessRange.maxVisible;
            }
            this._scrollBar.init(argBusinessRange, !this._argumentAxes[0].getOptions().valueMarginsEnabled).setPosition(zoomMinArg, zoomMaxArg);
        }
        this._updateTracker(trackerCanvases);
        this._updateLegendPosition(drawOptions, isLegendInside);
        this._applyPointMarkersAutoHiding();
        this._renderSeries(drawOptions, isRotated, isLegendInside);
        this._renderer.unlock();
    },
    _updateLegendPosition: (0, $gcp4g.noop),
    _createCrosshairCursor: (0, $gcp4g.noop),
    _appendSeriesGroups () {
        this._seriesGroup.linkAppend();
        this._labelsGroup.linkAppend();
        this._appendAdditionalSeriesGroups();
    },
    _renderSeries (drawOptions, isRotated, isLegendInside) {
        this._calculateSeriesLayout(drawOptions, isRotated);
        this._renderSeriesElements(drawOptions, isLegendInside);
    },
    _calculateSeriesLayout (drawOptions, isRotated) {
        drawOptions.hideLayoutLabels = this.layoutManager.needMoreSpaceForPanesCanvas(this._getLayoutTargets(), isRotated) && !this._themeManager.getOptions("adaptiveLayout").keepLabels;
        this._updateSeriesDimensions(drawOptions);
    },
    _getArgFilter: ()=>()=>true,
    _getValFilter: ()=>()=>true,
    _getPointsToAnimation (series) {
        var argViewPortFilter = this._getArgFilter();
        return series.map((s)=>{
            var valViewPortFilter = this._getValFilter(s);
            return s.getPoints().filter((p)=>p.getOptions().visible && argViewPortFilter(p.argument) && (valViewPortFilter(p.getMinValue(true)) || valViewPortFilter(p.getMaxValue(true)))).length;
        });
    },
    _renderSeriesElements (drawOptions, isLegendInside) {
        var { series: series } = this;
        var resolveLabelOverlapping = this._themeManager.getOptions("resolveLabelOverlapping");
        var pointsToAnimation = this._getPointsToAnimation(series);
        series.forEach((singleSeries, index)=>{
            this._applyExtraSettings(singleSeries, drawOptions);
            var animationEnabled = drawOptions.animate && pointsToAnimation[index] <= drawOptions.animationPointsLimit && this._renderer.animationEnabled();
            singleSeries.draw(animationEnabled, drawOptions.hideLayoutLabels, this._getLegendCallBack(singleSeries));
        });
        if ("none" === resolveLabelOverlapping) this._adjustSeriesLabels(false);
        else this._locateLabels(resolveLabelOverlapping);
        this._renderTrackers(isLegendInside);
        this._tracker.repairTooltip();
        this._renderExtraElements();
        this._clearCanvas();
        this._seriesElementsDrawn = true;
    },
    _changesApplied () {
        if (this._seriesElementsDrawn) {
            this._seriesElementsDrawn = false;
            this._drawn();
            this._renderCompleteHandler();
        }
    },
    _locateLabels (resolveLabelOverlapping) {
        this._resolveLabelOverlapping(resolveLabelOverlapping);
    },
    _renderExtraElements () {},
    _clearCanvas () {
        this._canvas = this.__originalCanvas;
    },
    _resolveLabelOverlapping (resolveLabelOverlapping) {
        var func;
        switch(resolveLabelOverlapping){
            case "stack":
                func = this._resolveLabelOverlappingStack;
                break;
            case "hide":
                func = this._resolveLabelOverlappingHide;
                break;
            case "shift":
                func = this._resolveLabelOverlappingShift;
        }
        return (0, $6ntMu.isFunction)(func) && func.call(this);
    },
    _getVisibleSeries () {
        return (0, $gcp4g.grep)(this.getAllSeries(), (series)=>series.isVisible());
    },
    _resolveLabelOverlappingHide () {
        var labels = [];
        var currentLabel;
        var nextLabel;
        var currentLabelRect;
        var nextLabelRect;
        var i;
        var j;
        var points;
        var series = this._getVisibleSeries();
        for(i = 0; i < series.length; i++){
            points = series[i].getVisiblePoints();
            for(j = 0; j < points.length; j++)labels.push.apply(labels, points[j].getLabels());
        }
        for(i = 0; i < labels.length; i++){
            currentLabel = labels[i];
            if (!currentLabel.isVisible()) continue;
            currentLabelRect = currentLabel.getBoundingRect();
            for(j = i + 1; j < labels.length; j++){
                nextLabel = labels[j];
                nextLabelRect = nextLabel.getBoundingRect();
                if ($5ab78c3feee42cb7$var$checkOverlapping(currentLabelRect, nextLabelRect)) nextLabel.draw(false);
            }
        }
    },
    _cleanGroups () {
        this._stripsGroup.linkRemove().clear();
        this._gridGroup.linkRemove().clear();
        this._axesGroup.linkRemove().clear();
        this._constantLinesGroup.clear();
        this._stripLabelAxesGroup.linkRemove().clear();
        this._labelsGroup.linkRemove().clear();
        this._crosshairCursorGroup.linkRemove().clear();
        this._scaleBreaksGroup.linkRemove().clear();
    },
    _allowLegendInsidePosition: ()=>false,
    _createLegend () {
        var legendSettings = $5ab78c3feee42cb7$var$getLegendSettings(this._legendDataField);
        this._legend = new (0, $g3uKC.Legend)({
            renderer: this._renderer,
            widget: this,
            group: this._legendGroup,
            backgroundClass: "dxc-border",
            itemGroupClass: "dxc-item",
            titleGroupClass: "dxc-title",
            textField: legendSettings.textField,
            getFormatObject: legendSettings.getFormatObject,
            allowInsidePosition: this._allowLegendInsidePosition()
        });
        this._updateLegend();
        this._layout.add(this._legend);
    },
    _updateLegend () {
        var themeManager = this._themeManager;
        var legendOptions = themeManager.getOptions("legend");
        var legendData = this._getLegendData();
        legendOptions.containerBackgroundColor = themeManager.getOptions("containerBackgroundColor");
        legendOptions._incidentOccurred = this._incidentOccurred;
        this._legend.update(legendData, legendOptions, themeManager.theme("legend").title);
        this._change([
            "LAYOUT"
        ]);
    },
    _prepareDrawOptions (drawOptions) {
        var animationOptions = this._getAnimationOptions();
        var options = (0, $2oTOp.extend)({}, {
            force: false,
            adjustAxes: true,
            drawLegend: true,
            drawTitle: true,
            animate: animationOptions.enabled,
            animationPointsLimit: animationOptions.maxPointCountSupported
        }, drawOptions, this.__renderOptions);
        if (!(0, $6ntMu.isDefined)(options.recreateCanvas)) options.recreateCanvas = options.adjustAxes && options.drawLegend && options.drawTitle;
        return options;
    },
    _processRefreshData (newRefreshAction) {
        var currentRefreshActionPosition = $5ab78c3feee42cb7$var$ACTIONS_BY_PRIORITY.indexOf(this._currentRefreshData);
        var newRefreshActionPosition = $5ab78c3feee42cb7$var$ACTIONS_BY_PRIORITY.indexOf(newRefreshAction);
        if (!this._currentRefreshData || currentRefreshActionPosition >= 0 && newRefreshActionPosition < currentRefreshActionPosition) this._currentRefreshData = newRefreshAction;
        this._requestChange([
            "REFRESH"
        ]);
    },
    _getLegendData () {
        return (0, $dw9tZ.map)(this._getLegendTargets(), (item)=>{
            var { legendData: legendData } = item;
            var style = item.getLegendStyles;
            var { opacity: opacity } = style.normal;
            if (!item.visible) {
                if (!(0, $6ntMu.isDefined)(opacity) || opacity > $5ab78c3feee42cb7$var$DEFAULT_OPACITY) opacity = $5ab78c3feee42cb7$var$DEFAULT_OPACITY;
                legendData.textOpacity = $5ab78c3feee42cb7$var$DEFAULT_OPACITY;
            }
            var opacityStyle = {
                opacity: opacity
            };
            legendData.states = {
                hover: (0, $2oTOp.extend)({}, style.hover, opacityStyle),
                selection: (0, $2oTOp.extend)({}, style.selection, opacityStyle),
                normal: (0, $2oTOp.extend)({}, style.normal, opacityStyle)
            };
            return legendData;
        });
    },
    _getLegendOptions (item) {
        return {
            legendData: {
                text: item[this._legendItemTextField],
                id: item.index,
                visible: true
            },
            getLegendStyles: item.getLegendStyles(),
            visible: item.isVisible()
        };
    },
    _disposeSeries (seriesIndex) {
        var _a;
        if (this.series) {
            if ((0, $6ntMu.isDefined)(seriesIndex)) {
                this.series[seriesIndex].dispose();
                this.series.splice(seriesIndex, 1);
            } else {
                this.series.forEach((s)=>s.dispose());
                this.series.length = 0;
            }
        }
        if (!(null === (_a = this.series) || void 0 === _a ? void 0 : _a.length)) this.series = [];
    },
    _disposeSeriesFamilies () {
        (this.seriesFamilies || []).forEach((family)=>{
            family.dispose();
        });
        this.seriesFamilies = null;
        this._needHandleRenderComplete = true;
    },
    _optionChanged (arg) {
        this._themeManager.resetOptions(arg.name);
        this.callBase.apply(this, arguments);
    },
    _applyChanges () {
        this._themeManager.update(this._options.silent());
        this.callBase(...arguments);
    },
    _optionChangesMap: {
        animation: "ANIMATION",
        dataSource: "DATA_SOURCE",
        palette: "PALETTE",
        paletteExtensionMode: "PALETTE",
        legend: "FORCE_DATA_INIT",
        seriesTemplate: "FORCE_DATA_INIT",
        export: "FORCE_RENDER",
        valueAxis: "AXES_AND_PANES",
        argumentAxis: "AXES_AND_PANES",
        commonAxisSettings: "AXES_AND_PANES",
        panes: "AXES_AND_PANES",
        commonPaneSettings: "AXES_AND_PANES",
        defaultPane: "AXES_AND_PANES",
        containerBackgroundColor: "AXES_AND_PANES",
        rotated: "ROTATED",
        autoHidePointMarkers: "REFRESH_SERIES_REINIT",
        customizePoint: "REFRESH_SERIES_REINIT",
        customizeLabel: "REFRESH_SERIES_REINIT",
        scrollBar: "SCROLL_BAR"
    },
    _optionChangesOrder: [
        "ROTATED",
        "PALETTE",
        "REFRESH_SERIES_REINIT",
        "USE_SPIDER_WEB",
        "AXES_AND_PANES",
        "INIT",
        "REINIT",
        "DATA_SOURCE",
        "REFRESH_SERIES_DATA_INIT",
        "DATA_INIT",
        "FORCE_DATA_INIT",
        "REFRESH_AXES",
        "CORRECT_AXIS"
    ],
    _customChangesOrder: [
        "ANIMATION",
        "REFRESH_SERIES_FAMILIES",
        "FORCE_FIRST_DRAWING",
        "FORCE_DRAWING",
        "FORCE_RENDER",
        "VISUAL_RANGE",
        "SCROLL_BAR",
        "REINIT",
        "REFRESH",
        "FULL_RENDER"
    ],
    _change_ANIMATION () {
        this._renderer.updateAnimationOptions(this._getAnimationOptions());
    },
    _change_DATA_SOURCE () {
        this._needHandleRenderComplete = true;
        this._updateDataSource();
    },
    _change_PALETTE () {
        this._themeManager.updatePalette();
        this._refreshSeries("DATA_INIT");
    },
    _change_REFRESH_SERIES_DATA_INIT () {
        this._refreshSeries("DATA_INIT");
    },
    _change_DATA_INIT () {
        if ((!this.series || this.needToPopulateSeries) && !this._changes.has("FORCE_DATA_INIT")) this._dataInit();
    },
    _change_FORCE_DATA_INIT () {
        this._dataInit();
    },
    _change_REFRESH_SERIES_FAMILIES () {
        this._processSeriesFamilies();
        this._populateBusinessRange();
        this._processRefreshData($5ab78c3feee42cb7$var$FORCE_RENDER_REFRESH_ACTION);
    },
    _change_FORCE_RENDER () {
        this._processRefreshData($5ab78c3feee42cb7$var$FORCE_RENDER_REFRESH_ACTION);
    },
    _change_AXES_AND_PANES () {
        this._refreshSeries("INIT");
    },
    _change_ROTATED () {
        this._createScrollBar();
        this._refreshSeries("INIT");
    },
    _change_REFRESH_SERIES_REINIT () {
        this._refreshSeries("INIT");
    },
    _change_REFRESH_AXES () {
        (0, $dw9tZ.setCanvasValues)(this._canvas);
        this._reinitAxes();
        this._requestChange([
            "CORRECT_AXIS",
            "FULL_RENDER"
        ]);
    },
    _change_SCROLL_BAR () {
        this._createScrollBar();
        this._processRefreshData($5ab78c3feee42cb7$var$FORCE_RENDER_REFRESH_ACTION);
    },
    _change_REINIT () {
        this._processRefreshData($5ab78c3feee42cb7$var$REINIT_REFRESH_ACTION);
    },
    _change_FORCE_DRAWING () {
        this._resetComponentsAnimation();
    },
    _change_FORCE_FIRST_DRAWING () {
        this._resetComponentsAnimation(true);
    },
    _resetComponentsAnimation (isFirstDrawing) {
        this.series.forEach((s)=>{
            s.resetApplyingAnimation(isFirstDrawing);
        });
        this._resetAxesAnimation(isFirstDrawing);
    },
    _resetAxesAnimation: (0, $gcp4g.noop),
    _refreshSeries (actionName) {
        this.needToPopulateSeries = true;
        this._requestChange([
            actionName
        ]);
    },
    _change_CORRECT_AXIS () {
        this._correctAxes();
    },
    _doRefresh () {
        var methodName = this._currentRefreshData;
        if (methodName) {
            this._currentRefreshData = null;
            this._renderer.stopAllAnimations(true);
            this[methodName]();
        }
    },
    _updateCanvasClipRect (canvas) {
        var width = Math.max(canvas.width - canvas.left - canvas.right, 0);
        var height = Math.max(canvas.height - canvas.top - canvas.bottom, 0);
        this._canvasClipRect.attr({
            x: canvas.left,
            y: canvas.top,
            width: width,
            height: height
        });
        this._backgroundRect.attr({
            x: canvas.left,
            y: canvas.top,
            width: width,
            height: height
        });
    },
    _getCanvasClipRectID () {
        return this._canvasClipRect.id;
    },
    _dataSourceChangedHandler () {
        if (this._changes.has("INIT")) this._requestChange([
            "DATA_INIT"
        ]);
        else this._requestChange([
            "FORCE_DATA_INIT"
        ]);
    },
    _dataInit () {
        this._dataSpecificInit(true);
    },
    _processSingleSeries (singleSeries) {
        singleSeries.createPoints(false);
    },
    _handleSeriesDataUpdated () {
        if (this._getVisibleSeries().some((s)=>s.useAggregation())) this._populateMarginOptions();
        this.series.forEach((s)=>this._processSingleSeries(s), this);
    },
    _dataSpecificInit (needRedraw) {
        if (!this.series || this.needToPopulateSeries) this.series = this._populateSeries();
        this._repopulateSeries();
        this._seriesPopulatedHandlerCore();
        this._populateBusinessRange();
        this._tracker.updateSeries(this.series, this._changes.has("INIT"));
        this._updateLegend();
        if (needRedraw) this._requestChange([
            "FULL_RENDER"
        ]);
    },
    _forceRender () {
        this._doRender({
            force: true
        });
    },
    _repopulateSeries () {
        var themeManager = this._themeManager;
        var data = this._dataSourceItems();
        var dataValidatorOptions = themeManager.getOptions("dataPrepareSettings");
        var seriesTemplate = themeManager.getOptions("seriesTemplate");
        if (seriesTemplate) this._populateSeries(data);
        this._groupSeries();
        var parsedData = (0, $6Ztqs.validateData)(data, this._groupsData, this._incidentOccurred, dataValidatorOptions);
        themeManager.resetPalette();
        this.series.forEach((singleSeries)=>{
            singleSeries.updateData(parsedData[singleSeries.getArgumentField()]);
        });
        this._handleSeriesDataUpdated();
    },
    _renderCompleteHandler () {
        var allSeriesInited = true;
        if (this._needHandleRenderComplete) {
            this.series.forEach((s)=>{
                allSeriesInited = allSeriesInited && s.canRenderCompleteHandle();
            });
            if (allSeriesInited) {
                this._needHandleRenderComplete = false;
                this._eventTrigger("done", {
                    target: this
                });
            }
        }
    },
    _dataIsReady () {
        return (0, $6ntMu.isDefined)(this.option("dataSource")) && this._dataIsLoaded();
    },
    _populateSeriesOptions (data) {
        var themeManager = this._themeManager;
        var seriesTemplate = themeManager.getOptions("seriesTemplate");
        var seriesOptions = seriesTemplate ? (0, $dw9tZ.processSeriesTemplate)(seriesTemplate, data || []) : this.option("series");
        var allSeriesOptions = $5ab78c3feee42cb7$var$isArray(seriesOptions) ? seriesOptions : seriesOptions ? [
            seriesOptions
        ] : [];
        var extraOptions = this._getExtraOptions();
        var particularSeriesOptions;
        var seriesTheme;
        var seriesThemes = [];
        var seriesVisibilityChanged = (target)=>{
            this._specialProcessSeries();
            this._populateBusinessRange(target && target.getValueAxis(), true);
            this._renderer.stopAllAnimations(true);
            this._updateLegend();
            this._requestChange([
                "FULL_RENDER"
            ]);
        };
        for(var i = 0; i < allSeriesOptions.length; i++){
            particularSeriesOptions = (0, $2oTOp.extend)(true, {}, allSeriesOptions[i], extraOptions);
            if (!(0, $6ntMu.isDefined)(particularSeriesOptions.name) || "" === particularSeriesOptions.name) particularSeriesOptions.name = "Series ".concat((i + 1).toString());
            particularSeriesOptions.rotated = this._isRotated();
            particularSeriesOptions.customizePoint = themeManager.getOptions("customizePoint");
            particularSeriesOptions.customizeLabel = themeManager.getOptions("customizeLabel");
            particularSeriesOptions.visibilityChanged = seriesVisibilityChanged;
            particularSeriesOptions.incidentOccurred = this._incidentOccurred;
            seriesTheme = themeManager.getOptions("series", particularSeriesOptions, allSeriesOptions.length);
            if (this._checkPaneName(seriesTheme)) seriesThemes.push(seriesTheme);
        }
        return seriesThemes;
    },
    _populateSeries (data) {
        var _a;
        var seriesBasis = [];
        var incidentOccurred = this._incidentOccurred;
        var seriesThemes = this._populateSeriesOptions(data);
        var particularSeries;
        var disposeSeriesFamilies = false;
        this.needToPopulateSeries = false;
        seriesThemes.forEach((theme)=>{
            var _a;
            var curSeries = null === (_a = this.series) || void 0 === _a ? void 0 : _a.find((s)=>s.name === theme.name && !seriesBasis.map((sb)=>sb.series).includes(s));
            if (curSeries && curSeries.type === theme.type) seriesBasis.push({
                series: curSeries,
                options: theme
            });
            else {
                seriesBasis.push({
                    options: theme
                });
                disposeSeriesFamilies = true;
            }
        });
        0 !== (null === (_a = this.series) || void 0 === _a ? void 0 : _a.length) && this._tracker.clearHover();
        (0, $8OLOW.reverseEach)(this.series, (index, series)=>{
            if (!seriesBasis.some((s)=>series === s.series)) {
                this._disposeSeries(index);
                disposeSeriesFamilies = true;
            }
        });
        !disposeSeriesFamilies && (disposeSeriesFamilies = seriesBasis.some((sb)=>sb.series.name !== seriesThemes[sb.series.index].name));
        this.series = [];
        disposeSeriesFamilies && this._disposeSeriesFamilies();
        this._themeManager.resetPalette();
        var eventPipe = (data)=>{
            this.series.forEach((currentSeries)=>{
                currentSeries.notify(data);
            });
        };
        seriesBasis.forEach((basis)=>{
            var _a, _b;
            var seriesTheme = basis.options;
            var argumentAxis = null !== (_b = null === (_a = this._argumentAxes) || void 0 === _a ? void 0 : _a.filter((a)=>a.pane === seriesTheme.pane)[0]) && void 0 !== _b ? _b : this.getArgumentAxis();
            var renderSettings = {
                commonSeriesModes: this._getSelectionModes(),
                argumentAxis: argumentAxis,
                valueAxis: this._getValueAxis(seriesTheme.pane, seriesTheme.axis)
            };
            if (basis.series) {
                particularSeries = basis.series;
                particularSeries.updateOptions(seriesTheme, renderSettings);
            } else particularSeries = new (0, $2Vk35.Series)((0, $2oTOp.extend)({
                renderer: this._renderer,
                seriesGroup: this._seriesGroup,
                labelsGroup: this._labelsGroup,
                eventTrigger: this._eventTrigger,
                eventPipe: eventPipe,
                incidentOccurred: incidentOccurred
            }, renderSettings), seriesTheme);
            if (!particularSeries.isUpdated) incidentOccurred("E2101", [
                seriesTheme.type
            ]);
            else {
                particularSeries.index = this.series.length;
                this.series.push(particularSeries);
            }
        });
        return this.series;
    },
    getStackedPoints (point) {
        var stackName = point.series.getStackName();
        return this._getVisibleSeries().reduce((stackPoints, series)=>{
            if (!(0, $6ntMu.isDefined)(series.getStackName()) || !(0, $6ntMu.isDefined)(stackName) || stackName === series.getStackName()) stackPoints = stackPoints.concat(series.getPointsByArg(point.argument));
            return stackPoints;
        }, []);
    },
    getAllSeries: function() {
        return (this.series || []).slice();
    },
    getSeriesByName: function(name) {
        var found = (this.series || []).find((singleSeries)=>singleSeries.name === name);
        return found || null;
    },
    getSeriesByPos: function(pos) {
        return (this.series || [])[pos];
    },
    clearSelection: function() {
        this._tracker.clearSelection();
    },
    hideTooltip () {
        this._tracker._hideTooltip();
    },
    clearHover () {
        this._tracker.clearHover();
    },
    render (renderOptions) {
        this.__renderOptions = renderOptions;
        this.__forceRender = renderOptions && renderOptions.force;
        this.callBase.apply(this, arguments);
        this.__renderOptions = this.__forceRender = null;
        return this;
    },
    refresh () {
        this._disposeSeries();
        this._disposeSeriesFamilies();
        this._requestChange([
            "CONTAINER_SIZE",
            "REFRESH_SERIES_REINIT"
        ]);
    },
    _getMinSize () {
        var adaptiveLayout = this._layoutManagerOptions();
        return [
            adaptiveLayout.width,
            adaptiveLayout.height
        ];
    },
    _change_REFRESH () {
        if (!this._changes.has("INIT")) this._doRefresh();
        else this._currentRefreshData = null;
    },
    _change_FULL_RENDER () {
        this._forceRender();
    },
    _change_INIT () {
        this._reinit();
    },
    _stopCurrentHandling () {
        this._tracker.stopCurrentHandling();
    }
});
$5ab78c3feee42cb7$var$REFRESH_SERIES_DATA_INIT_ACTION_OPTIONS.forEach((name)=>{
    $5ab78c3feee42cb7$export$ba89768bd61fb9ef.prototype._optionChangesMap[name] = "REFRESH_SERIES_DATA_INIT";
});
$5ab78c3feee42cb7$var$FORCE_RENDER_REFRESH_ACTION_OPTIONS.forEach((name)=>{
    $5ab78c3feee42cb7$export$ba89768bd61fb9ef.prototype._optionChangesMap[name] = "FORCE_RENDER";
});
$5ab78c3feee42cb7$var$REFRESH_SERIES_FAMILIES_ACTION_OPTIONS.forEach((name)=>{
    $5ab78c3feee42cb7$export$ba89768bd61fb9ef.prototype._optionChangesMap[name] = "REFRESH_SERIES_FAMILIES";
});
$5ab78c3feee42cb7$export$ba89768bd61fb9ef.addPlugin((0, $5Z13B.plugin));
$5ab78c3feee42cb7$export$ba89768bd61fb9ef.addPlugin((0, $a0Hpu.plugin));
$5ab78c3feee42cb7$export$ba89768bd61fb9ef.addPlugin((0, $7AWWW.plugin));
$5ab78c3feee42cb7$export$ba89768bd61fb9ef.addPlugin((0, $6NEbp.plugin));
$5ab78c3feee42cb7$export$ba89768bd61fb9ef.addPlugin((0, $jM2K9.plugin));
var { _change_TITLE: $5ab78c3feee42cb7$var$_change_TITLE } = $5ab78c3feee42cb7$export$ba89768bd61fb9ef.prototype;
$5ab78c3feee42cb7$export$ba89768bd61fb9ef.prototype._change_TITLE = function() {
    $5ab78c3feee42cb7$var$_change_TITLE.apply(this, arguments);
    this._change([
        "FORCE_RENDER"
    ]);
};

});
parcelRegister("e6jz0", function(module, exports) {

$parcel$export(module.exports, "LayoutManager", function () { return $a440cd249f2c46bc$export$4a04ad01c410b415; });
/**
 * DevExtreme (esm/viz/chart_components/layout_manager.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $8LJ26 = parcelRequire("8LJ26");

var $ksd2I = parcelRequire("ksd2I");
var { floor: $a440cd249f2c46bc$var$floor, sqrt: $a440cd249f2c46bc$var$sqrt } = Math;
var $a440cd249f2c46bc$var$_min = Math.min;
var $a440cd249f2c46bc$var$_max = Math.max;
var $a440cd249f2c46bc$var$DEFAULT_INNER_RADIUS = .5;
var $a440cd249f2c46bc$var$RADIAL_LABEL_INDENT = (0, $8LJ26.default).radialLabelIndent;
function $a440cd249f2c46bc$var$getNearestCoord(firstCoord, secondCoord, pointCenterCoord) {
    var nearestCoord;
    if (pointCenterCoord < firstCoord) nearestCoord = firstCoord;
    else if (secondCoord < pointCenterCoord) nearestCoord = secondCoord;
    else nearestCoord = pointCenterCoord;
    return nearestCoord;
}
function $a440cd249f2c46bc$var$getLabelLayout(point) {
    if (point._label.isVisible() && "inside" !== point._label.getLayoutOptions().position) return point._label.getBoundingRect();
}
function $a440cd249f2c46bc$var$getPieRadius(series, paneCenterX, paneCenterY, accessibleRadius, minR) {
    series.some(function(singleSeries) {
        return singleSeries.getVisiblePoints().reduce(function(radiusIsFound, point) {
            var labelBBox = $a440cd249f2c46bc$var$getLabelLayout(point);
            if (labelBBox) {
                var xCoords = $a440cd249f2c46bc$var$getNearestCoord(labelBBox.x, labelBBox.x + labelBBox.width, paneCenterX);
                var yCoords = $a440cd249f2c46bc$var$getNearestCoord(labelBBox.y, labelBBox.y + labelBBox.height, paneCenterY);
                accessibleRadius = $a440cd249f2c46bc$var$_min($a440cd249f2c46bc$var$_max($a440cd249f2c46bc$var$getLengthFromCenter(xCoords, yCoords, paneCenterX, paneCenterY) - $a440cd249f2c46bc$var$RADIAL_LABEL_INDENT, minR), accessibleRadius);
                radiusIsFound = true;
            }
            return radiusIsFound;
        }, false);
    });
    return accessibleRadius;
}
function $a440cd249f2c46bc$var$getSizeLabels(series) {
    return series.reduce(function(res, singleSeries) {
        var maxWidth = singleSeries.getVisiblePoints().reduce(function(width, point) {
            var labelBBox = $a440cd249f2c46bc$var$getLabelLayout(point);
            if (labelBBox && labelBBox.width > width) width = labelBBox.width;
            return width;
        }, 0);
        var rWidth = maxWidth;
        if (maxWidth) {
            res.outerLabelsCount++;
            if (res.outerLabelsCount > 1) maxWidth += (0, $8LJ26.default).pieLabelSpacing;
            rWidth += (0, $8LJ26.default).pieLabelSpacing;
        }
        res.sizes.push(maxWidth);
        res.rSizes.push(rWidth);
        res.common += maxWidth;
        return res;
    }, {
        sizes: [],
        rSizes: [],
        common: 0,
        outerLabelsCount: 0
    });
}
function $a440cd249f2c46bc$var$correctLabelRadius(labelSizes, radius, series, canvas, averageWidthLabels, centerX) {
    var curRadius;
    var i;
    var runningWidth = 0;
    var sizes = labelSizes.sizes;
    var rSizes = labelSizes.rSizes;
    for(i = 0; i < series.length; i++){
        if (0 === sizes[i]) {
            curRadius && (curRadius += rSizes[i - 1]);
            continue;
        }
        curRadius = $a440cd249f2c46bc$var$floor(curRadius ? curRadius + rSizes[i - 1] : radius);
        series[i].correctLabelRadius(curRadius);
        runningWidth += averageWidthLabels || sizes[i];
        rSizes[i] = averageWidthLabels || rSizes[i];
        series[i].setVisibleArea({
            left: $a440cd249f2c46bc$var$floor(centerX - radius - runningWidth),
            right: $a440cd249f2c46bc$var$floor(canvas.width - (centerX + radius + runningWidth)),
            top: canvas.top,
            bottom: canvas.bottom,
            width: canvas.width,
            height: canvas.height
        });
    }
}
function $a440cd249f2c46bc$var$getLengthFromCenter(x, y, paneCenterX, paneCenterY) {
    return $a440cd249f2c46bc$var$sqrt((x - paneCenterX) * (x - paneCenterX) + (y - paneCenterY) * (y - paneCenterY));
}
function $a440cd249f2c46bc$var$getInnerRadius(_ref) {
    var { type: type, innerRadius: innerRadius } = _ref;
    return "pie" === type ? 0 : (0, $6ntMu.isNumeric)(innerRadius) ? Number(innerRadius) : $a440cd249f2c46bc$var$DEFAULT_INNER_RADIUS;
}
function $a440cd249f2c46bc$export$4a04ad01c410b415() {}
function $a440cd249f2c46bc$var$getAverageLabelWidth(centerX, radius, canvas, sizeLabels) {
    return (centerX - radius - $a440cd249f2c46bc$var$RADIAL_LABEL_INDENT - canvas.left) / sizeLabels.outerLabelsCount;
}
function $a440cd249f2c46bc$var$getFullRadiusWithLabels(centerX, canvas, sizeLabels) {
    return centerX - canvas.left - (sizeLabels.outerLabelsCount > 0 ? sizeLabels.common + $a440cd249f2c46bc$var$RADIAL_LABEL_INDENT : 0);
}
function $a440cd249f2c46bc$var$correctAvailableRadius(availableRadius, canvas, series, minR, paneCenterX, paneCenterY) {
    var sizeLabels = $a440cd249f2c46bc$var$getSizeLabels(series);
    var averageWidthLabels;
    var fullRadiusWithLabels = $a440cd249f2c46bc$var$getFullRadiusWithLabels(paneCenterX, canvas, sizeLabels);
    if (fullRadiusWithLabels < minR) {
        availableRadius = minR;
        averageWidthLabels = $a440cd249f2c46bc$var$getAverageLabelWidth(paneCenterX, availableRadius, canvas, sizeLabels);
    } else availableRadius = $a440cd249f2c46bc$var$_min($a440cd249f2c46bc$var$getPieRadius(series, paneCenterX, paneCenterY, availableRadius, minR), fullRadiusWithLabels);
    $a440cd249f2c46bc$var$correctLabelRadius(sizeLabels, availableRadius + $a440cd249f2c46bc$var$RADIAL_LABEL_INDENT, series, canvas, averageWidthLabels, paneCenterX);
    return availableRadius;
}
function $a440cd249f2c46bc$var$toLayoutElementCoords(canvas) {
    return new (0, $ksd2I.WrapperLayoutElement)(null, {
        x: canvas.left,
        y: canvas.top,
        width: canvas.width - canvas.left - canvas.right,
        height: canvas.height - canvas.top - canvas.bottom
    });
}
$a440cd249f2c46bc$export$4a04ad01c410b415.prototype = {
    constructor: $a440cd249f2c46bc$export$4a04ad01c410b415,
    setOptions: function(options) {
        this._options = options;
    },
    applyPieChartSeriesLayout: function(canvas, series, hideLayoutLabels) {
        var paneSpaceHeight = canvas.height - canvas.top - canvas.bottom;
        var paneSpaceWidth = canvas.width - canvas.left - canvas.right;
        var paneCenterX = paneSpaceWidth / 2 + canvas.left;
        var paneCenterY = paneSpaceHeight / 2 + canvas.top;
        var piePercentage = this._options.piePercentage;
        var availableRadius;
        var minR;
        if ((0, $6ntMu.isNumeric)(piePercentage)) availableRadius = minR = piePercentage * $a440cd249f2c46bc$var$_min(canvas.height, canvas.width) / 2;
        else {
            availableRadius = $a440cd249f2c46bc$var$_min(paneSpaceWidth, paneSpaceHeight) / 2;
            minR = this._options.minPiePercentage * availableRadius;
        }
        if (!hideLayoutLabels) availableRadius = $a440cd249f2c46bc$var$correctAvailableRadius(availableRadius, canvas, series, minR, paneCenterX, paneCenterY);
        return {
            centerX: $a440cd249f2c46bc$var$floor(paneCenterX),
            centerY: $a440cd249f2c46bc$var$floor(paneCenterY),
            radiusInner: $a440cd249f2c46bc$var$floor(availableRadius * $a440cd249f2c46bc$var$getInnerRadius(series[0])),
            radiusOuter: $a440cd249f2c46bc$var$floor(availableRadius)
        };
    },
    applyEqualPieChartLayout: function(series, layout) {
        var radius = layout.radius;
        return {
            centerX: $a440cd249f2c46bc$var$floor(layout.x),
            centerY: $a440cd249f2c46bc$var$floor(layout.y),
            radiusInner: $a440cd249f2c46bc$var$floor(radius * $a440cd249f2c46bc$var$getInnerRadius(series[0])),
            radiusOuter: $a440cd249f2c46bc$var$floor(radius)
        };
    },
    correctPieLabelRadius: function(series, layout, canvas) {
        var sizeLabels = $a440cd249f2c46bc$var$getSizeLabels(series);
        var averageWidthLabels;
        var radius = layout.radiusOuter + $a440cd249f2c46bc$var$RADIAL_LABEL_INDENT;
        var availableLabelWidth = layout.centerX - canvas.left - radius;
        if (sizeLabels.common + $a440cd249f2c46bc$var$RADIAL_LABEL_INDENT > availableLabelWidth) averageWidthLabels = $a440cd249f2c46bc$var$getAverageLabelWidth(layout.centerX, layout.radiusOuter, canvas, sizeLabels);
        $a440cd249f2c46bc$var$correctLabelRadius(sizeLabels, radius, series, canvas, averageWidthLabels, layout.centerX);
    },
    needMoreSpaceForPanesCanvas (panes, rotated, fixedSizeCallback) {
        var options = this._options;
        var width = options.width;
        var height = options.height;
        var piePercentage = options.piePercentage;
        var percentageIsValid = (0, $6ntMu.isNumeric)(piePercentage);
        var needHorizontalSpace = 0;
        var needVerticalSpace = 0;
        panes.forEach((pane)=>{
            var paneCanvas = pane.canvas;
            var minSize = percentageIsValid ? $a440cd249f2c46bc$var$_min(paneCanvas.width, paneCanvas.height) * piePercentage : void 0;
            var paneSized = fixedSizeCallback ? fixedSizeCallback(pane) : {
                width: false,
                height: false
            };
            var needPaneHorizontalSpace = !paneSized.width ? (percentageIsValid ? minSize : width) - (paneCanvas.width - paneCanvas.left - paneCanvas.right) : 0;
            var needPaneVerticalSpace = !paneSized.height ? (percentageIsValid ? minSize : height) - (paneCanvas.height - paneCanvas.top - paneCanvas.bottom) : 0;
            if (rotated) {
                needHorizontalSpace += needPaneHorizontalSpace > 0 ? needPaneHorizontalSpace : 0;
                needVerticalSpace = $a440cd249f2c46bc$var$_max(needPaneVerticalSpace > 0 ? needPaneVerticalSpace : 0, needVerticalSpace);
            } else {
                needHorizontalSpace = $a440cd249f2c46bc$var$_max(needPaneHorizontalSpace > 0 ? needPaneHorizontalSpace : 0, needHorizontalSpace);
                needVerticalSpace += needPaneVerticalSpace > 0 ? needPaneVerticalSpace : 0;
            }
        });
        return needHorizontalSpace > 0 || needVerticalSpace > 0 ? {
            width: needHorizontalSpace,
            height: needVerticalSpace
        } : false;
    },
    layoutInsideLegend: function(legend, canvas) {
        var layoutOptions = legend.getLayoutOptions();
        if (!layoutOptions) return;
        var position = layoutOptions.position;
        var cutSide = layoutOptions.cutSide;
        var my = {
            horizontal: position.horizontal,
            vertical: position.vertical
        };
        canvas[layoutOptions.cutLayoutSide] += "horizontal" === layoutOptions.cutSide ? layoutOptions.width : layoutOptions.height;
        my[cutSide] = ({
            left: "right",
            right: "left",
            top: "bottom",
            bottom: "top",
            center: "center"
        })[my[cutSide]];
        legend.position({
            of: $a440cd249f2c46bc$var$toLayoutElementCoords(canvas),
            my: my,
            at: position
        });
    }
};

});
parcelRegister("ksd2I", function(module, exports) {

$parcel$export(module.exports, "LayoutElement", function () { return $ee408a34336c5c02$export$3e02c2e3708bf4e3; });
$parcel$export(module.exports, "WrapperLayoutElement", function () { return $ee408a34336c5c02$export$9854e20d4881db44; });
/**
 * DevExtreme (esm/viz/core/layout_element.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $gcp4g = parcelRequire("gcp4g");

var $5VpUx = parcelRequire("5VpUx");
var $ee408a34336c5c02$var$_round = Math.round;
var $ee408a34336c5c02$var$defaultOffset = {
    horizontal: 0,
    vertical: 0
};
var $ee408a34336c5c02$var$alignFactors = {
    center: .5,
    right: 1,
    bottom: 1,
    left: 0,
    top: 0
};
function $ee408a34336c5c02$export$3e02c2e3708bf4e3(options) {
    this._options = options;
}
$ee408a34336c5c02$export$3e02c2e3708bf4e3.prototype = {
    constructor: $ee408a34336c5c02$export$3e02c2e3708bf4e3,
    position: function(options) {
        var ofBBox = options.of.getLayoutOptions();
        var myBBox = this.getLayoutOptions();
        var at = options.at;
        var my = options.my;
        var offset = options.offset || $ee408a34336c5c02$var$defaultOffset;
        var shiftX = -$ee408a34336c5c02$var$alignFactors[my.horizontal] * myBBox.width + ofBBox.x + $ee408a34336c5c02$var$alignFactors[at.horizontal] * ofBBox.width + parseInt(offset.horizontal);
        var shiftY = -$ee408a34336c5c02$var$alignFactors[my.vertical] * myBBox.height + ofBBox.y + $ee408a34336c5c02$var$alignFactors[at.vertical] * ofBBox.height + parseInt(offset.vertical);
        this.shift($ee408a34336c5c02$var$_round(shiftX), $ee408a34336c5c02$var$_round(shiftY));
    },
    getLayoutOptions: (0, $gcp4g.noop)
};
function $ee408a34336c5c02$export$9854e20d4881db44(renderElement, bBox) {
    this._renderElement = renderElement;
    this._cacheBBox = bBox;
}
var $ee408a34336c5c02$var$wrapperLayoutElementPrototype = $ee408a34336c5c02$export$9854e20d4881db44.prototype = (0, $5VpUx.clone)($ee408a34336c5c02$export$3e02c2e3708bf4e3.prototype);
$ee408a34336c5c02$var$wrapperLayoutElementPrototype.constructor = $ee408a34336c5c02$export$9854e20d4881db44;
$ee408a34336c5c02$var$wrapperLayoutElementPrototype.getLayoutOptions = function() {
    return this._cacheBBox || this._renderElement.getBBox();
};
$ee408a34336c5c02$var$wrapperLayoutElementPrototype.shift = function(shiftX, shiftY) {
    var bBox = this.getLayoutOptions();
    this._renderElement.move($ee408a34336c5c02$var$_round(shiftX - bBox.x), $ee408a34336c5c02$var$_round(shiftY - bBox.y));
};

});


parcelRegister("hHPaz", function(module, exports) {

$parcel$export(module.exports, "ChartTracker", function () { return $ce3e2509d4dd1c2c$export$bf1e0f269b8cf9a4; });
$parcel$export(module.exports, "PieTracker", function () { return $ce3e2509d4dd1c2c$export$e899b88c874f0500; });
/**
 * DevExtreme (esm/viz/chart_components/tracker.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $3yzYM = parcelRequire("3yzYM");

var $60GuF = parcelRequire("60GuF");

var $bfcCm = parcelRequire("bfcCm");

var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $8LJ26 = parcelRequire("8LJ26");

var $dw9tZ = parcelRequire("dw9tZ");

var $cgnQR = parcelRequire("cgnQR");

var $bcOMe = parcelRequire("bcOMe");

var $6ntMu = parcelRequire("6ntMu");

var $gcp4g = parcelRequire("gcp4g");

var $cvYFL = parcelRequire("cvYFL");
var $ce3e2509d4dd1c2c$var$_floor = Math.floor;
var $ce3e2509d4dd1c2c$var$eventsConsts = (0, $8LJ26.default).events;
var $ce3e2509d4dd1c2c$var$statesConsts = (0, $8LJ26.default).states;
var $ce3e2509d4dd1c2c$var$HOVER_STATE = $ce3e2509d4dd1c2c$var$statesConsts.hoverMark;
var $ce3e2509d4dd1c2c$var$NORMAL_STATE = $ce3e2509d4dd1c2c$var$statesConsts.normalMark;
var $ce3e2509d4dd1c2c$var$EVENT_NS = "dxChartTracker";
var $ce3e2509d4dd1c2c$var$DOT_EVENT_NS = "." + $ce3e2509d4dd1c2c$var$EVENT_NS;
var $ce3e2509d4dd1c2c$var$POINTER_ACTION = (0, $bcOMe.addNamespace)([
    (0, $cgnQR.default).down,
    (0, $cgnQR.default).move
], $ce3e2509d4dd1c2c$var$EVENT_NS);
var $ce3e2509d4dd1c2c$var$LEGEND_CLICK = "legendClick";
var $ce3e2509d4dd1c2c$var$SERIES_CLICK = "seriesClick";
var $ce3e2509d4dd1c2c$var$POINT_CLICK = "pointClick";
var $ce3e2509d4dd1c2c$var$POINT_DATA = "chart-data-point";
var $ce3e2509d4dd1c2c$var$SERIES_DATA = "chart-data-series";
var $ce3e2509d4dd1c2c$var$ARG_DATA = "chart-data-argument";
var $ce3e2509d4dd1c2c$var$DELAY = 100;
var $ce3e2509d4dd1c2c$var$HOLD_TIMEOUT = 300;
var $ce3e2509d4dd1c2c$var$NONE_MODE = "none";
var $ce3e2509d4dd1c2c$var$ALL_ARGUMENT_POINTS_MODE = "allargumentpoints";
var $ce3e2509d4dd1c2c$var$INCLUDE_POINTS_MODE = "includepoints";
var $ce3e2509d4dd1c2c$var$EXLUDE_POINTS_MODE = "excludepoints";
var $ce3e2509d4dd1c2c$var$LEGEND_HOVER_MODES = [
    $ce3e2509d4dd1c2c$var$INCLUDE_POINTS_MODE,
    $ce3e2509d4dd1c2c$var$EXLUDE_POINTS_MODE,
    $ce3e2509d4dd1c2c$var$NONE_MODE
];
function $ce3e2509d4dd1c2c$var$getData(event, dataKey, tryCheckParent) {
    var target = event.target;
    if ("tspan" === target.tagName) return target.parentNode[dataKey];
    var data = target[dataKey];
    if (tryCheckParent && !(0, $6ntMu.isDefined)(data)) return function getParentData(node) {
        if (node.parentNode) {
            if ((0, $6ntMu.isDefined)(node.parentNode[dataKey])) return node.parentNode[dataKey];
            else return getParentData(node.parentNode);
        }
        return;
    }(target);
    return data;
}
function $ce3e2509d4dd1c2c$var$eventCanceled(_ref, target, clickTarget) {
    var { event: event, cancel: cancel } = _ref;
    var deprecatedCancel = event.cancel;
    var eventCanceled = cancel || deprecatedCancel;
    if (deprecatedCancel) (0, $cvYFL.default).log("W0003", "".concat(clickTarget, "Click handler argument"), "event.cancel", "22.1", "Use the 'cancel' field instead");
    return eventCanceled || !target.getOptions();
}
function $ce3e2509d4dd1c2c$var$correctLegendHoverMode(mode) {
    if ($ce3e2509d4dd1c2c$var$LEGEND_HOVER_MODES.indexOf(mode) > -1) return mode;
    else return $ce3e2509d4dd1c2c$var$INCLUDE_POINTS_MODE;
}
function $ce3e2509d4dd1c2c$var$correctHoverMode(target) {
    var mode = target.getOptions().hoverMode;
    return mode === $ce3e2509d4dd1c2c$var$NONE_MODE ? mode : $ce3e2509d4dd1c2c$var$ALL_ARGUMENT_POINTS_MODE;
}
var $ce3e2509d4dd1c2c$var$baseTrackerPrototype = {
    ctor: function(options) {
        var that = this;
        var data = {
            tracker: that
        };
        that._renderer = options.renderer;
        that._legend = options.legend;
        that._tooltip = options.tooltip;
        that._eventTrigger = options.eventTrigger;
        that._seriesGroup = options.seriesGroup;
        options.seriesGroup.off($ce3e2509d4dd1c2c$var$DOT_EVENT_NS).on((0, $bcOMe.addNamespace)($ce3e2509d4dd1c2c$var$eventsConsts.showPointTooltip, $ce3e2509d4dd1c2c$var$EVENT_NS), data, that._showPointTooltip).on((0, $bcOMe.addNamespace)($ce3e2509d4dd1c2c$var$eventsConsts.hidePointTooltip, $ce3e2509d4dd1c2c$var$EVENT_NS), data, that._hidePointTooltip);
        that._renderer.root.off($ce3e2509d4dd1c2c$var$DOT_EVENT_NS).on($ce3e2509d4dd1c2c$var$POINTER_ACTION, data, that._pointerHandler).on((0, $bcOMe.addNamespace)((0, $cgnQR.default).up, $ce3e2509d4dd1c2c$var$EVENT_NS), ()=>clearTimeout(that._holdTimer)).on((0, $bcOMe.addNamespace)((0, $bfcCm.name), $ce3e2509d4dd1c2c$var$EVENT_NS), data, that._clickHandler);
    },
    update: function(options) {
        this._chart = options.chart;
    },
    updateSeries (series, resetDecorations) {
        var that = this;
        var noHoveredSeries = !(null !== series && void 0 !== series && series.some((s)=>s === that.hoveredSeries) || that._hoveredPoint && that._hoveredPoint.series);
        if (that._storedSeries !== series) that._storedSeries = series || [];
        if (noHoveredSeries) {
            that._clean();
            that._renderer.initHatching();
        }
        if (resetDecorations) {
            that.clearSelection();
            if (!noHoveredSeries) {
                that._hideTooltip(that.pointAtShownTooltip);
                that.clearHover();
            }
        }
    },
    setCanvases: function(mainCanvas, paneCanvases) {
        this._mainCanvas = mainCanvas;
        this._canvases = paneCanvases;
    },
    repairTooltip: function() {
        var point = this.pointAtShownTooltip;
        if (!point || !point.series || !point.isVisible()) this._hideTooltip(point, true);
        else this._showTooltip(point);
    },
    _setHoveredPoint: function(point) {
        if (point === this._hoveredPoint) return;
        this._releaseHoveredPoint();
        point.hover();
        this._hoveredPoint = point;
    },
    _releaseHoveredPoint: function(isPointerOut) {
        if (this._hoveredPoint && this._hoveredPoint.getOptions()) {
            this._hoveredPoint.clearHover();
            this._hoveredPoint = null;
            if (this._tooltip.isEnabled()) this._hideTooltip(this._hoveredPoint, false, isPointerOut);
        }
    },
    _setHoveredSeries: function(series, mode) {
        this._releaseHoveredSeries();
        this._releaseHoveredPoint();
        series.hover(mode);
        this.hoveredSeries = series;
    },
    _releaseHoveredSeries () {
        if (this.hoveredSeries) {
            this.hoveredSeries.clearHover();
            this.hoveredSeries = null;
        }
    },
    clearSelection () {
        this._storedSeries.forEach((series)=>{
            if (series) {
                series.clearSelection();
                series.getPoints().forEach((point)=>point.clearSelection());
            }
        });
    },
    _clean: function() {
        this.hoveredPoint = this.hoveredSeries = this._hoveredArgumentPoints = null;
        this._hideTooltip(this.pointAtShownTooltip);
    },
    clearHover: function(isPointerOut) {
        this._resetHoveredArgument();
        this._releaseHoveredSeries();
        this._releaseHoveredPoint(isPointerOut);
    },
    _hideTooltip: function(point, silent, isPointerOut) {
        if (!this._tooltip || point && this.pointAtShownTooltip !== point) return;
        if (!silent && this.pointAtShownTooltip) this.pointAtShownTooltip = null;
        this._tooltip.hide(!!isPointerOut);
    },
    _showTooltip: function(point) {
        var that = this;
        var tooltipFormatObject;
        var eventData = {
            target: point
        };
        if (null !== point && void 0 !== point && point.getOptions()) {
            tooltipFormatObject = point.getTooltipFormatObject(that._tooltip, that._tooltip.isShared() && that._chart.getStackedPoints(point));
            if (!(0, $6ntMu.isDefined)(tooltipFormatObject.valueText) && !tooltipFormatObject.points || !point.isVisible()) return;
            var coords = point.getTooltipParams(that._tooltip.getLocation());
            var rootOffset = that._renderer.getRootOffset();
            coords.x += rootOffset.left;
            coords.y += rootOffset.top;
            var callback = (result)=>{
                result && (that.pointAtShownTooltip = point);
            };
            callback(that._tooltip.show(tooltipFormatObject, coords, eventData, void 0, callback));
        }
    },
    _showPointTooltip: function(event, point) {
        var that = event.data.tracker;
        var pointWithTooltip = that.pointAtShownTooltip;
        if (pointWithTooltip && pointWithTooltip !== point) that._hideTooltip(pointWithTooltip);
        that._showTooltip(point);
    },
    _hidePointTooltip: function(event, point) {
        event.data.tracker._hideTooltip(point, false, true);
    },
    _enableOutHandler: function() {
        if (this._outHandler) return;
        var that = this;
        var handler = function(e) {
            var rootOffset = that._renderer.getRootOffset();
            var x = $ce3e2509d4dd1c2c$var$_floor(e.pageX - rootOffset.left);
            var y = $ce3e2509d4dd1c2c$var$_floor(e.pageY - rootOffset.top);
            if (!(0, $dw9tZ.pointInCanvas)(that._mainCanvas, x, y) && !that._isCursorOnTooltip(e)) {
                that._pointerOut();
                that._disableOutHandler();
            }
        };
        (0, $60GuF.default).on((0, $3yzYM.default).getDocument(), $ce3e2509d4dd1c2c$var$POINTER_ACTION, handler);
        this._outHandler = handler;
    },
    _isCursorOnTooltip: function(e) {
        return this._tooltip.isEnabled() && this._tooltip.isCursorOnTooltip(e.pageX, e.pageY);
    },
    _disableOutHandler: function() {
        this._outHandler && (0, $60GuF.default).off((0, $3yzYM.default).getDocument(), $ce3e2509d4dd1c2c$var$POINTER_ACTION, this._outHandler);
        this._outHandler = null;
    },
    stopCurrentHandling: function() {
        this._pointerOut(true);
    },
    _pointerOut: function(force) {
        this.clearHover(true);
        (force || this._tooltip.isEnabled()) && this._hideTooltip(this.pointAtShownTooltip, false, true);
    },
    _triggerLegendClick: function(eventArgs, elementClick) {
        var eventTrigger = this._eventTrigger;
        eventTrigger($ce3e2509d4dd1c2c$var$LEGEND_CLICK, eventArgs, function() {
            !$ce3e2509d4dd1c2c$var$eventCanceled(eventArgs, eventArgs.target, "legend") && eventTrigger(elementClick, eventArgs);
        });
    },
    _hoverLegendItem: function(x, y) {
        var item = this._legend.getItemByCoord(x, y);
        var series;
        var legendHoverMode = $ce3e2509d4dd1c2c$var$correctLegendHoverMode(this._legend.getOptions().hoverMode);
        if (item) {
            series = this._storedSeries[item.id];
            if (!series.isHovered() || series.lastHoverMode !== legendHoverMode) this._setHoveredSeries(series, legendHoverMode);
            this._tooltip.isEnabled() && this._hideTooltip(this.pointAtShownTooltip);
        } else this.clearHover();
    },
    _hoverArgument: function(argument, argumentIndex) {
        var hoverMode = this._getArgumentHoverMode();
        if ((0, $6ntMu.isDefined)(argument)) {
            this._releaseHoveredPoint();
            this._hoveredArgument = argument;
            this._argumentIndex = argumentIndex;
            this._notifySeries({
                action: "pointHover",
                notifyLegend: this._notifyLegendOnHoverArgument,
                target: {
                    argument: argument,
                    fullState: $ce3e2509d4dd1c2c$var$HOVER_STATE,
                    argumentIndex: argumentIndex,
                    getOptions: function() {
                        return {
                            hoverMode: hoverMode
                        };
                    }
                }
            });
        }
    },
    _resetHoveredArgument: function() {
        var hoverMode;
        if ((0, $6ntMu.isDefined)(this._hoveredArgument)) {
            hoverMode = this._getArgumentHoverMode();
            this._notifySeries({
                action: "clearPointHover",
                notifyLegend: this._notifyLegendOnHoverArgument,
                target: {
                    fullState: $ce3e2509d4dd1c2c$var$NORMAL_STATE,
                    argumentIndex: this._argumentIndex,
                    argument: this._hoveredArgument,
                    getOptions: function() {
                        return {
                            hoverMode: hoverMode
                        };
                    }
                }
            });
            this._hoveredArgument = null;
        }
    },
    _notifySeries: function(data) {
        this._storedSeries.forEach(function(series) {
            series.notify(data);
        });
    },
    _pointerHandler: function(e) {
        var _series;
        var that = e.data.tracker;
        var rootOffset = that._renderer.getRootOffset();
        var x = $ce3e2509d4dd1c2c$var$_floor(e.pageX - rootOffset.left);
        var y = $ce3e2509d4dd1c2c$var$_floor(e.pageY - rootOffset.top);
        var canvas = that._getCanvas(x, y);
        var series = $ce3e2509d4dd1c2c$var$getData(e, $ce3e2509d4dd1c2c$var$SERIES_DATA);
        var point = $ce3e2509d4dd1c2c$var$getData(e, $ce3e2509d4dd1c2c$var$POINT_DATA) || (null === (_series = series) || void 0 === _series ? void 0 : _series.getPointByCoord(x, y));
        that._isHolding = false;
        clearTimeout(that._holdTimer);
        if (e.type === (0, $cgnQR.default).down) that._holdTimer = setTimeout(()=>that._isHolding = true, $ce3e2509d4dd1c2c$var$HOLD_TIMEOUT);
        if (point && !point.getMarkerVisibility()) point = void 0;
        that._enableOutHandler();
        if (that._legend.coordsIn(x, y)) {
            that._hoverLegendItem(x, y);
            return;
        }
        if (that.hoveredSeries && that.hoveredSeries !== that._stuckSeries) that._releaseHoveredSeries();
        if (that._hoverArgumentAxis(x, y, e)) return;
        if (that._isPointerOut(canvas, point)) that._pointerOut();
        if (!canvas && !point) return;
        if (series && !point) {
            point = series.getNeighborPoint(x, y);
            if (!that._stickyHovering && point && !point.coordsIn(x, y)) point = null;
            if (series !== that.hoveredSeries) {
                that._setTimeout(function() {
                    that._setHoveredSeries(series);
                    that._setStuckSeries(e, series, x, y);
                    that._pointerComplete(point, x, y);
                }, series);
                return;
            }
        } else if (point) {
            if (e.type !== (0, $cgnQR.default).move && "touch" !== e.pointerType) return;
            if (that.hoveredSeries) that._setTimeout(()=>that._pointerOnPoint(point, x, y, e), point);
            else that._pointerOnPoint(point, x, y, e);
            return;
        } else if (that._setStuckSeries(e, void 0, x, y) && that._stickyHovering) {
            var _point;
            series = that._stuckSeries;
            point = series.getNeighborPoint(x, y);
            that._releaseHoveredSeries();
            (null === (_point = point) || void 0 === _point ? void 0 : _point.getMarkerVisibility()) && that._setHoveredPoint(point);
        } else if (!that._stickyHovering) that._pointerOut();
        that._pointerComplete(point, x, y);
    },
    _pointerOnPoint: function(point, x, y) {
        this._resetHoveredArgument();
        this._setHoveredPoint(point);
        this._pointerComplete(point, x, y);
    },
    _pointerComplete: function(point) {
        this.pointAtShownTooltip !== point && this._tooltip.isEnabled() && this._showTooltip(point);
    },
    _clickHandler: function(e) {
        var _point2;
        var that = e.data.tracker;
        if (that._isHolding) return;
        var rootOffset = that._renderer.getRootOffset();
        var x = $ce3e2509d4dd1c2c$var$_floor(e.pageX - rootOffset.left);
        var y = $ce3e2509d4dd1c2c$var$_floor(e.pageY - rootOffset.top);
        var point = $ce3e2509d4dd1c2c$var$getData(e, $ce3e2509d4dd1c2c$var$POINT_DATA);
        var series = that._stuckSeries || $ce3e2509d4dd1c2c$var$getData(e, $ce3e2509d4dd1c2c$var$SERIES_DATA) || (null === (_point2 = point) || void 0 === _point2 ? void 0 : _point2.series);
        var axis = that._argumentAxis;
        if (that._legend.coordsIn(x, y)) {
            var item = that._legend.getItemByCoord(x, y);
            if (item) that._legendClick(item, e);
        } else if (null !== axis && void 0 !== axis && axis.coordsIn(x, y)) {
            var argument = $ce3e2509d4dd1c2c$var$getData(e, $ce3e2509d4dd1c2c$var$ARG_DATA, true);
            if ((0, $6ntMu.isDefined)(argument)) that._eventTrigger("argumentAxisClick", {
                argument: argument,
                event: e
            });
        } else if (series) {
            var _point3;
            point = point || series.getPointByCoord(x, y);
            if (null !== (_point3 = point) && void 0 !== _point3 && _point3.getMarkerVisibility()) that._pointClick(point, e);
            else $ce3e2509d4dd1c2c$var$getData(e, $ce3e2509d4dd1c2c$var$SERIES_DATA) && that._eventTrigger($ce3e2509d4dd1c2c$var$SERIES_CLICK, {
                target: series,
                event: e
            });
        }
    },
    dispose: function() {
        this._disableOutHandler();
        this._renderer.root.off($ce3e2509d4dd1c2c$var$DOT_EVENT_NS);
        this._seriesGroup.off($ce3e2509d4dd1c2c$var$DOT_EVENT_NS);
    }
};
var $ce3e2509d4dd1c2c$export$bf1e0f269b8cf9a4 = function(options) {
    this.ctor(options);
};
(0, $2oTOp.extend)($ce3e2509d4dd1c2c$export$bf1e0f269b8cf9a4.prototype, $ce3e2509d4dd1c2c$var$baseTrackerPrototype, {
    _pointClick: function(point, event) {
        var eventTrigger = this._eventTrigger;
        var series = point.series;
        var eventArgs = {
            target: point,
            event: event
        };
        eventTrigger($ce3e2509d4dd1c2c$var$POINT_CLICK, eventArgs, function() {
            !$ce3e2509d4dd1c2c$var$eventCanceled(eventArgs, series, "point") && eventTrigger($ce3e2509d4dd1c2c$var$SERIES_CLICK, {
                target: series,
                event: event
            });
        });
    },
    update: function(options) {
        $ce3e2509d4dd1c2c$var$baseTrackerPrototype.update.call(this, options);
        this._argumentAxis = options.argumentAxis || {};
        this._axisHoverEnabled = this._argumentAxis && (0, $dw9tZ.normalizeEnum)(this._argumentAxis.getOptions().hoverMode) === $ce3e2509d4dd1c2c$var$ALL_ARGUMENT_POINTS_MODE;
        this._rotated = options.rotated;
        this._crosshair = options.crosshair;
        this._stickyHovering = options.stickyHovering;
    },
    _getCanvas: function(x, y) {
        var canvases = this._canvases || [];
        for(var i = 0; i < canvases.length; i++){
            var c = canvases[i];
            if ((0, $dw9tZ.pointInCanvas)(c, x, y)) return c;
        }
        return null;
    },
    _isPointerOut: function(canvas) {
        return !canvas && this._stuckSeries;
    },
    _hideCrosshair: function() {
        var _this$_crosshair;
        null === (_this$_crosshair = this._crosshair) || void 0 === _this$_crosshair || _this$_crosshair.hide();
    },
    _moveCrosshair: function(point, x, y) {
        if (this._crosshair && null !== point && void 0 !== point && point.isVisible()) this._crosshair.show({
            point: point,
            x: x,
            y: y
        });
    },
    _clean: function() {
        $ce3e2509d4dd1c2c$var$baseTrackerPrototype._clean.call(this);
        this._resetTimer();
        this._stuckSeries = null;
    },
    _getSeriesForShared: function(x, y) {
        var _point4;
        var points = [];
        var point = null;
        var distance = 1 / 0;
        if (this._tooltip.isShared() && !this.hoveredSeries) {
            (0, $8OLOW.each)(this._storedSeries, function(_, series) {
                var point = series.getNeighborPoint(x, y);
                point && points.push(point);
            });
            (0, $8OLOW.each)(points, function(_, p) {
                var coords = p.getCrosshairData(x, y);
                var d = (0, $dw9tZ.getDistance)(x, y, coords.x, coords.y);
                if (d < distance) {
                    point = p;
                    distance = d;
                }
            });
        }
        return null === (_point4 = point) || void 0 === _point4 ? void 0 : _point4.series;
    },
    _setTimeout: function(callback, keeper) {
        var that = this;
        if (that._timeoutKeeper !== keeper) {
            that._resetTimer();
            that._hoverTimeout = setTimeout(function() {
                callback();
                that._timeoutKeeper = null;
            }, $ce3e2509d4dd1c2c$var$DELAY);
            that._timeoutKeeper = keeper;
        }
    },
    _resetTimer: function() {
        clearTimeout(this._hoverTimeout);
        this._timeoutKeeper = this._hoverTimeout = null;
    },
    _stopEvent: function(e) {
        if (!(0, $6ntMu.isDefined)(e.cancelable) || e.cancelable) {
            e.preventDefault();
            e.stopPropagation();
        }
    },
    _setStuckSeries: function(e, series, x, y) {
        if ("mouse" !== e.pointerType) this._stuckSeries = null;
        else this._stuckSeries = series || this._stuckSeries || this._getSeriesForShared(x, y);
        return !!this._stuckSeries;
    },
    _pointerOut: function() {
        var that = this;
        that._stuckSeries = null;
        that._hideCrosshair();
        that._resetTimer();
        $ce3e2509d4dd1c2c$var$baseTrackerPrototype._pointerOut.apply(that, arguments);
    },
    _hoverArgumentAxis: function(x, y, e) {
        this._resetHoveredArgument();
        if (this._axisHoverEnabled && this._argumentAxis.coordsIn(x, y)) {
            this._hoverArgument($ce3e2509d4dd1c2c$var$getData(e, $ce3e2509d4dd1c2c$var$ARG_DATA, true));
            return true;
        }
    },
    _pointerComplete: function(point, x, y) {
        this.hoveredSeries && this.hoveredSeries.updateHover(x, y);
        this._resetTimer();
        this._moveCrosshair(point, x, y);
        $ce3e2509d4dd1c2c$var$baseTrackerPrototype._pointerComplete.call(this, point);
    },
    _legendClick: function(item, e) {
        var series = this._storedSeries[item.id];
        this._triggerLegendClick({
            target: series,
            event: e
        }, $ce3e2509d4dd1c2c$var$SERIES_CLICK);
    },
    _hoverLegendItem: function(x, y) {
        this._stuckSeries = null;
        this._hideCrosshair();
        $ce3e2509d4dd1c2c$var$baseTrackerPrototype._hoverLegendItem.call(this, x, y);
    },
    _pointerOnPoint: function(point, x, y, e) {
        this._setStuckSeries(e, point.series, x, y);
        this._releaseHoveredSeries();
        $ce3e2509d4dd1c2c$var$baseTrackerPrototype._pointerOnPoint.call(this, point, x, y, e);
    },
    _notifyLegendOnHoverArgument: false,
    _getArgumentHoverMode: function() {
        return $ce3e2509d4dd1c2c$var$correctHoverMode(this._argumentAxis);
    },
    dispose: function() {
        this._resetTimer();
        $ce3e2509d4dd1c2c$var$baseTrackerPrototype.dispose.call(this);
    }
});
var $ce3e2509d4dd1c2c$export$e899b88c874f0500 = function(options) {
    this.ctor(options);
};
(0, $2oTOp.extend)($ce3e2509d4dd1c2c$export$e899b88c874f0500.prototype, $ce3e2509d4dd1c2c$var$baseTrackerPrototype, {
    _isPointerOut: function(_, point) {
        return !point;
    },
    _legendClick: function(item, e) {
        var points = [];
        this._storedSeries.forEach((s)=>points.push.apply(points, s.getPointsByKeys(item.argument, item.argumentIndex)));
        this._eventTrigger($ce3e2509d4dd1c2c$var$LEGEND_CLICK, {
            target: item.argument,
            points: points,
            event: e
        });
    },
    _pointClick: function(point, e) {
        this._eventTrigger($ce3e2509d4dd1c2c$var$POINT_CLICK, {
            target: point,
            event: e
        });
    },
    _hoverLegendItem: function(x, y) {
        var item = this._legend.getItemByCoord(x, y);
        if (item && this._hoveredArgument !== item.argument) {
            this._resetHoveredArgument();
            this._hoverArgument(item.argument, item.argumentIndex);
        } else if (!item) this.clearHover();
    },
    _getArgumentHoverMode: function() {
        return $ce3e2509d4dd1c2c$var$correctHoverMode(this._legend);
    },
    _hoverArgumentAxis: (0, $gcp4g.noop),
    _setStuckSeries: (0, $gcp4g.noop),
    _getCanvas: (0, $gcp4g.noop),
    _notifyLegendOnHoverArgument: true
});

});
parcelRegister("bfcCm", function(module, exports) {

$parcel$export(module.exports, "name", function () { return $82fae204814583da$export$a8ff84c12d48cfa6; });
/**
 * DevExtreme (esm/events/click.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $60GuF = parcelRequire("60GuF");

var $jF0bZ = parcelRequire("jF0bZ");

var $3yzYM = parcelRequire("3yzYM");

var $g3YTP = parcelRequire("g3YTP");

var $9gxmQ = parcelRequire("9gxmQ");

var $bcOMe = parcelRequire("bcOMe");

var $63jeB = parcelRequire("63jeB");

var $cgnQR = parcelRequire("cgnQR");

var $1xoTt = parcelRequire("1xoTt");

var $gIBa7 = parcelRequire("gIBa7");
var $82fae204814583da$export$a8ff84c12d48cfa6 = "dxclick";
var $82fae204814583da$var$misc = {
    requestAnimationFrame: (0, $9gxmQ.requestAnimationFrame),
    cancelAnimationFrame: (0, $9gxmQ.cancelAnimationFrame)
};
var $82fae204814583da$var$prevented = null;
var $82fae204814583da$var$lastFiredEvent = null;
var $82fae204814583da$var$onNodeRemove = ()=>{
    $82fae204814583da$var$lastFiredEvent = null;
};
var $82fae204814583da$var$clickHandler = function(e) {
    var originalEvent = e.originalEvent;
    var eventAlreadyFired = $82fae204814583da$var$lastFiredEvent === originalEvent || originalEvent && originalEvent.DXCLICK_FIRED;
    var leftButton = !e.which || 1 === e.which;
    if (leftButton && !$82fae204814583da$var$prevented && !eventAlreadyFired) {
        if (originalEvent) originalEvent.DXCLICK_FIRED = true;
        (0, $63jeB.unsubscribeNodesDisposing)($82fae204814583da$var$lastFiredEvent, $82fae204814583da$var$onNodeRemove);
        $82fae204814583da$var$lastFiredEvent = originalEvent;
        (0, $63jeB.subscribeNodesDisposing)($82fae204814583da$var$lastFiredEvent, $82fae204814583da$var$onNodeRemove);
        (0, $bcOMe.fireEvent)({
            type: $82fae204814583da$export$a8ff84c12d48cfa6,
            originalEvent: e
        });
    }
};
var $82fae204814583da$var$ClickEmitter = (0, $1xoTt.default).inherit({
    ctor: function(element) {
        this.callBase(element);
        (0, $60GuF.default).on(this.getElement(), "click", $82fae204814583da$var$clickHandler);
    },
    start: function(e) {
        $82fae204814583da$var$prevented = null;
    },
    cancel: function() {
        $82fae204814583da$var$prevented = true;
    },
    dispose: function() {
        (0, $60GuF.default).off(this.getElement(), "click", $82fae204814583da$var$clickHandler);
    }
});
!function() {
    var desktopDevice = (0, $jF0bZ.default).real().generic;
    if (!desktopDevice) {
        var startTarget = null;
        var blurPrevented = false;
        var document = (0, $3yzYM.default).getDocument();
        (0, $60GuF.default).subscribeGlobal(document, (0, $bcOMe.addNamespace)((0, $cgnQR.default).down, "NATIVE_CLICK_FIXER"), function(e) {
            startTarget = e.target;
            blurPrevented = e.isDefaultPrevented();
        });
        (0, $60GuF.default).subscribeGlobal(document, (0, $bcOMe.addNamespace)("click", "NATIVE_CLICK_FIXER"), function(e) {
            var $target = (0, $2vlX8.default)(e.target);
            if (!blurPrevented && startTarget && !$target.is(startTarget) && !(0, $2vlX8.default)(startTarget).is("label") && (element = $target, (0, $2vlX8.default)(element).is("input, textarea, select, button ,:focus, :focus *"))) (0, $g3YTP.resetActiveElement)();
            var element;
            startTarget = null;
            blurPrevented = false;
        });
    }
}();
(0, $gIBa7.default)({
    emitter: $82fae204814583da$var$ClickEmitter,
    bubble: true,
    events: [
        $82fae204814583da$export$a8ff84c12d48cfa6
    ]
});

});
parcelRegister("63jeB", function(module, exports) {

$parcel$export(module.exports, "subscribeNodesDisposing", function () { return $4681f1791aeebbf8$export$7106d7971e8b260a; });
$parcel$export(module.exports, "unsubscribeNodesDisposing", function () { return $4681f1791aeebbf8$export$5657c76022182e09; });
/**
 * DevExtreme (esm/events/utils/event_nodes_disposing.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $60GuF = parcelRequire("60GuF");

var $1qDFW = parcelRequire("1qDFW");
function $4681f1791aeebbf8$var$nodesByEvent(event) {
    return event && [
        event.target,
        event.delegateTarget,
        event.relatedTarget,
        event.currentTarget
    ].filter((node)=>!!node);
}
var $4681f1791aeebbf8$export$7106d7971e8b260a = (event, callback)=>{
    (0, $60GuF.default).one($4681f1791aeebbf8$var$nodesByEvent(event), (0, $1qDFW.removeEvent), callback);
};
var $4681f1791aeebbf8$export$5657c76022182e09 = (event, callback)=>{
    (0, $60GuF.default).off($4681f1791aeebbf8$var$nodesByEvent(event), (0, $1qDFW.removeEvent), callback);
};

});



parcelRegister("72UWv", function(module, exports) {

$parcel$export(module.exports, "ThemeManager", function () { return $5214e3f0628f9fa9$export$5510f7c459d7063c; });
/**
 * DevExtreme (esm/viz/components/chart_theme_manager.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $gcp4g = parcelRequire("gcp4g");

var $6ntMu = parcelRequire("6ntMu");

var $2oTOp = parcelRequire("2oTOp");

var $64UbH = parcelRequire("64UbH");

var $dw9tZ = parcelRequire("dw9tZ");
var $5214e3f0628f9fa9$export$5510f7c459d7063c = (0, $64UbH.BaseThemeManager).inherit(function() {
    var processAxisOptions = function(axisOptions) {
        if (!axisOptions) return {};
        axisOptions = (0, $2oTOp.extend)(true, {}, axisOptions);
        axisOptions.title = (options = axisOptions.title, (0, $6ntMu.isString)(options) ? {
            text: options
        } : options);
        var options;
        if ("logarithmic" === axisOptions.type && axisOptions.logarithmBase <= 0 || axisOptions.logarithmBase && !(0, $6ntMu.isNumeric)(axisOptions.logarithmBase)) {
            axisOptions.logarithmBase = void 0;
            axisOptions.logarithmBaseError = true;
        }
        if (axisOptions.label) {
            if (axisOptions.label.alignment) axisOptions.label.userAlignment = true;
        }
        return axisOptions;
    };
    var applyParticularAxisOptions = function(name, userOptions, rotated) {
        var theme = this._theme;
        var position = !(rotated ^ "valueAxis" === name) ? "horizontalAxis" : "verticalAxis";
        var processedUserOptions = processAxisOptions(userOptions);
        var commonAxisSettings = processAxisOptions(this._userOptions.commonAxisSettings);
        var mergeOptions = (0, $2oTOp.extend)(true, {}, theme.commonAxisSettings, theme[position], theme[name], commonAxisSettings, processedUserOptions);
        mergeOptions.workWeek = processedUserOptions.workWeek || theme[name].workWeek;
        mergeOptions.forceUserTickInterval |= (0, $6ntMu.isDefined)(processedUserOptions.tickInterval) && !(0, $6ntMu.isDefined)(processedUserOptions.axisDivisionFactor);
        return mergeOptions;
    };
    var mergeOptions = function(name, userOptions) {
        userOptions = userOptions || this._userOptions[name];
        var theme = this._theme[name];
        var result = this._mergedSettings[name];
        if (result) return result;
        if ((0, $6ntMu.isPlainObject)(theme) && (0, $6ntMu.isPlainObject)(userOptions)) result = (0, $2oTOp.extend)(true, {}, theme, userOptions);
        else result = (0, $6ntMu.isDefined)(userOptions) ? userOptions : theme;
        this._mergedSettings[name] = result;
        return result;
    };
    var applyParticularTheme = {
        base: mergeOptions,
        argumentAxis: applyParticularAxisOptions,
        valueAxisRangeSelector: function() {
            return mergeOptions.call(this, "valueAxis");
        },
        valueAxis: applyParticularAxisOptions,
        series: function(name, userOptions, seriesCount) {
            var that = this;
            var theme = that._theme;
            var userCommonSettings = that._userOptions.commonSeriesSettings || {};
            var themeCommonSettings = theme.commonSeriesSettings;
            var widgetType = that._themeSection.split(".").slice(-1)[0];
            var type = (0, $dw9tZ.normalizeEnum)(userOptions.type || userCommonSettings.type || themeCommonSettings.type || "pie" === widgetType && theme.type);
            var palette = that.palette;
            var isBar = ~type.indexOf("bar");
            var isLine = ~type.indexOf("line");
            var isArea = ~type.indexOf("area");
            var isBubble = "bubble" === type;
            var mainSeriesColor;
            var resolveLabelsOverlapping = that.getOptions("resolveLabelsOverlapping");
            var containerBackgroundColor = that.getOptions("containerBackgroundColor");
            var seriesTemplate = applyParticularTheme.seriesTemplate.call(this);
            var seriesVisibility;
            if (isBar || isBubble) {
                userOptions = (0, $2oTOp.extend)(true, {}, userCommonSettings, userCommonSettings[type], userOptions);
                seriesVisibility = userOptions.visible;
                userCommonSettings = {
                    type: {}
                };
                (0, $2oTOp.extend)(true, userOptions, userOptions.point);
                userOptions.visible = seriesVisibility;
            }
            var settings = (0, $2oTOp.extend)(true, {
                aggregation: {}
            }, themeCommonSettings, themeCommonSettings[type], userCommonSettings, userCommonSettings[type], userOptions);
            settings.aggregation.enabled = "chart" === widgetType && !!settings.aggregation.enabled;
            settings.type = type;
            settings.widgetType = widgetType;
            settings.containerBackgroundColor = containerBackgroundColor;
            if ("pie" !== widgetType) mainSeriesColor = settings.color || palette.getNextColor(seriesCount);
            else mainSeriesColor = function(argument, index, count) {
                var cat = "".concat(argument, "-").concat(index);
                if (!that._multiPieColors[cat]) that._multiPieColors[cat] = palette.getNextColor(count);
                return that._multiPieColors[cat];
            };
            settings.mainSeriesColor = mainSeriesColor;
            settings.resolveLabelsOverlapping = resolveLabelsOverlapping;
            if (settings.label && (isLine || isArea && "rangearea" !== type || "scatter" === type)) settings.label.position = "outside";
            if (seriesTemplate) settings.nameField = seriesTemplate.nameField;
            return settings;
        },
        animation: function(name) {
            var userOptions = this._userOptions[name];
            userOptions = (0, $6ntMu.isPlainObject)(userOptions) ? userOptions : (0, $6ntMu.isDefined)(userOptions) ? {
                enabled: !!userOptions
            } : {};
            return mergeOptions.call(this, name, userOptions);
        },
        seriesTemplate () {
            var value = mergeOptions.call(this, "seriesTemplate");
            if (value) value.nameField = value.nameField || "series";
            return value;
        },
        zoomAndPan () {
            function parseOption(option) {
                option = (0, $dw9tZ.normalizeEnum)(option);
                var pan = "pan" === option || "both" === option;
                var zoom = "zoom" === option || "both" === option;
                return {
                    pan: pan,
                    zoom: zoom,
                    none: !pan && !zoom
                };
            }
            var options = mergeOptions.call(this, "zoomAndPan");
            return {
                valueAxis: parseOption(options.valueAxis),
                argumentAxis: parseOption(options.argumentAxis),
                dragToZoom: !!options.dragToZoom,
                dragBoxStyle: {
                    class: "dxc-shutter",
                    fill: options.dragBoxStyle.color,
                    opacity: options.dragBoxStyle.opacity
                },
                panKey: options.panKey,
                allowMouseWheel: !!options.allowMouseWheel,
                allowTouchGestures: !!options.allowTouchGestures
            };
        }
    };
    return {
        _themeSection: "chart",
        ctor: function(params) {
            var that = this;
            that.callBase.apply(that, arguments);
            var options = params.options || {};
            that._userOptions = options;
            that._mergeAxisTitleOptions = [];
            that._multiPieColors = {};
            that._callback = (0, $gcp4g.noop);
        },
        dispose: function() {
            var that = this;
            that.palette && that.palette.dispose();
            that.palette = that._userOptions = that._mergedSettings = that._multiPieColors = null;
            return that.callBase.apply(that, arguments);
        },
        resetPalette: function() {
            this.palette.reset();
            this._multiPieColors = {};
        },
        getOptions: function(name) {
            return (applyParticularTheme[name] || applyParticularTheme.base).apply(this, arguments);
        },
        refresh: function() {
            this._mergedSettings = {};
            return this.callBase.apply(this, arguments);
        },
        _initializeTheme: function() {
            var that = this;
            that.callBase.apply(that, arguments);
            that.updatePalette();
        },
        resetOptions: function(name) {
            this._mergedSettings[name] = null;
        },
        update: function(options) {
            this._userOptions = options;
        },
        updatePalette: function() {
            this.palette = this.createPalette(this.getOptions("palette"), {
                useHighlight: true,
                extensionMode: this.getOptions("paletteExtensionMode")
            });
        }
    };
}());

});
parcelRegister("64UbH", function(module, exports) {

$parcel$export(module.exports, "BaseThemeManager", function () { return $46ceb387d56f4220$export$49d645457cdb7237; });
/**
 * DevExtreme (esm/viz/core/base_theme_manager.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $a2g7x = parcelRequire("a2g7x");

var $2oTOp = parcelRequire("2oTOp");

var $6ntMu = parcelRequire("6ntMu");

var $8OLOW = parcelRequire("8OLOW");

var $8IOug = parcelRequire("8IOug");

var $dw9tZ = parcelRequire("dw9tZ");

var $4mP7M = parcelRequire("4mP7M");
var $46ceb387d56f4220$var$_getTheme = (0, $4mP7M.getTheme);
var $46ceb387d56f4220$var$_addCacheItem = (0, $4mP7M.addCacheItem);
var $46ceb387d56f4220$var$_removeCacheItem = (0, $4mP7M.removeCacheItem);
var $46ceb387d56f4220$var$_extend = (0, $2oTOp.extend);
var $46ceb387d56f4220$var$_each = (0, $8OLOW.each);
function $46ceb387d56f4220$var$getThemePart(theme, path) {
    var _theme = theme;
    path && $46ceb387d56f4220$var$_each(path.split("."), function(_, pathItem) {
        return _theme = _theme[pathItem];
    });
    return _theme;
}
var $46ceb387d56f4220$export$49d645457cdb7237 = (0, $a2g7x.default).inherit({
    ctor: function(options) {
        this._themeSection = options.themeSection;
        this._fontFields = options.fontFields || [];
        $46ceb387d56f4220$var$_addCacheItem(this);
    },
    dispose: function() {
        $46ceb387d56f4220$var$_removeCacheItem(this);
        this._callback = this._theme = this._font = null;
        return this;
    },
    setCallback: function(callback) {
        this._callback = callback;
        return this;
    },
    setTheme: function(theme, rtl) {
        this._current = theme;
        this._rtl = rtl;
        return this.refresh();
    },
    refresh: function() {
        var current = this._current || {};
        var theme = $46ceb387d56f4220$var$_getTheme(current.name || current);
        this._themeName = theme.name;
        this._defaultPalette = theme.defaultPalette;
        this._font = $46ceb387d56f4220$var$_extend({}, theme.font, current.font);
        this._themeSection && $46ceb387d56f4220$var$_each(this._themeSection.split("."), function(_, path) {
            theme = $46ceb387d56f4220$var$_extend(true, {}, theme[path]);
        });
        this._theme = $46ceb387d56f4220$var$_extend(true, {}, theme, (0, $6ntMu.isString)(current) ? {} : current);
        this._initializeTheme();
        if ((0, $dw9tZ.parseScalar)(this._rtl, this._theme.rtlEnabled)) $46ceb387d56f4220$var$_extend(true, this._theme, this._theme._rtl);
        this._callback();
        return this;
    },
    theme: function(path) {
        return $46ceb387d56f4220$var$getThemePart(this._theme, path);
    },
    themeName: function() {
        return this._themeName;
    },
    createPalette: function(palette, options) {
        return (0, $8IOug.createPalette)(palette, options, this._defaultPalette);
    },
    createDiscretePalette: function(palette, count) {
        return (0, $8IOug.getDiscretePalette)(palette, count, this._defaultPalette);
    },
    createGradientPalette: function(palette) {
        return (0, $8IOug.getGradientPalette)(palette, this._defaultPalette);
    },
    getAccentColor: function(palette) {
        return (0, $8IOug.getAccentColor)(palette, this._defaultPalette);
    },
    _initializeTheme: function() {
        var that = this;
        $46ceb387d56f4220$var$_each(that._fontFields || [], function(_, path) {
            that._initializeFont($46ceb387d56f4220$var$getThemePart(that._theme, path));
        });
    },
    _initializeFont: function(font) {
        $46ceb387d56f4220$var$_extend(font, this._font, $46ceb387d56f4220$var$_extend({}, font));
    }
});

});
parcelRegister("8IOug", function(module, exports) {

$parcel$export(module.exports, "createPalette", function () { return $65999879f8b92279$export$3294634ed8c53d35; });
$parcel$export(module.exports, "getAccentColor", function () { return $65999879f8b92279$export$88ae96f54cc5e852; });
$parcel$export(module.exports, "getDiscretePalette", function () { return $65999879f8b92279$export$d09c889422bcc3f; });
$parcel$export(module.exports, "getGradientPalette", function () { return $65999879f8b92279$export$d355f6e10a823494; });
/**
 * DevExtreme (esm/viz/palette.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $dw9tZ = parcelRequire("dw9tZ");

var $2oTOp = parcelRequire("2oTOp");

var $lmWRz = parcelRequire("lmWRz");

var $6ntMu = parcelRequire("6ntMu");
var $65999879f8b92279$var$_floor = Math.floor;
var $65999879f8b92279$var$_ceil = Math.ceil;
var $65999879f8b92279$var$_isArray = Array.isArray;
var $65999879f8b92279$var$HIGHLIGHTING_STEP = 50;
var $65999879f8b92279$var$DEFAULT_PALETTE = "material";
var $65999879f8b92279$var$officePalette = {
    simpleSet: [
        "#5f8b95",
        "#ba4d51",
        "#af8a53",
        "#955f71",
        "#859666",
        "#7e688c"
    ],
    indicatingSet: [
        "#a3b97c",
        "#e1b676",
        "#ec7f83"
    ],
    gradientSet: [
        "#5f8b95",
        "#ba4d51"
    ],
    accentColor: "#ba4d51"
};
var $65999879f8b92279$var$palettes = {
    [$65999879f8b92279$var$DEFAULT_PALETTE]: {
        simpleSet: [
            "#1db2f5",
            "#f5564a",
            "#97c95c",
            "#ffc720",
            "#eb3573",
            "#a63db8"
        ],
        indicatingSet: [
            "#97c95c",
            "#ffc720",
            "#f5564a"
        ],
        gradientSet: [
            "#1db2f5",
            "#97c95c"
        ],
        accentColor: "#1db2f5"
    },
    office: $65999879f8b92279$var$officePalette,
    "harmony light": {
        simpleSet: [
            "#fcb65e",
            "#679ec5",
            "#ad79ce",
            "#7abd5c",
            "#e18e92",
            "#b6d623",
            "#b7abea",
            "#85dbd5"
        ],
        indicatingSet: [
            "#b6d623",
            "#fcb65e",
            "#e18e92"
        ],
        gradientSet: [
            "#7abd5c",
            "#fcb65e"
        ],
        accentColor: "#679ec5"
    },
    "soft pastel": {
        simpleSet: [
            "#60a69f",
            "#78b6d9",
            "#6682bb",
            "#a37182",
            "#eeba69",
            "#90ba58",
            "#456c68",
            "#7565a4"
        ],
        indicatingSet: [
            "#90ba58",
            "#eeba69",
            "#a37182"
        ],
        gradientSet: [
            "#78b6d9",
            "#eeba69"
        ],
        accentColor: "#60a69f"
    },
    pastel: {
        simpleSet: [
            "#bb7862",
            "#70b3a1",
            "#bb626a",
            "#057d85",
            "#ab394b",
            "#dac599",
            "#153459",
            "#b1d2c6"
        ],
        indicatingSet: [
            "#70b3a1",
            "#dac599",
            "#bb626a"
        ],
        gradientSet: [
            "#bb7862",
            "#70b3a1"
        ],
        accentColor: "#bb7862"
    },
    bright: {
        simpleSet: [
            "#70c92f",
            "#f8ca00",
            "#bd1550",
            "#e97f02",
            "#9d419c",
            "#7e4452",
            "#9ab57e",
            "#36a3a6"
        ],
        indicatingSet: [
            "#70c92f",
            "#f8ca00",
            "#bd1550"
        ],
        gradientSet: [
            "#e97f02",
            "#f8ca00"
        ],
        accentColor: "#e97f02"
    },
    soft: {
        simpleSet: [
            "#cbc87b",
            "#9ab57e",
            "#e55253",
            "#7e4452",
            "#e8c267",
            "#565077",
            "#6babac",
            "#ad6082"
        ],
        indicatingSet: [
            "#9ab57e",
            "#e8c267",
            "#e55253"
        ],
        gradientSet: [
            "#9ab57e",
            "#e8c267"
        ],
        accentColor: "#565077"
    },
    ocean: {
        simpleSet: [
            "#75c099",
            "#acc371",
            "#378a8a",
            "#5fa26a",
            "#064970",
            "#38c5d2",
            "#00a7c6",
            "#6f84bb"
        ],
        indicatingSet: [
            "#c8e394",
            "#7bc59d",
            "#397c8b"
        ],
        gradientSet: [
            "#acc371",
            "#38c5d2"
        ],
        accentColor: "#378a8a"
    },
    vintage: {
        simpleSet: [
            "#dea484",
            "#efc59c",
            "#cb715e",
            "#eb9692",
            "#a85c4c",
            "#f2c0b5",
            "#c96374",
            "#dd956c"
        ],
        indicatingSet: [
            "#ffe5c6",
            "#f4bb9d",
            "#e57660"
        ],
        gradientSet: [
            "#efc59c",
            "#cb715e"
        ],
        accentColor: "#cb715e"
    },
    violet: {
        simpleSet: [
            "#d1a1d1",
            "#eeacc5",
            "#7b5685",
            "#7e7cad",
            "#a13d73",
            "#5b41ab",
            "#e287e2",
            "#689cc1"
        ],
        indicatingSet: [
            "#d8e2f6",
            "#d0b2da",
            "#d56a8a"
        ],
        gradientSet: [
            "#eeacc5",
            "#7b5685"
        ],
        accentColor: "#7b5685"
    },
    carmine: {
        simpleSet: [
            "#fb7764",
            "#73d47f",
            "#fed85e",
            "#d47683",
            "#dde392",
            "#757ab2"
        ],
        indicatingSet: [
            "#5cb85c",
            "#f0ad4e",
            "#d9534f"
        ],
        gradientSet: [
            "#fb7764",
            "#73d47f"
        ],
        accentColor: "#f05b41"
    },
    "dark moon": {
        simpleSet: [
            "#4ddac1",
            "#f4c99a",
            "#80dd9b",
            "#f998b3",
            "#4aaaa0",
            "#a5aef1"
        ],
        indicatingSet: [
            "#59d8a4",
            "#f0ad4e",
            "#f9517e"
        ],
        gradientSet: [
            "#4ddac1",
            "#f4c99a"
        ],
        accentColor: "#3debd3"
    },
    "soft blue": {
        simpleSet: [
            "#7ab8eb",
            "#97da97",
            "#facb86",
            "#e78683",
            "#839bda",
            "#4db7be"
        ],
        indicatingSet: [
            "#5cb85c",
            "#f0ad4e",
            "#d9534f"
        ],
        gradientSet: [
            "#7ab8eb",
            "#97da97"
        ],
        accentColor: "#7ab8eb"
    },
    "dark violet": {
        simpleSet: [
            "#9c63ff",
            "#64c064",
            "#eead51",
            "#d2504b",
            "#4b6bbf",
            "#2da7b0"
        ],
        indicatingSet: [
            "#5cb85c",
            "#f0ad4e",
            "#d9534f"
        ],
        gradientSet: [
            "#9c63ff",
            "#64c064"
        ],
        accentColor: "#9c63ff"
    },
    "green mist": {
        simpleSet: [
            "#3cbab2",
            "#8ed962",
            "#5b9d95",
            "#efcc7c",
            "#f1929f",
            "#4d8dab"
        ],
        indicatingSet: [
            "#72d63c",
            "#ffc852",
            "#f74a5e"
        ],
        gradientSet: [
            "#3cbab2",
            "#8ed962"
        ],
        accentColor: "#3cbab2"
    }
};
var $65999879f8b92279$var$currentPaletteName;
function $65999879f8b92279$export$b869dd214721594c(name) {
    if (void 0 === name) return $65999879f8b92279$var$currentPaletteName || $65999879f8b92279$var$DEFAULT_PALETTE;
    else {
        name = (0, $dw9tZ.normalizeEnum)(name);
        $65999879f8b92279$var$currentPaletteName = name in $65999879f8b92279$var$palettes ? name : void 0;
    }
}
function $65999879f8b92279$export$253cd51ce7d49924(palette, count) {
    var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
        keepLastColorInEnd: false
    };
    options.type = options.baseColorSet;
    options.extensionMode = options.paletteExtensionMode;
    return $65999879f8b92279$export$3294634ed8c53d35(palette, options).generateColors(count);
}
function $65999879f8b92279$export$747ccad006a63299(palette, parameters) {
    parameters = parameters || {};
    palette = palette || (void 0 === $65999879f8b92279$var$currentPaletteName ? parameters.themeDefault : $65999879f8b92279$export$b869dd214721594c());
    var result;
    var type = parameters.type;
    if ($65999879f8b92279$var$_isArray(palette)) return palette.slice(0);
    else {
        if ((0, $6ntMu.isString)(palette)) result = $65999879f8b92279$var$palettes[(0, $dw9tZ.normalizeEnum)(palette)];
        if (!result) result = $65999879f8b92279$var$palettes[$65999879f8b92279$export$b869dd214721594c()];
    }
    return type ? result[type].slice(0) : result;
}
function $65999879f8b92279$export$bdc650247d07dd09(name, palette) {
    var item = {};
    var paletteName;
    if ($65999879f8b92279$var$_isArray(palette)) item.simpleSet = palette.slice(0);
    else if (palette) {
        item.simpleSet = $65999879f8b92279$var$_isArray(palette.simpleSet) ? palette.simpleSet.slice(0) : void 0;
        item.indicatingSet = $65999879f8b92279$var$_isArray(palette.indicatingSet) ? palette.indicatingSet.slice(0) : void 0;
        item.gradientSet = $65999879f8b92279$var$_isArray(palette.gradientSet) ? palette.gradientSet.slice(0) : void 0;
        item.accentColor = palette.accentColor;
    }
    if (!item.accentColor) item.accentColor = item.simpleSet && item.simpleSet[0];
    if (item.simpleSet || item.indicatingSet || item.gradientSet) {
        paletteName = (0, $dw9tZ.normalizeEnum)(name);
        (0, $2oTOp.extend)($65999879f8b92279$var$palettes[paletteName] = $65999879f8b92279$var$palettes[paletteName] || {}, item);
    }
}
function $65999879f8b92279$export$88ae96f54cc5e852(palette, themeDefault) {
    palette = $65999879f8b92279$export$747ccad006a63299(palette, {
        themeDefault: themeDefault
    });
    return palette.accentColor || palette[0];
}
function $65999879f8b92279$var$RingBuf(buf) {
    var ind = 0;
    this.next = function() {
        var res = buf[ind++];
        if (ind === buf.length) this.reset();
        return res;
    };
    this.reset = function() {
        ind = 0;
    };
}
function $65999879f8b92279$var$getAlternateColorsStrategy(palette, parameters) {
    var stepHighlight = parameters.useHighlight ? $65999879f8b92279$var$HIGHLIGHTING_STEP : 0;
    var paletteSteps = new $65999879f8b92279$var$RingBuf([
        0,
        stepHighlight,
        -stepHighlight
    ]);
    var currentPalette = [];
    function _reset() {
        var step = paletteSteps.next();
        currentPalette = step ? $65999879f8b92279$var$getAlteredPalette(palette, step) : palette.slice(0);
    }
    return {
        getColor: function(index) {
            var color = currentPalette[index % palette.length];
            if (index % palette.length === palette.length - 1) _reset();
            return color;
        },
        generateColors: function(count) {
            var colors = [];
            count = count || parameters.count;
            for(var i = 0; i < count; i++)colors.push(this.getColor(i));
            return colors;
        },
        reset: function() {
            paletteSteps.reset();
            _reset();
        }
    };
}
function $65999879f8b92279$var$getExtrapolateColorsStrategy(palette, parameters) {
    return {
        getColor: function(index, count) {
            var paletteCount = palette.length;
            var cycles = $65999879f8b92279$var$_floor((count - 1) / paletteCount + 1);
            var color = palette[index % paletteCount];
            if (cycles > 1) return function(color, cycleIndex, cycleCount) {
                var hsl = new (0, $lmWRz.default)(color).hsl;
                var l = hsl.l / 100;
                var diapason = cycleCount - 1 / cycleCount;
                var minL = l - .5 * diapason;
                var maxL = l + .5 * diapason;
                var cycleMiddle = (cycleCount - 1) / 2;
                var cycleDiff = cycleIndex - cycleMiddle;
                if (minL < Math.min(.5, .9 * l)) minL = Math.min(.5, .9 * l);
                if (maxL > Math.max(.8, l + .15 * (1 - l))) maxL = Math.max(.8, l + .15 * (1 - l));
                if (cycleDiff < 0) l -= (minL - l) * cycleDiff / cycleMiddle;
                else l += cycleDiff / cycleMiddle * (maxL - l);
                hsl.l = 100 * l;
                return (0, $lmWRz.default).prototype.fromHSL(hsl).toHex();
            }(color, $65999879f8b92279$var$_floor(index / paletteCount), cycles);
            return color;
        },
        generateColors: function(count) {
            var colors = [];
            count = count || parameters.count;
            for(var i = 0; i < count; i++)colors.push(this.getColor(i, count));
            return colors;
        },
        reset: function() {}
    };
}
function $65999879f8b92279$var$getColorMixer(palette, parameters) {
    var paletteCount = palette.length;
    var extendedPalette = [];
    function distributeColors(count, colorsCount, startIndex, distribution) {
        var groupSize = Math.floor(count / colorsCount);
        var extraItems = count - colorsCount * groupSize;
        var i = startIndex;
        var middleIndex;
        var size;
        while(i < startIndex + count){
            size = groupSize;
            if (extraItems > 0) {
                size += 1;
                extraItems--;
            }
            middleIndex = size > 2 ? Math.floor(size / 2) : 0;
            distribution.push(i + middleIndex);
            i += size;
        }
        return distribution.sort(function(a, b) {
            return a - b;
        });
    }
    function getColorAndDistance(arr, startIndex, count) {
        startIndex = (count + startIndex) % count;
        var distance = 0;
        for(var i = startIndex; i < 2 * count; i += 1){
            var index = (count + i) % count;
            if (arr[index]) return [
                arr[index],
                distance
            ];
            distance++;
        }
    }
    function extendPalette(count) {
        if (count <= paletteCount) return palette;
        var result = [];
        var colorInGroups = paletteCount - 2;
        var currentColorIndex = 0;
        var cleanColorIndices = [];
        if (parameters.keepLastColorInEnd) cleanColorIndices = distributeColors(count - 2, colorInGroups, 1, [
            0,
            count - 1
        ]);
        else cleanColorIndices = distributeColors(count - 1, paletteCount - 1, 1, [
            0
        ]);
        for(var i = 0; i < count; i++)if (cleanColorIndices.indexOf(i) > -1) result[i] = palette[currentColorIndex++];
        result = function(paletteWithEmptyColors, paletteLength) {
            for(var i = 0; i < paletteLength; i++){
                var color = paletteWithEmptyColors[i];
                if (!color) {
                    var color1 = paletteWithEmptyColors[i - 1];
                    if (!color1) continue;
                    else {
                        var c2 = getColorAndDistance(paletteWithEmptyColors, i, paletteLength);
                        var color2 = new (0, $lmWRz.default)(c2[0]);
                        color1 = new (0, $lmWRz.default)(color1);
                        for(var j = 0; j < c2[1]; j++, i++)paletteWithEmptyColors[i] = color1.blend(color2, (j + 1) / (c2[1] + 1)).toHex();
                    }
                }
            }
            return paletteWithEmptyColors;
        }(result, count);
        return result;
    }
    return {
        getColor: function(index, count) {
            count = count || parameters.count || paletteCount;
            if (extendedPalette.length !== count) extendedPalette = extendPalette(count);
            return extendedPalette[index % count];
        },
        generateColors: function(count, repeat) {
            count = count || parameters.count || paletteCount;
            if (repeat && count > paletteCount) {
                var colors = extendPalette(paletteCount);
                for(var i = 0; i < count - paletteCount; i++)colors.push(colors[i]);
                return colors;
            } else return paletteCount > 0 ? extendPalette(count).slice(0, count) : [];
        },
        reset: function() {}
    };
}
function $65999879f8b92279$export$3294634ed8c53d35(palette, parameters, themeDefaultPalette) {
    var paletteObj = {
        dispose () {
            this._extensionStrategy = null;
        },
        getNextColor (count) {
            return this._extensionStrategy.getColor(this._currentColor++, count);
        },
        generateColors (count, parameters) {
            return this._extensionStrategy.generateColors(count, (parameters || {}).repeat);
        },
        reset () {
            this._currentColor = 0;
            this._extensionStrategy.reset();
            return this;
        }
    };
    parameters = parameters || {};
    var extensionMode = (parameters.extensionMode || "").toLowerCase();
    var colors = $65999879f8b92279$export$747ccad006a63299(palette, {
        type: parameters.type || "simpleSet",
        themeDefault: themeDefaultPalette
    });
    if ("alternate" === extensionMode) paletteObj._extensionStrategy = $65999879f8b92279$var$getAlternateColorsStrategy(colors, parameters);
    else if ("extrapolate" === extensionMode) paletteObj._extensionStrategy = $65999879f8b92279$var$getExtrapolateColorsStrategy(colors, parameters);
    else paletteObj._extensionStrategy = $65999879f8b92279$var$getColorMixer(colors, parameters);
    paletteObj.reset();
    return paletteObj;
}
function $65999879f8b92279$var$getAlteredPalette(originalPalette, step) {
    var palette = [];
    var i;
    var ii = originalPalette.length;
    for(i = 0; i < ii; ++i)palette.push($65999879f8b92279$var$getNewColor(originalPalette[i], step));
    return palette;
}
function $65999879f8b92279$var$getNewColor(currentColor, step) {
    var newColor = new (0, $lmWRz.default)(currentColor).alter(step);
    var lightness = $65999879f8b92279$var$getLightness(newColor);
    if (lightness > 200 || lightness < 55) newColor = new (0, $lmWRz.default)(currentColor).alter(-step / 2);
    return newColor.toHex();
}
function $65999879f8b92279$var$getLightness(color) {
    return .3 * color.r + .59 * color.g + .11 * color.b;
}
function $65999879f8b92279$export$d09c889422bcc3f(source, size, themeDefaultPalette) {
    var palette = size > 0 ? $65999879f8b92279$var$createDiscreteColors($65999879f8b92279$export$747ccad006a63299(source, {
        type: "gradientSet",
        themeDefault: themeDefaultPalette
    }), size) : [];
    return {
        getColor: function(index) {
            return palette[index] || null;
        }
    };
}
function $65999879f8b92279$var$createDiscreteColors(source, count) {
    var colorCount = count - 1;
    var sourceCount = source.length - 1;
    var colors = [];
    var gradient = [];
    var i;
    function addColor(pos) {
        var k = sourceCount * pos;
        var kl = $65999879f8b92279$var$_floor(k);
        var kr = $65999879f8b92279$var$_ceil(k);
        gradient.push(colors[kl].blend(colors[kr], k - kl).toHex());
    }
    for(i = 0; i <= sourceCount; ++i)colors.push(new (0, $lmWRz.default)(source[i]));
    if (colorCount > 0) for(i = 0; i <= colorCount; ++i)addColor(i / colorCount);
    else addColor(.5);
    return gradient;
}
function $65999879f8b92279$export$d355f6e10a823494(source, themeDefaultPalette) {
    var palette = $65999879f8b92279$export$747ccad006a63299(source, {
        type: "gradientSet",
        themeDefault: themeDefaultPalette
    });
    var color1 = new (0, $lmWRz.default)(palette[0]);
    var color2 = new (0, $lmWRz.default)(palette[1]);
    return {
        getColor: function(ratio) {
            return 0 <= ratio && ratio <= 1 ? color1.blend(color2, ratio).toHex() : null;
        }
    };
}

});

parcelRegister("4mP7M", function(module, exports) {

$parcel$export(module.exports, "getTheme", function () { return $32e0dfbd705f01bc$export$89cbf1a0881c8b9c; });
$parcel$export(module.exports, "addCacheItem", function () { return $32e0dfbd705f01bc$export$3652c9ca4580443; });
$parcel$export(module.exports, "removeCacheItem", function () { return $32e0dfbd705f01bc$export$5276de248983c9b2; });
/**
 * DevExtreme (esm/viz/themes.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $dw9tZ = parcelRequire("dw9tZ");

var $gv7j8 = parcelRequire("gv7j8");

var $6ntMu = parcelRequire("6ntMu");

var $4Joaa = parcelRequire("4Joaa");

var $9MOuD = parcelRequire("9MOuD");

var $jCQNu = parcelRequire("jCQNu");

var $6h4vM = parcelRequire("6h4vM");

var $9WUzS = parcelRequire("9WUzS");

var $kld7C = parcelRequire("kld7C");

var $l5rHQ = parcelRequire("l5rHQ");

var $9QmcG = parcelRequire("9QmcG");

var $eY71X = parcelRequire("eY71X");
var $32e0dfbd705f01bc$var$themes = {};
var $32e0dfbd705f01bc$var$themesMapping = {};
var $32e0dfbd705f01bc$var$themesSchemeMapping = {};
var $32e0dfbd705f01bc$var$_extend = (0, $2oTOp.extend);
var $32e0dfbd705f01bc$var$_each = (0, $8OLOW.each);
var $32e0dfbd705f01bc$var$currentThemeName = null;
var $32e0dfbd705f01bc$var$defaultTheme;
var $32e0dfbd705f01bc$var$nextCacheUid = 0;
var $32e0dfbd705f01bc$var$widgetsCache = {};
function $32e0dfbd705f01bc$export$89cbf1a0881c8b9c(themeName) {
    var name = (0, $dw9tZ.normalizeEnum)(themeName);
    return $32e0dfbd705f01bc$var$themes[name] || $32e0dfbd705f01bc$var$themes[$32e0dfbd705f01bc$var$themesMapping[name] || $32e0dfbd705f01bc$export$f89dfc8082866bac()];
}
function $32e0dfbd705f01bc$var$findThemeNameByName(name, scheme) {
    return $32e0dfbd705f01bc$var$themesMapping[name + "." + scheme] || $32e0dfbd705f01bc$var$themesSchemeMapping[name + "." + scheme] || $32e0dfbd705f01bc$var$themesMapping[name];
}
function $32e0dfbd705f01bc$var$findThemeNameByPlatform(platform, version, scheme) {
    return $32e0dfbd705f01bc$var$findThemeNameByName(platform + version, scheme) || $32e0dfbd705f01bc$var$findThemeNameByName(platform, scheme);
}
function $32e0dfbd705f01bc$export$f89dfc8082866bac(themeName, colorScheme) {
    if (!arguments.length) return $32e0dfbd705f01bc$var$currentThemeName || $32e0dfbd705f01bc$var$findThemeNameByName((0, $gv7j8.current)()) || $32e0dfbd705f01bc$var$defaultTheme;
    var scheme = (0, $dw9tZ.normalizeEnum)(colorScheme);
    $32e0dfbd705f01bc$var$currentThemeName = (themeName && themeName.platform ? $32e0dfbd705f01bc$var$findThemeNameByPlatform((0, $dw9tZ.normalizeEnum)(themeName.platform), themeName.version, scheme) : $32e0dfbd705f01bc$var$findThemeNameByName((0, $dw9tZ.normalizeEnum)(themeName), scheme)) || $32e0dfbd705f01bc$var$currentThemeName;
    return this;
}
function $32e0dfbd705f01bc$var$getThemeInfo(themeName, splitter) {
    var k = themeName.indexOf(splitter);
    return k > 0 ? {
        name: themeName.substring(0, k),
        scheme: themeName.substring(k + 1)
    } : null;
}
function $32e0dfbd705f01bc$var$registerThemeName(themeName, targetThemeName) {
    var themeInfo = $32e0dfbd705f01bc$var$getThemeInfo(themeName, ".") || {
        name: themeName
    };
    var name = themeInfo.name;
    var scheme = themeInfo.scheme;
    if (scheme) {
        $32e0dfbd705f01bc$var$themesMapping[name] = $32e0dfbd705f01bc$var$themesMapping[name] || targetThemeName;
        $32e0dfbd705f01bc$var$themesMapping[name + "." + scheme] = targetThemeName;
    } else $32e0dfbd705f01bc$var$themesMapping[name] = targetThemeName;
}
function $32e0dfbd705f01bc$export$f9c59eed5de5ff80(theme, baseThemeName) {
    var themeName = (0, $dw9tZ.normalizeEnum)(theme && theme.name);
    if (themeName) {
        theme.isDefault && ($32e0dfbd705f01bc$var$defaultTheme = themeName);
        $32e0dfbd705f01bc$var$registerThemeName(themeName, themeName);
        $32e0dfbd705f01bc$var$themes[themeName] = $32e0dfbd705f01bc$var$_extend(true, {}, $32e0dfbd705f01bc$export$89cbf1a0881c8b9c(baseThemeName), $32e0dfbd705f01bc$var$patchTheme(theme));
    }
}
function $32e0dfbd705f01bc$export$b88723c3b3c4cd8f(from, to) {
    $32e0dfbd705f01bc$var$themesSchemeMapping[from] = to;
}
function $32e0dfbd705f01bc$var$mergeScalar(target, field, source, sourceValue) {
    var _value = source ? source[field] : sourceValue;
    if (void 0 !== _value && void 0 === target[field]) target[field] = _value;
}
function $32e0dfbd705f01bc$var$mergeObject(target, field, source, sourceValue) {
    var _value = source ? source[field] : sourceValue;
    if (void 0 !== _value) target[field] = $32e0dfbd705f01bc$var$_extend(true, {}, _value, target[field]);
}
function $32e0dfbd705f01bc$var$patchTheme(theme) {
    theme = $32e0dfbd705f01bc$var$_extend(true, {
        loadingIndicator: {
            font: {}
        },
        export: {
            font: {}
        },
        legend: {
            font: {},
            border: {}
        },
        title: {
            font: {}
        },
        tooltip: {
            font: {}
        },
        "chart:common": {},
        "chart:common:axis": {
            grid: {},
            minorGrid: {},
            tick: {},
            minorTick: {},
            title: {
                font: {}
            },
            label: {
                font: {}
            }
        },
        "chart:common:annotation": {
            font: {},
            border: {}
        },
        chart: {
            commonSeriesSettings: {
                candlestick: {}
            }
        },
        pie: {},
        polar: {},
        gauge: {
            scale: {
                tick: {},
                minorTick: {},
                label: {
                    font: {}
                }
            }
        },
        barGauge: {},
        funnel: {},
        sankey: {},
        map: {
            background: {}
        },
        treeMap: {
            tile: {
                selectionStyle: {
                    border: {}
                }
            },
            group: {
                border: {},
                selectionStyle: {
                    border: {}
                },
                label: {
                    font: {}
                }
            }
        },
        rangeSelector: {
            scale: {
                tick: {},
                minorTick: {},
                label: {
                    font: {}
                }
            },
            chart: {}
        },
        sparkline: {},
        bullet: {}
    }, theme);
    $32e0dfbd705f01bc$var$mergeScalar(theme.loadingIndicator, "backgroundColor", theme);
    $32e0dfbd705f01bc$var$mergeScalar(theme.chart.commonSeriesSettings.candlestick, "innerColor", null, theme.backgroundColor);
    $32e0dfbd705f01bc$var$mergeScalar(theme.map.background, "color", null, theme.backgroundColor);
    $32e0dfbd705f01bc$var$mergeScalar(theme.title.font, "color", null, theme.primaryTitleColor);
    $32e0dfbd705f01bc$var$mergeObject(theme.title, "subtitle", null, theme.title);
    $32e0dfbd705f01bc$var$mergeScalar(theme.legend.font, "color", null, theme.secondaryTitleColor);
    $32e0dfbd705f01bc$var$mergeScalar(theme.legend.border, "color", null, theme.gridColor);
    $32e0dfbd705f01bc$var$patchAxes(theme);
    $32e0dfbd705f01bc$var$_each([
        "chart",
        "pie",
        "polar",
        "gauge",
        "barGauge",
        "map",
        "treeMap",
        "funnel",
        "rangeSelector",
        "sparkline",
        "bullet",
        "sankey"
    ], function(_, section) {
        $32e0dfbd705f01bc$var$mergeScalar(theme[section], "redrawOnResize", theme);
        $32e0dfbd705f01bc$var$mergeScalar(theme[section], "containerBackgroundColor", null, theme.backgroundColor);
        $32e0dfbd705f01bc$var$mergeObject(theme[section], "tooltip", theme);
        $32e0dfbd705f01bc$var$mergeObject(theme[section], "export", theme);
    });
    $32e0dfbd705f01bc$var$_each([
        "chart",
        "pie",
        "polar",
        "gauge",
        "barGauge",
        "map",
        "treeMap",
        "funnel",
        "rangeSelector",
        "sankey"
    ], function(_, section) {
        $32e0dfbd705f01bc$var$mergeObject(theme[section], "loadingIndicator", theme);
        $32e0dfbd705f01bc$var$mergeObject(theme[section], "legend", theme);
        $32e0dfbd705f01bc$var$mergeObject(theme[section], "title", theme);
    });
    $32e0dfbd705f01bc$var$_each([
        "chart",
        "pie",
        "polar"
    ], function(_, section) {
        $32e0dfbd705f01bc$var$mergeObject(theme, section, null, theme["chart:common"]);
    });
    $32e0dfbd705f01bc$var$_each([
        "chart",
        "polar"
    ], function(_, section) {
        theme[section] = theme[section] || {};
        $32e0dfbd705f01bc$var$mergeObject(theme[section], "commonAxisSettings", null, theme["chart:common:axis"]);
    });
    $32e0dfbd705f01bc$var$_each([
        "chart",
        "polar",
        "map",
        "pie"
    ], function(_, section) {
        theme[section] = theme[section] || {};
        $32e0dfbd705f01bc$var$mergeObject(theme[section], "commonAnnotationSettings", null, theme["chart:common:annotation"]);
    });
    $32e0dfbd705f01bc$var$mergeObject(theme.rangeSelector.chart, "commonSeriesSettings", theme.chart);
    $32e0dfbd705f01bc$var$mergeObject(theme.rangeSelector.chart, "dataPrepareSettings", theme.chart);
    $32e0dfbd705f01bc$var$mergeScalar(theme.treeMap.group.border, "color", null, theme.gridColor);
    $32e0dfbd705f01bc$var$mergeScalar(theme.treeMap.tile.selectionStyle.border, "color", null, theme.primaryTitleColor);
    $32e0dfbd705f01bc$var$mergeScalar(theme.treeMap.group.selectionStyle.border, "color", null, theme.primaryTitleColor);
    $32e0dfbd705f01bc$var$mergeScalar(theme.map.legend, "backgroundColor", theme);
    $32e0dfbd705f01bc$var$patchMapLayers(theme);
    return theme;
}
function $32e0dfbd705f01bc$var$patchAxes(theme) {
    var commonAxisSettings = theme["chart:common:axis"];
    $32e0dfbd705f01bc$var$_each([
        commonAxisSettings.grid,
        commonAxisSettings.minorGrid
    ], function(_, obj) {
        $32e0dfbd705f01bc$var$mergeScalar(obj, "color", null, theme.gridColor);
    });
    $32e0dfbd705f01bc$var$_each([
        commonAxisSettings,
        commonAxisSettings.tick,
        commonAxisSettings.minorTick,
        commonAxisSettings.label.font
    ], function(_, obj) {
        $32e0dfbd705f01bc$var$mergeScalar(obj, "color", null, theme.axisColor);
    });
    $32e0dfbd705f01bc$var$mergeScalar(commonAxisSettings.title.font, "color", null, theme.secondaryTitleColor);
    $32e0dfbd705f01bc$var$mergeScalar(theme.gauge.scale.label.font, "color", null, theme.axisColor);
    $32e0dfbd705f01bc$var$mergeScalar(theme.gauge.scale.tick, "color", null, theme.backgroundColor);
    $32e0dfbd705f01bc$var$mergeScalar(theme.gauge.scale.minorTick, "color", null, theme.backgroundColor);
    $32e0dfbd705f01bc$var$mergeScalar(theme.rangeSelector.scale.label.font, "color", null, theme.axisColor);
}
function $32e0dfbd705f01bc$var$patchMapLayers(theme) {
    var map = theme.map;
    $32e0dfbd705f01bc$var$_each([
        "area",
        "line",
        "marker"
    ], function(_, section) {
        $32e0dfbd705f01bc$var$mergeObject(map, "layer:" + section, null, map.layer);
    });
    $32e0dfbd705f01bc$var$_each([
        "dot",
        "bubble",
        "pie",
        "image"
    ], function(_, section) {
        $32e0dfbd705f01bc$var$mergeObject(map, "layer:marker:" + section, null, map["layer:marker"]);
    });
}
function $32e0dfbd705f01bc$export$3652c9ca4580443(target) {
    var cacheUid = ++$32e0dfbd705f01bc$var$nextCacheUid;
    target._cache = cacheUid;
    $32e0dfbd705f01bc$var$widgetsCache[cacheUid] = target;
}
function $32e0dfbd705f01bc$export$5276de248983c9b2(target) {
    delete $32e0dfbd705f01bc$var$widgetsCache[target._cache];
}
function $32e0dfbd705f01bc$export$7e677a7b493344b1() {
    $32e0dfbd705f01bc$var$_each($32e0dfbd705f01bc$var$widgetsCache, function() {
        this.refresh();
    });
    return this;
}
if ((0, $6ntMu.isEmptyObject)($32e0dfbd705f01bc$var$themes) && (0, $6ntMu.isEmptyObject)($32e0dfbd705f01bc$var$themesMapping) && !$32e0dfbd705f01bc$var$defaultTheme) [].concat((0, $4Joaa.default), (0, $9MOuD.default), (0, $jCQNu.default), (0, $6h4vM.default), (0, $9WUzS.default), (0, $kld7C.default), (0, $l5rHQ.default), (0, $9QmcG.default), (0, $eY71X.default)).forEach((t)=>{
    $32e0dfbd705f01bc$export$f9c59eed5de5ff80(t.theme, t.baseThemeName);
});

});
parcelRegister("gv7j8", function(module, exports) {

$parcel$export(module.exports, "current", function () { return $c03535b6b3ee25dc$export$97aac956da55dae9; });
/**
 * DevExtreme (esm/ui/themes.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $iE2yv = parcelRequire("iE2yv");

var $jF0bZ = parcelRequire("jF0bZ");

var $3yzYM = parcelRequire("3yzYM");

var $2vlX8 = parcelRequire("2vlX8");

var $dDkff = parcelRequire("dDkff");

var $XxsMu = parcelRequire("XxsMu");

var $8OLOW = parcelRequire("8OLOW");

var $8n1m9 = parcelRequire("8n1m9");

var $3O5Oh = parcelRequire("3O5Oh");

var $hYatw = parcelRequire("hYatw");

var $ax9z5 = parcelRequire("ax9z5");

var $HvBq2 = parcelRequire("HvBq2");
var $c03535b6b3ee25dc$var$window = (0, $hYatw.getWindow)();
var $c03535b6b3ee25dc$var$ready = (0, $8n1m9.default).add;
var $c03535b6b3ee25dc$var$viewPort = (0, $3O5Oh.value);
var $c03535b6b3ee25dc$var$viewPortChanged = (0, $3O5Oh.changeCallback);
var $c03535b6b3ee25dc$var$initDeferred = new (0, $dDkff.Deferred);
var $c03535b6b3ee25dc$var$DX_LINK_SELECTOR = "link[rel=dx-theme]";
var $c03535b6b3ee25dc$var$THEME_ATTR = "data-theme";
var $c03535b6b3ee25dc$var$ACTIVE_ATTR = "data-active";
var $c03535b6b3ee25dc$var$DX_HAIRLINES_CLASS = "dx-hairlines";
var $c03535b6b3ee25dc$var$ANY_THEME = "any";
var $c03535b6b3ee25dc$var$context;
var $c03535b6b3ee25dc$var$$activeThemeLink;
var $c03535b6b3ee25dc$var$knownThemes;
var $c03535b6b3ee25dc$var$currentThemeName;
var $c03535b6b3ee25dc$var$pendingThemeName;
var $c03535b6b3ee25dc$var$defaultTimeout = 15e3;
var $c03535b6b3ee25dc$var$THEME_MARKER_PREFIX = "dx.";
function $c03535b6b3ee25dc$var$readThemeMarker() {
    if (!(0, $hYatw.hasWindow)()) return null;
    var element = (0, $2vlX8.default)("<div>", $c03535b6b3ee25dc$var$context).addClass("dx-theme-marker").appendTo($c03535b6b3ee25dc$var$context.documentElement);
    var result;
    try {
        result = $c03535b6b3ee25dc$var$window.getComputedStyle(element.get(0)).fontFamily;
        if (!result) return null;
        result = result.replace(/["']/g, "");
        if (result.substr(0, $c03535b6b3ee25dc$var$THEME_MARKER_PREFIX.length) !== $c03535b6b3ee25dc$var$THEME_MARKER_PREFIX) return null;
        return result.substr($c03535b6b3ee25dc$var$THEME_MARKER_PREFIX.length);
    } finally{
        element.remove();
    }
}
function $c03535b6b3ee25dc$export$7539c5f20fb4e2d6(themeName) {
    var waitStartTime;
    var timerId;
    var intervalCleared = true;
    $c03535b6b3ee25dc$var$pendingThemeName = themeName;
    function handleLoaded() {
        $c03535b6b3ee25dc$var$pendingThemeName = null;
        clearInterval(timerId);
        intervalCleared = true;
        (0, $ax9z5.themeReadyCallback).fire();
        (0, $ax9z5.themeReadyCallback).empty();
        $c03535b6b3ee25dc$var$initDeferred.resolve();
    }
    if ($c03535b6b3ee25dc$export$6401058c755eed88() || !$c03535b6b3ee25dc$var$defaultTimeout) handleLoaded();
    else {
        if (!intervalCleared) {
            if ($c03535b6b3ee25dc$var$pendingThemeName) $c03535b6b3ee25dc$var$pendingThemeName = themeName;
            return;
        }
        waitStartTime = Date.now();
        intervalCleared = false;
        timerId = setInterval(function() {
            var isLoaded = $c03535b6b3ee25dc$export$6401058c755eed88();
            var isTimeout = !isLoaded && Date.now() - waitStartTime > $c03535b6b3ee25dc$var$defaultTimeout;
            if (isTimeout) (0, $HvBq2.default).log("W0004", $c03535b6b3ee25dc$var$pendingThemeName);
            if (isLoaded || isTimeout) handleLoaded();
        }, 10);
    }
}
function $c03535b6b3ee25dc$export$6401058c755eed88() {
    if (!$c03535b6b3ee25dc$var$pendingThemeName) return true;
    var anyThemePending = $c03535b6b3ee25dc$var$pendingThemeName === $c03535b6b3ee25dc$var$ANY_THEME;
    if ("resolved" === $c03535b6b3ee25dc$var$initDeferred.state() && anyThemePending) return true;
    var themeMarker = $c03535b6b3ee25dc$var$readThemeMarker();
    if (themeMarker && anyThemePending) return true;
    return themeMarker === $c03535b6b3ee25dc$var$pendingThemeName;
}
function $c03535b6b3ee25dc$var$processMarkup() {
    var $allThemeLinks = (0, $2vlX8.default)($c03535b6b3ee25dc$var$DX_LINK_SELECTOR, $c03535b6b3ee25dc$var$context);
    if (!$allThemeLinks.length) return;
    $c03535b6b3ee25dc$var$knownThemes = {};
    $c03535b6b3ee25dc$var$$activeThemeLink = (0, $2vlX8.default)((0, $XxsMu.parseHTML)("<link rel=stylesheet>"), $c03535b6b3ee25dc$var$context);
    $allThemeLinks.each(function() {
        var link = (0, $2vlX8.default)(this, $c03535b6b3ee25dc$var$context);
        var fullThemeName = link.attr($c03535b6b3ee25dc$var$THEME_ATTR);
        var url = link.attr("href");
        var isActive = "true" === link.attr($c03535b6b3ee25dc$var$ACTIVE_ATTR);
        $c03535b6b3ee25dc$var$knownThemes[fullThemeName] = {
            url: url,
            isActive: isActive
        };
    });
    $allThemeLinks.last().after($c03535b6b3ee25dc$var$$activeThemeLink);
    $allThemeLinks.remove();
}
function $c03535b6b3ee25dc$var$resolveFullThemeName(desiredThemeName) {
    var desiredThemeParts = desiredThemeName ? desiredThemeName.split(".") : [];
    var result = null;
    if ($c03535b6b3ee25dc$var$knownThemes) {
        if (desiredThemeName in $c03535b6b3ee25dc$var$knownThemes) return desiredThemeName;
        (0, $8OLOW.each)($c03535b6b3ee25dc$var$knownThemes, function(knownThemeName, themeData) {
            var knownThemeParts = knownThemeName.split(".");
            if (desiredThemeParts[0] && knownThemeParts[0] !== desiredThemeParts[0]) return;
            if (desiredThemeParts[1] && desiredThemeParts[1] !== knownThemeParts[1]) return;
            if (desiredThemeParts[2] && desiredThemeParts[2] !== knownThemeParts[2]) return;
            if (!result || themeData.isActive) result = knownThemeName;
            if (themeData.isActive) return false;
        });
    }
    return result;
}
function $c03535b6b3ee25dc$var$initContext(newContext) {
    try {
        if (newContext !== $c03535b6b3ee25dc$var$context) $c03535b6b3ee25dc$var$knownThemes = null;
    } catch (x) {
        $c03535b6b3ee25dc$var$knownThemes = null;
    }
    $c03535b6b3ee25dc$var$context = newContext;
}
function $c03535b6b3ee25dc$export$2cd8252107eb640b(options) {
    options = options || {};
    $c03535b6b3ee25dc$var$initContext(options.context || (0, $3yzYM.default).getDocument());
    if (!$c03535b6b3ee25dc$var$context) return;
    $c03535b6b3ee25dc$var$processMarkup();
    $c03535b6b3ee25dc$var$currentThemeName = void 0;
    $c03535b6b3ee25dc$export$97aac956da55dae9(options);
}
function $c03535b6b3ee25dc$export$97aac956da55dae9(options) {
    if (!arguments.length) {
        $c03535b6b3ee25dc$var$currentThemeName = $c03535b6b3ee25dc$var$currentThemeName || $c03535b6b3ee25dc$var$readThemeMarker();
        return $c03535b6b3ee25dc$var$currentThemeName;
    }
    $c03535b6b3ee25dc$export$95af15e7e6aec8c4($c03535b6b3ee25dc$var$viewPort());
    options = options || {};
    if ("string" === typeof options) options = {
        theme: options
    };
    var isAutoInit = options._autoInit;
    var loadCallback = options.loadCallback;
    var currentThemeData;
    $c03535b6b3ee25dc$var$currentThemeName = $c03535b6b3ee25dc$var$resolveFullThemeName(options.theme || $c03535b6b3ee25dc$var$currentThemeName);
    if ($c03535b6b3ee25dc$var$currentThemeName) currentThemeData = $c03535b6b3ee25dc$var$knownThemes[$c03535b6b3ee25dc$var$currentThemeName];
    if (loadCallback) (0, $ax9z5.themeReadyCallback).add(loadCallback);
    if (currentThemeData) {
        $c03535b6b3ee25dc$var$$activeThemeLink.attr("href", $c03535b6b3ee25dc$var$knownThemes[$c03535b6b3ee25dc$var$currentThemeName].url);
        if ((0, $ax9z5.themeReadyCallback).has() || "resolved" !== $c03535b6b3ee25dc$var$initDeferred.state() || options._forceTimeout) $c03535b6b3ee25dc$export$7539c5f20fb4e2d6($c03535b6b3ee25dc$var$currentThemeName);
    } else if (isAutoInit) {
        if ((0, $hYatw.hasWindow)()) $c03535b6b3ee25dc$export$7539c5f20fb4e2d6($c03535b6b3ee25dc$var$ANY_THEME);
        (0, $ax9z5.themeReadyCallback).fire();
        (0, $ax9z5.themeReadyCallback).empty();
    } else throw (0, $HvBq2.default).Error("E0021", $c03535b6b3ee25dc$var$currentThemeName);
    $c03535b6b3ee25dc$var$initDeferred.done(()=>$c03535b6b3ee25dc$export$aa37fc7c9cd9ed39((0, $3O5Oh.originalViewPort)(), $c03535b6b3ee25dc$var$currentThemeName));
}
function $c03535b6b3ee25dc$var$getCssClasses(themeName) {
    themeName = themeName || $c03535b6b3ee25dc$export$97aac956da55dae9();
    var result = [];
    var themeNameParts = themeName && themeName.split(".");
    if (themeNameParts) {
        result.push("dx-theme-" + themeNameParts[0], "dx-theme-" + themeNameParts[0] + "-typography");
        if (themeNameParts.length > 1) result.push("dx-color-scheme-" + themeNameParts[1] + ($c03535b6b3ee25dc$export$3fd812f1603d479a(themeName) ? "-" + themeNameParts[2] : ""));
    }
    return result;
}
var $c03535b6b3ee25dc$var$themeClasses;
function $c03535b6b3ee25dc$export$aa37fc7c9cd9ed39(element, themeName) {
    $c03535b6b3ee25dc$var$themeClasses = $c03535b6b3ee25dc$var$getCssClasses(themeName).join(" ");
    (0, $2vlX8.default)(element).addClass($c03535b6b3ee25dc$var$themeClasses);
    !function() {
        var pixelRatio = (0, $hYatw.hasWindow)() && $c03535b6b3ee25dc$var$window.devicePixelRatio;
        if (!pixelRatio || pixelRatio < 2) return;
        var $tester = (0, $2vlX8.default)("<div>");
        $tester.css("border", ".5px solid transparent");
        (0, $2vlX8.default)("body").append($tester);
        if (1 === (0, $iE2yv.getOuterHeight)($tester)) {
            (0, $2vlX8.default)(element).addClass($c03535b6b3ee25dc$var$DX_HAIRLINES_CLASS);
            $c03535b6b3ee25dc$var$themeClasses += " " + $c03535b6b3ee25dc$var$DX_HAIRLINES_CLASS;
        }
        $tester.remove();
    }();
}
function $c03535b6b3ee25dc$export$95af15e7e6aec8c4(element) {
    (0, $2vlX8.default)(element).removeClass($c03535b6b3ee25dc$var$themeClasses);
}
function $c03535b6b3ee25dc$export$28ee1007e174a2a6(callback) {
    (0, $ax9z5.themeReadyCallback).add(callback);
}
function $c03535b6b3ee25dc$var$isTheme(themeRegExp, themeName) {
    if (!themeName) themeName = $c03535b6b3ee25dc$var$currentThemeName || $c03535b6b3ee25dc$var$readThemeMarker();
    return new RegExp(themeRegExp).test(themeName);
}
function $c03535b6b3ee25dc$export$3fd812f1603d479a(themeName) {
    return $c03535b6b3ee25dc$var$isTheme("material", themeName);
}
function $c03535b6b3ee25dc$export$12ebef8cea5fbe70(themeName) {
    return $c03535b6b3ee25dc$var$isTheme("generic", themeName);
}
function $c03535b6b3ee25dc$export$a79ad82046afa44e(themeName) {
    return $c03535b6b3ee25dc$var$isTheme("dark", themeName);
}
function $c03535b6b3ee25dc$export$817485789353cfbb(themeName) {
    return $c03535b6b3ee25dc$var$isTheme("compact", themeName);
}
function $c03535b6b3ee25dc$export$f608b81a6098c44e(text, fontWeight) {
    var document = (0, $3yzYM.default).getDocument();
    var testElement = document.createElement("span");
    testElement.style.position = "absolute";
    testElement.style.top = "-9999px";
    testElement.style.left = "-9999px";
    testElement.style.visibility = "hidden";
    testElement.style.fontFamily = "Arial";
    testElement.style.fontSize = "250px";
    testElement.style.fontWeight = fontWeight;
    testElement.innerHTML = text;
    document.body.appendChild(testElement);
    var etalonFontWidth = testElement.offsetWidth;
    testElement.style.fontFamily = "Roboto, RobotoFallback, Arial";
    var testedFontWidth = testElement.offsetWidth;
    testElement.parentNode.removeChild(testElement);
    return etalonFontWidth !== testedFontWidth;
}
function $c03535b6b3ee25dc$export$89d3ece523561d26(text, fontWeight) {
    return new Promise((resolve)=>{
        var clear = ()=>{
            clearInterval(intervalId);
            clearTimeout(timeoutId);
            resolve();
        };
        var intervalId = setInterval(()=>{
            if ($c03535b6b3ee25dc$export$f608b81a6098c44e(text, fontWeight)) clear();
        }, 15);
        var timeoutId = setTimeout(clear, 2e3);
    });
}
function $c03535b6b3ee25dc$var$autoInit() {
    $c03535b6b3ee25dc$export$2cd8252107eb640b({
        _autoInit: true,
        _forceTimeout: true
    });
    if ((0, $2vlX8.default)($c03535b6b3ee25dc$var$DX_LINK_SELECTOR, $c03535b6b3ee25dc$var$context).length) throw (0, $HvBq2.default).Error("E0022");
}
if ((0, $hYatw.hasWindow)()) $c03535b6b3ee25dc$var$autoInit();
else $c03535b6b3ee25dc$var$ready($c03535b6b3ee25dc$var$autoInit);
$c03535b6b3ee25dc$var$viewPortChanged.add(function(viewPort, prevViewPort) {
    $c03535b6b3ee25dc$var$initDeferred.done(function() {
        $c03535b6b3ee25dc$export$95af15e7e6aec8c4(prevViewPort);
        $c03535b6b3ee25dc$export$aa37fc7c9cd9ed39(viewPort);
    });
});
(0, $jF0bZ.default).changed.add(function() {
    $c03535b6b3ee25dc$export$2cd8252107eb640b({
        _autoInit: true
    });
});
function $c03535b6b3ee25dc$export$20d2bbb3d4c0a948() {
    $c03535b6b3ee25dc$var$$activeThemeLink && $c03535b6b3ee25dc$var$$activeThemeLink.attr("href", "about:blank");
    $c03535b6b3ee25dc$var$currentThemeName = null;
    $c03535b6b3ee25dc$var$pendingThemeName = null;
    $c03535b6b3ee25dc$var$initDeferred = new (0, $dDkff.Deferred);
}
function $c03535b6b3ee25dc$export$a9944645ccb5faf8(callback) {
    $c03535b6b3ee25dc$var$initDeferred.done(callback);
}
function $c03535b6b3ee25dc$export$69a2d719149fc54c(timeout) {
    $c03535b6b3ee25dc$var$defaultTimeout = timeout;
}
var $c03535b6b3ee25dc$export$2e2bcd8739ae039 = {
    setDefaultTimeout: $c03535b6b3ee25dc$export$69a2d719149fc54c,
    initialized: $c03535b6b3ee25dc$export$a9944645ccb5faf8,
    resetTheme: $c03535b6b3ee25dc$export$20d2bbb3d4c0a948,
    ready: $c03535b6b3ee25dc$export$28ee1007e174a2a6,
    waitWebFont: $c03535b6b3ee25dc$export$89d3ece523561d26,
    isWebFontLoaded: $c03535b6b3ee25dc$export$f608b81a6098c44e,
    isCompact: $c03535b6b3ee25dc$export$817485789353cfbb,
    isDark: $c03535b6b3ee25dc$export$a79ad82046afa44e,
    isGeneric: $c03535b6b3ee25dc$export$12ebef8cea5fbe70,
    isMaterial: $c03535b6b3ee25dc$export$3fd812f1603d479a,
    detachCssClasses: $c03535b6b3ee25dc$export$95af15e7e6aec8c4,
    attachCssClasses: $c03535b6b3ee25dc$export$aa37fc7c9cd9ed39,
    current: $c03535b6b3ee25dc$export$97aac956da55dae9,
    waitForThemeLoad: $c03535b6b3ee25dc$export$7539c5f20fb4e2d6,
    isPendingThemeLoaded: $c03535b6b3ee25dc$export$6401058c755eed88
};

});
parcelRegister("ax9z5", function(module, exports) {

$parcel$export(module.exports, "themeReadyCallback", function () { return $7ab467d5851e41e5$export$cb9b1fc96bceb1a3; });
/**
 * DevExtreme (esm/ui/themes_callback.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $dYDfV = parcelRequire("dYDfV");
var $7ab467d5851e41e5$export$cb9b1fc96bceb1a3 = (0, $dYDfV.default)();

});

parcelRegister("HvBq2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $082c87df23b43dd1$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/ui/widget/ui.errors.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $hCicl = parcelRequire("hCicl");

var $cvYFL = parcelRequire("cvYFL");
var $082c87df23b43dd1$export$2e2bcd8739ae039 = (0, $hCicl.default)((0, $cvYFL.default).ERROR_MESSAGES, {
    E1001: "Module '{0}'. Controller '{1}' is already registered",
    E1002: "Module '{0}'. Controller '{1}' does not inherit from DevExpress.ui.dxDataGrid.Controller",
    E1003: "Module '{0}'. View '{1}' is already registered",
    E1004: "Module '{0}'. View '{1}' does not inherit from DevExpress.ui.dxDataGrid.View",
    E1005: "Public method '{0}' is already registered",
    E1006: "Public method '{0}.{1}' does not exist",
    E1007: "State storing cannot be provided due to the restrictions of the browser",
    E1010: "The template does not contain the TextBox widget",
    E1011: 'Items cannot be deleted from the List. Implement the "remove" function in the data store',
    E1012: "Editing type '{0}' with the name '{1}' is unsupported",
    E1016: "Unexpected type of data source is provided for a lookup column",
    E1018: "The 'collapseAll' method cannot be called if you use a remote data source",
    E1019: "Search mode '{0}' is unavailable",
    E1020: "The type cannot be changed after initialization",
    E1021: "{0} '{1}' you are trying to remove does not exist",
    E1022: 'The "markers" option is given an invalid value. Assign an array instead',
    E1023: 'The "routes" option is given an invalid value. Assign an array instead',
    E1025: "This layout is too complex to render",
    E1026: 'The "calculateCustomSummary" function is missing from a field whose "summaryType" option is set to "custom"',
    E1031: "Unknown subscription in the Scheduler widget: '{0}'",
    E1032: "Unknown start date in an appointment: '{0}'",
    E1033: "Unknown step in the date navigator: '{0}'",
    E1034: "The browser does not implement an API for saving files",
    E1035: "The editor cannot be created: {0}",
    E1037: "Invalid structure of grouped data",
    E1038: "The browser does not support local storages for local web pages",
    E1039: "A cell's position cannot be calculated",
    E1040: "The '{0}' key value is not unique within the data array",
    E1041: "The '{0}' script is referenced after the DevExtreme scripts or not referenced at all",
    E1042: "{0} requires the key field to be specified",
    E1043: "Changes cannot be processed due to the incorrectly set key",
    E1044: "The key field specified by the keyExpr option does not match the key field specified in the data store",
    E1045: "Editing requires the key field to be specified in the data store",
    E1046: "The '{0}' key field is not found in data objects",
    E1047: 'The "{0}" field is not found in the fields array',
    E1048: 'The "{0}" operation is not found in the filterOperations array',
    E1049: "Column '{0}': filtering is allowed but the 'dataField' or 'name' option is not specified",
    E1050: "The validationRules option does not apply to third-party editors defined in the editCellTemplate",
    E1051: 'HtmlEditor\'s valueType is "{0}", but the {0} converter was not imported.',
    E1052: '{0} should have the "dataSource" option specified',
    E1053: 'The "buttons" option accepts an array that contains only objects or string values',
    E1054: "All text editor buttons must have names",
    E1055: 'One or several text editor buttons have invalid or non-unique "name" values',
    E1056: 'The {0} widget does not support buttons of the "{1}" type',
    E1058: 'The "startDayHour" must be earlier than the "endDayHour"',
    E1059: "The following column names are not unique: {0}",
    E1060: "All editable columns must have names",
    W1001: 'The "key" option cannot be modified after initialization',
    W1002: "An item with the key '{0}' does not exist",
    W1003: "A group with the key '{0}' in which you are trying to select items does not exist",
    W1004: "The item '{0}' you are trying to select in the group '{1}' does not exist",
    W1005: "Due to column data types being unspecified, data has been loaded twice in order to apply initial filter settings. To resolve this issue, specify data types for all grid columns.",
    W1006: "The map service returned the following error: '{0}'",
    W1007: "No item with key {0} was found in the data source, but this key was used as the parent key for item {1}",
    W1008: "Cannot scroll to the '{0}' date because it does not exist on the current view",
    W1009: "Searching works only if data is specified using the dataSource option",
    W1010: "The capability to select all items works with source data of plain structure only",
    W1011: 'The "keyExpr" option is not applied when dataSource is not an array',
    W1012: "The '{0}' key field is not found in data objects",
    W1013: 'The "message" field in the dialog component was renamed to "messageHtml". Change your code correspondingly. In addition, if you used HTML code in the message, make sure that it is secure',
    W1014: "The Floating Action Button exceeds the recommended speed dial action count. If you need to display more speed dial actions, increase the maxSpeedDialActionCount option value in the global config.",
    W1015: 'The "cellDuration" should divide the range from the "startDayHour" to the "endDayHour" into even intervals',
    W1016: "The '{0}' field in the HTML Editor toolbar item configuration was renamed to '{1}'. Please make a corresponding change in your code.",
    W1017: "The 'key' property is not specified for a lookup data source. Please specify it to prevent requests for the entire dataset when users filter data.",
    W1018: "Infinite scrolling may not work properly with multiple selection. To use these features together, set 'selection.deferred' to true or set 'selection.selectAllMode' to 'page'.",
    W1019: "Filter query string exceeds maximum length limit of {0} characters.",
    W1020: "hideEvent is ignored when the shading property is true",
    W1021: "The '{0}' is not rendered because none of the DOM elements match the value of the \"container\" property.",
    W1022: "{0} JSON parsing error: '{1}'",
    W1023: "Appointments require unique keys. Otherwise, the agenda view may not work correctly.",
    W1025: "'scrolling.mode' is set to 'virtual' or 'infinite'. Specify the height of the component."
});

});


parcelRegister("4Joaa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $371e1baec5ca366c$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/core/themes/generic.light.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $371e1baec5ca366c$var$WHITE = "#ffffff";
var $371e1baec5ca366c$var$BLACK = "#000000";
var $371e1baec5ca366c$var$LIGHT_GREY = "#d3d3d3";
var $371e1baec5ca366c$var$GREY_GREEN = "#303030";
var $371e1baec5ca366c$var$SOME_GREY = "#2b2b2b";
var $371e1baec5ca366c$var$RED = "#ff0000";
var $371e1baec5ca366c$var$PRIMARY_TITLE_COLOR = "#232323";
var $371e1baec5ca366c$var$SECONDARY_TITLE_COLOR = "#767676";
var $371e1baec5ca366c$var$NONE = "none";
var $371e1baec5ca366c$var$SOLID = "solid";
var $371e1baec5ca366c$var$TOP = "top";
var $371e1baec5ca366c$var$RIGHT = "right";
var $371e1baec5ca366c$var$BOTTOM = "bottom";
var $371e1baec5ca366c$var$LEFT = "left";
var $371e1baec5ca366c$var$CENTER = "center";
var $371e1baec5ca366c$var$INSIDE = "inside";
var $371e1baec5ca366c$var$OUTSIDE = "outside";
var $371e1baec5ca366c$export$2e2bcd8739ae039 = [
    {
        theme: {
            name: "generic.light",
            isDefault: true,
            font: {
                color: $371e1baec5ca366c$var$SECONDARY_TITLE_COLOR,
                family: "'Segoe UI', 'Helvetica Neue', 'Trebuchet MS', Verdana, sans-serif",
                weight: 400,
                size: 12,
                cursor: "default"
            },
            redrawOnResize: true,
            backgroundColor: $371e1baec5ca366c$var$WHITE,
            primaryTitleColor: $371e1baec5ca366c$var$PRIMARY_TITLE_COLOR,
            secondaryTitleColor: $371e1baec5ca366c$var$SECONDARY_TITLE_COLOR,
            gridColor: $371e1baec5ca366c$var$LIGHT_GREY,
            axisColor: $371e1baec5ca366c$var$SECONDARY_TITLE_COLOR,
            title: {
                backgroundColor: $371e1baec5ca366c$var$WHITE,
                font: {
                    size: 28,
                    family: "'Segoe UI Light', 'Helvetica Neue Light', 'Segoe UI', 'Helvetica Neue', 'Trebuchet MS', Verdana, sans-serif",
                    weight: 200
                },
                subtitle: {
                    font: {
                        size: 16
                    },
                    offset: 0,
                    wordWrap: "normal",
                    textOverflow: "ellipsis"
                },
                wordWrap: "normal",
                textOverflow: "ellipsis"
            },
            loadingIndicator: {
                text: "Loading..."
            },
            export: {
                backgroundColor: $371e1baec5ca366c$var$WHITE,
                margin: 10,
                font: {
                    size: 14,
                    color: $371e1baec5ca366c$var$PRIMARY_TITLE_COLOR,
                    weight: 400
                },
                button: {
                    margin: {
                        top: 8,
                        left: 10,
                        right: 10,
                        bottom: 8
                    },
                    default: {
                        color: "#333",
                        borderColor: "#ddd",
                        backgroundColor: $371e1baec5ca366c$var$WHITE
                    },
                    hover: {
                        color: "#333",
                        borderColor: "#bebebe",
                        backgroundColor: "#e6e6e6"
                    },
                    focus: {
                        color: $371e1baec5ca366c$var$BLACK,
                        borderColor: "#9d9d9d",
                        backgroundColor: "#e6e6e6"
                    },
                    active: {
                        color: "#333",
                        borderColor: "#9d9d9d",
                        backgroundColor: "#d4d4d4"
                    }
                },
                shadowColor: $371e1baec5ca366c$var$LIGHT_GREY
            },
            tooltip: {
                enabled: false,
                border: {
                    width: 1,
                    color: $371e1baec5ca366c$var$LIGHT_GREY,
                    dashStyle: $371e1baec5ca366c$var$SOLID,
                    visible: true
                },
                font: {
                    color: $371e1baec5ca366c$var$PRIMARY_TITLE_COLOR
                },
                color: $371e1baec5ca366c$var$WHITE,
                arrowLength: 10,
                paddingLeftRight: 18,
                paddingTopBottom: 15,
                textAlignment: "center",
                shared: false,
                location: $371e1baec5ca366c$var$CENTER,
                shadow: {
                    opacity: .4,
                    offsetX: 0,
                    offsetY: 4,
                    blur: 2,
                    color: $371e1baec5ca366c$var$BLACK
                },
                interactive: false
            },
            legend: {
                hoverMode: "includePoints",
                verticalAlignment: $371e1baec5ca366c$var$TOP,
                horizontalAlignment: $371e1baec5ca366c$var$RIGHT,
                position: $371e1baec5ca366c$var$OUTSIDE,
                visible: true,
                margin: 10,
                markerSize: 12,
                border: {
                    visible: false,
                    width: 1,
                    cornerRadius: 0,
                    dashStyle: $371e1baec5ca366c$var$SOLID
                },
                paddingLeftRight: 20,
                paddingTopBottom: 15,
                columnCount: 0,
                rowCount: 0,
                columnItemSpacing: 20,
                rowItemSpacing: 8,
                title: {
                    backgroundColor: $371e1baec5ca366c$var$WHITE,
                    margin: {
                        left: 0,
                        bottom: 9,
                        right: 0,
                        top: 0
                    },
                    font: {
                        size: 18,
                        weight: 200
                    },
                    subtitle: {
                        offset: 0,
                        font: {
                            size: 14
                        },
                        wordWrap: "none",
                        textOverflow: "ellipsis"
                    },
                    wordWrap: "none",
                    textOverflow: "ellipsis"
                }
            },
            "chart:common": {
                animation: {
                    enabled: true,
                    duration: 1e3,
                    easing: "easeOutCubic",
                    maxPointCountSupported: 300
                },
                commonSeriesSettings: {
                    border: {
                        visible: false,
                        width: 2
                    },
                    showInLegend: true,
                    visible: true,
                    hoverMode: "nearestPoint",
                    selectionMode: "includePoints",
                    hoverStyle: {
                        hatching: {
                            direction: $371e1baec5ca366c$var$RIGHT,
                            width: 2,
                            step: 6,
                            opacity: .75
                        },
                        border: {
                            visible: false,
                            width: 3
                        }
                    },
                    selectionStyle: {
                        hatching: {
                            direction: $371e1baec5ca366c$var$RIGHT,
                            width: 2,
                            step: 6,
                            opacity: .5
                        },
                        border: {
                            visible: false,
                            width: 3
                        }
                    },
                    valueErrorBar: {
                        displayMode: "auto",
                        value: 1,
                        color: $371e1baec5ca366c$var$BLACK,
                        lineWidth: 2,
                        edgeLength: 8
                    },
                    label: {
                        visible: false,
                        alignment: $371e1baec5ca366c$var$CENTER,
                        rotationAngle: 0,
                        horizontalOffset: 0,
                        verticalOffset: 0,
                        radialOffset: 0,
                        showForZeroValues: true,
                        customizeText: void 0,
                        maxLabelCount: void 0,
                        position: $371e1baec5ca366c$var$OUTSIDE,
                        font: {
                            color: $371e1baec5ca366c$var$WHITE
                        },
                        border: {
                            visible: false,
                            width: 1,
                            color: $371e1baec5ca366c$var$LIGHT_GREY,
                            dashStyle: $371e1baec5ca366c$var$SOLID
                        },
                        connector: {
                            visible: false,
                            width: 1
                        }
                    }
                },
                seriesSelectionMode: "single",
                pointSelectionMode: "single",
                equalRowHeight: true,
                dataPrepareSettings: {
                    checkTypeForAllData: false,
                    convertToAxisDataType: true,
                    sortingMethod: true
                },
                title: {
                    margin: 10
                },
                adaptiveLayout: {
                    width: 80,
                    height: 80,
                    keepLabels: true
                },
                _rtl: {
                    legend: {
                        itemTextPosition: $371e1baec5ca366c$var$LEFT
                    }
                },
                resolveLabelOverlapping: $371e1baec5ca366c$var$NONE
            },
            "chart:common:axis": {
                visible: true,
                valueMarginsEnabled: true,
                placeholderSize: null,
                logarithmBase: 10,
                discreteAxisDivisionMode: "betweenLabels",
                aggregatedPointsPosition: "betweenTicks",
                width: 1,
                label: {
                    visible: true
                },
                grid: {
                    visible: false,
                    width: 1
                },
                minorGrid: {
                    visible: false,
                    width: 1,
                    opacity: .3
                },
                tick: {
                    visible: true,
                    width: 1,
                    length: 7,
                    shift: 3
                },
                minorTick: {
                    visible: false,
                    width: 1,
                    opacity: .3,
                    length: 7,
                    shift: 3
                },
                stripStyle: {
                    paddingLeftRight: 10,
                    paddingTopBottom: 5
                },
                constantLineStyle: {
                    width: 1,
                    color: $371e1baec5ca366c$var$BLACK,
                    dashStyle: $371e1baec5ca366c$var$SOLID,
                    label: {
                        visible: true,
                        position: $371e1baec5ca366c$var$INSIDE
                    }
                },
                marker: {
                    label: {}
                }
            },
            "chart:common:annotation": {
                font: {
                    color: "#333333"
                },
                tooltipEnabled: true,
                border: {
                    width: 1,
                    color: "#dddddd",
                    dashStyle: $371e1baec5ca366c$var$SOLID,
                    visible: true
                },
                color: $371e1baec5ca366c$var$WHITE,
                opacity: .9,
                arrowLength: 14,
                arrowWidth: 14,
                paddingLeftRight: 10,
                paddingTopBottom: 10,
                shadow: {
                    opacity: .15,
                    offsetX: 0,
                    offsetY: 1,
                    blur: 4,
                    color: $371e1baec5ca366c$var$BLACK
                },
                image: {
                    width: 30,
                    height: 30
                },
                wordWrap: "normal",
                textOverflow: "ellipsis",
                allowDragging: false
            },
            chart: {
                commonSeriesSettings: {
                    type: "line",
                    stack: "default",
                    aggregation: {
                        enabled: void 0
                    },
                    point: {
                        visible: true,
                        symbol: "circle",
                        size: 12,
                        border: {
                            visible: false,
                            width: 1
                        },
                        hoverMode: "onlyPoint",
                        selectionMode: "onlyPoint",
                        hoverStyle: {
                            border: {
                                visible: true,
                                width: 4
                            }
                        },
                        selectionStyle: {
                            border: {
                                visible: true,
                                width: 4
                            }
                        }
                    },
                    scatter: {},
                    line: {
                        width: 2,
                        dashStyle: $371e1baec5ca366c$var$SOLID,
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: $371e1baec5ca366c$var$NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        }
                    },
                    stackedline: {
                        width: 2,
                        dashStyle: $371e1baec5ca366c$var$SOLID,
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: $371e1baec5ca366c$var$NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        }
                    },
                    stackedspline: {
                        width: 2,
                        dashStyle: $371e1baec5ca366c$var$SOLID,
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: $371e1baec5ca366c$var$NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        }
                    },
                    fullstackedline: {
                        width: 2,
                        dashStyle: $371e1baec5ca366c$var$SOLID,
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: $371e1baec5ca366c$var$NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        }
                    },
                    fullstackedspline: {
                        width: 2,
                        dashStyle: $371e1baec5ca366c$var$SOLID,
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: $371e1baec5ca366c$var$NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        }
                    },
                    stepline: {
                        width: 2,
                        dashStyle: $371e1baec5ca366c$var$SOLID,
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: $371e1baec5ca366c$var$NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        }
                    },
                    area: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    stackedarea: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    fullstackedarea: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    fullstackedsplinearea: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    steparea: {
                        border: {
                            visible: true,
                            width: 2
                        },
                        point: {
                            visible: false
                        },
                        hoverStyle: {
                            border: {
                                visible: true,
                                width: 3
                            }
                        },
                        selectionStyle: {
                            border: {
                                visible: true,
                                width: 3
                            }
                        },
                        opacity: .5
                    },
                    spline: {
                        width: 2,
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: $371e1baec5ca366c$var$NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        }
                    },
                    splinearea: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    stackedsplinearea: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    bar: {
                        cornerRadius: 0,
                        point: {
                            hoverStyle: {
                                border: {
                                    visible: false
                                }
                            },
                            selectionStyle: {
                                border: {
                                    visible: false
                                }
                            }
                        }
                    },
                    stackedbar: {
                        cornerRadius: 0,
                        point: {
                            hoverStyle: {
                                border: {
                                    visible: false
                                }
                            },
                            selectionStyle: {
                                border: {
                                    visible: false
                                }
                            }
                        },
                        label: {
                            position: $371e1baec5ca366c$var$INSIDE
                        }
                    },
                    fullstackedbar: {
                        cornerRadius: 0,
                        point: {
                            hoverStyle: {
                                border: {
                                    visible: false
                                }
                            },
                            selectionStyle: {
                                border: {
                                    visible: false
                                }
                            }
                        },
                        label: {
                            position: $371e1baec5ca366c$var$INSIDE
                        }
                    },
                    rangebar: {
                        cornerRadius: 0,
                        point: {
                            hoverStyle: {
                                border: {
                                    visible: false
                                }
                            },
                            selectionStyle: {
                                border: {
                                    visible: false
                                }
                            }
                        }
                    },
                    rangearea: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    rangesplinearea: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    bubble: {
                        opacity: .5,
                        point: {
                            hoverStyle: {
                                border: {
                                    visible: false
                                }
                            },
                            selectionStyle: {
                                border: {
                                    visible: false
                                }
                            }
                        }
                    },
                    candlestick: {
                        width: 1,
                        reduction: {
                            color: $371e1baec5ca366c$var$RED
                        },
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: $371e1baec5ca366c$var$NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        },
                        point: {
                            border: {
                                visible: true
                            }
                        }
                    },
                    stock: {
                        width: 1,
                        reduction: {
                            color: $371e1baec5ca366c$var$RED
                        },
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: $371e1baec5ca366c$var$NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        },
                        point: {
                            border: {
                                visible: true
                            }
                        }
                    }
                },
                crosshair: {
                    enabled: false,
                    color: "#f05b41",
                    width: 1,
                    dashStyle: $371e1baec5ca366c$var$SOLID,
                    label: {
                        visible: false,
                        font: {
                            color: $371e1baec5ca366c$var$WHITE,
                            size: 12
                        }
                    },
                    verticalLine: {
                        visible: true
                    },
                    horizontalLine: {
                        visible: true
                    }
                },
                commonAxisSettings: {
                    multipleAxesSpacing: 5,
                    forceUserTickInterval: false,
                    breakStyle: {
                        width: 5,
                        color: "#ababab",
                        line: "waved"
                    },
                    label: {
                        displayMode: "standard",
                        overlappingBehavior: "hide",
                        indentFromAxis: 10,
                        wordWrap: "normal",
                        textOverflow: "none"
                    },
                    title: {
                        font: {
                            size: 16
                        },
                        margin: 6,
                        alignment: $371e1baec5ca366c$var$CENTER
                    },
                    constantLineStyle: {
                        paddingLeftRight: 10,
                        paddingTopBottom: 10
                    }
                },
                horizontalAxis: {
                    position: $371e1baec5ca366c$var$BOTTOM,
                    axisDivisionFactor: 70,
                    label: {
                        rotationAngle: 90,
                        staggeringSpacing: 5,
                        alignment: $371e1baec5ca366c$var$CENTER
                    },
                    stripStyle: {
                        label: {
                            horizontalAlignment: $371e1baec5ca366c$var$CENTER,
                            verticalAlignment: $371e1baec5ca366c$var$TOP
                        }
                    },
                    constantLineStyle: {
                        label: {
                            horizontalAlignment: $371e1baec5ca366c$var$RIGHT,
                            verticalAlignment: $371e1baec5ca366c$var$TOP
                        }
                    },
                    constantLines: []
                },
                verticalAxis: {
                    position: $371e1baec5ca366c$var$LEFT,
                    axisDivisionFactor: 40,
                    label: {
                        alignment: $371e1baec5ca366c$var$RIGHT
                    },
                    stripStyle: {
                        label: {
                            horizontalAlignment: $371e1baec5ca366c$var$LEFT,
                            verticalAlignment: $371e1baec5ca366c$var$CENTER
                        }
                    },
                    constantLineStyle: {
                        label: {
                            horizontalAlignment: $371e1baec5ca366c$var$LEFT,
                            verticalAlignment: $371e1baec5ca366c$var$TOP
                        }
                    },
                    constantLines: []
                },
                argumentAxis: {
                    endOnTick: false,
                    workWeek: [
                        1,
                        2,
                        3,
                        4,
                        5
                    ]
                },
                valueAxis: {
                    grid: {
                        visible: true
                    },
                    autoBreaksEnabled: false,
                    maxAutoBreakCount: 4
                },
                commonPaneSettings: {
                    backgroundColor: $371e1baec5ca366c$var$NONE,
                    border: {
                        color: $371e1baec5ca366c$var$LIGHT_GREY,
                        width: 1,
                        visible: false,
                        top: true,
                        bottom: true,
                        left: true,
                        right: true,
                        dashStyle: $371e1baec5ca366c$var$SOLID
                    }
                },
                scrollBar: {
                    visible: false,
                    offset: 5,
                    color: "gray",
                    width: 10
                },
                adjustOnZoom: true,
                autoHidePointMarkers: true,
                rotated: false,
                synchronizeMultiAxes: true,
                stickyHovering: true,
                barGroupPadding: .3,
                minBubbleSize: 12,
                maxBubbleSize: .2,
                zoomAndPan: {
                    dragBoxStyle: {
                        color: "#2a2a2a",
                        opacity: .2
                    },
                    panKey: "shift",
                    allowMouseWheel: true,
                    allowTouchGestures: true
                }
            },
            pie: {
                innerRadius: .5,
                minDiameter: .5,
                type: "pie",
                dataPrepareSettings: {
                    _skipArgumentSorting: true
                },
                commonSeriesSettings: {
                    pie: {
                        border: {
                            visible: false,
                            width: 2,
                            color: $371e1baec5ca366c$var$WHITE
                        },
                        hoverStyle: {
                            hatching: {
                                direction: $371e1baec5ca366c$var$RIGHT,
                                width: 4,
                                step: 10,
                                opacity: .75
                            },
                            border: {
                                visible: false,
                                width: 2
                            }
                        },
                        selectionStyle: {
                            hatching: {
                                direction: $371e1baec5ca366c$var$RIGHT,
                                width: 4,
                                step: 10,
                                opacity: .5
                            },
                            border: {
                                visible: false,
                                width: 2
                            }
                        }
                    },
                    doughnut: {
                        border: {
                            visible: false,
                            width: 2,
                            color: $371e1baec5ca366c$var$WHITE
                        },
                        hoverStyle: {
                            hatching: {
                                direction: $371e1baec5ca366c$var$RIGHT,
                                width: 4,
                                step: 10,
                                opacity: .75
                            },
                            border: {
                                visible: false,
                                width: 2
                            }
                        },
                        selectionStyle: {
                            hatching: {
                                direction: $371e1baec5ca366c$var$RIGHT,
                                width: 4,
                                step: 10,
                                opacity: .5
                            },
                            border: {
                                visible: false,
                                width: 2
                            }
                        }
                    },
                    donut: {
                        border: {
                            visible: false,
                            width: 2,
                            color: $371e1baec5ca366c$var$WHITE
                        },
                        hoverStyle: {
                            hatching: {
                                direction: $371e1baec5ca366c$var$RIGHT,
                                width: 4,
                                step: 10,
                                opacity: .75
                            },
                            border: {
                                visible: false,
                                width: 2
                            }
                        },
                        selectionStyle: {
                            hatching: {
                                direction: $371e1baec5ca366c$var$RIGHT,
                                width: 4,
                                step: 10,
                                opacity: .5
                            },
                            border: {
                                visible: false,
                                width: 2
                            }
                        }
                    },
                    label: {
                        textOverflow: "ellipsis",
                        wordWrap: "normal"
                    }
                },
                legend: {
                    hoverMode: "allArgumentPoints",
                    backgroundColor: $371e1baec5ca366c$var$NONE
                },
                adaptiveLayout: {
                    keepLabels: false
                }
            },
            gauge: {
                scale: {
                    tick: {
                        visible: true,
                        length: 5,
                        width: 2,
                        opacity: 1
                    },
                    minorTick: {
                        visible: false,
                        length: 3,
                        width: 1,
                        opacity: 1
                    },
                    label: {
                        visible: true,
                        alignment: $371e1baec5ca366c$var$CENTER,
                        hideFirstOrLast: "last",
                        overlappingBehavior: "hide"
                    },
                    position: $371e1baec5ca366c$var$TOP,
                    endOnTick: false
                },
                rangeContainer: {
                    offset: 0,
                    width: 5,
                    backgroundColor: "#808080"
                },
                valueIndicators: {
                    _default: {
                        color: "#c2c2c2"
                    },
                    rangebar: {
                        space: 2,
                        size: 10,
                        color: "#cbc5cf",
                        backgroundColor: $371e1baec5ca366c$var$NONE,
                        text: {
                            indent: 0,
                            font: {
                                size: 14,
                                color: null
                            }
                        }
                    },
                    twocolorneedle: {
                        secondColor: "#e18e92"
                    },
                    trianglemarker: {
                        space: 2,
                        length: 14,
                        width: 13,
                        color: "#8798a5"
                    },
                    textcloud: {
                        arrowLength: 5,
                        horizontalOffset: 6,
                        verticalOffset: 3,
                        color: "#679ec5",
                        text: {
                            font: {
                                color: $371e1baec5ca366c$var$WHITE,
                                size: 18
                            }
                        }
                    }
                },
                indicator: {
                    hasPositiveMeaning: true,
                    layout: {
                        horizontalAlignment: $371e1baec5ca366c$var$CENTER,
                        verticalAlignment: $371e1baec5ca366c$var$BOTTOM
                    },
                    text: {
                        font: {
                            size: 18
                        }
                    }
                },
                _circular: {
                    scale: {
                        scaleDivisionFactor: 17,
                        orientation: $371e1baec5ca366c$var$OUTSIDE,
                        label: {
                            indentFromTick: 10
                        }
                    },
                    rangeContainer: {
                        orientation: $371e1baec5ca366c$var$OUTSIDE
                    },
                    valueIndicatorType: "rectangleneedle",
                    subvalueIndicatorType: "trianglemarker",
                    valueIndicators: {
                        _type: "rectangleneedle",
                        _default: {
                            offset: 20,
                            indentFromCenter: 0,
                            width: 2,
                            spindleSize: 14,
                            spindleGapSize: 10,
                            beginAdaptingAtRadius: 50
                        },
                        triangleneedle: {
                            width: 4
                        },
                        twocolorneedle: {
                            space: 2,
                            secondFraction: .4
                        },
                        rangebar: {
                            offset: 30
                        },
                        trianglemarker: {
                            offset: 6
                        },
                        textcloud: {
                            offset: -6
                        }
                    }
                },
                _linear: {
                    scale: {
                        scaleDivisionFactor: 25,
                        horizontalOrientation: $371e1baec5ca366c$var$RIGHT,
                        verticalOrientation: $371e1baec5ca366c$var$BOTTOM,
                        label: {
                            indentFromTick: -10
                        }
                    },
                    rangeContainer: {
                        horizontalOrientation: $371e1baec5ca366c$var$RIGHT,
                        verticalOrientation: $371e1baec5ca366c$var$BOTTOM
                    },
                    valueIndicatorType: "rangebar",
                    subvalueIndicatorType: "trianglemarker",
                    valueIndicators: {
                        _type: "rectangle",
                        _default: {
                            offset: 2.5,
                            length: 15,
                            width: 15
                        },
                        rectangle: {
                            width: 10
                        },
                        rangebar: {
                            offset: 10,
                            horizontalOrientation: $371e1baec5ca366c$var$RIGHT,
                            verticalOrientation: $371e1baec5ca366c$var$BOTTOM
                        },
                        trianglemarker: {
                            offset: 10,
                            horizontalOrientation: $371e1baec5ca366c$var$LEFT,
                            verticalOrientation: $371e1baec5ca366c$var$TOP
                        },
                        textcloud: {
                            offset: -1,
                            horizontalOrientation: $371e1baec5ca366c$var$LEFT,
                            verticalOrientation: $371e1baec5ca366c$var$TOP
                        }
                    }
                }
            },
            barGauge: {
                backgroundColor: "#e0e0e0",
                relativeInnerRadius: .3,
                barSpacing: 4,
                resolveLabelOverlapping: "hide",
                label: {
                    indent: 20,
                    connectorWidth: 2,
                    font: {
                        size: 16
                    }
                },
                legend: {
                    visible: false
                },
                indicator: {
                    hasPositiveMeaning: true,
                    layout: {
                        horizontalAlignment: $371e1baec5ca366c$var$CENTER,
                        verticalAlignment: $371e1baec5ca366c$var$BOTTOM
                    },
                    text: {
                        font: {
                            size: 18
                        }
                    }
                }
            },
            rangeSelector: {
                scale: {
                    valueMarginsEnabled: true,
                    width: 1,
                    color: $371e1baec5ca366c$var$BLACK,
                    opacity: .1,
                    showCustomBoundaryTicks: true,
                    label: {
                        overlappingBehavior: "hide",
                        alignment: $371e1baec5ca366c$var$CENTER,
                        visible: true,
                        topIndent: 7,
                        font: {
                            size: 11
                        }
                    },
                    tick: {
                        width: 1,
                        color: $371e1baec5ca366c$var$BLACK,
                        opacity: .17,
                        visible: true,
                        length: 12
                    },
                    minorTick: {
                        width: 1,
                        color: $371e1baec5ca366c$var$BLACK,
                        opacity: .05,
                        visible: true,
                        length: 12
                    },
                    marker: {
                        width: 1,
                        color: "#000000",
                        opacity: .1,
                        visible: true,
                        separatorHeight: 33,
                        topIndent: 10,
                        textLeftIndent: 7,
                        textTopIndent: 11,
                        label: {}
                    },
                    logarithmBase: 10,
                    workWeek: [
                        1,
                        2,
                        3,
                        4,
                        5
                    ],
                    breakStyle: {
                        width: 5,
                        color: "#ababab",
                        line: "waved"
                    },
                    endOnTick: false
                },
                selectedRangeColor: "#606060",
                sliderMarker: {
                    visible: true,
                    paddingTopBottom: 2,
                    paddingLeftRight: 4,
                    color: "#606060",
                    invalidRangeColor: $371e1baec5ca366c$var$RED,
                    font: {
                        color: $371e1baec5ca366c$var$WHITE,
                        size: 11
                    }
                },
                sliderHandle: {
                    width: 1,
                    color: $371e1baec5ca366c$var$BLACK,
                    opacity: .2
                },
                shutter: {
                    opacity: .75
                },
                background: {
                    color: "#c0bae1",
                    visible: true,
                    image: {
                        location: "full"
                    }
                },
                behavior: {
                    snapToTicks: true,
                    animationEnabled: true,
                    moveSelectedRangeByClick: true,
                    manualRangeSelectionEnabled: true,
                    allowSlidersSwap: true,
                    callValueChanged: "onMovingComplete"
                },
                redrawOnResize: true,
                chart: {
                    barGroupPadding: .3,
                    minBubbleSize: 12,
                    maxBubbleSize: .2,
                    topIndent: .1,
                    bottomIndent: 0,
                    valueAxis: {
                        inverted: false,
                        logarithmBase: 10
                    },
                    commonSeriesSettings: {
                        type: "area",
                        aggregation: {
                            enabled: void 0
                        },
                        point: {
                            visible: false
                        },
                        scatter: {
                            point: {
                                visible: true
                            }
                        }
                    }
                }
            },
            map: {
                title: {
                    margin: 10
                },
                background: {
                    borderWidth: 1,
                    borderColor: "#cacaca"
                },
                layer: {
                    label: {
                        enabled: false,
                        stroke: $371e1baec5ca366c$var$WHITE,
                        "stroke-width": 1,
                        "stroke-opacity": .7,
                        font: {
                            color: $371e1baec5ca366c$var$SOME_GREY,
                            size: 12
                        }
                    }
                },
                "layer:area": {
                    borderWidth: 1,
                    borderColor: $371e1baec5ca366c$var$WHITE,
                    color: "#d2d2d2",
                    hoveredBorderColor: $371e1baec5ca366c$var$GREY_GREEN,
                    selectedBorderWidth: 2,
                    selectedBorderColor: $371e1baec5ca366c$var$GREY_GREEN,
                    label: {
                        "stroke-width": 2,
                        font: {
                            size: 16
                        }
                    }
                },
                "layer:line": {
                    borderWidth: 2,
                    color: "#ba8365",
                    hoveredColor: "#a94813",
                    selectedBorderWidth: 3,
                    selectedColor: "#e55100",
                    label: {
                        "stroke-width": 2,
                        font: {
                            size: 16
                        }
                    }
                },
                "layer:marker": {
                    label: {
                        enabled: true,
                        "stroke-width": 1,
                        font: {
                            size: 12
                        }
                    }
                },
                "layer:marker:dot": {
                    borderWidth: 2,
                    borderColor: $371e1baec5ca366c$var$WHITE,
                    size: 8,
                    selectedStep: 2,
                    backStep: 18,
                    backColor: $371e1baec5ca366c$var$WHITE,
                    backOpacity: .32,
                    shadow: true
                },
                "layer:marker:bubble": {
                    minSize: 20,
                    maxSize: 50,
                    hoveredBorderWidth: 1,
                    hoveredBorderColor: $371e1baec5ca366c$var$GREY_GREEN,
                    selectedBorderWidth: 2,
                    selectedBorderColor: $371e1baec5ca366c$var$GREY_GREEN
                },
                "layer:marker:pie": {
                    size: 50,
                    hoveredBorderWidth: 1,
                    hoveredBorderColor: $371e1baec5ca366c$var$GREY_GREEN,
                    selectedBorderWidth: 2,
                    selectedBorderColor: $371e1baec5ca366c$var$GREY_GREEN
                },
                "layer:marker:image": {
                    size: 20
                },
                legend: {
                    verticalAlignment: $371e1baec5ca366c$var$BOTTOM,
                    horizontalAlignment: $371e1baec5ca366c$var$RIGHT,
                    position: $371e1baec5ca366c$var$INSIDE,
                    backgroundOpacity: .65,
                    border: {
                        visible: true
                    },
                    paddingLeftRight: 16,
                    paddingTopBottom: 12
                },
                controlBar: {
                    borderColor: "#5d5d5d",
                    borderWidth: 3,
                    color: $371e1baec5ca366c$var$WHITE,
                    margin: 20,
                    opacity: .3
                },
                _rtl: {
                    legend: {
                        itemTextPosition: $371e1baec5ca366c$var$LEFT
                    }
                }
            },
            treeMap: {
                tile: {
                    border: {
                        width: 1,
                        opacity: .2,
                        color: "#000000"
                    },
                    color: "#5f8b95",
                    hoverStyle: {
                        hatching: {
                            opacity: .75,
                            step: 6,
                            width: 2,
                            direction: "right"
                        },
                        border: {}
                    },
                    selectionStyle: {
                        hatching: {
                            opacity: .5,
                            step: 6,
                            width: 2,
                            direction: "right"
                        },
                        border: {
                            opacity: 1
                        }
                    },
                    label: {
                        visible: true,
                        paddingLeftRight: 5,
                        paddingTopBottom: 4,
                        font: {
                            color: "#ffffff",
                            weight: 600
                        },
                        shadow: {
                            opacity: .6,
                            offsetX: 0,
                            offsetY: 1,
                            blur: 2,
                            color: "#000000"
                        },
                        wordWrap: "normal",
                        textOverflow: "ellipsis"
                    }
                },
                group: {
                    padding: 4,
                    border: {
                        width: 1
                    },
                    color: "#eeeeee",
                    hoverStyle: {
                        hatching: {
                            opacity: 0,
                            step: 6,
                            width: 2,
                            direction: "right"
                        },
                        border: {}
                    },
                    selectionStyle: {
                        hatching: {
                            opacity: 0,
                            step: 6,
                            width: 2,
                            direction: "right"
                        },
                        border: {}
                    },
                    label: {
                        visible: true,
                        paddingLeftRight: 5,
                        paddingTopBottom: 4,
                        font: {
                            color: $371e1baec5ca366c$var$SECONDARY_TITLE_COLOR,
                            weight: 600
                        },
                        textOverflow: "ellipsis"
                    }
                },
                title: {
                    subtitle: {}
                },
                tooltip: {},
                loadingIndicator: {}
            },
            sparkline: {
                lineColor: "#666666",
                lineWidth: 2,
                areaOpacity: .2,
                minColor: "#e8c267",
                maxColor: "#e55253",
                barPositiveColor: "#a9a9a9",
                barNegativeColor: "#d7d7d7",
                winColor: "#a9a9a9",
                lossColor: "#d7d7d7",
                firstLastColor: "#666666",
                pointSymbol: "circle",
                pointColor: $371e1baec5ca366c$var$WHITE,
                pointSize: 4,
                type: "line",
                argumentField: "arg",
                valueField: "val",
                winlossThreshold: 0,
                showFirstLast: true,
                showMinMax: false,
                tooltip: {
                    enabled: true
                }
            },
            bullet: {
                color: "#e8c267",
                targetColor: "#666666",
                targetWidth: 4,
                showTarget: true,
                showZeroLevel: true,
                tooltip: {
                    enabled: true
                }
            },
            polar: {
                commonSeriesSettings: {
                    type: "scatter",
                    closed: true,
                    point: {
                        visible: true,
                        symbol: "circle",
                        size: 12,
                        border: {
                            visible: false,
                            width: 1
                        },
                        hoverMode: "onlyPoint",
                        selectionMode: "onlyPoint",
                        hoverStyle: {
                            border: {
                                visible: true,
                                width: 4
                            },
                            size: 12
                        },
                        selectionStyle: {
                            border: {
                                visible: true,
                                width: 4
                            },
                            size: 12
                        }
                    },
                    scatter: {},
                    line: {
                        width: 2,
                        dashStyle: $371e1baec5ca366c$var$SOLID,
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: $371e1baec5ca366c$var$NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        }
                    },
                    area: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    stackedline: {
                        width: 2
                    },
                    bar: {
                        opacity: .8
                    },
                    stackedbar: {
                        opacity: .8
                    }
                },
                adaptiveLayout: {
                    width: 80,
                    height: 80,
                    keepLabels: true
                },
                barGroupPadding: .3,
                commonAxisSettings: {
                    visible: true,
                    forceUserTickInterval: false,
                    label: {
                        overlappingBehavior: "hide",
                        indentFromAxis: 5
                    },
                    grid: {
                        visible: true
                    },
                    minorGrid: {
                        visible: true
                    },
                    tick: {
                        visible: true
                    },
                    title: {
                        font: {
                            size: 16
                        },
                        margin: 10
                    }
                },
                argumentAxis: {
                    startAngle: 0,
                    firstPointOnStartAngle: false,
                    period: void 0
                },
                valueAxis: {
                    endOnTick: false,
                    tick: {
                        visible: false
                    }
                },
                horizontalAxis: {
                    position: $371e1baec5ca366c$var$TOP,
                    axisDivisionFactor: 50,
                    label: {
                        alignment: $371e1baec5ca366c$var$CENTER
                    }
                },
                verticalAxis: {
                    position: $371e1baec5ca366c$var$TOP,
                    axisDivisionFactor: 30,
                    label: {
                        alignment: $371e1baec5ca366c$var$RIGHT
                    }
                }
            },
            funnel: {
                sortData: true,
                valueField: "val",
                colorField: "color",
                argumentField: "arg",
                hoverEnabled: true,
                selectionMode: "single",
                item: {
                    border: {
                        visible: false,
                        width: 2,
                        color: $371e1baec5ca366c$var$WHITE
                    },
                    hoverStyle: {
                        hatching: {
                            opacity: .75,
                            step: 6,
                            width: 2,
                            direction: $371e1baec5ca366c$var$RIGHT
                        },
                        border: {}
                    },
                    selectionStyle: {
                        hatching: {
                            opacity: .5,
                            step: 6,
                            width: 2,
                            direction: $371e1baec5ca366c$var$RIGHT
                        },
                        border: {}
                    }
                },
                title: {
                    margin: 10
                },
                adaptiveLayout: {
                    width: 80,
                    height: 80,
                    keepLabels: true
                },
                legend: {
                    visible: false
                },
                _rtl: {
                    legend: {
                        itemTextPosition: $371e1baec5ca366c$var$LEFT
                    }
                },
                tooltip: {
                    customizeTooltip: function(info) {
                        return {
                            text: info.item.argument + " " + info.valueText
                        };
                    }
                },
                inverted: false,
                algorithm: "dynamicSlope",
                neckWidth: 0,
                neckHeight: 0,
                resolveLabelOverlapping: "shift",
                label: {
                    textOverflow: "ellipsis",
                    wordWrap: "normal",
                    visible: true,
                    horizontalAlignment: $371e1baec5ca366c$var$RIGHT,
                    horizontalOffset: 0,
                    verticalOffset: 0,
                    showForZeroValues: false,
                    customizeText: function(info) {
                        return info.item.argument + " " + info.valueText;
                    },
                    position: "columns",
                    font: {
                        color: $371e1baec5ca366c$var$WHITE
                    },
                    border: {
                        visible: false,
                        width: 1,
                        color: $371e1baec5ca366c$var$LIGHT_GREY,
                        dashStyle: $371e1baec5ca366c$var$SOLID
                    },
                    connector: {
                        visible: true,
                        width: 1,
                        opacity: .5
                    }
                }
            },
            sankey: {
                sourceField: "source",
                targetField: "target",
                weightField: "weight",
                hoverEnabled: true,
                alignment: $371e1baec5ca366c$var$CENTER,
                adaptiveLayout: {
                    width: 80,
                    height: 80,
                    keepLabels: true
                },
                label: {
                    visible: true,
                    horizontalOffset: 8,
                    verticalOffset: 0,
                    overlappingBehavior: "ellipsis",
                    useNodeColors: false,
                    font: {
                        color: $371e1baec5ca366c$var$BLACK,
                        weight: 500
                    },
                    border: {
                        visible: false,
                        width: 2,
                        color: $371e1baec5ca366c$var$WHITE
                    },
                    customizeText: function(info) {
                        return info.title;
                    },
                    shadow: {
                        opacity: .2,
                        offsetX: 0,
                        offsetY: 1,
                        blur: 1,
                        color: $371e1baec5ca366c$var$WHITE
                    }
                },
                title: {
                    margin: 10,
                    font: {
                        size: 28,
                        weight: 200
                    },
                    subtitle: {
                        font: {
                            size: 16
                        }
                    }
                },
                tooltip: {
                    enabled: true
                },
                node: {
                    padding: 30,
                    width: 8,
                    opacity: 1,
                    border: {
                        color: $371e1baec5ca366c$var$WHITE,
                        width: 1,
                        visible: false
                    },
                    hoverStyle: {
                        hatching: {
                            opacity: .75,
                            step: 6,
                            width: 2,
                            direction: $371e1baec5ca366c$var$RIGHT
                        },
                        border: {}
                    }
                },
                link: {
                    color: "#888888",
                    colorMode: "none",
                    opacity: .3,
                    border: {
                        color: $371e1baec5ca366c$var$WHITE,
                        width: 1,
                        visible: false
                    },
                    hoverStyle: {
                        opacity: .5,
                        hatching: {
                            opacity: .75,
                            step: 6,
                            width: 2,
                            direction: $371e1baec5ca366c$var$RIGHT
                        },
                        border: {}
                    }
                }
            }
        },
        baseThemeName: void 0
    },
    {
        theme: {
            name: "generic.light.compact"
        },
        baseThemeName: "generic.light"
    }
];

});

parcelRegister("9MOuD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71ffc39e00132976$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/core/themes/generic.carmine.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $71ffc39e00132976$var$ACCENT_COLOR = "#f05b41";
var $71ffc39e00132976$var$BACKGROUND_COLOR = "#fff";
var $71ffc39e00132976$var$TITLE_COLOR = "#333";
var $71ffc39e00132976$var$SUBTITLE_COLOR = "#8899a8";
var $71ffc39e00132976$var$TEXT_COLOR = "#707070";
var $71ffc39e00132976$var$BORDER_COLOR = "#dee1e3";
var $71ffc39e00132976$export$2e2bcd8739ae039 = [
    {
        theme: {
            name: "generic.carmine",
            defaultPalette: "Carmine",
            backgroundColor: $71ffc39e00132976$var$BACKGROUND_COLOR,
            primaryTitleColor: $71ffc39e00132976$var$TITLE_COLOR,
            secondaryTitleColor: $71ffc39e00132976$var$SUBTITLE_COLOR,
            gridColor: $71ffc39e00132976$var$BORDER_COLOR,
            axisColor: $71ffc39e00132976$var$TEXT_COLOR,
            export: {
                backgroundColor: $71ffc39e00132976$var$BACKGROUND_COLOR,
                font: {
                    color: $71ffc39e00132976$var$TITLE_COLOR
                },
                button: {
                    default: {
                        color: $71ffc39e00132976$var$TITLE_COLOR,
                        borderColor: "#b1b7bd",
                        backgroundColor: $71ffc39e00132976$var$BACKGROUND_COLOR
                    },
                    hover: {
                        color: $71ffc39e00132976$var$TITLE_COLOR,
                        borderColor: "#b1b7bd",
                        backgroundColor: "#faf2f0"
                    },
                    focus: {
                        color: $71ffc39e00132976$var$TITLE_COLOR,
                        borderColor: "#6d7781",
                        backgroundColor: "#faf2f0"
                    },
                    active: {
                        color: $71ffc39e00132976$var$TITLE_COLOR,
                        borderColor: "#6d7781",
                        backgroundColor: "#f5e7e4"
                    }
                }
            },
            legend: {
                font: {
                    color: $71ffc39e00132976$var$TEXT_COLOR
                }
            },
            tooltip: {
                color: $71ffc39e00132976$var$BACKGROUND_COLOR,
                border: {
                    color: $71ffc39e00132976$var$BORDER_COLOR
                },
                font: {
                    color: $71ffc39e00132976$var$TITLE_COLOR
                }
            },
            "chart:common": {
                commonSeriesSettings: {
                    label: {
                        border: {
                            color: $71ffc39e00132976$var$BORDER_COLOR
                        }
                    }
                }
            },
            "chart:common:annotation": {
                font: {
                    color: $71ffc39e00132976$var$TITLE_COLOR
                },
                border: {
                    color: $71ffc39e00132976$var$BORDER_COLOR
                },
                color: $71ffc39e00132976$var$BACKGROUND_COLOR
            },
            chart: {
                commonPaneSettings: {
                    border: {
                        color: $71ffc39e00132976$var$BORDER_COLOR
                    }
                },
                commonAxisSettings: {
                    breakStyle: {
                        color: "#c1c5c7"
                    }
                }
            },
            rangeSelector: {
                scale: {
                    breakStyle: {
                        color: "#c1c5c7"
                    },
                    tick: {
                        opacity: .12
                    }
                },
                selectedRangeColor: $71ffc39e00132976$var$ACCENT_COLOR,
                sliderMarker: {
                    color: $71ffc39e00132976$var$ACCENT_COLOR
                },
                sliderHandle: {
                    color: $71ffc39e00132976$var$ACCENT_COLOR,
                    opacity: .5
                }
            },
            sparkline: {
                pointColor: $71ffc39e00132976$var$BACKGROUND_COLOR,
                minColor: "#f0ad4e",
                maxColor: "#f74d61"
            },
            treeMap: {
                group: {
                    color: $71ffc39e00132976$var$BORDER_COLOR,
                    label: {
                        font: {
                            color: $71ffc39e00132976$var$SUBTITLE_COLOR
                        }
                    }
                }
            },
            bullet: {
                color: $71ffc39e00132976$var$ACCENT_COLOR
            },
            gauge: {
                valueIndicators: {
                    rangebar: {
                        color: $71ffc39e00132976$var$ACCENT_COLOR
                    },
                    textcloud: {
                        color: $71ffc39e00132976$var$ACCENT_COLOR
                    }
                }
            }
        },
        baseThemeName: "generic.light"
    },
    {
        theme: {
            name: "generic.carmine.compact"
        },
        baseThemeName: "generic.carmine"
    }
];

});

parcelRegister("jCQNu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e49a85565b1adcd0$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/core/themes/generic.dark.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $e49a85565b1adcd0$var$WHITE = "#ffffff";
var $e49a85565b1adcd0$var$BLACK = "#000000";
var $e49a85565b1adcd0$var$SOME_GREY = "#2b2b2b";
var $e49a85565b1adcd0$var$RANGE_COLOR = "#b5b5b5";
var $e49a85565b1adcd0$var$GREY_GREEN = "#303030";
var $e49a85565b1adcd0$var$AREA_LAYER_COLOR = "#686868";
var $e49a85565b1adcd0$var$LINE_COLOR = "#c7c7c7";
var $e49a85565b1adcd0$var$TARGET_COLOR = "#8e8e8e";
var $e49a85565b1adcd0$var$POSITIVE_COLOR = "#b8b8b8";
var $e49a85565b1adcd0$var$BORDER_COLOR = "#494949";
var $e49a85565b1adcd0$export$2e2bcd8739ae039 = [
    {
        theme: {
            name: "generic.dark",
            font: {
                color: "#808080"
            },
            backgroundColor: "#2a2a2a",
            primaryTitleColor: "#dedede",
            secondaryTitleColor: "#a3a3a3",
            gridColor: "#555555",
            axisColor: "#a3a3a3",
            export: {
                backgroundColor: "#2a2a2a",
                font: {
                    color: "#dbdbdb"
                },
                button: {
                    default: {
                        color: "#dedede",
                        borderColor: "#4d4d4d",
                        backgroundColor: "#2e2e2e"
                    },
                    hover: {
                        color: "#dedede",
                        borderColor: "#6c6c6c",
                        backgroundColor: "#444"
                    },
                    focus: {
                        color: "#dedede",
                        borderColor: "#8d8d8d",
                        backgroundColor: "#444444"
                    },
                    active: {
                        color: "#dedede",
                        borderColor: "#8d8d8d",
                        backgroundColor: "#555555"
                    }
                },
                shadowColor: "#292929"
            },
            tooltip: {
                color: $e49a85565b1adcd0$var$SOME_GREY,
                border: {
                    color: $e49a85565b1adcd0$var$BORDER_COLOR
                },
                font: {
                    color: "#929292"
                }
            },
            "chart:common": {
                commonSeriesSettings: {
                    label: {
                        border: {
                            color: $e49a85565b1adcd0$var$BORDER_COLOR
                        }
                    },
                    valueErrorBar: {
                        color: $e49a85565b1adcd0$var$WHITE
                    }
                }
            },
            "chart:common:axis": {
                constantLineStyle: {
                    color: $e49a85565b1adcd0$var$WHITE
                }
            },
            "chart:common:annotation": {
                font: {
                    color: "#929292"
                },
                border: {
                    color: $e49a85565b1adcd0$var$BORDER_COLOR
                },
                color: $e49a85565b1adcd0$var$SOME_GREY,
                shadow: {
                    opacity: .008,
                    offsetY: 4,
                    blur: 8
                }
            },
            chart: {
                commonPaneSettings: {
                    border: {
                        color: $e49a85565b1adcd0$var$BORDER_COLOR
                    }
                },
                commonAxisSettings: {
                    breakStyle: {
                        color: "#818181"
                    }
                },
                zoomAndPan: {
                    dragBoxStyle: {
                        color: $e49a85565b1adcd0$var$WHITE
                    }
                }
            },
            gauge: {
                rangeContainer: {
                    backgroundColor: $e49a85565b1adcd0$var$RANGE_COLOR
                },
                valueIndicators: {
                    _default: {
                        color: $e49a85565b1adcd0$var$RANGE_COLOR
                    },
                    rangebar: {
                        color: "#84788b"
                    },
                    twocolorneedle: {
                        secondColor: "#ba544d"
                    },
                    trianglemarker: {
                        color: "#b7918f"
                    },
                    textcloud: {
                        color: "#ba544d"
                    }
                }
            },
            barGauge: {
                backgroundColor: "#3c3c3c"
            },
            rangeSelector: {
                scale: {
                    tick: {
                        color: $e49a85565b1adcd0$var$WHITE,
                        opacity: .32
                    },
                    minorTick: {
                        color: $e49a85565b1adcd0$var$WHITE,
                        opacity: .1
                    },
                    breakStyle: {
                        color: "#818181"
                    }
                },
                selectedRangeColor: $e49a85565b1adcd0$var$RANGE_COLOR,
                sliderMarker: {
                    color: $e49a85565b1adcd0$var$RANGE_COLOR,
                    font: {
                        color: $e49a85565b1adcd0$var$GREY_GREEN
                    }
                },
                sliderHandle: {
                    color: $e49a85565b1adcd0$var$WHITE,
                    opacity: .2
                },
                shutter: {
                    color: $e49a85565b1adcd0$var$SOME_GREY,
                    opacity: .9
                }
            },
            map: {
                background: {
                    borderColor: "#3f3f3f"
                },
                layer: {
                    label: {
                        stroke: $e49a85565b1adcd0$var$BLACK,
                        font: {
                            color: $e49a85565b1adcd0$var$WHITE
                        }
                    }
                },
                "layer:area": {
                    borderColor: $e49a85565b1adcd0$var$GREY_GREEN,
                    color: $e49a85565b1adcd0$var$AREA_LAYER_COLOR,
                    hoveredBorderColor: $e49a85565b1adcd0$var$WHITE,
                    selectedBorderColor: $e49a85565b1adcd0$var$WHITE
                },
                "layer:line": {
                    color: "#c77244",
                    hoveredColor: "#ff5d04",
                    selectedColor: "#ff784f"
                },
                "layer:marker:bubble": {
                    hoveredBorderColor: $e49a85565b1adcd0$var$WHITE,
                    selectedBorderColor: $e49a85565b1adcd0$var$WHITE
                },
                "layer:marker:pie": {
                    hoveredBorderColor: $e49a85565b1adcd0$var$WHITE,
                    selectedBorderColor: $e49a85565b1adcd0$var$WHITE
                },
                legend: {
                    border: {
                        color: "#3f3f3f"
                    },
                    font: {
                        color: $e49a85565b1adcd0$var$WHITE
                    }
                },
                controlBar: {
                    borderColor: $e49a85565b1adcd0$var$LINE_COLOR,
                    color: $e49a85565b1adcd0$var$GREY_GREEN
                }
            },
            treeMap: {
                group: {
                    color: "#4c4c4c",
                    label: {
                        font: {
                            color: "#a3a3a3"
                        }
                    }
                }
            },
            sparkline: {
                lineColor: $e49a85565b1adcd0$var$LINE_COLOR,
                firstLastColor: $e49a85565b1adcd0$var$LINE_COLOR,
                barPositiveColor: $e49a85565b1adcd0$var$POSITIVE_COLOR,
                barNegativeColor: $e49a85565b1adcd0$var$TARGET_COLOR,
                winColor: $e49a85565b1adcd0$var$POSITIVE_COLOR,
                lossColor: $e49a85565b1adcd0$var$TARGET_COLOR,
                pointColor: $e49a85565b1adcd0$var$GREY_GREEN
            },
            bullet: {
                targetColor: $e49a85565b1adcd0$var$TARGET_COLOR
            },
            funnel: {
                item: {
                    border: {
                        color: "#2a2a2a"
                    }
                }
            },
            sankey: {
                label: {
                    font: {
                        color: $e49a85565b1adcd0$var$WHITE
                    },
                    shadow: {
                        opacity: 0
                    }
                },
                node: {
                    border: {
                        color: "#2a2a2a"
                    }
                },
                link: {
                    color: "#888888",
                    border: {
                        color: "#2a2a2a"
                    },
                    hoverStyle: {
                        color: "#bbbbbb"
                    }
                }
            }
        },
        baseThemeName: "generic.light"
    },
    {
        theme: {
            name: "generic.dark.compact"
        },
        baseThemeName: "generic.dark"
    }
];

});

parcelRegister("6h4vM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4917d48678b4b4bc$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/core/themes/generic.contrast.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $4917d48678b4b4bc$var$WHITE = "#ffffff";
var $4917d48678b4b4bc$var$BLACK = "#000000";
var $4917d48678b4b4bc$var$CONTRAST_ACTIVE = "#cf00da";
var $4917d48678b4b4bc$var$MARKER_COLOR = "#f8ca00";
var $4917d48678b4b4bc$var$AREA_LAYER_COLOR = "#686868";
var $4917d48678b4b4bc$export$2e2bcd8739ae039 = [
    {
        theme: {
            name: "generic.contrast",
            defaultPalette: "Bright",
            font: {
                color: $4917d48678b4b4bc$var$WHITE
            },
            backgroundColor: $4917d48678b4b4bc$var$BLACK,
            primaryTitleColor: $4917d48678b4b4bc$var$WHITE,
            secondaryTitleColor: $4917d48678b4b4bc$var$WHITE,
            gridColor: $4917d48678b4b4bc$var$WHITE,
            axisColor: $4917d48678b4b4bc$var$WHITE,
            export: {
                backgroundColor: $4917d48678b4b4bc$var$BLACK,
                font: {
                    color: $4917d48678b4b4bc$var$WHITE
                },
                button: {
                    default: {
                        color: $4917d48678b4b4bc$var$WHITE,
                        borderColor: $4917d48678b4b4bc$var$WHITE,
                        backgroundColor: $4917d48678b4b4bc$var$BLACK
                    },
                    hover: {
                        color: $4917d48678b4b4bc$var$WHITE,
                        borderColor: $4917d48678b4b4bc$var$WHITE,
                        backgroundColor: "#cf00d7"
                    },
                    focus: {
                        color: $4917d48678b4b4bc$var$WHITE,
                        borderColor: "#cf00d7",
                        backgroundColor: $4917d48678b4b4bc$var$BLACK
                    },
                    active: {
                        color: $4917d48678b4b4bc$var$BLACK,
                        borderColor: $4917d48678b4b4bc$var$WHITE,
                        backgroundColor: $4917d48678b4b4bc$var$WHITE
                    }
                },
                borderColor: $4917d48678b4b4bc$var$WHITE,
                menuButtonColor: $4917d48678b4b4bc$var$BLACK,
                activeBackgroundColor: $4917d48678b4b4bc$var$WHITE,
                activeColor: $4917d48678b4b4bc$var$BLACK,
                selectedBorderColor: $4917d48678b4b4bc$var$CONTRAST_ACTIVE,
                selectedColor: $4917d48678b4b4bc$var$CONTRAST_ACTIVE,
                shadowColor: "none"
            },
            tooltip: {
                border: {
                    color: $4917d48678b4b4bc$var$WHITE
                },
                font: {
                    color: $4917d48678b4b4bc$var$WHITE
                },
                color: $4917d48678b4b4bc$var$BLACK
            },
            "chart:common": {
                commonSeriesSettings: {
                    valueErrorBar: {
                        color: $4917d48678b4b4bc$var$WHITE
                    },
                    hoverStyle: {
                        hatching: {
                            opacity: .5
                        }
                    },
                    selectionStyle: {
                        hatching: {
                            opacity: .35
                        }
                    },
                    label: {
                        font: {
                            color: $4917d48678b4b4bc$var$WHITE
                        },
                        border: {
                            color: $4917d48678b4b4bc$var$WHITE
                        }
                    }
                }
            },
            "chart:common:axis": {
                constantLineStyle: {
                    color: $4917d48678b4b4bc$var$WHITE
                }
            },
            "chart:common:annotation": {
                font: {
                    color: $4917d48678b4b4bc$var$WHITE
                },
                border: {
                    color: $4917d48678b4b4bc$var$WHITE
                },
                color: $4917d48678b4b4bc$var$BLACK
            },
            chart: {
                commonSeriesSettings: {},
                crosshair: {
                    color: "#cf00d7"
                },
                commonPaneSettings: {
                    backgroundColor: $4917d48678b4b4bc$var$BLACK,
                    border: {
                        color: $4917d48678b4b4bc$var$WHITE
                    }
                },
                scrollBar: {
                    color: $4917d48678b4b4bc$var$WHITE
                },
                commonAxisSettings: {
                    breakStyle: {
                        color: "#cf00d7"
                    }
                },
                zoomAndPan: {
                    dragBoxStyle: {
                        color: $4917d48678b4b4bc$var$WHITE,
                        opacity: .7
                    }
                }
            },
            pie: {
                commonSeriesSettings: {
                    pie: {
                        hoverStyle: {
                            hatching: {
                                opacity: .5
                            }
                        },
                        selectionStyle: {
                            hatching: {
                                opacity: .35
                            }
                        }
                    },
                    doughnut: {
                        hoverStyle: {
                            hatching: {
                                opacity: .5
                            }
                        },
                        selectionStyle: {
                            hatching: {
                                opacity: .35
                            }
                        }
                    },
                    donut: {
                        hoverStyle: {
                            hatching: {
                                opacity: .5
                            }
                        },
                        selectionStyle: {
                            hatching: {
                                opacity: .35
                            }
                        }
                    }
                }
            },
            gauge: {
                rangeContainer: {
                    backgroundColor: $4917d48678b4b4bc$var$WHITE
                },
                valueIndicators: {
                    _default: {
                        color: $4917d48678b4b4bc$var$WHITE
                    },
                    rangebar: {
                        color: $4917d48678b4b4bc$var$WHITE,
                        backgroundColor: $4917d48678b4b4bc$var$BLACK
                    },
                    twocolorneedle: {
                        secondColor: $4917d48678b4b4bc$var$WHITE
                    },
                    trianglemarker: {
                        color: $4917d48678b4b4bc$var$WHITE
                    },
                    textcloud: {
                        color: $4917d48678b4b4bc$var$WHITE,
                        text: {
                            font: {
                                color: $4917d48678b4b4bc$var$BLACK
                            }
                        }
                    }
                }
            },
            barGauge: {
                backgroundColor: "#3c3c3c"
            },
            rangeSelector: {
                scale: {
                    tick: {
                        color: $4917d48678b4b4bc$var$WHITE,
                        opacity: .4
                    },
                    minorTick: {
                        color: $4917d48678b4b4bc$var$WHITE,
                        opacity: .12
                    },
                    breakStyle: {
                        color: "#cf00d7"
                    }
                },
                selectedRangeColor: $4917d48678b4b4bc$var$CONTRAST_ACTIVE,
                sliderMarker: {
                    color: $4917d48678b4b4bc$var$CONTRAST_ACTIVE
                },
                sliderHandle: {
                    color: $4917d48678b4b4bc$var$CONTRAST_ACTIVE,
                    opacity: 1
                },
                shutter: {
                    opacity: .75
                },
                background: {
                    color: $4917d48678b4b4bc$var$BLACK
                }
            },
            map: {
                background: {
                    borderColor: $4917d48678b4b4bc$var$WHITE
                },
                layer: {
                    label: {
                        stroke: $4917d48678b4b4bc$var$BLACK,
                        font: {
                            color: $4917d48678b4b4bc$var$WHITE
                        }
                    }
                },
                "layer:area": {
                    borderColor: $4917d48678b4b4bc$var$BLACK,
                    color: $4917d48678b4b4bc$var$AREA_LAYER_COLOR,
                    hoveredBorderColor: $4917d48678b4b4bc$var$WHITE,
                    selectedBorderColor: $4917d48678b4b4bc$var$WHITE,
                    label: {
                        font: {
                            opacity: 1
                        }
                    }
                },
                "layer:line": {
                    color: "#267cff",
                    hoveredColor: "#f613ff",
                    selectedColor: $4917d48678b4b4bc$var$WHITE
                },
                "layer:marker:dot": {
                    borderColor: $4917d48678b4b4bc$var$BLACK,
                    color: $4917d48678b4b4bc$var$MARKER_COLOR,
                    backColor: $4917d48678b4b4bc$var$BLACK,
                    backOpacity: .32
                },
                "layer:marker:bubble": {
                    color: $4917d48678b4b4bc$var$MARKER_COLOR,
                    hoveredBorderColor: $4917d48678b4b4bc$var$WHITE,
                    selectedBorderColor: $4917d48678b4b4bc$var$WHITE
                },
                "layer:marker:pie": {
                    hoveredBorderColor: $4917d48678b4b4bc$var$WHITE,
                    selectedBorderColor: $4917d48678b4b4bc$var$WHITE
                },
                controlBar: {
                    borderColor: $4917d48678b4b4bc$var$WHITE,
                    color: $4917d48678b4b4bc$var$BLACK,
                    opacity: .3
                }
            },
            treeMap: {
                tile: {
                    color: "#70c92f"
                },
                group: {
                    color: "#797979",
                    label: {
                        font: {
                            color: $4917d48678b4b4bc$var$WHITE
                        }
                    }
                }
            },
            sparkline: {
                pointColor: $4917d48678b4b4bc$var$BLACK
            },
            bullet: {},
            polar: {
                commonSeriesSettings: {}
            },
            funnel: {
                label: {
                    connector: {
                        opacity: 1
                    }
                }
            },
            sankey: {
                label: {
                    font: {
                        color: $4917d48678b4b4bc$var$WHITE
                    },
                    shadow: {
                        opacity: 0
                    }
                },
                node: {
                    border: {
                        visible: true,
                        width: 1,
                        color: $4917d48678b4b4bc$var$WHITE
                    }
                },
                link: {
                    opacity: .5,
                    border: {
                        visible: true,
                        width: 1,
                        color: $4917d48678b4b4bc$var$WHITE
                    },
                    hoverStyle: {
                        opacity: .9
                    }
                }
            }
        },
        baseThemeName: "generic.light"
    },
    {
        theme: {
            name: "generic.contrast.compact"
        },
        baseThemeName: "generic.contrast"
    }
];

});

parcelRegister("9WUzS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73e56b011377dcc4$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/core/themes/generic.darkmoon.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $73e56b011377dcc4$var$ACCENT_COLOR = "#3debd3";
var $73e56b011377dcc4$var$BACKGROUND_COLOR = "#465672";
var $73e56b011377dcc4$var$TITLE_COLOR = "#fff";
var $73e56b011377dcc4$var$SUBTITLE_COLOR = "#919bac";
var $73e56b011377dcc4$var$TEXT_COLOR = "#c7ccd4";
var $73e56b011377dcc4$var$BORDER_COLOR = "#596980";
var $73e56b011377dcc4$export$2e2bcd8739ae039 = [
    {
        theme: {
            name: "generic.darkmoon",
            defaultPalette: "Dark Moon",
            backgroundColor: $73e56b011377dcc4$var$BACKGROUND_COLOR,
            primaryTitleColor: $73e56b011377dcc4$var$TITLE_COLOR,
            secondaryTitleColor: $73e56b011377dcc4$var$SUBTITLE_COLOR,
            gridColor: $73e56b011377dcc4$var$BORDER_COLOR,
            axisColor: $73e56b011377dcc4$var$TEXT_COLOR,
            export: {
                backgroundColor: $73e56b011377dcc4$var$BACKGROUND_COLOR,
                font: {
                    color: $73e56b011377dcc4$var$TITLE_COLOR
                },
                button: {
                    default: {
                        color: $73e56b011377dcc4$var$TITLE_COLOR,
                        borderColor: "#7a889e",
                        backgroundColor: $73e56b011377dcc4$var$BACKGROUND_COLOR
                    },
                    hover: {
                        color: $73e56b011377dcc4$var$TITLE_COLOR,
                        borderColor: "#9da8b8",
                        backgroundColor: "#596e92"
                    },
                    focus: {
                        color: $73e56b011377dcc4$var$TITLE_COLOR,
                        borderColor: "#c4cad4",
                        backgroundColor: "#596e92"
                    },
                    active: {
                        color: $73e56b011377dcc4$var$TITLE_COLOR,
                        borderColor: "#c4cad4",
                        backgroundColor: "#6b80a4"
                    }
                }
            },
            legend: {
                font: {
                    color: $73e56b011377dcc4$var$TEXT_COLOR
                }
            },
            tooltip: {
                color: "#62789e",
                border: {
                    color: $73e56b011377dcc4$var$BORDER_COLOR
                },
                font: {
                    color: $73e56b011377dcc4$var$TITLE_COLOR
                }
            },
            "chart:common": {
                commonSeriesSettings: {
                    label: {
                        border: {
                            color: $73e56b011377dcc4$var$BORDER_COLOR
                        }
                    }
                }
            },
            "chart:common:annotation": {
                font: {
                    color: $73e56b011377dcc4$var$TITLE_COLOR
                },
                border: {
                    color: $73e56b011377dcc4$var$BORDER_COLOR
                },
                color: "#62789e"
            },
            chart: {
                commonPaneSettings: {
                    border: {
                        color: $73e56b011377dcc4$var$BORDER_COLOR
                    }
                },
                commonAxisSettings: {
                    breakStyle: {
                        color: "#73869e"
                    }
                }
            },
            gauge: {
                valueIndicators: {
                    rangebar: {
                        color: $73e56b011377dcc4$var$ACCENT_COLOR
                    },
                    textcloud: {
                        color: $73e56b011377dcc4$var$ACCENT_COLOR,
                        text: {
                            font: {
                                color: $73e56b011377dcc4$var$BACKGROUND_COLOR
                            }
                        }
                    }
                }
            },
            barGauge: {
                backgroundColor: "#526280"
            },
            funnel: {
                item: {
                    border: {
                        color: $73e56b011377dcc4$var$BACKGROUND_COLOR
                    }
                }
            },
            sparkline: {
                pointColor: $73e56b011377dcc4$var$BACKGROUND_COLOR,
                minColor: "#f0ad4e",
                maxColor: "#f9517e"
            },
            treeMap: {
                group: {
                    color: $73e56b011377dcc4$var$BORDER_COLOR,
                    label: {
                        font: {
                            color: $73e56b011377dcc4$var$TITLE_COLOR
                        }
                    }
                }
            },
            map: {
                background: {
                    borderColor: $73e56b011377dcc4$var$BORDER_COLOR
                },
                "layer:area": {
                    color: "#97a3b6",
                    borderColor: $73e56b011377dcc4$var$BACKGROUND_COLOR
                }
            },
            rangeSelector: {
                shutter: {
                    color: $73e56b011377dcc4$var$BACKGROUND_COLOR
                },
                scale: {
                    breakStyle: {
                        color: "#73869e"
                    },
                    tick: {
                        opacity: .2
                    }
                },
                selectedRangeColor: $73e56b011377dcc4$var$ACCENT_COLOR,
                sliderMarker: {
                    color: $73e56b011377dcc4$var$ACCENT_COLOR,
                    font: {
                        color: "#000"
                    }
                },
                sliderHandle: {
                    color: $73e56b011377dcc4$var$ACCENT_COLOR,
                    opacity: .5
                }
            },
            bullet: {
                color: $73e56b011377dcc4$var$ACCENT_COLOR
            },
            sankey: {
                link: {
                    border: {
                        color: $73e56b011377dcc4$var$BACKGROUND_COLOR
                    }
                },
                node: {
                    border: {
                        color: $73e56b011377dcc4$var$BACKGROUND_COLOR
                    }
                }
            }
        },
        baseThemeName: "generic.dark"
    },
    {
        theme: {
            name: "generic.darkmoon.compact"
        },
        baseThemeName: "generic.darkmoon"
    }
];

});

parcelRegister("kld7C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eceff289ca4c1052$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/core/themes/generic.darkviolet.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $eceff289ca4c1052$var$ACCENT_COLOR = "#9c63ff";
var $eceff289ca4c1052$var$BACKGROUND_COLOR = "#17171f";
var $eceff289ca4c1052$var$TITLE_COLOR = "#f5f6f7";
var $eceff289ca4c1052$var$SUBTITLE_COLOR = "#fff";
var $eceff289ca4c1052$var$TEXT_COLOR = "#b2b2b6";
var $eceff289ca4c1052$var$BORDER_COLOR = "#343840";
var $eceff289ca4c1052$export$2e2bcd8739ae039 = [
    {
        theme: {
            name: "generic.darkviolet",
            defaultPalette: "Dark Violet",
            backgroundColor: $eceff289ca4c1052$var$BACKGROUND_COLOR,
            primaryTitleColor: $eceff289ca4c1052$var$TITLE_COLOR,
            secondaryTitleColor: $eceff289ca4c1052$var$SUBTITLE_COLOR,
            gridColor: $eceff289ca4c1052$var$BORDER_COLOR,
            axisColor: $eceff289ca4c1052$var$TEXT_COLOR,
            export: {
                backgroundColor: $eceff289ca4c1052$var$BACKGROUND_COLOR,
                font: {
                    color: $eceff289ca4c1052$var$TITLE_COLOR
                },
                button: {
                    default: {
                        color: $eceff289ca4c1052$var$TITLE_COLOR,
                        borderColor: "#414152",
                        backgroundColor: $eceff289ca4c1052$var$BACKGROUND_COLOR
                    },
                    hover: {
                        color: $eceff289ca4c1052$var$TITLE_COLOR,
                        borderColor: "#5c5c74",
                        backgroundColor: "#2d2d3c"
                    },
                    focus: {
                        color: $eceff289ca4c1052$var$TITLE_COLOR,
                        borderColor: "#7c7c97",
                        backgroundColor: "#2d2d3c"
                    },
                    active: {
                        color: $eceff289ca4c1052$var$TITLE_COLOR,
                        borderColor: "#7c7c97",
                        backgroundColor: "#3c3c51"
                    }
                }
            },
            legend: {
                font: {
                    color: $eceff289ca4c1052$var$TEXT_COLOR
                }
            },
            tooltip: {
                color: $eceff289ca4c1052$var$BACKGROUND_COLOR,
                border: {
                    color: "#414152"
                },
                font: {
                    color: $eceff289ca4c1052$var$TITLE_COLOR
                }
            },
            "chart:common": {
                commonSeriesSettings: {
                    label: {
                        border: {
                            color: $eceff289ca4c1052$var$BORDER_COLOR
                        }
                    }
                }
            },
            "chart:common:annotation": {
                font: {
                    color: $eceff289ca4c1052$var$TITLE_COLOR
                },
                border: {
                    color: "#414152"
                },
                color: $eceff289ca4c1052$var$BACKGROUND_COLOR
            },
            chart: {
                commonPaneSettings: {
                    border: {
                        color: $eceff289ca4c1052$var$BORDER_COLOR
                    }
                },
                commonAxisSettings: {
                    breakStyle: {
                        color: "#575e6b"
                    }
                }
            },
            funnel: {
                item: {
                    border: {
                        color: $eceff289ca4c1052$var$BACKGROUND_COLOR
                    }
                }
            },
            sparkline: {
                pointColor: $eceff289ca4c1052$var$BACKGROUND_COLOR,
                minColor: "#f0ad4e",
                maxColor: "#d9534f"
            },
            treeMap: {
                group: {
                    color: $eceff289ca4c1052$var$BORDER_COLOR,
                    label: {
                        font: {
                            color: $eceff289ca4c1052$var$SUBTITLE_COLOR
                        }
                    }
                }
            },
            rangeSelector: {
                shutter: {
                    color: $eceff289ca4c1052$var$BACKGROUND_COLOR
                },
                scale: {
                    breakStyle: {
                        color: "#575e6b"
                    },
                    tick: {
                        opacity: .2
                    }
                },
                selectedRangeColor: $eceff289ca4c1052$var$ACCENT_COLOR,
                sliderMarker: {
                    color: $eceff289ca4c1052$var$ACCENT_COLOR,
                    font: {
                        color: "#fff"
                    }
                },
                sliderHandle: {
                    color: $eceff289ca4c1052$var$ACCENT_COLOR,
                    opacity: .5
                }
            },
            bullet: {
                color: $eceff289ca4c1052$var$ACCENT_COLOR
            },
            gauge: {
                valueIndicators: {
                    rangebar: {
                        color: $eceff289ca4c1052$var$ACCENT_COLOR
                    },
                    textcloud: {
                        color: $eceff289ca4c1052$var$ACCENT_COLOR
                    }
                }
            },
            sankey: {
                link: {
                    border: {
                        color: $eceff289ca4c1052$var$BACKGROUND_COLOR
                    }
                },
                node: {
                    border: {
                        color: $eceff289ca4c1052$var$BACKGROUND_COLOR
                    }
                }
            }
        },
        baseThemeName: "generic.dark"
    },
    {
        theme: {
            name: "generic.darkviolet.compact"
        },
        baseThemeName: "generic.darkviolet"
    }
];

});

parcelRegister("l5rHQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f59f8e7d3af00450$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/core/themes/generic.greenmist.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $f59f8e7d3af00450$var$ACCENT_COLOR = "#3cbab2";
var $f59f8e7d3af00450$var$BACKGROUND_COLOR = "#f5f5f5";
var $f59f8e7d3af00450$var$TITLE_COLOR = "#28484f";
var $f59f8e7d3af00450$var$SUBTITLE_COLOR = "#7eb2be";
var $f59f8e7d3af00450$var$TEXT_COLOR = "#657c80";
var $f59f8e7d3af00450$var$BORDER_COLOR = "#dedede";
var $f59f8e7d3af00450$export$2e2bcd8739ae039 = [
    {
        theme: {
            name: "generic.greenmist",
            defaultPalette: "Green Mist",
            backgroundColor: $f59f8e7d3af00450$var$BACKGROUND_COLOR,
            primaryTitleColor: $f59f8e7d3af00450$var$TITLE_COLOR,
            secondaryTitleColor: $f59f8e7d3af00450$var$SUBTITLE_COLOR,
            gridColor: $f59f8e7d3af00450$var$BORDER_COLOR,
            axisColor: $f59f8e7d3af00450$var$TEXT_COLOR,
            export: {
                backgroundColor: $f59f8e7d3af00450$var$BACKGROUND_COLOR,
                font: {
                    color: $f59f8e7d3af00450$var$TITLE_COLOR
                },
                button: {
                    default: {
                        color: $f59f8e7d3af00450$var$TITLE_COLOR,
                        borderColor: "#a2b4b8",
                        backgroundColor: $f59f8e7d3af00450$var$BACKGROUND_COLOR
                    },
                    hover: {
                        color: $f59f8e7d3af00450$var$TITLE_COLOR,
                        borderColor: "#7f989e",
                        backgroundColor: "rgba(222, 222, 222, 0.4)"
                    },
                    focus: {
                        color: $f59f8e7d3af00450$var$TITLE_COLOR,
                        borderColor: "#5f777c",
                        backgroundColor: "rgba(222, 222, 222, 0.4)"
                    },
                    active: {
                        color: $f59f8e7d3af00450$var$TITLE_COLOR,
                        borderColor: "#5f777c",
                        backgroundColor: "rgba(222, 222, 222, 0.8)"
                    }
                }
            },
            legend: {
                font: {
                    color: $f59f8e7d3af00450$var$TEXT_COLOR
                }
            },
            tooltip: {
                color: "#fff",
                border: {
                    color: $f59f8e7d3af00450$var$BORDER_COLOR
                },
                font: {
                    color: $f59f8e7d3af00450$var$TITLE_COLOR
                }
            },
            "chart:common": {
                commonSeriesSettings: {
                    label: {
                        border: {
                            color: $f59f8e7d3af00450$var$BORDER_COLOR
                        }
                    }
                }
            },
            "chart:common:annotation": {
                color: "#fff",
                border: {
                    color: $f59f8e7d3af00450$var$BORDER_COLOR
                },
                font: {
                    color: $f59f8e7d3af00450$var$TITLE_COLOR
                }
            },
            chart: {
                commonPaneSettings: {
                    border: {
                        color: $f59f8e7d3af00450$var$BORDER_COLOR
                    }
                },
                commonAxisSettings: {
                    breakStyle: {
                        color: "#c1c1c1"
                    }
                }
            },
            funnel: {
                item: {
                    border: {
                        color: $f59f8e7d3af00450$var$BACKGROUND_COLOR
                    }
                }
            },
            sparkline: {
                pointColor: $f59f8e7d3af00450$var$BACKGROUND_COLOR,
                minColor: "#ffc852",
                maxColor: "#f74a5e"
            },
            treeMap: {
                group: {
                    color: $f59f8e7d3af00450$var$BORDER_COLOR,
                    label: {
                        font: {
                            color: $f59f8e7d3af00450$var$SUBTITLE_COLOR
                        }
                    }
                }
            },
            rangeSelector: {
                shutter: {
                    color: $f59f8e7d3af00450$var$BACKGROUND_COLOR
                },
                scale: {
                    breakStyle: {
                        color: "#c1c1c1"
                    },
                    tick: {
                        opacity: .12
                    }
                },
                selectedRangeColor: $f59f8e7d3af00450$var$ACCENT_COLOR,
                sliderMarker: {
                    color: $f59f8e7d3af00450$var$ACCENT_COLOR
                },
                sliderHandle: {
                    color: $f59f8e7d3af00450$var$ACCENT_COLOR,
                    opacity: .5
                }
            },
            bullet: {
                color: $f59f8e7d3af00450$var$ACCENT_COLOR
            },
            gauge: {
                valueIndicators: {
                    rangebar: {
                        color: $f59f8e7d3af00450$var$ACCENT_COLOR
                    },
                    textcloud: {
                        color: $f59f8e7d3af00450$var$ACCENT_COLOR
                    }
                }
            }
        },
        baseThemeName: "generic.light"
    },
    {
        theme: {
            name: "generic.greenmist.compact"
        },
        baseThemeName: "generic.greenmist"
    }
];

});

parcelRegister("9QmcG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72aa319284db3b1e$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/core/themes/generic.softblue.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $72aa319284db3b1e$var$ACCENT_COLOR = "#7ab8eb";
var $72aa319284db3b1e$var$BACKGROUND_COLOR = "#fff";
var $72aa319284db3b1e$var$TITLE_COLOR = "#333";
var $72aa319284db3b1e$var$SUBTITLE_COLOR = "#99a1a8";
var $72aa319284db3b1e$var$TEXT_COLOR = "#707070";
var $72aa319284db3b1e$var$BORDER_COLOR = "#e8eaeb";
var $72aa319284db3b1e$export$2e2bcd8739ae039 = [
    {
        theme: {
            name: "generic.softblue",
            defaultPalette: "Soft Blue",
            backgroundColor: $72aa319284db3b1e$var$BACKGROUND_COLOR,
            primaryTitleColor: $72aa319284db3b1e$var$TITLE_COLOR,
            secondaryTitleColor: $72aa319284db3b1e$var$SUBTITLE_COLOR,
            gridColor: $72aa319284db3b1e$var$BORDER_COLOR,
            axisColor: $72aa319284db3b1e$var$TEXT_COLOR,
            export: {
                backgroundColor: $72aa319284db3b1e$var$BACKGROUND_COLOR,
                font: {
                    color: $72aa319284db3b1e$var$TITLE_COLOR
                },
                button: {
                    default: {
                        color: $72aa319284db3b1e$var$TITLE_COLOR,
                        borderColor: "#c9d0d4",
                        backgroundColor: $72aa319284db3b1e$var$BACKGROUND_COLOR
                    },
                    hover: {
                        color: $72aa319284db3b1e$var$TITLE_COLOR,
                        borderColor: "#a7b2b9",
                        backgroundColor: "#e6e6e6"
                    },
                    focus: {
                        color: $72aa319284db3b1e$var$TITLE_COLOR,
                        borderColor: "#82929b",
                        backgroundColor: "#e6e6e6"
                    },
                    active: {
                        color: $72aa319284db3b1e$var$TITLE_COLOR,
                        borderColor: "#82929b",
                        backgroundColor: "#d4d4d4"
                    }
                }
            },
            legend: {
                font: {
                    color: $72aa319284db3b1e$var$TEXT_COLOR
                }
            },
            tooltip: {
                color: $72aa319284db3b1e$var$BACKGROUND_COLOR,
                border: {
                    color: $72aa319284db3b1e$var$BORDER_COLOR
                },
                font: {
                    color: $72aa319284db3b1e$var$TITLE_COLOR
                }
            },
            "chart:common": {
                commonSeriesSettings: {
                    label: {
                        border: {
                            color: $72aa319284db3b1e$var$BORDER_COLOR
                        }
                    }
                }
            },
            "chart:common:annotation": {
                color: $72aa319284db3b1e$var$BACKGROUND_COLOR,
                border: {
                    color: $72aa319284db3b1e$var$BORDER_COLOR
                },
                font: {
                    color: $72aa319284db3b1e$var$TITLE_COLOR
                }
            },
            chart: {
                commonPaneSettings: {
                    border: {
                        color: $72aa319284db3b1e$var$BORDER_COLOR
                    }
                },
                commonAxisSettings: {
                    breakStyle: {
                        color: "#cfd2d3"
                    }
                }
            },
            rangeSelector: {
                scale: {
                    breakStyle: {
                        color: "#cfd2d3"
                    },
                    tick: {
                        opacity: .12
                    }
                },
                selectedRangeColor: $72aa319284db3b1e$var$ACCENT_COLOR,
                sliderMarker: {
                    color: $72aa319284db3b1e$var$ACCENT_COLOR
                },
                sliderHandle: {
                    color: $72aa319284db3b1e$var$ACCENT_COLOR,
                    opacity: .5
                }
            },
            sparkline: {
                pointColor: $72aa319284db3b1e$var$BACKGROUND_COLOR,
                minColor: "#f0ad4e",
                maxColor: "#d9534f"
            },
            treeMap: {
                group: {
                    color: $72aa319284db3b1e$var$BORDER_COLOR,
                    label: {
                        font: {
                            color: $72aa319284db3b1e$var$SUBTITLE_COLOR
                        }
                    }
                }
            },
            bullet: {
                color: $72aa319284db3b1e$var$ACCENT_COLOR
            },
            gauge: {
                valueIndicators: {
                    rangebar: {
                        color: $72aa319284db3b1e$var$ACCENT_COLOR
                    },
                    textcloud: {
                        color: $72aa319284db3b1e$var$ACCENT_COLOR
                    }
                }
            }
        },
        baseThemeName: "generic.light"
    },
    {
        theme: {
            name: "generic.softblue.compact"
        },
        baseThemeName: "generic.softblue"
    }
];

});

parcelRegister("eY71X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae5c1f66c731dcf3$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/core/themes/material.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $ae5c1f66c731dcf3$var$FONT_FAMILY = "'Roboto', 'RobotoFallback', 'Helvetica', 'Arial', sans-serif";
var $ae5c1f66c731dcf3$var$LIGHT_TITLE_COLOR = "rgba(0,0,0,0.87)";
var $ae5c1f66c731dcf3$var$LIGHT_LABEL_COLOR = "rgba(0,0,0,0.54)";
var $ae5c1f66c731dcf3$var$DARK_TITLE_COLOR = "rgba(255,255,255,0.87)";
var $ae5c1f66c731dcf3$var$DARK_LABEL_COLOR = "rgba(255,255,255,0.54)";
var $ae5c1f66c731dcf3$var$DARK_BACKGROUND_COLOR = "#363640";
var $ae5c1f66c731dcf3$var$WHITE = "#ffffff";
var $ae5c1f66c731dcf3$var$BLACK = "#000000";
var $ae5c1f66c731dcf3$var$RANGE_COLOR = "#b5b5b5";
var $ae5c1f66c731dcf3$var$AREA_LAYER_COLOR = "#686868";
var $ae5c1f66c731dcf3$var$LINE_COLOR = "#c7c7c7";
var $ae5c1f66c731dcf3$var$TARGET_COLOR = "#8e8e8e";
var $ae5c1f66c731dcf3$var$POSITIVE_COLOR = "#b8b8b8";
var $ae5c1f66c731dcf3$var$LABEL_BORDER_COLOR = "#494949";
var $ae5c1f66c731dcf3$var$BREAK_STYLE_COLOR = "#818181";
var $ae5c1f66c731dcf3$var$themes = [
    {
        theme: {
            name: "material",
            defaultPalette: "Material",
            font: {
                family: $ae5c1f66c731dcf3$var$FONT_FAMILY
            },
            title: {
                margin: {
                    top: 20,
                    bottom: 20,
                    left: 0,
                    right: 0
                },
                font: {
                    size: 20,
                    family: $ae5c1f66c731dcf3$var$FONT_FAMILY,
                    weight: 500
                },
                horizontalAlignment: "left",
                subtitle: {
                    font: {
                        size: 14
                    },
                    horizontalAlignment: "left"
                }
            },
            tooltip: {
                shadow: {
                    opacity: 0
                },
                border: {
                    visible: false
                },
                paddingLeftRight: 8,
                paddingTopBottom: 6,
                arrowLength: 0,
                location: "edge",
                color: "#616161",
                font: {
                    color: $ae5c1f66c731dcf3$var$WHITE
                },
                cornerRadius: 4
            },
            chart: {
                commonAxisSettings: {
                    minorTick: {
                        opacity: .5
                    },
                    label: {
                        font: {
                            size: 11
                        }
                    }
                },
                commonAnnotationSettings: {
                    font: {
                        color: $ae5c1f66c731dcf3$var$WHITE
                    },
                    border: {
                        color: "#616161"
                    },
                    color: "#616161",
                    arrowLength: 14,
                    arrowWidth: 0,
                    shadow: {
                        opacity: .08,
                        offsetY: 4,
                        blur: 8
                    },
                    cornerRadius: 4
                }
            },
            pie: {
                title: {
                    horizontalAlignment: "center",
                    subtitle: {
                        horizontalAlignment: "center"
                    }
                }
            },
            polar: {
                commonAxisSettings: {
                    minorTick: {
                        opacity: .5
                    }
                },
                title: {
                    horizontalAlignment: "center",
                    subtitle: {
                        horizontalAlignment: "center"
                    }
                }
            },
            funnel: {
                title: {
                    horizontalAlignment: "center",
                    subtitle: {
                        horizontalAlignment: "center"
                    }
                }
            },
            gauge: {
                title: {
                    horizontalAlignment: "center",
                    subtitle: {
                        horizontalAlignment: "center"
                    }
                }
            },
            barGauge: {
                title: {
                    horizontalAlignment: "center",
                    subtitle: {
                        horizontalAlignment: "center"
                    }
                }
            },
            rangeSelector: {
                sliderHandle: {
                    opacity: .5
                }
            },
            treeMap: {
                group: {
                    label: {
                        font: {
                            weight: 500
                        }
                    }
                }
            }
        },
        baseThemeName: "generic.light"
    },
    {
        theme: {
            name: "material.light",
            gridColor: "#e0e0e0",
            axisColor: $ae5c1f66c731dcf3$var$LIGHT_LABEL_COLOR,
            primaryTitleColor: $ae5c1f66c731dcf3$var$LIGHT_TITLE_COLOR,
            legend: {
                font: {
                    color: $ae5c1f66c731dcf3$var$LIGHT_LABEL_COLOR
                }
            },
            chart: {
                scrollBar: {
                    color: "#bfbfbf",
                    opacity: .7
                }
            },
            gauge: {
                rangeContainer: {
                    backgroundColor: "rgba(0,0,0,0.2)"
                }
            },
            barGauge: {
                backgroundColor: "#efefef"
            }
        },
        baseThemeName: "material"
    },
    {
        theme: {
            name: "material.dark",
            gridColor: "#515159",
            backgroundColor: $ae5c1f66c731dcf3$var$DARK_BACKGROUND_COLOR,
            axisColor: $ae5c1f66c731dcf3$var$DARK_LABEL_COLOR,
            font: {
                color: $ae5c1f66c731dcf3$var$DARK_LABEL_COLOR
            },
            primaryTitleColor: $ae5c1f66c731dcf3$var$DARK_TITLE_COLOR,
            secondaryTitleColor: $ae5c1f66c731dcf3$var$DARK_TITLE_COLOR,
            tooltip: {
                color: "#000"
            },
            export: {
                backgroundColor: $ae5c1f66c731dcf3$var$DARK_BACKGROUND_COLOR,
                font: {
                    color: "#dbdbdb"
                },
                button: {
                    default: {
                        color: "#dedede",
                        borderColor: "#4d4d4d",
                        backgroundColor: $ae5c1f66c731dcf3$var$DARK_BACKGROUND_COLOR
                    },
                    hover: {
                        color: "#dedede",
                        borderColor: "#6c6c6c",
                        backgroundColor: "#3f3f4b"
                    },
                    focus: {
                        color: "#dedede",
                        borderColor: "#8d8d8d",
                        backgroundColor: "#494956"
                    },
                    active: {
                        color: "#dedede",
                        borderColor: "#8d8d8d",
                        backgroundColor: "#494956"
                    }
                },
                shadowColor: "#292929"
            },
            "chart:common": {
                commonSeriesSettings: {
                    label: {
                        border: {
                            color: $ae5c1f66c731dcf3$var$LABEL_BORDER_COLOR
                        }
                    },
                    valueErrorBar: {
                        color: $ae5c1f66c731dcf3$var$WHITE
                    }
                }
            },
            "chart:common:axis": {
                constantLineStyle: {
                    color: $ae5c1f66c731dcf3$var$WHITE
                }
            },
            "chart:common:annotation": {
                border: {
                    color: "#000"
                },
                color: "#000"
            },
            chart: {
                commonPaneSettings: {
                    border: {
                        color: $ae5c1f66c731dcf3$var$LABEL_BORDER_COLOR
                    }
                },
                commonAxisSettings: {
                    breakStyle: {
                        color: $ae5c1f66c731dcf3$var$BREAK_STYLE_COLOR
                    }
                },
                zoomAndPan: {
                    dragBoxStyle: {
                        color: $ae5c1f66c731dcf3$var$WHITE
                    }
                }
            },
            gauge: {
                rangeContainer: {
                    backgroundColor: $ae5c1f66c731dcf3$var$RANGE_COLOR
                },
                valueIndicators: {
                    _default: {
                        color: $ae5c1f66c731dcf3$var$RANGE_COLOR
                    },
                    rangebar: {
                        color: "#84788b"
                    },
                    twocolorneedle: {
                        secondColor: "#ba544d"
                    },
                    trianglemarker: {
                        color: "#b7918f"
                    },
                    textcloud: {
                        color: "#ba544d"
                    }
                }
            },
            barGauge: {
                backgroundColor: "#3c3c3c"
            },
            rangeSelector: {
                scale: {
                    tick: {
                        color: $ae5c1f66c731dcf3$var$WHITE,
                        opacity: .32
                    },
                    minorTick: {
                        color: $ae5c1f66c731dcf3$var$WHITE,
                        opacity: .1
                    },
                    breakStyle: {
                        color: $ae5c1f66c731dcf3$var$BREAK_STYLE_COLOR
                    }
                },
                selectedRangeColor: $ae5c1f66c731dcf3$var$RANGE_COLOR,
                sliderMarker: {
                    color: $ae5c1f66c731dcf3$var$RANGE_COLOR,
                    font: {
                        color: $ae5c1f66c731dcf3$var$DARK_BACKGROUND_COLOR
                    }
                },
                sliderHandle: {
                    color: $ae5c1f66c731dcf3$var$WHITE,
                    opacity: .2
                },
                shutter: {
                    color: $ae5c1f66c731dcf3$var$WHITE,
                    opacity: .1
                }
            },
            map: {
                background: {
                    borderColor: "#3f3f3f"
                },
                layer: {
                    label: {
                        stroke: $ae5c1f66c731dcf3$var$BLACK,
                        font: {
                            color: $ae5c1f66c731dcf3$var$WHITE
                        }
                    }
                },
                "layer:area": {
                    borderColor: $ae5c1f66c731dcf3$var$DARK_BACKGROUND_COLOR,
                    color: $ae5c1f66c731dcf3$var$AREA_LAYER_COLOR,
                    hoveredBorderColor: $ae5c1f66c731dcf3$var$WHITE,
                    selectedBorderColor: $ae5c1f66c731dcf3$var$WHITE
                },
                "layer:line": {
                    color: "#c77244",
                    hoveredColor: "#ff5d04",
                    selectedColor: "#ff784f"
                },
                "layer:marker:bubble": {
                    hoveredBorderColor: $ae5c1f66c731dcf3$var$WHITE,
                    selectedBorderColor: $ae5c1f66c731dcf3$var$WHITE
                },
                "layer:marker:pie": {
                    hoveredBorderColor: $ae5c1f66c731dcf3$var$WHITE,
                    selectedBorderColor: $ae5c1f66c731dcf3$var$WHITE
                },
                legend: {
                    border: {
                        color: "#3f3f3f"
                    },
                    font: {
                        color: $ae5c1f66c731dcf3$var$WHITE
                    }
                },
                controlBar: {
                    borderColor: $ae5c1f66c731dcf3$var$LINE_COLOR,
                    color: $ae5c1f66c731dcf3$var$DARK_BACKGROUND_COLOR
                }
            },
            treeMap: {
                group: {
                    color: "#4c4c4c",
                    label: {
                        font: {
                            color: "#a3a3a3"
                        }
                    }
                }
            },
            sparkline: {
                lineColor: $ae5c1f66c731dcf3$var$LINE_COLOR,
                firstLastColor: $ae5c1f66c731dcf3$var$LINE_COLOR,
                barPositiveColor: $ae5c1f66c731dcf3$var$POSITIVE_COLOR,
                barNegativeColor: $ae5c1f66c731dcf3$var$TARGET_COLOR,
                winColor: $ae5c1f66c731dcf3$var$POSITIVE_COLOR,
                lossColor: $ae5c1f66c731dcf3$var$TARGET_COLOR,
                pointColor: $ae5c1f66c731dcf3$var$DARK_BACKGROUND_COLOR
            },
            bullet: {
                targetColor: $ae5c1f66c731dcf3$var$TARGET_COLOR
            },
            funnel: {
                item: {
                    border: {
                        color: $ae5c1f66c731dcf3$var$DARK_BACKGROUND_COLOR
                    }
                }
            },
            sankey: {
                label: {
                    font: {
                        color: $ae5c1f66c731dcf3$var$WHITE
                    }
                }
            }
        },
        baseThemeName: "material"
    }
];
function $ae5c1f66c731dcf3$var$getMaterialColorScheme(accentName, themeName, accentColor) {
    return {
        theme: {
            name: "material." + accentName + "." + themeName,
            rangeSelector: {
                selectedRangeColor: accentColor,
                sliderMarker: {
                    color: accentColor
                },
                sliderHandle: {
                    color: accentColor
                }
            },
            map: {
                "layer:marker:dot": {
                    color: accentColor
                },
                "layer:marker:bubble": {
                    color: accentColor
                },
                legend: {
                    markerColor: accentColor
                }
            },
            bullet: {
                color: accentColor
            },
            gauge: {
                valueIndicators: {
                    rangebar: {
                        color: accentColor
                    },
                    textcloud: {
                        color: accentColor
                    }
                }
            }
        },
        baseThemeName: "material." + themeName
    };
}
var $ae5c1f66c731dcf3$var$materialAccents = {
    blue: "#03a9f4",
    lime: "#cddc39",
    orange: "#ff5722",
    purple: "#9c27b0",
    teal: "#009688"
};
for(var $ae5c1f66c731dcf3$var$accent in $ae5c1f66c731dcf3$var$materialAccents)if (Object.prototype.hasOwnProperty.call($ae5c1f66c731dcf3$var$materialAccents, $ae5c1f66c731dcf3$var$accent)) {
    var $ae5c1f66c731dcf3$var$color = $ae5c1f66c731dcf3$var$materialAccents[$ae5c1f66c731dcf3$var$accent];
    $ae5c1f66c731dcf3$var$themes.push($ae5c1f66c731dcf3$var$getMaterialColorScheme($ae5c1f66c731dcf3$var$accent, "light", $ae5c1f66c731dcf3$var$color), $ae5c1f66c731dcf3$var$getMaterialColorScheme($ae5c1f66c731dcf3$var$accent, "dark", $ae5c1f66c731dcf3$var$color), {
        theme: {
            name: "material.".concat($ae5c1f66c731dcf3$var$accent, ".light.compact")
        },
        baseThemeName: "material.".concat($ae5c1f66c731dcf3$var$accent, ".light")
    }, {
        theme: {
            name: "material.".concat($ae5c1f66c731dcf3$var$accent, ".dark.compact")
        },
        baseThemeName: "material.".concat($ae5c1f66c731dcf3$var$accent, ".dark")
    });
}
var $ae5c1f66c731dcf3$export$2e2bcd8739ae039 = $ae5c1f66c731dcf3$var$themes;

});




parcelRegister("6Ztqs", function(module, exports) {

$parcel$export(module.exports, "validateData", function () { return $516f43ec7ace1070$export$60c024fdb76e949e; });
/**
 * DevExtreme (esm/viz/components/data_validator.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $2oTOp = parcelRequire("2oTOp");

var $dw9tZ = parcelRequire("dw9tZ");

var $1zStA = parcelRequire("1zStA");
var $516f43ec7ace1070$var$STRING = "string";
var $516f43ec7ace1070$var$NUMERIC = "numeric";
var $516f43ec7ace1070$var$DATETIME = "datetime";
var $516f43ec7ace1070$var$DISCRETE = "discrete";
var $516f43ec7ace1070$var$SEMIDISCRETE = "semidiscrete";
var $516f43ec7ace1070$var$CONTINUOUS = "continuous";
var $516f43ec7ace1070$var$LOGARITHMIC = "logarithmic";
var $516f43ec7ace1070$var$VALUE_TYPE = "valueType";
var $516f43ec7ace1070$var$ARGUMENT_TYPE = "argumentType";
var $516f43ec7ace1070$var$axisTypeParser = (0, $dw9tZ.enumParser)([
    $516f43ec7ace1070$var$STRING,
    $516f43ec7ace1070$var$NUMERIC,
    $516f43ec7ace1070$var$DATETIME
]);
var $516f43ec7ace1070$var$_isArray = Array.isArray;
function $516f43ec7ace1070$var$groupingValues(data, others, valueField, index) {
    if (index >= 0) data.slice(index).forEach(function(cell) {
        if ((0, $6ntMu.isDefined)(cell[valueField])) {
            others[valueField] += cell[valueField];
            cell[valueField] = void 0;
        }
    });
}
function $516f43ec7ace1070$var$processGroups(groups) {
    groups.forEach(function(group) {
        group.valueType = group.valueAxisType = null;
        group.series.forEach(function(series) {
            series.updateDataType({});
        });
        group.valueAxis && group.valueAxis.resetTypes($516f43ec7ace1070$var$VALUE_TYPE);
    });
}
function $516f43ec7ace1070$var$sortValues(data, asc, selector) {
    var func = asc ? function(a, b) {
        return a - b;
    } : function(a, b) {
        return b - a;
    };
    data.sort(function(a, b) {
        var valA = selector(a);
        var valB = selector(b);
        var aa = (0, $6ntMu.isDefined)(valA) ? 1 : 0;
        var bb = (0, $6ntMu.isDefined)(valB) ? 1 : 0;
        return aa && bb ? func(valA, valB) : func(aa, bb);
    });
    return data;
}
function $516f43ec7ace1070$var$resetArgumentAxes(axes) {
    axes && axes.forEach(function(axis) {
        axis.resetTypes($516f43ec7ace1070$var$ARGUMENT_TYPE);
    });
}
function $516f43ec7ace1070$var$parseCategories(categories, parser) {
    var newArray = [];
    categories.forEach(function(category) {
        var parsedCategory = parser(category);
        void 0 !== parsedCategory && newArray.push(parsedCategory);
    });
    return newArray;
}
function $516f43ec7ace1070$var$parseAxisCategories(groupsData, parsers) {
    var argumentCategories = groupsData.argumentOptions && groupsData.argumentOptions.categories;
    groupsData.groups.forEach(function(valueGroup, i) {
        var categories = valueGroup.valueOptions && valueGroup.valueOptions.categories;
        if (categories) valueGroup.valueOptions.categories = $516f43ec7ace1070$var$parseCategories(categories, parsers[i + 1]);
    });
    if (argumentCategories) groupsData.argumentOptions.categories = $516f43ec7ace1070$var$parseCategories(argumentCategories, parsers[0]);
}
function $516f43ec7ace1070$var$eigen(x) {
    return x;
}
function $516f43ec7ace1070$var$getType(unit, type) {
    var result = type;
    if (type === $516f43ec7ace1070$var$STRING || (0, $6ntMu.isString)(unit)) result = $516f43ec7ace1070$var$STRING;
    else if (type === $516f43ec7ace1070$var$DATETIME || (0, $6ntMu.isDate)(unit)) result = $516f43ec7ace1070$var$DATETIME;
    else if ((0, $6ntMu.isNumeric)(unit)) result = $516f43ec7ace1070$var$NUMERIC;
    return result;
}
function $516f43ec7ace1070$var$correctAxisType(type, axisType, hasCategories, incidentOccurred) {
    if (type === $516f43ec7ace1070$var$STRING && (axisType === $516f43ec7ace1070$var$CONTINUOUS || axisType === $516f43ec7ace1070$var$LOGARITHMIC || axisType === $516f43ec7ace1070$var$SEMIDISCRETE)) incidentOccurred("E2002");
    return axisType === $516f43ec7ace1070$var$LOGARITHMIC ? $516f43ec7ace1070$var$LOGARITHMIC : hasCategories || axisType === $516f43ec7ace1070$var$DISCRETE || type === $516f43ec7ace1070$var$STRING ? $516f43ec7ace1070$var$DISCRETE : axisType === $516f43ec7ace1070$var$SEMIDISCRETE ? $516f43ec7ace1070$var$SEMIDISCRETE : $516f43ec7ace1070$var$CONTINUOUS;
}
function $516f43ec7ace1070$var$validUnit(unit, field, incidentOccurred) {
    if (unit) incidentOccurred(!(0, $6ntMu.isNumeric)(unit) && !(0, $6ntMu.isDate)(unit) && !(0, $6ntMu.isString)(unit) ? "E2003" : "E2004", [
        field
    ]);
}
function $516f43ec7ace1070$var$createParserUnit(type, axisType, incidentOccurred) {
    var parser = type ? (0, $1zStA.getParser)(type) : $516f43ec7ace1070$var$eigen;
    var filterInfinity = axisType !== $516f43ec7ace1070$var$DISCRETE ? function(x) {
        return isFinite(x) || void 0 === x ? x : null;
    } : $516f43ec7ace1070$var$eigen;
    return function(unit, field) {
        var parseUnit = filterInfinity(parser(unit));
        if (void 0 === parseUnit) $516f43ec7ace1070$var$validUnit(unit, field, incidentOccurred);
        return parseUnit;
    };
}
function $516f43ec7ace1070$var$prepareParsers(groupsData, incidentOccurred) {
    var argumentParser = $516f43ec7ace1070$var$createParserUnit(groupsData.argumentType, groupsData.argumentAxisType, incidentOccurred);
    var sizeParser;
    var valueParser;
    var categoryParsers = [
        argumentParser
    ];
    var cache = {};
    var list = [];
    groupsData.groups.forEach(function(group, groupIndex) {
        group.series.forEach(function(series) {
            valueParser = $516f43ec7ace1070$var$createParserUnit(group.valueType, group.valueAxisType, incidentOccurred);
            sizeParser = $516f43ec7ace1070$var$createParserUnit($516f43ec7ace1070$var$NUMERIC, $516f43ec7ace1070$var$CONTINUOUS, incidentOccurred);
            cache[series.getArgumentField()] = argumentParser;
            series.getValueFields().forEach(function(field) {
                categoryParsers[groupIndex + 1] = valueParser;
                cache[field] = valueParser;
            });
            if (series.getSizeField()) cache[series.getSizeField()] = sizeParser;
        });
    });
    for(var field in cache)list.push([
        field,
        cache[field]
    ]);
    list.length && $516f43ec7ace1070$var$parseAxisCategories(groupsData, categoryParsers);
    return list;
}
function $516f43ec7ace1070$var$getParsedCell(cell, parsers) {
    var i;
    var ii = parsers.length;
    var obj = (0, $2oTOp.extend)({}, cell);
    var field;
    var value;
    for(i = 0; i < ii; ++i){
        field = parsers[i][0];
        value = cell[field];
        obj[field] = parsers[i][1](value, field);
    }
    return obj;
}
function $516f43ec7ace1070$var$parse(data, parsers) {
    var parsedData = [];
    var i;
    var ii = data.length;
    parsedData.length = ii;
    for(i = 0; i < ii; ++i)parsedData[i] = $516f43ec7ace1070$var$getParsedCell(data[i], parsers);
    return parsedData;
}
function $516f43ec7ace1070$var$findIndexByThreshold(data, valueField, threshold) {
    var i;
    var ii = data.length;
    var value;
    for(i = 0; i < ii; ++i){
        value = data[i][valueField];
        if ((0, $6ntMu.isDefined)(value) && threshold > value) break;
    }
    return i;
}
function $516f43ec7ace1070$var$groupMinSlices(originalData, argumentField, valueField, smallValuesGrouping) {
    smallValuesGrouping = smallValuesGrouping || {};
    var mode = smallValuesGrouping.mode;
    var others = {};
    if (!mode || "none" === mode) return;
    others[argumentField] = String(smallValuesGrouping.groupName || "others");
    others[valueField] = 0;
    var data = $516f43ec7ace1070$var$sortValues(originalData.slice(), false, function(a) {
        return a[valueField];
    });
    $516f43ec7ace1070$var$groupingValues(data, others, valueField, "smallValueThreshold" === mode ? $516f43ec7ace1070$var$findIndexByThreshold(data, valueField, smallValuesGrouping.threshold) : smallValuesGrouping.topCount);
    others[valueField] && originalData.push(others);
}
function $516f43ec7ace1070$var$groupPieData(data, groupsData) {
    var firstSeries = groupsData.groups[0] && groupsData.groups[0].series[0];
    var isPie = firstSeries && ("pie" === firstSeries.type || "doughnut" === firstSeries.type || "donut" === firstSeries.type);
    if (!isPie) return;
    groupsData.groups.forEach(function(group) {
        group.series.forEach(function(series) {
            $516f43ec7ace1070$var$groupMinSlices(data, series.getArgumentField(), series.getValueFields()[0], series.getOptions().smallValuesGrouping);
        });
    });
}
function $516f43ec7ace1070$var$addUniqueItemToCollection(item, collection, itemsHash) {
    if (!itemsHash[item]) {
        collection.push(item);
        itemsHash[item] = true;
    }
}
function $516f43ec7ace1070$var$getUniqueArgumentFields(groupsData) {
    var uniqueArgumentFields = [];
    var hash = {};
    groupsData.groups.forEach(function(group) {
        group.series.forEach(function(series) {
            $516f43ec7ace1070$var$addUniqueItemToCollection(series.getArgumentField(), uniqueArgumentFields, hash);
        });
    });
    return uniqueArgumentFields;
}
function $516f43ec7ace1070$var$sort(a, b) {
    var result = a - b;
    if (isNaN(result)) {
        if (!(0, $6ntMu.isDefined)(a)) return 1;
        if (!(0, $6ntMu.isDefined)(b)) return -1;
        return 0;
    }
    return result;
}
function $516f43ec7ace1070$var$sortByArgument(data, argumentField) {
    return data.slice().sort(function(a, b) {
        return $516f43ec7ace1070$var$sort(a[argumentField], b[argumentField]);
    });
}
function $516f43ec7ace1070$var$sortByCallback(data, callback) {
    return data.slice().sort(callback);
}
function $516f43ec7ace1070$var$checkValueTypeOfGroup(group, cell) {
    group.series.forEach(function(series) {
        series.getValueFields().forEach(function(field) {
            group.valueType = $516f43ec7ace1070$var$getType(cell[field], group.valueType);
        });
    });
    return group.valueType;
}
function $516f43ec7ace1070$var$getSortByCategories(categories) {
    var hash = {};
    categories.forEach(function(value, i) {
        hash[value] = i;
    });
    return function(data, argumentField) {
        return $516f43ec7ace1070$var$sortValues(data.slice(), true, function(a) {
            return hash[a[argumentField]];
        });
    };
}
function $516f43ec7ace1070$var$sortData(data, groupsData, options, uniqueArgumentFields) {
    var dataByArguments = {};
    var isDiscrete = groupsData.argumentAxisType === $516f43ec7ace1070$var$DISCRETE;
    var userCategories = isDiscrete && groupsData.argumentOptions && groupsData.argumentOptions.categories;
    var sortFunction = function(data) {
        return data;
    };
    var sortingMethodOption = options.sortingMethod;
    var reSortCategories;
    if (!userCategories && (0, $6ntMu.isFunction)(sortingMethodOption)) data = $516f43ec7ace1070$var$sortByCallback(data, sortingMethodOption);
    if (isDiscrete) groupsData.categories = $516f43ec7ace1070$var$getCategories(data, uniqueArgumentFields, userCategories);
    if (userCategories || !(0, $6ntMu.isFunction)(sortingMethodOption) && groupsData.argumentType === $516f43ec7ace1070$var$STRING && !options._skipArgumentSorting) sortFunction = $516f43ec7ace1070$var$getSortByCategories(groupsData.categories);
    else if (true === sortingMethodOption && groupsData.argumentType !== $516f43ec7ace1070$var$STRING) {
        sortFunction = $516f43ec7ace1070$var$sortByArgument;
        reSortCategories = isDiscrete;
    }
    uniqueArgumentFields.forEach(function(field) {
        dataByArguments[field] = sortFunction(data, field);
    });
    if (reSortCategories) groupsData.categories = groupsData.categories.sort($516f43ec7ace1070$var$sort);
    return dataByArguments;
}
function $516f43ec7ace1070$var$checkItemExistence(collection, item) {
    return -1 === collection.map(function(collectionItem) {
        return collectionItem.valueOf();
    }).indexOf(item.valueOf());
}
function $516f43ec7ace1070$var$getCategories(data, uniqueArgumentFields, userCategories) {
    var categories = userCategories ? userCategories.slice() : [];
    uniqueArgumentFields.forEach(function(field) {
        data.forEach(function(item) {
            var dataItem = item[field];
            (0, $6ntMu.isDefined)(dataItem) && $516f43ec7ace1070$var$checkItemExistence(categories, dataItem) && categories.push(dataItem);
        });
    });
    return categories;
}
function $516f43ec7ace1070$var$checkArgumentTypeOfGroup(series, cell, groupsData) {
    series.forEach(function(currentSeries) {
        groupsData.argumentType = $516f43ec7ace1070$var$getType(cell[currentSeries.getArgumentField()], groupsData.argumentType);
    });
    return groupsData.argumentType;
}
function $516f43ec7ace1070$var$checkType(data, groupsData, checkTypeForAllData) {
    var groupsWithUndefinedValueType = [];
    var groupsWithUndefinedArgumentType = [];
    var argumentTypeGroup = groupsData.argumentOptions && $516f43ec7ace1070$var$axisTypeParser(groupsData.argumentOptions.argumentType);
    var groupsIndexes;
    groupsData.groups.forEach(function(group) {
        if (!group.series.length) return;
        var valueTypeGroup = group.valueOptions && $516f43ec7ace1070$var$axisTypeParser(group.valueOptions.valueType);
        group.valueType = valueTypeGroup;
        groupsData.argumentType = argumentTypeGroup;
        !valueTypeGroup && groupsWithUndefinedValueType.push(group);
        !argumentTypeGroup && groupsWithUndefinedArgumentType.push(group);
    });
    if (groupsWithUndefinedValueType.length || groupsWithUndefinedArgumentType.length) {
        groupsIndexes = groupsWithUndefinedValueType.map(function(_, index) {
            return index;
        });
        data.some(function(cell) {
            var defineArg;
            groupsWithUndefinedValueType.forEach(function(group, groupIndex) {
                if ($516f43ec7ace1070$var$checkValueTypeOfGroup(group, cell) && groupsIndexes.indexOf(groupIndex) >= 0) groupsIndexes.splice(groupIndex, 1);
            });
            if (!defineArg) groupsWithUndefinedArgumentType.forEach(function(group) {
                defineArg = $516f43ec7ace1070$var$checkArgumentTypeOfGroup(group.series, cell, groupsData);
            });
            if (!checkTypeForAllData && defineArg && 0 === groupsIndexes.length) return true;
        });
    }
}
function $516f43ec7ace1070$var$checkAxisType(groupsData, incidentOccurred) {
    var argumentOptions = groupsData.argumentOptions || {};
    var userArgumentCategories = argumentOptions && argumentOptions.categories || [];
    var argumentAxisType = $516f43ec7ace1070$var$correctAxisType(groupsData.argumentType, argumentOptions.type, !!userArgumentCategories.length, incidentOccurred);
    groupsData.groups.forEach(function(group) {
        var valueOptions = group.valueOptions || {};
        var valueCategories = valueOptions.categories || [];
        var valueAxisType = $516f43ec7ace1070$var$correctAxisType(group.valueType, valueOptions.type, !!valueCategories.length, incidentOccurred);
        group.series.forEach(function(series) {
            var optionsSeries = {};
            optionsSeries.argumentAxisType = argumentAxisType;
            optionsSeries.valueAxisType = valueAxisType;
            groupsData.argumentAxisType = groupsData.argumentAxisType || optionsSeries.argumentAxisType;
            group.valueAxisType = group.valueAxisType || optionsSeries.valueAxisType;
            optionsSeries.argumentType = groupsData.argumentType;
            optionsSeries.valueType = group.valueType;
            optionsSeries.showZero = valueOptions.showZero;
            series.updateDataType(optionsSeries);
        });
        group.valueAxisType = group.valueAxisType || valueAxisType;
        if (group.valueAxis) {
            group.valueAxis.setTypes(group.valueAxisType, group.valueType, $516f43ec7ace1070$var$VALUE_TYPE);
            group.valueAxis.validate();
        }
    });
    groupsData.argumentAxisType = groupsData.argumentAxisType || argumentAxisType;
    if (groupsData.argumentAxes) groupsData.argumentAxes.forEach(function(axis) {
        axis.setTypes(groupsData.argumentAxisType, groupsData.argumentType, $516f43ec7ace1070$var$ARGUMENT_TYPE);
        axis.validate();
    });
}
function $516f43ec7ace1070$var$verifyData(source, incidentOccurred) {
    var data = [];
    var sourceIsDefined = (0, $6ntMu.isDefined)(source);
    var hasError = sourceIsDefined && !$516f43ec7ace1070$var$_isArray(source);
    var i;
    var ii;
    var k;
    var item;
    if (sourceIsDefined && !hasError) for(i = 0, ii = source.length, k = 0; i < ii; ++i){
        item = source[i];
        if ((0, $6ntMu.isObject)(item)) data[k++] = item;
        else if (item) hasError = true;
    }
    if (hasError) incidentOccurred("E2001");
    return data;
}
function $516f43ec7ace1070$export$60c024fdb76e949e(data, groupsData, incidentOccurred, options) {
    data = $516f43ec7ace1070$var$verifyData(data, incidentOccurred);
    groupsData.argumentType = groupsData.argumentAxisType = null;
    $516f43ec7ace1070$var$processGroups(groupsData.groups);
    $516f43ec7ace1070$var$resetArgumentAxes(groupsData.argumentAxes);
    $516f43ec7ace1070$var$checkType(data, groupsData, options.checkTypeForAllData);
    $516f43ec7ace1070$var$checkAxisType(groupsData, incidentOccurred);
    if (options.convertToAxisDataType) data = $516f43ec7ace1070$var$parse(data, $516f43ec7ace1070$var$prepareParsers(groupsData, incidentOccurred));
    $516f43ec7ace1070$var$groupPieData(data, groupsData);
    var dataByArgumentFields = $516f43ec7ace1070$var$sortData(data, groupsData, options, $516f43ec7ace1070$var$getUniqueArgumentFields(groupsData));
    return dataByArgumentFields;
}

});
parcelRegister("1zStA", function(module, exports) {

$parcel$export(module.exports, "getParser", function () { return $1263512814b7ffc3$export$d003a19ab753048; });
/**
 * DevExtreme (esm/viz/components/parse_utils.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $gcp4g = parcelRequire("gcp4g");

var $6826Q = parcelRequire("6826Q");

var $6ntMu = parcelRequire("6ntMu");
var $1263512814b7ffc3$var$parsers = {
    string: function(val) {
        return (0, $6ntMu.isDefined)(val) ? "" + val : val;
    },
    numeric: function(val) {
        if (!(0, $6ntMu.isDefined)(val)) return val;
        var parsedVal = Number(val);
        if (isNaN(parsedVal)) parsedVal = void 0;
        return parsedVal;
    },
    datetime: function(val) {
        if (!(0, $6ntMu.isDefined)(val)) return val;
        var parsedVal;
        var numVal = Number(val);
        if (!isNaN(numVal)) parsedVal = new Date(numVal);
        else parsedVal = (0, $6826Q.default).deserializeDate(val);
        if (isNaN(Number(parsedVal))) parsedVal = void 0;
        return parsedVal;
    }
};
function $1263512814b7ffc3$export$3943ec9a2ac4227f(type) {
    return "numeric" === type || "datetime" === type || "string" === type ? type : "";
}
var $1263512814b7ffc3$export$d003a19ab753048 = function(valueType) {
    return $1263512814b7ffc3$var$parsers[$1263512814b7ffc3$export$3943ec9a2ac4227f(valueType)] || (0, $gcp4g.noop);
};

});
parcelRegister("6826Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4765204da3a3d06f$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/utils/date_serialization.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $8IERv = parcelRequire("8IERv");

var $3A7XW = parcelRequire("3A7XW");

var $kUXlT = parcelRequire("kUXlT");

var $6ntMu = parcelRequire("6ntMu");
var $4765204da3a3d06f$var$NUMBER_SERIALIZATION_FORMAT = "number";
var $4765204da3a3d06f$var$DATE_SERIALIZATION_FORMAT = "yyyy/MM/dd";
var $4765204da3a3d06f$var$DATETIME_SERIALIZATION_FORMAT = "yyyy/MM/dd HH:mm:ss";
var $4765204da3a3d06f$var$ISO8601_PATTERN = /^(\d{4,})(-)?(\d{2})(-)?(\d{2})(?:T(\d{2})(:)?(\d{2})?(:)?(\d{2}(?:\.(\d{1,3})\d*)?)?)?(Z|([+-])(\d{2})(:)?(\d{2})?)?$/;
var $4765204da3a3d06f$var$ISO8601_TIME_PATTERN = /^(\d{2}):(\d{2})(:(\d{2}))?$/;
var $4765204da3a3d06f$var$ISO8601_PATTERN_PARTS = [
    "",
    "yyyy",
    "",
    "MM",
    "",
    "dd",
    "THH",
    "",
    "mm",
    "",
    "ss",
    ".SSS"
];
var $4765204da3a3d06f$var$DATE_SERIALIZATION_PATTERN = /^(\d{4})\/(\d{2})\/(\d{2})$/;
var $4765204da3a3d06f$var$MILLISECOND_LENGHT = 3;
var $4765204da3a3d06f$var$dateParser = function(text, skipISO8601Parsing) {
    var result;
    if ((0, $6ntMu.isString)(text) && !skipISO8601Parsing) result = $4765204da3a3d06f$var$parseISO8601String(text);
    return result || $4765204da3a3d06f$var$parseDate(text);
};
function $4765204da3a3d06f$var$getTimePart(part) {
    return +part || 0;
}
function $4765204da3a3d06f$var$parseDate(text) {
    var isDefaultSerializationFormat = $4765204da3a3d06f$var$getDateSerializationFormat(text) === $4765204da3a3d06f$var$DATE_SERIALIZATION_FORMAT;
    var parsedValue = !(0, $6ntMu.isDate)(text) && Date.parse(text);
    if (!parsedValue && isDefaultSerializationFormat) {
        var parts = text.match($4765204da3a3d06f$var$DATE_SERIALIZATION_PATTERN);
        if (parts) {
            var newDate = new Date($4765204da3a3d06f$var$getTimePart(parts[1]), $4765204da3a3d06f$var$getTimePart(parts[2]), $4765204da3a3d06f$var$getTimePart(parts[3]));
            newDate.setFullYear($4765204da3a3d06f$var$getTimePart(parts[1]));
            newDate.setMonth($4765204da3a3d06f$var$getTimePart(parts[2]) - 1);
            newDate.setDate($4765204da3a3d06f$var$getTimePart(parts[3]));
            return newDate;
        }
    }
    return (0, $6ntMu.isNumeric)(parsedValue) ? new Date(parsedValue) : text;
}
function $4765204da3a3d06f$var$parseISO8601String(text) {
    var parts = text.match($4765204da3a3d06f$var$ISO8601_PATTERN);
    if (!parts) {
        parts = text.match($4765204da3a3d06f$var$ISO8601_TIME_PATTERN);
        if (parts) return new Date(0, 0, 0, $4765204da3a3d06f$var$getTimePart(parts[1]), $4765204da3a3d06f$var$getTimePart(parts[2]), $4765204da3a3d06f$var$getTimePart(parts[4]));
        return;
    }
    var year = $4765204da3a3d06f$var$getTimePart(parts[1]);
    var month = --parts[3];
    var day = parts[5];
    var timeZoneHour = 0;
    var timeZoneMinute = 0;
    var correctYear = (d)=>{
        year < 100 && d.setFullYear(year);
        return d;
    };
    timeZoneHour = $4765204da3a3d06f$var$getTimePart(parts[14]);
    timeZoneMinute = $4765204da3a3d06f$var$getTimePart(parts[16]);
    if ("-" === parts[13]) {
        timeZoneHour = -timeZoneHour;
        timeZoneMinute = -timeZoneMinute;
    }
    var hour = $4765204da3a3d06f$var$getTimePart(parts[6]) - timeZoneHour;
    var minute = $4765204da3a3d06f$var$getTimePart(parts[8]) - timeZoneMinute;
    var second = $4765204da3a3d06f$var$getTimePart(parts[10]);
    var millisecond = function(part) {
        part = part || "";
        return $4765204da3a3d06f$var$getTimePart(part) * Math.pow(10, $4765204da3a3d06f$var$MILLISECOND_LENGHT - part.length);
    }(parts[11]);
    if (parts[12]) return correctYear(new Date(Date.UTC(year, month, day, hour, minute, second, millisecond)));
    return correctYear(new Date(year, month, day, hour, minute, second, millisecond));
}
var $4765204da3a3d06f$var$getIso8601Format = function(text, useUtc) {
    var parts = text.match($4765204da3a3d06f$var$ISO8601_PATTERN);
    var result = "";
    if (!parts) {
        parts = text.match($4765204da3a3d06f$var$ISO8601_TIME_PATTERN);
        if (parts) return parts[3] ? "HH:mm:ss" : "HH:mm";
        return;
    }
    for(var i = 1; i < $4765204da3a3d06f$var$ISO8601_PATTERN_PARTS.length; i++)if (parts[i]) result += $4765204da3a3d06f$var$ISO8601_PATTERN_PARTS[i] || parts[i];
    if ("Z" === parts[12]) result += "'Z'";
    if (parts[14]) {
        if (parts[15]) result += "xxx";
        else if (parts[16]) result += "xx";
        else result += "x";
    }
    return result;
};
var $4765204da3a3d06f$var$deserializeDate = function(value) {
    if ("number" === typeof value) return new Date(value);
    return $4765204da3a3d06f$var$dateParser(value, !(0, $8IERv.default)().forceIsoDateParsing);
};
var $4765204da3a3d06f$var$serializeDate = function(value, serializationFormat) {
    if (!serializationFormat) return value;
    if (!(0, $6ntMu.isDate)(value)) return null;
    if (serializationFormat === $4765204da3a3d06f$var$NUMBER_SERIALIZATION_FORMAT) return value && value.valueOf ? value.valueOf() : null;
    return (0, $3A7XW.getFormatter)(serializationFormat, (0, $kUXlT.default))(value);
};
var $4765204da3a3d06f$var$getDateSerializationFormat = function(value) {
    if ("number" === typeof value) return $4765204da3a3d06f$var$NUMBER_SERIALIZATION_FORMAT;
    else if ((0, $6ntMu.isString)(value)) {
        var format;
        if ((0, $8IERv.default)().forceIsoDateParsing) format = $4765204da3a3d06f$var$getIso8601Format(value);
        if (format) return format;
        else if (value.indexOf(":") >= 0) return $4765204da3a3d06f$var$DATETIME_SERIALIZATION_FORMAT;
        else return $4765204da3a3d06f$var$DATE_SERIALIZATION_FORMAT;
    } else if (value) return null;
};
var $4765204da3a3d06f$export$2e2bcd8739ae039 = {
    dateParser: $4765204da3a3d06f$var$dateParser,
    deserializeDate: $4765204da3a3d06f$var$deserializeDate,
    serializeDate: $4765204da3a3d06f$var$serializeDate,
    getDateSerializationFormat: $4765204da3a3d06f$var$getDateSerializationFormat
};

});



parcelRegister("g3uKC", function(module, exports) {

$parcel$export(module.exports, "Legend", function () { return $bb04c7a121c66b83$export$ed247974535929c7; });
/**
 * DevExtreme (esm/viz/components/legend.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $dw9tZ = parcelRequire("dw9tZ");

var $2oTOp = parcelRequire("2oTOp");

var $ksd2I = parcelRequire("ksd2I");

var $6ntMu = parcelRequire("6ntMu");

var $a0Hpu = parcelRequire("a0Hpu");

var $5VpUx = parcelRequire("5VpUx");

var $gcp4g = parcelRequire("gcp4g");

var $fORY6 = parcelRequire("fORY6");

var $dDkff = parcelRequire("dDkff");
var $bb04c7a121c66b83$var$_Number = Number;
var $bb04c7a121c66b83$var$_math = Math;
var $bb04c7a121c66b83$var$_round = $bb04c7a121c66b83$var$_math.round;
var $bb04c7a121c66b83$var$_max = $bb04c7a121c66b83$var$_math.max;
var $bb04c7a121c66b83$var$_min = $bb04c7a121c66b83$var$_math.min;
var $bb04c7a121c66b83$var$_ceil = $bb04c7a121c66b83$var$_math.ceil;
var $bb04c7a121c66b83$var$_isDefined = (0, $6ntMu.isDefined);
var $bb04c7a121c66b83$var$_isFunction = (0, $6ntMu.isFunction);
var $bb04c7a121c66b83$var$_enumParser = (0, $dw9tZ.enumParser);
var $bb04c7a121c66b83$var$_normalizeEnum = (0, $dw9tZ.normalizeEnum);
var $bb04c7a121c66b83$var$_extend = (0, $2oTOp.extend);
var $bb04c7a121c66b83$var$DEFAULT_MARGIN = 10;
var $bb04c7a121c66b83$var$DEFAULT_MARKER_HATCHING_WIDTH = 2;
var $bb04c7a121c66b83$var$DEFAULT_MARKER_HATCHING_STEP = 5;
var $bb04c7a121c66b83$var$CENTER = "center";
var $bb04c7a121c66b83$var$RIGHT = "right";
var $bb04c7a121c66b83$var$LEFT = "left";
var $bb04c7a121c66b83$var$TOP = "top";
var $bb04c7a121c66b83$var$BOTTOM = "bottom";
var $bb04c7a121c66b83$var$HORIZONTAL = "horizontal";
var $bb04c7a121c66b83$var$VERTICAL = "vertical";
var $bb04c7a121c66b83$var$INSIDE = "inside";
var $bb04c7a121c66b83$var$OUTSIDE = "outside";
var $bb04c7a121c66b83$var$NONE = "none";
var $bb04c7a121c66b83$var$HEIGHT = "height";
var $bb04c7a121c66b83$var$WIDTH = "width";
var $bb04c7a121c66b83$var$parseHorizontalAlignment = $bb04c7a121c66b83$var$_enumParser([
    $bb04c7a121c66b83$var$LEFT,
    $bb04c7a121c66b83$var$CENTER,
    $bb04c7a121c66b83$var$RIGHT
]);
var $bb04c7a121c66b83$var$parseVerticalAlignment = $bb04c7a121c66b83$var$_enumParser([
    $bb04c7a121c66b83$var$TOP,
    $bb04c7a121c66b83$var$BOTTOM
]);
var $bb04c7a121c66b83$var$parseOrientation = $bb04c7a121c66b83$var$_enumParser([
    $bb04c7a121c66b83$var$VERTICAL,
    $bb04c7a121c66b83$var$HORIZONTAL
]);
var $bb04c7a121c66b83$var$parseItemTextPosition = $bb04c7a121c66b83$var$_enumParser([
    $bb04c7a121c66b83$var$LEFT,
    $bb04c7a121c66b83$var$RIGHT,
    $bb04c7a121c66b83$var$TOP,
    $bb04c7a121c66b83$var$BOTTOM
]);
var $bb04c7a121c66b83$var$parsePosition = $bb04c7a121c66b83$var$_enumParser([
    $bb04c7a121c66b83$var$OUTSIDE,
    $bb04c7a121c66b83$var$INSIDE
]);
var $bb04c7a121c66b83$var$parseItemsAlignment = $bb04c7a121c66b83$var$_enumParser([
    $bb04c7a121c66b83$var$LEFT,
    $bb04c7a121c66b83$var$CENTER,
    $bb04c7a121c66b83$var$RIGHT
]);
function $bb04c7a121c66b83$var$getState(state, color, stateName) {
    if (!state) return;
    var colorFromAction = state.fill;
    return (0, $2oTOp.extend)({}, {
        state: stateName,
        fill: colorFromAction === $bb04c7a121c66b83$var$NONE ? color : colorFromAction,
        opacity: state.opacity,
        hatching: $bb04c7a121c66b83$var$_extend({}, state.hatching, {
            step: $bb04c7a121c66b83$var$DEFAULT_MARKER_HATCHING_STEP,
            width: $bb04c7a121c66b83$var$DEFAULT_MARKER_HATCHING_WIDTH
        })
    });
}
function $bb04c7a121c66b83$var$getAttributes(item, state, size) {
    var attrs = (0, $fORY6.processHatchingAttrs)(item, state);
    if (attrs.fill && 0 === attrs.fill.indexOf("DevExpress")) attrs.fill = (0, $fORY6.getFuncIri)(attrs.fill);
    attrs.opacity = attrs.opacity >= 0 ? attrs.opacity : 1;
    return (0, $2oTOp.extend)({}, attrs, {
        size: size
    });
}
function $bb04c7a121c66b83$var$parseMargins(options) {
    var margin = options.margin;
    if (margin >= 0) {
        margin = $bb04c7a121c66b83$var$_Number(options.margin);
        margin = {
            top: margin,
            bottom: margin,
            left: margin,
            right: margin
        };
    } else margin = {
        top: margin.top >= 0 ? $bb04c7a121c66b83$var$_Number(margin.top) : $bb04c7a121c66b83$var$DEFAULT_MARGIN,
        bottom: margin.bottom >= 0 ? $bb04c7a121c66b83$var$_Number(margin.bottom) : $bb04c7a121c66b83$var$DEFAULT_MARGIN,
        left: margin.left >= 0 ? $bb04c7a121c66b83$var$_Number(margin.left) : $bb04c7a121c66b83$var$DEFAULT_MARGIN,
        right: margin.right >= 0 ? $bb04c7a121c66b83$var$_Number(margin.right) : $bb04c7a121c66b83$var$DEFAULT_MARGIN
    };
    options.margin = margin;
}
function $bb04c7a121c66b83$var$getSizeItem(options, markerBBox, labelBBox) {
    var width;
    var height;
    switch(options.itemTextPosition){
        case $bb04c7a121c66b83$var$LEFT:
        case $bb04c7a121c66b83$var$RIGHT:
            width = markerBBox.width + 7 + labelBBox.width;
            height = $bb04c7a121c66b83$var$_max(markerBBox.height, labelBBox.height);
            break;
        case $bb04c7a121c66b83$var$TOP:
        case $bb04c7a121c66b83$var$BOTTOM:
            width = $bb04c7a121c66b83$var$_max(markerBBox.width, labelBBox.width);
            height = markerBBox.height + 4 + labelBBox.height;
    }
    return {
        width: width,
        height: height
    };
}
function $bb04c7a121c66b83$var$calculateBBoxLabelAndMarker(markerBBox, labelBBox) {
    var bBox = {};
    bBox.left = $bb04c7a121c66b83$var$_min(markerBBox.x, labelBBox.x);
    bBox.top = $bb04c7a121c66b83$var$_min(markerBBox.y, labelBBox.y);
    bBox.right = $bb04c7a121c66b83$var$_max(markerBBox.x + markerBBox.width, labelBBox.x + labelBBox.width);
    bBox.bottom = $bb04c7a121c66b83$var$_max(markerBBox.y + markerBBox.height, labelBBox.y + labelBBox.height);
    return bBox;
}
function $bb04c7a121c66b83$var$applyMarkerState(id, idToIndexMap, items, stateName) {
    var item = idToIndexMap && items[idToIndexMap[id]];
    if (item) item.renderMarker(item.states[stateName]);
}
function $bb04c7a121c66b83$var$parseOptions(options, textField, allowInsidePosition) {
    if (!options) return null;
    $bb04c7a121c66b83$var$parseMargins(options);
    options.horizontalAlignment = $bb04c7a121c66b83$var$parseHorizontalAlignment(options.horizontalAlignment, $bb04c7a121c66b83$var$RIGHT);
    options.verticalAlignment = $bb04c7a121c66b83$var$parseVerticalAlignment(options.verticalAlignment, options.horizontalAlignment === $bb04c7a121c66b83$var$CENTER ? $bb04c7a121c66b83$var$BOTTOM : $bb04c7a121c66b83$var$TOP);
    options.orientation = $bb04c7a121c66b83$var$parseOrientation(options.orientation, options.horizontalAlignment === $bb04c7a121c66b83$var$CENTER ? $bb04c7a121c66b83$var$HORIZONTAL : $bb04c7a121c66b83$var$VERTICAL);
    options.itemTextPosition = $bb04c7a121c66b83$var$parseItemTextPosition(options.itemTextPosition, options.orientation === $bb04c7a121c66b83$var$HORIZONTAL ? $bb04c7a121c66b83$var$BOTTOM : $bb04c7a121c66b83$var$RIGHT);
    options.position = allowInsidePosition ? $bb04c7a121c66b83$var$parsePosition(options.position, $bb04c7a121c66b83$var$OUTSIDE) : $bb04c7a121c66b83$var$OUTSIDE;
    options.itemsAlignment = $bb04c7a121c66b83$var$parseItemsAlignment(options.itemsAlignment, null);
    options.hoverMode = $bb04c7a121c66b83$var$_normalizeEnum(options.hoverMode);
    options.customizeText = $bb04c7a121c66b83$var$_isFunction(options.customizeText) ? options.customizeText : function() {
        return this[textField];
    };
    options.customizeHint = $bb04c7a121c66b83$var$_isFunction(options.customizeHint) ? options.customizeHint : (0, $gcp4g.noop);
    options._incidentOccurred = options._incidentOccurred || (0, $gcp4g.noop);
    return options;
}
function $bb04c7a121c66b83$var$createSquareMarker(renderer, size) {
    return renderer.rect(0, 0, size, size);
}
function $bb04c7a121c66b83$var$createCircleMarker(renderer, size) {
    return renderer.circle(size / 2, size / 2, size / 2);
}
function $bb04c7a121c66b83$var$isCircle(type) {
    return "circle" === $bb04c7a121c66b83$var$_normalizeEnum(type);
}
function $bb04c7a121c66b83$var$inRect(rect, x, y) {
    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
}
function $bb04c7a121c66b83$var$checkLinesSize(lines, layoutOptions, countItems, margins) {
    var position = {
        x: 0,
        y: 0
    };
    var maxMeasureLength = 0;
    var maxAltMeasureLength = 0;
    var margin = 0;
    if ("y" === layoutOptions.direction) margin = margins.top + margins.bottom;
    else margin = margins.left + margins.right;
    lines.forEach(function(line, i) {
        var firstItem = line[0];
        var lineLength = line.length;
        line.forEach(function(item, index) {
            var offset = item.offset || layoutOptions.spacing;
            position[layoutOptions.direction] += item[layoutOptions.measure] + (index !== lineLength - 1 ? offset : 0);
            maxMeasureLength = $bb04c7a121c66b83$var$_max(maxMeasureLength, position[layoutOptions.direction]);
        });
        position[layoutOptions.direction] = 0;
        position[layoutOptions.altDirection] += firstItem[layoutOptions.altMeasure] + firstItem.altOffset || layoutOptions.altSpacing;
        maxAltMeasureLength = $bb04c7a121c66b83$var$_max(maxAltMeasureLength, position[layoutOptions.altDirection]);
    });
    if (maxMeasureLength + margin > layoutOptions.length) {
        layoutOptions.countItem = $bb04c7a121c66b83$var$decreaseItemCount(layoutOptions, countItems);
        return true;
    }
}
function $bb04c7a121c66b83$var$decreaseItemCount(layoutOptions, countItems) {
    layoutOptions.altCountItem++;
    return $bb04c7a121c66b83$var$_ceil(countItems / layoutOptions.altCountItem);
}
function $bb04c7a121c66b83$var$getLineLength(line, layoutOptions) {
    return line.reduce((lineLength, item)=>{
        var offset = item.offset || layoutOptions.spacing;
        return lineLength + item[layoutOptions.measure] + offset;
    }, 0);
}
function $bb04c7a121c66b83$var$getMaxLineLength(lines, layoutOptions) {
    return lines.reduce((maxLineLength, line)=>$bb04c7a121c66b83$var$_max(maxLineLength, $bb04c7a121c66b83$var$getLineLength(line, layoutOptions)), 0);
}
function $bb04c7a121c66b83$var$getInitPositionForDirection(line, layoutOptions, maxLineLength) {
    var lineLength = $bb04c7a121c66b83$var$getLineLength(line, layoutOptions);
    var initPosition;
    switch(layoutOptions.itemsAlignment){
        case $bb04c7a121c66b83$var$RIGHT:
            initPosition = maxLineLength - lineLength;
            break;
        case $bb04c7a121c66b83$var$CENTER:
            initPosition = (maxLineLength - lineLength) / 2;
            break;
        default:
            initPosition = 0;
    }
    return initPosition;
}
function $bb04c7a121c66b83$var$getPos(layoutOptions) {
    switch(layoutOptions.itemTextPosition){
        case $bb04c7a121c66b83$var$BOTTOM:
            return {
                horizontal: $bb04c7a121c66b83$var$CENTER,
                vertical: $bb04c7a121c66b83$var$TOP
            };
        case $bb04c7a121c66b83$var$TOP:
            return {
                horizontal: $bb04c7a121c66b83$var$CENTER,
                vertical: $bb04c7a121c66b83$var$BOTTOM
            };
        case $bb04c7a121c66b83$var$LEFT:
            return {
                horizontal: $bb04c7a121c66b83$var$RIGHT,
                vertical: $bb04c7a121c66b83$var$CENTER
            };
        case $bb04c7a121c66b83$var$RIGHT:
            return {
                horizontal: $bb04c7a121c66b83$var$LEFT,
                vertical: $bb04c7a121c66b83$var$CENTER
            };
    }
}
function $bb04c7a121c66b83$var$getLines(lines, layoutOptions, itemIndex) {
    var tableLine = {};
    if (itemIndex % layoutOptions.countItem === 0) {
        if (layoutOptions.markerOffset) lines.push([], []);
        else lines.push([]);
    }
    if (layoutOptions.markerOffset) {
        tableLine.firstLine = lines[lines.length - 1];
        tableLine.secondLine = lines[lines.length - 2];
    } else tableLine.firstLine = tableLine.secondLine = lines[lines.length - 1];
    return tableLine;
}
function $bb04c7a121c66b83$var$setMaxInLine(line, measure) {
    var maxLineSize = line.reduce((maxLineSize, item)=>{
        var itemMeasure = item ? item[measure] : maxLineSize;
        return $bb04c7a121c66b83$var$_max(maxLineSize, itemMeasure);
    }, 0);
    line.forEach((item)=>{
        if (item) item[measure] = maxLineSize;
    });
}
function $bb04c7a121c66b83$var$transpose(array) {
    var width = array.length;
    var height = array[0].length;
    var i;
    var j;
    var transposeArray = [];
    for(i = 0; i < height; i++){
        transposeArray[i] = [];
        for(j = 0; j < width; j++)transposeArray[i][j] = array[j][i];
    }
    return transposeArray;
}
function $bb04c7a121c66b83$var$getAlign(position) {
    switch(position){
        case $bb04c7a121c66b83$var$TOP:
        case $bb04c7a121c66b83$var$BOTTOM:
            return $bb04c7a121c66b83$var$CENTER;
        case $bb04c7a121c66b83$var$LEFT:
            return $bb04c7a121c66b83$var$RIGHT;
        case $bb04c7a121c66b83$var$RIGHT:
            return $bb04c7a121c66b83$var$LEFT;
    }
}
var $bb04c7a121c66b83$var$getMarkerCreator = function(type) {
    return $bb04c7a121c66b83$var$isCircle(type) ? $bb04c7a121c66b83$var$createCircleMarker : $bb04c7a121c66b83$var$createSquareMarker;
};
function $bb04c7a121c66b83$var$getTitleHorizontalAlignment(options) {
    if (options.horizontalAlignment === $bb04c7a121c66b83$var$CENTER) return $bb04c7a121c66b83$var$CENTER;
    else if (options.itemTextPosition === $bb04c7a121c66b83$var$RIGHT) return $bb04c7a121c66b83$var$LEFT;
    else if (options.itemTextPosition === $bb04c7a121c66b83$var$LEFT) return $bb04c7a121c66b83$var$RIGHT;
    else return $bb04c7a121c66b83$var$CENTER;
}
var $bb04c7a121c66b83$export$ed247974535929c7 = function(settings) {
    this._renderer = settings.renderer;
    this._legendGroup = settings.group;
    this._backgroundClass = settings.backgroundClass;
    this._itemGroupClass = settings.itemGroupClass;
    this._textField = settings.textField;
    this._getCustomizeObject = settings.getFormatObject;
    this._titleGroupClass = settings.titleGroupClass;
    this._allowInsidePosition = settings.allowInsidePosition;
    this._widget = settings.widget;
    this._updated = false;
};
var $bb04c7a121c66b83$var$_Legend = $bb04c7a121c66b83$export$ed247974535929c7;
var $bb04c7a121c66b83$var$legendPrototype = $bb04c7a121c66b83$var$_Legend.prototype = (0, $5VpUx.clone)((0, $ksd2I.LayoutElement).prototype);
(0, $2oTOp.extend)($bb04c7a121c66b83$var$legendPrototype, {
    constructor: $bb04c7a121c66b83$var$_Legend,
    getOptions: function() {
        return this._options;
    },
    update: function() {
        var data = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        var options = arguments.length > 1 ? arguments[1] : void 0;
        var themeManagerTitleOptions = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        var that = this;
        options = that._options = $bb04c7a121c66b83$var$parseOptions(options, that._textField, that._allowInsidePosition) || {};
        var initMarkerSize = options.markerSize;
        this._updated = true;
        this._data = data.map((dataItem)=>{
            dataItem.size = $bb04c7a121c66b83$var$_Number(dataItem.size > 0 ? dataItem.size : initMarkerSize);
            dataItem.marker = $bb04c7a121c66b83$var$getAttributes(dataItem, dataItem.states.normal);
            Object.defineProperty(dataItem.marker, "size", {
                get: ()=>dataItem.size,
                set (value) {
                    dataItem.size = value;
                }
            });
            Object.defineProperty(dataItem.marker, "opacity", {
                get: ()=>dataItem.states.normal.opacity,
                set (value) {
                    dataItem.states.normal.opacity = dataItem.states.hover.opacity = dataItem.states.selection.opacity = value;
                }
            });
            return dataItem;
        });
        if (options.customizeItems) that._data = options.customizeItems(data.slice()) || data;
        that._boundingRect = {
            width: 0,
            height: 0,
            x: 0,
            y: 0
        };
        if (that.isVisible() && !that._title) that._title = new (0, $a0Hpu.Title)({
            renderer: that._renderer,
            cssClass: that._titleGroupClass,
            root: that._legendGroup
        });
        if (that._title) {
            var titleOptions = options.title;
            themeManagerTitleOptions.horizontalAlignment = $bb04c7a121c66b83$var$getTitleHorizontalAlignment(options);
            that._title.update(themeManagerTitleOptions, titleOptions);
        }
        this.erase();
        return that;
    },
    isVisible: function() {
        return this._options && this._options.visible;
    },
    draw: function(width, height) {
        var items = this._getItemData();
        this.erase();
        if (!(this.isVisible() && items && items.length)) return this;
        this._insideLegendGroup = this._renderer.g().enableLinks().append(this._legendGroup);
        this._title.changeLink(this._insideLegendGroup);
        this._createBackground();
        if (this._title.hasText()) {
            var horizontalPadding = this._background ? 2 * this._options.paddingLeftRight : 0;
            this._title.draw(width - horizontalPadding, height);
        }
        this._markersGroup = this._renderer.g().attr({
            class: this._itemGroupClass
        }).append(this._insideLegendGroup);
        this._createItems(items);
        this._updateElementsPosition(width, height);
        return this;
    },
    _measureElements: function() {
        var options = this._options;
        var maxBBoxHeight = 0;
        this._items.forEach((item)=>{
            var labelBBox = item.label.getBBox();
            var markerBBox = item.marker.getBBox();
            item.markerBBox = markerBBox;
            item.markerSize = Math.max(markerBBox.width, markerBBox.height);
            var bBox = $bb04c7a121c66b83$var$getSizeItem(options, markerBBox, labelBBox);
            item.labelBBox = labelBBox;
            item.bBox = bBox;
            maxBBoxHeight = $bb04c7a121c66b83$var$_max(maxBBoxHeight, bBox.height);
        });
        if (options.equalRowHeight) this._items.forEach((item)=>item.bBox.height = maxBBoxHeight);
    },
    _updateElementsPosition: function(width, height) {
        var options = this._options;
        this._size = {
            width: width,
            height: height
        };
        this._measureElements();
        this._locateElements(options);
        this._finalUpdate(options);
        var size = this.getLayoutOptions();
        if (size.width > width || size.height > height) this.freeSpace();
    },
    _createItems: function(items) {
        var that = this;
        var options = that._options;
        var renderer = that._renderer;
        var createMarker = $bb04c7a121c66b83$var$getMarkerCreator(options.markerShape);
        that._markersId = {};
        var templateFunction = !options.markerTemplate ? (dataItem, group)=>{
            var attrs = dataItem.marker;
            createMarker(renderer, attrs.size).attr({
                fill: attrs.fill,
                opacity: attrs.opacity
            }).append({
                element: group
            });
        } : options.markerTemplate;
        var template = that._widget._getTemplate(templateFunction);
        var markersGroup = that._markersGroup;
        markersGroup.css((0, $dw9tZ.patchFontOptions)(options.font));
        that._deferredItems = [];
        that._templatesGroups = [];
        that._items = (items || []).map((dataItem, i)=>{
            var stateOfDataItem = dataItem.states;
            var normalState = stateOfDataItem.normal;
            var normalStateFill = normalState.fill;
            dataItem.size = dataItem.marker.size;
            var states = {
                normal: (0, $2oTOp.extend)(normalState, {
                    fill: normalStateFill || options.markerColor || options.defaultColor,
                    state: "normal"
                }),
                hover: $bb04c7a121c66b83$var$getState(stateOfDataItem.hover, normalStateFill, "hovered"),
                selection: $bb04c7a121c66b83$var$getState(stateOfDataItem.selection, normalStateFill, "selected")
            };
            dataItem.states = states;
            var itemGroup = renderer.g().append(markersGroup);
            var markerGroup = renderer.g().attr({
                class: "dxl-marker"
            }).append(itemGroup);
            that._deferredItems[i] = new (0, $dDkff.Deferred);
            that._templatesGroups.push(markerGroup);
            var item = {
                label: that._createLabel(dataItem, itemGroup),
                marker: markerGroup,
                renderer: renderer,
                group: itemGroup,
                tracker: {
                    id: dataItem.id,
                    argument: dataItem.argument,
                    argumentIndex: dataItem.argumentIndex
                },
                states: states,
                itemTextPosition: options.itemTextPosition,
                markerOffset: 0,
                bBoxes: [],
                renderMarker (state) {
                    dataItem.marker = $bb04c7a121c66b83$var$getAttributes(item, state, dataItem.size);
                    markerGroup.clear();
                    template.render({
                        model: dataItem,
                        container: markerGroup.element,
                        onRendered: that._deferredItems[i].resolve
                    });
                }
            };
            item.renderMarker(states.normal);
            that._createHint(dataItem, itemGroup);
            if (void 0 !== dataItem.id) that._markersId[dataItem.id] = i;
            return item;
        });
    },
    getTemplatesGroups: function() {
        return this._templatesGroups || [];
    },
    getTemplatesDef: function() {
        return this._deferredItems || [];
    },
    _getItemData: function() {
        var items = this._data || [];
        var options = this._options || {};
        if (options.inverted) items = items.slice().reverse();
        return items.filter((i)=>i.visible);
    },
    _finalUpdate: function(options) {
        this._adjustBackgroundSettings(options);
        this._setBoundingRect(options.margin);
    },
    erase: function() {
        var insideLegendGroup = this._insideLegendGroup;
        insideLegendGroup && insideLegendGroup.dispose();
        this._insideLegendGroup = this._markersGroup = this._x1 = this._x2 = this._y2 = this._y2 = null;
        return this;
    },
    _locateElements: function(locationOptions) {
        this._moveInInitialValues();
        this._locateRowsColumns(locationOptions);
    },
    _moveInInitialValues: function() {
        this._title.hasText() && this._title.move([
            0,
            0
        ]);
        this._legendGroup && this._legendGroup.move(0, 0);
        this._background && this._background.attr({
            x: 0,
            y: 0,
            width: 0,
            height: 0
        });
    },
    applySelected: function(id) {
        $bb04c7a121c66b83$var$applyMarkerState(id, this._markersId, this._items, "selection");
        return this;
    },
    applyHover: function(id) {
        $bb04c7a121c66b83$var$applyMarkerState(id, this._markersId, this._items, "hover");
        return this;
    },
    resetItem: function(id) {
        $bb04c7a121c66b83$var$applyMarkerState(id, this._markersId, this._items, "normal");
        return this;
    },
    _createLabel: function(data, group) {
        var labelFormatObject = this._getCustomizeObject(data);
        var options = this._options;
        var align = $bb04c7a121c66b83$var$getAlign(options.itemTextPosition);
        var text = options.customizeText.call(labelFormatObject, labelFormatObject);
        var fontStyle = $bb04c7a121c66b83$var$_isDefined(data.textOpacity) ? {
            color: options.font.color,
            opacity: data.textOpacity
        } : {};
        return this._renderer.text(text, 0, 0).css((0, $dw9tZ.patchFontOptions)(fontStyle)).attr({
            align: align,
            class: options.cssClass
        }).append(group);
    },
    _createHint: function(data, group) {
        var labelFormatObject = this._getCustomizeObject(data);
        var text = this._options.customizeHint.call(labelFormatObject, labelFormatObject);
        if ($bb04c7a121c66b83$var$_isDefined(text) && "" !== text) group.setTitle(text);
    },
    _createBackground: function() {
        var isInside = this._options.position === $bb04c7a121c66b83$var$INSIDE;
        var color = this._options.backgroundColor;
        var fill = color || (isInside ? this._options.containerBackgroundColor : $bb04c7a121c66b83$var$NONE);
        if (this._options.border.visible || (isInside || color) && color !== $bb04c7a121c66b83$var$NONE) this._background = this._renderer.rect(0, 0, 0, 0).attr({
            fill: fill,
            class: this._backgroundClass
        }).append(this._insideLegendGroup);
    },
    _locateRowsColumns: function(options) {
        var iteration = 0;
        var layoutOptions = this._getItemsLayoutOptions();
        var countItems = this._items.length;
        var lines;
        do {
            lines = [];
            this._createLines(lines, layoutOptions);
            this._alignLines(lines, layoutOptions);
            iteration++;
        }while ($bb04c7a121c66b83$var$checkLinesSize(lines, layoutOptions, countItems, options.margin) && iteration < countItems);
        this._applyItemPosition(lines, layoutOptions);
    },
    _createLines: function(lines, layoutOptions) {
        this._items.forEach((item, i)=>{
            var tableLine = $bb04c7a121c66b83$var$getLines(lines, layoutOptions, i);
            var labelBox = {
                width: item.labelBBox.width,
                height: item.labelBBox.height,
                element: item.label,
                bBox: item.labelBBox,
                pos: $bb04c7a121c66b83$var$getPos(layoutOptions),
                itemIndex: i
            };
            var markerBox = {
                width: item.markerBBox.width,
                height: item.markerBBox.height,
                element: item.marker,
                pos: {
                    horizontal: $bb04c7a121c66b83$var$CENTER,
                    vertical: $bb04c7a121c66b83$var$CENTER
                },
                bBox: {
                    width: item.markerBBox.width,
                    height: item.markerBBox.height,
                    x: item.markerBBox.x,
                    y: item.markerBBox.y
                },
                itemIndex: i
            };
            var firstItem;
            var secondItem;
            var offsetDirection = layoutOptions.markerOffset ? "altOffset" : "offset";
            if (layoutOptions.inverseLabelPosition) {
                firstItem = labelBox;
                secondItem = markerBox;
            } else {
                firstItem = markerBox;
                secondItem = labelBox;
            }
            firstItem[offsetDirection] = layoutOptions.labelOffset;
            tableLine.secondLine.push(firstItem);
            tableLine.firstLine.push(secondItem);
        });
    },
    _alignLines: function(lines, layoutOptions) {
        var i;
        var measure = layoutOptions.altMeasure;
        lines.forEach((line)=>$bb04c7a121c66b83$var$setMaxInLine(line, measure));
        measure = layoutOptions.measure;
        if (layoutOptions.itemsAlignment) {
            if (layoutOptions.markerOffset) for(i = 0; i < lines.length;)$bb04c7a121c66b83$var$transpose([
                lines[i++],
                lines[i++]
            ]).forEach(processLine);
        } else $bb04c7a121c66b83$var$transpose(lines).forEach(processLine);
        function processLine(line) {
            $bb04c7a121c66b83$var$setMaxInLine(line, measure);
        }
    },
    _applyItemPosition: function(lines, layoutOptions) {
        var that = this;
        var position = {
            x: 0,
            y: 0
        };
        var maxLineLength = $bb04c7a121c66b83$var$getMaxLineLength(lines, layoutOptions);
        lines.forEach((line)=>{
            var firstItem = line[0];
            var altOffset = firstItem.altOffset || layoutOptions.altSpacing;
            position[layoutOptions.direction] = $bb04c7a121c66b83$var$getInitPositionForDirection(line, layoutOptions, maxLineLength);
            line.forEach((item)=>{
                var offset = item.offset || layoutOptions.spacing;
                var wrap = new (0, $ksd2I.WrapperLayoutElement)(item.element, item.bBox);
                var itemBBoxOptions = {
                    x: position.x,
                    y: position.y,
                    width: item.width,
                    height: item.height
                };
                var itemBBox = new (0, $ksd2I.WrapperLayoutElement)(null, itemBBoxOptions);
                var itemLegend = that._items[item.itemIndex];
                wrap.position({
                    of: itemBBox,
                    my: item.pos,
                    at: item.pos
                });
                itemLegend.bBoxes.push(itemBBox);
                position[layoutOptions.direction] += item[layoutOptions.measure] + offset;
            });
            position[layoutOptions.altDirection] += firstItem[layoutOptions.altMeasure] + altOffset;
        });
        this._items.forEach((item)=>{
            var itemBBox = $bb04c7a121c66b83$var$calculateBBoxLabelAndMarker(item.bBoxes[0].getLayoutOptions(), item.bBoxes[1].getLayoutOptions());
            var horizontal = that._options.columnItemSpacing / 2;
            var vertical = that._options.rowItemSpacing / 2;
            item.tracker.left = itemBBox.left - horizontal;
            item.tracker.right = itemBBox.right + horizontal;
            item.tracker.top = itemBBox.top - vertical;
            item.tracker.bottom = itemBBox.bottom + vertical;
        });
    },
    _getItemsLayoutOptions: function() {
        var options = this._options;
        var orientation = options.orientation;
        var layoutOptions = {
            itemsAlignment: options.itemsAlignment,
            orientation: options.orientation
        };
        var width = this._size.width - (this._background ? 2 * options.paddingLeftRight : 0);
        var height = this._size.height - (this._background ? 2 * options.paddingTopBottom : 0);
        if (orientation === $bb04c7a121c66b83$var$HORIZONTAL) {
            layoutOptions.length = width;
            layoutOptions.spacing = options.columnItemSpacing;
            layoutOptions.direction = "x";
            layoutOptions.measure = $bb04c7a121c66b83$var$WIDTH;
            layoutOptions.altMeasure = $bb04c7a121c66b83$var$HEIGHT;
            layoutOptions.altDirection = "y";
            layoutOptions.altSpacing = options.rowItemSpacing;
            layoutOptions.countItem = options.columnCount;
            layoutOptions.altCountItem = options.rowCount;
            layoutOptions.marginTextLabel = 4;
            layoutOptions.labelOffset = 7;
            if (options.itemTextPosition === $bb04c7a121c66b83$var$BOTTOM || options.itemTextPosition === $bb04c7a121c66b83$var$TOP) {
                layoutOptions.labelOffset = 4;
                layoutOptions.markerOffset = true;
            }
        } else {
            layoutOptions.length = height;
            layoutOptions.spacing = options.rowItemSpacing;
            layoutOptions.direction = "y";
            layoutOptions.measure = $bb04c7a121c66b83$var$HEIGHT;
            layoutOptions.altMeasure = $bb04c7a121c66b83$var$WIDTH;
            layoutOptions.altDirection = "x";
            layoutOptions.altSpacing = options.columnItemSpacing;
            layoutOptions.countItem = options.rowCount;
            layoutOptions.altCountItem = options.columnCount;
            layoutOptions.marginTextLabel = 7;
            layoutOptions.labelOffset = 4;
            if (options.itemTextPosition === $bb04c7a121c66b83$var$RIGHT || options.itemTextPosition === $bb04c7a121c66b83$var$LEFT) {
                layoutOptions.labelOffset = 7;
                layoutOptions.markerOffset = true;
            }
        }
        if (!layoutOptions.countItem) {
            if (layoutOptions.altCountItem) layoutOptions.countItem = $bb04c7a121c66b83$var$_ceil(this._items.length / layoutOptions.altCountItem);
            else layoutOptions.countItem = this._items.length;
        }
        if (options.itemTextPosition === $bb04c7a121c66b83$var$TOP || options.itemTextPosition === $bb04c7a121c66b83$var$LEFT) layoutOptions.inverseLabelPosition = true;
        layoutOptions.itemTextPosition = options.itemTextPosition;
        layoutOptions.altCountItem = layoutOptions.altCountItem || $bb04c7a121c66b83$var$_ceil(this._items.length / layoutOptions.countItem);
        return layoutOptions;
    },
    _adjustBackgroundSettings: function(locationOptions) {
        if (!this._background) return;
        var border = locationOptions.border;
        var legendBox = this._calculateTotalBox();
        var backgroundSettings = {
            x: $bb04c7a121c66b83$var$_round(legendBox.x - locationOptions.paddingLeftRight),
            y: $bb04c7a121c66b83$var$_round(legendBox.y - locationOptions.paddingTopBottom),
            width: $bb04c7a121c66b83$var$_round(legendBox.width) + 2 * locationOptions.paddingLeftRight,
            height: $bb04c7a121c66b83$var$_round(legendBox.height),
            opacity: locationOptions.backgroundOpacity
        };
        if (border.visible && border.width && border.color && border.color !== $bb04c7a121c66b83$var$NONE) {
            backgroundSettings["stroke-width"] = border.width;
            backgroundSettings.stroke = border.color;
            backgroundSettings["stroke-opacity"] = border.opacity;
            backgroundSettings.dashStyle = border.dashStyle;
            backgroundSettings.rx = border.cornerRadius || 0;
            backgroundSettings.ry = border.cornerRadius || 0;
        }
        this._background.attr(backgroundSettings);
    },
    _setBoundingRect: function(margin) {
        if (!this._insideLegendGroup) return;
        var box = this._calculateTotalBox();
        box.height += margin.top + margin.bottom;
        box.widthWithoutMargins = box.width;
        box.width += margin.left + margin.right;
        box.x -= margin.left;
        box.y -= margin.top;
        this._boundingRect = box;
    },
    _calculateTotalBox: function() {
        var markerBox = this._markersGroup.getBBox();
        var titleBox = this._title.getCorrectedLayoutOptions();
        var box = this._insideLegendGroup.getBBox();
        var verticalPadding = this._background ? 2 * this._options.paddingTopBottom : 0;
        box.height = markerBox.height + titleBox.height + verticalPadding;
        titleBox.width > box.width && (box.width = titleBox.width);
        return box;
    },
    getActionCallback: function(point) {
        var that = this;
        if (that._options.visible) return function(act) {
            that[act](point.index);
        };
        else return 0, $gcp4g.noop;
    },
    getLayoutOptions: function() {
        var options = this._options;
        var boundingRect = this._insideLegendGroup ? this._boundingRect : {
            width: 0,
            height: 0,
            x: 0,
            y: 0
        };
        if (options) {
            boundingRect.verticalAlignment = options.verticalAlignment;
            boundingRect.horizontalAlignment = options.horizontalAlignment;
            if (options.orientation === $bb04c7a121c66b83$var$HORIZONTAL) {
                boundingRect.cutLayoutSide = options.verticalAlignment;
                boundingRect.cutSide = "vertical";
            } else if (options.horizontalAlignment === $bb04c7a121c66b83$var$CENTER) {
                boundingRect.cutLayoutSide = options.verticalAlignment;
                boundingRect.cutSide = "vertical";
            } else {
                boundingRect.cutLayoutSide = options.horizontalAlignment;
                boundingRect.cutSide = "horizontal";
            }
            boundingRect.position = {
                horizontal: options.horizontalAlignment,
                vertical: options.verticalAlignment
            };
            return boundingRect;
        }
        return null;
    },
    shift: function(x, y) {
        var box = {};
        if (this._insideLegendGroup) this._insideLegendGroup.attr({
            translateX: x - this._boundingRect.x,
            translateY: y - this._boundingRect.y
        });
        this._title && this._shiftTitle(this._boundingRect.widthWithoutMargins);
        this._markersGroup && this._shiftMarkers();
        if (this._insideLegendGroup) box = this._legendGroup.getBBox();
        this._x1 = box.x;
        this._y1 = box.y;
        this._x2 = box.x + box.width;
        this._y2 = box.y + box.height;
        return this;
    },
    _shiftTitle: function(boxWidth) {
        var title = this._title;
        var titleBox = title.getCorrectedLayoutOptions();
        if (!titleBox || !title.hasText()) return;
        var width = boxWidth - (this._background ? 2 * this._options.paddingLeftRight : 0);
        var titleOptions = title.getOptions();
        var titleY = titleBox.y + titleOptions.margin.top;
        var titleX = 0;
        if (titleOptions.verticalAlignment === $bb04c7a121c66b83$var$BOTTOM && this._markersGroup) titleY += this._markersGroup.getBBox().height;
        if (titleOptions.horizontalAlignment === $bb04c7a121c66b83$var$RIGHT) titleX = width - titleBox.width;
        else if (titleOptions.horizontalAlignment === $bb04c7a121c66b83$var$CENTER) titleX = (width - titleBox.width) / 2;
        title.shift(titleX, titleY);
    },
    _shiftMarkers: function() {
        var titleBox = this._title.getLayoutOptions();
        var markerBox = this._markersGroup.getBBox();
        var titleOptions = this._title.getOptions() || {};
        var center = 0;
        var y = 0;
        if (titleBox.width > markerBox.width && this._options.horizontalAlignment === $bb04c7a121c66b83$var$CENTER) center = titleBox.width / 2 - markerBox.width / 2;
        if (titleOptions.verticalAlignment === $bb04c7a121c66b83$var$TOP) y = titleBox.height;
        if (0 !== center || 0 !== y) {
            this._markersGroup.attr({
                translateX: center,
                translateY: y
            });
            this._items.forEach((item)=>{
                item.tracker.left += center;
                item.tracker.right += center;
                item.tracker.top += y;
                item.tracker.bottom += y;
            });
        }
    },
    getPosition: function() {
        return this._options.position;
    },
    coordsIn: function(x, y) {
        return x >= this._x1 && x <= this._x2 && y >= this._y1 && y <= this._y2;
    },
    getItemByCoord: function(x, y) {
        var items = this._items;
        var legendGroup = this._insideLegendGroup;
        x -= legendGroup.attr("translateX");
        y -= legendGroup.attr("translateY");
        for(var i = 0; i < items.length; i++){
            if ($bb04c7a121c66b83$var$inRect(items[i].tracker, x, y)) return items[i].tracker;
        }
        return null;
    },
    dispose: function() {
        this._title && this._title.dispose();
        this._legendGroup = this._insideLegendGroup = this._title = this._renderer = this._options = this._data = this._items = null;
        return this;
    },
    layoutOptions: function() {
        if (!this.isVisible()) return null;
        var pos = this.getLayoutOptions();
        return {
            horizontalAlignment: this._options.horizontalAlignment,
            verticalAlignment: this._options.verticalAlignment,
            side: pos.cutSide,
            priority: 1,
            position: this.getPosition()
        };
    },
    measure: function(size) {
        if (this._updated || !this._insideLegendGroup) {
            this.draw(size[0], size[1]);
            this._updated = false;
        } else {
            this._items.forEach((item)=>{
                item.bBoxes = [];
            });
            this._updateElementsPosition(size[0], size[1]);
        }
        var rect = this.getLayoutOptions();
        return [
            rect.width,
            rect.height
        ];
    },
    move: function(rect) {
        this.shift(rect[0], rect[1]);
    },
    freeSpace: function() {
        this._options._incidentOccurred("W2104");
        this.erase();
    }
});
var $bb04c7a121c66b83$export$ca524d3785e2543 = {
    name: "legend",
    init: function() {
        var group = this._renderer.g().attr({
            class: this._rootClassPrefix + "-legend"
        }).enableLinks().append(this._renderer.root);
        this._legend = new $bb04c7a121c66b83$export$ed247974535929c7({
            renderer: this._renderer,
            group: group,
            widget: this,
            itemGroupClass: this._rootClassPrefix + "-item",
            titleGroupClass: this._rootClassPrefix + "-title",
            textField: "text",
            getFormatObject: function(data) {
                return {
                    item: data.item,
                    text: data.text
                };
            }
        });
        this._layout.add(this._legend);
    },
    extenders: {
        _applyTilesAppearance: function() {
            var that = this;
            this._items.forEach(function(item) {
                that._applyLegendItemStyle(item.id, item.getState());
            });
        },
        _buildNodes: function() {
            this._createLegendItems();
        }
    },
    members: {
        _applyLegendItemStyle: function(id, state) {
            var legend = this._legend;
            switch(state){
                case "hover":
                    legend.applyHover(id);
                    break;
                case "selection":
                    legend.applySelected(id);
                    break;
                default:
                    legend.resetItem(id);
            }
        },
        _createLegendItems: function() {
            if (this._legend.update(this._getLegendData(), this._getOption("legend"), this._themeManager.theme("legend").title)) this._requestChange([
                "LAYOUT"
            ]);
        }
    },
    dispose: function() {
        this._legend.dispose();
    },
    customize: function(constructor) {
        constructor.prototype._proxyData.push(function(x, y) {
            if (this._legend.coordsIn(x, y)) {
                var item = this._legend.getItemByCoord(x, y);
                if (item) return {
                    id: item.id,
                    type: "legend"
                };
            }
        });
        constructor.addChange({
            code: "LEGEND",
            handler: function() {
                this._createLegendItems();
            },
            isThemeDependent: true,
            option: "legend",
            isOptionChange: true
        });
    }
};

});
parcelRegister("a0Hpu", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return $749b93d1b4cee1d1$export$f99233281efd08a0; });
$parcel$export(module.exports, "plugin", function () { return $749b93d1b4cee1d1$export$ca524d3785e2543; });
/**
 * DevExtreme (esm/viz/core/title.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $2oTOp = parcelRequire("2oTOp");

var $dw9tZ = parcelRequire("dw9tZ");

var $ksd2I = parcelRequire("ksd2I");
var $749b93d1b4cee1d1$var$_Number = Number;
var $749b93d1b4cee1d1$var$parseHorizontalAlignment = (0, $dw9tZ.enumParser)([
    "left",
    "center",
    "right"
]);
var $749b93d1b4cee1d1$var$parseVerticalAlignment = (0, $dw9tZ.enumParser)([
    "top",
    "bottom"
]);
var $749b93d1b4cee1d1$var$DEFAULT_MARGIN = 10;
function $749b93d1b4cee1d1$var$hasText(text) {
    return !!(text && String(text).length > 0);
}
function $749b93d1b4cee1d1$var$processTitleLength(elem, text, width, options, placeholderSize) {
    if (elem.attr({
        text: text
    }).setMaxSize(width, placeholderSize, options).textChanged) elem.setTitle(text);
}
function $749b93d1b4cee1d1$var$pickMarginValue(value) {
    return value >= 0 ? $749b93d1b4cee1d1$var$_Number(value) : $749b93d1b4cee1d1$var$DEFAULT_MARGIN;
}
function $749b93d1b4cee1d1$var$validateMargin(margin) {
    var result;
    if (margin >= 0) result = {
        left: $749b93d1b4cee1d1$var$_Number(margin),
        top: $749b93d1b4cee1d1$var$_Number(margin),
        right: $749b93d1b4cee1d1$var$_Number(margin),
        bottom: $749b93d1b4cee1d1$var$_Number(margin)
    };
    else {
        margin = margin || {};
        result = {
            left: $749b93d1b4cee1d1$var$pickMarginValue(margin.left),
            top: $749b93d1b4cee1d1$var$pickMarginValue(margin.top),
            right: $749b93d1b4cee1d1$var$pickMarginValue(margin.right),
            bottom: $749b93d1b4cee1d1$var$pickMarginValue(margin.bottom)
        };
    }
    return result;
}
function $749b93d1b4cee1d1$var$checkRect(rect, boundingRect) {
    return rect[2] - rect[0] < boundingRect.width || rect[3] - rect[1] < boundingRect.height;
}
var $749b93d1b4cee1d1$export$f99233281efd08a0 = function(params) {
    this._params = params;
    this._group = params.renderer.g().attr({
        class: params.cssClass
    }).linkOn(params.root || params.renderer.root, "title");
    this._hasText = false;
};
(0, $2oTOp.extend)($749b93d1b4cee1d1$export$f99233281efd08a0.prototype, (0, $ksd2I.LayoutElement).prototype, {
    dispose: function() {
        this._group.linkRemove();
        this._group.linkOff();
        if (this._titleElement) {
            this._clipRect.dispose();
            this._titleElement = this._subtitleElement = this._clipRect = null;
        }
        this._params = this._group = this._options = null;
    },
    _updateOptions: function(options) {
        this._options = options;
        this._options.horizontalAlignment = $749b93d1b4cee1d1$var$parseHorizontalAlignment(options.horizontalAlignment, "center");
        this._options.verticalAlignment = $749b93d1b4cee1d1$var$parseVerticalAlignment(options.verticalAlignment, "top");
        this._options.margin = $749b93d1b4cee1d1$var$validateMargin(options.margin);
    },
    _updateStructure: function() {
        var renderer = this._params.renderer;
        var group = this._group;
        var options = this._options;
        var align = options.horizontalAlignment;
        if (!this._titleElement) {
            this._titleElement = renderer.text().append(group);
            this._subtitleElement = renderer.text();
            this._clipRect = renderer.clipRect();
            group.attr({
                "clip-path": this._clipRect.id
            });
        }
        this._titleElement.attr({
            align: align,
            class: options.cssClass
        });
        this._subtitleElement.attr({
            align: align,
            class: options.subtitle.cssClass
        });
        group.linkAppend();
        $749b93d1b4cee1d1$var$hasText(options.subtitle.text) ? this._subtitleElement.append(group) : this._subtitleElement.remove();
    },
    _updateTexts: function() {
        var options = this._options;
        var subtitleOptions = options.subtitle;
        var titleElement = this._titleElement;
        var subtitleElement = this._subtitleElement;
        var titleBox;
        titleElement.attr({
            text: "A",
            y: 0
        }).css((0, $dw9tZ.patchFontOptions)(options.font));
        titleBox = titleElement.getBBox();
        this._baseLineCorrection = titleBox.height + titleBox.y;
        titleElement.attr({
            text: options.text
        });
        titleBox = titleElement.getBBox();
        var y = -titleBox.y;
        titleElement.attr({
            y: y
        });
        if ($749b93d1b4cee1d1$var$hasText(subtitleOptions.text)) subtitleElement.attr({
            text: subtitleOptions.text,
            y: 0
        }).css((0, $dw9tZ.patchFontOptions)(subtitleOptions.font));
    },
    _shiftSubtitle () {
        var titleBox = this._titleElement.getBBox();
        var element = this._subtitleElement;
        var offset = this._options.subtitle.offset;
        element.move(0, titleBox.y + titleBox.height - element.getBBox().y - offset);
    },
    _updateBoundingRectAlignment: function() {
        var boundingRect = this._boundingRect;
        var options = this._options;
        boundingRect.verticalAlignment = options.verticalAlignment;
        boundingRect.horizontalAlignment = options.horizontalAlignment;
        boundingRect.cutLayoutSide = options.verticalAlignment;
        boundingRect.cutSide = "vertical";
        boundingRect.position = {
            horizontal: options.horizontalAlignment,
            vertical: options.verticalAlignment
        };
    },
    hasText: function() {
        return this._hasText;
    },
    update: function(themeOptions, userOptions) {
        var options = (0, $2oTOp.extend)(true, {}, themeOptions, $749b93d1b4cee1d1$var$processTitleOptions(userOptions));
        var _hasText = $749b93d1b4cee1d1$var$hasText(options.text);
        var isLayoutChanged = _hasText || _hasText !== this._hasText;
        this._baseLineCorrection = 0;
        this._updateOptions(options);
        this._boundingRect = {};
        if (_hasText) {
            this._updateStructure();
            this._updateTexts();
        } else this._group.linkRemove();
        this._updateBoundingRect();
        this._updateBoundingRectAlignment();
        this._hasText = _hasText;
        return isLayoutChanged;
    },
    draw: function(width, height) {
        if (this._hasText) {
            this._group.linkAppend();
            this._correctTitleLength(width);
            if (this._group.getBBox().height > height) this.freeSpace();
        }
        return this;
    },
    _correctTitleLength: function(width) {
        var options = this._options;
        var margin = options.margin;
        var maxWidth = width - margin.left - margin.right;
        var placeholderSize = options.placeholderSize;
        $749b93d1b4cee1d1$var$processTitleLength(this._titleElement, options.text, maxWidth, options, placeholderSize);
        if (this._subtitleElement) {
            if ($749b93d1b4cee1d1$var$_Number(placeholderSize) > 0) placeholderSize -= this._titleElement.getBBox().height;
            $749b93d1b4cee1d1$var$processTitleLength(this._subtitleElement, options.subtitle.text, maxWidth, options.subtitle, placeholderSize);
            this._shiftSubtitle();
        }
        this._updateBoundingRect();
        var { x: x, y: y, height: height } = this.getCorrectedLayoutOptions();
        this._clipRect.attr({
            x: x,
            y: y,
            width: width,
            height: height
        });
    },
    getLayoutOptions: function() {
        return this._boundingRect || null;
    },
    shift: function(x, y) {
        var box = this.getLayoutOptions();
        this._group.move(x - box.x, y - box.y);
        return this;
    },
    _updateBoundingRect: function() {
        var options = this._options;
        var margin = options.margin;
        var boundingRect = this._boundingRect;
        var box = this._hasText ? this._group.getBBox() : {
            width: 0,
            height: 0,
            x: 0,
            y: 0,
            isEmpty: true
        };
        if (!box.isEmpty) {
            box.height += margin.top + margin.bottom - this._baseLineCorrection;
            box.width += margin.left + margin.right;
            box.x -= margin.left;
            box.y += this._baseLineCorrection - margin.top;
        }
        if (options.placeholderSize > 0) box.height = options.placeholderSize;
        boundingRect.height = box.height;
        boundingRect.width = box.width;
        boundingRect.x = box.x;
        boundingRect.y = box.y;
    },
    getCorrectedLayoutOptions () {
        var srcBox = this.getLayoutOptions();
        var correction = this._baseLineCorrection;
        return (0, $2oTOp.extend)({}, srcBox, {
            y: srcBox.y - correction,
            height: srcBox.height + correction
        });
    },
    layoutOptions: function() {
        if (!this._hasText) return null;
        return {
            horizontalAlignment: this._boundingRect.horizontalAlignment,
            verticalAlignment: this._boundingRect.verticalAlignment,
            priority: 0
        };
    },
    measure: function(size) {
        this.draw(size[0], size[1]);
        return [
            this._boundingRect.width,
            this._boundingRect.height
        ];
    },
    move: function(rect, fitRect) {
        var boundingRect = this._boundingRect;
        if ($749b93d1b4cee1d1$var$checkRect(rect, boundingRect)) this.shift(fitRect[0], fitRect[1]);
        else this.shift(Math.round(rect[0]), Math.round(rect[1]));
    },
    freeSpace: function() {
        this._params.incidentOccurred("W2103");
        this._group.linkRemove();
        this._boundingRect.width = this._boundingRect.height = 0;
    },
    getOptions: function() {
        return this._options;
    },
    changeLink: function(root) {
        this._group.linkRemove();
        this._group.linkOn(root, "title");
    }
});
function $749b93d1b4cee1d1$var$processTitleOptions(options) {
    var newOptions = (0, $6ntMu.isString)(options) ? {
        text: options
    } : options || {};
    newOptions.subtitle = (0, $6ntMu.isString)(newOptions.subtitle) ? {
        text: newOptions.subtitle
    } : newOptions.subtitle || {};
    return newOptions;
}
var $749b93d1b4cee1d1$export$ca524d3785e2543 = {
    name: "title",
    init: function() {
        this._title = new $749b93d1b4cee1d1$export$f99233281efd08a0({
            renderer: this._renderer,
            cssClass: this._rootClassPrefix + "-title",
            incidentOccurred: this._incidentOccurred
        });
        this._layout.add(this._title);
    },
    dispose: function() {
        this._title.dispose();
        this._title = null;
    },
    customize: function(constructor) {
        constructor.addChange({
            code: "TITLE",
            handler: function() {
                if (this._title.update(this._themeManager.theme("title"), this.option("title"))) this._change([
                    "LAYOUT"
                ]);
            },
            isThemeDependent: true,
            option: "title",
            isOptionChange: true
        });
    },
    fontFields: [
        "title.font",
        "title.subtitle.font"
    ]
};

});


parcelRegister("7AWWW", function(module, exports) {

$parcel$export(module.exports, "plugin", function () { return $58799f633e52d236$export$ca524d3785e2543; });
/**
 * DevExtreme (esm/viz/core/data_source.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $gcp4g = parcelRequire("gcp4g");

var $66w7N = parcelRequire("66w7N");
var $58799f633e52d236$var$postCtor = (0, $66w7N.default).postCtor;
var $58799f633e52d236$var$name;
var $58799f633e52d236$var$members = {
    _dataSourceLoadErrorHandler: function() {
        this._dataSourceChangedHandler();
    },
    _dataSourceOptions: function() {
        return {
            paginate: false
        };
    },
    _updateDataSource: function() {
        this._refreshDataSource();
        if (!this.option("dataSource")) this._dataSourceChangedHandler();
    },
    _dataIsLoaded: function() {
        return !this._dataSource || this._dataSource.isLoaded();
    },
    _dataSourceItems: function() {
        return this._dataSource && this._dataSource.items();
    }
};
for($58799f633e52d236$var$name in 0, $66w7N.default){
    if ("postCtor" === $58799f633e52d236$var$name) continue;
    $58799f633e52d236$var$members[$58799f633e52d236$var$name] = (0, $66w7N.default)[$58799f633e52d236$var$name];
}
var $58799f633e52d236$export$ca524d3785e2543 = {
    name: "data_source",
    init: function() {
        $58799f633e52d236$var$postCtor.call(this);
    },
    dispose: (0, $gcp4g.noop),
    members: $58799f633e52d236$var$members
};

});
parcelRegister("66w7N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $471c38e8ed8e78be$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/data_helper.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $9rTrl = parcelRequire("9rTrl");

var $2oTOp = parcelRequire("2oTOp");

var $2xD6m = parcelRequire("2xD6m");

var $66sos = parcelRequire("66sos");
var $471c38e8ed8e78be$var$DATA_SOURCE_OPTIONS_METHOD = "_dataSourceOptions";
var $471c38e8ed8e78be$var$DATA_SOURCE_CHANGED_METHOD = "_dataSourceChangedHandler";
var $471c38e8ed8e78be$var$DATA_SOURCE_LOAD_ERROR_METHOD = "_dataSourceLoadErrorHandler";
var $471c38e8ed8e78be$var$DATA_SOURCE_LOADING_CHANGED_METHOD = "_dataSourceLoadingChangedHandler";
var $471c38e8ed8e78be$var$DATA_SOURCE_FROM_URL_LOAD_MODE_METHOD = "_dataSourceFromUrlLoadMode";
var $471c38e8ed8e78be$var$SPECIFIC_DATA_SOURCE_OPTION = "_getSpecificDataSourceOption";
var $471c38e8ed8e78be$var$NORMALIZE_DATA_SOURCE = "_normalizeDataSource";
var $471c38e8ed8e78be$var$DataHelperMixin = {
    postCtor: function() {
        this.on("disposing", (function() {
            this._disposeDataSource();
        }).bind(this));
    },
    _refreshDataSource: function() {
        this._initDataSource();
        this._loadDataSource();
    },
    _initDataSource: function() {
        var dataSourceOptions = $471c38e8ed8e78be$var$SPECIFIC_DATA_SOURCE_OPTION in this ? this[$471c38e8ed8e78be$var$SPECIFIC_DATA_SOURCE_OPTION]() : this.option("dataSource");
        var widgetDataSourceOptions;
        var dataSourceType;
        this._disposeDataSource();
        if (dataSourceOptions) {
            if (dataSourceOptions instanceof (0, $9rTrl.DataSource)) {
                this._isSharedDataSource = true;
                this._dataSource = dataSourceOptions;
            } else {
                widgetDataSourceOptions = $471c38e8ed8e78be$var$DATA_SOURCE_OPTIONS_METHOD in this ? this[$471c38e8ed8e78be$var$DATA_SOURCE_OPTIONS_METHOD]() : {};
                dataSourceType = this._dataSourceType ? this._dataSourceType() : (0, $9rTrl.DataSource);
                dataSourceOptions = (0, $2xD6m.normalizeDataSourceOptions)(dataSourceOptions, {
                    fromUrlLoadMode: $471c38e8ed8e78be$var$DATA_SOURCE_FROM_URL_LOAD_MODE_METHOD in this && this[$471c38e8ed8e78be$var$DATA_SOURCE_FROM_URL_LOAD_MODE_METHOD]()
                });
                this._dataSource = new dataSourceType((0, $2oTOp.extend)(true, {}, widgetDataSourceOptions, dataSourceOptions));
            }
            if ($471c38e8ed8e78be$var$NORMALIZE_DATA_SOURCE in this) this._dataSource = this[$471c38e8ed8e78be$var$NORMALIZE_DATA_SOURCE](this._dataSource);
            this._addDataSourceHandlers();
            this._initDataController();
        }
    },
    _initDataController: function() {
        var _this$option;
        var dataController = null === (_this$option = this.option) || void 0 === _this$option ? void 0 : _this$option.call(this, "_dataController");
        var dataSource = this._dataSource;
        if (dataController) this._dataController = dataController;
        else this._dataController = new (0, $66sos.default)(dataSource);
    },
    _addDataSourceHandlers: function() {
        if ($471c38e8ed8e78be$var$DATA_SOURCE_CHANGED_METHOD in this) this._addDataSourceChangeHandler();
        if ($471c38e8ed8e78be$var$DATA_SOURCE_LOAD_ERROR_METHOD in this) this._addDataSourceLoadErrorHandler();
        if ($471c38e8ed8e78be$var$DATA_SOURCE_LOADING_CHANGED_METHOD in this) this._addDataSourceLoadingChangedHandler();
        this._addReadyWatcher();
    },
    _addReadyWatcher: function() {
        this._dataSource.on("loadingChanged", (function(isLoading) {
            this._ready && this._ready(!isLoading);
        }).bind(this));
    },
    _addDataSourceChangeHandler: function() {
        var dataSource = this._dataSource;
        this._proxiedDataSourceChangedHandler = (function(e) {
            this[$471c38e8ed8e78be$var$DATA_SOURCE_CHANGED_METHOD](dataSource.items(), e);
        }).bind(this);
        dataSource.on("changed", this._proxiedDataSourceChangedHandler);
    },
    _addDataSourceLoadErrorHandler: function() {
        this._proxiedDataSourceLoadErrorHandler = this[$471c38e8ed8e78be$var$DATA_SOURCE_LOAD_ERROR_METHOD].bind(this);
        this._dataSource.on("loadError", this._proxiedDataSourceLoadErrorHandler);
    },
    _addDataSourceLoadingChangedHandler: function() {
        this._proxiedDataSourceLoadingChangedHandler = this[$471c38e8ed8e78be$var$DATA_SOURCE_LOADING_CHANGED_METHOD].bind(this);
        this._dataSource.on("loadingChanged", this._proxiedDataSourceLoadingChangedHandler);
    },
    _loadDataSource: function() {
        var dataSource = this._dataSource;
        if (dataSource) {
            if (dataSource.isLoaded()) this._proxiedDataSourceChangedHandler && this._proxiedDataSourceChangedHandler();
            else dataSource.load();
        }
    },
    _loadSingle: function(key, value) {
        key = "this" === key ? this._dataSource.key() || "this" : key;
        return this._dataSource.loadSingle(key, value);
    },
    _isLastPage: function() {
        return !this._dataSource || this._dataSource.isLastPage() || !this._dataSource._pageSize;
    },
    _isDataSourceLoading: function() {
        return this._dataSource && this._dataSource.isLoading();
    },
    _disposeDataSource: function() {
        if (this._dataSource) {
            if (this._isSharedDataSource) {
                delete this._isSharedDataSource;
                this._proxiedDataSourceChangedHandler && this._dataSource.off("changed", this._proxiedDataSourceChangedHandler);
                this._proxiedDataSourceLoadErrorHandler && this._dataSource.off("loadError", this._proxiedDataSourceLoadErrorHandler);
                this._proxiedDataSourceLoadingChangedHandler && this._dataSource.off("loadingChanged", this._proxiedDataSourceLoadingChangedHandler);
            } else this._dataSource.dispose();
            delete this._dataSource;
            delete this._proxiedDataSourceChangedHandler;
            delete this._proxiedDataSourceLoadErrorHandler;
            delete this._proxiedDataSourceLoadingChangedHandler;
        }
    },
    getDataSource: function() {
        return this._dataSource || null;
    }
};
var $471c38e8ed8e78be$export$2e2bcd8739ae039 = $471c38e8ed8e78be$var$DataHelperMixin;

});
parcelRegister("9rTrl", function(module, exports) {

$parcel$export(module.exports, "DataSource", function () { return $6e11a3e41c762a0f$export$accd73d198d77d2f; });
/**
 * DevExtreme (esm/data/data_source/data_source.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $a2g7x = parcelRequire("a2g7x");

var $2oTOp = parcelRequire("2oTOp");

var $gcp4g = parcelRequire("gcp4g");

var $8OLOW = parcelRequire("8OLOW");

var $6ntMu = parcelRequire("6ntMu");

var $bXwdG = parcelRequire("bXwdG");

var $7ZQfQ = parcelRequire("7ZQfQ");

var $8uHJZ = parcelRequire("8uHJZ");

var $dL2Eh = parcelRequire("dL2Eh");

var $5wFvO = parcelRequire("5wFvO");

var $4sqTC = parcelRequire("4sqTC");

var $dDkff = parcelRequire("dDkff");

var $2heqD = parcelRequire("2heqD");

var $2xD6m = parcelRequire("2xD6m");
var $6e11a3e41c762a0f$export$accd73d198d77d2f = (0, $a2g7x.default).inherit({
    ctor (options) {
        var _options$reshapeOnPus;
        options = (0, $2xD6m.normalizeDataSourceOptions)(options);
        this._eventsStrategy = new (0, $dL2Eh.EventsStrategy)(this, {
            syncStrategy: true
        });
        this._store = options.store;
        this._changedTime = 0;
        var needThrottling = 0 !== options.pushAggregationTimeout;
        if (needThrottling) {
            var throttlingTimeout = void 0 === options.pushAggregationTimeout ? ()=>5 * this._changedTime : options.pushAggregationTimeout;
            var pushDeferred;
            var lastPushWaiters;
            var throttlingPushHandler = (0, $bXwdG.throttleChanges)((changes)=>{
                pushDeferred.resolve();
                var storePushPending = (0, $dDkff.when)(...lastPushWaiters);
                storePushPending.done(()=>this._onPush(changes));
                lastPushWaiters = void 0;
                pushDeferred = void 0;
            }, throttlingTimeout);
            this._onPushHandler = (args)=>{
                this._aggregationTimeoutId = throttlingPushHandler(args.changes);
                if (!pushDeferred) pushDeferred = new (0, $dDkff.Deferred);
                lastPushWaiters = args.waitFor;
                args.waitFor.push(pushDeferred.promise());
            };
            this._store.on("beforePushAggregation", this._onPushHandler);
        } else {
            this._onPushHandler = (changes)=>this._onPush(changes);
            this._store.on("push", this._onPushHandler);
        }
        this._storeLoadOptions = this._extractLoadOptions(options);
        this._mapFunc = options.map;
        this._postProcessFunc = options.postProcess;
        this._pageIndex = void 0 !== options.pageIndex ? options.pageIndex : 0;
        this._pageSize = void 0 !== options.pageSize ? options.pageSize : 20;
        this._loadingCount = 0;
        this._loadQueue = this._createLoadQueue();
        this._searchValue = "searchValue" in options ? options.searchValue : null;
        this._searchOperation = options.searchOperation || "contains";
        this._searchExpr = options.searchExpr;
        this._paginate = options.paginate;
        this._reshapeOnPush = null !== (_options$reshapeOnPus = options.reshapeOnPush) && void 0 !== _options$reshapeOnPus ? _options$reshapeOnPus : false;
        (0, $8OLOW.each)([
            "onChanged",
            "onLoadError",
            "onLoadingChanged",
            "onCustomizeLoadResult",
            "onCustomizeStoreLoadOptions"
        ], (_, optionName)=>{
            if (optionName in options) this.on(optionName.substr(2, 1).toLowerCase() + optionName.substr(3), options[optionName]);
        });
        this._operationManager = new (0, $2heqD.default);
        this._init();
    },
    _init () {
        this._items = [];
        this._userData = {};
        this._totalCount = -1;
        this._isLoaded = false;
        if (!(0, $6ntMu.isDefined)(this._paginate)) this._paginate = !this.group();
        this._isLastPage = !this._paginate;
    },
    dispose () {
        var _this$_delayedLoadTas;
        this._store.off("beforePushAggregation", this._onPushHandler);
        this._store.off("push", this._onPushHandler);
        this._eventsStrategy.dispose();
        clearTimeout(this._aggregationTimeoutId);
        null === (_this$_delayedLoadTas = this._delayedLoadTask) || void 0 === _this$_delayedLoadTas || _this$_delayedLoadTas.abort();
        this._operationManager.cancelAll();
        delete this._store;
        delete this._items;
        delete this._delayedLoadTask;
        this._disposed = true;
    },
    _extractLoadOptions (options) {
        var result = {};
        var names = [
            "sort",
            "filter",
            "select",
            "group",
            "requireTotalCount"
        ];
        var customNames = this._store._customLoadOptions();
        if (customNames) names = names.concat(customNames);
        (0, $8OLOW.each)(names, function() {
            result[this] = options[this];
        });
        return result;
    },
    loadOptions () {
        return this._storeLoadOptions;
    },
    items () {
        return this._items;
    },
    pageIndex (newIndex) {
        if (!(0, $6ntMu.isNumeric)(newIndex)) return this._pageIndex;
        this._pageIndex = newIndex;
        this._isLastPage = !this._paginate;
    },
    paginate (value) {
        if (!(0, $6ntMu.isBoolean)(value)) return this._paginate;
        if (this._paginate !== value) {
            this._paginate = value;
            this.pageIndex(0);
        }
    },
    pageSize (value) {
        if (!(0, $6ntMu.isNumeric)(value)) return this._pageSize;
        this._pageSize = value;
    },
    isLastPage () {
        return this._isLastPage;
    },
    generateStoreLoadOptionAccessor (optionName) {
        return (args)=>{
            var normalizedArgs = (0, $2xD6m.normalizeStoreLoadOptionAccessorArguments)(args);
            if (void 0 === normalizedArgs) return this._storeLoadOptions[optionName];
            this._storeLoadOptions[optionName] = normalizedArgs;
        };
    },
    sort () {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.generateStoreLoadOptionAccessor("sort")(args);
    },
    filter () {
        var newFilter = (0, $2xD6m.normalizeStoreLoadOptionAccessorArguments)(arguments);
        if (void 0 === newFilter) return this._storeLoadOptions.filter;
        this._storeLoadOptions.filter = newFilter;
        this.pageIndex(0);
    },
    group () {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.generateStoreLoadOptionAccessor("group")(args);
    },
    select () {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.generateStoreLoadOptionAccessor("select")(args);
    },
    requireTotalCount (value) {
        if (!(0, $6ntMu.isBoolean)(value)) return this._storeLoadOptions.requireTotalCount;
        this._storeLoadOptions.requireTotalCount = value;
    },
    searchValue (value) {
        if (arguments.length < 1) return this._searchValue;
        this._searchValue = value;
        this.pageIndex(0);
    },
    searchOperation (op) {
        if (!(0, $6ntMu.isString)(op)) return this._searchOperation;
        this._searchOperation = op;
        this.pageIndex(0);
    },
    searchExpr (expr) {
        var argc = arguments.length;
        if (0 === argc) return this._searchExpr;
        if (argc > 1) expr = [].slice.call(arguments);
        this._searchExpr = expr;
        this.pageIndex(0);
    },
    store () {
        return this._store;
    },
    key () {
        var _this$_store;
        return null === (_this$_store = this._store) || void 0 === _this$_store ? void 0 : _this$_store.key();
    },
    totalCount () {
        return this._totalCount;
    },
    isLoaded () {
        return this._isLoaded;
    },
    isLoading () {
        return this._loadingCount > 0;
    },
    beginLoading () {
        this._changeLoadingCount(1);
    },
    endLoading () {
        this._changeLoadingCount(-1);
    },
    _createLoadQueue: ()=>(0, $4sqTC.create)(),
    _changeLoadingCount (increment) {
        var oldLoading = this.isLoading();
        this._loadingCount += increment;
        var newLoading = this.isLoading();
        if (oldLoading ^ newLoading) this._eventsStrategy.fireEvent("loadingChanged", [
            newLoading
        ]);
    },
    _scheduleLoadCallbacks (deferred) {
        this.beginLoading();
        deferred.always(()=>{
            this.endLoading();
        });
    },
    _scheduleFailCallbacks (deferred) {
        var _this = this;
        deferred.fail(function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            if (args[0] === (0, $2xD6m.CANCELED_TOKEN)) return;
            _this._eventsStrategy.fireEvent("loadError", args);
        });
    },
    _fireChanged (args) {
        var date = new Date;
        this._eventsStrategy.fireEvent("changed", args);
        this._changedTime = new Date - date;
    },
    _scheduleChangedCallbacks (deferred) {
        deferred.done(()=>this._fireChanged());
    },
    loadSingle (propName, propValue) {
        var d = new (0, $dDkff.Deferred);
        var key = this.key();
        var store = this._store;
        var options = this._createStoreLoadOptions();
        this._scheduleFailCallbacks(d);
        if (arguments.length < 2) {
            propValue = propName;
            propName = key;
        }
        delete options.skip;
        delete options.group;
        delete options.refresh;
        delete options.pageIndex;
        delete options.searchString;
        (()=>{
            if (propName === key || store instanceof (0, $8uHJZ.default) && !store._byKeyViaLoad()) return store.byKey(propValue, options);
            options.take = 1;
            options.filter = options.filter ? [
                options.filter,
                [
                    propName,
                    propValue
                ]
            ] : [
                propName,
                propValue
            ];
            return store.load(options);
        })().fail(d.reject).done((data)=>{
            var isEmptyArray = Array.isArray(data) && !data.length;
            if (!(0, $6ntMu.isDefined)(data) || isEmptyArray) d.reject(new (0, $5wFvO.errors).Error("E4009"));
            else {
                if (!Array.isArray(data)) data = [
                    data
                ];
                d.resolve(this._applyMapFunction(data)[0]);
            }
        });
        return d.promise();
    },
    load () {
        var d = new (0, $dDkff.Deferred);
        var loadTask = ()=>{
            if (this._disposed) return;
            if (!(0, $2xD6m.isPending)(d)) return;
            return this._loadFromStore(loadOperation, d);
        };
        this._scheduleLoadCallbacks(d);
        this._scheduleFailCallbacks(d);
        this._scheduleChangedCallbacks(d);
        var loadOperation = this._createLoadOperation(d);
        this._eventsStrategy.fireEvent("customizeStoreLoadOptions", [
            loadOperation
        ]);
        this._loadQueue.add(()=>{
            if ("number" === typeof loadOperation.delay) this._delayedLoadTask = (0, $gcp4g.executeAsync)(loadTask, loadOperation.delay);
            else loadTask();
            return d.promise();
        });
        return d.promise({
            operationId: loadOperation.operationId
        });
    },
    _onPush (changes) {
        if (this._reshapeOnPush) this.load();
        else {
            var changingArgs = {
                changes: changes
            };
            this._eventsStrategy.fireEvent("changing", [
                changingArgs
            ]);
            var group = this.group();
            var items = this.items();
            var groupLevel = 0;
            var dataSourceChanges = this.paginate() || group ? changes.filter((item)=>"update" === item.type) : changes;
            if (group) groupLevel = Array.isArray(group) ? group.length : 1;
            if (this._mapFunc) dataSourceChanges.forEach((item)=>{
                if ("insert" === item.type) item.data = this._mapFunc(item.data);
            });
            if (changingArgs.postProcessChanges) dataSourceChanges = changingArgs.postProcessChanges(dataSourceChanges);
            (0, $7ZQfQ.applyBatch)({
                keyInfo: this.store(),
                data: items,
                changes: dataSourceChanges,
                groupCount: groupLevel,
                useInsertIndex: true
            });
            this._fireChanged([
                {
                    changes: changes
                }
            ]);
        }
    },
    _createLoadOperation (deferred) {
        var operationId = this._operationManager.add(deferred);
        var storeLoadOptions = this._createStoreLoadOptions();
        deferred.always(()=>this._operationManager.remove(operationId));
        return {
            operationId: operationId,
            storeLoadOptions: storeLoadOptions
        };
    },
    reload () {
        var store = this.store();
        store._clearCache();
        this._init();
        return this.load();
    },
    cancel (operationId) {
        return this._operationManager.cancel(operationId);
    },
    cancelAll () {
        return this._operationManager.cancelAll();
    },
    _addSearchOptions (storeLoadOptions) {
        if (this._disposed) return;
        if (this.store()._useDefaultSearch) this._addSearchFilter(storeLoadOptions);
        else {
            storeLoadOptions.searchOperation = this._searchOperation;
            storeLoadOptions.searchValue = this._searchValue;
            storeLoadOptions.searchExpr = this._searchExpr;
        }
    },
    _createStoreLoadOptions () {
        var result = (0, $2oTOp.extend)({}, this._storeLoadOptions);
        this._addSearchOptions(result);
        if (this._paginate) {
            if (this._pageSize) {
                result.skip = this._pageIndex * this._pageSize;
                result.take = this._pageSize;
            }
        }
        result.userData = this._userData;
        return result;
    },
    _addSearchFilter (storeLoadOptions) {
        var value = this._searchValue;
        var op = this._searchOperation;
        var selector = this._searchExpr;
        var searchFilter = [];
        if (!value) return;
        if (!selector) selector = "this";
        if (!Array.isArray(selector)) selector = [
            selector
        ];
        (0, $8OLOW.each)(selector, function(i, item) {
            if (searchFilter.length) searchFilter.push("or");
            searchFilter.push([
                item,
                op,
                value
            ]);
        });
        if (storeLoadOptions.filter) storeLoadOptions.filter = [
            searchFilter,
            storeLoadOptions.filter
        ];
        else storeLoadOptions.filter = searchFilter;
    },
    _loadFromStore (loadOptions, pendingDeferred) {
        var handleSuccess = (data, extra)=>{
            if (this._disposed) return;
            if (!(0, $2xD6m.isPending)(pendingDeferred)) return;
            var loadResult = (0, $2oTOp.extend)((0, $2xD6m.normalizeLoadResult)(data, extra), loadOptions);
            this._eventsStrategy.fireEvent("customizeLoadResult", [
                loadResult
            ]);
            (0, $dDkff.when)(loadResult.data).done((data)=>{
                loadResult.data = data;
                this._processStoreLoadResult(loadResult, pendingDeferred);
            }).fail(pendingDeferred.reject);
        };
        if (loadOptions.data) return (new (0, $dDkff.Deferred)).resolve(loadOptions.data).done(handleSuccess);
        return this.store().load(loadOptions.storeLoadOptions).done(handleSuccess).fail(pendingDeferred.reject);
    },
    _processStoreLoadResult (loadResult, pendingDeferred) {
        var data = loadResult.data;
        var extra = loadResult.extra;
        var storeLoadOptions = loadResult.storeLoadOptions;
        var resolvePendingDeferred = ()=>{
            this._isLoaded = true;
            this._totalCount = isFinite(extra.totalCount) ? extra.totalCount : -1;
            return pendingDeferred.resolve(data, extra);
        };
        if (this._disposed) return;
        data = this._applyPostProcessFunction(this._applyMapFunction(data));
        if (!(0, $6ntMu.isObject)(extra)) extra = {};
        this._items = data;
        if (!data.length || !this._paginate || this._pageSize && data.length < this._pageSize) this._isLastPage = true;
        if (storeLoadOptions.requireTotalCount && !isFinite(extra.totalCount)) (()=>{
            this.store().totalCount(storeLoadOptions).done(function(count) {
                extra.totalCount = count;
                resolvePendingDeferred();
            }).fail(pendingDeferred.reject);
        })();
        else resolvePendingDeferred();
    },
    _applyMapFunction (data) {
        if (this._mapFunc) return (0, $2xD6m.mapDataRespectingGrouping)(data, this._mapFunc, this.group());
        return data;
    },
    _applyPostProcessFunction (data) {
        if (this._postProcessFunc) return this._postProcessFunc(data);
        return data;
    },
    on (eventName, eventHandler) {
        this._eventsStrategy.on(eventName, eventHandler);
        return this;
    },
    off (eventName, eventHandler) {
        this._eventsStrategy.off(eventName, eventHandler);
        return this;
    }
});

});
parcelRegister("bXwdG", function(module, exports) {

$parcel$export(module.exports, "XHR_ERROR_UNLOAD", function () { return $8b4e328a331bf384$export$fdf24cb3d7f350db; });
$parcel$export(module.exports, "normalizeBinaryCriterion", function () { return $8b4e328a331bf384$export$933b84f6a98705f7; });
$parcel$export(module.exports, "normalizeSortingInfo", function () { return $8b4e328a331bf384$export$135c7fc85b054442; });
$parcel$export(module.exports, "errorMessageFromXhr", function () { return $8b4e328a331bf384$export$82cea3675f8d7b3c; });
$parcel$export(module.exports, "aggregators", function () { return $8b4e328a331bf384$export$b67d605a1a19c2e3; });
$parcel$export(module.exports, "processRequestResultLock", function () { return $8b4e328a331bf384$export$edd1a41e0d415428; });
$parcel$export(module.exports, "isConjunctiveOperator", function () { return $8b4e328a331bf384$export$aa7afd6a80ed4af9; });
$parcel$export(module.exports, "keysEqual", function () { return $8b4e328a331bf384$export$d5a0c5c7ef294f97; });
$parcel$export(module.exports, "isUnaryOperation", function () { return $8b4e328a331bf384$export$898502623f390c5e; });
$parcel$export(module.exports, "isGroupCriterion", function () { return $8b4e328a331bf384$export$ef2f4af2df69d799; });
$parcel$export(module.exports, "trivialPromise", function () { return $8b4e328a331bf384$export$94aaab8a54b141a5; });
$parcel$export(module.exports, "rejectedPromise", function () { return $8b4e328a331bf384$export$58665203f98928f1; });
$parcel$export(module.exports, "throttleChanges", function () { return $8b4e328a331bf384$export$ba0b702101ef6809; });
/**
 * DevExtreme (esm/data/utils.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $3yzYM = parcelRequire("3yzYM");

var $8n1m9 = parcelRequire("8n1m9");

var $hYatw = parcelRequire("hYatw");

var $8OLOW = parcelRequire("8OLOW");

var $dDkff = parcelRequire("dDkff");

var $gcp4g = parcelRequire("gcp4g");
var $8b4e328a331bf384$var$ready = (0, $8n1m9.default).add;
var $8b4e328a331bf384$export$fdf24cb3d7f350db = "DEVEXTREME_XHR_ERROR_UNLOAD";
var $8b4e328a331bf384$export$933b84f6a98705f7 = function(crit) {
    return [
        crit[0],
        crit.length < 3 ? "=" : String(crit[1]).toLowerCase(),
        crit.length < 2 ? true : crit[crit.length - 1]
    ];
};
var $8b4e328a331bf384$export$135c7fc85b054442 = function(info) {
    if (!Array.isArray(info)) info = [
        info
    ];
    return (0, $8OLOW.map)(info, function(i) {
        var result = {
            selector: (0, $6ntMu.isFunction)(i) || "string" === typeof i ? i : i.getter || i.field || i.selector,
            desc: !!(i.desc || "d" === String(i.dir).charAt(0).toLowerCase())
        };
        if (i.compare) result.compare = i.compare;
        return result;
    });
};
var $8b4e328a331bf384$export$82cea3675f8d7b3c = function() {
    var textStatusMessages = {
        timeout: "Network connection timeout",
        error: "Unspecified network error",
        parsererror: "Unexpected server response"
    };
    var unloading;
    $8b4e328a331bf384$var$ready(function() {
        var window = (0, $hYatw.getWindow)();
        (0, $3yzYM.default).listen(window, "beforeunload", function() {
            unloading = true;
        });
    });
    return function(xhr, textStatus) {
        if (unloading) return $8b4e328a331bf384$export$fdf24cb3d7f350db;
        if (xhr.status < 400) return function(textStatus) {
            var result = textStatusMessages[textStatus];
            if (!result) return textStatus;
            return result;
        }(textStatus);
        return xhr.statusText;
    };
}();
var $8b4e328a331bf384$export$b67d605a1a19c2e3 = {
    count: {
        seed: 0,
        step: function(count) {
            return 1 + count;
        }
    },
    sum: {
        seed: 0,
        step: function(sum, item) {
            return sum + item;
        }
    },
    min: {
        step: function(min, item) {
            return item < min ? item : min;
        }
    },
    max: {
        step: function(max, item) {
            return item > max ? item : max;
        }
    },
    avg: {
        seed: [
            0,
            0
        ],
        step: function(pair, value) {
            return [
                pair[0] + value,
                pair[1] + 1
            ];
        },
        finalize: function(pair) {
            return pair[1] ? pair[0] / pair[1] : NaN;
        }
    }
};
var $8b4e328a331bf384$export$edd1a41e0d415428 = function() {
    var lockCount = 0;
    var lockDeferred;
    return {
        obtain: function() {
            if (0 === lockCount) lockDeferred = new (0, $dDkff.Deferred);
            lockCount++;
        },
        release: function() {
            lockCount--;
            if (lockCount < 1) lockDeferred.resolve();
        },
        promise: function() {
            var deferred = 0 === lockCount ? (new (0, $dDkff.Deferred)).resolve() : lockDeferred;
            return deferred.promise();
        },
        reset: function() {
            lockCount = 0;
            if (lockDeferred) lockDeferred.resolve();
        }
    };
}();
function $8b4e328a331bf384$export$6485892aedff6f1a(condition) {
    return /^(or|\|\||\|)$/i.test(condition);
}
function $8b4e328a331bf384$export$aa7afd6a80ed4af9(condition) {
    return /^(and|&&|&)$/i.test(condition);
}
var $8b4e328a331bf384$export$d5a0c5c7ef294f97 = function(keyExpr, key1, key2) {
    if (Array.isArray(keyExpr)) {
        var names = (0, $8OLOW.map)(key1, function(v, k) {
            return k;
        });
        var name;
        for(var i = 0; i < names.length; i++){
            name = names[i];
            if (!(0, $gcp4g.equalByValue)(key1[name], key2[name], {
                strict: false
            })) return false;
        }
        return true;
    }
    return (0, $gcp4g.equalByValue)(key1, key2, {
        strict: false
    });
};
var $8b4e328a331bf384$var$BASE64_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
var $8b4e328a331bf384$export$7d4079ca09f99033 = function(input) {
    if (!Array.isArray(input)) input = $8b4e328a331bf384$var$stringToByteArray(String(input));
    var result = "";
    function getBase64Char(index) {
        return $8b4e328a331bf384$var$BASE64_CHARS.charAt(index);
    }
    for(var i = 0; i < input.length; i += 3){
        var octet1 = input[i];
        var octet2 = input[i + 1];
        var octet3 = input[i + 2];
        result += (0, $8OLOW.map)([
            octet1 >> 2,
            (3 & octet1) << 4 | octet2 >> 4,
            isNaN(octet2) ? 64 : (15 & octet2) << 2 | octet3 >> 6,
            isNaN(octet3) ? 64 : 63 & octet3
        ], getBase64Char).join("");
    }
    return result;
};
function $8b4e328a331bf384$var$stringToByteArray(str) {
    var bytes = [];
    var code;
    var i;
    for(i = 0; i < str.length; i++){
        code = str.charCodeAt(i);
        if (code < 128) bytes.push(code);
        else if (code < 2048) bytes.push(192 + (code >> 6), 128 + (63 & code));
        else if (code < 65536) bytes.push(224 + (code >> 12), 128 + (code >> 6 & 63), 128 + (63 & code));
        else if (code < 2097152) bytes.push(240 + (code >> 18), 128 + (code >> 12 & 63), 128 + (code >> 6 & 63), 128 + (63 & code));
    }
    return bytes;
}
var $8b4e328a331bf384$export$898502623f390c5e = function(crit) {
    return "!" === crit[0] && Array.isArray(crit[1]);
};
var $8b4e328a331bf384$var$isGroupOperator = function(value) {
    return "and" === value || "or" === value;
};
var $8b4e328a331bf384$export$ef2f4af2df69d799 = function(crit) {
    var first = crit[0];
    var second = crit[1];
    if (Array.isArray(first)) return true;
    if ((0, $6ntMu.isFunction)(first)) {
        if (Array.isArray(second) || (0, $6ntMu.isFunction)(second) || $8b4e328a331bf384$var$isGroupOperator(second)) return true;
    }
    return false;
};
var $8b4e328a331bf384$export$94aaab8a54b141a5 = function() {
    var d = new (0, $dDkff.Deferred);
    return d.resolve.apply(d, arguments).promise();
};
var $8b4e328a331bf384$export$58665203f98928f1 = function() {
    var d = new (0, $dDkff.Deferred);
    return d.reject.apply(d, arguments).promise();
};
function $8b4e328a331bf384$var$throttle(func, timeout) {
    var timeoutId;
    return function() {
        if (!timeoutId) timeoutId = setTimeout(()=>{
            timeoutId = void 0;
            func.call(this);
        }, (0, $6ntMu.isFunction)(timeout) ? timeout() : timeout);
        return timeoutId;
    };
}
function $8b4e328a331bf384$export$ba0b702101ef6809(func, timeout) {
    var cache = [];
    var throttled = $8b4e328a331bf384$var$throttle(function() {
        func.call(this, cache);
        cache = [];
    }, timeout);
    return function(changes) {
        if (Array.isArray(changes)) cache.push(...changes);
        return throttled.call(this, cache);
    };
}

});

parcelRegister("7ZQfQ", function(module, exports) {

$parcel$export(module.exports, "indexByKey", function () { return $5d26c38ff44df8d3$export$ec9c86cc7ac0ca60; });
$parcel$export(module.exports, "applyBatch", function () { return $5d26c38ff44df8d3$export$65d4799c35eb3744; });
$parcel$export(module.exports, "update", function () { return $5d26c38ff44df8d3$export$722fbec263ad908a; });
$parcel$export(module.exports, "insert", function () { return $5d26c38ff44df8d3$export$21a5ca8aa77d35ff; });
$parcel$export(module.exports, "remove", function () { return $5d26c38ff44df8d3$export$cd7f480d6b8286c3; });
/**
 * DevExtreme (esm/data/array_utils.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $4WYaH = parcelRequire("4WYaH");

var $6ntMu = parcelRequire("6ntMu");

var $8IERv = parcelRequire("8IERv");

var $kuGI3 = parcelRequire("kuGI3");

var $2oTOp = parcelRequire("2oTOp");

var $5wFvO = parcelRequire("5wFvO");

var $5VpUx = parcelRequire("5VpUx");

var $8Cgs4 = parcelRequire("8Cgs4");

var $bXwdG = parcelRequire("bXwdG");
function $5d26c38ff44df8d3$var$hasKey(target, keyOrKeys) {
    var key;
    var keys = "string" === typeof keyOrKeys ? keyOrKeys.split() : keyOrKeys.slice();
    while(keys.length){
        key = keys.shift();
        if (key in target) return true;
    }
    return false;
}
function $5d26c38ff44df8d3$var$findItems(keyInfo, items, key, groupCount) {
    var childItems;
    var result;
    if (groupCount) for(var i = 0; i < items.length; i++){
        childItems = items[i].items || items[i].collapsedItems || [];
        result = $5d26c38ff44df8d3$var$findItems(keyInfo, childItems || [], key, groupCount - 1);
        if (result) return result;
    }
    else if ($5d26c38ff44df8d3$export$ec9c86cc7ac0ca60(keyInfo, items, key) >= 0) return items;
}
function $5d26c38ff44df8d3$var$getItems(keyInfo, items, key, groupCount) {
    if (groupCount) return $5d26c38ff44df8d3$var$findItems(keyInfo, items, key, groupCount) || [];
    return items;
}
function $5d26c38ff44df8d3$var$generateDataByKeyMap(keyInfo, array) {
    if (keyInfo.key() && (!array._dataByKeyMap || array._dataByKeyMapLength !== array.length)) {
        var dataByKeyMap = {};
        var arrayLength = array.length;
        for(var i = 0; i < arrayLength; i++)dataByKeyMap[JSON.stringify(keyInfo.keyOf(array[i]))] = array[i];
        array._dataByKeyMap = dataByKeyMap;
        array._dataByKeyMapLength = arrayLength;
    }
}
function $5d26c38ff44df8d3$var$getCacheValue(array, key) {
    if (array._dataByKeyMap) return array._dataByKeyMap[JSON.stringify(key)];
}
function $5d26c38ff44df8d3$var$getHasKeyCacheValue(array, key) {
    if (array._dataByKeyMap) return array._dataByKeyMap[JSON.stringify(key)];
    return true;
}
function $5d26c38ff44df8d3$var$setDataByKeyMapValue(array, key, data) {
    if (array._dataByKeyMap) {
        array._dataByKeyMap[JSON.stringify(key)] = data;
        array._dataByKeyMapLength += data ? 1 : -1;
    }
}
function $5d26c38ff44df8d3$var$cloneInstanceWithChangedPaths(instance, changes, clonedInstances) {
    clonedInstances = clonedInstances || new WeakMap;
    var result = instance ? Object.create(Object.getPrototypeOf(instance)) : {};
    if (instance) clonedInstances.set(instance, result);
    var instanceWithoutPrototype = (0, $4WYaH.default)({}, instance);
    (0, $5VpUx.deepExtendArraySafe)(result, instanceWithoutPrototype, true, true);
    for(var name in instanceWithoutPrototype){
        var value = instanceWithoutPrototype[name];
        var change = null === changes || void 0 === changes ? void 0 : changes[name];
        if ((0, $6ntMu.isObject)(value) && !(0, $6ntMu.isPlainObject)(value) && (0, $6ntMu.isObject)(change) && !clonedInstances.has(value)) result[name] = $5d26c38ff44df8d3$var$cloneInstanceWithChangedPaths(value, change, clonedInstances);
    }
    for(var _name in result){
        var prop = result[_name];
        if ((0, $6ntMu.isObject)(prop) && clonedInstances.has(prop)) result[_name] = clonedInstances.get(prop);
    }
    return result;
}
function $5d26c38ff44df8d3$export$66c546ca672b947c(target, changes) {
    var result = $5d26c38ff44df8d3$var$cloneInstanceWithChangedPaths(target, changes);
    return (0, $5VpUx.deepExtendArraySafe)(result, changes, true, true);
}
function $5d26c38ff44df8d3$export$65d4799c35eb3744(_ref) {
    var { keyInfo: keyInfo, data: data, changes: changes, groupCount: groupCount, useInsertIndex: useInsertIndex, immutable: immutable, disableCache: disableCache, logError: logError, skipCopying: skipCopying } = _ref;
    var resultItems = true === immutable ? [
        ...data
    ] : data;
    changes.forEach((item)=>{
        var items = "insert" === item.type ? resultItems : $5d26c38ff44df8d3$var$getItems(keyInfo, resultItems, item.key, groupCount);
        !disableCache && $5d26c38ff44df8d3$var$generateDataByKeyMap(keyInfo, items);
        switch(item.type){
            case "update":
                $5d26c38ff44df8d3$export$722fbec263ad908a(keyInfo, items, item.key, item.data, true, immutable, logError);
                break;
            case "insert":
                $5d26c38ff44df8d3$export$21a5ca8aa77d35ff(keyInfo, items, item.data, useInsertIndex && (0, $6ntMu.isDefined)(item.index) ? item.index : -1, true, logError, skipCopying);
                break;
            case "remove":
                $5d26c38ff44df8d3$export$cd7f480d6b8286c3(keyInfo, items, item.key, true, logError);
        }
    });
    return resultItems;
}
function $5d26c38ff44df8d3$var$getErrorResult(isBatch, logError, errorCode) {
    return !isBatch ? (0, $bXwdG.rejectedPromise)((0, $5wFvO.errors).Error(errorCode)) : logError && (0, $5wFvO.errors).log(errorCode);
}
function $5d26c38ff44df8d3$export$10db731c0a813ec1(data, changes) {
    var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    var { keyExpr: keyExpr = "id", immutable: immutable = true } = options;
    var keyGetter = (0, $8Cgs4.compileGetter)(keyExpr);
    var keyInfo = {
        key: ()=>keyExpr,
        keyOf: (obj)=>keyGetter(obj)
    };
    return $5d26c38ff44df8d3$export$65d4799c35eb3744({
        keyInfo: keyInfo,
        data: data,
        changes: changes,
        immutable: immutable,
        disableCache: true,
        logError: true
    });
}
function $5d26c38ff44df8d3$export$722fbec263ad908a(keyInfo, array, key, data, isBatch, immutable, logError) {
    var target;
    var keyExpr = keyInfo.key();
    if (keyExpr) {
        if ($5d26c38ff44df8d3$var$hasKey(data, keyExpr) && !(0, $bXwdG.keysEqual)(keyExpr, key, keyInfo.keyOf(data))) return $5d26c38ff44df8d3$var$getErrorResult(isBatch, logError, "E4017");
        target = $5d26c38ff44df8d3$var$getCacheValue(array, key);
        if (!target) {
            var index = $5d26c38ff44df8d3$export$ec9c86cc7ac0ca60(keyInfo, array, key);
            if (index < 0) return $5d26c38ff44df8d3$var$getErrorResult(isBatch, logError, "E4009");
            target = array[index];
            if (true === immutable && (0, $6ntMu.isDefined)(target)) {
                var newTarget = $5d26c38ff44df8d3$export$66c546ca672b947c(target, data);
                array[index] = newTarget;
                return !isBatch && (0, $bXwdG.trivialPromise)(newTarget, key);
            }
        }
    } else target = key;
    (0, $5VpUx.deepExtendArraySafe)(target, data, true);
    if (!isBatch) {
        if ((0, $8IERv.default)().useLegacyStoreResult) return (0, $bXwdG.trivialPromise)(key, data);
        else return (0, $bXwdG.trivialPromise)(target, key);
    }
}
function $5d26c38ff44df8d3$export$21a5ca8aa77d35ff(keyInfo, array, data, index, isBatch, logError, skipCopying) {
    var keyValue;
    var keyExpr = keyInfo.key();
    var obj = (0, $6ntMu.isPlainObject)(data) && !skipCopying ? (0, $2oTOp.extend)({}, data) : data;
    if (keyExpr) {
        keyValue = keyInfo.keyOf(obj);
        if (void 0 === keyValue || "object" === typeof keyValue && (0, $6ntMu.isEmptyObject)(keyValue)) {
            if (Array.isArray(keyExpr)) throw (0, $5wFvO.errors).Error("E4007");
            keyValue = obj[keyExpr] = String(new (0, $kuGI3.default));
        } else if (void 0 !== array[$5d26c38ff44df8d3$export$ec9c86cc7ac0ca60(keyInfo, array, keyValue)]) return $5d26c38ff44df8d3$var$getErrorResult(isBatch, logError, "E4008");
    } else keyValue = obj;
    if (index >= 0) array.splice(index, 0, obj);
    else array.push(obj);
    $5d26c38ff44df8d3$var$setDataByKeyMapValue(array, keyValue, obj);
    if (!isBatch) return (0, $bXwdG.trivialPromise)((0, $8IERv.default)().useLegacyStoreResult ? data : obj, keyValue);
}
function $5d26c38ff44df8d3$export$cd7f480d6b8286c3(keyInfo, array, key, isBatch, logError) {
    var index = $5d26c38ff44df8d3$export$ec9c86cc7ac0ca60(keyInfo, array, key);
    if (index > -1) {
        array.splice(index, 1);
        $5d26c38ff44df8d3$var$setDataByKeyMapValue(array, key, null);
    }
    if (!isBatch) return (0, $bXwdG.trivialPromise)(key);
    else if (index < 0) return $5d26c38ff44df8d3$var$getErrorResult(isBatch, logError, "E4009");
}
function $5d26c38ff44df8d3$export$ec9c86cc7ac0ca60(keyInfo, array, key) {
    var keyExpr = keyInfo.key();
    if (!$5d26c38ff44df8d3$var$getHasKeyCacheValue(array, key)) return -1;
    for(var i = 0, arrayLength = array.length; i < arrayLength; i++){
        if ((0, $bXwdG.keysEqual)(keyExpr, keyInfo.keyOf(array[i]), key)) return i;
    }
    return -1;
}

});
parcelRegister("5wFvO", function(module, exports) {

$parcel$export(module.exports, "errors", function () { return $406024588789c06d$export$30f3b02011db23c0; });
$parcel$export(module.exports, "handleError", function () { return $406024588789c06d$export$d3da1ecaf1206c58; });
/**
 * DevExtreme (esm/data/errors.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $hCicl = parcelRequire("hCicl");

var $cvYFL = parcelRequire("cvYFL");
var $406024588789c06d$export$30f3b02011db23c0 = (0, $hCicl.default)((0, $cvYFL.default).ERROR_MESSAGES, {
    E4000: "[DevExpress.data]: {0}",
    E4001: "Unknown aggregating function is detected: '{0}'",
    E4002: "Unsupported OData protocol version is used",
    E4003: "Unknown filter operation is used: {0}",
    E4004: "The thenby() method is called before the sortby() method",
    E4005: "Store requires a key expression for this operation",
    E4006: "ArrayStore 'data' option must be an array",
    E4007: "Compound keys cannot be auto-generated",
    E4008: "Attempt to insert an item with a duplicated key",
    E4009: "Data item cannot be found",
    E4010: "CustomStore does not support creating queries",
    E4011: "Custom Store method is not implemented or is not a function: {0}",
    E4012: "Custom Store method returns an invalid value: {0}",
    E4013: "Local Store requires the 'name' configuration option is specified",
    E4014: "Unknown data type is specified for ODataStore: {0}",
    E4015: "Unknown entity name or alias is used: {0}",
    E4016: "The compileSetter(expr) method is called with 'self' passed as a parameter",
    E4017: "Keys cannot be modified",
    E4018: "The server has returned a non-numeric value in a response to an item count request",
    E4019: "Mixing of group operators inside a single group of filter expression is not allowed",
    E4020: "Unknown store type is detected: {0}",
    E4021: "The server response does not provide the totalCount value",
    E4022: "The server response does not provide the groupCount value",
    E4023: "Could not parse the following XML: {0}",
    E4024: "String function {0} cannot be used with the data field {1} of type {2}.",
    W4000: "Data returned from the server has an incorrect structure",
    W4001: 'The {0} field is listed in both "keyType" and "fieldTypes". The value of "fieldTypes" is used.',
    W4002: "Data loading has failed for some cells due to the following error: {0}"
});
var $406024588789c06d$export$cc3fdd528b56c4a9 = null;
var $406024588789c06d$export$d3da1ecaf1206c58 = function(error) {
    var _errorHandler;
    null === (_errorHandler = $406024588789c06d$export$cc3fdd528b56c4a9) || void 0 === _errorHandler || _errorHandler(error);
};
var $406024588789c06d$export$56c340fcfa13d1a2 = (handler)=>$406024588789c06d$export$cc3fdd528b56c4a9 = handler;

});


parcelRegister("8uHJZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62f30e1a40aaeba7$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/data/custom_store.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $bXwdG = parcelRequire("bXwdG");

var $7ZQfQ = parcelRequire("7ZQfQ");

var $6ntMu = parcelRequire("6ntMu");

var $8IERv = parcelRequire("8IERv");

var $5wFvO = parcelRequire("5wFvO");

var $aXXVC = parcelRequire("aXXVC");

var $9ZiP3 = parcelRequire("9ZiP3");

var $kCXun = parcelRequire("kCXun");

var $dDkff = parcelRequire("dDkff");
var $62f30e1a40aaeba7$var$TOTAL_COUNT = "totalCount";
var $62f30e1a40aaeba7$var$LOAD = "load";
var $62f30e1a40aaeba7$var$BY_KEY = "byKey";
var $62f30e1a40aaeba7$var$INSERT = "insert";
var $62f30e1a40aaeba7$var$UPDATE = "update";
var $62f30e1a40aaeba7$var$REMOVE = "remove";
function $62f30e1a40aaeba7$var$isPromise(obj) {
    return obj && (0, $6ntMu.isFunction)(obj.then);
}
function $62f30e1a40aaeba7$var$trivialPromise(value) {
    return (new (0, $dDkff.Deferred)).resolve(value).promise();
}
function $62f30e1a40aaeba7$var$ensureRequiredFuncOption(name, obj) {
    if (!(0, $6ntMu.isFunction)(obj)) throw (0, $5wFvO.errors).Error("E4011", name);
}
function $62f30e1a40aaeba7$var$throwInvalidUserFuncResult(name) {
    throw (0, $5wFvO.errors).Error("E4012", name);
}
function $62f30e1a40aaeba7$var$createUserFuncFailureHandler(pendingDeferred) {
    function errorMessageFromXhr(promiseArguments) {
        var xhr = promiseArguments[0];
        var textStatus = promiseArguments[1];
        if (!xhr || !xhr.getResponseHeader) return null;
        return (0, $bXwdG.errorMessageFromXhr)(xhr, textStatus);
    }
    return function(arg) {
        var error;
        if (arg instanceof Error) error = arg;
        else error = new Error(errorMessageFromXhr(arguments) || arg && String(arg) || "Unknown error");
        if (error.message !== (0, $bXwdG.XHR_ERROR_UNLOAD)) pendingDeferred.reject(error);
    };
}
function $62f30e1a40aaeba7$var$invokeUserLoad(store, options) {
    var userFunc = store._loadFunc;
    var userResult;
    $62f30e1a40aaeba7$var$ensureRequiredFuncOption($62f30e1a40aaeba7$var$LOAD, userFunc);
    userResult = userFunc.apply(store, [
        options
    ]);
    if (Array.isArray(userResult)) userResult = $62f30e1a40aaeba7$var$trivialPromise(userResult);
    else if (null === userResult || void 0 === userResult) userResult = $62f30e1a40aaeba7$var$trivialPromise([]);
    else if (!$62f30e1a40aaeba7$var$isPromise(userResult)) $62f30e1a40aaeba7$var$throwInvalidUserFuncResult($62f30e1a40aaeba7$var$LOAD);
    return (0, $dDkff.fromPromise)(userResult);
}
function $62f30e1a40aaeba7$var$invokeUserTotalCountFunc(store, options) {
    var userFunc = store._totalCountFunc;
    var userResult;
    if (!(0, $6ntMu.isFunction)(userFunc)) throw (0, $5wFvO.errors).Error("E4021");
    userResult = userFunc.apply(store, [
        options
    ]);
    if (!$62f30e1a40aaeba7$var$isPromise(userResult)) {
        userResult = Number(userResult);
        if (!isFinite(userResult)) $62f30e1a40aaeba7$var$throwInvalidUserFuncResult($62f30e1a40aaeba7$var$TOTAL_COUNT);
        userResult = $62f30e1a40aaeba7$var$trivialPromise(userResult);
    }
    return (0, $dDkff.fromPromise)(userResult);
}
function $62f30e1a40aaeba7$var$invokeUserByKeyFunc(store, key, extraOptions) {
    var userFunc = store._byKeyFunc;
    var userResult;
    $62f30e1a40aaeba7$var$ensureRequiredFuncOption($62f30e1a40aaeba7$var$BY_KEY, userFunc);
    userResult = userFunc.apply(store, [
        key,
        extraOptions
    ]);
    if (!$62f30e1a40aaeba7$var$isPromise(userResult)) userResult = $62f30e1a40aaeba7$var$trivialPromise(userResult);
    return (0, $dDkff.fromPromise)(userResult);
}
function $62f30e1a40aaeba7$var$runRawLoad(pendingDeferred, store, userFuncOptions, continuation) {
    if (store.__rawData) continuation(store.__rawData);
    else {
        var loadPromise = store.__rawDataPromise || $62f30e1a40aaeba7$var$invokeUserLoad(store, userFuncOptions);
        if (store._cacheRawData) store.__rawDataPromise = loadPromise;
        loadPromise.always(function() {
            delete store.__rawDataPromise;
        }).done(function(rawData) {
            if (store._cacheRawData) store.__rawData = rawData;
            continuation(rawData);
        }).fail($62f30e1a40aaeba7$var$createUserFuncFailureHandler(pendingDeferred));
    }
}
function $62f30e1a40aaeba7$var$runRawLoadWithQuery(pendingDeferred, store, options, countOnly) {
    options = options || {};
    var userFuncOptions = {};
    if ("userData" in options) userFuncOptions.userData = options.userData;
    $62f30e1a40aaeba7$var$runRawLoad(pendingDeferred, store, userFuncOptions, function(rawData) {
        var rawDataQuery = (0, $9ZiP3.default)(rawData, {
            errorHandler: store._errorHandler
        });
        var itemsQuery;
        var totalCountQuery;
        var waitList = [];
        var items;
        var totalCount;
        if (!countOnly) {
            itemsQuery = (0, $kCXun.default).queryByOptions(rawDataQuery, options);
            if (itemsQuery === rawDataQuery) items = rawData.slice(0);
            else waitList.push(itemsQuery.enumerate().done(function(asyncResult) {
                items = asyncResult;
            }));
        }
        if (options.requireTotalCount || countOnly) {
            totalCountQuery = (0, $kCXun.default).queryByOptions(rawDataQuery, options, true);
            if (totalCountQuery === rawDataQuery) totalCount = rawData.length;
            else waitList.push(totalCountQuery.count().done(function(asyncResult) {
                totalCount = asyncResult;
            }));
        }
        (0, $dDkff.when).apply((0, $2vlX8.default), waitList).done(function() {
            if (countOnly) pendingDeferred.resolve(totalCount);
            else if (options.requireTotalCount) pendingDeferred.resolve(items, {
                totalCount: totalCount
            });
            else pendingDeferred.resolve(items);
        }).fail(function(x) {
            pendingDeferred.reject(x);
        });
    });
}
function $62f30e1a40aaeba7$var$runRawLoadWithKey(pendingDeferred, store, key) {
    $62f30e1a40aaeba7$var$runRawLoad(pendingDeferred, store, {}, function(rawData) {
        var keyExpr = store.key();
        var item;
        for(var i = 0, len = rawData.length; i < len; i++){
            item = rawData[i];
            if ((0, $bXwdG.keysEqual)(keyExpr, store.keyOf(rawData[i]), key)) {
                pendingDeferred.resolve(item);
                return;
            }
        }
        pendingDeferred.reject((0, $5wFvO.errors).Error("E4009"));
    });
}
var $62f30e1a40aaeba7$var$CustomStore = (0, $aXXVC.default).inherit({
    ctor: function(options) {
        options = options || {};
        this.callBase(options);
        this._useDefaultSearch = !!options.useDefaultSearch || "raw" === options.loadMode;
        this._loadMode = options.loadMode;
        this._cacheRawData = false !== options.cacheRawData;
        this._loadFunc = options[$62f30e1a40aaeba7$var$LOAD];
        this._totalCountFunc = options[$62f30e1a40aaeba7$var$TOTAL_COUNT];
        this._byKeyFunc = options[$62f30e1a40aaeba7$var$BY_KEY];
        this._insertFunc = options[$62f30e1a40aaeba7$var$INSERT];
        this._updateFunc = options[$62f30e1a40aaeba7$var$UPDATE];
        this._removeFunc = options[$62f30e1a40aaeba7$var$REMOVE];
    },
    _clearCache () {
        delete this.__rawData;
    },
    createQuery: function() {
        throw (0, $5wFvO.errors).Error("E4010");
    },
    clearRawDataCache: function() {
        this._clearCache();
    },
    _totalCountImpl: function(options) {
        var d = new (0, $dDkff.Deferred);
        if ("raw" === this._loadMode && !this._totalCountFunc) $62f30e1a40aaeba7$var$runRawLoadWithQuery(d, this, options, true);
        else {
            $62f30e1a40aaeba7$var$invokeUserTotalCountFunc(this, options).done(function(count) {
                d.resolve(Number(count));
            }).fail($62f30e1a40aaeba7$var$createUserFuncFailureHandler(d));
            d = this._addFailHandlers(d);
        }
        return d.promise();
    },
    _pushImpl: function(changes) {
        if (this.__rawData) (0, $7ZQfQ.applyBatch)({
            keyInfo: this,
            data: this.__rawData,
            changes: changes
        });
    },
    _loadImpl: function(options) {
        var d = new (0, $dDkff.Deferred);
        if ("raw" === this._loadMode) $62f30e1a40aaeba7$var$runRawLoadWithQuery(d, this, options, false);
        else {
            $62f30e1a40aaeba7$var$invokeUserLoad(this, options).done(function(data, extra) {
                d.resolve(data, extra);
            }).fail($62f30e1a40aaeba7$var$createUserFuncFailureHandler(d));
            d = this._addFailHandlers(d);
        }
        return d.promise();
    },
    _byKeyImpl: function(key, extraOptions) {
        var d = new (0, $dDkff.Deferred);
        if (this._byKeyViaLoad()) {
            this._requireKey();
            $62f30e1a40aaeba7$var$runRawLoadWithKey(d, this, key);
        } else $62f30e1a40aaeba7$var$invokeUserByKeyFunc(this, key, extraOptions).done(function(obj) {
            d.resolve(obj);
        }).fail($62f30e1a40aaeba7$var$createUserFuncFailureHandler(d));
        return d.promise();
    },
    _byKeyViaLoad: function() {
        return "raw" === this._loadMode && !this._byKeyFunc;
    },
    _insertImpl: function(values) {
        var that = this;
        var userFunc = that._insertFunc;
        var userResult;
        var d = new (0, $dDkff.Deferred);
        $62f30e1a40aaeba7$var$ensureRequiredFuncOption($62f30e1a40aaeba7$var$INSERT, userFunc);
        userResult = userFunc.apply(that, [
            values
        ]);
        if (!$62f30e1a40aaeba7$var$isPromise(userResult)) userResult = $62f30e1a40aaeba7$var$trivialPromise(userResult);
        (0, $dDkff.fromPromise)(userResult).done(function(serverResponse) {
            if ((0, $8IERv.default)().useLegacyStoreResult) d.resolve(values, serverResponse);
            else d.resolve(serverResponse || values, that.keyOf(serverResponse));
        }).fail($62f30e1a40aaeba7$var$createUserFuncFailureHandler(d));
        return d.promise();
    },
    _updateImpl: function(key, values) {
        var userFunc = this._updateFunc;
        var userResult;
        var d = new (0, $dDkff.Deferred);
        $62f30e1a40aaeba7$var$ensureRequiredFuncOption($62f30e1a40aaeba7$var$UPDATE, userFunc);
        userResult = userFunc.apply(this, [
            key,
            values
        ]);
        if (!$62f30e1a40aaeba7$var$isPromise(userResult)) userResult = $62f30e1a40aaeba7$var$trivialPromise(userResult);
        (0, $dDkff.fromPromise)(userResult).done(function(serverResponse) {
            if ((0, $8IERv.default)().useLegacyStoreResult) d.resolve(key, values);
            else d.resolve(serverResponse || values, key);
        }).fail($62f30e1a40aaeba7$var$createUserFuncFailureHandler(d));
        return d.promise();
    },
    _removeImpl: function(key) {
        var userFunc = this._removeFunc;
        var userResult;
        var d = new (0, $dDkff.Deferred);
        $62f30e1a40aaeba7$var$ensureRequiredFuncOption($62f30e1a40aaeba7$var$REMOVE, userFunc);
        userResult = userFunc.apply(this, [
            key
        ]);
        if (!$62f30e1a40aaeba7$var$isPromise(userResult)) userResult = $62f30e1a40aaeba7$var$trivialPromise();
        (0, $dDkff.fromPromise)(userResult).done(function() {
            d.resolve(key);
        }).fail($62f30e1a40aaeba7$var$createUserFuncFailureHandler(d));
        return d.promise();
    }
});
var $62f30e1a40aaeba7$export$2e2bcd8739ae039 = $62f30e1a40aaeba7$var$CustomStore;

});
parcelRegister("aXXVC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fbde69401faed03$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/data/abstract_store.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $a2g7x = parcelRequire("a2g7x");

var $dL2Eh = parcelRequire("dL2Eh");

var $8OLOW = parcelRequire("8OLOW");

var $5wFvO = parcelRequire("5wFvO");

var $bXwdG = parcelRequire("bXwdG");

var $8Cgs4 = parcelRequire("8Cgs4");

var $kCXun = parcelRequire("kCXun");

var $dDkff = parcelRequire("dDkff");

var $gcp4g = parcelRequire("gcp4g");
var $7fbde69401faed03$var$abstract = (0, $a2g7x.default).abstract;
var $7fbde69401faed03$var$queryByOptions = (0, $kCXun.default).queryByOptions;
var $7fbde69401faed03$var$storeImpl = {};
var $7fbde69401faed03$var$Store = (0, $a2g7x.default).inherit({
    ctor: function(options) {
        var that = this;
        options = options || {};
        this._eventsStrategy = new (0, $dL2Eh.EventsStrategy)(this);
        (0, $8OLOW.each)([
            "onLoaded",
            "onLoading",
            "onInserted",
            "onInserting",
            "onUpdated",
            "onUpdating",
            "onPush",
            "onRemoved",
            "onRemoving",
            "onModified",
            "onModifying"
        ], function(_, optionName) {
            if (optionName in options) that.on(optionName.slice(2).toLowerCase(), options[optionName]);
        });
        this._key = options.key;
        this._errorHandler = options.errorHandler;
        this._useDefaultSearch = true;
    },
    _clearCache: (0, $gcp4g.noop),
    _customLoadOptions: function() {
        return null;
    },
    key: function() {
        return this._key;
    },
    keyOf: function(obj) {
        if (!this._keyGetter) this._keyGetter = (0, $8Cgs4.compileGetter)(this.key());
        return this._keyGetter(obj);
    },
    _requireKey: function() {
        if (!this.key()) throw (0, $5wFvO.errors).Error("E4005");
    },
    load: function(options) {
        var that = this;
        options = options || {};
        this._eventsStrategy.fireEvent("loading", [
            options
        ]);
        return this._withLock(this._loadImpl(options)).done(function(result) {
            that._eventsStrategy.fireEvent("loaded", [
                result,
                options
            ]);
        });
    },
    _loadImpl: function(options) {
        return $7fbde69401faed03$var$queryByOptions(this.createQuery(options), options).enumerate();
    },
    _withLock: function(task) {
        var result = new (0, $dDkff.Deferred);
        task.done(function() {
            var that = this;
            var args = arguments;
            (0, $bXwdG.processRequestResultLock).promise().done(function() {
                result.resolveWith(that, args);
            });
        }).fail(function() {
            result.rejectWith(this, arguments);
        });
        return result;
    },
    createQuery: $7fbde69401faed03$var$abstract,
    totalCount: function(options) {
        return this._totalCountImpl(options);
    },
    _totalCountImpl: function(options) {
        return $7fbde69401faed03$var$queryByOptions(this.createQuery(options), options, true).count();
    },
    byKey: function(key, extraOptions) {
        return this._addFailHandlers(this._withLock(this._byKeyImpl(key, extraOptions)));
    },
    _byKeyImpl: $7fbde69401faed03$var$abstract,
    insert: function(values) {
        var that = this;
        that._eventsStrategy.fireEvent("modifying");
        that._eventsStrategy.fireEvent("inserting", [
            values
        ]);
        return that._addFailHandlers(that._insertImpl(values).done(function(callbackValues, callbackKey) {
            that._eventsStrategy.fireEvent("inserted", [
                callbackValues,
                callbackKey
            ]);
            that._eventsStrategy.fireEvent("modified");
        }));
    },
    _insertImpl: $7fbde69401faed03$var$abstract,
    update: function(key, values) {
        var that = this;
        that._eventsStrategy.fireEvent("modifying");
        that._eventsStrategy.fireEvent("updating", [
            key,
            values
        ]);
        return that._addFailHandlers(that._updateImpl(key, values).done(function() {
            that._eventsStrategy.fireEvent("updated", [
                key,
                values
            ]);
            that._eventsStrategy.fireEvent("modified");
        }));
    },
    _updateImpl: $7fbde69401faed03$var$abstract,
    push: function(changes) {
        var beforePushArgs = {
            changes: changes,
            waitFor: []
        };
        this._eventsStrategy.fireEvent("beforePushAggregation", [
            beforePushArgs
        ]);
        (0, $dDkff.when)(...beforePushArgs.waitFor).done(()=>{
            this._pushImpl(changes);
            this._eventsStrategy.fireEvent("beforePush", [
                {
                    changes: changes
                }
            ]);
            this._eventsStrategy.fireEvent("push", [
                changes
            ]);
        });
    },
    _pushImpl: (0, $gcp4g.noop),
    remove: function(key) {
        var that = this;
        that._eventsStrategy.fireEvent("modifying");
        that._eventsStrategy.fireEvent("removing", [
            key
        ]);
        return that._addFailHandlers(that._removeImpl(key).done(function(callbackKey) {
            that._eventsStrategy.fireEvent("removed", [
                callbackKey
            ]);
            that._eventsStrategy.fireEvent("modified");
        }));
    },
    _removeImpl: $7fbde69401faed03$var$abstract,
    _addFailHandlers: function(deferred) {
        return deferred.fail(this._errorHandler).fail((0, $5wFvO.handleError));
    },
    on (eventName, eventHandler) {
        this._eventsStrategy.on(eventName, eventHandler);
        return this;
    },
    off (eventName, eventHandler) {
        this._eventsStrategy.off(eventName, eventHandler);
        return this;
    }
});
$7fbde69401faed03$var$Store.create = function(alias, options) {
    if (!(alias in $7fbde69401faed03$var$storeImpl)) throw (0, $5wFvO.errors).Error("E4020", alias);
    return new $7fbde69401faed03$var$storeImpl[alias](options);
};
$7fbde69401faed03$var$Store.registerClass = function(type, alias) {
    if (alias) $7fbde69401faed03$var$storeImpl[alias] = type;
    return type;
};
$7fbde69401faed03$var$Store.inherit = function(inheritor) {
    return function(members, alias) {
        var type = inheritor.apply(this, [
            members
        ]);
        $7fbde69401faed03$var$Store.registerClass(type, alias);
        return type;
    };
}($7fbde69401faed03$var$Store.inherit);
var $7fbde69401faed03$export$2e2bcd8739ae039 = $7fbde69401faed03$var$Store;

});
parcelRegister("kCXun", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f045808a78ef1584$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/data/store_helper.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $gcp4g = parcelRequire("gcp4g");

var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $9ZiP3 = parcelRequire("9ZiP3");

var $bXwdG = parcelRequire("bXwdG");
function $f045808a78ef1584$var$multiLevelGroup(query, groupInfo) {
    query = query.groupBy(groupInfo[0].selector);
    if (groupInfo.length > 1) query = query.select(function(g) {
        return (0, $2oTOp.extend)({}, g, {
            items: $f045808a78ef1584$var$multiLevelGroup((0, $9ZiP3.default)(g.items), groupInfo.slice(1)).toArray()
        });
    });
    return query;
}
function $f045808a78ef1584$var$arrangeSortingInfo(groupInfo, sortInfo) {
    var filteredGroup = [];
    (0, $8OLOW.each)(groupInfo, function(_, group) {
        var collision = (0, $gcp4g.grep)(sortInfo, function(sort) {
            return group.selector === sort.selector;
        });
        if (collision.length < 1) filteredGroup.push(group);
    });
    return filteredGroup.concat(sortInfo);
}
function $f045808a78ef1584$var$queryByOptions(query, options, isCountQuery) {
    options = options || {};
    var filter = options.filter;
    if (filter) query = query.filter(filter);
    if (isCountQuery) return query;
    var sort = options.sort;
    var select = options.select;
    var group = options.group;
    var skip = options.skip;
    var take = options.take;
    if (group) {
        group = (0, $bXwdG.normalizeSortingInfo)(group);
        group.keepInitialKeyOrder = !!options.group.keepInitialKeyOrder;
    }
    if (sort || group) {
        sort = (0, $bXwdG.normalizeSortingInfo)(sort || []);
        if (group && !group.keepInitialKeyOrder) sort = $f045808a78ef1584$var$arrangeSortingInfo(group, sort);
        (0, $8OLOW.each)(sort, function(index) {
            query = query[index ? "thenBy" : "sortBy"](this.selector, this.desc, this.compare);
        });
    }
    if (select) query = query.select(select);
    if (group) query = $f045808a78ef1584$var$multiLevelGroup(query, group);
    if (take || skip) query = query.slice(skip || 0, take);
    return query;
}
var $f045808a78ef1584$export$2e2bcd8739ae039 = {
    multiLevelGroup: $f045808a78ef1584$var$multiLevelGroup,
    arrangeSortingInfo: $f045808a78ef1584$var$arrangeSortingInfo,
    queryByOptions: $f045808a78ef1584$var$queryByOptions
};

});
parcelRegister("9ZiP3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7458694eb6c029d8$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/data/array_query.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $a2g7x = parcelRequire("a2g7x");

var $6ntMu = parcelRequire("6ntMu");

var $8OLOW = parcelRequire("8OLOW");

var $8Cgs4 = parcelRequire("8Cgs4");

var $dDkff = parcelRequire("dDkff");

var $5wFvO = parcelRequire("5wFvO");

var $bXwdG = parcelRequire("bXwdG");
var $7458694eb6c029d8$var$Iterator = (0, $a2g7x.default).inherit({
    toArray: function() {
        var result = [];
        this.reset();
        while(this.next())result.push(this.current());
        return result;
    },
    countable: function() {
        return false;
    }
});
var $7458694eb6c029d8$var$ArrayIterator = $7458694eb6c029d8$var$Iterator.inherit({
    ctor: function(array) {
        this.array = array;
        this.index = -1;
    },
    next: function() {
        if (this.index + 1 < this.array.length) {
            this.index++;
            return true;
        }
        return false;
    },
    current: function() {
        return this.array[this.index];
    },
    reset: function() {
        this.index = -1;
    },
    toArray: function() {
        return this.array.slice(0);
    },
    countable: function() {
        return true;
    },
    count: function() {
        return this.array.length;
    }
});
var $7458694eb6c029d8$var$WrappedIterator = $7458694eb6c029d8$var$Iterator.inherit({
    ctor: function(iter) {
        this.iter = iter;
    },
    next: function() {
        return this.iter.next();
    },
    current: function() {
        return this.iter.current();
    },
    reset: function() {
        return this.iter.reset();
    }
});
var $7458694eb6c029d8$var$MapIterator = $7458694eb6c029d8$var$WrappedIterator.inherit({
    ctor: function(iter, mapper) {
        this.callBase(iter);
        this.index = -1;
        this.mapper = mapper;
    },
    current: function() {
        return this.mapper(this.callBase(), this.index);
    },
    next: function() {
        var hasNext = this.callBase();
        if (hasNext) this.index++;
        return hasNext;
    }
});
var $7458694eb6c029d8$var$defaultCompare = function(xValue, yValue) {
    xValue = (0, $8Cgs4.toComparable)(xValue);
    yValue = (0, $8Cgs4.toComparable)(yValue);
    if (null === xValue && null !== yValue) return -1;
    if (null !== xValue && null === yValue) return 1;
    if (void 0 === xValue && void 0 !== yValue) return 1;
    if (void 0 !== xValue && void 0 === yValue) return -1;
    if (xValue < yValue) return -1;
    if (xValue > yValue) return 1;
    return 0;
};
var $7458694eb6c029d8$var$SortIterator = $7458694eb6c029d8$var$Iterator.inherit({
    ctor: function(iter, getter, desc, compare) {
        if (!(iter instanceof $7458694eb6c029d8$var$MapIterator)) iter = new $7458694eb6c029d8$var$MapIterator(iter, this._wrap);
        this.iter = iter;
        this.rules = [
            {
                getter: getter,
                desc: desc,
                compare: compare
            }
        ];
    },
    thenBy: function(getter, desc, compare) {
        var result = new $7458694eb6c029d8$var$SortIterator(this.sortedIter || this.iter, getter, desc, compare);
        if (!this.sortedIter) result.rules = this.rules.concat(result.rules);
        return result;
    },
    next: function() {
        this._ensureSorted();
        return this.sortedIter.next();
    },
    current: function() {
        this._ensureSorted();
        return this.sortedIter.current();
    },
    reset: function() {
        delete this.sortedIter;
    },
    countable: function() {
        return this.sortedIter || this.iter.countable();
    },
    count: function() {
        if (this.sortedIter) return this.sortedIter.count();
        return this.iter.count();
    },
    _ensureSorted: function() {
        var that = this;
        if (that.sortedIter) return;
        (0, $8OLOW.each)(that.rules, function() {
            this.getter = (0, $8Cgs4.compileGetter)(this.getter);
        });
        that.sortedIter = new $7458694eb6c029d8$var$MapIterator(new $7458694eb6c029d8$var$ArrayIterator(this.iter.toArray().sort(function(x, y) {
            return that._compare(x, y);
        })), that._unwrap);
    },
    _wrap: function(record, index) {
        return {
            index: index,
            value: record
        };
    },
    _unwrap: function(wrappedItem) {
        return wrappedItem.value;
    },
    _compare: function(x, y) {
        var xIndex = x.index;
        var yIndex = y.index;
        x = x.value;
        y = y.value;
        if (x === y) return xIndex - yIndex;
        for(var i = 0, rulesCount = this.rules.length; i < rulesCount; i++){
            var rule = this.rules[i];
            var xValue = rule.getter(x);
            var yValue = rule.getter(y);
            var compare = rule.compare || $7458694eb6c029d8$var$defaultCompare;
            var compareResult = compare(xValue, yValue);
            if (compareResult) return rule.desc ? -compareResult : compareResult;
        }
        return xIndex - yIndex;
    }
});
var $7458694eb6c029d8$var$compileCriteria = function() {
    var toString = function(value) {
        return (0, $6ntMu.isDefined)(value) ? value.toString() : "";
    };
    function compileEquals(getter, value, negate) {
        return function(obj) {
            obj = (0, $8Cgs4.toComparable)(getter(obj));
            var result = function(value) {
                return "" === value || 0 === value || false === value;
            }(value) ? obj === value : obj == value;
            if (negate) result = !result;
            return result;
        };
    }
    return function(crit) {
        if ((0, $6ntMu.isFunction)(crit)) return crit;
        if ((0, $bXwdG.isGroupCriterion)(crit)) return function(crit) {
            var ops = [];
            var isConjunctiveOperator = false;
            var isConjunctiveNextOperator = false;
            (0, $8OLOW.each)(crit, function() {
                if (Array.isArray(this) || (0, $6ntMu.isFunction)(this)) {
                    if (ops.length > 1 && isConjunctiveOperator !== isConjunctiveNextOperator) throw new (0, $5wFvO.errors).Error("E4019");
                    ops.push($7458694eb6c029d8$var$compileCriteria(this));
                    isConjunctiveOperator = isConjunctiveNextOperator;
                    isConjunctiveNextOperator = true;
                } else isConjunctiveNextOperator = (0, $bXwdG.isConjunctiveOperator)(this);
            });
            return function(d) {
                var result = isConjunctiveOperator;
                for(var i = 0; i < ops.length; i++)if (ops[i](d) !== isConjunctiveOperator) {
                    result = !isConjunctiveOperator;
                    break;
                }
                return result;
            };
        }(crit);
        if ((0, $bXwdG.isUnaryOperation)(crit)) return function(crit) {
            var op = crit[0];
            var criteria = $7458694eb6c029d8$var$compileCriteria(crit[1]);
            if ("!" === op) return function(obj) {
                return !criteria(obj);
            };
            throw (0, $5wFvO.errors).Error("E4003", op);
        }(crit);
        return function(crit) {
            crit = (0, $bXwdG.normalizeBinaryCriterion)(crit);
            var getter = (0, $8Cgs4.compileGetter)(crit[0]);
            var op = crit[1];
            var value = crit[2];
            value = (0, $8Cgs4.toComparable)(value);
            var compare = (obj, operatorFn)=>{
                obj = (0, $8Cgs4.toComparable)(getter(obj));
                return (null == value || null == obj) && value !== obj ? false : operatorFn(obj, value);
            };
            switch(op.toLowerCase()){
                case "=":
                    return compileEquals(getter, value);
                case "<>":
                    return compileEquals(getter, value, true);
                case ">":
                    return (obj)=>compare(obj, (a, b)=>a > b);
                case "<":
                    return (obj)=>compare(obj, (a, b)=>a < b);
                case ">=":
                    return (obj)=>compare(obj, (a, b)=>a >= b);
                case "<=":
                    return (obj)=>compare(obj, (a, b)=>a <= b);
                case "startswith":
                    return function(obj) {
                        return 0 === (0, $8Cgs4.toComparable)(toString(getter(obj))).indexOf(value);
                    };
                case "endswith":
                    return function(obj) {
                        var getterValue = (0, $8Cgs4.toComparable)(toString(getter(obj)));
                        var searchValue = toString(value);
                        if (getterValue.length < searchValue.length) return false;
                        var index = getterValue.lastIndexOf(value);
                        return -1 !== index && index === getterValue.length - value.length;
                    };
                case "contains":
                    return function(obj) {
                        return (0, $8Cgs4.toComparable)(toString(getter(obj))).indexOf(value) > -1;
                    };
                case "notcontains":
                    return function(obj) {
                        return -1 === (0, $8Cgs4.toComparable)(toString(getter(obj))).indexOf(value);
                    };
            }
            throw (0, $5wFvO.errors).Error("E4003", op);
        }(crit);
    };
}();
var $7458694eb6c029d8$var$FilterIterator = $7458694eb6c029d8$var$WrappedIterator.inherit({
    ctor: function(iter, criteria) {
        this.callBase(iter);
        this.criteria = $7458694eb6c029d8$var$compileCriteria(criteria);
    },
    next: function() {
        while(this.iter.next()){
            if (this.criteria(this.current())) return true;
        }
        return false;
    }
});
var $7458694eb6c029d8$var$GroupIterator = $7458694eb6c029d8$var$Iterator.inherit({
    ctor: function(iter, getter) {
        this.iter = iter;
        this.getter = getter;
    },
    next: function() {
        this._ensureGrouped();
        return this.groupedIter.next();
    },
    current: function() {
        this._ensureGrouped();
        return this.groupedIter.current();
    },
    reset: function() {
        delete this.groupedIter;
    },
    countable: function() {
        return !!this.groupedIter;
    },
    count: function() {
        return this.groupedIter.count();
    },
    _ensureGrouped: function() {
        if (this.groupedIter) return;
        var hash = {};
        var keys = [];
        var iter = this.iter;
        var getter = (0, $8Cgs4.compileGetter)(this.getter);
        iter.reset();
        while(iter.next()){
            var current = iter.current();
            var key = getter(current);
            if (key in hash) hash[key].push(current);
            else {
                hash[key] = [
                    current
                ];
                keys.push(key);
            }
        }
        this.groupedIter = new $7458694eb6c029d8$var$ArrayIterator((0, $8OLOW.map)(keys, function(key) {
            return {
                key: key,
                items: hash[key]
            };
        }));
    }
});
var $7458694eb6c029d8$var$SelectIterator = $7458694eb6c029d8$var$WrappedIterator.inherit({
    ctor: function(iter, getter) {
        this.callBase(iter);
        this.getter = (0, $8Cgs4.compileGetter)(getter);
    },
    current: function() {
        return this.getter(this.callBase());
    },
    countable: function() {
        return this.iter.countable();
    },
    count: function() {
        return this.iter.count();
    }
});
var $7458694eb6c029d8$var$SliceIterator = $7458694eb6c029d8$var$WrappedIterator.inherit({
    ctor: function(iter, skip, take) {
        this.callBase(iter);
        this.skip = Math.max(0, skip);
        this.take = Math.max(0, take);
        this.pos = 0;
    },
    next: function() {
        if (this.pos >= this.skip + this.take) return false;
        while(this.pos < this.skip && this.iter.next())this.pos++;
        this.pos++;
        return this.iter.next();
    },
    reset: function() {
        this.callBase();
        this.pos = 0;
    },
    countable: function() {
        return this.iter.countable();
    },
    count: function() {
        return Math.min(this.iter.count() - this.skip, this.take);
    }
});
var $7458694eb6c029d8$var$arrayQueryImpl = function arrayQueryImpl(iter, queryOptions) {
    queryOptions = queryOptions || {};
    if (!(iter instanceof $7458694eb6c029d8$var$Iterator)) iter = new $7458694eb6c029d8$var$ArrayIterator(iter);
    var handleError = function(error) {
        var handler = queryOptions.errorHandler;
        if (handler) handler(error);
        (0, $5wFvO.handleError)(error);
    };
    var aggregateCore = function(aggregator) {
        var d = (new (0, $dDkff.Deferred)).fail(handleError);
        var seed;
        var step = aggregator.step;
        var finalize = aggregator.finalize;
        try {
            iter.reset();
            if ("seed" in aggregator) seed = aggregator.seed;
            else seed = iter.next() ? iter.current() : NaN;
            var accumulator = seed;
            while(iter.next())accumulator = step(accumulator, iter.current());
            d.resolve(finalize ? finalize(accumulator) : accumulator);
        } catch (x) {
            d.reject(x);
        }
        return d.promise();
    };
    var standardAggregate = function(name) {
        return aggregateCore((0, $bXwdG.aggregators)[name]);
    };
    var select = function(getter) {
        if (!(0, $6ntMu.isFunction)(getter) && !Array.isArray(getter)) getter = [].slice.call(arguments);
        return chainQuery(new $7458694eb6c029d8$var$SelectIterator(iter, getter));
    };
    var selectProp = function(name) {
        return select((0, $8Cgs4.compileGetter)(name));
    };
    function chainQuery(iter) {
        return arrayQueryImpl(iter, queryOptions);
    }
    return {
        toArray: function() {
            return iter.toArray();
        },
        enumerate: function() {
            var d = (new (0, $dDkff.Deferred)).fail(handleError);
            try {
                d.resolve(iter.toArray());
            } catch (x) {
                d.reject(x);
            }
            return d.promise();
        },
        sortBy: function(getter, desc, compare) {
            return chainQuery(new $7458694eb6c029d8$var$SortIterator(iter, getter, desc, compare));
        },
        thenBy: function(getter, desc, compare) {
            if (iter instanceof $7458694eb6c029d8$var$SortIterator) return chainQuery(iter.thenBy(getter, desc, compare));
            throw (0, $5wFvO.errors).Error("E4004");
        },
        filter: function(criteria) {
            if (!Array.isArray(criteria)) criteria = [].slice.call(arguments);
            return chainQuery(new $7458694eb6c029d8$var$FilterIterator(iter, criteria));
        },
        slice: function(skip, take) {
            if (void 0 === take) take = Number.MAX_VALUE;
            return chainQuery(new $7458694eb6c029d8$var$SliceIterator(iter, skip, take));
        },
        select: select,
        groupBy: function(getter) {
            return chainQuery(new $7458694eb6c029d8$var$GroupIterator(iter, getter));
        },
        aggregate: function(seed, step, finalize) {
            if (arguments.length < 2) return aggregateCore({
                step: arguments[0]
            });
            return aggregateCore({
                seed: seed,
                step: step,
                finalize: finalize
            });
        },
        count: function() {
            if (iter.countable()) {
                var d = (new (0, $dDkff.Deferred)).fail(handleError);
                try {
                    d.resolve(iter.count());
                } catch (x) {
                    d.reject(x);
                }
                return d.promise();
            }
            return standardAggregate("count");
        },
        sum: function(getter) {
            if (getter) return selectProp(getter).sum();
            return standardAggregate("sum");
        },
        min: function(getter) {
            if (getter) return selectProp(getter).min();
            return standardAggregate("min");
        },
        max: function(getter) {
            if (getter) return selectProp(getter).max();
            return standardAggregate("max");
        },
        avg: function(getter) {
            if (getter) return selectProp(getter).avg();
            return standardAggregate("avg");
        }
    };
};
var $7458694eb6c029d8$export$2e2bcd8739ae039 = $7458694eb6c029d8$var$arrayQueryImpl;

});




parcelRegister("4sqTC", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $33eea3ee8c4f1958$export$185802fd694ee1f5; });
/**
 * DevExtreme (esm/core/utils/queue.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $cvYFL = parcelRequire("cvYFL");

var $dDkff = parcelRequire("dDkff");
function $33eea3ee8c4f1958$export$185802fd694ee1f5(discardPendingTasks) {
    var _tasks = [];
    var _busy = false;
    function exec() {
        while(_tasks.length){
            _busy = true;
            var task = _tasks.shift();
            var result = task();
            if (void 0 === result) continue;
            if (result.then) {
                (0, $dDkff.when)(result).always(exec);
                return;
            }
            throw (0, $cvYFL.default).Error("E0015");
        }
        _busy = false;
    }
    return {
        add: function(task, removeTaskCallback) {
            if (!discardPendingTasks) _tasks.push(task);
            else {
                if (_tasks[0] && removeTaskCallback) removeTaskCallback(_tasks[0]);
                _tasks = [
                    task
                ];
            }
            if (!_busy) exec();
        },
        busy: function() {
            return _busy;
        }
    };
}
var $33eea3ee8c4f1958$export$513072ba72100d9c = $33eea3ee8c4f1958$export$185802fd694ee1f5().add;

});

parcelRegister("2heqD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a885c8832d54f5f$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/data/data_source/operation_manager.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2xD6m = parcelRequire("2xD6m");
class $1a885c8832d54f5f$export$2e2bcd8739ae039 {
    constructor(){
        this._counter = -1;
        this._deferreds = {};
    }
    add(deferred) {
        this._counter++;
        this._deferreds[this._counter] = deferred;
        return this._counter;
    }
    remove(operationId) {
        return delete this._deferreds[operationId];
    }
    cancel(operationId) {
        if (operationId in this._deferreds) {
            this._deferreds[operationId].reject((0, $2xD6m.CANCELED_TOKEN));
            return true;
        }
        return false;
    }
    cancelAll() {
        while(this._counter > -1){
            this.cancel(this._counter);
            this._counter--;
        }
    }
}

});
parcelRegister("2xD6m", function(module, exports) {

$parcel$export(module.exports, "CANCELED_TOKEN", function () { return $1d9cfe9fa7bbacda$export$26f77cefc5e83a13; });
$parcel$export(module.exports, "isPending", function () { return $1d9cfe9fa7bbacda$export$872dec21e9a69476; });
$parcel$export(module.exports, "normalizeStoreLoadOptionAccessorArguments", function () { return $1d9cfe9fa7bbacda$export$c741248c4dd9504f; });
$parcel$export(module.exports, "mapDataRespectingGrouping", function () { return $1d9cfe9fa7bbacda$export$6df46f28ca6f7a22; });
$parcel$export(module.exports, "normalizeLoadResult", function () { return $1d9cfe9fa7bbacda$export$39a9f23879314f2b; });
$parcel$export(module.exports, "normalizeDataSourceOptions", function () { return $1d9cfe9fa7bbacda$export$b542b8cb4d19a8a8; });
/**
 * DevExtreme (esm/data/data_source/utils.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $8DG5X = parcelRequire("8DG5X");

var $aXXVC = parcelRequire("aXXVC");

var $6fWjf = parcelRequire("6fWjf");

var $8OLOW = parcelRequire("8OLOW");

var $8uHJZ = parcelRequire("8uHJZ");

var $2oTOp = parcelRequire("2oTOp");

var $6ntMu = parcelRequire("6ntMu");

var $bXwdG = parcelRequire("bXwdG");
var $1d9cfe9fa7bbacda$var$_excluded = [
    "items"
];
var $1d9cfe9fa7bbacda$export$26f77cefc5e83a13 = "canceled";
var $1d9cfe9fa7bbacda$export$872dec21e9a69476 = (deferred)=>"pending" === deferred.state();
var $1d9cfe9fa7bbacda$export$c741248c4dd9504f = (originalArguments)=>{
    switch(originalArguments.length){
        case 0:
            return;
        case 1:
            return originalArguments[0];
    }
    return [].slice.call(originalArguments);
};
var $1d9cfe9fa7bbacda$var$mapGroup = (group, level, mapper)=>(0, $8OLOW.map)(group, (item)=>{
        var restItem = (0, $hCIyK.default)(item, $1d9cfe9fa7bbacda$var$_excluded);
        return (0, $4WYaH.default)({}, restItem, {
            items: $1d9cfe9fa7bbacda$var$mapRecursive(item.items, level - 1, mapper)
        });
    });
var $1d9cfe9fa7bbacda$var$mapRecursive = (items, level, mapper)=>{
    if (!Array.isArray(items)) return items;
    return level ? $1d9cfe9fa7bbacda$var$mapGroup(items, level, mapper) : (0, $8OLOW.map)(items, mapper);
};
var $1d9cfe9fa7bbacda$export$6df46f28ca6f7a22 = (items, mapper, groupInfo)=>{
    var level = groupInfo ? (0, $bXwdG.normalizeSortingInfo)(groupInfo).length : 0;
    return $1d9cfe9fa7bbacda$var$mapRecursive(items, level, mapper);
};
var $1d9cfe9fa7bbacda$export$39a9f23879314f2b = (data, extra)=>{
    var _data;
    if (null !== (_data = data) && void 0 !== _data && _data.data) {
        extra = data;
        data = data.data;
    }
    if (!Array.isArray(data)) data = [
        data
    ];
    return {
        data: data,
        extra: extra
    };
};
var $1d9cfe9fa7bbacda$var$createCustomStoreFromLoadFunc = (options)=>{
    var storeConfig = {};
    (0, $8OLOW.each)([
        "useDefaultSearch",
        "key",
        "load",
        "loadMode",
        "cacheRawData",
        "byKey",
        "lookup",
        "totalCount",
        "insert",
        "update",
        "remove"
    ], function() {
        storeConfig[this] = options[this];
        delete options[this];
    });
    return new (0, $8uHJZ.default)(storeConfig);
};
var $1d9cfe9fa7bbacda$var$createStoreFromConfig = (storeConfig)=>{
    var alias = storeConfig.type;
    delete storeConfig.type;
    return (0, $aXXVC.default).create(alias, storeConfig);
};
var $1d9cfe9fa7bbacda$var$createCustomStoreFromUrl = (url, normalizationOptions)=>new (0, $8uHJZ.default)({
        load: ()=>(0, $8DG5X.default).sendRequest({
                url: url,
                dataType: "json"
            }),
        loadMode: null === normalizationOptions || void 0 === normalizationOptions ? void 0 : normalizationOptions.fromUrlLoadMode
    });
var $1d9cfe9fa7bbacda$export$b542b8cb4d19a8a8 = (options, normalizationOptions)=>{
    var store;
    if ("string" === typeof options) options = {
        paginate: false,
        store: $1d9cfe9fa7bbacda$var$createCustomStoreFromUrl(options, normalizationOptions)
    };
    if (void 0 === options) options = [];
    if (Array.isArray(options) || options instanceof (0, $aXXVC.default)) options = {
        store: options
    };
    else options = (0, $2oTOp.extend)({}, options);
    if (void 0 === options.store) options.store = [];
    store = options.store;
    if ("load" in options) store = $1d9cfe9fa7bbacda$var$createCustomStoreFromLoadFunc(options);
    else if (Array.isArray(store)) store = new (0, $6fWjf.default)(store);
    else if ((0, $6ntMu.isPlainObject)(store)) store = $1d9cfe9fa7bbacda$var$createStoreFromConfig((0, $2oTOp.extend)({}, store));
    options.store = store;
    return options;
};

});
parcelRegister("8DG5X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64a29e6eee653186$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/utils/ajax.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $dDkff = parcelRequire("dDkff");

var $3yzYM = parcelRequire("3yzYM");

var $8epHo = parcelRequire("8epHo");

var $hYatw = parcelRequire("hYatw");

var $2oTOp = parcelRequire("2oTOp");

var $6ntMu = parcelRequire("6ntMu");

var $5Nras = parcelRequire("5Nras");
var $64a29e6eee653186$var$window = (0, $hYatw.getWindow)();
var $64a29e6eee653186$var$SUCCESS = "success";
var $64a29e6eee653186$var$ERROR = "error";
var $64a29e6eee653186$var$TIMEOUT = "timeout";
var $64a29e6eee653186$var$NO_CONTENT = "nocontent";
var $64a29e6eee653186$var$PARSER_ERROR = "parsererror";
var $64a29e6eee653186$var$isStatusSuccess = function(status) {
    return 200 <= status && status < 300;
};
var $64a29e6eee653186$var$hasContent = function(status) {
    return 204 !== status;
};
var $64a29e6eee653186$var$paramsConvert = function(params) {
    var result = [];
    for(var name in params){
        var value = params[name];
        if (void 0 === value) continue;
        if (null === value) value = "";
        if ("function" === typeof value) value = value();
        result.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
    }
    return result.join("&");
};
var $64a29e6eee653186$var$createScript = function(options) {
    var script = (0, $3yzYM.default).createElement("script");
    for(var name in options)script[name] = options[name];
    return script;
};
var $64a29e6eee653186$var$removeScript = function(scriptNode) {
    scriptNode.parentNode.removeChild(scriptNode);
};
var $64a29e6eee653186$var$appendToHead = function(element) {
    return (0, $3yzYM.default).getHead().appendChild(element);
};
var $64a29e6eee653186$var$evalScript = function(code) {
    var script = $64a29e6eee653186$var$createScript({
        text: code
    });
    $64a29e6eee653186$var$appendToHead(script);
    $64a29e6eee653186$var$removeScript(script);
};
var $64a29e6eee653186$var$evalCrossDomainScript = function(url) {
    var script = $64a29e6eee653186$var$createScript({
        src: url
    });
    return new Promise(function(resolve, reject) {
        var events = {
            load: resolve,
            error: reject
        };
        var loadHandler = function(e) {
            events[e.type]();
            $64a29e6eee653186$var$removeScript(script);
        };
        for(var event in events)(0, $3yzYM.default).listen(script, event, loadHandler);
        $64a29e6eee653186$var$appendToHead(script);
    });
};
var $64a29e6eee653186$var$getAcceptHeader = function(options) {
    var dataType = options.dataType || "*";
    var scriptAccept = "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript";
    var accepts = {
        "*": "*/*",
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript",
        jsonp: scriptAccept,
        script: scriptAccept
    };
    (0, $2oTOp.extendFromObject)(accepts, options.accepts, true);
    return accepts[dataType] ? accepts[dataType] + ("*" !== dataType ? ", */*; q=0.01" : "") : accepts["*"];
};
var $64a29e6eee653186$var$getContentTypeHeader = function(options) {
    var defaultContentType;
    if (options.data && !options.upload && "GET" !== $64a29e6eee653186$var$getMethod(options)) defaultContentType = "application/x-www-form-urlencoded;charset=utf-8";
    return options.contentType || defaultContentType;
};
var $64a29e6eee653186$var$getDataFromResponse = function(xhr) {
    return xhr.responseType && "text" !== xhr.responseType || "string" !== typeof xhr.responseText ? xhr.response : xhr.responseText;
};
var $64a29e6eee653186$var$postProcess = function(deferred, xhr, dataType) {
    var data = $64a29e6eee653186$var$getDataFromResponse(xhr);
    switch(dataType){
        case "jsonp":
            $64a29e6eee653186$var$evalScript(data);
            break;
        case "script":
            $64a29e6eee653186$var$evalScript(data);
            deferred.resolve(data, $64a29e6eee653186$var$SUCCESS, xhr);
            break;
        case "json":
            try {
                deferred.resolve(JSON.parse(data), $64a29e6eee653186$var$SUCCESS, xhr);
            } catch (e) {
                deferred.reject(xhr, $64a29e6eee653186$var$PARSER_ERROR, e);
            }
            break;
        default:
            deferred.resolve(data, $64a29e6eee653186$var$SUCCESS, xhr);
    }
};
var $64a29e6eee653186$var$isCrossDomain = function(url) {
    if (!(0, $hYatw.hasWindow)()) return true;
    var crossDomain = false;
    var originAnchor = (0, $3yzYM.default).createElement("a");
    var urlAnchor = (0, $3yzYM.default).createElement("a");
    originAnchor.href = $64a29e6eee653186$var$window.location.href;
    try {
        urlAnchor.href = url;
        urlAnchor.href = urlAnchor.href;
        crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
    } catch (e) {
        crossDomain = true;
    }
    return crossDomain;
};
var $64a29e6eee653186$var$setHttpTimeout = function(timeout, xhr) {
    return timeout && setTimeout(function() {
        xhr.customStatus = $64a29e6eee653186$var$TIMEOUT;
        xhr.abort();
    }, timeout);
};
var $64a29e6eee653186$var$getJsonpOptions = function(options) {
    if ("jsonp" === options.dataType) {
        var random = Math.random().toString().replace(/\D/g, "");
        var callbackName = options.jsonpCallback || "dxCallback" + Date.now() + "_" + random;
        var callbackParameter = options.jsonp || "callback";
        options.data = options.data || {};
        options.data[callbackParameter] = callbackName;
        return callbackName;
    }
};
var $64a29e6eee653186$var$getRequestOptions = function(options, headers) {
    var params = options.data;
    var paramsAlreadyString = "string" === typeof params;
    var url = options.url || $64a29e6eee653186$var$window.location.href;
    if (!paramsAlreadyString && !options.cache) {
        params = params || {};
        params._ = Date.now();
    }
    if (params && !options.upload) {
        if (!paramsAlreadyString) params = $64a29e6eee653186$var$paramsConvert(params);
        if ("GET" === $64a29e6eee653186$var$getMethod(options)) {
            if ("" !== params) url += (url.indexOf("?") > -1 ? "&" : "?") + params;
            params = null;
        } else if (headers["Content-Type"] && headers["Content-Type"].indexOf("application/x-www-form-urlencoded") > -1) params = params.replace(/%20/g, "+");
    }
    return {
        url: url,
        parameters: params
    };
};
function $64a29e6eee653186$var$getMethod(options) {
    return (options.method || "GET").toUpperCase();
}
var $64a29e6eee653186$var$getRequestHeaders = function(options) {
    var headers = options.headers || {};
    headers["Content-Type"] = headers["Content-Type"] || $64a29e6eee653186$var$getContentTypeHeader(options);
    headers.Accept = headers.Accept || $64a29e6eee653186$var$getAcceptHeader(options);
    if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
    return headers;
};
var $64a29e6eee653186$var$sendRequest = function(options) {
    var xhr = (0, $8epHo.default).getXhr();
    var d = new (0, $dDkff.Deferred);
    var result = d.promise();
    var async = (0, $6ntMu.isDefined)(options.async) ? options.async : true;
    var dataType = options.dataType;
    var timeout = options.timeout || 0;
    var timeoutId;
    options.crossDomain = $64a29e6eee653186$var$isCrossDomain(options.url);
    var needScriptEvaluation = "jsonp" === dataType || "script" === dataType;
    if (void 0 === options.cache) options.cache = !needScriptEvaluation;
    var callbackName = $64a29e6eee653186$var$getJsonpOptions(options);
    var headers = $64a29e6eee653186$var$getRequestHeaders(options);
    var requestOptions = $64a29e6eee653186$var$getRequestOptions(options, headers);
    var url = requestOptions.url;
    var parameters = requestOptions.parameters;
    if (callbackName) $64a29e6eee653186$var$window[callbackName] = function(data) {
        d.resolve(data, $64a29e6eee653186$var$SUCCESS, xhr);
    };
    if (options.crossDomain && needScriptEvaluation) {
        $64a29e6eee653186$var$evalCrossDomainScript(url).then(function() {
            if ("jsonp" === dataType) return;
            d.resolve(null, $64a29e6eee653186$var$SUCCESS, xhr);
        }, function() {
            d.reject(xhr, $64a29e6eee653186$var$ERROR);
        });
        return result;
    }
    if (options.crossDomain && !("withCredentials" in xhr)) {
        d.reject(xhr, $64a29e6eee653186$var$ERROR);
        return result;
    }
    xhr.open($64a29e6eee653186$var$getMethod(options), url, async, options.username, options.password);
    if (async) {
        xhr.timeout = timeout;
        timeoutId = $64a29e6eee653186$var$setHttpTimeout(timeout, xhr);
    }
    xhr.onreadystatechange = function(e) {
        if (4 === xhr.readyState) {
            clearTimeout(timeoutId);
            if ($64a29e6eee653186$var$isStatusSuccess(xhr.status)) {
                if ($64a29e6eee653186$var$hasContent(xhr.status)) $64a29e6eee653186$var$postProcess(d, xhr, dataType);
                else d.resolve(null, $64a29e6eee653186$var$NO_CONTENT, xhr);
            } else d.reject(xhr, xhr.customStatus || $64a29e6eee653186$var$ERROR);
        }
    };
    if (options.upload) {
        xhr.upload.onprogress = options.upload.onprogress;
        xhr.upload.onloadstart = options.upload.onloadstart;
        xhr.upload.onabort = options.upload.onabort;
    }
    if (options.xhrFields) for(var field in options.xhrFields)xhr[field] = options.xhrFields[field];
    if ("arraybuffer" === options.responseType) xhr.responseType = options.responseType;
    for(var name in headers)if (Object.prototype.hasOwnProperty.call(headers, name) && (0, $6ntMu.isDefined)(headers[name])) xhr.setRequestHeader(name, headers[name]);
    if (options.beforeSend) options.beforeSend(xhr);
    xhr.send(parameters);
    result.abort = function() {
        xhr.abort();
    };
    return result;
};
var $64a29e6eee653186$export$2e2bcd8739ae039 = (0, $5Nras.default)({
    sendRequest: $64a29e6eee653186$var$sendRequest
});

});
parcelRegister("8epHo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fe390c65f010371$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/http_request.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $hYatw = parcelRequire("hYatw");

var $5Nras = parcelRequire("5Nras");
var $5fe390c65f010371$var$window = (0, $hYatw.getWindow)();
var $5fe390c65f010371$var$nativeXMLHttpRequest = {
    getXhr: function() {
        return new $5fe390c65f010371$var$window.XMLHttpRequest;
    }
};
var $5fe390c65f010371$export$2e2bcd8739ae039 = (0, $5Nras.default)($5fe390c65f010371$var$nativeXMLHttpRequest);

});


parcelRegister("6fWjf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48e15fd8dea90354$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/data/array_store.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $bXwdG = parcelRequire("bXwdG");

var $jxMhc = parcelRequire("jxMhc");

var $5wFvO = parcelRequire("5wFvO");

var $aXXVC = parcelRequire("aXXVC");

var $7ZQfQ = parcelRequire("7ZQfQ");
var $48e15fd8dea90354$var$ArrayStore = (0, $aXXVC.default).inherit({
    ctor: function(options) {
        if (Array.isArray(options)) options = {
            data: options
        };
        else options = options || {};
        this.callBase(options);
        var initialArray = options.data;
        if (initialArray && !Array.isArray(initialArray)) throw (0, $5wFvO.errors).Error("E4006");
        this._array = initialArray || [];
    },
    createQuery: function() {
        return (0, $jxMhc.default)(this._array, {
            errorHandler: this._errorHandler
        });
    },
    _byKeyImpl: function(key) {
        var index = (0, $7ZQfQ.indexByKey)(this, this._array, key);
        if (-1 === index) return (0, $bXwdG.rejectedPromise)((0, $5wFvO.errors).Error("E4009"));
        return (0, $bXwdG.trivialPromise)(this._array[index]);
    },
    _insertImpl: function(values) {
        return (0, $7ZQfQ.insert)(this, this._array, values);
    },
    _pushImpl: function(changes) {
        (0, $7ZQfQ.applyBatch)({
            keyInfo: this,
            data: this._array,
            changes: changes
        });
    },
    _updateImpl: function(key, values) {
        return (0, $7ZQfQ.update)(this, this._array, key, values);
    },
    _removeImpl: function(key) {
        return (0, $7ZQfQ.remove)(this, this._array, key);
    },
    clear: function() {
        this._eventsStrategy.fireEvent("modifying");
        this._array = [];
        this._eventsStrategy.fireEvent("modified");
    }
}, "array");
var $48e15fd8dea90354$export$2e2bcd8739ae039 = $48e15fd8dea90354$var$ArrayStore;

});
parcelRegister("jxMhc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3a68c0f703ac5ba$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/data/query.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $fOxet = parcelRequire("fOxet");
var $e3a68c0f703ac5ba$var$query = function() {
    var impl = Array.isArray(arguments[0]) ? "array" : "remote";
    return (0, $fOxet.queryImpl)[impl].apply(this, arguments);
};
var $e3a68c0f703ac5ba$export$2e2bcd8739ae039 = $e3a68c0f703ac5ba$var$query;

});
parcelRegister("fOxet", function(module, exports) {

$parcel$export(module.exports, "queryImpl", function () { return $b8354dce4ad1adff$export$e04e0533a723bd3b; });
/**
 * DevExtreme (esm/data/query_implementation.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $9ZiP3 = parcelRequire("9ZiP3");

var $7mfoz = parcelRequire("7mfoz");
var $b8354dce4ad1adff$export$e04e0533a723bd3b = {
    array: (0, $9ZiP3.default),
    remote: (0, $7mfoz.default)
};

});
parcelRegister("7mfoz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55b687a67d524bbf$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/data/remote_query.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $cxDte = parcelRequire("cxDte");

var $5wFvO = parcelRequire("5wFvO");

var $8OLOW = parcelRequire("8OLOW");

var $6ntMu = parcelRequire("6ntMu");

var $dDkff = parcelRequire("dDkff");

var $9ZiP3 = parcelRequire("9ZiP3");
var $55b687a67d524bbf$var$remoteQueryImpl = function remoteQueryImpl(url, queryOptions, tasks) {
    tasks = tasks || [];
    queryOptions = queryOptions || {};
    var createTask = function(name, args) {
        return {
            name: name,
            args: args
        };
    };
    var exec = function(executorTask) {
        var d = new (0, $dDkff.Deferred);
        var _adapterFactory;
        var _adapter;
        var _taskQueue;
        var _currentTask;
        var _mergedSortArgs;
        var rejectWithNotify = function(error) {
            var handler = queryOptions.errorHandler;
            if (handler) handler(error);
            (0, $5wFvO.handleError)(error);
            d.reject(error);
        };
        function mergeSortTask(task) {
            switch(task.name){
                case "sortBy":
                    _mergedSortArgs = [
                        task.args
                    ];
                    return true;
                case "thenBy":
                    if (!_mergedSortArgs) throw (0, $5wFvO.errors).Error("E4004");
                    _mergedSortArgs.push(task.args);
                    return true;
            }
            return false;
        }
        try {
            _adapterFactory = queryOptions.adapter;
            if (!(0, $6ntMu.isFunction)(_adapterFactory)) _adapterFactory = (0, $cxDte.default)[_adapterFactory];
            _adapter = _adapterFactory(queryOptions);
            _taskQueue = [].concat(tasks).concat(executorTask);
            var optimize = _adapter.optimize;
            if (optimize) optimize(_taskQueue);
            while(_taskQueue.length){
                _currentTask = _taskQueue[0];
                if (!mergeSortTask(_currentTask)) {
                    if (_mergedSortArgs) {
                        _taskQueue.unshift(createTask("multiSort", [
                            _mergedSortArgs
                        ]));
                        _mergedSortArgs = null;
                        continue;
                    }
                    if ("enumerate" !== String(_currentTask.name)) {
                        if (!_adapter[_currentTask.name] || false === _adapter[_currentTask.name].apply(_adapter, _currentTask.args)) break;
                    }
                }
                _taskQueue.shift();
            }
            !function() {
                var head = _taskQueue[0];
                var unmergedTasks = [];
                if (head && "multiSort" === head.name) {
                    _taskQueue.shift();
                    (0, $8OLOW.each)(head.args[0], function() {
                        unmergedTasks.push(createTask(unmergedTasks.length ? "thenBy" : "sortBy", this));
                    });
                }
                _taskQueue = unmergedTasks.concat(_taskQueue);
            }();
            _adapter.exec(url).done(function(result, extra) {
                if (!_taskQueue.length) d.resolve(result, extra);
                else {
                    var clientChain = (0, $9ZiP3.default)(result, {
                        errorHandler: queryOptions.errorHandler
                    });
                    (0, $8OLOW.each)(_taskQueue, function() {
                        clientChain = clientChain[this.name].apply(clientChain, this.args);
                    });
                    clientChain.done(d.resolve).fail(d.reject);
                }
            }).fail(rejectWithNotify);
        } catch (x) {
            rejectWithNotify(x);
        }
        return d.promise();
    };
    var query = {};
    (0, $8OLOW.each)([
        "sortBy",
        "thenBy",
        "filter",
        "slice",
        "select",
        "groupBy"
    ], function() {
        var name = String(this);
        query[name] = function() {
            return remoteQueryImpl(url, queryOptions, tasks.concat(createTask(name, arguments)));
        };
    });
    (0, $8OLOW.each)([
        "count",
        "min",
        "max",
        "sum",
        "avg",
        "aggregate",
        "enumerate"
    ], function() {
        var name = String(this);
        query[name] = function() {
            return exec.call(this, createTask(name, arguments));
        };
    });
    return query;
};
var $55b687a67d524bbf$export$2e2bcd8739ae039 = $55b687a67d524bbf$var$remoteQueryImpl;

});
parcelRegister("cxDte", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92172f24a78207be$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/data/query_adapters.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $92172f24a78207be$export$2e2bcd8739ae039 = {};

});








parcelRegister("66sos", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $471953f566b32320$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/ui/collection/data_controller.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $gcp4g = parcelRequire("gcp4g");

var $dDkff = parcelRequire("dDkff");
var $471953f566b32320$var$DataControllerMock = {
    load: ()=>(0, $dDkff.Deferred)().reject(),
    loadSingle: ()=>(0, $dDkff.Deferred)().reject(),
    loadFromStore: ()=>(0, $dDkff.Deferred)().reject(),
    loadNextPage: ()=>(0, $dDkff.Deferred)().reject(),
    loadOptions: (0, $gcp4g.noop),
    userData: (0, $gcp4g.noop),
    cancel: (0, $gcp4g.noop),
    cancelAll: (0, $gcp4g.noop),
    filter: (0, $gcp4g.noop),
    addSearchFilter: (0, $gcp4g.noop),
    group: (0, $gcp4g.noop),
    paginate: (0, $gcp4g.noop),
    pageSize: (0, $gcp4g.noop),
    pageIndex: (0, $gcp4g.noop),
    resetDataSourcePageIndex: (0, $gcp4g.noop),
    totalCount: (0, $gcp4g.noop),
    isLastPage: (0, $gcp4g.noop),
    isLoading: (0, $gcp4g.noop),
    isLoaded: (0, $gcp4g.noop),
    searchValue: (0, $gcp4g.noop),
    searchOperation: (0, $gcp4g.noop),
    searchExpr: (0, $gcp4g.noop),
    select: (0, $gcp4g.noop),
    key: (0, $gcp4g.noop),
    keyOf: (0, $gcp4g.noop),
    store: (0, $gcp4g.noop),
    items: (0, $gcp4g.noop),
    applyMapFunction: (0, $gcp4g.noop),
    getDataSource: (0, $gcp4g.noop),
    reload: (0, $gcp4g.noop),
    on: (0, $gcp4g.noop),
    off: (0, $gcp4g.noop)
};
class $471953f566b32320$var$DataController {
    constructor(dataSource){
        if (!dataSource) return $471953f566b32320$var$DataControllerMock;
        this._dataSource = dataSource;
    }
    load() {
        return this._dataSource.load();
    }
    loadSingle(propName, propValue) {
        if (arguments.length < 2) {
            propValue = propName;
            propName = this.key();
        }
        return this._dataSource.loadSingle(propName, propValue);
    }
    loadFromStore(loadOptions) {
        return this.store().load(loadOptions);
    }
    loadNextPage() {
        this.pageIndex(1 + this.pageIndex());
        return this.load();
    }
    loadOptions() {
        return this._dataSource.loadOptions();
    }
    userData() {
        return this._dataSource._userData;
    }
    cancel(operationId) {
        this._dataSource.cancel(operationId);
    }
    cancelAll() {
        this._dataSource.cancelAll();
    }
    filter(filter) {
        return this._dataSource.filter(filter);
    }
    addSearchFilter(storeLoadOptions) {
        this._dataSource._addSearchFilter(storeLoadOptions);
    }
    group(group) {
        return this._dataSource.group(group);
    }
    paginate() {
        return this._dataSource.paginate();
    }
    pageSize() {
        return this._dataSource._pageSize;
    }
    pageIndex(pageIndex) {
        return this._dataSource.pageIndex(pageIndex);
    }
    resetDataSourcePageIndex() {
        if (this.pageIndex()) {
            this.pageIndex(0);
            this.load();
        }
    }
    totalCount() {
        return this._dataSource.totalCount();
    }
    isLastPage() {
        return this._dataSource.isLastPage() || !this._dataSource._pageSize;
    }
    isLoading() {
        return this._dataSource.isLoading();
    }
    isLoaded() {
        return this._dataSource.isLoaded();
    }
    searchValue(value) {
        if (!arguments.length) return this._dataSource.searchValue();
        return this._dataSource.searchValue(value);
    }
    searchOperation(operation) {
        return this._dataSource.searchOperation(operation);
    }
    searchExpr(expr) {
        if (!arguments.length) return this._dataSource.searchExpr();
        return this._dataSource.searchExpr(expr);
    }
    select() {
        return this._dataSource.select(...arguments);
    }
    key() {
        return this._dataSource.key();
    }
    keyOf(item) {
        return this.store().keyOf(item);
    }
    store() {
        return this._dataSource.store();
    }
    items() {
        return this._dataSource.items();
    }
    applyMapFunction(data) {
        return this._dataSource._applyMapFunction(data);
    }
    getDataSource() {
        return this._dataSource || null;
    }
    reload() {
        return this._dataSource.reload();
    }
    on(event, handler) {
        this._dataSource.on(event, handler);
    }
    off(event, handler) {
        this._dataSource.off(event, handler);
    }
}
var $471953f566b32320$export$2e2bcd8739ae039 = $471953f566b32320$var$DataController;

});



parcelRegister("5Z13B", function(module, exports) {

$parcel$export(module.exports, "plugin", function () { return $45b378275d69a3cc$export$ca524d3785e2543; });
/**
 * DevExtreme (esm/viz/core/export.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $hYatw = parcelRequire("hYatw");

var $dw9tZ = parcelRequire("dw9tZ");

var $jmNgH = parcelRequire("jmNgH");

var $com36 = parcelRequire("com36");

var $9zsY3 = parcelRequire("9zsY3");

var $6ntMu = parcelRequire("6ntMu");

var $4mP7M = parcelRequire("4mP7M");

var $kapgi = parcelRequire("kapgi");

var $cgnQR = parcelRequire("cgnQR");

var $9U2XG = parcelRequire("9U2XG");

var $iE2yv = parcelRequire("iE2yv");
var $45b378275d69a3cc$var$pointerActions = [
    (0, $cgnQR.default).down,
    (0, $cgnQR.default).move
].join(" ");
var $45b378275d69a3cc$var$BUTTON_SIZE = 35;
var $45b378275d69a3cc$var$ICON_COORDS = [
    [
        9,
        12,
        26,
        12,
        26,
        14,
        9,
        14
    ],
    [
        9,
        17,
        26,
        17,
        26,
        19,
        9,
        19
    ],
    [
        9,
        22,
        26,
        22,
        26,
        24,
        9,
        24
    ]
];
var $45b378275d69a3cc$var$LIST_PADDING_TOP = 4;
var $45b378275d69a3cc$var$LIST_WIDTH = 120;
var $45b378275d69a3cc$var$VERTICAL_TEXT_MARGIN = 8;
var $45b378275d69a3cc$var$HORIZONTAL_TEXT_MARGIN = 15;
var $45b378275d69a3cc$var$MENU_ITEM_HEIGHT = 30;
var $45b378275d69a3cc$var$LIST_STROKE_WIDTH = 1;
var $45b378275d69a3cc$var$MARGIN = 10;
var $45b378275d69a3cc$var$SHADOW_OFFSET = 2;
var $45b378275d69a3cc$var$SHADOW_BLUR = 3;
var $45b378275d69a3cc$var$DEFAULT_EXPORT_FORMAT = "PNG";
var $45b378275d69a3cc$var$ALLOWED_IMAGE_FORMATS = [
    $45b378275d69a3cc$var$DEFAULT_EXPORT_FORMAT,
    "JPEG",
    "GIF"
];
var $45b378275d69a3cc$var$ALLOWED_EXTRA_FORMATS = [
    "PDF",
    "SVG"
];
var $45b378275d69a3cc$var$EXPORT_CSS_CLASS = "dx-export-menu";
var $45b378275d69a3cc$var$A4WidthCm = "21cm";
var $45b378275d69a3cc$var$EXPORT_DATA_KEY = "export-element-type";
var $45b378275d69a3cc$var$FORMAT_DATA_KEY = "export-element-format";
var $45b378275d69a3cc$var$GET_COLOR_REGEX = /data-backgroundcolor="([^"]*)"/;
function $45b378275d69a3cc$var$getValidFormats() {
    var imageFormats = (0, $com36.image).testFormats($45b378275d69a3cc$var$ALLOWED_IMAGE_FORMATS);
    return {
        unsupported: imageFormats.unsupported,
        supported: imageFormats.supported.concat($45b378275d69a3cc$var$ALLOWED_EXTRA_FORMATS)
    };
}
function $45b378275d69a3cc$var$validateFormat(format, incidentOccurred, validFormats) {
    validFormats = validFormats || $45b378275d69a3cc$var$getValidFormats();
    format = String(format).toUpperCase();
    if (-1 !== validFormats.supported.indexOf(format)) return format;
    if (-1 !== validFormats.unsupported.indexOf(format)) incidentOccurred && incidentOccurred("W2108", [
        format
    ]);
}
function $45b378275d69a3cc$var$getCreatorFunc(format) {
    if ("SVG" === format) return (0, $com36.svg).getData;
    else if ("PDF" === format) return (0, $com36.pdf).getData;
    else return (0, $com36.image).getData;
}
function $45b378275d69a3cc$var$print(imageSrc, options) {
    var document = (0, $hYatw.getWindow)().document;
    var iFrame = document.createElement("iframe");
    iFrame.onload = $45b378275d69a3cc$var$setPrint(imageSrc, options);
    iFrame.style.position = "fixed";
    iFrame.style.width = "0";
    iFrame.style.height = "0";
    iFrame.style.right = "0";
    iFrame.style.bottom = "0";
    document.body.appendChild(iFrame);
}
function $45b378275d69a3cc$var$calculatePrintPageWidth(iFrameBody) {
    iFrameBody.style.width = $45b378275d69a3cc$var$A4WidthCm;
    var width = (0, $iE2yv.getWidth)(iFrameBody);
    iFrameBody.style.width = "";
    return width;
}
function $45b378275d69a3cc$var$setPrint(imageSrc, options) {
    return function() {
        var window = this.contentWindow;
        var img = window.document.createElement("img");
        window.document.body.appendChild(img);
        var widthRatio = $45b378275d69a3cc$var$calculatePrintPageWidth(window.document.body) / options.width;
        if (widthRatio < 1) {
            window.document.body.style.transform = "scale(".concat(widthRatio, ")");
            window.document.body.style["transform-origin"] = "0 0";
        }
        var removeFrame = ()=>{
            this.parentElement.removeChild(this);
        };
        img.addEventListener("load", ()=>{
            window.focus();
            window.print();
        });
        img.addEventListener("error", removeFrame);
        window.addEventListener("afterprint", ()=>{
            setTimeout(removeFrame, 0);
        });
        img.src = imageSrc;
    };
}
function $45b378275d69a3cc$var$getItemAttributes(options, type, itemIndex) {
    var x = $45b378275d69a3cc$var$BUTTON_SIZE - $45b378275d69a3cc$var$LIST_WIDTH;
    var y = $45b378275d69a3cc$var$BUTTON_SIZE + $45b378275d69a3cc$var$LIST_PADDING_TOP + $45b378275d69a3cc$var$LIST_STROKE_WIDTH + itemIndex * $45b378275d69a3cc$var$MENU_ITEM_HEIGHT;
    var attr = {
        rect: {
            width: $45b378275d69a3cc$var$LIST_WIDTH - 2 * $45b378275d69a3cc$var$LIST_STROKE_WIDTH,
            height: $45b378275d69a3cc$var$MENU_ITEM_HEIGHT,
            x: x + $45b378275d69a3cc$var$LIST_STROKE_WIDTH,
            y: y
        },
        text: {
            x: x + (options.rtl ? $45b378275d69a3cc$var$LIST_WIDTH - $45b378275d69a3cc$var$HORIZONTAL_TEXT_MARGIN : $45b378275d69a3cc$var$HORIZONTAL_TEXT_MARGIN),
            y: y + $45b378275d69a3cc$var$MENU_ITEM_HEIGHT - $45b378275d69a3cc$var$VERTICAL_TEXT_MARGIN
        }
    };
    if ("printing" === type) attr.separator = {
        stroke: options.button.default.borderColor,
        "stroke-width": $45b378275d69a3cc$var$LIST_STROKE_WIDTH,
        cursor: "pointer",
        sharp: "v",
        d: "M " + x + " " + (y + $45b378275d69a3cc$var$MENU_ITEM_HEIGHT - $45b378275d69a3cc$var$LIST_STROKE_WIDTH) + " L " + (x + $45b378275d69a3cc$var$LIST_WIDTH) + " " + (y + $45b378275d69a3cc$var$MENU_ITEM_HEIGHT - $45b378275d69a3cc$var$LIST_STROKE_WIDTH)
    };
    return attr;
}
function $45b378275d69a3cc$var$createMenuItem(renderer, options, settings) {
    var itemData = {};
    var type = settings.type;
    var format = settings.format;
    var attr = $45b378275d69a3cc$var$getItemAttributes(options, type, settings.itemIndex);
    var fontStyle = (0, $dw9tZ.patchFontOptions)(options.font);
    fontStyle["pointer-events"] = "none";
    var menuItem = renderer.g().attr({
        class: $45b378275d69a3cc$var$EXPORT_CSS_CLASS + "-list-item"
    });
    itemData[$45b378275d69a3cc$var$EXPORT_DATA_KEY] = type;
    if (format) itemData[$45b378275d69a3cc$var$FORMAT_DATA_KEY] = format;
    var rect = renderer.rect();
    rect.attr(attr.rect).css({
        cursor: "pointer",
        "pointer-events": "all"
    }).data(itemData);
    rect.on((0, $kapgi.start) + ".export", ()=>rect.attr({
            fill: options.button.hover.backgroundColor
        })).on((0, $kapgi.end) + ".export", ()=>rect.attr({
            fill: null
        }));
    rect.append(menuItem);
    var text = renderer.text(settings.text).css(fontStyle).attr(attr.text).append(menuItem);
    if ("printing" === type) renderer.path(null, "line").attr(attr.separator).append(menuItem);
    return {
        g: menuItem,
        rect: rect,
        resetState: ()=>rect.attr({
                fill: null
            }),
        fixPosition: ()=>{
            var textBBox = text.getBBox();
            text.move(attr.text.x - textBBox.x - (options.rtl ? textBBox.width : 0));
        }
    };
}
function $45b378275d69a3cc$var$createMenuItems(renderer, options) {
    var items = [];
    if (options.printingEnabled) items.push($45b378275d69a3cc$var$createMenuItem(renderer, options, {
        type: "printing",
        text: (0, $9zsY3.default).format("vizExport-printingButtonText"),
        itemIndex: items.length
    }));
    items = options.formats.reduce((r, format)=>{
        r.push($45b378275d69a3cc$var$createMenuItem(renderer, options, {
            type: "exporting",
            text: (0, $9zsY3.default).getFormatter("vizExport-exportButtonText")(format),
            format: format,
            itemIndex: r.length
        }));
        return r;
    }, items);
    return items;
}
function $45b378275d69a3cc$var$getBackgroundColorFromMarkup(markup) {
    var parsedMarkup = $45b378275d69a3cc$var$GET_COLOR_REGEX.exec(markup);
    return null === parsedMarkup || void 0 === parsedMarkup ? void 0 : parsedMarkup[1];
}
var $45b378275d69a3cc$export$7d0716557f33d8b = function(markup, options) {
    options.format = $45b378275d69a3cc$var$validateFormat(options.format) || $45b378275d69a3cc$var$DEFAULT_EXPORT_FORMAT;
    options.fileName = options.fileName || "file";
    options.exportingAction = options.onExporting;
    options.exportedAction = options.onExported;
    options.fileSavingAction = options.onFileSaving;
    options.margin = (0, $6ntMu.isDefined)(options.margin) ? options.margin : $45b378275d69a3cc$var$MARGIN;
    options.backgroundColor = (0, $6ntMu.isDefined)(options.backgroundColor) ? options.backgroundColor : $45b378275d69a3cc$var$getBackgroundColorFromMarkup(markup) || (0, $4mP7M.getTheme)().backgroundColor;
    (0, $com36.export)(markup, options, $45b378275d69a3cc$var$getCreatorFunc(options.format));
};
var $45b378275d69a3cc$export$6262ac39523f95f2 = (widgets)=>$45b378275d69a3cc$export$aaf516b063ad0849(widgets).markup;
var $45b378275d69a3cc$export$cf5175cc419cb23 = function(widgets, options) {
    options = options || {};
    var markupInfo = $45b378275d69a3cc$export$aaf516b063ad0849(widgets, {
        gridLayout: options.gridLayout,
        verticalAlignment: options.verticalAlignment,
        horizontalAlignment: options.horizontalAlignment
    });
    options.width = markupInfo.width;
    options.height = markupInfo.height;
    $45b378275d69a3cc$export$7d0716557f33d8b(markupInfo.markup, options);
};
var $45b378275d69a3cc$export$aaf516b063ad0849 = function(widgets) {
    var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    if (!Array.isArray(widgets)) widgets = [
        [
            widgets
        ]
    ];
    else if (!Array.isArray(widgets[0])) widgets = widgets.map((item)=>[
            item
        ]);
    var compactView = !options.gridLayout;
    var exportItems = widgets.reduce((r, row, rowIndex)=>{
        var rowInfo = row.reduce((r, item, colIndex)=>{
            var size = item.getSize();
            var backgroundColor = item.option("backgroundColor") || (0, $4mP7M.getTheme)(item.option("theme")).backgroundColor;
            backgroundColor && -1 === r.backgroundColors.indexOf(backgroundColor) && r.backgroundColors.push(backgroundColor);
            r.hOffset = r.width;
            r.width += size.width;
            r.height = Math.max(r.height, size.height);
            r.itemWidth = Math.max(r.itemWidth, size.width);
            r.items.push({
                markup: item.svg(),
                width: size.width,
                height: size.height,
                c: colIndex,
                r: rowIndex,
                hOffset: r.hOffset
            });
            return r;
        }, {
            items: [],
            height: 0,
            itemWidth: 0,
            hOffset: 0,
            width: 0,
            backgroundColors: r.backgroundColors
        });
        r.rowOffsets.push(r.totalHeight);
        r.rowHeights.push(rowInfo.height);
        r.totalHeight += rowInfo.height;
        r.items = r.items.concat(rowInfo.items);
        r.itemWidth = Math.max(r.itemWidth, rowInfo.itemWidth);
        r.maxItemLen = Math.max(r.maxItemLen, rowInfo.items.length);
        r.totalWidth = compactView ? Math.max(r.totalWidth, rowInfo.width) : r.maxItemLen * r.itemWidth;
        return r;
    }, {
        items: [],
        rowOffsets: [],
        rowHeights: [],
        itemWidth: 0,
        totalHeight: 0,
        maxItemLen: 0,
        totalWidth: 0,
        backgroundColors: []
    });
    var backgroundColor = 'data-backgroundcolor="'.concat(1 === exportItems.backgroundColors.length ? exportItems.backgroundColors[0] : "", '" ');
    var getVOffset = (item)=>{
        var align = options.verticalAlignment;
        var dy = exportItems.rowHeights[item.r] - item.height;
        return exportItems.rowOffsets[item.r] + ("bottom" === align ? dy : "center" === align ? dy / 2 : 0);
    };
    var getHOffset = (item)=>{
        if (compactView) return item.hOffset;
        var align = options.horizontalAlignment;
        var colWidth = exportItems.itemWidth;
        var dx = colWidth - item.width;
        return item.c * colWidth + ("right" === align ? dx : "center" === align ? dx / 2 : 0);
    };
    var totalHeight = exportItems.totalHeight;
    var totalWidth = exportItems.totalWidth;
    return {
        markup: "<svg " + backgroundColor + 'height="' + totalHeight + '" width="' + totalWidth + '" version="1.1" xmlns="http://www.w3.org/2000/svg">' + exportItems.items.map((item)=>'<g transform="translate('.concat(getHOffset(item), ",").concat(getVOffset(item), ')">').concat(item.markup, "</g>")).join("") + "</svg>",
        width: totalWidth,
        height: totalHeight
    };
};
var $45b378275d69a3cc$export$f962f50fb774e224 = function(params) {
    var renderer = this._renderer = params.renderer;
    this._incidentOccurred = params.incidentOccurred;
    this._exportTo = params.exportTo;
    this._print = params.print;
    this._shadow = renderer.shadowFilter("-50%", "-50%", "200%", "200%", $45b378275d69a3cc$var$SHADOW_OFFSET, 6, $45b378275d69a3cc$var$SHADOW_BLUR);
    this._shadow.attr({
        opacity: .8
    });
    this._group = renderer.g().attr({
        class: $45b378275d69a3cc$var$EXPORT_CSS_CLASS,
        [(0, $jmNgH.HIDDEN_FOR_EXPORT)]: true
    }).linkOn(renderer.root, {
        name: "export-menu",
        after: "peripheral"
    });
    this._buttonGroup = renderer.g().attr({
        class: $45b378275d69a3cc$var$EXPORT_CSS_CLASS + "-button"
    }).append(this._group);
    this._listGroup = renderer.g().attr({
        class: $45b378275d69a3cc$var$EXPORT_CSS_CLASS + "-list"
    }).append(this._group);
    this._overlay = renderer.rect(-$45b378275d69a3cc$var$LIST_WIDTH + $45b378275d69a3cc$var$BUTTON_SIZE, $45b378275d69a3cc$var$BUTTON_SIZE + $45b378275d69a3cc$var$LIST_PADDING_TOP, $45b378275d69a3cc$var$LIST_WIDTH, 0);
    this._overlay.attr({
        "stroke-width": $45b378275d69a3cc$var$LIST_STROKE_WIDTH,
        cursor: "pointer",
        rx: 4,
        ry: 4,
        filter: this._shadow.id
    });
    this._overlay.data({
        "export-element-type": "list"
    });
    this.validFormats = $45b378275d69a3cc$var$getValidFormats();
    this._subscribeEvents();
};
(0, $2oTOp.extend)($45b378275d69a3cc$export$f962f50fb774e224.prototype, {
    getLayoutOptions () {
        if (this._hiddenDueToLayout) return {
            width: 0,
            height: 0,
            cutSide: "vertical",
            cutLayoutSide: "top"
        };
        var bBox = this._buttonGroup.getBBox();
        bBox.cutSide = "vertical";
        bBox.cutLayoutSide = "top";
        bBox.height += $45b378275d69a3cc$var$MARGIN;
        bBox.position = {
            vertical: "top",
            horizontal: "right"
        };
        bBox.verticalAlignment = "top";
        bBox.horizontalAlignment = "right";
        return bBox;
    },
    shift (_, y) {
        this._group.attr({
            translateY: this._group.attr("translateY") + y
        });
    },
    draw (width, height, canvas) {
        this._group.move(width - $45b378275d69a3cc$var$BUTTON_SIZE - $45b378275d69a3cc$var$SHADOW_OFFSET - $45b378275d69a3cc$var$SHADOW_BLUR + canvas.left, Math.floor(height / 2 - $45b378275d69a3cc$var$BUTTON_SIZE / 2));
        var layoutOptions = this.getLayoutOptions();
        if (layoutOptions.width > width || layoutOptions.height > height) this.freeSpace();
        return this;
    },
    show () {
        this._group.linkAppend();
    },
    hide () {
        this._group.linkRemove();
    },
    setOptions (options) {
        this._options = options;
        if (options.formats) options.formats = options.formats.reduce((r, format)=>{
            format = $45b378275d69a3cc$var$validateFormat(format, this._incidentOccurred, this.validFormats);
            format && r.push(format);
            return r;
        }, []);
        else options.formats = this.validFormats.supported.slice();
        options.printingEnabled = void 0 === options.printingEnabled ? true : options.printingEnabled;
        if (options.enabled && (options.formats.length || options.printingEnabled)) {
            this.show();
            this._updateButton();
            this._updateList();
            this._hideList();
        } else this.hide();
    },
    dispose () {
        this._unsubscribeEvents();
        this._group.linkRemove().linkOff();
        this._group.dispose();
        this._shadow.dispose();
    },
    layoutOptions () {
        return this._options.enabled && {
            horizontalAlignment: "right",
            verticalAlignment: "top",
            weak: true
        };
    },
    measure () {
        this._fillSpace();
        var margin = this._options.button.margin;
        return [
            $45b378275d69a3cc$var$BUTTON_SIZE + margin.left + margin.right,
            $45b378275d69a3cc$var$BUTTON_SIZE + margin.top + margin.bottom
        ];
    },
    move (rect) {
        var margin = this._options.button.margin;
        this._group.attr({
            translateX: Math.round(rect[0]) + margin.left,
            translateY: Math.round(rect[1]) + margin.top
        });
    },
    _fillSpace () {
        this._hiddenDueToLayout = false;
        this.show();
    },
    freeSpace () {
        this._incidentOccurred("W2107");
        this._hiddenDueToLayout = true;
        this.hide();
    },
    _hideList () {
        this._listGroup.remove();
        this._listShown = false;
        this._setButtonState("default");
        this._menuItems.forEach((item)=>item.resetState());
    },
    _showList () {
        this._listGroup.append(this._group);
        this._listShown = true;
        this._menuItems.forEach((item)=>item.fixPosition());
    },
    _setButtonState (state) {
        var style = this._options.button[state];
        this._button.attr({
            stroke: style.borderColor,
            fill: style.backgroundColor
        });
        this._icon.attr({
            fill: style.color
        });
    },
    _subscribeEvents () {
        this._renderer.root.on((0, $cgnQR.default).up + ".export", (e)=>{
            var elementType = e.target[$45b378275d69a3cc$var$EXPORT_DATA_KEY];
            if (!elementType) {
                if (this._button) this._hideList();
                return;
            }
            if ("button" === elementType) {
                if (this._listShown) {
                    this._setButtonState("default");
                    this._hideList();
                } else {
                    this._setButtonState("focus");
                    this._showList();
                }
            } else if ("printing" === elementType) {
                this._print();
                this._hideList();
            } else if ("exporting" === elementType) {
                this._exportTo(e.target[$45b378275d69a3cc$var$FORMAT_DATA_KEY]);
                this._hideList();
            }
        });
        this._listGroup.on($45b378275d69a3cc$var$pointerActions, (e)=>e.stopPropagation());
        this._buttonGroup.on((0, $cgnQR.default).enter, ()=>this._setButtonState("hover"));
        this._buttonGroup.on((0, $cgnQR.default).leave, ()=>this._setButtonState(this._listShown ? "focus" : "default"));
        this._buttonGroup.on((0, $cgnQR.default).down + ".export", ()=>this._setButtonState("active"));
    },
    _unsubscribeEvents () {
        this._renderer.root.off(".export");
        this._listGroup.off();
        this._buttonGroup.off();
    },
    _updateButton () {
        var renderer = this._renderer;
        var options = this._options;
        var exportData = {
            "export-element-type": "button"
        };
        if (!this._button) {
            this._button = renderer.rect(0, 0, $45b378275d69a3cc$var$BUTTON_SIZE, $45b378275d69a3cc$var$BUTTON_SIZE).append(this._buttonGroup);
            this._button.attr({
                rx: 4,
                ry: 4,
                fill: options.button.default.backgroundColor,
                stroke: options.button.default.borderColor,
                "stroke-width": 1,
                cursor: "pointer"
            });
            this._button.data(exportData);
            this._icon = renderer.path($45b378275d69a3cc$var$ICON_COORDS).append(this._buttonGroup);
            this._icon.attr({
                fill: options.button.default.color,
                cursor: "pointer"
            });
            this._icon.data(exportData);
            this._buttonGroup.setTitle((0, $9zsY3.default).format("vizExport-titleMenuText"));
        }
    },
    _updateList () {
        var options = this._options;
        var buttonDefault = options.button.default;
        var listGroup = this._listGroup;
        var items = $45b378275d69a3cc$var$createMenuItems(this._renderer, options);
        this._shadow.attr({
            color: options.shadowColor
        });
        this._overlay.attr({
            height: items.length * $45b378275d69a3cc$var$MENU_ITEM_HEIGHT + 2 * $45b378275d69a3cc$var$LIST_STROKE_WIDTH,
            fill: buttonDefault.backgroundColor,
            stroke: buttonDefault.borderColor
        });
        listGroup.clear();
        this._overlay.append(listGroup);
        items.forEach((item)=>item.g.append(listGroup));
        this._menuItems = items;
    }
});
function $45b378275d69a3cc$var$getExportOptions(widget, exportOptions, fileName, format) {
    if (format || exportOptions.format) format = $45b378275d69a3cc$var$validateFormat(format || exportOptions.format, widget._incidentOccurred);
    var { width: width, height: height } = widget.getSize();
    return {
        format: format || $45b378275d69a3cc$var$DEFAULT_EXPORT_FORMAT,
        fileName: fileName || exportOptions.fileName || "file",
        backgroundColor: exportOptions.backgroundColor,
        width: width,
        height: height,
        margin: exportOptions.margin,
        svgToCanvas: exportOptions.svgToCanvas,
        exportingAction: widget._createActionByOption("onExporting", {
            excludeValidators: [
                "disabled"
            ]
        }),
        exportedAction: widget._createActionByOption("onExported", {
            excludeValidators: [
                "disabled"
            ]
        }),
        fileSavingAction: widget._createActionByOption("onFileSaving", {
            excludeValidators: [
                "disabled"
            ]
        })
    };
}
var $45b378275d69a3cc$export$ca524d3785e2543 = {
    name: "export",
    init () {
        this._exportMenu = new $45b378275d69a3cc$export$f962f50fb774e224({
            renderer: this._renderer,
            incidentOccurred: this._incidentOccurred,
            print: ()=>this.print(),
            exportTo: (format)=>this.exportTo(void 0, format)
        });
        this._layout.add(this._exportMenu);
    },
    dispose () {
        this._exportMenu.dispose();
    },
    members: {
        _getExportMenuOptions () {
            return (0, $2oTOp.extend)({}, this._getOption("export"), {
                rtl: this._getOption("rtlEnabled", true)
            });
        },
        _disablePointerEvents () {
            var pointerEventsValue = this._renderer.root.attr("pointer-events");
            this._renderer.root.attr({
                "pointer-events": "none"
            });
            return pointerEventsValue;
        },
        exportTo (fileName, format) {
            var menu = this._exportMenu;
            var options = $45b378275d69a3cc$var$getExportOptions(this, this._getOption("export") || {}, fileName, format);
            menu && menu.hide();
            var pointerEventsValue = this._disablePointerEvents();
            var promise = (0, $com36.export)(this._renderer.root.element, options, $45b378275d69a3cc$var$getCreatorFunc(options.format)).fail((0, $9U2XG.logger).error).always(()=>{
                this._renderer.root.attr({
                    "pointer-events": pointerEventsValue
                });
            });
            menu && menu.show();
            return promise;
        },
        print () {
            var menu = this._exportMenu;
            var options = $45b378275d69a3cc$var$getExportOptions(this, this._getOption("export") || {});
            options.exportingAction = null;
            options.exportedAction = null;
            options.margin = 0;
            options.format = "PNG";
            options.useBase64 = true;
            options.fileSavingAction = (eventArgs)=>{
                $45b378275d69a3cc$var$print("data:image/png;base64,".concat(eventArgs.data), {
                    width: options.width,
                    __test: options.__test
                });
                eventArgs.cancel = true;
            };
            var pointerEventsValue = this._disablePointerEvents();
            menu && menu.hide();
            var promise = (0, $com36.export)(this._renderer.root.element, options, $45b378275d69a3cc$var$getCreatorFunc(options.format)).fail((0, $9U2XG.logger).error).always(()=>{
                this._renderer.root.attr({
                    "pointer-events": pointerEventsValue
                });
            });
            menu && menu.show();
            return promise;
        }
    },
    customize (constructor) {
        var proto = constructor.prototype;
        constructor.addChange({
            code: "EXPORT",
            handler () {
                this._exportMenu.setOptions(this._getExportMenuOptions());
                this._change([
                    "LAYOUT"
                ]);
            },
            isThemeDependent: true,
            isOptionChange: true,
            option: "export"
        });
        proto._optionChangesMap.onExporting = "EXPORT";
        proto._optionChangesMap.onExported = "EXPORT";
        proto._optionChangesMap.onFileSaving = "EXPORT";
    },
    fontFields: [
        "export.font"
    ]
};

});
parcelRegister("com36", function(module, exports) {

$parcel$export(module.exports, "export", function () { return $9058d4691a5c7819$export$5faec355c22dc11f; });
$parcel$export(module.exports, "image", function () { return $9058d4691a5c7819$export$5c452ff88e35e47d; });
$parcel$export(module.exports, "pdf", function () { return $9058d4691a5c7819$export$278e8ca9e1fa9094; });
$parcel$export(module.exports, "svg", function () { return $9058d4691a5c7819$export$7ed1367e7fa1ad68; });
/**
 * DevExtreme (esm/exporter.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $jf4Dw = parcelRequire("jf4Dw");

var $dGyyw = parcelRequire("dGyyw");

var $fA7Jk = parcelRequire("fA7Jk");

var $22BvS = parcelRequire("22BvS");

var $6ntMu = parcelRequire("6ntMu");

var $dDkff = parcelRequire("dDkff");

var $iWekk = parcelRequire("iWekk");

var $jPgAf = parcelRequire("jPgAf");
function $9058d4691a5c7819$export$5faec355c22dc11f(data, options, getData) {
    if (!data) return (new (0, $dDkff.Deferred)).resolve();
    var exportingAction = options.exportingAction;
    var exportedAction = options.exportedAction;
    var fileSavingAction = options.fileSavingAction;
    var eventArgs = {
        fileName: options.fileName,
        format: options.format,
        cancel: false
    };
    if ((0, $6ntMu.isBoolean)(options.selectedRowsOnly)) eventArgs.selectedRowsOnly = options.selectedRowsOnly;
    (0, $6ntMu.isFunction)(exportingAction) && exportingAction(eventArgs);
    if (!eventArgs.cancel) return getData(data, options).then((blob)=>{
        (0, $6ntMu.isFunction)(exportedAction) && exportedAction();
        if ((0, $6ntMu.isFunction)(fileSavingAction)) {
            eventArgs.data = blob;
            fileSavingAction(eventArgs);
        }
        if (!eventArgs.cancel) {
            var format = "xlsx" === options.format ? "EXCEL" : options.format;
            (0, $jf4Dw.fileSaver).saveAs(eventArgs.fileName, format, blob);
        }
    });
    return (new (0, $dDkff.Deferred)).resolve();
}
var $9058d4691a5c7819$export$288e33dd8075b52e = {
    creator: (0, $dGyyw.ExcelCreator),
    getData: (0, $dGyyw.getData),
    formatConverter: (0, $iWekk.default)
};
var $9058d4691a5c7819$export$5c452ff88e35e47d = {
    creator: (0, $fA7Jk.imageCreator),
    getData: (0, $fA7Jk.getData),
    testFormats: (0, $fA7Jk.testFormats)
};
var $9058d4691a5c7819$export$278e8ca9e1fa9094 = {
    getData: (0, $jPgAf.getData)
};
var $9058d4691a5c7819$export$7ed1367e7fa1ad68 = {
    creator: (0, $22BvS.svgCreator),
    getData: (0, $22BvS.getData)
};

});
parcelRegister("jf4Dw", function(module, exports) {

$parcel$export(module.exports, "MIME_TYPES", function () { return $e02303c0b979d59e$export$edfb5d7e4280f611; });
$parcel$export(module.exports, "fileSaver", function () { return $e02303c0b979d59e$export$7c88398a90a0206; });
/**
 * DevExtreme (esm/exporter/file_saver.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $3yzYM = parcelRequire("3yzYM");

var $hYatw = parcelRequire("hYatw");

var $HvBq2 = parcelRequire("HvBq2");

var $6ntMu = parcelRequire("6ntMu");

var $9U2XG = parcelRequire("9U2XG");
var $e02303c0b979d59e$var$window = (0, $hYatw.getWindow)();
var $e02303c0b979d59e$var$navigator = (0, $hYatw.getNavigator)();
var $e02303c0b979d59e$var$FILE_EXTESIONS = {
    EXCEL: "xlsx",
    CSS: "css",
    PNG: "png",
    JPEG: "jpeg",
    GIF: "gif",
    SVG: "svg",
    PDF: "pdf"
};
var $e02303c0b979d59e$export$edfb5d7e4280f611 = {
    CSS: "text/css",
    EXCEL: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    PNG: "image/png",
    JPEG: "image/jpeg",
    GIF: "image/gif",
    SVG: "image/svg+xml",
    PDF: "application/pdf"
};
var $e02303c0b979d59e$export$7c88398a90a0206 = {
    _revokeObjectURLTimeout: 3e4,
    _getDataUri: function(format, data) {
        var mimeType = this._getMimeType(format);
        return "data:".concat(mimeType, ";base64,").concat(data);
    },
    _getMimeType: function(format) {
        return $e02303c0b979d59e$export$edfb5d7e4280f611[format] || "application/octet-stream";
    },
    _linkDownloader: function(fileName, href) {
        var exportLinkElement = (0, $3yzYM.default).createElement("a");
        exportLinkElement.download = fileName;
        exportLinkElement.href = href;
        exportLinkElement.target = "_blank";
        return exportLinkElement;
    },
    _winJSBlobSave: function(blob, fileName, format) {
        var savePicker = new Windows.Storage.Pickers.FileSavePicker;
        savePicker.suggestedStartLocation = Windows.Storage.Pickers.PickerLocationId.documentsLibrary;
        var fileExtension = $e02303c0b979d59e$var$FILE_EXTESIONS[format];
        if (fileExtension) {
            var mimeType = this._getMimeType(format);
            savePicker.fileTypeChoices.insert(mimeType, [
                "." + fileExtension
            ]);
        }
        savePicker.suggestedFileName = fileName;
        savePicker.pickSaveFileAsync().then(function(file) {
            if (file) file.openAsync(Windows.Storage.FileAccessMode.readWrite).then(function(outputStream) {
                var inputStream = blob.msDetachStream();
                Windows.Storage.Streams.RandomAccessStream.copyAsync(inputStream, outputStream).then(function() {
                    outputStream.flushAsync().done(function() {
                        inputStream.close();
                        outputStream.close();
                    });
                });
            });
        });
    },
    _click: function(link) {
        try {
            link.dispatchEvent(new MouseEvent("click", {
                cancelable: true
            }));
        } catch (e) {
            var event = (0, $3yzYM.default).getDocument().createEvent("MouseEvents");
            event.initMouseEvent("click", true, true, $e02303c0b979d59e$var$window, 0, 0, 0, 80, 20, false, false, false, false, 0, null);
            link.dispatchEvent(event);
        }
    },
    _saveBlobAs: function(fileName, format, data) {
        this._blobSaved = false;
        if ((0, $6ntMu.isDefined)($e02303c0b979d59e$var$navigator.msSaveOrOpenBlob)) {
            $e02303c0b979d59e$var$navigator.msSaveOrOpenBlob(data, fileName);
            this._blobSaved = true;
        } else if ((0, $6ntMu.isDefined)($e02303c0b979d59e$var$window.WinJS)) {
            this._winJSBlobSave(data, fileName, format);
            this._blobSaved = true;
        } else {
            var URL = $e02303c0b979d59e$var$window.URL || $e02303c0b979d59e$var$window.webkitURL || $e02303c0b979d59e$var$window.mozURL || $e02303c0b979d59e$var$window.msURL || $e02303c0b979d59e$var$window.oURL;
            if ((0, $6ntMu.isDefined)(URL)) {
                var objectURL = URL.createObjectURL(data);
                var downloadLink = this._linkDownloader(fileName, objectURL);
                setTimeout(()=>{
                    URL.revokeObjectURL(objectURL);
                    this._objectUrlRevoked = true;
                }, this._revokeObjectURLTimeout);
                this._click(downloadLink);
            } else (0, $9U2XG.logger).warn("window.URL || window.webkitURL || window.mozURL || window.msURL || window.oURL is not defined");
        }
    },
    saveAs: function(fileName, format, data) {
        var fileExtension = $e02303c0b979d59e$var$FILE_EXTESIONS[format];
        if (fileExtension) fileName += "." + fileExtension;
        if ((0, $6ntMu.isFunction)($e02303c0b979d59e$var$window.Blob)) this._saveBlobAs(fileName, format, data);
        else {
            if (!(0, $6ntMu.isDefined)($e02303c0b979d59e$var$navigator.userAgent.match(/iPad/i))) (0, $HvBq2.default).log("E1034");
            var downloadLink = this._linkDownloader(fileName, this._getDataUri(format, data));
            this._click(downloadLink);
        }
    }
};

});

parcelRegister("dGyyw", function(module, exports) {

$parcel$export(module.exports, "ExcelCreator", function () { return $9f6a00af148b9df9$export$f0d0e79ed75962b9; });
$parcel$export(module.exports, "getData", function () { return $9f6a00af148b9df9$export$7a171f172be0782e; });
/**
 * DevExtreme (esm/exporter/excel_creator.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $a2g7x = parcelRequire("a2g7x");

var $hYatw = parcelRequire("hYatw");

var $6ntMu = parcelRequire("6ntMu");

var $2oTOp = parcelRequire("2oTOp");

var $HvBq2 = parcelRequire("HvBq2");

var $9vHY4 = parcelRequire("9vHY4");

var $jt1Do = parcelRequire("jt1Do");

var $jf4Dw = parcelRequire("jf4Dw");

var $iWekk = parcelRequire("iWekk");

var $diyO6 = parcelRequire("diyO6");

var $dDkff = parcelRequire("dDkff");
var $9f6a00af148b9df9$var$XML_TAG = '<?xml version="1.0" encoding="utf-8"?>';
var $9f6a00af148b9df9$var$GROUP_SHEET_PR_XML = '<sheetPr><outlinePr summaryBelow="0"/></sheetPr>';
var $9f6a00af148b9df9$var$SINGLE_SHEET_PR_XML = "<sheetPr/>";
var $9f6a00af148b9df9$var$BASE_STYLE_XML2 = '<borders count="1"><border><left style="thin"><color rgb="FFD3D3D3"/></left><right style="thin"><color rgb="FFD3D3D3"/></right><top style="thin"><color rgb="FFD3D3D3"/></top><bottom style="thin"><color rgb="FFD3D3D3"/></bottom></border></borders><cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
var $9f6a00af148b9df9$var$OPEN_XML_FORMAT_URL = "http://schemas.openxmlformats.org";
var $9f6a00af148b9df9$var$RELATIONSHIP_PART_NAME = "rels";
var $9f6a00af148b9df9$var$XL_FOLDER_NAME = "xl";
var $9f6a00af148b9df9$var$WORKBOOK_FILE_NAME = "workbook.xml";
var $9f6a00af148b9df9$var$CONTENTTYPES_FILE_NAME = "[Content_Types].xml";
var $9f6a00af148b9df9$var$SHAREDSTRING_FILE_NAME = "sharedStrings.xml";
var $9f6a00af148b9df9$var$STYLE_FILE_NAME = "styles.xml";
var $9f6a00af148b9df9$var$WORKSHEETS_FOLDER = "worksheets";
var $9f6a00af148b9df9$var$WORKSHEET_FILE_NAME = "sheet1.xml";
var $9f6a00af148b9df9$var$WORKSHEET_HEADER_XML = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac">';
var $9f6a00af148b9df9$var$VALID_TYPES = {
    boolean: "b",
    date: "d",
    number: "n",
    string: "s"
};
var $9f6a00af148b9df9$var$EXCEL_START_TIME = Date.UTC(1899, 11, 30);
var $9f6a00af148b9df9$var$DAYS_COUNT_BEFORE_29_FEB_1900 = 60;
var $9f6a00af148b9df9$var$MAX_DIGIT_WIDTH_IN_PIXELS = 7;
var $9f6a00af148b9df9$var$UNSUPPORTED_FORMAT_MAPPING = {
    quarter: "shortDate",
    quarterAndYear: "shortDate",
    minute: "longTime",
    millisecond: "longTime"
};
var $9f6a00af148b9df9$export$f0d0e79ed75962b9 = (0, $a2g7x.default).inherit({
    _getXMLTag: function(tagName, attributes, content) {
        var result = "<" + tagName;
        var i;
        var length = attributes.length;
        var attr;
        for(i = 0; i < length; i++){
            attr = attributes[i];
            if (void 0 !== attr.value) result = result + " " + attr.name + '="' + attr.value + '"';
        }
        return (0, $6ntMu.isDefined)(content) ? result + ">" + content + "</" + tagName + ">" : result + " />";
    },
    _convertToExcelCellRef: function(zeroBasedRowIndex, zeroBasedCellIndex) {
        var columnName = "";
        var charCode;
        var isCellIndexFound;
        while(!isCellIndexFound){
            charCode = 65 + (zeroBasedCellIndex >= 26 ? zeroBasedCellIndex % 26 : Math.ceil(zeroBasedCellIndex));
            columnName = String.fromCharCode(charCode) + columnName;
            if (zeroBasedCellIndex >= 26) zeroBasedCellIndex = Math.floor(zeroBasedCellIndex / 26) - 1;
            else isCellIndexFound = true;
        }
        return columnName + (zeroBasedRowIndex + 1);
    },
    _convertToExcelCellRefAndTrackMaxIndex: function(rowIndex, cellIndex) {
        if (this._maxRowIndex < Number(rowIndex)) this._maxRowIndex = Number(rowIndex);
        if (this._maxColumnIndex < Number(cellIndex)) this._maxColumnIndex = Number(cellIndex);
        return this._convertToExcelCellRef(rowIndex, cellIndex);
    },
    _getDataType: function(dataType) {
        return $9f6a00af148b9df9$var$VALID_TYPES[dataType] || $9f6a00af148b9df9$var$VALID_TYPES.string;
    },
    _tryGetExcelCellDataType: function(object) {
        if ((0, $6ntMu.isDefined)(object)) {
            if ("number" === typeof object) {
                if (isFinite(object)) return $9f6a00af148b9df9$var$VALID_TYPES.number;
                else return $9f6a00af148b9df9$var$VALID_TYPES.string;
            } else if ((0, $6ntMu.isString)(object)) return $9f6a00af148b9df9$var$VALID_TYPES.string;
            else if ((0, $6ntMu.isDate)(object)) return $9f6a00af148b9df9$var$VALID_TYPES.number;
            else if ((0, $6ntMu.isBoolean)(object)) return $9f6a00af148b9df9$var$VALID_TYPES.boolean;
        }
    },
    _formatObjectConverter: function(format, dataType) {
        var result = {
            format: format,
            precision: format && format.precision,
            dataType: dataType
        };
        if ((0, $6ntMu.isObject)(format)) return (0, $2oTOp.extend)(result, format, {
            format: format.formatter || format.type,
            currency: format.currency
        });
        return result;
    },
    _tryConvertToExcelNumberFormat: function(format, dataType) {
        var newFormat = this._formatObjectConverter(format, dataType);
        format = newFormat.format;
        var currency = newFormat.currency;
        dataType = newFormat.dataType;
        if ((0, $6ntMu.isDefined)(format) && "date" === dataType) format = $9f6a00af148b9df9$var$UNSUPPORTED_FORMAT_MAPPING[format && format.type || format] || format;
        return (0, $iWekk.default).convertFormat(format, newFormat.precision, dataType, currency);
    },
    _appendString: function(value) {
        if ((0, $6ntMu.isDefined)(value)) {
            value = String(value);
            if (value.length) {
                value = (0, $9vHY4.encodeHtml)(value);
                if (void 0 === this._stringHash[value]) {
                    this._stringHash[value] = this._stringArray.length;
                    this._stringArray.push(value);
                }
                return this._stringHash[value];
            }
        }
    },
    _tryGetExcelDateValue: function(date) {
        var days;
        var totalTime;
        if ((0, $6ntMu.isDate)(date)) {
            days = Math.floor((Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - $9f6a00af148b9df9$var$EXCEL_START_TIME) / 864e5);
            if (days < $9f6a00af148b9df9$var$DAYS_COUNT_BEFORE_29_FEB_1900) days--;
            totalTime = (3600 * date.getHours() + 60 * date.getMinutes() + date.getSeconds()) / 86400;
            return days + totalTime;
        }
    },
    _prepareValue: function(rowIndex, cellIndex) {
        var dataProvider = this._dataProvider;
        var { cellSourceData: cellSourceData } = dataProvider.getCellData(rowIndex, cellIndex) || {};
        var { value: value } = dataProvider.getCellData(rowIndex, cellIndex) || {};
        var sourceValue;
        var type = this._getDataType(dataProvider.getCellType(rowIndex, cellIndex));
        if (type === $9f6a00af148b9df9$var$VALID_TYPES.date && !(0, $6ntMu.isDate)(value)) type = $9f6a00af148b9df9$var$VALID_TYPES.string;
        switch(type){
            case $9f6a00af148b9df9$var$VALID_TYPES.string:
                sourceValue = value;
                value = this._appendString(value);
                break;
            case $9f6a00af148b9df9$var$VALID_TYPES.date:
                sourceValue = value;
                value = this._tryGetExcelDateValue(value);
                type = $9f6a00af148b9df9$var$VALID_TYPES.number;
        }
        return {
            value: value,
            type: type,
            sourceValue: sourceValue,
            cellSourceData: cellSourceData
        };
    },
    _callCustomizeExcelCell: function(_ref) {
        var { dataProvider: dataProvider, value: value, style: style, sourceData: sourceData } = _ref;
        var styleCopy = (0, $diyO6.default).copyCellFormat(style);
        var args = {
            value: value,
            numberFormat: styleCopy.numberFormat,
            clearStyle: function() {
                this.horizontalAlignment = null;
                this.verticalAlignment = null;
                this.wrapTextEnabled = null;
                this.font = null;
                this.numberFormat = null;
            }
        };
        if ((0, $6ntMu.isDefined)(styleCopy)) {
            if ((0, $6ntMu.isDefined)(styleCopy.alignment)) {
                args.horizontalAlignment = styleCopy.alignment.horizontal;
                args.verticalAlignment = styleCopy.alignment.vertical;
                args.wrapTextEnabled = styleCopy.alignment.wrapText;
            }
            args.backgroundColor = styleCopy.backgroundColor;
            args.fillPatternType = styleCopy.fillPatternType;
            args.fillPatternColor = styleCopy.fillPatternColor;
            args.font = styleCopy.font;
        }
        dataProvider.customizeExcelCell(args, sourceData);
        var newStyle = styleCopy || {};
        newStyle.font = args.font;
        newStyle.alignment = newStyle.alignment || {};
        newStyle.alignment.horizontal = args.horizontalAlignment;
        newStyle.alignment.vertical = args.verticalAlignment;
        newStyle.alignment.wrapText = args.wrapTextEnabled;
        newStyle.backgroundColor = args.backgroundColor;
        newStyle.fillPatternType = args.fillPatternType;
        newStyle.fillPatternColor = args.fillPatternColor;
        newStyle.numberFormat = args.numberFormat;
        return {
            value: args.value,
            style: newStyle
        };
    },
    _getDataArray: function() {
        var rowIndex;
        var cellIndex;
        var cellsArray;
        var cellData;
        var result = [];
        var dataProvider = this._dataProvider;
        var rowsLength = dataProvider.getRowsCount();
        var columns = dataProvider.getColumns();
        var cellsLength;
        for(rowIndex = 0; rowIndex < rowsLength; rowIndex++){
            cellsArray = [];
            cellsLength = columns.length;
            for(cellIndex = 0; cellIndex !== cellsLength; cellIndex++){
                cellData = this._prepareValue(rowIndex, cellIndex);
                var styleArrayIndex = dataProvider.getStyleId(rowIndex, cellIndex);
                var cellStyleId = this._styleArrayIndexToCellStyleIdMap[styleArrayIndex];
                if (dataProvider.hasCustomizeExcelCell && dataProvider.hasCustomizeExcelCell()) {
                    var value = cellData.sourceValue || cellData.value;
                    var modifiedExcelCell = this._callCustomizeExcelCell({
                        dataProvider: dataProvider,
                        value: value,
                        style: this._styleArray[styleArrayIndex],
                        sourceData: cellData.cellSourceData
                    });
                    if (modifiedExcelCell.value !== value) {
                        if (typeof modifiedExcelCell.value !== typeof value || "number" === typeof modifiedExcelCell.value && !isFinite(modifiedExcelCell.value)) {
                            var cellDataType = this._tryGetExcelCellDataType(modifiedExcelCell.value);
                            if ((0, $6ntMu.isDefined)(cellDataType)) cellData.type = cellDataType;
                        }
                        switch(cellData.type){
                            case $9f6a00af148b9df9$var$VALID_TYPES.string:
                                cellData.value = this._appendString(modifiedExcelCell.value);
                                break;
                            case $9f6a00af148b9df9$var$VALID_TYPES.date:
                                cellData.value = modifiedExcelCell.value;
                                break;
                            case $9f6a00af148b9df9$var$VALID_TYPES.number:
                                var newValue = modifiedExcelCell.value;
                                var excelDateValue = this._tryGetExcelDateValue(newValue);
                                if ((0, $6ntMu.isDefined)(excelDateValue)) newValue = excelDateValue;
                                cellData.value = newValue;
                                break;
                            default:
                                cellData.value = modifiedExcelCell.value;
                        }
                    }
                    cellStyleId = this._excelFile.registerCellFormat(modifiedExcelCell.style);
                }
                cellsArray.push({
                    style: cellStyleId,
                    value: cellData.value,
                    type: cellData.type
                });
            }
            if (!this._needSheetPr && dataProvider.getGroupLevel(rowIndex) > 0) this._needSheetPr = true;
            result.push(cellsArray);
        }
        return result;
    },
    _calculateWidth: function(pixelsWidth) {
        pixelsWidth = parseInt(pixelsWidth, 10);
        if (!pixelsWidth || pixelsWidth < 5) pixelsWidth = 100;
        return Math.min(255, Math.floor((pixelsWidth - 5) / $9f6a00af148b9df9$var$MAX_DIGIT_WIDTH_IN_PIXELS * 100 + .5) / 100);
    },
    _prepareStyleData: function() {
        var that = this;
        var styles = that._dataProvider.getStyles();
        that._dataProvider.getColumns().forEach(function(column) {
            that._colsArray.push(that._calculateWidth(column.width));
        });
        var fonts = [
            {
                size: 11,
                color: {
                    theme: 1
                },
                name: "Calibri",
                family: 2,
                scheme: "minor",
                bold: false
            },
            {
                size: 11,
                color: {
                    theme: 1
                },
                name: "Calibri",
                family: 2,
                scheme: "minor",
                bold: true
            }
        ];
        this._excelFile.registerFont(fonts[0]);
        this._excelFile.registerFont(fonts[1]);
        styles.forEach(function(style) {
            var numberFormat = that._tryConvertToExcelNumberFormat(style.format, style.dataType);
            if (!(0, $6ntMu.isDefined)(numberFormat)) numberFormat = 0;
            that._styleArray.push({
                font: fonts[Number(!!style.bold)],
                numberFormat: numberFormat,
                alignment: {
                    vertical: "top",
                    wrapText: !!style.wrapText,
                    horizontal: style.alignment || "left"
                }
            });
        });
        that._styleArrayIndexToCellStyleIdMap = that._styleArray.map((item)=>this._excelFile.registerCellFormat(item));
    },
    _prepareCellData: function() {
        this._cellsArray = this._getDataArray();
    },
    _createXMLRelationships: function(xmlRelationships) {
        return this._getXMLTag("Relationships", [
            {
                name: "xmlns",
                value: $9f6a00af148b9df9$var$OPEN_XML_FORMAT_URL + "/package/2006/relationships"
            }
        ], xmlRelationships);
    },
    _createXMLRelationship: function(id, type, target) {
        return this._getXMLTag("Relationship", [
            {
                name: "Id",
                value: "rId" + id
            },
            {
                name: "Type",
                value: $9f6a00af148b9df9$var$OPEN_XML_FORMAT_URL + "/officeDocument/2006/relationships/" + type
            },
            {
                name: "Target",
                value: target
            }
        ]);
    },
    _getWorkbookContent: function() {
        return $9f6a00af148b9df9$var$XML_TAG + this._getXMLTag("workbook", [
            {
                name: "xmlns:r",
                value: $9f6a00af148b9df9$var$OPEN_XML_FORMAT_URL + "/officeDocument/2006/relationships"
            },
            {
                name: "xmlns",
                value: $9f6a00af148b9df9$var$OPEN_XML_FORMAT_URL + "/spreadsheetml/2006/main"
            }
        ], '<bookViews><workbookView xWindow="0" yWindow="0" windowWidth="0" windowHeight="0"/></bookViews><sheets><sheet name="Sheet" sheetId="1" r:id="rId1" /></sheets><definedNames><definedName name="_xlnm.Print_Titles" localSheetId="0">Sheet!$1:$1</definedName><definedName name="_xlnm._FilterDatabase" hidden="0" localSheetId="0">Sheet!$A$1:$F$6332</definedName></definedNames>');
    },
    _getContentTypesContent: function() {
        return $9f6a00af148b9df9$var$XML_TAG + '<Types xmlns="' + $9f6a00af148b9df9$var$OPEN_XML_FORMAT_URL + '/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml" /><Default Extension="xml" ContentType="application/xml" /><Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" /><Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml" /><Override PartName="/xl/sharedStrings.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml" /><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" /></Types>';
    },
    _generateStylesXML: function() {
        var folder = this._zip.folder($9f6a00af148b9df9$var$XL_FOLDER_NAME);
        var XML = "";
        XML += this._excelFile.generateNumberFormatsXml();
        XML += this._excelFile.generateFontsXml();
        XML += this._excelFile.generateFillsXml();
        XML += $9f6a00af148b9df9$var$BASE_STYLE_XML2;
        XML += this._excelFile.generateCellFormatsXml();
        XML += this._getXMLTag("cellStyles", [
            {
                name: "count",
                value: 1
            }
        ], this._getXMLTag("cellStyle", [
            {
                name: "name",
                value: "Normal"
            },
            {
                name: "xfId",
                value: 0
            },
            {
                name: "builtinId",
                value: 0
            }
        ]));
        XML = $9f6a00af148b9df9$var$XML_TAG + this._getXMLTag("styleSheet", [
            {
                name: "xmlns",
                value: $9f6a00af148b9df9$var$OPEN_XML_FORMAT_URL + "/spreadsheetml/2006/main"
            }
        ], XML);
        folder.file($9f6a00af148b9df9$var$STYLE_FILE_NAME, XML);
        this._styleArray = [];
    },
    _generateStringsXML: function() {
        var folder = this._zip.folder($9f6a00af148b9df9$var$XL_FOLDER_NAME);
        var stringIndex;
        var stringsLength = this._stringArray.length;
        var sharedStringXml = $9f6a00af148b9df9$var$XML_TAG;
        for(stringIndex = 0; stringIndex < stringsLength; stringIndex++)this._stringArray[stringIndex] = this._getXMLTag("si", [], this._getXMLTag("t", [], this._stringArray[stringIndex]));
        sharedStringXml += this._getXMLTag("sst", [
            {
                name: "xmlns",
                value: $9f6a00af148b9df9$var$OPEN_XML_FORMAT_URL + "/spreadsheetml/2006/main"
            },
            {
                name: "count",
                value: this._stringArray.length
            },
            {
                name: "uniqueCount",
                value: this._stringArray.length
            }
        ], this._stringArray.join(""));
        folder.file($9f6a00af148b9df9$var$SHAREDSTRING_FILE_NAME, sharedStringXml);
        this._stringArray = [];
    },
    _getPaneXML: function() {
        var attributes = [
            {
                name: "activePane",
                value: "bottomLeft"
            },
            {
                name: "state",
                value: "frozen"
            }
        ];
        var frozenArea = this._dataProvider.getFrozenArea();
        if (!(frozenArea.x || frozenArea.y)) return "";
        if (frozenArea.x) attributes.push({
            name: "xSplit",
            value: frozenArea.x
        });
        if (frozenArea.y) attributes.push({
            name: "ySplit",
            value: frozenArea.y
        });
        attributes.push({
            name: "topLeftCell",
            value: this._convertToExcelCellRefAndTrackMaxIndex(frozenArea.y, frozenArea.x)
        });
        return this._getXMLTag("pane", attributes);
    },
    _getAutoFilterXML: function(maxCellIndex) {
        if (this._options.autoFilterEnabled) return '<autoFilter ref="A' + this._dataProvider.getHeaderRowCount() + ":" + maxCellIndex + '" />';
        return "";
    },
    _generateWorksheetXML: function() {
        var colIndex;
        var rowIndex;
        var cellData;
        var xmlCells;
        var xmlRows = [];
        var rowsLength = this._cellsArray.length;
        var cellsLength;
        var colsLength = this._colsArray.length;
        var rSpans = "1:" + colsLength;
        var headerRowCount = this._dataProvider.getHeaderRowCount ? this._dataProvider.getHeaderRowCount() : 1;
        var xmlResult = [
            $9f6a00af148b9df9$var$WORKSHEET_HEADER_XML
        ];
        xmlResult.push(this._needSheetPr ? $9f6a00af148b9df9$var$GROUP_SHEET_PR_XML : $9f6a00af148b9df9$var$SINGLE_SHEET_PR_XML);
        xmlResult.push('<dimension ref="A1:C1"/>');
        xmlResult.push("<sheetViews><sheetView ");
        xmlResult.push(this._rtlEnabled ? 'rightToLeft="1" ' : "");
        xmlResult.push('tabSelected="1" workbookViewId="0">');
        xmlResult.push(this._getPaneXML());
        xmlResult.push("</sheetView></sheetViews>");
        xmlResult.push('<sheetFormatPr defaultRowHeight="15"');
        xmlResult.push(' outlineLevelRow="' + (this._dataProvider.getRowsCount() > 0 ? this._dataProvider.getGroupLevel(0) : 0) + '"');
        xmlResult.push(' x14ac:dyDescent="0.25"/>');
        for(colIndex = 0; colIndex < colsLength; colIndex++)this._colsArray[colIndex] = this._getXMLTag("col", [
            {
                name: "width",
                value: this._colsArray[colIndex]
            },
            {
                name: "min",
                value: Number(colIndex) + 1
            },
            {
                name: "max",
                value: Number(colIndex) + 1
            },
            {
                name: "customWidth",
                value: 1
            }
        ]);
        xmlResult.push(this._getXMLTag("cols", [], this._colsArray.join("")) + "<sheetData>");
        for(rowIndex = 0; rowIndex < rowsLength; rowIndex++){
            xmlCells = [];
            cellsLength = this._cellsArray[rowIndex].length;
            for(colIndex = 0; colIndex < cellsLength; colIndex++){
                rowIndex = Number(rowIndex);
                cellData = this._cellsArray[rowIndex][colIndex];
                xmlCells.push(this._getXMLTag("c", [
                    {
                        name: "r",
                        value: this._convertToExcelCellRefAndTrackMaxIndex(rowIndex, colIndex)
                    },
                    {
                        name: "s",
                        value: cellData.style
                    },
                    {
                        name: "t",
                        value: cellData.type
                    }
                ], (0, $6ntMu.isDefined)(cellData.value) ? this._getXMLTag("v", [], cellData.value) : null));
            }
            xmlRows.push(this._getXMLTag("row", [
                {
                    name: "r",
                    value: Number(rowIndex) + 1
                },
                {
                    name: "spans",
                    value: rSpans
                },
                {
                    name: "outlineLevel",
                    value: rowIndex >= headerRowCount ? this._dataProvider.getGroupLevel(rowIndex) : 0
                },
                {
                    name: "x14ac:dyDescent",
                    value: "0.25"
                }
            ], xmlCells.join("")));
            this._cellsArray[rowIndex] = null;
            if (xmlRows.length > 1e4) {
                xmlResult.push(xmlRows.join(""));
                xmlRows = [];
            }
        }
        xmlResult.push(xmlRows.join(""));
        var rightBottomCellRef = this._convertToExcelCellRef(this._maxRowIndex, this._maxColumnIndex);
        xmlResult.push("</sheetData>" + this._getAutoFilterXML(rightBottomCellRef) + this._generateMergingXML() + "</worksheet>");
        this._zip.folder($9f6a00af148b9df9$var$XL_FOLDER_NAME).folder($9f6a00af148b9df9$var$WORKSHEETS_FOLDER).file($9f6a00af148b9df9$var$WORKSHEET_FILE_NAME, xmlResult.join(""));
        this._colsArray = [];
        this._cellsArray = [];
    },
    _generateMergingXML: function() {
        var k;
        var l;
        var cellIndex;
        var rowIndex;
        var rowsLength = (0, $6ntMu.isDefined)(this._dataProvider.getHeaderRowCount) ? this._dataProvider.getHeaderRowCount() : this._dataProvider.getRowsCount();
        var columnsLength = this._dataProvider.getColumns().length;
        var usedArea = [];
        var mergeArray = [];
        var mergeIndex;
        var mergeXML = "";
        for(rowIndex = 0; rowIndex < rowsLength; rowIndex++){
            for(cellIndex = 0; cellIndex !== columnsLength; cellIndex++)if (!(0, $6ntMu.isDefined)(usedArea[rowIndex]) || !(0, $6ntMu.isDefined)(usedArea[rowIndex][cellIndex])) {
                var cellMerge = this._dataProvider.getCellMerging(rowIndex, cellIndex);
                if (cellMerge.colspan || cellMerge.rowspan) {
                    mergeArray.push({
                        start: this._convertToExcelCellRefAndTrackMaxIndex(rowIndex, cellIndex),
                        end: this._convertToExcelCellRefAndTrackMaxIndex(rowIndex + (cellMerge.rowspan || 0), cellIndex + (cellMerge.colspan || 0))
                    });
                    for(k = rowIndex; k <= rowIndex + cellMerge.rowspan || 0; k++)for(l = cellIndex; l <= cellIndex + cellMerge.colspan || 0; l++){
                        if (!(0, $6ntMu.isDefined)(usedArea[k])) usedArea[k] = [];
                        usedArea[k][l] = true;
                    }
                }
            }
        }
        var mergeArrayLength = mergeArray.length;
        for(mergeIndex = 0; mergeIndex < mergeArrayLength; mergeIndex++)mergeXML += this._getXMLTag("mergeCell", [
            {
                name: "ref",
                value: mergeArray[mergeIndex].start + ":" + mergeArray[mergeIndex].end
            }
        ]);
        return mergeXML.length ? this._getXMLTag("mergeCells", [
            {
                name: "count",
                value: mergeArrayLength
            }
        ], mergeXML) : "";
    },
    _generateCommonXML: function() {
        var relsFileContent = $9f6a00af148b9df9$var$XML_TAG + this._createXMLRelationships(this._createXMLRelationship(1, "officeDocument", "xl/" + $9f6a00af148b9df9$var$WORKBOOK_FILE_NAME));
        var folder = this._zip.folder($9f6a00af148b9df9$var$XL_FOLDER_NAME);
        var relsXML = $9f6a00af148b9df9$var$XML_TAG;
        this._zip.folder("_" + $9f6a00af148b9df9$var$RELATIONSHIP_PART_NAME).file("." + $9f6a00af148b9df9$var$RELATIONSHIP_PART_NAME, relsFileContent);
        var xmlRelationships = this._createXMLRelationship(1, "worksheet", "worksheets/" + $9f6a00af148b9df9$var$WORKSHEET_FILE_NAME) + this._createXMLRelationship(2, "styles", $9f6a00af148b9df9$var$STYLE_FILE_NAME) + this._createXMLRelationship(3, "sharedStrings", $9f6a00af148b9df9$var$SHAREDSTRING_FILE_NAME);
        relsXML += this._createXMLRelationships(xmlRelationships);
        folder.folder("_" + $9f6a00af148b9df9$var$RELATIONSHIP_PART_NAME).file($9f6a00af148b9df9$var$WORKBOOK_FILE_NAME + ".rels", relsXML);
        folder.file($9f6a00af148b9df9$var$WORKBOOK_FILE_NAME, this._getWorkbookContent());
        this._zip.file($9f6a00af148b9df9$var$CONTENTTYPES_FILE_NAME, this._getContentTypesContent());
    },
    _generateContent: function() {
        this._prepareStyleData();
        this._prepareCellData();
        this._generateWorkXML();
        this._generateCommonXML();
    },
    _generateWorkXML: function() {
        this._generateStylesXML();
        this._generateStringsXML();
        this._generateWorksheetXML();
    },
    ctor: function(dataProvider, options) {
        this._rtlEnabled = options && !!options.rtlEnabled;
        this._options = options;
        this._maxRowIndex = 0;
        this._maxColumnIndex = 0;
        this._stringArray = [];
        this._stringHash = {};
        this._styleArray = [];
        this._colsArray = [];
        this._cellsArray = [];
        this._needSheetPr = false;
        this._dataProvider = dataProvider;
        this._excelFile = new (0, $diyO6.default);
        if ((0, $6ntMu.isDefined)($9f6a00af148b9df9$export$f0d0e79ed75962b9.JSZip)) this._zip = new $9f6a00af148b9df9$export$f0d0e79ed75962b9.JSZip;
        else this._zip = null;
    },
    _checkZipState: function() {
        if (!this._zip) throw (0, $HvBq2.default).Error("E1041", "JSZip");
    },
    ready: function() {
        return this._dataProvider.ready();
    },
    getData: function(isBlob) {
        var options = {
            type: isBlob ? "blob" : "base64",
            compression: "DEFLATE",
            mimeType: (0, $jf4Dw.MIME_TYPES).EXCEL
        };
        var deferred = new (0, $dDkff.Deferred);
        this._checkZipState();
        this._generateContent();
        if (this._zip.generateAsync) this._zip.generateAsync(options).then(deferred.resolve);
        else deferred.resolve(this._zip.generate(options));
        return deferred;
    }
});
$9f6a00af148b9df9$export$f0d0e79ed75962b9.JSZip = (0, (/*@__PURE__*/$parcel$interopDefault($jt1Do)));
function $9f6a00af148b9df9$export$7a171f172be0782e(data, options) {
    var excelCreator = new $9f6a00af148b9df9$export$f0d0e79ed75962b9(data, options);
    excelCreator._checkZipState();
    return excelCreator.ready().then(()=>excelCreator.getData((0, $6ntMu.isFunction)((0, $hYatw.getWindow)().Blob)));
}

});
parcelRegister("jt1Do", function(module, exports) {
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ 
var $ihoyg = parcelRequire("ihoyg");
var $e2c1fe4adf5792f6$require$Buffer = $ihoyg.Buffer;

var $4TNnu = parcelRequire("4TNnu");
!function(e) {
    module.exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\0\0",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $e2c1fe4adf5792f6$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($e2c1fe4adf5792f6$require$Buffer.from && $e2c1fe4adf5792f6$require$Buffer.from !== Uint8Array.from) return $e2c1fe4adf5792f6$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $e2c1fe4adf5792f6$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($e2c1fe4adf5792f6$require$Buffer.alloc) return $e2c1fe4adf5792f6$require$Buffer.alloc(e);
                        var t = new $e2c1fe4adf5792f6$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $e2c1fe4adf5792f6$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK\x03\x04", r.CENTRAL_FILE_HEADER = "PK\x01\x02", r.CENTRAL_DIRECTORY_END = "PK\x05\x06", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06", r.DATA_DESCRIPTOR = "PK\x07\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $e2c1fe4adf5792f6$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $e2c1fe4adf5792f6$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $4TNnu.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});

});
parcelRegister("ihoyg", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $d4ecdbf520e63dca$export$a143d493d941bafc; }, function (v) { return $d4ecdbf520e63dca$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $d4ecdbf520e63dca$export$f99ded8fe4b79145; }, function (v) { return $d4ecdbf520e63dca$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d4ecdbf520e63dca$export$a143d493d941bafc;
var $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a;
var $d4ecdbf520e63dca$export$f99ded8fe4b79145;
var $d4ecdbf520e63dca$export$599f31c3813fae4d;
"use strict";

var $hqZtu = parcelRequire("hqZtu");

var $5WQj6 = parcelRequire("5WQj6");
var $d4ecdbf520e63dca$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$d4ecdbf520e63dca$export$a143d493d941bafc = $d4ecdbf520e63dca$var$Buffer;
$d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = $d4ecdbf520e63dca$var$SlowBuffer;
$d4ecdbf520e63dca$export$f99ded8fe4b79145 = 50;
var $d4ecdbf520e63dca$var$K_MAX_LENGTH = 0x7fffffff;
$d4ecdbf520e63dca$export$599f31c3813fae4d = $d4ecdbf520e63dca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT = $d4ecdbf520e63dca$var$typedArraySupport();
if (!$d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d4ecdbf520e63dca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d4ecdbf520e63dca$var$createBuffer(length) {
    if (length > $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d4ecdbf520e63dca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d4ecdbf520e63dca$var$allocUnsafe(arg);
    }
    return $d4ecdbf520e63dca$var$from(arg, encodingOrOffset, length);
}
$d4ecdbf520e63dca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $d4ecdbf520e63dca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d4ecdbf520e63dca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d4ecdbf520e63dca$var$isInstance(value, ArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, ArrayBuffer)) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($d4ecdbf520e63dca$var$isInstance(value, SharedArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, SharedArrayBuffer))) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d4ecdbf520e63dca$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d4ecdbf520e63dca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $d4ecdbf520e63dca$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d4ecdbf520e63dca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer, Uint8Array);
function $d4ecdbf520e63dca$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d4ecdbf520e63dca$var$alloc(size, fill, encoding) {
    $d4ecdbf520e63dca$var$assertSize(size);
    if (size <= 0) return $d4ecdbf520e63dca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $d4ecdbf520e63dca$var$createBuffer(size).fill(fill, encoding) : $d4ecdbf520e63dca$var$createBuffer(size).fill(fill);
    return $d4ecdbf520e63dca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d4ecdbf520e63dca$var$Buffer.alloc = function(size, fill, encoding) {
    return $d4ecdbf520e63dca$var$alloc(size, fill, encoding);
};
function $d4ecdbf520e63dca$var$allocUnsafe(size) {
    $d4ecdbf520e63dca$var$assertSize(size);
    return $d4ecdbf520e63dca$var$createBuffer(size < 0 ? 0 : $d4ecdbf520e63dca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d4ecdbf520e63dca$var$Buffer.allocUnsafe = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d4ecdbf520e63dca$var$Buffer.allocUnsafeSlow = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
function $d4ecdbf520e63dca$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $d4ecdbf520e63dca$var$byteLength(string, encoding) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d4ecdbf520e63dca$var$checked(array.length) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayView(arrayView) {
    if ($d4ecdbf520e63dca$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d4ecdbf520e63dca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d4ecdbf520e63dca$var$fromArrayLike(arrayView);
}
function $d4ecdbf520e63dca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
function $d4ecdbf520e63dca$var$fromObject(obj) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(obj)) {
        var len = $d4ecdbf520e63dca$var$checked(obj.length) | 0;
        var buf = $d4ecdbf520e63dca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $d4ecdbf520e63dca$var$numberIsNaN(obj.length)) return $d4ecdbf520e63dca$var$createBuffer(0);
        return $d4ecdbf520e63dca$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $d4ecdbf520e63dca$var$fromArrayLike(obj.data);
}
function $d4ecdbf520e63dca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d4ecdbf520e63dca$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $d4ecdbf520e63dca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d4ecdbf520e63dca$var$Buffer.alloc(+length);
}
$d4ecdbf520e63dca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d4ecdbf520e63dca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d4ecdbf520e63dca$var$Buffer.compare = function compare(a, b) {
    if ($d4ecdbf520e63dca$var$isInstance(a, Uint8Array)) a = $d4ecdbf520e63dca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d4ecdbf520e63dca$var$isInstance(b, Uint8Array)) b = $d4ecdbf520e63dca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(a) || !$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d4ecdbf520e63dca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$d4ecdbf520e63dca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d4ecdbf520e63dca$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d4ecdbf520e63dca$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d4ecdbf520e63dca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $d4ecdbf520e63dca$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d4ecdbf520e63dca$var$byteLength(string, encoding) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d4ecdbf520e63dca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $d4ecdbf520e63dca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d4ecdbf520e63dca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d4ecdbf520e63dca$var$Buffer.byteLength = $d4ecdbf520e63dca$var$byteLength;
function $d4ecdbf520e63dca$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Slice(this, start, end);
        case "ascii":
            return $d4ecdbf520e63dca$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$latin1Slice(this, start, end);
        case "base64":
            return $d4ecdbf520e63dca$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d4ecdbf520e63dca$var$Buffer.prototype._isBuffer = true;
function $d4ecdbf520e63dca$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d4ecdbf520e63dca$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$d4ecdbf520e63dca$var$swap(this, i, i + 1);
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $d4ecdbf520e63dca$var$swap(this, i, i + 3);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $d4ecdbf520e63dca$var$swap(this, i, i + 7);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 6);
        $d4ecdbf520e63dca$var$swap(this, i + 2, i + 5);
        $d4ecdbf520e63dca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $d4ecdbf520e63dca$var$utf8Slice(this, 0, length);
    return $d4ecdbf520e63dca$var$slowToString.apply(this, arguments);
};
$d4ecdbf520e63dca$var$Buffer.prototype.toLocaleString = $d4ecdbf520e63dca$var$Buffer.prototype.toString;
$d4ecdbf520e63dca$var$Buffer.prototype.equals = function equals(b) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $d4ecdbf520e63dca$var$Buffer.compare(this, b) === 0;
};
$d4ecdbf520e63dca$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $d4ecdbf520e63dca$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($d4ecdbf520e63dca$var$customInspectSymbol) $d4ecdbf520e63dca$var$Buffer.prototype[$d4ecdbf520e63dca$var$customInspectSymbol] = $d4ecdbf520e63dca$var$Buffer.prototype.inspect;
$d4ecdbf520e63dca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d4ecdbf520e63dca$var$isInstance(target, Uint8Array)) target = $d4ecdbf520e63dca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d4ecdbf520e63dca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d4ecdbf520e63dca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $d4ecdbf520e63dca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d4ecdbf520e63dca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d4ecdbf520e63dca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d4ecdbf520e63dca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d4ecdbf520e63dca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d4ecdbf520e63dca$var$utf8Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d4ecdbf520e63dca$var$asciiWrite(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$asciiToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$base64Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$base64ToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$ucs2Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d4ecdbf520e63dca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $d4ecdbf520e63dca$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d4ecdbf520e63dca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d4ecdbf520e63dca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hqZtu.fromByteArray(buf);
    else return $hqZtu.fromByteArray(buf.slice(start, end));
}
function $d4ecdbf520e63dca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d4ecdbf520e63dca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d4ecdbf520e63dca$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d4ecdbf520e63dca$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d4ecdbf520e63dca$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d4ecdbf520e63dca$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $d4ecdbf520e63dca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d4ecdbf520e63dca$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d4ecdbf520e63dca$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d4ecdbf520e63dca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$d4ecdbf520e63dca$var$Buffer.prototype.readUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, true, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, false, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, true, 52, 8);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, false, 52, 8);
};
function $d4ecdbf520e63dca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $d4ecdbf520e63dca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, false, noAssert);
};
function $d4ecdbf520e63dca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d4ecdbf520e63dca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d4ecdbf520e63dca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d4ecdbf520e63dca$var$Buffer.isBuffer(val) ? val : $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $d4ecdbf520e63dca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d4ecdbf520e63dca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d4ecdbf520e63dca$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $d4ecdbf520e63dca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $d4ecdbf520e63dca$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d4ecdbf520e63dca$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d4ecdbf520e63dca$var$base64ToBytes(str) {
    return $hqZtu.toByteArray($d4ecdbf520e63dca$var$base64clean(str));
}
function $d4ecdbf520e63dca$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d4ecdbf520e63dca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d4ecdbf520e63dca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d4ecdbf520e63dca$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("hqZtu", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $034686670a8a195b$export$d622b2ad8d90c771; }, function (v) { return $034686670a8a195b$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $034686670a8a195b$export$6100ba28696e12de; }, function (v) { return $034686670a8a195b$export$6100ba28696e12de = v; });
var $034686670a8a195b$export$a48f0734ac7c2329;
var $034686670a8a195b$export$d622b2ad8d90c771;
var $034686670a8a195b$export$6100ba28696e12de;
"use strict";
$034686670a8a195b$export$a48f0734ac7c2329 = $034686670a8a195b$var$byteLength;
$034686670a8a195b$export$d622b2ad8d90c771 = $034686670a8a195b$var$toByteArray;
$034686670a8a195b$export$6100ba28696e12de = $034686670a8a195b$var$fromByteArray;
var $034686670a8a195b$var$lookup = [];
var $034686670a8a195b$var$revLookup = [];
var $034686670a8a195b$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $034686670a8a195b$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $034686670a8a195b$var$i = 0, $034686670a8a195b$var$len = $034686670a8a195b$var$code.length; $034686670a8a195b$var$i < $034686670a8a195b$var$len; ++$034686670a8a195b$var$i){
    $034686670a8a195b$var$lookup[$034686670a8a195b$var$i] = $034686670a8a195b$var$code[$034686670a8a195b$var$i];
    $034686670a8a195b$var$revLookup[$034686670a8a195b$var$code.charCodeAt($034686670a8a195b$var$i)] = $034686670a8a195b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$034686670a8a195b$var$revLookup["-".charCodeAt(0)] = 62;
$034686670a8a195b$var$revLookup["_".charCodeAt(0)] = 63;
function $034686670a8a195b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $034686670a8a195b$var$byteLength(b64) {
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$toByteArray(b64) {
    var tmp;
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $034686670a8a195b$var$Arr($034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 18 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 2 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 10 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $034686670a8a195b$var$tripletToBase64(num) {
    return $034686670a8a195b$var$lookup[num >> 18 & 0x3F] + $034686670a8a195b$var$lookup[num >> 12 & 0x3F] + $034686670a8a195b$var$lookup[num >> 6 & 0x3F] + $034686670a8a195b$var$lookup[num & 0x3F];
}
function $034686670a8a195b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($034686670a8a195b$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $034686670a8a195b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($034686670a8a195b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 2] + $034686670a8a195b$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 10] + $034686670a8a195b$var$lookup[tmp >> 4 & 0x3F] + $034686670a8a195b$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("5WQj6", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $454af19f7384844b$export$aafa59e2e03f2942; }, function (v) { return $454af19f7384844b$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $454af19f7384844b$export$68d8715fc104d294; }, function (v) { return $454af19f7384844b$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $454af19f7384844b$export$aafa59e2e03f2942;
var $454af19f7384844b$export$68d8715fc104d294;
$454af19f7384844b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$454af19f7384844b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("4TNnu", function(module, exports) {
// shim for using process in browser
var $391299e0893a3dfa$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};

});


parcelRegister("iWekk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc98c1ce3cca59d0$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/exporter/excel_format_converter.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $9vHY4 = parcelRequire("9vHY4");

var $8qyBL = parcelRequire("8qyBL");

var $8gWak = parcelRequire("8gWak");

var $6ntMu = parcelRequire("6ntMu");

var $9oJex = parcelRequire("9oJex");

var $iCO5E = parcelRequire("iCO5E");
parcelRequire("i9oc6");
var $dc98c1ce3cca59d0$var$ARABIC_ZERO_CODE = 1632;
var $dc98c1ce3cca59d0$var$DEFINED_NUMBER_FORMTATS = {
    thousands: "#,##0{0},&quot;K&quot;",
    millions: "#,##0{0},,&quot;M&quot;",
    billions: "#,##0{0},,,&quot;B&quot;",
    trillions: "#,##0{0},,,,&quot;T&quot;",
    percent: "0{0}%",
    decimal: "#{0}",
    fixedpoint: "#,##0{0}",
    exponential: "0{0}E+00",
    currency: " "
};
var $dc98c1ce3cca59d0$var$PERIOD_REGEXP = /a+/g;
var $dc98c1ce3cca59d0$var$DAY_REGEXP = /E/g;
var $dc98c1ce3cca59d0$var$DO_REGEXP = /dE+/g;
var $dc98c1ce3cca59d0$var$STANDALONE_MONTH_REGEXP = /L/g;
var $dc98c1ce3cca59d0$var$HOUR_REGEXP = /h/g;
var $dc98c1ce3cca59d0$var$ANY_REGEXP = /./g;
var $dc98c1ce3cca59d0$var$excelFormatConverter = {
    _applyPrecision: function(format, precision) {
        var result;
        var i;
        if (precision > 0) {
            result = "decimal" !== format ? "." : "";
            for(i = 0; i < precision; i++)result += "0";
            return result;
        }
        return "";
    },
    _hasArabicDigits: function(text) {
        var code;
        for(var i = 0; i < text.length; i++){
            code = text.charCodeAt(i);
            if (code >= $dc98c1ce3cca59d0$var$ARABIC_ZERO_CODE && code < $dc98c1ce3cca59d0$var$ARABIC_ZERO_CODE + 10) return true;
        }
        return false;
    },
    _convertDateFormatToOpenXml: function(format) {
        return format.split("/").join("\\/").split("'").map(function(datePart, index) {
            if (index % 2 === 0) return datePart.replace($dc98c1ce3cca59d0$var$PERIOD_REGEXP, "AM/PM").replace($dc98c1ce3cca59d0$var$DO_REGEXP, "d").replace($dc98c1ce3cca59d0$var$DAY_REGEXP, "d").replace($dc98c1ce3cca59d0$var$STANDALONE_MONTH_REGEXP, "M").replace($dc98c1ce3cca59d0$var$HOUR_REGEXP, "H").split("[").join("\\[").split("]").join("\\]");
            if (datePart) return datePart.replace($dc98c1ce3cca59d0$var$ANY_REGEXP, "\\$&");
            return "'";
        }).join("");
    },
    _convertDateFormat: function(format) {
        var formattedValue = ((0, $8gWak.default).format(new Date(2009, 8, 8, 6, 5, 4), format) || "").toString();
        var result = (0, $9oJex.getFormat)((value)=>(0, $8gWak.default).format(value, format));
        if (result) {
            result = this._convertDateFormatToOpenXml(result);
            result = this._getLanguageInfo(formattedValue) + result;
        }
        return result;
    },
    _getLanguageInfo: function(defaultPattern) {
        var languageID = (0, $iCO5E.getLanguageId)();
        var languageIDStr = languageID ? languageID.toString(16) : "";
        var languageInfo = "";
        if (this._hasArabicDigits(defaultPattern)) {
            while(languageIDStr.length < 3)languageIDStr = "0" + languageIDStr;
            languageInfo = "[$-2010" + languageIDStr + "]";
        } else if (languageIDStr) languageInfo = "[$-" + languageIDStr + "]";
        return languageInfo;
    },
    _convertNumberFormat: function(format, precision, currency) {
        var result;
        var excelFormat;
        if ("currency" === format) excelFormat = (0, $8qyBL.default).getOpenXmlCurrencyFormat(currency);
        else excelFormat = $dc98c1ce3cca59d0$var$DEFINED_NUMBER_FORMTATS[format.toLowerCase()];
        if (excelFormat) result = (0, $9vHY4.format)(excelFormat, this._applyPrecision(format, precision));
        return result;
    },
    convertFormat: function(format, precision, type, currency) {
        if ((0, $6ntMu.isDefined)(format)) {
            if ("date" === type) return $dc98c1ce3cca59d0$var$excelFormatConverter._convertDateFormat(format);
            else if ((0, $6ntMu.isString)(format) && $dc98c1ce3cca59d0$var$DEFINED_NUMBER_FORMTATS[format.toLowerCase()]) return $dc98c1ce3cca59d0$var$excelFormatConverter._convertNumberFormat(format, precision, currency);
        }
    }
};
var $dc98c1ce3cca59d0$export$2e2bcd8739ae039 = $dc98c1ce3cca59d0$var$excelFormatConverter;

});
parcelRegister("iCO5E", function(module, exports) {

$parcel$export(module.exports, "getLanguageId", function () { return $d8f2a17ccd5f39ba$export$6adf9b057a2a1827; });
/**
 * DevExtreme (esm/localization/language_codes.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $iTFn1 = parcelRequire("iTFn1");
var $d8f2a17ccd5f39ba$var$LANGUAGE_CODES = {
    ar: 1,
    bg: 2,
    ca: 3,
    "zh-Hans": 4,
    cs: 5,
    da: 6,
    de: 7,
    el: 8,
    en: 9,
    es: 10,
    fi: 11,
    fr: 12,
    he: 13,
    hu: 14,
    is: 15,
    it: 16,
    ja: 17,
    ko: 18,
    nl: 19,
    no: 20,
    pl: 21,
    pt: 22,
    rm: 23,
    ro: 24,
    ru: 25,
    hr: 26,
    sk: 27,
    sq: 28,
    sv: 29,
    th: 30,
    tr: 31,
    ur: 32,
    id: 33,
    uk: 34,
    be: 35,
    sl: 36,
    et: 37,
    lv: 38,
    lt: 39,
    tg: 40,
    fa: 41,
    vi: 42,
    hy: 43,
    az: 44,
    eu: 45,
    hsb: 46,
    mk: 47,
    tn: 50,
    xh: 52,
    zu: 53,
    af: 54,
    ka: 55,
    fo: 56,
    hi: 57,
    mt: 58,
    se: 59,
    ga: 60,
    ms: 62,
    kk: 63,
    ky: 64,
    sw: 65,
    tk: 66,
    uz: 67,
    tt: 68,
    bn: 69,
    pa: 70,
    gu: 71,
    or: 72,
    ta: 73,
    te: 74,
    kn: 75,
    ml: 76,
    as: 77,
    mr: 78,
    sa: 79,
    mn: 80,
    bo: 81,
    cy: 82,
    km: 83,
    lo: 84,
    gl: 86,
    kok: 87,
    syr: 90,
    si: 91,
    iu: 93,
    am: 94,
    tzm: 95,
    ne: 97,
    fy: 98,
    ps: 99,
    fil: 100,
    dv: 101,
    ha: 104,
    yo: 106,
    quz: 107,
    nso: 108,
    ba: 109,
    lb: 110,
    kl: 111,
    ig: 112,
    ii: 120,
    arn: 122,
    moh: 124,
    br: 126,
    ug: 128,
    mi: 129,
    oc: 130,
    co: 131,
    gsw: 132,
    sah: 133,
    qut: 134,
    rw: 135,
    wo: 136,
    prs: 140,
    gd: 145,
    "ar-SA": 1025,
    "bg-BG": 1026,
    "ca-ES": 1027,
    "zh-TW": 1028,
    "cs-CZ": 1029,
    "da-DK": 1030,
    "de-DE": 1031,
    "el-GR": 1032,
    "en-US": 1033,
    "fi-FI": 1035,
    "fr-FR": 1036,
    "he-IL": 1037,
    "hu-HU": 1038,
    "is-IS": 1039,
    "it-IT": 1040,
    "ja-JP": 1041,
    "ko-KR": 1042,
    "nl-NL": 1043,
    "nb-NO": 1044,
    "pl-PL": 1045,
    "pt-BR": 1046,
    "rm-CH": 1047,
    "ro-RO": 1048,
    "ru-RU": 1049,
    "hr-HR": 1050,
    "sk-SK": 1051,
    "sq-AL": 1052,
    "sv-SE": 1053,
    "th-TH": 1054,
    "tr-TR": 1055,
    "ur-PK": 1056,
    "id-ID": 1057,
    "uk-UA": 1058,
    "be-BY": 1059,
    "sl-SI": 1060,
    "et-EE": 1061,
    "lv-LV": 1062,
    "lt-LT": 1063,
    "tg-Cyrl-TJ": 1064,
    "fa-IR": 1065,
    "vi-VN": 1066,
    "hy-AM": 1067,
    "az-Latn-AZ": 1068,
    "eu-ES": 1069,
    "hsb-DE": 1070,
    "mk-MK": 1071,
    "tn-ZA": 1074,
    "xh-ZA": 1076,
    "zu-ZA": 1077,
    "af-ZA": 1078,
    "ka-GE": 1079,
    "fo-FO": 1080,
    "hi-IN": 1081,
    "mt-MT": 1082,
    "se-NO": 1083,
    "ms-MY": 1086,
    "kk-KZ": 1087,
    "ky-KG": 1088,
    "sw-KE": 1089,
    "tk-TM": 1090,
    "uz-Latn-UZ": 1091,
    "tt-RU": 1092,
    "bn-IN": 1093,
    "pa-IN": 1094,
    "gu-IN": 1095,
    "or-IN": 1096,
    "ta-IN": 1097,
    "te-IN": 1098,
    "kn-IN": 1099,
    "ml-IN": 1100,
    "as-IN": 1101,
    "mr-IN": 1102,
    "sa-IN": 1103,
    "mn-MN": 1104,
    "bo-CN": 1105,
    "cy-GB": 1106,
    "km-KH": 1107,
    "lo-LA": 1108,
    "gl-ES": 1110,
    "kok-IN": 1111,
    "syr-SY": 1114,
    "si-LK": 1115,
    "iu-Cans-CA": 1117,
    "am-ET": 1118,
    "ne-NP": 1121,
    "fy-NL": 1122,
    "ps-AF": 1123,
    "fil-PH": 1124,
    "dv-MV": 1125,
    "ha-Latn-NG": 1128,
    "yo-NG": 1130,
    "quz-BO": 1131,
    "nso-ZA": 1132,
    "ba-RU": 1133,
    "lb-LU": 1134,
    "kl-GL": 1135,
    "ig-NG": 1136,
    "ii-CN": 1144,
    "arn-CL": 1146,
    "moh-CA": 1148,
    "br-FR": 1150,
    "ug-CN": 1152,
    "mi-NZ": 1153,
    "oc-FR": 1154,
    "co-FR": 1155,
    "gsw-FR": 1156,
    "sah-RU": 1157,
    "qut-GT": 1158,
    "rw-RW": 1159,
    "wo-SN": 1160,
    "prs-AF": 1164,
    "gd-GB": 1169,
    "ar-IQ": 2049,
    "zh-CN": 2052,
    "de-CH": 2055,
    "en-GB": 2057,
    "es-MX": 2058,
    "fr-BE": 2060,
    "it-CH": 2064,
    "nl-BE": 2067,
    "nn-NO": 2068,
    "pt-PT": 2070,
    "sr-Latn-CS": 2074,
    "sv-FI": 2077,
    "az-Cyrl-AZ": 2092,
    "dsb-DE": 2094,
    "se-SE": 2107,
    "ga-IE": 2108,
    "ms-BN": 2110,
    "uz-Cyrl-UZ": 2115,
    "bn-BD": 2117,
    "mn-Mong-CN": 2128,
    "iu-Latn-CA": 2141,
    "tzm-Latn-DZ": 2143,
    "quz-EC": 2155,
    "ar-EG": 3073,
    "zh-HK": 3076,
    "de-AT": 3079,
    "en-AU": 3081,
    "es-ES": 3082,
    "fr-CA": 3084,
    "sr-Cyrl-CS": 3098,
    "se-FI": 3131,
    "quz-PE": 3179,
    "ar-LY": 4097,
    "zh-SG": 4100,
    "de-LU": 4103,
    "en-CA": 4105,
    "es-GT": 4106,
    "fr-CH": 4108,
    "hr-BA": 4122,
    "smj-NO": 4155,
    "ar-DZ": 5121,
    "zh-MO": 5124,
    "de-LI": 5127,
    "en-NZ": 5129,
    "es-CR": 5130,
    "fr-LU": 5132,
    "bs-Latn-BA": 5146,
    "smj-SE": 5179,
    "ar-MA": 6145,
    "en-IE": 6153,
    "es-PA": 6154,
    "fr-MC": 6156,
    "sr-Latn-BA": 6170,
    "sma-NO": 6203,
    "ar-TN": 7169,
    "en-ZA": 7177,
    "es-DO": 7178,
    "sr-Cyrl-BA": 7194,
    "sma-SE": 7227,
    "ar-OM": 8193,
    "en-JM": 8201,
    "es-VE": 8202,
    "bs-Cyrl-BA": 8218,
    "sms-FI": 8251,
    "ar-YE": 9217,
    "en-029": 9225,
    "es-CO": 9226,
    "sr-Latn-RS": 9242,
    "smn-FI": 9275,
    "ar-SY": 10241,
    "en-BZ": 10249,
    "es-PE": 10250,
    "sr-Cyrl-RS": 10266,
    "ar-JO": 11265,
    "en-TT": 11273,
    "es-AR": 11274,
    "sr-Latn-ME": 11290,
    "ar-LB": 12289,
    "en-ZW": 12297,
    "es-EC": 12298,
    "sr-Cyrl-ME": 12314,
    "ar-KW": 13313,
    "en-PH": 13321,
    "es-CL": 13322,
    "ar-AE": 14337,
    "es-UY": 14346,
    "ar-BH": 15361,
    "es-PY": 15370,
    "ar-QA": 16385,
    "en-IN": 16393,
    "es-BO": 16394,
    "en-MY": 17417,
    "es-SV": 17418,
    "en-SG": 18441,
    "es-HN": 18442,
    "es-NI": 19466,
    "es-PR": 20490,
    "es-US": 21514,
    "bs-Cyrl": 25626,
    "bs-Latn": 26650,
    "sr-Cyrl": 27674,
    "sr-Latn": 28698,
    smn: 28731,
    "az-Cyrl": 29740,
    sms: 29755,
    zh: 30724,
    nn: 30740,
    bs: 30746,
    "az-Latn": 30764,
    sma: 30779,
    "uz-Cyrl": 30787,
    "mn-Cyrl": 30800,
    "iu-Cans": 30813,
    "zh-Hant": 31748,
    nb: 31764,
    sr: 31770,
    "tg-Cyrl": 31784,
    dsb: 31790,
    smj: 31803,
    "uz-Latn": 31811,
    "mn-Mong": 31824,
    "iu-Latn": 31837,
    "tzm-Latn": 31839,
    "ha-Latn": 31848
};
function $d8f2a17ccd5f39ba$export$6adf9b057a2a1827() {
    return $d8f2a17ccd5f39ba$var$LANGUAGE_CODES[(0, $iTFn1.default).locale()];
}

});


parcelRegister("diyO6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ae7f4c5cbdd51b0$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/exporter/excel/excel.file.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $4zgsW = parcelRequire("4zgsW");

var $boYDu = parcelRequire("boYDu");

var $klm0K = parcelRequire("klm0K");

var $WEbrM = parcelRequire("WEbrM");

var $9KqrD = parcelRequire("9KqrD");
class $9ae7f4c5cbdd51b0$export$2e2bcd8739ae039 {
    constructor(){
        this._cellFormatTags = [];
        this._fillTags = [];
        this._fontTags = [];
        this._numberFormatTags = [];
        this._fillTags.push((0, $klm0K.default).tryCreateTag({
            patternFill: {
                patternType: "none"
            }
        }));
    }
    registerCellFormat(cellFormat) {
        var result;
        var cellFormatTag = (0, $boYDu.default).tryCreateTag(cellFormat, {
            registerFill: this.registerFill.bind(this),
            registerFont: this.registerFont.bind(this),
            registerNumberFormat: this.registerNumberFormat.bind(this)
        });
        if ((0, $6ntMu.isDefined)(cellFormatTag)) {
            for(var i = 0; i < this._cellFormatTags.length; i++)if ((0, $boYDu.default).areEqual(this._cellFormatTags[i], cellFormatTag)) {
                result = i;
                break;
            }
            if (void 0 === result) result = this._cellFormatTags.push(cellFormatTag) - 1;
        }
        return result;
    }
    static copyCellFormat(source) {
        return (0, $boYDu.default).copy(source);
    }
    generateCellFormatsXml() {
        var cellFormatTagsAsXmlStringsArray = this._cellFormatTags.map((tag)=>(0, $boYDu.default).toXml(tag));
        return (0, $4zgsW.default).toXml("cellXfs", {
            count: cellFormatTagsAsXmlStringsArray.length
        }, cellFormatTagsAsXmlStringsArray.join(""));
    }
    registerFill(fill) {
        var result;
        var fillTag = (0, $klm0K.default).tryCreateTag(fill);
        if ((0, $6ntMu.isDefined)(fillTag)) {
            for(var i = 0; i < this._fillTags.length; i++)if ((0, $klm0K.default).areEqual(this._fillTags[i], fillTag)) {
                result = i;
                break;
            }
            if (void 0 === result) {
                if (this._fillTags.length < 2) this._fillTags.push((0, $klm0K.default).tryCreateTag({
                    patternFill: {
                        patternType: "Gray125"
                    }
                }));
                result = this._fillTags.push(fillTag) - 1;
            }
        }
        return result;
    }
    generateFillsXml() {
        var tagsAsXmlStringsArray = this._fillTags.map((tag)=>(0, $klm0K.default).toXml(tag));
        return (0, $4zgsW.default).toXml("fills", {
            count: tagsAsXmlStringsArray.length
        }, tagsAsXmlStringsArray.join(""));
    }
    registerFont(font) {
        var result;
        var fontTag = (0, $WEbrM.default).tryCreateTag(font);
        if ((0, $6ntMu.isDefined)(fontTag)) {
            for(var i = 0; i < this._fontTags.length; i++)if ((0, $WEbrM.default).areEqual(this._fontTags[i], fontTag)) {
                result = i;
                break;
            }
            if (void 0 === result) result = this._fontTags.push(fontTag) - 1;
        }
        return result;
    }
    generateFontsXml() {
        var xmlStringsArray = this._fontTags.map((tag)=>(0, $WEbrM.default).toXml(tag));
        return (0, $4zgsW.default).toXml("fonts", {
            count: xmlStringsArray.length
        }, xmlStringsArray.join(""));
    }
    _convertNumberFormatIndexToId(index) {
        return 165 + index;
    }
    registerNumberFormat(numberFormat) {
        var result;
        var tag = (0, $9KqrD.default).tryCreateTag(numberFormat);
        if ((0, $6ntMu.isDefined)(tag)) {
            for(var i = 0; i < this._numberFormatTags.length; i++)if ((0, $9KqrD.default).areEqual(this._numberFormatTags[i], tag)) {
                result = this._numberFormatTags[i][(0, $9KqrD.default).ID_PROPERTY_NAME];
                break;
            }
            if (void 0 === result) {
                tag[(0, $9KqrD.default).ID_PROPERTY_NAME] = this._convertNumberFormatIndexToId(this._numberFormatTags.length);
                result = tag[(0, $9KqrD.default).ID_PROPERTY_NAME];
                this._numberFormatTags.push(tag);
            }
        }
        return result;
    }
    generateNumberFormatsXml() {
        if (this._numberFormatTags.length > 0) {
            var xmlStringsArray = this._numberFormatTags.map((tag)=>(0, $9KqrD.default).toXml(tag));
            return (0, $4zgsW.default).toXml("numFmts", {
                count: xmlStringsArray.length
            }, xmlStringsArray.join(""));
        } else return "";
    }
}

});
parcelRegister("4zgsW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3537341413d4a350$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/exporter/excel/excel.tag_helper.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");
var $3537341413d4a350$var$tagHelper = {
    toXml: function(tagName, attributes, content) {
        var result = [
            "<",
            tagName
        ];
        for(var attributeName in attributes){
            var attributeValue = attributes[attributeName];
            if ((0, $6ntMu.isDefined)(attributeValue)) result.push(" ", attributeName, '="', attributeValue, '"');
        }
        if ((0, $6ntMu.isDefined)(content) && "" !== content) result.push(">", content, "</", tagName, ">");
        else result.push(" />");
        return result.join("");
    }
};
var $3537341413d4a350$export$2e2bcd8739ae039 = $3537341413d4a350$var$tagHelper;

});

parcelRegister("boYDu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84d0f8a1da902851$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/exporter/excel/excel.cell_format_helper.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $4zgsW = parcelRequire("4zgsW");

var $bwNWz = parcelRequire("bwNWz");

var $klm0K = parcelRequire("klm0K");

var $WEbrM = parcelRequire("WEbrM");
var $84d0f8a1da902851$var$cellFormatHelper = {
    tryCreateTag: function(sourceObj, sharedItemsContainer) {
        var result = null;
        if ((0, $6ntMu.isDefined)(sourceObj)) {
            var numberFormatId;
            if ("number" === typeof sourceObj.numberFormat) numberFormatId = sourceObj.numberFormat;
            else numberFormatId = sharedItemsContainer.registerNumberFormat(sourceObj.numberFormat);
            var fill = sourceObj.fill;
            if (!(0, $6ntMu.isDefined)(fill)) fill = (0, $klm0K.default).tryCreateFillFromSimpleFormat(sourceObj);
            result = {
                numberFormatId: numberFormatId,
                alignment: (0, $bwNWz.default).tryCreateTag(sourceObj.alignment),
                fontId: sharedItemsContainer.registerFont(sourceObj.font),
                fillId: sharedItemsContainer.registerFill(fill)
            };
            if ($84d0f8a1da902851$var$cellFormatHelper.isEmpty(result)) result = null;
        }
        return result;
    },
    copy: function(source) {
        var result;
        if (null === source) result = null;
        else if ((0, $6ntMu.isDefined)(source)) {
            result = {};
            if (void 0 !== source.numberFormat) result.numberFormat = source.numberFormat;
            if (void 0 !== source.fill) result.fill = (0, $klm0K.default).copy(source.fill);
            else (0, $klm0K.default).copySimpleFormat(source, result);
            if (void 0 !== source.alignment) result.alignment = (0, $bwNWz.default).copy(source.alignment);
            if (void 0 !== source.font) result.font = (0, $WEbrM.default).copy(source.font);
        }
        return result;
    },
    areEqual: function(leftTag, rightTag) {
        return $84d0f8a1da902851$var$cellFormatHelper.isEmpty(leftTag) && $84d0f8a1da902851$var$cellFormatHelper.isEmpty(rightTag) || (0, $6ntMu.isDefined)(leftTag) && (0, $6ntMu.isDefined)(rightTag) && leftTag.fontId === rightTag.fontId && leftTag.numberFormatId === rightTag.numberFormatId && leftTag.fillId === rightTag.fillId && (0, $bwNWz.default).areEqual(leftTag.alignment, rightTag.alignment);
    },
    isEmpty: function(tag) {
        return !(0, $6ntMu.isDefined)(tag) || !(0, $6ntMu.isDefined)(tag.fontId) && !(0, $6ntMu.isDefined)(tag.numberFormatId) && !(0, $6ntMu.isDefined)(tag.fillId) && (0, $bwNWz.default).isEmpty(tag.alignment);
    },
    toXml: function(tag) {
        var isAlignmentEmpty = (0, $bwNWz.default).isEmpty(tag.alignment);
        var applyNumberFormat;
        if ((0, $6ntMu.isDefined)(tag.numberFormatId)) applyNumberFormat = tag.numberFormatId > 0 ? 1 : 0;
        return (0, $4zgsW.default).toXml("xf", {
            xfId: 0,
            applyAlignment: isAlignmentEmpty ? null : 1,
            fontId: tag.fontId,
            applyNumberFormat: applyNumberFormat,
            fillId: tag.fillId,
            numFmtId: tag.numberFormatId
        }, isAlignmentEmpty ? null : (0, $bwNWz.default).toXml(tag.alignment));
    }
};
var $84d0f8a1da902851$export$2e2bcd8739ae039 = $84d0f8a1da902851$var$cellFormatHelper;

});
parcelRegister("bwNWz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86496c9f36b162b4$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/exporter/excel/excel.cell_alignment_helper.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $4zgsW = parcelRequire("4zgsW");
var $86496c9f36b162b4$var$cellAlignmentHelper = {
    tryCreateTag: function(sourceObj) {
        var result = null;
        if ((0, $6ntMu.isDefined)(sourceObj)) {
            result = {
                vertical: sourceObj.vertical,
                wrapText: sourceObj.wrapText,
                horizontal: sourceObj.horizontal
            };
            if ($86496c9f36b162b4$var$cellAlignmentHelper.isEmpty(result)) result = null;
        }
        return result;
    },
    copy: function(source) {
        var result = null;
        if ((0, $6ntMu.isDefined)(source)) {
            result = {};
            if (void 0 !== source.horizontal) result.horizontal = source.horizontal;
            if (void 0 !== source.vertical) result.vertical = source.vertical;
            if (void 0 !== source.wrapText) result.wrapText = source.wrapText;
        }
        return result;
    },
    areEqual: function(leftTag, rightTag) {
        return $86496c9f36b162b4$var$cellAlignmentHelper.isEmpty(leftTag) && $86496c9f36b162b4$var$cellAlignmentHelper.isEmpty(rightTag) || (0, $6ntMu.isDefined)(leftTag) && (0, $6ntMu.isDefined)(rightTag) && leftTag.vertical === rightTag.vertical && leftTag.wrapText === rightTag.wrapText && leftTag.horizontal === rightTag.horizontal;
    },
    isEmpty: function(tag) {
        return !(0, $6ntMu.isDefined)(tag) || !(0, $6ntMu.isDefined)(tag.vertical) && !(0, $6ntMu.isDefined)(tag.wrapText) && !(0, $6ntMu.isDefined)(tag.horizontal);
    },
    toXml: function(tag) {
        return (0, $4zgsW.default).toXml("alignment", {
            vertical: tag.vertical,
            wrapText: (0, $6ntMu.isDefined)(tag.wrapText) ? Number(tag.wrapText) : void 0,
            horizontal: tag.horizontal
        });
    }
};
var $86496c9f36b162b4$export$2e2bcd8739ae039 = $86496c9f36b162b4$var$cellAlignmentHelper;

});

parcelRegister("klm0K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecf6d7c64e296497$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/exporter/excel/excel.fill_helper.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $4zgsW = parcelRequire("4zgsW");

var $hk6iO = parcelRequire("hk6iO");
var $ecf6d7c64e296497$var$fillHelper = {
    tryCreateTag: function(sourceObj) {
        var result = null;
        if ((0, $6ntMu.isDefined)(sourceObj)) {
            result = {
                patternFill: (0, $hk6iO.default).tryCreateTag(sourceObj.patternFill)
            };
            if ($ecf6d7c64e296497$var$fillHelper.isEmpty(result)) result = null;
        }
        return result;
    },
    tryCreateFillFromSimpleFormat: function() {
        var { backgroundColor: backgroundColor, fillPatternType: fillPatternType, fillPatternColor: fillPatternColor } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        if ((0, $6ntMu.isDefined)(backgroundColor) && !((0, $6ntMu.isDefined)(fillPatternType) && (0, $6ntMu.isDefined)(fillPatternColor))) return {
            patternFill: {
                patternType: "solid",
                foregroundColor: {
                    rgb: backgroundColor
                }
            }
        };
        else if ((0, $6ntMu.isDefined)(fillPatternType) && (0, $6ntMu.isDefined)(fillPatternColor)) return {
            patternFill: {
                patternType: fillPatternType,
                foregroundColor: {
                    rgb: fillPatternColor
                },
                backgroundColor: {
                    rgb: backgroundColor
                }
            }
        };
    },
    copySimpleFormat: function(source, target) {
        if (void 0 !== source.backgroundColor) target.backgroundColor = source.backgroundColor;
        if (void 0 !== source.fillPatternType) target.fillPatternType = source.fillPatternType;
        if (void 0 !== source.fillPatternColor) target.fillPatternColor = source.fillPatternColor;
    },
    copy: function(source) {
        var result = null;
        if ((0, $6ntMu.isDefined)(source)) {
            result = {};
            if (void 0 !== source.patternFill) result.patternFill = (0, $hk6iO.default).copy(source.patternFill);
        }
        return result;
    },
    areEqual: function(leftTag, rightTag) {
        return $ecf6d7c64e296497$var$fillHelper.isEmpty(leftTag) && $ecf6d7c64e296497$var$fillHelper.isEmpty(rightTag) || (0, $6ntMu.isDefined)(leftTag) && (0, $6ntMu.isDefined)(rightTag) && (0, $hk6iO.default).areEqual(leftTag.patternFill, rightTag.patternFill);
    },
    isEmpty: function(tag) {
        return !(0, $6ntMu.isDefined)(tag) || (0, $hk6iO.default).isEmpty(tag.patternFill);
    },
    toXml: function(tag) {
        return (0, $4zgsW.default).toXml("fill", {}, (0, $hk6iO.default).toXml(tag.patternFill));
    }
};
var $ecf6d7c64e296497$export$2e2bcd8739ae039 = $ecf6d7c64e296497$var$fillHelper;

});
parcelRegister("hk6iO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9c931726bf8c9a9$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/exporter/excel/excel.pattern_fill_helper.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $4zgsW = parcelRequire("4zgsW");

var $5neL0 = parcelRequire("5neL0");
var $c9c931726bf8c9a9$var$patternFillHelper = {
    tryCreateTag: function(sourceObj) {
        var result = null;
        if ((0, $6ntMu.isDefined)(sourceObj)) {
            result = {
                patternType: sourceObj.patternType,
                backgroundColor: (0, $5neL0.default).tryCreateTag(sourceObj.backgroundColor),
                foregroundColor: (0, $5neL0.default).tryCreateTag(sourceObj.foregroundColor)
            };
            if ($c9c931726bf8c9a9$var$patternFillHelper.isEmpty(result)) result = null;
        }
        return result;
    },
    copy: function(source) {
        var result = null;
        if ((0, $6ntMu.isDefined)(source)) {
            result = {};
            if (void 0 !== source.patternType) result.patternType = source.patternType;
            if (void 0 !== source.backgroundColor) result.backgroundColor = (0, $5neL0.default).copy(source.backgroundColor);
            if (void 0 !== source.foregroundColor) result.foregroundColor = (0, $5neL0.default).copy(source.foregroundColor);
        }
        return result;
    },
    areEqual: function(leftTag, rightTag) {
        return $c9c931726bf8c9a9$var$patternFillHelper.isEmpty(leftTag) && $c9c931726bf8c9a9$var$patternFillHelper.isEmpty(rightTag) || (0, $6ntMu.isDefined)(leftTag) && (0, $6ntMu.isDefined)(rightTag) && leftTag.patternType === rightTag.patternType && (0, $5neL0.default).areEqual(leftTag.backgroundColor, rightTag.backgroundColor) && (0, $5neL0.default).areEqual(leftTag.foregroundColor, rightTag.foregroundColor);
    },
    isEmpty: function(tag) {
        return !(0, $6ntMu.isDefined)(tag) || !(0, $6ntMu.isDefined)(tag.patternType);
    },
    toXml: function(tag) {
        var content = [
            (0, $6ntMu.isDefined)(tag.foregroundColor) ? (0, $5neL0.default).toXml("fgColor", tag.foregroundColor) : "",
            (0, $6ntMu.isDefined)(tag.backgroundColor) ? (0, $5neL0.default).toXml("bgColor", tag.backgroundColor) : ""
        ].join("");
        return (0, $4zgsW.default).toXml("patternFill", {
            patternType: tag.patternType
        }, content);
    }
};
var $c9c931726bf8c9a9$export$2e2bcd8739ae039 = $c9c931726bf8c9a9$var$patternFillHelper;

});
parcelRegister("5neL0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e9a8c3657f0d748$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/exporter/excel/excel.color_helper.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $4zgsW = parcelRequire("4zgsW");
var $3e9a8c3657f0d748$var$colorHelper = {
    _tryConvertColor: function(source) {
        if ("string" !== typeof source) return source;
        var result;
        if (source.length > 0 && "#" === source[0]) {
            var colorCode = source.substr(1, source.length);
            if (6 === colorCode.length) result = "FF" + colorCode;
            else if (8 === colorCode.length) result = colorCode[6] + colorCode[7] + colorCode.substr(0, 6);
            else result = colorCode;
        } else result = source;
        return result;
    },
    tryCreateTag: function(sourceObj) {
        var result = null;
        if ((0, $6ntMu.isDefined)(sourceObj)) {
            if ("string" === typeof sourceObj) result = {
                rgb: this._tryConvertColor(sourceObj)
            };
            else result = {
                rgb: this._tryConvertColor(sourceObj.rgb),
                theme: sourceObj.theme
            };
            if ($3e9a8c3657f0d748$var$colorHelper.isEmpty(result)) result = null;
        }
        return result;
    },
    copy: function(source) {
        var result = null;
        if ((0, $6ntMu.isDefined)(source)) {
            if ("string" === typeof source) result = source;
            else {
                result = {};
                if (void 0 !== source.rgb) result.rgb = source.rgb;
                if (void 0 !== source.theme) result.theme = source.theme;
            }
        }
        return result;
    },
    isEmpty: function(tag) {
        return !(0, $6ntMu.isDefined)(tag) || !(0, $6ntMu.isDefined)(tag.rgb) && !(0, $6ntMu.isDefined)(tag.theme);
    },
    areEqual: function(leftTag, rightTag) {
        return $3e9a8c3657f0d748$var$colorHelper.isEmpty(leftTag) && $3e9a8c3657f0d748$var$colorHelper.isEmpty(rightTag) || (0, $6ntMu.isDefined)(leftTag) && (0, $6ntMu.isDefined)(rightTag) && leftTag.rgb === rightTag.rgb && leftTag.theme === rightTag.theme;
    },
    toXml: function(tagName, tag) {
        return (0, $4zgsW.default).toXml(tagName, {
            rgb: tag.rgb,
            theme: tag.theme
        });
    }
};
var $3e9a8c3657f0d748$export$2e2bcd8739ae039 = $3e9a8c3657f0d748$var$colorHelper;

});



parcelRegister("WEbrM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b049686b0446f3c$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/exporter/excel/excel.font_helper.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $4zgsW = parcelRequire("4zgsW");

var $5neL0 = parcelRequire("5neL0");
var $0b049686b0446f3c$var$fontHelper = {
    tryCreateTag: function(sourceObj) {
        var result = null;
        if ((0, $6ntMu.isDefined)(sourceObj)) {
            result = {
                size: sourceObj.size,
                name: sourceObj.name,
                family: sourceObj.family,
                scheme: sourceObj.scheme,
                bold: sourceObj.bold,
                italic: sourceObj.italic,
                underline: sourceObj.underline,
                color: (0, $5neL0.default).tryCreateTag(sourceObj.color)
            };
            if ($0b049686b0446f3c$var$fontHelper.isEmpty(result)) result = null;
        }
        return result;
    },
    copy: function(source) {
        var result = null;
        if ((0, $6ntMu.isDefined)(source)) {
            result = {};
            if (void 0 !== source.size) result.size = source.size;
            if (void 0 !== source.name) result.name = source.name;
            if (void 0 !== source.family) result.family = source.family;
            if (void 0 !== source.scheme) result.scheme = source.scheme;
            if (void 0 !== source.bold) result.bold = source.bold;
            if (void 0 !== source.italic) result.italic = source.italic;
            if (void 0 !== source.underline) result.underline = source.underline;
            if (void 0 !== source.color) result.color = (0, $5neL0.default).copy(source.color);
        }
        return result;
    },
    areEqual: function(leftTag, rightTag) {
        return $0b049686b0446f3c$var$fontHelper.isEmpty(leftTag) && $0b049686b0446f3c$var$fontHelper.isEmpty(rightTag) || (0, $6ntMu.isDefined)(leftTag) && (0, $6ntMu.isDefined)(rightTag) && leftTag.size === rightTag.size && leftTag.name === rightTag.name && leftTag.family === rightTag.family && leftTag.scheme === rightTag.scheme && (leftTag.bold === rightTag.bold || !leftTag.bold === !rightTag.bold) && (leftTag.italic === rightTag.italic || !leftTag.italic === !rightTag.italic) && leftTag.underline === rightTag.underline && (0, $5neL0.default).areEqual(leftTag.color, rightTag.color);
    },
    isEmpty: function(tag) {
        return !(0, $6ntMu.isDefined)(tag) || !(0, $6ntMu.isDefined)(tag.size) && !(0, $6ntMu.isDefined)(tag.name) && !(0, $6ntMu.isDefined)(tag.family) && !(0, $6ntMu.isDefined)(tag.scheme) && (!(0, $6ntMu.isDefined)(tag.bold) || !tag.bold) && (!(0, $6ntMu.isDefined)(tag.italic) || !tag.italic) && !(0, $6ntMu.isDefined)(tag.underline) && (0, $5neL0.default).isEmpty(tag.color);
    },
    toXml: function(tag) {
        var content = [
            (0, $6ntMu.isDefined)(tag.bold) && tag.bold ? (0, $4zgsW.default).toXml("b", {}) : "",
            (0, $6ntMu.isDefined)(tag.size) ? (0, $4zgsW.default).toXml("sz", {
                val: tag.size
            }) : "",
            (0, $6ntMu.isDefined)(tag.color) ? (0, $5neL0.default).toXml("color", tag.color) : "",
            (0, $6ntMu.isDefined)(tag.name) ? (0, $4zgsW.default).toXml("name", {
                val: tag.name
            }) : "",
            (0, $6ntMu.isDefined)(tag.family) ? (0, $4zgsW.default).toXml("family", {
                val: tag.family
            }) : "",
            (0, $6ntMu.isDefined)(tag.scheme) ? (0, $4zgsW.default).toXml("scheme", {
                val: tag.scheme
            }) : "",
            (0, $6ntMu.isDefined)(tag.italic) && tag.italic ? (0, $4zgsW.default).toXml("i", {}) : "",
            (0, $6ntMu.isDefined)(tag.underline) ? (0, $4zgsW.default).toXml("u", {
                val: tag.underline
            }) : ""
        ].join("");
        return (0, $4zgsW.default).toXml("font", {}, content);
    }
};
var $0b049686b0446f3c$export$2e2bcd8739ae039 = $0b049686b0446f3c$var$fontHelper;

});


parcelRegister("9KqrD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $718cec4c48599c8b$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/exporter/excel/excel.number_format_helper.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $4zgsW = parcelRequire("4zgsW");
var $718cec4c48599c8b$var$numberFormatHelper = {
    ID_PROPERTY_NAME: "id",
    tryCreateTag: function(sourceObj) {
        var result = null;
        if ("string" === typeof sourceObj) {
            result = {
                formatCode: sourceObj
            };
            if ($718cec4c48599c8b$var$numberFormatHelper.isEmpty(result)) result = null;
        }
        return result;
    },
    areEqual: function(leftTag, rightTag) {
        return $718cec4c48599c8b$var$numberFormatHelper.isEmpty(leftTag) && $718cec4c48599c8b$var$numberFormatHelper.isEmpty(rightTag) || (0, $6ntMu.isDefined)(leftTag) && (0, $6ntMu.isDefined)(rightTag) && leftTag.formatCode === rightTag.formatCode;
    },
    isEmpty: function(tag) {
        return !(0, $6ntMu.isDefined)(tag) || !(0, $6ntMu.isDefined)(tag.formatCode) || "" === tag.formatCode;
    },
    toXml: function(tag) {
        return (0, $4zgsW.default).toXml("numFmt", {
            numFmtId: tag[$718cec4c48599c8b$var$numberFormatHelper.ID_PROPERTY_NAME],
            formatCode: tag.formatCode
        });
    }
};
var $718cec4c48599c8b$export$2e2bcd8739ae039 = $718cec4c48599c8b$var$numberFormatHelper;

});



parcelRegister("fA7Jk", function(module, exports) {

$parcel$export(module.exports, "imageCreator", function () { return $b58036d313baf33e$export$895a5cea458529ce; });
$parcel$export(module.exports, "calcScaledInfo", function () { return $b58036d313baf33e$export$6743a422cef1ec68; });
$parcel$export(module.exports, "getData", function () { return $b58036d313baf33e$export$7a171f172be0782e; });
$parcel$export(module.exports, "testFormats", function () { return $b58036d313baf33e$export$e377ed5c0f6acea9; });
/**
 * DevExtreme (esm/exporter/image_creator.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $lmWRz = parcelRequire("lmWRz");

var $6ntMu = parcelRequire("6ntMu");

var $jmNgH = parcelRequire("jmNgH");

var $8OLOW = parcelRequire("8OLOW");

var $2oTOp = parcelRequire("2oTOp");

var $3yzYM = parcelRequire("3yzYM");

var $g3YTP = parcelRequire("g3YTP");

var $hYatw = parcelRequire("hYatw");

var $lQCfZ = parcelRequire("lQCfZ");

var $dDkff = parcelRequire("dDkff");
var $b58036d313baf33e$var$window = (0, $hYatw.getWindow)();
var $b58036d313baf33e$var$_math = Math;
var $b58036d313baf33e$var$PI = $b58036d313baf33e$var$_math.PI;
var $b58036d313baf33e$var$_min = $b58036d313baf33e$var$_math.min;
var $b58036d313baf33e$var$_abs = $b58036d313baf33e$var$_math.abs;
var $b58036d313baf33e$var$_sqrt = $b58036d313baf33e$var$_math.sqrt;
var $b58036d313baf33e$var$_pow = $b58036d313baf33e$var$_math.pow;
var $b58036d313baf33e$var$_atan2 = $b58036d313baf33e$var$_math.atan2;
var $b58036d313baf33e$var$_cos = $b58036d313baf33e$var$_math.cos;
var $b58036d313baf33e$var$_sin = $b58036d313baf33e$var$_math.sin;
var $b58036d313baf33e$var$_number = Number;
var $b58036d313baf33e$var$IMAGE_QUALITY = 1;
var $b58036d313baf33e$var$TEXT_DECORATION_LINE_WIDTH_COEFF = .05;
var $b58036d313baf33e$var$DEFAULT_FONT_SIZE = "10px";
var $b58036d313baf33e$var$DEFAULT_FONT_FAMILY = "sans-serif";
var $b58036d313baf33e$var$DEFAULT_TEXT_COLOR = "#000";
var $b58036d313baf33e$var$parseAttributes;
function $b58036d313baf33e$var$getStringFromCanvas(canvas, mimeType) {
    var dataURL = canvas.toDataURL(mimeType, $b58036d313baf33e$var$IMAGE_QUALITY);
    var imageData = $b58036d313baf33e$var$window.atob(dataURL.substring(("data:" + mimeType + ";base64,").length));
    return imageData;
}
function $b58036d313baf33e$var$arcTo(x1, y1, x2, y2, radius, largeArcFlag, clockwise, context) {
    var cBx = (x1 + x2) / 2;
    var cBy = (y1 + y2) / 2;
    var aB = $b58036d313baf33e$var$_atan2(y1 - y2, x1 - x2);
    var k = largeArcFlag ? 1 : -1;
    aB += $b58036d313baf33e$var$PI / 180 * 90 * (clockwise ? 1 : -1);
    var opSide = $b58036d313baf33e$var$_sqrt($b58036d313baf33e$var$_pow(x2 - x1, 2) + $b58036d313baf33e$var$_pow(y2 - y1, 2)) / 2;
    var adjSide = $b58036d313baf33e$var$_sqrt($b58036d313baf33e$var$_abs($b58036d313baf33e$var$_pow(radius, 2) - $b58036d313baf33e$var$_pow(opSide, 2)));
    var centerX = cBx + k * (adjSide * $b58036d313baf33e$var$_cos(aB));
    var centerY = cBy + k * (adjSide * $b58036d313baf33e$var$_sin(aB));
    var startAngle = $b58036d313baf33e$var$_atan2(y1 - centerY, x1 - centerX);
    var endAngle = $b58036d313baf33e$var$_atan2(y2 - centerY, x2 - centerX);
    context.arc(centerX, centerY, radius, startAngle, endAngle, !clockwise);
}
function $b58036d313baf33e$var$getElementOptions(element, rootAppended) {
    var attr = $b58036d313baf33e$var$parseAttributes(element.attributes || {});
    var options = (0, $2oTOp.extend)({}, attr, {
        text: element.textContent.replace(/\s+/g, " "),
        textAlign: "middle" === attr["text-anchor"] ? "center" : attr["text-anchor"]
    });
    var transform = attr.transform;
    var coords;
    if (transform) {
        coords = transform.match(/translate\(-*\d+([.]\d+)*(,*\s*-*\d+([.]\d+)*)*/);
        if (coords) {
            coords = coords[0].match(/-*\d+([.]\d+)*/g);
            options.translateX = $b58036d313baf33e$var$_number(coords[0]);
            options.translateY = coords[1] ? $b58036d313baf33e$var$_number(coords[1]) : 0;
        }
        coords = transform.match(/rotate\(-*\d+([.]\d+)*(,*\s*-*\d+([.]\d+)*,*\s*-*\d+([.]\d+)*)*/);
        if (coords) {
            coords = coords[0].match(/-*\d+([.]\d+)*/g);
            options.rotationAngle = $b58036d313baf33e$var$_number(coords[0]);
            options.rotationX = coords[1] && $b58036d313baf33e$var$_number(coords[1]);
            options.rotationY = coords[2] && $b58036d313baf33e$var$_number(coords[2]);
        }
        coords = transform.match(/scale\(-*\d+([.]\d+)*(,*\s*-*\d+([.]\d+)*)*/);
        if (coords) {
            coords = coords[0].match(/-*\d+([.]\d+)*/g);
            options.scaleX = $b58036d313baf33e$var$_number(coords[0]);
            if (coords.length > 1) options.scaleY = $b58036d313baf33e$var$_number(coords[1]);
            else options.scaleY = options.scaleX;
        }
    }
    $b58036d313baf33e$var$parseStyles(element, options, rootAppended);
    return options;
}
function $b58036d313baf33e$var$drawRect(context, options) {
    var x = options.x;
    var y = options.y;
    var width = options.width;
    var height = options.height;
    var cornerRadius = options.rx;
    if (!cornerRadius) context.rect(x, y, width, height);
    else {
        cornerRadius = $b58036d313baf33e$var$_min(cornerRadius, width / 2, height / 2);
        context.save();
        context.translate(x, y);
        context.moveTo(width / 2, 0);
        context.arcTo(width, 0, width, height, cornerRadius);
        context.arcTo(width, height, 0, height, cornerRadius);
        context.arcTo(0, height, 0, 0, cornerRadius);
        context.arcTo(0, 0, cornerRadius, 0, cornerRadius);
        context.lineTo(width / 2, 0);
        context.restore();
    }
}
function $b58036d313baf33e$var$drawImage(context, options, shared) {
    var d = new (0, $dDkff.Deferred);
    var image = new $b58036d313baf33e$var$window.Image;
    image.onload = function() {
        context.save();
        context.globalAlpha = options.globalAlpha;
        $b58036d313baf33e$var$transformElement(context, options);
        $b58036d313baf33e$var$clipElement(context, options, shared);
        context.drawImage(image, options.x || 0, options.y || 0, options.width, options.height);
        context.restore();
        d.resolve();
    };
    image.onerror = function() {
        d.resolve();
    };
    image.setAttribute("crossOrigin", "anonymous");
    image.src = options.href || options["xlink:href"];
    return d;
}
function $b58036d313baf33e$var$drawPath(context, dAttr) {
    var dArray = dAttr.replace(/,/g, " ").split(/([A-Z])/i).filter((item)=>"" !== item.trim());
    var i = 0;
    var params;
    var prevParams;
    var prevParamsLen;
    do {
        params = (dArray[i + 1] || "").trim().split(" ");
        switch(dArray[i]){
            case "M":
                context.moveTo($b58036d313baf33e$var$_number(params[0]), $b58036d313baf33e$var$_number(params[1]));
                i += 2;
                break;
            case "L":
                for(var j = 0; j < params.length / 2; j++)context.lineTo($b58036d313baf33e$var$_number(params[2 * j]), $b58036d313baf33e$var$_number(params[2 * j + 1]));
                i += 2;
                break;
            case "C":
                context.bezierCurveTo($b58036d313baf33e$var$_number(params[0]), $b58036d313baf33e$var$_number(params[1]), $b58036d313baf33e$var$_number(params[2]), $b58036d313baf33e$var$_number(params[3]), $b58036d313baf33e$var$_number(params[4]), $b58036d313baf33e$var$_number(params[5]));
                i += 2;
                break;
            case "a":
                prevParams = dArray[i - 1].trim().split(" ");
                prevParamsLen = prevParams.length - 1;
                $b58036d313baf33e$var$arcTo($b58036d313baf33e$var$_number(prevParams[prevParamsLen - 1]), $b58036d313baf33e$var$_number(prevParams[prevParamsLen]), $b58036d313baf33e$var$_number(prevParams[prevParamsLen - 1]) + $b58036d313baf33e$var$_number(params[5]), $b58036d313baf33e$var$_number(prevParams[prevParamsLen]) + $b58036d313baf33e$var$_number(params[6]), $b58036d313baf33e$var$_number(params[0]), $b58036d313baf33e$var$_number(params[3]), $b58036d313baf33e$var$_number(params[4]), context);
                i += 2;
                break;
            case "A":
                prevParams = dArray[i - 1].trim().split(" ");
                prevParamsLen = prevParams.length - 1;
                $b58036d313baf33e$var$arcTo($b58036d313baf33e$var$_number(prevParams[prevParamsLen - 1]), $b58036d313baf33e$var$_number(prevParams[prevParamsLen]), $b58036d313baf33e$var$_number(params[5]), $b58036d313baf33e$var$_number(params[6]), $b58036d313baf33e$var$_number(params[0]), $b58036d313baf33e$var$_number(params[3]), $b58036d313baf33e$var$_number(params[4]), context);
                i += 2;
                break;
            case "Z":
                context.closePath();
                i += 1;
                break;
            default:
                i++;
        }
    }while (i < dArray.length);
}
function $b58036d313baf33e$var$parseStyles(element, options, rootAppended) {
    var style = element.style || {};
    var field;
    for(field in style)if ("" !== style[field]) options[(0, $lQCfZ.camelize)(field)] = style[field];
    if (rootAppended && (0, $3yzYM.default).isElementNode(element)) {
        style = $b58036d313baf33e$var$window.getComputedStyle(element);
        [
            "fill",
            "stroke",
            "stroke-width",
            "font-family",
            "font-size",
            "font-style",
            "font-weight"
        ].forEach(function(prop) {
            if (prop in style && "" !== style[prop]) options[(0, $lQCfZ.camelize)(prop)] = style[prop];
        });
        [
            "opacity",
            "fill-opacity",
            "stroke-opacity"
        ].forEach(function(prop) {
            if (prop in style && "" !== style[prop] && "1" !== style[prop]) options[prop] = $b58036d313baf33e$var$_number(style[prop]);
        });
    }
    options.textDecoration = options.textDecoration || options.textDecorationLine;
    options.globalAlpha = (0, $6ntMu.isDefined)(options.opacity) ? options.opacity : options.globalAlpha;
}
function $b58036d313baf33e$var$parseUrl(urlString) {
    var matches = urlString && urlString.match(/url\(.*#(.*?)["']?\)/i);
    return matches && matches[1];
}
function $b58036d313baf33e$var$setFontStyle(context, options) {
    var fontParams = [];
    options.fontSize = options.fontSize || $b58036d313baf33e$var$DEFAULT_FONT_SIZE;
    options.fontFamily = options.fontFamily || $b58036d313baf33e$var$DEFAULT_FONT_FAMILY;
    options.fill = options.fill || $b58036d313baf33e$var$DEFAULT_TEXT_COLOR;
    options.fontStyle && fontParams.push(options.fontStyle);
    options.fontWeight && fontParams.push(options.fontWeight);
    fontParams.push(options.fontSize);
    fontParams.push(options.fontFamily);
    context.font = fontParams.join(" ");
    context.textAlign = options.textAlign;
    context.fillStyle = options.fill;
    context.globalAlpha = options.globalAlpha;
}
function $b58036d313baf33e$var$drawText(context, options, shared) {
    $b58036d313baf33e$var$setFontStyle(context, options);
    $b58036d313baf33e$var$applyFilter(context, options, shared);
    options.text && context.fillText(options.text, options.x || 0, options.y || 0);
    $b58036d313baf33e$var$strokeElement(context, options, true);
    $b58036d313baf33e$var$drawTextDecoration(context, options, shared);
}
function $b58036d313baf33e$var$drawTextDecoration(context, options, shared) {
    if (!options.textDecoration || "none" === options.textDecoration) return;
    var x = options.x;
    var textWidth = context.measureText(options.text).width;
    var textHeight = parseInt(options.fontSize, 10);
    var lineHeight = textHeight * $b58036d313baf33e$var$TEXT_DECORATION_LINE_WIDTH_COEFF < 1 ? 1 : textHeight * $b58036d313baf33e$var$TEXT_DECORATION_LINE_WIDTH_COEFF;
    var y = options.y;
    switch(options.textDecoration){
        case "line-through":
            y -= textHeight / 3 + lineHeight / 2;
            break;
        case "overline":
            y -= textHeight - lineHeight;
            break;
        case "underline":
            y += lineHeight;
    }
    context.rect(x, y, textWidth, lineHeight);
    $b58036d313baf33e$var$fillElement(context, options, shared);
    $b58036d313baf33e$var$strokeElement(context, options);
}
function $b58036d313baf33e$var$aggregateOpacity(options) {
    options.strokeOpacity = void 0 !== options["stroke-opacity"] ? options["stroke-opacity"] : 1;
    options.fillOpacity = void 0 !== options["fill-opacity"] ? options["fill-opacity"] : 1;
    if (void 0 !== options.opacity) {
        options.strokeOpacity *= options.opacity;
        options.fillOpacity *= options.opacity;
    }
}
function $b58036d313baf33e$var$hasTspan(element) {
    var nodes = element.childNodes;
    for(var i = 0; i < nodes.length; i++){
        if ("tspan" === nodes[i].tagName) return true;
    }
    return false;
}
function $b58036d313baf33e$var$drawTextElement(childNodes, context, options, shared) {
    var lines = [];
    var line;
    var offset = 0;
    for(var i = 0; i < childNodes.length; i++){
        var element = childNodes[i];
        if (void 0 === element.tagName) $b58036d313baf33e$var$drawElement(element, context, options, shared);
        else if ("tspan" === element.tagName || "text" === element.tagName) {
            var elementOptions = $b58036d313baf33e$var$getElementOptions(element, shared.rootAppended);
            var mergedOptions = (0, $2oTOp.extend)({}, options, elementOptions);
            if ("tspan" === element.tagName && $b58036d313baf33e$var$hasTspan(element)) {
                $b58036d313baf33e$var$drawTextElement(element.childNodes, context, mergedOptions, shared);
                continue;
            }
            mergedOptions.textAlign = "start";
            if (!line || void 0 !== elementOptions.x) {
                line = {
                    elements: [],
                    options: [],
                    widths: [],
                    offsets: []
                };
                lines.push(line);
            }
            if (void 0 !== elementOptions.y) offset = 0;
            if (void 0 !== elementOptions.dy) offset += parseFloat(elementOptions.dy);
            line.elements.push(element);
            line.options.push(mergedOptions);
            line.offsets.push(offset);
            $b58036d313baf33e$var$setFontStyle(context, mergedOptions);
            line.widths.push(context.measureText(mergedOptions.text).width);
        }
    }
    lines.forEach(function(line) {
        var commonWidth = line.widths.reduce(function(commonWidth, width) {
            return commonWidth + width;
        }, 0);
        var xDiff = 0;
        var currentOffset = 0;
        if ("center" === options.textAlign) xDiff = commonWidth / 2;
        if ("end" === options.textAlign) xDiff = commonWidth;
        line.options.forEach(function(o, index) {
            var width = line.widths[index];
            o.x = o.x - xDiff + currentOffset;
            o.y += line.offsets[index];
            currentOffset += width;
        });
        line.elements.forEach(function(element, index) {
            $b58036d313baf33e$var$drawTextElement(element.childNodes, context, line.options[index], shared);
        });
    });
}
function $b58036d313baf33e$var$drawElement(element, context, parentOptions, shared) {
    var tagName = element.tagName;
    var isText = "text" === tagName || "tspan" === tagName || void 0 === tagName;
    var isImage = "image" === tagName;
    var isComment = 8 === element.nodeType;
    var options = (0, $2oTOp.extend)({}, parentOptions, $b58036d313baf33e$var$getElementOptions(element, shared.rootAppended));
    if ("hidden" === options.visibility || options[0, $jmNgH.HIDDEN_FOR_EXPORT] || isComment) return;
    context.save();
    !isImage && $b58036d313baf33e$var$transformElement(context, options);
    $b58036d313baf33e$var$clipElement(context, options, shared);
    $b58036d313baf33e$var$aggregateOpacity(options);
    var promise;
    context.beginPath();
    switch(element.tagName){
        case void 0:
            $b58036d313baf33e$var$drawText(context, options, shared);
            break;
        case "text":
        case "tspan":
            $b58036d313baf33e$var$drawTextElement(element.childNodes, context, options, shared);
            break;
        case "image":
            promise = $b58036d313baf33e$var$drawImage(context, options, shared);
            break;
        case "path":
            $b58036d313baf33e$var$drawPath(context, options.d);
            break;
        case "rect":
            $b58036d313baf33e$var$drawRect(context, options);
            context.closePath();
            break;
        case "circle":
            context.arc(options.cx, options.cy, options.r, 0, 2 * $b58036d313baf33e$var$PI, 1);
    }
    if (!isText) {
        $b58036d313baf33e$var$applyFilter(context, options, shared);
        $b58036d313baf33e$var$fillElement(context, options, shared);
        $b58036d313baf33e$var$strokeElement(context, options);
    }
    $b58036d313baf33e$var$applyGradient(context, options, shared, element);
    context.restore();
    return promise;
}
function $b58036d313baf33e$var$applyGradient(context, options, _ref, element) {
    var { gradients: gradients } = _ref;
    if (0 === gradients.length) return;
    var id = $b58036d313baf33e$var$parseUrl(options.fill);
    if (id && gradients[id]) {
        var box = element.getBBox();
        var gradient = context.createLinearGradient(box.x, 0, box.x + box.width, 0);
        gradients[id].forEach((opt)=>{
            var offset = parseInt(opt.offset.replace(/%/, ""));
            gradient.addColorStop(offset / 100, opt.stopColor);
        });
        context.globalAlpha = options.opacity;
        context.fillStyle = gradient;
        context.fill();
    }
}
function $b58036d313baf33e$var$applyFilter(context, options, shared) {
    var filterOptions;
    var id = $b58036d313baf33e$var$parseUrl(options.filter);
    if (id) {
        filterOptions = shared.filters[id];
        if (!filterOptions) filterOptions = {
            offsetX: 0,
            offsetY: 0,
            blur: 0,
            color: "#000"
        };
        context.shadowOffsetX = filterOptions.offsetX;
        context.shadowOffsetY = filterOptions.offsetY;
        context.shadowColor = filterOptions.color;
        context.shadowBlur = filterOptions.blur;
    }
}
function $b58036d313baf33e$var$transformElement(context, options) {
    context.translate(options.translateX || 0, options.translateY || 0);
    options.translateX = void 0;
    options.translateY = void 0;
    if (options.rotationAngle) {
        context.translate(options.rotationX || 0, options.rotationY || 0);
        context.rotate(options.rotationAngle * $b58036d313baf33e$var$PI / 180);
        context.translate(-(options.rotationX || 0), -(options.rotationY || 0));
        options.rotationAngle = void 0;
        options.rotationX = void 0;
        options.rotationY = void 0;
    }
    if (isFinite(options.scaleX)) {
        context.scale(options.scaleX, options.scaleY);
        options.scaleX = void 0;
        options.scaleY = void 0;
    }
}
function $b58036d313baf33e$var$clipElement(context, options, shared) {
    if (options["clip-path"]) {
        $b58036d313baf33e$var$drawElement(shared.clipPaths[$b58036d313baf33e$var$parseUrl(options["clip-path"])], context, {}, shared);
        context.clip();
        options["clip-path"] = void 0;
    }
}
function $b58036d313baf33e$var$hex2rgba(hexColor, alpha) {
    var color = new (0, $lmWRz.default)(hexColor);
    return "rgba(" + color.r + "," + color.g + "," + color.b + "," + alpha + ")";
}
function $b58036d313baf33e$var$createGradient(element) {
    var options = [];
    (0, $8OLOW.each)(element.childNodes, (_, _ref2)=>{
        var { attributes: attributes } = _ref2;
        options.push({
            offset: attributes.offset.value,
            stopColor: attributes["stop-color"].value
        });
    });
    return options;
}
function $b58036d313baf33e$var$createFilter(element) {
    var color;
    var opacity;
    var filterOptions = {};
    (0, $8OLOW.each)(element.childNodes, function(_, node) {
        var attr = node.attributes;
        if (!attr.result) return;
        switch(attr.result.value){
            case "gaussianBlurResult":
                filterOptions.blur = $b58036d313baf33e$var$_number(attr.stdDeviation.value);
                break;
            case "offsetResult":
                filterOptions.offsetX = $b58036d313baf33e$var$_number(attr.dx.value);
                filterOptions.offsetY = $b58036d313baf33e$var$_number(attr.dy.value);
                break;
            case "floodResult":
                color = attr["flood-color"] ? attr["flood-color"].value : "#000";
                opacity = attr["flood-opacity"] ? attr["flood-opacity"].value : 1;
                filterOptions.color = $b58036d313baf33e$var$hex2rgba(color, opacity);
        }
    });
    return filterOptions;
}
function $b58036d313baf33e$var$asyncEach(array, callback) {
    var d = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new (0, $dDkff.Deferred);
    var i = 0;
    for(; i < array.length; i++){
        var result = callback(array[i]);
        if ((0, $6ntMu.isPromise)(result)) {
            result.then(()=>{
                $b58036d313baf33e$var$asyncEach(Array.prototype.slice.call(array, i + 1), callback, d);
            });
            break;
        }
    }
    if (i === array.length) d.resolve();
    return d;
}
function $b58036d313baf33e$var$drawCanvasElements(elements, context, parentOptions, shared) {
    return $b58036d313baf33e$var$asyncEach(elements, function(element) {
        switch(element.tagName && element.tagName.toLowerCase()){
            case "g":
            case "svg":
                var options = (0, $2oTOp.extend)({}, parentOptions, $b58036d313baf33e$var$getElementOptions(element, shared.rootAppended));
                context.save();
                $b58036d313baf33e$var$transformElement(context, options);
                $b58036d313baf33e$var$clipElement(context, options, shared);
                var onDone = ()=>{
                    context.restore();
                };
                var d = $b58036d313baf33e$var$drawCanvasElements(element.childNodes, context, options, shared);
                if ((0, $6ntMu.isPromise)(d)) d.then(onDone);
                else onDone();
                return d;
            case "defs":
                return $b58036d313baf33e$var$drawCanvasElements(element.childNodes, context, {}, shared);
            case "clippath":
                shared.clipPaths[element.attributes.id.textContent] = element.childNodes[0];
                break;
            case "pattern":
                shared.patterns[element.attributes.id.textContent] = element;
                break;
            case "filter":
                shared.filters[element.id] = $b58036d313baf33e$var$createFilter(element);
                break;
            case "lineargradient":
                shared.gradients[element.attributes.id.textContent] = $b58036d313baf33e$var$createGradient(element);
                break;
            default:
                return $b58036d313baf33e$var$drawElement(element, context, parentOptions, shared);
        }
    });
}
function $b58036d313baf33e$var$setLineDash(context, options) {
    var matches = options["stroke-dasharray"] && options["stroke-dasharray"].match(/(\d+)/g);
    if (matches && matches.length) {
        matches = (0, $8OLOW.map)(matches, function(item) {
            return $b58036d313baf33e$var$_number(item);
        });
        context.setLineDash(matches);
    }
}
function $b58036d313baf33e$var$strokeElement(context, options, isText) {
    var stroke = options.stroke;
    if (stroke && "none" !== stroke && 0 !== options["stroke-width"]) {
        $b58036d313baf33e$var$setLineDash(context, options);
        context.lineJoin = options["stroke-linejoin"];
        context.lineWidth = options["stroke-width"];
        context.globalAlpha = options.strokeOpacity;
        context.strokeStyle = stroke;
        isText ? context.strokeText(options.text, options.x, options.y) : context.stroke();
        context.globalAlpha = 1;
    }
}
function $b58036d313baf33e$var$getPattern(context, pattern, shared) {
    var options = $b58036d313baf33e$var$getElementOptions(pattern, shared.rootAppended);
    var patternCanvas = $b58036d313baf33e$export$895a5cea458529ce._createCanvas(options.width, options.height, 0);
    var patternContext = patternCanvas.getContext("2d");
    $b58036d313baf33e$var$drawCanvasElements(pattern.childNodes, patternContext, options, shared);
    return context.createPattern(patternCanvas, "repeat");
}
function $b58036d313baf33e$var$fillElement(context, options, shared) {
    var fill = options.fill;
    if (fill && "none" !== fill) {
        if (-1 === fill.search(/url/)) context.fillStyle = fill;
        else {
            var pattern = shared.patterns[$b58036d313baf33e$var$parseUrl(fill)];
            if (!pattern) return;
            context.fillStyle = $b58036d313baf33e$var$getPattern(context, pattern, shared);
        }
        context.globalAlpha = options.fillOpacity;
        context.fill();
        context.globalAlpha = 1;
    }
}
$b58036d313baf33e$var$parseAttributes = function(attributes) {
    var newAttributes = {};
    var attr;
    (0, $8OLOW.each)(attributes, function(index, item) {
        attr = item.textContent;
        if (isFinite(attr)) attr = $b58036d313baf33e$var$_number(attr);
        newAttributes[item.name.toLowerCase()] = attr;
    });
    return newAttributes;
};
function $b58036d313baf33e$var$drawBackground(context, width, height, backgroundColor, margin) {
    context.fillStyle = backgroundColor || "#ffffff";
    context.fillRect(-margin, -margin, width + 2 * margin, height + 2 * margin);
}
function $b58036d313baf33e$var$createInvisibleDiv() {
    var invisibleDiv = (0, $3yzYM.default).createElement("div");
    invisibleDiv.style.left = "-9999px";
    invisibleDiv.style.position = "absolute";
    return invisibleDiv;
}
function $b58036d313baf33e$var$convertSvgToCanvas(svg, canvas, rootAppended) {
    return $b58036d313baf33e$var$drawCanvasElements(svg.childNodes, canvas.getContext("2d"), {}, {
        clipPaths: {},
        patterns: {},
        filters: {},
        gradients: {},
        rootAppended: rootAppended
    });
}
function $b58036d313baf33e$var$getCanvasFromSvg(markup, _ref3) {
    var { width: width, height: height, backgroundColor: backgroundColor, margin: margin, svgToCanvas: svgToCanvas = $b58036d313baf33e$var$convertSvgToCanvas } = _ref3;
    var scaledScreenInfo = $b58036d313baf33e$export$6743a422cef1ec68(width, height);
    var canvas = $b58036d313baf33e$export$895a5cea458529ce._createCanvas(scaledScreenInfo.width, scaledScreenInfo.height, margin);
    var context = canvas.getContext("2d");
    context.setTransform(scaledScreenInfo.pixelRatio, 0, 0, scaledScreenInfo.pixelRatio, 0, 0);
    var svgElem = (0, $jmNgH.getSvgElement)(markup);
    var invisibleDiv;
    var markupIsDomElement = (0, $3yzYM.default).isElementNode(markup);
    context.translate(margin, margin);
    (0, $3yzYM.default).getBody().appendChild(canvas);
    if (!markupIsDomElement) {
        invisibleDiv = $b58036d313baf33e$var$createInvisibleDiv();
        invisibleDiv.appendChild(svgElem);
        (0, $3yzYM.default).getBody().appendChild(invisibleDiv);
    }
    if (svgElem.attributes.direction) canvas.dir = svgElem.attributes.direction.textContent;
    $b58036d313baf33e$var$drawBackground(context, width, height, backgroundColor, margin);
    return (0, $dDkff.fromPromise)(svgToCanvas(svgElem, canvas, markupIsDomElement && (0, $g3YTP.contains)((0, $3yzYM.default).getBody(), markup))).then(()=>canvas).always(()=>{
        invisibleDiv && (0, $3yzYM.default).getBody().removeChild(invisibleDiv);
        (0, $3yzYM.default).getBody().removeChild(canvas);
    });
}
var $b58036d313baf33e$export$895a5cea458529ce = {
    getImageData: function(markup, options) {
        var mimeType = "image/" + options.format;
        if ((0, $6ntMu.isFunction)(options.__parseAttributesFn)) $b58036d313baf33e$var$parseAttributes = options.__parseAttributesFn;
        return $b58036d313baf33e$var$getCanvasFromSvg(markup, options).then((canvas)=>$b58036d313baf33e$var$getStringFromCanvas(canvas, mimeType));
    },
    getData: function(markup, options) {
        var that = this;
        return $b58036d313baf33e$export$895a5cea458529ce.getImageData(markup, options).then((binaryData)=>{
            var mimeType = "image/" + options.format;
            var data = (0, $6ntMu.isFunction)($b58036d313baf33e$var$window.Blob) && !options.useBase64 ? that._getBlob(binaryData, mimeType) : that._getBase64(binaryData);
            return data;
        });
    },
    _getBlob: function(binaryData, mimeType) {
        var i;
        var dataArray = new Uint8Array(binaryData.length);
        for(i = 0; i < binaryData.length; i++)dataArray[i] = binaryData.charCodeAt(i);
        return new $b58036d313baf33e$var$window.Blob([
            dataArray.buffer
        ], {
            type: mimeType
        });
    },
    _getBase64: function(binaryData) {
        return $b58036d313baf33e$var$window.btoa(binaryData);
    },
    _createCanvas (width, height, margin) {
        var canvas = (0, $2vlX8.default)("<canvas>")[0];
        canvas.width = width + 2 * margin;
        canvas.height = height + 2 * margin;
        canvas.hidden = true;
        return canvas;
    }
};
function $b58036d313baf33e$export$7a171f172be0782e(data, options) {
    return $b58036d313baf33e$export$895a5cea458529ce.getData(data, options);
}
function $b58036d313baf33e$export$e377ed5c0f6acea9(formats) {
    var canvas = $b58036d313baf33e$export$895a5cea458529ce._createCanvas(100, 100, 0);
    return formats.reduce(function(r, f) {
        var mimeType = ("image/" + f).toLowerCase();
        if (-1 !== canvas.toDataURL(mimeType).indexOf(mimeType)) r.supported.push(f);
        else r.unsupported.push(f);
        return r;
    }, {
        supported: [],
        unsupported: []
    });
}
function $b58036d313baf33e$export$6743a422cef1ec68(width, height) {
    var pixelRatio = $b58036d313baf33e$var$window.devicePixelRatio || 1;
    return {
        pixelRatio: pixelRatio,
        width: width * pixelRatio,
        height: height * pixelRatio
    };
}

});

parcelRegister("22BvS", function(module, exports) {

$parcel$export(module.exports, "svgCreator", function () { return $17c8de05bfd457e2$export$23997479cd40ad57; });
$parcel$export(module.exports, "getData", function () { return $17c8de05bfd457e2$export$7a171f172be0782e; });
/**
 * DevExtreme (esm/exporter/svg_creator.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $8DG5X = parcelRequire("8DG5X");

var $hYatw = parcelRequire("hYatw");

var $6ntMu = parcelRequire("6ntMu");

var $8OLOW = parcelRequire("8OLOW");

var $jmNgH = parcelRequire("jmNgH");

var $dDkff = parcelRequire("dDkff");
var $17c8de05bfd457e2$var$window = (0, $hYatw.getWindow)();
var $17c8de05bfd457e2$export$23997479cd40ad57 = {
    _markup: "",
    _imageArray: {},
    _imageDeferreds: [],
    _getBinaryFile: function(src, callback) {
        (0, $8DG5X.default).sendRequest({
            url: src,
            method: "GET",
            responseType: "arraybuffer"
        }).done(callback).fail(function() {
            callback(false);
        });
    },
    _loadImages: function() {
        var that = this;
        (0, $8OLOW.each)(that._imageArray, function(src) {
            var deferred = new (0, $dDkff.Deferred);
            that._imageDeferreds.push(deferred);
            that._getBinaryFile(src, function(response) {
                if (!response) {
                    delete that._imageArray[src];
                    deferred.resolve();
                    return;
                }
                var i;
                var binary = "";
                var bytes = new Uint8Array(response);
                var length = bytes.byteLength;
                for(i = 0; i < length; i++)binary += String.fromCharCode(bytes[i]);
                that._imageArray[src] = "data:image/png;base64," + $17c8de05bfd457e2$var$window.btoa(binary);
                deferred.resolve();
            });
        });
    },
    _parseImages: function(element) {
        var href;
        var that = this;
        if ("image" === element.tagName) {
            href = (0, $2vlX8.default)(element).attr("href") || (0, $2vlX8.default)(element).attr("xlink:href");
            if (!that._imageArray[href]) that._imageArray[href] = "";
        }
        (0, $8OLOW.each)(element.childNodes, function(_, element) {
            that._parseImages(element);
        });
    },
    _prepareImages: function(svgElem) {
        this._parseImages(svgElem);
        this._loadImages();
        return (0, $dDkff.when).apply((0, $2vlX8.default), this._imageDeferreds);
    },
    getData: function(data, options) {
        var markup;
        var that = this;
        var svgElem = (0, $jmNgH.getSvgElement)(data);
        var $svgObject = (0, $2vlX8.default)(svgElem);
        $svgObject.find("[".concat((0, $jmNgH.HIDDEN_FOR_EXPORT), "]")).remove();
        markup = '<?xml version="1.0" encoding="UTF-8" standalone="yes" ?>' + (0, $jmNgH.getSvgMarkup)($svgObject.get(0), options.backgroundColor);
        return that._prepareImages(svgElem).then(()=>{
            (0, $8OLOW.each)(that._imageArray, function(href, dataURI) {
                var regexpString = "href=['|\"]".concat(href, "['|\"]");
                markup = markup.replace(new RegExp(regexpString, "gi"), 'href="'.concat(dataURI, '"'));
            });
            return (0, $6ntMu.isFunction)($17c8de05bfd457e2$var$window.Blob) ? that._getBlob(markup) : that._getBase64(markup);
        });
    },
    _getBlob: function(markup) {
        return new $17c8de05bfd457e2$var$window.Blob([
            markup
        ], {
            type: "image/svg+xml"
        });
    },
    _getBase64: function(markup) {
        return $17c8de05bfd457e2$var$window.btoa(markup);
    }
};
function $17c8de05bfd457e2$export$7a171f172be0782e(data, options) {
    return $17c8de05bfd457e2$export$23997479cd40ad57.getData(data, options);
}

});

parcelRegister("jPgAf", function(module, exports) {

$parcel$export(module.exports, "getData", function () { return $e6efa4ee1a9f82a2$export$7a171f172be0782e; });
/**
 * DevExtreme (esm/exporter/pdf_creator.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $5gpMu = parcelRequire("5gpMu");

var $hYatw = parcelRequire("hYatw");

var $fA7Jk = parcelRequire("fA7Jk");

var $6ntMu = parcelRequire("6ntMu");

var $2oTOp = parcelRequire("2oTOp");
var $e6efa4ee1a9f82a2$var$window = (0, $hYatw.getWindow)();
var $e6efa4ee1a9f82a2$var$mainPageTemplate = "%PDF-1.3\r\n2 0 obj\r\n<</ProcSet[/PDF/ImageB/ImageC/ImageI]/XObject<</I0 5 0 R>>>>\r\nendobj\r\n4 0 obj\r\n<</Type/Pages/Kids[1 0 R]/Count 1>>\r\nendobj\r\n7 0 obj\r\n<</OpenAction[1 0 R /FitH null]/Type/Catalog/Pages 4 0 R/PageLayout/OneColumn>>\r\nendobj\r\n1 0 obj\r\n<</Type/Page/Resources 2 0 R/MediaBox[0 0 _width_ _height_]/Contents 3 0 R/Parent 4 0 R>>\r\nendobj\r\n";
var $e6efa4ee1a9f82a2$var$contentTemplate = "3 0 obj\r\n<</Length 52>>stream\r\n0.20 w\n0 G\nq _width_ 0 0 _height_ 0.00 0.00 cm /I0 Do Q\r\nendstream\r\nendobj\r\n";
var $e6efa4ee1a9f82a2$var$infoTemplate = "6 0 obj\r\n<</CreationDate _date_/Producer(DevExtreme _version_)>>\r\nendobj\r\n";
var $e6efa4ee1a9f82a2$var$imageStartTemplate = "5 0 obj\r\n<</Type/XObject/Subtype/Image/Width _width_/Height _height_/ColorSpace/DeviceRGB/BitsPerComponent 8/Filter/DCTDecode/Length _length_>>stream\r\n";
var $e6efa4ee1a9f82a2$var$imageEndTemplate = "\r\nendstream\r\nendobj\r\n";
var $e6efa4ee1a9f82a2$var$trailerTemplate = "trailer\r\n<<\r\n/Size 8\r\n/Root 7 0 R\r\n/Info 6 0 R\r\n>>\r\nstartxref\r\n_length_\r\n%%EOF";
var $e6efa4ee1a9f82a2$var$xrefTemplate = "xref\r\n0 8\r\n0000000000 65535 f\r\n0000000241 00000 n\r\n0000000010 00000 n\r\n_main_ 00000 n\r\n0000000089 00000 n\r\n_image_ 00000 n\r\n_info_ 00000 n\r\n0000000143 00000 n\r\n";
var $e6efa4ee1a9f82a2$var$pad = function pad(str, len) {
    return str.length < len ? pad("0" + str, len) : str;
};
var $e6efa4ee1a9f82a2$var$composePdfString = function(imageString, options, curDate) {
    var margin = 2 * (options.margin || 0);
    var { width: width, height: height } = (0, $fA7Jk.calcScaledInfo)(options.width, options.height);
    width += margin;
    height += margin;
    var widthPt = (.75 * width).toFixed(2);
    var heightPt = (.75 * height).toFixed(2);
    var flooredWidth = Math.floor(width);
    var flooredHeight = Math.floor(height);
    var mainPage = $e6efa4ee1a9f82a2$var$mainPageTemplate.replace("_width_", widthPt).replace("_height_", heightPt);
    var content = $e6efa4ee1a9f82a2$var$contentTemplate.replace("_width_", widthPt).replace("_height_", heightPt);
    var info = $e6efa4ee1a9f82a2$var$infoTemplate.replace("_date_", curDate).replace("_version_", (0, $5gpMu.version));
    var image = $e6efa4ee1a9f82a2$var$imageStartTemplate.replace("_width_", flooredWidth).replace("_height_", flooredHeight).replace("_length_", imageString.length) + imageString + $e6efa4ee1a9f82a2$var$imageEndTemplate;
    var xref = $e6efa4ee1a9f82a2$var$getXref(mainPage.length, content.length, info.length);
    var mainContent = mainPage + content + info + image;
    var trailer = $e6efa4ee1a9f82a2$var$trailerTemplate.replace("_length_", mainContent.length);
    return mainContent + xref + trailer;
};
function $e6efa4ee1a9f82a2$var$getXref(mainPageLength, contentLength, infoLength) {
    return $e6efa4ee1a9f82a2$var$xrefTemplate.replace("_main_", $e6efa4ee1a9f82a2$var$pad(mainPageLength + "", 10)).replace("_info_", $e6efa4ee1a9f82a2$var$pad(mainPageLength + contentLength + "", 10)).replace("_image_", $e6efa4ee1a9f82a2$var$pad(mainPageLength + contentLength + infoLength + "", 10));
}
var $e6efa4ee1a9f82a2$var$getCurDate = function() {
    return new Date;
};
var $e6efa4ee1a9f82a2$var$getBlob = function(binaryData) {
    var i = 0;
    var dataArray = new Uint8Array(binaryData.length);
    for(; i < binaryData.length; i++)dataArray[i] = binaryData.charCodeAt(i);
    return new $e6efa4ee1a9f82a2$var$window.Blob([
        dataArray.buffer
    ], {
        type: "application/pdf"
    });
};
var $e6efa4ee1a9f82a2$var$getBase64 = function(binaryData) {
    return $e6efa4ee1a9f82a2$var$window.btoa(binaryData);
};
function $e6efa4ee1a9f82a2$var$getTwoDigitValue(value) {
    var stringValue = value.toString();
    if (1 === stringValue.length) return "0".concat(value);
    return value;
}
function $e6efa4ee1a9f82a2$var$convertToPdfDateFormat(date) {
    var dateUnits = [
        date.getUTCFullYear(),
        $e6efa4ee1a9f82a2$var$getTwoDigitValue(date.getUTCMonth()),
        $e6efa4ee1a9f82a2$var$getTwoDigitValue(date.getUTCDate()),
        $e6efa4ee1a9f82a2$var$getTwoDigitValue(date.getUTCHours()),
        $e6efa4ee1a9f82a2$var$getTwoDigitValue(date.getUTCMinutes()),
        $e6efa4ee1a9f82a2$var$getTwoDigitValue(date.getUTCSeconds())
    ];
    return "(D:".concat(dateUnits.join(""), "Z00'00')");
}
function $e6efa4ee1a9f82a2$export$7a171f172be0782e(data, options) {
    return (0, $fA7Jk.imageCreator).getImageData(data, (0, $2oTOp.extend)({}, options, {
        format: "JPEG"
    })).then((imageString)=>{
        var binaryData = $e6efa4ee1a9f82a2$var$composePdfString(imageString, options, $e6efa4ee1a9f82a2$var$convertToPdfDateFormat($e6efa4ee1a9f82a2$var$getCurDate()));
        var pdfData = (0, $6ntMu.isFunction)($e6efa4ee1a9f82a2$var$window.Blob) ? $e6efa4ee1a9f82a2$var$getBlob(binaryData) : $e6efa4ee1a9f82a2$var$getBase64(binaryData);
        return pdfData;
    });
}

});


parcelRegister("9zsY3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f7dda5471457002$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/localization/message.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $5Nras = parcelRequire("5Nras");

var $2oTOp = parcelRequire("2oTOp");

var $9vHY4 = parcelRequire("9vHY4");

var $lQCfZ = parcelRequire("lQCfZ");

var $iTFn1 = parcelRequire("iTFn1");

var $4uawf = parcelRequire("4uawf");
var $6f7dda5471457002$var$baseDictionary = (0, $2oTOp.extend)(true, {}, (0, $4uawf.defaultMessages));
var $6f7dda5471457002$var$getDataByLocale = (localeData, locale)=>localeData[locale] || {};
var $6f7dda5471457002$var$newMessages = {};
var $6f7dda5471457002$var$messageLocalization = (0, $5Nras.default)({
    engine: function() {
        return "base";
    },
    _dictionary: $6f7dda5471457002$var$baseDictionary,
    load: function(messages) {
        (0, $2oTOp.extend)(true, this._dictionary, messages);
    },
    _localizablePrefix: "@",
    setup: function(localizablePrefix) {
        this._localizablePrefix = localizablePrefix;
    },
    localizeString: function(text) {
        var that = this;
        var regex = new RegExp("(^|[^a-zA-Z_0-9" + that._localizablePrefix + "-]+)(" + that._localizablePrefix + "{1,2})([a-zA-Z_0-9-]+)", "g");
        var escapeString = that._localizablePrefix + that._localizablePrefix;
        return text.replace(regex, (str, prefix, escape, localizationKey)=>{
            var defaultResult = that._localizablePrefix + localizationKey;
            var result;
            if (escape !== escapeString) result = that.format(localizationKey);
            if (!result) $6f7dda5471457002$var$newMessages[localizationKey] = (0, $lQCfZ.humanize)(localizationKey);
            return prefix + (result || defaultResult);
        });
    },
    getMessagesByLocales: function() {
        return this._dictionary;
    },
    getDictionary: function(onlyNew) {
        if (onlyNew) return $6f7dda5471457002$var$newMessages;
        return (0, $2oTOp.extend)({}, $6f7dda5471457002$var$newMessages, this.getMessagesByLocales()[(0, $iTFn1.default).locale()]);
    },
    getFormatter: function(key) {
        return this._getFormatterBase(key) || this._getFormatterBase(key, "en");
    },
    _getFormatterBase: function(key, locale) {
        var message = (0, $iTFn1.default).getValueByClosestLocale((locale)=>$6f7dda5471457002$var$getDataByLocale(this._dictionary, locale)[key]);
        if (message) return function() {
            var args = 1 === arguments.length && Array.isArray(arguments[0]) ? arguments[0].slice(0) : Array.prototype.slice.call(arguments, 0);
            args.unshift(message);
            return (0, $9vHY4.format).apply(this, args);
        };
    },
    format: function(key) {
        var formatter = this.getFormatter(key);
        var values = Array.prototype.slice.call(arguments, 1);
        return formatter && formatter.apply(this, values) || "";
    }
});
var $6f7dda5471457002$export$2e2bcd8739ae039 = $6f7dda5471457002$var$messageLocalization;

});
parcelRegister("4uawf", function(module, exports) {

$parcel$export(module.exports, "defaultMessages", function () { return $34421fa1fc281d57$export$628f6f7219a6b8b6; });
/**
 * DevExtreme (esm/localization/default_messages.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ // !!! AUTO-GENERATED FILE, DO NOT EDIT
var $34421fa1fc281d57$export$628f6f7219a6b8b6 = {
    en: {
        Yes: "Yes",
        No: "No",
        Cancel: "Cancel",
        Close: "Close",
        Clear: "Clear",
        Done: "Done",
        Loading: "Loading...",
        Select: "Select...",
        Search: "Search",
        Back: "Back",
        OK: "OK",
        "dxCollectionWidget-noDataText": "No data to display",
        "dxDropDownEditor-selectLabel": "Select",
        "validation-required": "Required",
        "validation-required-formatted": "{0} is required",
        "validation-numeric": "Value must be a number",
        "validation-numeric-formatted": "{0} must be a number",
        "validation-range": "Value is out of range",
        "validation-range-formatted": "{0} is out of range",
        "validation-stringLength": "The length of the value is not correct",
        "validation-stringLength-formatted": "The length of {0} is not correct",
        "validation-custom": "Value is invalid",
        "validation-custom-formatted": "{0} is invalid",
        "validation-async": "Value is invalid",
        "validation-async-formatted": "{0} is invalid",
        "validation-compare": "Values do not match",
        "validation-compare-formatted": "{0} does not match",
        "validation-pattern": "Value does not match pattern",
        "validation-pattern-formatted": "{0} does not match pattern",
        "validation-email": "Email is invalid",
        "validation-email-formatted": "{0} is invalid",
        "validation-mask": "Value is invalid",
        "dxLookup-searchPlaceholder": "Minimum character number: {0}",
        "dxList-pullingDownText": "Pull down to refresh...",
        "dxList-pulledDownText": "Release to refresh...",
        "dxList-refreshingText": "Refreshing...",
        "dxList-pageLoadingText": "Loading...",
        "dxList-nextButtonText": "More",
        "dxList-selectAll": "Select All",
        "dxListEditDecorator-delete": "Delete",
        "dxListEditDecorator-more": "More",
        "dxScrollView-pullingDownText": "Pull down to refresh...",
        "dxScrollView-pulledDownText": "Release to refresh...",
        "dxScrollView-refreshingText": "Refreshing...",
        "dxScrollView-reachBottomText": "Loading...",
        "dxDateBox-simulatedDataPickerTitleTime": "Select time",
        "dxDateBox-simulatedDataPickerTitleDate": "Select date",
        "dxDateBox-simulatedDataPickerTitleDateTime": "Select date and time",
        "dxDateBox-validation-datetime": "Value must be a date or time",
        "dxFileUploader-selectFile": "Select a file",
        "dxFileUploader-dropFile": "or Drop a file here",
        "dxFileUploader-bytes": "bytes",
        "dxFileUploader-kb": "KB",
        "dxFileUploader-Mb": "MB",
        "dxFileUploader-Gb": "GB",
        "dxFileUploader-upload": "Upload",
        "dxFileUploader-uploaded": "Uploaded",
        "dxFileUploader-readyToUpload": "Ready to upload",
        "dxFileUploader-uploadAbortedMessage": "Upload cancelled",
        "dxFileUploader-uploadFailedMessage": "Upload failed",
        "dxFileUploader-invalidFileExtension": "File type is not allowed",
        "dxFileUploader-invalidMaxFileSize": "File is too large",
        "dxFileUploader-invalidMinFileSize": "File is too small",
        "dxRangeSlider-ariaFrom": "From",
        "dxRangeSlider-ariaTill": "Till",
        "dxSwitch-switchedOnText": "ON",
        "dxSwitch-switchedOffText": "OFF",
        "dxForm-optionalMark": "optional",
        "dxForm-requiredMessage": "{0} is required",
        "dxNumberBox-invalidValueMessage": "Value must be a number",
        "dxNumberBox-noDataText": "No data",
        "dxDataGrid-columnChooserTitle": "Column Chooser",
        "dxDataGrid-columnChooserEmptyText": "Drag a column here to hide it",
        "dxDataGrid-groupContinuesMessage": "Continues on the next page",
        "dxDataGrid-groupContinuedMessage": "Continued from the previous page",
        "dxDataGrid-groupHeaderText": "Group by This Column",
        "dxDataGrid-ungroupHeaderText": "Ungroup",
        "dxDataGrid-ungroupAllText": "Ungroup All",
        "dxDataGrid-editingEditRow": "Edit",
        "dxDataGrid-editingSaveRowChanges": "Save",
        "dxDataGrid-editingCancelRowChanges": "Cancel",
        "dxDataGrid-editingDeleteRow": "Delete",
        "dxDataGrid-editingUndeleteRow": "Undelete",
        "dxDataGrid-editingConfirmDeleteMessage": "Are you sure you want to delete this record?",
        "dxDataGrid-validationCancelChanges": "Cancel changes",
        "dxDataGrid-groupPanelEmptyText": "Drag a column header here to group by that column",
        "dxDataGrid-noDataText": "No data",
        "dxDataGrid-searchPanelPlaceholder": "Search...",
        "dxDataGrid-filterRowShowAllText": "(All)",
        "dxDataGrid-filterRowResetOperationText": "Reset",
        "dxDataGrid-filterRowOperationEquals": "Equals",
        "dxDataGrid-filterRowOperationNotEquals": "Does not equal",
        "dxDataGrid-filterRowOperationLess": "Less than",
        "dxDataGrid-filterRowOperationLessOrEquals": "Less than or equal to",
        "dxDataGrid-filterRowOperationGreater": "Greater than",
        "dxDataGrid-filterRowOperationGreaterOrEquals": "Greater than or equal to",
        "dxDataGrid-filterRowOperationStartsWith": "Starts with",
        "dxDataGrid-filterRowOperationContains": "Contains",
        "dxDataGrid-filterRowOperationNotContains": "Does not contain",
        "dxDataGrid-filterRowOperationEndsWith": "Ends with",
        "dxDataGrid-filterRowOperationBetween": "Between",
        "dxDataGrid-filterRowOperationBetweenStartText": "Start",
        "dxDataGrid-filterRowOperationBetweenEndText": "End",
        "dxDataGrid-ariaSearchBox": "Search box",
        "dxDataGrid-applyFilterText": "Apply filter",
        "dxDataGrid-trueText": "true",
        "dxDataGrid-falseText": "false",
        "dxDataGrid-sortingAscendingText": "Sort Ascending",
        "dxDataGrid-sortingDescendingText": "Sort Descending",
        "dxDataGrid-sortingClearText": "Clear Sorting",
        "dxDataGrid-editingSaveAllChanges": "Save changes",
        "dxDataGrid-editingCancelAllChanges": "Discard changes",
        "dxDataGrid-editingAddRow": "Add a row",
        "dxDataGrid-summaryMin": "Min: {0}",
        "dxDataGrid-summaryMinOtherColumn": "Min of {1} is {0}",
        "dxDataGrid-summaryMax": "Max: {0}",
        "dxDataGrid-summaryMaxOtherColumn": "Max of {1} is {0}",
        "dxDataGrid-summaryAvg": "Avg: {0}",
        "dxDataGrid-summaryAvgOtherColumn": "Avg of {1} is {0}",
        "dxDataGrid-summarySum": "Sum: {0}",
        "dxDataGrid-summarySumOtherColumn": "Sum of {1} is {0}",
        "dxDataGrid-summaryCount": "Count: {0}",
        "dxDataGrid-columnFixingFix": "Fix",
        "dxDataGrid-columnFixingUnfix": "Unfix",
        "dxDataGrid-columnFixingLeftPosition": "To the left",
        "dxDataGrid-columnFixingRightPosition": "To the right",
        "dxDataGrid-exportTo": "Export",
        "dxDataGrid-exportToExcel": "Export to Excel file",
        "dxDataGrid-exporting": "Exporting...",
        "dxDataGrid-excelFormat": "Excel file",
        "dxDataGrid-selectedRows": "Selected rows",
        "dxDataGrid-exportSelectedRows": "Export selected rows to {0}",
        "dxDataGrid-exportAll": "Export all data to {0}",
        "dxDataGrid-headerFilterLabel": "Filter options",
        "dxDataGrid-headerFilterIndicatorLabel": "Show filter options for column '{0}'",
        "dxDataGrid-headerFilterEmptyValue": "(Blanks)",
        "dxDataGrid-headerFilterOK": "OK",
        "dxDataGrid-headerFilterCancel": "Cancel",
        "dxDataGrid-ariaAdaptiveCollapse": "Hide additional data",
        "dxDataGrid-ariaAdaptiveExpand": "Display additional data",
        "dxDataGrid-ariaColumn": "Column",
        "dxDataGrid-ariaValue": "Value",
        "dxDataGrid-ariaFilterCell": "Filter cell",
        "dxDataGrid-ariaCollapse": "Collapse",
        "dxDataGrid-ariaExpand": "Expand",
        "dxDataGrid-ariaDataGrid": "Data grid with {0} rows and {1} columns",
        "dxDataGrid-ariaSearchInGrid": "Search in the data grid",
        "dxDataGrid-ariaSelectAll": "Select all",
        "dxDataGrid-ariaSelectRow": "Select row",
        "dxDataGrid-ariaToolbar": "Data grid toolbar",
        "dxDataGrid-ariaEditForm": "Edit form",
        "dxDataGrid-filterBuilderPopupTitle": "Filter Builder",
        "dxDataGrid-filterPanelCreateFilter": "Create Filter",
        "dxDataGrid-filterPanelClearFilter": "Clear",
        "dxDataGrid-filterPanelFilterEnabledHint": "Enable the filter",
        "dxTreeList-ariaTreeList": "Tree list with {0} rows and {1} columns",
        "dxTreeList-ariaSearchInGrid": "Search in the tree list",
        "dxTreeList-ariaToolbar": "Tree list toolbar",
        "dxTreeList-editingAddRowToNode": "Add",
        "dxPager-infoText": "Page {0} of {1} ({2} items)",
        "dxPager-pagesCountText": "of",
        "dxPager-pageSize": "Items per page: {0}",
        "dxPager-pageSizesAllText": "All",
        "dxPager-page": "Page {0}",
        "dxPager-prevPage": "Previous Page",
        "dxPager-nextPage": "Next Page",
        "dxPager-ariaLabel": "Page Navigation",
        "dxPager-ariaPageSize": "Page size",
        "dxPager-ariaPageNumber": "Page number",
        "dxPivotGrid-grandTotal": "Grand Total",
        "dxPivotGrid-total": "{0} Total",
        "dxPivotGrid-fieldChooserTitle": "Field Chooser",
        "dxPivotGrid-showFieldChooser": "Show Field Chooser",
        "dxPivotGrid-expandAll": "Expand All",
        "dxPivotGrid-collapseAll": "Collapse All",
        "dxPivotGrid-sortColumnBySummary": 'Sort "{0}" by This Column',
        "dxPivotGrid-sortRowBySummary": 'Sort "{0}" by This Row',
        "dxPivotGrid-removeAllSorting": "Remove All Sorting",
        "dxPivotGrid-dataNotAvailable": "N/A",
        "dxPivotGrid-rowFields": "Row Fields",
        "dxPivotGrid-columnFields": "Column Fields",
        "dxPivotGrid-dataFields": "Data Fields",
        "dxPivotGrid-filterFields": "Filter Fields",
        "dxPivotGrid-allFields": "All Fields",
        "dxPivotGrid-columnFieldArea": "Drop Column Fields Here",
        "dxPivotGrid-dataFieldArea": "Drop Data Fields Here",
        "dxPivotGrid-rowFieldArea": "Drop Row Fields Here",
        "dxPivotGrid-filterFieldArea": "Drop Filter Fields Here",
        "dxScheduler-editorLabelTitle": "Subject",
        "dxScheduler-editorLabelStartDate": "Start Date",
        "dxScheduler-editorLabelEndDate": "End Date",
        "dxScheduler-editorLabelDescription": "Description",
        "dxScheduler-editorLabelRecurrence": "Repeat",
        "dxScheduler-openAppointment": "Open appointment",
        "dxScheduler-recurrenceNever": "Never",
        "dxScheduler-recurrenceMinutely": "Every minute",
        "dxScheduler-recurrenceHourly": "Hourly",
        "dxScheduler-recurrenceDaily": "Daily",
        "dxScheduler-recurrenceWeekly": "Weekly",
        "dxScheduler-recurrenceMonthly": "Monthly",
        "dxScheduler-recurrenceYearly": "Yearly",
        "dxScheduler-recurrenceRepeatEvery": "Repeat Every",
        "dxScheduler-recurrenceRepeatOn": "Repeat On",
        "dxScheduler-recurrenceEnd": "End repeat",
        "dxScheduler-recurrenceAfter": "After",
        "dxScheduler-recurrenceOn": "On",
        "dxScheduler-recurrenceRepeatMinutely": "minute(s)",
        "dxScheduler-recurrenceRepeatHourly": "hour(s)",
        "dxScheduler-recurrenceRepeatDaily": "day(s)",
        "dxScheduler-recurrenceRepeatWeekly": "week(s)",
        "dxScheduler-recurrenceRepeatMonthly": "month(s)",
        "dxScheduler-recurrenceRepeatYearly": "year(s)",
        "dxScheduler-switcherDay": "Day",
        "dxScheduler-switcherWeek": "Week",
        "dxScheduler-switcherWorkWeek": "Work Week",
        "dxScheduler-switcherMonth": "Month",
        "dxScheduler-switcherAgenda": "Agenda",
        "dxScheduler-switcherTimelineDay": "Timeline Day",
        "dxScheduler-switcherTimelineWeek": "Timeline Week",
        "dxScheduler-switcherTimelineWorkWeek": "Timeline Work Week",
        "dxScheduler-switcherTimelineMonth": "Timeline Month",
        "dxScheduler-recurrenceRepeatOnDate": "on date",
        "dxScheduler-recurrenceRepeatCount": "occurrence(s)",
        "dxScheduler-allDay": "All day",
        "dxScheduler-confirmRecurrenceEditMessage": "Do you want to edit only this appointment or the whole series?",
        "dxScheduler-confirmRecurrenceDeleteMessage": "Do you want to delete only this appointment or the whole series?",
        "dxScheduler-confirmRecurrenceEditSeries": "Edit series",
        "dxScheduler-confirmRecurrenceDeleteSeries": "Delete series",
        "dxScheduler-confirmRecurrenceEditOccurrence": "Edit appointment",
        "dxScheduler-confirmRecurrenceDeleteOccurrence": "Delete appointment",
        "dxScheduler-noTimezoneTitle": "No timezone",
        "dxScheduler-moreAppointments": "{0} more",
        "dxCalendar-todayButtonText": "Today",
        "dxCalendar-ariaWidgetName": "Calendar",
        "dxCalendar-ariaHotKeysInfo": "To navigate between views, press Control, and then Left Arrow or Right Arrow. To zoom in on a view, press Control, and then Down Arrow. To zoom out, press Control, and then Up Arrow.",
        "dxColorView-ariaRed": "Red",
        "dxColorView-ariaGreen": "Green",
        "dxColorView-ariaBlue": "Blue",
        "dxColorView-ariaAlpha": "Transparency",
        "dxColorView-ariaHex": "Color code",
        "dxTagBox-selected": "{0} selected",
        "dxTagBox-allSelected": "All selected ({0})",
        "dxTagBox-moreSelected": "{0} more",
        "vizExport-printingButtonText": "Print",
        "vizExport-titleMenuText": "Exporting/Printing",
        "vizExport-exportButtonText": "{0} file",
        "dxFilterBuilder-and": "And",
        "dxFilterBuilder-or": "Or",
        "dxFilterBuilder-notAnd": "Not And",
        "dxFilterBuilder-notOr": "Not Or",
        "dxFilterBuilder-addCondition": "Add Condition",
        "dxFilterBuilder-addGroup": "Add Group",
        "dxFilterBuilder-enterValueText": "<enter a value>",
        "dxFilterBuilder-filterOperationEquals": "Equals",
        "dxFilterBuilder-filterOperationNotEquals": "Does not equal",
        "dxFilterBuilder-filterOperationLess": "Is less than",
        "dxFilterBuilder-filterOperationLessOrEquals": "Is less than or equal to",
        "dxFilterBuilder-filterOperationGreater": "Is greater than",
        "dxFilterBuilder-filterOperationGreaterOrEquals": "Is greater than or equal to",
        "dxFilterBuilder-filterOperationStartsWith": "Starts with",
        "dxFilterBuilder-filterOperationContains": "Contains",
        "dxFilterBuilder-filterOperationNotContains": "Does not contain",
        "dxFilterBuilder-filterOperationEndsWith": "Ends with",
        "dxFilterBuilder-filterOperationIsBlank": "Is blank",
        "dxFilterBuilder-filterOperationIsNotBlank": "Is not blank",
        "dxFilterBuilder-filterOperationBetween": "Is between",
        "dxFilterBuilder-filterOperationAnyOf": "Is any of",
        "dxFilterBuilder-filterOperationNoneOf": "Is none of",
        "dxHtmlEditor-dialogColorCaption": "Change Font Color",
        "dxHtmlEditor-dialogBackgroundCaption": "Change Background Color",
        "dxHtmlEditor-dialogLinkCaption": "Add Link",
        "dxHtmlEditor-dialogLinkUrlField": "URL",
        "dxHtmlEditor-dialogLinkTextField": "Text",
        "dxHtmlEditor-dialogLinkTargetField": "Open link in new window",
        "dxHtmlEditor-dialogImageCaption": "Add Image",
        "dxHtmlEditor-dialogImageUrlField": "URL",
        "dxHtmlEditor-dialogImageAltField": "Alternate text",
        "dxHtmlEditor-dialogImageWidthField": "Width (px)",
        "dxHtmlEditor-dialogImageHeightField": "Height (px)",
        "dxHtmlEditor-dialogInsertTableRowsField": "Rows",
        "dxHtmlEditor-dialogInsertTableColumnsField": "Columns",
        "dxHtmlEditor-dialogInsertTableCaption": "Insert Table",
        "dxHtmlEditor-dialogUpdateImageCaption": "Update Image",
        "dxHtmlEditor-dialogImageUpdateButton": "Update",
        "dxHtmlEditor-dialogImageAddButton": "Add",
        "dxHtmlEditor-dialogImageSpecifyUrl": "From the Web",
        "dxHtmlEditor-dialogImageSelectFile": "From This Device",
        "dxHtmlEditor-dialogImageKeepAspectRatio": "Keep Aspect Ratio",
        "dxHtmlEditor-dialogImageEncodeToBase64": "Encode to Base64",
        "dxHtmlEditor-heading": "Heading",
        "dxHtmlEditor-normalText": "Normal text",
        "dxHtmlEditor-background": "Background Color",
        "dxHtmlEditor-bold": "Bold",
        "dxHtmlEditor-color": "Font Color",
        "dxHtmlEditor-font": "Font",
        "dxHtmlEditor-italic": "Italic",
        "dxHtmlEditor-link": "Add Link",
        "dxHtmlEditor-image": "Add Image",
        "dxHtmlEditor-size": "Size",
        "dxHtmlEditor-strike": "Strikethrough",
        "dxHtmlEditor-subscript": "Subscript",
        "dxHtmlEditor-superscript": "Superscript",
        "dxHtmlEditor-underline": "Underline",
        "dxHtmlEditor-blockquote": "Blockquote",
        "dxHtmlEditor-header": "Header",
        "dxHtmlEditor-increaseIndent": "Increase Indent",
        "dxHtmlEditor-decreaseIndent": "Decrease Indent",
        "dxHtmlEditor-orderedList": "Ordered List",
        "dxHtmlEditor-bulletList": "Bullet List",
        "dxHtmlEditor-alignLeft": "Align Left",
        "dxHtmlEditor-alignCenter": "Align Center",
        "dxHtmlEditor-alignRight": "Align Right",
        "dxHtmlEditor-alignJustify": "Align Justify",
        "dxHtmlEditor-codeBlock": "Code Block",
        "dxHtmlEditor-variable": "Add Variable",
        "dxHtmlEditor-undo": "Undo",
        "dxHtmlEditor-redo": "Redo",
        "dxHtmlEditor-clear": "Clear Formatting",
        "dxHtmlEditor-insertTable": "Insert Table",
        "dxHtmlEditor-insertHeaderRow": "Insert Header Row",
        "dxHtmlEditor-insertRowAbove": "Insert Row Above",
        "dxHtmlEditor-insertRowBelow": "Insert Row Below",
        "dxHtmlEditor-insertColumnLeft": "Insert Column Left",
        "dxHtmlEditor-insertColumnRight": "Insert Column Right",
        "dxHtmlEditor-deleteColumn": "Delete Column",
        "dxHtmlEditor-deleteRow": "Delete Row",
        "dxHtmlEditor-deleteTable": "Delete Table",
        "dxHtmlEditor-cellProperties": "Cell Properties",
        "dxHtmlEditor-tableProperties": "Table Properties",
        "dxHtmlEditor-insert": "Insert",
        "dxHtmlEditor-delete": "Delete",
        "dxHtmlEditor-border": "Border",
        "dxHtmlEditor-style": "Style",
        "dxHtmlEditor-width": "Width",
        "dxHtmlEditor-height": "Height",
        "dxHtmlEditor-borderColor": "Color",
        "dxHtmlEditor-tableBackground": "Background",
        "dxHtmlEditor-dimensions": "Dimensions",
        "dxHtmlEditor-alignment": "Alignment",
        "dxHtmlEditor-horizontal": "Horizontal",
        "dxHtmlEditor-vertical": "Vertical",
        "dxHtmlEditor-paddingVertical": "Vertical Padding",
        "dxHtmlEditor-paddingHorizontal": "Horizontal Padding",
        "dxHtmlEditor-pixels": "Pixels",
        "dxHtmlEditor-list": "List",
        "dxHtmlEditor-ordered": "Ordered",
        "dxHtmlEditor-bullet": "Bullet",
        "dxHtmlEditor-align": "Align",
        "dxHtmlEditor-center": "Center",
        "dxHtmlEditor-left": "Left",
        "dxHtmlEditor-right": "Right",
        "dxHtmlEditor-indent": "Indent",
        "dxHtmlEditor-justify": "Justify",
        "dxHtmlEditor-borderStyleNone": "none",
        "dxHtmlEditor-borderStyleHidden": "hidden",
        "dxHtmlEditor-borderStyleDotted": "dotted",
        "dxHtmlEditor-borderStyleDashed": "dashed",
        "dxHtmlEditor-borderStyleSolid": "solid",
        "dxHtmlEditor-borderStyleDouble": "double",
        "dxHtmlEditor-borderStyleGroove": "groove",
        "dxHtmlEditor-borderStyleRidge": "ridge",
        "dxHtmlEditor-borderStyleInset": "inset",
        "dxHtmlEditor-borderStyleOutset": "outset",
        "dxFileManager-newDirectoryName": "Untitled directory",
        "dxFileManager-rootDirectoryName": "Files",
        "dxFileManager-errorNoAccess": "Access Denied. Operation could not be completed.",
        "dxFileManager-errorDirectoryExistsFormat": "Directory '{0}' already exists.",
        "dxFileManager-errorFileExistsFormat": "File '{0}' already exists.",
        "dxFileManager-errorFileNotFoundFormat": "File '{0}' not found.",
        "dxFileManager-errorDirectoryNotFoundFormat": "Directory '{0}' not found.",
        "dxFileManager-errorWrongFileExtension": "File extension is not allowed.",
        "dxFileManager-errorMaxFileSizeExceeded": "File size exceeds the maximum allowed size.",
        "dxFileManager-errorInvalidSymbols": "This name contains invalid characters.",
        "dxFileManager-errorDefault": "Unspecified error.",
        "dxFileManager-errorDirectoryOpenFailed": "The directory cannot be opened",
        "dxFileManager-commandCreate": "New directory",
        "dxFileManager-commandRename": "Rename",
        "dxFileManager-commandMove": "Move to",
        "dxFileManager-commandCopy": "Copy to",
        "dxFileManager-commandDelete": "Delete",
        "dxFileManager-commandDownload": "Download",
        "dxFileManager-commandUpload": "Upload files",
        "dxFileManager-commandRefresh": "Refresh",
        "dxFileManager-commandThumbnails": "Thumbnails View",
        "dxFileManager-commandDetails": "Details View",
        "dxFileManager-commandClearSelection": "Clear selection",
        "dxFileManager-commandShowNavPane": "Toggle navigation pane",
        "dxFileManager-dialogDirectoryChooserMoveTitle": "Move to",
        "dxFileManager-dialogDirectoryChooserMoveButtonText": "Move",
        "dxFileManager-dialogDirectoryChooserCopyTitle": "Copy to",
        "dxFileManager-dialogDirectoryChooserCopyButtonText": "Copy",
        "dxFileManager-dialogRenameItemTitle": "Rename",
        "dxFileManager-dialogRenameItemButtonText": "Save",
        "dxFileManager-dialogCreateDirectoryTitle": "New directory",
        "dxFileManager-dialogCreateDirectoryButtonText": "Create",
        "dxFileManager-dialogDeleteItemTitle": "Delete",
        "dxFileManager-dialogDeleteItemButtonText": "Delete",
        "dxFileManager-dialogDeleteItemSingleItemConfirmation": "Are you sure you want to delete {0}?",
        "dxFileManager-dialogDeleteItemMultipleItemsConfirmation": "Are you sure you want to delete {0} items?",
        "dxFileManager-dialogButtonCancel": "Cancel",
        "dxFileManager-editingCreateSingleItemProcessingMessage": "Creating a directory inside {0}",
        "dxFileManager-editingCreateSingleItemSuccessMessage": "Created a directory inside {0}",
        "dxFileManager-editingCreateSingleItemErrorMessage": "Directory was not created",
        "dxFileManager-editingCreateCommonErrorMessage": "Directory was not created",
        "dxFileManager-editingRenameSingleItemProcessingMessage": "Renaming an item inside {0}",
        "dxFileManager-editingRenameSingleItemSuccessMessage": "Renamed an item inside {0}",
        "dxFileManager-editingRenameSingleItemErrorMessage": "Item was not renamed",
        "dxFileManager-editingRenameCommonErrorMessage": "Item was not renamed",
        "dxFileManager-editingDeleteSingleItemProcessingMessage": "Deleting an item from {0}",
        "dxFileManager-editingDeleteMultipleItemsProcessingMessage": "Deleting {0} items from {1}",
        "dxFileManager-editingDeleteSingleItemSuccessMessage": "Deleted an item from {0}",
        "dxFileManager-editingDeleteMultipleItemsSuccessMessage": "Deleted {0} items from {1}",
        "dxFileManager-editingDeleteSingleItemErrorMessage": "Item was not deleted",
        "dxFileManager-editingDeleteMultipleItemsErrorMessage": "{0} items were not deleted",
        "dxFileManager-editingDeleteCommonErrorMessage": "Some items were not deleted",
        "dxFileManager-editingMoveSingleItemProcessingMessage": "Moving an item to {0}",
        "dxFileManager-editingMoveMultipleItemsProcessingMessage": "Moving {0} items to {1}",
        "dxFileManager-editingMoveSingleItemSuccessMessage": "Moved an item to {0}",
        "dxFileManager-editingMoveMultipleItemsSuccessMessage": "Moved {0} items to {1}",
        "dxFileManager-editingMoveSingleItemErrorMessage": "Item was not moved",
        "dxFileManager-editingMoveMultipleItemsErrorMessage": "{0} items were not moved",
        "dxFileManager-editingMoveCommonErrorMessage": "Some items were not moved",
        "dxFileManager-editingCopySingleItemProcessingMessage": "Copying an item to {0}",
        "dxFileManager-editingCopyMultipleItemsProcessingMessage": "Copying {0} items to {1}",
        "dxFileManager-editingCopySingleItemSuccessMessage": "Copied an item to {0}",
        "dxFileManager-editingCopyMultipleItemsSuccessMessage": "Copied {0} items to {1}",
        "dxFileManager-editingCopySingleItemErrorMessage": "Item was not copied",
        "dxFileManager-editingCopyMultipleItemsErrorMessage": "{0} items were not copied",
        "dxFileManager-editingCopyCommonErrorMessage": "Some items were not copied",
        "dxFileManager-editingUploadSingleItemProcessingMessage": "Uploading an item to {0}",
        "dxFileManager-editingUploadMultipleItemsProcessingMessage": "Uploading {0} items to {1}",
        "dxFileManager-editingUploadSingleItemSuccessMessage": "Uploaded an item to {0}",
        "dxFileManager-editingUploadMultipleItemsSuccessMessage": "Uploaded {0} items to {1}",
        "dxFileManager-editingUploadSingleItemErrorMessage": "Item was not uploaded",
        "dxFileManager-editingUploadMultipleItemsErrorMessage": "{0} items were not uploaded",
        "dxFileManager-editingUploadCanceledMessage": "Canceled",
        "dxFileManager-editingDownloadSingleItemErrorMessage": "Item was not downloaded",
        "dxFileManager-editingDownloadMultipleItemsErrorMessage": "{0} items were not downloaded",
        "dxFileManager-listDetailsColumnCaptionName": "Name",
        "dxFileManager-listDetailsColumnCaptionDateModified": "Date Modified",
        "dxFileManager-listDetailsColumnCaptionFileSize": "File Size",
        "dxFileManager-listThumbnailsTooltipTextSize": "Size",
        "dxFileManager-listThumbnailsTooltipTextDateModified": "Date Modified",
        "dxFileManager-notificationProgressPanelTitle": "Progress",
        "dxFileManager-notificationProgressPanelEmptyListText": "No operations",
        "dxFileManager-notificationProgressPanelOperationCanceled": "Canceled",
        "dxDiagram-categoryGeneral": "General",
        "dxDiagram-categoryFlowchart": "Flowchart",
        "dxDiagram-categoryOrgChart": "Org Chart",
        "dxDiagram-categoryContainers": "Containers",
        "dxDiagram-categoryCustom": "Custom",
        "dxDiagram-commandExportToSvg": "Export to SVG",
        "dxDiagram-commandExportToPng": "Export to PNG",
        "dxDiagram-commandExportToJpg": "Export to JPEG",
        "dxDiagram-commandUndo": "Undo",
        "dxDiagram-commandRedo": "Redo",
        "dxDiagram-commandFontName": "Font Name",
        "dxDiagram-commandFontSize": "Font Size",
        "dxDiagram-commandBold": "Bold",
        "dxDiagram-commandItalic": "Italic",
        "dxDiagram-commandUnderline": "Underline",
        "dxDiagram-commandTextColor": "Font Color",
        "dxDiagram-commandLineColor": "Line Color",
        "dxDiagram-commandLineWidth": "Line Width",
        "dxDiagram-commandLineStyle": "Line Style",
        "dxDiagram-commandLineStyleSolid": "Solid",
        "dxDiagram-commandLineStyleDotted": "Dotted",
        "dxDiagram-commandLineStyleDashed": "Dashed",
        "dxDiagram-commandFillColor": "Fill Color",
        "dxDiagram-commandAlignLeft": "Align Left",
        "dxDiagram-commandAlignCenter": "Align Center",
        "dxDiagram-commandAlignRight": "Align Right",
        "dxDiagram-commandConnectorLineType": "Connector Line Type",
        "dxDiagram-commandConnectorLineStraight": "Straight",
        "dxDiagram-commandConnectorLineOrthogonal": "Orthogonal",
        "dxDiagram-commandConnectorLineStart": "Connector Line Start",
        "dxDiagram-commandConnectorLineEnd": "Connector Line End",
        "dxDiagram-commandConnectorLineNone": "None",
        "dxDiagram-commandConnectorLineArrow": "Arrow",
        "dxDiagram-commandFullscreen": "Full Screen",
        "dxDiagram-commandUnits": "Units",
        "dxDiagram-commandPageSize": "Page Size",
        "dxDiagram-commandPageOrientation": "Page Orientation",
        "dxDiagram-commandPageOrientationLandscape": "Landscape",
        "dxDiagram-commandPageOrientationPortrait": "Portrait",
        "dxDiagram-commandPageColor": "Page Color",
        "dxDiagram-commandShowGrid": "Show Grid",
        "dxDiagram-commandSnapToGrid": "Snap to Grid",
        "dxDiagram-commandGridSize": "Grid Size",
        "dxDiagram-commandZoomLevel": "Zoom Level",
        "dxDiagram-commandAutoZoom": "Auto Zoom",
        "dxDiagram-commandFitToContent": "Fit to Content",
        "dxDiagram-commandFitToWidth": "Fit to Width",
        "dxDiagram-commandAutoZoomByContent": "Auto Zoom by Content",
        "dxDiagram-commandAutoZoomByWidth": "Auto Zoom by Width",
        "dxDiagram-commandSimpleView": "Simple View",
        "dxDiagram-commandCut": "Cut",
        "dxDiagram-commandCopy": "Copy",
        "dxDiagram-commandPaste": "Paste",
        "dxDiagram-commandSelectAll": "Select All",
        "dxDiagram-commandDelete": "Delete",
        "dxDiagram-commandBringToFront": "Bring to Front",
        "dxDiagram-commandSendToBack": "Send to Back",
        "dxDiagram-commandLock": "Lock",
        "dxDiagram-commandUnlock": "Unlock",
        "dxDiagram-commandInsertShapeImage": "Insert Image...",
        "dxDiagram-commandEditShapeImage": "Change Image...",
        "dxDiagram-commandDeleteShapeImage": "Delete Image",
        "dxDiagram-commandLayoutLeftToRight": "Left-to-right",
        "dxDiagram-commandLayoutRightToLeft": "Right-to-left",
        "dxDiagram-commandLayoutTopToBottom": "Top-to-bottom",
        "dxDiagram-commandLayoutBottomToTop": "Bottom-to-top",
        "dxDiagram-unitIn": "in",
        "dxDiagram-unitCm": "cm",
        "dxDiagram-unitPx": "px",
        "dxDiagram-dialogButtonOK": "OK",
        "dxDiagram-dialogButtonCancel": "Cancel",
        "dxDiagram-dialogInsertShapeImageTitle": "Insert Image",
        "dxDiagram-dialogEditShapeImageTitle": "Change Image",
        "dxDiagram-dialogEditShapeImageSelectButton": "Select image",
        "dxDiagram-dialogEditShapeImageLabelText": "or drop a file here",
        "dxDiagram-uiExport": "Export",
        "dxDiagram-uiProperties": "Properties",
        "dxDiagram-uiSettings": "Settings",
        "dxDiagram-uiShowToolbox": "Show Toolbox",
        "dxDiagram-uiSearch": "Search",
        "dxDiagram-uiStyle": "Style",
        "dxDiagram-uiLayout": "Layout",
        "dxDiagram-uiLayoutTree": "Tree",
        "dxDiagram-uiLayoutLayered": "Layered",
        "dxDiagram-uiDiagram": "Diagram",
        "dxDiagram-uiText": "Text",
        "dxDiagram-uiObject": "Object",
        "dxDiagram-uiConnector": "Connector",
        "dxDiagram-uiPage": "Page",
        "dxDiagram-shapeText": "Text",
        "dxDiagram-shapeRectangle": "Rectangle",
        "dxDiagram-shapeEllipse": "Ellipse",
        "dxDiagram-shapeCross": "Cross",
        "dxDiagram-shapeTriangle": "Triangle",
        "dxDiagram-shapeDiamond": "Diamond",
        "dxDiagram-shapeHeart": "Heart",
        "dxDiagram-shapePentagon": "Pentagon",
        "dxDiagram-shapeHexagon": "Hexagon",
        "dxDiagram-shapeOctagon": "Octagon",
        "dxDiagram-shapeStar": "Star",
        "dxDiagram-shapeArrowLeft": "Left Arrow",
        "dxDiagram-shapeArrowUp": "Up Arrow",
        "dxDiagram-shapeArrowRight": "Right Arrow",
        "dxDiagram-shapeArrowDown": "Down Arrow",
        "dxDiagram-shapeArrowUpDown": "Up Down Arrow",
        "dxDiagram-shapeArrowLeftRight": "Left Right Arrow",
        "dxDiagram-shapeProcess": "Process",
        "dxDiagram-shapeDecision": "Decision",
        "dxDiagram-shapeTerminator": "Terminator",
        "dxDiagram-shapePredefinedProcess": "Predefined Process",
        "dxDiagram-shapeDocument": "Document",
        "dxDiagram-shapeMultipleDocuments": "Multiple Documents",
        "dxDiagram-shapeManualInput": "Manual Input",
        "dxDiagram-shapePreparation": "Preparation",
        "dxDiagram-shapeData": "Data",
        "dxDiagram-shapeDatabase": "Database",
        "dxDiagram-shapeHardDisk": "Hard Disk",
        "dxDiagram-shapeInternalStorage": "Internal Storage",
        "dxDiagram-shapePaperTape": "Paper Tape",
        "dxDiagram-shapeManualOperation": "Manual Operation",
        "dxDiagram-shapeDelay": "Delay",
        "dxDiagram-shapeStoredData": "Stored Data",
        "dxDiagram-shapeDisplay": "Display",
        "dxDiagram-shapeMerge": "Merge",
        "dxDiagram-shapeConnector": "Connector",
        "dxDiagram-shapeOr": "Or",
        "dxDiagram-shapeSummingJunction": "Summing Junction",
        "dxDiagram-shapeContainerDefaultText": "Container",
        "dxDiagram-shapeVerticalContainer": "Vertical Container",
        "dxDiagram-shapeHorizontalContainer": "Horizontal Container",
        "dxDiagram-shapeCardDefaultText": "Person's Name",
        "dxDiagram-shapeCardWithImageOnLeft": "Card with Image on the Left",
        "dxDiagram-shapeCardWithImageOnTop": "Card with Image on the Top",
        "dxDiagram-shapeCardWithImageOnRight": "Card with Image on the Right",
        "dxGantt-dialogTitle": "Title",
        "dxGantt-dialogStartTitle": "Start",
        "dxGantt-dialogEndTitle": "End",
        "dxGantt-dialogProgressTitle": "Progress",
        "dxGantt-dialogResourcesTitle": "Resources",
        "dxGantt-dialogResourceManagerTitle": "Resource Manager",
        "dxGantt-dialogTaskDetailsTitle": "Task Details",
        "dxGantt-dialogEditResourceListHint": "Edit Resource List",
        "dxGantt-dialogEditNoResources": "No resources",
        "dxGantt-dialogButtonAdd": "Add",
        "dxGantt-contextMenuNewTask": "New Task",
        "dxGantt-contextMenuNewSubtask": "New Subtask",
        "dxGantt-contextMenuDeleteTask": "Delete Task",
        "dxGantt-contextMenuDeleteDependency": "Delete Dependency",
        "dxGantt-dialogTaskDeleteConfirmation": "Deleting a task also deletes all its dependencies and subtasks. Are you sure you want to delete this task?",
        "dxGantt-dialogDependencyDeleteConfirmation": "Are you sure you want to delete the dependency from the task?",
        "dxGantt-dialogResourcesDeleteConfirmation": "Deleting a resource also deletes it from tasks to which this resource is assigned. Are you sure you want to delete these resources? Resources: {0}",
        "dxGantt-dialogConstraintCriticalViolationMessage": "The task you are attempting to move is linked to a second task by a dependency relation. This change would conflict with dependency rules. How would you like to proceed?",
        "dxGantt-dialogConstraintViolationMessage": "The task you are attempting to move is linked to a second task by a dependency relation. How would you like to proceed?",
        "dxGantt-dialogCancelOperationMessage": "Cancel the operation",
        "dxGantt-dialogDeleteDependencyMessage": "Delete the dependency",
        "dxGantt-dialogMoveTaskAndKeepDependencyMessage": "Move the task and keep the dependency",
        "dxGantt-dialogConstraintCriticalViolationSeveralTasksMessage": "The task you are attempting to move is linked to another tasks by dependency relations. This change would conflict with dependency rules. How would you like to proceed?",
        "dxGantt-dialogConstraintViolationSeveralTasksMessage": "The task you are attempting to move is linked to another tasks by dependency relations. How would you like to proceed?",
        "dxGantt-dialogDeleteDependenciesMessage": "Delete the dependency relations",
        "dxGantt-dialogMoveTaskAndKeepDependenciesMessage": "Move the task and keep the dependencies",
        "dxGantt-undo": "Undo",
        "dxGantt-redo": "Redo",
        "dxGantt-expandAll": "Expand All",
        "dxGantt-collapseAll": "Collapse All",
        "dxGantt-addNewTask": "Add New Task",
        "dxGantt-deleteSelectedTask": "Delete Selected Task",
        "dxGantt-zoomIn": "Zoom In",
        "dxGantt-zoomOut": "Zoom Out",
        "dxGantt-fullScreen": "Full Screen",
        "dxGantt-quarter": "Q{0}",
        "dxGantt-sortingAscendingText": "Sort Ascending",
        "dxGantt-sortingDescendingText": "Sort Descending",
        "dxGantt-sortingClearText": "Clear Sorting",
        "dxGantt-showResources": "Show Resources",
        "dxGantt-showDependencies": "Show Dependencies",
        "dxGantt-dialogStartDateValidation": "Start date must be after {0}",
        "dxGantt-dialogEndDateValidation": "End date must be after {0}"
    }
};

});


parcelRegister("kapgi", function(module, exports) {

$parcel$export(module.exports, "start", function () { return $eae8564e7596228e$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $eae8564e7596228e$export$bd5df0f255a350f8; });
/**
 * DevExtreme (esm/events/hover.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $60GuF = parcelRequire("60GuF");

var $jc4XS = parcelRequire("jc4XS");

var $a2g7x = parcelRequire("a2g7x");

var $jF0bZ = parcelRequire("jF0bZ");

var $jxLje = parcelRequire("jxLje");

var $bcOMe = parcelRequire("bcOMe");

var $cgnQR = parcelRequire("cgnQR");
var $eae8564e7596228e$var$HOVERSTART_NAMESPACE = "dxHoverStart";
var $eae8564e7596228e$export$b3571188c770cc5a = "dxhoverstart";
var $eae8564e7596228e$var$POINTERENTER_NAMESPACED_EVENT_NAME = (0, $bcOMe.addNamespace)((0, $cgnQR.default).enter, $eae8564e7596228e$var$HOVERSTART_NAMESPACE);
var $eae8564e7596228e$var$HOVEREND_NAMESPACE = "dxHoverEnd";
var $eae8564e7596228e$export$bd5df0f255a350f8 = "dxhoverend";
var $eae8564e7596228e$var$POINTERLEAVE_NAMESPACED_EVENT_NAME = (0, $bcOMe.addNamespace)((0, $cgnQR.default).leave, $eae8564e7596228e$var$HOVEREND_NAMESPACE);
var $eae8564e7596228e$var$Hover = (0, $a2g7x.default).inherit({
    noBubble: true,
    ctor: function() {
        this._handlerArrayKeyPath = this._eventNamespace + "_HandlerStore";
    },
    setup: function(element) {
        (0, $jc4XS.data)(element, this._handlerArrayKeyPath, {});
    },
    add: function(element, handleObj) {
        var that = this;
        var handler = function(e) {
            that._handler(e);
        };
        (0, $60GuF.default).on(element, this._originalEventName, handleObj.selector, handler);
        (0, $jc4XS.data)(element, this._handlerArrayKeyPath)[handleObj.guid] = handler;
    },
    _handler: function(e) {
        if ((0, $bcOMe.isTouchEvent)(e) || (0, $jF0bZ.default).isSimulator()) return;
        (0, $bcOMe.fireEvent)({
            type: this._eventName,
            originalEvent: e,
            delegateTarget: e.delegateTarget
        });
    },
    remove: function(element, handleObj) {
        var handler = (0, $jc4XS.data)(element, this._handlerArrayKeyPath)[handleObj.guid];
        (0, $60GuF.default).off(element, this._originalEventName, handleObj.selector, handler);
    },
    teardown: function(element) {
        (0, $jc4XS.removeData)(element, this._handlerArrayKeyPath);
    }
});
var $eae8564e7596228e$var$HoverStart = $eae8564e7596228e$var$Hover.inherit({
    ctor: function() {
        this._eventNamespace = $eae8564e7596228e$var$HOVERSTART_NAMESPACE;
        this._eventName = $eae8564e7596228e$export$b3571188c770cc5a;
        this._originalEventName = $eae8564e7596228e$var$POINTERENTER_NAMESPACED_EVENT_NAME;
        this.callBase();
    },
    _handler: function(e) {
        var pointers = e.pointers || [];
        if (!pointers.length) this.callBase(e);
    }
});
var $eae8564e7596228e$var$HoverEnd = $eae8564e7596228e$var$Hover.inherit({
    ctor: function() {
        this._eventNamespace = $eae8564e7596228e$var$HOVEREND_NAMESPACE;
        this._eventName = $eae8564e7596228e$export$bd5df0f255a350f8;
        this._originalEventName = $eae8564e7596228e$var$POINTERLEAVE_NAMESPACED_EVENT_NAME;
        this.callBase();
    }
});
(0, $jxLje.default)($eae8564e7596228e$export$b3571188c770cc5a, new $eae8564e7596228e$var$HoverStart);
(0, $jxLje.default)($eae8564e7596228e$export$bd5df0f255a350f8, new $eae8564e7596228e$var$HoverEnd);

});


parcelRegister("jM2K9", function(module, exports) {

$parcel$export(module.exports, "plugin", function () { return $e654a0c7706bb17a$export$ca524d3785e2543; });
/**
 * DevExtreme (esm/viz/core/loading_indicator.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $dw9tZ = parcelRequire("dw9tZ");
var $e654a0c7706bb17a$var$STATE_HIDDEN = 0;
var $e654a0c7706bb17a$var$STATE_SHOWN = 1;
var $e654a0c7706bb17a$var$ANIMATION_EASING = "linear";
var $e654a0c7706bb17a$var$ANIMATION_DURATION = 400;
var $e654a0c7706bb17a$var$LOADING_INDICATOR_READY = "loadingIndicatorReady";
var $e654a0c7706bb17a$export$7c20be4c1d342248 = function(parameters) {
    var renderer = parameters.renderer;
    this._group = renderer.g().attr({
        class: "dx-loading-indicator"
    }).linkOn(renderer.root, {
        name: "loading-indicator",
        after: "peripheral"
    });
    this._rect = renderer.rect().attr({
        opacity: 0
    }).append(this._group);
    this._text = renderer.text().attr({
        align: "center"
    }).append(this._group);
    this._createStates(parameters.eventTrigger, this._group, renderer.root, parameters.notify);
};
$e654a0c7706bb17a$export$7c20be4c1d342248.prototype = {
    constructor: $e654a0c7706bb17a$export$7c20be4c1d342248,
    _createStates: function(eventTrigger, group, root, notify) {
        this._states = [
            {
                opacity: 0,
                start: function() {
                    notify(false);
                },
                complete: function() {
                    group.linkRemove();
                    root.css({
                        "pointer-events": ""
                    });
                    eventTrigger($e654a0c7706bb17a$var$LOADING_INDICATOR_READY);
                }
            },
            {
                opacity: .85,
                start: function() {
                    group.linkAppend();
                    root.css({
                        "pointer-events": "none"
                    });
                    notify(true);
                },
                complete: function() {
                    eventTrigger($e654a0c7706bb17a$var$LOADING_INDICATOR_READY);
                }
            }
        ];
        this._state = $e654a0c7706bb17a$var$STATE_HIDDEN;
    },
    setSize: function(size) {
        var width = size.width;
        var height = size.height;
        this._rect.attr({
            width: width,
            height: height
        });
        this._text.attr({
            x: width / 2,
            y: height / 2
        });
    },
    setOptions: function(options) {
        this._rect.attr({
            fill: options.backgroundColor
        });
        this._text.css((0, $dw9tZ.patchFontOptions)(options.font)).attr({
            text: options.text,
            class: options.cssClass
        });
        this[options.show ? "show" : "hide"]();
    },
    dispose: function() {
        this._group.linkRemove().linkOff();
        this._group = this._rect = this._text = this._states = null;
    },
    _transit: function(stateId) {
        var state;
        if (this._state !== stateId) {
            this._state = stateId;
            this._isHiding = false;
            state = this._states[stateId];
            this._rect.stopAnimation().animate({
                opacity: state.opacity
            }, {
                complete: state.complete,
                easing: $e654a0c7706bb17a$var$ANIMATION_EASING,
                duration: $e654a0c7706bb17a$var$ANIMATION_DURATION,
                unstoppable: true
            });
            this._noHiding = true;
            state.start();
            this._noHiding = false;
        }
    },
    show: function() {
        this._transit($e654a0c7706bb17a$var$STATE_SHOWN);
    },
    hide: function() {
        this._transit($e654a0c7706bb17a$var$STATE_HIDDEN);
    },
    scheduleHiding: function() {
        if (!this._noHiding) this._isHiding = true;
    },
    fulfillHiding: function() {
        if (this._isHiding) this.hide();
    }
};
var $e654a0c7706bb17a$export$ca524d3785e2543 = {
    name: "loading_indicator",
    init: function() {
        var that = this;
        that._loadingIndicator = new $e654a0c7706bb17a$export$7c20be4c1d342248({
            eventTrigger: that._eventTrigger,
            renderer: that._renderer,
            notify: function(state) {
                that._skipLoadingIndicatorOptions = true;
                that.option("loadingIndicator", {
                    show: state
                });
                that._skipLoadingIndicatorOptions = false;
                if (state) that._stopCurrentHandling();
            }
        });
        that._scheduleLoadingIndicatorHiding();
    },
    dispose: function() {
        this._loadingIndicator.dispose();
        this._loadingIndicator = null;
    },
    members: {
        _scheduleLoadingIndicatorHiding: function() {
            this._loadingIndicator.scheduleHiding();
        },
        _fulfillLoadingIndicatorHiding: function() {
            this._loadingIndicator.fulfillHiding();
        },
        showLoadingIndicator: function() {
            this._loadingIndicator.show();
        },
        hideLoadingIndicator: function() {
            this._loadingIndicator.hide();
        },
        _onBeginUpdate: function() {
            if (!this._optionChangedLocker) this._scheduleLoadingIndicatorHiding();
        }
    },
    extenders: {
        _dataSourceLoadingChangedHandler (isLoading) {
            if (isLoading && (this._options.silent("loadingIndicator") || {}).enabled) this._loadingIndicator.show();
        },
        _setContentSize () {
            this._loadingIndicator.setSize(this._canvas);
        },
        endUpdate () {
            if (this._initialized && this._dataIsReady()) this._fulfillLoadingIndicatorHiding();
        }
    },
    customize: function(constructor) {
        var proto = constructor.prototype;
        if (proto._dataSourceChangedHandler) {
            var _dataSourceChangedHandler = proto._dataSourceChangedHandler;
            proto._dataSourceChangedHandler = function() {
                this._scheduleLoadingIndicatorHiding();
                _dataSourceChangedHandler.apply(this, arguments);
            };
        }
        constructor.addChange({
            code: "LOADING_INDICATOR",
            handler: function() {
                if (!this._skipLoadingIndicatorOptions) this._loadingIndicator.setOptions(this._getOption("loadingIndicator"));
                this._scheduleLoadingIndicatorHiding();
            },
            isThemeDependent: true,
            option: "loadingIndicator",
            isOptionChange: true
        });
        proto._eventsMap.onLoadingIndicatorReady = {
            name: "loadingIndicatorReady"
        };
        var _drawn = proto._drawn;
        proto._drawn = function() {
            _drawn.apply(this, arguments);
            if (this._dataIsReady()) this._fulfillLoadingIndicatorHiding();
        };
    },
    fontFields: [
        "loadingIndicator.font"
    ]
};

});

parcelRegister("2Vk35", function(module, exports) {

$parcel$export(module.exports, "Series", function () { return $221074ecec3b9f06$export$ed28a77b2a3badcf; });
/**
 * DevExtreme (esm/viz/series/base_series.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $avmkl = parcelRequire("avmkl");

var $dw9tZ = parcelRequire("dw9tZ");

var $gcp4g = parcelRequire("gcp4g");

var $8LJ26 = parcelRequire("8LJ26");

var $lPQM0 = parcelRequire("lPQM0");

var $3Ev8J = parcelRequire("3Ev8J");

var $bmaKW = parcelRequire("bmaKW");

var $9Qo4w = parcelRequire("9Qo4w");

var $aaioz = parcelRequire("aaioz");

var $iutGb = parcelRequire("iutGb");

var $jd19x = parcelRequire("jd19x");

var $1nMRh = parcelRequire("1nMRh");

var $ggW68 = parcelRequire("ggW68");

var $fIHko = parcelRequire("fIHko");
var $221074ecec3b9f06$var$seriesNS = {};
var $221074ecec3b9f06$var$states = (0, $8LJ26.default).states;
var $221074ecec3b9f06$var$DISCRETE = "discrete";
var $221074ecec3b9f06$var$SELECTED_STATE = $221074ecec3b9f06$var$states.selectedMark;
var $221074ecec3b9f06$var$HOVER_STATE = $221074ecec3b9f06$var$states.hoverMark;
var $221074ecec3b9f06$var$HOVER = $221074ecec3b9f06$var$states.hover;
var $221074ecec3b9f06$var$NORMAL = $221074ecec3b9f06$var$states.normal;
var $221074ecec3b9f06$var$SELECTION = $221074ecec3b9f06$var$states.selection;
var $221074ecec3b9f06$var$APPLY_SELECTED = $221074ecec3b9f06$var$states.applySelected;
var $221074ecec3b9f06$var$APPLY_HOVER = $221074ecec3b9f06$var$states.applyHover;
var $221074ecec3b9f06$var$RESET_ITEM = $221074ecec3b9f06$var$states.resetItem;
var $221074ecec3b9f06$var$NONE_MODE = "none";
var $221074ecec3b9f06$var$INCLUDE_POINTS = "includepoints";
var $221074ecec3b9f06$var$NEAREST_POINT = "nearestpoint";
var $221074ecec3b9f06$var$SERIES_SELECTION_CHANGED = "seriesSelectionChanged";
var $221074ecec3b9f06$var$POINT_SELECTION_CHANGED = "pointSelectionChanged";
var $221074ecec3b9f06$var$SERIES_HOVER_CHANGED = "seriesHoverChanged";
var $221074ecec3b9f06$var$POINT_HOVER_CHANGED = "pointHoverChanged";
var $221074ecec3b9f06$var$ALL_SERIES_POINTS = "allseriespoints";
var $221074ecec3b9f06$var$ALL_ARGUMENT_POINTS = "allargumentpoints";
var $221074ecec3b9f06$var$POINT_HOVER = "pointHover";
var $221074ecec3b9f06$var$CLEAR_POINT_HOVER = "clearPointHover";
var $221074ecec3b9f06$var$SERIES_SELECT = "seriesSelect";
var $221074ecec3b9f06$var$POINT_SELECT = "pointSelect";
var $221074ecec3b9f06$var$POINT_DESELECT = "pointDeselect";
var $221074ecec3b9f06$var$getEmptyBusinessRange = function() {
    return {
        arg: {},
        val: {}
    };
};
function $221074ecec3b9f06$var$triggerEvent(element, event, point) {
    element && element.trigger(event, point);
}
$221074ecec3b9f06$var$seriesNS.mixins = {
    chart: {},
    pie: {},
    polar: {}
};
$221074ecec3b9f06$var$seriesNS.mixins.chart.scatter = $3Ev8J.chart;
$221074ecec3b9f06$var$seriesNS.mixins.polar.scatter = $3Ev8J.polar;
(0, $2oTOp.extend)($221074ecec3b9f06$var$seriesNS.mixins.pie, $1nMRh);
(0, $2oTOp.extend)($221074ecec3b9f06$var$seriesNS.mixins.chart, $bmaKW.chart, $9Qo4w.chart, $aaioz.chart, (0, $iutGb.chart), (0, $jd19x.chart), $ggW68, $fIHko.chart);
(0, $2oTOp.extend)($221074ecec3b9f06$var$seriesNS.mixins.polar, $bmaKW.polar, $9Qo4w.polar, $aaioz.polar, $fIHko.polar);
function $221074ecec3b9f06$var$includePointsMode(mode) {
    mode = (0, $dw9tZ.normalizeEnum)(mode);
    return mode === $221074ecec3b9f06$var$INCLUDE_POINTS || mode === $221074ecec3b9f06$var$ALL_SERIES_POINTS;
}
function $221074ecec3b9f06$var$getLabelOptions(labelOptions, defaultColor) {
    var opt = labelOptions || {};
    var labelFont = (0, $2oTOp.extend)({}, opt.font) || {};
    var labelBorder = opt.border || {};
    var labelConnector = opt.connector || {};
    var backgroundAttr = {
        fill: opt.backgroundColor || defaultColor,
        "stroke-width": labelBorder.visible ? labelBorder.width || 0 : 0,
        stroke: labelBorder.visible && labelBorder.width ? labelBorder.color : "none",
        dashStyle: labelBorder.dashStyle
    };
    var connectorAttr = {
        stroke: labelConnector.visible && labelConnector.width ? labelConnector.color || defaultColor : "none",
        "stroke-width": labelConnector.visible ? labelConnector.width || 0 : 0
    };
    labelFont.color = "none" === opt.backgroundColor && "#ffffff" === (0, $dw9tZ.normalizeEnum)(labelFont.color) && "inside" !== opt.position ? defaultColor : labelFont.color;
    return {
        alignment: opt.alignment,
        format: opt.format,
        argumentFormat: opt.argumentFormat,
        customizeText: (0, $6ntMu.isFunction)(opt.customizeText) ? opt.customizeText : void 0,
        attributes: {
            font: labelFont
        },
        visible: 0 !== labelFont.size ? opt.visible : false,
        showForZeroValues: opt.showForZeroValues,
        horizontalOffset: opt.horizontalOffset,
        verticalOffset: opt.verticalOffset,
        radialOffset: opt.radialOffset,
        background: backgroundAttr,
        position: opt.position,
        connector: connectorAttr,
        rotationAngle: opt.rotationAngle,
        wordWrap: opt.wordWrap,
        textOverflow: opt.textOverflow,
        cssClass: opt.cssClass,
        displayFormat: opt.displayFormat
    };
}
function $221074ecec3b9f06$var$setPointHoverState(point, legendCallback) {
    point.fullState |= $221074ecec3b9f06$var$HOVER_STATE;
    point.applyView(legendCallback);
}
function $221074ecec3b9f06$var$releasePointHoverState(point, legendCallback) {
    point.fullState &= ~$221074ecec3b9f06$var$HOVER_STATE;
    point.applyView(legendCallback);
    point.releaseHoverState();
}
function $221074ecec3b9f06$var$setPointSelectedState(point, legendCallback) {
    point.fullState |= $221074ecec3b9f06$var$SELECTED_STATE;
    point.applyView(legendCallback);
}
function $221074ecec3b9f06$var$releasePointSelectedState(point, legendCallback) {
    point.fullState &= ~$221074ecec3b9f06$var$SELECTED_STATE;
    point.applyView(legendCallback);
}
function $221074ecec3b9f06$var$mergePointOptionsCore(base, extra) {
    var options = (0, $2oTOp.extend)({}, base, extra);
    options.border = (0, $2oTOp.extend)({}, base && base.border, extra && extra.border);
    return options;
}
function $221074ecec3b9f06$var$mergePointOptions(base, extra) {
    var options = $221074ecec3b9f06$var$mergePointOptionsCore(base, extra);
    options.image = (0, $2oTOp.extend)(true, {}, base.image, extra.image);
    options.selectionStyle = $221074ecec3b9f06$var$mergePointOptionsCore(base.selectionStyle, extra.selectionStyle);
    options.hoverStyle = $221074ecec3b9f06$var$mergePointOptionsCore(base.hoverStyle, extra.hoverStyle);
    return options;
}
function $221074ecec3b9f06$export$ed28a77b2a3badcf(settings, options) {
    this.fullState = 0;
    this._extGroups = settings;
    this._renderer = settings.renderer;
    this._group = settings.renderer.g().attr({
        class: "dxc-series"
    });
    this._eventTrigger = settings.eventTrigger;
    this._eventPipe = settings.eventPipe;
    this._incidentOccurred = settings.incidentOccurred;
    this._legendCallback = (0, $gcp4g.noop);
    this.updateOptions(options, settings);
}
function $221074ecec3b9f06$var$getData(pointData) {
    return pointData.data;
}
function $221074ecec3b9f06$var$getValueChecker(axisType, axis) {
    if (!axis || "logarithmic" !== axisType || false !== axis.getOptions().allowNegatives) return ()=>true;
    else return (value)=>value > 0;
}
$221074ecec3b9f06$export$ed28a77b2a3badcf.prototype = {
    constructor: $221074ecec3b9f06$export$ed28a77b2a3badcf,
    _createLegendState: (0, $gcp4g.noop),
    getLegendStyles: function() {
        return this._styles.legendStyles;
    },
    _createStyles: function(options) {
        var mainSeriesColor = options.mainSeriesColor;
        this._styles = {
            normal: this._parseStyle(options, mainSeriesColor, mainSeriesColor),
            hover: this._parseStyle(options.hoverStyle || {}, mainSeriesColor, mainSeriesColor),
            selection: this._parseStyle(options.selectionStyle || {}, mainSeriesColor, mainSeriesColor),
            legendStyles: {
                normal: this._createLegendState(options, mainSeriesColor),
                hover: this._createLegendState(options.hoverStyle || {}, mainSeriesColor),
                selection: this._createLegendState(options.selectionStyle || {}, mainSeriesColor)
            }
        };
    },
    setClippingParams (baseId, wideId, forceClipping) {
        var clipLabels = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : true;
        this._paneClipRectID = baseId;
        this._widePaneClipRectID = wideId;
        this._forceClipping = forceClipping;
        this._clipLabels = clipLabels;
    },
    applyClip: function() {
        this._group.attr({
            "clip-path": this._paneClipRectID
        });
    },
    resetClip: function() {
        this._group.attr({
            "clip-path": null
        });
    },
    getTagField: function() {
        return this._options.tagField || "tag";
    },
    getValueFields: (0, $gcp4g.noop),
    getSizeField: (0, $gcp4g.noop),
    getArgumentField: (0, $gcp4g.noop),
    getPoints: function() {
        return this._points;
    },
    getPointsInViewPort: function() {
        return (0, $lPQM0.default).getPointsInViewPort(this);
    },
    _createPoint: function(data, index, oldPoint) {
        data.index = index;
        var pointsByArgument = this.pointsByArgument;
        var options = this._getCreatingPointOptions(data);
        var arg = data.argument.valueOf();
        var point = oldPoint;
        if (point) point.update(data, options);
        else {
            point = new (0, $avmkl.Point)(this, data, options);
            if (this.isSelected() && $221074ecec3b9f06$var$includePointsMode(this.lastSelectionMode)) point.setView($221074ecec3b9f06$var$SELECTION);
        }
        var pointByArgument = pointsByArgument[arg];
        if (pointByArgument) pointByArgument.push(point);
        else pointsByArgument[arg] = [
            point
        ];
        if (point.hasValue()) this.customizePoint(point, data);
        return point;
    },
    getRangeData: function() {
        return this._visible ? this._getRangeData() : $221074ecec3b9f06$var$getEmptyBusinessRange();
    },
    getArgumentRange: function() {
        return this._visible ? (0, $lPQM0.default).getArgumentRange(this) : $221074ecec3b9f06$var$getEmptyBusinessRange();
    },
    getViewport: function() {
        return (0, $lPQM0.default).getViewport(this);
    },
    _deleteGroup: function(groupName) {
        var group = this[groupName];
        if (group) {
            group.dispose();
            this[groupName] = null;
        }
    },
    updateOptions (newOptions, settings) {
        var widgetType = newOptions.widgetType;
        var oldType = this.type;
        var newType = newOptions.type;
        this.type = newType && (0, $dw9tZ.normalizeEnum)(newType.toString());
        if (!this._checkType(widgetType) || this._checkPolarBarType(widgetType, newOptions)) {
            this.dispose();
            this.isUpdated = false;
            return;
        }
        if (oldType !== this.type) {
            this._firstDrawing = true;
            this._resetType(oldType, widgetType);
            this._setType(this.type, widgetType);
        } else this._defineDrawingState();
        this._options = newOptions;
        this._pointOptions = null;
        this.name = newOptions.name;
        this.pane = newOptions.pane;
        this.tag = newOptions.tag;
        if (settings) {
            this._seriesModes = settings.commonSeriesModes || this._seriesModes;
            this._valueAxis = settings.valueAxis || this._valueAxis;
            this.axis = this._valueAxis && this._valueAxis.name;
            this._argumentAxis = settings.argumentAxis || this._argumentAxis;
        }
        this._createStyles(newOptions);
        this._stackName = null;
        this._updateOptions(newOptions);
        this._visible = newOptions.visible;
        this.isUpdated = true;
        this.stack = newOptions.stack;
        this.barOverlapGroup = newOptions.barOverlapGroup;
        this._createGroups();
        this._processEmptyValue = newOptions.ignoreEmptyPoints ? (x)=>null === x ? void 0 : x : (x)=>x;
    },
    _defineDrawingState () {
        this._firstDrawing = true;
    },
    _disposePoints: function(points) {
        (0, $8OLOW.each)(points || [], function(_, p) {
            p.dispose();
        });
    },
    updateDataType: function(settings) {
        this.argumentType = settings.argumentType;
        this.valueType = settings.valueType;
        this.argumentAxisType = settings.argumentAxisType;
        this.valueAxisType = settings.valueAxisType;
        this.showZero = settings.showZero;
        this._argumentChecker = $221074ecec3b9f06$var$getValueChecker(settings.argumentAxisType, this.getArgumentAxis());
        this._valueChecker = $221074ecec3b9f06$var$getValueChecker(settings.valueAxisType, this.getValueAxis());
        return this;
    },
    _argumentChecker: function() {
        return true;
    },
    _valueChecker: function() {
        return true;
    },
    getOptions: function() {
        return this._options;
    },
    _getOldPoint: function(data, oldPointsByArgument, index) {
        var arg = data.argument && data.argument.valueOf();
        var point = (oldPointsByArgument[arg] || [])[0];
        if (point) oldPointsByArgument[arg].splice(0, 1);
        return point;
    },
    updateData: function(data) {
        var options = this._options;
        var nameField = options.nameField;
        data = data || [];
        if (data.length) this._canRenderCompleteHandle = true;
        var dataSelector = this._getPointDataSelector();
        var itemsWithoutArgument = 0;
        this._data = data.reduce((data, dataItem, index)=>{
            var pointDataItem = dataSelector(dataItem);
            if ((0, $6ntMu.isDefined)(pointDataItem.argument)) {
                if (!nameField || dataItem[nameField] === options.nameFieldValue) {
                    pointDataItem.index = index;
                    data.push(pointDataItem);
                }
            } else itemsWithoutArgument++;
            return data;
        }, []);
        if (itemsWithoutArgument && itemsWithoutArgument === data.length) this._incidentOccurred("W2002", [
            this.name,
            this.getArgumentField()
        ]);
        this._endUpdateData();
    },
    _getData () {
        var data = this._data || [];
        if (this.useAggregation()) data = this._resample(this.getArgumentAxis().getAggregationInfo(this._useAllAggregatedPoints, this.argumentAxisType !== $221074ecec3b9f06$var$DISCRETE ? this.getArgumentRange() : {}), data);
        return data;
    },
    useAggregation: function() {
        var aggregation = this.getOptions().aggregation;
        return aggregation && aggregation.enabled;
    },
    autoHidePointMarkersEnabled: (0, $gcp4g.noop),
    usePointsToDefineAutoHiding: (0, $gcp4g.noop),
    createPoints (useAllAggregatedPoints) {
        this._normalizeUsingAllAggregatedPoints(useAllAggregatedPoints);
        this._createPoints();
    },
    _normalizeUsingAllAggregatedPoints: function(useAllAggregatedPoints) {
        this._useAllAggregatedPoints = this.useAggregation() && (this.argumentAxisType === $221074ecec3b9f06$var$DISCRETE || (this._data || []).length > 1 && !!useAllAggregatedPoints);
    },
    _createPoints: function() {
        var that = this;
        var oldPointsByArgument = that.pointsByArgument || {};
        var data = that._getData();
        that.pointsByArgument = {};
        that._calculateErrorBars(data);
        var skippedFields = {};
        var points = data.reduce((points, pointDataItem)=>{
            if (that._checkData(pointDataItem, skippedFields)) {
                var pointIndex = points.length;
                var oldPoint = that._getOldPoint(pointDataItem, oldPointsByArgument, pointIndex);
                var point = that._createPoint(pointDataItem, pointIndex, oldPoint);
                points.push(point);
            }
            return points;
        }, []);
        for(var field in skippedFields)if (skippedFields[field] === data.length) that._incidentOccurred("W2002", [
            that.name,
            field
        ]);
        Object.keys(oldPointsByArgument).forEach((key)=>that._disposePoints(oldPointsByArgument[key]));
        that._points = points;
    },
    _removeOldSegments: function() {
        var that = this;
        var startIndex = that._segments.length;
        (0, $8OLOW.each)(that._graphics.splice(startIndex, that._graphics.length) || [], function(_, elem) {
            that._removeElement(elem);
        });
        if (that._trackers) (0, $8OLOW.each)(that._trackers.splice(startIndex, that._trackers.length) || [], function(_, elem) {
            elem.remove();
        });
    },
    _drawElements: function(animationEnabled, firstDrawing, translateAllPoints) {
        var that = this;
        var points = that._points || [];
        var closeSegment = points[0] && points[0].hasValue() && that._options.closed;
        var groupForPoint = {
            markers: that._markersGroup,
            errorBars: that._errorBarGroup
        };
        that._drawnPoints = [];
        that._graphics = that._graphics || [];
        that._segments = [];
        var segments = points.reduce(function(segments, p) {
            var segment = segments[segments.length - 1];
            if (!p.translated || translateAllPoints) {
                p.translate();
                !translateAllPoints && p.setDefaultCoords();
            }
            if (p.hasValue() && p.hasCoords()) {
                translateAllPoints && that._drawPoint({
                    point: p,
                    groups: groupForPoint,
                    hasAnimation: animationEnabled,
                    firstDrawing: firstDrawing
                });
                segment.push(p);
            } else if (!p.hasValue()) segment.length && segments.push([]);
            else p.setInvisibility();
            return segments;
        }, [
            []
        ]);
        segments.forEach(function(segment, index) {
            if (segment.length) that._drawSegment(segment, animationEnabled, index, closeSegment && index === this.length - 1);
        }, segments);
        that._firstDrawing = !points.length;
        that._removeOldSegments();
        animationEnabled && that._animate(firstDrawing);
    },
    draw: function(animationEnabled, hideLayoutLabels, legendCallback) {
        var firstDrawing = this._firstDrawing;
        this._legendCallback = legendCallback || this._legendCallback;
        if (!this._visible) {
            this._group.remove();
            return;
        }
        this._appendInGroup();
        this._applyVisibleArea();
        this._setGroupsSettings(animationEnabled, firstDrawing);
        !firstDrawing && !this._resetApplyingAnimation && this._drawElements(false, firstDrawing, false);
        this._drawElements(animationEnabled, firstDrawing, true);
        hideLayoutLabels && this.hideLabels();
        if (this.isSelected()) this._changeStyle(this.lastSelectionMode, void 0, true);
        else if (this.isHovered()) this._changeStyle(this.lastHoverMode, void 0, true);
        else this._applyStyle(this._styles.normal);
        this._resetApplyingAnimation = false;
    },
    _setLabelGroupSettings: function(animationEnabled) {
        var settings = {
            class: "dxc-labels",
            "pointer-events": "none"
        };
        this._clipLabels && this._applyElementsClipRect(settings);
        this._applyClearingSettings(settings);
        animationEnabled && (settings.opacity = .001);
        this._labelsGroup.attr(settings).append(this._extGroups.labelsGroup);
    },
    _checkType: function(widgetType) {
        return !!$221074ecec3b9f06$var$seriesNS.mixins[widgetType][this.type];
    },
    _checkPolarBarType: function(widgetType, options) {
        return "polar" === widgetType && options.spiderWidget && -1 !== this.type.indexOf("bar");
    },
    _resetType: function(seriesType, widgetType) {
        var methodName;
        var methods;
        if (seriesType) {
            methods = $221074ecec3b9f06$var$seriesNS.mixins[widgetType][seriesType];
            for(methodName in methods)delete this[methodName];
        }
    },
    _setType: function(seriesType, widgetType) {
        var methodName;
        var methods = $221074ecec3b9f06$var$seriesNS.mixins[widgetType][seriesType];
        for(methodName in methods)this[methodName] = methods[methodName];
    },
    _setPointsView: function(view, target) {
        this.getPoints().forEach(function(point) {
            if (target !== point) point.setView(view);
        });
    },
    _resetPointsView: function(view, target) {
        this.getPoints().forEach(function(point) {
            if (target !== point) point.resetView(view);
        });
    },
    _resetNearestPoint: function() {
        this._nearestPoint && null !== this._nearestPoint.series && this._nearestPoint.resetView($221074ecec3b9f06$var$HOVER);
        this._nearestPoint = null;
    },
    _setSelectedState: function(mode) {
        this.lastSelectionMode = (0, $dw9tZ.normalizeEnum)(mode || this._options.selectionMode);
        this.fullState = this.fullState | $221074ecec3b9f06$var$SELECTED_STATE;
        this._resetNearestPoint();
        this._changeStyle(this.lastSelectionMode);
        if (this.lastSelectionMode !== $221074ecec3b9f06$var$NONE_MODE && this.isHovered() && $221074ecec3b9f06$var$includePointsMode(this.lastHoverMode)) this._resetPointsView($221074ecec3b9f06$var$HOVER);
    },
    _releaseSelectedState: function() {
        this.fullState = this.fullState & ~$221074ecec3b9f06$var$SELECTED_STATE;
        this._changeStyle(this.lastSelectionMode, $221074ecec3b9f06$var$SELECTION);
        if (this.lastSelectionMode !== $221074ecec3b9f06$var$NONE_MODE && this.isHovered() && $221074ecec3b9f06$var$includePointsMode(this.lastHoverMode)) this._setPointsView($221074ecec3b9f06$var$HOVER);
    },
    isFullStackedSeries: function() {
        return 0 === this.type.indexOf("fullstacked");
    },
    isStackedSeries: function() {
        return 0 === this.type.indexOf("stacked");
    },
    resetApplyingAnimation: function(isFirstDrawing) {
        this._resetApplyingAnimation = true;
        if (isFirstDrawing) this._firstDrawing = true;
    },
    isFinancialSeries: function() {
        return "stock" === this.type || "candlestick" === this.type;
    },
    _canChangeView: function() {
        return !this.isSelected() && (0, $dw9tZ.normalizeEnum)(this._options.hoverMode) !== $221074ecec3b9f06$var$NONE_MODE;
    },
    _changeStyle: function(mode, resetView, skipPoints) {
        var state = this.fullState;
        var styles = [
            $221074ecec3b9f06$var$NORMAL,
            $221074ecec3b9f06$var$HOVER,
            $221074ecec3b9f06$var$SELECTION,
            $221074ecec3b9f06$var$SELECTION
        ];
        if ("none" === this.lastHoverMode) state &= ~$221074ecec3b9f06$var$HOVER_STATE;
        if ("none" === this.lastSelectionMode) state &= ~$221074ecec3b9f06$var$SELECTED_STATE;
        if ($221074ecec3b9f06$var$includePointsMode(mode) && !skipPoints) {
            if (!resetView) this._setPointsView(styles[state]);
            else this._resetPointsView(resetView);
        }
        this._legendCallback([
            $221074ecec3b9f06$var$RESET_ITEM,
            $221074ecec3b9f06$var$APPLY_HOVER,
            $221074ecec3b9f06$var$APPLY_SELECTED,
            $221074ecec3b9f06$var$APPLY_SELECTED
        ][state]);
        this._applyStyle(this._styles[styles[state]]);
    },
    updateHover: function(x, y) {
        var currentNearestPoint = this._nearestPoint;
        var point = this.isHovered() && this.lastHoverMode === $221074ecec3b9f06$var$NEAREST_POINT && this.getNeighborPoint(x, y);
        if (point !== currentNearestPoint && !(this.isSelected() && this.lastSelectionMode !== $221074ecec3b9f06$var$NONE_MODE)) {
            this._resetNearestPoint();
            if (point) {
                point.setView($221074ecec3b9f06$var$HOVER);
                this._nearestPoint = point;
            }
        }
    },
    _getMainAxisName: function() {
        return this._options.rotated ? "X" : "Y";
    },
    areLabelsVisible: function() {
        return !(0, $6ntMu.isDefined)(this._options.maxLabelCount) || this._points.length <= this._options.maxLabelCount;
    },
    getLabelVisibility: function() {
        return this.areLabelsVisible() && this._options.label && this._options.label.visible;
    },
    customizePoint: function(point, pointData) {
        var options = this._options;
        var customizePoint = options.customizePoint;
        var customizeObject;
        var pointOptions;
        var customLabelOptions;
        var customOptions;
        var customizeLabel = options.customizeLabel;
        var useLabelCustomOptions;
        var usePointCustomOptions;
        if (customizeLabel && customizeLabel.call) {
            customizeObject = (0, $2oTOp.extend)({
                seriesName: this.name
            }, pointData);
            customizeObject.series = this;
            customLabelOptions = customizeLabel.call(customizeObject, customizeObject);
            useLabelCustomOptions = customLabelOptions && !(0, $6ntMu.isEmptyObject)(customLabelOptions);
            customLabelOptions = useLabelCustomOptions ? (0, $2oTOp.extend)(true, {}, options.label, customLabelOptions) : null;
        }
        if (customizePoint && customizePoint.call) {
            customizeObject = customizeObject || (0, $2oTOp.extend)({
                seriesName: this.name
            }, pointData);
            customizeObject.series = this;
            customOptions = customizePoint.call(customizeObject, customizeObject);
            usePointCustomOptions = customOptions && !(0, $6ntMu.isEmptyObject)(customOptions);
        }
        if (useLabelCustomOptions || usePointCustomOptions) {
            pointOptions = this._parsePointOptions(this._preparePointOptions(customOptions), customLabelOptions || options.label, pointData, point);
            pointOptions.styles.useLabelCustomOptions = useLabelCustomOptions;
            pointOptions.styles.usePointCustomOptions = usePointCustomOptions;
            point.updateOptions(pointOptions);
        }
    },
    show: function() {
        if (!this._visible) this._changeVisibility(true);
    },
    hide: function() {
        if (this._visible) this._changeVisibility(false);
    },
    _changeVisibility: function(visibility) {
        this._visible = this._options.visible = visibility;
        this._updatePointsVisibility();
        this.hidePointTooltip();
        this._options.visibilityChanged(this);
    },
    _updatePointsVisibility: (0, $gcp4g.noop),
    hideLabels: function() {
        (0, $8OLOW.each)(this._points, function(_, point) {
            point._label.draw(false);
        });
    },
    _parsePointOptions: function(pointOptions, labelOptions, data, point) {
        var options = this._options;
        var styles = this._createPointStyles(pointOptions, data, point);
        var parsedOptions = (0, $2oTOp.extend)({}, pointOptions, {
            type: options.type,
            rotated: options.rotated,
            styles: styles,
            widgetType: options.widgetType,
            visibilityChanged: options.visibilityChanged
        });
        parsedOptions.label = $221074ecec3b9f06$var$getLabelOptions(labelOptions, styles.normal.fill);
        if (this.areErrorBarsVisible()) parsedOptions.errorBars = options.valueErrorBar;
        return parsedOptions;
    },
    _preparePointOptions: function(customOptions) {
        var pointOptions = this._getOptionsForPoint();
        return customOptions ? $221074ecec3b9f06$var$mergePointOptions(pointOptions, customOptions) : pointOptions;
    },
    _getMarkerGroupOptions: function() {
        return (0, $2oTOp.extend)(false, {}, this._getOptionsForPoint(), {
            hoverStyle: {},
            selectionStyle: {}
        });
    },
    _getAggregationMethod: function(isDiscrete, aggregateByCategory) {
        var options = this.getOptions().aggregation;
        var method = (0, $dw9tZ.normalizeEnum)(options.method);
        var customAggregator = "custom" === method && options.calculate;
        var aggregator;
        if (isDiscrete && !aggregateByCategory) aggregator = (_ref)=>{
            var { data: data } = _ref;
            return data[0];
        };
        else aggregator = this._aggregators[method] || this._aggregators[this._defaultAggregator];
        return customAggregator || aggregator;
    },
    _resample (_ref2, data) {
        var { interval: interval, ticks: ticks, aggregateByCategory: aggregateByCategory } = _ref2;
        var that = this;
        var isDiscrete = that.argumentAxisType === $221074ecec3b9f06$var$DISCRETE || that.valueAxisType === $221074ecec3b9f06$var$DISCRETE;
        var dataIndex = 0;
        var dataSelector = this._getPointDataSelector();
        var options = that.getOptions();
        var addAggregatedData = (target, data, aggregationInfo)=>{
            if (!data) return;
            var processData = (d)=>{
                var pointData = d && dataSelector(d, options);
                if (pointData && that._checkData(pointData)) {
                    pointData.aggregationInfo = aggregationInfo;
                    target.push(pointData);
                }
            };
            if (Array.isArray(data)) data.forEach(processData);
            else processData(data);
        };
        var aggregationMethod = this._getAggregationMethod(isDiscrete, aggregateByCategory);
        if (isDiscrete) {
            if (aggregateByCategory) {
                var categories = this.getArgumentAxis().getTranslator().getBusinessRange().categories;
                var groups = categories.reduce((g, category)=>{
                    g[category.valueOf()] = [];
                    return g;
                }, {});
                data.forEach((dataItem)=>{
                    groups[dataItem.argument.valueOf()].push(dataItem);
                });
                return categories.reduce((result, c)=>{
                    addAggregatedData(result, aggregationMethod({
                        aggregationInterval: null,
                        intervalStart: c,
                        intervalEnd: c,
                        data: groups[c.valueOf()].map($221074ecec3b9f06$var$getData)
                    }, that));
                    return result;
                }, []);
            } else return data.reduce((result, dataItem, index, data)=>{
                result[1].push(dataItem);
                if (index === data.length - 1 || (index + 1) % interval === 0) {
                    var dataInInterval = result[1];
                    var aggregationInfo = {
                        aggregationInterval: interval,
                        data: dataInInterval.map($221074ecec3b9f06$var$getData)
                    };
                    addAggregatedData(result[0], aggregationMethod(aggregationInfo, that));
                    result[1] = [];
                }
                return result;
            }, [
                [],
                []
            ])[0];
        }
        var aggregatedData = [];
        if (1 === ticks.length) {
            var aggregationInfo = {
                intervalStart: ticks[0],
                intervalEnd: ticks[0],
                aggregationInterval: null,
                data: data.map($221074ecec3b9f06$var$getData)
            };
            addAggregatedData(aggregatedData, aggregationMethod(aggregationInfo, that), aggregationInfo);
        } else for(var i = 1; i < ticks.length; i++){
            var intervalEnd = ticks[i];
            var intervalStart = ticks[i - 1];
            var dataInInterval = [];
            while(data[dataIndex] && data[dataIndex].argument < intervalEnd){
                if (data[dataIndex].argument >= intervalStart) dataInInterval.push(data[dataIndex]);
                dataIndex++;
            }
            var _aggregationInfo = {
                intervalStart: intervalStart,
                intervalEnd: intervalEnd,
                aggregationInterval: interval,
                data: dataInInterval.map($221074ecec3b9f06$var$getData)
            };
            addAggregatedData(aggregatedData, aggregationMethod(_aggregationInfo, that), _aggregationInfo);
        }
        that._endUpdateData();
        return aggregatedData;
    },
    canRenderCompleteHandle: function() {
        var result = this._canRenderCompleteHandle;
        delete this._canRenderCompleteHandle;
        return !!result;
    },
    isHovered: function() {
        return !!(1 & this.fullState);
    },
    isSelected: function() {
        return !!(2 & this.fullState);
    },
    isVisible: function() {
        return this._visible;
    },
    getAllPoints: function() {
        this._createAllAggregatedPoints();
        return (this._points || []).slice();
    },
    getPointByPos: function(pos) {
        this._createAllAggregatedPoints();
        return (this._points || [])[pos];
    },
    getVisiblePoints: function() {
        return (this._drawnPoints || []).slice();
    },
    selectPoint: function(point) {
        if (!point.isSelected()) {
            $221074ecec3b9f06$var$setPointSelectedState(point, this._legendCallback);
            this._eventPipe({
                action: $221074ecec3b9f06$var$POINT_SELECT,
                target: point
            });
            this._eventTrigger($221074ecec3b9f06$var$POINT_SELECTION_CHANGED, {
                target: point
            });
        }
    },
    deselectPoint: function(point) {
        if (point.isSelected()) {
            $221074ecec3b9f06$var$releasePointSelectedState(point, this._legendCallback);
            this._eventPipe({
                action: $221074ecec3b9f06$var$POINT_DESELECT,
                target: point
            });
            this._eventTrigger($221074ecec3b9f06$var$POINT_SELECTION_CHANGED, {
                target: point
            });
        }
    },
    hover: function(mode) {
        var eventTrigger = this._eventTrigger;
        if (this.isHovered()) return;
        this.lastHoverMode = (0, $dw9tZ.normalizeEnum)(mode || this._options.hoverMode);
        this.fullState = this.fullState | $221074ecec3b9f06$var$HOVER_STATE;
        this._changeStyle(this.lastHoverMode, void 0, this.isSelected() && this.lastSelectionMode !== $221074ecec3b9f06$var$NONE_MODE);
        eventTrigger($221074ecec3b9f06$var$SERIES_HOVER_CHANGED, {
            target: this
        });
    },
    clearHover: function() {
        var eventTrigger = this._eventTrigger;
        if (!this.isHovered()) return;
        this._resetNearestPoint();
        this.fullState = this.fullState & ~$221074ecec3b9f06$var$HOVER_STATE;
        this._changeStyle(this.lastHoverMode, $221074ecec3b9f06$var$HOVER, this.isSelected() && this.lastSelectionMode !== $221074ecec3b9f06$var$NONE_MODE);
        eventTrigger($221074ecec3b9f06$var$SERIES_HOVER_CHANGED, {
            target: this
        });
    },
    hoverPoint: function(point) {
        if (!point.isHovered()) {
            point.clearHover();
            $221074ecec3b9f06$var$setPointHoverState(point, this._legendCallback);
            this._canChangeView() && this._applyStyle(this._styles.hover);
            this._eventPipe({
                action: $221074ecec3b9f06$var$POINT_HOVER,
                target: point
            });
            this._eventTrigger($221074ecec3b9f06$var$POINT_HOVER_CHANGED, {
                target: point
            });
        }
    },
    clearPointHover: function() {
        var that = this;
        that.getPoints().some(function(currentPoint) {
            if (currentPoint.isHovered()) {
                $221074ecec3b9f06$var$releasePointHoverState(currentPoint, that._legendCallback);
                that._canChangeView() && that._applyStyle(that._styles.normal);
                that._eventPipe({
                    action: $221074ecec3b9f06$var$CLEAR_POINT_HOVER,
                    target: currentPoint
                });
                that._eventTrigger($221074ecec3b9f06$var$POINT_HOVER_CHANGED, {
                    target: currentPoint
                });
                return true;
            }
            return false;
        });
    },
    showPointTooltip: function(point) {
        $221074ecec3b9f06$var$triggerEvent(this._extGroups.seriesGroup, "showpointtooltip", point);
    },
    hidePointTooltip: function(point) {
        $221074ecec3b9f06$var$triggerEvent(this._extGroups.seriesGroup, "hidepointtooltip", point);
    },
    select: function() {
        if (!this.isSelected()) {
            this._setSelectedState(this._options.selectionMode);
            this._eventPipe({
                action: $221074ecec3b9f06$var$SERIES_SELECT,
                target: this
            });
            this._group.toForeground();
            this._eventTrigger($221074ecec3b9f06$var$SERIES_SELECTION_CHANGED, {
                target: this
            });
        }
    },
    clearSelection: function() {
        if (this.isSelected()) {
            this._releaseSelectedState();
            this._eventTrigger($221074ecec3b9f06$var$SERIES_SELECTION_CHANGED, {
                target: this
            });
        }
    },
    getPointsByArg: function(arg, skipPointsCreation) {
        var argValue = arg.valueOf();
        var points = this.pointsByArgument[argValue];
        if (!points && !skipPointsCreation && this._createAllAggregatedPoints()) points = this.pointsByArgument[argValue];
        return points || [];
    },
    _createAllAggregatedPoints: function() {
        if (this.useAggregation() && !this._useAllAggregatedPoints) {
            this.createPoints(true);
            return true;
        }
        return false;
    },
    getPointsByKeys: function(arg) {
        return this.getPointsByArg(arg);
    },
    notify: function(data) {
        var that = this;
        var action = data.action;
        var seriesModes = that._seriesModes;
        var target = data.target;
        var targetOptions = target.getOptions();
        var pointHoverMode = (0, $dw9tZ.normalizeEnum)(targetOptions.hoverMode);
        var selectionModeOfPoint = (0, $dw9tZ.normalizeEnum)(targetOptions.selectionMode);
        if (action === $221074ecec3b9f06$var$POINT_HOVER) that._hoverPointHandler(target, pointHoverMode, data.notifyLegend);
        else if (action === $221074ecec3b9f06$var$CLEAR_POINT_HOVER) that._clearPointHoverHandler(target, pointHoverMode, data.notifyLegend);
        else if (action === $221074ecec3b9f06$var$SERIES_SELECT) target !== that && "single" === seriesModes.seriesSelectionMode && that.clearSelection();
        else if (action === $221074ecec3b9f06$var$POINT_SELECT) {
            if ("single" === seriesModes.pointSelectionMode) that.getPoints().some(function(currentPoint) {
                if (currentPoint !== target && currentPoint.isSelected()) {
                    that.deselectPoint(currentPoint);
                    return true;
                }
                return false;
            });
            that._selectPointHandler(target, selectionModeOfPoint);
        } else if (action === $221074ecec3b9f06$var$POINT_DESELECT) that._deselectPointHandler(target, selectionModeOfPoint);
    },
    _selectPointHandler: function(target, mode) {
        if (mode === $221074ecec3b9f06$var$ALL_SERIES_POINTS) target.series === this && this._setPointsView($221074ecec3b9f06$var$SELECTION, target);
        else if (mode === $221074ecec3b9f06$var$ALL_ARGUMENT_POINTS) this.getPointsByKeys(target.argument, target.argumentIndex).forEach(function(currentPoint) {
            currentPoint !== target && currentPoint.setView($221074ecec3b9f06$var$SELECTION);
        });
    },
    _deselectPointHandler: function(target, mode) {
        if (mode === $221074ecec3b9f06$var$ALL_SERIES_POINTS) target.series === this && this._resetPointsView($221074ecec3b9f06$var$SELECTION, target);
        else if (mode === $221074ecec3b9f06$var$ALL_ARGUMENT_POINTS) this.getPointsByKeys(target.argument, target.argumentIndex).forEach(function(currentPoint) {
            currentPoint !== target && currentPoint.resetView($221074ecec3b9f06$var$SELECTION);
        });
    },
    _hoverPointHandler: function(target, mode, notifyLegend) {
        if (target.series !== this && mode === $221074ecec3b9f06$var$ALL_ARGUMENT_POINTS) {
            this.getPointsByKeys(target.argument, target.argumentIndex).forEach(function(currentPoint) {
                currentPoint.setView($221074ecec3b9f06$var$HOVER);
            });
            notifyLegend && this._legendCallback(target);
        } else if (mode === $221074ecec3b9f06$var$ALL_SERIES_POINTS && target.series === this) this._setPointsView($221074ecec3b9f06$var$HOVER, target);
    },
    _clearPointHoverHandler: function(target, mode, notifyLegend) {
        if (mode === $221074ecec3b9f06$var$ALL_ARGUMENT_POINTS) {
            target.series !== this && this.getPointsByKeys(target.argument, target.argumentIndex).forEach(function(currentPoint) {
                currentPoint.resetView($221074ecec3b9f06$var$HOVER);
            });
            notifyLegend && this._legendCallback(target);
        } else if (mode === $221074ecec3b9f06$var$ALL_SERIES_POINTS && target.series === this) this._resetPointsView($221074ecec3b9f06$var$HOVER, target);
    },
    _deletePoints: function() {
        this._disposePoints(this._points);
        this._points = this._drawnPoints = null;
    },
    _deleteTrackers: function() {
        (0, $8OLOW.each)(this._trackers || [], function(_, tracker) {
            tracker.remove();
        });
        this._trackersGroup && this._trackersGroup.dispose();
        this._trackers = this._trackersGroup = null;
    },
    dispose: function() {
        this._deletePoints();
        this._group.dispose();
        this._labelsGroup && this._labelsGroup.dispose();
        this._errorBarGroup && this._errorBarGroup.dispose();
        this._deleteTrackers();
        this._group = this._extGroups = this._markersGroup = this._elementsGroup = this._bordersGroup = this._labelsGroup = this._errorBarGroup = this._graphics = this._rangeData = this._renderer = this._styles = this._options = this._pointOptions = this._drawnPoints = this.pointsByArgument = this._segments = this._prevSeries = null;
    },
    correctPosition: (0, $gcp4g.noop),
    drawTrackers: (0, $gcp4g.noop),
    getNeighborPoint: (0, $gcp4g.noop),
    areErrorBarsVisible: (0, $gcp4g.noop),
    getMarginOptions: function() {
        return this._patchMarginOptions({
            percentStick: this.isFullStackedSeries()
        });
    },
    getColor: function() {
        return this.getLegendStyles().normal.fill;
    },
    getOpacity: function() {
        return this._options.opacity;
    },
    getStackName: function() {
        return this._stackName;
    },
    getBarOverlapGroup: function() {
        return this._options.barOverlapGroup;
    },
    getPointByCoord: function(x, y) {
        var point = this.getNeighborPoint(x, y);
        return null !== point && void 0 !== point && point.coordsIn(x, y) ? point : null;
    },
    getValueAxis: function() {
        return this._valueAxis;
    },
    getArgumentAxis: function() {
        return this._argumentAxis;
    },
    getMarkersGroup () {
        return this._markersGroup;
    },
    getRenderer () {
        return this._renderer;
    },
    removePointElements () {
        if (this._markersGroup) {
            (0, $8OLOW.each)(this._points, (_, p)=>p.deleteMarker());
            this._markersGroup.dispose();
            this._markersGroup = null;
        }
    },
    removeGraphicElements () {
        var that = this;
        if (that._elementsGroup) {
            that._elementsGroup.dispose();
            that._elementsGroup = null;
        }
        (0, $8OLOW.each)(that._graphics || [], (_, elem)=>{
            that._removeElement(elem);
        });
        that._graphics = null;
    },
    removeBordersGroup () {
        if (this._bordersGroup) {
            this._bordersGroup.dispose();
            this._bordersGroup = null;
        }
    }
};
var $221074ecec3b9f06$export$7d6c3ba1e86fd7aa = $221074ecec3b9f06$var$seriesNS.mixins;

});
parcelRegister("avmkl", function(module, exports) {

$parcel$export(module.exports, "Point", function () { return $7a5e1e5c931c47c9$export$baf26146a414f24a; });
/**
 * DevExtreme (esm/viz/series/points/base_point.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $8LJ26 = parcelRequire("8LJ26");

var $1WEGH = parcelRequire("1WEGH");

var $euKb3 = parcelRequire("euKb3");

var $9RPP9 = parcelRequire("9RPP9");

var $8kJfa = parcelRequire("8kJfa");

var $gTntZ = parcelRequire("gTntZ");

var $jIcUg = parcelRequire("jIcUg");

var $1RF3f = parcelRequire("1RF3f");

var $6fkLT = parcelRequire("6fkLT");

var $9DReF = parcelRequire("9DReF");

var $dw9tZ = parcelRequire("dw9tZ");

var $2oTOp = parcelRequire("2oTOp");

var $6ntMu = parcelRequire("6ntMu");

var $gcp4g = parcelRequire("gcp4g");
var $7a5e1e5c931c47c9$var$mixins = {};
var $7a5e1e5c931c47c9$var$_extend = (0, $2oTOp.extend);
var $7a5e1e5c931c47c9$var$statesConsts = (0, $8LJ26.default).states;
var $7a5e1e5c931c47c9$var$SYMBOL_POINT = "symbolPoint";
var $7a5e1e5c931c47c9$var$POLAR_SYMBOL_POINT = "polarSymbolPoint";
var $7a5e1e5c931c47c9$var$BAR_POINT = "barPoint";
var $7a5e1e5c931c47c9$var$POLAR_BAR_POINT = "polarBarPoint";
var $7a5e1e5c931c47c9$var$PIE_POINT = "piePoint";
var $7a5e1e5c931c47c9$var$SELECTED_STATE = $7a5e1e5c931c47c9$var$statesConsts.selectedMark;
var $7a5e1e5c931c47c9$var$HOVER_STATE = $7a5e1e5c931c47c9$var$statesConsts.hoverMark;
var $7a5e1e5c931c47c9$var$NORMAL_STATE = $7a5e1e5c931c47c9$var$statesConsts.normalMark;
var $7a5e1e5c931c47c9$var$HOVER = $7a5e1e5c931c47c9$var$statesConsts.hover;
var $7a5e1e5c931c47c9$var$NORMAL = $7a5e1e5c931c47c9$var$statesConsts.normal;
var $7a5e1e5c931c47c9$var$SELECTION = $7a5e1e5c931c47c9$var$statesConsts.selection;
var $7a5e1e5c931c47c9$var$pointTypes = {
    chart: {
        scatter: $7a5e1e5c931c47c9$var$SYMBOL_POINT,
        line: $7a5e1e5c931c47c9$var$SYMBOL_POINT,
        spline: $7a5e1e5c931c47c9$var$SYMBOL_POINT,
        stepline: $7a5e1e5c931c47c9$var$SYMBOL_POINT,
        stackedline: $7a5e1e5c931c47c9$var$SYMBOL_POINT,
        fullstackedline: $7a5e1e5c931c47c9$var$SYMBOL_POINT,
        stackedspline: $7a5e1e5c931c47c9$var$SYMBOL_POINT,
        fullstackedspline: $7a5e1e5c931c47c9$var$SYMBOL_POINT,
        stackedsplinearea: $7a5e1e5c931c47c9$var$SYMBOL_POINT,
        fullstackedsplinearea: $7a5e1e5c931c47c9$var$SYMBOL_POINT,
        area: $7a5e1e5c931c47c9$var$SYMBOL_POINT,
        splinearea: $7a5e1e5c931c47c9$var$SYMBOL_POINT,
        steparea: $7a5e1e5c931c47c9$var$SYMBOL_POINT,
        stackedarea: $7a5e1e5c931c47c9$var$SYMBOL_POINT,
        fullstackedarea: $7a5e1e5c931c47c9$var$SYMBOL_POINT,
        rangearea: "rangeSymbolPoint",
        bar: $7a5e1e5c931c47c9$var$BAR_POINT,
        stackedbar: $7a5e1e5c931c47c9$var$BAR_POINT,
        fullstackedbar: $7a5e1e5c931c47c9$var$BAR_POINT,
        rangebar: "rangeBarPoint",
        bubble: "bubblePoint",
        stock: "stockPoint",
        candlestick: "candlestickPoint"
    },
    pie: {
        pie: $7a5e1e5c931c47c9$var$PIE_POINT,
        doughnut: $7a5e1e5c931c47c9$var$PIE_POINT,
        donut: $7a5e1e5c931c47c9$var$PIE_POINT
    },
    polar: {
        scatter: $7a5e1e5c931c47c9$var$POLAR_SYMBOL_POINT,
        line: $7a5e1e5c931c47c9$var$POLAR_SYMBOL_POINT,
        area: $7a5e1e5c931c47c9$var$POLAR_SYMBOL_POINT,
        bar: $7a5e1e5c931c47c9$var$POLAR_BAR_POINT,
        stackedbar: $7a5e1e5c931c47c9$var$POLAR_BAR_POINT
    }
};
function $7a5e1e5c931c47c9$var$isNoneMode(mode) {
    return "none" === (0, $dw9tZ.normalizeEnum)(mode);
}
function $7a5e1e5c931c47c9$export$baf26146a414f24a(series, dataItem, options) {
    this.fullState = $7a5e1e5c931c47c9$var$NORMAL_STATE;
    this.series = series;
    this.update(dataItem, options);
    this._viewCounters = {
        hover: 0,
        selection: 0
    };
    this._emptySettings = {
        fill: null,
        stroke: null,
        dashStyle: null
    };
}
$7a5e1e5c931c47c9$var$mixins.symbolPoint = (0, $1WEGH.default);
$7a5e1e5c931c47c9$var$mixins.barPoint = (0, $euKb3.default);
$7a5e1e5c931c47c9$var$mixins.bubblePoint = (0, $9RPP9.default);
$7a5e1e5c931c47c9$var$mixins.piePoint = (0, $8kJfa.default);
$7a5e1e5c931c47c9$var$mixins.rangeSymbolPoint = (0, $gTntZ.default);
$7a5e1e5c931c47c9$var$mixins.rangeBarPoint = (0, $jIcUg.default);
$7a5e1e5c931c47c9$var$mixins.candlestickPoint = (0, $1RF3f.default);
$7a5e1e5c931c47c9$var$mixins.stockPoint = (0, $6fkLT.default);
$7a5e1e5c931c47c9$var$mixins.polarSymbolPoint = (0, $9DReF.polarSymbolPoint);
$7a5e1e5c931c47c9$var$mixins.polarBarPoint = (0, $9DReF.polarBarPoint);
$7a5e1e5c931c47c9$export$baf26146a414f24a.prototype = {
    constructor: $7a5e1e5c931c47c9$export$baf26146a414f24a,
    getColor: function() {
        if (!this.hasValue() && !this._styles.usePointCustomOptions) this.series.customizePoint(this, this._dataItem);
        return this._styles.normal.fill || this.series.getColor();
    },
    _getStyle: function() {
        return this._styles[this._currentStyle || "normal"];
    },
    update: function(dataItem, options) {
        this.updateOptions(options);
        this.updateData(dataItem);
    },
    updateData: function(dataItem) {
        var argumentWasChanged = this.argument !== dataItem.argument;
        this.argument = this.initialArgument = this.originalArgument = dataItem.argument;
        this.tag = dataItem.tag;
        this.index = dataItem.index;
        this._dataItem = dataItem;
        this.data = dataItem.data;
        this.lowError = dataItem.lowError;
        this.highError = dataItem.highError;
        this.aggregationInfo = dataItem.aggregationInfo;
        this._updateData(dataItem, argumentWasChanged);
        !this.hasValue() && this.setInvisibility();
        this._fillStyle();
        this._updateLabelData();
    },
    deleteMarker: function() {
        if (this.graphic) this.graphic.dispose();
        this.graphic = null;
    },
    draw: function(renderer, groups, animationEnabled, firstDrawing) {
        if (this._needDeletingOnDraw || this.series.autoHidePointMarkers && !this.isSelected()) {
            this.deleteMarker();
            this._needDeletingOnDraw = false;
        }
        if (this._needClearingOnDraw) {
            this.clearMarker();
            this._needClearingOnDraw = false;
        }
        if (!this._hasGraphic()) this.getMarkerVisibility() && !this.series.autoHidePointMarkers && this._drawMarker(renderer, groups.markers, animationEnabled, firstDrawing);
        else this._updateMarker(animationEnabled, this._getStyle(), groups.markers);
        this._drawLabel();
        this._drawErrorBar(renderer, groups.errorBars, animationEnabled);
        return this;
    },
    _getViewStyle: function() {
        var state = $7a5e1e5c931c47c9$var$NORMAL_STATE;
        var fullState = this.fullState;
        var styles = [
            $7a5e1e5c931c47c9$var$NORMAL,
            $7a5e1e5c931c47c9$var$HOVER,
            $7a5e1e5c931c47c9$var$SELECTION,
            $7a5e1e5c931c47c9$var$SELECTION
        ];
        if (this._viewCounters.hover) state |= $7a5e1e5c931c47c9$var$HOVER_STATE;
        if (this._viewCounters.selection) state |= $7a5e1e5c931c47c9$var$SELECTED_STATE;
        if ($7a5e1e5c931c47c9$var$isNoneMode(this.getOptions().selectionMode)) fullState &= ~$7a5e1e5c931c47c9$var$SELECTED_STATE;
        if ($7a5e1e5c931c47c9$var$isNoneMode(this.getOptions().hoverMode)) fullState &= ~$7a5e1e5c931c47c9$var$HOVER_STATE;
        state |= fullState;
        return styles[state];
    },
    applyView: function(legendCallback) {
        var style = this._getViewStyle();
        this._currentStyle = style;
        if (!this.graphic && this.getMarkerVisibility() && this.series.autoHidePointMarkers && (style === $7a5e1e5c931c47c9$var$SELECTION || style === $7a5e1e5c931c47c9$var$HOVER)) this._drawMarker(this.series.getRenderer(), this.series.getMarkersGroup());
        if (this.graphic) {
            if (this.series.autoHidePointMarkers && style !== $7a5e1e5c931c47c9$var$SELECTION && style !== $7a5e1e5c931c47c9$var$HOVER) this.deleteMarker();
            else {
                if ("normal" === style) this.clearMarker();
                else this.graphic.toForeground();
                this._updateMarker(true, this._styles[style], void 0, legendCallback);
            }
        }
    },
    setView: function(style) {
        this._viewCounters[style]++;
        this.applyView();
    },
    resetView: function(style) {
        var viewCounters = this._viewCounters;
        --viewCounters[style];
        if (viewCounters[style] < 0) viewCounters[style] = 0;
        this.applyView();
    },
    releaseHoverState: function() {
        if (this.graphic && !this.isSelected()) this.graphic.toBackground();
    },
    select: function() {
        this.series.selectPoint(this);
    },
    clearSelection: function() {
        this.series.deselectPoint(this);
    },
    hover: function() {
        this.series.hoverPoint(this);
    },
    clearHover: function() {
        this.series.clearPointHover();
    },
    showTooltip: function() {
        this.series.showPointTooltip(this);
    },
    hideTooltip: function() {
        this.series.hidePointTooltip(this);
    },
    _checkLabelsChanging: function(oldType, newType) {
        var isNewRange = ~newType.indexOf("range");
        var isOldRange = ~oldType.indexOf("range");
        return isOldRange && !isNewRange || !isOldRange && isNewRange;
    },
    updateOptions: function(newOptions) {
        if (!newOptions) return;
        var oldOptions = this._options;
        var widgetType = newOptions.widgetType;
        var oldType = oldOptions && oldOptions.type;
        var newType = newOptions.type;
        var newPointTypeMixin = $7a5e1e5c931c47c9$var$pointTypes[widgetType][newType];
        if (oldType !== newType) {
            this._needDeletingOnDraw = true;
            this._needClearingOnDraw = false;
            if (oldType) {
                this._checkLabelsChanging(oldType, newType) && this.deleteLabel();
                this._resetType($7a5e1e5c931c47c9$var$mixins[$7a5e1e5c931c47c9$var$pointTypes[oldType]]);
            }
            this._setType($7a5e1e5c931c47c9$var$mixins[newPointTypeMixin]);
        } else {
            this._needDeletingOnDraw = this._checkSymbol(oldOptions, newOptions);
            this._needClearingOnDraw = this._checkCustomize(oldOptions, newOptions);
        }
        this._options = newOptions;
        this._fillStyle();
        this._updateLabelOptions(newPointTypeMixin);
    },
    translate: function() {
        if (this.hasValue()) {
            this._translate();
            this.translated = true;
        }
    },
    _checkCustomize: function(oldOptions, newOptions) {
        return oldOptions.styles.usePointCustomOptions && !newOptions.styles.usePointCustomOptions;
    },
    _getCustomLabelVisibility: function() {
        return this._styles.useLabelCustomOptions ? !!this._options.label.visible : null;
    },
    getBoundingRect: function() {
        return this._getGraphicBBox();
    },
    _resetType: function(methods) {
        for(var methodName in methods)delete this[methodName];
    },
    _setType: function(methods) {
        for(var methodName in methods)this[methodName] = methods[methodName];
    },
    isInVisibleArea: function() {
        return this.inVisibleArea;
    },
    isSelected: function() {
        return !!(this.fullState & $7a5e1e5c931c47c9$var$SELECTED_STATE);
    },
    isHovered: function() {
        return !!(this.fullState & $7a5e1e5c931c47c9$var$HOVER_STATE);
    },
    getOptions: function() {
        return this._options;
    },
    animate: function(complete, settings, partitionDuration) {
        if (!this.graphic) {
            complete && complete();
            return;
        }
        this.graphic.animate(settings, {
            partitionDuration: partitionDuration
        }, complete);
    },
    getCoords: function(min) {
        if (!min) return {
            x: this.x,
            y: this.y
        };
        if (!this._options.rotated) return {
            x: this.x,
            y: this.minY + (this.y - this.minY ? 0 : 1)
        };
        return {
            x: this.minX - (this.x - this.minX ? 0 : 1),
            y: this.y
        };
    },
    getDefaultCoords: function() {
        return !this._options.rotated ? {
            x: this.x,
            y: this.defaultY
        } : {
            x: this.defaultX,
            y: this.y
        };
    },
    setDefaultCoords () {
        var coords = this.getDefaultCoords();
        this.x = coords.x;
        this.y = coords.y;
    },
    _getVisibleArea: function() {
        return this.series.getVisibleArea();
    },
    _getArgTranslator: function() {
        return this.series.getArgumentAxis().getTranslator();
    },
    _getValTranslator: function() {
        return this.series.getValueAxis().getTranslator();
    },
    isArgumentCorrect () {
        return this.series._argumentChecker(this.argument);
    },
    isValueCorrect () {
        var valueChecker = this.series._valueChecker;
        return valueChecker(this.getMinValue()) && valueChecker(this.getMaxValue());
    },
    hasValue: function() {
        return null !== this.value && null !== this.minValue && this.isArgumentCorrect() && this.isValueCorrect();
    },
    hasCoords: (0, $gcp4g.noop),
    correctPosition: (0, $gcp4g.noop),
    correctRadius: (0, $gcp4g.noop),
    correctLabelRadius: (0, $gcp4g.noop),
    getCrosshairData: (0, $gcp4g.noop),
    getPointRadius: (0, $gcp4g.noop),
    _populatePointShape: (0, $gcp4g.noop),
    _checkSymbol: (0, $gcp4g.noop),
    getMarkerCoords: (0, $gcp4g.noop),
    hide: (0, $gcp4g.noop),
    show: (0, $gcp4g.noop),
    hideMarker: (0, $gcp4g.noop),
    setInvisibility: (0, $gcp4g.noop),
    clearVisibility: (0, $gcp4g.noop),
    isVisible: (0, $gcp4g.noop),
    resetCorrection: (0, $gcp4g.noop),
    correctValue: (0, $gcp4g.noop),
    resetValue: (0, $gcp4g.noop),
    setPercentValue: (0, $gcp4g.noop),
    correctCoordinates: (0, $gcp4g.noop),
    coordsIn: (0, $gcp4g.noop),
    getTooltipParams: (0, $gcp4g.noop),
    applyWordWrap: (0, $gcp4g.noop),
    setLabelTrackerData: (0, $gcp4g.noop),
    updateLabelCoord: (0, $gcp4g.noop),
    drawLabel: (0, $gcp4g.noop),
    correctLabelPosition: (0, $gcp4g.noop),
    getMinValue: (0, $gcp4g.noop),
    getMaxValue: (0, $gcp4g.noop),
    _drawErrorBar: (0, $gcp4g.noop),
    getMarkerVisibility: (0, $gcp4g.noop),
    dispose: function() {
        this.deleteMarker();
        this.deleteLabel();
        this._errorBar && this._errorBar.dispose();
        this._options = this._styles = this.series = this._errorBar = null;
    },
    getTooltipFormatObject: function(tooltip, stackPoints) {
        var tooltipFormatObject = this._getFormatObject(tooltip);
        var sharedTooltipValuesArray = [];
        var tooltipStackPointsFormatObject = [];
        if (stackPoints) {
            stackPoints.forEach((point)=>{
                if (!point.isVisible()) return;
                var formatObject = point._getFormatObject(tooltip);
                tooltipStackPointsFormatObject.push(formatObject);
                sharedTooltipValuesArray.push(formatObject.seriesName + ": " + formatObject.valueText);
            });
            $7a5e1e5c931c47c9$var$_extend(tooltipFormatObject, {
                points: tooltipStackPointsFormatObject,
                valueText: sharedTooltipValuesArray.join("\n"),
                stackName: this.series.getStackName() || null
            });
        }
        var aggregationInfo = this.aggregationInfo;
        if (aggregationInfo) {
            var axis = this.series.getArgumentAxis();
            var rangeText = axis.formatRange(aggregationInfo.intervalStart, aggregationInfo.intervalEnd, aggregationInfo.aggregationInterval, tooltip.getOptions().argumentFormat);
            if (rangeText) tooltipFormatObject.valueText += "\n".concat(rangeText);
        }
        return tooltipFormatObject;
    },
    setHole: function(holeValue, position) {
        var minValue = isFinite(this.minValue) ? this.minValue : 0;
        if ((0, $6ntMu.isDefined)(holeValue)) {
            if ("left" === position) {
                this.leftHole = this.value - holeValue;
                this.minLeftHole = minValue - holeValue;
            } else {
                this.rightHole = this.value - holeValue;
                this.minRightHole = minValue - holeValue;
            }
        }
    },
    resetHoles: function() {
        this.leftHole = null;
        this.minLeftHole = null;
        this.rightHole = null;
        this.minRightHole = null;
    },
    getLabel: function() {
        return this._label;
    },
    getLabels: function() {
        return [
            this._label
        ];
    },
    getCenterCoord () {
        return {
            x: this.x,
            y: this.y
        };
    }
};

});
parcelRegister("1WEGH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16aac4f652c1f928$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/series/points/symbol_point.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $gcp4g = parcelRequire("gcp4g");

var $hYatw = parcelRequire("hYatw");

var $1RlWj = parcelRequire("1RlWj");

var $6ntMu = parcelRequire("6ntMu");

var $dw9tZ = parcelRequire("dw9tZ");
var $16aac4f652c1f928$var$window = (0, $hYatw.getWindow)();
var $16aac4f652c1f928$var$_extend = (0, $2oTOp.extend);
var $16aac4f652c1f928$var$_math = Math;
var $16aac4f652c1f928$var$_round = $16aac4f652c1f928$var$_math.round;
var $16aac4f652c1f928$var$_floor = $16aac4f652c1f928$var$_math.floor;
var $16aac4f652c1f928$var$_ceil = $16aac4f652c1f928$var$_math.ceil;
var $16aac4f652c1f928$var$DEFAULT_IMAGE_WIDTH = 20;
var $16aac4f652c1f928$var$DEFAULT_IMAGE_HEIGHT = 20;
var $16aac4f652c1f928$var$LABEL_OFFSET = 10;
var $16aac4f652c1f928$var$CANVAS_POSITION_DEFAULT = "canvas_position_default";
function $16aac4f652c1f928$var$getSquareMarkerCoords(radius) {
    return [
        -radius,
        -radius,
        radius,
        -radius,
        radius,
        radius,
        -radius,
        radius,
        -radius,
        -radius
    ];
}
function $16aac4f652c1f928$var$getPolygonMarkerCoords(radius) {
    var r = $16aac4f652c1f928$var$_ceil(radius);
    return [
        -r,
        0,
        0,
        -r,
        r,
        0,
        0,
        r,
        -r,
        0
    ];
}
function $16aac4f652c1f928$var$getCrossMarkerCoords(radius) {
    var r = $16aac4f652c1f928$var$_ceil(radius);
    var floorHalfRadius = $16aac4f652c1f928$var$_floor(r / 2);
    var ceilHalfRadius = $16aac4f652c1f928$var$_ceil(r / 2);
    return [
        -r,
        -floorHalfRadius,
        -floorHalfRadius,
        -r,
        0,
        -ceilHalfRadius,
        floorHalfRadius,
        -r,
        r,
        -floorHalfRadius,
        ceilHalfRadius,
        0,
        r,
        floorHalfRadius,
        floorHalfRadius,
        r,
        0,
        ceilHalfRadius,
        -floorHalfRadius,
        r,
        -r,
        floorHalfRadius,
        -ceilHalfRadius,
        0
    ];
}
function $16aac4f652c1f928$var$getTriangleDownMarkerCoords(radius) {
    return [
        -radius,
        -radius,
        radius,
        -radius,
        0,
        radius,
        -radius,
        -radius
    ];
}
function $16aac4f652c1f928$var$getTriangleUpMarkerCoords(radius) {
    return [
        -radius,
        radius,
        radius,
        radius,
        0,
        -radius,
        -radius,
        radius
    ];
}
var $16aac4f652c1f928$export$2e2bcd8739ae039 = {
    deleteLabel: function() {
        this._label.dispose();
        this._label = null;
    },
    _hasGraphic: function() {
        return this.graphic;
    },
    clearVisibility: function() {
        var graphic = this.graphic;
        if (graphic && graphic.attr("visibility")) graphic.attr({
            visibility: null
        });
    },
    isVisible: function() {
        return this.inVisibleArea && this.series.isVisible();
    },
    setInvisibility: function() {
        var graphic = this.graphic;
        if (graphic && "hidden" !== graphic.attr("visibility")) graphic.attr({
            visibility: "hidden"
        });
        this._errorBar && this._errorBar.attr({
            visibility: "hidden"
        });
        this._label.draw(false);
    },
    clearMarker: function() {
        var graphic = this.graphic;
        graphic && graphic.attr(this._emptySettings);
    },
    _createLabel: function() {
        this._label = new (0, $1RlWj.Label)({
            renderer: this.series._renderer,
            labelsGroup: this.series._labelsGroup,
            point: this
        });
    },
    _calculateVisibility: function(x, y) {
        var { minX: minX, maxX: maxX, minY: minY, maxY: maxY } = this._getVisibleArea();
        this.inVisibleArea = minX <= x && maxX >= x && minY <= y && maxY >= y;
    },
    _updateLabelData: function() {
        this._label.setData(this._getLabelFormatObject());
    },
    _updateLabelOptions: function() {
        !this._label && this._createLabel();
        this._label.setOptions(this._options.label);
    },
    _checkImage: function(image) {
        return (0, $6ntMu.isDefined)(image) && ("string" === typeof image || (0, $6ntMu.isDefined)(image.url));
    },
    _fillStyle: function() {
        this._styles = this._options.styles;
    },
    _checkSymbol: function(oldOptions, newOptions) {
        var oldSymbol = oldOptions.symbol;
        var newSymbol = newOptions.symbol;
        var symbolChanged = "circle" === oldSymbol && "circle" !== newSymbol || "circle" !== oldSymbol && "circle" === newSymbol;
        var imageChanged = this._checkImage(oldOptions.image) !== this._checkImage(newOptions.image);
        return !!(symbolChanged || imageChanged);
    },
    _populatePointShape: function(symbol, radius) {
        switch(symbol){
            case "square":
                return $16aac4f652c1f928$var$getSquareMarkerCoords(radius);
            case "polygon":
                return $16aac4f652c1f928$var$getPolygonMarkerCoords(radius);
            case "triangle":
            case "triangleDown":
                return $16aac4f652c1f928$var$getTriangleDownMarkerCoords(radius);
            case "triangleUp":
                return $16aac4f652c1f928$var$getTriangleUpMarkerCoords(radius);
            case "cross":
                return $16aac4f652c1f928$var$getCrossMarkerCoords(radius);
        }
    },
    hasCoords: function() {
        return null !== this.x && null !== this.y;
    },
    correctValue: function(correction) {
        var axis = this.series.getValueAxis();
        if (this.hasValue()) {
            this.value = this.properValue = axis.validateUnit(this.initialValue.valueOf() + correction.valueOf());
            this.minValue = axis.validateUnit(correction);
        }
    },
    resetCorrection: function() {
        this.value = this.properValue = this.initialValue;
        this.minValue = $16aac4f652c1f928$var$CANVAS_POSITION_DEFAULT;
    },
    resetValue: function() {
        if (this.hasValue()) {
            this.value = this.properValue = this.initialValue = 0;
            this.minValue = 0;
            this._label.setDataField("value", this.value);
        }
    },
    _getTranslates: function(animationEnabled) {
        var translateX = this.x;
        var translateY = this.y;
        if (animationEnabled) {
            if (this._options.rotated) translateX = this.defaultX;
            else translateY = this.defaultY;
        }
        return {
            x: translateX,
            y: translateY
        };
    },
    _createImageMarker: function(renderer, settings, options) {
        var width = options.width || $16aac4f652c1f928$var$DEFAULT_IMAGE_WIDTH;
        var height = options.height || $16aac4f652c1f928$var$DEFAULT_IMAGE_HEIGHT;
        return renderer.image(-$16aac4f652c1f928$var$_round(.5 * width), -$16aac4f652c1f928$var$_round(.5 * height), width, height, options.url ? options.url.toString() : options.toString(), "center").attr({
            translateX: settings.translateX,
            translateY: settings.translateY,
            visibility: settings.visibility
        });
    },
    _createSymbolMarker: function(renderer, pointSettings) {
        var marker;
        var symbol = this._options.symbol;
        if ("circle" === symbol) {
            delete pointSettings.points;
            marker = renderer.circle().attr(pointSettings);
        } else if ("square" === symbol || "polygon" === symbol || "triangle" === symbol || "triangleDown" === symbol || "triangleUp" === symbol || "cross" === symbol) marker = renderer.path([], "area").attr(pointSettings).sharp();
        return marker;
    },
    _createMarker: function(renderer, group, image, settings) {
        var marker = this._checkImage(image) ? this._createImageMarker(renderer, settings, image) : this._createSymbolMarker(renderer, settings);
        if (marker) marker.data({
            "chart-data-point": this
        }).append(group);
        return marker;
    },
    _getSymbolBBox: function(x, y, r) {
        return {
            x: x - r,
            y: y - r,
            width: 2 * r,
            height: 2 * r
        };
    },
    _getImageBBox: function(x, y) {
        var image = this._options.image;
        var width = image.width || $16aac4f652c1f928$var$DEFAULT_IMAGE_WIDTH;
        var height = image.height || $16aac4f652c1f928$var$DEFAULT_IMAGE_HEIGHT;
        return {
            x: x - $16aac4f652c1f928$var$_round(width / 2),
            y: y - $16aac4f652c1f928$var$_round(height / 2),
            width: width,
            height: height
        };
    },
    _getGraphicBBox: function() {
        var options = this._options;
        var x = this.x;
        var y = this.y;
        var bBox;
        if (options.visible) bBox = this._checkImage(options.image) ? this._getImageBBox(x, y) : this._getSymbolBBox(x, y, options.styles.normal.r);
        else bBox = {
            x: x,
            y: y,
            width: 0,
            height: 0
        };
        return bBox;
    },
    hideInsideLabel: (0, $gcp4g.noop),
    _getShiftLabelCoords: function(label) {
        var coord = this._addLabelAlignmentAndOffset(label, this._getLabelCoords(label));
        return this._checkLabelPosition(label, coord);
    },
    _drawLabel: function() {
        var customVisibility = this._getCustomLabelVisibility();
        var label = this._label;
        var isVisible = this._showForZeroValues() && this.hasValue() && false !== customVisibility && (this.series.getLabelVisibility() || customVisibility);
        label.draw(!!isVisible);
    },
    correctLabelPosition: function(label) {
        var coord = this._getShiftLabelCoords(label);
        if (!this.hideInsideLabel(label, coord)) {
            label.setFigureToDrawConnector(this._getLabelConnector(label.pointPosition));
            label.shift($16aac4f652c1f928$var$_round(coord.x), $16aac4f652c1f928$var$_round(coord.y));
        }
    },
    _showForZeroValues: function() {
        return true;
    },
    _getLabelConnector: function(pointPosition) {
        var bBox = this._getGraphicBBox(pointPosition);
        var w2 = bBox.width / 2;
        var h2 = bBox.height / 2;
        return {
            x: bBox.x + w2,
            y: bBox.y + h2,
            r: this._options.visible ? Math.max(w2, h2) : 0
        };
    },
    _getPositionFromLocation: function() {
        return {
            x: this.x,
            y: this.y
        };
    },
    _isPointInVisibleArea: function(visibleArea, graphicBBox) {
        return visibleArea.minX <= graphicBBox.x + graphicBBox.width && visibleArea.maxX >= graphicBBox.x && visibleArea.minY <= graphicBBox.y + graphicBBox.height && visibleArea.maxY >= graphicBBox.y;
    },
    _checkLabelPosition: function(label, coord) {
        var visibleArea = this._getVisibleArea();
        var labelBBox = label.getBoundingRect();
        var graphicBBox = this._getGraphicBBox(label.pointPosition);
        var fullGraphicBBox = this._getGraphicBBox();
        var isInside = "inside" === label.getLayoutOptions().position;
        var offset = $16aac4f652c1f928$var$LABEL_OFFSET;
        if (this._isPointInVisibleArea(visibleArea, fullGraphicBBox)) {
            if (!this._options.rotated) {
                if (visibleArea.minX > coord.x) coord.x = visibleArea.minX;
                if (visibleArea.maxX < coord.x + labelBBox.width) coord.x = visibleArea.maxX - labelBBox.width;
                if (visibleArea.minY > coord.y) coord.y = isInside ? visibleArea.minY : graphicBBox.y + graphicBBox.height + offset;
                if (visibleArea.maxY < coord.y + labelBBox.height) coord.y = isInside ? visibleArea.maxY - labelBBox.height : graphicBBox.y - labelBBox.height - offset;
            } else {
                if (visibleArea.minX > coord.x) coord.x = isInside ? visibleArea.minX : graphicBBox.x + graphicBBox.width + offset;
                if (visibleArea.maxX < coord.x + labelBBox.width) coord.x = isInside ? visibleArea.maxX - labelBBox.width : graphicBBox.x - offset - labelBBox.width;
                if (visibleArea.minY > coord.y) coord.y = visibleArea.minY;
                if (visibleArea.maxY < coord.y + labelBBox.height) coord.y = visibleArea.maxY - labelBBox.height;
            }
        }
        return coord;
    },
    _addLabelAlignmentAndOffset: function(label, coord) {
        var labelBBox = label.getBoundingRect();
        var labelOptions = label.getLayoutOptions();
        if (!this._options.rotated) {
            if ("left" === labelOptions.alignment) coord.x += labelBBox.width / 2;
            else if ("right" === labelOptions.alignment) coord.x -= labelBBox.width / 2;
        }
        coord.x += labelOptions.horizontalOffset;
        coord.y += labelOptions.verticalOffset;
        return coord;
    },
    _getLabelCoords: function(label) {
        return this._getLabelCoordOfPosition(label, this._getLabelPosition(label.pointPosition));
    },
    _getLabelCoordOfPosition: function(label, position) {
        var labelBBox = label.getBoundingRect();
        var graphicBBox = this._getGraphicBBox(label.pointPosition);
        var offset = $16aac4f652c1f928$var$LABEL_OFFSET;
        var centerY = graphicBBox.height / 2 - labelBBox.height / 2;
        var centerX = graphicBBox.width / 2 - labelBBox.width / 2;
        var x = graphicBBox.x;
        var y = graphicBBox.y;
        switch(position){
            case "left":
                x -= labelBBox.width + offset;
                y += centerY;
                break;
            case "right":
                x += graphicBBox.width + offset;
                y += centerY;
                break;
            case "top":
                x += centerX;
                y -= labelBBox.height + offset;
                break;
            case "bottom":
                x += centerX;
                y += graphicBBox.height + offset;
                break;
            case "inside":
                x += centerX;
                y += centerY;
        }
        return {
            x: x,
            y: y
        };
    },
    _drawMarker: function(renderer, group, animationEnabled) {
        var options = this._options;
        var translates = this._getTranslates(animationEnabled);
        var style = this._getStyle();
        this.graphic = this._createMarker(renderer, group, options.image, $16aac4f652c1f928$var$_extend({
            translateX: translates.x,
            translateY: translates.y,
            points: this._populatePointShape(options.symbol, style.r)
        }, style));
    },
    _getErrorBarSettings: function() {
        return {
            visibility: "visible"
        };
    },
    _getErrorBarBaseEdgeLength () {
        return 2 * this.getPointRadius();
    },
    _drawErrorBar: function(renderer, group) {
        if (!this._options.errorBars) return;
        var options = this._options;
        var errorBarOptions = options.errorBars;
        var points = [];
        var settings;
        var pos = this._errorBarPos;
        var high = this._highErrorCoord;
        var low = this._lowErrorCoord;
        var displayMode = (0, $dw9tZ.normalizeEnum)(errorBarOptions.displayMode);
        var isHighDisplayMode = "high" === displayMode;
        var isLowDisplayMode = "low" === displayMode;
        var highErrorOnly = (isHighDisplayMode || !(0, $6ntMu.isDefined)(low)) && (0, $6ntMu.isDefined)(high) && !isLowDisplayMode;
        var lowErrorOnly = (isLowDisplayMode || !(0, $6ntMu.isDefined)(high)) && (0, $6ntMu.isDefined)(low) && !isHighDisplayMode;
        var edgeLength = errorBarOptions.edgeLength;
        if (edgeLength <= 1 && edgeLength > 0) edgeLength = this._getErrorBarBaseEdgeLength() * errorBarOptions.edgeLength;
        edgeLength = $16aac4f652c1f928$var$_floor(parseInt(edgeLength) / 2);
        highErrorOnly && (low = this._baseErrorBarPos);
        lowErrorOnly && (high = this._baseErrorBarPos);
        if ("none" !== displayMode && (0, $6ntMu.isDefined)(high) && (0, $6ntMu.isDefined)(low) && (0, $6ntMu.isDefined)(pos)) {
            !lowErrorOnly && points.push([
                pos - edgeLength,
                high,
                pos + edgeLength,
                high
            ]);
            points.push([
                pos,
                high,
                pos,
                low
            ]);
            !highErrorOnly && points.push([
                pos + edgeLength,
                low,
                pos - edgeLength,
                low
            ]);
            options.rotated && (0, $8OLOW.each)(points, function(_, p) {
                p.reverse();
            });
            settings = this._getErrorBarSettings(errorBarOptions);
            if (!this._errorBar) this._errorBar = renderer.path(points, "line").attr(settings).append(group);
            else {
                settings.points = points;
                this._errorBar.attr(settings);
            }
        } else this._errorBar && this._errorBar.attr({
            visibility: "hidden"
        });
    },
    getTooltipParams: function() {
        var graphic = this.graphic;
        return {
            x: this.x,
            y: this.y,
            offset: graphic ? graphic.getBBox().height / 2 : 0
        };
    },
    setPercentValue: function(absTotal, total, leftHoleTotal, rightHoleTotal) {
        var valuePercent = this.value / absTotal || 0;
        var minValuePercent = this.minValue / absTotal || 0;
        var percent = valuePercent - minValuePercent;
        this._label.setDataField("percent", percent);
        this._label.setDataField("total", total);
        if (this.series.isFullStackedSeries() && this.hasValue()) {
            if (this.leftHole) {
                this.leftHole /= absTotal - leftHoleTotal;
                this.minLeftHole /= absTotal - leftHoleTotal;
            }
            if (this.rightHole) {
                this.rightHole /= absTotal - rightHoleTotal;
                this.minRightHole /= absTotal - rightHoleTotal;
            }
            this.value = this.properValue = valuePercent;
            this.minValue = !minValuePercent ? this.minValue : minValuePercent;
        }
    },
    _storeTrackerR: function() {
        var navigator = $16aac4f652c1f928$var$window.navigator;
        var r = this._options.styles.normal.r;
        var minTrackerSize = (0, $hYatw.hasProperty)("ontouchstart") || navigator.msPointerEnabled && navigator.msMaxTouchPoints || navigator.pointerEnabled && navigator.maxTouchPoints ? 20 : 6;
        this._options.trackerR = r < minTrackerSize ? minTrackerSize : r;
        return this._options.trackerR;
    },
    _translateErrorBars: function() {
        var options = this._options;
        var rotated = options.rotated;
        var errorBars = options.errorBars;
        var translator = this._getValTranslator();
        if (!errorBars) return;
        (0, $6ntMu.isDefined)(this.lowError) && (this._lowErrorCoord = translator.translate(this.lowError));
        (0, $6ntMu.isDefined)(this.highError) && (this._highErrorCoord = translator.translate(this.highError));
        this._errorBarPos = $16aac4f652c1f928$var$_floor(rotated ? this.vy : this.vx);
        this._baseErrorBarPos = "stdDeviation" === errorBars.type ? this._lowErrorCoord + (this._highErrorCoord - this._lowErrorCoord) / 2 : rotated ? this.vx : this.vy;
    },
    _translate: function() {
        var valTranslator = this._getValTranslator();
        var argTranslator = this._getArgTranslator();
        if (this._options.rotated) {
            this.vx = this.x = valTranslator.translate(this.value, void 0, true);
            this.vy = this.y = argTranslator.translate(this.argument, void 0, true);
            this.minX = valTranslator.translate(this.minValue, void 0, true);
            this.defaultX = valTranslator.translate($16aac4f652c1f928$var$CANVAS_POSITION_DEFAULT);
        } else {
            this.vy = this.y = valTranslator.translate(this.value, void 0, true);
            this.vx = this.x = argTranslator.translate(this.argument, void 0, true);
            this.minY = valTranslator.translate(this.minValue, void 0, true);
            this.defaultY = valTranslator.translate($16aac4f652c1f928$var$CANVAS_POSITION_DEFAULT);
        }
        this._translateErrorBars();
        this._calculateVisibility(this.x, this.y);
    },
    _updateData: function(data) {
        this.value = this.properValue = this.initialValue = this.originalValue = data.value;
        this.minValue = this.initialMinValue = this.originalMinValue = (0, $6ntMu.isDefined)(data.minValue) ? data.minValue : $16aac4f652c1f928$var$CANVAS_POSITION_DEFAULT;
    },
    _getImageSettings: function(image) {
        return {
            href: image.url || image.toString(),
            width: image.width || $16aac4f652c1f928$var$DEFAULT_IMAGE_WIDTH,
            height: image.height || $16aac4f652c1f928$var$DEFAULT_IMAGE_HEIGHT
        };
    },
    getCrosshairData: function() {
        var r = this._options.rotated;
        var value = this.properValue;
        var argument = this.argument;
        return {
            x: this.vx,
            y: this.vy,
            xValue: r ? value : argument,
            yValue: r ? argument : value,
            axis: this.series.axis
        };
    },
    getPointRadius: function() {
        var style = this._getStyle();
        var options = this._options;
        var r = style.r;
        var extraSpace;
        var symbol = options.symbol;
        var isSquare = "square" === symbol;
        var isTriangle = "triangle" === symbol || "triangleDown" === symbol || "triangleUp" === symbol;
        if (options.visible && !options.image && r) {
            extraSpace = style["stroke-width"] / 2;
            return (isSquare || isTriangle ? 1.4 * r : r) + extraSpace;
        }
        return 0;
    },
    _updateMarker: function(animationEnabled, style) {
        var options = this._options;
        var settings;
        var image = options.image;
        var visibility = !this.isVisible() ? {
            visibility: "hidden"
        } : {};
        if (this._checkImage(image)) settings = $16aac4f652c1f928$var$_extend({}, {
            visibility: style.visibility
        }, visibility, this._getImageSettings(image));
        else settings = $16aac4f652c1f928$var$_extend({}, style, visibility, {
            points: this._populatePointShape(options.symbol, style.r)
        });
        if (!animationEnabled) {
            settings.translateX = this.x;
            settings.translateY = this.y;
        }
        this.graphic.attr(settings).sharp();
    },
    _getLabelFormatObject: function() {
        return {
            argument: this.initialArgument,
            value: this.initialValue,
            originalArgument: this.originalArgument,
            originalValue: this.originalValue,
            seriesName: this.series.name,
            lowErrorValue: this.lowError,
            highErrorValue: this.highError,
            point: this
        };
    },
    _getLabelPosition: function() {
        var rotated = this._options.rotated;
        if (this.initialValue > 0) return rotated ? "right" : "top";
        else return rotated ? "left" : "bottom";
    },
    _getFormatObject: function(tooltip) {
        var labelFormatObject = this._label.getData();
        return $16aac4f652c1f928$var$_extend({}, labelFormatObject, {
            argumentText: tooltip.formatValue(this.initialArgument, "argument"),
            valueText: tooltip.formatValue(this.initialValue)
        }, (0, $6ntMu.isDefined)(labelFormatObject.percent) ? {
            percentText: tooltip.formatValue(labelFormatObject.percent, "percent")
        } : {}, (0, $6ntMu.isDefined)(labelFormatObject.total) ? {
            totalText: tooltip.formatValue(labelFormatObject.total)
        } : {});
    },
    getMarkerVisibility: function() {
        return this._options.visible;
    },
    coordsIn: function(x, y) {
        var trackerRadius = this._storeTrackerR();
        return x >= this.x - trackerRadius && x <= this.x + trackerRadius && y >= this.y - trackerRadius && y <= this.y + trackerRadius;
    },
    getMinValue: function(noErrorBar) {
        var errorBarOptions = this._options.errorBars;
        if (errorBarOptions && !noErrorBar) {
            var displayMode = errorBarOptions.displayMode;
            var lowValue = "high" !== displayMode && (0, $6ntMu.isDefined)(this.lowError) ? this.lowError : this.value;
            var highValue = "low" !== displayMode && (0, $6ntMu.isDefined)(this.highError) ? this.highError : this.value;
            return lowValue < highValue ? lowValue : highValue;
        } else return this.value;
    },
    getMaxValue: function(noErrorBar) {
        var errorBarOptions = this._options.errorBars;
        if (errorBarOptions && !noErrorBar) {
            var displayMode = errorBarOptions.displayMode;
            var lowValue = "high" !== displayMode && (0, $6ntMu.isDefined)(this.lowError) ? this.lowError : this.value;
            var highValue = "low" !== displayMode && (0, $6ntMu.isDefined)(this.highError) ? this.highError : this.value;
            return lowValue > highValue ? lowValue : highValue;
        } else return this.value;
    }
};

});
parcelRegister("1RlWj", function(module, exports) {

$parcel$export(module.exports, "Label", function () { return $15abc26e53ff231a$export$b04be29aa201d4f5; });
/**
 * DevExtreme (esm/viz/series/points/label.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $7UWPL = parcelRequire("7UWPL");

var $dw9tZ = parcelRequire("dw9tZ");

var $8OLOW = parcelRequire("8OLOW");

var $2oTOp = parcelRequire("2oTOp");

var $fxwIP = parcelRequire("fxwIP");
var $15abc26e53ff231a$var$_format = (0, $7UWPL.default).format;
var $15abc26e53ff231a$var$_math = Math;
var $15abc26e53ff231a$var$_round = $15abc26e53ff231a$var$_math.round;
var $15abc26e53ff231a$var$_floor = $15abc26e53ff231a$var$_math.floor;
var $15abc26e53ff231a$var$_abs = $15abc26e53ff231a$var$_math.abs;
var $15abc26e53ff231a$var$CONNECTOR_LENGTH = 12;
var $15abc26e53ff231a$var$LABEL_BACKGROUND_PADDING_X = 8;
var $15abc26e53ff231a$var$LABEL_BACKGROUND_PADDING_Y = 4;
function $15abc26e53ff231a$var$getClosestCoord(point, coords) {
    var closestDistance = 1 / 0;
    var closestCoord;
    (0, $8OLOW.each)(coords, function(_, coord) {
        var x = point[0] - coord[0];
        var y = point[1] - coord[1];
        var distance = x * x + y * y;
        if (distance < closestDistance) {
            closestDistance = distance;
            closestCoord = coord;
        }
    });
    return [
        $15abc26e53ff231a$var$_floor(closestCoord[0]),
        $15abc26e53ff231a$var$_floor(closestCoord[1])
    ];
}
function $15abc26e53ff231a$var$getCrossCoord(rect, coord, indexOffset) {
    return (coord - rect[0 + indexOffset]) / (rect[2 + indexOffset] - rect[0 + indexOffset]) * (rect[3 - indexOffset] - rect[1 - indexOffset]) + rect[1 - indexOffset];
}
var $15abc26e53ff231a$var$barPointStrategy = {
    isLabelInside: function(labelPoint, figure) {
        var xc = labelPoint.x + labelPoint.width / 2;
        var yc = labelPoint.y + labelPoint.height / 2;
        return figure.x <= xc && xc <= figure.x + figure.width && figure.y <= yc && yc <= figure.y + figure.height;
    },
    prepareLabelPoints: function(bBox, rotatedBBox, isHorizontal, angle, figureCenter) {
        var x1 = rotatedBBox.x;
        var xc = x1 + rotatedBBox.width / 2;
        var x2 = x1 + rotatedBBox.width - 1;
        var y1 = rotatedBBox.y;
        var yc = y1 + rotatedBBox.height / 2;
        var y2 = y1 + rotatedBBox.height - 1;
        var labelPoints;
        var isRectangular = $15abc26e53ff231a$var$_abs(angle) % 90 === 0;
        if (figureCenter[0] > x1 && figureCenter[0] < x2) {
            if (isRectangular) labelPoints = [
                [
                    figureCenter[0],
                    $15abc26e53ff231a$var$_abs(figureCenter[1] - y1) < $15abc26e53ff231a$var$_abs(figureCenter[1] - y2) ? y1 : y2
                ]
            ];
            else labelPoints = [
                [
                    figureCenter[0],
                    $15abc26e53ff231a$var$getCrossCoord([
                        x1,
                        y1,
                        x2,
                        y2
                    ], figureCenter[0], 0)
                ]
            ];
        } else if (figureCenter[1] > y1 && figureCenter[1] < y2) {
            if (isRectangular) labelPoints = [
                [
                    $15abc26e53ff231a$var$_abs(figureCenter[0] - x1) < $15abc26e53ff231a$var$_abs(figureCenter[0] - x2) ? x1 : x2,
                    figureCenter[1]
                ]
            ];
            else labelPoints = [
                [
                    $15abc26e53ff231a$var$getCrossCoord([
                        x1,
                        y1,
                        x2,
                        y2
                    ], figureCenter[1], 1),
                    figureCenter[1]
                ]
            ];
        } else if (isRectangular) labelPoints = [
            [
                x1,
                y1
            ],
            [
                isHorizontal ? x1 : xc,
                isHorizontal ? yc : y1
            ],
            [
                x2,
                y1
            ],
            [
                x1,
                y2
            ],
            [
                isHorizontal ? x2 : xc,
                isHorizontal ? yc : y2
            ],
            [
                x2,
                y2
            ]
        ];
        else labelPoints = [
            [
                xc,
                yc
            ]
        ];
        return labelPoints;
    },
    isHorizontal: function(bBox, figure) {
        return bBox.x > figure.x + figure.width || bBox.x + bBox.width < figure.x;
    },
    getFigureCenter: function(figure) {
        return [
            $15abc26e53ff231a$var$_floor(figure.x + figure.width / 2),
            $15abc26e53ff231a$var$_floor(figure.y + figure.height / 2)
        ];
    },
    findFigurePoint: function(figure, labelPoint) {
        var figureCenter = $15abc26e53ff231a$var$barPointStrategy.getFigureCenter(figure);
        var point = $15abc26e53ff231a$var$getClosestCoord(labelPoint, [
            [
                figure.x,
                figureCenter[1]
            ],
            [
                figureCenter[0],
                figure.y + figure.height
            ],
            [
                figure.x + figure.width,
                figureCenter[1]
            ],
            [
                figureCenter[0],
                figure.y
            ]
        ]);
        return point;
    },
    adjustPoints: function(points) {
        var lineIsVertical = $15abc26e53ff231a$var$_abs(points[1] - points[3]) <= 1;
        var lineIsHorizontal = $15abc26e53ff231a$var$_abs(points[0] - points[2]) <= 1;
        if (lineIsHorizontal) points[0] = points[2];
        if (lineIsVertical) points[1] = points[3];
        return points;
    }
};
var $15abc26e53ff231a$var$symbolPointStrategy = {
    isLabelInside: function() {
        return false;
    },
    prepareLabelPoints: $15abc26e53ff231a$var$barPointStrategy.prepareLabelPoints,
    isHorizontal: function(bBox, figure) {
        return bBox.x > figure.x + figure.r || bBox.x + bBox.width < figure.x - figure.r;
    },
    getFigureCenter: function(figure) {
        return [
            figure.x,
            figure.y
        ];
    },
    findFigurePoint: function(figure, labelPoint) {
        var angle = Math.atan2(figure.y - labelPoint[1], labelPoint[0] - figure.x);
        return [
            $15abc26e53ff231a$var$_round(figure.x + figure.r * Math.cos(angle)),
            $15abc26e53ff231a$var$_round(figure.y - figure.r * Math.sin(angle))
        ];
    },
    adjustPoints: $15abc26e53ff231a$var$barPointStrategy.adjustPoints
};
var $15abc26e53ff231a$var$piePointStrategy = {
    isLabelInside: function(_0, _1, isOutside) {
        return !isOutside;
    },
    prepareLabelPoints: function(bBox, rotatedBBox, isHorizontal, angle) {
        var xl = bBox.x;
        var xr = xl + bBox.width;
        var xc = xl + $15abc26e53ff231a$var$_round(bBox.width / 2);
        var yt = bBox.y;
        var yb = yt + bBox.height;
        var yc = yt + $15abc26e53ff231a$var$_round(bBox.height / 2);
        var points = [
            [
                [
                    xl,
                    yt
                ],
                [
                    xr,
                    yt
                ]
            ],
            [
                [
                    xr,
                    yt
                ],
                [
                    xr,
                    yb
                ]
            ],
            [
                [
                    xr,
                    yb
                ],
                [
                    xl,
                    yb
                ]
            ],
            [
                [
                    xl,
                    yb
                ],
                [
                    xl,
                    yt
                ]
            ]
        ];
        var cosSin = (0, $dw9tZ.getCosAndSin)(angle);
        if (0 === angle) points = isHorizontal ? [
            [
                xl,
                yc
            ],
            [
                xr,
                yc
            ]
        ] : [
            [
                xc,
                yt
            ],
            [
                xc,
                yb
            ]
        ];
        else points = points.map(function(pair) {
            return pair.map(function(point) {
                return [
                    $15abc26e53ff231a$var$_round((point[0] - xc) * cosSin.cos + (point[1] - yc) * cosSin.sin + xc),
                    $15abc26e53ff231a$var$_round(-(point[0] - xc) * cosSin.sin + (point[1] - yc) * cosSin.cos + yc)
                ];
            });
        }).reduce(function(r, pair) {
            var point1x = pair[0][0];
            var point1y = pair[0][1];
            var point2x = pair[1][0];
            var point2y = pair[1][1];
            if (isHorizontal) {
                if (point1y >= yc && yc >= point2y || point1y <= yc && yc <= point2y) r.push([
                    (yc - point1y) * (point2x - point1x) / (point2y - point1y) + point1x,
                    yc
                ]);
            } else if (point1x >= xc && xc >= point2x || point1x <= xc && xc <= point2x) r.push([
                xc,
                (xc - point1x) * (point2y - point1y) / (point2x - point1x) + point1y
            ]);
            return r;
        }, []);
        return points;
    },
    isHorizontal: function(bBox, figure) {
        return bBox.x > figure.x || figure.x > bBox.x + bBox.width;
    },
    getFigureCenter: $15abc26e53ff231a$var$symbolPointStrategy.getFigureCenter,
    findFigurePoint: function(figure, labelPoint, isHorizontal) {
        if (!isHorizontal) return [
            figure.x,
            figure.y
        ];
        var labelX = labelPoint[0];
        var x = $15abc26e53ff231a$var$_round(figure.x + (figure.y - labelPoint[1]) / Math.tan((0, $dw9tZ.degreesToRadians)(figure.angle)));
        var points = [
            figure.x,
            figure.y,
            x,
            labelPoint[1]
        ];
        if (!(figure.x <= x && x <= labelX) && !(labelX <= x && x <= figure.x)) {
            if ($15abc26e53ff231a$var$_abs(figure.x - labelX) < $15abc26e53ff231a$var$CONNECTOR_LENGTH) points = [
                figure.x,
                figure.y
            ];
            else if (figure.x <= labelX) points[2] = figure.x + $15abc26e53ff231a$var$CONNECTOR_LENGTH;
            else points[2] = figure.x - $15abc26e53ff231a$var$CONNECTOR_LENGTH;
        }
        return points;
    },
    adjustPoints: function(points) {
        return points;
    }
};
function $15abc26e53ff231a$var$selectStrategy(figure) {
    return void 0 !== figure.angle && $15abc26e53ff231a$var$piePointStrategy || void 0 !== figure.r && $15abc26e53ff231a$var$symbolPointStrategy || $15abc26e53ff231a$var$barPointStrategy;
}
function $15abc26e53ff231a$var$disposeItem(obj, field) {
    obj[field] && obj[field].dispose();
    obj[field] = null;
}
function $15abc26e53ff231a$var$checkBackground(background) {
    return background && (background.fill && "none" !== background.fill || background["stroke-width"] > 0 && background.stroke && "none" !== background.stroke);
}
function $15abc26e53ff231a$var$checkConnector(connector) {
    return connector && connector["stroke-width"] > 0 && connector.stroke && "none" !== connector.stroke;
}
function $15abc26e53ff231a$var$formatText(data, options) {
    var format = options.format;
    data.valueText = $15abc26e53ff231a$var$_format(data.value, format);
    data.argumentText = $15abc26e53ff231a$var$_format(data.argument, options.argumentFormat);
    if (void 0 !== data.percent) data.percentText = $15abc26e53ff231a$var$_format(data.percent, {
        type: "percent",
        precision: format && format.percentPrecision
    });
    if (void 0 !== data.total) data.totalText = $15abc26e53ff231a$var$_format(data.total, format);
    if (void 0 !== data.openValue) data.openValueText = $15abc26e53ff231a$var$_format(data.openValue, format);
    if (void 0 !== data.closeValue) data.closeValueText = $15abc26e53ff231a$var$_format(data.closeValue, format);
    if (void 0 !== data.lowValue) data.lowValueText = $15abc26e53ff231a$var$_format(data.lowValue, format);
    if (void 0 !== data.highValue) data.highValueText = $15abc26e53ff231a$var$_format(data.highValue, format);
    if (void 0 !== data.reductionValue) data.reductionValueText = $15abc26e53ff231a$var$_format(data.reductionValue, format);
    return options.customizeText ? options.customizeText.call(data, data) : options.displayFormat ? (0, $fxwIP.processDisplayFormat)(options.displayFormat, data) : data.valueText;
}
function $15abc26e53ff231a$export$b04be29aa201d4f5(renderSettings) {
    this._renderer = renderSettings.renderer;
    this._container = renderSettings.labelsGroup;
    this._point = renderSettings.point;
    this._strategy = renderSettings.strategy;
    this._rowCount = 1;
}
$15abc26e53ff231a$export$b04be29aa201d4f5.prototype = {
    constructor: $15abc26e53ff231a$export$b04be29aa201d4f5,
    setColor: function(color) {
        this._color = color;
    },
    setOptions: function(options) {
        this._options = options;
    },
    setData: function(data) {
        this._data = data;
    },
    setDataField: function(fieldName, fieldValue) {
        this._data = this._data || {};
        this._data[fieldName] = fieldValue;
    },
    getData: function() {
        return this._data;
    },
    setFigureToDrawConnector: function(figure) {
        this._figure = figure;
    },
    dispose: function() {
        $15abc26e53ff231a$var$disposeItem(this, "_group");
        this._data = this._options = this._textContent = this._visible = this._insideGroup = this._text = this._background = this._connector = this._figure = null;
    },
    _setVisibility: function(value, state) {
        this._group && this._group.attr({
            visibility: value
        });
        this._visible = state;
    },
    isVisible: function() {
        return this._visible;
    },
    hide: function(holdInvisible) {
        this._holdVisibility = !!holdInvisible;
        this._hide();
    },
    _hide: function() {
        this._setVisibility("hidden", false);
    },
    show: function(holdVisible) {
        var correctPosition = !this._drawn;
        if (this._point.hasValue()) {
            this._holdVisibility = !!holdVisible;
            this._show();
            correctPosition && this._point.correctLabelPosition(this);
        }
    },
    _show: function() {
        var renderer = this._renderer;
        var container = this._container;
        var options = this._options || {};
        var text = this._textContent = $15abc26e53ff231a$var$formatText(this._data, options) || null;
        if (text) {
            if (!this._group) {
                this._group = renderer.g().append(container);
                this._insideGroup = renderer.g().append(this._group);
                this._text = renderer.text("", 0, 0).append(this._insideGroup);
            }
            this._text.css(options.attributes ? (0, $dw9tZ.patchFontOptions)(options.attributes.font) : {});
            if ($15abc26e53ff231a$var$checkBackground(options.background)) {
                this._background = this._background || renderer.rect().append(this._insideGroup).toBackground();
                this._background.attr(options.background);
                this._color && this._background.attr({
                    fill: this._color
                });
            } else $15abc26e53ff231a$var$disposeItem(this, "_background");
            if ($15abc26e53ff231a$var$checkConnector(options.connector)) {
                this._connector = this._connector || renderer.path([], "line").sharp().append(this._group).toBackground();
                this._connector.attr(options.connector);
                this._color && this._connector.attr({
                    stroke: this._color
                });
            } else $15abc26e53ff231a$var$disposeItem(this, "_connector");
            this._text.attr({
                text: text,
                align: options.textAlignment,
                class: options.cssClass
            });
            this._updateBackground(this._text.getBBox());
            this._setVisibility("visible", true);
            this._drawn = true;
        } else this._hide();
    },
    _getLabelVisibility: function(isVisible) {
        return this._holdVisibility ? this.isVisible() : isVisible;
    },
    draw: function(isVisible) {
        if (this._getLabelVisibility(isVisible)) {
            this._show();
            this._point && this._point.correctLabelPosition(this);
        } else {
            this._drawn = false;
            this._hide();
        }
        return this;
    },
    _updateBackground: function(bBox) {
        if (this._background) {
            bBox.x -= $15abc26e53ff231a$var$LABEL_BACKGROUND_PADDING_X;
            bBox.y -= $15abc26e53ff231a$var$LABEL_BACKGROUND_PADDING_Y;
            bBox.width += 2 * $15abc26e53ff231a$var$LABEL_BACKGROUND_PADDING_X;
            bBox.height += 2 * $15abc26e53ff231a$var$LABEL_BACKGROUND_PADDING_Y;
            this._background.attr(bBox);
        }
        this._bBoxWithoutRotation = (0, $2oTOp.extend)({}, bBox);
        var rotationAngle = this._options.rotationAngle || 0;
        this._insideGroup.rotate(rotationAngle, bBox.x + bBox.width / 2, bBox.y + bBox.height / 2);
        bBox = (0, $dw9tZ.rotateBBox)(bBox, [
            bBox.x + bBox.width / 2,
            bBox.y + bBox.height / 2
        ], -rotationAngle);
        this._bBox = bBox;
    },
    getFigureCenter () {
        var figure = this._figure;
        var strategy = this._strategy || $15abc26e53ff231a$var$selectStrategy(figure);
        return strategy.getFigureCenter(figure);
    },
    _getConnectorPoints: function() {
        var figure = this._figure;
        var options = this._options;
        var strategy = this._strategy || $15abc26e53ff231a$var$selectStrategy(figure);
        var bBox = this._shiftBBox(this._bBoxWithoutRotation);
        var rotatedBBox = this.getBoundingRect();
        var labelPoint;
        var points = [];
        var isHorizontal;
        if (!strategy.isLabelInside(bBox, figure, "inside" !== options.position)) {
            isHorizontal = strategy.isHorizontal(bBox, figure);
            var figureCenter = this.getFigureCenter();
            points = strategy.prepareLabelPoints(bBox, rotatedBBox, isHorizontal, -options.rotationAngle || 0, figureCenter);
            labelPoint = $15abc26e53ff231a$var$getClosestCoord(figureCenter, points);
            points = strategy.findFigurePoint(figure, labelPoint, isHorizontal);
            points = points.concat(labelPoint);
        }
        return strategy.adjustPoints(points);
    },
    fit: function(maxWidth) {
        var padding = this._background ? 2 * $15abc26e53ff231a$var$LABEL_BACKGROUND_PADDING_X : 0;
        var rowCountChanged = false;
        if (this._text) {
            var result = this._text.setMaxSize(maxWidth - padding, void 0, this._options);
            var rowCount = result.rowCount;
            if (0 === rowCount) rowCount = 1;
            if (rowCount !== this._rowCount) {
                rowCountChanged = true;
                this._rowCount = rowCount;
            }
            result.textIsEmpty && $15abc26e53ff231a$var$disposeItem(this, "_background");
        }
        this._updateBackground(this._text.getBBox());
        return rowCountChanged;
    },
    resetEllipsis: function() {
        this._text && this._text.restoreText();
        this._updateBackground(this._text.getBBox());
    },
    setTrackerData: function(point) {
        this._text.data({
            "chart-data-point": point
        });
        this._background && this._background.data({
            "chart-data-point": point
        });
    },
    hideInsideLabel: function(coords) {
        return this._point.hideInsideLabel(this, coords);
    },
    getPoint () {
        return this._point;
    },
    shift: function(x, y) {
        if (this._textContent) {
            this._insideGroup.attr({
                translateX: this._x = $15abc26e53ff231a$var$_round(x - this._bBox.x),
                translateY: this._y = $15abc26e53ff231a$var$_round(y - this._bBox.y)
            });
            if (this._connector) this._connector.attr({
                points: this._getConnectorPoints()
            });
        }
        return this;
    },
    getBoundingRect: function() {
        return this._shiftBBox(this._bBox);
    },
    _shiftBBox: function(bBox) {
        return this._textContent ? {
            x: bBox.x + this._x,
            y: bBox.y + this._y,
            width: bBox.width,
            height: bBox.height
        } : {};
    },
    getLayoutOptions: function() {
        var options = this._options;
        return {
            alignment: options.alignment,
            background: $15abc26e53ff231a$var$checkBackground(options.background),
            horizontalOffset: options.horizontalOffset,
            verticalOffset: options.verticalOffset,
            radialOffset: options.radialOffset,
            position: options.position,
            connectorOffset: ($15abc26e53ff231a$var$checkConnector(options.connector) ? $15abc26e53ff231a$var$CONNECTOR_LENGTH : 0) + ($15abc26e53ff231a$var$checkBackground(options.background) ? $15abc26e53ff231a$var$LABEL_BACKGROUND_PADDING_X : 0)
        };
    }
};

});
parcelRegister("fxwIP", function(module, exports) {

$parcel$export(module.exports, "processDisplayFormat", function () { return $b50351fd53af44f8$export$2b2f756017b9f61c; });
/**
 * DevExtreme (esm/viz/series/helpers/display_format_parser.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $5x5oL = parcelRequire("5x5oL");
var $b50351fd53af44f8$var$startPlaceHolderChar = "{";
var $b50351fd53af44f8$var$endPlaceHolderChar = "}";
var $b50351fd53af44f8$var$placeholderFormatDelimiter = ":";
function $b50351fd53af44f8$var$formatValue(value, format) {
    if (format) {
        if (value instanceof Date) return (0, $5x5oL.formatDate)(value, format);
        if ("number" === typeof value) return (0, $5x5oL.formatNumber)(value, format);
    }
    return value;
}
function $b50351fd53af44f8$var$getValueByPlaceHolder(placeHolder, pointInfo) {
    var customFormat = "";
    var customFormatIndex = placeHolder.indexOf($b50351fd53af44f8$var$placeholderFormatDelimiter);
    if (customFormatIndex > 0) {
        customFormat = placeHolder.substr(customFormatIndex + 1);
        placeHolder = placeHolder.substr(0, customFormatIndex);
    }
    return $b50351fd53af44f8$var$formatValue(pointInfo[placeHolder], customFormat);
}
function $b50351fd53af44f8$export$2b2f756017b9f61c(displayFormat, pointInfo) {
    var actualText = displayFormat;
    var continueProcess = true;
    while(continueProcess){
        var startBracketIndex = actualText.indexOf($b50351fd53af44f8$var$startPlaceHolderChar);
        var endBracketIndex = actualText.indexOf($b50351fd53af44f8$var$endPlaceHolderChar);
        if (startBracketIndex >= 0 && endBracketIndex > 0) {
            var placeHolder = actualText.substring(startBracketIndex + 1, endBracketIndex);
            var value = $b50351fd53af44f8$var$getValueByPlaceHolder(placeHolder, pointInfo);
            actualText = actualText.substr(0, startBracketIndex) + value + actualText.substr(endBracketIndex + 1);
        } else continueProcess = false;
    }
    return actualText;
}

});
parcelRegister("5x5oL", function(module, exports) {

$parcel$export(module.exports, "formatNumber", function () { return $407438cf5c9a25f5$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatDate", function () { return $407438cf5c9a25f5$export$3ae94a2503e890a1; });
/**
 * DevExtreme (esm/localization.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $iTFn1 = parcelRequire("iTFn1");

var $9zsY3 = parcelRequire("9zsY3");

var $8qyBL = parcelRequire("8qyBL");

var $8gWak = parcelRequire("8gWak");
parcelRequire("i9oc6");
var $407438cf5c9a25f5$export$162ce11d62a1ca51 = (0, $iTFn1.default).locale.bind((0, $iTFn1.default));
var $407438cf5c9a25f5$export$5ad1685e25d6394f = (0, $9zsY3.default).load.bind((0, $9zsY3.default));
var $407438cf5c9a25f5$export$25868d1e8e76735f = (0, $9zsY3.default).format.bind((0, $9zsY3.default));
var $407438cf5c9a25f5$export$f5dd818bff069720 = (0, $8qyBL.default).format.bind((0, $8qyBL.default));
var $407438cf5c9a25f5$export$6bf0e8cf8e1d780d = (0, $8qyBL.default).parse.bind((0, $8qyBL.default));
var $407438cf5c9a25f5$export$3ae94a2503e890a1 = (0, $8gWak.default).format.bind((0, $8gWak.default));
var $407438cf5c9a25f5$export$6b862160d295c8e = (0, $8gWak.default).parse.bind((0, $8gWak.default));
function $407438cf5c9a25f5$export$60d49c08b2d0ee15() {
    if ("intl" === (0, $8qyBL.default).engine()) (0, $8qyBL.default).resetInjection();
    if ("intl" === (0, $8gWak.default).engine()) (0, $8gWak.default).resetInjection();
}

});




parcelRegister("euKb3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8d7afe47a71f53a$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/series/points/bar_point.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $1WEGH = parcelRequire("1WEGH");
var $a8d7afe47a71f53a$var$_extend = (0, $2oTOp.extend);
var $a8d7afe47a71f53a$var$_math = Math;
var $a8d7afe47a71f53a$var$_floor = $a8d7afe47a71f53a$var$_math.floor;
var $a8d7afe47a71f53a$var$_abs = $a8d7afe47a71f53a$var$_math.abs;
var $a8d7afe47a71f53a$var$CANVAS_POSITION_DEFAULT = "canvas_position_default";
var $a8d7afe47a71f53a$var$DEFAULT_BAR_TRACKER_SIZE = 9;
var $a8d7afe47a71f53a$var$CORRECTING_BAR_TRACKER_VALUE = 4;
var $a8d7afe47a71f53a$var$RIGHT = "right";
var $a8d7afe47a71f53a$var$LEFT = "left";
var $a8d7afe47a71f53a$var$TOP = "top";
var $a8d7afe47a71f53a$var$BOTTOM = "bottom";
function $a8d7afe47a71f53a$var$getLabelOrientation(point) {
    var initialValue = point.initialValue;
    var invert = point._getValTranslator().getBusinessRange().invert;
    var isDiscreteValue = "discrete" === point.series.valueAxisType;
    var isFullStacked = point.series.isFullStackedSeries();
    var notAxisInverted = !isDiscreteValue && (initialValue >= 0 && !invert || initialValue < 0 && invert) || isDiscreteValue && !invert || isFullStacked;
    return notAxisInverted ? $a8d7afe47a71f53a$var$TOP : $a8d7afe47a71f53a$var$BOTTOM;
}
var $a8d7afe47a71f53a$export$2e2bcd8739ae039 = $a8d7afe47a71f53a$var$_extend({}, (0, $1WEGH.default), {
    correctCoordinates (correctOptions) {
        var correction = $a8d7afe47a71f53a$var$_floor(correctOptions.offset - correctOptions.width / 2);
        if (this._options.rotated) {
            this.height = correctOptions.width;
            this.yCorrection = correction;
            this.xCorrection = null;
        } else {
            this.width = correctOptions.width;
            this.xCorrection = correction;
            this.yCorrection = null;
        }
    },
    _calculateVisibility: function(x, y, width, height) {
        var { minX: minX, maxX: maxX, minY: minY, maxY: maxY } = this._getVisibleArea();
        this.inVisibleArea = minX <= x + width && maxX >= x && minY <= y + height && maxY >= y;
    },
    _cacheVisibility: function(x, y, minY, rotated) {
        var size = Math.abs(y - minY);
        y = Math.min(y, minY);
        if (rotated) this._calculateVisibility(y, x, size, this.height);
        else this._calculateVisibility(x, y, this.width, size);
    },
    _getGraphicBBox: function(location) {
        var bBox = {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
        if (location) {
            var isTop = "top" === location;
            if (!this._options.rotated) {
                bBox.y = isTop ? bBox.y : bBox.y + bBox.height;
                bBox.height = 0;
            } else {
                bBox.x = isTop ? bBox.x + bBox.width : bBox.x;
                bBox.width = 0;
            }
        }
        return bBox;
    },
    _getLabelConnector: function(location) {
        return this._getGraphicBBox(location);
    },
    _getLabelPosition: function() {
        var position = $a8d7afe47a71f53a$var$getLabelOrientation(this);
        if (this._options.rotated) position = position === $a8d7afe47a71f53a$var$TOP ? $a8d7afe47a71f53a$var$RIGHT : $a8d7afe47a71f53a$var$LEFT;
        return position;
    },
    _getLabelCoords: function(label) {
        var coords;
        if (0 === this.initialValue && this.series.isFullStackedSeries()) {
            if (!this._options.rotated) coords = this._getLabelCoordOfPosition(label, $a8d7afe47a71f53a$var$TOP);
            else coords = this._getLabelCoordOfPosition(label, $a8d7afe47a71f53a$var$RIGHT);
        } else if ("inside" === label.getLayoutOptions().position) coords = this._getLabelCoordOfPosition(label, "inside");
        else coords = (0, $1WEGH.default)._getLabelCoords.call(this, label);
        return coords;
    },
    _drawLabel: function() {
        this._label.pointPosition = "inside" !== this._label.getLayoutOptions().position && $a8d7afe47a71f53a$var$getLabelOrientation(this);
        (0, $1WEGH.default)._drawLabel.call(this);
    },
    hideInsideLabel: function(label, coord) {
        var graphicBBox = this._getGraphicBBox();
        var labelBBox = label.getBoundingRect();
        if (this._options.resolveLabelsOverlapping) {
            if ((coord.y <= graphicBBox.y && coord.y + labelBBox.height >= graphicBBox.y + graphicBBox.height || coord.x <= graphicBBox.x && coord.x + labelBBox.width >= graphicBBox.x + graphicBBox.width) && !(coord.y > graphicBBox.y + graphicBBox.height || coord.y + labelBBox.height < graphicBBox.y || coord.x > graphicBBox.x + graphicBBox.width || coord.x + labelBBox.width < graphicBBox.x)) {
                label.draw(false);
                return true;
            }
        }
        return false;
    },
    _showForZeroValues: function() {
        return this._options.label.showForZeroValues || this.initialValue;
    },
    _drawMarker (renderer, group, animationEnabled) {
        var style = this._getStyle();
        var r = this._options.cornerRadius;
        var rotated = this._options.rotated;
        var { x: x, y: y, width: width, height: height } = this.getMarkerCoords();
        if (animationEnabled) {
            if (rotated) {
                width = 0;
                x = this.defaultX;
            } else {
                height = 0;
                y = this.defaultY;
            }
        }
        this.graphic = renderer.rect(x, y, width, height).attr({
            rx: r,
            ry: r
        }).smartAttr(style).data({
            "chart-data-point": this
        }).append(group);
    },
    _getSettingsForTracker: function() {
        var y = this.y;
        var height = this.height;
        var x = this.x;
        var width = this.width;
        if (this._options.rotated) {
            if (1 === width) {
                width = $a8d7afe47a71f53a$var$DEFAULT_BAR_TRACKER_SIZE;
                x -= $a8d7afe47a71f53a$var$CORRECTING_BAR_TRACKER_VALUE;
            }
        } else if (1 === height) {
            height = $a8d7afe47a71f53a$var$DEFAULT_BAR_TRACKER_SIZE;
            y -= $a8d7afe47a71f53a$var$CORRECTING_BAR_TRACKER_VALUE;
        }
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    },
    getGraphicSettings: function() {
        var graphic = this.graphic;
        return {
            x: graphic.attr("x"),
            y: graphic.attr("y"),
            height: graphic.attr("height"),
            width: graphic.attr("width")
        };
    },
    _getEdgeTooltipParams () {
        var isPositive = this.value >= 0;
        var xCoord;
        var yCoord;
        var invertedBusinessRange = this._getValTranslator().getBusinessRange().invert;
        var { x: x, y: y, width: width, height: height } = this;
        if (this._options.rotated) {
            yCoord = y + height / 2;
            if (invertedBusinessRange) xCoord = isPositive ? x : x + width;
            else xCoord = isPositive ? x + width : x;
        } else {
            xCoord = x + width / 2;
            if (invertedBusinessRange) yCoord = isPositive ? y + height : y;
            else yCoord = isPositive ? y : y + height;
        }
        return {
            x: xCoord,
            y: yCoord,
            offset: 0
        };
    },
    getTooltipParams: function(location) {
        if ("edge" === location) return this._getEdgeTooltipParams();
        var center = this.getCenterCoord();
        center.offset = 0;
        return center;
    },
    getCenterCoord () {
        var { width: width, height: height, x: x, y: y } = this;
        return {
            x: x + width / 2,
            y: y + height / 2
        };
    },
    _truncateCoord: function(coord, bounds) {
        if (null === coord) return coord;
        if (coord < bounds[0]) return bounds[0];
        if (coord > bounds[1]) return bounds[1];
        return coord;
    },
    _getErrorBarBaseEdgeLength () {
        return this._options.rotated ? this.height : this.width;
    },
    _translateErrorBars: function(argVisibleArea) {
        (0, $1WEGH.default)._translateErrorBars.call(this);
        if (this._errorBarPos < argVisibleArea[0] || this._errorBarPos > argVisibleArea[1]) this._errorBarPos = void 0;
    },
    _translate: function() {
        var rotated = this._options.rotated;
        var valAxis = rotated ? "x" : "y";
        var argAxis = rotated ? "y" : "x";
        var valIntervalName = rotated ? "width" : "height";
        var argIntervalName = rotated ? "height" : "width";
        var argTranslator = this._getArgTranslator();
        var valTranslator = this._getValTranslator();
        var argVisibleArea = this.series.getArgumentAxis().getVisibleArea();
        var valVisibleArea = this.series.getValueAxis().getVisibleArea();
        var arg = argTranslator.translate(this.argument);
        var val = valTranslator.translate(this.value, 1);
        var minVal = valTranslator.translate(this.minValue, -1);
        this[argAxis] = arg = null === arg ? arg : arg + (this[argAxis + "Correction"] || 0);
        this["v" + valAxis] = val;
        this["v" + argAxis] = arg + this[argIntervalName] / 2;
        this._cacheVisibility(arg, val, minVal, rotated);
        val = this._truncateCoord(val, valVisibleArea);
        minVal = this._truncateCoord(minVal, valVisibleArea);
        this[valIntervalName] = $a8d7afe47a71f53a$var$_abs(val - minVal);
        val = val < minVal ? val : minVal;
        this[valAxis] = null === val ? val : val + (this[valAxis + "Correction"] || 0);
        this["min" + valAxis.toUpperCase()] = null === minVal ? minVal : minVal + (this[valAxis + "Correction"] || 0);
        this["default" + valAxis.toUpperCase()] = valTranslator.translate($a8d7afe47a71f53a$var$CANVAS_POSITION_DEFAULT);
        this._translateErrorBars(argVisibleArea);
        if (this.inVisibleArea && null !== this[argAxis]) {
            if (this[argAxis] < argVisibleArea[0]) {
                this[argIntervalName] = this[argIntervalName] - (argVisibleArea[0] - this[argAxis]);
                this[argAxis] = argVisibleArea[0];
            }
            if (this[argAxis] + this[argIntervalName] > argVisibleArea[1]) this[argIntervalName] = argVisibleArea[1] - this[argAxis];
        }
    },
    _updateMarker: function(animationEnabled, style) {
        this.graphic.smartAttr($a8d7afe47a71f53a$var$_extend({}, style, !animationEnabled ? this.getMarkerCoords() : {}));
    },
    getMarkerCoords: function() {
        var x = this.x;
        var y = this.y;
        var width = this.width;
        var height = this.height;
        var argAxis = this.series.getArgumentAxis();
        var rotated = this._options.rotated;
        if (argAxis.getAxisPosition) {
            var axisOptions = argAxis.getOptions();
            var edgeOffset = Math.round(axisOptions.width / 2);
            var argAxisPosition = argAxis.getAxisPosition();
            if (axisOptions.visible) {
                if (!rotated) {
                    height -= this.minY === this.defaultY && this.minY === argAxisPosition - argAxis.getAxisShift() ? edgeOffset : 0;
                    height < 0 && (height = 0);
                } else {
                    var isStartFromAxis = this.minX === this.defaultX && this.minX === argAxisPosition - argAxis.getAxisShift();
                    x += isStartFromAxis ? edgeOffset : 0;
                    width -= isStartFromAxis ? edgeOffset : 0;
                    width < 0 && (width = 0);
                }
            }
        }
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    },
    coordsIn: function(x, y) {
        return x >= this.x && x <= this.x + this.width && y >= this.y && y <= this.y + this.height;
    }
});

});

parcelRegister("9RPP9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72f1437409e4535f$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/series/points/bubble_point.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $1WEGH = parcelRequire("1WEGH");
var $72f1437409e4535f$var$_extend = (0, $2oTOp.extend);
var $72f1437409e4535f$var$MIN_BUBBLE_HEIGHT = 20;
var $72f1437409e4535f$export$2e2bcd8739ae039 = $72f1437409e4535f$var$_extend({}, (0, $1WEGH.default), {
    correctCoordinates: function(diameter) {
        this.bubbleSize = diameter / 2;
    },
    _drawMarker: function(renderer, group, animationEnabled) {
        var attr = $72f1437409e4535f$var$_extend({
            translateX: this.x,
            translateY: this.y
        }, this._getStyle());
        this.graphic = renderer.circle(0, 0, animationEnabled ? 0 : this.bubbleSize).smartAttr(attr).data({
            "chart-data-point": this
        }).append(group);
    },
    getTooltipParams: function(location) {
        var graphic = this.graphic;
        if (!graphic) return;
        var height = graphic.getBBox().height;
        return {
            x: this.x,
            y: this.y,
            offset: height < $72f1437409e4535f$var$MIN_BUBBLE_HEIGHT || "edge" === location ? height / 2 : 0
        };
    },
    _getLabelFormatObject: function() {
        var formatObject = (0, $1WEGH.default)._getLabelFormatObject.call(this);
        formatObject.size = this.initialSize;
        return formatObject;
    },
    _updateData: function(data) {
        (0, $1WEGH.default)._updateData.call(this, data);
        this.size = this.initialSize = data.size;
    },
    _getGraphicBBox: function() {
        return this._getSymbolBBox(this.x, this.y, this.bubbleSize);
    },
    _updateMarker: function(animationEnabled, style) {
        if (!animationEnabled) style = $72f1437409e4535f$var$_extend({
            r: this.bubbleSize,
            translateX: this.x,
            translateY: this.y
        }, style);
        this.graphic.smartAttr(style);
    },
    _getFormatObject: function(tooltip) {
        var formatObject = (0, $1WEGH.default)._getFormatObject.call(this, tooltip);
        formatObject.sizeText = tooltip.formatValue(this.initialSize);
        return formatObject;
    },
    _storeTrackerR: function() {
        return this.bubbleSize;
    },
    _getLabelCoords: function(label) {
        var coords;
        if ("inside" === label.getLayoutOptions().position) coords = this._getLabelCoordOfPosition(label, "inside");
        else coords = (0, $1WEGH.default)._getLabelCoords.call(this, label);
        return coords;
    }
});

});

parcelRegister("8kJfa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61134967c4b804fe$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/series/points/pie_point.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $1WEGH = parcelRequire("1WEGH");

var $dw9tZ = parcelRequire("dw9tZ");

var $6ntMu = parcelRequire("6ntMu");

var $8LJ26 = parcelRequire("8LJ26");
var $61134967c4b804fe$var$_extend = (0, $2oTOp.extend);
var $61134967c4b804fe$var$_round = Math.round;
var $61134967c4b804fe$var$_sqrt = Math.sqrt;
var $61134967c4b804fe$var$_acos = Math.acos;
var $61134967c4b804fe$var$DEG = 180 / Math.PI;
var $61134967c4b804fe$var$_abs = Math.abs;
var $61134967c4b804fe$var$RADIAL_LABEL_INDENT = (0, $8LJ26.default).radialLabelIndent;
var $61134967c4b804fe$export$2e2bcd8739ae039 = $61134967c4b804fe$var$_extend({}, (0, $1WEGH.default), {
    _updateData: function(data, argumentChanged) {
        (0, $1WEGH.default)._updateData.call(this, data);
        if (argumentChanged || !(0, $6ntMu.isDefined)(this._visible)) this._visible = true;
        this.minValue = this.initialMinValue = this.originalMinValue = (0, $6ntMu.isDefined)(data.minValue) ? data.minValue : 0;
    },
    animate: function(complete, duration, delay) {
        this.graphic.animate({
            x: this.centerX,
            y: this.centerY,
            outerRadius: this.radiusOuter,
            innerRadius: this.radiusInner,
            startAngle: this.toAngle,
            endAngle: this.fromAngle
        }, {
            delay: delay,
            partitionDuration: duration
        }, complete);
    },
    correctPosition: function(correction) {
        this.correctRadius(correction);
        this.correctLabelRadius(correction.radiusOuter + $61134967c4b804fe$var$RADIAL_LABEL_INDENT);
        this.centerX = correction.centerX;
        this.centerY = correction.centerY;
    },
    correctRadius: function(correction) {
        this.radiusInner = correction.radiusInner;
        this.radiusOuter = correction.radiusOuter;
    },
    correctLabelRadius: function(radiusLabels) {
        this.radiusLabels = radiusLabels;
    },
    correctValue: function(correction, percent, base) {
        this.value = (base || this.normalInitialValue) + correction;
        this.minValue = correction;
        this.percent = percent;
        this._label.setDataField("percent", percent);
    },
    _updateLabelData: function() {
        this._label.setData(this._getLabelFormatObject());
    },
    _getShiftLabelCoords: function() {
        var bBox = this._label.getBoundingRect();
        var coord = this._getLabelCoords(this._label);
        var visibleArea = this._getVisibleArea();
        if (this._isLabelDrawingWithoutPoints) return this._checkLabelPosition(coord, bBox, visibleArea);
        else return this._getLabelExtraCoord(coord, this._checkVerticalLabelPosition(coord, bBox, visibleArea), bBox);
    },
    _getLabelPosition: function(options) {
        return options.position;
    },
    getAnnotationCoords: function(location) {
        return this._getElementCoords("edge" !== location ? "inside" : "outside", this.radiusOuter, 0);
    },
    _getElementCoords: function(position, elementRadius, radialOffset) {
        var bBox = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        var that = this;
        var angleFunctions = (0, $dw9tZ.getCosAndSin)(that.middleAngle);
        var radiusInner = that.radiusInner;
        var radiusOuter = that.radiusOuter;
        var columnsPosition = "columns" === position;
        var rad;
        var x;
        if ("inside" === position) {
            rad = radiusInner + (radiusOuter - radiusInner) / 2 + radialOffset;
            x = that.centerX + rad * angleFunctions.cos - bBox.width / 2;
        } else {
            rad = elementRadius + radialOffset;
            if (angleFunctions.cos > .1 || columnsPosition && angleFunctions.cos >= 0) x = that.centerX + rad * angleFunctions.cos;
            else if (angleFunctions.cos < -0.1 || columnsPosition && angleFunctions.cos < 0) x = that.centerX + rad * angleFunctions.cos - bBox.width;
            else x = that.centerX + rad * angleFunctions.cos - bBox.width / 2;
        }
        return {
            x: x,
            y: $61134967c4b804fe$var$_round(that.centerY - rad * angleFunctions.sin - bBox.height / 2)
        };
    },
    _getLabelCoords: function(label) {
        var bBox = label.getBoundingRect();
        var options = label.getLayoutOptions();
        var position = this._getLabelPosition(options);
        return this._getElementCoords(position, this.radiusLabels, options.radialOffset, bBox);
    },
    _correctLabelCoord: function(coord, moveLabelsFromCenter) {
        var label = this._label;
        var bBox = label.getBoundingRect();
        var labelWidth = bBox.width;
        var options = label.getLayoutOptions();
        var visibleArea = this._getVisibleArea();
        var rightBorderX = visibleArea.maxX - labelWidth;
        var leftBorderX = visibleArea.minX;
        var angleOfPoint = (0, $dw9tZ.normalizeAngle)(this.middleAngle);
        var centerX = this.centerX;
        var connectorOffset = options.connectorOffset;
        var x = coord.x;
        if ("columns" === options.position) {
            if (angleOfPoint <= 90 || angleOfPoint >= 270) x = rightBorderX;
            else x = leftBorderX;
            coord.x = x;
        } else if ("inside" !== options.position && moveLabelsFromCenter) {
            if (angleOfPoint <= 90 || angleOfPoint >= 270) {
                if (x - connectorOffset < centerX) x = centerX + connectorOffset;
            } else if (x + labelWidth + connectorOffset > centerX) x = centerX - labelWidth - connectorOffset;
            coord.x = x;
        }
        return coord;
    },
    drawLabel: function() {
        this.translate();
        this._isLabelDrawingWithoutPoints = true;
        this._drawLabel();
        this._isLabelDrawingWithoutPoints = false;
    },
    updateLabelCoord: function(moveLabelsFromCenter) {
        var bBox = this._label.getBoundingRect();
        var coord = this._correctLabelCoord(bBox, moveLabelsFromCenter);
        coord = this._checkHorizontalLabelPosition(coord, bBox, this._getVisibleArea());
        this._label.shift($61134967c4b804fe$var$_round(coord.x), $61134967c4b804fe$var$_round(bBox.y));
    },
    _checkVerticalLabelPosition: function(coord, box, visibleArea) {
        var x = coord.x;
        var y = coord.y;
        if (coord.y + box.height > visibleArea.maxY) y = visibleArea.maxY - box.height;
        else if (coord.y < visibleArea.minY) y = visibleArea.minY;
        return {
            x: x,
            y: y
        };
    },
    _getLabelExtraCoord: function(coord, shiftCoord, box) {
        return coord.y !== shiftCoord.y ? (0, $dw9tZ.getVerticallyShiftedAngularCoords)({
            x: coord.x,
            y: coord.y,
            width: box.width,
            height: box.height
        }, shiftCoord.y - coord.y, {
            x: this.centerX,
            y: this.centerY
        }) : coord;
    },
    _checkHorizontalLabelPosition: function(coord, box, visibleArea) {
        var x = coord.x;
        var y = coord.y;
        if (coord.x + box.width > visibleArea.maxX) x = visibleArea.maxX - box.width;
        else if (coord.x < visibleArea.minX) x = visibleArea.minX;
        return {
            x: x,
            y: y
        };
    },
    applyWordWrap: function(moveLabelsFromCenter) {
        var label = this._label;
        var box = label.getBoundingRect();
        var visibleArea = this._getVisibleArea();
        var position = label.getLayoutOptions().position;
        var width = box.width;
        var rowCountChanged = false;
        if ("columns" === position && this.series.index > 0) width = visibleArea.maxX - this.centerX - this.radiusLabels;
        else if ("inside" === position) {
            if (width > visibleArea.maxX - visibleArea.minX) width = visibleArea.maxX - visibleArea.minX;
        } else if (moveLabelsFromCenter && box.x < this.centerX && box.width + box.x > this.centerX) width = Math.floor((visibleArea.maxX - visibleArea.minX) / 2);
        else if (box.x + width > visibleArea.maxX) width = visibleArea.maxX - box.x;
        else if (box.x < visibleArea.minX) width = box.x + width - visibleArea.minX;
        if (width < box.width) rowCountChanged = label.fit(width);
        return rowCountChanged;
    },
    setLabelTrackerData: function() {
        this._label.setTrackerData(this);
    },
    _checkLabelPosition: function(coord, bBox, visibleArea) {
        coord = this._checkHorizontalLabelPosition(coord, bBox, visibleArea);
        return this._checkVerticalLabelPosition(coord, bBox, visibleArea);
    },
    _getLabelConnector: function() {
        var rad = this.radiusOuter;
        var seriesStyle = this._options.styles.normal;
        var strokeWidthBy2 = seriesStyle["stroke-width"] / 2;
        var borderWidth = this.series.getOptions().containerBackgroundColor === seriesStyle.stroke ? $61134967c4b804fe$var$_round(strokeWidthBy2) : $61134967c4b804fe$var$_round(-strokeWidthBy2);
        var angleFunctions = (0, $dw9tZ.getCosAndSin)($61134967c4b804fe$var$_round(this.middleAngle));
        return {
            x: $61134967c4b804fe$var$_round(this.centerX + (rad - borderWidth) * angleFunctions.cos),
            y: $61134967c4b804fe$var$_round(this.centerY - (rad - borderWidth) * angleFunctions.sin),
            angle: this.middleAngle
        };
    },
    _drawMarker: function(renderer, group, animationEnabled, firstDrawing) {
        var radiusOuter = this.radiusOuter;
        var radiusInner = this.radiusInner;
        var fromAngle = this.fromAngle;
        var toAngle = this.toAngle;
        if (animationEnabled) {
            radiusInner = radiusOuter = 0;
            if (!firstDrawing) fromAngle = toAngle = this.shiftedAngle;
        }
        this.graphic = renderer.arc(this.centerX, this.centerY, radiusInner, radiusOuter, toAngle, fromAngle).attr({
            "stroke-linejoin": "round"
        }).smartAttr(this._getStyle()).data({
            "chart-data-point": this
        }).sharp().append(group);
    },
    getTooltipParams: function() {
        var angleFunctions = (0, $dw9tZ.getCosAndSin)(this.middleAngle);
        var radiusInner = this.radiusInner;
        var radiusOuter = this.radiusOuter;
        return {
            x: this.centerX + (radiusInner + (radiusOuter - radiusInner) / 2) * angleFunctions.cos,
            y: this.centerY - (radiusInner + (radiusOuter - radiusInner) / 2) * angleFunctions.sin,
            offset: 0
        };
    },
    _translate: function() {
        var angle = this.shiftedAngle || 0;
        var value = this.value;
        var minValue = this.minValue;
        var translator = this._getValTranslator();
        this.fromAngle = translator.translate(minValue) + angle;
        this.toAngle = translator.translate(value) + angle;
        this.middleAngle = translator.translate((value - minValue) / 2 + minValue) + angle;
        if (!this.isVisible()) this.middleAngle = this.toAngle = this.fromAngle = this.fromAngle || angle;
    },
    getMarkerVisibility: function() {
        return true;
    },
    _updateMarker: function(animationEnabled, style, _, callback) {
        if (!animationEnabled) style = $61134967c4b804fe$var$_extend({
            x: this.centerX,
            y: this.centerY,
            outerRadius: this.radiusOuter,
            innerRadius: this.radiusInner,
            startAngle: this.toAngle,
            endAngle: this.fromAngle
        }, style);
        this.graphic.smartAttr(style).sharp();
        callback && callback();
    },
    getLegendStyles: function() {
        return this._styles.legendStyles;
    },
    isInVisibleArea: function() {
        return true;
    },
    hide: function() {
        if (this._visible) {
            this._visible = false;
            this.hideTooltip();
            this._options.visibilityChanged();
        }
    },
    show: function() {
        if (!this._visible) {
            this._visible = true;
            this._options.visibilityChanged();
        }
    },
    setInvisibility: function() {
        this._label.draw(false);
    },
    isVisible: function() {
        return this._visible;
    },
    _getFormatObject: function(tooltip) {
        var formatObject = (0, $1WEGH.default)._getFormatObject.call(this, tooltip);
        var percent = this.percent;
        formatObject.percent = percent;
        formatObject.percentText = tooltip.formatValue(percent, "percent");
        return formatObject;
    },
    getColor: function() {
        return this._styles.normal.fill;
    },
    coordsIn: function(x, y) {
        var lx = x - this.centerX;
        var ly = y - this.centerY;
        var r = $61134967c4b804fe$var$_sqrt(lx * lx + ly * ly);
        var fromAngle = this.fromAngle % 360;
        var toAngle = this.toAngle % 360;
        var angle;
        if (r < this.radiusInner || r > this.radiusOuter || 0 === r) return false;
        angle = $61134967c4b804fe$var$_acos(lx / r) * $61134967c4b804fe$var$DEG * (ly > 0 ? -1 : 1);
        if (angle < 0) angle += 360;
        if (fromAngle === toAngle && $61134967c4b804fe$var$_abs(this.toAngle - this.fromAngle) > 1e-4) return true;
        else return fromAngle >= toAngle ? angle <= fromAngle && angle >= toAngle : !(angle >= fromAngle && angle <= toAngle);
    }
});

});

parcelRegister("gTntZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4c3ff92861a0a51$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/series/points/range_symbol_point.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $8OLOW = parcelRequire("8OLOW");

var $2oTOp = parcelRequire("2oTOp");

var $gcp4g = parcelRequire("gcp4g");

var $1RlWj = parcelRequire("1RlWj");

var $1WEGH = parcelRequire("1WEGH");

var $6ntMu = parcelRequire("6ntMu");
var $c4c3ff92861a0a51$var$_extend = (0, $2oTOp.extend);
var $c4c3ff92861a0a51$var$_math = Math;
var $c4c3ff92861a0a51$var$_abs = $c4c3ff92861a0a51$var$_math.abs;
var $c4c3ff92861a0a51$var$_min = $c4c3ff92861a0a51$var$_math.min;
var $c4c3ff92861a0a51$var$_max = $c4c3ff92861a0a51$var$_math.max;
var $c4c3ff92861a0a51$var$_round = $c4c3ff92861a0a51$var$_math.round;
var $c4c3ff92861a0a51$var$DEFAULT_IMAGE_WIDTH = 20;
var $c4c3ff92861a0a51$var$DEFAULT_IMAGE_HEIGHT = 20;
var $c4c3ff92861a0a51$export$2e2bcd8739ae039 = $c4c3ff92861a0a51$var$_extend({}, (0, $1WEGH.default), {
    deleteLabel: function() {
        this._topLabel.dispose();
        this._topLabel = null;
        this._bottomLabel.dispose();
        this._bottomLabel = null;
    },
    hideMarker: function(type) {
        var graphic = this.graphic;
        var marker = graphic && graphic[type + "Marker"];
        var label = this["_" + type + "Label"];
        if (marker && "hidden" !== marker.attr("visibility")) marker.attr({
            visibility: "hidden"
        });
        label.draw(false);
    },
    setInvisibility: function() {
        this.hideMarker("top");
        this.hideMarker("bottom");
    },
    clearVisibility: function() {
        var graphic = this.graphic;
        var topMarker = graphic && graphic.topMarker;
        var bottomMarker = graphic && graphic.bottomMarker;
        if (topMarker && topMarker.attr("visibility")) topMarker.attr({
            visibility: null
        });
        if (bottomMarker && bottomMarker.attr("visibility")) bottomMarker.attr({
            visibility: null
        });
    },
    clearMarker: function() {
        var graphic = this.graphic;
        var topMarker = graphic && graphic.topMarker;
        var bottomMarker = graphic && graphic.bottomMarker;
        var emptySettings = this._emptySettings;
        topMarker && topMarker.attr(emptySettings);
        bottomMarker && bottomMarker.attr(emptySettings);
    },
    _getLabelPosition: function(markerType) {
        var position;
        var labelsInside = "inside" === this._options.label.position;
        if (!this._options.rotated) position = "top" === markerType ^ labelsInside ? "top" : "bottom";
        else position = "top" === markerType ^ labelsInside ? "right" : "left";
        return position;
    },
    _getLabelMinFormatObject: function() {
        return {
            index: 0,
            argument: this.initialArgument,
            value: this.initialMinValue,
            seriesName: this.series.name,
            originalValue: this.originalMinValue,
            originalArgument: this.originalArgument,
            point: this
        };
    },
    _updateLabelData: function() {
        var maxFormatObject = this._getLabelFormatObject();
        maxFormatObject.index = 1;
        this._topLabel.setData(maxFormatObject);
        this._bottomLabel.setData(this._getLabelMinFormatObject());
    },
    _updateLabelOptions: function() {
        var options = this._options.label;
        (!this._topLabel || !this._bottomLabel) && this._createLabel();
        this._topLabel.setOptions(options);
        this._bottomLabel.setOptions(options);
    },
    _createLabel: function() {
        var options = {
            renderer: this.series._renderer,
            labelsGroup: this.series._labelsGroup,
            point: this
        };
        this._topLabel = new (0, $1RlWj.Label)(options);
        this._bottomLabel = new (0, $1RlWj.Label)(options);
    },
    _getGraphicBBox: function(location) {
        var options = this._options;
        var images = this._getImage(options.image);
        var image = "top" === location ? this._checkImage(images.top) : this._checkImage(images.bottom);
        var bBox;
        var coord = this._getPositionFromLocation(location);
        if (options.visible) bBox = image ? this._getImageBBox(coord.x, coord.y) : this._getSymbolBBox(coord.x, coord.y, options.styles.normal.r);
        else bBox = {
            x: coord.x,
            y: coord.y,
            width: 0,
            height: 0
        };
        return bBox;
    },
    _getPositionFromLocation: function(location) {
        var x;
        var y;
        var isTop = "top" === location;
        if (!this._options.rotated) {
            x = this.x;
            y = isTop ? $c4c3ff92861a0a51$var$_min(this.y, this.minY) : $c4c3ff92861a0a51$var$_max(this.y, this.minY);
        } else {
            x = isTop ? $c4c3ff92861a0a51$var$_max(this.x, this.minX) : $c4c3ff92861a0a51$var$_min(this.x, this.minX);
            y = this.y;
        }
        return {
            x: x,
            y: y
        };
    },
    _checkOverlay: function(bottomCoord, topCoord, topValue) {
        return bottomCoord < topCoord + topValue;
    },
    _getOverlayCorrections: function(topCoords, bottomCoords) {
        var rotated = this._options.rotated;
        var coordSelector = !rotated ? "y" : "x";
        var valueSelector = !rotated ? "height" : "width";
        var visibleArea = this.series.getValueAxis().getVisibleArea();
        var minBound = visibleArea[0];
        var maxBound = visibleArea[1];
        var delta = $c4c3ff92861a0a51$var$_round((topCoords[coordSelector] + topCoords[valueSelector] - bottomCoords[coordSelector]) / 2);
        var coord1 = topCoords[coordSelector] - delta;
        var coord2 = bottomCoords[coordSelector] + delta;
        if (coord1 < minBound) {
            delta = minBound - coord1;
            coord1 += delta;
            coord2 += delta;
        } else if (coord2 + bottomCoords[valueSelector] > maxBound) {
            delta = maxBound - coord2 - bottomCoords[valueSelector];
            coord1 += delta;
            coord2 += delta;
        }
        return {
            coord1: coord1,
            coord2: coord2
        };
    },
    _checkLabelsOverlay: function(topLocation) {
        var topCoords = this._topLabel.getBoundingRect();
        var bottomCoords = this._bottomLabel.getBoundingRect();
        var corrections = {};
        if (!this._options.rotated) {
            if ("top" === topLocation) {
                if (this._checkOverlay(bottomCoords.y, topCoords.y, topCoords.height)) {
                    corrections = this._getOverlayCorrections(topCoords, bottomCoords);
                    this._topLabel.shift(topCoords.x, corrections.coord1);
                    this._bottomLabel.shift(bottomCoords.x, corrections.coord2);
                }
            } else if (this._checkOverlay(topCoords.y, bottomCoords.y, bottomCoords.height)) {
                corrections = this._getOverlayCorrections(bottomCoords, topCoords);
                this._topLabel.shift(topCoords.x, corrections.coord2);
                this._bottomLabel.shift(bottomCoords.x, corrections.coord1);
            }
        } else if ("top" === topLocation) {
            if (this._checkOverlay(topCoords.x, bottomCoords.x, bottomCoords.width)) {
                corrections = this._getOverlayCorrections(bottomCoords, topCoords);
                this._topLabel.shift(corrections.coord2, topCoords.y);
                this._bottomLabel.shift(corrections.coord1, bottomCoords.y);
            }
        } else if (this._checkOverlay(bottomCoords.x, topCoords.x, topCoords.width)) {
            corrections = this._getOverlayCorrections(topCoords, bottomCoords);
            this._topLabel.shift(corrections.coord1, topCoords.y);
            this._bottomLabel.shift(corrections.coord2, bottomCoords.y);
        }
    },
    _drawLabel: function() {
        var labels = [];
        var notInverted = this._options.rotated ? this.x >= this.minX : this.y < this.minY;
        var customVisibility = this._getCustomLabelVisibility();
        var topLabel = this._topLabel;
        var bottomLabel = this._bottomLabel;
        topLabel.pointPosition = notInverted ? "top" : "bottom";
        bottomLabel.pointPosition = notInverted ? "bottom" : "top";
        if ((this.series.getLabelVisibility() || customVisibility) && this.hasValue() && false !== customVisibility) {
            false !== this.visibleTopMarker && labels.push(topLabel);
            false !== this.visibleBottomMarker && labels.push(bottomLabel);
            (0, $8OLOW.each)(labels, function(_, label) {
                label.draw(true);
            });
            this._checkLabelsOverlay(this._topLabel.pointPosition);
        } else {
            topLabel.draw(false);
            bottomLabel.draw(false);
        }
    },
    _getImage: function(imageOption) {
        var image = {};
        if ((0, $6ntMu.isDefined)(imageOption)) {
            if ("string" === typeof imageOption) image.top = image.bottom = imageOption;
            else {
                image.top = {
                    url: "string" === typeof imageOption.url ? imageOption.url : imageOption.url && imageOption.url.rangeMaxPoint,
                    width: "number" === typeof imageOption.width ? imageOption.width : imageOption.width && imageOption.width.rangeMaxPoint,
                    height: "number" === typeof imageOption.height ? imageOption.height : imageOption.height && imageOption.height.rangeMaxPoint
                };
                image.bottom = {
                    url: "string" === typeof imageOption.url ? imageOption.url : imageOption.url && imageOption.url.rangeMinPoint,
                    width: "number" === typeof imageOption.width ? imageOption.width : imageOption.width && imageOption.width.rangeMinPoint,
                    height: "number" === typeof imageOption.height ? imageOption.height : imageOption.height && imageOption.height.rangeMinPoint
                };
            }
        }
        return image;
    },
    _checkSymbol: function(oldOptions, newOptions) {
        var oldSymbol = oldOptions.symbol;
        var newSymbol = newOptions.symbol;
        var symbolChanged = "circle" === oldSymbol && "circle" !== newSymbol || "circle" !== oldSymbol && "circle" === newSymbol;
        var oldImages = this._getImage(oldOptions.image);
        var newImages = this._getImage(newOptions.image);
        var topImageChanged = this._checkImage(oldImages.top) !== this._checkImage(newImages.top);
        var bottomImageChanged = this._checkImage(oldImages.bottom) !== this._checkImage(newImages.bottom);
        return symbolChanged || topImageChanged || bottomImageChanged;
    },
    _getSettingsForTwoMarkers: function(style) {
        var options = this._options;
        var settings = {};
        var x = options.rotated ? $c4c3ff92861a0a51$var$_min(this.x, this.minX) : this.x;
        var y = options.rotated ? this.y : $c4c3ff92861a0a51$var$_min(this.y, this.minY);
        var radius = style.r;
        var points = this._populatePointShape(options.symbol, radius);
        settings.top = $c4c3ff92861a0a51$var$_extend({
            translateX: x + this.width,
            translateY: y,
            r: radius
        }, style);
        settings.bottom = $c4c3ff92861a0a51$var$_extend({
            translateX: x,
            translateY: y + this.height,
            r: radius
        }, style);
        if (points) settings.top.points = settings.bottom.points = points;
        return settings;
    },
    _hasGraphic: function() {
        return this.graphic && this.graphic.topMarker && this.graphic.bottomMarker;
    },
    _drawOneMarker: function(renderer, markerType, imageSettings, settings) {
        var graphic = this.graphic;
        if (graphic[markerType]) this._updateOneMarker(markerType, settings);
        else graphic[markerType] = this._createMarker(renderer, graphic, imageSettings, settings);
    },
    _drawMarker: function(renderer, group, animationEnabled, firstDrawing, style) {
        var settings = this._getSettingsForTwoMarkers(style || this._getStyle());
        var image = this._getImage(this._options.image);
        if (this._checkImage(image.top)) settings.top = this._getImageSettings(settings.top, image.top);
        if (this._checkImage(image.bottom)) settings.bottom = this._getImageSettings(settings.bottom, image.bottom);
        this.graphic = this.graphic || renderer.g().append(group);
        this.visibleTopMarker && this._drawOneMarker(renderer, "topMarker", image.top, settings.top);
        this.visibleBottomMarker && this._drawOneMarker(renderer, "bottomMarker", image.bottom, settings.bottom);
    },
    _getSettingsForTracker: function(radius) {
        var rotated = this._options.rotated;
        return {
            translateX: rotated ? $c4c3ff92861a0a51$var$_min(this.x, this.minX) - radius : this.x - radius,
            translateY: rotated ? this.y - radius : $c4c3ff92861a0a51$var$_min(this.y, this.minY) - radius,
            width: this.width + 2 * radius,
            height: this.height + 2 * radius
        };
    },
    isInVisibleArea: function() {
        var rotated = this._options.rotated;
        var argument = !rotated ? this.x : this.y;
        var maxValue = !rotated ? $c4c3ff92861a0a51$var$_max(this.minY, this.y) : $c4c3ff92861a0a51$var$_max(this.minX, this.x);
        var minValue = !rotated ? $c4c3ff92861a0a51$var$_min(this.minY, this.y) : $c4c3ff92861a0a51$var$_min(this.minX, this.x);
        var tmp;
        var visibleTopMarker;
        var visibleBottomMarker;
        var visibleRangeArea = true;
        var visibleArgArea = this.series.getArgumentAxis().getVisibleArea();
        var visibleValArea = this.series.getValueAxis().getVisibleArea();
        var notVisibleByArg = visibleArgArea[1] < argument || visibleArgArea[0] > argument;
        var notVisibleByVal = visibleValArea[0] > minValue && visibleValArea[0] > maxValue || visibleValArea[1] < minValue && visibleValArea[1] < maxValue;
        if (notVisibleByArg || notVisibleByVal) visibleTopMarker = visibleBottomMarker = visibleRangeArea = false;
        else {
            visibleTopMarker = visibleValArea[0] <= minValue && visibleValArea[1] > minValue;
            visibleBottomMarker = visibleValArea[0] < maxValue && visibleValArea[1] >= maxValue;
            if (rotated) {
                tmp = visibleTopMarker;
                visibleTopMarker = visibleBottomMarker;
                visibleBottomMarker = tmp;
            }
        }
        this.visibleTopMarker = visibleTopMarker;
        this.visibleBottomMarker = visibleBottomMarker;
        return visibleRangeArea;
    },
    getTooltipParams: function() {
        var x;
        var y;
        var rotated = this._options.rotated;
        var minValue = !rotated ? $c4c3ff92861a0a51$var$_min(this.y, this.minY) : $c4c3ff92861a0a51$var$_min(this.x, this.minX);
        var side = !rotated ? "height" : "width";
        var visibleArea = this._getVisibleArea();
        var minVisible = rotated ? visibleArea.minX : visibleArea.minY;
        var maxVisible = rotated ? visibleArea.maxX : visibleArea.maxY;
        var min = $c4c3ff92861a0a51$var$_max(minVisible, minValue);
        var max = $c4c3ff92861a0a51$var$_min(maxVisible, minValue + this[side]);
        if (!rotated) {
            x = this.x;
            y = min + (max - min) / 2;
        } else {
            y = this.y;
            x = min + (max - min) / 2;
        }
        return {
            x: x,
            y: y,
            offset: 0
        };
    },
    _translate: function() {
        var rotated = this._options.rotated;
        (0, $1WEGH.default)._translate.call(this);
        this.height = rotated ? 0 : $c4c3ff92861a0a51$var$_abs(this.minY - this.y);
        this.width = rotated ? $c4c3ff92861a0a51$var$_abs(this.x - this.minX) : 0;
    },
    hasCoords: function() {
        return (0, $1WEGH.default).hasCoords.call(this) && !(null === this.minX || null === this.minY);
    },
    _updateData: function(data) {
        (0, $1WEGH.default)._updateData.call(this, data);
        this.minValue = this.initialMinValue = this.originalMinValue = data.minValue;
    },
    _getImageSettings: function(settings, image) {
        return {
            href: image.url || image.toString(),
            width: image.width || $c4c3ff92861a0a51$var$DEFAULT_IMAGE_WIDTH,
            height: image.height || $c4c3ff92861a0a51$var$DEFAULT_IMAGE_HEIGHT,
            translateX: settings.translateX,
            translateY: settings.translateY
        };
    },
    getCrosshairData: function(x, y) {
        var rotated = this._options.rotated;
        var minX = this.minX;
        var minY = this.minY;
        var vx = this.vx;
        var vy = this.vy;
        var value = this.value;
        var minValue = this.minValue;
        var argument = this.argument;
        var coords = {
            axis: this.series.axis,
            x: vx,
            y: vy,
            yValue: value,
            xValue: argument
        };
        if (rotated) {
            coords.yValue = argument;
            if ($c4c3ff92861a0a51$var$_abs(vx - x) < $c4c3ff92861a0a51$var$_abs(minX - x)) coords.xValue = value;
            else {
                coords.x = minX;
                coords.xValue = minValue;
            }
        } else if ($c4c3ff92861a0a51$var$_abs(vy - y) >= $c4c3ff92861a0a51$var$_abs(minY - y)) {
            coords.y = minY;
            coords.yValue = minValue;
        }
        return coords;
    },
    _updateOneMarker: function(markerType, settings) {
        this.graphic && this.graphic[markerType] && this.graphic[markerType].attr(settings);
    },
    _updateMarker: function(animationEnabled, style) {
        this._drawMarker(void 0, void 0, false, false, style);
    },
    _getFormatObject: function(tooltip) {
        var initialMinValue = this.initialMinValue;
        var initialValue = this.initialValue;
        var initialArgument = this.initialArgument;
        var minValue = tooltip.formatValue(initialMinValue);
        var value = tooltip.formatValue(initialValue);
        return {
            argument: initialArgument,
            argumentText: tooltip.formatValue(initialArgument, "argument"),
            valueText: minValue + " - " + value,
            rangeValue1Text: minValue,
            rangeValue2Text: value,
            rangeValue1: initialMinValue,
            rangeValue2: initialValue,
            seriesName: this.series.name,
            point: this,
            originalMinValue: this.originalMinValue,
            originalValue: this.originalValue,
            originalArgument: this.originalArgument
        };
    },
    getLabel: function() {
        return [
            this._topLabel,
            this._bottomLabel
        ];
    },
    getLabels: function() {
        return [
            this._topLabel,
            this._bottomLabel
        ];
    },
    getBoundingRect: (0, $gcp4g.noop),
    coordsIn: function(x, y) {
        var trackerRadius = this._storeTrackerR();
        var xCond = x >= this.x - trackerRadius && x <= this.x + trackerRadius;
        var yCond = y >= this.y - trackerRadius && y <= this.y + trackerRadius;
        if (this._options.rotated) return yCond && (xCond || x >= this.minX - trackerRadius && x <= this.minX + trackerRadius);
        else return xCond && (yCond || y >= this.minY - trackerRadius && y <= this.minY + trackerRadius);
    },
    getMaxValue: function() {
        if ("discrete" !== this.series.valueAxisType) return this.minValue > this.value ? this.minValue : this.value;
        return this.value;
    },
    getMinValue: function() {
        if ("discrete" !== this.series.valueAxisType) return this.minValue < this.value ? this.minValue : this.value;
        return this.minValue;
    }
});

});

parcelRegister("jIcUg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e59c235932214872$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/series/points/range_bar_point.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $gcp4g = parcelRequire("gcp4g");

var $2oTOp = parcelRequire("2oTOp");

var $euKb3 = parcelRequire("euKb3");

var $gTntZ = parcelRequire("gTntZ");
var $e59c235932214872$var$_extend = (0, $2oTOp.extend);
var $e59c235932214872$export$2e2bcd8739ae039 = $e59c235932214872$var$_extend({}, (0, $euKb3.default), {
    deleteLabel: (0, $gTntZ.default).deleteLabel,
    _getFormatObject: (0, $gTntZ.default)._getFormatObject,
    clearVisibility: function() {
        var graphic = this.graphic;
        if (graphic && graphic.attr("visibility")) graphic.attr({
            visibility: null
        });
    },
    setInvisibility: function() {
        var graphic = this.graphic;
        if (graphic && "hidden" !== graphic.attr("visibility")) graphic.attr({
            visibility: "hidden"
        });
        this._topLabel.draw(false);
        this._bottomLabel.draw(false);
    },
    getTooltipParams: function(location) {
        var edgeLocation = "edge" === location;
        var x;
        var y;
        if (this._options.rotated) {
            x = edgeLocation ? this.x + this.width : this.x + this.width / 2;
            y = this.y + this.height / 2;
        } else {
            x = this.x + this.width / 2;
            y = edgeLocation ? this.y : this.y + this.height / 2;
        }
        return {
            x: x,
            y: y,
            offset: 0
        };
    },
    _translate: function() {
        var barMethods = (0, $euKb3.default);
        barMethods._translate.call(this);
        if (this._options.rotated) this.width = this.width || 1;
        else this.height = this.height || 1;
    },
    hasCoords: (0, $gTntZ.default).hasCoords,
    _updateData: (0, $gTntZ.default)._updateData,
    _getLabelPosition: (0, $gTntZ.default)._getLabelPosition,
    _getLabelMinFormatObject: (0, $gTntZ.default)._getLabelMinFormatObject,
    _updateLabelData: (0, $gTntZ.default)._updateLabelData,
    _updateLabelOptions: (0, $gTntZ.default)._updateLabelOptions,
    getCrosshairData: (0, $gTntZ.default).getCrosshairData,
    _createLabel: (0, $gTntZ.default)._createLabel,
    _checkOverlay: (0, $gTntZ.default)._checkOverlay,
    _checkLabelsOverlay: (0, $gTntZ.default)._checkLabelsOverlay,
    _getOverlayCorrections: (0, $gTntZ.default)._getOverlayCorrections,
    _drawLabel: (0, $gTntZ.default)._drawLabel,
    _getLabelCoords: (0, $gTntZ.default)._getLabelCoords,
    getLabel: (0, $gTntZ.default).getLabel,
    getLabels: (0, $gTntZ.default).getLabels,
    getBoundingRect: (0, $gcp4g.noop),
    getMinValue: (0, $gTntZ.default).getMinValue,
    getMaxValue: (0, $gTntZ.default).getMaxValue
});

});

parcelRegister("1RF3f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15ba95a2f40b0a5f$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/series/points/candlestick_point.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $1WEGH = parcelRequire("1WEGH");

var $euKb3 = parcelRequire("euKb3");
var $15ba95a2f40b0a5f$var$_math = Math;
var $15ba95a2f40b0a5f$var$_abs = $15ba95a2f40b0a5f$var$_math.abs;
var $15ba95a2f40b0a5f$var$_min = $15ba95a2f40b0a5f$var$_math.min;
var $15ba95a2f40b0a5f$var$_max = $15ba95a2f40b0a5f$var$_math.max;
var $15ba95a2f40b0a5f$var$_round = $15ba95a2f40b0a5f$var$_math.round;
var $15ba95a2f40b0a5f$var$DEFAULT_FINANCIAL_TRACKER_MARGIN = 2;
var $15ba95a2f40b0a5f$export$2e2bcd8739ae039 = (0, $2oTOp.extend)({}, (0, $euKb3.default), {
    _calculateVisibility: (0, $1WEGH.default)._calculateVisibility,
    _getContinuousPoints: function(openCoord, closeCoord) {
        var x = this.x;
        var createPoint = this._options.rotated ? function(x, y) {
            return [
                y,
                x
            ];
        } : function(x, y) {
            return [
                x,
                y
            ];
        };
        var width = this.width;
        var highCoord = this.highY;
        var max = $15ba95a2f40b0a5f$var$_abs(highCoord - openCoord) < $15ba95a2f40b0a5f$var$_abs(highCoord - closeCoord) ? openCoord : closeCoord;
        var min = max === closeCoord ? openCoord : closeCoord;
        var points;
        if (min === max) points = [].concat(createPoint(x, this.highY)).concat(createPoint(x, this.lowY)).concat(createPoint(x, this.closeY)).concat(createPoint(x - width / 2, this.closeY)).concat(createPoint(x + width / 2, this.closeY)).concat(createPoint(x, this.closeY));
        else points = [].concat(createPoint(x, this.highY)).concat(createPoint(x, max)).concat(createPoint(x + width / 2, max)).concat(createPoint(x + width / 2, min)).concat(createPoint(x, min)).concat(createPoint(x, this.lowY)).concat(createPoint(x, min)).concat(createPoint(x - width / 2, min)).concat(createPoint(x - width / 2, max)).concat(createPoint(x, max));
        return points;
    },
    _getCrockPoints: function(y) {
        var x = this.x;
        var createPoint = this._options.rotated ? function(x, y) {
            return [
                y,
                x
            ];
        } : function(x, y) {
            return [
                x,
                y
            ];
        };
        return [].concat(createPoint(x, this.highY)).concat(createPoint(x, this.lowY)).concat(createPoint(x, y)).concat(createPoint(x - this.width / 2, y)).concat(createPoint(x + this.width / 2, y)).concat(createPoint(x, y));
    },
    _getPoints: function() {
        var points;
        var closeCoord = this.closeY;
        var openCoord = this.openY;
        if (null !== closeCoord && null !== openCoord) points = this._getContinuousPoints(openCoord, closeCoord);
        else if (openCoord === closeCoord) points = [
            this.x,
            this.highY,
            this.x,
            this.lowY
        ];
        else points = this._getCrockPoints(null !== openCoord ? openCoord : closeCoord);
        return points;
    },
    getColor: function() {
        return this._isReduction ? this._options.reduction.color : this._styles.normal.stroke || this.series.getColor();
    },
    _drawMarkerInGroup: function(group, attributes, renderer) {
        this.graphic = renderer.path(this._getPoints(), "area").attr({
            "stroke-linecap": "square"
        }).attr(attributes).data({
            "chart-data-point": this
        }).sharp().append(group);
    },
    _fillStyle: function() {
        var styles = this._options.styles;
        if (this._isReduction && this._isPositive) this._styles = styles.reductionPositive;
        else if (this._isReduction) this._styles = styles.reduction;
        else if (this._isPositive) this._styles = styles.positive;
        else this._styles = styles;
    },
    _getMinTrackerWidth: function() {
        return 2 + 2 * this._styles.normal["stroke-width"];
    },
    correctCoordinates: function(correctOptions) {
        var minWidth = this._getMinTrackerWidth();
        var width = correctOptions.width;
        width = width < minWidth ? minWidth : width > 10 ? 10 : width;
        this.width = width + width % 2;
        this.xCorrection = correctOptions.offset;
    },
    _getMarkerGroup: function(group) {
        var markerGroup;
        if (this._isReduction && this._isPositive) markerGroup = group.reductionPositiveMarkersGroup;
        else if (this._isReduction) markerGroup = group.reductionMarkersGroup;
        else if (this._isPositive) markerGroup = group.defaultPositiveMarkersGroup;
        else markerGroup = group.defaultMarkersGroup;
        return markerGroup;
    },
    _drawMarker: function(renderer, group) {
        this._drawMarkerInGroup(this._getMarkerGroup(group), this._getStyle(), renderer);
    },
    _getSettingsForTracker: function() {
        var highY = this.highY;
        var lowY = this.lowY;
        var rotated = this._options.rotated;
        var x;
        var y;
        var width;
        var height;
        if (highY === lowY) {
            highY = rotated ? highY + $15ba95a2f40b0a5f$var$DEFAULT_FINANCIAL_TRACKER_MARGIN : highY - $15ba95a2f40b0a5f$var$DEFAULT_FINANCIAL_TRACKER_MARGIN;
            lowY = rotated ? lowY - $15ba95a2f40b0a5f$var$DEFAULT_FINANCIAL_TRACKER_MARGIN : lowY + $15ba95a2f40b0a5f$var$DEFAULT_FINANCIAL_TRACKER_MARGIN;
        }
        if (rotated) {
            x = $15ba95a2f40b0a5f$var$_min(lowY, highY);
            y = this.x - this.width / 2;
            width = $15ba95a2f40b0a5f$var$_abs(lowY - highY);
            height = this.width;
        } else {
            x = this.x - this.width / 2;
            y = $15ba95a2f40b0a5f$var$_min(lowY, highY);
            width = this.width;
            height = $15ba95a2f40b0a5f$var$_abs(lowY - highY);
        }
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    },
    _getGraphicBBox: function(location) {
        var rotated = this._options.rotated;
        var x = this.x;
        var width = this.width;
        var lowY = this.lowY;
        var highY = this.highY;
        if (location) {
            var valVisibleArea = this.series.getValueAxis().getVisibleArea();
            highY = this._truncateCoord(highY, valVisibleArea);
            lowY = this._truncateCoord(lowY, valVisibleArea);
        }
        var bBox = {
            x: !rotated ? x - $15ba95a2f40b0a5f$var$_round(width / 2) : lowY,
            y: !rotated ? highY : x - $15ba95a2f40b0a5f$var$_round(width / 2),
            width: !rotated ? width : highY - lowY,
            height: !rotated ? lowY - highY : width
        };
        if (location) {
            var isTop = "top" === location;
            if (!this._options.rotated) {
                bBox.y = isTop ? bBox.y : bBox.y + bBox.height;
                bBox.height = 0;
            } else {
                bBox.x = isTop ? bBox.x + bBox.width : bBox.x;
                bBox.width = 0;
            }
        }
        return bBox;
    },
    getTooltipParams: function(location) {
        if (this.graphic) {
            var minValue = $15ba95a2f40b0a5f$var$_min(this.lowY, this.highY);
            var maxValue = $15ba95a2f40b0a5f$var$_max(this.lowY, this.highY);
            var visibleArea = this._getVisibleArea();
            var rotated = this._options.rotated;
            var minVisible = rotated ? visibleArea.minX : visibleArea.minY;
            var maxVisible = rotated ? visibleArea.maxX : visibleArea.maxY;
            var min = $15ba95a2f40b0a5f$var$_max(minVisible, minValue);
            var max = $15ba95a2f40b0a5f$var$_min(maxVisible, maxValue);
            var centerCoord = this.getCenterCoord();
            if ("edge" === location) centerCoord[rotated ? "x" : "y"] = rotated ? max : min;
            centerCoord.offset = 0;
            return centerCoord;
        }
    },
    getCenterCoord () {
        if (this.graphic) {
            var x;
            var y;
            var minValue = $15ba95a2f40b0a5f$var$_min(this.lowY, this.highY);
            var maxValue = $15ba95a2f40b0a5f$var$_max(this.lowY, this.highY);
            var visibleArea = this._getVisibleArea();
            var rotated = this._options.rotated;
            var minVisible = rotated ? visibleArea.minX : visibleArea.minY;
            var maxVisible = rotated ? visibleArea.maxX : visibleArea.maxY;
            var min = $15ba95a2f40b0a5f$var$_max(minVisible, minValue);
            var max = $15ba95a2f40b0a5f$var$_min(maxVisible, maxValue);
            var center = min + (max - min) / 2;
            if (rotated) {
                y = this.x;
                x = center;
            } else {
                x = this.x;
                y = center;
            }
            return {
                x: x,
                y: y
            };
        }
    },
    hasValue: function() {
        return null !== this.highValue && null !== this.lowValue;
    },
    hasCoords: function() {
        return null !== this.x && null !== this.lowY && null !== this.highY;
    },
    _translate: function() {
        var rotated = this._options.rotated;
        var valTranslator = this._getValTranslator();
        var x = this._getArgTranslator().translate(this.argument);
        this.vx = this.vy = this.x = null === x ? x : x + (this.xCorrection || 0);
        this.openY = null !== this.openValue ? valTranslator.translate(this.openValue) : null;
        this.highY = valTranslator.translate(this.highValue);
        this.lowY = valTranslator.translate(this.lowValue);
        this.closeY = null !== this.closeValue ? valTranslator.translate(this.closeValue) : null;
        var centerValue = $15ba95a2f40b0a5f$var$_min(this.lowY, this.highY) + $15ba95a2f40b0a5f$var$_abs(this.lowY - this.highY) / 2;
        this._calculateVisibility(!rotated ? this.x : centerValue, !rotated ? centerValue : this.x);
    },
    getCrosshairData: function(x, y) {
        var rotated = this._options.rotated;
        var origY = rotated ? x : y;
        var yValue;
        var argument = this.argument;
        var coords;
        var coord = "low";
        if ($15ba95a2f40b0a5f$var$_abs(this.lowY - origY) < $15ba95a2f40b0a5f$var$_abs(this.closeY - origY)) yValue = this.lowY;
        else {
            yValue = this.closeY;
            coord = "close";
        }
        if ($15ba95a2f40b0a5f$var$_abs(yValue - origY) >= $15ba95a2f40b0a5f$var$_abs(this.openY - origY)) {
            yValue = this.openY;
            coord = "open";
        }
        if ($15ba95a2f40b0a5f$var$_abs(yValue - origY) >= $15ba95a2f40b0a5f$var$_abs(this.highY - origY)) {
            yValue = this.highY;
            coord = "high";
        }
        if (rotated) coords = {
            y: this.vy,
            x: yValue,
            xValue: this[coord + "Value"],
            yValue: argument
        };
        else coords = {
            x: this.vx,
            y: yValue,
            xValue: argument,
            yValue: this[coord + "Value"]
        };
        coords.axis = this.series.axis;
        return coords;
    },
    _updateData: function(data) {
        var label = this._label;
        var reductionColor = this._options.reduction.color;
        this.value = this.initialValue = data.reductionValue;
        this.originalValue = data.value;
        this.lowValue = this.originalLowValue = data.lowValue;
        this.highValue = this.originalHighValue = data.highValue;
        this.openValue = this.originalOpenValue = data.openValue;
        this.closeValue = this.originalCloseValue = data.closeValue;
        this._isPositive = data.openValue < data.closeValue;
        this._isReduction = data.isReduction;
        if (this._isReduction) label.setColor(reductionColor);
    },
    _updateMarker: function(animationEnabled, style, group) {
        var graphic = this.graphic;
        graphic.attr({
            points: this._getPoints()
        }).smartAttr(style).sharp();
        group && graphic.append(this._getMarkerGroup(group));
    },
    _getLabelFormatObject: function() {
        return {
            openValue: this.openValue,
            highValue: this.highValue,
            lowValue: this.lowValue,
            closeValue: this.closeValue,
            reductionValue: this.initialValue,
            argument: this.initialArgument,
            value: this.initialValue,
            seriesName: this.series.name,
            originalOpenValue: this.originalOpenValue,
            originalCloseValue: this.originalCloseValue,
            originalLowValue: this.originalLowValue,
            originalHighValue: this.originalHighValue,
            originalArgument: this.originalArgument,
            point: this
        };
    },
    _getFormatObject: function(tooltip) {
        var highValue = tooltip.formatValue(this.highValue);
        var openValue = tooltip.formatValue(this.openValue);
        var closeValue = tooltip.formatValue(this.closeValue);
        var lowValue = tooltip.formatValue(this.lowValue);
        var symbolMethods = (0, $1WEGH.default);
        var formatObject = symbolMethods._getFormatObject.call(this, tooltip);
        return (0, $2oTOp.extend)({}, formatObject, {
            valueText: "h: " + highValue + ("" !== openValue ? " o: " + openValue : "") + ("" !== closeValue ? " c: " + closeValue : "") + " l: " + lowValue,
            highValueText: highValue,
            openValueText: openValue,
            closeValueText: closeValue,
            lowValueText: lowValue
        });
    },
    getMaxValue: function() {
        return this.highValue;
    },
    getMinValue: function() {
        return this.lowValue;
    }
});

});

parcelRegister("6fkLT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48c4418e329e7f13$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/series/points/stock_point.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $6ntMu = parcelRequire("6ntMu");

var $1RF3f = parcelRequire("1RF3f");
var $48c4418e329e7f13$var$_extend = (0, $2oTOp.extend);
var $48c4418e329e7f13$var$_isNumeric = (0, $6ntMu.isNumeric);
var $48c4418e329e7f13$export$2e2bcd8739ae039 = $48c4418e329e7f13$var$_extend({}, (0, $1RF3f.default), {
    _getPoints: function() {
        var createPoint = this._options.rotated ? function(x, y) {
            return [
                y,
                x
            ];
        } : function(x, y) {
            return [
                x,
                y
            ];
        };
        var openYExist = $48c4418e329e7f13$var$_isNumeric(this.openY);
        var closeYExist = $48c4418e329e7f13$var$_isNumeric(this.closeY);
        var x = this.x;
        var width = this.width;
        var points = [].concat(createPoint(x, this.highY));
        openYExist && (points = points.concat(createPoint(x, this.openY)));
        openYExist && (points = points.concat(createPoint(x - width / 2, this.openY)));
        openYExist && (points = points.concat(createPoint(x, this.openY)));
        closeYExist && (points = points.concat(createPoint(x, this.closeY)));
        closeYExist && (points = points.concat(createPoint(x + width / 2, this.closeY)));
        closeYExist && (points = points.concat(createPoint(x, this.closeY)));
        points = points.concat(createPoint(x, this.lowY));
        return points;
    },
    _drawMarkerInGroup: function(group, attributes, renderer) {
        this.graphic = renderer.path(this._getPoints(), "line").attr({
            "stroke-linecap": "square"
        }).attr(attributes).data({
            "chart-data-point": this
        }).sharp().append(group);
    },
    _getMinTrackerWidth: function() {
        var width = 2 + this._styles.normal["stroke-width"];
        return width + width % 2;
    }
});

});

parcelRegister("9DReF", function(module, exports) {

$parcel$export(module.exports, "polarSymbolPoint", function () { return $70510d0998f30964$export$9f8f1e63c5efd409; });
$parcel$export(module.exports, "polarBarPoint", function () { return $70510d0998f30964$export$906b69c9a059c86a; });
/**
 * DevExtreme (esm/viz/series/points/polar_point.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $1WEGH = parcelRequire("1WEGH");

var $euKb3 = parcelRequire("euKb3");

var $8kJfa = parcelRequire("8kJfa");

var $6ntMu = parcelRequire("6ntMu");

var $dw9tZ = parcelRequire("dw9tZ");

var $8LJ26 = parcelRequire("8LJ26");
var $70510d0998f30964$var$_extend = (0, $2oTOp.extend);
var $70510d0998f30964$var$_math = Math;
var $70510d0998f30964$var$_max = $70510d0998f30964$var$_math.max;
var $70510d0998f30964$var$RADIAL_LABEL_INDENT = (0, $8LJ26.default).radialLabelIndent;
var $70510d0998f30964$var$ERROR_BARS_ANGLE_OFFSET = 90;
var $70510d0998f30964$var$CANVAS_POSITION_START = "canvas_position_start";
var $70510d0998f30964$var$CANVAS_POSITION_END = "canvas_position_end";
var $70510d0998f30964$var$CANVAS_POSITION_DEFAULT = "canvas_position_default";
var $70510d0998f30964$export$9f8f1e63c5efd409 = $70510d0998f30964$var$_extend({}, (0, $1WEGH.default), {
    _getLabelCoords: (0, $8kJfa.default)._getLabelCoords,
    _getElementCoords: (0, $8kJfa.default)._getElementCoords,
    _moveLabelOnCanvas: function(coord, visibleArea, labelBBox) {
        var x = coord.x;
        var y = coord.y;
        if (visibleArea.minX > x) x = visibleArea.minX;
        if (visibleArea.maxX < x + labelBBox.width) x = visibleArea.maxX - labelBBox.width;
        if (visibleArea.minY > y) y = visibleArea.minY;
        if (visibleArea.maxY < y + labelBBox.height) y = visibleArea.maxY - labelBBox.height;
        return {
            x: x,
            y: y
        };
    },
    _getLabelPosition: function() {
        return "outside";
    },
    _getCoords: function(argument, value) {
        var axis = this.series.getValueAxis();
        var startAngle = axis.getAngles()[0];
        var angle = this._getArgTranslator().translate(argument);
        var radius = this._getValTranslator().translate(value);
        var coords = (0, $dw9tZ.convertPolarToXY)(axis.getCenter(), axis.getAngles()[0], angle, radius);
        coords.angle = angle + startAngle - 90, coords.radius = radius;
        return coords;
    },
    _translate () {
        var center = this.series.getValueAxis().getCenter();
        var coord = this._getCoords(this.argument, this.value);
        var translator = this._getValTranslator();
        var maxRadius = translator.isInverted() ? translator.translate($70510d0998f30964$var$CANVAS_POSITION_START) : translator.translate($70510d0998f30964$var$CANVAS_POSITION_END);
        var normalizedRadius = (0, $6ntMu.isDefined)(coord.radius) && coord.radius >= 0 ? coord.radius : null;
        this.vx = (0, $dw9tZ.normalizeAngle)(coord.angle);
        this.vy = this.radiusOuter = this.radiusLabels = normalizedRadius;
        this.radiusLabels += $70510d0998f30964$var$RADIAL_LABEL_INDENT;
        this.radius = normalizedRadius;
        this.middleAngle = -coord.angle;
        this.angle = -coord.angle;
        this.x = coord.x;
        this.y = coord.y;
        this.defaultX = this.centerX = center.x;
        this.defaultY = this.centerY = center.y;
        this._translateErrorBars();
        this.inVisibleArea = this._checkRadiusForVisibleArea(normalizedRadius, maxRadius);
    },
    _checkRadiusForVisibleArea: (radius, maxRadius)=>(0, $6ntMu.isDefined)(radius) && radius <= maxRadius,
    _translateErrorBars: function() {
        var errorBars = this._options.errorBars;
        var translator = this._getValTranslator();
        if (!errorBars) return;
        (0, $6ntMu.isDefined)(this.lowError) && (this._lowErrorCoord = this.centerY - translator.translate(this.lowError));
        (0, $6ntMu.isDefined)(this.highError) && (this._highErrorCoord = this.centerY - translator.translate(this.highError));
        this._errorBarPos = this.centerX;
        this._baseErrorBarPos = "stdDeviation" === errorBars.type ? this._lowErrorCoord + (this._highErrorCoord - this._lowErrorCoord) / 2 : this.centerY - this.radius;
    },
    _getTranslates: function(animationEnabled) {
        return animationEnabled ? this.getDefaultCoords() : {
            x: this.x,
            y: this.y
        };
    },
    getDefaultCoords: function() {
        var cosSin = (0, $dw9tZ.getCosAndSin)(-this.angle);
        var radius = this._getValTranslator().translate($70510d0998f30964$var$CANVAS_POSITION_DEFAULT);
        var x = this.defaultX + radius * cosSin.cos;
        var y = this.defaultY + radius * cosSin.sin;
        return {
            x: x,
            y: y
        };
    },
    _addLabelAlignmentAndOffset: function(label, coord) {
        return coord;
    },
    _checkLabelPosition: function(label, coord) {
        var visibleArea = this._getVisibleArea();
        var graphicBBox = this._getGraphicBBox();
        if (this._isPointInVisibleArea(visibleArea, graphicBBox)) coord = this._moveLabelOnCanvas(coord, visibleArea, label.getBoundingRect());
        return coord;
    },
    _getErrorBarSettings: function(errorBarOptions, animationEnabled) {
        var settings = (0, $1WEGH.default)._getErrorBarSettings.call(this, errorBarOptions, animationEnabled);
        settings.rotate = $70510d0998f30964$var$ERROR_BARS_ANGLE_OFFSET - this.angle;
        settings.rotateX = this.centerX;
        settings.rotateY = this.centerY;
        return settings;
    },
    getCoords: function(min) {
        return min ? this.getDefaultCoords() : {
            x: this.x,
            y: this.y
        };
    }
});
var $70510d0998f30964$export$906b69c9a059c86a = $70510d0998f30964$var$_extend({}, (0, $euKb3.default), {
    _translateErrorBars: $70510d0998f30964$export$9f8f1e63c5efd409._translateErrorBars,
    _getErrorBarSettings: $70510d0998f30964$export$9f8f1e63c5efd409._getErrorBarSettings,
    _moveLabelOnCanvas: $70510d0998f30964$export$9f8f1e63c5efd409._moveLabelOnCanvas,
    _getLabelCoords: (0, $8kJfa.default)._getLabelCoords,
    _getElementCoords: (0, $8kJfa.default)._getElementCoords,
    _getLabelConnector: (0, $8kJfa.default)._getLabelConnector,
    getTooltipParams: (0, $8kJfa.default).getTooltipParams,
    _getLabelPosition: (0, $8kJfa.default)._getLabelPosition,
    _getCoords: $70510d0998f30964$export$9f8f1e63c5efd409._getCoords,
    _translate () {
        var translator = this._getValTranslator();
        var businessRange = translator.getBusinessRange();
        var maxRadius = translator.isInverted() ? translator.translate($70510d0998f30964$var$CANVAS_POSITION_START) : translator.translate($70510d0998f30964$var$CANVAS_POSITION_END);
        this.radiusInner = translator.translate(this.minValue);
        $70510d0998f30964$export$9f8f1e63c5efd409._translate.call(this);
        if (null === this.radiusInner) this.radiusInner = this.radius = maxRadius;
        else if (null === this.radius) this.radius = this.value >= businessRange.minVisible ? maxRadius : 0;
        else if (this.radius > maxRadius) this.radius = maxRadius;
        this.radiusOuter = this.radiusLabels = $70510d0998f30964$var$_max(this.radiusInner, this.radius);
        this.radiusLabels += $70510d0998f30964$var$RADIAL_LABEL_INDENT;
        this.radiusInner = this.defaultRadius = $70510d0998f30964$var$_math.min(this.radiusInner, this.radius);
        this.middleAngle = this.angle = -(0, $dw9tZ.normalizeAngle)(this.middleAngleCorrection - this.angle);
    },
    _checkRadiusForVisibleArea (radius) {
        return (0, $6ntMu.isDefined)(radius) || this._getValTranslator().translate(this.minValue) > 0;
    },
    _getErrorBarBaseEdgeLength () {
        var coord = this.getMarkerCoords();
        return $70510d0998f30964$var$_math.PI * coord.outerRadius * $70510d0998f30964$var$_math.abs(coord.startAngle - coord.endAngle) / 180;
    },
    getMarkerCoords: function() {
        return {
            x: this.centerX,
            y: this.centerY,
            outerRadius: this.radiusOuter,
            innerRadius: this.defaultRadius,
            startAngle: this.middleAngle - this.interval / 2,
            endAngle: this.middleAngle + this.interval / 2
        };
    },
    _drawMarker: function(renderer, group, animationEnabled) {
        var styles = this._getStyle();
        var coords = this.getMarkerCoords();
        var innerRadius = coords.innerRadius;
        var outerRadius = coords.outerRadius;
        var start = this._getCoords(this.argument, $70510d0998f30964$var$CANVAS_POSITION_DEFAULT);
        var x = coords.x;
        var y = coords.y;
        if (animationEnabled) {
            innerRadius = 0;
            outerRadius = 0;
            x = start.x;
            y = start.y;
        }
        this.graphic = renderer.arc(x, y, innerRadius, outerRadius, coords.startAngle, coords.endAngle).attr(styles).data({
            "chart-data-point": this
        }).append(group);
    },
    _checkLabelPosition: function(label, coord) {
        var visibleArea = this._getVisibleArea();
        var angleFunctions = (0, $dw9tZ.getCosAndSin)(this.middleAngle);
        var x = this.centerX + this.defaultRadius * angleFunctions.cos;
        var y = this.centerY - this.defaultRadius * angleFunctions.sin;
        if (x > visibleArea.minX && x < visibleArea.maxX && y > visibleArea.minY && y < visibleArea.maxY) coord = this._moveLabelOnCanvas(coord, visibleArea, label.getBoundingRect());
        return coord;
    },
    _addLabelAlignmentAndOffset: function(label, coord) {
        return coord;
    },
    correctCoordinates: function(correctOptions) {
        this.middleAngleCorrection = correctOptions.offset;
        this.interval = correctOptions.width;
    },
    coordsIn: function(x, y) {
        var val = (0, $dw9tZ.convertXYToPolar)(this.series.getValueAxis().getCenter(), x, y);
        var coords = this.getMarkerCoords();
        var isBetweenAngles = coords.startAngle < coords.endAngle ? -val.phi >= coords.startAngle && -val.phi <= coords.endAngle : -val.phi <= coords.startAngle && -val.phi >= coords.endAngle;
        return val.r >= coords.innerRadius && val.r <= coords.outerRadius && isBetweenAngles;
    }
});

});


parcelRegister("lPQM0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe574c1280f4a59a$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/series/helpers/range_data_calculator.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $dw9tZ = parcelRequire("dw9tZ");

var $6ntMu = parcelRequire("6ntMu");

var $gcp4g = parcelRequire("gcp4g");
var $fe574c1280f4a59a$var$DISCRETE = "discrete";
var { abs: $fe574c1280f4a59a$var$abs, floor: $fe574c1280f4a59a$var$floor, ceil: $fe574c1280f4a59a$var$ceil, min: $fe574c1280f4a59a$var$min } = Math;
function $fe574c1280f4a59a$var$continuousRangeCalculator(range, minValue, maxValue) {
    range.min = range.min < minValue ? range.min : minValue;
    range.max = range.max > maxValue ? range.max : maxValue;
}
function $fe574c1280f4a59a$var$createGetLogFunction(axisType, axis) {
    if ("logarithmic" !== axisType) return null;
    var base = axis.getOptions().logarithmBase;
    return (value)=>{
        var log = (0, $dw9tZ.getLog)($fe574c1280f4a59a$var$abs(value), base);
        var round = log < 0 ? $fe574c1280f4a59a$var$floor : $fe574c1280f4a59a$var$ceil;
        return round(log);
    };
}
function $fe574c1280f4a59a$var$getRangeCalculator(axisType, axis, getLog) {
    var rangeCalculator = $fe574c1280f4a59a$var$continuousRangeCalculator;
    if (axisType === $fe574c1280f4a59a$var$DISCRETE) rangeCalculator = function(range, minValue, maxValue) {
        if (minValue !== maxValue) range.categories.push(maxValue);
        range.categories.push(minValue);
    };
    else if (axis) rangeCalculator = function(range, value) {
        var interval = axis.calculateInterval(value, range.prevValue);
        var minInterval = range.interval;
        range.interval = (minInterval < interval ? minInterval : interval) || minInterval;
        range.prevValue = value;
        $fe574c1280f4a59a$var$continuousRangeCalculator(range, value, value);
    };
    if (getLog) return (range, minValue, maxValue)=>{
        var minArgs = [];
        rangeCalculator(range, minValue, maxValue);
        0 !== minValue && minArgs.push(getLog(minValue));
        0 !== maxValue && minArgs.push(getLog(maxValue));
        var linearThreshold = $fe574c1280f4a59a$var$min.apply(null, minArgs);
        range.linearThreshold = range.linearThreshold < linearThreshold ? range.linearThreshold : linearThreshold;
    };
    return rangeCalculator;
}
function $fe574c1280f4a59a$var$getInitialRange(axisType, dataType, firstValue) {
    var range = {
        axisType: axisType,
        dataType: dataType
    };
    if (axisType === $fe574c1280f4a59a$var$DISCRETE) range.categories = [];
    else {
        range.min = (0, $6ntMu.isObject)(firstValue) ? firstValue.min : firstValue;
        range.max = (0, $6ntMu.isObject)(firstValue) ? firstValue.max : firstValue;
    }
    return range;
}
function $fe574c1280f4a59a$var$processCategories(range) {
    if (range.categories) range.categories = (0, $dw9tZ.unique)(range.categories);
    return range;
}
function $fe574c1280f4a59a$var$getValueForArgument(point, extraPoint, x, range) {
    if (extraPoint && (0, $6ntMu.isDefined)(extraPoint.value)) {
        var y1 = point.value;
        var y2 = extraPoint.value;
        var x1 = point.argument;
        var x2 = extraPoint.argument;
        var r = (x - x1) * (y2 - y1) / (x2 - x1) + y1.valueOf();
        return "datetime" === range.dataType ? new Date(r) : r;
    } else return point.value;
}
function $fe574c1280f4a59a$var$calculateRangeBetweenPoints(rangeCalculator, range, point, prevPoint, bound) {
    var value = $fe574c1280f4a59a$var$getValueForArgument(point, prevPoint, bound, range);
    rangeCalculator(range, value, value);
}
function $fe574c1280f4a59a$var$isLineSeries(series) {
    return series.type.toLowerCase().indexOf("line") >= 0 || series.type.toLowerCase().indexOf("area") >= 0;
}
function $fe574c1280f4a59a$var$getViewportReducer(series) {
    var rangeCalculator = $fe574c1280f4a59a$var$getRangeCalculator(series.valueAxisType);
    var argumentAxis = series.getArgumentAxis();
    var viewport = argumentAxis && series.getArgumentAxis().visualRange() || {};
    var calculatePointBetweenPoints = $fe574c1280f4a59a$var$isLineSeries(series) ? $fe574c1280f4a59a$var$calculateRangeBetweenPoints : (0, $gcp4g.noop);
    if (argumentAxis && argumentAxis.getMarginOptions().checkInterval) {
        var range = series.getArgumentAxis().getTranslator().getBusinessRange();
        var add = (0, $dw9tZ.getAddFunction)(range, false);
        var interval = range.interval;
        if (isFinite(interval) && (0, $6ntMu.isDefined)(viewport.startValue) && (0, $6ntMu.isDefined)(viewport.endValue)) {
            viewport.startValue = add(viewport.startValue, interval, -1);
            viewport.endValue = add(viewport.endValue, interval);
        }
    }
    var viewportFilter = $fe574c1280f4a59a$var$getViewPortFilter(viewport);
    return function(range, point, index, points) {
        var argument = point.argument;
        if (!point.hasValue()) return range;
        if (viewportFilter(argument)) {
            if (!range.startCalc) {
                range.startCalc = true;
                calculatePointBetweenPoints(rangeCalculator, range, point, points[index - 1], viewport.startValue);
            }
            rangeCalculator(range, point.getMinValue(), point.getMaxValue());
        } else if (!viewport.categories && (0, $6ntMu.isDefined)(viewport.startValue) && argument > viewport.startValue) {
            if (!range.startCalc) calculatePointBetweenPoints(rangeCalculator, range, point, points[index - 1], viewport.startValue);
            range.endCalc = true;
            calculatePointBetweenPoints(rangeCalculator, range, point, points[index - 1], viewport.endValue);
        }
        return range;
    };
}
function $fe574c1280f4a59a$var$getViewPortFilter(viewport) {
    if (viewport.categories) {
        var dictionary = viewport.categories.reduce((result, category)=>{
            result[category.valueOf()] = true;
            return result;
        }, {});
        return (argument)=>(0, $6ntMu.isDefined)(argument) && dictionary[argument.valueOf()];
    }
    if (!(0, $6ntMu.isDefined)(viewport.startValue) && !(0, $6ntMu.isDefined)(viewport.endValue)) return ()=>true;
    if (!(0, $6ntMu.isDefined)(viewport.endValue)) return (argument)=>argument >= viewport.startValue;
    if (!(0, $6ntMu.isDefined)(viewport.startValue)) return (argument)=>argument <= viewport.endValue;
    return (argument)=>argument >= viewport.startValue && argument <= viewport.endValue;
}
var $fe574c1280f4a59a$export$2e2bcd8739ae039 = {
    getViewPortFilter: $fe574c1280f4a59a$var$getViewPortFilter,
    getArgumentRange: function(series) {
        var data = series._data || [];
        var range = {};
        if (data.length) {
            if (series.argumentAxisType === $fe574c1280f4a59a$var$DISCRETE) range = {
                categories: data.map((item)=>item.argument)
            };
            else {
                var interval;
                if (data.length > 1) {
                    var i1 = series.getArgumentAxis().calculateInterval(data[0].argument, data[1].argument);
                    var i2 = series.getArgumentAxis().calculateInterval(data[data.length - 1].argument, data[data.length - 2].argument);
                    interval = $fe574c1280f4a59a$var$min(i1, i2);
                }
                range = {
                    min: data[0].argument,
                    max: data[data.length - 1].argument,
                    interval: interval
                };
            }
        }
        return $fe574c1280f4a59a$var$processCategories(range);
    },
    getRangeData: function(series) {
        var points = series.getPoints();
        var useAggregation = series.useAggregation();
        var argumentAxis = series.getArgumentAxis();
        var argumentCalculator = $fe574c1280f4a59a$var$getRangeCalculator(series.argumentAxisType, points.length > 1 && argumentAxis, $fe574c1280f4a59a$var$createGetLogFunction(series.argumentAxisType, argumentAxis));
        var valueRangeCalculator = $fe574c1280f4a59a$var$getRangeCalculator(series.valueAxisType, null, $fe574c1280f4a59a$var$createGetLogFunction(series.valueAxisType, series.getValueAxis()));
        var viewportReducer = $fe574c1280f4a59a$var$getViewportReducer(series);
        var range = points.reduce(function(range, point, index, points) {
            var argument = point.argument;
            if (!point.isArgumentCorrect()) return range;
            argumentCalculator(range.arg, argument, argument);
            if (point.hasValue()) {
                valueRangeCalculator(range.val, point.getMinValue(), point.getMaxValue());
                viewportReducer(range.viewport, point, index, points);
            }
            return range;
        }, {
            arg: $fe574c1280f4a59a$var$getInitialRange(series.argumentAxisType, series.argumentType, null !== argumentAxis && void 0 !== argumentAxis && argumentAxis.aggregatedPointBetweenTicks() ? void 0 : series.getArgumentRangeInitialValue()),
            val: $fe574c1280f4a59a$var$getInitialRange(series.valueAxisType, series.valueType, points.length ? series.getValueRangeInitialValue() : void 0),
            viewport: $fe574c1280f4a59a$var$getInitialRange(series.valueAxisType, series.valueType, points.length ? series.getValueRangeInitialValue() : void 0)
        });
        if (useAggregation) {
            var argumentRange = this.getArgumentRange(series);
            if (series.argumentAxisType === $fe574c1280f4a59a$var$DISCRETE) range.arg = argumentRange;
            else {
                var viewport = argumentAxis.getViewport();
                if ((0, $6ntMu.isDefined)(viewport.startValue) || (0, $6ntMu.isDefined)(viewport.length)) argumentCalculator(range.arg, argumentRange.min, argumentRange.min);
                if ((0, $6ntMu.isDefined)(viewport.endValue) || (0, $6ntMu.isDefined)(viewport.length) && (0, $6ntMu.isDefined)(viewport.startValue)) argumentCalculator(range.arg, argumentRange.max, argumentRange.max);
            }
        }
        $fe574c1280f4a59a$var$processCategories(range.arg);
        $fe574c1280f4a59a$var$processCategories(range.val);
        return range;
    },
    getViewport: function(series) {
        var points = series.getPoints();
        var range;
        var reducer = $fe574c1280f4a59a$var$getViewportReducer(series);
        range = $fe574c1280f4a59a$var$getInitialRange(series.valueAxisType, series.valueType, points.length ? series.getValueRangeInitialValue() : void 0);
        points.some(function(point, index) {
            reducer(range, point, index, points);
            return range.endCalc;
        });
        return range;
    },
    getPointsInViewPort: function(series) {
        var argumentViewPortFilter = $fe574c1280f4a59a$var$getViewPortFilter(series.getArgumentAxis().visualRange() || {});
        var valueViewPort = series.getValueAxis().visualRange() || {};
        var valueViewPortFilter = $fe574c1280f4a59a$var$getViewPortFilter(valueViewPort);
        var points = series.getPoints();
        var addValue = function(values, point, isEdge) {
            var minValue = point.getMinValue();
            var maxValue = point.getMaxValue();
            var isMinValueInViewPort = valueViewPortFilter(minValue);
            var isMaxValueInViewPort = valueViewPortFilter(maxValue);
            if (isMinValueInViewPort) values.push(minValue);
            if (maxValue !== minValue && isMaxValueInViewPort) values.push(maxValue);
            if (isEdge && !isMinValueInViewPort && !isMaxValueInViewPort) {
                if (!values.length) values.push(valueViewPort.startValue);
                else values.push(valueViewPort.endValue);
            }
        };
        var addEdgePoints = $fe574c1280f4a59a$var$isLineSeries(series) ? function(result, points, index) {
            var point = points[index];
            var prevPoint = points[index - 1];
            var nextPoint = points[index + 1];
            if (nextPoint && argumentViewPortFilter(nextPoint.argument)) addValue(result[1], point, true);
            if (prevPoint && argumentViewPortFilter(prevPoint.argument)) addValue(result[1], point, true);
        } : (0, $gcp4g.noop);
        return points.reduce(function(result, point, index) {
            if (argumentViewPortFilter(point.argument)) addValue(result[0], point);
            else addEdgePoints(result, points, index);
            return result;
        }, [
            [],
            []
        ]);
    }
};

});

parcelRegister("3Ev8J", function(module, exports) {

$parcel$export(module.exports, "chart", function () { return $2a8d4339caea2716$export$8fde8ebd684d5072; });
$parcel$export(module.exports, "polar", function () { return $2a8d4339caea2716$export$5f7108acdc6fb162; });
/**
 * DevExtreme (esm/viz/series/scatter_series.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $lPQM0 = parcelRequire("lPQM0");

var $6ntMu = parcelRequire("6ntMu");

var $dw9tZ = parcelRequire("dw9tZ");

var $gcp4g = parcelRequire("gcp4g");
var $2a8d4339caea2716$var$math = Math;
var $2a8d4339caea2716$var$_abs = $2a8d4339caea2716$var$math.abs;
var $2a8d4339caea2716$var$_sqrt = $2a8d4339caea2716$var$math.sqrt;
var $2a8d4339caea2716$var$_max = $2a8d4339caea2716$var$math.max;
var $2a8d4339caea2716$var$DEFAULT_TRACKER_WIDTH = 12;
var $2a8d4339caea2716$var$DEFAULT_DURATION = 400;
var $2a8d4339caea2716$var$HIGH_ERROR = "highError";
var $2a8d4339caea2716$var$LOW_ERROR = "lowError";
var $2a8d4339caea2716$var$VARIANCE = "variance";
var $2a8d4339caea2716$var$STANDARD_DEVIATION = "stddeviation";
var $2a8d4339caea2716$var$STANDARD_ERROR = "stderror";
var $2a8d4339caea2716$var$PERCENT = "percent";
var $2a8d4339caea2716$var$FIXED = "fixed";
var $2a8d4339caea2716$var$UNDEFINED = "undefined";
var $2a8d4339caea2716$var$DISCRETE = "discrete";
var $2a8d4339caea2716$var$LOGARITHMIC = "logarithmic";
var $2a8d4339caea2716$var$DATETIME = "datetime";
var $2a8d4339caea2716$export$8fde8ebd684d5072 = {};
var $2a8d4339caea2716$export$5f7108acdc6fb162 = {};
function $2a8d4339caea2716$var$sum(array) {
    var result = 0;
    (0, $8OLOW.each)(array, function(_, value) {
        result += value;
    });
    return result;
}
function $2a8d4339caea2716$var$isErrorBarTypeCorrect(type) {
    return [
        $2a8d4339caea2716$var$FIXED,
        $2a8d4339caea2716$var$PERCENT,
        $2a8d4339caea2716$var$VARIANCE,
        $2a8d4339caea2716$var$STANDARD_DEVIATION,
        $2a8d4339caea2716$var$STANDARD_ERROR
    ].includes(type);
}
function $2a8d4339caea2716$var$variance(array, expectedValue) {
    return $2a8d4339caea2716$var$sum((0, $dw9tZ.map)(array, function(value) {
        return (value - expectedValue) * (value - expectedValue);
    })) / array.length;
}
function $2a8d4339caea2716$var$calculateAvgErrorBars(result, data, series) {
    var errorBarsOptions = series.getOptions().valueErrorBar;
    var valueField = series.getValueFields()[0];
    var lowValueField = errorBarsOptions.lowValueField || $2a8d4339caea2716$var$LOW_ERROR;
    var highValueField = errorBarsOptions.highValueField || $2a8d4339caea2716$var$HIGH_ERROR;
    if (series.areErrorBarsVisible() && void 0 === errorBarsOptions.type) {
        var fusionData = data.reduce(function(result, item) {
            if ((0, $6ntMu.isDefined)(item[lowValueField])) {
                result[0] += item[valueField] - item[lowValueField];
                result[1]++;
            }
            if ((0, $6ntMu.isDefined)(item[highValueField])) {
                result[2] += item[highValueField] - item[valueField];
                result[3]++;
            }
            return result;
        }, [
            0,
            0,
            0,
            0
        ]);
        if (fusionData[1]) result[lowValueField] = result[valueField] - fusionData[0] / fusionData[1];
        if (fusionData[2]) result[highValueField] = result[valueField] + fusionData[2] / fusionData[3];
    }
    return result;
}
function $2a8d4339caea2716$var$calculateSumErrorBars(result, data, series) {
    var errorBarsOptions = series.getOptions().valueErrorBar;
    var lowValueField = errorBarsOptions.lowValueField || $2a8d4339caea2716$var$LOW_ERROR;
    var highValueField = errorBarsOptions.highValueField || $2a8d4339caea2716$var$HIGH_ERROR;
    if (series.areErrorBarsVisible() && void 0 === errorBarsOptions.type) {
        result[lowValueField] = 0;
        result[highValueField] = 0;
        result = data.reduce(function(result, item) {
            result[lowValueField] += item[lowValueField];
            result[highValueField] += item[highValueField];
            return result;
        }, result);
    }
    return result;
}
function $2a8d4339caea2716$var$getMinMaxAggregator(compare) {
    return (_ref, series)=>{
        var { intervalStart: intervalStart, intervalEnd: intervalEnd, data: data } = _ref;
        var valueField = series.getValueFields()[0];
        var targetData = data[0];
        targetData = data.reduce((result, item)=>{
            var value = item[valueField];
            if (null === result[valueField]) result = item;
            if (null !== value && compare(value, result[valueField])) return item;
            return result;
        }, targetData);
        return (0, $2oTOp.extend)({}, targetData, {
            [series.getArgumentField()]: series._getIntervalCenter(intervalStart, intervalEnd)
        });
    };
}
function $2a8d4339caea2716$var$checkFields(data, fieldsToCheck, skippedFields) {
    var allFieldsIsValid = true;
    for(var field in fieldsToCheck){
        var isArgument = "argument" === field;
        if (isArgument || "size" === field ? !(0, $6ntMu.isDefined)(data[field]) : void 0 === data[field]) {
            var selector = fieldsToCheck[field];
            if (!isArgument) skippedFields[selector] = (skippedFields[selector] || 0) + 1;
            allFieldsIsValid = false;
        }
    }
    return allFieldsIsValid;
}
var $2a8d4339caea2716$var$baseScatterMethods = {
    _defaultDuration: $2a8d4339caea2716$var$DEFAULT_DURATION,
    _defaultTrackerWidth: $2a8d4339caea2716$var$DEFAULT_TRACKER_WIDTH,
    _applyStyle: (0, $gcp4g.noop),
    _updateOptions: (0, $gcp4g.noop),
    _parseStyle: (0, $gcp4g.noop),
    _prepareSegment: (0, $gcp4g.noop),
    _drawSegment: (0, $gcp4g.noop),
    _appendInGroup: function() {
        this._group.append(this._extGroups.seriesGroup);
    },
    _createLegendState: function(styleOptions, defaultColor) {
        return {
            fill: styleOptions.color || defaultColor,
            hatching: styleOptions.hatching ? (0, $2oTOp.extend)({}, styleOptions.hatching, {
                direction: "right"
            }) : void 0
        };
    },
    _applyElementsClipRect: function(settings) {
        settings["clip-path"] = this._paneClipRectID;
    },
    _applyMarkerClipRect: function(settings) {
        settings["clip-path"] = this._forceClipping ? this._paneClipRectID : null;
    },
    _createGroup: function(groupName, parent, target, settings) {
        var group = parent[groupName] = parent[groupName] || this._renderer.g();
        target && group.append(target);
        settings && group.attr(settings);
    },
    _applyClearingSettings: function(settings) {
        settings.opacity = null;
        settings.scale = null;
        if (this._options.rotated) settings.translateX = null;
        else settings.translateY = null;
    },
    _createGroups: function() {
        this._createGroup("_markersGroup", this, this._group);
        this._createGroup("_labelsGroup", this);
    },
    _setMarkerGroupSettings: function() {
        var settings = this._createPointStyles(this._getMarkerGroupOptions()).normal;
        settings.class = "dxc-markers";
        settings.opacity = 1;
        this._applyMarkerClipRect(settings);
        this._markersGroup.attr(settings);
    },
    getVisibleArea: function() {
        return this._visibleArea;
    },
    areErrorBarsVisible: function() {
        var errorBarOptions = this._options.valueErrorBar;
        return errorBarOptions && this._errorBarsEnabled() && "none" !== errorBarOptions.displayMode && ($2a8d4339caea2716$var$isErrorBarTypeCorrect((0, $dw9tZ.normalizeEnum)(errorBarOptions.type)) || (0, $6ntMu.isDefined)(errorBarOptions.lowValueField) || (0, $6ntMu.isDefined)(errorBarOptions.highValueField));
    },
    groupPointsByCoords (rotated) {
        var cat = [];
        (0, $8OLOW.each)(this.getVisiblePoints(), function(_, p) {
            var pointCoord = parseInt(rotated ? p.vy : p.vx);
            if (!cat[pointCoord]) cat[pointCoord] = p;
            else Array.isArray(cat[pointCoord]) ? cat[pointCoord].push(p) : cat[pointCoord] = [
                cat[pointCoord],
                p
            ];
        });
        return cat;
    },
    _createErrorBarGroup: function(animationEnabled) {
        var errorBarOptions = this._options.valueErrorBar;
        var settings;
        if (this.areErrorBarsVisible()) {
            settings = {
                class: "dxc-error-bars",
                stroke: errorBarOptions.color,
                "stroke-width": errorBarOptions.lineWidth,
                opacity: animationEnabled ? .001 : errorBarOptions.opacity || 1,
                "stroke-linecap": "square",
                sharp: true,
                "clip-path": this._forceClipping ? this._paneClipRectID : this._widePaneClipRectID
            };
            this._createGroup("_errorBarGroup", this, this._group, settings);
        }
    },
    _setGroupsSettings: function(animationEnabled) {
        this._setMarkerGroupSettings();
        this._setLabelGroupSettings(animationEnabled);
        this._createErrorBarGroup(animationEnabled);
    },
    _getCreatingPointOptions: function() {
        var defaultPointOptions;
        var creatingPointOptions = this._predefinedPointOptions;
        var normalStyle;
        if (!creatingPointOptions) {
            defaultPointOptions = this._getPointOptions();
            this._predefinedPointOptions = creatingPointOptions = (0, $2oTOp.extend)(true, {
                styles: {}
            }, defaultPointOptions);
            normalStyle = defaultPointOptions.styles && defaultPointOptions.styles.normal || {};
            creatingPointOptions.styles = creatingPointOptions.styles || {};
            creatingPointOptions.styles.normal = {
                "stroke-width": normalStyle["stroke-width"],
                r: normalStyle.r,
                opacity: normalStyle.opacity
            };
        }
        return creatingPointOptions;
    },
    _getPointOptions: function() {
        return this._parsePointOptions(this._preparePointOptions(), this._options.label);
    },
    _getOptionsForPoint: function() {
        return this._options.point;
    },
    _parsePointStyle: function(style, defaultColor, defaultBorderColor, defaultSize) {
        var border = style.border || {};
        var sizeValue = void 0 !== style.size ? style.size : defaultSize;
        return {
            fill: style.color || defaultColor,
            stroke: border.color || defaultBorderColor,
            "stroke-width": border.visible ? border.width : 0,
            r: sizeValue / 2 + (border.visible && 0 !== sizeValue ? ~~(border.width / 2) || 0 : 0)
        };
    },
    _createPointStyles: function(pointOptions) {
        var mainPointColor = pointOptions.color || this._options.mainSeriesColor;
        var containerColor = this._options.containerBackgroundColor;
        var normalStyle = this._parsePointStyle(pointOptions, mainPointColor, mainPointColor);
        normalStyle.visibility = pointOptions.visible ? "visible" : "hidden";
        return {
            normal: normalStyle,
            hover: this._parsePointStyle(pointOptions.hoverStyle, containerColor, mainPointColor, pointOptions.size),
            selection: this._parsePointStyle(pointOptions.selectionStyle, containerColor, mainPointColor, pointOptions.size)
        };
    },
    _checkData: function(data, skippedFields, fieldsToCheck) {
        fieldsToCheck = fieldsToCheck || {
            value: this.getValueFields()[0]
        };
        fieldsToCheck.argument = this.getArgumentField();
        return $2a8d4339caea2716$var$checkFields(data, fieldsToCheck, skippedFields || {}) && data.value === data.value;
    },
    getArgumentRangeInitialValue () {
        var points = this.getPoints();
        if (this.useAggregation() && points.length) {
            var _points$0$aggregation, _points$aggregationIn;
            return {
                min: null === (_points$0$aggregation = points[0].aggregationInfo) || void 0 === _points$0$aggregation ? void 0 : _points$0$aggregation.intervalStart,
                max: null === (_points$aggregationIn = points[points.length - 1].aggregationInfo) || void 0 === _points$aggregationIn ? void 0 : _points$aggregationIn.intervalEnd
            };
        }
        return;
    },
    getValueRangeInitialValue: function() {
        return;
    },
    _getRangeData: function() {
        return (0, $lPQM0.default).getRangeData(this);
    },
    _getPointDataSelector: function() {
        var valueField = this.getValueFields()[0];
        var argumentField = this.getArgumentField();
        var tagField = this.getTagField();
        var areErrorBarsVisible = this.areErrorBarsVisible();
        var lowValueField;
        var highValueField;
        if (areErrorBarsVisible) {
            var errorBarOptions = this._options.valueErrorBar;
            lowValueField = errorBarOptions.lowValueField || $2a8d4339caea2716$var$LOW_ERROR;
            highValueField = errorBarOptions.highValueField || $2a8d4339caea2716$var$HIGH_ERROR;
        }
        return (data)=>{
            var pointData = {
                value: this._processEmptyValue(data[valueField]),
                argument: data[argumentField],
                tag: data[tagField],
                data: data
            };
            if (areErrorBarsVisible) {
                pointData.lowError = data[lowValueField];
                pointData.highError = data[highValueField];
            }
            return pointData;
        };
    },
    _errorBarsEnabled: function() {
        return this.valueAxisType !== $2a8d4339caea2716$var$DISCRETE && this.valueAxisType !== $2a8d4339caea2716$var$LOGARITHMIC && this.valueType !== $2a8d4339caea2716$var$DATETIME;
    },
    _drawPoint: function(options) {
        var point = options.point;
        if (point.isInVisibleArea()) {
            point.clearVisibility();
            point.draw(this._renderer, options.groups, options.hasAnimation, options.firstDrawing);
            this._drawnPoints.push(point);
        } else point.setInvisibility();
    },
    _animateComplete: function() {
        var animationSettings = {
            duration: this._defaultDuration
        };
        this._labelsGroup && this._labelsGroup.animate({
            opacity: 1
        }, animationSettings);
        this._errorBarGroup && this._errorBarGroup.animate({
            opacity: this._options.valueErrorBar.opacity || 1
        }, animationSettings);
    },
    _animate: function() {
        var that = this;
        var lastPointIndex = that._drawnPoints.length - 1;
        (0, $8OLOW.each)(that._drawnPoints || [], function(i, p) {
            p.animate(i === lastPointIndex ? function() {
                that._animateComplete();
            } : void 0, {
                translateX: p.x,
                translateY: p.y
            });
        });
    },
    _getIntervalCenter (intervalStart, intervalEnd) {
        var argAxis = this.getArgumentAxis();
        var axisOptions = argAxis.getOptions();
        if (argAxis.aggregatedPointBetweenTicks()) return intervalStart;
        return "discrete" !== axisOptions.type ? argAxis.getVisualRangeCenter({
            minVisible: intervalStart,
            maxVisible: intervalEnd
        }, true) : intervalStart;
    },
    _defaultAggregator: "avg",
    _aggregators: {
        avg (_ref2, series) {
            var { data: data, intervalStart: intervalStart, intervalEnd: intervalEnd } = _ref2;
            if (!data.length) return;
            var valueField = series.getValueFields()[0];
            var aggregationResult = data.reduce((result, item)=>{
                var value = item[valueField];
                if ((0, $6ntMu.isDefined)(value)) {
                    result[0] += value;
                    result[1]++;
                } else if (null === value) result[2]++;
                return result;
            }, [
                0,
                0,
                0
            ]);
            return $2a8d4339caea2716$var$calculateAvgErrorBars({
                [valueField]: aggregationResult[2] === data.length ? null : aggregationResult[0] / aggregationResult[1],
                [series.getArgumentField()]: series._getIntervalCenter(intervalStart, intervalEnd)
            }, data, series);
        },
        sum (_ref3, series) {
            var { intervalStart: intervalStart, intervalEnd: intervalEnd, data: data } = _ref3;
            if (!data.length) return;
            var valueField = series.getValueFields()[0];
            var aggregationResult = data.reduce((result, item)=>{
                var value = item[valueField];
                if (void 0 !== value) result[0] += value;
                if (null === value) result[1]++;
                else if (void 0 === value) result[2]++;
                return result;
            }, [
                0,
                0,
                0
            ]);
            var value = aggregationResult[0];
            if (aggregationResult[1] === data.length) value = null;
            if (aggregationResult[2] === data.length) return;
            return $2a8d4339caea2716$var$calculateSumErrorBars({
                [valueField]: value,
                [series.getArgumentField()]: series._getIntervalCenter(intervalStart, intervalEnd)
            }, data, series);
        },
        count (_ref4, series) {
            var { data: data, intervalStart: intervalStart, intervalEnd: intervalEnd } = _ref4;
            var valueField = series.getValueFields()[0];
            return {
                [series.getArgumentField()]: series._getIntervalCenter(intervalStart, intervalEnd),
                [valueField]: data.filter((i)=>void 0 !== i[valueField]).length
            };
        },
        min: $2a8d4339caea2716$var$getMinMaxAggregator((a, b)=>a < b),
        max: $2a8d4339caea2716$var$getMinMaxAggregator((a, b)=>a > b)
    },
    _endUpdateData: function() {
        delete this._predefinedPointOptions;
    },
    getArgumentField: function() {
        return this._options.argumentField || "arg";
    },
    getValueFields: function() {
        var options = this._options;
        var errorBarsOptions = options.valueErrorBar;
        var valueFields = [
            options.valueField || "val"
        ];
        var lowValueField;
        var highValueField;
        if (errorBarsOptions) {
            lowValueField = errorBarsOptions.lowValueField;
            highValueField = errorBarsOptions.highValueField;
            (0, $6ntMu.isString)(lowValueField) && valueFields.push(lowValueField);
            (0, $6ntMu.isString)(highValueField) && valueFields.push(highValueField);
        }
        return valueFields;
    },
    _calculateErrorBars: function(data) {
        if (!this.areErrorBarsVisible()) return;
        var options = this._options;
        var errorBarsOptions = options.valueErrorBar;
        var errorBarType = (0, $dw9tZ.normalizeEnum)(errorBarsOptions.type);
        var floatErrorValue = parseFloat(errorBarsOptions.value);
        var valueField = this.getValueFields()[0];
        var value;
        var lowValueField = errorBarsOptions.lowValueField || $2a8d4339caea2716$var$LOW_ERROR;
        var highValueField = errorBarsOptions.highValueField || $2a8d4339caea2716$var$HIGH_ERROR;
        var valueArray;
        var valueArrayLength;
        var meanValue;
        var processDataItem;
        var addSubError = function(_i, item) {
            value = item.value;
            item.lowError = value - floatErrorValue;
            item.highError = value + floatErrorValue;
        };
        switch(errorBarType){
            case $2a8d4339caea2716$var$FIXED:
                processDataItem = addSubError;
                break;
            case $2a8d4339caea2716$var$PERCENT:
                processDataItem = function(_, item) {
                    value = item.value;
                    var error = value * floatErrorValue / 100;
                    item.lowError = value - error;
                    item.highError = value + error;
                };
                break;
            case $2a8d4339caea2716$var$UNDEFINED:
                processDataItem = function(_, item) {
                    item.lowError = item.data[lowValueField];
                    item.highError = item.data[highValueField];
                };
                break;
            default:
                valueArray = (0, $dw9tZ.map)(data, function(item) {
                    return (0, $6ntMu.isDefined)(item.data[valueField]) ? item.data[valueField] : null;
                });
                valueArrayLength = valueArray.length;
                floatErrorValue = floatErrorValue || 1;
                switch(errorBarType){
                    case $2a8d4339caea2716$var$VARIANCE:
                        floatErrorValue = $2a8d4339caea2716$var$variance(valueArray, $2a8d4339caea2716$var$sum(valueArray) / valueArrayLength) * floatErrorValue;
                        processDataItem = addSubError;
                        break;
                    case $2a8d4339caea2716$var$STANDARD_DEVIATION:
                        meanValue = $2a8d4339caea2716$var$sum(valueArray) / valueArrayLength;
                        floatErrorValue = $2a8d4339caea2716$var$_sqrt($2a8d4339caea2716$var$variance(valueArray, meanValue)) * floatErrorValue;
                        processDataItem = function(_, item) {
                            item.lowError = meanValue - floatErrorValue;
                            item.highError = meanValue + floatErrorValue;
                        };
                        break;
                    case $2a8d4339caea2716$var$STANDARD_ERROR:
                        floatErrorValue = $2a8d4339caea2716$var$_sqrt($2a8d4339caea2716$var$variance(valueArray, $2a8d4339caea2716$var$sum(valueArray) / valueArrayLength) / valueArrayLength) * floatErrorValue;
                        processDataItem = addSubError;
                }
        }
        processDataItem && (0, $8OLOW.each)(data, processDataItem);
    },
    _patchMarginOptions: function(options) {
        var pointOptions = this._getCreatingPointOptions();
        var styles = pointOptions.styles;
        var maxSize = [
            styles.normal,
            styles.hover,
            styles.selection
        ].reduce(function(max, style) {
            return $2a8d4339caea2716$var$_max(max, 2 * style.r + style["stroke-width"]);
        }, 0);
        options.size = pointOptions.visible ? maxSize : 0;
        options.sizePointNormalState = pointOptions.visible ? 2 * styles.normal.r + styles.normal["stroke-width"] : 2;
        return options;
    },
    usePointsToDefineAutoHiding: ()=>true
};
$2a8d4339caea2716$export$8fde8ebd684d5072 = (0, $2oTOp.extend)({}, $2a8d4339caea2716$var$baseScatterMethods, {
    drawTrackers: function() {
        var that = this;
        var trackers;
        var trackersGroup;
        var segments = that._segments || [];
        var rotated = that._options.rotated;
        if (!that.isVisible()) return;
        if (segments.length) {
            trackers = that._trackers = that._trackers || [];
            trackersGroup = that._trackersGroup = (that._trackersGroup || that._renderer.g().attr({
                fill: "gray",
                opacity: .001,
                stroke: "gray",
                class: "dxc-trackers"
            })).attr({
                "clip-path": this._paneClipRectID || null
            }).append(that._group);
            (0, $8OLOW.each)(segments, function(i, segment) {
                if (!trackers[i]) trackers[i] = that._drawTrackerElement(segment).data({
                    "chart-data-series": that
                }).append(trackersGroup);
                else that._updateTrackerElement(segment, trackers[i]);
            });
        }
        that._trackersTranslator = that.groupPointsByCoords(rotated);
    },
    _checkAxisVisibleAreaCoord (isArgument, coord) {
        var axis = isArgument ? this.getArgumentAxis() : this.getValueAxis();
        var visibleArea = axis.getVisibleArea();
        return (0, $6ntMu.isDefined)(coord) && visibleArea[0] <= coord && visibleArea[1] >= coord;
    },
    checkSeriesViewportCoord (axis, coord) {
        return this.getPoints().length && this.isVisible();
    },
    getSeriesPairCoord (coord, isArgument) {
        var oppositeCoord = null;
        var isOpposite = !isArgument && !this._options.rotated || isArgument && this._options.rotated;
        var coordName = !isOpposite ? "vx" : "vy";
        var oppositeCoordName = !isOpposite ? "vy" : "vx";
        var points = this.getVisiblePoints();
        for(var i = 0; i < points.length; i++){
            var p = points[i];
            var tmpCoord = p[coordName] === coord ? p[oppositeCoordName] : void 0;
            if (this._checkAxisVisibleAreaCoord(!isArgument, tmpCoord)) {
                oppositeCoord = tmpCoord;
                break;
            }
        }
        return oppositeCoord;
    },
    _getNearestPoints: (point, nextPoint)=>[
            point,
            nextPoint
        ],
    _getBezierPoints: ()=>[],
    _getNearestPointsByCoord (coord, isArgument) {
        var that = this;
        var rotated = that.getOptions().rotated;
        var isOpposite = !isArgument && !rotated || isArgument && rotated;
        var coordName = isOpposite ? "vy" : "vx";
        var allPoints = that.getPoints();
        var bezierPoints = that._getBezierPoints();
        var nearestPoints = [];
        if (allPoints.length > 1) allPoints.forEach((point, i)=>{
            var nextPoint = allPoints[i + 1];
            if (nextPoint && (point[coordName] <= coord && nextPoint[coordName] >= coord || point[coordName] >= coord && nextPoint[coordName] <= coord)) nearestPoints.push(that._getNearestPoints(point, nextPoint, bezierPoints));
        });
        else nearestPoints.push([
            allPoints[0],
            allPoints[0]
        ]);
        return nearestPoints;
    },
    getNeighborPoint: function(x, y) {
        var pCoord = this._options.rotated ? y : x;
        var nCoord = pCoord;
        var cat = this._trackersTranslator;
        var point = null;
        var minDistance;
        var oppositeCoord = this._options.rotated ? x : y;
        var oppositeCoordName = this._options.rotated ? "vx" : "vy";
        if (this.isVisible() && cat) {
            point = cat[pCoord];
            do {
                point = cat[nCoord] || cat[pCoord];
                pCoord--;
                nCoord++;
            }while ((pCoord >= 0 || nCoord < cat.length) && !point);
            if (Array.isArray(point)) {
                minDistance = $2a8d4339caea2716$var$_abs(point[0][oppositeCoordName] - oppositeCoord);
                (0, $8OLOW.each)(point, function(i, p) {
                    var distance = $2a8d4339caea2716$var$_abs(p[oppositeCoordName] - oppositeCoord);
                    if (minDistance >= distance) {
                        minDistance = distance;
                        point = p;
                    }
                });
            }
        }
        return point;
    },
    _applyVisibleArea: function() {
        var rotated = this._options.rotated;
        var visibleX = (rotated ? this.getValueAxis() : this.getArgumentAxis()).getVisibleArea();
        var visibleY = (rotated ? this.getArgumentAxis() : this.getValueAxis()).getVisibleArea();
        this._visibleArea = {
            minX: visibleX[0],
            maxX: visibleX[1],
            minY: visibleY[0],
            maxY: visibleY[1]
        };
    },
    getPointCenterByArg (arg) {
        var point = this.getPointsByArg(arg)[0];
        return point ? point.getCenterCoord() : void 0;
    }
});
$2a8d4339caea2716$export$5f7108acdc6fb162 = (0, $2oTOp.extend)({}, $2a8d4339caea2716$var$baseScatterMethods, {
    drawTrackers: function() {
        $2a8d4339caea2716$export$8fde8ebd684d5072.drawTrackers.call(this);
        var cat = this._trackersTranslator;
        var index;
        if (!this.isVisible()) return;
        (0, $8OLOW.each)(cat, function(i, category) {
            if (category) {
                index = i;
                return false;
            }
        });
        cat[index + 360] = cat[index];
    },
    getNeighborPoint: function(x, y) {
        var pos = (0, $dw9tZ.convertXYToPolar)(this.getValueAxis().getCenter(), x, y);
        return $2a8d4339caea2716$export$8fde8ebd684d5072.getNeighborPoint.call(this, pos.phi, pos.r);
    },
    _applyVisibleArea: function() {
        var canvas = this.getValueAxis().getCanvas();
        this._visibleArea = {
            minX: canvas.left,
            maxX: canvas.width - canvas.right,
            minY: canvas.top,
            maxY: canvas.height - canvas.bottom
        };
    },
    getSeriesPairCoord (params, isArgument) {
        var coords = null;
        var paramName = isArgument ? "argument" : "radius";
        var points = this.getVisiblePoints();
        for(var i = 0; i < points.length; i++){
            var p = points[i];
            var tmpPoint = (0, $6ntMu.isDefined)(p[paramName]) && (0, $6ntMu.isDefined)(params[paramName]) && p[paramName].valueOf() === params[paramName].valueOf() ? {
                x: p.x,
                y: p.y
            } : void 0;
            if ((0, $6ntMu.isDefined)(tmpPoint)) {
                coords = tmpPoint;
                break;
            }
        }
        return coords;
    }
});

});

parcelRegister("bmaKW", function(module, exports) {

$parcel$export(module.exports, "chart", function () { return $844a17bef79091e6$export$8fde8ebd684d5072; });
$parcel$export(module.exports, "polar", function () { return $844a17bef79091e6$export$5f7108acdc6fb162; });
/**
 * DevExtreme (esm/viz/series/line_series.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $3Ev8J = parcelRequire("3Ev8J");

var $5VpUx = parcelRequire("5VpUx");

var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $dw9tZ = parcelRequire("dw9tZ");

var $laqiS = parcelRequire("laqiS");
var $844a17bef79091e6$var$DISCRETE = "discrete";
var { round: $844a17bef79091e6$var$round, sqrt: $844a17bef79091e6$var$sqrt, pow: $844a17bef79091e6$var$pow, min: $844a17bef79091e6$var$min, max: $844a17bef79091e6$var$max, abs: $844a17bef79091e6$var$abs } = Math;
var $844a17bef79091e6$export$8fde8ebd684d5072 = {};
var $844a17bef79091e6$export$5f7108acdc6fb162 = {};
function $844a17bef79091e6$var$clonePoint(point, newX, newY, newAngle) {
    var p = (0, $5VpUx.clone)(point);
    p.x = newX;
    p.y = newY;
    p.angle = newAngle;
    return p;
}
function $844a17bef79091e6$var$getTangentPoint(point, prevPoint, centerPoint, tan, nextStepAngle) {
    var correctAngle = point.angle + nextStepAngle;
    var cosSin = (0, $dw9tZ.getCosAndSin)(correctAngle);
    var x = centerPoint.x + (point.radius + tan * nextStepAngle) * cosSin.cos;
    var y = centerPoint.y - (point.radius + tan * nextStepAngle) * cosSin.sin;
    return $844a17bef79091e6$var$clonePoint(prevPoint, x, y, correctAngle);
}
function $844a17bef79091e6$var$obtainCubicBezierTCoef(p, p0, p1, p2, p3) {
    var d = p0 - p;
    var c = 3 * p1 - 3 * p0;
    var b = 3 * p2 - 6 * p1 + 3 * p0;
    var a = p3 - 3 * p2 + 3 * p1 - p0;
    return (0, $laqiS.solveCubicEquation)(a, b, c, d);
}
var $844a17bef79091e6$var$lineMethods = {
    autoHidePointMarkersEnabled: ()=>true,
    _applyGroupSettings: function(style, settings, group) {
        settings = (0, $2oTOp.extend)(settings, style);
        this._applyElementsClipRect(settings);
        group.attr(settings);
    },
    _setGroupsSettings: function(animationEnabled) {
        var style = this._styles.normal;
        this._applyGroupSettings(style.elements, {
            class: "dxc-elements"
        }, this._elementsGroup);
        this._bordersGroup && this._applyGroupSettings(style.border, {
            class: "dxc-borders"
        }, this._bordersGroup);
        (0, $3Ev8J.chart)._setGroupsSettings.call(this, animationEnabled);
        animationEnabled && this._markersGroup && this._markersGroup.attr({
            opacity: .001
        });
    },
    _createGroups: function() {
        this._createGroup("_elementsGroup", this, this._group);
        this._areBordersVisible() && this._createGroup("_bordersGroup", this, this._group);
        (0, $3Ev8J.chart)._createGroups.call(this);
    },
    _areBordersVisible: function() {
        return false;
    },
    _getDefaultSegment: function(segment) {
        return {
            line: (0, $dw9tZ.map)(segment.line || [], function(pt) {
                return pt.getDefaultCoords();
            })
        };
    },
    _prepareSegment: function(points) {
        return {
            line: points
        };
    },
    _parseLineOptions: function(options, defaultColor) {
        return {
            stroke: options.color || defaultColor,
            "stroke-width": options.width,
            dashStyle: options.dashStyle || "solid"
        };
    },
    _parseStyle: function(options, defaultColor) {
        return {
            elements: this._parseLineOptions(options, defaultColor)
        };
    },
    _applyStyle: function(style) {
        this._elementsGroup && this._elementsGroup.attr(style.elements);
        (0, $8OLOW.each)(this._graphics || [], function(_, graphic) {
            graphic.line && graphic.line.attr({
                "stroke-width": style.elements["stroke-width"]
            }).sharp();
        });
    },
    _drawElement: function(segment, group) {
        return {
            line: this._createMainElement(segment.line, {
                "stroke-width": this._styles.normal.elements["stroke-width"]
            }).append(group)
        };
    },
    _removeElement: function(element) {
        element.line.remove();
    },
    _updateElement: function(element, segment, animate, animationComplete) {
        var params = {
            points: segment.line
        };
        var lineElement = element.line;
        animate ? lineElement.animate(params, {}, animationComplete) : lineElement.attr(params);
    },
    _animateComplete: function() {
        (0, $3Ev8J.chart)._animateComplete.call(this);
        this._markersGroup && this._markersGroup.animate({
            opacity: 1
        }, {
            duration: this._defaultDuration
        });
    },
    _animate: function() {
        var that = this;
        var lastIndex = that._graphics.length - 1;
        (0, $8OLOW.each)(that._graphics || [], function(i, elem) {
            var complete;
            if (i === lastIndex) complete = function() {
                that._animateComplete();
            };
            that._updateElement(elem, that._segments[i], true, complete);
        });
    },
    _drawPoint: function(options) {
        (0, $3Ev8J.chart)._drawPoint.call(this, {
            point: options.point,
            groups: options.groups
        });
    },
    _createMainElement: function(points, settings) {
        return this._renderer.path(points, "line").attr(settings);
    },
    _sortPoints: function(points, rotated) {
        return rotated ? points.sort(function(p1, p2) {
            return p2.y - p1.y;
        }) : points.sort(function(p1, p2) {
            return p1.x - p2.x;
        });
    },
    _drawSegment: function(points, animationEnabled, segmentCount, lastSegment) {
        var rotated = this._options.rotated;
        var segment = this._prepareSegment(points, rotated, lastSegment);
        this._segments.push(segment);
        if (!this._graphics[segmentCount]) this._graphics[segmentCount] = this._drawElement(animationEnabled ? this._getDefaultSegment(segment) : segment, this._elementsGroup);
        else if (!animationEnabled) this._updateElement(this._graphics[segmentCount], segment);
    },
    _getTrackerSettings: function() {
        var defaultTrackerWidth = this._defaultTrackerWidth;
        var strokeWidthFromElements = this._styles.normal.elements["stroke-width"];
        return {
            "stroke-width": strokeWidthFromElements > defaultTrackerWidth ? strokeWidthFromElements : defaultTrackerWidth,
            fill: "none"
        };
    },
    _getMainPointsFromSegment: function(segment) {
        return segment.line;
    },
    _drawTrackerElement: function(segment) {
        return this._createMainElement(this._getMainPointsFromSegment(segment), this._getTrackerSettings(segment));
    },
    _updateTrackerElement: function(segment, element) {
        var settings = this._getTrackerSettings(segment);
        settings.points = this._getMainPointsFromSegment(segment);
        element.attr(settings);
    },
    checkSeriesViewportCoord (axis, coord) {
        if (!(0, $3Ev8J.chart).checkSeriesViewportCoord.call(this)) return false;
        var range = axis.isArgumentAxis ? this.getArgumentRange() : this.getViewport();
        var min = axis.getTranslator().translate(range.categories ? range.categories[0] : range.min);
        var max = axis.getTranslator().translate(range.categories ? range.categories[range.categories.length - 1] : range.max);
        var rotated = this.getOptions().rotated;
        var inverted = axis.getOptions().inverted;
        return axis.isArgumentAxis && (!rotated && !inverted || rotated && inverted) || !axis.isArgumentAxis && (rotated && !inverted || !rotated && inverted) ? coord >= min && coord <= max : coord >= max && coord <= min;
    }
};
var $844a17bef79091e6$var$lineSeries = $844a17bef79091e6$export$8fde8ebd684d5072.line = (0, $2oTOp.extend)({}, (0, $3Ev8J.chart), $844a17bef79091e6$var$lineMethods, {
    getPointCenterByArg (arg) {
        var value = this.getArgumentAxis().getTranslator().translate(arg);
        return {
            x: value,
            y: value
        };
    },
    getSeriesPairCoord (coord, isArgument) {
        var oppositeCoord = null;
        var nearestPoints = this._getNearestPointsByCoord(coord, isArgument);
        var needValueCoord = isArgument && !this._options.rotated || !isArgument && this._options.rotated;
        for(var i = 0; i < nearestPoints.length; i++){
            var p = nearestPoints[i];
            var k = (p[1].vy - p[0].vy) / (p[1].vx - p[0].vx);
            var b = p[0].vy - p[0].vx * k;
            var tmpCoord = void 0;
            if (p[1].vx - p[0].vx === 0) tmpCoord = needValueCoord ? p[0].vy : p[0].vx;
            else tmpCoord = needValueCoord ? k * coord + b : (coord - b) / k;
            if (this._checkAxisVisibleAreaCoord(!isArgument, tmpCoord)) {
                oppositeCoord = tmpCoord;
                break;
            }
        }
        return oppositeCoord;
    }
});
$844a17bef79091e6$export$8fde8ebd684d5072.stepline = (0, $2oTOp.extend)({}, $844a17bef79091e6$var$lineSeries, {
    _calculateStepLinePoints (points) {
        var segment = [];
        var coordName = this._options.rotated ? "x" : "y";
        (0, $8OLOW.each)(points, function(i, pt) {
            var point;
            if (!i) {
                segment.push(pt);
                return;
            }
            var step = segment[segment.length - 1][coordName];
            if (step !== pt[coordName]) {
                point = (0, $5VpUx.clone)(pt);
                point[coordName] = step;
                segment.push(point);
            }
            segment.push(pt);
        });
        return segment;
    },
    _prepareSegment: function(points) {
        return $844a17bef79091e6$var$lineSeries._prepareSegment(this._calculateStepLinePoints(points));
    },
    getSeriesPairCoord (coord, isArgument) {
        var oppositeCoord;
        var rotated = this._options.rotated;
        var isOpposite = !isArgument && !rotated || isArgument && rotated;
        var coordName = !isOpposite ? "vx" : "vy";
        var oppositeCoordName = !isOpposite ? "vy" : "vx";
        var nearestPoints = this._getNearestPointsByCoord(coord, isArgument);
        for(var i = 0; i < nearestPoints.length; i++){
            var p = nearestPoints[i];
            var tmpCoord = void 0;
            if (isArgument) tmpCoord = coord !== p[1][coordName] ? p[0][oppositeCoordName] : p[1][oppositeCoordName];
            else tmpCoord = coord === p[0][coordName] ? p[0][oppositeCoordName] : p[1][oppositeCoordName];
            if (this._checkAxisVisibleAreaCoord(!isArgument, tmpCoord)) {
                oppositeCoord = tmpCoord;
                break;
            }
        }
        return oppositeCoord;
    }
});
$844a17bef79091e6$export$8fde8ebd684d5072.spline = (0, $2oTOp.extend)({}, $844a17bef79091e6$var$lineSeries, {
    _calculateBezierPoints: function(src, rotated) {
        var bezierPoints = [];
        var pointsCopy = src;
        var checkExtremum = function(otherPointCoord, pointCoord, controlCoord) {
            return otherPointCoord > pointCoord && controlCoord > otherPointCoord || otherPointCoord < pointCoord && controlCoord < otherPointCoord ? otherPointCoord : controlCoord;
        };
        if (1 !== pointsCopy.length) pointsCopy.forEach(function(curPoint, i) {
            var leftControlX;
            var leftControlY;
            var rightControlX;
            var rightControlY;
            var prevPoint = pointsCopy[i - 1];
            var nextPoint = pointsCopy[i + 1];
            var x1;
            var x2;
            var y1;
            var y2;
            var a;
            var b;
            var c;
            var xc;
            var yc;
            var shift;
            if (!i || i === pointsCopy.length - 1) {
                bezierPoints.push(curPoint, curPoint);
                return;
            }
            var xCur = curPoint.x;
            var yCur = curPoint.y;
            x1 = prevPoint.x;
            x2 = nextPoint.x;
            y1 = prevPoint.y;
            y2 = nextPoint.y;
            var curIsExtremum = !!(!rotated && (yCur <= prevPoint.y && yCur <= nextPoint.y || yCur >= prevPoint.y && yCur >= nextPoint.y) || rotated && (xCur <= prevPoint.x && xCur <= nextPoint.x || xCur >= prevPoint.x && xCur >= nextPoint.x));
            if (curIsExtremum) {
                if (!rotated) {
                    rightControlY = leftControlY = yCur;
                    rightControlX = (xCur + nextPoint.x) / 2;
                    leftControlX = (xCur + prevPoint.x) / 2;
                } else {
                    rightControlX = leftControlX = xCur;
                    rightControlY = (yCur + nextPoint.y) / 2;
                    leftControlY = (yCur + prevPoint.y) / 2;
                }
            } else {
                a = y2 - y1;
                b = x1 - x2;
                c = y1 * x2 - x1 * y2;
                if (!rotated) {
                    if (!b) {
                        bezierPoints.push(curPoint, curPoint, curPoint);
                        return;
                    }
                    xc = xCur;
                    yc = -1 * (a * xc + c) / b;
                    shift = yc - yCur;
                    y1 -= shift;
                    y2 -= shift;
                } else {
                    if (!a) {
                        bezierPoints.push(curPoint, curPoint, curPoint);
                        return;
                    }
                    yc = yCur;
                    xc = -1 * (b * yc + c) / a;
                    shift = xc - xCur;
                    x1 -= shift;
                    x2 -= shift;
                }
                rightControlX = (xCur + .5 * x2) / 1.5;
                rightControlY = (yCur + .5 * y2) / 1.5;
                leftControlX = (xCur + .5 * x1) / 1.5;
                leftControlY = (yCur + .5 * y1) / 1.5;
            }
            if (!rotated) {
                leftControlY = checkExtremum(prevPoint.y, yCur, leftControlY);
                rightControlY = checkExtremum(nextPoint.y, yCur, rightControlY);
            } else {
                leftControlX = checkExtremum(prevPoint.x, xCur, leftControlX);
                rightControlX = checkExtremum(nextPoint.x, xCur, rightControlX);
            }
            var leftPoint = $844a17bef79091e6$var$clonePoint(curPoint, leftControlX, leftControlY);
            var rightPoint = $844a17bef79091e6$var$clonePoint(curPoint, rightControlX, rightControlY);
            bezierPoints.push(leftPoint, curPoint, rightPoint);
        });
        else bezierPoints.push(pointsCopy[0]);
        return bezierPoints;
    },
    _prepareSegment: function(points, rotated) {
        return $844a17bef79091e6$var$lineSeries._prepareSegment(this._calculateBezierPoints(points, rotated));
    },
    _createMainElement: function(points, settings) {
        return this._renderer.path(points, "bezier").attr(settings);
    },
    getSeriesPairCoord (coord, isArgument) {
        var oppositeCoord = null;
        var isOpposite = !isArgument && !this._options.rotated || isArgument && this._options.rotated;
        var coordName = !isOpposite ? "vx" : "vy";
        var bezierCoordName = !isOpposite ? "x" : "y";
        var oppositeCoordName = !isOpposite ? "vy" : "vx";
        var bezierOppositeCoordName = !isOpposite ? "y" : "x";
        var axis = !isArgument ? this.getArgumentAxis() : this.getValueAxis();
        var visibleArea = axis.getVisibleArea();
        var nearestPoints = this._getNearestPointsByCoord(coord, isArgument);
        var _loop = function() {
            var p = nearestPoints[i];
            if (1 === p.length) visibleArea[0] <= p[0][oppositeCoordName] && visibleArea[1] >= p[0][oppositeCoordName] && (oppositeCoord = p[0][oppositeCoordName]);
            else {
                var ts = $844a17bef79091e6$var$obtainCubicBezierTCoef(coord, p[0][coordName], p[1][bezierCoordName], p[2][bezierCoordName], p[3][coordName]);
                ts.forEach((t)=>{
                    if (t >= 0 && t <= 1) {
                        var tmpCoord = Math.pow(1 - t, 3) * p[0][oppositeCoordName] + 3 * Math.pow(1 - t, 2) * t * p[1][bezierOppositeCoordName] + 3 * (1 - t) * t * t * p[2][bezierOppositeCoordName] + t * t * t * p[3][oppositeCoordName];
                        if (visibleArea[0] <= tmpCoord && visibleArea[1] >= tmpCoord) oppositeCoord = tmpCoord;
                    }
                });
            }
            if (null !== oppositeCoord) return "break";
        };
        for(var i = 0; i < nearestPoints.length; i++){
            var _ret = _loop();
            if ("break" === _ret) break;
        }
        return oppositeCoord;
    },
    _getNearestPoints (point, nextPoint, bezierPoints) {
        var index = bezierPoints.indexOf(point);
        return [
            point,
            bezierPoints[index + 1],
            bezierPoints[index + 2],
            nextPoint
        ];
    },
    _getBezierPoints () {
        return this._segments.length > 0 ? this._segments.reduce((a, seg)=>a.concat(seg.line), []) : [];
    }
});
$844a17bef79091e6$export$5f7108acdc6fb162.line = (0, $2oTOp.extend)({}, (0, $3Ev8J.polar), $844a17bef79091e6$var$lineMethods, {
    _sortPoints: function(points) {
        return points;
    },
    _prepareSegment: function(points, rotated, lastSegment) {
        var preparedPoints = [];
        var centerPoint = this.getValueAxis().getCenter();
        var i;
        lastSegment && this._closeSegment(points);
        if (this.argumentAxisType !== $844a17bef79091e6$var$DISCRETE && this.valueAxisType !== $844a17bef79091e6$var$DISCRETE) {
            for(i = 1; i < points.length; i++)preparedPoints = preparedPoints.concat(this._getTangentPoints(points[i], points[i - 1], centerPoint, i === points.length - 1));
            if (!preparedPoints.length) preparedPoints = points;
        } else return $844a17bef79091e6$var$lineSeries._prepareSegment.call(this, points);
        return {
            line: preparedPoints
        };
    },
    _getRemainingAngle: function(angle) {
        var normAngle = (0, $dw9tZ.normalizeAngle)(angle);
        return angle >= 0 ? 360 - normAngle : -normAngle;
    },
    _closeSegment (points) {
        var point;
        if (this._segments.length) point = this._segments[0].line[0];
        else point = $844a17bef79091e6$var$clonePoint(points[0], points[0].x, points[0].y, points[0].angle);
        point = this._modifyReflectedPoint(point, points[points.length - 1]);
        if (point) points.push(point);
    },
    _modifyReflectedPoint (point, lastPoint) {
        if (lastPoint.angle === point.angle) return;
        if ((0, $dw9tZ.normalizeAngle)($844a17bef79091e6$var$round(lastPoint.angle)) === (0, $dw9tZ.normalizeAngle)($844a17bef79091e6$var$round(point.angle))) point.angle = lastPoint.angle;
        else {
            var differenceAngle = lastPoint.angle - point.angle;
            point.angle = lastPoint.angle + this._getRemainingAngle(differenceAngle);
        }
        return point;
    },
    _getTangentPoints: function(point, prevPoint, centerPoint, isLastSegment) {
        var tangentPoints = [];
        var betweenAngle = Math.round(prevPoint.angle - point.angle);
        var tan = (prevPoint.radius - point.radius) / betweenAngle;
        var i;
        if (0 === betweenAngle) tangentPoints = [
            prevPoint,
            point
        ];
        else if (betweenAngle > 0) {
            var angle = isLastSegment ? betweenAngle : betweenAngle - 1;
            for(i = angle; i >= 0; i--)tangentPoints.push($844a17bef79091e6$var$getTangentPoint(point, prevPoint, centerPoint, tan, i));
        } else {
            var _angle = isLastSegment ? betweenAngle : betweenAngle + 1;
            for(i = 0; i >= _angle; i--)tangentPoints.push($844a17bef79091e6$var$getTangentPoint(point, prevPoint, centerPoint, tan, betweenAngle - i));
        }
        return tangentPoints;
    },
    getSeriesPairCoord (params, isArgument) {
        var argAxis = this.getArgumentAxis();
        var paramName = isArgument ? "angle" : "radius";
        var coordParam = params[paramName];
        var centerPoint = argAxis.getCenter();
        var isInsideInterval = (prevPoint, point, _ref)=>{
            var { x: x, y: y } = _ref;
            var p1, p2;
            return (p1 = {
                x: x,
                y: y
            }, p2 = centerPoint, $844a17bef79091e6$var$sqrt($844a17bef79091e6$var$pow(p1.x - p2.x, 2) + $844a17bef79091e6$var$pow(p1.y - p2.y, 2))) <= argAxis.getRadius() && $844a17bef79091e6$var$min(prevPoint.x, point.x) <= x && $844a17bef79091e6$var$max(prevPoint.x, point.x) >= x && $844a17bef79091e6$var$min(prevPoint.y, point.y) <= y && $844a17bef79091e6$var$max(prevPoint.y, point.y) >= y;
        };
        var coords;
        var neighborPoints = this.getNeighborPoints(coordParam, paramName);
        if (1 === neighborPoints.length) coords = neighborPoints[0];
        else if (neighborPoints.length > 1) {
            var prevPoint = neighborPoints[0];
            var point = neighborPoints[1];
            if (this.argumentAxisType !== $844a17bef79091e6$var$DISCRETE && this.valueAxisType !== $844a17bef79091e6$var$DISCRETE) {
                var tan;
                var stepAngle;
                if (isArgument) {
                    tan = (prevPoint.radius - point.radius) / (prevPoint.angle - point.angle);
                    stepAngle = coordParam - point.angle;
                } else {
                    tan = (prevPoint.radius - point.radius) / (prevPoint.angle - point.angle);
                    stepAngle = (coordParam - point.radius) / tan;
                }
                coords = $844a17bef79091e6$var$getTangentPoint(point, prevPoint, centerPoint, tan, stepAngle);
            } else if (isArgument) {
                var cosSin = (0, $dw9tZ.getCosAndSin)(-coordParam);
                var k1 = (point.y - prevPoint.y) / (point.x - prevPoint.x);
                var b1 = prevPoint.y - prevPoint.x * k1;
                var k2 = cosSin.sin / cosSin.cos;
                var b2 = centerPoint.y - k2 * centerPoint.x;
                var x = (b2 - b1) / (k1 - k2);
                var y = k1 * x + b1;
                if (isInsideInterval(prevPoint, point, {
                    x: x,
                    y: y
                })) {
                    var quarter = $844a17bef79091e6$var$abs((0, $laqiS.trunc)((360 + coordParam) / 90) % 4);
                    if (0 === quarter && x >= centerPoint.x && y <= centerPoint.y || 1 === quarter && x <= centerPoint.x && y <= centerPoint.y || 2 === quarter && x <= centerPoint.x && y >= centerPoint.y || 3 === quarter && x >= centerPoint.x && y >= centerPoint.y) coords = {
                        x: x,
                        y: y
                    };
                }
            } else {
                var k = (point.y - prevPoint.y) / (point.x - prevPoint.x);
                var y0 = prevPoint.y - prevPoint.x * k;
                var a = 1 + k * k;
                var b = -2 * centerPoint.x + 2 * k * y0 - 2 * k * centerPoint.y;
                var c = -$844a17bef79091e6$var$pow(coordParam, 2) + $844a17bef79091e6$var$pow(y0 - centerPoint.y, 2) + $844a17bef79091e6$var$pow(centerPoint.x, 2);
                var d = b * b - 4 * a * c;
                if (d >= 0) {
                    var x1 = (-b - $844a17bef79091e6$var$sqrt(d)) / (2 * a);
                    var x2 = (-b + $844a17bef79091e6$var$sqrt(d)) / (2 * a);
                    var y1 = k * x1 + y0;
                    var y2 = k * x2 + y0;
                    coords = isInsideInterval(prevPoint, point, {
                        x: x1,
                        y: y1
                    }) ? {
                        x: x1,
                        y: y1
                    } : isInsideInterval(prevPoint, point, {
                        x: x2,
                        y: y2
                    }) ? {
                        x: x2,
                        y: y2
                    } : void 0;
                }
            }
        }
        return coords;
    },
    getNeighborPoints (param, paramName) {
        var points = this.getPoints();
        var neighborPoints = [];
        if (this.getOptions().closed) {
            points = (0, $2oTOp.extend)(true, [], points);
            var lastPoint = points[points.length - 1];
            var firstPointCopy = $844a17bef79091e6$var$clonePoint(points[0], points[0].x, points[0].y, points[0].angle);
            var lastPointCopy = $844a17bef79091e6$var$clonePoint(lastPoint, lastPoint.x, lastPoint.y, lastPoint.angle);
            var rearwardRefPoint = this._modifyReflectedPoint(firstPointCopy, lastPoint);
            var forwardRefPoint = this._modifyReflectedPoint(lastPointCopy, points[0]);
            if (forwardRefPoint) points.unshift(forwardRefPoint);
            if (rearwardRefPoint) points.push(rearwardRefPoint);
        }
        for(var i = 1; i < points.length; i++){
            if (points[i - 1][paramName] === param) neighborPoints.push(points[i - 1]);
            else if (points[i][paramName] === param) neighborPoints.push(points[i]);
            else if (points[i][paramName] > param && points[i - 1][paramName] < param || points[i - 1][paramName] > param && points[i][paramName] < param) {
                neighborPoints.push(points[i - 1]);
                neighborPoints.push(points[i]);
            }
            if (neighborPoints.length > 0) break;
        }
        return neighborPoints;
    }
});

});

parcelRegister("9Qo4w", function(module, exports) {

$parcel$export(module.exports, "chart", function () { return $72aba49616487172$export$8fde8ebd684d5072; });
$parcel$export(module.exports, "polar", function () { return $72aba49616487172$export$5f7108acdc6fb162; });
/**
 * DevExtreme (esm/viz/series/area_series.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $5VpUx = parcelRequire("5VpUx");

var $2oTOp = parcelRequire("2oTOp");

var $3Ev8J = parcelRequire("3Ev8J");

var $bmaKW = parcelRequire("bmaKW");

var $dw9tZ = parcelRequire("dw9tZ");
var $72aba49616487172$var$chartLineSeries = (0, $bmaKW.chart).line;
var $72aba49616487172$var$polarLineSeries = (0, $bmaKW.polar).line;
var $72aba49616487172$var$_extend = (0, $2oTOp.extend);
var $72aba49616487172$var$calculateBezierPoints = (0, $bmaKW.chart).spline._calculateBezierPoints;
var $72aba49616487172$export$8fde8ebd684d5072 = {};
var $72aba49616487172$export$5f7108acdc6fb162 = {};
var $72aba49616487172$var$baseAreaMethods = {
    _createBorderElement: $72aba49616487172$var$chartLineSeries._createMainElement,
    _createLegendState: function(styleOptions, defaultColor) {
        return {
            fill: styleOptions.color || defaultColor,
            opacity: styleOptions.opacity,
            hatching: styleOptions.hatching
        };
    },
    getValueRangeInitialValue: function() {
        if ("logarithmic" !== this.valueAxisType && "datetime" !== this.valueType && false !== this.showZero) return 0;
        else return (0, $3Ev8J.chart).getValueRangeInitialValue.call(this);
    },
    _getDefaultSegment: function(segment) {
        var defaultSegment = $72aba49616487172$var$chartLineSeries._getDefaultSegment(segment);
        defaultSegment.area = defaultSegment.line.concat(defaultSegment.line.slice().reverse());
        return defaultSegment;
    },
    _updateElement: function(element, segment, animate, complete) {
        var lineParams = {
            points: segment.line
        };
        var areaParams = {
            points: segment.area
        };
        var borderElement = element.line;
        if (animate) {
            borderElement && borderElement.animate(lineParams);
            element.area.animate(areaParams, {}, complete);
        } else {
            borderElement && borderElement.attr(lineParams);
            element.area.attr(areaParams);
        }
    },
    _removeElement: function(element) {
        element.line && element.line.remove();
        element.area.remove();
    },
    _drawElement: function(segment) {
        return {
            line: this._bordersGroup && this._createBorderElement(segment.line, {
                "stroke-width": this._styles.normal.border["stroke-width"]
            }).append(this._bordersGroup),
            area: this._createMainElement(segment.area).append(this._elementsGroup)
        };
    },
    _applyStyle: function(style) {
        this._elementsGroup && this._elementsGroup.smartAttr(style.elements);
        this._bordersGroup && this._bordersGroup.attr(style.border);
        (this._graphics || []).forEach(function(graphic) {
            graphic.line && graphic.line.attr({
                "stroke-width": style.border["stroke-width"]
            }).sharp();
        });
    },
    _parseStyle: function(options, defaultColor, defaultBorderColor) {
        var borderOptions = options.border || {};
        var borderStyle = $72aba49616487172$var$chartLineSeries._parseLineOptions(borderOptions, defaultBorderColor);
        borderStyle.stroke = borderOptions.visible && borderStyle["stroke-width"] ? borderStyle.stroke : "none";
        borderStyle["stroke-width"] = borderStyle["stroke-width"] || 1;
        return {
            border: borderStyle,
            elements: {
                stroke: "none",
                fill: options.color || defaultColor,
                hatching: options.hatching,
                opacity: options.opacity
            }
        };
    },
    _areBordersVisible: function() {
        var options = this._options;
        return options.border.visible || options.hoverStyle.border.visible || options.selectionStyle.border.visible;
    },
    _createMainElement: function(points, settings) {
        return this._renderer.path(points, "area").attr(settings);
    },
    _getTrackerSettings: function(segment) {
        return {
            "stroke-width": segment.singlePointSegment ? this._defaultTrackerWidth : 0
        };
    },
    _getMainPointsFromSegment: function(segment) {
        return segment.area;
    }
};
function $72aba49616487172$var$createAreaPoints(points) {
    return (0, $dw9tZ.map)(points, function(pt) {
        return pt.getCoords();
    }).concat((0, $dw9tZ.map)(points.slice().reverse(), function(pt) {
        return pt.getCoords(true);
    }));
}
var $72aba49616487172$var$areaSeries = $72aba49616487172$export$8fde8ebd684d5072.area = $72aba49616487172$var$_extend({}, $72aba49616487172$var$chartLineSeries, $72aba49616487172$var$baseAreaMethods, {
    _prepareSegment (points, rotated) {
        var processedPoints = this._processSinglePointsAreaSegment(points, rotated);
        var areaPoints = $72aba49616487172$var$createAreaPoints(processedPoints);
        var argAxis = this.getArgumentAxis();
        if (argAxis.getAxisPosition) {
            var argAxisPosition = argAxis.getAxisPosition();
            var axisOptions = argAxis.getOptions();
            var edgeOffset = (!rotated ? -1 : 1) * Math.round(axisOptions.width / 2);
            if (axisOptions.visible) areaPoints.forEach((p, i)=>{
                if (p) {
                    var index = 1 === points.length ? 0 : i < points.length ? i : areaPoints.length - 1 - i;
                    rotated && p.x === points[index].defaultX && p.x === argAxisPosition - argAxis.getAxisShift() && (p.x += edgeOffset);
                    !rotated && p.y === points[index].defaultY && p.y === argAxisPosition - argAxis.getAxisShift() && (p.y += edgeOffset);
                }
            });
        }
        return {
            line: processedPoints,
            area: areaPoints,
            singlePointSegment: processedPoints !== points
        };
    },
    _processSinglePointsAreaSegment: function(points, rotated) {
        if (points && 1 === points.length) {
            var p = points[0];
            var p1 = (0, $5VpUx.clone)(p);
            p1[rotated ? "y" : "x"] += 1;
            p1.argument = null;
            return [
                p,
                p1
            ];
        }
        return points;
    }
});
$72aba49616487172$export$5f7108acdc6fb162.area = $72aba49616487172$var$_extend({}, $72aba49616487172$var$polarLineSeries, $72aba49616487172$var$baseAreaMethods, {
    _prepareSegment: function(points, rotated, lastSegment) {
        lastSegment && $72aba49616487172$var$polarLineSeries._closeSegment.call(this, points);
        return $72aba49616487172$var$areaSeries._prepareSegment.call(this, points);
    },
    _processSinglePointsAreaSegment: function(points) {
        return (0, $bmaKW.polar).line._prepareSegment.call(this, points).line;
    }
});
$72aba49616487172$export$8fde8ebd684d5072.steparea = $72aba49616487172$var$_extend({}, $72aba49616487172$var$areaSeries, {
    _prepareSegment: function(points, rotated) {
        var stepLineSeries = (0, $bmaKW.chart).stepline;
        points = $72aba49616487172$var$areaSeries._processSinglePointsAreaSegment(points, rotated);
        return $72aba49616487172$var$areaSeries._prepareSegment.call(this, stepLineSeries._calculateStepLinePoints.call(this, points), rotated);
    },
    getSeriesPairCoord: (0, $bmaKW.chart).stepline.getSeriesPairCoord
});
$72aba49616487172$export$8fde8ebd684d5072.splinearea = $72aba49616487172$var$_extend({}, $72aba49616487172$var$areaSeries, {
    _areaPointsToSplineAreaPoints: function(areaPoints) {
        var previousMiddlePoint = areaPoints[areaPoints.length / 2 - 1];
        var middlePoint = areaPoints[areaPoints.length / 2];
        areaPoints.splice(areaPoints.length / 2, 0, {
            x: previousMiddlePoint.x,
            y: previousMiddlePoint.y
        }, {
            x: middlePoint.x,
            y: middlePoint.y
        });
    },
    _prepareSegment: function(points, rotated) {
        var processedPoints = $72aba49616487172$var$areaSeries._processSinglePointsAreaSegment(points, rotated);
        var areaSegment = $72aba49616487172$var$areaSeries._prepareSegment.call(this, $72aba49616487172$var$calculateBezierPoints(processedPoints, rotated));
        this._areaPointsToSplineAreaPoints(areaSegment.area);
        areaSegment.singlePointSegment = processedPoints !== points;
        return areaSegment;
    },
    _getDefaultSegment: function(segment) {
        var areaDefaultSegment = $72aba49616487172$var$areaSeries._getDefaultSegment(segment);
        this._areaPointsToSplineAreaPoints(areaDefaultSegment.area);
        return areaDefaultSegment;
    },
    _createMainElement: function(points, settings) {
        return this._renderer.path(points, "bezierarea").attr(settings);
    },
    _createBorderElement: (0, $bmaKW.chart).spline._createMainElement,
    getSeriesPairCoord: (0, $bmaKW.chart).spline.getSeriesPairCoord,
    _getNearestPoints: (0, $bmaKW.chart).spline._getNearestPoints,
    _getBezierPoints: (0, $bmaKW.chart).spline._getBezierPoints,
    obtainCubicBezierTCoef: (0, $bmaKW.chart).spline.obtainCubicBezierTCoef
});

});

parcelRegister("aaioz", function(module, exports) {

$parcel$export(module.exports, "chart", function () { return $76691b7f1d25c226$export$8fde8ebd684d5072; });
$parcel$export(module.exports, "polar", function () { return $76691b7f1d25c226$export$5f7108acdc6fb162; });
/**
 * DevExtreme (esm/viz/series/bar_series.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $3Ev8J = parcelRequire("3Ev8J");

var $9Qo4w = parcelRequire("9Qo4w");

var $dw9tZ = parcelRequire("dw9tZ");

var $6ntMu = parcelRequire("6ntMu");
var $76691b7f1d25c226$var$areaSeries = (0, $9Qo4w.chart).area;
var $76691b7f1d25c226$var$chartSeries = $3Ev8J.chart;
var $76691b7f1d25c226$var$polarSeries = $3Ev8J.polar;
var $76691b7f1d25c226$var$_extend = (0, $2oTOp.extend);
var $76691b7f1d25c226$var$_each = (0, $8OLOW.each);
var $76691b7f1d25c226$export$8fde8ebd684d5072 = {};
var $76691b7f1d25c226$export$5f7108acdc6fb162 = {};
var $76691b7f1d25c226$var$baseBarSeriesMethods = {
    _createLegendState: function(styleOptions, defaultColor) {
        return {
            fill: styleOptions.color || defaultColor,
            hatching: styleOptions.hatching
        };
    },
    _parsePointStyle: function(style, defaultColor, defaultBorderColor) {
        var color = style.color || defaultColor;
        var base = $76691b7f1d25c226$var$chartSeries._parsePointStyle.call(this, style, color, defaultBorderColor);
        base.fill = color;
        base.hatching = style.hatching;
        base.dashStyle = style.border && style.border.dashStyle || "solid";
        delete base.r;
        return base;
    },
    _applyMarkerClipRect: function(settings) {
        settings["clip-path"] = null;
    },
    _setGroupsSettings: function(animationEnabled, firstDrawing) {
        var that = this;
        var settings = {};
        $76691b7f1d25c226$var$chartSeries._setGroupsSettings.apply(that, arguments);
        if (animationEnabled && firstDrawing) settings = this._getAffineCoordOptions();
        else if (!animationEnabled) settings = {
            scaleX: 1,
            scaleY: 1,
            translateX: 0,
            translateY: 0
        };
        that._markersGroup.attr(settings);
    },
    _drawPoint: function(options) {
        options.hasAnimation = options.hasAnimation && !options.firstDrawing;
        options.firstDrawing = false;
        $76691b7f1d25c226$var$chartSeries._drawPoint.call(this, options);
    },
    _getMainColor: function() {
        return this._options.mainSeriesColor;
    },
    _createPointStyles: function(pointOptions) {
        var mainColor = pointOptions.color || this._getMainColor();
        return {
            normal: this._parsePointStyle(pointOptions, mainColor, mainColor),
            hover: this._parsePointStyle(pointOptions.hoverStyle || {}, mainColor, mainColor),
            selection: this._parsePointStyle(pointOptions.selectionStyle || {}, mainColor, mainColor)
        };
    },
    _updatePointsVisibility: function() {
        var visibility = this._options.visible;
        (0, $8OLOW.each)(this._points, function(_, point) {
            point._options.visible = visibility;
        });
    },
    _getOptionsForPoint: function() {
        return this._options;
    },
    _animate: function(firstDrawing) {
        var that = this;
        that._animatePoints(firstDrawing, function() {
            that._animateComplete();
        }, function(drawnPoints, complete) {
            var lastPointIndex = drawnPoints.length - 1;
            $76691b7f1d25c226$var$_each(drawnPoints || [], function(i, point) {
                point.animate(i === lastPointIndex ? complete : void 0, point.getMarkerCoords());
            });
        });
    },
    getValueRangeInitialValue: $76691b7f1d25c226$var$areaSeries.getValueRangeInitialValue,
    _patchMarginOptions: function(options) {
        var _this$getArgumentAxis;
        options.checkInterval = !this.useAggregation() || (null === (_this$getArgumentAxis = this.getArgumentAxis()) || void 0 === _this$getArgumentAxis ? void 0 : _this$getArgumentAxis.aggregatedPointBetweenTicks());
        return options;
    },
    _defaultAggregator: "sum",
    _defineDrawingState () {},
    usePointsToDefineAutoHiding: ()=>false
};
$76691b7f1d25c226$export$8fde8ebd684d5072.bar = $76691b7f1d25c226$var$_extend({}, $76691b7f1d25c226$var$chartSeries, $76691b7f1d25c226$var$baseBarSeriesMethods, {
    _getAffineCoordOptions: function() {
        var rotated = this._options.rotated;
        var direction = rotated ? "X" : "Y";
        var settings = {
            scaleX: rotated ? .001 : 1,
            scaleY: rotated ? 1 : .001
        };
        settings["translate" + direction] = this.getValueAxis().getTranslator().translate("canvas_position_default");
        return settings;
    },
    _animatePoints: function(firstDrawing, complete, animateFunc) {
        this._markersGroup.animate({
            scaleX: 1,
            scaleY: 1,
            translateY: 0,
            translateX: 0
        }, void 0, complete);
        if (!firstDrawing) animateFunc(this._drawnPoints, complete);
    },
    checkSeriesViewportCoord (axis, coord) {
        if (!$76691b7f1d25c226$var$chartSeries.checkSeriesViewportCoord.call(this)) return false;
        if (axis.isArgumentAxis) return true;
        var translator = axis.getTranslator();
        var range = this.getViewport();
        var min = translator.translate(range.categories ? range.categories[0] : range.min);
        var max = translator.translate(range.categories ? range.categories[range.categories.length - 1] : range.max);
        var rotated = this.getOptions().rotated;
        var inverted = axis.getOptions().inverted;
        return rotated && !inverted || !rotated && inverted ? coord >= min && coord <= max : coord >= max && coord <= min;
    },
    getSeriesPairCoord (coord, isArgument) {
        var oppositeCoord = null;
        var { rotated: rotated } = this._options;
        var isOpposite = !isArgument && !rotated || isArgument && rotated;
        var coordName = isOpposite ? "vy" : "vx";
        var oppositeCoordName = isOpposite ? "vx" : "vy";
        var points = this.getPoints();
        for(var i = 0; i < points.length; i++){
            var p = points[i];
            var tmpCoord = void 0;
            if (isArgument) tmpCoord = p.getCenterCoord()[coordName[1]] === coord ? p[oppositeCoordName] : void 0;
            else tmpCoord = p[coordName] === coord ? p[oppositeCoordName] : void 0;
            if (this._checkAxisVisibleAreaCoord(!isArgument, tmpCoord)) {
                oppositeCoord = tmpCoord;
                break;
            }
        }
        return oppositeCoord;
    }
});
$76691b7f1d25c226$export$5f7108acdc6fb162.bar = $76691b7f1d25c226$var$_extend({}, $76691b7f1d25c226$var$polarSeries, $76691b7f1d25c226$var$baseBarSeriesMethods, {
    _animatePoints: function(firstDrawing, complete, animateFunc) {
        animateFunc(this._drawnPoints, complete);
    },
    _setGroupsSettings: $76691b7f1d25c226$var$chartSeries._setGroupsSettings,
    _drawPoint: function(point, groups, animationEnabled) {
        $76691b7f1d25c226$var$chartSeries._drawPoint.call(this, point, groups, animationEnabled);
    },
    _parsePointStyle: function(style) {
        var base = $76691b7f1d25c226$var$baseBarSeriesMethods._parsePointStyle.apply(this, arguments);
        base.opacity = style.opacity;
        return base;
    },
    _createGroups: $76691b7f1d25c226$var$chartSeries._createGroups,
    _setMarkerGroupSettings: function() {
        var markersSettings = this._createPointStyles(this._getMarkerGroupOptions()).normal;
        markersSettings.class = "dxc-markers";
        this._applyMarkerClipRect(markersSettings);
        var groupSettings = $76691b7f1d25c226$var$_extend({}, markersSettings);
        delete groupSettings.opacity;
        this._markersGroup.attr(groupSettings);
    },
    getSeriesPairCoord (params, isArgument) {
        var coords = null;
        var paramName = isArgument ? "argument" : "radius";
        var points = this.getVisiblePoints();
        var argAxis = this.getArgumentAxis();
        var startAngle = argAxis.getAngles()[0];
        for(var i = 0; i < points.length; i++){
            var p = points[i];
            var tmpPoint = (0, $6ntMu.isDefined)(p[paramName]) && (0, $6ntMu.isDefined)(params[paramName]) && p[paramName].valueOf() === params[paramName].valueOf() ? (0, $dw9tZ.convertPolarToXY)(argAxis.getCenter(), startAngle, -argAxis.getTranslatedAngle(p.angle), p.radius) : void 0;
            if ((0, $6ntMu.isDefined)(tmpPoint)) {
                coords = tmpPoint;
                break;
            }
        }
        return coords;
    },
    _createLegendState: $76691b7f1d25c226$var$areaSeries._createLegendState
});

});

parcelRegister("iutGb", function(module, exports) {

$parcel$export(module.exports, "chart", function () { return $d7620d0ae394d037$export$8fde8ebd684d5072; });
/**
 * DevExtreme (esm/viz/series/range_series.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $6ntMu = parcelRequire("6ntMu");

var $dw9tZ = parcelRequire("dw9tZ");

var $gcp4g = parcelRequire("gcp4g");

var $3Ev8J = parcelRequire("3Ev8J");

var $aaioz = parcelRequire("aaioz");

var $9Qo4w = parcelRequire("9Qo4w");
var $d7620d0ae394d037$var$_extend = (0, $2oTOp.extend);
var $d7620d0ae394d037$var$barSeries = (0, $aaioz.chart).bar;
var $d7620d0ae394d037$var$areaSeries = (0, $9Qo4w.chart).area;
var $d7620d0ae394d037$export$8fde8ebd684d5072 = {};
var $d7620d0ae394d037$var$baseRangeSeries = {
    areErrorBarsVisible: (0, $gcp4g.noop),
    _createErrorBarGroup: (0, $gcp4g.noop),
    _checkData: function(data, skippedFields) {
        var valueFields = this.getValueFields();
        return (0, $3Ev8J.chart)._checkData.call(this, data, skippedFields, {
            minValue: valueFields[0],
            value: valueFields[1]
        }) && data.minValue === data.minValue;
    },
    getValueRangeInitialValue: (0, $3Ev8J.chart).getValueRangeInitialValue,
    _getPointDataSelector: function(data) {
        var valueFields = this.getValueFields();
        var val1Field = valueFields[0];
        var val2Field = valueFields[1];
        var tagField = this.getTagField();
        var argumentField = this.getArgumentField();
        return (data)=>({
                tag: data[tagField],
                minValue: this._processEmptyValue(data[val1Field]),
                value: this._processEmptyValue(data[val2Field]),
                argument: data[argumentField],
                data: data
            });
    },
    _defaultAggregator: "range",
    _aggregators: {
        range (_ref, series) {
            var { intervalStart: intervalStart, intervalEnd: intervalEnd, data: data } = _ref;
            if (!data.length) return;
            var valueFields = series.getValueFields();
            var val1Field = valueFields[0];
            var val2Field = valueFields[1];
            var result = data.reduce((result, item)=>{
                var val1 = item[val1Field];
                var val2 = item[val2Field];
                if (!(0, $6ntMu.isDefined)(val1) || !(0, $6ntMu.isDefined)(val2)) return result;
                result[val1Field] = Math.min(result[val1Field], Math.min(val1, val2));
                result[val2Field] = Math.max(result[val2Field], Math.max(val1, val2));
                return result;
            }, {
                [val1Field]: 1 / 0,
                [val2Field]: -1 / 0,
                [series.getArgumentField()]: series._getIntervalCenter(intervalStart, intervalEnd)
            });
            if (!isFinite(result[val1Field]) || !isFinite(result[val2Field])) {
                if (data.filter((i)=>null === i[val1Field] && null === i[val2Field]).length === data.length) result[val1Field] = result[val2Field] = null;
                else return;
            }
            return result;
        }
    },
    getValueFields: function() {
        return [
            this._options.rangeValue1Field || "val1",
            this._options.rangeValue2Field || "val2"
        ];
    },
    getSeriesPairCoord (coord, isArgument) {
        var oppositeCoord = null;
        var { rotated: rotated } = this._options;
        var isOpposite = !isArgument && !rotated || isArgument && rotated;
        var coordName = isOpposite ? "vy" : "vx";
        var minCoordName = rotated ? "minX" : "minY";
        var oppositeCoordName = isOpposite ? "vx" : "vy";
        var points = this.getPoints();
        for(var i = 0; i < points.length; i++){
            var p = points[i];
            var tmpCoord = void 0;
            if (isArgument) tmpCoord = p.getCenterCoord()[coordName[1]] === coord ? p[oppositeCoordName] : void 0;
            else {
                var coords = [
                    Math.min(p[coordName], p[minCoordName]),
                    Math.max(p[coordName], p[minCoordName])
                ];
                tmpCoord = coord >= coords[0] && coord <= coords[1] ? p[oppositeCoordName] : void 0;
            }
            if (this._checkAxisVisibleAreaCoord(!isArgument, tmpCoord)) {
                oppositeCoord = tmpCoord;
                break;
            }
        }
        return oppositeCoord;
    }
};
$d7620d0ae394d037$export$8fde8ebd684d5072.rangebar = $d7620d0ae394d037$var$_extend({}, $d7620d0ae394d037$var$barSeries, $d7620d0ae394d037$var$baseRangeSeries);
$d7620d0ae394d037$export$8fde8ebd684d5072.rangearea = $d7620d0ae394d037$var$_extend({}, $d7620d0ae394d037$var$areaSeries, {
    _drawPoint: function(options) {
        var point = options.point;
        if (point.isInVisibleArea()) {
            point.clearVisibility();
            point.draw(this._renderer, options.groups);
            this._drawnPoints.push(point);
            if (!point.visibleTopMarker) point.hideMarker("top");
            if (!point.visibleBottomMarker) point.hideMarker("bottom");
        } else point.setInvisibility();
    },
    _prepareSegment: function(points, rotated) {
        var processedPoints = this._processSinglePointsAreaSegment(points, rotated);
        var processedMinPointsCoords = (0, $dw9tZ.map)(processedPoints, function(pt) {
            return pt.getCoords(true);
        });
        return {
            line: processedPoints,
            bottomLine: processedMinPointsCoords,
            area: (0, $dw9tZ.map)(processedPoints, function(pt) {
                return pt.getCoords();
            }).concat(processedMinPointsCoords.slice().reverse()),
            singlePointSegment: processedPoints !== points
        };
    },
    _getDefaultSegment: function(segment) {
        var defaultSegment = $d7620d0ae394d037$var$areaSeries._getDefaultSegment.call(this, segment);
        defaultSegment.bottomLine = defaultSegment.line;
        return defaultSegment;
    },
    _removeElement: function(element) {
        $d7620d0ae394d037$var$areaSeries._removeElement.call(this, element);
        element.bottomLine && element.bottomLine.remove();
    },
    _drawElement: function(segment, group) {
        var drawnElement = $d7620d0ae394d037$var$areaSeries._drawElement.call(this, segment, group);
        drawnElement.bottomLine = this._bordersGroup && this._createBorderElement(segment.bottomLine, {
            "stroke-width": this._styles.normal.border["stroke-width"]
        }).append(this._bordersGroup);
        return drawnElement;
    },
    _applyStyle: function(style) {
        var elementsGroup = this._elementsGroup;
        var bordersGroup = this._bordersGroup;
        elementsGroup && elementsGroup.smartAttr(style.elements);
        bordersGroup && bordersGroup.attr(style.border);
        (this._graphics || []).forEach(function(graphic) {
            graphic.line && graphic.line.attr({
                "stroke-width": style.border["stroke-width"]
            });
            graphic.bottomLine && graphic.bottomLine.attr({
                "stroke-width": style.border["stroke-width"]
            });
        });
    },
    _updateElement: function(element, segment, animate, complete) {
        var bottomLineParams = {
            points: segment.bottomLine
        };
        var bottomBorderElement = element.bottomLine;
        $d7620d0ae394d037$var$areaSeries._updateElement.apply(this, arguments);
        if (bottomBorderElement) animate ? bottomBorderElement.animate(bottomLineParams) : bottomBorderElement.attr(bottomLineParams);
    }
}, $d7620d0ae394d037$var$baseRangeSeries);

});

parcelRegister("jd19x", function(module, exports) {

$parcel$export(module.exports, "chart", function () { return $dfc0202769a2817d$export$8fde8ebd684d5072; });
/**
 * DevExtreme (esm/viz/series/bubble_series.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $bmaKW = parcelRequire("bmaKW");

var $3Ev8J = parcelRequire("3Ev8J");

var $9Qo4w = parcelRequire("9Qo4w");

var $aaioz = parcelRequire("aaioz");

var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $gcp4g = parcelRequire("gcp4g");
var $dfc0202769a2817d$var$lineSeries = (0, $bmaKW.chart).line;
var $dfc0202769a2817d$var$areaSeries = (0, $9Qo4w.chart).area;
var $dfc0202769a2817d$var$chartBarSeries = (0, $aaioz.chart).bar;
var $dfc0202769a2817d$var$polarBarSeries = (0, $aaioz.polar).bar;
var $dfc0202769a2817d$var$_extend = (0, $2oTOp.extend);
var $dfc0202769a2817d$var$_each = (0, $8OLOW.each);
var $dfc0202769a2817d$var$_noop = (0, $gcp4g.noop);
var $dfc0202769a2817d$export$8fde8ebd684d5072 = {};
$dfc0202769a2817d$export$8fde8ebd684d5072.bubble = $dfc0202769a2817d$var$_extend({}, (0, $3Ev8J.chart), {
    _calculateErrorBars: $dfc0202769a2817d$var$_noop,
    _getMainColor: $dfc0202769a2817d$var$chartBarSeries._getMainColor,
    _createPointStyles: $dfc0202769a2817d$var$chartBarSeries._createPointStyles,
    _updatePointsVisibility: $dfc0202769a2817d$var$chartBarSeries._updatePointsVisibility,
    _getOptionsForPoint: $dfc0202769a2817d$var$chartBarSeries._getOptionsForPoint,
    _applyMarkerClipRect: $dfc0202769a2817d$var$lineSeries._applyElementsClipRect,
    _parsePointStyle: $dfc0202769a2817d$var$polarBarSeries._parsePointStyle,
    _createLegendState: $dfc0202769a2817d$var$areaSeries._createLegendState,
    _setMarkerGroupSettings: $dfc0202769a2817d$var$polarBarSeries._setMarkerGroupSettings,
    areErrorBarsVisible: $dfc0202769a2817d$var$_noop,
    _createErrorBarGroup: $dfc0202769a2817d$var$_noop,
    _checkData: function(data, skippedFields) {
        return (0, $3Ev8J.chart)._checkData.call(this, data, skippedFields, {
            value: this.getValueFields()[0],
            size: this.getSizeField()
        });
    },
    _getPointDataSelector: function(data, options) {
        var sizeField = this.getSizeField();
        var baseGetter = (0, $3Ev8J.chart)._getPointDataSelector.call(this);
        return (data)=>{
            var pointData = baseGetter(data);
            pointData.size = data[sizeField];
            return pointData;
        };
    },
    _aggregators: {
        avg (_ref, series) {
            var { data: data, intervalStart: intervalStart, intervalEnd: intervalEnd } = _ref;
            if (!data.length) return;
            var valueField = series.getValueFields()[0];
            var sizeField = series.getSizeField();
            var aggregate = data.reduce((result, item)=>{
                result[0] += item[valueField];
                result[1] += item[sizeField];
                result[2]++;
                return result;
            }, [
                0,
                0,
                0
            ]);
            return {
                [valueField]: aggregate[0] / aggregate[2],
                [sizeField]: aggregate[1] / aggregate[2],
                [series.getArgumentField()]: series._getIntervalCenter(intervalStart, intervalEnd)
            };
        }
    },
    getValueFields: function() {
        return [
            this._options.valueField || "val"
        ];
    },
    getSizeField: function() {
        return this._options.sizeField || "size";
    },
    _animate: function() {
        var that = this;
        var lastPointIndex = that._drawnPoints.length - 1;
        var labelsGroup = that._labelsGroup;
        var labelAnimFunc = function() {
            labelsGroup && labelsGroup.animate({
                opacity: 1
            }, {
                duration: that._defaultDuration
            });
        };
        $dfc0202769a2817d$var$_each(that._drawnPoints || [], function(i, p) {
            p.animate(i === lastPointIndex ? labelAnimFunc : void 0, {
                r: p.bubbleSize,
                translateX: p.x,
                translateY: p.y
            });
        });
    },
    _patchMarginOptions: function(options) {
        options.processBubbleSize = true;
        return options;
    }
});

});

parcelRegister("1nMRh", function(module, exports) {

$parcel$export(module.exports, "pie", function () { return $101dd6b068782510$export$47a9dca4012556c5; });
$parcel$export(module.exports, "doughnut", function () { return $101dd6b068782510$export$a34b926d586e6ab8; });
$parcel$export(module.exports, "donut", function () { return $101dd6b068782510$export$93e7d1dbd4c55fc0; });
/**
 * DevExtreme (esm/viz/series/pie_series.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $gcp4g = parcelRequire("gcp4g");

var $8OLOW = parcelRequire("8OLOW");

var $3Ev8J = parcelRequire("3Ev8J");

var $dw9tZ = parcelRequire("dw9tZ");

var $2oTOp = parcelRequire("2oTOp");

var $aaioz = parcelRequire("aaioz");
var $101dd6b068782510$var$chartScatterSeries = (0, $3Ev8J.chart);
var $101dd6b068782510$var$barSeries = (0, $aaioz.chart).bar;
var $101dd6b068782510$var$_extend = (0, $2oTOp.extend);
var $101dd6b068782510$var$_each = (0, $8OLOW.each);
var $101dd6b068782510$var$_noop = (0, $gcp4g.noop);
var $101dd6b068782510$var$_map = (0, $dw9tZ.map);
var $101dd6b068782510$var$_isFinite = isFinite;
var $101dd6b068782510$var$_max = Math.max;
var $101dd6b068782510$var$ANIMATION_DURATION = .7;
var $101dd6b068782510$var$INSIDE = "inside";
var $101dd6b068782510$export$47a9dca4012556c5 = $101dd6b068782510$var$_extend({}, $101dd6b068782510$var$barSeries, {
    _setGroupsSettings: function() {
        $101dd6b068782510$var$chartScatterSeries._setGroupsSettings.apply(this, arguments);
        this._labelsGroup.attr({
            "pointer-events": null
        });
    },
    _createErrorBarGroup: $101dd6b068782510$var$_noop,
    _drawPoint: function(options) {
        var point = options.point;
        var legendCallback = this._legendCallback;
        $101dd6b068782510$var$chartScatterSeries._drawPoint.call(this, options);
        !point.isVisible() && point.setInvisibility();
        point.isSelected() && legendCallback();
    },
    _getOldPoint: function(data, oldPointsByArgument, index) {
        var point = (this._points || [])[index];
        if (point) oldPointsByArgument[point.argument.valueOf()] = oldPointsByArgument[point.argument.valueOf()].filter((p)=>p !== point);
        return point;
    },
    adjustLabels: function(moveLabelsFromCenter) {
        return (this._points || []).reduce((r, p)=>{
            if (p._label.isVisible()) {
                p.setLabelTrackerData();
                r = p.applyWordWrap(moveLabelsFromCenter) || r;
                p.updateLabelCoord(moveLabelsFromCenter);
                return r;
            }
        }, false);
    },
    _applyElementsClipRect: $101dd6b068782510$var$_noop,
    getColor: $101dd6b068782510$var$_noop,
    areErrorBarsVisible: $101dd6b068782510$var$_noop,
    drawLabelsWOPoints: function() {
        if (this._options.label.position === $101dd6b068782510$var$INSIDE) return false;
        this._labelsGroup.append(this._extGroups.labelsGroup);
        (this._points || []).forEach(function(point) {
            point.drawLabel();
        });
        return true;
    },
    getPointsCount: function() {
        return this._data.filter((d)=>this._checkData(d)).length;
    },
    setMaxPointsCount: function(count) {
        this._pointsCount = count;
    },
    _getCreatingPointOptions: function(data, dataIndex) {
        return this._getPointOptions(data, dataIndex);
    },
    _updateOptions: function(options) {
        this.labelSpace = 0;
        this.innerRadius = "pie" === this.type ? 0 : options.innerRadius;
    },
    _checkData: function(data, skippedFields) {
        var base = $101dd6b068782510$var$barSeries._checkData.call(this, data, skippedFields, {
            value: this.getValueFields()[0]
        });
        return this._options.paintNullPoints ? base : base && null !== data.value;
    },
    _createGroups: $101dd6b068782510$var$chartScatterSeries._createGroups,
    _setMarkerGroupSettings: function() {
        this._markersGroup.attr({
            class: "dxc-markers"
        });
    },
    _getMainColor (data, point) {
        var pointsByArg = this.getPointsByArg(data.argument);
        var argumentIndex = point ? pointsByArg.indexOf(point) : pointsByArg.length;
        return this._options.mainSeriesColor(data.argument, argumentIndex, this._pointsCount);
    },
    _getPointOptions: function(data) {
        return this._parsePointOptions(this._preparePointOptions(), this._options.label, data);
    },
    _getRangeData: function() {
        return this._rangeData;
    },
    _createPointStyles: function(pointOptions, data, point) {
        var mainColor = pointOptions.color || this._getMainColor(data, point);
        return {
            normal: this._parsePointStyle(pointOptions, mainColor, mainColor),
            hover: this._parsePointStyle(pointOptions.hoverStyle, mainColor, mainColor),
            selection: this._parsePointStyle(pointOptions.selectionStyle, mainColor, mainColor),
            legendStyles: {
                normal: this._createLegendState(pointOptions, mainColor),
                hover: this._createLegendState(pointOptions.hoverStyle, mainColor),
                selection: this._createLegendState(pointOptions.selectionStyle, mainColor)
            }
        };
    },
    _getArrangeMinShownValue: function(points, total) {
        var minSegmentSize = this._options.minSegmentSize;
        var totalMinSegmentSize = 0;
        var totalNotMinValues = 0;
        total = total || points.length;
        $101dd6b068782510$var$_each(points, function(_, point) {
            if (point.isVisible()) {
                if (point.normalInitialValue < minSegmentSize * total / 360) totalMinSegmentSize += minSegmentSize;
                else totalNotMinValues += point.normalInitialValue;
            }
        });
        return totalMinSegmentSize < 360 ? minSegmentSize * totalNotMinValues / (360 - totalMinSegmentSize) : 0;
    },
    _applyArrangeCorrection: function(points, minShownValue, total) {
        var options = this._options;
        var isClockWise = "anticlockwise" !== options.segmentsDirection;
        var shiftedAngle = $101dd6b068782510$var$_isFinite(options.startAngle) ? (0, $dw9tZ.normalizeAngle)(options.startAngle) : 0;
        var minSegmentSize = options.minSegmentSize;
        var percent;
        var correction = 0;
        var zeroTotalCorrection = 0;
        if (0 === total) {
            total = points.filter(function(el) {
                return el.isVisible();
            }).length;
            zeroTotalCorrection = 1;
        }
        $101dd6b068782510$var$_each(isClockWise ? points : points.concat([]).reverse(), function(_, point) {
            var val = point.isVisible() ? zeroTotalCorrection || point.normalInitialValue : 0;
            var updatedZeroValue;
            if (minSegmentSize && point.isVisible() && val < minShownValue) updatedZeroValue = minShownValue;
            percent = val / total;
            point.correctValue(correction, percent, zeroTotalCorrection + (updatedZeroValue || 0));
            point.shiftedAngle = shiftedAngle;
            correction += updatedZeroValue || val;
        });
        this._rangeData = {
            val: {
                min: 0,
                max: correction
            }
        };
    },
    _removePoint: function(point) {
        var points = this.getPointsByArg(point.argument);
        points.splice(points.indexOf(point), 1);
        point.dispose();
    },
    arrangePoints: function() {
        var that = this;
        var originalPoints = that._points || [];
        var minSegmentSize = that._options.minSegmentSize;
        var minShownValue;
        var isAllPointsNegative = true;
        var i = 0;
        var len = originalPoints.length;
        while(i < len && isAllPointsNegative){
            isAllPointsNegative = originalPoints[i].value <= 0;
            i++;
        }
        var points = that._points = $101dd6b068782510$var$_map(originalPoints, function(point) {
            if (null === point.value || !isAllPointsNegative && point.value < 0) {
                that._removePoint(point);
                return null;
            } else return point;
        });
        var maxValue = points.reduce(function(max, p) {
            return $101dd6b068782510$var$_max(max, Math.abs(p.initialValue));
        }, 0);
        points.forEach(function(p) {
            p.normalInitialValue = p.initialValue / (0 !== maxValue ? maxValue : 1);
        });
        var total = points.reduce(function(total, point) {
            return total + (point.isVisible() ? point.normalInitialValue : 0);
        }, 0);
        if (minSegmentSize) minShownValue = this._getArrangeMinShownValue(points, total);
        that._applyArrangeCorrection(points, minShownValue, total);
    },
    correctPosition: function(correction, canvas) {
        $101dd6b068782510$var$_each(this._points, function(_, point) {
            point.correctPosition(correction);
        });
        this.setVisibleArea(canvas);
    },
    correctRadius: function(correction) {
        this._points.forEach(function(point) {
            point.correctRadius(correction);
        });
    },
    correctLabelRadius: function(labelRadius) {
        this._points.forEach(function(point) {
            point.correctLabelRadius(labelRadius);
        });
    },
    setVisibleArea: function(canvas) {
        this._visibleArea = {
            minX: canvas.left,
            maxX: canvas.width - canvas.right,
            minY: canvas.top,
            maxY: canvas.height - canvas.bottom
        };
    },
    _applyVisibleArea: $101dd6b068782510$var$_noop,
    _animate: function(firstDrawing) {
        var that = this;
        var points = that._points;
        var pointsCount = points && points.length;
        var completeFunc = function() {
            that._animateComplete();
        };
        var animatePoint;
        if (firstDrawing) animatePoint = function(p, i) {
            p.animate(i === pointsCount - 1 ? completeFunc : void 0, $101dd6b068782510$var$ANIMATION_DURATION, (1 - $101dd6b068782510$var$ANIMATION_DURATION) * i / (pointsCount - 1));
        };
        else animatePoint = function(p, i) {
            p.animate(i === pointsCount - 1 ? completeFunc : void 0);
        };
        points.forEach(animatePoint);
    },
    getVisiblePoints: function() {
        return $101dd6b068782510$var$_map(this._points, function(p) {
            return p.isVisible() ? p : null;
        });
    },
    getPointsByKeys: function(arg, argumentIndex) {
        var pointsByArg = this.getPointsByArg(arg);
        return pointsByArg[argumentIndex] && [
            pointsByArg[argumentIndex]
        ] || [];
    }
});
var $101dd6b068782510$export$a34b926d586e6ab8 = $101dd6b068782510$export$47a9dca4012556c5;
var $101dd6b068782510$export$93e7d1dbd4c55fc0 = $101dd6b068782510$export$47a9dca4012556c5;

});

parcelRegister("ggW68", function(module, exports) {

$parcel$export(module.exports, "stock", function () { return $bd8b35024c39d8fa$export$7e905d6be1ab1c91; });
$parcel$export(module.exports, "candlestick", function () { return $bd8b35024c39d8fa$export$75fd59269bca8515; });
/**
 * DevExtreme (esm/viz/series/financial_series.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $3Ev8J = parcelRequire("3Ev8J");

var $aaioz = parcelRequire("aaioz");

var $2oTOp = parcelRequire("2oTOp");

var $6ntMu = parcelRequire("6ntMu");

var $dw9tZ = parcelRequire("dw9tZ");

var $gcp4g = parcelRequire("gcp4g");
var $bd8b35024c39d8fa$var$barSeries = (0, $aaioz.chart).bar;
var $bd8b35024c39d8fa$var$DEFAULT_FINANCIAL_POINT_SIZE = 10;
var $bd8b35024c39d8fa$export$7e905d6be1ab1c91 = (0, $2oTOp.extend)({}, (0, $3Ev8J.chart), {
    _animate: (0, $gcp4g.noop),
    _applyMarkerClipRect: function(settings) {
        settings["clip-path"] = this._forceClipping ? this._paneClipRectID : this._widePaneClipRectID;
    },
    _updatePointsVisibility: $bd8b35024c39d8fa$var$barSeries._updatePointsVisibility,
    _getOptionsForPoint: $bd8b35024c39d8fa$var$barSeries._getOptionsForPoint,
    _createErrorBarGroup: (0, $gcp4g.noop),
    areErrorBarsVisible: (0, $gcp4g.noop),
    _createGroups: (0, $3Ev8J.chart)._createGroups,
    _setMarkerGroupSettings: function() {
        var markersGroup = this._markersGroup;
        var styles = this._createPointStyles(this._getMarkerGroupOptions());
        var defaultStyle = (0, $2oTOp.extend)(styles.normal, {
            class: "default-markers"
        });
        var defaultPositiveStyle = (0, $2oTOp.extend)(styles.positive.normal, {
            class: "default-positive-markers"
        });
        var reductionStyle = (0, $2oTOp.extend)(styles.reduction.normal, {
            class: "reduction-markers"
        });
        var reductionPositiveStyle = (0, $2oTOp.extend)(styles.reductionPositive.normal, {
            class: "reduction-positive-markers"
        });
        var markerSettings = {
            class: "dxc-markers"
        };
        this._applyMarkerClipRect(markerSettings);
        markersGroup.attr(markerSettings);
        this._createGroup("defaultMarkersGroup", markersGroup, markersGroup, defaultStyle);
        this._createGroup("reductionMarkersGroup", markersGroup, markersGroup, reductionStyle);
        this._createGroup("defaultPositiveMarkersGroup", markersGroup, markersGroup, defaultPositiveStyle);
        this._createGroup("reductionPositiveMarkersGroup", markersGroup, markersGroup, reductionPositiveStyle);
    },
    _setGroupsSettings: function() {
        (0, $3Ev8J.chart)._setGroupsSettings.call(this, false);
    },
    _getCreatingPointOptions: function() {
        var defaultPointOptions;
        var creatingPointOptions = this._predefinedPointOptions;
        if (!creatingPointOptions) {
            defaultPointOptions = this._getPointOptions();
            this._predefinedPointOptions = creatingPointOptions = (0, $2oTOp.extend)(true, {
                styles: {}
            }, defaultPointOptions);
            creatingPointOptions.styles.normal = creatingPointOptions.styles.positive.normal = creatingPointOptions.styles.reduction.normal = creatingPointOptions.styles.reductionPositive.normal = {
                "stroke-width": defaultPointOptions.styles && defaultPointOptions.styles.normal && defaultPointOptions.styles.normal["stroke-width"]
            };
        }
        return creatingPointOptions;
    },
    _checkData: function(data, skippedFields) {
        var valueFields = this.getValueFields();
        return (0, $3Ev8J.chart)._checkData.call(this, data, skippedFields, {
            openValue: valueFields[0],
            highValue: valueFields[1],
            lowValue: valueFields[2],
            closeValue: valueFields[3]
        }) && data.highValue === data.highValue && data.lowValue === data.lowValue;
    },
    _getPointDataSelector: function(data, options) {
        var that = this;
        var level;
        var valueFields = that.getValueFields();
        var argumentField = that.getArgumentField();
        var openValueField = valueFields[0];
        var highValueField = valueFields[1];
        var lowValueField = valueFields[2];
        var closeValueField = valueFields[3];
        that.level = that._options.reduction.level;
        switch((0, $dw9tZ.normalizeEnum)(that.level)){
            case "open":
                level = openValueField;
                break;
            case "high":
                level = highValueField;
                break;
            case "low":
                level = lowValueField;
                break;
            default:
                level = closeValueField;
                that.level = "close";
        }
        var prevLevelValue;
        return (data)=>{
            var reductionValue = data[level];
            var isReduction = false;
            if ((0, $6ntMu.isDefined)(reductionValue)) {
                if ((0, $6ntMu.isDefined)(prevLevelValue)) isReduction = reductionValue < prevLevelValue;
                prevLevelValue = reductionValue;
            }
            return {
                argument: data[argumentField],
                highValue: this._processEmptyValue(data[highValueField]),
                lowValue: this._processEmptyValue(data[lowValueField]),
                closeValue: this._processEmptyValue(data[closeValueField]),
                openValue: this._processEmptyValue(data[openValueField]),
                reductionValue: reductionValue,
                tag: data[that.getTagField()],
                isReduction: isReduction,
                data: data
            };
        };
    },
    _parsePointStyle: function(style, defaultColor, innerColor) {
        return {
            stroke: style.color || defaultColor,
            "stroke-width": style.width,
            fill: style.color || innerColor
        };
    },
    _getDefaultStyle: function(options) {
        var mainPointColor = options.color || this._options.mainSeriesColor;
        return {
            normal: this._parsePointStyle(options, mainPointColor, mainPointColor),
            hover: this._parsePointStyle(options.hoverStyle, mainPointColor, mainPointColor),
            selection: this._parsePointStyle(options.selectionStyle, mainPointColor, mainPointColor)
        };
    },
    _getReductionStyle: function(options) {
        var reductionColor = options.reduction.color;
        return {
            normal: this._parsePointStyle({
                color: reductionColor,
                width: options.width,
                hatching: options.hatching
            }, reductionColor, reductionColor),
            hover: this._parsePointStyle(options.hoverStyle, reductionColor, reductionColor),
            selection: this._parsePointStyle(options.selectionStyle, reductionColor, reductionColor)
        };
    },
    _createPointStyles: function(pointOptions) {
        var innerColor = this._options.innerColor;
        var styles = this._getDefaultStyle(pointOptions);
        var positiveStyle = (0, $2oTOp.extend)(true, {}, styles);
        var reductionStyle = this._getReductionStyle(pointOptions);
        var reductionPositiveStyle = (0, $2oTOp.extend)(true, {}, reductionStyle);
        positiveStyle.normal.fill = positiveStyle.hover.fill = positiveStyle.selection.fill = innerColor;
        reductionPositiveStyle.normal.fill = reductionPositiveStyle.hover.fill = reductionPositiveStyle.selection.fill = innerColor;
        styles.positive = positiveStyle;
        styles.reduction = reductionStyle;
        styles.reductionPositive = reductionPositiveStyle;
        return styles;
    },
    _endUpdateData: function() {
        delete this._predefinedPointOptions;
    },
    _defaultAggregator: "ohlc",
    _aggregators: {
        ohlc: (_ref, series)=>{
            var { intervalStart: intervalStart, intervalEnd: intervalEnd, data: data } = _ref;
            if (!data.length) return;
            var result = {};
            var valueFields = series.getValueFields();
            var highValueField = valueFields[1];
            var lowValueField = valueFields[2];
            result[highValueField] = -1 / 0;
            result[lowValueField] = 1 / 0;
            result = data.reduce(function(result, item) {
                if (null !== item[highValueField]) result[highValueField] = Math.max(result[highValueField], item[highValueField]);
                if (null !== item[lowValueField]) result[lowValueField] = Math.min(result[lowValueField], item[lowValueField]);
                return result;
            }, result);
            result[valueFields[0]] = data[0][valueFields[0]];
            result[valueFields[3]] = data[data.length - 1][valueFields[3]];
            if (!isFinite(result[highValueField])) result[highValueField] = null;
            if (!isFinite(result[lowValueField])) result[lowValueField] = null;
            result[series.getArgumentField()] = series._getIntervalCenter(intervalStart, intervalEnd);
            return result;
        }
    },
    getValueFields: function() {
        var options = this._options;
        return [
            options.openValueField || "open",
            options.highValueField || "high",
            options.lowValueField || "low",
            options.closeValueField || "close"
        ];
    },
    getArgumentField: function() {
        return this._options.argumentField || "date";
    },
    _patchMarginOptions: function(options) {
        var pointOptions = this._getCreatingPointOptions();
        var styles = pointOptions.styles;
        var border = [
            styles.normal,
            styles.hover,
            styles.selection
        ].reduce(function(max, style) {
            return Math.max(max, style["stroke-width"]);
        }, 0);
        options.size = $bd8b35024c39d8fa$var$DEFAULT_FINANCIAL_POINT_SIZE + border;
        options.sizePointNormalState = $bd8b35024c39d8fa$var$DEFAULT_FINANCIAL_POINT_SIZE;
        return options;
    },
    getSeriesPairCoord (coord, isArgument) {
        var oppositeCoord = null;
        var points = this.getVisiblePoints();
        for(var i = 0; i < points.length; i++){
            var p = points[i];
            var tmpCoord = void 0;
            if (isArgument) tmpCoord = p.vx === coord ? (p.openY + p.closeY) / 2 : void 0;
            else {
                var coords = [
                    Math.min(p.lowY, p.highY),
                    Math.max(p.lowY, p.highY)
                ];
                tmpCoord = coord >= coords[0] && coord <= coords[1] ? p.vx : void 0;
            }
            if (this._checkAxisVisibleAreaCoord(!isArgument, tmpCoord)) {
                oppositeCoord = tmpCoord;
                break;
            }
        }
        return oppositeCoord;
    },
    usePointsToDefineAutoHiding: ()=>false
});
var $bd8b35024c39d8fa$export$75fd59269bca8515 = (0, $2oTOp.extend)({}, $bd8b35024c39d8fa$export$7e905d6be1ab1c91, {
    _parsePointStyle: function(style, defaultColor, innerColor) {
        var color = style.color || innerColor;
        var base = $bd8b35024c39d8fa$export$7e905d6be1ab1c91._parsePointStyle.call(this, style, defaultColor, color);
        base.fill = color;
        base.hatching = style.hatching;
        return base;
    }
});

});

parcelRegister("fIHko", function(module, exports) {

$parcel$export(module.exports, "chart", function () { return $b71c931744091a83$export$8fde8ebd684d5072; });
$parcel$export(module.exports, "polar", function () { return $b71c931744091a83$export$5f7108acdc6fb162; });
/**
 * DevExtreme (esm/viz/series/stacked_series.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $gcp4g = parcelRequire("gcp4g");

var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $9Qo4w = parcelRequire("9Qo4w");

var $aaioz = parcelRequire("aaioz");

var $bmaKW = parcelRequire("bmaKW");

var $dw9tZ = parcelRequire("dw9tZ");

var $5VpUx = parcelRequire("5VpUx");
var $b71c931744091a83$var$chartAreaSeries = (0, $9Qo4w.chart).area;
var $b71c931744091a83$var$chartBarSeries = (0, $aaioz.chart).bar;
var $b71c931744091a83$var$baseStackedSeries = {
    _calculateErrorBars: (0, $gcp4g.noop),
    _updateOptions: function(options) {
        this._stackName = "axis_" + (options.axis || "default");
    }
};
var $b71c931744091a83$export$8fde8ebd684d5072 = {};
var $b71c931744091a83$export$5f7108acdc6fb162 = {};
$b71c931744091a83$export$8fde8ebd684d5072.stackedline = (0, $2oTOp.extend)({}, (0, $bmaKW.chart).line, $b71c931744091a83$var$baseStackedSeries, {});
$b71c931744091a83$export$8fde8ebd684d5072.stackedspline = (0, $2oTOp.extend)({}, (0, $bmaKW.chart).spline, $b71c931744091a83$var$baseStackedSeries, {});
$b71c931744091a83$export$8fde8ebd684d5072.fullstackedline = (0, $2oTOp.extend)({}, (0, $bmaKW.chart).line, $b71c931744091a83$var$baseStackedSeries, {
    getValueRangeInitialValue: (0, $9Qo4w.chart).area.getValueRangeInitialValue
});
$b71c931744091a83$export$8fde8ebd684d5072.fullstackedspline = (0, $2oTOp.extend)({}, (0, $bmaKW.chart).spline, $b71c931744091a83$var$baseStackedSeries, {
    getValueRangeInitialValue: (0, $9Qo4w.chart).area.getValueRangeInitialValue
});
var $b71c931744091a83$var$stackedBar = $b71c931744091a83$export$8fde8ebd684d5072.stackedbar = (0, $2oTOp.extend)({}, $b71c931744091a83$var$chartBarSeries, $b71c931744091a83$var$baseStackedSeries, {
    _updateOptions: function(options) {
        $b71c931744091a83$var$baseStackedSeries._updateOptions.call(this, options);
        this._stackName = this._stackName + "_stack_" + (options.stack || "default");
    }
});
$b71c931744091a83$export$8fde8ebd684d5072.fullstackedbar = (0, $2oTOp.extend)({}, $b71c931744091a83$var$chartBarSeries, $b71c931744091a83$var$baseStackedSeries, {
    _updateOptions: $b71c931744091a83$var$stackedBar._updateOptions
});
function $b71c931744091a83$var$clonePoint(point, value, minValue, position) {
    point = (0, $5VpUx.clone)(point);
    point.value = value;
    point.minValue = minValue;
    point.translate();
    point.argument = point.argument + position;
    return point;
}
function $b71c931744091a83$var$preparePointsForStackedAreaSegment(points) {
    var i = 0;
    var p;
    var result = [];
    var array;
    var len = points.length;
    while(i < len){
        p = points[i];
        array = [
            p
        ];
        if (p.leftHole) array = [
            $b71c931744091a83$var$clonePoint(p, p.leftHole, p.minLeftHole, "left"),
            p
        ];
        if (p.rightHole) array.push($b71c931744091a83$var$clonePoint(p, p.rightHole, p.minRightHole, "right"));
        result.push(array);
        i++;
    }
    return [].concat.apply([], result);
}
$b71c931744091a83$export$8fde8ebd684d5072.stackedarea = (0, $2oTOp.extend)({}, $b71c931744091a83$var$chartAreaSeries, $b71c931744091a83$var$baseStackedSeries, {
    _prepareSegment: function(points, rotated) {
        return $b71c931744091a83$var$chartAreaSeries._prepareSegment.call(this, $b71c931744091a83$var$preparePointsForStackedAreaSegment(points), rotated);
    },
    _appendInGroup: function() {
        this._group.append(this._extGroups.seriesGroup).toBackground();
    }
});
function $b71c931744091a83$var$getPointsByArgFromPrevSeries(prevSeries, argument) {
    var result;
    while(!result && prevSeries){
        result = prevSeries._segmentByArg && prevSeries._segmentByArg[argument];
        prevSeries = prevSeries._prevSeries;
    }
    return result;
}
$b71c931744091a83$export$8fde8ebd684d5072.stackedsplinearea = (0, $2oTOp.extend)({}, (0, $9Qo4w.chart).splinearea, $b71c931744091a83$var$baseStackedSeries, {
    _prepareSegment: function(points, rotated) {
        var that = this;
        var areaSegment;
        points = $b71c931744091a83$var$preparePointsForStackedAreaSegment(points);
        if (!this._prevSeries || 1 === points.length) areaSegment = (0, $9Qo4w.chart).splinearea._prepareSegment.call(this, points, rotated);
        else {
            var forwardPoints = (0, $bmaKW.chart).spline._calculateBezierPoints(points, rotated);
            var backwardPoints = (0, $dw9tZ.map)(points, function(p) {
                var point = p.getCoords(true);
                point.argument = p.argument;
                return point;
            });
            var prevSeriesForwardPoints = [];
            var pointByArg = {};
            var i = 0;
            var len = that._prevSeries._segments.length;
            while(i < len){
                prevSeriesForwardPoints = prevSeriesForwardPoints.concat(that._prevSeries._segments[i].line);
                i++;
            }
            (0, $8OLOW.each)(prevSeriesForwardPoints, function(_, p) {
                if (null !== p.argument) {
                    var argument = p.argument.valueOf();
                    if (!pointByArg[argument]) pointByArg[argument] = [
                        p
                    ];
                    else pointByArg[argument].push(p);
                }
            });
            that._prevSeries._segmentByArg = pointByArg;
            backwardPoints = (0, $bmaKW.chart).spline._calculateBezierPoints(backwardPoints, rotated);
            (0, $8OLOW.each)(backwardPoints, function(i, p) {
                var argument = p.argument.valueOf();
                var prevSeriesPoints;
                if (i % 3 === 0) {
                    prevSeriesPoints = pointByArg[argument] || $b71c931744091a83$var$getPointsByArgFromPrevSeries(that._prevSeries, argument);
                    if (prevSeriesPoints) {
                        backwardPoints[i - 1] && prevSeriesPoints[0] && (backwardPoints[i - 1] = prevSeriesPoints[0]);
                        backwardPoints[i + 1] && (backwardPoints[i + 1] = prevSeriesPoints[2] || p);
                    }
                }
            });
            areaSegment = {
                line: forwardPoints,
                area: forwardPoints.concat(backwardPoints.reverse())
            };
            that._areaPointsToSplineAreaPoints(areaSegment.area);
        }
        return areaSegment;
    },
    _appendInGroup: $b71c931744091a83$export$8fde8ebd684d5072.stackedarea._appendInGroup
});
$b71c931744091a83$export$8fde8ebd684d5072.fullstackedarea = (0, $2oTOp.extend)({}, $b71c931744091a83$var$chartAreaSeries, $b71c931744091a83$var$baseStackedSeries, {
    _prepareSegment: $b71c931744091a83$export$8fde8ebd684d5072.stackedarea._prepareSegment,
    _appendInGroup: $b71c931744091a83$export$8fde8ebd684d5072.stackedarea._appendInGroup
});
$b71c931744091a83$export$8fde8ebd684d5072.fullstackedsplinearea = (0, $2oTOp.extend)({}, (0, $9Qo4w.chart).splinearea, $b71c931744091a83$var$baseStackedSeries, {
    _prepareSegment: $b71c931744091a83$export$8fde8ebd684d5072.stackedsplinearea._prepareSegment,
    _appendInGroup: $b71c931744091a83$export$8fde8ebd684d5072.stackedarea._appendInGroup
});
$b71c931744091a83$export$5f7108acdc6fb162.stackedbar = (0, $2oTOp.extend)({}, (0, $aaioz.polar).bar, $b71c931744091a83$var$baseStackedSeries, {});

});


parcelRegister("9wl6Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ee77a159c481a31$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/__internal/viz/core/m_base_widget.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $jF0bZ = parcelRequire("jF0bZ");

var $3yzYM = parcelRequire("3yzYM");

var $2rq4a = parcelRequire("2rq4a");

var $2vlX8 = parcelRequire("2vlX8");

var $gcp4g = parcelRequire("gcp4g");

var $dDkff = parcelRequire("dDkff");

var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $iE2yv = parcelRequire("iE2yv");

var $6ntMu = parcelRequire("6ntMu");

var $hYatw = parcelRequire("hYatw");

var $60GuF = parcelRequire("60GuF");

var $64UbH = parcelRequire("64UbH");

var $7xBJI = parcelRequire("7xBJI");

var $Ut3m2 = parcelRequire("Ut3m2");

var $e7MTd = parcelRequire("e7MTd");

var $SJOFr = parcelRequire("SJOFr");

var $fORY6 = parcelRequire("fORY6");

var $dw9tZ = parcelRequire("dw9tZ");

var $5XaPR = parcelRequire("5XaPR");
var { log: $6ee77a159c481a31$var$log } = (0, $Ut3m2.default);
var $6ee77a159c481a31$var$OPTION_RTL_ENABLED = "rtlEnabled";
var $6ee77a159c481a31$var$SIZED_ELEMENT_CLASS = "dx-sized-element";
var $6ee77a159c481a31$var$baseOptionMethod = (0, $2rq4a.default).prototype.option;
function $6ee77a159c481a31$var$getTrue() {
    return true;
}
function $6ee77a159c481a31$var$getFalse() {
    return false;
}
function $6ee77a159c481a31$var$defaultOnIncidentOccurred(e) {
    if (!e.component._eventsStrategy.hasEvent("incidentOccurred")) $6ee77a159c481a31$var$log.apply(null, [
        e.target.id
    ].concat(e.target.args || []));
}
function $6ee77a159c481a31$var$pickPositiveValue(values) {
    return values.reduce((result, value)=>value > 0 && !result ? value : result, 0);
}
var $6ee77a159c481a31$var$getEmptyComponent = function() {
    var emptyComponentConfig = {
        _initTemplates () {},
        ctor (element, options) {
            this.callBase(element, options);
            var sizedElement = (0, $3yzYM.default).createElement("div");
            var width = options && (0, $6ntMu.isNumeric)(options.width) ? "".concat(options.width, "px") : "100%";
            var height = options && (0, $6ntMu.isNumeric)(options.height) ? "".concat(options.height, "px") : "".concat(this._getDefaultSize().height, "px");
            (0, $3yzYM.default).setStyle(sizedElement, "width", width);
            (0, $3yzYM.default).setStyle(sizedElement, "height", height);
            (0, $3yzYM.default).setClass(sizedElement, $6ee77a159c481a31$var$SIZED_ELEMENT_CLASS, false);
            (0, $3yzYM.default).insertElement(element, sizedElement);
        }
    };
    var EmptyComponent = (0, $2rq4a.default).inherit(emptyComponentConfig);
    var originalInherit = EmptyComponent.inherit;
    EmptyComponent.inherit = function(config) {
        Object.keys(config).forEach((field)=>{
            if ((0, $6ntMu.isFunction)(config[field]) && "_" !== field.substr(0, 1) && "option" !== field || "_dispose" === field || "_optionChanged" === field) config[field] = (0, $gcp4g.noop);
        });
        return originalInherit.call(this, config);
    };
    return EmptyComponent;
};
function $6ee77a159c481a31$var$callForEach(functions) {
    functions.forEach((c)=>c());
}
var $6ee77a159c481a31$var$isServerSide = !(0, $hYatw.hasWindow)();
function $6ee77a159c481a31$var$sizeIsValid(value) {
    return (0, $6ntMu.isDefined)(value) && value > 0;
}
var $6ee77a159c481a31$var$baseWidget = $6ee77a159c481a31$var$isServerSide ? $6ee77a159c481a31$var$getEmptyComponent() : (0, $2rq4a.default).inherit({
    _eventsMap: {
        onIncidentOccurred: {
            name: "incidentOccurred",
            actionSettings: {
                excludeValidators: [
                    "disabled"
                ]
            }
        },
        onDrawn: {
            name: "drawn",
            actionSettings: {
                excludeValidators: [
                    "disabled"
                ]
            }
        }
    },
    _getDefaultOptions () {
        return (0, $2oTOp.extend)(this.callBase(), {
            onIncidentOccurred: $6ee77a159c481a31$var$defaultOnIncidentOccurred
        });
    },
    _useLinks: true,
    _init () {
        this._$element.children(".".concat($6ee77a159c481a31$var$SIZED_ELEMENT_CLASS)).remove();
        this._$element.children(".".concat($6ee77a159c481a31$var$SIZED_ELEMENT_CLASS)).remove();
        this.callBase(...arguments);
        this._changesLocker = 0;
        this._optionChangedLocker = 0;
        this._asyncFirstDrawing = true;
        this._changes = (0, $e7MTd.changes)();
        this._suspendChanges();
        this._themeManager = this._createThemeManager();
        this._themeManager.setCallback(()=>{
            this._requestChange(this._themeDependentChanges);
        });
        this._renderElementAttributes();
        this._initRenderer();
        var useLinks = this._useLinks;
        if (useLinks) this._renderer.root.enableLinks().virtualLink("core").virtualLink("peripheral");
        this._renderVisibilityChange();
        this._attachVisibilityChangeHandlers();
        this._toggleParentsScrollSubscription(this._isVisible());
        this._initEventTrigger();
        this._incidentOccurred = (0, $7xBJI.createIncidentOccurred)(this.NAME, this._eventTrigger);
        this._layout = new (0, $SJOFr.default);
        if (useLinks) this._renderer.root.linkAfter("core");
        this._initPlugins();
        this._initCore();
        if (useLinks) this._renderer.root.linkAfter();
        this._change(this._initialChanges);
    },
    _createThemeManager () {
        return new (0, $64UbH.BaseThemeManager)(this._getThemeManagerOptions());
    },
    _getThemeManagerOptions () {
        return {
            themeSection: this._themeSection,
            fontFields: this._fontFields
        };
    },
    _initialChanges: [
        "LAYOUT",
        "RESIZE_HANDLER",
        "THEME",
        "DISABLED"
    ],
    _initPlugins () {
        (0, $8OLOW.each)(this._plugins, (_, plugin)=>{
            plugin.init.call(this);
        });
    },
    _disposePlugins () {
        (0, $8OLOW.each)(this._plugins.slice().reverse(), (_, plugin)=>{
            plugin.dispose.call(this);
        });
    },
    _change (codes) {
        this._changes.add(codes);
    },
    _suspendChanges () {
        this._changesLocker += 1;
    },
    _resumeChanges () {
        if (0 === --this._changesLocker && this._changes.count() > 0 && !this._applyingChanges) {
            this._renderer.lock();
            this._applyingChanges = true;
            this._applyChanges();
            this._changes.reset();
            this._applyingChanges = false;
            this._changesApplied();
            this._renderer.unlock();
            if (this._optionsQueue) this._applyQueuedOptions();
            this.resolveItemsDeferred(this._legend ? [
                this._legend
            ] : []);
            this._optionChangedLocker += 1;
            this._notify();
            this._optionChangedLocker -= 1;
        }
    },
    resolveItemsDeferred (items) {
        this._resolveDeferred(this._getTemplatesItems(items));
    },
    _collectTemplatesFromItems: (items)=>items.reduce((prev, i)=>({
                items: prev.items.concat(i.getTemplatesDef()),
                groups: prev.groups.concat(i.getTemplatesGroups())
            }), {
            items: [],
            groups: []
        }),
    _getTemplatesItems (items) {
        var elements = this._collectTemplatesFromItems(items);
        var extraItems = this._getExtraTemplatesItems();
        return {
            items: extraItems.items.concat(elements.items),
            groups: extraItems.groups.concat(elements.groups),
            launchRequest: [
                extraItems.launchRequest
            ],
            doneRequest: [
                extraItems.doneRequest
            ]
        };
    },
    _getExtraTemplatesItems: ()=>({
            items: [],
            groups: [],
            launchRequest: ()=>{},
            doneRequest: ()=>{}
        }),
    _resolveDeferred (_ref) {
        var { items: items, launchRequest: launchRequest, doneRequest: doneRequest, groups: groups } = _ref;
        this._setGroupsVisibility(groups, "hidden");
        if (this._changesApplying) {
            this._changesApplying = false;
            $6ee77a159c481a31$var$callForEach(doneRequest);
            return;
        }
        var syncRendering = true;
        (0, $dDkff.when).apply(this, items).done(()=>{
            if (syncRendering) {
                this._setGroupsVisibility(groups, "visible");
                return;
            }
            $6ee77a159c481a31$var$callForEach(launchRequest);
            this._changesApplying = true;
            var changes = [
                "LAYOUT",
                "FULL_RENDER"
            ];
            if (this._asyncFirstDrawing) {
                changes.push("FORCE_FIRST_DRAWING");
                this._asyncFirstDrawing = false;
            } else changes.push("FORCE_DRAWING");
            this._requestChange(changes);
            this._setGroupsVisibility(groups, "visible");
        });
        syncRendering = false;
    },
    _setGroupsVisibility (groups, visibility) {
        groups.forEach((g)=>g.attr({
                visibility: visibility
            }));
    },
    _applyQueuedOptions () {
        var queue = this._optionsQueue;
        this._optionsQueue = null;
        this.beginUpdate();
        (0, $8OLOW.each)(queue, (_, action)=>{
            action();
        });
        this.endUpdate();
    },
    _requestChange (codes) {
        this._suspendChanges();
        this._change(codes);
        this._resumeChanges();
    },
    _applyChanges () {
        var changes = this._changes;
        var order = this._totalChangesOrder;
        var changesOrderLength = order.length;
        for(var i = 0; i < changesOrderLength; i += 1)if (changes.has(order[i])) this["_change_".concat(order[i])]();
    },
    _optionChangesOrder: [
        "EVENTS",
        "THEME",
        "RENDERER",
        "RESIZE_HANDLER"
    ],
    _layoutChangesOrder: [
        "ELEMENT_ATTR",
        "CONTAINER_SIZE",
        "LAYOUT"
    ],
    _customChangesOrder: [
        "DISABLED"
    ],
    _change_EVENTS () {
        this._eventTrigger.applyChanges();
    },
    _change_THEME () {
        this._setThemeAndRtl();
    },
    _change_RENDERER () {
        this._setRendererOptions();
    },
    _change_RESIZE_HANDLER () {
        this._setupResizeHandler();
    },
    _change_ELEMENT_ATTR () {
        this._renderElementAttributes();
        this._change([
            "CONTAINER_SIZE"
        ]);
    },
    _change_CONTAINER_SIZE () {
        this._updateSize();
    },
    _change_LAYOUT () {
        this._setContentSize();
    },
    _change_DISABLED () {
        var renderer = this._renderer;
        var { root: root } = renderer;
        if (this.option("disabled")) {
            this._initDisabledState = root.attr("pointer-events");
            root.attr({
                "pointer-events": "none",
                filter: renderer.getGrayScaleFilter().id
            });
        } else if ("none" === root.attr("pointer-events")) root.attr({
            "pointer-events": (0, $6ntMu.isDefined)(this._initDisabledState) ? this._initDisabledState : null,
            filter: null
        });
    },
    _themeDependentChanges: [
        "RENDERER"
    ],
    _initRenderer () {
        var rawCanvas = this._calculateRawCanvas();
        this._canvas = (0, $5XaPR.floorCanvasDimensions)(rawCanvas);
        this._renderer = new (0, $fORY6.Renderer)({
            cssClass: "".concat(this._rootClassPrefix, " ").concat(this._rootClass),
            pathModified: this.option("pathModified"),
            container: this._$element[0]
        });
        this._renderer.resize(this._canvas.width, this._canvas.height);
    },
    _disposeRenderer () {
        this._renderer.dispose();
    },
    _getAnimationOptions: (0, $gcp4g.noop),
    render () {
        this._requestChange([
            "CONTAINER_SIZE"
        ]);
        var visible = this._isVisible();
        this._toggleParentsScrollSubscription(visible);
        !visible && this._stopCurrentHandling();
    },
    _toggleParentsScrollSubscription (subscribe) {
        var $parents = (0, $2vlX8.default)(this._renderer.root.element).parents();
        if ("generic" === (0, $jF0bZ.default).real().platform) $parents = $parents.add((0, $hYatw.getWindow)());
        this._proxiedTargetParentsScrollHandler = this._proxiedTargetParentsScrollHandler || (function() {
            this._stopCurrentHandling();
        }).bind(this);
        (0, $60GuF.default).off((0, $2vlX8.default)("").add(this._$prevRootParents), "scroll.viz_widgets", this._proxiedTargetParentsScrollHandler);
        if (subscribe) {
            (0, $60GuF.default).on($parents, "scroll.viz_widgets", this._proxiedTargetParentsScrollHandler);
            this._$prevRootParents = $parents;
        }
    },
    _stopCurrentHandling: (0, $gcp4g.noop),
    _dispose () {
        if (this._disposed) return;
        this.callBase(...arguments);
        this._toggleParentsScrollSubscription(false);
        this._removeResizeHandler();
        this._layout.dispose();
        this._eventTrigger.dispose();
        this._disposeCore();
        this._disposePlugins();
        this._disposeRenderer();
        this._themeManager.dispose();
        this._themeManager = null;
        this._renderer = null;
        this._eventTrigger = null;
    },
    _initEventTrigger () {
        this._eventTrigger = (0, $7xBJI.createEventTrigger)(this._eventsMap, (name, actionSettings)=>this._createActionByOption(name, actionSettings));
    },
    _calculateRawCanvas () {
        var size = this.option("size") || {};
        var margin = this.option("margin") || {};
        var defaultCanvas = this._getDefaultSize() || {};
        var getSizeOfSide = (size, side, getter)=>{
            if ($6ee77a159c481a31$var$sizeIsValid(size[side]) || !(0, $hYatw.hasWindow)()) return 0;
            var elementSize = getter(this._$element);
            return elementSize <= 1 ? 0 : elementSize;
        };
        var elementWidth = getSizeOfSide(size, "width", (x)=>(0, $iE2yv.getWidth)(x));
        var elementHeight = getSizeOfSide(size, "height", (x)=>(0, $iE2yv.getHeight)(x));
        var canvas = {
            width: size.width <= 0 ? 0 : $6ee77a159c481a31$var$pickPositiveValue([
                size.width,
                elementWidth,
                defaultCanvas.width
            ]),
            height: size.height <= 0 ? 0 : $6ee77a159c481a31$var$pickPositiveValue([
                size.height,
                elementHeight,
                defaultCanvas.height
            ]),
            left: $6ee77a159c481a31$var$pickPositiveValue([
                margin.left,
                defaultCanvas.left
            ]),
            top: $6ee77a159c481a31$var$pickPositiveValue([
                margin.top,
                defaultCanvas.top
            ]),
            right: $6ee77a159c481a31$var$pickPositiveValue([
                margin.right,
                defaultCanvas.right
            ]),
            bottom: $6ee77a159c481a31$var$pickPositiveValue([
                margin.bottom,
                defaultCanvas.bottom
            ])
        };
        if (canvas.width - canvas.left - canvas.right <= 0 || canvas.height - canvas.top - canvas.bottom <= 0) canvas = {
            width: 0,
            height: 0
        };
        return canvas;
    },
    _updateSize () {
        var rawCanvas = this._calculateRawCanvas();
        if ((0, $5XaPR.areCanvasesDifferent)(this._canvas, rawCanvas) || this.__forceRender) {
            this._canvas = (0, $5XaPR.floorCanvasDimensions)(rawCanvas);
            this._recreateSizeDependentObjects(true);
            this._renderer.resize(this._canvas.width, this._canvas.height);
            this._change([
                "LAYOUT"
            ]);
        }
    },
    _recreateSizeDependentObjects: (0, $gcp4g.noop),
    _getMinSize: ()=>[
            0,
            0
        ],
    _getAlignmentRect: (0, $gcp4g.noop),
    _setContentSize () {
        var canvas = this._canvas;
        var layout = this._layout;
        var rect = canvas.width > 0 && canvas.height > 0 ? [
            canvas.left,
            canvas.top,
            canvas.width - canvas.right,
            canvas.height - canvas.bottom
        ] : [
            0,
            0,
            0,
            0
        ];
        rect = layout.forward(rect, this._getMinSize());
        var nextRect = this._applySize(rect) || rect;
        layout.backward(nextRect, this._getAlignmentRect() || nextRect);
    },
    _getOption (name, isScalar) {
        var theme = this._themeManager.theme(name);
        var option = this.option(name);
        return isScalar ? void 0 !== option ? option : theme : (0, $2oTOp.extend)(true, {}, theme, option);
    },
    _setupResizeHandler () {
        var redrawOnResize = (0, $dw9tZ.parseScalar)(this._getOption("redrawOnResize", true), true);
        if (this._disposeResizeHandler) this._removeResizeHandler();
        this._disposeResizeHandler = (0, $7xBJI.createResizeHandler)(this._$element[0], redrawOnResize, ()=>this._requestChange([
                "CONTAINER_SIZE"
            ]));
    },
    _removeResizeHandler () {
        if (this._disposeResizeHandler) {
            this._disposeResizeHandler();
            this._disposeResizeHandler = null;
        }
    },
    _onBeginUpdate: (0, $gcp4g.noop),
    beginUpdate () {
        if (this._initialized && this._isUpdateAllowed()) {
            this._onBeginUpdate();
            this._suspendChanges();
        }
        this.callBase(...arguments);
        return this;
    },
    endUpdate () {
        this.callBase();
        this._isUpdateAllowed() && this._resumeChanges();
        return this;
    },
    option (name) {
        if (this._initialized && this._applyingChanges && (arguments.length > 1 || (0, $6ntMu.isObject)(name))) {
            this._optionsQueue = this._optionsQueue || [];
            this._optionsQueue.push(this._getActionForUpdating(arguments));
        } else return $6ee77a159c481a31$var$baseOptionMethod.apply(this, arguments);
    },
    _getActionForUpdating (args) {
        return ()=>{
            $6ee77a159c481a31$var$baseOptionMethod.apply(this, args);
        };
    },
    _clean: (0, $gcp4g.noop),
    _render: (0, $gcp4g.noop),
    _optionChanged (arg) {
        if (this._optionChangedLocker) return;
        var partialChanges = this.getPartialChangeOptionsName(arg);
        var changes = [];
        if (partialChanges.length > 0) partialChanges.forEach((pc)=>changes.push(this._partialOptionChangesMap[pc]));
        else changes.push(this._optionChangesMap[arg.name]);
        changes = changes.filter((c)=>!!c);
        if (this._eventTrigger.change(arg.name)) this._change([
            "EVENTS"
        ]);
        else if (changes.length > 0) this._change(changes);
        else this.callBase.apply(this, arguments);
    },
    _notify: (0, $gcp4g.noop),
    _changesApplied: (0, $gcp4g.noop),
    _optionChangesMap: {
        size: "CONTAINER_SIZE",
        margin: "CONTAINER_SIZE",
        redrawOnResize: "RESIZE_HANDLER",
        theme: "THEME",
        rtlEnabled: "THEME",
        encodeHtml: "THEME",
        elementAttr: "ELEMENT_ATTR",
        disabled: "DISABLED"
    },
    _partialOptionChangesMap: {},
    _partialOptionChangesPath: {},
    getPartialChangeOptionsName (changedOption) {
        var { fullName: fullName } = changedOption;
        var sections = fullName.split(/[.]/);
        var { name: name } = changedOption;
        var { value: value } = changedOption;
        var options = this._partialOptionChangesPath[name];
        var partialChangeOptionsName = [];
        if (options) {
            if (true === options) partialChangeOptionsName.push(name);
            else {
                options.forEach((op)=>{
                    fullName.indexOf(op) >= 0 && partialChangeOptionsName.push(op);
                });
                if (1 === sections.length) {
                    if ("object" === (0, $6ntMu.type)(value)) this._addOptionsNameForPartialUpdate(value, options, partialChangeOptionsName);
                    else if ("array" === (0, $6ntMu.type)(value)) {
                        if (value.length > 0 && value.every((item)=>this._checkOptionsForPartialUpdate(item, options))) value.forEach((item)=>{
                            this._addOptionsNameForPartialUpdate(item, options, partialChangeOptionsName);
                        });
                    }
                }
            }
        }
        return partialChangeOptionsName.filter((value, index, self)=>self.indexOf(value) === index);
    },
    _checkOptionsForPartialUpdate: (optionObject, options)=>!Object.keys(optionObject).some((key)=>-1 === options.indexOf(key)),
    _addOptionsNameForPartialUpdate (optionObject, options, partialChangeOptionsName) {
        var optionKeys = Object.keys(optionObject);
        if (this._checkOptionsForPartialUpdate(optionObject, options)) optionKeys.forEach((key)=>options.indexOf(key) > -1 && partialChangeOptionsName.push(key));
    },
    _visibilityChanged () {
        this.render();
    },
    _setThemeAndRtl () {
        this._themeManager.setTheme(this.option("theme"), this.option($6ee77a159c481a31$var$OPTION_RTL_ENABLED));
    },
    _getRendererOptions () {
        return {
            rtl: this.option($6ee77a159c481a31$var$OPTION_RTL_ENABLED),
            encodeHtml: this.option("encodeHtml"),
            animation: this._getAnimationOptions()
        };
    },
    _setRendererOptions () {
        this._renderer.setOptions(this._getRendererOptions());
    },
    svg () {
        return this._renderer.svg();
    },
    getSize () {
        var canvas = this._canvas || {};
        return {
            width: canvas.width,
            height: canvas.height
        };
    },
    isReady: $6ee77a159c481a31$var$getFalse,
    _dataIsReady: $6ee77a159c481a31$var$getTrue,
    _resetIsReady () {
        this.isReady = $6ee77a159c481a31$var$getFalse;
    },
    _drawn () {
        this.isReady = $6ee77a159c481a31$var$getFalse;
        if (this._dataIsReady()) this._renderer.onEndAnimation(()=>{
            this.isReady = $6ee77a159c481a31$var$getTrue;
        });
        this._eventTrigger("drawn", {});
    }
});
var $6ee77a159c481a31$export$2e2bcd8739ae039 = $6ee77a159c481a31$var$baseWidget;
(0, $e7MTd.replaceInherit)($6ee77a159c481a31$var$baseWidget);

});
parcelRegister("2rq4a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c72529cab305432$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/dom_component.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $8IERv = parcelRequire("8IERv");

var $cvYFL = parcelRequire("cvYFL");

var $2SbZF = parcelRequire("2SbZF");

var $cGLkX = parcelRequire("cGLkX");

var $kHZlm = parcelRequire("kHZlm");

var $8irnY = parcelRequire("8irnY");

var $lINBx = parcelRequire("lINBx");

var $jc4XS = parcelRequire("jc4XS");

var $8OLOW = parcelRequire("8OLOW");

var $2oTOp = parcelRequire("2oTOp");

var $3w5fK = parcelRequire("3w5fK");

var $gcp4g = parcelRequire("gcp4g");

var $6ntMu = parcelRequire("6ntMu");

var $hYatw = parcelRequire("hYatw");

var $kOEFu = parcelRequire("kOEFu");
var { abstract: $1c72529cab305432$var$abstract } = (0, $cGLkX.Component);
var $1c72529cab305432$var$DOMComponent = (0, $cGLkX.Component).inherit({
    _getDefaultOptions () {
        return (0, $2oTOp.extend)(this.callBase(), {
            width: void 0,
            height: void 0,
            rtlEnabled: (0, $8IERv.default)().rtlEnabled,
            elementAttr: {},
            disabled: false,
            integrationOptions: {}
        }, this._useTemplates() ? (0, $kHZlm.TemplateManager).createDefaultOptions() : {});
    },
    ctor (element, options) {
        this._customClass = null;
        this._createElement(element);
        (0, $8irnY.attachInstanceToElement)(this._$element, this, this._dispose);
        this.callBase(options);
    },
    _createElement (element) {
        this._$element = (0, $2vlX8.default)(element);
    },
    _getSynchronizableOptionsForCreateComponent: ()=>[
            "rtlEnabled",
            "disabled",
            "templatesRenderAsynchronously"
        ],
    _checkFunctionValueDeprecation: function(optionNames) {
        if (!this.option("_ignoreFunctionValueDeprecation")) optionNames.forEach((optionName)=>{
            if ((0, $6ntMu.isFunction)(this.option(optionName))) (0, $cvYFL.default).log("W0017", optionName);
        });
    },
    _visibilityChanged: $1c72529cab305432$var$abstract,
    _dimensionChanged: $1c72529cab305432$var$abstract,
    _init () {
        this.callBase();
        this._checkFunctionValueDeprecation([
            "width",
            "height",
            "maxHeight",
            "maxWidth",
            "minHeight",
            "minWidth",
            "popupHeight",
            "popupWidth"
        ]);
        this._attachWindowResizeCallback();
        this._initTemplateManager();
    },
    _setOptionsByDevice (instanceCustomRules) {
        this.callBase([].concat(this.constructor._classCustomRules || [], instanceCustomRules || []));
    },
    _isInitialOptionValue (name) {
        var isCustomOption = this.constructor._classCustomRules && Object.prototype.hasOwnProperty.call(this._convertRulesToOptions(this.constructor._classCustomRules), name);
        return !isCustomOption && this.callBase(name);
    },
    _attachWindowResizeCallback () {
        if (this._isDimensionChangeSupported()) {
            var windowResizeCallBack = this._windowResizeCallBack = this._dimensionChanged.bind(this);
            (0, $2SbZF.default).add(windowResizeCallBack);
        }
    },
    _isDimensionChangeSupported () {
        return this._dimensionChanged !== $1c72529cab305432$var$abstract;
    },
    _renderComponent () {
        this._initMarkup();
        (0, $hYatw.hasWindow)() && this._render();
    },
    _initMarkup () {
        var { rtlEnabled: rtlEnabled } = this.option() || {};
        this._renderElementAttributes();
        this._toggleRTLDirection(rtlEnabled);
        this._renderVisibilityChange();
        this._renderDimensions();
    },
    _render () {
        this._attachVisibilityChangeHandlers();
        (0, $lINBx.addShadowDomStyles)(this.$element());
    },
    _renderElementAttributes () {
        var { elementAttr: elementAttr } = this.option() || {};
        var attributes = (0, $2oTOp.extend)({}, elementAttr);
        var classNames = attributes.class;
        delete attributes.class;
        this.$element().attr(attributes).removeClass(this._customClass).addClass(classNames);
        this._customClass = classNames;
    },
    _renderVisibilityChange () {
        if (this._isDimensionChangeSupported()) this._attachDimensionChangeHandlers();
        if (this._isVisibilityChangeSupported()) {
            var $element = this.$element();
            $element.addClass("dx-visibility-change-handler");
        }
    },
    _renderDimensions () {
        var $element = this.$element();
        var element = $element.get(0);
        var width = this._getOptionValue("width", element);
        var height = this._getOptionValue("height", element);
        if (this._isCssUpdateRequired(element, height, width)) $element.css({
            width: null === width ? "" : width,
            height: null === height ? "" : height
        });
    },
    _isCssUpdateRequired: (element, height, width)=>!!((0, $6ntMu.isDefined)(width) || (0, $6ntMu.isDefined)(height) || element.style.width || element.style.height),
    _attachDimensionChangeHandlers () {
        var $el = this.$element();
        var namespace = "".concat(this.NAME, "VisibilityChange");
        (0, $kOEFu.resize).off($el, {
            namespace: namespace
        });
        (0, $kOEFu.resize).on($el, ()=>this._dimensionChanged(), {
            namespace: namespace
        });
    },
    _attachVisibilityChangeHandlers () {
        if (this._isVisibilityChangeSupported()) {
            var $el = this.$element();
            var namespace = "".concat(this.NAME, "VisibilityChange");
            this._isHidden = !this._isVisible();
            (0, $kOEFu.visibility).off($el, {
                namespace: namespace
            });
            (0, $kOEFu.visibility).on($el, ()=>this._checkVisibilityChanged("shown"), ()=>this._checkVisibilityChanged("hiding"), {
                namespace: namespace
            });
        }
    },
    _isVisible () {
        var $element = this.$element();
        return $element.is(":visible");
    },
    _checkVisibilityChanged (action) {
        var isVisible = this._isVisible();
        if (isVisible) {
            if ("hiding" === action && !this._isHidden) {
                this._visibilityChanged(false);
                this._isHidden = true;
            } else if ("shown" === action && this._isHidden) {
                this._isHidden = false;
                this._visibilityChanged(true);
            }
        }
    },
    _isVisibilityChangeSupported () {
        return this._visibilityChanged !== $1c72529cab305432$var$abstract && (0, $hYatw.hasWindow)();
    },
    _clean: (0, $gcp4g.noop),
    _modelByElement () {
        var { modelByElement: modelByElement } = this.option();
        var $element = this.$element();
        return modelByElement ? modelByElement($element) : void 0;
    },
    _invalidate () {
        if (this._isUpdateAllowed()) throw (0, $cvYFL.default).Error("E0007");
        this._requireRefresh = true;
    },
    _refresh () {
        this._clean();
        this._renderComponent();
    },
    _dispose () {
        this._templateManager && this._templateManager.dispose();
        this.callBase();
        this._clean();
        this._detachWindowResizeCallback();
    },
    _detachWindowResizeCallback () {
        if (this._isDimensionChangeSupported()) (0, $2SbZF.default).remove(this._windowResizeCallBack);
    },
    _toggleRTLDirection (rtl) {
        var $element = this.$element();
        $element.toggleClass("dx-rtl", rtl);
    },
    _createComponent (element, component) {
        var config = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        var synchronizableOptions = (0, $gcp4g.grep)(this._getSynchronizableOptionsForCreateComponent(), (value)=>!(value in config));
        var { integrationOptions: integrationOptions } = this.option();
        var { nestedComponentOptions: nestedComponentOptions } = this.option();
        nestedComponentOptions = nestedComponentOptions || (0, $gcp4g.noop);
        var nestedComponentConfig = (0, $2oTOp.extend)({
            integrationOptions: integrationOptions
        }, nestedComponentOptions(this));
        synchronizableOptions.forEach((optionName)=>nestedComponentConfig[optionName] = this.option(optionName));
        this._extendConfig(config, nestedComponentConfig);
        var instance = void 0;
        if ((0, $6ntMu.isString)(component)) {
            var $element = (0, $2vlX8.default)(element)[component](config);
            instance = $element[component]("instance");
        } else if (element) {
            instance = component.getInstance(element);
            if (instance) instance.option(config);
            else instance = new component(element, config);
        }
        if (instance) {
            var optionChangedHandler = (_ref)=>{
                var { name: name, value: value } = _ref;
                if (synchronizableOptions.includes(name)) instance.option(name, value);
            };
            this.on("optionChanged", optionChangedHandler);
            instance.on("disposing", ()=>this.off("optionChanged", optionChangedHandler));
        }
        return instance;
    },
    _extendConfig (config, extendConfig) {
        (0, $8OLOW.each)(extendConfig, (key, value)=>{
            !Object.prototype.hasOwnProperty.call(config, key) && (config[key] = value);
        });
    },
    _defaultActionConfig () {
        var $element = this.$element();
        var context = this._modelByElement($element);
        return (0, $2oTOp.extend)(this.callBase(), {
            context: context
        });
    },
    _defaultActionArgs () {
        var $element = this.$element();
        var model = this._modelByElement($element);
        var element = this.element();
        return (0, $2oTOp.extend)(this.callBase(), {
            element: element,
            model: model
        });
    },
    _optionChanged (args) {
        switch(args.name){
            case "width":
            case "height":
                this._renderDimensions();
                break;
            case "rtlEnabled":
                this._invalidate();
                break;
            case "elementAttr":
                this._renderElementAttributes();
                break;
            case "disabled":
            case "integrationOptions":
                break;
            default:
                this.callBase(args);
        }
    },
    _removeAttributes (element) {
        var attrs = element.attributes;
        for(var i = attrs.length - 1; i >= 0; i--){
            var attr = attrs[i];
            if (attr) {
                var { name: name } = attr;
                if (!name.indexOf("aria-") || -1 !== name.indexOf("dx-") || "role" === name || "style" === name || "tabindex" === name) element.removeAttribute(name);
            }
        }
    },
    _removeClasses (element) {
        element.className = element.className.split(" ").filter((cssClass)=>0 !== cssClass.lastIndexOf("dx-", 0)).join(" ");
    },
    _updateDOMComponent (renderRequired) {
        if (renderRequired) this._renderComponent();
        else if (this._requireRefresh) {
            this._requireRefresh = false;
            this._refresh();
        }
    },
    endUpdate () {
        var renderRequired = this._isInitializingRequired();
        this.callBase();
        this._isUpdateAllowed() && this._updateDOMComponent(renderRequired);
    },
    $element () {
        return this._$element;
    },
    element () {
        var $element = this.$element();
        return (0, $3w5fK.getPublicElement)($element);
    },
    dispose () {
        var element = this.$element().get(0);
        (0, $jc4XS.cleanDataRecursive)(element, true);
        element.textContent = "";
        this._removeAttributes(element);
        this._removeClasses(element);
    },
    resetOption (optionName) {
        this.callBase(optionName);
        if ("width" === optionName || "height" === optionName) {
            var initialOption = this.initialOption(optionName);
            !(0, $6ntMu.isDefined)(initialOption) && this.$element().css(optionName, "");
        }
    },
    _getAnonymousTemplateName () {
        return;
    },
    _initTemplateManager () {
        if (this._templateManager || !this._useTemplates()) return;
        var { integrationOptions: integrationOptions = {} } = this.option();
        var { createTemplate: createTemplate } = integrationOptions;
        this._templateManager = new (0, $kHZlm.TemplateManager)(createTemplate, this._getAnonymousTemplateName());
        this._initTemplates();
    },
    _initTemplates () {
        var { templates: templates, anonymousTemplateMeta: anonymousTemplateMeta } = this._templateManager.extractTemplates(this.$element());
        var anonymousTemplate = this.option("integrationOptions.templates.".concat(anonymousTemplateMeta.name));
        templates.forEach((_ref2)=>{
            var { name: name, template: template } = _ref2;
            this._options.silent("integrationOptions.templates.".concat(name), template);
        });
        if (anonymousTemplateMeta.name && !anonymousTemplate) {
            this._options.silent("integrationOptions.templates.".concat(anonymousTemplateMeta.name), anonymousTemplateMeta.template);
            this._options.silent("_hasAnonymousTemplateContent", true);
        }
    },
    _getTemplateByOption (optionName) {
        return this._getTemplate(this.option(optionName));
    },
    _getTemplate (templateSource) {
        var templates = this.option("integrationOptions.templates");
        var isAsyncTemplate = this.option("templatesRenderAsynchronously");
        var skipTemplates = this.option("integrationOptions.skipTemplates");
        return this._templateManager.getTemplate(templateSource, templates, {
            isAsyncTemplate: isAsyncTemplate,
            skipTemplates: skipTemplates
        }, this);
    },
    _saveTemplate (name, template) {
        this._setOptionWithoutOptionChange("integrationOptions.templates." + name, this._templateManager._createTemplate(template));
    },
    _useTemplates: ()=>true
});
$1c72529cab305432$var$DOMComponent.getInstance = function(element) {
    return (0, $8irnY.getInstanceByElement)((0, $2vlX8.default)(element), this);
};
$1c72529cab305432$var$DOMComponent.defaultOptions = function(rule) {
    this._classCustomRules = this._classCustomRules || [];
    this._classCustomRules.push(rule);
};
var $1c72529cab305432$export$2e2bcd8739ae039 = $1c72529cab305432$var$DOMComponent;

});
parcelRegister("cGLkX", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $93ce20731cc4d0b7$export$16fa2f45be04daa8; });
/**
 * DevExtreme (esm/core/component.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $8IERv = parcelRequire("8IERv");

var $2oTOp = parcelRequire("2oTOp");

var $jc09l = parcelRequire("jc09l");

var $apI87 = parcelRequire("apI87");

var $a2g7x = parcelRequire("a2g7x");

var $imKwV = parcelRequire("imKwV");

var $cvYFL = parcelRequire("cvYFL");

var $dYDfV = parcelRequire("dYDfV");

var $dL2Eh = parcelRequire("dL2Eh");

var $8irnY = parcelRequire("8irnY");

var $eQoAl = parcelRequire("eQoAl");

var $6ntMu = parcelRequire("6ntMu");

var $gcp4g = parcelRequire("gcp4g");

var $8Cgs4 = parcelRequire("8Cgs4");
var $93ce20731cc4d0b7$var$getEventName = (actionName)=>actionName.charAt(2).toLowerCase() + actionName.substr(3);
var $93ce20731cc4d0b7$var$isInnerOption = (optionName)=>0 === optionName.indexOf("_", 0);
var $93ce20731cc4d0b7$export$16fa2f45be04daa8 = (0, $a2g7x.default).inherit({
    _setDeprecatedOptions () {
        this._deprecatedOptions = {};
    },
    _getDeprecatedOptions () {
        return this._deprecatedOptions;
    },
    _getDefaultOptions: ()=>({
            onInitialized: null,
            onOptionChanged: null,
            onDisposing: null,
            defaultOptionsRules: null
        }),
    _defaultOptionsRules: ()=>[],
    _setOptionsByDevice (rules) {
        this._options.applyRules(rules);
    },
    _convertRulesToOptions: (rules)=>(0, $apI87.convertRulesToOptions)(rules),
    _isInitialOptionValue (name) {
        return this._options.isInitial(name);
    },
    _setOptionsByReference () {
        this._optionsByReference = {};
    },
    _getOptionsByReference () {
        return this._optionsByReference;
    },
    ctor () {
        var options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        var { _optionChangedCallbacks: _optionChangedCallbacks, _disposingCallbacks: _disposingCallbacks } = options;
        this.NAME = (0, $8irnY.name)(this.constructor);
        this._eventsStrategy = (0, $dL2Eh.EventsStrategy).create(this, options.eventsStrategy);
        this._updateLockCount = 0;
        this._optionChangedCallbacks = _optionChangedCallbacks || (0, $dYDfV.default)();
        this._disposingCallbacks = _disposingCallbacks || (0, $dYDfV.default)();
        this.postponedOperations = new (0, $eQoAl.PostponedOperations);
        this._createOptions(options);
    },
    _createOptions (options) {
        this.beginUpdate();
        try {
            this._setOptionsByReference();
            this._setDeprecatedOptions();
            this._options = new (0, $jc09l.Options)(this._getDefaultOptions(), this._getDefaultOptions(), this._getOptionsByReference(), this._getDeprecatedOptions());
            this._options.onChanging((name, previousValue, value)=>this._initialized && this._optionChanging(name, previousValue, value));
            this._options.onDeprecated((option, info)=>this._logDeprecatedOptionWarning(option, info));
            this._options.onChanged((name, value, previousValue)=>this._notifyOptionChanged(name, value, previousValue));
            this._options.onStartChange(()=>this.beginUpdate());
            this._options.onEndChange(()=>this.endUpdate());
            this._options.addRules(this._defaultOptionsRules());
            if (options && options.onInitializing) options.onInitializing.apply(this, [
                options
            ]);
            this._setOptionsByDevice(options.defaultOptionsRules);
            this._initOptions(options);
        } finally{
            this.endUpdate();
        }
    },
    _initOptions (options) {
        this.option(options);
    },
    _init () {
        this._createOptionChangedAction();
        this.on("disposing", (args)=>{
            this._disposingCallbacks.fireWith(this, [
                args
            ]);
        });
    },
    _logDeprecatedOptionWarning (option, info) {
        var message = info.message || "Use the '".concat(info.alias, "' option instead");
        (0, $cvYFL.default).log("W0001", this.NAME, option, info.since, message);
    },
    _logDeprecatedComponentWarning (since, alias) {
        (0, $cvYFL.default).log("W0000", this.NAME, since, "Use the '".concat(alias, "' widget instead"));
    },
    _createOptionChangedAction () {
        this._optionChangedAction = this._createActionByOption("onOptionChanged", {
            excludeValidators: [
                "disabled",
                "readOnly"
            ]
        });
    },
    _createDisposingAction () {
        this._disposingAction = this._createActionByOption("onDisposing", {
            excludeValidators: [
                "disabled",
                "readOnly"
            ]
        });
    },
    _optionChanged (args) {
        switch(args.name){
            case "onDisposing":
            case "onInitialized":
                break;
            case "onOptionChanged":
                this._createOptionChangedAction();
        }
    },
    _dispose () {
        this._optionChangedCallbacks.empty();
        this._createDisposingAction();
        this._disposingAction();
        this._eventsStrategy.dispose();
        this._options.dispose();
        this._disposed = true;
    },
    _lockUpdate () {
        this._updateLockCount++;
    },
    _unlockUpdate () {
        this._updateLockCount = Math.max(this._updateLockCount - 1, 0);
    },
    _isUpdateAllowed () {
        return 0 === this._updateLockCount;
    },
    _isInitializingRequired () {
        return !this._initializing && !this._initialized;
    },
    isInitialized () {
        return this._initialized;
    },
    _commitUpdate () {
        this.postponedOperations.callPostponedOperations();
        this._isInitializingRequired() && this._initializeComponent();
    },
    _initializeComponent () {
        this._initializing = true;
        try {
            this._init();
        } finally{
            this._initializing = false;
            this._lockUpdate();
            this._createActionByOption("onInitialized", {
                excludeValidators: [
                    "disabled",
                    "readOnly"
                ]
            })();
            this._unlockUpdate();
            this._initialized = true;
        }
    },
    instance () {
        return this;
    },
    beginUpdate: function() {
        this._lockUpdate();
    },
    endUpdate: function() {
        this._unlockUpdate();
        this._isUpdateAllowed() && this._commitUpdate();
    },
    _optionChanging: (0, $gcp4g.noop),
    _notifyOptionChanged (option, value, previousValue) {
        if (this._initialized) {
            var optionNames = [
                option
            ].concat(this._options.getAliasesByName(option));
            for(var i = 0; i < optionNames.length; i++){
                var name = optionNames[i];
                var args = {
                    name: (0, $8Cgs4.getPathParts)(name)[0],
                    fullName: name,
                    value: value,
                    previousValue: previousValue
                };
                if (!$93ce20731cc4d0b7$var$isInnerOption(name)) {
                    this._optionChangedCallbacks.fireWith(this, [
                        (0, $2oTOp.extend)(this._defaultActionArgs(), args)
                    ]);
                    this._optionChangedAction((0, $2oTOp.extend)({}, args));
                }
                if (!this._disposed && this._cancelOptionChange !== name) this._optionChanged(args);
            }
        }
    },
    initialOption (name) {
        return this._options.initial(name);
    },
    _defaultActionConfig () {
        return {
            context: this,
            component: this
        };
    },
    _defaultActionArgs () {
        return {
            component: this
        };
    },
    _createAction (actionSource, config) {
        var action;
        return (e)=>{
            if (!(0, $6ntMu.isDefined)(e)) e = {};
            if (!(0, $6ntMu.isPlainObject)(e)) e = {
                actionValue: e
            };
            action = action || new (0, $imKwV.default)(actionSource, (0, $2oTOp.extend)({}, config, this._defaultActionConfig()));
            return action.execute.call(action, (0, $2oTOp.extend)(e, this._defaultActionArgs()));
        };
    },
    _createActionByOption (optionName, config) {
        var _this = this;
        var action;
        var eventName;
        var actionFunc;
        config = (0, $2oTOp.extend)({}, config);
        var result = function() {
            if (!eventName) {
                config = config || {};
                if ("string" !== typeof optionName) throw (0, $cvYFL.default).Error("E0008");
                if (0 === optionName.indexOf("on")) eventName = $93ce20731cc4d0b7$var$getEventName(optionName);
                actionFunc = _this.option(optionName);
            }
            if (!action && !actionFunc && !config.beforeExecute && !config.afterExecute && !_this._eventsStrategy.hasEvent(eventName)) return;
            if (!action) {
                var beforeExecute = config.beforeExecute;
                config.beforeExecute = function() {
                    for(var _len2 = arguments.length, props = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)props[_key2] = arguments[_key2];
                    beforeExecute && beforeExecute.apply(_this, props);
                    _this._eventsStrategy.fireEvent(eventName, props[0].args);
                };
                action = _this._createAction(actionFunc, config);
            }
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if ((0, $8IERv.default)().wrapActionsBeforeExecute) {
                var beforeActionExecute = _this.option("beforeActionExecute") || (0, $gcp4g.noop);
                var wrappedAction = beforeActionExecute(_this, action, config) || action;
                return wrappedAction.apply(_this, args);
            }
            return action.apply(_this, args);
        };
        if ((0, $8IERv.default)().wrapActionsBeforeExecute) return result;
        var onActionCreated = this.option("onActionCreated") || (0, $gcp4g.noop);
        return onActionCreated(this, result, config) || result;
    },
    on (eventName, eventHandler) {
        this._eventsStrategy.on(eventName, eventHandler);
        return this;
    },
    off (eventName, eventHandler) {
        this._eventsStrategy.off(eventName, eventHandler);
        return this;
    },
    hasActionSubscription: function(actionName) {
        return !!this._options.silent(actionName) || this._eventsStrategy.hasEvent($93ce20731cc4d0b7$var$getEventName(actionName));
    },
    isOptionDeprecated (name) {
        return this._options.isDeprecated(name);
    },
    _setOptionWithoutOptionChange (name, value) {
        this._cancelOptionChange = name;
        this.option(name, value);
        this._cancelOptionChange = false;
    },
    _getOptionValue (name, context) {
        var value = this.option(name);
        if ((0, $6ntMu.isFunction)(value)) return value.bind(context)();
        return value;
    },
    option () {
        return this._options.option(...arguments);
    },
    resetOption (name) {
        this.beginUpdate();
        this._options.reset(name);
        this.endUpdate();
    }
});

});
parcelRegister("jc09l", function(module, exports) {

$parcel$export(module.exports, "Options", function () { return $df8f41082c1d0e87$export$c019608e5b5bb4cb; });
/**
 * DevExtreme (esm/core/options/index.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $4WYaH = parcelRequire("4WYaH");

var $6ntMu = parcelRequire("6ntMu");

var $gcp4g = parcelRequire("gcp4g");

var $Gp5Hu = parcelRequire("Gp5Hu");

var $8Cgs4 = parcelRequire("8Cgs4");

var $apI87 = parcelRequire("apI87");

var $2oTOp = parcelRequire("2oTOp");
class $df8f41082c1d0e87$export$c019608e5b5bb4cb {
    constructor(options, defaultOptions, optionsByReference, deprecatedOptions){
        this._deprecatedCallback;
        this._startChangeCallback;
        this._endChangeCallback;
        this._default = defaultOptions;
        this._deprecated = deprecatedOptions;
        this._deprecatedNames = [];
        this._initDeprecatedNames();
        this._optionManager = new (0, $Gp5Hu.OptionManager)(options, optionsByReference);
        this._optionManager.onRelevantNamesPrepared((options, name, value, silent)=>this._setRelevantNames(options, name, value, silent));
        this._cachedOptions = {};
        this._rules = [];
    }
    set _initial(value) {
        this._initialOptions = value;
    }
    get _initial() {
        if (!this._initialOptions) {
            var rulesOptions = this._getByRules(this.silent("defaultOptionsRules"));
            this._initialOptions = this._default;
            this._optionManager._setByReference(this._initialOptions, rulesOptions);
        }
        return this._initialOptions;
    }
    _initDeprecatedNames() {
        for(var optionName in this._deprecated)this._deprecatedNames.push(optionName);
    }
    _getByRules(rules) {
        rules = Array.isArray(rules) ? this._rules.concat(rules) : this._rules;
        return (0, $apI87.convertRulesToOptions)(rules);
    }
    _notifyDeprecated(option) {
        var info = this._deprecated[option];
        if (info) this._deprecatedCallback(option, info);
    }
    _setRelevantNames(options, name, value, silent) {
        if (name) {
            var normalizedName = this._normalizeName(name, silent);
            if (normalizedName && normalizedName !== name) {
                this._setField(options, normalizedName, value);
                this._clearField(options, name);
            }
        }
    }
    _setField(options, fullName, value) {
        var fieldName = "";
        var fieldObject = null;
        do {
            fieldName = fieldName ? ".".concat(fieldName) : "";
            fieldName = (0, $apI87.getFieldName)(fullName) + fieldName;
            fullName = (0, $apI87.getParentName)(fullName);
            fieldObject = fullName ? this._optionManager.get(options, fullName, false) : options;
        }while (!fieldObject);
        fieldObject[fieldName] = value;
    }
    _clearField(options, name) {
        delete options[name];
        var previousFieldName = (0, $apI87.getParentName)(name);
        var fieldObject = previousFieldName ? this._optionManager.get(options, previousFieldName, false) : options;
        if (fieldObject) delete fieldObject[(0, $apI87.getFieldName)(name)];
    }
    _normalizeName(name, silent) {
        if (this._deprecatedNames.length && name) {
            for(var i = 0; i < this._deprecatedNames.length; i++)if (this._deprecatedNames[i] === name) {
                var deprecate = this._deprecated[name];
                if (deprecate) {
                    !silent && this._notifyDeprecated(name);
                    return deprecate.alias || name;
                }
            }
        }
        return name;
    }
    addRules(rules) {
        this._rules = rules.concat(this._rules);
    }
    applyRules(rules) {
        var options = this._getByRules(rules);
        this.silent(options);
    }
    dispose() {
        this._deprecatedCallback = (0, $gcp4g.noop);
        this._startChangeCallback = (0, $gcp4g.noop);
        this._endChangeCallback = (0, $gcp4g.noop);
        this._optionManager.dispose();
    }
    onChanging(callBack) {
        this._optionManager.onChanging(callBack);
    }
    onChanged(callBack) {
        this._optionManager.onChanged(callBack);
    }
    onDeprecated(callBack) {
        this._deprecatedCallback = callBack;
    }
    onStartChange(callBack) {
        this._startChangeCallback = callBack;
    }
    onEndChange(callBack) {
        this._endChangeCallback = callBack;
    }
    isInitial(name) {
        var value = this.silent(name);
        var initialValue = this.initial(name);
        var areFunctions = (0, $6ntMu.isFunction)(value) && (0, $6ntMu.isFunction)(initialValue);
        return areFunctions ? value.toString() === initialValue.toString() : (0, $gcp4g.equalByValue)(value, initialValue);
    }
    initial(name) {
        return (0, $apI87.getNestedOptionValue)(this._initial, name);
    }
    option(options, value) {
        var isGetter = arguments.length < 2 && "object" !== (0, $6ntMu.type)(options);
        if (isGetter) return this._optionManager.get(void 0, this._normalizeName(options));
        else {
            this._startChangeCallback();
            try {
                this._optionManager.set(options, value);
            } finally{
                this._endChangeCallback();
            }
        }
    }
    silent(options, value) {
        var isGetter = arguments.length < 2 && "object" !== (0, $6ntMu.type)(options);
        if (isGetter) return this._optionManager.get(void 0, options, void 0, true);
        else this._optionManager.set(options, value, void 0, true);
    }
    reset(name) {
        if (name) {
            var fullPath = (0, $8Cgs4.getPathParts)(name);
            var value = fullPath.reduce((value, field)=>value ? value[field] : this.initial(field), null);
            var defaultValue = (0, $6ntMu.isObject)(value) ? (0, $4WYaH.default)({}, value) : value;
            this._optionManager.set(name, defaultValue, false);
        }
    }
    getAliasesByName(name) {
        return Object.keys(this._deprecated).filter((aliasName)=>name === this._deprecated[aliasName].alias);
    }
    isDeprecated(name) {
        return Object.prototype.hasOwnProperty.call(this._deprecated, name);
    }
    cache(name, options) {
        var isGetter = arguments.length < 2;
        if (isGetter) return this._cachedOptions[name];
        else this._cachedOptions[name] = (0, $2oTOp.extend)(this._cachedOptions[name], options);
    }
}

});
parcelRegister("Gp5Hu", function(module, exports) {

$parcel$export(module.exports, "OptionManager", function () { return $07f762e5ba3742d2$export$95c698951477af5c; });
/**
 * DevExtreme (esm/core/options/option_manager.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $8Cgs4 = parcelRequire("8Cgs4");

var $gcp4g = parcelRequire("gcp4g");

var $jh6BM = parcelRequire("jh6BM");

var $2oTOp = parcelRequire("2oTOp");

var $6ntMu = parcelRequire("6ntMu");

var $apI87 = parcelRequire("apI87");
var $07f762e5ba3742d2$var$cachedGetters = {};
var $07f762e5ba3742d2$var$cachedSetters = {};
class $07f762e5ba3742d2$export$95c698951477af5c {
    constructor(options, optionsByReference){
        this._options = options;
        this._optionsByReference = optionsByReference;
        this._changingCallback;
        this._changedCallback;
        this._namePreparedCallbacks;
    }
    _setByReference(options, rulesOptions) {
        (0, $2oTOp.extend)(true, options, rulesOptions);
        for(var fieldName in this._optionsByReference)if (Object.prototype.hasOwnProperty.call(rulesOptions, fieldName)) options[fieldName] = rulesOptions[fieldName];
    }
    _setPreparedValue(name, value, merge, silent) {
        var previousValue = this.get(this._options, name, false);
        if (!(0, $jh6BM.equals)(previousValue, value)) {
            var path = (0, $8Cgs4.getPathParts)(name);
            !silent && this._changingCallback(name, previousValue, value);
            $07f762e5ba3742d2$var$cachedSetters[name] = $07f762e5ba3742d2$var$cachedSetters[name] || (0, $8Cgs4.compileSetter)(name);
            $07f762e5ba3742d2$var$cachedSetters[name](this._options, value, {
                functionsAsIs: true,
                merge: (0, $6ntMu.isDefined)(merge) ? merge : !this._optionsByReference[name],
                unwrapObservables: path.length > 1 && !!this._optionsByReference[path[0]]
            });
            !silent && this._changedCallback(name, value, previousValue);
        }
    }
    _prepareRelevantNames(options, name, value, silent) {
        if ((0, $6ntMu.isPlainObject)(value)) for(var valueName in value)this._prepareRelevantNames(options, "".concat(name, ".").concat(valueName), value[valueName]);
        this._namePreparedCallbacks(options, name, value, silent);
    }
    get() {
        var options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._options;
        var name = arguments.length > 1 ? arguments[1] : void 0;
        var unwrapObservables = arguments.length > 2 ? arguments[2] : void 0;
        $07f762e5ba3742d2$var$cachedGetters[name] = $07f762e5ba3742d2$var$cachedGetters[name] || (0, $8Cgs4.compileGetter)(name);
        return $07f762e5ba3742d2$var$cachedGetters[name](options, {
            functionsAsIs: true,
            unwrapObservables: unwrapObservables
        });
    }
    set(options, value, merge, silent) {
        options = (0, $apI87.normalizeOptions)(options, value);
        for(var name in options)this._prepareRelevantNames(options, name, options[name], silent);
        for(var _name in options)this._setPreparedValue(_name, options[_name], merge, silent);
    }
    onRelevantNamesPrepared(callBack) {
        this._namePreparedCallbacks = callBack;
    }
    onChanging(callBack) {
        this._changingCallback = callBack;
    }
    onChanged(callBack) {
        this._changedCallback = callBack;
    }
    dispose() {
        this._changingCallback = (0, $gcp4g.noop);
        this._changedCallback = (0, $gcp4g.noop);
    }
}

});
parcelRegister("jh6BM", function(module, exports) {

$parcel$export(module.exports, "equals", function () { return $e084bb23724b6af3$export$e9bab7fafb253603; });
/**
 * DevExtreme (esm/core/utils/comparator.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $3yzYM = parcelRequire("3yzYM");

var $8Cgs4 = parcelRequire("8Cgs4");

var $6ntMu = parcelRequire("6ntMu");
var $e084bb23724b6af3$var$hasNegation = function(oldValue, newValue) {
    return 1 / oldValue === 1 / newValue;
};
var $e084bb23724b6af3$export$e9bab7fafb253603 = function(oldValue, newValue) {
    oldValue = (0, $8Cgs4.toComparable)(oldValue, true);
    newValue = (0, $8Cgs4.toComparable)(newValue, true);
    if (oldValue && newValue && (0, $6ntMu.isRenderer)(oldValue) && (0, $6ntMu.isRenderer)(newValue)) return newValue.is(oldValue);
    var oldValueIsNaN = oldValue !== oldValue;
    var newValueIsNaN = newValue !== newValue;
    if (oldValueIsNaN && newValueIsNaN) return true;
    if (0 === oldValue && 0 === newValue) return $e084bb23724b6af3$var$hasNegation(oldValue, newValue);
    if (null === oldValue || "object" !== typeof oldValue || (0, $3yzYM.default).isElementNode(oldValue)) return oldValue === newValue;
    return false;
};

});

parcelRegister("apI87", function(module, exports) {

$parcel$export(module.exports, "convertRulesToOptions", function () { return $794e7879b063d8f0$export$f9c61bf0d66fa1a1; });
$parcel$export(module.exports, "normalizeOptions", function () { return $794e7879b063d8f0$export$eb806c0b85b62f7a; });
$parcel$export(module.exports, "getFieldName", function () { return $794e7879b063d8f0$export$3128dedc24eee543; });
$parcel$export(module.exports, "getParentName", function () { return $794e7879b063d8f0$export$de13ee09b400fa1b; });
$parcel$export(module.exports, "getNestedOptionValue", function () { return $794e7879b063d8f0$export$f05b4c1b89879a14; });
/**
 * DevExtreme (esm/core/options/utils.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $jF0bZ = parcelRequire("jF0bZ");

var $6ntMu = parcelRequire("6ntMu");

var $gcp4g = parcelRequire("gcp4g");

var $2oTOp = parcelRequire("2oTOp");

var $8Cgs4 = parcelRequire("8Cgs4");
var $794e7879b063d8f0$var$cachedGetters = {};
var $794e7879b063d8f0$export$f9c61bf0d66fa1a1 = (rules)=>{
    var currentDevice = (0, $jF0bZ.default).current();
    return rules.reduce((options, _ref)=>{
        var { device: device, options: ruleOptions } = _ref;
        var deviceFilter = device || {};
        var match = (0, $6ntMu.isFunction)(deviceFilter) ? deviceFilter(currentDevice) : $794e7879b063d8f0$export$8fed9c4f2b257722(currentDevice, deviceFilter);
        if (match) (0, $2oTOp.extend)(true, options, ruleOptions);
        return options;
    }, {});
};
var $794e7879b063d8f0$export$eb806c0b85b62f7a = (options, value)=>"string" !== typeof options ? options : {
        [options]: value
    };
var $794e7879b063d8f0$export$8fed9c4f2b257722 = (device, filter)=>(0, $6ntMu.isEmptyObject)(filter) || (0, $gcp4g.findBestMatches)(device, [
        filter
    ]).length > 0;
var $794e7879b063d8f0$export$3128dedc24eee543 = (fullName)=>fullName.substr(fullName.lastIndexOf(".") + 1);
var $794e7879b063d8f0$export$de13ee09b400fa1b = (fullName)=>fullName.substr(0, fullName.lastIndexOf("."));
var $794e7879b063d8f0$export$f05b4c1b89879a14 = function(optionsObject, name) {
    $794e7879b063d8f0$var$cachedGetters[name] = $794e7879b063d8f0$var$cachedGetters[name] || (0, $8Cgs4.compileGetter)(name);
    return $794e7879b063d8f0$var$cachedGetters[name](optionsObject, {
        functionsAsIs: true
    });
};
var $794e7879b063d8f0$export$1ea743575cdd46c8 = function() {
    var options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
    return options;
};

});



parcelRegister("imKwV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5ee5ff766a948ea$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/action.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $hYatw = parcelRequire("hYatw");

var $6ntMu = parcelRequire("6ntMu");

var $8OLOW = parcelRequire("8OLOW");
class $d5ee5ff766a948ea$export$2e2bcd8739ae039 {
    constructor(action, config){
        config = config || {};
        this._action = action;
        this._context = config.context || (0, $hYatw.getWindow)();
        this._beforeExecute = config.beforeExecute;
        this._afterExecute = config.afterExecute;
        this._component = config.component;
        this._validatingTargetName = config.validatingTargetName;
        var excludeValidators = this._excludeValidators = {};
        if (config.excludeValidators) for(var i = 0; i < config.excludeValidators.length; i++)excludeValidators[config.excludeValidators[i]] = true;
    }
    execute() {
        var e = {
            action: this._action,
            args: Array.prototype.slice.call(arguments),
            context: this._context,
            component: this._component,
            validatingTargetName: this._validatingTargetName,
            cancel: false,
            handled: false
        };
        var beforeExecute = this._beforeExecute;
        var afterExecute = this._afterExecute;
        var argsBag = e.args[0] || {};
        if (!this._validateAction(e)) return;
        null === beforeExecute || void 0 === beforeExecute || beforeExecute.call(this._context, e);
        if (e.cancel) return;
        var result = this._executeAction(e);
        if (argsBag.cancel) return;
        null === afterExecute || void 0 === afterExecute || afterExecute.call(this._context, e);
        return result;
    }
    _validateAction(e) {
        var excludeValidators = this._excludeValidators;
        var { executors: executors } = $d5ee5ff766a948ea$export$2e2bcd8739ae039;
        for(var name in executors)if (!excludeValidators[name]) {
            var _executor$validate;
            var executor = executors[name];
            null === (_executor$validate = executor.validate) || void 0 === _executor$validate || _executor$validate.call(executor, e);
            if (e.cancel) return false;
        }
        return true;
    }
    _executeAction(e) {
        var result;
        var { executors: executors } = $d5ee5ff766a948ea$export$2e2bcd8739ae039;
        for(var name in executors){
            var _executor$execute;
            var executor = executors[name];
            null === (_executor$execute = executor.execute) || void 0 === _executor$execute || _executor$execute.call(executor, e);
            if (e.handled) {
                result = e.result;
                break;
            }
        }
        return result;
    }
    static registerExecutor(name, executor) {
        if ((0, $6ntMu.isPlainObject)(name)) {
            (0, $8OLOW.each)(name, $d5ee5ff766a948ea$export$2e2bcd8739ae039.registerExecutor);
            return;
        }
        $d5ee5ff766a948ea$export$2e2bcd8739ae039.executors[name] = executor;
    }
    static unregisterExecutor() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        (0, $8OLOW.each)(args, function() {
            delete $d5ee5ff766a948ea$export$2e2bcd8739ae039.executors[this];
        });
    }
}
$d5ee5ff766a948ea$export$2e2bcd8739ae039.executors = {};
var $d5ee5ff766a948ea$var$createValidatorByTargetElement = (condition)=>(e)=>{
        if (!e.args.length) return;
        var args = e.args[0];
        var element = args[e.validatingTargetName] || args.element;
        if (element && condition((0, $2vlX8.default)(element))) e.cancel = true;
    };
$d5ee5ff766a948ea$export$2e2bcd8739ae039.registerExecutor({
    disabled: {
        validate: $d5ee5ff766a948ea$var$createValidatorByTargetElement(($target)=>$target.is(".dx-state-disabled, .dx-state-disabled *"))
    },
    readOnly: {
        validate: $d5ee5ff766a948ea$var$createValidatorByTargetElement(($target)=>$target.is(".dx-state-readonly, .dx-state-readonly *:not(.dx-state-independent)"))
    },
    undefined: {
        execute: (e)=>{
            if (!e.action) {
                e.result = void 0;
                e.handled = true;
            }
        }
    },
    func: {
        execute: (e)=>{
            if ((0, $6ntMu.isFunction)(e.action)) {
                e.result = e.action.call(e.context, e.args[0]);
                e.handled = true;
            }
        }
    }
});

});

parcelRegister("eQoAl", function(module, exports) {

$parcel$export(module.exports, "PostponedOperations", function () { return $ace8fe1b0dee8abc$export$d9b7a99eb978a6ed; });
/**
 * DevExtreme (esm/core/postponed_operations.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $dDkff = parcelRequire("dDkff");

var $6ntMu = parcelRequire("6ntMu");
class $ace8fe1b0dee8abc$export$d9b7a99eb978a6ed {
    constructor(){
        this._postponedOperations = {};
    }
    add(key, fn, postponedPromise) {
        if (key in this._postponedOperations) postponedPromise && this._postponedOperations[key].promises.push(postponedPromise);
        else {
            var completePromise = new (0, $dDkff.Deferred);
            this._postponedOperations[key] = {
                fn: fn,
                completePromise: completePromise,
                promises: postponedPromise ? [
                    postponedPromise
                ] : []
            };
        }
        return this._postponedOperations[key].completePromise.promise();
    }
    callPostponedOperations() {
        for(var key in this._postponedOperations){
            var operation = this._postponedOperations[key];
            if ((0, $6ntMu.isDefined)(operation)) {
                if (operation.promises && operation.promises.length) (0, $dDkff.when)(...operation.promises).done(operation.fn).then(operation.completePromise.resolve);
                else operation.fn().done(operation.completePromise.resolve);
            }
        }
        this._postponedOperations = {};
    }
}

});


parcelRegister("kHZlm", function(module, exports) {

$parcel$export(module.exports, "TemplateManager", function () { return $f1376853f355371d$export$8cc24d54938ccaf6; });
/**
 * DevExtreme (esm/core/template_manager.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $6ntMu = parcelRequire("6ntMu");

var $gcp4g = parcelRequire("gcp4g");

var $2oTOp = parcelRequire("2oTOp");

var $ioAAe = parcelRequire("ioAAe");

var $dH9fV = parcelRequire("dH9fV");

var $72jmS = parcelRequire("72jmS");
var $f1376853f355371d$var$TEXT_NODE = 3;
var $f1376853f355371d$var$ANONYMOUS_TEMPLATE_NAME = "template";
var $f1376853f355371d$var$TEMPLATE_OPTIONS_NAME = "dxTemplate";
var $f1376853f355371d$var$TEMPLATE_WRAPPER_CLASS = "dx-template-wrapper";
var $f1376853f355371d$var$DX_POLYMORPH_WIDGET_TEMPLATE = new (0, $ioAAe.FunctionTemplate)((_ref)=>{
    var { model: model, parent: parent } = _ref;
    var widgetName = model.widget;
    if (!widgetName) return (0, $2vlX8.default)();
    var widgetElement = (0, $2vlX8.default)("<div>");
    var widgetOptions = model.options || {};
    if (parent) parent._createComponent(widgetElement, widgetName, widgetOptions);
    else widgetElement[widgetName](widgetOptions);
    return widgetElement;
});
class $f1376853f355371d$export$8cc24d54938ccaf6 {
    constructor(createElement, anonymousTemplateName){
        this._tempTemplates = [];
        this._defaultTemplates = {};
        this._anonymousTemplateName = anonymousTemplateName || $f1376853f355371d$var$ANONYMOUS_TEMPLATE_NAME;
        this._createElement = createElement || (0, $72jmS.defaultCreateElement);
        this._createTemplateIfNeeded = this._createTemplateIfNeeded.bind(this);
    }
    static createDefaultOptions() {
        return {
            integrationOptions: {
                watchMethod: function(fn, callback) {
                    var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                    if (!options.skipImmediate) callback(fn());
                    return 0, $gcp4g.noop;
                },
                templates: {
                    "dx-polymorph-widget": $f1376853f355371d$var$DX_POLYMORPH_WIDGET_TEMPLATE
                },
                useDeferUpdateForTemplates: true
            }
        };
    }
    get anonymousTemplateName() {
        return this._anonymousTemplateName;
    }
    addDefaultTemplates(templates) {
        this._defaultTemplates = (0, $2oTOp.extend)({}, this._defaultTemplates, templates);
    }
    dispose() {
        this._tempTemplates.forEach((tempTemplate)=>{
            tempTemplate.template.dispose && tempTemplate.template.dispose();
        });
        this._tempTemplates = [];
    }
    extractTemplates($el) {
        var templates = this._extractTemplates($el);
        var anonymousTemplateMeta = this._extractAnonymousTemplate($el);
        return {
            templates: templates,
            anonymousTemplateMeta: anonymousTemplateMeta
        };
    }
    _extractTemplates($el) {
        var templates = (0, $72jmS.findTemplates)($el, $f1376853f355371d$var$TEMPLATE_OPTIONS_NAME);
        var suitableTemplates = (0, $72jmS.suitableTemplatesByName)(templates);
        templates.forEach((_ref2)=>{
            var { element: element, options: { name: name } } = _ref2;
            if (element === suitableTemplates[name]) (0, $2vlX8.default)(element).addClass($f1376853f355371d$var$TEMPLATE_WRAPPER_CLASS).detach();
            else (0, $2vlX8.default)(element).remove();
        });
        return Object.keys(suitableTemplates).map((name)=>({
                name: name,
                template: this._createTemplate(suitableTemplates[name])
            }));
    }
    _extractAnonymousTemplate($el) {
        var $anonymousTemplate = $el.contents().detach();
        var $notJunkTemplateContent = $anonymousTemplate.filter((_, element)=>{
            var isTextNode = element.nodeType === $f1376853f355371d$var$TEXT_NODE;
            var isEmptyText = (0, $2vlX8.default)(element).text().trim().length < 1;
            return !(isTextNode && isEmptyText);
        });
        return $notJunkTemplateContent.length > 0 ? {
            template: this._createTemplate($anonymousTemplate),
            name: this._anonymousTemplateName
        } : {};
    }
    _createTemplateIfNeeded(templateSource) {
        var cachedTemplate = this._tempTemplates.filter((tempTemplate)=>tempTemplate.source === (0, $72jmS.templateKey)(templateSource))[0];
        if (cachedTemplate) return cachedTemplate.template;
        var template = this._createTemplate(templateSource);
        this._tempTemplates.push({
            template: template,
            source: (0, $72jmS.templateKey)(templateSource)
        });
        return template;
    }
    _createTemplate(templateSource) {
        return this._createElement((0, $72jmS.validateTemplateSource)(templateSource));
    }
    getTemplate(templateSource, templates, _ref3, context) {
        var { isAsyncTemplate: isAsyncTemplate, skipTemplates: skipTemplates } = _ref3;
        if (!(0, $6ntMu.isFunction)(templateSource)) return (0, $72jmS.acquireTemplate)(templateSource, this._createTemplateIfNeeded, templates, isAsyncTemplate, skipTemplates, this._defaultTemplates);
        return new (0, $ioAAe.FunctionTemplate)((options)=>{
            var templateSourceResult = templateSource.apply(context, (0, $72jmS.getNormalizedTemplateArgs)(options));
            if (!(0, $6ntMu.isDefined)(templateSourceResult)) return new (0, $dH9fV.EmptyTemplate);
            var dispose = false;
            var template = (0, $72jmS.acquireTemplate)(templateSourceResult, (templateSource)=>{
                if (templateSource.nodeType || (0, $6ntMu.isRenderer)(templateSource) && !(0, $2vlX8.default)(templateSource).is("script")) return new (0, $ioAAe.FunctionTemplate)(()=>templateSource);
                dispose = true;
                return this._createTemplate(templateSource);
            }, templates, isAsyncTemplate, skipTemplates, this._defaultTemplates);
            var result = template.render(options);
            dispose && template.dispose && template.dispose();
            return result;
        });
    }
}

});
parcelRegister("ioAAe", function(module, exports) {

$parcel$export(module.exports, "FunctionTemplate", function () { return $d646d8975d2df459$export$20e41931b96e61ee; });
/**
 * DevExtreme (esm/core/templates/function_template.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $lzWPl = parcelRequire("lzWPl");

var $g3YTP = parcelRequire("g3YTP");
class $d646d8975d2df459$export$20e41931b96e61ee extends (0, $lzWPl.TemplateBase) {
    constructor(render){
        super();
        this._render = render;
    }
    _renderCore(options) {
        return (0, $g3YTP.normalizeTemplateElement)(this._render(options));
    }
}

});
parcelRegister("lzWPl", function(module, exports) {

$parcel$export(module.exports, "TemplateBase", function () { return $fb5a7fb0d210089a$export$5d87153a4d09e2fc; });
/**
 * DevExtreme (esm/core/templates/template_base.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $3yzYM = parcelRequire("3yzYM");

var $dYDfV = parcelRequire("dYDfV");

var $g3YTP = parcelRequire("g3YTP");

var $78nVZ = parcelRequire("78nVZ");

var $cvYFL = parcelRequire("cvYFL");
var $fb5a7fb0d210089a$export$434e2a93fd66123c = (0, $dYDfV.default)({
    syncStrategy: true
});
class $fb5a7fb0d210089a$export$5d87153a4d09e2fc {
    render(options) {
        options = options || {};
        var onRendered = options.onRendered;
        delete options.onRendered;
        var $result;
        if (options.renovated && options.transclude && this._element) $result = (0, $2vlX8.default)("<div>").append(this._element).contents();
        else $result = this._renderCore(options);
        this._ensureResultInContainer($result, options.container);
        $fb5a7fb0d210089a$export$434e2a93fd66123c.fire($result, options.container);
        onRendered && onRendered();
        return $result;
    }
    _ensureResultInContainer($result, container) {
        if (!container) return;
        var $container = (0, $2vlX8.default)(container);
        var resultInContainer = (0, $g3YTP.contains)($container.get(0), $result.get(0));
        $container.append($result);
        if (resultInContainer) return;
        var resultInBody = (0, $3yzYM.default).getBody().contains($container.get(0));
        if (!resultInBody) return;
        (0, $78nVZ.triggerShownEvent)($result);
    }
    _renderCore() {
        throw (0, $cvYFL.default).Error("E0001");
    }
}

});
parcelRegister("78nVZ", function(module, exports) {

$parcel$export(module.exports, "triggerShownEvent", function () { return $531bd8a1d3542c18$export$4e43b9e1134fa3da; });
/**
 * DevExtreme (esm/events/visibility_change.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $60GuF = parcelRequire("60GuF");
var $531bd8a1d3542c18$var$triggerVisibilityChangeEvent = function(eventName) {
    return function(element) {
        var $element = (0, $2vlX8.default)(element || "body");
        var changeHandlers = $element.filter(".dx-visibility-change-handler").add($element.find(".dx-visibility-change-handler"));
        for(var i = 0; i < changeHandlers.length; i++)(0, $60GuF.default).triggerHandler(changeHandlers[i], eventName);
    };
};
var $531bd8a1d3542c18$export$4e43b9e1134fa3da = $531bd8a1d3542c18$var$triggerVisibilityChangeEvent("dxshown");
var $531bd8a1d3542c18$export$7d7521d776086d59 = $531bd8a1d3542c18$var$triggerVisibilityChangeEvent("dxhiding");
var $531bd8a1d3542c18$export$88a2f523edad4966 = $531bd8a1d3542c18$var$triggerVisibilityChangeEvent("dxresize");

});



parcelRegister("dH9fV", function(module, exports) {

$parcel$export(module.exports, "EmptyTemplate", function () { return $9f8678889f5f4874$export$4b3068c5113eee76; });
/**
 * DevExtreme (esm/core/templates/empty_template.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $lzWPl = parcelRequire("lzWPl");
class $9f8678889f5f4874$export$4b3068c5113eee76 extends (0, $lzWPl.TemplateBase) {
    _renderCore() {
        return (0, $2vlX8.default)();
    }
}

});

parcelRegister("72jmS", function(module, exports) {

$parcel$export(module.exports, "findTemplates", function () { return $51f7be62fa790b13$export$75966f4973c440f0; });
$parcel$export(module.exports, "suitableTemplatesByName", function () { return $51f7be62fa790b13$export$3447da4d918aa301; });
$parcel$export(module.exports, "getNormalizedTemplateArgs", function () { return $51f7be62fa790b13$export$f9b44f7392bb9230; });
$parcel$export(module.exports, "validateTemplateSource", function () { return $51f7be62fa790b13$export$688284434f6df07b; });
$parcel$export(module.exports, "templateKey", function () { return $51f7be62fa790b13$export$c1ae3d51410c11ca; });
$parcel$export(module.exports, "defaultCreateElement", function () { return $51f7be62fa790b13$export$94945cb50bce6264; });
$parcel$export(module.exports, "acquireTemplate", function () { return $51f7be62fa790b13$export$eadb7dc99e233ca5; });
/**
 * DevExtreme (esm/core/utils/template_manager.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $4WYaH = parcelRequire("4WYaH");

var $8IERv = parcelRequire("8IERv");

var $jF0bZ = parcelRequire("jF0bZ");

var $3w5fK = parcelRequire("3w5fK");

var $cvYFL = parcelRequire("cvYFL");

var $2vlX8 = parcelRequire("2vlX8");

var $h0WyQ = parcelRequire("h0WyQ");

var $dH9fV = parcelRequire("dH9fV");

var $b5LEF = parcelRequire("b5LEF");

var $lzWPl = parcelRequire("lzWPl");

var $d64MP = parcelRequire("d64MP");

var $gcp4g = parcelRequire("gcp4g");

var $g3YTP = parcelRequire("g3YTP");

var $2oTOp = parcelRequire("2oTOp");

var $6ntMu = parcelRequire("6ntMu");
var $51f7be62fa790b13$export$75966f4973c440f0 = (element, name)=>{
    var templates = (0, $2vlX8.default)(element).contents().filter("[".concat("data-options", '*="').concat(name, '"]'));
    return [].slice.call(templates).map((element)=>{
        var optionsString = (0, $2vlX8.default)(element).attr("data-options") || "";
        return {
            element: element,
            options: (0, $8IERv.default)().optionsParser(optionsString)[name]
        };
    }).filter((template)=>!!template.options);
};
var $51f7be62fa790b13$export$3447da4d918aa301 = (rawTemplates)=>{
    var templatesMap = (0, $d64MP.groupBy)(rawTemplates, (template)=>template.options.name);
    if (templatesMap[void 0]) throw (0, $cvYFL.default).Error("E0023");
    var result = {};
    Object.keys(templatesMap).forEach((name)=>{
        var _findBestMatches$;
        var suitableTemplate = null === (_findBestMatches$ = (0, $gcp4g.findBestMatches)((0, $jF0bZ.default).current(), templatesMap[name], (template)=>template.options)[0]) || void 0 === _findBestMatches$ ? void 0 : _findBestMatches$.element;
        if (suitableTemplate) result[name] = suitableTemplate;
    });
    return result;
};
var $51f7be62fa790b13$export$9adcd7f12a4c9739 = (template)=>{
    var render = template.render.bind(template);
    return (0, $2oTOp.extend)({}, template, {
        render (options) {
            var templateResult = render(options);
            options && options.onRendered && options.onRendered();
            return templateResult;
        }
    });
};
var $51f7be62fa790b13$export$e64a6aab437b2f98 = (template)=>{
    var render = template.render.bind(template);
    return (0, $2oTOp.extend)({}, template, {
        render (options) {
            var $container = (0, $2vlX8.default)(options.container);
            return render((0, $4WYaH.default)({}, options, {
                container: (0, $3w5fK.getPublicElement)($container)
            }));
        }
    });
};
var $51f7be62fa790b13$export$f9b44f7392bb9230 = (options)=>{
    var args = [];
    if ("model" in options) args.push(options.model);
    if ("index" in options) args.push(options.index);
    args.push(options.container);
    return args;
};
var $51f7be62fa790b13$export$688284434f6df07b = (templateSource)=>"string" === typeof templateSource ? (0, $g3YTP.normalizeTemplateElement)(templateSource) : templateSource;
var $51f7be62fa790b13$export$c1ae3d51410c11ca = (templateSource)=>(0, $6ntMu.isRenderer)(templateSource) && templateSource[0] || templateSource;
var $51f7be62fa790b13$export$94945cb50bce6264 = (element)=>new (0, $b5LEF.Template)(element);
var $51f7be62fa790b13$export$cf2bfdc46f6cabb2 = (templateSource, templates, isAsyncTemplate, skipTemplates)=>{
    var integrationTemplate = null;
    if (!skipTemplates || -1 === skipTemplates.indexOf(templateSource)) {
        integrationTemplate = templates[templateSource];
        if (integrationTemplate && !(integrationTemplate instanceof (0, $lzWPl.TemplateBase))) {
            if ((0, $6ntMu.isFunction)(integrationTemplate.render)) integrationTemplate = $51f7be62fa790b13$export$e64a6aab437b2f98(integrationTemplate);
            if (!isAsyncTemplate) integrationTemplate = $51f7be62fa790b13$export$9adcd7f12a4c9739(integrationTemplate);
        }
    }
    return integrationTemplate;
};
var $51f7be62fa790b13$export$eadb7dc99e233ca5 = (templateSource, createTemplate, templates, isAsyncTemplate, skipTemplates, defaultTemplates)=>{
    if (null == templateSource) return new (0, $dH9fV.EmptyTemplate);
    if (templateSource instanceof (0, $h0WyQ.ChildDefaultTemplate)) return defaultTemplates[templateSource.name];
    if (templateSource instanceof (0, $lzWPl.TemplateBase)) return templateSource;
    if ((0, $6ntMu.isFunction)(templateSource.render) && !(0, $6ntMu.isRenderer)(templateSource)) return isAsyncTemplate ? templateSource : $51f7be62fa790b13$export$9adcd7f12a4c9739(templateSource);
    if (templateSource.nodeType || (0, $6ntMu.isRenderer)(templateSource)) return createTemplate((0, $2vlX8.default)(templateSource));
    return $51f7be62fa790b13$export$cf2bfdc46f6cabb2(templateSource, templates, isAsyncTemplate, skipTemplates) || defaultTemplates[templateSource] || createTemplate(templateSource);
};

});
parcelRegister("3w5fK", function(module, exports) {

$parcel$export(module.exports, "getPublicElement", function () { return $28f86f67c636ce35$export$f35e2167d0d6fe58; });
/**
 * DevExtreme (esm/core/element.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $28f86f67c636ce35$var$strategy = function(element) {
    return element && element.get(0);
};
function $28f86f67c636ce35$export$f35e2167d0d6fe58(element) {
    return $28f86f67c636ce35$var$strategy(element);
}
function $28f86f67c636ce35$export$98ca6cfbd121a38b(newStrategy) {
    $28f86f67c636ce35$var$strategy = newStrategy;
}

});

parcelRegister("h0WyQ", function(module, exports) {

$parcel$export(module.exports, "ChildDefaultTemplate", function () { return $c62fdcc0a1e2b433$export$d3c3a537efbf1054; });
/**
 * DevExtreme (esm/core/templates/child_default_template.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $lzWPl = parcelRequire("lzWPl");
class $c62fdcc0a1e2b433$export$d3c3a537efbf1054 extends (0, $lzWPl.TemplateBase) {
    constructor(name){
        super();
        this.name = name;
    }
}

});

parcelRegister("b5LEF", function(module, exports) {

$parcel$export(module.exports, "Template", function () { return $8135209fa93bcff3$export$14416b8d99d47caa; });
/**
 * DevExtreme (esm/core/templates/template.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $lzWPl = parcelRequire("lzWPl");

var $g3YTP = parcelRequire("g3YTP");

var $jnK2w = parcelRequire("jnK2w");
parcelRequire("gttGE");
(0, $jnK2w.registerTemplateEngine)("default", {
    compile: (element)=>(0, $g3YTP.normalizeTemplateElement)(element),
    render: (template, model, index)=>template.clone()
});
(0, $jnK2w.setTemplateEngine)("default");
class $8135209fa93bcff3$export$14416b8d99d47caa extends (0, $lzWPl.TemplateBase) {
    constructor(element){
        super();
        this._element = element;
    }
    _renderCore(options) {
        var transclude = options.transclude;
        if (!transclude && !this._compiledTemplate) this._compiledTemplate = (0, $jnK2w.getCurrentTemplateEngine)().compile(this._element);
        return (0, $2vlX8.default)("<div>").append(transclude ? this._element : (0, $jnK2w.getCurrentTemplateEngine)().render(this._compiledTemplate, options.model, options.index)).contents();
    }
    source() {
        return (0, $2vlX8.default)(this._element).clone();
    }
}

});
parcelRegister("jnK2w", function(module, exports) {

$parcel$export(module.exports, "registerTemplateEngine", function () { return $e1c3e0d297604388$export$1e663df7421c18d3; });
$parcel$export(module.exports, "setTemplateEngine", function () { return $e1c3e0d297604388$export$9c6c39f50211dc91; });
$parcel$export(module.exports, "getCurrentTemplateEngine", function () { return $e1c3e0d297604388$export$f84fecf446ec6eba; });
/**
 * DevExtreme (esm/core/templates/template_engine_registry.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $cvYFL = parcelRequire("cvYFL");
var $e1c3e0d297604388$var$templateEngines = {};
var $e1c3e0d297604388$var$currentTemplateEngine;
function $e1c3e0d297604388$export$1e663df7421c18d3(name, templateEngine) {
    $e1c3e0d297604388$var$templateEngines[name] = templateEngine;
}
function $e1c3e0d297604388$export$9c6c39f50211dc91(templateEngine) {
    if ((0, $6ntMu.isString)(templateEngine)) {
        $e1c3e0d297604388$var$currentTemplateEngine = $e1c3e0d297604388$var$templateEngines[templateEngine];
        if (!$e1c3e0d297604388$var$currentTemplateEngine) throw (0, $cvYFL.default).Error("E0020", templateEngine);
    } else $e1c3e0d297604388$var$currentTemplateEngine = templateEngine;
}
function $e1c3e0d297604388$export$f84fecf446ec6eba() {
    return $e1c3e0d297604388$var$currentTemplateEngine;
}

});

parcelRegister("gttGE", function(module, exports) {
/**
 * DevExtreme (esm/core/templates/template_engines.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $g3YTP = parcelRequire("g3YTP");

var $jnK2w = parcelRequire("jnK2w");
(0, $jnK2w.registerTemplateEngine)("jquery-tmpl", {
    compile: (element)=>(0, $g3YTP.extractTemplateMarkup)(element),
    render: (template, data)=>jQuery.tmpl(template, data)
});
(0, $jnK2w.registerTemplateEngine)("jsrender", {
    compile: (element)=>(jQuery ? jQuery : jsrender).templates((0, $g3YTP.extractTemplateMarkup)(element)),
    render: (template, data)=>template.render(data)
});
(0, $jnK2w.registerTemplateEngine)("mustache", {
    compile: (element)=>(0, $g3YTP.extractTemplateMarkup)(element),
    render: (template, data)=>Mustache.render(template, data)
});
(0, $jnK2w.registerTemplateEngine)("hogan", {
    compile: (element)=>Hogan.compile((0, $g3YTP.extractTemplateMarkup)(element)),
    render: (template, data)=>template.render(data)
});
(0, $jnK2w.registerTemplateEngine)("underscore", {
    compile: (element)=>_.template((0, $g3YTP.extractTemplateMarkup)(element)),
    render: (template, data)=>template(data)
});
(0, $jnK2w.registerTemplateEngine)("handlebars", {
    compile: (element)=>Handlebars.compile((0, $g3YTP.extractTemplateMarkup)(element)),
    render: (template, data)=>template(data)
});
(0, $jnK2w.registerTemplateEngine)("doT", {
    compile: (element)=>doT.template((0, $g3YTP.extractTemplateMarkup)(element)),
    render: (template, data)=>template(data)
});

});




parcelRegister("kOEFu", function(module, exports) {

$parcel$export(module.exports, "resize", function () { return $f2780609c943d419$export$4380c87abf28fdf; });
$parcel$export(module.exports, "visibility", function () { return $f2780609c943d419$export$91fa9ac3f4021ce4; });
/**
 * DevExtreme (esm/events/short.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $60GuF = parcelRequire("60GuF");

var $aoC8f = parcelRequire("aoC8f");

var $bcOMe = parcelRequire("bcOMe");
function $f2780609c943d419$var$addNamespace(event, namespace) {
    return namespace ? (0, $bcOMe.addNamespace)(event, namespace) : event;
}
function $f2780609c943d419$var$executeAction(action, args) {
    return "function" === typeof action ? action(args) : action.execute(args);
}
var $f2780609c943d419$export$89da14300d534261 = {
    on: ($el, active, inactive, opts)=>{
        var { selector: selector, showTimeout: showTimeout, hideTimeout: hideTimeout, namespace: namespace } = opts;
        (0, $60GuF.default).on($el, $f2780609c943d419$var$addNamespace("dxactive", namespace), selector, {
            timeout: showTimeout
        }, (event)=>$f2780609c943d419$var$executeAction(active, {
                event: event,
                element: event.currentTarget
            }));
        (0, $60GuF.default).on($el, $f2780609c943d419$var$addNamespace("dxinactive", namespace), selector, {
            timeout: hideTimeout
        }, (event)=>$f2780609c943d419$var$executeAction(inactive, {
                event: event,
                element: event.currentTarget
            }));
    },
    off: ($el, _ref)=>{
        var { namespace: namespace, selector: selector } = _ref;
        (0, $60GuF.default).off($el, $f2780609c943d419$var$addNamespace("dxactive", namespace), selector);
        (0, $60GuF.default).off($el, $f2780609c943d419$var$addNamespace("dxinactive", namespace), selector);
    }
};
var $f2780609c943d419$export$4380c87abf28fdf = {
    on: function($el, resize) {
        var { namespace: namespace } = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        (0, $60GuF.default).on($el, $f2780609c943d419$var$addNamespace("dxresize", namespace), resize);
    },
    off: function($el) {
        var { namespace: namespace } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        (0, $60GuF.default).off($el, $f2780609c943d419$var$addNamespace("dxresize", namespace));
    }
};
var $f2780609c943d419$export$3f60957f5dbf3876 = {
    on: ($el, start, end, _ref2)=>{
        var { selector: selector, namespace: namespace } = _ref2;
        (0, $60GuF.default).on($el, $f2780609c943d419$var$addNamespace("dxhoverend", namespace), selector, (event)=>end(event));
        (0, $60GuF.default).on($el, $f2780609c943d419$var$addNamespace("dxhoverstart", namespace), selector, (event)=>$f2780609c943d419$var$executeAction(start, {
                element: event.target,
                event: event
            }));
    },
    off: ($el, _ref3)=>{
        var { selector: selector, namespace: namespace } = _ref3;
        (0, $60GuF.default).off($el, $f2780609c943d419$var$addNamespace("dxhoverstart", namespace), selector);
        (0, $60GuF.default).off($el, $f2780609c943d419$var$addNamespace("dxhoverend", namespace), selector);
    }
};
var $f2780609c943d419$export$91fa9ac3f4021ce4 = {
    on: ($el, shown, hiding, _ref4)=>{
        var { namespace: namespace } = _ref4;
        (0, $60GuF.default).on($el, $f2780609c943d419$var$addNamespace("dxhiding", namespace), hiding);
        (0, $60GuF.default).on($el, $f2780609c943d419$var$addNamespace("dxshown", namespace), shown);
    },
    off: ($el, _ref5)=>{
        var { namespace: namespace } = _ref5;
        (0, $60GuF.default).off($el, $f2780609c943d419$var$addNamespace("dxhiding", namespace));
        (0, $60GuF.default).off($el, $f2780609c943d419$var$addNamespace("dxshown", namespace));
    }
};
var $f2780609c943d419$export$d7ddd398f22d79ef = {
    on: ($el, focusIn, focusOut, _ref6)=>{
        var { namespace: namespace } = _ref6;
        (0, $60GuF.default).on($el, $f2780609c943d419$var$addNamespace("focusin", namespace), focusIn);
        (0, $60GuF.default).on($el, $f2780609c943d419$var$addNamespace("focusout", namespace), focusOut);
    },
    off: ($el, _ref7)=>{
        var { namespace: namespace } = _ref7;
        (0, $60GuF.default).off($el, $f2780609c943d419$var$addNamespace("focusin", namespace));
        (0, $60GuF.default).off($el, $f2780609c943d419$var$addNamespace("focusout", namespace));
    },
    trigger: ($el)=>(0, $60GuF.default).trigger($el, "focus")
};
var $f2780609c943d419$export$78d3a24c08a161b4 = {
    on: function($el, click) {
        var { namespace: namespace } = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        (0, $60GuF.default).on($el, $f2780609c943d419$var$addNamespace("dxclick", namespace), click);
    },
    off: function($el) {
        var { namespace: namespace } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        (0, $60GuF.default).off($el, $f2780609c943d419$var$addNamespace("dxclick", namespace));
    }
};
var $f2780609c943d419$export$64ef1bee2b9504c1 = {
    on: function($el, click) {
        var { namespace: namespace } = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        (0, $60GuF.default).on($el, $f2780609c943d419$var$addNamespace("click", namespace), click);
    },
    off: function($el) {
        var { namespace: namespace } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        (0, $60GuF.default).off($el, $f2780609c943d419$var$addNamespace("click", namespace));
    }
};
var $f2780609c943d419$var$index = 0;
var $f2780609c943d419$var$keyboardProcessors = {};
var $f2780609c943d419$var$generateListenerId = ()=>"keyboardProcessorId".concat($f2780609c943d419$var$index++);
var $f2780609c943d419$export$cfdd767f5a513509 = {
    on: (element, focusTarget, handler)=>{
        var listenerId = $f2780609c943d419$var$generateListenerId();
        $f2780609c943d419$var$keyboardProcessors[listenerId] = new (0, $aoC8f.default)({
            element: element,
            focusTarget: focusTarget,
            handler: handler
        });
        return listenerId;
    },
    off: (listenerId)=>{
        if (listenerId && $f2780609c943d419$var$keyboardProcessors[listenerId]) {
            $f2780609c943d419$var$keyboardProcessors[listenerId].dispose();
            delete $f2780609c943d419$var$keyboardProcessors[listenerId];
        }
    },
    _getProcessor: (listenerId)=>$f2780609c943d419$var$keyboardProcessors[listenerId]
};

});
parcelRegister("aoC8f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7919b984926f75d9$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/events/core/keyboard_processor.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2vlX8 = parcelRequire("2vlX8");

var $60GuF = parcelRequire("60GuF");

var $a2g7x = parcelRequire("a2g7x");

var $bcOMe = parcelRequire("bcOMe");
var $7919b984926f75d9$var$COMPOSITION_START_EVENT = "compositionstart";
var $7919b984926f75d9$var$COMPOSITION_END_EVENT = "compositionend";
var $7919b984926f75d9$var$KEYDOWN_EVENT = "keydown";
var $7919b984926f75d9$var$NAMESPACE = "KeyboardProcessor";
var $7919b984926f75d9$var$createKeyDownOptions = (e)=>({
        keyName: (0, $bcOMe.normalizeKeyName)(e),
        key: e.key,
        code: e.code,
        ctrl: e.ctrlKey,
        location: e.location,
        metaKey: e.metaKey,
        shift: e.shiftKey,
        alt: e.altKey,
        which: e.which,
        originalEvent: e
    });
var $7919b984926f75d9$var$KeyboardProcessor = (0, $a2g7x.default).inherit({
    _keydown: (0, $bcOMe.addNamespace)($7919b984926f75d9$var$KEYDOWN_EVENT, $7919b984926f75d9$var$NAMESPACE),
    _compositionStart: (0, $bcOMe.addNamespace)($7919b984926f75d9$var$COMPOSITION_START_EVENT, $7919b984926f75d9$var$NAMESPACE),
    _compositionEnd: (0, $bcOMe.addNamespace)($7919b984926f75d9$var$COMPOSITION_END_EVENT, $7919b984926f75d9$var$NAMESPACE),
    ctor: function(options) {
        options = options || {};
        if (options.element) this._element = (0, $2vlX8.default)(options.element);
        if (options.focusTarget) this._focusTarget = options.focusTarget;
        this._handler = options.handler;
        if (this._element) {
            this._processFunction = (e)=>{
                var focusTargets = (0, $2vlX8.default)(this._focusTarget).toArray();
                var isNotFocusTarget = this._focusTarget && this._focusTarget !== e.target && !focusTargets.includes(e.target);
                var shouldSkipProcessing = this._isComposingJustFinished && 229 === e.which || this._isComposing || isNotFocusTarget;
                this._isComposingJustFinished = false;
                if (!shouldSkipProcessing) this.process(e);
            };
            this._toggleProcessingWithContext = this.toggleProcessing.bind(this);
            (0, $60GuF.default).on(this._element, this._keydown, this._processFunction);
            (0, $60GuF.default).on(this._element, this._compositionStart, this._toggleProcessingWithContext);
            (0, $60GuF.default).on(this._element, this._compositionEnd, this._toggleProcessingWithContext);
        }
    },
    dispose: function() {
        if (this._element) {
            (0, $60GuF.default).off(this._element, this._keydown, this._processFunction);
            (0, $60GuF.default).off(this._element, this._compositionStart, this._toggleProcessingWithContext);
            (0, $60GuF.default).off(this._element, this._compositionEnd, this._toggleProcessingWithContext);
        }
        this._element = void 0;
        this._handler = void 0;
    },
    process: function(e) {
        this._handler($7919b984926f75d9$var$createKeyDownOptions(e));
    },
    toggleProcessing: function(_ref) {
        var { type: type } = _ref;
        this._isComposing = type === $7919b984926f75d9$var$COMPOSITION_START_EVENT;
        this._isComposingJustFinished = !this._isComposing;
    }
});
$7919b984926f75d9$var$KeyboardProcessor.createKeyDownOptions = $7919b984926f75d9$var$createKeyDownOptions;
var $7919b984926f75d9$export$2e2bcd8739ae039 = $7919b984926f75d9$var$KeyboardProcessor;

});



parcelRegister("7xBJI", function(module, exports) {

$parcel$export(module.exports, "createEventTrigger", function () { return $57d8e31c5f48eebc$export$5d04eba666987b27; });
$parcel$export(module.exports, "createIncidentOccurred", function () { return $57d8e31c5f48eebc$export$531e3d846bf78d14; });
$parcel$export(module.exports, "createResizeHandler", function () { return $57d8e31c5f48eebc$export$1c6828a73b08a1; });
/**
 * DevExtreme (esm/viz/core/base_widget.utils.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $5gpMu = parcelRequire("5gpMu");

var $9vHY4 = parcelRequire("9vHY4");

var $Ut3m2 = parcelRequire("Ut3m2");

var $8OLOW = parcelRequire("8OLOW");

var $2SbZF = parcelRequire("2SbZF");

var $jGnjU = parcelRequire("jGnjU");

var $dw9tZ = parcelRequire("dw9tZ");
var $57d8e31c5f48eebc$var$ERROR_MESSAGES = (0, $Ut3m2.default).ERROR_MESSAGES;
function $57d8e31c5f48eebc$export$5d04eba666987b27(eventsMap, callbackGetter) {
    var triggers = {};
    (0, $8OLOW.each)(eventsMap, function(name, info) {
        if (info.name) createEvent(name);
    });
    var changes;
    triggerEvent.change = function(name) {
        var eventInfo = eventsMap[name];
        if (eventInfo) (changes = changes || {})[name] = eventInfo;
        return !!eventInfo;
    };
    triggerEvent.applyChanges = function() {
        if (changes) {
            (0, $8OLOW.each)(changes, function(name, eventInfo) {
                createEvent(eventInfo.newName || name);
            });
            changes = null;
        }
    };
    triggerEvent.dispose = function() {
        eventsMap = callbackGetter = triggers = null;
    };
    return triggerEvent;
    function createEvent(name) {
        var eventInfo = eventsMap[name];
        triggers[eventInfo.name] = callbackGetter(name, eventInfo.actionSettings);
    }
    function triggerEvent(name, arg, complete) {
        triggers[name](arg);
        complete && complete();
    }
}
var $57d8e31c5f48eebc$export$531e3d846bf78d14 = function(widgetName, eventTrigger) {
    return function(id, args) {
        eventTrigger("incidentOccurred", {
            target: {
                id: id,
                type: "E" === id[0] ? "error" : "warning",
                args: args,
                text: (0, $9vHY4.format).apply(null, [
                    $57d8e31c5f48eebc$var$ERROR_MESSAGES[id]
                ].concat(args || [])),
                widget: widgetName,
                version: (0, $5gpMu.version)
            }
        });
    };
};
function $57d8e31c5f48eebc$var$getResizeManager(resizeCallback) {
    return (observe, unsubscribe)=>{
        var { handler: handler, dispose: dispose } = $57d8e31c5f48eebc$var$createDeferredHandler(resizeCallback, unsubscribe);
        observe(handler);
        return dispose;
    };
}
function $57d8e31c5f48eebc$var$createDeferredHandler(callback, unsubscribe) {
    var timeout;
    var handler = function() {
        clearTimeout(timeout);
        timeout = setTimeout(callback, 100);
    };
    return {
        handler: handler,
        dispose () {
            clearTimeout(timeout);
            unsubscribe(handler);
        }
    };
}
function $57d8e31c5f48eebc$export$1c6828a73b08a1(contentElement, redrawOnResize, resize) {
    var disposeHandler;
    var resizeManager = $57d8e31c5f48eebc$var$getResizeManager(resize);
    if ("windowonly" === (0, $dw9tZ.normalizeEnum)(redrawOnResize)) disposeHandler = resizeManager((handler)=>(0, $2SbZF.default).add(handler), (handler)=>(0, $2SbZF.default).remove(handler));
    else if (true === redrawOnResize) disposeHandler = resizeManager((handler)=>(0, $jGnjU.default).observe(contentElement, handler), ()=>(0, $jGnjU.default).unobserve(contentElement));
    return disposeHandler;
}

});
parcelRegister("Ut3m2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a9bc46b430466d1$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/core/errors_warnings.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $hCicl = parcelRequire("hCicl");

var $cvYFL = parcelRequire("cvYFL");
var $0a9bc46b430466d1$export$2e2bcd8739ae039 = (0, $hCicl.default)((0, $cvYFL.default).ERROR_MESSAGES, {
    E2001: "Invalid data source",
    E2002: "Axis type and data type are incompatible",
    E2003: 'The "{0}" data source field contains data of unsupported type',
    E2004: 'The "{0}" data source field is inconsistent',
    E2005: 'The value field "{0}" is absent in the data source or all its values are negative',
    E2006: "A cycle is detected in provided data",
    E2007: 'The value field "{0}" is absent in the data source',
    E2008: 'The value field "{0}" must be a string',
    E2009: 'The value field "{0}" must be a positive numeric value',
    E2101: "Unknown series type: {0}",
    E2102: "Ambiguity occurred between two value axes with the same name",
    E2103: 'The "{0}" option is given an invalid value. Assign a function instead',
    E2104: "Invalid logarithm base",
    E2105: 'Invalid value of a "{0}"',
    E2202: "Invalid {0} scale value",
    E2203: "The range you are trying to set is invalid",
    W2002: "The {0} series cannot be drawn because the {1} data field is missing",
    W2003: "Tick interval is too small",
    W2101: 'The "{0}" pane does not exist; the last pane is used by default',
    W2102: 'A value axis with the "{0}" name was created automatically',
    W2103: "The chart title was hidden due to the container size",
    W2104: "The legend was hidden due to the container size",
    W2105: 'The title of the "{0}" axis was hidden due to the container size',
    W2106: 'The labels of the "{0}" axis were hidden due to the container size',
    W2107: "The export menu was hidden due to the container size",
    W2108: "The browser does not support exporting images to {0} format.",
    W2301: "Invalid value range"
});

});

parcelRegister("jGnjU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e544076fe4d98a84$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/core/resize_observer.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $gcp4g = parcelRequire("gcp4g");

var $hYatw = parcelRequire("hYatw");
var $e544076fe4d98a84$var$window = (0, $hYatw.getWindow)();
var $e544076fe4d98a84$var$ResizeObserverMock = {
    observe: (0, $gcp4g.noop),
    unobserve: (0, $gcp4g.noop),
    disconnect: (0, $gcp4g.noop)
};
class $e544076fe4d98a84$var$ResizeObserverSingleton {
    constructor(){
        if (!(0, $hYatw.hasWindow)() || !$e544076fe4d98a84$var$window.ResizeObserver) return $e544076fe4d98a84$var$ResizeObserverMock;
        this._callbacksMap = new Map;
        this._observer = new $e544076fe4d98a84$var$window.ResizeObserver((entries)=>{
            entries.forEach((entry)=>{
                var _this$_callbacksMap$g;
                null === (_this$_callbacksMap$g = this._callbacksMap.get(entry.target)) || void 0 === _this$_callbacksMap$g || _this$_callbacksMap$g(entry);
            });
        });
    }
    observe(element, callback) {
        this._callbacksMap.set(element, callback);
        this._observer.observe(element);
    }
    unobserve(element) {
        this._callbacksMap.delete(element);
        this._observer.unobserve(element);
    }
    disconnect() {
        this._callbacksMap.clear();
        this._observer.disconnect();
    }
}
var $e544076fe4d98a84$var$resizeObserverSingleton = new $e544076fe4d98a84$var$ResizeObserverSingleton;
var $e544076fe4d98a84$export$2e2bcd8739ae039 = $e544076fe4d98a84$var$resizeObserverSingleton;

});


parcelRegister("e7MTd", function(module, exports) {

$parcel$export(module.exports, "replaceInherit", function () { return $a487a4942a958e3d$export$72443dd311d4e3dc; });
$parcel$export(module.exports, "changes", function () { return $a487a4942a958e3d$export$5f64e879c3ad59fe; });
/**
 * DevExtreme (esm/viz/core/helpers.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $hYatw = parcelRequire("hYatw");

var $gcp4g = parcelRequire("gcp4g");
var $a487a4942a958e3d$var$isServerSide = !(0, $hYatw.hasWindow)();
function $a487a4942a958e3d$var$Flags() {
    this.reset();
}
$a487a4942a958e3d$var$Flags.prototype = {
    constructor: $a487a4942a958e3d$var$Flags,
    add: function(codes) {
        var i;
        var ii = codes.length;
        var flags = this._flags;
        for(i = 0; i < ii; ++i)flags[codes[i]] = 1;
    },
    has: function(code) {
        return this._flags[code] > 0;
    },
    count: function() {
        return Object.keys(this._flags).length;
    },
    reset: function() {
        this._flags = {};
    }
};
function $a487a4942a958e3d$var$combineMaps(baseMap, thisMap) {
    return baseMap !== thisMap ? (0, $2oTOp.extend)({}, baseMap, thisMap) : (0, $2oTOp.extend)({}, baseMap);
}
function $a487a4942a958e3d$var$combineLists(baseList, thisList) {
    return baseList !== thisList ? baseList.concat(thisList) : baseList.slice();
}
function $a487a4942a958e3d$var$buildTotalChanges(proto) {
    proto._totalChangesOrder = proto._optionChangesOrder.concat(proto._layoutChangesOrder, proto._customChangesOrder);
}
function $a487a4942a958e3d$var$addChange(settings) {
    var proto = this.prototype;
    var code = settings.code;
    proto["_change_" + code] = settings.handler;
    if (settings.isThemeDependent) proto._themeDependentChanges.push(code);
    if (settings.option) proto._optionChangesMap[settings.option] = code;
    (settings.isOptionChange ? proto._optionChangesOrder : proto._customChangesOrder).push(code);
    $a487a4942a958e3d$var$buildTotalChanges(proto);
}
function $a487a4942a958e3d$var$createChainExecutor() {
    var executeChain = function executeChain() {
        var i;
        var ii = executeChain._chain.length;
        var result;
        for(i = 0; i < ii; ++i)result = executeChain._chain[i].apply(this, arguments);
        return result;
    };
    executeChain._chain = [];
    executeChain.add = function(item) {
        executeChain._chain.push(item);
    };
    executeChain.copy = function(executor) {
        executeChain._chain = executor._chain.slice();
    };
    return executeChain;
}
function $a487a4942a958e3d$export$9f77e0932fb78f72(target, name, expander) {
    var current = target[name];
    if (!current) current = expander;
    else if (!current.add) {
        current = $a487a4942a958e3d$var$createChainExecutor();
        current.add(target[name]);
        current.add(expander);
    } else {
        if (false === Object.prototype.hasOwnProperty.call(target, name)) {
            current = $a487a4942a958e3d$var$createChainExecutor();
            current.copy(target[name]);
        }
        current.add(expander);
    }
    target[name] = current;
}
function $a487a4942a958e3d$var$addPlugin(plugin) {
    var proto = this.prototype;
    proto._plugins.push(plugin);
    plugin.fontFields && proto._fontFields.push.apply(proto._fontFields, plugin.fontFields);
    if (plugin.members) (0, $2oTOp.extend)(this.prototype, plugin.members);
    if (plugin.customize) plugin.customize(this);
    if (plugin.extenders) Object.keys(plugin.extenders).forEach(function(key) {
        var func = plugin.extenders[key];
        $a487a4942a958e3d$export$9f77e0932fb78f72(proto, key, func);
    }, this);
}
var $a487a4942a958e3d$export$72443dd311d4e3dc = $a487a4942a958e3d$var$isServerSide ? function(widget) {
    var _inherit = widget.inherit;
    widget.inherit = function() {
        var result = _inherit.apply(this, arguments);
        var proto = result.prototype;
        [
            "_plugins",
            "_eventsMap",
            "_initialChanges",
            "_themeDependentChanges",
            "_optionChangesMap",
            "_optionChangesOrder",
            "_layoutChangesOrder",
            "_customChangesOrder",
            "_totalChangesOrder"
        ].forEach(function(key) {
            proto[key] = {};
        });
        result.addPlugin = (0, $gcp4g.noop);
        return result;
    };
    widget.addChange = (0, $gcp4g.noop);
    widget.addPlugin = (0, $gcp4g.noop);
} : function(widget) {
    var _inherit = widget.inherit;
    widget.inherit = function() {
        var proto = this.prototype;
        var plugins = proto._plugins;
        var fontFields = proto._fontFields;
        var eventsMap = proto._eventsMap;
        var initialChanges = proto._initialChanges;
        var themeDependentChanges = proto._themeDependentChanges;
        var optionChangesMap = proto._optionChangesMap;
        var partialOptionChangesMap = proto._partialOptionChangesMap;
        var partialOptionChangesPath = proto._partialOptionChangesPath;
        var optionChangesOrder = proto._optionChangesOrder;
        var layoutChangesOrder = proto._layoutChangesOrder;
        var customChangesOrder = proto._customChangesOrder;
        var result = _inherit.apply(this, arguments);
        proto = result.prototype;
        proto._plugins = $a487a4942a958e3d$var$combineLists(plugins, proto._plugins);
        proto._fontFields = $a487a4942a958e3d$var$combineLists(fontFields, proto._fontFields);
        proto._eventsMap = $a487a4942a958e3d$var$combineMaps(eventsMap, proto._eventsMap);
        proto._initialChanges = $a487a4942a958e3d$var$combineLists(initialChanges, proto._initialChanges);
        proto._themeDependentChanges = $a487a4942a958e3d$var$combineLists(themeDependentChanges, proto._themeDependentChanges);
        proto._optionChangesMap = $a487a4942a958e3d$var$combineMaps(optionChangesMap, proto._optionChangesMap);
        proto._partialOptionChangesMap = $a487a4942a958e3d$var$combineMaps(partialOptionChangesMap, proto._partialOptionChangesMap);
        proto._partialOptionChangesPath = $a487a4942a958e3d$var$combineMaps(partialOptionChangesPath, proto._partialOptionChangesPath);
        proto._optionChangesOrder = $a487a4942a958e3d$var$combineLists(optionChangesOrder, proto._optionChangesOrder);
        proto._layoutChangesOrder = $a487a4942a958e3d$var$combineLists(layoutChangesOrder, proto._layoutChangesOrder);
        proto._customChangesOrder = $a487a4942a958e3d$var$combineLists(customChangesOrder, proto._customChangesOrder);
        $a487a4942a958e3d$var$buildTotalChanges(proto);
        result.addPlugin = $a487a4942a958e3d$var$addPlugin;
        return result;
    };
    widget.prototype._plugins = [];
    widget.prototype._fontFields = [];
    widget.addChange = $a487a4942a958e3d$var$addChange;
    widget.addPlugin = $a487a4942a958e3d$var$addPlugin;
};
function $a487a4942a958e3d$export$5f64e879c3ad59fe() {
    return new $a487a4942a958e3d$var$Flags;
}

});

parcelRegister("SJOFr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a4895681c6f5820$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/core/layout.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $dw9tZ = parcelRequire("dw9tZ");
var $0a4895681c6f5820$var$_min = Math.min;
var $0a4895681c6f5820$var$_max = Math.max;
var $0a4895681c6f5820$var$_round = Math.round;
var $0a4895681c6f5820$var$ALIGN_START = 0;
var $0a4895681c6f5820$var$ALIGN_MIDDLE = 1;
var $0a4895681c6f5820$var$ALIGN_END = 2;
var $0a4895681c6f5820$var$horizontalAlignmentMap = {
    left: $0a4895681c6f5820$var$ALIGN_START,
    center: $0a4895681c6f5820$var$ALIGN_MIDDLE,
    right: $0a4895681c6f5820$var$ALIGN_END
};
var $0a4895681c6f5820$var$verticalAlignmentMap = {
    top: $0a4895681c6f5820$var$ALIGN_START,
    center: $0a4895681c6f5820$var$ALIGN_MIDDLE,
    bottom: $0a4895681c6f5820$var$ALIGN_END
};
var $0a4895681c6f5820$var$sideMap = {
    horizontal: 0,
    vertical: 1
};
var $0a4895681c6f5820$var$slicersMap = {};
var $0a4895681c6f5820$var$BBOX_CEIL_CORRECTION = 2;
$0a4895681c6f5820$var$slicersMap[$0a4895681c6f5820$var$ALIGN_START] = function(a, b, size) {
    return [
        a,
        $0a4895681c6f5820$var$_min(b, a + size)
    ];
};
$0a4895681c6f5820$var$slicersMap[$0a4895681c6f5820$var$ALIGN_MIDDLE] = function(a, b, size) {
    return [
        $0a4895681c6f5820$var$_max(a, (a + b - size) / 2),
        $0a4895681c6f5820$var$_min(b, (a + b + size) / 2)
    ];
};
$0a4895681c6f5820$var$slicersMap[$0a4895681c6f5820$var$ALIGN_END] = function(a, b, size) {
    return [
        $0a4895681c6f5820$var$_max(a, b - size),
        b
    ];
};
function $0a4895681c6f5820$var$pickValue(value, map, defaultValue) {
    var val = (0, $dw9tZ.normalizeEnum)(value);
    return val in map ? map[val] : defaultValue;
}
function $0a4895681c6f5820$var$normalizeLayoutOptions(options) {
    var side = $0a4895681c6f5820$var$pickValue(options.side, $0a4895681c6f5820$var$sideMap, 1);
    var alignment = [
        $0a4895681c6f5820$var$pickValue(options.horizontalAlignment, $0a4895681c6f5820$var$horizontalAlignmentMap, $0a4895681c6f5820$var$ALIGN_MIDDLE),
        $0a4895681c6f5820$var$pickValue(options.verticalAlignment, $0a4895681c6f5820$var$verticalAlignmentMap, $0a4895681c6f5820$var$ALIGN_START)
    ];
    return {
        side: side,
        primary: $0a4895681c6f5820$var$bringToEdge(alignment[side]),
        secondary: alignment[1 - side],
        weak: options.weak,
        priority: options.priority || 0,
        header: options.header,
        position: options.position
    };
}
function $0a4895681c6f5820$var$bringToEdge(primary) {
    return primary < 2 ? 0 : 2;
}
function $0a4895681c6f5820$var$getConjugateSide(side) {
    return 1 - side;
}
function $0a4895681c6f5820$var$getSlice(alignment, a, b, size) {
    return $0a4895681c6f5820$var$slicersMap[alignment](a, b, size);
}
function $0a4895681c6f5820$var$getShrink(alignment, size) {
    return (alignment > 0 ? -1 : 1) * size;
}
function $0a4895681c6f5820$var$processForward(item, rect, minSize) {
    var side = item.side;
    var size = item.element.measure([
        rect[2] - rect[0],
        rect[3] - rect[1]
    ]);
    var minSide = "indside" === item.position ? 0 : minSize[side];
    var isValid = size[side] < rect[2 + side] - rect[side] - minSide;
    if (isValid) {
        if ("inside" !== item.position) rect[item.primary + side] += $0a4895681c6f5820$var$getShrink(item.primary, size[side]);
        item.size = size;
    }
    return isValid;
}
function $0a4895681c6f5820$var$processRectBackward(item, rect, alignmentRect) {
    var primarySide = item.side;
    var secondarySide = $0a4895681c6f5820$var$getConjugateSide(primarySide);
    var itemRect = [];
    var secondary = $0a4895681c6f5820$var$getSlice(item.secondary, alignmentRect[secondarySide], alignmentRect[2 + secondarySide], item.size[secondarySide]);
    itemRect[primarySide] = $0a4895681c6f5820$var$_round(itemRect[2 + primarySide] = rect[item.primary + primarySide] + ("inside" === item.position ? $0a4895681c6f5820$var$getShrink(item.primary, item.size[primarySide]) : 0));
    itemRect[item.primary + primarySide] = $0a4895681c6f5820$var$_round(rect[item.primary + primarySide] - $0a4895681c6f5820$var$getShrink(item.primary, item.size[primarySide]));
    if ("inside" !== item.position) rect[item.primary + primarySide] = itemRect[item.primary + primarySide];
    itemRect[secondarySide] = $0a4895681c6f5820$var$_round(secondary[0]);
    itemRect[2 + secondarySide] = $0a4895681c6f5820$var$_round(secondary[1]);
    return itemRect;
}
function $0a4895681c6f5820$var$processBackward(item, rect, alignmentRect, fitRect, size, targetRect) {
    var itemRect = $0a4895681c6f5820$var$processRectBackward(item, rect, alignmentRect);
    var itemFitRect = $0a4895681c6f5820$var$processRectBackward(item, fitRect, fitRect);
    if (size[item.side] > 0) {
        size[item.side] -= item.size[item.side];
        targetRect[item.primary + item.side] = itemRect[item.primary + item.side];
        item.element.freeSpace();
    } else item.element.move(itemRect, itemFitRect);
}
function $0a4895681c6f5820$var$Layout() {
    this._targets = [];
}
$0a4895681c6f5820$var$Layout.prototype = {
    constructor: $0a4895681c6f5820$var$Layout,
    dispose: function() {
        this._targets = null;
    },
    add: function(target) {
        this._targets.push(target);
    },
    forward: function(targetRect, minSize) {
        var rect = targetRect.slice();
        var targets = $0a4895681c6f5820$var$createTargets(this._targets);
        var i;
        var ii = targets.length;
        var cache = [];
        for(i = 0; i < ii; ++i)if ($0a4895681c6f5820$var$processForward(targets[i], rect, minSize)) cache.push(targets[i]);
        else targets[i].element.freeSpace();
        this._cache = cache.reverse();
        return rect;
    },
    backward: function(targetRect, alignmentRect) {
        var size = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [
            0,
            0
        ];
        var backwardRect = targetRect.slice();
        var fitRect = targetRect.slice();
        var targets = this._cache;
        var targetSide = 0;
        var target;
        var i;
        var ii = targets.length;
        for(i = 0; i < ii; ++i){
            target = targets[i];
            if (target.side !== targetSide) backwardRect = targetRect.slice();
            $0a4895681c6f5820$var$processBackward(target, backwardRect, alignmentRect, fitRect, size, targetRect);
            targetSide = target.side;
        }
        return size;
    }
};
function $0a4895681c6f5820$var$createTargets(targets) {
    var i;
    var ii = targets.length;
    var collection = [];
    var layout;
    for(i = 0; i < ii; ++i){
        layout = targets[i].layoutOptions();
        if (layout) {
            layout = $0a4895681c6f5820$var$normalizeLayoutOptions(layout);
            layout.element = targets[i];
            collection.push(layout);
        }
    }
    collection.sort(function(a, b) {
        return b.side - a.side || a.priority - b.priority;
    });
    collection = $0a4895681c6f5820$var$processWeakItems(collection);
    return collection;
}
function $0a4895681c6f5820$var$processWeakItems(collection) {
    var weakItem = collection.filter(function(item) {
        return true === item.weak;
    })[0];
    var headerItem;
    if (weakItem) headerItem = collection.filter(function(item) {
        return weakItem.primary === item.primary && item.side === weakItem.side && item !== weakItem;
    })[0];
    if (weakItem && headerItem) return [
        $0a4895681c6f5820$var$makeHeader(headerItem, weakItem)
    ].concat(collection.filter(function(item) {
        return !(item === headerItem || item === weakItem);
    }));
    return collection;
}
function $0a4895681c6f5820$var$processBackwardHeaderRect(element, rect) {
    var rectCopy = rect.slice();
    var itemRect = $0a4895681c6f5820$var$processRectBackward(element, rectCopy, rectCopy);
    itemRect[element.side] = rect[element.side];
    itemRect[2 + element.side] = rect[2 + element.side];
    return itemRect;
}
function $0a4895681c6f5820$var$makeHeader(header, weakElement) {
    var side = header.side;
    var primary = header.primary;
    var secondary = header.secondary;
    return {
        side: side,
        primary: primary,
        secondary: secondary,
        priority: 0,
        element: {
            measure: function(targetSize) {
                var result = targetSize.slice();
                var weakSize = weakElement.element.measure(targetSize.slice());
                targetSize[primary] -= weakSize[primary];
                var headerSize = header.element.measure(targetSize.slice());
                result[side] = weakSize[side] = headerSize[side] = Math.max(headerSize[side], weakSize[side]);
                weakElement.size = weakSize;
                header.size = headerSize;
                return result;
            },
            move: function(rect, fitRect) {
                if (fitRect[2] - fitRect[0] < header.size[0] + weakElement.size[0] - $0a4895681c6f5820$var$BBOX_CEIL_CORRECTION) {
                    this.freeSpace();
                    return;
                }
                var weakRect = $0a4895681c6f5820$var$processBackwardHeaderRect(weakElement, fitRect);
                fitRect[2 + weakElement.primary] = weakRect[weakElement.primary];
                var headerFitReact = $0a4895681c6f5820$var$processBackwardHeaderRect(header, fitRect);
                if (fitRect[2 + weakElement.primary] < rect[2 + weakElement.primary] && header.size[header.primary] > rect[2 + header.primary] - rect[header.primary]) rect[2 + weakElement.primary] = fitRect[2 + weakElement.primary];
                var headerRect = $0a4895681c6f5820$var$processBackwardHeaderRect(header, rect);
                if (headerRect[2 + weakElement.primary] > fitRect[2 + weakElement.primary]) {
                    rect[2 + weakElement.primary] = fitRect[2 + weakElement.primary];
                    headerRect = $0a4895681c6f5820$var$processBackwardHeaderRect(header, rect);
                }
                weakElement.element.move(weakRect);
                header.element.move(headerRect, headerFitReact);
            },
            freeSpace: function() {
                header.element.freeSpace();
                weakElement.element.freeSpace();
            }
        }
    };
}
var $0a4895681c6f5820$export$2e2bcd8739ae039 = $0a4895681c6f5820$var$Layout;

});

parcelRegister("5XaPR", function(module, exports) {

$parcel$export(module.exports, "prepareSegmentRectPoints", function () { return $455ade2182d48e3a$export$7a384d022b983d1c; });
$parcel$export(module.exports, "areCanvasesDifferent", function () { return $455ade2182d48e3a$export$aca5e57c8537d040; });
$parcel$export(module.exports, "floorCanvasDimensions", function () { return $455ade2182d48e3a$export$df8a399cfb41b303; });
/**
 * DevExtreme (esm/viz/utils.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $4WYaH = parcelRequire("4WYaH");

var $fORY6 = parcelRequire("fORY6");

var $8OLOW = parcelRequire("8OLOW");
var { floor: $455ade2182d48e3a$var$floor } = Math;
var $455ade2182d48e3a$export$7a384d022b983d1c = function(left, top, width, height, borderOptions) {
    var maxSW = ~~((width < height ? width : height) / 2);
    var sw = borderOptions.width || 0;
    var newSW = sw < maxSW ? sw : maxSW;
    left += newSW / 2;
    top += newSW / 2;
    width -= newSW;
    height -= newSW;
    var right = left + width;
    var bottom = top + height;
    var points = [];
    var segments = [];
    var segmentSequence;
    var visiblyOpt = 0;
    var prevSegmentVisibility = 0;
    var allSegment = {
        top: [
            [
                left,
                top
            ],
            [
                right,
                top
            ]
        ],
        right: [
            [
                right,
                top
            ],
            [
                right,
                bottom
            ]
        ],
        bottom: [
            [
                right,
                bottom
            ],
            [
                left,
                bottom
            ]
        ],
        left: [
            [
                left,
                bottom
            ],
            [
                left,
                top
            ]
        ]
    };
    (0, $8OLOW.each)(allSegment, function(seg) {
        var visibility = !!borderOptions[seg];
        visiblyOpt = 2 * visiblyOpt + ~~visibility;
    });
    switch(visiblyOpt){
        case 13:
        case 9:
            segmentSequence = [
                "left",
                "top",
                "right",
                "bottom"
            ];
            break;
        case 11:
            segmentSequence = [
                "bottom",
                "left",
                "top",
                "right"
            ];
            break;
        default:
            segmentSequence = [
                "top",
                "right",
                "bottom",
                "left"
            ];
    }
    (0, $8OLOW.each)(segmentSequence, function(_, seg) {
        var segmentVisibility = !!borderOptions[seg];
        if (!prevSegmentVisibility && segments.length) {
            points.push(segments);
            segments = [];
        }
        if (segmentVisibility) (0, $8OLOW.each)(allSegment[seg].slice(prevSegmentVisibility), function(_, segment) {
            segments = segments.concat(segment);
        });
        prevSegmentVisibility = ~~segmentVisibility;
    });
    segments.length && points.push(segments);
    1 === points.length && (points = points[0]);
    return {
        points: points,
        pathType: 15 === visiblyOpt ? "area" : "line"
    };
};
var $455ade2182d48e3a$export$aca5e57c8537d040 = function(canvas1, canvas2) {
    var sizeLessThreshold = [
        "width",
        "height"
    ].every((key)=>Math.abs(canvas1[key] - canvas2[key]) < 1);
    var canvasCoordsIsEqual = [
        "left",
        "right",
        "top",
        "bottom"
    ].every((key)=>canvas1[key] === canvas2[key]);
    return !(sizeLessThreshold && canvasCoordsIsEqual);
};
var $455ade2182d48e3a$export$df8a399cfb41b303 = function(canvas) {
    return (0, $4WYaH.default)({}, canvas, {
        height: $455ade2182d48e3a$var$floor(canvas.height),
        width: $455ade2182d48e3a$var$floor(canvas.width)
    });
};

});


parcelRegister("32RRa", function(module, exports) {

$parcel$export(module.exports, "RollingStock", function () { return $237b55cf0b4341a6$export$4fa3d6a3f81d4ebf; });
/**
 * DevExtreme (esm/__internal/viz/chart_components/rolling_stock.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ class $237b55cf0b4341a6$export$4fa3d6a3f81d4ebf {
    constructor(label, isRotated, shiftFunction){
        var bBox = label.getBoundingRect();
        var { x: x } = bBox;
        var { y: y } = bBox;
        var endX = bBox.x + bBox.width;
        var endY = bBox.y + bBox.height;
        this.labels = [
            label
        ];
        this.shiftFunction = shiftFunction;
        this.bBox = {
            start: isRotated ? x : y,
            width: isRotated ? bBox.width : bBox.height,
            end: isRotated ? endX : endY,
            oppositeStart: isRotated ? y : x,
            oppositeEnd: isRotated ? endY : endX
        };
        this.initialPosition = isRotated ? bBox.x : bBox.y;
    }
    toChain(nextRollingStock) {
        var nextRollingStockBBox = nextRollingStock.getBoundingRect();
        nextRollingStock.shift(nextRollingStockBBox.start - this.bBox.end);
        this.changeBoxWidth(nextRollingStockBBox.width);
        this.labels = this.labels.concat(nextRollingStock.labels);
    }
    getBoundingRect() {
        return this.bBox;
    }
    shift(shiftLength) {
        this.labels.forEach((label)=>{
            var bBox = label.getBoundingRect();
            var coords = this.shiftFunction(bBox, shiftLength);
            if (!label.hideInsideLabel(coords)) label.shift(coords.x, coords.y);
        });
        this.bBox.end -= shiftLength;
        this.bBox.start -= shiftLength;
    }
    setRollingStockInCanvas(canvas) {
        if (this.bBox.end > canvas.end) this.shift(this.bBox.end - canvas.end);
    }
    getLabels() {
        return this.labels;
    }
    value() {
        return this.labels[0].getData().value;
    }
    getInitialPosition() {
        return this.initialPosition;
    }
    changeBoxWidth(width) {
        this.bBox.end += width;
        this.bBox.width += width;
    }
}

});




parcelRegister("eCfBx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa40b802dd2fccfc$var$ReactIs, $aa40b802dd2fccfc$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("2tbKl"))();

});
parcelRegister("2tbKl", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $c3YnH = parcelRequire("c3YnH");
function $1cc766ccf0672393$var$emptyFunction() {}
function $1cc766ccf0672393$var$emptyFunctionWithReset() {}
$1cc766ccf0672393$var$emptyFunctionWithReset.resetWarningCache = $1cc766ccf0672393$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $c3YnH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $1cc766ccf0672393$var$emptyFunctionWithReset,
        resetWarningCache: $1cc766ccf0672393$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("c3YnH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $8c849a51633fc8b0$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $8c849a51633fc8b0$var$ReactPropTypesSecret;

});



parcelRegister("2qbeQ", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
var $1c36ba2d65e741fd$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Component = void 0;

var $bh6RR = parcelRequire("bh6RR");

var $aKrW4 = parcelRequire("aKrW4");

var $fpGsg = parcelRequire("fpGsg");
var $1c36ba2d65e741fd$var$Component = /** @class */ function(_super) {
    $1c36ba2d65e741fd$var$__extends(Component, _super);
    function Component(props) {
        var _this = _super.call(this, props) || this;
        _this._extensionCreators = [];
        _this._registerExtension = _this._registerExtension.bind(_this);
        return _this;
    }
    Component.prototype.componentDidMount = function() {
        _super.prototype.componentDidMount.call(this);
        this._createWidget();
        this._createExtensions();
    };
    Component.prototype.componentWillUnmount = function() {
        _super.prototype.componentWillUnmount.call(this);
        this.clearExtensions();
    };
    Component.prototype.clearExtensions = function() {
        this._extensionCreators = [];
    };
    Component.prototype.renderChildren = function() {
        var _this = this;
        return $bh6RR.Children.map(this.props.children, function(child) {
            if (child && Object.prototype.isPrototypeOf.call($fpGsg.ExtensionComponent, child.type)) return $bh6RR.cloneElement(child, {
                onMounted: _this._registerExtension
            });
            return child;
        });
    };
    Component.prototype._registerExtension = function(creator) {
        this._extensionCreators.push(creator);
    };
    Component.prototype._createExtensions = function() {
        var _this = this;
        this._extensionCreators.forEach(function(creator) {
            return creator(_this._element);
        });
    };
    return Component;
}($aKrW4.ComponentBase);
module.exports.Component = $1c36ba2d65e741fd$var$Component;

});
parcelRegister("aKrW4", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
var $7d33deb2bfefd704$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7d33deb2bfefd704$var$__assign = module.exports && module.exports.__assign || function() {
    $7d33deb2bfefd704$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7d33deb2bfefd704$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DX_REMOVE_EVENT = module.exports.ComponentBase = void 0;

var $1DQcf = parcelRequire("1DQcf");

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");

var $kF9XG = parcelRequire("kF9XG");

var $hrldD = parcelRequire("hrldD");

var $1ivwh = parcelRequire("1ivwh");

var $gxJM2 = parcelRequire("gxJM2");

var $g8nHh = parcelRequire("g8nHh");

var $b1sL6 = parcelRequire("b1sL6");

var $ebvE2 = parcelRequire("ebvE2");
var $7d33deb2bfefd704$var$DX_REMOVE_EVENT = "dxremove";
module.exports.DX_REMOVE_EVENT = $7d33deb2bfefd704$var$DX_REMOVE_EVENT;
var $7d33deb2bfefd704$var$ComponentBase = /** @class */ function(_super) {
    $7d33deb2bfefd704$var$__extends(ComponentBase, _super);
    function ComponentBase(props) {
        var _this = _super.call(this, props) || this;
        _this.isPortalComponent = false;
        _this._templateProps = [];
        _this._childNodes = [];
        _this.useRequestAnimationFrameFlag = false;
        _this.useDeferUpdateForTemplates = false;
        _this._setTemplatesRendererRef = _this._setTemplatesRendererRef.bind(_this);
        _this._createWidget = _this._createWidget.bind(_this);
        _this._templatesStore = new $1ivwh.TemplatesStore(function() {
            if (_this._templatesRendererRef) _this._templatesRendererRef.scheduleUpdate(_this.useDeferUpdateForTemplates);
        });
        _this._templatesManager = new $kF9XG.default(_this._templatesStore);
        _this._optionsManager = new $gxJM2.OptionsManager(_this._templatesManager);
        return _this;
    }
    ComponentBase.displayContentsStyle = function() {
        return $ebvE2.isIE() ? {
            width: "100%",
            height: "100%",
            padding: 0,
            margin: 0
        } : {
            display: "contents"
        };
    };
    ComponentBase.prototype.componentDidMount = function() {
        var _a;
        var _b;
        if ((_b = this._childNodes) === null || _b === void 0 ? void 0 : _b.length) (_a = this._element).append.apply(_a, this._childNodes);
        else if (this._element.childNodes.length) this._childNodes = Array.from(this._element.childNodes);
        this._updateCssClasses(null, this.props);
    };
    ComponentBase.prototype.componentDidUpdate = function(prevProps) {
        this._updateCssClasses(prevProps, this.props);
        var config = this._getConfig();
        this._optionsManager.update(config);
        if (this._templatesRendererRef) this._templatesRendererRef.scheduleUpdate(this.useDeferUpdateForTemplates, $gxJM2.scheduleGuards);
        $gxJM2.unscheduleGuards();
    };
    ComponentBase.prototype.componentWillUnmount = function() {
        var _a;
        if (this._instance) {
            (_a = this._childNodes) === null || _a === void 0 || _a.forEach(function(child) {
                var _a;
                return (_a = child.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(child);
            });
            $1DQcf.triggerHandler(this._element, $7d33deb2bfefd704$var$DX_REMOVE_EVENT);
            this._instance.dispose();
        }
        this._optionsManager.dispose();
    };
    ComponentBase.prototype._createWidget = function(element) {
        element = element || this._element;
        var config = this._getConfig();
        this._instance = new this._WidgetClass(element, $7d33deb2bfefd704$var$__assign({
            templatesRenderAsynchronously: true
        }, this._optionsManager.getInitialOptions(config)));
        if (!this.useRequestAnimationFrameFlag) this.useDeferUpdateForTemplates = this._instance.option("integrationOptions.useDeferUpdateForTemplates");
        this._optionsManager.setInstance(this._instance, config, this.subscribableOptions, this.independentEvents);
        this._instance.on("optionChanged", this._optionsManager.onOptionChanged);
    };
    ComponentBase.prototype._getConfig = function() {
        return $b1sL6.buildConfigTree({
            templates: this._templateProps,
            initialValuesProps: this._defaults,
            predefinedValuesProps: {},
            expectedChildren: this._expectedChildren
        }, this.props);
    };
    ComponentBase.prototype._setTemplatesRendererRef = function(instance) {
        this._templatesRendererRef = instance;
    };
    ComponentBase.prototype._getElementProps = function() {
        var _this = this;
        var elementProps = {
            ref: function(element) {
                _this._element = element;
            }
        };
        $g8nHh.elementPropNames.forEach(function(name) {
            var props = _this.props;
            if (name in props) elementProps[name] = props[name];
        });
        return elementProps;
    };
    ComponentBase.prototype._updateCssClasses = function(prevProps, newProps) {
        var _a, _b;
        var prevClassName = prevProps ? $g8nHh.getClassName(prevProps) : undefined;
        var newClassName = $g8nHh.getClassName(newProps);
        if (prevClassName === newClassName) return;
        if (prevClassName) {
            var classNames = prevClassName.split(" ").filter(function(c) {
                return c;
            });
            if (classNames.length) (_a = this._element.classList).remove.apply(_a, classNames);
        }
        if (newClassName) {
            var classNames = newClassName.split(" ").filter(function(c) {
                return c;
            });
            if (classNames.length) (_b = this._element.classList).add.apply(_b, classNames);
        }
    };
    ComponentBase.prototype.renderChildren = function() {
        var children = this.props.children;
        return children;
    };
    ComponentBase.prototype.renderContent = function() {
        var _this = this;
        var children = this.props.children;
        return this.isPortalComponent && children ? $bh6RR.createElement("div", {
            ref: function(node) {
                if (node && _this.portalContainer !== node) {
                    _this.portalContainer = node;
                    _this.forceUpdate();
                }
            },
            style: ComponentBase.displayContentsStyle()
        }) : this.renderChildren();
    };
    ComponentBase.prototype.renderPortal = function() {
        return this.portalContainer && $6afFj.createPortal(this.renderChildren(), this.portalContainer);
    };
    ComponentBase.prototype.render = function() {
        return $bh6RR.createElement($bh6RR.Fragment, {}, $bh6RR.createElement("div", this._getElementProps(), this.renderContent(), $bh6RR.createElement($hrldD.TemplatesRenderer, {
            templatesStore: this._templatesStore,
            ref: this._setTemplatesRendererRef
        })), this.isPortalComponent && this.renderPortal());
    };
    return ComponentBase;
}($bh6RR.PureComponent);
module.exports.ComponentBase = $7d33deb2bfefd704$var$ComponentBase;

});
parcelRegister("1DQcf", function(module, exports) {

$parcel$export(module.exports, "one", function () { return $1321ec1e895da090$export$80bf7733f1207381; });
$parcel$export(module.exports, "off", function () { return $1321ec1e895da090$export$8c8705df4a2dcec9; });
$parcel$export(module.exports, "triggerHandler", function () { return $1321ec1e895da090$export$e1caf2fca16e7e23; });
/**
 * DevExtreme (esm/events/index.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $60GuF = parcelRequire("60GuF");
var $1321ec1e895da090$export$af631764ddc44097 = (0, $60GuF.default).on;
var $1321ec1e895da090$export$80bf7733f1207381 = (0, $60GuF.default).one;
var $1321ec1e895da090$export$8c8705df4a2dcec9 = (0, $60GuF.default).off;
var $1321ec1e895da090$export$e614dc9140f7ae71 = (0, $60GuF.default).trigger;
var $1321ec1e895da090$export$e1caf2fca16e7e23 = (0, $60GuF.default).triggerHandler;
var $1321ec1e895da090$export$d61e24a684f9e51 = (0, $60GuF.default).Event;

});

parcelRegister("kF9XG", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bh6RR = parcelRequire("bh6RR");

var $iH8zX = parcelRequire("iH8zX");

var $f58TF = parcelRequire("f58TF");
function $f0af5d2ae390ce9f$var$normalizeProps(props) {
    if ($iH8zX.getOption("useLegacyTemplateEngine")) {
        var model = props.data;
        if (model && Object.prototype.hasOwnProperty.call(model, "key")) model.dxkey = model.key;
        return model;
    }
    return props;
}
var $f0af5d2ae390ce9f$var$contentCreators = {
    component: function(contentGetter) {
        return function(props) {
            props = $f0af5d2ae390ce9f$var$normalizeProps(props);
            return $bh6RR.createElement.bind(null, contentGetter())(props);
        };
    },
    render: function(contentGetter) {
        return function(props) {
            $f0af5d2ae390ce9f$var$normalizeProps(props);
            return contentGetter()(props.data, props.index);
        };
    },
    children: function(contentGetter) {
        return function() {
            return contentGetter();
        };
    }
};
var $f0af5d2ae390ce9f$var$TemplatesManager = /** @class */ function() {
    function TemplatesManager(templatesStore) {
        this._templates = {};
        this._templatesContent = {};
        this._templatesStore = templatesStore;
    }
    TemplatesManager.prototype.add = function(name, template) {
        var _this = this;
        this._templatesContent[name] = template.content;
        var contentCreator = $f0af5d2ae390ce9f$var$contentCreators[template.type].bind(this, function() {
            return _this._templatesContent[name];
        });
        this._templates[name] = $f58TF.createDxTemplate(contentCreator, this._templatesStore, template.keyFn);
    };
    Object.defineProperty(TemplatesManager.prototype, "templatesCount", {
        get: function() {
            return Object.keys(this._templates).length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemplatesManager.prototype, "templates", {
        get: function() {
            return this._templates;
        },
        enumerable: false,
        configurable: true
    });
    return TemplatesManager;
}();
module.exports.default = $f0af5d2ae390ce9f$var$TemplatesManager;

});
parcelRegister("iH8zX", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
var $d9c2e5c58370e46b$var$__assign = module.exports && module.exports.__assign || function() {
    $d9c2e5c58370e46b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d9c2e5c58370e46b$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getOption = void 0;
var $d9c2e5c58370e46b$var$config = {
    useLegacyTemplateEngine: false
};
function $d9c2e5c58370e46b$var$setOptions(options) {
    $d9c2e5c58370e46b$var$config = $d9c2e5c58370e46b$var$__assign($d9c2e5c58370e46b$var$__assign({}, $d9c2e5c58370e46b$var$config), options);
}
function $d9c2e5c58370e46b$var$getOption(optionName) {
    return $d9c2e5c58370e46b$var$config[optionName];
}
module.exports.getOption = $d9c2e5c58370e46b$var$getOption;
module.exports.default = $d9c2e5c58370e46b$var$setOptions;

});

parcelRegister("f58TF", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createDxTemplate = void 0;

var $bh6RR = parcelRequire("bh6RR");

var $f0saG = parcelRequire("f0saG");

var $3myFM = parcelRequire("3myFM");

var $aKrW4 = parcelRequire("aKrW4");

var $1DQcf = parcelRequire("1DQcf");
function $afae395d8481adbc$var$unwrapElement(element) {
    return element.get ? element.get(0) : element;
}
function $afae395d8481adbc$var$createDxTemplate(createContentProvider, templatesStore, keyFn) {
    var renderedTemplates = new $f0saG.DoubleKeyMap();
    return {
        render: function(data) {
            var container = $afae395d8481adbc$var$unwrapElement(data.container);
            var key = {
                key1: data.model,
                key2: container
            };
            var prevTemplateId = renderedTemplates.get(key);
            var templateId;
            var onRemoved = function() {
                templatesStore.setDeferredRemove(templateId, true);
                renderedTemplates.delete(key);
            };
            var _subscribeOnContainerRemoval = function() {
                if (container.nodeType === Node.ELEMENT_NODE) $1DQcf.one(container, $aKrW4.DX_REMOVE_EVENT, onRemoved);
            };
            var _unsubscribeOnContainerRemoval = function() {
                if (container.nodeType === Node.ELEMENT_NODE) $1DQcf.off(container, $aKrW4.DX_REMOVE_EVENT, onRemoved);
            };
            if (prevTemplateId) templateId = prevTemplateId;
            else {
                templateId = keyFn ? keyFn(data.model) : "__template_" + $f0saG.generateID();
                if (data.model !== undefined) renderedTemplates.set(key, templateId);
            }
            _subscribeOnContainerRemoval();
            templatesStore.add(templateId, function() {
                var props = {
                    data: data.model,
                    index: data.index
                };
                var contentProvider = createContentProvider();
                return $bh6RR.createElement($3myFM.TemplateWrapper, {
                    content: contentProvider(props),
                    container: container,
                    onRemoved: onRemoved,
                    onDidMount: function() {
                        var _a;
                        _unsubscribeOnContainerRemoval();
                        templatesStore.setDeferredRemove(templateId, false);
                        (_a = data.onRendered) === null || _a === void 0 || _a.call(data);
                    },
                    key: templateId
                });
            });
            return container;
        }
    };
}
module.exports.createDxTemplate = $afae395d8481adbc$var$createDxTemplate;

});
parcelRegister("f0saG", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.capitalizeFirstLetter = module.exports.DoubleKeyMap = module.exports.generateID = void 0;
function $aeccb5553a8809ac$var$generateID() {
    return Math.random().toString(36).substr(2);
}
module.exports.generateID = $aeccb5553a8809ac$var$generateID;
var $aeccb5553a8809ac$var$DoubleKeyMap = /** @class */ function() {
    function DoubleKeyMap() {
        this._map = new Map();
    }
    DoubleKeyMap.prototype.set = function(_a, value) {
        var key1 = _a.key1, key2 = _a.key2;
        var innerMap = this._map.get(key1);
        if (!innerMap) {
            innerMap = new Map();
            this._map.set(key1, innerMap);
        }
        innerMap.set(key2, value);
    };
    DoubleKeyMap.prototype.get = function(_a) {
        var key1 = _a.key1, key2 = _a.key2;
        var innerMap = this._map.get(key1);
        return innerMap ? innerMap.get(key2) : undefined;
    };
    DoubleKeyMap.prototype.delete = function(_a) {
        var key1 = _a.key1, key2 = _a.key2;
        var innerMap = this._map.get(key1);
        if (!innerMap) return;
        innerMap.delete(key2);
        if (innerMap.size === 0) this._map.delete(key1);
    };
    return DoubleKeyMap;
}();
module.exports.DoubleKeyMap = $aeccb5553a8809ac$var$DoubleKeyMap;
function $aeccb5553a8809ac$var$capitalizeFirstLetter(text) {
    if (text.length) return "" + text[0].toUpperCase() + text.substr(1);
    return "";
}
module.exports.capitalizeFirstLetter = $aeccb5553a8809ac$var$capitalizeFirstLetter;

});

parcelRegister("3myFM", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
var $272e527c59929df5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TemplateWrapper = void 0;

var $1DQcf = parcelRequire("1DQcf");

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");

var $aKrW4 = parcelRequire("aKrW4");
var $272e527c59929df5$var$removalListenerStyle = {
    display: "none"
};
var $272e527c59929df5$var$TableNodeNames;
(function(TableNodeNames) {
    TableNodeNames["TABLE"] = "tbody";
    TableNodeNames["TBODY"] = "tr";
})($272e527c59929df5$var$TableNodeNames || ($272e527c59929df5$var$TableNodeNames = {}));
var $272e527c59929df5$var$TemplateWrapper = /** @class */ function(_super) {
    $272e527c59929df5$var$__extends(TemplateWrapper, _super);
    function TemplateWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this._removalListenerRef = $bh6RR.createRef();
        _this.state = {
            removalListenerRequired: false
        };
        _this._onDxRemove = _this._onDxRemove.bind(_this);
        _this.getPreviousSiblingNode = _this.getPreviousSiblingNode.bind(_this);
        return _this;
    }
    TemplateWrapper.prototype.componentDidMount = function() {
        var _a, _b;
        this._subscribeOnRemove();
        (_b = (_a = this.props).onDidMount) === null || _b === void 0 || _b.call(_a);
    };
    TemplateWrapper.prototype.componentDidUpdate = function() {
        this._subscribeOnRemove();
    };
    TemplateWrapper.prototype.componentWillUnmount = function() {
        // Let React remove it itself
        var node = this.element;
        var hiddenNode = this.hiddenElement;
        var container = this.props.container;
        if (node) container.appendChild(node);
        if (hiddenNode) container.appendChild(hiddenNode);
        if (this._listenerElement) container.appendChild(this._listenerElement);
    };
    Object.defineProperty(TemplateWrapper.prototype, "_listenerElement", {
        get: function() {
            return this._removalListenerRef.current;
        },
        enumerable: false,
        configurable: true
    });
    TemplateWrapper.prototype.getPreviousSiblingNode = function(node) {
        this.hiddenElement = node;
        this.element = node === null || node === void 0 ? void 0 : node.previousSibling;
    };
    TemplateWrapper.prototype._subscribeOnRemove = function() {
        var node = this.element;
        var removalListenerRequired = this.state.removalListenerRequired;
        if (node && node.nodeType === Node.ELEMENT_NODE) {
            this._subscribeOnElementRemoval(node);
            return;
        }
        if (!removalListenerRequired) {
            this.setState({
                removalListenerRequired: true
            });
            return;
        }
        if (this._listenerElement) this._subscribeOnElementRemoval(this._listenerElement);
    };
    TemplateWrapper.prototype._subscribeOnElementRemoval = function(element) {
        $1DQcf.off(element, $aKrW4.DX_REMOVE_EVENT, this._onDxRemove);
        $1DQcf.one(element, $aKrW4.DX_REMOVE_EVENT, this._onDxRemove);
    };
    TemplateWrapper.prototype._onDxRemove = function() {
        var onRemoved = this.props.onRemoved;
        onRemoved();
    };
    TemplateWrapper.prototype.render = function() {
        var removalListenerRequired = this.state.removalListenerRequired;
        var _a = this.props, content = _a.content, container = _a.container;
        var removalListener = removalListenerRequired ? $bh6RR.createElement("span", {
            style: $272e527c59929df5$var$removalListenerStyle,
            ref: this._removalListenerRef
        }) : undefined;
        var nodeName = $272e527c59929df5$var$TableNodeNames[container.nodeName] || "div";
        return $6afFj.createPortal($bh6RR.createElement($bh6RR.Fragment, null, content, content && $bh6RR.createElement(nodeName, {
            style: {
                display: "none"
            },
            ref: this.getPreviousSiblingNode
        }), removalListener), container);
    };
    return TemplateWrapper;
}($bh6RR.PureComponent);
module.exports.TemplateWrapper = $272e527c59929df5$var$TemplateWrapper;

});



parcelRegister("hrldD", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
var $cb256af02748cee9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TemplatesRenderer = void 0;

var $9gxmQ = parcelRequire("9gxmQ");

var $gcp4g = parcelRequire("gcp4g");

var $bh6RR = parcelRequire("bh6RR");
var $cb256af02748cee9$var$TemplatesRenderer = /** @class */ function(_super) {
    $cb256af02748cee9$var$__extends(TemplatesRenderer, _super);
    function TemplatesRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.updateScheduled = false;
        _this.mounted = false;
        _this.shouldRepeatForceUpdate = false;
        _this.isUpdateFuncLaunched = false;
        return _this;
    }
    TemplatesRenderer.prototype.componentDidMount = function() {
        this.mounted = true;
    };
    TemplatesRenderer.prototype.componentWillUnmount = function() {
        this.mounted = false;
    };
    TemplatesRenderer.prototype.scheduleUpdate = function(useDeferUpdate, onRendered) {
        var _this = this;
        if (this.updateScheduled) {
            this.shouldRepeatForceUpdate = this.isUpdateFuncLaunched;
            return;
        }
        this.updateScheduled = true;
        var updateFunc = useDeferUpdate ? $gcp4g.deferUpdate : $9gxmQ.requestAnimationFrame;
        updateFunc(function() {
            if (_this.mounted) {
                _this.isUpdateFuncLaunched = true;
                _this.forceUpdate(function() {
                    _this.updateScheduled = false;
                    onRendered === null || onRendered === void 0 || onRendered();
                    if (_this.shouldRepeatForceUpdate) {
                        _this.shouldRepeatForceUpdate = false;
                        _this.forceUpdate();
                    }
                });
            }
            _this.isUpdateFuncLaunched = false;
            _this.updateScheduled = false;
        });
    };
    TemplatesRenderer.prototype.render = function() {
        var templatesStore = this.props.templatesStore;
        return $bh6RR.createElement($bh6RR.Fragment, {}, templatesStore.renderWrappers());
    };
    return TemplatesRenderer;
}($bh6RR.PureComponent);
module.exports.TemplatesRenderer = $cb256af02748cee9$var$TemplatesRenderer;

});

parcelRegister("1ivwh", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TemplatesStore = void 0;
var $0f1fec018bc3cccc$var$TemplatesStore = /** @class */ function() {
    function TemplatesStore(onTemplateAdded) {
        this._templates = {};
        this._onTemplateAdded = onTemplateAdded;
    }
    TemplatesStore.prototype.add = function(templateId, templateFunc) {
        this._templates[templateId] = {
            template: templateFunc,
            isDeferredRemove: false
        };
        this._onTemplateAdded();
    };
    TemplatesStore.prototype.setDeferredRemove = function(templateId, isDeferredRemove) {
        if (this._templates[templateId]) this._templates[templateId].isDeferredRemove = isDeferredRemove;
    };
    TemplatesStore.prototype.removeDefferedTemplate = function() {
        var _this = this;
        Object.entries(this._templates).filter(function(_a) {
            var templateInfo = _a[1];
            return templateInfo.isDeferredRemove;
        }).forEach(function(_a) {
            var templateId = _a[0];
            delete _this._templates[templateId];
        });
    };
    TemplatesStore.prototype.renderWrappers = function() {
        var _this = this;
        this.removeDefferedTemplate();
        return Object.getOwnPropertyNames(this._templates).map(function(templateId) {
            return _this._templates[templateId].template();
        });
    };
    return TemplatesStore;
}();
module.exports.TemplatesStore = $0f1fec018bc3cccc$var$TemplatesStore;

});

parcelRegister("gxJM2", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OptionsManager = module.exports.scheduleGuards = module.exports.unscheduleGuards = void 0;

var $3hcP7 = parcelRequire("3hcP7");

var $3qUgU = parcelRequire("3qUgU");

var $ebvE2 = parcelRequire("ebvE2");

var $f0saG = parcelRequire("f0saG");
var $c0b33c26cdfb7536$var$optionsManagers = new Set();
var $c0b33c26cdfb7536$var$guardTimeoutHandler = -1;
function $c0b33c26cdfb7536$var$unscheduleGuards() {
    clearTimeout($c0b33c26cdfb7536$var$guardTimeoutHandler);
}
module.exports.unscheduleGuards = $c0b33c26cdfb7536$var$unscheduleGuards;
function $c0b33c26cdfb7536$var$scheduleGuards() {
    $c0b33c26cdfb7536$var$unscheduleGuards();
    $c0b33c26cdfb7536$var$guardTimeoutHandler = window.setTimeout(function() {
        $c0b33c26cdfb7536$var$optionsManagers.forEach(function(optionManager) {
            return optionManager.execGuards();
        });
    });
}
module.exports.scheduleGuards = $c0b33c26cdfb7536$var$scheduleGuards;
var $c0b33c26cdfb7536$var$OptionsManager = /** @class */ function() {
    function OptionsManager(templatesManager) {
        this.guards = {};
        this.isUpdating = false;
        this.templatesManager = templatesManager;
        $c0b33c26cdfb7536$var$optionsManagers.add(this);
        this.onOptionChanged = this.onOptionChanged.bind(this);
        this.wrapOptionValue = this.wrapOptionValue.bind(this);
    }
    OptionsManager.prototype.setInstance = function(instance, config, subscribableOptions, independentEvents) {
        this.instance = instance;
        this.currentConfig = config;
        this.subscribableOptions = new Set(subscribableOptions);
        this.independentEvents = new Set(independentEvents);
    };
    OptionsManager.prototype.getInitialOptions = function(rootNode) {
        var _this = this;
        var config = $3qUgU.buildConfig(rootNode, false);
        Object.keys(config.templates).forEach(function(key) {
            _this.templatesManager.add(key, config.templates[key]);
        });
        var options = {};
        Object.keys(config.options).forEach(function(key) {
            options[key] = _this.wrapOptionValue(key, config.options[key]);
        });
        if (this.templatesManager.templatesCount > 0) options.integrationOptions = {
            templates: this.templatesManager.templates
        };
        return options;
    };
    OptionsManager.prototype.update = function(config) {
        var _this = this;
        var changedOptions = [];
        var optionChangedHandler = function(_a) {
            var value = _a.value, fullName = _a.fullName;
            changedOptions.push([
                fullName,
                value
            ]);
        };
        this.instance.on("optionChanged", optionChangedHandler);
        var changes = $3hcP7.getChanges(config, this.currentConfig);
        if (!changes.options && !changes.templates && !changes.removedOptions.length) return;
        this.instance.beginUpdate();
        this.isUpdating = true;
        changes.removedOptions.forEach(function(optionName) {
            _this.resetOption(optionName);
        });
        Object.keys(changes.templates).forEach(function(key) {
            _this.templatesManager.add(key, changes.templates[key]);
        });
        if (this.templatesManager.templatesCount > 0) this.setValue("integrationOptions", {
            templates: this.templatesManager.templates
        });
        Object.keys(changes.options).forEach(function(key) {
            _this.setValue(key, changes.options[key]);
        });
        this.isUpdating = false;
        this.instance.off("optionChanged", optionChangedHandler);
        this.currentConfig = config;
        changedOptions.forEach(function(_a) {
            var name = _a[0], value = _a[1];
            var currentPropValue = config.options[name];
            if (Object.prototype.hasOwnProperty.call(config.options, name) && currentPropValue !== value) _this.setValue(name, currentPropValue);
        });
        this.instance.endUpdate();
    };
    OptionsManager.prototype.onOptionChanged = function(e) {
        var _this = this;
        var _a;
        if (this.isUpdating) return;
        var valueDescriptor = $3qUgU.findValue(this.currentConfig, e.fullName.split("."));
        if (!valueDescriptor || valueDescriptor.value !== e.value) this.callOptionChangeHandler(e.fullName, e.value);
        valueDescriptor = $3qUgU.findValue(this.currentConfig, e.fullName.split("."));
        if (!valueDescriptor) return;
        var value = valueDescriptor.value, type = valueDescriptor.type;
        if (value instanceof Array && type === $3qUgU.ValueType.Array) {
            for(var i = 0; i < value.length; i += 1)if (value[i] !== ((_a = e.value) === null || _a === void 0 ? void 0 : _a[i])) {
                this.addGuard(e.fullName, value);
                return;
            }
        } else if (type === $3qUgU.ValueType.Complex && value instanceof Object) Object.keys(value).forEach(function(key) {
            var _a;
            if (value[key] === ((_a = e.value) === null || _a === void 0 ? void 0 : _a[key])) return;
            _this.addGuard($ebvE2.mergeNameParts(e.fullName, key), value[key]);
        });
        else {
            var valuesAreEqual = value === e.value;
            var valuesAreEqualObjects = !valuesAreEqual && value instanceof Object && e.value instanceof Object && $ebvE2.shallowEquals(value, e.value);
            if (valuesAreEqual || valuesAreEqualObjects || this.instance.skipOptionsRollBack) return;
            this.addGuard(e.fullName, value);
        }
    };
    OptionsManager.prototype.dispose = function() {
        var _this = this;
        $c0b33c26cdfb7536$var$optionsManagers.delete(this);
        Object.keys(this.guards).forEach(function(optionName) {
            delete _this.guards[optionName];
        });
    };
    OptionsManager.prototype.isOptionSubscribable = function(optionName) {
        return this.subscribableOptions.has(optionName);
    };
    OptionsManager.prototype.isIndependentEvent = function(optionName) {
        return this.independentEvents.has(optionName);
    };
    OptionsManager.prototype.callOptionChangeHandler = function(optionName, optionValue) {
        if (!this.isOptionSubscribable(optionName)) return;
        var parts = optionName.split(".");
        var propName = parts[parts.length - 1];
        if (propName.startsWith("on")) return;
        var eventName = "on" + $f0saG.capitalizeFirstLetter(propName) + "Change";
        parts[parts.length - 1] = eventName;
        var changeEvent = $3qUgU.findValue(this.currentConfig, parts);
        if (!changeEvent) return;
        if (typeof changeEvent.value !== "function") throw new Error("Invalid value for the " + eventName + " property.\n                " + eventName + " must be a function.");
        changeEvent.value(optionValue);
    };
    OptionsManager.prototype.wrapOptionValue = function(name, value) {
        var _this = this;
        if (name.substr(0, 2) === "on" && typeof value === "function") return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (!_this.isUpdating || _this.isIndependentEvent(name)) value.apply(void 0, args);
        };
        return value;
    };
    OptionsManager.prototype.addGuard = function(optionName, optionValue) {
        var _this = this;
        if (this.guards[optionName] !== undefined) return;
        var handler = function() {
            _this.setValue(optionName, optionValue);
            delete _this.guards[optionName];
        };
        this.guards[optionName] = handler;
        $c0b33c26cdfb7536$var$scheduleGuards();
    };
    OptionsManager.prototype.execGuards = function() {
        Object.values(this.guards).forEach(function(handler) {
            return handler();
        });
    };
    OptionsManager.prototype.resetOption = function(name) {
        this.instance.resetOption(name);
    };
    OptionsManager.prototype.setValue = function(name, value) {
        if (this.guards[name]) delete this.guards[name];
        this.instance.option(name, this.wrapOptionValue(name, value));
    };
    return OptionsManager;
}();
module.exports.OptionsManager = $c0b33c26cdfb7536$var$OptionsManager;

});
parcelRegister("3hcP7", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getChanges = void 0;

var $3qUgU = parcelRequire("3qUgU");

var $ebvE2 = parcelRequire("ebvE2");
function $262ce81c2d6e1e08$var$compareTemplates(current, prev, changesAccum) {
    var currentTemplatesOptions = {};
    var currentTemplates = {};
    var prevTemplatesOptions = {};
    var prevTemplates = {};
    $3qUgU.buildTemplates(current, currentTemplatesOptions, currentTemplates);
    $3qUgU.buildTemplates(prev, prevTemplatesOptions, prevTemplates);
    changesAccum.addRemovedValues(currentTemplatesOptions, prevTemplatesOptions, current.fullName);
    // TODO: support switching to default templates
    // appendRemovedValues(currentTemplates, prevTemplates, "", changesAccum.templates);
    Object.keys(currentTemplatesOptions).forEach(function(key) {
        if (currentTemplatesOptions[key] === prevTemplatesOptions[key]) return;
        changesAccum.options[$ebvE2.mergeNameParts(current.fullName, key)] = currentTemplatesOptions[key];
    });
    Object.keys(currentTemplates).forEach(function(key) {
        var currentTemplate = currentTemplates[key];
        var prevTemplate = prevTemplates[key];
        if (prevTemplate && currentTemplate.content === prevTemplate.content) return;
        changesAccum.templates[key] = currentTemplate;
    });
}
function $262ce81c2d6e1e08$var$compare(current, prev, changesAccum) {
    if (!prev) {
        changesAccum.options[current.fullName] = $3qUgU.buildNode(current, changesAccum.templates, true);
        return;
    }
    changesAccum.addRemovedValues(current.options, prev.options, current.fullName);
    changesAccum.addRemovedValues(current.configCollections, prev.configCollections, current.fullName);
    changesAccum.addRemovedValues(current.configs, prev.configs, current.fullName);
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $262ce81c2d6e1e08$var$compareCollections(current, prev, changesAccum);
    Object.keys(current.configs).forEach(function(key) {
        $262ce81c2d6e1e08$var$compare(current.configs[key], prev.configs[key], changesAccum);
    });
    Object.keys(current.options).forEach(function(key) {
        if (current.options[key] === prev.options[key]) return;
        changesAccum.options[$ebvE2.mergeNameParts(current.fullName, key)] = current.options[key];
    });
    $262ce81c2d6e1e08$var$compareTemplates(current, prev, changesAccum);
}
function $262ce81c2d6e1e08$var$appendRemovedValues(current, prev, path, changesAccum) {
    var removedKeys = Object.keys(prev).filter(function(key) {
        return Object.keys(current).indexOf(key) < 0;
    });
    removedKeys.forEach(function(key) {
        changesAccum.push($ebvE2.mergeNameParts(path, key));
    });
}
function $262ce81c2d6e1e08$var$getChanges(current, prev) {
    var changesAccum = {
        options: {},
        removedOptions: [],
        templates: {},
        addRemovedValues: function(currentOptions, prevOptions, path) {
            $262ce81c2d6e1e08$var$appendRemovedValues(currentOptions, prevOptions, path, this.removedOptions);
        }
    };
    $262ce81c2d6e1e08$var$compare(current, prev, changesAccum);
    return changesAccum;
}
module.exports.getChanges = $262ce81c2d6e1e08$var$getChanges;
function $262ce81c2d6e1e08$var$compareCollections(current, prev, changesAccum) {
    Object.keys(current.configCollections).forEach(function(key) {
        var currentCollection = current.configCollections[key];
        var prevCollection = prev.configCollections[key] || [];
        if (!currentCollection || currentCollection.length !== prevCollection.length) {
            var updatedCollection_1 = [];
            currentCollection.forEach(function(item) {
                var config = $3qUgU.buildNode(item, changesAccum.templates, true);
                updatedCollection_1.push(config);
            });
            changesAccum.options[$ebvE2.mergeNameParts(current.fullName, key)] = updatedCollection_1;
            return;
        }
        for(var i = 0; i < currentCollection.length; i += 1)$262ce81c2d6e1e08$var$compare(currentCollection[i], prevCollection[i], changesAccum);
    });
}

});
parcelRegister("3qUgU", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findValueInObject = module.exports.findValue = module.exports.buildTemplates = module.exports.buildNode = module.exports.buildConfig = module.exports.ValueType = void 0;

var $ebvE2 = parcelRequire("ebvE2");
function $27ff7330aca556bb$var$buildTemplates(node, optionsAccum, templatesAccum) {
    node.templates.forEach(function(template) {
        if (template.isAnonymous) {
            var templateName = $ebvE2.mergeNameParts(node.fullName, template.optionName);
            optionsAccum[template.optionName] = templateName;
            templatesAccum[templateName] = template;
        } else templatesAccum[template.optionName] = template;
    });
}
module.exports.buildTemplates = $27ff7330aca556bb$var$buildTemplates;
function $27ff7330aca556bb$var$buildNode(node, templatesAccum, ignoreInitialValues) {
    var result = {};
    Object.keys(node.predefinedOptions).forEach(function(key) {
        result[key] = node.predefinedOptions[key];
    });
    Object.keys(node.configs).forEach(function(key) {
        result[key] = $27ff7330aca556bb$var$buildNode(node.configs[key], templatesAccum, ignoreInitialValues);
    });
    Object.keys(node.configCollections).forEach(function(key) {
        result[key] = node.configCollections[key].map(function(item) {
            return $27ff7330aca556bb$var$buildNode(item, templatesAccum, ignoreInitialValues);
        });
    });
    if (!ignoreInitialValues) Object.keys(node.initialOptions).forEach(function(key) {
        result[key] = node.initialOptions[key];
    });
    Object.keys(node.options).forEach(function(key) {
        result[key] = node.options[key];
    });
    $27ff7330aca556bb$var$buildTemplates(node, result, templatesAccum);
    return result;
}
module.exports.buildNode = $27ff7330aca556bb$var$buildNode;
function $27ff7330aca556bb$var$buildConfig(root, ignoreInitialValues) {
    var templatesAccum = {};
    var options = $27ff7330aca556bb$var$buildNode(root, templatesAccum, ignoreInitialValues);
    return {
        templates: templatesAccum,
        options: options
    };
}
module.exports.buildConfig = $27ff7330aca556bb$var$buildConfig;
var $27ff7330aca556bb$var$ValueType;
(function(ValueType) {
    ValueType[ValueType["Simple"] = 0] = "Simple";
    ValueType[ValueType["Complex"] = 1] = "Complex";
    ValueType[ValueType["Array"] = 2] = "Array";
})($27ff7330aca556bb$var$ValueType || ($27ff7330aca556bb$var$ValueType = {}));
module.exports.ValueType = $27ff7330aca556bb$var$ValueType;
function $27ff7330aca556bb$var$findValueInObject(obj, path) {
    var key = path.shift();
    if (!key) return {
        value: obj,
        type: $27ff7330aca556bb$var$ValueType.Simple
    };
    if (obj instanceof Object && Object.keys(obj).includes(key)) return $27ff7330aca556bb$var$findValueInObject(obj[key], path);
    return undefined;
}
module.exports.findValueInObject = $27ff7330aca556bb$var$findValueInObject;
function $27ff7330aca556bb$var$findValue(node, path) {
    var name = path.shift();
    if (!name) return {
        value: $27ff7330aca556bb$var$buildConfig(node, true).options,
        type: $27ff7330aca556bb$var$ValueType.Complex
    };
    var optionInfo = $ebvE2.parseOptionName(name);
    if (optionInfo.name in node.options) {
        var options = optionInfo.isCollectionItem ? node.options[optionInfo.name][optionInfo.index] : node.options[optionInfo.name];
        return $27ff7330aca556bb$var$findValueInObject(options, path);
    }
    if (optionInfo.isCollectionItem) {
        var collection = node.configCollections[optionInfo.name];
        if (!collection) return undefined;
        var item = collection[optionInfo.index];
        if (!item) return undefined;
        return $27ff7330aca556bb$var$findValue(item, path);
    }
    var child = node.configs[optionInfo.name];
    if (child) return $27ff7330aca556bb$var$findValue(child, path);
    var childCollection = node.configCollections[optionInfo.name];
    if (childCollection) {
        if (path.length !== 0) return undefined;
        return {
            value: childCollection.map(function(item) {
                return $27ff7330aca556bb$var$buildNode(item, {}, true);
            }),
            type: $27ff7330aca556bb$var$ValueType.Array
        };
    }
    return undefined;
}
module.exports.findValue = $27ff7330aca556bb$var$findValue;

});
parcelRegister("ebvE2", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shallowEquals = module.exports.isIE = module.exports.parseOptionName = module.exports.mergeNameParts = void 0;
function $a53aa3c6f8b2c8fa$var$mergeNameParts() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.filter(function(value) {
        return value;
    }).join(".");
}
module.exports.mergeNameParts = $a53aa3c6f8b2c8fa$var$mergeNameParts;
function $a53aa3c6f8b2c8fa$var$parseOptionName(name) {
    var parts = name.split("[");
    if (parts.length === 1) return {
        isCollectionItem: false,
        name: name
    };
    return {
        isCollectionItem: true,
        name: parts[0],
        index: Number(parts[1].slice(0, -1))
    };
}
module.exports.parseOptionName = $a53aa3c6f8b2c8fa$var$parseOptionName;
var $a53aa3c6f8b2c8fa$var$isIE = function() {
    var _a, _b;
    var ua = (_b = (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) !== null && _b !== void 0 ? _b : ""; // Check the userAgent property of the window.navigator object
    var msie = ua.indexOf("MSIE"); // IE 10 or older
    var trident = ua.indexOf("Trident/"); // IE 11
    return msie > 0 || trident > 0;
};
module.exports.isIE = $a53aa3c6f8b2c8fa$var$isIE;
var $a53aa3c6f8b2c8fa$var$shallowEquals = function(first, second) {
    if (Object.keys(first).length !== Object.keys(second).length) return false;
    return Object.keys(first).every(function(key) {
        return first[key] === second[key];
    });
};
module.exports.shallowEquals = $a53aa3c6f8b2c8fa$var$shallowEquals;

});




parcelRegister("g8nHh", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.separateProps = module.exports.getClassName = module.exports.elementPropNames = void 0;
var $bbefc672983fae0f$var$elementPropNames = [
    "style",
    "id"
];
module.exports.elementPropNames = $bbefc672983fae0f$var$elementPropNames;
var $bbefc672983fae0f$var$classNamePropName = "className";
function $bbefc672983fae0f$var$isIgnoredProp(name) {
    return name === "children" || name === $bbefc672983fae0f$var$classNamePropName || $bbefc672983fae0f$var$elementPropNames.indexOf(name) > -1;
}
function $bbefc672983fae0f$var$separateProps(props, defaultsProps, templateProps) {
    templateProps = templateProps || [];
    var defaults = {};
    var options = {};
    var templates = {};
    var knownTemplates = {};
    templateProps.forEach(function(value) {
        knownTemplates[value.component] = true;
        knownTemplates[value.render] = true;
    });
    Object.keys(props).forEach(function(key) {
        var defaultOptionName = defaultsProps ? defaultsProps[key] : null;
        if ($bbefc672983fae0f$var$isIgnoredProp(key)) return;
        if (defaultOptionName) {
            defaults[defaultOptionName] = props[key];
            return;
        }
        if (knownTemplates[key]) {
            templates[key] = props[key];
            return;
        }
        options[key] = props[key];
    });
    return {
        options: options,
        defaults: defaults,
        templates: templates
    };
}
module.exports.separateProps = $bbefc672983fae0f$var$separateProps;
function $bbefc672983fae0f$var$getClassName(props) {
    return props[$bbefc672983fae0f$var$classNamePropName];
}
module.exports.getClassName = $bbefc672983fae0f$var$getClassName;

});

parcelRegister("b1sL6", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
var $8066189c2d87c5ba$var$__assign = module.exports && module.exports.__assign || function() {
    $8066189c2d87c5ba$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8066189c2d87c5ba$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildConfigTree = module.exports.processChildren = void 0;

var $bh6RR = parcelRequire("bh6RR");

var $g8nHh = parcelRequire("g8nHh");

var $bE0oj = parcelRequire("bE0oj");

var $ebvE2 = parcelRequire("ebvE2");

var $gKK8j = parcelRequire("gKK8j");
function $8066189c2d87c5ba$var$processChildren(parentElement, parentFullName) {
    var templates = [];
    var configCollections = {};
    var configs = {};
    var hasTranscludedContent = false;
    $bh6RR.Children.map(parentElement.props.children, function(child) {
        var element = $bE0oj.getElementInfo(child, parentElement.descriptor.expectedChildren);
        if (element.type === $bE0oj.ElementType.Unknown) {
            if (child !== null && child !== undefined && child !== false) hasTranscludedContent = true;
            return;
        }
        if (element.type === $bE0oj.ElementType.Template) {
            var template = $gKK8j.getNamedTemplate(element.props);
            if (template) templates.push(template);
            return;
        }
        if (element.descriptor.isCollection) {
            var collection = configCollections[element.descriptor.name];
            if (!collection) {
                collection = [];
                configCollections[element.descriptor.name] = collection;
            }
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            var collectionItem = $8066189c2d87c5ba$var$createConfigNode(element, $ebvE2.mergeNameParts(parentFullName, element.descriptor.name) + "[" + collection.length + "]");
            collection.push(collectionItem);
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        var configNode = $8066189c2d87c5ba$var$createConfigNode(element, parentFullName);
        configs[element.descriptor.name] = configNode;
    });
    return {
        configs: configs,
        configCollections: configCollections,
        templates: templates,
        hasTranscludedContent: hasTranscludedContent
    };
}
module.exports.processChildren = $8066189c2d87c5ba$var$processChildren;
function $8066189c2d87c5ba$var$createConfigNode(element, path) {
    var fullName = element.descriptor.isCollection ? path : $ebvE2.mergeNameParts(path, element.descriptor.name);
    var separatedValues = $g8nHh.separateProps(element.props, element.descriptor.initialValuesProps, element.descriptor.templates);
    var childrenData = $8066189c2d87c5ba$var$processChildren(element, fullName);
    element.descriptor.templates.forEach(function(templateMeta) {
        var template = $gKK8j.getAnonymousTemplate(element.props, templateMeta, path.length > 0 ? childrenData.hasTranscludedContent : false);
        if (template) childrenData.templates.push(template);
    });
    return {
        fullName: fullName,
        predefinedOptions: element.descriptor.predefinedValuesProps,
        initialOptions: separatedValues.defaults,
        options: separatedValues.options,
        templates: childrenData.templates,
        configCollections: childrenData.configCollections,
        configs: childrenData.configs
    };
}
function $8066189c2d87c5ba$var$buildConfigTree(widgetDescriptor, props) {
    return $8066189c2d87c5ba$var$createConfigNode({
        type: $bE0oj.ElementType.Option,
        descriptor: $8066189c2d87c5ba$var$__assign({
            name: "",
            isCollection: false
        }, widgetDescriptor),
        props: props
    }, "");
}
module.exports.buildConfigTree = $8066189c2d87c5ba$var$buildConfigTree;

});
parcelRegister("bE0oj", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ElementType = module.exports.getElementInfo = void 0;

var $fdx5c = parcelRequire("fdx5c");
var $87a3bbc8b88a5bc1$var$ElementType;
(function(ElementType) {
    ElementType[ElementType["Option"] = 0] = "Option";
    ElementType[ElementType["Template"] = 1] = "Template";
    ElementType[ElementType["Unknown"] = 2] = "Unknown";
})($87a3bbc8b88a5bc1$var$ElementType || ($87a3bbc8b88a5bc1$var$ElementType = {}));
module.exports.ElementType = $87a3bbc8b88a5bc1$var$ElementType;
function $87a3bbc8b88a5bc1$var$getElementInfo(element, parentExpectedChildren) {
    var reactElement = element;
    if (!reactElement || !reactElement.type) return {
        type: $87a3bbc8b88a5bc1$var$ElementType.Unknown
    };
    if (reactElement.type === $fdx5c.Template) return {
        type: $87a3bbc8b88a5bc1$var$ElementType.Template,
        props: reactElement.props
    };
    var elementDescriptor = reactElement.type;
    if (elementDescriptor.OptionName) {
        var name_1 = elementDescriptor.OptionName;
        var isCollectionItem = elementDescriptor.IsCollectionItem;
        var expectation = parentExpectedChildren && parentExpectedChildren[name_1];
        if (expectation) {
            isCollectionItem = expectation.isCollectionItem;
            if (expectation.optionName) name_1 = expectation.optionName;
        }
        return {
            type: $87a3bbc8b88a5bc1$var$ElementType.Option,
            descriptor: {
                name: name_1,
                isCollection: isCollectionItem,
                templates: elementDescriptor.TemplateProps || [],
                initialValuesProps: elementDescriptor.DefaultsProps || {},
                predefinedValuesProps: elementDescriptor.PredefinedProps || {},
                expectedChildren: elementDescriptor.ExpectedChildren || {}
            },
            props: reactElement.props
        };
    }
    return {
        type: $87a3bbc8b88a5bc1$var$ElementType.Unknown
    };
}
module.exports.getElementInfo = $87a3bbc8b88a5bc1$var$getElementInfo;

});
parcelRegister("fdx5c", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
var $b141bb785977dae3$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findProps = module.exports.Template = void 0;

var $eCfBx = parcelRequire("eCfBx");

var $bh6RR = parcelRequire("bh6RR");
var $b141bb785977dae3$var$Template = /** @class */ function(_super) {
    $b141bb785977dae3$var$__extends(Template, _super);
    function Template() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Template.prototype.render = function() {
        return null;
    };
    return Template;
}($bh6RR.PureComponent);
module.exports.Template = $b141bb785977dae3$var$Template;
var $b141bb785977dae3$var$requiredPropsCheck = function(props) {
    if (!props.component && !props.render && !props.children) return new Error("The Template component requires 'component' or 'render' property");
    return null;
};
$b141bb785977dae3$var$Template.propTypes = {
    name: $eCfBx.string.isRequired,
    component: $b141bb785977dae3$var$requiredPropsCheck,
    render: $b141bb785977dae3$var$requiredPropsCheck,
    children: $b141bb785977dae3$var$requiredPropsCheck
};
function $b141bb785977dae3$var$findProps(child) {
    if (child.type !== $b141bb785977dae3$var$Template) return undefined;
    return {
        name: child.props.name,
        render: child.props.render,
        component: child.props.component,
        children: child.props.children,
        keyFn: child.props.keyFn
    };
}
module.exports.findProps = $b141bb785977dae3$var$findProps;

});


parcelRegister("gKK8j", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getNamedTemplate = module.exports.getAnonymousTemplate = void 0;
function $c324ba4f7b304a4f$var$getAnonymousTemplate(props, templateMeta, hasTranscludedContent) {
    if (templateMeta.tmplOption === "template" && hasTranscludedContent) return {
        optionName: templateMeta.tmplOption,
        isAnonymous: true,
        type: "children",
        content: props.children,
        keyFn: props[templateMeta.keyFn]
    };
    if (props[templateMeta.render]) return {
        optionName: templateMeta.tmplOption,
        isAnonymous: true,
        type: "render",
        content: props[templateMeta.render],
        keyFn: props[templateMeta.keyFn]
    };
    if (props[templateMeta.component]) return {
        optionName: templateMeta.tmplOption,
        isAnonymous: true,
        type: "component",
        content: props[templateMeta.component],
        keyFn: props[templateMeta.keyFn]
    };
    return null;
}
module.exports.getAnonymousTemplate = $c324ba4f7b304a4f$var$getAnonymousTemplate;
function $c324ba4f7b304a4f$var$getNamedTemplate(props) {
    if (!props.name) return null;
    if (props.component) return {
        optionName: props.name,
        isAnonymous: false,
        type: "component",
        content: props.component,
        keyFn: props.keyFn
    };
    if (props.render) return {
        optionName: props.name,
        isAnonymous: false,
        type: "render",
        content: props.render,
        keyFn: props.keyFn
    };
    return {
        optionName: props.name,
        isAnonymous: false,
        type: "children",
        content: props.children,
        keyFn: props.keyFn
    };
}
module.exports.getNamedTemplate = $c324ba4f7b304a4f$var$getNamedTemplate;

});



parcelRegister("fpGsg", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
var $b38a1f7cddca13e6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExtensionComponent = void 0;

var $aKrW4 = parcelRequire("aKrW4");
var $b38a1f7cddca13e6$var$ExtensionComponent = /** @class */ function(_super) {
    $b38a1f7cddca13e6$var$__extends(ExtensionComponent, _super);
    function ExtensionComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExtensionComponent.prototype.componentDidMount = function() {
        var onMounted = this.props.onMounted;
        if (onMounted) onMounted(this._createWidget);
        else this._createWidget();
    };
    return ExtensionComponent;
}($aKrW4.ComponentBase);
module.exports.ExtensionComponent = $b38a1f7cddca13e6$var$ExtensionComponent;

});


parcelRegister("gkuLz", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
var $be366126cfbc6017$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bh6RR = parcelRequire("bh6RR");

var $bE0oj = parcelRequire("bE0oj");
var $be366126cfbc6017$var$NestedOption = /** @class */ function(_super) {
    $be366126cfbc6017$var$__extends(NestedOption, _super);
    function NestedOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NestedOption.prototype.render = function() {
        var stateChildren = this.props.children;
        var children = $bh6RR.Children.map(stateChildren, function(child) {
            var childElementInfo = $bE0oj.getElementInfo(child);
            return childElementInfo.type === $bE0oj.ElementType.Option ? child : null;
        });
        return $bh6RR.createElement($bh6RR.Fragment, {}, children);
    };
    return NestedOption;
}($bh6RR.PureComponent);
module.exports.default = $be366126cfbc6017$var$NestedOption;

});


parcelRegister("k3DeF", function(module, exports) {
/*!
 * devextreme-react
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */ "use strict";
var $e9a285d79f845ae6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LegendTitle = module.exports.Legend = module.exports.Label = module.exports.Image = module.exports.HoverStyle = module.exports.HorizontalLineLabel = module.exports.HorizontalLine = module.exports.Height = module.exports.Hatching = module.exports.Grid = module.exports.Format = module.exports.Font = module.exports.Export = module.exports.DragBoxStyle = module.exports.DataPrepareSettings = module.exports.Crosshair = module.exports.ConstantLineStyle = module.exports.ConstantLineLabel = module.exports.ConstantLine = module.exports.Connector = module.exports.CommonSeriesSettingsSelectionStyle = module.exports.CommonSeriesSettingsLabel = module.exports.CommonSeriesSettingsHoverStyle = module.exports.CommonSeriesSettings = module.exports.CommonPaneSettings = module.exports.CommonAxisSettingsTitle = module.exports.CommonAxisSettingsLabel = module.exports.CommonAxisSettingsConstantLineStyleLabel = module.exports.CommonAxisSettingsConstantLineStyle = module.exports.CommonAxisSettings = module.exports.CommonAnnotationSettings = module.exports.ChartTitleSubtitle = module.exports.ChartTitle = module.exports.BreakStyle = module.exports.Break = module.exports.Border = module.exports.AxisTitle = module.exports.AxisLabel = module.exports.AxisConstantLineStyleLabel = module.exports.AxisConstantLineStyle = module.exports.ArgumentFormat = module.exports.ArgumentAxis = module.exports.AnnotationImage = module.exports.AnnotationBorder = module.exports.Annotation = module.exports.Animation = module.exports.AggregationInterval = module.exports.Aggregation = module.exports.AdaptiveLayout = module.exports.Chart = void 0;
module.exports.ZoomAndPan = module.exports.Width = module.exports.WholeRange = module.exports.VisualRange = module.exports.VerticalLine = module.exports.ValueErrorBar = module.exports.ValueAxis = module.exports.Url = module.exports.TooltipBorder = module.exports.Tooltip = module.exports.Title = module.exports.TickInterval = module.exports.Tick = module.exports.Subtitle = module.exports.StripStyleLabel = module.exports.StripStyle = module.exports.StripLabel = module.exports.Strip = module.exports.Size = module.exports.Shadow = module.exports.SeriesTemplate = module.exports.SeriesBorder = module.exports.Series = module.exports.SelectionStyle = module.exports.ScrollBar = module.exports.Reduction = module.exports.PointSelectionStyle = module.exports.PointImage = module.exports.PointHoverStyle = module.exports.PointBorder = module.exports.Point = module.exports.PaneBorder = module.exports.Pane = module.exports.MinVisualRangeLength = module.exports.MinorTickInterval = module.exports.MinorTick = module.exports.MinorGrid = module.exports.Margin = module.exports.LoadingIndicator = module.exports.Length = module.exports.LegendTitleSubtitle = void 0;

var $iIrpj = parcelRequire("iIrpj");

var $eCfBx = parcelRequire("eCfBx");

var $2qbeQ = parcelRequire("2qbeQ");

var $gkuLz = parcelRequire("gkuLz");
var $e9a285d79f845ae6$var$Chart = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Chart, _super);
    function Chart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._WidgetClass = $iIrpj.default;
        _this.useRequestAnimationFrameFlag = true;
        _this.subscribableOptions = [
            "argumentAxis",
            "argumentAxis.categories",
            "argumentAxis.visualRange",
            "loadingIndicator",
            "loadingIndicator.show",
            "valueAxis",
            "valueAxis.categories",
            "valueAxis.visualRange"
        ];
        _this.independentEvents = [
            "onArgumentAxisClick",
            "onDisposing",
            "onDone",
            "onDrawn",
            "onExported",
            "onExporting",
            "onFileSaving",
            "onIncidentOccurred",
            "onInitialized",
            "onLegendClick",
            "onPointClick",
            "onSeriesClick",
            "onTooltipHidden",
            "onTooltipShown",
            "onZoomEnd",
            "onZoomStart"
        ];
        _this._defaults = {
            defaultArgumentAxis: "argumentAxis",
            defaultLoadingIndicator: "loadingIndicator",
            defaultValueAxis: "valueAxis"
        };
        _this._expectedChildren = {
            adaptiveLayout: {
                optionName: "adaptiveLayout",
                isCollectionItem: false
            },
            animation: {
                optionName: "animation",
                isCollectionItem: false
            },
            annotation: {
                optionName: "annotations",
                isCollectionItem: true
            },
            argumentAxis: {
                optionName: "argumentAxis",
                isCollectionItem: false
            },
            chartTitle: {
                optionName: "title",
                isCollectionItem: false
            },
            commonAnnotationSettings: {
                optionName: "commonAnnotationSettings",
                isCollectionItem: false
            },
            commonAxisSettings: {
                optionName: "commonAxisSettings",
                isCollectionItem: false
            },
            commonPaneSettings: {
                optionName: "commonPaneSettings",
                isCollectionItem: false
            },
            commonSeriesSettings: {
                optionName: "commonSeriesSettings",
                isCollectionItem: false
            },
            crosshair: {
                optionName: "crosshair",
                isCollectionItem: false
            },
            dataPrepareSettings: {
                optionName: "dataPrepareSettings",
                isCollectionItem: false
            },
            export: {
                optionName: "export",
                isCollectionItem: false
            },
            legend: {
                optionName: "legend",
                isCollectionItem: false
            },
            loadingIndicator: {
                optionName: "loadingIndicator",
                isCollectionItem: false
            },
            margin: {
                optionName: "margin",
                isCollectionItem: false
            },
            pane: {
                optionName: "panes",
                isCollectionItem: true
            },
            scrollBar: {
                optionName: "scrollBar",
                isCollectionItem: false
            },
            series: {
                optionName: "series",
                isCollectionItem: true
            },
            seriesTemplate: {
                optionName: "seriesTemplate",
                isCollectionItem: false
            },
            size: {
                optionName: "size",
                isCollectionItem: false
            },
            title: {
                optionName: "title",
                isCollectionItem: false
            },
            tooltip: {
                optionName: "tooltip",
                isCollectionItem: false
            },
            valueAxis: {
                optionName: "valueAxis",
                isCollectionItem: true
            },
            zoomAndPan: {
                optionName: "zoomAndPan",
                isCollectionItem: false
            }
        };
        return _this;
    }
    Object.defineProperty(Chart.prototype, "instance", {
        get: function() {
            return this._instance;
        },
        enumerable: false,
        configurable: true
    });
    return Chart;
}($2qbeQ.Component);
module.exports.Chart = $e9a285d79f845ae6$var$Chart;
$e9a285d79f845ae6$var$Chart.propTypes = {
    adaptiveLayout: $eCfBx.object,
    adjustOnZoom: $eCfBx.bool,
    animation: $eCfBx.oneOfType([
        $eCfBx.bool,
        $eCfBx.object
    ]),
    annotations: $eCfBx.array,
    argumentAxis: $eCfBx.object,
    autoHidePointMarkers: $eCfBx.bool,
    barGroupPadding: $eCfBx.number,
    barGroupWidth: $eCfBx.number,
    commonAnnotationSettings: $eCfBx.object,
    commonAxisSettings: $eCfBx.object,
    commonPaneSettings: $eCfBx.object,
    commonSeriesSettings: $eCfBx.object,
    containerBackgroundColor: $eCfBx.string,
    crosshair: $eCfBx.object,
    customizeAnnotation: $eCfBx.func,
    customizeLabel: $eCfBx.func,
    customizePoint: $eCfBx.func,
    dataPrepareSettings: $eCfBx.object,
    defaultPane: $eCfBx.string,
    disabled: $eCfBx.bool,
    elementAttr: $eCfBx.object,
    export: $eCfBx.object,
    legend: $eCfBx.object,
    loadingIndicator: $eCfBx.object,
    margin: $eCfBx.object,
    maxBubbleSize: $eCfBx.number,
    minBubbleSize: $eCfBx.number,
    negativesAsZeroes: $eCfBx.bool,
    onArgumentAxisClick: $eCfBx.func,
    onDisposing: $eCfBx.func,
    onDone: $eCfBx.func,
    onDrawn: $eCfBx.func,
    onExported: $eCfBx.func,
    onExporting: $eCfBx.func,
    onFileSaving: $eCfBx.func,
    onIncidentOccurred: $eCfBx.func,
    onInitialized: $eCfBx.func,
    onLegendClick: $eCfBx.func,
    onOptionChanged: $eCfBx.func,
    onPointClick: $eCfBx.func,
    onPointHoverChanged: $eCfBx.func,
    onPointSelectionChanged: $eCfBx.func,
    onSeriesClick: $eCfBx.func,
    onSeriesHoverChanged: $eCfBx.func,
    onSeriesSelectionChanged: $eCfBx.func,
    onTooltipHidden: $eCfBx.func,
    onTooltipShown: $eCfBx.func,
    onZoomEnd: $eCfBx.func,
    onZoomStart: $eCfBx.func,
    palette: $eCfBx.oneOfType([
        $eCfBx.array,
        $eCfBx.oneOfType([
            $eCfBx.string,
            $eCfBx.oneOf([
                "Bright",
                "Harmony Light",
                "Ocean",
                "Pastel",
                "Soft",
                "Soft Pastel",
                "Vintage",
                "Violet",
                "Carmine",
                "Dark Moon",
                "Dark Violet",
                "Green Mist",
                "Soft Blue",
                "Material",
                "Office"
            ])
        ])
    ]),
    paletteExtensionMode: $eCfBx.oneOfType([
        $eCfBx.string,
        $eCfBx.oneOf([
            "alternate",
            "blend",
            "extrapolate"
        ])
    ]),
    panes: $eCfBx.oneOfType([
        $eCfBx.array,
        $eCfBx.object
    ]),
    pathModified: $eCfBx.bool,
    pointSelectionMode: $eCfBx.oneOfType([
        $eCfBx.string,
        $eCfBx.oneOf([
            "single",
            "multiple"
        ])
    ]),
    redrawOnResize: $eCfBx.bool,
    resizePanesOnZoom: $eCfBx.bool,
    resolveLabelOverlapping: $eCfBx.oneOfType([
        $eCfBx.string,
        $eCfBx.oneOf([
            "hide",
            "none",
            "stack"
        ])
    ]),
    rotated: $eCfBx.bool,
    rtlEnabled: $eCfBx.bool,
    scrollBar: $eCfBx.object,
    series: $eCfBx.oneOfType([
        $eCfBx.array,
        $eCfBx.object
    ]),
    seriesSelectionMode: $eCfBx.oneOfType([
        $eCfBx.string,
        $eCfBx.oneOf([
            "single",
            "multiple"
        ])
    ]),
    seriesTemplate: $eCfBx.object,
    size: $eCfBx.object,
    stickyHovering: $eCfBx.bool,
    synchronizeMultiAxes: $eCfBx.bool,
    theme: $eCfBx.oneOfType([
        $eCfBx.string,
        $eCfBx.oneOf([
            "generic.dark",
            "generic.light",
            "generic.contrast",
            "generic.carmine",
            "generic.darkmoon",
            "generic.darkviolet",
            "generic.greenmist",
            "generic.softblue",
            "material.blue.light",
            "material.lime.light",
            "material.orange.light",
            "material.purple.light",
            "material.teal.light"
        ])
    ]),
    title: $eCfBx.oneOfType([
        $eCfBx.object,
        $eCfBx.string
    ]),
    tooltip: $eCfBx.object,
    valueAxis: $eCfBx.oneOfType([
        $eCfBx.array,
        $eCfBx.object
    ]),
    zoomAndPan: $eCfBx.object
};
var $e9a285d79f845ae6$var$AdaptiveLayout = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(AdaptiveLayout, _super);
    function AdaptiveLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdaptiveLayout.OptionName = "adaptiveLayout";
    return AdaptiveLayout;
}($gkuLz.default);
module.exports.AdaptiveLayout = $e9a285d79f845ae6$var$AdaptiveLayout;
var $e9a285d79f845ae6$var$Aggregation = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Aggregation, _super);
    function Aggregation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Aggregation.OptionName = "aggregation";
    return Aggregation;
}($gkuLz.default);
module.exports.Aggregation = $e9a285d79f845ae6$var$Aggregation;
var $e9a285d79f845ae6$var$AggregationInterval = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(AggregationInterval, _super);
    function AggregationInterval() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AggregationInterval.OptionName = "aggregationInterval";
    return AggregationInterval;
}($gkuLz.default);
module.exports.AggregationInterval = $e9a285d79f845ae6$var$AggregationInterval;
var $e9a285d79f845ae6$var$Animation = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Animation, _super);
    function Animation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Animation.OptionName = "animation";
    return Animation;
}($gkuLz.default);
module.exports.Animation = $e9a285d79f845ae6$var$Animation;
var $e9a285d79f845ae6$var$Annotation = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Annotation, _super);
    function Annotation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Annotation.OptionName = "annotations";
    Annotation.IsCollectionItem = true;
    Annotation.ExpectedChildren = {
        annotationBorder: {
            optionName: "border",
            isCollectionItem: false
        },
        annotationImage: {
            optionName: "image",
            isCollectionItem: false
        },
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        font: {
            optionName: "font",
            isCollectionItem: false
        },
        image: {
            optionName: "image",
            isCollectionItem: false
        },
        shadow: {
            optionName: "shadow",
            isCollectionItem: false
        }
    };
    Annotation.TemplateProps = [
        {
            tmplOption: "template",
            render: "render",
            component: "component",
            keyFn: "keyFn"
        },
        {
            tmplOption: "tooltipTemplate",
            render: "tooltipRender",
            component: "tooltipComponent",
            keyFn: "tooltipKeyFn"
        }
    ];
    return Annotation;
}($gkuLz.default);
module.exports.Annotation = $e9a285d79f845ae6$var$Annotation;
var $e9a285d79f845ae6$var$AnnotationBorder = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(AnnotationBorder, _super);
    function AnnotationBorder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnnotationBorder.OptionName = "border";
    return AnnotationBorder;
}($gkuLz.default);
module.exports.AnnotationBorder = $e9a285d79f845ae6$var$AnnotationBorder;
var $e9a285d79f845ae6$var$AnnotationImage = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(AnnotationImage, _super);
    function AnnotationImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnnotationImage.OptionName = "image";
    return AnnotationImage;
}($gkuLz.default);
module.exports.AnnotationImage = $e9a285d79f845ae6$var$AnnotationImage;
var $e9a285d79f845ae6$var$ArgumentAxis = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(ArgumentAxis, _super);
    function ArgumentAxis() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArgumentAxis.OptionName = "argumentAxis";
    ArgumentAxis.DefaultsProps = {
        defaultCategories: "categories",
        defaultVisualRange: "visualRange"
    };
    ArgumentAxis.ExpectedChildren = {
        aggregationInterval: {
            optionName: "aggregationInterval",
            isCollectionItem: false
        },
        axisConstantLineStyle: {
            optionName: "constantLineStyle",
            isCollectionItem: false
        },
        axisLabel: {
            optionName: "label",
            isCollectionItem: false
        },
        axisTitle: {
            optionName: "title",
            isCollectionItem: false
        },
        break: {
            optionName: "breaks",
            isCollectionItem: true
        },
        breakStyle: {
            optionName: "breakStyle",
            isCollectionItem: false
        },
        constantLine: {
            optionName: "constantLines",
            isCollectionItem: true
        },
        constantLineStyle: {
            optionName: "constantLineStyle",
            isCollectionItem: false
        },
        grid: {
            optionName: "grid",
            isCollectionItem: false
        },
        label: {
            optionName: "label",
            isCollectionItem: false
        },
        minorGrid: {
            optionName: "minorGrid",
            isCollectionItem: false
        },
        minorTick: {
            optionName: "minorTick",
            isCollectionItem: false
        },
        minorTickInterval: {
            optionName: "minorTickInterval",
            isCollectionItem: false
        },
        minVisualRangeLength: {
            optionName: "minVisualRangeLength",
            isCollectionItem: false
        },
        strip: {
            optionName: "strips",
            isCollectionItem: true
        },
        stripStyle: {
            optionName: "stripStyle",
            isCollectionItem: false
        },
        tick: {
            optionName: "tick",
            isCollectionItem: false
        },
        tickInterval: {
            optionName: "tickInterval",
            isCollectionItem: false
        },
        title: {
            optionName: "title",
            isCollectionItem: false
        },
        visualRange: {
            optionName: "visualRange",
            isCollectionItem: false
        },
        wholeRange: {
            optionName: "wholeRange",
            isCollectionItem: false
        }
    };
    return ArgumentAxis;
}($gkuLz.default);
module.exports.ArgumentAxis = $e9a285d79f845ae6$var$ArgumentAxis;
var $e9a285d79f845ae6$var$ArgumentFormat = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(ArgumentFormat, _super);
    function ArgumentFormat() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArgumentFormat.OptionName = "argumentFormat";
    return ArgumentFormat;
}($gkuLz.default);
module.exports.ArgumentFormat = $e9a285d79f845ae6$var$ArgumentFormat;
var $e9a285d79f845ae6$var$AxisConstantLineStyle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(AxisConstantLineStyle, _super);
    function AxisConstantLineStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AxisConstantLineStyle.OptionName = "constantLineStyle";
    return AxisConstantLineStyle;
}($gkuLz.default);
module.exports.AxisConstantLineStyle = $e9a285d79f845ae6$var$AxisConstantLineStyle;
var $e9a285d79f845ae6$var$AxisConstantLineStyleLabel = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(AxisConstantLineStyleLabel, _super);
    function AxisConstantLineStyleLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AxisConstantLineStyleLabel.OptionName = "label";
    return AxisConstantLineStyleLabel;
}($gkuLz.default);
module.exports.AxisConstantLineStyleLabel = $e9a285d79f845ae6$var$AxisConstantLineStyleLabel;
var $e9a285d79f845ae6$var$AxisLabel = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(AxisLabel, _super);
    function AxisLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AxisLabel.OptionName = "label";
    AxisLabel.TemplateProps = [
        {
            tmplOption: "template",
            render: "render",
            component: "component",
            keyFn: "keyFn"
        }
    ];
    return AxisLabel;
}($gkuLz.default);
module.exports.AxisLabel = $e9a285d79f845ae6$var$AxisLabel;
var $e9a285d79f845ae6$var$AxisTitle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(AxisTitle, _super);
    function AxisTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AxisTitle.OptionName = "title";
    return AxisTitle;
}($gkuLz.default);
module.exports.AxisTitle = $e9a285d79f845ae6$var$AxisTitle;
var $e9a285d79f845ae6$var$Border = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Border, _super);
    function Border() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Border.OptionName = "border";
    return Border;
}($gkuLz.default);
module.exports.Border = $e9a285d79f845ae6$var$Border;
var $e9a285d79f845ae6$var$Break = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Break, _super);
    function Break() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Break.OptionName = "breaks";
    Break.IsCollectionItem = true;
    return Break;
}($gkuLz.default);
module.exports.Break = $e9a285d79f845ae6$var$Break;
var $e9a285d79f845ae6$var$BreakStyle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(BreakStyle, _super);
    function BreakStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BreakStyle.OptionName = "breakStyle";
    return BreakStyle;
}($gkuLz.default);
module.exports.BreakStyle = $e9a285d79f845ae6$var$BreakStyle;
var $e9a285d79f845ae6$var$ChartTitle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(ChartTitle, _super);
    function ChartTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChartTitle.OptionName = "title";
    ChartTitle.ExpectedChildren = {
        chartTitleSubtitle: {
            optionName: "subtitle",
            isCollectionItem: false
        },
        font: {
            optionName: "font",
            isCollectionItem: false
        },
        margin: {
            optionName: "margin",
            isCollectionItem: false
        },
        subtitle: {
            optionName: "subtitle",
            isCollectionItem: false
        }
    };
    return ChartTitle;
}($gkuLz.default);
module.exports.ChartTitle = $e9a285d79f845ae6$var$ChartTitle;
var $e9a285d79f845ae6$var$ChartTitleSubtitle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(ChartTitleSubtitle, _super);
    function ChartTitleSubtitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChartTitleSubtitle.OptionName = "subtitle";
    ChartTitleSubtitle.ExpectedChildren = {
        font: {
            optionName: "font",
            isCollectionItem: false
        }
    };
    return ChartTitleSubtitle;
}($gkuLz.default);
module.exports.ChartTitleSubtitle = $e9a285d79f845ae6$var$ChartTitleSubtitle;
var $e9a285d79f845ae6$var$CommonAnnotationSettings = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(CommonAnnotationSettings, _super);
    function CommonAnnotationSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonAnnotationSettings.OptionName = "commonAnnotationSettings";
    CommonAnnotationSettings.TemplateProps = [
        {
            tmplOption: "template",
            render: "render",
            component: "component",
            keyFn: "keyFn"
        },
        {
            tmplOption: "tooltipTemplate",
            render: "tooltipRender",
            component: "tooltipComponent",
            keyFn: "tooltipKeyFn"
        }
    ];
    return CommonAnnotationSettings;
}($gkuLz.default);
module.exports.CommonAnnotationSettings = $e9a285d79f845ae6$var$CommonAnnotationSettings;
var $e9a285d79f845ae6$var$CommonAxisSettings = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(CommonAxisSettings, _super);
    function CommonAxisSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonAxisSettings.OptionName = "commonAxisSettings";
    CommonAxisSettings.ExpectedChildren = {
        commonAxisSettingsConstantLineStyle: {
            optionName: "constantLineStyle",
            isCollectionItem: false
        },
        commonAxisSettingsLabel: {
            optionName: "label",
            isCollectionItem: false
        },
        commonAxisSettingsTitle: {
            optionName: "title",
            isCollectionItem: false
        },
        constantLineStyle: {
            optionName: "constantLineStyle",
            isCollectionItem: false
        },
        label: {
            optionName: "label",
            isCollectionItem: false
        },
        title: {
            optionName: "title",
            isCollectionItem: false
        }
    };
    return CommonAxisSettings;
}($gkuLz.default);
module.exports.CommonAxisSettings = $e9a285d79f845ae6$var$CommonAxisSettings;
var $e9a285d79f845ae6$var$CommonAxisSettingsConstantLineStyle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(CommonAxisSettingsConstantLineStyle, _super);
    function CommonAxisSettingsConstantLineStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonAxisSettingsConstantLineStyle.OptionName = "constantLineStyle";
    CommonAxisSettingsConstantLineStyle.ExpectedChildren = {
        commonAxisSettingsConstantLineStyleLabel: {
            optionName: "label",
            isCollectionItem: false
        },
        label: {
            optionName: "label",
            isCollectionItem: false
        }
    };
    return CommonAxisSettingsConstantLineStyle;
}($gkuLz.default);
module.exports.CommonAxisSettingsConstantLineStyle = $e9a285d79f845ae6$var$CommonAxisSettingsConstantLineStyle;
var $e9a285d79f845ae6$var$CommonAxisSettingsConstantLineStyleLabel = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(CommonAxisSettingsConstantLineStyleLabel, _super);
    function CommonAxisSettingsConstantLineStyleLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonAxisSettingsConstantLineStyleLabel.OptionName = "label";
    return CommonAxisSettingsConstantLineStyleLabel;
}($gkuLz.default);
module.exports.CommonAxisSettingsConstantLineStyleLabel = $e9a285d79f845ae6$var$CommonAxisSettingsConstantLineStyleLabel;
var $e9a285d79f845ae6$var$CommonAxisSettingsLabel = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(CommonAxisSettingsLabel, _super);
    function CommonAxisSettingsLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonAxisSettingsLabel.OptionName = "label";
    CommonAxisSettingsLabel.TemplateProps = [
        {
            tmplOption: "template",
            render: "render",
            component: "component",
            keyFn: "keyFn"
        }
    ];
    return CommonAxisSettingsLabel;
}($gkuLz.default);
module.exports.CommonAxisSettingsLabel = $e9a285d79f845ae6$var$CommonAxisSettingsLabel;
var $e9a285d79f845ae6$var$CommonAxisSettingsTitle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(CommonAxisSettingsTitle, _super);
    function CommonAxisSettingsTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonAxisSettingsTitle.OptionName = "title";
    return CommonAxisSettingsTitle;
}($gkuLz.default);
module.exports.CommonAxisSettingsTitle = $e9a285d79f845ae6$var$CommonAxisSettingsTitle;
var $e9a285d79f845ae6$var$CommonPaneSettings = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(CommonPaneSettings, _super);
    function CommonPaneSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonPaneSettings.OptionName = "commonPaneSettings";
    CommonPaneSettings.ExpectedChildren = {
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        paneBorder: {
            optionName: "border",
            isCollectionItem: false
        }
    };
    return CommonPaneSettings;
}($gkuLz.default);
module.exports.CommonPaneSettings = $e9a285d79f845ae6$var$CommonPaneSettings;
var $e9a285d79f845ae6$var$CommonSeriesSettings = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(CommonSeriesSettings, _super);
    function CommonSeriesSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonSeriesSettings.OptionName = "commonSeriesSettings";
    CommonSeriesSettings.ExpectedChildren = {
        aggregation: {
            optionName: "aggregation",
            isCollectionItem: false
        },
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        commonSeriesSettingsHoverStyle: {
            optionName: "hoverStyle",
            isCollectionItem: false
        },
        commonSeriesSettingsLabel: {
            optionName: "label",
            isCollectionItem: false
        },
        commonSeriesSettingsSelectionStyle: {
            optionName: "selectionStyle",
            isCollectionItem: false
        },
        hoverStyle: {
            optionName: "hoverStyle",
            isCollectionItem: false
        },
        label: {
            optionName: "label",
            isCollectionItem: false
        },
        point: {
            optionName: "point",
            isCollectionItem: false
        },
        reduction: {
            optionName: "reduction",
            isCollectionItem: false
        },
        selectionStyle: {
            optionName: "selectionStyle",
            isCollectionItem: false
        },
        seriesBorder: {
            optionName: "border",
            isCollectionItem: false
        },
        valueErrorBar: {
            optionName: "valueErrorBar",
            isCollectionItem: false
        }
    };
    return CommonSeriesSettings;
}($gkuLz.default);
module.exports.CommonSeriesSettings = $e9a285d79f845ae6$var$CommonSeriesSettings;
var $e9a285d79f845ae6$var$CommonSeriesSettingsHoverStyle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(CommonSeriesSettingsHoverStyle, _super);
    function CommonSeriesSettingsHoverStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonSeriesSettingsHoverStyle.OptionName = "hoverStyle";
    CommonSeriesSettingsHoverStyle.ExpectedChildren = {
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        hatching: {
            optionName: "hatching",
            isCollectionItem: false
        },
        seriesBorder: {
            optionName: "border",
            isCollectionItem: false
        }
    };
    return CommonSeriesSettingsHoverStyle;
}($gkuLz.default);
module.exports.CommonSeriesSettingsHoverStyle = $e9a285d79f845ae6$var$CommonSeriesSettingsHoverStyle;
var $e9a285d79f845ae6$var$CommonSeriesSettingsLabel = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(CommonSeriesSettingsLabel, _super);
    function CommonSeriesSettingsLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonSeriesSettingsLabel.OptionName = "label";
    CommonSeriesSettingsLabel.ExpectedChildren = {
        argumentFormat: {
            optionName: "argumentFormat",
            isCollectionItem: false
        },
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        connector: {
            optionName: "connector",
            isCollectionItem: false
        },
        font: {
            optionName: "font",
            isCollectionItem: false
        },
        format: {
            optionName: "format",
            isCollectionItem: false
        },
        seriesBorder: {
            optionName: "border",
            isCollectionItem: false
        }
    };
    return CommonSeriesSettingsLabel;
}($gkuLz.default);
module.exports.CommonSeriesSettingsLabel = $e9a285d79f845ae6$var$CommonSeriesSettingsLabel;
var $e9a285d79f845ae6$var$CommonSeriesSettingsSelectionStyle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(CommonSeriesSettingsSelectionStyle, _super);
    function CommonSeriesSettingsSelectionStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonSeriesSettingsSelectionStyle.OptionName = "selectionStyle";
    CommonSeriesSettingsSelectionStyle.ExpectedChildren = {
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        hatching: {
            optionName: "hatching",
            isCollectionItem: false
        },
        seriesBorder: {
            optionName: "border",
            isCollectionItem: false
        }
    };
    return CommonSeriesSettingsSelectionStyle;
}($gkuLz.default);
module.exports.CommonSeriesSettingsSelectionStyle = $e9a285d79f845ae6$var$CommonSeriesSettingsSelectionStyle;
var $e9a285d79f845ae6$var$Connector = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Connector, _super);
    function Connector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Connector.OptionName = "connector";
    return Connector;
}($gkuLz.default);
module.exports.Connector = $e9a285d79f845ae6$var$Connector;
var $e9a285d79f845ae6$var$ConstantLine = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(ConstantLine, _super);
    function ConstantLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConstantLine.OptionName = "constantLines";
    ConstantLine.IsCollectionItem = true;
    return ConstantLine;
}($gkuLz.default);
module.exports.ConstantLine = $e9a285d79f845ae6$var$ConstantLine;
var $e9a285d79f845ae6$var$ConstantLineLabel = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(ConstantLineLabel, _super);
    function ConstantLineLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConstantLineLabel.OptionName = "label";
    return ConstantLineLabel;
}($gkuLz.default);
module.exports.ConstantLineLabel = $e9a285d79f845ae6$var$ConstantLineLabel;
var $e9a285d79f845ae6$var$ConstantLineStyle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(ConstantLineStyle, _super);
    function ConstantLineStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConstantLineStyle.OptionName = "constantLineStyle";
    return ConstantLineStyle;
}($gkuLz.default);
module.exports.ConstantLineStyle = $e9a285d79f845ae6$var$ConstantLineStyle;
var $e9a285d79f845ae6$var$Crosshair = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Crosshair, _super);
    function Crosshair() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Crosshair.OptionName = "crosshair";
    Crosshair.ExpectedChildren = {
        horizontalLine: {
            optionName: "horizontalLine",
            isCollectionItem: false
        },
        horizontalLineLabel: {
            optionName: "label",
            isCollectionItem: false
        },
        label: {
            optionName: "label",
            isCollectionItem: false
        },
        verticalLine: {
            optionName: "verticalLine",
            isCollectionItem: false
        }
    };
    return Crosshair;
}($gkuLz.default);
module.exports.Crosshair = $e9a285d79f845ae6$var$Crosshair;
var $e9a285d79f845ae6$var$DataPrepareSettings = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(DataPrepareSettings, _super);
    function DataPrepareSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataPrepareSettings.OptionName = "dataPrepareSettings";
    return DataPrepareSettings;
}($gkuLz.default);
module.exports.DataPrepareSettings = $e9a285d79f845ae6$var$DataPrepareSettings;
var $e9a285d79f845ae6$var$DragBoxStyle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(DragBoxStyle, _super);
    function DragBoxStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DragBoxStyle.OptionName = "dragBoxStyle";
    return DragBoxStyle;
}($gkuLz.default);
module.exports.DragBoxStyle = $e9a285d79f845ae6$var$DragBoxStyle;
var $e9a285d79f845ae6$var$Export = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Export, _super);
    function Export() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Export.OptionName = "export";
    return Export;
}($gkuLz.default);
module.exports.Export = $e9a285d79f845ae6$var$Export;
var $e9a285d79f845ae6$var$Font = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Font, _super);
    function Font() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Font.OptionName = "font";
    return Font;
}($gkuLz.default);
module.exports.Font = $e9a285d79f845ae6$var$Font;
var $e9a285d79f845ae6$var$Format = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Format, _super);
    function Format() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Format.OptionName = "format";
    return Format;
}($gkuLz.default);
module.exports.Format = $e9a285d79f845ae6$var$Format;
var $e9a285d79f845ae6$var$Grid = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Grid, _super);
    function Grid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Grid.OptionName = "grid";
    return Grid;
}($gkuLz.default);
module.exports.Grid = $e9a285d79f845ae6$var$Grid;
var $e9a285d79f845ae6$var$Hatching = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Hatching, _super);
    function Hatching() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Hatching.OptionName = "hatching";
    return Hatching;
}($gkuLz.default);
module.exports.Hatching = $e9a285d79f845ae6$var$Hatching;
var $e9a285d79f845ae6$var$Height = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Height, _super);
    function Height() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Height.OptionName = "height";
    return Height;
}($gkuLz.default);
module.exports.Height = $e9a285d79f845ae6$var$Height;
var $e9a285d79f845ae6$var$HorizontalLine = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(HorizontalLine, _super);
    function HorizontalLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HorizontalLine.OptionName = "horizontalLine";
    HorizontalLine.ExpectedChildren = {
        horizontalLineLabel: {
            optionName: "label",
            isCollectionItem: false
        },
        label: {
            optionName: "label",
            isCollectionItem: false
        }
    };
    return HorizontalLine;
}($gkuLz.default);
module.exports.HorizontalLine = $e9a285d79f845ae6$var$HorizontalLine;
var $e9a285d79f845ae6$var$HorizontalLineLabel = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(HorizontalLineLabel, _super);
    function HorizontalLineLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HorizontalLineLabel.OptionName = "label";
    return HorizontalLineLabel;
}($gkuLz.default);
module.exports.HorizontalLineLabel = $e9a285d79f845ae6$var$HorizontalLineLabel;
var $e9a285d79f845ae6$var$HoverStyle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(HoverStyle, _super);
    function HoverStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HoverStyle.OptionName = "hoverStyle";
    return HoverStyle;
}($gkuLz.default);
module.exports.HoverStyle = $e9a285d79f845ae6$var$HoverStyle;
var $e9a285d79f845ae6$var$Image = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Image, _super);
    function Image() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Image.OptionName = "image";
    return Image;
}($gkuLz.default);
module.exports.Image = $e9a285d79f845ae6$var$Image;
var $e9a285d79f845ae6$var$Label = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Label, _super);
    function Label() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Label.OptionName = "label";
    Label.TemplateProps = [
        {
            tmplOption: "template",
            render: "render",
            component: "component",
            keyFn: "keyFn"
        }
    ];
    return Label;
}($gkuLz.default);
module.exports.Label = $e9a285d79f845ae6$var$Label;
var $e9a285d79f845ae6$var$Legend = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Legend, _super);
    function Legend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Legend.OptionName = "legend";
    Legend.ExpectedChildren = {
        annotationBorder: {
            optionName: "border",
            isCollectionItem: false
        },
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        font: {
            optionName: "font",
            isCollectionItem: false
        },
        legendTitle: {
            optionName: "title",
            isCollectionItem: false
        },
        margin: {
            optionName: "margin",
            isCollectionItem: false
        },
        title: {
            optionName: "title",
            isCollectionItem: false
        }
    };
    Legend.TemplateProps = [
        {
            tmplOption: "markerTemplate",
            render: "markerRender",
            component: "markerComponent",
            keyFn: "markerKeyFn"
        }
    ];
    return Legend;
}($gkuLz.default);
module.exports.Legend = $e9a285d79f845ae6$var$Legend;
var $e9a285d79f845ae6$var$LegendTitle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(LegendTitle, _super);
    function LegendTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegendTitle.OptionName = "title";
    LegendTitle.ExpectedChildren = {
        font: {
            optionName: "font",
            isCollectionItem: false
        },
        legendTitleSubtitle: {
            optionName: "subtitle",
            isCollectionItem: false
        },
        margin: {
            optionName: "margin",
            isCollectionItem: false
        },
        subtitle: {
            optionName: "subtitle",
            isCollectionItem: false
        }
    };
    return LegendTitle;
}($gkuLz.default);
module.exports.LegendTitle = $e9a285d79f845ae6$var$LegendTitle;
var $e9a285d79f845ae6$var$LegendTitleSubtitle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(LegendTitleSubtitle, _super);
    function LegendTitleSubtitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegendTitleSubtitle.OptionName = "subtitle";
    LegendTitleSubtitle.ExpectedChildren = {
        font: {
            optionName: "font",
            isCollectionItem: false
        }
    };
    return LegendTitleSubtitle;
}($gkuLz.default);
module.exports.LegendTitleSubtitle = $e9a285d79f845ae6$var$LegendTitleSubtitle;
var $e9a285d79f845ae6$var$Length = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Length, _super);
    function Length() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Length.OptionName = "length";
    return Length;
}($gkuLz.default);
module.exports.Length = $e9a285d79f845ae6$var$Length;
var $e9a285d79f845ae6$var$LoadingIndicator = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(LoadingIndicator, _super);
    function LoadingIndicator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingIndicator.OptionName = "loadingIndicator";
    LoadingIndicator.DefaultsProps = {
        defaultShow: "show"
    };
    LoadingIndicator.ExpectedChildren = {
        font: {
            optionName: "font",
            isCollectionItem: false
        }
    };
    return LoadingIndicator;
}($gkuLz.default);
module.exports.LoadingIndicator = $e9a285d79f845ae6$var$LoadingIndicator;
var $e9a285d79f845ae6$var$Margin = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Margin, _super);
    function Margin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Margin.OptionName = "margin";
    return Margin;
}($gkuLz.default);
module.exports.Margin = $e9a285d79f845ae6$var$Margin;
var $e9a285d79f845ae6$var$MinorGrid = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(MinorGrid, _super);
    function MinorGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MinorGrid.OptionName = "minorGrid";
    return MinorGrid;
}($gkuLz.default);
module.exports.MinorGrid = $e9a285d79f845ae6$var$MinorGrid;
var $e9a285d79f845ae6$var$MinorTick = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(MinorTick, _super);
    function MinorTick() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MinorTick.OptionName = "minorTick";
    return MinorTick;
}($gkuLz.default);
module.exports.MinorTick = $e9a285d79f845ae6$var$MinorTick;
var $e9a285d79f845ae6$var$MinorTickInterval = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(MinorTickInterval, _super);
    function MinorTickInterval() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MinorTickInterval.OptionName = "minorTickInterval";
    return MinorTickInterval;
}($gkuLz.default);
module.exports.MinorTickInterval = $e9a285d79f845ae6$var$MinorTickInterval;
var $e9a285d79f845ae6$var$MinVisualRangeLength = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(MinVisualRangeLength, _super);
    function MinVisualRangeLength() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MinVisualRangeLength.OptionName = "minVisualRangeLength";
    return MinVisualRangeLength;
}($gkuLz.default);
module.exports.MinVisualRangeLength = $e9a285d79f845ae6$var$MinVisualRangeLength;
var $e9a285d79f845ae6$var$Pane = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Pane, _super);
    function Pane() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Pane.OptionName = "panes";
    Pane.IsCollectionItem = true;
    return Pane;
}($gkuLz.default);
module.exports.Pane = $e9a285d79f845ae6$var$Pane;
var $e9a285d79f845ae6$var$PaneBorder = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(PaneBorder, _super);
    function PaneBorder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaneBorder.OptionName = "border";
    return PaneBorder;
}($gkuLz.default);
module.exports.PaneBorder = $e9a285d79f845ae6$var$PaneBorder;
var $e9a285d79f845ae6$var$Point = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Point, _super);
    function Point() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Point.OptionName = "point";
    Point.ExpectedChildren = {
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        hoverStyle: {
            optionName: "hoverStyle",
            isCollectionItem: false
        },
        image: {
            optionName: "image",
            isCollectionItem: false
        },
        pointBorder: {
            optionName: "border",
            isCollectionItem: false
        },
        pointHoverStyle: {
            optionName: "hoverStyle",
            isCollectionItem: false
        },
        pointImage: {
            optionName: "image",
            isCollectionItem: false
        },
        pointSelectionStyle: {
            optionName: "selectionStyle",
            isCollectionItem: false
        },
        selectionStyle: {
            optionName: "selectionStyle",
            isCollectionItem: false
        }
    };
    return Point;
}($gkuLz.default);
module.exports.Point = $e9a285d79f845ae6$var$Point;
var $e9a285d79f845ae6$var$PointBorder = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(PointBorder, _super);
    function PointBorder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PointBorder.OptionName = "border";
    return PointBorder;
}($gkuLz.default);
module.exports.PointBorder = $e9a285d79f845ae6$var$PointBorder;
var $e9a285d79f845ae6$var$PointHoverStyle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(PointHoverStyle, _super);
    function PointHoverStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PointHoverStyle.OptionName = "hoverStyle";
    PointHoverStyle.ExpectedChildren = {
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        pointBorder: {
            optionName: "border",
            isCollectionItem: false
        }
    };
    return PointHoverStyle;
}($gkuLz.default);
module.exports.PointHoverStyle = $e9a285d79f845ae6$var$PointHoverStyle;
var $e9a285d79f845ae6$var$PointImage = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(PointImage, _super);
    function PointImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PointImage.OptionName = "image";
    PointImage.ExpectedChildren = {
        height: {
            optionName: "height",
            isCollectionItem: false
        },
        url: {
            optionName: "url",
            isCollectionItem: false
        },
        width: {
            optionName: "width",
            isCollectionItem: false
        }
    };
    return PointImage;
}($gkuLz.default);
module.exports.PointImage = $e9a285d79f845ae6$var$PointImage;
var $e9a285d79f845ae6$var$PointSelectionStyle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(PointSelectionStyle, _super);
    function PointSelectionStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PointSelectionStyle.OptionName = "selectionStyle";
    PointSelectionStyle.ExpectedChildren = {
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        pointBorder: {
            optionName: "border",
            isCollectionItem: false
        }
    };
    return PointSelectionStyle;
}($gkuLz.default);
module.exports.PointSelectionStyle = $e9a285d79f845ae6$var$PointSelectionStyle;
var $e9a285d79f845ae6$var$Reduction = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Reduction, _super);
    function Reduction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Reduction.OptionName = "reduction";
    return Reduction;
}($gkuLz.default);
module.exports.Reduction = $e9a285d79f845ae6$var$Reduction;
var $e9a285d79f845ae6$var$ScrollBar = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(ScrollBar, _super);
    function ScrollBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScrollBar.OptionName = "scrollBar";
    return ScrollBar;
}($gkuLz.default);
module.exports.ScrollBar = $e9a285d79f845ae6$var$ScrollBar;
var $e9a285d79f845ae6$var$SelectionStyle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(SelectionStyle, _super);
    function SelectionStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectionStyle.OptionName = "selectionStyle";
    return SelectionStyle;
}($gkuLz.default);
module.exports.SelectionStyle = $e9a285d79f845ae6$var$SelectionStyle;
var $e9a285d79f845ae6$var$Series = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Series, _super);
    function Series() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Series.OptionName = "series";
    Series.IsCollectionItem = true;
    return Series;
}($gkuLz.default);
module.exports.Series = $e9a285d79f845ae6$var$Series;
var $e9a285d79f845ae6$var$SeriesBorder = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(SeriesBorder, _super);
    function SeriesBorder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SeriesBorder.OptionName = "border";
    return SeriesBorder;
}($gkuLz.default);
module.exports.SeriesBorder = $e9a285d79f845ae6$var$SeriesBorder;
var $e9a285d79f845ae6$var$SeriesTemplate = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(SeriesTemplate, _super);
    function SeriesTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SeriesTemplate.OptionName = "seriesTemplate";
    return SeriesTemplate;
}($gkuLz.default);
module.exports.SeriesTemplate = $e9a285d79f845ae6$var$SeriesTemplate;
var $e9a285d79f845ae6$var$Shadow = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Shadow, _super);
    function Shadow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Shadow.OptionName = "shadow";
    return Shadow;
}($gkuLz.default);
module.exports.Shadow = $e9a285d79f845ae6$var$Shadow;
var $e9a285d79f845ae6$var$Size = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Size, _super);
    function Size() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Size.OptionName = "size";
    return Size;
}($gkuLz.default);
module.exports.Size = $e9a285d79f845ae6$var$Size;
var $e9a285d79f845ae6$var$Strip = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Strip, _super);
    function Strip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Strip.OptionName = "strips";
    Strip.IsCollectionItem = true;
    return Strip;
}($gkuLz.default);
module.exports.Strip = $e9a285d79f845ae6$var$Strip;
var $e9a285d79f845ae6$var$StripLabel = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(StripLabel, _super);
    function StripLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StripLabel.OptionName = "label";
    return StripLabel;
}($gkuLz.default);
module.exports.StripLabel = $e9a285d79f845ae6$var$StripLabel;
var $e9a285d79f845ae6$var$StripStyle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(StripStyle, _super);
    function StripStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StripStyle.OptionName = "stripStyle";
    StripStyle.ExpectedChildren = {
        label: {
            optionName: "label",
            isCollectionItem: false
        },
        stripStyleLabel: {
            optionName: "label",
            isCollectionItem: false
        }
    };
    return StripStyle;
}($gkuLz.default);
module.exports.StripStyle = $e9a285d79f845ae6$var$StripStyle;
var $e9a285d79f845ae6$var$StripStyleLabel = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(StripStyleLabel, _super);
    function StripStyleLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StripStyleLabel.OptionName = "label";
    return StripStyleLabel;
}($gkuLz.default);
module.exports.StripStyleLabel = $e9a285d79f845ae6$var$StripStyleLabel;
var $e9a285d79f845ae6$var$Subtitle = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Subtitle, _super);
    function Subtitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Subtitle.OptionName = "subtitle";
    return Subtitle;
}($gkuLz.default);
module.exports.Subtitle = $e9a285d79f845ae6$var$Subtitle;
var $e9a285d79f845ae6$var$Tick = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Tick, _super);
    function Tick() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tick.OptionName = "tick";
    return Tick;
}($gkuLz.default);
module.exports.Tick = $e9a285d79f845ae6$var$Tick;
var $e9a285d79f845ae6$var$TickInterval = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(TickInterval, _super);
    function TickInterval() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TickInterval.OptionName = "tickInterval";
    return TickInterval;
}($gkuLz.default);
module.exports.TickInterval = $e9a285d79f845ae6$var$TickInterval;
var $e9a285d79f845ae6$var$Title = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Title, _super);
    function Title() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Title.OptionName = "title";
    return Title;
}($gkuLz.default);
module.exports.Title = $e9a285d79f845ae6$var$Title;
var $e9a285d79f845ae6$var$Tooltip = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Tooltip, _super);
    function Tooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tooltip.OptionName = "tooltip";
    Tooltip.ExpectedChildren = {
        argumentFormat: {
            optionName: "argumentFormat",
            isCollectionItem: false
        },
        border: {
            optionName: "border",
            isCollectionItem: false
        },
        font: {
            optionName: "font",
            isCollectionItem: false
        },
        format: {
            optionName: "format",
            isCollectionItem: false
        },
        shadow: {
            optionName: "shadow",
            isCollectionItem: false
        },
        tooltipBorder: {
            optionName: "border",
            isCollectionItem: false
        }
    };
    Tooltip.TemplateProps = [
        {
            tmplOption: "contentTemplate",
            render: "contentRender",
            component: "contentComponent",
            keyFn: "contentKeyFn"
        }
    ];
    return Tooltip;
}($gkuLz.default);
module.exports.Tooltip = $e9a285d79f845ae6$var$Tooltip;
var $e9a285d79f845ae6$var$TooltipBorder = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(TooltipBorder, _super);
    function TooltipBorder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TooltipBorder.OptionName = "border";
    return TooltipBorder;
}($gkuLz.default);
module.exports.TooltipBorder = $e9a285d79f845ae6$var$TooltipBorder;
var $e9a285d79f845ae6$var$Url = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Url, _super);
    function Url() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Url.OptionName = "url";
    return Url;
}($gkuLz.default);
module.exports.Url = $e9a285d79f845ae6$var$Url;
var $e9a285d79f845ae6$var$ValueAxis = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(ValueAxis, _super);
    function ValueAxis() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ValueAxis.OptionName = "valueAxis";
    ValueAxis.IsCollectionItem = true;
    ValueAxis.DefaultsProps = {
        defaultCategories: "categories",
        defaultVisualRange: "visualRange"
    };
    ValueAxis.ExpectedChildren = {
        axisConstantLineStyle: {
            optionName: "constantLineStyle",
            isCollectionItem: false
        },
        axisLabel: {
            optionName: "label",
            isCollectionItem: false
        },
        axisTitle: {
            optionName: "title",
            isCollectionItem: false
        },
        break: {
            optionName: "breaks",
            isCollectionItem: true
        },
        constantLine: {
            optionName: "constantLines",
            isCollectionItem: true
        },
        constantLineStyle: {
            optionName: "constantLineStyle",
            isCollectionItem: false
        },
        label: {
            optionName: "label",
            isCollectionItem: false
        },
        minorTickInterval: {
            optionName: "minorTickInterval",
            isCollectionItem: false
        },
        minVisualRangeLength: {
            optionName: "minVisualRangeLength",
            isCollectionItem: false
        },
        strip: {
            optionName: "strips",
            isCollectionItem: true
        },
        tickInterval: {
            optionName: "tickInterval",
            isCollectionItem: false
        },
        title: {
            optionName: "title",
            isCollectionItem: false
        },
        visualRange: {
            optionName: "visualRange",
            isCollectionItem: false
        },
        wholeRange: {
            optionName: "wholeRange",
            isCollectionItem: false
        }
    };
    return ValueAxis;
}($gkuLz.default);
module.exports.ValueAxis = $e9a285d79f845ae6$var$ValueAxis;
var $e9a285d79f845ae6$var$ValueErrorBar = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(ValueErrorBar, _super);
    function ValueErrorBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ValueErrorBar.OptionName = "valueErrorBar";
    return ValueErrorBar;
}($gkuLz.default);
module.exports.ValueErrorBar = $e9a285d79f845ae6$var$ValueErrorBar;
var $e9a285d79f845ae6$var$VerticalLine = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(VerticalLine, _super);
    function VerticalLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VerticalLine.OptionName = "verticalLine";
    VerticalLine.ExpectedChildren = {
        horizontalLineLabel: {
            optionName: "label",
            isCollectionItem: false
        },
        label: {
            optionName: "label",
            isCollectionItem: false
        }
    };
    return VerticalLine;
}($gkuLz.default);
module.exports.VerticalLine = $e9a285d79f845ae6$var$VerticalLine;
var $e9a285d79f845ae6$var$VisualRange = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(VisualRange, _super);
    function VisualRange() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VisualRange.OptionName = "visualRange";
    VisualRange.DefaultsProps = {
        defaultEndValue: "endValue",
        defaultStartValue: "startValue"
    };
    return VisualRange;
}($gkuLz.default);
module.exports.VisualRange = $e9a285d79f845ae6$var$VisualRange;
var $e9a285d79f845ae6$var$WholeRange = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(WholeRange, _super);
    function WholeRange() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WholeRange.OptionName = "wholeRange";
    WholeRange.DefaultsProps = {
        defaultEndValue: "endValue",
        defaultStartValue: "startValue"
    };
    return WholeRange;
}($gkuLz.default);
module.exports.WholeRange = $e9a285d79f845ae6$var$WholeRange;
var $e9a285d79f845ae6$var$Width = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(Width, _super);
    function Width() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Width.OptionName = "width";
    return Width;
}($gkuLz.default);
module.exports.Width = $e9a285d79f845ae6$var$Width;
var $e9a285d79f845ae6$var$ZoomAndPan = /** @class */ function(_super) {
    $e9a285d79f845ae6$var$__extends(ZoomAndPan, _super);
    function ZoomAndPan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZoomAndPan.OptionName = "zoomAndPan";
    ZoomAndPan.ExpectedChildren = {
        dragBoxStyle: {
            optionName: "dragBoxStyle",
            isCollectionItem: false
        }
    };
    return ZoomAndPan;
}($gkuLz.default);
module.exports.ZoomAndPan = $e9a285d79f845ae6$var$ZoomAndPan;
module.exports.default = $e9a285d79f845ae6$var$Chart;

});
parcelRegister("iIrpj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da01989616d709f4$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/chart.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $9QLAW = parcelRequire("9QLAW");
var $da01989616d709f4$export$2e2bcd8739ae039 = (0, $9QLAW.default);

});
parcelRegister("9QLAW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72bde3bcd4253ecb$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/__internal/viz/m_chart.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $9UmiO = parcelRequire("9UmiO");

var $gcp4g = parcelRequire("gcp4g");

var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $laqiS = parcelRequire("laqiS");

var $iE2yv = parcelRequire("iE2yv");

var $6ntMu = parcelRequire("6ntMu");

var $hYatw = parcelRequire("hYatw");

var $55jA4 = parcelRequire("55jA4");

var $e6jz0 = parcelRequire("e6jz0");

var $kSBht = parcelRequire("kSBht");

var $2bqSa = parcelRequire("2bqSa");

var $6V66N = parcelRequire("6V66N");

var $j4RF2 = parcelRequire("j4RF2");

var $cYTj1 = parcelRequire("cYTj1");

var $dw9tZ = parcelRequire("dw9tZ");

var $lPQM0 = parcelRequire("lPQM0");

var $4jhWa = parcelRequire("4jhWa");

var $5XaPR = parcelRequire("5XaPR");

var $lDNDs = parcelRequire("lDNDs");

var $7MSPx = parcelRequire("7MSPx");
var $72bde3bcd4253ecb$var$DEFAULT_PANE_NAME = "default";
var $72bde3bcd4253ecb$var$VISUAL_RANGE = "VISUAL_RANGE";
var $72bde3bcd4253ecb$var$DEFAULT_PANES = [
    {
        name: $72bde3bcd4253ecb$var$DEFAULT_PANE_NAME,
        border: {}
    }
];
var $72bde3bcd4253ecb$var$DISCRETE = "discrete";
var { isArray: $72bde3bcd4253ecb$var$isArray } = Array;
function $72bde3bcd4253ecb$var$getFirstAxisNameForPane(axes, paneName, defaultPane) {
    var result;
    for(var i = 0; i < axes.length; i += 1)if (axes[i].pane === paneName || void 0 === axes[i].pane && paneName === defaultPane) {
        result = axes[i].name;
        break;
    }
    if (!result) result = axes[0].name;
    return result;
}
function $72bde3bcd4253ecb$var$changeVisibilityAxisGrids(axis, gridVisibility, minorGridVisibility) {
    var gridOpt = axis.getOptions().grid;
    var minorGridOpt = axis.getOptions().minorGrid;
    gridOpt.visible = gridVisibility;
    minorGridOpt && (minorGridOpt.visible = minorGridVisibility);
}
function $72bde3bcd4253ecb$var$hideGridsOnNonFirstValueAxisForPane(axesForPane) {
    var axisShown = false;
    var hiddenStubAxis = [];
    var minorGridVisibility = axesForPane.some((axis)=>{
        var minorGridOptions = axis.getOptions().minorGrid;
        return null === minorGridOptions || void 0 === minorGridOptions ? void 0 : minorGridOptions.visible;
    });
    var gridVisibility = axesForPane.some((axis)=>{
        var gridOptions = axis.getOptions().grid;
        return null === gridOptions || void 0 === gridOptions ? void 0 : gridOptions.visible;
    });
    if (axesForPane.length > 1) {
        axesForPane.forEach((axis)=>{
            var gridOpt = axis.getOptions().grid;
            if (axisShown) $72bde3bcd4253ecb$var$changeVisibilityAxisGrids(axis, false, false);
            else if (null === gridOpt || void 0 === gridOpt ? void 0 : gridOpt.visible) {
                if (axis.getTranslator().getBusinessRange().isEmpty()) {
                    $72bde3bcd4253ecb$var$changeVisibilityAxisGrids(axis, false, false);
                    hiddenStubAxis.push(axis);
                } else {
                    axisShown = true;
                    $72bde3bcd4253ecb$var$changeVisibilityAxisGrids(axis, gridVisibility, minorGridVisibility);
                }
            }
        });
        if (!axisShown && hiddenStubAxis.length) $72bde3bcd4253ecb$var$changeVisibilityAxisGrids(hiddenStubAxis[0], gridVisibility, minorGridVisibility);
    }
}
function $72bde3bcd4253ecb$var$findAxisOptions(valueAxes, valueAxesOptions, axisName) {
    var result;
    var axInd;
    for(axInd = 0; axInd < valueAxesOptions.length; axInd += 1)if (valueAxesOptions[axInd].name === axisName) {
        result = valueAxesOptions[axInd];
        result.priority = axInd;
        break;
    }
    if (!result) {
        for(axInd = 0; axInd < valueAxes.length; axInd += 1)if (valueAxes[axInd].name === axisName) {
            result = valueAxes[axInd].getOptions();
            result.priority = valueAxes[axInd].priority;
            break;
        }
    }
    return result;
}
function $72bde3bcd4253ecb$var$findAxis(paneName, axisName, axes) {
    var axisByName = axes.find((axis)=>axis.name === axisName && axis.pane === paneName);
    if (axisByName) return axisByName;
    if (paneName) return $72bde3bcd4253ecb$var$findAxis(void 0, axisName, axes);
}
function $72bde3bcd4253ecb$var$compareAxes(a, b) {
    return a.priority - b.priority;
}
function $72bde3bcd4253ecb$var$doesPaneExist(panes, paneName) {
    return panes.some((pane)=>pane.name === paneName);
}
function $72bde3bcd4253ecb$var$accumulate(field, src1, src2, auxSpacing) {
    var val1 = src1[field] || 0;
    var val2 = src2[field] || 0;
    return val1 + val2 + (val1 && val2 ? auxSpacing : 0);
}
function $72bde3bcd4253ecb$var$pickMax(field, src1, src2) {
    return $72bde3bcd4253ecb$var$pickMaxValue(src1[field], src2[field]);
}
function $72bde3bcd4253ecb$var$pickMaxValue(val1, val2) {
    return Math.max(val1 || 0, val2 || 0);
}
function $72bde3bcd4253ecb$var$getAxisMargins(axis) {
    return axis.getMargins();
}
function $72bde3bcd4253ecb$var$getHorizontalAxesMargins(axes, getMarginsFunc) {
    return axes.reduce((margins, axis)=>{
        var _a;
        var axisMargins = getMarginsFunc(axis);
        var paneMargins = margins.panes[axis.pane] = margins.panes[axis.pane] || {};
        var spacing = axis.getMultipleAxesSpacing();
        paneMargins.top = $72bde3bcd4253ecb$var$accumulate("top", paneMargins, axisMargins, spacing);
        paneMargins.bottom = $72bde3bcd4253ecb$var$accumulate("bottom", paneMargins, axisMargins, spacing);
        paneMargins.left = $72bde3bcd4253ecb$var$pickMax("left", paneMargins, axisMargins);
        paneMargins.right = $72bde3bcd4253ecb$var$pickMax("right", paneMargins, axisMargins);
        margins.top = $72bde3bcd4253ecb$var$pickMax("top", paneMargins, margins);
        margins.bottom = $72bde3bcd4253ecb$var$pickMax("bottom", paneMargins, margins);
        margins.left = $72bde3bcd4253ecb$var$pickMax("left", paneMargins, margins);
        margins.right = $72bde3bcd4253ecb$var$pickMax("right", paneMargins, margins);
        var orthogonalAxis = null === (_a = axis.getOrthogonalAxis) || void 0 === _a ? void 0 : _a.call(axis);
        var shouldResetPositionMargin = (null === orthogonalAxis || void 0 === orthogonalAxis ? void 0 : orthogonalAxis.customPositionIsAvailable()) && (!axis.customPositionIsBoundaryOrthogonalAxis() || !orthogonalAxis.customPositionEqualsToPredefined());
        if (shouldResetPositionMargin) margins[orthogonalAxis.getResolvedBoundaryPosition()] = 0;
        return margins;
    }, {
        panes: {}
    });
}
function $72bde3bcd4253ecb$var$getVerticalAxesMargins(axes) {
    return axes.reduce((margins, axis)=>{
        var axisMargins = axis.getMargins();
        var paneMargins = margins.panes[axis.pane] = margins.panes[axis.pane] || {};
        var spacing = axis.getMultipleAxesSpacing();
        paneMargins.top = $72bde3bcd4253ecb$var$pickMax("top", paneMargins, axisMargins);
        paneMargins.bottom = $72bde3bcd4253ecb$var$pickMax("bottom", paneMargins, axisMargins);
        paneMargins.left = $72bde3bcd4253ecb$var$accumulate("left", paneMargins, axisMargins, spacing);
        paneMargins.right = $72bde3bcd4253ecb$var$accumulate("right", paneMargins, axisMargins, spacing);
        margins.top = $72bde3bcd4253ecb$var$pickMax("top", paneMargins, margins);
        margins.bottom = $72bde3bcd4253ecb$var$pickMax("bottom", paneMargins, margins);
        margins.left = $72bde3bcd4253ecb$var$pickMax("left", paneMargins, margins);
        margins.right = $72bde3bcd4253ecb$var$pickMax("right", paneMargins, margins);
        return margins;
    }, {
        panes: {}
    });
}
function $72bde3bcd4253ecb$var$performActionOnAxes(axes, action, actionArgument1, actionArgument2, actionArgument3) {
    axes.forEach((axis)=>{
        axis[action](null === actionArgument1 || void 0 === actionArgument1 ? void 0 : actionArgument1[axis.pane], (null === actionArgument2 || void 0 === actionArgument2 ? void 0 : actionArgument2[axis.pane]) || actionArgument2, actionArgument3);
    });
}
function $72bde3bcd4253ecb$var$shrinkCanvases(isRotated, canvases, sizes, verticalMargins, horizontalMargins) {
    function getMargin(side, margins, pane) {
        var m = !(isRotated ? [
            "left",
            "right"
        ] : [
            "top",
            "bottom"
        ]).includes(side) ? margins : margins.panes[pane] || {};
        return m[side];
    }
    function getMaxMargin(side, margins1, margins2, pane) {
        return $72bde3bcd4253ecb$var$pickMaxValue(getMargin(side, margins1, pane), getMargin(side, margins2, pane));
    }
    var getOriginalField = (field)=>"original".concat(field[0].toUpperCase()).concat(field.slice(1));
    function shrink(canvases, paneNames, sizeField, startMargin, endMargin, oppositeMargins) {
        paneNames = paneNames.sort((p1, p2)=>canvases[p2][startMargin] - canvases[p1][startMargin]);
        paneNames.forEach((pane)=>{
            var canvas = canvases[pane];
            oppositeMargins.forEach((margin)=>{
                canvas[margin] = canvas[getOriginalField(margin)] + getMaxMargin(margin, verticalMargins, horizontalMargins, pane);
            });
        });
        var firstPane = canvases[paneNames[0]];
        var initialEmptySpace = firstPane[sizeField] - firstPane[getOriginalField(endMargin)] - canvases[paneNames.at(-1)][getOriginalField(startMargin)];
        var emptySpace = paneNames.reduce((space, paneName)=>{
            var maxStartMargin = getMaxMargin(startMargin, verticalMargins, horizontalMargins, paneName);
            var maxEndMargin = getMaxMargin(endMargin, verticalMargins, horizontalMargins, paneName);
            return space - maxStartMargin - maxEndMargin;
        }, initialEmptySpace) - (0, $dw9tZ.PANE_PADDING) * (paneNames.length - 1);
        emptySpace -= Object.keys(sizes).reduce((prev, key)=>{
            var currentHeight = !(0, $dw9tZ.isRelativeHeightPane)(sizes[key]) ? sizes[key].height : 0;
            return prev + currentHeight;
        }, 0);
        var initialOffset = firstPane[sizeField] - firstPane[getOriginalField(endMargin)] - (emptySpace < 0 ? emptySpace : 0);
        paneNames.reduce((offset, pane)=>{
            var canvas = canvases[pane];
            var paneSize = sizes[pane];
            offset -= getMaxMargin(endMargin, verticalMargins, horizontalMargins, pane);
            canvas[endMargin] = firstPane[sizeField] - offset;
            offset -= !(0, $dw9tZ.isRelativeHeightPane)(paneSize) ? paneSize.height : Math.floor(emptySpace * paneSize.height);
            canvas[startMargin] = offset;
            offset -= getMaxMargin(startMargin, verticalMargins, horizontalMargins, pane) + (0, $dw9tZ.PANE_PADDING);
            return offset;
        }, initialOffset);
    }
    var paneNames = Object.keys(canvases);
    if (!isRotated) shrink(canvases, paneNames, "height", "top", "bottom", [
        "left",
        "right"
    ]);
    else shrink(canvases, paneNames, "width", "left", "right", [
        "top",
        "bottom"
    ]);
    return canvases;
}
function $72bde3bcd4253ecb$var$drawAxesWithTicks(axes, condition, canvases, panesBorderOptions) {
    if (condition) {
        $72bde3bcd4253ecb$var$performActionOnAxes(axes, "createTicks", canvases);
        (0, $kSBht.default).synchronize(axes);
    }
    $72bde3bcd4253ecb$var$performActionOnAxes(axes, "draw", !condition && canvases, panesBorderOptions);
}
function $72bde3bcd4253ecb$var$shiftAxis(side1, side2) {
    var shifts = {};
    return function(axis) {
        if (!axis.customPositionIsAvailable() || axis.customPositionEqualsToPredefined()) {
            var shift = shifts[axis.pane] = shifts[axis.pane] || {
                top: 0,
                left: 0,
                bottom: 0,
                right: 0
            };
            var spacing = axis.getMultipleAxesSpacing();
            var margins = axis.getMargins();
            axis.shift(shift);
            shift[side1] = $72bde3bcd4253ecb$var$accumulate(side1, shift, margins, spacing);
            shift[side2] = $72bde3bcd4253ecb$var$accumulate(side2, shift, margins, spacing);
        } else axis.shift({
            top: 0,
            left: 0,
            bottom: 0,
            right: 0
        });
    };
}
function $72bde3bcd4253ecb$var$getCommonSize(side, margins) {
    var size = 0;
    var paneMargins;
    Object.keys(margins.panes).forEach((pane)=>{
        paneMargins = margins.panes[pane];
        size += "height" === side ? paneMargins.top + paneMargins.bottom : paneMargins.left + paneMargins.right;
    });
    return size;
}
function $72bde3bcd4253ecb$var$checkUsedSpace(sizeShortage, side, axes, getMarginFunc) {
    var size = 0;
    if (sizeShortage[side] > 0) {
        size = $72bde3bcd4253ecb$var$getCommonSize(side, getMarginFunc(axes, $72bde3bcd4253ecb$var$getAxisMargins));
        $72bde3bcd4253ecb$var$performActionOnAxes(axes, "hideTitle");
        sizeShortage[side] -= size - $72bde3bcd4253ecb$var$getCommonSize(side, getMarginFunc(axes, $72bde3bcd4253ecb$var$getAxisMargins));
    }
    if (sizeShortage[side] > 0) $72bde3bcd4253ecb$var$performActionOnAxes(axes, "hideOuterElements");
}
function $72bde3bcd4253ecb$var$axisAnimationEnabled(drawOptions, pointsToAnimation) {
    var pointsCount = pointsToAnimation.reduce((sum, count)=>sum + count, 0) / pointsToAnimation.length;
    return drawOptions.animate && pointsCount <= drawOptions.animationPointsLimit;
}
function $72bde3bcd4253ecb$var$collectMarkersInfoBySeries(allSeries, filteredSeries, argAxis) {
    var series = [];
    var overloadedSeries = {};
    var argVisualRange = argAxis.visualRange();
    var argTranslator = argAxis.getTranslator();
    var argViewPortFilter = (0, $lPQM0.default).getViewPortFilter(argVisualRange || {});
    filteredSeries.forEach((s)=>{
        var valAxis = s.getValueAxis();
        var valVisualRange = valAxis.getCanvasRange();
        var valTranslator = valAxis.getTranslator();
        var seriesIndex = allSeries.indexOf(s);
        var valViewPortFilter = (0, $lPQM0.default).getViewPortFilter(valVisualRange || {});
        overloadedSeries[seriesIndex] = {};
        filteredSeries.forEach((sr)=>{
            overloadedSeries[seriesIndex][allSeries.indexOf(sr)] = 0;
        });
        var seriesPoints = [];
        var pointsInViewport = s.getPoints().filter((p)=>p.getOptions().visible && argViewPortFilter(p.argument) && (valViewPortFilter(p.getMinValue(true)) || valViewPortFilter(p.getMaxValue(true))));
        pointsInViewport.forEach((p)=>{
            var tp = {
                seriesIndex: seriesIndex,
                argument: p.argument,
                value: p.getMaxValue(true),
                size: p.bubbleSize || p.getOptions().size,
                x: void 0,
                y: void 0
            };
            if (p.getMinValue(true) !== p.getMaxValue(true)) {
                var mp = (0, $2oTOp.extend)({}, tp);
                mp.value = p.getMinValue(true);
                mp.x = argTranslator.to(mp.argument, 1);
                mp.y = valTranslator.to(mp.value, 1);
                seriesPoints.push(mp);
            }
            tp.x = argTranslator.to(tp.argument, 1);
            tp.y = valTranslator.to(tp.value, 1);
            seriesPoints.push(tp);
        });
        overloadedSeries[seriesIndex].pointsCount = seriesPoints.length;
        overloadedSeries[seriesIndex].total = 0;
        overloadedSeries[seriesIndex].continuousSeries = 0;
        series.push({
            name: s.name,
            index: seriesIndex,
            points: seriesPoints
        });
    });
    return {
        series: series,
        overloadedSeries: overloadedSeries
    };
}
function $72bde3bcd4253ecb$var$applyAutoHidePointMarkers(allSeries, filteredSeries, overloadedSeries, argAxis) {
    var argAxisType = argAxis.getOptions().type;
    filteredSeries.forEach((s)=>{
        var seriesIndex = allSeries.indexOf(s);
        s.autoHidePointMarkers = false;
        var tickCount = argAxis.getTicksValues().majorTicksValues.length;
        if (s.autoHidePointMarkersEnabled() && (argAxisType === $72bde3bcd4253ecb$var$DISCRETE || overloadedSeries[seriesIndex].pointsCount > tickCount)) {
            var shouldContinueLoop = true;
            Object.keys(overloadedSeries[seriesIndex]).forEach((index)=>{
                var i = parseInt(index, 10);
                if (shouldContinueLoop && (isNaN(i) || overloadedSeries[seriesIndex].total / overloadedSeries[seriesIndex].continuousSeries < 3)) return;
                if (i === seriesIndex) {
                    if (2 * overloadedSeries[i][i] >= overloadedSeries[i].pointsCount) {
                        s.autoHidePointMarkers = true;
                        shouldContinueLoop = false;
                    }
                } else if (overloadedSeries[seriesIndex].total >= overloadedSeries[seriesIndex].pointsCount) {
                    s.autoHidePointMarkers = true;
                    shouldContinueLoop = false;
                }
            });
        }
    });
}
function $72bde3bcd4253ecb$var$fastHidingPointMarkersByArea(canvas, markersInfo, series) {
    var area = canvas.width * canvas.height;
    var seriesPoints = markersInfo.series;
    var _loop = function(i) {
        var currentSeries = series.filter((s)=>s.name === seriesPoints[i].name)[0];
        var { points: points } = seriesPoints[i];
        var pointSize = points.length ? points[0].size : 0;
        var pointsArea = pointSize * pointSize * points.length;
        if (currentSeries.autoHidePointMarkersEnabled() && pointsArea >= area / seriesPoints.length) {
            var { index: index } = seriesPoints[i];
            currentSeries.autoHidePointMarkers = true;
            seriesPoints.splice(i, 1);
            series.splice(series.indexOf(currentSeries), 1);
            markersInfo.overloadedSeries[index] = null;
        }
    };
    for(var i = seriesPoints.length - 1; i >= 0; i -= 1)_loop(i);
}
function $72bde3bcd4253ecb$var$updateMarkersInfo(points, overloadedSeries) {
    var isContinuousSeries = false;
    for(var i = 0; i < points.length - 1; i += 1){
        var curPoint = points[i];
        var { size: size } = curPoint;
        if ((0, $6ntMu.isDefined)(curPoint.x) && (0, $6ntMu.isDefined)(curPoint.y)) for(var j = i + 1; j < points.length; j += 1){
            var nextPoint = points[j];
            var nextX = null === nextPoint || void 0 === nextPoint ? void 0 : nextPoint.x;
            var nextY = null === nextPoint || void 0 === nextPoint ? void 0 : nextPoint.y;
            if (!(0, $6ntMu.isDefined)(nextX) || Math.abs(curPoint.x - nextX) >= size) {
                isContinuousSeries = isContinuousSeries && j !== i + 1;
                break;
            } else {
                var distance = (0, $6ntMu.isDefined)(nextX) && (0, $6ntMu.isDefined)(nextY) && Math.sqrt(Math.pow(curPoint.x - nextX, 2) + Math.pow(curPoint.y - nextY, 2));
                if (distance && distance < size) {
                    overloadedSeries[curPoint.seriesIndex][nextPoint.seriesIndex] += 1;
                    overloadedSeries[curPoint.seriesIndex].total += 1;
                    if (!isContinuousSeries) {
                        overloadedSeries[curPoint.seriesIndex].continuousSeries += 1;
                        isContinuousSeries = true;
                    }
                }
            }
        }
    }
}
var $72bde3bcd4253ecb$var$dxChart = (0, $lDNDs.AdvancedChart).inherit({
    _themeSection: "chart",
    _fontFields: [
        "crosshair.label.font"
    ],
    _initCore () {
        this.paneAxis = {};
        this.callBase();
    },
    _init () {
        this._containerInitialHeight = (0, $hYatw.hasWindow)() ? (0, $iE2yv.getHeight)(this._$element) : 0;
        this.callBase();
    },
    _correctAxes () {
        this._correctValueAxes(true);
    },
    _getExtraOptions: (0, $gcp4g.noop),
    _createPanes () {
        var panes = this.option("panes");
        var panesNameCounter = 0;
        var defaultPane;
        if (!panes || $72bde3bcd4253ecb$var$isArray(panes) && !panes.length) panes = $72bde3bcd4253ecb$var$DEFAULT_PANES;
        this.callBase();
        defaultPane = this.option("defaultPane");
        panes = (0, $2oTOp.extend)(true, [], $72bde3bcd4253ecb$var$isArray(panes) ? panes : [
            panes
        ]);
        (0, $8OLOW.each)(panes, (_, pane)=>{
            pane.name = !(0, $6ntMu.isDefined)(pane.name) ? $72bde3bcd4253ecb$var$DEFAULT_PANE_NAME + panesNameCounter++ : pane.name;
        });
        if ((0, $6ntMu.isDefined)(defaultPane)) {
            if (!$72bde3bcd4253ecb$var$doesPaneExist(panes, defaultPane)) {
                this._incidentOccurred("W2101", [
                    defaultPane
                ]);
                defaultPane = panes[panes.length - 1].name;
            }
        } else defaultPane = panes[panes.length - 1].name;
        this.defaultPane = defaultPane;
        panes = this._isRotated() ? panes.reverse() : panes;
        return panes;
    },
    _getAxisRenderingOptions: ()=>({
            axisType: "xyAxes",
            drawingType: "linear"
        }),
    _prepareAxisOptions (typeSelector, userOptions, rotated) {
        return {
            isHorizontal: "argumentAxis" === typeSelector !== rotated,
            containerColor: this._themeManager.getOptions("containerBackgroundColor")
        };
    },
    _checkPaneName (seriesTheme) {
        var paneList = (0, $dw9tZ.map)(this.panes, (pane)=>pane.name);
        seriesTheme.pane = seriesTheme.pane || this.defaultPane;
        return paneList.includes(seriesTheme.pane);
    },
    _initCustomPositioningAxes () {
        var argumentAxis = this.getArgumentAxis();
        var valueAxisName = argumentAxis.getOptions().customPositionAxis;
        var valueAxis = this._valueAxes.find((v)=>v.pane === argumentAxis.pane && (!valueAxisName || valueAxisName === v.name));
        this._valueAxes.forEach((v)=>{
            if (argumentAxis !== v.getOrthogonalAxis()) {
                v.getOrthogonalAxis = ()=>argumentAxis;
                v.customPositionIsBoundaryOrthogonalAxis = ()=>argumentAxis.customPositionIsBoundary();
            }
        });
        if ((0, $6ntMu.isDefined)(valueAxis) && valueAxis !== argumentAxis.getOrthogonalAxis()) {
            argumentAxis.getOrthogonalAxis = ()=>valueAxis;
            argumentAxis.customPositionIsBoundaryOrthogonalAxis = ()=>this._valueAxes.some((v)=>v.customPositionIsBoundary());
        } else if ((0, $6ntMu.isDefined)(argumentAxis.getOrthogonalAxis()) && !(0, $6ntMu.isDefined)(valueAxis)) argumentAxis.getOrthogonalAxis = (0, $gcp4g.noop);
    },
    _getAllAxes () {
        return this._argumentAxes.concat(this._valueAxes);
    },
    _resetAxesAnimation (isFirstDrawing, isHorizontal) {
        var axes;
        if ((0, $6ntMu.isDefined)(isHorizontal)) axes = isHorizontal ^ this._isRotated() ? this._argumentAxes : this._valueAxes;
        else axes = this._getAllAxes();
        axes.forEach((a)=>{
            a.resetApplyingAnimation(isFirstDrawing);
        });
    },
    _axesBoundaryPositioning () {
        var allAxes = this._getAllAxes();
        var boundaryStateChanged = false;
        allAxes.forEach((a)=>{
            if (a.customPositionIsAvailable()) {
                var prevBoundaryState = a.customPositionIsBoundary();
                a._customBoundaryPosition = a.getCustomBoundaryPosition();
                boundaryStateChanged = boundaryStateChanged || prevBoundaryState !== a.customPositionIsBoundary();
            }
        });
        return boundaryStateChanged;
    },
    _getCrosshairMargins () {
        var crosshairOptions = this._getCrosshairOptions() || {};
        var crosshairEnabled = crosshairOptions.enabled;
        var margins = (0, $55jA4.getMargins)();
        var horizontalLabel = (0, $2oTOp.extend)(true, {}, crosshairOptions.label, crosshairOptions.horizontalLine.label);
        var verticalLabel = (0, $2oTOp.extend)(true, {}, crosshairOptions.label, crosshairOptions.verticalLine.label);
        return {
            x: crosshairEnabled && crosshairOptions.horizontalLine.visible && horizontalLabel.visible ? margins.x : 0,
            y: crosshairEnabled && crosshairOptions.verticalLine.visible && verticalLabel.visible ? margins.y : 0
        };
    },
    _getValueAxis (paneName, axisName) {
        var valueAxes = this._valueAxes;
        var valueAxisOptions = this.option("valueAxis") || {};
        var valueAxesOptions = $72bde3bcd4253ecb$var$isArray(valueAxisOptions) ? valueAxisOptions : [
            valueAxisOptions
        ];
        var rotated = this._isRotated();
        var crosshairMargins = this._getCrosshairMargins();
        var axisOptions;
        var axis;
        axisName = axisName || $72bde3bcd4253ecb$var$getFirstAxisNameForPane(valueAxes, paneName, this.defaultPane);
        axis = $72bde3bcd4253ecb$var$findAxis(paneName, axisName, valueAxes);
        if (!axis) {
            axisOptions = $72bde3bcd4253ecb$var$findAxisOptions(valueAxes, valueAxesOptions, axisName);
            if (!axisOptions) {
                this._incidentOccurred("W2102", [
                    axisName
                ]);
                axisOptions = {
                    name: axisName,
                    priority: valueAxes.length
                };
            }
            axis = this._createAxis(false, this._populateAxesOptions("valueAxis", axisOptions, {
                pane: paneName,
                name: axisName,
                optionPath: $72bde3bcd4253ecb$var$isArray(valueAxisOptions) ? "valueAxis[".concat(axisOptions.priority, "]") : "valueAxis",
                crosshairMargin: rotated ? crosshairMargins.y : crosshairMargins.x
            }, rotated));
            axis.applyVisualRangeSetter(this._getVisualRangeSetter());
            valueAxes.push(axis);
        }
        axis.setPane(paneName);
        return axis;
    },
    _correctValueAxes (needHideGrids) {
        var synchronizeMultiAxes = this._themeManager.getOptions("synchronizeMultiAxes");
        var valueAxes = this._valueAxes;
        var paneWithAxis = {};
        this.series.forEach((series)=>{
            var axis = series.getValueAxis();
            paneWithAxis[axis.pane] = true;
        });
        this.panes.forEach((pane)=>{
            var paneName = pane.name;
            if (!paneWithAxis[paneName]) this._getValueAxis(paneName);
            if (needHideGrids && synchronizeMultiAxes) $72bde3bcd4253ecb$var$hideGridsOnNonFirstValueAxisForPane(valueAxes.filter((axis)=>axis.pane === paneName));
        });
        this._valueAxes = valueAxes.filter((axis)=>{
            if (!axis.pane) axis.setPane(this.defaultPane);
            var paneExists = $72bde3bcd4253ecb$var$doesPaneExist(this.panes, axis.pane);
            if (!paneExists) {
                axis.dispose();
                axis = null;
            }
            return paneExists;
        }).sort($72bde3bcd4253ecb$var$compareAxes);
        var defaultAxis = this.getValueAxis();
        this._valueAxes.forEach((axis)=>{
            var { optionPath: optionPath } = axis.getOptions();
            if (optionPath) {
                var axesWithSamePath = this._valueAxes.filter((a)=>a.getOptions().optionPath === optionPath);
                if (axesWithSamePath.length > 1) {
                    if (axesWithSamePath.some((a)=>a === defaultAxis)) axesWithSamePath.forEach((a)=>{
                        if (a !== defaultAxis) a.getOptions().optionPath = null;
                    });
                    else axesWithSamePath.forEach((a, i)=>{
                        if (0 !== i) a.getOptions().optionPath = null;
                    });
                }
            }
        });
    },
    _getSeriesForPane (paneName) {
        var paneSeries = [];
        (0, $8OLOW.each)(this.series, (_, oneSeries)=>{
            if (oneSeries.pane === paneName) paneSeries.push(oneSeries);
        });
        return paneSeries;
    },
    _createPanesBorderOptions () {
        var commonBorderOptions = this._themeManager.getOptions("commonPaneSettings").border;
        var panesBorderOptions = {};
        this.panes.forEach((pane)=>{
            panesBorderOptions[pane.name] = (0, $2oTOp.extend)(true, {}, commonBorderOptions, pane.border);
        });
        return panesBorderOptions;
    },
    _createScrollBar () {
        var _a;
        var scrollBarOptions = this._themeManager.getOptions("scrollBar") || {};
        var scrollBarGroup = this._scrollBarGroup;
        if (scrollBarOptions.visible) {
            scrollBarOptions.rotated = this._isRotated();
            this._scrollBar = (this._scrollBar || new (0, $2bqSa.ScrollBar)(this._renderer, scrollBarGroup)).update(scrollBarOptions);
        } else {
            scrollBarGroup.linkRemove();
            null === (_a = this._scrollBar) || void 0 === _a || _a.dispose();
            this._scrollBar = null;
        }
    },
    _executeAppendAfterSeries (append) {
        append();
    },
    _prepareToRender () {
        var panesBorderOptions = this._createPanesBorderOptions();
        this._createPanesBackground();
        this._appendAxesGroups();
        this._adjustViewport();
        return panesBorderOptions;
    },
    _adjustViewport () {
        var adjustOnZoom = this._themeManager.getOptions("adjustOnZoom");
        if (!adjustOnZoom) return;
        this._valueAxes.forEach((axis)=>axis.adjust());
    },
    _recreateSizeDependentObjects (isCanvasChanged) {
        var series = this._getVisibleSeries();
        var useAggregation = series.some((s)=>s.useAggregation());
        var zoomChanged = this._isZooming();
        if (!useAggregation) return;
        this._argumentAxes.forEach((axis)=>{
            axis.updateCanvas(this._canvas, true);
        });
        series.forEach((series)=>{
            if (series.useAggregation() && (isCanvasChanged || zoomChanged || !series._useAllAggregatedPoints)) series.createPoints();
        });
        this._processSeriesFamilies();
    },
    _isZooming () {
        var argumentAxis = this.getArgumentAxis();
        if (!(null === argumentAxis || void 0 === argumentAxis ? void 0 : argumentAxis.getTranslator())) return false;
        var businessRange = argumentAxis.getTranslator().getBusinessRange();
        var zoomRange = argumentAxis.getViewport();
        var min = zoomRange ? zoomRange.min : 0;
        var max = zoomRange ? zoomRange.max : 0;
        if ("logarithmic" === businessRange.axisType) {
            min = (0, $dw9tZ.getLog)(min, businessRange.base);
            max = (0, $dw9tZ.getLog)(max, businessRange.base);
        }
        var viewportDistance = businessRange.axisType === $72bde3bcd4253ecb$var$DISCRETE ? (0, $dw9tZ.getCategoriesInfo)(businessRange.categories, min, max).categories.length : Math.abs(max - min);
        var precision = (0, $laqiS.getPrecision)(viewportDistance);
        precision = precision > 1 ? Math.pow(10, precision - 2) : 1;
        var zoomChanged = Math.round((this._zoomLength - viewportDistance) * precision) / precision !== 0;
        this._zoomLength = viewportDistance;
        return zoomChanged;
    },
    _handleSeriesDataUpdated () {
        var viewport = new (0, $4jhWa.Range);
        this.series.forEach((s)=>{
            viewport.addRange(s.getArgumentRange());
        });
        this._argumentAxes.forEach((axis)=>{
            axis.updateCanvas(this._canvas, true);
            axis.setBusinessRange(viewport, this._axesReinitialized);
        });
        this.callBase();
    },
    _isLegendInside () {
        return this._legend && "inside" === this._legend.getPosition();
    },
    _isRotated () {
        return this._themeManager.getOptions("rotated");
    },
    _getLayoutTargets () {
        return this.panes;
    },
    _applyClipRects (panesBorderOptions) {
        this._drawPanesBorders(panesBorderOptions);
        this._createClipRectsForPanes();
        this._applyClipRectsForAxes();
        this._fillPanesBackground();
    },
    _updateLegendPosition (drawOptions, legendHasInsidePosition) {
        if (drawOptions.drawLegend && this._legend && legendHasInsidePosition) {
            var { panes: panes } = this;
            var newCanvas = (0, $2oTOp.extend)({}, panes[0].canvas);
            var layoutManager = new (0, $e6jz0.LayoutManager);
            newCanvas.right = panes[panes.length - 1].canvas.right;
            newCanvas.bottom = panes[panes.length - 1].canvas.bottom;
            layoutManager.layoutInsideLegend(this._legend, newCanvas);
        }
    },
    _allowLegendInsidePosition: ()=>true,
    _applyExtraSettings (series) {
        var paneIndex = this._getPaneIndex(series.pane);
        var panesClipRects = this._panesClipRects;
        var wideClipRect = panesClipRects.wide[paneIndex];
        series.setClippingParams(panesClipRects.base[paneIndex].id, null === wideClipRect || void 0 === wideClipRect ? void 0 : wideClipRect.id, this._getPaneBorderVisibility(paneIndex));
    },
    _updatePanesCanvases (drawOptions) {
        if (!drawOptions.recreateCanvas) return;
        (0, $dw9tZ.updatePanesCanvases)(this.panes, this._canvas, this._isRotated());
    },
    _normalizePanesHeight () {
        (0, $dw9tZ.normalizePanesHeight)(this.panes);
    },
    _renderScaleBreaks () {
        this._valueAxes.concat(this._argumentAxes).forEach((axis)=>{
            axis.drawScaleBreaks();
        });
    },
    _getArgFilter () {
        return (0, $lPQM0.default).getViewPortFilter(this.getArgumentAxis().visualRange() || {});
    },
    _applyPointMarkersAutoHiding () {
        var allSeries = this.series;
        if (!this._themeManager.getOptions("autoHidePointMarkers")) {
            allSeries.forEach((s)=>{
                s.autoHidePointMarkers = false;
            });
            return;
        }
        this.panes.forEach((_ref)=>{
            var { borderCoords: borderCoords, name: name } = _ref;
            var series = allSeries.filter((s)=>s.pane === name && s.usePointsToDefineAutoHiding());
            var argAxis = this.getArgumentAxis();
            var markersInfo = $72bde3bcd4253ecb$var$collectMarkersInfoBySeries(allSeries, series, argAxis);
            $72bde3bcd4253ecb$var$fastHidingPointMarkersByArea(borderCoords, markersInfo, series);
            if (markersInfo.series.length) {
                var argVisualRange = argAxis.visualRange();
                var argAxisIsDiscrete = argAxis.getOptions().type === $72bde3bcd4253ecb$var$DISCRETE;
                var sortingCallback = argAxisIsDiscrete ? (p1, p2)=>argVisualRange.categories.indexOf(p1.argument) - argVisualRange.categories.indexOf(p2.argument) : (p1, p2)=>p1.argument - p2.argument;
                var points = [];
                markersInfo.series.forEach((s)=>{
                    points = points.concat(s.points);
                });
                points.sort(sortingCallback);
                $72bde3bcd4253ecb$var$updateMarkersInfo(points, markersInfo.overloadedSeries);
                $72bde3bcd4253ecb$var$applyAutoHidePointMarkers(allSeries, series, markersInfo.overloadedSeries, argAxis);
            }
        });
    },
    _renderAxes (drawOptions, panesBorderOptions) {
        function calculateTitlesWidth(axes) {
            return axes.map((axis)=>{
                if (!axis.getTitle) return 0;
                var title = axis.getTitle();
                return title ? title.bBox.width : 0;
            });
        }
        var rotated = this._isRotated();
        var synchronizeMultiAxes = this._themeManager.getOptions("synchronizeMultiAxes");
        var scrollBar = this._scrollBar ? [
            this._scrollBar
        ] : [];
        var extendedArgAxes = this._isArgumentAxisBeforeScrollBar() ? this._argumentAxes.concat(scrollBar) : scrollBar.concat(this._argumentAxes);
        var verticalAxes = rotated ? this._argumentAxes : this._valueAxes;
        var verticalElements = rotated ? extendedArgAxes : this._valueAxes;
        var horizontalAxes = rotated ? this._valueAxes : this._argumentAxes;
        var horizontalElements = rotated ? this._valueAxes : extendedArgAxes;
        var allAxes = verticalAxes.concat(horizontalAxes);
        var allElements = allAxes.concat(scrollBar);
        var verticalAxesFirstDrawing = verticalAxes.some((v)=>v.isFirstDrawing());
        this._normalizePanesHeight();
        this._updatePanesCanvases(drawOptions);
        var panesCanvases = this.panes.reduce((canvases, pane)=>{
            canvases[pane.name] = (0, $2oTOp.extend)({}, pane.canvas);
            return canvases;
        }, {});
        var paneSizes = this.panes.reduce((sizes, pane)=>{
            sizes[pane.name] = {
                height: pane.height,
                unit: pane.unit
            };
            return sizes;
        }, {});
        var cleanPanesCanvases = (0, $2oTOp.extend)(true, {}, panesCanvases);
        this._initCustomPositioningAxes();
        var needCustomAdjustAxes = this._axesBoundaryPositioning();
        if (!drawOptions.adjustAxes && !needCustomAdjustAxes) {
            $72bde3bcd4253ecb$var$drawAxesWithTicks(verticalAxes, !rotated && synchronizeMultiAxes, panesCanvases, panesBorderOptions);
            $72bde3bcd4253ecb$var$drawAxesWithTicks(horizontalAxes, rotated && synchronizeMultiAxes, panesCanvases, panesBorderOptions);
            $72bde3bcd4253ecb$var$performActionOnAxes(allAxes, "prepareAnimation");
            this._renderScaleBreaks();
            horizontalAxes.forEach((a)=>a.resolveOverlappingForCustomPositioning(verticalAxes));
            verticalAxes.forEach((a)=>a.resolveOverlappingForCustomPositioning(horizontalAxes));
            return false;
        }
        if (needCustomAdjustAxes) allAxes.forEach((a)=>a.customPositionIsAvailable() && a.shift({
                top: 0,
                left: 0,
                bottom: 0,
                right: 0
            }));
        if (this._scrollBar) this._scrollBar.setPane(this.panes);
        var vAxesMargins = {
            panes: {},
            left: 0,
            right: 0
        };
        var hAxesMargins = $72bde3bcd4253ecb$var$getHorizontalAxesMargins(horizontalElements, (axis)=>axis.estimateMargins(panesCanvases[axis.pane]));
        panesCanvases = $72bde3bcd4253ecb$var$shrinkCanvases(rotated, panesCanvases, paneSizes, vAxesMargins, hAxesMargins);
        var drawAxesAndSetCanvases = (isHorizontal)=>{
            var axes = isHorizontal ? horizontalAxes : verticalAxes;
            var condition = (isHorizontal ? rotated : !rotated) && synchronizeMultiAxes;
            $72bde3bcd4253ecb$var$drawAxesWithTicks(axes, condition, panesCanvases, panesBorderOptions);
            if (isHorizontal) hAxesMargins = $72bde3bcd4253ecb$var$getHorizontalAxesMargins(horizontalElements, $72bde3bcd4253ecb$var$getAxisMargins);
            else vAxesMargins = $72bde3bcd4253ecb$var$getVerticalAxesMargins(verticalElements);
            panesCanvases = $72bde3bcd4253ecb$var$shrinkCanvases(rotated, panesCanvases, paneSizes, vAxesMargins, hAxesMargins);
        };
        drawAxesAndSetCanvases(false);
        drawAxesAndSetCanvases(true);
        if (!this._changesApplying && this._estimateTickIntervals(verticalAxes, panesCanvases)) drawAxesAndSetCanvases(false);
        var oldTitlesWidth = calculateTitlesWidth(verticalAxes);
        var visibleSeries = this._getVisibleSeries();
        var pointsToAnimation = this._getPointsToAnimation(visibleSeries);
        var axesIsAnimated = $72bde3bcd4253ecb$var$axisAnimationEnabled(drawOptions, pointsToAnimation);
        $72bde3bcd4253ecb$var$performActionOnAxes(allElements, "updateSize", panesCanvases, axesIsAnimated);
        horizontalElements.forEach($72bde3bcd4253ecb$var$shiftAxis("top", "bottom"));
        verticalElements.forEach($72bde3bcd4253ecb$var$shiftAxis("left", "right"));
        this._renderScaleBreaks();
        this.panes.forEach((pane)=>{
            (0, $2oTOp.extend)(pane.canvas, panesCanvases[pane.name]);
        });
        this._valueAxes.forEach((axis)=>{
            axis.setInitRange();
        });
        verticalAxes.forEach((axis, i)=>{
            var _a;
            if (null === (_a = axis.hasWrap) || void 0 === _a ? void 0 : _a.call(axis)) {
                var title = axis.getTitle();
                var newTitleWidth = title ? title.bBox.width : 0;
                var offset = newTitleWidth - oldTitlesWidth[i];
                if ("right" === axis.getOptions().position) vAxesMargins.right += offset;
                else {
                    vAxesMargins.left += offset;
                    this.panes.forEach((_ref2)=>{
                        var { name: name } = _ref2;
                        vAxesMargins.panes[name].left += offset;
                    });
                }
                panesCanvases = $72bde3bcd4253ecb$var$shrinkCanvases(rotated, panesCanvases, paneSizes, vAxesMargins, hAxesMargins);
                $72bde3bcd4253ecb$var$performActionOnAxes(allElements, "updateSize", panesCanvases, false, false);
                oldTitlesWidth = calculateTitlesWidth(verticalAxes);
            }
        });
        if (verticalAxes.some((v)=>v.customPositionIsAvailable() && v.getCustomPosition() !== v._axisPosition)) {
            axesIsAnimated && this._resetAxesAnimation(verticalAxesFirstDrawing, false);
            $72bde3bcd4253ecb$var$performActionOnAxes(verticalAxes, "updateSize", panesCanvases, axesIsAnimated);
        }
        horizontalAxes.forEach((a)=>a.resolveOverlappingForCustomPositioning(verticalAxes));
        verticalAxes.forEach((a)=>a.resolveOverlappingForCustomPositioning(horizontalAxes));
        return cleanPanesCanvases;
    },
    _getExtraTemplatesItems () {
        var allAxes = (this._argumentAxes || []).concat(this._valueAxes || []);
        var elements = this._collectTemplatesFromItems(allAxes);
        return {
            items: elements.items,
            groups: elements.groups,
            launchRequest () {
                allAxes.forEach((a)=>{
                    a.setRenderedState(true);
                });
            },
            doneRequest () {
                allAxes.forEach((a)=>{
                    a.setRenderedState(false);
                });
            }
        };
    },
    _estimateTickIntervals: (axes, canvases)=>axes.some((axis)=>axis.estimateTickInterval(canvases[axis.pane])),
    checkForMoreSpaceForPanesCanvas () {
        var rotated = this._isRotated();
        var panesAreCustomSized = this.panes.filter((p)=>p.unit).length === this.panes.length;
        var needSpace = false;
        if (panesAreCustomSized) {
            var needHorizontalSpace = 0;
            var needVerticalSpace = 0;
            if (rotated) {
                var argAxisRightMargin = this.getArgumentAxis().getMargins().right;
                var rightPanesIndent = Math.min(...this.panes.map((p)=>p.canvas.right));
                needHorizontalSpace = this._canvas.right + argAxisRightMargin - rightPanesIndent;
            } else {
                var argAxisBottomMargin = this.getArgumentAxis().getMargins().bottom;
                var bottomPanesIndent = Math.min(...this.panes.map((p)=>p.canvas.bottom));
                needVerticalSpace = this._canvas.bottom + argAxisBottomMargin - bottomPanesIndent;
            }
            needSpace = needHorizontalSpace > 0 || needVerticalSpace > 0 ? {
                width: needHorizontalSpace,
                height: needVerticalSpace
            } : false;
            if (0 !== needVerticalSpace) {
                var realSize = this.getSize();
                var customSize = this.option("size");
                var container = this._$element[0];
                var containerHasStyledHeight = !!parseInt(container.style.height, 10) || 0 !== this._containerInitialHeight;
                if (!rotated && !(null === customSize || void 0 === customSize ? void 0 : customSize.height) && !containerHasStyledHeight) {
                    this._forceResize(realSize.width, realSize.height + needVerticalSpace);
                    needSpace = false;
                }
            }
        } else needSpace = this.layoutManager.needMoreSpaceForPanesCanvas(this._getLayoutTargets(), rotated, (pane)=>({
                width: rotated && !!pane.unit,
                height: !rotated && !!pane.unit
            }));
        return needSpace;
    },
    _forceResize (width, height) {
        this._renderer.resize(width, height);
        this._updateSize(true);
        this._setContentSize();
        this._preserveOriginalCanvas();
        this._updateCanvasClipRect(this._canvas);
    },
    _shrinkAxes (sizeShortage, panesCanvases) {
        if (!sizeShortage || !panesCanvases) return;
        this._renderer.stopAllAnimations(true);
        var rotated = this._isRotated();
        var scrollBar = this._scrollBar ? [
            this._scrollBar
        ] : [];
        var extendedArgAxes = this._isArgumentAxisBeforeScrollBar() ? this._argumentAxes.concat(scrollBar) : scrollBar.concat(this._argumentAxes);
        var verticalAxes = rotated ? extendedArgAxes : this._valueAxes;
        var horizontalAxes = rotated ? this._valueAxes : extendedArgAxes;
        var allAxes = verticalAxes.concat(horizontalAxes);
        if (sizeShortage.width || sizeShortage.height) {
            $72bde3bcd4253ecb$var$checkUsedSpace(sizeShortage, "height", horizontalAxes, $72bde3bcd4253ecb$var$getHorizontalAxesMargins);
            $72bde3bcd4253ecb$var$checkUsedSpace(sizeShortage, "width", verticalAxes, $72bde3bcd4253ecb$var$getVerticalAxesMargins);
            $72bde3bcd4253ecb$var$performActionOnAxes(allAxes, "updateSize", panesCanvases);
            var paneSizes = this.panes.reduce((sizes, pane)=>{
                sizes[pane.name] = {
                    height: pane.height,
                    unit: pane.unit
                };
                return sizes;
            }, {});
            panesCanvases = $72bde3bcd4253ecb$var$shrinkCanvases(rotated, panesCanvases, paneSizes, $72bde3bcd4253ecb$var$getVerticalAxesMargins(verticalAxes), $72bde3bcd4253ecb$var$getHorizontalAxesMargins(horizontalAxes, $72bde3bcd4253ecb$var$getAxisMargins));
            $72bde3bcd4253ecb$var$performActionOnAxes(allAxes, "updateSize", panesCanvases);
            horizontalAxes.forEach($72bde3bcd4253ecb$var$shiftAxis("top", "bottom"));
            verticalAxes.forEach($72bde3bcd4253ecb$var$shiftAxis("left", "right"));
            this.panes.forEach((pane)=>(0, $2oTOp.extend)(pane.canvas, panesCanvases[pane.name]));
        }
    },
    _isArgumentAxisBeforeScrollBar () {
        var _a;
        var argumentAxis = this.getArgumentAxis();
        if (this._scrollBar) {
            var argAxisPosition = argumentAxis.getResolvedBoundaryPosition();
            var argAxisLabelPosition = null === (_a = argumentAxis.getOptions().label) || void 0 === _a ? void 0 : _a.position;
            var scrollBarPosition = this._scrollBar.getOptions().position;
            return argumentAxis.hasNonBoundaryPosition() || scrollBarPosition === argAxisPosition && argAxisLabelPosition !== scrollBarPosition;
        }
        return false;
    },
    _getPanesParameters () {
        var { panes: panes } = this;
        var params = [];
        for(var i = 0; i < panes.length; i += 1)if (this._getPaneBorderVisibility(i)) params.push({
            coords: panes[i].borderCoords,
            clipRect: this._panesClipRects.fixed[i]
        });
        return params;
    },
    _createCrosshairCursor () {
        var options = this._themeManager.getOptions("crosshair") || {};
        var argumentAxis = this.getArgumentAxis();
        var axes = this._isRotated() ? [
            this._valueAxes,
            [
                argumentAxis
            ]
        ] : [
            [
                argumentAxis
            ],
            this._valueAxes
        ];
        var parameters = {
            canvas: this._getCommonCanvas(),
            panes: this._getPanesParameters(),
            axes: axes
        };
        if (!(null === options || void 0 === options ? void 0 : options.enabled)) return;
        if (this._crosshair) this._crosshair.update(options, parameters);
        else this._crosshair = new (0, $55jA4.Crosshair)(this._renderer, options, parameters, this._crosshairCursorGroup);
        this._crosshair.render();
    },
    _getCommonCanvas () {
        var commonCanvas;
        var { panes: panes } = this;
        for(var i = 0; i < panes.length; i += 1){
            var { canvas: canvas } = panes[i];
            if (!commonCanvas) commonCanvas = (0, $2oTOp.extend)({}, canvas);
            else {
                commonCanvas.right = canvas.right;
                commonCanvas.bottom = canvas.bottom;
            }
        }
        return commonCanvas;
    },
    _createPanesBackground () {
        var defaultBackgroundColor = this._themeManager.getOptions("commonPaneSettings").backgroundColor;
        var renderer = this._renderer;
        var rects = [];
        this._panesBackgroundGroup.clear();
        for(var i = 0; i < this.panes.length; i += 1){
            var backgroundColor = this.panes[i].backgroundColor || defaultBackgroundColor;
            if (!backgroundColor || "none" === backgroundColor) {
                rects.push(null);
                continue;
            }
            var rect = renderer.rect(0, 0, 0, 0).attr({
                fill: backgroundColor,
                "stroke-width": 0
            }).append(this._panesBackgroundGroup);
            rects.push(rect);
        }
        this.panesBackground = rects;
    },
    _fillPanesBackground () {
        (0, $8OLOW.each)(this.panes, (i, pane)=>{
            var bc = pane.borderCoords;
            if (null !== this.panesBackground[i]) this.panesBackground[i].attr({
                x: bc.left,
                y: bc.top,
                width: bc.width,
                height: bc.height
            });
        });
    },
    _calcPaneBorderCoords (pane) {
        var { canvas: canvas } = pane;
        var bc = pane.borderCoords = pane.borderCoords || {};
        bc.left = canvas.left;
        bc.top = canvas.top;
        bc.right = canvas.width - canvas.right;
        bc.bottom = canvas.height - canvas.bottom;
        bc.width = Math.max(bc.right - bc.left, 0);
        bc.height = Math.max(bc.bottom - bc.top, 0);
    },
    _drawPanesBorders (panesBorderOptions) {
        var rotated = this._isRotated();
        this._panesBorderGroup.linkRemove().clear();
        (0, $8OLOW.each)(this.panes, (i, pane)=>{
            var borderOptions = panesBorderOptions[pane.name];
            var attr = {
                fill: "none",
                stroke: borderOptions.color,
                "stroke-opacity": borderOptions.opacity,
                "stroke-width": borderOptions.width,
                dashStyle: borderOptions.dashStyle,
                "stroke-linecap": "square"
            };
            this._calcPaneBorderCoords(pane, rotated);
            if (!borderOptions.visible) return;
            var bc = pane.borderCoords;
            var segmentRectParams = (0, $5XaPR.prepareSegmentRectPoints)(bc.left, bc.top, bc.width, bc.height, borderOptions);
            this._renderer.path(segmentRectParams.points, segmentRectParams.pathType).attr(attr).append(this._panesBorderGroup);
        });
        this._panesBorderGroup.linkAppend();
    },
    _createClipRect (clipArray, index, left, top, width, height) {
        var clipRect = clipArray[index];
        if (!clipRect) {
            clipRect = this._renderer.clipRect(left, top, width, height);
            clipArray[index] = clipRect;
        } else clipRect.attr({
            x: left,
            y: top,
            width: width,
            height: height
        });
    },
    _createClipRectsForPanes () {
        var canvas = this._canvas;
        (0, $8OLOW.each)(this.panes, (i, pane)=>{
            var needWideClipRect = false;
            var bc = pane.borderCoords;
            var { left: left } = bc;
            var { top: top } = bc;
            var { width: width } = bc;
            var { height: height } = bc;
            var panesClipRects = this._panesClipRects;
            this._createClipRect(panesClipRects.fixed, i, left, top, width, height);
            this._createClipRect(panesClipRects.base, i, left, top, width, height);
            (0, $8OLOW.each)(this.series, (_, series)=>{
                if (series.pane === pane.name && (series.isFinancialSeries() || series.areErrorBarsVisible())) needWideClipRect = true;
            });
            if (needWideClipRect) {
                if (this._isRotated()) {
                    top = 0;
                    height = canvas.height;
                } else {
                    left = 0;
                    width = canvas.width;
                }
                this._createClipRect(panesClipRects.wide, i, left, top, width, height);
            } else panesClipRects.wide[i] = null;
        });
    },
    _applyClipRectsForAxes () {
        var axes = this._getAllAxes();
        var chartCanvasClipRectID = this._getCanvasClipRectID();
        for(var i = 0; i < axes.length; i += 1){
            var elementsClipRectID = this._getElementsClipRectID(axes[i].pane);
            axes[i].applyClipRects(elementsClipRectID, chartCanvasClipRectID);
        }
    },
    _getPaneBorderVisibility (paneIndex) {
        var _a;
        var commonPaneBorderVisible = this._themeManager.getOptions("commonPaneSettings").border.visible;
        var pane = this.panes[paneIndex];
        var paneVisibility = null === (_a = null === pane || void 0 === pane ? void 0 : pane.border) || void 0 === _a ? void 0 : _a.visible;
        return void 0 === paneVisibility ? commonPaneBorderVisible : paneVisibility;
    },
    _getCanvasForPane (paneName) {
        var _a;
        return null === (_a = this.panes.find((pane)=>pane.name === paneName)) || void 0 === _a ? void 0 : _a.canvas;
    },
    _getTrackerSettings () {
        return (0, $2oTOp.extend)(this.callBase(), {
            chart: this,
            rotated: this._isRotated(),
            crosshair: this._getCrosshairOptions().enabled ? this._crosshair : null,
            stickyHovering: this._themeManager.getOptions("stickyHovering")
        });
    },
    _resolveLabelOverlappingStack () {
        var isRotated = this._isRotated();
        var shiftDirection = isRotated ? (box, length)=>({
                x: box.x - length,
                y: box.y
            }) : (box, length)=>({
                x: box.x,
                y: box.y - length
            });
        var processor = (a, b)=>{
            var coordPosition = isRotated ? 1 : 0;
            var figureCenter1 = a.labels[0].getFigureCenter()[coordPosition];
            var figureCenter12 = b.labels[0].getFigureCenter()[coordPosition];
            if (figureCenter1 - figureCenter12 === 0) {
                var translator = a.labels[0].getPoint().series.getValueAxis().getTranslator();
                var direction = translator.isInverted() ? -1 : 1;
                return (a.value() - b.value()) * direction;
            }
            return 0;
        };
        (0, $8OLOW.each)(this._getStackPoints(), (_, stacks)=>{
            (0, $8OLOW.each)(stacks, (_, points)=>{
                var isInverted = points[0].series.getValueAxis().getOptions().inverted;
                (0, $7MSPx.overlapping).resolveLabelOverlappingInOneDirection(points, this._getCommonCanvas(), isRotated, isInverted, shiftDirection, processor);
            });
        });
    },
    _getStackPoints () {
        var stackPoints = {};
        var visibleSeries = this._getVisibleSeries();
        (0, $8OLOW.each)(visibleSeries, (_, singleSeries)=>{
            var points = singleSeries.getPoints();
            var stackName = singleSeries.getStackName() || null;
            (0, $8OLOW.each)(points, (_, point)=>{
                var { argument: argument } = point;
                if (!stackPoints[argument]) stackPoints[argument] = {};
                if (!stackPoints[argument][stackName]) stackPoints[argument][stackName] = [];
                stackPoints[argument][stackName].push(point);
            });
        });
        return stackPoints;
    },
    _getCrosshairOptions () {
        return this._getOption("crosshair");
    },
    zoomArgument (min, max) {
        if (!this._initialized || !(0, $6ntMu.isDefined)(min) && !(0, $6ntMu.isDefined)(max)) return;
        this.getArgumentAxis().visualRange([
            min,
            max
        ]);
    },
    resetVisualRange () {
        var axes = this._argumentAxes;
        var nonVirtualArgumentAxis = this.getArgumentAxis();
        axes.forEach((axis)=>{
            axis.resetVisualRange(nonVirtualArgumentAxis !== axis);
            this._applyCustomVisualRangeOption(axis);
        });
        this.callBase();
    },
    getVisibleArgumentBounds () {
        var translator = this._argumentAxes[0].getTranslator();
        var range = translator.getBusinessRange();
        var isDiscrete = range.axisType === $72bde3bcd4253ecb$var$DISCRETE;
        var { categories: categories } = range;
        return {
            minVisible: isDiscrete ? range.minVisible || categories[0] : range.minVisible,
            maxVisible: isDiscrete ? range.maxVisible || categories[categories.length - 1] : range.maxVisible
        };
    },
    _change_FULL_RENDER () {
        this.callBase();
        if (this._changes.has($72bde3bcd4253ecb$var$VISUAL_RANGE)) this._raiseZoomEndHandlers();
    },
    _getAxesForScaling () {
        return [
            this.getArgumentAxis()
        ].concat(this._valueAxes);
    },
    _applyVisualRangeByVirtualAxes (axis, range) {
        if (axis.isArgumentAxis) {
            if (axis !== this.getArgumentAxis()) return true;
            this._argumentAxes.filter((a)=>a !== axis).forEach((a)=>a.visualRange(range, {
                    start: true,
                    end: true
                }));
        }
        return false;
    },
    _raiseZoomEndHandlers () {
        this._argumentAxes.forEach((axis)=>axis.handleZoomEnd());
        this.callBase();
    },
    _setOptionsByReference () {
        this.callBase();
        (0, $2oTOp.extend)(this._optionsByReference, {
            "argumentAxis.visualRange": true
        });
    },
    option () {
        var option = this.callBase(...arguments);
        var valueAxis = this._options.silent("valueAxis");
        if ("array" === (0, $6ntMu.type)(valueAxis)) for(var i = 0; i < valueAxis.length; i += 1){
            var optionPath = "valueAxis[".concat(i, "].visualRange");
            this._optionsByReference[optionPath] = true;
        }
        return option;
    },
    _notifyVisualRange () {
        var argAxis = this._argumentAxes[0];
        var argumentVisualRange = (0, $dw9tZ.convertVisualRangeObject)(argAxis.visualRange(), !$72bde3bcd4253ecb$var$isArray(this.option("argumentAxis.visualRange")));
        if (!argAxis.skipEventRising || !(0, $dw9tZ.rangesAreEqual)(argumentVisualRange, this.option("argumentAxis.visualRange"))) this.option("argumentAxis.visualRange", argumentVisualRange);
        else argAxis.skipEventRising = null;
        this.callBase();
    }
});
$72bde3bcd4253ecb$var$dxChart.addPlugin((0, $6V66N.default));
$72bde3bcd4253ecb$var$dxChart.addPlugin((0, $j4RF2.default));
$72bde3bcd4253ecb$var$dxChart.addPlugin((0, $cYTj1.plugins).core);
$72bde3bcd4253ecb$var$dxChart.addPlugin((0, $cYTj1.plugins).chart);
(0, $9UmiO.default)("dxChart", $72bde3bcd4253ecb$var$dxChart);
var $72bde3bcd4253ecb$export$2e2bcd8739ae039 = $72bde3bcd4253ecb$var$dxChart;

});
parcelRegister("55jA4", function(module, exports) {

$parcel$export(module.exports, "getMargins", function () { return $3b3c9bb4c2d744d6$export$8068c832b814dfb0; });
$parcel$export(module.exports, "Crosshair", function () { return $3b3c9bb4c2d744d6$export$2a195a185c8aa9e; });
/**
 * DevExtreme (esm/viz/chart_components/crosshair.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $dw9tZ = parcelRequire("dw9tZ");

var $2oTOp = parcelRequire("2oTOp");
var $3b3c9bb4c2d744d6$var$math = Math;
var $3b3c9bb4c2d744d6$var$mathAbs = $3b3c9bb4c2d744d6$var$math.abs;
var $3b3c9bb4c2d744d6$var$mathMin = $3b3c9bb4c2d744d6$var$math.min;
var $3b3c9bb4c2d744d6$var$mathMax = $3b3c9bb4c2d744d6$var$math.max;
var $3b3c9bb4c2d744d6$var$mathFloor = $3b3c9bb4c2d744d6$var$math.floor;
var $3b3c9bb4c2d744d6$var$HORIZONTAL = "horizontal";
var $3b3c9bb4c2d744d6$var$VERTICAL = "vertical";
var $3b3c9bb4c2d744d6$var$LABEL_BACKGROUND_PADDING_X = 8;
var $3b3c9bb4c2d744d6$var$LABEL_BACKGROUND_PADDING_Y = 4;
var $3b3c9bb4c2d744d6$var$CENTER = "center";
var $3b3c9bb4c2d744d6$var$RIGHT = "right";
var $3b3c9bb4c2d744d6$var$LEFT = "left";
var $3b3c9bb4c2d744d6$var$TOP = "top";
var $3b3c9bb4c2d744d6$var$BOTTOM = "bottom";
function $3b3c9bb4c2d744d6$export$8068c832b814dfb0() {
    return {
        x: $3b3c9bb4c2d744d6$var$LABEL_BACKGROUND_PADDING_X,
        y: $3b3c9bb4c2d744d6$var$LABEL_BACKGROUND_PADDING_Y
    };
}
function $3b3c9bb4c2d744d6$var$getRectangleBBox(bBox) {
    return {
        x: bBox.x - $3b3c9bb4c2d744d6$var$LABEL_BACKGROUND_PADDING_X,
        y: bBox.y - $3b3c9bb4c2d744d6$var$LABEL_BACKGROUND_PADDING_Y,
        width: bBox.width + 2 * $3b3c9bb4c2d744d6$var$LABEL_BACKGROUND_PADDING_X,
        height: bBox.height + 2 * $3b3c9bb4c2d744d6$var$LABEL_BACKGROUND_PADDING_Y
    };
}
function $3b3c9bb4c2d744d6$var$getLabelCheckerPosition(x, y, isHorizontal, canvas) {
    var params = isHorizontal ? [
        "x",
        "width",
        "y",
        "height",
        y,
        0
    ] : [
        "y",
        "height",
        "x",
        "width",
        x,
        1
    ];
    return function(bBox, position, coord) {
        var labelCoord = {
            x: coord.x,
            y: coord.y
        };
        var rectangleBBox = $3b3c9bb4c2d744d6$var$getRectangleBBox(bBox);
        var delta = isHorizontal ? coord.y - bBox.y - bBox.height / 2 : coord.y - bBox.y;
        labelCoord.y = isHorizontal || !isHorizontal && position === $3b3c9bb4c2d744d6$var$BOTTOM ? coord.y + delta : coord.y;
        if (rectangleBBox[params[0]] < 0) labelCoord[params[0]] -= rectangleBBox[params[0]];
        else if (rectangleBBox[params[0]] + rectangleBBox[params[1]] + delta * params[5] > canvas[params[1]]) labelCoord[params[0]] -= rectangleBBox[params[0]] + rectangleBBox[params[1]] + delta * params[5] - canvas[params[1]];
        if (params[4] - rectangleBBox[params[3]] / 2 < 0) labelCoord[params[2]] -= params[4] - rectangleBBox[params[3]] / 2;
        else if (params[4] + rectangleBBox[params[3]] / 2 > canvas[params[3]]) labelCoord[params[2]] -= params[4] + rectangleBBox[params[3]] / 2 - canvas[params[3]];
        return labelCoord;
    };
}
function $3b3c9bb4c2d744d6$export$2a195a185c8aa9e(renderer, options, params, group) {
    this._renderer = renderer;
    this._crosshairGroup = group;
    this._options = {};
    this.update(options, params);
}
$3b3c9bb4c2d744d6$export$2a195a185c8aa9e.prototype = {
    constructor: $3b3c9bb4c2d744d6$export$2a195a185c8aa9e,
    update: function(options, params) {
        var canvas = params.canvas;
        this._canvas = {
            top: canvas.top,
            bottom: canvas.height - canvas.bottom,
            left: canvas.left,
            right: canvas.width - canvas.right,
            width: canvas.width,
            height: canvas.height
        };
        this._axes = params.axes;
        this._panes = params.panes;
        this._prepareOptions(options, $3b3c9bb4c2d744d6$var$HORIZONTAL);
        this._prepareOptions(options, $3b3c9bb4c2d744d6$var$VERTICAL);
    },
    dispose: function() {
        this._renderer = this._crosshairGroup = this._options = this._axes = this._canvas = this._horizontalGroup = this._verticalGroup = this._horizontal = this._vertical = this._circle = this._panes = null;
    },
    _prepareOptions: function(options, direction) {
        var lineOptions = options[direction + "Line"];
        this._options[direction] = {
            visible: lineOptions.visible,
            line: {
                stroke: lineOptions.color || options.color,
                "stroke-width": lineOptions.width || options.width,
                dashStyle: lineOptions.dashStyle || options.dashStyle,
                opacity: lineOptions.opacity || options.opacity,
                "stroke-linecap": "butt"
            },
            label: (0, $2oTOp.extend)(true, {}, options.label, lineOptions.label)
        };
    },
    _createLines: function(options, sharpParam, group) {
        var lines = [];
        var canvas = this._canvas;
        var points = [
            canvas.left,
            canvas.top,
            canvas.left,
            canvas.top
        ];
        for(var i = 0; i < 2; i++)lines.push(this._renderer.path(points, "line").attr(options).sharp(sharpParam).append(group));
        return lines;
    },
    render: function() {
        var renderer = this._renderer;
        var options = this._options;
        var verticalOptions = options.vertical;
        var horizontalOptions = options.horizontal;
        var extraOptions = horizontalOptions.visible ? horizontalOptions.line : verticalOptions.line;
        var circleOptions = {
            stroke: extraOptions.stroke,
            "stroke-width": extraOptions["stroke-width"],
            dashStyle: extraOptions.dashStyle,
            opacity: extraOptions.opacity
        };
        var canvas = this._canvas;
        this._horizontal = {};
        this._vertical = {};
        this._circle = renderer.circle(canvas.left, canvas.top, 0).attr(circleOptions).append(this._crosshairGroup);
        this._horizontalGroup = renderer.g().append(this._crosshairGroup);
        this._verticalGroup = renderer.g().append(this._crosshairGroup);
        if (verticalOptions.visible) {
            this._vertical.lines = this._createLines(verticalOptions.line, "h", this._verticalGroup);
            this._vertical.labels = this._createLabels(this._axes[0], verticalOptions, false, this._verticalGroup);
        }
        if (horizontalOptions.visible) {
            this._horizontal.lines = this._createLines(horizontalOptions.line, "v", this._horizontalGroup);
            this._horizontal.labels = this._createLabels(this._axes[1], horizontalOptions, true, this._horizontalGroup);
        }
        this.hide();
    },
    _createLabels: function(axes, options, isHorizontal, group) {
        var canvas = this._canvas;
        var renderer = this._renderer;
        var x;
        var y;
        var text;
        var labels = [];
        var background;
        var currentLabelPos;
        var labelOptions = options.label;
        if (labelOptions.visible) axes.forEach(function(axis) {
            var position = axis.getOptions().position;
            if (axis.getTranslator().getBusinessRange().isEmpty()) return;
            currentLabelPos = axis.getLabelsPosition();
            if (isHorizontal) {
                y = canvas.top;
                x = currentLabelPos;
            } else {
                x = canvas.left;
                y = currentLabelPos;
            }
            var align = position === $3b3c9bb4c2d744d6$var$TOP || position === $3b3c9bb4c2d744d6$var$BOTTOM ? $3b3c9bb4c2d744d6$var$CENTER : position === $3b3c9bb4c2d744d6$var$RIGHT ? $3b3c9bb4c2d744d6$var$LEFT : $3b3c9bb4c2d744d6$var$RIGHT;
            background = renderer.rect(0, 0, 0, 0).attr({
                fill: labelOptions.backgroundColor || options.line.stroke
            }).append(group);
            text = renderer.text("0", 0, 0).css((0, $dw9tZ.patchFontOptions)(options.label.font)).attr({
                align: align,
                class: labelOptions.cssClass
            }).append(group);
            labels.push({
                text: text,
                background: background,
                axis: axis,
                options: labelOptions,
                pos: {
                    coord: currentLabelPos,
                    side: position
                },
                startXY: {
                    x: x,
                    y: y
                }
            });
        });
        return labels;
    },
    _updateText: function(value, axisName, labels, point, func) {
        var that = this;
        labels.forEach(function(label) {
            var axis = label.axis;
            var coord = label.startXY;
            var textElement = label.text;
            var backgroundElement = label.background;
            var text = "";
            if (!axis.name || axis.name === axisName) text = axis.getFormattedValue(value, label.options, point);
            if (text) {
                textElement.attr({
                    text: text,
                    x: coord.x,
                    y: coord.y
                });
                textElement.attr(func(textElement.getBBox(), label.pos.side, coord));
                that._updateLinesCanvas(label);
                backgroundElement.attr($3b3c9bb4c2d744d6$var$getRectangleBBox(textElement.getBBox()));
            } else {
                textElement.attr({
                    text: ""
                });
                backgroundElement.attr({
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                });
            }
        });
    },
    hide: function() {
        this._crosshairGroup.attr({
            visibility: "hidden"
        });
    },
    _updateLinesCanvas: function(label) {
        var position = label.pos.side;
        var labelCoord = label.pos.coord;
        var coords = this._linesCanvas;
        var canvas = this._canvas;
        coords[position] = coords[position] !== canvas[position] && $3b3c9bb4c2d744d6$var$mathAbs(coords[position] - canvas[position]) < $3b3c9bb4c2d744d6$var$mathAbs(labelCoord - canvas[position]) ? coords[position] : labelCoord;
    },
    _updateLines: function(lines, x, y, r, isHorizontal) {
        var coords = this._linesCanvas;
        var canvas = this._canvas;
        var points = isHorizontal ? [
            [
                $3b3c9bb4c2d744d6$var$mathMin(x - r, coords.left),
                canvas.top,
                x - r,
                canvas.top
            ],
            [
                x + r,
                canvas.top,
                $3b3c9bb4c2d744d6$var$mathMax(coords.right, x + r),
                canvas.top
            ]
        ] : [
            [
                canvas.left,
                $3b3c9bb4c2d744d6$var$mathMin(coords.top, y - r),
                canvas.left,
                y - r
            ],
            [
                canvas.left,
                y + r,
                canvas.left,
                $3b3c9bb4c2d744d6$var$mathMax(coords.bottom, y + r)
            ]
        ];
        for(var i = 0; i < 2; i++)lines[i].attr({
            points: points[i]
        }).sharp(isHorizontal ? "v" : "h", isHorizontal ? y === canvas.bottom ? -1 : 1 : x === canvas.right ? -1 : 1);
    },
    _resetLinesCanvas: function() {
        var canvas = this._canvas;
        this._linesCanvas = {
            left: canvas.left,
            right: canvas.right,
            top: canvas.top,
            bottom: canvas.bottom
        };
    },
    _getClipRectForPane: function(x, y) {
        var panes = this._panes;
        var i;
        var coords;
        for(i = 0; i < panes.length; i++){
            coords = panes[i].coords;
            if (coords.left <= x && coords.right >= x && coords.top <= y && coords.bottom >= y) return panes[i].clipRect;
        }
        return {
            id: null
        };
    },
    show: function(data) {
        var point = data.point;
        var pointData = point.getCrosshairData(data.x, data.y);
        var r = point.getPointRadius();
        var horizontal = this._horizontal;
        var vertical = this._vertical;
        var rad = !r ? 0 : r + 3;
        var canvas = this._canvas;
        var x = $3b3c9bb4c2d744d6$var$mathFloor(pointData.x);
        var y = $3b3c9bb4c2d744d6$var$mathFloor(pointData.y);
        if (x >= canvas.left && x <= canvas.right && y >= canvas.top && y <= canvas.bottom) {
            this._crosshairGroup.attr({
                visibility: "visible"
            });
            this._resetLinesCanvas();
            this._circle.attr({
                cx: x,
                cy: y,
                r: rad,
                "clip-path": this._getClipRectForPane(x, y).id
            });
            if (horizontal.lines) {
                this._updateText(pointData.yValue, pointData.axis, horizontal.labels, point, $3b3c9bb4c2d744d6$var$getLabelCheckerPosition(x, y, true, canvas));
                this._updateLines(horizontal.lines, x, y, rad, true);
                this._horizontalGroup.attr({
                    translateY: y - canvas.top
                });
            }
            if (vertical.lines) {
                this._updateText(pointData.xValue, pointData.axis, vertical.labels, point, $3b3c9bb4c2d744d6$var$getLabelCheckerPosition(x, y, false, canvas));
                this._updateLines(vertical.lines, x, y, rad, false);
                this._verticalGroup.attr({
                    translateX: x - canvas.left
                });
            }
        } else this.hide();
    }
};

});

parcelRegister("kSBht", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f335c4fa128732ac$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/chart_components/multi_axes_synchronizer.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ parcelRequire("9U2XG");

var $6ntMu = parcelRequire("6ntMu");

var $8OLOW = parcelRequire("8OLOW");

var $dw9tZ = parcelRequire("dw9tZ");

var $laqiS = parcelRequire("laqiS");
var $f335c4fa128732ac$var$_math = Math;
var $f335c4fa128732ac$var$_floor = $f335c4fa128732ac$var$_math.floor;
var $f335c4fa128732ac$var$_max = $f335c4fa128732ac$var$_math.max;
var $f335c4fa128732ac$var$_abs = $f335c4fa128732ac$var$_math.abs;
function $f335c4fa128732ac$var$getValueAxesPerPanes(valueAxes) {
    var result = {};
    valueAxes.forEach((axis)=>{
        var pane = axis.pane;
        if (!result[pane]) result[pane] = [];
        result[pane].push(axis);
    });
    return result;
}
var $f335c4fa128732ac$var$linearConverter = (br)=>({
        transform: function(v, b) {
            return (0, $laqiS.adjust)((0, $dw9tZ.getLogExt)(v, b, br.allowNegatives, br.linearThreshold));
        },
        getTicks: function(interval, tickValues, base) {
            var ticks = [];
            var tick = this.transform(tickValues[0], base);
            while(ticks.length < tickValues.length){
                ticks.push(tick);
                tick = (0, $laqiS.adjust)(tick + interval);
            }
            return ticks;
        }
    });
var $f335c4fa128732ac$var$logConverter = (br)=>({
        transform: function(v, b) {
            return (0, $laqiS.adjust)((0, $dw9tZ.raiseToExt)(v, b, br.allowNegatives, br.linearThreshold));
        },
        getTicks: function(interval, tickValues, base) {
            var ticks = [];
            var tick;
            for(var i = 0; i < tickValues.length; i += 1){
                tick = this.transform(tickValues[i], base);
                ticks.push(tick);
            }
            return ticks;
        }
    });
function $f335c4fa128732ac$var$convertAxisInfo(axisInfo, converter) {
    if (!axisInfo.isLogarithmic) return;
    var base = axisInfo.logarithmicBase;
    var tickValues = axisInfo.tickValues;
    axisInfo.minValue = converter.transform(axisInfo.minValue, base);
    axisInfo.oldMinValue = converter.transform(axisInfo.oldMinValue, base);
    axisInfo.maxValue = converter.transform(axisInfo.maxValue, base);
    axisInfo.oldMaxValue = converter.transform(axisInfo.oldMaxValue, base);
    axisInfo.tickInterval = $f335c4fa128732ac$var$_math.round(axisInfo.tickInterval);
    if (axisInfo.tickInterval < 1) axisInfo.tickInterval = 1;
    var ticks = converter.getTicks(axisInfo.tickInterval, tickValues, base);
    ticks.tickInterval = axisInfo.tickInterval;
    axisInfo.tickValues = ticks;
}
function $f335c4fa128732ac$var$populateAxesInfo(axes) {
    return axes.reduce(function(result, axis) {
        var ticksValues = axis.getTicksValues();
        var majorTicks = ticksValues.majorTicksValues;
        var options = axis.getOptions();
        var businessRange = axis.getTranslator().getBusinessRange();
        var visibleArea = axis.getVisibleArea();
        var axisInfo;
        var tickInterval = axis._tickInterval;
        var synchronizedValue = options.synchronizedValue;
        var action = axis.getViewport().action;
        if (majorTicks && majorTicks.length > 0 && (0, $6ntMu.isNumeric)(majorTicks[0]) && "discrete" !== options.type && !businessRange.isEmpty() && !(businessRange.breaks && businessRange.breaks.length) && "zoom" !== action && "pan" !== action) {
            axis.applyMargins();
            var startValue = axis.getTranslator().from(visibleArea[0]);
            var endValue = axis.getTranslator().from(visibleArea[1]);
            var minValue = startValue < endValue ? startValue : endValue;
            var maxValue = startValue < endValue ? endValue : startValue;
            if (minValue === maxValue && (0, $6ntMu.isDefined)(synchronizedValue)) {
                tickInterval = $f335c4fa128732ac$var$_abs(majorTicks[0] - synchronizedValue) || 1;
                minValue = majorTicks[0] - tickInterval;
                maxValue = majorTicks[0] + tickInterval;
            }
            axisInfo = {
                axis: axis,
                isLogarithmic: "logarithmic" === options.type,
                logarithmicBase: businessRange.base,
                tickValues: majorTicks,
                minorValues: ticksValues.minorTicksValues,
                minorTickInterval: axis._minorTickInterval,
                minValue: minValue,
                oldMinValue: minValue,
                maxValue: maxValue,
                oldMaxValue: maxValue,
                inverted: businessRange.invert,
                tickInterval: tickInterval,
                synchronizedValue: synchronizedValue
            };
            $f335c4fa128732ac$var$convertAxisInfo(axisInfo, $f335c4fa128732ac$var$linearConverter(axis.getTranslator().getBusinessRange()));
            result.push(axisInfo);
        }
        return result;
    }, []);
}
function $f335c4fa128732ac$var$updateTickValues(axesInfo) {
    var maxTicksCount = axesInfo.reduce((max, axisInfo)=>$f335c4fa128732ac$var$_max(max, axisInfo.tickValues.length), 0);
    axesInfo.forEach((axisInfo)=>{
        var ticksMultiplier;
        var ticksCount;
        var additionalStartTicksCount = 0;
        var synchronizedValue = axisInfo.synchronizedValue;
        var tickValues = axisInfo.tickValues;
        var tickInterval = axisInfo.tickInterval;
        if ((0, $6ntMu.isDefined)(synchronizedValue)) {
            axisInfo.baseTickValue = axisInfo.invertedBaseTickValue = synchronizedValue;
            axisInfo.tickValues = [
                axisInfo.baseTickValue
            ];
        } else {
            if (tickValues.length > 1 && tickInterval) {
                ticksMultiplier = $f335c4fa128732ac$var$_floor((maxTicksCount + 1) / tickValues.length);
                ticksCount = ticksMultiplier > 1 ? $f335c4fa128732ac$var$_floor((maxTicksCount + 1) / ticksMultiplier) : maxTicksCount;
                additionalStartTicksCount = $f335c4fa128732ac$var$_floor((ticksCount - tickValues.length) / 2);
                while(additionalStartTicksCount > 0 && 0 !== tickValues[0]){
                    tickValues.unshift((0, $laqiS.adjust)(tickValues[0] - tickInterval));
                    additionalStartTicksCount--;
                }
                while(tickValues.length < ticksCount)tickValues.push((0, $laqiS.adjust)(tickValues[tickValues.length - 1] + tickInterval));
                axisInfo.tickInterval = tickInterval / ticksMultiplier;
            }
            axisInfo.baseTickValue = tickValues[0];
            axisInfo.invertedBaseTickValue = tickValues[tickValues.length - 1];
        }
    });
}
function $f335c4fa128732ac$var$getAxisRange(axisInfo) {
    return axisInfo.maxValue - axisInfo.minValue || 1;
}
function $f335c4fa128732ac$var$getMainAxisInfo(axesInfo) {
    for(var i = 0; i < axesInfo.length; i++){
        if (!axesInfo[i].stubData) return axesInfo[i];
    }
    return null;
}
function $f335c4fa128732ac$var$correctMinMaxValues(axesInfo) {
    var mainAxisInfo = $f335c4fa128732ac$var$getMainAxisInfo(axesInfo);
    var mainAxisInfoTickInterval = mainAxisInfo.tickInterval;
    axesInfo.forEach((axisInfo)=>{
        var scale;
        var move;
        var mainAxisBaseValueOffset;
        var valueFromAxisInfo;
        if (axisInfo !== mainAxisInfo) {
            if (mainAxisInfoTickInterval && axisInfo.tickInterval) {
                if (axisInfo.stubData && (0, $6ntMu.isDefined)(axisInfo.synchronizedValue)) {
                    axisInfo.oldMinValue = axisInfo.minValue = axisInfo.baseTickValue - (mainAxisInfo.baseTickValue - mainAxisInfo.minValue) / mainAxisInfoTickInterval * axisInfo.tickInterval;
                    axisInfo.oldMaxValue = axisInfo.maxValue = axisInfo.baseTickValue - (mainAxisInfo.baseTickValue - mainAxisInfo.maxValue) / mainAxisInfoTickInterval * axisInfo.tickInterval;
                }
                scale = mainAxisInfoTickInterval / $f335c4fa128732ac$var$getAxisRange(mainAxisInfo) / axisInfo.tickInterval * $f335c4fa128732ac$var$getAxisRange(axisInfo);
                axisInfo.maxValue = axisInfo.minValue + $f335c4fa128732ac$var$getAxisRange(axisInfo) / scale;
            }
            if (mainAxisInfo.inverted && !axisInfo.inverted || !mainAxisInfo.inverted && axisInfo.inverted) mainAxisBaseValueOffset = mainAxisInfo.maxValue - mainAxisInfo.invertedBaseTickValue;
            else mainAxisBaseValueOffset = mainAxisInfo.baseTickValue - mainAxisInfo.minValue;
            valueFromAxisInfo = $f335c4fa128732ac$var$getAxisRange(axisInfo);
            move = (mainAxisBaseValueOffset / $f335c4fa128732ac$var$getAxisRange(mainAxisInfo) - (axisInfo.baseTickValue - axisInfo.minValue) / valueFromAxisInfo) * valueFromAxisInfo;
            axisInfo.minValue -= move;
            axisInfo.maxValue -= move;
        }
    });
}
function $f335c4fa128732ac$var$calculatePaddings(axesInfo) {
    var minPadding;
    var maxPadding;
    var startPadding = 0;
    var endPadding = 0;
    axesInfo.forEach((axisInfo)=>{
        var inverted = axisInfo.inverted;
        minPadding = axisInfo.minValue > axisInfo.oldMinValue ? (axisInfo.minValue - axisInfo.oldMinValue) / $f335c4fa128732ac$var$getAxisRange(axisInfo) : 0;
        maxPadding = axisInfo.maxValue < axisInfo.oldMaxValue ? (axisInfo.oldMaxValue - axisInfo.maxValue) / $f335c4fa128732ac$var$getAxisRange(axisInfo) : 0;
        startPadding = $f335c4fa128732ac$var$_max(startPadding, inverted ? maxPadding : minPadding);
        endPadding = $f335c4fa128732ac$var$_max(endPadding, inverted ? minPadding : maxPadding);
    });
    return {
        start: startPadding,
        end: endPadding
    };
}
function $f335c4fa128732ac$var$correctMinMaxValuesByPaddings(axesInfo, paddings) {
    axesInfo.forEach((info)=>{
        var range = $f335c4fa128732ac$var$getAxisRange(info);
        var inverted = info.inverted;
        info.minValue = (0, $laqiS.adjust)(info.minValue - paddings[inverted ? "end" : "start"] * range);
        info.maxValue = (0, $laqiS.adjust)(info.maxValue + paddings[inverted ? "start" : "end"] * range);
    });
}
function $f335c4fa128732ac$var$updateTickValuesIfSynchronizedValueUsed(axesInfo) {
    var hasSynchronizedValue = false;
    axesInfo.forEach((info)=>{
        hasSynchronizedValue = hasSynchronizedValue || (0, $6ntMu.isDefined)(info.synchronizedValue);
    });
    axesInfo.forEach((info)=>{
        var tickInterval = info.tickInterval;
        var tickValues = info.tickValues;
        var maxValue = info.maxValue;
        var minValue = info.minValue;
        var tick;
        if (hasSynchronizedValue && tickInterval) {
            while((tick = (0, $laqiS.adjust)(tickValues[0] - tickInterval)) >= minValue)tickValues.unshift(tick);
            tick = tickValues[tickValues.length - 1];
            while((tick = (0, $laqiS.adjust)(tick + tickInterval)) <= maxValue)tickValues.push(tick);
        }
        while(tickValues[0] + tickInterval / 10 < minValue)tickValues.shift();
        while(tickValues[tickValues.length - 1] - tickInterval / 10 > maxValue)tickValues.pop();
    });
}
function $f335c4fa128732ac$var$applyMinMaxValues(axesInfo) {
    axesInfo.forEach((info)=>{
        var axis = info.axis;
        var range = axis.getTranslator().getBusinessRange();
        if (range.min === range.minVisible) range.min = info.minValue;
        if (range.max === range.maxVisible) range.max = info.maxValue;
        range.minVisible = info.minValue;
        range.maxVisible = info.maxValue;
        if (range.min > range.minVisible) range.min = range.minVisible;
        if (range.max < range.maxVisible) range.max = range.maxVisible;
        axis.getTranslator().updateBusinessRange(range);
        axis.setTicks({
            majorTicks: info.tickValues,
            minorTicks: info.minorValues
        });
    });
}
function $f335c4fa128732ac$var$correctAfterSynchronize(axesInfo) {
    var invalidAxisInfo = [];
    var correctValue;
    axesInfo.forEach((info)=>{
        if (info.oldMaxValue - info.oldMinValue === 0) invalidAxisInfo.push(info);
        else if (!(0, $6ntMu.isDefined)(correctValue) && !(0, $6ntMu.isDefined)(info.synchronizedValue)) correctValue = $f335c4fa128732ac$var$_abs((info.maxValue - info.minValue) / (info.tickValues[$f335c4fa128732ac$var$_floor(info.tickValues.length / 2)] - info.minValue || info.maxValue));
    });
    if (!(0, $6ntMu.isDefined)(correctValue)) return;
    invalidAxisInfo.forEach((info)=>{
        var firstTick = info.tickValues[0];
        var correctedTick = firstTick * correctValue;
        if (firstTick > 0) {
            info.maxValue = correctedTick;
            info.minValue = 0;
        } else if (firstTick < 0) {
            info.minValue = correctedTick;
            info.maxValue = 0;
        }
    });
}
function $f335c4fa128732ac$var$updateMinorTicks(axesInfo) {
    axesInfo.forEach(function(axisInfo) {
        if (!axisInfo.minorTickInterval) return;
        var ticks = [];
        var interval = axisInfo.minorTickInterval;
        var tickCount = axisInfo.tickInterval / interval - 1;
        for(var i = 1; i < axisInfo.tickValues.length; i++){
            var tick = axisInfo.tickValues[i - 1];
            for(var j = 0; j < tickCount; j++){
                tick += interval;
                ticks.push(tick);
            }
        }
        axisInfo.minorValues = ticks;
    });
}
function $f335c4fa128732ac$var$allAxesValuesOnSameSideFromZero(axesInfo) {
    var allPositive = true;
    var allNegative = true;
    axesInfo.forEach((axis)=>{
        if (axis.oldMinValue > 0 || axis.oldMaxValue > 0) allNegative = false;
        if (axis.oldMinValue < 0 || axis.oldMaxValue < 0) allPositive = false;
    });
    return allPositive || allNegative;
}
function $f335c4fa128732ac$var$correctPaddings(axesInfo, paddings) {
    if (!$f335c4fa128732ac$var$allAxesValuesOnSameSideFromZero(axesInfo)) return paddings;
    return axesInfo.reduce((prev, info)=>{
        var inverted = info.inverted;
        var { start: start, end: end } = info.axis.getCorrectedValuesToZero(info.minValue, info.maxValue);
        if ((0, $6ntMu.isDefined)(start) || (0, $6ntMu.isDefined)(end)) return inverted ? {
            start: prev.start,
            end: Math.min(prev.end, end)
        } : {
            start: Math.min(prev.start, start),
            end: prev.end
        };
        return prev;
    }, paddings);
}
var $f335c4fa128732ac$var$multiAxesSynchronizer = {
    synchronize: function(valueAxes) {
        (0, $8OLOW.each)($f335c4fa128732ac$var$getValueAxesPerPanes(valueAxes), function(_, axes) {
            var axesInfo;
            var paddings;
            if (axes.length > 1) {
                axesInfo = $f335c4fa128732ac$var$populateAxesInfo(axes);
                if (axesInfo.length < 2 || !$f335c4fa128732ac$var$getMainAxisInfo(axesInfo)) return;
                $f335c4fa128732ac$var$updateTickValues(axesInfo);
                $f335c4fa128732ac$var$correctMinMaxValues(axesInfo);
                paddings = $f335c4fa128732ac$var$calculatePaddings(axesInfo);
                paddings = $f335c4fa128732ac$var$correctPaddings(axesInfo, paddings);
                $f335c4fa128732ac$var$correctMinMaxValuesByPaddings(axesInfo, paddings);
                $f335c4fa128732ac$var$correctAfterSynchronize(axesInfo);
                $f335c4fa128732ac$var$updateTickValuesIfSynchronizedValueUsed(axesInfo);
                $f335c4fa128732ac$var$updateMinorTicks(axesInfo);
                axesInfo.forEach((info)=>{
                    $f335c4fa128732ac$var$convertAxisInfo(info, $f335c4fa128732ac$var$logConverter(info.axis.getTranslator().getBusinessRange()));
                });
                $f335c4fa128732ac$var$applyMinMaxValues(axesInfo);
            }
        });
    }
};
var $f335c4fa128732ac$export$2e2bcd8739ae039 = $f335c4fa128732ac$var$multiAxesSynchronizer;

});

parcelRegister("2bqSa", function(module, exports) {

$parcel$export(module.exports, "ScrollBar", function () { return $1971742f6389fbca$export$342551df3dea21fb; });
/**
 * DevExtreme (esm/viz/chart_components/scroll_bar.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $60GuF = parcelRequire("60GuF");

var $bcOMe = parcelRequire("bcOMe");

var $2oTOp = parcelRequire("2oTOp");

var $gkgW0 = parcelRequire("gkgW0");

var $6ntMu = parcelRequire("6ntMu");

var $gcp4g = parcelRequire("gcp4g");

var $bTgwK = parcelRequire("bTgwK");
var $1971742f6389fbca$var$_min = Math.min;
var $1971742f6389fbca$var$_max = Math.max;
var $1971742f6389fbca$var$MIN_SCROLL_BAR_SIZE = 2;
var $1971742f6389fbca$export$342551df3dea21fb = function(renderer, group) {
    this._translator = new (0, $gkgW0.Translator2D)({}, {}, {});
    this._scroll = renderer.rect().append(group);
    this._addEvents();
};
function $1971742f6389fbca$var$_getXCoord(canvas, pos, offset, width) {
    var x = 0;
    if ("right" === pos) x = canvas.width - canvas.right + offset;
    else if ("left" === pos) x = canvas.left - offset - width;
    return x;
}
function $1971742f6389fbca$var$_getYCoord(canvas, pos, offset, width) {
    var y = 0;
    if ("top" === pos) y = canvas.top - offset;
    else if ("bottom" === pos) y = canvas.height - canvas.bottom + width + offset;
    return y;
}
$1971742f6389fbca$export$342551df3dea21fb.prototype = {
    _addEvents: function() {
        var scrollElement = this._scroll.element;
        (0, $60GuF.default).on(scrollElement, (0, $bTgwK.start), (e)=>{
            (0, $bcOMe.fireEvent)({
                type: "dxc-scroll-start",
                originalEvent: e,
                target: scrollElement
            });
        });
        (0, $60GuF.default).on(scrollElement, (0, $bTgwK.move), (e)=>{
            var dX = -e.offset.x * this._scale;
            var dY = -e.offset.y * this._scale;
            var lx = this._offset - (this._layoutOptions.vertical ? dY : dX) / this._scale;
            this._applyPosition(lx, lx + this._translator.canvasLength / this._scale);
            (0, $bcOMe.fireEvent)({
                type: "dxc-scroll-move",
                originalEvent: e,
                target: scrollElement,
                offset: {
                    x: dX,
                    y: dY
                }
            });
        });
        (0, $60GuF.default).on(scrollElement, (0, $bTgwK.end), (e)=>{
            (0, $bcOMe.fireEvent)({
                type: "dxc-scroll-end",
                originalEvent: e,
                target: scrollElement,
                offset: {
                    x: -e.offset.x * this._scale,
                    y: -e.offset.y * this._scale
                }
            });
        });
    },
    update: function(options) {
        var position = options.position;
        var isVertical = options.rotated;
        var defaultPosition = isVertical ? "right" : "top";
        var secondaryPosition = isVertical ? "left" : "bottom";
        if (position !== defaultPosition && position !== secondaryPosition) position = defaultPosition;
        this._scroll.attr({
            rotate: !options.rotated ? -90 : 0,
            rotateX: 0,
            rotateY: 0,
            fill: options.color,
            width: options.width,
            opacity: options.opacity
        });
        this._layoutOptions = {
            width: options.width,
            offset: options.offset,
            vertical: isVertical,
            position: position
        };
        return this;
    },
    init: function(range, stick) {
        var isDiscrete = "discrete" === range.axisType;
        this._translateWithOffset = isDiscrete && !stick ? 1 : 0;
        this._translator.update((0, $2oTOp.extend)({}, range, {
            minVisible: null,
            maxVisible: null,
            visibleCategories: null
        }, isDiscrete && {
            min: null,
            max: null
        } || {}), this._canvas, {
            isHorizontal: !this._layoutOptions.vertical,
            stick: stick
        });
        return this;
    },
    getOptions: function() {
        return this._layoutOptions;
    },
    setPane: function(panes) {
        var position = this._layoutOptions.position;
        var pane;
        if ("left" === position || "top" === position) pane = panes[0];
        else pane = panes[panes.length - 1];
        this.pane = pane.name;
        return this;
    },
    updateSize: function(canvas) {
        this._canvas = (0, $2oTOp.extend)({}, canvas);
        var options = this._layoutOptions;
        var pos = options.position;
        var offset = options.offset;
        var width = options.width;
        this._scroll.attr({
            translateX: $1971742f6389fbca$var$_getXCoord(canvas, pos, offset, width),
            translateY: $1971742f6389fbca$var$_getYCoord(canvas, pos, offset, width)
        });
    },
    getMultipleAxesSpacing: function() {
        return 0;
    },
    estimateMargins: function() {
        return this.getMargins();
    },
    getMargins: function() {
        var options = this._layoutOptions;
        var margins = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        margins[options.position] = options.width + options.offset;
        return margins;
    },
    shift: function(margins) {
        var _that$_scroll$attr, _that$_scroll$attr2;
        var options = this._layoutOptions;
        var side = options.position;
        var isVertical = options.vertical;
        var attr = {
            translateX: null !== (_that$_scroll$attr = this._scroll.attr("translateX")) && void 0 !== _that$_scroll$attr ? _that$_scroll$attr : 0,
            translateY: null !== (_that$_scroll$attr2 = this._scroll.attr("translateY")) && void 0 !== _that$_scroll$attr2 ? _that$_scroll$attr2 : 0
        };
        var shift = margins[side];
        attr[isVertical ? "translateX" : "translateY"] += ("left" === side || "top" === side ? -1 : 1) * shift;
        this._scroll.attr(attr);
    },
    hideTitle: (0, $gcp4g.noop),
    hideOuterElements: (0, $gcp4g.noop),
    setPosition: function(min, max) {
        var translator = this._translator;
        var minPoint = (0, $6ntMu.isDefined)(min) ? translator.translate(min, -this._translateWithOffset) : translator.translate("canvas_position_start");
        var maxPoint = (0, $6ntMu.isDefined)(max) ? translator.translate(max, this._translateWithOffset) : translator.translate("canvas_position_end");
        this._offset = $1971742f6389fbca$var$_min(minPoint, maxPoint);
        this._scale = translator.getScale(min, max);
        this._applyPosition($1971742f6389fbca$var$_min(minPoint, maxPoint), $1971742f6389fbca$var$_max(minPoint, maxPoint));
    },
    customPositionIsAvailable: ()=>false,
    dispose: function() {
        this._scroll.dispose();
        this._scroll = this._translator = null;
    },
    _applyPosition: function(x1, x2) {
        var visibleArea = this._translator.getCanvasVisibleArea();
        x1 = $1971742f6389fbca$var$_max(x1, visibleArea.min);
        x1 = $1971742f6389fbca$var$_min(x1, visibleArea.max);
        x2 = $1971742f6389fbca$var$_min(x2, visibleArea.max);
        x2 = $1971742f6389fbca$var$_max(x2, visibleArea.min);
        var height = Math.abs(x2 - x1);
        this._scroll.attr({
            y: x1,
            height: height < $1971742f6389fbca$var$MIN_SCROLL_BAR_SIZE ? $1971742f6389fbca$var$MIN_SCROLL_BAR_SIZE : height
        });
    }
};

});
parcelRegister("gkgW0", function(module, exports) {

$parcel$export(module.exports, "Translator2D", function () { return $be2ba670007d27ff$export$6ebc39d67c503536; });
/**
 * DevExtreme (esm/viz/translators/translator2d.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $4jhWa = parcelRequire("4jhWa");

var $lYlNM = parcelRequire("lYlNM");

var $jZFhH = parcelRequire("jZFhH");

var $2Ftnl = parcelRequire("2Ftnl");

var $kD4rh = parcelRequire("kD4rh");

var $dw9tZ = parcelRequire("dw9tZ");

var $6ntMu = parcelRequire("6ntMu");

var $laqiS = parcelRequire("laqiS");

var $f38Z1 = parcelRequire("f38Z1");
var $be2ba670007d27ff$var$_abs = Math.abs;
var $be2ba670007d27ff$var$CANVAS_PROP = [
    "width",
    "height",
    "left",
    "top",
    "bottom",
    "right"
];
var $be2ba670007d27ff$var$dummyTranslator = {
    to (value) {
        var coord = this._canvasOptions.startPoint + (this._options.conversionValue ? value : Math.round(value));
        return coord > this._canvasOptions.endPoint ? this._canvasOptions.endPoint : coord;
    },
    from (value) {
        return value - this._canvasOptions.startPoint;
    }
};
var $be2ba670007d27ff$var$validateCanvas = function(canvas) {
    (0, $8OLOW.each)($be2ba670007d27ff$var$CANVAS_PROP, function(_, prop) {
        canvas[prop] = parseInt(canvas[prop]) || 0;
    });
    return canvas;
};
var $be2ba670007d27ff$var$makeCategoriesToPoints = function(categories) {
    var categoriesToPoints = {};
    categories.forEach(function(item, i) {
        categoriesToPoints[item.valueOf()] = i;
    });
    return categoriesToPoints;
};
var $be2ba670007d27ff$var$validateBusinessRange = function(businessRange) {
    if (!(businessRange instanceof (0, $4jhWa.Range))) businessRange = new (0, $4jhWa.Range)(businessRange);
    function validate(valueSelector, baseValueSelector) {
        if (!(0, $6ntMu.isDefined)(businessRange[valueSelector]) && (0, $6ntMu.isDefined)(businessRange[baseValueSelector])) businessRange[valueSelector] = businessRange[baseValueSelector];
    }
    validate("minVisible", "min");
    validate("maxVisible", "max");
    return businessRange;
};
function $be2ba670007d27ff$var$prepareBreaks(breaks, range) {
    var transform = "logarithmic" === range.axisType ? function(value) {
        return (0, $dw9tZ.getLogExt)(value, range.base);
    } : function(value) {
        return value;
    };
    var array = [];
    var br;
    var transformFrom;
    var transformTo;
    var i;
    var length = breaks.length;
    var sum = 0;
    for(i = 0; i < length; i++){
        br = breaks[i];
        transformFrom = transform(br.from);
        transformTo = transform(br.to);
        sum += transformTo - transformFrom;
        array.push({
            trFrom: transformFrom,
            trTo: transformTo,
            from: br.from,
            to: br.to,
            length: sum,
            cumulativeWidth: br.cumulativeWidth
        });
    }
    return array;
}
function $be2ba670007d27ff$var$getCanvasBounds(range) {
    var min = range.min;
    var max = range.max;
    var minVisible = range.minVisible;
    var maxVisible = range.maxVisible;
    var isLogarithmic = "logarithmic" === range.axisType;
    if (isLogarithmic) {
        maxVisible = (0, $dw9tZ.getLogExt)(maxVisible, range.base, range.allowNegatives, range.linearThreshold);
        minVisible = (0, $dw9tZ.getLogExt)(minVisible, range.base, range.allowNegatives, range.linearThreshold);
        min = (0, $dw9tZ.getLogExt)(min, range.base, range.allowNegatives, range.linearThreshold);
        max = (0, $dw9tZ.getLogExt)(max, range.base, range.allowNegatives, range.linearThreshold);
    }
    return {
        base: range.base,
        rangeMin: min,
        rangeMax: max,
        rangeMinVisible: minVisible,
        rangeMaxVisible: maxVisible
    };
}
function $be2ba670007d27ff$var$getCheckingMethodsAboutBreaks(inverted) {
    return {
        isStartSide: !inverted ? function(pos, breaks, start, end) {
            return pos < breaks[0][start];
        } : function(pos, breaks, start, end) {
            return pos <= breaks[breaks.length - 1][end];
        },
        isEndSide: !inverted ? function(pos, breaks, start, end) {
            return pos >= breaks[breaks.length - 1][end];
        } : function(pos, breaks, start, end) {
            return pos > breaks[0][start];
        },
        isInBreak: !inverted ? function(pos, br, start, end) {
            return pos >= br[start] && pos < br[end];
        } : function(pos, br, start, end) {
            return pos > br[end] && pos <= br[start];
        },
        isBetweenBreaks: !inverted ? function(pos, br, prevBreak, start, end) {
            return pos < br[start] && pos >= prevBreak[end];
        } : function(pos, br, prevBreak, start, end) {
            return pos >= br[end] && pos < prevBreak[start];
        },
        getLength: !inverted ? function(br) {
            return br.length;
        } : function(br, lastBreak) {
            return lastBreak.length - br.length;
        },
        getBreaksSize: !inverted ? function(br) {
            return br.cumulativeWidth;
        } : function(br, lastBreak) {
            return lastBreak.cumulativeWidth - br.cumulativeWidth;
        }
    };
}
var $be2ba670007d27ff$export$6ebc39d67c503536 = function(businessRange, canvas, options) {
    this.update(businessRange, canvas, options);
};
$be2ba670007d27ff$export$6ebc39d67c503536.prototype = {
    constructor: $be2ba670007d27ff$export$6ebc39d67c503536,
    reinit: function() {
        var that = this;
        var options = that._options;
        var range = that._businessRange;
        var categories = range.categories || [];
        var script = {};
        var canvasOptions = that._prepareCanvasOptions();
        var visibleCategories = (0, $dw9tZ.getCategoriesInfo)(categories, range.minVisible, range.maxVisible).categories;
        var categoriesLength = visibleCategories.length;
        if (range.isEmpty()) script = $be2ba670007d27ff$var$dummyTranslator;
        else switch(range.axisType){
            case "logarithmic":
                script = (0, $kD4rh.default);
                break;
            case "semidiscrete":
                script = (0, $jZFhH.default);
                canvasOptions.ratioOfCanvasRange = canvasOptions.canvasLength / ((0, $f38Z1.default).addInterval(canvasOptions.rangeMaxVisible, options.interval) - canvasOptions.rangeMinVisible);
                break;
            case "discrete":
                script = (0, $lYlNM.default);
                that._categories = categories;
                canvasOptions.interval = that._getDiscreteInterval(options.addSpiderCategory ? categoriesLength + 1 : categoriesLength, canvasOptions);
                that._categoriesToPoints = $be2ba670007d27ff$var$makeCategoriesToPoints(categories);
                if (categoriesLength) {
                    canvasOptions.startPointIndex = that._categoriesToPoints[visibleCategories[0].valueOf()];
                    that.visibleCategories = visibleCategories;
                }
                break;
            default:
                if ("datetime" === range.dataType) script = (0, $2Ftnl.default);
        }
        (that._oldMethods || []).forEach(function(methodName) {
            delete that[methodName];
        });
        that._oldMethods = Object.keys(script);
        (0, $2oTOp.extend)(that, script);
        that._conversionValue = options.conversionValue ? (value)=>value : (value, skipRound)=>skipRound ? value : Math.round(value);
        that.sc = {};
        that._checkingMethodsAboutBreaks = [
            $be2ba670007d27ff$var$getCheckingMethodsAboutBreaks(false),
            $be2ba670007d27ff$var$getCheckingMethodsAboutBreaks(that.isInverted())
        ];
        that._translateBreaks();
        that._calculateSpecialValues();
    },
    _translateBreaks: function() {
        var breaks = this._breaks;
        var size = this._options.breaksSize;
        var i;
        var b;
        var end;
        var length;
        if (void 0 === breaks) return;
        for(i = 0, length = breaks.length; i < length; i++){
            b = breaks[i];
            end = this.translate(b.to);
            b.end = end;
            b.start = !b.gapSize ? !this.isInverted() ? end - size : end + size : end;
        }
    },
    _checkValueAboutBreaks: function(breaks, pos, start, end, methods) {
        var i;
        var length;
        var prop = {
            length: 0,
            breaksSize: void 0,
            inBreak: false
        };
        var br;
        var prevBreak;
        var lastBreak = breaks[breaks.length - 1];
        if (methods.isStartSide(pos, breaks, start, end)) return prop;
        else if (methods.isEndSide(pos, breaks, start, end)) return {
            length: lastBreak.length,
            breaksSize: lastBreak.cumulativeWidth,
            inBreak: false
        };
        for(i = 0, length = breaks.length; i < length; i++){
            br = breaks[i];
            prevBreak = breaks[i - 1];
            if (methods.isInBreak(pos, br, start, end)) {
                prop.inBreak = true;
                prop.break = br;
                break;
            }
            if (prevBreak && methods.isBetweenBreaks(pos, br, prevBreak, start, end)) {
                prop = {
                    length: methods.getLength(prevBreak, lastBreak),
                    breaksSize: methods.getBreaksSize(prevBreak, lastBreak),
                    inBreak: false
                };
                break;
            }
        }
        return prop;
    },
    isInverted: function() {
        return !(this._options.isHorizontal ^ this._businessRange.invert);
    },
    _getDiscreteInterval: function(categoriesLength, canvasOptions) {
        var correctedCategoriesCount = categoriesLength - (this._options.stick ? 1 : 0);
        return correctedCategoriesCount > 0 ? canvasOptions.canvasLength / correctedCategoriesCount : canvasOptions.canvasLength;
    },
    _prepareCanvasOptions () {
        var businessRange = this._businessRange;
        var canvasOptions = this._canvasOptions = $be2ba670007d27ff$var$getCanvasBounds(businessRange);
        var canvas = this._canvas;
        var breaks = this._breaks;
        var length;
        canvasOptions.startPadding = canvas.startPadding || 0;
        canvasOptions.endPadding = canvas.endPadding || 0;
        if (this._options.isHorizontal) {
            canvasOptions.startPoint = canvas.left + canvasOptions.startPadding;
            length = canvas.width;
            canvasOptions.endPoint = canvas.width - canvas.right - canvasOptions.endPadding;
            canvasOptions.invert = businessRange.invert;
        } else {
            canvasOptions.startPoint = canvas.top + canvasOptions.startPadding;
            length = canvas.height;
            canvasOptions.endPoint = canvas.height - canvas.bottom - canvasOptions.endPadding;
            canvasOptions.invert = !businessRange.invert;
        }
        this.canvasLength = canvasOptions.canvasLength = canvasOptions.endPoint - canvasOptions.startPoint;
        canvasOptions.rangeDoubleError = Math.pow(10, (0, $dw9tZ.getPower)(canvasOptions.rangeMax - canvasOptions.rangeMin) - (0, $dw9tZ.getPower)(length) - 2);
        canvasOptions.ratioOfCanvasRange = canvasOptions.canvasLength / (canvasOptions.rangeMaxVisible - canvasOptions.rangeMinVisible);
        if (void 0 !== breaks) canvasOptions.ratioOfCanvasRange = (canvasOptions.canvasLength - breaks[breaks.length - 1].cumulativeWidth) / (canvasOptions.rangeMaxVisible - canvasOptions.rangeMinVisible - breaks[breaks.length - 1].length);
        return canvasOptions;
    },
    updateCanvas: function(canvas) {
        this._canvas = $be2ba670007d27ff$var$validateCanvas(canvas);
        this.reinit();
    },
    updateBusinessRange: function(businessRange) {
        var breaks = businessRange.breaks || [];
        this._userBreaks = businessRange.userBreaks || [];
        this._businessRange = $be2ba670007d27ff$var$validateBusinessRange(businessRange);
        this._breaks = breaks.length ? $be2ba670007d27ff$var$prepareBreaks(breaks, this._businessRange) : void 0;
        this.reinit();
    },
    update: function(businessRange, canvas, options) {
        this._options = (0, $2oTOp.extend)(this._options || {}, options);
        this._canvas = $be2ba670007d27ff$var$validateCanvas(canvas);
        this.updateBusinessRange(businessRange);
    },
    getBusinessRange: function() {
        return this._businessRange;
    },
    getEventScale: function(zoomEvent) {
        return zoomEvent.deltaScale || 1;
    },
    getCanvasVisibleArea: function() {
        return {
            min: this._canvasOptions.startPoint,
            max: this._canvasOptions.endPoint
        };
    },
    _calculateSpecialValues: function() {
        var canvasOptions = this._canvasOptions;
        var startPoint = canvasOptions.startPoint - canvasOptions.startPadding;
        var endPoint = canvasOptions.endPoint + canvasOptions.endPadding;
        var range = this._businessRange;
        var minVisible = range.minVisible;
        var maxVisible = range.maxVisible;
        var canvas_position_center_middle = startPoint + canvasOptions.canvasLength / 2;
        var canvas_position_default;
        if (minVisible < 0 && maxVisible > 0 && minVisible !== maxVisible) canvas_position_default = this.translate(0, 1);
        if (!(0, $6ntMu.isDefined)(canvas_position_default)) {
            var invert = range.invert ^ (minVisible < 0 && maxVisible <= 0);
            if (this._options.isHorizontal) canvas_position_default = invert ? endPoint : startPoint;
            else canvas_position_default = invert ? startPoint : endPoint;
        }
        this.sc = {
            canvas_position_default: canvas_position_default,
            canvas_position_left: startPoint,
            canvas_position_top: startPoint,
            canvas_position_center: canvas_position_center_middle,
            canvas_position_middle: canvas_position_center_middle,
            canvas_position_right: endPoint,
            canvas_position_bottom: endPoint,
            canvas_position_start: canvasOptions.invert ? endPoint : startPoint,
            canvas_position_end: canvasOptions.invert ? startPoint : endPoint
        };
    },
    translateSpecialCase (value) {
        return this.sc[value];
    },
    _calculateProjection: function(distance) {
        var canvasOptions = this._canvasOptions;
        return canvasOptions.invert ? canvasOptions.endPoint - distance : canvasOptions.startPoint + distance;
    },
    _calculateUnProjection: function(distance) {
        var canvasOptions = this._canvasOptions;
        "datetime" === this._businessRange.dataType && (distance = Math.round(distance));
        return canvasOptions.invert ? canvasOptions.rangeMaxVisible.valueOf() - distance : canvasOptions.rangeMinVisible.valueOf() + distance;
    },
    getMinBarSize: function(minBarSize) {
        var visibleArea = this.getCanvasVisibleArea();
        var minValue = this.from(visibleArea.min + minBarSize);
        return $be2ba670007d27ff$var$_abs(this.from(visibleArea.min) - (!(0, $6ntMu.isDefined)(minValue) ? this.from(visibleArea.max) : minValue));
    },
    checkMinBarSize: function(value, minShownValue) {
        return $be2ba670007d27ff$var$_abs(value) < minShownValue ? value >= 0 ? minShownValue : -minShownValue : value;
    },
    translate (bp, direction, skipRound) {
        var specialValue = this.translateSpecialCase(bp);
        if ((0, $6ntMu.isDefined)(specialValue)) return Math.round(specialValue);
        if (isNaN(bp)) return null;
        return this.to(bp, direction, skipRound);
    },
    getInterval: function(interval) {
        var _interval;
        var canvasOptions = this._canvasOptions;
        interval = null !== (_interval = interval) && void 0 !== _interval ? _interval : this._businessRange.interval;
        if (interval) return Math.round(canvasOptions.ratioOfCanvasRange * interval);
        return Math.round(canvasOptions.endPoint - canvasOptions.startPoint);
    },
    zoom (translate, scale, wholeRange) {
        var canvasOptions = this._canvasOptions;
        if (canvasOptions.rangeMinVisible.valueOf() === canvasOptions.rangeMaxVisible.valueOf() && 0 !== translate) return this.zoomZeroLengthRange(translate, scale);
        var startPoint = canvasOptions.startPoint;
        var endPoint = canvasOptions.endPoint;
        var isInverted = this.isInverted();
        var newStart = (startPoint + translate) / scale;
        var newEnd = (endPoint + translate) / scale;
        wholeRange = wholeRange || {};
        var minPoint = this.to(isInverted ? wholeRange.endValue : wholeRange.startValue);
        var maxPoint = this.to(isInverted ? wholeRange.startValue : wholeRange.endValue);
        var min;
        var max;
        if (minPoint > newStart) {
            newEnd -= newStart - minPoint;
            newStart = minPoint;
            min = isInverted ? wholeRange.endValue : wholeRange.startValue;
        }
        if (maxPoint < newEnd) {
            newStart -= newEnd - maxPoint;
            newEnd = maxPoint;
            max = isInverted ? wholeRange.startValue : wholeRange.endValue;
        }
        if (maxPoint - minPoint < newEnd - newStart) {
            newStart = minPoint;
            newEnd = maxPoint;
        }
        translate = (endPoint - startPoint) * newStart / (newEnd - newStart) - startPoint;
        scale = (startPoint + translate) / newStart || 1;
        min = (0, $6ntMu.isDefined)(min) ? min : (0, $laqiS.adjust)(this.from(newStart, 1));
        max = (0, $6ntMu.isDefined)(max) ? max : (0, $laqiS.adjust)(this.from(newEnd, -1));
        if (scale <= 1) {
            min = this._correctValueAboutBreaks(min, 1 === scale ? translate : -1);
            max = this._correctValueAboutBreaks(max, 1 === scale ? translate : 1);
        }
        if (min > max) {
            min = min > wholeRange.endValue ? wholeRange.endValue : min;
            max = max < wholeRange.startValue ? wholeRange.startValue : max;
        } else {
            min = min < wholeRange.startValue ? wholeRange.startValue : min;
            max = max > wholeRange.endValue ? wholeRange.endValue : max;
        }
        return {
            min: min,
            max: max,
            translate: (0, $laqiS.adjust)(translate),
            scale: (0, $laqiS.adjust)(scale)
        };
    },
    _correctValueAboutBreaks (value, direction) {
        var br = this._userBreaks.filter((br)=>value >= br.from && value <= br.to);
        if (br.length) return direction > 0 ? br[0].to : br[0].from;
        else return value;
    },
    zoomZeroLengthRange (translate, scale) {
        var canvasOptions = this._canvasOptions;
        var min = canvasOptions.rangeMin;
        var max = canvasOptions.rangeMax;
        var correction = (max.valueOf() !== min.valueOf() ? max.valueOf() - min.valueOf() : $be2ba670007d27ff$var$_abs(canvasOptions.rangeMinVisible.valueOf() - min.valueOf())) / canvasOptions.canvasLength;
        var isDateTime = (0, $6ntMu.isDate)(max) || (0, $6ntMu.isDate)(min);
        var isLogarithmic = "logarithmic" === this._businessRange.axisType;
        var newMin = canvasOptions.rangeMinVisible.valueOf() - correction;
        var newMax = canvasOptions.rangeMaxVisible.valueOf() + correction;
        newMin = isLogarithmic ? (0, $laqiS.adjust)((0, $dw9tZ.raiseToExt)(newMin, canvasOptions.base)) : isDateTime ? new Date(newMin) : newMin;
        newMax = isLogarithmic ? (0, $laqiS.adjust)((0, $dw9tZ.raiseToExt)(newMax, canvasOptions.base)) : isDateTime ? new Date(newMax) : newMax;
        return {
            min: newMin,
            max: newMax,
            translate: translate,
            scale: scale
        };
    },
    getMinScale: function(zoom) {
        var { dataType: dataType, interval: interval } = this._businessRange;
        if ("datetime" === dataType && 1 === interval) return this.getDateTimeMinScale(zoom);
        return zoom ? 1.1 : .9;
    },
    getDateTimeMinScale (zoom) {
        var canvasOptions = this._canvasOptions;
        var length = canvasOptions.canvasLength / canvasOptions.ratioOfCanvasRange;
        length += (parseInt(.1 * length) || 1) * (zoom ? -2 : 2);
        return canvasOptions.canvasLength / (Math.max(length, 1) * canvasOptions.ratioOfCanvasRange);
    },
    getScale: function(val1, val2) {
        var canvasOptions = this._canvasOptions;
        if (canvasOptions.rangeMax === canvasOptions.rangeMin) return 1;
        val1 = (0, $6ntMu.isDefined)(val1) ? this.fromValue(val1) : canvasOptions.rangeMin;
        val2 = (0, $6ntMu.isDefined)(val2) ? this.fromValue(val2) : canvasOptions.rangeMax;
        return (canvasOptions.rangeMax - canvasOptions.rangeMin) / Math.abs(val1 - val2);
    },
    isValid: function(value) {
        var co = this._canvasOptions;
        value = this.fromValue(value);
        return null !== value && !isNaN(value) && value.valueOf() + co.rangeDoubleError >= co.rangeMin && value.valueOf() - co.rangeDoubleError <= co.rangeMax;
    },
    getCorrectValue: function(value, direction) {
        var breaks = this._breaks;
        var prop;
        value = this.fromValue(value);
        if (this._breaks) {
            prop = this._checkValueAboutBreaks(breaks, value, "trFrom", "trTo", this._checkingMethodsAboutBreaks[0]);
            if (true === prop.inBreak) return this.toValue(direction > 0 ? prop.break.trTo : prop.break.trFrom);
        }
        return this.toValue(value);
    },
    to: function(bp, direction, skipRound) {
        var range = this.getBusinessRange();
        if ((0, $6ntMu.isDefined)(range.maxVisible) && (0, $6ntMu.isDefined)(range.minVisible) && range.maxVisible.valueOf() === range.minVisible.valueOf()) {
            if (!(0, $6ntMu.isDefined)(bp) || range.maxVisible.valueOf() !== bp.valueOf()) return null;
            return this.translateSpecialCase(0 === bp && this._options.shiftZeroValue ? "canvas_position_default" : "canvas_position_middle");
        }
        bp = this.fromValue(bp);
        var canvasOptions = this._canvasOptions;
        var breaks = this._breaks;
        var prop = {
            length: 0
        };
        var commonBreakSize = 0;
        if (void 0 !== breaks) {
            prop = this._checkValueAboutBreaks(breaks, bp, "trFrom", "trTo", this._checkingMethodsAboutBreaks[0]);
            commonBreakSize = (0, $6ntMu.isDefined)(prop.breaksSize) ? prop.breaksSize : 0;
        }
        if (true === prop.inBreak) {
            if (direction > 0) return prop.break.start;
            else if (direction < 0) return prop.break.end;
            else return null;
        }
        return this._conversionValue(this._calculateProjection((bp - canvasOptions.rangeMinVisible - prop.length) * canvasOptions.ratioOfCanvasRange + commonBreakSize), skipRound);
    },
    from: function(pos, direction) {
        var breaks = this._breaks;
        var prop = {
            length: 0
        };
        var canvasOptions = this._canvasOptions;
        var startPoint = canvasOptions.startPoint;
        var commonBreakSize = 0;
        if (void 0 !== breaks) {
            prop = this._checkValueAboutBreaks(breaks, pos, "start", "end", this._checkingMethodsAboutBreaks[1]);
            commonBreakSize = (0, $6ntMu.isDefined)(prop.breaksSize) ? prop.breaksSize : 0;
        }
        if (true === prop.inBreak) {
            if (direction > 0) return this.toValue(prop.break.trTo);
            else if (direction < 0) return this.toValue(prop.break.trFrom);
            else return null;
        }
        return this.toValue(this._calculateUnProjection((pos - startPoint - commonBreakSize) / canvasOptions.ratioOfCanvasRange + prop.length));
    },
    isValueProlonged: false,
    getRange: function() {
        return [
            this.toValue(this._canvasOptions.rangeMin),
            this.toValue(this._canvasOptions.rangeMax)
        ];
    },
    getScreenRange: function() {
        return [
            this._canvasOptions.startPoint,
            this._canvasOptions.endPoint
        ];
    },
    add: function(value, diff, dir) {
        return this._add(value, diff, (this._businessRange.invert ? -1 : 1) * dir);
    },
    _add: function(value, diff, coeff) {
        return this.toValue(this.fromValue(value) + diff * coeff);
    },
    fromValue: function(value) {
        return null !== value ? Number(value) : null;
    },
    toValue: function(value) {
        return null !== value ? Number(value) : null;
    },
    ratioOfCanvasRange () {
        return this._canvasOptions.ratioOfCanvasRange;
    },
    convert: (value)=>value,
    getRangeByMinZoomValue (minZoom, visualRange) {
        if (visualRange.minVisible + minZoom <= this._businessRange.max) return [
            visualRange.minVisible,
            visualRange.minVisible + minZoom
        ];
        else return [
            visualRange.maxVisible - minZoom,
            visualRange.maxVisible
        ];
    }
};

});
parcelRegister("lYlNM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fff01cffd3eb83af$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/translators/category_translator.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $laqiS = parcelRequire("laqiS");
var $fff01cffd3eb83af$var$round = Math.round;
function $fff01cffd3eb83af$var$getValue(value) {
    return value;
}
var $fff01cffd3eb83af$export$2e2bcd8739ae039 = {
    translate: function(category, directionOffset) {
        var canvasOptions = this._canvasOptions;
        var categoryIndex = this._categoriesToPoints[null === category || void 0 === category ? void 0 : category.valueOf()];
        var specialValue = this.translateSpecialCase(category);
        var startPointIndex = canvasOptions.startPointIndex || 0;
        var stickInterval = this._options.stick ? 0 : .5;
        if ((0, $6ntMu.isDefined)(specialValue)) return $fff01cffd3eb83af$var$round(specialValue);
        if (!categoryIndex && 0 !== categoryIndex) return null;
        directionOffset = directionOffset || 0;
        var stickDelta = categoryIndex + stickInterval - startPointIndex + .5 * directionOffset;
        return $fff01cffd3eb83af$var$round(this._calculateProjection(canvasOptions.interval * stickDelta));
    },
    getInterval: function() {
        return this._canvasOptions.interval;
    },
    getEventScale: function(zoomEvent) {
        var scale = zoomEvent.deltaScale || 1;
        return 1 - (1 - scale) / (.75 + this.visibleCategories.length / this._categories.length);
    },
    zoom: function(translate, scale) {
        var categories = this._categories;
        var canvasOptions = this._canvasOptions;
        var stick = this._options.stick;
        var invert = canvasOptions.invert;
        var interval = canvasOptions.interval * scale;
        var translateCategories = translate / interval;
        var visibleCount = (this.visibleCategories || []).length;
        var startCategoryIndex = parseInt((canvasOptions.startPointIndex || 0) + translateCategories + .5);
        var categoriesLength = parseInt((0, $laqiS.adjust)(canvasOptions.canvasLength / interval) + (stick ? 1 : 0)) || 1;
        var endCategoryIndex;
        if (invert) startCategoryIndex = parseInt((canvasOptions.startPointIndex || 0) + visibleCount - translateCategories + .5) - categoriesLength;
        if (startCategoryIndex < 0) startCategoryIndex = 0;
        endCategoryIndex = startCategoryIndex + categoriesLength;
        if (endCategoryIndex > categories.length) {
            endCategoryIndex = categories.length;
            startCategoryIndex = endCategoryIndex - categoriesLength;
            if (startCategoryIndex < 0) startCategoryIndex = 0;
        }
        var newVisibleCategories = categories.slice(parseInt(startCategoryIndex), parseInt(endCategoryIndex));
        var newInterval = this._getDiscreteInterval(newVisibleCategories.length, canvasOptions);
        scale = newInterval / canvasOptions.interval;
        translate = this.translate(!invert ? newVisibleCategories[0] : newVisibleCategories[newVisibleCategories.length - 1]) * scale - (canvasOptions.startPoint + (stick ? 0 : newInterval / 2));
        return {
            min: newVisibleCategories[0],
            max: newVisibleCategories[newVisibleCategories.length - 1],
            translate: translate,
            scale: scale
        };
    },
    getMinScale: function(zoom) {
        var canvasOptions = this._canvasOptions;
        var categoriesLength = (this.visibleCategories || this._categories).length;
        categoriesLength += (parseInt(.1 * categoriesLength) || 1) * (zoom ? -2 : 2);
        return canvasOptions.canvasLength / (Math.max(categoriesLength, 1) * canvasOptions.interval);
    },
    getScale: function(min, max) {
        var canvasOptions = this._canvasOptions;
        var visibleArea = this.getCanvasVisibleArea();
        var stickOffset = !this._options.stick && 1;
        var minPoint = (0, $6ntMu.isDefined)(min) ? this.translate(min, -stickOffset) : null;
        var maxPoint = (0, $6ntMu.isDefined)(max) ? this.translate(max, +stickOffset) : null;
        if (null === minPoint) minPoint = canvasOptions.invert ? visibleArea.max : visibleArea.min;
        if (null === maxPoint) maxPoint = canvasOptions.invert ? visibleArea.min : visibleArea.max;
        return this.canvasLength / Math.abs(maxPoint - minPoint);
    },
    isValid: function(value) {
        return (0, $6ntMu.isDefined)(value) ? this._categoriesToPoints[value.valueOf()] >= 0 : false;
    },
    getCorrectValue: $fff01cffd3eb83af$var$getValue,
    to: function(value, direction) {
        var canvasOptions = this._canvasOptions;
        var categoryIndex = this._categoriesToPoints[null === value || void 0 === value ? void 0 : value.valueOf()];
        var startPointIndex = canvasOptions.startPointIndex || 0;
        var stickDelta = categoryIndex + (this._options.stick ? 0 : .5) - startPointIndex + (this._businessRange.invert ? -1 : 1) * direction * .5;
        return $fff01cffd3eb83af$var$round(this._calculateProjection(canvasOptions.interval * stickDelta));
    },
    from: function(position) {
        var direction = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        var canvasOptions = this._canvasOptions;
        var startPoint = canvasOptions.startPoint;
        var categories = this.visibleCategories || this._categories;
        var categoriesLength = categories.length;
        var stickInterval = this._options.stick ? .5 : 0;
        var result = $fff01cffd3eb83af$var$round((position - startPoint) / canvasOptions.interval + stickInterval - .5 - .5 * direction);
        if (result >= categoriesLength) result = categoriesLength - 1;
        if (result < 0) result = 0;
        if (canvasOptions.invert) result = categoriesLength - result - 1;
        return categories[result];
    },
    _add: function() {
        return NaN;
    },
    toValue: $fff01cffd3eb83af$var$getValue,
    isValueProlonged: true,
    getRangeByMinZoomValue (minZoom, visualRange) {
        var categories = this._categories;
        var minVisibleIndex = categories.indexOf(visualRange.minVisible);
        var maxVisibleIndex = categories.indexOf(visualRange.maxVisible);
        var startIndex = minVisibleIndex + minZoom - 1;
        var endIndex = maxVisibleIndex - minZoom + 1;
        if (categories[startIndex]) return [
            visualRange.minVisible,
            categories[startIndex]
        ];
        else return [
            categories[endIndex],
            visualRange.maxVisible
        ];
    }
};

});

parcelRegister("jZFhH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8e3bd0d0a36f766$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/translators/interval_translator.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $f38Z1 = parcelRequire("f38Z1");

var $laqiS = parcelRequire("laqiS");
var $e8e3bd0d0a36f766$var$floor = Math.floor;
var $e8e3bd0d0a36f766$export$2e2bcd8739ae039 = {
    _intervalize: function(value, interval) {
        if (!(0, $6ntMu.isDefined)(value)) return;
        if ("datetime" === this._businessRange.dataType) {
            if ((0, $6ntMu.isNumeric)(value)) value = new Date(value);
            else value = new Date(value.getTime());
            value = (0, $f38Z1.default).correctDateWithUnitBeginning(value, interval, null, this._options.firstDayOfWeek);
        } else value = (0, $laqiS.adjust)($e8e3bd0d0a36f766$var$floor((0, $laqiS.adjust)(value / interval)) * interval, interval);
        return value;
    },
    translate: function(bp, direction, interval) {
        var specialValue = this.translateSpecialCase(bp);
        if ((0, $6ntMu.isDefined)(specialValue)) return Math.round(specialValue);
        interval = interval || this._options.interval;
        if (!this.isValid(bp, interval)) return null;
        return this.to(bp, direction, interval);
    },
    getInterval: function() {
        return Math.round(this._canvasOptions.ratioOfCanvasRange * (this._businessRange.interval || Math.abs(this._canvasOptions.rangeMax - this._canvasOptions.rangeMin)));
    },
    zoom: function() {},
    getMinScale: function() {},
    getScale: function() {},
    _parse: function(value) {
        return "datetime" === this._businessRange.dataType ? new Date(value) : Number(value);
    },
    fromValue: function(value) {
        return this._parse(value);
    },
    toValue: function(value) {
        return this._parse(value);
    },
    isValid: function(value, interval) {
        var co = this._canvasOptions;
        var rangeMin = co.rangeMin;
        var rangeMax = co.rangeMax;
        interval = interval || this._options.interval;
        if (null === value || isNaN(value)) return false;
        value = "datetime" === this._businessRange.dataType && (0, $6ntMu.isNumeric)(value) ? new Date(value) : value;
        if (interval !== this._options.interval) {
            rangeMin = this._intervalize(rangeMin, interval);
            rangeMax = this._intervalize(rangeMax, interval);
        }
        if (value.valueOf() < rangeMin || value.valueOf() >= (0, $f38Z1.default).addInterval(rangeMax, interval)) return false;
        return true;
    },
    to: function(bp, direction, interval) {
        interval = interval || this._options.interval;
        var v1 = this._intervalize(bp, interval);
        var v2 = (0, $f38Z1.default).addInterval(v1, interval);
        var res = this._to(v1);
        var p2 = this._to(v2);
        if (!direction) res = $e8e3bd0d0a36f766$var$floor((res + p2) / 2);
        else if (direction > 0) res = p2;
        return res;
    },
    _to: function(value) {
        var co = this._canvasOptions;
        var rMin = co.rangeMinVisible;
        var rMax = co.rangeMaxVisible;
        var offset = value - rMin;
        if (value < rMin) offset = 0;
        else if (value > rMax) offset = (0, $f38Z1.default).addInterval(rMax, this._options.interval) - rMin;
        return this._conversionValue(this._calculateProjection(offset * this._canvasOptions.ratioOfCanvasRange));
    },
    from: function(position, direction) {
        var origInterval = this._options.interval;
        var interval = origInterval;
        var co = this._canvasOptions;
        var rMin = co.rangeMinVisible;
        var rMax = co.rangeMaxVisible;
        var value;
        if ("datetime" === this._businessRange.dataType) interval = (0, $f38Z1.default).dateToMilliseconds(origInterval);
        value = this._calculateUnProjection((position - this._canvasOptions.startPoint) / this._canvasOptions.ratioOfCanvasRange);
        value = this._intervalize((0, $f38Z1.default).addInterval(value, interval / 2, direction > 0), origInterval);
        if (value < rMin) value = rMin;
        else if (value > rMax) value = rMax;
        return value;
    },
    _add: function() {
        return NaN;
    },
    isValueProlonged: true
};

});

parcelRegister("2Ftnl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f163275021f7238$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/translators/datetime_translator.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $f38Z1 = parcelRequire("f38Z1");
function $1f163275021f7238$var$parse(value) {
    return null !== value ? new Date(value) : value;
}
var $1f163275021f7238$export$2e2bcd8739ae039 = {
    fromValue: $1f163275021f7238$var$parse,
    toValue: $1f163275021f7238$var$parse,
    _add: (0, $f38Z1.default).addDateInterval,
    convert: (0, $f38Z1.default).dateToMilliseconds
};

});

parcelRegister("kD4rh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f04ae4ad1d7bac4a$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/translators/logarithmic_translator.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $dw9tZ = parcelRequire("dw9tZ");

var $6ntMu = parcelRequire("6ntMu");
var $f04ae4ad1d7bac4a$export$2e2bcd8739ae039 = {
    fromValue: function(value) {
        return null !== value ? (0, $dw9tZ.getLogExt)(value, this._canvasOptions.base, this._businessRange.allowNegatives, this._businessRange.linearThreshold) : value;
    },
    toValue: function(value) {
        return null !== value ? (0, $dw9tZ.raiseToExt)(value, this._canvasOptions.base, this._businessRange.allowNegatives, this._businessRange.linearThreshold) : value;
    },
    getMinBarSize: function(minBarSize) {
        var visibleArea = this.getCanvasVisibleArea();
        var minValue = this.from(visibleArea.min + minBarSize);
        var canvasOptions = this._canvasOptions;
        var startValue = this.fromValue(this.from(visibleArea.min));
        var endValue = this.fromValue(null !== minValue && void 0 !== minValue ? minValue : this.from(visibleArea.max));
        var value = Math.abs(startValue - endValue);
        return Math.pow(canvasOptions.base, value);
    },
    checkMinBarSize: function(initialValue, minShownValue, stackValue) {
        var canvasOptions = this._canvasOptions;
        var prevValue = stackValue ? stackValue - initialValue : 0;
        var baseMethod = this.constructor.prototype.checkMinBarSize;
        var minBarSize;
        var updateValue;
        if ((0, $6ntMu.isDefined)(minShownValue) && prevValue > 0) {
            minBarSize = baseMethod(this.fromValue(stackValue / prevValue), this.fromValue(minShownValue) - canvasOptions.rangeMinVisible);
            updateValue = Math.pow(canvasOptions.base, this.fromValue(prevValue) + minBarSize) - prevValue;
        } else updateValue = baseMethod(initialValue, minShownValue);
        return updateValue;
    }
};

});



parcelRegister("6V66N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $509ccdff37d86aed$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/chart_components/shutter_zoom.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $bTgwK = parcelRequire("bTgwK");
var $509ccdff37d86aed$var$SHUTTER_EVENTS_NS = ".shutter-zoom";
var $509ccdff37d86aed$var$DRAG_START_EVENT_NAME = (0, $bTgwK.start) + $509ccdff37d86aed$var$SHUTTER_EVENTS_NS;
var $509ccdff37d86aed$var$DRAG_UPDATE_EVENT_NAME = (0, $bTgwK.move) + $509ccdff37d86aed$var$SHUTTER_EVENTS_NS;
var $509ccdff37d86aed$var$DRAG_END_EVENT_NAME = (0, $bTgwK.end) + $509ccdff37d86aed$var$SHUTTER_EVENTS_NS;
function $509ccdff37d86aed$var$getPointerCoord(rootOffset, canvas, rotated, e) {
    var coord = Math.floor(rotated ? e.pageY - rootOffset.top : e.pageX - rootOffset.left);
    var min = rotated ? canvas.y1 : canvas.x1;
    var max = rotated ? canvas.y2 : canvas.x2;
    if (coord < min) coord = min;
    else if (coord > max) coord = max;
    return coord;
}
function $509ccdff37d86aed$var$checkCoords(rootOffset, canvas, e) {
    var x = e.pageX - rootOffset.left;
    var y = e.pageY - rootOffset.top;
    return x >= canvas.x1 && x <= canvas.x2 && y >= canvas.y1 && y <= canvas.y2;
}
function $509ccdff37d86aed$var$dragStartHandler(ctx) {
    return function(e) {
        var offset = ctx.getRootOffset();
        var canvas = ctx.getCanvas();
        if (!$509ccdff37d86aed$var$checkCoords(offset, canvas, e)) {
            e.cancel = true;
            return;
        }
        ctx.rootOffset = offset;
        ctx.canvas = canvas;
        ctx.startCoord = $509ccdff37d86aed$var$getPointerCoord(offset, canvas, ctx.rotated, e);
        ctx.triggerStart();
        ctx.rect.attr({
            x: canvas.x1,
            y: canvas.y1,
            width: canvas.width,
            height: canvas.height
        }).append(ctx.root);
    };
}
function $509ccdff37d86aed$var$dragHandler(ctx) {
    return function(e) {
        var curCoord = $509ccdff37d86aed$var$getPointerCoord(ctx.rootOffset, ctx.canvas, ctx.rotated, e);
        var attr = {};
        ctx.curCoord = curCoord;
        attr[ctx.rotated ? "y" : "x"] = Math.min(ctx.startCoord, curCoord);
        attr[ctx.rotated ? "height" : "width"] = Math.abs(ctx.startCoord - curCoord);
        ctx.rect.attr(attr);
    };
}
function $509ccdff37d86aed$var$dragEndHandler(ctx) {
    return function(e) {
        ctx.triggerEnd();
        ctx.rect.remove();
    };
}
function $509ccdff37d86aed$var$shutterZoom(options) {
    var chart = options.chart;
    var renderer = options.renderer;
    var rotated = options.rotated;
    var rect = renderer.rect(0, 0, 0, 0).attr(options.shutterOptions);
    var shutter = {
        rect: rect,
        root: renderer.root,
        rotated: rotated,
        triggerStart: function() {
            chart._eventTrigger("zoomStart");
        },
        triggerEnd: function() {
            var tr = chart._argumentAxes[0].getTranslator();
            var rangeStart = Math.min(this.startCoord, this.curCoord);
            var rangeEnd = Math.max(this.startCoord, this.curCoord);
            chart._eventTrigger("zoomEnd", {
                rangeStart: tr.from(rangeStart),
                rangeEnd: tr.from(rangeEnd)
            });
        },
        dispose: function() {
            renderer.root.off($509ccdff37d86aed$var$SHUTTER_EVENTS_NS);
            rect.dispose();
        },
        getRootOffset: function() {
            return renderer.getRootOffset();
        },
        getCanvas: function() {
            var canvas = chart._canvas;
            var panes = chart.panes;
            var firstPane = panes[0].canvas;
            var lastPane = panes[panes.length - 1].canvas;
            return {
                x1: firstPane.left,
                y1: firstPane.top,
                x2: canvas.width - lastPane.right,
                y2: canvas.height - lastPane.bottom,
                width: canvas.width - firstPane.left - lastPane.right,
                height: canvas.height - firstPane.top - lastPane.bottom
            };
        }
    };
    renderer.root.off($509ccdff37d86aed$var$SHUTTER_EVENTS_NS).on($509ccdff37d86aed$var$DRAG_START_EVENT_NAME, {
        direction: rotated ? "vertical" : "horizontal",
        immediate: true
    }, $509ccdff37d86aed$var$dragStartHandler(shutter)).on($509ccdff37d86aed$var$DRAG_UPDATE_EVENT_NAME, $509ccdff37d86aed$var$dragHandler(shutter)).on($509ccdff37d86aed$var$DRAG_END_EVENT_NAME, $509ccdff37d86aed$var$dragEndHandler(shutter));
    return shutter;
}
var $509ccdff37d86aed$export$2e2bcd8739ae039 = {
    name: "shutter_zoom",
    init: function() {
        var options = this.option("shutterZoom") || {};
        if (!options.enabled) return;
        this._shutterZoom = $509ccdff37d86aed$var$shutterZoom({
            chart: this,
            renderer: this._renderer,
            rotated: this.option("rotated"),
            shutterOptions: options
        });
    },
    dispose: function() {
        this._shutterZoom && this._shutterZoom.dispose();
    }
};

});

parcelRegister("j4RF2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de3803f5a917600e$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/chart_components/zoom_and_pan.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $4WYaH = parcelRequire("4WYaH");

var $6ntMu = parcelRequire("6ntMu");

var $2oTOp = parcelRequire("2oTOp");

var $dw9tZ = parcelRequire("dw9tZ");

var $fFYtV = parcelRequire("fFYtV");

var $1yNgF = parcelRequire("1yNgF");

var $bTgwK = parcelRequire("bTgwK");
var $de3803f5a917600e$var$EVENTS_NS = ".zoomAndPanNS";
var $de3803f5a917600e$var$DRAG_START_EVENT_NAME = (0, $bTgwK.start) + $de3803f5a917600e$var$EVENTS_NS;
var $de3803f5a917600e$var$DRAG_EVENT_NAME = (0, $bTgwK.move) + $de3803f5a917600e$var$EVENTS_NS;
var $de3803f5a917600e$var$DRAG_END_EVENT_NAME = (0, $bTgwK.end) + $de3803f5a917600e$var$EVENTS_NS;
var $de3803f5a917600e$var$PINCH_START_EVENT_NAME = $1yNgF.pinchstart + $de3803f5a917600e$var$EVENTS_NS;
var $de3803f5a917600e$var$PINCH_EVENT_NAME = $1yNgF.pinch + $de3803f5a917600e$var$EVENTS_NS;
var $de3803f5a917600e$var$PINCH_END_EVENT_NAME = $1yNgF.pinchend + $de3803f5a917600e$var$EVENTS_NS;
var $de3803f5a917600e$var$SCROLL_BAR_START_EVENT_NAME = "dxc-scroll-start" + $de3803f5a917600e$var$EVENTS_NS;
var $de3803f5a917600e$var$SCROLL_BAR_MOVE_EVENT_NAME = "dxc-scroll-move" + $de3803f5a917600e$var$EVENTS_NS;
var $de3803f5a917600e$var$SCROLL_BAR_END_EVENT_NAME = "dxc-scroll-end" + $de3803f5a917600e$var$EVENTS_NS;
var $de3803f5a917600e$var$GESTURE_TIMEOUT = 300;
var $de3803f5a917600e$var$MIN_DRAG_DELTA = 5;
var $de3803f5a917600e$var$_min = Math.min;
var $de3803f5a917600e$var$_max = Math.max;
var $de3803f5a917600e$var$_abs = Math.abs;
function $de3803f5a917600e$var$canvasToRect(canvas) {
    return {
        x: canvas.left,
        y: canvas.top,
        width: canvas.width - canvas.left - canvas.right,
        height: canvas.height - canvas.top - canvas.bottom
    };
}
function $de3803f5a917600e$var$checkCoords(rect, coords) {
    var x = coords.x;
    var y = coords.y;
    return x >= rect.x && x <= rect.width + rect.x && y >= rect.y && y <= rect.height + rect.y;
}
function $de3803f5a917600e$var$sortAxes(axes, onlyAxisToNotify) {
    if (onlyAxisToNotify) axes = axes.sort((a, b)=>{
        if (a === onlyAxisToNotify) return -1;
        if (b === onlyAxisToNotify) return 1;
        return 0;
    });
    return axes;
}
function $de3803f5a917600e$var$getFilteredAxes(axes) {
    return axes.filter((a)=>!a.getTranslator().getBusinessRange().isEmpty());
}
function $de3803f5a917600e$var$isAxisAvailablePanning(axes) {
    return axes.some((axis)=>!axis.isExtremePosition(false) || !axis.isExtremePosition(true));
}
function $de3803f5a917600e$var$axisZoom(axis, onlyAxisToNotify, getRange, getParameters, actionField, scale, e) {
    var silent = onlyAxisToNotify && axis !== onlyAxisToNotify;
    var range = getRange(axis);
    var { stopInteraction: stopInteraction, correctedRange: correctedRange } = axis.checkZoomingLowerLimitOvercome(actionField, scale, range);
    var result = axis.handleZooming(stopInteraction ? null : correctedRange, getParameters(silent), e, actionField);
    stopInteraction && axis.handleZoomEnd();
    return {
        stopInteraction: stopInteraction,
        result: result
    };
}
function $de3803f5a917600e$var$zoomAxes(e, axes, getRange, zoom, params, onlyAxisToNotify) {
    axes = $de3803f5a917600e$var$sortAxes(axes, onlyAxisToNotify);
    var zoomStarted = false;
    var getParameters = (silent)=>({
            start: !!silent,
            end: !!silent
        });
    $de3803f5a917600e$var$getFilteredAxes(axes).some((axis)=>{
        var translator = axis.getTranslator();
        var scale = translator.getMinScale(zoom);
        var { stopInteraction: stopInteraction, result: result } = $de3803f5a917600e$var$axisZoom(axis, onlyAxisToNotify, getRange((0, $4WYaH.default)({
            scale: scale,
            translator: translator,
            axis: axis
        }, params)), getParameters, "zoom", scale, e);
        zoomStarted = !stopInteraction;
        return onlyAxisToNotify && result.isPrevented;
    });
    return zoomStarted;
}
function $de3803f5a917600e$var$cancelEvent(e) {
    if (e.originalEvent) $de3803f5a917600e$var$cancelEvent(e.originalEvent);
    if (false !== e.cancelable) e.cancel = true;
}
var $de3803f5a917600e$export$2e2bcd8739ae039 = {
    name: "zoom_and_pan",
    init: function() {
        var chart = this;
        var renderer = this._renderer;
        function getAxesCopy(zoomAndPan, actionField) {
            var axes = [];
            var options = zoomAndPan.options;
            var actionData = zoomAndPan.actionData;
            if (options.argumentAxis[actionField]) axes.push(chart.getArgumentAxis());
            if (options.valueAxis[actionField]) axes = axes.concat(actionData.valueAxes);
            return axes;
        }
        function startAxesViewportChanging(zoomAndPan, actionField, e) {
            var axes = getAxesCopy(zoomAndPan, actionField);
            $de3803f5a917600e$var$getFilteredAxes(axes).some((axis)=>axis.handleZooming(null, {
                    end: true
                }, e, actionField).isPrevented) && $de3803f5a917600e$var$cancelEvent(e);
        }
        function axesViewportChanging(zoomAndPan, actionField, e, offsetCalc, centerCalc) {
            function zoomAxes(axes, criteria, coordField, e, actionData) {
                var zoom = {
                    zoomed: false
                };
                criteria && $de3803f5a917600e$var$getFilteredAxes(axes).forEach((axis)=>{
                    var options = axis.getOptions();
                    var viewport = axis.visualRange();
                    var scale = axis.getTranslator().getEventScale(e);
                    var translate = -offsetCalc(e, actionData, coordField, scale);
                    zoom = (0, $2oTOp.extend)(true, zoom, axis.getTranslator().zoom(translate, scale, axis.getZoomBounds()));
                    var range = axis.adjustRange((0, $dw9tZ.getVizRangeObject)([
                        zoom.min,
                        zoom.max
                    ]));
                    var { stopInteraction: stopInteraction, correctedRange: correctedRange } = axis.checkZoomingLowerLimitOvercome(actionField, scale, range);
                    if (!(0, $6ntMu.isDefined)(viewport) || viewport.startValue.valueOf() !== correctedRange.startValue.valueOf() || viewport.endValue.valueOf() !== correctedRange.endValue.valueOf()) {
                        axis.handleZooming(stopInteraction ? null : correctedRange, {
                            start: true,
                            end: true
                        }, e, actionField);
                        if (!stopInteraction) {
                            zoom.zoomed = true;
                            zoom.deltaTranslate = translate - zoom.translate;
                        }
                    } else if ("touch" === e.pointerType && "discrete" === options.type) {
                        var isMinPosition = axis.isExtremePosition(false);
                        var isMaxPosition = axis.isExtremePosition(true);
                        var zoomInEnabled = scale > 1 && !stopInteraction;
                        var zoomOutEnabled = scale < 1 && (!isMinPosition || !isMaxPosition);
                        var panningEnabled = 1 === scale && !(isMinPosition && (translate < 0 && !options.inverted || translate > 0 && options.inverted) || isMaxPosition && (translate > 0 && !options.inverted || translate < 0 && options.inverted));
                        zoom.enabled = zoomInEnabled || zoomOutEnabled || panningEnabled;
                    }
                });
                return zoom;
            }
            function storeOffset(e, actionData, zoom, coordField) {
                if (zoom.zoomed) actionData.offset[coordField] = (e.offset ? e.offset[coordField] : actionData.offset[coordField]) + zoom.deltaTranslate;
            }
            function storeCenter(center, actionData, zoom, coordField) {
                if (zoom.zoomed) actionData.center[coordField] = center[coordField] + zoom.deltaTranslate;
            }
            var rotated = chart.option("rotated");
            var actionData = zoomAndPan.actionData;
            var options = zoomAndPan.options;
            var argZoom = {};
            var valZoom = {};
            if (!actionData.fallback) {
                argZoom = zoomAxes(chart._argumentAxes, options.argumentAxis[actionField], rotated ? "y" : "x", e, actionData);
                valZoom = zoomAxes(actionData.valueAxes, options.valueAxis[actionField], rotated ? "x" : "y", e, actionData);
                chart._requestChange([
                    "VISUAL_RANGE"
                ]);
                storeOffset(e, actionData, argZoom, rotated ? "y" : "x");
                storeOffset(e, actionData, valZoom, rotated ? "x" : "y");
            }
            var center = centerCalc(e);
            storeCenter(center, actionData, argZoom, rotated ? "y" : "x");
            storeCenter(center, actionData, valZoom, rotated ? "x" : "y");
            if (!argZoom.zoomed && !valZoom.zoomed) actionData.center = center;
            return argZoom.zoomed || valZoom.zoomed || actionData.fallback || argZoom.enabled || valZoom.enabled;
        }
        function finishAxesViewportChanging(zoomAndPan, actionField, e, offsetCalc) {
            function zoomAxes(axes, coordField, actionData, onlyAxisToNotify) {
                var zoomStarted = false;
                var scale = e.scale || 1;
                var getRange = (axis)=>{
                    var zoom = axis.getTranslator().zoom(-offsetCalc(e, actionData, coordField, scale), scale, axis.getZoomBounds());
                    return {
                        startValue: zoom.min,
                        endValue: zoom.max
                    };
                };
                var getParameters = (silent)=>({
                        start: true,
                        end: silent
                    });
                $de3803f5a917600e$var$getFilteredAxes(axes).forEach((axis)=>{
                    zoomStarted = !$de3803f5a917600e$var$axisZoom(axis, onlyAxisToNotify, getRange, getParameters, actionField, scale, e).stopInteraction;
                });
                return zoomStarted;
            }
            var rotated = chart.option("rotated");
            var actionData = zoomAndPan.actionData;
            var options = zoomAndPan.options;
            var zoomStarted = true;
            if (actionData.fallback) {
                zoomStarted &= options.argumentAxis[actionField] && zoomAxes(chart._argumentAxes, rotated ? "y" : "x", actionData, chart.getArgumentAxis());
                zoomStarted |= options.valueAxis[actionField] && zoomAxes(actionData.valueAxes, rotated ? "x" : "y", actionData);
            } else {
                var axes = getAxesCopy(zoomAndPan, actionField);
                $de3803f5a917600e$var$getFilteredAxes(axes).forEach((axis)=>{
                    axis.handleZooming(null, {
                        start: true
                    }, e, actionField);
                });
                zoomStarted = axes.length;
            }
            zoomStarted && chart._requestChange([
                "VISUAL_RANGE"
            ]);
        }
        function prepareActionData(coords, action) {
            var axes = chart._argumentAxes.filter((axis)=>$de3803f5a917600e$var$checkCoords($de3803f5a917600e$var$canvasToRect(axis.getCanvas()), coords));
            return {
                fallback: chart._lastRenderingTime > $de3803f5a917600e$var$GESTURE_TIMEOUT,
                cancel: !axes.length || !(0, $6ntMu.isDefined)(action),
                action: action,
                curAxisRect: axes.length && $de3803f5a917600e$var$canvasToRect(axes[0].getCanvas()),
                valueAxes: axes.length && chart._valueAxes.filter((axis)=>$de3803f5a917600e$var$checkCoords($de3803f5a917600e$var$canvasToRect(axis.getCanvas()), coords)),
                offset: {
                    x: 0,
                    y: 0
                },
                center: coords,
                startCenter: coords
            };
        }
        function getPointerCoord(rect, e) {
            var rootOffset = renderer.getRootOffset();
            return {
                x: $de3803f5a917600e$var$_min($de3803f5a917600e$var$_max(e.pageX - rootOffset.left, rect.x), rect.width + rect.x),
                y: $de3803f5a917600e$var$_min($de3803f5a917600e$var$_max(e.pageY - rootOffset.top, rect.y), rect.height + rect.y)
            };
        }
        function calcCenterForPinch(e) {
            var rootOffset = renderer.getRootOffset();
            var x1 = e.pointers[0].pageX;
            var x2 = e.pointers[1].pageX;
            var y1 = e.pointers[0].pageY;
            var y2 = e.pointers[1].pageY;
            return {
                x: $de3803f5a917600e$var$_min(x1, x2) + $de3803f5a917600e$var$_abs(x2 - x1) / 2 - rootOffset.left,
                y: $de3803f5a917600e$var$_min(y1, y2) + $de3803f5a917600e$var$_abs(y2 - y1) / 2 - rootOffset.top
            };
        }
        function calcCenterForDrag(e) {
            var rootOffset = renderer.getRootOffset();
            return {
                x: e.pageX - rootOffset.left,
                y: e.pageY - rootOffset.top
            };
        }
        function calcOffsetForDrag(e, actionData, coordField) {
            return e.offset[coordField] - actionData.offset[coordField];
        }
        function preventDefaults(e) {
            if (false !== e.cancelable) {
                e.preventDefault();
                e.stopPropagation();
            }
            chart._stopCurrentHandling();
        }
        var zoomAndPan = {
            dragStartHandler: function(e) {
                var options = zoomAndPan.options;
                var isTouch = "touch" === e.pointerType;
                var wantPan = options.argumentAxis.pan || options.valueAxis.pan;
                var wantZoom = options.argumentAxis.zoom || options.valueAxis.zoom;
                var panKeyPressed = (0, $6ntMu.isDefined)(options.panKey) && e[(0, $dw9tZ.normalizeEnum)(options.panKey) + "Key"];
                var dragToZoom = options.dragToZoom;
                var action;
                e._cancelPreventDefault = true;
                if (isTouch) {
                    if (options.allowTouchGestures && wantPan) {
                        var cancelPanning = !zoomAndPan.panningVisualRangeEnabled() || zoomAndPan.skipEvent;
                        action = cancelPanning ? null : "pan";
                    }
                } else if (dragToZoom && wantPan && panKeyPressed || !dragToZoom && wantPan) action = "pan";
                else if (dragToZoom && wantZoom) action = "zoom";
                var actionData = prepareActionData(calcCenterForDrag(e), action);
                if (actionData.cancel) {
                    zoomAndPan.skipEvent = false;
                    if (false !== e.cancelable) e.cancel = true;
                    return;
                }
                zoomAndPan.actionData = actionData;
                if ("zoom" === action) {
                    actionData.startCoords = getPointerCoord(actionData.curAxisRect, e);
                    actionData.rect = renderer.rect(0, 0, 0, 0).attr(options.dragBoxStyle).append(renderer.root);
                } else startAxesViewportChanging(zoomAndPan, "pan", e);
            },
            dragHandler: function(e) {
                var rotated = chart.option("rotated");
                var options = zoomAndPan.options;
                var actionData = zoomAndPan.actionData;
                var isTouch = "touch" === e.pointerType;
                e._cancelPreventDefault = true;
                if (!actionData || isTouch && !zoomAndPan.panningVisualRangeEnabled()) return;
                if ("zoom" === actionData.action) {
                    preventDefaults(e);
                    var curCanvas = actionData.curAxisRect;
                    var startCoords = actionData.startCoords;
                    var curCoords = getPointerCoord(curCanvas, e);
                    var zoomArg = options.argumentAxis.zoom;
                    var zoomVal = options.valueAxis.zoom;
                    var rect = {
                        x: $de3803f5a917600e$var$_min(startCoords.x, curCoords.x),
                        y: $de3803f5a917600e$var$_min(startCoords.y, curCoords.y),
                        width: $de3803f5a917600e$var$_abs(startCoords.x - curCoords.x),
                        height: $de3803f5a917600e$var$_abs(startCoords.y - curCoords.y)
                    };
                    if (!zoomArg || !zoomVal) {
                        if (!zoomArg && !rotated || !zoomVal && rotated) {
                            rect.x = curCanvas.x;
                            rect.width = curCanvas.width;
                        } else {
                            rect.y = curCanvas.y;
                            rect.height = curCanvas.height;
                        }
                    }
                    actionData.rect.attr(rect);
                } else if ("pan" === actionData.action) {
                    axesViewportChanging(zoomAndPan, "pan", e, calcOffsetForDrag, (e)=>e.offset);
                    var deltaOffsetY = Math.abs(e.offset.y - actionData.offset.y);
                    var deltaOffsetX = Math.abs(e.offset.x - actionData.offset.x);
                    if (isTouch && (deltaOffsetY > $de3803f5a917600e$var$MIN_DRAG_DELTA && deltaOffsetY > Math.abs(actionData.offset.x) || deltaOffsetX > $de3803f5a917600e$var$MIN_DRAG_DELTA && deltaOffsetX > Math.abs(actionData.offset.y))) return;
                    preventDefaults(e);
                }
            },
            dragEndHandler: function(e) {
                var rotated = chart.option("rotated");
                var options = zoomAndPan.options;
                var actionData = zoomAndPan.actionData;
                var isTouch = "touch" === e.pointerType;
                var getRange = (_ref)=>{
                    var { translator: translator, startCoord: startCoord, curCoord: curCoord } = _ref;
                    return ()=>[
                            translator.from(startCoord),
                            translator.from(curCoord)
                        ];
                };
                var getCoords = (curCoords, startCoords, field)=>({
                        curCoord: curCoords[field],
                        startCoord: startCoords[field]
                    });
                var needToZoom = (axisOption, coords)=>axisOption.zoom && $de3803f5a917600e$var$_abs(coords.curCoord - coords.startCoord) > $de3803f5a917600e$var$MIN_DRAG_DELTA;
                var panIsEmpty = actionData && "pan" === actionData.action && !actionData.fallback && 0 === actionData.offset.x && 0 === actionData.offset.y;
                if (!actionData || isTouch && !zoomAndPan.panningVisualRangeEnabled() || panIsEmpty) return;
                !isTouch && preventDefaults(e);
                if ("zoom" === actionData.action) {
                    var curCoords = getPointerCoord(actionData.curAxisRect, e);
                    var argumentCoords = getCoords(curCoords, actionData.startCoords, rotated ? "y" : "x");
                    var valueCoords = getCoords(curCoords, actionData.startCoords, rotated ? "x" : "y");
                    var argumentAxesZoomed = needToZoom(options.argumentAxis, argumentCoords) && $de3803f5a917600e$var$zoomAxes(e, chart._argumentAxes, getRange, true, argumentCoords, chart.getArgumentAxis());
                    var valueAxesZoomed = needToZoom(options.valueAxis, valueCoords) && $de3803f5a917600e$var$zoomAxes(e, actionData.valueAxes, getRange, true, valueCoords);
                    if (valueAxesZoomed || argumentAxesZoomed) chart._requestChange([
                        "VISUAL_RANGE"
                    ]);
                    actionData.rect.dispose();
                } else if ("pan" === actionData.action) finishAxesViewportChanging(zoomAndPan, "pan", e, calcOffsetForDrag);
                zoomAndPan.actionData = null;
            },
            pinchStartHandler: function(e) {
                var actionData = prepareActionData(calcCenterForPinch(e), "zoom");
                if (actionData.cancel) {
                    $de3803f5a917600e$var$cancelEvent(e);
                    return;
                }
                zoomAndPan.actionData = actionData;
                startAxesViewportChanging(zoomAndPan, "zoom", e);
            },
            pinchHandler: function(e) {
                if (!zoomAndPan.actionData) return;
                axesViewportChanging(zoomAndPan, "zoom", e, (e, actionData, coordField, scale)=>calcCenterForPinch(e)[coordField] - actionData.center[coordField] + (actionData.center[coordField] - actionData.center[coordField] * scale), calcCenterForPinch);
                preventDefaults(e);
            },
            pinchEndHandler: function(e) {
                if (!zoomAndPan.actionData) return;
                finishAxesViewportChanging(zoomAndPan, "zoom", e, (e, actionData, coordField, scale)=>actionData.center[coordField] - actionData.startCenter[coordField] + (actionData.startCenter[coordField] - actionData.startCenter[coordField] * scale));
                zoomAndPan.actionData = null;
            },
            mouseWheelHandler: function(e) {
                var options = zoomAndPan.options;
                var rotated = chart.option("rotated");
                var getRange = (_ref2)=>{
                    var { translator: translator, coord: coord, scale: scale, axis: axis } = _ref2;
                    return ()=>{
                        var zoom = translator.zoom(-(coord - coord * scale), scale, axis.getZoomBounds());
                        return {
                            startValue: zoom.min,
                            endValue: zoom.max
                        };
                    };
                };
                var coords = calcCenterForDrag(e);
                var axesZoomed = false;
                var targetAxes;
                if (options.valueAxis.zoom) {
                    targetAxes = chart._valueAxes.filter((axis)=>$de3803f5a917600e$var$checkCoords($de3803f5a917600e$var$canvasToRect(axis.getCanvas()), coords));
                    if (0 === targetAxes.length) {
                        var targetCanvas = chart._valueAxes.reduce((r, axis)=>{
                            if (!r && axis.coordsIn(coords.x, coords.y)) r = axis.getCanvas();
                            return r;
                        }, null);
                        if (targetCanvas) targetAxes = chart._valueAxes.filter((axis)=>$de3803f5a917600e$var$checkCoords($de3803f5a917600e$var$canvasToRect(axis.getCanvas()), {
                                x: targetCanvas.left,
                                y: targetCanvas.top
                            }));
                    }
                    axesZoomed |= $de3803f5a917600e$var$zoomAxes(e, targetAxes, getRange, e.delta > 0, {
                        coord: rotated ? coords.x : coords.y
                    });
                }
                if (options.argumentAxis.zoom) {
                    var canZoom = chart._argumentAxes.some((axis)=>{
                        if ($de3803f5a917600e$var$checkCoords($de3803f5a917600e$var$canvasToRect(axis.getCanvas()), coords) || axis.coordsIn(coords.x, coords.y)) return true;
                        return false;
                    });
                    axesZoomed |= canZoom && $de3803f5a917600e$var$zoomAxes(e, chart._argumentAxes, getRange, e.delta > 0, {
                        coord: rotated ? coords.y : coords.x
                    }, chart.getArgumentAxis());
                }
                if (axesZoomed) {
                    chart._requestChange([
                        "VISUAL_RANGE"
                    ]);
                    if (targetAxes && $de3803f5a917600e$var$isAxisAvailablePanning(targetAxes) || !targetAxes && zoomAndPan.panningVisualRangeEnabled()) preventDefaults(e);
                }
            },
            cleanup: function() {
                renderer.root.off($de3803f5a917600e$var$EVENTS_NS);
                zoomAndPan.actionData && zoomAndPan.actionData.rect && zoomAndPan.actionData.rect.dispose();
                zoomAndPan.actionData = null;
                renderer.root.css({
                    "touch-action": "",
                    "-ms-touch-action": ""
                });
            },
            setup: function(options) {
                zoomAndPan.cleanup();
                if (!options.argumentAxis.pan) renderer.root.on($de3803f5a917600e$var$SCROLL_BAR_START_EVENT_NAME, $de3803f5a917600e$var$cancelEvent);
                if (options.argumentAxis.none && options.valueAxis.none) return;
                zoomAndPan.options = options;
                if ((options.argumentAxis.zoom || options.valueAxis.zoom) && options.allowMouseWheel) renderer.root.on((0, $fFYtV.name) + $de3803f5a917600e$var$EVENTS_NS, zoomAndPan.mouseWheelHandler);
                if ((options.argumentAxis.zoom || options.valueAxis.zoom) && options.allowTouchGestures) renderer.root.on($de3803f5a917600e$var$PINCH_START_EVENT_NAME, {
                    passive: false
                }, zoomAndPan.pinchStartHandler).on($de3803f5a917600e$var$PINCH_EVENT_NAME, {
                    passive: false
                }, zoomAndPan.pinchHandler).on($de3803f5a917600e$var$PINCH_END_EVENT_NAME, zoomAndPan.pinchEndHandler);
                renderer.root.on($de3803f5a917600e$var$DRAG_START_EVENT_NAME, {
                    immediate: true,
                    passive: false
                }, zoomAndPan.dragStartHandler).on($de3803f5a917600e$var$DRAG_EVENT_NAME, {
                    immediate: true,
                    passive: false
                }, zoomAndPan.dragHandler).on($de3803f5a917600e$var$DRAG_END_EVENT_NAME, zoomAndPan.dragEndHandler);
                renderer.root.on($de3803f5a917600e$var$SCROLL_BAR_START_EVENT_NAME, function(e) {
                    zoomAndPan.actionData = {
                        valueAxes: [],
                        offset: {
                            x: 0,
                            y: 0
                        },
                        center: {
                            x: 0,
                            y: 0
                        }
                    };
                    preventDefaults(e);
                    startAxesViewportChanging(zoomAndPan, "pan", e);
                }).on($de3803f5a917600e$var$SCROLL_BAR_MOVE_EVENT_NAME, function(e) {
                    preventDefaults(e);
                    axesViewportChanging(zoomAndPan, "pan", e, calcOffsetForDrag, (e)=>e.offset);
                }).on($de3803f5a917600e$var$SCROLL_BAR_END_EVENT_NAME, function(e) {
                    preventDefaults(e);
                    finishAxesViewportChanging(zoomAndPan, "pan", e, calcOffsetForDrag);
                    zoomAndPan.actionData = null;
                });
            },
            panningVisualRangeEnabled: function() {
                return $de3803f5a917600e$var$isAxisAvailablePanning(chart._valueAxes) || $de3803f5a917600e$var$isAxisAvailablePanning(chart._argumentAxes);
            }
        };
        this._zoomAndPan = zoomAndPan;
    },
    members: {
        _setupZoomAndPan: function() {
            this._zoomAndPan.setup(this._themeManager.getOptions("zoomAndPan"));
        }
    },
    dispose: function() {
        this._zoomAndPan.cleanup();
    },
    customize: function(constructor) {
        constructor.addChange({
            code: "ZOOM_AND_PAN",
            handler: function() {
                this._setupZoomAndPan();
            },
            isThemeDependent: true,
            isOptionChange: true,
            option: "zoomAndPan"
        });
    }
};

});
parcelRegister("1yNgF", function(module, exports) {

$parcel$export(module.exports, "pinchstart", function () { return $122f2efae78ec5a8$export$9e9ad0434cf4ebd5; });
$parcel$export(module.exports, "pinch", function () { return $122f2efae78ec5a8$export$d13b44eae9d2049e; });
$parcel$export(module.exports, "pinchend", function () { return $122f2efae78ec5a8$export$88cf0d8e611101cb; });
/**
 * DevExtreme (esm/events/transform.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $laqiS = parcelRequire("laqiS");

var $8OLOW = parcelRequire("8OLOW");

var $bcOMe = parcelRequire("bcOMe");

var $1xoTt = parcelRequire("1xoTt");

var $gIBa7 = parcelRequire("gIBa7");
var $122f2efae78ec5a8$var$DX_PREFIX = "dx";
var $122f2efae78ec5a8$var$TRANSFORM = "transform";
var $122f2efae78ec5a8$var$TRANSLATE = "translate";
var $122f2efae78ec5a8$var$PINCH = "pinch";
var $122f2efae78ec5a8$var$ROTATE = "rotate";
var $122f2efae78ec5a8$var$START_POSTFIX = "start";
var $122f2efae78ec5a8$var$UPDATE_POSTFIX = "";
var $122f2efae78ec5a8$var$END_POSTFIX = "end";
var $122f2efae78ec5a8$var$eventAliases = [];
var $122f2efae78ec5a8$var$addAlias = function(eventName, eventArgs) {
    $122f2efae78ec5a8$var$eventAliases.push({
        name: eventName,
        args: eventArgs
    });
};
$122f2efae78ec5a8$var$addAlias($122f2efae78ec5a8$var$TRANSFORM, {
    scale: true,
    deltaScale: true,
    rotation: true,
    deltaRotation: true,
    translation: true,
    deltaTranslation: true
});
$122f2efae78ec5a8$var$addAlias($122f2efae78ec5a8$var$TRANSLATE, {
    translation: true,
    deltaTranslation: true
});
$122f2efae78ec5a8$var$addAlias($122f2efae78ec5a8$var$PINCH, {
    scale: true,
    deltaScale: true
});
$122f2efae78ec5a8$var$addAlias($122f2efae78ec5a8$var$ROTATE, {
    rotation: true,
    deltaRotation: true
});
var $122f2efae78ec5a8$var$getVector = function(first, second) {
    return {
        x: second.pageX - first.pageX,
        y: -second.pageY + first.pageY,
        centerX: .5 * (second.pageX + first.pageX),
        centerY: .5 * (second.pageY + first.pageY)
    };
};
var $122f2efae78ec5a8$var$getEventVector = function(e) {
    var pointers = e.pointers;
    return $122f2efae78ec5a8$var$getVector(pointers[0], pointers[1]);
};
var $122f2efae78ec5a8$var$getDistance = function(vector) {
    return Math.sqrt(vector.x * vector.x + vector.y * vector.y);
};
var $122f2efae78ec5a8$var$getScale = function(firstVector, secondVector) {
    return $122f2efae78ec5a8$var$getDistance(firstVector) / $122f2efae78ec5a8$var$getDistance(secondVector);
};
var $122f2efae78ec5a8$var$getRotation = function(firstVector, secondVector) {
    var scalarProduct = firstVector.x * secondVector.x + firstVector.y * secondVector.y;
    var distanceProduct = $122f2efae78ec5a8$var$getDistance(firstVector) * $122f2efae78ec5a8$var$getDistance(secondVector);
    if (0 === distanceProduct) return 0;
    var sign = (0, $laqiS.sign)(firstVector.x * secondVector.y - secondVector.x * firstVector.y);
    var angle = Math.acos((0, $laqiS.fitIntoRange)(scalarProduct / distanceProduct, -1, 1));
    return sign * angle;
};
var $122f2efae78ec5a8$var$getTranslation = function(firstVector, secondVector) {
    return {
        x: firstVector.centerX - secondVector.centerX,
        y: firstVector.centerY - secondVector.centerY
    };
};
var $122f2efae78ec5a8$var$TransformEmitter = (0, $1xoTt.default).inherit({
    validatePointers: function(e) {
        return (0, $bcOMe.hasTouches)(e) > 1;
    },
    start: function(e) {
        this._accept(e);
        var startVector = $122f2efae78ec5a8$var$getEventVector(e);
        this._startVector = startVector;
        this._prevVector = startVector;
        this._fireEventAliases($122f2efae78ec5a8$var$START_POSTFIX, e);
    },
    move: function(e) {
        var currentVector = $122f2efae78ec5a8$var$getEventVector(e);
        var eventArgs = this._getEventArgs(currentVector);
        this._fireEventAliases($122f2efae78ec5a8$var$UPDATE_POSTFIX, e, eventArgs);
        this._prevVector = currentVector;
    },
    end: function(e) {
        var eventArgs = this._getEventArgs(this._prevVector);
        this._fireEventAliases($122f2efae78ec5a8$var$END_POSTFIX, e, eventArgs);
    },
    _getEventArgs: function(vector) {
        return {
            scale: $122f2efae78ec5a8$var$getScale(vector, this._startVector),
            deltaScale: $122f2efae78ec5a8$var$getScale(vector, this._prevVector),
            rotation: $122f2efae78ec5a8$var$getRotation(vector, this._startVector),
            deltaRotation: $122f2efae78ec5a8$var$getRotation(vector, this._prevVector),
            translation: $122f2efae78ec5a8$var$getTranslation(vector, this._startVector),
            deltaTranslation: $122f2efae78ec5a8$var$getTranslation(vector, this._prevVector)
        };
    },
    _fireEventAliases: function(eventPostfix, originalEvent, eventArgs) {
        eventArgs = eventArgs || {};
        $8OLOW.each($122f2efae78ec5a8$var$eventAliases, (function(_, eventAlias) {
            var args = {};
            $8OLOW.each(eventAlias.args, function(name) {
                if (name in eventArgs) args[name] = eventArgs[name];
            });
            this._fireEvent($122f2efae78ec5a8$var$DX_PREFIX + eventAlias.name + eventPostfix, originalEvent, args);
        }).bind(this));
    }
});
var $122f2efae78ec5a8$var$eventNames = $122f2efae78ec5a8$var$eventAliases.reduce((result, eventAlias)=>{
    [
        $122f2efae78ec5a8$var$START_POSTFIX,
        $122f2efae78ec5a8$var$UPDATE_POSTFIX,
        $122f2efae78ec5a8$var$END_POSTFIX
    ].forEach((eventPostfix)=>{
        result.push($122f2efae78ec5a8$var$DX_PREFIX + eventAlias.name + eventPostfix);
    });
    return result;
}, []);
(0, $gIBa7.default)({
    emitter: $122f2efae78ec5a8$var$TransformEmitter,
    events: $122f2efae78ec5a8$var$eventNames
});
var $122f2efae78ec5a8$var$exportNames = {};
$8OLOW.each($122f2efae78ec5a8$var$eventNames, function(_, eventName) {
    $122f2efae78ec5a8$var$exportNames[eventName.substring($122f2efae78ec5a8$var$DX_PREFIX.length)] = eventName;
});
var { transformstart: $122f2efae78ec5a8$export$c60519ecab4574dd, transform: $122f2efae78ec5a8$export$51186ad6e864892a, transformend: $122f2efae78ec5a8$export$6f4da1af66721988, translatestart: $122f2efae78ec5a8$export$98b8db064f76d1c2, translate: $122f2efae78ec5a8$export$d73ee8ef04f5226a, translateend: $122f2efae78ec5a8$export$b5bfaeded0a636c4, zoomstart: $122f2efae78ec5a8$export$f07ac9c30794cd5c, zoom: $122f2efae78ec5a8$export$e83f174dbf56adcc, zoomend: $122f2efae78ec5a8$export$afa287e43c43bb6f, pinchstart: $122f2efae78ec5a8$export$9e9ad0434cf4ebd5, pinch: $122f2efae78ec5a8$export$d13b44eae9d2049e, pinchend: $122f2efae78ec5a8$export$88cf0d8e611101cb, rotatestart: $122f2efae78ec5a8$export$8d3015b79ea66b23, rotate: $122f2efae78ec5a8$export$bb628a54ab399bc9, rotateend: $122f2efae78ec5a8$export$3aa09744d710f8ec } = $122f2efae78ec5a8$var$exportNames;

});


parcelRegister("lDNDs", function(module, exports) {

$parcel$export(module.exports, "AdvancedChart", function () { return $fc13be07a1dbfd77$export$60348cad35b439c3; });
/**
 * DevExtreme (esm/__internal/viz/chart_components/m_advanced_chart.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $4WYaH = parcelRequire("4WYaH");

var $gcp4g = parcelRequire("gcp4g");

var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $6ntMu = parcelRequire("6ntMu");

var $bmLsb = parcelRequire("bmLsb");

var $fMmme = parcelRequire("fMmme");

var $dw9tZ = parcelRequire("dw9tZ");

var $lPQM0 = parcelRequire("lPQM0");

var $4jhWa = parcelRequire("4jhWa");

var $5XaPR = parcelRequire("5XaPR");

var $7MSPx = parcelRequire("7MSPx");
var { isArray: $fc13be07a1dbfd77$var$isArray } = Array;
var $fc13be07a1dbfd77$var$DEFAULT_AXIS_NAME = "defaultAxisName";
var $fc13be07a1dbfd77$var$FONT = "font";
var $fc13be07a1dbfd77$var$COMMON_AXIS_SETTINGS = "commonAxisSettings";
var $fc13be07a1dbfd77$var$DEFAULT_PANE_NAME = "default";
var $fc13be07a1dbfd77$var$VISUAL_RANGE = "VISUAL_RANGE";
function $fc13be07a1dbfd77$var$prepareAxis(axisOptions) {
    if ($fc13be07a1dbfd77$var$isArray(axisOptions)) return 0 === axisOptions.length ? [
        {}
    ] : axisOptions;
    return [
        axisOptions
    ];
}
function $fc13be07a1dbfd77$var$processBubbleMargin(marginOptions, bubbleSize) {
    if (marginOptions.processBubbleSize) marginOptions.size = bubbleSize;
    return marginOptions;
}
function $fc13be07a1dbfd77$var$estimateBubbleSize(size, panesCount, maxSize, rotated) {
    var width = rotated ? size.width / panesCount : size.width;
    var height = rotated ? size.height : size.height / panesCount;
    return Math.min(width, height) * maxSize;
}
function $fc13be07a1dbfd77$var$setAxisVisualRangeByOption(arg, axis, isDirectOption, index) {
    var options;
    var visualRange;
    if (isDirectOption) {
        visualRange = arg.value;
        options = {
            skipEventRising: true
        };
        var wrappedVisualRange = $fc13be07a1dbfd77$var$wrapVisualRange(arg.fullName, visualRange);
        if (wrappedVisualRange) {
            options = {
                allowPartialUpdate: true
            };
            visualRange = wrappedVisualRange;
        }
    } else visualRange = ((0, $6ntMu.isDefined)(index) ? arg.value[index] : arg.value).visualRange;
    axis.visualRange(visualRange, options);
}
function $fc13be07a1dbfd77$var$getAxisTypes(groupsData, axis, isArgumentAxes) {
    if (isArgumentAxes) return {
        argumentAxisType: groupsData.argumentAxisType,
        argumentType: groupsData.argumentType
    };
    var { valueAxisType: valueAxisType, valueType: valueType } = groupsData.groups.find((g)=>g.valueAxis === axis);
    return {
        valueAxisType: valueAxisType,
        valueType: valueType
    };
}
function $fc13be07a1dbfd77$var$wrapVisualRange(fullName, value) {
    var pathElements = fullName.split(".");
    var destElem = pathElements.at(-1);
    if ("endValue" === destElem || "startValue" === destElem) return {
        [destElem]: value
    };
    return;
}
var $fc13be07a1dbfd77$export$60348cad35b439c3 = (0, $7MSPx.BaseChart).inherit({
    _fontFields: [
        "".concat($fc13be07a1dbfd77$var$COMMON_AXIS_SETTINGS, ".label.").concat($fc13be07a1dbfd77$var$FONT),
        "".concat($fc13be07a1dbfd77$var$COMMON_AXIS_SETTINGS, ".title.").concat($fc13be07a1dbfd77$var$FONT)
    ],
    _partialOptionChangesMap: {
        visualRange: $fc13be07a1dbfd77$var$VISUAL_RANGE,
        _customVisualRange: $fc13be07a1dbfd77$var$VISUAL_RANGE,
        strips: "REFRESH_AXES",
        constantLines: "REFRESH_AXES"
    },
    _partialOptionChangesPath: {
        argumentAxis: [
            "strips",
            "constantLines",
            "visualRange",
            "_customVisualRange"
        ],
        valueAxis: [
            "strips",
            "constantLines",
            "visualRange",
            "_customVisualRange"
        ]
    },
    _initCore () {
        this._panesClipRects = {};
        this.callBase();
    },
    _disposeCore () {
        var disposeObjectsInArray = this._disposeObjectsInArray;
        var panesClipRects = this._panesClipRects;
        this.callBase();
        disposeObjectsInArray.call(panesClipRects, "fixed");
        disposeObjectsInArray.call(panesClipRects, "base");
        disposeObjectsInArray.call(panesClipRects, "wide");
        this._panesClipRects = null;
        this._labelsAxesGroup.linkOff();
        this._labelsAxesGroup.dispose();
        this._labelsAxesGroup = null;
    },
    _dispose () {
        var disposeObjectsInArray = this._disposeObjectsInArray;
        this.callBase();
        this.panes = null;
        if (this._legend) {
            this._legend.dispose();
            this._legend = null;
        }
        disposeObjectsInArray.call(this, "panesBackground");
        disposeObjectsInArray.call(this, "seriesFamilies");
        this._disposeAxes();
    },
    _createPanes () {
        this._cleanPanesClipRects("fixed");
        this._cleanPanesClipRects("base");
        this._cleanPanesClipRects("wide");
    },
    _cleanPanesClipRects (clipArrayName) {
        var clipArray = this._panesClipRects[clipArrayName];
        (clipArray || []).forEach((clipRect)=>{
            null === clipRect || void 0 === clipRect || clipRect.dispose();
        });
        this._panesClipRects[clipArrayName] = [];
    },
    _getElementsClipRectID (paneName) {
        var clipShape = this._panesClipRects.fixed[this._getPaneIndex(paneName)];
        return null === clipShape || void 0 === clipShape ? void 0 : clipShape.id;
    },
    _getPaneIndex (paneName) {
        var name = paneName || $fc13be07a1dbfd77$var$DEFAULT_PANE_NAME;
        return this.panes.findIndex((pane)=>pane.name === name);
    },
    _updateSize (forceUpdateCanvas) {
        this.callBase();
        if (forceUpdateCanvas && (0, $5XaPR.areCanvasesDifferent)(this.__currentCanvas, this._canvas)) this.__currentCanvas = (0, $5XaPR.floorCanvasDimensions)(this._canvas);
        (0, $dw9tZ.setCanvasValues)(this._canvas);
    },
    _reinitAxes () {
        this.panes = this._createPanes();
        this._populateAxes();
        this._axesReinitialized = true;
    },
    _populateAxes () {
        var { panes: panes } = this;
        var rotated = this._isRotated();
        var argumentAxesOptions = $fc13be07a1dbfd77$var$prepareAxis(this.option("argumentAxis") || {})[0];
        var valueAxisOption = this.option("valueAxis");
        var valueAxesOptions = $fc13be07a1dbfd77$var$prepareAxis(valueAxisOption || {});
        var argumentAxesPopulatedOptions;
        var valueAxesPopulatedOptions = [];
        var axisNames = [];
        var valueAxesCounter = 0;
        var paneWithNonVirtualAxis;
        var crosshairMargins = this._getCrosshairMargins();
        function getNextAxisName() {
            var name = $fc13be07a1dbfd77$var$DEFAULT_AXIS_NAME + String(valueAxesCounter);
            valueAxesCounter += 1;
            return name;
        }
        if (rotated) paneWithNonVirtualAxis = "right" === argumentAxesOptions.position ? panes[panes.length - 1].name : panes[0].name;
        else paneWithNonVirtualAxis = "top" === argumentAxesOptions.position ? panes[0].name : panes[panes.length - 1].name;
        argumentAxesPopulatedOptions = (0, $dw9tZ.map)(panes, (pane)=>{
            var virtual = pane.name !== paneWithNonVirtualAxis;
            return this._populateAxesOptions("argumentAxis", argumentAxesOptions, {
                pane: pane.name,
                name: null,
                optionPath: "argumentAxis",
                crosshairMargin: rotated ? crosshairMargins.x : crosshairMargins.y
            }, rotated, virtual);
        });
        valueAxesOptions.forEach((axisOptions, priority)=>{
            var _a;
            var axisPanes = [];
            var { name: name } = axisOptions;
            if (name && axisNames.includes(name)) {
                this._incidentOccurred("E2102");
                return;
            }
            if (name) axisNames.push(name);
            if (axisOptions.pane) axisPanes.push(axisOptions.pane);
            if (null === (_a = axisOptions.panes) || void 0 === _a ? void 0 : _a.length) axisPanes = axisPanes.concat(axisOptions.panes.slice(0));
            axisPanes = (0, $dw9tZ.unique)(axisPanes);
            if (!axisPanes.length) axisPanes.push(void 0);
            axisPanes.forEach((pane)=>{
                var optionPath = $fc13be07a1dbfd77$var$isArray(valueAxisOption) ? "valueAxis[".concat(String(priority), "]") : "valueAxis";
                valueAxesPopulatedOptions.push(this._populateAxesOptions("valueAxis", axisOptions, {
                    name: name || getNextAxisName(),
                    pane: pane,
                    priority: priority,
                    optionPath: optionPath,
                    crosshairMargin: rotated ? crosshairMargins.y : crosshairMargins.x
                }, rotated));
            });
        });
        this._redesignAxes(argumentAxesPopulatedOptions, true, paneWithNonVirtualAxis);
        this._redesignAxes(valueAxesPopulatedOptions, false);
    },
    _redesignAxes (options, isArgumentAxes, paneWithNonVirtualAxis) {
        var axesBasis = [];
        var axes = isArgumentAxes ? this._argumentAxes : this._valueAxes;
        options.forEach((opt)=>{
            var curAxes = null === axes || void 0 === axes ? void 0 : axes.filter((a)=>a.name === opt.name && (!(0, $6ntMu.isDefined)(opt.pane) && this.panes.some((p)=>p.name === a.pane) || a.pane === opt.pane));
            if (null === curAxes || void 0 === curAxes ? void 0 : curAxes.length) curAxes.forEach((axis)=>{
                var axisTypes = $fc13be07a1dbfd77$var$getAxisTypes(this._groupsData, axis, isArgumentAxes);
                axis.updateOptions(opt);
                if (isArgumentAxes) axis.setTypes(axisTypes.argumentAxisType, axisTypes.argumentType, "argumentType");
                else axis.setTypes(axisTypes.valueAxisType, axisTypes.valueType, "valueType");
                axis.validate();
                axesBasis.push({
                    axis: axis
                });
            });
            else axesBasis.push({
                options: opt
            });
        });
        if (axes) (0, $8OLOW.reverseEach)(axes, (index, axis)=>{
            if (!axesBasis.some((basis)=>basis.axis && basis.axis === axis)) this._disposeAxis(index, isArgumentAxes);
        });
        else if (isArgumentAxes) axes = this._argumentAxes = [];
        else axes = this._valueAxes = [];
        axesBasis.forEach((basis)=>{
            var { axis: axis } = basis;
            if (basis.axis && isArgumentAxes) basis.axis.isVirtual = basis.axis.pane !== paneWithNonVirtualAxis;
            else if (basis.options) {
                axis = this._createAxis(isArgumentAxes, basis.options, isArgumentAxes ? basis.options.pane !== paneWithNonVirtualAxis : void 0);
                axes.push(axis);
            }
            axis.applyVisualRangeSetter(this._getVisualRangeSetter());
        });
    },
    _disposeAxis (index, isArgumentAxis) {
        var axes = isArgumentAxis ? this._argumentAxes : this._valueAxes;
        var axis = axes[index];
        if (!axis) return;
        axis.dispose();
        axes.splice(index, 1);
    },
    _disposeAxes () {
        var disposeObjectsInArray = this._disposeObjectsInArray;
        disposeObjectsInArray.call(this, "_argumentAxes");
        disposeObjectsInArray.call(this, "_valueAxes");
    },
    _appendAdditionalSeriesGroups () {
        this._crosshairCursorGroup.linkAppend();
        if (this._scrollBar) this._scrollBarGroup.linkAppend();
    },
    _getLegendTargets () {
        return (this.series || []).map((s)=>{
            var item = this._getLegendOptions(s);
            item.legendData.series = s;
            if (!s.getOptions().showInLegend) item.legendData.visible = false;
            return item;
        });
    },
    _legendItemTextField: "name",
    _seriesPopulatedHandlerCore () {
        this._processSeriesFamilies();
        this._processValueAxisFormat();
    },
    _renderTrackers () {
        for(var i = 0; i < this.series.length; i += 1)this.series[i].drawTrackers();
    },
    _specialProcessSeries () {
        this._processSeriesFamilies();
    },
    _processSeriesFamilies () {
        var _a;
        var types = [];
        var families = [];
        var paneSeries;
        var themeManager = this._themeManager;
        var negativesAsZeroes = themeManager.getOptions("negativesAsZeroes");
        var negativesAsZeros = themeManager.getOptions("negativesAsZeros");
        var familyOptions = {
            minBubbleSize: themeManager.getOptions("minBubbleSize"),
            maxBubbleSize: themeManager.getOptions("maxBubbleSize"),
            barGroupPadding: themeManager.getOptions("barGroupPadding"),
            barGroupWidth: themeManager.getOptions("barGroupWidth"),
            negativesAsZeroes: (0, $6ntMu.isDefined)(negativesAsZeroes) ? negativesAsZeroes : negativesAsZeros
        };
        if (null === (_a = this.seriesFamilies) || void 0 === _a ? void 0 : _a.length) {
            this.seriesFamilies.forEach((family)=>{
                family.updateOptions(familyOptions);
                family.adjustSeriesValues();
            });
            return;
        }
        this.series.forEach((item)=>{
            if (!types.includes(item.type)) types.push(item.type);
        });
        this._getLayoutTargets().forEach((pane)=>{
            paneSeries = this._getSeriesForPane(pane.name);
            types.forEach((type)=>{
                var family = new (0, $fMmme.SeriesFamily)({
                    type: type,
                    pane: pane.name,
                    minBubbleSize: familyOptions.minBubbleSize,
                    maxBubbleSize: familyOptions.maxBubbleSize,
                    barGroupPadding: familyOptions.barGroupPadding,
                    barGroupWidth: familyOptions.barGroupWidth,
                    negativesAsZeroes: familyOptions.negativesAsZeroes,
                    rotated: this._isRotated()
                });
                family.add(paneSeries);
                family.adjustSeriesValues();
                families.push(family);
            });
        });
        this.seriesFamilies = families;
    },
    _updateSeriesDimensions () {
        var seriesFamilies = this.seriesFamilies || [];
        for(var i = 0; i < seriesFamilies.length; i += 1){
            var family = seriesFamilies[i];
            family.updateSeriesValues();
            family.adjustSeriesDimensions();
        }
    },
    _getLegendCallBack (series) {
        var _a;
        return null === (_a = this._legend) || void 0 === _a ? void 0 : _a.getActionCallback(series);
    },
    _appendAxesGroups () {
        this._stripsGroup.linkAppend();
        this._gridGroup.linkAppend();
        this._axesGroup.linkAppend();
        this._labelsAxesGroup.linkAppend();
        this._constantLinesGroup.linkAppend();
        this._stripLabelAxesGroup.linkAppend();
        this._scaleBreaksGroup.linkAppend();
    },
    _populateMarginOptions () {
        var bubbleSize = $fc13be07a1dbfd77$var$estimateBubbleSize(this.getSize(), this.panes.length, this._themeManager.getOptions("maxBubbleSize"), this._isRotated());
        var argumentMarginOptions = {};
        this._valueAxes.forEach((valueAxis)=>{
            var groupSeries = this.series.filter((series)=>series.getValueAxis() === valueAxis);
            var marginOptions = {};
            groupSeries.forEach((series)=>{
                if (series.isVisible()) {
                    var seriesMarginOptions = $fc13be07a1dbfd77$var$processBubbleMargin(series.getMarginOptions(), bubbleSize);
                    marginOptions = (0, $dw9tZ.mergeMarginOptions)(marginOptions, seriesMarginOptions);
                    argumentMarginOptions = (0, $dw9tZ.mergeMarginOptions)(argumentMarginOptions, seriesMarginOptions);
                }
            });
            valueAxis.setMarginOptions(marginOptions);
        });
        this._argumentAxes.forEach((a)=>a.setMarginOptions(argumentMarginOptions));
    },
    _populateBusinessRange (updatedAxis, keepRange) {
        var rotated = this._isRotated();
        var series = this._getVisibleSeries();
        var argRanges = {};
        var commonArgRange = new (0, $4jhWa.Range)({
            rotated: !!rotated
        });
        var getPaneName = (axis)=>axis.pane || $fc13be07a1dbfd77$var$DEFAULT_PANE_NAME;
        this.panes.forEach((p)=>{
            argRanges[p.name] = new (0, $4jhWa.Range)({
                rotated: !!rotated
            });
        });
        this._valueAxes.forEach((valueAxis)=>{
            var groupRange = new (0, $4jhWa.Range)({
                rotated: !!rotated,
                pane: valueAxis.pane,
                axis: valueAxis.name
            });
            var groupSeries = series.filter((series)=>series.getValueAxis() === valueAxis);
            groupSeries.forEach((series)=>{
                var seriesRange = series.getRangeData();
                groupRange.addRange(seriesRange.val);
                argRanges[getPaneName(valueAxis)].addRange(seriesRange.arg);
            });
            if (!updatedAxis || updatedAxis && groupSeries.length && valueAxis === updatedAxis) {
                valueAxis.setGroupSeries(groupSeries);
                valueAxis.setBusinessRange(groupRange, this._axesReinitialized || keepRange, this._argumentAxes[0]._lastVisualRangeUpdateMode);
            }
        });
        if (!updatedAxis || updatedAxis && series.length) {
            Object.keys(argRanges).forEach((p)=>commonArgRange.addRange(argRanges[p]));
            var commonInterval = commonArgRange.interval;
            this._argumentAxes.forEach((a)=>{
                var _a;
                var currentInterval = null !== (_a = argRanges[getPaneName(a)].interval) && void 0 !== _a ? _a : commonInterval;
                a.setBusinessRange(new (0, $4jhWa.Range)((0, $4WYaH.default)((0, $4WYaH.default)({}, commonArgRange), {
                    interval: currentInterval
                })), this._axesReinitialized, void 0, this._groupsData.categories);
            });
        }
        this._populateMarginOptions();
    },
    getArgumentAxis () {
        return (this._argumentAxes || []).find((a)=>!a.isVirtual);
    },
    getValueAxis (name) {
        return (this._valueAxes || []).find((0, $6ntMu.isDefined)(name) ? (a)=>a.name === name : (a)=>a.pane === this.defaultPane);
    },
    _getGroupsData () {
        var groups = [];
        this._valueAxes.forEach((axis)=>{
            groups.push({
                series: this.series.filter((series)=>series.getValueAxis() === axis),
                valueAxis: axis,
                valueOptions: axis.getOptions()
            });
        });
        return {
            groups: groups,
            argumentAxes: this._argumentAxes,
            argumentOptions: this._argumentAxes[0].getOptions()
        };
    },
    _groupSeries () {
        this._correctValueAxes(false);
        this._groupsData = this._getGroupsData();
    },
    _processValueAxisFormat () {
        var axesWithFullStackedFormat = [];
        this.series.forEach((series)=>{
            var axis = series.getValueAxis();
            if (series.isFullStackedSeries()) {
                axis.setPercentLabelFormat();
                axesWithFullStackedFormat.push(axis);
            }
        });
        this._valueAxes.forEach((axis)=>{
            if (!axesWithFullStackedFormat.includes(axis)) axis.resetAutoLabelFormat();
        });
    },
    _populateAxesOptions (typeSelector, userOptions, axisOptions, rotated, virtual) {
        var preparedUserOptions = this._prepareStripsAndConstantLines(typeSelector, userOptions, rotated);
        var options = (0, $2oTOp.extend)(true, {}, preparedUserOptions, axisOptions, this._prepareAxisOptions(typeSelector, preparedUserOptions, rotated));
        if (virtual) {
            options.visible = false;
            options.tick.visible = false;
            options.minorTick.visible = false;
            options.label.visible = false;
            options.title = {};
        }
        return options;
    },
    _getValFilter: (series)=>(0, $lPQM0.default).getViewPortFilter(series.getValueAxis().visualRange() || {}),
    _createAxis (isArgumentAxes, options, virtual) {
        var typeSelector = isArgumentAxes ? "argumentAxis" : "valueAxis";
        var renderingSettings = (0, $2oTOp.extend)({
            renderer: this._renderer,
            incidentOccurred: this._incidentOccurred,
            eventTrigger: this._eventTrigger,
            axisClass: isArgumentAxes ? "arg" : "val",
            widgetClass: "dxc",
            stripsGroup: this._stripsGroup,
            stripLabelAxesGroup: this._stripLabelAxesGroup,
            constantLinesGroup: this._constantLinesGroup,
            scaleBreaksGroup: this._scaleBreaksGroup,
            axesContainerGroup: this._axesGroup,
            labelsAxesGroup: this._labelsAxesGroup,
            gridGroup: this._gridGroup,
            isArgumentAxis: isArgumentAxes,
            getTemplate: (template)=>this._getTemplate(template)
        }, this._getAxisRenderingOptions(typeSelector));
        var axis = new (0, $bmLsb.Axis)(renderingSettings);
        axis.updateOptions(options);
        axis.isVirtual = virtual;
        return axis;
    },
    _applyVisualRangeByVirtualAxes: ()=>false,
    _applyCustomVisualRangeOption (axis, range) {
        if (axis.getOptions().optionPath) this._parseVisualRangeOption("".concat(axis.getOptions().optionPath, ".visualRange"), range);
    },
    _getVisualRangeSetter () {
        return (axis, _ref)=>{
            var { skipEventRising: skipEventRising, range: range } = _ref;
            this._applyCustomVisualRangeOption(axis, range);
            axis.setCustomVisualRange(range);
            axis.skipEventRising = skipEventRising;
            if (!this._applyVisualRangeByVirtualAxes(axis, range)) {
                if (this._applyingChanges) this._change_VISUAL_RANGE();
                else this._requestChange([
                    $fc13be07a1dbfd77$var$VISUAL_RANGE
                ]);
            }
        };
    },
    _getTrackerSettings () {
        return (0, $2oTOp.extend)(this.callBase(), {
            argumentAxis: this.getArgumentAxis()
        });
    },
    _prepareStripsAndConstantLines (typeSelector, userOptions, rotated) {
        userOptions = this._themeManager.getOptions(typeSelector, userOptions, rotated);
        if (userOptions.strips) userOptions.strips.forEach((line, i)=>{
            userOptions.strips[i] = (0, $2oTOp.extend)(true, {}, userOptions.stripStyle, line);
        });
        if (userOptions.constantLines) userOptions.constantLines.forEach((line, i)=>{
            userOptions.constantLines[i] = (0, $2oTOp.extend)(true, {}, userOptions.constantLineStyle, line);
        });
        return userOptions;
    },
    refresh () {
        this._disposeAxes();
        this.callBase();
    },
    _layoutAxes (drawAxes) {
        drawAxes();
        var needSpace = this.checkForMoreSpaceForPanesCanvas();
        if (needSpace) {
            var rect = this._rect.slice();
            var size = this._layout.backward(rect, rect, [
                needSpace.width,
                needSpace.height
            ]);
            needSpace.width = Math.max(0, size[0]);
            needSpace.height = Math.max(0, size[1]);
            this._canvas = this._createCanvasFromRect(rect);
            drawAxes(needSpace);
        }
    },
    checkForMoreSpaceForPanesCanvas () {
        return this.layoutManager.needMoreSpaceForPanesCanvas(this._getLayoutTargets(), this._isRotated());
    },
    _parseVisualRangeOption (fullName, value) {
        var _a;
        var name = fullName.split(/[.[]/)[0];
        var index = fullName.match(/\d+/g);
        index = (0, $6ntMu.isDefined)(index) ? parseInt(index[0], 10) : index;
        if (fullName.indexOf("visualRange") > 0) {
            if ("object" !== (0, $6ntMu.type)(value)) value = null !== (_a = $fc13be07a1dbfd77$var$wrapVisualRange(fullName, value)) && void 0 !== _a ? _a : value;
            this._setCustomVisualRange(name, index, value);
        } else if (("object" === (0, $6ntMu.type)(value) || $fc13be07a1dbfd77$var$isArray(value)) && name.indexOf("Axis") > 0 && JSON.stringify(value).indexOf("visualRange") > 0) {
            if ((0, $6ntMu.isDefined)(value.visualRange)) this._setCustomVisualRange(name, index, value.visualRange);
            else if ($fc13be07a1dbfd77$var$isArray(value)) value.forEach((a, i)=>{
                if ((0, $6ntMu.isDefined)(a.visualRange)) this._setCustomVisualRange(name, i, a.visualRange);
            });
        }
    },
    _setCustomVisualRange (axesName, index, value) {
        var options = this._options.silent(axesName);
        if (!options) return;
        if (!(0, $6ntMu.isDefined)(index)) options._customVisualRange = value;
        else options[index]._customVisualRange = value;
        this._axesReinitialized = true;
    },
    _raiseZoomEndHandlers () {
        this._valueAxes.forEach((axis)=>axis.handleZoomEnd());
    },
    _setOptionsByReference () {
        this.callBase();
        (0, $2oTOp.extend)(this._optionsByReference, {
            "valueAxis.visualRange": true
        });
    },
    _notifyOptionChanged (option, value) {
        this.callBase.apply(this, arguments);
        if (!this._optionChangedLocker) this._parseVisualRangeOption(option, value);
    },
    _notifyVisualRange () {
        this._valueAxes.forEach((axis)=>{
            var axisPath = axis.getOptions().optionPath;
            if (axisPath) {
                var path = "".concat(axisPath, ".visualRange");
                var visualRange = (0, $dw9tZ.convertVisualRangeObject)(axis.visualRange(), !$fc13be07a1dbfd77$var$isArray(this.option(path)));
                if (!axis.skipEventRising || !(0, $dw9tZ.rangesAreEqual)(visualRange, this.option(path))) {
                    if (!this.option(axisPath) && "valueAxis" !== axisPath) this.option(axisPath, {
                        name: axis.name,
                        visualRange: visualRange
                    });
                    else this.option(path, visualRange);
                } else axis.skipEventRising = null;
            }
        });
    },
    _notify () {
        this.callBase();
        this._axesReinitialized = false;
        if (true !== this.option("disableTwoWayBinding")) {
            this.skipOptionsRollBack = true;
            this._notifyVisualRange();
            this.skipOptionsRollBack = false;
        }
    },
    _getAxesForScaling () {
        return this._valueAxes;
    },
    _getAxesByOptionPath (arg, isDirectOption, optionName) {
        var sourceAxes = this._getAxesForScaling();
        var axes = [];
        if (isDirectOption) {
            var axisPath;
            if (arg.fullName) axisPath = arg.fullName.slice(0, arg.fullName.indexOf("."));
            axes = sourceAxes.filter((a)=>a.getOptions().optionPath === axisPath);
        } else if ("object" === (0, $6ntMu.type)(arg.value)) axes = sourceAxes.filter((a)=>a.getOptions().optionPath === arg.name);
        else if ($fc13be07a1dbfd77$var$isArray(arg.value)) arg.value.forEach((v, index)=>{
            var axis = sourceAxes.filter((a)=>a.getOptions().optionPath === "".concat(arg.name, "[").concat(index, "]"))[0];
            if ((0, $6ntMu.isDefined)(v[optionName]) && (0, $6ntMu.isDefined)(axis)) axes[index] = axis;
        });
        return axes;
    },
    _optionChanged (arg) {
        if (!this._optionChangedLocker) {
            var axes;
            var isDirectOption = arg.fullName.indexOf("visualRange") > 0 ? true : this.getPartialChangeOptionsName(arg).indexOf("visualRange") > -1 ? false : void 0;
            if ((0, $6ntMu.isDefined)(isDirectOption)) {
                axes = this._getAxesByOptionPath(arg, isDirectOption, "visualRange");
                if (axes) {
                    if (axes.length > 1 || $fc13be07a1dbfd77$var$isArray(arg.value)) axes.forEach((a, index)=>$fc13be07a1dbfd77$var$setAxisVisualRangeByOption(arg, a, isDirectOption, index));
                    else if (1 === axes.length) $fc13be07a1dbfd77$var$setAxisVisualRangeByOption(arg, axes[0], isDirectOption);
                }
            }
        }
        this.callBase(arg);
    },
    _change_VISUAL_RANGE () {
        this._recreateSizeDependentObjects(false);
        if (!this._changes.has("FULL_RENDER")) {
            var resizePanesOnZoom = this.option("resizePanesOnZoom");
            this._doRender({
                force: true,
                drawTitle: false,
                drawLegend: false,
                adjustAxes: null !== resizePanesOnZoom && void 0 !== resizePanesOnZoom ? resizePanesOnZoom : this.option("adjustAxesOnZoom") || false,
                animate: false
            });
            this._raiseZoomEndHandlers();
        }
    },
    resetVisualRange () {
        this._valueAxes.forEach((axis)=>{
            axis.resetVisualRange(false);
            this._applyCustomVisualRangeOption(axis);
        });
        this._requestChange([
            $fc13be07a1dbfd77$var$VISUAL_RANGE
        ]);
    },
    _getCrosshairMargins: ()=>({
            x: 0,
            y: 0
        }),
    _legendDataField: "series",
    _adjustSeriesLabels: (0, $gcp4g.noop),
    _correctValueAxes: (0, $gcp4g.noop)
});

});
parcelRegister("bmLsb", function(module, exports) {

$parcel$export(module.exports, "Axis", function () { return $84668f108f98ba54$export$d06866a9fb0606da; });
/**
 * DevExtreme (esm/viz/axes/base_axis.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $3g0R6 = parcelRequire("3g0R6");

var $dw9tZ = parcelRequire("dw9tZ");

var $6ntMu = parcelRequire("6ntMu");

var $aELZT = parcelRequire("aELZT");

var $2oTOp = parcelRequire("2oTOp");

var $7UWPL = parcelRequire("7UWPL");

var $1zStA = parcelRequire("1zStA");

var $kJz4k = parcelRequire("kJz4k");

var $gkgW0 = parcelRequire("gkgW0");

var $4jhWa = parcelRequire("4jhWa");

var $a6TS4 = parcelRequire("a6TS4");

var $laqiS = parcelRequire("laqiS");

var $f38Z1 = parcelRequire("f38Z1");

var $gcp4g = parcelRequire("gcp4g");

var $ioF0U = parcelRequire("ioF0U");

var $5nic1 = parcelRequire("5nic1");

var $bA6EZ = parcelRequire("bA6EZ");

var $3Pl7q = parcelRequire("3Pl7q");

var $dDkff = parcelRequire("dDkff");

var $53BqL = parcelRequire("53BqL");
var $84668f108f98ba54$var$convertTicksToValues = (0, $aELZT.default).convertTicksToValues;
var $84668f108f98ba54$var$_math = Math;
var $84668f108f98ba54$var$_abs = $84668f108f98ba54$var$_math.abs;
var $84668f108f98ba54$var$_max = $84668f108f98ba54$var$_math.max;
var $84668f108f98ba54$var$_min = $84668f108f98ba54$var$_math.min;
var $84668f108f98ba54$var$_isArray = Array.isArray;
var $84668f108f98ba54$var$DEFAULT_AXIS_LABEL_SPACING = 5;
var $84668f108f98ba54$var$MAX_GRID_BORDER_ADHENSION = 4;
var $84668f108f98ba54$var$TOP = (0, $aELZT.default).top;
var $84668f108f98ba54$var$BOTTOM = (0, $aELZT.default).bottom;
var $84668f108f98ba54$var$LEFT = (0, $aELZT.default).left;
var $84668f108f98ba54$var$RIGHT = (0, $aELZT.default).right;
var $84668f108f98ba54$var$CENTER = (0, $aELZT.default).center;
var $84668f108f98ba54$var$KEEP = "keep";
var $84668f108f98ba54$var$SHIFT = "shift";
var $84668f108f98ba54$var$RESET = "reset";
var $84668f108f98ba54$var$ROTATE = "rotate";
var $84668f108f98ba54$var$DEFAULT_AXIS_DIVISION_FACTOR = 50;
var $84668f108f98ba54$var$DEFAULT_MINOR_AXIS_DIVISION_FACTOR = 15;
var $84668f108f98ba54$var$SCROLL_THRESHOLD = 5;
var $84668f108f98ba54$var$MIN_BAR_MARGIN = 5;
var $84668f108f98ba54$var$MAX_MARGIN_VALUE = .8;
var $84668f108f98ba54$var$dateIntervals = {
    day: 864e5,
    week: 6048e5
};
function $84668f108f98ba54$var$getTickGenerator(options, incidentOccurred, skipTickGeneration, rangeIsEmpty, adjustDivisionFactor, _ref) {
    var _options$workWeek;
    var { allowNegatives: allowNegatives, linearThreshold: linearThreshold } = _ref;
    return (0, $kJz4k.tickGenerator)({
        axisType: options.type,
        dataType: options.dataType,
        logBase: options.logarithmBase,
        allowNegatives: allowNegatives,
        linearThreshold: linearThreshold,
        axisDivisionFactor: adjustDivisionFactor(options.axisDivisionFactor || $84668f108f98ba54$var$DEFAULT_AXIS_DIVISION_FACTOR),
        minorAxisDivisionFactor: adjustDivisionFactor(options.minorAxisDivisionFactor || $84668f108f98ba54$var$DEFAULT_MINOR_AXIS_DIVISION_FACTOR),
        numberMultipliers: options.numberMultipliers,
        calculateMinors: options.minorTick.visible || options.minorGrid.visible || options.calculateMinors,
        allowDecimals: options.allowDecimals,
        endOnTick: options.endOnTick,
        incidentOccurred: incidentOccurred,
        firstDayOfWeek: null === (_options$workWeek = options.workWeek) || void 0 === _options$workWeek ? void 0 : _options$workWeek[0],
        skipTickGeneration: skipTickGeneration,
        skipCalculationLimits: options.skipCalculationLimits,
        generateExtraTick: options.generateExtraTick,
        minTickInterval: options.minTickInterval,
        rangeIsEmpty: rangeIsEmpty
    });
}
function $84668f108f98ba54$var$createMajorTick(axis, renderer, skippedCategory) {
    var options = axis.getOptions();
    return (0, $a6TS4.tick)(axis, renderer, options.tick, options.grid, skippedCategory, false);
}
function $84668f108f98ba54$var$createMinorTick(axis, renderer) {
    var options = axis.getOptions();
    return (0, $a6TS4.tick)(axis, renderer, options.minorTick, options.minorGrid);
}
function $84668f108f98ba54$var$createBoundaryTick(axis, renderer, isFirst) {
    var options = axis.getOptions();
    return (0, $a6TS4.tick)(axis, renderer, (0, $2oTOp.extend)({}, options.tick, {
        visible: options.showCustomBoundaryTicks
    }), options.grid, void 0, false, isFirst ? -1 : 1);
}
function $84668f108f98ba54$var$callAction(elements, action, actionArgument1, actionArgument2) {
    (elements || []).forEach((e)=>e[action](actionArgument1, actionArgument2));
}
function $84668f108f98ba54$var$initTickCoords(ticks) {
    $84668f108f98ba54$var$callAction(ticks, "initCoords");
}
function $84668f108f98ba54$var$drawTickMarks(ticks, options) {
    $84668f108f98ba54$var$callAction(ticks, "drawMark", options);
}
function $84668f108f98ba54$var$drawGrids(ticks, drawLine) {
    $84668f108f98ba54$var$callAction(ticks, "drawGrid", drawLine);
}
function $84668f108f98ba54$var$updateTicksPosition(ticks, options, animate) {
    $84668f108f98ba54$var$callAction(ticks, "updateTickPosition", options, animate);
}
function $84668f108f98ba54$var$updateGridsPosition(ticks, animate) {
    $84668f108f98ba54$var$callAction(ticks, "updateGridPosition", animate);
}
function $84668f108f98ba54$var$cleanUpInvalidTicks(ticks) {
    var i = ticks.length - 1;
    for(i; i >= 0; i--){
        if (!$84668f108f98ba54$var$removeInvalidTick(ticks, i)) break;
    }
    for(i = 0; i < ticks.length; i++){
        if ($84668f108f98ba54$var$removeInvalidTick(ticks, i)) i--;
        else break;
    }
}
function $84668f108f98ba54$var$removeInvalidTick(ticks, i) {
    if (null === ticks[i].coords.x || null === ticks[i].coords.y) {
        ticks.splice(i, 1);
        return true;
    }
    return false;
}
function $84668f108f98ba54$var$validateAxisOptions(options) {
    var _labelOptions$minSpac;
    var labelOptions = options.label;
    var position = options.position;
    var defaultPosition = options.isHorizontal ? $84668f108f98ba54$var$BOTTOM : $84668f108f98ba54$var$LEFT;
    var secondaryPosition = options.isHorizontal ? $84668f108f98ba54$var$TOP : $84668f108f98ba54$var$RIGHT;
    var labelPosition = labelOptions.position;
    if (position !== defaultPosition && position !== secondaryPosition) position = defaultPosition;
    if (!labelPosition || "outside" === labelPosition) labelPosition = position;
    else if ("inside" === labelPosition) labelPosition = ({
        [$84668f108f98ba54$var$TOP]: $84668f108f98ba54$var$BOTTOM,
        [$84668f108f98ba54$var$BOTTOM]: $84668f108f98ba54$var$TOP,
        [$84668f108f98ba54$var$LEFT]: $84668f108f98ba54$var$RIGHT,
        [$84668f108f98ba54$var$RIGHT]: $84668f108f98ba54$var$LEFT
    })[position];
    if (labelPosition !== defaultPosition && labelPosition !== secondaryPosition) labelPosition = position;
    if (labelOptions.alignment !== $84668f108f98ba54$var$CENTER && !labelOptions.userAlignment) labelOptions.alignment = ({
        [$84668f108f98ba54$var$TOP]: $84668f108f98ba54$var$CENTER,
        [$84668f108f98ba54$var$BOTTOM]: $84668f108f98ba54$var$CENTER,
        [$84668f108f98ba54$var$LEFT]: $84668f108f98ba54$var$RIGHT,
        [$84668f108f98ba54$var$RIGHT]: $84668f108f98ba54$var$LEFT
    })[labelPosition];
    options.position = position;
    labelOptions.position = labelPosition;
    options.hoverMode = options.hoverMode ? options.hoverMode.toLowerCase() : "none";
    labelOptions.minSpacing = null !== (_labelOptions$minSpac = labelOptions.minSpacing) && void 0 !== _labelOptions$minSpac ? _labelOptions$minSpac : $84668f108f98ba54$var$DEFAULT_AXIS_LABEL_SPACING;
    options.type && (options.type = options.type.toLowerCase());
    options.argumentType && (options.argumentType = options.argumentType.toLowerCase());
    options.valueType && (options.valueType = options.valueType.toLowerCase());
}
function $84668f108f98ba54$var$getOptimalAngle(boxes, labelOpt) {
    var angle = 180 * $84668f108f98ba54$var$_math.asin((boxes[0].height + labelOpt.minSpacing) / (boxes[1].x - boxes[0].x)) / $84668f108f98ba54$var$_math.PI;
    return angle < 45 ? -45 : -90;
}
function $84668f108f98ba54$var$updateLabels(ticks, step, func) {
    ticks.forEach(function(tick, index) {
        if (tick.getContentContainer()) {
            if (index % step !== 0) tick.removeLabel();
            else if (func) func(tick, index);
        }
    });
}
function $84668f108f98ba54$var$getZoomBoundValue(optionValue, dataValue) {
    if (void 0 === optionValue) return dataValue;
    else if (null === optionValue) return;
    else return optionValue;
}
function $84668f108f98ba54$var$configureGenerator(options, axisDivisionFactor, viewPort, screenDelta, minTickInterval) {
    var tickGeneratorOptions = (0, $2oTOp.extend)({}, options, {
        endOnTick: true,
        axisDivisionFactor: axisDivisionFactor,
        skipCalculationLimits: true,
        generateExtraTick: true,
        minTickInterval: minTickInterval
    });
    return function(tickInterval, skipTickGeneration, min, max, breaks) {
        return $84668f108f98ba54$var$getTickGenerator(tickGeneratorOptions, (0, $gcp4g.noop), skipTickGeneration, viewPort.isEmpty(), (v)=>v, viewPort)({
            min: min,
            max: max,
            categories: viewPort.categories,
            isSpacedMargin: viewPort.isSpacedMargin
        }, screenDelta, tickInterval, (0, $6ntMu.isDefined)(tickInterval), void 0, void 0, void 0, breaks);
    };
}
function $84668f108f98ba54$var$getConstantLineSharpDirection(coord, axisCanvas) {
    return Math.max(axisCanvas.start, axisCanvas.end) !== coord ? 1 : -1;
}
var $84668f108f98ba54$export$d06866a9fb0606da = function(renderSettings) {
    this._renderer = renderSettings.renderer;
    this._incidentOccurred = renderSettings.incidentOccurred;
    this._eventTrigger = renderSettings.eventTrigger;
    this._stripsGroup = renderSettings.stripsGroup;
    this._stripLabelAxesGroup = renderSettings.stripLabelAxesGroup;
    this._labelsAxesGroup = renderSettings.labelsAxesGroup;
    this._constantLinesGroup = renderSettings.constantLinesGroup;
    this._scaleBreaksGroup = renderSettings.scaleBreaksGroup;
    this._axesContainerGroup = renderSettings.axesContainerGroup;
    this._gridContainerGroup = renderSettings.gridGroup;
    this._axisCssPrefix = renderSettings.widgetClass + "-" + (renderSettings.axisClass ? renderSettings.axisClass + "-" : "");
    this._setType(renderSettings.axisType, renderSettings.drawingType);
    this._createAxisGroups();
    this._translator = this._createTranslator();
    this.isArgumentAxis = renderSettings.isArgumentAxis;
    this._viewport = {};
    this._prevDataInfo = {};
    this._firstDrawing = true;
    this._initRange = {};
    this._getTemplate = renderSettings.getTemplate;
};
$84668f108f98ba54$export$d06866a9fb0606da.prototype = {
    constructor: $84668f108f98ba54$export$d06866a9fb0606da,
    _drawAxis () {
        var options = this._options;
        if (!options.visible) return;
        this._axisElement = this._createAxisElement();
        this._updateAxisElementPosition();
        this._axisElement.attr({
            "stroke-width": options.width,
            stroke: options.color,
            "stroke-opacity": options.opacity
        }).sharp(this._getSharpParam(true), this.getAxisSharpDirection()).append(this._axisLineGroup);
    },
    _createPathElement (points, attr, sharpDirection) {
        return this.sharp(this._renderer.path(points, "line").attr(attr), sharpDirection);
    },
    sharp (svgElement) {
        var sharpDirection = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
        return svgElement.sharp(this._getSharpParam(), sharpDirection);
    },
    customPositionIsAvailable: ()=>false,
    getOrthogonalAxis: (0, $gcp4g.noop),
    getCustomPosition: (0, $gcp4g.noop),
    getCustomBoundaryPosition: (0, $gcp4g.noop),
    resolveOverlappingForCustomPositioning: (0, $gcp4g.noop),
    hasNonBoundaryPosition: ()=>false,
    customPositionIsBoundaryOrthogonalAxis: ()=>false,
    getResolvedBoundaryPosition () {
        return this.getOptions().position;
    },
    getAxisSharpDirection () {
        var position = this.getResolvedBoundaryPosition();
        return this.hasNonBoundaryPosition() || position !== $84668f108f98ba54$var$BOTTOM && position !== $84668f108f98ba54$var$RIGHT ? 1 : -1;
    },
    getSharpDirectionByCoords (coords) {
        var canvas = this._getCanvasStartEnd();
        var maxCoord = Math.max(canvas.start, canvas.end);
        return this.getRadius ? 0 : maxCoord !== coords[this._isHorizontal ? "x" : "y"] ? 1 : -1;
    },
    _getGridLineDrawer: function() {
        var that = this;
        return function(tick, gridStyle) {
            var grid = that._getGridPoints(tick.coords);
            if (grid.points) return that._createPathElement(grid.points, gridStyle, that.getSharpDirectionByCoords(tick.coords));
            return null;
        };
    },
    _getGridPoints: function(coords) {
        var isHorizontal = this._isHorizontal;
        var tickPositionField = isHorizontal ? "x" : "y";
        var orthogonalPositions = this._orthogonalPositions;
        var positionFrom = orthogonalPositions.start;
        var positionTo = orthogonalPositions.end;
        var borderOptions = this.borderOptions;
        var canvasStart = isHorizontal ? $84668f108f98ba54$var$LEFT : $84668f108f98ba54$var$TOP;
        var canvasEnd = isHorizontal ? $84668f108f98ba54$var$RIGHT : $84668f108f98ba54$var$BOTTOM;
        var axisCanvas = this.getCanvas();
        var canvas = {
            left: axisCanvas.left,
            right: axisCanvas.width - axisCanvas.right,
            top: axisCanvas.top,
            bottom: axisCanvas.height - axisCanvas.bottom
        };
        var firstBorderLinePosition = borderOptions.visible && borderOptions[canvasStart] ? canvas[canvasStart] : void 0;
        var lastBorderLinePosition = borderOptions.visible && borderOptions[canvasEnd] ? canvas[canvasEnd] : void 0;
        var minDelta = $84668f108f98ba54$var$MAX_GRID_BORDER_ADHENSION + firstBorderLinePosition;
        var maxDelta = lastBorderLinePosition - $84668f108f98ba54$var$MAX_GRID_BORDER_ADHENSION;
        if (this.areCoordsOutsideAxis(coords) || void 0 === coords[tickPositionField] || coords[tickPositionField] < minDelta || coords[tickPositionField] > maxDelta) return {
            points: null
        };
        return {
            points: isHorizontal ? null !== coords[tickPositionField] ? [
                coords[tickPositionField],
                positionFrom,
                coords[tickPositionField],
                positionTo
            ] : null : null !== coords[tickPositionField] ? [
                positionFrom,
                coords[tickPositionField],
                positionTo,
                coords[tickPositionField]
            ] : null
        };
    },
    _getConstantLinePos: function(parsedValue, canvasStart, canvasEnd) {
        var value = this._getTranslatedCoord(parsedValue);
        if (!(0, $6ntMu.isDefined)(value) || value < $84668f108f98ba54$var$_min(canvasStart, canvasEnd) || value > $84668f108f98ba54$var$_max(canvasStart, canvasEnd)) return;
        return value;
    },
    _getConstantLineGraphicAttributes: function(value) {
        var positionFrom = this._orthogonalPositions.start;
        var positionTo = this._orthogonalPositions.end;
        return {
            points: this._isHorizontal ? [
                value,
                positionFrom,
                value,
                positionTo
            ] : [
                positionFrom,
                value,
                positionTo,
                value
            ]
        };
    },
    _createConstantLine: function(value, attr) {
        return this._createPathElement(this._getConstantLineGraphicAttributes(value).points, attr, $84668f108f98ba54$var$getConstantLineSharpDirection(value, this._getCanvasStartEnd()));
    },
    _drawConstantLineLabelText: function(text, x, y, _ref2, group) {
        var { font: font, cssClass: cssClass } = _ref2;
        return this._renderer.text(text, x, y).css((0, $dw9tZ.patchFontOptions)((0, $2oTOp.extend)({}, this._options.label.font, font))).attr({
            align: "center",
            class: cssClass
        }).append(group);
    },
    _drawConstantLineLabels: function(parsedValue, lineLabelOptions, value, group) {
        var _text;
        var text = lineLabelOptions.text;
        var options = this._options;
        var labelOptions = options.label;
        this._checkAlignmentConstantLineLabels(lineLabelOptions);
        text = null !== (_text = text) && void 0 !== _text ? _text : this.formatLabel(parsedValue, labelOptions);
        var coords = this._getConstantLineLabelsCoords(value, lineLabelOptions);
        return this._drawConstantLineLabelText(text, coords.x, coords.y, lineLabelOptions, group);
    },
    _getStripPos: function(startValue, endValue, canvasStart, canvasEnd, range) {
        var isContinuous = !!(range.minVisible || range.maxVisible);
        var categories = (range.categories || []).reduce(function(result, cat) {
            result.push(cat.valueOf());
            return result;
        }, []);
        var start;
        var end;
        var swap;
        var startCategoryIndex;
        var endCategoryIndex;
        if (!isContinuous) {
            if ((0, $6ntMu.isDefined)(startValue) && (0, $6ntMu.isDefined)(endValue)) {
                var _parsedStartValue$val, _parsedEndValue$value;
                var parsedStartValue = this.parser(startValue);
                var parsedEndValue = this.parser(endValue);
                startCategoryIndex = categories.indexOf(null !== (_parsedStartValue$val = null === parsedStartValue || void 0 === parsedStartValue ? void 0 : parsedStartValue.valueOf()) && void 0 !== _parsedStartValue$val ? _parsedStartValue$val : void 0);
                endCategoryIndex = categories.indexOf(null !== (_parsedEndValue$value = null === parsedEndValue || void 0 === parsedEndValue ? void 0 : parsedEndValue.valueOf()) && void 0 !== _parsedEndValue$value ? _parsedEndValue$value : void 0);
                if (-1 === startCategoryIndex || -1 === endCategoryIndex) return {
                    from: 0,
                    to: 0,
                    outOfCanvas: true
                };
                if (startCategoryIndex > endCategoryIndex) {
                    swap = endValue;
                    endValue = startValue;
                    startValue = swap;
                }
            }
        }
        if ((0, $6ntMu.isDefined)(startValue)) {
            startValue = this.validateUnit(startValue, "E2105", "strip");
            start = this._getTranslatedCoord(startValue, -1);
        } else start = canvasStart;
        if ((0, $6ntMu.isDefined)(endValue)) {
            endValue = this.validateUnit(endValue, "E2105", "strip");
            end = this._getTranslatedCoord(endValue, 1);
        } else end = canvasEnd;
        var stripPosition = start < end ? {
            from: start,
            to: end
        } : {
            from: end,
            to: start
        };
        var visibleArea = this.getVisibleArea();
        if (stripPosition.from <= visibleArea[0] && stripPosition.to <= visibleArea[0] || stripPosition.from >= visibleArea[1] && stripPosition.to >= visibleArea[1]) stripPosition.outOfCanvas = true;
        return stripPosition;
    },
    _getStripGraphicAttributes: function(fromPoint, toPoint) {
        var x;
        var y;
        var width;
        var height;
        var orthogonalPositions = this._orthogonalPositions;
        var positionFrom = orthogonalPositions.start;
        var positionTo = orthogonalPositions.end;
        if (this._isHorizontal) {
            x = fromPoint;
            y = $84668f108f98ba54$var$_min(positionFrom, positionTo);
            width = toPoint - fromPoint;
            height = $84668f108f98ba54$var$_abs(positionFrom - positionTo);
        } else {
            x = $84668f108f98ba54$var$_min(positionFrom, positionTo);
            y = fromPoint;
            width = $84668f108f98ba54$var$_abs(positionFrom - positionTo);
            height = $84668f108f98ba54$var$_abs(fromPoint - toPoint);
        }
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    },
    _createStrip: function(attrs) {
        return this._renderer.rect(attrs.x, attrs.y, attrs.width, attrs.height);
    },
    _adjustStripLabels: function() {
        var that = this;
        this._strips.forEach(function(strip) {
            if (strip.label) strip.label.attr(that._getAdjustedStripLabelCoords(strip));
        });
    },
    _adjustLabelsCoord (offset, maxWidth, checkCanvas) {
        var getContainerAttrs = (tick)=>this._getLabelAdjustedCoord(tick, offset + (tick.labelOffset || 0), maxWidth, checkCanvas);
        this._majorTicks.forEach(function(tick) {
            if (tick.label) {
                tick.updateMultilineTextAlignment();
                tick.label.attr(getContainerAttrs(tick));
            } else tick.templateContainer && tick.templateContainer.attr(getContainerAttrs(tick));
        });
    },
    _adjustLabels: function(offset) {
        var options = this.getOptions();
        var positionsAreConsistent = options.position === options.label.position;
        var maxSize = this._majorTicks.reduce(function(size, tick) {
            if (!tick.getContentContainer()) return size;
            var bBox = tick.labelRotationAngle ? (0, $dw9tZ.rotateBBox)(tick.labelBBox, [
                tick.labelCoords.x,
                tick.labelCoords.y
            ], -tick.labelRotationAngle) : tick.labelBBox;
            return {
                width: $84668f108f98ba54$var$_max(size.width || 0, bBox.width),
                height: $84668f108f98ba54$var$_max(size.height || 0, bBox.height),
                offset: $84668f108f98ba54$var$_max(size.offset || 0, tick.labelOffset || 0)
            };
        }, {});
        var additionalOffset = positionsAreConsistent ? this._isHorizontal ? maxSize.height : maxSize.width : 0;
        this._adjustLabelsCoord(offset, maxSize.width);
        return offset + additionalOffset + (additionalOffset && this._options.label.indentFromAxis) + (positionsAreConsistent ? maxSize.offset : 0);
    },
    _getLabelAdjustedCoord: function(tick, offset, maxWidth) {
        offset = offset || 0;
        var options = this._options;
        var templateBox = tick.templateContainer && tick.templateContainer.getBBox();
        var box = templateBox || (0, $dw9tZ.rotateBBox)(tick.labelBBox, [
            tick.labelCoords.x,
            tick.labelCoords.y
        ], -tick.labelRotationAngle || 0);
        var textAlign = tick.labelAlignment || options.label.alignment;
        var isDiscrete = "discrete" === this._options.type;
        var isFlatLabel = tick.labelRotationAngle % 90 === 0;
        var indentFromAxis = options.label.indentFromAxis;
        var labelPosition = options.label.position;
        var axisPosition = this._axisPosition;
        var labelCoords = tick.labelCoords;
        var labelX = labelCoords.x;
        var translateX;
        var translateY;
        if (this._isHorizontal) {
            if (labelPosition === $84668f108f98ba54$var$BOTTOM) translateY = axisPosition + indentFromAxis - box.y + offset;
            else translateY = axisPosition - indentFromAxis - (box.y + box.height) - offset;
            if (textAlign === $84668f108f98ba54$var$RIGHT) translateX = isDiscrete && isFlatLabel ? tick.coords.x - (box.x + box.width) : labelX - box.x - box.width;
            else if (textAlign === $84668f108f98ba54$var$LEFT) translateX = isDiscrete && isFlatLabel ? labelX - box.x - (tick.coords.x - labelX) : labelX - box.x;
            else translateX = labelX - box.x - box.width / 2;
        } else {
            translateY = labelCoords.y - box.y - box.height / 2;
            if (labelPosition === $84668f108f98ba54$var$LEFT) {
                if (textAlign === $84668f108f98ba54$var$LEFT) translateX = axisPosition - indentFromAxis - maxWidth - box.x;
                else if (textAlign === $84668f108f98ba54$var$CENTER) translateX = axisPosition - indentFromAxis - maxWidth / 2 - box.x - box.width / 2;
                else translateX = axisPosition - indentFromAxis - box.x - box.width;
                translateX -= offset;
            } else {
                if (textAlign === $84668f108f98ba54$var$RIGHT) translateX = axisPosition + indentFromAxis + maxWidth - box.x - box.width;
                else if (textAlign === $84668f108f98ba54$var$CENTER) translateX = axisPosition + indentFromAxis + maxWidth / 2 - box.x - box.width / 2;
                else translateX = axisPosition + indentFromAxis - box.x;
                translateX += offset;
            }
        }
        return {
            translateX: translateX,
            translateY: translateY
        };
    },
    _createAxisConstantLineGroups: function() {
        var renderer = this._renderer;
        var classSelector = this._axisCssPrefix;
        var constantLinesClass = classSelector + "constant-lines";
        var insideGroup = renderer.g().attr({
            class: constantLinesClass
        });
        var outsideGroup1 = renderer.g().attr({
            class: constantLinesClass
        });
        var outsideGroup2 = renderer.g().attr({
            class: constantLinesClass
        });
        return {
            inside: insideGroup,
            outside1: outsideGroup1,
            left: outsideGroup1,
            top: outsideGroup1,
            outside2: outsideGroup2,
            right: outsideGroup2,
            bottom: outsideGroup2,
            remove: function() {
                this.inside.remove();
                this.outside1.remove();
                this.outside2.remove();
            },
            clear: function() {
                this.inside.clear();
                this.outside1.clear();
                this.outside2.clear();
            }
        };
    },
    _createAxisGroups: function() {
        var renderer = this._renderer;
        var classSelector = this._axisCssPrefix;
        this._axisGroup = renderer.g().attr({
            class: classSelector + "axis"
        }).enableLinks();
        this._axisStripGroup = renderer.g().attr({
            class: classSelector + "strips"
        });
        this._axisGridGroup = renderer.g().attr({
            class: classSelector + "grid"
        });
        this._axisElementsGroup = renderer.g().attr({
            class: classSelector + "elements"
        });
        this._axisLineGroup = renderer.g().attr({
            class: classSelector + "line"
        }).linkOn(this._axisGroup, "axisLine").linkAppend();
        this._axisTitleGroup = renderer.g().attr({
            class: classSelector + "title"
        }).append(this._axisGroup);
        this._axisConstantLineGroups = {
            above: this._createAxisConstantLineGroups(),
            under: this._createAxisConstantLineGroups()
        };
        this._axisStripLabelGroup = renderer.g().attr({
            class: classSelector + "axis-labels"
        });
    },
    _clearAxisGroups: function() {
        this._axisGroup.remove();
        this._axisStripGroup.remove();
        this._axisStripLabelGroup.remove();
        this._axisConstantLineGroups.above.remove();
        this._axisConstantLineGroups.under.remove();
        this._axisGridGroup.remove();
        this._axisTitleGroup.clear();
        if (!this._options.label.template || !this.isRendered()) {
            this._axisElementsGroup.remove();
            this._axisElementsGroup.clear();
        }
        this._axisLineGroup && this._axisLineGroup.clear();
        this._axisStripGroup && this._axisStripGroup.clear();
        this._axisGridGroup && this._axisGridGroup.clear();
        this._axisConstantLineGroups.above.clear();
        this._axisConstantLineGroups.under.clear();
        this._axisStripLabelGroup && this._axisStripLabelGroup.clear();
    },
    _getLabelFormatObject: function(value, labelOptions, range, point, tickInterval, ticks) {
        range = range || this._getViewportRange();
        var formatObject = {
            value: value,
            valueText: (0, $3g0R6.smartFormatter)(value, {
                labelOptions: labelOptions,
                ticks: ticks || $84668f108f98ba54$var$convertTicksToValues(this._majorTicks),
                tickInterval: null !== tickInterval && void 0 !== tickInterval ? tickInterval : this._tickInterval,
                dataType: this._options.dataType,
                logarithmBase: this._options.logarithmBase,
                type: this._options.type,
                showTransition: !this._options.marker.visible,
                point: point
            }) || "",
            min: range.minVisible,
            max: range.maxVisible
        };
        if (point) formatObject.point = point;
        return formatObject;
    },
    formatLabel: function(value, labelOptions, range, point, tickInterval, ticks) {
        var formatObject = this._getLabelFormatObject(value, labelOptions, range, point, tickInterval, ticks);
        return (0, $6ntMu.isFunction)(labelOptions.customizeText) ? labelOptions.customizeText.call(formatObject, formatObject) : formatObject.valueText;
    },
    formatHint: function(value, labelOptions, range) {
        var formatObject = this._getLabelFormatObject(value, labelOptions, range);
        return (0, $6ntMu.isFunction)(labelOptions.customizeHint) ? labelOptions.customizeHint.call(formatObject, formatObject) : void 0;
    },
    formatRange (startValue, endValue, interval, argumentFormat) {
        return (0, $3g0R6.formatRange)({
            startValue: startValue,
            endValue: endValue,
            tickInterval: interval,
            argumentFormat: argumentFormat,
            axisOptions: this.getOptions()
        });
    },
    _setTickOffset: function() {
        var options = this._options;
        var discreteAxisDivisionMode = options.discreteAxisDivisionMode;
        this._tickOffset = +("crossLabels" !== discreteAxisDivisionMode || !discreteAxisDivisionMode);
    },
    aggregatedPointBetweenTicks () {
        return "crossTicks" === this._options.aggregatedPointsPosition;
    },
    resetApplyingAnimation: function(isFirstDrawing) {
        this._resetApplyingAnimation = true;
        if (isFirstDrawing) this._firstDrawing = true;
    },
    isFirstDrawing () {
        return this._firstDrawing;
    },
    getMargins: function() {
        var that = this;
        var { position: position, offset: offset, customPosition: customPosition, placeholderSize: placeholderSize, grid: grid, tick: tick, crosshairMargin: crosshairMargin } = that._options;
        var isDefinedCustomPositionOption = (0, $6ntMu.isDefined)(customPosition);
        var boundaryPosition = that.getResolvedBoundaryPosition();
        var canvas = that.getCanvas();
        var cLeft = canvas.left;
        var cTop = canvas.top;
        var cRight = canvas.width - canvas.right;
        var cBottom = canvas.height - canvas.bottom;
        var edgeMarginCorrection = $84668f108f98ba54$var$_max(grid.visible && grid.width || 0, tick.visible && tick.width || 0);
        var constantLineAboveSeries = that._axisConstantLineGroups.above;
        var constantLineUnderSeries = that._axisConstantLineGroups.under;
        var boxes = [
            that._axisElementsGroup,
            constantLineAboveSeries.outside1,
            constantLineAboveSeries.outside2,
            constantLineUnderSeries.outside1,
            constantLineUnderSeries.outside2,
            that._axisLineGroup
        ].map((group)=>group && group.getBBox()).concat(function(group) {
            var box = group && group.getBBox();
            if (!box || box.isEmpty) return box;
            if (that._isHorizontal) {
                box.x = cLeft;
                box.width = cRight - cLeft;
            } else {
                box.y = cTop;
                box.height = cBottom - cTop;
            }
            return box;
        }(that._axisTitleGroup));
        var margins = (0, $53BqL.calculateCanvasMargins)(boxes, canvas);
        margins[position] += crosshairMargin;
        if (that.hasNonBoundaryPosition() && isDefinedCustomPositionOption) margins[boundaryPosition] = 0;
        if (placeholderSize) margins[position] = placeholderSize;
        if (edgeMarginCorrection) {
            if (that._isHorizontal && canvas.right < edgeMarginCorrection && margins.right < edgeMarginCorrection) margins.right = edgeMarginCorrection;
            if (!that._isHorizontal && canvas.bottom < edgeMarginCorrection && margins.bottom < edgeMarginCorrection) margins.bottom = edgeMarginCorrection;
        }
        if (!isDefinedCustomPositionOption && (0, $6ntMu.isDefined)(offset)) {
            var moveByOffset = that.customPositionIsBoundary() && (offset > 0 && (boundaryPosition === $84668f108f98ba54$var$LEFT || boundaryPosition === $84668f108f98ba54$var$TOP) || offset < 0 && (boundaryPosition === $84668f108f98ba54$var$RIGHT || boundaryPosition === $84668f108f98ba54$var$BOTTOM));
            margins[boundaryPosition] -= moveByOffset ? offset : 0;
        }
        return margins;
    },
    validateUnit: function(unit, idError, parameters) {
        unit = this.parser(unit);
        if (void 0 === unit && idError) this._incidentOccurred(idError, [
            parameters
        ]);
        return unit;
    },
    _setType: function(axisType, drawingType) {
        var axisTypeMethods;
        switch(axisType){
            case "xyAxes":
                axisTypeMethods = (0, $ioF0U.default);
                break;
            case "polarAxes":
                axisTypeMethods = $5nic1;
        }
        (0, $2oTOp.extend)(this, axisTypeMethods[drawingType]);
    },
    _getSharpParam: function() {
        return true;
    },
    _disposeBreaksGroup: (0, $gcp4g.noop),
    dispose: function() {
        [
            this._axisElementsGroup,
            this._axisStripGroup,
            this._axisGroup
        ].forEach(function(g) {
            g.dispose();
        });
        this._strips = this._title = null;
        this._axisStripGroup = this._axisConstantLineGroups = this._axisStripLabelGroup = this._axisBreaksGroup = null;
        this._axisLineGroup = this._axisElementsGroup = this._axisGridGroup = null;
        this._axisGroup = this._axisTitleGroup = null;
        this._axesContainerGroup = this._stripsGroup = this._constantLinesGroup = this._labelsAxesGroup = null;
        this._renderer = this._options = this._textOptions = this._textFontStyles = null;
        this._translator = null;
        this._majorTicks = this._minorTicks = null;
        this._disposeBreaksGroup();
        this._templatesRendered && this._templatesRendered.reject();
    },
    getOptions: function() {
        return this._options;
    },
    setPane: function(pane) {
        this.pane = pane;
        this._options.pane = pane;
    },
    setTypes: function(type, axisType, typeSelector) {
        this._options.type = type || this._options.type;
        this._options[typeSelector] = axisType || this._options[typeSelector];
        this._updateTranslator();
    },
    resetTypes: function(typeSelector) {
        this._options.type = this._initTypes.type;
        this._options[typeSelector] = this._initTypes[typeSelector];
    },
    getTranslator: function() {
        return this._translator;
    },
    updateOptions: function(options) {
        var that = this;
        var labelOpt = options.label;
        $84668f108f98ba54$var$validateAxisOptions(options);
        that._options = options;
        options.tick = options.tick || {};
        options.minorTick = options.minorTick || {};
        options.grid = options.grid || {};
        options.minorGrid = options.minorGrid || {};
        options.title = options.title || {};
        options.marker = options.marker || {};
        that._initTypes = {
            type: options.type,
            argumentType: options.argumentType,
            valueType: options.valueType
        };
        that._setTickOffset();
        that._isHorizontal = options.isHorizontal;
        that.pane = options.pane;
        that.name = options.name;
        that.priority = options.priority;
        that._hasLabelFormat = "" !== labelOpt.format && (0, $6ntMu.isDefined)(labelOpt.format);
        that._textOptions = {
            opacity: labelOpt.opacity,
            align: "center",
            class: labelOpt.cssClass
        };
        that._textFontStyles = (0, $dw9tZ.patchFontOptions)(labelOpt.font);
        if (options.type === (0, $aELZT.default).logarithmic) {
            if (options.logarithmBaseError) {
                that._incidentOccurred("E2104");
                delete options.logarithmBaseError;
            }
        }
        that._updateTranslator();
        that._createConstantLines();
        that._strips = (options.strips || []).map((o)=>(0, $3Pl7q.default)(that, o));
        that._majorTicks = that._minorTicks = null;
        that._firstDrawing = true;
    },
    calculateInterval: function(value, prevValue) {
        var options = this._options;
        if (!options || options.type !== (0, $aELZT.default).logarithmic) return $84668f108f98ba54$var$_abs(value - prevValue);
        var { allowNegatives: allowNegatives, linearThreshold: linearThreshold } = new (0, $4jhWa.Range)(this.getTranslator().getBusinessRange());
        return $84668f108f98ba54$var$_abs((0, $dw9tZ.getLogExt)(value, options.logarithmBase, allowNegatives, linearThreshold) - (0, $dw9tZ.getLogExt)(prevValue, options.logarithmBase, allowNegatives, linearThreshold));
    },
    getCanvasRange () {
        var translator = this._translator;
        return {
            startValue: translator.from(translator.translate("canvas_position_start")),
            endValue: translator.from(translator.translate("canvas_position_end"))
        };
    },
    _processCanvas: function(canvas) {
        return canvas;
    },
    updateCanvas: function(canvas, canvasRedesign) {
        if (!canvasRedesign) {
            var positions = this._orthogonalPositions = {
                start: !this._isHorizontal ? canvas.left : canvas.top,
                end: !this._isHorizontal ? canvas.width - canvas.right : canvas.height - canvas.bottom
            };
            positions.center = positions.start + (positions.end - positions.start) / 2;
        } else this._orthogonalPositions = null;
        this._canvas = canvas;
        this._translator.updateCanvas(this._processCanvas(canvas));
        this._initAxisPositions();
    },
    getCanvas: function() {
        return this._canvas;
    },
    getAxisShift () {
        return this._axisShift || 0;
    },
    hideTitle: function() {
        if (this._options.title.text) {
            this._incidentOccurred("W2105", [
                this._isHorizontal ? "horizontal" : "vertical"
            ]);
            this._axisTitleGroup.clear();
        }
    },
    getTitle: function() {
        return this._title;
    },
    hideOuterElements: function() {
        var options = this._options;
        if ((options.label.visible || this._outsideConstantLines.length) && !this._translator.getBusinessRange().isEmpty()) {
            this._incidentOccurred("W2106", [
                this._isHorizontal ? "horizontal" : "vertical"
            ]);
            this._axisElementsGroup.clear();
            $84668f108f98ba54$var$callAction(this._outsideConstantLines, "removeLabel");
        }
    },
    _resolveLogarithmicOptionsForRange (range) {
        var options = this._options;
        if (options.type === (0, $aELZT.default).logarithmic) {
            range.addRange({
                allowNegatives: void 0 !== options.allowNegatives ? options.allowNegatives : range.min <= 0
            });
            if (!isNaN(options.linearThreshold)) range.linearThreshold = options.linearThreshold;
        }
    },
    adjustViewport (businessRange) {
        var options = this._options;
        var isDiscrete = options.type === (0, $aELZT.default).discrete;
        var categories = this._seriesData && this._seriesData.categories || [];
        var wholeRange = this.adjustRange((0, $dw9tZ.getVizRangeObject)(options.wholeRange));
        var visualRange = this.getViewport() || {};
        var result = new (0, $4jhWa.Range)(businessRange);
        this._addConstantLinesToRange(result);
        var minDefined = (0, $6ntMu.isDefined)(visualRange.startValue);
        var maxDefined = (0, $6ntMu.isDefined)(visualRange.endValue);
        if (!isDiscrete) {
            minDefined = minDefined && (!(0, $6ntMu.isDefined)(wholeRange.endValue) || visualRange.startValue < wholeRange.endValue);
            maxDefined = maxDefined && (!(0, $6ntMu.isDefined)(wholeRange.startValue) || visualRange.endValue > wholeRange.startValue);
        }
        var minVisible = minDefined ? visualRange.startValue : result.minVisible;
        var maxVisible = maxDefined ? visualRange.endValue : result.maxVisible;
        if (!isDiscrete) {
            var _wholeRange$startValu, _wholeRange$endValue;
            result.min = null !== (_wholeRange$startValu = wholeRange.startValue) && void 0 !== _wholeRange$startValu ? _wholeRange$startValu : result.min;
            result.max = null !== (_wholeRange$endValue = wholeRange.endValue) && void 0 !== _wholeRange$endValue ? _wholeRange$endValue : result.max;
        } else {
            var categoriesInfo = (0, $dw9tZ.getCategoriesInfo)(categories, wholeRange.startValue, wholeRange.endValue);
            categories = categoriesInfo.categories;
            result.categories = categories;
        }
        var adjustedVisualRange = (0, $dw9tZ.adjustVisualRange)({
            axisType: options.type,
            dataType: options.dataType,
            base: options.logarithmBase
        }, {
            startValue: minDefined ? visualRange.startValue : void 0,
            endValue: maxDefined ? visualRange.endValue : void 0,
            length: visualRange.length
        }, {
            categories: categories,
            min: wholeRange.startValue,
            max: wholeRange.endValue
        }, {
            categories: categories,
            min: minVisible,
            max: maxVisible
        });
        result.minVisible = adjustedVisualRange.startValue;
        result.maxVisible = adjustedVisualRange.endValue;
        !(0, $6ntMu.isDefined)(result.min) && (result.min = result.minVisible);
        !(0, $6ntMu.isDefined)(result.max) && (result.max = result.maxVisible);
        result.addRange({});
        this._resolveLogarithmicOptionsForRange(result);
        return result;
    },
    adjustRange (range) {
        range = range || {};
        var isDiscrete = this._options.type === (0, $aELZT.default).discrete;
        var isLogarithmic = this._options.type === (0, $aELZT.default).logarithmic;
        var disabledNegatives = false === this._options.allowNegatives;
        if (isLogarithmic) {
            range.startValue = disabledNegatives && range.startValue <= 0 ? null : range.startValue;
            range.endValue = disabledNegatives && range.endValue <= 0 ? null : range.endValue;
        }
        if (!isDiscrete && (0, $6ntMu.isDefined)(range.startValue) && (0, $6ntMu.isDefined)(range.endValue) && range.startValue > range.endValue) {
            var tmp = range.endValue;
            range.endValue = range.startValue;
            range.startValue = tmp;
        }
        return range;
    },
    _getVisualRangeUpdateMode (viewport, newRange, oppositeValue) {
        var value = this._options.visualRangeUpdateMode;
        var translator = this._translator;
        var range = this._seriesData;
        var prevDataInfo = this._prevDataInfo;
        if (prevDataInfo.isEmpty && !prevDataInfo.containsConstantLine) return $84668f108f98ba54$var$KEEP;
        if (!this.isArgumentAxis) {
            var _viewport = this.getViewport();
            if (!(0, $6ntMu.isDefined)(_viewport.startValue) && !(0, $6ntMu.isDefined)(_viewport.endValue) && !(0, $6ntMu.isDefined)(_viewport.length)) return $84668f108f98ba54$var$RESET;
        }
        if (this.isArgumentAxis) {
            if (-1 === [
                $84668f108f98ba54$var$SHIFT,
                $84668f108f98ba54$var$KEEP,
                $84668f108f98ba54$var$RESET
            ].indexOf(value)) {
                if (range.axisType === (0, $aELZT.default).discrete) {
                    var categories = range.categories;
                    var newCategories = newRange.categories;
                    var visualRange = this.visualRange();
                    if (categories && newCategories && categories.length && -1 !== newCategories.map((c)=>c.valueOf()).join(",").indexOf(categories.map((c)=>c.valueOf()).join(",")) && (visualRange.startValue.valueOf() !== categories[0].valueOf() || visualRange.endValue.valueOf() !== categories[categories.length - 1].valueOf())) value = $84668f108f98ba54$var$KEEP;
                    else value = $84668f108f98ba54$var$RESET;
                } else {
                    var minPoint = translator.translate(range.min);
                    var minVisiblePoint = translator.translate(viewport.startValue);
                    var maxPoint = translator.translate(range.max);
                    var maxVisiblePoint = translator.translate(viewport.endValue);
                    if (minPoint === minVisiblePoint && maxPoint === maxVisiblePoint) value = $84668f108f98ba54$var$RESET;
                    else if (minPoint !== minVisiblePoint && maxPoint === maxVisiblePoint) value = $84668f108f98ba54$var$SHIFT;
                    else value = $84668f108f98ba54$var$KEEP;
                }
                if (value === $84668f108f98ba54$var$KEEP && prevDataInfo.isEmpty && prevDataInfo.containsConstantLine) value = $84668f108f98ba54$var$RESET;
            }
        } else if (-1 === [
            $84668f108f98ba54$var$KEEP,
            $84668f108f98ba54$var$RESET
        ].indexOf(value)) {
            if (oppositeValue === $84668f108f98ba54$var$KEEP) value = $84668f108f98ba54$var$KEEP;
            else value = $84668f108f98ba54$var$RESET;
        }
        return value;
    },
    _handleBusinessRangeChanged (oppositeVisualRangeUpdateMode, axisReinitialized, newRange) {
        var visualRange = this.visualRange();
        if (axisReinitialized || this._translator.getBusinessRange().isEmpty()) return;
        var visualRangeUpdateMode = this._lastVisualRangeUpdateMode = this._getVisualRangeUpdateMode(visualRange, newRange, oppositeVisualRangeUpdateMode);
        if (visualRangeUpdateMode === $84668f108f98ba54$var$KEEP) this._setVisualRange([
            visualRange.startValue,
            visualRange.endValue
        ]);
        else if (visualRangeUpdateMode === $84668f108f98ba54$var$RESET) this._setVisualRange([
            null,
            null
        ]);
        else if (visualRangeUpdateMode === $84668f108f98ba54$var$SHIFT) this._setVisualRange({
            length: this.getVisualRangeLength()
        });
    },
    getVisualRangeLength (range) {
        var currentBusinessRange = range || this._translator.getBusinessRange();
        var { type: type } = this._options;
        var length;
        if (type === (0, $aELZT.default).logarithmic) length = (0, $laqiS.adjust)(this.calculateInterval(currentBusinessRange.maxVisible, currentBusinessRange.minVisible));
        else if (type === (0, $aELZT.default).discrete) {
            var categoriesInfo = (0, $dw9tZ.getCategoriesInfo)(currentBusinessRange.categories, currentBusinessRange.minVisible, currentBusinessRange.maxVisible);
            length = categoriesInfo.categories.length;
        } else length = currentBusinessRange.maxVisible - currentBusinessRange.minVisible;
        return length;
    },
    getVisualRangeCenter (range, useMerge) {
        var translator = this.getTranslator();
        var businessRange = translator.getBusinessRange();
        var currentBusinessRange = useMerge ? (0, $2oTOp.extend)(true, {}, businessRange, range || {}) : range || businessRange;
        var { type: type, logarithmBase: logarithmBase } = this._options;
        var center;
        if (!(0, $6ntMu.isDefined)(currentBusinessRange.minVisible) || !(0, $6ntMu.isDefined)(currentBusinessRange.maxVisible)) return;
        if (type === (0, $aELZT.default).logarithmic) {
            var { allowNegatives: allowNegatives, linearThreshold: linearThreshold, minVisible: minVisible, maxVisible: maxVisible } = currentBusinessRange;
            center = (0, $dw9tZ.raiseToExt)((0, $laqiS.adjust)((0, $dw9tZ.getLogExt)(maxVisible, logarithmBase, allowNegatives, linearThreshold) + (0, $dw9tZ.getLogExt)(minVisible, logarithmBase, allowNegatives, linearThreshold)) / 2, logarithmBase, allowNegatives, linearThreshold);
        } else if (type === (0, $aELZT.default).discrete) {
            var categoriesInfo = (0, $dw9tZ.getCategoriesInfo)(currentBusinessRange.categories, currentBusinessRange.minVisible, currentBusinessRange.maxVisible);
            var index = Math.ceil(categoriesInfo.categories.length / 2) - 1;
            center = businessRange.categories.indexOf(categoriesInfo.categories[index]);
        } else center = translator.toValue((currentBusinessRange.maxVisible.valueOf() + currentBusinessRange.minVisible.valueOf()) / 2);
        return center;
    },
    setBusinessRange (range, axisReinitialized, oppositeVisualRangeUpdateMode, argCategories) {
        var _that$_seriesData$min, _that$_seriesData$max;
        var options = this._options;
        var isDiscrete = options.type === (0, $aELZT.default).discrete;
        this._handleBusinessRangeChanged(oppositeVisualRangeUpdateMode, axisReinitialized, range);
        this._seriesData = new (0, $4jhWa.Range)(range);
        var dataIsEmpty = this._seriesData.isEmpty();
        var rangeWithConstantLines = new (0, $4jhWa.Range)(this._seriesData);
        this._addConstantLinesToRange(rangeWithConstantLines);
        this._prevDataInfo = {
            isEmpty: dataIsEmpty,
            containsConstantLine: rangeWithConstantLines.containsConstantLine
        };
        this._seriesData.addRange({
            categories: options.categories,
            dataType: options.dataType,
            axisType: options.type,
            base: options.logarithmBase,
            invert: options.inverted
        });
        this._resolveLogarithmicOptionsForRange(this._seriesData);
        if (!isDiscrete) {
            if (!(0, $6ntMu.isDefined)(this._seriesData.min) && !(0, $6ntMu.isDefined)(this._seriesData.max)) {
                var visualRange = this.getViewport();
                visualRange && this._seriesData.addRange({
                    min: visualRange.startValue,
                    max: visualRange.endValue
                });
            }
            var synchronizedValue = options.synchronizedValue;
            if ((0, $6ntMu.isDefined)(synchronizedValue)) this._seriesData.addRange({
                min: synchronizedValue,
                max: synchronizedValue
            });
        }
        this._seriesData.minVisible = null !== (_that$_seriesData$min = this._seriesData.minVisible) && void 0 !== _that$_seriesData$min ? _that$_seriesData$min : this._seriesData.min;
        this._seriesData.maxVisible = null !== (_that$_seriesData$max = this._seriesData.maxVisible) && void 0 !== _that$_seriesData$max ? _that$_seriesData$max : this._seriesData.max;
        if (!this.isArgumentAxis && options.showZero) this._seriesData.correctValueZeroLevel();
        this._seriesData.sortCategories(this.getCategoriesSorter(argCategories));
        this._seriesData.userBreaks = this._seriesData.isEmpty() ? [] : this._getScaleBreaks(options, this._seriesData, this._series, this.isArgumentAxis);
        this._translator.updateBusinessRange(this._getViewportRange());
    },
    _addConstantLinesToRange (dataRange) {
        this._outsideConstantLines.concat(this._insideConstantLines || []).forEach((cl)=>{
            if (cl.options.extendAxis) {
                var value = cl.getParsedValue();
                dataRange.addRange({
                    containsConstantLine: true,
                    minVisible: value,
                    maxVisible: value,
                    min: !(0, $6ntMu.isDefined)(dataRange.min) ? value : dataRange.min,
                    max: !(0, $6ntMu.isDefined)(dataRange.max) ? value : dataRange.max
                });
            }
        });
    },
    setGroupSeries: function(series) {
        this._series = series;
    },
    getLabelsPosition: function() {
        var options = this._options;
        var position = options.position;
        var labelShift = options.label.indentFromAxis + (this._axisShift || 0) + this._constantLabelOffset;
        var axisPosition = this._axisPosition;
        return position === $84668f108f98ba54$var$TOP || position === $84668f108f98ba54$var$LEFT ? axisPosition - labelShift : axisPosition + labelShift;
    },
    getFormattedValue: function(value, options, point) {
        var labelOptions = this._options.label;
        return (0, $6ntMu.isDefined)(value) ? this.formatLabel(value, (0, $2oTOp.extend)(true, {}, labelOptions, options), void 0, point) : null;
    },
    _getBoundaryTicks: function(majors, viewPort) {
        var length = majors.length;
        var options = this._options;
        var customBounds = options.customBoundTicks;
        var min = viewPort.minVisible;
        var max = viewPort.maxVisible;
        var addMinMax = options.showCustomBoundaryTicks ? this._boundaryTicksVisibility : {};
        var boundaryTicks = [];
        if (options.type === (0, $aELZT.default).discrete) {
            if (this._tickOffset && 0 !== majors.length) boundaryTicks = [
                majors[0],
                majors[majors.length - 1]
            ];
        } else if (customBounds) {
            if (addMinMax.min && (0, $6ntMu.isDefined)(customBounds[0])) boundaryTicks.push(customBounds[0]);
            if (addMinMax.max && (0, $6ntMu.isDefined)(customBounds[1])) boundaryTicks.push(customBounds[1]);
        } else {
            if (addMinMax.min && (0 === length || majors[0] > min)) boundaryTicks.push(min);
            if (addMinMax.max && (0 === length || majors[length - 1] < max)) boundaryTicks.push(max);
        }
        return boundaryTicks;
    },
    setPercentLabelFormat: function() {
        if (!this._hasLabelFormat) this._options.label.format = "percent";
    },
    resetAutoLabelFormat: function() {
        if (!this._hasLabelFormat) delete this._options.label.format;
    },
    getMultipleAxesSpacing: function() {
        return this._options.multipleAxesSpacing || 0;
    },
    getTicksValues: function() {
        return {
            majorTicksValues: $84668f108f98ba54$var$convertTicksToValues(this._majorTicks),
            minorTicksValues: $84668f108f98ba54$var$convertTicksToValues(this._minorTicks)
        };
    },
    estimateTickInterval: function(canvas) {
        this.updateCanvas(canvas);
        return this._tickInterval !== this._getTicks(this._getViewportRange(), (0, $gcp4g.noop), true).tickInterval;
    },
    setTicks: function(ticks) {
        var majors = ticks.majorTicks || [];
        this._majorTicks = majors.map($84668f108f98ba54$var$createMajorTick(this, this._renderer, this._getSkippedCategory(majors)));
        this._minorTicks = (ticks.minorTicks || []).map($84668f108f98ba54$var$createMinorTick(this, this._renderer));
        this._isSynchronized = true;
    },
    _adjustDivisionFactor: function(val) {
        return val;
    },
    _getTicks: function(viewPort, incidentOccurred, skipTickGeneration) {
        var options = this._options;
        var customTicks = options.customTicks;
        var customMinorTicks = options.customMinorTicks;
        return $84668f108f98ba54$var$getTickGenerator(options, incidentOccurred || this._incidentOccurred, skipTickGeneration, this._translator.getBusinessRange().isEmpty(), this._adjustDivisionFactor.bind(this), viewPort)({
            min: viewPort.minVisible,
            max: viewPort.maxVisible,
            categories: viewPort.categories,
            isSpacedMargin: viewPort.isSpacedMargin
        }, this._getScreenDelta(), options.tickInterval, "ignore" === options.label.overlappingBehavior || options.forceUserTickInterval, {
            majors: customTicks,
            minors: customMinorTicks
        }, options.minorTickInterval, options.minorTickCount, this._initialBreaks);
    },
    _createTicksAndLabelFormat: function(range, incidentOccurred) {
        var options = this._options;
        var ticks = this._getTicks(range, incidentOccurred, false);
        if (!range.isEmpty() && options.type === (0, $aELZT.default).discrete && "datetime" === options.dataType && !this._hasLabelFormat && ticks.ticks.length) options.label.format = (0, $7UWPL.default).getDateFormatByTicks(ticks.ticks);
        return ticks;
    },
    getAggregationInfo (useAllAggregatedPoints, range) {
        var _visualRange$startVal, _visualRange$endValue, _that$_seriesData;
        var options = this._options;
        var marginOptions = this._marginOptions;
        var businessRange = new (0, $4jhWa.Range)(this.getTranslator().getBusinessRange()).addRange(range);
        var visualRange = this.getViewport();
        var minVisible = null !== (_visualRange$startVal = null === visualRange || void 0 === visualRange ? void 0 : visualRange.startValue) && void 0 !== _visualRange$startVal ? _visualRange$startVal : businessRange.minVisible;
        var maxVisible = null !== (_visualRange$endValue = null === visualRange || void 0 === visualRange ? void 0 : visualRange.endValue) && void 0 !== _visualRange$endValue ? _visualRange$endValue : businessRange.maxVisible;
        var ticks = [];
        if (options.type === (0, $aELZT.default).discrete && options.aggregateByCategory) return {
            aggregateByCategory: true
        };
        var aggregationInterval = options.aggregationInterval;
        var aggregationGroupWidth = options.aggregationGroupWidth;
        if (!aggregationGroupWidth && marginOptions) {
            if (marginOptions.checkInterval) aggregationGroupWidth = options.axisDivisionFactor;
            if (marginOptions.sizePointNormalState) aggregationGroupWidth = Math.min(marginOptions.sizePointNormalState, options.axisDivisionFactor);
        }
        var minInterval = !options.aggregationGroupWidth && !aggregationInterval && range.interval;
        var generateTicks = $84668f108f98ba54$var$configureGenerator(options, aggregationGroupWidth, businessRange, this._getScreenDelta(), minInterval);
        var tickInterval = generateTicks(aggregationInterval, true, minVisible, maxVisible, null === (_that$_seriesData = this._seriesData) || void 0 === _that$_seriesData ? void 0 : _that$_seriesData.breaks).tickInterval;
        if (options.type !== (0, $aELZT.default).discrete) {
            var min = useAllAggregatedPoints ? businessRange.min : minVisible;
            var max = useAllAggregatedPoints ? businessRange.max : maxVisible;
            if ((0, $6ntMu.isDefined)(min) && (0, $6ntMu.isDefined)(max)) {
                var add = (0, $dw9tZ.getAddFunction)({
                    base: options.logarithmBase,
                    axisType: options.type,
                    dataType: options.dataType
                }, false);
                var start = min;
                var end = max;
                if (!useAllAggregatedPoints && (0, $6ntMu.isDefined)(tickInterval)) {
                    var maxMinDistance = Math.max(this.calculateInterval(max, min), "datetime" === options.dataType ? (0, $f38Z1.default).dateToMilliseconds(tickInterval) : tickInterval);
                    start = add(min, maxMinDistance, -1);
                    end = add(max, maxMinDistance);
                }
                start = start < businessRange.min ? businessRange.min : start;
                end = end > businessRange.max ? businessRange.max : end;
                var breaks = this._getScaleBreaks(options, {
                    minVisible: start,
                    maxVisible: end
                }, this._series, this.isArgumentAxis);
                var filteredBreaks = this._filterBreaks(breaks, {
                    minVisible: start,
                    maxVisible: end
                }, options.breakStyle);
                ticks = generateTicks(tickInterval, false, start, end, filteredBreaks).ticks;
            }
        }
        this._aggregationInterval = tickInterval;
        return {
            interval: tickInterval,
            ticks: ticks
        };
    },
    getTickInterval () {
        return this._tickInterval;
    },
    getAggregationInterval () {
        return this._aggregationInterval;
    },
    createTicks: function(canvas) {
        var that = this;
        var renderer = that._renderer;
        var options = that._options;
        if (!canvas) return;
        that._isSynchronized = false;
        that.updateCanvas(canvas);
        var range = that._getViewportRange();
        that._initialBreaks = range.breaks = this._seriesData.breaks = that._filterBreaks(this._seriesData.userBreaks, range, options.breakStyle);
        that._estimatedTickInterval = that._getTicks(that.adjustViewport(this._seriesData), (0, $gcp4g.noop), true).tickInterval;
        var margins = this._calculateValueMargins();
        range.addRange({
            minVisible: margins.minValue,
            maxVisible: margins.maxValue,
            isSpacedMargin: margins.isSpacedMargin
        });
        var ticks = that._createTicksAndLabelFormat(range);
        var boundaryTicks = that._getBoundaryTicks(ticks.ticks, that._getViewportRange());
        if (options.showCustomBoundaryTicks && boundaryTicks.length) {
            that._boundaryTicks = [
                boundaryTicks[0]
            ].map($84668f108f98ba54$var$createBoundaryTick(that, renderer, true));
            if (boundaryTicks.length > 1) that._boundaryTicks = that._boundaryTicks.concat([
                boundaryTicks[1]
            ].map($84668f108f98ba54$var$createBoundaryTick(that, renderer, false)));
        } else that._boundaryTicks = [];
        var minors = (ticks.minorTicks || []).filter(function(minor) {
            return !boundaryTicks.some(function(boundary) {
                return (0, $dw9tZ.valueOf)(boundary) === (0, $dw9tZ.valueOf)(minor);
            });
        });
        that._tickInterval = ticks.tickInterval;
        that._minorTickInterval = ticks.minorTickInterval;
        var oldMajorTicks = that._majorTicks || [];
        var majorTicksByValues = oldMajorTicks.reduce((r, t)=>{
            r[t.value.valueOf()] = t;
            return r;
        }, {});
        var sameType = (0, $6ntMu.type)(ticks.ticks[0]) === (0, $6ntMu.type)(oldMajorTicks[0] && oldMajorTicks[0].value);
        var skippedCategory = that._getSkippedCategory(ticks.ticks);
        var majorTicks = ticks.ticks.map((v)=>{
            var tick = majorTicksByValues[v.valueOf()];
            if (tick && sameType) {
                delete majorTicksByValues[v.valueOf()];
                tick.setSkippedCategory(skippedCategory);
                return tick;
            } else return $84668f108f98ba54$var$createMajorTick(that, renderer, skippedCategory)(v);
        });
        that._majorTicks = majorTicks;
        var oldMinorTicks = that._minorTicks || [];
        that._minorTicks = minors.map((v, i)=>{
            var minorTick = oldMinorTicks[i];
            if (minorTick) {
                minorTick.updateValue(v);
                return minorTick;
            }
            return $84668f108f98ba54$var$createMinorTick(that, renderer)(v);
        });
        that._ticksToRemove = Object.keys(majorTicksByValues).map((k)=>majorTicksByValues[k]).concat(oldMinorTicks.slice(that._minorTicks.length, oldMinorTicks.length));
        that._ticksToRemove.forEach((t)=>{
            var _t$label;
            return null === (_t$label = t.label) || void 0 === _t$label ? void 0 : _t$label.removeTitle();
        });
        if (ticks.breaks) that._seriesData.breaks = ticks.breaks;
        that._reinitTranslator(that._getViewportRange());
    },
    _reinitTranslator: function(range) {
        var translator = this._translator;
        if (this._isSynchronized) return;
        translator.updateBusinessRange(range);
    },
    _getViewportRange () {
        return this.adjustViewport(this._seriesData);
    },
    setMarginOptions: function(options) {
        this._marginOptions = options;
    },
    getMarginOptions () {
        var _this$_marginOptions;
        return null !== (_this$_marginOptions = this._marginOptions) && void 0 !== _this$_marginOptions ? _this$_marginOptions : {};
    },
    _calculateRangeInterval: function(interval) {
        var isDateTime = "datetime" === this._options.dataType;
        var minArgs = [];
        var addToArgs = function(value) {
            (0, $6ntMu.isDefined)(value) && minArgs.push(isDateTime ? (0, $f38Z1.default).dateToMilliseconds(value) : value);
        };
        addToArgs(this._tickInterval);
        addToArgs(this._estimatedTickInterval);
        (0, $6ntMu.isDefined)(interval) && minArgs.push(interval);
        addToArgs(this._aggregationInterval);
        return this._calculateWorkWeekInterval($84668f108f98ba54$var$_min.apply(this, minArgs));
    },
    _calculateWorkWeekInterval (businessInterval) {
        var options = this._options;
        if ("datetime" === options.dataType && options.workdaysOnly && businessInterval) {
            var workWeek = options.workWeek.length * $84668f108f98ba54$var$dateIntervals.day;
            var weekend = $84668f108f98ba54$var$dateIntervals.week - workWeek;
            if (workWeek !== businessInterval && weekend < businessInterval) {
                var weekendsCount = Math.ceil(businessInterval / $84668f108f98ba54$var$dateIntervals.week);
                businessInterval -= weekend * weekendsCount;
            } else if (weekend >= businessInterval && businessInterval > $84668f108f98ba54$var$dateIntervals.day) businessInterval = $84668f108f98ba54$var$dateIntervals.day;
        }
        return businessInterval;
    },
    _getConvertIntervalCoefficient (intervalInPx, screenDelta) {
        var ratioOfCanvasRange = this._translator.ratioOfCanvasRange();
        return ratioOfCanvasRange / (ratioOfCanvasRange * screenDelta / (intervalInPx + screenDelta));
    },
    _calculateValueMargins (ticks) {
        this._resetMargins();
        var margins = this.getMarginOptions();
        var marginSize = (margins.size || 0) / 2;
        var options = this._options;
        var dataRange = this._getViewportRange();
        var viewPort = this.getViewport();
        var screenDelta = this._getScreenDelta();
        var isDiscrete = -1 !== (options.type || "").indexOf((0, $aELZT.default).discrete);
        var valueMarginsEnabled = options.valueMarginsEnabled && !isDiscrete && !this.customPositionIsBoundaryOrthogonalAxis();
        var translator = this._translator;
        var minValueMargin = options.minValueMargin;
        var maxValueMargin = options.maxValueMargin;
        var minPadding = 0;
        var maxPadding = 0;
        var interval = 0;
        var rangeInterval;
        if (dataRange.stubData || !screenDelta) return {
            startPadding: 0,
            endPadding: 0
        };
        if (this.isArgumentAxis && margins.checkInterval) {
            rangeInterval = this._calculateRangeInterval(dataRange.interval);
            var pxInterval = translator.getInterval(rangeInterval);
            if (isFinite(pxInterval)) interval = Math.ceil(pxInterval / (2 * this._getConvertIntervalCoefficient(pxInterval, screenDelta)));
            else rangeInterval = 0;
        }
        var minPercentPadding;
        var maxPercentPadding;
        var maxPaddingValue = screenDelta * $84668f108f98ba54$var$MAX_MARGIN_VALUE / 2;
        if (valueMarginsEnabled) {
            if ((0, $6ntMu.isDefined)(minValueMargin)) minPercentPadding = isFinite(minValueMargin) ? minValueMargin : 0;
            else if (!this.isArgumentAxis && margins.checkInterval && (0, $dw9tZ.valueOf)(dataRange.minVisible) > 0 && (0, $dw9tZ.valueOf)(dataRange.minVisible) === (0, $dw9tZ.valueOf)(dataRange.min)) minPadding = $84668f108f98ba54$var$MIN_BAR_MARGIN;
            else {
                minPadding = Math.max(marginSize, interval);
                minPadding = Math.min(maxPaddingValue, minPadding);
            }
            if ((0, $6ntMu.isDefined)(maxValueMargin)) maxPercentPadding = isFinite(maxValueMargin) ? maxValueMargin : 0;
            else if (!this.isArgumentAxis && margins.checkInterval && (0, $dw9tZ.valueOf)(dataRange.maxVisible) < 0 && (0, $dw9tZ.valueOf)(dataRange.maxVisible) === (0, $dw9tZ.valueOf)(dataRange.max)) maxPadding = $84668f108f98ba54$var$MIN_BAR_MARGIN;
            else {
                maxPadding = Math.max(marginSize, interval);
                maxPadding = Math.min(maxPaddingValue, maxPadding);
            }
        }
        var percentStick = margins.percentStick && !this.isArgumentAxis;
        if (percentStick) {
            if (1 === $84668f108f98ba54$var$_abs(dataRange.max)) maxPadding = 0;
            if (1 === $84668f108f98ba54$var$_abs(dataRange.min)) minPadding = 0;
        }
        var canvasStartEnd = this._getCanvasStartEnd();
        var commonMargin = 1 + (minPercentPadding || 0) + (maxPercentPadding || 0);
        var screenDeltaWithMargins = (screenDelta - minPadding - maxPadding) / commonMargin || screenDelta;
        if (void 0 !== minPercentPadding || void 0 !== maxPercentPadding) {
            if (void 0 !== minPercentPadding) minPadding = screenDeltaWithMargins * minPercentPadding;
            if (void 0 !== maxPercentPadding) maxPadding = screenDeltaWithMargins * maxPercentPadding;
        }
        var minValue;
        var maxValue;
        if (options.type !== (0, $aELZT.default).discrete && ticks && ticks.length > 1 && !options.skipViewportExtending && !viewPort.action && false !== options.endOnTick) {
            var length = ticks.length;
            var firstTickPosition = translator.translate(ticks[0].value);
            var lastTickPosition = translator.translate(ticks[length - 1].value);
            var invertMultiplier = firstTickPosition > lastTickPosition ? -1 : 1;
            var minTickPadding = $84668f108f98ba54$var$_max(invertMultiplier * (canvasStartEnd.start - firstTickPosition), 0);
            var maxTickPadding = $84668f108f98ba54$var$_max(invertMultiplier * (lastTickPosition - canvasStartEnd.end), 0);
            if (minTickPadding > minPadding || maxTickPadding > maxPadding) {
                var commonPadding = maxTickPadding + minTickPadding;
                var coeff = this._getConvertIntervalCoefficient(commonPadding, screenDelta);
                if (minTickPadding >= minPadding) minValue = ticks[0].value;
                if (maxTickPadding >= maxPadding) maxValue = ticks[length - 1].value;
                minPadding = $84668f108f98ba54$var$_max(minTickPadding, minPadding) / coeff;
                maxPadding = $84668f108f98ba54$var$_max(maxTickPadding, maxPadding) / coeff;
            }
        }
        minPercentPadding = void 0 === minPercentPadding ? minPadding / screenDeltaWithMargins : minPercentPadding;
        maxPercentPadding = void 0 === maxPercentPadding ? maxPadding / screenDeltaWithMargins : maxPercentPadding;
        if (!isDiscrete) {
            if (this._translator.isInverted()) {
                var _minValue, _maxValue;
                minValue = null !== (_minValue = minValue) && void 0 !== _minValue ? _minValue : translator.from(canvasStartEnd.start + screenDelta * minPercentPadding, -1);
                maxValue = null !== (_maxValue = maxValue) && void 0 !== _maxValue ? _maxValue : translator.from(canvasStartEnd.end - screenDelta * maxPercentPadding, 1);
            } else {
                var _minValue2, _maxValue2;
                minValue = null !== (_minValue2 = minValue) && void 0 !== _minValue2 ? _minValue2 : translator.from(canvasStartEnd.start - screenDelta * minPercentPadding, -1);
                maxValue = null !== (_maxValue2 = maxValue) && void 0 !== _maxValue2 ? _maxValue2 : translator.from(canvasStartEnd.end + screenDelta * maxPercentPadding, 1);
            }
        }
        var { correctedMin: correctedMin, correctedMax: correctedMax, start: start, end: end } = this.getCorrectedValuesToZero(minValue, maxValue);
        minPadding = null !== start && void 0 !== start ? start : minPadding;
        maxPadding = null !== end && void 0 !== end ? end : maxPadding;
        return {
            startPadding: translator.isInverted() ? maxPadding : minPadding,
            endPadding: translator.isInverted() ? minPadding : maxPadding,
            minValue: null !== correctedMin && void 0 !== correctedMin ? correctedMin : minValue,
            maxValue: null !== correctedMax && void 0 !== correctedMax ? correctedMax : maxValue,
            interval: rangeInterval,
            isSpacedMargin: minPadding === maxPadding && 0 !== minPadding
        };
    },
    getCorrectedValuesToZero (minValue, maxValue) {
        var that = this;
        var translator = that._translator;
        var canvasStartEnd = that._getCanvasStartEnd();
        var dataRange = that._getViewportRange();
        var screenDelta = that._getScreenDelta();
        var options = that._options;
        var start;
        var end;
        var correctedMin;
        var correctedMax;
        var correctZeroLevel = (minPoint, maxPoint)=>{
            var minExpectedPadding = $84668f108f98ba54$var$_abs(canvasStartEnd.start - minPoint);
            var maxExpectedPadding = $84668f108f98ba54$var$_abs(canvasStartEnd.end - maxPoint);
            var coeff = that._getConvertIntervalCoefficient(minExpectedPadding + maxExpectedPadding, screenDelta);
            start = minExpectedPadding / coeff;
            end = maxExpectedPadding / coeff;
        };
        if (!that.isArgumentAxis && "datetime" !== options.dataType) {
            if (minValue * dataRange.min <= 0 && minValue * dataRange.minVisible <= 0) {
                correctZeroLevel(translator.translate(0), translator.translate(maxValue));
                correctedMin = 0;
            }
            if (maxValue * dataRange.max <= 0 && maxValue * dataRange.maxVisible <= 0) {
                correctZeroLevel(translator.translate(minValue), translator.translate(0));
                correctedMax = 0;
            }
        }
        return {
            start: isFinite(start) ? start : null,
            end: isFinite(end) ? end : null,
            correctedMin: correctedMin,
            correctedMax: correctedMax
        };
    },
    applyMargins () {
        if (this._isSynchronized) return;
        var margins = this._calculateValueMargins(this._majorTicks);
        var canvas = (0, $2oTOp.extend)({}, this._canvas, {
            startPadding: margins.startPadding,
            endPadding: margins.endPadding
        });
        this._translator.updateCanvas(this._processCanvas(canvas));
        if (isFinite(margins.interval)) {
            var br = this._translator.getBusinessRange();
            br.addRange({
                interval: margins.interval
            });
            this._translator.updateBusinessRange(br);
        }
    },
    _resetMargins: function() {
        this._reinitTranslator(this._getViewportRange());
        if (this._canvas) this._translator.updateCanvas(this._processCanvas(this._canvas));
    },
    _createConstantLines () {
        var constantLines = (this._options.constantLines || []).map((o)=>(0, $bA6EZ.default)(this, o));
        this._outsideConstantLines = constantLines.filter((l)=>"outside" === l.labelPosition);
        this._insideConstantLines = constantLines.filter((l)=>"inside" === l.labelPosition);
    },
    draw: function(canvas, borderOptions) {
        var that = this;
        var options = this._options;
        that.borderOptions = borderOptions || {
            visible: false
        };
        that._resetMargins();
        that.createTicks(canvas);
        that.applyMargins();
        that._clearAxisGroups();
        $84668f108f98ba54$var$initTickCoords(that._majorTicks);
        $84668f108f98ba54$var$initTickCoords(that._minorTicks);
        $84668f108f98ba54$var$initTickCoords(that._boundaryTicks);
        that._axisGroup.append(that._axesContainerGroup);
        that._drawAxis();
        that._drawTitle();
        $84668f108f98ba54$var$drawTickMarks(that._majorTicks, options.tick);
        $84668f108f98ba54$var$drawTickMarks(that._minorTicks, options.minorTick);
        $84668f108f98ba54$var$drawTickMarks(that._boundaryTicks, options.tick);
        var drawGridLine = that._getGridLineDrawer();
        $84668f108f98ba54$var$drawGrids(that._majorTicks, drawGridLine);
        $84668f108f98ba54$var$drawGrids(that._minorTicks, drawGridLine);
        $84668f108f98ba54$var$callAction(that._majorTicks, "drawLabel", that._getViewportRange(), that._getTemplate(options.label.template));
        that._templatesRendered && that._templatesRendered.reject();
        that._templatesRendered = new (0, $dDkff.Deferred);
        that._majorTicks.forEach(function(tick) {
            tick.labelRotationAngle = 0;
            tick.labelAlignment = void 0;
            tick.labelOffset = 0;
        });
        $84668f108f98ba54$var$callAction(that._outsideConstantLines.concat(that._insideConstantLines), "draw");
        $84668f108f98ba54$var$callAction(that._strips, "draw");
        that._dateMarkers = that._drawDateMarkers() || [];
        that._stripLabelAxesGroup && that._axisStripLabelGroup.append(that._stripLabelAxesGroup);
        that._gridContainerGroup && that._axisGridGroup.append(that._gridContainerGroup);
        that._stripsGroup && that._axisStripGroup.append(that._stripsGroup);
        that._labelsAxesGroup && that._axisElementsGroup.append(that._labelsAxesGroup);
        if (that._constantLinesGroup) {
            that._axisConstantLineGroups.above.inside.append(that._constantLinesGroup.above);
            that._axisConstantLineGroups.above.outside1.append(that._constantLinesGroup.above);
            that._axisConstantLineGroups.above.outside2.append(that._constantLinesGroup.above);
            that._axisConstantLineGroups.under.inside.append(that._constantLinesGroup.under);
            that._axisConstantLineGroups.under.outside1.append(that._constantLinesGroup.under);
            that._axisConstantLineGroups.under.outside2.append(that._constantLinesGroup.under);
        }
        that._measureTitle();
        (0, $53BqL.measureLabels)(that._majorTicks);
        !options.label.template && that._applyWordWrap();
        (0, $53BqL.measureLabels)(that._outsideConstantLines);
        (0, $53BqL.measureLabels)(that._insideConstantLines);
        (0, $53BqL.measureLabels)(that._strips);
        (0, $53BqL.measureLabels)(that._dateMarkers);
        that._adjustConstantLineLabels(that._insideConstantLines);
        that._adjustStripLabels();
        var offset = that._constantLabelOffset = that._adjustConstantLineLabels(that._outsideConstantLines);
        if (!that._translator.getBusinessRange().isEmpty()) {
            that._setLabelsPlacement();
            offset = that._adjustLabels(offset);
        }
        (0, $dDkff.when).apply(this, that._majorTicks.map((tick)=>tick.getTemplateDeferred())).done(()=>{
            that._templatesRendered.resolve();
        });
        offset = that._adjustDateMarkers(offset);
        that._adjustTitle(offset);
    },
    getTemplatesDef () {
        return this._templatesRendered;
    },
    setRenderedState (state) {
        this._drawn = state;
    },
    isRendered () {
        return this._drawn;
    },
    _applyWordWrap () {
        var convertedTickInterval;
        var textWidth;
        var textHeight;
        var options = this._options;
        var tickInterval = this._tickInterval;
        if ((0, $6ntMu.isDefined)(tickInterval)) convertedTickInterval = this.getTranslator().getInterval("datetime" === options.dataType ? (0, $f38Z1.default).dateToMilliseconds(tickInterval) : tickInterval);
        var displayMode = this._validateDisplayMode(options.label.displayMode);
        var overlappingMode = this._validateOverlappingMode(options.label.overlappingBehavior, displayMode);
        var wordWrapMode = options.label.wordWrap || "none";
        var overflowMode = options.label.textOverflow || "none";
        if (("none" !== wordWrapMode || "none" !== overflowMode) && displayMode !== $84668f108f98ba54$var$ROTATE && overlappingMode !== $84668f108f98ba54$var$ROTATE && "auto" !== overlappingMode) {
            var usefulSpace = (0, $6ntMu.isDefined)(options.placeholderSize) ? options.placeholderSize - options.label.indentFromAxis : void 0;
            if (this._isHorizontal) {
                textWidth = convertedTickInterval;
                textHeight = usefulSpace;
            } else {
                textWidth = usefulSpace;
                textHeight = convertedTickInterval;
            }
            var correctByWidth = false;
            var correctByHeight = false;
            if (textWidth) {
                if (this._majorTicks.some((tick)=>tick.labelBBox.width > textWidth)) correctByWidth = true;
            }
            if (textHeight) {
                if (this._majorTicks.some((tick)=>tick.labelBBox.height > textHeight)) correctByHeight = true;
            }
            if (correctByWidth || correctByHeight) {
                this._majorTicks.forEach((tick)=>{
                    tick.label && tick.label.setMaxSize(textWidth, textHeight, options.label);
                });
                (0, $53BqL.measureLabels)(this._majorTicks);
            }
        }
    },
    _measureTitle: (0, $gcp4g.noop),
    animate () {
        $84668f108f98ba54$var$callAction(this._majorTicks, "animateLabels");
    },
    updateSize (canvas, animate) {
        var updateTitle = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : true;
        this.updateCanvas(canvas);
        if (updateTitle) {
            this._checkTitleOverflow();
            this._measureTitle();
            this._updateTitleCoords();
        }
        this._reinitTranslator(this._getViewportRange());
        this.applyMargins();
        var animationEnabled = !this._firstDrawing && animate;
        var options = this._options;
        $84668f108f98ba54$var$initTickCoords(this._majorTicks);
        $84668f108f98ba54$var$initTickCoords(this._minorTicks);
        $84668f108f98ba54$var$initTickCoords(this._boundaryTicks);
        if (this._resetApplyingAnimation && !this._firstDrawing) this._resetStartCoordinates();
        $84668f108f98ba54$var$cleanUpInvalidTicks(this._majorTicks);
        $84668f108f98ba54$var$cleanUpInvalidTicks(this._minorTicks);
        $84668f108f98ba54$var$cleanUpInvalidTicks(this._boundaryTicks);
        if (this._axisElement) this._updateAxisElementPosition();
        $84668f108f98ba54$var$updateTicksPosition(this._majorTicks, options.tick, animationEnabled);
        $84668f108f98ba54$var$updateTicksPosition(this._minorTicks, options.minorTick, animationEnabled);
        $84668f108f98ba54$var$updateTicksPosition(this._boundaryTicks, options.tick);
        $84668f108f98ba54$var$callAction(this._majorTicks, "updateLabelPosition", animationEnabled);
        this._outsideConstantLines.concat(this._insideConstantLines || []).forEach((l)=>l.updatePosition(animationEnabled));
        $84668f108f98ba54$var$callAction(this._strips, "updatePosition", animationEnabled);
        $84668f108f98ba54$var$updateGridsPosition(this._majorTicks, animationEnabled);
        $84668f108f98ba54$var$updateGridsPosition(this._minorTicks, animationEnabled);
        if (animationEnabled) $84668f108f98ba54$var$callAction(this._ticksToRemove || [], "fadeOutElements");
        this.prepareAnimation();
        this._ticksToRemove = null;
        if (!this._translator.getBusinessRange().isEmpty()) this._firstDrawing = false;
        this._resetApplyingAnimation = false;
        this._updateLabelsPosition();
    },
    _updateLabelsPosition: (0, $gcp4g.noop),
    prepareAnimation () {
        var action = "saveCoords";
        $84668f108f98ba54$var$callAction(this._majorTicks, action);
        $84668f108f98ba54$var$callAction(this._minorTicks, action);
        $84668f108f98ba54$var$callAction(this._insideConstantLines, action);
        $84668f108f98ba54$var$callAction(this._outsideConstantLines, action);
        $84668f108f98ba54$var$callAction(this._strips, action);
    },
    _resetStartCoordinates () {
        var action = "resetCoordinates";
        $84668f108f98ba54$var$callAction(this._majorTicks, action);
        $84668f108f98ba54$var$callAction(this._minorTicks, action);
        $84668f108f98ba54$var$callAction(this._insideConstantLines, action);
        $84668f108f98ba54$var$callAction(this._outsideConstantLines, action);
        $84668f108f98ba54$var$callAction(this._strips, action);
    },
    applyClipRects: function(elementsClipID, canvasClipID) {
        this._axisGroup.attr({
            "clip-path": canvasClipID
        });
        this._axisStripGroup.attr({
            "clip-path": elementsClipID
        });
        this._axisElementsGroup.attr({
            "clip-path": canvasClipID
        });
    },
    _validateVisualRange (optionValue) {
        var range = (0, $dw9tZ.getVizRangeObject)(optionValue);
        if (void 0 !== range.startValue) range.startValue = this.validateUnit(range.startValue);
        if (void 0 !== range.endValue) range.endValue = this.validateUnit(range.endValue);
        return (0, $dw9tZ.convertVisualRangeObject)(range, !$84668f108f98ba54$var$_isArray(optionValue));
    },
    _validateOptions (options) {
        options.wholeRange = this._validateVisualRange(options.wholeRange);
        options.visualRange = options._customVisualRange = this._validateVisualRange(options._customVisualRange);
        this._setVisualRange(options._customVisualRange);
    },
    validate () {
        var options = this._options;
        var dataType = this.isArgumentAxis ? options.argumentType : options.valueType;
        var parser = dataType ? (0, $1zStA.getParser)(dataType) : function(unit) {
            return unit;
        };
        this.parser = parser;
        options.dataType = dataType;
        this._validateOptions(options);
    },
    resetVisualRange (isSilent) {
        this._seriesData.minVisible = this._seriesData.min;
        this._seriesData.maxVisible = this._seriesData.max;
        this.handleZooming([
            null,
            null
        ], {
            start: !!isSilent,
            end: !!isSilent
        });
    },
    _setVisualRange (visualRange, allowPartialUpdate) {
        var range = this.adjustRange((0, $dw9tZ.getVizRangeObject)(visualRange));
        if (allowPartialUpdate) {
            (0, $6ntMu.isDefined)(range.startValue) && (this._viewport.startValue = range.startValue);
            (0, $6ntMu.isDefined)(range.endValue) && (this._viewport.endValue = range.endValue);
        } else this._viewport = range;
    },
    _applyZooming (visualRange, allowPartialUpdate) {
        this._resetVisualRangeOption();
        this._setVisualRange(visualRange, allowPartialUpdate);
        var viewPort = this.getViewport();
        this._seriesData.userBreaks = this._getScaleBreaks(this._options, {
            minVisible: viewPort.startValue,
            maxVisible: viewPort.endValue
        }, this._series, this.isArgumentAxis);
        this._translator.updateBusinessRange(this._getViewportRange());
    },
    getZoomStartEventArg (event, actionType) {
        return {
            axis: this,
            range: this.visualRange(),
            cancel: false,
            event: event,
            actionType: actionType
        };
    },
    _getZoomEndEventArg (previousRange, event, actionType, zoomFactor, shift) {
        var newRange = this.visualRange();
        return {
            axis: this,
            previousRange: previousRange,
            range: newRange,
            cancel: false,
            event: event,
            actionType: actionType,
            zoomFactor: zoomFactor,
            shift: shift,
            rangeStart: newRange.startValue,
            rangeEnd: newRange.endValue
        };
    },
    getZoomBounds () {
        var wholeRange = (0, $dw9tZ.getVizRangeObject)(this._options.wholeRange);
        var range = this.getTranslator().getBusinessRange();
        var secondPriorityRange = {
            startValue: $84668f108f98ba54$var$getZoomBoundValue(this._initRange.startValue, range.min),
            endValue: $84668f108f98ba54$var$getZoomBoundValue(this._initRange.endValue, range.max)
        };
        return {
            startValue: $84668f108f98ba54$var$getZoomBoundValue(wholeRange.startValue, secondPriorityRange.startValue),
            endValue: $84668f108f98ba54$var$getZoomBoundValue(wholeRange.endValue, secondPriorityRange.endValue)
        };
    },
    setInitRange () {
        this._initRange = {};
        if (0 === Object.keys(this._options.wholeRange || {}).length) this._initRange = this.getZoomBounds();
    },
    _resetVisualRangeOption () {
        this._options._customVisualRange = {};
    },
    getTemplatesGroups () {
        var ticks = this._majorTicks;
        if (ticks) return this._majorTicks.map((tick)=>tick.templateContainer).filter((item)=>(0, $6ntMu.isDefined)(item));
        else return [];
    },
    setCustomVisualRange (range) {
        this._options._customVisualRange = range;
    },
    visualRange () {
        var args = arguments;
        var visualRange;
        if (0 === args.length) {
            var adjustedRange = this._getAdjustedBusinessRange();
            var startValue = adjustedRange.minVisible;
            var endValue = adjustedRange.maxVisible;
            if (this._options.type === (0, $aELZT.default).discrete) {
                var _startValue, _endValue;
                startValue = null !== (_startValue = startValue) && void 0 !== _startValue ? _startValue : adjustedRange.categories[0];
                endValue = null !== (_endValue = endValue) && void 0 !== _endValue ? _endValue : adjustedRange.categories[adjustedRange.categories.length - 1];
                return {
                    startValue: startValue,
                    endValue: endValue,
                    categories: (0, $dw9tZ.getCategoriesInfo)(adjustedRange.categories, startValue, endValue).categories
                };
            }
            return {
                startValue: startValue,
                endValue: endValue
            };
        } else if ($84668f108f98ba54$var$_isArray(args[0])) visualRange = args[0];
        else if ((0, $6ntMu.isPlainObject)(args[0])) visualRange = (0, $2oTOp.extend)({}, args[0]);
        else visualRange = [
            args[0],
            args[1]
        ];
        var zoomResults = this.handleZooming(visualRange, args[1]);
        if (!zoomResults.isPrevented) this._visualRange(this, zoomResults);
    },
    handleZooming (visualRange, preventEvents, domEvent, action) {
        preventEvents = preventEvents || {};
        if ((0, $6ntMu.isDefined)(visualRange)) {
            visualRange = this._validateVisualRange(visualRange);
            visualRange.action = action;
        }
        var zoomStartEvent = this.getZoomStartEventArg(domEvent, action);
        var previousRange = zoomStartEvent.range;
        !preventEvents.start && this._eventTrigger("zoomStart", zoomStartEvent);
        var zoomResults = {
            isPrevented: zoomStartEvent.cancel,
            skipEventRising: preventEvents.skipEventRising,
            range: visualRange || zoomStartEvent.range
        };
        if (!zoomStartEvent.cancel) {
            (0, $6ntMu.isDefined)(visualRange) && this._applyZooming(visualRange, preventEvents.allowPartialUpdate);
            if (!(0, $6ntMu.isDefined)(this._storedZoomEndParams)) this._storedZoomEndParams = {
                startRange: previousRange,
                type: this.getOptions().type
            };
            this._storedZoomEndParams.event = domEvent;
            this._storedZoomEndParams.action = action;
            this._storedZoomEndParams.prevent = !!preventEvents.end;
        }
        return zoomResults;
    },
    handleZoomEnd () {
        if ((0, $6ntMu.isDefined)(this._storedZoomEndParams) && !this._storedZoomEndParams.prevent) {
            var previousRange = this._storedZoomEndParams.startRange;
            var domEvent = this._storedZoomEndParams.event;
            var action = this._storedZoomEndParams.action;
            var previousBusinessRange = {
                minVisible: previousRange.startValue,
                maxVisible: previousRange.endValue,
                categories: previousRange.categories
            };
            var typeIsNotChanged = this.getOptions().type === this._storedZoomEndParams.type;
            var shift = typeIsNotChanged ? (0, $laqiS.adjust)(this.getVisualRangeCenter() - this.getVisualRangeCenter(previousBusinessRange, false)) : NaN;
            var zoomFactor = typeIsNotChanged ? +(Math.round(this.getVisualRangeLength(previousBusinessRange) / (this.getVisualRangeLength() || 1) + "e+2") + "e-2") : NaN;
            var zoomEndEvent = this._getZoomEndEventArg(previousRange, domEvent, action, zoomFactor, shift);
            zoomEndEvent.cancel = this.checkZoomingLowerLimitOvercome(1 === zoomFactor ? "pan" : "zoom", zoomFactor).stopInteraction;
            this._eventTrigger("zoomEnd", zoomEndEvent);
            if (zoomEndEvent.cancel) this._restorePreviousVisualRange(previousRange);
            this._storedZoomEndParams = null;
        }
    },
    _restorePreviousVisualRange (previousRange) {
        this._storedZoomEndParams = null;
        this._applyZooming(previousRange);
        this._visualRange(this, previousRange);
    },
    checkZoomingLowerLimitOvercome (actionType, zoomFactor, range) {
        var options = this._options;
        var translator = this._translator;
        var minZoom = options.minVisualRangeLength;
        var correctedRange = range;
        var visualRange;
        var isOvercoming = "zoom" === actionType && zoomFactor >= 1;
        var businessRange = translator.getBusinessRange();
        if (range) {
            visualRange = this.adjustRange((0, $dw9tZ.getVizRangeObject)(range));
            visualRange = {
                minVisible: visualRange.startValue,
                maxVisible: visualRange.endValue,
                categories: businessRange.categories
            };
        }
        var beforeVisualRangeLength = this.getVisualRangeLength(businessRange);
        var afterVisualRangeLength = this.getVisualRangeLength(visualRange);
        if ((0, $6ntMu.isDefined)(minZoom) || "discrete" === options.type) {
            minZoom = translator.convert(minZoom);
            if (visualRange && minZoom < beforeVisualRangeLength && minZoom >= afterVisualRangeLength) {
                correctedRange = (0, $dw9tZ.getVizRangeObject)(translator.getRangeByMinZoomValue(minZoom, visualRange));
                isOvercoming = false;
            } else isOvercoming &= minZoom > afterVisualRangeLength;
        } else {
            var canvasLength = this._translator.canvasLength;
            var fullRange = {
                minVisible: businessRange.min,
                maxVisible: businessRange.max,
                categories: businessRange.categories
            };
            isOvercoming &= this.getVisualRangeLength(fullRange) / canvasLength >= afterVisualRangeLength;
        }
        return {
            stopInteraction: !!isOvercoming,
            correctedRange: correctedRange
        };
    },
    isExtremePosition (isMax) {
        var extremeDataValue;
        var seriesData;
        if ("discrete" === this._options.type) {
            seriesData = this._translator.getBusinessRange();
            extremeDataValue = isMax ? seriesData.categories[seriesData.categories.length - 1] : seriesData.categories[0];
        } else {
            seriesData = this.getZoomBounds();
            extremeDataValue = isMax ? seriesData.endValue : seriesData.startValue;
        }
        var translator = this.getTranslator();
        var extremePoint = translator.translate(extremeDataValue);
        var visualRange = this.visualRange();
        var visualRangePoint = isMax ? translator.translate(visualRange.endValue) : translator.translate(visualRange.startValue);
        return $84668f108f98ba54$var$_abs(visualRangePoint - extremePoint) < $84668f108f98ba54$var$SCROLL_THRESHOLD;
    },
    getViewport () {
        return this._viewport;
    },
    getFullTicks: function() {
        var majors = this._majorTicks || [];
        if (this._options.type === (0, $aELZT.default).discrete) return $84668f108f98ba54$var$convertTicksToValues(majors);
        else return $84668f108f98ba54$var$convertTicksToValues(majors.concat(this._minorTicks, this._boundaryTicks)).sort(function(a, b) {
            return (0, $dw9tZ.valueOf)(a) - (0, $dw9tZ.valueOf)(b);
        });
    },
    measureLabels: function(canvas, withIndents) {
        var that = this;
        var options = that._options;
        var widthAxis = options.visible ? options.width : 0;
        var ticks;
        var indent = withIndents ? options.label.indentFromAxis + .5 * options.tick.length : 0;
        var tickInterval;
        var viewportRange = that._getViewportRange();
        if (viewportRange.isEmpty() || !options.label.visible || !that._axisElementsGroup) return {
            height: widthAxis,
            width: widthAxis,
            x: 0,
            y: 0
        };
        if (that._majorTicks) ticks = $84668f108f98ba54$var$convertTicksToValues(that._majorTicks);
        else {
            that.updateCanvas(canvas);
            ticks = that._createTicksAndLabelFormat(viewportRange, (0, $gcp4g.noop));
            tickInterval = ticks.tickInterval;
            ticks = ticks.ticks;
        }
        var maxText = ticks.reduce(function(prevLabel, tick, index) {
            var label = that.formatLabel(tick, options.label, viewportRange, void 0, tickInterval, ticks);
            if (prevLabel.length < label.length) return label;
            else return prevLabel;
        }, that.formatLabel(ticks[0], options.label, viewportRange, void 0, tickInterval, ticks));
        var text = that._renderer.text(maxText, 0, 0).css(that._textFontStyles).attr(that._textOptions).append(that._renderer.root);
        var box = text.getBBox();
        text.remove();
        return {
            x: box.x,
            y: box.y,
            width: box.width + indent,
            height: box.height + indent
        };
    },
    _setLabelsPlacement: function() {
        if (!this._options.label.visible) return;
        var labelOpt = this._options.label;
        var displayMode = this._validateDisplayMode(labelOpt.displayMode);
        var overlappingMode = this._validateOverlappingMode(labelOpt.overlappingBehavior, displayMode);
        var ignoreOverlapping = "none" === overlappingMode || "ignore" === overlappingMode;
        var behavior = {
            rotationAngle: labelOpt.rotationAngle,
            staggeringSpacing: labelOpt.staggeringSpacing
        };
        var notRecastStep;
        var boxes = this._majorTicks.map(function(tick) {
            return tick.labelBBox;
        });
        var step = this._getStep(boxes);
        switch(displayMode){
            case $84668f108f98ba54$var$ROTATE:
                if (ignoreOverlapping) {
                    notRecastStep = true;
                    step = 1;
                }
                this._applyLabelMode(displayMode, step, boxes, labelOpt, notRecastStep);
                break;
            case "stagger":
                if (ignoreOverlapping) step = 2;
                this._applyLabelMode(displayMode, $84668f108f98ba54$var$_max(step, 2), boxes, labelOpt);
                break;
            default:
                this._applyLabelOverlapping(boxes, overlappingMode, step, behavior);
        }
    },
    _applyLabelOverlapping: function(boxes, mode, step, behavior) {
        var labelOpt = this._options.label;
        var majorTicks = this._majorTicks;
        if ("none" === mode || "ignore" === mode) return;
        if (step > 1 && boxes.some(function(box, index, array) {
            if (0 === index) return false;
            return (0, $aELZT.default).areLabelsOverlap(box, array[index - 1], labelOpt.minSpacing, labelOpt.alignment);
        })) this._applyLabelMode(mode, step, boxes, behavior);
        this._checkBoundedLabelsOverlapping(majorTicks, boxes, mode);
        this._checkShiftedLabels(majorTicks, boxes, labelOpt.minSpacing, labelOpt.alignment);
    },
    _applyLabelMode: function(mode, step, boxes, behavior, notRecastStep) {
        var majorTicks = this._majorTicks;
        var labelOpt = this._options.label;
        var angle = behavior.rotationAngle;
        var labelHeight;
        var alignment;
        var func;
        switch(mode){
            case $84668f108f98ba54$var$ROTATE:
                if (!labelOpt.userAlignment) {
                    alignment = angle < 0 ? $84668f108f98ba54$var$RIGHT : $84668f108f98ba54$var$LEFT;
                    if (angle % 90 === 0) alignment = $84668f108f98ba54$var$CENTER;
                }
                step = notRecastStep ? step : this._getStep(boxes, angle);
                func = function(tick) {
                    var contentContainer = tick.getContentContainer();
                    if (!contentContainer) return;
                    contentContainer.rotate(angle);
                    tick.labelRotationAngle = angle;
                    alignment && (tick.labelAlignment = alignment);
                };
                $84668f108f98ba54$var$updateLabels(majorTicks, step, func);
                break;
            case "stagger":
                labelHeight = this._getMaxLabelHeight(boxes, behavior.staggeringSpacing);
                func = function(tick, index) {
                    if (index / (step - 1) % 2 !== 0) tick.labelOffset = labelHeight;
                };
                $84668f108f98ba54$var$updateLabels(majorTicks, step - 1, func);
                break;
            case "auto":
            case "_auto":
                if (2 === step) this._applyLabelMode("stagger", step, boxes, behavior);
                else this._applyLabelMode($84668f108f98ba54$var$ROTATE, step, boxes, {
                    rotationAngle: $84668f108f98ba54$var$getOptimalAngle(boxes, labelOpt)
                });
                break;
            default:
                $84668f108f98ba54$var$updateLabels(majorTicks, step);
        }
    },
    getMarkerTrackers: (0, $gcp4g.noop),
    _drawDateMarkers: (0, $gcp4g.noop),
    _adjustDateMarkers: (0, $gcp4g.noop),
    coordsIn: (0, $gcp4g.noop),
    areCoordsOutsideAxis: (0, $gcp4g.noop),
    _getSkippedCategory: (0, $gcp4g.noop),
    _initAxisPositions: (0, $gcp4g.noop),
    _drawTitle: (0, $gcp4g.noop),
    _updateTitleCoords: (0, $gcp4g.noop),
    _adjustConstantLineLabels: (0, $gcp4g.noop),
    _createTranslator: function() {
        return new (0, $gkgW0.Translator2D)({}, {}, {});
    },
    _updateTranslator: function() {
        var translator = this._translator;
        translator.update(translator.getBusinessRange(), this._canvas || {}, this._getTranslatorOptions());
    },
    _getTranslatorOptions: function() {
        var _options$workWeek2, _options$breakStyle$w, _options$breakStyle;
        var options = this._options;
        return {
            isHorizontal: this._isHorizontal,
            shiftZeroValue: !this.isArgumentAxis,
            interval: options.semiDiscreteInterval,
            firstDayOfWeek: null === (_options$workWeek2 = options.workWeek) || void 0 === _options$workWeek2 ? void 0 : _options$workWeek2[0],
            stick: this._getStick(),
            breaksSize: null !== (_options$breakStyle$w = null === (_options$breakStyle = options.breakStyle) || void 0 === _options$breakStyle ? void 0 : _options$breakStyle.width) && void 0 !== _options$breakStyle$w ? _options$breakStyle$w : 0
        };
    },
    getVisibleArea () {
        var canvas = this._getCanvasStartEnd();
        return [
            canvas.start,
            canvas.end
        ].sort((a, b)=>a - b);
    },
    _getCanvasStartEnd: function() {
        var isHorizontal = this._isHorizontal;
        var canvas = this._canvas || {};
        var invert = this._translator.getBusinessRange().invert;
        var coords = isHorizontal ? [
            canvas.left,
            canvas.width - canvas.right
        ] : [
            canvas.height - canvas.bottom,
            canvas.top
        ];
        invert && coords.reverse();
        return {
            start: coords[0],
            end: coords[1]
        };
    },
    _getScreenDelta: function() {
        var canvas = this._getCanvasStartEnd();
        var breaks = this._seriesData ? this._seriesData.breaks || [] : [];
        var breaksLength = breaks.length;
        var screenDelta = $84668f108f98ba54$var$_abs(canvas.start - canvas.end);
        return screenDelta - (breaksLength ? breaks[breaksLength - 1].cumulativeWidth : 0);
    },
    _getScaleBreaks: function() {
        return [];
    },
    _filterBreaks: function() {
        return [];
    },
    _adjustTitle: (0, $gcp4g.noop),
    _checkTitleOverflow: (0, $gcp4g.noop),
    getSpiderTicks: (0, $gcp4g.noop),
    setSpiderTicks: (0, $gcp4g.noop),
    _checkBoundedLabelsOverlapping: (0, $gcp4g.noop),
    _checkShiftedLabels: (0, $gcp4g.noop),
    drawScaleBreaks: (0, $gcp4g.noop),
    _visualRange: (0, $gcp4g.noop),
    _rotateConstantLine: (0, $gcp4g.noop),
    applyVisualRangeSetter (visualRangeSetter) {
        this._visualRange = visualRangeSetter;
    },
    getCategoriesSorter (argCategories) {
        var sort;
        if (this.isArgumentAxis) sort = argCategories;
        else {
            var categoriesSortingMethod = this._options.categoriesSortingMethod;
            sort = null !== categoriesSortingMethod && void 0 !== categoriesSortingMethod ? categoriesSortingMethod : this._options.categories;
        }
        return sort;
    },
    _getAdjustedBusinessRange () {
        return this.adjustViewport(this._translator.getBusinessRange());
    }
};

});
parcelRegister("3g0R6", function(module, exports) {

$parcel$export(module.exports, "smartFormatter", function () { return $25f3879f3b13ac8a$export$661c3b2486c2f40; });
$parcel$export(module.exports, "formatRange", function () { return $25f3879f3b13ac8a$export$9b1080e2eec9158; });
/**
 * DevExtreme (esm/viz/axes/smart_formatter.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $7UWPL = parcelRequire("7UWPL");

var $6ntMu = parcelRequire("6ntMu");

var $f38Z1 = parcelRequire("f38Z1");

var $laqiS = parcelRequire("laqiS");

var $dw9tZ = parcelRequire("dw9tZ");
var $25f3879f3b13ac8a$var$_format = (0, $7UWPL.default).format;
var { abs: $25f3879f3b13ac8a$var$abs, floor: $25f3879f3b13ac8a$var$floor } = Math;
var $25f3879f3b13ac8a$var$EXPONENTIAL = "exponential";
var $25f3879f3b13ac8a$var$formats = [
    "fixedPoint",
    "thousands",
    "millions",
    "billions",
    "trillions",
    $25f3879f3b13ac8a$var$EXPONENTIAL
];
var $25f3879f3b13ac8a$var$dateUnitIntervals = [
    "millisecond",
    "second",
    "minute",
    "hour",
    "day",
    "month",
    "year"
];
function $25f3879f3b13ac8a$var$getDatesDifferences(prevDate, curDate, nextDate, tickFormat) {
    var prevDifferences;
    var nextDifferences;
    var dateUnitInterval;
    var dateUnitsLength = $25f3879f3b13ac8a$var$dateUnitIntervals.length;
    var i;
    var j;
    if ("week" === tickFormat) tickFormat = "day";
    else if ("quarter" === tickFormat) tickFormat = "month";
    else if ("shorttime" === tickFormat) tickFormat = "hour";
    else if ("longtime" === tickFormat) tickFormat = "second";
    var tickFormatIndex = $25f3879f3b13ac8a$var$dateUnitIntervals.indexOf(tickFormat);
    if (nextDate) {
        nextDifferences = (0, $f38Z1.default).getDatesDifferences(curDate, nextDate);
        prevDifferences = (0, $f38Z1.default).getDatesDifferences(curDate, prevDate);
        if (nextDifferences[tickFormat]) for(i = dateUnitsLength - 1; i >= tickFormatIndex; i--){
            dateUnitInterval = $25f3879f3b13ac8a$var$dateUnitIntervals[i];
            if (i === tickFormatIndex) $25f3879f3b13ac8a$var$setDateUnitInterval(nextDifferences, tickFormatIndex + (nextDifferences.millisecond ? 2 : 1));
            else if (nextDifferences[dateUnitInterval]) {
                $25f3879f3b13ac8a$var$resetDateUnitInterval(nextDifferences, i);
                break;
            }
        }
    } else {
        prevDifferences = (0, $f38Z1.default).getDatesDifferences(prevDate, curDate);
        for(i = dateUnitsLength - 1; i >= tickFormatIndex; i--){
            dateUnitInterval = $25f3879f3b13ac8a$var$dateUnitIntervals[i];
            if (prevDifferences[dateUnitInterval]) {
                if (i - tickFormatIndex > 1) {
                    for(j = tickFormatIndex + 1; j >= 0; j--)$25f3879f3b13ac8a$var$resetDateUnitInterval(prevDifferences, j);
                    break;
                } else if ($25f3879f3b13ac8a$var$isDateTimeStart(curDate, dateUnitInterval)) {
                    for(j = i - 1; j > 0; j--)$25f3879f3b13ac8a$var$resetDateUnitInterval(prevDifferences, j);
                    break;
                }
            }
        }
    }
    return nextDate ? nextDifferences : prevDifferences;
}
function $25f3879f3b13ac8a$var$isDateTimeStart(date, dateUnitInterval) {
    var unitNumbers = [
        date.getMilliseconds(),
        date.getSeconds(),
        date.getMinutes(),
        date.getHours(),
        date.getDate(),
        date.getMonth()
    ];
    var unitIndex = $25f3879f3b13ac8a$var$dateUnitIntervals.indexOf(dateUnitInterval);
    var i;
    for(i = 0; i < unitIndex; i++){
        if (4 === i && 1 !== unitNumbers[i] || 4 !== i && 0 !== unitNumbers[i]) return false;
    }
    return true;
}
function $25f3879f3b13ac8a$var$resetDateUnitInterval(differences, intervalIndex) {
    var dateUnitInterval = $25f3879f3b13ac8a$var$dateUnitIntervals[intervalIndex];
    if (differences[dateUnitInterval]) {
        differences[dateUnitInterval] = false;
        differences.count--;
    }
}
function $25f3879f3b13ac8a$var$setDateUnitInterval(differences, intervalIndex) {
    var dateUnitInterval = $25f3879f3b13ac8a$var$dateUnitIntervals[intervalIndex];
    if (false === differences[dateUnitInterval]) {
        differences[dateUnitInterval] = true;
        differences.count++;
    }
}
function $25f3879f3b13ac8a$var$getNoZeroIndex(str) {
    return str.length - parseInt(str).toString().length;
}
function $25f3879f3b13ac8a$var$getTransitionTickIndex(ticks, value) {
    var i;
    var curDiff;
    var minDiff;
    var nearestTickIndex = 0;
    minDiff = $25f3879f3b13ac8a$var$abs(value - ticks[0]);
    for(i = 1; i < ticks.length; i++){
        curDiff = $25f3879f3b13ac8a$var$abs(value - ticks[i]);
        if (curDiff < minDiff) {
            minDiff = curDiff;
            nearestTickIndex = i;
        }
    }
    return nearestTickIndex;
}
function $25f3879f3b13ac8a$var$splitDecimalNumber(value) {
    return value.toString().split(".");
}
function $25f3879f3b13ac8a$var$createFormat(type) {
    var formatter;
    if ((0, $6ntMu.isFunction)(type)) {
        formatter = type;
        type = null;
    }
    return {
        type: type,
        formatter: formatter
    };
}
function $25f3879f3b13ac8a$var$formatLogarithmicNumber(tick) {
    var log10Tick = (0, $dw9tZ.getAdjustedLog10)($25f3879f3b13ac8a$var$abs(tick));
    var type;
    if (log10Tick > 0) type = $25f3879f3b13ac8a$var$formats[$25f3879f3b13ac8a$var$floor(log10Tick / 3)] || $25f3879f3b13ac8a$var$EXPONENTIAL;
    else if (log10Tick < -4) type = $25f3879f3b13ac8a$var$EXPONENTIAL;
    else return $25f3879f3b13ac8a$var$_format((0, $laqiS.adjust)(tick));
    return $25f3879f3b13ac8a$var$_format(tick, {
        type: type,
        precision: 0
    });
}
function $25f3879f3b13ac8a$var$getDateTimeFormat(tick, _ref) {
    var { showTransition: showTransition, ticks: ticks, tickInterval: tickInterval } = _ref;
    var typeFormat = (0, $f38Z1.default).getDateFormatByTickInterval(tickInterval);
    var prevDateIndex;
    var nextDateIndex;
    if (showTransition && ticks.length) {
        var indexOfTick = ticks.map(Number).indexOf(+tick);
        if (1 === ticks.length && 0 === indexOfTick) typeFormat = (0, $7UWPL.default).getDateFormatByTicks(ticks);
        else {
            if (-1 === indexOfTick) prevDateIndex = $25f3879f3b13ac8a$var$getTransitionTickIndex(ticks, tick);
            else {
                prevDateIndex = 0 === indexOfTick ? ticks.length - 1 : indexOfTick - 1;
                nextDateIndex = 0 === indexOfTick ? 1 : -1;
            }
            var datesDifferences = $25f3879f3b13ac8a$var$getDatesDifferences(ticks[prevDateIndex], tick, ticks[nextDateIndex], typeFormat);
            typeFormat = (0, $7UWPL.default).getDateFormatByDifferences(datesDifferences, typeFormat);
        }
    }
    return $25f3879f3b13ac8a$var$createFormat(typeFormat);
}
function $25f3879f3b13ac8a$var$getFormatExponential(tick, tickInterval) {
    var stringTick = $25f3879f3b13ac8a$var$abs(tick).toString();
    if (!(0, $6ntMu.isExponential)(tick)) return $25f3879f3b13ac8a$var$abs($25f3879f3b13ac8a$var$getNoZeroIndex(stringTick.split(".")[1]) - (0, $laqiS.getExponent)(tickInterval) + 1);
    else return Math.max($25f3879f3b13ac8a$var$abs((0, $laqiS.getExponent)(tick) - (0, $laqiS.getExponent)(tickInterval)), $25f3879f3b13ac8a$var$abs((0, $laqiS.getPrecision)(tick) - (0, $laqiS.getPrecision)(tickInterval)));
}
function $25f3879f3b13ac8a$var$getFormatWithModifier(tick, tickInterval) {
    var tickIntervalIndex = $25f3879f3b13ac8a$var$floor((0, $dw9tZ.getAdjustedLog10)(tickInterval));
    var tickIndex;
    var typeFormat;
    var precision = 0;
    var actualIndex = tickIndex = $25f3879f3b13ac8a$var$floor((0, $dw9tZ.getAdjustedLog10)($25f3879f3b13ac8a$var$abs(tick)));
    if (tickIndex - tickIntervalIndex >= 2) actualIndex = tickIntervalIndex;
    var indexOfFormat = $25f3879f3b13ac8a$var$floor(actualIndex / 3);
    var offset = 3 * indexOfFormat;
    if (indexOfFormat < 5) {
        if (tickIntervalIndex - offset === 2 && tickIndex >= 3) {
            indexOfFormat++;
            offset = 3 * indexOfFormat;
        }
        typeFormat = $25f3879f3b13ac8a$var$formats[indexOfFormat];
    } else typeFormat = $25f3879f3b13ac8a$var$formats[$25f3879f3b13ac8a$var$formats.length - 1];
    if (offset > 0) {
        var separatedTickInterval = $25f3879f3b13ac8a$var$splitDecimalNumber(tickInterval / Math.pow(10, offset));
        if (separatedTickInterval[1]) precision = separatedTickInterval[1].length;
    }
    return {
        precision: precision,
        type: typeFormat
    };
}
function $25f3879f3b13ac8a$var$getHighDiffFormat(diff) {
    var stop = false;
    for(var i in diff){
        if (true === diff[i] || "hour" === i || stop) {
            diff[i] = false;
            stop = true;
        } else if (false === diff[i]) diff[i] = true;
    }
    return $25f3879f3b13ac8a$var$createFormat((0, $7UWPL.default).getDateFormatByDifferences(diff));
}
function $25f3879f3b13ac8a$var$getHighAndSelfDiffFormat(diff, interval) {
    var stop = false;
    for(var i in diff){
        if (stop) diff[i] = false;
        else if (i === interval) stop = true;
        else diff[i] = true;
    }
    return $25f3879f3b13ac8a$var$createFormat((0, $7UWPL.default).getDateFormatByDifferences(diff));
}
function $25f3879f3b13ac8a$var$formatDateRange(startValue, endValue, tickInterval) {
    var diff = $25f3879f3b13ac8a$var$getDatesDifferences(startValue, endValue);
    var typeFormat = (0, $f38Z1.default).getDateFormatByTickInterval(tickInterval);
    var diffFormatType = (0, $7UWPL.default).getDateFormatByDifferences(diff, typeFormat);
    var diffFormat = $25f3879f3b13ac8a$var$createFormat(diffFormatType);
    var values = [];
    if (tickInterval in diff) {
        var rangeFormat = $25f3879f3b13ac8a$var$getHighAndSelfDiffFormat($25f3879f3b13ac8a$var$getDatesDifferences(startValue, endValue), tickInterval);
        var value = $25f3879f3b13ac8a$var$_format(startValue, rangeFormat);
        if (value) values.push(value);
    } else {
        var _rangeFormat = $25f3879f3b13ac8a$var$getHighDiffFormat($25f3879f3b13ac8a$var$getDatesDifferences(startValue, endValue));
        var highValue = $25f3879f3b13ac8a$var$_format(startValue, _rangeFormat);
        if (highValue) values.push(highValue);
        values.push("".concat($25f3879f3b13ac8a$var$_format(startValue, diffFormat), " - ").concat($25f3879f3b13ac8a$var$_format(endValue, diffFormat)));
    }
    return values.join(", ");
}
function $25f3879f3b13ac8a$var$processDateInterval(interval) {
    if ((0, $6ntMu.isObject)(interval)) {
        var dateUnits = Object.keys(interval);
        var sum = dateUnits.reduce((sum, k)=>interval[k] + sum, 0);
        if (1 === sum) {
            var dateUnit = dateUnits.filter((k)=>1 === interval[k])[0];
            return dateUnit.slice(0, dateUnit.length - 1);
        }
    }
    return interval;
}
function $25f3879f3b13ac8a$export$661c3b2486c2f40(tick, options) {
    var tickInterval = options.tickInterval;
    var stringTick = $25f3879f3b13ac8a$var$abs(tick).toString();
    var format = options.labelOptions.format;
    var ticks = options.ticks;
    var isLogarithmic = "logarithmic" === options.type;
    if (1 === ticks.length && 0 === ticks.indexOf(tick) && !(0, $6ntMu.isDefined)(tickInterval)) tickInterval = $25f3879f3b13ac8a$var$abs(tick) >= 1 ? 1 : (0, $laqiS.adjust)(1 - $25f3879f3b13ac8a$var$abs(tick), tick);
    if (Object.is(tick, -0)) tick = 0;
    if (!(0, $6ntMu.isDefined)(format) && "discrete" !== options.type && tick && (10 === options.logarithmBase || !isLogarithmic)) {
        if ("datetime" !== options.dataType && (0, $6ntMu.isDefined)(tickInterval)) {
            if (ticks.length && -1 === ticks.indexOf(tick)) {
                var indexOfTick = $25f3879f3b13ac8a$var$getTransitionTickIndex(ticks, tick);
                tickInterval = (0, $laqiS.adjust)($25f3879f3b13ac8a$var$abs(tick - ticks[indexOfTick]), tick);
            }
            if (isLogarithmic) return $25f3879f3b13ac8a$var$formatLogarithmicNumber(tick);
            else {
                var separatedTickInterval = $25f3879f3b13ac8a$var$splitDecimalNumber(tickInterval);
                if (separatedTickInterval < 2) separatedTickInterval = $25f3879f3b13ac8a$var$splitDecimalNumber(tick);
                if (separatedTickInterval.length > 1 && !(0, $6ntMu.isExponential)(tickInterval)) format = {
                    type: $25f3879f3b13ac8a$var$formats[0],
                    precision: separatedTickInterval[1].length
                };
                else if ((0, $6ntMu.isExponential)(tickInterval) && (-1 !== stringTick.indexOf(".") || (0, $6ntMu.isExponential)(tick))) format = {
                    type: $25f3879f3b13ac8a$var$EXPONENTIAL,
                    precision: $25f3879f3b13ac8a$var$getFormatExponential(tick, tickInterval)
                };
                else format = $25f3879f3b13ac8a$var$getFormatWithModifier(tick, tickInterval);
            }
        } else if ("datetime" === options.dataType) format = $25f3879f3b13ac8a$var$getDateTimeFormat(tick, options);
    }
    return $25f3879f3b13ac8a$var$_format(tick, format);
}
function $25f3879f3b13ac8a$export$9b1080e2eec9158(_ref2) {
    var { startValue: startValue, endValue: endValue, tickInterval: tickInterval, argumentFormat: argumentFormat, axisOptions: { dataType: dataType, type: type, logarithmBase: logarithmBase } } = _ref2;
    if ("discrete" === type) return "";
    if ("datetime" === dataType) return $25f3879f3b13ac8a$var$formatDateRange(startValue, endValue, $25f3879f3b13ac8a$var$processDateInterval(tickInterval));
    var formatOptions = {
        ticks: [],
        type: type,
        dataType: dataType,
        tickInterval: tickInterval,
        logarithmBase: logarithmBase,
        labelOptions: {
            format: argumentFormat
        }
    };
    return "".concat($25f3879f3b13ac8a$export$661c3b2486c2f40(startValue, formatOptions), " - ").concat($25f3879f3b13ac8a$export$661c3b2486c2f40(endValue, formatOptions));
}

});

parcelRegister("aELZT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c22df0d17913aef$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/axes/axes_constants.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $dw9tZ = parcelRequire("dw9tZ");
var $7c22df0d17913aef$export$2e2bcd8739ae039 = {
    logarithmic: "logarithmic",
    discrete: "discrete",
    numeric: "numeric",
    left: "left",
    right: "right",
    top: "top",
    bottom: "bottom",
    center: "center",
    horizontal: "horizontal",
    vertical: "vertical",
    convertTicksToValues: function(ticks) {
        return (0, $dw9tZ.map)(ticks || [], function(item) {
            return item.value;
        });
    },
    validateOverlappingMode: function(mode) {
        return "ignore" === mode || "none" === mode ? mode : "hide";
    },
    getTicksCountInRange: function(ticks, valueKey, range) {
        var i = 1;
        if (ticks.length > 1) for(; i < ticks.length; i++){
            if (Math.abs(ticks[i].coords[valueKey] - ticks[0].coords[valueKey]) >= range) break;
        }
        return i;
    },
    areLabelsOverlap: function(bBox1, bBox2, spacing, alignment) {
        var horizontalInverted = bBox1.x > bBox2.x;
        var verticalInverted = bBox1.y > bBox2.y;
        var x1 = bBox1.x;
        var x2 = bBox2.x;
        var width1 = bBox1.width;
        var width2 = bBox2.width;
        if ("left" === alignment) {
            x1 += width1 / 2;
            x2 += width2 / 2;
        } else if ("right" === alignment) {
            x1 -= width1 / 2;
            x2 -= width2 / 2;
        }
        var hasHorizontalOverlapping = horizontalInverted ? x2 + width2 + spacing > x1 : x1 + width1 + spacing > x2;
        var hasVerticalOverlapping = verticalInverted ? bBox2.y + bBox2.height > bBox1.y : bBox1.y + bBox1.height > bBox2.y;
        return hasHorizontalOverlapping && hasVerticalOverlapping;
    }
};

});

parcelRegister("kJz4k", function(module, exports) {

$parcel$export(module.exports, "tickGenerator", function () { return $03e5368ea0d45f9a$export$69828eed7c503d53; });
/**
 * DevExtreme (esm/viz/axes/tick_generator.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $dw9tZ = parcelRequire("dw9tZ");

var $f38Z1 = parcelRequire("f38Z1");

var $6ntMu = parcelRequire("6ntMu");

var $laqiS = parcelRequire("laqiS");

var $2oTOp = parcelRequire("2oTOp");
var $03e5368ea0d45f9a$var$convertDateUnitToMilliseconds = (0, $f38Z1.default).convertDateUnitToMilliseconds;
var $03e5368ea0d45f9a$var$dateToMilliseconds = (0, $f38Z1.default).dateToMilliseconds;
var $03e5368ea0d45f9a$var$math = Math;
var $03e5368ea0d45f9a$var$mathAbs = $03e5368ea0d45f9a$var$math.abs;
var $03e5368ea0d45f9a$var$mathFloor = $03e5368ea0d45f9a$var$math.floor;
var $03e5368ea0d45f9a$var$mathCeil = $03e5368ea0d45f9a$var$math.ceil;
var $03e5368ea0d45f9a$var$mathPow = $03e5368ea0d45f9a$var$math.pow;
var $03e5368ea0d45f9a$var$NUMBER_MULTIPLIERS = [
    1,
    2,
    2.5,
    5
];
var $03e5368ea0d45f9a$var$LOGARITHMIC_MULTIPLIERS = [
    1,
    2,
    3,
    5
];
var $03e5368ea0d45f9a$var$DATETIME_MULTIPLIERS = {
    millisecond: [
        1,
        2,
        5,
        10,
        25,
        50,
        100,
        250,
        500
    ],
    second: [
        1,
        2,
        3,
        5,
        10,
        15,
        20,
        30
    ],
    minute: [
        1,
        2,
        3,
        5,
        10,
        15,
        20,
        30
    ],
    hour: [
        1,
        2,
        3,
        4,
        6,
        8,
        12
    ],
    day: [
        1,
        2
    ],
    week: [
        1,
        2
    ],
    month: [
        1,
        2,
        3,
        6
    ]
};
var $03e5368ea0d45f9a$var$DATETIME_MULTIPLIERS_WITH_BIG_WEEKEND = (0, $2oTOp.extend)({}, $03e5368ea0d45f9a$var$DATETIME_MULTIPLIERS, {
    day: [
        1
    ]
});
var $03e5368ea0d45f9a$var$DATETIME_MINOR_MULTIPLIERS = {
    millisecond: [
        1,
        2,
        5,
        10,
        25,
        50,
        100,
        250,
        500
    ],
    second: [
        1,
        2,
        3,
        5,
        10,
        15,
        20,
        30
    ],
    minute: [
        1,
        2,
        3,
        5,
        10,
        15,
        20,
        30
    ],
    hour: [
        1,
        2,
        3,
        4,
        6,
        8,
        12
    ],
    day: [
        1,
        2,
        3,
        7,
        14
    ],
    month: [
        1,
        2,
        3,
        6
    ]
};
var $03e5368ea0d45f9a$var$MINOR_DELIMITERS = [
    2,
    4,
    5,
    8,
    10
];
var $03e5368ea0d45f9a$var$VISIBILITY_DELIMITER = 3;
var $03e5368ea0d45f9a$var$MINUTE = 6e4;
function $03e5368ea0d45f9a$var$dummyGenerator(options) {
    return function(data, screenDelta, tickInterval, forceTickInterval) {
        var count = $03e5368ea0d45f9a$var$mathFloor(screenDelta / options.axisDivisionFactor);
        count = count < 1 ? 1 : count;
        var interval = screenDelta / count;
        return {
            ticks: interval > 0 ? Array.apply(null, new Array(count + 1)).map((_, i)=>interval * i) : [],
            tickInterval: interval
        };
    };
}
function $03e5368ea0d45f9a$var$discreteGenerator(options) {
    return function(data, screenDelta, tickInterval, forceTickInterval) {
        var categories = (0, $dw9tZ.getCategoriesInfo)(data.categories, data.min, data.max).categories;
        return {
            ticks: categories,
            tickInterval: $03e5368ea0d45f9a$var$mathCeil(categories.length * options.axisDivisionFactor / screenDelta)
        };
    };
}
var $03e5368ea0d45f9a$var$getValue = (value)=>value;
var $03e5368ea0d45f9a$var$getLogValue = (base, allowNegatives, linearThreshold)=>(value)=>(0, $dw9tZ.getLogExt)(value, base, allowNegatives, linearThreshold);
var $03e5368ea0d45f9a$var$raiseTo = (base, allowNegatives, linearThreshold)=>(value)=>(0, $dw9tZ.raiseToExt)(value, base, allowNegatives, linearThreshold);
var $03e5368ea0d45f9a$var$mathRaiseTo = (base)=>(value)=>(0, $dw9tZ.raiseTo)(value, base);
var $03e5368ea0d45f9a$var$logAbsValue = (base)=>(value)=>0 === value ? 0 : (0, $dw9tZ.getLog)($03e5368ea0d45f9a$var$mathAbs(value), base);
var $03e5368ea0d45f9a$var$correctValueByInterval = (post, round, getValue)=>(value, interval)=>(0, $laqiS.adjust)(post(round((0, $laqiS.adjust)(getValue(value) / interval)) * interval));
function $03e5368ea0d45f9a$var$correctMinValueByEndOnTick(floorFunc, ceilFunc, resolveEndOnTick, endOnTick) {
    if ((0, $6ntMu.isDefined)(endOnTick)) return endOnTick ? floorFunc : ceilFunc;
    return function(value, interval, businessViewInfo, forceEndOnTick) {
        var floorTickValue = floorFunc(value, interval);
        if (value - floorTickValue === 0 || !(0, $6ntMu.isDefined)(businessViewInfo) || resolveEndOnTick(value, floorTickValue, interval, businessViewInfo) || forceEndOnTick) return floorTickValue;
        return ceilFunc(value, interval);
    };
}
function $03e5368ea0d45f9a$var$resolveEndOnTick(curValue, tickValue, interval, businessViewInfo) {
    var prevTickDataDiff = interval - $03e5368ea0d45f9a$var$mathAbs(tickValue - curValue);
    var intervalCount = $03e5368ea0d45f9a$var$math.max($03e5368ea0d45f9a$var$mathCeil(businessViewInfo.businessDelta / interval), 2);
    var businessRatio = businessViewInfo.screenDelta / (intervalCount * interval);
    var potentialTickScreenDiff = $03e5368ea0d45f9a$var$math.round(businessRatio * prevTickDataDiff);
    var delimiterFactor = (0, $dw9tZ.getLogExt)(businessRatio * interval / businessViewInfo.axisDivisionFactor, 2) + 1;
    var delimiterMultiplier = (businessViewInfo.isSpacedMargin ? 2 : 1) * delimiterFactor;
    var screenDelimiter = $03e5368ea0d45f9a$var$math.round($03e5368ea0d45f9a$var$VISIBILITY_DELIMITER * delimiterMultiplier);
    return businessViewInfo.businessDelta > businessViewInfo.interval && potentialTickScreenDiff >= screenDelimiter;
}
function $03e5368ea0d45f9a$var$resolveEndOnTickLog(base) {
    return function(curValue, tickValue, interval, businessViewInfo) {
        return $03e5368ea0d45f9a$var$resolveEndOnTick((0, $dw9tZ.getLogExt)(curValue, base), (0, $dw9tZ.getLogExt)(tickValue, base), interval, businessViewInfo);
    };
}
function $03e5368ea0d45f9a$var$resolveEndOnTickDate(curValue, tickValue, interval, businessViewInfo) {
    return $03e5368ea0d45f9a$var$resolveEndOnTick(curValue.valueOf(), tickValue.valueOf(), $03e5368ea0d45f9a$var$dateToMilliseconds(interval), businessViewInfo);
}
function $03e5368ea0d45f9a$var$getBusinessDelta(data, breaks) {
    var spacing = 0;
    if (breaks) spacing = breaks.reduce((prev, item)=>prev + (item.to - item.from), 0);
    return $03e5368ea0d45f9a$var$mathAbs(data.max - data.min - spacing);
}
function $03e5368ea0d45f9a$var$getBusinessDeltaLog(base, allowNegatives, linearThreshold) {
    var getLog = $03e5368ea0d45f9a$var$getLogValue(base, allowNegatives, linearThreshold);
    return function(data, breaks) {
        var spacing = 0;
        if (breaks) spacing = breaks.reduce((prev, item)=>prev + $03e5368ea0d45f9a$var$mathAbs(getLog(item.to / item.from)), 0);
        return $03e5368ea0d45f9a$var$mathCeil($03e5368ea0d45f9a$var$mathAbs(getLog(data.max) - getLog(data.min)) - spacing);
    };
}
function $03e5368ea0d45f9a$var$getIntervalByFactor(businessDelta, screenDelta, axisDivisionFactor, addTickCount) {
    var count = screenDelta / axisDivisionFactor - (addTickCount || 0);
    count = count < 1 ? 1 : count;
    return businessDelta / count;
}
function $03e5368ea0d45f9a$var$getMultiplierFactor(interval, factorDelta) {
    return $03e5368ea0d45f9a$var$mathPow(10, $03e5368ea0d45f9a$var$mathFloor((0, $dw9tZ.getLogExt)(interval, 10)) + (factorDelta || 0));
}
function $03e5368ea0d45f9a$var$calculateTickInterval(businessDelta, screenDelta, tickInterval, forceTickInterval, axisDivisionFactor, multipliers, allowDecimals, addTickCount, _, minTickInterval) {
    var interval = $03e5368ea0d45f9a$var$getIntervalByFactor(businessDelta, screenDelta, axisDivisionFactor, addTickCount);
    var result = 1;
    var onlyIntegers = false === allowDecimals;
    if (!forceTickInterval || !tickInterval) {
        if (interval >= 1 || !onlyIntegers && interval > 0) result = $03e5368ea0d45f9a$var$adjustInterval(interval, multipliers, onlyIntegers);
        if (!tickInterval || !forceTickInterval && tickInterval < result) tickInterval = result;
    }
    if (!forceTickInterval && minTickInterval) {
        minTickInterval = $03e5368ea0d45f9a$var$adjustInterval(minTickInterval, multipliers, onlyIntegers);
        if (minTickInterval > tickInterval) tickInterval = minTickInterval;
    }
    return tickInterval;
}
function $03e5368ea0d45f9a$var$adjustInterval(interval, multipliers, onlyIntegers) {
    var factor = $03e5368ea0d45f9a$var$getMultiplierFactor(interval, -1);
    var result = 1;
    multipliers = multipliers || $03e5368ea0d45f9a$var$NUMBER_MULTIPLIERS;
    if (interval > 0) {
        interval /= factor;
        result = multipliers.concat(10 * multipliers[0]).map((m)=>10 * m).reduce((r, m)=>{
            if (.1 === factor && onlyIntegers && 25 === m) return r;
            return r < interval ? m : r;
        }, 0);
        result = (0, $laqiS.adjust)(result * factor, factor);
    }
    return result;
}
function $03e5368ea0d45f9a$var$calculateMinorTickInterval(businessDelta, screenDelta, tickInterval, axisDivisionFactor) {
    var interval = $03e5368ea0d45f9a$var$getIntervalByFactor(businessDelta, screenDelta, axisDivisionFactor);
    return tickInterval || $03e5368ea0d45f9a$var$MINOR_DELIMITERS.reduce((r, d)=>{
        var cur = businessDelta / d;
        return cur >= interval ? cur : r;
    }, 0);
}
function $03e5368ea0d45f9a$var$getCalculateTickIntervalLog(skipCalculationLimits) {
    return function(businessDelta, screenDelta, tickInterval, forceTickInterval, axisDivisionFactor, multipliers, allowDecimals, _, __, minTickInterval) {
        var interval = $03e5368ea0d45f9a$var$getIntervalByFactor(businessDelta, screenDelta, axisDivisionFactor);
        var result = 0;
        var adjustInterval = $03e5368ea0d45f9a$var$getAdjustIntervalLog(skipCalculationLimits);
        if (!forceTickInterval || !tickInterval) {
            if (interval > 0) result = adjustInterval(interval, multipliers);
            if (!tickInterval || !forceTickInterval && tickInterval < result) tickInterval = result;
        }
        if (!forceTickInterval && minTickInterval) {
            minTickInterval = adjustInterval(minTickInterval, multipliers);
            if (minTickInterval > tickInterval) tickInterval = minTickInterval;
        }
        return tickInterval;
    };
}
function $03e5368ea0d45f9a$var$getAdjustIntervalLog(skipCalculationLimits) {
    return function(interval, multipliers) {
        var factor = $03e5368ea0d45f9a$var$getMultiplierFactor(interval);
        multipliers = multipliers || $03e5368ea0d45f9a$var$LOGARITHMIC_MULTIPLIERS;
        if (!skipCalculationLimits && factor < 1) factor = 1;
        return multipliers.concat(10 * multipliers[0]).reduce((r, m)=>r < interval ? m * factor : r, 0);
    };
}
function $03e5368ea0d45f9a$var$getDataTimeMultipliers(gapSize) {
    if (gapSize && gapSize > 2) return $03e5368ea0d45f9a$var$DATETIME_MULTIPLIERS_WITH_BIG_WEEKEND;
    else return $03e5368ea0d45f9a$var$DATETIME_MULTIPLIERS;
}
function $03e5368ea0d45f9a$var$numbersReducer(interval, key) {
    return function(r, m) {
        if (!r && interval <= $03e5368ea0d45f9a$var$convertDateUnitToMilliseconds(key, m)) {
            r = {};
            r[key + "s"] = m;
        }
        return r;
    };
}
function $03e5368ea0d45f9a$var$yearsReducer(interval, factor) {
    return function(r, m) {
        var years = factor * m;
        if (!r && interval <= $03e5368ea0d45f9a$var$convertDateUnitToMilliseconds("year", years) && 2.5 !== years) r = {
            years: years
        };
        return r;
    };
}
function $03e5368ea0d45f9a$var$calculateTickIntervalDateTime(businessDelta, screenDelta, tickInterval, forceTickInterval, axisDivisionFactor, multipliers, allowDecimals, addTickCount, gapSize, minTickInterval) {
    if (!forceTickInterval || !tickInterval) {
        var result = $03e5368ea0d45f9a$var$adjustIntervalDateTime($03e5368ea0d45f9a$var$getIntervalByFactor(businessDelta, screenDelta, axisDivisionFactor), multipliers, null, gapSize);
        if (!tickInterval || !forceTickInterval && $03e5368ea0d45f9a$var$dateToMilliseconds(tickInterval) <= $03e5368ea0d45f9a$var$dateToMilliseconds(result)) tickInterval = result;
    }
    if (!forceTickInterval && minTickInterval) {
        minTickInterval = $03e5368ea0d45f9a$var$adjustIntervalDateTime(minTickInterval, multipliers, null, gapSize);
        if ($03e5368ea0d45f9a$var$dateToMilliseconds(minTickInterval) > $03e5368ea0d45f9a$var$dateToMilliseconds(tickInterval)) tickInterval = minTickInterval;
    }
    return tickInterval;
}
function $03e5368ea0d45f9a$var$adjustIntervalDateTime(interval, multipliers, _, gapSize) {
    var result;
    multipliers = multipliers || $03e5368ea0d45f9a$var$getDataTimeMultipliers(gapSize);
    for(var key in multipliers){
        result = multipliers[key].reduce($03e5368ea0d45f9a$var$numbersReducer(interval, key), result);
        if (result) break;
    }
    if (!result) for(var factor = 1;; factor *= 10){
        result = $03e5368ea0d45f9a$var$NUMBER_MULTIPLIERS.reduce($03e5368ea0d45f9a$var$yearsReducer(interval, factor), result);
        if (result) break;
    }
    return result;
}
function $03e5368ea0d45f9a$var$calculateMinorTickIntervalDateTime(businessDelta, screenDelta, tickInterval, axisDivisionFactor) {
    return $03e5368ea0d45f9a$var$calculateTickIntervalDateTime(businessDelta, screenDelta, tickInterval, true, axisDivisionFactor, $03e5368ea0d45f9a$var$DATETIME_MINOR_MULTIPLIERS);
}
function $03e5368ea0d45f9a$var$getTickIntervalByCustomTicks(getValue, postProcess) {
    return (ticks)=>ticks ? postProcess($03e5368ea0d45f9a$var$mathAbs((0, $laqiS.adjust)(getValue(ticks[1]) - getValue(ticks[0])))) || void 0 : void 0;
}
function $03e5368ea0d45f9a$var$addInterval(value, interval, isNegative) {
    return (0, $f38Z1.default).addInterval(value, interval, isNegative);
}
function $03e5368ea0d45f9a$var$addIntervalLog(log, raise) {
    return (value, interval, isNegative)=>raise($03e5368ea0d45f9a$var$addInterval(log(value), interval, isNegative));
}
function $03e5368ea0d45f9a$var$addIntervalDate(value, interval, isNegative) {
    return $03e5368ea0d45f9a$var$addInterval(value, interval, isNegative);
}
function $03e5368ea0d45f9a$var$addIntervalWithBreaks(addInterval, breaks, correctValue) {
    breaks = breaks.filter((b)=>!b.gapSize);
    return function(value, interval, isNegative) {
        var breakSize;
        value = addInterval(value, interval, isNegative);
        if (!breaks.every((item)=>{
            if (value >= addInterval(item.from, interval) && addInterval(value, interval) < item.to) breakSize = item.to - item.from - 2 * (addInterval(item.from, interval) - item.from);
            return !breakSize;
        })) value = correctValue(addInterval(value, breakSize), interval);
        return value;
    };
}
function $03e5368ea0d45f9a$var$calculateTicks(addInterval, correctMinValue, adjustInterval, resolveEndOnTick) {
    return function(data, tickInterval, endOnTick, gaps, breaks, businessDelta, screenDelta, axisDivisionFactor, generateExtraTick) {
        var correctTickValue = $03e5368ea0d45f9a$var$correctTickValueOnGapSize(addInterval, gaps);
        var min = data.min;
        var max = data.max;
        var businessViewInfo = {
            screenDelta: screenDelta,
            businessDelta: businessDelta,
            axisDivisionFactor: axisDivisionFactor,
            isSpacedMargin: data.isSpacedMargin,
            interval: tickInterval
        };
        var cur = correctMinValue(min, tickInterval, businessViewInfo);
        var ticks = [];
        if (null !== breaks && void 0 !== breaks && breaks.length) addInterval = $03e5368ea0d45f9a$var$addIntervalWithBreaks(addInterval, breaks, correctMinValue);
        if (cur > max) {
            cur = correctMinValue(min, adjustInterval(businessDelta / 2), businessViewInfo);
            if (cur > max) {
                endOnTick = true;
                cur = correctMinValue(min, tickInterval, businessViewInfo, endOnTick);
            }
        }
        cur = correctTickValue(cur);
        var prev;
        while(cur < max && cur !== prev || generateExtraTick && cur <= max){
            ticks.push(cur);
            prev = cur;
            cur = correctTickValue(addInterval(cur, tickInterval));
        }
        if (endOnTick || cur - max === 0 || !(0, $6ntMu.isDefined)(endOnTick) && resolveEndOnTick(max, cur, tickInterval, businessViewInfo)) ticks.push(cur);
        return ticks;
    };
}
function $03e5368ea0d45f9a$var$calculateMinorTicks(updateTickInterval, addInterval, correctMinValue, correctTickValue, ceil) {
    return function(min, max, majorTicks, minorTickInterval, tickInterval, breaks, maxCount) {
        var factor = tickInterval / minorTickInterval;
        var lastMajor = majorTicks[majorTicks.length - 1];
        var firstMajor = majorTicks[0];
        var tickBalance = maxCount - 1;
        if (null !== breaks && void 0 !== breaks && breaks.length) addInterval = $03e5368ea0d45f9a$var$addIntervalWithBreaks(addInterval, breaks, correctMinValue);
        minorTickInterval = updateTickInterval(minorTickInterval, firstMajor, firstMajor, factor);
        if (0 === minorTickInterval) return [];
        var cur = correctTickValue(correctMinValue(min, tickInterval, min), minorTickInterval);
        minorTickInterval = updateTickInterval(minorTickInterval, firstMajor, cur, factor);
        var ticks = [];
        while(cur < firstMajor && (!tickBalance || tickBalance > 0)){
            cur >= min && ticks.push(cur);
            tickBalance--;
            cur = addInterval(cur, minorTickInterval);
        }
        var middleTicks = majorTicks.reduce((r, tick)=>{
            tickBalance = maxCount - 1;
            if (null === r.prevTick) {
                r.prevTick = tick;
                return r;
            }
            minorTickInterval = updateTickInterval(minorTickInterval, tick, r.prevTick, factor);
            var cur = correctTickValue(r.prevTick, minorTickInterval);
            while(cur < tick && (!tickBalance || tickBalance > 0)){
                cur !== r.prevTick && r.minors.push(cur);
                tickBalance--;
                cur = addInterval(cur, minorTickInterval);
            }
            r.prevTick = tick;
            return r;
        }, {
            prevTick: null,
            minors: []
        });
        ticks = ticks.concat(middleTicks.minors);
        var maxValue = ceil(max, tickInterval, min);
        minorTickInterval = updateTickInterval(minorTickInterval, maxValue, maxValue, factor);
        cur = correctTickValue(lastMajor, minorTickInterval);
        var prev;
        while(cur < max && cur !== prev){
            ticks.push(cur);
            prev = cur;
            cur = addInterval(cur, minorTickInterval);
        }
        if (lastMajor - max !== 0 && cur - max === 0) ticks.push(cur);
        return ticks;
    };
}
function $03e5368ea0d45f9a$var$filterTicks(ticks, breaks) {
    if (breaks.length) {
        var result = breaks.reduce((result, b)=>{
            var tmpTicks = [];
            var i;
            for(i = result[1]; i < ticks.length; i++){
                var tickValue = ticks[i];
                if (tickValue < b.from) tmpTicks.push(tickValue);
                if (tickValue >= b.to) break;
            }
            return [
                result[0].concat(tmpTicks),
                i
            ];
        }, [
            [],
            0
        ]);
        return result[0].concat(ticks.slice(result[1]));
    }
    return ticks;
}
function $03e5368ea0d45f9a$var$correctTickValueOnGapSize(addInterval, breaks) {
    return function(value) {
        var gapSize;
        if (!breaks.every((item)=>{
            if (value >= item.from && value < item.to) gapSize = item.gapSize;
            return !gapSize;
        })) value = addInterval(value, gapSize);
        return value;
    };
}
function $03e5368ea0d45f9a$var$generator(options, getBusinessDelta, calculateTickInterval, calculateMinorTickInterval, getMajorTickIntervalByCustomTicks, getMinorTickIntervalByCustomTicks, convertTickInterval, calculateTicks, calculateMinorTicks, processScaleBreaks) {
    function correctUserTickInterval(tickInterval, businessDelta, limit) {
        if (tickInterval && businessDelta / convertTickInterval(tickInterval) >= limit + 1) {
            options.incidentOccurred("W2003");
            tickInterval = void 0;
        }
        return tickInterval;
    }
    return function(data, screenDelta, tickInterval, forceTickInterval, customTicks, minorTickInterval, minorTickCount, breaks) {
        customTicks = customTicks || {};
        var businessDelta = getBusinessDelta(data, breaks);
        var result = function(customTicks) {
            return {
                tickInterval: getMajorTickIntervalByCustomTicks(customTicks.majors),
                ticks: customTicks.majors || [],
                minorTickInterval: getMinorTickIntervalByCustomTicks(customTicks.minors),
                minorTicks: customTicks.minors || []
            };
        }(customTicks);
        if (!isNaN(businessDelta)) {
            if (0 === businessDelta && !customTicks.majors) result.ticks = [
                data.min
            ];
            else {
                result = function(ticks, data, businessDelta, screenDelta, tickInterval, forceTickInterval, customTicks, breaks) {
                    if (customTicks.majors) {
                        ticks.breaks = breaks;
                        return ticks;
                    }
                    var gaps = breaks.filter((b)=>b.gapSize);
                    var majorTicks;
                    tickInterval = options.skipCalculationLimits ? tickInterval : correctUserTickInterval(tickInterval, businessDelta, screenDelta);
                    tickInterval = calculateTickInterval(businessDelta, screenDelta, tickInterval, forceTickInterval, options.axisDivisionFactor, options.numberMultipliers, options.allowDecimals, breaks.length, gaps[0] && gaps[0].gapSize.days, options.minTickInterval);
                    if (!options.skipTickGeneration) {
                        majorTicks = calculateTicks(data, tickInterval, options.endOnTick, gaps, breaks, businessDelta, screenDelta, options.axisDivisionFactor, options.generateExtraTick);
                        breaks = processScaleBreaks(breaks, majorTicks, tickInterval);
                        majorTicks = $03e5368ea0d45f9a$var$filterTicks(majorTicks, breaks);
                        ticks.breaks = breaks;
                        ticks.ticks = ticks.ticks.concat(majorTicks);
                    }
                    ticks.tickInterval = tickInterval;
                    return ticks;
                }(result, data, businessDelta, screenDelta, tickInterval, forceTickInterval, customTicks, breaks || []);
                if (!options.skipTickGeneration && businessDelta > 0) result = function(ticks, data, businessDelta, screenDelta, minorTickInterval, minorTickCount, customTicks) {
                    if (!options.calculateMinors) return ticks;
                    if (customTicks.minors) return ticks;
                    var minorBusinessDelta = convertTickInterval(ticks.tickInterval);
                    var minorScreenDelta = screenDelta * minorBusinessDelta / businessDelta;
                    var breaks = ticks.breaks;
                    if (!minorTickInterval && minorTickCount) minorTickInterval = getMinorTickIntervalByCustomTicks([
                        minorBusinessDelta / (minorTickCount + 1),
                        minorBusinessDelta / (minorTickCount + 1) * 2
                    ]);
                    else minorTickCount = void 0;
                    minorTickInterval = correctUserTickInterval(minorTickInterval, minorBusinessDelta, minorScreenDelta);
                    minorTickInterval = calculateMinorTickInterval(minorBusinessDelta, minorScreenDelta, minorTickInterval, options.minorAxisDivisionFactor);
                    ticks.minorTicks = $03e5368ea0d45f9a$var$filterTicks(ticks.minorTicks.concat(calculateMinorTicks(data.min, data.max, ticks.ticks, minorTickInterval, ticks.tickInterval, breaks, minorTickCount)), breaks);
                    ticks.minorTickInterval = minorTickInterval;
                    return ticks;
                }(result, data, businessDelta, screenDelta, minorTickInterval, minorTickCount, customTicks);
            }
        }
        return result;
    };
}
function $03e5368ea0d45f9a$var$getBaseTick(breakValue, _ref, interval, getValue) {
    var [tick, insideTick] = _ref;
    if (!(0, $6ntMu.isDefined)(tick) || $03e5368ea0d45f9a$var$mathAbs(getValue(breakValue) - getValue(tick)) / interval > .25) {
        if ((0, $6ntMu.isDefined)(insideTick) && $03e5368ea0d45f9a$var$mathAbs(getValue(insideTick) - getValue(tick)) / interval < 2) tick = insideTick;
        else if (!(0, $6ntMu.isDefined)(tick)) tick = breakValue;
    }
    return tick;
}
function $03e5368ea0d45f9a$var$getScaleBreaksProcessor(convertTickInterval, getValue, addCorrection) {
    return function(breaks, ticks, tickInterval) {
        var interval = convertTickInterval(tickInterval);
        var correction = .5 * interval;
        return breaks.reduce((result, b)=>{
            var breakTicks = ticks.filter((tick)=>tick <= b.from);
            var from = addCorrection($03e5368ea0d45f9a$var$getBaseTick(b.from, [].concat(breakTicks[breakTicks.length - 1], ticks[breakTicks.length]), interval, getValue), correction);
            breakTicks = ticks.filter((tick)=>tick >= b.to);
            var to = addCorrection($03e5368ea0d45f9a$var$getBaseTick(b.to, [].concat(breakTicks[0], ticks[ticks.length - breakTicks.length - 1]), interval, getValue), -correction);
            if (getValue(to) - getValue(from) < interval && !b.gapSize) return result;
            if (b.gapSize) return result.concat([
                b
            ]);
            return result.concat([
                {
                    from: from,
                    to: to,
                    cumulativeWidth: b.cumulativeWidth
                }
            ]);
        }, []);
    };
}
function $03e5368ea0d45f9a$var$numericGenerator(options) {
    var floor = $03e5368ea0d45f9a$var$correctValueByInterval($03e5368ea0d45f9a$var$getValue, $03e5368ea0d45f9a$var$mathFloor, $03e5368ea0d45f9a$var$getValue);
    var ceil = $03e5368ea0d45f9a$var$correctValueByInterval($03e5368ea0d45f9a$var$getValue, $03e5368ea0d45f9a$var$mathCeil, $03e5368ea0d45f9a$var$getValue);
    var calculateTickIntervalByCustomTicks = $03e5368ea0d45f9a$var$getTickIntervalByCustomTicks($03e5368ea0d45f9a$var$getValue, $03e5368ea0d45f9a$var$getValue);
    return $03e5368ea0d45f9a$var$generator(options, $03e5368ea0d45f9a$var$getBusinessDelta, $03e5368ea0d45f9a$var$calculateTickInterval, $03e5368ea0d45f9a$var$calculateMinorTickInterval, calculateTickIntervalByCustomTicks, calculateTickIntervalByCustomTicks, $03e5368ea0d45f9a$var$getValue, $03e5368ea0d45f9a$var$calculateTicks($03e5368ea0d45f9a$var$addInterval, $03e5368ea0d45f9a$var$correctMinValueByEndOnTick(floor, ceil, $03e5368ea0d45f9a$var$resolveEndOnTick, options.endOnTick), $03e5368ea0d45f9a$var$adjustInterval, $03e5368ea0d45f9a$var$resolveEndOnTick), $03e5368ea0d45f9a$var$calculateMinorTicks($03e5368ea0d45f9a$var$getValue, $03e5368ea0d45f9a$var$addInterval, floor, $03e5368ea0d45f9a$var$addInterval, $03e5368ea0d45f9a$var$getValue), $03e5368ea0d45f9a$var$getScaleBreaksProcessor($03e5368ea0d45f9a$var$getValue, $03e5368ea0d45f9a$var$getValue, (value, correction)=>value + correction));
}
var $03e5368ea0d45f9a$var$correctValueByIntervalLog = (post, getRound, getValue)=>(value, interval)=>(0, $laqiS.sign)(value) * (0, $laqiS.adjust)(post(getRound(value)((0, $laqiS.adjust)(getValue(value) / interval)) * interval));
function $03e5368ea0d45f9a$var$logarithmicGenerator(options) {
    var base = options.logBase;
    var raise = $03e5368ea0d45f9a$var$raiseTo(base, options.allowNegatives, options.linearThreshold);
    var log = $03e5368ea0d45f9a$var$getLogValue(base, options.allowNegatives, options.linearThreshold);
    var absLog = $03e5368ea0d45f9a$var$logAbsValue(base);
    var absRaise = $03e5368ea0d45f9a$var$mathRaiseTo(base);
    var floor = $03e5368ea0d45f9a$var$correctValueByIntervalLog(absRaise, (value)=>value < 0 ? $03e5368ea0d45f9a$var$mathCeil : $03e5368ea0d45f9a$var$mathFloor, absLog);
    var ceil = $03e5368ea0d45f9a$var$correctValueByIntervalLog(absRaise, (value)=>value < 0 ? $03e5368ea0d45f9a$var$mathFloor : $03e5368ea0d45f9a$var$mathCeil, absLog);
    var ceilNumber = $03e5368ea0d45f9a$var$correctValueByInterval($03e5368ea0d45f9a$var$getValue, $03e5368ea0d45f9a$var$mathCeil, $03e5368ea0d45f9a$var$getValue);
    return $03e5368ea0d45f9a$var$generator(options, $03e5368ea0d45f9a$var$getBusinessDeltaLog(base, options.allowNegatives, options.linearThreshold), $03e5368ea0d45f9a$var$getCalculateTickIntervalLog(options.skipCalculationLimits), $03e5368ea0d45f9a$var$calculateMinorTickInterval, $03e5368ea0d45f9a$var$getTickIntervalByCustomTicks(log, $03e5368ea0d45f9a$var$getValue), $03e5368ea0d45f9a$var$getTickIntervalByCustomTicks($03e5368ea0d45f9a$var$getValue, $03e5368ea0d45f9a$var$getValue), $03e5368ea0d45f9a$var$getValue, $03e5368ea0d45f9a$var$calculateTicks($03e5368ea0d45f9a$var$addIntervalLog(log, raise), $03e5368ea0d45f9a$var$correctMinValueByEndOnTick(floor, ceil, $03e5368ea0d45f9a$var$resolveEndOnTickLog(base), options.endOnTick), $03e5368ea0d45f9a$var$getAdjustIntervalLog(options.skipCalculationLimits), $03e5368ea0d45f9a$var$resolveEndOnTickLog(base)), $03e5368ea0d45f9a$var$calculateMinorTicks((_, tick, prevTick, factor)=>Math.max(Math.abs(tick), Math.abs(prevTick)) / factor, $03e5368ea0d45f9a$var$addInterval, floor, ceilNumber, ceil), $03e5368ea0d45f9a$var$getScaleBreaksProcessor($03e5368ea0d45f9a$var$getValue, log, (value, correction)=>raise(log(value) + correction)));
}
function $03e5368ea0d45f9a$var$dateGenerator(options) {
    function floor(value, interval) {
        var floorNumber = $03e5368ea0d45f9a$var$correctValueByInterval($03e5368ea0d45f9a$var$getValue, $03e5368ea0d45f9a$var$mathFloor, $03e5368ea0d45f9a$var$getValue);
        var intervalObject = (0, $6ntMu.isString)(interval) ? (0, $f38Z1.default).getDateIntervalByString(interval.toLowerCase()) : interval;
        var divider = $03e5368ea0d45f9a$var$dateToMilliseconds(interval);
        if (intervalObject.days % 7 === 0 || interval.quarters) intervalObject = $03e5368ea0d45f9a$var$adjustIntervalDateTime(divider);
        var correctDateWithUnitBeginning = (v)=>(0, $f38Z1.default).correctDateWithUnitBeginning(v, intervalObject, null, options.firstDayOfWeek);
        var floorAtStartDate = (v)=>new Date($03e5368ea0d45f9a$var$mathFloor((v.getTime() - v.getTimezoneOffset() * $03e5368ea0d45f9a$var$MINUTE) / divider) * divider + v.getTimezoneOffset() * $03e5368ea0d45f9a$var$MINUTE);
        value = correctDateWithUnitBeginning(value);
        if ("years" in intervalObject) value.setFullYear(floorNumber(value.getFullYear(), intervalObject.years));
        else if ("quarters" in intervalObject) value = correctDateWithUnitBeginning(floorAtStartDate(value));
        else if ("months" in intervalObject) value.setMonth(floorNumber(value.getMonth(), intervalObject.months));
        else if ("weeks" in intervalObject || "days" in intervalObject) value = correctDateWithUnitBeginning(floorAtStartDate(value));
        else if ("hours" in intervalObject) value.setHours(floorNumber(value.getHours(), intervalObject.hours));
        else if ("minutes" in intervalObject) value.setMinutes(floorNumber(value.getMinutes(), intervalObject.minutes));
        else if ("seconds" in intervalObject) value.setSeconds(floorNumber(value.getSeconds(), intervalObject.seconds));
        else if ("milliseconds" in intervalObject) value = floorAtStartDate(value);
        return value;
    }
    var calculateTickIntervalByCustomTicks = $03e5368ea0d45f9a$var$getTickIntervalByCustomTicks($03e5368ea0d45f9a$var$getValue, (0, $f38Z1.default).convertMillisecondsToDateUnits);
    return $03e5368ea0d45f9a$var$generator(options, $03e5368ea0d45f9a$var$getBusinessDelta, $03e5368ea0d45f9a$var$calculateTickIntervalDateTime, $03e5368ea0d45f9a$var$calculateMinorTickIntervalDateTime, calculateTickIntervalByCustomTicks, calculateTickIntervalByCustomTicks, $03e5368ea0d45f9a$var$dateToMilliseconds, $03e5368ea0d45f9a$var$calculateTicks($03e5368ea0d45f9a$var$addIntervalDate, $03e5368ea0d45f9a$var$correctMinValueByEndOnTick(floor, function(value, interval) {
        var newValue = floor(value, interval);
        while(value - newValue > 0)newValue = $03e5368ea0d45f9a$var$addIntervalDate(newValue, interval);
        return newValue;
    }, $03e5368ea0d45f9a$var$resolveEndOnTickDate, options.endOnTick), $03e5368ea0d45f9a$var$adjustIntervalDateTime, $03e5368ea0d45f9a$var$resolveEndOnTickDate), $03e5368ea0d45f9a$var$calculateMinorTicks($03e5368ea0d45f9a$var$getValue, $03e5368ea0d45f9a$var$addIntervalDate, floor, $03e5368ea0d45f9a$var$addIntervalDate, $03e5368ea0d45f9a$var$getValue), $03e5368ea0d45f9a$var$getScaleBreaksProcessor($03e5368ea0d45f9a$var$dateToMilliseconds, $03e5368ea0d45f9a$var$getValue, (value, correction)=>new Date(value.getTime() + correction)));
}
var $03e5368ea0d45f9a$export$69828eed7c503d53 = function(options) {
    var result;
    if (options.rangeIsEmpty) result = $03e5368ea0d45f9a$var$dummyGenerator(options);
    else if ("discrete" === options.axisType) result = $03e5368ea0d45f9a$var$discreteGenerator(options);
    else if ("logarithmic" === options.axisType) result = $03e5368ea0d45f9a$var$logarithmicGenerator(options);
    else if ("datetime" === options.dataType) result = $03e5368ea0d45f9a$var$dateGenerator(options);
    else result = $03e5368ea0d45f9a$var$numericGenerator(options);
    return result;
};

});

parcelRegister("a6TS4", function(module, exports) {

$parcel$export(module.exports, "tick", function () { return $75c5cdc1f3fb1f9d$export$55d7f61db91b7b70; });
/**
 * DevExtreme (esm/viz/axes/tick.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $2oTOp = parcelRequire("2oTOp");

var $dDkff = parcelRequire("dDkff");
function $75c5cdc1f3fb1f9d$var$getPathStyle(options) {
    return {
        stroke: options.color,
        "stroke-width": options.width,
        "stroke-opacity": options.opacity,
        opacity: 1
    };
}
function $75c5cdc1f3fb1f9d$export$55d7f61db91b7b70(axis, renderer, tickOptions, gridOptions, skippedCategory, skipLabels, offset) {
    var tickOffset = offset || axis._tickOffset;
    var lineGroup = axis._axisLineGroup;
    var elementsGroup = axis._axisElementsGroup;
    var tickStyle = $75c5cdc1f3fb1f9d$var$getPathStyle(tickOptions);
    var gridStyle = $75c5cdc1f3fb1f9d$var$getPathStyle(gridOptions);
    var emptyStrRegExp = /^\s+$/;
    var axisOptions = axis.getOptions();
    var labelOptions = axisOptions.label;
    var labelStyle = axis._textOptions;
    function getLabelFontStyle(tick) {
        var fontStyle = axis._textFontStyles;
        var customizeColor = labelOptions.customizeColor;
        if (customizeColor && customizeColor.call) fontStyle = (0, $2oTOp.extend)({}, axis._textFontStyles, {
            fill: customizeColor.call(tick, tick)
        });
        return fontStyle;
    }
    function createLabelHint(tick, range) {
        var labelHint = axis.formatHint(tick.value, labelOptions, range);
        if ((0, $6ntMu.isDefined)(labelHint) && "" !== labelHint) tick.getContentContainer().setTitle(labelHint);
    }
    return function(value) {
        var tick = {
            value: value,
            updateValue (newValue) {
                this.value = value = newValue;
            },
            initCoords: function() {
                this.coords = axis._getTranslatedValue(value, tickOffset);
                this.labelCoords = axis._getTranslatedValue(value);
            },
            saveCoords () {
                this._lastStoredCoordinates = {
                    coords: this._storedCoords,
                    labelCoords: this._storedLabelsCoords
                };
                this._storedCoords = this.coords;
                this._storedLabelsCoords = this.templateContainer ? this._getTemplateCoords() : this.labelCoords;
            },
            resetCoordinates () {
                if (this._lastStoredCoordinates) {
                    this._storedCoords = this._lastStoredCoordinates.coords;
                    this._storedLabelsCoords = this._lastStoredCoordinates.labelCoords;
                }
            },
            drawMark (options) {
                if (!tickOptions.visible || skippedCategory === value) return;
                if (axis.areCoordsOutsideAxis(this.coords)) return;
                if (this.mark) {
                    this.mark.append(lineGroup);
                    axis.sharp(this.mark, axis.getSharpDirectionByCoords(this.coords));
                    this.updateTickPosition(options);
                } else {
                    this.mark = axis._createPathElement([], tickStyle, axis.getSharpDirectionByCoords(this.coords)).append(lineGroup);
                    this.updateTickPosition(options);
                }
            },
            setSkippedCategory (category) {
                skippedCategory = category;
            },
            _updateLine (lineElement, settings, storedSettings, animate, isGridLine) {
                if (!lineElement) return;
                if (null === settings.points || null === settings.r) {
                    lineElement.remove();
                    return;
                }
                if (animate && storedSettings && null !== storedSettings.points) {
                    settings.opacity = 1;
                    lineElement.attr(storedSettings);
                    lineElement.animate(settings);
                } else {
                    settings.opacity = animate ? 0 : 1;
                    lineElement.attr(settings);
                    animate && lineElement.animate({
                        opacity: 1
                    }, {
                        delay: .5,
                        partitionDuration: .5
                    });
                }
                this.coords.angle && axis._rotateTick(lineElement, this.coords, isGridLine);
            },
            updateTickPosition: function(options, animate) {
                this._updateLine(this.mark, {
                    points: axis._getTickMarkPoints(tick.coords, tickOptions.length, options)
                }, this._storedCoords && {
                    points: axis._getTickMarkPoints(tick._storedCoords, tickOptions.length, options)
                }, animate, false);
            },
            drawLabel: function(range, template) {
                if (this.templateContainer && axis.isRendered()) {
                    this.updateLabelPosition();
                    return;
                }
                var labelIsVisible = labelOptions.visible && !skipLabels && !axis.getTranslator().getBusinessRange().isEmpty() && !axis.areCoordsOutsideAxis(this.labelCoords);
                if (!labelIsVisible) {
                    if (this.label) this.removeLabel();
                    return;
                }
                var templateOption = labelOptions.template;
                var text = axis.formatLabel(value, labelOptions, range);
                if (this.label) {
                    this.label.attr({
                        text: text,
                        rotate: 0
                    }).append(elementsGroup);
                    createLabelHint(this, range);
                    this.updateLabelPosition();
                    return;
                }
                if (templateOption) {
                    this.templateContainer = renderer.g().append(elementsGroup);
                    this._templateDef && this._templateDef.reject();
                    this._templateDef = new (0, $dDkff.Deferred);
                    template.render({
                        model: {
                            valueText: text,
                            value: this.value,
                            labelFontStyle: getLabelFontStyle(this),
                            labelStyle: labelStyle
                        },
                        container: this.templateContainer.element,
                        onRendered: ()=>{
                            this.updateLabelPosition();
                            this._templateDef && this._templateDef.resolve();
                        }
                    });
                } else if ((0, $6ntMu.isDefined)(text) && "" !== text && !emptyStrRegExp.test(text)) {
                    this.label = renderer.text(text).css(getLabelFontStyle(this)).attr(labelStyle).append(elementsGroup);
                    this.updateLabelPosition();
                    createLabelHint(this, range);
                }
                var containerForData = this.getContentContainer();
                containerForData && containerForData.data("chart-data-argument", this.value);
                this.templateContainer && createLabelHint(this, range);
            },
            getTemplateDeferred () {
                return this._templateDef;
            },
            getContentContainer () {
                return this.templateContainer || this.label;
            },
            fadeOutElements () {
                var startSettings = {
                    opacity: 1
                };
                var endSettings = {
                    opacity: 0
                };
                var animationSettings = {
                    partitionDuration: .5
                };
                if (this.getContentContainer()) this._fadeOutLabel();
                if (this.grid) this.grid.append(axis._axisGridGroup).attr(startSettings).animate(endSettings, animationSettings);
                if (this.mark) this.mark.append(axis._axisLineGroup).attr(startSettings).animate(endSettings, animationSettings);
            },
            _fadeInLabel () {
                var group = axis._renderer.g().attr({
                    opacity: 0
                }).append(axis._axisElementsGroup).animate({
                    opacity: 1
                }, {
                    delay: .5,
                    partitionDuration: .5
                });
                this.getContentContainer().append(group);
            },
            _fadeOutLabel () {
                var group = axis._renderer.g().attr({
                    opacity: 1
                }).animate({
                    opacity: 0
                }, {
                    partitionDuration: .5
                }).append(axis._axisElementsGroup).toBackground();
                this.getContentContainer().append(group);
            },
            _getTemplateCoords () {
                return axis._getLabelAdjustedCoord(this, (axis._constantLabelOffset || 0) + (tick.labelOffset || 0));
            },
            updateLabelPosition: function(animate) {
                var templateContainer = this.templateContainer;
                if (!this.getContentContainer()) return;
                if (animate && this._storedLabelsCoords) {
                    if (templateContainer) {
                        templateContainer.attr(this._storedLabelsCoords);
                        var lCoords = this._getTemplateCoords();
                        templateContainer.animate(lCoords);
                    } else {
                        this.label.attr({
                            x: this._storedLabelsCoords.x,
                            y: this._storedLabelsCoords.y
                        });
                        this.label.animate({
                            x: this.labelCoords.x,
                            y: this.labelCoords.y
                        });
                    }
                } else {
                    if (templateContainer) {
                        var _lCoords = this._getTemplateCoords();
                        templateContainer.attr(_lCoords);
                    } else this.label.attr({
                        x: this.labelCoords.x,
                        y: this.labelCoords.y
                    });
                    if (animate) this._fadeInLabel();
                }
            },
            updateMultilineTextAlignment () {
                if (labelOptions.template || !this.label) return;
                this.label.attr({
                    textsAlignment: this.labelAlignment || axis.getOptions().label.alignment
                });
            },
            drawGrid: function(drawLine) {
                if (gridOptions.visible && skippedCategory !== this.value) {
                    if (this.grid) {
                        this.grid.append(axis._axisGridGroup);
                        axis.sharp(this.grid, axis.getSharpDirectionByCoords(this.coords));
                        this.updateGridPosition();
                    } else {
                        this.grid = drawLine(this, gridStyle);
                        this.grid && this.grid.append(axis._axisGridGroup);
                    }
                }
            },
            updateGridPosition: function(animate) {
                this._updateLine(this.grid, axis._getGridPoints(tick.coords), this._storedCoords && axis._getGridPoints(this._storedCoords), animate, true);
            },
            removeLabel () {
                var contentContainer = this.getContentContainer();
                contentContainer && contentContainer.remove();
                this._templateDef && this._templateDef.reject();
                this._templateDef = this.templateContainer = this.label = null;
            }
        };
        return tick;
    };
}

});

parcelRegister("ioF0U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d64a485686c19c75$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/axes/xy_axes.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $4jhWa = parcelRequire("4jhWa");

var $7UWPL = parcelRequire("7UWPL");

var $f38Z1 = parcelRequire("f38Z1");

var $2oTOp = parcelRequire("2oTOp");

var $gPVzX = parcelRequire("gPVzX");

var $gcp4g = parcelRequire("gcp4g");

var $dw9tZ = parcelRequire("dw9tZ");

var $6ntMu = parcelRequire("6ntMu");

var $aELZT = parcelRequire("aELZT");
var $d64a485686c19c75$var$getNextDateUnit = (0, $f38Z1.default).getNextDateUnit;
var $d64a485686c19c75$var$correctDateWithUnitBeginning = (0, $f38Z1.default).correctDateWithUnitBeginning;
var $d64a485686c19c75$var$_math = Math;
var $d64a485686c19c75$var$_max = $d64a485686c19c75$var$_math.max;
var $d64a485686c19c75$var$TOP = (0, $aELZT.default).top;
var $d64a485686c19c75$var$BOTTOM = (0, $aELZT.default).bottom;
var $d64a485686c19c75$var$LEFT = (0, $aELZT.default).left;
var $d64a485686c19c75$var$RIGHT = (0, $aELZT.default).right;
var $d64a485686c19c75$var$CENTER = (0, $aELZT.default).center;
var $d64a485686c19c75$var$SCALE_BREAK_OFFSET = 3;
var $d64a485686c19c75$var$RANGE_RATIO = .3;
var $d64a485686c19c75$var$WAVED_LINE_CENTER = 2;
var $d64a485686c19c75$var$WAVED_LINE_TOP = 0;
var $d64a485686c19c75$var$WAVED_LINE_BOTTOM = 4;
var $d64a485686c19c75$var$WAVED_LINE_LENGTH = 24;
var $d64a485686c19c75$var$TICKS_CORRECTIONS = {
    left: -1,
    top: -1,
    right: 0,
    bottom: 0,
    center: -0.5
};
function $d64a485686c19c75$var$prepareDatesDifferences(datesDifferences, tickInterval) {
    var dateUnitInterval;
    var i;
    if ("week" === tickInterval) tickInterval = "day";
    if ("quarter" === tickInterval) tickInterval = "month";
    if (datesDifferences[tickInterval]) for(i = 0; i < (0, $f38Z1.default).dateUnitIntervals.length; i++){
        dateUnitInterval = (0, $f38Z1.default).dateUnitIntervals[i];
        if (datesDifferences[dateUnitInterval]) {
            datesDifferences[dateUnitInterval] = false;
            datesDifferences.count--;
        }
        if (dateUnitInterval === tickInterval) break;
    }
}
function $d64a485686c19c75$var$sortingBreaks(breaks) {
    return breaks.sort(function(a, b) {
        return a.from - b.from;
    });
}
function $d64a485686c19c75$var$getMarkerDates(min, max, markerInterval) {
    var origMin = min;
    var dates;
    min = $d64a485686c19c75$var$correctDateWithUnitBeginning(min, markerInterval);
    max = $d64a485686c19c75$var$correctDateWithUnitBeginning(max, markerInterval);
    dates = (0, $f38Z1.default).getSequenceByInterval(min, max, markerInterval);
    if (dates.length && origMin > dates[0]) dates = dates.slice(1);
    return dates;
}
function $d64a485686c19c75$var$getStripHorizontalAlignmentPosition(alignment) {
    var position = "start";
    if ("center" === alignment) position = "center";
    if ("right" === alignment) position = "end";
    return position;
}
function $d64a485686c19c75$var$getStripVerticalAlignmentPosition(alignment) {
    var position = "start";
    if ("center" === alignment) position = "center";
    if ("bottom" === alignment) position = "end";
    return position;
}
function $d64a485686c19c75$var$getMarkerInterval(tickInterval) {
    var markerInterval = $d64a485686c19c75$var$getNextDateUnit(tickInterval);
    if ("quarter" === markerInterval) markerInterval = $d64a485686c19c75$var$getNextDateUnit(markerInterval);
    return markerInterval;
}
function $d64a485686c19c75$var$getMarkerFormat(curDate, prevDate, tickInterval, markerInterval) {
    var format = markerInterval;
    var datesDifferences = prevDate && (0, $f38Z1.default).getDatesDifferences(prevDate, curDate);
    if (prevDate && "year" !== tickInterval) {
        $d64a485686c19c75$var$prepareDatesDifferences(datesDifferences, tickInterval);
        format = (0, $7UWPL.default).getDateFormatByDifferences(datesDifferences);
    }
    return format;
}
function $d64a485686c19c75$var$getMaxSide(act, boxes) {
    return boxes.reduce(function(prevValue, box) {
        return $d64a485686c19c75$var$_max(prevValue, act(box));
    }, 0);
}
function $d64a485686c19c75$var$getDistanceByAngle(bBox, rotationAngle) {
    rotationAngle = $d64a485686c19c75$var$_math.abs(rotationAngle);
    rotationAngle = rotationAngle % 180 >= 90 ? 90 - rotationAngle % 90 : rotationAngle % 90;
    var a = rotationAngle * ($d64a485686c19c75$var$_math.PI / 180);
    if (a >= $d64a485686c19c75$var$_math.atan(bBox.height / bBox.width)) return bBox.height / $d64a485686c19c75$var$_math.abs($d64a485686c19c75$var$_math.sin(a));
    else return bBox.width;
}
function $d64a485686c19c75$var$getMaxConstantLinePadding(constantLines) {
    return constantLines.reduce(function(padding, options) {
        return $d64a485686c19c75$var$_max(padding, options.paddingTopBottom);
    }, 0);
}
function $d64a485686c19c75$var$getConstantLineLabelMarginForVerticalAlignment(constantLines, alignment, labelHeight) {
    return constantLines.some(function(options) {
        return options.label.verticalAlignment === alignment;
    }) && labelHeight || 0;
}
function $d64a485686c19c75$var$getLeftMargin(bBox) {
    return $d64a485686c19c75$var$_math.abs(bBox.x) || 0;
}
function $d64a485686c19c75$var$getRightMargin(bBox) {
    return $d64a485686c19c75$var$_math.abs(bBox.width - $d64a485686c19c75$var$_math.abs(bBox.x)) || 0;
}
function $d64a485686c19c75$var$generateRangesOnPoints(points, edgePoints, getRange) {
    var i;
    var length;
    var maxRange = null;
    var ranges = [];
    var curValue;
    var prevValue;
    var curRange;
    for(i = 1, length = points.length; i < length; i++){
        curValue = points[i];
        prevValue = points[i - 1];
        curRange = getRange(curValue, prevValue);
        if (edgePoints.indexOf(curValue) >= 0) {
            if (!maxRange || curRange > maxRange.length) maxRange = {
                start: curValue,
                end: prevValue,
                length: curRange
            };
        } else {
            if (maxRange && curRange < maxRange.length) ranges.push(maxRange);
            else ranges.push({
                start: curValue,
                end: prevValue,
                length: curRange
            });
            maxRange = null;
        }
    }
    if (maxRange) ranges.push(maxRange);
    return ranges;
}
function $d64a485686c19c75$var$generateAutoBreaks(_ref, series, _ref2) {
    var { logarithmBase: logarithmBase, type: type, maxAutoBreakCount: maxAutoBreakCount } = _ref;
    var { minVisible: minVisible, maxVisible: maxVisible } = _ref2;
    var breaks = [];
    var getRange = "logarithmic" === type ? (min, max)=>(0, $dw9tZ.getLog)(max / min, logarithmBase) : (min, max)=>max - min;
    var visibleRange = getRange(minVisible, maxVisible);
    var points = series.reduce((result, s)=>{
        var points = s.getPointsInViewPort();
        result[0] = result[0].concat(points[0]);
        result[1] = result[1].concat(points[1]);
        return result;
    }, [
        [],
        []
    ]);
    var sortedAllPoints = points[0].concat(points[1]).sort((a, b)=>b - a);
    var edgePoints = points[1].filter((p)=>points[0].indexOf(p) < 0);
    var minDiff = $d64a485686c19c75$var$RANGE_RATIO * visibleRange;
    var ranges = $d64a485686c19c75$var$generateRangesOnPoints(sortedAllPoints, edgePoints, getRange).sort((a, b)=>b.length - a.length);
    var epsilon = $d64a485686c19c75$var$_math.min.apply(null, ranges.map((r)=>r.length)) / 1e3;
    var _maxAutoBreakCount = (0, $6ntMu.isDefined)(maxAutoBreakCount) ? $d64a485686c19c75$var$_math.min(maxAutoBreakCount, ranges.length) : ranges.length;
    for(var i = 0; i < _maxAutoBreakCount; i++){
        if (ranges[i].length >= minDiff) {
            if (visibleRange <= ranges[i].length) break;
            visibleRange -= ranges[i].length;
            if (visibleRange > epsilon || visibleRange < -epsilon) {
                breaks.push({
                    from: ranges[i].start,
                    to: ranges[i].end
                });
                minDiff = $d64a485686c19c75$var$RANGE_RATIO * visibleRange;
            }
        } else break;
    }
    $d64a485686c19c75$var$sortingBreaks(breaks);
    return breaks;
}
var $d64a485686c19c75$export$2e2bcd8739ae039 = {
    linear: {
        _getStep: function(boxes, rotationAngle) {
            var spacing = this._options.label.minSpacing;
            var func = this._isHorizontal ? function(box) {
                return box.width + spacing;
            } : function(box) {
                return box.height;
            };
            var maxLabelLength = $d64a485686c19c75$var$getMaxSide(func, boxes);
            if (rotationAngle) maxLabelLength = $d64a485686c19c75$var$getDistanceByAngle({
                width: maxLabelLength,
                height: this._getMaxLabelHeight(boxes, 0)
            }, rotationAngle);
            return (0, $aELZT.default).getTicksCountInRange(this._majorTicks, this._isHorizontal ? "x" : "y", maxLabelLength);
        },
        _getMaxLabelHeight: function(boxes, spacing) {
            return $d64a485686c19c75$var$getMaxSide(function(box) {
                return box.height;
            }, boxes) + spacing;
        },
        _validateOverlappingMode: function(mode, displayMode) {
            if (this._isHorizontal && ("rotate" === displayMode || "stagger" === displayMode) || !this._isHorizontal) return (0, $aELZT.default).validateOverlappingMode(mode);
            return mode;
        },
        _validateDisplayMode: function(mode) {
            return this._isHorizontal ? mode : "standard";
        },
        getMarkerTrackers: function() {
            return this._markerTrackers;
        },
        _getSharpParam: function(opposite) {
            return this._isHorizontal ^ opposite ? "h" : "v";
        },
        _createAxisElement: function() {
            return this._renderer.path([], "line");
        },
        _updateAxisElementPosition: function() {
            var axisCoord = this._axisPosition;
            var canvas = this._getCanvasStartEnd();
            this._axisElement.attr({
                points: this._isHorizontal ? [
                    canvas.start,
                    axisCoord,
                    canvas.end,
                    axisCoord
                ] : [
                    axisCoord,
                    canvas.start,
                    axisCoord,
                    canvas.end
                ]
            });
        },
        _getTranslatedCoord: function(value, offset) {
            return this._translator.translate(value, offset);
        },
        _initAxisPositions () {
            if (this.customPositionIsAvailable()) this._customBoundaryPosition = this.getCustomBoundaryPosition();
            if (!this.customPositionIsAvailable() || this.customPositionIsBoundary()) this._axisPosition = this.getPredefinedPosition(this.getResolvedBoundaryPosition());
            else this._axisPosition = this.getCustomPosition();
        },
        _getTickMarkPoints (coords, length, tickOptions) {
            var isHorizontal = this._isHorizontal;
            var tickOrientation = this._options.tickOrientation;
            var labelPosition = this._options.label.position;
            var tickStartCoord;
            if ((0, $6ntMu.isDefined)(tickOrientation)) tickStartCoord = $d64a485686c19c75$var$TICKS_CORRECTIONS[tickOrientation] * length;
            else {
                var shift = tickOptions.shift || 0;
                if (!isHorizontal && labelPosition === $d64a485686c19c75$var$LEFT || isHorizontal && labelPosition !== $d64a485686c19c75$var$BOTTOM) shift = -shift;
                tickStartCoord = shift + this.getTickStartPositionShift(length);
            }
            return [
                coords.x + (isHorizontal ? 0 : tickStartCoord),
                coords.y + (isHorizontal ? tickStartCoord : 0),
                coords.x + (isHorizontal ? 0 : tickStartCoord + length),
                coords.y + (isHorizontal ? tickStartCoord + length : 0)
            ];
        },
        getTickStartPositionShift (length) {
            var width = this._options.width;
            var position = this.getResolvedBoundaryPosition();
            return length % 2 === 1 ? width % 2 === 0 && (position === $d64a485686c19c75$var$LEFT || position === $d64a485686c19c75$var$TOP) || width % 2 === 1 && (position === $d64a485686c19c75$var$RIGHT || position === $d64a485686c19c75$var$BOTTOM) && !this.hasNonBoundaryPosition() ? Math.floor(-length / 2) : -Math.floor(length / 2) : -length / 2 + (width % 2 === 0 ? 0 : position === $d64a485686c19c75$var$BOTTOM || position === $d64a485686c19c75$var$RIGHT ? -1 : 1);
        },
        _getTitleCoords: function() {
            var horizontal = this._isHorizontal;
            var x = this._axisPosition;
            var y = this._axisPosition;
            var align = this._options.title.alignment;
            var canvas = this._getCanvasStartEnd();
            var fromStartToEnd = horizontal || this._options.position === $d64a485686c19c75$var$LEFT;
            var canvasStart = fromStartToEnd ? canvas.start : canvas.end;
            var canvasEnd = fromStartToEnd ? canvas.end : canvas.start;
            var coord = align === $d64a485686c19c75$var$LEFT ? canvasStart : align === $d64a485686c19c75$var$RIGHT ? canvasEnd : canvas.start + (canvas.end - canvas.start) / 2;
            if (horizontal) x = coord;
            else y = coord;
            return {
                x: x,
                y: y
            };
        },
        _drawTitleText: function(group, coords) {
            var options = this._options;
            var titleOptions = options.title;
            var attrs = {
                opacity: titleOptions.opacity,
                align: titleOptions.alignment,
                class: titleOptions.cssClass
            };
            if (!titleOptions.text || !group) return;
            coords = coords || this._getTitleCoords();
            if (!this._isHorizontal) attrs.rotate = options.position === $d64a485686c19c75$var$LEFT ? 270 : 90;
            var text = this._renderer.text(titleOptions.text, coords.x, coords.y).css((0, $dw9tZ.patchFontOptions)(titleOptions.font)).attr(attrs).append(group);
            this._checkTitleOverflow(text);
            return text;
        },
        _updateTitleCoords: function() {
            this._title && this._title.element.attr(this._getTitleCoords());
        },
        _drawTitle: function() {
            var title = this._drawTitleText(this._axisTitleGroup);
            if (title) this._title = {
                element: title
            };
        },
        _measureTitle: function() {
            if (this._title) {
                if (this._title.bBox && !this._title.originalSize) this._title.originalSize = this._title.bBox;
                this._title.bBox = this._title.element.getBBox();
            }
        },
        _drawDateMarker: function(date, options, range) {
            var markerOptions = this._options.marker;
            var invert = this._translator.getBusinessRange().invert;
            var textIndent = markerOptions.width + markerOptions.textLeftIndent;
            var pathElement;
            if (null === options.x) return;
            if (!options.withoutStick) pathElement = this._renderer.path([
                options.x,
                options.y,
                options.x,
                options.y + markerOptions.separatorHeight
            ], "line").attr({
                "stroke-width": markerOptions.width,
                stroke: markerOptions.color,
                "stroke-opacity": markerOptions.opacity,
                sharp: "h"
            }).append(this._axisElementsGroup);
            var text = String(this.formatLabel(date, options.labelOptions, range));
            return {
                date: date,
                x: options.x,
                y: options.y,
                cropped: options.withoutStick,
                label: this._renderer.text(text, options.x, options.y).css((0, $dw9tZ.patchFontOptions)(markerOptions.label.font)).append(this._axisElementsGroup),
                line: pathElement,
                getContentContainer () {
                    return this.label;
                },
                getEnd: function() {
                    return this.x + (invert ? -1 : 1) * (textIndent + this.labelBBox.width);
                },
                setTitle: function() {
                    this.title = text;
                },
                hideLabel: function() {
                    this.label.dispose();
                    this.label = null;
                    this.title = text;
                },
                hide: function() {
                    if (pathElement) {
                        pathElement.dispose();
                        pathElement = null;
                    }
                    this.label.dispose();
                    this.label = null;
                    this.hidden = true;
                }
            };
        },
        _drawDateMarkers: function() {
            var that = this;
            var options = that._options;
            var translator = that._translator;
            var viewport = that._getViewportRange();
            var minBound = viewport.minVisible;
            var dateMarkers = [];
            var dateMarker;
            function draw(markerDate, format, withoutStick) {
                return that._drawDateMarker(markerDate, {
                    x: translator.translate(markerDate),
                    y: markersAreaTop,
                    labelOptions: that._getLabelFormatOptions(format),
                    withoutStick: withoutStick
                }, viewport);
            }
            if (viewport.isEmpty() || !options.marker.visible || "datetime" !== options.argumentType || "discrete" === options.type || that._majorTicks.length <= 1) return [];
            var markersAreaTop = that._axisPosition + options.marker.topIndent;
            var tickInterval = (0, $f38Z1.default).getDateUnitInterval(this._tickInterval);
            var markerInterval = $d64a485686c19c75$var$getMarkerInterval(tickInterval);
            var markerDates = $d64a485686c19c75$var$getMarkerDates(minBound, viewport.maxVisible, markerInterval);
            if (markerDates.length > 1 || 1 === markerDates.length && minBound < markerDates[0]) {
                dateMarkers = markerDates.reduce(function(markers, curDate, i, dates) {
                    var marker = draw(curDate, $d64a485686c19c75$var$getMarkerFormat(curDate, dates[i - 1] || minBound < curDate && minBound, tickInterval, markerInterval));
                    marker && markers.push(marker);
                    return markers;
                }, []);
                if (minBound < markerDates[0]) {
                    dateMarker = draw(minBound, $d64a485686c19c75$var$getMarkerFormat(minBound, markerDates[0], tickInterval, markerInterval), true);
                    dateMarker && dateMarkers.unshift(dateMarker);
                }
            }
            return dateMarkers;
        },
        _adjustDateMarkers: function(offset) {
            offset = offset || 0;
            var that = this;
            var markerOptions = this._options.marker;
            var textIndent = markerOptions.width + markerOptions.textLeftIndent;
            var invert = this._translator.getBusinessRange().invert;
            var canvas = that._getCanvasStartEnd();
            var dateMarkers = this._dateMarkers;
            if (!dateMarkers.length) return offset;
            if (dateMarkers[0].cropped) {
                if (!this._checkMarkersPosition(invert, dateMarkers[1], dateMarkers[0])) dateMarkers[0].hideLabel();
            }
            var prevDateMarker;
            dateMarkers.forEach(function(marker, i, markers) {
                if (marker.cropped) return;
                if (invert ? marker.getEnd() < canvas.end : marker.getEnd() > canvas.end) marker.hideLabel();
                else if (that._checkMarkersPosition(invert, marker, prevDateMarker)) prevDateMarker = marker;
                else marker.hide();
            });
            this._dateMarkers.forEach(function(marker) {
                if (marker.label) {
                    var labelBBox = marker.labelBBox;
                    var dy = marker.y + markerOptions.textTopIndent - labelBBox.y;
                    marker.label.attr({
                        translateX: invert ? marker.x - textIndent - labelBBox.x - labelBBox.width : marker.x + textIndent - labelBBox.x,
                        translateY: dy + offset
                    });
                }
                if (marker.line) marker.line.attr({
                    translateY: offset
                });
            });
            that._initializeMarkersTrackers(offset);
            return offset + markerOptions.topIndent + markerOptions.separatorHeight;
        },
        _checkMarkersPosition: function(invert, dateMarker, prevDateMarker) {
            if (void 0 === prevDateMarker) return true;
            return invert ? dateMarker.x < prevDateMarker.getEnd() : dateMarker.x > prevDateMarker.getEnd();
        },
        _initializeMarkersTrackers: function(offset) {
            var separatorHeight = this._options.marker.separatorHeight;
            var renderer = this._renderer;
            var businessRange = this._translator.getBusinessRange();
            var canvas = this._getCanvasStartEnd();
            var group = this._axisElementsGroup;
            this._markerTrackers = this._dateMarkers.filter(function(marker) {
                return !marker.hidden;
            }).map(function(marker, i, markers) {
                var nextMarker = markers[i + 1] || {
                    x: canvas.end,
                    date: businessRange.max
                };
                var x = marker.x;
                var y = marker.y + offset;
                var markerTracker = renderer.path([
                    x,
                    y,
                    x,
                    y + separatorHeight,
                    nextMarker.x,
                    y + separatorHeight,
                    nextMarker.x,
                    y,
                    x,
                    y
                ], "area").attr({
                    "stroke-width": 1,
                    stroke: "grey",
                    fill: "grey",
                    opacity: 1e-4
                }).append(group);
                markerTracker.data("range", {
                    startValue: marker.date,
                    endValue: nextMarker.date
                });
                if (marker.title) markerTracker.setTitle(marker.title);
                return markerTracker;
            });
        },
        _getLabelFormatOptions: function(formatString) {
            var markerLabelOptions = this._markerLabelOptions;
            if (!markerLabelOptions) this._markerLabelOptions = markerLabelOptions = (0, $2oTOp.extend)(true, {}, this._options.marker.label);
            if (!(0, $6ntMu.isDefined)(this._options.marker.label.format)) markerLabelOptions.format = formatString;
            return markerLabelOptions;
        },
        _adjustConstantLineLabels: function(constantLines) {
            var that = this;
            var axisPosition = that._options.position;
            var canvas = that.getCanvas();
            var canvasLeft = canvas.left;
            var canvasRight = canvas.width - canvas.right;
            var canvasTop = canvas.top;
            var canvasBottom = canvas.height - canvas.bottom;
            var verticalCenter = canvasTop + (canvasBottom - canvasTop) / 2;
            var horizontalCenter = canvasLeft + (canvasRight - canvasLeft) / 2;
            var maxLabel = 0;
            constantLines.forEach(function(item) {
                var isHorizontal = that._isHorizontal;
                var linesOptions = item.options;
                var paddingTopBottom = linesOptions.paddingTopBottom;
                var paddingLeftRight = linesOptions.paddingLeftRight;
                var labelOptions = linesOptions.label;
                var labelVerticalAlignment = labelOptions.verticalAlignment;
                var labelHorizontalAlignment = labelOptions.horizontalAlignment;
                var labelIsInside = "inside" === labelOptions.position;
                var label = item.label;
                var box = item.labelBBox;
                var translateX;
                var translateY;
                if (null === label || box.isEmpty) return;
                if (isHorizontal) {
                    if (labelIsInside) {
                        if (labelHorizontalAlignment === $d64a485686c19c75$var$LEFT) translateX = item.coord - paddingLeftRight - box.x - box.width;
                        else translateX = item.coord + paddingLeftRight - box.x;
                        switch(labelVerticalAlignment){
                            case $d64a485686c19c75$var$CENTER:
                                translateY = verticalCenter - box.y - box.height / 2;
                                break;
                            case $d64a485686c19c75$var$BOTTOM:
                                translateY = canvasBottom - paddingTopBottom - box.y - box.height;
                                break;
                            default:
                                translateY = canvasTop + paddingTopBottom - box.y;
                        }
                    } else {
                        if (axisPosition === labelVerticalAlignment) maxLabel = $d64a485686c19c75$var$_max(maxLabel, box.height + paddingTopBottom);
                        translateX = item.coord - box.x - box.width / 2;
                        if (labelVerticalAlignment === $d64a485686c19c75$var$BOTTOM) translateY = canvasBottom + paddingTopBottom - box.y;
                        else translateY = canvasTop - paddingTopBottom - box.y - box.height;
                    }
                } else if (labelIsInside) {
                    if (labelVerticalAlignment === $d64a485686c19c75$var$BOTTOM) translateY = item.coord + paddingTopBottom - box.y;
                    else translateY = item.coord - paddingTopBottom - box.y - box.height;
                    switch(labelHorizontalAlignment){
                        case $d64a485686c19c75$var$CENTER:
                            translateX = horizontalCenter - box.x - box.width / 2;
                            break;
                        case $d64a485686c19c75$var$RIGHT:
                            translateX = canvasRight - paddingLeftRight - box.x - box.width;
                            break;
                        default:
                            translateX = canvasLeft + paddingLeftRight - box.x;
                    }
                } else {
                    if (axisPosition === labelHorizontalAlignment) maxLabel = $d64a485686c19c75$var$_max(maxLabel, box.width + paddingLeftRight);
                    translateY = item.coord - box.y - box.height / 2;
                    if (labelHorizontalAlignment === $d64a485686c19c75$var$RIGHT) translateX = canvasRight + paddingLeftRight - box.x;
                    else translateX = canvasLeft - paddingLeftRight - box.x - box.width;
                }
                label.attr({
                    translateX: translateX,
                    translateY: translateY
                });
            });
            return maxLabel;
        },
        _drawConstantLinesForEstimating: function(constantLines) {
            var that = this;
            var renderer = this._renderer;
            var group = renderer.g();
            constantLines.forEach(function(options) {
                that._drawConstantLineLabelText(options.label.text, 0, 0, options.label, group).attr({
                    align: "center"
                });
            });
            return group.append(renderer.root);
        },
        _estimateLabelHeight: function(bBox, labelOptions) {
            var height = bBox.height;
            var drawingType = labelOptions.drawingType;
            if ("stagger" === this._validateDisplayMode(drawingType) || "stagger" === this._validateOverlappingMode(labelOptions.overlappingBehavior, drawingType)) height = 2 * height + labelOptions.staggeringSpacing;
            if ("rotate" === this._validateDisplayMode(drawingType) || "rotate" === this._validateOverlappingMode(labelOptions.overlappingBehavior, drawingType)) {
                var sinCos = (0, $dw9tZ.getCosAndSin)(labelOptions.rotationAngle);
                height = height * sinCos.cos + bBox.width * sinCos.sin;
            }
            return height && (height + labelOptions.indentFromAxis || 0) || 0;
        },
        estimateMargins: function(canvas) {
            this.updateCanvas(canvas);
            var range = this._getViewportRange();
            var ticksData = this._createTicksAndLabelFormat(range);
            var ticks = ticksData.ticks;
            var tickInterval = ticksData.tickInterval;
            var options = this._options;
            var constantLineOptions = this._outsideConstantLines.filter((l)=>l.labelOptions.visible).map((l)=>l.options);
            var rootElement = this._renderer.root;
            var labelIsVisible = options.label.visible && !range.isEmpty() && ticks.length;
            var labelValue = labelIsVisible && this.formatLabel(ticks[ticks.length - 1], options.label, void 0, void 0, tickInterval, ticks);
            var labelElement = labelIsVisible && this._renderer.text(labelValue, 0, 0).css(this._textFontStyles).attr(this._textOptions).append(rootElement);
            var titleElement = this._drawTitleText(rootElement, {
                x: 0,
                y: 0
            });
            var constantLinesLabelsElement = this._drawConstantLinesForEstimating(constantLineOptions);
            var labelBox = !options.label.template && labelElement && labelElement.getBBox() || {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            };
            var titleBox = titleElement && titleElement.getBBox() || {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            };
            var constantLinesBox = constantLinesLabelsElement.getBBox();
            var titleHeight = titleBox.height ? titleBox.height + options.title.margin : 0;
            var labelHeight = this._estimateLabelHeight(labelBox, options.label);
            var constantLinesHeight = constantLinesBox.height ? constantLinesBox.height + $d64a485686c19c75$var$getMaxConstantLinePadding(constantLineOptions) : 0;
            var height = labelHeight + titleHeight;
            var margins = {
                left: $d64a485686c19c75$var$_max($d64a485686c19c75$var$getLeftMargin(labelBox), $d64a485686c19c75$var$getLeftMargin(constantLinesBox)),
                right: $d64a485686c19c75$var$_max($d64a485686c19c75$var$getRightMargin(labelBox), $d64a485686c19c75$var$getRightMargin(constantLinesBox)),
                top: ("top" === options.position ? height : 0) + $d64a485686c19c75$var$getConstantLineLabelMarginForVerticalAlignment(constantLineOptions, "top", constantLinesHeight),
                bottom: ("top" !== options.position ? height : 0) + $d64a485686c19c75$var$getConstantLineLabelMarginForVerticalAlignment(constantLineOptions, "bottom", constantLinesHeight)
            };
            labelElement && labelElement.remove();
            titleElement && titleElement.remove();
            constantLinesLabelsElement && constantLinesLabelsElement.remove();
            return margins;
        },
        _checkAlignmentConstantLineLabels: function(labelOptions) {
            var position = labelOptions.position;
            var verticalAlignment = (labelOptions.verticalAlignment || "").toLowerCase();
            var horizontalAlignment = (labelOptions.horizontalAlignment || "").toLowerCase();
            if (this._isHorizontal) {
                if ("outside" === position) {
                    verticalAlignment = verticalAlignment === $d64a485686c19c75$var$BOTTOM ? $d64a485686c19c75$var$BOTTOM : $d64a485686c19c75$var$TOP;
                    horizontalAlignment = $d64a485686c19c75$var$CENTER;
                } else {
                    verticalAlignment = verticalAlignment === $d64a485686c19c75$var$CENTER ? $d64a485686c19c75$var$CENTER : verticalAlignment === $d64a485686c19c75$var$BOTTOM ? $d64a485686c19c75$var$BOTTOM : $d64a485686c19c75$var$TOP;
                    horizontalAlignment = horizontalAlignment === $d64a485686c19c75$var$LEFT ? $d64a485686c19c75$var$LEFT : $d64a485686c19c75$var$RIGHT;
                }
            } else if ("outside" === position) {
                verticalAlignment = $d64a485686c19c75$var$CENTER;
                horizontalAlignment = horizontalAlignment === $d64a485686c19c75$var$LEFT ? $d64a485686c19c75$var$LEFT : $d64a485686c19c75$var$RIGHT;
            } else {
                verticalAlignment = verticalAlignment === $d64a485686c19c75$var$BOTTOM ? $d64a485686c19c75$var$BOTTOM : $d64a485686c19c75$var$TOP;
                horizontalAlignment = horizontalAlignment === $d64a485686c19c75$var$RIGHT ? $d64a485686c19c75$var$RIGHT : horizontalAlignment === $d64a485686c19c75$var$CENTER ? $d64a485686c19c75$var$CENTER : $d64a485686c19c75$var$LEFT;
            }
            labelOptions.verticalAlignment = verticalAlignment;
            labelOptions.horizontalAlignment = horizontalAlignment;
        },
        _getConstantLineLabelsCoords: function(value, lineLabelOptions) {
            var x = value;
            var y = value;
            if (this._isHorizontal) y = this._orthogonalPositions["top" === lineLabelOptions.verticalAlignment ? "start" : "end"];
            else x = this._orthogonalPositions["right" === lineLabelOptions.horizontalAlignment ? "end" : "start"];
            return {
                x: x,
                y: y
            };
        },
        _getAdjustedStripLabelCoords: function(strip) {
            var stripOptions = strip.options;
            var paddingTopBottom = stripOptions.paddingTopBottom;
            var paddingLeftRight = stripOptions.paddingLeftRight;
            var horizontalAlignment = stripOptions.label.horizontalAlignment;
            var verticalAlignment = stripOptions.label.verticalAlignment;
            var box = strip.labelBBox;
            var labelHeight = box.height;
            var labelWidth = box.width;
            var labelCoords = strip.labelCoords;
            var y = labelCoords.y - box.y;
            var x = labelCoords.x - box.x;
            if (verticalAlignment === $d64a485686c19c75$var$TOP) y += paddingTopBottom;
            else if (verticalAlignment === $d64a485686c19c75$var$CENTER) y -= labelHeight / 2;
            else if (verticalAlignment === $d64a485686c19c75$var$BOTTOM) y -= paddingTopBottom + labelHeight;
            if (horizontalAlignment === $d64a485686c19c75$var$LEFT) x += paddingLeftRight;
            else if (horizontalAlignment === $d64a485686c19c75$var$CENTER) x -= labelWidth / 2;
            else if (horizontalAlignment === $d64a485686c19c75$var$RIGHT) x -= paddingLeftRight + labelWidth;
            return {
                translateX: x,
                translateY: y
            };
        },
        _adjustTitle: function(offset) {
            offset = offset || 0;
            if (!this._title) return;
            var options = this._options;
            var position = options.position;
            var margin = options.title.margin;
            var title = this._title;
            var boxTitle = title.bBox;
            var x = boxTitle.x;
            var y = boxTitle.y;
            var width = boxTitle.width;
            var height = boxTitle.height;
            var axisPosition = this._axisPosition;
            var loCoord = axisPosition - margin - offset;
            var hiCoord = axisPosition + margin + offset;
            var params = {};
            if (this._isHorizontal) {
                if (position === $d64a485686c19c75$var$TOP) params.translateY = loCoord - (y + height);
                else params.translateY = hiCoord - y;
            } else if (position === $d64a485686c19c75$var$LEFT) params.translateX = loCoord - (x + width);
            else params.translateX = hiCoord - x;
            title.element.attr(params);
        },
        _checkTitleOverflow: function(titleElement) {
            if (!this._title && !titleElement) return;
            var canvasLength = this._getScreenDelta();
            var title = titleElement ? {
                bBox: titleElement.getBBox(),
                element: titleElement
            } : this._title;
            var titleOptions = this._options.title;
            var boxTitle = title.bBox;
            if ((this._isHorizontal ? boxTitle.width : boxTitle.height) > canvasLength) {
                title.element.setMaxSize(canvasLength, void 0, {
                    wordWrap: titleOptions.wordWrap || "none",
                    textOverflow: titleOptions.textOverflow || "ellipsis"
                });
                this._wrapped = titleOptions.wordWrap && "none" !== titleOptions.wordWrap;
            } else {
                var moreThanOriginalSize = title.originalSize && canvasLength > (this._isHorizontal ? title.originalSize.width : title.originalSize.height);
                !this._wrapped && moreThanOriginalSize && title.element.restoreText();
            }
        },
        coordsIn: function(x, y) {
            var canvas = this.getCanvas();
            var isHorizontal = this._options.isHorizontal;
            var position = this._options.position;
            var coord = isHorizontal ? y : x;
            if (isHorizontal && (x < canvas.left || x > canvas.width - canvas.right) || !isHorizontal && (y < canvas.top || y > canvas.height - canvas.bottom)) return false;
            if (isHorizontal && position === (0, $aELZT.default).top || !isHorizontal && position === (0, $aELZT.default).left) return coord < canvas[position];
            return coord > canvas[isHorizontal ? "height" : "width"] - canvas[position];
        },
        _boundaryTicksVisibility: {
            min: true,
            max: true
        },
        adjust () {
            var seriesData = this._seriesData;
            var viewport = this._series.filter((s)=>s.isVisible()).reduce((range, s)=>{
                var seriesRange = s.getViewport();
                range.min = (0, $6ntMu.isDefined)(seriesRange.min) ? range.min < seriesRange.min ? range.min : seriesRange.min : range.min;
                range.max = (0, $6ntMu.isDefined)(seriesRange.max) ? range.max > seriesRange.max ? range.max : seriesRange.max : range.max;
                if (s.showZero) {
                    range = new (0, $4jhWa.Range)(range);
                    range.correctValueZeroLevel();
                }
                return range;
            }, {});
            if ((0, $6ntMu.isDefined)(viewport.min) && (0, $6ntMu.isDefined)(viewport.max)) {
                seriesData.minVisible = viewport.min;
                seriesData.maxVisible = viewport.max;
            }
            seriesData.userBreaks = this._getScaleBreaks(this._options, {
                minVisible: seriesData.minVisible,
                maxVisible: seriesData.maxVisible
            }, this._series, this.isArgumentAxis);
            this._translator.updateBusinessRange(this._getViewportRange());
        },
        hasWrap () {
            return this._wrapped;
        },
        getAxisPosition () {
            return this._axisPosition;
        },
        _getStick: function() {
            return !this._options.valueMarginsEnabled;
        },
        _getStripLabelCoords: function(from, to, stripLabelOptions) {
            var orthogonalPositions = this._orthogonalPositions;
            var isHorizontal = this._isHorizontal;
            var horizontalAlignment = stripLabelOptions.horizontalAlignment;
            var verticalAlignment = stripLabelOptions.verticalAlignment;
            var x;
            var y;
            if (isHorizontal) {
                if (horizontalAlignment === $d64a485686c19c75$var$CENTER) x = from + (to - from) / 2;
                else if (horizontalAlignment === $d64a485686c19c75$var$LEFT) x = from;
                else if (horizontalAlignment === $d64a485686c19c75$var$RIGHT) x = to;
                y = orthogonalPositions[$d64a485686c19c75$var$getStripVerticalAlignmentPosition(verticalAlignment)];
            } else {
                x = orthogonalPositions[$d64a485686c19c75$var$getStripHorizontalAlignmentPosition(horizontalAlignment)];
                if (verticalAlignment === $d64a485686c19c75$var$TOP) y = from;
                else if (verticalAlignment === $d64a485686c19c75$var$CENTER) y = to + (from - to) / 2;
                else if (verticalAlignment === $d64a485686c19c75$var$BOTTOM) y = to;
            }
            return {
                x: x,
                y: y
            };
        },
        _getTranslatedValue: function(value, offset) {
            var pos1 = this._translator.translate(value, offset, "semidiscrete" === this._options.type && this._options.tickInterval);
            var pos2 = this._axisPosition;
            var isHorizontal = this._isHorizontal;
            return {
                x: isHorizontal ? pos1 : pos2,
                y: isHorizontal ? pos2 : pos1
            };
        },
        areCoordsOutsideAxis: function(coords) {
            var coord = this._isHorizontal ? coords.x : coords.y;
            var visibleArea = this.getVisibleArea();
            if (coord < visibleArea[0] || coord > visibleArea[1]) return true;
            return false;
        },
        _getSkippedCategory: function(ticks) {
            var skippedCategory;
            if (this._options.type === (0, $aELZT.default).discrete && this._tickOffset && 0 !== ticks.length) skippedCategory = ticks[ticks.length - 1];
            return skippedCategory;
        },
        _filterBreaks: function(breaks, viewport, breakStyle) {
            var minVisible = viewport.minVisible;
            var maxVisible = viewport.maxVisible;
            var breakSize = breakStyle ? breakStyle.width : 0;
            return breaks.reduce(function(result, currentBreak) {
                var from = currentBreak.from;
                var to = currentBreak.to;
                var lastResult = result[result.length - 1];
                var newBreak;
                if (!(0, $6ntMu.isDefined)(from) || !(0, $6ntMu.isDefined)(to)) return result;
                if (from > to) to = [
                    from,
                    from = to
                ][0];
                if (result.length && from < lastResult.to) {
                    if (to > lastResult.to) {
                        lastResult.to = to > maxVisible ? maxVisible : to;
                        if (lastResult.gapSize) {
                            lastResult.gapSize = void 0;
                            lastResult.cumulativeWidth += breakSize;
                        }
                    }
                } else if (from >= minVisible && from < maxVisible || to <= maxVisible && to > minVisible) {
                    from = from >= minVisible ? from : minVisible;
                    to = to <= maxVisible ? to : maxVisible;
                    if (to - from < maxVisible - minVisible) {
                        var _lastResult$cumulativ;
                        newBreak = {
                            from: from,
                            to: to,
                            cumulativeWidth: (null !== (_lastResult$cumulativ = null === lastResult || void 0 === lastResult ? void 0 : lastResult.cumulativeWidth) && void 0 !== _lastResult$cumulativ ? _lastResult$cumulativ : 0) + breakSize
                        };
                        if (currentBreak.gapSize) {
                            var _lastResult$cumulativ2;
                            newBreak.gapSize = (0, $f38Z1.default).convertMillisecondsToDateUnits(to - from);
                            newBreak.cumulativeWidth = null !== (_lastResult$cumulativ2 = null === lastResult || void 0 === lastResult ? void 0 : lastResult.cumulativeWidth) && void 0 !== _lastResult$cumulativ2 ? _lastResult$cumulativ2 : 0;
                        }
                        result.push(newBreak);
                    }
                }
                return result;
            }, []);
        },
        _getScaleBreaks: function(axisOptions, viewport, series, isArgumentAxis) {
            var that = this;
            var breaks = (axisOptions.breaks || []).map(function(b) {
                return {
                    from: that.parser(b.startValue),
                    to: that.parser(b.endValue)
                };
            });
            if ("discrete" !== axisOptions.type && "datetime" === axisOptions.dataType && axisOptions.workdaysOnly) breaks = breaks.concat((0, $gPVzX.generateDateBreaks)(viewport.minVisible, viewport.maxVisible, axisOptions.workWeek, axisOptions.singleWorkdays, axisOptions.holidays));
            if (!isArgumentAxis && "discrete" !== axisOptions.type && "datetime" !== axisOptions.dataType && axisOptions.autoBreaksEnabled && 0 !== axisOptions.maxAutoBreakCount) breaks = breaks.concat($d64a485686c19c75$var$generateAutoBreaks(axisOptions, series, viewport));
            return $d64a485686c19c75$var$sortingBreaks(breaks);
        },
        _drawBreak: function(translatedEnd, positionFrom, positionTo, width, options, group) {
            var breakStart = translatedEnd - (!this._translator.isInverted() ? width + 1 : 0);
            var attr = {
                "stroke-width": 1,
                stroke: options.borderColor,
                sharp: !options.isWaved ? options.isHorizontal ? "h" : "v" : void 0
            };
            var spaceAttr = {
                stroke: options.color,
                "stroke-width": width
            };
            var getPoints = this._isHorizontal ? $d64a485686c19c75$var$rotateLine : function(p) {
                return p;
            };
            var drawer = $d64a485686c19c75$var$getLineDrawer(this._renderer, group, getPoints, positionFrom, breakStart, positionTo, options.isWaved);
            drawer(width / 2, spaceAttr);
            drawer(0, attr);
            drawer(width, attr);
        },
        _createBreakClipRect: function(from, to) {
            var canvas = this._canvas;
            var clipWidth = to - from;
            var clipRect;
            if (this._isHorizontal) clipRect = this._renderer.clipRect(canvas.left, from, canvas.width, clipWidth);
            else clipRect = this._renderer.clipRect(from, canvas.top, clipWidth, canvas.height);
            this._breaksElements = this._breaksElements || [];
            this._breaksElements.push(clipRect);
            return clipRect.id;
        },
        _createBreaksGroup: function(clipFrom, clipTo) {
            var group = this._renderer.g().attr({
                class: this._axisCssPrefix + "breaks",
                "clip-path": this._createBreakClipRect(clipFrom, clipTo)
            }).append(this._scaleBreaksGroup);
            this._breaksElements = this._breaksElements || [];
            this._breaksElements.push(group);
            return group;
        },
        _disposeBreaksGroup: function() {
            (this._breaksElements || []).forEach(function(clipRect) {
                clipRect.dispose();
            });
            this._breaksElements = null;
        },
        drawScaleBreaks: function(customCanvas) {
            var that = this;
            var options = that._options;
            var breakStyle = options.breakStyle;
            var position = options.position;
            var positionFrom;
            var positionTo;
            var breaks = that._translator.getBusinessRange().breaks || [];
            var additionGroup;
            var additionBreakFrom;
            var additionBreakTo;
            that._disposeBreaksGroup();
            if (!(breaks && breaks.length)) return;
            var breakOptions = {
                color: that._options.containerColor,
                borderColor: breakStyle.color,
                isHorizontal: that._isHorizontal,
                isWaved: "straight" !== breakStyle.line.toLowerCase()
            };
            if (customCanvas) {
                positionFrom = customCanvas.start;
                positionTo = customCanvas.end;
            } else {
                positionFrom = that._orthogonalPositions.start - (options.visible && !that._axisShift && (position === $d64a485686c19c75$var$LEFT || position === $d64a485686c19c75$var$TOP) ? $d64a485686c19c75$var$SCALE_BREAK_OFFSET : 0);
                positionTo = that._orthogonalPositions.end + (options.visible && (position === $d64a485686c19c75$var$RIGHT || position === $d64a485686c19c75$var$BOTTOM) ? $d64a485686c19c75$var$SCALE_BREAK_OFFSET : 0);
            }
            var mainGroup = that._createBreaksGroup(positionFrom, positionTo);
            if (that._axisShift && options.visible) {
                additionBreakFrom = that._axisPosition - that._axisShift - $d64a485686c19c75$var$SCALE_BREAK_OFFSET;
                additionBreakTo = additionBreakFrom + 2 * $d64a485686c19c75$var$SCALE_BREAK_OFFSET;
                additionGroup = that._createBreaksGroup(additionBreakFrom, additionBreakTo);
            }
            breaks.forEach(function(br) {
                if (!br.gapSize) {
                    var breakCoord = that._getTranslatedCoord(br.to);
                    that._drawBreak(breakCoord, positionFrom, positionTo, breakStyle.width, breakOptions, mainGroup);
                    if (that._axisShift && options.visible) that._drawBreak(breakCoord, additionBreakFrom, additionBreakTo, breakStyle.width, breakOptions, additionGroup);
                }
            });
        },
        _getSpiderCategoryOption: (0, $gcp4g.noop),
        shift: function(margins) {
            var options = this._options;
            var isHorizontal = options.isHorizontal;
            var axesSpacing = this.getMultipleAxesSpacing();
            var constantLinesGroups = this._axisConstantLineGroups;
            function shiftGroup(side, group) {
                var attr = {
                    translateX: 0,
                    translateY: 0
                };
                var shift = margins[side] ? margins[side] + axesSpacing : 0;
                attr[isHorizontal ? "translateY" : "translateX"] = (side === $d64a485686c19c75$var$LEFT || side === $d64a485686c19c75$var$TOP ? -1 : 1) * shift;
                (group[side] || group).attr(attr);
                return shift;
            }
            this._axisShift = shiftGroup(options.position, this._axisGroup);
            shiftGroup(options.position, this._axisElementsGroup);
            (isHorizontal ? [
                $d64a485686c19c75$var$TOP,
                $d64a485686c19c75$var$BOTTOM
            ] : [
                $d64a485686c19c75$var$LEFT,
                $d64a485686c19c75$var$RIGHT
            ]).forEach((side)=>{
                shiftGroup(side, constantLinesGroups.above);
                shiftGroup(side, constantLinesGroups.under);
            });
        },
        getCustomPosition (position) {
            var orthogonalAxis = this.getOrthogonalAxis();
            var resolvedPosition = null !== position && void 0 !== position ? position : this.getResolvedPositionOption();
            var offset = this.getOptions().offset;
            var orthogonalTranslator = orthogonalAxis.getTranslator();
            var orthogonalAxisType = orthogonalAxis.getOptions().type;
            var validPosition = orthogonalAxis.validateUnit(resolvedPosition);
            var currentPosition;
            if ("discrete" === orthogonalAxisType && (!orthogonalTranslator._categories || orthogonalTranslator._categories.indexOf(validPosition) < 0)) validPosition = void 0;
            if (this.positionIsBoundary(resolvedPosition)) currentPosition = this.getPredefinedPosition(resolvedPosition);
            else if (!(0, $6ntMu.isDefined)(validPosition)) currentPosition = this.getPredefinedPosition(this.getOptions().position);
            else currentPosition = orthogonalTranslator.to(validPosition, -1);
            if (isFinite(currentPosition) && isFinite(offset)) currentPosition += offset;
            return currentPosition;
        },
        getCustomBoundaryPosition (position) {
            var { customPosition: customPosition, offset: offset } = this.getOptions();
            var resolvedPosition = null !== position && void 0 !== position ? position : this.getResolvedPositionOption();
            var orthogonalAxis = this.getOrthogonalAxis();
            var orthogonalTranslator = orthogonalAxis.getTranslator();
            var visibleArea = orthogonalTranslator.getCanvasVisibleArea();
            if (!(0, $6ntMu.isDefined)(orthogonalAxis._orthogonalPositions) || 0 === orthogonalTranslator.canvasLength) return;
            var currentPosition = this.getCustomPosition(resolvedPosition);
            if (!(0, $6ntMu.isDefined)(currentPosition)) return this.getResolvedBoundaryPosition();
            else if ((0, $6ntMu.isDefined)(customPosition)) {
                if (currentPosition <= visibleArea.min) return this._isHorizontal ? $d64a485686c19c75$var$TOP : $d64a485686c19c75$var$LEFT;
                else if (currentPosition >= visibleArea.max) return this._isHorizontal ? $d64a485686c19c75$var$BOTTOM : $d64a485686c19c75$var$RIGHT;
            } else if ((0, $6ntMu.isDefined)(offset)) {
                if (currentPosition <= this._orthogonalPositions.start) return this._isHorizontal ? $d64a485686c19c75$var$TOP : $d64a485686c19c75$var$LEFT;
                else if (currentPosition >= this._orthogonalPositions.end) return this._isHorizontal ? $d64a485686c19c75$var$BOTTOM : $d64a485686c19c75$var$RIGHT;
            }
            return currentPosition;
        },
        getResolvedPositionOption () {
            var _options$customPositi;
            var options = this.getOptions();
            return null !== (_options$customPositi = options.customPosition) && void 0 !== _options$customPositi ? _options$customPositi : options.position;
        },
        customPositionIsAvailable () {
            var options = this.getOptions();
            return (0, $6ntMu.isDefined)(this.getOrthogonalAxis()) && ((0, $6ntMu.isDefined)(options.customPosition) || isFinite(options.offset));
        },
        hasNonBoundaryPosition () {
            return this.customPositionIsAvailable() && !this.customPositionIsBoundary();
        },
        getResolvedBoundaryPosition () {
            return this.customPositionIsBoundary() ? this._customBoundaryPosition : this.getOptions().position;
        },
        customPositionEqualsToPredefined () {
            return this.customPositionIsBoundary() && this._customBoundaryPosition === this.getOptions().position;
        },
        customPositionIsBoundary () {
            return this.positionIsBoundary(this._customBoundaryPosition);
        },
        positionIsBoundary: (position)=>[
                $d64a485686c19c75$var$TOP,
                $d64a485686c19c75$var$LEFT,
                $d64a485686c19c75$var$BOTTOM,
                $d64a485686c19c75$var$RIGHT
            ].indexOf(position) >= 0,
        getPredefinedPosition (position) {
            var _this$_orthogonalPosi;
            return null === (_this$_orthogonalPosi = this._orthogonalPositions) || void 0 === _this$_orthogonalPosi ? void 0 : _this$_orthogonalPosi[position === $d64a485686c19c75$var$TOP || position === $d64a485686c19c75$var$LEFT ? "start" : "end"];
        },
        resolveOverlappingForCustomPositioning (oppositeAxes) {
            var that = this;
            if (!that.hasNonBoundaryPosition() && !that.customPositionIsBoundary() && !oppositeAxes.some((a)=>a.hasNonBoundaryPosition())) return;
            var overlappingObj = {
                axes: [],
                ticks: []
            };
            oppositeAxes.filter((orthogonalAxis)=>orthogonalAxis.pane === that.pane).forEach((orthogonalAxis)=>{
                for(var i = 0; i < that._majorTicks.length; i++){
                    var tick = that._majorTicks[i];
                    var label = tick.label;
                    if (label) {
                        if (overlappingObj.axes.indexOf(orthogonalAxis) < 0 && that._detectElementsOverlapping(label, orthogonalAxis._axisElement)) {
                            overlappingObj.axes.push(orthogonalAxis);
                            that._shiftThroughOrthogonalAxisOverlappedTick(label, orthogonalAxis);
                        }
                        for(var j = 0; j < orthogonalAxis._majorTicks.length; j++){
                            var oppositeTick = orthogonalAxis._majorTicks[j];
                            var oppositeLabel = oppositeTick.label;
                            if (oppositeLabel && that._detectElementsOverlapping(label, oppositeLabel)) {
                                overlappingObj.ticks.push(tick);
                                that._shiftThroughAxisOverlappedTick(tick);
                                i = that._majorTicks.length;
                                break;
                            }
                        }
                    }
                    if (tick.mark && overlappingObj.ticks.indexOf(tick) < 0) {
                        if (that._isHorizontal && tick.mark.attr("translateY")) tick.mark.attr({
                            translateY: 0
                        });
                        else if (!that._isHorizontal && tick.mark.attr("translateX")) tick.mark.attr({
                            translateX: 0
                        });
                    }
                }
            });
        },
        _shiftThroughOrthogonalAxisOverlappedTick (label, orthogonalAxis) {
            var labelBBox = label.getBBox();
            var orthogonalAxisPosition = orthogonalAxis.getAxisPosition();
            var orthogonalAxisLabelOptions = orthogonalAxis.getOptions().label;
            var orthogonalAxisLabelPosition = orthogonalAxisLabelOptions.position;
            var orthogonalAxisLabelIndent = orthogonalAxisLabelOptions.indentFromAxis / 2;
            var translateCoordName = this._isHorizontal ? "translateX" : "translateY";
            var defaultOrthogonalAxisLabelPosition = this._isHorizontal ? $d64a485686c19c75$var$LEFT : $d64a485686c19c75$var$TOP;
            var translate = label.attr(translateCoordName);
            var labelCoord = (this._isHorizontal ? labelBBox.x : labelBBox.y) + translate;
            var labelSize = this._isHorizontal ? labelBBox.width : labelBBox.height;
            var outsidePart = orthogonalAxisPosition - labelCoord;
            var insidePart = labelCoord + labelSize - orthogonalAxisPosition;
            var attr = {};
            attr[translateCoordName] = translate;
            if (outsidePart > 0 && insidePart > 0) {
                if (insidePart - outsidePart > 1) attr[translateCoordName] += outsidePart + orthogonalAxisLabelIndent;
                else if (outsidePart - insidePart > 1) attr[translateCoordName] -= insidePart + orthogonalAxisLabelIndent;
                else attr[translateCoordName] += orthogonalAxisLabelPosition === defaultOrthogonalAxisLabelPosition ? outsidePart + orthogonalAxisLabelIndent : -(insidePart + orthogonalAxisLabelIndent);
                label.attr(attr);
            }
        },
        _shiftThroughAxisOverlappedTick (tick) {
            var _tick$mark;
            var label = tick.label;
            if (!label) return;
            var labelBBox = label.getBBox();
            var tickMarkBBox = null === (_tick$mark = tick.mark) || void 0 === _tick$mark ? void 0 : _tick$mark.getBBox();
            var axisPosition = this.getAxisPosition();
            var labelOptions = this.getOptions().label;
            var labelIndent = labelOptions.indentFromAxis;
            var labelPosition = labelOptions.position;
            var defaultLabelPosition = this._isHorizontal ? $d64a485686c19c75$var$TOP : $d64a485686c19c75$var$LEFT;
            var translateCoordName = this._isHorizontal ? "translateY" : "translateX";
            var translate = label.attr(translateCoordName);
            var labelCoord = (this._isHorizontal ? labelBBox.y : labelBBox.x) + translate;
            var labelSize = this._isHorizontal ? labelBBox.height : labelBBox.width;
            var attr = {};
            attr[translateCoordName] = translate + (labelPosition === defaultLabelPosition ? axisPosition - labelCoord + labelIndent : -(labelCoord - axisPosition + labelSize + labelIndent));
            label.attr(attr);
            if (tick.mark) {
                var markerSize = this._isHorizontal ? tickMarkBBox.height : tickMarkBBox.width;
                var dir = labelPosition === defaultLabelPosition ? 1 : -1;
                attr[translateCoordName] = dir * (markerSize - 1);
                tick.mark.attr(attr);
            }
        },
        _detectElementsOverlapping (element1, element2) {
            if (!element1 || !element2) return false;
            var bBox1 = element1.getBBox();
            var x1 = bBox1.x + element1.attr("translateX");
            var y1 = bBox1.y + element1.attr("translateY");
            var bBox2 = element2.getBBox();
            var x2 = bBox2.x + element2.attr("translateX");
            var y2 = bBox2.y + element2.attr("translateY");
            return (x2 >= x1 && x2 <= x1 + bBox1.width || x1 >= x2 && x1 <= x2 + bBox2.width) && (y2 >= y1 && y2 <= y1 + bBox1.height || y1 >= y2 && y1 <= y2 + bBox2.height);
        }
    }
};
function $d64a485686c19c75$var$getLineDrawer(renderer, root, rotatePoints, positionFrom, breakStart, positionTo, isWaved) {
    var elementType = isWaved ? "bezier" : "line";
    var group = renderer.g().append(root);
    return function(offset, attr) {
        renderer.path(rotatePoints($d64a485686c19c75$var$getPoints(positionFrom, breakStart, positionTo, offset, isWaved)), elementType).attr(attr).append(group);
    };
}
function $d64a485686c19c75$var$getPoints(positionFrom, breakStart, positionTo, offset, isWaved) {
    if (!isWaved) return [
        positionFrom,
        breakStart + offset,
        positionTo,
        breakStart + offset
    ];
    breakStart += offset;
    var currentPosition;
    var topPoint = breakStart + $d64a485686c19c75$var$WAVED_LINE_TOP;
    var centerPoint = breakStart + $d64a485686c19c75$var$WAVED_LINE_CENTER;
    var bottomPoint = breakStart + $d64a485686c19c75$var$WAVED_LINE_BOTTOM;
    var points = [
        [
            positionFrom,
            centerPoint
        ]
    ];
    for(currentPosition = positionFrom; currentPosition < positionTo + $d64a485686c19c75$var$WAVED_LINE_LENGTH; currentPosition += $d64a485686c19c75$var$WAVED_LINE_LENGTH)points.push([
        currentPosition + 6,
        topPoint,
        currentPosition + 6,
        topPoint,
        currentPosition + 12,
        centerPoint,
        currentPosition + 18,
        bottomPoint,
        currentPosition + 18,
        bottomPoint,
        currentPosition + 24,
        centerPoint
    ]);
    return [].concat.apply([], points);
}
function $d64a485686c19c75$var$rotateLine(lineCoords) {
    var points = [];
    var i;
    for(i = 0; i < lineCoords.length; i += 2){
        points.push(lineCoords[i + 1]);
        points.push(lineCoords[i]);
    }
    return points;
}

});
parcelRegister("gPVzX", function(module, exports) {

$parcel$export(module.exports, "generateDateBreaks", function () { return $c41e12bdc5139f8f$export$972825aaf3017def; });
/**
 * DevExtreme (esm/viz/axes/datetime_breaks.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $f38Z1 = parcelRequire("f38Z1");
var $c41e12bdc5139f8f$var$days = [
    0,
    1,
    2,
    3,
    4,
    5,
    6
];
function $c41e12bdc5139f8f$var$getWeekendDays(workdays) {
    return $c41e12bdc5139f8f$var$days.filter(function(day) {
        return !workdays.some(function(workDay) {
            return workDay === day;
        });
    });
}
function $c41e12bdc5139f8f$var$getNextDayIndex(dayIndex) {
    return (dayIndex + 1) % 7;
}
function $c41e12bdc5139f8f$var$dayBetweenWeekend(weekend, day) {
    var start = weekend.start;
    var end = weekend.end;
    while(start !== end){
        if (start === day) return true;
        start = $c41e12bdc5139f8f$var$getNextDayIndex(start);
    }
    return false;
}
function $c41e12bdc5139f8f$var$getDaysDistance(day, end) {
    var length = 0;
    while(day !== end){
        day = $c41e12bdc5139f8f$var$getNextDayIndex(day);
        length++;
    }
    return length;
}
function $c41e12bdc5139f8f$var$separateBreak(scaleBreak, day) {
    var result = [];
    var dayEnd = new Date(day);
    dayEnd.setDate(day.getDate() + 1);
    if (day > scaleBreak.from) result.push({
        from: scaleBreak.from,
        to: day
    });
    if (dayEnd < scaleBreak.to) result.push({
        from: dayEnd,
        to: scaleBreak.to
    });
    return result;
}
function $c41e12bdc5139f8f$var$getWeekEndDayIndices(workDays) {
    var indices = $c41e12bdc5139f8f$var$getWeekendDays(workDays);
    if (indices.length < 7) while($c41e12bdc5139f8f$var$getNextDayIndex(indices[indices.length - 1]) === indices[0])indices.unshift(indices.pop());
    return indices;
}
function $c41e12bdc5139f8f$var$generateDateBreaksForWeekend(min, max, weekendDayIndices) {
    var day = min.getDate();
    var breaks = [];
    var weekends = weekendDayIndices.reduce(function(obj, day) {
        var currentWeekEnd = obj[1];
        if (void 0 === currentWeekEnd.start) {
            currentWeekEnd = {
                start: day,
                end: $c41e12bdc5139f8f$var$getNextDayIndex(day)
            };
            obj[0].push(currentWeekEnd);
            return [
                obj[0],
                currentWeekEnd
            ];
        } else if (currentWeekEnd.end === day) {
            currentWeekEnd.end = $c41e12bdc5139f8f$var$getNextDayIndex(day);
            return obj;
        }
        currentWeekEnd = {
            start: day,
            end: $c41e12bdc5139f8f$var$getNextDayIndex(day)
        };
        obj[0].push(currentWeekEnd);
        return [
            obj[0],
            currentWeekEnd
        ];
    }, [
        [],
        {}
    ]);
    weekends[0].forEach(function(weekend) {
        var currentDate = new Date(min);
        currentDate = (0, $f38Z1.default).trimTime(currentDate);
        while(currentDate < max){
            day = currentDate.getDay();
            var date = currentDate.getDate();
            if ($c41e12bdc5139f8f$var$dayBetweenWeekend(weekend, day)) {
                var from = new Date(currentDate);
                currentDate.setDate(date + $c41e12bdc5139f8f$var$getDaysDistance(day, weekend.end));
                var to = new Date(currentDate);
                breaks.push({
                    from: from,
                    to: to
                });
            }
            currentDate.setDate(currentDate.getDate() + 1);
        }
    });
    return breaks;
}
function $c41e12bdc5139f8f$var$excludeWorkDaysFromWeekEndBreaks(breaks, exactWorkDays) {
    var result = breaks.slice();
    var i;
    var processWorkDay = function(workday) {
        workday = (0, $f38Z1.default).trimTime(new Date(workday));
        if (result[i].from <= workday && result[i].to > workday) {
            var separatedBreak = $c41e12bdc5139f8f$var$separateBreak(result[i], workday);
            if (2 === separatedBreak.length) result.splice(i, 1, separatedBreak[0], separatedBreak[1]);
            else if (1 === separatedBreak.length) result.splice(i, 1, separatedBreak[0]);
            else result.splice(i, 1);
        }
    };
    for(i = 0; i < result.length; i++)exactWorkDays.forEach(processWorkDay);
    return result;
}
function $c41e12bdc5139f8f$var$generateBreaksForHolidays(min, max, holidays, weekendDayIndices) {
    var day;
    var dayInWeekend = function(dayIndex) {
        return dayIndex === day;
    };
    var adjustedMin = (0, $f38Z1.default).trimTime(min);
    var adjustedMax = (0, $f38Z1.default).trimTime(max);
    adjustedMax.setDate(max.getDate() + 1);
    return holidays.reduce(function(breaks, holiday) {
        var holidayStart;
        var holidayEnd;
        holiday = new Date(holiday);
        day = holiday.getDay();
        if (!weekendDayIndices.some(dayInWeekend) && holiday >= adjustedMin && holiday <= adjustedMax) {
            holidayStart = (0, $f38Z1.default).trimTime(holiday);
            holidayEnd = new Date(holidayStart);
            holidayEnd.setDate(holidayStart.getDate() + 1);
            breaks.push({
                from: holidayStart,
                to: holidayEnd
            });
        }
        return breaks;
    }, []);
}
function $c41e12bdc5139f8f$var$calculateGaps(breaks) {
    return breaks.map(function(b) {
        return {
            from: b.from,
            to: b.to,
            gapSize: (0, $f38Z1.default).convertMillisecondsToDateUnits(b.to - b.from)
        };
    });
}
function $c41e12bdc5139f8f$export$972825aaf3017def(min, max, workWeek, singleWorkdays, holidays) {
    var weekendDayIndices = $c41e12bdc5139f8f$var$getWeekEndDayIndices(workWeek);
    var breaks = $c41e12bdc5139f8f$var$generateDateBreaksForWeekend(min, max, weekendDayIndices);
    breaks.push.apply(breaks, $c41e12bdc5139f8f$var$generateBreaksForHolidays(min, max, holidays || [], weekendDayIndices));
    return $c41e12bdc5139f8f$var$calculateGaps($c41e12bdc5139f8f$var$excludeWorkDaysFromWeekEndBreaks(breaks, singleWorkdays || []));
}

});


parcelRegister("5nic1", function(module, exports) {

$parcel$export(module.exports, "circular", function () { return $3e9d36790f175719$export$f99d756c6d81ae3f; });
$parcel$export(module.exports, "circularSpider", function () { return $3e9d36790f175719$export$45d9e517b3d4dc58; });
$parcel$export(module.exports, "linear", function () { return $3e9d36790f175719$export$45db2fc2f15997e7; });
$parcel$export(module.exports, "linearSpider", function () { return $3e9d36790f175719$export$b23d8e2f516709d5; });
/**
 * DevExtreme (esm/viz/axes/polar_axes.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $dw9tZ = parcelRequire("dw9tZ");

var $6ntMu = parcelRequire("6ntMu");

var $2oTOp = parcelRequire("2oTOp");

var $aELZT = parcelRequire("aELZT");

var $ioF0U = parcelRequire("ioF0U");

var $a6TS4 = parcelRequire("a6TS4");

var $53BqL = parcelRequire("53BqL");

var $gcp4g = parcelRequire("gcp4g");
var { PI: $3e9d36790f175719$var$PI, abs: $3e9d36790f175719$var$abs, atan: $3e9d36790f175719$var$atan, round: $3e9d36790f175719$var$round } = Math;
var $3e9d36790f175719$var$_min = Math.min;
var $3e9d36790f175719$var$_max = Math.max;
var $3e9d36790f175719$var$xyAxesLinear = (0, $ioF0U.default).linear;
var $3e9d36790f175719$var$HALF_PI_ANGLE = 90;
function $3e9d36790f175719$var$getPolarQuarter(angle) {
    var quarter;
    angle = (0, $dw9tZ.normalizeAngle)(angle);
    if (angle >= 315 && angle <= 360 || angle < 45 && angle >= 0) quarter = 1;
    else if (angle >= 45 && angle < 135) quarter = 2;
    else if (angle >= 135 && angle < 225) quarter = 3;
    else if (angle >= 225 && angle < 315) quarter = 4;
    return quarter;
}
var $3e9d36790f175719$var$circularAxes = {
    _calculateValueMargins (ticks) {
        var { minVisible: minVisible, maxVisible: maxVisible } = this._getViewportRange();
        if (ticks && ticks.length > 1) {
            minVisible = minVisible < ticks[0].value ? minVisible : ticks[0].value;
            maxVisible = minVisible > ticks[ticks.length - 1].value ? maxVisible : ticks[ticks.length - 1].value;
        }
        return {
            minValue: minVisible,
            maxValue: maxVisible
        };
    },
    applyMargins () {
        var margins = this._calculateValueMargins(this._majorTicks);
        var br = this._translator.getBusinessRange();
        br.addRange({
            minVisible: margins.minValue,
            maxVisible: margins.maxValue,
            interval: this._calculateRangeInterval(br.interval)
        });
        this._translator.updateBusinessRange(br);
    },
    _getTranslatorOptions: function() {
        return {
            isHorizontal: true,
            conversionValue: true,
            addSpiderCategory: this._getSpiderCategoryOption(),
            stick: this._getStick()
        };
    },
    getCenter: function() {
        return this._center;
    },
    getRadius: function() {
        return this._radius;
    },
    getAngles: function() {
        var options = this._options;
        return [
            options.startAngle,
            options.endAngle
        ];
    },
    _updateRadius (canvas) {
        var rad = $3e9d36790f175719$var$_min(canvas.width - canvas.left - canvas.right, canvas.height - canvas.top - canvas.bottom) / 2;
        this._radius = rad < 0 ? 0 : rad;
    },
    _updateCenter: function(canvas) {
        this._center = {
            x: canvas.left + (canvas.width - canvas.right - canvas.left) / 2,
            y: canvas.top + (canvas.height - canvas.top - canvas.bottom) / 2
        };
    },
    _processCanvas: function(canvas) {
        this._updateRadius(canvas);
        this._updateCenter(canvas);
        return {
            left: 0,
            right: 0,
            width: this._getScreenDelta()
        };
    },
    _createAxisElement: function() {
        return this._renderer.circle();
    },
    _updateAxisElementPosition: function() {
        var center = this.getCenter();
        this._axisElement.attr({
            cx: center.x,
            cy: center.y,
            r: this.getRadius()
        });
    },
    _boundaryTicksVisibility: {
        min: true
    },
    _getSpiderCategoryOption: function() {
        return this._options.firstPointOnStartAngle;
    },
    _validateOptions (options) {
        var originValue = options.originValue;
        var wholeRange = options.wholeRange = {};
        var period = options.period;
        if ((0, $6ntMu.isDefined)(originValue)) originValue = this.validateUnit(originValue);
        if (period > 0 && options.argumentType === (0, $aELZT.default).numeric) {
            originValue = originValue || 0;
            wholeRange.endValue = originValue + period;
            this._viewport = (0, $dw9tZ.getVizRangeObject)([
                originValue,
                wholeRange.endValue
            ]);
        }
        if ((0, $6ntMu.isDefined)(originValue)) wholeRange.startValue = originValue;
    },
    getMargins () {
        var tickOptions = this._options.tick;
        var tickOuterLength = $3e9d36790f175719$var$_max(tickOptions.visible ? tickOptions.length / 2 + tickOptions.shift : 0, 0);
        var radius = this.getRadius();
        var { x: x, y: y } = this._center;
        var labelBoxes = this._majorTicks.map((t)=>t.label && t.label.getBBox()).filter((b)=>b);
        var canvas = (0, $2oTOp.extend)({}, this._canvas, {
            left: x - radius,
            top: y - radius,
            right: this._canvas.width - (x + radius),
            bottom: this._canvas.height - (y + radius)
        });
        var margins = (0, $53BqL.calculateCanvasMargins)(labelBoxes, canvas);
        Object.keys(margins).forEach((k)=>margins[k] = margins[k] < tickOuterLength ? tickOuterLength : margins[k]);
        return margins;
    },
    _updateLabelsPosition () {
        (0, $53BqL.measureLabels)(this._majorTicks);
        this._adjustLabelsCoord(0, 0, true);
        this._checkBoundedLabelsOverlapping(this._majorTicks, this._majorTicks.map((t)=>t.labelBBox));
    },
    _setVisualRange: (0, $gcp4g.noop),
    applyVisualRangeSetter: (0, $gcp4g.noop),
    _getStick: function() {
        return this._options.firstPointOnStartAngle || this._options.type !== (0, $aELZT.default).discrete;
    },
    _getTranslatedCoord: function(value, offset) {
        return this._translator.translate(value, offset) - $3e9d36790f175719$var$HALF_PI_ANGLE;
    },
    _getCanvasStartEnd: function() {
        return {
            start: 0 - $3e9d36790f175719$var$HALF_PI_ANGLE,
            end: 360 - $3e9d36790f175719$var$HALF_PI_ANGLE
        };
    },
    _getStripGraphicAttributes: function(fromAngle, toAngle) {
        var center = this.getCenter();
        var angle = this.getAngles()[0];
        var r = this.getRadius();
        return {
            x: center.x,
            y: center.y,
            innerRadius: 0,
            outerRadius: r,
            startAngle: -toAngle - angle,
            endAngle: -fromAngle - angle
        };
    },
    _createStrip: function(coords) {
        return this._renderer.arc(coords.x, coords.y, coords.innerRadius, coords.outerRadius, coords.startAngle, coords.endAngle);
    },
    _getStripLabelCoords: function(from, to) {
        var coords = this._getStripGraphicAttributes(from, to);
        var angle = coords.startAngle + (coords.endAngle - coords.startAngle) / 2;
        var cosSin = (0, $dw9tZ.getCosAndSin)(angle);
        var halfRad = this.getRadius() / 2;
        var center = this.getCenter();
        var x = $3e9d36790f175719$var$round(center.x + halfRad * cosSin.cos);
        var y = $3e9d36790f175719$var$round(center.y - halfRad * cosSin.sin);
        return {
            x: x,
            y: y,
            align: (0, $aELZT.default).center
        };
    },
    _getConstantLineGraphicAttributes: function(value) {
        var center = this.getCenter();
        var r = this.getRadius();
        return {
            points: [
                center.x,
                center.y,
                center.x + r,
                center.y
            ]
        };
    },
    _createConstantLine: function(value, attr) {
        return this._createPathElement(this._getConstantLineGraphicAttributes(value).points, attr);
    },
    _rotateConstantLine (line, value) {
        var { x: x, y: y } = this.getCenter();
        line.rotate(value + this.getAngles()[0], x, y);
    },
    _getConstantLineLabelsCoords: function(value) {
        var cosSin = (0, $dw9tZ.getCosAndSin)(-value - this.getAngles()[0]);
        var halfRad = this.getRadius() / 2;
        var center = this.getCenter();
        var x = $3e9d36790f175719$var$round(center.x + halfRad * cosSin.cos);
        var y = $3e9d36790f175719$var$round(center.y - halfRad * cosSin.sin);
        return {
            x: x,
            y: y
        };
    },
    _checkAlignmentConstantLineLabels: (0, $gcp4g.noop),
    _adjustDivisionFactor: function(val) {
        return 180 * val / (this.getRadius() * $3e9d36790f175719$var$PI);
    },
    _getScreenDelta: function() {
        var angles = this.getAngles();
        return $3e9d36790f175719$var$abs(angles[0] - angles[1]);
    },
    _getTickMarkPoints: function(coords, length, _ref) {
        var { shift: shift = 0 } = _ref;
        var center = this.getCenter();
        var radiusWithTicks = this.getRadius() + length * ({
            inside: -1,
            center: -0.5,
            outside: 0
        })[this._options.tickOrientation || "center"];
        return [
            center.x + radiusWithTicks + shift,
            center.y,
            center.x + radiusWithTicks + length + shift,
            center.y
        ];
    },
    _getLabelAdjustedCoord: function(tick, _offset, _maxWidth, checkCanvas) {
        var labelCoords = tick.labelCoords;
        var labelY = labelCoords.y;
        var labelAngle = labelCoords.angle;
        var cosSin = (0, $dw9tZ.getCosAndSin)(labelAngle);
        var cos = cosSin.cos;
        var sin = cosSin.sin;
        var box = tick.labelBBox;
        var halfWidth = box.width / 2;
        var halfHeight = box.height / 2;
        var indentFromAxis = this._options.label.indentFromAxis || 0;
        var x = labelCoords.x + indentFromAxis * cos;
        var y = labelY + (labelY - box.y - halfHeight) + indentFromAxis * sin;
        var shiftX = 0;
        var shiftY = 0;
        switch($3e9d36790f175719$var$getPolarQuarter(labelAngle)){
            case 1:
                shiftX = halfWidth;
                shiftY = halfHeight * sin;
                break;
            case 2:
                shiftX = halfWidth * cos;
                shiftY = halfHeight;
                break;
            case 3:
                shiftX = -halfWidth;
                shiftY = halfHeight * sin;
                break;
            case 4:
                shiftX = halfWidth * cos;
                shiftY = -halfHeight;
        }
        if (checkCanvas) {
            var canvas = this._canvas;
            var boxShiftX = x - labelCoords.x + shiftX;
            var boxShiftY = y - labelCoords.y + shiftY;
            if (box.x + boxShiftX < canvas.originalLeft) shiftX -= box.x + boxShiftX - canvas.originalLeft;
            if (box.x + box.width + boxShiftX > canvas.width - canvas.originalRight) shiftX -= box.x + box.width + boxShiftX - (canvas.width - canvas.originalRight);
            if (box.y + boxShiftY < canvas.originalTop) shiftY -= box.y + boxShiftY - canvas.originalTop;
            if (box.y + box.height + boxShiftY > canvas.height - canvas.originalBottom) shiftY -= box.y + box.height + boxShiftY - (canvas.height - canvas.originalBottom);
        }
        return {
            x: x + shiftX,
            y: y + shiftY
        };
    },
    _getGridLineDrawer: function() {
        var that = this;
        return function(tick, gridStyle) {
            var center = that.getCenter();
            return that._createPathElement(that._getGridPoints().points, gridStyle).rotate(tick.coords.angle, center.x, center.y);
        };
    },
    _getGridPoints: function() {
        var r = this.getRadius();
        var center = this.getCenter();
        return {
            points: [
                center.x,
                center.y,
                center.x + r,
                center.y
            ]
        };
    },
    _getTranslatedValue: function(value, offset) {
        var startAngle = this.getAngles()[0];
        var angle = this._translator.translate(value, -offset);
        var coords = (0, $dw9tZ.convertPolarToXY)(this.getCenter(), startAngle, angle, this.getRadius());
        return {
            x: coords.x,
            y: coords.y,
            angle: this.getTranslatedAngle(angle)
        };
    },
    _getAdjustedStripLabelCoords: function(strip) {
        var box = strip.labelBBox;
        return {
            translateY: strip.label.attr("y") - box.y - box.height / 2
        };
    },
    coordsIn: function(x, y) {
        return (0, $dw9tZ.convertXYToPolar)(this.getCenter(), x, y).r > this.getRadius();
    },
    _rotateTick: function(element, coords) {
        var center = this.getCenter();
        element.rotate(coords.angle, center.x, center.y);
    },
    _validateOverlappingMode: function(mode) {
        return (0, $aELZT.default).validateOverlappingMode(mode);
    },
    _validateDisplayMode: function() {
        return "standard";
    },
    _getStep: function(boxes) {
        var radius = this.getRadius() + (this._options.label.indentFromAxis || 0);
        var maxLabelBox = boxes.reduce(function(prevValue, box) {
            var curValue = prevValue;
            if (prevValue.width < box.width) curValue.width = box.width;
            if (prevValue.height < box.height) curValue.height = box.height;
            return curValue;
        }, {
            width: 0,
            height: 0
        });
        var angle1 = $3e9d36790f175719$var$abs(2 * $3e9d36790f175719$var$atan(maxLabelBox.height / (2 * radius - maxLabelBox.width)) * 180 / $3e9d36790f175719$var$PI);
        var angle2 = $3e9d36790f175719$var$abs(2 * $3e9d36790f175719$var$atan(maxLabelBox.width / (2 * radius - maxLabelBox.height)) * 180 / $3e9d36790f175719$var$PI);
        return (0, $aELZT.default).getTicksCountInRange(this._majorTicks, "angle", $3e9d36790f175719$var$_max(angle1, angle2));
    },
    _checkBoundedLabelsOverlapping: function(majorTicks, boxes, mode) {
        var labelOpt = this._options.label;
        mode = mode || this._validateOverlappingMode(labelOpt.overlappingBehavior);
        if ("hide" !== mode) return;
        var lastVisibleLabelIndex = majorTicks.reduce((lastVisibleLabelIndex, tick, index)=>tick.label ? index : lastVisibleLabelIndex, null);
        if (!lastVisibleLabelIndex) return;
        if ((0, $aELZT.default).areLabelsOverlap(boxes[0], boxes[lastVisibleLabelIndex], labelOpt.minSpacing, (0, $aELZT.default).center)) "first" === labelOpt.hideFirstOrLast ? majorTicks[0].removeLabel() : majorTicks[lastVisibleLabelIndex].removeLabel();
    },
    shift: function(margins) {
        this._axisGroup.attr({
            translateX: margins.right,
            translateY: margins.bottom
        });
        this._axisElementsGroup.attr({
            translateX: margins.right,
            translateY: margins.bottom
        });
    },
    getTranslatedAngle (angle) {
        var startAngle = this.getAngles()[0];
        return angle + startAngle - $3e9d36790f175719$var$HALF_PI_ANGLE;
    }
};
var $3e9d36790f175719$export$f99d756c6d81ae3f = $3e9d36790f175719$var$circularAxes;
var $3e9d36790f175719$export$45d9e517b3d4dc58 = (0, $2oTOp.extend)({}, $3e9d36790f175719$var$circularAxes, {
    _createAxisElement: function() {
        return this._renderer.path([], "area");
    },
    _updateAxisElementPosition: function() {
        this._axisElement.attr({
            points: (0, $dw9tZ.map)(this.getSpiderTicks(), function(tick) {
                return {
                    x: tick.coords.x,
                    y: tick.coords.y
                };
            })
        });
    },
    _getStick: function() {
        return true;
    },
    _getSpiderCategoryOption: function() {
        return true;
    },
    getSpiderTicks: function() {
        var ticks = this.getFullTicks();
        this._spiderTicks = ticks.map((0, $a6TS4.tick)(this, this.renderer, {}, {}, this._getSkippedCategory(ticks), true));
        this._spiderTicks.forEach(function(tick) {
            tick.initCoords();
        });
        return this._spiderTicks;
    },
    _getStripGraphicAttributes: function(fromAngle, toAngle) {
        var center = this.getCenter();
        var spiderTicks = this.getSpiderTicks();
        var firstTick;
        var lastTick;
        var nextTick;
        var tick;
        var points = [];
        var i = 0;
        var len = spiderTicks.length;
        while(i < len){
            tick = spiderTicks[i].coords;
            if (tick.angle >= fromAngle && tick.angle <= toAngle) {
                if (!firstTick) {
                    firstTick = (spiderTicks[i - 1] || spiderTicks[spiderTicks.length - 1]).coords;
                    points.push((tick.x + firstTick.x) / 2, (tick.y + firstTick.y) / 2);
                }
                points.push(tick.x, tick.y);
                nextTick = (spiderTicks[i + 1] || spiderTicks[0]).coords;
                lastTick = {
                    x: (tick.x + nextTick.x) / 2,
                    y: (tick.y + nextTick.y) / 2
                };
            }
            i++;
        }
        points.push(lastTick.x, lastTick.y);
        points.push(center.x, center.y);
        return {
            points: points
        };
    },
    _createStrip: function(_ref2) {
        var { points: points } = _ref2;
        return this._renderer.path(points, "area");
    },
    _getTranslatedCoord: function(value, offset) {
        return this._translator.translate(value, offset) - $3e9d36790f175719$var$HALF_PI_ANGLE;
    },
    _setTickOffset: function() {
        this._tickOffset = false;
    }
});
var $3e9d36790f175719$export$45db2fc2f15997e7 = {
    _resetMargins () {
        this._reinitTranslator(this._getViewportRange());
    },
    _getStick: $3e9d36790f175719$var$xyAxesLinear._getStick,
    _getSpiderCategoryOption: (0, $gcp4g.noop),
    _getTranslatorOptions: function() {
        return {
            isHorizontal: true,
            stick: this._getStick()
        };
    },
    getRadius: $3e9d36790f175719$var$circularAxes.getRadius,
    getCenter: $3e9d36790f175719$var$circularAxes.getCenter,
    getAngles: $3e9d36790f175719$var$circularAxes.getAngles,
    _updateRadius: $3e9d36790f175719$var$circularAxes._updateRadius,
    _updateCenter: $3e9d36790f175719$var$circularAxes._updateCenter,
    _processCanvas (canvas) {
        this._updateRadius(canvas);
        this._updateCenter(canvas);
        return {
            left: 0,
            right: 0,
            startPadding: canvas.startPadding,
            endPadding: canvas.endPadding,
            width: this.getRadius()
        };
    },
    _createAxisElement: $3e9d36790f175719$var$xyAxesLinear._createAxisElement,
    _updateAxisElementPosition: function() {
        var centerCoord = this.getCenter();
        this._axisElement.attr({
            points: [
                centerCoord.x,
                centerCoord.y,
                centerCoord.x + this.getRadius(),
                centerCoord.y
            ]
        }).rotate(this.getAngles()[0] - $3e9d36790f175719$var$HALF_PI_ANGLE, centerCoord.x, centerCoord.y);
    },
    _getScreenDelta: function() {
        return this.getRadius();
    },
    _getTickMarkPoints: function(coords, length) {
        return [
            coords.x - length / 2,
            coords.y,
            coords.x + length / 2,
            coords.y
        ];
    },
    _getLabelAdjustedCoord: function(tick) {
        var labelCoords = tick.labelCoords;
        var labelY = labelCoords.y;
        var cosSin = (0, $dw9tZ.getCosAndSin)(labelCoords.angle);
        var indentFromAxis = this._options.label.indentFromAxis || 0;
        var box = tick.labelBBox;
        var x = labelCoords.x - $3e9d36790f175719$var$abs(indentFromAxis * cosSin.sin) + $3e9d36790f175719$var$abs(box.width / 2 * cosSin.cos) - box.width / 2;
        var y = labelY + (labelY - box.y) - $3e9d36790f175719$var$abs(box.height / 2 * cosSin.sin) + $3e9d36790f175719$var$abs(indentFromAxis * cosSin.cos);
        return {
            x: x,
            y: y
        };
    },
    _getGridLineDrawer: function() {
        var that = this;
        return function(tick, gridStyle) {
            var grid = that._getGridPoints(tick.coords);
            return that._renderer.circle(grid.cx, grid.cy, grid.r).attr(gridStyle).sharp();
        };
    },
    _getGridPoints: function(coords) {
        var pos = this.getCenter();
        var radius = (0, $dw9tZ.getDistance)(pos.x, pos.y, coords.x, coords.y);
        if (radius > this.getRadius()) return {
            cx: null,
            cy: null,
            r: null
        };
        return {
            cx: pos.x,
            cy: pos.y,
            r: radius
        };
    },
    _getTranslatedValue: function(value, offset) {
        var startAngle = this.getAngles()[0];
        var xy = (0, $dw9tZ.convertPolarToXY)(this.getCenter(), startAngle, 0, this._translator.translate(value, offset));
        return {
            x: xy.x,
            y: xy.y,
            angle: startAngle - $3e9d36790f175719$var$HALF_PI_ANGLE
        };
    },
    _getTranslatedCoord: function(value, offset) {
        return this._translator.translate(value, offset);
    },
    _getCanvasStartEnd () {
        var invert = this.getTranslator().getBusinessRange().invert;
        var coords = [
            0,
            this.getRadius()
        ];
        invert && coords.reverse();
        return {
            start: coords[0],
            end: coords[1]
        };
    },
    _getStripGraphicAttributes: function(fromPoint, toPoint) {
        var center = this.getCenter();
        return {
            x: center.x,
            y: center.y,
            innerRadius: fromPoint,
            outerRadius: toPoint
        };
    },
    _createStrip: function(attrs) {
        return this._renderer.arc(attrs.x, attrs.y, attrs.innerRadius, attrs.outerRadius, 0, 360);
    },
    _getAdjustedStripLabelCoords: $3e9d36790f175719$var$circularAxes._getAdjustedStripLabelCoords,
    _getStripLabelCoords: function(from, to) {
        var labelPos = from + (to - from) / 2;
        var center = this.getCenter();
        var y = $3e9d36790f175719$var$round(center.y - labelPos);
        return {
            x: center.x,
            y: y,
            align: (0, $aELZT.default).center
        };
    },
    _getConstantLineGraphicAttributes: function(value) {
        var center = this.getCenter();
        return {
            cx: center.x,
            cy: center.y,
            r: value
        };
    },
    _createConstantLine: function(value, attr) {
        var attrs = this._getConstantLineGraphicAttributes(value);
        return this._renderer.circle(attrs.cx, attrs.cy, attrs.r).attr(attr).sharp();
    },
    _getConstantLineLabelsCoords: function(value) {
        var center = this.getCenter();
        var y = $3e9d36790f175719$var$round(center.y - value);
        return {
            x: center.x,
            y: y
        };
    },
    _checkAlignmentConstantLineLabels: (0, $gcp4g.noop),
    _rotateTick: function(element, coords, isGridLine) {
        !isGridLine && element.rotate(coords.angle + $3e9d36790f175719$var$HALF_PI_ANGLE, coords.x, coords.y);
    },
    _validateOverlappingMode: $3e9d36790f175719$var$circularAxes._validateOverlappingMode,
    _validateDisplayMode: $3e9d36790f175719$var$circularAxes._validateDisplayMode,
    _getStep: function(boxes) {
        var quarter = $3e9d36790f175719$var$getPolarQuarter(this.getAngles()[0]);
        var spacing = this._options.label.minSpacing;
        var func = 2 === quarter || 4 === quarter ? function(box) {
            return box.width + spacing;
        } : function(box) {
            return box.height;
        };
        var maxLabelLength = boxes.reduce((prevValue, box)=>$3e9d36790f175719$var$_max(prevValue, func(box)), 0);
        return (0, $aELZT.default).getTicksCountInRange(this._majorTicks, 2 === quarter || 4 === quarter ? "x" : "y", maxLabelLength);
    }
};
var $3e9d36790f175719$export$b23d8e2f516709d5 = (0, $2oTOp.extend)({}, $3e9d36790f175719$export$45db2fc2f15997e7, {
    _createPathElement: function(points, attr) {
        return this._renderer.path(points, "area").attr(attr).sharp();
    },
    setSpiderTicks: function(ticks) {
        this._spiderTicks = ticks;
    },
    _getGridLineDrawer: function() {
        var that = this;
        return function(tick, gridStyle) {
            return that._createPathElement(that._getGridPoints(tick.coords).points, gridStyle);
        };
    },
    _getGridPoints: function(coords) {
        var pos = this.getCenter();
        var radius = (0, $dw9tZ.getDistance)(pos.x, pos.y, coords.x, coords.y);
        return this._getGridPointsByRadius(radius);
    },
    _getGridPointsByRadius: function(radius) {
        var pos = this.getCenter();
        if (radius > this.getRadius()) return {
            points: null
        };
        return {
            points: (0, $dw9tZ.map)(this._spiderTicks, function(tick) {
                var cosSin = (0, $dw9tZ.getCosAndSin)(tick.coords.angle);
                return {
                    x: $3e9d36790f175719$var$round(pos.x + radius * cosSin.cos),
                    y: $3e9d36790f175719$var$round(pos.y + radius * cosSin.sin)
                };
            })
        };
    },
    _getStripGraphicAttributes: function(fromPoint, toPoint) {
        var innerPoints = this._getGridPointsByRadius(toPoint).points;
        var outerPoints = this._getGridPointsByRadius(fromPoint).points;
        return {
            points: [
                outerPoints,
                innerPoints.reverse()
            ]
        };
    },
    _createStrip: $3e9d36790f175719$export$45d9e517b3d4dc58._createStrip,
    _getConstantLineGraphicAttributes: function(value) {
        return this._getGridPointsByRadius(value);
    },
    _createConstantLine: function(value, attr) {
        return this._createPathElement(this._getConstantLineGraphicAttributes(value).points, attr);
    }
});

});
parcelRegister("53BqL", function(module, exports) {

$parcel$export(module.exports, "calculateCanvasMargins", function () { return $3aea44807867215b$export$f07eb647a8681dac; });
$parcel$export(module.exports, "measureLabels", function () { return $3aea44807867215b$export$bfd7e0f575fb59a7; });
/**
 * DevExtreme (esm/viz/axes/axes_utils.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $3aea44807867215b$var$_max = Math.max;
var $3aea44807867215b$export$f07eb647a8681dac = function(bBoxes, canvas) {
    var cLeft = canvas.left;
    var cTop = canvas.top;
    var cRight = canvas.width - canvas.right;
    var cBottom = canvas.height - canvas.bottom;
    return bBoxes.reduce(function(margins, bBox) {
        if (!bBox || bBox.isEmpty) return margins;
        return {
            left: $3aea44807867215b$var$_max(margins.left, cLeft - bBox.x),
            top: $3aea44807867215b$var$_max(margins.top, cTop - bBox.y),
            right: $3aea44807867215b$var$_max(margins.right, bBox.x + bBox.width - cRight),
            bottom: $3aea44807867215b$var$_max(margins.bottom, bBox.y + bBox.height - cBottom)
        };
    }, {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    });
};
var $3aea44807867215b$export$bfd7e0f575fb59a7 = function(items) {
    items.forEach(function(item) {
        var label = item.getContentContainer();
        item.labelBBox = label ? label.getBBox() : {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    });
};

});


parcelRegister("bA6EZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86e8390bd6cf3858$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/axes/constant_line.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");
function $86e8390bd6cf3858$export$2e2bcd8739ae039(axis, options) {
    var labelOptions = options.label || {};
    var labelPosition = labelOptions.position || "inside";
    var parsedValue;
    var valueIsParsed = false;
    var lastStoredCoordinates;
    axis._checkAlignmentConstantLineLabels(labelOptions);
    var storedCoord;
    return {
        options: options,
        labelOptions: labelOptions,
        labelPosition: labelPosition,
        label: null,
        line: null,
        getParsedValue () {
            if (!valueIsParsed) {
                parsedValue = axis.validateUnit(options.value, "E2105", "constantLine");
                valueIsParsed = true;
                return parsedValue;
            }
            return parsedValue;
        },
        draw () {
            if (!(0, $6ntMu.isDefined)(options.value) || axis._translator.getBusinessRange().isEmpty()) return this;
            var canvas = axis._getCanvasStartEnd();
            var parsedValue = this.getParsedValue();
            this.coord = axis._getConstantLinePos(parsedValue, canvas.start, canvas.end);
            var rootGroup = options.displayBehindSeries ? axis._axisConstantLineGroups.under : axis._axisConstantLineGroups.above;
            var group = rootGroup[labelPosition];
            if (!group) {
                var side = axis._isHorizontal ? labelOptions.verticalAlignment : labelOptions.horizontalAlignment;
                group = rootGroup[side];
            }
            if (!(0, $6ntMu.isDefined)(this.coord)) return this;
            var path = axis._createConstantLine(this.coord, {
                stroke: options.color,
                "stroke-width": options.width,
                dashStyle: options.dashStyle
            });
            this.line = path.append(rootGroup.inside);
            this.label = labelOptions.visible ? axis._drawConstantLineLabels(parsedValue, labelOptions, this.coord, group) : null;
            this.updatePosition();
            return this;
        },
        getContentContainer () {
            return this.label;
        },
        removeLabel () {
            this.label && this.label.remove();
        },
        updatePosition (animate) {
            var canvas = axis._getCanvasStartEnd();
            var coord = axis._getConstantLinePos(this.getParsedValue(), canvas.start, canvas.end);
            if (!(0, $6ntMu.isDefined)(coord)) return;
            this.coord = coord;
            if (animate && storedCoord) {
                this.label && this.label.attr(axis._getConstantLineLabelsCoords(storedCoord, this.labelOptions));
                this.line && this.line.attr(axis._getConstantLineGraphicAttributes(storedCoord));
                this.label && this.label.animate(axis._getConstantLineLabelsCoords(this.coord, this.labelOptions));
                this.line && this.line.animate(axis._getConstantLineGraphicAttributes(this.coord));
            } else {
                this.label && this.label.attr(axis._getConstantLineLabelsCoords(this.coord, this.labelOptions));
                this.line && this.line.attr(axis._getConstantLineGraphicAttributes(this.coord));
                axis._rotateConstantLine(this.line, this.coord);
            }
        },
        saveCoords () {
            lastStoredCoordinates = storedCoord;
            storedCoord = this.coord;
        },
        resetCoordinates () {
            storedCoord = lastStoredCoordinates;
        }
    };
}

});

parcelRegister("3Pl7q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c96844702c7c0ae$export$2e2bcd8739ae039; });
/**
 * DevExtreme (esm/viz/axes/strip.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $dw9tZ = parcelRequire("dw9tZ");

var $2oTOp = parcelRequire("2oTOp");
function $2c96844702c7c0ae$export$2e2bcd8739ae039(axis, options) {
    var storedCoord;
    var lastStoredCoordinates;
    var labelOptions = options.label || {};
    return {
        options: options,
        label: null,
        rect: null,
        _getCoord () {
            var canvas = axis._getCanvasStartEnd();
            var range = axis._translator.getBusinessRange();
            return axis._getStripPos(options.startValue, options.endValue, canvas.start, canvas.end, range);
        },
        _drawLabel: (coords)=>axis._renderer.text(labelOptions.text, coords.x, coords.y).css((0, $dw9tZ.patchFontOptions)((0, $2oTOp.extend)({}, axis.getOptions().label.font, labelOptions.font))).attr({
                align: "center",
                class: labelOptions.cssClass
            }).append(axis._axisStripLabelGroup),
        draw () {
            if (axis._translator.getBusinessRange().isEmpty()) return;
            if (((0, $6ntMu.isDefined)(options.startValue) || (0, $6ntMu.isDefined)(options.endValue)) && (0, $6ntMu.isDefined)(options.color)) {
                var stripPos = this._getCoord();
                this.labelCoords = labelOptions.text ? axis._getStripLabelCoords(stripPos.from, stripPos.to, labelOptions) : null;
                if (stripPos.outOfCanvas || !(0, $6ntMu.isDefined)(stripPos.to) || !(0, $6ntMu.isDefined)(stripPos.from)) return;
                this.rect = axis._createStrip(axis._getStripGraphicAttributes(stripPos.from, stripPos.to)).attr({
                    fill: options.color
                }).append(axis._axisStripGroup);
                this.label = labelOptions.text ? this._drawLabel(this.labelCoords) : null;
            }
        },
        getContentContainer () {
            return this.label;
        },
        removeLabel () {},
        updatePosition (animate) {
            var stripPos = this._getCoord();
            if (animate && storedCoord) {
                this.label && this.label.attr(axis._getStripLabelCoords(storedCoord.from, storedCoord.to, options.label));
                this.rect && this.rect.attr(axis._getStripGraphicAttributes(storedCoord.from, storedCoord.to));
                this.label && this.label.animate(axis._getStripLabelCoords(stripPos.from, stripPos.to, options.label));
                this.rect && this.rect.animate(axis._getStripGraphicAttributes(stripPos.from, stripPos.to));
            } else {
                this.label && this.label.attr(axis._getStripLabelCoords(stripPos.from, stripPos.to, options.label));
                this.rect && this.rect.attr(axis._getStripGraphicAttributes(stripPos.from, stripPos.to));
            }
        },
        saveCoords () {
            lastStoredCoordinates = storedCoord;
            storedCoord = this._getCoord();
        },
        resetCoordinates () {
            storedCoord = lastStoredCoordinates;
        }
    };
}

});


parcelRegister("fMmme", function(module, exports) {

$parcel$export(module.exports, "SeriesFamily", function () { return $b7ccae7915f3b17b$export$4795c3035731a707; });
/**
 * DevExtreme (esm/viz/core/series_family.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ 
var $6ntMu = parcelRequire("6ntMu");

var $2oTOp = parcelRequire("2oTOp");

var $8OLOW = parcelRequire("8OLOW");

var $laqiS = parcelRequire("laqiS");

var $gcp4g = parcelRequire("gcp4g");

var $dw9tZ = parcelRequire("dw9tZ");

var $f38Z1 = parcelRequire("f38Z1");
var { round: $b7ccae7915f3b17b$var$round, abs: $b7ccae7915f3b17b$var$abs, pow: $b7ccae7915f3b17b$var$pow, sqrt: $b7ccae7915f3b17b$var$sqrt } = Math;
var $b7ccae7915f3b17b$var$_min = Math.min;
var $b7ccae7915f3b17b$var$DEFAULT_BAR_GROUP_PADDING = .3;
function $b7ccae7915f3b17b$var$validateBarPadding(barPadding) {
    return barPadding < 0 || barPadding > 1 ? void 0 : barPadding;
}
function $b7ccae7915f3b17b$var$validateBarGroupPadding(barGroupPadding) {
    return barGroupPadding < 0 || barGroupPadding > 1 ? $b7ccae7915f3b17b$var$DEFAULT_BAR_GROUP_PADDING : barGroupPadding;
}
function $b7ccae7915f3b17b$var$isStackExist(series, arg) {
    return series.some(function(s) {
        return !s.getOptions().ignoreEmptyPoints || s.getPointsByArg(arg, true).some(function(point) {
            return point.hasValue();
        });
    });
}
function $b7ccae7915f3b17b$var$correctStackCoordinates(series, currentStacks, arg, stack, parameters, barsArea, seriesStackIndexCallback) {
    series.forEach(function(series) {
        var stackIndex = seriesStackIndexCallback(currentStacks.indexOf(stack), currentStacks.length);
        var points = series.getPointsByArg(arg, true);
        var barPadding = $b7ccae7915f3b17b$var$validateBarPadding(series.getOptions().barPadding);
        var barWidth = series.getOptions().barWidth;
        var offset = $b7ccae7915f3b17b$var$getOffset(stackIndex, parameters);
        var width = parameters.width;
        var extraParameters;
        if (-1 === stackIndex) return;
        if ((0, $6ntMu.isDefined)(barPadding) || (0, $6ntMu.isDefined)(barWidth)) {
            extraParameters = $b7ccae7915f3b17b$var$calculateParams(barsArea, currentStacks.length, 1 - barPadding, barWidth);
            width = extraParameters.width;
            if (!series.getBarOverlapGroup()) offset = $b7ccae7915f3b17b$var$getOffset(stackIndex, extraParameters);
        }
        $b7ccae7915f3b17b$var$correctPointCoordinates(points, width, offset);
    });
}
function $b7ccae7915f3b17b$var$getStackName(series) {
    return series.getStackName() || series.getBarOverlapGroup();
}
function $b7ccae7915f3b17b$var$adjustBarSeriesDimensionsCore(series, options, seriesStackIndexCallback) {
    var _series$, _series$2;
    var commonStacks = [];
    var allArguments = [];
    var seriesInStacks = {};
    var barGroupWidth = options.barGroupWidth;
    var argumentAxis = null === (_series$ = series[0]) || void 0 === _series$ ? void 0 : _series$.getArgumentAxis();
    var interval;
    if (null !== (_series$2 = series[0]) && void 0 !== _series$2 && _series$2.useAggregation()) {
        var _series$3;
        var isDateArgAxis = "datetime" === (null === (_series$3 = series[0]) || void 0 === _series$3 ? void 0 : _series$3.argumentType);
        var tickInterval = argumentAxis.getTickInterval();
        var aggregationInterval = argumentAxis.getAggregationInterval();
        tickInterval = isDateArgAxis ? (0, $f38Z1.default).dateToMilliseconds(tickInterval) : tickInterval;
        aggregationInterval = isDateArgAxis ? (0, $f38Z1.default).dateToMilliseconds(aggregationInterval) : aggregationInterval;
        interval = aggregationInterval < tickInterval ? aggregationInterval : tickInterval;
    }
    interval = null === argumentAxis || void 0 === argumentAxis ? void 0 : argumentAxis.getTranslator().getInterval(interval);
    var barsArea = barGroupWidth ? interval > barGroupWidth ? barGroupWidth : interval : interval * (1 - $b7ccae7915f3b17b$var$validateBarGroupPadding(options.barGroupPadding));
    series.forEach(function(s, i) {
        var stackName = $b7ccae7915f3b17b$var$getStackName(s) || i.toString();
        var argument;
        for(argument in s.pointsByArgument)if (-1 === allArguments.indexOf(argument.valueOf())) allArguments.push(argument.valueOf());
        if (-1 === commonStacks.indexOf(stackName)) {
            commonStacks.push(stackName);
            seriesInStacks[stackName] = [];
        }
        seriesInStacks[stackName].push(s);
    });
    allArguments.forEach(function(arg) {
        var currentStacks = commonStacks.reduce((stacks, stack)=>{
            if ($b7ccae7915f3b17b$var$isStackExist(seriesInStacks[stack], arg)) stacks.push(stack);
            return stacks;
        }, []);
        var parameters = $b7ccae7915f3b17b$var$calculateParams(barsArea, currentStacks.length);
        commonStacks.forEach((stack)=>{
            $b7ccae7915f3b17b$var$correctStackCoordinates(seriesInStacks[stack], currentStacks, arg, stack, parameters, barsArea, seriesStackIndexCallback);
        });
    });
}
function $b7ccae7915f3b17b$var$calculateParams(barsArea, count, percentWidth, fixedBarWidth) {
    var spacing;
    var width;
    if (fixedBarWidth) {
        width = $b7ccae7915f3b17b$var$_min(fixedBarWidth, barsArea / count);
        spacing = count > 1 ? $b7ccae7915f3b17b$var$round((barsArea - $b7ccae7915f3b17b$var$round(width) * count) / (count - 1)) : 0;
    } else if ((0, $6ntMu.isDefined)(percentWidth)) {
        width = barsArea * percentWidth / count;
        spacing = count > 1 ? $b7ccae7915f3b17b$var$round((barsArea - barsArea * percentWidth) / (count - 1)) : 0;
    } else {
        spacing = $b7ccae7915f3b17b$var$round(barsArea / count * .2);
        width = (barsArea - spacing * (count - 1)) / count;
    }
    return {
        width: width > 1 ? $b7ccae7915f3b17b$var$round(width) : 1,
        spacing: spacing,
        middleIndex: count / 2,
        rawWidth: width
    };
}
function $b7ccae7915f3b17b$var$getOffset(stackIndex, parameters) {
    var width = parameters.rawWidth < 1 ? parameters.rawWidth : parameters.width;
    return (stackIndex - parameters.middleIndex + .5) * width - (parameters.middleIndex - stackIndex - .5) * parameters.spacing;
}
function $b7ccae7915f3b17b$var$correctPointCoordinates(points, width, offset) {
    (0, $8OLOW.each)(points, function(_, point) {
        point.correctCoordinates({
            width: width,
            offset: offset
        });
    });
}
function $b7ccae7915f3b17b$var$getValueType(value) {
    return value >= 0 ? "positive" : "negative";
}
function $b7ccae7915f3b17b$var$getVisibleSeries(that) {
    return that.series.filter(function(s) {
        return s.isVisible();
    });
}
function $b7ccae7915f3b17b$var$getAbsStackSumByArg(stackKeepers, stackName, argument) {
    var positiveStackValue = (stackKeepers.positive[stackName] || {})[argument] || 0;
    var negativeStackValue = -(stackKeepers.negative[stackName] || {})[argument] || 0;
    return positiveStackValue + negativeStackValue;
}
function $b7ccae7915f3b17b$var$getStackSumByArg(stackKeepers, stackName, argument) {
    var positiveStackValue = (stackKeepers.positive[stackName] || {})[argument] || 0;
    var negativeStackValue = (stackKeepers.negative[stackName] || {})[argument] || 0;
    return positiveStackValue + negativeStackValue;
}
function $b7ccae7915f3b17b$var$getSeriesStackIndexCallback(inverted) {
    if (!inverted) return function(index) {
        return index;
    };
    else return function(index, stackCount) {
        return stackCount - index - 1;
    };
}
function $b7ccae7915f3b17b$var$isInverted(series) {
    return series[0] && series[0].getArgumentAxis().getTranslator().isInverted();
}
function $b7ccae7915f3b17b$var$adjustBarSeriesDimensions() {
    var series = $b7ccae7915f3b17b$var$getVisibleSeries(this);
    $b7ccae7915f3b17b$var$adjustBarSeriesDimensionsCore(series, this._options, $b7ccae7915f3b17b$var$getSeriesStackIndexCallback($b7ccae7915f3b17b$var$isInverted(series)));
}
function $b7ccae7915f3b17b$var$getFirstValueSign(series) {
    var points = series.getPoints();
    var value;
    for(var i = 0; i < points.length; i++){
        var point = points[i];
        value = point.initialValue && point.initialValue.valueOf();
        if ($b7ccae7915f3b17b$var$abs(value) > 0) break;
    }
    return (0, $laqiS.sign)(value);
}
function $b7ccae7915f3b17b$var$adjustStackedSeriesValues() {
    var negativesAsZeroes = this._options.negativesAsZeroes;
    var series = $b7ccae7915f3b17b$var$getVisibleSeries(this);
    var stackKeepers = {
        positive: {},
        negative: {}
    };
    var holesStack = {
        left: {},
        right: {}
    };
    var lastSeriesInPositiveStack = {};
    var lastSeriesInNegativeStack = {};
    series.forEach(function(singleSeries) {
        var stackName = $b7ccae7915f3b17b$var$getStackName(singleSeries);
        var hole = false;
        var stack = $b7ccae7915f3b17b$var$getFirstValueSign(singleSeries) < 0 ? lastSeriesInNegativeStack : lastSeriesInPositiveStack;
        singleSeries._prevSeries = stack[stackName];
        stack[stackName] = singleSeries;
        singleSeries.holes = (0, $2oTOp.extend)(true, {}, holesStack);
        singleSeries.getPoints().forEach(function(point, index, points) {
            var value = point.initialValue && point.initialValue.valueOf();
            var argument = point.argument.valueOf();
            var stacks = value >= 0 ? stackKeepers.positive : stackKeepers.negative;
            var isNotBarSeries = "bar" !== singleSeries.type;
            if (negativesAsZeroes && value < 0) {
                stacks = stackKeepers.positive;
                value = 0;
                point.resetValue();
            }
            stacks[stackName] = stacks[stackName] || {};
            var currentStack = stacks[stackName];
            if (currentStack[argument]) {
                if (isNotBarSeries) point.correctValue(currentStack[argument]);
                currentStack[argument] += value;
            } else {
                currentStack[argument] = value;
                if (isNotBarSeries) point.resetCorrection();
            }
            if (!point.hasValue()) {
                var prevPoint = points[index - 1];
                if (!hole && prevPoint && prevPoint.hasValue()) {
                    argument = prevPoint.argument.valueOf();
                    prevPoint._skipSetRightHole = true;
                    holesStack.right[argument] = (holesStack.right[argument] || 0) + (prevPoint.value.valueOf() - (isFinite(prevPoint.minValue) ? prevPoint.minValue.valueOf() : 0));
                }
                hole = true;
            } else if (hole) {
                hole = false;
                holesStack.left[argument] = (holesStack.left[argument] || 0) + (point.value.valueOf() - (isFinite(point.minValue) ? point.minValue.valueOf() : 0));
                point._skipSetLeftHole = true;
            }
        });
    });
    series.forEach(function(singleSeries) {
        var holes = singleSeries.holes;
        singleSeries.getPoints().forEach(function(point) {
            var argument = point.argument.valueOf();
            point.resetHoles();
            !point._skipSetLeftHole && point.setHole(holes.left[argument] || holesStack.left[argument] && 0, "left");
            !point._skipSetRightHole && point.setHole(holes.right[argument] || holesStack.right[argument] && 0, "right");
            point._skipSetLeftHole = null;
            point._skipSetRightHole = null;
        });
    });
    this._stackKeepers = stackKeepers;
    series.forEach(function(singleSeries) {
        singleSeries.getPoints().forEach(function(point) {
            var argument = point.argument.valueOf();
            var stackName = $b7ccae7915f3b17b$var$getStackName(singleSeries);
            var absTotal = $b7ccae7915f3b17b$var$getAbsStackSumByArg(stackKeepers, stackName, argument);
            var total = $b7ccae7915f3b17b$var$getStackSumByArg(stackKeepers, stackName, argument);
            point.setPercentValue(absTotal, total, holesStack.left[argument], holesStack.right[argument]);
        });
    });
}
function $b7ccae7915f3b17b$var$updateStackedSeriesValues() {
    var that = this;
    var series = $b7ccae7915f3b17b$var$getVisibleSeries(that);
    var stack = that._stackKeepers;
    var stackKeepers = {
        positive: {},
        negative: {}
    };
    (0, $8OLOW.each)(series, function(_, singleSeries) {
        var minBarSize = singleSeries.getOptions().minBarSize;
        var valueAxisTranslator = singleSeries.getValueAxis().getTranslator();
        var minShownBusinessValue = minBarSize && valueAxisTranslator.getMinBarSize(minBarSize);
        var stackName = singleSeries.getStackName();
        (0, $8OLOW.each)(singleSeries.getPoints(), function(index, point) {
            if (!point.hasValue()) return;
            var value = point.initialValue && point.initialValue.valueOf();
            var argument = point.argument.valueOf();
            if (that.fullStacked) value = value / $b7ccae7915f3b17b$var$getAbsStackSumByArg(stack, stackName, argument) || 0;
            var updateValue = valueAxisTranslator.checkMinBarSize(value, minShownBusinessValue, point.value);
            var valueType = $b7ccae7915f3b17b$var$getValueType(updateValue);
            var currentStack = stackKeepers[valueType][stackName] = stackKeepers[valueType][stackName] || {};
            if (currentStack[argument]) {
                point.minValue = currentStack[argument];
                currentStack[argument] += updateValue;
            } else currentStack[argument] = updateValue;
            point.value = currentStack[argument];
        });
    });
    if (that.fullStacked) $b7ccae7915f3b17b$var$updateFullStackedSeriesValues(series, stackKeepers);
}
function $b7ccae7915f3b17b$var$updateFullStackedSeriesValues(series, stackKeepers) {
    (0, $8OLOW.each)(series, function(_, singleSeries) {
        var stackName = singleSeries.getStackName ? singleSeries.getStackName() : "default";
        (0, $8OLOW.each)(singleSeries.getPoints(), function(index, point) {
            var stackSum = $b7ccae7915f3b17b$var$getAbsStackSumByArg(stackKeepers, stackName, point.argument.valueOf());
            if (0 !== stackSum) {
                point.value = point.value / stackSum;
                if ((0, $6ntMu.isNumeric)(point.minValue)) point.minValue = point.minValue / stackSum;
            }
        });
    });
}
function $b7ccae7915f3b17b$var$updateRangeSeriesValues() {
    var series = $b7ccae7915f3b17b$var$getVisibleSeries(this);
    (0, $8OLOW.each)(series, function(_, singleSeries) {
        var minBarSize = singleSeries.getOptions().minBarSize;
        var valueAxisTranslator = singleSeries.getValueAxis().getTranslator();
        var minShownBusinessValue = minBarSize && valueAxisTranslator.getMinBarSize(minBarSize);
        if (minShownBusinessValue) (0, $8OLOW.each)(singleSeries.getPoints(), function(_, point) {
            if (!point.hasValue()) return;
            if (point.value.valueOf() - point.minValue.valueOf() < minShownBusinessValue) {
                point.value = point.value.valueOf() + minShownBusinessValue / 2;
                point.minValue = point.minValue.valueOf() - minShownBusinessValue / 2;
            }
        });
    });
}
function $b7ccae7915f3b17b$var$updateBarSeriesValues() {
    (0, $8OLOW.each)(this.series, function(_, singleSeries) {
        var minBarSize = singleSeries.getOptions().minBarSize;
        var valueAxisTranslator = singleSeries.getValueAxis().getTranslator();
        var minShownBusinessValue = minBarSize && valueAxisTranslator.getMinBarSize(minBarSize);
        if (minShownBusinessValue) (0, $8OLOW.each)(singleSeries.getPoints(), function(index, point) {
            if (point.hasValue()) point.value = valueAxisTranslator.checkMinBarSize(point.initialValue, minShownBusinessValue);
        });
    });
}
function $b7ccae7915f3b17b$var$adjustCandlestickSeriesDimensions() {
    var series = $b7ccae7915f3b17b$var$getVisibleSeries(this);
    $b7ccae7915f3b17b$var$adjustBarSeriesDimensionsCore(series, {
        barGroupPadding: .3
    }, $b7ccae7915f3b17b$var$getSeriesStackIndexCallback($b7ccae7915f3b17b$var$isInverted(series)));
}
function $b7ccae7915f3b17b$var$adjustBubbleSeriesDimensions() {
    var series = $b7ccae7915f3b17b$var$getVisibleSeries(this);
    if (!series.length) return;
    var options = this._options;
    var visibleAreaX = series[0].getArgumentAxis().getVisibleArea();
    var visibleAreaY = series[0].getValueAxis().getVisibleArea();
    var min = $b7ccae7915f3b17b$var$_min(visibleAreaX[1] - visibleAreaX[0], visibleAreaY[1] - visibleAreaY[0]);
    var minBubbleArea = $b7ccae7915f3b17b$var$pow(options.minBubbleSize, 2);
    var maxBubbleArea = $b7ccae7915f3b17b$var$pow(min * options.maxBubbleSize, 2);
    var equalBubbleSize = (min * options.maxBubbleSize + options.minBubbleSize) / 2;
    var minPointSize = 1 / 0;
    var maxPointSize = -1 / 0;
    var pointSize;
    var bubbleArea;
    var sizeProportion;
    (0, $8OLOW.each)(series, function(_, seriesItem) {
        (0, $8OLOW.each)(seriesItem.getPoints(), function(_, point) {
            maxPointSize = maxPointSize > point.size ? maxPointSize : point.size;
            minPointSize = minPointSize < point.size ? minPointSize : point.size;
        });
    });
    var sizeDispersion = maxPointSize - minPointSize;
    var areaDispersion = $b7ccae7915f3b17b$var$abs(maxBubbleArea - minBubbleArea);
    (0, $8OLOW.each)(series, function(_, seriesItem) {
        (0, $8OLOW.each)(seriesItem.getPoints(), function(_, point) {
            if (maxPointSize === minPointSize) pointSize = $b7ccae7915f3b17b$var$round(equalBubbleSize);
            else {
                sizeProportion = $b7ccae7915f3b17b$var$abs(point.size - minPointSize) / sizeDispersion;
                bubbleArea = areaDispersion * sizeProportion + minBubbleArea;
                pointSize = $b7ccae7915f3b17b$var$round($b7ccae7915f3b17b$var$sqrt(bubbleArea));
            }
            point.correctCoordinates(pointSize);
        });
    });
}
function $b7ccae7915f3b17b$export$4795c3035731a707(options) {
    this.type = (0, $dw9tZ.normalizeEnum)(options.type);
    this.pane = options.pane;
    this.series = [];
    this.updateOptions(options);
    switch(this.type){
        case "bar":
            this.adjustSeriesDimensions = $b7ccae7915f3b17b$var$adjustBarSeriesDimensions;
            this.updateSeriesValues = $b7ccae7915f3b17b$var$updateBarSeriesValues;
            this.adjustSeriesValues = $b7ccae7915f3b17b$var$adjustStackedSeriesValues;
            break;
        case "rangebar":
            this.adjustSeriesDimensions = $b7ccae7915f3b17b$var$adjustBarSeriesDimensions;
            this.updateSeriesValues = $b7ccae7915f3b17b$var$updateRangeSeriesValues;
            break;
        case "fullstackedbar":
            this.fullStacked = true;
            this.adjustSeriesDimensions = $b7ccae7915f3b17b$var$adjustBarSeriesDimensions;
            this.adjustSeriesValues = $b7ccae7915f3b17b$var$adjustStackedSeriesValues;
            this.updateSeriesValues = $b7ccae7915f3b17b$var$updateStackedSeriesValues;
            break;
        case "stackedbar":
            this.adjustSeriesDimensions = $b7ccae7915f3b17b$var$adjustBarSeriesDimensions;
            this.adjustSeriesValues = $b7ccae7915f3b17b$var$adjustStackedSeriesValues;
            this.updateSeriesValues = $b7ccae7915f3b17b$var$updateStackedSeriesValues;
            break;
        case "fullstackedarea":
        case "fullstackedline":
        case "fullstackedspline":
        case "fullstackedsplinearea":
            this.fullStacked = true;
            this.adjustSeriesValues = $b7ccae7915f3b17b$var$adjustStackedSeriesValues;
            break;
        case "stackedarea":
        case "stackedsplinearea":
        case "stackedline":
        case "stackedspline":
            this.adjustSeriesValues = $b7ccae7915f3b17b$var$adjustStackedSeriesValues;
            break;
        case "candlestick":
        case "stock":
            this.adjustSeriesDimensions = $b7ccae7915f3b17b$var$adjustCandlestickSeriesDimensions;
            break;
        case "bubble":
            this.adjustSeriesDimensions = $b7ccae7915f3b17b$var$adjustBubbleSeriesDimensions;
    }
}
$b7ccae7915f3b17b$export$4795c3035731a707.prototype = {
    constructor: $b7ccae7915f3b17b$export$4795c3035731a707,
    adjustSeriesDimensions: (0, $gcp4g.noop),
    adjustSeriesValues: (0, $gcp4g.noop),
    updateSeriesValues: (0, $gcp4g.noop),
    updateOptions: function(options) {
        this._options = options;
    },
    dispose: function() {
        this.series = null;
    },
    add: function(series) {
        var type = this.type;
        this.series = (0, $dw9tZ.map)(series, (singleSeries)=>singleSeries.type === type ? singleSeries : null);
    }
};

});





parcelRegister("ePCTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acc3ff8a1eac85bb$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $eP4dZ = parcelRequire("eP4dZ");

var $gIHYf = parcelRequire("gIHYf");

var $7J7Kn = parcelRequire("7J7Kn");


var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $8gyMY = parcelRequire("8gyMY");

var $5NdAq = parcelRequire("5NdAq");

var $dv594 = parcelRequire("dv594");

var $ih19M = parcelRequire("ih19M");
"use client";
const $acc3ff8a1eac85bb$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $acc3ff8a1eac85bb$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function $acc3ff8a1eac85bb$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, $eP4dZ.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${$acc3ff8a1eac85bb$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $4WYaH.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $acc3ff8a1eac85bb$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $eP4dZ.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $eP4dZ.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, $dv594.default).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $acc3ff8a1eac85bb$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = "";
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== "") return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $acc3ff8a1eac85bb$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $eP4dZ.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === "object") zeroValueBreakpointKeys = $acc3ff8a1eac85bb$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $eP4dZ.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${$acc3ff8a1eac85bb$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $dv594.default).item}`]: {
                    paddingTop: $acc3ff8a1eac85bb$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $dv594.default).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $acc3ff8a1eac85bb$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $eP4dZ.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === "object") zeroValueBreakpointKeys = $acc3ff8a1eac85bb$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $eP4dZ.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${$acc3ff8a1eac85bb$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$acc3ff8a1eac85bb$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $dv594.default).item}`]: {
                    paddingLeft: $acc3ff8a1eac85bb$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: "100%",
                marginLeft: 0,
                [`& > .${(0, $dv594.default).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $acc3ff8a1eac85bb$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $acc3ff8a1eac85bb$var$GridRoot = (0, $g4l1t.default)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $acc3ff8a1eac85bb$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), $acc3ff8a1eac85bb$export$71d4225eeb1bc13e, $acc3ff8a1eac85bb$export$380604d7c79f9e8f, $acc3ff8a1eac85bb$export$4315fba5128fb4a1, $acc3ff8a1eac85bb$export$ca2a698f6020fda);
function $acc3ff8a1eac85bb$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $acc3ff8a1eac85bb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $acc3ff8a1eac85bb$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...spacingClasses,
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $dv594.getGridUtilityClass), classes);
};
const $acc3ff8a1eac85bb$var$Grid = /*#__PURE__*/ $bh6RR.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $cNBED.default)({
        props: inProps,
        name: "MuiGrid"
    });
    const { breakpoints: breakpoints } = (0, $8gyMY.default)();
    const props = (0, $gIHYf.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = "div", container: container = false, direction: direction = "row", item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = "wrap", zeroMinWidth: zeroMinWidth = false } = props, other = (0, $hCIyK.default)(props, $acc3ff8a1eac85bb$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $bh6RR.useContext((0, $5NdAq.default));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $4WYaH.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $4WYaH.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $acc3ff8a1eac85bb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5NdAq.default).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($acc3ff8a1eac85bb$var$GridRoot, (0, $4WYaH.default)({
            ownerState: ownerState,
            className: (0, $aPsoC.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $acc3ff8a1eac85bb$export$2e2bcd8739ae039 = $acc3ff8a1eac85bb$var$Grid;

});
parcelRegister("aPsoC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa1a2e608fb826ea$export$2e2bcd8739ae039; });
function $fa1a2e608fb826ea$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $fa1a2e608fb826ea$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $fa1a2e608fb826ea$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $fa1a2e608fb826ea$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $fa1a2e608fb826ea$export$2e2bcd8739ae039 = $fa1a2e608fb826ea$export$4f5d2d50c9deca37;

});

parcelRegister("gIHYf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2c2dd16a68b0773$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $cseKH = parcelRequire("cseKH");

var $8RAwN = parcelRequire("8RAwN");
const $c2c2dd16a68b0773$var$_excluded = [
    "sx"
];
const $c2c2dd16a68b0773$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $8RAwN.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $c2c2dd16a68b0773$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $hCIyK.default)(props, $c2c2dd16a68b0773$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $c2c2dd16a68b0773$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $cseKH.isPlainObject)(result)) return systemProps;
        return (0, $4WYaH.default)({}, systemProps, result);
    };
    else finalSx = (0, $4WYaH.default)({}, systemProps, inSx);
    return (0, $4WYaH.default)({}, otherProps, {
        sx: finalSx
    });
}

});

parcelRegister("7J7Kn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a02beca202937b2$export$2e2bcd8739ae039; });
function $5a02beca202937b2$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("g4l1t", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", function () { return $bb2d53ba8ea7fa4b$export$effb20ecdbf4d6aa; });
$parcel$export(module.exports, "slotShouldForwardProp", function () { return $bb2d53ba8ea7fa4b$export$f10c5a10d27438e5; });
$parcel$export(module.exports, "default", function () { return $bb2d53ba8ea7fa4b$export$2e2bcd8739ae039; });

var $4Wt3S = parcelRequire("4Wt3S");

var $OFmxN = parcelRequire("OFmxN");

var $wllwT = parcelRequire("wllwT");
"use client";
const $bb2d53ba8ea7fa4b$export$effb20ecdbf4d6aa = (prop)=>(0, $4Wt3S.shouldForwardProp)(prop) && prop !== "classes";
const $bb2d53ba8ea7fa4b$export$f10c5a10d27438e5 = (0, $4Wt3S.shouldForwardProp);
const $bb2d53ba8ea7fa4b$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($4Wt3S)))({
    themeId: (0, $wllwT.default),
    defaultTheme: $OFmxN.default,
    rootShouldForwardProp: $bb2d53ba8ea7fa4b$export$effb20ecdbf4d6aa
});
var $bb2d53ba8ea7fa4b$export$2e2bcd8739ae039 = $bb2d53ba8ea7fa4b$var$styled;

});
parcelRegister("4Wt3S", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $39931f3774534d7b$var$createStyled;
module.exports.shouldForwardProp = $39931f3774534d7b$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $39931f3774534d7b$var$_extends2 = $2ZnTs((parcelRequire("3Tqyg")));

var $39931f3774534d7b$var$_objectWithoutPropertiesLoose2 = $2ZnTs((parcelRequire("4bIUn")));

var $39931f3774534d7b$var$_styledEngine = $39931f3774534d7b$var$_interopRequireWildcard((parcelRequire("8BdII")));

var $cseKH = parcelRequire("cseKH");

var $39931f3774534d7b$var$_capitalize = $2ZnTs((parcelRequire("gIQ0a")));

var $39931f3774534d7b$var$_getDisplayName = $2ZnTs((parcelRequire("57dtn")));

var $39931f3774534d7b$var$_createTheme = $2ZnTs((parcelRequire("kUSQI")));

var $39931f3774534d7b$var$_styleFunctionSx = $2ZnTs((parcelRequire("0jTcY")));
const $39931f3774534d7b$var$_excluded = [
    "ownerState"
], $39931f3774534d7b$var$_excluded2 = [
    "variants"
], $39931f3774534d7b$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $39931f3774534d7b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($39931f3774534d7b$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $39931f3774534d7b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $39931f3774534d7b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $39931f3774534d7b$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $39931f3774534d7b$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $39931f3774534d7b$var$shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $39931f3774534d7b$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $39931f3774534d7b$var$_createTheme.default)();
const $39931f3774534d7b$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $39931f3774534d7b$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $39931f3774534d7b$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $39931f3774534d7b$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $39931f3774534d7b$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $39931f3774534d7b$var$_objectWithoutPropertiesLoose2.default)(_ref, $39931f3774534d7b$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $39931f3774534d7b$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$39931f3774534d7b$var$processStyleArg(resolvedStyle, (0, $39931f3774534d7b$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $39931f3774534d7b$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $39931f3774534d7b$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $39931f3774534d7b$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $39931f3774534d7b$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $39931f3774534d7b$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $39931f3774534d7b$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $39931f3774534d7b$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $39931f3774534d7b$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $39931f3774534d7b$var$_styleFunctionSx.default)((0, $39931f3774534d7b$var$_extends2.default)({}, props, {
            theme: $39931f3774534d7b$var$resolveTheme((0, $39931f3774534d7b$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $39931f3774534d7b$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $39931f3774534d7b$var$defaultOverridesResolver($39931f3774534d7b$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $39931f3774534d7b$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $39931f3774534d7b$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $39931f3774534d7b$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($39931f3774534d7b$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $39931f3774534d7b$var$_styledEngine.default)(tag, (0, $39931f3774534d7b$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $cseKH.isPlainObject)(stylesArg)) return (props)=>$39931f3774534d7b$var$processStyleArg(stylesArg, (0, $39931f3774534d7b$var$_extends2.default)({}, props, {
                    theme: $39931f3774534d7b$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $39931f3774534d7b$var$resolveTheme((0, $39931f3774534d7b$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $39931f3774534d7b$var$processStyleArg(slotStyle, (0, $39931f3774534d7b$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $39931f3774534d7b$var$resolveTheme((0, $39931f3774534d7b$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $39931f3774534d7b$var$processStyleArg({
                    variants: themeVariants
                }, (0, $39931f3774534d7b$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("3Tqyg", function(module, exports) {
function $2d5b1ac1574da936$var$_extends() {
    module.exports = $2d5b1ac1574da936$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $2d5b1ac1574da936$var$_extends.apply(this, arguments);
}
module.exports = $2d5b1ac1574da936$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4bIUn", function(module, exports) {
function $30cb065ea47a1f86$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $30cb065ea47a1f86$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8BdII", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $642c6bfe92b66bd8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $642c6bfe92b66bd8$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("k0FAg")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("fPZvG")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("fPZvG")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("kQHyY")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("6SFe5")).default; });
/**
 * @mui/styled-engine v5.15.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $8dDdL = parcelRequire("8dDdL");

var $fPZvG = parcelRequire("fPZvG");
var $k0FAg = parcelRequire("k0FAg");

var $kQHyY = parcelRequire("kQHyY");

var $6SFe5 = parcelRequire("6SFe5");
"use client";
function $642c6bfe92b66bd8$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $8dDdL.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $642c6bfe92b66bd8$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("8dDdL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fbdf620290b3477$export$2e2bcd8739ae039; });

var $4I7Ie = parcelRequire("4I7Ie");
parcelRequire("3Tqyg");
parcelRequire("bh6RR");
parcelRequire("e94ba");

parcelRequire("3hmGv");
parcelRequire("c1zwb");
parcelRequire("lSpak");
var $5fbdf620290b3477$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $5fbdf620290b3477$export$2e2bcd8739ae039 = (0, $4I7Ie.default).bind();
$5fbdf620290b3477$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $5fbdf620290b3477$export$2e2bcd8739ae039[tagName] = $5fbdf620290b3477$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("4I7Ie", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36e14100b8801cb7$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $e94ba = parcelRequire("e94ba");
parcelRequire("fPZvG");
var $k0FAg = parcelRequire("k0FAg");

var $3hmGv = parcelRequire("3hmGv");

var $c1zwb = parcelRequire("c1zwb");

var $lSpak = parcelRequire("lSpak");
var $36e14100b8801cb7$var$testOmitPropsOnStringTag = (0, $e94ba.default);
var $36e14100b8801cb7$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $36e14100b8801cb7$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $36e14100b8801cb7$var$testOmitPropsOnStringTag : $36e14100b8801cb7$var$testOmitPropsOnComponent;
};
var $36e14100b8801cb7$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $36e14100b8801cb7$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $36e14100b8801cb7$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $3hmGv.registerStyles)(cache, serialized, isStringTag);
    (0, $lSpak.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $3hmGv.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $36e14100b8801cb7$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $36e14100b8801cb7$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $36e14100b8801cb7$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $k0FAg.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $bh6RR.useContext((0, $k0FAg.T));
            }
            if (typeof props.className === "string") className = (0, $3hmGv.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $c1zwb.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $36e14100b8801cb7$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($36e14100b8801cb7$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $bh6RR.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $4WYaH.default)({}, options, nextOptions, {
                shouldForwardProp: $36e14100b8801cb7$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("e94ba", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4c525d7dbc25949$export$2e2bcd8739ae039; });

var $cthCm = parcelRequire("cthCm");
var $a4c525d7dbc25949$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $a4c525d7dbc25949$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $cthCm.default)(function(prop) {
    return $a4c525d7dbc25949$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("cthCm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9145dbf8e0e857b1$export$2e2bcd8739ae039; });
function $9145dbf8e0e857b1$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("fPZvG", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $b87b550e76e09f68$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $b87b550e76e09f68$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $b87b550e76e09f68$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("k0FAg")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("k0FAg")).w; });

var $k0FAg = parcelRequire("k0FAg");

var $bh6RR = parcelRequire("bh6RR");

var $3hmGv = parcelRequire("3hmGv");

var $lSpak = parcelRequire("lSpak");

var $c1zwb = parcelRequire("c1zwb");
parcelRequire("lNmZA");
parcelRequire("3Tqyg");
parcelRequire("ieFqf");

parcelRequire("adG4d");
var $b87b550e76e09f68$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $b87b550e76e09f68$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $k0FAg.h).call(props, "css")) // $FlowFixMe
    return $bh6RR.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $k0FAg.E);
    createElementArgArray[1] = (0, $k0FAg.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $bh6RR.createElement.apply(null, createElementArgArray);
};
var $b87b550e76e09f68$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $b87b550e76e09f68$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $k0FAg.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $c1zwb.serializeStyles)([
        styles
    ], undefined, $bh6RR.useContext((0, $k0FAg.T)));
    if (!(0, $k0FAg.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $bh6RR.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $bh6RR.useRef();
    (0, $lSpak.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $lSpak.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $3hmGv.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $b87b550e76e09f68$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $c1zwb.serializeStyles)(args);
}
var $b87b550e76e09f68$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $b87b550e76e09f68$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $b87b550e76e09f68$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $b87b550e76e09f68$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $3hmGv.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $b87b550e76e09f68$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $lSpak.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $3hmGv.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $b87b550e76e09f68$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $k0FAg.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $c1zwb.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $3hmGv.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $b87b550e76e09f68$var$merge(cache.registered, css, $b87b550e76e09f68$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $bh6RR.useContext((0, $k0FAg.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($b87b550e76e09f68$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $b87b550e76e09f68$var$isBrowser, $b87b550e76e09f68$var$isTestEnv, $b87b550e76e09f68$var$globalContext, $b87b550e76e09f68$var$globalKey;

});
parcelRegister("k0FAg", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $e914107019eefbc9$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $e914107019eefbc9$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $e914107019eefbc9$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $e914107019eefbc9$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $e914107019eefbc9$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $e914107019eefbc9$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $e914107019eefbc9$export$a9c23c6ac3fc3eca; });

var $bh6RR = parcelRequire("bh6RR");

var $lNmZA = parcelRequire("lNmZA");

var $4WYaH = parcelRequire("4WYaH");

var $ieFqf = parcelRequire("ieFqf");

var $8GHIh = parcelRequire("8GHIh");

var $3hmGv = parcelRequire("3hmGv");

var $c1zwb = parcelRequire("c1zwb");

var $lSpak = parcelRequire("lSpak");
var $e914107019eefbc9$export$23f2a1d2818174ef = true;
var $e914107019eefbc9$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $e914107019eefbc9$var$EmotionCacheContext = /* #__PURE__ */ $bh6RR.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $lNmZA.default)({
    key: "css"
}) : null);
var $e914107019eefbc9$export$e7094788287c5e9b = $e914107019eefbc9$var$EmotionCacheContext.Provider;
var $e914107019eefbc9$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $bh6RR.useContext)($e914107019eefbc9$var$EmotionCacheContext);
};
var $e914107019eefbc9$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $bh6RR.useContext)($e914107019eefbc9$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$e914107019eefbc9$export$23f2a1d2818174ef) $e914107019eefbc9$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $bh6RR.useContext)($e914107019eefbc9$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $lNmZA.default)({
                key: "css"
            });
            return /*#__PURE__*/ $bh6RR.createElement($e914107019eefbc9$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $e914107019eefbc9$export$971d5caa766a69d7 = /* #__PURE__ */ $bh6RR.createContext({});
var $e914107019eefbc9$export$3b14a55fb2447963 = function useTheme() {
    return $bh6RR.useContext($e914107019eefbc9$export$971d5caa766a69d7);
};
var $e914107019eefbc9$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $4WYaH.default)({}, outerTheme, theme);
};
var $e914107019eefbc9$var$createCacheWithTheme = /* #__PURE__ */ (0, $ieFqf.default)(function(outerTheme) {
    return (0, $ieFqf.default)(function(theme) {
        return $e914107019eefbc9$var$getTheme(outerTheme, theme);
    });
});
var $e914107019eefbc9$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $bh6RR.useContext($e914107019eefbc9$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $e914107019eefbc9$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $bh6RR.createElement($e914107019eefbc9$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $e914107019eefbc9$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $bh6RR.useContext($e914107019eefbc9$export$971d5caa766a69d7);
        return /*#__PURE__*/ $bh6RR.createElement(Component, (0, $4WYaH.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $bh6RR.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $8GHIh.default)(WithTheme, Component);
}
var $e914107019eefbc9$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $e914107019eefbc9$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $e914107019eefbc9$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $e914107019eefbc9$var$getLastPart(match[1]);
    return undefined;
};
var $e914107019eefbc9$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $e914107019eefbc9$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $e914107019eefbc9$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $e914107019eefbc9$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($e914107019eefbc9$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $e914107019eefbc9$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $e914107019eefbc9$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $e914107019eefbc9$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $e914107019eefbc9$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($e914107019eefbc9$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$e914107019eefbc9$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $e914107019eefbc9$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $3hmGv.registerStyles)(cache, serialized, isStringTag);
    (0, $lSpak.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $3hmGv.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $e914107019eefbc9$var$Emotion = /* #__PURE__ */ $e914107019eefbc9$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$e914107019eefbc9$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $3hmGv.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $c1zwb.serializeStyles)(registeredStyles, undefined, $bh6RR.useContext($e914107019eefbc9$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($e914107019eefbc9$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $e914107019eefbc9$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($e914107019eefbc9$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $bh6RR.createElement(WrappedComponent, newProps));
});
var $e914107019eefbc9$export$a9c23c6ac3fc3eca = $e914107019eefbc9$var$Emotion;

});
parcelRegister("lNmZA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fde0026076b18275$export$2e2bcd8739ae039; });

var $gmA7Z = parcelRequire("gmA7Z");

var $sdBdz = parcelRequire("sdBdz");
parcelRequire("ieFqf");
parcelRequire("cthCm");
var $fde0026076b18275$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $sdBdz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $sdBdz.token)(character)) break;
        (0, $sdBdz.next)();
    }
    return (0, $sdBdz.slice)(begin, (0, $sdBdz.position));
};
var $fde0026076b18275$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $sdBdz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $sdBdz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fde0026076b18275$var$identifierWithPointTracking((0, $sdBdz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $sdBdz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $sdBdz.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $sdBdz.from)(character);
    }
    while (character = (0, $sdBdz.next)());
    return parsed;
};
var $fde0026076b18275$var$getRules = function getRules(value, points) {
    return (0, $sdBdz.dealloc)($fde0026076b18275$var$toRules((0, $sdBdz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fde0026076b18275$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fde0026076b18275$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fde0026076b18275$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fde0026076b18275$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fde0026076b18275$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fde0026076b18275$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $fde0026076b18275$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $fde0026076b18275$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($fde0026076b18275$var$ignoreFlag) > -1;
};
var $fde0026076b18275$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fde0026076b18275$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $fde0026076b18275$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fde0026076b18275$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fde0026076b18275$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fde0026076b18275$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $fde0026076b18275$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fde0026076b18275$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fde0026076b18275$var$nullifyElement(element);
    } else if ($fde0026076b18275$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fde0026076b18275$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fde0026076b18275$var$prefix(value, length) {
    switch((0, $sdBdz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $sdBdz.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $sdBdz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MOZ) + value + (0, $sdBdz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + value + value;
        // order
        case 6165:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.replace)(value, /(\w+).+(:[^]+)/, (0, $sdBdz.WEBKIT) + "box-$1$2" + (0, $sdBdz.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + "flex-item-" + (0, $sdBdz.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + "flex-line-pack" + (0, $sdBdz.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $sdBdz.WEBKIT) + "box-" + (0, $sdBdz.replace)(value, "-grow", "") + (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $sdBdz.WEBKIT) + (0, $sdBdz.replace)(value, /([^-])(transform)/g, "$1" + (0, $sdBdz.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $sdBdz.replace)((0, $sdBdz.replace)((0, $sdBdz.replace)(value, /(zoom-|grab)/, (0, $sdBdz.WEBKIT) + "$1"), /(image-set)/, (0, $sdBdz.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $sdBdz.replace)(value, /(image-set\([^]*)/, (0, $sdBdz.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $sdBdz.replace)((0, $sdBdz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $sdBdz.WEBKIT) + "box-pack:$3" + (0, $sdBdz.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $sdBdz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $sdBdz.replace)(value, /(.+)-inline(.+)/, (0, $sdBdz.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $sdBdz.strlen)(value) - 1 - length > 6) switch((0, $sdBdz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $sdBdz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $sdBdz.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $sdBdz.WEBKIT) + "$2-$3" + "$1" + (0, $sdBdz.MOZ) + ((0, $sdBdz.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $sdBdz.indexof)(value, "stretch") ? $fde0026076b18275$var$prefix((0, $sdBdz.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $sdBdz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $sdBdz.charat)(value, (0, $sdBdz.strlen)(value) - 3 - (~(0, $sdBdz.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $sdBdz.replace)(value, ":", ":" + (0, $sdBdz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $sdBdz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $sdBdz.WEBKIT) + ((0, $sdBdz.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $sdBdz.WEBKIT) + "$2$3" + "$1" + (0, $sdBdz.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $sdBdz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + value + value;
    }
    return value;
}
var $fde0026076b18275$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $sdBdz.DECLARATION:
                element["return"] = $fde0026076b18275$var$prefix(element.value, element.length);
                break;
            case 0, $sdBdz.KEYFRAMES:
                return (0, $sdBdz.serialize)([
                    (0, $sdBdz.copy)(element, {
                        value: (0, $sdBdz.replace)(element.value, "@", "@" + (0, $sdBdz.WEBKIT))
                    })
                ], callback);
            case 0, $sdBdz.RULESET:
                if (element.length) return (0, $sdBdz.combine)(element.props, function(value) {
                    switch((0, $sdBdz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $sdBdz.serialize)([
                                (0, $sdBdz.copy)(element, {
                                    props: [
                                        (0, $sdBdz.replace)(value, /:(read-\w+)/, ":" + (0, $sdBdz.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $sdBdz.serialize)([
                                (0, $sdBdz.copy)(element, {
                                    props: [
                                        (0, $sdBdz.replace)(value, /:(plac\w+)/, ":" + (0, $sdBdz.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $sdBdz.copy)(element, {
                                    props: [
                                        (0, $sdBdz.replace)(value, /:(plac\w+)/, ":" + (0, $sdBdz.MOZ) + "$1")
                                    ]
                                }),
                                (0, $sdBdz.copy)(element, {
                                    props: [
                                        (0, $sdBdz.replace)(value, /:(plac\w+)/, (0, $sdBdz.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $fde0026076b18275$var$defaultStylisPlugins = [
    $fde0026076b18275$var$prefixer
];
var $fde0026076b18275$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $fde0026076b18275$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fde0026076b18275$var$compat,
        $fde0026076b18275$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $sdBdz.stringify),
        (0, $sdBdz.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $sdBdz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $sdBdz.serialize)((0, $sdBdz.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $gmA7Z.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("gmA7Z", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $be9ab9a8c7d78547$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $be9ab9a8c7d78547$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $be9ab9a8c7d78547$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $be9ab9a8c7d78547$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($be9ab9a8c7d78547$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $be9ab9a8c7d78547$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("sdBdz", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $783faa7ec18221fc$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $783faa7ec18221fc$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $783faa7ec18221fc$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $783faa7ec18221fc$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $783faa7ec18221fc$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $783faa7ec18221fc$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $783faa7ec18221fc$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $783faa7ec18221fc$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $783faa7ec18221fc$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $783faa7ec18221fc$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $783faa7ec18221fc$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $783faa7ec18221fc$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $783faa7ec18221fc$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $783faa7ec18221fc$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $783faa7ec18221fc$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $783faa7ec18221fc$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $783faa7ec18221fc$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $783faa7ec18221fc$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $783faa7ec18221fc$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $783faa7ec18221fc$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $783faa7ec18221fc$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $783faa7ec18221fc$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $783faa7ec18221fc$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $783faa7ec18221fc$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $783faa7ec18221fc$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $783faa7ec18221fc$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $783faa7ec18221fc$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $783faa7ec18221fc$export$38bcb760f1d4871c; });
var $783faa7ec18221fc$export$71ad59f2e432cfe8 = "-ms-";
var $783faa7ec18221fc$export$2c0f367103c8d01c = "-moz-";
var $783faa7ec18221fc$export$39dfd62a25e0fe93 = "-webkit-";
var $783faa7ec18221fc$export$a29989082612d0d9 = "comm";
var $783faa7ec18221fc$export$aa3a2e812ca8570d = "rule";
var $783faa7ec18221fc$export$527d108ccf083c2b = "decl";
var $783faa7ec18221fc$export$d3d35020fa5b54f0 = "@page";
var $783faa7ec18221fc$export$500415a86c544f73 = "@media";
var $783faa7ec18221fc$export$a763edbf796b780a = "@import";
var $783faa7ec18221fc$export$2790aeb8b4e5c826 = "@charset";
var $783faa7ec18221fc$export$1cc683e23b84b133 = "@viewport";
var $783faa7ec18221fc$export$9447a5efea57e862 = "@supports";
var $783faa7ec18221fc$export$ef011b4e114b1fba = "@document";
var $783faa7ec18221fc$export$6aad947bda0f3f46 = "@namespace";
var $783faa7ec18221fc$export$b44a8529a35fcb60 = "@keyframes";
var $783faa7ec18221fc$export$2c16de31893252e6 = "@font-face";
var $783faa7ec18221fc$export$3d846dd52e150c6f = "@counter-style";
var $783faa7ec18221fc$export$22314bfbb57653fe = "@font-feature-values";
var $783faa7ec18221fc$export$d773506282b3cfe6 = "@layer";
var $783faa7ec18221fc$export$2335f513bbd82c6d = Math.abs;
var $783faa7ec18221fc$export$6788812c4e6611e6 = String.fromCharCode;
var $783faa7ec18221fc$export$e6e34fd1f2686227 = Object.assign;
function $783faa7ec18221fc$export$d6af199866bfb566(e, r) {
    return $783faa7ec18221fc$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 0)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 1)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 2)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 3) : 0;
}
function $783faa7ec18221fc$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $783faa7ec18221fc$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $783faa7ec18221fc$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $783faa7ec18221fc$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $783faa7ec18221fc$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $783faa7ec18221fc$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $783faa7ec18221fc$export$36776f635604f274(e) {
    return e.length;
}
function $783faa7ec18221fc$export$f9084667e487ed46(e) {
    return e.length;
}
function $783faa7ec18221fc$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $783faa7ec18221fc$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $783faa7ec18221fc$export$53f1d5ea8de3d7c = 1;
var $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1;
var $783faa7ec18221fc$export$f24224f1c91d8156 = 0;
var $783faa7ec18221fc$export$5880b8b5730aff45 = 0;
var $783faa7ec18221fc$export$c0306caf338ac095 = 0;
var $783faa7ec18221fc$export$30a86d91af8ff6e6 = "";
function $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $783faa7ec18221fc$export$53f1d5ea8de3d7c,
        column: $783faa7ec18221fc$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $783faa7ec18221fc$export$784d13d8ee351f07(e, r) {
    return $783faa7ec18221fc$export$e6e34fd1f2686227($783faa7ec18221fc$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $783faa7ec18221fc$export$eba6f6f03b0a92e7() {
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$232faf9add678146() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 > 0 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, --$783faa7ec18221fc$export$5880b8b5730aff45) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3--, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c--;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$48cfd1e771a65c4f() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 < $783faa7ec18221fc$export$f24224f1c91d8156 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45++) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3++, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c++;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$4d3fb11e950abb9e() {
    return $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$e88cb2efb12ae807() {
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$58adb3bec8346d0f(e, r) {
    return $783faa7ec18221fc$export$2f35ab04d2335697($783faa7ec18221fc$export$30a86d91af8ff6e6, e, r);
}
function $783faa7ec18221fc$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $783faa7ec18221fc$export$2de70f21292aac9e(e) {
    return $783faa7ec18221fc$export$53f1d5ea8de3d7c = $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$f24224f1c91d8156 = $783faa7ec18221fc$export$36776f635604f274($783faa7ec18221fc$export$30a86d91af8ff6e6 = e), $783faa7ec18221fc$export$5880b8b5730aff45 = 0, [];
}
function $783faa7ec18221fc$export$45918ac1574455b1(e) {
    return $783faa7ec18221fc$export$30a86d91af8ff6e6 = "", e;
}
function $783faa7ec18221fc$export$410ac95b9ec204b8(e) {
    return $783faa7ec18221fc$export$87c2784dc9fc4ab($783faa7ec18221fc$export$58adb3bec8346d0f($783faa7ec18221fc$export$5880b8b5730aff45 - 1, $783faa7ec18221fc$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $783faa7ec18221fc$export$660b2ee2d4fb4eff(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$5f8c09e3ae6f64e1($783faa7ec18221fc$export$2de70f21292aac9e(e)));
}
function $783faa7ec18221fc$export$7af1228ff777d175(e) {
    while($783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$4d3fb11e950abb9e())if ($783faa7ec18221fc$export$c0306caf338ac095 < 33) $783faa7ec18221fc$export$48cfd1e771a65c4f();
    else break;
    return $783faa7ec18221fc$export$9e1725a4cfeada27(e) > 2 || $783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $783faa7ec18221fc$export$5f8c09e3ae6f64e1(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095)){
        case 0:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$c0306caf338ac095), e);
            break;
        default:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$c0306caf338ac095), e);
    }
    return e;
}
function $783faa7ec18221fc$export$955ba06d119e085e(e, r) {
    while(--r && $783faa7ec18221fc$export$48cfd1e771a65c4f())if ($783faa7ec18221fc$export$c0306caf338ac095 < 48 || $783faa7ec18221fc$export$c0306caf338ac095 > 102 || $783faa7ec18221fc$export$c0306caf338ac095 > 57 && $783faa7ec18221fc$export$c0306caf338ac095 < 65 || $783faa7ec18221fc$export$c0306caf338ac095 > 70 && $783faa7ec18221fc$export$c0306caf338ac095 < 97) break;
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$e88cb2efb12ae807() + (r < 6 && $783faa7ec18221fc$export$4d3fb11e950abb9e() == 32 && $783faa7ec18221fc$export$48cfd1e771a65c4f() == 32));
}
function $783faa7ec18221fc$export$c889f2fcc19dbf12(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$c0306caf338ac095){
        case e:
            return $783faa7ec18221fc$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $783faa7ec18221fc$export$c889f2fcc19dbf12($783faa7ec18221fc$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $783faa7ec18221fc$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $783faa7ec18221fc$export$48cfd1e771a65c4f();
            break;
    }
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$4254d4e2b3745c4c(e, r) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 57) break;
    else if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 84 && $783faa7ec18221fc$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $783faa7ec18221fc$export$58adb3bec8346d0f(r, $783faa7ec18221fc$export$5880b8b5730aff45 - 1) + "*" + $783faa7ec18221fc$export$6788812c4e6611e6(e === 47 ? e : $783faa7ec18221fc$export$48cfd1e771a65c4f());
}
function $783faa7ec18221fc$export$c2ab62c7bf24634(e) {
    while(!$783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$4d3fb11e950abb9e()))$783faa7ec18221fc$export$48cfd1e771a65c4f();
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$ef7acd7185315e22(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $783faa7ec18221fc$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $783faa7ec18221fc$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $783faa7ec18221fc$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $783faa7ec18221fc$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($783faa7ec18221fc$export$f8e21b1e77979a08(j += $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $783faa7ec18221fc$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $783faa7ec18221fc$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $783faa7ec18221fc$export$955ba06d119e085e($783faa7ec18221fc$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($783faa7ec18221fc$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$4a34f930e789283c($783faa7ec18221fc$export$4254d4e2b3745c4c($783faa7ec18221fc$export$48cfd1e771a65c4f(), $783faa7ec18221fc$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $783faa7ec18221fc$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $783faa7ec18221fc$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $783faa7ec18221fc$export$36776f635604f274(j) - l) $783faa7ec18221fc$export$10d8903dec122b9d(p > 32 ? $783faa7ec18221fc$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $783faa7ec18221fc$export$f8483753829ec8f3($783faa7ec18221fc$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $783faa7ec18221fc$export$10d8903dec122b9d(y = $783faa7ec18221fc$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $783faa7ec18221fc$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $783faa7ec18221fc$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $783faa7ec18221fc$export$98e6a39c04603d36(e, y, y, n && $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $783faa7ec18221fc$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $783faa7ec18221fc$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $783faa7ec18221fc$export$232faf9add678146() == 125) continue;
            }
            switch(j += $783faa7ec18221fc$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($783faa7ec18221fc$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($783faa7ec18221fc$export$4d3fb11e950abb9e() === 45) j += $783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$48cfd1e771a65c4f());
                    v = $783faa7ec18221fc$export$4d3fb11e950abb9e(), o = l = $783faa7ec18221fc$export$36776f635604f274(g = j += $783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $783faa7ec18221fc$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $783faa7ec18221fc$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $783faa7ec18221fc$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $783faa7ec18221fc$export$2f35ab04d2335697(e, v + 1, v = $783faa7ec18221fc$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $783faa7ec18221fc$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $783faa7ec18221fc$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, s === 0 ? $783faa7ec18221fc$export$aa3a2e812ca8570d : i, f, o, l);
}
function $783faa7ec18221fc$export$4a34f930e789283c(e, r, a) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$a29989082612d0d9, $783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$eba6f6f03b0a92e7()), $783faa7ec18221fc$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $783faa7ec18221fc$export$f8483753829ec8f3(e, r, a, n) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$527d108ccf083c2b, $783faa7ec18221fc$export$2f35ab04d2335697(e, 0, n), $783faa7ec18221fc$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $783faa7ec18221fc$export$82e9f45cca5ba907(n, c, s) {
    switch($783faa7ec18221fc$export$d6af199866bfb566(n, c)){
        case 5103:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $783faa7ec18221fc$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$2c0f367103c8d01c + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-$1$2" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-item-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-line-pack" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-grow", "") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-pack:$3" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-column-align" + $783faa7ec18221fc$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$783faa7ec18221fc$export$f8e21b1e77979a08(s, "span") ? $783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) : +$783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) - +$783faa7ec18221fc$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($783faa7ec18221fc$export$36776f635604f274(n) - 1 - c > 6) switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $783faa7ec18221fc$export$2c0f367103c8d01c + ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n, "stretch") ? $783faa7ec18221fc$export$82e9f45cca5ba907($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 6) === 121) return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, $783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + ($783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $783faa7ec18221fc$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $783faa7ec18221fc$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $783faa7ec18221fc$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $783faa7ec18221fc$export$a763edbf796b780a:
        case $783faa7ec18221fc$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $783faa7ec18221fc$export$a29989082612d0d9:
            return "";
        case $783faa7ec18221fc$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $783faa7ec18221fc$export$36776f635604f274(a = $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $783faa7ec18221fc$export$5a7767152ae0305f(e) {
    var r = $783faa7ec18221fc$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $783faa7ec18221fc$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $783faa7ec18221fc$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $783faa7ec18221fc$export$527d108ccf083c2b:
                n.return = $783faa7ec18221fc$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $783faa7ec18221fc$export$b44a8529a35fcb60:
                return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                    $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                        value: $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $783faa7ec18221fc$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $783faa7ec18221fc$export$aa3a2e812ca8570d:
                if (n.length) return $783faa7ec18221fc$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($783faa7ec18221fc$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $783faa7ec18221fc$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $783faa7ec18221fc$export$76a88f7de6507443(e) {
    switch(e.type){
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $783faa7ec18221fc$export$1be1fc439b849fdf($783faa7ec18221fc$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($783faa7ec18221fc$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $783faa7ec18221fc$export$2f35ab04d2335697(r, 1, $783faa7ec18221fc$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $783faa7ec18221fc$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $783faa7ec18221fc$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $783faa7ec18221fc$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("ieFqf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d469aa6647f846c1$export$2e2bcd8739ae039; });
var $d469aa6647f846c1$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRegister("8GHIh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65342784890a87de$export$2e2bcd8739ae039; });

var $adG4d = parcelRequire("adG4d");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $65342784890a87de$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($adG4d)))(targetComponent, sourceComponent);
};

});
parcelRegister("adG4d", function(module, exports) {
"use strict";

var $lhF4u = parcelRequire("lhF4u");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $770bbfe5492d7fd4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $770bbfe5492d7fd4$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $770bbfe5492d7fd4$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$TYPE_STATICS = {};
$770bbfe5492d7fd4$var$TYPE_STATICS[$lhF4u.ForwardRef] = $770bbfe5492d7fd4$var$FORWARD_REF_STATICS;
$770bbfe5492d7fd4$var$TYPE_STATICS[$lhF4u.Memo] = $770bbfe5492d7fd4$var$MEMO_STATICS;
function $770bbfe5492d7fd4$var$getStatics(component) {
    // React v16.11 and below
    if ($lhF4u.isMemo(component)) return $770bbfe5492d7fd4$var$MEMO_STATICS;
     // React v16.12 and above
    return $770bbfe5492d7fd4$var$TYPE_STATICS[component["$$typeof"]] || $770bbfe5492d7fd4$var$REACT_STATICS;
}
var $770bbfe5492d7fd4$var$defineProperty = Object.defineProperty;
var $770bbfe5492d7fd4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $770bbfe5492d7fd4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $770bbfe5492d7fd4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $770bbfe5492d7fd4$var$getPrototypeOf = Object.getPrototypeOf;
var $770bbfe5492d7fd4$var$objectPrototype = Object.prototype;
function $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($770bbfe5492d7fd4$var$objectPrototype) {
            var inheritedComponent = $770bbfe5492d7fd4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $770bbfe5492d7fd4$var$objectPrototype) $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $770bbfe5492d7fd4$var$getOwnPropertyNames(sourceComponent);
        if ($770bbfe5492d7fd4$var$getOwnPropertySymbols) keys = keys.concat($770bbfe5492d7fd4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $770bbfe5492d7fd4$var$getStatics(targetComponent);
        var sourceStatics = $770bbfe5492d7fd4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$770bbfe5492d7fd4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $770bbfe5492d7fd4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $770bbfe5492d7fd4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $770bbfe5492d7fd4$var$hoistNonReactStatics;

});
parcelRegister("lhF4u", function(module, exports) {
"use strict";

module.exports = (parcelRequire("g4WQO"));

});
parcelRegister("g4WQO", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $bb4aab9d21a68c2e$export$2b8d127b894957b9; }, function (v) { return $bb4aab9d21a68c2e$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $bb4aab9d21a68c2e$export$cea3a54a6425200c; }, function (v) { return $bb4aab9d21a68c2e$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $bb4aab9d21a68c2e$export$a7c73072b1a182ae; }, function (v) { return $bb4aab9d21a68c2e$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $bb4aab9d21a68c2e$export$9f27bc3417b4524d; }, function (v) { return $bb4aab9d21a68c2e$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $bb4aab9d21a68c2e$export$db77ccec0bb4ccac; }, function (v) { return $bb4aab9d21a68c2e$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35; }, function (v) { return $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bb4aab9d21a68c2e$export$ffb0004e005737fa; }, function (v) { return $bb4aab9d21a68c2e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $bb4aab9d21a68c2e$export$b624eff549462981; }, function (v) { return $bb4aab9d21a68c2e$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $bb4aab9d21a68c2e$export$7897aa7841a5380c; }, function (v) { return $bb4aab9d21a68c2e$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $bb4aab9d21a68c2e$export$602eac185826482c; }, function (v) { return $bb4aab9d21a68c2e$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $bb4aab9d21a68c2e$export$e2c29f18771995cb; }, function (v) { return $bb4aab9d21a68c2e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bb4aab9d21a68c2e$export$5f8d39834fd61797; }, function (v) { return $bb4aab9d21a68c2e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bb4aab9d21a68c2e$export$74bf444e3cd11ea5; }, function (v) { return $bb4aab9d21a68c2e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $bb4aab9d21a68c2e$export$92387174baf9b227; }, function (v) { return $bb4aab9d21a68c2e$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $bb4aab9d21a68c2e$export$ec112efeb987d9c6; }, function (v) { return $bb4aab9d21a68c2e$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $bb4aab9d21a68c2e$export$b706b080d889d2c9; }, function (v) { return $bb4aab9d21a68c2e$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $bb4aab9d21a68c2e$export$5be5a87408f70ddc; }, function (v) { return $bb4aab9d21a68c2e$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d; }, function (v) { return $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $bb4aab9d21a68c2e$export$455c2e768291efa6; }, function (v) { return $bb4aab9d21a68c2e$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $bb4aab9d21a68c2e$export$9522e17588c12572; }, function (v) { return $bb4aab9d21a68c2e$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $bb4aab9d21a68c2e$export$2110ac352bb060b9; }, function (v) { return $bb4aab9d21a68c2e$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $bb4aab9d21a68c2e$export$56885ab8b9c456ab; }, function (v) { return $bb4aab9d21a68c2e$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $bb4aab9d21a68c2e$export$d927fcb6adf8f9de; }, function (v) { return $bb4aab9d21a68c2e$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $bb4aab9d21a68c2e$export$b82d16f27459e05a; }, function (v) { return $bb4aab9d21a68c2e$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $bb4aab9d21a68c2e$export$522c17b4f5e123e8; }, function (v) { return $bb4aab9d21a68c2e$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6; }, function (v) { return $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $bb4aab9d21a68c2e$export$9b621391a187a31a; }, function (v) { return $bb4aab9d21a68c2e$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $bb4aab9d21a68c2e$export$f5bbd400c2f4426f; }, function (v) { return $bb4aab9d21a68c2e$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bb4aab9d21a68c2e$export$2b8d127b894957b9;
var $bb4aab9d21a68c2e$export$cea3a54a6425200c;
var $bb4aab9d21a68c2e$export$a7c73072b1a182ae;
var $bb4aab9d21a68c2e$export$9f27bc3417b4524d;
var $bb4aab9d21a68c2e$export$db77ccec0bb4ccac;
var $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35;
var $bb4aab9d21a68c2e$export$ffb0004e005737fa;
var $bb4aab9d21a68c2e$export$b624eff549462981;
var $bb4aab9d21a68c2e$export$7897aa7841a5380c;
var $bb4aab9d21a68c2e$export$602eac185826482c;
var $bb4aab9d21a68c2e$export$e2c29f18771995cb;
var $bb4aab9d21a68c2e$export$5f8d39834fd61797;
var $bb4aab9d21a68c2e$export$74bf444e3cd11ea5;
var $bb4aab9d21a68c2e$export$92387174baf9b227;
var $bb4aab9d21a68c2e$export$ec112efeb987d9c6;
var $bb4aab9d21a68c2e$export$b706b080d889d2c9;
var $bb4aab9d21a68c2e$export$5be5a87408f70ddc;
var $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d;
var $bb4aab9d21a68c2e$export$455c2e768291efa6;
var $bb4aab9d21a68c2e$export$9522e17588c12572;
var $bb4aab9d21a68c2e$export$2110ac352bb060b9;
var $bb4aab9d21a68c2e$export$56885ab8b9c456ab;
var $bb4aab9d21a68c2e$export$d927fcb6adf8f9de;
var $bb4aab9d21a68c2e$export$b82d16f27459e05a;
var $bb4aab9d21a68c2e$export$522c17b4f5e123e8;
var $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6;
var $bb4aab9d21a68c2e$export$9b621391a187a31a;
var $bb4aab9d21a68c2e$export$f5bbd400c2f4426f;
"use strict";
var $bb4aab9d21a68c2e$var$b = "function" === typeof Symbol && Symbol.for, $bb4aab9d21a68c2e$var$c = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.element") : 60103, $bb4aab9d21a68c2e$var$d = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.portal") : 60106, $bb4aab9d21a68c2e$var$e = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.fragment") : 60107, $bb4aab9d21a68c2e$var$f = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.strict_mode") : 60108, $bb4aab9d21a68c2e$var$g = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.profiler") : 60114, $bb4aab9d21a68c2e$var$h = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.provider") : 60109, $bb4aab9d21a68c2e$var$k = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.context") : 60110, $bb4aab9d21a68c2e$var$l = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.async_mode") : 60111, $bb4aab9d21a68c2e$var$m = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.concurrent_mode") : 60111, $bb4aab9d21a68c2e$var$n = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.forward_ref") : 60112, $bb4aab9d21a68c2e$var$p = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.suspense") : 60113, $bb4aab9d21a68c2e$var$q = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.suspense_list") : 60120, $bb4aab9d21a68c2e$var$r = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.memo") : 60115, $bb4aab9d21a68c2e$var$t = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.lazy") : 60116, $bb4aab9d21a68c2e$var$v = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.block") : 60121, $bb4aab9d21a68c2e$var$w = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.fundamental") : 60117, $bb4aab9d21a68c2e$var$x = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.responder") : 60118, $bb4aab9d21a68c2e$var$y = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.scope") : 60119;
function $bb4aab9d21a68c2e$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $bb4aab9d21a68c2e$var$c:
                switch(a = a.type, a){
                    case $bb4aab9d21a68c2e$var$l:
                    case $bb4aab9d21a68c2e$var$m:
                    case $bb4aab9d21a68c2e$var$e:
                    case $bb4aab9d21a68c2e$var$g:
                    case $bb4aab9d21a68c2e$var$f:
                    case $bb4aab9d21a68c2e$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $bb4aab9d21a68c2e$var$k:
                            case $bb4aab9d21a68c2e$var$n:
                            case $bb4aab9d21a68c2e$var$t:
                            case $bb4aab9d21a68c2e$var$r:
                            case $bb4aab9d21a68c2e$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $bb4aab9d21a68c2e$var$d:
                return u;
        }
    }
}
function $bb4aab9d21a68c2e$var$A(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$m;
}
$bb4aab9d21a68c2e$export$2b8d127b894957b9 = $bb4aab9d21a68c2e$var$l;
$bb4aab9d21a68c2e$export$cea3a54a6425200c = $bb4aab9d21a68c2e$var$m;
$bb4aab9d21a68c2e$export$a7c73072b1a182ae = $bb4aab9d21a68c2e$var$k;
$bb4aab9d21a68c2e$export$9f27bc3417b4524d = $bb4aab9d21a68c2e$var$h;
$bb4aab9d21a68c2e$export$db77ccec0bb4ccac = $bb4aab9d21a68c2e$var$c;
$bb4aab9d21a68c2e$export$8392c0c9d3dcbd35 = $bb4aab9d21a68c2e$var$n;
$bb4aab9d21a68c2e$export$ffb0004e005737fa = $bb4aab9d21a68c2e$var$e;
$bb4aab9d21a68c2e$export$b624eff549462981 = $bb4aab9d21a68c2e$var$t;
$bb4aab9d21a68c2e$export$7897aa7841a5380c = $bb4aab9d21a68c2e$var$r;
$bb4aab9d21a68c2e$export$602eac185826482c = $bb4aab9d21a68c2e$var$d;
$bb4aab9d21a68c2e$export$e2c29f18771995cb = $bb4aab9d21a68c2e$var$g;
$bb4aab9d21a68c2e$export$5f8d39834fd61797 = $bb4aab9d21a68c2e$var$f;
$bb4aab9d21a68c2e$export$74bf444e3cd11ea5 = $bb4aab9d21a68c2e$var$p;
$bb4aab9d21a68c2e$export$92387174baf9b227 = function(a) {
    return $bb4aab9d21a68c2e$var$A(a) || $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$l;
};
$bb4aab9d21a68c2e$export$ec112efeb987d9c6 = $bb4aab9d21a68c2e$var$A;
$bb4aab9d21a68c2e$export$b706b080d889d2c9 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$k;
};
$bb4aab9d21a68c2e$export$5be5a87408f70ddc = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$h;
};
$bb4aab9d21a68c2e$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bb4aab9d21a68c2e$var$c;
};
$bb4aab9d21a68c2e$export$455c2e768291efa6 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$n;
};
$bb4aab9d21a68c2e$export$9522e17588c12572 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$e;
};
$bb4aab9d21a68c2e$export$2110ac352bb060b9 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$t;
};
$bb4aab9d21a68c2e$export$56885ab8b9c456ab = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$r;
};
$bb4aab9d21a68c2e$export$d927fcb6adf8f9de = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$d;
};
$bb4aab9d21a68c2e$export$b82d16f27459e05a = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$g;
};
$bb4aab9d21a68c2e$export$522c17b4f5e123e8 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$f;
};
$bb4aab9d21a68c2e$export$1aabd8a0274ecfd6 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$p;
};
$bb4aab9d21a68c2e$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $bb4aab9d21a68c2e$var$e || a === $bb4aab9d21a68c2e$var$m || a === $bb4aab9d21a68c2e$var$g || a === $bb4aab9d21a68c2e$var$f || a === $bb4aab9d21a68c2e$var$p || a === $bb4aab9d21a68c2e$var$q || "object" === typeof a && null !== a && (a.$$typeof === $bb4aab9d21a68c2e$var$t || a.$$typeof === $bb4aab9d21a68c2e$var$r || a.$$typeof === $bb4aab9d21a68c2e$var$h || a.$$typeof === $bb4aab9d21a68c2e$var$k || a.$$typeof === $bb4aab9d21a68c2e$var$n || a.$$typeof === $bb4aab9d21a68c2e$var$w || a.$$typeof === $bb4aab9d21a68c2e$var$x || a.$$typeof === $bb4aab9d21a68c2e$var$y || a.$$typeof === $bb4aab9d21a68c2e$var$v);
};
$bb4aab9d21a68c2e$export$f5bbd400c2f4426f = $bb4aab9d21a68c2e$var$z;

});




parcelRegister("3hmGv", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $26348e4e5e8090bb$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $26348e4e5e8090bb$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $26348e4e5e8090bb$export$6f077d94b33a01aa; });
var $26348e4e5e8090bb$var$isBrowser = true;
function $26348e4e5e8090bb$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $26348e4e5e8090bb$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $26348e4e5e8090bb$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $26348e4e5e8090bb$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $26348e4e5e8090bb$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("c1zwb", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $8c11213058c26f89$export$6321afa313b251b5; });

var $171Pu = parcelRequire("171Pu");

var $amwve = parcelRequire("amwve");

var $cthCm = parcelRequire("cthCm");
var $8c11213058c26f89$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $8c11213058c26f89$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $8c11213058c26f89$var$hyphenateRegex = /[A-Z]|^ms/g;
var $8c11213058c26f89$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $8c11213058c26f89$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $8c11213058c26f89$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $8c11213058c26f89$var$processStyleName = /* #__PURE__ */ (0, $cthCm.default)(function(styleName) {
    return $8c11213058c26f89$var$isCustomProperty(styleName) ? styleName : styleName.replace($8c11213058c26f89$var$hyphenateRegex, "-$&").toLowerCase();
});
var $8c11213058c26f89$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($8c11213058c26f89$var$animationRegex, function(match, p1, p2) {
                $8c11213058c26f89$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $8c11213058c26f89$var$cursor
                };
                return p1;
            });
    }
    if ((0, $amwve.default)[key] !== 1 && !$8c11213058c26f89$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $8c11213058c26f89$var$contentValuePattern, $8c11213058c26f89$var$contentValues, $8c11213058c26f89$var$oldProcessStyleValue, $8c11213058c26f89$var$msPattern, $8c11213058c26f89$var$hyphenPattern, $8c11213058c26f89$var$hyphenatedCache;
var $8c11213058c26f89$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $8c11213058c26f89$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $8c11213058c26f89$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $8c11213058c26f89$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $8c11213058c26f89$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $8c11213058c26f89$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $8c11213058c26f89$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $8c11213058c26f89$var$cursor;
                var result = interpolation(mergedProps);
                $8c11213058c26f89$var$cursor = previousCursor;
                return $8c11213058c26f89$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $8c11213058c26f89$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $8c11213058c26f89$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($8c11213058c26f89$var$isProcessableValue(value)) string += $8c11213058c26f89$var$processStyleName(_key) + ":" + $8c11213058c26f89$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($8c11213058c26f89$var$isProcessableValue(value[_i])) string += $8c11213058c26f89$var$processStyleName(_key) + ":" + $8c11213058c26f89$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $8c11213058c26f89$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $8c11213058c26f89$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $8c11213058c26f89$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $8c11213058c26f89$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $8c11213058c26f89$var$cursor;
var $8c11213058c26f89$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $8c11213058c26f89$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $8c11213058c26f89$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $8c11213058c26f89$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $8c11213058c26f89$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $8c11213058c26f89$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $171Pu.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $8c11213058c26f89$var$cursor
    };
};

});
parcelRegister("171Pu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cf7dd2d70c55cf3$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $0cf7dd2d70c55cf3$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("amwve", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78b52bced097bc64$export$2e2bcd8739ae039; });
var $78b52bced097bc64$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("lSpak", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $fed2297e202d3641$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $fed2297e202d3641$export$811a713a7276cb9d; });

var $bh6RR = parcelRequire("bh6RR");
var $fed2297e202d3641$var$syncFallback = function syncFallback(create) {
    return create();
};
var $fed2297e202d3641$var$useInsertionEffect = $bh6RR.useInsertionEffect ? $bh6RR.useInsertionEffect : false;
var $fed2297e202d3641$export$db21c7ffa21794e7 = $fed2297e202d3641$var$useInsertionEffect || $fed2297e202d3641$var$syncFallback;
var $fed2297e202d3641$export$811a713a7276cb9d = $fed2297e202d3641$var$useInsertionEffect || $bh6RR.useLayoutEffect;

});





parcelRegister("kQHyY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2da74b5e2a0d09e$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");


var $k0FAg = parcelRequire("k0FAg");

var $lNmZA = parcelRequire("lNmZA");

var $ih19M = parcelRequire("ih19M");
"use client";
let $f2da74b5e2a0d09e$var$cache;
if (typeof document === "object") $f2da74b5e2a0d09e$var$cache = (0, $lNmZA.default)({
    key: "css",
    prepend: true
});
function $f2da74b5e2a0d09e$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $f2da74b5e2a0d09e$var$cache ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $k0FAg.C), {
        value: $f2da74b5e2a0d09e$var$cache,
        children: children
    }) : children;
}

});

parcelRegister("6SFe5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5027c3e86ace5307$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");


var $fPZvG = parcelRequire("fPZvG");

var $ih19M = parcelRequire("ih19M");
"use client";
function $5027c3e86ace5307$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $5027c3e86ace5307$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($5027c3e86ace5307$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $fPZvG.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("gIQ0a", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("gNE2F")).default; });

var $gNE2F = parcelRequire("gNE2F");

});

parcelRegister("57dtn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("bBoQ3")).default; });

var $bBoQ3 = parcelRequire("bBoQ3");
$parcel$exportWildcard(module.exports, $bBoQ3);

});
parcelRegister("bBoQ3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $87266ad5a002ddaf$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $87266ad5a002ddaf$export$2e2bcd8739ae039; });

var $8NbEM = parcelRequire("8NbEM");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $87266ad5a002ddaf$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $87266ad5a002ddaf$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($87266ad5a002ddaf$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || "";
}
function $87266ad5a002ddaf$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || $87266ad5a002ddaf$export$aad197c7121a6651(Component) || fallback;
}
function $87266ad5a002ddaf$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $87266ad5a002ddaf$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $87266ad5a002ddaf$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $87266ad5a002ddaf$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $8NbEM.ForwardRef:
            return $87266ad5a002ddaf$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $8NbEM.Memo:
            return $87266ad5a002ddaf$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("8NbEM", function(module, exports) {
"use strict";

module.exports = (parcelRequire("beRv0"));

});
parcelRegister("beRv0", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $82ea8056f8f7cd43$export$a7c73072b1a182ae; }, function (v) { return $82ea8056f8f7cd43$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $82ea8056f8f7cd43$export$9f27bc3417b4524d; }, function (v) { return $82ea8056f8f7cd43$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $82ea8056f8f7cd43$export$db77ccec0bb4ccac; }, function (v) { return $82ea8056f8f7cd43$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $82ea8056f8f7cd43$export$8392c0c9d3dcbd35; }, function (v) { return $82ea8056f8f7cd43$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $82ea8056f8f7cd43$export$ffb0004e005737fa; }, function (v) { return $82ea8056f8f7cd43$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $82ea8056f8f7cd43$export$b624eff549462981; }, function (v) { return $82ea8056f8f7cd43$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $82ea8056f8f7cd43$export$7897aa7841a5380c; }, function (v) { return $82ea8056f8f7cd43$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $82ea8056f8f7cd43$export$602eac185826482c; }, function (v) { return $82ea8056f8f7cd43$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $82ea8056f8f7cd43$export$e2c29f18771995cb; }, function (v) { return $82ea8056f8f7cd43$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $82ea8056f8f7cd43$export$5f8d39834fd61797; }, function (v) { return $82ea8056f8f7cd43$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $82ea8056f8f7cd43$export$74bf444e3cd11ea5; }, function (v) { return $82ea8056f8f7cd43$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $82ea8056f8f7cd43$export$998bcd577473dd93; }, function (v) { return $82ea8056f8f7cd43$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $82ea8056f8f7cd43$export$92387174baf9b227; }, function (v) { return $82ea8056f8f7cd43$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $82ea8056f8f7cd43$export$ec112efeb987d9c6; }, function (v) { return $82ea8056f8f7cd43$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $82ea8056f8f7cd43$export$b706b080d889d2c9; }, function (v) { return $82ea8056f8f7cd43$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $82ea8056f8f7cd43$export$5be5a87408f70ddc; }, function (v) { return $82ea8056f8f7cd43$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $82ea8056f8f7cd43$export$45a5e7f76e0caa8d; }, function (v) { return $82ea8056f8f7cd43$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $82ea8056f8f7cd43$export$455c2e768291efa6; }, function (v) { return $82ea8056f8f7cd43$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $82ea8056f8f7cd43$export$9522e17588c12572; }, function (v) { return $82ea8056f8f7cd43$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $82ea8056f8f7cd43$export$2110ac352bb060b9; }, function (v) { return $82ea8056f8f7cd43$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $82ea8056f8f7cd43$export$56885ab8b9c456ab; }, function (v) { return $82ea8056f8f7cd43$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $82ea8056f8f7cd43$export$d927fcb6adf8f9de; }, function (v) { return $82ea8056f8f7cd43$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $82ea8056f8f7cd43$export$b82d16f27459e05a; }, function (v) { return $82ea8056f8f7cd43$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $82ea8056f8f7cd43$export$522c17b4f5e123e8; }, function (v) { return $82ea8056f8f7cd43$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $82ea8056f8f7cd43$export$1aabd8a0274ecfd6; }, function (v) { return $82ea8056f8f7cd43$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $82ea8056f8f7cd43$export$3d6c20d97e46b957; }, function (v) { return $82ea8056f8f7cd43$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $82ea8056f8f7cd43$export$9b621391a187a31a; }, function (v) { return $82ea8056f8f7cd43$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $82ea8056f8f7cd43$export$f5bbd400c2f4426f; }, function (v) { return $82ea8056f8f7cd43$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $82ea8056f8f7cd43$export$a7c73072b1a182ae;
var $82ea8056f8f7cd43$export$9f27bc3417b4524d;
var $82ea8056f8f7cd43$export$db77ccec0bb4ccac;
var $82ea8056f8f7cd43$export$8392c0c9d3dcbd35;
var $82ea8056f8f7cd43$export$ffb0004e005737fa;
var $82ea8056f8f7cd43$export$b624eff549462981;
var $82ea8056f8f7cd43$export$7897aa7841a5380c;
var $82ea8056f8f7cd43$export$602eac185826482c;
var $82ea8056f8f7cd43$export$e2c29f18771995cb;
var $82ea8056f8f7cd43$export$5f8d39834fd61797;
var $82ea8056f8f7cd43$export$74bf444e3cd11ea5;
var $82ea8056f8f7cd43$export$998bcd577473dd93;
var $82ea8056f8f7cd43$export$92387174baf9b227;
var $82ea8056f8f7cd43$export$ec112efeb987d9c6;
var $82ea8056f8f7cd43$export$b706b080d889d2c9;
var $82ea8056f8f7cd43$export$5be5a87408f70ddc;
var $82ea8056f8f7cd43$export$45a5e7f76e0caa8d;
var $82ea8056f8f7cd43$export$455c2e768291efa6;
var $82ea8056f8f7cd43$export$9522e17588c12572;
var $82ea8056f8f7cd43$export$2110ac352bb060b9;
var $82ea8056f8f7cd43$export$56885ab8b9c456ab;
var $82ea8056f8f7cd43$export$d927fcb6adf8f9de;
var $82ea8056f8f7cd43$export$b82d16f27459e05a;
var $82ea8056f8f7cd43$export$522c17b4f5e123e8;
var $82ea8056f8f7cd43$export$1aabd8a0274ecfd6;
var $82ea8056f8f7cd43$export$3d6c20d97e46b957;
var $82ea8056f8f7cd43$export$9b621391a187a31a;
var $82ea8056f8f7cd43$export$f5bbd400c2f4426f;
"use strict";
var $82ea8056f8f7cd43$var$b = Symbol.for("react.element"), $82ea8056f8f7cd43$var$c = Symbol.for("react.portal"), $82ea8056f8f7cd43$var$d = Symbol.for("react.fragment"), $82ea8056f8f7cd43$var$e = Symbol.for("react.strict_mode"), $82ea8056f8f7cd43$var$f = Symbol.for("react.profiler"), $82ea8056f8f7cd43$var$g = Symbol.for("react.provider"), $82ea8056f8f7cd43$var$h = Symbol.for("react.context"), $82ea8056f8f7cd43$var$k = Symbol.for("react.server_context"), $82ea8056f8f7cd43$var$l = Symbol.for("react.forward_ref"), $82ea8056f8f7cd43$var$m = Symbol.for("react.suspense"), $82ea8056f8f7cd43$var$n = Symbol.for("react.suspense_list"), $82ea8056f8f7cd43$var$p = Symbol.for("react.memo"), $82ea8056f8f7cd43$var$q = Symbol.for("react.lazy"), $82ea8056f8f7cd43$var$t = Symbol.for("react.offscreen"), $82ea8056f8f7cd43$var$u;
$82ea8056f8f7cd43$var$u = Symbol.for("react.module.reference");
function $82ea8056f8f7cd43$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $82ea8056f8f7cd43$var$b:
                switch(a = a.type, a){
                    case $82ea8056f8f7cd43$var$d:
                    case $82ea8056f8f7cd43$var$f:
                    case $82ea8056f8f7cd43$var$e:
                    case $82ea8056f8f7cd43$var$m:
                    case $82ea8056f8f7cd43$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $82ea8056f8f7cd43$var$k:
                            case $82ea8056f8f7cd43$var$h:
                            case $82ea8056f8f7cd43$var$l:
                            case $82ea8056f8f7cd43$var$q:
                            case $82ea8056f8f7cd43$var$p:
                            case $82ea8056f8f7cd43$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $82ea8056f8f7cd43$var$c:
                return r;
        }
    }
}
$82ea8056f8f7cd43$export$a7c73072b1a182ae = $82ea8056f8f7cd43$var$h;
$82ea8056f8f7cd43$export$9f27bc3417b4524d = $82ea8056f8f7cd43$var$g;
$82ea8056f8f7cd43$export$db77ccec0bb4ccac = $82ea8056f8f7cd43$var$b;
$82ea8056f8f7cd43$export$8392c0c9d3dcbd35 = $82ea8056f8f7cd43$var$l;
$82ea8056f8f7cd43$export$ffb0004e005737fa = $82ea8056f8f7cd43$var$d;
$82ea8056f8f7cd43$export$b624eff549462981 = $82ea8056f8f7cd43$var$q;
$82ea8056f8f7cd43$export$7897aa7841a5380c = $82ea8056f8f7cd43$var$p;
$82ea8056f8f7cd43$export$602eac185826482c = $82ea8056f8f7cd43$var$c;
$82ea8056f8f7cd43$export$e2c29f18771995cb = $82ea8056f8f7cd43$var$f;
$82ea8056f8f7cd43$export$5f8d39834fd61797 = $82ea8056f8f7cd43$var$e;
$82ea8056f8f7cd43$export$74bf444e3cd11ea5 = $82ea8056f8f7cd43$var$m;
$82ea8056f8f7cd43$export$998bcd577473dd93 = $82ea8056f8f7cd43$var$n;
$82ea8056f8f7cd43$export$92387174baf9b227 = function() {
    return !1;
};
$82ea8056f8f7cd43$export$ec112efeb987d9c6 = function() {
    return !1;
};
$82ea8056f8f7cd43$export$b706b080d889d2c9 = function(a) {
    return $82ea8056f8f7cd43$var$v(a) === $82ea8056f8f7cd43$var$h;
};
$82ea8056f8f7cd43$export$5be5a87408f70ddc = function(a) {
    return $82ea8056f8f7cd43$var$v(a) === $82ea8056f8f7cd43$var$g;
};
$82ea8056f8f7cd43$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $82ea8056f8f7cd43$var$b;
};
$82ea8056f8f7cd43$export$455c2e768291efa6 = function(a) {
    return $82ea8056f8f7cd43$var$v(a) === $82ea8056f8f7cd43$var$l;
};
$82ea8056f8f7cd43$export$9522e17588c12572 = function(a) {
    return $82ea8056f8f7cd43$var$v(a) === $82ea8056f8f7cd43$var$d;
};
$82ea8056f8f7cd43$export$2110ac352bb060b9 = function(a) {
    return $82ea8056f8f7cd43$var$v(a) === $82ea8056f8f7cd43$var$q;
};
$82ea8056f8f7cd43$export$56885ab8b9c456ab = function(a) {
    return $82ea8056f8f7cd43$var$v(a) === $82ea8056f8f7cd43$var$p;
};
$82ea8056f8f7cd43$export$d927fcb6adf8f9de = function(a) {
    return $82ea8056f8f7cd43$var$v(a) === $82ea8056f8f7cd43$var$c;
};
$82ea8056f8f7cd43$export$b82d16f27459e05a = function(a) {
    return $82ea8056f8f7cd43$var$v(a) === $82ea8056f8f7cd43$var$f;
};
$82ea8056f8f7cd43$export$522c17b4f5e123e8 = function(a) {
    return $82ea8056f8f7cd43$var$v(a) === $82ea8056f8f7cd43$var$e;
};
$82ea8056f8f7cd43$export$1aabd8a0274ecfd6 = function(a) {
    return $82ea8056f8f7cd43$var$v(a) === $82ea8056f8f7cd43$var$m;
};
$82ea8056f8f7cd43$export$3d6c20d97e46b957 = function(a) {
    return $82ea8056f8f7cd43$var$v(a) === $82ea8056f8f7cd43$var$n;
};
$82ea8056f8f7cd43$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $82ea8056f8f7cd43$var$d || a === $82ea8056f8f7cd43$var$f || a === $82ea8056f8f7cd43$var$e || a === $82ea8056f8f7cd43$var$m || a === $82ea8056f8f7cd43$var$n || a === $82ea8056f8f7cd43$var$t || "object" === typeof a && null !== a && (a.$$typeof === $82ea8056f8f7cd43$var$q || a.$$typeof === $82ea8056f8f7cd43$var$p || a.$$typeof === $82ea8056f8f7cd43$var$g || a.$$typeof === $82ea8056f8f7cd43$var$h || a.$$typeof === $82ea8056f8f7cd43$var$l || a.$$typeof === $82ea8056f8f7cd43$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$82ea8056f8f7cd43$export$f5bbd400c2f4426f = $82ea8056f8f7cd43$var$v;

});




parcelRegister("kUSQI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("1zcRx")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("9HQTC")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("cxNpU")).default; });

var $1zcRx = parcelRequire("1zcRx");

var $9HQTC = parcelRequire("9HQTC");

var $cxNpU = parcelRequire("cxNpU");

});

parcelRegister("0jTcY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("f9NmP")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("f9NmP")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("gIHYf")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("8RAwN")).default; });

var $f9NmP = parcelRequire("f9NmP");

var $gIHYf = parcelRequire("gIHYf");

var $8RAwN = parcelRequire("8RAwN");

});


parcelRegister("OFmxN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0984c161637848f6$export$2e2bcd8739ae039; });

var $gcMmG = parcelRequire("gcMmG");
"use client";
const $0984c161637848f6$var$defaultTheme = (0, $gcMmG.default)();
var $0984c161637848f6$export$2e2bcd8739ae039 = $0984c161637848f6$var$defaultTheme;

});

parcelRegister("wllwT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06138c31a4420582$export$2e2bcd8739ae039; });
var $06138c31a4420582$export$2e2bcd8739ae039 = "$$material";

});


parcelRegister("cNBED", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9517450a96abd5a0$export$2e2bcd8739ae039; });

var $2DXvq = parcelRequire("2DXvq");

var $OFmxN = parcelRequire("OFmxN");

var $wllwT = parcelRequire("wllwT");
"use client";
function $9517450a96abd5a0$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $2DXvq.default)({
        props: props,
        name: name,
        defaultTheme: $OFmxN.default,
        themeId: (0, $wllwT.default)
    });
}

});
parcelRegister("2DXvq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ecd61e8c633a3b4$export$2e2bcd8739ae039; });

var $lGIi0 = parcelRequire("lGIi0");

var $dm6dP = parcelRequire("dm6dP");
"use client";
function $1ecd61e8c633a3b4$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $dm6dP.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $lGIi0.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("lGIi0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc9fe0280c7e2b01$export$2e2bcd8739ae039; });

var $3G5xx = parcelRequire("3G5xx");
function $fc9fe0280c7e2b01$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $3G5xx.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("3G5xx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ad99772796bb6cc$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");
function $2ad99772796bb6cc$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $4WYaH.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $4WYaH.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $4WYaH.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $2ad99772796bb6cc$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("dm6dP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b922804b7aaad5c$export$2e2bcd8739ae039; });

var $1zcRx = parcelRequire("1zcRx");

var $hDooL = parcelRequire("hDooL");
"use client";
const $9b922804b7aaad5c$export$35e57303dbd8a66 = (0, $1zcRx.default)();
function $9b922804b7aaad5c$var$useTheme(defaultTheme = $9b922804b7aaad5c$export$35e57303dbd8a66) {
    return (0, $hDooL.default)(defaultTheme);
}
var $9b922804b7aaad5c$export$2e2bcd8739ae039 = $9b922804b7aaad5c$var$useTheme;

});
parcelRegister("hDooL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd690132dfc7e660$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("fPZvG");
var $k0FAg = parcelRequire("k0FAg");
"use client";
function $cd690132dfc7e660$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $cd690132dfc7e660$var$useTheme(defaultTheme = null) {
    const contextTheme = $bh6RR.useContext((0, $k0FAg.T));
    return !contextTheme || $cd690132dfc7e660$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $cd690132dfc7e660$export$2e2bcd8739ae039 = $cd690132dfc7e660$var$useTheme;

});




parcelRegister("8gyMY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $604acdb59e07bb0a$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $dm6dP = parcelRequire("dm6dP");

var $OFmxN = parcelRequire("OFmxN");

var $wllwT = parcelRequire("wllwT");
"use client";
function $604acdb59e07bb0a$export$2e2bcd8739ae039() {
    const theme = (0, $dm6dP.default)((0, $OFmxN.default));
    return theme[0, $wllwT.default] || theme;
}

});

parcelRegister("5NdAq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $437c115ba9531921$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
"use client";
/**
 * @ignore - internal component.
 */ const $437c115ba9531921$var$GridContext = /*#__PURE__*/ $bh6RR.createContext();
var $437c115ba9531921$export$2e2bcd8739ae039 = $437c115ba9531921$var$GridContext;

});

parcelRegister("dv594", function(module, exports) {

$parcel$export(module.exports, "getGridUtilityClass", function () { return $9d42295ed08dd953$export$9973ac5fd0181f33; });
$parcel$export(module.exports, "default", function () { return $9d42295ed08dd953$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $9d42295ed08dd953$export$9973ac5fd0181f33(slot) {
    return (0, $XybB6.default)("MuiGrid", slot);
}
const $9d42295ed08dd953$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $9d42295ed08dd953$var$DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const $9d42295ed08dd953$var$WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const $9d42295ed08dd953$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $9d42295ed08dd953$var$gridClasses = (0, $igcUF.default)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    // spacings
    ...$9d42295ed08dd953$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$9d42295ed08dd953$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$9d42295ed08dd953$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$9d42295ed08dd953$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$9d42295ed08dd953$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$9d42295ed08dd953$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$9d42295ed08dd953$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$9d42295ed08dd953$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $9d42295ed08dd953$export$2e2bcd8739ae039 = $9d42295ed08dd953$var$gridClasses;

});
parcelRegister("igcUF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4b3bcd7a30606cb$export$2e2bcd8739ae039; });

var $XybB6 = parcelRequire("XybB6");
function $d4b3bcd7a30606cb$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $XybB6.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("XybB6", function(module, exports) {

$parcel$export(module.exports, "globalStateClasses", function () { return $0b300771171bce3b$export$9d6b9120de57c54; });
$parcel$export(module.exports, "default", function () { return $0b300771171bce3b$export$2e2bcd8739ae039; });

var $3TEEB = parcelRequire("3TEEB");
const $0b300771171bce3b$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $0b300771171bce3b$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $0b300771171bce3b$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $3TEEB.default).generate(componentName)}-${slot}`;
}
function $0b300771171bce3b$export$34c0130b1f3e8ae3(slot) {
    return $0b300771171bce3b$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("3TEEB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d660b2bff8b878a$export$2e2bcd8739ae039; });
const $2d660b2bff8b878a$var$defaultGenerator = (componentName)=>componentName;
const $2d660b2bff8b878a$var$createClassNameGenerator = ()=>{
    let generate = $2d660b2bff8b878a$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $2d660b2bff8b878a$var$defaultGenerator;
        }
    };
};
const $2d660b2bff8b878a$var$ClassNameGenerator = $2d660b2bff8b878a$var$createClassNameGenerator();
var $2d660b2bff8b878a$export$2e2bcd8739ae039 = $2d660b2bff8b878a$var$ClassNameGenerator;

});






parcelRegister("8TSey", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75f917fc48c896e9$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $gUBkJ = parcelRequire("gUBkJ");

var $ayVxz = parcelRequire("ayVxz");

var $6L9uu = parcelRequire("6L9uu");

var $idMAb = parcelRequire("idMAb");
var $ePCTs = parcelRequire("ePCTs");

var $aanxD = parcelRequire("aanxD");

var $d7fM7 = parcelRequire("d7fM7");

var $cxTnx = parcelRequire("cxTnx");

var $aM783 = parcelRequire("aM783");

var $daKAK = parcelRequire("daKAK");

var $ereuo = parcelRequire("ereuo");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");

var $jTwFz = parcelRequire("jTwFz");
const $75f917fc48c896e9$var$CalendarList = ()=>{
    const { state: state, dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [startDate, setStartDate] = (0, $bh6RR.useState)(null);
    const [endDate, setEndDate] = (0, $bh6RR.useState)(null);
    const { data: data, loading: loading } = (0, $hjfla.useEventsQuery)();
    const [allEvents, setAllEvents] = (0, $bh6RR.useState)([]);
    const [filteredEvents, setFilteredEvents] = (0, $bh6RR.useState)([]);
    const [deleteEvent] = (0, $hjfla.useDeleteEventMutation)();
    const [openEventForm, setOpenEventForm] = (0, $bh6RR.useState)(false);
    const [isEditMode, setIsEditMode] = (0, $bh6RR.useState)(false);
    const [selectedEvent, setSelectedEvent] = (0, $bh6RR.useState)(null);
    const canCreate = (0, $dqRXb.canUserCreate)(state.user, (0, $gUBkJ.Types).CalendarEvent);
    const minAllowedDate = new Date(2000, 0, 1);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            setAllEvents(data.result);
            setFilteredEvents(data.result);
        }
    }, [
        data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (allEvents.length > 0) {
            let filteredByDate = allEvents;
            const currentStartDate = startDate ? new Date(startDate) : null;
            const currentEndDate = endDate ? new Date(endDate) : null;
            const cleanStartDate = currentStartDate ? new Date(currentStartDate.getFullYear(), currentStartDate.getMonth(), currentStartDate.getDate(), 0, 0, 0).getTime() : null;
            const cleanEndDate = currentEndDate ? new Date(currentEndDate.getFullYear(), currentEndDate.getMonth(), currentEndDate.getDate() + 1, 0, 0, 0).getTime() : null;
            if (currentStartDate && currentEndDate) {
                if (currentStartDate > currentEndDate) filteredByDate = allEvents.filter((e)=>new Date(parseInt(e.start_date)).getTime() >= cleanStartDate);
                else filteredByDate = allEvents.filter((e)=>{
                    const scheduledDate = new Date(parseInt(e.start_date)).getTime();
                    return scheduledDate >= cleanStartDate && scheduledDate < cleanEndDate;
                });
            } else if (currentEndDate && !currentStartDate) filteredByDate = allEvents.filter((e)=>new Date(parseInt(e.end_date)).getTime() < cleanEndDate);
            else if (currentStartDate && !currentEndDate) filteredByDate = allEvents.filter((e)=>new Date(parseInt(e.start_date)).getTime() >= cleanStartDate);
            setFilteredEvents(filteredByDate);
        }
    }, [
        startDate,
        endDate
    ]);
    const handleDelete = (rowData)=>{
        if (!rowData) return;
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteEvent({
            variables: {
                id: parseInt(rowData.id)
            },
            update (cache) {
                const eventQuery = cache.readQuery({
                    query: (0, $hjfla.EventsDocument)
                });
                if (eventQuery.result) {
                    const cacheEventIndex = eventQuery.result.findIndex((e)=>e?.id === rowData.id);
                    if (cacheEventIndex > -1) {
                        const data = eventQuery.result.filter((e)=>e?.id !== rowData.id);
                        cache.writeQuery({
                            query: (0, $hjfla.EventsDocument),
                            data: {
                                result: data
                            }
                        });
                    }
                }
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Event deleted ${rowData.title}`,
                        severity: "success"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: e.message,
                    severity: "error"
                }
            });
        });
    };
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${rowData.title}?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const formatDate = (rowData, name)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return rowData[name] ? // @ts-ignore
        (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(parseInt(rowData[name])).format((0, $aM783.DATE_TIME_FORMATS).DATE_AND_TIME) : "";
    };
    const renderExportEventColumn = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: `export-event-${rowData.id}`,
            onClick: ()=>handleExportPressed(rowData),
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aanxD.default), {
                style: {
                    color: (0, $6L9uu.Colors).skyBlue
                }
            })
        });
    };
    const handleCloseForm = ()=>{
        setIsEditMode(false);
        setOpenEventForm(false);
        setSelectedEvent(null);
    };
    const handleDetails = (rowData)=>{
        setSelectedEvent(rowData);
        setOpenEventForm(true);
        setIsEditMode(true);
    };
    const handleExportPressed = (rowData)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const cal = (0, $ereuo.ics)();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        cal.addEvent(rowData.title, rowData.description, rowData.location, new Date(parseInt(rowData.start_date)), new Date(parseInt(rowData.end_date)));
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        cal.download(rowData.title);
    };
    const openCreateEventMethod = ()=>{
        setOpenEventForm(true);
    };
    const exportCurrentCalendarEvents = ()=>{
        const fileName = `Calendar events${startDate ? ` from ${(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(startDate).format("YYYY_MM_DD")}` : ""}${endDate ? ` until ${(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(endDate).format("YYYY_MM_DD")}` : ""}`;
        const csvData = filteredEvents.map((r)=>({
                Title: r.title,
                Location: r?.location,
                Description: r?.description,
                Creator: r.creator.fullName,
                Company: r.company.name,
                Type: r.type.type,
                "Start Date/Time": (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(parseInt(r.start_date)).format((0, $aM783.DATE_TIME_FORMATS).DATE_AND_TIME),
                "End Date/Time": (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(parseInt(r.end_date)).format((0, $aM783.DATE_TIME_FORMATS).DATE_AND_TIME)
            }));
        (0, $daKAK.exportDataAsExcel)(csvData, fileName);
    };
    const columns = [
        {
            title: "Details",
            width: 63.5,
            sorting: false
        },
        {
            title: "Title",
            width: 256,
            field: "title"
        },
        {
            title: "Location",
            width: 256.5,
            field: "location"
        },
        {
            title: "Creator",
            width: 214.5,
            field: "creator.fullName"
        },
        {
            title: "Company",
            width: 325.5,
            field: "company.name"
        },
        {
            title: "Type",
            width: 209.5,
            field: "type.type"
        },
        {
            title: "Start date/time",
            width: 161,
            field: "start_date",
            type: "date",
            render: (rowData)=>formatDate(rowData, "start_date")
        },
        {
            title: "End date/time",
            width: 163,
            field: "end_date",
            type: "date",
            render: (rowData)=>formatDate(rowData, "end_date")
        },
        {
            title: "Export",
            width: 50,
            sorting: false,
            render: renderExportEventColumn
        },
        {
            title: "Remove",
            width: 71.5,
            sorting: false
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "overviewPage",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                    columns: columns,
                    data: filteredEvents,
                    loading: loading,
                    handleRemove: handleRemove,
                    handleDetails: handleDetails,
                    pageSize: 10,
                    createButtonProps: {
                        id: "create-event-button",
                        onClick: openCreateEventMethod,
                        text: "Create Event",
                        disabled: !canCreate
                    },
                    exportButtonProps: {
                        id: "export-calendar-button",
                        onClick: exportCurrentCalendarEvents
                    },
                    additionalFilters: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        container: true,
                        style: {
                            maxWidth: "350px"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $e4eIN.LocalizationProvider), {
                            dateAdapter: (0, $1Dn8S.AdapterDateFns),
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                                    item: true,
                                    xs: 6,
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                        id: "start-date-picker",
                                        label: "Start Date",
                                        value: startDate,
                                        clearable: true,
                                        onChange: (date)=>setStartDate(date),
                                        sx: {
                                            maxWidth: "175px",
                                            marginRight: "10px"
                                        },
                                        minDate: minAllowedDate
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                                    xs: 6,
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                        id: "end-date-picker",
                                        label: "End Date",
                                        value: endDate,
                                        clearable: true,
                                        onChange: (date)=>setEndDate(date),
                                        minDate: startDate || minAllowedDate,
                                        sx: {
                                            maxWidth: "175px",
                                            marginLeft: "10px"
                                        }
                                    })
                                })
                            ]
                        })
                    })
                }),
                openEventForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $jTwFz.default), {
                    handleClose: handleCloseForm,
                    calendarEvent: selectedEvent,
                    isEditMode: isEditMode
                })
            ]
        })
    });
};
var $75f917fc48c896e9$export$2e2bcd8739ae039 = $75f917fc48c896e9$var$CalendarList;

});
parcelRegister("dqRXb", function(module, exports) {

$parcel$export(module.exports, "canUserDelete", function () { return $5036724d64ed6f1b$export$2e61d2b120398c0e; });
$parcel$export(module.exports, "canUserCreate", function () { return $5036724d64ed6f1b$export$9afda9425a9b03d2; });
$parcel$export(module.exports, "canUserEdit", function () { return $5036724d64ed6f1b$export$6b5b44595778eef8; });

var $8Oiq1 = parcelRequire("8Oiq1");

var $gUBkJ = parcelRequire("gUBkJ");
const $5036724d64ed6f1b$var$allRoles = [
    (0, $8Oiq1.Roles).Admin,
    (0, $8Oiq1.Roles).InvoiceEditor,
    (0, $8Oiq1.Roles).EsgOperator,
    (0, $8Oiq1.Roles).IndexOperator,
    (0, $8Oiq1.Roles).Operator,
    (0, $8Oiq1.Roles).MarketingOperator
];
const $5036724d64ed6f1b$var$crudRights = {
    Product: {
        create: [
            (0, $8Oiq1.Roles).Admin
        ],
        edit: [
            (0, $8Oiq1.Roles).Admin
        ],
        delete: [
            (0, $8Oiq1.Roles).Admin
        ]
    },
    Company: {
        create: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).InvoiceEditor
        ],
        edit: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).InvoiceEditor
        ],
        delete: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).InvoiceEditor
        ]
    },
    Membership: {
        create: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).InvoiceEditor
        ],
        edit: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).InvoiceEditor
        ],
        delete: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).InvoiceEditor
        ]
    },
    Invoice: {
        create: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).InvoiceEditor
        ],
        edit: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).InvoiceEditor
        ],
        delete: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).InvoiceEditor
        ]
    },
    Contact: {
        create: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).InvoiceEditor
        ],
        edit: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).InvoiceEditor
        ],
        delete: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).InvoiceEditor
        ]
    },
    Template: {
        create: [
            ...$5036724d64ed6f1b$var$allRoles
        ],
        delete: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).MarketingOperator
        ],
        edit: [
            ...$5036724d64ed6f1b$var$allRoles
        ]
    },
    RecipientList: {
        create: [
            ...$5036724d64ed6f1b$var$allRoles
        ],
        edit: [
            ...$5036724d64ed6f1b$var$allRoles
        ],
        delete: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).MarketingOperator
        ]
    },
    Scheduler: {
        create: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).IndexOperator,
            (0, $8Oiq1.Roles).MarketingOperator
        ],
        delete: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).IndexOperator,
            (0, $8Oiq1.Roles).MarketingOperator
        ],
        edit: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).IndexOperator,
            (0, $8Oiq1.Roles).MarketingOperator
        ]
    },
    CalendarEvent: {
        create: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).InvoiceEditor,
            (0, $8Oiq1.Roles).IndexOperator,
            (0, $8Oiq1.Roles).MarketingOperator
        ],
        delete: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).InvoiceEditor,
            (0, $8Oiq1.Roles).IndexOperator,
            (0, $8Oiq1.Roles).MarketingOperator
        ],
        edit: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).InvoiceEditor,
            (0, $8Oiq1.Roles).IndexOperator,
            (0, $8Oiq1.Roles).MarketingOperator
        ]
    },
    Etf: {
        create: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).IndexOperator
        ],
        delete: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).IndexOperator
        ],
        edit: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).IndexOperator
        ]
    },
    Stock: {
        create: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).IndexOperator
        ],
        delete: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).IndexOperator
        ],
        edit: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).IndexOperator
        ]
    },
    Index: {
        create: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).IndexOperator
        ],
        delete: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).IndexOperator
        ],
        edit: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).IndexOperator
        ]
    },
    IndexSerie: {
        create: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).IndexOperator
        ],
        delete: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).IndexOperator
        ],
        edit: [
            (0, $8Oiq1.Roles).Admin,
            (0, $8Oiq1.Roles).IndexOperator
        ]
    }
};
const $5036724d64ed6f1b$var$restrictedTypes = [
    (0, $gUBkJ.Types).Membership,
    (0, $gUBkJ.Types).Company,
    (0, $gUBkJ.Types).Contact,
    (0, $gUBkJ.Types).Invoice,
    (0, $gUBkJ.Types).Product,
    (0, $gUBkJ.Types).Template,
    (0, $gUBkJ.Types).RecipientList,
    (0, $gUBkJ.Types).Scheduler,
    (0, $gUBkJ.Types).CalendarEvent,
    (0, $gUBkJ.Types).ETF,
    (0, $gUBkJ.Types).Stock,
    (0, $gUBkJ.Types).Index,
    (0, $gUBkJ.Types).IndexSeries
];
const $5036724d64ed6f1b$var$canPerformAction = (userRoles, allowedRoles)=>{
    const result = userRoles?.some((r)=>allowedRoles.includes(r));
    return result ?? false;
};
const $5036724d64ed6f1b$export$2e61d2b120398c0e = (user, item)=>{
    if (item && $5036724d64ed6f1b$var$restrictedTypes.includes(item)) {
        const allowedRoles = $5036724d64ed6f1b$var$crudRights[item]?.delete || [];
        return $5036724d64ed6f1b$var$canPerformAction(user.data?.roles, allowedRoles);
    }
    return true;
};
const $5036724d64ed6f1b$export$9afda9425a9b03d2 = (user, item)=>{
    const allowedRoles = $5036724d64ed6f1b$var$crudRights[item]?.create || [];
    return $5036724d64ed6f1b$var$canPerformAction(user.data?.roles, allowedRoles);
};
const $5036724d64ed6f1b$export$6b5b44595778eef8 = (user, item)=>{
    const allowedRoles = $5036724d64ed6f1b$var$crudRights[item]?.edit || [];
    return $5036724d64ed6f1b$var$canPerformAction(user.data?.roles, allowedRoles);
};

});
parcelRegister("8Oiq1", function(module, exports) {

$parcel$export(module.exports, "Roles", function () { return $bd5c68dd0f7f1fa5$export$d1d9e451800db729; });
$parcel$export(module.exports, "Categories", function () { return $bd5c68dd0f7f1fa5$export$e1e795cef0e670e6; });
var $bd5c68dd0f7f1fa5$export$d1d9e451800db729;
(function(Roles) {
    Roles["Admin"] = "admin";
    Roles["InvoiceEditor"] = "invoice_editor";
    Roles["EsgOperator"] = "esg_operator";
    Roles["IndexOperator"] = "index_operator";
    Roles["Operator"] = "operator";
    Roles["MarketingOperator"] = "marketing_operator";
})($bd5c68dd0f7f1fa5$export$d1d9e451800db729 || ($bd5c68dd0f7f1fa5$export$d1d9e451800db729 = {}));
var $bd5c68dd0f7f1fa5$export$e1e795cef0e670e6;
(function(Categories) {
    Categories["Comminications"] = "Communications";
    Categories["Research"] = "Research";
})($bd5c68dd0f7f1fa5$export$e1e795cef0e670e6 || ($bd5c68dd0f7f1fa5$export$e1e795cef0e670e6 = {}));

});

parcelRegister("gUBkJ", function(module, exports) {

$parcel$export(module.exports, "Types", function () { return $0f6d1a2dc74d85eb$export$4624c240901a6889; });
var $0f6d1a2dc74d85eb$export$4624c240901a6889;
(function(Types) {
    Types["Membership"] = "Membership";
    Types["Contact"] = "Contact";
    Types["Company"] = "Company";
    Types["Product"] = "Product";
    Types["Invoice"] = "Invoice";
    Types["Address"] = "Address";
    Types["User"] = "User";
    Types["Template"] = "Template";
    Types["RecipientList"] = "RecipientList";
    Types["Scheduler"] = "Scheduler";
    Types["CalendarEvent"] = "CalendarEvent";
    Types["ETF"] = "Etf";
    Types["Stock"] = "Stock";
    Types["Index"] = "Index";
    Types["IndexSeries"] = "IndexSerie";
    Types["Nav"] = "Nav";
    Types["DividendGross"] = "DividendGross";
    Types["HistoryLtv"] = "HistoryLtv";
    Types["HistoryKpi"] = "HistoryKpi";
    Types["HistoryAward"] = "HistoryAward";
    Types["AllocationSector"] = "AllocationSector";
    Types["HistoryAllocationCountry"] = "HistoryAllocationCountry";
    Types["HistoryRecalc"] = "HistoryRecalc";
})($0f6d1a2dc74d85eb$export$4624c240901a6889 || ($0f6d1a2dc74d85eb$export$4624c240901a6889 = {}));

});


parcelRegister("idMAb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d43f206865e0cc7f$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $3G5xx = parcelRequire("3G5xx");

var $7J7Kn = parcelRequire("7J7Kn");

var $cG3EF = parcelRequire("cG3EF");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $aEoM0 = parcelRequire("aEoM0");

var $fGH8N = parcelRequire("fGH8N");

var $5Hj8x = parcelRequire("5Hj8x");

var $lGzv4 = parcelRequire("lGzv4");

var $14scH = parcelRequire("14scH");

var $ih19M = parcelRequire("ih19M");
"use client";
const $d43f206865e0cc7f$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $d43f206865e0cc7f$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $fGH8N.default)(color)}`,
            `size${(0, $fGH8N.default)(size)}`,
            `${variant}Size${(0, $fGH8N.default)(size)}`,
            `color${(0, $fGH8N.default)(color)}`,
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "icon",
            "startIcon",
            `iconSize${(0, $fGH8N.default)(size)}`
        ],
        endIcon: [
            "icon",
            "endIcon",
            `iconSize${(0, $fGH8N.default)(size)}`
        ]
    };
    const composedClasses = (0, $7J7Kn.default)(slots, (0, $5Hj8x.getButtonUtilityClass), classes);
    return (0, $4WYaH.default)({}, classes, composedClasses);
};
const $d43f206865e0cc7f$var$commonIconStyles = (ownerState)=>(0, $4WYaH.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $d43f206865e0cc7f$var$ButtonRoot = (0, $g4l1t.default)((0, $aEoM0.default), {
    shouldForwardProp: (prop)=>(0, $g4l1t.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $fGH8N.default)(ownerState.color)}`],
            styles[`size${(0, $fGH8N.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $fGH8N.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $4WYaH.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $4WYaH.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cG3EF.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cG3EF.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cG3EF.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $4WYaH.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $5Hj8x.default).focusVisible}`]: (0, $4WYaH.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $5Hj8x.default).disabled}`]: (0, $4WYaH.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $cG3EF.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $5Hj8x.default).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $5Hj8x.default).disabled}`]: {
            boxShadow: "none"
        }
    });
const $d43f206865e0cc7f$var$ButtonStartIcon = (0, $g4l1t.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $fGH8N.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $d43f206865e0cc7f$var$commonIconStyles(ownerState)));
const $d43f206865e0cc7f$var$ButtonEndIcon = (0, $g4l1t.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $fGH8N.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $d43f206865e0cc7f$var$commonIconStyles(ownerState)));
const $d43f206865e0cc7f$var$Button = /*#__PURE__*/ $bh6RR.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $bh6RR.useContext((0, $lGzv4.default));
    const buttonGroupButtonContextPositionClassName = $bh6RR.useContext((0, $14scH.default));
    const resolvedProps = (0, $3G5xx.default)(contextProps, inProps);
    const props = (0, $cNBED.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $hCIyK.default)(props, $d43f206865e0cc7f$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $d43f206865e0cc7f$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $ih19M.jsx)($d43f206865e0cc7f$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $ih19M.jsx)($d43f206865e0cc7f$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $ih19M.jsxs)($d43f206865e0cc7f$var$ButtonRoot, (0, $4WYaH.default)({
        ownerState: ownerState,
        className: (0, $aPsoC.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $aPsoC.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $d43f206865e0cc7f$export$2e2bcd8739ae039 = $d43f206865e0cc7f$var$Button;

});
parcelRegister("aEoM0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c10db4061610272$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");



var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $erAkb = parcelRequire("erAkb");

var $8M7SI = parcelRequire("8M7SI");

var $kVG1h = parcelRequire("kVG1h");

var $h0tYH = parcelRequire("h0tYH");

var $3jw06 = parcelRequire("3jw06");

var $ih19M = parcelRequire("ih19M");
"use client";
const $7c10db4061610272$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $7c10db4061610272$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $7J7Kn.default)(slots, (0, $3jw06.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $7c10db4061610272$export$7ec0dcc5e3cdcd36 = (0, $g4l1t.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $3jw06.default).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $7c10db4061610272$var$ButtonBase = /*#__PURE__*/ $bh6RR.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $hCIyK.default)(props, $7c10db4061610272$var$_excluded);
    const buttonRef = $bh6RR.useRef(null);
    const rippleRef = $bh6RR.useRef(null);
    const handleRippleRef = (0, $erAkb.default)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $kVG1h.default)();
    const [focusVisible, setFocusVisible] = $bh6RR.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $bh6RR.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $bh6RR.useState(false);
    $bh6RR.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $bh6RR.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $8M7SI.default)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $8M7SI.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $bh6RR.useRef(false);
    const handleKeyDown = (0, $8M7SI.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $8M7SI.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $erAkb.default)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $4WYaH.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $7c10db4061610272$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($7c10db4061610272$export$7ec0dcc5e3cdcd36, (0, $4WYaH.default)({
        as: ComponentProp,
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $ih19M.jsx)((0, $h0tYH.default), (0, $4WYaH.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $7c10db4061610272$export$2e2bcd8739ae039 = $7c10db4061610272$var$ButtonBase;

});
parcelRegister("erAkb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a83fc3979212c585$export$2e2bcd8739ae039; });

var $fpwfv = parcelRequire("fpwfv");
"use client";
var $a83fc3979212c585$export$2e2bcd8739ae039 = (0, $fpwfv.default);

});
parcelRegister("fpwfv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b38234d2d8df5583$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $gzLMq = parcelRequire("gzLMq");
"use client";
function $b38234d2d8df5583$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $bh6RR.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $gzLMq.default)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});
parcelRegister("gzLMq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c114fa5ac6b5fdd2$export$2e2bcd8739ae039; });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $c114fa5ac6b5fdd2$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}

});



parcelRegister("8M7SI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6638eb82ff2b4a1f$export$2e2bcd8739ae039; });

var $5EGAX = parcelRequire("5EGAX");
"use client";
var $6638eb82ff2b4a1f$export$2e2bcd8739ae039 = (0, $5EGAX.default);

});
parcelRegister("5EGAX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41e1bab13c0f46b1$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $joJqx = parcelRequire("joJqx");
"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $41e1bab13c0f46b1$var$useEventCallback(fn) {
    const ref = $bh6RR.useRef(fn);
    (0, $joJqx.default)(()=>{
        ref.current = fn;
    });
    return $bh6RR.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $41e1bab13c0f46b1$export$2e2bcd8739ae039 = $41e1bab13c0f46b1$var$useEventCallback;

});
parcelRegister("joJqx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1f37f0f40864ef6$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $e1f37f0f40864ef6$var$useEnhancedEffect = typeof window !== "undefined" ? $bh6RR.useLayoutEffect : $bh6RR.useEffect;
var $e1f37f0f40864ef6$export$2e2bcd8739ae039 = $e1f37f0f40864ef6$var$useEnhancedEffect;

});



parcelRegister("kVG1h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3c9b9c4f8ebb7e8$export$2e2bcd8739ae039; });

var $81QPn = parcelRequire("81QPn");
"use client";
var $f3c9b9c4f8ebb7e8$export$2e2bcd8739ae039 = (0, $81QPn.default);

});
parcelRegister("81QPn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d87652e0fc292cc$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $edgJc = parcelRequire("edgJc");
"use client";
let $5d87652e0fc292cc$var$hadKeyboardEvent = true;
let $5d87652e0fc292cc$var$hadFocusVisibleRecently = false;
const $5d87652e0fc292cc$var$hadFocusVisibleRecentlyTimeout = new (0, $edgJc.Timeout)();
const $5d87652e0fc292cc$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $5d87652e0fc292cc$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $5d87652e0fc292cc$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $5d87652e0fc292cc$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $5d87652e0fc292cc$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $5d87652e0fc292cc$var$handlePointerDown() {
    $5d87652e0fc292cc$var$hadKeyboardEvent = false;
}
function $5d87652e0fc292cc$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($5d87652e0fc292cc$var$hadFocusVisibleRecently) $5d87652e0fc292cc$var$hadKeyboardEvent = true;
    }
}
function $5d87652e0fc292cc$var$prepare(doc) {
    doc.addEventListener("keydown", $5d87652e0fc292cc$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $5d87652e0fc292cc$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $5d87652e0fc292cc$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $5d87652e0fc292cc$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $5d87652e0fc292cc$var$handleVisibilityChange, true);
}
function $5d87652e0fc292cc$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $5d87652e0fc292cc$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $5d87652e0fc292cc$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $5d87652e0fc292cc$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $5d87652e0fc292cc$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $5d87652e0fc292cc$var$handleVisibilityChange, true);
}
function $5d87652e0fc292cc$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $5d87652e0fc292cc$var$hadKeyboardEvent || $5d87652e0fc292cc$var$focusTriggersKeyboardModality(target);
}
function $5d87652e0fc292cc$export$2e2bcd8739ae039() {
    const ref = $bh6RR.useCallback((node)=>{
        if (node != null) $5d87652e0fc292cc$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $bh6RR.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $5d87652e0fc292cc$var$hadFocusVisibleRecently = true;
            $5d87652e0fc292cc$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $5d87652e0fc292cc$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($5d87652e0fc292cc$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}

});
parcelRegister("edgJc", function(module, exports) {

$parcel$export(module.exports, "Timeout", function () { return $a58f416609180600$export$786b4da70f00938b; });
$parcel$export(module.exports, "default", function () { return $a58f416609180600$export$2e2bcd8739ae039; });

var $eTspR = parcelRequire("eTspR");

var $3B5TA = parcelRequire("3B5TA");
"use client";
class $a58f416609180600$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $a58f416609180600$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $a58f416609180600$export$2e2bcd8739ae039() {
    const timeout = (0, $eTspR.default)($a58f416609180600$export$786b4da70f00938b.create).current;
    (0, $3B5TA.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("eTspR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad7c3e98e7821fe3$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
"use client";
const $ad7c3e98e7821fe3$var$UNINITIALIZED = {};
function $ad7c3e98e7821fe3$export$2e2bcd8739ae039(init, initArg) {
    const ref = $bh6RR.useRef($ad7c3e98e7821fe3$var$UNINITIALIZED);
    if (ref.current === $ad7c3e98e7821fe3$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});

parcelRegister("3B5TA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29e966884c7338f4$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
"use client";
const $29e966884c7338f4$var$EMPTY = [];
function $29e966884c7338f4$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $bh6RR.useEffect(fn, $29e966884c7338f4$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});




parcelRegister("h0tYH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c619b0c04884f58c$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $bm1aQ = parcelRequire("bm1aQ");

var $aPsoC = parcelRequire("aPsoC");

var $fPZvG = parcelRequire("fPZvG");

var $edgJc = parcelRequire("edgJc");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $ixTys = parcelRequire("ixTys");

var $e7JbL = parcelRequire("e7JbL");

var $ih19M = parcelRequire("ih19M");
"use client";
const $c619b0c04884f58c$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $c619b0c04884f58c$var$_ = (t)=>t, $c619b0c04884f58c$var$_t, $c619b0c04884f58c$var$_t2, $c619b0c04884f58c$var$_t3, $c619b0c04884f58c$var$_t4;
const $c619b0c04884f58c$var$DURATION = 550;
const $c619b0c04884f58c$export$95d0c9356b2231a3 = 80;
const $c619b0c04884f58c$var$enterKeyframe = (0, $fPZvG.keyframes)($c619b0c04884f58c$var$_t || ($c619b0c04884f58c$var$_t = $c619b0c04884f58c$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $c619b0c04884f58c$var$exitKeyframe = (0, $fPZvG.keyframes)($c619b0c04884f58c$var$_t2 || ($c619b0c04884f58c$var$_t2 = $c619b0c04884f58c$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $c619b0c04884f58c$var$pulsateKeyframe = (0, $fPZvG.keyframes)($c619b0c04884f58c$var$_t3 || ($c619b0c04884f58c$var$_t3 = $c619b0c04884f58c$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $c619b0c04884f58c$export$f6b7418508c72c25 = (0, $g4l1t.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $c619b0c04884f58c$export$676cfe7b12693c4b = (0, $g4l1t.default)((0, $ixTys.default), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($c619b0c04884f58c$var$_t4 || ($c619b0c04884f58c$var$_t4 = $c619b0c04884f58c$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $e7JbL.default).rippleVisible, $c619b0c04884f58c$var$enterKeyframe, $c619b0c04884f58c$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $e7JbL.default).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $e7JbL.default).child, (0, $e7JbL.default).childLeaving, $c619b0c04884f58c$var$exitKeyframe, $c619b0c04884f58c$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $e7JbL.default).childPulsate, $c619b0c04884f58c$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $c619b0c04884f58c$var$TouchRipple = /*#__PURE__*/ $bh6RR.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $hCIyK.default)(props, $c619b0c04884f58c$var$_excluded);
    const [ripples, setRipples] = $bh6RR.useState([]);
    const nextKey = $bh6RR.useRef(0);
    const rippleCallback = $bh6RR.useRef(null);
    $bh6RR.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $bh6RR.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $edgJc.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $bh6RR.useRef(null);
    const container = $bh6RR.useRef(null);
    const startCommit = $bh6RR.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ih19M.jsx)($c619b0c04884f58c$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $aPsoC.default)(classes.ripple, (0, $e7JbL.default).ripple),
                        rippleVisible: (0, $aPsoC.default)(classes.rippleVisible, (0, $e7JbL.default).rippleVisible),
                        ripplePulsate: (0, $aPsoC.default)(classes.ripplePulsate, (0, $e7JbL.default).ripplePulsate),
                        child: (0, $aPsoC.default)(classes.child, (0, $e7JbL.default).child),
                        childLeaving: (0, $aPsoC.default)(classes.childLeaving, (0, $e7JbL.default).childLeaving),
                        childPulsate: (0, $aPsoC.default)(classes.childPulsate, (0, $e7JbL.default).childPulsate)
                    },
                    timeout: $c619b0c04884f58c$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $bh6RR.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($c619b0c04884f58c$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $bh6RR.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $bh6RR.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $bh6RR.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($c619b0c04884f58c$export$f6b7418508c72c25, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)((0, $e7JbL.default).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bm1aQ.default), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $c619b0c04884f58c$export$2e2bcd8739ae039 = $c619b0c04884f58c$var$TouchRipple;

});
parcelRegister("bm1aQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8442a8eba1100460$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $hqR4t = parcelRequire("hqR4t");

var $gMqD6 = parcelRequire("gMqD6");


var $bh6RR = parcelRequire("bh6RR");

var $70uTP = parcelRequire("70uTP");

var $ePspO = parcelRequire("ePspO");
var $8442a8eba1100460$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $8442a8eba1100460$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $8442a8eba1100460$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $gMqD6.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $hqR4t.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $ePspO.getInitialChildMapping)(nextProps, handleExited) : (0, $ePspO.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $ePspO.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $4WYaH.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $hCIyK.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $8442a8eba1100460$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $70uTP.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $70uTP.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$8442a8eba1100460$var$TransitionGroup.propTypes = {};
$8442a8eba1100460$var$TransitionGroup.defaultProps = $8442a8eba1100460$var$defaultProps;
var $8442a8eba1100460$export$2e2bcd8739ae039 = $8442a8eba1100460$var$TransitionGroup;

});
parcelRegister("hqR4t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb0e0834598ff6d6$export$2e2bcd8739ae039; });
function $cb0e0834598ff6d6$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("gMqD6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c375c92967c25393$export$2e2bcd8739ae039; });

var $hloi6 = parcelRequire("hloi6");
function $c375c92967c25393$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $hloi6.default)(subClass, superClass);
}

});
parcelRegister("hloi6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca073d81f2a471af$export$2e2bcd8739ae039; });
function $ca073d81f2a471af$export$2e2bcd8739ae039(o, p) {
    $ca073d81f2a471af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ca073d81f2a471af$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("70uTP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51a0807799a59896$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
var $51a0807799a59896$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);

});

parcelRegister("ePspO", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $acbbdecafa0b932b$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $acbbdecafa0b932b$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $acbbdecafa0b932b$export$36fd1af28d383ec0; });

var $bh6RR = parcelRequire("bh6RR");
function $acbbdecafa0b932b$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $bh6RR.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $bh6RR.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $acbbdecafa0b932b$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $acbbdecafa0b932b$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $acbbdecafa0b932b$export$fa71e2345c31d7a2(props, onExited) {
    return $acbbdecafa0b932b$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $bh6RR.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $acbbdecafa0b932b$var$getProp(child, "appear", props),
            enter: $acbbdecafa0b932b$var$getProp(child, "enter", props),
            exit: $acbbdecafa0b932b$var$getProp(child, "exit", props)
        });
    });
}
function $acbbdecafa0b932b$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $acbbdecafa0b932b$export$bbc8a025727ea824(nextProps.children);
    var children = $acbbdecafa0b932b$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $bh6RR.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $bh6RR.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $bh6RR.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $acbbdecafa0b932b$var$getProp(child, "exit", nextProps),
            enter: $acbbdecafa0b932b$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $bh6RR.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $bh6RR.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $bh6RR.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $acbbdecafa0b932b$var$getProp(child, "exit", nextProps),
            enter: $acbbdecafa0b932b$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRegister("ixTys", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d806670e58944783$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $ih19M = parcelRequire("ih19M");
"use client";
function $d806670e58944783$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $bh6RR.useState(false);
    const rippleClassName = (0, $aPsoC.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $aPsoC.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $bh6RR.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
            className: childClassName
        })
    });
}
var $d806670e58944783$export$2e2bcd8739ae039 = $d806670e58944783$var$Ripple;

});

parcelRegister("e7JbL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a484c5b1e92c0283$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $a484c5b1e92c0283$export$b464606f735ab902(slot) {
    return (0, $XybB6.default)("MuiTouchRipple", slot);
}
const $a484c5b1e92c0283$var$touchRippleClasses = (0, $igcUF.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $a484c5b1e92c0283$export$2e2bcd8739ae039 = $a484c5b1e92c0283$var$touchRippleClasses;

});


parcelRegister("3jw06", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", function () { return $269bf8204c4a8a34$export$fccb0498dcd99783; });
$parcel$export(module.exports, "default", function () { return $269bf8204c4a8a34$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $269bf8204c4a8a34$export$fccb0498dcd99783(slot) {
    return (0, $XybB6.default)("MuiButtonBase", slot);
}
const $269bf8204c4a8a34$var$buttonBaseClasses = (0, $igcUF.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $269bf8204c4a8a34$export$2e2bcd8739ae039 = $269bf8204c4a8a34$var$buttonBaseClasses;

});


parcelRegister("fGH8N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6bc3e223b7a0835$export$2e2bcd8739ae039; });

var $gNE2F = parcelRequire("gNE2F");
var $b6bc3e223b7a0835$export$2e2bcd8739ae039 = (0, $gNE2F.default);

});

parcelRegister("5Hj8x", function(module, exports) {

$parcel$export(module.exports, "getButtonUtilityClass", function () { return $425fd013c1fc393f$export$5a6f9035944c8119; });
$parcel$export(module.exports, "default", function () { return $425fd013c1fc393f$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $425fd013c1fc393f$export$5a6f9035944c8119(slot) {
    return (0, $XybB6.default)("MuiButton", slot);
}
const $425fd013c1fc393f$var$buttonClasses = (0, $igcUF.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorError",
    "colorInfo",
    "colorWarning",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "icon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $425fd013c1fc393f$export$2e2bcd8739ae039 = $425fd013c1fc393f$var$buttonClasses;

});

parcelRegister("lGzv4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc990ecbb370c5c5$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
/**
 * @ignore - internal component.
 */ const $fc990ecbb370c5c5$var$ButtonGroupContext = /*#__PURE__*/ $bh6RR.createContext({});
var $fc990ecbb370c5c5$export$2e2bcd8739ae039 = $fc990ecbb370c5c5$var$ButtonGroupContext;

});

parcelRegister("14scH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c7c0ad6660c674f$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
/**
 * @ignore - internal component.
 */ const $0c7c0ad6660c674f$var$ButtonGroupButtonContext = /*#__PURE__*/ $bh6RR.createContext(undefined);
var $0c7c0ad6660c674f$export$2e2bcd8739ae039 = $0c7c0ad6660c674f$var$ButtonGroupButtonContext;

});


parcelRegister("aanxD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $766d196a31d0fcff$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $766d196a31d0fcff$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V8h14zM7 10h5v5H7z"
}), "Today");

});
parcelRegister("7B0TL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $587caf852a5d6450$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $35wch = parcelRequire("35wch");

var $ih19M = parcelRequire("ih19M");
"use client";
function $587caf852a5d6450$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $35wch.default), (0, $4WYaH.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $35wch.default).muiName;
    return /*#__PURE__*/ $bh6RR.memo(/*#__PURE__*/ $bh6RR.forwardRef(Component));
}

});
parcelRegister("35wch", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23fad063f0767f1f$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $fGH8N = parcelRequire("fGH8N");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $b2lJO = parcelRequire("b2lJO");

var $ih19M = parcelRequire("ih19M");
"use client";
const $23fad063f0767f1f$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $23fad063f0767f1f$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $fGH8N.default)(color)}`,
            `fontSize${(0, $fGH8N.default)(fontSize)}`
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $b2lJO.getSvgIconUtilityClass), classes);
};
const $23fad063f0767f1f$var$SvgIconRoot = (0, $g4l1t.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $fGH8N.default)(ownerState.color)}`],
            styles[`fontSize${(0, $fGH8N.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $23fad063f0767f1f$var$SvgIcon = /*#__PURE__*/ $bh6RR.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $hCIyK.default)(props, $23fad063f0767f1f$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $bh6RR.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $23fad063f0767f1f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($23fad063f0767f1f$var$SvgIconRoot, (0, $4WYaH.default)({
        as: component,
        className: (0, $aPsoC.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ih19M.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$23fad063f0767f1f$var$SvgIcon.muiName = "SvgIcon";
var $23fad063f0767f1f$export$2e2bcd8739ae039 = $23fad063f0767f1f$var$SvgIcon;

});
parcelRegister("b2lJO", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $8090be528a37166c$export$c7c50641356bdfa5; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $8090be528a37166c$export$c7c50641356bdfa5(slot) {
    return (0, $XybB6.default)("MuiSvgIcon", slot);
}
const $8090be528a37166c$var$svgIconClasses = (0, $igcUF.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $8090be528a37166c$export$2e2bcd8739ae039 = $8090be528a37166c$var$svgIconClasses;

});




parcelRegister("d7fM7", function(module, exports) {

$parcel$export(module.exports, "getCellValue", function () { return $4f07fba8c29d5a31$export$b1f6fa0c5f374def; });
$parcel$export(module.exports, "getComparator", function () { return $4f07fba8c29d5a31$export$1f14d6e84ea4650a; });
$parcel$export(module.exports, "default", function () { return $4f07fba8c29d5a31$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $am7GZ = parcelRequire("am7GZ");
var $iTI7v = parcelRequire("iTI7v");
var $4AJYG = parcelRequire("4AJYG");
var $77DVl = parcelRequire("77DVl");
var $6RrdM = parcelRequire("6RrdM");
var $jsf2t = parcelRequire("jsf2t");
var $hEr3D = parcelRequire("hEr3D");
var $gExfQ = parcelRequire("gExfQ");
var $6GPiu = parcelRequire("6GPiu");
var $1swyP = parcelRequire("1swyP");
var $5LQ5V = parcelRequire("5LQ5V");

var $bt9fX = parcelRequire("bt9fX");
var $dRSqV = parcelRequire("dRSqV");
var $3Xpkr = parcelRequire("3Xpkr");
var $5hIzD = parcelRequire("5hIzD");
var $goe1T = parcelRequire("goe1T");
var $jIOsh = parcelRequire("jIOsh");

var $6L9uu = parcelRequire("6L9uu");

var $gSGmk = parcelRequire("gSGmk");

var $8d818 = parcelRequire("8d818");

var $lfYlj = parcelRequire("lfYlj");

var $3A2xv = parcelRequire("3A2xv");

var $b5b48 = parcelRequire("b5b48");

var $8Oiq1 = parcelRequire("8Oiq1");

var $gUBkJ = parcelRequire("gUBkJ");

var $dqRXb = parcelRequire("dqRXb");

var $bu31C = parcelRequire("bu31C");

var $aM783 = parcelRequire("aM783");
const $4f07fba8c29d5a31$var$boxShadowStyle = {
    boxShadow: "0px 10px 20px #69AAF366"
};
const $4f07fba8c29d5a31$var$getTableRowCellStyle = (index, colLength, width)=>({
        border: "none",
        left: 0,
        textAlign: "center",
        color: "primary.main",
        padding: 0,
        width: width ? `${width}px` : "auto",
        zIndex: index === 0 ? 2 : 1,
        borderTopLeftRadius: index === 0 ? "2px" : 0,
        borderBottomLeftRadius: index === 0 ? "2px" : 0,
        borderBottomRightRadius: index + 1 === colLength ? "2px" : 0,
        borderTopRightRadius: index + 1 === colLength ? "2px" : 0,
        borderRight: index + 1 === colLength ? "none" : `0.5px solid ${(0, $6L9uu.Colors).third}`
    });
const $4f07fba8c29d5a31$var$tableRowStyle = {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    height: "60px",
    color: (0, $6L9uu.Colors).main,
    textAlign: "center",
    opacity: 1,
    ...$4f07fba8c29d5a31$var$boxShadowStyle,
    border: "none",
    "&.MuiTableRow-hover": {
        "&:hover": {
            backgroundColor: "#E8F3FF",
            "& td": {
                backgroundColor: "#E8F3FF"
            }
        }
    }
};
const $4f07fba8c29d5a31$var$tableHeaderCellFontStyle = {
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "15px",
    zIndex: 1,
    textAlign: "center",
    color: (0, $6L9uu.Colors).main
};
const $4f07fba8c29d5a31$var$tableHeaderCellStyle = {
    borderRight: "1px solid #FFFFFF",
    ...$4f07fba8c29d5a31$var$tableHeaderCellFontStyle
};
const $4f07fba8c29d5a31$var$actionButtonIconStyle = {
    marginRight: "7px"
};
const $4f07fba8c29d5a31$var$TableHeaders = ({ columns: columns, order: order, orderBy: orderBy, onRequestSort: onRequestSort })=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $hEr3D.default), {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $6GPiu.default), {
            sx: {
                background: "#69AAF399 0% 0% no-repeat padding-box",
                height: "42px",
                ...$4f07fba8c29d5a31$var$boxShadowStyle
            },
            children: columns.map((col, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $6RrdM.default), {
                    align: col.type === "numeric" ? "right" : "left",
                    padding: "none",
                    sortDirection: orderBy === col ? order : false,
                    sx: {
                        ...$4f07fba8c29d5a31$var$tableHeaderCellStyle,
                        padding: col.sorting !== false ? 0 : "0 13px",
                        width: col.width ? `${col.width}px` : "auto"
                    },
                    children: col.sorting !== false ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $1swyP.default), {
                        active: orderBy === col,
                        direction: orderBy === col ? order : "asc",
                        onClick: ()=>onRequestSort(col),
                        sx: {
                            marginLeft: col.type === "numeric" ? 0 : "26px",
                            marginRight: col.type !== "numeric" ? 0 : "26px"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                            sx: $4f07fba8c29d5a31$var$tableHeaderCellFontStyle,
                            children: col.title
                        })
                    }) : col.title
                }, index))
        })
    });
function $4f07fba8c29d5a31$var$descendingComparator(a, b, orderBy) {
    if (orderBy.customSort) return orderBy.customSort(a, b);
    else {
        const item1 = $4f07fba8c29d5a31$export$b1f6fa0c5f374def(a, orderBy.field ?? "");
        const item2 = $4f07fba8c29d5a31$export$b1f6fa0c5f374def(b, orderBy.field ?? "");
        if (orderBy.type === "numeric" || orderBy.type === "date") return Number(item1) - Number(item2);
        else if (orderBy.type === "boolean") return (item1.toLowerCase() === "true" ? 1 : 0) - (item2.toLowerCase() === "true" ? 1 : 0);
        else return item1.localeCompare(item2);
    }
}
function $4f07fba8c29d5a31$export$1f14d6e84ea4650a(order, orderBy) {
    return order === "desc" ? (a, b)=>$4f07fba8c29d5a31$var$descendingComparator(a, b, orderBy) : (a, b)=>-$4f07fba8c29d5a31$var$descendingComparator(a, b, orderBy);
}
const $4f07fba8c29d5a31$export$b1f6fa0c5f374def = (rowData, path)=>{
    const parts = path.split(".");
    if (parts.length == 1) return rowData[parts[0]] !== undefined && rowData[parts[0]] !== null ? rowData[parts[0]].toString() : "";
    else {
        if (rowData[parts[0]]) return $4f07fba8c29d5a31$export$b1f6fa0c5f374def(rowData[parts[0]], parts.slice(1).join("."));
        else return "";
    }
};
const $4f07fba8c29d5a31$var$OverviewTable = ({ columns: columns, data: data, isLayoutFixed: isLayoutFixed, hidePagination: hidePagination, rowsPerPageOptions: rowsPerPageOptions, pageSize: pageSize, createButtonProps: createButtonProps, exportButtonProps: exportButtonProps, importButtonProps: importButtonProps, downloadButtonProps: downloadButtonProps, hideSearch: hideSearch, handleDetails: handleDetails, handleRemove: handleRemove, loading: loading = false, crudType: crudType, additionalFilters: additionalFilters, page: controlledPage, onPageChange: controlledOnPageChange, onRowsPerPageChange: controlledOnRowsPerPageChange, totalCount: totalCount, orderBy: controlledOrderBy, orderDirection: controlledOrderDirection, onSortChange: controlledOnSortChange })=>{
    const { state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const deletableItems = !data || data.length === 0 ? false : (0, $dqRXb.canUserDelete)(state.user, crudType);
    const itemsPerPageOptions = rowsPerPageOptions ?? [
        10,
        15,
        25,
        50
    ];
    // Use controlled or uncontrolled sorting
    const isControlledSorting = controlledOrderBy !== undefined && controlledOnSortChange !== undefined;
    const [internalOrder, setInternalOrder] = (0, $bh6RR.useState)("asc");
    const [internalOrderBy, setInternalOrderBy] = (0, $bh6RR.useState)(null);
    const order = isControlledSorting ? controlledOrderDirection || "asc" : internalOrder;
    const orderBy = isControlledSorting ? controlledOrderBy ? columns.find((col)=>col.field === controlledOrderBy) || null : null : internalOrderBy;
    const [internalPage, setInternalPage] = (0, $bh6RR.useState)(0);
    const [internalItemsPerPage, setInternalItemsPerPage] = (0, $bh6RR.useState)(pageSize ?? itemsPerPageOptions.length > 1 ? itemsPerPageOptions[1] : itemsPerPageOptions[0]);
    const [searchValue, setSearchValue] = (0, $bh6RR.useState)("");
    const [filteredData, setFilteredData] = (0, $bh6RR.useState)(data);
    // Use controlled or uncontrolled pagination
    const isControlledPagination = controlledPage !== undefined;
    const page = isControlledPagination ? controlledPage : internalPage;
    const itemsPerPage = isControlledPagination ? pageSize ?? internalItemsPerPage : internalItemsPerPage;
    (0, $bh6RR.useEffect)(()=>{
        setFilteredData(data);
        if (!hideSearch) filterData(searchValue);
        // Only reset page if pagination is not controlled
        if (!isControlledPagination) setInternalPage(0);
    }, [
        data,
        isControlledPagination
    ]);
    const handleRequestSort = (property)=>{
        if (isControlledSorting && controlledOnSortChange) {
            // Controlled sorting: notify parent
            // 3-state cycle: no sort -> asc -> desc -> no sort
            const isCurrentColumn = orderBy === property;
            const isAsc = isCurrentColumn && order === "asc";
            const isDesc = isCurrentColumn && order === "desc";
            let newOrderBy;
            let newOrder;
            if (!isCurrentColumn) {
                // Different column: start with ascending
                newOrderBy = property;
                newOrder = "asc";
            } else if (isAsc) {
                // Same column, currently asc: switch to desc
                newOrderBy = property;
                newOrder = "desc";
            } else if (isDesc) {
                // Same column, currently desc: clear sorting
                newOrderBy = null;
                newOrder = "asc";
            } else {
                // Fallback case (should not happen in normal flow): default to ascending
                newOrderBy = property;
                newOrder = "asc";
            }
            controlledOnSortChange(newOrderBy?.field || null, newOrder);
        } else {
            // Uncontrolled sorting: manage state internally
            const isAsc = orderBy === property && order === "asc";
            setInternalOrder(isAsc ? "desc" : "asc");
            const newOrderBy = isAsc ? property : orderBy !== property ? property : null;
            setInternalOrderBy(newOrderBy);
        }
    };
    const getReadyToUseData = ()=>{
        let rows = filteredData.slice();
        // Only sort on client side if not using controlled sorting (server-side sorting)
        if (!isControlledSorting && orderBy !== null) rows = rows.sort($4f07fba8c29d5a31$export$1f14d6e84ea4650a(order, orderBy));
        // Don't slice data if using server-side pagination (hidePagination or controlled)
        if (hidePagination !== true && !isControlledPagination) rows = rows.slice(page * itemsPerPage, page * itemsPerPage + itemsPerPage);
        return rows;
    };
    const handleChangePage = (event, newPage)=>{
        if (isControlledPagination && controlledOnPageChange) controlledOnPageChange(event, newPage);
        else setInternalPage(newPage);
    };
    const handleChangeRowsPerPage = (event)=>{
        const newItemsPerPage = parseInt(event.target.value, 10);
        if (isControlledPagination && controlledOnRowsPerPageChange) controlledOnRowsPerPageChange(event);
        else {
            setInternalItemsPerPage(newItemsPerPage);
            setInternalPage(0);
        }
    };
    const handleValueChange = (event)=>{
        const { value: value } = event.currentTarget;
        setSearchValue(value);
        filterData(value);
        // Reset page when search changes
        if (isControlledPagination && controlledOnPageChange) controlledOnPageChange(event, 0);
        else setInternalPage(0);
    };
    const filterData = (filter)=>{
        const trimmedSearchText = filter.trim();
        setFilteredData(data.filter((row)=>{
            return columns.filter((columnDef)=>{
                return columnDef.searchable === undefined ? true : columnDef.searchable;
            }).some((columnDef)=>{
                if (columnDef.customFilterAndSearch) return !!columnDef.customFilterAndSearch(trimmedSearchText, row, columnDef);
                else if (columnDef.field) {
                    const value = $4f07fba8c29d5a31$export$b1f6fa0c5f374def(row, columnDef.field);
                    return value?.toString().toUpperCase().includes(trimmedSearchText.toUpperCase());
                }
            });
        }));
    };
    const generateToolbar = ()=>{
        return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                display: "flex",
                alignItems: "end",
                marginBottom: "14px",
                padding: "0 24px",
                gap: "20px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        flexGrow: 0
                    },
                    children: hideSearch !== true && /*#__PURE__*/ (0, $ih19M.jsx)((0, $5LQ5V.default), {
                        id: "table-search-field",
                        value: searchValue,
                        onChange: handleValueChange,
                        sx: {
                            color: (0, $6L9uu.Colors).main,
                            backgroundColor: (0, $6L9uu.Colors).input_field_background,
                            maxWidth: "365px",
                            height: "36px",
                            borderRadius: "9px",
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                    border: "none"
                                }
                            }
                        },
                        placeholder: "Search...",
                        InputProps: {
                            startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $jIOsh.default), {
                                sx: {
                                    color: (0, $6L9uu.Colors).main,
                                    width: "20px",
                                    height: "20px",
                                    marginRight: "10px",
                                    input: {
                                        "&::placeholder": {
                                            color: (0, $6L9uu.Colors).main
                                        }
                                    }
                                }
                            }),
                            endAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $am7GZ.default), {
                                disabled: !Boolean(searchValue),
                                onClick: ()=>{
                                    setSearchValue("");
                                    filterData("");
                                    // Reset page when clearing search
                                    if (isControlledPagination && controlledOnPageChange) controlledOnPageChange(null, 0);
                                    else setInternalPage(0);
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3Xpkr.default), {
                                    sx: {
                                        color: searchValue ? (0, $6L9uu.Colors).main : "#9CA3AE",
                                        width: "20px",
                                        height: "20px"
                                    }
                                })
                            }),
                            style: {
                                height: "36px",
                                color: (0, $6L9uu.Colors).main,
                                paddingRight: "4px"
                            }
                        },
                        className: "custom-search"
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        flexGrow: 1
                    },
                    children: additionalFilters
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    sx: {
                        flexGrow: 0,
                        display: "flex",
                        gap: "10px"
                    },
                    children: [
                        exportButtonProps && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                            id: exportButtonProps.id,
                            "data-testid": exportButtonProps.id,
                            onClick: ()=>exportButtonProps.onClick(),
                            sx: (0, $6L9uu.buttons).cancel,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $dRSqV.default), {
                                    sx: $4f07fba8c29d5a31$var$actionButtonIconStyle
                                }),
                                "Export"
                            ]
                        }),
                        importButtonProps && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                            id: importButtonProps.id,
                            "data-testid": importButtonProps.id,
                            onClick: ()=>importButtonProps.onClick(),
                            sx: (0, $6L9uu.buttons).cancel,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $goe1T.default), {
                                    sx: $4f07fba8c29d5a31$var$actionButtonIconStyle
                                }),
                                " Import"
                            ]
                        }),
                        downloadButtonProps && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                            id: downloadButtonProps.id,
                            "data-testid": downloadButtonProps.id,
                            onClick: ()=>downloadButtonProps.onClick(),
                            sx: (0, $6L9uu.buttons).cancel,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $5hIzD.default), {
                                    sx: $4f07fba8c29d5a31$var$actionButtonIconStyle
                                }),
                                " Download"
                            ]
                        }),
                        createButtonProps && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                            id: createButtonProps.id,
                            onClick: ()=>createButtonProps.onClick(),
                            disabled: createButtonProps.disabled || false,
                            variant: "contained",
                            color: "primary",
                            sx: (0, $6L9uu.buttons).overviewCreate,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $bt9fX.default), {
                                    sx: $4f07fba8c29d5a31$var$actionButtonIconStyle
                                }),
                                createButtonProps.text
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const shouldShowToolbar = hideSearch !== true || createButtonProps || exportButtonProps || importButtonProps || downloadButtonProps || additionalFilters;
    const detailsButton = (rowData)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: rowData.name ? rowData.name : rowData.number ? rowData.number : `${rowData.email}-${rowData.company?.name}`,
            "data-testid": rowData.id,
            sx: {
                width: "auto"
            },
            onClick: ()=>handleDetails ? handleDetails(rowData) : console.log("Missing handle details function", rowData),
            children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($lfYlj))),
                alt: "detailsButton"
            })
        });
    const removeButton = (rowData)=>{
        const disableDelete = shouldDisableDelete(rowData);
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: rowData.name ? `${rowData.name}-delete` : `${rowData.email}-delete`,
            "data-testid": `${rowData.id}-delete`,
            sx: {
                width: "auto"
            },
            disabled: disableDelete,
            onClick: ()=>handleRemove ? handleRemove(rowData) : console.log("Missing handle remove function", rowData),
            children: disableDelete ? /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($b5b48))),
                alt: "removeButtonGray"
            }) : /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3A2xv))),
                alt: "removeButton"
            })
        });
    };
    const shouldDisableDelete = (rowData)=>{
        if (rowData.__typename === (0, $gUBkJ.Types).Invoice && rowData.status.name === (0, $aM783.INVOICE_STATUS_CONFIRMED)) return true;
        else if (rowData.__typename === (0, $gUBkJ.Types).User) {
            const restrictedRoles = [
                (0, $8Oiq1.Roles).Admin,
                (0, $8Oiq1.Roles).InvoiceEditor
            ];
            return restrictedRoles.some((r)=>rowData.roles.includes(r));
        } else if (rowData.__typename === (0, $gUBkJ.Types).Index || rowData.__typename === (0, $gUBkJ.Types).IndexSeries || rowData.__typename === (0, $gUBkJ.Types).ETF || rowData.__typename === (0, $gUBkJ.Types).Stock) {
            const restrictedRoles = [
                (0, $8Oiq1.Roles).Admin,
                (0, $8Oiq1.Roles).IndexOperator
            ];
            return !restrictedRoles.some((r)=>state.user.data?.roles.includes(r));
        } else return !deletableItems;
    };
    const styledColumns = columns.map((column)=>{
        let res = {
            ...column
        };
        if (column.title === "Details") res = {
            ...res,
            render: detailsButton
        };
        else if (column.title === "Remove") res = {
            ...res,
            render: removeButton
        };
        return res;
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $iTI7v.default), {
        sx: {
            width: "100%",
            padding: `${shouldShowToolbar ? "32px" : "14px"} 0`,
            boxShadow: "0px 10px 15px rgba(8, 79, 180, 0.05)",
            borderRadius: "8px"
        },
        children: [
            shouldShowToolbar && generateToolbar(),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jsf2t.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $4AJYG.default), {
                    "aria-labelledby": "tableTitle",
                    sx: {
                        tableLayout: isLayoutFixed === true ? "fixed" : "default",
                        borderCollapse: "separate",
                        borderSpacing: "0 18px",
                        padding: "0 10px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)($4f07fba8c29d5a31$var$TableHeaders, {
                            order: order,
                            orderBy: orderBy,
                            onRequestSort: handleRequestSort,
                            columns: columns
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $77DVl.default), {
                            children: getReadyToUseData().map((rowData, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $6GPiu.default), {
                                    hover: true,
                                    // onClick={handleDetails ? () => handleDetails(rowData) : () => true}
                                    sx: {
                                        ...$4f07fba8c29d5a31$var$tableRowStyle,
                                        cursor: handleDetails ? "pointer" : "default"
                                    },
                                    children: styledColumns.map((col, index2)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $6RrdM.default), {
                                            sx: $4f07fba8c29d5a31$var$getTableRowCellStyle(index2, columns.length, col.width),
                                            children: col.render ? col.render(rowData) : (0, $gSGmk.displayText)($4f07fba8c29d5a31$export$b1f6fa0c5f374def(rowData, col.field ?? ""), col.type)
                                        }, index2))
                                }, index))
                        })
                    ]
                })
            }),
            hidePagination !== true && /*#__PURE__*/ (0, $ih19M.jsx)((0, $gExfQ.default), {
                rowsPerPageOptions: itemsPerPageOptions,
                showFirstButton: true,
                showLastButton: true,
                component: "div",
                count: totalCount !== undefined ? totalCount : filteredData.length,
                rowsPerPage: itemsPerPage,
                page: page,
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage,
                backIconButtonProps: {
                    contextMenu: "back",
                    color: "info",
                    title: "Previous"
                },
                labelDisplayedRows: ({ from: from, to: to, count: count })=>{
                    if (isControlledPagination && totalCount !== undefined) {
                        // Server-side pagination: show actual range
                        const actualFrom = count > 0 ? from : 0;
                        const actualTo = Math.min(to, count);
                        return `${actualFrom}-${actualTo} of ${count}`;
                    }
                    // Client-side pagination: show page info
                    const pageCount = count > itemsPerPage ? Math.floor(count / itemsPerPage + 1) : 1;
                    return `${page + 1} of ${pageCount}`;
                },
                nextIconButtonProps: {
                    color: "info",
                    title: "Next"
                },
                labelRowsPerPage: /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                    style: {
                        fontSize: "14px",
                        lineHeight: "17px",
                        color: (0, $6L9uu.Colors).gray
                    },
                    children: [
                        "Total:",
                        " ",
                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            style: {
                                color: (0, $6L9uu.Colors).skyBlue,
                                fontSize: "12px",
                                fontWeight: 700
                            },
                            children: totalCount !== undefined ? totalCount : data.length
                        })
                    ]
                }),
                SelectProps: {
                    id: "table-pagination-select",
                    renderValue: (props)=>`${props} Rows/Page`,
                    sx: {
                        color: (0, $6L9uu.Colors).main,
                        border: `1px solid ${(0, $6L9uu.Colors).main}`,
                        borderRadius: `${(0, $6L9uu.shapes).borderRadius}px`,
                        backgroundColor: (0, $6L9uu.Colors).white,
                        fontSize: "12px",
                        lineHeight: "16px",
                        fontWeight: 700,
                        marginRight: "20px",
                        "&.Mui-focused div": {
                            borderRadius: `${(0, $6L9uu.shapes).borderRadius}px`,
                            backgroundColor: (0, $6L9uu.Colors).white
                        }
                    }
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                loading: loading
            })
        ]
    });
};
var $4f07fba8c29d5a31$export$2e2bcd8739ae039 = $4f07fba8c29d5a31$var$OverviewTable;

});
parcelRegister("chLJv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f1c19533f0ca7a5$export$2e2bcd8739ae039; });

var $4f9bW = parcelRequire("4f9bW");


var $3TEEB = parcelRequire("3TEEB");

var $gcMmG = parcelRequire("gcMmG");

var $wllwT = parcelRequire("wllwT");

var $gU8r3 = parcelRequire("gU8r3");
"use client";
const $8f1c19533f0ca7a5$var$defaultTheme = (0, $gcMmG.default)();
const $8f1c19533f0ca7a5$var$Box = (0, $4f9bW.default)({
    themeId: (0, $wllwT.default),
    defaultTheme: $8f1c19533f0ca7a5$var$defaultTheme,
    defaultClassName: (0, $gU8r3.default).root,
    generateClassName: (0, $3TEEB.default).generate
});
var $8f1c19533f0ca7a5$export$2e2bcd8739ae039 = $8f1c19533f0ca7a5$var$Box;

});
parcelRegister("4f9bW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $316fb1613a027ac6$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");

var $aPsoC = parcelRequire("aPsoC");

var $8BdII = parcelRequire("8BdII");

var $f9NmP = parcelRequire("f9NmP");
var $gIHYf = parcelRequire("gIHYf");

var $dm6dP = parcelRequire("dm6dP");

var $ih19M = parcelRequire("ih19M");
"use client";
const $316fb1613a027ac6$var$_excluded = [
    "className",
    "component"
];
function $316fb1613a027ac6$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $8BdII.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $f9NmP.default));
    const Box = /*#__PURE__*/ $bh6RR.forwardRef(function Box(inProps, ref) {
        const theme = (0, $dm6dP.default)(defaultTheme);
        const _extendSxProp = (0, $gIHYf.default)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $hCIyK.default)(_extendSxProp, $316fb1613a027ac6$var$_excluded);
        return /*#__PURE__*/ (0, $ih19M.jsx)(BoxRoot, (0, $4WYaH.default)({
            as: component,
            ref: ref,
            className: (0, $aPsoC.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}

});

parcelRegister("gU8r3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4e86b5f00221157$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");
const $c4e86b5f00221157$var$boxClasses = (0, $igcUF.default)("MuiBox", [
    "root"
]);
var $c4e86b5f00221157$export$2e2bcd8739ae039 = $c4e86b5f00221157$var$boxClasses;

});


parcelRegister("am7GZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78a1ecfdeb9afc7a$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $7J7Kn = parcelRequire("7J7Kn");

var $cG3EF = parcelRequire("cG3EF");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $aEoM0 = parcelRequire("aEoM0");

var $fGH8N = parcelRequire("fGH8N");

var $6gjHo = parcelRequire("6gjHo");

var $ih19M = parcelRequire("ih19M");
"use client";
const $78a1ecfdeb9afc7a$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $78a1ecfdeb9afc7a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $fGH8N.default)(color)}`,
            edge && `edge${(0, $fGH8N.default)(edge)}`,
            `size${(0, $fGH8N.default)(size)}`
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $6gjHo.getIconButtonUtilityClass), classes);
};
const $78a1ecfdeb9afc7a$var$IconButtonRoot = (0, $g4l1t.default)((0, $aEoM0.default), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $fGH8N.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $fGH8N.default)(ownerState.edge)}`],
            styles[`size${(0, $fGH8N.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cG3EF.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $4WYaH.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $4WYaH.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $4WYaH.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cG3EF.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $6gjHo.default).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $78a1ecfdeb9afc7a$var$IconButton = /*#__PURE__*/ $bh6RR.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $hCIyK.default)(props, $78a1ecfdeb9afc7a$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $78a1ecfdeb9afc7a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($78a1ecfdeb9afc7a$var$IconButtonRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $78a1ecfdeb9afc7a$export$2e2bcd8739ae039 = $78a1ecfdeb9afc7a$var$IconButton;

});
parcelRegister("6gjHo", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", function () { return $48f3847998426035$export$5e8702d71474f093; });
$parcel$export(module.exports, "default", function () { return $48f3847998426035$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $48f3847998426035$export$5e8702d71474f093(slot) {
    return (0, $XybB6.default)("MuiIconButton", slot);
}
const $48f3847998426035$var$iconButtonClasses = (0, $igcUF.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $48f3847998426035$export$2e2bcd8739ae039 = $48f3847998426035$var$iconButtonClasses;

});


parcelRegister("iTI7v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc1f965cf97b1820$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");



var $7J7Kn = parcelRequire("7J7Kn");

var $cG3EF = parcelRequire("cG3EF");

var $g4l1t = parcelRequire("g4l1t");

var $7WR98 = parcelRequire("7WR98");

var $cNBED = parcelRequire("cNBED");


var $e7i2f = parcelRequire("e7i2f");

var $ih19M = parcelRequire("ih19M");
"use client";
const $dc1f965cf97b1820$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $dc1f965cf97b1820$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $e7i2f.getPaperUtilityClass), classes);
};
const $dc1f965cf97b1820$var$PaperRoot = (0, $g4l1t.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $4WYaH.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $4WYaH.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $cG3EF.alpha)("#fff", (0, $7WR98.default)(ownerState.elevation))}, ${(0, $cG3EF.alpha)("#fff", (0, $7WR98.default)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $dc1f965cf97b1820$var$Paper = /*#__PURE__*/ $bh6RR.forwardRef(function Paper(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $hCIyK.default)(props, $dc1f965cf97b1820$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $dc1f965cf97b1820$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($dc1f965cf97b1820$var$PaperRoot, (0, $4WYaH.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref
    }, other));
});
var $dc1f965cf97b1820$export$2e2bcd8739ae039 = $dc1f965cf97b1820$var$Paper;

});
parcelRegister("7WR98", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c972cf40eafc7df$export$2e2bcd8739ae039; });
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $5c972cf40eafc7df$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $5c972cf40eafc7df$export$2e2bcd8739ae039 = $5c972cf40eafc7df$var$getOverlayAlpha;

});

parcelRegister("e7i2f", function(module, exports) {

$parcel$export(module.exports, "getPaperUtilityClass", function () { return $a46fb58ff80b1409$export$29cdb466b9b6f20b; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $a46fb58ff80b1409$export$29cdb466b9b6f20b(slot) {
    return (0, $XybB6.default)("MuiPaper", slot);
}
const $a46fb58ff80b1409$var$paperClasses = (0, $igcUF.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $a46fb58ff80b1409$export$2e2bcd8739ae039 = $a46fb58ff80b1409$var$paperClasses;

});


parcelRegister("4AJYG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $357e30723240190f$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $kPHwy = parcelRequire("kPHwy");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $dTwv6 = parcelRequire("dTwv6");

var $ih19M = parcelRequire("ih19M");
"use client";
const $357e30723240190f$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $357e30723240190f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            stickyHeader && "stickyHeader"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $dTwv6.getTableUtilityClass), classes);
};
const $357e30723240190f$var$TableRoot = (0, $g4l1t.default)("table", {
    name: "MuiTable",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "table",
        width: "100%",
        borderCollapse: "collapse",
        borderSpacing: 0,
        "& caption": (0, $4WYaH.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: "left",
            captionSide: "bottom"
        })
    }, ownerState.stickyHeader && {
        borderCollapse: "separate"
    }));
const $357e30723240190f$var$defaultComponent = "table";
const $357e30723240190f$var$Table = /*#__PURE__*/ $bh6RR.forwardRef(function Table(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTable"
    });
    const { className: className, component: component = $357e30723240190f$var$defaultComponent, padding: padding = "normal", size: size = "medium", stickyHeader: stickyHeader = false } = props, other = (0, $hCIyK.default)(props, $357e30723240190f$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $357e30723240190f$var$useUtilityClasses(ownerState);
    const table = $bh6RR.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $kPHwy.default).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($357e30723240190f$var$TableRoot, (0, $4WYaH.default)({
            as: component,
            role: component === $357e30723240190f$var$defaultComponent ? null : "table",
            ref: ref,
            className: (0, $aPsoC.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $357e30723240190f$export$2e2bcd8739ae039 = $357e30723240190f$var$Table;

});
parcelRegister("kPHwy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2aa551040aadf23$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
"use client";
/**
 * @ignore - internal component.
 */ const $f2aa551040aadf23$var$TableContext = /*#__PURE__*/ $bh6RR.createContext();
var $f2aa551040aadf23$export$2e2bcd8739ae039 = $f2aa551040aadf23$var$TableContext;

});

parcelRegister("dTwv6", function(module, exports) {

$parcel$export(module.exports, "getTableUtilityClass", function () { return $a1d99f5ef039a242$export$315cb19215f77ce0; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $a1d99f5ef039a242$export$315cb19215f77ce0(slot) {
    return (0, $XybB6.default)("MuiTable", slot);
}
const $a1d99f5ef039a242$var$tableClasses = (0, $igcUF.default)("MuiTable", [
    "root",
    "stickyHeader"
]);
var $a1d99f5ef039a242$export$2e2bcd8739ae039 = $a1d99f5ef039a242$var$tableClasses;

});


parcelRegister("77DVl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52f827ebb7bd0a04$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $aQcZC = parcelRequire("aQcZC");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $4TnRO = parcelRequire("4TnRO");

var $ih19M = parcelRequire("ih19M");
"use client";
const $52f827ebb7bd0a04$var$_excluded = [
    "className",
    "component"
];
const $52f827ebb7bd0a04$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $4TnRO.getTableBodyUtilityClass), classes);
};
const $52f827ebb7bd0a04$var$TableBodyRoot = (0, $g4l1t.default)("tbody", {
    name: "MuiTableBody",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-row-group"
});
const $52f827ebb7bd0a04$var$tablelvl2 = {
    variant: "body"
};
const $52f827ebb7bd0a04$var$defaultComponent = "tbody";
const $52f827ebb7bd0a04$var$TableBody = /*#__PURE__*/ $bh6RR.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTableBody"
    });
    const { className: className, component: component = $52f827ebb7bd0a04$var$defaultComponent } = props, other = (0, $hCIyK.default)(props, $52f827ebb7bd0a04$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component
    });
    const classes = $52f827ebb7bd0a04$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $aQcZC.default).Provider, {
        value: $52f827ebb7bd0a04$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($52f827ebb7bd0a04$var$TableBodyRoot, (0, $4WYaH.default)({
            className: (0, $aPsoC.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $52f827ebb7bd0a04$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
var $52f827ebb7bd0a04$export$2e2bcd8739ae039 = $52f827ebb7bd0a04$var$TableBody;

});
parcelRegister("aQcZC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e48d6d65c9854e1$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
/**
 * @ignore - internal component.
 */ const $7e48d6d65c9854e1$var$Tablelvl2Context = /*#__PURE__*/ $bh6RR.createContext();
var $7e48d6d65c9854e1$export$2e2bcd8739ae039 = $7e48d6d65c9854e1$var$Tablelvl2Context;

});

parcelRegister("4TnRO", function(module, exports) {

$parcel$export(module.exports, "getTableBodyUtilityClass", function () { return $38fecff55707093b$export$98bd2a9b566ec665; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $38fecff55707093b$export$98bd2a9b566ec665(slot) {
    return (0, $XybB6.default)("MuiTableBody", slot);
}
const $38fecff55707093b$var$tableBodyClasses = (0, $igcUF.default)("MuiTableBody", [
    "root"
]);
var $38fecff55707093b$export$2e2bcd8739ae039 = $38fecff55707093b$var$tableBodyClasses;

});


parcelRegister("6RrdM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4feccedea5ed7554$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $cG3EF = parcelRequire("cG3EF");

var $fGH8N = parcelRequire("fGH8N");

var $kPHwy = parcelRequire("kPHwy");

var $aQcZC = parcelRequire("aQcZC");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $irxW7 = parcelRequire("irxW7");

var $ih19M = parcelRequire("ih19M");
"use client";
const $4feccedea5ed7554$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $4feccedea5ed7554$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            stickyHeader && "stickyHeader",
            align !== "inherit" && `align${(0, $fGH8N.default)(align)}`,
            padding !== "normal" && `padding${(0, $fGH8N.default)(padding)}`,
            `size${(0, $fGH8N.default)(size)}`
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $irxW7.getTableCellUtilityClass), classes);
};
const $4feccedea5ed7554$var$TableCellRoot = (0, $g4l1t.default)("td", {
    name: "MuiTableCell",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $fGH8N.default)(ownerState.size)}`],
            ownerState.padding !== "normal" && styles[`padding${(0, $fGH8N.default)(ownerState.padding)}`],
            ownerState.align !== "inherit" && styles[`align${(0, $fGH8N.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({}, theme.typography.body2, {
        display: "table-cell",
        verticalAlign: "inherit",
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === "light" ? (0, $cG3EF.lighten)((0, $cG3EF.alpha)(theme.palette.divider, 1), 0.88) : (0, $cG3EF.darken)((0, $cG3EF.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: "left",
        padding: 16
    }, ownerState.variant === "head" && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === "body" && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === "footer" && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === "small" && {
        padding: "6px 16px",
        [`&.${(0, $irxW7.default).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: "0 12px 0 16px",
            "& > *": {
                padding: 0
            }
        }
    }, ownerState.padding === "checkbox" && {
        width: 48,
        // prevent the checkbox column from growing
        padding: "0 0 0 4px"
    }, ownerState.padding === "none" && {
        padding: 0
    }, ownerState.align === "left" && {
        textAlign: "left"
    }, ownerState.align === "center" && {
        textAlign: "center"
    }, ownerState.align === "right" && {
        textAlign: "right",
        flexDirection: "row-reverse"
    }, ownerState.align === "justify" && {
        textAlign: "justify"
    }, ownerState.stickyHeader && {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $4feccedea5ed7554$var$TableCell = /*#__PURE__*/ $bh6RR.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTableCell"
    });
    const { align: align = "inherit", className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $hCIyK.default)(props, $4feccedea5ed7554$var$_excluded);
    const table = $bh6RR.useContext((0, $kPHwy.default));
    const tablelvl2 = $bh6RR.useContext((0, $aQcZC.default));
    const isHeadCell = tablelvl2 && tablelvl2.variant === "head";
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? "th" : "td";
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === "td") scope = undefined;
    else if (!scope && isHeadCell) scope = "col";
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $4WYaH.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : "normal"),
        size: sizeProp || (table && table.size ? table.size : "medium"),
        sortDirection: sortDirection,
        stickyHeader: variant === "head" && table && table.stickyHeader,
        variant: variant
    });
    const classes = $4feccedea5ed7554$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
    return /*#__PURE__*/ (0, $ih19M.jsx)($4feccedea5ed7554$var$TableCellRoot, (0, $4WYaH.default)({
        as: component,
        ref: ref,
        className: (0, $aPsoC.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $4feccedea5ed7554$export$2e2bcd8739ae039 = $4feccedea5ed7554$var$TableCell;

});
parcelRegister("irxW7", function(module, exports) {

$parcel$export(module.exports, "getTableCellUtilityClass", function () { return $d6d512a72c64def8$export$33a0f07a16a10b1b; });
$parcel$export(module.exports, "default", function () { return $d6d512a72c64def8$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $d6d512a72c64def8$export$33a0f07a16a10b1b(slot) {
    return (0, $XybB6.default)("MuiTableCell", slot);
}
const $d6d512a72c64def8$var$tableCellClasses = (0, $igcUF.default)("MuiTableCell", [
    "root",
    "head",
    "body",
    "footer",
    "sizeSmall",
    "sizeMedium",
    "paddingCheckbox",
    "paddingNone",
    "alignLeft",
    "alignCenter",
    "alignRight",
    "alignJustify",
    "stickyHeader"
]);
var $d6d512a72c64def8$export$2e2bcd8739ae039 = $d6d512a72c64def8$var$tableCellClasses;

});


parcelRegister("jsf2t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e29c4c3daf9f5f0a$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $jQGJj = parcelRequire("jQGJj");

var $ih19M = parcelRequire("ih19M");
"use client";
const $e29c4c3daf9f5f0a$var$_excluded = [
    "className",
    "component"
];
const $e29c4c3daf9f5f0a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $jQGJj.getTableContainerUtilityClass), classes);
};
const $e29c4c3daf9f5f0a$var$TableContainerRoot = (0, $g4l1t.default)("div", {
    name: "MuiTableContainer",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    width: "100%",
    overflowX: "auto"
});
const $e29c4c3daf9f5f0a$var$TableContainer = /*#__PURE__*/ $bh6RR.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTableContainer"
    });
    const { className: className, component: component = "div" } = props, other = (0, $hCIyK.default)(props, $e29c4c3daf9f5f0a$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component
    });
    const classes = $e29c4c3daf9f5f0a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($e29c4c3daf9f5f0a$var$TableContainerRoot, (0, $4WYaH.default)({
        ref: ref,
        as: component,
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState
    }, other));
});
var $e29c4c3daf9f5f0a$export$2e2bcd8739ae039 = $e29c4c3daf9f5f0a$var$TableContainer;

});
parcelRegister("jQGJj", function(module, exports) {

$parcel$export(module.exports, "getTableContainerUtilityClass", function () { return $e73404e26e630b8c$export$eed427986a7abdf9; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $e73404e26e630b8c$export$eed427986a7abdf9(slot) {
    return (0, $XybB6.default)("MuiTableContainer", slot);
}
const $e73404e26e630b8c$var$tableContainerClasses = (0, $igcUF.default)("MuiTableContainer", [
    "root"
]);
var $e73404e26e630b8c$export$2e2bcd8739ae039 = $e73404e26e630b8c$var$tableContainerClasses;

});


parcelRegister("hEr3D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd9b2928e2c2b989$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $aQcZC = parcelRequire("aQcZC");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $el3Lo = parcelRequire("el3Lo");

var $ih19M = parcelRequire("ih19M");
"use client";
const $cd9b2928e2c2b989$var$_excluded = [
    "className",
    "component"
];
const $cd9b2928e2c2b989$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $el3Lo.getTableHeadUtilityClass), classes);
};
const $cd9b2928e2c2b989$var$TableHeadRoot = (0, $g4l1t.default)("thead", {
    name: "MuiTableHead",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-header-group"
});
const $cd9b2928e2c2b989$var$tablelvl2 = {
    variant: "head"
};
const $cd9b2928e2c2b989$var$defaultComponent = "thead";
const $cd9b2928e2c2b989$var$TableHead = /*#__PURE__*/ $bh6RR.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTableHead"
    });
    const { className: className, component: component = $cd9b2928e2c2b989$var$defaultComponent } = props, other = (0, $hCIyK.default)(props, $cd9b2928e2c2b989$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component
    });
    const classes = $cd9b2928e2c2b989$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $aQcZC.default).Provider, {
        value: $cd9b2928e2c2b989$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($cd9b2928e2c2b989$var$TableHeadRoot, (0, $4WYaH.default)({
            as: component,
            className: (0, $aPsoC.default)(classes.root, className),
            ref: ref,
            role: component === $cd9b2928e2c2b989$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
var $cd9b2928e2c2b989$export$2e2bcd8739ae039 = $cd9b2928e2c2b989$var$TableHead;

});
parcelRegister("el3Lo", function(module, exports) {

$parcel$export(module.exports, "getTableHeadUtilityClass", function () { return $a705f233bc9202fc$export$2e731cea2d1c2392; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $a705f233bc9202fc$export$2e731cea2d1c2392(slot) {
    return (0, $XybB6.default)("MuiTableHead", slot);
}
const $a705f233bc9202fc$var$tableHeadClasses = (0, $igcUF.default)("MuiTableHead", [
    "root"
]);
var $a705f233bc9202fc$export$2e2bcd8739ae039 = $a705f233bc9202fc$var$tableHeadClasses;

});


parcelRegister("gExfQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1fa2d74162b0d1a$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");



var $bLFa3 = parcelRequire("bLFa3");

var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $dNs2U = parcelRequire("dNs2U");

var $kY90d = parcelRequire("kY90d");

var $5QlDC = parcelRequire("5QlDC");

var $6RrdM = parcelRequire("6RrdM");

var $eJOwd = parcelRequire("eJOwd");

var $8TKyB = parcelRequire("8TKyB");

var $5R8eh = parcelRequire("5R8eh");

var $aSR7M = parcelRequire("aSR7M");

var $ih19M = parcelRequire("ih19M");
"use client";
var $c1fa2d74162b0d1a$var$_InputBase;
const $c1fa2d74162b0d1a$var$_excluded = [
    "ActionsComponent",
    "backIconButtonProps",
    "className",
    "colSpan",
    "component",
    "count",
    "disabled",
    "getItemAriaLabel",
    "labelDisplayedRows",
    "labelRowsPerPage",
    "nextIconButtonProps",
    "onPageChange",
    "onRowsPerPageChange",
    "page",
    "rowsPerPage",
    "rowsPerPageOptions",
    "SelectProps",
    "showFirstButton",
    "showLastButton",
    "slotProps",
    "slots"
];
const $c1fa2d74162b0d1a$var$TablePaginationRoot = (0, $g4l1t.default)((0, $6RrdM.default), {
    name: "MuiTablePagination",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        overflow: "auto",
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        "&:last-child": {
            padding: 0
        }
    }));
const $c1fa2d74162b0d1a$var$TablePaginationToolbar = (0, $g4l1t.default)((0, $eJOwd.default), {
    name: "MuiTablePagination",
    slot: "Toolbar",
    overridesResolver: (props, styles)=>(0, $4WYaH.default)({
            [`& .${(0, $aSR7M.default).actions}`]: styles.actions
        }, styles.toolbar)
})(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up("sm")]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, $aSR7M.default).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    }));
const $c1fa2d74162b0d1a$var$TablePaginationSpacer = (0, $g4l1t.default)("div", {
    name: "MuiTablePagination",
    slot: "Spacer",
    overridesResolver: (props, styles)=>styles.spacer
})({
    flex: "1 1 100%"
});
const $c1fa2d74162b0d1a$var$TablePaginationSelectLabel = (0, $g4l1t.default)("p", {
    name: "MuiTablePagination",
    slot: "SelectLabel",
    overridesResolver: (props, styles)=>styles.selectLabel
})(({ theme: theme })=>(0, $4WYaH.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
const $c1fa2d74162b0d1a$var$TablePaginationSelect = (0, $g4l1t.default)((0, $5QlDC.default), {
    name: "MuiTablePagination",
    slot: "Select",
    overridesResolver: (props, styles)=>(0, $4WYaH.default)({
            [`& .${(0, $aSR7M.default).selectIcon}`]: styles.selectIcon,
            [`& .${(0, $aSR7M.default).select}`]: styles.select
        }, styles.input, styles.selectRoot)
})({
    color: "inherit",
    fontSize: "inherit",
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, $aSR7M.default).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: "right",
        textAlignLast: "right" // Align <select> on Chrome.
    }
});
const $c1fa2d74162b0d1a$var$TablePaginationMenuItem = (0, $g4l1t.default)((0, $kY90d.default), {
    name: "MuiTablePagination",
    slot: "MenuItem",
    overridesResolver: (props, styles)=>styles.menuItem
})({});
const $c1fa2d74162b0d1a$var$TablePaginationDisplayedRows = (0, $g4l1t.default)("p", {
    name: "MuiTablePagination",
    slot: "DisplayedRows",
    overridesResolver: (props, styles)=>styles.displayedRows
})(({ theme: theme })=>(0, $4WYaH.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
function $c1fa2d74162b0d1a$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $c1fa2d74162b0d1a$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $c1fa2d74162b0d1a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        toolbar: [
            "toolbar"
        ],
        spacer: [
            "spacer"
        ],
        selectLabel: [
            "selectLabel"
        ],
        select: [
            "select"
        ],
        input: [
            "input"
        ],
        selectIcon: [
            "selectIcon"
        ],
        menuItem: [
            "menuItem"
        ],
        displayedRows: [
            "displayedRows"
        ],
        actions: [
            "actions"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $aSR7M.getTablePaginationUtilityClass), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $c1fa2d74162b0d1a$var$TablePagination = /*#__PURE__*/ $bh6RR.forwardRef(function TablePagination(inProps, ref) {
    var _slotProps$select;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTablePagination"
    });
    const { ActionsComponent: ActionsComponent = (0, $8TKyB.default), backIconButtonProps: backIconButtonProps, className: className, colSpan: colSpanProp, component: component = (0, $6RrdM.default), count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $c1fa2d74162b0d1a$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $c1fa2d74162b0d1a$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = "Rows per page:", nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $hCIyK.default)(props, $c1fa2d74162b0d1a$var$_excluded);
    const ownerState = props;
    const classes = $c1fa2d74162b0d1a$var$useUtilityClasses(ownerState);
    const selectProps = (_slotProps$select = slotProps == null ? void 0 : slotProps.select) != null ? _slotProps$select : SelectProps;
    const MenuItemComponent = selectProps.native ? "option" : $c1fa2d74162b0d1a$var$TablePaginationMenuItem;
    let colSpan;
    if (component === (0, $6RrdM.default) || component === "td") colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $5R8eh.default)(selectProps.id);
    const labelId = (0, $5R8eh.default)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)($c1fa2d74162b0d1a$var$TablePaginationRoot, (0, $4WYaH.default)({
        colSpan: colSpan,
        ref: ref,
        as: component,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)($c1fa2d74162b0d1a$var$TablePaginationToolbar, {
            className: classes.toolbar,
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)($c1fa2d74162b0d1a$var$TablePaginationSpacer, {
                    className: classes.spacer
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ih19M.jsx)($c1fa2d74162b0d1a$var$TablePaginationSelectLabel, {
                    className: classes.selectLabel,
                    id: labelId,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ih19M.jsx)($c1fa2d74162b0d1a$var$TablePaginationSelect, (0, $4WYaH.default)({
                    variant: "standard"
                }, !selectProps.variant && {
                    input: $c1fa2d74162b0d1a$var$_InputBase || ($c1fa2d74162b0d1a$var$_InputBase = /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {}))
                }, {
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId
                }, selectProps, {
                    classes: (0, $4WYaH.default)({}, selectProps.classes, {
                        // TODO v5 remove `classes.input`
                        root: (0, $aPsoC.default)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $aPsoC.default)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $aPsoC.default)(classes.selectIcon, (selectProps.classes || {}).icon)
                    }),
                    disabled: disabled,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $bh6RR.createElement)(MenuItemComponent, (0, $4WYaH.default)({}, !(0, $bLFa3.isHostComponent)(MenuItemComponent) && {
                            ownerState: ownerState
                        }, {
                            className: classes.menuItem,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }), rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                })),
                /*#__PURE__*/ (0, $ih19M.jsx)($c1fa2d74162b0d1a$var$TablePaginationDisplayedRows, {
                    className: classes.displayedRows,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    }));
});
var $c1fa2d74162b0d1a$export$2e2bcd8739ae039 = $c1fa2d74162b0d1a$var$TablePagination;

});
parcelRegister("bLFa3", function(module, exports) {

$parcel$export(module.exports, "isHostComponent", function () { return $89140338e0d83a08$export$e28348cc2430497; });
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $89140338e0d83a08$export$e28348cc2430497(element) {
    return typeof element === "string";
}

});

parcelRegister("dNs2U", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", function () { return $a0b59b49e43b8ab6$export$965edad20a84fa75; });
$parcel$export(module.exports, "inputOverridesResolver", function () { return $a0b59b49e43b8ab6$export$cf507b112810e72d; });
$parcel$export(module.exports, "InputBaseRoot", function () { return $a0b59b49e43b8ab6$export$298a043133d72a38; });
$parcel$export(module.exports, "InputBaseComponent", function () { return $a0b59b49e43b8ab6$export$a1ad29c901026019; });
$parcel$export(module.exports, "default", function () { return $a0b59b49e43b8ab6$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $2ZqBj = parcelRequire("2ZqBj");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");



var $kh05v = parcelRequire("kh05v");

var $bLFa3 = parcelRequire("bLFa3");

var $7J7Kn = parcelRequire("7J7Kn");

var $jjSic = parcelRequire("jjSic");

var $fbHce = parcelRequire("fbHce");

var $djfcj = parcelRequire("djfcj");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $fGH8N = parcelRequire("fGH8N");

var $erAkb = parcelRequire("erAkb");

var $iWGrV = parcelRequire("iWGrV");

var $9fFmW = parcelRequire("9fFmW");

var $7ENQK = parcelRequire("7ENQK");

var $k1IMo = parcelRequire("k1IMo");

var $ih19M = parcelRequire("ih19M");
"use client";
const $a0b59b49e43b8ab6$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $a0b59b49e43b8ab6$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $fGH8N.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $a0b59b49e43b8ab6$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $a0b59b49e43b8ab6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $fGH8N.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, $fGH8N.default)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $k1IMo.getInputBaseUtilityClass), classes);
};
const $a0b59b49e43b8ab6$export$298a043133d72a38 = (0, $g4l1t.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $a0b59b49e43b8ab6$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $k1IMo.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $4WYaH.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $a0b59b49e43b8ab6$export$a1ad29c901026019 = (0, $g4l1t.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $a0b59b49e43b8ab6$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $4WYaH.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $4WYaH.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $k1IMo.default).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $k1IMo.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $a0b59b49e43b8ab6$var$inputGlobalStyles = /*#__PURE__*/ (0, $ih19M.jsx)((0, $9fFmW.default), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $a0b59b49e43b8ab6$var$InputBase = /*#__PURE__*/ $bh6RR.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $hCIyK.default)(props, $a0b59b49e43b8ab6$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $bh6RR.useRef(value != null);
    const inputRef = $bh6RR.useRef();
    const handleInputRefWarning = $bh6RR.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $erAkb.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $bh6RR.useState(false);
    const muiFormControl = (0, $djfcj.default)();
    const fcs = (0, $jjSic.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $bh6RR.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $bh6RR.useCallback((obj)=>{
        if ((0, $7ENQK.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $iWGrV.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $2ZqBj.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $bh6RR.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $4WYaH.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $4WYaH.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $kh05v.TextareaAutosize);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $bh6RR.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $a0b59b49e43b8ab6$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $a0b59b49e43b8ab6$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $a0b59b49e43b8ab6$export$a1ad29c901026019;
    inputProps = (0, $4WYaH.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $a0b59b49e43b8ab6$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $ih19M.jsxs)(Root, (0, $4WYaH.default)({}, rootProps, !(0, $bLFa3.isHostComponent)(Root) && {
                ownerState: (0, $4WYaH.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $aPsoC.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $fbHce.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)(Input, (0, $4WYaH.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $bLFa3.isHostComponent)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $4WYaH.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $aPsoC.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $4WYaH.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $a0b59b49e43b8ab6$export$2e2bcd8739ae039 = $a0b59b49e43b8ab6$var$InputBase;

});
parcelRegister("kh05v", function(module, exports) {

$parcel$export(module.exports, "TextareaAutosize", function () { return $ec2576a168a4bb7d$export$d1710922ecaf577a; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $eQ4Io = parcelRequire("eQ4Io");
var $jqdHv = parcelRequire("jqdHv");
var $joJqx = parcelRequire("joJqx");
var $fpwfv = parcelRequire("fpwfv");

var $ih19M = parcelRequire("ih19M");
"use client";
const $ec2576a168a4bb7d$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $ec2576a168a4bb7d$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $ec2576a168a4bb7d$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $ec2576a168a4bb7d$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $ec2576a168a4bb7d$export$d1710922ecaf577a = /*#__PURE__*/ $bh6RR.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $hCIyK.default)(props, $ec2576a168a4bb7d$var$_excluded);
    const { current: isControlled } = $bh6RR.useRef(value != null);
    const inputRef = $bh6RR.useRef(null);
    const handleRef = (0, $fpwfv.default)(forwardedRef, inputRef);
    const shadowRef = $bh6RR.useRef(null);
    const calculateTextareaStyles = $bh6RR.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $jqdHv.default)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $ec2576a168a4bb7d$var$getStyleValue(computedStyle.paddingBottom) + $ec2576a168a4bb7d$var$getStyleValue(computedStyle.paddingTop);
        const border = $ec2576a168a4bb7d$var$getStyleValue(computedStyle.borderBottomWidth) + $ec2576a168a4bb7d$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = $bh6RR.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if ($ec2576a168a4bb7d$var$isEmpty(textareaStyles)) return;
        const input = inputRef.current;
        input.style.height = `${textareaStyles.outerHeightStyle}px`;
        input.style.overflow = textareaStyles.overflowing ? "hidden" : "";
    }, [
        calculateTextareaStyles
    ]);
    (0, $joJqx.default)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $eQ4Io.default)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $jqdHv.default)(input);
        containerWindow.addEventListener("resize", debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener("resize", debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, $joJqx.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("textarea", (0, $4WYaH.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows
            }, other)),
            /*#__PURE__*/ (0, $ih19M.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $4WYaH.default)({}, $ec2576a168a4bb7d$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});

});
parcelRegister("eQ4Io", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acd994508ee6890e$export$2e2bcd8739ae039; });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $acd994508ee6890e$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});

parcelRegister("jqdHv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e23b12b9b29d98ed$export$2e2bcd8739ae039; });

var $7TDiU = parcelRequire("7TDiU");
function $e23b12b9b29d98ed$export$2e2bcd8739ae039(node) {
    const doc = (0, $7TDiU.default)(node);
    return doc.defaultView || window;
}

});
parcelRegister("7TDiU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bfc286b4a48889d$export$2e2bcd8739ae039; });
function $5bfc286b4a48889d$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});



parcelRegister("jjSic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e109e804291f2556$export$2e2bcd8739ae039; });
function $e109e804291f2556$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("fbHce", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0e963fd279c7a5a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
/**
 * @ignore - internal component.
 */ const $b0e963fd279c7a5a$var$FormControlContext = /*#__PURE__*/ $bh6RR.createContext(undefined);
var $b0e963fd279c7a5a$export$2e2bcd8739ae039 = $b0e963fd279c7a5a$var$FormControlContext;

});

parcelRegister("djfcj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b08d69ddb3fa552$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $fbHce = parcelRequire("fbHce");
"use client";
function $9b08d69ddb3fa552$export$2e2bcd8739ae039() {
    return $bh6RR.useContext((0, $fbHce.default));
}

});

parcelRegister("iWGrV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcae9259d56f58e7$export$2e2bcd8739ae039; });

var $joJqx = parcelRequire("joJqx");
"use client";
var $dcae9259d56f58e7$export$2e2bcd8739ae039 = (0, $joJqx.default);

});

parcelRegister("9fFmW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bc59ad1fb4eb28d$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");
parcelRequire("bh6RR");


var $1EIH3 = parcelRequire("1EIH3");

var $OFmxN = parcelRequire("OFmxN");

var $wllwT = parcelRequire("wllwT");

var $ih19M = parcelRequire("ih19M");
"use client";
function $6bc59ad1fb4eb28d$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1EIH3.default), (0, $4WYaH.default)({}, props, {
        defaultTheme: (0, $OFmxN.default),
        themeId: (0, $wllwT.default)
    }));
}
var $6bc59ad1fb4eb28d$export$2e2bcd8739ae039 = $6bc59ad1fb4eb28d$var$GlobalStyles;

});
parcelRegister("1EIH3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $134c32104760d758$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");


var $6SFe5 = parcelRequire("6SFe5");

var $dm6dP = parcelRequire("dm6dP");

var $ih19M = parcelRequire("ih19M");
"use client";
function $134c32104760d758$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $dm6dP.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $6SFe5.default), {
        styles: globalStyles
    });
}
var $134c32104760d758$export$2e2bcd8739ae039 = $134c32104760d758$var$GlobalStyles;

});


parcelRegister("7ENQK", function(module, exports) {

$parcel$export(module.exports, "isFilled", function () { return $5932eff8f19cf69b$export$d652b828d7fdeff8; });
$parcel$export(module.exports, "isAdornedStart", function () { return $5932eff8f19cf69b$export$1b68bdfa56faeb5d; });
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $5932eff8f19cf69b$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $5932eff8f19cf69b$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($5932eff8f19cf69b$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $5932eff8f19cf69b$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $5932eff8f19cf69b$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRegister("k1IMo", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", function () { return $e946a2ecf6856961$export$ef57d5c8ca2278f6; });
$parcel$export(module.exports, "default", function () { return $e946a2ecf6856961$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $e946a2ecf6856961$export$ef57d5c8ca2278f6(slot) {
    return (0, $XybB6.default)("MuiInputBase", slot);
}
const $e946a2ecf6856961$var$inputBaseClasses = (0, $igcUF.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $e946a2ecf6856961$export$2e2bcd8739ae039 = $e946a2ecf6856961$var$inputBaseClasses;

});


parcelRegister("kY90d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f44064f4c316ac6a$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $cG3EF = parcelRequire("cG3EF");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $goHq9 = parcelRequire("goHq9");

var $aEoM0 = parcelRequire("aEoM0");

var $iWGrV = parcelRequire("iWGrV");

var $erAkb = parcelRequire("erAkb");

var $iQvLk = parcelRequire("iQvLk");

var $bqsaC = parcelRequire("bqsaC");

var $dQhw4 = parcelRequire("dQhw4");

var $f5abv = parcelRequire("f5abv");

var $ih19M = parcelRequire("ih19M");
"use client";
const $f44064f4c316ac6a$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $f44064f4c316ac6a$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $f44064f4c316ac6a$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $7J7Kn.default)(slots, (0, $f5abv.getMenuItemUtilityClass), classes);
    return (0, $4WYaH.default)({}, classes, composedClasses);
};
const $f44064f4c316ac6a$var$MenuItemRoot = (0, $g4l1t.default)((0, $aEoM0.default), {
    shouldForwardProp: (prop)=>(0, $g4l1t.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $f44064f4c316ac6a$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $f5abv.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cG3EF.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $f5abv.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cG3EF.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $f5abv.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $cG3EF.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cG3EF.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $f5abv.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $f5abv.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $iQvLk.default).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $iQvLk.default).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $dQhw4.default).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $dQhw4.default).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $bqsaC.default).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $4WYaH.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $bqsaC.default).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $f44064f4c316ac6a$var$MenuItem = /*#__PURE__*/ $bh6RR.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className } = props, other = (0, $hCIyK.default)(props, $f44064f4c316ac6a$var$_excluded);
    const context = $bh6RR.useContext((0, $goHq9.default));
    const childContext = $bh6RR.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $bh6RR.useRef(null);
    (0, $iWGrV.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $4WYaH.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $f44064f4c316ac6a$var$useUtilityClasses(props);
    const handleRef = (0, $erAkb.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $goHq9.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($f44064f4c316ac6a$var$MenuItemRoot, (0, $4WYaH.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $aPsoC.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $aPsoC.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $f44064f4c316ac6a$export$2e2bcd8739ae039 = $f44064f4c316ac6a$var$MenuItem;

});
parcelRegister("goHq9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf0091ae3cbbb604$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
"use client";
/**
 * @ignore - internal component.
 */ const $bf0091ae3cbbb604$var$ListContext = /*#__PURE__*/ $bh6RR.createContext({});
var $bf0091ae3cbbb604$export$2e2bcd8739ae039 = $bf0091ae3cbbb604$var$ListContext;

});

parcelRegister("iQvLk", function(module, exports) {

$parcel$export(module.exports, "getDividerUtilityClass", function () { return $db85b8a975ad3c17$export$46f01d01378ec5a2; });
$parcel$export(module.exports, "default", function () { return $db85b8a975ad3c17$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $db85b8a975ad3c17$export$46f01d01378ec5a2(slot) {
    return (0, $XybB6.default)("MuiDivider", slot);
}
const $db85b8a975ad3c17$var$dividerClasses = (0, $igcUF.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $db85b8a975ad3c17$export$2e2bcd8739ae039 = $db85b8a975ad3c17$var$dividerClasses;

});

parcelRegister("bqsaC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8517f9705d6fa9f4$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $8517f9705d6fa9f4$export$81478e24460c57f2(slot) {
    return (0, $XybB6.default)("MuiListItemIcon", slot);
}
const $8517f9705d6fa9f4$var$listItemIconClasses = (0, $igcUF.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $8517f9705d6fa9f4$export$2e2bcd8739ae039 = $8517f9705d6fa9f4$var$listItemIconClasses;

});

parcelRegister("dQhw4", function(module, exports) {

$parcel$export(module.exports, "getListItemTextUtilityClass", function () { return $a13db80f5b20edc5$export$1061006a0db3aeb5; });
$parcel$export(module.exports, "default", function () { return $a13db80f5b20edc5$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $a13db80f5b20edc5$export$1061006a0db3aeb5(slot) {
    return (0, $XybB6.default)("MuiListItemText", slot);
}
const $a13db80f5b20edc5$var$listItemTextClasses = (0, $igcUF.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $a13db80f5b20edc5$export$2e2bcd8739ae039 = $a13db80f5b20edc5$var$listItemTextClasses;

});

parcelRegister("f5abv", function(module, exports) {

$parcel$export(module.exports, "getMenuItemUtilityClass", function () { return $afaf391782c01b15$export$515f8c67b5305377; });
$parcel$export(module.exports, "default", function () { return $afaf391782c01b15$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $afaf391782c01b15$export$515f8c67b5305377(slot) {
    return (0, $XybB6.default)("MuiMenuItem", slot);
}
const $afaf391782c01b15$var$menuItemClasses = (0, $igcUF.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $afaf391782c01b15$export$2e2bcd8739ae039 = $afaf391782c01b15$var$menuItemClasses;

});


parcelRegister("5QlDC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $441297f24ebfba98$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $cseKH = parcelRequire("cseKH");

var $68EpC = parcelRequire("68EpC");

var $jjSic = parcelRequire("jjSic");

var $djfcj = parcelRequire("djfcj");

var $4bgmh = parcelRequire("4bgmh");

var $1958g = parcelRequire("1958g");

var $83QDW = parcelRequire("83QDW");

var $jTRoG = parcelRequire("jTRoG");

var $8D1KM = parcelRequire("8D1KM");

var $cNBED = parcelRequire("cNBED");

var $erAkb = parcelRequire("erAkb");

var $g4l1t = parcelRequire("g4l1t");

var $ih19M = parcelRequire("ih19M");
"use client";
const $441297f24ebfba98$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $441297f24ebfba98$var$_excluded2 = [
    "root"
];
const $441297f24ebfba98$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $441297f24ebfba98$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $g4l1t.rootShouldForwardProp)(prop) && prop !== "variant",
    slot: "Root"
};
const $441297f24ebfba98$var$StyledInput = (0, $g4l1t.default)((0, $1958g.default), $441297f24ebfba98$var$styledRootConfig)("");
const $441297f24ebfba98$var$StyledOutlinedInput = (0, $g4l1t.default)((0, $8D1KM.default), $441297f24ebfba98$var$styledRootConfig)("");
const $441297f24ebfba98$var$StyledFilledInput = (0, $g4l1t.default)((0, $jTRoG.default), $441297f24ebfba98$var$styledRootConfig)("");
const $441297f24ebfba98$var$Select = /*#__PURE__*/ $bh6RR.forwardRef(function Select(inProps, ref) {
    const props = (0, $cNBED.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $4bgmh.default), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $hCIyK.default)(props, $441297f24ebfba98$var$_excluded);
    const inputComponent = native ? (0, $83QDW.default) : (0, $68EpC.default);
    const muiFormControl = (0, $djfcj.default)();
    const fcs = (0, $jjSic.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $4WYaH.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $441297f24ebfba98$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $hCIyK.default)(classes, $441297f24ebfba98$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $ih19M.jsx)($441297f24ebfba98$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $ih19M.jsx)($441297f24ebfba98$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $ih19M.jsx)($441297f24ebfba98$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $erAkb.default)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Fragment, {
        children: /*#__PURE__*/ $bh6RR.cloneElement(InputComponent, (0, $4WYaH.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $4WYaH.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $4WYaH.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $cseKH.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $aPsoC.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$441297f24ebfba98$var$Select.muiName = "Select";
var $441297f24ebfba98$export$2e2bcd8739ae039 = $441297f24ebfba98$var$Select;

});
parcelRegister("68EpC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4782d674f565dc99$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $2ZqBj = parcelRequire("2ZqBj");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("f5Ssd");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $fVi1O = parcelRequire("fVi1O");


var $27yUY = parcelRequire("27yUY");

var $fGH8N = parcelRequire("fGH8N");

var $jfEbr = parcelRequire("jfEbr");

var $83QDW = parcelRequire("83QDW");

var $7ENQK = parcelRequire("7ENQK");

var $g4l1t = parcelRequire("g4l1t");

var $erAkb = parcelRequire("erAkb");

var $82V4F = parcelRequire("82V4F");

var $eLyTY = parcelRequire("eLyTY");

var $ih19M = parcelRequire("ih19M");
"use client";
var $4782d674f565dc99$var$_span;
const $4782d674f565dc99$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $4782d674f565dc99$var$SelectSelect = (0, $g4l1t.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $eLyTY.default).select}`]: styles.select
            },
            {
                [`&.${(0, $eLyTY.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $eLyTY.default).error}`]: styles.error
            },
            {
                [`&.${(0, $eLyTY.default).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $83QDW.nativeSelectSelectStyles), {
    // Win specificity over the input base
    [`&.${(0, $eLyTY.default).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $4782d674f565dc99$var$SelectIcon = (0, $g4l1t.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $fGH8N.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $83QDW.nativeSelectIconStyles));
const $4782d674f565dc99$var$SelectNativeInput = (0, $g4l1t.default)("input", {
    shouldForwardProp: (prop)=>(0, $g4l1t.slotShouldForwardProp)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $4782d674f565dc99$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $4782d674f565dc99$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $4782d674f565dc99$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $fGH8N.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $eLyTY.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const $4782d674f565dc99$var$SelectInput = /*#__PURE__*/ $bh6RR.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $hCIyK.default)(props, $4782d674f565dc99$var$_excluded);
    const [value, setValueState] = (0, $82V4F.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $82V4F.default)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $bh6RR.useRef(null);
    const displayRef = $bh6RR.useRef(null);
    const [displayNode, setDisplayNode] = $bh6RR.useState(null);
    const { current: isOpenControlled } = $bh6RR.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $bh6RR.useState();
    const handleRef = (0, $erAkb.default)(ref, inputRefProp);
    const handleDisplayRef = $bh6RR.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $bh6RR.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $bh6RR.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $bh6RR.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $bh6RR.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $27yUY.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $bh6RR.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $7ENQK.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $bh6RR.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $2ZqBj.default)(2));
            selected = value.some((v)=>$4782d674f565dc99$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $4782d674f565dc99$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $bh6RR.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $4WYaH.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $4782d674f565dc99$var$useUtilityClasses(ownerState);
    const paperProps = (0, $4WYaH.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $fVi1O.default)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($4782d674f565dc99$var$SelectSelect, (0, $4WYaH.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $aPsoC.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $4782d674f565dc99$var$isEmpty(display) ? $4782d674f565dc99$var$_span || ($4782d674f565dc99$var$_span = /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $ih19M.jsx)($4782d674f565dc99$var$SelectNativeInput, (0, $4WYaH.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $ih19M.jsx)($4782d674f565dc99$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jfEbr.default), (0, $4WYaH.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $4WYaH.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    "aria-multiselectable": multiple ? "true" : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $4WYaH.default)({}, MenuProps.slotProps, {
                    paper: (0, $4WYaH.default)({}, paperProps, {
                        style: (0, $4WYaH.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $4782d674f565dc99$export$2e2bcd8739ae039 = $4782d674f565dc99$var$SelectInput;

});
parcelRegister("f5Ssd", function(module, exports) {
"use strict";

module.exports = (parcelRequire("b701j"));

});
parcelRegister("b701j", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $81705d27164b8443$export$a7c73072b1a182ae; }, function (v) { return $81705d27164b8443$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $81705d27164b8443$export$9f27bc3417b4524d; }, function (v) { return $81705d27164b8443$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $81705d27164b8443$export$db77ccec0bb4ccac; }, function (v) { return $81705d27164b8443$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $81705d27164b8443$export$8392c0c9d3dcbd35; }, function (v) { return $81705d27164b8443$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $81705d27164b8443$export$ffb0004e005737fa; }, function (v) { return $81705d27164b8443$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $81705d27164b8443$export$b624eff549462981; }, function (v) { return $81705d27164b8443$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $81705d27164b8443$export$7897aa7841a5380c; }, function (v) { return $81705d27164b8443$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $81705d27164b8443$export$602eac185826482c; }, function (v) { return $81705d27164b8443$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $81705d27164b8443$export$e2c29f18771995cb; }, function (v) { return $81705d27164b8443$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $81705d27164b8443$export$5f8d39834fd61797; }, function (v) { return $81705d27164b8443$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $81705d27164b8443$export$74bf444e3cd11ea5; }, function (v) { return $81705d27164b8443$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $81705d27164b8443$export$998bcd577473dd93; }, function (v) { return $81705d27164b8443$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $81705d27164b8443$export$92387174baf9b227; }, function (v) { return $81705d27164b8443$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $81705d27164b8443$export$ec112efeb987d9c6; }, function (v) { return $81705d27164b8443$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $81705d27164b8443$export$b706b080d889d2c9; }, function (v) { return $81705d27164b8443$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $81705d27164b8443$export$5be5a87408f70ddc; }, function (v) { return $81705d27164b8443$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $81705d27164b8443$export$45a5e7f76e0caa8d; }, function (v) { return $81705d27164b8443$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $81705d27164b8443$export$455c2e768291efa6; }, function (v) { return $81705d27164b8443$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $81705d27164b8443$export$9522e17588c12572; }, function (v) { return $81705d27164b8443$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $81705d27164b8443$export$2110ac352bb060b9; }, function (v) { return $81705d27164b8443$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $81705d27164b8443$export$56885ab8b9c456ab; }, function (v) { return $81705d27164b8443$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $81705d27164b8443$export$d927fcb6adf8f9de; }, function (v) { return $81705d27164b8443$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $81705d27164b8443$export$b82d16f27459e05a; }, function (v) { return $81705d27164b8443$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $81705d27164b8443$export$522c17b4f5e123e8; }, function (v) { return $81705d27164b8443$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $81705d27164b8443$export$1aabd8a0274ecfd6; }, function (v) { return $81705d27164b8443$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $81705d27164b8443$export$3d6c20d97e46b957; }, function (v) { return $81705d27164b8443$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $81705d27164b8443$export$9b621391a187a31a; }, function (v) { return $81705d27164b8443$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $81705d27164b8443$export$f5bbd400c2f4426f; }, function (v) { return $81705d27164b8443$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $81705d27164b8443$export$a7c73072b1a182ae;
var $81705d27164b8443$export$9f27bc3417b4524d;
var $81705d27164b8443$export$db77ccec0bb4ccac;
var $81705d27164b8443$export$8392c0c9d3dcbd35;
var $81705d27164b8443$export$ffb0004e005737fa;
var $81705d27164b8443$export$b624eff549462981;
var $81705d27164b8443$export$7897aa7841a5380c;
var $81705d27164b8443$export$602eac185826482c;
var $81705d27164b8443$export$e2c29f18771995cb;
var $81705d27164b8443$export$5f8d39834fd61797;
var $81705d27164b8443$export$74bf444e3cd11ea5;
var $81705d27164b8443$export$998bcd577473dd93;
var $81705d27164b8443$export$92387174baf9b227;
var $81705d27164b8443$export$ec112efeb987d9c6;
var $81705d27164b8443$export$b706b080d889d2c9;
var $81705d27164b8443$export$5be5a87408f70ddc;
var $81705d27164b8443$export$45a5e7f76e0caa8d;
var $81705d27164b8443$export$455c2e768291efa6;
var $81705d27164b8443$export$9522e17588c12572;
var $81705d27164b8443$export$2110ac352bb060b9;
var $81705d27164b8443$export$56885ab8b9c456ab;
var $81705d27164b8443$export$d927fcb6adf8f9de;
var $81705d27164b8443$export$b82d16f27459e05a;
var $81705d27164b8443$export$522c17b4f5e123e8;
var $81705d27164b8443$export$1aabd8a0274ecfd6;
var $81705d27164b8443$export$3d6c20d97e46b957;
var $81705d27164b8443$export$9b621391a187a31a;
var $81705d27164b8443$export$f5bbd400c2f4426f;
"use strict";
var $81705d27164b8443$var$b = Symbol.for("react.element"), $81705d27164b8443$var$c = Symbol.for("react.portal"), $81705d27164b8443$var$d = Symbol.for("react.fragment"), $81705d27164b8443$var$e = Symbol.for("react.strict_mode"), $81705d27164b8443$var$f = Symbol.for("react.profiler"), $81705d27164b8443$var$g = Symbol.for("react.provider"), $81705d27164b8443$var$h = Symbol.for("react.context"), $81705d27164b8443$var$k = Symbol.for("react.server_context"), $81705d27164b8443$var$l = Symbol.for("react.forward_ref"), $81705d27164b8443$var$m = Symbol.for("react.suspense"), $81705d27164b8443$var$n = Symbol.for("react.suspense_list"), $81705d27164b8443$var$p = Symbol.for("react.memo"), $81705d27164b8443$var$q = Symbol.for("react.lazy"), $81705d27164b8443$var$t = Symbol.for("react.offscreen"), $81705d27164b8443$var$u;
$81705d27164b8443$var$u = Symbol.for("react.module.reference");
function $81705d27164b8443$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $81705d27164b8443$var$b:
                switch(a = a.type, a){
                    case $81705d27164b8443$var$d:
                    case $81705d27164b8443$var$f:
                    case $81705d27164b8443$var$e:
                    case $81705d27164b8443$var$m:
                    case $81705d27164b8443$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $81705d27164b8443$var$k:
                            case $81705d27164b8443$var$h:
                            case $81705d27164b8443$var$l:
                            case $81705d27164b8443$var$q:
                            case $81705d27164b8443$var$p:
                            case $81705d27164b8443$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $81705d27164b8443$var$c:
                return r;
        }
    }
}
$81705d27164b8443$export$a7c73072b1a182ae = $81705d27164b8443$var$h;
$81705d27164b8443$export$9f27bc3417b4524d = $81705d27164b8443$var$g;
$81705d27164b8443$export$db77ccec0bb4ccac = $81705d27164b8443$var$b;
$81705d27164b8443$export$8392c0c9d3dcbd35 = $81705d27164b8443$var$l;
$81705d27164b8443$export$ffb0004e005737fa = $81705d27164b8443$var$d;
$81705d27164b8443$export$b624eff549462981 = $81705d27164b8443$var$q;
$81705d27164b8443$export$7897aa7841a5380c = $81705d27164b8443$var$p;
$81705d27164b8443$export$602eac185826482c = $81705d27164b8443$var$c;
$81705d27164b8443$export$e2c29f18771995cb = $81705d27164b8443$var$f;
$81705d27164b8443$export$5f8d39834fd61797 = $81705d27164b8443$var$e;
$81705d27164b8443$export$74bf444e3cd11ea5 = $81705d27164b8443$var$m;
$81705d27164b8443$export$998bcd577473dd93 = $81705d27164b8443$var$n;
$81705d27164b8443$export$92387174baf9b227 = function() {
    return !1;
};
$81705d27164b8443$export$ec112efeb987d9c6 = function() {
    return !1;
};
$81705d27164b8443$export$b706b080d889d2c9 = function(a) {
    return $81705d27164b8443$var$v(a) === $81705d27164b8443$var$h;
};
$81705d27164b8443$export$5be5a87408f70ddc = function(a) {
    return $81705d27164b8443$var$v(a) === $81705d27164b8443$var$g;
};
$81705d27164b8443$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $81705d27164b8443$var$b;
};
$81705d27164b8443$export$455c2e768291efa6 = function(a) {
    return $81705d27164b8443$var$v(a) === $81705d27164b8443$var$l;
};
$81705d27164b8443$export$9522e17588c12572 = function(a) {
    return $81705d27164b8443$var$v(a) === $81705d27164b8443$var$d;
};
$81705d27164b8443$export$2110ac352bb060b9 = function(a) {
    return $81705d27164b8443$var$v(a) === $81705d27164b8443$var$q;
};
$81705d27164b8443$export$56885ab8b9c456ab = function(a) {
    return $81705d27164b8443$var$v(a) === $81705d27164b8443$var$p;
};
$81705d27164b8443$export$d927fcb6adf8f9de = function(a) {
    return $81705d27164b8443$var$v(a) === $81705d27164b8443$var$c;
};
$81705d27164b8443$export$b82d16f27459e05a = function(a) {
    return $81705d27164b8443$var$v(a) === $81705d27164b8443$var$f;
};
$81705d27164b8443$export$522c17b4f5e123e8 = function(a) {
    return $81705d27164b8443$var$v(a) === $81705d27164b8443$var$e;
};
$81705d27164b8443$export$1aabd8a0274ecfd6 = function(a) {
    return $81705d27164b8443$var$v(a) === $81705d27164b8443$var$m;
};
$81705d27164b8443$export$3d6c20d97e46b957 = function(a) {
    return $81705d27164b8443$var$v(a) === $81705d27164b8443$var$n;
};
$81705d27164b8443$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $81705d27164b8443$var$d || a === $81705d27164b8443$var$f || a === $81705d27164b8443$var$e || a === $81705d27164b8443$var$m || a === $81705d27164b8443$var$n || a === $81705d27164b8443$var$t || "object" === typeof a && null !== a && (a.$$typeof === $81705d27164b8443$var$q || a.$$typeof === $81705d27164b8443$var$p || a.$$typeof === $81705d27164b8443$var$g || a.$$typeof === $81705d27164b8443$var$h || a.$$typeof === $81705d27164b8443$var$l || a.$$typeof === $81705d27164b8443$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$81705d27164b8443$export$f5bbd400c2f4426f = $81705d27164b8443$var$v;

});


parcelRegister("fVi1O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b97a29eba5f9a048$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
"use client";
let $b97a29eba5f9a048$var$globalId = 0;
function $b97a29eba5f9a048$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $bh6RR.useState(idOverride);
    const id = idOverride || defaultId;
    $bh6RR.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $b97a29eba5f9a048$var$globalId += 1;
            setDefaultId(`mui-${$b97a29eba5f9a048$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $b97a29eba5f9a048$var$maybeReactUseId = $bh6RR["useId".toString()];
function $b97a29eba5f9a048$export$2e2bcd8739ae039(idOverride) {
    if ($b97a29eba5f9a048$var$maybeReactUseId !== undefined) {
        const reactId = $b97a29eba5f9a048$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $b97a29eba5f9a048$var$useGlobalId(idOverride);
}

});

parcelRegister("27yUY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18b75235194c199d$export$2e2bcd8739ae039; });

var $7TDiU = parcelRequire("7TDiU");
var $18b75235194c199d$export$2e2bcd8739ae039 = (0, $7TDiU.default);

});

parcelRegister("jfEbr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e03e96a117c75697$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("f5Ssd");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $7ITag = parcelRequire("7ITag");


var $i4bt9 = parcelRequire("i4bt9");

var $9Dw6r = parcelRequire("9Dw6r");

var $g4l1t = parcelRequire("g4l1t");

var $8gyMY = parcelRequire("8gyMY");

var $cNBED = parcelRequire("cNBED");

var $5wAd2 = parcelRequire("5wAd2");

var $ih19M = parcelRequire("ih19M");
"use client";
const $e03e96a117c75697$var$_excluded = [
    "onEntering"
], $e03e96a117c75697$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $e03e96a117c75697$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $e03e96a117c75697$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $e03e96a117c75697$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $5wAd2.getMenuUtilityClass), classes);
};
const $e03e96a117c75697$var$MenuRoot = (0, $g4l1t.default)((0, $9Dw6r.default), {
    shouldForwardProp: (prop)=>(0, $g4l1t.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $e03e96a117c75697$export$4f7c51a5920c9f33 = (0, $g4l1t.default)((0, $9Dw6r.PopoverPaper), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $e03e96a117c75697$var$MenuMenuList = (0, $g4l1t.default)((0, $i4bt9.default), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $e03e96a117c75697$var$Menu = /*#__PURE__*/ $bh6RR.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $hCIyK.default)(props.TransitionProps, $e03e96a117c75697$var$_excluded), other = (0, $hCIyK.default)(props, $e03e96a117c75697$var$_excluded2);
    const theme = (0, $8gyMY.default)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $4WYaH.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $e03e96a117c75697$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $bh6RR.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $bh6RR.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $bh6RR.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $e03e96a117c75697$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $7ITag.useSlotProps)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $7ITag.useSlotProps)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)($e03e96a117c75697$var$MenuRoot, (0, $4WYaH.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $e03e96a117c75697$var$RTL_ORIGIN : $e03e96a117c75697$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $4WYaH.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($e03e96a117c75697$var$MenuMenuList, (0, $4WYaH.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $aPsoC.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $e03e96a117c75697$export$2e2bcd8739ae039 = $e03e96a117c75697$var$Menu;

});
parcelRegister("7ITag", function(module, exports) {

$parcel$export(module.exports, "useSlotProps", function () { return $59f76f0115628c32$export$1e5c9e6e4e15efe3; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $fpwfv = parcelRequire("fpwfv");

var $95U3o = parcelRequire("95U3o");

var $7NHbQ = parcelRequire("7NHbQ");

var $4Mv5B = parcelRequire("4Mv5B");
"use client";
const $59f76f0115628c32$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $59f76f0115628c32$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $hCIyK.default)(parameters, $59f76f0115628c32$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $4Mv5B.resolveComponentProps)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $7NHbQ.mergeSlotProps)((0, $4WYaH.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $fpwfv.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $95U3o.appendOwnerState)(elementType, (0, $4WYaH.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}

});
parcelRegister("95U3o", function(module, exports) {

$parcel$export(module.exports, "appendOwnerState", function () { return $69f00fcefdfcbe82$export$b089efb01a7bdf50; });

var $4WYaH = parcelRequire("4WYaH");

var $bLFa3 = parcelRequire("bLFa3");
function $69f00fcefdfcbe82$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $bLFa3.isHostComponent)(elementType)) return otherProps;
    return (0, $4WYaH.default)({}, otherProps, {
        ownerState: (0, $4WYaH.default)({}, otherProps.ownerState, ownerState)
    });
}

});

parcelRegister("7NHbQ", function(module, exports) {

$parcel$export(module.exports, "mergeSlotProps", function () { return $5ade9caa5bce179d$export$b01d1e419b049226; });

var $4WYaH = parcelRequire("4WYaH");

var $aPsoC = parcelRequire("aPsoC");

var $kLmLK = parcelRequire("kLmLK");

var $lGuRm = parcelRequire("lGuRm");
function $5ade9caa5bce179d$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $aPsoC.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $4WYaH.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $4WYaH.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $kLmLK.extractEventHandlers)((0, $4WYaH.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $lGuRm.omitEventHandlers)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $lGuRm.omitEventHandlers)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $aPsoC.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $4WYaH.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $4WYaH.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}

});
parcelRegister("kLmLK", function(module, exports) {

$parcel$export(module.exports, "extractEventHandlers", function () { return $f1d9dbe76af4afdb$export$24d5698b57eff81c; });
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $f1d9dbe76af4afdb$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}

});

parcelRegister("lGuRm", function(module, exports) {

$parcel$export(module.exports, "omitEventHandlers", function () { return $fc95754d996e5d47$export$2ac0fa4d3a39be45; });
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $fc95754d996e5d47$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}

});


parcelRegister("4Mv5B", function(module, exports) {

$parcel$export(module.exports, "resolveComponentProps", function () { return $37b3c2ce0c992b04$export$308c24034cde71de; });
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $37b3c2ce0c992b04$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}

});


parcelRegister("i4bt9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2717f3bdfc4469f$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("f5Ssd");


var $27yUY = parcelRequire("27yUY");

var $17TrO = parcelRequire("17TrO");

var $covRi = parcelRequire("covRi");

var $erAkb = parcelRequire("erAkb");

var $iWGrV = parcelRequire("iWGrV");

var $ih19M = parcelRequire("ih19M");
"use client";
const $d2717f3bdfc4469f$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $d2717f3bdfc4469f$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $d2717f3bdfc4469f$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $d2717f3bdfc4469f$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $d2717f3bdfc4469f$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$d2717f3bdfc4469f$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $d2717f3bdfc4469f$var$MenuList = /*#__PURE__*/ $bh6RR.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $hCIyK.default)(props, $d2717f3bdfc4469f$var$_excluded);
    const listRef = $bh6RR.useRef(null);
    const textCriteriaRef = $bh6RR.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $iWGrV.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $bh6RR.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $covRi.default)((0, $27yUY.default)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $27yUY.default)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $d2717f3bdfc4469f$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $d2717f3bdfc4469f$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $d2717f3bdfc4469f$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $d2717f3bdfc4469f$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $d2717f3bdfc4469f$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $d2717f3bdfc4469f$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $d2717f3bdfc4469f$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $d2717f3bdfc4469f$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $d2717f3bdfc4469f$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $d2717f3bdfc4469f$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $d2717f3bdfc4469f$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $erAkb.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $bh6RR.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $bh6RR.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $bh6RR.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $bh6RR.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $17TrO.default), (0, $4WYaH.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $d2717f3bdfc4469f$export$2e2bcd8739ae039 = $d2717f3bdfc4469f$var$MenuList;

});
parcelRegister("17TrO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d21749f81dc4807$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $goHq9 = parcelRequire("goHq9");

var $9hljg = parcelRequire("9hljg");

var $ih19M = parcelRequire("ih19M");
"use client";
const $0d21749f81dc4807$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $0d21749f81dc4807$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $9hljg.getListUtilityClass), classes);
};
const $0d21749f81dc4807$var$ListRoot = (0, $g4l1t.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $0d21749f81dc4807$var$List = /*#__PURE__*/ $bh6RR.forwardRef(function List(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $hCIyK.default)(props, $0d21749f81dc4807$var$_excluded);
    const context = $bh6RR.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $0d21749f81dc4807$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $goHq9.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)($0d21749f81dc4807$var$ListRoot, (0, $4WYaH.default)({
            as: component,
            className: (0, $aPsoC.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $0d21749f81dc4807$export$2e2bcd8739ae039 = $0d21749f81dc4807$var$List;

});
parcelRegister("9hljg", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", function () { return $6c163b430aaf082c$export$c6bd6795ed6e3203; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $6c163b430aaf082c$export$c6bd6795ed6e3203(slot) {
    return (0, $XybB6.default)("MuiList", slot);
}
const $6c163b430aaf082c$var$listClasses = (0, $igcUF.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $6c163b430aaf082c$export$2e2bcd8739ae039 = $6c163b430aaf082c$var$listClasses;

});


parcelRegister("covRi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9060705fcf5f7de2$export$2e2bcd8739ae039; });

var $e8UWb = parcelRequire("e8UWb");
var $9060705fcf5f7de2$export$2e2bcd8739ae039 = (0, $e8UWb.default);

});
parcelRegister("e8UWb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4bdfa9c3da74149$export$2e2bcd8739ae039; });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $a4bdfa9c3da74149$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}

});



parcelRegister("9Dw6r", function(module, exports) {

$parcel$export(module.exports, "PopoverPaper", function () { return $7040a88a1261c916$export$821346c38a2d9390; });
$parcel$export(module.exports, "default", function () { return $7040a88a1261c916$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $bLFa3 = parcelRequire("bLFa3");
var $7ITag = parcelRequire("7ITag");

var $7J7Kn = parcelRequire("7J7Kn");






var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $4lWVQ = parcelRequire("4lWVQ");

var $27yUY = parcelRequire("27yUY");

var $kPbNB = parcelRequire("kPbNB");

var $erAkb = parcelRequire("erAkb");

var $clZiP = parcelRequire("clZiP");

var $cXsrx = parcelRequire("cXsrx");

var $iTI7v = parcelRequire("iTI7v");

var $bUvp2 = parcelRequire("bUvp2");

var $ih19M = parcelRequire("ih19M");
"use client";
const $7040a88a1261c916$var$_excluded = [
    "onEntering"
], $7040a88a1261c916$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $7040a88a1261c916$var$_excluded3 = [
    "slotProps"
];
function $7040a88a1261c916$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $7040a88a1261c916$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $7040a88a1261c916$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $7040a88a1261c916$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $7040a88a1261c916$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $bUvp2.getPopoverUtilityClass), classes);
};
const $7040a88a1261c916$export$bcce13685275fc99 = (0, $g4l1t.default)((0, $cXsrx.default), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $7040a88a1261c916$export$821346c38a2d9390 = (0, $g4l1t.default)((0, $iTI7v.default), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $7040a88a1261c916$var$Popover = /*#__PURE__*/ $bh6RR.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $clZiP.default), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $hCIyK.default)(props.TransitionProps, $7040a88a1261c916$var$_excluded), other = (0, $hCIyK.default)(props, $7040a88a1261c916$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $bh6RR.useRef();
    const handlePaperRef = (0, $erAkb.default)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $4WYaH.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $7040a88a1261c916$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $bh6RR.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $7040a88a1261c916$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $27yUY.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $7040a88a1261c916$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $7040a88a1261c916$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $bh6RR.useCallback((elemRect)=>{
        return {
            vertical: $7040a88a1261c916$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $7040a88a1261c916$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $bh6RR.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $7040a88a1261c916$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $kPbNB.default)($7040a88a1261c916$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $7040a88a1261c916$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $bh6RR.useState(open);
    const setPositioningStyles = $bh6RR.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $bh6RR.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $bh6RR.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $bh6RR.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $bh6RR.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $4lWVQ.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $kPbNB.default)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $27yUY.default)($7040a88a1261c916$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $7040a88a1261c916$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $7040a88a1261c916$export$821346c38a2d9390;
    const paperProps = (0, $7ITag.useSlotProps)({
        elementType: PaperSlot,
        externalSlotProps: (0, $4WYaH.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $4WYaH.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $7ITag.useSlotProps)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $hCIyK.default)(_useSlotProps, $7040a88a1261c916$var$_excluded3);
    return /*#__PURE__*/ (0, $ih19M.jsx)(RootSlot, (0, $4WYaH.default)({}, rootProps, !(0, $bLFa3.isHostComponent)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ih19M.jsx)(PaperSlot, (0, $4WYaH.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $7040a88a1261c916$export$2e2bcd8739ae039 = $7040a88a1261c916$var$Popover;

});
parcelRegister("4lWVQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32b6d6434f5dfddb$export$2e2bcd8739ae039; });

var $eQ4Io = parcelRequire("eQ4Io");
var $32b6d6434f5dfddb$export$2e2bcd8739ae039 = (0, $eQ4Io.default);

});

parcelRegister("kPbNB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f291b92187f148d8$export$2e2bcd8739ae039; });

var $jqdHv = parcelRequire("jqdHv");
var $f291b92187f148d8$export$2e2bcd8739ae039 = (0, $jqdHv.default);

});

parcelRegister("clZiP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fe6ff9ee2f854fb$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $edgJc = parcelRequire("edgJc");


var $7ARPd = parcelRequire("7ARPd");

var $8gyMY = parcelRequire("8gyMY");

var $6SHzw = parcelRequire("6SHzw");

var $erAkb = parcelRequire("erAkb");

var $ih19M = parcelRequire("ih19M");
"use client";
const $8fe6ff9ee2f854fb$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $8fe6ff9ee2f854fb$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $8fe6ff9ee2f854fb$var$styles = {
    entering: {
        opacity: 1,
        transform: $8fe6ff9ee2f854fb$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $8fe6ff9ee2f854fb$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $8fe6ff9ee2f854fb$var$Grow = /*#__PURE__*/ $bh6RR.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $7ARPd.default) } = props, other = (0, $hCIyK.default)(props, $8fe6ff9ee2f854fb$var$_excluded);
    const timer = (0, $edgJc.default)();
    const autoTimeout = $bh6RR.useRef();
    const theme = (0, $8gyMY.default)();
    const nodeRef = $bh6RR.useRef(null);
    const handleRef = (0, $erAkb.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $6SHzw.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $6SHzw.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $8fe6ff9ee2f854fb$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $6SHzw.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $8fe6ff9ee2f854fb$var$isWebKit154 ? duration : duration * 0.666,
                delay: $8fe6ff9ee2f854fb$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $8fe6ff9ee2f854fb$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $bh6RR.cloneElement(children, (0, $4WYaH.default)({
                style: (0, $4WYaH.default)({
                    opacity: 0,
                    transform: $8fe6ff9ee2f854fb$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $8fe6ff9ee2f854fb$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$8fe6ff9ee2f854fb$var$Grow.muiSupportAuto = true;
var $8fe6ff9ee2f854fb$export$2e2bcd8739ae039 = $8fe6ff9ee2f854fb$var$Grow;

});
parcelRegister("7ARPd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5875a5c0de10c551$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $gMqD6 = parcelRequire("gMqD6");


var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");

var $3SX21 = parcelRequire("3SX21");


var $70uTP = parcelRequire("70uTP");

var $klu5V = parcelRequire("klu5V");
var $5875a5c0de10c551$export$bb38bb9a1161268 = "unmounted";
var $5875a5c0de10c551$export$84cbff306f539230 = "exited";
var $5875a5c0de10c551$export$df38205c966be359 = "entering";
var $5875a5c0de10c551$export$78e9e6e3e014d60a = "entered";
var $5875a5c0de10c551$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $5875a5c0de10c551$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $gMqD6.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $5875a5c0de10c551$export$84cbff306f539230;
                _this.appearStatus = $5875a5c0de10c551$export$df38205c966be359;
            } else initialStatus = $5875a5c0de10c551$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $5875a5c0de10c551$export$bb38bb9a1161268;
        else initialStatus = $5875a5c0de10c551$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $5875a5c0de10c551$export$bb38bb9a1161268) return {
            status: $5875a5c0de10c551$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $5875a5c0de10c551$export$df38205c966be359 && status !== $5875a5c0de10c551$export$78e9e6e3e014d60a) nextStatus = $5875a5c0de10c551$export$df38205c966be359;
            } else if (status === $5875a5c0de10c551$export$df38205c966be359 || status === $5875a5c0de10c551$export$78e9e6e3e014d60a) nextStatus = $5875a5c0de10c551$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $5875a5c0de10c551$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $klu5V.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $5875a5c0de10c551$export$84cbff306f539230) this.setState({
            status: $5875a5c0de10c551$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $3SX21.default).disabled) {
            this.safeSetState({
                status: $5875a5c0de10c551$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $5875a5c0de10c551$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $5875a5c0de10c551$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $3SX21.default).disabled) {
            this.safeSetState({
                status: $5875a5c0de10c551$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $5875a5c0de10c551$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $5875a5c0de10c551$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $5875a5c0de10c551$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $hCIyK.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $70uTP.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$5875a5c0de10c551$var$Transition.contextType = (0, $70uTP.default);
$5875a5c0de10c551$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $5875a5c0de10c551$var$noop() {}
$5875a5c0de10c551$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $5875a5c0de10c551$var$noop,
    onEntering: $5875a5c0de10c551$var$noop,
    onEntered: $5875a5c0de10c551$var$noop,
    onExit: $5875a5c0de10c551$var$noop,
    onExiting: $5875a5c0de10c551$var$noop,
    onExited: $5875a5c0de10c551$var$noop
};
$5875a5c0de10c551$var$Transition.UNMOUNTED = $5875a5c0de10c551$export$bb38bb9a1161268;
$5875a5c0de10c551$var$Transition.EXITED = $5875a5c0de10c551$export$84cbff306f539230;
$5875a5c0de10c551$var$Transition.ENTERING = $5875a5c0de10c551$export$df38205c966be359;
$5875a5c0de10c551$var$Transition.ENTERED = $5875a5c0de10c551$export$78e9e6e3e014d60a;
$5875a5c0de10c551$var$Transition.EXITING = $5875a5c0de10c551$export$4aacc83d4d59139f;
var $5875a5c0de10c551$export$2e2bcd8739ae039 = $5875a5c0de10c551$var$Transition;

});
parcelRegister("3SX21", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d4434ad62cd5cee$export$2e2bcd8739ae039; });
var $2d4434ad62cd5cee$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("klu5V", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $ecfd1cf4e45b6881$export$7d26bbb1236dafd6; });
var $ecfd1cf4e45b6881$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("6SHzw", function(module, exports) {

$parcel$export(module.exports, "reflow", function () { return $502995b8d9f16242$export$b7a864e1eaef9de5; });
$parcel$export(module.exports, "getTransitionProps", function () { return $502995b8d9f16242$export$8cb1e9b404609ae9; });
const $502995b8d9f16242$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $502995b8d9f16242$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}

});


parcelRegister("cXsrx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96f10eeb79eab37c$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");



var $7ITag = parcelRequire("7ITag");

var $3dkzN = parcelRequire("3dkzN");

var $7J7Kn = parcelRequire("7J7Kn");

var $jfyRA = parcelRequire("jfyRA");

var $8FFT1 = parcelRequire("8FFT1");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $74PV0 = parcelRequire("74PV0");

var $hSckl = parcelRequire("hSckl");

var $ih19M = parcelRequire("ih19M");
"use client";
const $96f10eeb79eab37c$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $96f10eeb79eab37c$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $hSckl.getModalUtilityClass), classes);
};
const $96f10eeb79eab37c$var$ModalRoot = (0, $g4l1t.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $96f10eeb79eab37c$var$ModalBackdrop = (0, $g4l1t.default)((0, $74PV0.default), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $96f10eeb79eab37c$var$Modal = /*#__PURE__*/ $bh6RR.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $cNBED.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $96f10eeb79eab37c$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $hCIyK.default)(props, $96f10eeb79eab37c$var$_excluded);
    const propsWithDefaults = (0, $4WYaH.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $3dkzN.useModal)((0, $4WYaH.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $4WYaH.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $96f10eeb79eab37c$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $96f10eeb79eab37c$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $7ITag.useSlotProps)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $aPsoC.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $7ITag.useSlotProps)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $4WYaH.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $aPsoC.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8FFT1.Portal), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)(RootSlot, (0, $4WYaH.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ih19M.jsx)(BackdropSlot, (0, $4WYaH.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $jfyRA.FocusTrap), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $bh6RR.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $96f10eeb79eab37c$export$2e2bcd8739ae039 = $96f10eeb79eab37c$var$Modal;

});
parcelRegister("3dkzN", function(module, exports) {

$parcel$export(module.exports, "useModal", function () { return $25728c0d23185f0e$export$33ffd74ebf07f060; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $keUKf = parcelRequire("keUKf");
var $7TDiU = parcelRequire("7TDiU");
var $5EGAX = parcelRequire("5EGAX");
var $fpwfv = parcelRequire("fpwfv");

var $kLmLK = parcelRequire("kLmLK");

var $4U6ZI = parcelRequire("4U6ZI");
"use client";
function $25728c0d23185f0e$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $25728c0d23185f0e$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $25728c0d23185f0e$var$defaultManager = new (0, $4U6ZI.ModalManager)();
function $25728c0d23185f0e$export$33ffd74ebf07f060(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $25728c0d23185f0e$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $bh6RR.useRef({});
    const mountNodeRef = $bh6RR.useRef(null);
    const modalRef = $bh6RR.useRef(null);
    const handleRef = (0, $fpwfv.default)(modalRef, rootRef);
    const [exited, setExited] = $bh6RR.useState(!open);
    const hasTransition = $25728c0d23185f0e$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $7TDiU.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $5EGAX.default)(()=>{
        const resolvedContainer = $25728c0d23185f0e$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $bh6RR.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $5EGAX.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $4U6ZI.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $bh6RR.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $bh6RR.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $bh6RR.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $kLmLK.extractEventHandlers)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $4WYaH.default)({}, propsEventHandlers, otherHandlers);
        return (0, $4WYaH.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $4WYaH.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $keUKf.default)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $keUKf.default)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}

});
parcelRegister("keUKf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebc121ce5c24382e$export$2e2bcd8739ae039; });
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $ebc121ce5c24382e$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRegister("4U6ZI", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", function () { return $3921d1590822ab10$export$e1bd0c6150f13d96; });
$parcel$export(module.exports, "ModalManager", function () { return $3921d1590822ab10$export$ce11c4ecd08cea67; });

var $e8UWb = parcelRequire("e8UWb");
var $7TDiU = parcelRequire("7TDiU");
var $jqdHv = parcelRequire("jqdHv");
// Is a vertical scrollbar displayed?
function $3921d1590822ab10$var$isOverflowing(container) {
    const doc = (0, $7TDiU.default)(container);
    if (doc.body === container) return (0, $jqdHv.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $3921d1590822ab10$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $3921d1590822ab10$var$getPaddingRight(element) {
    return parseInt((0, $jqdHv.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $3921d1590822ab10$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $3921d1590822ab10$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$3921d1590822ab10$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $3921d1590822ab10$export$e1bd0c6150f13d96(element, show);
    });
}
function $3921d1590822ab10$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $3921d1590822ab10$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($3921d1590822ab10$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $e8UWb.default)((0, $7TDiU.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$3921d1590822ab10$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $7TDiU.default)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$3921d1590822ab10$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $7TDiU.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $jqdHv.default)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $3921d1590822ab10$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $3921d1590822ab10$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $3921d1590822ab10$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $3921d1590822ab10$var$getHiddenSiblings(container);
        $3921d1590822ab10$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $3921d1590822ab10$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $3921d1590822ab10$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $3921d1590822ab10$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $3921d1590822ab10$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $3921d1590822ab10$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $3921d1590822ab10$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $3921d1590822ab10$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}

});


parcelRegister("jfyRA", function(module, exports) {

$parcel$export(module.exports, "FocusTrap", function () { return $e03a7628f42c24a8$export$34eba2437817a67b; });

var $bh6RR = parcelRequire("bh6RR");


var $7TDiU = parcelRequire("7TDiU");
var $fpwfv = parcelRequire("fpwfv");

var $ih19M = parcelRequire("ih19M");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $e03a7628f42c24a8$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $e03a7628f42c24a8$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $e03a7628f42c24a8$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $e03a7628f42c24a8$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $e03a7628f42c24a8$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $e03a7628f42c24a8$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($e03a7628f42c24a8$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $e03a7628f42c24a8$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$e03a7628f42c24a8$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $e03a7628f42c24a8$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $e03a7628f42c24a8$export$34eba2437817a67b(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $e03a7628f42c24a8$var$defaultGetTabbable, isEnabled: isEnabled = $e03a7628f42c24a8$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $bh6RR.useRef(false);
    const sentinelStart = $bh6RR.useRef(null);
    const sentinelEnd = $bh6RR.useRef(null);
    const nodeToRestore = $bh6RR.useRef(null);
    const reactFocusEventTarget = $bh6RR.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $bh6RR.useRef(false);
    const rootRef = $bh6RR.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $fpwfv.default)(children.ref, rootRef);
    const lastKeydown = $bh6RR.useRef(null);
    $bh6RR.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $bh6RR.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $7TDiU.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $bh6RR.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $7TDiU.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $bh6RR.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}

});

parcelRegister("8FFT1", function(module, exports) {

$parcel$export(module.exports, "Portal", function () { return $6502a4d210ca8b64$export$602eac185826482c; });

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");


var $gzLMq = parcelRequire("gzLMq");
var $joJqx = parcelRequire("joJqx");
var $fpwfv = parcelRequire("fpwfv");

var $ih19M = parcelRequire("ih19M");
"use client";
function $6502a4d210ca8b64$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $6502a4d210ca8b64$export$602eac185826482c = /*#__PURE__*/ $bh6RR.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $bh6RR.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $fpwfv.default)(/*#__PURE__*/ $bh6RR.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $joJqx.default)(()=>{
        if (!disablePortal) setMountNode($6502a4d210ca8b64$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $joJqx.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $gzLMq.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $gzLMq.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $bh6RR.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $bh6RR.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Fragment, {
        children: mountNode ? /*#__PURE__*/ $6afFj.createPortal(children, mountNode) : mountNode
    });
});

});

parcelRegister("74PV0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52712e091ff6e80b$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $9q08x = parcelRequire("9q08x");

var $7CQdS = parcelRequire("7CQdS");

var $ih19M = parcelRequire("ih19M");
"use client";
const $52712e091ff6e80b$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $52712e091ff6e80b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $7CQdS.getBackdropUtilityClass), classes);
};
const $52712e091ff6e80b$var$BackdropRoot = (0, $g4l1t.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $52712e091ff6e80b$var$Backdrop = /*#__PURE__*/ $bh6RR.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $9q08x.default), transitionDuration: transitionDuration } = props, other = (0, $hCIyK.default)(props, $52712e091ff6e80b$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $52712e091ff6e80b$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)($52712e091ff6e80b$var$BackdropRoot, (0, $4WYaH.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $aPsoC.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $4WYaH.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $52712e091ff6e80b$export$2e2bcd8739ae039 = $52712e091ff6e80b$var$Backdrop;

});
parcelRegister("9q08x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6db6a5e8cee46790$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $7ARPd = parcelRequire("7ARPd");


var $8gyMY = parcelRequire("8gyMY");

var $6SHzw = parcelRequire("6SHzw");

var $erAkb = parcelRequire("erAkb");

var $ih19M = parcelRequire("ih19M");
"use client";
const $6db6a5e8cee46790$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $6db6a5e8cee46790$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $6db6a5e8cee46790$var$Fade = /*#__PURE__*/ $bh6RR.forwardRef(function Fade(props, ref) {
    const theme = (0, $8gyMY.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $7ARPd.default) } = props, other = (0, $hCIyK.default)(props, $6db6a5e8cee46790$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $bh6RR.useRef(null);
    const handleRef = (0, $erAkb.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $6SHzw.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $6SHzw.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $6SHzw.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $bh6RR.cloneElement(children, (0, $4WYaH.default)({
                style: (0, $4WYaH.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $6db6a5e8cee46790$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $6db6a5e8cee46790$export$2e2bcd8739ae039 = $6db6a5e8cee46790$var$Fade;

});

parcelRegister("7CQdS", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", function () { return $58d497618cd73966$export$9927a91fd93152bd; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $58d497618cd73966$export$9927a91fd93152bd(slot) {
    return (0, $XybB6.default)("MuiBackdrop", slot);
}
const $58d497618cd73966$var$backdropClasses = (0, $igcUF.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $58d497618cd73966$export$2e2bcd8739ae039 = $58d497618cd73966$var$backdropClasses;

});


parcelRegister("hSckl", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", function () { return $d0310aba0aea524b$export$67960e22b12a638d; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $d0310aba0aea524b$export$67960e22b12a638d(slot) {
    return (0, $XybB6.default)("MuiModal", slot);
}
const $d0310aba0aea524b$var$modalClasses = (0, $igcUF.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $d0310aba0aea524b$export$2e2bcd8739ae039 = $d0310aba0aea524b$var$modalClasses;

});


parcelRegister("bUvp2", function(module, exports) {

$parcel$export(module.exports, "getPopoverUtilityClass", function () { return $8abd48a13f95144e$export$88f455dd56c95edb; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $8abd48a13f95144e$export$88f455dd56c95edb(slot) {
    return (0, $XybB6.default)("MuiPopover", slot);
}
const $8abd48a13f95144e$var$popoverClasses = (0, $igcUF.default)("MuiPopover", [
    "root",
    "paper"
]);
var $8abd48a13f95144e$export$2e2bcd8739ae039 = $8abd48a13f95144e$var$popoverClasses;

});


parcelRegister("5wAd2", function(module, exports) {

$parcel$export(module.exports, "getMenuUtilityClass", function () { return $405c074dc68b8d3a$export$2cf86a63a84fe23d; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $405c074dc68b8d3a$export$2cf86a63a84fe23d(slot) {
    return (0, $XybB6.default)("MuiMenu", slot);
}
const $405c074dc68b8d3a$var$menuClasses = (0, $igcUF.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $405c074dc68b8d3a$export$2e2bcd8739ae039 = $405c074dc68b8d3a$var$menuClasses;

});


parcelRegister("83QDW", function(module, exports) {

$parcel$export(module.exports, "nativeSelectSelectStyles", function () { return $5de7705d7f2b86f1$export$c1eccd1617458c87; });
$parcel$export(module.exports, "nativeSelectIconStyles", function () { return $5de7705d7f2b86f1$export$e7a817afd12a40d0; });
$parcel$export(module.exports, "default", function () { return $5de7705d7f2b86f1$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $7J7Kn = parcelRequire("7J7Kn");

var $fGH8N = parcelRequire("fGH8N");

var $Bn57C = parcelRequire("Bn57C");

var $g4l1t = parcelRequire("g4l1t");

var $ih19M = parcelRequire("ih19M");
"use client";
const $5de7705d7f2b86f1$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $5de7705d7f2b86f1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $fGH8N.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $Bn57C.getNativeSelectUtilityClasses), classes);
};
const $5de7705d7f2b86f1$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $4WYaH.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $4WYaH.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $Bn57C.default).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $5de7705d7f2b86f1$var$NativeSelectSelect = (0, $g4l1t.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $g4l1t.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $Bn57C.default).multiple}`]: styles.multiple
            }
        ];
    }
})($5de7705d7f2b86f1$export$c1eccd1617458c87);
const $5de7705d7f2b86f1$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $4WYaH.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $Bn57C.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $5de7705d7f2b86f1$var$NativeSelectIcon = (0, $g4l1t.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $fGH8N.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($5de7705d7f2b86f1$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $5de7705d7f2b86f1$var$NativeSelectInput = /*#__PURE__*/ $bh6RR.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $hCIyK.default)(props, $5de7705d7f2b86f1$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $5de7705d7f2b86f1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($5de7705d7f2b86f1$var$NativeSelectSelect, (0, $4WYaH.default)({
                ownerState: ownerState,
                className: (0, $aPsoC.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $ih19M.jsx)($5de7705d7f2b86f1$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $5de7705d7f2b86f1$export$2e2bcd8739ae039 = $5de7705d7f2b86f1$var$NativeSelectInput;

});
parcelRegister("Bn57C", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", function () { return $07055c57c2df772f$export$1ee13051fd9e2ab5; });
$parcel$export(module.exports, "default", function () { return $07055c57c2df772f$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $07055c57c2df772f$export$1ee13051fd9e2ab5(slot) {
    return (0, $XybB6.default)("MuiNativeSelect", slot);
}
const $07055c57c2df772f$var$nativeSelectClasses = (0, $igcUF.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $07055c57c2df772f$export$2e2bcd8739ae039 = $07055c57c2df772f$var$nativeSelectClasses;

});


parcelRegister("82V4F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dbac85f8c597fa5$export$2e2bcd8739ae039; });

var $dI1ry = parcelRequire("dI1ry");
"use client";
var $5dbac85f8c597fa5$export$2e2bcd8739ae039 = (0, $dI1ry.default);

});
parcelRegister("dI1ry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fb0810ff6038a80$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
"use client";
function $9fb0810ff6038a80$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $bh6RR.useRef(controlled !== undefined);
    const [valueState, setValue] = $bh6RR.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $bh6RR.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("eLyTY", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", function () { return $ac00873c433adbe7$export$2c0c1ee5a3392e; });
$parcel$export(module.exports, "default", function () { return $ac00873c433adbe7$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $ac00873c433adbe7$export$2c0c1ee5a3392e(slot) {
    return (0, $XybB6.default)("MuiSelect", slot);
}
const $ac00873c433adbe7$var$selectClasses = (0, $igcUF.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $ac00873c433adbe7$export$2e2bcd8739ae039 = $ac00873c433adbe7$var$selectClasses;

});


parcelRegister("4bgmh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30b4e0f19df2fb53$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $30b4e0f19df2fb53$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");

});

parcelRegister("1958g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d5a9ce5ab5856be$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $7J7Kn = parcelRequire("7J7Kn");

var $cseKH = parcelRequire("cseKH");


var $dNs2U = parcelRequire("dNs2U");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $lIfEy = parcelRequire("lIfEy");

var $dNs2U = parcelRequire("dNs2U");

var $ih19M = parcelRequire("ih19M");
"use client";
const $0d5a9ce5ab5856be$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $0d5a9ce5ab5856be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $7J7Kn.default)(slots, (0, $lIfEy.getInputUtilityClass), classes);
    return (0, $4WYaH.default)({}, classes, composedClasses);
};
const $0d5a9ce5ab5856be$var$InputRoot = (0, $g4l1t.default)((0, $dNs2U.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $g4l1t.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $dNs2U.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $4WYaH.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $lIfEy.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $lIfEy.default).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $lIfEy.default).disabled}, .${(0, $lIfEy.default).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $lIfEy.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $0d5a9ce5ab5856be$var$InputInput = (0, $g4l1t.default)((0, $dNs2U.InputBaseComponent), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $dNs2U.inputOverridesResolver)
})({});
const $0d5a9ce5ab5856be$var$Input = /*#__PURE__*/ $bh6RR.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $hCIyK.default)(props, $0d5a9ce5ab5856be$var$_excluded);
    const classes = $0d5a9ce5ab5856be$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $cseKH.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $0d5a9ce5ab5856be$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $0d5a9ce5ab5856be$var$InputInput;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), (0, $4WYaH.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$0d5a9ce5ab5856be$var$Input.muiName = "Input";
var $0d5a9ce5ab5856be$export$2e2bcd8739ae039 = $0d5a9ce5ab5856be$var$Input;

});
parcelRegister("lIfEy", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", function () { return $fce9d965f48d5d89$export$cdb270390122322b; });
$parcel$export(module.exports, "default", function () { return $fce9d965f48d5d89$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");

var $k1IMo = parcelRequire("k1IMo");
function $fce9d965f48d5d89$export$cdb270390122322b(slot) {
    return (0, $XybB6.default)("MuiInput", slot);
}
const $fce9d965f48d5d89$var$inputClasses = (0, $4WYaH.default)({}, (0, $k1IMo.default), (0, $igcUF.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $fce9d965f48d5d89$export$2e2bcd8739ae039 = $fce9d965f48d5d89$var$inputClasses;

});


parcelRegister("jTRoG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7cc92f35eed53d9$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $cseKH = parcelRequire("cseKH");



var $7J7Kn = parcelRequire("7J7Kn");

var $dNs2U = parcelRequire("dNs2U");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $lDuMV = parcelRequire("lDuMV");

var $dNs2U = parcelRequire("dNs2U");

var $ih19M = parcelRequire("ih19M");
"use client";
const $e7cc92f35eed53d9$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $e7cc92f35eed53d9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $7J7Kn.default)(slots, (0, $lDuMV.getFilledInputUtilityClass), classes);
    return (0, $4WYaH.default)({}, classes, composedClasses);
};
const $e7cc92f35eed53d9$var$FilledInputRoot = (0, $g4l1t.default)((0, $dNs2U.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $g4l1t.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $dNs2U.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $4WYaH.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $lDuMV.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $lDuMV.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $lDuMV.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $lDuMV.default).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $lDuMV.default).disabled}, .${(0, $lDuMV.default).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $lDuMV.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $4WYaH.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $e7cc92f35eed53d9$var$FilledInputInput = (0, $g4l1t.default)((0, $dNs2U.InputBaseComponent), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $dNs2U.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $e7cc92f35eed53d9$var$FilledInput = /*#__PURE__*/ $bh6RR.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $hCIyK.default)(props, $e7cc92f35eed53d9$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $e7cc92f35eed53d9$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $cseKH.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $e7cc92f35eed53d9$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $e7cc92f35eed53d9$var$FilledInputInput;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), (0, $4WYaH.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$e7cc92f35eed53d9$var$FilledInput.muiName = "Input";
var $e7cc92f35eed53d9$export$2e2bcd8739ae039 = $e7cc92f35eed53d9$var$FilledInput;

});
parcelRegister("lDuMV", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", function () { return $fc051f6061f55b95$export$3331e419f1a48437; });
$parcel$export(module.exports, "default", function () { return $fc051f6061f55b95$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");

var $k1IMo = parcelRequire("k1IMo");
function $fc051f6061f55b95$export$3331e419f1a48437(slot) {
    return (0, $XybB6.default)("MuiFilledInput", slot);
}
const $fc051f6061f55b95$var$filledInputClasses = (0, $4WYaH.default)({}, (0, $k1IMo.default), (0, $igcUF.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $fc051f6061f55b95$export$2e2bcd8739ae039 = $fc051f6061f55b95$var$filledInputClasses;

});


parcelRegister("8D1KM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6483536f7a4d2aed$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");



var $7J7Kn = parcelRequire("7J7Kn");

var $03UwN = parcelRequire("03UwN");

var $djfcj = parcelRequire("djfcj");

var $jjSic = parcelRequire("jjSic");

var $g4l1t = parcelRequire("g4l1t");

var $fjIjG = parcelRequire("fjIjG");

var $dNs2U = parcelRequire("dNs2U");

var $cNBED = parcelRequire("cNBED");

var $ih19M = parcelRequire("ih19M");
"use client";
const $6483536f7a4d2aed$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $6483536f7a4d2aed$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $7J7Kn.default)(slots, (0, $fjIjG.getOutlinedInputUtilityClass), classes);
    return (0, $4WYaH.default)({}, classes, composedClasses);
};
const $6483536f7a4d2aed$var$OutlinedInputRoot = (0, $g4l1t.default)((0, $dNs2U.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $g4l1t.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $dNs2U.rootOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $4WYaH.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $fjIjG.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $fjIjG.default).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $fjIjG.default).focused} .${(0, $fjIjG.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $fjIjG.default).error} .${(0, $fjIjG.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $fjIjG.default).disabled} .${(0, $fjIjG.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $4WYaH.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $6483536f7a4d2aed$var$NotchedOutlineRoot = (0, $g4l1t.default)((0, $03UwN.default), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $6483536f7a4d2aed$var$OutlinedInputInput = (0, $g4l1t.default)((0, $dNs2U.InputBaseComponent), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $dNs2U.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $6483536f7a4d2aed$var$OutlinedInput = /*#__PURE__*/ $bh6RR.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text" } = props, other = (0, $hCIyK.default)(props, $6483536f7a4d2aed$var$_excluded);
    const classes = $6483536f7a4d2aed$var$useUtilityClasses(props);
    const muiFormControl = (0, $djfcj.default)();
    const fcs = (0, $jjSic.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $6483536f7a4d2aed$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $6483536f7a4d2aed$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), (0, $4WYaH.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ih19M.jsx)($6483536f7a4d2aed$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $4WYaH.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$6483536f7a4d2aed$var$OutlinedInput.muiName = "Input";
var $6483536f7a4d2aed$export$2e2bcd8739ae039 = $6483536f7a4d2aed$var$OutlinedInput;

});
parcelRegister("03UwN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00bc21389def8de5$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");
parcelRequire("bh6RR");


var $g4l1t = parcelRequire("g4l1t");

var $ih19M = parcelRequire("ih19M");
"use client";
var $00bc21389def8de5$var$_span;
const $00bc21389def8de5$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $00bc21389def8de5$var$NotchedOutlineRoot = (0, $g4l1t.default)("fieldset", {
    shouldForwardProp: (0, $g4l1t.rootShouldForwardProp)
})({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $00bc21389def8de5$var$NotchedOutlineLegend = (0, $g4l1t.default)("legend", {
    shouldForwardProp: (0, $g4l1t.rootShouldForwardProp)
})(({ ownerState: ownerState, theme: theme })=>(0, $4WYaH.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $4WYaH.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $00bc21389def8de5$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $hCIyK.default)(props, $00bc21389def8de5$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $4WYaH.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)($00bc21389def8de5$var$NotchedOutlineRoot, (0, $4WYaH.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)($00bc21389def8de5$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                children: label
            }) : $00bc21389def8de5$var$_span || ($00bc21389def8de5$var$_span = /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}

});

parcelRegister("fjIjG", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", function () { return $b26b01ab860175bb$export$89922944c7227687; });
$parcel$export(module.exports, "default", function () { return $b26b01ab860175bb$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");

var $k1IMo = parcelRequire("k1IMo");
function $b26b01ab860175bb$export$89922944c7227687(slot) {
    return (0, $XybB6.default)("MuiOutlinedInput", slot);
}
const $b26b01ab860175bb$var$outlinedInputClasses = (0, $4WYaH.default)({}, (0, $k1IMo.default), (0, $igcUF.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $b26b01ab860175bb$export$2e2bcd8739ae039 = $b26b01ab860175bb$var$outlinedInputClasses;

});



parcelRegister("eJOwd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abac749ee53f5558$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $hrrmv = parcelRequire("hrrmv");

var $ih19M = parcelRequire("ih19M");
"use client";
const $abac749ee53f5558$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $abac749ee53f5558$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $hrrmv.getToolbarUtilityClass), classes);
};
const $abac749ee53f5558$var$ToolbarRoot = (0, $g4l1t.default)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        position: "relative",
        display: "flex",
        alignItems: "center"
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === "dense" && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === "regular" && theme.mixins.toolbar);
const $abac749ee53f5558$var$Toolbar = /*#__PURE__*/ $bh6RR.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiToolbar"
    });
    const { className: className, component: component = "div", disableGutters: disableGutters = false, variant: variant = "regular" } = props, other = (0, $hCIyK.default)(props, $abac749ee53f5558$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $abac749ee53f5558$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($abac749ee53f5558$var$ToolbarRoot, (0, $4WYaH.default)({
        as: component,
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $abac749ee53f5558$export$2e2bcd8739ae039 = $abac749ee53f5558$var$Toolbar;

});
parcelRegister("hrrmv", function(module, exports) {

$parcel$export(module.exports, "getToolbarUtilityClass", function () { return $cb2a2ed36782e926$export$b12cb262231eef32; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $cb2a2ed36782e926$export$b12cb262231eef32(slot) {
    return (0, $XybB6.default)("MuiToolbar", slot);
}
const $cb2a2ed36782e926$var$toolbarClasses = (0, $igcUF.default)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
var $cb2a2ed36782e926$export$2e2bcd8739ae039 = $cb2a2ed36782e926$var$toolbarClasses;

});


parcelRegister("8TKyB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67a793103f0910c0$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $1R8zt = parcelRequire("1R8zt");

var $6BGOB = parcelRequire("6BGOB");

var $8gyMY = parcelRequire("8gyMY");

var $am7GZ = parcelRequire("am7GZ");

var $dQLGO = parcelRequire("dQLGO");

var $gRSzM = parcelRequire("gRSzM");

var $ih19M = parcelRequire("ih19M");
"use client";
const $67a793103f0910c0$var$_excluded = [
    "backIconButtonProps",
    "count",
    "disabled",
    "getItemAriaLabel",
    "nextIconButtonProps",
    "onPageChange",
    "page",
    "rowsPerPage",
    "showFirstButton",
    "showLastButton",
    "slots",
    "slotProps"
];
const $67a793103f0910c0$var$TablePaginationActions = /*#__PURE__*/ $bh6RR.forwardRef(function TablePaginationActions(props, ref) {
    var _slots$firstButton, _slots$lastButton, _slots$nextButton, _slots$previousButton, _slots$firstButtonIco, _slots$lastButtonIcon, _slots$nextButtonIcon, _slots$previousButton2;
    const { backIconButtonProps: backIconButtonProps, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $hCIyK.default)(props, $67a793103f0910c0$var$_excluded);
    const theme = (0, $8gyMY.default)();
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = (_slots$firstButton = slots.firstButton) != null ? _slots$firstButton : (0, $am7GZ.default);
    const LastButton = (_slots$lastButton = slots.lastButton) != null ? _slots$lastButton : (0, $am7GZ.default);
    const NextButton = (_slots$nextButton = slots.nextButton) != null ? _slots$nextButton : (0, $am7GZ.default);
    const PreviousButton = (_slots$previousButton = slots.previousButton) != null ? _slots$previousButton : (0, $am7GZ.default);
    const FirstButtonIcon = (_slots$firstButtonIco = slots.firstButtonIcon) != null ? _slots$firstButtonIco : (0, $gRSzM.default);
    const LastButtonIcon = (_slots$lastButtonIcon = slots.lastButtonIcon) != null ? _slots$lastButtonIcon : (0, $dQLGO.default);
    const NextButtonIcon = (_slots$nextButtonIcon = slots.nextButtonIcon) != null ? _slots$nextButtonIcon : (0, $6BGOB.default);
    const PreviousButtonIcon = (_slots$previousButton2 = slots.previousButtonIcon) != null ? _slots$previousButton2 : (0, $1R8zt.default);
    const FirstButtonSlot = theme.direction === "rtl" ? LastButton : FirstButton;
    const PreviousButtonSlot = theme.direction === "rtl" ? NextButton : PreviousButton;
    const NextButtonSlot = theme.direction === "rtl" ? PreviousButton : NextButton;
    const LastButtonSlot = theme.direction === "rtl" ? FirstButton : LastButton;
    const firstButtonSlotProps = theme.direction === "rtl" ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = theme.direction === "rtl" ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = theme.direction === "rtl" ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = theme.direction === "rtl" ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", (0, $4WYaH.default)({
        ref: ref
    }, other, {
        children: [
            showFirstButton && /*#__PURE__*/ (0, $ih19M.jsx)(FirstButtonSlot, (0, $4WYaH.default)({
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel("first", page),
                title: getItemAriaLabel("first", page)
            }, firstButtonSlotProps, {
                children: theme.direction === "rtl" ? /*#__PURE__*/ (0, $ih19M.jsx)(LastButtonIcon, (0, $4WYaH.default)({}, slotProps.lastButtonIcon)) : /*#__PURE__*/ (0, $ih19M.jsx)(FirstButtonIcon, (0, $4WYaH.default)({}, slotProps.firstButtonIcon))
            })),
            /*#__PURE__*/ (0, $ih19M.jsx)(PreviousButtonSlot, (0, $4WYaH.default)({
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel("previous", page),
                title: getItemAriaLabel("previous", page)
            }, previousButtonSlotProps != null ? previousButtonSlotProps : backIconButtonProps, {
                children: theme.direction === "rtl" ? /*#__PURE__*/ (0, $ih19M.jsx)(NextButtonIcon, (0, $4WYaH.default)({}, slotProps.nextButtonIcon)) : /*#__PURE__*/ (0, $ih19M.jsx)(PreviousButtonIcon, (0, $4WYaH.default)({}, slotProps.previousButtonIcon))
            })),
            /*#__PURE__*/ (0, $ih19M.jsx)(NextButtonSlot, (0, $4WYaH.default)({
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel("next", page),
                title: getItemAriaLabel("next", page)
            }, nextButtonSlotProps != null ? nextButtonSlotProps : nextIconButtonProps, {
                children: theme.direction === "rtl" ? /*#__PURE__*/ (0, $ih19M.jsx)(PreviousButtonIcon, (0, $4WYaH.default)({}, slotProps.previousButtonIcon)) : /*#__PURE__*/ (0, $ih19M.jsx)(NextButtonIcon, (0, $4WYaH.default)({}, slotProps.nextButtonIcon))
            })),
            showLastButton && /*#__PURE__*/ (0, $ih19M.jsx)(LastButtonSlot, (0, $4WYaH.default)({
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel("last", page),
                title: getItemAriaLabel("last", page)
            }, lastButtonSlotProps, {
                children: theme.direction === "rtl" ? /*#__PURE__*/ (0, $ih19M.jsx)(FirstButtonIcon, (0, $4WYaH.default)({}, slotProps.firstButtonIcon)) : /*#__PURE__*/ (0, $ih19M.jsx)(LastButtonIcon, (0, $4WYaH.default)({}, slotProps.lastButtonIcon))
            }))
        ]
    }));
});
var $67a793103f0910c0$export$2e2bcd8739ae039 = $67a793103f0910c0$var$TablePaginationActions;

});
parcelRegister("1R8zt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15a163b639b6a820$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $15a163b639b6a820$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft");

});

parcelRegister("6BGOB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cf768f47e3a7b8e$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $4cf768f47e3a7b8e$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");

});

parcelRegister("dQLGO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1551fd0248390e7$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $a1551fd0248390e7$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage");

});

parcelRegister("gRSzM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c47bee3bbb698430$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $c47bee3bbb698430$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage");

});


parcelRegister("5R8eh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4438492ebbd53597$export$2e2bcd8739ae039; });

var $fVi1O = parcelRequire("fVi1O");
"use client";
var $4438492ebbd53597$export$2e2bcd8739ae039 = (0, $fVi1O.default);

});

parcelRegister("aSR7M", function(module, exports) {

$parcel$export(module.exports, "getTablePaginationUtilityClass", function () { return $7ec827ef0591e152$export$909e637b22246f4c; });
$parcel$export(module.exports, "default", function () { return $7ec827ef0591e152$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $7ec827ef0591e152$export$909e637b22246f4c(slot) {
    return (0, $XybB6.default)("MuiTablePagination", slot);
}
const $7ec827ef0591e152$var$tablePaginationClasses = (0, $igcUF.default)("MuiTablePagination", [
    "root",
    "toolbar",
    "spacer",
    "selectLabel",
    "selectRoot",
    "select",
    "selectIcon",
    "input",
    "menuItem",
    "displayedRows",
    "actions"
]);
var $7ec827ef0591e152$export$2e2bcd8739ae039 = $7ec827ef0591e152$var$tablePaginationClasses;

});


parcelRegister("6GPiu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4dee74dfac3d9566$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $cG3EF = parcelRequire("cG3EF");

var $aQcZC = parcelRequire("aQcZC");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $8BpcR = parcelRequire("8BpcR");

var $ih19M = parcelRequire("ih19M");
"use client";
const $4dee74dfac3d9566$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $4dee74dfac3d9566$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            hover && "hover",
            head && "head",
            footer && "footer"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $8BpcR.getTableRowUtilityClass), classes);
};
const $4dee74dfac3d9566$var$TableRowRoot = (0, $g4l1t.default)("tr", {
    name: "MuiTableRow",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: "inherit",
        display: "table-row",
        verticalAlign: "middle",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $8BpcR.default).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $8BpcR.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cG3EF.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $cG3EF.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $4dee74dfac3d9566$var$defaultComponent = "tr";
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $4dee74dfac3d9566$var$TableRow = /*#__PURE__*/ $bh6RR.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTableRow"
    });
    const { className: className, component: component = $4dee74dfac3d9566$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $hCIyK.default)(props, $4dee74dfac3d9566$var$_excluded);
    const tablelvl2 = $bh6RR.useContext((0, $aQcZC.default));
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === "head",
        footer: tablelvl2 && tablelvl2.variant === "footer"
    });
    const classes = $4dee74dfac3d9566$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($4dee74dfac3d9566$var$TableRowRoot, (0, $4WYaH.default)({
        as: component,
        ref: ref,
        className: (0, $aPsoC.default)(classes.root, className),
        role: component === $4dee74dfac3d9566$var$defaultComponent ? null : "row",
        ownerState: ownerState
    }, other));
});
var $4dee74dfac3d9566$export$2e2bcd8739ae039 = $4dee74dfac3d9566$var$TableRow;

});
parcelRegister("8BpcR", function(module, exports) {

$parcel$export(module.exports, "getTableRowUtilityClass", function () { return $643554ebfc0ae5bf$export$ba0a6d6c28940107; });
$parcel$export(module.exports, "default", function () { return $643554ebfc0ae5bf$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $643554ebfc0ae5bf$export$ba0a6d6c28940107(slot) {
    return (0, $XybB6.default)("MuiTableRow", slot);
}
const $643554ebfc0ae5bf$var$tableRowClasses = (0, $igcUF.default)("MuiTableRow", [
    "root",
    "selected",
    "hover",
    "head",
    "footer"
]);
var $643554ebfc0ae5bf$export$2e2bcd8739ae039 = $643554ebfc0ae5bf$var$tableRowClasses;

});


parcelRegister("1swyP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1101a9d9ef3cb512$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $7J7Kn = parcelRequire("7J7Kn");

var $aPsoC = parcelRequire("aPsoC");


var $bh6RR = parcelRequire("bh6RR");

var $aEoM0 = parcelRequire("aEoM0");

var $43NPh = parcelRequire("43NPh");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $fGH8N = parcelRequire("fGH8N");

var $jtudq = parcelRequire("jtudq");

var $ih19M = parcelRequire("ih19M");
"use client";
const $1101a9d9ef3cb512$var$_excluded = [
    "active",
    "children",
    "className",
    "direction",
    "hideSortIcon",
    "IconComponent"
];
const $1101a9d9ef3cb512$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, direction: direction, active: active } = ownerState;
    const slots = {
        root: [
            "root",
            active && "active"
        ],
        icon: [
            "icon",
            `iconDirection${(0, $fGH8N.default)(direction)}`
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $jtudq.getTableSortLabelUtilityClass), classes);
};
const $1101a9d9ef3cb512$var$TableSortLabelRoot = (0, $g4l1t.default)((0, $aEoM0.default), {
    name: "MuiTableSortLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.active && styles.active
        ];
    }
})(({ theme: theme })=>({
        cursor: "pointer",
        display: "inline-flex",
        justifyContent: "flex-start",
        flexDirection: "inherit",
        alignItems: "center",
        "&:focus": {
            color: (theme.vars || theme).palette.text.secondary
        },
        "&:hover": {
            color: (theme.vars || theme).palette.text.secondary,
            [`& .${(0, $jtudq.default).icon}`]: {
                opacity: 0.5
            }
        },
        [`&.${(0, $jtudq.default).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            [`& .${(0, $jtudq.default).icon}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.text.secondary
            }
        }
    }));
const $1101a9d9ef3cb512$var$TableSortLabelIcon = (0, $g4l1t.default)("span", {
    name: "MuiTableSortLabel",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            styles[`iconDirection${(0, $fGH8N.default)(ownerState.direction)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        fontSize: 18,
        marginRight: 4,
        marginLeft: 4,
        opacity: 0,
        transition: theme.transitions.create([
            "opacity",
            "transform"
        ], {
            duration: theme.transitions.duration.shorter
        }),
        userSelect: "none"
    }, ownerState.direction === "desc" && {
        transform: "rotate(0deg)"
    }, ownerState.direction === "asc" && {
        transform: "rotate(180deg)"
    }));
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */ const $1101a9d9ef3cb512$var$TableSortLabel = /*#__PURE__*/ $bh6RR.forwardRef(function TableSortLabel(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTableSortLabel"
    });
    const { active: active = false, children: children, className: className, direction: direction = "asc", hideSortIcon: hideSortIcon = false, IconComponent: IconComponent = (0, $43NPh.default) } = props, other = (0, $hCIyK.default)(props, $1101a9d9ef3cb512$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        active: active,
        direction: direction,
        hideSortIcon: hideSortIcon,
        IconComponent: IconComponent
    });
    const classes = $1101a9d9ef3cb512$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($1101a9d9ef3cb512$var$TableSortLabelRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        component: "span",
        disableRipple: true,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            children,
            hideSortIcon && !active ? null : /*#__PURE__*/ (0, $ih19M.jsx)($1101a9d9ef3cb512$var$TableSortLabelIcon, {
                as: IconComponent,
                className: (0, $aPsoC.default)(classes.icon),
                ownerState: ownerState
            })
        ]
    }));
});
var $1101a9d9ef3cb512$export$2e2bcd8739ae039 = $1101a9d9ef3cb512$var$TableSortLabel;

});
parcelRegister("43NPh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f4e17a3aff29381$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $2f4e17a3aff29381$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), "ArrowDownward");

});

parcelRegister("jtudq", function(module, exports) {

$parcel$export(module.exports, "getTableSortLabelUtilityClass", function () { return $e2d829eea40d711e$export$645d356c89a51794; });
$parcel$export(module.exports, "default", function () { return $e2d829eea40d711e$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $e2d829eea40d711e$export$645d356c89a51794(slot) {
    return (0, $XybB6.default)("MuiTableSortLabel", slot);
}
const $e2d829eea40d711e$var$tableSortLabelClasses = (0, $igcUF.default)("MuiTableSortLabel", [
    "root",
    "active",
    "icon",
    "iconDirectionDesc",
    "iconDirectionAsc"
]);
var $e2d829eea40d711e$export$2e2bcd8739ae039 = $e2d829eea40d711e$var$tableSortLabelClasses;

});


parcelRegister("5LQ5V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4339c06d9828fc29$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $fVi1O = parcelRequire("fVi1O");


var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $1958g = parcelRequire("1958g");

var $jTRoG = parcelRequire("jTRoG");

var $8D1KM = parcelRequire("8D1KM");

var $jdcJs = parcelRequire("jdcJs");

var $fyVOI = parcelRequire("fyVOI");

var $7cqxZ = parcelRequire("7cqxZ");

var $5QlDC = parcelRequire("5QlDC");

var $vffw2 = parcelRequire("vffw2");

var $ih19M = parcelRequire("ih19M");
"use client";
const $4339c06d9828fc29$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $4339c06d9828fc29$var$variantComponent = {
    standard: (0, $1958g.default),
    filled: (0, $jTRoG.default),
    outlined: (0, $8D1KM.default)
};
const $4339c06d9828fc29$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $vffw2.getTextFieldUtilityClass), classes);
};
const $4339c06d9828fc29$var$TextFieldRoot = (0, $g4l1t.default)((0, $fyVOI.default), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $4339c06d9828fc29$var$TextField = /*#__PURE__*/ $bh6RR.forwardRef(function TextField(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = "outlined" } = props, other = (0, $hCIyK.default)(props, $4339c06d9828fc29$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $4339c06d9828fc29$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $fVi1O.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $4339c06d9828fc29$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $ih19M.jsx)(InputComponent, (0, $4WYaH.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $ih19M.jsxs)($4339c06d9828fc29$var$TextFieldRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $ih19M.jsx)((0, $jdcJs.default), (0, $4WYaH.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $5QlDC.default), (0, $4WYaH.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $ih19M.jsx)((0, $7cqxZ.default), (0, $4WYaH.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $4339c06d9828fc29$export$2e2bcd8739ae039 = $4339c06d9828fc29$var$TextField;

});
parcelRegister("jdcJs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfc91b92f84907cb$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $7J7Kn = parcelRequire("7J7Kn");

var $aPsoC = parcelRequire("aPsoC");

var $jjSic = parcelRequire("jjSic");

var $djfcj = parcelRequire("djfcj");

var $g7vB6 = parcelRequire("g7vB6");
var $cBhUP = parcelRequire("cBhUP");

var $cNBED = parcelRequire("cNBED");

var $fGH8N = parcelRequire("fGH8N");

var $g4l1t = parcelRequire("g4l1t");

var $jYabi = parcelRequire("jYabi");

var $ih19M = parcelRequire("ih19M");
"use client";
const $dfc91b92f84907cb$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $dfc91b92f84907cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, $fGH8N.default)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $7J7Kn.default)(slots, (0, $jYabi.getInputLabelUtilityClasses), classes);
    return (0, $4WYaH.default)({}, classes, composedClasses);
};
const $dfc91b92f84907cb$var$InputLabelRoot = (0, $g4l1t.default)((0, $g7vB6.default), {
    shouldForwardProp: (prop)=>(0, $g4l1t.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $cBhUP.default).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $4WYaH.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $4WYaH.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $4WYaH.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $dfc91b92f84907cb$var$InputLabel = /*#__PURE__*/ $bh6RR.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $cNBED.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $hCIyK.default)(props, $dfc91b92f84907cb$var$_excluded);
    const muiFormControl = (0, $djfcj.default)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $jjSic.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required",
            "focused"
        ]
    });
    const ownerState = (0, $4WYaH.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $dfc91b92f84907cb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($dfc91b92f84907cb$var$InputLabelRoot, (0, $4WYaH.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $aPsoC.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $dfc91b92f84907cb$export$2e2bcd8739ae039 = $dfc91b92f84907cb$var$InputLabel;

});
parcelRegister("g7vB6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbc5cf5be56e0eb3$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $jjSic = parcelRequire("jjSic");

var $djfcj = parcelRequire("djfcj");

var $fGH8N = parcelRequire("fGH8N");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $cBhUP = parcelRequire("cBhUP");

var $ih19M = parcelRequire("ih19M");
"use client";
const $bbc5cf5be56e0eb3$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $bbc5cf5be56e0eb3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $fGH8N.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $cBhUP.getFormLabelUtilityClasses), classes);
};
const $bbc5cf5be56e0eb3$export$aa5bc7f8a4705b27 = (0, $g4l1t.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $4WYaH.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $cBhUP.default).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $cBhUP.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $cBhUP.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $bbc5cf5be56e0eb3$var$AsteriskComponent = (0, $g4l1t.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $cBhUP.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $bbc5cf5be56e0eb3$var$FormLabel = /*#__PURE__*/ $bh6RR.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $hCIyK.default)(props, $bbc5cf5be56e0eb3$var$_excluded);
    const muiFormControl = (0, $djfcj.default)();
    const fcs = (0, $jjSic.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $bbc5cf5be56e0eb3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bbc5cf5be56e0eb3$export$aa5bc7f8a4705b27, (0, $4WYaH.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $ih19M.jsxs)($bbc5cf5be56e0eb3$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
var $bbc5cf5be56e0eb3$export$2e2bcd8739ae039 = $bbc5cf5be56e0eb3$var$FormLabel;

});
parcelRegister("cBhUP", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", function () { return $92c6d6688b111d5a$export$f7d501e40371cd17; });
$parcel$export(module.exports, "default", function () { return $92c6d6688b111d5a$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $92c6d6688b111d5a$export$f7d501e40371cd17(slot) {
    return (0, $XybB6.default)("MuiFormLabel", slot);
}
const $92c6d6688b111d5a$var$formLabelClasses = (0, $igcUF.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $92c6d6688b111d5a$export$2e2bcd8739ae039 = $92c6d6688b111d5a$var$formLabelClasses;

});


parcelRegister("jYabi", function(module, exports) {

$parcel$export(module.exports, "getInputLabelUtilityClasses", function () { return $e89b84aab3fdfd41$export$c1c4b4545ad2ea5f; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $e89b84aab3fdfd41$export$c1c4b4545ad2ea5f(slot) {
    return (0, $XybB6.default)("MuiInputLabel", slot);
}
const $e89b84aab3fdfd41$var$inputLabelClasses = (0, $igcUF.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $e89b84aab3fdfd41$export$2e2bcd8739ae039 = $e89b84aab3fdfd41$var$inputLabelClasses;

});


parcelRegister("fyVOI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b546e13b2ba36935$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $7ENQK = parcelRequire("7ENQK");

var $fGH8N = parcelRequire("fGH8N");

var $jg59e = parcelRequire("jg59e");

var $fbHce = parcelRequire("fbHce");

var $8YK9z = parcelRequire("8YK9z");

var $ih19M = parcelRequire("ih19M");
"use client";
const $b546e13b2ba36935$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $b546e13b2ba36935$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $fGH8N.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $8YK9z.getFormControlUtilityClasses), classes);
};
const $b546e13b2ba36935$var$FormControlRoot = (0, $g4l1t.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $4WYaH.default)({}, styles.root, styles[`margin${(0, $fGH8N.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $b546e13b2ba36935$var$FormControl = /*#__PURE__*/ $bh6RR.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $hCIyK.default)(props, $b546e13b2ba36935$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $b546e13b2ba36935$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $bh6RR.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $bh6RR.Children.forEach(children, (child)=>{
            if (!(0, $jg59e.default)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $jg59e.default)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $7ENQK.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $bh6RR.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $bh6RR.Children.forEach(children, (child)=>{
            if (!(0, $jg59e.default)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $7ENQK.isFilled)(child.props, true) || (0, $7ENQK.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $bh6RR.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $bh6RR.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $fbHce.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($b546e13b2ba36935$var$FormControlRoot, (0, $4WYaH.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $aPsoC.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $b546e13b2ba36935$export$2e2bcd8739ae039 = $b546e13b2ba36935$var$FormControl;

});
parcelRegister("jg59e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e053812f349fe26c$export$2e2bcd8739ae039; });

var $g81tQ = parcelRequire("g81tQ");
var $e053812f349fe26c$export$2e2bcd8739ae039 = (0, $g81tQ.default);

});
parcelRegister("g81tQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbde8aacf7ae4709$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
function $bbde8aacf7ae4709$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $bh6RR.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}

});


parcelRegister("8YK9z", function(module, exports) {

$parcel$export(module.exports, "getFormControlUtilityClasses", function () { return $6897ba6e1e11ae84$export$149c8b8bab2289d1; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $6897ba6e1e11ae84$export$149c8b8bab2289d1(slot) {
    return (0, $XybB6.default)("MuiFormControl", slot);
}
const $6897ba6e1e11ae84$var$formControlClasses = (0, $igcUF.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $6897ba6e1e11ae84$export$2e2bcd8739ae039 = $6897ba6e1e11ae84$var$formControlClasses;

});


parcelRegister("7cqxZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53de3f1ef2288eee$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $jjSic = parcelRequire("jjSic");

var $djfcj = parcelRequire("djfcj");

var $g4l1t = parcelRequire("g4l1t");

var $fGH8N = parcelRequire("fGH8N");

var $jtR3d = parcelRequire("jtR3d");

var $cNBED = parcelRequire("cNBED");

var $ih19M = parcelRequire("ih19M");
"use client";
var $53de3f1ef2288eee$var$_span;
const $53de3f1ef2288eee$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $53de3f1ef2288eee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $fGH8N.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $jtR3d.getFormHelperTextUtilityClasses), classes);
};
const $53de3f1ef2288eee$var$FormHelperTextRoot = (0, $g4l1t.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $fGH8N.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $jtR3d.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $jtR3d.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $53de3f1ef2288eee$var$FormHelperText = /*#__PURE__*/ $bh6RR.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $hCIyK.default)(props, $53de3f1ef2288eee$var$_excluded);
    const muiFormControl = (0, $djfcj.default)();
    const fcs = (0, $jjSic.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $53de3f1ef2288eee$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($53de3f1ef2288eee$var$FormHelperTextRoot, (0, $4WYaH.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $53de3f1ef2288eee$var$_span || ($53de3f1ef2288eee$var$_span = /*#__PURE__*/ (0, $ih19M.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $53de3f1ef2288eee$export$2e2bcd8739ae039 = $53de3f1ef2288eee$var$FormHelperText;

});
parcelRegister("jtR3d", function(module, exports) {

$parcel$export(module.exports, "getFormHelperTextUtilityClasses", function () { return $e2e9e08d62099c2f$export$a394fa61b1d583a9; });
$parcel$export(module.exports, "default", function () { return $e2e9e08d62099c2f$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $e2e9e08d62099c2f$export$a394fa61b1d583a9(slot) {
    return (0, $XybB6.default)("MuiFormHelperText", slot);
}
const $e2e9e08d62099c2f$var$formHelperTextClasses = (0, $igcUF.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $e2e9e08d62099c2f$export$2e2bcd8739ae039 = $e2e9e08d62099c2f$var$formHelperTextClasses;

});


parcelRegister("vffw2", function(module, exports) {

$parcel$export(module.exports, "getTextFieldUtilityClass", function () { return $05deb98c8456e26e$export$c1bdcbaf0596aeda; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $05deb98c8456e26e$export$c1bdcbaf0596aeda(slot) {
    return (0, $XybB6.default)("MuiTextField", slot);
}
const $05deb98c8456e26e$var$textFieldClasses = (0, $igcUF.default)("MuiTextField", [
    "root"
]);
var $05deb98c8456e26e$export$2e2bcd8739ae039 = $05deb98c8456e26e$var$textFieldClasses;

});


parcelRegister("bt9fX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85999547992716a4$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $85999547992716a4$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11h-4v4h-2v-4H7v-2h4V7h2v4h4z"
}), "AddCircle");

});

parcelRegister("dRSqV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a18a72e5005c34f7$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $a18a72e5005c34f7$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m0 15-5-5h3V9h4v4h3z"
}), "AssignmentReturned");

});

parcelRegister("3Xpkr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e1a878fcd0fc9be$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $2e1a878fcd0fc9be$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");

});

parcelRegister("5hIzD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d911dafdd678350$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $3d911dafdd678350$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M17 13l-5 5-5-5h3V9h4v4z"
}), "CloudDownload");

});

parcelRegister("goe1T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bee9c531a8cbdaad$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $bee9c531a8cbdaad$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 9h-4V3H9v6H5l7 7zM5 18v2h14v-2z"
}), "GetApp");

});

parcelRegister("jIOsh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5b943b8920ffc79$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $e5b943b8920ffc79$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "Search");

});

parcelRegister("gSGmk", function(module, exports) {

$parcel$export(module.exports, "displayText", function () { return $517a4bb547f0a8d0$export$45009418d6bce35; });
$parcel$export(module.exports, "formatDate", function () { return $517a4bb547f0a8d0$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "validEmailRegex", function () { return $517a4bb547f0a8d0$export$985ca500fc29e68; });
$parcel$export(module.exports, "validWebsiteRegex", function () { return $517a4bb547f0a8d0$export$570f351f0468ee68; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $aitry = parcelRequire("aitry");

var $2eJeT = parcelRequire("2eJeT");

var $aM783 = parcelRequire("aM783");
const $517a4bb547f0a8d0$export$45009418d6bce35 = (text, type)=>{
    if (type && type === "money") return /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), {
        sx: {
            fontWeight: 500,
            fontSize: "14px"
        },
        children: Number(text).toFixed(2)
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), {
        sx: {
            fontWeight: 500,
            fontSize: "14px"
        },
        children: text
    });
};
const $517a4bb547f0a8d0$export$3ae94a2503e890a1 = (value, format = (0, $aM783.DATE_TIME_FORMATS).DATE)=>{
    if (value) return !isNaN(value) && !isNaN(parseFloat(value)) ? (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(parseInt(value.toString())).format(format) : (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(value).format(format);
    return "";
};
const $517a4bb547f0a8d0$export$985ca500fc29e68 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const $517a4bb547f0a8d0$export$570f351f0468ee68 = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gim; // const formatDate = (rowData: IMembership, name: string, nestedName?: string) => {
 //     if (name && nestedName) {
 //       // eslint-disable-next-line @typescript-eslint/ban-ts-comment
 //       // @ts-ignore
 //       return rowData[name] && rowData[name][nestedName]
 //         ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
 //           // @ts-ignore
 //           moment(parseInt(rowData[name][nestedName] as string)).format(DATE_TIME_FORMATS.DATE)
 //         : '';
 //     } else {
 //       // eslint-disable-next-line @typescript-eslint/ban-ts-comment
 //       // @ts-ignore
 //       return rowData[name]
 //         ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
 //           // @ts-ignore
 //           moment(parseInt(rowData[name] as string)).format(DATE_TIME_FORMATS.DATE)
 //         : '';
 //     }
 //   };

});
parcelRegister("aitry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77f26cb2b0fda3b7$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $gIHYf = parcelRequire("gIHYf");

var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $fGH8N = parcelRequire("fGH8N");

var $DLUvM = parcelRequire("DLUvM");

var $ih19M = parcelRequire("ih19M");
"use client";
const $77f26cb2b0fda3b7$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $77f26cb2b0fda3b7$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $fGH8N.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $DLUvM.getTypographyUtilityClass), classes);
};
const $77f26cb2b0fda3b7$export$140e2f5526d3cad8 = (0, $g4l1t.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $fGH8N.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $77f26cb2b0fda3b7$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $77f26cb2b0fda3b7$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $77f26cb2b0fda3b7$var$transformDeprecatedColors = (color)=>{
    return $77f26cb2b0fda3b7$var$colorTransformations[color] || color;
};
const $77f26cb2b0fda3b7$var$Typography = /*#__PURE__*/ $bh6RR.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $77f26cb2b0fda3b7$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $gIHYf.default)((0, $4WYaH.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $77f26cb2b0fda3b7$var$defaultVariantMapping } = props, other = (0, $hCIyK.default)(props, $77f26cb2b0fda3b7$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $77f26cb2b0fda3b7$var$defaultVariantMapping[variant]) || "span";
    const classes = $77f26cb2b0fda3b7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($77f26cb2b0fda3b7$export$140e2f5526d3cad8, (0, $4WYaH.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className)
    }, other));
});
var $77f26cb2b0fda3b7$export$2e2bcd8739ae039 = $77f26cb2b0fda3b7$var$Typography;

});
parcelRegister("DLUvM", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", function () { return $0778cea7da3e9252$export$24c1f8f60cbac79e; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $0778cea7da3e9252$export$24c1f8f60cbac79e(slot) {
    return (0, $XybB6.default)("MuiTypography", slot);
}
const $0778cea7da3e9252$var$typographyClasses = (0, $igcUF.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $0778cea7da3e9252$export$2e2bcd8739ae039 = $0778cea7da3e9252$var$typographyClasses;

});



parcelRegister("8d818", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98760780514d44dd$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $iWE1K = parcelRequire("iWE1K");

var $aPsoC = parcelRequire("aPsoC");

var $lGCck = parcelRequire("lGCck");

var $6L9uu = parcelRequire("6L9uu");

var $cXsrx = parcelRequire("cXsrx");
const $98760780514d44dd$var$useStyles = (0, $lGCck.default)(()=>{
    return {
        modal: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        "&:focus": {
            outline: "none"
        }
    };
});
const $98760780514d44dd$var$Loader = ({ loading: loading, modalClasses: modalClasses })=>{
    const classes = $98760780514d44dd$var$useStyles();
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cXsrx.default), {
        className: (0, $aPsoC.default)(classes.modal, modalClasses, "modalContainer"),
        open: loading,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            id: "loadingContainer",
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iWE1K))), {
                size: 120,
                color: (0, $6L9uu.Colors).main,
                loading: true
            })
        })
    });
};
var $98760780514d44dd$export$2e2bcd8739ae039 = $98760780514d44dd$var$Loader;

});
parcelRegister("iWE1K", function(module, exports) {
"use strict";
var $dcacb1529eef9b44$var$__assign = module.exports && module.exports.__assign || function() {
    $dcacb1529eef9b44$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dcacb1529eef9b44$var$__assign.apply(this, arguments);
};
var $dcacb1529eef9b44$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dcacb1529eef9b44$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $dcacb1529eef9b44$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $dcacb1529eef9b44$var$__createBinding(result, mod, k);
    }
    $dcacb1529eef9b44$var$__setModuleDefault(result, mod);
    return result;
};
var $dcacb1529eef9b44$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dcacb1529eef9b44$var$React = $dcacb1529eef9b44$var$__importStar((parcelRequire("bh6RR")));

var $2UVtk = parcelRequire("2UVtk");

var $kPILs = parcelRequire("kPILs");
var $dcacb1529eef9b44$var$rotate = (0, $kPILs.createAnimation)("DotLoader", "100% {transform: rotate(360deg)}", "rotate");
var $dcacb1529eef9b44$var$bounce = (0, $kPILs.createAnimation)("DotLoader", "0%, 100% {transform: scale(0)} 50% {transform: scale(1.0)}", "bounce");
function $dcacb1529eef9b44$var$DotLoader(_a) {
    var _b = _a.loading, loading = _b === void 0 ? true : _b, _c = _a.color, color = _c === void 0 ? "#000000" : _c, _d = _a.speedMultiplier, speedMultiplier = _d === void 0 ? 1 : _d, _e = _a.cssOverride, cssOverride = _e === void 0 ? {} : _e, _f = _a.size, size = _f === void 0 ? 60 : _f, additionalprops = $dcacb1529eef9b44$var$__rest(_a, [
        "loading",
        "color",
        "speedMultiplier",
        "cssOverride",
        "size"
    ]);
    var wrapper = $dcacb1529eef9b44$var$__assign({
        display: "inherit",
        position: "relative",
        width: (0, $2UVtk.cssValue)(size),
        height: (0, $2UVtk.cssValue)(size),
        animationFillMode: "forwards",
        animation: "".concat($dcacb1529eef9b44$var$rotate, " ").concat(2 / speedMultiplier, "s 0s infinite linear")
    }, cssOverride);
    var style = function(i) {
        var _a = (0, $2UVtk.parseLengthAndUnit)(size), value = _a.value, unit = _a.unit;
        return {
            position: "absolute",
            top: i % 2 ? "0" : "auto",
            bottom: i % 2 ? "auto" : "0",
            height: "".concat(value / 2).concat(unit),
            width: "".concat(value / 2).concat(unit),
            backgroundColor: color,
            borderRadius: "100%",
            animationFillMode: "forwards",
            animation: "".concat($dcacb1529eef9b44$var$bounce, " ").concat(2 / speedMultiplier, "s ").concat(i === 2 ? "1s" : "0s", " infinite linear")
        };
    };
    if (!loading) return null;
    return $dcacb1529eef9b44$var$React.createElement("span", $dcacb1529eef9b44$var$__assign({
        style: wrapper
    }, additionalprops), $dcacb1529eef9b44$var$React.createElement("span", {
        style: style(1)
    }), $dcacb1529eef9b44$var$React.createElement("span", {
        style: style(2)
    }));
}
module.exports.default = $dcacb1529eef9b44$var$DotLoader;

});
parcelRegister("2UVtk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cssValue = module.exports.parseLengthAndUnit = void 0;
var $21fd6477d0fd10d8$var$cssUnit = {
    cm: true,
    mm: true,
    in: true,
    px: true,
    pt: true,
    pc: true,
    em: true,
    ex: true,
    ch: true,
    rem: true,
    vw: true,
    vh: true,
    vmin: true,
    vmax: true,
    "%": true
};
/**
 * If size is a number, append px to the value as default unit.
 * If size is a string, validate against list of valid units.
 * If unit is valid, return size as is.
 * If unit is invalid, console warn issue, replace with px as the unit.
 *
 * @param {(number | string)} size
 * @return {LengthObject} LengthObject
 */ function $21fd6477d0fd10d8$var$parseLengthAndUnit(size) {
    if (typeof size === "number") return {
        value: size,
        unit: "px"
    };
    var value;
    var valueString = (size.match(/^[0-9.]*/) || "").toString();
    if (valueString.includes(".")) value = parseFloat(valueString);
    else value = parseInt(valueString, 10);
    var unit = (size.match(/[^0-9]*$/) || "").toString();
    if ($21fd6477d0fd10d8$var$cssUnit[unit]) return {
        value: value,
        unit: unit
    };
    console.warn("React Spinners: ".concat(size, " is not a valid css value. Defaulting to ").concat(value, "px."));
    return {
        value: value,
        unit: "px"
    };
}
module.exports.parseLengthAndUnit = $21fd6477d0fd10d8$var$parseLengthAndUnit;
/**
 * Take value as an input and return valid css value
 *
 * @param {(number | string)} value
 * @return {string} valid css value
 */ function $21fd6477d0fd10d8$var$cssValue(value) {
    var lengthWithunit = $21fd6477d0fd10d8$var$parseLengthAndUnit(value);
    return "".concat(lengthWithunit.value).concat(lengthWithunit.unit);
}
module.exports.cssValue = $21fd6477d0fd10d8$var$cssValue;

});

parcelRegister("kPILs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createAnimation = void 0;
var $f2ab4b5d051c8e61$var$createAnimation = function(loaderName, frames, suffix) {
    var animationName = "react-spinners-".concat(loaderName, "-").concat(suffix);
    if (typeof window == "undefined" || !window.document) return animationName;
    var styleEl = document.createElement("style");
    document.head.appendChild(styleEl);
    var styleSheet = styleEl.sheet;
    var keyFrames = "\n    @keyframes ".concat(animationName, " {\n      ").concat(frames, "\n    }\n  ");
    if (styleSheet) styleSheet.insertRule(keyFrames, 0);
    return animationName;
};
module.exports.createAnimation = $f2ab4b5d051c8e61$var$createAnimation;

});


parcelRegister("lGCck", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc9b2689ac88a840$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $lrqlA = parcelRequire("lrqlA");

var $5bDNZ = parcelRequire("5bDNZ");

var $1Ax3N = parcelRequire("1Ax3N");

var $6xqDW = parcelRequire("6xqDW");

var $jbrI0 = parcelRequire("jbrI0");

var $imu6v = parcelRequire("imu6v");

var $lFwTe = parcelRequire("lFwTe");

var $bs7R3 = parcelRequire("bs7R3");
const $fc9b2689ac88a840$var$_excluded = [
    "name",
    "classNamePrefix",
    "Component",
    "defaultTheme"
];
function $fc9b2689ac88a840$var$getClasses({ state: state, stylesOptions: stylesOptions }, classes, Component) {
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
    // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    let generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $5bDNZ.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $fc9b2689ac88a840$var$attach({ state: state, theme: theme, stylesOptions: stylesOptions, stylesCreator: stylesCreator, name: name }, props) {
    if (stylesOptions.disableGeneration) return;
    let sheetManager = (0, $1Ax3N.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $1Ax3N.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    const options = (0, $4WYaH.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === "boolean" ? stylesOptions.flip : theme.direction === "rtl"
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        let staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $1Ax3N.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        const styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $4WYaH.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $1Ax3N.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $lrqlA.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        const dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $4WYaH.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $5bDNZ.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $fc9b2689ac88a840$var$update({ state: state }, props) {
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $fc9b2689ac88a840$var$detach({ state: state, theme: theme, stylesOptions: stylesOptions, stylesCreator: stylesCreator }) {
    if (stylesOptions.disableGeneration) return;
    const sheetManager = (0, $1Ax3N.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $1Ax3N.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $fc9b2689ac88a840$var$useSynchronousEffect(func, values) {
    const key = $bh6RR.useRef([]);
    let output;
    // Store "generation" key. Just returns a new object every time
    const currentKey = $bh6RR.useMemo(()=>({}), values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    $bh6RR.useEffect(()=>()=>{
            if (output) output();
        }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $fc9b2689ac88a840$export$2e2bcd8739ae039(stylesOrCreator, options = {}) {
    const { name: // alias for classNamePrefix, if provided will listen to theme (required for theme.components[name].styleOverrides)
    name, // Help with debuggability.
    classNamePrefix: classNamePrefixOption, Component: Component, defaultTheme: defaultTheme = (0, $bs7R3.default) } = options, stylesOptions2 = (0, $hCIyK.default)(options, $fc9b2689ac88a840$var$_excluded);
    const stylesCreator = (0, $lFwTe.default)(stylesOrCreator);
    const classNamePrefix = name || classNamePrefixOption || "makeStyles";
    stylesCreator.options = {
        index: (0, $imu6v.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    const useStyles = (props = {})=>{
        const theme = (0, $6xqDW.default)() || defaultTheme;
        const stylesOptions = (0, $4WYaH.default)({}, $bh6RR.useContext((0, $jbrI0.StylesContext)), stylesOptions2);
        const instance = $bh6RR.useRef();
        const shouldUpdate = $bh6RR.useRef();
        $fc9b2689ac88a840$var$useSynchronousEffect(()=>{
            const current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $fc9b2689ac88a840$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return ()=>{
                $fc9b2689ac88a840$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        $bh6RR.useEffect(()=>{
            if (shouldUpdate.current) $fc9b2689ac88a840$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        const classes = $fc9b2689ac88a840$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}

});
parcelRegister("lrqlA", function(module, exports) {

$parcel$export(module.exports, "createRule", function () { return createRule; });
$parcel$export(module.exports, "toCssValue", function () { return toCssValue; });
$parcel$export(module.exports, "RuleList", function () { return RuleList; });
$parcel$export(module.exports, "create", function () { return createJss; });
$parcel$export(module.exports, "hasCSSTOMSupport", function () { return hasCSSTOMSupport; });
$parcel$export(module.exports, "getDynamicStyles", function () { return getDynamicStyles; });

var $4WYaH = parcelRequire("4WYaH");

var $cob8O = parcelRequire("cob8O");

var $bKo8Q = parcelRequire("bKo8Q");

var $kuNiL = parcelRequire("kuNiL");

var $gMqD6 = parcelRequire("gMqD6");

var $hqR4t = parcelRequire("hqR4t");

var $hCIyK = parcelRequire("hCIyK");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== "object") return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = "unnamed";
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = "";
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === "!important") break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ""; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === "!important") break;
        if (cssValue) cssValue += ", ";
        cssValue += join(value[i], " ");
    }
    else cssValue = join(value, ", "); // Add !important, because it was ignored.
    if (value[value.length - 1] === "!important") cssValue += " !important";
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: "",
        space: ""
    };
    return {
        linebreak: "\n",
        space: " "
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = "";
    for(var index = 0; index < indent; index++)result += "  ";
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = "";
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== "fallbacks") {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr("}", indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== "undefined" && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, "\\$1");
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = "style";
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $gMqD6.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $hqR4t.default)((0, $hqR4t.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== "object") json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $4WYaH.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $kuNiL.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === "@" || options.parent && options.parent.type === "keyframes") return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = "conditional";
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : "unknown"; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $4WYaH.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : "";
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = "keyframes";
        this.at = "@keyframes";
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = "noname";
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $4WYaH.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $4WYaH.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === "string") return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === "string" && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style" || !sheet) return style;
        if ("animation-name" in style) replaceRef(style, "animation-name", sheet.keyframes);
        if ("animation" in style) replaceRef(style, "animation", sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case "animation":
                return findReferencedKeyframe(val, sheet.keyframes);
            case "animation-name":
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $gMqD6.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $4WYaH.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === "keyframes") return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = "font-face";
        this.at = "@font-face";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = "";
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = "viewport";
        this.at = "@viewport";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === "@viewport" || key === "@-ms-viewport" ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = "simple";
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = "";
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += "\n";
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    "@charset": true,
    "@import": true,
    "@namespace": true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $4WYaH.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $4WYaH.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string") {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = "";
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $4WYaH.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === "object" ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: "external"
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $hCIyK.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = "";
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $kuNiL.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" && window.Math === Math ? window : typeof self !== "undefined" && self.Math === Math ? self : Function("return this")();
var ns = "2f1acc6c3a606b082e5eef5e54414ffb";
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = "";
        var prefix = "";
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || "c") + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : "") + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return "";
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf("!important") : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? "important" : "");
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector("head");
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === "string") {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === "number") {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute("content") : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ("insertRule" in container) container.insertRule(rule, index);
        else if ("appendRule" in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement("style"); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = "\n";
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute("data-jss", "");
        if (media) this.element.setAttribute("media", media);
        if (meta) this.element.setAttribute("data-meta", meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute("nonce", nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = "\n";
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === "conditional" || rule.type === "keyframes") {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $cob8O.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: "internal"
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $4WYaH.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ("Renderer" in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== "number") index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $4WYaH.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === "object") return this.createRule(undefined, name, style);
        var ruleOptions = (0, $4WYaH.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $bKo8Q.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $bKo8Q.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $kuNiL.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === "object" && CSS != null && "number" in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === "function") {
            if (!to) to = {};
            to[key] = value;
        } else if (type === "object" && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $f9c08e91c2468f05$export$2e2bcd8739ae039 = index;

});
parcelRegister("cob8O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90505e58c00ce0c9$export$2e2bcd8739ae039; });
var $90505e58c00ce0c9$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $90505e58c00ce0c9$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $90505e58c00ce0c9$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $90505e58c00ce0c9$var$_typeof(document)) === "object" && document.nodeType === 9;
var $90505e58c00ce0c9$export$2e2bcd8739ae039 = $90505e58c00ce0c9$export$4e09c449d6c407f7;

});

parcelRegister("bKo8Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88d6b79dcec0cfd7$export$2e2bcd8739ae039; });
var $88d6b79dcec0cfd7$var$isProduction = true;
function $88d6b79dcec0cfd7$var$warning(condition, message) {
    if (!$88d6b79dcec0cfd7$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $88d6b79dcec0cfd7$export$2e2bcd8739ae039 = $88d6b79dcec0cfd7$var$warning;

});

parcelRegister("kuNiL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eebcda4657ff09bb$export$2e2bcd8739ae039; });

var $hTglg = parcelRequire("hTglg");
function $eebcda4657ff09bb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $hTglg.default)(descriptor.key), descriptor);
    }
}
function $eebcda4657ff09bb$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $eebcda4657ff09bb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $eebcda4657ff09bb$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});
parcelRegister("hTglg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0643fe154cb74c1$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");

var $cMfNc = parcelRequire("cMfNc");
function $d0643fe154cb74c1$export$2e2bcd8739ae039(t) {
    var i = (0, $cMfNc.default)(t, "string");
    return "symbol" == (0, $51lpG.default)(i) ? i : String(i);
}

});
parcelRegister("51lpG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a7da7f4c81a8554$export$2e2bcd8739ae039; });
function $3a7da7f4c81a8554$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $3a7da7f4c81a8554$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3a7da7f4c81a8554$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cMfNc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94d637ce061dd3ca$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");
function $94d637ce061dd3ca$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $51lpG.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $51lpG.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("5bDNZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c6cdb592d0f78ff$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

function $3c6cdb592d0f78ff$export$2e2bcd8739ae039(options = {}) {
    const { baseClasses: baseClasses, newClasses: newClasses, Component: Component } = options;
    if (!newClasses) return baseClasses;
    const nextClasses = (0, $4WYaH.default)({}, baseClasses);
    Object.keys(newClasses).forEach((key)=>{
        if (newClasses[key]) nextClasses[key] = `${baseClasses[key]} ${newClasses[key]}`;
    });
    return nextClasses;
}

});

parcelRegister("1Ax3N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1282cc53521097b4$export$2e2bcd8739ae039; });
// Used https://github.com/thinkloop/multi-key-cache as inspiration
const $1282cc53521097b4$var$multiKeyStore = {
    set: (cache, key1, key2, value)=>{
        let subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $1282cc53521097b4$export$2e2bcd8739ae039 = $1282cc53521097b4$var$multiKeyStore;

});

parcelRegister("6xqDW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c2a7df26390fbda$export$2e2bcd8739ae039; });

var $fwLjQ = parcelRequire("fwLjQ");
function $4c2a7df26390fbda$export$2e2bcd8739ae039() {
    var _privateTheme$$$mater;
    const privateTheme = (0, $fwLjQ.default)();
    return (_privateTheme$$$mater = privateTheme == null ? void 0 : privateTheme.$$material) != null ? _privateTheme$$$mater : privateTheme;
}

});
parcelRegister("fwLjQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4de8cc6d4bd6bc2$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $1mHbS = parcelRequire("1mHbS");
function $b4de8cc6d4bd6bc2$export$2e2bcd8739ae039() {
    const theme = $bh6RR.useContext((0, $1mHbS.default));
    return theme;
}

});
parcelRegister("1mHbS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fe9594a3f1c8c31$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
const $0fe9594a3f1c8c31$var$ThemeContext = /*#__PURE__*/ $bh6RR.createContext(null);
var $0fe9594a3f1c8c31$export$2e2bcd8739ae039 = $0fe9594a3f1c8c31$var$ThemeContext;

});



parcelRegister("jbrI0", function(module, exports) {

$parcel$export(module.exports, "StylesContext", function () { return $df7489c7071e411d$export$f4de434b269fe487; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");



var $lrqlA = parcelRequire("lrqlA");

var $c3wK5 = parcelRequire("c3wK5");

var $fcKLw = parcelRequire("fcKLw");

var $ih19M = parcelRequire("ih19M");
const $df7489c7071e411d$var$_excluded = [
    "children",
    "injectFirst",
    "disableGeneration"
];
const $df7489c7071e411d$var$defaultJSS = (0, $lrqlA.create)((0, $fcKLw.default)());
// Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
const $df7489c7071e411d$var$defaultGenerateClassName = (0, $c3wK5.default)();
const $df7489c7071e411d$export$70a8aea9ff58d1cd = new Map();
const $df7489c7071e411d$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $df7489c7071e411d$var$defaultGenerateClassName,
    jss: $df7489c7071e411d$var$defaultJSS,
    sheetsCache: null,
    sheetsManager: $df7489c7071e411d$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
const $df7489c7071e411d$export$f4de434b269fe487 = /*#__PURE__*/ $bh6RR.createContext($df7489c7071e411d$var$defaultOptions);
let $df7489c7071e411d$var$injectFirstNode;
function $df7489c7071e411d$export$2e2bcd8739ae039(props) {
    const { children: children, injectFirst: injectFirst = false, disableGeneration: disableGeneration = false } = props, localOptions = (0, $hCIyK.default)(props, $df7489c7071e411d$var$_excluded);
    const outerOptions = $bh6RR.useContext($df7489c7071e411d$export$f4de434b269fe487);
    const { generateClassName: generateClassName, jss: jss, serverGenerateClassName: serverGenerateClassName, sheetsCache: sheetsCache, sheetsManager: sheetsManager, sheetsRegistry: sheetsRegistry } = (0, $4WYaH.default)({}, outerOptions, localOptions);
    const value = $bh6RR.useMemo(()=>{
        const context = {
            disableGeneration: disableGeneration,
            generateClassName: generateClassName,
            jss: jss,
            serverGenerateClassName: serverGenerateClassName,
            sheetsCache: sheetsCache,
            sheetsManager: sheetsManager,
            sheetsRegistry: sheetsRegistry
        };
        if (!context.jss.options.insertionPoint && injectFirst && typeof window !== "undefined") {
            if (!$df7489c7071e411d$var$injectFirstNode) {
                const head = document.head;
                $df7489c7071e411d$var$injectFirstNode = document.createComment("mui-inject-first");
                head.insertBefore($df7489c7071e411d$var$injectFirstNode, head.firstChild);
            }
            context.jss = (0, $lrqlA.create)({
                plugins: (0, $fcKLw.default)().plugins,
                insertionPoint: $df7489c7071e411d$var$injectFirstNode
            });
        }
        return context;
    }, [
        injectFirst,
        disableGeneration,
        generateClassName,
        jss,
        serverGenerateClassName,
        sheetsCache,
        sheetsManager,
        sheetsRegistry
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($df7489c7071e411d$export$f4de434b269fe487.Provider, {
        value: value,
        children: children
    });
}

});
parcelRegister("c3wK5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c6f29cf3f6bfd12$export$2e2bcd8739ae039; });

var $jIarf = parcelRequire("jIarf");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously defined styles as well as
 * being untouched by simple user overrides.
 */ const $8c6f29cf3f6bfd12$var$stateClasses = [
    "checked",
    "disabled",
    "error",
    "focused",
    "focusVisible",
    "required",
    "expanded",
    "selected"
];
function $8c6f29cf3f6bfd12$export$2e2bcd8739ae039(options = {}) {
    const { disableGlobal: disableGlobal = false, productionPrefix: productionPrefix = "jss", seed: seed = "" } = options;
    const seedPrefix = seed === "" ? "" : `${seed}-`;
    let ruleCounter = 0;
    const getNextCounterId = ()=>{
        ruleCounter += 1;
        return ruleCounter;
    };
    return (rule, styleSheet)=>{
        const name = styleSheet.options.name;
        // Is a global static MUI style?
        if (name && name.indexOf("Mui") === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($8c6f29cf3f6bfd12$var$stateClasses.indexOf(rule.key) !== -1) return `Mui-${rule.key}`;
            const prefix = `${seedPrefix}${name}-${rule.key}`;
            if (!styleSheet.options.theme[0, $jIarf.default] || seed !== "") return prefix;
            return `${prefix}-${getNextCounterId()}`;
        }
        return `${seedPrefix}${productionPrefix}${getNextCounterId()}`;
    };
}

});
parcelRegister("jIarf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e59a393a76df9a0e$export$2e2bcd8739ae039; });
const $e59a393a76df9a0e$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $e59a393a76df9a0e$export$2e2bcd8739ae039 = $e59a393a76df9a0e$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";

});


parcelRegister("fcKLw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b11c40a5a8bae43c$export$2e2bcd8739ae039; });

var $lGn75 = parcelRequire("lGn75");

var $ddY0D = parcelRequire("ddY0D");

var $avNTh = parcelRequire("avNTh");

var $6DGTk = parcelRequire("6DGTk");

var $9CUwI = parcelRequire("9CUwI");

var $gAErx = parcelRequire("gAErx");

var $80wZV = parcelRequire("80wZV");
function $b11c40a5a8bae43c$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $lGn75.default)(),
            (0, $ddY0D.default)(),
            (0, $avNTh.default)(),
            (0, $6DGTk.default)(),
            (0, $9CUwI.default)(),
            // Disable the vendor prefixer server-side, it does nothing.
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === "undefined" ? null : (0, $gAErx.default)(),
            (0, $80wZV.default)()
        ]
    };
}

});
parcelRegister("lGn75", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc8f730b382434f1$export$2e2bcd8739ae039; });


var $lrqlA = parcelRequire("lrqlA");
var $fc8f730b382434f1$var$now = Date.now();
var $fc8f730b382434f1$var$fnValuesNs = "fnValues" + $fc8f730b382434f1$var$now;
var $fc8f730b382434f1$var$fnRuleNs = "fnStyle" + ++$fc8f730b382434f1$var$now;
var $fc8f730b382434f1$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== "function") return null;
            var rule = (0, $lrqlA.createRule)(name, {}, options);
            rule[$fc8f730b382434f1$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($fc8f730b382434f1$var$fnValuesNs in rule || $fc8f730b382434f1$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== "function") continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$fc8f730b382434f1$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$fc8f730b382434f1$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$fc8f730b382434f1$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $fc8f730b382434f1$export$2e2bcd8739ae039 = $fc8f730b382434f1$var$functionPlugin;

});

parcelRegister("ddY0D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a0b09d8df48aadc$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $lrqlA = parcelRequire("lrqlA");
var $9a0b09d8df48aadc$var$at = "@global";
var $9a0b09d8df48aadc$var$atPrefix = "@global ";
var $9a0b09d8df48aadc$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = "global";
        this.at = $9a0b09d8df48aadc$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $lrqlA.RuleList)((0, $4WYaH.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $9a0b09d8df48aadc$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = "global";
        this.at = $9a0b09d8df48aadc$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($9a0b09d8df48aadc$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $4WYaH.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : "";
    };
    return GlobalPrefixedRule;
}();
var $9a0b09d8df48aadc$var$separatorRegExp = /\s*,\s*/g;
function $9a0b09d8df48aadc$var$addScope(selector, scope) {
    var parts = selector.split($9a0b09d8df48aadc$var$separatorRegExp);
    var scoped = "";
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ", ";
    }
    return scoped;
}
function $9a0b09d8df48aadc$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$9a0b09d8df48aadc$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $4WYaH.default)({}, options, {
        selector: $9a0b09d8df48aadc$var$addScope(name, rule.selector)
    }));
    delete style[$9a0b09d8df48aadc$var$at];
}
function $9a0b09d8df48aadc$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== "@" || prop.substr(0, $9a0b09d8df48aadc$var$at.length) !== $9a0b09d8df48aadc$var$at) continue;
        var selector = $9a0b09d8df48aadc$var$addScope(prop.substr($9a0b09d8df48aadc$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $4WYaH.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $9a0b09d8df48aadc$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $9a0b09d8df48aadc$var$at) return new $9a0b09d8df48aadc$var$GlobalContainerRule(name, styles, options);
        if (name[0] === "@" && name.substr(0, $9a0b09d8df48aadc$var$atPrefix.length) === $9a0b09d8df48aadc$var$atPrefix) return new $9a0b09d8df48aadc$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === "global" || parent.options.parent && parent.options.parent.type === "global") options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== "style" || !sheet) return;
        $9a0b09d8df48aadc$var$handleNestedGlobalContainerRule(rule, sheet);
        $9a0b09d8df48aadc$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $9a0b09d8df48aadc$export$2e2bcd8739ae039 = $9a0b09d8df48aadc$var$jssGlobal;

});

parcelRegister("avNTh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01f99ad62fc1fd6d$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $01f99ad62fc1fd6d$var$separatorRegExp = /\s*,\s*/g;
var $01f99ad62fc1fd6d$var$parentRegExp = /&/g;
var $01f99ad62fc1fd6d$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $01f99ad62fc1fd6d$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($01f99ad62fc1fd6d$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($01f99ad62fc1fd6d$var$separatorRegExp);
        var result = "";
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ", "; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf("&") !== -1 ? nested.replace($01f99ad62fc1fd6d$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $4WYaH.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $4WYaH.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style") return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf("&") !== -1;
            var isNestedConditional = prop[0] === "@";
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($01f99ad62fc1fd6d$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ("replaceRule" in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $4WYaH.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $4WYaH.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $01f99ad62fc1fd6d$export$2e2bcd8739ae039 = $01f99ad62fc1fd6d$var$jssNested;

});

parcelRegister("6DGTk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d57a7ec76f96997$export$2e2bcd8739ae039; });

var $1mQJn = parcelRequire("1mQJn");
/**
 * Convert camel cased property names to dash separated.
 */ function $4d57a7ec76f96997$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf("--") === 0 ? prop : (0, $1mQJn.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($4d57a7ec76f96997$var$convertCase);
        else converted.fallbacks = $4d57a7ec76f96997$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $4d57a7ec76f96997$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $4d57a7ec76f96997$var$convertCase(style[index]);
            return style;
        }
        return $4d57a7ec76f96997$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf("--") === 0) return value;
        var hyphenatedProp = (0, $1mQJn.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $4d57a7ec76f96997$export$2e2bcd8739ae039 = $4d57a7ec76f96997$var$camelCase;

});
parcelRegister("1mQJn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ff0bfc26ba44f29$export$2e2bcd8739ae039; });
/* eslint-disable no-var, prefer-template */ var $0ff0bfc26ba44f29$var$uppercasePattern = /[A-Z]/g;
var $0ff0bfc26ba44f29$var$msPattern = /^ms-/;
var $0ff0bfc26ba44f29$var$cache = {};
function $0ff0bfc26ba44f29$var$toHyphenLower(match) {
    return "-" + match.toLowerCase();
}
function $0ff0bfc26ba44f29$var$hyphenateStyleName(name) {
    if ($0ff0bfc26ba44f29$var$cache.hasOwnProperty(name)) return $0ff0bfc26ba44f29$var$cache[name];
    var hName = name.replace($0ff0bfc26ba44f29$var$uppercasePattern, $0ff0bfc26ba44f29$var$toHyphenLower);
    return $0ff0bfc26ba44f29$var$cache[name] = $0ff0bfc26ba44f29$var$msPattern.test(hName) ? "-" + hName : hName;
}
var $0ff0bfc26ba44f29$export$2e2bcd8739ae039 = $0ff0bfc26ba44f29$var$hyphenateStyleName;

});


parcelRegister("9CUwI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $702382a92195133c$export$2e2bcd8739ae039; });

var $lrqlA = parcelRequire("lrqlA");
var $702382a92195133c$var$px = (0, $lrqlA.hasCSSTOMSupport) && CSS ? CSS.px : "px";
var $702382a92195133c$var$ms = (0, $lrqlA.hasCSSTOMSupport) && CSS ? CSS.ms : "ms";
var $702382a92195133c$var$percent = (0, $lrqlA.hasCSSTOMSupport) && CSS ? CSS.percent : "%";
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $702382a92195133c$var$defaultUnits = {
    // Animation properties
    "animation-delay": $702382a92195133c$var$ms,
    "animation-duration": $702382a92195133c$var$ms,
    // Background properties
    "background-position": $702382a92195133c$var$px,
    "background-position-x": $702382a92195133c$var$px,
    "background-position-y": $702382a92195133c$var$px,
    "background-size": $702382a92195133c$var$px,
    // Border Properties
    border: $702382a92195133c$var$px,
    "border-bottom": $702382a92195133c$var$px,
    "border-bottom-left-radius": $702382a92195133c$var$px,
    "border-bottom-right-radius": $702382a92195133c$var$px,
    "border-bottom-width": $702382a92195133c$var$px,
    "border-left": $702382a92195133c$var$px,
    "border-left-width": $702382a92195133c$var$px,
    "border-radius": $702382a92195133c$var$px,
    "border-right": $702382a92195133c$var$px,
    "border-right-width": $702382a92195133c$var$px,
    "border-top": $702382a92195133c$var$px,
    "border-top-left-radius": $702382a92195133c$var$px,
    "border-top-right-radius": $702382a92195133c$var$px,
    "border-top-width": $702382a92195133c$var$px,
    "border-width": $702382a92195133c$var$px,
    "border-block": $702382a92195133c$var$px,
    "border-block-end": $702382a92195133c$var$px,
    "border-block-end-width": $702382a92195133c$var$px,
    "border-block-start": $702382a92195133c$var$px,
    "border-block-start-width": $702382a92195133c$var$px,
    "border-block-width": $702382a92195133c$var$px,
    "border-inline": $702382a92195133c$var$px,
    "border-inline-end": $702382a92195133c$var$px,
    "border-inline-end-width": $702382a92195133c$var$px,
    "border-inline-start": $702382a92195133c$var$px,
    "border-inline-start-width": $702382a92195133c$var$px,
    "border-inline-width": $702382a92195133c$var$px,
    "border-start-start-radius": $702382a92195133c$var$px,
    "border-start-end-radius": $702382a92195133c$var$px,
    "border-end-start-radius": $702382a92195133c$var$px,
    "border-end-end-radius": $702382a92195133c$var$px,
    // Margin properties
    margin: $702382a92195133c$var$px,
    "margin-bottom": $702382a92195133c$var$px,
    "margin-left": $702382a92195133c$var$px,
    "margin-right": $702382a92195133c$var$px,
    "margin-top": $702382a92195133c$var$px,
    "margin-block": $702382a92195133c$var$px,
    "margin-block-end": $702382a92195133c$var$px,
    "margin-block-start": $702382a92195133c$var$px,
    "margin-inline": $702382a92195133c$var$px,
    "margin-inline-end": $702382a92195133c$var$px,
    "margin-inline-start": $702382a92195133c$var$px,
    // Padding properties
    padding: $702382a92195133c$var$px,
    "padding-bottom": $702382a92195133c$var$px,
    "padding-left": $702382a92195133c$var$px,
    "padding-right": $702382a92195133c$var$px,
    "padding-top": $702382a92195133c$var$px,
    "padding-block": $702382a92195133c$var$px,
    "padding-block-end": $702382a92195133c$var$px,
    "padding-block-start": $702382a92195133c$var$px,
    "padding-inline": $702382a92195133c$var$px,
    "padding-inline-end": $702382a92195133c$var$px,
    "padding-inline-start": $702382a92195133c$var$px,
    // Mask properties
    "mask-position-x": $702382a92195133c$var$px,
    "mask-position-y": $702382a92195133c$var$px,
    "mask-size": $702382a92195133c$var$px,
    // Width and height properties
    height: $702382a92195133c$var$px,
    width: $702382a92195133c$var$px,
    "min-height": $702382a92195133c$var$px,
    "max-height": $702382a92195133c$var$px,
    "min-width": $702382a92195133c$var$px,
    "max-width": $702382a92195133c$var$px,
    // Position properties
    bottom: $702382a92195133c$var$px,
    left: $702382a92195133c$var$px,
    top: $702382a92195133c$var$px,
    right: $702382a92195133c$var$px,
    inset: $702382a92195133c$var$px,
    "inset-block": $702382a92195133c$var$px,
    "inset-block-end": $702382a92195133c$var$px,
    "inset-block-start": $702382a92195133c$var$px,
    "inset-inline": $702382a92195133c$var$px,
    "inset-inline-end": $702382a92195133c$var$px,
    "inset-inline-start": $702382a92195133c$var$px,
    // Shadow properties
    "box-shadow": $702382a92195133c$var$px,
    "text-shadow": $702382a92195133c$var$px,
    // Column properties
    "column-gap": $702382a92195133c$var$px,
    "column-rule": $702382a92195133c$var$px,
    "column-rule-width": $702382a92195133c$var$px,
    "column-width": $702382a92195133c$var$px,
    // Font and text properties
    "font-size": $702382a92195133c$var$px,
    "font-size-delta": $702382a92195133c$var$px,
    "letter-spacing": $702382a92195133c$var$px,
    "text-decoration-thickness": $702382a92195133c$var$px,
    "text-indent": $702382a92195133c$var$px,
    "text-stroke": $702382a92195133c$var$px,
    "text-stroke-width": $702382a92195133c$var$px,
    "word-spacing": $702382a92195133c$var$px,
    // Motion properties
    motion: $702382a92195133c$var$px,
    "motion-offset": $702382a92195133c$var$px,
    // Outline properties
    outline: $702382a92195133c$var$px,
    "outline-offset": $702382a92195133c$var$px,
    "outline-width": $702382a92195133c$var$px,
    // Perspective properties
    perspective: $702382a92195133c$var$px,
    "perspective-origin-x": $702382a92195133c$var$percent,
    "perspective-origin-y": $702382a92195133c$var$percent,
    // Transform properties
    "transform-origin": $702382a92195133c$var$percent,
    "transform-origin-x": $702382a92195133c$var$percent,
    "transform-origin-y": $702382a92195133c$var$percent,
    "transform-origin-z": $702382a92195133c$var$percent,
    // Transition properties
    "transition-delay": $702382a92195133c$var$ms,
    "transition-duration": $702382a92195133c$var$ms,
    // Alignment properties
    "vertical-align": $702382a92195133c$var$px,
    "flex-basis": $702382a92195133c$var$px,
    // Some random properties
    "shape-margin": $702382a92195133c$var$px,
    size: $702382a92195133c$var$px,
    gap: $702382a92195133c$var$px,
    // Grid properties
    grid: $702382a92195133c$var$px,
    "grid-gap": $702382a92195133c$var$px,
    "row-gap": $702382a92195133c$var$px,
    "grid-row-gap": $702382a92195133c$var$px,
    "grid-column-gap": $702382a92195133c$var$px,
    "grid-template-rows": $702382a92195133c$var$px,
    "grid-template-columns": $702382a92195133c$var$px,
    "grid-auto-rows": $702382a92195133c$var$px,
    "grid-auto-columns": $702382a92195133c$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    "box-shadow-x": $702382a92195133c$var$px,
    "box-shadow-y": $702382a92195133c$var$px,
    "box-shadow-blur": $702382a92195133c$var$px,
    "box-shadow-spread": $702382a92195133c$var$px,
    "font-line-height": $702382a92195133c$var$px,
    "text-shadow-x": $702382a92195133c$var$px,
    "text-shadow-y": $702382a92195133c$var$px,
    "text-shadow-blur": $702382a92195133c$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $702382a92195133c$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $702382a92195133c$var$units = $702382a92195133c$var$addCamelCasedVersion($702382a92195133c$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $702382a92195133c$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $702382a92195133c$var$iterate(prop, value[i], options);
    else if (typeof value === "object") {
        if (prop === "fallbacks") for(var innerProp in value)value[innerProp] = $702382a92195133c$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $702382a92195133c$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === "number" && isNaN(value) === false) {
        var unit = options[prop] || $702382a92195133c$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $702382a92195133c$var$px)) return typeof unit === "function" ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $702382a92195133c$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $702382a92195133c$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        for(var prop in style)style[prop] = $702382a92195133c$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $702382a92195133c$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $702382a92195133c$export$2e2bcd8739ae039 = $702382a92195133c$var$defaultUnit;

});

parcelRegister("gAErx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c13f6150388ba631$export$2e2bcd8739ae039; });

var $fjHKK = parcelRequire("fjHKK");

var $lrqlA = parcelRequire("lrqlA");
/**
 * Add vendor prefix to a property name when needed.
 */ function $c13f6150388ba631$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === "keyframes") {
            var atRule = rule;
            atRule.at = (0, $fjHKK.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === "fallbacks" && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $fjHKK.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $fjHKK.supportedValue)(supportedProp, (0, $lrqlA.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $fjHKK.supportedValue)(prop, (0, $lrqlA.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $c13f6150388ba631$export$2e2bcd8739ae039 = $c13f6150388ba631$var$jssVendorPrefixer;

});
parcelRegister("fjHKK", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", function () { return $b26a91ccc30c45c7$export$b6aa0648d950180a; });
$parcel$export(module.exports, "supportedProperty", function () { return $b26a91ccc30c45c7$export$ce097f82c2e4551a; });
$parcel$export(module.exports, "supportedValue", function () { return $b26a91ccc30c45c7$export$511766124059c277; });

var $cob8O = parcelRequire("cob8O");

var $jX7qT = parcelRequire("jX7qT");
// Export javascript style and css style vendor prefixes.
var $b26a91ccc30c45c7$var$js = "";
var $b26a91ccc30c45c7$var$css = "";
var $b26a91ccc30c45c7$var$vendor = "";
var $b26a91ccc30c45c7$var$browser = "";
var $b26a91ccc30c45c7$var$isTouch = (0, $cob8O.default) && "ontouchstart" in document.documentElement; // We should not do anything if required serverside.
if (0, $cob8O.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $b26a91ccc30c45c7$var$jsCssMap = {
        Moz: "-moz-",
        ms: "-ms-",
        O: "-o-",
        Webkit: "-webkit-"
    };
    var $b26a91ccc30c45c7$var$_document$createEleme = document.createElement("p"), $b26a91ccc30c45c7$var$style = $b26a91ccc30c45c7$var$_document$createEleme.style;
    var $b26a91ccc30c45c7$var$testProp = "Transform";
    for(var $b26a91ccc30c45c7$var$key in $b26a91ccc30c45c7$var$jsCssMap)if ($b26a91ccc30c45c7$var$key + $b26a91ccc30c45c7$var$testProp in $b26a91ccc30c45c7$var$style) {
        $b26a91ccc30c45c7$var$js = $b26a91ccc30c45c7$var$key;
        $b26a91ccc30c45c7$var$css = $b26a91ccc30c45c7$var$jsCssMap[$b26a91ccc30c45c7$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($b26a91ccc30c45c7$var$js === "Webkit" && "msHyphens" in $b26a91ccc30c45c7$var$style) {
        $b26a91ccc30c45c7$var$js = "ms";
        $b26a91ccc30c45c7$var$css = $b26a91ccc30c45c7$var$jsCssMap.ms;
        $b26a91ccc30c45c7$var$browser = "edge";
    } // Correctly detect the Safari browser.
    if ($b26a91ccc30c45c7$var$js === "Webkit" && "-apple-trailing-word" in $b26a91ccc30c45c7$var$style) $b26a91ccc30c45c7$var$vendor = "apple";
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $b26a91ccc30c45c7$export$82e9f45cca5ba907 = {
    js: $b26a91ccc30c45c7$var$js,
    css: $b26a91ccc30c45c7$var$css,
    vendor: $b26a91ccc30c45c7$var$vendor,
    browser: $b26a91ccc30c45c7$var$browser,
    isTouch: $b26a91ccc30c45c7$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $b26a91ccc30c45c7$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === "-") return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "ms") return key;
    return "@" + $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $b26a91ccc30c45c7$var$appearence = {
    noPrefill: [
        "appearance"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "appearance") return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "ms") return "-webkit-" + prop;
        return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $b26a91ccc30c45c7$var$colorAdjust = {
    noPrefill: [
        "color-adjust"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "color-adjust") return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "Webkit") return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $b26a91ccc30c45c7$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $b26a91ccc30c45c7$var$toUpper(match, c) {
    return c ? c.toUpperCase() : "";
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $b26a91ccc30c45c7$var$camelize(str) {
    return str.replace($b26a91ccc30c45c7$var$regExp, $b26a91ccc30c45c7$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $b26a91ccc30c45c7$var$pascalize(str) {
    return $b26a91ccc30c45c7$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $b26a91ccc30c45c7$var$mask = {
    noPrefill: [
        "mask"
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "Webkit") {
            var longhand = "mask-image";
            if ($b26a91ccc30c45c7$var$camelize(longhand) in style) return prop;
            if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js + $b26a91ccc30c45c7$var$pascalize(longhand) in style) return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $b26a91ccc30c45c7$var$textOrientation = {
    noPrefill: [
        "text-orientation"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "text-orientation") return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.vendor === "apple" && !$b26a91ccc30c45c7$export$82e9f45cca5ba907.isTouch) return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $b26a91ccc30c45c7$var$transform = {
    noPrefill: [
        "transform"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transform") return false;
        if (options.transform) return prop;
        return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $b26a91ccc30c45c7$var$transition = {
    noPrefill: [
        "transition"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transition") return false;
        if (options.transition) return prop;
        return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $b26a91ccc30c45c7$var$writingMode = {
    noPrefill: [
        "writing-mode"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "writing-mode") return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "Webkit" || $b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "ms" && $b26a91ccc30c45c7$export$82e9f45cca5ba907.browser !== "edge") return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $b26a91ccc30c45c7$var$userSelect = {
    noPrefill: [
        "user-select"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "user-select") return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "Moz" || $b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "ms" || $b26a91ccc30c45c7$export$82e9f45cca5ba907.vendor === "apple") return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $b26a91ccc30c45c7$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "Webkit") {
            var jsProp = "WebkitColumn" + $b26a91ccc30c45c7$var$pascalize(prop);
            return jsProp in style ? $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "Moz") {
            var _jsProp = "page" + $b26a91ccc30c45c7$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $b26a91ccc30c45c7$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "Moz") return prop;
        var newProp = prop.replace("-inline", "");
        return $b26a91ccc30c45c7$export$82e9f45cca5ba907.js + $b26a91ccc30c45c7$var$pascalize(newProp) in style ? $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $b26a91ccc30c45c7$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $b26a91ccc30c45c7$var$camelize(prop) in style ? prop : false;
    }
};
var $b26a91ccc30c45c7$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $b26a91ccc30c45c7$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === "-") return prop; // Return already prefixed value without prefixing.
        if (prop[0] === "-" && prop[1] === "-") return prop;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js + pascalized in style) return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js !== "Webkit" && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $b26a91ccc30c45c7$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== "scroll-snap") return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "ms") return "" + $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $b26a91ccc30c45c7$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "overscroll-behavior") return false;
        if ($b26a91ccc30c45c7$export$82e9f45cca5ba907.js === "ms") return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $b26a91ccc30c45c7$var$propMap = {
    "flex-grow": "flex-positive",
    "flex-shrink": "flex-negative",
    "flex-basis": "flex-preferred-size",
    "justify-content": "flex-pack",
    order: "flex-order",
    "align-items": "flex-align",
    "align-content": "flex-line-pack" // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $b26a91ccc30c45c7$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $b26a91ccc30c45c7$var$propMap[prop];
        if (!newProp) return false;
        return $b26a91ccc30c45c7$export$82e9f45cca5ba907.js + $b26a91ccc30c45c7$var$pascalize(newProp) in style ? $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $b26a91ccc30c45c7$var$propMap$1 = {
    flex: "box-flex",
    "flex-grow": "box-flex",
    "flex-direction": [
        "box-orient",
        "box-direction"
    ],
    order: "box-ordinal-group",
    "align-items": "box-align",
    "flex-flow": [
        "box-orient",
        "box-direction"
    ],
    "justify-content": "box-pack"
};
var $b26a91ccc30c45c7$var$propKeys = Object.keys($b26a91ccc30c45c7$var$propMap$1);
var $b26a91ccc30c45c7$var$prefixCss = function prefixCss(p) {
    return $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $b26a91ccc30c45c7$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($b26a91ccc30c45c7$var$propKeys.indexOf(prop) > -1) {
            var newProp = $b26a91ccc30c45c7$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $b26a91ccc30c45c7$export$82e9f45cca5ba907.js + $b26a91ccc30c45c7$var$pascalize(newProp) in style ? $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($b26a91ccc30c45c7$export$82e9f45cca5ba907.js + $b26a91ccc30c45c7$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($b26a91ccc30c45c7$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $b26a91ccc30c45c7$var$plugins = [
    $b26a91ccc30c45c7$var$appearence,
    $b26a91ccc30c45c7$var$colorAdjust,
    $b26a91ccc30c45c7$var$mask,
    $b26a91ccc30c45c7$var$textOrientation,
    $b26a91ccc30c45c7$var$transform,
    $b26a91ccc30c45c7$var$transition,
    $b26a91ccc30c45c7$var$writingMode,
    $b26a91ccc30c45c7$var$userSelect,
    $b26a91ccc30c45c7$var$breakPropsOld,
    $b26a91ccc30c45c7$var$inlineLogicalOld,
    $b26a91ccc30c45c7$var$unprefixed,
    $b26a91ccc30c45c7$var$prefixed,
    $b26a91ccc30c45c7$var$scrollSnap,
    $b26a91ccc30c45c7$var$overscrollBehavior,
    $b26a91ccc30c45c7$var$flex2012,
    $b26a91ccc30c45c7$var$flex2009
];
var $b26a91ccc30c45c7$var$propertyDetectors = $b26a91ccc30c45c7$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $b26a91ccc30c45c7$var$noPrefill = $b26a91ccc30c45c7$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $jX7qT.default)(p.noPrefill));
    return a;
}, []);
var $b26a91ccc30c45c7$var$el;
var $b26a91ccc30c45c7$var$cache = {};
if (0, $cob8O.default) {
    $b26a91ccc30c45c7$var$el = document.createElement("p"); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $b26a91ccc30c45c7$var$computed = window.getComputedStyle(document.documentElement, "");
    for(var $b26a91ccc30c45c7$var$key$1 in $b26a91ccc30c45c7$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($b26a91ccc30c45c7$var$key$1)) $b26a91ccc30c45c7$var$cache[$b26a91ccc30c45c7$var$computed[$b26a91ccc30c45c7$var$key$1]] = $b26a91ccc30c45c7$var$computed[$b26a91ccc30c45c7$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $b26a91ccc30c45c7$var$noPrefill.forEach(function(x) {
        return delete $b26a91ccc30c45c7$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $b26a91ccc30c45c7$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$b26a91ccc30c45c7$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($b26a91ccc30c45c7$var$cache[prop] != null) return $b26a91ccc30c45c7$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === "transition" || prop === "transform") options[prop] = prop in $b26a91ccc30c45c7$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $b26a91ccc30c45c7$var$propertyDetectors.length; i++){
        $b26a91ccc30c45c7$var$cache[prop] = $b26a91ccc30c45c7$var$propertyDetectors[i](prop, $b26a91ccc30c45c7$var$el.style, options); // Break loop, if value found.
        if ($b26a91ccc30c45c7$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $b26a91ccc30c45c7$var$el.style[prop] = "";
    } catch (err) {
        return false;
    }
    return $b26a91ccc30c45c7$var$cache[prop];
}
var $b26a91ccc30c45c7$var$cache$1 = {};
var $b26a91ccc30c45c7$var$transitionProperties = {
    transition: 1,
    "transition-property": 1,
    "-webkit-transition": 1,
    "-webkit-transition-property": 1
};
var $b26a91ccc30c45c7$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $b26a91ccc30c45c7$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $b26a91ccc30c45c7$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === "var") return "var";
    if (p1 === "all") return "all";
    if (p2 === "all") return ", all";
    var prefixedValue = p1 ? $b26a91ccc30c45c7$export$ce097f82c2e4551a(p1) : ", " + $b26a91ccc30c45c7$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $cob8O.default) $b26a91ccc30c45c7$var$el$1 = document.createElement("p");
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $b26a91ccc30c45c7$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$b26a91ccc30c45c7$var$el$1 || property === "content") return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== "string" || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($b26a91ccc30c45c7$var$cache$1[cacheKey] != null) return $b26a91ccc30c45c7$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $b26a91ccc30c45c7$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $b26a91ccc30c45c7$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($b26a91ccc30c45c7$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($b26a91ccc30c45c7$var$transPropsRegExp, $b26a91ccc30c45c7$var$prefixTransitionCallback);
    else if ($b26a91ccc30c45c7$var$el$1.style[property] === "") {
        // Value with a vendor prefix.
        prefixedValue = $b26a91ccc30c45c7$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === "-ms-flex") $b26a91ccc30c45c7$var$el$1.style[property] = "-ms-flexbox"; // Test prefixed value.
        $b26a91ccc30c45c7$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($b26a91ccc30c45c7$var$el$1.style[property] === "") {
            $b26a91ccc30c45c7$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $b26a91ccc30c45c7$var$el$1.style[property] = ""; // Write current value to cache.
    $b26a91ccc30c45c7$var$cache$1[cacheKey] = prefixedValue;
    return $b26a91ccc30c45c7$var$cache$1[cacheKey];
}

});
parcelRegister("jX7qT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8694aff92b422dc$export$2e2bcd8739ae039; });

var $8yNIs = parcelRequire("8yNIs");

var $cq1as = parcelRequire("cq1as");

var $9F6mQ = parcelRequire("9F6mQ");

var $2tVCP = parcelRequire("2tVCP");
function $e8694aff92b422dc$export$2e2bcd8739ae039(arr) {
    return (0, $8yNIs.default)(arr) || (0, $cq1as.default)(arr) || (0, $9F6mQ.default)(arr) || (0, $2tVCP.default)();
}

});
parcelRegister("8yNIs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63b81041f3d12ee7$export$2e2bcd8739ae039; });

var $cnxX0 = parcelRequire("cnxX0");
function $63b81041f3d12ee7$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $cnxX0.default)(arr);
}

});
parcelRegister("cnxX0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9031f7f2924753e9$export$2e2bcd8739ae039; });
function $9031f7f2924753e9$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("cq1as", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90a8d1a06a2704aa$export$2e2bcd8739ae039; });
function $90a8d1a06a2704aa$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("9F6mQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $708ce1d4f20bd938$export$2e2bcd8739ae039; });

var $cnxX0 = parcelRequire("cnxX0");
function $708ce1d4f20bd938$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $cnxX0.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $cnxX0.default)(o, minLen);
}

});

parcelRegister("2tVCP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ceafd62b5589195$export$2e2bcd8739ae039; });
function $1ceafd62b5589195$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("80wZV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d47eb7841bd32ac$export$2e2bcd8739ae039; });
/**
 * Sort props by length.
 */ function $5d47eb7841bd32ac$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== "style") return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $5d47eb7841bd32ac$export$2e2bcd8739ae039 = $5d47eb7841bd32ac$var$jssPropsSort;

});



parcelRegister("imu6v", function(module, exports) {

$parcel$export(module.exports, "increment", function () { return $d5e1a214ec560f37$export$a2647aa13413c947; });
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
let $d5e1a214ec560f37$var$indexCounter = -1000000000;
function $d5e1a214ec560f37$export$a2647aa13413c947() {
    $d5e1a214ec560f37$var$indexCounter += 1;
    return $d5e1a214ec560f37$var$indexCounter;
}

});

parcelRegister("lFwTe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc66f08657e9761d$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $cseKH = parcelRequire("cseKH");

var $fNI3N = parcelRequire("fNI3N");

function $fc66f08657e9761d$export$2e2bcd8739ae039(stylesOrCreator) {
    const themingEnabled = typeof stylesOrCreator === "function";
    return {
        create: (theme, name)=>{
            let styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.components || !theme.components[name] || !theme.components[name].styleOverrides && !theme.components[name].variants) return styles;
            const overrides = theme.components[name].styleOverrides || {};
            const variants = theme.components[name].variants || [];
            const stylesWithOverrides = (0, $4WYaH.default)({}, styles);
            Object.keys(overrides).forEach((key)=>{
                stylesWithOverrides[key] = (0, $cseKH.default)(stylesWithOverrides[key] || {}, overrides[key]);
            });
            variants.forEach((definition)=>{
                const classKey = (0, $fNI3N.default)(definition.props);
                stylesWithOverrides[classKey] = (0, $cseKH.default)(stylesWithOverrides[classKey] || {}, definition.style);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});
parcelRegister("fNI3N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b80d9c0ee4f773f2$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $gNE2F = parcelRequire("gNE2F");
const $b80d9c0ee4f773f2$var$_excluded = [
    "variant"
];
function $b80d9c0ee4f773f2$var$isEmpty(string) {
    return string.length === 0;
}
function $b80d9c0ee4f773f2$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $hCIyK.default)(props, $b80d9c0ee4f773f2$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $b80d9c0ee4f773f2$var$isEmpty(classKey) ? props[key] : (0, $gNE2F.default)(props[key]);
        else classKey += `${$b80d9c0ee4f773f2$var$isEmpty(classKey) ? key : (0, $gNE2F.default)(key)}${(0, $gNE2F.default)(props[key].toString())}`;
    });
    return classKey;
}

});


parcelRegister("bs7R3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85686708b0a6232f$export$2e2bcd8739ae039; });
// We use the same empty object to ref count the styles that don't need a theme object.
const $85686708b0a6232f$var$noopTheme = {};
var $85686708b0a6232f$export$2e2bcd8739ae039 = $85686708b0a6232f$var$noopTheme;

});



parcelRegister("lfYlj", function(module, exports) {
module.exports = new URL("details.f9ee7c14.svg", import.meta.url).toString();

});

parcelRegister("3A2xv", function(module, exports) {
module.exports = new URL("trash.364d3d52.svg", import.meta.url).toString();

});

parcelRegister("b5b48", function(module, exports) {
module.exports = new URL("trash_gray.9c99544d.svg", import.meta.url).toString();

});


parcelRegister("daKAK", function(module, exports) {

$parcel$export(module.exports, "exportDataAsExcel", function () { return $24917cf1f666e086$export$6897615712bf9f63; });

var $358bY = parcelRequire("358bY");

var $TDoiN = parcelRequire("TDoiN");
const $24917cf1f666e086$export$6897615712bf9f63 = (csvData, fileName)=>{
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const ws = $TDoiN.utils.json_to_sheet(csvData);
    const wb = {
        Sheets: {
            data: ws
        },
        SheetNames: [
            "data"
        ]
    };
    const excelBuffer = $TDoiN.write(wb, {
        bookType: "xlsx",
        type: "array"
    });
    const data = new Blob([
        excelBuffer
    ], {
        type: fileType
    });
    $358bY.saveAs(data, fileName + fileExtension);
};

});
parcelRegister("358bY", function(module, exports) {
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})(module.exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, module.exports = g;
});

});

parcelRegister("TDoiN", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $3ee4f50b1ae43a89$export$aafa59e2e03f2942; });
$parcel$export(module.exports, "write", function () { return $3ee4f50b1ae43a89$export$68d8715fc104d294; });
$parcel$export(module.exports, "utils", function () { return $3ee4f50b1ae43a89$export$eab97d15b1788b8d; });
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported XLSX */ /*global process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */ 
var $5Io6y = parcelRequire("5Io6y");
var $3ee4f50b1ae43a89$require$Buffer = $5Io6y.Buffer;

var $5Io6y = parcelRequire("5Io6y");
var $3ee4f50b1ae43a89$var$XLSX = {};
$3ee4f50b1ae43a89$var$XLSX.version = "0.18.5";
var $3ee4f50b1ae43a89$var$current_codepage = 1200, $3ee4f50b1ae43a89$var$current_ansi = 1252;
var $3ee4f50b1ae43a89$var$VALID_ANSI = [
    874,
    932,
    936,
    949,
    950,
    1250,
    1251,
    1252,
    1253,
    1254,
    1255,
    1256,
    1257,
    1258,
    10000
];
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */ var $3ee4f50b1ae43a89$var$CS2CP = {
    /*::[*/ 0: 1252,
    /* ANSI */ /*::[*/ 1: 65001,
    /* DEFAULT */ /*::[*/ 2: 65001,
    /* SYMBOL */ /*::[*/ 77: 10000,
    /* MAC */ /*::[*/ 128: 932,
    /* SHIFTJIS */ /*::[*/ 129: 949,
    /* HANGUL */ /*::[*/ 130: 1361,
    /* JOHAB */ /*::[*/ 134: 936,
    /* GB2312 */ /*::[*/ 136: 950,
    /* CHINESEBIG5 */ /*::[*/ 161: 1253,
    /* GREEK */ /*::[*/ 162: 1254,
    /* TURKISH */ /*::[*/ 163: 1258,
    /* VIETNAMESE */ /*::[*/ 177: 1255,
    /* HEBREW */ /*::[*/ 178: 1256,
    /* ARABIC */ /*::[*/ 186: 1257,
    /* BALTIC */ /*::[*/ 204: 1251,
    /* RUSSIAN */ /*::[*/ 222: 874,
    /* THAI */ /*::[*/ 238: 1250,
    /* EASTEUROPE */ /*::[*/ 255: 1252,
    /* OEM */ /*::[*/ 69: 6969 /* MISC */ 
} /*:any*/ ;
var $3ee4f50b1ae43a89$var$set_ansi = function(cp /*:number*/ ) {
    if ($3ee4f50b1ae43a89$var$VALID_ANSI.indexOf(cp) == -1) return;
    $3ee4f50b1ae43a89$var$current_ansi = $3ee4f50b1ae43a89$var$CS2CP[0] = cp;
};
function $3ee4f50b1ae43a89$var$reset_ansi() {
    $3ee4f50b1ae43a89$var$set_ansi(1252);
}
var $3ee4f50b1ae43a89$var$set_cp = function(cp /*:number*/ ) {
    $3ee4f50b1ae43a89$var$current_codepage = cp;
    $3ee4f50b1ae43a89$var$set_ansi(cp);
};
function $3ee4f50b1ae43a89$var$reset_cp() {
    $3ee4f50b1ae43a89$var$set_cp(1200);
    $3ee4f50b1ae43a89$var$reset_ansi();
}
function $3ee4f50b1ae43a89$var$char_codes(data /*:string*/ ) /*:Array<number>*/ {
    var o /*:Array<number>*/  = [];
    for(var i = 0, len = data.length; i < len; ++i)o[i] = data.charCodeAt(i);
    return o;
}
function $3ee4f50b1ae43a89$var$utf16leread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i) + (data.charCodeAt(2 * i + 1) << 8));
    return o.join("");
}
function $3ee4f50b1ae43a89$var$utf16beread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i + 1) + (data.charCodeAt(2 * i) << 8));
    return o.join("");
}
var $3ee4f50b1ae43a89$var$debom = function(data /*:string*/ ) /*:string*/ {
    var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
    if (c1 == 0xFF && c2 == 0xFE) return $3ee4f50b1ae43a89$var$utf16leread(data.slice(2));
    if (c1 == 0xFE && c2 == 0xFF) return $3ee4f50b1ae43a89$var$utf16beread(data.slice(2));
    if (c1 == 0xFEFF) return data.slice(1);
    return data;
};
var $3ee4f50b1ae43a89$var$_getchar = function _gc1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $3ee4f50b1ae43a89$var$_getansi = function _ga1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $3ee4f50b1ae43a89$var$$cptable;
function $3ee4f50b1ae43a89$export$58f247d16f363b86(cptable) {
    $3ee4f50b1ae43a89$var$$cptable = cptable;
    $3ee4f50b1ae43a89$var$set_cp = function(cp /*:number*/ ) {
        $3ee4f50b1ae43a89$var$current_codepage = cp;
        $3ee4f50b1ae43a89$var$set_ansi(cp);
    };
    $3ee4f50b1ae43a89$var$debom = function(data /*:string*/ ) {
        if (data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) return $3ee4f50b1ae43a89$var$$cptable.utils.decode(1200, $3ee4f50b1ae43a89$var$char_codes(data.slice(2)));
        return data;
    };
    $3ee4f50b1ae43a89$var$_getchar = function _gc2(x /*:number*/ ) /*:string*/ {
        if ($3ee4f50b1ae43a89$var$current_codepage === 1200) return String.fromCharCode(x);
        return $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_codepage, [
            x & 255,
            x >> 8
        ])[0];
    };
    $3ee4f50b1ae43a89$var$_getansi = function _ga2(x /*:number*/ ) /*:string*/ {
        return $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_ansi, [
            x
        ])[0];
    };
    $3ee4f50b1ae43a89$var$cpdoit();
}
var $3ee4f50b1ae43a89$var$DENSE = null;
var $3ee4f50b1ae43a89$var$DIF_XL = true;
var $3ee4f50b1ae43a89$var$Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function $3ee4f50b1ae43a89$var$Base64_encode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $3ee4f50b1ae43a89$var$Base64_map.charAt(e1) + $3ee4f50b1ae43a89$var$Base64_map.charAt(e2) + $3ee4f50b1ae43a89$var$Base64_map.charAt(e3) + $3ee4f50b1ae43a89$var$Base64_map.charAt(e4);
    }
    return o;
}
function $3ee4f50b1ae43a89$var$Base64_decode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    input = input.replace(/[^\w\+\/\=]/g, "");
    for(var i = 0; i < input.length;){
        e1 = $3ee4f50b1ae43a89$var$Base64_map.indexOf(input.charAt(i++));
        e2 = $3ee4f50b1ae43a89$var$Base64_map.indexOf(input.charAt(i++));
        c1 = e1 << 2 | e2 >> 4;
        o += String.fromCharCode(c1);
        e3 = $3ee4f50b1ae43a89$var$Base64_map.indexOf(input.charAt(i++));
        c2 = (e2 & 15) << 4 | e3 >> 2;
        if (e3 !== 64) o += String.fromCharCode(c2);
        e4 = $3ee4f50b1ae43a89$var$Base64_map.indexOf(input.charAt(i++));
        c3 = (e3 & 3) << 6 | e4;
        if (e4 !== 64) o += String.fromCharCode(c3);
    }
    return o;
}
var $3ee4f50b1ae43a89$var$has_buf = /*#__PURE__*/ function() {
    return typeof $3ee4f50b1ae43a89$require$Buffer !== "undefined" && typeof $5Io6y !== "undefined" && typeof $5Io6y.versions !== "undefined" && !!$5Io6y.versions.node;
}();
var $3ee4f50b1ae43a89$var$Buffer_from = /*#__PURE__*/ function() {
    if (typeof $3ee4f50b1ae43a89$require$Buffer !== "undefined") {
        var nbfs = !$3ee4f50b1ae43a89$require$Buffer.from;
        if (!nbfs) try {
            $3ee4f50b1ae43a89$require$Buffer.from("foo", "utf8");
        } catch (e) {
            nbfs = true;
        }
        return nbfs ? function(buf, enc) {
            return enc ? new $3ee4f50b1ae43a89$require$Buffer(buf, enc) : new $3ee4f50b1ae43a89$require$Buffer(buf);
        } : $3ee4f50b1ae43a89$require$Buffer.from.bind($3ee4f50b1ae43a89$require$Buffer);
    }
    return function() {};
}();
function $3ee4f50b1ae43a89$var$new_raw_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$require$Buffer.alloc ? $3ee4f50b1ae43a89$require$Buffer.alloc(len) : new $3ee4f50b1ae43a89$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
function $3ee4f50b1ae43a89$var$new_unsafe_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$require$Buffer.allocUnsafe ? $3ee4f50b1ae43a89$require$Buffer.allocUnsafe(len) : new $3ee4f50b1ae43a89$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
var $3ee4f50b1ae43a89$var$s2a = function s2a(s /*:string*/ ) /*:any*/ {
    if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$var$Buffer_from(s, "binary");
    return s.split("").map(function(x /*:string*/ ) /*:number*/ {
        return x.charCodeAt(0) & 0xff;
    });
};
function $3ee4f50b1ae43a89$var$s2ab(s /*:string*/ ) /*:any*/ {
    if (typeof ArrayBuffer === "undefined") return $3ee4f50b1ae43a89$var$s2a(s);
    var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
    for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}
function $3ee4f50b1ae43a89$var$a2s(data /*:any*/ ) /*:string*/ {
    if (Array.isArray(data)) return data.map(function(c) {
        return String.fromCharCode(c);
    }).join("");
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length; ++i)o[i] = String.fromCharCode(data[i]);
    return o.join("");
}
function $3ee4f50b1ae43a89$var$a2u(data /*:Array<number>*/ ) /*:Uint8Array*/ {
    if (typeof Uint8Array === "undefined") throw new Error("Unsupported");
    return new Uint8Array(data);
}
function $3ee4f50b1ae43a89$var$ab2a(data /*:ArrayBuffer|Uint8Array*/ ) /*:Array<number>*/ {
    if (typeof ArrayBuffer == "undefined") throw new Error("Unsupported");
    if (data instanceof ArrayBuffer) return $3ee4f50b1ae43a89$var$ab2a(new Uint8Array(data));
    /*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */ var o = new Array(data.length);
    for(var i = 0; i < data.length; ++i)o[i] = data[i];
    return o;
}
var $3ee4f50b1ae43a89$var$bconcat = $3ee4f50b1ae43a89$var$has_buf ? function(bufs) {
    return $3ee4f50b1ae43a89$require$Buffer.concat(bufs.map(function(buf) {
        return $3ee4f50b1ae43a89$require$Buffer.isBuffer(buf) ? buf : $3ee4f50b1ae43a89$var$Buffer_from(buf);
    }));
} : function(bufs) {
    if (typeof Uint8Array !== "undefined") {
        var i = 0, maxlen = 0;
        for(i = 0; i < bufs.length; ++i)maxlen += bufs[i].length;
        var o = new Uint8Array(maxlen);
        var len = 0;
        for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i){
            len = bufs[i].length;
            if (bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
            else if (typeof bufs[i] == "string") throw "wtf";
            else o.set(new Uint8Array(bufs[i]), maxlen);
        }
        return o;
    }
    return [].concat.apply([], bufs.map(function(buf) {
        return Array.isArray(buf) ? buf : [].slice.call(buf);
    }));
};
function $3ee4f50b1ae43a89$var$utf8decode(content /*:string*/ ) {
    var out = [], widx = 0, L = content.length + 250;
    var o = $3ee4f50b1ae43a89$var$new_raw_buf(content.length + 255);
    for(var ridx = 0; ridx < content.length; ++ridx){
        var c = content.charCodeAt(ridx);
        if (c < 0x80) o[widx++] = c;
        else if (c < 0x800) {
            o[widx++] = 192 | c >> 6 & 31;
            o[widx++] = 128 | c & 63;
        } else if (c >= 0xD800 && c < 0xE000) {
            c = (c & 1023) + 64;
            var d = content.charCodeAt(++ridx) & 1023;
            o[widx++] = 240 | c >> 8 & 7;
            o[widx++] = 128 | c >> 2 & 63;
            o[widx++] = 128 | d >> 6 & 15 | (c & 3) << 4;
            o[widx++] = 128 | d & 63;
        } else {
            o[widx++] = 224 | c >> 12 & 15;
            o[widx++] = 128 | c >> 6 & 63;
            o[widx++] = 128 | c & 63;
        }
        if (widx > L) {
            out.push(o.slice(0, widx));
            widx = 0;
            o = $3ee4f50b1ae43a89$var$new_raw_buf(65535);
            L = 65530;
        }
    }
    out.push(o.slice(0, widx));
    return $3ee4f50b1ae43a89$var$bconcat(out);
}
var $3ee4f50b1ae43a89$var$chr0 = /\u0000/g, $3ee4f50b1ae43a89$var$chr1 = /[\u0001-\u0006]/g;
/*::
declare type Block = any;
declare type BufArray = {
	newblk(sz:number):Block;
	next(sz:number):Block;
	end():any;
	push(buf:Block):void;
};

type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

type EvertType = {[string]:string};
type EvertNumType = {[string]:number};
type EvertArrType = {[string]:Array<string>};

type StringConv = {(string):string};

*/ /* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W041 */ function $3ee4f50b1ae43a89$var$_strrev(x /*:string*/ ) /*:string*/ {
    var o = "", i = x.length - 1;
    while(i >= 0)o += x.charAt(i--);
    return o;
}
function $3ee4f50b1ae43a89$var$pad0(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $3ee4f50b1ae43a89$var$fill("0", d - t.length) + t;
}
function $3ee4f50b1ae43a89$var$pad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $3ee4f50b1ae43a89$var$fill(" ", d - t.length) + t;
}
function $3ee4f50b1ae43a89$var$rpad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : t + $3ee4f50b1ae43a89$var$fill(" ", d - t.length);
}
function $3ee4f50b1ae43a89$var$pad0r1(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + Math.round(v);
    return t.length >= d ? t : $3ee4f50b1ae43a89$var$fill("0", d - t.length) + t;
}
function $3ee4f50b1ae43a89$var$pad0r2(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $3ee4f50b1ae43a89$var$fill("0", d - t.length) + t;
}
var $3ee4f50b1ae43a89$var$p2_32 = /*#__PURE__*/ Math.pow(2, 32);
function $3ee4f50b1ae43a89$var$pad0r(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    if (v > $3ee4f50b1ae43a89$var$p2_32 || v < -$3ee4f50b1ae43a89$var$p2_32) return $3ee4f50b1ae43a89$var$pad0r1(v, d);
    var i = Math.round(v);
    return $3ee4f50b1ae43a89$var$pad0r2(i, d);
}
/* yes, in 2022 this is still faster than string compare */ function $3ee4f50b1ae43a89$var$SSF_isgeneral(s /*:string*/ , i /*:?number*/ ) /*:boolean*/ {
    i = i || 0;
    return s.length >= 7 + i && (s.charCodeAt(i) | 32) === 103 && (s.charCodeAt(i + 1) | 32) === 101 && (s.charCodeAt(i + 2) | 32) === 110 && (s.charCodeAt(i + 3) | 32) === 101 && (s.charCodeAt(i + 4) | 32) === 114 && (s.charCodeAt(i + 5) | 32) === 97 && (s.charCodeAt(i + 6) | 32) === 108;
}
var $3ee4f50b1ae43a89$var$days /*:Array<Array<string> >*/  = [
    [
        "Sun",
        "Sunday"
    ],
    [
        "Mon",
        "Monday"
    ],
    [
        "Tue",
        "Tuesday"
    ],
    [
        "Wed",
        "Wednesday"
    ],
    [
        "Thu",
        "Thursday"
    ],
    [
        "Fri",
        "Friday"
    ],
    [
        "Sat",
        "Saturday"
    ]
];
var $3ee4f50b1ae43a89$var$months /*:Array<Array<string> >*/  = [
    [
        "J",
        "Jan",
        "January"
    ],
    [
        "F",
        "Feb",
        "February"
    ],
    [
        "M",
        "Mar",
        "March"
    ],
    [
        "A",
        "Apr",
        "April"
    ],
    [
        "M",
        "May",
        "May"
    ],
    [
        "J",
        "Jun",
        "June"
    ],
    [
        "J",
        "Jul",
        "July"
    ],
    [
        "A",
        "Aug",
        "August"
    ],
    [
        "S",
        "Sep",
        "September"
    ],
    [
        "O",
        "Oct",
        "October"
    ],
    [
        "N",
        "Nov",
        "November"
    ],
    [
        "D",
        "Dec",
        "December"
    ]
];
function $3ee4f50b1ae43a89$var$SSF_init_table(t /*:any*/ ) {
    if (!t) t = {};
    t[0] = "General";
    t[1] = "0";
    t[2] = "0.00";
    t[3] = "#,##0";
    t[4] = "#,##0.00";
    t[9] = "0%";
    t[10] = "0.00%";
    t[11] = "0.00E+00";
    t[12] = "# ?/?";
    t[13] = "# ??/??";
    t[14] = "m/d/yy";
    t[15] = "d-mmm-yy";
    t[16] = "d-mmm";
    t[17] = "mmm-yy";
    t[18] = "h:mm AM/PM";
    t[19] = "h:mm:ss AM/PM";
    t[20] = "h:mm";
    t[21] = "h:mm:ss";
    t[22] = "m/d/yy h:mm";
    t[37] = "#,##0 ;(#,##0)";
    t[38] = "#,##0 ;[Red](#,##0)";
    t[39] = "#,##0.00;(#,##0.00)";
    t[40] = "#,##0.00;[Red](#,##0.00)";
    t[45] = "mm:ss";
    t[46] = "[h]:mm:ss";
    t[47] = "mmss.0";
    t[48] = "##0.0E+0";
    t[49] = "@";
    t[56] = '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "';
    return t;
}
/* repeated to satiate webpack */ var $3ee4f50b1ae43a89$var$table_fmt = {
    0: "General",
    1: "0",
    2: "0.00",
    3: "#,##0",
    4: "#,##0.00",
    9: "0%",
    10: "0.00%",
    11: "0.00E+00",
    12: "# ?/?",
    13: "# ??/??",
    14: "m/d/yy",
    15: "d-mmm-yy",
    16: "d-mmm",
    17: "mmm-yy",
    18: "h:mm AM/PM",
    19: "h:mm:ss AM/PM",
    20: "h:mm",
    21: "h:mm:ss",
    22: "m/d/yy h:mm",
    37: "#,##0 ;(#,##0)",
    38: "#,##0 ;[Red](#,##0)",
    39: "#,##0.00;(#,##0.00)",
    40: "#,##0.00;[Red](#,##0.00)",
    45: "mm:ss",
    46: "[h]:mm:ss",
    47: "mmss.0",
    48: "##0.0E+0",
    49: "@",
    56: '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "'
};
/* Defaults determined by systematically testing in Excel 2019 */ /* These formats appear to default to other formats in the table */ var $3ee4f50b1ae43a89$var$SSF_default_map = {
    5: 37,
    6: 38,
    7: 39,
    8: 40,
    23: 0,
    24: 0,
    25: 0,
    26: 0,
    27: 14,
    28: 14,
    29: 14,
    30: 14,
    31: 14,
    50: 14,
    51: 14,
    52: 14,
    53: 14,
    54: 14,
    55: 14,
    56: 14,
    57: 14,
    58: 14,
    59: 1,
    60: 2,
    61: 3,
    62: 4,
    67: 9,
    68: 10,
    69: 12,
    70: 13,
    71: 14,
    72: 14,
    73: 15,
    74: 16,
    75: 17,
    76: 20,
    77: 21,
    78: 22,
    79: 45,
    80: 46,
    81: 47,
    82: 0 // 82 ->  0 ... 65536 -> 0 (omitted)
};
/* These formats technically refer to Accounting formats with no equivalent */ var $3ee4f50b1ae43a89$var$SSF_default_str = {
    //  5 -- Currency,   0 decimal, black negative
    5: '"$"#,##0_);\\("$"#,##0\\)',
    63: '"$"#,##0_);\\("$"#,##0\\)',
    //  6 -- Currency,   0 decimal, red   negative
    6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    //  7 -- Currency,   2 decimal, black negative
    7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    //  8 -- Currency,   2 decimal, red   negative
    8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    // 41 -- Accounting, 0 decimal, No Symbol
    41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
    // 42 -- Accounting, 0 decimal, $  Symbol
    42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
    // 43 -- Accounting, 2 decimal, No Symbol
    43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
    // 44 -- Accounting, 2 decimal, $  Symbol
    44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function $3ee4f50b1ae43a89$var$SSF_frac(x /*:number*/ , D /*:number*/ , mixed /*:?boolean*/ ) /*:Array<number>*/ {
    var sgn = x < 0 ? -1 : 1;
    var B = x * sgn;
    var P_2 = 0, P_1 = 1, P = 0;
    var Q_2 = 1, Q_1 = 0, Q = 0;
    var A = Math.floor(B);
    while(Q_1 < D){
        A = Math.floor(B);
        P = A * P_1 + P_2;
        Q = A * Q_1 + Q_2;
        if (B - A < 0.00000005) break;
        B = 1 / (B - A);
        P_2 = P_1;
        P_1 = P;
        Q_2 = Q_1;
        Q_1 = Q;
    }
    if (Q > D) {
        if (Q_1 > D) {
            Q = Q_2;
            P = P_2;
        } else {
            Q = Q_1;
            P = P_1;
        }
    }
    if (!mixed) return [
        0,
        sgn * P,
        Q
    ];
    var q = Math.floor(sgn * P / Q);
    return [
        q,
        sgn * P - q * Q,
        Q
    ];
}
function $3ee4f50b1ae43a89$var$SSF_parse_date_code(v /*:number*/ , opts /*:?any*/ , b2 /*:?boolean*/ ) {
    if (v > 2958465 || v < 0) return null;
    var date = v | 0, time = Math.floor(86400 * (v - date)), dow = 0;
    var dout = [];
    var out = {
        D: date,
        T: time,
        u: 86400 * (v - date) - time,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0
    };
    if (Math.abs(out.u) < 1e-6) out.u = 0;
    if (opts && opts.date1904) date += 1462;
    if (out.u > 0.9999) {
        out.u = 0;
        if (++time == 86400) {
            out.T = time = 0;
            ++date;
            ++out.D;
        }
    }
    if (date === 60) {
        dout = b2 ? [
            1317,
            10,
            29
        ] : [
            1900,
            2,
            29
        ];
        dow = 3;
    } else if (date === 0) {
        dout = b2 ? [
            1317,
            8,
            29
        ] : [
            1900,
            1,
            0
        ];
        dow = 6;
    } else {
        if (date > 60) --date;
        /* 1 = Jan 1 1900 in Gregorian */ var d = new Date(1900, 0, 1);
        d.setDate(d.getDate() + date - 1);
        dout = [
            d.getFullYear(),
            d.getMonth() + 1,
            d.getDate()
        ];
        dow = d.getDay();
        if (date < 60) dow = (dow + 6) % 7;
        if (b2) dow = $3ee4f50b1ae43a89$var$SSF_fix_hijri(d, dout);
    }
    out.y = dout[0];
    out.m = dout[1];
    out.d = dout[2];
    out.S = time % 60;
    time = Math.floor(time / 60);
    out.M = time % 60;
    time = Math.floor(time / 60);
    out.H = time;
    out.q = dow;
    return out;
}
var $3ee4f50b1ae43a89$var$SSFbasedate = /*#__PURE__*/ new Date(1899, 11, 31, 0, 0, 0);
var $3ee4f50b1ae43a89$var$SSFdnthresh = /*#__PURE__*/ $3ee4f50b1ae43a89$var$SSFbasedate.getTime();
var $3ee4f50b1ae43a89$var$SSFbase1904 = /*#__PURE__*/ new Date(1900, 2, 1, 0, 0, 0);
function $3ee4f50b1ae43a89$var$datenum_local(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    if (date1904) epoch -= 126230400000;
    else if (v >= $3ee4f50b1ae43a89$var$SSFbase1904) epoch += 86400000;
    return (epoch - ($3ee4f50b1ae43a89$var$SSFdnthresh + /*#__PURE__*/ (v.getTimezoneOffset() - /*#__PURE__*/ $3ee4f50b1ae43a89$var$SSFbasedate.getTimezoneOffset()) * 60000)) / 86400000;
}
/* ECMA-376 18.8.30 numFmt*/ /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */ /* exponent >= -9 and <= 9 */ function $3ee4f50b1ae43a89$var$SSF_strip_decimal(o /*:string*/ ) /*:string*/ {
    return o.indexOf(".") == -1 ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
/* General Exponential always shows 2 digits exp and trims the mantissa */ function $3ee4f50b1ae43a89$var$SSF_normalize_exp(o /*:string*/ ) /*:string*/ {
    if (o.indexOf("E") == -1) return o;
    return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
/* exponent >= -9 and <= 9 */ function $3ee4f50b1ae43a89$var$SSF_small_exp(v /*:number*/ ) /*:string*/ {
    var w = v < 0 ? 12 : 11;
    var o = $3ee4f50b1ae43a89$var$SSF_strip_decimal(v.toFixed(12));
    if (o.length <= w) return o;
    o = v.toPrecision(10);
    if (o.length <= w) return o;
    return v.toExponential(5);
}
/* exponent >= 11 or <= -10 likely exponential */ function $3ee4f50b1ae43a89$var$SSF_large_exp(v /*:number*/ ) /*:string*/ {
    var o = $3ee4f50b1ae43a89$var$SSF_strip_decimal(v.toFixed(11));
    return o.length > (v < 0 ? 12 : 11) || o === "0" || o === "-0" ? v.toPrecision(6) : o;
}
function $3ee4f50b1ae43a89$var$SSF_general_num(v /*:number*/ ) /*:string*/ {
    var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E), o;
    if (V >= -4 && V <= -1) o = v.toPrecision(10 + V);
    else if (Math.abs(V) <= 9) o = $3ee4f50b1ae43a89$var$SSF_small_exp(v);
    else if (V === 10) o = v.toFixed(10).substr(0, 12);
    else o = $3ee4f50b1ae43a89$var$SSF_large_exp(v);
    return $3ee4f50b1ae43a89$var$SSF_strip_decimal($3ee4f50b1ae43a89$var$SSF_normalize_exp(o.toUpperCase()));
}
/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	The longest 32-bit integer text is "-2147483648", exactly 11 chars
	TODO: technically the display depends on the width of the cell
*/ function $3ee4f50b1ae43a89$var$SSF_general(v /*:any*/ , opts /*:any*/ ) {
    switch(typeof v){
        case "string":
            return v;
        case "boolean":
            return v ? "TRUE" : "FALSE";
        case "number":
            return (v | 0) === v ? v.toString(10) : $3ee4f50b1ae43a89$var$SSF_general_num(v);
        case "undefined":
            return "";
        case "object":
            if (v == null) return "";
            if (v instanceof Date) return $3ee4f50b1ae43a89$var$SSF_format(14, $3ee4f50b1ae43a89$var$datenum_local(v, opts && opts.date1904), opts);
    }
    throw new Error("unsupported value in General format: " + v);
}
function $3ee4f50b1ae43a89$var$SSF_fix_hijri(date /*:Date*/ , o /*:[number, number, number]*/ ) {
    /* TODO: properly adjust y/m/d and  */ o[0] -= 581;
    var dow = date.getDay();
    if (date < 60) dow = (dow + 6) % 7;
    return dow;
}
//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
function $3ee4f50b1ae43a89$var$SSF_write_date(type /*:number*/ , fmt /*:string*/ , val, ss0 /*:?number*/ ) /*:string*/ {
    var o = "", ss = 0, tt = 0, y = val.y, out, outl = 0;
    switch(type){
        case 98:
            /* 'b' buddhist year */ y = val.y + 543;
        /* falls through */ case 121:
            /* 'y' year */ switch(fmt.length){
                case 1:
                case 2:
                    out = y % 100;
                    outl = 2;
                    break;
                default:
                    out = y % 10000;
                    outl = 4;
                    break;
            }
            break;
        case 109:
            /* 'm' month */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.m;
                    outl = fmt.length;
                    break;
                case 3:
                    return $3ee4f50b1ae43a89$var$months[val.m - 1][1];
                case 5:
                    return $3ee4f50b1ae43a89$var$months[val.m - 1][0];
                default:
                    return $3ee4f50b1ae43a89$var$months[val.m - 1][2];
            }
            break;
        case 100:
            /* 'd' day */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.d;
                    outl = fmt.length;
                    break;
                case 3:
                    return $3ee4f50b1ae43a89$var$days[val.q][0];
                default:
                    return $3ee4f50b1ae43a89$var$days[val.q][1];
            }
            break;
        case 104:
            /* 'h' 12-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = 1 + (val.H + 11) % 12;
                    outl = fmt.length;
                    break;
                default:
                    throw "bad hour format: " + fmt;
            }
            break;
        case 72:
            /* 'H' 24-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.H;
                    outl = fmt.length;
                    break;
                default:
                    throw "bad hour format: " + fmt;
            }
            break;
        case 77:
            /* 'M' minutes */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.M;
                    outl = fmt.length;
                    break;
                default:
                    throw "bad minute format: " + fmt;
            }
            break;
        case 115:
            /* 's' seconds */ if (fmt != "s" && fmt != "ss" && fmt != ".0" && fmt != ".00" && fmt != ".000") throw "bad second format: " + fmt;
            if (val.u === 0 && (fmt == "s" || fmt == "ss")) return $3ee4f50b1ae43a89$var$pad0(val.S, fmt.length);
            /*::if(!ss0) ss0 = 0; */ if (ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
            else tt = ss0 === 1 ? 10 : 1;
            ss = Math.round(tt * (val.S + val.u));
            if (ss >= 60 * tt) ss = 0;
            if (fmt === "s") return ss === 0 ? "0" : "" + ss / tt;
            o = $3ee4f50b1ae43a89$var$pad0(ss, 2 + ss0);
            if (fmt === "ss") return o.substr(0, 2);
            return "." + o.substr(2, fmt.length - 1);
        case 90:
            /* 'Z' absolute time */ switch(fmt){
                case "[h]":
                case "[hh]":
                    out = val.D * 24 + val.H;
                    break;
                case "[m]":
                case "[mm]":
                    out = (val.D * 24 + val.H) * 60 + val.M;
                    break;
                case "[s]":
                case "[ss]":
                    out = ((val.D * 24 + val.H) * 60 + val.M) * 60 + Math.round(val.S + val.u);
                    break;
                default:
                    throw "bad abstime format: " + fmt;
            }
            outl = fmt.length === 3 ? 1 : 2;
            break;
        case 101:
            /* 'e' era */ out = y;
            outl = 1;
            break;
    }
    var outstr = outl > 0 ? $3ee4f50b1ae43a89$var$pad0(out, outl) : "";
    return outstr;
}
/*jshint -W086 */ /*jshint +W086 */ function $3ee4f50b1ae43a89$var$commaify(s /*:string*/ ) /*:string*/ {
    var w = 3;
    if (s.length <= w) return s;
    var j = s.length % w, o = s.substr(0, j);
    for(; j != s.length; j += w)o += (o.length > 0 ? "," : "") + s.substr(j, w);
    return o;
}
var $3ee4f50b1ae43a89$var$pct1 = /%/g;
function $3ee4f50b1ae43a89$var$write_num_pct(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($3ee4f50b1ae43a89$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $3ee4f50b1ae43a89$var$write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + $3ee4f50b1ae43a89$var$fill("%", mul);
}
function $3ee4f50b1ae43a89$var$write_num_cm(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $3ee4f50b1ae43a89$var$write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
}
function $3ee4f50b1ae43a89$var$write_num_exp(fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";
        else if (val < 0) return "-" + $3ee4f50b1ae43a89$var$write_num_exp(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf("E");
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (o.indexOf("e") === -1) {
            var fakee = Math.floor(Math.log(val) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            while(o.substr(0, 2) === "0."){
                o = o.charAt(0) + o.substr(2, period) + "." + o.substr(2 + period);
                o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
            }
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
var $3ee4f50b1ae43a89$var$frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function $3ee4f50b1ae43a89$var$write_num_f1(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    var den = parseInt(r[4], 10), rr = Math.round(aval * den), base = Math.floor(rr / den);
    var myn = rr - base * den, myd = den;
    return sign + (base === 0 ? "" : "" + base) + " " + (myn === 0 ? $3ee4f50b1ae43a89$var$fill(" ", r[1].length + 1 + r[4].length) : $3ee4f50b1ae43a89$var$pad_(myn, r[1].length) + r[2] + "/" + r[3] + $3ee4f50b1ae43a89$var$pad0(myd, r[4].length));
}
function $3ee4f50b1ae43a89$var$write_num_f2(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    return sign + (aval === 0 ? "" : "" + aval) + $3ee4f50b1ae43a89$var$fill(" ", r[1].length + 2 + r[4].length);
}
var $3ee4f50b1ae43a89$var$dec1 = /^#*0*\.([0#]+)/;
var $3ee4f50b1ae43a89$var$closeparen = /\).*[0#]/;
var $3ee4f50b1ae43a89$var$phone = /\(###\) ###\\?-####/;
function $3ee4f50b1ae43a89$var$hashq(str /*:string*/ ) /*:string*/ {
    var o = "", cc;
    for(var i = 0; i != str.length; ++i)switch(cc = str.charCodeAt(i)){
        case 35:
            break;
        case 63:
            o += " ";
            break;
        case 48:
            o += "0";
            break;
        default:
            o += String.fromCharCode(cc);
    }
    return o;
}
function $3ee4f50b1ae43a89$var$rnd(val /*:number*/ , d /*:number*/ ) /*:string*/ {
    var dd = Math.pow(10, d);
    return "" + Math.round(val * dd) / dd;
}
function $3ee4f50b1ae43a89$var$dec(val /*:number*/ , d /*:number*/ ) /*:number*/ {
    var _frac = val - Math.floor(val), dd = Math.pow(10, d);
    if (d < ("" + Math.round(_frac * dd)).length) return 0;
    return Math.round(_frac * dd);
}
function $3ee4f50b1ae43a89$var$carry(val /*:number*/ , d /*:number*/ ) /*:number*/ {
    if (d < ("" + Math.round((val - Math.floor(val)) * Math.pow(10, d))).length) return 1;
    return 0;
}
function $3ee4f50b1ae43a89$var$flr(val /*:number*/ ) /*:string*/ {
    if (val < 2147483647 && val > -2147483648) return "" + (val >= 0 ? val | 0 : val - 1 | 0);
    return "" + Math.floor(val);
}
function $3ee4f50b1ae43a89$var$write_num_flt(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($3ee4f50b1ae43a89$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return $3ee4f50b1ae43a89$var$write_num_flt("n", ffmt, val);
        return "(" + $3ee4f50b1ae43a89$var$write_num_flt("n", ffmt, -val) + ")";
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $3ee4f50b1ae43a89$var$write_num_cm(type, fmt, val);
    if (fmt.indexOf("%") !== -1) return $3ee4f50b1ae43a89$var$write_num_pct(type, fmt, val);
    if (fmt.indexOf("E") !== -1) return $3ee4f50b1ae43a89$var$write_num_exp(fmt, val);
    if (fmt.charCodeAt(0) === 36) return "$" + $3ee4f50b1ae43a89$var$write_num_flt(type, fmt.substr(fmt.charAt(1) == " " ? 2 : 1), val);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $3ee4f50b1ae43a89$var$pad0r(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = $3ee4f50b1ae43a89$var$pad0r(val, 0);
        if (o === "0") o = "";
        return o.length > fmt.length ? o : $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($3ee4f50b1ae43a89$var$frac1)) return $3ee4f50b1ae43a89$var$write_num_f1(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $3ee4f50b1ae43a89$var$pad0r(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($3ee4f50b1ae43a89$var$dec1)) {
        o = $3ee4f50b1ae43a89$var$rnd(val, r[1].length).replace(/^([^\.]+)$/, "$1." + $3ee4f50b1ae43a89$var$hashq(r[1])).replace(/\.$/, "." + $3ee4f50b1ae43a89$var$hashq(r[1])).replace(/\.(\d*)$/, function($$, $1) {
            return "." + $1 + $3ee4f50b1ae43a89$var$fill("0", $3ee4f50b1ae43a89$var$hashq(/*::(*/ r /*::||[""])*/ [1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + $3ee4f50b1ae43a89$var$rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $3ee4f50b1ae43a89$var$commaify($3ee4f50b1ae43a89$var$pad0r(aval, 0));
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + $3ee4f50b1ae43a89$var$write_num_flt(type, fmt, -val) : $3ee4f50b1ae43a89$var$commaify("" + (Math.floor(val) + $3ee4f50b1ae43a89$var$carry(val, r[1].length))) + "." + $3ee4f50b1ae43a89$var$pad0($3ee4f50b1ae43a89$var$dec(val, r[1].length), r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $3ee4f50b1ae43a89$var$write_num_flt(type, fmt.replace(/^#,#*,/, ""), val);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $3ee4f50b1ae43a89$var$_strrev($3ee4f50b1ae43a89$var$write_num_flt(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return $3ee4f50b1ae43a89$var$_strrev($3ee4f50b1ae43a89$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === "0" ? "0" : "";
        }));
    }
    if (fmt.match($3ee4f50b1ae43a89$var$phone)) {
        o = $3ee4f50b1ae43a89$var$write_num_flt(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $3ee4f50b1ae43a89$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $3ee4f50b1ae43a89$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $3ee4f50b1ae43a89$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $3ee4f50b1ae43a89$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $3ee4f50b1ae43a89$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $3ee4f50b1ae43a89$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $3ee4f50b1ae43a89$var$rpad_(ff[2], ri) : $3ee4f50b1ae43a89$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = $3ee4f50b1ae43a89$var$pad0r(val, 0);
        if (fmt.length <= o.length) return o;
        return $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0?]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) {
        ri = $3ee4f50b1ae43a89$var$dec(val, r[1].length);
        return val < 0 ? "-" + $3ee4f50b1ae43a89$var$write_num_flt(type, fmt, -val) : $3ee4f50b1ae43a89$var$commaify($3ee4f50b1ae43a89$var$flr(val)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
            return "00," + ($$.length < 3 ? $3ee4f50b1ae43a89$var$pad0(0, 3 - $$.length) : "") + $$;
        }) + "." + $3ee4f50b1ae43a89$var$pad0(ri, r[1].length);
    }
    switch(fmt){
        case "###,##0.00":
            return $3ee4f50b1ae43a89$var$write_num_flt(type, "#,##0.00", val);
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $3ee4f50b1ae43a89$var$commaify($3ee4f50b1ae43a89$var$pad0r(aval, 0));
            return x !== "0" ? sign + x : "";
        case "###,###.00":
            return $3ee4f50b1ae43a89$var$write_num_flt(type, "###,##0.00", val).replace(/^0\./, ".");
        case "#,###.00":
            return $3ee4f50b1ae43a89$var$write_num_flt(type, "#,##0.00", val).replace(/^0\./, ".");
        default:
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $3ee4f50b1ae43a89$var$write_num_cm2(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $3ee4f50b1ae43a89$var$write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
}
function $3ee4f50b1ae43a89$var$write_num_pct2(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($3ee4f50b1ae43a89$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $3ee4f50b1ae43a89$var$write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + $3ee4f50b1ae43a89$var$fill("%", mul);
}
function $3ee4f50b1ae43a89$var$write_num_exp2(fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";
        else if (val < 0) return "-" + $3ee4f50b1ae43a89$var$write_num_exp2(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf("E");
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (!o.match(/[Ee]/)) {
            var fakee = Math.floor(Math.log(val) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
function $3ee4f50b1ae43a89$var$write_num_int(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($3ee4f50b1ae43a89$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return $3ee4f50b1ae43a89$var$write_num_int("n", ffmt, val);
        return "(" + $3ee4f50b1ae43a89$var$write_num_int("n", ffmt, -val) + ")";
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $3ee4f50b1ae43a89$var$write_num_cm2(type, fmt, val);
    if (fmt.indexOf("%") !== -1) return $3ee4f50b1ae43a89$var$write_num_pct2(type, fmt, val);
    if (fmt.indexOf("E") !== -1) return $3ee4f50b1ae43a89$var$write_num_exp2(fmt, val);
    if (fmt.charCodeAt(0) === 36) return "$" + $3ee4f50b1ae43a89$var$write_num_int(type, fmt.substr(fmt.charAt(1) == " " ? 2 : 1), val);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $3ee4f50b1ae43a89$var$pad0(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = "" + val;
        if (val === 0) o = "";
        return o.length > fmt.length ? o : $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($3ee4f50b1ae43a89$var$frac1)) return $3ee4f50b1ae43a89$var$write_num_f2(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $3ee4f50b1ae43a89$var$pad0(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($3ee4f50b1ae43a89$var$dec1)) {
        /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ o = ("" + val).replace(/^([^\.]+)$/, "$1." + $3ee4f50b1ae43a89$var$hashq(r[1])).replace(/\.$/, "." + $3ee4f50b1ae43a89$var$hashq(r[1]));
        o = o.replace(/\.(\d*)$/, function($$, $1) {
            /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ return "." + $1 + $3ee4f50b1ae43a89$var$fill("0", $3ee4f50b1ae43a89$var$hashq(r[1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + ("" + aval).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $3ee4f50b1ae43a89$var$commaify("" + aval);
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + $3ee4f50b1ae43a89$var$write_num_int(type, fmt, -val) : $3ee4f50b1ae43a89$var$commaify("" + val) + "." + $3ee4f50b1ae43a89$var$fill("0", r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $3ee4f50b1ae43a89$var$write_num_int(type, fmt.replace(/^#,#*,/, ""), val);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $3ee4f50b1ae43a89$var$_strrev($3ee4f50b1ae43a89$var$write_num_int(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return $3ee4f50b1ae43a89$var$_strrev($3ee4f50b1ae43a89$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === "0" ? "0" : "";
        }));
    }
    if (fmt.match($3ee4f50b1ae43a89$var$phone)) {
        o = $3ee4f50b1ae43a89$var$write_num_int(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $3ee4f50b1ae43a89$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $3ee4f50b1ae43a89$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $3ee4f50b1ae43a89$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $3ee4f50b1ae43a89$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $3ee4f50b1ae43a89$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $3ee4f50b1ae43a89$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $3ee4f50b1ae43a89$var$rpad_(ff[2], ri) : $3ee4f50b1ae43a89$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = "" + val;
        if (fmt.length <= o.length) return o;
        return $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) return val < 0 ? "-" + $3ee4f50b1ae43a89$var$write_num_int(type, fmt, -val) : $3ee4f50b1ae43a89$var$commaify("" + val).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
        return "00," + ($$.length < 3 ? $3ee4f50b1ae43a89$var$pad0(0, 3 - $$.length) : "") + $$;
    }) + "." + $3ee4f50b1ae43a89$var$pad0(0, r[1].length);
    switch(fmt){
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $3ee4f50b1ae43a89$var$commaify("" + aval);
            return x !== "0" ? sign + x : "";
        default:
            if (fmt.match(/\.[0#?]*$/)) return $3ee4f50b1ae43a89$var$write_num_int(type, fmt.slice(0, fmt.lastIndexOf(".")), val) + $3ee4f50b1ae43a89$var$hashq(fmt.slice(fmt.lastIndexOf(".")));
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $3ee4f50b1ae43a89$var$write_num(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    return (val | 0) === val ? $3ee4f50b1ae43a89$var$write_num_int(type, fmt, val) : $3ee4f50b1ae43a89$var$write_num_flt(type, fmt, val);
}
function $3ee4f50b1ae43a89$var$SSF_split_fmt(fmt /*:string*/ ) /*:Array<string>*/ {
    var out /*:Array<string>*/  = [];
    var in_str = false /*, cc*/ ;
    for(var i = 0, j = 0; i < fmt.length; ++i)switch(/*cc=*/ fmt.charCodeAt(i)){
        case 34:
            /* '"' */ in_str = !in_str;
            break;
        case 95:
        case 42:
        case 92:
            /* '_' '*' '\\' */ ++i;
            break;
        case 59:
            /* ';' */ out[out.length] = fmt.substr(j, i - j);
            j = i + 1;
    }
    out[out.length] = fmt.substr(j);
    if (in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
    return out;
}
var $3ee4f50b1ae43a89$var$SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function $3ee4f50b1ae43a89$var$fmt_is_date(fmt /*:string*/ ) /*:boolean*/ {
    var i = 0, /*cc = 0,*/ c = "", o = "";
    while(i < fmt.length)switch(c = fmt.charAt(i)){
        case "G":
            if ($3ee4f50b1ae43a89$var$SSF_isgeneral(fmt, i)) i += 6;
            i++;
            break;
        case '"':
            for(; /*cc=*/ fmt.charCodeAt(++i) !== 34 && i < fmt.length;);
            ++i;
            break;
        case "\\":
            i += 2;
            break;
        case "_":
            i += 2;
            break;
        case "@":
            ++i;
            break;
        case "B":
        case "b":
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") return true;
        /* falls through */ case "M":
        case "D":
        case "Y":
        case "H":
        case "S":
        case "E":
        /* falls through */ case "m":
        case "d":
        case "y":
        case "h":
        case "s":
        case "e":
        case "g":
            return true;
        case "A":
        case "a":
        case "\u4E0A":
            if (fmt.substr(i, 3).toUpperCase() === "A/P") return true;
            if (fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
            if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") return true;
            ++i;
            break;
        case "[":
            o = c;
            while(fmt.charAt(i++) !== "]" && i < fmt.length)o += fmt.charAt(i);
            if (o.match($3ee4f50b1ae43a89$var$SSF_abstime)) return true;
            break;
        case ".":
        /* falls through */ case "0":
        case "#":
            while(i < fmt.length && ("0#?.,E+-%".indexOf(c = fmt.charAt(++i)) > -1 || c == "\\" && fmt.charAt(i + 1) == "-" && "0#".indexOf(fmt.charAt(i + 2)) > -1));
            break;
        case "?":
            while(fmt.charAt(++i) === c);
            break;
        case "*":
            ++i;
            if (fmt.charAt(i) == " " || fmt.charAt(i) == "*") ++i;
            break;
        case "(":
        case ")":
            ++i;
            break;
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1);
            break;
        case " ":
            ++i;
            break;
        default:
            ++i;
            break;
    }
    return false;
}
function $3ee4f50b1ae43a89$var$eval_fmt(fmt /*:string*/ , v /*:any*/ , opts /*:any*/ , flen /*:number*/ ) {
    var out = [], o = "", i = 0, c = "", lst = "t", dt, j, cc;
    var hr = "H";
    /* Tokenize */ while(i < fmt.length)switch(c = fmt.charAt(i)){
        case "G":
            /* General */ if (!$3ee4f50b1ae43a89$var$SSF_isgeneral(fmt, i)) throw new Error("unrecognized character " + c + " in " + fmt);
            out[out.length] = {
                t: "G",
                v: "General"
            };
            i += 7;
            break;
        case '"':
            /* Literal text */ for(o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length;)o += String.fromCharCode(cc);
            out[out.length] = {
                t: "t",
                v: o
            };
            ++i;
            break;
        case "\\":
            var w = fmt.charAt(++i), t = w === "(" || w === ")" ? w : "t";
            out[out.length] = {
                t: t,
                v: w
            };
            ++i;
            break;
        case "_":
            out[out.length] = {
                t: "t",
                v: " "
            };
            i += 2;
            break;
        case "@":
            /* Text Placeholder */ out[out.length] = {
                t: "T",
                v: v
            };
            ++i;
            break;
        case "B":
        case "b":
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") {
                if (dt == null) {
                    dt = $3ee4f50b1ae43a89$var$SSF_parse_date_code(v, opts, fmt.charAt(i + 1) === "2");
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: "X",
                    v: fmt.substr(i, 2)
                };
                lst = c;
                i += 2;
                break;
            }
        /* falls through */ case "M":
        case "D":
        case "Y":
        case "H":
        case "S":
        case "E":
            c = c.toLowerCase();
        /* falls through */ case "m":
        case "d":
        case "y":
        case "h":
        case "s":
        case "e":
        case "g":
            if (v < 0) return "";
            if (dt == null) {
                dt = $3ee4f50b1ae43a89$var$SSF_parse_date_code(v, opts);
                if (dt == null) return "";
            }
            o = c;
            while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c)o += c;
            if (c === "m" && lst.toLowerCase() === "h") c = "M";
            if (c === "h") c = hr;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case "A":
        case "a":
        case "\u4E0A":
            var q = {
                t: c,
                v: c
            };
            if (dt == null) dt = $3ee4f50b1ae43a89$var$SSF_parse_date_code(v, opts);
            if (fmt.substr(i, 3).toUpperCase() === "A/P") {
                if (dt != null) q.v = dt.H >= 12 ? "P" : "A";
                q.t = "T";
                hr = "h";
                i += 3;
            } else if (fmt.substr(i, 5).toUpperCase() === "AM/PM") {
                if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM";
                q.t = "T";
                i += 5;
                hr = "h";
            } else if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") {
                if (dt != null) q.v = dt.H >= 12 ? "\u4E0B\u5348" : "\u4E0A\u5348";
                q.t = "T";
                i += 5;
                hr = "h";
            } else {
                q.t = "t";
                ++i;
            }
            if (dt == null && q.t === "T") return "";
            out[out.length] = q;
            lst = c;
            break;
        case "[":
            o = c;
            while(fmt.charAt(i++) !== "]" && i < fmt.length)o += fmt.charAt(i);
            if (o.slice(-1) !== "]") throw 'unterminated "[" block: |' + o + "|";
            if (o.match($3ee4f50b1ae43a89$var$SSF_abstime)) {
                if (dt == null) {
                    dt = $3ee4f50b1ae43a89$var$SSF_parse_date_code(v, opts);
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: "Z",
                    v: o.toLowerCase()
                };
                lst = o.charAt(1);
            } else if (o.indexOf("$") > -1) {
                o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$";
                if (!$3ee4f50b1ae43a89$var$fmt_is_date(fmt)) out[out.length] = {
                    t: "t",
                    v: o
                };
            }
            break;
        /* Numbers */ case ".":
            if (dt != null) {
                o = c;
                while(++i < fmt.length && (c = fmt.charAt(i)) === "0")o += c;
                out[out.length] = {
                    t: "s",
                    v: o
                };
                break;
            }
        /* falls through */ case "0":
        case "#":
            o = c;
            while(++i < fmt.length && "0#?.,E+-%".indexOf(c = fmt.charAt(i)) > -1)o += c;
            out[out.length] = {
                t: "n",
                v: o
            };
            break;
        case "?":
            o = c;
            while(fmt.charAt(++i) === c)o += c;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case "*":
            ++i;
            if (fmt.charAt(i) == " " || fmt.charAt(i) == "*") ++i;
            break; // **
        case "(":
        case ")":
            out[out.length] = {
                t: flen === 1 ? "t" : c,
                v: c
            };
            ++i;
            break;
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
            o = c;
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1)o += fmt.charAt(i);
            out[out.length] = {
                t: "D",
                v: o
            };
            break;
        case " ":
            out[out.length] = {
                t: c,
                v: c
            };
            ++i;
            break;
        case "$":
            out[out.length] = {
                t: "t",
                v: "$"
            };
            ++i;
            break;
        default:
            if (",$-+/():!^&'~{}<>=\u20ACacfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error("unrecognized character " + c + " in " + fmt);
            out[out.length] = {
                t: "t",
                v: c
            };
            ++i;
            break;
    }
    /* Scan for date/time parts */ var bt = 0, ss0 = 0, ssm;
    for(i = out.length - 1, lst = "t"; i >= 0; --i)switch(out[i].t){
        case "h":
        case "H":
            out[i].t = hr;
            lst = "h";
            if (bt < 1) bt = 1;
            break;
        case "s":
            if (ssm = out[i].v.match(/\.0+$/)) ss0 = Math.max(ss0, ssm[0].length - 1);
            if (bt < 3) bt = 3;
        /* falls through */ case "d":
        case "y":
        case "M":
        case "e":
            lst = out[i].t;
            break;
        case "m":
            if (lst === "s") {
                out[i].t = "M";
                if (bt < 2) bt = 2;
            }
            break;
        case "X":
            break;
        case "Z":
            if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
            if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
            if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
    }
    /* time rounding depends on presence of minute / second / usec fields */ switch(bt){
        case 0:
            break;
        case 1:
            /*::if(!dt) break;*/ if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            break;
        case 2:
            /*::if(!dt) break;*/ if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            break;
    }
    /* replace fields */ var nstr = "", jj;
    for(i = 0; i < out.length; ++i)switch(out[i].t){
        case "t":
        case "T":
        case " ":
        case "D":
            break;
        case "X":
            out[i].v = "";
            out[i].t = ";";
            break;
        case "d":
        case "m":
        case "y":
        case "h":
        case "H":
        case "M":
        case "s":
        case "e":
        case "b":
        case "Z":
            /*::if(!dt) throw "unreachable"; */ out[i].v = $3ee4f50b1ae43a89$var$SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
            out[i].t = "t";
            break;
        case "n":
        case "?":
            jj = i + 1;
            while(out[jj] != null && ((c = out[jj].t) === "?" || c === "D" || (c === " " || c === "t") && out[jj + 1] != null && (out[jj + 1].t === "?" || out[jj + 1].t === "t" && out[jj + 1].v === "/") || out[i].t === "(" && (c === " " || c === "n" || c === ")") || c === "t" && (out[jj].v === "/" || out[jj].v === " " && out[jj + 1] != null && out[jj + 1].t == "?"))){
                out[i].v += out[jj].v;
                out[jj] = {
                    v: "",
                    t: ";"
                };
                ++jj;
            }
            nstr += out[i].v;
            i = jj - 1;
            break;
        case "G":
            out[i].t = "t";
            out[i].v = $3ee4f50b1ae43a89$var$SSF_general(v, opts);
            break;
    }
    var vv = "", myv, ostr;
    if (nstr.length > 0) {
        if (nstr.charCodeAt(0) == 40) /* '(' */ {
            myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v;
            ostr = $3ee4f50b1ae43a89$var$write_num("n", nstr, myv);
        } else {
            myv = v < 0 && flen > 1 ? -v : v;
            ostr = $3ee4f50b1ae43a89$var$write_num("n", nstr, myv);
            if (myv < 0 && out[0] && out[0].t == "t") {
                ostr = ostr.substr(1);
                out[0].v = "-" + out[0].v;
            }
        }
        jj = ostr.length - 1;
        var decpt = out.length;
        for(i = 0; i < out.length; ++i)if (out[i] != null && out[i].t != "t" && out[i].v.indexOf(".") > -1) {
            decpt = i;
            break;
        }
        var lasti = out.length;
        if (decpt === out.length && ostr.indexOf("E") === -1) {
            for(i = out.length - 1; i >= 0; --i){
                if (out[i] == null || "n?".indexOf(out[i].t) === -1) continue;
                if (jj >= out[i].v.length - 1) {
                    jj -= out[i].v.length;
                    out[i].v = ostr.substr(jj + 1, out[i].v.length);
                } else if (jj < 0) out[i].v = "";
                else {
                    out[i].v = ostr.substr(0, jj + 1);
                    jj = -1;
                }
                out[i].t = "t";
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
        } else if (decpt !== out.length && ostr.indexOf("E") === -1) {
            jj = ostr.indexOf(".") - 1;
            for(i = decpt; i >= 0; --i){
                if (out[i] == null || "n?".indexOf(out[i].t) === -1) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") - 1 : out[i].v.length - 1;
                vv = out[i].v.substr(j + 1);
                for(; j >= 0; --j)if (jj >= 0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
                out[i].v = vv;
                out[i].t = "t";
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
            jj = ostr.indexOf(".") + 1;
            for(i = decpt; i < out.length; ++i){
                if (out[i] == null || "n?(".indexOf(out[i].t) === -1 && i !== decpt) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") + 1 : 0;
                vv = out[i].v.substr(0, j);
                for(; j < out[i].v.length; ++j)if (jj < ostr.length) vv += ostr.charAt(jj++);
                out[i].v = vv;
                out[i].t = "t";
                lasti = i;
            }
        }
    }
    for(i = 0; i < out.length; ++i)if (out[i] != null && "n?".indexOf(out[i].t) > -1) {
        myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v;
        out[i].v = $3ee4f50b1ae43a89$var$write_num(out[i].t, out[i].v, myv);
        out[i].t = "t";
    }
    var retval = "";
    for(i = 0; i !== out.length; ++i)if (out[i] != null) retval += out[i].v;
    return retval;
}
var $3ee4f50b1ae43a89$var$cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function $3ee4f50b1ae43a89$var$chkcond(v, rr) {
    if (rr == null) return false;
    var thresh = parseFloat(rr[2]);
    switch(rr[1]){
        case "=":
            if (v == thresh) return true;
            break;
        case ">":
            if (v > thresh) return true;
            break;
        case "<":
            if (v < thresh) return true;
            break;
        case "<>":
            if (v != thresh) return true;
            break;
        case ">=":
            if (v >= thresh) return true;
            break;
        case "<=":
            if (v <= thresh) return true;
            break;
    }
    return false;
}
function $3ee4f50b1ae43a89$var$choose_fmt(f /*:string*/ , v /*:any*/ ) {
    var fmt = $3ee4f50b1ae43a89$var$SSF_split_fmt(f);
    var l = fmt.length, lat = fmt[l - 1].indexOf("@");
    if (l < 4 && lat > -1) --l;
    if (fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
    if (typeof v !== "number") return [
        4,
        fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"
    ];
    switch(fmt.length){
        case 1:
            fmt = lat > -1 ? [
                "General",
                "General",
                "General",
                fmt[0]
            ] : [
                fmt[0],
                fmt[0],
                fmt[0],
                "@"
            ];
            break;
        case 2:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[0],
                fmt[0],
                fmt[1]
            ] : [
                fmt[0],
                fmt[1],
                fmt[0],
                "@"
            ];
            break;
        case 3:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[1],
                fmt[0],
                fmt[2]
            ] : [
                fmt[0],
                fmt[1],
                fmt[2],
                "@"
            ];
            break;
        case 4:
            break;
    }
    var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
    if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [
        l,
        ff
    ];
    if (fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
        var m1 = fmt[0].match($3ee4f50b1ae43a89$var$cfregex2);
        var m2 = fmt[1].match($3ee4f50b1ae43a89$var$cfregex2);
        return $3ee4f50b1ae43a89$var$chkcond(v, m1) ? [
            l,
            fmt[0]
        ] : $3ee4f50b1ae43a89$var$chkcond(v, m2) ? [
            l,
            fmt[1]
        ] : [
            l,
            fmt[m1 != null && m2 != null ? 2 : 1]
        ];
    }
    return [
        l,
        ff
    ];
}
function $3ee4f50b1ae43a89$var$SSF_format(fmt /*:string|number*/ , v /*:any*/ , o /*:?any*/ ) {
    if (o == null) o = {};
    var sfmt = "";
    switch(typeof fmt){
        case "string":
            if (fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
            else sfmt = fmt;
            break;
        case "number":
            if (fmt == 14 && o.dateNF) sfmt = o.dateNF;
            else sfmt = (o.table != null ? o.table /*:any*/  : $3ee4f50b1ae43a89$var$table_fmt)[fmt];
            if (sfmt == null) sfmt = o.table && o.table[$3ee4f50b1ae43a89$var$SSF_default_map[fmt]] || $3ee4f50b1ae43a89$var$table_fmt[$3ee4f50b1ae43a89$var$SSF_default_map[fmt]];
            if (sfmt == null) sfmt = $3ee4f50b1ae43a89$var$SSF_default_str[fmt] || "General";
            break;
    }
    if ($3ee4f50b1ae43a89$var$SSF_isgeneral(sfmt, 0)) return $3ee4f50b1ae43a89$var$SSF_general(v, o);
    if (v instanceof Date) v = $3ee4f50b1ae43a89$var$datenum_local(v, o.date1904);
    var f = $3ee4f50b1ae43a89$var$choose_fmt(sfmt, v);
    if ($3ee4f50b1ae43a89$var$SSF_isgeneral(f[1])) return $3ee4f50b1ae43a89$var$SSF_general(v, o);
    if (v === true) v = "TRUE";
    else if (v === false) v = "FALSE";
    else if (v === "" || v == null) return "";
    return $3ee4f50b1ae43a89$var$eval_fmt(f[1], v, o, f[0]);
}
function $3ee4f50b1ae43a89$var$SSF_load(fmt /*:string*/ , idx /*:?number*/ ) /*:number*/ {
    if (typeof idx != "number") {
        idx = +idx || -1;
        /*::if(typeof idx != 'number') return 0x188; */ for(var i = 0; i < 0x0188; ++i){
            /*::if(typeof idx != 'number') return 0x188; */ if ($3ee4f50b1ae43a89$var$table_fmt[i] == undefined) {
                if (idx < 0) idx = i;
                continue;
            }
            if ($3ee4f50b1ae43a89$var$table_fmt[i] == fmt) {
                idx = i;
                break;
            }
        }
        /*::if(typeof idx != 'number') return 0x188; */ if (idx < 0) idx = 0x187;
    }
    /*::if(typeof idx != 'number') return 0x188; */ $3ee4f50b1ae43a89$var$table_fmt[idx] = fmt;
    return idx;
}
function $3ee4f50b1ae43a89$var$SSF_load_table(tbl /*:SSFTable*/ ) /*:void*/ {
    for(var i = 0; i != 0x0188; ++i)if (tbl[i] !== undefined) $3ee4f50b1ae43a89$var$SSF_load(tbl[i], i);
}
function $3ee4f50b1ae43a89$var$make_ssf() {
    $3ee4f50b1ae43a89$var$table_fmt = $3ee4f50b1ae43a89$var$SSF_init_table();
}
var $3ee4f50b1ae43a89$export$40d8edd678456c2b = {
    format: $3ee4f50b1ae43a89$var$SSF_format,
    load: $3ee4f50b1ae43a89$var$SSF_load,
    _table: $3ee4f50b1ae43a89$var$table_fmt,
    load_table: $3ee4f50b1ae43a89$var$SSF_load_table,
    parse_date_code: $3ee4f50b1ae43a89$var$SSF_parse_date_code,
    is_date: $3ee4f50b1ae43a89$var$fmt_is_date,
    get_table: function get_table() {
        return $3ee4f50b1ae43a89$export$40d8edd678456c2b._table = $3ee4f50b1ae43a89$var$table_fmt;
    }
};
var $3ee4f50b1ae43a89$var$SSFImplicit /*{[number]:string}*/  = {
    "5": '"$"#,##0_);\\("$"#,##0\\)',
    "6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "23": "General",
    "24": "General",
    "25": "General",
    "26": "General",
    "27": "m/d/yy",
    "28": "m/d/yy",
    "29": "m/d/yy",
    "30": "m/d/yy",
    "31": "m/d/yy",
    "32": "h:mm:ss",
    "33": "h:mm:ss",
    "34": "h:mm:ss",
    "35": "h:mm:ss",
    "36": "m/d/yy",
    "41": '_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',
    "42": '_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',
    "43": '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',
    "44": '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',
    "50": "m/d/yy",
    "51": "m/d/yy",
    "52": "m/d/yy",
    "53": "m/d/yy",
    "54": "m/d/yy",
    "55": "m/d/yy",
    "56": "m/d/yy",
    "57": "m/d/yy",
    "58": "m/d/yy",
    "59": "0",
    "60": "0.00",
    "61": "#,##0",
    "62": "#,##0.00",
    "63": '"$"#,##0_);\\("$"#,##0\\)',
    "64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "67": "0%",
    "68": "0.00%",
    "69": "# ?/?",
    "70": "# ??/??",
    "71": "m/d/yy",
    "72": "m/d/yy",
    "73": "d-mmm-yy",
    "74": "d-mmm",
    "75": "mmm-yy",
    "76": "h:mm",
    "77": "h:mm:ss",
    "78": "m/d/yy h:mm",
    "79": "mm:ss",
    "80": "[h]:mm:ss",
    "81": "mmss.0"
} /*:any*/ ;
/* dateNF parse TODO: move to SSF */ var $3ee4f50b1ae43a89$var$dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function $3ee4f50b1ae43a89$var$dateNF_regex(dateNF /*:string|number*/ ) /*:RegExp*/ {
    var fmt = typeof dateNF == "number" ? $3ee4f50b1ae43a89$var$table_fmt[dateNF] : dateNF;
    fmt = fmt.replace($3ee4f50b1ae43a89$var$dateNFregex, "(\\d+)");
    return new RegExp("^" + fmt + "$");
}
function $3ee4f50b1ae43a89$var$dateNF_fix(str /*:string*/ , dateNF /*:string*/ , match /*:Array<string>*/ ) /*:string*/ {
    var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
    (dateNF.match($3ee4f50b1ae43a89$var$dateNFregex) || []).forEach(function(n, i) {
        var v = parseInt(match[i + 1], 10);
        switch(n.toLowerCase().charAt(0)){
            case "y":
                Y = v;
                break;
            case "d":
                d = v;
                break;
            case "h":
                H = v;
                break;
            case "s":
                S = v;
                break;
            case "m":
                if (H >= 0) M = v;
                else m = v;
                break;
        }
    });
    if (S >= 0 && M == -1 && m >= 0) {
        M = m;
        m = -1;
    }
    var datestr = ("" + (Y >= 0 ? Y : new Date().getFullYear())).slice(-4) + "-" + ("00" + (m >= 1 ? m : 1)).slice(-2) + "-" + ("00" + (d >= 1 ? d : 1)).slice(-2);
    if (datestr.length == 7) datestr = "0" + datestr;
    if (datestr.length == 8) datestr = "20" + datestr;
    var timestr = ("00" + (H >= 0 ? H : 0)).slice(-2) + ":" + ("00" + (M >= 0 ? M : 0)).slice(-2) + ":" + ("00" + (S >= 0 ? S : 0)).slice(-2);
    if (H == -1 && M == -1 && S == -1) return datestr;
    if (Y == -1 && m == -1 && d == -1) return timestr;
    return datestr + "T" + timestr;
}
/*::
declare var ReadShift:any;
declare var CheckField:any;
declare var prep_blob:any;
declare var __readUInt32LE:any;
declare var __readInt32LE:any;
declare var __toBuffer:any;
declare var __utf16le:any;
declare var bconcat:any;
declare var s2a:any;
declare var chr0:any;
declare var chr1:any;
declare var has_buf:boolean;
declare var new_buf:any;
declare var new_raw_buf:any;
declare var new_unsafe_buf:any;
declare var Buffer_from:any;
*/ /* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint eqnull:true */ /*exported CFB */ /*global Uint8Array:false, Uint16Array:false */ /*::
type SectorEntry = {
	name?:string;
	nodes?:Array<number>;
	data:RawBytes;
};
type SectorList = {
	[k:string|number]:SectorEntry;
	name:?string;
	fat_addrs:Array<number>;
	ssz:number;
}
type CFBFiles = {[n:string]:CFBEntry};
*/ /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var $3ee4f50b1ae43a89$var$CRC32 = /*#__PURE__*/ function() {
    var CRC32 = {};
    CRC32.version = "1.2.0";
    /* see perf/crc32table.js */ /*global Int32Array */ function signed_crc_table() /*:any*/ {
        var c = 0, table /*:Array<number>*/  = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== "undefined" ? new Int32Array(table) : table;
    }
    var T0 = signed_crc_table();
    function slice_by_16_tables(T) {
        var c = 0, v = 0, n = 0, table /*:Array<number>*/  = typeof Int32Array !== "undefined" ? new Int32Array(4096) : new Array(4096);
        for(n = 0; n != 256; ++n)table[n] = T[n];
        for(n = 0; n != 256; ++n){
            v = T[n];
            for(c = 256 + n; c < 4096; c += 256)v = table[c] = v >>> 8 ^ T[v & 0xFF];
        }
        var out = [];
        for(n = 1; n != 16; ++n)out[n - 1] = typeof Int32Array !== "undefined" ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
        return out;
    }
    var TT = slice_by_16_tables(T0);
    var T1 = TT[0], T2 = TT[1], T3 = TT[2], T4 = TT[3], T5 = TT[4];
    var T6 = TT[5], T7 = TT[6], T8 = TT[7], T9 = TT[8], Ta = TT[9];
    var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
    function crc32_bstr(bstr /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1;
        for(var i = 0, L = bstr.length; i < L;)C = C >>> 8 ^ T0[(C ^ bstr.charCodeAt(i++)) & 0xFF];
        return ~C;
    }
    function crc32_buf(B /*:Uint8Array|Array<number>*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1, L = B.length - 15, i = 0;
        for(; i < L;)C = Tf[B[i++] ^ C & 255] ^ Te[B[i++] ^ C >> 8 & 255] ^ Td[B[i++] ^ C >> 16 & 255] ^ Tc[B[i++] ^ C >>> 24] ^ Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^ T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^ T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
        L += 15;
        while(i < L)C = C >>> 8 ^ T0[(C ^ B[i++]) & 0xFF];
        return ~C;
    }
    function crc32_str(str /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed ^ -1;
        for(var i = 0, L = str.length, c = 0, d = 0; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) C = C >>> 8 ^ T0[(C ^ c) & 0xFF];
            else if (c < 0x800) {
                C = C >>> 8 ^ T0[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                C = C >>> 8 ^ T0[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d & 63)) & 0xFF];
            } else {
                C = C >>> 8 ^ T0[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            }
        }
        return ~C;
    }
    CRC32.table = T0;
    CRC32.bstr = crc32_bstr;
    CRC32.buf = crc32_buf;
    CRC32.str = crc32_str;
    return CRC32;
}();
/* [MS-CFB] v20171201 */ var $3ee4f50b1ae43a89$export$9f0e51cd97c572a = /*#__PURE__*/ function _CFB() {
    var exports = {};
    exports.version = "1.2.1";
    /* [MS-CFB] 2.6.4 */ function namecmp(l /*:string*/ , r /*:string*/ ) /*:number*/ {
        var L = l.split("/"), R = r.split("/");
        for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i){
            if (c = L[i].length - R[i].length) return c;
            if (L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
        }
        return L.length - R.length;
    }
    function dirname(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return p.slice(0, -1).indexOf("/") === -1 ? p : dirname(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(0, c + 1);
    }
    function filename(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(c + 1);
    }
    /* -------------------------------------------------------------------------- */ /* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/ /* write JS date to buf as a DOS date */ function write_dos_date(buf /*:CFBlob*/ , date /*:Date|string*/ ) {
        if (typeof date === "string") date = new Date(date);
        var hms /*:number*/  = date.getHours();
        hms = hms << 6 | date.getMinutes();
        hms = hms << 5 | date.getSeconds() >>> 1;
        buf.write_shift(2, hms);
        var ymd /*:number*/  = date.getFullYear() - 1980;
        ymd = ymd << 4 | date.getMonth() + 1;
        ymd = ymd << 5 | date.getDate();
        buf.write_shift(2, ymd);
    }
    /* read four bytes from buf and interpret as a DOS date */ function parse_dos_date(buf /*:CFBlob*/ ) /*:Date*/ {
        var hms = buf.read_shift(2) & 0xFFFF;
        var ymd = buf.read_shift(2) & 0xFFFF;
        var val = new Date();
        var d = ymd & 0x1F;
        ymd >>>= 5;
        var m = ymd & 0x0F;
        ymd >>>= 4;
        val.setMilliseconds(0);
        val.setFullYear(ymd + 1980);
        val.setMonth(m - 1);
        val.setDate(d);
        var S = hms & 0x1F;
        hms >>>= 5;
        var M = hms & 0x3F;
        hms >>>= 6;
        val.setHours(hms);
        val.setMinutes(M);
        val.setSeconds(S << 1);
        return val;
    }
    function parse_extra_field(blob /*:CFBlob*/ ) /*:any*/ {
        $3ee4f50b1ae43a89$var$prep_blob(blob, 0);
        var o = /*::(*/ {} /*:: :any)*/ ;
        var flags = 0;
        while(blob.l <= blob.length - 4){
            var type = blob.read_shift(2);
            var sz = blob.read_shift(2), tgt = blob.l + sz;
            var p = {};
            switch(type){
                /* UNIX-style Timestamps */ case 0x5455:
                    flags = blob.read_shift(1);
                    if (flags & 1) p.mtime = blob.read_shift(4);
                    /* for some reason, CD flag corresponds to LFH */ if (sz > 5) {
                        if (flags & 2) p.atime = blob.read_shift(4);
                        if (flags & 4) p.ctime = blob.read_shift(4);
                    }
                    if (p.mtime) p.mt = new Date(p.mtime * 1000);
                    break;
            }
            blob.l = tgt;
            o[type] = p;
        }
        return o;
    }
    var fs /*:: = require('fs'); */ ;
    function get_fs() {
        return fs || (fs = {});
    }
    function parse(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
        if ((file[0] | 0x20) == 0x6d && (file[1] | 0x20) == 0x69) return parse_mad(file, options);
        if (file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
        var mver = 3;
        var ssz = 512;
        var nmfs = 0; // number of mini FAT sectors
        var difat_sec_cnt = 0;
        var dir_start = 0;
        var minifat_start = 0;
        var difat_start = 0;
        var fat_addrs /*:Array<number>*/  = []; // locations of FAT sectors
        /* [MS-CFB] 2.2 Compound File Header */ var blob /*:CFBlob*/  = /*::(*/ file.slice(0, 512) /*:: :any)*/ ;
        $3ee4f50b1ae43a89$var$prep_blob(blob, 0);
        /* major version */ var mv = check_get_mver(blob);
        mver = mv[0];
        switch(mver){
            case 3:
                ssz = 512;
                break;
            case 4:
                ssz = 4096;
                break;
            case 0:
                if (mv[1] == 0) return parse_zip(file, options);
            /* falls through */ default:
                throw new Error("Major Version: Expected 3 or 4 saw " + mver);
        }
        /* reprocess header */ if (ssz !== 512) {
            blob = /*::(*/ file.slice(0, ssz) /*:: :any)*/ ;
            $3ee4f50b1ae43a89$var$prep_blob(blob, 28 /* blob.l */ );
        }
        /* Save header for final object */ var header /*:RawBytes*/  = file.slice(0, ssz);
        check_shifts(blob, mver);
        // Number of Directory Sectors
        var dir_cnt /*:number*/  = blob.read_shift(4, "i");
        if (mver === 3 && dir_cnt !== 0) throw new Error("# Directory Sectors: Expected 0 saw " + dir_cnt);
        // Number of FAT Sectors
        blob.l += 4;
        // First Directory Sector Location
        dir_start = blob.read_shift(4, "i");
        // Transaction Signature
        blob.l += 4;
        // Mini Stream Cutoff Size
        blob.chk("00100000", "Mini Stream Cutoff Size: ");
        // First Mini FAT Sector Location
        minifat_start = blob.read_shift(4, "i");
        // Number of Mini FAT Sectors
        nmfs = blob.read_shift(4, "i");
        // First DIFAT sector location
        difat_start = blob.read_shift(4, "i");
        // Number of DIFAT Sectors
        difat_sec_cnt = blob.read_shift(4, "i");
        // Grab FAT Sector Locations
        for(var q = -1, j = 0; j < 109; ++j){
            q = blob.read_shift(4, "i");
            if (q < 0) break;
            fat_addrs[j] = q;
        }
        /** Break the file up into sectors */ var sectors /*:Array<RawBytes>*/  = sectorify(file, ssz);
        sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
        /** Chains */ var sector_list /*:SectorList*/  = make_sector_list(sectors, dir_start, fat_addrs, ssz);
        sector_list[dir_start].name = "!Directory";
        if (nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
        sector_list[fat_addrs[0]].name = "!FAT";
        sector_list.fat_addrs = fat_addrs;
        sector_list.ssz = ssz;
        /* [MS-CFB] 2.6.1 Compound File Directory Entry */ var files /*:CFBFiles*/  = {}, Paths /*:Array<string>*/  = [], FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
        build_full_paths(FileIndex, FullPaths, Paths);
        Paths.shift();
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        // $FlowIgnore
        if (options && options.raw) o.raw = {
            header: header,
            sectors: sectors
        };
        return o;
    } // parse
    /* [MS-CFB] 2.2 Compound File Header -- read up to major version */ function check_get_mver(blob /*:CFBlob*/ ) /*:[number, number]*/ {
        if (blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [
            0,
            0
        ];
        // header signature 8
        blob.chk(HEADER_SIGNATURE, "Header Signature: ");
        // clsid 16
        //blob.chk(HEADER_CLSID, 'CLSID: ');
        blob.l += 16;
        // minor version 2
        var mver /*:number*/  = blob.read_shift(2, "u");
        return [
            blob.read_shift(2, "u"),
            mver
        ];
    }
    function check_shifts(blob /*:CFBlob*/ , mver /*:number*/ ) /*:void*/ {
        var shift = 0x09;
        // Byte Order
        //blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
        blob.l += 2;
        // Sector Shift
        switch(shift = blob.read_shift(2)){
            case 0x09:
                if (mver != 3) throw new Error("Sector Shift: Expected 9 saw " + shift);
                break;
            case 0x0c:
                if (mver != 4) throw new Error("Sector Shift: Expected 12 saw " + shift);
                break;
            default:
                throw new Error("Sector Shift: Expected 9 or 12 saw " + shift);
        }
        // Mini Sector Shift
        blob.chk("0600", "Mini Sector Shift: ");
        // Reserved
        blob.chk("000000000000", "Reserved: ");
    }
    /** Break the file up into sectors */ function sectorify(file /*:RawBytes*/ , ssz /*:number*/ ) /*:Array<RawBytes>*/ {
        var nsectors = Math.ceil(file.length / ssz) - 1;
        var sectors /*:Array<RawBytes>*/  = [];
        for(var i = 1; i < nsectors; ++i)sectors[i - 1] = file.slice(i * ssz, (i + 1) * ssz);
        sectors[nsectors - 1] = file.slice(nsectors * ssz);
        return sectors;
    }
    /* [MS-CFB] 2.6.4 Red-Black Tree */ function build_full_paths(FI /*:CFBFileIndex*/ , FP /*:Array<string>*/ , Paths /*:Array<string>*/ ) /*:void*/ {
        var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
        var dad /*:Array<number>*/  = [], q /*:Array<number>*/  = [];
        for(; i < pl; ++i){
            dad[i] = q[i] = i;
            FP[i] = Paths[i];
        }
        for(; j < q.length; ++j){
            i = q[j];
            L = FI[i].L;
            R = FI[i].R;
            C = FI[i].C;
            if (dad[i] === i) {
                if (L !== -1 /*NOSTREAM*/  && dad[L] !== L) dad[i] = dad[L];
                if (R !== -1 && dad[R] !== R) dad[i] = dad[R];
            }
            if (C !== -1 /*NOSTREAM*/ ) dad[C] = i;
            if (L !== -1 && i != dad[i]) {
                dad[L] = dad[i];
                if (q.lastIndexOf(L) < j) q.push(L);
            }
            if (R !== -1 && i != dad[i]) {
                dad[R] = dad[i];
                if (q.lastIndexOf(R) < j) q.push(R);
            }
        }
        for(i = 1; i < pl; ++i)if (dad[i] === i) {
            if (R !== -1 /*NOSTREAM*/  && dad[R] !== R) dad[i] = dad[R];
            else if (L !== -1 && dad[L] !== L) dad[i] = dad[L];
        }
        for(i = 1; i < pl; ++i){
            if (FI[i].type === 0 /* unknown */ ) continue;
            j = i;
            if (j != dad[j]) do {
                j = dad[j];
                FP[i] = FP[j] + "/" + FP[i];
            }while (j !== 0 && -1 !== dad[j] && j != dad[j]);
            dad[i] = -1;
        }
        FP[0] += "/";
        for(i = 1; i < pl; ++i)if (FI[i].type !== 2 /* stream */ ) FP[i] += "/";
    }
    function get_mfat_entry(entry /*:CFBEntry*/ , payload /*:RawBytes*/ , mini /*:?RawBytes*/ ) /*:CFBlob*/ {
        var start = entry.start, size = entry.size;
        //return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
        var o = [];
        var idx = start;
        while(mini && size > 0 && idx >= 0){
            o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
            size -= MSSZ;
            idx = $3ee4f50b1ae43a89$var$__readInt32LE(mini, idx * 4);
        }
        if (o.length === 0) return $3ee4f50b1ae43a89$var$new_buf(0);
        return $3ee4f50b1ae43a89$var$bconcat(o).slice(0, entry.size);
    }
    /** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */ function sleuth_fat(idx /*:number*/ , cnt /*:number*/ , sectors /*:Array<RawBytes>*/ , ssz /*:number*/ , fat_addrs) /*:void*/ {
        var q /*:number*/  = ENDOFCHAIN;
        if (idx === ENDOFCHAIN) {
            if (cnt !== 0) throw new Error("DIFAT chain shorter than expected");
        } else if (idx !== -1 /*FREESECT*/ ) {
            var sector = sectors[idx], m = (ssz >>> 2) - 1;
            if (!sector) return;
            for(var i = 0; i < m; ++i){
                if ((q = $3ee4f50b1ae43a89$var$__readInt32LE(sector, i * 4)) === ENDOFCHAIN) break;
                fat_addrs.push(q);
            }
            sleuth_fat($3ee4f50b1ae43a89$var$__readInt32LE(sector, ssz - 4), cnt - 1, sectors, ssz, fat_addrs);
        }
    }
    /** Follow the linked list of sectors for a given starting point */ function get_sector_list(sectors /*:Array<RawBytes>*/ , start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ , chkd /*:?Array<boolean>*/ ) /*:SectorEntry*/ {
        var buf /*:Array<number>*/  = [], buf_chain /*:Array<any>*/  = [];
        if (!chkd) chkd = [];
        var modulus = ssz - 1, j = 0, jj = 0;
        for(j = start; j >= 0;){
            chkd[j] = true;
            buf[buf.length] = j;
            buf_chain.push(sectors[j]);
            var addr = fat_addrs[Math.floor(j * 4 / ssz)];
            jj = j * 4 & modulus;
            if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
            if (!sectors[addr]) break;
            j = $3ee4f50b1ae43a89$var$__readInt32LE(sectors[addr], jj);
        }
        return {
            nodes: buf,
            data: $3ee4f50b1ae43a89$var$__toBuffer([
                buf_chain
            ])
        };
    }
    /** Chase down the sector linked lists */ function make_sector_list(sectors /*:Array<RawBytes>*/ , dir_start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ ) /*:SectorList*/ {
        var sl = sectors.length, sector_list /*:SectorList*/  = [];
        var chkd /*:Array<boolean>*/  = [], buf /*:Array<number>*/  = [], buf_chain /*:Array<RawBytes>*/  = [];
        var modulus = ssz - 1, i = 0, j = 0, k = 0, jj = 0;
        for(i = 0; i < sl; ++i){
            buf = [];
            k = i + dir_start;
            if (k >= sl) k -= sl;
            if (chkd[k]) continue;
            buf_chain = [];
            var seen = [];
            for(j = k; j >= 0;){
                seen[j] = true;
                chkd[j] = true;
                buf[buf.length] = j;
                buf_chain.push(sectors[j]);
                var addr /*:number*/  = fat_addrs[Math.floor(j * 4 / ssz)];
                jj = j * 4 & modulus;
                if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
                if (!sectors[addr]) break;
                j = $3ee4f50b1ae43a89$var$__readInt32LE(sectors[addr], jj);
                if (seen[j]) break;
            }
            sector_list[k] = {
                nodes: buf,
                data: $3ee4f50b1ae43a89$var$__toBuffer([
                    buf_chain
                ])
            } /*:SectorEntry*/ ;
        }
        return sector_list;
    }
    /* [MS-CFB] 2.6.1 Compound File Directory Entry */ function read_directory(dir_start /*:number*/ , sector_list /*:SectorList*/ , sectors /*:Array<RawBytes>*/ , Paths /*:Array<string>*/ , nmfs, files, FileIndex, mini) {
        var minifat_store = 0, pl = Paths.length ? 2 : 0;
        var sector = sector_list[dir_start].data;
        var i = 0, namelen = 0, name;
        for(; i < sector.length; i += 128){
            var blob /*:CFBlob*/  = /*::(*/ sector.slice(i, i + 128) /*:: :any)*/ ;
            $3ee4f50b1ae43a89$var$prep_blob(blob, 64);
            namelen = blob.read_shift(2);
            name = $3ee4f50b1ae43a89$var$__utf16le(blob, 0, namelen - pl);
            Paths.push(name);
            var o /*:CFBEntry*/  = {
                name: name,
                type: blob.read_shift(1),
                color: blob.read_shift(1),
                L: blob.read_shift(4, "i"),
                R: blob.read_shift(4, "i"),
                C: blob.read_shift(4, "i"),
                clsid: blob.read_shift(16),
                state: blob.read_shift(4, "i"),
                start: 0,
                size: 0
            };
            var ctime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (ctime !== 0) o.ct = read_date(blob, blob.l - 8);
            var mtime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (mtime !== 0) o.mt = read_date(blob, blob.l - 8);
            o.start = blob.read_shift(4, "i");
            o.size = blob.read_shift(4, "i");
            if (o.size < 0 && o.start < 0) {
                o.size = o.type = 0;
                o.start = ENDOFCHAIN;
                o.name = "";
            }
            if (o.type === 5) {
                minifat_store = o.start;
                if (nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
            /*minifat_size = o.size;*/ } else if (o.size >= 4096 /* MSCSZ */ ) {
                o.storage = "fat";
                if (sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
                sector_list[o.start].name = o.name;
                o.content = sector_list[o.start].data.slice(0, o.size);
            } else {
                o.storage = "minifat";
                if (o.size < 0) o.size = 0;
                else if (minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini] || {}).data);
            }
            if (o.content) $3ee4f50b1ae43a89$var$prep_blob(o.content, 0);
            files[name] = o;
            FileIndex.push(o);
        }
    }
    function read_date(blob /*:RawBytes|CFBlob*/ , offset /*:number*/ ) /*:Date*/ {
        return new Date(($3ee4f50b1ae43a89$var$__readUInt32LE(blob, offset + 4) / 1e7 * Math.pow(2, 32) + $3ee4f50b1ae43a89$var$__readUInt32LE(blob, offset) / 1e7 - 11644473600) * 1000);
    }
    function read_file(filename /*:string*/ , options /*:CFBReadOpts*/ ) {
        get_fs();
        return parse(fs.readFileSync(filename), options);
    }
    function read(blob /*:RawBytes|string*/ , options /*:CFBReadOpts*/ ) {
        var type = options && options.type;
        if (!type) {
            if ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(blob)) type = "buffer";
        }
        switch(type || "base64"){
            case "file":
                /*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */ return read_file(blob, options);
            case "base64":
                /*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */ return parse($3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$Base64_decode(blob)), options);
            case "binary":
                /*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */ return parse($3ee4f50b1ae43a89$var$s2a(blob), options);
        }
        return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */ blob, options);
    }
    function init_cfb(cfb /*:CFBContainer*/ , opts /*:?any*/ ) /*:void*/ {
        var o = opts || {}, root = o.root || "Root Entry";
        if (!cfb.FullPaths) cfb.FullPaths = [];
        if (!cfb.FileIndex) cfb.FileIndex = [];
        if (cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
        if (cfb.FullPaths.length === 0) {
            cfb.FullPaths[0] = root + "/";
            cfb.FileIndex[0] = {
                name: root,
                type: 5
            } /*:any*/ ;
        }
        if (o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
        seed_cfb(cfb);
    }
    function seed_cfb(cfb /*:CFBContainer*/ ) /*:void*/ {
        var nm = "\x01Sh33tJ5";
        if ($3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "/" + nm)) return;
        var p = $3ee4f50b1ae43a89$var$new_buf(4);
        p[0] = 55;
        p[1] = p[3] = 50;
        p[2] = 54;
        cfb.FileIndex.push({
            name: nm,
            type: 2,
            content: p,
            size: 4,
            L: 69,
            R: 69,
            C: 69
        } /*:any*/ );
        cfb.FullPaths.push(cfb.FullPaths[0] + nm);
        rebuild_cfb(cfb);
    }
    function rebuild_cfb(cfb /*:CFBContainer*/ , f /*:?boolean*/ ) /*:void*/ {
        init_cfb(cfb);
        var gc = false, s = false;
        for(var i = cfb.FullPaths.length - 1; i >= 0; --i){
            var _file = cfb.FileIndex[i];
            switch(_file.type){
                case 0:
                    if (s) gc = true;
                    else {
                        cfb.FileIndex.pop();
                        cfb.FullPaths.pop();
                    }
                    break;
                case 1:
                case 2:
                case 5:
                    s = true;
                    if (isNaN(_file.R * _file.L * _file.C)) gc = true;
                    if (_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
                    break;
                default:
                    gc = true;
                    break;
            }
        }
        if (!gc && !f) return;
        var now = new Date(1987, 1, 19), j = 0;
        // Track which names exist
        var fullPaths = Object.create ? Object.create(null) : {};
        var data /*:Array<[string, CFBEntry]>*/  = [];
        for(i = 0; i < cfb.FullPaths.length; ++i){
            fullPaths[cfb.FullPaths[i]] = true;
            if (cfb.FileIndex[i].type === 0) continue;
            data.push([
                cfb.FullPaths[i],
                cfb.FileIndex[i]
            ]);
        }
        for(i = 0; i < data.length; ++i){
            var dad = dirname(data[i][0]);
            s = fullPaths[dad];
            if (!s) {
                data.push([
                    dad,
                    {
                        name: filename(dad).replace("/", ""),
                        type: 1,
                        clsid: HEADER_CLSID,
                        ct: now,
                        mt: now,
                        content: null
                    } /*:any*/ 
                ]);
                // Add name to set
                fullPaths[dad] = true;
            }
        }
        data.sort(function(x, y) {
            return namecmp(x[0], y[0]);
        });
        cfb.FullPaths = [];
        cfb.FileIndex = [];
        for(i = 0; i < data.length; ++i){
            cfb.FullPaths[i] = data[i][0];
            cfb.FileIndex[i] = data[i][1];
        }
        for(i = 0; i < data.length; ++i){
            var elt = cfb.FileIndex[i];
            var nm = cfb.FullPaths[i];
            elt.name = filename(nm).replace("/", "");
            elt.L = elt.R = elt.C = -(elt.color = 1);
            elt.size = elt.content ? elt.content.length : 0;
            elt.start = 0;
            elt.clsid = elt.clsid || HEADER_CLSID;
            if (i === 0) {
                elt.C = data.length > 1 ? 1 : -1;
                elt.size = 0;
                elt.type = 5;
            } else if (nm.slice(-1) == "/") {
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == nm) break;
                elt.C = j >= data.length ? -1 : j;
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == dirname(nm)) break;
                elt.R = j >= data.length ? -1 : j;
                elt.type = 1;
            } else {
                if (dirname(cfb.FullPaths[i + 1] || "") == dirname(nm)) elt.R = i + 1;
                elt.type = 2;
            }
        }
    }
    function _write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var _opts = options || {};
        /* MAD is order-sensitive, skip rebuild and sort */ if (_opts.fileType == "mad") return write_mad(cfb, _opts);
        rebuild_cfb(cfb);
        switch(_opts.fileType){
            case "zip":
                return write_zip(cfb, _opts);
        }
        var L = function(cfb /*:CFBContainer*/ ) /*:Array<number>*/ {
            var mini_size = 0, fat_size = 0;
            for(var i = 0; i < cfb.FileIndex.length; ++i){
                var file = cfb.FileIndex[i];
                if (!file.content) continue;
                /*:: if(file.content == null) throw new Error("unreachable"); */ var flen = file.content.length;
                if (flen > 0) {
                    if (flen < 0x1000) mini_size += flen + 0x3F >> 6;
                    else fat_size += flen + 0x01FF >> 9;
                }
            }
            var dir_cnt = cfb.FullPaths.length + 3 >> 2;
            var mini_cnt = mini_size + 7 >> 3;
            var mfat_cnt = mini_size + 0x7F >> 7;
            var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
            var fat_cnt = fat_base + 0x7F >> 7;
            var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            while(fat_base + fat_cnt + difat_cnt + 0x7F >> 7 > fat_cnt)difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            var L = [
                1,
                difat_cnt,
                fat_cnt,
                mfat_cnt,
                dir_cnt,
                fat_size,
                mini_size,
                0
            ];
            cfb.FileIndex[0].size = mini_size << 6;
            L[7] = (cfb.FileIndex[0].start = L[0] + L[1] + L[2] + L[3] + L[4] + L[5]) + (L[6] + 7 >> 3);
            return L;
        }(cfb);
        var o = $3ee4f50b1ae43a89$var$new_buf(L[7] << 9);
        var i = 0, T = 0;
        for(i = 0; i < 8; ++i)o.write_shift(1, HEADER_SIG[i]);
        for(i = 0; i < 8; ++i)o.write_shift(2, 0);
        o.write_shift(2, 0x003E);
        o.write_shift(2, 0x0003);
        o.write_shift(2, 0xFFFE);
        o.write_shift(2, 0x0009);
        o.write_shift(2, 0x0006);
        for(i = 0; i < 3; ++i)o.write_shift(2, 0);
        o.write_shift(4, 0);
        o.write_shift(4, L[2]);
        o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
        o.write_shift(4, 0);
        o.write_shift(4, 4096);
        o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[3]);
        o.write_shift(-4, L[1] ? L[0] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[1]);
        for(i = 0; i < 109; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
        if (L[1]) for(T = 0; T < L[1]; ++T){
            for(; i < 236 + T * 127; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
            o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
        }
        var chainit = function(w /*:number*/ ) /*:void*/ {
            for(T += w; i < T - 1; ++i)o.write_shift(-4, i + 1);
            if (w) {
                ++i;
                o.write_shift(-4, ENDOFCHAIN);
            }
        };
        T = i = 0;
        for(T += L[1]; i < T; ++i)o.write_shift(-4, consts.DIFSECT);
        for(T += L[2]; i < T; ++i)o.write_shift(-4, consts.FATSECT);
        chainit(L[3]);
        chainit(L[4]);
        var j /*:number*/  = 0, flen /*:number*/  = 0;
        var file /*:CFBEntry*/  = cfb.FileIndex[0];
        for(; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (flen < 0x1000) continue;
            file.start = T;
            chainit(flen + 0x01FF >> 9);
        }
        chainit(L[6] + 7 >> 3);
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        T = i = 0;
        for(j = 0; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (!flen || flen >= 0x1000) continue;
            file.start = T;
            chainit(flen + 0x3F >> 6);
        }
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        for(i = 0; i < L[4] << 2; ++i){
            var nm = cfb.FullPaths[i];
            if (!nm || nm.length === 0) {
                for(j = 0; j < 17; ++j)o.write_shift(4, 0);
                for(j = 0; j < 3; ++j)o.write_shift(4, -1);
                for(j = 0; j < 12; ++j)o.write_shift(4, 0);
                continue;
            }
            file = cfb.FileIndex[i];
            if (i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
            var _nm /*:string*/  = i === 0 && _opts.root || file.name;
            flen = 2 * (_nm.length + 1);
            o.write_shift(64, _nm, "utf16le");
            o.write_shift(2, flen);
            o.write_shift(1, file.type);
            o.write_shift(1, file.color);
            o.write_shift(-4, file.L);
            o.write_shift(-4, file.R);
            o.write_shift(-4, file.C);
            if (!file.clsid) for(j = 0; j < 4; ++j)o.write_shift(4, 0);
            else o.write_shift(16, file.clsid, "hex");
            o.write_shift(4, file.state || 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, file.start);
            o.write_shift(4, file.size);
            o.write_shift(4, 0);
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size >= 0x1000) {
                o.l = file.start + 1 << 9;
                if ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 511 & -512;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x1FF; ++j)o.write_shift(1, 0);
                }
            }
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size > 0 && file.size < 0x1000) {
                if ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 63 & -64;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x3F; ++j)o.write_shift(1, 0);
                }
            }
        }
        if ($3ee4f50b1ae43a89$var$has_buf) o.l = o.length;
        else // When using Buffer, already 0-filled
        while(o.l < o.length)o.write_shift(1, 0);
        return o;
    }
    /* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */ function find(cfb /*:CFBContainer*/ , path /*:string*/ ) /*:?CFBEntry*/ {
        var UCFullPaths /*:Array<string>*/  = cfb.FullPaths.map(function(x) {
            return x.toUpperCase();
        });
        var UCPaths /*:Array<string>*/  = UCFullPaths.map(function(x) {
            var y = x.split("/");
            return y[y.length - (x.slice(-1) == "/" ? 2 : 1)];
        });
        var k /*:boolean*/  = false;
        if (path.charCodeAt(0) === 47 /* "/" */ ) {
            k = true;
            path = UCFullPaths[0].slice(0, -1) + path;
        } else k = path.indexOf("/") !== -1;
        var UCPath /*:string*/  = path.toUpperCase();
        var w /*:number*/  = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
        if (w !== -1) return cfb.FileIndex[w];
        var m = !UCPath.match($3ee4f50b1ae43a89$var$chr1);
        UCPath = UCPath.replace($3ee4f50b1ae43a89$var$chr0, "");
        if (m) UCPath = UCPath.replace($3ee4f50b1ae43a89$var$chr1, "!");
        for(w = 0; w < UCFullPaths.length; ++w){
            if ((m ? UCFullPaths[w].replace($3ee4f50b1ae43a89$var$chr1, "!") : UCFullPaths[w]).replace($3ee4f50b1ae43a89$var$chr0, "") == UCPath) return cfb.FileIndex[w];
            if ((m ? UCPaths[w].replace($3ee4f50b1ae43a89$var$chr1, "!") : UCPaths[w]).replace($3ee4f50b1ae43a89$var$chr0, "") == UCPath) return cfb.FileIndex[w];
        }
        return null;
    }
    /** CFB Constants */ var MSSZ = 64; /* Mini Sector Size = 1<<6 */ 
    //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
    /* 2.1 Compound File Sector Numbers and Types */ var ENDOFCHAIN = -2;
    /* 2.2 Compound File Header */ var HEADER_SIGNATURE = "d0cf11e0a1b11ae1";
    var HEADER_SIG = [
        0xD0,
        0xCF,
        0x11,
        0xE0,
        0xA1,
        0xB1,
        0x1A,
        0xE1
    ];
    var HEADER_CLSID = "00000000000000000000000000000000";
    var consts = {
        /* 2.1 Compund File Sector Numbers and Types */ MAXREGSECT: -6,
        DIFSECT: -4,
        FATSECT: -3,
        ENDOFCHAIN: ENDOFCHAIN,
        FREESECT: -1,
        /* 2.2 Compound File Header */ HEADER_SIGNATURE: HEADER_SIGNATURE,
        HEADER_MINOR_VERSION: "3e00",
        MAXREGSID: -6,
        NOSTREAM: -1,
        HEADER_CLSID: HEADER_CLSID,
        /* 2.6.1 Compound File Directory Entry */ EntryTypes: [
            "unknown",
            "storage",
            "stream",
            "lockbytes",
            "property",
            "root"
        ]
    };
    function write_file(cfb /*:CFBContainer*/ , filename /*:string*/ , options /*:CFBWriteOpts*/ ) /*:void*/ {
        get_fs();
        var o = _write(cfb, options);
        /*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */ fs.writeFileSync(filename, o);
    }
    function a2s(o /*:RawBytes*/ ) /*:string*/ {
        var out = new Array(o.length);
        for(var i = 0; i < o.length; ++i)out[i] = String.fromCharCode(o[i]);
        return out.join("");
    }
    function write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var o = _write(cfb, options);
        switch(options && options.type || "buffer"){
            case "file":
                get_fs();
                fs.writeFileSync(options.filename, o /*:any*/ );
                return o;
            case "binary":
                return typeof o == "string" ? o : a2s(o);
            case "base64":
                return $3ee4f50b1ae43a89$var$Base64_encode(typeof o == "string" ? o : a2s(o));
            case "buffer":
                if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$require$Buffer.isBuffer(o) ? o : $3ee4f50b1ae43a89$var$Buffer_from(o);
            /* falls through */ case "array":
                return typeof o == "string" ? $3ee4f50b1ae43a89$var$s2a(o) : o;
        }
        return o;
    }
    /* node < 8.1 zlib does not expose bytesRead, so default to pure JS */ var _zlib;
    function use_zlib(zlib) {
        try {
            var InflateRaw = zlib.InflateRaw;
            var InflRaw = new InflateRaw();
            InflRaw._processChunk(new Uint8Array([
                3,
                0
            ]), InflRaw._finishFlushFlag);
            if (InflRaw.bytesRead) _zlib = zlib;
            else throw new Error("zlib does not expose bytesRead");
        } catch (e) {
            console.error("cannot use native zlib: " + (e.message || e));
        }
    }
    function _inflateRawSync(payload, usz) {
        if (!_zlib) return _inflate(payload, usz);
        var InflateRaw = _zlib.InflateRaw;
        var InflRaw = new InflateRaw();
        var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
        payload.l += InflRaw.bytesRead;
        return out;
    }
    function _deflateRawSync(payload) {
        return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
    }
    var CLEN_ORDER = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    /*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */ var LEN_LN = [
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258
    ];
    /*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */ var DST_LN = [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577
    ];
    function bit_swap_8(n) {
        var t = (n << 1 | n << 11) & 0x22110 | (n << 5 | n << 15) & 0x88440;
        return (t >> 16 | t >> 8 | t) & 0xFF;
    }
    var use_typed_arrays = typeof Uint8Array !== "undefined";
    var bitswap8 = use_typed_arrays ? new Uint8Array(256) : [];
    for(var q = 0; q < 256; ++q)bitswap8[q] = bit_swap_8(q);
    function bit_swap_n(n, b) {
        var rev = bitswap8[n & 0xFF];
        if (b <= 8) return rev >>> 8 - b;
        rev = rev << 8 | bitswap8[n >> 8 & 0xFF];
        if (b <= 16) return rev >>> 16 - b;
        rev = rev << 8 | bitswap8[n >> 16 & 0xFF];
        return rev >>> 24 - b;
    }
    /* helpers for unaligned bit reads */ function read_bits_2(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 6 ? 0 : buf[h + 1] << 8)) >>> w & 0x03;
    }
    function read_bits_3(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 5 ? 0 : buf[h + 1] << 8)) >>> w & 0x07;
    }
    function read_bits_4(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 4 ? 0 : buf[h + 1] << 8)) >>> w & 0x0F;
    }
    function read_bits_5(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 3 ? 0 : buf[h + 1] << 8)) >>> w & 0x1F;
    }
    function read_bits_7(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 1 ? 0 : buf[h + 1] << 8)) >>> w & 0x7F;
    }
    /* works up to n = 3 * 8 + 1 = 25 */ function read_bits_n(buf, bl, n) {
        var w = bl & 7, h = bl >>> 3, f = (1 << n) - 1;
        var v = buf[h] >>> w;
        if (n < 8 - w) return v & f;
        v |= buf[h + 1] << 8 - w;
        if (n < 16 - w) return v & f;
        v |= buf[h + 2] << 16 - w;
        if (n < 24 - w) return v & f;
        v |= buf[h + 3] << 24 - w;
        return v & f;
    }
    /* helpers for unaligned bit writes */ function write_bits_3(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        if (w <= 5) buf[h] |= (v & 7) << w;
        else {
            buf[h] |= v << w & 0xFF;
            buf[h + 1] = (v & 7) >> 8 - w;
        }
        return bl + 3;
    }
    function write_bits_1(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v = (v & 1) << w;
        buf[h] |= v;
        return bl + 1;
    }
    function write_bits_8(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v;
        return bl + 8;
    }
    function write_bits_16(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v & 0xFF;
        buf[h + 2] = v >>> 8;
        return bl + 16;
    }
    /* until ArrayBuffer#realloc is a thing, fake a realloc */ function realloc(b, sz /*:number*/ ) {
        var L = b.length, M = 2 * L > sz ? 2 * L : sz + 5, i = 0;
        if (L >= sz) return b;
        if ($3ee4f50b1ae43a89$var$has_buf) {
            var o = $3ee4f50b1ae43a89$var$new_unsafe_buf(M);
            // $FlowIgnore
            if (b.copy) b.copy(o);
            else for(; i < b.length; ++i)o[i] = b[i];
            return o;
        } else if (use_typed_arrays) {
            var a = new Uint8Array(M);
            if (a.set) a.set(b);
            else for(; i < L; ++i)a[i] = b[i];
            return a;
        }
        b.length = M;
        return b;
    }
    /* zero-filled arrays for older browsers */ function zero_fill_array(n) {
        var o = new Array(n);
        for(var i = 0; i < n; ++i)o[i] = 0;
        return o;
    }
    /* build tree (used for literals and lengths) */ function build_tree(clens, cmap, MAX /*:number*/ ) /*:number*/ {
        var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
        var bl_count = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
        for(i = 0; i < 32; ++i)bl_count[i] = 0;
        for(i = L; i < MAX; ++i)clens[i] = 0;
        L = clens.length;
        var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
        /* build code tree */ for(i = 0; i < L; ++i){
            bl_count[w = clens[i]]++;
            if (maxlen < w) maxlen = w;
            ctree[i] = 0;
        }
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)bl_count[i + 16] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i){
            ccode = clens[i];
            if (ccode != 0) ctree[i] = bl_count[ccode + 16]++;
        }
        /* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bit_swap_n(ctree[i], maxlen) >> maxlen - cleni;
                for(j = (1 << maxlen + 4 - cleni) - 1; j >= 0; --j)cmap[ccode | j << cleni] = cleni & 15 | i << 4;
            }
        }
        return maxlen;
    }
    /* Fixed Huffman */ var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
    var fix_dmap = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
    if (!use_typed_arrays) {
        for(var i = 0; i < 512; ++i)fix_lmap[i] = 0;
        for(i = 0; i < 32; ++i)fix_dmap[i] = 0;
    }
    (function() {
        var dlens /*:Array<number>*/  = [];
        var i = 0;
        for(; i < 32; i++)dlens.push(5);
        build_tree(dlens, fix_dmap, 32);
        var clens /*:Array<number>*/  = [];
        i = 0;
        for(; i <= 143; i++)clens.push(8);
        for(; i <= 255; i++)clens.push(9);
        for(; i <= 279; i++)clens.push(7);
        for(; i <= 287; i++)clens.push(8);
        build_tree(clens, fix_lmap, 288);
    })();
    var _deflateRaw = /*#__PURE__*/ function _deflateRawIIFE() {
        var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
        var j = 0, k = 0;
        for(; j < DST_LN.length - 1; ++j)for(; k < DST_LN[j + 1]; ++k)DST_LN_RE[k] = j;
        for(; k < 32768; ++k)DST_LN_RE[k] = 29;
        var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
        for(j = 0, k = 0; j < LEN_LN.length - 1; ++j)for(; k < LEN_LN[j + 1]; ++k)LEN_LN_RE[k] = j;
        function write_stored(data, out) {
            var boff = 0;
            while(boff < data.length){
                var L = Math.min(0xFFFF, data.length - boff);
                var h = boff + L == data.length;
                out.write_shift(1, +h);
                out.write_shift(2, L);
                out.write_shift(2, ~L & 0xFFFF);
                while(L-- > 0)out[out.l++] = data[boff++];
            }
            return out.l;
        }
        /* Fixed Huffman */ function write_huff_fixed(data, out) {
            var bl = 0;
            var boff = 0;
            var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
            while(boff < data.length){
                var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
                /* write a stored block for short data */ if (L < 10) {
                    bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
                    if (bl & 7) bl += 8 - (bl & 7);
                    out.l = bl / 8 | 0;
                    out.write_shift(2, L);
                    out.write_shift(2, ~L & 0xFFFF);
                    while(L-- > 0)out[out.l++] = data[boff++];
                    bl = out.l * 8;
                    continue;
                }
                bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
                var hash = 0;
                while(L-- > 0){
                    var d = data[boff];
                    hash = (hash << 5 ^ d) & 0x7FFF;
                    var match = -1, mlen = 0;
                    if (match = addrs[hash]) {
                        match |= boff & -32768;
                        if (match > boff) match -= 0x8000;
                        if (match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250)++mlen;
                    }
                    if (mlen > 2) {
                        /* Copy Token  */ d = LEN_LN_RE[mlen];
                        if (d <= 22) bl = write_bits_8(out, bl, bitswap8[d + 1] >> 1) - 1;
                        else {
                            write_bits_8(out, bl, 3);
                            bl += 5;
                            write_bits_8(out, bl, bitswap8[d - 23] >> 5);
                            bl += 3;
                        }
                        var len_eb = d < 8 ? 0 : d - 4 >> 2;
                        if (len_eb > 0) {
                            write_bits_16(out, bl, mlen - LEN_LN[d]);
                            bl += len_eb;
                        }
                        d = DST_LN_RE[boff - match];
                        bl = write_bits_8(out, bl, bitswap8[d] >> 3);
                        bl -= 3;
                        var dst_eb = d < 4 ? 0 : d - 2 >> 1;
                        if (dst_eb > 0) {
                            write_bits_16(out, bl, boff - match - DST_LN[d]);
                            bl += dst_eb;
                        }
                        for(var q = 0; q < mlen; ++q){
                            addrs[hash] = boff & 0x7FFF;
                            hash = (hash << 5 ^ data[boff]) & 0x7FFF;
                            ++boff;
                        }
                        L -= mlen - 1;
                    } else {
                        /* Literal Token */ if (d <= 143) d = d + 48;
                        else bl = write_bits_1(out, bl, 1);
                        bl = write_bits_8(out, bl, bitswap8[d]);
                        addrs[hash] = boff & 0x7FFF;
                        ++boff;
                    }
                }
                bl = write_bits_8(out, bl, 0) - 1;
            }
            out.l = (bl + 7) / 8 | 0;
            return out.l;
        }
        return function _deflateRaw(data, out) {
            if (data.length < 8) return write_stored(data, out);
            return write_huff_fixed(data, out);
        };
    }();
    function _deflate(data) {
        var buf = $3ee4f50b1ae43a89$var$new_buf(50 + Math.floor(data.length * 1.1));
        var off = _deflateRaw(data, buf);
        return buf.slice(0, off);
    }
    /* modified inflate function also moves original read head */ var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_cmap = use_typed_arrays ? new Uint16Array(128) : zero_fill_array(128);
    var dyn_len_1 = 1, dyn_len_2 = 1;
    /* 5.5.3 Expanding Huffman Codes */ function dyn(data, boff /*:number*/ ) {
        /* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */ var _HLIT = read_bits_5(data, boff) + 257;
        boff += 5;
        var _HDIST = read_bits_5(data, boff) + 1;
        boff += 5;
        var _HCLEN = read_bits_4(data, boff) + 4;
        boff += 4;
        var w = 0;
        /* grab and store code lengths */ var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
        var ctree = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var maxlen = 1;
        var bl_count = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var L = clens.length; /* 19 */ 
        for(var i = 0; i < _HCLEN; ++i){
            clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
            if (maxlen < w) maxlen = w;
            bl_count[w]++;
            boff += 3;
        }
        /* build code tree */ var ccode = 0;
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)next_code[i] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i)if ((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
        /* cmap[7 bits from stream] = (off&7) + (lit<<3) */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bitswap8[ctree[i]] >> 8 - cleni;
                for(var j = (1 << 7 - cleni) - 1; j >= 0; --j)dyn_cmap[ccode | j << cleni] = cleni & 7 | i << 3;
            }
        }
        /* read literal and dist codes at once */ var hcodes /*:Array<number>*/  = [];
        maxlen = 1;
        for(; hcodes.length < _HLIT + _HDIST;){
            ccode = dyn_cmap[read_bits_7(data, boff)];
            boff += ccode & 7;
            switch(ccode >>>= 3){
                case 16:
                    w = 3 + read_bits_2(data, boff);
                    boff += 2;
                    ccode = hcodes[hcodes.length - 1];
                    while(w-- > 0)hcodes.push(ccode);
                    break;
                case 17:
                    w = 3 + read_bits_3(data, boff);
                    boff += 3;
                    while(w-- > 0)hcodes.push(0);
                    break;
                case 18:
                    w = 11 + read_bits_7(data, boff);
                    boff += 7;
                    while(w-- > 0)hcodes.push(0);
                    break;
                default:
                    hcodes.push(ccode);
                    if (maxlen < ccode) maxlen = ccode;
                    break;
            }
        }
        /* build literal / length trees */ var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
        for(i = _HLIT; i < 286; ++i)h1[i] = 0;
        for(i = _HDIST; i < 30; ++i)h2[i] = 0;
        dyn_len_1 = build_tree(h1, dyn_lmap, 286);
        dyn_len_2 = build_tree(h2, dyn_dmap, 30);
        return boff;
    }
    /* return [ data, bytesRead ] */ function inflate(data, usz /*:number*/ ) {
        /* shortcircuit for empty buffer [0x03, 0x00] */ if (data[0] == 3 && !(data[1] & 0x3)) return [
            $3ee4f50b1ae43a89$var$new_raw_buf(usz),
            2
        ];
        /* bit offset */ var boff = 0;
        /* header includes final bit and type bits */ var header = 0;
        var outbuf = $3ee4f50b1ae43a89$var$new_unsafe_buf(usz ? usz : 262144);
        var woff = 0;
        var OL = outbuf.length >>> 0;
        var max_len_1 = 0, max_len_2 = 0;
        while((header & 1) == 0){
            header = read_bits_3(data, boff);
            boff += 3;
            if (header >>> 1 == 0) {
                /* Stored block */ if (boff & 7) boff += 8 - (boff & 7);
                /* 2 bytes sz, 2 bytes bit inverse */ var sz = data[boff >>> 3] | data[(boff >>> 3) + 1] << 8;
                boff += 32;
                /* push sz bytes */ if (sz > 0) {
                    if (!usz && OL < woff + sz) {
                        outbuf = realloc(outbuf, woff + sz);
                        OL = outbuf.length;
                    }
                    while(sz-- > 0){
                        outbuf[woff++] = data[boff >>> 3];
                        boff += 8;
                    }
                }
                continue;
            } else if (header >> 1 == 1) {
                /* Fixed Huffman */ max_len_1 = 9;
                max_len_2 = 5;
            } else {
                /* Dynamic Huffman */ boff = dyn(data, boff);
                max_len_1 = dyn_len_1;
                max_len_2 = dyn_len_2;
            }
            for(;;){
                if (!usz && OL < woff + 32767) {
                    outbuf = realloc(outbuf, woff + 32767);
                    OL = outbuf.length;
                }
                /* ingest code and move read head */ var bits = read_bits_n(data, boff, max_len_1);
                var code = header >>> 1 == 1 ? fix_lmap[bits] : dyn_lmap[bits];
                boff += code & 15;
                code >>>= 4;
                /* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */ if ((code >>> 8 & 0xFF) === 0) outbuf[woff++] = code;
                else if (code == 256) break;
                else {
                    code -= 257;
                    var len_eb = code < 8 ? 0 : code - 4 >> 2;
                    if (len_eb > 5) len_eb = 0;
                    var tgt = woff + LEN_LN[code];
                    /* length extra bits */ if (len_eb > 0) {
                        tgt += read_bits_n(data, boff, len_eb);
                        boff += len_eb;
                    }
                    /* dist code */ bits = read_bits_n(data, boff, max_len_2);
                    code = header >>> 1 == 1 ? fix_dmap[bits] : dyn_dmap[bits];
                    boff += code & 15;
                    code >>>= 4;
                    var dst_eb = code < 4 ? 0 : code - 2 >> 1;
                    var dst = DST_LN[code];
                    /* dist extra bits */ if (dst_eb > 0) {
                        dst += read_bits_n(data, boff, dst_eb);
                        boff += dst_eb;
                    }
                    /* in the common case, manual byte copy is faster than TA set / Buffer copy */ if (!usz && OL < tgt) {
                        outbuf = realloc(outbuf, tgt + 100);
                        OL = outbuf.length;
                    }
                    while(woff < tgt){
                        outbuf[woff] = outbuf[woff - dst];
                        ++woff;
                    }
                }
            }
        }
        if (usz) return [
            outbuf,
            boff + 7 >>> 3
        ];
        return [
            outbuf.slice(0, woff),
            boff + 7 >>> 3
        ];
    }
    function _inflate(payload, usz) {
        var data = payload.slice(payload.l || 0);
        var out = inflate(data, usz);
        payload.l += out[1];
        return out[0];
    }
    function warn_or_throw(wrn, msg) {
        if (wrn) {
            if (typeof console !== "undefined") console.error(msg);
        } else throw new Error(msg);
    }
    function parse_zip(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        var blob /*:CFBlob*/  = /*::(*/ file /*:: :any)*/ ;
        $3ee4f50b1ae43a89$var$prep_blob(blob, 0);
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o, {
            root: options.root
        });
        /* find end of central directory, start just after signature */ var i = blob.length - 4;
        while((blob[i] != 0x50 || blob[i + 1] != 0x4b || blob[i + 2] != 0x05 || blob[i + 3] != 0x06) && i >= 0)--i;
        blob.l = i + 4;
        /* parse end of central directory */ blob.l += 4;
        var fcnt = blob.read_shift(2);
        blob.l += 6;
        var start_cd = blob.read_shift(4);
        /* parse central directory */ blob.l = start_cd;
        for(i = 0; i < fcnt; ++i){
            /* trust local file header instead of CD entry */ blob.l += 20;
            var csz = blob.read_shift(4);
            var usz = blob.read_shift(4);
            var namelen = blob.read_shift(2);
            var efsz = blob.read_shift(2);
            var fcsz = blob.read_shift(2);
            blob.l += 8;
            var offset = blob.read_shift(4);
            var EF = parse_extra_field(/*::(*/ blob.slice(blob.l + namelen, blob.l + namelen + efsz));
            blob.l += namelen + efsz + fcsz;
            var L = blob.l;
            blob.l = offset + 4;
            parse_local_file(blob, csz, usz, o, EF);
            blob.l = L;
        }
        return o;
    }
    /* head starts just after local file header signature */ function parse_local_file(blob /*:CFBlob*/ , csz /*:number*/ , usz /*:number*/ , o /*:CFBContainer*/ , EF) {
        /* [local file header] */ blob.l += 2;
        var flags = blob.read_shift(2);
        var meth = blob.read_shift(2);
        var date = parse_dos_date(blob);
        if (flags & 0x2041) throw new Error("Unsupported ZIP encryption");
        var crc32 = blob.read_shift(4);
        var _csz = blob.read_shift(4);
        var _usz = blob.read_shift(4);
        var namelen = blob.read_shift(2);
        var efsz = blob.read_shift(2);
        // TODO: flags & (1<<11) // UTF8
        var name = "";
        for(var i = 0; i < namelen; ++i)name += String.fromCharCode(blob[blob.l++]);
        if (efsz) {
            var ef = parse_extra_field(/*::(*/ blob.slice(blob.l, blob.l + efsz));
            if ((ef[0x5455] || {}).mt) date = ef[0x5455].mt;
            if (((EF || {})[0x5455] || {}).mt) date = EF[0x5455].mt;
        }
        blob.l += efsz;
        /* [encryption header] */ /* [file data] */ var data = blob.slice(blob.l, blob.l + _csz);
        switch(meth){
            case 8:
                data = _inflateRawSync(blob, _usz);
                break;
            case 0:
                break; // TODO: scan for magic number
            default:
                throw new Error("Unsupported ZIP Compression method " + meth);
        }
        /* [data descriptor] */ var wrn = false;
        if (flags & 8) {
            crc32 = blob.read_shift(4);
            if (crc32 == 0x08074b50) {
                crc32 = blob.read_shift(4);
                wrn = true;
            }
            _csz = blob.read_shift(4);
            _usz = blob.read_shift(4);
        }
        if (_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
        if (_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
        //var _crc32 = CRC32.buf(data, 0);
        //if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
        cfb_add(o, name, data, {
            unsafe: true,
            mt: date
        });
    }
    function write_zip(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes*/ {
        var _opts = options || {};
        var out = [], cdirs = [];
        var o /*:CFBlob*/  = $3ee4f50b1ae43a89$var$new_buf(1);
        var method = _opts.compression ? 8 : 0, flags = 0;
        var desc = false;
        if (desc) flags |= 8;
        var i = 0, j = 0;
        var start_cd = 0, fcnt = 0;
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        var crcs = [];
        var sz_cd = 0;
        for(i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\x01Sh33tJ5") continue;
            var start = start_cd;
            /* TODO: CP437 filename */ var namebuf = $3ee4f50b1ae43a89$var$new_buf(fp.length);
            for(j = 0; j < fp.length; ++j)namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
            namebuf = namebuf.slice(0, namebuf.l);
            crcs[fcnt] = $3ee4f50b1ae43a89$var$CRC32.buf(/*::((*/ fi.content /*::||[]):any)*/ , 0);
            var outbuf = fi.content /*::||[]*/ ;
            if (method == 8) outbuf = _deflateRawSync(outbuf);
            /* local file header */ o = $3ee4f50b1ae43a89$var$new_buf(30);
            o.write_shift(4, 0x04034b50);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            /* TODO: last mod file time/date */ if (fi.mt) write_dos_date(o, fi.mt);
            else o.write_shift(4, 0);
            o.write_shift(-4, flags & 8 ? 0 : crcs[fcnt]);
            o.write_shift(4, flags & 8 ? 0 : outbuf.length);
            o.write_shift(4, flags & 8 ? 0 : /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            start_cd += o.length;
            out.push(o);
            start_cd += namebuf.length;
            out.push(namebuf);
            /* TODO: extra fields? */ /* TODO: encryption header ? */ start_cd += outbuf.length;
            out.push(outbuf);
            /* data descriptor */ if (flags & 8) {
                o = $3ee4f50b1ae43a89$var$new_buf(12);
                o.write_shift(-4, crcs[fcnt]);
                o.write_shift(4, outbuf.length);
                o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
                start_cd += o.l;
                out.push(o);
            }
            /* central directory */ o = $3ee4f50b1ae43a89$var$new_buf(46);
            o.write_shift(4, 0x02014b50);
            o.write_shift(2, 0);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            o.write_shift(4, 0); /* TODO: last mod file time/date */ 
            o.write_shift(-4, crcs[fcnt]);
            o.write_shift(4, outbuf.length);
            o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(4, 0);
            o.write_shift(4, start);
            sz_cd += o.l;
            cdirs.push(o);
            sz_cd += namebuf.length;
            cdirs.push(namebuf);
            ++fcnt;
        }
        /* end of central directory */ o = $3ee4f50b1ae43a89$var$new_buf(22);
        o.write_shift(4, 0x06054b50);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, fcnt);
        o.write_shift(2, fcnt);
        o.write_shift(4, sz_cd);
        o.write_shift(4, start_cd);
        o.write_shift(2, 0);
        return $3ee4f50b1ae43a89$var$bconcat([
            $3ee4f50b1ae43a89$var$bconcat(out /*:any*/ ),
            $3ee4f50b1ae43a89$var$bconcat(cdirs),
            o
        ]);
    }
    var ContentTypeMap = {
        "htm": "text/html",
        "xml": "text/xml",
        "gif": "image/gif",
        "jpg": "image/jpeg",
        "png": "image/png",
        "mso": "application/x-mso",
        "thmx": "application/vnd.ms-officetheme",
        "sh33tj5": "application/octet-stream"
    } /*:any*/ ;
    function get_content_type(fi /*:CFBEntry*/ , fp /*:string*/ ) /*:string*/ {
        if (fi.ctype) return fi.ctype;
        var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
        if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        if (fp) {
            m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
            if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        }
        return "application/octet-stream";
    }
    /* 76 character chunks TODO: intertwine encoding */ function write_base64_76(bstr /*:string*/ ) /*:string*/ {
        var data = $3ee4f50b1ae43a89$var$Base64_encode(bstr);
        var o = [];
        for(var i = 0; i < data.length; i += 76)o.push(data.slice(i, i + 76));
        return o.join("\r\n") + "\r\n";
    }
    /*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/ function write_quoted_printable(text /*:string*/ ) /*:string*/ {
        var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
            var w = c.charCodeAt(0).toString(16).toUpperCase();
            return "=" + (w.length == 1 ? "0" + w : w);
        });
        encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
        if (encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
        encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
        var o /*:Array<string>*/  = [], split = encoded.split("\r\n");
        for(var si = 0; si < split.length; ++si){
            var str = split[si];
            if (str.length == 0) {
                o.push("");
                continue;
            }
            for(var i = 0; i < str.length;){
                var end = 76;
                var tmp = str.slice(i, i + end);
                if (tmp.charAt(end - 1) == "=") end--;
                else if (tmp.charAt(end - 2) == "=") end -= 2;
                else if (tmp.charAt(end - 3) == "=") end -= 3;
                tmp = str.slice(i, i + end);
                i += end;
                if (i < str.length) tmp += "=";
                o.push(tmp);
            }
        }
        return o.join("\r\n");
    }
    function parse_quoted_printable(data /*:Array<string>*/ ) /*:RawBytes*/ {
        var o = [];
        /* unify long lines */ for(var di = 0; di < data.length; ++di){
            var line = data[di];
            while(di <= data.length && line.charAt(line.length - 1) == "=")line = line.slice(0, line.length - 1) + data[++di];
            o.push(line);
        }
        /* decode */ for(var oi = 0; oi < o.length; ++oi)o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) {
            return String.fromCharCode(parseInt($$.slice(1), 16));
        });
        return $3ee4f50b1ae43a89$var$s2a(o.join("\r\n"));
    }
    function parse_mime(cfb /*:CFBContainer*/ , data /*:Array<string>*/ , root /*:string*/ ) /*:void*/ {
        var fname = "", cte = "", ctype = "", fdata;
        var di = 0;
        for(; di < 10; ++di){
            var line = data[di];
            if (!line || line.match(/^\s*$/)) break;
            var m = line.match(/^(.*?):\s*([^\s].*)$/);
            if (m) switch(m[1].toLowerCase()){
                case "content-location":
                    fname = m[2].trim();
                    break;
                case "content-type":
                    ctype = m[2].trim();
                    break;
                case "content-transfer-encoding":
                    cte = m[2].trim();
                    break;
            }
        }
        ++di;
        switch(cte.toLowerCase()){
            case "base64":
                fdata = $3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$Base64_decode(data.slice(di).join("")));
                break;
            case "quoted-printable":
                fdata = parse_quoted_printable(data.slice(di));
                break;
            default:
                throw new Error("Unsupported Content-Transfer-Encoding " + cte);
        }
        var file = cfb_add(cfb, fname.slice(root.length), fdata, {
            unsafe: true
        });
        if (ctype) file.ctype = ctype;
    }
    function parse_mad(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (a2s(file.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
        var root = options && options.root || "";
        // $FlowIgnore
        var data = ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
        var di = 0, row = "";
        /* if root is not specified, scan for the common prefix */ for(di = 0; di < data.length; ++di){
            row = data[di];
            if (!/^Content-Location:/i.test(row)) continue;
            row = row.slice(row.indexOf("file"));
            if (!root) root = row.slice(0, row.lastIndexOf("/") + 1);
            if (row.slice(0, root.length) == root) continue;
            while(root.length > 0){
                root = root.slice(0, root.length - 1);
                root = root.slice(0, root.lastIndexOf("/") + 1);
                if (row.slice(0, root.length) == root) break;
            }
        }
        var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
        if (!mboundary) throw new Error("MAD cannot find boundary");
        var boundary = "--" + (mboundary[1] || "");
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o);
        var start_di, fcnt = 0;
        for(di = 0; di < data.length; ++di){
            var line = data[di];
            if (line !== boundary && line !== boundary + "--") continue;
            if (fcnt++) parse_mime(o, data.slice(start_di, di), root);
            start_di = di;
        }
        return o;
    }
    function write_mad(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:string*/ {
        var opts = options || {};
        var boundary = opts.boundary || "SheetJS";
        boundary = "------=" + boundary;
        var out = [
            "MIME-Version: 1.0",
            'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
            "",
            "",
            ""
        ];
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        for(var i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\x01Sh33tJ5") continue;
            /* Normalize filename */ fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
                return "_x" + c.charCodeAt(0).toString(16) + "_";
            }).replace(/[\u0080-\uFFFF]/g, function(u) {
                return "_u" + u.charCodeAt(0).toString(16) + "_";
            });
            /* Extract content as binary string */ var ca = fi.content;
            // $FlowIgnore
            var cstr = $3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
            /* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */ var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
            for(var csl = 0; csl <= L; ++csl)if ((cc = cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
            var qp = dispcnt >= L * 4 / 5;
            out.push(boundary);
            out.push("Content-Location: " + (opts.root || "file:///C:/SheetJS/") + fp);
            out.push("Content-Transfer-Encoding: " + (qp ? "quoted-printable" : "base64"));
            out.push("Content-Type: " + get_content_type(fi, fp));
            out.push("");
            out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
        }
        out.push(boundary + "--\r\n");
        return out.join("\r\n");
    }
    function cfb_new(opts /*:?any*/ ) /*:CFBContainer*/ {
        var o /*:CFBContainer*/  = {} /*:any*/ ;
        init_cfb(o, opts);
        return o;
    }
    function cfb_add(cfb /*:CFBContainer*/ , name /*:string*/ , content /*:?RawBytes*/ , opts /*:?any*/ ) /*:CFBEntry*/ {
        var unsafe = opts && opts.unsafe;
        if (!unsafe) init_cfb(cfb);
        var file = !unsafe && $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, name);
        if (!file) {
            var fpath /*:string*/  = cfb.FullPaths[0];
            if (name.slice(0, fpath.length) == fpath) fpath = name;
            else {
                if (fpath.slice(-1) != "/") fpath += "/";
                fpath = (fpath + name).replace("//", "/");
            }
            file = {
                name: filename(name),
                type: 2
            } /*:any*/ ;
            cfb.FileIndex.push(file);
            cfb.FullPaths.push(fpath);
            if (!unsafe) $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_gc(cfb);
        }
        /*:: if(!file) throw new Error("unreachable"); */ file.content = content /*:any*/ ;
        file.size = content ? content.length : 0;
        if (opts) {
            if (opts.CLSID) file.clsid = opts.CLSID;
            if (opts.mt) file.mt = opts.mt;
            if (opts.ct) file.ct = opts.ct;
        }
        return file;
    }
    function cfb_del(cfb /*:CFBContainer*/ , name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex.splice(j, 1);
                cfb.FullPaths.splice(j, 1);
                return true;
            }
        }
        return false;
    }
    function cfb_mov(cfb /*:CFBContainer*/ , old_name /*:string*/ , new_name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, old_name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex[j].name = filename(new_name);
                cfb.FullPaths[j] = new_name;
                return true;
            }
        }
        return false;
    }
    function cfb_gc(cfb /*:CFBContainer*/ ) /*:void*/ {
        rebuild_cfb(cfb, true);
    }
    exports.find = find;
    exports.read = read;
    exports.parse = parse;
    exports.write = write;
    exports.writeFile = write_file;
    exports.utils = {
        cfb_new: cfb_new,
        cfb_add: cfb_add,
        cfb_del: cfb_del,
        cfb_mov: cfb_mov,
        cfb_gc: cfb_gc,
        ReadShift: $3ee4f50b1ae43a89$var$ReadShift,
        CheckField: $3ee4f50b1ae43a89$var$CheckField,
        prep_blob: $3ee4f50b1ae43a89$var$prep_blob,
        bconcat: $3ee4f50b1ae43a89$var$bconcat,
        use_zlib: use_zlib,
        _deflateRaw: _deflate,
        _inflateRaw: _inflate,
        consts: consts
    };
    return exports;
}();
let $3ee4f50b1ae43a89$var$_fs = void 0;
function $3ee4f50b1ae43a89$export$a48eb669e1768bcf(fs) {
    $3ee4f50b1ae43a89$var$_fs = fs;
}
/* normalize data for blob ctor */ function $3ee4f50b1ae43a89$var$blobify(data) {
    if (typeof data === "string") return $3ee4f50b1ae43a89$var$s2ab(data);
    if (Array.isArray(data)) return $3ee4f50b1ae43a89$var$a2u(data);
    return data;
}
/* write or download file */ function $3ee4f50b1ae43a89$var$write_dl(fname /*:string*/ , payload /*:any*/ , enc /*:?string*/ ) {
    /*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */ if (typeof $3ee4f50b1ae43a89$var$_fs !== "undefined" && $3ee4f50b1ae43a89$var$_fs.writeFileSync) return enc ? $3ee4f50b1ae43a89$var$_fs.writeFileSync(fname, payload, enc) : $3ee4f50b1ae43a89$var$_fs.writeFileSync(fname, payload);
    if (typeof Deno !== "undefined") {
        /* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */ if (enc && typeof payload == "string") switch(enc){
            case "utf8":
                payload = new TextEncoder(enc).encode(payload);
                break;
            case "binary":
                payload = $3ee4f50b1ae43a89$var$s2ab(payload);
                break;
            /* TODO: binary equivalent */ default:
                throw new Error("Unsupported encoding " + enc);
        }
        return Deno.writeFileSync(fname, payload);
    }
    var data = enc == "utf8" ? $3ee4f50b1ae43a89$var$utf8write(payload) : payload;
    /*:: declare var IE_SaveFile: any; */ if (typeof IE_SaveFile !== "undefined") return IE_SaveFile(data, fname);
    if (typeof Blob !== "undefined") {
        var blob = new Blob([
            $3ee4f50b1ae43a89$var$blobify(data)
        ], {
            type: "application/octet-stream"
        });
        /*:: declare var navigator: any; */ if (typeof navigator !== "undefined" && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
        /*:: declare var saveAs: any; */ if (typeof saveAs !== "undefined") return saveAs(blob, fname);
        if (typeof URL !== "undefined" && typeof document !== "undefined" && document.createElement && URL.createObjectURL) {
            var url = URL.createObjectURL(blob);
            /*:: declare var chrome: any; */ if (typeof chrome === "object" && typeof (chrome.downloads || {}).download == "function") {
                if (URL.revokeObjectURL && typeof setTimeout !== "undefined") setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return chrome.downloads.download({
                    url: url,
                    filename: fname,
                    saveAs: true
                });
            }
            var a = document.createElement("a");
            if (a.download != null) {
                /*:: if(document.body == null) throw new Error("unreachable"); */ a.download = fname;
                a.href = url;
                document.body.appendChild(a);
                a.click();
                /*:: if(document.body == null) throw new Error("unreachable"); */ document.body.removeChild(a);
                if (URL.revokeObjectURL && typeof setTimeout !== "undefined") setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return url;
            }
        }
    }
    // $FlowIgnore
    if (typeof $ !== "undefined" && typeof File !== "undefined" && typeof Folder !== "undefined") try {
        // $FlowIgnore
        var out = File(fname);
        out.open("w");
        out.encoding = "binary";
        if (Array.isArray(payload)) payload = $3ee4f50b1ae43a89$var$a2s(payload);
        out.write(payload);
        out.close();
        return payload;
    } catch (e) {
        if (!e.message || !e.message.match(/onstruct/)) throw e;
    }
    throw new Error("cannot save file " + fname);
}
/* read binary data from file */ function $3ee4f50b1ae43a89$var$read_binary(path /*:string*/ ) {
    if (typeof $3ee4f50b1ae43a89$var$_fs !== "undefined") return $3ee4f50b1ae43a89$var$_fs.readFileSync(path);
    if (typeof Deno !== "undefined") return Deno.readFileSync(path);
    // $FlowIgnore
    if (typeof $ !== "undefined" && typeof File !== "undefined" && typeof Folder !== "undefined") try {
        // $FlowIgnore
        var infile = File(path);
        infile.open("r");
        infile.encoding = "binary";
        var data = infile.read();
        infile.close();
        return data;
    } catch (e) {
        if (!e.message || !e.message.match(/onstruct/)) throw e;
    }
    throw new Error("Cannot access file " + path);
}
function $3ee4f50b1ae43a89$var$keys(o /*:any*/ ) /*:Array<any>*/ {
    var ks = Object.keys(o), o2 = [];
    for(var i = 0; i < ks.length; ++i)if (Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
    return o2;
}
function $3ee4f50b1ae43a89$var$evert_key(obj /*:any*/ , key /*:string*/ ) /*:EvertType*/ {
    var o = [], K = $3ee4f50b1ae43a89$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)if (o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
    return o;
}
function $3ee4f50b1ae43a89$var$evert(obj /*:any*/ ) /*:EvertType*/ {
    var o = [], K = $3ee4f50b1ae43a89$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = K[i];
    return o;
}
function $3ee4f50b1ae43a89$var$evert_num(obj /*:any*/ ) /*:EvertNumType*/ {
    var o = [], K = $3ee4f50b1ae43a89$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = parseInt(K[i], 10);
    return o;
}
function $3ee4f50b1ae43a89$var$evert_arr(obj /*:any*/ ) /*:EvertArrType*/ {
    var o /*:EvertArrType*/  = [], K = $3ee4f50b1ae43a89$var$keys(obj);
    for(var i = 0; i !== K.length; ++i){
        if (o[obj[K[i]]] == null) o[obj[K[i]]] = [];
        o[obj[K[i]]].push(K[i]);
    }
    return o;
}
var $3ee4f50b1ae43a89$var$basedate = /*#__PURE__*/ new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
function $3ee4f50b1ae43a89$var$datenum(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    if (date1904) epoch -= 126316800000;
    var dnthresh = /*#__PURE__*/ $3ee4f50b1ae43a89$var$basedate.getTime() + /*#__PURE__*/ (v.getTimezoneOffset() - /*#__PURE__*/ $3ee4f50b1ae43a89$var$basedate.getTimezoneOffset()) * 60000;
    return (epoch - dnthresh) / 86400000;
}
var $3ee4f50b1ae43a89$var$refdate = /*#__PURE__*/ new Date();
var $3ee4f50b1ae43a89$var$dnthresh = /*#__PURE__*/ $3ee4f50b1ae43a89$var$basedate.getTime() + /*#__PURE__*/ ($3ee4f50b1ae43a89$var$refdate.getTimezoneOffset() - /*#__PURE__*/ $3ee4f50b1ae43a89$var$basedate.getTimezoneOffset()) * 60000;
var $3ee4f50b1ae43a89$var$refoffset = /*#__PURE__*/ $3ee4f50b1ae43a89$var$refdate.getTimezoneOffset();
function $3ee4f50b1ae43a89$var$numdate(v /*:number*/ ) /*:Date*/ {
    var out = new Date();
    out.setTime(v * 86400000 + $3ee4f50b1ae43a89$var$dnthresh);
    if (out.getTimezoneOffset() !== $3ee4f50b1ae43a89$var$refoffset) out.setTime(out.getTime() + (out.getTimezoneOffset() - $3ee4f50b1ae43a89$var$refoffset) * 60000);
    return out;
}
/* ISO 8601 Duration */ function $3ee4f50b1ae43a89$var$parse_isodur(s) {
    var sec = 0, mt = 0, time = false;
    var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
    if (!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
    for(var i = 1; i != m.length; ++i){
        if (!m[i]) continue;
        mt = 1;
        if (i > 3) time = true;
        switch(m[i].slice(m[i].length - 1)){
            case "Y":
                throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length - 1));
            case "D":
                mt *= 24;
            /* falls through */ case "H":
                mt *= 60;
            /* falls through */ case "M":
                if (!time) throw new Error("Unsupported ISO Duration Field: M");
                else mt *= 60;
            /* falls through */ case "S":
                break;
        }
        sec += mt * parseInt(m[i], 10);
    }
    return sec;
}
var $3ee4f50b1ae43a89$var$good_pd_date_1 = /*#__PURE__*/ new Date("2017-02-19T19:06:09.000Z");
var $3ee4f50b1ae43a89$var$good_pd_date = /*#__PURE__*/ isNaN(/*#__PURE__*/ $3ee4f50b1ae43a89$var$good_pd_date_1.getFullYear()) ? /*#__PURE__*/ new Date("2/19/17") : $3ee4f50b1ae43a89$var$good_pd_date_1;
var $3ee4f50b1ae43a89$var$good_pd = /*#__PURE__*/ $3ee4f50b1ae43a89$var$good_pd_date.getFullYear() == 2017;
/* parses a date as a local date */ function $3ee4f50b1ae43a89$var$parseDate(str /*:string|Date*/ , fixdate /*:?number*/ ) /*:Date*/ {
    var d = new Date(str);
    if ($3ee4f50b1ae43a89$var$good_pd) {
        /*:: if(fixdate == null) fixdate = 0; */ if (fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60000);
        else if (fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60000);
        return d;
    }
    if (str instanceof Date) return str;
    if ($3ee4f50b1ae43a89$var$good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
        var s = d.getFullYear();
        if (str.indexOf("" + s) > -1) return d;
        d.setFullYear(d.getFullYear() + 100);
        return d;
    }
    var n = str.match(/\d+/g) || [
        "2017",
        "2",
        "19",
        "0",
        "0",
        "0"
    ];
    var out = new Date(+n[0], +n[1] - 1, +n[2], +n[3] || 0, +n[4] || 0, +n[5] || 0);
    if (str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60000);
    return out;
}
function $3ee4f50b1ae43a89$var$cc2str(arr /*:Array<number>*/ , debomit) /*:string*/ {
    if ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(arr)) {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $3ee4f50b1ae43a89$var$utf8write(arr.slice(2).toString("utf16le"));
            if (arr[1] == 0xFE && arr[2] == 0xFF) return $3ee4f50b1ae43a89$var$utf8write($3ee4f50b1ae43a89$var$utf16beread(arr.slice(2).toString("binary")));
        }
        return arr.toString("binary");
    }
    if (typeof TextDecoder !== "undefined") try {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $3ee4f50b1ae43a89$var$utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
            if (arr[0] == 0xFE && arr[1] == 0xFF) return $3ee4f50b1ae43a89$var$utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
        }
        var rev = {
            "\u20AC": "\x80",
            "\u201A": "\x82",
            "\u0192": "\x83",
            "\u201E": "\x84",
            "\u2026": "\x85",
            "\u2020": "\x86",
            "\u2021": "\x87",
            "\u02C6": "\x88",
            "\u2030": "\x89",
            "\u0160": "\x8a",
            "\u2039": "\x8b",
            "\u0152": "\x8c",
            "\u017D": "\x8e",
            "\u2018": "\x91",
            "\u2019": "\x92",
            "\u201C": "\x93",
            "\u201D": "\x94",
            "\u2022": "\x95",
            "\u2013": "\x96",
            "\u2014": "\x97",
            "\u02DC": "\x98",
            "\u2122": "\x99",
            "\u0161": "\x9a",
            "\u203A": "\x9b",
            "\u0153": "\x9c",
            "\u017E": "\x9e",
            "\u0178": "\x9f"
        };
        if (Array.isArray(arr)) arr = new Uint8Array(arr);
        return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) {
            return rev[c] || c;
        });
    } catch (e) {}
    var o = [];
    for(var i = 0; i != arr.length; ++i)o.push(String.fromCharCode(arr[i]));
    return o.join("");
}
function $3ee4f50b1ae43a89$var$dup(o /*:any*/ ) /*:any*/ {
    if (typeof JSON != "undefined" && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
    if (typeof o != "object" || o == null) return o;
    if (o instanceof Date) return new Date(o.getTime());
    var out = {};
    for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = $3ee4f50b1ae43a89$var$dup(o[k]);
    return out;
}
function $3ee4f50b1ae43a89$var$fill(c /*:string*/ , l /*:number*/ ) /*:string*/ {
    var o = "";
    while(o.length < l)o += c;
    return o;
}
/* TODO: stress test */ function $3ee4f50b1ae43a89$var$fuzzynum(s /*:string*/ ) /*:number*/ {
    var v /*:number*/  = Number(s);
    if (!isNaN(v)) return isFinite(v) ? v : NaN;
    if (!/\d/.test(s)) return v;
    var wt = 1;
    var ss = s.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
        wt *= 100;
        return "";
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    ss = ss.replace(/[(](.*)[)]/, function($$, $1) {
        wt = -wt;
        return $1;
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    return v;
}
var $3ee4f50b1ae43a89$var$lower_months = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
];
function $3ee4f50b1ae43a89$var$fuzzydate(s /*:string*/ ) /*:Date*/ {
    var o = new Date(s), n = new Date(NaN);
    var y = o.getYear(), m = o.getMonth(), d = o.getDate();
    if (isNaN(d)) return n;
    var lower = s.toLowerCase();
    if (lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
        lower = lower.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, "");
        if (lower.length > 3 && $3ee4f50b1ae43a89$var$lower_months.indexOf(lower) == -1) return n;
    } else if (lower.match(/[a-z]/)) return n;
    if (y < 0 || y > 8099) return n;
    if ((m > 0 || d > 1) && y != 101) return o;
    if (s.match(/[^-0-9:,\/\\]/)) return n;
    return o;
}
var $3ee4f50b1ae43a89$var$split_regex = /*#__PURE__*/ function() {
    var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
    return function split_regex(str /*:string*/ , re, def /*:string*/ ) /*:Array<string>*/ {
        if (safe_split_regex || typeof re == "string") return str.split(re);
        var p = str.split(re), o = [
            p[0]
        ];
        for(var i = 1; i < p.length; ++i){
            o.push(def);
            o.push(p[i]);
        }
        return o;
    };
}();
function $3ee4f50b1ae43a89$var$getdatastr(data) /*:?string*/ {
    if (!data) return null;
    if (data.content && data.type) return $3ee4f50b1ae43a89$var$cc2str(data.content, true);
    if (data.data) return $3ee4f50b1ae43a89$var$debom(data.data);
    if (data.asNodeBuffer && $3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$var$debom(data.asNodeBuffer().toString("binary"));
    if (data.asBinary) return $3ee4f50b1ae43a89$var$debom(data.asBinary());
    if (data._data && data._data.getContent) return $3ee4f50b1ae43a89$var$debom($3ee4f50b1ae43a89$var$cc2str(Array.prototype.slice.call(data._data.getContent(), 0)));
    return null;
}
function $3ee4f50b1ae43a89$var$getdatabin(data) {
    if (!data) return null;
    if (data.data) return $3ee4f50b1ae43a89$var$char_codes(data.data);
    if (data.asNodeBuffer && $3ee4f50b1ae43a89$var$has_buf) return data.asNodeBuffer();
    if (data._data && data._data.getContent) {
        var o = data._data.getContent();
        if (typeof o == "string") return $3ee4f50b1ae43a89$var$char_codes(o);
        return Array.prototype.slice.call(o);
    }
    if (data.content && data.type) return data.content;
    return null;
}
function $3ee4f50b1ae43a89$var$getdata(data) {
    return data && data.name.slice(-4) === ".bin" ? $3ee4f50b1ae43a89$var$getdatabin(data) : $3ee4f50b1ae43a89$var$getdatastr(data);
}
/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */ /* OASIS does not comment on filename case sensitivity */ function $3ee4f50b1ae43a89$var$safegetzipfile(zip, file /*:string*/ ) {
    var k = zip.FullPaths || $3ee4f50b1ae43a89$var$keys(zip.files);
    var f = file.toLowerCase().replace(/[\/]/g, "\\"), g = f.replace(/\\/g, "/");
    for(var i = 0; i < k.length; ++i){
        var n = k[i].replace(/^Root Entry[\/]/, "").toLowerCase();
        if (f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
    }
    return null;
}
function $3ee4f50b1ae43a89$var$getzipfile(zip, file /*:string*/ ) {
    var o = $3ee4f50b1ae43a89$var$safegetzipfile(zip, file);
    if (o == null) throw new Error("Cannot find file " + file + " in zip");
    return o;
}
function $3ee4f50b1ae43a89$var$getzipdata(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $3ee4f50b1ae43a89$var$getdata($3ee4f50b1ae43a89$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $3ee4f50b1ae43a89$var$getzipdata(zip, file);
    } catch (e) {
        return null;
    }
}
function $3ee4f50b1ae43a89$var$getzipstr(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:?string*/ {
    if (!safe) return $3ee4f50b1ae43a89$var$getdatastr($3ee4f50b1ae43a89$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $3ee4f50b1ae43a89$var$getzipstr(zip, file);
    } catch (e) {
        return null;
    }
}
function $3ee4f50b1ae43a89$var$getzipbin(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $3ee4f50b1ae43a89$var$getdatabin($3ee4f50b1ae43a89$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $3ee4f50b1ae43a89$var$getzipbin(zip, file);
    } catch (e) {
        return null;
    }
}
function $3ee4f50b1ae43a89$var$zipentries(zip) {
    var k = zip.FullPaths || $3ee4f50b1ae43a89$var$keys(zip.files), o = [];
    for(var i = 0; i < k.length; ++i)if (k[i].slice(-1) != "/") o.push(k[i].replace(/^Root Entry[\/]/, ""));
    return o.sort();
}
function $3ee4f50b1ae43a89$var$zip_add_file(zip, path, content) {
    if (zip.FullPaths) {
        if (typeof content == "string") {
            var res;
            if ($3ee4f50b1ae43a89$var$has_buf) res = $3ee4f50b1ae43a89$var$Buffer_from(content);
            else res = $3ee4f50b1ae43a89$var$utf8decode(content);
            return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(zip, path, res);
        }
        $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(zip, path, content);
    } else zip.file(path, content);
}
function $3ee4f50b1ae43a89$var$zip_new() {
    return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_new();
}
function $3ee4f50b1ae43a89$var$zip_read(d, o) {
    switch(o.type){
        case "base64":
            return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(d, {
                type: "base64"
            });
        case "binary":
            return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(d, {
                type: "binary"
            });
        case "buffer":
        case "array":
            return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(d, {
                type: "buffer"
            });
    }
    throw new Error("Unrecognized type " + o.type);
}
function $3ee4f50b1ae43a89$var$resolve_path(path /*:string*/ , base /*:string*/ ) /*:string*/ {
    if (path.charAt(0) == "/") return path.slice(1);
    var result = base.split("/");
    if (base.slice(-1) != "/") result.pop(); // folder path
    var target = path.split("/");
    while(target.length !== 0){
        var step = target.shift();
        if (step === "..") result.pop();
        else if (step !== ".") result.push(step);
    }
    return result.join("/");
}
var $3ee4f50b1ae43a89$var$XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var $3ee4f50b1ae43a89$var$attregexg = /([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var $3ee4f50b1ae43a89$var$tagregex1 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, $3ee4f50b1ae43a89$var$tagregex2 = /<[^>]*>/g;
var $3ee4f50b1ae43a89$var$tagregex = /*#__PURE__*/ $3ee4f50b1ae43a89$var$XML_HEADER.match($3ee4f50b1ae43a89$var$tagregex1) ? $3ee4f50b1ae43a89$var$tagregex1 : $3ee4f50b1ae43a89$var$tagregex2;
var $3ee4f50b1ae43a89$var$nsregex = /<\w*:/, $3ee4f50b1ae43a89$var$nsregex2 = /<(\/?)\w+:/;
function $3ee4f50b1ae43a89$var$parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($3ee4f50b1ae43a89$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i];
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        for(j = 0; j != q.length; ++j)if (q.charCodeAt(j) === 58) break;
        if (j === q.length) {
            if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
            z[q] = v;
            if (!skip_LC) z[q.toLowerCase()] = v;
        } else {
            var k = (j === 5 && q.slice(0, 5) === "xmlns" ? "xmlns" : "") + q.slice(j + 1);
            if (z[k] && q.slice(j - 3, j) == "ext") continue; // from ods
            z[k] = v;
            if (!skip_LC) z[k.toLowerCase()] = v;
        }
    }
    return z;
}
function $3ee4f50b1ae43a89$var$strip_ns(x /*:string*/ ) /*:string*/ {
    return x.replace($3ee4f50b1ae43a89$var$nsregex2, "<$1");
}
var $3ee4f50b1ae43a89$var$encodings = {
    "&quot;": '"',
    "&apos;": "'",
    "&gt;": ">",
    "&lt;": "<",
    "&amp;": "&"
};
var $3ee4f50b1ae43a89$var$rencoding = /*#__PURE__*/ $3ee4f50b1ae43a89$var$evert($3ee4f50b1ae43a89$var$encodings);
//var rencstr = "&<>'\"".split("");
// TODO: CP remap (need to read file version to determine OS)
var $3ee4f50b1ae43a89$var$unescapexml /*:StringConv*/  = /*#__PURE__*/ function() {
    /* 22.4.2.4 bstr (Basic String) */ var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
    return function unescapexml(text /*:string*/ ) /*:string*/ {
        var s = text + "", i = s.indexOf("<![CDATA[");
        if (i == -1) return s.replace(encregex, function($$, $1) {
            return $3ee4f50b1ae43a89$var$encodings[$$] || String.fromCharCode(parseInt($1, $$.indexOf("x") > -1 ? 16 : 10)) || $$;
        }).replace(coderegex, function(m, c) {
            return String.fromCharCode(parseInt(c, 16));
        });
        var j = s.indexOf("]]>");
        return unescapexml(s.slice(0, i)) + s.slice(i + 9, j) + unescapexml(s.slice(j + 3));
    };
}();
var $3ee4f50b1ae43a89$var$decregex = /[&<>'"]/g, $3ee4f50b1ae43a89$var$charegex = /[\u0000-\u0008\u000b-\u001f]/g;
function $3ee4f50b1ae43a89$var$escapexml(text /*:string*/ ) /*:string*/ {
    var s = text + "";
    return s.replace($3ee4f50b1ae43a89$var$decregex, function(y) {
        return $3ee4f50b1ae43a89$var$rencoding[y];
    }).replace($3ee4f50b1ae43a89$var$charegex, function(s) {
        return "_x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + "_";
    });
}
function $3ee4f50b1ae43a89$var$escapexmltag(text /*:string*/ ) /*:string*/ {
    return $3ee4f50b1ae43a89$var$escapexml(text).replace(/ /g, "_x0020_");
}
var $3ee4f50b1ae43a89$var$htmlcharegex = /[\u0000-\u001f]/g;
function $3ee4f50b1ae43a89$var$escapehtml(text /*:string*/ ) /*:string*/ {
    var s = text + "";
    return s.replace($3ee4f50b1ae43a89$var$decregex, function(y) {
        return $3ee4f50b1ae43a89$var$rencoding[y];
    }).replace(/\n/g, "<br/>").replace($3ee4f50b1ae43a89$var$htmlcharegex, function(s) {
        return "&#x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + ";";
    });
}
function $3ee4f50b1ae43a89$var$escapexlml(text /*:string*/ ) /*:string*/ {
    var s = text + "";
    return s.replace($3ee4f50b1ae43a89$var$decregex, function(y) {
        return $3ee4f50b1ae43a89$var$rencoding[y];
    }).replace($3ee4f50b1ae43a89$var$htmlcharegex, function(s) {
        return "&#x" + s.charCodeAt(0).toString(16).toUpperCase() + ";";
    });
}
/* TODO: handle codepages */ var $3ee4f50b1ae43a89$var$xlml_fixstr /*:StringConv*/  = /*#__PURE__*/ function() {
    var entregex = /&#(\d+);/g;
    function entrepl($$ /*:string*/ , $1 /*:string*/ ) /*:string*/ {
        return String.fromCharCode(parseInt($1, 10));
    }
    return function xlml_fixstr(str /*:string*/ ) /*:string*/ {
        return str.replace(entregex, entrepl);
    };
}();
function $3ee4f50b1ae43a89$var$xlml_unfixstr(str /*:string*/ ) /*:string*/ {
    return str.replace(/(\r\n|[\r\n])/g, "&#10;");
}
function $3ee4f50b1ae43a89$var$parsexmlbool(value /*:any*/ ) /*:boolean*/ {
    switch(value){
        case 1:
        case true:
        case "1":
        case "true":
        case "TRUE":
            return true;
        /* case '0': case 'false': case 'FALSE':*/ default:
            return false;
    }
}
function $3ee4f50b1ae43a89$var$utf8reada(orig /*:string*/ ) /*:string*/ {
    var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        if (c < 128) {
            out += String.fromCharCode(c);
            continue;
        }
        d = orig.charCodeAt(i++);
        if (c > 191 && c < 224) {
            f = (c & 31) << 6;
            f |= d & 63;
            out += String.fromCharCode(f);
            continue;
        }
        e = orig.charCodeAt(i++);
        if (c < 240) {
            out += String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | e & 63);
            continue;
        }
        f = orig.charCodeAt(i++);
        w = ((c & 7) << 18 | (d & 63) << 12 | (e & 63) << 6 | f & 63) - 65536;
        out += String.fromCharCode(0xD800 + (w >>> 10 & 1023));
        out += String.fromCharCode(0xDC00 + (w & 1023));
    }
    return out;
}
function $3ee4f50b1ae43a89$var$utf8readb(data) {
    var out = $3ee4f50b1ae43a89$var$new_raw_buf(2 * data.length), w, i, j = 1, k = 0, ww = 0, c;
    for(i = 0; i < data.length; i += j){
        j = 1;
        if ((c = data.charCodeAt(i)) < 128) w = c;
        else if (c < 224) {
            w = (c & 31) * 64 + (data.charCodeAt(i + 1) & 63);
            j = 2;
        } else if (c < 240) {
            w = (c & 15) * 4096 + (data.charCodeAt(i + 1) & 63) * 64 + (data.charCodeAt(i + 2) & 63);
            j = 3;
        } else {
            j = 4;
            w = (c & 7) * 262144 + (data.charCodeAt(i + 1) & 63) * 4096 + (data.charCodeAt(i + 2) & 63) * 64 + (data.charCodeAt(i + 3) & 63);
            w -= 65536;
            ww = 0xD800 + (w >>> 10 & 1023);
            w = 0xDC00 + (w & 1023);
        }
        if (ww !== 0) {
            out[k++] = ww & 255;
            out[k++] = ww >>> 8;
            ww = 0;
        }
        out[k++] = w % 256;
        out[k++] = w >>> 8;
    }
    return out.slice(0, k).toString("ucs2");
}
function $3ee4f50b1ae43a89$var$utf8readc(data) {
    return $3ee4f50b1ae43a89$var$Buffer_from(data, "binary").toString("utf8");
}
var $3ee4f50b1ae43a89$var$utf8corpus = "foo bar baz\xe2\x98\x83\xf0\x9f\x8d\xa3";
var $3ee4f50b1ae43a89$var$utf8read = $3ee4f50b1ae43a89$var$has_buf && /*#__PURE__*/ ($3ee4f50b1ae43a89$var$utf8readc($3ee4f50b1ae43a89$var$utf8corpus) == /*#__PURE__*/ $3ee4f50b1ae43a89$var$utf8reada($3ee4f50b1ae43a89$var$utf8corpus) && $3ee4f50b1ae43a89$var$utf8readc || /*#__PURE__*/ $3ee4f50b1ae43a89$var$utf8readb($3ee4f50b1ae43a89$var$utf8corpus) == /*#__PURE__*/ $3ee4f50b1ae43a89$var$utf8reada($3ee4f50b1ae43a89$var$utf8corpus) && $3ee4f50b1ae43a89$var$utf8readb) || $3ee4f50b1ae43a89$var$utf8reada;
var $3ee4f50b1ae43a89$var$utf8write /*:StringConv*/  = $3ee4f50b1ae43a89$var$has_buf ? function(data) {
    return $3ee4f50b1ae43a89$var$Buffer_from(data, "utf8").toString("binary");
} : function(orig /*:string*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [], i = 0, c = 0, d = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        switch(true){
            case c < 128:
                out.push(String.fromCharCode(c));
                break;
            case c < 2048:
                out.push(String.fromCharCode(192 + (c >> 6)));
                out.push(String.fromCharCode(128 + (c & 63)));
                break;
            case c >= 55296 && c < 57344:
                c -= 55296;
                d = orig.charCodeAt(i++) - 56320 + (c << 10);
                out.push(String.fromCharCode(240 + (d >> 18 & 7)));
                out.push(String.fromCharCode(144 + (d >> 12 & 63)));
                out.push(String.fromCharCode(128 + (d >> 6 & 63)));
                out.push(String.fromCharCode(128 + (d & 63)));
                break;
            default:
                out.push(String.fromCharCode(224 + (c >> 12)));
                out.push(String.fromCharCode(128 + (c >> 6 & 63)));
                out.push(String.fromCharCode(128 + (c & 63)));
        }
    }
    return out.join("");
};
// matches <foo>...</foo> extracts content
var $3ee4f50b1ae43a89$var$matchtag = /*#__PURE__*/ function() {
    var mtcache /*:{[k:string]:RegExp}*/  = {} /*:any*/ ;
    return function matchtag(f /*:string*/ , g /*:?string*/ ) /*:RegExp*/ {
        var t = f + "|" + (g || "");
        if (mtcache[t]) return mtcache[t];
        return mtcache[t] = new RegExp("<(?:\\w+:)?" + f + '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' + f + ">", g || "");
    };
}();
var $3ee4f50b1ae43a89$var$htmldecode /*:{(s:string):string}*/  = /*#__PURE__*/ function() {
    var entities /*:Array<[RegExp, string]>*/  = [
        [
            "nbsp",
            " "
        ],
        [
            "middot",
            "\xb7"
        ],
        [
            "quot",
            '"'
        ],
        [
            "apos",
            "'"
        ],
        [
            "gt",
            ">"
        ],
        [
            "lt",
            "<"
        ],
        [
            "amp",
            "&"
        ]
    ].map(function(x /*:[string, string]*/ ) {
        return [
            new RegExp("&" + x[0] + ";", "ig"),
            x[1]
        ];
    });
    return function htmldecode(str /*:string*/ ) /*:string*/ {
        var o = str// Remove new lines and spaces from start of content
        .replace(/^[\t\n\r ]+/, "")// Remove new lines and spaces from end of content
        .replace(/[\t\n\r ]+$/, "")// Added line which removes any white space characters after and before html tags
        .replace(/>\s+/g, ">").replace(/\s+</g, "<")// Replace remaining new lines and spaces with space
        .replace(/[\t\n\r ]+/g, " ")// Replace <br> tags with new lines
        .replace(/<\s*[bB][rR]\s*\/?>/g, "\n")// Strip HTML elements
        .replace(/<[^>]*>/g, "");
        for(var i = 0; i < entities.length; ++i)o = o.replace(entities[i][0], entities[i][1]);
        return o;
    };
}();
var $3ee4f50b1ae43a89$var$vtregex = /*#__PURE__*/ function() {
    var vt_cache = {};
    return function vt_regex(bt) {
        if (vt_cache[bt] !== undefined) return vt_cache[bt];
        return vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", "g");
    };
}();
var $3ee4f50b1ae43a89$var$vtvregex = /<\/?(?:vt:)?variant>/g, $3ee4f50b1ae43a89$var$vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
function $3ee4f50b1ae43a89$var$parseVector(data /*:string*/ , opts) /*:Array<{v:string,t:string}>*/ {
    var h = $3ee4f50b1ae43a89$var$parsexmltag(data);
    var matches /*:Array<string>*/  = data.match($3ee4f50b1ae43a89$var$vtregex(h.baseType)) || [];
    var res /*:Array<any>*/  = [];
    if (matches.length != h.size) {
        if (opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
        return res;
    }
    matches.forEach(function(x /*:string*/ ) {
        var v = x.replace($3ee4f50b1ae43a89$var$vtvregex, "").match($3ee4f50b1ae43a89$var$vtmregex);
        if (v) res.push({
            v: $3ee4f50b1ae43a89$var$utf8read(v[2]),
            t: v[1]
        });
    });
    return res;
}
var $3ee4f50b1ae43a89$var$wtregex = /(^\s|\s$|\n)/;
function $3ee4f50b1ae43a89$var$writetag(f /*:string*/ , g /*:string*/ ) /*:string*/ {
    return "<" + f + (g.match($3ee4f50b1ae43a89$var$wtregex) ? ' xml:space="preserve"' : "") + ">" + g + "</" + f + ">";
}
function $3ee4f50b1ae43a89$var$wxt_helper(h) /*:string*/ {
    return $3ee4f50b1ae43a89$var$keys(h).map(function(k) {
        return " " + k + '="' + h[k] + '"';
    }).join("");
}
function $3ee4f50b1ae43a89$var$writextag(f /*:string*/ , g /*:?string*/ , h) {
    return "<" + f + (h != null ? $3ee4f50b1ae43a89$var$wxt_helper(h) : "") + (g != null ? (g.match($3ee4f50b1ae43a89$var$wtregex) ? ' xml:space="preserve"' : "") + ">" + g + "</" + f : "/") + ">";
}
function $3ee4f50b1ae43a89$var$write_w3cdtf(d /*:Date*/ , t /*:?boolean*/ ) /*:string*/ {
    try {
        return d.toISOString().replace(/\.\d*/, "");
    } catch (e) {
        if (t) throw e;
    }
    return "";
}
function $3ee4f50b1ae43a89$var$write_vt(s, xlsx /*:?boolean*/ ) /*:string*/ {
    switch(typeof s){
        case "string":
            var o = $3ee4f50b1ae43a89$var$writextag("vt:lpwstr", $3ee4f50b1ae43a89$var$escapexml(s));
            if (xlsx) o = o.replace(/&quot;/g, "_x0022_");
            return o;
        case "number":
            return $3ee4f50b1ae43a89$var$writextag((s | 0) == s ? "vt:i4" : "vt:r8", $3ee4f50b1ae43a89$var$escapexml(String(s)));
        case "boolean":
            return $3ee4f50b1ae43a89$var$writextag("vt:bool", s ? "true" : "false");
    }
    if (s instanceof Date) return $3ee4f50b1ae43a89$var$writextag("vt:filetime", $3ee4f50b1ae43a89$var$write_w3cdtf(s));
    throw new Error("Unable to serialize " + s);
}
function $3ee4f50b1ae43a89$var$xlml_normalize(d) /*:string*/ {
    if ($3ee4f50b1ae43a89$var$has_buf && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/ $3ee4f50b1ae43a89$require$Buffer.isBuffer(d)) return d.toString("utf8");
    if (typeof d === "string") return d;
    /* duktape */ if (typeof Uint8Array !== "undefined" && d instanceof Uint8Array) return $3ee4f50b1ae43a89$var$utf8read($3ee4f50b1ae43a89$var$a2s($3ee4f50b1ae43a89$var$ab2a(d)));
    throw new Error("Bad input format: expected Buffer or string");
}
/* UOS uses CJK in tags */ var $3ee4f50b1ae43a89$var$xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg;
//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
var $3ee4f50b1ae43a89$var$XMLNS = {
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
    CT: "http://schemas.openxmlformats.org/package/2006/content-types",
    RELS: "http://schemas.openxmlformats.org/package/2006/relationships",
    TCMNT: "http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments",
    "dc": "http://purl.org/dc/elements/1.1/",
    "dcterms": "http://purl.org/dc/terms/",
    "dcmitype": "http://purl.org/dc/dcmitype/",
    "mx": "http://schemas.microsoft.com/office/mac/excel/2008/main",
    "r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
    "sjs": "http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",
    "vt": "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",
    "xsi": "http://www.w3.org/2001/XMLSchema-instance",
    "xsd": "http://www.w3.org/2001/XMLSchema"
} /*:any*/ ;
var $3ee4f50b1ae43a89$var$XMLNS_main = [
    "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
    "http://purl.oclc.org/ooxml/spreadsheetml/main",
    "http://schemas.microsoft.com/office/excel/2006/main",
    "http://schemas.microsoft.com/office/excel/2006/2"
];
var $3ee4f50b1ae43a89$var$XLMLNS = {
    "o": "urn:schemas-microsoft-com:office:office",
    "x": "urn:schemas-microsoft-com:office:excel",
    "ss": "urn:schemas-microsoft-com:office:spreadsheet",
    "dt": "uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",
    "mv": "http://macVmlSchemaUri",
    "v": "urn:schemas-microsoft-com:vml",
    "html": "http://www.w3.org/TR/REC-html40"
} /*:any*/ ;
function $3ee4f50b1ae43a89$var$read_double_le(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var s = 1 - 2 * (b[idx + 7] >>> 7);
    var e = ((b[idx + 7] & 0x7f) << 4) + (b[idx + 6] >>> 4 & 0x0f);
    var m = b[idx + 6] & 0x0f;
    for(var i = 5; i >= 0; --i)m = m * 256 + b[idx + i];
    if (e == 0x7ff) return m == 0 ? s * Infinity : NaN;
    if (e == 0) e = -1022;
    else {
        e -= 1023;
        m += Math.pow(2, 52);
    }
    return s * Math.pow(2, e - 52) * m;
}
function $3ee4f50b1ae43a89$var$write_double_le(b /*:RawBytes|CFBlob*/ , v /*:number*/ , idx /*:number*/ ) {
    var bs = (v < 0 || 1 / v == -Infinity ? 1 : 0) << 7, e = 0, m = 0;
    var av = bs ? -v : v;
    if (!isFinite(av)) {
        e = 0x7ff;
        m = isNaN(v) ? 0x6969 : 0;
    } else if (av == 0) e = m = 0;
    else {
        e = Math.floor(Math.log(av) / Math.LN2);
        m = av * Math.pow(2, 52 - e);
        if (e <= -1023 && (!isFinite(m) || m < Math.pow(2, 52))) e = -1022;
        else {
            m -= Math.pow(2, 52);
            e += 1023;
        }
    }
    for(var i = 0; i <= 5; ++i, m /= 256)b[idx + i] = m & 0xff;
    b[idx + 6] = (e & 0x0f) << 4 | m & 0xf;
    b[idx + 7] = e >> 4 | bs;
}
var $3ee4f50b1ae43a89$var$___toBuffer = function(bufs /*:Array<Array<RawBytes> >*/ ) /*:RawBytes*/ {
    var x = [], w = 10240;
    for(var i = 0; i < bufs[0].length; ++i)if (bufs[0][i]) for(var j = 0, L = bufs[0][i].length; j < L; j += w)x.push.apply(x, bufs[0][i].slice(j, j + w));
    return x;
};
var $3ee4f50b1ae43a89$var$__toBuffer = $3ee4f50b1ae43a89$var$has_buf ? function(bufs) {
    return bufs[0].length > 0 && $3ee4f50b1ae43a89$require$Buffer.isBuffer(bufs[0][0]) ? $3ee4f50b1ae43a89$require$Buffer.concat(bufs[0].map(function(x) {
        return $3ee4f50b1ae43a89$require$Buffer.isBuffer(x) ? x : $3ee4f50b1ae43a89$var$Buffer_from(x);
    })) : $3ee4f50b1ae43a89$var$___toBuffer(bufs);
} : $3ee4f50b1ae43a89$var$___toBuffer;
var $3ee4f50b1ae43a89$var$___utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < e; i += 2)ss.push(String.fromCharCode($3ee4f50b1ae43a89$var$__readUInt16LE(b, i)));
    return ss.join("").replace($3ee4f50b1ae43a89$var$chr0, "");
};
var $3ee4f50b1ae43a89$var$__utf16le = $3ee4f50b1ae43a89$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return $3ee4f50b1ae43a89$var$___utf16le(b, s, e);
    return b.toString("utf16le", s, e).replace($3ee4f50b1ae43a89$var$chr0, "") /*.replace(chr1,'!')*/ ;
} : $3ee4f50b1ae43a89$var$___utf16le;
var $3ee4f50b1ae43a89$var$___hexlify = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < s + l; ++i)ss.push(("0" + b[i].toString(16)).slice(-2));
    return ss.join("");
};
var $3ee4f50b1ae43a89$var$__hexlify = $3ee4f50b1ae43a89$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    return $3ee4f50b1ae43a89$require$Buffer.isBuffer(b) ? b.toString("hex", s, s + l) : $3ee4f50b1ae43a89$var$___hexlify(b, s, l);
} : $3ee4f50b1ae43a89$var$___hexlify;
var $3ee4f50b1ae43a89$var$___utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    var ss = [];
    for(var i = s; i < e; i++)ss.push(String.fromCharCode($3ee4f50b1ae43a89$var$__readUInt8(b, i)));
    return ss.join("");
};
var $3ee4f50b1ae43a89$var$__utf8 = $3ee4f50b1ae43a89$var$has_buf ? function utf8_b(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    return $3ee4f50b1ae43a89$require$Buffer.isBuffer(b) ? b.toString("utf8", s, e) : $3ee4f50b1ae43a89$var$___utf8(b, s, e);
} : $3ee4f50b1ae43a89$var$___utf8;
var $3ee4f50b1ae43a89$var$___lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
    return len > 0 ? $3ee4f50b1ae43a89$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $3ee4f50b1ae43a89$var$__lpstr = $3ee4f50b1ae43a89$var$___lpstr;
var $3ee4f50b1ae43a89$var$___cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
    return len > 0 ? $3ee4f50b1ae43a89$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $3ee4f50b1ae43a89$var$__cpstr = $3ee4f50b1ae43a89$var$___cpstr;
var $3ee4f50b1ae43a89$var$___lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = 2 * $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
    return len > 0 ? $3ee4f50b1ae43a89$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $3ee4f50b1ae43a89$var$__lpwstr = $3ee4f50b1ae43a89$var$___lpwstr;
var $3ee4f50b1ae43a89$var$___lpp4 = function lpp4_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
    return len > 0 ? $3ee4f50b1ae43a89$var$__utf16le(b, i + 4, i + 4 + len) : "";
};
var $3ee4f50b1ae43a89$var$__lpp4 = $3ee4f50b1ae43a89$var$___lpp4;
var $3ee4f50b1ae43a89$var$___8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
    return len > 0 ? $3ee4f50b1ae43a89$var$__utf8(b, i + 4, i + 4 + len) : "";
};
var $3ee4f50b1ae43a89$var$__8lpp4 = $3ee4f50b1ae43a89$var$___8lpp4;
var $3ee4f50b1ae43a89$var$___double = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) {
    return $3ee4f50b1ae43a89$var$read_double_le(b, idx);
};
var $3ee4f50b1ae43a89$var$__double = $3ee4f50b1ae43a89$var$___double;
var $3ee4f50b1ae43a89$var$is_buf = function is_buf_a(a) {
    return Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
};
if ($3ee4f50b1ae43a89$var$has_buf /*:: && typeof Buffer !== 'undefined'*/ ) {
    $3ee4f50b1ae43a89$var$__lpstr = function lpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return $3ee4f50b1ae43a89$var$___lpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString("utf8", i + 4, i + 4 + len - 1) : "";
    };
    $3ee4f50b1ae43a89$var$__cpstr = function cpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return $3ee4f50b1ae43a89$var$___cpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString("utf8", i + 4, i + 4 + len - 1) : "";
    };
    $3ee4f50b1ae43a89$var$__lpwstr = function lpwstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return $3ee4f50b1ae43a89$var$___lpwstr(b, i);
        var len = 2 * b.readUInt32LE(i);
        return b.toString("utf16le", i + 4, i + 4 + len - 1);
    };
    $3ee4f50b1ae43a89$var$__lpp4 = function lpp4_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return $3ee4f50b1ae43a89$var$___lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString("utf16le", i + 4, i + 4 + len);
    };
    $3ee4f50b1ae43a89$var$__8lpp4 = function lpp4_8b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return $3ee4f50b1ae43a89$var$___8lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString("utf8", i + 4, i + 4 + len);
    };
    $3ee4f50b1ae43a89$var$__double = function double_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if ($3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return b.readDoubleLE(i);
        return $3ee4f50b1ae43a89$var$___double(b, i);
    };
    $3ee4f50b1ae43a89$var$is_buf = function is_buf_b(a) {
        return $3ee4f50b1ae43a89$require$Buffer.isBuffer(a) || Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
    };
}
/* from js-xls */ function $3ee4f50b1ae43a89$var$cpdoit() {
    $3ee4f50b1ae43a89$var$__utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $3ee4f50b1ae43a89$var$$cptable.utils.decode(1200, b.slice(s, e)).replace($3ee4f50b1ae43a89$var$chr0, "");
    };
    $3ee4f50b1ae43a89$var$__utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $3ee4f50b1ae43a89$var$$cptable.utils.decode(65001, b.slice(s, e));
    };
    $3ee4f50b1ae43a89$var$__lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
        return len > 0 ? $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_ansi, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $3ee4f50b1ae43a89$var$__cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
        return len > 0 ? $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_codepage, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $3ee4f50b1ae43a89$var$__lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = 2 * $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
        return len > 0 ? $3ee4f50b1ae43a89$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $3ee4f50b1ae43a89$var$__lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
        return len > 0 ? $3ee4f50b1ae43a89$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len)) : "";
    };
    $3ee4f50b1ae43a89$var$__8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
        return len > 0 ? $3ee4f50b1ae43a89$var$$cptable.utils.decode(65001, b.slice(i + 4, i + 4 + len)) : "";
    };
}
if (typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined") $3ee4f50b1ae43a89$var$cpdoit();
var $3ee4f50b1ae43a89$var$__readUInt8 = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx];
};
var $3ee4f50b1ae43a89$var$__readUInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 1] * 256 + b[idx];
};
var $3ee4f50b1ae43a89$var$__readInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var u = b[idx + 1] * 256 + b[idx];
    return u < 0x8000 ? u : (0xffff - u + 1) * -1;
};
var $3ee4f50b1ae43a89$var$__readUInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] * 16777216 + (b[idx + 2] << 16) + (b[idx + 1] << 8) + b[idx];
};
var $3ee4f50b1ae43a89$var$__readInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] << 24 | b[idx + 2] << 16 | b[idx + 1] << 8 | b[idx];
};
var $3ee4f50b1ae43a89$var$__readInt32BE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx] << 24 | b[idx + 1] << 16 | b[idx + 2] << 8 | b[idx + 3];
};
function $3ee4f50b1ae43a89$var$ReadShift(size /*:number*/ , t /*:?string*/ ) /*:number|string*/ {
    var o = "", oI /*:: :number = 0*/ , oR, oo = [], w, vv, i, loc;
    switch(t){
        case "dbcs":
            loc = this.l;
            if ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(this)) o = this.slice(this.l, this.l + 2 * size).toString("utf16le");
            else for(i = 0; i < size; ++i){
                o += String.fromCharCode($3ee4f50b1ae43a89$var$__readUInt16LE(this, loc));
                loc += 2;
            }
            size *= 2;
            break;
        case "utf8":
            o = $3ee4f50b1ae43a89$var$__utf8(this, this.l, this.l + size);
            break;
        case "utf16le":
            size *= 2;
            o = $3ee4f50b1ae43a89$var$__utf16le(this, this.l, this.l + size);
            break;
        case "wstr":
            if (typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined") o = $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_codepage, this.slice(this.l, this.l + 2 * size));
            else return $3ee4f50b1ae43a89$var$ReadShift.call(this, size, "dbcs");
            size = 2 * size;
            break;
        /* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */ case "lpstr-ansi":
            o = $3ee4f50b1ae43a89$var$__lpstr(this, this.l);
            size = 4 + $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
            break;
        case "lpstr-cp":
            o = $3ee4f50b1ae43a89$var$__cpstr(this, this.l);
            size = 4 + $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */ case "lpwstr":
            o = $3ee4f50b1ae43a89$var$__lpwstr(this, this.l);
            size = 4 + 2 * $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */ case "lpp4":
            size = 4 + $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
            o = $3ee4f50b1ae43a89$var$__lpp4(this, this.l);
            if (size & 0x02) size += 2;
            break;
        /* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */ case "8lpp4":
            size = 4 + $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
            o = $3ee4f50b1ae43a89$var$__8lpp4(this, this.l);
            if (size & 0x03) size += 4 - (size & 0x03);
            break;
        case "cstr":
            size = 0;
            o = "";
            while((w = $3ee4f50b1ae43a89$var$__readUInt8(this, this.l + size++)) !== 0)oo.push($3ee4f50b1ae43a89$var$_getchar(w));
            o = oo.join("");
            break;
        case "_wstr":
            size = 0;
            o = "";
            while((w = $3ee4f50b1ae43a89$var$__readUInt16LE(this, this.l + size)) !== 0){
                oo.push($3ee4f50b1ae43a89$var$_getchar(w));
                size += 2;
            }
            size += 2;
            o = oo.join("");
            break;
        /* sbcs and dbcs support continue records in the SST way TODO codepages */ case "dbcs-cont":
            o = "";
            loc = this.l;
            for(i = 0; i < size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $3ee4f50b1ae43a89$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $3ee4f50b1ae43a89$var$ReadShift.call(this, size - i, w ? "dbcs-cont" : "sbcs-cont");
                    return oo.join("") + vv;
                }
                oo.push($3ee4f50b1ae43a89$var$_getchar($3ee4f50b1ae43a89$var$__readUInt16LE(this, loc)));
                loc += 2;
            }
            o = oo.join("");
            size *= 2;
            break;
        case "cpstr":
            if (typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined") {
                o = $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_codepage, this.slice(this.l, this.l + size));
                break;
            }
        /* falls through */ case "sbcs-cont":
            o = "";
            loc = this.l;
            for(i = 0; i != size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $3ee4f50b1ae43a89$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $3ee4f50b1ae43a89$var$ReadShift.call(this, size - i, w ? "dbcs-cont" : "sbcs-cont");
                    return oo.join("") + vv;
                }
                oo.push($3ee4f50b1ae43a89$var$_getchar($3ee4f50b1ae43a89$var$__readUInt8(this, loc)));
                loc += 1;
            }
            o = oo.join("");
            break;
        default:
            switch(size){
                case 1:
                    oI = $3ee4f50b1ae43a89$var$__readUInt8(this, this.l);
                    this.l++;
                    return oI;
                case 2:
                    oI = (t === "i" ? $3ee4f50b1ae43a89$var$__readInt16LE : $3ee4f50b1ae43a89$var$__readUInt16LE)(this, this.l);
                    this.l += 2;
                    return oI;
                case 4:
                case -4:
                    if (t === "i" || (this[this.l + 3] & 0x80) === 0) {
                        oI = (size > 0 ? $3ee4f50b1ae43a89$var$__readInt32LE : $3ee4f50b1ae43a89$var$__readInt32BE)(this, this.l);
                        this.l += 4;
                        return oI;
                    } else {
                        oR = $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
                        this.l += 4;
                    }
                    return oR;
                case 8:
                case -8:
                    if (t === "f") {
                        if (size == 8) oR = $3ee4f50b1ae43a89$var$__double(this, this.l);
                        else oR = $3ee4f50b1ae43a89$var$__double([
                            this[this.l + 7],
                            this[this.l + 6],
                            this[this.l + 5],
                            this[this.l + 4],
                            this[this.l + 3],
                            this[this.l + 2],
                            this[this.l + 1],
                            this[this.l + 0]
                        ], 0);
                        this.l += 8;
                        return oR;
                    } else size = 8;
                /* falls through */ case 16:
                    o = $3ee4f50b1ae43a89$var$__hexlify(this, this.l, size);
                    break;
            }
    }
    this.l += size;
    return o;
}
var $3ee4f50b1ae43a89$var$__writeUInt32LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >>> 8 & 0xFF;
    b[idx + 2] = val >>> 16 & 0xFF;
    b[idx + 3] = val >>> 24 & 0xFF;
};
var $3ee4f50b1ae43a89$var$__writeInt32LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >> 8 & 0xFF;
    b[idx + 2] = val >> 16 & 0xFF;
    b[idx + 3] = val >> 24 & 0xFF;
};
var $3ee4f50b1ae43a89$var$__writeUInt16LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >>> 8 & 0xFF;
};
function $3ee4f50b1ae43a89$var$WriteShift(t /*:number*/ , val /*:string|number*/ , f /*:?string*/ ) /*:any*/ {
    var size = 0, i = 0;
    if (f === "dbcs") {
        /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i)$3ee4f50b1ae43a89$var$__writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
        size = 2 * val.length;
    } else if (f === "sbcs") {
        if (typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined" && $3ee4f50b1ae43a89$var$current_ansi == 874) /* TODO: use tables directly, don't encode */ /*:: if(typeof val !== "string") throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i){
            var cppayload = $3ee4f50b1ae43a89$var$$cptable.utils.encode($3ee4f50b1ae43a89$var$current_ansi, val.charAt(i));
            this[this.l + i] = cppayload[0];
        }
        else {
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ val = val.replace(/[^\x00-\x7F]/g, "_");
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i)this[this.l + i] = val.charCodeAt(i) & 0xFF;
        }
        size = val.length;
    } else if (f === "hex") {
        for(; i < t; ++i)/*:: if(typeof val !== "string") throw new Error("unreachable"); */ this[this.l++] = parseInt(val.slice(2 * i, 2 * i + 2), 16) || 0;
        return this;
    } else if (f === "utf16le") {
        /*:: if(typeof val !== "string") throw new Error("unreachable"); */ var end /*:number*/  = Math.min(this.l + t, this.length);
        for(i = 0; i < Math.min(val.length, t); ++i){
            var cc = val.charCodeAt(i);
            this[this.l++] = cc & 0xff;
            this[this.l++] = cc >> 8;
        }
        while(this.l < end)this[this.l++] = 0;
        return this;
    } else /*:: if(typeof val === 'number') */ switch(t){
        case 1:
            size = 1;
            this[this.l] = val & 0xFF;
            break;
        case 2:
            size = 2;
            this[this.l] = val & 0xFF;
            val >>>= 8;
            this[this.l + 1] = val & 0xFF;
            break;
        case 3:
            size = 3;
            this[this.l] = val & 0xFF;
            val >>>= 8;
            this[this.l + 1] = val & 0xFF;
            val >>>= 8;
            this[this.l + 2] = val & 0xFF;
            break;
        case 4:
            size = 4;
            $3ee4f50b1ae43a89$var$__writeUInt32LE(this, val, this.l);
            break;
        case 8:
            size = 8;
            if (f === "f") {
                $3ee4f50b1ae43a89$var$write_double_le(this, val, this.l);
                break;
            }
        /* falls through */ case 16:
            break;
        case -4:
            size = 4;
            $3ee4f50b1ae43a89$var$__writeInt32LE(this, val, this.l);
            break;
    }
    this.l += size;
    return this;
}
function $3ee4f50b1ae43a89$var$CheckField(hexstr /*:string*/ , fld /*:string*/ ) /*:void*/ {
    var m = $3ee4f50b1ae43a89$var$__hexlify(this, this.l, hexstr.length >> 1);
    if (m !== hexstr) throw new Error(fld + "Expected " + hexstr + " saw " + m);
    this.l += hexstr.length >> 1;
}
function $3ee4f50b1ae43a89$var$prep_blob(blob, pos /*:number*/ ) /*:void*/ {
    blob.l = pos;
    blob.read_shift = /*::(*/ $3ee4f50b1ae43a89$var$ReadShift /*:: :any)*/ ;
    blob.chk = $3ee4f50b1ae43a89$var$CheckField;
    blob.write_shift = $3ee4f50b1ae43a89$var$WriteShift;
}
function $3ee4f50b1ae43a89$var$parsenoop(blob, length /*:: :number, opts?:any */ ) {
    blob.l += length;
}
function $3ee4f50b1ae43a89$var$new_buf(sz /*:number*/ ) /*:Block*/ {
    var o = $3ee4f50b1ae43a89$var$new_raw_buf(sz);
    $3ee4f50b1ae43a89$var$prep_blob(o, 0);
    return o;
}
/* [MS-XLSB] 2.1.4 Record */ function $3ee4f50b1ae43a89$var$recordhopper(data, cb /*:RecordHopperCB*/ , opts /*:?any*/ ) {
    if (!data) return;
    var tmpbyte, cntbyte, length;
    $3ee4f50b1ae43a89$var$prep_blob(data, data.l || 0);
    var L = data.length, RT = 0, tgt = 0;
    while(data.l < L){
        RT = data.read_shift(1);
        if (RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F) << 7);
        var R = $3ee4f50b1ae43a89$var$XLSBRecordEnum[RT] || $3ee4f50b1ae43a89$var$XLSBRecordEnum[0xFFFF];
        tmpbyte = data.read_shift(1);
        length = tmpbyte & 0x7F;
        for(cntbyte = 1; cntbyte < 4 && tmpbyte & 0x80; ++cntbyte)length += ((tmpbyte = data.read_shift(1)) & 0x7F) << 7 * cntbyte;
        tgt = data.l + length;
        var d = R.f && R.f(data, length, opts);
        data.l = tgt;
        if (cb(d, R, RT)) return;
    }
}
/* control buffer usage for fixed-length buffers */ function $3ee4f50b1ae43a89$var$buf_array() /*:BufArray*/ {
    var bufs /*:Array<Block>*/  = [], blksz = $3ee4f50b1ae43a89$var$has_buf ? 256 : 2048;
    var newblk = function ba_newblk(sz /*:number*/ ) /*:Block*/ {
        var o /*:Block*/  = $3ee4f50b1ae43a89$var$new_buf(sz);
        $3ee4f50b1ae43a89$var$prep_blob(o, 0);
        return o;
    };
    var curbuf /*:Block*/  = newblk(blksz);
    var endbuf = function ba_endbuf() {
        if (!curbuf) return;
        if (curbuf.length > curbuf.l) {
            curbuf = curbuf.slice(0, curbuf.l);
            curbuf.l = curbuf.length;
        }
        if (curbuf.length > 0) bufs.push(curbuf);
        curbuf = null;
    };
    var next = function ba_next(sz /*:number*/ ) /*:Block*/ {
        if (curbuf && sz < curbuf.length - curbuf.l) return curbuf;
        endbuf();
        return curbuf = newblk(Math.max(sz + 1, blksz));
    };
    var end = function ba_end() {
        endbuf();
        return $3ee4f50b1ae43a89$var$bconcat(bufs);
    };
    var push = function ba_push(buf) {
        endbuf();
        curbuf = buf;
        if (curbuf.l == null) curbuf.l = curbuf.length;
        next(blksz);
    };
    return {
        next: next,
        push: push,
        end: end,
        _bufs: bufs
    } /*:any*/ ;
}
function $3ee4f50b1ae43a89$var$write_record(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) {
    var t /*:number*/  = +type, l;
    if (isNaN(t)) return; // TODO: throw something here?
    if (!length) length = $3ee4f50b1ae43a89$var$XLSBRecordEnum[t].p || (payload || []).length || 0;
    l = 1 + (t >= 0x80 ? 1 : 0) + 1 /* + length*/ ;
    if (length >= 0x80) ++l;
    if (length >= 0x4000) ++l;
    if (length >= 0x200000) ++l;
    var o = ba.next(l);
    if (t <= 0x7F) o.write_shift(1, t);
    else {
        o.write_shift(1, (t & 0x7F) + 0x80);
        o.write_shift(1, t >> 7);
    }
    for(var i = 0; i != 4; ++i)if (length >= 0x80) {
        o.write_shift(1, (length & 0x7F) + 0x80);
        length >>= 7;
    } else {
        o.write_shift(1, length);
        break;
    }
    if (/*:: length != null &&*/ length > 0 && $3ee4f50b1ae43a89$var$is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */ function $3ee4f50b1ae43a89$var$shift_cell_xls(cell /*:CellAddress*/ , tgt /*:any*/ , opts /*:?any*/ ) /*:CellAddress*/ {
    var out = $3ee4f50b1ae43a89$var$dup(cell);
    if (tgt.s) {
        if (out.cRel) out.c += tgt.s.c;
        if (out.rRel) out.r += tgt.s.r;
    } else {
        if (out.cRel) out.c += tgt.c;
        if (out.rRel) out.r += tgt.r;
    }
    if (!opts || opts.biff < 12) {
        while(out.c >= 0x100)out.c -= 0x100;
        while(out.r >= 0x10000)out.r -= 0x10000;
    }
    return out;
}
function $3ee4f50b1ae43a89$var$shift_range_xls(cell, range, opts) {
    var out = $3ee4f50b1ae43a89$var$dup(cell);
    out.s = $3ee4f50b1ae43a89$var$shift_cell_xls(out.s, range.s, opts);
    out.e = $3ee4f50b1ae43a89$var$shift_cell_xls(out.e, range.s, opts);
    return out;
}
function $3ee4f50b1ae43a89$var$encode_cell_xls(c /*:CellAddress*/ , biff /*:number*/ ) /*:string*/ {
    if (c.cRel && c.c < 0) {
        c = $3ee4f50b1ae43a89$var$dup(c);
        while(c.c < 0)c.c += biff > 8 ? 0x4000 : 0x100;
    }
    if (c.rRel && c.r < 0) {
        c = $3ee4f50b1ae43a89$var$dup(c);
        while(c.r < 0)c.r += biff > 8 ? 0x100000 : biff > 5 ? 0x10000 : 0x4000;
    }
    var s = $3ee4f50b1ae43a89$var$encode_cell(c);
    if (!c.cRel && c.cRel != null) s = $3ee4f50b1ae43a89$var$fix_col(s);
    if (!c.rRel && c.rRel != null) s = $3ee4f50b1ae43a89$var$fix_row(s);
    return s;
}
function $3ee4f50b1ae43a89$var$encode_range_xls(r, opts) /*:string*/ {
    if (r.s.r == 0 && !r.s.rRel) {
        if (r.e.r == (opts.biff >= 12 ? 0xFFFFF : opts.biff >= 8 ? 0x10000 : 0x4000) && !r.e.rRel) return (r.s.cRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_col(r.e.c);
    }
    if (r.s.c == 0 && !r.s.cRel) {
        if (r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) return (r.s.rRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_row(r.e.r);
    }
    return $3ee4f50b1ae43a89$var$encode_cell_xls(r.s, opts.biff) + ":" + $3ee4f50b1ae43a89$var$encode_cell_xls(r.e, opts.biff);
}
function $3ee4f50b1ae43a89$var$decode_row(rowstr /*:string*/ ) /*:number*/ {
    return parseInt($3ee4f50b1ae43a89$var$unfix_row(rowstr), 10) - 1;
}
function $3ee4f50b1ae43a89$var$encode_row(row /*:number*/ ) /*:string*/ {
    return "" + (row + 1);
}
function $3ee4f50b1ae43a89$var$fix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function $3ee4f50b1ae43a89$var$unfix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/\$(\d+)$/, "$1");
}
function $3ee4f50b1ae43a89$var$decode_col(colstr /*:string*/ ) /*:number*/ {
    var c = $3ee4f50b1ae43a89$var$unfix_col(colstr), d = 0, i = 0;
    for(; i !== c.length; ++i)d = 26 * d + c.charCodeAt(i) - 64;
    return d - 1;
}
function $3ee4f50b1ae43a89$var$encode_col(col /*:number*/ ) /*:string*/ {
    if (col < 0) throw new Error("invalid column " + col);
    var s = "";
    for(++col; col; col = Math.floor((col - 1) / 26))s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s;
}
function $3ee4f50b1ae43a89$var$fix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^([A-Z])/, "$$$1");
}
function $3ee4f50b1ae43a89$var$unfix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^\$([A-Z])/, "$1");
}
function $3ee4f50b1ae43a89$var$split_cell(cstr /*:string*/ ) /*:Array<string>*/ {
    return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
//function decode_cell(cstr/*:string*/)/*:CellAddress*/ { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
function $3ee4f50b1ae43a89$var$decode_cell(cstr /*:string*/ ) /*:CellAddress*/ {
    var R = 0, C = 0;
    for(var i = 0; i < cstr.length; ++i){
        var cc = cstr.charCodeAt(i);
        if (cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
        else if (cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
    }
    return {
        c: C - 1,
        r: R - 1
    };
}
//function encode_cell(cell/*:CellAddress*/)/*:string*/ { return encode_col(cell.c) + encode_row(cell.r); }
function $3ee4f50b1ae43a89$var$encode_cell(cell /*:CellAddress*/ ) /*:string*/ {
    var col = cell.c + 1;
    var s = "";
    for(; col; col = (col - 1) / 26 | 0)s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s + (cell.r + 1);
}
function $3ee4f50b1ae43a89$var$decode_range(range /*:string*/ ) /*:Range*/ {
    var idx = range.indexOf(":");
    if (idx == -1) return {
        s: $3ee4f50b1ae43a89$var$decode_cell(range),
        e: $3ee4f50b1ae43a89$var$decode_cell(range)
    };
    return {
        s: $3ee4f50b1ae43a89$var$decode_cell(range.slice(0, idx)),
        e: $3ee4f50b1ae43a89$var$decode_cell(range.slice(idx + 1))
    };
}
/*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */ function $3ee4f50b1ae43a89$var$encode_range(cs /*:CellAddrSpec|Range*/ , ce /*:?CellAddrSpec*/ ) /*:string*/ {
    if (typeof ce === "undefined" || typeof ce === "number") /*:: if(!(cs instanceof Range)) throw "unreachable"; */ return $3ee4f50b1ae43a89$var$encode_range(cs.s, cs.e);
    /*:: if((cs instanceof Range)) throw "unreachable"; */ if (typeof cs !== "string") cs = $3ee4f50b1ae43a89$var$encode_cell(cs /*:any*/ );
    if (typeof ce !== "string") ce = $3ee4f50b1ae43a89$var$encode_cell(ce /*:any*/ );
    /*:: if(typeof cs !== 'string') throw "unreachable"; */ /*:: if(typeof ce !== 'string') throw "unreachable"; */ return cs == ce ? cs : cs + ":" + ce;
}
function $3ee4f50b1ae43a89$var$safe_decode_range(range /*:string*/ ) /*:Range*/ {
    var o = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var idx = 0, i = 0, cc = 0;
    var len = range.length;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.s.c = --idx;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.s.r = --idx;
    if (i === len || cc != 10) {
        o.e.c = o.s.c;
        o.e.r = o.s.r;
        return o;
    }
    ++i;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.e.c = --idx;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.e.r = --idx;
    return o;
}
function $3ee4f50b1ae43a89$var$safe_format_cell(cell /*:Cell*/ , v /*:any*/ ) {
    var q = cell.t == "d" && v instanceof Date;
    if (cell.z != null) try {
        return cell.w = $3ee4f50b1ae43a89$var$SSF_format(cell.z, q ? $3ee4f50b1ae43a89$var$datenum(v) : v);
    } catch (e) {}
    try {
        return cell.w = $3ee4f50b1ae43a89$var$SSF_format((cell.XF || {}).numFmtId || (q ? 14 : 0), q ? $3ee4f50b1ae43a89$var$datenum(v) : v);
    } catch (e) {
        return "" + v;
    }
}
function $3ee4f50b1ae43a89$var$format_cell(cell /*:Cell*/ , v /*:any*/ , o /*:any*/ ) {
    if (cell == null || cell.t == null || cell.t == "z") return "";
    if (cell.w !== undefined) return cell.w;
    if (cell.t == "d" && !cell.z && o && o.dateNF) cell.z = o.dateNF;
    if (cell.t == "e") return $3ee4f50b1ae43a89$var$BErr[cell.v] || cell.v;
    if (v == undefined) return $3ee4f50b1ae43a89$var$safe_format_cell(cell, cell.v);
    return $3ee4f50b1ae43a89$var$safe_format_cell(cell, v);
}
function $3ee4f50b1ae43a89$var$sheet_to_workbook(sheet /*:Worksheet*/ , opts) /*:Workbook*/ {
    var n = opts && opts.sheet ? opts.sheet : "Sheet1";
    var sheets = {};
    sheets[n] = sheet;
    return {
        SheetNames: [
            n
        ],
        Sheets: sheets
    };
}
function $3ee4f50b1ae43a89$var$sheet_add_aoa(_ws /*:?Worksheet*/ , data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? Array.isArray(_ws) : o.dense;
    if ($3ee4f50b1ae43a89$var$DENSE != null && dense == null) dense = $3ee4f50b1ae43a89$var$DENSE;
    var ws /*:Worksheet*/  = _ws || (dense ? [] : {} /*:any*/ );
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == "number") _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $3ee4f50b1ae43a89$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
        if (!ws["!ref"]) ws["!ref"] = "A1:A1";
    }
    var range /*:Range*/  = {
        s: {
            c: 10000000,
            r: 10000000
        },
        e: {
            c: 0,
            r: 0
        }
    } /*:any*/ ;
    if (ws["!ref"]) {
        var _range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]);
        range.s.c = _range.s.c;
        range.s.r = _range.s.r;
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) range.e.r = _R = _range.e.r + 1;
    }
    for(var R = 0; R != data.length; ++R){
        if (!data[R]) continue;
        if (!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
        for(var C = 0; C != data[R].length; ++C){
            if (typeof data[R][C] === "undefined") continue;
            var cell /*:Cell*/  = {
                v: data[R][C]
            } /*:any*/ ;
            var __R = _R + R, __C = _C + C;
            if (range.s.r > __R) range.s.r = __R;
            if (range.s.c > __C) range.s.c = __C;
            if (range.e.r < __R) range.e.r = __R;
            if (range.e.c < __C) range.e.c = __C;
            if (data[R][C] && typeof data[R][C] === "object" && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
            else {
                if (Array.isArray(cell.v)) {
                    cell.f = data[R][C][1];
                    cell.v = cell.v[0];
                }
                if (cell.v === null) {
                    if (cell.f) cell.t = "n";
                    else if (o.nullError) {
                        cell.t = "e";
                        cell.v = 0;
                    } else if (!o.sheetStubs) continue;
                    else cell.t = "z";
                } else if (typeof cell.v === "number") cell.t = "n";
                else if (typeof cell.v === "boolean") cell.t = "b";
                else if (cell.v instanceof Date) {
                    cell.z = o.dateNF || $3ee4f50b1ae43a89$var$table_fmt[14];
                    if (o.cellDates) {
                        cell.t = "d";
                        cell.w = $3ee4f50b1ae43a89$var$SSF_format(cell.z, $3ee4f50b1ae43a89$var$datenum(cell.v));
                    } else {
                        cell.t = "n";
                        cell.v = $3ee4f50b1ae43a89$var$datenum(cell.v);
                        cell.w = $3ee4f50b1ae43a89$var$SSF_format(cell.z, cell.v);
                    }
                } else cell.t = "s";
            }
            if (dense) {
                if (!ws[__R]) ws[__R] = [];
                if (ws[__R][__C] && ws[__R][__C].z) cell.z = ws[__R][__C].z;
                ws[__R][__C] = cell;
            } else {
                var cell_ref = $3ee4f50b1ae43a89$var$encode_cell({
                    c: __C,
                    r: __R
                } /*:any*/ );
                if (ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
                ws[cell_ref] = cell;
            }
        }
    }
    if (range.s.c < 10000000) ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
    return ws;
}
function $3ee4f50b1ae43a89$var$aoa_to_sheet(data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    return $3ee4f50b1ae43a89$var$sheet_add_aoa(null, data, opts);
}
function $3ee4f50b1ae43a89$var$parse_Int32LE(data) {
    return data.read_shift(4, "i");
}
function $3ee4f50b1ae43a89$var$write_UInt32LE(x /*:number*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(4, x);
    return o;
}
/* [MS-XLSB] 2.5.168 */ function $3ee4f50b1ae43a89$var$parse_XLWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "dbcs");
}
function $3ee4f50b1ae43a89$var$write_XLWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $3ee4f50b1ae43a89$var$new_buf(4 + 2 * data.length);
    }
    o.write_shift(4, data.length);
    if (data.length > 0) o.write_shift(0, data, "dbcs");
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.91 */ //function parse_LPWideString(data/*::, length*/)/*:string*/ {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}
/* [MS-XLSB] 2.5.143 */ function $3ee4f50b1ae43a89$var$parse_StrRun(data) {
    return {
        ich: data.read_shift(2),
        ifnt: data.read_shift(2)
    };
}
function $3ee4f50b1ae43a89$var$write_StrRun(run, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(2, run.ich || 0);
    o.write_shift(2, run.ifnt || 0);
    return o;
}
/* [MS-XLSB] 2.5.121 */ function $3ee4f50b1ae43a89$var$parse_RichStr(data, length /*:number*/ ) /*:XLString*/ {
    var start = data.l;
    var flags = data.read_shift(1);
    var str = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    var rgsStrRun = [];
    var z = {
        t: str,
        h: str
    } /*:any*/ ;
    if ((flags & 1) !== 0) {
        /* TODO: formatted string */ var dwSizeStrRun = data.read_shift(4);
        for(var i = 0; i != dwSizeStrRun; ++i)rgsStrRun.push($3ee4f50b1ae43a89$var$parse_StrRun(data));
        z.r = rgsStrRun;
    } else z.r = [
        {
            ich: 0,
            ifnt: 0
        }
    ];
    //if((flags & 2) !== 0) { /* fExtStr */
    //	/* TODO: phonetic string */
    //}
    data.l = start + length;
    return z;
}
function $3ee4f50b1ae43a89$var$write_RichStr(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $3ee4f50b1ae43a89$var$new_buf(15 + 4 * str.t.length);
    }
    o.write_shift(1, 0);
    $3ee4f50b1ae43a89$var$write_XLWideString(str.t, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */ var $3ee4f50b1ae43a89$var$parse_BrtCommentText = $3ee4f50b1ae43a89$var$parse_RichStr;
function $3ee4f50b1ae43a89$var$write_BrtCommentText(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $3ee4f50b1ae43a89$var$new_buf(23 + 4 * str.t.length);
    }
    o.write_shift(1, 1);
    $3ee4f50b1ae43a89$var$write_XLWideString(str.t, o);
    o.write_shift(4, 1);
    $3ee4f50b1ae43a89$var$write_StrRun({
        ich: 0,
        ifnt: 0
    }, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.9 */ function $3ee4f50b1ae43a89$var$parse_XLSBCell(data) /*:any*/ {
    var col = data.read_shift(4);
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: col,
        iStyleRef: iStyleRef
    };
}
function $3ee4f50b1ae43a89$var$write_XLSBCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(-4, cell.c);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* Short XLSB Cell does not include column */ function $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data) /*:any*/ {
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: -1,
        iStyleRef: iStyleRef
    };
}
function $3ee4f50b1ae43a89$var$write_XLSBShortCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* [MS-XLSB] 2.5.21 */ var $3ee4f50b1ae43a89$var$parse_XLSBCodeName = $3ee4f50b1ae43a89$var$parse_XLWideString;
var $3ee4f50b1ae43a89$var$write_XLSBCodeName = $3ee4f50b1ae43a89$var$write_XLWideString;
/* [MS-XLSB] 2.5.166 */ function $3ee4f50b1ae43a89$var$parse_XLNullableWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, "dbcs");
}
function $3ee4f50b1ae43a89$var$write_XLNullableWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $3ee4f50b1ae43a89$var$new_buf(127);
    }
    o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
    if (data.length > 0) o.write_shift(0, data, "dbcs");
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.165 */ var $3ee4f50b1ae43a89$var$parse_XLNameWideString = $3ee4f50b1ae43a89$var$parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;
/* [MS-XLSB] 2.5.114 */ var $3ee4f50b1ae43a89$var$parse_RelID = $3ee4f50b1ae43a89$var$parse_XLNullableWideString;
var $3ee4f50b1ae43a89$var$write_RelID = $3ee4f50b1ae43a89$var$write_XLNullableWideString;
/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */ function $3ee4f50b1ae43a89$var$parse_RkNumber(data) /*:number*/ {
    var b = data.slice(data.l, data.l + 4);
    var fX100 = b[0] & 1, fInt = b[0] & 2;
    data.l += 4;
    var RK = fInt === 0 ? $3ee4f50b1ae43a89$var$__double([
        0,
        0,
        0,
        0,
        b[0] & 0xFC,
        b[1],
        b[2],
        b[3]
    ], 0) : $3ee4f50b1ae43a89$var$__readInt32LE(b, 0) >> 2;
    return fX100 ? RK / 100 : RK;
}
function $3ee4f50b1ae43a89$var$write_RkNumber(data /*:number*/ , o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(4);
    var fX100 = 0, fInt = 0, d100 = data * 100;
    if (data == (data | 0) && data >= -536870912 && data < 536870912) fInt = 1;
    else if (d100 == (d100 | 0) && d100 >= -536870912 && d100 < 536870912) {
        fInt = 1;
        fX100 = 1;
    }
    if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
    else throw new Error("unsupported RkNumber " + data); // TODO
}
/* [MS-XLSB] 2.5.117 RfX */ function $3ee4f50b1ae43a89$var$parse_RfX(data /*::, length*/ ) /*:Range*/ {
    var cell /*:Range*/  = {
        s: {},
        e: {}
    } /*:any*/ ;
    cell.s.r = data.read_shift(4);
    cell.e.r = data.read_shift(4);
    cell.s.c = data.read_shift(4);
    cell.e.c = data.read_shift(4);
    return cell;
}
function $3ee4f50b1ae43a89$var$write_RfX(r /*:Range*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(16);
    o.write_shift(4, r.s.r);
    o.write_shift(4, r.e.r);
    o.write_shift(4, r.s.c);
    o.write_shift(4, r.e.c);
    return o;
}
/* [MS-XLSB] 2.5.153 UncheckedRfX */ var $3ee4f50b1ae43a89$var$parse_UncheckedRfX = $3ee4f50b1ae43a89$var$parse_RfX;
var $3ee4f50b1ae43a89$var$write_UncheckedRfX = $3ee4f50b1ae43a89$var$write_RfX;
/* [MS-XLSB] 2.5.155 UncheckedSqRfX */ //function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx/*:string*/) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}
/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */ /* TODO: error checking, NaN and Infinity values are not valid Xnum */ function $3ee4f50b1ae43a89$var$parse_Xnum(data /*::, length*/ ) {
    if (data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
    return data.read_shift(8, "f");
}
function $3ee4f50b1ae43a89$var$write_Xnum(data, o) {
    return (o || $3ee4f50b1ae43a89$var$new_buf(8)).write_shift(8, data, "f");
}
/* [MS-XLSB] 2.4.324 BrtColor */ function $3ee4f50b1ae43a89$var$parse_BrtColor(data /*::, length*/ ) {
    var out = {};
    var d = data.read_shift(1);
    //var fValidRGB = d & 1;
    var xColorType = d >>> 1;
    var index = data.read_shift(1);
    var nTS = data.read_shift(2, "i");
    var bR = data.read_shift(1);
    var bG = data.read_shift(1);
    var bB = data.read_shift(1);
    data.l++; //var bAlpha = data.read_shift(1);
    switch(xColorType){
        case 0:
            out.auto = 1;
            break;
        case 1:
            out.index = index;
            var icv = $3ee4f50b1ae43a89$var$XLSIcv[index];
            /* automatic pseudo index 81 */ if (icv) out.rgb = $3ee4f50b1ae43a89$var$rgb2Hex(icv);
            break;
        case 2:
            /* if(!fValidRGB) throw new Error("invalid"); */ out.rgb = $3ee4f50b1ae43a89$var$rgb2Hex([
                bR,
                bG,
                bB
            ]);
            break;
        case 3:
            out.theme = index;
            break;
    }
    if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
    return out;
}
function $3ee4f50b1ae43a89$var$write_BrtColor(color, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(8);
    if (!color || color.auto) {
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        return o;
    }
    if (color.index != null) {
        o.write_shift(1, 0x02);
        o.write_shift(1, color.index);
    } else if (color.theme != null) {
        o.write_shift(1, 0x06);
        o.write_shift(1, color.theme);
    } else {
        o.write_shift(1, 0x05);
        o.write_shift(1, 0);
    }
    var nTS = color.tint || 0;
    if (nTS > 0) nTS *= 32767;
    else if (nTS < 0) nTS *= 32768;
    o.write_shift(2, nTS);
    if (!color.rgb || color.theme != null) {
        o.write_shift(2, 0);
        o.write_shift(1, 0);
        o.write_shift(1, 0);
    } else {
        var rgb = color.rgb || "FFFFFF";
        if (typeof rgb == "number") rgb = ("000000" + rgb.toString(16)).slice(-6);
        o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
        o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
        o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
        o.write_shift(1, 0xFF);
    }
    return o;
}
/* [MS-XLSB] 2.5.52 */ function $3ee4f50b1ae43a89$var$parse_FontFlags(data /*::, length, opts*/ ) {
    var d = data.read_shift(1);
    data.l++;
    var out = {
        fBold: d & 0x01,
        fItalic: d & 0x02,
        fUnderline: d & 0x04,
        fStrikeout: d & 0x08,
        fOutline: d & 0x10,
        fShadow: d & 0x20,
        fCondense: d & 0x40,
        fExtend: d & 0x80
    };
    return out;
}
function $3ee4f50b1ae43a89$var$write_FontFlags(font, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(2);
    var grbit = (font.italic ? 0x02 : 0) | (font.strike ? 0x08 : 0) | (font.outline ? 0x10 : 0) | (font.shadow ? 0x20 : 0) | (font.condense ? 0x40 : 0) | (font.extend ? 0x80 : 0);
    o.write_shift(1, grbit);
    o.write_shift(1, 0);
    return o;
}
/* [MS-OLEDS] 2.3.1 and 2.3.2 */ function $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrString(o, w /*:number*/ ) /*:string*/ {
    // $FlowIgnore
    var ClipFmt = {
        2: "BITMAP",
        3: "METAFILEPICT",
        8: "DIB",
        14: "ENHMETAFILE"
    };
    var m /*:number*/  = o.read_shift(4);
    switch(m){
        case 0x00000000:
            return "";
        case 0xffffffff:
        case 0xfffffffe:
            return ClipFmt[o.read_shift(4)] || "";
    }
    if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
    o.l -= 4;
    return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrAnsiString(o) {
    return $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrString(o, 1);
}
function $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrUnicodeString(o) {
    return $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrString(o, 2);
}
/* [MS-OLEPS] 2.2 PropertyType */ // Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var $3ee4f50b1ae43a89$var$VT_I2 = 0x0002;
var $3ee4f50b1ae43a89$var$VT_I4 = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var $3ee4f50b1ae43a89$var$VT_BOOL = 0x000B;
var $3ee4f50b1ae43a89$var$VT_VARIANT = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var $3ee4f50b1ae43a89$var$VT_UI4 = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
var $3ee4f50b1ae43a89$var$VT_LPSTR = 0x001E;
//var VT_LPWSTR   = 0x001F;
var $3ee4f50b1ae43a89$var$VT_FILETIME = 0x0040;
var $3ee4f50b1ae43a89$var$VT_BLOB = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var $3ee4f50b1ae43a89$var$VT_CF = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
var $3ee4f50b1ae43a89$var$VT_VECTOR = 0x1000;
var $3ee4f50b1ae43a89$var$VT_VECTOR_VARIANT = 0x100C;
var $3ee4f50b1ae43a89$var$VT_VECTOR_LPSTR = 0x101E;
//var VT_ARRAY    = 0x2000;
var $3ee4f50b1ae43a89$var$VT_STRING = 0x0050; // 2.3.3.1.11 VtString
var $3ee4f50b1ae43a89$var$VT_USTR = 0x0051; // 2.3.3.1.12 VtUnalignedString
var $3ee4f50b1ae43a89$var$VT_CUSTOM = [
    $3ee4f50b1ae43a89$var$VT_STRING,
    $3ee4f50b1ae43a89$var$VT_USTR
];
/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */ var $3ee4f50b1ae43a89$var$DocSummaryPIDDSI = {
    /*::[*/ 0x01: {
        n: "CodePage",
        t: $3ee4f50b1ae43a89$var$VT_I2
    },
    /*::[*/ 0x02: {
        n: "Category",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x03: {
        n: "PresentationFormat",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x04: {
        n: "ByteCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x05: {
        n: "LineCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x06: {
        n: "ParagraphCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x07: {
        n: "SlideCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x08: {
        n: "NoteCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x09: {
        n: "HiddenCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x0a: {
        n: "MultimediaClipCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x0b: {
        n: "ScaleCrop",
        t: $3ee4f50b1ae43a89$var$VT_BOOL
    },
    /*::[*/ 0x0c: {
        n: "HeadingPairs",
        t: $3ee4f50b1ae43a89$var$VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ 
    },
    /*::[*/ 0x0d: {
        n: "TitlesOfParts",
        t: $3ee4f50b1ae43a89$var$VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ 
    },
    /*::[*/ 0x0e: {
        n: "Manager",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x0f: {
        n: "Company",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x10: {
        n: "LinksUpToDate",
        t: $3ee4f50b1ae43a89$var$VT_BOOL
    },
    /*::[*/ 0x11: {
        n: "CharacterCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x13: {
        n: "SharedDoc",
        t: $3ee4f50b1ae43a89$var$VT_BOOL
    },
    /*::[*/ 0x16: {
        n: "HyperlinksChanged",
        t: $3ee4f50b1ae43a89$var$VT_BOOL
    },
    /*::[*/ 0x17: {
        n: "AppVersion",
        t: $3ee4f50b1ae43a89$var$VT_I4,
        p: "version"
    },
    /*::[*/ 0x18: {
        n: "DigSig",
        t: $3ee4f50b1ae43a89$var$VT_BLOB
    },
    /*::[*/ 0x1A: {
        n: "ContentType",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x1B: {
        n: "ContentStatus",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x1C: {
        n: "Language",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x1D: {
        n: "Version",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0xFF: {},
    /* [MS-OLEPS] 2.18 */ /*::[*/ 0x80000000: {
        n: "Locale",
        t: $3ee4f50b1ae43a89$var$VT_UI4
    },
    /*::[*/ 0x80000003: {
        n: "Behavior",
        t: $3ee4f50b1ae43a89$var$VT_UI4
    },
    /*::[*/ 0x72627262: {}
};
/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */ var $3ee4f50b1ae43a89$var$SummaryPIDSI = {
    /*::[*/ 0x01: {
        n: "CodePage",
        t: $3ee4f50b1ae43a89$var$VT_I2
    },
    /*::[*/ 0x02: {
        n: "Title",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x03: {
        n: "Subject",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x04: {
        n: "Author",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x05: {
        n: "Keywords",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x06: {
        n: "Comments",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x07: {
        n: "Template",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x08: {
        n: "LastAuthor",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x09: {
        n: "RevNumber",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x0A: {
        n: "EditTime",
        t: $3ee4f50b1ae43a89$var$VT_FILETIME
    },
    /*::[*/ 0x0B: {
        n: "LastPrinted",
        t: $3ee4f50b1ae43a89$var$VT_FILETIME
    },
    /*::[*/ 0x0C: {
        n: "CreatedDate",
        t: $3ee4f50b1ae43a89$var$VT_FILETIME
    },
    /*::[*/ 0x0D: {
        n: "ModifiedDate",
        t: $3ee4f50b1ae43a89$var$VT_FILETIME
    },
    /*::[*/ 0x0E: {
        n: "PageCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x0F: {
        n: "WordCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x10: {
        n: "CharCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x11: {
        n: "Thumbnail",
        t: $3ee4f50b1ae43a89$var$VT_CF
    },
    /*::[*/ 0x12: {
        n: "Application",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x13: {
        n: "DocSecurity",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0xFF: {},
    /* [MS-OLEPS] 2.18 */ /*::[*/ 0x80000000: {
        n: "Locale",
        t: $3ee4f50b1ae43a89$var$VT_UI4
    },
    /*::[*/ 0x80000003: {
        n: "Behavior",
        t: $3ee4f50b1ae43a89$var$VT_UI4
    },
    /*::[*/ 0x72627262: {}
};
/* [MS-XLS] 2.4.63 Country/Region codes */ var $3ee4f50b1ae43a89$var$CountryEnum = {
    /*::[*/ 0x0001: "US",
    /*::[*/ 0x0002: "CA",
    /*::[*/ 0x0003: "",
    /*::[*/ 0x0007: "RU",
    /*::[*/ 0x0014: "EG",
    /*::[*/ 0x001E: "GR",
    /*::[*/ 0x001F: "NL",
    /*::[*/ 0x0020: "BE",
    /*::[*/ 0x0021: "FR",
    /*::[*/ 0x0022: "ES",
    /*::[*/ 0x0024: "HU",
    /*::[*/ 0x0027: "IT",
    /*::[*/ 0x0029: "CH",
    /*::[*/ 0x002B: "AT",
    /*::[*/ 0x002C: "GB",
    /*::[*/ 0x002D: "DK",
    /*::[*/ 0x002E: "SE",
    /*::[*/ 0x002F: "NO",
    /*::[*/ 0x0030: "PL",
    /*::[*/ 0x0031: "DE",
    /*::[*/ 0x0034: "MX",
    /*::[*/ 0x0037: "BR",
    /*::[*/ 0x003d: "AU",
    /*::[*/ 0x0040: "NZ",
    /*::[*/ 0x0042: "TH",
    /*::[*/ 0x0051: "JP",
    /*::[*/ 0x0052: "KR",
    /*::[*/ 0x0054: "VN",
    /*::[*/ 0x0056: "CN",
    /*::[*/ 0x005A: "TR",
    /*::[*/ 0x0069: "JS",
    /*::[*/ 0x00D5: "DZ",
    /*::[*/ 0x00D8: "MA",
    /*::[*/ 0x00DA: "LY",
    /*::[*/ 0x015F: "PT",
    /*::[*/ 0x0162: "IS",
    /*::[*/ 0x0166: "FI",
    /*::[*/ 0x01A4: "CZ",
    /*::[*/ 0x0376: "TW",
    /*::[*/ 0x03C1: "LB",
    /*::[*/ 0x03C2: "JO",
    /*::[*/ 0x03C3: "SY",
    /*::[*/ 0x03C4: "IQ",
    /*::[*/ 0x03C5: "KW",
    /*::[*/ 0x03C6: "SA",
    /*::[*/ 0x03CB: "AE",
    /*::[*/ 0x03CC: "IL",
    /*::[*/ 0x03CE: "QA",
    /*::[*/ 0x03D5: "IR",
    /*::[*/ 0xFFFF: "US" // United States
};
/* [MS-XLS] 2.5.127 */ var $3ee4f50b1ae43a89$var$XLSFillPattern = [
    null,
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
function $3ee4f50b1ae43a89$var$rgbify(arr /*:Array<number>*/ ) /*:Array<[number, number, number]>*/ {
    return arr.map(function(x) {
        return [
            x >> 16 & 255,
            x >> 8 & 255,
            x & 255
        ];
    });
}
/* [MS-XLS] 2.5.161 */ /* [MS-XLSB] 2.5.75 Icv */ var $3ee4f50b1ae43a89$var$_XLSIcv = /*#__PURE__*/ $3ee4f50b1ae43a89$var$rgbify([
    /* Color Constants */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    /* Overridable Defaults */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    0x800000,
    0x008000,
    0x000080,
    0x808000,
    0x800080,
    0x008080,
    0xC0C0C0,
    0x808080,
    0x9999FF,
    0x993366,
    0xFFFFCC,
    0xCCFFFF,
    0x660066,
    0xFF8080,
    0x0066CC,
    0xCCCCFF,
    0x000080,
    0xFF00FF,
    0xFFFF00,
    0x00FFFF,
    0x800080,
    0x800000,
    0x008080,
    0x0000FF,
    0x00CCFF,
    0xCCFFFF,
    0xCCFFCC,
    0xFFFF99,
    0x99CCFF,
    0xFF99CC,
    0xCC99FF,
    0xFFCC99,
    0x3366FF,
    0x33CCCC,
    0x99CC00,
    0xFFCC00,
    0xFF9900,
    0xFF6600,
    0x666699,
    0x969696,
    0x003366,
    0x339966,
    0x003300,
    0x333300,
    0x993300,
    0x993366,
    0x333399,
    0x333333,
    /* Other entries to appease BIFF8/12 */ 0xFFFFFF,
    /* 0x40 icvForeground ?? */ 0x000000,
    /* 0x41 icvBackground ?? */ 0x000000,
    /* 0x42 icvFrame ?? */ 0x000000,
    /* 0x43 icv3D ?? */ 0x000000,
    /* 0x44 icv3DText ?? */ 0x000000,
    /* 0x45 icv3DHilite ?? */ 0x000000,
    /* 0x46 icv3DShadow ?? */ 0x000000,
    /* 0x47 icvHilite ?? */ 0x000000,
    /* 0x48 icvCtlText ?? */ 0x000000,
    /* 0x49 icvCtlScrl ?? */ 0x000000,
    /* 0x4A icvCtlInv ?? */ 0x000000,
    /* 0x4B icvCtlBody ?? */ 0x000000,
    /* 0x4C icvCtlFrame ?? */ 0x000000,
    /* 0x4D icvCtlFore ?? */ 0x000000,
    /* 0x4E icvCtlBack ?? */ 0x000000,
    /* 0x4F icvCtlNeutral */ 0x000000,
    /* 0x50 icvInfoBk ?? */ 0x000000 /* 0x51 icvInfoText ?? */ 
]);
var $3ee4f50b1ae43a89$var$XLSIcv = /*#__PURE__*/ $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$_XLSIcv);
/* [MS-XLSB] 2.5.97.2 */ var $3ee4f50b1ae43a89$var$BErr = {
    /*::[*/ 0x00: "#NULL!",
    /*::[*/ 0x07: "#DIV/0!",
    /*::[*/ 0x0F: "#VALUE!",
    /*::[*/ 0x17: "#REF!",
    /*::[*/ 0x1D: "#NAME?",
    /*::[*/ 0x24: "#NUM!",
    /*::[*/ 0x2A: "#N/A",
    /*::[*/ 0x2B: "#GETTING_DATA",
    /*::[*/ 0xFF: "#WTF?"
};
//var RBErr = evert_num(BErr);
var $3ee4f50b1ae43a89$var$RBErr = {
    "#NULL!": 0x00,
    "#DIV/0!": 0x07,
    "#VALUE!": 0x0F,
    "#REF!": 0x17,
    "#NAME?": 0x1D,
    "#NUM!": 0x24,
    "#N/A": 0x2A,
    "#GETTING_DATA": 0x2B,
    "#WTF?": 0xFF
};
/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */ /* 12.3 Part Summary <SpreadsheetML> */ /* 14.2 Part Summary <DrawingML> */ /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */ var $3ee4f50b1ae43a89$var$ct2type /*{[string]:string}*/  = {
    /* Workbook */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
    "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
    /* Worksheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
    "application/vnd.ms-excel.worksheet": "sheets",
    "application/vnd.ms-excel.binIndexWs": "TODO",
    /* Binary Index */ /* Chartsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
    "application/vnd.ms-excel.chartsheet": "charts",
    /* Macrosheet */ "application/vnd.ms-excel.macrosheet+xml": "macros",
    "application/vnd.ms-excel.macrosheet": "macros",
    "application/vnd.ms-excel.intlmacrosheet": "TODO",
    "application/vnd.ms-excel.binIndexMs": "TODO",
    /* Binary Index */ /* Dialogsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
    "application/vnd.ms-excel.dialogsheet": "dialogs",
    /* Shared Strings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
    "application/vnd.ms-excel.sharedStrings": "strs",
    /* Styles */ "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
    "application/vnd.ms-excel.styles": "styles",
    /* File Properties */ "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
    "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
    "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
    /* Custom Data Properties */ "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
    /* Comments */ "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
    "application/vnd.ms-excel.comments": "comments",
    "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
    "application/vnd.ms-excel.person+xml": "people",
    /* Metadata (Stock/Geography and Dynamic Array) */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
    "application/vnd.ms-excel.sheetMetadata": "metadata",
    /* PivotTable */ "application/vnd.ms-excel.pivotTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
    /* Chart Objects */ "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
    /* Chart Colors */ "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
    /* Chart Style */ "application/vnd.ms-office.chartstyle+xml": "TODO",
    /* Chart Advanced */ "application/vnd.ms-office.chartex+xml": "TODO",
    /* Calculation Chain */ "application/vnd.ms-excel.calcChain": "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
    /* Printer Settings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
    /* ActiveX */ "application/vnd.ms-office.activeX": "TODO",
    "application/vnd.ms-office.activeX+xml": "TODO",
    /* Custom Toolbars */ "application/vnd.ms-excel.attachedToolbars": "TODO",
    /* External Data Connections */ "application/vnd.ms-excel.connections": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
    /* External Links */ "application/vnd.ms-excel.externalLink": "links",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
    /* PivotCache */ "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
    "application/vnd.ms-excel.pivotCacheRecords": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
    /* Query Table */ "application/vnd.ms-excel.queryTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
    /* Shared Workbook */ "application/vnd.ms-excel.userNames": "TODO",
    "application/vnd.ms-excel.revisionHeaders": "TODO",
    "application/vnd.ms-excel.revisionLog": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
    /* Single Cell Table */ "application/vnd.ms-excel.tableSingleCells": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
    /* Slicer */ "application/vnd.ms-excel.slicer": "TODO",
    "application/vnd.ms-excel.slicerCache": "TODO",
    "application/vnd.ms-excel.slicer+xml": "TODO",
    "application/vnd.ms-excel.slicerCache+xml": "TODO",
    /* Sort Map */ "application/vnd.ms-excel.wsSortMap": "TODO",
    /* Table */ "application/vnd.ms-excel.table": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
    /* Themes */ "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
    /* Theme Override */ "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
    /* Timeline */ "application/vnd.ms-excel.Timeline+xml": "TODO",
    /* verify */ "application/vnd.ms-excel.TimelineCache+xml": "TODO",
    /* verify */ /* VBA */ "application/vnd.ms-office.vbaProject": "vba",
    "application/vnd.ms-office.vbaProjectSignature": "TODO",
    /* Volatile Dependencies */ "application/vnd.ms-office.volatileDependencies": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
    /* Control Properties */ "application/vnd.ms-excel.controlproperties+xml": "TODO",
    /* Data Model */ "application/vnd.openxmlformats-officedocument.model+data": "TODO",
    /* Survey */ "application/vnd.ms-excel.Survey+xml": "TODO",
    /* Drawing */ "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
    "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
    /* VML */ "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
    "application/vnd.openxmlformats-package.relationships+xml": "rels",
    "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
    /* Image */ "image/png": "TODO",
    "sheet": "js"
} /*:any*/ ;
var $3ee4f50b1ae43a89$var$CT_LIST = {
    workbooks: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
        xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
        xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
        xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
        xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
    },
    strs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
        xlsb: "application/vnd.ms-excel.sharedStrings"
    },
    comments: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
        xlsb: "application/vnd.ms-excel.comments"
    },
    sheets: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
        xlsb: "application/vnd.ms-excel.worksheet"
    },
    charts: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
        xlsb: "application/vnd.ms-excel.chartsheet"
    },
    dialogs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
        xlsb: "application/vnd.ms-excel.dialogsheet"
    },
    macros: {
        xlsx: "application/vnd.ms-excel.macrosheet+xml",
        xlsb: "application/vnd.ms-excel.macrosheet"
    },
    metadata: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
        xlsb: "application/vnd.ms-excel.sheetMetadata"
    },
    styles: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
        xlsb: "application/vnd.ms-excel.styles"
    }
};
function $3ee4f50b1ae43a89$var$new_ct() /*:any*/ {
    return {
        workbooks: [],
        sheets: [],
        charts: [],
        dialogs: [],
        macros: [],
        rels: [],
        strs: [],
        comments: [],
        threadedcomments: [],
        links: [],
        coreprops: [],
        extprops: [],
        custprops: [],
        themes: [],
        styles: [],
        calcchains: [],
        vba: [],
        drawings: [],
        metadata: [],
        people: [],
        TODO: [],
        xmlns: ""
    } /*:any*/ ;
}
function $3ee4f50b1ae43a89$var$parse_ct(data /*:?string*/ ) {
    var ct = $3ee4f50b1ae43a89$var$new_ct();
    if (!data || !data.match) return ct;
    var ctext = {};
    (data.match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch(y[0].replace($3ee4f50b1ae43a89$var$nsregex, "<")){
            case "<?xml":
                break;
            case "<Types":
                ct.xmlns = y["xmlns" + (y[0].match(/<(\w+):/) || [
                    "",
                    ""
                ])[1]];
                break;
            case "<Default":
                ctext[y.Extension] = y.ContentType;
                break;
            case "<Override":
                if (ct[$3ee4f50b1ae43a89$var$ct2type[y.ContentType]] !== undefined) ct[$3ee4f50b1ae43a89$var$ct2type[y.ContentType]].push(y.PartName);
                break;
        }
    });
    if (ct.xmlns !== $3ee4f50b1ae43a89$var$XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
    ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
    ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
    ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
    ct.defaults = ctext;
    delete ct.calcchains;
    return ct;
}
function $3ee4f50b1ae43a89$var$write_ct(ct, opts) /*:string*/ {
    var type2ct /*{[string]:Array<string>}*/  = $3ee4f50b1ae43a89$var$evert_arr($3ee4f50b1ae43a89$var$ct2type);
    var o /*:Array<string>*/  = [], v;
    o[o.length] = $3ee4f50b1ae43a89$var$XML_HEADER;
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("Types", null, {
        "xmlns": $3ee4f50b1ae43a89$var$XMLNS.CT,
        "xmlns:xsd": $3ee4f50b1ae43a89$var$XMLNS.xsd,
        "xmlns:xsi": $3ee4f50b1ae43a89$var$XMLNS.xsi
    });
    o = o.concat([
        [
            "xml",
            "application/xml"
        ],
        [
            "bin",
            "application/vnd.ms-excel.sheet.binary.macroEnabled.main"
        ],
        [
            "vml",
            "application/vnd.openxmlformats-officedocument.vmlDrawing"
        ],
        [
            "data",
            "application/vnd.openxmlformats-officedocument.model+data"
        ],
        /* from test files */ [
            "bmp",
            "image/bmp"
        ],
        [
            "png",
            "image/png"
        ],
        [
            "gif",
            "image/gif"
        ],
        [
            "emf",
            "image/x-emf"
        ],
        [
            "wmf",
            "image/x-wmf"
        ],
        [
            "jpg",
            "image/jpeg"
        ],
        [
            "jpeg",
            "image/jpeg"
        ],
        [
            "tif",
            "image/tiff"
        ],
        [
            "tiff",
            "image/tiff"
        ],
        [
            "pdf",
            "application/pdf"
        ],
        [
            "rels",
            "application/vnd.openxmlformats-package.relationships+xml"
        ]
    ].map(function(x) {
        return $3ee4f50b1ae43a89$var$writextag("Default", null, {
            "Extension": x[0],
            "ContentType": x[1]
        });
    }));
    /* only write first instance */ var f1 = function(w) {
        if (ct[w] && ct[w].length > 0) {
            v = ct[w][0];
            o[o.length] = $3ee4f50b1ae43a89$var$writextag("Override", null, {
                "PartName": (v[0] == "/" ? "" : "/") + v,
                "ContentType": $3ee4f50b1ae43a89$var$CT_LIST[w][opts.bookType] || $3ee4f50b1ae43a89$var$CT_LIST[w]["xlsx"]
            });
        }
    };
    /* book type-specific */ var f2 = function(w) {
        (ct[w] || []).forEach(function(v) {
            o[o.length] = $3ee4f50b1ae43a89$var$writextag("Override", null, {
                "PartName": (v[0] == "/" ? "" : "/") + v,
                "ContentType": $3ee4f50b1ae43a89$var$CT_LIST[w][opts.bookType] || $3ee4f50b1ae43a89$var$CT_LIST[w]["xlsx"]
            });
        });
    };
    /* standard type */ var f3 = function(t) {
        (ct[t] || []).forEach(function(v) {
            o[o.length] = $3ee4f50b1ae43a89$var$writextag("Override", null, {
                "PartName": (v[0] == "/" ? "" : "/") + v,
                "ContentType": type2ct[t][0]
            });
        });
    };
    f1("workbooks");
    f2("sheets");
    f2("charts");
    f3("themes");
    [
        "strs",
        "styles"
    ].forEach(f1);
    [
        "coreprops",
        "extprops",
        "custprops"
    ].forEach(f3);
    f3("vba");
    f3("comments");
    f3("threadedcomments");
    f3("drawings");
    f2("metadata");
    f3("people");
    if (o.length > 2) {
        o[o.length] = "</Types>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 9.3 Relationships */ var $3ee4f50b1ae43a89$var$RELS = {
    WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
    VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
    XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
    XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
    XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
    CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
    CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
    CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties",
    SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
    STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
    THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
    CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
    CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
    CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
    WS: [
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
        "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
    ],
    DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
    MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
    IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
    DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
    XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
    TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
    PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
    VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
} /*:any*/ ;
/* 9.3.3 Representing Relationships */ function $3ee4f50b1ae43a89$var$get_rels_path(file /*:string*/ ) /*:string*/ {
    var n = file.lastIndexOf("/");
    return file.slice(0, n + 1) + "_rels/" + file.slice(n + 1) + ".rels";
}
function $3ee4f50b1ae43a89$var$parse_rels(data /*:?string*/ , currentFilePath /*:string*/ ) {
    var rels = {
        "!id": {}
    };
    if (!data) return rels;
    if (currentFilePath.charAt(0) !== "/") currentFilePath = "/" + currentFilePath;
    var hash = {};
    (data.match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        /* 9.3.2.2 OPC_Relationships */ if (y[0] === "<Relationship") {
            var rel = {};
            rel.Type = y.Type;
            rel.Target = y.Target;
            rel.Id = y.Id;
            if (y.TargetMode) rel.TargetMode = y.TargetMode;
            var canonictarget = y.TargetMode === "External" ? y.Target : $3ee4f50b1ae43a89$var$resolve_path(y.Target, currentFilePath);
            rels[canonictarget] = rel;
            hash[y.Id] = rel;
        }
    });
    rels["!id"] = hash;
    return rels;
}
/* TODO */ function $3ee4f50b1ae43a89$var$write_rels(rels) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("Relationships", null, {
            //'xmlns:ns0': XMLNS.RELS,
            "xmlns": $3ee4f50b1ae43a89$var$XMLNS.RELS
        })
    ];
    $3ee4f50b1ae43a89$var$keys(rels["!id"]).forEach(function(rid) {
        o[o.length] = $3ee4f50b1ae43a89$var$writextag("Relationship", null, rels["!id"][rid]);
    });
    if (o.length > 2) {
        o[o.length] = "</Relationships>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
function $3ee4f50b1ae43a89$var$add_rels(rels, rId /*:number*/ , f, type, relobj, targetmode /*:?string*/ ) /*:number*/ {
    if (!relobj) relobj = {};
    if (!rels["!id"]) rels["!id"] = {};
    if (!rels["!idx"]) rels["!idx"] = 1;
    if (rId < 0) for(rId = rels["!idx"]; rels["!id"]["rId" + rId]; ++rId);
    rels["!idx"] = rId + 1;
    relobj.Id = "rId" + rId;
    relobj.Type = type;
    relobj.Target = f;
    if (targetmode) relobj.TargetMode = targetmode;
    else if ([
        $3ee4f50b1ae43a89$var$RELS.HLINK,
        $3ee4f50b1ae43a89$var$RELS.XPATH,
        $3ee4f50b1ae43a89$var$RELS.XMISS
    ].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
    if (rels["!id"][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
    rels["!id"][relobj.Id] = relobj;
    rels[("/" + relobj.Target).replace("//", "/")] = relobj;
    return rId;
}
/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */ /* Part 3 Section 4 Manifest File */ var $3ee4f50b1ae43a89$var$CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function $3ee4f50b1ae43a89$var$parse_manifest(d, opts) {
    var str = $3ee4f50b1ae43a89$var$xlml_normalize(d);
    var Rn;
    var FEtag;
    while(Rn = $3ee4f50b1ae43a89$var$xlmlregex.exec(str))switch(Rn[3]){
        case "manifest":
            break; // 4.2 <manifest:manifest>
        case "file-entry":
            FEtag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            if (FEtag.path == "/" && FEtag.type !== $3ee4f50b1ae43a89$var$CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
            break;
        case "encryption-data":
        case "algorithm":
        case "start-key-generation":
        case "key-derivation":
            throw new Error("Unsupported ODS Encryption");
        default:
            if (opts && opts.WTF) throw Rn;
    }
}
function $3ee4f50b1ae43a89$var$write_manifest(manifest /*:Array<Array<string> >*/ ) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
    o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
    for(var i = 0; i < manifest.length; ++i)o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
    o.push("</manifest:manifest>");
    return o.join("");
}
/* Part 3 Section 6 Metadata Manifest File */ function $3ee4f50b1ae43a89$var$write_rdf_type(file /*:string*/ , res /*:string*/ , tag /*:?string*/ ) {
    return [
        '  <rdf:Description rdf:about="' + file + '">\n',
        '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + "#" + res + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $3ee4f50b1ae43a89$var$write_rdf_has(base /*:string*/ , file /*:string*/ ) {
    return [
        '  <rdf:Description rdf:about="' + base + '">\n',
        '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $3ee4f50b1ae43a89$var$write_rdf(rdf) {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
    for(var i = 0; i != rdf.length; ++i){
        o.push($3ee4f50b1ae43a89$var$write_rdf_type(rdf[i][0], rdf[i][1]));
        o.push($3ee4f50b1ae43a89$var$write_rdf_has("", rdf[i][0]));
    }
    o.push($3ee4f50b1ae43a89$var$write_rdf_type("", "Document", "pkg"));
    o.push("</rdf:RDF>");
    return o.join("");
}
/* TODO: pull properties */ function $3ee4f50b1ae43a89$var$write_meta_ods() /*:string*/ {
    return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + $3ee4f50b1ae43a89$var$XLSX.version + "</meta:generator></office:meta></office:document-meta>";
}
/* ECMA-376 Part II 11.1 Core Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $3ee4f50b1ae43a89$var$CORE_PROPS /*:Array<Array<string> >*/  = [
    [
        "cp:category",
        "Category"
    ],
    [
        "cp:contentStatus",
        "ContentStatus"
    ],
    [
        "cp:keywords",
        "Keywords"
    ],
    [
        "cp:lastModifiedBy",
        "LastAuthor"
    ],
    [
        "cp:lastPrinted",
        "LastPrinted"
    ],
    [
        "cp:revision",
        "RevNumber"
    ],
    [
        "cp:version",
        "Version"
    ],
    [
        "dc:creator",
        "Author"
    ],
    [
        "dc:description",
        "Comments"
    ],
    [
        "dc:identifier",
        "Identifier"
    ],
    [
        "dc:language",
        "Language"
    ],
    [
        "dc:subject",
        "Subject"
    ],
    [
        "dc:title",
        "Title"
    ],
    [
        "dcterms:created",
        "CreatedDate",
        "date"
    ],
    [
        "dcterms:modified",
        "ModifiedDate",
        "date"
    ]
];
var $3ee4f50b1ae43a89$var$CORE_PROPS_REGEX /*:Array<RegExp>*/  = /*#__PURE__*/ function() {
    var r = new Array($3ee4f50b1ae43a89$var$CORE_PROPS.length);
    for(var i = 0; i < $3ee4f50b1ae43a89$var$CORE_PROPS.length; ++i){
        var f = $3ee4f50b1ae43a89$var$CORE_PROPS[i];
        var g = "(?:" + f[0].slice(0, f[0].indexOf(":")) + ":)" + f[0].slice(f[0].indexOf(":") + 1);
        r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)</" + g + ">");
    }
    return r;
}();
function $3ee4f50b1ae43a89$var$parse_core_props(data) {
    var p = {};
    data = $3ee4f50b1ae43a89$var$utf8read(data);
    for(var i = 0; i < $3ee4f50b1ae43a89$var$CORE_PROPS.length; ++i){
        var f = $3ee4f50b1ae43a89$var$CORE_PROPS[i], cur = data.match($3ee4f50b1ae43a89$var$CORE_PROPS_REGEX[i]);
        if (cur != null && cur.length > 0) p[f[1]] = $3ee4f50b1ae43a89$var$unescapexml(cur[1]);
        if (f[2] === "date" && p[f[1]]) p[f[1]] = $3ee4f50b1ae43a89$var$parseDate(p[f[1]]);
    }
    return p;
}
function $3ee4f50b1ae43a89$var$cp_doit(f, g, h, o, p) {
    if (p[f] != null || g == null || g === "") return;
    p[f] = g;
    g = $3ee4f50b1ae43a89$var$escapexml(g);
    o[o.length] = h ? $3ee4f50b1ae43a89$var$writextag(f, g, h) : $3ee4f50b1ae43a89$var$writetag(f, g);
}
function $3ee4f50b1ae43a89$var$write_core_props(cp, _opts) {
    var opts = _opts || {};
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("cp:coreProperties", null, {
            //'xmlns': XMLNS.CORE_PROPS,
            "xmlns:cp": $3ee4f50b1ae43a89$var$XMLNS.CORE_PROPS,
            "xmlns:dc": $3ee4f50b1ae43a89$var$XMLNS.dc,
            "xmlns:dcterms": $3ee4f50b1ae43a89$var$XMLNS.dcterms,
            "xmlns:dcmitype": $3ee4f50b1ae43a89$var$XMLNS.dcmitype,
            "xmlns:xsi": $3ee4f50b1ae43a89$var$XMLNS.xsi
        })
    ], p = {};
    if (!cp && !opts.Props) return o.join("");
    if (cp) {
        if (cp.CreatedDate != null) $3ee4f50b1ae43a89$var$cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : $3ee4f50b1ae43a89$var$write_w3cdtf(cp.CreatedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
        if (cp.ModifiedDate != null) $3ee4f50b1ae43a89$var$cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : $3ee4f50b1ae43a89$var$write_w3cdtf(cp.ModifiedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
    }
    for(var i = 0; i != $3ee4f50b1ae43a89$var$CORE_PROPS.length; ++i){
        var f = $3ee4f50b1ae43a89$var$CORE_PROPS[i];
        var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
        if (v === true) v = "1";
        else if (v === false) v = "0";
        else if (typeof v == "number") v = String(v);
        if (v != null) $3ee4f50b1ae43a89$var$cp_doit(f[0], v, null, o, p);
    }
    if (o.length > 2) {
        o[o.length] = "</cp:coreProperties>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $3ee4f50b1ae43a89$var$EXT_PROPS /*:Array<Array<string> >*/  = [
    [
        "Application",
        "Application",
        "string"
    ],
    [
        "AppVersion",
        "AppVersion",
        "string"
    ],
    [
        "Company",
        "Company",
        "string"
    ],
    [
        "DocSecurity",
        "DocSecurity",
        "string"
    ],
    [
        "Manager",
        "Manager",
        "string"
    ],
    [
        "HyperlinksChanged",
        "HyperlinksChanged",
        "bool"
    ],
    [
        "SharedDoc",
        "SharedDoc",
        "bool"
    ],
    [
        "LinksUpToDate",
        "LinksUpToDate",
        "bool"
    ],
    [
        "ScaleCrop",
        "ScaleCrop",
        "bool"
    ],
    [
        "HeadingPairs",
        "HeadingPairs",
        "raw"
    ],
    [
        "TitlesOfParts",
        "TitlesOfParts",
        "raw"
    ]
];
var $3ee4f50b1ae43a89$var$PseudoPropsPairs = [
    "Worksheets",
    "SheetNames",
    "NamedRanges",
    "DefinedNames",
    "Chartsheets",
    "ChartNames"
];
function $3ee4f50b1ae43a89$var$load_props_pairs(HP /*:string|Array<Array<any>>*/ , TOP, props, opts) {
    var v = [];
    if (typeof HP == "string") v = $3ee4f50b1ae43a89$var$parseVector(HP, opts);
    else for(var j = 0; j < HP.length; ++j)v = v.concat(HP[j].map(function(hp) {
        return {
            v: hp
        };
    }));
    var parts = typeof TOP == "string" ? $3ee4f50b1ae43a89$var$parseVector(TOP, opts).map(function(x) {
        return x.v;
    }) : TOP;
    var idx = 0, len = 0;
    if (parts.length > 0) for(var i = 0; i !== v.length; i += 2){
        len = +v[i + 1].v;
        switch(v[i].v){
            case "Worksheets":
            case "\u5DE5\u4F5C\u8868":
            case "\u041B\u0438\u0441\u0442\u044B":
            case "\u0623\u0648\u0631\u0627\u0642 \u0627\u0644\u0639\u0645\u0644":
            case "\u30EF\u30FC\u30AF\u30B7\u30FC\u30C8":
            case "\u05D2\u05DC\u05D9\u05D5\u05E0\u05D5\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4":
            case "Arbeitsbl\xe4tter":
            case "\xc7al\u0131\u015Fma Sayfalar\u0131":
            case "Feuilles de calcul":
            case "Fogli di lavoro":
            case "Folhas de c\xe1lculo":
            case "Planilhas":
            case "Regneark":
            case "Hojas de c\xe1lculo":
            case "Werkbladen":
                props.Worksheets = len;
                props.SheetNames = parts.slice(idx, idx + len);
                break;
            case "Named Ranges":
            case "Rangos con nombre":
            case "\u540D\u524D\u4ED8\u304D\u4E00\u89A7":
            case "Benannte Bereiche":
            case "Navngivne omr\xe5der":
                props.NamedRanges = len;
                props.DefinedNames = parts.slice(idx, idx + len);
                break;
            case "Charts":
            case "Diagramme":
                props.Chartsheets = len;
                props.ChartNames = parts.slice(idx, idx + len);
                break;
        }
        idx += len;
    }
}
function $3ee4f50b1ae43a89$var$parse_ext_props(data, p, opts) {
    var q = {};
    if (!p) p = {};
    data = $3ee4f50b1ae43a89$var$utf8read(data);
    $3ee4f50b1ae43a89$var$EXT_PROPS.forEach(function(f) {
        var xml = (data.match($3ee4f50b1ae43a89$var$matchtag(f[0])) || [])[1];
        switch(f[2]){
            case "string":
                if (xml) p[f[1]] = $3ee4f50b1ae43a89$var$unescapexml(xml);
                break;
            case "bool":
                p[f[1]] = xml === "true";
                break;
            case "raw":
                var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)</" + f[0] + ">"));
                if (cur && cur.length > 0) q[f[1]] = cur[1];
                break;
        }
    });
    if (q.HeadingPairs && q.TitlesOfParts) $3ee4f50b1ae43a89$var$load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
    return p;
}
function $3ee4f50b1ae43a89$var$write_ext_props(cp /*::, opts*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], W = $3ee4f50b1ae43a89$var$writextag;
    if (!cp) cp = {};
    cp.Application = "SheetJS";
    o[o.length] = $3ee4f50b1ae43a89$var$XML_HEADER;
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("Properties", null, {
        "xmlns": $3ee4f50b1ae43a89$var$XMLNS.EXT_PROPS,
        "xmlns:vt": $3ee4f50b1ae43a89$var$XMLNS.vt
    });
    $3ee4f50b1ae43a89$var$EXT_PROPS.forEach(function(f) {
        if (cp[f[1]] === undefined) return;
        var v;
        switch(f[2]){
            case "string":
                v = $3ee4f50b1ae43a89$var$escapexml(String(cp[f[1]]));
                break;
            case "bool":
                v = cp[f[1]] ? "true" : "false";
                break;
        }
        if (v !== undefined) o[o.length] = W(f[0], v);
    });
    /* TODO: HeadingPairs, TitlesOfParts */ o[o.length] = W("HeadingPairs", W("vt:vector", W("vt:variant", "<vt:lpstr>Worksheets</vt:lpstr>") + W("vt:variant", W("vt:i4", String(cp.Worksheets))), {
        size: 2,
        baseType: "variant"
    }));
    o[o.length] = W("TitlesOfParts", W("vt:vector", cp.SheetNames.map(function(s) {
        return "<vt:lpstr>" + $3ee4f50b1ae43a89$var$escapexml(s) + "</vt:lpstr>";
    }).join(""), {
        size: cp.Worksheets,
        baseType: "lpstr"
    }));
    if (o.length > 2) {
        o[o.length] = "</Properties>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */ var $3ee4f50b1ae43a89$var$custregex = /<[^>]+>[^<]*/g;
function $3ee4f50b1ae43a89$var$parse_cust_props(data /*:string*/ , opts) {
    var p = {}, name = "";
    var m = data.match($3ee4f50b1ae43a89$var$custregex);
    if (m) for(var i = 0; i != m.length; ++i){
        var x = m[i], y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch(y[0]){
            case "<?xml":
                break;
            case "<Properties":
                break;
            case "<property":
                name = $3ee4f50b1ae43a89$var$unescapexml(y.name);
                break;
            case "</property>":
                name = null;
                break;
            default:
                if (x.indexOf("<vt:") === 0) {
                    var toks = x.split(">");
                    var type = toks[0].slice(4), text = toks[1];
                    /* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */ switch(type){
                        case "lpstr":
                        case "bstr":
                        case "lpwstr":
                            p[name] = $3ee4f50b1ae43a89$var$unescapexml(text);
                            break;
                        case "bool":
                            p[name] = $3ee4f50b1ae43a89$var$parsexmlbool(text);
                            break;
                        case "i1":
                        case "i2":
                        case "i4":
                        case "i8":
                        case "int":
                        case "uint":
                            p[name] = parseInt(text, 10);
                            break;
                        case "r4":
                        case "r8":
                        case "decimal":
                            p[name] = parseFloat(text);
                            break;
                        case "filetime":
                        case "date":
                            p[name] = $3ee4f50b1ae43a89$var$parseDate(text);
                            break;
                        case "cy":
                        case "error":
                            p[name] = $3ee4f50b1ae43a89$var$unescapexml(text);
                            break;
                        default:
                            if (type.slice(-1) == "/") break;
                            if (opts.WTF && typeof console !== "undefined") console.warn("Unexpected", x, type, toks);
                    }
                } else if (x.slice(0, 2) === "</") ;
                else if (opts.WTF) throw new Error(x);
        }
    }
    return p;
}
function $3ee4f50b1ae43a89$var$write_cust_props(cp /*::, opts*/ ) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("Properties", null, {
            "xmlns": $3ee4f50b1ae43a89$var$XMLNS.CUST_PROPS,
            "xmlns:vt": $3ee4f50b1ae43a89$var$XMLNS.vt
        })
    ];
    if (!cp) return o.join("");
    var pid = 1;
    $3ee4f50b1ae43a89$var$keys(cp).forEach(function custprop(k) {
        ++pid;
        o[o.length] = $3ee4f50b1ae43a89$var$writextag("property", $3ee4f50b1ae43a89$var$write_vt(cp[k], true), {
            "fmtid": "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",
            "pid": pid,
            "name": $3ee4f50b1ae43a89$var$escapexml(k)
        });
    });
    if (o.length > 2) {
        o[o.length] = "</Properties>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* Common Name -> XLML Name */ var $3ee4f50b1ae43a89$var$XLMLDocPropsMap = {
    Title: "Title",
    Subject: "Subject",
    Author: "Author",
    Keywords: "Keywords",
    Comments: "Description",
    LastAuthor: "LastAuthor",
    RevNumber: "Revision",
    Application: "AppName",
    /* TotalTime: 'TotalTime', */ LastPrinted: "LastPrinted",
    CreatedDate: "Created",
    ModifiedDate: "LastSaved",
    /* Pages */ /* Words */ /* Characters */ Category: "Category",
    /* PresentationFormat */ Manager: "Manager",
    Company: "Company",
    /* Guid */ /* HyperlinkBase */ /* Bytes */ /* Lines */ /* Paragraphs */ /* CharactersWithSpaces */ AppVersion: "Version",
    ContentStatus: "ContentStatus",
    /* NOTE: missing from schema */ Identifier: "Identifier",
    /* NOTE: missing from schema */ Language: "Language" /* NOTE: missing from schema */ 
};
var $3ee4f50b1ae43a89$var$evert_XLMLDPM;
function $3ee4f50b1ae43a89$var$xlml_set_prop(Props, tag /*:string*/ , val) {
    if (!$3ee4f50b1ae43a89$var$evert_XLMLDPM) $3ee4f50b1ae43a89$var$evert_XLMLDPM = $3ee4f50b1ae43a89$var$evert($3ee4f50b1ae43a89$var$XLMLDocPropsMap);
    tag = $3ee4f50b1ae43a89$var$evert_XLMLDPM[tag] || tag;
    Props[tag] = val;
}
function $3ee4f50b1ae43a89$var$xlml_write_docprops(Props, opts) {
    var o /*:Array<string>*/  = [];
    $3ee4f50b1ae43a89$var$keys($3ee4f50b1ae43a89$var$XLMLDocPropsMap).map(function(m) {
        for(var i = 0; i < $3ee4f50b1ae43a89$var$CORE_PROPS.length; ++i)if ($3ee4f50b1ae43a89$var$CORE_PROPS[i][1] == m) return $3ee4f50b1ae43a89$var$CORE_PROPS[i];
        for(i = 0; i < $3ee4f50b1ae43a89$var$EXT_PROPS.length; ++i)if ($3ee4f50b1ae43a89$var$EXT_PROPS[i][1] == m) return $3ee4f50b1ae43a89$var$EXT_PROPS[i];
        throw m;
    }).forEach(function(p) {
        if (Props[p[1]] == null) return;
        var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
        switch(p[2]){
            case "date":
                m = new Date(m).toISOString().replace(/\.\d*Z/, "Z");
                break;
        }
        if (typeof m == "number") m = String(m);
        else if (m === true || m === false) m = m ? "1" : "0";
        else if (m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/, "");
        o.push($3ee4f50b1ae43a89$var$writetag($3ee4f50b1ae43a89$var$XLMLDocPropsMap[p[1]] || p[1], m));
    });
    return $3ee4f50b1ae43a89$var$writextag("DocumentProperties", o.join(""), {
        xmlns: $3ee4f50b1ae43a89$var$XLMLNS.o
    });
}
function $3ee4f50b1ae43a89$var$xlml_write_custprops(Props, Custprops /*::, opts*/ ) {
    var BLACKLIST = [
        "Worksheets",
        "SheetNames"
    ];
    var T = "CustomDocumentProperties";
    var o /*:Array<string>*/  = [];
    if (Props) $3ee4f50b1ae43a89$var$keys(Props).forEach(function(k) {
        /*:: if(!Props) return; */ if (!Object.prototype.hasOwnProperty.call(Props, k)) return;
        for(var i = 0; i < $3ee4f50b1ae43a89$var$CORE_PROPS.length; ++i)if (k == $3ee4f50b1ae43a89$var$CORE_PROPS[i][1]) return;
        for(i = 0; i < $3ee4f50b1ae43a89$var$EXT_PROPS.length; ++i)if (k == $3ee4f50b1ae43a89$var$EXT_PROPS[i][1]) return;
        for(i = 0; i < BLACKLIST.length; ++i)if (k == BLACKLIST[i]) return;
        var m = Props[k];
        var t = "string";
        if (typeof m == "number") {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else m = String(m);
        o.push($3ee4f50b1ae43a89$var$writextag($3ee4f50b1ae43a89$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    if (Custprops) $3ee4f50b1ae43a89$var$keys(Custprops).forEach(function(k) {
        /*:: if(!Custprops) return; */ if (!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
        if (Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
        var m = Custprops[k];
        var t = "string";
        if (typeof m == "number") {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else if (m instanceof Date) {
            t = "dateTime.tz";
            m = m.toISOString();
        } else m = String(m);
        o.push($3ee4f50b1ae43a89$var$writextag($3ee4f50b1ae43a89$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    return "<" + T + ' xmlns="' + $3ee4f50b1ae43a89$var$XLMLNS.o + '">' + o.join("") + "</" + T + ">";
}
/* [MS-DTYP] 2.3.3 FILETIME */ /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */ /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */ function $3ee4f50b1ae43a89$var$parse_FILETIME(blob) {
    var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
    return new Date((dwHighDateTime / 1e7 * Math.pow(2, 32) + dwLowDateTime / 1e7 - 11644473600) * 1000).toISOString().replace(/\.000/, "");
}
function $3ee4f50b1ae43a89$var$write_FILETIME(time /*:string|Date*/ ) {
    var date = typeof time == "string" ? new Date(Date.parse(time)) : time;
    var t = date.getTime() / 1000 + 11644473600;
    var l = t % Math.pow(2, 32), h = (t - l) / Math.pow(2, 32);
    l *= 1e7;
    h *= 1e7;
    var w = l / Math.pow(2, 32) | 0;
    if (w > 0) {
        l = l % Math.pow(2, 32);
        h += w;
    }
    var o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(4, l);
    o.write_shift(4, h);
    return o;
}
/* [MS-OSHARED] 2.3.3.1.4 Lpstr */ function $3ee4f50b1ae43a89$var$parse_lpstr(blob, type, pad /*:?number*/ ) {
    var start = blob.l;
    var str = blob.read_shift(0, "lpstr-cp");
    if (pad) while(blob.l - start & 3)++blob.l;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */ function $3ee4f50b1ae43a89$var$parse_lpwstr(blob, type, pad) {
    var str = blob.read_shift(0, "lpwstr");
    if (pad) blob.l += 4 - (str.length + 1 & 3) & 3;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.11 VtString */ /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */ function $3ee4f50b1ae43a89$var$parse_VtStringBase(blob, stringType, pad) {
    if (stringType === 0x1F /*VT_LPWSTR*/ ) return $3ee4f50b1ae43a89$var$parse_lpwstr(blob);
    return $3ee4f50b1ae43a89$var$parse_lpstr(blob, stringType, pad);
}
function $3ee4f50b1ae43a89$var$parse_VtString(blob, t /*:number*/ , pad /*:?boolean*/ ) {
    return $3ee4f50b1ae43a89$var$parse_VtStringBase(blob, t, pad === false ? 0 : 4);
}
function $3ee4f50b1ae43a89$var$parse_VtUnalignedString(blob, t /*:number*/ ) {
    if (!t) throw new Error("VtUnalignedString must have positive length");
    return $3ee4f50b1ae43a89$var$parse_VtStringBase(blob, t, 0);
}
/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */ function $3ee4f50b1ae43a89$var$parse_VtVecLpwstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i){
        var start = blob.l;
        ret[i] = blob.read_shift(0, "lpwstr").replace($3ee4f50b1ae43a89$var$chr0, "");
        if (blob.l - start & 0x02) blob.l += 2;
    }
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */ function $3ee4f50b1ae43a89$var$parse_VtVecUnalignedLpstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i)ret[i] = blob.read_shift(0, "lpstr-cp").replace($3ee4f50b1ae43a89$var$chr0, "");
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */ function $3ee4f50b1ae43a89$var$parse_VtHeadingPair(blob) {
    var start = blob.l;
    var headingString = $3ee4f50b1ae43a89$var$parse_TypedPropertyValue(blob, $3ee4f50b1ae43a89$var$VT_USTR);
    if (blob[blob.l] == 0x00 && blob[blob.l + 1] == 0x00 && blob.l - start & 0x02) blob.l += 2;
    var headerParts = $3ee4f50b1ae43a89$var$parse_TypedPropertyValue(blob, $3ee4f50b1ae43a89$var$VT_I4);
    return [
        headingString,
        headerParts
    ];
}
/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */ function $3ee4f50b1ae43a89$var$parse_VtVecHeadingPairValue(blob) {
    var cElements = blob.read_shift(4);
    var out = [];
    for(var i = 0; i < cElements / 2; ++i)out.push($3ee4f50b1ae43a89$var$parse_VtHeadingPair(blob));
    return out;
}
/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */ function $3ee4f50b1ae43a89$var$parse_dictionary(blob, CodePage) {
    var cnt = blob.read_shift(4);
    var dict /*:{[number]:string}*/  = {} /*:any*/ ;
    for(var j = 0; j != cnt; ++j){
        var pid = blob.read_shift(4);
        var len = blob.read_shift(4);
        dict[pid] = blob.read_shift(len, CodePage === 0x4B0 ? "utf16le" : "utf8").replace($3ee4f50b1ae43a89$var$chr0, "").replace($3ee4f50b1ae43a89$var$chr1, "!");
        if (CodePage === 0x4B0 && len % 2) blob.l += 2;
    }
    if (blob.l & 3) blob.l = blob.l >> 3 << 2;
    return dict;
}
/* [MS-OLEPS] 2.9 BLOB */ function $3ee4f50b1ae43a89$var$parse_BLOB(blob) {
    var size = blob.read_shift(4);
    var bytes = blob.slice(blob.l, blob.l + size);
    blob.l += size;
    if ((size & 3) > 0) blob.l += 4 - (size & 3) & 3;
    return bytes;
}
/* [MS-OLEPS] 2.11 ClipboardData */ function $3ee4f50b1ae43a89$var$parse_ClipboardData(blob) {
    // TODO
    var o = {};
    o.Size = blob.read_shift(4);
    //o.Format = blob.read_shift(4);
    blob.l += o.Size + 3 - (o.Size - 1) % 4;
    return o;
}
/* [MS-OLEPS] 2.15 TypedPropertyValue */ function $3ee4f50b1ae43a89$var$parse_TypedPropertyValue(blob, type /*:number*/ , _opts) /*:any*/ {
    var t = blob.read_shift(2), ret, opts = _opts || {};
    blob.l += 2;
    if (type !== $3ee4f50b1ae43a89$var$VT_VARIANT) {
        if (t !== type && $3ee4f50b1ae43a89$var$VT_CUSTOM.indexOf(type) === -1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error("Expected type " + type + " saw " + t);
    }
    switch(type === $3ee4f50b1ae43a89$var$VT_VARIANT ? t : type){
        case 0x02 /*VT_I2*/ :
            ret = blob.read_shift(2, "i");
            if (!opts.raw) blob.l += 2;
            return ret;
        case 0x03 /*VT_I4*/ :
            ret = blob.read_shift(4, "i");
            return ret;
        case 0x0B /*VT_BOOL*/ :
            return blob.read_shift(4) !== 0x0;
        case 0x13 /*VT_UI4*/ :
            ret = blob.read_shift(4);
            return ret;
        case 0x1E /*VT_LPSTR*/ :
            return $3ee4f50b1ae43a89$var$parse_lpstr(blob, t, 4).replace($3ee4f50b1ae43a89$var$chr0, "");
        case 0x1F /*VT_LPWSTR*/ :
            return $3ee4f50b1ae43a89$var$parse_lpwstr(blob);
        case 0x40 /*VT_FILETIME*/ :
            return $3ee4f50b1ae43a89$var$parse_FILETIME(blob);
        case 0x41 /*VT_BLOB*/ :
            return $3ee4f50b1ae43a89$var$parse_BLOB(blob);
        case 0x47 /*VT_CF*/ :
            return $3ee4f50b1ae43a89$var$parse_ClipboardData(blob);
        case 0x50 /*VT_STRING*/ :
            return $3ee4f50b1ae43a89$var$parse_VtString(blob, t, !opts.raw).replace($3ee4f50b1ae43a89$var$chr0, "");
        case 0x51 /*VT_USTR*/ :
            return $3ee4f50b1ae43a89$var$parse_VtUnalignedString(blob, t /*, 4*/ ).replace($3ee4f50b1ae43a89$var$chr0, "");
        case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
            return $3ee4f50b1ae43a89$var$parse_VtVecHeadingPairValue(blob);
        case 0x101E /*VT_VECTOR|VT_LPSTR*/ :
        case 0x101F /*VT_VECTOR|VT_LPWSTR*/ :
            return t == 0x101F ? $3ee4f50b1ae43a89$var$parse_VtVecLpwstrValue(blob) : $3ee4f50b1ae43a89$var$parse_VtVecUnalignedLpstrValue(blob);
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
    }
}
function $3ee4f50b1ae43a89$var$write_TypedPropertyValue(type /*:number*/ , value) {
    var o = $3ee4f50b1ae43a89$var$new_buf(4), p = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(4, type == 0x50 ? 0x1F : type);
    switch(type){
        case 0x03 /*VT_I4*/ :
            p.write_shift(-4, value);
            break;
        case 0x05 /*VT_I4*/ :
            p = $3ee4f50b1ae43a89$var$new_buf(8);
            p.write_shift(8, value, "f");
            break;
        case 0x0B /*VT_BOOL*/ :
            p.write_shift(4, value ? 0x01 : 0x00);
            break;
        case 0x40 /*VT_FILETIME*/ :
            /*:: if(typeof value !== "string" && !(value instanceof Date)) throw "unreachable"; */ p = $3ee4f50b1ae43a89$var$write_FILETIME(value);
            break;
        case 0x1F /*VT_LPWSTR*/ :
        case 0x50 /*VT_STRING*/ :
            /*:: if(typeof value !== "string") throw "unreachable"; */ p = $3ee4f50b1ae43a89$var$new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            p.write_shift(4, value.length + 1);
            p.write_shift(0, value, "dbcs");
            while(p.l != p.length)p.write_shift(1, 0);
            break;
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
    }
    return $3ee4f50b1ae43a89$var$bconcat([
        o,
        p
    ]);
}
/* [MS-OLEPS] 2.20 PropertySet */ function $3ee4f50b1ae43a89$var$parse_PropertySet(blob, PIDSI) {
    var start_addr = blob.l;
    var size = blob.read_shift(4);
    var NumProps = blob.read_shift(4);
    var Props = [], i = 0;
    var CodePage = 0;
    var Dictionary = -1, DictObj /*:{[number]:string}*/  = {} /*:any*/ ;
    for(i = 0; i != NumProps; ++i){
        var PropID = blob.read_shift(4);
        var Offset = blob.read_shift(4);
        Props[i] = [
            PropID,
            Offset + start_addr
        ];
    }
    Props.sort(function(x, y) {
        return x[1] - y[1];
    });
    var PropH = {};
    for(i = 0; i != NumProps; ++i){
        if (blob.l !== Props[i][1]) {
            var fail = true;
            if (i > 0 && PIDSI) switch(PIDSI[Props[i - 1][0]].t){
                case 0x02 /*VT_I2*/ :
                    if (blob.l + 2 === Props[i][1]) {
                        blob.l += 2;
                        fail = false;
                    }
                    break;
                case 0x50 /*VT_STRING*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
                case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
            }
            if ((!PIDSI || i == 0) && blob.l <= Props[i][1]) {
                fail = false;
                blob.l = Props[i][1];
            }
            if (fail) throw new Error("Read Error: Expected address " + Props[i][1] + " at " + blob.l + " :" + i);
        }
        if (PIDSI) {
            var piddsi = PIDSI[Props[i][0]];
            PropH[piddsi.n] = $3ee4f50b1ae43a89$var$parse_TypedPropertyValue(blob, piddsi.t, {
                raw: true
            });
            if (piddsi.p === "version") PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
            if (piddsi.n == "CodePage") switch(PropH[piddsi.n]){
                case 0:
                    PropH[piddsi.n] = 1252;
                /* falls through */ case 874:
                case 932:
                case 936:
                case 949:
                case 950:
                case 1250:
                case 1251:
                case 1253:
                case 1254:
                case 1255:
                case 1256:
                case 1257:
                case 1258:
                case 10000:
                case 1200:
                case 1201:
                case 1252:
                case 65000:
                case -536:
                case 65001:
                case -535:
                    $3ee4f50b1ae43a89$var$set_cp(CodePage = PropH[piddsi.n] >>> 0 & 0xFFFF);
                    break;
                default:
                    throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
            }
        } else {
            if (Props[i][0] === 0x1) {
                CodePage = PropH.CodePage = $3ee4f50b1ae43a89$var$parse_TypedPropertyValue(blob, $3ee4f50b1ae43a89$var$VT_I2);
                $3ee4f50b1ae43a89$var$set_cp(CodePage);
                if (Dictionary !== -1) {
                    var oldpos = blob.l;
                    blob.l = Props[Dictionary][1];
                    DictObj = $3ee4f50b1ae43a89$var$parse_dictionary(blob, CodePage);
                    blob.l = oldpos;
                }
            } else if (Props[i][0] === 0) {
                if (CodePage === 0) {
                    Dictionary = i;
                    blob.l = Props[i + 1][1];
                    continue;
                }
                DictObj = $3ee4f50b1ae43a89$var$parse_dictionary(blob, CodePage);
            } else {
                var name = DictObj[Props[i][0]];
                var val;
                /* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */ switch(blob[blob.l]){
                    case 0x41 /*VT_BLOB*/ :
                        blob.l += 4;
                        val = $3ee4f50b1ae43a89$var$parse_BLOB(blob);
                        break;
                    case 0x1E /*VT_LPSTR*/ :
                        blob.l += 4;
                        val = $3ee4f50b1ae43a89$var$parse_VtString(blob, blob[blob.l - 4]).replace(/\u0000+$/, "");
                        break;
                    case 0x1F /*VT_LPWSTR*/ :
                        blob.l += 4;
                        val = $3ee4f50b1ae43a89$var$parse_VtString(blob, blob[blob.l - 4]).replace(/\u0000+$/, "");
                        break;
                    case 0x03 /*VT_I4*/ :
                        blob.l += 4;
                        val = blob.read_shift(4, "i");
                        break;
                    case 0x13 /*VT_UI4*/ :
                        blob.l += 4;
                        val = blob.read_shift(4);
                        break;
                    case 0x05 /*VT_R8*/ :
                        blob.l += 4;
                        val = blob.read_shift(8, "f");
                        break;
                    case 0x0B /*VT_BOOL*/ :
                        blob.l += 4;
                        val = $3ee4f50b1ae43a89$var$parsebool(blob, 4);
                        break;
                    case 0x40 /*VT_FILETIME*/ :
                        blob.l += 4;
                        val = $3ee4f50b1ae43a89$var$parseDate($3ee4f50b1ae43a89$var$parse_FILETIME(blob));
                        break;
                    default:
                        throw new Error("unparsed value: " + blob[blob.l]);
                }
                PropH[name] = val;
            }
        }
    }
    blob.l = start_addr + size; /* step ahead to skip padding */ 
    return PropH;
}
var $3ee4f50b1ae43a89$var$XLSPSSkip = [
    "CodePage",
    "Thumbnail",
    "_PID_LINKBASE",
    "_PID_HLINKS",
    "SystemIdentifier",
    "FMTID"
]; //.concat(PseudoPropsPairs);
function $3ee4f50b1ae43a89$var$guess_property_type(val /*:any*/ ) /*:number*/ {
    switch(typeof val){
        case "boolean":
            return 0x0B;
        case "number":
            return (val | 0) == val ? 0x03 : 0x05;
        case "string":
            return 0x1F;
        case "object":
            if (val instanceof Date) return 0x40;
            break;
    }
    return -1;
}
function $3ee4f50b1ae43a89$var$write_PropertySet(entries, RE, PIDSI) {
    var hdr = $3ee4f50b1ae43a89$var$new_buf(8), piao = [], prop = [];
    var sz = 8, i = 0;
    var pr = $3ee4f50b1ae43a89$var$new_buf(8), pio = $3ee4f50b1ae43a89$var$new_buf(8);
    pr.write_shift(4, 0x0002);
    pr.write_shift(4, 0x04B0);
    pio.write_shift(4, 0x0001);
    prop.push(pr);
    piao.push(pio);
    sz += 8 + pr.length;
    if (!RE) {
        pio = $3ee4f50b1ae43a89$var$new_buf(8);
        pio.write_shift(4, 0);
        piao.unshift(pio);
        var bufs = [
            $3ee4f50b1ae43a89$var$new_buf(4)
        ];
        bufs[0].write_shift(4, entries.length);
        for(i = 0; i < entries.length; ++i){
            var value = entries[i][0];
            pr = $3ee4f50b1ae43a89$var$new_buf(8 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            pr.write_shift(4, i + 2);
            pr.write_shift(4, value.length + 1);
            pr.write_shift(0, value, "dbcs");
            while(pr.l != pr.length)pr.write_shift(1, 0);
            bufs.push(pr);
        }
        pr = $3ee4f50b1ae43a89$var$bconcat(bufs);
        prop.unshift(pr);
        sz += 8 + pr.length;
    }
    for(i = 0; i < entries.length; ++i){
        if (RE && !RE[entries[i][0]]) continue;
        if ($3ee4f50b1ae43a89$var$XLSPSSkip.indexOf(entries[i][0]) > -1 || $3ee4f50b1ae43a89$var$PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
        if (entries[i][1] == null) continue;
        var val = entries[i][1], idx = 0;
        if (RE) {
            idx = +RE[entries[i][0]];
            var pinfo = PIDSI /*:: || {}*/ [idx] /*:: || {} */ ;
            if (pinfo.p == "version" && typeof val == "string") {
                /*:: if(typeof val !== "string") throw "unreachable"; */ var arr = val.split(".");
                val = (+arr[0] << 16) + (+arr[1] || 0);
            }
            pr = $3ee4f50b1ae43a89$var$write_TypedPropertyValue(pinfo.t, val);
        } else {
            var T = $3ee4f50b1ae43a89$var$guess_property_type(val);
            if (T == -1) {
                T = 0x1F;
                val = String(val);
            }
            pr = $3ee4f50b1ae43a89$var$write_TypedPropertyValue(T, val);
        }
        prop.push(pr);
        pio = $3ee4f50b1ae43a89$var$new_buf(8);
        pio.write_shift(4, !RE ? 2 + i : idx);
        piao.push(pio);
        sz += 8 + pr.length;
    }
    var w = 8 * (prop.length + 1);
    for(i = 0; i < prop.length; ++i){
        piao[i].write_shift(4, w);
        w += prop[i].length;
    }
    hdr.write_shift(4, sz);
    hdr.write_shift(4, prop.length);
    return $3ee4f50b1ae43a89$var$bconcat([
        hdr
    ].concat(piao).concat(prop));
}
/* [MS-OLEPS] 2.21 PropertySetStream */ function $3ee4f50b1ae43a89$var$parse_PropertySetStream(file, PIDSI, clsid) {
    var blob = file.content;
    if (!blob) return {} /*:any*/ ;
    $3ee4f50b1ae43a89$var$prep_blob(blob, 0);
    var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
    blob.chk("feff", "Byte Order: ");
    /*var vers = */ blob.read_shift(2); // TODO: check version
    var SystemIdentifier = blob.read_shift(4);
    var CLSID = blob.read_shift(16);
    if (CLSID !== $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
    NumSets = blob.read_shift(4);
    if (NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
    FMTID0 = blob.read_shift(16);
    Offset0 = blob.read_shift(4);
    if (NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
    else if (NumSets === 2) {
        FMTID1 = blob.read_shift(16);
        Offset1 = blob.read_shift(4);
    }
    var PSet0 = $3ee4f50b1ae43a89$var$parse_PropertySet(blob, PIDSI);
    var rval = {
        SystemIdentifier: SystemIdentifier
    } /*:any*/ ;
    for(var y in PSet0)rval[y] = PSet0[y];
    //rval.blob = blob;
    rval.FMTID = FMTID0;
    //rval.PSet0 = PSet0;
    if (NumSets === 1) return rval;
    if (Offset1 - blob.l == 2) blob.l += 2;
    if (blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
    var PSet1;
    try {
        PSet1 = $3ee4f50b1ae43a89$var$parse_PropertySet(blob, null);
    } catch (e) {}
    for(y in PSet1)rval[y] = PSet1[y];
    rval.FMTID = [
        FMTID0,
        FMTID1
    ]; // TODO: verify FMTID0/1
    return rval;
}
function $3ee4f50b1ae43a89$var$write_PropertySetStream(entries, clsid, RE, PIDSI /*:{[key:string|number]:any}*/ , entries2 /*:?any*/ , clsid2 /*:?any*/ ) {
    var hdr = $3ee4f50b1ae43a89$var$new_buf(entries2 ? 68 : 48);
    var bufs = [
        hdr
    ];
    hdr.write_shift(2, 0xFFFE);
    hdr.write_shift(2, 0x0000); /* TODO: type 1 props */ 
    hdr.write_shift(4, 0x32363237);
    hdr.write_shift(16, $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID, "hex");
    hdr.write_shift(4, entries2 ? 2 : 1);
    hdr.write_shift(16, clsid, "hex");
    hdr.write_shift(4, entries2 ? 68 : 48);
    var ps0 = $3ee4f50b1ae43a89$var$write_PropertySet(entries, RE, PIDSI);
    bufs.push(ps0);
    if (entries2) {
        var ps1 = $3ee4f50b1ae43a89$var$write_PropertySet(entries2, null, null);
        hdr.write_shift(16, clsid2, "hex");
        hdr.write_shift(4, 68 + ps0.length);
        bufs.push(ps1);
    }
    return $3ee4f50b1ae43a89$var$bconcat(bufs);
}
function $3ee4f50b1ae43a89$var$parsenoop2(blob, length) {
    blob.read_shift(length);
    return null;
}
function $3ee4f50b1ae43a89$var$writezeroes(n, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(n);
    for(var j = 0; j < n; ++j)o.write_shift(1, 0);
    return o;
}
function $3ee4f50b1ae43a89$var$parslurp(blob, length, cb) {
    var arr = [], target = blob.l + length;
    while(blob.l < target)arr.push(cb(blob, target - blob.l));
    if (target !== blob.l) throw new Error("Slurp error");
    return arr;
}
function $3ee4f50b1ae43a89$var$parsebool(blob, length /*:number*/ ) {
    return blob.read_shift(length) === 0x1;
}
function $3ee4f50b1ae43a89$var$writebool(v /*:any*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(2);
    o.write_shift(2, +!!v);
    return o;
}
function $3ee4f50b1ae43a89$var$parseuint16(blob /*::, length:?number, opts:?any*/ ) {
    return blob.read_shift(2, "u");
}
function $3ee4f50b1ae43a89$var$writeuint16(v /*:number*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(2);
    o.write_shift(2, v);
    return o;
}
function $3ee4f50b1ae43a89$var$parseuint16a(blob, length /*:: :?number, opts:?any*/ ) {
    return $3ee4f50b1ae43a89$var$parslurp(blob, length, $3ee4f50b1ae43a89$var$parseuint16);
}
/* --- 2.5 Structures --- */ /* [MS-XLS] 2.5.10 Bes (boolean or error) */ function $3ee4f50b1ae43a89$var$parse_Bes(blob /*::, length*/ ) {
    var v = blob.read_shift(1), t = blob.read_shift(1);
    return t === 0x01 ? v : v === 0x01;
}
function $3ee4f50b1ae43a89$var$write_Bes(v, t /*:string*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(2);
    o.write_shift(1, t == "e" ? +v : +!!v);
    o.write_shift(1, t == "e" ? 1 : 0);
    return o;
}
/* [MS-XLS] 2.5.240 ShortXLUnicodeString */ function $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
    var encoding = "sbcs-cont";
    var cp = $3ee4f50b1ae43a89$var$current_codepage;
    if (opts && opts.biff >= 8) $3ee4f50b1ae43a89$var$current_codepage = 1200;
    if (!opts || opts.biff == 8) {
        var fHighByte = blob.read_shift(1);
        if (fHighByte) encoding = "dbcs-cont";
    } else if (opts.biff == 12) encoding = "wstr";
    if (opts.biff >= 2 && opts.biff <= 5) encoding = "cpstr";
    var o = cch ? blob.read_shift(cch, encoding) : "";
    $3ee4f50b1ae43a89$var$current_codepage = cp;
    return o;
}
/* 2.5.293 XLUnicodeRichExtendedString */ function $3ee4f50b1ae43a89$var$parse_XLUnicodeRichExtendedString(blob) {
    var cp = $3ee4f50b1ae43a89$var$current_codepage;
    $3ee4f50b1ae43a89$var$current_codepage = 1200;
    var cch = blob.read_shift(2), flags = blob.read_shift(1);
    var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
    var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
    var cRun = 0, cbExtRst;
    var z = {};
    if (fRichSt) cRun = blob.read_shift(2);
    if (fExtSt) cbExtRst = blob.read_shift(4);
    var encoding = width == 2 ? "dbcs-cont" : "sbcs-cont";
    var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
    if (fRichSt) blob.l += 4 * cRun; //TODO: parse this
    if (fExtSt) blob.l += cbExtRst; //TODO: parse this
    z.t = msg;
    if (!fRichSt) {
        z.raw = "<t>" + z.t + "</t>";
        z.r = z.t;
    }
    $3ee4f50b1ae43a89$var$current_codepage = cp;
    return z;
}
function $3ee4f50b1ae43a89$var$write_XLUnicodeRichExtendedString(xlstr /*:: :XLString, opts*/ ) {
    var str = xlstr.t || "", nfmts = 1;
    var hdr = $3ee4f50b1ae43a89$var$new_buf(3 + (nfmts > 1 ? 2 : 0));
    hdr.write_shift(2, str.length);
    hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
    if (nfmts > 1) hdr.write_shift(2, nfmts);
    var otext = $3ee4f50b1ae43a89$var$new_buf(2 * str.length);
    otext.write_shift(2 * str.length, str, "utf16le");
    var out = [
        hdr,
        otext
    ];
    return $3ee4f50b1ae43a89$var$bconcat(out);
}
/* 2.5.296 XLUnicodeStringNoCch */ function $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cch, opts) {
    var retval;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, "cpstr");
        if (opts.biff >= 12) return blob.read_shift(cch, "dbcs-cont");
    }
    var fHighByte = blob.read_shift(1);
    if (fHighByte === 0) retval = blob.read_shift(cch, "sbcs-cont");
    else retval = blob.read_shift(cch, "dbcs-cont");
    return retval;
}
/* 2.5.294 XLUnicodeString */ function $3ee4f50b1ae43a89$var$parse_XLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */ function $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, length, opts) {
    if (opts.biff > 5) return $3ee4f50b1ae43a89$var$parse_XLUnicodeString(blob, length, opts);
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, opts.biff <= 4 || !blob.lens ? "cpstr" : "sbcs-cont");
}
/* TODO: BIFF5 and lower, codepage awareness */ function $3ee4f50b1ae43a89$var$write_XLUnicodeString(str, opts, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(3 + 2 * str.length);
    o.write_shift(2, str.length);
    o.write_shift(1, 1);
    o.write_shift(31, str, "utf16le");
    return o;
}
/* [MS-XLS] 2.5.61 ControlInfo */ function $3ee4f50b1ae43a89$var$parse_ControlInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(1);
    blob.l++;
    var accel = blob.read_shift(2);
    blob.l += 2;
    return [
        flags,
        accel
    ];
}
/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */ function $3ee4f50b1ae43a89$var$parse_URLMoniker(blob /*::, length, opts*/ ) {
    var len = blob.read_shift(4), start = blob.l;
    var extra = false;
    if (len > 24) {
        /* look ahead */ blob.l += len - 24;
        if (blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
        blob.l = start;
    }
    var url = blob.read_shift((extra ? len - 24 : len) >> 1, "utf16le").replace($3ee4f50b1ae43a89$var$chr0, "");
    if (extra) blob.l += 24;
    return url;
}
/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */ function $3ee4f50b1ae43a89$var$parse_FileMoniker(blob /*::, length*/ ) {
    var cAnti = blob.read_shift(2);
    var preamble = "";
    while(cAnti-- > 0)preamble += "../";
    var ansiPath = blob.read_shift(0, "lpstr-ansi");
    blob.l += 2; //var endServer = blob.read_shift(2);
    if (blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
    var sz = blob.read_shift(4);
    if (sz === 0) return preamble + ansiPath.replace(/\\/g, "/");
    var bytes = blob.read_shift(4);
    if (blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
    var unicodePath = blob.read_shift(bytes >> 1, "utf16le").replace($3ee4f50b1ae43a89$var$chr0, "");
    return preamble + unicodePath;
}
/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */ function $3ee4f50b1ae43a89$var$parse_HyperlinkMoniker(blob, length) {
    var clsid = blob.read_shift(16);
    length -= 16;
    switch(clsid){
        case "e0c9ea79f9bace118c8200aa004ba90b":
            return $3ee4f50b1ae43a89$var$parse_URLMoniker(blob, length);
        case "0303000000000000c000000000000046":
            return $3ee4f50b1ae43a89$var$parse_FileMoniker(blob, length);
        default:
            throw new Error("Unsupported Moniker " + clsid);
    }
}
/* [MS-OSHARED] 2.3.7.9 HyperlinkString */ function $3ee4f50b1ae43a89$var$parse_HyperlinkString(blob /*::, length*/ ) {
    var len = blob.read_shift(4);
    var o = len > 0 ? blob.read_shift(len, "utf16le").replace($3ee4f50b1ae43a89$var$chr0, "") : "";
    return o;
}
function $3ee4f50b1ae43a89$var$write_HyperlinkString(str /*:string*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(6 + str.length * 2);
    o.write_shift(4, 1 + str.length);
    for(var i = 0; i < str.length; ++i)o.write_shift(2, str.charCodeAt(i));
    o.write_shift(2, 0);
    return o;
}
/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */ function $3ee4f50b1ae43a89$var$parse_Hyperlink(blob, length) /*:Hyperlink*/ {
    var end = blob.l + length;
    var sVer = blob.read_shift(4);
    if (sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
    var flags = blob.read_shift(2);
    blob.l += 2;
    var displayName, targetFrameName, moniker, oleMoniker, Loc = "", guid, fileTime;
    if (flags & 0x0010) displayName = $3ee4f50b1ae43a89$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0080) targetFrameName = $3ee4f50b1ae43a89$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0101) moniker = $3ee4f50b1ae43a89$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0001) oleMoniker = $3ee4f50b1ae43a89$var$parse_HyperlinkMoniker(blob, end - blob.l);
    if (flags & 0x0008) Loc = $3ee4f50b1ae43a89$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0020) guid = blob.read_shift(16);
    if (flags & 0x0040) fileTime = $3ee4f50b1ae43a89$var$parse_FILETIME(blob /*, 8*/ );
    blob.l = end;
    var target = targetFrameName || moniker || oleMoniker || "";
    if (target && Loc) target += "#" + Loc;
    if (!target) target = "#" + Loc;
    if (flags & 0x0002 && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
    var out = {
        Target: target
    } /*:any*/ ;
    if (guid) out.guid = guid;
    if (fileTime) out.time = fileTime;
    if (displayName) out.Tooltip = displayName;
    return out;
}
function $3ee4f50b1ae43a89$var$write_Hyperlink(hl) {
    var out = $3ee4f50b1ae43a89$var$new_buf(512), i = 0;
    var Target = hl.Target;
    if (Target.slice(0, 7) == "file://") Target = Target.slice(7);
    var hashidx = Target.indexOf("#");
    var F = hashidx > -1 ? 0x1f : 0x17;
    switch(Target.charAt(0)){
        case "#":
            F = 0x1c;
            break;
        case ".":
            F &= -3;
            break;
    }
    out.write_shift(4, 2);
    out.write_shift(4, F);
    var data = [
        8,
        6815827,
        6619237,
        4849780,
        83
    ];
    for(i = 0; i < data.length; ++i)out.write_shift(4, data[i]);
    if (F == 0x1C) {
        Target = Target.slice(1);
        $3ee4f50b1ae43a89$var$write_HyperlinkString(Target, out);
    } else if (F & 0x02) {
        data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
        out.write_shift(4, 2 * (Pretarget.length + 1));
        for(i = 0; i < Pretarget.length; ++i)out.write_shift(2, Pretarget.charCodeAt(i));
        out.write_shift(2, 0);
        if (F & 0x08) $3ee4f50b1ae43a89$var$write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx + 1) : "", out);
    } else {
        data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var P = 0;
        while(Target.slice(P * 3, P * 3 + 3) == "../" || Target.slice(P * 3, P * 3 + 3) == "..\\")++P;
        out.write_shift(2, P);
        out.write_shift(4, Target.length - 3 * P + 1);
        for(i = 0; i < Target.length - 3 * P; ++i)out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
        out.write_shift(1, 0);
        out.write_shift(2, 0xFFFF);
        out.write_shift(2, 0xDEAD);
        for(i = 0; i < 6; ++i)out.write_shift(4, 0);
    }
    return out.slice(0, out.l);
}
/* 2.5.178 LongRGBA */ function $3ee4f50b1ae43a89$var$parse_LongRGBA(blob /*::, length*/ ) {
    var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1);
    return [
        r,
        g,
        b,
        a
    ];
}
/* 2.5.177 LongRGB */ function $3ee4f50b1ae43a89$var$parse_LongRGB(blob, length) {
    var x = $3ee4f50b1ae43a89$var$parse_LongRGBA(blob, length);
    x[3] = 0;
    return x;
}
/* [MS-XLS] 2.5.19 */ function $3ee4f50b1ae43a89$var$parse_XLSCell(blob /*::, length*/ ) /*:Cell*/ {
    var rw = blob.read_shift(2); // 0-indexed
    var col = blob.read_shift(2);
    var ixfe = blob.read_shift(2);
    return {
        r: rw,
        c: col,
        ixfe: ixfe
    } /*:any*/ ;
}
function $3ee4f50b1ae43a89$var$write_XLSCell(R /*:number*/ , C /*:number*/ , ixfe /*:?number*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(6);
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, ixfe || 0);
    return o;
}
/* [MS-XLS] 2.5.134 */ function $3ee4f50b1ae43a89$var$parse_frtHeader(blob) {
    var rt = blob.read_shift(2);
    var flags = blob.read_shift(2); // TODO: parse these flags
    blob.l += 8;
    return {
        type: rt,
        flags: flags
    };
}
function $3ee4f50b1ae43a89$var$parse_OptXLUnicodeString(blob, length, opts) {
    return length === 0 ? "" : $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, length, opts);
}
/* [MS-XLS] 2.5.344 */ function $3ee4f50b1ae43a89$var$parse_XTI(blob, length, opts) {
    var w = opts.biff > 8 ? 4 : 2;
    var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w, "i"), itabLast = blob.read_shift(w, "i");
    return [
        iSupBook,
        itabFirst,
        itabLast
    ];
}
/* [MS-XLS] 2.5.218 */ function $3ee4f50b1ae43a89$var$parse_RkRec(blob) {
    var ixfe = blob.read_shift(2);
    var RK = $3ee4f50b1ae43a89$var$parse_RkNumber(blob);
    return [
        ixfe,
        RK
    ];
}
/* [MS-XLS] 2.5.1 */ function $3ee4f50b1ae43a89$var$parse_AddinUdf(blob, length, opts) {
    blob.l += 4;
    length -= 4;
    var l = blob.l + length;
    var udfName = $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, length, opts);
    var cb = blob.read_shift(2);
    l -= blob.l;
    if (cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
    blob.l += cb;
    return udfName;
}
/* [MS-XLS] 2.5.209 TODO: Check sizes */ function $3ee4f50b1ae43a89$var$parse_Ref8U(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(2);
    var colLast = blob.read_shift(2);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
function $3ee4f50b1ae43a89$var$write_Ref8U(r /*:Range*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(2, r.s.r);
    o.write_shift(2, r.e.r);
    o.write_shift(2, r.s.c);
    o.write_shift(2, r.e.c);
    return o;
}
/* [MS-XLS] 2.5.211 */ function $3ee4f50b1ae43a89$var$parse_RefU(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(1);
    var colLast = blob.read_shift(1);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
/* [MS-XLS] 2.5.207 */ var $3ee4f50b1ae43a89$var$parse_Ref = $3ee4f50b1ae43a89$var$parse_RefU;
/* [MS-XLS] 2.5.143 */ function $3ee4f50b1ae43a89$var$parse_FtCmo(blob /*::, length*/ ) {
    blob.l += 4;
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var flags = blob.read_shift(2);
    blob.l += 12;
    return [
        id,
        ot,
        flags
    ];
}
/* [MS-XLS] 2.5.149 */ function $3ee4f50b1ae43a89$var$parse_FtNts(blob) {
    var out = {};
    blob.l += 4;
    blob.l += 16; // GUID TODO
    out.fSharedNote = blob.read_shift(2);
    blob.l += 4;
    return out;
}
/* [MS-XLS] 2.5.142 */ function $3ee4f50b1ae43a89$var$parse_FtCf(blob) {
    var out = {};
    blob.l += 4;
    blob.cf = blob.read_shift(2);
    return out;
}
/* [MS-XLS] 2.5.140 - 2.5.154 and friends */ function $3ee4f50b1ae43a89$var$parse_FtSkip(blob) {
    blob.l += 2;
    blob.l += blob.read_shift(2);
}
var $3ee4f50b1ae43a89$var$FtTab = {
    /*::[*/ 0x00: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtEnd */ /*::[*/ 0x04: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtMacro */ /*::[*/ 0x05: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtButton */ /*::[*/ 0x06: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtGmo */ /*::[*/ 0x07: $3ee4f50b1ae43a89$var$parse_FtCf,
    /* FtCf */ /*::[*/ 0x08: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtPioGrbit */ /*::[*/ 0x09: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtPictFmla */ /*::[*/ 0x0A: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtCbls */ /*::[*/ 0x0B: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtRbo */ /*::[*/ 0x0C: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtSbs */ /*::[*/ 0x0D: $3ee4f50b1ae43a89$var$parse_FtNts,
    /* FtNts */ /*::[*/ 0x0E: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtSbsFmla */ /*::[*/ 0x0F: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtGboData */ /*::[*/ 0x10: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtEdoData */ /*::[*/ 0x11: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtRboData */ /*::[*/ 0x12: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtCblsData */ /*::[*/ 0x13: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtLbsData */ /*::[*/ 0x14: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtCblsFmla */ /*::[*/ 0x15: $3ee4f50b1ae43a89$var$parse_FtCmo
};
function $3ee4f50b1ae43a89$var$parse_FtArray(blob, length /*::, ot*/ ) {
    var tgt = blob.l + length;
    var fts = [];
    while(blob.l < tgt){
        var ft = blob.read_shift(2);
        blob.l -= 2;
        try {
            fts.push($3ee4f50b1ae43a89$var$FtTab[ft](blob, tgt - blob.l));
        } catch (e) {
            blob.l = tgt;
            return fts;
        }
    }
    if (blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
    return fts;
}
/* --- 2.4 Records --- */ /* [MS-XLS] 2.4.21 */ function $3ee4f50b1ae43a89$var$parse_BOF(blob, length) {
    var o = {
        BIFFVer: 0,
        dt: 0
    };
    o.BIFFVer = blob.read_shift(2);
    length -= 2;
    if (length >= 2) {
        o.dt = blob.read_shift(2);
        blob.l -= 2;
    }
    switch(o.BIFFVer){
        case 0x0600:
        /* BIFF8 */ case 0x0500:
        /* BIFF5 */ case 0x0400:
        /* BIFF4 */ case 0x0300:
        /* BIFF3 */ case 0x0200:
        /* BIFF2 */ case 0x0002:
        case 0x0007:
            break;
        default:
            if (length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
    }
    blob.read_shift(length);
    return o;
}
function $3ee4f50b1ae43a89$var$write_BOF(wb /*:Workbook*/ , t /*:number*/ , o) {
    var h = 0x0600, w = 16;
    switch(o.bookType){
        case "biff8":
            break;
        case "biff5":
            h = 0x0500;
            w = 8;
            break;
        case "biff4":
            h = 0x0004;
            w = 6;
            break;
        case "biff3":
            h = 0x0003;
            w = 6;
            break;
        case "biff2":
            h = 0x0002;
            w = 4;
            break;
        case "xla":
            break;
        default:
            throw new Error("unsupported BIFF version");
    }
    var out = $3ee4f50b1ae43a89$var$new_buf(w);
    out.write_shift(2, h);
    out.write_shift(2, t);
    if (w > 4) out.write_shift(2, 0x7262);
    if (w > 6) out.write_shift(2, 0x07CD);
    if (w > 8) {
        out.write_shift(2, 0xC009);
        out.write_shift(2, 0x0001);
        out.write_shift(2, 0x0706);
        out.write_shift(2, 0x0000);
    }
    return out;
}
/* [MS-XLS] 2.4.146 */ function $3ee4f50b1ae43a89$var$parse_InterfaceHdr(blob, length) {
    if (length === 0) return 0x04b0;
    blob.read_shift(2);
    return 0x04b0;
}
/* [MS-XLS] 2.4.349 */ function $3ee4f50b1ae43a89$var$parse_WriteAccess(blob, length, opts) {
    if (opts.enc) {
        blob.l += length;
        return "";
    }
    var l = blob.l;
    // TODO: make sure XLUnicodeString doesnt overrun
    var UserName = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, 0, opts);
    blob.read_shift(length + l - blob.l);
    return UserName;
}
function $3ee4f50b1ae43a89$var$write_WriteAccess(s /*:string*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $3ee4f50b1ae43a89$var$new_buf(b8 ? 112 : 54);
    o.write_shift(opts.biff == 8 ? 2 : 1, 7);
    if (b8) o.write_shift(1, 0);
    o.write_shift(4, 0x33336853);
    o.write_shift(4, 0x00534A74 | (b8 ? 0 : 0x20000000));
    while(o.l < o.length)o.write_shift(1, b8 ? 0 : 32);
    return o;
}
/* [MS-XLS] 2.4.351 */ function $3ee4f50b1ae43a89$var$parse_WsBool(blob, length, opts) {
    var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
    return {
        fDialog: flags & 0x10,
        fBelow: flags & 0x40,
        fRight: flags & 0x80
    };
}
/* [MS-XLS] 2.4.28 */ function $3ee4f50b1ae43a89$var$parse_BoundSheet8(blob, length, opts) {
    var pos = blob.read_shift(4);
    var hidden = blob.read_shift(1) & 0x03;
    var dt = blob.read_shift(1);
    switch(dt){
        case 0:
            dt = "Worksheet";
            break;
        case 1:
            dt = "Macrosheet";
            break;
        case 2:
            dt = "Chartsheet";
            break;
        case 6:
            dt = "VBAModule";
            break;
    }
    var name = $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, 0, opts);
    if (name.length === 0) name = "Sheet1";
    return {
        pos: pos,
        hs: hidden,
        dt: dt,
        name: name
    };
}
function $3ee4f50b1ae43a89$var$write_BoundSheet8(data, opts) {
    var w = !opts || opts.biff >= 8 ? 2 : 1;
    var o = $3ee4f50b1ae43a89$var$new_buf(8 + w * data.name.length);
    o.write_shift(4, data.pos);
    o.write_shift(1, data.hs || 0);
    o.write_shift(1, data.dt);
    o.write_shift(1, data.name.length);
    if (opts.biff >= 8) o.write_shift(1, 1);
    o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? "sbcs" : "utf16le");
    var out = o.slice(0, o.l);
    out.l = o.l;
    return out;
}
/* [MS-XLS] 2.4.265 TODO */ function $3ee4f50b1ae43a89$var$parse_SST(blob, length) /*:SST*/ {
    var end = blob.l + length;
    var cnt = blob.read_shift(4);
    var ucnt = blob.read_shift(4);
    var strs /*:SST*/  = [];
    for(var i = 0; i != ucnt && blob.l < end; ++i)strs.push($3ee4f50b1ae43a89$var$parse_XLUnicodeRichExtendedString(blob));
    strs.Count = cnt;
    strs.Unique = ucnt;
    return strs;
}
function $3ee4f50b1ae43a89$var$write_SST(sst, opts) {
    var header = $3ee4f50b1ae43a89$var$new_buf(8);
    header.write_shift(4, sst.Count);
    header.write_shift(4, sst.Unique);
    var strs = [];
    for(var j = 0; j < sst.length; ++j)strs[j] = $3ee4f50b1ae43a89$var$write_XLUnicodeRichExtendedString(sst[j], opts);
    var o = $3ee4f50b1ae43a89$var$bconcat([
        header
    ].concat(strs));
    /*::(*/ o /*:: :any)*/ .parts = [
        header.length
    ].concat(strs.map(function(str) {
        return str.length;
    }));
    return o;
}
/* [MS-XLS] 2.4.107 */ function $3ee4f50b1ae43a89$var$parse_ExtSST(blob, length) {
    var extsst = {};
    extsst.dsst = blob.read_shift(2);
    blob.l += length - 2;
    return extsst;
}
/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */ function $3ee4f50b1ae43a89$var$parse_Row(blob) {
    var z = {} /*:any*/ ;
    z.r = blob.read_shift(2);
    z.c = blob.read_shift(2);
    z.cnt = blob.read_shift(2) - z.c;
    var miyRw = blob.read_shift(2);
    blob.l += 4; // reserved(2), unused(2)
    var flags = blob.read_shift(1); // various flags
    blob.l += 3; // reserved(8), ixfe(12), flags(4)
    if (flags & 0x07) z.level = flags & 0x07;
    // collapsed: flags & 0x10
    if (flags & 0x20) z.hidden = true;
    if (flags & 0x40) z.hpt = miyRw / 20;
    return z;
}
/* [MS-XLS] 2.4.125 */ function $3ee4f50b1ae43a89$var$parse_ForceFullCalculation(blob) {
    var header = $3ee4f50b1ae43a89$var$parse_frtHeader(blob);
    if (header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
    var fullcalc = blob.read_shift(4);
    return fullcalc !== 0x0;
}
/* [MS-XLS] 2.4.215 rt */ function $3ee4f50b1ae43a89$var$parse_RecalcId(blob) {
    blob.read_shift(2);
    return blob.read_shift(4);
}
/* [MS-XLS] 2.4.87 */ function $3ee4f50b1ae43a89$var$parse_DefaultRowHeight(blob, length, opts) {
    var f = 0;
    if (!(opts && opts.biff == 2)) f = blob.read_shift(2);
    var miyRw = blob.read_shift(2);
    if (opts && opts.biff == 2) {
        f = 1 - (miyRw >> 15);
        miyRw &= 0x7fff;
    }
    var fl = {
        Unsynced: f & 1,
        DyZero: (f & 2) >> 1,
        ExAsc: (f & 4) >> 2,
        ExDsc: (f & 8) >> 3
    };
    return [
        fl,
        miyRw
    ];
}
/* [MS-XLS] 2.4.345 TODO */ function $3ee4f50b1ae43a89$var$parse_Window1(blob) {
    var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
    var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
    var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
    return {
        Pos: [
            xWn,
            yWn
        ],
        Dim: [
            dxWn,
            dyWn
        ],
        Flags: flags,
        CurTab: iTabCur,
        FirstTab: iTabFirst,
        Selected: ctabSel,
        TabRatio: wTabRatio
    };
}
function $3ee4f50b1ae43a89$var$write_Window1() {
    var o = $3ee4f50b1ae43a89$var$new_buf(18);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0x7260);
    o.write_shift(2, 0x44c0);
    o.write_shift(2, 0x38);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 1);
    o.write_shift(2, 0x01f4);
    return o;
}
/* [MS-XLS] 2.4.346 TODO */ function $3ee4f50b1ae43a89$var$parse_Window2(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff < 5) return {};
    var f = blob.read_shift(2);
    return {
        RTL: f & 0x40
    };
}
function $3ee4f50b1ae43a89$var$write_Window2(view) {
    var o = $3ee4f50b1ae43a89$var$new_buf(18), f = 0x6b6;
    if (view && view.RTL) f |= 0x40;
    o.write_shift(2, f);
    o.write_shift(4, 0);
    o.write_shift(4, 64);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLS] 2.4.189 TODO */ function $3ee4f50b1ae43a89$var$parse_Pane() {}
/* [MS-XLS] 2.4.122 TODO */ function $3ee4f50b1ae43a89$var$parse_Font(blob, length, opts) {
    var o /*:any*/  = {
        dyHeight: blob.read_shift(2),
        fl: blob.read_shift(2)
    };
    switch(opts && opts.biff || 8){
        case 2:
            break;
        case 3:
        case 4:
            blob.l += 2;
            break;
        default:
            blob.l += 10;
            break;
    }
    o.name = $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, 0, opts);
    return o;
}
function $3ee4f50b1ae43a89$var$write_Font(data, opts) {
    var name = data.name || "Arial";
    var b5 = opts && opts.biff == 5, w = b5 ? 15 + name.length : 16 + 2 * name.length;
    var o = $3ee4f50b1ae43a89$var$new_buf(w);
    o.write_shift(2, (data.sz || 12) * 20);
    o.write_shift(4, 0);
    o.write_shift(2, 400);
    o.write_shift(4, 0);
    o.write_shift(2, 0);
    o.write_shift(1, name.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * name.length, name, b5 ? "sbcs" : "utf16le");
    return o;
}
/* [MS-XLS] 2.4.149 */ function $3ee4f50b1ae43a89$var$parse_LabelSst(blob) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob);
    cell.isst = blob.read_shift(4);
    return cell;
}
function $3ee4f50b1ae43a89$var$write_LabelSst(R /*:number*/ , C /*:number*/ , v /*:number*/ , os /*:number*/  /*::, opts*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(10);
    $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os, o);
    o.write_shift(4, v);
    return o;
}
/* [MS-XLS] 2.4.148 */ function $3ee4f50b1ae43a89$var$parse_Label(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var target = blob.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2) blob.l++;
    var str = $3ee4f50b1ae43a89$var$parse_XLUnicodeString(blob, target - blob.l, opts);
    cell.val = str;
    return cell;
}
function $3ee4f50b1ae43a89$var$write_Label(R /*:number*/ , C /*:number*/ , v /*:string*/ , os /*:number*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $3ee4f50b1ae43a89$var$new_buf(8 + +b8 + (1 + b8) * v.length);
    $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os, o);
    o.write_shift(2, v.length);
    if (b8) o.write_shift(1, 1);
    o.write_shift((1 + b8) * v.length, v, b8 ? "utf16le" : "sbcs");
    return o;
}
/* [MS-XLS] 2.4.126 Number Formats */ function $3ee4f50b1ae43a89$var$parse_Format(blob, length, opts) {
    var numFmtId = blob.read_shift(2);
    var fmtstr = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        numFmtId,
        fmtstr
    ];
}
function $3ee4f50b1ae43a89$var$write_Format(i /*:number*/ , f /*:string*/ , opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(b5 ? 3 + f.length : 5 + 2 * f.length);
    o.write_shift(2, i);
    o.write_shift(b5 ? 1 : 2, f.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * f.length, f, b5 ? "sbcs" : "utf16le");
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (out.l == null) out.l = out.length;
    return out;
}
var $3ee4f50b1ae43a89$var$parse_BIFF2Format = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2;
/* [MS-XLS] 2.4.90 */ function $3ee4f50b1ae43a89$var$parse_Dimensions(blob, length, opts) {
    var end = blob.l + length;
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = blob.read_shift(2), C = blob.read_shift(2);
    blob.l = end;
    return {
        s: {
            r: r,
            c: c
        },
        e: {
            r: R,
            c: C
        }
    };
}
function $3ee4f50b1ae43a89$var$write_Dimensions(range, opts) {
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var o = $3ee4f50b1ae43a89$var$new_buf(2 * w + 6);
    o.write_shift(w, range.s.r);
    o.write_shift(w, range.e.r + 1);
    o.write_shift(2, range.s.c);
    o.write_shift(2, range.e.c + 1);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.220 */ function $3ee4f50b1ae43a89$var$parse_RK(blob) {
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrec = $3ee4f50b1ae43a89$var$parse_RkRec(blob);
    return {
        r: rw,
        c: col,
        ixfe: rkrec[0],
        rknum: rkrec[1]
    };
}
/* [MS-XLS] 2.4.175 */ function $3ee4f50b1ae43a89$var$parse_MulRk(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrecs = [];
    while(blob.l < target)rkrecs.push($3ee4f50b1ae43a89$var$parse_RkRec(blob));
    if (blob.l !== target) throw new Error("MulRK read error");
    var lastcol = blob.read_shift(2);
    if (rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        rkrec: rkrecs
    };
}
/* [MS-XLS] 2.4.174 */ function $3ee4f50b1ae43a89$var$parse_MulBlank(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var ixfes = [];
    while(blob.l < target)ixfes.push(blob.read_shift(2));
    if (blob.l !== target) throw new Error("MulBlank read error");
    var lastcol = blob.read_shift(2);
    if (ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        ixfe: ixfes
    };
}
/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */ function $3ee4f50b1ae43a89$var$parse_CellStyleXF(blob, length, style, opts) {
    var o = {};
    var a = blob.read_shift(4), b = blob.read_shift(4);
    var c = blob.read_shift(4), d = blob.read_shift(2);
    o.patternType = $3ee4f50b1ae43a89$var$XLSFillPattern[c >> 26];
    if (!opts.cellStyles) return o;
    o.alc = a & 0x07;
    o.fWrap = a >> 3 & 0x01;
    o.alcV = a >> 4 & 0x07;
    o.fJustLast = a >> 7 & 0x01;
    o.trot = a >> 8 & 0xFF;
    o.cIndent = a >> 16 & 0x0F;
    o.fShrinkToFit = a >> 20 & 0x01;
    o.iReadOrder = a >> 22 & 0x02;
    o.fAtrNum = a >> 26 & 0x01;
    o.fAtrFnt = a >> 27 & 0x01;
    o.fAtrAlc = a >> 28 & 0x01;
    o.fAtrBdr = a >> 29 & 0x01;
    o.fAtrPat = a >> 30 & 0x01;
    o.fAtrProt = a >> 31 & 0x01;
    o.dgLeft = b & 0x0F;
    o.dgRight = b >> 4 & 0x0F;
    o.dgTop = b >> 8 & 0x0F;
    o.dgBottom = b >> 12 & 0x0F;
    o.icvLeft = b >> 16 & 0x7F;
    o.icvRight = b >> 23 & 0x7F;
    o.grbitDiag = b >> 30 & 0x03;
    o.icvTop = c & 0x7F;
    o.icvBottom = c >> 7 & 0x7F;
    o.icvDiag = c >> 14 & 0x7F;
    o.dgDiag = c >> 21 & 0x0F;
    o.icvFore = d & 0x7F;
    o.icvBack = d >> 7 & 0x7F;
    o.fsxButton = d >> 14 & 0x01;
    return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
/* [MS-XLS] 2.4.353 TODO: actually do this right */ function $3ee4f50b1ae43a89$var$parse_XF(blob, length, opts) {
    var o = {};
    o.ifnt = blob.read_shift(2);
    o.numFmtId = blob.read_shift(2);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    length -= 6;
    o.data = $3ee4f50b1ae43a89$var$parse_CellStyleXF(blob, length, o.fStyle, opts);
    return o;
}
function $3ee4f50b1ae43a89$var$write_XF(data, ixfeP, opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(b5 ? 16 : 20);
    o.write_shift(2, 0);
    if (data.style) {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, 0xFFF4);
    } else {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, ixfeP << 4);
    }
    var f = 0;
    if (data.numFmtId > 0 && b5) f |= 0x0400;
    o.write_shift(4, f);
    o.write_shift(4, 0);
    if (!b5) o.write_shift(4, 0);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.134 */ function $3ee4f50b1ae43a89$var$parse_Guts(blob) {
    blob.l += 4;
    var out = [
        blob.read_shift(2),
        blob.read_shift(2)
    ];
    if (out[0] !== 0) out[0]--;
    if (out[1] !== 0) out[1]--;
    if (out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
    return out;
}
function $3ee4f50b1ae43a89$var$write_Guts(guts /*:Array<number>*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(4, 0);
    o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
    o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
    return o;
}
/* [MS-XLS] 2.4.24 */ function $3ee4f50b1ae43a89$var$parse_BoolErr(blob, length, opts) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2 || length == 9) ++blob.l;
    var val = $3ee4f50b1ae43a89$var$parse_Bes(blob, 2);
    cell.val = val;
    cell.t = val === true || val === false ? "b" : "e";
    return cell;
}
function $3ee4f50b1ae43a89$var$write_BoolErr(R /*:number*/ , C /*:number*/ , v, os /*:number*/ , opts, t /*:string*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(8);
    $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os, o);
    $3ee4f50b1ae43a89$var$write_Bes(v, t, o);
    return o;
}
/* [MS-XLS] 2.4.180 Number */ function $3ee4f50b1ae43a89$var$parse_Number(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6);
    var xnum = $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
    cell.val = xnum;
    return cell;
}
function $3ee4f50b1ae43a89$var$write_Number(R /*:number*/ , C /*:number*/ , v, os /*:: :number, opts*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(14);
    $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os, o);
    $3ee4f50b1ae43a89$var$write_Xnum(v, o);
    return o;
}
var $3ee4f50b1ae43a89$var$parse_XLHeaderFooter = $3ee4f50b1ae43a89$var$parse_OptXLUnicodeString; // TODO: parse 2.4.136
/* [MS-XLS] 2.4.271 */ function $3ee4f50b1ae43a89$var$parse_SupBook(blob, length, opts) {
    var end = blob.l + length;
    var ctab = blob.read_shift(2);
    var cch = blob.read_shift(2);
    opts.sbcch = cch;
    if (cch == 0x0401 || cch == 0x3A01) return [
        cch,
        ctab
    ];
    if (cch < 0x01 || cch > 0xff) throw new Error("Unexpected SupBook type: " + cch);
    var virtPath = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cch);
    /* TODO: 2.5.277 Virtual Path */ var rgst = [];
    while(end > blob.l)rgst.push($3ee4f50b1ae43a89$var$parse_XLUnicodeString(blob));
    return [
        cch,
        ctab,
        virtPath,
        rgst
    ];
}
/* [MS-XLS] 2.4.105 TODO */ function $3ee4f50b1ae43a89$var$parse_ExternName(blob, length, opts) {
    var flags = blob.read_shift(2);
    var body;
    var o = {
        fBuiltIn: flags & 0x01,
        fWantAdvise: flags >>> 1 & 0x01,
        fWantPict: flags >>> 2 & 0x01,
        fOle: flags >>> 3 & 0x01,
        fOleLink: flags >>> 4 & 0x01,
        cf: flags >>> 5 & 0x3FF,
        fIcon: flags >>> 15 & 0x01
    } /*:any*/ ;
    if (opts.sbcch === 0x3A01) body = $3ee4f50b1ae43a89$var$parse_AddinUdf(blob, length - 2, opts);
    //else throw new Error("unsupported SupBook cch: " + opts.sbcch);
    o.body = body || blob.read_shift(length - 2);
    if (typeof body === "string") o.Name = body;
    return o;
}
/* [MS-XLS] 2.4.150 TODO */ var $3ee4f50b1ae43a89$var$XLSLblBuiltIn = [
    "_xlnm.Consolidate_Area",
    "_xlnm.Auto_Open",
    "_xlnm.Auto_Close",
    "_xlnm.Extract",
    "_xlnm.Database",
    "_xlnm.Criteria",
    "_xlnm.Print_Area",
    "_xlnm.Print_Titles",
    "_xlnm.Recorder",
    "_xlnm.Data_Form",
    "_xlnm.Auto_Activate",
    "_xlnm.Auto_Deactivate",
    "_xlnm.Sheet_Title",
    "_xlnm._FilterDatabase"
];
function $3ee4f50b1ae43a89$var$parse_Lbl(blob, length, opts) {
    var target = blob.l + length;
    var flags = blob.read_shift(2);
    var chKey = blob.read_shift(1);
    var cch = blob.read_shift(1);
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var itab = 0;
    if (!opts || opts.biff >= 5) {
        if (opts.biff != 5) blob.l += 2;
        itab = blob.read_shift(2);
        if (opts.biff == 5) blob.l += 2;
        blob.l += 4;
    }
    var name = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    if (flags & 0x20) name = $3ee4f50b1ae43a89$var$XLSLblBuiltIn[name.charCodeAt(0)];
    var npflen = target - blob.l;
    if (opts && opts.biff == 2) --npflen;
    /*jshint -W018 */ var rgce = target == blob.l || cce === 0 || !(npflen > 0) ? [] : $3ee4f50b1ae43a89$var$parse_NameParsedFormula(blob, npflen, opts, cce);
    /*jshint +W018 */ return {
        chKey: chKey,
        Name: name,
        itab: itab,
        rgce: rgce
    };
}
/* [MS-XLS] 2.4.106 TODO: verify filename encoding */ function $3ee4f50b1ae43a89$var$parse_ExternSheet(blob, length, opts) {
    if (opts.biff < 8) return $3ee4f50b1ae43a89$var$parse_BIFF5ExternSheet(blob, length, opts);
    var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
    while(len-- !== 0)o.push($3ee4f50b1ae43a89$var$parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
    // [iSupBook, itabFirst, itabLast];
    if (blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BIFF5ExternSheet(blob, length, opts) {
    if (blob[blob.l + 1] == 0x03) blob[blob.l]++;
    var o = $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, length, opts);
    return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}
/* [MS-XLS] 2.4.176 TODO: check older biff */ function $3ee4f50b1ae43a89$var$parse_NameCmt(blob, length, opts) {
    if (opts.biff < 8) {
        blob.l += length;
        return;
    }
    var cchName = blob.read_shift(2);
    var cchComment = blob.read_shift(2);
    var name = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cchName, opts);
    var comment = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cchComment, opts);
    return [
        name,
        comment
    ];
}
/* [MS-XLS] 2.4.260 */ function $3ee4f50b1ae43a89$var$parse_ShrFmla(blob, length, opts) {
    var ref = $3ee4f50b1ae43a89$var$parse_RefU(blob, 6);
    blob.l++;
    var cUse = blob.read_shift(1);
    length -= 8;
    return [
        $3ee4f50b1ae43a89$var$parse_SharedParsedFormula(blob, length, opts),
        cUse,
        ref
    ];
}
/* [MS-XLS] 2.4.4 TODO */ function $3ee4f50b1ae43a89$var$parse_Array(blob, length, opts) {
    var ref = $3ee4f50b1ae43a89$var$parse_Ref(blob, 6);
    /* TODO: fAlwaysCalc */ switch(opts.biff){
        case 2:
            blob.l++;
            length -= 7;
            break;
        case 3:
        case 4:
            blob.l += 2;
            length -= 8;
            break;
        default:
            blob.l += 6;
            length -= 12;
    }
    return [
        ref,
        $3ee4f50b1ae43a89$var$parse_ArrayParsedFormula(blob, length, opts, ref)
    ];
}
/* [MS-XLS] 2.4.173 */ function $3ee4f50b1ae43a89$var$parse_MTRSettings(blob) {
    var fMTREnabled = blob.read_shift(4) !== 0x00;
    var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
    var cUserThreadCount = blob.read_shift(4);
    return [
        fMTREnabled,
        fUserSetThreadCount,
        cUserThreadCount
    ];
}
/* [MS-XLS] 2.5.186 TODO: BIFF5 */ function $3ee4f50b1ae43a89$var$parse_NoteSh(blob, length, opts) {
    if (opts.biff < 8) return;
    var row = blob.read_shift(2), col = blob.read_shift(2);
    var flags = blob.read_shift(2), idObj = blob.read_shift(2);
    var stAuthor = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, 0, opts);
    if (opts.biff < 8) blob.read_shift(1);
    return [
        {
            r: row,
            c: col
        },
        stAuthor,
        idObj,
        flags
    ];
}
/* [MS-XLS] 2.4.179 */ function $3ee4f50b1ae43a89$var$parse_Note(blob, length, opts) {
    /* TODO: Support revisions */ return $3ee4f50b1ae43a89$var$parse_NoteSh(blob, length, opts);
}
/* [MS-XLS] 2.4.168 */ function $3ee4f50b1ae43a89$var$parse_MergeCells(blob, length) /*:Array<Range>*/ {
    var merges /*:Array<Range>*/  = [];
    var cmcs = blob.read_shift(2);
    while(cmcs--)merges.push($3ee4f50b1ae43a89$var$parse_Ref8U(blob, length));
    return merges;
}
function $3ee4f50b1ae43a89$var$write_MergeCells(merges /*:Array<Range>*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(2 + merges.length * 8);
    o.write_shift(2, merges.length);
    for(var i = 0; i < merges.length; ++i)$3ee4f50b1ae43a89$var$write_Ref8U(merges[i], o);
    return o;
}
/* [MS-XLS] 2.4.181 TODO: parse all the things! */ function $3ee4f50b1ae43a89$var$parse_Obj(blob, length, opts) {
    if (opts && opts.biff < 8) return $3ee4f50b1ae43a89$var$parse_BIFF5Obj(blob, length, opts);
    var cmo = $3ee4f50b1ae43a89$var$parse_FtCmo(blob, 22); // id, ot, flags
    var fts = $3ee4f50b1ae43a89$var$parse_FtArray(blob, length - 22, cmo[1]);
    return {
        cmo: cmo,
        ft: fts
    };
}
/* from older spec */ var $3ee4f50b1ae43a89$var$parse_BIFF5OT = {
    0x08: function(blob, length) {
        var tgt = blob.l + length;
        blob.l += 10; // todo
        var cf = blob.read_shift(2);
        blob.l += 4;
        blob.l += 2; //var cbPictFmla = blob.read_shift(2);
        blob.l += 2;
        blob.l += 2; //var grbit = blob.read_shift(2);
        blob.l += 4;
        var cchName = blob.read_shift(1);
        blob.l += cchName; // TODO: stName
        blob.l = tgt; // TODO: fmla
        return {
            fmt: cf
        };
    }
};
function $3ee4f50b1ae43a89$var$parse_BIFF5Obj(blob, length, opts) {
    blob.l += 4; //var cnt = blob.read_shift(4);
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var grbit = blob.read_shift(2);
    blob.l += 2; //var colL = blob.read_shift(2);
    blob.l += 2; //var dxL = blob.read_shift(2);
    blob.l += 2; //var rwT = blob.read_shift(2);
    blob.l += 2; //var dyT = blob.read_shift(2);
    blob.l += 2; //var colR = blob.read_shift(2);
    blob.l += 2; //var dxR = blob.read_shift(2);
    blob.l += 2; //var rwB = blob.read_shift(2);
    blob.l += 2; //var dyB = blob.read_shift(2);
    blob.l += 2; //var cbMacro = blob.read_shift(2);
    blob.l += 6;
    length -= 36;
    var fts = [];
    fts.push(($3ee4f50b1ae43a89$var$parse_BIFF5OT[ot] || $3ee4f50b1ae43a89$var$parsenoop)(blob, length, opts));
    return {
        cmo: [
            id,
            ot,
            grbit
        ],
        ft: fts
    };
}
/* [MS-XLS] 2.4.329 TODO: parse properly */ function $3ee4f50b1ae43a89$var$parse_TxO(blob, length, opts) {
    var s = blob.l;
    var texts = "";
    try {
        blob.l += 4;
        var ot = (opts.lastobj || {
            cmo: [
                0,
                0
            ]
        }).cmo[1];
        var controlInfo; // eslint-disable-line no-unused-vars
        if ([
            0,
            5,
            7,
            11,
            12,
            14
        ].indexOf(ot) == -1) blob.l += 6;
        else controlInfo = $3ee4f50b1ae43a89$var$parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
        var cchText = blob.read_shift(2);
        /*var cbRuns = */ blob.read_shift(2);
        /*var ifntEmpty = */ $3ee4f50b1ae43a89$var$parseuint16(blob, 2);
        var len = blob.read_shift(2);
        blob.l += len;
        //var fmla = parse_ObjFmla(blob, s + length - blob.l);
        for(var i = 1; i < blob.lens.length - 1; ++i){
            if (blob.l - s != blob.lens[i]) throw new Error("TxO: bad continue record");
            var hdr = blob[blob.l];
            var t = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, blob.lens[i + 1] - blob.lens[i] - 1);
            texts += t;
            if (texts.length >= (hdr ? cchText : 2 * cchText)) break;
        }
        if (texts.length !== cchText && texts.length !== cchText * 2) throw new Error("cchText: " + cchText + " != " + texts.length);
        blob.l = s + length;
        /* [MS-XLS] 2.5.272 TxORuns */ //	var rgTxoRuns = [];
        //	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
        //	var cchText2 = blob.read_shift(2);
        //	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
        //	blob.l += 6;
        //	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
        return {
            t: texts
        };
    } catch (e) {
        blob.l = s + length;
        return {
            t: texts
        };
    }
}
/* [MS-XLS] 2.4.140 */ function $3ee4f50b1ae43a89$var$parse_HLink(blob, length) {
    var ref = $3ee4f50b1ae43a89$var$parse_Ref8U(blob, 8);
    blob.l += 16; /* CLSID */ 
    var hlink = $3ee4f50b1ae43a89$var$parse_Hyperlink(blob, length - 24);
    return [
        ref,
        hlink
    ];
}
function $3ee4f50b1ae43a89$var$write_HLink(hl) {
    var O = $3ee4f50b1ae43a89$var$new_buf(24);
    var ref = $3ee4f50b1ae43a89$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
    for(var i = 0; i < 16; ++i)O.write_shift(1, parseInt(clsid[i], 16));
    return $3ee4f50b1ae43a89$var$bconcat([
        O,
        $3ee4f50b1ae43a89$var$write_Hyperlink(hl[1])
    ]);
}
/* [MS-XLS] 2.4.141 */ function $3ee4f50b1ae43a89$var$parse_HLinkTooltip(blob, length) {
    blob.read_shift(2);
    var ref = $3ee4f50b1ae43a89$var$parse_Ref8U(blob, 8);
    var wzTooltip = blob.read_shift((length - 10) / 2, "dbcs-cont");
    wzTooltip = wzTooltip.replace($3ee4f50b1ae43a89$var$chr0, "");
    return [
        ref,
        wzTooltip
    ];
}
function $3ee4f50b1ae43a89$var$write_HLinkTooltip(hl) {
    var TT = hl[1].Tooltip;
    var O = $3ee4f50b1ae43a89$var$new_buf(10 + 2 * (TT.length + 1));
    O.write_shift(2, 0x0800);
    var ref = $3ee4f50b1ae43a89$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    for(var i = 0; i < TT.length; ++i)O.write_shift(2, TT.charCodeAt(i));
    O.write_shift(2, 0);
    return O;
}
/* [MS-XLS] 2.4.63 */ function $3ee4f50b1ae43a89$var$parse_Country(blob) /*:[string|number, string|number]*/ {
    var o = [
        0,
        0
    ], d;
    d = blob.read_shift(2);
    o[0] = $3ee4f50b1ae43a89$var$CountryEnum[d] || d;
    d = blob.read_shift(2);
    o[1] = $3ee4f50b1ae43a89$var$CountryEnum[d] || d;
    return o;
}
function $3ee4f50b1ae43a89$var$write_Country(o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(2, 0x01);
    o.write_shift(2, 0x01);
    return o;
}
/* [MS-XLS] 2.4.50 ClrtClient */ function $3ee4f50b1ae43a89$var$parse_ClrtClient(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($3ee4f50b1ae43a89$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.188 */ function $3ee4f50b1ae43a89$var$parse_Palette(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($3ee4f50b1ae43a89$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.354 */ function $3ee4f50b1ae43a89$var$parse_XFCRC(blob) {
    blob.l += 2;
    var o = {
        cxfs: 0,
        crc: 0
    };
    o.cxfs = blob.read_shift(2);
    o.crc = blob.read_shift(4);
    return o;
}
/* [MS-XLS] 2.4.53 TODO: parse flags */ /* [MS-XLSB] 2.4.323 TODO: parse flags */ function $3ee4f50b1ae43a89$var$parse_ColInfo(blob, length, opts) {
    if (!opts.cellStyles) return $3ee4f50b1ae43a89$var$parsenoop(blob, length);
    var w = opts && opts.biff >= 12 ? 4 : 2;
    var colFirst = blob.read_shift(w);
    var colLast = blob.read_shift(w);
    var coldx = blob.read_shift(w);
    var ixfe = blob.read_shift(w);
    var flags = blob.read_shift(2);
    if (w == 2) blob.l += 2;
    var o = {
        s: colFirst,
        e: colLast,
        w: coldx,
        ixfe: ixfe,
        flags: flags
    } /*:any*/ ;
    if (opts.biff >= 5 || !opts.biff) o.level = flags >> 8 & 0x7;
    return o;
}
function $3ee4f50b1ae43a89$var$write_ColInfo(col, idx) {
    var o = $3ee4f50b1ae43a89$var$new_buf(12);
    o.write_shift(2, idx);
    o.write_shift(2, idx);
    o.write_shift(2, col.width * 256);
    o.write_shift(2, 0);
    var f = 0;
    if (col.hidden) f |= 1;
    o.write_shift(1, f);
    f = col.level || 0;
    o.write_shift(1, f);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.257 */ function $3ee4f50b1ae43a89$var$parse_Setup(blob, length) {
    var o = {};
    if (length < 32) return o;
    blob.l += 16;
    o.header = $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
    o.footer = $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
    blob.l += 2;
    return o;
}
/* [MS-XLS] 2.4.261 */ function $3ee4f50b1ae43a89$var$parse_ShtProps(blob, length, opts) {
    var def = {
        area: false
    };
    if (opts.biff != 5) {
        blob.l += length;
        return def;
    }
    var d = blob.read_shift(1);
    blob.l += 3;
    if (d & 0x10) def.area = true;
    return def;
}
/* [MS-XLS] 2.4.241 */ function $3ee4f50b1ae43a89$var$write_RRTabId(n /*:number*/ ) {
    var out = $3ee4f50b1ae43a89$var$new_buf(2 * n);
    for(var i = 0; i < n; ++i)out.write_shift(2, i + 1);
    return out;
}
var $3ee4f50b1ae43a89$var$parse_Blank = $3ee4f50b1ae43a89$var$parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */ 
var $3ee4f50b1ae43a89$var$parse_Scl = $3ee4f50b1ae43a89$var$parseuint16a; /* [MS-XLS] 2.4.247 num, den */ 
var $3ee4f50b1ae43a89$var$parse_String = $3ee4f50b1ae43a89$var$parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */ 
/* --- Specific to versions before BIFF8 --- */ function $3ee4f50b1ae43a89$var$parse_ImData(blob) {
    var cf = blob.read_shift(2);
    var env = blob.read_shift(2);
    var lcb = blob.read_shift(4);
    var o = {
        fmt: cf,
        env: env,
        len: lcb,
        data: blob.slice(blob.l, blob.l + lcb)
    };
    blob.l += lcb;
    return o;
}
/* BIFF2_??? where ??? is the name from [XLS] */ function $3ee4f50b1ae43a89$var$parse_BIFF2STR(blob, length, opts) {
    if (opts.biffguess && opts.biff == 5) opts.biff = 2;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var str = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, length - 7, opts);
    cell.t = "str";
    cell.val = str;
    return cell;
}
function $3ee4f50b1ae43a89$var$parse_BIFF2NUM(blob /*::, length*/ ) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var num = $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
    cell.t = "n";
    cell.val = num;
    return cell;
}
function $3ee4f50b1ae43a89$var$write_BIFF2NUM(r /*:number*/ , c /*:number*/ , val /*:number*/ ) {
    var out = $3ee4f50b1ae43a89$var$new_buf(15);
    $3ee4f50b1ae43a89$var$write_BIFF2Cell(out, r, c);
    out.write_shift(8, val, "f");
    return out;
}
function $3ee4f50b1ae43a89$var$parse_BIFF2INT(blob) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var num = blob.read_shift(2);
    cell.t = "n";
    cell.val = num;
    return cell;
}
function $3ee4f50b1ae43a89$var$write_BIFF2INT(r /*:number*/ , c /*:number*/ , val /*:number*/ ) {
    var out = $3ee4f50b1ae43a89$var$new_buf(9);
    $3ee4f50b1ae43a89$var$write_BIFF2Cell(out, r, c);
    out.write_shift(2, val);
    return out;
}
function $3ee4f50b1ae43a89$var$parse_BIFF2STRING(blob) {
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, "sbcs-cont");
}
/* TODO: convert to BIFF8 font struct */ function $3ee4f50b1ae43a89$var$parse_BIFF2FONTXTRA(blob, length) {
    blob.l += 6; // unknown
    blob.l += 2; // font weight "bls"
    blob.l += 1; // charset
    blob.l += 3; // unknown
    blob.l += 1; // font family
    blob.l += length - 13;
}
/* TODO: parse rich text runs */ function $3ee4f50b1ae43a89$var$parse_RString(blob, length, opts) {
    var end = blob.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6);
    var cch = blob.read_shift(2);
    var str = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    blob.l = end;
    cell.t = "str";
    cell.val = str;
    return cell;
}
/* from js-harb (C) 2014-present  SheetJS */ var $3ee4f50b1ae43a89$var$DBF_SUPPORTED_VERSIONS = [
    0x02,
    0x03,
    0x30,
    0x31,
    0x83,
    0x8B,
    0x8C,
    0xF5
];
var $3ee4f50b1ae43a89$var$DBF = /*#__PURE__*/ function() {
    var dbf_codepage_map = {
        /* Code Pages Supported by Visual FoxPro */ /*::[*/ 0x01: 437,
        /*::[*/ 0x02: 850,
        /*::[*/ 0x03: 1252,
        /*::[*/ 0x04: 10000,
        /*::[*/ 0x64: 852,
        /*::[*/ 0x65: 866,
        /*::[*/ 0x66: 865,
        /*::[*/ 0x67: 861,
        /*::[*/ 0x68: 895,
        /*::[*/ 0x69: 620,
        /*::[*/ 0x6A: 737,
        /*::[*/ 0x6B: 857,
        /*::[*/ 0x78: 950,
        /*::[*/ 0x79: 949,
        /*::[*/ 0x7A: 936,
        /*::[*/ 0x7B: 932,
        /*::[*/ 0x7C: 874,
        /*::[*/ 0x7D: 1255,
        /*::[*/ 0x7E: 1256,
        /*::[*/ 0x96: 10007,
        /*::[*/ 0x97: 10029,
        /*::[*/ 0x98: 10006,
        /*::[*/ 0xC8: 1250,
        /*::[*/ 0xC9: 1251,
        /*::[*/ 0xCA: 1254,
        /*::[*/ 0xCB: 1253,
        /* shapefile DBF extension */ /*::[*/ 0x00: 20127,
        /*::[*/ 0x08: 865,
        /*::[*/ 0x09: 437,
        /*::[*/ 0x0A: 850,
        /*::[*/ 0x0B: 437,
        /*::[*/ 0x0D: 437,
        /*::[*/ 0x0E: 850,
        /*::[*/ 0x0F: 437,
        /*::[*/ 0x10: 850,
        /*::[*/ 0x11: 437,
        /*::[*/ 0x12: 850,
        /*::[*/ 0x13: 932,
        /*::[*/ 0x14: 850,
        /*::[*/ 0x15: 437,
        /*::[*/ 0x16: 850,
        /*::[*/ 0x17: 865,
        /*::[*/ 0x18: 437,
        /*::[*/ 0x19: 437,
        /*::[*/ 0x1A: 850,
        /*::[*/ 0x1B: 437,
        /*::[*/ 0x1C: 863,
        /*::[*/ 0x1D: 850,
        /*::[*/ 0x1F: 852,
        /*::[*/ 0x22: 852,
        /*::[*/ 0x23: 852,
        /*::[*/ 0x24: 860,
        /*::[*/ 0x25: 850,
        /*::[*/ 0x26: 866,
        /*::[*/ 0x37: 850,
        /*::[*/ 0x40: 852,
        /*::[*/ 0x4D: 936,
        /*::[*/ 0x4E: 949,
        /*::[*/ 0x4F: 950,
        /*::[*/ 0x50: 874,
        /*::[*/ 0x57: 1252,
        /*::[*/ 0x58: 1252,
        /*::[*/ 0x59: 1252,
        /*::[*/ 0x6C: 863,
        /*::[*/ 0x86: 737,
        /*::[*/ 0x87: 852,
        /*::[*/ 0x88: 857,
        /*::[*/ 0xCC: 1257,
        /*::[*/ 0xFF: 16969
    };
    var dbf_reverse_map = $3ee4f50b1ae43a89$var$evert({
        /*::[*/ 0x01: 437,
        /*::[*/ 0x02: 850,
        /*::[*/ 0x03: 1252,
        /*::[*/ 0x04: 10000,
        /*::[*/ 0x64: 852,
        /*::[*/ 0x65: 866,
        /*::[*/ 0x66: 865,
        /*::[*/ 0x67: 861,
        /*::[*/ 0x68: 895,
        /*::[*/ 0x69: 620,
        /*::[*/ 0x6A: 737,
        /*::[*/ 0x6B: 857,
        /*::[*/ 0x78: 950,
        /*::[*/ 0x79: 949,
        /*::[*/ 0x7A: 936,
        /*::[*/ 0x7B: 932,
        /*::[*/ 0x7C: 874,
        /*::[*/ 0x7D: 1255,
        /*::[*/ 0x7E: 1256,
        /*::[*/ 0x96: 10007,
        /*::[*/ 0x97: 10029,
        /*::[*/ 0x98: 10006,
        /*::[*/ 0xC8: 1250,
        /*::[*/ 0xC9: 1251,
        /*::[*/ 0xCA: 1254,
        /*::[*/ 0xCB: 1253,
        /*::[*/ 0x00: 20127
    });
    /* TODO: find an actual specification */ function dbf_to_aoa(buf, opts) /*:AOA*/ {
        var out /*:AOA*/  = [];
        var d /*:Block*/  = $3ee4f50b1ae43a89$var$new_raw_buf(1);
        switch(opts.type){
            case "base64":
                d = $3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$Base64_decode(buf));
                break;
            case "binary":
                d = $3ee4f50b1ae43a89$var$s2a(buf);
                break;
            case "buffer":
            case "array":
                d = buf;
                break;
        }
        $3ee4f50b1ae43a89$var$prep_blob(d, 0);
        /* header */ var ft = d.read_shift(1);
        var memo = !!(ft & 0x88);
        var vfp = false, l7 = false;
        switch(ft){
            case 0x02:
                break; // dBASE II
            case 0x03:
                break; // dBASE III
            case 0x30:
                vfp = true;
                memo = true;
                break; // VFP
            case 0x31:
                vfp = true;
                memo = true;
                break; // VFP with autoincrement
            // 0x43 dBASE IV SQL table files
            // 0x63 dBASE IV SQL system files
            case 0x83:
                break; // dBASE III with memo
            case 0x8B:
                break; // dBASE IV with memo
            case 0x8C:
                l7 = true;
                break; // dBASE Level 7 with memo
            // case 0xCB dBASE IV SQL table files with memo
            case 0xF5:
                break; // FoxPro 2.x with memo
            // case 0xFB FoxBASE
            default:
                throw new Error("DBF Unsupported Version: " + ft.toString(16));
        }
        var nrow = 0, fpos = 0x0209;
        if (ft == 0x02) nrow = d.read_shift(2);
        d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
        if (ft != 0x02) nrow = d.read_shift(4);
        if (nrow > 1048576) nrow = 1e6;
        if (ft != 0x02) fpos = d.read_shift(2); // header length
        var rlen = d.read_shift(2); // record length
        var /*flags = 0,*/ current_cp = opts.codepage || 1252;
        if (ft != 0x02) {
            d.l += 16;
            /*flags = */ d.read_shift(1);
            //if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
            /* codepage present in FoxPro and dBASE Level 7 */ if (d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
            d.l += 1;
            d.l += 2;
        }
        if (l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
        /*:: type DBFField = { name:string; len:number; type:string; } */ var fields /*:Array<DBFField>*/  = [], field /*:DBFField*/  = {} /*:any*/ ;
        var hend = Math.min(d.length, ft == 0x02 ? 0x209 : fpos - 10 - (vfp ? 264 : 0));
        var ww = l7 ? 32 : 11;
        while(d.l < hend && d[d.l] != 0x0d){
            field = {} /*:any*/ ;
            field.name = $3ee4f50b1ae43a89$var$$cptable.utils.decode(current_cp, d.slice(d.l, d.l + ww)).replace(/[\u0000\r\n].*$/g, "");
            d.l += ww;
            field.type = String.fromCharCode(d.read_shift(1));
            if (ft != 0x02 && !l7) field.offset = d.read_shift(4);
            field.len = d.read_shift(1);
            if (ft == 0x02) field.offset = d.read_shift(2);
            field.dec = d.read_shift(1);
            if (field.name.length) fields.push(field);
            if (ft != 0x02) d.l += l7 ? 13 : 14;
            switch(field.type){
                case "B":
                    if ((!vfp || field.len != 8) && opts.WTF) console.log("Skipping " + field.name + ":" + field.type);
                    break;
                case "G":
                case "P":
                    if (opts.WTF) console.log("Skipping " + field.name + ":" + field.type);
                    break;
                case "+":
                case "0":
                case "@":
                case "C":
                case "D":
                case "F":
                case "I":
                case "L":
                case "M":
                case "N":
                case "O":
                case "T":
                case "Y":
                    break;
                default:
                    throw new Error("Unknown Field Type: " + field.type);
            }
        }
        if (d[d.l] !== 0x0D) d.l = fpos - 1;
        if (d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
        d.l = fpos;
        /* data */ var R = 0, C = 0;
        out[0] = [];
        for(C = 0; C != fields.length; ++C)out[0][C] = fields[C].name;
        while(nrow-- > 0){
            if (d[d.l] === 0x2A) {
                // TODO: record marked as deleted -- create a hidden row?
                d.l += rlen;
                continue;
            }
            ++d.l;
            out[++R] = [];
            C = 0;
            for(C = 0; C != fields.length; ++C){
                var dd = d.slice(d.l, d.l + fields[C].len);
                d.l += fields[C].len;
                $3ee4f50b1ae43a89$var$prep_blob(dd, 0);
                var s = $3ee4f50b1ae43a89$var$$cptable.utils.decode(current_cp, dd);
                switch(fields[C].type){
                    case "C":
                        // NOTE: it is conventional to write '  /  /  ' for empty dates
                        if (s.trim().length) out[R][C] = s.replace(/\s+$/, "");
                        break;
                    case "D":
                        if (s.length === 8) out[R][C] = new Date(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8));
                        else out[R][C] = s;
                        break;
                    case "F":
                        out[R][C] = parseFloat(s.trim());
                        break;
                    case "+":
                    case "I":
                        out[R][C] = l7 ? dd.read_shift(-4, "i") ^ 0x80000000 : dd.read_shift(4, "i");
                        break;
                    case "L":
                        switch(s.trim().toUpperCase()){
                            case "Y":
                            case "T":
                                out[R][C] = true;
                                break;
                            case "N":
                            case "F":
                                out[R][C] = false;
                                break;
                            case "":
                            case "?":
                                break;
                            default:
                                throw new Error("DBF Unrecognized L:|" + s + "|");
                        }
                        break;
                    case "M":
                        /* TODO: handle memo files */ if (!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
                        out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10) : dd.read_shift(4));
                        break;
                    case "N":
                        s = s.replace(/\u0000/g, "").trim();
                        // NOTE: dBASE II interprets "  .  " as 0
                        if (s && s != ".") out[R][C] = +s || 0;
                        break;
                    case "@":
                        // NOTE: dBASE specs appear to be incorrect
                        out[R][C] = new Date(dd.read_shift(-8, "f") - 0x388317533400);
                        break;
                    case "T":
                        out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4));
                        break;
                    case "Y":
                        out[R][C] = dd.read_shift(4, "i") / 1e4 + dd.read_shift(4, "i") / 1e4 * Math.pow(2, 32);
                        break;
                    case "O":
                        out[R][C] = -dd.read_shift(-8, "f");
                        break;
                    case "B":
                        if (vfp && fields[C].len == 8) {
                            out[R][C] = dd.read_shift(8, "f");
                            break;
                        }
                    /* falls through */ case "G":
                    case "P":
                        dd.l += fields[C].len;
                        break;
                    case "0":
                        if (fields[C].name === "_NullFlags") break;
                    /* falls through */ default:
                        throw new Error("DBF Unsupported data type " + fields[C].type);
                }
            }
        }
        if (ft != 0x02) {
            if (d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l - 1) + " of " + d.length + " " + d[d.l - 1].toString(16));
        }
        if (opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
        opts.DBF = fields;
        return out;
    }
    function dbf_to_sheet(buf, opts) /*:Worksheet*/ {
        var o = opts || {};
        if (!o.dateNF) o.dateNF = "yyyymmdd";
        var ws = $3ee4f50b1ae43a89$var$aoa_to_sheet(dbf_to_aoa(buf, o), o);
        ws["!cols"] = o.DBF.map(function(field) {
            return {
                wch: field.len,
                DBF: field
            };
        });
        delete o.DBF;
        return ws;
    }
    function dbf_to_workbook(buf, opts) /*:Workbook*/ {
        try {
            return $3ee4f50b1ae43a89$var$sheet_to_workbook(dbf_to_sheet(buf, opts), opts);
        } catch (e) {
            if (opts && opts.WTF) throw e;
        }
        return {
            SheetNames: [],
            Sheets: {}
        };
    }
    var _RLEN = {
        "B": 8,
        "C": 250,
        "L": 1,
        "D": 8,
        "?": 0,
        "": 0
    };
    function sheet_to_dbf(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $3ee4f50b1ae43a89$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write DBF to JS string");
        var ba = $3ee4f50b1ae43a89$var$buf_array();
        var aoa /*:AOA*/  = $3ee4f50b1ae43a89$var$sheet_to_json(ws, {
            header: 1,
            raw: true,
            cellDates: true
        });
        var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
        var i = 0, j = 0, hcnt = 0, rlen = 1;
        for(i = 0; i < headers.length; ++i){
            if (((cols[i] || {}).DBF || {}).name) {
                headers[i] = cols[i].DBF.name;
                ++hcnt;
                continue;
            }
            if (headers[i] == null) continue;
            ++hcnt;
            if (typeof headers[i] === "number") headers[i] = headers[i].toString(10);
            if (typeof headers[i] !== "string") throw new Error("DBF Invalid column name " + headers[i] + " |" + typeof headers[i] + "|");
            if (headers.indexOf(headers[i]) !== i) {
                for(j = 0; j < 1024; ++j)if (headers.indexOf(headers[i] + "_" + j) == -1) {
                    headers[i] += "_" + j;
                    break;
                }
            }
        }
        var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]);
        var coltypes /*:Array<string>*/  = [];
        var colwidths /*:Array<number>*/  = [];
        var coldecimals /*:Array<number>*/  = [];
        for(i = 0; i <= range.e.c - range.s.c; ++i){
            var guess = "", _guess = "", maxlen = 0;
            var col /*:Array<any>*/  = [];
            for(j = 0; j < data.length; ++j)if (data[j][i] != null) col.push(data[j][i]);
            if (col.length == 0 || headers[i] == null) {
                coltypes[i] = "?";
                continue;
            }
            for(j = 0; j < col.length; ++j){
                switch(typeof col[j]){
                    /* TODO: check if L2 compat is desired */ case "number":
                        _guess = "B";
                        break;
                    case "string":
                        _guess = "C";
                        break;
                    case "boolean":
                        _guess = "L";
                        break;
                    case "object":
                        _guess = col[j] instanceof Date ? "D" : "C";
                        break;
                    default:
                        _guess = "C";
                }
                maxlen = Math.max(maxlen, String(col[j]).length);
                guess = guess && guess != _guess ? "C" : _guess;
            //if(guess == 'C') break;
            }
            if (maxlen > 250) maxlen = 250;
            _guess = ((cols[i] || {}).DBF || {}).type;
            /* TODO: more fine grained control over DBF type resolution */ if (_guess == "C") {
                if (cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
            }
            if (guess == "B" && _guess == "N") {
                guess = "N";
                coldecimals[i] = cols[i].DBF.dec;
                maxlen = cols[i].DBF.len;
            }
            colwidths[i] = guess == "C" || _guess == "N" ? maxlen : _RLEN[guess] || 0;
            rlen += colwidths[i];
            coltypes[i] = guess;
        }
        var h = ba.next(32);
        h.write_shift(4, 0x13021130);
        h.write_shift(4, data.length);
        h.write_shift(2, 296 + 32 * hcnt);
        h.write_shift(2, rlen);
        for(i = 0; i < 4; ++i)h.write_shift(4, 0);
        h.write_shift(4, 0x00000000 | (+dbf_reverse_map[/*::String(*/ $3ee4f50b1ae43a89$var$current_ansi /*::)*/ ] || 0x03) << 8);
        for(i = 0, j = 0; i < headers.length; ++i){
            if (headers[i] == null) continue;
            var hf = ba.next(32);
            var _f = (headers[i].slice(-10) + "\0\0\0\0\0\0\0\0\0\0\0").slice(0, 11);
            hf.write_shift(1, _f, "sbcs");
            hf.write_shift(1, coltypes[i] == "?" ? "C" : coltypes[i], "sbcs");
            hf.write_shift(4, j);
            hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
            hf.write_shift(1, coldecimals[i] || 0);
            hf.write_shift(1, 0x02);
            hf.write_shift(4, 0);
            hf.write_shift(1, 0);
            hf.write_shift(4, 0);
            hf.write_shift(4, 0);
            j += colwidths[i] || _RLEN[coltypes[i]] || 0;
        }
        var hb = ba.next(264);
        hb.write_shift(4, 0x0000000D);
        for(i = 0; i < 65; ++i)hb.write_shift(4, 0x00000000);
        for(i = 0; i < data.length; ++i){
            var rout = ba.next(rlen);
            rout.write_shift(1, 0);
            for(j = 0; j < headers.length; ++j){
                if (headers[j] == null) continue;
                switch(coltypes[j]){
                    case "L":
                        rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46);
                        break;
                    case "B":
                        rout.write_shift(8, data[i][j] || 0, "f");
                        break;
                    case "N":
                        var _n = "0";
                        if (typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j] || 0);
                        for(hcnt = 0; hcnt < colwidths[j] - _n.length; ++hcnt)rout.write_shift(1, 0x20);
                        rout.write_shift(1, _n, "sbcs");
                        break;
                    case "D":
                        if (!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
                        else {
                            rout.write_shift(4, ("0000" + data[i][j].getFullYear()).slice(-4), "sbcs");
                            rout.write_shift(2, ("00" + (data[i][j].getMonth() + 1)).slice(-2), "sbcs");
                            rout.write_shift(2, ("00" + data[i][j].getDate()).slice(-2), "sbcs");
                        }
                        break;
                    case "C":
                        var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
                        rout.write_shift(1, _s, "sbcs");
                        for(hcnt = 0; hcnt < colwidths[j] - _s.length; ++hcnt)rout.write_shift(1, 0x20);
                        break;
                }
            }
        // data
        }
        ba.next(1).write_shift(1, 0x1A);
        return ba.end();
    }
    return {
        to_workbook: dbf_to_workbook,
        to_sheet: dbf_to_sheet,
        from_sheet: sheet_to_dbf
    };
}();
var $3ee4f50b1ae43a89$var$SYLK = /*#__PURE__*/ function() {
    /* TODO: stress test sequences */ var sylk_escapes = {
        AA: "\xc0",
        BA: "\xc1",
        CA: "\xc2",
        DA: 195,
        HA: "\xc4",
        JA: 197,
        AE: "\xc8",
        BE: "\xc9",
        CE: "\xca",
        HE: "\xcb",
        AI: "\xcc",
        BI: "\xcd",
        CI: "\xce",
        HI: "\xcf",
        AO: "\xd2",
        BO: "\xd3",
        CO: "\xd4",
        DO: 213,
        HO: "\xd6",
        AU: "\xd9",
        BU: "\xda",
        CU: "\xdb",
        HU: "\xdc",
        Aa: "\xe0",
        Ba: "\xe1",
        Ca: "\xe2",
        Da: 227,
        Ha: "\xe4",
        Ja: 229,
        Ae: "\xe8",
        Be: "\xe9",
        Ce: "\xea",
        He: "\xeb",
        Ai: "\xec",
        Bi: "\xed",
        Ci: "\xee",
        Hi: "\xef",
        Ao: "\xf2",
        Bo: "\xf3",
        Co: "\xf4",
        Do: 245,
        Ho: "\xf6",
        Au: "\xf9",
        Bu: "\xfa",
        Cu: "\xfb",
        Hu: "\xfc",
        KC: "\xc7",
        Kc: "\xe7",
        q: "\xe6",
        z: "\u0153",
        a: "\xc6",
        j: "\u0152",
        DN: 209,
        Dn: 241,
        Hy: 255,
        S: 169,
        c: 170,
        R: 174,
        "B ": 180,
        /*::[*/ 0: 176,
        /*::[*/ 1: 177,
        /*::[*/ 2: 178,
        /*::[*/ 3: 179,
        /*::[*/ 5: 181,
        /*::[*/ 6: 182,
        /*::[*/ 7: 183,
        Q: 185,
        k: 186,
        b: 208,
        i: 216,
        l: 222,
        s: 240,
        y: 248,
        "!": 161,
        '"': 162,
        "#": 163,
        "(": 164,
        "%": 165,
        "'": 167,
        "H ": 168,
        "+": 171,
        ";": 187,
        "<": 188,
        "=": 189,
        ">": 190,
        "?": 191,
        "{": 223
    } /*:any*/ ;
    var sylk_char_regex = new RegExp("\x1bN(" + $3ee4f50b1ae43a89$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm");
    var sylk_char_fn = function(_, $1) {
        var o = sylk_escapes[$1];
        return typeof o == "number" ? $3ee4f50b1ae43a89$var$_getansi(o) : o;
    };
    var decode_sylk_char = function($$, $1, $2) {
        var newcc = $1.charCodeAt(0) - 0x20 << 4 | $2.charCodeAt(0) - 0x30;
        return newcc == 59 ? $$ : $3ee4f50b1ae43a89$var$_getansi(newcc);
    };
    sylk_escapes["|"] = 254;
    /* TODO: find an actual specification */ function sylk_to_aoa(d /*:RawData*/ , opts) /*:[AOA, Worksheet]*/ {
        switch(opts.type){
            case "base64":
                return sylk_to_aoa_str($3ee4f50b1ae43a89$var$Base64_decode(d), opts);
            case "binary":
                return sylk_to_aoa_str(d, opts);
            case "buffer":
                return sylk_to_aoa_str($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(d) ? d.toString("binary") : $3ee4f50b1ae43a89$var$a2s(d), opts);
            case "array":
                return sylk_to_aoa_str($3ee4f50b1ae43a89$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function sylk_to_aoa_str(str /*:string*/ , opts) /*:[AOA, Worksheet]*/ {
        var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr /*:AOA*/  = [];
        var formats /*:Array<string>*/  = [];
        var next_cell_format /*:string|null*/  = null;
        var sht = {}, rowinfo /*:Array<RowInfo>*/  = [], colinfo /*:Array<ColInfo>*/  = [], cw /*:Array<string>*/  = [];
        var Mval = 0, j;
        if (+opts.codepage >= 0) $3ee4f50b1ae43a89$var$set_cp(+opts.codepage);
        for(; ri !== records.length; ++ri){
            Mval = 0;
            var rstr = records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
            var record = rstr.replace(/;;/g, "\0").split(";").map(function(x) {
                return x.replace(/\u0000/g, ";");
            });
            var RT = record[0], val;
            if (rstr.length > 0) switch(RT){
                case "ID":
                    break; /* header */ 
                case "E":
                    break; /* EOF */ 
                case "B":
                    break; /* dimensions */ 
                case "O":
                    break; /* options? */ 
                case "W":
                    break; /* window? */ 
                case "P":
                    if (record[1].charAt(0) == "P") formats.push(rstr.slice(3).replace(/;;/g, ";"));
                    break;
                case "C":
                    var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case "A":
                            break; // TODO: comment
                        case "X":
                            C = parseInt(record[rj].slice(1)) - 1;
                            C_seen_X = true;
                            break;
                        case "Y":
                            R = parseInt(record[rj].slice(1)) - 1;
                            if (!C_seen_X) C = 0;
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case "K":
                            val = record[rj].slice(1);
                            if (val.charAt(0) === '"') val = val.slice(1, val.length - 1);
                            else if (val === "TRUE") val = true;
                            else if (val === "FALSE") val = false;
                            else if (!isNaN($3ee4f50b1ae43a89$var$fuzzynum(val))) {
                                val = $3ee4f50b1ae43a89$var$fuzzynum(val);
                                if (next_cell_format !== null && $3ee4f50b1ae43a89$var$fmt_is_date(next_cell_format)) val = $3ee4f50b1ae43a89$var$numdate(val);
                            } else if (!isNaN($3ee4f50b1ae43a89$var$fuzzydate(val).getDate())) val = $3ee4f50b1ae43a89$var$parseDate(val);
                            if (typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined" && typeof val == "string" && (opts || {}).type != "string" && (opts || {}).codepage) val = $3ee4f50b1ae43a89$var$$cptable.utils.decode(opts.codepage, val);
                            C_seen_K = true;
                            break;
                        case "E":
                            C_seen_E = true;
                            var formula = $3ee4f50b1ae43a89$var$rc_to_a1(record[rj].slice(1), {
                                r: R,
                                c: C
                            });
                            arr[R][C] = [
                                arr[R][C],
                                formula
                            ];
                            break;
                        case "S":
                            C_seen_S = true;
                            arr[R][C] = [
                                arr[R][C],
                                "S5S"
                            ];
                            break;
                        case "G":
                            break; // unknown
                        case "R":
                            _R = parseInt(record[rj].slice(1)) - 1;
                            break;
                        case "C":
                            _C = parseInt(record[rj].slice(1)) - 1;
                            break;
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (C_seen_K) {
                        if (arr[R][C] && arr[R][C].length == 2) arr[R][C][0] = val;
                        else arr[R][C] = val;
                        next_cell_format = null;
                    }
                    if (C_seen_S) {
                        if (C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
                        var shrbase = _R > -1 && arr[_R][_C];
                        if (!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
                        arr[R][C][1] = $3ee4f50b1ae43a89$var$shift_formula_str(shrbase[1], {
                            r: R - _R,
                            c: C - _C
                        });
                    }
                    break;
                case "F":
                    var F_seen = 0;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case "X":
                            C = parseInt(record[rj].slice(1)) - 1;
                            ++F_seen;
                            break;
                        case "Y":
                            R = parseInt(record[rj].slice(1)) - 1; /*C = 0;*/ 
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case "M":
                            Mval = parseInt(record[rj].slice(1)) / 20;
                            break;
                        case "F":
                            break; /* ??? */ 
                        case "G":
                            break; /* hide grid */ 
                        case "P":
                            next_cell_format = formats[parseInt(record[rj].slice(1))];
                            break;
                        case "S":
                            break; /* cell style */ 
                        case "D":
                            break; /* column */ 
                        case "N":
                            break; /* font */ 
                        case "W":
                            cw = record[rj].slice(1).split(" ");
                            for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j){
                                Mval = parseInt(cw[2], 10);
                                colinfo[j - 1] = Mval === 0 ? {
                                    hidden: true
                                } : {
                                    wch: Mval
                                };
                                $3ee4f50b1ae43a89$var$process_col(colinfo[j - 1]);
                            }
                            break;
                        case "C":
                            /* default column format */ C = parseInt(record[rj].slice(1)) - 1;
                            if (!colinfo[C]) colinfo[C] = {};
                            break;
                        case "R":
                            /* row properties */ R = parseInt(record[rj].slice(1)) - 1;
                            if (!rowinfo[R]) rowinfo[R] = {};
                            if (Mval > 0) {
                                rowinfo[R].hpt = Mval;
                                rowinfo[R].hpx = $3ee4f50b1ae43a89$var$pt2px(Mval);
                            } else if (Mval === 0) rowinfo[R].hidden = true;
                            break;
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (F_seen < 1) next_cell_format = null;
                    break;
                default:
                    if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
            }
        }
        if (rowinfo.length > 0) sht["!rows"] = rowinfo;
        if (colinfo.length > 0) sht["!cols"] = colinfo;
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return [
            arr,
            sht
        ];
    }
    function sylk_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var aoasht = sylk_to_aoa(d, opts);
        var aoa = aoasht[0], ws = aoasht[1];
        var o = $3ee4f50b1ae43a89$var$aoa_to_sheet(aoa, opts);
        $3ee4f50b1ae43a89$var$keys(ws).forEach(function(k) {
            o[k] = ws[k];
        });
        return o;
    }
    function sylk_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $3ee4f50b1ae43a89$var$sheet_to_workbook(sylk_to_sheet(d, opts), opts);
    }
    function write_ws_cell_sylk(cell /*:Cell*/ , ws /*:Worksheet*/ , R /*:number*/ , C /*:number*/  /*::, opts*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";K";
        switch(cell.t){
            case "n":
                o += cell.v || 0;
                if (cell.f && !cell.F) o += ";E" + $3ee4f50b1ae43a89$var$a1_to_rc(cell.f, {
                    r: R,
                    c: C
                });
                break;
            case "b":
                o += cell.v ? "TRUE" : "FALSE";
                break;
            case "e":
                o += cell.w || cell.v;
                break;
            case "d":
                o += '"' + (cell.w || cell.v) + '"';
                break;
            case "s":
                o += '"' + cell.v.replace(/"/g, "").replace(/;/g, ";;") + '"';
                break;
        }
        return o;
    }
    function write_ws_cols_sylk(out, cols) {
        cols.forEach(function(col, i) {
            var rec = "F;W" + (i + 1) + " " + (i + 1) + " ";
            if (col.hidden) rec += "0";
            else {
                if (typeof col.width == "number" && !col.wpx) col.wpx = $3ee4f50b1ae43a89$var$width2px(col.width);
                if (typeof col.wpx == "number" && !col.wch) col.wch = $3ee4f50b1ae43a89$var$px2char(col.wpx);
                if (typeof col.wch == "number") rec += Math.round(col.wch);
            }
            if (rec.charAt(rec.length - 1) != " ") out.push(rec);
        });
    }
    function write_ws_rows_sylk(out /*:Array<string>*/ , rows /*:Array<RowInfo>*/ ) {
        rows.forEach(function(row, i) {
            var rec = "F;";
            if (row.hidden) rec += "M0;";
            else if (row.hpt) rec += "M" + 20 * row.hpt + ";";
            else if (row.hpx) rec += "M" + 20 * $3ee4f50b1ae43a89$var$px2pt(row.hpx) + ";";
            if (rec.length > 2) out.push(rec + "R" + (i + 1));
        });
    }
    function sheet_to_sylk(ws /*:Worksheet*/ , opts /*:?any*/ ) /*:string*/ {
        var preamble /*:Array<string>*/  = [
            "ID;PWXL;N;E"
        ], o /*:Array<string>*/  = [];
        var r = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]), cell /*:Cell*/ ;
        var dense = Array.isArray(ws);
        var RS = "\r\n";
        preamble.push("P;PGeneral");
        preamble.push("F;P0;DG0G8;M255");
        if (ws["!cols"]) write_ws_cols_sylk(preamble, ws["!cols"]);
        if (ws["!rows"]) write_ws_rows_sylk(preamble, ws["!rows"]);
        preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [
            r.s.c,
            r.s.r,
            r.e.c,
            r.e.r
        ].join(" "));
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            var coord = $3ee4f50b1ae43a89$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws[R] || [])[C] : ws[coord];
            if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
            o.push(write_ws_cell_sylk(cell, ws, R, C, opts));
        }
        return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
    }
    return {
        to_workbook: sylk_to_workbook,
        to_sheet: sylk_to_sheet,
        from_sheet: sheet_to_sylk
    };
}();
var $3ee4f50b1ae43a89$var$DIF = /*#__PURE__*/ function() {
    function dif_to_aoa(d /*:RawData*/ , opts) /*:AOA*/ {
        switch(opts.type){
            case "base64":
                return dif_to_aoa_str($3ee4f50b1ae43a89$var$Base64_decode(d), opts);
            case "binary":
                return dif_to_aoa_str(d, opts);
            case "buffer":
                return dif_to_aoa_str($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(d) ? d.toString("binary") : $3ee4f50b1ae43a89$var$a2s(d), opts);
            case "array":
                return dif_to_aoa_str($3ee4f50b1ae43a89$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function dif_to_aoa_str(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split("\n"), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            if (records[ri].trim() === "BOT") {
                arr[++R] = [];
                C = 0;
                continue;
            }
            if (R < 0) continue;
            var metadata = records[ri].trim().split(",");
            var type = metadata[0], value = metadata[1];
            ++ri;
            var data = records[ri] || "";
            while((data.match(/["]/g) || []).length & 1 && ri < records.length - 1)data += "\n" + records[++ri];
            data = data.trim();
            switch(+type){
                case -1:
                    if (data === "BOT") {
                        arr[++R] = [];
                        C = 0;
                        continue;
                    } else if (data !== "EOD") throw new Error("Unrecognized DIF special command " + data);
                    break;
                case 0:
                    if (data === "TRUE") arr[R][C] = true;
                    else if (data === "FALSE") arr[R][C] = false;
                    else if (!isNaN($3ee4f50b1ae43a89$var$fuzzynum(value))) arr[R][C] = $3ee4f50b1ae43a89$var$fuzzynum(value);
                    else if (!isNaN($3ee4f50b1ae43a89$var$fuzzydate(value).getDate())) arr[R][C] = $3ee4f50b1ae43a89$var$parseDate(value);
                    else arr[R][C] = value;
                    ++C;
                    break;
                case 1:
                    data = data.slice(1, data.length - 1);
                    data = data.replace(/""/g, '"');
                    if ($3ee4f50b1ae43a89$var$DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
                    arr[R][C++] = data !== "" ? data : null;
                    break;
            }
            if (data === "EOD") break;
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function dif_to_sheet(str /*:string*/ , opts) /*:Worksheet*/ {
        return $3ee4f50b1ae43a89$var$aoa_to_sheet(dif_to_aoa(str, opts), opts);
    }
    function dif_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
        return $3ee4f50b1ae43a89$var$sheet_to_workbook(dif_to_sheet(str, opts), opts);
    }
    var sheet_to_dif = /*#__PURE__*/ function() {
        var push_field = function pf(o /*:Array<string>*/ , topic /*:string*/ , v /*:number*/ , n /*:number*/ , s /*:string*/ ) {
            o.push(topic);
            o.push(v + "," + n);
            o.push('"' + s.replace(/"/g, '""') + '"');
        };
        var push_value = function po(o /*:Array<string>*/ , type /*:number*/ , v /*:any*/ , s /*:string*/ ) {
            o.push(type + "," + v);
            o.push(type == 1 ? '"' + s.replace(/"/g, '""') + '"' : s);
        };
        return function sheet_to_dif(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
            var o /*:Array<string>*/  = [];
            var r = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]), cell /*:Cell*/ ;
            var dense = Array.isArray(ws);
            push_field(o, "TABLE", 0, 1, "sheetjs");
            push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1, "");
            push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1, "");
            push_field(o, "DATA", 0, 0, "");
            for(var R = r.s.r; R <= r.e.r; ++R){
                push_value(o, -1, 0, "BOT");
                for(var C = r.s.c; C <= r.e.c; ++C){
                    var coord = $3ee4f50b1ae43a89$var$encode_cell({
                        r: R,
                        c: C
                    });
                    cell = dense ? (ws[R] || [])[C] : ws[coord];
                    if (!cell) {
                        push_value(o, 1, 0, "");
                        continue;
                    }
                    switch(cell.t){
                        case "n":
                            var val = $3ee4f50b1ae43a89$var$DIF_XL ? cell.w : cell.v;
                            if (!val && cell.v != null) val = cell.v;
                            if (val == null) {
                                if ($3ee4f50b1ae43a89$var$DIF_XL && cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
                                else push_value(o, 1, 0, "");
                            } else push_value(o, 0, val, "V");
                            break;
                        case "b":
                            push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
                            break;
                        case "s":
                            push_value(o, 1, 0, !$3ee4f50b1ae43a89$var$DIF_XL || isNaN(cell.v) ? cell.v : '="' + cell.v + '"');
                            break;
                        case "d":
                            if (!cell.w) cell.w = $3ee4f50b1ae43a89$var$SSF_format(cell.z || $3ee4f50b1ae43a89$var$table_fmt[14], $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v)));
                            if ($3ee4f50b1ae43a89$var$DIF_XL) push_value(o, 0, cell.w, "V");
                            else push_value(o, 1, 0, cell.w);
                            break;
                        default:
                            push_value(o, 1, 0, "");
                    }
                }
            }
            push_value(o, -1, 0, "EOD");
            var RS = "\r\n";
            var oo = o.join(RS);
            //while((oo.length & 0x7F) != 0) oo += "\0";
            return oo;
        };
    }();
    return {
        to_workbook: dif_to_workbook,
        to_sheet: dif_to_sheet,
        from_sheet: sheet_to_dif
    };
}();
var $3ee4f50b1ae43a89$var$ETH = /*#__PURE__*/ function() {
    function decode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, "\n");
    }
    function encode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
    }
    function eth_to_aoa(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split("\n"), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            var record = records[ri].trim().split(":");
            if (record[0] !== "cell") continue;
            var addr = $3ee4f50b1ae43a89$var$decode_cell(record[1]);
            if (arr.length <= addr.r) {
                for(R = arr.length; R <= addr.r; ++R)if (!arr[R]) arr[R] = [];
            }
            R = addr.r;
            C = addr.c;
            switch(record[2]){
                case "t":
                    arr[R][C] = decode(record[3]);
                    break;
                case "v":
                    arr[R][C] = +record[3];
                    break;
                case "vtf":
                    var _f = record[record.length - 1];
                /* falls through */ case "vtc":
                    switch(record[3]){
                        case "nl":
                            arr[R][C] = +record[4] ? true : false;
                            break;
                        default:
                            arr[R][C] = +record[4];
                            break;
                    }
                    if (record[2] == "vtf") arr[R][C] = [
                        arr[R][C],
                        _f
                    ];
            }
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function eth_to_sheet(d /*:string*/ , opts) /*:Worksheet*/ {
        return $3ee4f50b1ae43a89$var$aoa_to_sheet(eth_to_aoa(d, opts), opts);
    }
    function eth_to_workbook(d /*:string*/ , opts) /*:Workbook*/ {
        return $3ee4f50b1ae43a89$var$sheet_to_workbook(eth_to_sheet(d, opts), opts);
    }
    var header = [
        "socialcalc:version:1.5",
        "MIME-Version: 1.0",
        "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
    ].join("\n");
    var sep = [
        "--SocialCalcSpreadsheetControlSave",
        "Content-type: text/plain; charset=UTF-8"
    ].join("\n") + "\n";
    /* TODO: the other parts */ var meta = [
        "# SocialCalc Spreadsheet Control Save",
        "part:sheet"
    ].join("\n");
    var end = "--SocialCalcSpreadsheetControlSave--";
    function sheet_to_eth_data(ws /*:Worksheet*/ ) /*:string*/ {
        if (!ws || !ws["!ref"]) return "";
        var o /*:Array<string>*/  = [], oo /*:Array<string>*/  = [], cell, coord = "";
        var r = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
        var dense = Array.isArray(ws);
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            coord = $3ee4f50b1ae43a89$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws[R] || [])[C] : ws[coord];
            if (!cell || cell.v == null || cell.t === "z") continue;
            oo = [
                "cell",
                coord,
                "t"
            ];
            switch(cell.t){
                case "s":
                case "str":
                    oo.push(encode(cell.v));
                    break;
                case "n":
                    if (!cell.f) {
                        oo[2] = "v";
                        oo[3] = cell.v;
                    } else {
                        oo[2] = "vtf";
                        oo[3] = "n";
                        oo[4] = cell.v;
                        oo[5] = encode(cell.f);
                    }
                    break;
                case "b":
                    oo[2] = "vt" + (cell.f ? "f" : "c");
                    oo[3] = "nl";
                    oo[4] = cell.v ? "1" : "0";
                    oo[5] = encode(cell.f || (cell.v ? "TRUE" : "FALSE"));
                    break;
                case "d":
                    var t = $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v));
                    oo[2] = "vtc";
                    oo[3] = "nd";
                    oo[4] = "" + t;
                    oo[5] = cell.w || $3ee4f50b1ae43a89$var$SSF_format(cell.z || $3ee4f50b1ae43a89$var$table_fmt[14], t);
                    break;
                case "e":
                    continue;
            }
            o.push(oo.join(":"));
        }
        o.push("sheet:c:" + (r.e.c - r.s.c + 1) + ":r:" + (r.e.r - r.s.r + 1) + ":tvf:1");
        o.push("valueformat:1:text-wiki");
        //o.push("copiedfrom:" + ws['!ref']); // clipboard only
        return o.join("\n");
    }
    function sheet_to_eth(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        return [
            header,
            sep,
            meta,
            sep,
            sheet_to_eth_data(ws),
            end
        ].join("\n");
    // return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
    }
    return {
        to_workbook: eth_to_workbook,
        to_sheet: eth_to_sheet,
        from_sheet: sheet_to_eth
    };
}();
var $3ee4f50b1ae43a89$var$PRN = /*#__PURE__*/ function() {
    function set_text_arr(data /*:string*/ , arr /*:AOA*/ , R /*:number*/ , C /*:number*/ , o /*:any*/ ) {
        if (o.raw) arr[R][C] = data;
        else if (data === "") ;
        else if (data === "TRUE") arr[R][C] = true;
        else if (data === "FALSE") arr[R][C] = false;
        else if (!isNaN($3ee4f50b1ae43a89$var$fuzzynum(data))) arr[R][C] = $3ee4f50b1ae43a89$var$fuzzynum(data);
        else if (!isNaN($3ee4f50b1ae43a89$var$fuzzydate(data).getDate())) arr[R][C] = $3ee4f50b1ae43a89$var$parseDate(data);
        else arr[R][C] = data;
    }
    function prn_to_aoa_str(f /*:string*/ , opts) /*:AOA*/ {
        var o = opts || {};
        var arr /*:AOA*/  = [];
        if (!f || f.length === 0) return arr;
        var lines = f.split(/[\r\n]/);
        var L = lines.length - 1;
        while(L >= 0 && lines[L].length === 0)--L;
        var start = 10, idx = 0;
        var R = 0;
        for(; R <= L; ++R){
            idx = lines[R].indexOf(" ");
            if (idx == -1) idx = lines[R].length;
            else idx++;
            start = Math.max(start, idx);
        }
        for(R = 0; R <= L; ++R){
            arr[R] = [];
            /* TODO: confirm that widths are always 10 */ var C = 0;
            set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
            for(C = 1; C <= (lines[R].length - start) / 10 + 1; ++C)set_text_arr(lines[R].slice(start + (C - 1) * 10, start + C * 10).trim(), arr, R, C, o);
        }
        if (o.sheetRows) arr = arr.slice(0, o.sheetRows);
        return arr;
    }
    // List of accepted CSV separators
    var guess_seps = {
        /*::[*/ 0x2C: ",",
        /*::[*/ 0x09: "	",
        /*::[*/ 0x3B: ";",
        /*::[*/ 0x7C: "|"
    };
    // CSV separator weights to be used in case of equal numbers
    var guess_sep_weights = {
        /*::[*/ 0x2C: 3,
        /*::[*/ 0x09: 2,
        /*::[*/ 0x3B: 1,
        /*::[*/ 0x7C: 0
    };
    function guess_sep(str) {
        var cnt = {}, instr = false, end = 0, cc = 0;
        for(; end < str.length; ++end){
            if ((cc = str.charCodeAt(end)) == 0x22) instr = !instr;
            else if (!instr && cc in guess_seps) cnt[cc] = (cnt[cc] || 0) + 1;
        }
        cc = [];
        for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
            cnt[end],
            end
        ]);
        if (!cc.length) {
            cnt = guess_sep_weights;
            for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
                cnt[end],
                end
            ]);
        }
        cc.sort(function(a, b) {
            return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]];
        });
        return guess_seps[cc.pop()[1]] || 0x2C;
    }
    function dsv_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var sep = "";
        if ($3ee4f50b1ae43a89$var$DENSE != null && o.dense == null) o.dense = $3ee4f50b1ae43a89$var$DENSE;
        var ws /*:Worksheet*/  = o.dense ? [] : {} /*:any*/ ;
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        } /*:any*/ ;
        if (str.slice(0, 4) == "sep=") {
            // If the line ends in \r\n
            if (str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10) {
                sep = str.charAt(4);
                str = str.slice(7);
            } else if (str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10) {
                sep = str.charAt(4);
                str = str.slice(6);
            } else sep = guess_sep(str.slice(0, 1024));
        } else if (o && o.FS) sep = o.FS;
        else sep = guess_sep(str.slice(0, 1024));
        var R = 0, C = 0, v = 0;
        var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc = 0, startcc = str.charCodeAt(0);
        str = str.replace(/\r\n/mg, "\n");
        var _re /*:?RegExp*/  = o.dateNF != null ? $3ee4f50b1ae43a89$var$dateNF_regex(o.dateNF) : null;
        function finish_cell() {
            var s = str.slice(start, end);
            var cell = {} /*:any*/ ;
            if (s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1, -1).replace(/""/g, '"');
            if (s.length === 0) cell.t = "z";
            else if (o.raw) {
                cell.t = "s";
                cell.v = s;
            } else if (s.trim().length === 0) {
                cell.t = "s";
                cell.v = s;
            } else if (s.charCodeAt(0) == 0x3D) {
                if (s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) {
                    cell.t = "s";
                    cell.v = s.slice(2, -1).replace(/""/g, '"');
                } else if ($3ee4f50b1ae43a89$var$fuzzyfmla(s)) {
                    cell.t = "n";
                    cell.f = s.slice(1);
                } else {
                    cell.t = "s";
                    cell.v = s;
                }
            } else if (s == "TRUE") {
                cell.t = "b";
                cell.v = true;
            } else if (s == "FALSE") {
                cell.t = "b";
                cell.v = false;
            } else if (!isNaN(v = $3ee4f50b1ae43a89$var$fuzzynum(s))) {
                cell.t = "n";
                if (o.cellText !== false) cell.w = s;
                cell.v = v;
            } else if (!isNaN($3ee4f50b1ae43a89$var$fuzzydate(s).getDate()) || _re && s.match(_re)) {
                cell.z = o.dateNF || $3ee4f50b1ae43a89$var$table_fmt[14];
                var k = 0;
                if (_re && s.match(_re)) {
                    s = $3ee4f50b1ae43a89$var$dateNF_fix(s, o.dateNF, s.match(_re) || []);
                    k = 1;
                }
                if (o.cellDates) {
                    cell.t = "d";
                    cell.v = $3ee4f50b1ae43a89$var$parseDate(s, k);
                } else {
                    cell.t = "n";
                    cell.v = $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(s, k));
                }
                if (o.cellText !== false) cell.w = $3ee4f50b1ae43a89$var$SSF_format(cell.z, cell.v instanceof Date ? $3ee4f50b1ae43a89$var$datenum(cell.v) : cell.v);
                if (!o.cellNF) delete cell.z;
            } else {
                cell.t = "s";
                cell.v = s;
            }
            if (cell.t == "z") ;
            else if (o.dense) {
                if (!ws[R]) ws[R] = [];
                ws[R][C] = cell;
            } else ws[$3ee4f50b1ae43a89$var$encode_cell({
                c: C,
                r: R
            })] = cell;
            start = end + 1;
            startcc = str.charCodeAt(start);
            if (range.e.c < C) range.e.c = C;
            if (range.e.r < R) range.e.r = R;
            if (cc == sepcc) ++C;
            else {
                C = 0;
                ++R;
                if (o.sheetRows && o.sheetRows <= R) return true;
            }
        }
        outer: for(; end < str.length; ++end)switch(cc = str.charCodeAt(end)){
            case 0x22:
                if (startcc === 0x22) instr = !instr;
                break;
            case sepcc:
            case 0x0a:
            case 0x0d:
                if (!instr && finish_cell()) break outer;
                break;
            default:
                break;
        }
        if (end - start > 0) finish_cell();
        ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
        return ws;
    }
    function prn_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        if (!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
        if (opts.FS) return dsv_to_sheet_str(str, opts);
        if (str.slice(0, 4) == "sep=") return dsv_to_sheet_str(str, opts);
        if (str.indexOf("	") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
        return $3ee4f50b1ae43a89$var$aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
    }
    function prn_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var str = "", bytes = opts.type == "string" ? [
            0,
            0,
            0,
            0
        ] : $3ee4f50b1ae43a89$var$firstbyte(d, opts);
        switch(opts.type){
            case "base64":
                str = $3ee4f50b1ae43a89$var$Base64_decode(d);
                break;
            case "binary":
                str = d;
                break;
            case "buffer":
                if (opts.codepage == 65001) str = d.toString("utf8"); // TODO: test if buf
                else if (opts.codepage && typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined") str = $3ee4f50b1ae43a89$var$$cptable.utils.decode(opts.codepage, d);
                else str = $3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(d) ? d.toString("binary") : $3ee4f50b1ae43a89$var$a2s(d);
                break;
            case "array":
                str = $3ee4f50b1ae43a89$var$cc2str(d);
                break;
            case "string":
                str = d;
                break;
            default:
                throw new Error("Unrecognized type " + opts.type);
        }
        if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $3ee4f50b1ae43a89$var$utf8read(str.slice(3));
        else if (opts.type != "string" && opts.type != "buffer" && opts.codepage == 65001) str = $3ee4f50b1ae43a89$var$utf8read(str);
        else if (opts.type == "binary" && typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined" && opts.codepage) str = $3ee4f50b1ae43a89$var$$cptable.utils.decode(opts.codepage, $3ee4f50b1ae43a89$var$$cptable.utils.encode(28591, str));
        if (str.slice(0, 19) == "socialcalc:version:") return $3ee4f50b1ae43a89$var$ETH.to_sheet(opts.type == "string" ? str : $3ee4f50b1ae43a89$var$utf8read(str), opts);
        return prn_to_sheet_str(str, opts);
    }
    function prn_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $3ee4f50b1ae43a89$var$sheet_to_workbook(prn_to_sheet(d, opts), opts);
    }
    function sheet_to_prn(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var o /*:Array<string>*/  = [];
        var r = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]), cell /*:Cell*/ ;
        var dense = Array.isArray(ws);
        for(var R = r.s.r; R <= r.e.r; ++R){
            var oo /*:Array<string>*/  = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                var coord = $3ee4f50b1ae43a89$var$encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws[R] || [])[C] : ws[coord];
                if (!cell || cell.v == null) {
                    oo.push("          ");
                    continue;
                }
                var w = (cell.w || ($3ee4f50b1ae43a89$var$format_cell(cell), cell.w) || "").slice(0, 10);
                while(w.length < 10)w += " ";
                oo.push(w + (C === 0 ? " " : ""));
            }
            o.push(oo.join(""));
        }
        return o.join("\n");
    }
    return {
        to_workbook: prn_to_workbook,
        to_sheet: prn_to_sheet,
        from_sheet: sheet_to_prn
    };
}();
/* Excel defaults to SYLK but warns if data is not valid */ function $3ee4f50b1ae43a89$var$read_wb_ID(d, opts) {
    var o = opts || {}, OLD_WTF = !!o.WTF;
    o.WTF = true;
    try {
        var out = $3ee4f50b1ae43a89$var$SYLK.to_workbook(d, o);
        o.WTF = OLD_WTF;
        return out;
    } catch (e) {
        o.WTF = OLD_WTF;
        if (!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
        return $3ee4f50b1ae43a89$var$PRN.to_workbook(d, opts);
    }
}
var $3ee4f50b1ae43a89$var$WK_ = /*#__PURE__*/ function() {
    function lotushopper(data, cb /*:RecordHopperCB*/ , opts /*:any*/ ) {
        if (!data) return;
        $3ee4f50b1ae43a89$var$prep_blob(data, data.l || 0);
        var Enum = opts.Enum || WK1Enum;
        while(data.l < data.length){
            var RT = data.read_shift(2);
            var R = Enum[RT] || Enum[0xFFFF];
            var length = data.read_shift(2);
            var tgt = data.l + length;
            var d = R.f && R.f(data, length, opts);
            data.l = tgt;
            if (cb(d, R, RT)) return;
        }
    }
    function lotus_to_workbook(d /*:RawData*/ , opts) {
        switch(opts.type){
            case "base64":
                return lotus_to_workbook_buf($3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$Base64_decode(d)), opts);
            case "binary":
                return lotus_to_workbook_buf($3ee4f50b1ae43a89$var$s2a(d), opts);
            case "buffer":
            case "array":
                return lotus_to_workbook_buf(d, opts);
        }
        throw "Unsupported type " + opts.type;
    }
    function lotus_to_workbook_buf(d, opts) /*:Workbook*/ {
        if (!d) return d;
        var o = opts || {};
        if ($3ee4f50b1ae43a89$var$DENSE != null && o.dense == null) o.dense = $3ee4f50b1ae43a89$var$DENSE;
        var s /*:Worksheet*/  = o.dense ? [] : {}, n = "Sheet1", next_n = "", sidx = 0;
        var sheets = {}, snames = [], realnames = [];
        var refguess = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var sheetRows = o.sheetRows || 0;
        if (d[2] == 0x00) {
            if (d[3] == 0x08 || d[3] == 0x09) {
                if (d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
            }
        }
        if (d[2] == 0x02) {
            o.Enum = WK1Enum;
            lotushopper(d, function(val, R, RT) {
                switch(RT){
                    case 0x00:
                        /* BOF */ o.vers = val;
                        if (val >= 0x1000) o.qpro = true;
                        break;
                    case 0x06:
                        refguess = val;
                        break; /* RANGE */ 
                    case 0xCC:
                        if (val) next_n = val;
                        break; /* SHEETNAMECS */ 
                    case 0xDE:
                        next_n = val;
                        break; /* SHEETNAMELP */ 
                    case 0x0F:
                    /* LABEL */ case 0x33:
                        /* STRING */ if (!o.qpro) val[1].v = val[1].v.slice(1);
                    /* falls through */ case 0x0D:
                    /* INTEGER */ case 0x0E:
                    /* NUMBER */ case 0x10:
                        /* FORMULA */ /* TODO: actual translation of the format code */ if (RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
                            val[1].z = o.dateNF || $3ee4f50b1ae43a89$var$table_fmt[14];
                            if (o.cellDates) {
                                val[1].t = "d";
                                val[1].v = $3ee4f50b1ae43a89$var$numdate(val[1].v);
                            }
                        }
                        if (o.qpro) {
                            if (val[3] > sidx) {
                                s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
                                sheets[n] = s;
                                snames.push(n);
                                s = o.dense ? [] : {};
                                refguess = {
                                    s: {
                                        r: 0,
                                        c: 0
                                    },
                                    e: {
                                        r: 0,
                                        c: 0
                                    }
                                };
                                sidx = val[3];
                                n = next_n || "Sheet" + (sidx + 1);
                                next_n = "";
                            }
                        }
                        var tmpcell = o.dense ? (s[val[0].r] || [])[val[0].c] : s[$3ee4f50b1ae43a89$var$encode_cell(val[0])];
                        if (tmpcell) {
                            tmpcell.t = val[1].t;
                            tmpcell.v = val[1].v;
                            if (val[1].z != null) tmpcell.z = val[1].z;
                            if (val[1].f != null) tmpcell.f = val[1].f;
                            break;
                        }
                        if (o.dense) {
                            if (!s[val[0].r]) s[val[0].r] = [];
                            s[val[0].r][val[0].c] = val[1];
                        } else s[$3ee4f50b1ae43a89$var$encode_cell(val[0])] = val[1];
                        break;
                    default:
                }
            }, o);
        } else if (d[2] == 0x1A || d[2] == 0x0E) {
            o.Enum = WK3Enum;
            if (d[2] == 0x0E) {
                o.qpro = true;
                d.l = 0;
            }
            lotushopper(d, function(val, R, RT) {
                switch(RT){
                    case 0xCC:
                        n = val;
                        break; /* SHEETNAMECS */ 
                    case 0x16:
                        /* LABEL16 */ val[1].v = val[1].v.slice(1);
                    /* falls through */ case 0x17:
                    /* NUMBER17 */ case 0x18:
                    /* NUMBER18 */ case 0x19:
                    /* FORMULA19 */ case 0x25:
                    /* NUMBER25 */ case 0x27:
                    /* NUMBER27 */ case 0x28:
                        /* FORMULA28 */ if (val[3] > sidx) {
                            s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
                            sheets[n] = s;
                            snames.push(n);
                            s = o.dense ? [] : {};
                            refguess = {
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 0,
                                    c: 0
                                }
                            };
                            sidx = val[3];
                            n = "Sheet" + (sidx + 1);
                        }
                        if (sheetRows > 0 && val[0].r >= sheetRows) break;
                        if (o.dense) {
                            if (!s[val[0].r]) s[val[0].r] = [];
                            s[val[0].r][val[0].c] = val[1];
                        } else s[$3ee4f50b1ae43a89$var$encode_cell(val[0])] = val[1];
                        if (refguess.e.c < val[0].c) refguess.e.c = val[0].c;
                        if (refguess.e.r < val[0].r) refguess.e.r = val[0].r;
                        break;
                    case 0x1B:
                        /* XFORMAT */ if (val[0x36b0]) realnames[val[0x36b0][0]] = val[0x36b0][1];
                        break;
                    case 0x0601:
                        /* SHEETINFOQP */ realnames[val[0]] = val[1];
                        if (val[0] == sidx) n = val[1];
                        break;
                    default:
                        break;
                }
            }, o);
        } else throw new Error("Unrecognized LOTUS BOF " + d[2]);
        s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
        sheets[next_n || n] = s;
        snames.push(next_n || n);
        if (!realnames.length) return {
            SheetNames: snames,
            Sheets: sheets
        };
        var osheets = {}, rnames = [];
        /* TODO: verify no collisions */ for(var i = 0; i < realnames.length; ++i)if (sheets[snames[i]]) {
            rnames.push(realnames[i] || snames[i]);
            osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
        } else {
            rnames.push(realnames[i]);
            osheets[realnames[i]] = {
                "!ref": "A1"
            };
        }
        return {
            SheetNames: rnames,
            Sheets: osheets
        };
    }
    function sheet_to_wk1(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $3ee4f50b1ae43a89$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK1 to JS string");
        var ba = $3ee4f50b1ae43a89$var$buf_array();
        var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]);
        var dense = Array.isArray(ws);
        var cols = [];
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x06, write_RANGE(range));
        var max_R = Math.min(range.e.r, 8191);
        for(var R = range.s.r; R <= max_R; ++R){
            var rr = $3ee4f50b1ae43a89$var$encode_row(R);
            for(var C = range.s.c; C <= range.e.c; ++C){
                if (R === range.s.r) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
                var ref = cols[C] + rr;
                var cell = dense ? (ws[R] || [])[C] : ws[ref];
                if (!cell || cell.t == "z") continue;
                /* TODO: formula records */ if (cell.t == "n") {
                    if ((cell.v | 0) == cell.v && cell.v >= -32768 && cell.v <= 32767) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell.v));
                    else $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell.v));
                } else {
                    var str = $3ee4f50b1ae43a89$var$format_cell(cell);
                    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
                }
            }
        }
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function book_to_wk3(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $3ee4f50b1ae43a89$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK3 to JS string");
        var ba = $3ee4f50b1ae43a89$var$buf_array();
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
        for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i)if ((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
        var wsidx = 0;
        for(i = 0; i < wb.SheetNames.length; ++i){
            var ws = wb.Sheets[wb.SheetNames[i]];
            if (!ws || !ws["!ref"]) continue;
            var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]);
            var dense = Array.isArray(ws);
            var cols = [];
            var max_R = Math.min(range.e.r, 8191);
            for(var R = range.s.r; R <= max_R; ++R){
                var rr = $3ee4f50b1ae43a89$var$encode_row(R);
                for(var C = range.s.c; C <= range.e.c; ++C){
                    if (R === range.s.r) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
                    var ref = cols[C] + rr;
                    var cell = dense ? (ws[R] || [])[C] : ws[ref];
                    if (!cell || cell.t == "z") continue;
                    /* TODO: FORMULA19 NUMBER18 records */ if (cell.t == "n") $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
                    else {
                        var str = $3ee4f50b1ae43a89$var$format_cell(cell);
                        /* TODO: max len? */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
                    }
                }
            }
            ++wsidx;
        }
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function write_BOF_WK1(v /*:number*/ ) {
        var out = $3ee4f50b1ae43a89$var$new_buf(2);
        out.write_shift(2, v);
        return out;
    }
    function write_BOF_WK3(wb /*:Workbook*/ ) {
        var out = $3ee4f50b1ae43a89$var$new_buf(26);
        out.write_shift(2, 0x1000);
        out.write_shift(2, 0x0004);
        out.write_shift(4, 0x0000);
        var rows = 0, cols = 0, wscnt = 0;
        for(var i = 0; i < wb.SheetNames.length; ++i){
            var name = wb.SheetNames[i];
            var ws = wb.Sheets[name];
            if (!ws || !ws["!ref"]) continue;
            ++wscnt;
            var range = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
            if (rows < range.e.r) rows = range.e.r;
            if (cols < range.e.c) cols = range.e.c;
        }
        if (rows > 8191) rows = 8191;
        out.write_shift(2, rows);
        out.write_shift(1, wscnt);
        out.write_shift(1, cols);
        out.write_shift(2, 0x00);
        out.write_shift(2, 0x00);
        out.write_shift(1, 0x01);
        out.write_shift(1, 0x02);
        out.write_shift(4, 0);
        out.write_shift(4, 0);
        return out;
    }
    function parse_RANGE(blob, length, opts) {
        var o = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        };
        if (length == 8 && opts.qpro) {
            o.s.c = blob.read_shift(1);
            blob.l++;
            o.s.r = blob.read_shift(2);
            o.e.c = blob.read_shift(1);
            blob.l++;
            o.e.r = blob.read_shift(2);
            return o;
        }
        o.s.c = blob.read_shift(2);
        o.s.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        o.e.c = blob.read_shift(2);
        o.e.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        if (o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
        return o;
    }
    function write_RANGE(range) {
        var out = $3ee4f50b1ae43a89$var$new_buf(8);
        out.write_shift(2, range.s.c);
        out.write_shift(2, range.s.r);
        out.write_shift(2, range.e.c);
        out.write_shift(2, range.e.r);
        return out;
    }
    function parse_cell(blob, length, opts) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: "n",
                v: 0
            },
            0,
            0
        ];
        if (opts.qpro && opts.vers != 0x5120) {
            o[0].c = blob.read_shift(1);
            o[3] = blob.read_shift(1);
            o[0].r = blob.read_shift(2);
            blob.l += 2;
        } else {
            o[2] = blob.read_shift(1);
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
        }
        return o;
    }
    function parse_LABEL(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = "s";
        if (opts.vers == 0x5120) {
            blob.l++;
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, "utf8");
            return o;
        }
        if (opts.qpro) blob.l++;
        o[1].v = blob.read_shift(tgt - blob.l, "cstr");
        return o;
    }
    function write_LABEL(R, C, s) {
        /* TODO: encoding */ var o = $3ee4f50b1ae43a89$var$new_buf(7 + s.length);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(1, 0x27); // ??
        for(var i = 0; i < o.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_INTEGER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(2, "i");
        return o;
    }
    function write_INTEGER(R, C, v) {
        var o = $3ee4f50b1ae43a89$var$new_buf(7);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(2, v, "i");
        return o;
    }
    function parse_NUMBER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(8, "f");
        return o;
    }
    function write_NUMBER(R, C, v) {
        var o = $3ee4f50b1ae43a89$var$new_buf(13);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(8, v, "f");
        return o;
    }
    function parse_FORMULA(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        /* TODO: formula */ o[1].v = blob.read_shift(8, "f");
        if (opts.qpro) blob.l = tgt;
        else {
            var flen = blob.read_shift(2);
            wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
            blob.l += flen;
        }
        return o;
    }
    function wk1_parse_rc(B, V, col) {
        var rel = V & 0x8000;
        V &= -32769;
        V = (rel ? B : 0) + (V >= 0x2000 ? V - 0x4000 : V);
        return (rel ? "" : "$") + (col ? $3ee4f50b1ae43a89$var$encode_col(V) : $3ee4f50b1ae43a89$var$encode_row(V));
    }
    /* var oprec = [
		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
	]; */ /* TODO: flesh out */ var FuncTab = {
        0x33: [
            "FALSE",
            0
        ],
        0x34: [
            "TRUE",
            0
        ],
        0x46: [
            "LEN",
            1
        ],
        0x50: [
            "SUM",
            69
        ],
        0x51: [
            "AVERAGEA",
            69
        ],
        0x52: [
            "COUNTA",
            69
        ],
        0x53: [
            "MINA",
            69
        ],
        0x54: [
            "MAXA",
            69
        ],
        0x6F: [
            "T",
            1
        ]
    };
    var BinOpTab = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "+",
        "-",
        "*",
        "/",
        "^",
        "=",
        "<>",
        "<=",
        ">=",
        "<",
        ">",
        "",
        "",
        "",
        "",
        "&",
        "",
        "",
        "",
        "",
        "",
        "",
        "" // eslint-disable-line no-mixed-spaces-and-tabs
    ];
    function wk1_fmla_to_csf(blob, o) {
        $3ee4f50b1ae43a89$var$prep_blob(blob, 0);
        var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
        while(blob.l < blob.length){
            var cc = blob[blob.l++];
            switch(cc){
                case 0x00:
                    out.push(blob.read_shift(8, "f"));
                    break;
                case 0x01:
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(C + R);
                    break;
                case 0x02:
                    var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(c + r + ":" + C + R);
                    break;
                case 0x03:
                    if (blob.l < blob.length) {
                        console.error("WK1 premature formula end");
                        return;
                    }
                    break;
                case 0x04:
                    out.push("(" + out.pop() + ")");
                    break;
                case 0x05:
                    out.push(blob.read_shift(2));
                    break;
                case 0x06:
                    /* TODO: text encoding */ var Z = "";
                    while(cc = blob[blob.l++])Z += String.fromCharCode(cc);
                    out.push('"' + Z.replace(/"/g, '""') + '"');
                    break;
                case 0x08:
                    out.push("-" + out.pop());
                    break;
                case 0x17:
                    out.push("+" + out.pop());
                    break;
                case 0x16:
                    out.push("NOT(" + out.pop() + ")");
                    break;
                case 0x14:
                case 0x15:
                    argR = out.pop();
                    argL = out.pop();
                    out.push([
                        "AND",
                        "OR"
                    ][cc - 0x14] + "(" + argL + "," + argR + ")");
                    break;
                default:
                    if (cc < 0x20 && BinOpTab[cc]) {
                        argR = out.pop();
                        argL = out.pop();
                        out.push(argL + BinOpTab[cc] + argR);
                    } else if (FuncTab[cc]) {
                        argc = FuncTab[cc][1];
                        if (argc == 69) argc = blob[blob.l++];
                        if (argc > out.length) {
                            console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|");
                            return;
                        }
                        var args = out.slice(-argc);
                        out.length -= argc;
                        out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
                    } else if (cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
                    else if (cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
                    else return console.error("WK1 unrecognized opcode " + cc.toString(16));
            }
        }
        if (out.length == 1) o[1].f = "" + out[0];
        else console.error("WK1 bad formula parse |" + out.join("|") + "|");
    }
    function parse_cell_3(blob /*::, length*/ ) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: "n",
                v: 0
            },
            0
        ];
        o[0].r = blob.read_shift(2);
        o[3] = blob[blob.l++];
        o[0].c = blob[blob.l++];
        return o;
    }
    function parse_LABEL_16(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].t = "s";
        o[1].v = blob.read_shift(length - 4, "cstr");
        return o;
    }
    function write_LABEL_16(R, C, wsidx, s) {
        /* TODO: encoding */ var o = $3ee4f50b1ae43a89$var$new_buf(6 + s.length);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        o.write_shift(1, 0x27);
        for(var i = 0; i < s.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_NUMBER_18(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].v = blob.read_shift(2);
        var v = o[1].v >> 1;
        if (o[1].v & 0x1) switch(v & 0x07){
            case 0:
                v = (v >> 3) * 5000;
                break;
            case 1:
                v = (v >> 3) * 500;
                break;
            case 2:
                v = (v >> 3) / 20;
                break;
            case 3:
                v = (v >> 3) / 200;
                break;
            case 4:
                v = (v >> 3) / 2000;
                break;
            case 5:
                v = (v >> 3) / 20000;
                break;
            case 6:
                v = (v >> 3) / 16;
                break;
            case 7:
                v = (v >> 3) / 64;
                break;
        }
        o[1].v = v;
        return o;
    }
    function parse_NUMBER_17(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        var v2 = blob.read_shift(4);
        var e = blob.read_shift(2);
        if (e == 0xFFFF) {
            if (v1 === 0 && v2 === 0xC0000000) {
                o[1].t = "e";
                o[1].v = 0x0F;
            } else if (v1 === 0 && v2 === 0xD0000000) {
                o[1].t = "e";
                o[1].v = 0x2A;
            } else o[1].v = 0;
            return o;
        }
        var s = e & 0x8000;
        e = (e & 0x7FFF) - 16446;
        o[1].v = (1 - s * 2) * (v2 * Math.pow(2, e + 32) + v1 * Math.pow(2, e));
        return o;
    }
    function write_NUMBER_17(R, C, wsidx, v) {
        var o = $3ee4f50b1ae43a89$var$new_buf(14);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        if (v == 0) {
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(2, 0xFFFF);
            return o;
        }
        var s = 0, e = 0, v1 = 0, v2 = 0;
        if (v < 0) {
            s = 1;
            v = -v;
        }
        e = Math.log2(v) | 0;
        v /= Math.pow(2, e - 31);
        v2 = v >>> 0;
        if ((v2 & 0x80000000) == 0) {
            v /= 2;
            ++e;
            v2 = v >>> 0;
        }
        v -= v2;
        v2 |= 0x80000000;
        v2 >>>= 0;
        v *= Math.pow(2, 32);
        v1 = v >>> 0;
        o.write_shift(4, v1);
        o.write_shift(4, v2);
        e += 0x3FFF + (s ? 0x8000 : 0);
        o.write_shift(2, e);
        return o;
    }
    function parse_FORMULA_19(blob, length) {
        var o = parse_NUMBER_17(blob, 14);
        blob.l += length - 14; /* TODO: WK3 formula */ 
        return o;
    }
    function parse_NUMBER_25(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        o[1].v = v1 >> 6;
        return o;
    }
    function parse_NUMBER_27(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(8, "f");
        o[1].v = v1;
        return o;
    }
    function parse_FORMULA_28(blob, length) {
        var o = parse_NUMBER_27(blob, 14);
        blob.l += length - 10; /* TODO: formula */ 
        return o;
    }
    function parse_SHEETNAMECS(blob, length) {
        return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, "cstr") : "";
    }
    function parse_SHEETNAMELP(blob, length) {
        var len = blob[blob.l++];
        if (len > length - 1) len = length - 1;
        var o = "";
        while(o.length < len)o += String.fromCharCode(blob[blob.l++]);
        return o;
    }
    function parse_SHEETINFOQP(blob, length, opts) {
        if (!opts.qpro || length < 21) return;
        var id = blob.read_shift(1);
        blob.l += 17;
        blob.l += 1; //var len = blob.read_shift(1);
        blob.l += 2;
        var nm = blob.read_shift(length - 21, "cstr");
        return [
            id,
            nm
        ];
    }
    function parse_XFORMAT(blob, length) {
        var o = {}, tgt = blob.l + length;
        while(blob.l < tgt){
            var dt = blob.read_shift(2);
            if (dt == 0x36b0) {
                o[dt] = [
                    0,
                    ""
                ];
                o[dt][0] = blob.read_shift(2);
                while(blob[blob.l]){
                    o[dt][1] += String.fromCharCode(blob[blob.l]);
                    blob.l++;
                }
                blob.l++;
            }
        // TODO: 0x3a99 ??
        }
        return o;
    }
    function write_XFORMAT_SHEETNAME(name, wsidx) {
        var out = $3ee4f50b1ae43a89$var$new_buf(5 + name.length);
        out.write_shift(2, 0x36b0);
        out.write_shift(2, wsidx);
        for(var i = 0; i < name.length; ++i){
            var cc = name.charCodeAt(i);
            out[out.l++] = cc > 0x7F ? 0x5F : cc;
        }
        out[out.l++] = 0;
        return out;
    }
    var WK1Enum = {
        /*::[*/ 0x0000: {
            n: "BOF",
            f: $3ee4f50b1ae43a89$var$parseuint16
        },
        /*::[*/ 0x0001: {
            n: "EOF"
        },
        /*::[*/ 0x0002: {
            n: "CALCMODE"
        },
        /*::[*/ 0x0003: {
            n: "CALCORDER"
        },
        /*::[*/ 0x0004: {
            n: "SPLIT"
        },
        /*::[*/ 0x0005: {
            n: "SYNC"
        },
        /*::[*/ 0x0006: {
            n: "RANGE",
            f: parse_RANGE
        },
        /*::[*/ 0x0007: {
            n: "WINDOW1"
        },
        /*::[*/ 0x0008: {
            n: "COLW1"
        },
        /*::[*/ 0x0009: {
            n: "WINTWO"
        },
        /*::[*/ 0x000A: {
            n: "COLW2"
        },
        /*::[*/ 0x000B: {
            n: "NAME"
        },
        /*::[*/ 0x000C: {
            n: "BLANK"
        },
        /*::[*/ 0x000D: {
            n: "INTEGER",
            f: parse_INTEGER
        },
        /*::[*/ 0x000E: {
            n: "NUMBER",
            f: parse_NUMBER
        },
        /*::[*/ 0x000F: {
            n: "LABEL",
            f: parse_LABEL
        },
        /*::[*/ 0x0010: {
            n: "FORMULA",
            f: parse_FORMULA
        },
        /*::[*/ 0x0018: {
            n: "TABLE"
        },
        /*::[*/ 0x0019: {
            n: "ORANGE"
        },
        /*::[*/ 0x001A: {
            n: "PRANGE"
        },
        /*::[*/ 0x001B: {
            n: "SRANGE"
        },
        /*::[*/ 0x001C: {
            n: "FRANGE"
        },
        /*::[*/ 0x001D: {
            n: "KRANGE1"
        },
        /*::[*/ 0x0020: {
            n: "HRANGE"
        },
        /*::[*/ 0x0023: {
            n: "KRANGE2"
        },
        /*::[*/ 0x0024: {
            n: "PROTEC"
        },
        /*::[*/ 0x0025: {
            n: "FOOTER"
        },
        /*::[*/ 0x0026: {
            n: "HEADER"
        },
        /*::[*/ 0x0027: {
            n: "SETUP"
        },
        /*::[*/ 0x0028: {
            n: "MARGINS"
        },
        /*::[*/ 0x0029: {
            n: "LABELFMT"
        },
        /*::[*/ 0x002A: {
            n: "TITLES"
        },
        /*::[*/ 0x002B: {
            n: "SHEETJS"
        },
        /*::[*/ 0x002D: {
            n: "GRAPH"
        },
        /*::[*/ 0x002E: {
            n: "NGRAPH"
        },
        /*::[*/ 0x002F: {
            n: "CALCCOUNT"
        },
        /*::[*/ 0x0030: {
            n: "UNFORMATTED"
        },
        /*::[*/ 0x0031: {
            n: "CURSORW12"
        },
        /*::[*/ 0x0032: {
            n: "WINDOW"
        },
        /*::[*/ 0x0033: {
            n: "STRING",
            f: parse_LABEL
        },
        /*::[*/ 0x0037: {
            n: "PASSWORD"
        },
        /*::[*/ 0x0038: {
            n: "LOCKED"
        },
        /*::[*/ 0x003C: {
            n: "QUERY"
        },
        /*::[*/ 0x003D: {
            n: "QUERYNAME"
        },
        /*::[*/ 0x003E: {
            n: "PRINT"
        },
        /*::[*/ 0x003F: {
            n: "PRINTNAME"
        },
        /*::[*/ 0x0040: {
            n: "GRAPH2"
        },
        /*::[*/ 0x0041: {
            n: "GRAPHNAME"
        },
        /*::[*/ 0x0042: {
            n: "ZOOM"
        },
        /*::[*/ 0x0043: {
            n: "SYMSPLIT"
        },
        /*::[*/ 0x0044: {
            n: "NSROWS"
        },
        /*::[*/ 0x0045: {
            n: "NSCOLS"
        },
        /*::[*/ 0x0046: {
            n: "RULER"
        },
        /*::[*/ 0x0047: {
            n: "NNAME"
        },
        /*::[*/ 0x0048: {
            n: "ACOMM"
        },
        /*::[*/ 0x0049: {
            n: "AMACRO"
        },
        /*::[*/ 0x004A: {
            n: "PARSE"
        },
        /*::[*/ 0x0066: {
            n: "PRANGES??"
        },
        /*::[*/ 0x0067: {
            n: "RRANGES??"
        },
        /*::[*/ 0x0068: {
            n: "FNAME??"
        },
        /*::[*/ 0x0069: {
            n: "MRANGES??"
        },
        /*::[*/ 0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        /*::[*/ 0x00DE: {
            n: "SHEETNAMELP",
            f: parse_SHEETNAMELP
        },
        /*::[*/ 0xFFFF: {
            n: ""
        }
    };
    var WK3Enum = {
        /*::[*/ 0x0000: {
            n: "BOF"
        },
        /*::[*/ 0x0001: {
            n: "EOF"
        },
        /*::[*/ 0x0002: {
            n: "PASSWORD"
        },
        /*::[*/ 0x0003: {
            n: "CALCSET"
        },
        /*::[*/ 0x0004: {
            n: "WINDOWSET"
        },
        /*::[*/ 0x0005: {
            n: "SHEETCELLPTR"
        },
        /*::[*/ 0x0006: {
            n: "SHEETLAYOUT"
        },
        /*::[*/ 0x0007: {
            n: "COLUMNWIDTH"
        },
        /*::[*/ 0x0008: {
            n: "HIDDENCOLUMN"
        },
        /*::[*/ 0x0009: {
            n: "USERRANGE"
        },
        /*::[*/ 0x000A: {
            n: "SYSTEMRANGE"
        },
        /*::[*/ 0x000B: {
            n: "ZEROFORCE"
        },
        /*::[*/ 0x000C: {
            n: "SORTKEYDIR"
        },
        /*::[*/ 0x000D: {
            n: "FILESEAL"
        },
        /*::[*/ 0x000E: {
            n: "DATAFILLNUMS"
        },
        /*::[*/ 0x000F: {
            n: "PRINTMAIN"
        },
        /*::[*/ 0x0010: {
            n: "PRINTSTRING"
        },
        /*::[*/ 0x0011: {
            n: "GRAPHMAIN"
        },
        /*::[*/ 0x0012: {
            n: "GRAPHSTRING"
        },
        /*::[*/ 0x0013: {
            n: "??"
        },
        /*::[*/ 0x0014: {
            n: "ERRCELL"
        },
        /*::[*/ 0x0015: {
            n: "NACELL"
        },
        /*::[*/ 0x0016: {
            n: "LABEL16",
            f: parse_LABEL_16
        },
        /*::[*/ 0x0017: {
            n: "NUMBER17",
            f: parse_NUMBER_17
        },
        /*::[*/ 0x0018: {
            n: "NUMBER18",
            f: parse_NUMBER_18
        },
        /*::[*/ 0x0019: {
            n: "FORMULA19",
            f: parse_FORMULA_19
        },
        /*::[*/ 0x001A: {
            n: "FORMULA1A"
        },
        /*::[*/ 0x001B: {
            n: "XFORMAT",
            f: parse_XFORMAT
        },
        /*::[*/ 0x001C: {
            n: "DTLABELMISC"
        },
        /*::[*/ 0x001D: {
            n: "DTLABELCELL"
        },
        /*::[*/ 0x001E: {
            n: "GRAPHWINDOW"
        },
        /*::[*/ 0x001F: {
            n: "CPA"
        },
        /*::[*/ 0x0020: {
            n: "LPLAUTO"
        },
        /*::[*/ 0x0021: {
            n: "QUERY"
        },
        /*::[*/ 0x0022: {
            n: "HIDDENSHEET"
        },
        /*::[*/ 0x0023: {
            n: "??"
        },
        /*::[*/ 0x0025: {
            n: "NUMBER25",
            f: parse_NUMBER_25
        },
        /*::[*/ 0x0026: {
            n: "??"
        },
        /*::[*/ 0x0027: {
            n: "NUMBER27",
            f: parse_NUMBER_27
        },
        /*::[*/ 0x0028: {
            n: "FORMULA28",
            f: parse_FORMULA_28
        },
        /*::[*/ 0x008E: {
            n: "??"
        },
        /*::[*/ 0x0093: {
            n: "??"
        },
        /*::[*/ 0x0096: {
            n: "??"
        },
        /*::[*/ 0x0097: {
            n: "??"
        },
        /*::[*/ 0x0098: {
            n: "??"
        },
        /*::[*/ 0x0099: {
            n: "??"
        },
        /*::[*/ 0x009A: {
            n: "??"
        },
        /*::[*/ 0x009B: {
            n: "??"
        },
        /*::[*/ 0x009C: {
            n: "??"
        },
        /*::[*/ 0x00A3: {
            n: "??"
        },
        /*::[*/ 0x00AE: {
            n: "??"
        },
        /*::[*/ 0x00AF: {
            n: "??"
        },
        /*::[*/ 0x00B0: {
            n: "??"
        },
        /*::[*/ 0x00B1: {
            n: "??"
        },
        /*::[*/ 0x00B8: {
            n: "??"
        },
        /*::[*/ 0x00B9: {
            n: "??"
        },
        /*::[*/ 0x00BA: {
            n: "??"
        },
        /*::[*/ 0x00BB: {
            n: "??"
        },
        /*::[*/ 0x00BC: {
            n: "??"
        },
        /*::[*/ 0x00C3: {
            n: "??"
        },
        /*::[*/ 0x00C9: {
            n: "??"
        },
        /*::[*/ 0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        /*::[*/ 0x00CD: {
            n: "??"
        },
        /*::[*/ 0x00CE: {
            n: "??"
        },
        /*::[*/ 0x00CF: {
            n: "??"
        },
        /*::[*/ 0x00D0: {
            n: "??"
        },
        /*::[*/ 0x0100: {
            n: "??"
        },
        /*::[*/ 0x0103: {
            n: "??"
        },
        /*::[*/ 0x0104: {
            n: "??"
        },
        /*::[*/ 0x0105: {
            n: "??"
        },
        /*::[*/ 0x0106: {
            n: "??"
        },
        /*::[*/ 0x0107: {
            n: "??"
        },
        /*::[*/ 0x0109: {
            n: "??"
        },
        /*::[*/ 0x010A: {
            n: "??"
        },
        /*::[*/ 0x010B: {
            n: "??"
        },
        /*::[*/ 0x010C: {
            n: "??"
        },
        /*::[*/ 0x010E: {
            n: "??"
        },
        /*::[*/ 0x010F: {
            n: "??"
        },
        /*::[*/ 0x0180: {
            n: "??"
        },
        /*::[*/ 0x0185: {
            n: "??"
        },
        /*::[*/ 0x0186: {
            n: "??"
        },
        /*::[*/ 0x0189: {
            n: "??"
        },
        /*::[*/ 0x018C: {
            n: "??"
        },
        /*::[*/ 0x0200: {
            n: "??"
        },
        /*::[*/ 0x0202: {
            n: "??"
        },
        /*::[*/ 0x0201: {
            n: "??"
        },
        /*::[*/ 0x0204: {
            n: "??"
        },
        /*::[*/ 0x0205: {
            n: "??"
        },
        /*::[*/ 0x0280: {
            n: "??"
        },
        /*::[*/ 0x0281: {
            n: "??"
        },
        /*::[*/ 0x0282: {
            n: "??"
        },
        /*::[*/ 0x0283: {
            n: "??"
        },
        /*::[*/ 0x0284: {
            n: "??"
        },
        /*::[*/ 0x0285: {
            n: "??"
        },
        /*::[*/ 0x0286: {
            n: "??"
        },
        /*::[*/ 0x0287: {
            n: "??"
        },
        /*::[*/ 0x0288: {
            n: "??"
        },
        /*::[*/ 0x0292: {
            n: "??"
        },
        /*::[*/ 0x0293: {
            n: "??"
        },
        /*::[*/ 0x0294: {
            n: "??"
        },
        /*::[*/ 0x0295: {
            n: "??"
        },
        /*::[*/ 0x0296: {
            n: "??"
        },
        /*::[*/ 0x0299: {
            n: "??"
        },
        /*::[*/ 0x029A: {
            n: "??"
        },
        /*::[*/ 0x0300: {
            n: "??"
        },
        /*::[*/ 0x0304: {
            n: "??"
        },
        /*::[*/ 0x0601: {
            n: "SHEETINFOQP",
            f: parse_SHEETINFOQP
        },
        /*::[*/ 0x0640: {
            n: "??"
        },
        /*::[*/ 0x0642: {
            n: "??"
        },
        /*::[*/ 0x0701: {
            n: "??"
        },
        /*::[*/ 0x0702: {
            n: "??"
        },
        /*::[*/ 0x0703: {
            n: "??"
        },
        /*::[*/ 0x0704: {
            n: "??"
        },
        /*::[*/ 0x0780: {
            n: "??"
        },
        /*::[*/ 0x0800: {
            n: "??"
        },
        /*::[*/ 0x0801: {
            n: "??"
        },
        /*::[*/ 0x0804: {
            n: "??"
        },
        /*::[*/ 0x0A80: {
            n: "??"
        },
        /*::[*/ 0x2AF6: {
            n: "??"
        },
        /*::[*/ 0x3231: {
            n: "??"
        },
        /*::[*/ 0x6E49: {
            n: "??"
        },
        /*::[*/ 0x6F44: {
            n: "??"
        },
        /*::[*/ 0xFFFF: {
            n: ""
        }
    };
    return {
        sheet_to_wk1: sheet_to_wk1,
        book_to_wk3: book_to_wk3,
        to_workbook: lotus_to_workbook
    };
}();
/* 18.4.7 rPr CT_RPrElt */ function $3ee4f50b1ae43a89$var$parse_rpr(rpr) {
    var font = {}, m = rpr.match($3ee4f50b1ae43a89$var$tagregex), i = 0;
    var pass = false;
    if (m) for(; i != m.length; ++i){
        var y = $3ee4f50b1ae43a89$var$parsexmltag(m[i]);
        switch(y[0].replace(/\w*:/g, "")){
            /* 18.8.12 condense CT_BooleanProperty */ /* ** not required . */ case "<condense":
                break;
            /* 18.8.17 extend CT_BooleanProperty */ /* ** not required . */ case "<extend":
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ /* ** not required . */ case "<shadow":
                if (!y.val) break;
            /* falls through */ case "<shadow>":
            case "<shadow/>":
                font.shadow = 1;
                break;
            case "</shadow>":
                break;
            /* 18.4.1 charset CT_IntProperty TODO */ case "<charset":
                if (y.val == "1") break;
                font.cp = $3ee4f50b1ae43a89$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.4.2 outline CT_BooleanProperty TODO */ case "<outline":
                if (!y.val) break;
            /* falls through */ case "<outline>":
            case "<outline/>":
                font.outline = 1;
                break;
            case "</outline>":
                break;
            /* 18.4.5 rFont CT_FontName */ case "<rFont":
                font.name = y.val;
                break;
            /* 18.4.11 sz CT_FontSize */ case "<sz":
                font.sz = y.val;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case "<strike":
                if (!y.val) break;
            /* falls through */ case "<strike>":
            case "<strike/>":
                font.strike = 1;
                break;
            case "</strike>":
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case "<u":
                if (!y.val) break;
                switch(y.val){
                    case "double":
                        font.uval = "double";
                        break;
                    case "singleAccounting":
                        font.uval = "single-accounting";
                        break;
                    case "doubleAccounting":
                        font.uval = "double-accounting";
                        break;
                }
            /* falls through */ case "<u>":
            case "<u/>":
                font.u = 1;
                break;
            case "</u>":
                break;
            /* 18.8.2 b */ case "<b":
                if (y.val == "0") break;
            /* falls through */ case "<b>":
            case "<b/>":
                font.b = 1;
                break;
            case "</b>":
                break;
            /* 18.8.26 i */ case "<i":
                if (y.val == "0") break;
            /* falls through */ case "<i>":
            case "<i/>":
                font.i = 1;
                break;
            case "</i>":
                break;
            /* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */ case "<color":
                if (y.rgb) font.color = y.rgb.slice(2, 8);
                break;
            case "<color>":
            case "<color/>":
            case "</color>":
                break;
            /* 18.8.18 family ST_FontFamily */ case "<family":
                font.family = y.val;
                break;
            case "<family>":
            case "<family/>":
            case "</family>":
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */ case "<vertAlign":
                font.valign = y.val;
                break;
            case "<vertAlign>":
            case "<vertAlign/>":
            case "</vertAlign>":
                break;
            /* 18.8.35 scheme CT_FontScheme TODO */ case "<scheme":
                break;
            case "<scheme>":
            case "<scheme/>":
            case "</scheme>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (y[0].charCodeAt(1) !== 47 && !pass) throw new Error("Unrecognized rich format " + y[0]);
        }
    }
    return font;
}
var $3ee4f50b1ae43a89$var$parse_rs = /*#__PURE__*/ function() {
    var tregex = $3ee4f50b1ae43a89$var$matchtag("t"), rpregex = $3ee4f50b1ae43a89$var$matchtag("rPr");
    /* 18.4.4 r CT_RElt */ function parse_r(r) {
        /* 18.4.12 t ST_Xstring */ var t = r.match(tregex) /*, cp = 65001*/ ;
        if (!t) return {
            t: "s",
            v: ""
        };
        var o /*:Cell*/  = {
            t: "s",
            v: $3ee4f50b1ae43a89$var$unescapexml(t[1])
        } /*:any*/ ;
        var rpr = r.match(rpregex);
        if (rpr) o.s = $3ee4f50b1ae43a89$var$parse_rpr(rpr[1]);
        return o;
    }
    var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
    return function parse_rs(rs) {
        return rs.replace(rregex, "").split(rend).map(parse_r).filter(function(r) {
            return r.v;
        });
    };
}();
/* Parse a list of <r> tags */ var $3ee4f50b1ae43a89$var$rs_to_html = /*#__PURE__*/ function parse_rs_factory() {
    var nlregex = /(\r\n|\n)/g;
    function parse_rpr2(font, intro, outro) {
        var style /*:Array<string>*/  = [];
        if (font.u) style.push("text-decoration: underline;");
        if (font.uval) style.push("text-underline-style:" + font.uval + ";");
        if (font.sz) style.push("font-size:" + font.sz + "pt;");
        if (font.outline) style.push("text-effect: outline;");
        if (font.shadow) style.push("text-shadow: auto;");
        intro.push('<span style="' + style.join("") + '">');
        if (font.b) {
            intro.push("<b>");
            outro.push("</b>");
        }
        if (font.i) {
            intro.push("<i>");
            outro.push("</i>");
        }
        if (font.strike) {
            intro.push("<s>");
            outro.push("</s>");
        }
        var align = font.valign || "";
        if (align == "superscript" || align == "super") align = "sup";
        else if (align == "subscript") align = "sub";
        if (align != "") {
            intro.push("<" + align + ">");
            outro.push("</" + align + ">");
        }
        outro.push("</span>");
        return font;
    }
    /* 18.4.4 r CT_RElt */ function r_to_html(r) {
        var terms /*:[Array<string>, string, Array<string>]*/  = [
            [],
            r.v,
            []
        ];
        if (!r.v) return "";
        if (r.s) parse_rpr2(r.s, terms[0], terms[2]);
        return terms[0].join("") + terms[1].replace(nlregex, "<br/>") + terms[2].join("");
    }
    return function parse_rs(rs) {
        return rs.map(r_to_html).join("");
    };
}();
/* 18.4.8 si CT_Rst */ var $3ee4f50b1ae43a89$var$sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, $3ee4f50b1ae43a89$var$sirregex = /<(?:\w+:)?r>/;
var $3ee4f50b1ae43a89$var$sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function $3ee4f50b1ae43a89$var$parse_si(x, opts) {
    var html = opts ? opts.cellHTML : true;
    var z = {};
    if (!x) return {
        t: ""
    };
    //var y;
    /* 18.4.12 t ST_Xstring (Plaintext String) */ // TODO: is whitespace actually valid here?
    if (x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
        z.t = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(x.slice(x.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || ""));
        z.r = $3ee4f50b1ae43a89$var$utf8read(x);
        if (html) z.h = $3ee4f50b1ae43a89$var$escapehtml(z.t);
    } else if (/*y = */ x.match($3ee4f50b1ae43a89$var$sirregex)) {
        z.r = $3ee4f50b1ae43a89$var$utf8read(x);
        z.t = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read((x.replace($3ee4f50b1ae43a89$var$sirphregex, "").match($3ee4f50b1ae43a89$var$sitregex) || []).join("").replace($3ee4f50b1ae43a89$var$tagregex, "")));
        if (html) z.h = $3ee4f50b1ae43a89$var$rs_to_html($3ee4f50b1ae43a89$var$parse_rs(z.r));
    }
    /* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */ /* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */ return z;
}
/* 18.4 Shared String Table */ var $3ee4f50b1ae43a89$var$sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
var $3ee4f50b1ae43a89$var$sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var $3ee4f50b1ae43a89$var$sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function $3ee4f50b1ae43a89$var$parse_sst_xml(data /*:string*/ , opts) /*:SST*/ {
    var s /*:SST*/  = [], ss = "";
    if (!data) return s;
    /* 18.4.9 sst CT_Sst */ var sst = data.match($3ee4f50b1ae43a89$var$sstr0);
    if (sst) {
        ss = sst[2].replace($3ee4f50b1ae43a89$var$sstr1, "").split($3ee4f50b1ae43a89$var$sstr2);
        for(var i = 0; i != ss.length; ++i){
            var o = $3ee4f50b1ae43a89$var$parse_si(ss[i].trim(), opts);
            if (o != null) s[s.length] = o;
        }
        sst = $3ee4f50b1ae43a89$var$parsexmltag(sst[1]);
        s.Count = sst.count;
        s.Unique = sst.uniqueCount;
    }
    return s;
}
var $3ee4f50b1ae43a89$var$straywsregex = /^\s|\s$|[\t\n\r]/;
function $3ee4f50b1ae43a89$var$write_sst_xml(sst /*:SST*/ , opts) /*:string*/ {
    if (!opts.bookSST) return "";
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("sst", null, {
        xmlns: $3ee4f50b1ae43a89$var$XMLNS_main[0],
        count: sst.Count,
        uniqueCount: sst.Unique
    });
    for(var i = 0; i != sst.length; ++i){
        if (sst[i] == null) continue;
        var s /*:XLString*/  = sst[i];
        var sitag = "<si>";
        if (s.r) sitag += s.r;
        else {
            sitag += "<t";
            if (!s.t) s.t = "";
            if (s.t.match($3ee4f50b1ae43a89$var$straywsregex)) sitag += ' xml:space="preserve"';
            sitag += ">" + $3ee4f50b1ae43a89$var$escapexml(s.t) + "</t>";
        }
        sitag += "</si>";
        o[o.length] = sitag;
    }
    if (o.length > 2) {
        o[o.length] = "</sst>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */ function $3ee4f50b1ae43a89$var$parse_BrtBeginSst(data) {
    return [
        data.read_shift(4),
        data.read_shift(4)
    ];
}
/* [MS-XLSB] 2.1.7.45 Shared Strings */ function $3ee4f50b1ae43a89$var$parse_sst_bin(data, opts) /*:SST*/ {
    var s /*:SST*/  = [];
    var pass = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function hopper_sst(val, R, RT) {
        switch(RT){
            case 0x009F:
                /* BrtBeginSst */ s.Count = val[0];
                s.Unique = val[1];
                break;
            case 0x0013:
                /* BrtSSTItem */ s.push(val);
                break;
            case 0x00A0:
                /* BrtEndSst */ return true;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            default:
                R.T;
                if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return s;
}
function $3ee4f50b1ae43a89$var$write_BrtBeginSst(sst, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(4, sst.Count);
    o.write_shift(4, sst.Unique);
    return o;
}
var $3ee4f50b1ae43a89$var$write_BrtSSTItem = $3ee4f50b1ae43a89$var$write_RichStr;
function $3ee4f50b1ae43a89$var$write_sst_bin(sst /*::, opts*/ ) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    $3ee4f50b1ae43a89$var$write_record(ba, 0x009F /* BrtBeginSst */ , $3ee4f50b1ae43a89$var$write_BrtBeginSst(sst));
    for(var i = 0; i < sst.length; ++i)$3ee4f50b1ae43a89$var$write_record(ba, 0x0013 /* BrtSSTItem */ , $3ee4f50b1ae43a89$var$write_BrtSSTItem(sst[i]));
    /* FRTSST */ $3ee4f50b1ae43a89$var$write_record(ba, 0x00A0 /* BrtEndSst */ );
    return ba.end();
}
function $3ee4f50b1ae43a89$var$_JS2ANSI(str /*:string*/ ) /*:Array<number>*/ {
    if (typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined") return $3ee4f50b1ae43a89$var$$cptable.utils.encode($3ee4f50b1ae43a89$var$current_ansi, str);
    var o /*:Array<number>*/  = [], oo = str.split("");
    for(var i = 0; i < oo.length; ++i)o[i] = oo[i].charCodeAt(0);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.4 Version */ function $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, length /*:?number*/ ) {
    var o /*:any*/  = {};
    o.Major = blob.read_shift(2);
    o.Minor = blob.read_shift(2);
    /*:: if(length == null) return o; */ if (length >= 4) blob.l += length - 4;
    return o;
}
/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */ function $3ee4f50b1ae43a89$var$parse_DataSpaceVersionInfo(blob) {
    var o = {};
    o.id = blob.read_shift(0, "lpp4");
    o.R = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    o.U = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    o.W = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */ function $3ee4f50b1ae43a89$var$parse_DataSpaceMapEntry(blob) {
    var len = blob.read_shift(4);
    var end = blob.l + len - 4;
    var o = {};
    var cnt = blob.read_shift(4);
    var comps /*:Array<{t:number, v:string}>*/  = [];
    /* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */ while(cnt-- > 0)comps.push({
        t: blob.read_shift(4),
        v: blob.read_shift(0, "lpp4")
    });
    o.name = blob.read_shift(0, "lpp4");
    o.comps = comps;
    if (blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */ function $3ee4f50b1ae43a89$var$parse_DataSpaceMap(blob) {
    var o = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push($3ee4f50b1ae43a89$var$parse_DataSpaceMapEntry(blob));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */ function $3ee4f50b1ae43a89$var$parse_DataSpaceDefinition(blob) /*:Array<string>*/ {
    var o /*:Array<string>*/  = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push(blob.read_shift(0, "lpp4"));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */ function $3ee4f50b1ae43a89$var$parse_TransformInfoHeader(blob) {
    var o = {};
    /*var len = */ blob.read_shift(4);
    blob.l += 4; // must be 0x1
    o.id = blob.read_shift(0, "lpp4");
    o.name = blob.read_shift(0, "lpp4");
    o.R = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    o.U = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    o.W = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_Primary(blob) {
    /* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */ var hdr = $3ee4f50b1ae43a89$var$parse_TransformInfoHeader(blob);
    /* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */ hdr.ename = blob.read_shift(0, "8lpp4");
    hdr.blksz = blob.read_shift(4);
    hdr.cmode = blob.read_shift(4);
    if (blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
    return hdr;
}
/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */ function $3ee4f50b1ae43a89$var$parse_EncryptionHeader(blob, length /*:number*/ ) {
    var tgt = blob.l + length;
    var o = {};
    o.Flags = blob.read_shift(4) & 0x3F;
    blob.l += 4;
    o.AlgID = blob.read_shift(4);
    var valid = false;
    switch(o.AlgID){
        case 0x660E:
        case 0x660F:
        case 0x6610:
            valid = o.Flags == 0x24;
            break;
        case 0x6801:
            valid = o.Flags == 0x04;
            break;
        case 0:
            valid = o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24;
            break;
        default:
            throw "Unrecognized encryption algorithm: " + o.AlgID;
    }
    if (!valid) throw new Error("Encryption Flags/AlgID mismatch");
    o.AlgIDHash = blob.read_shift(4);
    o.KeySize = blob.read_shift(4);
    o.ProviderType = blob.read_shift(4);
    blob.l += 8;
    o.CSPName = blob.read_shift(tgt - blob.l >> 1, "utf16le");
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */ function $3ee4f50b1ae43a89$var$parse_EncryptionVerifier(blob, length /*:number*/ ) {
    var o = {}, tgt = blob.l + length;
    blob.l += 4; // SaltSize must be 0x10
    o.Salt = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    o.Verifier = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    /*var sz = */ blob.read_shift(4);
    o.VerifierHash = blob.slice(blob.l, tgt);
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */ function $3ee4f50b1ae43a89$var$parse_EncryptionInfo(blob) {
    var vers = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob);
    switch(vers.Minor){
        case 0x02:
            return [
                vers.Minor,
                $3ee4f50b1ae43a89$var$parse_EncInfoStd(blob, vers)
            ];
        case 0x03:
            return [
                vers.Minor,
                $3ee4f50b1ae43a89$var$parse_EncInfoExt(blob, vers)
            ];
        case 0x04:
            return [
                vers.Minor,
                $3ee4f50b1ae43a89$var$parse_EncInfoAgl(blob, vers)
            ];
    }
    throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}
/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */ function $3ee4f50b1ae43a89$var$parse_EncInfoStd(blob /*::, vers*/ ) {
    var flags = blob.read_shift(4);
    if ((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
    var sz = blob.read_shift(4);
    //var tgt = blob.l + sz;
    var hdr = $3ee4f50b1ae43a89$var$parse_EncryptionHeader(blob, sz);
    var verifier = $3ee4f50b1ae43a89$var$parse_EncryptionVerifier(blob, blob.length - blob.l);
    return {
        t: "Std",
        h: hdr,
        v: verifier
    };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */ function $3ee4f50b1ae43a89$var$parse_EncInfoExt() {
    throw new Error("File is password-protected: ECMA-376 Extensible");
}
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */ function $3ee4f50b1ae43a89$var$parse_EncInfoAgl(blob /*::, vers*/ ) {
    var KeyData = [
        "saltSize",
        "blockSize",
        "keyBits",
        "hashSize",
        "cipherAlgorithm",
        "cipherChaining",
        "hashAlgorithm",
        "saltValue"
    ];
    blob.l += 4;
    var xml = blob.read_shift(blob.length - blob.l, "utf8");
    var o = {};
    xml.replace($3ee4f50b1ae43a89$var$tagregex, function xml_agile(x) {
        var y /*:any*/  = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<encryption":
            case "</encryption>":
                break;
            case "<keyData":
                KeyData.forEach(function(k) {
                    o[k] = y[k];
                });
                break;
            case "<dataIntegrity":
                o.encryptedHmacKey = y.encryptedHmacKey;
                o.encryptedHmacValue = y.encryptedHmacValue;
                break;
            case "<keyEncryptors>":
            case "<keyEncryptors":
                o.encs = [];
                break;
            case "</keyEncryptors>":
                break;
            case "<keyEncryptor":
                o.uri = y.uri;
                break;
            case "</keyEncryptor>":
                break;
            case "<encryptedKey":
                o.encs.push(y);
                break;
            default:
                throw y[0];
        }
    });
    return o;
}
/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */ function $3ee4f50b1ae43a89$var$parse_RC4CryptoHeader(blob, length /*:number*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    length -= 4;
    if (vers.Minor != 2) throw new Error("unrecognized minor version code: " + vers.Minor);
    if (vers.Major > 4 || vers.Major < 2) throw new Error("unrecognized major version code: " + vers.Major);
    o.Flags = blob.read_shift(4);
    length -= 4;
    var sz = blob.read_shift(4);
    length -= 4;
    o.EncryptionHeader = $3ee4f50b1ae43a89$var$parse_EncryptionHeader(blob, sz);
    length -= sz;
    o.EncryptionVerifier = $3ee4f50b1ae43a89$var$parse_EncryptionVerifier(blob, length);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */ function $3ee4f50b1ae43a89$var$parse_RC4Header(blob /*::, length*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    if (vers.Major != 1 || vers.Minor != 1) throw "unrecognized version code " + vers.Major + " : " + vers.Minor;
    o.Salt = blob.read_shift(16);
    o.EncryptedVerifier = blob.read_shift(16);
    o.EncryptedVerifierHash = blob.read_shift(16);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */ function $3ee4f50b1ae43a89$var$crypto_CreatePasswordVerifier_Method1(Password /*:string*/ ) {
    var Verifier = 0x0000, PasswordArray;
    var PasswordDecoded = $3ee4f50b1ae43a89$var$_JS2ANSI(Password);
    var len = PasswordDecoded.length + 1, i, PasswordByte;
    var Intermediate1, Intermediate2, Intermediate3;
    PasswordArray = $3ee4f50b1ae43a89$var$new_raw_buf(len);
    PasswordArray[0] = PasswordDecoded.length;
    for(i = 1; i != len; ++i)PasswordArray[i] = PasswordDecoded[i - 1];
    for(i = len - 1; i >= 0; --i){
        PasswordByte = PasswordArray[i];
        Intermediate1 = (Verifier & 0x4000) === 0x0000 ? 0 : 1;
        Intermediate2 = Verifier << 1 & 0x7FFF;
        Intermediate3 = Intermediate1 | Intermediate2;
        Verifier = Intermediate3 ^ PasswordByte;
    }
    return Verifier ^ 0xCE4B;
}
/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */ var $3ee4f50b1ae43a89$var$crypto_CreateXorArray_Method1 = /*#__PURE__*/ function() {
    var PadArray = [
        0xBB,
        0xFF,
        0xFF,
        0xBA,
        0xFF,
        0xFF,
        0xB9,
        0x80,
        0x00,
        0xBE,
        0x0F,
        0x00,
        0xBF,
        0x0F,
        0x00
    ];
    var InitialCode = [
        0xE1F0,
        0x1D0F,
        0xCC9C,
        0x84C0,
        0x110C,
        0x0E10,
        0xF1CE,
        0x313E,
        0x1872,
        0xE139,
        0xD40F,
        0x84F9,
        0x280C,
        0xA96A,
        0x4EC3
    ];
    var XorMatrix = [
        0xAEFC,
        0x4DD9,
        0x9BB2,
        0x2745,
        0x4E8A,
        0x9D14,
        0x2A09,
        0x7B61,
        0xF6C2,
        0xFDA5,
        0xEB6B,
        0xC6F7,
        0x9DCF,
        0x2BBF,
        0x4563,
        0x8AC6,
        0x05AD,
        0x0B5A,
        0x16B4,
        0x2D68,
        0x5AD0,
        0x0375,
        0x06EA,
        0x0DD4,
        0x1BA8,
        0x3750,
        0x6EA0,
        0xDD40,
        0xD849,
        0xA0B3,
        0x5147,
        0xA28E,
        0x553D,
        0xAA7A,
        0x44D5,
        0x6F45,
        0xDE8A,
        0xAD35,
        0x4A4B,
        0x9496,
        0x390D,
        0x721A,
        0xEB23,
        0xC667,
        0x9CEF,
        0x29FF,
        0x53FE,
        0xA7FC,
        0x5FD9,
        0x47D3,
        0x8FA6,
        0x0F6D,
        0x1EDA,
        0x3DB4,
        0x7B68,
        0xF6D0,
        0xB861,
        0x60E3,
        0xC1C6,
        0x93AD,
        0x377B,
        0x6EF6,
        0xDDEC,
        0x45A0,
        0x8B40,
        0x06A1,
        0x0D42,
        0x1A84,
        0x3508,
        0x6A10,
        0xAA51,
        0x4483,
        0x8906,
        0x022D,
        0x045A,
        0x08B4,
        0x1168,
        0x76B4,
        0xED68,
        0xCAF1,
        0x85C3,
        0x1BA7,
        0x374E,
        0x6E9C,
        0x3730,
        0x6E60,
        0xDCC0,
        0xA9A1,
        0x4363,
        0x86C6,
        0x1DAD,
        0x3331,
        0x6662,
        0xCCC4,
        0x89A9,
        0x0373,
        0x06E6,
        0x0DCC,
        0x1021,
        0x2042,
        0x4084,
        0x8108,
        0x1231,
        0x2462,
        0x48C4
    ];
    var Ror = function(Byte) {
        return (Byte / 2 | Byte * 128) & 0xFF;
    };
    var XorRor = function(byte1, byte2) {
        return Ror(byte1 ^ byte2);
    };
    var CreateXorKey_Method1 = function(Password) {
        var XorKey = InitialCode[Password.length - 1];
        var CurrentElement = 0x68;
        for(var i = Password.length - 1; i >= 0; --i){
            var Char = Password[i];
            for(var j = 0; j != 7; ++j){
                if (Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
                Char *= 2;
                --CurrentElement;
            }
        }
        return XorKey;
    };
    return function(password /*:string*/ ) {
        var Password = $3ee4f50b1ae43a89$var$_JS2ANSI(password);
        var XorKey = CreateXorKey_Method1(Password);
        var Index = Password.length;
        var ObfuscationArray = $3ee4f50b1ae43a89$var$new_raw_buf(16);
        for(var i = 0; i != 16; ++i)ObfuscationArray[i] = 0x00;
        var Temp, PasswordLastChar, PadIndex;
        if ((Index & 1) === 1) {
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            PasswordLastChar = Password[Password.length - 1];
            ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
        }
        while(Index > 0){
            --Index;
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
        }
        Index = 15;
        PadIndex = 15 - Password.length;
        while(PadIndex > 0){
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
            --Index;
            --PadIndex;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            --PadIndex;
        }
        return ObfuscationArray;
    };
}();
/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */ var $3ee4f50b1ae43a89$var$crypto_DecryptData_Method1 = function(password /*:string*/ , Data, XorArrayIndex, XorArray, O) {
    /* If XorArray is set, use it; if O is not set, make changes in-place */ if (!O) O = Data;
    if (!XorArray) XorArray = $3ee4f50b1ae43a89$var$crypto_CreateXorArray_Method1(password);
    var Index, Value;
    for(Index = 0; Index != Data.length; ++Index){
        Value = Data[Index];
        Value ^= XorArray[XorArrayIndex];
        Value = (Value >> 5 | Value << 3) & 0xFF;
        O[Index] = Value;
        ++XorArrayIndex;
    }
    return [
        O,
        XorArrayIndex,
        XorArray
    ];
};
var $3ee4f50b1ae43a89$var$crypto_MakeXorDecryptor = function(password /*:string*/ ) {
    var XorArrayIndex = 0, XorArray = $3ee4f50b1ae43a89$var$crypto_CreateXorArray_Method1(password);
    return function(Data) {
        var O = $3ee4f50b1ae43a89$var$crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
        XorArrayIndex = O[1];
        return O[0];
    };
};
/* 2.5.343 */ function $3ee4f50b1ae43a89$var$parse_XORObfuscation(blob, length, opts, out) {
    var o = {
        key: $3ee4f50b1ae43a89$var$parseuint16(blob),
        verificationBytes: $3ee4f50b1ae43a89$var$parseuint16(blob)
    } /*:any*/ ;
    if (opts.password) o.verifier = $3ee4f50b1ae43a89$var$crypto_CreatePasswordVerifier_Method1(opts.password);
    out.valid = o.verificationBytes === o.verifier;
    if (out.valid) out.insitu = $3ee4f50b1ae43a89$var$crypto_MakeXorDecryptor(opts.password);
    return o;
}
/* 2.4.117 */ function $3ee4f50b1ae43a89$var$parse_FilePassHeader(blob, length /*:number*/ , oo) {
    var o = oo || {};
    o.Info = blob.read_shift(2);
    blob.l -= 2;
    if (o.Info === 1) o.Data = $3ee4f50b1ae43a89$var$parse_RC4Header(blob, length);
    else o.Data = $3ee4f50b1ae43a89$var$parse_RC4CryptoHeader(blob, length);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_FilePass(blob, length /*:number*/ , opts) {
    var o = {
        Type: opts.biff >= 8 ? blob.read_shift(2) : 0
    } /*:any*/ ; /* wEncryptionType */ 
    if (o.Type) $3ee4f50b1ae43a89$var$parse_FilePassHeader(blob, length - 2, o);
    else $3ee4f50b1ae43a89$var$parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
    return o;
}
var $3ee4f50b1ae43a89$var$RTF = /*#__PURE__*/ function() {
    function rtf_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        switch(opts.type){
            case "base64":
                return rtf_to_sheet_str($3ee4f50b1ae43a89$var$Base64_decode(d), opts);
            case "binary":
                return rtf_to_sheet_str(d, opts);
            case "buffer":
                return rtf_to_sheet_str($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(d) ? d.toString("binary") : $3ee4f50b1ae43a89$var$a2s(d), opts);
            case "array":
                return rtf_to_sheet_str($3ee4f50b1ae43a89$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    /* TODO: this is a stub */ function rtf_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var ws /*:Worksheet*/  = o.dense ? [] : {} /*:any*/ ;
        var rows = str.match(/\\trowd.*?\\row\b/g);
        if (!rows.length) throw new Error("RTF missing table");
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: rows.length - 1
            }
        } /*:any*/ ;
        rows.forEach(function(rowtf, R) {
            if (Array.isArray(ws)) ws[R] = [];
            var rtfre = /\\\w+\b/g;
            var last_index = 0;
            var res;
            var C = -1;
            while(res = rtfre.exec(rowtf)){
                switch(res[0]){
                    case "\\cell":
                        var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
                        if (data[0] == " ") data = data.slice(1);
                        ++C;
                        if (data.length) {
                            // TODO: value parsing, including codepage adjustments
                            var cell = {
                                v: data,
                                t: "s"
                            };
                            if (Array.isArray(ws)) ws[R][C] = cell;
                            else ws[$3ee4f50b1ae43a89$var$encode_cell({
                                r: R,
                                c: C
                            })] = cell;
                        }
                        break;
                }
                last_index = rtfre.lastIndex;
            }
            if (C > range.e.c) range.e.c = C;
        });
        ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
        return ws;
    }
    function rtf_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $3ee4f50b1ae43a89$var$sheet_to_workbook(rtf_to_sheet(d, opts), opts);
    }
    /* TODO: this is a stub */ function sheet_to_rtf(ws /*:Worksheet*/  /*::, opts*/ ) /*:string*/ {
        var o = [
            "{\\rtf1\\ansi"
        ];
        var r = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]), cell /*:Cell*/ ;
        var dense = Array.isArray(ws);
        for(var R = r.s.r; R <= r.e.r; ++R){
            o.push("\\trowd\\trautofit1");
            for(var C = r.s.c; C <= r.e.c; ++C)o.push("\\cellx" + (C + 1));
            o.push("\\pard\\intbl");
            for(C = r.s.c; C <= r.e.c; ++C){
                var coord = $3ee4f50b1ae43a89$var$encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws[R] || [])[C] : ws[coord];
                if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
                o.push(" " + (cell.w || ($3ee4f50b1ae43a89$var$format_cell(cell), cell.w)));
                o.push("\\cell");
            }
            o.push("\\pard\\intbl\\row");
        }
        return o.join("") + "}";
    }
    return {
        to_workbook: rtf_to_workbook,
        to_sheet: rtf_to_sheet,
        from_sheet: sheet_to_rtf
    };
}();
function $3ee4f50b1ae43a89$var$hex2RGB(h) {
    var o = h.slice(h[0] === "#" ? 1 : 0).slice(0, 6);
    return [
        parseInt(o.slice(0, 2), 16),
        parseInt(o.slice(2, 4), 16),
        parseInt(o.slice(4, 6), 16)
    ];
}
function $3ee4f50b1ae43a89$var$rgb2Hex(rgb) {
    for(var i = 0, o = 1; i != 3; ++i)o = o * 256 + (rgb[i] > 255 ? 255 : rgb[i] < 0 ? 0 : rgb[i]);
    return o.toString(16).toUpperCase().slice(1);
}
function $3ee4f50b1ae43a89$var$rgb2HSL(rgb) {
    var R = rgb[0] / 255, G = rgb[1] / 255, B = rgb[2] / 255;
    var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
    if (C === 0) return [
        0,
        0,
        R
    ];
    var H6 = 0, S = 0, L2 = M + m;
    S = C / (L2 > 1 ? 2 - L2 : L2);
    switch(M){
        case R:
            H6 = ((G - B) / C + 6) % 6;
            break;
        case G:
            H6 = (B - R) / C + 2;
            break;
        case B:
            H6 = (R - G) / C + 4;
            break;
    }
    return [
        H6 / 6,
        S,
        L2 / 2
    ];
}
function $3ee4f50b1ae43a89$var$hsl2RGB(hsl) {
    var H = hsl[0], S = hsl[1], L = hsl[2];
    var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C / 2;
    var rgb = [
        m,
        m,
        m
    ], h6 = 6 * H;
    var X;
    if (S !== 0) switch(h6 | 0){
        case 0:
        case 6:
            X = C * h6;
            rgb[0] += C;
            rgb[1] += X;
            break;
        case 1:
            X = C * (2 - h6);
            rgb[0] += X;
            rgb[1] += C;
            break;
        case 2:
            X = C * (h6 - 2);
            rgb[1] += C;
            rgb[2] += X;
            break;
        case 3:
            X = C * (4 - h6);
            rgb[1] += X;
            rgb[2] += C;
            break;
        case 4:
            X = C * (h6 - 4);
            rgb[2] += C;
            rgb[0] += X;
            break;
        case 5:
            X = C * (6 - h6);
            rgb[2] += X;
            rgb[0] += C;
            break;
    }
    for(var i = 0; i != 3; ++i)rgb[i] = Math.round(rgb[i] * 255);
    return rgb;
}
/* 18.8.3 bgColor tint algorithm */ function $3ee4f50b1ae43a89$var$rgb_tint(hex, tint) {
    if (tint === 0) return hex;
    var hsl = $3ee4f50b1ae43a89$var$rgb2HSL($3ee4f50b1ae43a89$var$hex2RGB(hex));
    if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
    else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
    return $3ee4f50b1ae43a89$var$rgb2Hex($3ee4f50b1ae43a89$var$hsl2RGB(hsl));
}
/* 18.3.1.13 width calculations */ /* [MS-OI29500] 2.1.595 Column Width & Formatting */ var $3ee4f50b1ae43a89$var$DEF_MDW = 6, $3ee4f50b1ae43a89$var$MAX_MDW = 15, $3ee4f50b1ae43a89$var$MIN_MDW = 1, $3ee4f50b1ae43a89$var$MDW = $3ee4f50b1ae43a89$var$DEF_MDW;
function $3ee4f50b1ae43a89$var$width2px(width) {
    return Math.floor((width + Math.round(128 / $3ee4f50b1ae43a89$var$MDW) / 256) * $3ee4f50b1ae43a89$var$MDW);
}
function $3ee4f50b1ae43a89$var$px2char(px) {
    return Math.floor((px - 5) / $3ee4f50b1ae43a89$var$MDW * 100 + 0.5) / 100;
}
function $3ee4f50b1ae43a89$var$char2width(chr) {
    return Math.round((chr * $3ee4f50b1ae43a89$var$MDW + 5) / $3ee4f50b1ae43a89$var$MDW * 256) / 256;
}
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function $3ee4f50b1ae43a89$var$cycle_width(collw) {
    return $3ee4f50b1ae43a89$var$char2width($3ee4f50b1ae43a89$var$px2char($3ee4f50b1ae43a89$var$width2px(collw)));
}
/* XLSX/XLSB/XLS specify width in units of MDW */ function $3ee4f50b1ae43a89$var$find_mdw_colw(collw) {
    var delta = Math.abs(collw - $3ee4f50b1ae43a89$var$cycle_width(collw)), _MDW = $3ee4f50b1ae43a89$var$MDW;
    if (delta > 0.005) {
        for($3ee4f50b1ae43a89$var$MDW = $3ee4f50b1ae43a89$var$MIN_MDW; $3ee4f50b1ae43a89$var$MDW < $3ee4f50b1ae43a89$var$MAX_MDW; ++$3ee4f50b1ae43a89$var$MDW)if (Math.abs(collw - $3ee4f50b1ae43a89$var$cycle_width(collw)) <= delta) {
            delta = Math.abs(collw - $3ee4f50b1ae43a89$var$cycle_width(collw));
            _MDW = $3ee4f50b1ae43a89$var$MDW;
        }
    }
    $3ee4f50b1ae43a89$var$MDW = _MDW;
}
/* XLML specifies width in terms of pixels */ /*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/ function $3ee4f50b1ae43a89$var$process_col(coll /*:ColInfo*/ ) {
    if (coll.width) {
        coll.wpx = $3ee4f50b1ae43a89$var$width2px(coll.width);
        coll.wch = $3ee4f50b1ae43a89$var$px2char(coll.wpx);
        coll.MDW = $3ee4f50b1ae43a89$var$MDW;
    } else if (coll.wpx) {
        coll.wch = $3ee4f50b1ae43a89$var$px2char(coll.wpx);
        coll.width = $3ee4f50b1ae43a89$var$char2width(coll.wch);
        coll.MDW = $3ee4f50b1ae43a89$var$MDW;
    } else if (typeof coll.wch == "number") {
        coll.width = $3ee4f50b1ae43a89$var$char2width(coll.wch);
        coll.wpx = $3ee4f50b1ae43a89$var$width2px(coll.width);
        coll.MDW = $3ee4f50b1ae43a89$var$MDW;
    }
    if (coll.customWidth) delete coll.customWidth;
}
var $3ee4f50b1ae43a89$var$DEF_PPI = 96, $3ee4f50b1ae43a89$var$PPI = $3ee4f50b1ae43a89$var$DEF_PPI;
function $3ee4f50b1ae43a89$var$px2pt(px) {
    return px * 96 / $3ee4f50b1ae43a89$var$PPI;
}
function $3ee4f50b1ae43a89$var$pt2px(pt) {
    return pt * $3ee4f50b1ae43a89$var$PPI / 96;
}
/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */ var $3ee4f50b1ae43a89$var$XLMLPatternTypeMap = {
    "None": "none",
    "Solid": "solid",
    "Gray50": "mediumGray",
    "Gray75": "darkGray",
    "Gray25": "lightGray",
    "HorzStripe": "darkHorizontal",
    "VertStripe": "darkVertical",
    "ReverseDiagStripe": "darkDown",
    "DiagStripe": "darkUp",
    "DiagCross": "darkGrid",
    "ThickDiagCross": "darkTrellis",
    "ThinHorzStripe": "lightHorizontal",
    "ThinVertStripe": "lightVertical",
    "ThinReverseDiagStripe": "lightDown",
    "ThinHorzCross": "lightGrid"
};
/* 18.8.5 borders CT_Borders */ function $3ee4f50b1ae43a89$var$parse_borders(t, styles, themes, opts) {
    styles.Borders = [];
    var border = {};
    var pass = false;
    (t[0].match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<borders":
            case "<borders>":
            case "</borders>":
                break;
            /* 18.8.4 border CT_Border */ case "<border":
            case "<border>":
            case "<border/>":
                border = /*::(*/ {} /*:: :any)*/ ;
                if (y.diagonalUp) border.diagonalUp = $3ee4f50b1ae43a89$var$parsexmlbool(y.diagonalUp);
                if (y.diagonalDown) border.diagonalDown = $3ee4f50b1ae43a89$var$parsexmlbool(y.diagonalDown);
                styles.Borders.push(border);
                break;
            case "</border>":
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case "<left/>":
                break;
            case "<left":
            case "<left>":
                break;
            case "</left>":
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case "<right/>":
                break;
            case "<right":
            case "<right>":
                break;
            case "</right>":
                break;
            /* 18.8.43 top CT_BorderPr */ case "<top/>":
                break;
            case "<top":
            case "<top>":
                break;
            case "</top>":
                break;
            /* 18.8.6 bottom CT_BorderPr */ case "<bottom/>":
                break;
            case "<bottom":
            case "<bottom>":
                break;
            case "</bottom>":
                break;
            /* 18.8.13 diagonal CT_BorderPr */ case "<diagonal":
            case "<diagonal>":
            case "<diagonal/>":
                break;
            case "</diagonal>":
                break;
            /* 18.8.25 horizontal CT_BorderPr */ case "<horizontal":
            case "<horizontal>":
            case "<horizontal/>":
                break;
            case "</horizontal>":
                break;
            /* 18.8.44 vertical CT_BorderPr */ case "<vertical":
            case "<vertical>":
            case "<vertical/>":
                break;
            case "</vertical>":
                break;
            /* 18.8.37 start CT_BorderPr */ case "<start":
            case "<start>":
            case "<start/>":
                break;
            case "</start>":
                break;
            /* 18.8.16 end CT_BorderPr */ case "<end":
            case "<end>":
            case "<end/>":
                break;
            case "</end>":
                break;
            /* 18.8.? color CT_Color */ case "<color":
            case "<color>":
                break;
            case "<color/>":
            case "</color>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in borders");
                }
        }
    });
}
/* 18.8.21 fills CT_Fills */ function $3ee4f50b1ae43a89$var$parse_fills(t, styles, themes, opts) {
    styles.Fills = [];
    var fill = {};
    var pass = false;
    (t[0].match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<fills":
            case "<fills>":
            case "</fills>":
                break;
            /* 18.8.20 fill CT_Fill */ case "<fill>":
            case "<fill":
            case "<fill/>":
                fill = {};
                styles.Fills.push(fill);
                break;
            case "</fill>":
                break;
            /* 18.8.24 gradientFill CT_GradientFill */ case "<gradientFill>":
                break;
            case "<gradientFill":
            case "</gradientFill>":
                styles.Fills.push(fill);
                fill = {};
                break;
            /* 18.8.32 patternFill CT_PatternFill */ case "<patternFill":
            case "<patternFill>":
                if (y.patternType) fill.patternType = y.patternType;
                break;
            case "<patternFill/>":
            case "</patternFill>":
                break;
            /* 18.8.3 bgColor CT_Color */ case "<bgColor":
                if (!fill.bgColor) fill.bgColor = {};
                if (y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
                if (y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.bgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
                break;
            case "<bgColor/>":
            case "</bgColor>":
                break;
            /* 18.8.19 fgColor CT_Color */ case "<fgColor":
                if (!fill.fgColor) fill.fgColor = {};
                if (y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.fgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
                break;
            case "<fgColor/>":
            case "</fgColor>":
                break;
            /* 18.8.38 stop CT_GradientStop */ case "<stop":
            case "<stop/>":
                break;
            case "</stop>":
                break;
            /* 18.8.? color CT_Color */ case "<color":
            case "<color/>":
                break;
            case "</color>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in fills");
                }
        }
    });
}
/* 18.8.23 fonts CT_Fonts */ function $3ee4f50b1ae43a89$var$parse_fonts(t, styles, themes, opts) {
    styles.Fonts = [];
    var font = {};
    var pass = false;
    (t[0].match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<fonts":
            case "<fonts>":
            case "</fonts>":
                break;
            /* 18.8.22 font CT_Font */ case "<font":
            case "<font>":
                break;
            case "</font>":
            case "<font/>":
                styles.Fonts.push(font);
                font = {};
                break;
            /* 18.8.29 name CT_FontName */ case "<name":
                if (y.val) font.name = $3ee4f50b1ae43a89$var$utf8read(y.val);
                break;
            case "<name/>":
            case "</name>":
                break;
            /* 18.8.2  b CT_BooleanProperty */ case "<b":
                font.bold = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case "<b/>":
                font.bold = 1;
                break;
            /* 18.8.26 i CT_BooleanProperty */ case "<i":
                font.italic = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case "<i/>":
                font.italic = 1;
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case "<u":
                switch(y.val){
                    case "none":
                        font.underline = 0x00;
                        break;
                    case "single":
                        font.underline = 0x01;
                        break;
                    case "double":
                        font.underline = 0x02;
                        break;
                    case "singleAccounting":
                        font.underline = 0x21;
                        break;
                    case "doubleAccounting":
                        font.underline = 0x22;
                        break;
                }
                break;
            case "<u/>":
                font.underline = 1;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case "<strike":
                font.strike = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case "<strike/>":
                font.strike = 1;
                break;
            /* 18.4.2  outline CT_BooleanProperty */ case "<outline":
                font.outline = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case "<outline/>":
                font.outline = 1;
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ case "<shadow":
                font.shadow = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case "<shadow/>":
                font.shadow = 1;
                break;
            /* 18.8.12 condense CT_BooleanProperty */ case "<condense":
                font.condense = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case "<condense/>":
                font.condense = 1;
                break;
            /* 18.8.17 extend CT_BooleanProperty */ case "<extend":
                font.extend = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case "<extend/>":
                font.extend = 1;
                break;
            /* 18.4.11 sz CT_FontSize */ case "<sz":
                if (y.val) font.sz = +y.val;
                break;
            case "<sz/>":
            case "</sz>":
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty */ case "<vertAlign":
                if (y.val) font.vertAlign = y.val;
                break;
            case "<vertAlign/>":
            case "</vertAlign>":
                break;
            /* 18.8.18 family CT_FontFamily */ case "<family":
                if (y.val) font.family = parseInt(y.val, 10);
                break;
            case "<family/>":
            case "</family>":
                break;
            /* 18.8.35 scheme CT_FontScheme */ case "<scheme":
                if (y.val) font.scheme = y.val;
                break;
            case "<scheme/>":
            case "</scheme>":
                break;
            /* 18.4.1 charset CT_IntProperty */ case "<charset":
                if (y.val == "1") break;
                y.codepage = $3ee4f50b1ae43a89$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.?.? color CT_Color */ case "<color":
                if (!font.color) font.color = {};
                if (y.auto) font.color.auto = $3ee4f50b1ae43a89$var$parsexmlbool(y.auto);
                if (y.rgb) font.color.rgb = y.rgb.slice(-6);
                else if (y.indexed) {
                    font.color.index = parseInt(y.indexed, 10);
                    var icv = $3ee4f50b1ae43a89$var$XLSIcv[font.color.index];
                    if (font.color.index == 81) icv = $3ee4f50b1ae43a89$var$XLSIcv[1];
                    if (!icv) icv = $3ee4f50b1ae43a89$var$XLSIcv[1]; //throw new Error(x); // note: 206 is valid
                    font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
                } else if (y.theme) {
                    font.color.theme = parseInt(y.theme, 10);
                    if (y.tint) font.color.tint = parseFloat(y.tint);
                    if (y.theme && themes.themeElements && themes.themeElements.clrScheme) font.color.rgb = $3ee4f50b1ae43a89$var$rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
                }
                break;
            case "<color/>":
            case "</color>":
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case "<AlternateContent":
                pass = true;
                break;
            case "</AlternateContent>":
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in fonts");
                }
        }
    });
}
/* 18.8.31 numFmts CT_NumFmts */ function $3ee4f50b1ae43a89$var$parse_numFmts(t, styles, opts) {
    styles.NumberFmt = [];
    var k /*Array<number>*/  = $3ee4f50b1ae43a89$var$keys($3ee4f50b1ae43a89$var$table_fmt);
    for(var i = 0; i < k.length; ++i)styles.NumberFmt[k[i]] = $3ee4f50b1ae43a89$var$table_fmt[k[i]];
    var m = t[0].match($3ee4f50b1ae43a89$var$tagregex);
    if (!m) return;
    for(i = 0; i < m.length; ++i){
        var y = $3ee4f50b1ae43a89$var$parsexmltag(m[i]);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<numFmts":
            case "</numFmts>":
            case "<numFmts/>":
            case "<numFmts>":
                break;
            case "<numFmt":
                var f = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(y.formatCode)), j = parseInt(y.numFmtId, 10);
                styles.NumberFmt[j] = f;
                if (j > 0) {
                    if (j > 0x188) {
                        for(j = 0x188; j > 0x3c; --j)if (styles.NumberFmt[j] == null) break;
                        styles.NumberFmt[j] = f;
                    }
                    $3ee4f50b1ae43a89$var$SSF_load(f, j);
                }
                break;
            case "</numFmt>":
                break;
            default:
                if (opts.WTF) throw new Error("unrecognized " + y[0] + " in numFmts");
        }
    }
}
function $3ee4f50b1ae43a89$var$write_numFmts(NF /*:{[n:number|string]:string}*/  /*::, opts*/ ) {
    var o = [
        "<numFmts>"
    ];
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) o[o.length] = $3ee4f50b1ae43a89$var$writextag("numFmt", null, {
            numFmtId: i,
            formatCode: $3ee4f50b1ae43a89$var$escapexml(NF[i])
        });
    });
    if (o.length === 1) return "";
    o[o.length] = "</numFmts>";
    o[0] = $3ee4f50b1ae43a89$var$writextag("numFmts", null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8.10 cellXfs CT_CellXfs */ var $3ee4f50b1ae43a89$var$cellXF_uint = [
    "numFmtId",
    "fillId",
    "fontId",
    "borderId",
    "xfId"
];
var $3ee4f50b1ae43a89$var$cellXF_bool = [
    "applyAlignment",
    "applyBorder",
    "applyFill",
    "applyFont",
    "applyNumberFormat",
    "applyProtection",
    "pivotButton",
    "quotePrefix"
];
function $3ee4f50b1ae43a89$var$parse_cellXfs(t, styles, opts) {
    styles.CellXf = [];
    var xf;
    var pass = false;
    (t[0].match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x), i = 0;
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<cellXfs":
            case "<cellXfs>":
            case "<cellXfs/>":
            case "</cellXfs>":
                break;
            /* 18.8.45 xf CT_Xf */ case "<xf":
            case "<xf/>":
                xf = y;
                delete xf[0];
                for(i = 0; i < $3ee4f50b1ae43a89$var$cellXF_uint.length; ++i)if (xf[$3ee4f50b1ae43a89$var$cellXF_uint[i]]) xf[$3ee4f50b1ae43a89$var$cellXF_uint[i]] = parseInt(xf[$3ee4f50b1ae43a89$var$cellXF_uint[i]], 10);
                for(i = 0; i < $3ee4f50b1ae43a89$var$cellXF_bool.length; ++i)if (xf[$3ee4f50b1ae43a89$var$cellXF_bool[i]]) xf[$3ee4f50b1ae43a89$var$cellXF_bool[i]] = $3ee4f50b1ae43a89$var$parsexmlbool(xf[$3ee4f50b1ae43a89$var$cellXF_bool[i]]);
                if (styles.NumberFmt && xf.numFmtId > 0x188) {
                    for(i = 0x188; i > 0x3c; --i)if (styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) {
                        xf.numFmtId = i;
                        break;
                    }
                }
                styles.CellXf.push(xf);
                break;
            case "</xf>":
                break;
            /* 18.8.1 alignment CT_CellAlignment */ case "<alignment":
            case "<alignment/>":
                var alignment = {};
                if (y.vertical) alignment.vertical = y.vertical;
                if (y.horizontal) alignment.horizontal = y.horizontal;
                if (y.textRotation != null) alignment.textRotation = y.textRotation;
                if (y.indent) alignment.indent = y.indent;
                if (y.wrapText) alignment.wrapText = $3ee4f50b1ae43a89$var$parsexmlbool(y.wrapText);
                xf.alignment = alignment;
                break;
            case "</alignment>":
                break;
            /* 18.8.33 protection CT_CellProtection */ case "<protection":
                break;
            case "</protection>":
            case "<protection/>":
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case "<AlternateContent":
                pass = true;
                break;
            case "</AlternateContent>":
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in cellXfs");
                }
        }
    });
}
function $3ee4f50b1ae43a89$var$write_cellXfs(cellXfs) /*:string*/ {
    var o /*:Array<string>*/  = [];
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("cellXfs", null);
    cellXfs.forEach(function(c) {
        o[o.length] = $3ee4f50b1ae43a89$var$writextag("xf", null, c);
    });
    o[o.length] = "</cellXfs>";
    if (o.length === 2) return "";
    o[0] = $3ee4f50b1ae43a89$var$writextag("cellXfs", null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8 Styles CT_Stylesheet*/ var $3ee4f50b1ae43a89$var$parse_sty_xml = /*#__PURE__*/ function make_pstyx() {
    var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
    var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
    var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
    var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
    var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
    return function parse_sty_xml(data, themes, opts) {
        var styles = {};
        if (!data) return styles;
        data = data.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
        /* 18.8.39 styleSheet CT_Stylesheet */ var t;
        /* 18.8.31 numFmts CT_NumFmts ? */ if (t = data.match(numFmtRegex)) $3ee4f50b1ae43a89$var$parse_numFmts(t, styles, opts);
        /* 18.8.23 fonts CT_Fonts ? */ if (t = data.match(fontsRegex)) $3ee4f50b1ae43a89$var$parse_fonts(t, styles, themes, opts);
        /* 18.8.21 fills CT_Fills ? */ if (t = data.match(fillsRegex)) $3ee4f50b1ae43a89$var$parse_fills(t, styles, themes, opts);
        /* 18.8.5  borders CT_Borders ? */ if (t = data.match(bordersRegex)) $3ee4f50b1ae43a89$var$parse_borders(t, styles, themes, opts);
        /* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */ /* 18.8.8  cellStyles CT_CellStyles ? */ /* 18.8.10 cellXfs CT_CellXfs ? */ if (t = data.match(cellXfRegex)) $3ee4f50b1ae43a89$var$parse_cellXfs(t, styles, opts);
        /* 18.8.15 dxfs CT_Dxfs ? */ /* 18.8.42 tableStyles CT_TableStyles ? */ /* 18.8.11 colors CT_Colors ? */ /* 18.2.10 extLst CT_ExtensionList ? */ return styles;
    };
}();
function $3ee4f50b1ae43a89$var$write_sty_xml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("styleSheet", null, {
            "xmlns": $3ee4f50b1ae43a89$var$XMLNS_main[0],
            "xmlns:vt": $3ee4f50b1ae43a89$var$XMLNS.vt
        })
    ], w;
    if (wb.SSF && (w = $3ee4f50b1ae43a89$var$write_numFmts(wb.SSF)) != null) o[o.length] = w;
    o[o.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
    o[o.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';
    o[o.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';
    o[o.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
    if (w = $3ee4f50b1ae43a89$var$write_cellXfs(opts.cellXfs)) o[o.length] = w;
    o[o.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';
    o[o.length] = '<dxfs count="0"/>';
    o[o.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';
    if (o.length > 2) {
        o[o.length] = "</styleSheet>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */ function $3ee4f50b1ae43a89$var$parse_BrtFmt(data, length /*:number*/ ) {
    var numFmtId = data.read_shift(2);
    var stFmtCode = $3ee4f50b1ae43a89$var$parse_XLWideString(data, length - 2);
    return [
        numFmtId,
        stFmtCode
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtFmt(i /*:number*/ , f /*:string*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(6 + 4 * f.length);
    o.write_shift(2, i);
    $3ee4f50b1ae43a89$var$write_XLWideString(f, o);
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (o.l == null) o.l = o.length;
    return out;
}
/* [MS-XLSB] 2.4.659 BrtFont TODO */ function $3ee4f50b1ae43a89$var$parse_BrtFont(data, length /*:number*/ , opts) {
    var out = {} /*:any*/ ;
    out.sz = data.read_shift(2) / 20;
    var grbit = $3ee4f50b1ae43a89$var$parse_FontFlags(data, 2, opts);
    if (grbit.fItalic) out.italic = 1;
    if (grbit.fCondense) out.condense = 1;
    if (grbit.fExtend) out.extend = 1;
    if (grbit.fShadow) out.shadow = 1;
    if (grbit.fOutline) out.outline = 1;
    if (grbit.fStrikeout) out.strike = 1;
    var bls = data.read_shift(2);
    if (bls === 0x02BC) out.bold = 1;
    switch(data.read_shift(2)){
        /* case 0: out.vertAlign = "baseline"; break; */ case 1:
            out.vertAlign = "superscript";
            break;
        case 2:
            out.vertAlign = "subscript";
            break;
    }
    var underline = data.read_shift(1);
    if (underline != 0) out.underline = underline;
    var family = data.read_shift(1);
    if (family > 0) out.family = family;
    var bCharSet = data.read_shift(1);
    if (bCharSet > 0) out.charset = bCharSet;
    data.l++;
    out.color = $3ee4f50b1ae43a89$var$parse_BrtColor(data, 8);
    switch(data.read_shift(1)){
        /* case 0: out.scheme = "none": break; */ case 1:
            out.scheme = "major";
            break;
        case 2:
            out.scheme = "minor";
            break;
    }
    out.name = $3ee4f50b1ae43a89$var$parse_XLWideString(data, length - 21);
    return out;
}
function $3ee4f50b1ae43a89$var$write_BrtFont(font /*:any*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(153);
    o.write_shift(2, font.sz * 20);
    $3ee4f50b1ae43a89$var$write_FontFlags(font, o);
    o.write_shift(2, font.bold ? 0x02BC : 0x0190);
    var sss = 0;
    if (font.vertAlign == "superscript") sss = 1;
    else if (font.vertAlign == "subscript") sss = 2;
    o.write_shift(2, sss);
    o.write_shift(1, font.underline || 0);
    o.write_shift(1, font.family || 0);
    o.write_shift(1, font.charset || 0);
    o.write_shift(1, 0);
    $3ee4f50b1ae43a89$var$write_BrtColor(font.color, o);
    var scheme = 0;
    if (font.scheme == "major") scheme = 1;
    if (font.scheme == "minor") scheme = 2;
    o.write_shift(1, scheme);
    $3ee4f50b1ae43a89$var$write_XLWideString(font.name, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.650 BrtFill */ var $3ee4f50b1ae43a89$var$XLSBFillPTNames = [
    "none",
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
var $3ee4f50b1ae43a89$var$rev_XLSBFillPTNames /*:EvertNumType*/ ;
/* TODO: gradient fill representation */ var $3ee4f50b1ae43a89$var$parse_BrtFill = $3ee4f50b1ae43a89$var$parsenoop;
function $3ee4f50b1ae43a89$var$write_BrtFill(fill, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(84);
    if (!$3ee4f50b1ae43a89$var$rev_XLSBFillPTNames) $3ee4f50b1ae43a89$var$rev_XLSBFillPTNames = $3ee4f50b1ae43a89$var$evert($3ee4f50b1ae43a89$var$XLSBFillPTNames);
    var fls /*:number*/  = $3ee4f50b1ae43a89$var$rev_XLSBFillPTNames[fill.patternType];
    if (fls == null) fls = 0x28;
    o.write_shift(4, fls);
    var j = 0;
    if (fls != 0x28) {
        /* TODO: custom FG Color */ $3ee4f50b1ae43a89$var$write_BrtColor({
            auto: 1
        }, o);
        /* TODO: custom BG Color */ $3ee4f50b1ae43a89$var$write_BrtColor({
            auto: 1
        }, o);
        for(; j < 12; ++j)o.write_shift(4, 0);
    } else {
        for(; j < 4; ++j)o.write_shift(4, 0);
        for(; j < 12; ++j)o.write_shift(4, 0); /* TODO */ 
    /* iGradientType */ /* xnumDegree */ /* xnumFillToLeft */ /* xnumFillToRight */ /* xnumFillToTop */ /* xnumFillToBottom */ /* cNumStop */ /* xfillGradientStop */ }
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.824 BrtXF */ function $3ee4f50b1ae43a89$var$parse_BrtXF(data, length /*:number*/ ) {
    var tgt = data.l + length;
    var ixfeParent = data.read_shift(2);
    var ifmt = data.read_shift(2);
    data.l = tgt;
    return {
        ixfe: ixfeParent,
        numFmtId: ifmt
    };
}
function $3ee4f50b1ae43a89$var$write_BrtXF(data, ixfeP, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(16);
    o.write_shift(2, ixfeP || 0);
    o.write_shift(2, data.numFmtId || 0);
    o.write_shift(2, 0); /* iFont */ 
    o.write_shift(2, 0); /* iFill */ 
    o.write_shift(2, 0); /* ixBorder */ 
    o.write_shift(1, 0); /* trot */ 
    o.write_shift(1, 0); /* indent */ 
    var flow = 0;
    o.write_shift(1, flow); /* flags */ 
    o.write_shift(1, 0); /* flags */ 
    o.write_shift(1, 0); /* xfGrbitAtr */ 
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.5.4 Blxf TODO */ function $3ee4f50b1ae43a89$var$write_Blxf(data, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(10);
    o.write_shift(1, 0); /* dg */ 
    o.write_shift(1, 0);
    o.write_shift(4, 0); /* color */ 
    o.write_shift(4, 0); /* color */ 
    return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */ var $3ee4f50b1ae43a89$var$parse_BrtBorder = $3ee4f50b1ae43a89$var$parsenoop;
function $3ee4f50b1ae43a89$var$write_BrtBorder(border, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(51);
    o.write_shift(1, 0); /* diagonal */ 
    $3ee4f50b1ae43a89$var$write_Blxf(null, o); /* top */ 
    $3ee4f50b1ae43a89$var$write_Blxf(null, o); /* bottom */ 
    $3ee4f50b1ae43a89$var$write_Blxf(null, o); /* left */ 
    $3ee4f50b1ae43a89$var$write_Blxf(null, o); /* right */ 
    $3ee4f50b1ae43a89$var$write_Blxf(null, o); /* diag */ 
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.763 BrtStyle TODO */ function $3ee4f50b1ae43a89$var$write_BrtStyle(style, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(52);
    o.write_shift(4, style.xfId);
    o.write_shift(2, 1);
    o.write_shift(1, +style.builtinId);
    o.write_shift(1, 0); /* iLevel */ 
    $3ee4f50b1ae43a89$var$write_XLNullableWideString(style.name || "", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */ function $3ee4f50b1ae43a89$var$write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
    var o = $3ee4f50b1ae43a89$var$new_buf(2052);
    o.write_shift(4, cnt);
    $3ee4f50b1ae43a89$var$write_XLNullableWideString(defTableStyle, o);
    $3ee4f50b1ae43a89$var$write_XLNullableWideString(defPivotStyle, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.1.7.50 Styles */ function $3ee4f50b1ae43a89$var$parse_sty_bin(data, themes, opts) {
    var styles = {};
    styles.NumberFmt = [];
    for(var y in $3ee4f50b1ae43a89$var$table_fmt)styles.NumberFmt[y] = $3ee4f50b1ae43a89$var$table_fmt[y];
    styles.CellXf = [];
    styles.Fonts = [];
    var state /*:Array<string>*/  = [];
    var pass = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function hopper_sty(val, R, RT) {
        switch(RT){
            case 0x002C:
                /* BrtFmt */ styles.NumberFmt[val[0]] = val[1];
                $3ee4f50b1ae43a89$var$SSF_load(val[1], val[0]);
                break;
            case 0x002B:
                /* BrtFont */ styles.Fonts.push(val);
                if (val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) val.color.rgb = $3ee4f50b1ae43a89$var$rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
                break;
            case 0x0401:
                break;
            case 0x002D:
                break;
            case 0x002E:
                break;
            case 0x002F:
                /* BrtXF */ if (state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */ ) styles.CellXf.push(val);
                break;
            case 0x0030:
            /* BrtStyle */ case 0x01FB:
            /* BrtDXF */ case 0x023C:
            /* BrtMRUColor */ case 0x01DB:
                break;
            case 0x0493:
            /* BrtDXF14 */ case 0x0836:
            /* BrtDXF15 */ case 0x046A:
            /* BrtSlicerStyleElement */ case 0x0200:
            /* BrtTableStyleElement */ case 0x082F:
            /* BrtTimelineStyleElement */ case 0x0C00:
                break;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            case 0x0025:
                /* BrtACBegin */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* BrtACEnd */ state.pop();
                pass = false;
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return styles;
}
function $3ee4f50b1ae43a89$var$write_FMTS_bin(ba, NF /*:?SSFTable*/ ) {
    if (!NF) return;
    var cnt = 0;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) ++cnt;
    });
    if (cnt == 0) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0267 /* BrtBeginFmts */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $3ee4f50b1ae43a89$var$write_record(ba, 0x002C /* BrtFmt */ , $3ee4f50b1ae43a89$var$write_BrtFmt(i, NF[i]));
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0268 /* BrtEndFmts */ );
}
function $3ee4f50b1ae43a89$var$write_FONTS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0263 /* BrtBeginFonts */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x002B /* BrtFont */ , $3ee4f50b1ae43a89$var$write_BrtFont({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Calibri",
        family: 2,
        scheme: "minor"
    }));
    /* 1*65491BrtFont [ACFONTS] */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0264 /* BrtEndFonts */ );
}
function $3ee4f50b1ae43a89$var$write_FILLS_bin(ba /*::, data*/ ) {
    var cnt = 2;
    if (cnt == 0) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x025B /* BrtBeginFills */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x002D /* BrtFill */ , $3ee4f50b1ae43a89$var$write_BrtFill({
        patternType: "none"
    }));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x002D /* BrtFill */ , $3ee4f50b1ae43a89$var$write_BrtFill({
        patternType: "gray125"
    }));
    /* 1*65431BrtFill */ $3ee4f50b1ae43a89$var$write_record(ba, 0x025C /* BrtEndFills */ );
}
function $3ee4f50b1ae43a89$var$write_BORDERS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0265 /* BrtBeginBorders */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x002E /* BrtBorder */ , $3ee4f50b1ae43a89$var$write_BrtBorder({}));
    /* 1*65430BrtBorder */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0266 /* BrtEndBorders */ );
}
function $3ee4f50b1ae43a89$var$write_CELLSTYLEXFS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x002F /* BrtXF */ , $3ee4f50b1ae43a89$var$write_BrtXF({
        numFmtId: 0,
        fontId: 0,
        fillId: 0,
        borderId: 0
    }, 0xFFFF));
    /* 1*65430(BrtXF *FRT) */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0273 /* BrtEndCellStyleXFs */ );
}
function $3ee4f50b1ae43a89$var$write_CELLXFS_bin(ba, data) {
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0269 /* BrtBeginCellXFs */ , $3ee4f50b1ae43a89$var$write_UInt32LE(data.length));
    data.forEach(function(c) {
        $3ee4f50b1ae43a89$var$write_record(ba, 0x002F /* BrtXF */ , $3ee4f50b1ae43a89$var$write_BrtXF(c, 0));
    });
    /* 1*65430(BrtXF *FRT) */ $3ee4f50b1ae43a89$var$write_record(ba, 0x026A /* BrtEndCellXFs */ );
}
function $3ee4f50b1ae43a89$var$write_STYLES_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x026B /* BrtBeginStyles */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0030 /* BrtStyle */ , $3ee4f50b1ae43a89$var$write_BrtStyle({
        xfId: 0,
        builtinId: 0,
        name: "Normal"
    }));
    /* 1*65430(BrtStyle *FRT) */ $3ee4f50b1ae43a89$var$write_record(ba, 0x026C /* BrtEndStyles */ );
}
function $3ee4f50b1ae43a89$var$write_DXFS_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x01F9 /* BrtBeginDXFs */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    /* *2147483647(BrtDXF *FRT) */ $3ee4f50b1ae43a89$var$write_record(ba, 0x01FA /* BrtEndDXFs */ );
}
function $3ee4f50b1ae43a89$var$write_TABLESTYLES_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x01FC /* BrtBeginTableStyles */ , $3ee4f50b1ae43a89$var$write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
    /* *TABLESTYLE */ $3ee4f50b1ae43a89$var$write_record(ba, 0x01FD /* BrtEndTableStyles */ );
}
function $3ee4f50b1ae43a89$var$write_COLORPALETTE_bin() {
    return;
/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */ }
/* [MS-XLSB] 2.1.7.50 Styles */ function $3ee4f50b1ae43a89$var$write_sty_bin(wb, opts) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0116 /* BrtBeginStyleSheet */ );
    $3ee4f50b1ae43a89$var$write_FMTS_bin(ba, wb.SSF);
    $3ee4f50b1ae43a89$var$write_FONTS_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_FILLS_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_BORDERS_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_CELLSTYLEXFS_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_CELLXFS_bin(ba, opts.cellXfs);
    $3ee4f50b1ae43a89$var$write_STYLES_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_DXFS_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_TABLESTYLES_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_COLORPALETTE_bin(ba, wb);
    /* FRTSTYLESHEET*/ $3ee4f50b1ae43a89$var$write_record(ba, 0x0117 /* BrtEndStyleSheet */ );
    return ba.end();
}
/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */ var $3ee4f50b1ae43a89$var$XLSXThemeClrScheme = [
    "</a:lt1>",
    "</a:dk1>",
    "</a:lt2>",
    "</a:dk2>",
    "</a:accent1>",
    "</a:accent2>",
    "</a:accent3>",
    "</a:accent4>",
    "</a:accent5>",
    "</a:accent6>",
    "</a:hlink>",
    "</a:folHlink>"
];
/* 20.1.6.2 clrScheme CT_ColorScheme */ function $3ee4f50b1ae43a89$var$parse_clrScheme(t, themes, opts) {
    themes.themeElements.clrScheme = [];
    var color = {};
    (t[0].match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch(y[0]){
            /* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */ case "<a:clrScheme":
            case "</a:clrScheme>":
                break;
            /* 20.1.2.3.32 srgbClr CT_SRgbColor */ case "<a:srgbClr":
                color.rgb = y.val;
                break;
            /* 20.1.2.3.33 sysClr CT_SystemColor */ case "<a:sysClr":
                color.rgb = y.lastClr;
                break;
            /* 20.1.4.1.1 accent1 (Accent 1) */ /* 20.1.4.1.2 accent2 (Accent 2) */ /* 20.1.4.1.3 accent3 (Accent 3) */ /* 20.1.4.1.4 accent4 (Accent 4) */ /* 20.1.4.1.5 accent5 (Accent 5) */ /* 20.1.4.1.6 accent6 (Accent 6) */ /* 20.1.4.1.9 dk1 (Dark 1) */ /* 20.1.4.1.10 dk2 (Dark 2) */ /* 20.1.4.1.15 folHlink (Followed Hyperlink) */ /* 20.1.4.1.19 hlink (Hyperlink) */ /* 20.1.4.1.22 lt1 (Light 1) */ /* 20.1.4.1.23 lt2 (Light 2) */ case "<a:dk1>":
            case "</a:dk1>":
            case "<a:lt1>":
            case "</a:lt1>":
            case "<a:dk2>":
            case "</a:dk2>":
            case "<a:lt2>":
            case "</a:lt2>":
            case "<a:accent1>":
            case "</a:accent1>":
            case "<a:accent2>":
            case "</a:accent2>":
            case "<a:accent3>":
            case "</a:accent3>":
            case "<a:accent4>":
            case "</a:accent4>":
            case "<a:accent5>":
            case "</a:accent5>":
            case "<a:accent6>":
            case "</a:accent6>":
            case "<a:hlink>":
            case "</a:hlink>":
            case "<a:folHlink>":
            case "</a:folHlink>":
                if (y[0].charAt(1) === "/") {
                    themes.themeElements.clrScheme[$3ee4f50b1ae43a89$var$XLSXThemeClrScheme.indexOf(y[0])] = color;
                    color = {};
                } else color.name = y[0].slice(3, y[0].length - 1);
                break;
            default:
                if (opts && opts.WTF) throw new Error("Unrecognized " + y[0] + " in clrScheme");
        }
    });
}
/* 20.1.4.1.18 fontScheme CT_FontScheme */ function $3ee4f50b1ae43a89$var$parse_fontScheme() {}
/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */ function $3ee4f50b1ae43a89$var$parse_fmtScheme() {}
var $3ee4f50b1ae43a89$var$clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
var $3ee4f50b1ae43a89$var$fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
var $3ee4f50b1ae43a89$var$fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
/* 20.1.6.10 themeElements CT_BaseStyles */ function $3ee4f50b1ae43a89$var$parse_themeElements(data, themes, opts) {
    themes.themeElements = {};
    var t;
    [
        /* clrScheme CT_ColorScheme */ [
            "clrScheme",
            $3ee4f50b1ae43a89$var$clrsregex,
            $3ee4f50b1ae43a89$var$parse_clrScheme
        ],
        /* fontScheme CT_FontScheme */ [
            "fontScheme",
            $3ee4f50b1ae43a89$var$fntsregex,
            $3ee4f50b1ae43a89$var$parse_fontScheme
        ],
        /* fmtScheme CT_StyleMatrix */ [
            "fmtScheme",
            $3ee4f50b1ae43a89$var$fmtsregex,
            $3ee4f50b1ae43a89$var$parse_fmtScheme
        ]
    ].forEach(function(m) {
        if (!(t = data.match(m[1]))) throw new Error(m[0] + " not found in themeElements");
        m[2](t, themes, opts);
    });
}
var $3ee4f50b1ae43a89$var$themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
/* 14.2.7 Theme Part */ function $3ee4f50b1ae43a89$var$parse_theme_xml(data /*:string*/ , opts) {
    /* 20.1.6.9 theme CT_OfficeStyleSheet */ if (!data || data.length === 0) data = $3ee4f50b1ae43a89$var$write_theme();
    var t;
    var themes = {};
    /* themeElements CT_BaseStyles */ if (!(t = data.match($3ee4f50b1ae43a89$var$themeltregex))) throw new Error("themeElements not found in theme");
    $3ee4f50b1ae43a89$var$parse_themeElements(t[0], themes, opts);
    themes.raw = data;
    return themes;
}
function $3ee4f50b1ae43a89$var$write_theme(Themes, opts) /*:string*/ {
    if (opts && opts.themeXLSX) return opts.themeXLSX;
    if (Themes && typeof Themes.raw == "string") return Themes.raw;
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
    o[o.length] = "<a:themeElements>";
    o[o.length] = '<a:clrScheme name="Office">';
    o[o.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
    o[o.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
    o[o.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
    o[o.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
    o[o.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
    o[o.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
    o[o.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
    o[o.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
    o[o.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
    o[o.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
    o[o.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
    o[o.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
    o[o.length] = "</a:clrScheme>";
    o[o.length] = '<a:fontScheme name="Office">';
    o[o.length] = "<a:majorFont>";
    o[o.length] = '<a:latin typeface="Cambria"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = "</a:majorFont>";
    o[o.length] = "<a:minorFont>";
    o[o.length] = '<a:latin typeface="Calibri"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Arial"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Arial"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Arial"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = "</a:minorFont>";
    o[o.length] = "</a:fontScheme>";
    o[o.length] = '<a:fmtScheme name="Office">';
    o[o.length] = "<a:fillStyleLst>";
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:lin ang="16200000" scaled="1"/>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:lin ang="16200000" scaled="0"/>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = "</a:fillStyleLst>";
    o[o.length] = "<a:lnStyleLst>";
    o[o.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = "</a:lnStyleLst>";
    o[o.length] = "<a:effectStyleLst>";
    o[o.length] = "<a:effectStyle>";
    o[o.length] = "<a:effectLst>";
    o[o.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = "</a:effectLst>";
    o[o.length] = "</a:effectStyle>";
    o[o.length] = "<a:effectStyle>";
    o[o.length] = "<a:effectLst>";
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = "</a:effectLst>";
    o[o.length] = "</a:effectStyle>";
    o[o.length] = "<a:effectStyle>";
    o[o.length] = "<a:effectLst>";
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = "</a:effectLst>";
    o[o.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
    o[o.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
    o[o.length] = "</a:effectStyle>";
    o[o.length] = "</a:effectStyleLst>";
    o[o.length] = "<a:bgFillStyleLst>";
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = "</a:bgFillStyleLst>";
    o[o.length] = "</a:fmtScheme>";
    o[o.length] = "</a:themeElements>";
    o[o.length] = "<a:objectDefaults>";
    o[o.length] = "<a:spDef>";
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
    o[o.length] = "</a:spDef>";
    o[o.length] = "<a:lnDef>";
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
    o[o.length] = "</a:lnDef>";
    o[o.length] = "</a:objectDefaults>";
    o[o.length] = "<a:extraClrSchemeLst/>";
    o[o.length] = "</a:theme>";
    return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */ function $3ee4f50b1ae43a89$var$parse_Theme(blob, length, opts) {
    var end = blob.l + length;
    var dwThemeVersion = blob.read_shift(4);
    if (dwThemeVersion === 124226) return;
    if (!opts.cellStyles) {
        blob.l = end;
        return;
    }
    var data = blob.slice(blob.l);
    blob.l = end;
    var zip;
    try {
        zip = $3ee4f50b1ae43a89$var$zip_read(data, {
            type: "array"
        });
    } catch (e) {
        return;
    }
    var themeXML = $3ee4f50b1ae43a89$var$getzipstr(zip, "theme/theme/theme1.xml", true);
    if (!themeXML) return;
    return $3ee4f50b1ae43a89$var$parse_theme_xml(themeXML, opts);
}
/* 2.5.49 */ function $3ee4f50b1ae43a89$var$parse_ColorTheme(blob /*::, length*/ ) {
    return blob.read_shift(4);
}
/* 2.5.155 */ function $3ee4f50b1ae43a89$var$parse_FullColorExt(blob /*::, length*/ ) {
    var o = {};
    o.xclrType = blob.read_shift(2);
    o.nTintShade = blob.read_shift(2);
    switch(o.xclrType){
        case 0:
            blob.l += 4;
            break;
        case 1:
            o.xclrValue = $3ee4f50b1ae43a89$var$parse_IcvXF(blob, 4);
            break;
        case 2:
            o.xclrValue = $3ee4f50b1ae43a89$var$parse_LongRGBA(blob, 4);
            break;
        case 3:
            o.xclrValue = $3ee4f50b1ae43a89$var$parse_ColorTheme(blob, 4);
            break;
        case 4:
            blob.l += 4;
            break;
    }
    blob.l += 8;
    return o;
}
/* 2.5.164 TODO: read 7 bits*/ function $3ee4f50b1ae43a89$var$parse_IcvXF(blob, length) {
    return $3ee4f50b1ae43a89$var$parsenoop(blob, length);
}
/* 2.5.280 */ function $3ee4f50b1ae43a89$var$parse_XFExtGradient(blob, length) {
    return $3ee4f50b1ae43a89$var$parsenoop(blob, length);
}
/* [MS-XLS] 2.5.108 */ function $3ee4f50b1ae43a89$var$parse_ExtProp(blob /*::, length*/ ) /*:Array<any>*/ {
    var extType = blob.read_shift(2);
    var cb = blob.read_shift(2) - 4;
    var o = [
        extType
    ];
    switch(extType){
        case 0x04:
        case 0x05:
        case 0x07:
        case 0x08:
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0D:
            o[1] = $3ee4f50b1ae43a89$var$parse_FullColorExt(blob, cb);
            break;
        case 0x06:
            o[1] = $3ee4f50b1ae43a89$var$parse_XFExtGradient(blob, cb);
            break;
        case 0x0E:
        case 0x0F:
            o[1] = blob.read_shift(cb === 1 ? 1 : 2);
            break;
        default:
            throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
    }
    return o;
}
/* 2.4.355 */ function $3ee4f50b1ae43a89$var$parse_XFExt(blob, length) {
    var end = blob.l + length;
    blob.l += 2;
    var ixfe = blob.read_shift(2);
    blob.l += 2;
    var cexts = blob.read_shift(2);
    var ext /*:AOA*/  = [];
    while(cexts-- > 0)ext.push($3ee4f50b1ae43a89$var$parse_ExtProp(blob, end - blob.l));
    return {
        ixfe: ixfe,
        ext: ext
    };
}
/* xf is an XF, see parse_XFExt for xfext */ function $3ee4f50b1ae43a89$var$update_xfext(xf, xfext) {
    xfext.forEach(function(xfe) {
        xfe[0];
    });
}
function $3ee4f50b1ae43a89$var$parse_BrtMdtinfo(data, length) {
    return {
        flags: data.read_shift(4),
        version: data.read_shift(4),
        name: $3ee4f50b1ae43a89$var$parse_XLWideString(data, length - 8)
    };
}
function $3ee4f50b1ae43a89$var$write_BrtMdtinfo(data) {
    var o = $3ee4f50b1ae43a89$var$new_buf(12 + 2 * data.name.length);
    o.write_shift(4, data.flags);
    o.write_shift(4, data.version);
    $3ee4f50b1ae43a89$var$write_XLWideString(data.name, o);
    return o.slice(0, o.l);
}
function $3ee4f50b1ae43a89$var$parse_BrtMdb(data) {
    var out = [];
    var cnt = data.read_shift(4);
    while(cnt-- > 0)out.push([
        data.read_shift(4),
        data.read_shift(4)
    ]);
    return out;
}
function $3ee4f50b1ae43a89$var$write_BrtMdb(mdb) {
    var o = $3ee4f50b1ae43a89$var$new_buf(4 + 8 * mdb.length);
    o.write_shift(4, mdb.length);
    for(var i = 0; i < mdb.length; ++i){
        o.write_shift(4, mdb[i][0]);
        o.write_shift(4, mdb[i][1]);
    }
    return o;
}
function $3ee4f50b1ae43a89$var$write_BrtBeginEsfmd(cnt, name) {
    var o = $3ee4f50b1ae43a89$var$new_buf(8 + 2 * name.length);
    o.write_shift(4, cnt);
    $3ee4f50b1ae43a89$var$write_XLWideString(name, o);
    return o.slice(0, o.l);
}
function $3ee4f50b1ae43a89$var$parse_BrtBeginEsmdb(data) {
    data.l += 4;
    return data.read_shift(4) != 0;
}
function $3ee4f50b1ae43a89$var$write_BrtBeginEsmdb(cnt, cm) {
    var o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(4, cnt);
    o.write_shift(4, cm ? 1 : 0);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_xlmeta_bin(data, name, _opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    var opts = _opts || {};
    var state = [];
    var pass = false;
    var metatype = 2;
    $3ee4f50b1ae43a89$var$recordhopper(data, function(val, R, RT) {
        switch(RT){
            case 335:
                out.Types.push({
                    name: val.name
                });
                break;
            case 51:
                val.forEach(function(r) {
                    if (metatype == 1) out.Cell.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                    else if (metatype == 0) out.Value.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                });
                break;
            case 337:
                metatype = val ? 1 : 0;
                break;
            case 338:
                metatype = 2;
                break;
            case 35:
                state.push(RT);
                pass = true;
                break;
            case 36:
                state.pop();
                pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 35) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $3ee4f50b1ae43a89$var$write_xlmeta_bin() {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    $3ee4f50b1ae43a89$var$write_record(ba, 332);
    $3ee4f50b1ae43a89$var$write_record(ba, 334, $3ee4f50b1ae43a89$var$write_UInt32LE(1));
    $3ee4f50b1ae43a89$var$write_record(ba, 335, $3ee4f50b1ae43a89$var$write_BrtMdtinfo({
        name: "XLDAPR",
        version: 12e4,
        flags: 3496657072
    }));
    $3ee4f50b1ae43a89$var$write_record(ba, 336);
    $3ee4f50b1ae43a89$var$write_record(ba, 339, $3ee4f50b1ae43a89$var$write_BrtBeginEsfmd(1, "XLDAPR"));
    $3ee4f50b1ae43a89$var$write_record(ba, 52);
    $3ee4f50b1ae43a89$var$write_record(ba, 35, $3ee4f50b1ae43a89$var$write_UInt32LE(514));
    $3ee4f50b1ae43a89$var$write_record(ba, 4096, $3ee4f50b1ae43a89$var$write_UInt32LE(0));
    $3ee4f50b1ae43a89$var$write_record(ba, 4097, $3ee4f50b1ae43a89$var$writeuint16(1));
    $3ee4f50b1ae43a89$var$write_record(ba, 36);
    $3ee4f50b1ae43a89$var$write_record(ba, 53);
    $3ee4f50b1ae43a89$var$write_record(ba, 340);
    $3ee4f50b1ae43a89$var$write_record(ba, 337, $3ee4f50b1ae43a89$var$write_BrtBeginEsmdb(1, true));
    $3ee4f50b1ae43a89$var$write_record(ba, 51, $3ee4f50b1ae43a89$var$write_BrtMdb([
        [
            1,
            0
        ]
    ]));
    $3ee4f50b1ae43a89$var$write_record(ba, 338);
    $3ee4f50b1ae43a89$var$write_record(ba, 333);
    return ba.end();
}
function $3ee4f50b1ae43a89$var$parse_xlmeta_xml(data, name, opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    if (!data) return out;
    var pass = false;
    var metatype = 2;
    var lastmeta;
    data.replace($3ee4f50b1ae43a89$var$tagregex, function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<metadata":
            case "</metadata>":
                break;
            case "<metadataTypes":
            case "</metadataTypes>":
                break;
            case "<metadataType":
                out.Types.push({
                    name: y.name
                });
                break;
            case "</metadataType>":
                break;
            case "<futureMetadata":
                for(var j = 0; j < out.Types.length; ++j)if (out.Types[j].name == y.name) lastmeta = out.Types[j];
                break;
            case "</futureMetadata>":
                break;
            case "<bk>":
                break;
            case "</bk>":
                break;
            case "<rc":
                if (metatype == 1) out.Cell.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                else if (metatype == 0) out.Value.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                break;
            case "</rc>":
                break;
            case "<cellMetadata":
                metatype = 1;
                break;
            case "</cellMetadata>":
                metatype = 2;
                break;
            case "<valueMetadata":
                metatype = 0;
                break;
            case "</valueMetadata>":
                metatype = 2;
                break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            case "<rvb":
                if (!lastmeta) break;
                if (!lastmeta.offsets) lastmeta.offsets = [];
                lastmeta.offsets.push(+y.i);
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in metadata");
        }
        return x;
    });
    return out;
}
function $3ee4f50b1ae43a89$var$write_xlmeta_xml() {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
    return o.join("");
}
/* 18.6 Calculation Chain */ function $3ee4f50b1ae43a89$var$parse_cc_xml(data /*::, name, opts*/ ) /*:Array<any>*/ {
    var d = [];
    if (!data) return d;
    var i = 1;
    (data.match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch(y[0]){
            case "<?xml":
                break;
            /* 18.6.2  calcChain CT_CalcChain 1 */ case "<calcChain":
            case "<calcChain>":
            case "</calcChain>":
                break;
            /* 18.6.1  c CT_CalcCell 1 */ case "<c":
                delete y[0];
                if (y.i) i = y.i;
                else y.i = i;
                d.push(y);
                break;
        }
    });
    return d;
}
//function write_cc_xml(data, opts) { }
/* [MS-XLSB] 2.6.4.1 */ function $3ee4f50b1ae43a89$var$parse_BrtCalcChainItem$(data) {
    var out = {};
    out.i = data.read_shift(4);
    var cell = {};
    cell.r = data.read_shift(4);
    cell.c = data.read_shift(4);
    out.r = $3ee4f50b1ae43a89$var$encode_cell(cell);
    var flags = data.read_shift(1);
    if (flags & 0x2) out.l = "1";
    if (flags & 0x8) out.a = "1";
    return out;
}
/* 18.6 Calculation Chain */ function $3ee4f50b1ae43a89$var$parse_cc_bin(data, name, opts) {
    var out = [];
    var pass = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function hopper_cc(val, R, RT) {
        switch(RT){
            case 0x003F:
                /* 'BrtCalcChainItem$' */ out.push(val);
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */ function $3ee4f50b1ae43a89$var$parse_xlink_xml() {
//var opts = _opts || {};
//if(opts.WTF) throw "XLSX External Link";
}
/* [MS-XLSB] 2.1.7.25 External Link */ function $3ee4f50b1ae43a89$var$parse_xlink_bin(data, rel, name /*:string*/ , _opts) {
    if (!data) return data;
    var opts = _opts || {};
    var pass = false, end = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function xlink_parse(val, R, RT) {
        if (end) return;
        switch(RT){
            case 0x0167:
            /* 'BrtSupTabs' */ case 0x016B:
            /* 'BrtExternTableStart' */ case 0x016C:
            /* 'BrtExternTableEnd' */ case 0x016E:
            /* 'BrtExternRowHdr' */ case 0x016F:
            /* 'BrtExternCellBlank' */ case 0x0170:
            /* 'BrtExternCellReal' */ case 0x0171:
            /* 'BrtExternCellBool' */ case 0x0172:
            /* 'BrtExternCellError' */ case 0x0173:
            /* 'BrtExternCellString' */ case 0x01D8:
            /* 'BrtExternValueMeta' */ case 0x0241:
            /* 'BrtSupNameStart' */ case 0x0242:
            /* 'BrtSupNameValueStart' */ case 0x0243:
            /* 'BrtSupNameValueEnd' */ case 0x0244:
            /* 'BrtSupNameNum' */ case 0x0245:
            /* 'BrtSupNameErr' */ case 0x0246:
            /* 'BrtSupNameSt' */ case 0x0247:
            /* 'BrtSupNameNil' */ case 0x0248:
            /* 'BrtSupNameBool' */ case 0x0249:
            /* 'BrtSupNameFmla' */ case 0x024A:
            /* 'BrtSupNameBits' */ case 0x024B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
}
/* 20.5 DrawingML - SpreadsheetML Drawing */ /* 20.5.2.35 wsDr CT_Drawing */ function $3ee4f50b1ae43a89$var$parse_drawing(data, rels /*:any*/ ) {
    if (!data) return "??";
    /*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/ var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/) || [
        "",
        ""
    ])[1];
    return rels["!id"][id].Target;
}
/* L.5.5.2 SpreadsheetML Comments + VML Schema */ var $3ee4f50b1ae43a89$var$_shapeid = 1024;
function $3ee4f50b1ae43a89$var$write_comments_vml(rId /*:number*/ , comments) {
    var csize = [
        21600,
        21600
    ];
    /* L.5.2.1.2 Path Attribute */ var bbox = [
        "m0,0l0",
        csize[1],
        csize[0],
        csize[1],
        csize[0],
        "0xe"
    ].join(",");
    var o = [
        $3ee4f50b1ae43a89$var$writextag("xml", null, {
            "xmlns:v": $3ee4f50b1ae43a89$var$XLMLNS.v,
            "xmlns:o": $3ee4f50b1ae43a89$var$XLMLNS.o,
            "xmlns:x": $3ee4f50b1ae43a89$var$XLMLNS.x,
            "xmlns:mv": $3ee4f50b1ae43a89$var$XLMLNS.mv
        }).replace(/\/>/, ">"),
        $3ee4f50b1ae43a89$var$writextag("o:shapelayout", $3ee4f50b1ae43a89$var$writextag("o:idmap", null, {
            "v:ext": "edit",
            "data": rId
        }), {
            "v:ext": "edit"
        }),
        $3ee4f50b1ae43a89$var$writextag("v:shapetype", [
            $3ee4f50b1ae43a89$var$writextag("v:stroke", null, {
                joinstyle: "miter"
            }),
            $3ee4f50b1ae43a89$var$writextag("v:path", null, {
                gradientshapeok: "t",
                "o:connecttype": "rect"
            })
        ].join(""), {
            id: "_x0000_t202",
            "o:spt": 202,
            coordsize: csize.join(","),
            path: bbox
        })
    ];
    while($3ee4f50b1ae43a89$var$_shapeid < rId * 1000)$3ee4f50b1ae43a89$var$_shapeid += 1000;
    comments.forEach(function(x) {
        var c = $3ee4f50b1ae43a89$var$decode_cell(x[0]);
        var fillopts = /*::(*/ {
            "color2": "#BEFF82",
            "type": "gradient"
        } /*:: :any)*/ ;
        if (fillopts.type == "gradient") fillopts.angle = "-180";
        var fillparm = fillopts.type == "gradient" ? $3ee4f50b1ae43a89$var$writextag("o:fill", null, {
            type: "gradientUnscaled",
            "v:ext": "view"
        }) : null;
        var fillxml = $3ee4f50b1ae43a89$var$writextag("v:fill", fillparm, fillopts);
        var shadata = {
            on: "t",
            "obscured": "t"
        } /*:any*/ ;
        ++$3ee4f50b1ae43a89$var$_shapeid;
        o = o.concat([
            "<v:shape" + $3ee4f50b1ae43a89$var$wxt_helper({
                id: "_x0000_s" + $3ee4f50b1ae43a89$var$_shapeid,
                type: "#_x0000_t202",
                style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : ""),
                fillcolor: "#ECFAD4",
                strokecolor: "#edeaa1"
            }) + ">",
            fillxml,
            $3ee4f50b1ae43a89$var$writextag("v:shadow", null, shadata),
            $3ee4f50b1ae43a89$var$writextag("v:path", null, {
                "o:connecttype": "none"
            }),
            '<v:textbox><div style="text-align:left"></div></v:textbox>',
            '<x:ClientData ObjectType="Note">',
            "<x:MoveWithCells/>",
            "<x:SizeWithCells/>",
            /* Part 4 19.4.2.3 Anchor (Anchor) */ $3ee4f50b1ae43a89$var$writetag("x:Anchor", [
                c.c + 1,
                0,
                c.r + 1,
                0,
                c.c + 3,
                20,
                c.r + 5,
                20
            ].join(",")),
            $3ee4f50b1ae43a89$var$writetag("x:AutoFill", "False"),
            $3ee4f50b1ae43a89$var$writetag("x:Row", String(c.r)),
            $3ee4f50b1ae43a89$var$writetag("x:Column", String(c.c)),
            x[1].hidden ? "" : "<x:Visible/>",
            "</x:ClientData>",
            "</v:shape>"
        ]);
    });
    o.push("</xml>");
    return o.join("");
}
function $3ee4f50b1ae43a89$var$sheet_insert_comments(sheet, comments /*:Array<RawComment>*/ , threaded /*:boolean*/ , people /*:?Array<any>*/ ) {
    var dense = Array.isArray(sheet);
    var cell /*:Cell*/ ;
    comments.forEach(function(comment) {
        var r = $3ee4f50b1ae43a89$var$decode_cell(comment.ref);
        if (dense) {
            if (!sheet[r.r]) sheet[r.r] = [];
            cell = sheet[r.r][r.c];
        } else cell = sheet[comment.ref];
        if (!cell) {
            cell = {
                t: "z"
            } /*:any*/ ;
            if (dense) sheet[r.r][r.c] = cell;
            else sheet[comment.ref] = cell;
            var range = $3ee4f50b1ae43a89$var$safe_decode_range(sheet["!ref"] || "BDWGO1000001:A1");
            if (range.s.r > r.r) range.s.r = r.r;
            if (range.e.r < r.r) range.e.r = r.r;
            if (range.s.c > r.c) range.s.c = r.c;
            if (range.e.c < r.c) range.e.c = r.c;
            var encoded = $3ee4f50b1ae43a89$var$encode_range(range);
            if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
        }
        if (!cell.c) cell.c = [];
        var o /*:Comment*/  = {
            a: comment.author,
            t: comment.t,
            r: comment.r,
            T: threaded
        };
        if (comment.h) o.h = comment.h;
        /* threaded comments always override */ for(var i = cell.c.length - 1; i >= 0; --i){
            if (!threaded && cell.c[i].T) return;
            if (threaded && !cell.c[i].T) cell.c.splice(i, 1);
        }
        if (threaded && people) {
            for(i = 0; i < people.length; ++i)if (o.a == people[i].id) {
                o.a = people[i].name || o.a;
                break;
            }
        }
        cell.c.push(o);
    });
}
/* 18.7 Comments */ function $3ee4f50b1ae43a89$var$parse_comments_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    /* 18.7.6 CT_Comments */ if (data.match(/<(?:\w+:)?comments *\/>/)) return [];
    var authors /*:Array<string>*/  = [];
    var commentList /*:Array<RawComment>*/  = [];
    var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
    if (authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
        if (a) authors.push(a[1]);
    });
    var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
    if (cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
        if (!cm) return;
        var y = $3ee4f50b1ae43a89$var$parsexmltag(cm[0]);
        var comment /*:RawComment*/  = {
            author: y.authorId && authors[y.authorId] || "sheetjsghost",
            ref: y.ref,
            guid: y.guid
        } /*:any*/ ;
        var cell = $3ee4f50b1ae43a89$var$decode_cell(y.ref);
        if (opts.sheetRows && opts.sheetRows <= cell.r) return;
        var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
        var rt = !!textMatch && !!textMatch[1] && $3ee4f50b1ae43a89$var$parse_si(textMatch[1]) || {
            r: "",
            t: "",
            h: ""
        };
        comment.r = rt.r;
        if (rt.r == "<t></t>") rt.t = rt.h = "";
        comment.t = (rt.t || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        if (opts.cellHTML) comment.h = rt.h;
        commentList.push(comment);
    });
    return commentList;
}
function $3ee4f50b1ae43a89$var$write_comments_xml(data /*::, opts*/ ) {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("comments", null, {
            "xmlns": $3ee4f50b1ae43a89$var$XMLNS_main[0]
        })
    ];
    var iauthor /*:Array<string>*/  = [];
    o.push("<authors>");
    data.forEach(function(x) {
        x[1].forEach(function(w) {
            var a = $3ee4f50b1ae43a89$var$escapexml(w.a);
            if (iauthor.indexOf(a) == -1) {
                iauthor.push(a);
                o.push("<author>" + a + "</author>");
            }
            if (w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
                iauthor.push("tc=" + w.ID);
                o.push("<author>tc=" + w.ID + "</author>");
            }
        });
    });
    if (iauthor.length == 0) {
        iauthor.push("SheetJ5");
        o.push("<author>SheetJ5</author>");
    }
    o.push("</authors>");
    o.push("<commentList>");
    data.forEach(function(d) {
        /* 18.7.3 CT_Comment */ var lastauthor = 0, ts = [];
        if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
        else d[1].forEach(function(c) {
            if (c.a) lastauthor = iauthor.indexOf($3ee4f50b1ae43a89$var$escapexml(c.a));
            ts.push(c.t || "");
        });
        o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
        if (ts.length <= 1) o.push($3ee4f50b1ae43a89$var$writetag("t", $3ee4f50b1ae43a89$var$escapexml(ts[0] || "")));
        else {
            /* based on Threaded Comments -> Comments projection */ var t = "Comment:\n    " + ts[0] + "\n";
            for(var i = 1; i < ts.length; ++i)t += "Reply:\n    " + ts[i] + "\n";
            o.push($3ee4f50b1ae43a89$var$writetag("t", $3ee4f50b1ae43a89$var$escapexml(t)));
        }
        o.push("</text></comment>");
    });
    o.push("</commentList>");
    if (o.length > 2) {
        o[o.length] = "</comments>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSX] 2.1.17 */ function $3ee4f50b1ae43a89$var$parse_tcmnt_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    var out = [];
    var pass = false, comment = {}, tidx = 0;
    data.replace($3ee4f50b1ae43a89$var$tagregex, function xml_tcmnt(x, idx) {
        var y /*:any*/  = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<?xml":
                break;
            /* 2.6.207 ThreadedComments CT_ThreadedComments */ case "<ThreadedComments":
                break;
            case "</ThreadedComments>":
                break;
            /* 2.6.205 threadedComment CT_ThreadedComment */ case "<threadedComment":
                comment = {
                    author: y.personId,
                    guid: y.id,
                    ref: y.ref,
                    T: 1
                };
                break;
            case "</threadedComment>":
                if (comment.t != null) out.push(comment);
                break;
            case "<text>":
            case "<text":
                tidx = idx + x.length;
                break;
            case "</text>":
                comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                break;
            /* 2.6.206 mentions CT_ThreadedCommentMentions TODO */ case "<mentions":
            case "<mentions>":
                pass = true;
                break;
            case "</mentions>":
                pass = false;
                break;
            /* 2.6.202 mention CT_Mention TODO */ /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            /* 18.2.7  ext CT_Extension + */ case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in threaded comments");
        }
        return x;
    });
    return out;
}
function $3ee4f50b1ae43a89$var$write_tcmnt_xml(comments, people, opts) {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("ThreadedComments", null, {
            "xmlns": $3ee4f50b1ae43a89$var$XMLNS.TCMNT
        }).replace(/[\/]>/, ">")
    ];
    comments.forEach(function(carr) {
        var rootid = "";
        (carr[1] || []).forEach(function(c, idx) {
            if (!c.T) {
                delete c.ID;
                return;
            }
            if (c.a && people.indexOf(c.a) == -1) people.push(c.a);
            var tcopts = {
                ref: carr[0],
                id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
            };
            if (idx == 0) rootid = tcopts.id;
            else tcopts.parentId = rootid;
            c.ID = tcopts.id;
            if (c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
            o.push($3ee4f50b1ae43a89$var$writextag("threadedComment", $3ee4f50b1ae43a89$var$writetag("text", c.t || ""), tcopts));
        });
    });
    o.push("</ThreadedComments>");
    return o.join("");
}
/* [MS-XLSX] 2.1.18 */ function $3ee4f50b1ae43a89$var$parse_people_xml(data /*:string*/ , opts) {
    var out = [];
    var pass = false;
    data.replace($3ee4f50b1ae43a89$var$tagregex, function xml_tcmnt(x) {
        var y /*:any*/  = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<?xml":
                break;
            /* 2.4.85 personList CT_PersonList */ case "<personList":
                break;
            case "</personList>":
                break;
            /* 2.6.203 person CT_Person TODO: providers */ case "<person":
                out.push({
                    name: y.displayname,
                    id: y.id
                });
                break;
            case "</person>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            /* 18.2.7  ext CT_Extension + */ case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in threaded comments");
        }
        return x;
    });
    return out;
}
function $3ee4f50b1ae43a89$var$write_people_xml(people /*, opts*/ ) {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("personList", null, {
            "xmlns": $3ee4f50b1ae43a89$var$XMLNS.TCMNT,
            "xmlns:x": $3ee4f50b1ae43a89$var$XMLNS_main[0]
        }).replace(/[\/]>/, ">")
    ];
    people.forEach(function(person, idx) {
        o.push($3ee4f50b1ae43a89$var$writextag("person", null, {
            displayName: person,
            id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
            userId: person,
            providerId: "None"
        }));
    });
    o.push("</personList>");
    return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */ function $3ee4f50b1ae43a89$var$parse_BrtBeginComment(data) {
    var out = {};
    out.iauthor = data.read_shift(4);
    var rfx = $3ee4f50b1ae43a89$var$parse_UncheckedRfX(data, 16);
    out.rfx = rfx.s;
    out.ref = $3ee4f50b1ae43a89$var$encode_cell(rfx.s);
    data.l += 16; /*var guid = parse_GUID(data); */ 
    return out;
}
function $3ee4f50b1ae43a89$var$write_BrtBeginComment(data, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(36);
    o.write_shift(4, data[1].iauthor);
    $3ee4f50b1ae43a89$var$write_UncheckedRfX(data[0], o);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLSB] 2.4.327 BrtCommentAuthor */ var $3ee4f50b1ae43a89$var$parse_BrtCommentAuthor = $3ee4f50b1ae43a89$var$parse_XLWideString;
function $3ee4f50b1ae43a89$var$write_BrtCommentAuthor(data) {
    return $3ee4f50b1ae43a89$var$write_XLWideString(data.slice(0, 54));
}
/* [MS-XLSB] 2.1.7.8 Comments */ function $3ee4f50b1ae43a89$var$parse_comments_bin(data, opts) /*:Array<RawComment>*/ {
    var out /*:Array<RawComment>*/  = [];
    var authors /*:Array<string>*/  = [];
    var c = {};
    var pass = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function hopper_cmnt(val, R, RT) {
        switch(RT){
            case 0x0278:
                /* 'BrtCommentAuthor' */ authors.push(val);
                break;
            case 0x027B:
                /* 'BrtBeginComment' */ c = val;
                break;
            case 0x027D:
                /* 'BrtCommentText' */ c.t = val.t;
                c.h = val.h;
                c.r = val.r;
                break;
            case 0x027C:
                /* 'BrtEndComment' */ c.author = authors[c.iauthor];
                delete c /*:any*/ .iauthor;
                if (opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
                if (!c.t) c.t = "";
                delete c.rfx;
                out.push(c);
                break;
            case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                break;
            case 0x0026:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $3ee4f50b1ae43a89$var$write_comments_bin(data /*::, opts*/ ) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    var iauthor /*:Array<string>*/  = [];
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0274 /* BrtBeginComments */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0276 /* BrtBeginCommentAuthors */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            if (iauthor.indexOf(c.a) > -1) return;
            iauthor.push(c.a.slice(0, 54));
            $3ee4f50b1ae43a89$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $3ee4f50b1ae43a89$var$write_BrtCommentAuthor(c.a));
        });
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0277 /* BrtEndCommentAuthors */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0279 /* BrtBeginCommentList */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            c.iauthor = iauthor.indexOf(c.a);
            var range = {
                s: $3ee4f50b1ae43a89$var$decode_cell(comment[0]),
                e: $3ee4f50b1ae43a89$var$decode_cell(comment[0])
            };
            $3ee4f50b1ae43a89$var$write_record(ba, 0x027B /* BrtBeginComment */ , $3ee4f50b1ae43a89$var$write_BrtBeginComment([
                range,
                c
            ]));
            if (c.t && c.t.length > 0) $3ee4f50b1ae43a89$var$write_record(ba, 0x027D /* BrtCommentText */ , $3ee4f50b1ae43a89$var$write_BrtCommentText(c));
            $3ee4f50b1ae43a89$var$write_record(ba, 0x027C /* BrtEndComment */ );
            delete c.iauthor;
        });
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x027A /* BrtEndCommentList */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0275 /* BrtEndComments */ );
    return ba.end();
}
var $3ee4f50b1ae43a89$var$CT_VBA = "application/vnd.ms-office.vbaProject";
function $3ee4f50b1ae43a89$var$make_vba_xls(cfb) {
    var newcfb = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    cfb.FullPaths.forEach(function(p, i) {
        if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
        var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
        $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
    });
    return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.write(newcfb);
}
function $3ee4f50b1ae43a89$var$fill_vba_xls(cfb, vba) {
    vba.FullPaths.forEach(function(p, i) {
        if (i == 0) return;
        var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
        if (newpath.slice(-1) !== "/") $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
    });
}
var $3ee4f50b1ae43a89$var$VBAFMTS = [
    "xlsb",
    "xlsm",
    "xlam",
    "biff8",
    "xla"
];
/* macro and dialog sheet stubs */ function $3ee4f50b1ae43a89$var$parse_ds_bin() /*:Worksheet*/ {
    return {
        "!type": "dialog"
    };
}
function $3ee4f50b1ae43a89$var$parse_ds_xml() /*:Worksheet*/ {
    return {
        "!type": "dialog"
    };
}
function $3ee4f50b1ae43a89$var$parse_ms_bin() /*:Worksheet*/ {
    return {
        "!type": "macro"
    };
}
function $3ee4f50b1ae43a89$var$parse_ms_xml() /*:Worksheet*/ {
    return {
        "!type": "macro"
    };
}
/* TODO: it will be useful to parse the function str */ var $3ee4f50b1ae43a89$var$rc_to_a1 = /*#__PURE__*/ function() {
    var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
    var rcbase /*:Cell*/  = {
        r: 0,
        c: 0
    } /*:any*/ ;
    function rcfunc($$, $1, $2, $3) {
        var cRel = false, rRel = false;
        if ($2.length == 0) rRel = true;
        else if ($2.charAt(0) == "[") {
            rRel = true;
            $2 = $2.slice(1, -1);
        }
        if ($3.length == 0) cRel = true;
        else if ($3.charAt(0) == "[") {
            cRel = true;
            $3 = $3.slice(1, -1);
        }
        var R = $2.length > 0 ? parseInt($2, 10) | 0 : 0, C = $3.length > 0 ? parseInt($3, 10) | 0 : 0;
        if (cRel) C += rcbase.c;
        else --C;
        if (rRel) R += rcbase.r;
        else --R;
        return $1 + (cRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_col(C) + (rRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_row(R);
    }
    return function rc_to_a1(fstr /*:string*/ , base /*:Cell*/ ) /*:string*/ {
        rcbase = base;
        return fstr.replace(rcregex, rcfunc);
    };
}();
var $3ee4f50b1ae43a89$var$crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
var $3ee4f50b1ae43a89$var$a1_to_rc = /*#__PURE__*/ function() {
    return function a1_to_rc(fstr /*:string*/ , base /*:CellAddress*/ ) {
        return fstr.replace($3ee4f50b1ae43a89$var$crefregex, function($0, $1, $2, $3, $4, $5) {
            var c = $3ee4f50b1ae43a89$var$decode_col($3) - ($2 ? 0 : base.c);
            var r = $3ee4f50b1ae43a89$var$decode_row($5) - ($4 ? 0 : base.r);
            var R = r == 0 ? "" : !$4 ? "[" + r + "]" : r + 1;
            var C = c == 0 ? "" : !$2 ? "[" + c + "]" : c + 1;
            return $1 + "R" + R + "C" + C;
        });
    };
}();
/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */ function $3ee4f50b1ae43a89$var$shift_formula_str(f /*:string*/ , delta /*:Cell*/ ) /*:string*/ {
    return f.replace($3ee4f50b1ae43a89$var$crefregex, function($0, $1, $2, $3, $4, $5) {
        return $1 + ($2 == "$" ? $2 + $3 : $3ee4f50b1ae43a89$var$encode_col($3ee4f50b1ae43a89$var$decode_col($3) + delta.c)) + ($4 == "$" ? $4 + $5 : $3ee4f50b1ae43a89$var$encode_row($3ee4f50b1ae43a89$var$decode_row($5) + delta.r));
    });
}
function $3ee4f50b1ae43a89$var$shift_formula_xlsx(f /*:string*/ , range /*:string*/ , cell /*:string*/ ) /*:string*/ {
    var r = $3ee4f50b1ae43a89$var$decode_range(range), s = r.s, c = $3ee4f50b1ae43a89$var$decode_cell(cell);
    var delta = {
        r: c.r - s.r,
        c: c.c - s.c
    };
    return $3ee4f50b1ae43a89$var$shift_formula_str(f, delta);
}
/* TODO: parse formula */ function $3ee4f50b1ae43a89$var$fuzzyfmla(f /*:string*/ ) /*:boolean*/ {
    if (f.length == 1) return false;
    return true;
}
function $3ee4f50b1ae43a89$var$_xlfn(f /*:string*/ ) /*:string*/ {
    return f.replace(/_xlfn\./g, "");
}
function $3ee4f50b1ae43a89$var$parseread1(blob) {
    blob.l += 1;
    return;
}
/* [MS-XLS] 2.5.51 */ function $3ee4f50b1ae43a89$var$parse_ColRelU(blob, length) {
    var c = blob.read_shift(length == 1 ? 1 : 2);
    return [
        c & 0x3FFF,
        c >> 14 & 1,
        c >> 15 & 1
    ];
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */ function $3ee4f50b1ae43a89$var$parse_RgceArea(blob, length, opts) {
    var w = 2;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return $3ee4f50b1ae43a89$var$parse_RgceArea_BIFF2(blob, length, opts);
        else if (opts.biff == 12) w = 4;
    }
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    var C = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* BIFF 2-5 encodes flags in the row field */ function $3ee4f50b1ae43a89$var$parse_RgceArea_BIFF2(blob /*::, length, opts*/ ) {
    var r = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2), R = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    var C = blob.read_shift(1);
    return {
        s: {
            r: r[0],
            c: c,
            cRel: r[1],
            rRel: r[2]
        },
        e: {
            r: R[0],
            c: C,
            cRel: R[1],
            rRel: R[2]
        }
    };
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */ function $3ee4f50b1ae43a89$var$parse_RgceAreaRel(blob, length, opts) {
    if (opts.biff < 8) return $3ee4f50b1ae43a89$var$parse_RgceArea_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts.biff == 12 ? 4 : 2), R = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var c = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    var C = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */ function $3ee4f50b1ae43a89$var$parse_RgceLoc(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff <= 5) return $3ee4f50b1ae43a89$var$parse_RgceLoc_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
    var c = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    return {
        r: r,
        c: c[0],
        cRel: c[1],
        rRel: c[2]
    };
}
function $3ee4f50b1ae43a89$var$parse_RgceLoc_BIFF2(blob /*::, length, opts*/ ) {
    var r = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    return {
        r: r[0],
        c: c,
        cRel: r[1],
        rRel: r[2]
    };
}
/* [MS-XLS] 2.5.198.107, 2.5.47 */ function $3ee4f50b1ae43a89$var$parse_RgceElfLoc(blob /*::, length, opts*/ ) {
    var r = blob.read_shift(2);
    var c = blob.read_shift(2);
    return {
        r: r,
        c: c & 0xFF,
        fQuoted: !!(c & 0x4000),
        cRel: c >> 15,
        rRel: c >> 15
    };
}
/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */ function $3ee4f50b1ae43a89$var$parse_RgceLocRel(blob, length, opts) {
    var biff = opts && opts.biff ? opts.biff : 8;
    if (biff >= 2 && biff <= 5) return $3ee4f50b1ae43a89$var$parse_RgceLocRel_BIFF2(blob, length, opts);
    var r = blob.read_shift(biff >= 12 ? 4 : 2);
    var cl = blob.read_shift(2);
    var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
    cl &= 0x3FFF;
    if (rRel == 1) while(r > 0x7FFFF)r -= 0x100000;
    if (cRel == 1) while(cl > 0x1FFF)cl = cl - 0x4000;
    return {
        r: r,
        c: cl,
        cRel: cRel,
        rRel: rRel
    };
}
function $3ee4f50b1ae43a89$var$parse_RgceLocRel_BIFF2(blob /*::, length:number, opts*/ ) {
    var rl = blob.read_shift(2);
    var c = blob.read_shift(1);
    var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
    rl &= 0x3FFF;
    if (rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
    if (cRel == 1 && c >= 0x80) c = c - 0x100;
    return {
        r: rl,
        c: c,
        cRel: cRel,
        rRel: rRel
    };
}
/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */ function $3ee4f50b1ae43a89$var$parse_PtgArea(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $3ee4f50b1ae43a89$var$parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */ function $3ee4f50b1ae43a89$var$parse_PtgArea3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2, "i");
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    var area = $3ee4f50b1ae43a89$var$parse_RgceArea(blob, w, opts);
    return [
        type,
        ixti,
        area
    ];
}
/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */ function $3ee4f50b1ae43a89$var$parse_PtgAreaErr(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts && opts.biff > 8 ? 12 : opts.biff < 8 ? 6 : 8;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */ function $3ee4f50b1ae43a89$var$parse_PtgAreaErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */ function $3ee4f50b1ae43a89$var$parse_PtgAreaN(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $3ee4f50b1ae43a89$var$parse_RgceAreaRel(blob, length - 1, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */ function $3ee4f50b1ae43a89$var$parse_PtgArray(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrBaxcel(blob) {
    var bitSemi = blob[blob.l + 1] & 0x01; /* 1 = volatile */ 
    var bitBaxcel = 1;
    blob.l += 4;
    return [
        bitSemi,
        bitBaxcel
    ];
}
/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrChoose(blob, length, opts) /*:Array<number>*/ {
    blob.l += 2;
    var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var o /*:Array<number>*/  = [];
    /* offset is 1 less than the number of elements */ for(var i = 0; i <= offset; ++i)o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
    return o;
}
/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrGoto(blob, length, opts) {
    var bitGoto = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitGoto,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrIf(blob, length, opts) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLSB] 2.5.97.28 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrIfError(blob) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(2)
    ];
}
/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrSemi(blob, length, opts) {
    var bitSemi = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return [
        bitSemi
    ];
}
/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrSpaceType(blob /*::, length*/ ) {
    var type = blob.read_shift(1), cch = blob.read_shift(1);
    return [
        type,
        cch
    ];
}
/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrSpace(blob) {
    blob.read_shift(2);
    return $3ee4f50b1ae43a89$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrSpaceSemi(blob) {
    blob.read_shift(2);
    return $3ee4f50b1ae43a89$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */ function $3ee4f50b1ae43a89$var$parse_PtgRef(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $3ee4f50b1ae43a89$var$parse_RgceLoc(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */ function $3ee4f50b1ae43a89$var$parse_PtgRefN(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $3ee4f50b1ae43a89$var$parse_RgceLocRel(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */ function $3ee4f50b1ae43a89$var$parse_PtgRef3d(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var ixti = blob.read_shift(2); // XtiIndex
    if (opts && opts.biff == 5) blob.l += 12;
    var loc = $3ee4f50b1ae43a89$var$parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
    return [
        type,
        ixti,
        loc
    ];
}
/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */ function $3ee4f50b1ae43a89$var$parse_PtgFunc(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
    return [
        $3ee4f50b1ae43a89$var$FtabArgc[iftab],
        $3ee4f50b1ae43a89$var$Ftab[iftab],
        type
    ];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */ function $3ee4f50b1ae43a89$var$parse_PtgFuncVar(blob, length, opts) {
    var type = blob[blob.l++];
    var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [
        type == 0x58 ? -1 : 0,
        blob.read_shift(1)
    ] : $3ee4f50b1ae43a89$var$parsetab(blob);
    return [
        cparams,
        (tab[0] === 0 ? $3ee4f50b1ae43a89$var$Ftab : $3ee4f50b1ae43a89$var$Cetab)[tab[1]]
    ];
}
function $3ee4f50b1ae43a89$var$parsetab(blob) {
    return [
        blob[blob.l + 1] >> 7,
        blob.read_shift(2) & 0x7FFF
    ];
}
/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrSum(blob, length, opts) {
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return;
}
/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */ function $3ee4f50b1ae43a89$var$parse_PtgExp(blob, length, opts) {
    blob.l++;
    if (opts && opts.biff == 12) return [
        blob.read_shift(4, "i"),
        0
    ];
    var row = blob.read_shift(2);
    var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        row,
        col
    ];
}
/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */ function $3ee4f50b1ae43a89$var$parse_PtgErr(blob) {
    blob.l++;
    return $3ee4f50b1ae43a89$var$BErr[blob.read_shift(1)];
}
/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */ function $3ee4f50b1ae43a89$var$parse_PtgInt(blob) {
    blob.l++;
    return blob.read_shift(2);
}
/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */ function $3ee4f50b1ae43a89$var$parse_PtgBool(blob) {
    blob.l++;
    return blob.read_shift(1) !== 0;
}
/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */ function $3ee4f50b1ae43a89$var$parse_PtgNum(blob) {
    blob.l++;
    return $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
}
/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */ function $3ee4f50b1ae43a89$var$parse_PtgStr(blob, length, opts) {
    blob.l++;
    return $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, length - 1, opts);
}
/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */ /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */ function $3ee4f50b1ae43a89$var$parse_SerAr(blob, biff /*:number*/ ) {
    var val = [
        blob.read_shift(1)
    ];
    if (biff == 12) switch(val[0]){
        case 0x02:
            val[0] = 0x04;
            break; /* SerBool */ 
        case 0x04:
            val[0] = 0x10;
            break; /* SerErr */ 
        case 0x00:
            val[0] = 0x01;
            break; /* SerNum */ 
        case 0x01:
            val[0] = 0x02;
            break; /* SerStr */ 
    }
    switch(val[0]){
        case 0x04:
            /* SerBool -- boolean */ val[1] = $3ee4f50b1ae43a89$var$parsebool(blob, 1) ? "TRUE" : "FALSE";
            if (biff != 12) blob.l += 7;
            break;
        case 0x25:
        /* appears to be an alias */ case 0x10:
            /* SerErr -- error */ val[1] = $3ee4f50b1ae43a89$var$BErr[blob[blob.l]];
            blob.l += biff == 12 ? 4 : 8;
            break;
        case 0x00:
            /* SerNil -- honestly, I'm not sure how to reproduce this */ blob.l += 8;
            break;
        case 0x01:
            /* SerNum -- Xnum */ val[1] = $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
            break;
        case 0x02:
            /* SerStr -- XLUnicodeString (<256 chars) */ val[1] = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, 0, {
                biff: biff > 0 && biff < 8 ? 2 : biff
            });
            break;
        default:
            throw new Error("Bad SerAr: " + val[0]); /* Unreachable */ 
    }
    return val;
}
/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */ function $3ee4f50b1ae43a89$var$parse_PtgExtraMem(blob, cce, opts) {
    var count = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var out /*:Array<Range>*/  = [];
    for(var i = 0; i != count; ++i)out.push((opts.biff == 12 ? $3ee4f50b1ae43a89$var$parse_UncheckedRfX : $3ee4f50b1ae43a89$var$parse_Ref8U)(blob, 8));
    return out;
}
/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */ function $3ee4f50b1ae43a89$var$parse_PtgExtraArray(blob, length, opts) {
    var rows = 0, cols = 0;
    if (opts.biff == 12) {
        rows = blob.read_shift(4); // DRw
        cols = blob.read_shift(4); // DCol
    } else {
        cols = 1 + blob.read_shift(1); //DColByteU
        rows = 1 + blob.read_shift(2); //DRw
    }
    if (opts.biff >= 2 && opts.biff < 8) {
        --rows;
        if (--cols == 0) cols = 0x100;
    }
    // $FlowIgnore
    for(var i = 0, o /*:Array<Array<any>>*/  = []; i != rows && (o[i] = []); ++i)for(var j = 0; j != cols; ++j)o[i][j] = $3ee4f50b1ae43a89$var$parse_SerAr(blob, opts.biff);
    return o;
}
/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */ function $3ee4f50b1ae43a89$var$parse_PtgName(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var w = !opts || opts.biff >= 8 ? 4 : 2;
    var nameindex = blob.read_shift(w);
    switch(opts.biff){
        case 2:
            blob.l += 5;
            break;
        case 3:
        case 4:
            blob.l += 8;
            break;
        case 5:
            blob.l += 12;
            break;
    }
    return [
        type,
        0,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */ function $3ee4f50b1ae43a89$var$parse_PtgNameX(blob, length, opts) {
    if (opts.biff == 5) return $3ee4f50b1ae43a89$var$parse_PtgNameX_BIFF5(blob, length, opts);
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2); // XtiIndex
    var nameindex = blob.read_shift(4);
    return [
        type,
        ixti,
        nameindex
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgNameX_BIFF5(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2, "i"); // XtiIndex
    blob.l += 8;
    var nameindex = blob.read_shift(2);
    blob.l += 12;
    return [
        type,
        ixti,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */ function $3ee4f50b1ae43a89$var$parse_PtgMemArea(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */ function $3ee4f50b1ae43a89$var$parse_PtgMemFunc(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */ function $3ee4f50b1ae43a89$var$parse_PtgRefErr(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += 4;
    if (opts.biff < 8) blob.l--;
    if (opts.biff == 12) blob.l += 2;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */ function $3ee4f50b1ae43a89$var$parse_PtgRefErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 4;
    if (opts) switch(opts.biff){
        case 5:
            w = 15;
            break;
        case 12:
            w = 6;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */ var $3ee4f50b1ae43a89$var$parse_PtgMemErr = $3ee4f50b1ae43a89$var$parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */ var $3ee4f50b1ae43a89$var$parse_PtgMemNoMem = $3ee4f50b1ae43a89$var$parsenoop;
/* [MS-XLS] 2.5.198.92 */ var $3ee4f50b1ae43a89$var$parse_PtgTbl = $3ee4f50b1ae43a89$var$parsenoop;
function $3ee4f50b1ae43a89$var$parse_PtgElfLoc(blob, length, opts) {
    blob.l += 2;
    return [
        $3ee4f50b1ae43a89$var$parse_RgceElfLoc(blob, 4, opts)
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgElfNoop(blob /*::, length, opts*/ ) {
    blob.l += 6;
    return [];
}
/* [MS-XLS] 2.5.198.46 */ var $3ee4f50b1ae43a89$var$parse_PtgElfCol = $3ee4f50b1ae43a89$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */ var $3ee4f50b1ae43a89$var$parse_PtgElfColS = $3ee4f50b1ae43a89$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */ var $3ee4f50b1ae43a89$var$parse_PtgElfColSV = $3ee4f50b1ae43a89$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */ var $3ee4f50b1ae43a89$var$parse_PtgElfColV = $3ee4f50b1ae43a89$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */ function $3ee4f50b1ae43a89$var$parse_PtgElfLel(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        $3ee4f50b1ae43a89$var$parseuint16(blob),
        blob.read_shift(2) & 0x01
    ];
}
/* [MS-XLS] 2.5.198.51 */ var $3ee4f50b1ae43a89$var$parse_PtgElfRadical = $3ee4f50b1ae43a89$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */ var $3ee4f50b1ae43a89$var$parse_PtgElfRadicalLel = $3ee4f50b1ae43a89$var$parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */ var $3ee4f50b1ae43a89$var$parse_PtgElfRadicalS = $3ee4f50b1ae43a89$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */ var $3ee4f50b1ae43a89$var$parse_PtgElfRw = $3ee4f50b1ae43a89$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */ var $3ee4f50b1ae43a89$var$parse_PtgElfRwV = $3ee4f50b1ae43a89$var$parse_PtgElfLoc;
/* [MS-XLSB] 2.5.97.52 TODO */ var $3ee4f50b1ae43a89$var$PtgListRT = [
    "Data",
    "All",
    "Headers",
    "??",
    "?Data2",
    "??",
    "?DataHeaders",
    "??",
    "Totals",
    "??",
    "??",
    "??",
    "?DataTotals",
    "??",
    "??",
    "??",
    "?Current"
];
function $3ee4f50b1ae43a89$var$parse_PtgList(blob /*::, length, opts*/ ) {
    blob.l += 2;
    var ixti = blob.read_shift(2);
    var flags = blob.read_shift(2);
    var idx = blob.read_shift(4);
    var c = blob.read_shift(2);
    var C = blob.read_shift(2);
    var rt = $3ee4f50b1ae43a89$var$PtgListRT[flags >> 2 & 0x1F];
    return {
        ixti: ixti,
        coltype: flags & 0x3,
        rt: rt,
        idx: idx,
        c: c,
        C: C
    };
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */ function $3ee4f50b1ae43a89$var$parse_PtgSxName(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        blob.read_shift(4)
    ];
}
/* [XLS] old spec */ function $3ee4f50b1ae43a89$var$parse_PtgSheet(blob, length, opts) {
    blob.l += 5;
    blob.l += 2;
    blob.l += opts.biff == 2 ? 1 : 4;
    return [
        "PTGSHEET"
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgEndSheet(blob, length, opts) {
    blob.l += opts.biff == 2 ? 4 : 5;
    return [
        "PTGENDSHEET"
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgMemAreaN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgMemNoMemN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgAttrNoop(blob /*::, length, opts*/ ) {
    blob.l += 4;
    return [
        0,
        0
    ];
}
/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */ var $3ee4f50b1ae43a89$var$PtgTypes = {
    /*::[*/ 0x01: {
        n: "PtgExp",
        f: $3ee4f50b1ae43a89$var$parse_PtgExp
    },
    /*::[*/ 0x02: {
        n: "PtgTbl",
        f: $3ee4f50b1ae43a89$var$parse_PtgTbl
    },
    /*::[*/ 0x03: {
        n: "PtgAdd",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x04: {
        n: "PtgSub",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x05: {
        n: "PtgMul",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x06: {
        n: "PtgDiv",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x07: {
        n: "PtgPower",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x08: {
        n: "PtgConcat",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x09: {
        n: "PtgLt",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x0A: {
        n: "PtgLe",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x0B: {
        n: "PtgEq",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x0C: {
        n: "PtgGe",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x0D: {
        n: "PtgGt",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x0E: {
        n: "PtgNe",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x0F: {
        n: "PtgIsect",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x10: {
        n: "PtgUnion",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x11: {
        n: "PtgRange",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x12: {
        n: "PtgUplus",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x13: {
        n: "PtgUminus",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x14: {
        n: "PtgPercent",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x15: {
        n: "PtgParen",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x16: {
        n: "PtgMissArg",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x17: {
        n: "PtgStr",
        f: $3ee4f50b1ae43a89$var$parse_PtgStr
    },
    /*::[*/ 0x1A: {
        n: "PtgSheet",
        f: $3ee4f50b1ae43a89$var$parse_PtgSheet
    },
    /*::[*/ 0x1B: {
        n: "PtgEndSheet",
        f: $3ee4f50b1ae43a89$var$parse_PtgEndSheet
    },
    /*::[*/ 0x1C: {
        n: "PtgErr",
        f: $3ee4f50b1ae43a89$var$parse_PtgErr
    },
    /*::[*/ 0x1D: {
        n: "PtgBool",
        f: $3ee4f50b1ae43a89$var$parse_PtgBool
    },
    /*::[*/ 0x1E: {
        n: "PtgInt",
        f: $3ee4f50b1ae43a89$var$parse_PtgInt
    },
    /*::[*/ 0x1F: {
        n: "PtgNum",
        f: $3ee4f50b1ae43a89$var$parse_PtgNum
    },
    /*::[*/ 0x20: {
        n: "PtgArray",
        f: $3ee4f50b1ae43a89$var$parse_PtgArray
    },
    /*::[*/ 0x21: {
        n: "PtgFunc",
        f: $3ee4f50b1ae43a89$var$parse_PtgFunc
    },
    /*::[*/ 0x22: {
        n: "PtgFuncVar",
        f: $3ee4f50b1ae43a89$var$parse_PtgFuncVar
    },
    /*::[*/ 0x23: {
        n: "PtgName",
        f: $3ee4f50b1ae43a89$var$parse_PtgName
    },
    /*::[*/ 0x24: {
        n: "PtgRef",
        f: $3ee4f50b1ae43a89$var$parse_PtgRef
    },
    /*::[*/ 0x25: {
        n: "PtgArea",
        f: $3ee4f50b1ae43a89$var$parse_PtgArea
    },
    /*::[*/ 0x26: {
        n: "PtgMemArea",
        f: $3ee4f50b1ae43a89$var$parse_PtgMemArea
    },
    /*::[*/ 0x27: {
        n: "PtgMemErr",
        f: $3ee4f50b1ae43a89$var$parse_PtgMemErr
    },
    /*::[*/ 0x28: {
        n: "PtgMemNoMem",
        f: $3ee4f50b1ae43a89$var$parse_PtgMemNoMem
    },
    /*::[*/ 0x29: {
        n: "PtgMemFunc",
        f: $3ee4f50b1ae43a89$var$parse_PtgMemFunc
    },
    /*::[*/ 0x2A: {
        n: "PtgRefErr",
        f: $3ee4f50b1ae43a89$var$parse_PtgRefErr
    },
    /*::[*/ 0x2B: {
        n: "PtgAreaErr",
        f: $3ee4f50b1ae43a89$var$parse_PtgAreaErr
    },
    /*::[*/ 0x2C: {
        n: "PtgRefN",
        f: $3ee4f50b1ae43a89$var$parse_PtgRefN
    },
    /*::[*/ 0x2D: {
        n: "PtgAreaN",
        f: $3ee4f50b1ae43a89$var$parse_PtgAreaN
    },
    /*::[*/ 0x2E: {
        n: "PtgMemAreaN",
        f: $3ee4f50b1ae43a89$var$parse_PtgMemAreaN
    },
    /*::[*/ 0x2F: {
        n: "PtgMemNoMemN",
        f: $3ee4f50b1ae43a89$var$parse_PtgMemNoMemN
    },
    /*::[*/ 0x39: {
        n: "PtgNameX",
        f: $3ee4f50b1ae43a89$var$parse_PtgNameX
    },
    /*::[*/ 0x3A: {
        n: "PtgRef3d",
        f: $3ee4f50b1ae43a89$var$parse_PtgRef3d
    },
    /*::[*/ 0x3B: {
        n: "PtgArea3d",
        f: $3ee4f50b1ae43a89$var$parse_PtgArea3d
    },
    /*::[*/ 0x3C: {
        n: "PtgRefErr3d",
        f: $3ee4f50b1ae43a89$var$parse_PtgRefErr3d
    },
    /*::[*/ 0x3D: {
        n: "PtgAreaErr3d",
        f: $3ee4f50b1ae43a89$var$parse_PtgAreaErr3d
    },
    /*::[*/ 0xFF: {}
};
/* These are duplicated in the PtgTypes table */ var $3ee4f50b1ae43a89$var$PtgDupes = {
    /*::[*/ 0x40: 0x20,
    /*::[*/ 0x60: 0x20,
    /*::[*/ 0x41: 0x21,
    /*::[*/ 0x61: 0x21,
    /*::[*/ 0x42: 0x22,
    /*::[*/ 0x62: 0x22,
    /*::[*/ 0x43: 0x23,
    /*::[*/ 0x63: 0x23,
    /*::[*/ 0x44: 0x24,
    /*::[*/ 0x64: 0x24,
    /*::[*/ 0x45: 0x25,
    /*::[*/ 0x65: 0x25,
    /*::[*/ 0x46: 0x26,
    /*::[*/ 0x66: 0x26,
    /*::[*/ 0x47: 0x27,
    /*::[*/ 0x67: 0x27,
    /*::[*/ 0x48: 0x28,
    /*::[*/ 0x68: 0x28,
    /*::[*/ 0x49: 0x29,
    /*::[*/ 0x69: 0x29,
    /*::[*/ 0x4A: 0x2A,
    /*::[*/ 0x6A: 0x2A,
    /*::[*/ 0x4B: 0x2B,
    /*::[*/ 0x6B: 0x2B,
    /*::[*/ 0x4C: 0x2C,
    /*::[*/ 0x6C: 0x2C,
    /*::[*/ 0x4D: 0x2D,
    /*::[*/ 0x6D: 0x2D,
    /*::[*/ 0x4E: 0x2E,
    /*::[*/ 0x6E: 0x2E,
    /*::[*/ 0x4F: 0x2F,
    /*::[*/ 0x6F: 0x2F,
    /*::[*/ 0x58: 0x22,
    /*::[*/ 0x78: 0x22,
    /*::[*/ 0x59: 0x39,
    /*::[*/ 0x79: 0x39,
    /*::[*/ 0x5A: 0x3A,
    /*::[*/ 0x7A: 0x3A,
    /*::[*/ 0x5B: 0x3B,
    /*::[*/ 0x7B: 0x3B,
    /*::[*/ 0x5C: 0x3C,
    /*::[*/ 0x7C: 0x3C,
    /*::[*/ 0x5D: 0x3D,
    /*::[*/ 0x7D: 0x3D
};
var $3ee4f50b1ae43a89$var$Ptg18 = {
    /*::[*/ 0x01: {
        n: "PtgElfLel",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfLel
    },
    /*::[*/ 0x02: {
        n: "PtgElfRw",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfRw
    },
    /*::[*/ 0x03: {
        n: "PtgElfCol",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfCol
    },
    /*::[*/ 0x06: {
        n: "PtgElfRwV",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfRwV
    },
    /*::[*/ 0x07: {
        n: "PtgElfColV",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfColV
    },
    /*::[*/ 0x0A: {
        n: "PtgElfRadical",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfRadical
    },
    /*::[*/ 0x0B: {
        n: "PtgElfRadicalS",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfRadicalS
    },
    /*::[*/ 0x0D: {
        n: "PtgElfColS",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfColS
    },
    /*::[*/ 0x0F: {
        n: "PtgElfColSV",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfColSV
    },
    /*::[*/ 0x10: {
        n: "PtgElfRadicalLel",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfRadicalLel
    },
    /*::[*/ 0x19: {
        n: "PtgList",
        f: $3ee4f50b1ae43a89$var$parse_PtgList
    },
    /*::[*/ 0x1D: {
        n: "PtgSxName",
        f: $3ee4f50b1ae43a89$var$parse_PtgSxName
    },
    /*::[*/ 0xFF: {}
};
var $3ee4f50b1ae43a89$var$Ptg19 = {
    /*::[*/ 0x00: {
        n: "PtgAttrNoop",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrNoop
    },
    /*::[*/ 0x01: {
        n: "PtgAttrSemi",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrSemi
    },
    /*::[*/ 0x02: {
        n: "PtgAttrIf",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrIf
    },
    /*::[*/ 0x04: {
        n: "PtgAttrChoose",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrChoose
    },
    /*::[*/ 0x08: {
        n: "PtgAttrGoto",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrGoto
    },
    /*::[*/ 0x10: {
        n: "PtgAttrSum",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrSum
    },
    /*::[*/ 0x20: {
        n: "PtgAttrBaxcel",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrBaxcel
    },
    /*::[*/ 0x21: {
        n: "PtgAttrBaxcel",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrBaxcel
    },
    /*::[*/ 0x40: {
        n: "PtgAttrSpace",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrSpace
    },
    /*::[*/ 0x41: {
        n: "PtgAttrSpaceSemi",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrSpaceSemi
    },
    /*::[*/ 0x80: {
        n: "PtgAttrIfError",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrIfError
    },
    /*::[*/ 0xFF: {}
};
/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */ function $3ee4f50b1ae43a89$var$parse_RgbExtra(blob, length, rgce, opts) {
    if (opts.biff < 8) return $3ee4f50b1ae43a89$var$parsenoop(blob, length);
    var target = blob.l + length;
    var o = [];
    for(var i = 0; i !== rgce.length; ++i)switch(rgce[i][0]){
        case "PtgArray":
            /* PtgArray -> PtgExtraArray */ rgce[i][1] = $3ee4f50b1ae43a89$var$parse_PtgExtraArray(blob, 0, opts);
            o.push(rgce[i][1]);
            break;
        case "PtgMemArea":
            /* PtgMemArea -> PtgExtraMem */ rgce[i][2] = $3ee4f50b1ae43a89$var$parse_PtgExtraMem(blob, rgce[i][1], opts);
            o.push(rgce[i][2]);
            break;
        case "PtgExp":
            /* PtgExp -> PtgExtraCol */ if (opts && opts.biff == 12) {
                rgce[i][1][1] = blob.read_shift(4);
                o.push(rgce[i][1]);
            }
            break;
        case "PtgList":
        /* TODO: PtgList -> PtgExtraList */ case "PtgElfRadicalS":
        /* TODO: PtgElfRadicalS -> PtgExtraElf */ case "PtgElfColS":
        /* TODO: PtgElfColS -> PtgExtraElf */ case "PtgElfColSV":
            /* TODO: PtgElfColSV -> PtgExtraElf */ throw "Unsupported " + rgce[i][0];
        default:
            break;
    }
    length = target - blob.l;
    /* note: this is technically an error but Excel disregards */ //if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
    if (length !== 0) o.push($3ee4f50b1ae43a89$var$parsenoop(blob, length));
    return o;
}
/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */ function $3ee4f50b1ae43a89$var$parse_Rgce(blob, length, opts) {
    var target = blob.l + length;
    var R, id, ptgs = [];
    while(target != blob.l){
        length = target - blob.l;
        id = blob[blob.l];
        R = $3ee4f50b1ae43a89$var$PtgTypes[id] || $3ee4f50b1ae43a89$var$PtgTypes[$3ee4f50b1ae43a89$var$PtgDupes[id]];
        if (id === 0x18 || id === 0x19) R = (id === 0x18 ? $3ee4f50b1ae43a89$var$Ptg18 : $3ee4f50b1ae43a89$var$Ptg19)[blob[blob.l + 1]];
        if (!R || !R.f) $3ee4f50b1ae43a89$var$parsenoop(blob, length);
        else ptgs.push([
            R.n,
            R.f(blob, length, opts)
        ]);
    }
    return ptgs;
}
function $3ee4f50b1ae43a89$var$stringify_array(f /*:Array<Array<string>>*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < f.length; ++i){
        var x = f[i], r /*:Array<string>*/  = [];
        for(var j = 0; j < x.length; ++j){
            var y = x[j];
            if (y) switch(y[0]){
                // TODO: handle embedded quotes
                case 0x02:
                    /*:: if(typeof y[1] != 'string') throw "unreachable"; */ r.push('"' + y[1].replace(/"/g, '""') + '"');
                    break;
                default:
                    r.push(y[1]);
            }
            else r.push("");
        }
        o.push(r.join(","));
    }
    return o.join(";");
}
/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */ var $3ee4f50b1ae43a89$var$PtgBinOp = {
    PtgAdd: "+",
    PtgConcat: "&",
    PtgDiv: "/",
    PtgEq: "=",
    PtgGe: ">=",
    PtgGt: ">",
    PtgLe: "<=",
    PtgLt: "<",
    PtgMul: "*",
    PtgNe: "<>",
    PtgPower: "^",
    PtgSub: "-"
};
// List of invalid characters needs to be tested further
function $3ee4f50b1ae43a89$var$formula_quote_sheet_name(sname /*:string*/ , opts) /*:string*/ {
    if (!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
    if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname + "'";
    return sname;
}
function $3ee4f50b1ae43a89$var$get_ixti_raw(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    if (!supbooks) return "SH33TJSERR0";
    if (opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
    if (!supbooks.XTI) return "SH33TJSERR6";
    var XTI = supbooks.XTI[ixti];
    if (opts.biff < 8) {
        if (ixti > 10000) ixti -= 65536;
        if (ixti < 0) ixti = -ixti;
        return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
    }
    if (!XTI) return "SH33TJSERR1";
    var o = "";
    if (opts.biff > 8) switch(supbooks[XTI[0]][0]){
        case 0x0165:
            /* 'BrtSupSelf' */ o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x0166:
            /* 'BrtSupSame' */ if (opts.SID != null) return supbooks.SheetNames[opts.SID];
            return "SH33TJSSAME" + supbooks[XTI[0]][0];
        case 0x0163:
        /* 'BrtSupBookSrc' */ /* falls through */ default:
            return "SH33TJSSRC" + supbooks[XTI[0]][0];
    }
    switch(supbooks[XTI[0]][0][0]){
        case 0x0401:
            o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]] || "SH33TJSERR3";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x3A01:
            return supbooks[XTI[0]].slice(1).map(function(name) {
                return name.Name;
            }).join(";;"); //return "SH33TJSERR8";
        default:
            if (!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
            o = XTI[1] == -1 ? "#REF" : supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
    }
}
function $3ee4f50b1ae43a89$var$get_ixti(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    var ixtiraw = $3ee4f50b1ae43a89$var$get_ixti_raw(supbooks, ixti, opts);
    return ixtiraw == "#REF" ? ixtiraw : $3ee4f50b1ae43a89$var$formula_quote_sheet_name(ixtiraw, opts);
}
function $3ee4f50b1ae43a89$var$stringify_formula(formula /*Array<any>*/ , range, cell /*:any*/ , supbooks, opts) /*:string*/ {
    var biff = opts && opts.biff || 8;
    var _range = /*range != null ? range :*/ {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var stack /*:Array<string>*/  = [], e1, e2, /*::type,*/ c /*:CellAddress*/ , ixti = 0, nameidx = 0, r, sname = "";
    if (!formula[0] || !formula[0][0]) return "";
    var last_sp = -1, sp = "";
    for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff){
        var f = formula[0][ff];
        switch(f[0]){
            case "PtgUminus":
                /* [MS-XLS] 2.5.198.93 */ stack.push("-" + stack.pop());
                break;
            case "PtgUplus":
                /* [MS-XLS] 2.5.198.95 */ stack.push("+" + stack.pop());
                break;
            case "PtgPercent":
                /* [MS-XLS] 2.5.198.81 */ stack.push(stack.pop() + "%");
                break;
            case "PtgAdd":
            /* [MS-XLS] 2.5.198.26 */ case "PtgConcat":
            /* [MS-XLS] 2.5.198.43 */ case "PtgDiv":
            /* [MS-XLS] 2.5.198.45 */ case "PtgEq":
            /* [MS-XLS] 2.5.198.56 */ case "PtgGe":
            /* [MS-XLS] 2.5.198.64 */ case "PtgGt":
            /* [MS-XLS] 2.5.198.65 */ case "PtgLe":
            /* [MS-XLS] 2.5.198.68 */ case "PtgLt":
            /* [MS-XLS] 2.5.198.69 */ case "PtgMul":
            /* [MS-XLS] 2.5.198.75 */ case "PtgNe":
            /* [MS-XLS] 2.5.198.78 */ case "PtgPower":
            /* [MS-XLS] 2.5.198.82 */ case "PtgSub":
                /* [MS-XLS] 2.5.198.90 */ e1 = stack.pop();
                e2 = stack.pop();
                if (last_sp >= 0) {
                    switch(formula[0][last_sp][1][0]){
                        case 0:
                            // $FlowIgnore
                            sp = $3ee4f50b1ae43a89$var$fill(" ", formula[0][last_sp][1][1]);
                            break;
                        case 1:
                            // $FlowIgnore
                            sp = $3ee4f50b1ae43a89$var$fill("\r", formula[0][last_sp][1][1]);
                            break;
                        default:
                            sp = "";
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    e2 = e2 + sp;
                    last_sp = -1;
                }
                stack.push(e2 + $3ee4f50b1ae43a89$var$PtgBinOp[f[0]] + e1);
                break;
            case "PtgIsect":
                /* [MS-XLS] 2.5.198.67 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + " " + e1);
                break;
            case "PtgUnion":
                /* [MS-XLS] 2.5.198.94 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + "," + e1);
                break;
            case "PtgRange":
                /* [MS-XLS] 2.5.198.83 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + ":" + e1);
                break;
            case "PtgAttrChoose":
                break;
            case "PtgAttrGoto":
                break;
            case "PtgAttrIf":
                break;
            case "PtgAttrIfError":
                break;
            case "PtgRef":
                /* [MS-XLS] 2.5.198.84 */ /*::type = f[1][0]; */ c = $3ee4f50b1ae43a89$var$shift_cell_xls(f[1][1], _range, opts);
                stack.push($3ee4f50b1ae43a89$var$encode_cell_xls(c, biff));
                break;
            case "PtgRefN":
                /* [MS-XLS] 2.5.198.88 */ /*::type = f[1][0]; */ c = cell ? $3ee4f50b1ae43a89$var$shift_cell_xls(f[1][1], cell, opts) : f[1][1];
                stack.push($3ee4f50b1ae43a89$var$encode_cell_xls(c, biff));
                break;
            case "PtgRef3d":
                /* [MS-XLS] 2.5.198.85 */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                c = $3ee4f50b1ae43a89$var$shift_cell_xls(f[1][2], _range, opts);
                sname = $3ee4f50b1ae43a89$var$get_ixti(supbooks, ixti, opts);
                var w = sname; /* IE9 fails on defined names */  // eslint-disable-line no-unused-vars
                stack.push(sname + "!" + $3ee4f50b1ae43a89$var$encode_cell_xls(c, biff));
                break;
            case "PtgFunc":
            /* [MS-XLS] 2.5.198.62 */ case "PtgFuncVar":
                /* [MS-XLS] 2.5.198.63 */ /* f[1] = [argc, func, type] */ var argc /*:number*/  = f[1][0], func /*:string*/  = f[1][1];
                if (!argc) argc = 0;
                argc &= 0x7F;
                var args = argc == 0 ? [] : stack.slice(-argc);
                stack.length -= argc;
                if (func === "User") func = args.shift();
                stack.push(func + "(" + args.join(",") + ")");
                break;
            case "PtgBool":
                /* [MS-XLS] 2.5.198.42 */ stack.push(f[1] ? "TRUE" : "FALSE");
                break;
            case "PtgInt":
                /* [MS-XLS] 2.5.198.66 */ stack.push(/*::String(*/ f[1]);
                break;
            case "PtgNum":
                /* [MS-XLS] 2.5.198.79 TODO: precision? */ stack.push(String(f[1]));
                break;
            case "PtgStr":
                /* [MS-XLS] 2.5.198.89 */ // $FlowIgnore
                stack.push('"' + f[1].replace(/"/g, '""') + '"');
                break;
            case "PtgErr":
                /* [MS-XLS] 2.5.198.57 */ stack.push(/*::String(*/ f[1]);
                break;
            case "PtgAreaN":
                /* [MS-XLS] 2.5.198.31 TODO */ /*::type = f[1][0]; */ r = $3ee4f50b1ae43a89$var$shift_range_xls(f[1][1], cell ? {
                    s: cell
                } : _range, opts);
                stack.push($3ee4f50b1ae43a89$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case "PtgArea":
                /* [MS-XLS] 2.5.198.27 TODO: fixed points */ /*::type = f[1][0]; */ r = $3ee4f50b1ae43a89$var$shift_range_xls(f[1][1], _range, opts);
                stack.push($3ee4f50b1ae43a89$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case "PtgArea3d":
                /* [MS-XLS] 2.5.198.28 TODO */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                r = f[1][2];
                sname = $3ee4f50b1ae43a89$var$get_ixti(supbooks, ixti, opts);
                stack.push(sname + "!" + $3ee4f50b1ae43a89$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case "PtgAttrSum":
                /* [MS-XLS] 2.5.198.41 */ stack.push("SUM(" + stack.pop() + ")");
                break;
            case "PtgAttrBaxcel":
            /* [MS-XLS] 2.5.198.33 */ case "PtgAttrSemi":
                break;
            case "PtgName":
                /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */ /* f[1] = type, 0, nameindex */ nameidx = f[1][2];
                var lbl = (supbooks.names || [])[nameidx - 1] || (supbooks[0] || [])[nameidx];
                var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
                /* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */ if (name && name.slice(0, 6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
                stack.push(name);
                break;
            case "PtgNameX":
                /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */ /* f[1] = type, ixti, nameindex */ var bookidx /*:number*/  = f[1][1];
                nameidx = f[1][2];
                var externbook;
                /* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */ if (opts.biff <= 5) {
                    if (bookidx < 0) bookidx = -bookidx;
                    if (supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
                } else {
                    var o = "";
                    if (((supbooks[bookidx] || [])[0] || [])[0] == 0x3A01) ;
                    else if (((supbooks[bookidx] || [])[0] || [])[0] == 0x0401) {
                        if (supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab - 1] + "!";
                    } else o = supbooks.SheetNames[nameidx - 1] + "!";
                    if (supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
                    else if (supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
                    else {
                        var ixtidata = ($3ee4f50b1ae43a89$var$get_ixti_raw(supbooks, bookidx, opts) || "").split(";;");
                        if (ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
                        else o += "SH33TJSERRX";
                    }
                    stack.push(o);
                    break;
                }
                if (!externbook) externbook = {
                    Name: "SH33TJSERRY"
                };
                stack.push(externbook.Name);
                break;
            case "PtgParen":
                /* [MS-XLS] 2.5.198.80 */ var lp = "(", rp = ")";
                if (last_sp >= 0) {
                    sp = "";
                    switch(formula[0][last_sp][1][0]){
                        // $FlowIgnore
                        case 2:
                            lp = $3ee4f50b1ae43a89$var$fill(" ", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 3:
                            lp = $3ee4f50b1ae43a89$var$fill("\r", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 4:
                            rp = $3ee4f50b1ae43a89$var$fill(" ", formula[0][last_sp][1][1]) + rp;
                            break;
                        // $FlowIgnore
                        case 5:
                            rp = $3ee4f50b1ae43a89$var$fill("\r", formula[0][last_sp][1][1]) + rp;
                            break;
                        default:
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    last_sp = -1;
                }
                stack.push(lp + stack.pop() + rp);
                break;
            case "PtgRefErr":
                /* [MS-XLS] 2.5.198.86 */ stack.push("#REF!");
                break;
            case "PtgRefErr3d":
                /* [MS-XLS] 2.5.198.87 */ stack.push("#REF!");
                break;
            case "PtgExp":
                /* [MS-XLS] 2.5.198.58 TODO */ c = {
                    c: f[1][1],
                    r: f[1][0]
                };
                var q = {
                    c: cell.c,
                    r: cell.r
                } /*:any*/ ;
                if (supbooks.sharedf[$3ee4f50b1ae43a89$var$encode_cell(c)]) {
                    var parsedf = supbooks.sharedf[$3ee4f50b1ae43a89$var$encode_cell(c)];
                    stack.push($3ee4f50b1ae43a89$var$stringify_formula(parsedf, _range, q, supbooks, opts));
                } else {
                    var fnd = false;
                    for(e1 = 0; e1 != supbooks.arrayf.length; ++e1){
                        /* TODO: should be something like range_has */ e2 = supbooks.arrayf[e1];
                        if (c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
                        if (c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
                        stack.push($3ee4f50b1ae43a89$var$stringify_formula(e2[1], _range, q, supbooks, opts));
                        fnd = true;
                        break;
                    }
                    if (!fnd) stack.push(/*::String(*/ f[1]);
                }
                break;
            case "PtgArray":
                /* [MS-XLS] 2.5.198.32 TODO */ stack.push("{" + $3ee4f50b1ae43a89$var$stringify_array(/*::(*/ f[1]) + "}");
                break;
            case "PtgMemArea":
                break;
            case "PtgAttrSpace":
            /* [MS-XLS] 2.5.198.38 */ case "PtgAttrSpaceSemi":
                /* [MS-XLS] 2.5.198.39 */ last_sp = ff;
                break;
            case "PtgTbl":
                break;
            case "PtgMemErr":
                break;
            case "PtgMissArg":
                /* [MS-XLS] 2.5.198.74 */ stack.push("");
                break;
            case "PtgAreaErr":
                /* [MS-XLS] 2.5.198.29 */ stack.push("#REF!");
                break;
            case "PtgAreaErr3d":
                /* [MS-XLS] 2.5.198.30 */ stack.push("#REF!");
                break;
            case "PtgList":
                /* [MS-XLSB] 2.5.97.52 */ // $FlowIgnore
                stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
                break;
            case "PtgMemAreaN":
            case "PtgMemNoMemN":
            case "PtgAttrNoop":
            case "PtgSheet":
            case "PtgEndSheet":
                break;
            case "PtgMemFunc":
                break;
            case "PtgMemNoMem":
                break;
            case "PtgElfCol":
            /* [MS-XLS] 2.5.198.46 */ case "PtgElfColS":
            /* [MS-XLS] 2.5.198.47 */ case "PtgElfColSV":
            /* [MS-XLS] 2.5.198.48 */ case "PtgElfColV":
            /* [MS-XLS] 2.5.198.49 */ case "PtgElfLel":
            /* [MS-XLS] 2.5.198.50 */ case "PtgElfRadical":
            /* [MS-XLS] 2.5.198.51 */ case "PtgElfRadicalLel":
            /* [MS-XLS] 2.5.198.52 */ case "PtgElfRadicalS":
            /* [MS-XLS] 2.5.198.53 */ case "PtgElfRw":
            /* [MS-XLS] 2.5.198.54 */ case "PtgElfRwV":
                /* [MS-XLS] 2.5.198.55 */ throw new Error("Unsupported ELFs");
            case "PtgSxName":
                /* [MS-XLS] 2.5.198.91 TODO -- find a test case */ throw new Error("Unrecognized Formula Token: " + String(f));
            default:
                throw new Error("Unrecognized Formula Token: " + String(f));
        }
        var PtgNonDisp = [
            "PtgAttrSpace",
            "PtgAttrSpaceSemi",
            "PtgAttrGoto"
        ];
        if (opts.biff != 3) {
            if (last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
                f = formula[0][last_sp];
                var _left = true;
                switch(f[1][0]){
                    /* note: some bad XLSB files omit the PtgParen */ case 4:
                        _left = false;
                    /* falls through */ case 0:
                        // $FlowIgnore
                        sp = $3ee4f50b1ae43a89$var$fill(" ", f[1][1]);
                        break;
                    case 5:
                        _left = false;
                    /* falls through */ case 1:
                        // $FlowIgnore
                        sp = $3ee4f50b1ae43a89$var$fill("\r", f[1][1]);
                        break;
                    default:
                        sp = "";
                        // $FlowIgnore
                        if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
                }
                stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
                last_sp = -1;
            }
        }
    }
    if (stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
    return stack[0];
}
/* [MS-XLS] 2.5.198.1 TODO */ function $3ee4f50b1ae43a89$var$parse_ArrayParsedFormula(blob, length, opts /*::, ref*/ ) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $3ee4f50b1ae43a89$var$parsenoop(blob, length - 2)
    ];
    var rgce = $3ee4f50b1ae43a89$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $3ee4f50b1ae43a89$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.3 TODO */ function $3ee4f50b1ae43a89$var$parse_XLSCellParsedFormula(blob, length, opts) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $3ee4f50b1ae43a89$var$parsenoop(blob, length - 2)
    ];
    var rgce = $3ee4f50b1ae43a89$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $3ee4f50b1ae43a89$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.21 */ function $3ee4f50b1ae43a89$var$parse_NameParsedFormula(blob, length, opts, cce) {
    var target = blob.l + length;
    var rgce = $3ee4f50b1ae43a89$var$parse_Rgce(blob, cce, opts);
    var rgcb;
    if (target !== blob.l) rgcb = $3ee4f50b1ae43a89$var$parse_RgbExtra(blob, target - blob.l, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.118 TODO */ function $3ee4f50b1ae43a89$var$parse_SharedParsedFormula(blob, length, opts) {
    var target = blob.l + length;
    var rgcb, cce = blob.read_shift(2); // length of rgce
    var rgce = $3ee4f50b1ae43a89$var$parse_Rgce(blob, cce, opts);
    if (cce == 0xFFFF) return [
        [],
        $3ee4f50b1ae43a89$var$parsenoop(blob, length - 2)
    ];
    if (length !== cce + 2) rgcb = $3ee4f50b1ae43a89$var$parse_RgbExtra(blob, target - cce - 2, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */ function $3ee4f50b1ae43a89$var$parse_FormulaValue(blob /*::, length*/ ) {
    var b;
    if ($3ee4f50b1ae43a89$var$__readUInt16LE(blob, blob.l + 6) !== 0xFFFF) return [
        $3ee4f50b1ae43a89$var$parse_Xnum(blob),
        "n"
    ];
    switch(blob[blob.l]){
        case 0x00:
            blob.l += 8;
            return [
                "String",
                "s"
            ];
        case 0x01:
            b = blob[blob.l + 2] === 0x1;
            blob.l += 8;
            return [
                b,
                "b"
            ];
        case 0x02:
            b = blob[blob.l + 2];
            blob.l += 8;
            return [
                b,
                "e"
            ];
        case 0x03:
            blob.l += 8;
            return [
                "",
                "s"
            ];
    }
    return [];
}
function $3ee4f50b1ae43a89$var$write_FormulaValue(value) {
    if (value == null) {
        // Blank String Value
        var o = $3ee4f50b1ae43a89$var$new_buf(8);
        o.write_shift(1, 0x03);
        o.write_shift(1, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0xFFFF);
        return o;
    } else if (typeof value == "number") return $3ee4f50b1ae43a89$var$write_Xnum(value);
    return $3ee4f50b1ae43a89$var$write_Xnum(0);
}
/* [MS-XLS] 2.4.127 TODO */ function $3ee4f50b1ae43a89$var$parse_Formula(blob, length, opts) {
    var end = blob.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2) ++blob.l;
    var val = $3ee4f50b1ae43a89$var$parse_FormulaValue(blob, 8);
    var flags = blob.read_shift(1);
    if (opts.biff != 2) {
        blob.read_shift(1);
        if (opts.biff >= 5) /*var chn = */ blob.read_shift(4);
    }
    var cbf = $3ee4f50b1ae43a89$var$parse_XLSCellParsedFormula(blob, end - blob.l, opts);
    return {
        cell: cell,
        val: val[0],
        formula: cbf,
        shared: flags >> 3 & 1,
        tt: val[1]
    };
}
function $3ee4f50b1ae43a89$var$write_Formula(cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, os /*:number*/ ) {
    // Cell
    var o1 = $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os);
    // FormulaValue
    var o2 = $3ee4f50b1ae43a89$var$write_FormulaValue(cell.v);
    // flags + cache
    var o3 = $3ee4f50b1ae43a89$var$new_buf(6);
    var flags = 33;
    o3.write_shift(2, flags);
    o3.write_shift(4, 0);
    // CellParsedFormula
    var bf = $3ee4f50b1ae43a89$var$new_buf(cell.bf.length);
    for(var i = 0; i < cell.bf.length; ++i)bf[i] = cell.bf[i];
    var out = $3ee4f50b1ae43a89$var$bconcat([
        o1,
        o2,
        o3,
        bf
    ]);
    return out;
}
/* XLSB Parsed Formula records have the same shape */ function $3ee4f50b1ae43a89$var$parse_XLSBParsedFormula(data, length, opts) {
    var cce = data.read_shift(4);
    var rgce = $3ee4f50b1ae43a89$var$parse_Rgce(data, cce, opts);
    var cb = data.read_shift(4);
    var rgcb = cb > 0 ? $3ee4f50b1ae43a89$var$parse_RgbExtra(data, cb, rgce, opts) : null;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */ var $3ee4f50b1ae43a89$var$parse_XLSBArrayParsedFormula = $3ee4f50b1ae43a89$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */ var $3ee4f50b1ae43a89$var$parse_XLSBCellParsedFormula = $3ee4f50b1ae43a89$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.8 DVParsedFormula */ //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */ //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */ var $3ee4f50b1ae43a89$var$parse_XLSBNameParsedFormula = $3ee4f50b1ae43a89$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */ var $3ee4f50b1ae43a89$var$parse_XLSBSharedParsedFormula = $3ee4f50b1ae43a89$var$parse_XLSBParsedFormula;
var $3ee4f50b1ae43a89$var$Cetab = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS"
};
var $3ee4f50b1ae43a89$var$Ftab = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "CONVERT",
    724: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS"
};
var $3ee4f50b1ae43a89$var$FtabArgc = {
    2: 1,
    3: 1,
    10: 0,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    34: 0,
    35: 0,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    63: 0,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    74: 0,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    89: 0,
    90: 1,
    94: 0,
    95: 0,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    106: 1,
    108: 2,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    161: 1,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    186: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    225: 0,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0
};
/* Part 3 TODO: actually parse formulae */ function $3ee4f50b1ae43a89$var$ods_to_csf_formula(f /*:string*/ ) /*:string*/ {
    if (f.slice(0, 3) == "of:") f = f.slice(3);
    /* 5.2 Basic Expressions */ if (f.charCodeAt(0) == 61) {
        f = f.slice(1);
        if (f.charCodeAt(0) == 61) f = f.slice(1);
    }
    f = f.replace(/COM\.MICROSOFT\./g, "");
    /* Part 3 Section 5.8 References */ f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) {
        return $1.replace(/\./g, "");
    });
    /* TODO: something other than this */ f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
    return f.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function $3ee4f50b1ae43a89$var$csf_to_ods_formula(f /*:string*/ ) /*:string*/ {
    var o = "of:=" + f.replace($3ee4f50b1ae43a89$var$crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
    /* TODO: something other than this */ return o.replace(/;/g, "|").replace(/,/g, ";");
}
function $3ee4f50b1ae43a89$var$ods_to_csf_3D(r /*:string*/ ) /*:[string, string]*/ {
    var a = r.split(":");
    var s = a[0].split(".")[0];
    return [
        s,
        a[0].split(".")[1] + (a.length > 1 ? ":" + (a[1].split(".")[1] || a[1].split(".")[0]) : "")
    ];
}
function $3ee4f50b1ae43a89$var$csf_to_ods_3D(r /*:string*/ ) /*:string*/ {
    return r.replace(/\./, "!");
}
var $3ee4f50b1ae43a89$var$strs = {}; // shared strings
var $3ee4f50b1ae43a89$var$_ssfopts = {}; // spreadsheet formatting options
/*global Map */ var $3ee4f50b1ae43a89$var$browser_has_Map = typeof Map !== "undefined";
function $3ee4f50b1ae43a89$var$get_sst_id(sst /*:SST*/ , str /*:string*/ , rev) /*:number*/ {
    var i = 0, len = sst.length;
    if (rev) {
        if ($3ee4f50b1ae43a89$var$browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
            var revarr = $3ee4f50b1ae43a89$var$browser_has_Map ? rev.get(str) : rev[str];
            for(; i < revarr.length; ++i)if (sst[revarr[i]].t === str) {
                sst.Count++;
                return revarr[i];
            }
        }
    } else for(; i < len; ++i)if (sst[i].t === str) {
        sst.Count++;
        return i;
    }
    sst[len] = {
        t: str
    } /*:any*/ ;
    sst.Count++;
    sst.Unique++;
    if (rev) {
        if ($3ee4f50b1ae43a89$var$browser_has_Map) {
            if (!rev.has(str)) rev.set(str, []);
            rev.get(str).push(len);
        } else {
            if (!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
            rev[str].push(len);
        }
    }
    return len;
}
function $3ee4f50b1ae43a89$var$col_obj_w(C /*:number*/ , col) {
    var p = {
        min: C + 1,
        max: C + 1
    } /*:any*/ ;
    /* wch (chars), wpx (pixels) */ var wch = -1;
    if (col.MDW) $3ee4f50b1ae43a89$var$MDW = col.MDW;
    if (col.width != null) p.customWidth = 1;
    else if (col.wpx != null) wch = $3ee4f50b1ae43a89$var$px2char(col.wpx);
    else if (col.wch != null) wch = col.wch;
    if (wch > -1) {
        p.width = $3ee4f50b1ae43a89$var$char2width(wch);
        p.customWidth = 1;
    } else if (col.width != null) p.width = col.width;
    if (col.hidden) p.hidden = true;
    if (col.level != null) p.outlineLevel = p.level = col.level;
    return p;
}
function $3ee4f50b1ae43a89$var$default_margins(margins /*:Margins*/ , mode /*:?string*/ ) {
    if (!margins) return;
    var defs = [
        0.7,
        0.7,
        0.75,
        0.75,
        0.3,
        0.3
    ];
    if (mode == "xlml") defs = [
        1,
        1,
        1,
        1,
        0.5,
        0.5
    ];
    if (margins.left == null) margins.left = defs[0];
    if (margins.right == null) margins.right = defs[1];
    if (margins.top == null) margins.top = defs[2];
    if (margins.bottom == null) margins.bottom = defs[3];
    if (margins.header == null) margins.header = defs[4];
    if (margins.footer == null) margins.footer = defs[5];
}
function $3ee4f50b1ae43a89$var$get_cell_style(styles /*:Array<any>*/ , cell /*:Cell*/ , opts) {
    var z = opts.revssf[cell.z != null ? cell.z : "General"];
    var i = 0x3c, len = styles.length;
    if (z == null && opts.ssf) {
        for(; i < 0x188; ++i)if (opts.ssf[i] == null) {
            $3ee4f50b1ae43a89$var$SSF_load(cell.z, i);
            // $FlowIgnore
            opts.ssf[i] = cell.z;
            opts.revssf[cell.z] = z = i;
            break;
        }
    }
    for(i = 0; i != len; ++i)if (styles[i].numFmtId === z) return i;
    styles[len] = {
        numFmtId: z,
        fontId: 0,
        fillId: 0,
        borderId: 0,
        xfId: 0,
        applyNumberFormat: 1
    };
    return len;
}
function $3ee4f50b1ae43a89$var$safe_format(p /*:Cell*/ , fmtid /*:number*/ , fillid /*:?number*/ , opts, themes, styles) {
    try {
        if (opts.cellNF) p.z = $3ee4f50b1ae43a89$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (p.t === "z" && !opts.cellStyles) return;
    if (p.t === "d" && typeof p.v === "string") p.v = $3ee4f50b1ae43a89$var$parseDate(p.v);
    if ((!opts || opts.cellText !== false) && p.t !== "z") try {
        if ($3ee4f50b1ae43a89$var$table_fmt[fmtid] == null) $3ee4f50b1ae43a89$var$SSF_load($3ee4f50b1ae43a89$var$SSFImplicit[fmtid] || "General", fmtid);
        if (p.t === "e") p.w = p.w || $3ee4f50b1ae43a89$var$BErr[p.v];
        else if (fmtid === 0) {
            if (p.t === "n") {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $3ee4f50b1ae43a89$var$SSF_general_num(p.v);
            } else if (p.t === "d") {
                var dd = $3ee4f50b1ae43a89$var$datenum(p.v);
                if ((dd | 0) === dd) p.w = dd.toString(10);
                else p.w = $3ee4f50b1ae43a89$var$SSF_general_num(dd);
            } else if (p.v === undefined) return "";
            else p.w = $3ee4f50b1ae43a89$var$SSF_general(p.v, $3ee4f50b1ae43a89$var$_ssfopts);
        } else if (p.t === "d") p.w = $3ee4f50b1ae43a89$var$SSF_format(fmtid, $3ee4f50b1ae43a89$var$datenum(p.v), $3ee4f50b1ae43a89$var$_ssfopts);
        else p.w = $3ee4f50b1ae43a89$var$SSF_format(fmtid, p.v, $3ee4f50b1ae43a89$var$_ssfopts);
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts.cellStyles) return;
    if (fillid != null) try {
        p.s = styles.Fills[fillid];
        if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
            p.s.fgColor.rgb = $3ee4f50b1ae43a89$var$rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
            if (opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
        }
        if (p.s.bgColor && p.s.bgColor.theme) {
            p.s.bgColor.rgb = $3ee4f50b1ae43a89$var$rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
            if (opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
        }
    } catch (e) {
        if (opts.WTF && styles.Fills) throw e;
    }
}
function $3ee4f50b1ae43a89$var$check_ws(ws /*:Worksheet*/ , sname /*:string*/ , i /*:number*/ ) {
    if (ws && ws["!ref"]) {
        var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]);
        if (range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws["!ref"]);
    }
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_dim(ws /*:Worksheet*/ , s /*:string*/ ) {
    var d = $3ee4f50b1ae43a89$var$safe_decode_range(s);
    if (d.s.r <= d.e.r && d.s.c <= d.e.c && d.s.r >= 0 && d.s.c >= 0) ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(d);
}
var $3ee4f50b1ae43a89$var$mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
var $3ee4f50b1ae43a89$var$sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
var $3ee4f50b1ae43a89$var$hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
var $3ee4f50b1ae43a89$var$dimregex = /"(\w*:\w*)"/;
var $3ee4f50b1ae43a89$var$colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
var $3ee4f50b1ae43a89$var$afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
var $3ee4f50b1ae43a89$var$marginregex = /<(?:\w:)?pageMargins[^>]*\/>/g;
var $3ee4f50b1ae43a89$var$sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
var $3ee4f50b1ae43a89$var$sheetprregex2 = /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;
var $3ee4f50b1ae43a89$var$svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
/* 18.3 Worksheets */ function $3ee4f50b1ae43a89$var$parse_ws_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        "!id": {}
    };
    if ($3ee4f50b1ae43a89$var$DENSE != null && opts.dense == null) opts.dense = $3ee4f50b1ae43a89$var$DENSE;
    /* 18.3.1.99 worksheet CT_Worksheet */ var s = opts.dense ? [] : {} /*:any*/ ;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    } /*:any*/ ;
    var data1 = "", data2 = "";
    var mtch /*:?any*/  = data.match($3ee4f50b1ae43a89$var$sheetdataregex);
    if (mtch) {
        data1 = data.slice(0, mtch.index);
        data2 = data.slice(mtch.index + mtch[0].length);
    } else data1 = data2 = data;
    /* 18.3.1.82 sheetPr CT_SheetPr */ var sheetPr = data1.match($3ee4f50b1ae43a89$var$sheetprregex);
    if (sheetPr) $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    else if (sheetPr = data1.match($3ee4f50b1ae43a89$var$sheetprregex2)) $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1] || "", s, wb, idx, styles, themes);
    /* 18.3.1.35 dimension CT_SheetDimension */ var ridx = (data1.match(/<(?:\w*:)?dimension/) || {
        index: -1
    }).index;
    if (ridx > 0) {
        var ref = data1.slice(ridx, ridx + 50).match($3ee4f50b1ae43a89$var$dimregex);
        if (ref) $3ee4f50b1ae43a89$var$parse_ws_xml_dim(s, ref[1]);
    }
    /* 18.3.1.88 sheetViews CT_SheetViews */ var svs = data1.match($3ee4f50b1ae43a89$var$svsregex);
    if (svs && svs[1]) $3ee4f50b1ae43a89$var$parse_ws_xml_sheetviews(svs[1], wb);
    /* 18.3.1.17 cols CT_Cols */ var columns /*:Array<ColInfo>*/  = [];
    if (opts.cellStyles) {
        /* 18.3.1.13 col CT_Col */ var cols = data1.match($3ee4f50b1ae43a89$var$colregex);
        if (cols) $3ee4f50b1ae43a89$var$parse_ws_xml_cols(columns, cols);
    }
    /* 18.3.1.80 sheetData CT_SheetData ? */ if (mtch) $3ee4f50b1ae43a89$var$parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);
    /* 18.3.1.2  autoFilter CT_AutoFilter */ var afilter = data2.match($3ee4f50b1ae43a89$var$afregex);
    if (afilter) s["!autofilter"] = $3ee4f50b1ae43a89$var$parse_ws_xml_autofilter(afilter[0]);
    /* 18.3.1.55 mergeCells CT_MergeCells */ var merges /*:Array<Range>*/  = [];
    var _merge = data2.match($3ee4f50b1ae43a89$var$mergecregex);
    if (_merge) for(ridx = 0; ridx != _merge.length; ++ridx)merges[ridx] = $3ee4f50b1ae43a89$var$safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf('"') + 1));
    /* 18.3.1.48 hyperlinks CT_Hyperlinks */ var hlink = data2.match($3ee4f50b1ae43a89$var$hlinkregex);
    if (hlink) $3ee4f50b1ae43a89$var$parse_ws_xml_hlinks(s, hlink, rels);
    /* 18.3.1.62 pageMargins CT_PageMargins */ var margins = data2.match($3ee4f50b1ae43a89$var$marginregex);
    if (margins) s["!margins"] = $3ee4f50b1ae43a89$var$parse_ws_xml_margins($3ee4f50b1ae43a89$var$parsexmltag(margins[0]));
    if (!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
    if (opts.sheetRows > 0 && s["!ref"]) {
        var tmpref = $3ee4f50b1ae43a89$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(tmpref);
        }
    }
    if (columns.length > 0) s["!cols"] = columns;
    if (merges.length > 0) s["!merges"] = merges;
    return s;
}
function $3ee4f50b1ae43a89$var$write_ws_xml_merges(merges /*:Array<Range>*/ ) /*:string*/ {
    if (merges.length === 0) return "";
    var o = '<mergeCells count="' + merges.length + '">';
    for(var i = 0; i != merges.length; ++i)o += '<mergeCell ref="' + $3ee4f50b1ae43a89$var$encode_range(merges[i]) + '"/>';
    return o + "</mergeCells>";
}
/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */ function $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr(sheetPr /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    var data = $3ee4f50b1ae43a89$var$parsexmltag(sheetPr);
    if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
    if (data.codeName) wb.Sheets[idx].CodeName = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(data.codeName));
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr2(sheetPr /*:string*/ , body /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
}
function $3ee4f50b1ae43a89$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
    var needed = false;
    var props = {}, payload = null;
    if (opts.bookType !== "xlsx" && wb.vbaraw) {
        var cname = wb.SheetNames[idx];
        try {
            if (wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname;
        } catch (e) {}
        needed = true;
        props.codeName = $3ee4f50b1ae43a89$var$utf8write($3ee4f50b1ae43a89$var$escapexml(cname));
    }
    if (ws && ws["!outline"]) {
        var outlineprops = {
            summaryBelow: 1,
            summaryRight: 1
        };
        if (ws["!outline"].above) outlineprops.summaryBelow = 0;
        if (ws["!outline"].left) outlineprops.summaryRight = 0;
        payload = (payload || "") + $3ee4f50b1ae43a89$var$writextag("outlinePr", null, outlineprops);
    }
    if (!needed && !payload) return;
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("sheetPr", payload, props);
}
/* 18.3.1.85 sheetProtection CT_SheetProtection */ var $3ee4f50b1ae43a89$var$sheetprot_deffalse = [
    "objects",
    "scenarios",
    "selectLockedCells",
    "selectUnlockedCells"
];
var $3ee4f50b1ae43a89$var$sheetprot_deftrue = [
    "formatColumns",
    "formatRows",
    "formatCells",
    "insertColumns",
    "insertRows",
    "insertHyperlinks",
    "deleteColumns",
    "deleteRows",
    "sort",
    "autoFilter",
    "pivotTables"
];
function $3ee4f50b1ae43a89$var$write_ws_xml_protection(sp) /*:string*/ {
    // algorithmName, hashValue, saltValue, spinCount
    var o = {
        sheet: 1
    } /*:any*/ ;
    $3ee4f50b1ae43a89$var$sheetprot_deffalse.forEach(function(n) {
        if (sp[n] != null && sp[n]) o[n] = "1";
    });
    $3ee4f50b1ae43a89$var$sheetprot_deftrue.forEach(function(n) {
        if (sp[n] != null && !sp[n]) o[n] = "0";
    });
    /* TODO: algorithm */ if (sp.password) o.password = $3ee4f50b1ae43a89$var$crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
    return $3ee4f50b1ae43a89$var$writextag("sheetProtection", null, o);
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_hlinks(s, data /*:Array<string>*/ , rels) {
    var dense = Array.isArray(s);
    for(var i = 0; i != data.length; ++i){
        var val = $3ee4f50b1ae43a89$var$parsexmltag($3ee4f50b1ae43a89$var$utf8read(data[i]), true);
        if (!val.ref) return;
        var rel = ((rels || {})["!id"] || [])[val.id];
        if (rel) {
            val.Target = rel.Target;
            if (val.location) val.Target += "#" + $3ee4f50b1ae43a89$var$unescapexml(val.location);
        } else {
            val.Target = "#" + $3ee4f50b1ae43a89$var$unescapexml(val.location);
            rel = {
                Target: val.Target,
                TargetMode: "Internal"
            };
        }
        val.Rel = rel;
        if (val.tooltip) {
            val.Tooltip = val.tooltip;
            delete val.tooltip;
        }
        var rng = $3ee4f50b1ae43a89$var$safe_decode_range(val.ref);
        for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
            var addr = $3ee4f50b1ae43a89$var$encode_cell({
                c: C,
                r: R
            });
            if (dense) {
                if (!s[R]) s[R] = [];
                if (!s[R][C]) s[R][C] = {
                    t: "z",
                    v: undefined
                };
                s[R][C].l = val;
            } else {
                if (!s[addr]) s[addr] = {
                    t: "z",
                    v: undefined
                };
                s[addr].l = val;
            }
        }
    }
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_margins(margin) {
    var o = {};
    [
        "left",
        "right",
        "top",
        "bottom",
        "header",
        "footer"
    ].forEach(function(k) {
        if (margin[k]) o[k] = parseFloat(margin[k]);
    });
    return o;
}
function $3ee4f50b1ae43a89$var$write_ws_xml_margins(margin) /*:string*/ {
    $3ee4f50b1ae43a89$var$default_margins(margin);
    return $3ee4f50b1ae43a89$var$writextag("pageMargins", null, margin);
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_cols(columns, cols) {
    var seencol = false;
    for(var coli = 0; coli != cols.length; ++coli){
        var coll = $3ee4f50b1ae43a89$var$parsexmltag(cols[coli], true);
        if (coll.hidden) coll.hidden = $3ee4f50b1ae43a89$var$parsexmlbool(coll.hidden);
        var colm = parseInt(coll.min, 10) - 1, colM = parseInt(coll.max, 10) - 1;
        if (coll.outlineLevel) coll.level = +coll.outlineLevel || 0;
        delete coll.min;
        delete coll.max;
        coll.width = +coll.width;
        if (!seencol && coll.width) {
            seencol = true;
            $3ee4f50b1ae43a89$var$find_mdw_colw(coll.width);
        }
        $3ee4f50b1ae43a89$var$process_col(coll);
        while(colm <= colM)columns[colm++] = $3ee4f50b1ae43a89$var$dup(coll);
    }
}
function $3ee4f50b1ae43a89$var$write_ws_xml_cols(ws, cols) /*:string*/ {
    var o = [
        "<cols>"
    ], col;
    for(var i = 0; i != cols.length; ++i){
        if (!(col = cols[i])) continue;
        o[o.length] = $3ee4f50b1ae43a89$var$writextag("col", null, $3ee4f50b1ae43a89$var$col_obj_w(i, col));
    }
    o[o.length] = "</cols>";
    return o.join("");
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_autofilter(data /*:string*/ ) {
    var o = {
        ref: (data.match(/ref="([^"]*)"/) || [])[1]
    };
    return o;
}
function $3ee4f50b1ae43a89$var$write_ws_xml_autofilter(data, ws, wb, idx) /*:string*/ {
    var ref = typeof data.ref == "string" ? data.ref : $3ee4f50b1ae43a89$var$encode_range(data.ref);
    if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $3ee4f50b1ae43a89$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]).e.r;
        ref = $3ee4f50b1ae43a89$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != "_xlnm._FilterDatabase") continue;
        if (name.Sheet != idx) continue;
        name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref;
        break;
    }
    if (i == names.length) names.push({
        Name: "_xlnm._FilterDatabase",
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    return $3ee4f50b1ae43a89$var$writextag("autoFilter", null, {
        ref: ref
    });
}
/* 18.3.1.88 sheetViews CT_SheetViews */ /* 18.3.1.87 sheetView CT_SheetView */ var $3ee4f50b1ae43a89$var$sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
function $3ee4f50b1ae43a89$var$parse_ws_xml_sheetviews(data, wb /*:WBWBProps*/ ) {
    if (!wb.Views) wb.Views = [
        {}
    ];
    (data.match($3ee4f50b1ae43a89$var$sviewregex) || []).forEach(function(r /*:string*/ , i /*:number*/ ) {
        var tag = $3ee4f50b1ae43a89$var$parsexmltag(r);
        // $FlowIgnore
        if (!wb.Views[i]) wb.Views[i] = {};
        // $FlowIgnore
        if (+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
        // $FlowIgnore
        if ($3ee4f50b1ae43a89$var$parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
    });
}
function $3ee4f50b1ae43a89$var$write_ws_xml_sheetviews(ws, opts, idx, wb) /*:string*/ {
    var sview = {
        workbookViewId: "0"
    } /*:any*/ ;
    // $FlowIgnore
    if ((((wb || {}).Workbook || {}).Views || [])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
    return $3ee4f50b1ae43a89$var$writextag("sheetViews", $3ee4f50b1ae43a89$var$writextag("sheetView", null, sview), {});
}
function $3ee4f50b1ae43a89$var$write_ws_xml_cell(cell /*:Cell*/ , ref, ws, opts /*::, idx, wb*/ ) /*:string*/ {
    if (cell.c) ws["!comments"].push([
        ref,
        cell.c
    ]);
    if (cell.v === undefined && typeof cell.f !== "string" || cell.t === "z" && !cell.f) return "";
    var vv = "";
    var oldt = cell.t, oldv = cell.v;
    if (cell.t !== "z") switch(cell.t){
        case "b":
            vv = cell.v ? "1" : "0";
            break;
        case "n":
            vv = "" + cell.v;
            break;
        case "e":
            vv = $3ee4f50b1ae43a89$var$BErr[cell.v];
            break;
        case "d":
            if (opts && opts.cellDates) vv = $3ee4f50b1ae43a89$var$parseDate(cell.v, -1).toISOString();
            else {
                cell = $3ee4f50b1ae43a89$var$dup(cell);
                cell.t = "n";
                vv = "" + (cell.v = $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v)));
            }
            if (typeof cell.z === "undefined") cell.z = $3ee4f50b1ae43a89$var$table_fmt[14];
            break;
        default:
            vv = cell.v;
            break;
    }
    var v = $3ee4f50b1ae43a89$var$writetag("v", $3ee4f50b1ae43a89$var$escapexml(vv)), o = {
        r: ref
    } /*:any*/ ;
    /* TODO: cell style */ var os = $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, cell, opts);
    if (os !== 0) o.s = os;
    switch(cell.t){
        case "n":
            break;
        case "d":
            o.t = "d";
            break;
        case "b":
            o.t = "b";
            break;
        case "e":
            o.t = "e";
            break;
        case "z":
            break;
        default:
            if (cell.v == null) {
                delete cell.t;
                break;
            }
            if (cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
            if (opts && opts.bookSST) {
                v = $3ee4f50b1ae43a89$var$writetag("v", "" + $3ee4f50b1ae43a89$var$get_sst_id(opts.Strings, cell.v, opts.revStrings));
                o.t = "s";
                break;
            }
            o.t = "str";
            break;
    }
    if (cell.t != oldt) {
        cell.t = oldt;
        cell.v = oldv;
    }
    if (typeof cell.f == "string" && cell.f) {
        var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {
            t: "array",
            ref: cell.F
        } : null;
        v = $3ee4f50b1ae43a89$var$writextag("f", $3ee4f50b1ae43a89$var$escapexml(cell.f), ff) + (cell.v != null ? v : "");
    }
    if (cell.l) ws["!links"].push([
        ref,
        cell.l
    ]);
    if (cell.D) o.cm = 1;
    return $3ee4f50b1ae43a89$var$writextag("c", v, o);
}
var $3ee4f50b1ae43a89$var$parse_ws_xml_data = /*#__PURE__*/ function() {
    var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
    var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
    var refregex = /ref=["']([^"']*)["']/;
    var match_v = $3ee4f50b1ae43a89$var$matchtag("v"), match_f = $3ee4f50b1ae43a89$var$matchtag("f");
    return function parse_ws_xml_data(sdata /*:string*/ , s, opts, guess /*:Range*/ , themes, styles) {
        var ri = 0, x = "", cells /*:Array<string>*/  = [], cref /*:?Array<string>*/  = [], idx = 0, i = 0, cc = 0, d = "", p /*:any*/ ;
        var tag, tagr = 0, tagc = 0;
        var sstr, ftag;
        var fmtid = 0, fillid = 0;
        var do_format = Array.isArray(styles.CellXf), cf;
        var arrayf /*:Array<[Range, string]>*/  = [];
        var sharedf = [];
        var dense = Array.isArray(s);
        var rows /*:Array<RowInfo>*/  = [], rowobj = {}, rowrite = false;
        var sheetStubs = !!opts.sheetStubs;
        for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt){
            x = marr[mt].trim();
            var xlen = x.length;
            if (xlen === 0) continue;
            /* 18.3.1.73 row CT_Row */ var rstarti = 0;
            outa: for(ri = 0; ri < xlen; ++ri)switch(/*x.charCodeAt(ri)*/ x[ri]){
                case ">" /*62*/ :
                    if (/*x.charCodeAt(ri-1) != 47*/ x[ri - 1] != "/") {
                        ++ri;
                        break outa;
                    }
                    if (opts && opts.cellStyles) {
                        // TODO: avoid duplication
                        tag = $3ee4f50b1ae43a89$var$parsexmltag(x.slice(rstarti, ri), true);
                        tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
                        tagc = -1;
                        if (opts.sheetRows && opts.sheetRows < tagr) continue;
                        rowobj = {};
                        rowrite = false;
                        if (tag.ht) {
                            rowrite = true;
                            rowobj.hpt = parseFloat(tag.ht);
                            rowobj.hpx = $3ee4f50b1ae43a89$var$pt2px(rowobj.hpt);
                        }
                        if (tag.hidden == "1") {
                            rowrite = true;
                            rowobj.hidden = true;
                        }
                        if (tag.outlineLevel != null) {
                            rowrite = true;
                            rowobj.level = +tag.outlineLevel;
                        }
                        if (rowrite) rows[tagr - 1] = rowobj;
                    }
                    break;
                case "<" /*60*/ :
                    rstarti = ri;
                    break;
            }
            if (rstarti >= ri) break;
            tag = $3ee4f50b1ae43a89$var$parsexmltag(x.slice(rstarti, ri), true);
            tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
            tagc = -1;
            if (opts.sheetRows && opts.sheetRows < tagr) continue;
            if (guess.s.r > tagr - 1) guess.s.r = tagr - 1;
            if (guess.e.r < tagr - 1) guess.e.r = tagr - 1;
            if (opts && opts.cellStyles) {
                rowobj = {};
                rowrite = false;
                if (tag.ht) {
                    rowrite = true;
                    rowobj.hpt = parseFloat(tag.ht);
                    rowobj.hpx = $3ee4f50b1ae43a89$var$pt2px(rowobj.hpt);
                }
                if (tag.hidden == "1") {
                    rowrite = true;
                    rowobj.hidden = true;
                }
                if (tag.outlineLevel != null) {
                    rowrite = true;
                    rowobj.level = +tag.outlineLevel;
                }
                if (rowrite) rows[tagr - 1] = rowobj;
            }
            /* 18.3.1.4 c CT_Cell */ cells = x.slice(ri).split(cellregex);
            for(var rslice = 0; rslice != cells.length; ++rslice)if (cells[rslice].trim().charAt(0) != "<") break;
            cells = cells.slice(rslice);
            for(ri = 0; ri != cells.length; ++ri){
                x = cells[ri].trim();
                if (x.length === 0) continue;
                cref = x.match(rregex);
                idx = ri;
                i = 0;
                cc = 0;
                x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x;
                if (cref != null && cref.length === 2) {
                    idx = 0;
                    d = cref[1];
                    for(i = 0; i != d.length; ++i){
                        if ((cc = d.charCodeAt(i) - 64) < 1 || cc > 26) break;
                        idx = 26 * idx + cc;
                    }
                    --idx;
                    tagc = idx;
                } else ++tagc;
                for(i = 0; i != x.length; ++i)if (x.charCodeAt(i) === 62) break;
                ++i;
                tag = $3ee4f50b1ae43a89$var$parsexmltag(x.slice(0, i), true);
                if (!tag.r) tag.r = $3ee4f50b1ae43a89$var$encode_cell({
                    r: tagr - 1,
                    c: tagc
                });
                d = x.slice(i);
                p = {
                    t: ""
                } /*:any*/ ;
                if ((cref = d.match(match_v)) != null && /*::cref != null && */ cref[1] !== "") p.v = $3ee4f50b1ae43a89$var$unescapexml(cref[1]);
                if (opts.cellFormula) {
                    if ((cref = d.match(match_f)) != null && /*::cref != null && */ cref[1] !== "") {
                        /* TODO: match against XLSXFutureFunctions */ p.f = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(cref[1])).replace(/\r\n/g, "\n");
                        if (!opts.xlfn) p.f = $3ee4f50b1ae43a89$var$_xlfn(p.f);
                        if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="array"') > -1) {
                            p.F = (d.match(refregex) || [])[1];
                            if (p.F.indexOf(":") > -1) arrayf.push([
                                $3ee4f50b1ae43a89$var$safe_decode_range(p.F),
                                p.F
                            ]);
                        } else if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                            // TODO: parse formula
                            ftag = $3ee4f50b1ae43a89$var$parsexmltag(cref[0]);
                            var ___f = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(cref[1]));
                            if (!opts.xlfn) ___f = $3ee4f50b1ae43a89$var$_xlfn(___f);
                            sharedf[parseInt(ftag.si, 10)] = [
                                ftag,
                                ___f,
                                tag.r
                            ];
                        }
                    } else if (cref = d.match(/<f[^>]*\/>/)) {
                        ftag = $3ee4f50b1ae43a89$var$parsexmltag(cref[0]);
                        if (sharedf[ftag.si]) p.f = $3ee4f50b1ae43a89$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                    }
                    /* TODO: factor out contains logic */ var _tag = $3ee4f50b1ae43a89$var$decode_cell(tag.r);
                    for(i = 0; i < arrayf.length; ++i)if (_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r) {
                        if (_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c) p.F = arrayf[i][1];
                    }
                }
                if (tag.t == null && p.v === undefined) {
                    if (p.f || p.F) {
                        p.v = 0;
                        p.t = "n";
                    } else if (!sheetStubs) continue;
                    else p.t = "z";
                } else p.t = tag.t || "n";
                if (guess.s.c > tagc) guess.s.c = tagc;
                if (guess.e.c < tagc) guess.e.c = tagc;
                /* 18.18.11 t ST_CellType */ switch(p.t){
                    case "n":
                        if (p.v == "" || p.v == null) {
                            if (!sheetStubs) continue;
                            p.t = "z";
                        } else p.v = parseFloat(p.v);
                        break;
                    case "s":
                        if (typeof p.v == "undefined") {
                            if (!sheetStubs) continue;
                            p.t = "z";
                        } else {
                            sstr = $3ee4f50b1ae43a89$var$strs[parseInt(p.v, 10)];
                            p.v = sstr.t;
                            p.r = sstr.r;
                            if (opts.cellHTML) p.h = sstr.h;
                        }
                        break;
                    case "str":
                        p.t = "s";
                        p.v = p.v != null ? $3ee4f50b1ae43a89$var$utf8read(p.v) : "";
                        if (opts.cellHTML) p.h = $3ee4f50b1ae43a89$var$escapehtml(p.v);
                        break;
                    case "inlineStr":
                        cref = d.match(isregex);
                        p.t = "s";
                        if (cref != null && (sstr = $3ee4f50b1ae43a89$var$parse_si(cref[1]))) {
                            p.v = sstr.t;
                            if (opts.cellHTML) p.h = sstr.h;
                        } else p.v = "";
                        break;
                    case "b":
                        p.v = $3ee4f50b1ae43a89$var$parsexmlbool(p.v);
                        break;
                    case "d":
                        if (opts.cellDates) p.v = $3ee4f50b1ae43a89$var$parseDate(p.v, 1);
                        else {
                            p.v = $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(p.v, 1));
                            p.t = "n";
                        }
                        break;
                    /* error string in .w, number in .v */ case "e":
                        if (!opts || opts.cellText !== false) p.w = p.v;
                        p.v = $3ee4f50b1ae43a89$var$RBErr[p.v];
                        break;
                }
                /* formatting */ fmtid = fillid = 0;
                cf = null;
                if (do_format && tag.s !== undefined) {
                    cf = styles.CellXf[tag.s];
                    if (cf != null) {
                        if (cf.numFmtId != null) fmtid = cf.numFmtId;
                        if (opts.cellStyles) {
                            if (cf.fillId != null) fillid = cf.fillId;
                        }
                    }
                }
                $3ee4f50b1ae43a89$var$safe_format(p, fmtid, fillid, opts, themes, styles);
                if (opts.cellDates && do_format && p.t == "n" && $3ee4f50b1ae43a89$var$fmt_is_date($3ee4f50b1ae43a89$var$table_fmt[fmtid])) {
                    p.t = "d";
                    p.v = $3ee4f50b1ae43a89$var$numdate(p.v);
                }
                if (tag.cm && opts.xlmeta) {
                    var cm = (opts.xlmeta.Cell || [])[+tag.cm - 1];
                    if (cm && cm.type == "XLDAPR") p.D = true;
                }
                if (dense) {
                    var _r = $3ee4f50b1ae43a89$var$decode_cell(tag.r);
                    if (!s[_r.r]) s[_r.r] = [];
                    s[_r.r][_r.c] = p;
                } else s[tag.r] = p;
            }
        }
        if (rows.length > 0) s["!rows"] = rows;
    };
}();
function $3ee4f50b1ae43a89$var$write_ws_xml_data(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/  /*::, rels*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], r /*:Array<string>*/  = [], range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]), cell = "", ref, rr = "", cols /*:Array<string>*/  = [], R = 0, C = 0, rows = ws["!rows"];
    var dense = Array.isArray(ws);
    var params = {
        r: rr
    } /*:any*/ , row /*:RowInfo*/ , height = -1;
    for(C = range.s.c; C <= range.e.c; ++C)cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
    for(R = range.s.r; R <= range.e.r; ++R){
        r = [];
        rr = $3ee4f50b1ae43a89$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var _cell = dense ? (ws[R] || [])[C] : ws[ref];
            if (_cell === undefined) continue;
            if ((cell = $3ee4f50b1ae43a89$var$write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
        }
        if (r.length > 0 || rows && rows[R]) {
            params = {
                r: rr
            } /*:any*/ ;
            if (rows && rows[R]) {
                row = rows[R];
                if (row.hidden) params.hidden = 1;
                height = -1;
                if (row.hpx) height = $3ee4f50b1ae43a89$var$px2pt(row.hpx);
                else if (row.hpt) height = row.hpt;
                if (height > -1) {
                    params.ht = height;
                    params.customHeight = 1;
                }
                if (row.level) params.outlineLevel = row.level;
            }
            o[o.length] = $3ee4f50b1ae43a89$var$writextag("row", r.join(""), params);
        }
    }
    if (rows) {
        for(; R < rows.length; ++R)if (rows && rows[R]) {
            params = {
                r: R + 1
            } /*:any*/ ;
            row = rows[R];
            if (row.hidden) params.hidden = 1;
            height = -1;
            if (row.hpx) height = $3ee4f50b1ae43a89$var$px2pt(row.hpx);
            else if (row.hpt) height = row.hpt;
            if (height > -1) {
                params.ht = height;
                params.customHeight = 1;
            }
            if (row.level) params.outlineLevel = row.level;
            o[o.length] = $3ee4f50b1ae43a89$var$writextag("row", "", params);
        }
    }
    return o.join("");
}
function $3ee4f50b1ae43a89$var$write_ws_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("worksheet", null, {
            "xmlns": $3ee4f50b1ae43a89$var$XMLNS_main[0],
            "xmlns:r": $3ee4f50b1ae43a89$var$XMLNS.r
        })
    ];
    var s = wb.SheetNames[idx], sidx = 0, rdata = "";
    var ws = wb.Sheets[s];
    if (ws == null) ws = {};
    var ref = ws["!ref"] || "A1";
    var range = $3ee4f50b1ae43a89$var$safe_decode_range(ref);
    if (range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
        range.e.c = Math.min(range.e.c, 0x3FFF);
        range.e.r = Math.min(range.e.c, 0xFFFFF);
        ref = $3ee4f50b1ae43a89$var$encode_range(range);
    }
    if (!rels) rels = {};
    ws["!comments"] = [];
    var _drawing = [];
    $3ee4f50b1ae43a89$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o);
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("dimension", null, {
        "ref": ref
    });
    o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_sheetviews(ws, opts, idx, wb);
    /* TODO: store in WB, process styles */ if (opts.sheetFormat) o[o.length] = $3ee4f50b1ae43a89$var$writextag("sheetFormatPr", null, {
        defaultRowHeight: opts.sheetFormat.defaultRowHeight || "16",
        baseColWidth: opts.sheetFormat.baseColWidth || "10",
        outlineLevelRow: opts.sheetFormat.outlineLevelRow || "7"
    });
    if (ws["!cols"] != null && ws["!cols"].length > 0) o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_cols(ws, ws["!cols"]);
    o[sidx = o.length] = "<sheetData/>";
    ws["!links"] = [];
    if (ws["!ref"] != null) {
        rdata = $3ee4f50b1ae43a89$var$write_ws_xml_data(ws, opts, idx, wb, rels);
        if (rdata.length > 0) o[o.length] = rdata;
    }
    if (o.length > sidx + 1) {
        o[o.length] = "</sheetData>";
        o[sidx] = o[sidx].replace("/>", ">");
    }
    /* sheetCalcPr */ if (ws["!protect"]) o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_protection(ws["!protect"]);
    /* protectedRanges */ /* scenarios */ if (ws["!autofilter"] != null) o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_autofilter(ws["!autofilter"], ws, wb, idx);
    /* sortState */ /* dataConsolidate */ /* customSheetViews */ if (ws["!merges"] != null && ws["!merges"].length > 0) o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_merges(ws["!merges"]);
    /* phoneticPr */ /* conditionalFormatting */ /* dataValidations */ var relc = -1, rel, rId = -1;
    if (/*::(*/ ws["!links"]/*::||[])*/ .length > 0) {
        o[o.length] = "<hyperlinks>";
        /*::(*/ ws["!links"]/*::||[])*/ .forEach(function(l) {
            if (!l[1].Target) return;
            rel = {
                "ref": l[0]
            } /*:any*/ ;
            if (l[1].Target.charAt(0) != "#") {
                rId = $3ee4f50b1ae43a89$var$add_rels(rels, -1, $3ee4f50b1ae43a89$var$escapexml(l[1].Target).replace(/#.*$/, ""), $3ee4f50b1ae43a89$var$RELS.HLINK);
                rel["r:id"] = "rId" + rId;
            }
            if ((relc = l[1].Target.indexOf("#")) > -1) rel.location = $3ee4f50b1ae43a89$var$escapexml(l[1].Target.slice(relc + 1));
            if (l[1].Tooltip) rel.tooltip = $3ee4f50b1ae43a89$var$escapexml(l[1].Tooltip);
            o[o.length] = $3ee4f50b1ae43a89$var$writextag("hyperlink", null, rel);
        });
        o[o.length] = "</hyperlinks>";
    }
    delete ws["!links"];
    /* printOptions */ if (ws["!margins"] != null) o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_margins(ws["!margins"]);
    /* pageSetup */ /* headerFooter */ /* rowBreaks */ /* colBreaks */ /* customProperties */ /* cellWatches */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) o[o.length] = $3ee4f50b1ae43a89$var$writetag("ignoredErrors", $3ee4f50b1ae43a89$var$writextag("ignoredError", null, {
        numberStoredAsText: 1,
        sqref: ref
    }));
    /* smartTags */ if (_drawing.length > 0) {
        rId = $3ee4f50b1ae43a89$var$add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", $3ee4f50b1ae43a89$var$RELS.DRAW);
        o[o.length] = $3ee4f50b1ae43a89$var$writextag("drawing", null, {
            "r:id": "rId" + rId
        });
        ws["!drawing"] = _drawing;
    }
    if (ws["!comments"].length > 0) {
        rId = $3ee4f50b1ae43a89$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $3ee4f50b1ae43a89$var$RELS.VML);
        o[o.length] = $3ee4f50b1ae43a89$var$writextag("legacyDrawing", null, {
            "r:id": "rId" + rId
        });
        ws["!legacy"] = rId;
    }
    /* legacyDrawingHF */ /* picture */ /* oleObjects */ /* controls */ /* webPublishItems */ /* tableParts */ /* extLst */ if (o.length > 1) {
        o[o.length] = "</worksheet>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.726 BrtRowHdr */ function $3ee4f50b1ae43a89$var$parse_BrtRowHdr(data, length) {
    var z = {} /*:any*/ ;
    var tgt = data.l + length;
    z.r = data.read_shift(4);
    data.l += 4; // TODO: ixfe
    var miyRw = data.read_shift(2);
    data.l += 1; // TODO: top/bot padding
    var flags = data.read_shift(1);
    data.l = tgt;
    if (flags & 0x07) z.level = flags & 0x07;
    if (flags & 0x10) z.hidden = true;
    if (flags & 0x20) z.hpt = miyRw / 20;
    return z;
}
function $3ee4f50b1ae43a89$var$write_BrtRowHdr(R /*:number*/ , range, ws) {
    var o = $3ee4f50b1ae43a89$var$new_buf(145);
    var row = (ws["!rows"] || [])[R] || {};
    o.write_shift(4, R);
    o.write_shift(4, 0); /* TODO: ixfe */ 
    var miyRw = 0x0140;
    if (row.hpx) miyRw = $3ee4f50b1ae43a89$var$px2pt(row.hpx) * 20;
    else if (row.hpt) miyRw = row.hpt * 20;
    o.write_shift(2, miyRw);
    o.write_shift(1, 0); /* top/bot padding */ 
    var flags = 0x0;
    if (row.level) flags |= row.level;
    if (row.hidden) flags |= 0x10;
    if (row.hpx || row.hpt) flags |= 0x20;
    o.write_shift(1, flags);
    o.write_shift(1, 0); /* phonetic guide */ 
    /* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */ var ncolspan = 0, lcs = o.l;
    o.l += 4;
    var caddr = {
        r: R,
        c: 0
    };
    for(var i = 0; i < 16; ++i){
        if (range.s.c > i + 1 << 10 || range.e.c < i << 10) continue;
        var first = -1, last = -1;
        for(var j = i << 10; j < i + 1 << 10; ++j){
            caddr.c = j;
            var cell = Array.isArray(ws) ? (ws[caddr.r] || [])[caddr.c] : ws[$3ee4f50b1ae43a89$var$encode_cell(caddr)];
            if (cell) {
                if (first < 0) first = j;
                last = j;
            }
        }
        if (first < 0) continue;
        ++ncolspan;
        o.write_shift(4, first);
        o.write_shift(4, last);
    }
    var l = o.l;
    o.l = lcs;
    o.write_shift(4, ncolspan);
    o.l = l;
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $3ee4f50b1ae43a89$var$write_row_header(ba, ws, range, R) {
    var o = $3ee4f50b1ae43a89$var$write_BrtRowHdr(R, range, ws);
    if (o.length > 17 || (ws["!rows"] || [])[R]) $3ee4f50b1ae43a89$var$write_record(ba, 0x0000 /* BrtRowHdr */ , o);
}
/* [MS-XLSB] 2.4.820 BrtWsDim */ var $3ee4f50b1ae43a89$var$parse_BrtWsDim = $3ee4f50b1ae43a89$var$parse_UncheckedRfX;
var $3ee4f50b1ae43a89$var$write_BrtWsDim = $3ee4f50b1ae43a89$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */ function $3ee4f50b1ae43a89$var$parse_BrtWsFmtInfo() {}
//function write_BrtWsFmtInfo(ws, o) { }
/* [MS-XLSB] 2.4.823 BrtWsProp */ function $3ee4f50b1ae43a89$var$parse_BrtWsProp(data, length) {
    var z = {};
    var f = data[data.l];
    ++data.l;
    z.above = !(f & 0x40);
    z.left = !(f & 0x80);
    /* TODO: pull flags */ data.l += 18;
    z.name = $3ee4f50b1ae43a89$var$parse_XLSBCodeName(data, length - 19);
    return z;
}
function $3ee4f50b1ae43a89$var$write_BrtWsProp(str, outl, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(84 + 4 * str.length);
    var f = 0xC0;
    if (outl) {
        if (outl.above) f &= -65;
        if (outl.left) f &= -129;
    }
    o.write_shift(1, f);
    for(var i = 1; i < 3; ++i)o.write_shift(1, 0);
    $3ee4f50b1ae43a89$var$write_BrtColor({
        auto: 1
    }, o);
    o.write_shift(-4, -1);
    o.write_shift(-4, -1);
    $3ee4f50b1ae43a89$var$write_XLSBCodeName(str, o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.306 BrtCellBlank */ function $3ee4f50b1ae43a89$var$parse_BrtCellBlank(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    return [
        cell
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellBlank(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8);
    return $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
}
function $3ee4f50b1ae43a89$var$parse_BrtShortBlank(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    return [
        cell
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortBlank(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(4);
    return $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
}
/* [MS-XLSB] 2.4.307 BrtCellBool */ function $3ee4f50b1ae43a89$var$parse_BrtCellBool(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        "b"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellBool(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(9);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortBool(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        "b"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortBool(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(5);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
/* [MS-XLSB] 2.4.308 BrtCellError */ function $3ee4f50b1ae43a89$var$parse_BrtCellError(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        "e"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellError(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(9);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortError(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        "e"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortError(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v);
    o.write_shift(2, 0);
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.4.311 BrtCellIsst */ function $3ee4f50b1ae43a89$var$parse_BrtCellIsst(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        "s"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellIsst(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(12);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortIsst(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        "s"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortIsst(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
/* [MS-XLSB] 2.4.313 BrtCellReal */ function $3ee4f50b1ae43a89$var$parse_BrtCellReal(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_Xnum(data);
    return [
        cell,
        value,
        "n"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellReal(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(16);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_Xnum(cell.v, o);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortReal(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_Xnum(data);
    return [
        cell,
        value,
        "n"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortReal(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(12);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_Xnum(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.314 BrtCellRk */ function $3ee4f50b1ae43a89$var$parse_BrtCellRk(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_RkNumber(data);
    return [
        cell,
        value,
        "n"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellRk(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(12);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_RkNumber(cell.v, o);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortRk(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_RkNumber(data);
    return [
        cell,
        value,
        "n"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortRk(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_RkNumber(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.323 BrtCellRString */ function $3ee4f50b1ae43a89$var$parse_BrtCellRString(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_RichStr(data);
    return [
        cell,
        value,
        "is"
    ];
}
/* [MS-XLSB] 2.4.317 BrtCellSt */ function $3ee4f50b1ae43a89$var$parse_BrtCellSt(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    return [
        cell,
        value,
        "str"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellSt(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(12 + 4 * cell.v.length);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_XLWideString(cell.v, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortSt(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    return [
        cell,
        value,
        "str"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortSt(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8 + 4 * cell.v.length);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_XLWideString(cell.v, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.653 BrtFmlaBool */ function $3ee4f50b1ae43a89$var$parse_BrtFmlaBool(data, length, opts) {
    var end = data.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        "b"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $3ee4f50b1ae43a89$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.654 BrtFmlaError */ function $3ee4f50b1ae43a89$var$parse_BrtFmlaError(data, length, opts) {
    var end = data.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        "e"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $3ee4f50b1ae43a89$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.655 BrtFmlaNum */ function $3ee4f50b1ae43a89$var$parse_BrtFmlaNum(data, length, opts) {
    var end = data.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = $3ee4f50b1ae43a89$var$parse_Xnum(data);
    var o = [
        cell,
        value,
        "n"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $3ee4f50b1ae43a89$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.656 BrtFmlaString */ function $3ee4f50b1ae43a89$var$parse_BrtFmlaString(data, length, opts) {
    var end = data.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    var o = [
        cell,
        value,
        "str"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $3ee4f50b1ae43a89$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.682 BrtMergeCell */ var $3ee4f50b1ae43a89$var$parse_BrtMergeCell = $3ee4f50b1ae43a89$var$parse_UncheckedRfX;
var $3ee4f50b1ae43a89$var$write_BrtMergeCell = $3ee4f50b1ae43a89$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */ function $3ee4f50b1ae43a89$var$write_BrtBeginMergeCells(cnt, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(4, cnt);
    return o;
}
/* [MS-XLSB] 2.4.662 BrtHLink */ function $3ee4f50b1ae43a89$var$parse_BrtHLink(data, length /*::, opts*/ ) {
    var end = data.l + length;
    var rfx = $3ee4f50b1ae43a89$var$parse_UncheckedRfX(data, 16);
    var relId = $3ee4f50b1ae43a89$var$parse_XLNullableWideString(data);
    var loc = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    var tooltip = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    var display = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    data.l = end;
    var o = {
        rfx: rfx,
        relId: relId,
        loc: loc,
        display: display
    } /*:any*/ ;
    if (tooltip) o.Tooltip = tooltip;
    return o;
}
function $3ee4f50b1ae43a89$var$write_BrtHLink(l, rId) {
    var o = $3ee4f50b1ae43a89$var$new_buf(50 + 4 * (l[1].Target.length + (l[1].Tooltip || "").length));
    $3ee4f50b1ae43a89$var$write_UncheckedRfX({
        s: $3ee4f50b1ae43a89$var$decode_cell(l[0]),
        e: $3ee4f50b1ae43a89$var$decode_cell(l[0])
    }, o);
    $3ee4f50b1ae43a89$var$write_RelID("rId" + rId, o);
    var locidx = l[1].Target.indexOf("#");
    var loc = locidx == -1 ? "" : l[1].Target.slice(locidx + 1);
    $3ee4f50b1ae43a89$var$write_XLWideString(loc || "", o);
    $3ee4f50b1ae43a89$var$write_XLWideString(l[1].Tooltip || "", o);
    $3ee4f50b1ae43a89$var$write_XLWideString("", o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.692 BrtPane */ function $3ee4f50b1ae43a89$var$parse_BrtPane() {}
/* [MS-XLSB] 2.4.6 BrtArrFmla */ function $3ee4f50b1ae43a89$var$parse_BrtArrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $3ee4f50b1ae43a89$var$parse_RfX(data, 16);
    var fAlwaysCalc = data.read_shift(1);
    var o = [
        rfx
    ];
    o[2] = fAlwaysCalc;
    if (opts.cellFormula) {
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBArrayParsedFormula(data, end - data.l, opts);
        o[1] = formula;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.750 BrtShrFmla */ function $3ee4f50b1ae43a89$var$parse_BrtShrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $3ee4f50b1ae43a89$var$parse_UncheckedRfX(data, 16);
    var o = [
        rfx
    ];
    if (opts.cellFormula) {
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBSharedParsedFormula(data, end - data.l, opts);
        o[1] = formula;
        data.l = end;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.323 BrtColInfo */ /* TODO: once XLS ColInfo is set, combine the functions */ function $3ee4f50b1ae43a89$var$write_BrtColInfo(C /*:number*/ , col, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(18);
    var p = $3ee4f50b1ae43a89$var$col_obj_w(C, col);
    o.write_shift(-4, C);
    o.write_shift(-4, C);
    o.write_shift(4, (p.width || 10) * 256);
    o.write_shift(4, 0 /*ixfe*/ ); // style
    var flags = 0;
    if (col.hidden) flags |= 0x01;
    if (typeof p.width == "number") flags |= 0x02;
    if (col.level) flags |= col.level << 8;
    o.write_shift(2, flags); // bit flag
    return o;
}
/* [MS-XLSB] 2.4.678 BrtMargins */ var $3ee4f50b1ae43a89$var$BrtMarginKeys = [
    "left",
    "right",
    "top",
    "bottom",
    "header",
    "footer"
];
function $3ee4f50b1ae43a89$var$parse_BrtMargins(data /*::, length, opts*/ ) /*:Margins*/ {
    var margins = {} /*:any*/ ;
    $3ee4f50b1ae43a89$var$BrtMarginKeys.forEach(function(k) {
        margins[k] = $3ee4f50b1ae43a89$var$parse_Xnum(data, 8);
    });
    return margins;
}
function $3ee4f50b1ae43a89$var$write_BrtMargins(margins /*:Margins*/ , o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(48);
    $3ee4f50b1ae43a89$var$default_margins(margins);
    $3ee4f50b1ae43a89$var$BrtMarginKeys.forEach(function(k) {
        $3ee4f50b1ae43a89$var$write_Xnum(margins /*:any*/ [k], o);
    });
    return o;
}
/* [MS-XLSB] 2.4.299 BrtBeginWsView */ function $3ee4f50b1ae43a89$var$parse_BrtBeginWsView(data /*::, length, opts*/ ) {
    var f = data.read_shift(2);
    data.l += 28;
    return {
        RTL: f & 0x20
    };
}
function $3ee4f50b1ae43a89$var$write_BrtBeginWsView(ws, Workbook, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(30);
    var f = 0x39c;
    if ((((Workbook || {}).Views || [])[0] || {}).RTL) f |= 0x20;
    o.write_shift(2, f); // bit flag
    o.write_shift(4, 0);
    o.write_shift(4, 0); // view first row
    o.write_shift(4, 0); // view first col
    o.write_shift(1, 0); // gridline color ICV
    o.write_shift(1, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 100); // zoom scale
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(4, 0); // workbook view id
    return o;
}
/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */ function $3ee4f50b1ae43a89$var$write_BrtCellIgnoreEC(ref) {
    var o = $3ee4f50b1ae43a89$var$new_buf(24);
    o.write_shift(4, 4);
    o.write_shift(4, 1);
    $3ee4f50b1ae43a89$var$write_UncheckedRfX(ref, o);
    return o;
}
/* [MS-XLSB] 2.4.748 BrtSheetProtection */ function $3ee4f50b1ae43a89$var$write_BrtSheetProtection(sp, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(66);
    o.write_shift(2, sp.password ? $3ee4f50b1ae43a89$var$crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
    o.write_shift(4, 1); // this record should not be written if no protection
    [
        [
            "objects",
            false
        ],
        [
            "scenarios",
            false
        ],
        [
            "formatCells",
            true
        ],
        [
            "formatColumns",
            true
        ],
        [
            "formatRows",
            true
        ],
        [
            "insertColumns",
            true
        ],
        [
            "insertRows",
            true
        ],
        [
            "insertHyperlinks",
            true
        ],
        [
            "deleteColumns",
            true
        ],
        [
            "deleteRows",
            true
        ],
        [
            "selectLockedCells",
            false
        ],
        [
            "sort",
            true
        ],
        [
            "autoFilter",
            true
        ],
        [
            "pivotTables",
            true
        ],
        [
            "selectUnlockedCells",
            false
        ] // fSelUnlockedCells
    ].forEach(function(n) {
        /*:: if(o == null) throw "unreachable"; */ if (n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
        else o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
    });
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtDVal() {}
function $3ee4f50b1ae43a89$var$parse_BrtDVal14() {}
/* [MS-XLSB] 2.1.7.61 Worksheet */ function $3ee4f50b1ae43a89$var$parse_ws_bin(data, _opts, idx, rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    var opts = _opts || {};
    if (!rels) rels = {
        "!id": {}
    };
    if ($3ee4f50b1ae43a89$var$DENSE != null && opts.dense == null) opts.dense = $3ee4f50b1ae43a89$var$DENSE;
    var s /*:Worksheet*/  = opts.dense ? [] : {};
    var ref;
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var state /*:Array<string>*/  = [];
    var pass = false, end = false;
    var row, p, cf, R, C, addr, sstr, rr, cell /*:Cell*/ ;
    var merges /*:Array<Range>*/  = [];
    opts.biff = 12;
    opts["!row"] = 0;
    var ai = 0, af = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var sharedf = {};
    var supbooks = opts.supbooks || /*::(*/ wb /*:: :any)*/ .supbooks || [
        []
    ];
    supbooks.sharedf = sharedf;
    supbooks.arrayf = arrayf;
    supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) {
        return x.name;
    });
    if (!opts.supbooks) {
        opts.supbooks = supbooks;
        if (wb.Names) for(var i = 0; i < wb.Names.length; ++i)supbooks[0][i + 1] = wb.Names[i];
    }
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    $3ee4f50b1ae43a89$var$XLSBRecordEnum[0x0010] = {
        n: "BrtShortReal",
        f: $3ee4f50b1ae43a89$var$parse_BrtShortReal
    };
    var cm, vm;
    $3ee4f50b1ae43a89$var$recordhopper(data, function ws_parse(val, RR, RT) {
        if (end) return;
        switch(RT){
            case 0x0094:
                /* 'BrtWsDim' */ ref = val;
                break;
            case 0x0000:
                /* 'BrtRowHdr' */ row = val;
                if (opts.sheetRows && opts.sheetRows <= row.r) end = true;
                rr = $3ee4f50b1ae43a89$var$encode_row(R = row.r);
                opts["!row"] = row.r;
                if (val.hidden || val.hpt || val.level != null) {
                    if (val.hpt) val.hpx = $3ee4f50b1ae43a89$var$pt2px(val.hpt);
                    rowinfo[val.r] = val;
                }
                break;
            case 0x0002:
            /* 'BrtCellRk' */ case 0x0003:
            /* 'BrtCellError' */ case 0x0004:
            /* 'BrtCellBool' */ case 0x0005:
            /* 'BrtCellReal' */ case 0x0006:
            /* 'BrtCellSt' */ case 0x0007:
            /* 'BrtCellIsst' */ case 0x0008:
            /* 'BrtFmlaString' */ case 0x0009:
            /* 'BrtFmlaNum' */ case 0x000A:
            /* 'BrtFmlaBool' */ case 0x000B:
            /* 'BrtFmlaError' */ case 0x000D:
            /* 'BrtShortRk' */ case 0x000E:
            /* 'BrtShortError' */ case 0x000F:
            /* 'BrtShortBool' */ case 0x0010:
            /* 'BrtShortReal' */ case 0x0011:
            /* 'BrtShortSt' */ case 0x0012:
            /* 'BrtShortIsst' */ case 0x003E:
                /* 'BrtCellRString' */ p = {
                    t: val[2]
                } /*:any*/ ;
                switch(val[2]){
                    case "n":
                        p.v = val[1];
                        break;
                    case "s":
                        sstr = $3ee4f50b1ae43a89$var$strs[val[1]];
                        p.v = sstr.t;
                        p.r = sstr.r;
                        break;
                    case "b":
                        p.v = val[1] ? true : false;
                        break;
                    case "e":
                        p.v = val[1];
                        if (opts.cellText !== false) p.w = $3ee4f50b1ae43a89$var$BErr[p.v];
                        break;
                    case "str":
                        p.t = "s";
                        p.v = val[1];
                        break;
                    case "is":
                        p.t = "s";
                        p.v = val[1].t;
                        break;
                }
                if (cf = styles.CellXf[val[0].iStyleRef]) $3ee4f50b1ae43a89$var$safe_format(p, cf.numFmtId, null, opts, themes, styles);
                C = val[0].c == -1 ? C + 1 : val[0].c;
                if (opts.dense) {
                    if (!s[R]) s[R] = [];
                    s[R][C] = p;
                } else s[$3ee4f50b1ae43a89$var$encode_col(C) + rr] = p;
                if (opts.cellFormula) {
                    af = false;
                    for(ai = 0; ai < arrayf.length; ++ai){
                        var aii = arrayf[ai];
                        if (row.r >= aii[0].s.r && row.r <= aii[0].e.r) {
                            if (C >= aii[0].s.c && C <= aii[0].e.c) {
                                p.F = $3ee4f50b1ae43a89$var$encode_range(aii[0]);
                                af = true;
                            }
                        }
                    }
                    if (!af && val.length > 3) p.f = val[3];
                }
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (opts.cellDates && cf && p.t == "n" && $3ee4f50b1ae43a89$var$fmt_is_date($3ee4f50b1ae43a89$var$table_fmt[cf.numFmtId])) {
                    var _d = $3ee4f50b1ae43a89$var$SSF_parse_date_code(p.v);
                    if (_d) {
                        p.t = "d";
                        p.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
                    }
                }
                if (cm) {
                    if (cm.type == "XLDAPR") p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x0001:
            /* 'BrtCellBlank' */ case 0x000C:
                /* 'BrtShortBlank' */ if (!opts.sheetStubs || pass) break;
                p = {
                    t: "z",
                    v: void 0
                } /*:any*/ ;
                C = val[0].c == -1 ? C + 1 : val[0].c;
                if (opts.dense) {
                    if (!s[R]) s[R] = [];
                    s[R][C] = p;
                } else s[$3ee4f50b1ae43a89$var$encode_col(C) + rr] = p;
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (cm) {
                    if (cm.type == "XLDAPR") p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x00B0:
                /* 'BrtMergeCell' */ merges.push(val);
                break;
            case 0x0031:
                cm = ((opts.xlmeta || {}).Cell || [])[val - 1];
                break;
            case 0x01EE:
                /* 'BrtHLink' */ var rel = rels["!id"][val.relId];
                if (rel) {
                    val.Target = rel.Target;
                    if (val.loc) val.Target += "#" + val.loc;
                    val.Rel = rel;
                } else if (val.relId == "") val.Target = "#" + val.loc;
                for(R = val.rfx.s.r; R <= val.rfx.e.r; ++R)for(C = val.rfx.s.c; C <= val.rfx.e.c; ++C)if (opts.dense) {
                    if (!s[R]) s[R] = [];
                    if (!s[R][C]) s[R][C] = {
                        t: "z",
                        v: undefined
                    };
                    s[R][C].l = val;
                } else {
                    addr = $3ee4f50b1ae43a89$var$encode_cell({
                        c: C,
                        r: R
                    });
                    if (!s[addr]) s[addr] = {
                        t: "z",
                        v: undefined
                    };
                    s[addr].l = val;
                }
                break;
            case 0x01AA:
                /* 'BrtArrFmla' */ if (!opts.cellFormula) break;
                arrayf.push(val);
                cell = opts.dense ? s[R][C] : s[$3ee4f50b1ae43a89$var$encode_col(C) + rr];
                cell.f = $3ee4f50b1ae43a89$var$stringify_formula(val[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                cell.F = $3ee4f50b1ae43a89$var$encode_range(val[0]);
                break;
            case 0x01AB:
                /* 'BrtShrFmla' */ if (!opts.cellFormula) break;
                sharedf[$3ee4f50b1ae43a89$var$encode_cell(val[0].s)] = val[1];
                cell = opts.dense ? s[R][C] : s[$3ee4f50b1ae43a89$var$encode_col(C) + rr];
                cell.f = $3ee4f50b1ae43a89$var$stringify_formula(val[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                break;
            /* identical to 'ColInfo' in XLS */ case 0x003C:
                /* 'BrtColInfo' */ if (!opts.cellStyles) break;
                while(val.e >= val.s){
                    colinfo[val.e--] = {
                        width: val.w / 256,
                        hidden: !!(val.flags & 0x01),
                        level: val.level
                    };
                    if (!seencol) {
                        seencol = true;
                        $3ee4f50b1ae43a89$var$find_mdw_colw(val.w / 256);
                    }
                    $3ee4f50b1ae43a89$var$process_col(colinfo[val.e + 1]);
                }
                break;
            case 0x00A1:
                /* 'BrtBeginAFilter' */ s["!autofilter"] = {
                    ref: $3ee4f50b1ae43a89$var$encode_range(val)
                };
                break;
            case 0x01DC:
                /* 'BrtMargins' */ s["!margins"] = val;
                break;
            case 0x0093:
                /* 'BrtWsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val.name) wb.Sheets[idx].CodeName = val.name;
                if (val.above || val.left) s["!outline"] = {
                    above: val.above,
                    left: val.left
                };
                break;
            case 0x0089:
                /* 'BrtBeginWsView' */ if (!wb.Views) wb.Views = [
                    {}
                ];
                if (!wb.Views[0]) wb.Views[0] = {};
                if (val.RTL) wb.Views[0].RTL = true;
                break;
            case 0x01E5:
                break;
            case 0x0040:
            /* 'BrtDVal' */ case 0x041D:
                break;
            case 0x0097:
                break;
            case 0x0098:
            /* 'BrtSel' */ case 0x00AF:
            /* 'BrtAFilterDateGroupItem' */ case 0x0284:
            /* 'BrtActiveX' */ case 0x0271:
            /* 'BrtBigName' */ case 0x0232:
            /* 'BrtBkHim' */ case 0x018C:
            /* 'BrtBrk' */ case 0x0458:
            /* 'BrtCFIcon' */ case 0x047A:
            /* 'BrtCFRuleExt' */ case 0x01D7:
            /* 'BrtCFVO' */ case 0x041A:
            /* 'BrtCFVO14' */ case 0x0289:
            /* 'BrtCellIgnoreEC' */ case 0x0451:
            /* 'BrtCellIgnoreEC14' */ case 0x024D:
            /* 'BrtCellSmartTagProperty' */ case 0x025F:
            /* 'BrtCellWatch' */ case 0x0234:
            /* 'BrtColor' */ case 0x041F:
            /* 'BrtColor14' */ case 0x00A8:
            /* 'BrtColorFilter' */ case 0x00AE:
            /* 'BrtCustomFilter' */ case 0x049C:
            /* 'BrtCustomFilter14' */ case 0x01F3:
            /* 'BrtDRef' */ case 0x01FB:
            /* 'BrtDXF' */ case 0x0226:
            /* 'BrtDrawing' */ case 0x00AB:
            /* 'BrtDynamicFilter' */ case 0x00A7:
            /* 'BrtFilter' */ case 0x0499:
            /* 'BrtFilter14' */ case 0x00A9:
            /* 'BrtIconFilter' */ case 0x049D:
            /* 'BrtIconFilter14' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x0295:
            /* 'BrtListPart' */ case 0x027F:
            /* 'BrtOleObject' */ case 0x01DE:
            /* 'BrtPageSetup' */ case 0x0219:
            /* 'BrtPhoneticInfo' */ case 0x01DD:
            /* 'BrtPrintOptions' */ case 0x0218:
            /* 'BrtRangeProtection' */ case 0x044F:
            /* 'BrtRangeProtection14' */ case 0x02A8:
            /* 'BrtRangeProtectionIso' */ case 0x0450:
            /* 'BrtRangeProtectionIso14' */ case 0x0400:
            /* 'BrtRwDescent' */ case 0x0297:
            /* 'BrtSheetCalcProp' */ case 0x0217:
            /* 'BrtSheetProtection' */ case 0x02A6:
            /* 'BrtSheetProtectionIso' */ case 0x01F8:
            /* 'BrtSlc' */ case 0x0413:
            /* 'BrtSparkline' */ case 0x01AC:
            /* 'BrtTable' */ case 0x00AA:
            /* 'BrtTop10Filter' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0032:
            /* 'BrtValueMeta' */ case 0x0816:
            /* 'BrtWebExtension' */ case 0x0415:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            default:
                if (RR.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    delete opts.supbooks;
    delete opts["!row"];
    if (!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(ref || refguess);
    if (opts.sheetRows && s["!ref"]) {
        var tmpref = $3ee4f50b1ae43a89$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(tmpref);
        }
    }
    if (merges.length > 0) s["!merges"] = merges;
    if (colinfo.length > 0) s["!cols"] = colinfo;
    if (rowinfo.length > 0) s["!rows"] = rowinfo;
    return s;
}
/* TODO: something useful -- this is a stub */ function $3ee4f50b1ae43a89$var$write_ws_bin_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, ws /*:Worksheet*/ , last_seen /*:boolean*/ ) /*:boolean*/ {
    if (cell.v === undefined) return false;
    var vv = "";
    switch(cell.t){
        case "b":
            vv = cell.v ? "1" : "0";
            break;
        case "d":
            cell = $3ee4f50b1ae43a89$var$dup(cell);
            cell.z = cell.z || $3ee4f50b1ae43a89$var$table_fmt[14];
            cell.v = $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v));
            cell.t = "n";
            break;
        /* falls through */ case "n":
        case "e":
            vv = "" + cell.v;
            break;
        default:
            vv = cell.v;
            break;
    }
    var o /*:any*/  = {
        r: R,
        c: C
    } /*:any*/ ;
    /* TODO: cell style */ o.s = $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.l) ws["!links"].push([
        $3ee4f50b1ae43a89$var$encode_cell(o),
        cell.l
    ]);
    if (cell.c) ws["!comments"].push([
        $3ee4f50b1ae43a89$var$encode_cell(o),
        cell.c
    ]);
    switch(cell.t){
        case "s":
        case "str":
            if (opts.bookSST) {
                vv = $3ee4f50b1ae43a89$var$get_sst_id(opts.Strings, cell.v /*:any*/ , opts.revStrings);
                o.t = "s";
                o.v = vv;
                if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x0012 /* BrtShortIsst */ , $3ee4f50b1ae43a89$var$write_BrtShortIsst(cell, o));
                else $3ee4f50b1ae43a89$var$write_record(ba, 0x0007 /* BrtCellIsst */ , $3ee4f50b1ae43a89$var$write_BrtCellIsst(cell, o));
            } else {
                o.t = "str";
                if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x0011 /* BrtShortSt */ , $3ee4f50b1ae43a89$var$write_BrtShortSt(cell, o));
                else $3ee4f50b1ae43a89$var$write_record(ba, 0x0006 /* BrtCellSt */ , $3ee4f50b1ae43a89$var$write_BrtCellSt(cell, o));
            }
            return true;
        case "n":
            /* TODO: determine threshold for Real vs RK */ if (cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
                if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x000D /* BrtShortRk */ , $3ee4f50b1ae43a89$var$write_BrtShortRk(cell, o));
                else $3ee4f50b1ae43a89$var$write_record(ba, 0x0002 /* BrtCellRk */ , $3ee4f50b1ae43a89$var$write_BrtCellRk(cell, o));
            } else if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x0010 /* BrtShortReal */ , $3ee4f50b1ae43a89$var$write_BrtShortReal(cell, o));
            else $3ee4f50b1ae43a89$var$write_record(ba, 0x0005 /* BrtCellReal */ , $3ee4f50b1ae43a89$var$write_BrtCellReal(cell, o));
            return true;
        case "b":
            o.t = "b";
            if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x000F /* BrtShortBool */ , $3ee4f50b1ae43a89$var$write_BrtShortBool(cell, o));
            else $3ee4f50b1ae43a89$var$write_record(ba, 0x0004 /* BrtCellBool */ , $3ee4f50b1ae43a89$var$write_BrtCellBool(cell, o));
            return true;
        case "e":
            o.t = "e";
            if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x000E /* BrtShortError */ , $3ee4f50b1ae43a89$var$write_BrtShortError(cell, o));
            else $3ee4f50b1ae43a89$var$write_record(ba, 0x0003 /* BrtCellError */ , $3ee4f50b1ae43a89$var$write_BrtCellError(cell, o));
            return true;
    }
    if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x000C /* BrtShortBlank */ , $3ee4f50b1ae43a89$var$write_BrtShortBlank(cell, o));
    else $3ee4f50b1ae43a89$var$write_record(ba, 0x0001 /* BrtCellBlank */ , $3ee4f50b1ae43a89$var$write_BrtCellBlank(cell, o));
    return true;
}
function $3ee4f50b1ae43a89$var$write_CELLTABLE(ba, ws /*:Worksheet*/ , idx /*:number*/ , opts /*::, wb:Workbook*/ ) {
    var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"] || "A1"), ref, rr = "", cols /*:Array<string>*/  = [];
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0091 /* BrtBeginSheetData */ );
    var dense = Array.isArray(ws);
    var cap = range.e.r;
    if (ws["!rows"]) cap = Math.max(range.e.r, ws["!rows"].length - 1);
    for(var R = range.s.r; R <= cap; ++R){
        rr = $3ee4f50b1ae43a89$var$encode_row(R);
        /* [ACCELLTABLE] */ /* BrtRowHdr */ $3ee4f50b1ae43a89$var$write_row_header(ba, ws, range, R);
        var last_seen = false;
        if (R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C){
            /* *16384CELL */ if (R === range.s.r) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
            ref = cols[C] + rr;
            var cell = dense ? (ws[R] || [])[C] : ws[ref];
            if (!cell) {
                last_seen = false;
                continue;
            }
            /* write cell */ last_seen = $3ee4f50b1ae43a89$var$write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen);
        }
    }
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0092 /* BrtEndSheetData */ );
}
function $3ee4f50b1ae43a89$var$write_MERGECELLS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws["!merges"]) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x00B1 /* BrtBeginMergeCells */ , $3ee4f50b1ae43a89$var$write_BrtBeginMergeCells(ws["!merges"].length));
    ws["!merges"].forEach(function(m) {
        $3ee4f50b1ae43a89$var$write_record(ba, 0x00B0 /* BrtMergeCell */ , $3ee4f50b1ae43a89$var$write_BrtMergeCell(m));
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x00B2 /* BrtEndMergeCells */ );
}
function $3ee4f50b1ae43a89$var$write_COLINFOS(ba, ws /*:Worksheet*/  /*::, idx:number, opts, wb:Workbook*/ ) {
    if (!ws || !ws["!cols"]) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0186 /* BrtBeginColInfos */ );
    ws["!cols"].forEach(function(m, i) {
        if (m) $3ee4f50b1ae43a89$var$write_record(ba, 0x003C /* 'BrtColInfo' */ , $3ee4f50b1ae43a89$var$write_BrtColInfo(i, m));
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0187 /* BrtEndColInfos */ );
}
function $3ee4f50b1ae43a89$var$write_IGNOREECS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws["!ref"]) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0289 /* BrtCellIgnoreEC */ , $3ee4f50b1ae43a89$var$write_BrtCellIgnoreEC($3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"])));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x028A /* BrtEndCellIgnoreECs */ );
}
function $3ee4f50b1ae43a89$var$write_HLINKS(ba, ws /*:Worksheet*/ , rels) {
    /* *BrtHLink */ ws["!links"].forEach(function(l) {
        if (!l[1].Target) return;
        var rId = $3ee4f50b1ae43a89$var$add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), $3ee4f50b1ae43a89$var$RELS.HLINK);
        $3ee4f50b1ae43a89$var$write_record(ba, 0x01EE /* BrtHLink */ , $3ee4f50b1ae43a89$var$write_BrtHLink(l, rId));
    });
    delete ws["!links"];
}
function $3ee4f50b1ae43a89$var$write_LEGACYDRAWING(ba, ws /*:Worksheet*/ , idx /*:number*/ , rels) {
    /* [BrtLegacyDrawing] */ if (ws["!comments"].length > 0) {
        var rId = $3ee4f50b1ae43a89$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $3ee4f50b1ae43a89$var$RELS.VML);
        $3ee4f50b1ae43a89$var$write_record(ba, 0x0227 /* BrtLegacyDrawing */ , $3ee4f50b1ae43a89$var$write_RelID("rId" + rId));
        ws["!legacy"] = rId;
    }
}
function $3ee4f50b1ae43a89$var$write_AUTOFILTER(ba, ws, wb, idx) {
    if (!ws["!autofilter"]) return;
    var data = ws["!autofilter"];
    var ref = typeof data.ref === "string" ? data.ref : $3ee4f50b1ae43a89$var$encode_range(data.ref);
    /* Update FilterDatabase defined name for the worksheet */ if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $3ee4f50b1ae43a89$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]).e.r;
        ref = $3ee4f50b1ae43a89$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != "_xlnm._FilterDatabase") continue;
        if (name.Sheet != idx) continue;
        name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref;
        break;
    }
    if (i == names.length) names.push({
        Name: "_xlnm._FilterDatabase",
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x00A1 /* BrtBeginAFilter */ , $3ee4f50b1ae43a89$var$write_UncheckedRfX($3ee4f50b1ae43a89$var$safe_decode_range(ref)));
    /* *FILTERCOLUMN */ /* [SORTSTATE] */ /* BrtEndAFilter */ $3ee4f50b1ae43a89$var$write_record(ba, 0x00A2 /* BrtEndAFilter */ );
}
function $3ee4f50b1ae43a89$var$write_WSVIEWS2(ba, ws, Workbook) {
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0085 /* BrtBeginWsViews */ );
    /* [ACUID] */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0089 /* BrtBeginWsView */ , $3ee4f50b1ae43a89$var$write_BrtBeginWsView(ws, Workbook));
    /* [BrtPane] */ /* *4BrtSel */ /* *4SXSELECT */ /* *FRT */ $3ee4f50b1ae43a89$var$write_record(ba, 0x008A /* BrtEndWsView */ );
    /* *FRT */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0086 /* BrtEndWsViews */ );
}
function $3ee4f50b1ae43a89$var$write_WSFMTINFO() {
/* [ACWSFMTINFO] */ // write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
}
function $3ee4f50b1ae43a89$var$write_SHEETPROTECT(ba, ws) {
    if (!ws["!protect"]) return;
    /* [BrtSheetProtectionIso] */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0217 /* BrtSheetProtection */ , $3ee4f50b1ae43a89$var$write_BrtSheetProtection(ws["!protect"]));
}
function $3ee4f50b1ae43a89$var$write_ws_bin(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var c /*:string*/  = s;
    try {
        if (wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c;
    } catch (e) {}
    var r = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"] || "A1");
    if (r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + (ws["!ref"] || "A1") + " exceeds format limit A1:XFD1048576");
        r.e.c = Math.min(r.e.c, 0x3FFF);
        r.e.r = Math.min(r.e.c, 0xFFFFF);
    }
    ws["!links"] = [];
    /* passed back to write_zip and removed there */ ws["!comments"] = [];
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0081 /* BrtBeginSheet */ );
    if (wb.vbaraw || ws["!outline"]) $3ee4f50b1ae43a89$var$write_record(ba, 0x0093 /* BrtWsProp */ , $3ee4f50b1ae43a89$var$write_BrtWsProp(c, ws["!outline"]));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0094 /* BrtWsDim */ , $3ee4f50b1ae43a89$var$write_BrtWsDim(r));
    $3ee4f50b1ae43a89$var$write_WSVIEWS2(ba, ws, wb.Workbook);
    $3ee4f50b1ae43a89$var$write_WSFMTINFO(ba, ws);
    $3ee4f50b1ae43a89$var$write_COLINFOS(ba, ws, idx, opts, wb);
    $3ee4f50b1ae43a89$var$write_CELLTABLE(ba, ws, idx, opts, wb);
    /* [BrtSheetCalcProp] */ $3ee4f50b1ae43a89$var$write_SHEETPROTECT(ba, ws);
    /* *([BrtRangeProtectionIso] BrtRangeProtection) */ /* [SCENMAN] */ $3ee4f50b1ae43a89$var$write_AUTOFILTER(ba, ws, wb, idx);
    /* [SORTSTATE] */ /* [DCON] */ /* [USERSHVIEWS] */ $3ee4f50b1ae43a89$var$write_MERGECELLS(ba, ws);
    /* [BrtPhoneticInfo] */ /* *CONDITIONALFORMATTING */ /* [DVALS] */ $3ee4f50b1ae43a89$var$write_HLINKS(ba, ws, rels);
    /* [BrtPrintOptions] */ if (ws["!margins"]) $3ee4f50b1ae43a89$var$write_record(ba, 0x01DC /* BrtMargins */ , $3ee4f50b1ae43a89$var$write_BrtMargins(ws["!margins"]));
    /* [BrtPageSetup] */ /* [HEADERFOOTER] */ /* [RWBRK] */ /* [COLBRK] */ /* *BrtBigName */ /* [CELLWATCHES] */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) $3ee4f50b1ae43a89$var$write_IGNOREECS(ba, ws);
    /* [SMARTTAGS] */ /* [BrtDrawing] */ $3ee4f50b1ae43a89$var$write_LEGACYDRAWING(ba, ws, idx, rels);
    /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [OLEOBJECTS] */ /* [ACTIVEXCONTROLS] */ /* [WEBPUBITEMS] */ /* [LISTPARTS] */ /* FRTWORKSHEET */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
function $3ee4f50b1ae43a89$var$parse_Cache(data /*:string*/ ) /*:[Array<number|string>, string, ?string]*/ {
    var col /*:Array<number|string>*/  = [];
    var num = data.match(/^<c:numCache>/);
    var f;
    /* 21.2.2.150 pt CT_NumVal */ (data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg) || []).forEach(function(pt) {
        var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
        if (!q) return;
        col[+q[1]] = num ? +q[2] : q[2];
    });
    /* 21.2.2.71 formatCode CT_Xstring */ var nf = $3ee4f50b1ae43a89$var$unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || [
        "",
        "General"
    ])[1]);
    (data.match(/<c:f>(.*?)<\/c:f>/mg) || []).forEach(function(F) {
        f = F.replace(/<.*?>/g, "");
    });
    return [
        col,
        nf,
        f
    ];
}
/* 21.2 DrawingML - Charts */ function $3ee4f50b1ae43a89$var$parse_chart(data /*:?string*/ , name /*:string*/ , opts, rels, wb, csheet) {
    var cs /*:Worksheet*/  = csheet || {
        "!type": "chart"
    };
    if (!data) return csheet;
    /* 21.2.2.27 chart CT_Chart */ var C = 0, R = 0, col = "A";
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    /* 21.2.2.120 numCache CT_NumData */ (data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function(nc) {
        var cache = $3ee4f50b1ae43a89$var$parse_Cache(nc);
        refguess.s.r = refguess.s.c = 0;
        refguess.e.c = C;
        col = $3ee4f50b1ae43a89$var$encode_col(C);
        cache[0].forEach(function(n, i) {
            cs[col + $3ee4f50b1ae43a89$var$encode_row(i)] = {
                t: "n",
                v: n,
                z: cache[1]
            };
            R = i;
        });
        if (refguess.e.r < R) refguess.e.r = R;
        ++C;
    });
    if (C > 0) cs["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
    return cs;
}
/* 18.3 Worksheets also covers Chartsheets */ function $3ee4f50b1ae43a89$var$parse_cs_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    /* 18.3.1.12 chartsheet CT_ChartSheet */ if (!rels) rels = {
        "!id": {}
    };
    var s = {
        "!type": "chart",
        "!drawel": null,
        "!rel": ""
    } /*:any*/ ;
    var m;
    /* 18.3.1.83 sheetPr CT_ChartsheetPr */ var sheetPr = data.match($3ee4f50b1ae43a89$var$sheetprregex);
    if (sheetPr) $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    /* 18.3.1.36 drawing CT_Drawing */ if (m = data.match(/drawing r:id="(.*?)"/)) s["!rel"] = m[1];
    if (rels["!id"][s["!rel"]]) s["!drawel"] = rels["!id"][s["!rel"]];
    return s;
}
function $3ee4f50b1ae43a89$var$write_cs_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("chartsheet", null, {
            "xmlns": $3ee4f50b1ae43a89$var$XMLNS_main[0],
            "xmlns:r": $3ee4f50b1ae43a89$var$XMLNS.r
        })
    ];
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("drawing", null, {
        "r:id": "rId1"
    });
    $3ee4f50b1ae43a89$var$add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", $3ee4f50b1ae43a89$var$RELS.DRAW);
    if (o.length > 2) {
        o[o.length] = "</chartsheet>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.331 BrtCsProp */ function $3ee4f50b1ae43a89$var$parse_BrtCsProp(data, length /*:number*/ ) {
    data.l += 10;
    var name = $3ee4f50b1ae43a89$var$parse_XLWideString(data, length - 10);
    return {
        name: name
    };
}
/* [MS-XLSB] 2.1.7.7 Chart Sheet */ function $3ee4f50b1ae43a89$var$parse_cs_bin(data, opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        "!id": {}
    };
    var s = {
        "!type": "chart",
        "!drawel": null,
        "!rel": ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function cs_parse(val, R, RT) {
        switch(RT){
            case 0x0226:
                /* 'BrtDrawing' */ s["!rel"] = val;
                break;
            case 0x028B:
                /* 'BrtCsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val.name) wb.Sheets[idx].CodeName = val.name;
                break;
            case 0x0232:
            /* 'BrtBkHim' */ case 0x028C:
            /* 'BrtCsPageSetup' */ case 0x029D:
            /* 'BrtCsProtection' */ case 0x02A7:
            /* 'BrtCsProtectionIso' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x01DC:
            /* 'BrtMargins' */ case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    if (rels["!id"][s["!rel"]]) s["!drawel"] = rels["!id"][s["!rel"]];
    return s;
}
function $3ee4f50b1ae43a89$var$write_cs_bin() {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0081 /* BrtBeginSheet */ );
    /* [BrtCsProp] */ /* CSVIEWS */ /* [[BrtCsProtectionIso] BrtCsProtection] */ /* [USERCSVIEWS] */ /* [BrtMargins] */ /* [BrtCsPageSetup] */ /* [HEADERFOOTER] */ /* BrtDrawing */ /* [BrtLegacyDrawing] */ /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [WEBPUBITEMS] */ /* FRTCHARTSHEET */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
/* 18.2.28 (CT_WorkbookProtection) Defaults */ var $3ee4f50b1ae43a89$var$WBPropsDef = [
    [
        "allowRefreshQuery",
        false,
        "bool"
    ],
    [
        "autoCompressPictures",
        true,
        "bool"
    ],
    [
        "backupFile",
        false,
        "bool"
    ],
    [
        "checkCompatibility",
        false,
        "bool"
    ],
    [
        "CodeName",
        ""
    ],
    [
        "date1904",
        false,
        "bool"
    ],
    [
        "defaultThemeVersion",
        0,
        "int"
    ],
    [
        "filterPrivacy",
        false,
        "bool"
    ],
    [
        "hidePivotFieldList",
        false,
        "bool"
    ],
    [
        "promptedSolutions",
        false,
        "bool"
    ],
    [
        "publishItems",
        false,
        "bool"
    ],
    [
        "refreshAllConnections",
        false,
        "bool"
    ],
    [
        "saveExternalLinkValues",
        true,
        "bool"
    ],
    [
        "showBorderUnselectedTables",
        true,
        "bool"
    ],
    [
        "showInkAnnotation",
        true,
        "bool"
    ],
    [
        "showObjects",
        "all"
    ],
    [
        "showPivotChartFilter",
        false,
        "bool"
    ],
    [
        "updateLinks",
        "userSet"
    ]
];
/* 18.2.30 (CT_BookView) Defaults */ var $3ee4f50b1ae43a89$var$WBViewDef = [
    [
        "activeTab",
        0,
        "int"
    ],
    [
        "autoFilterDateGrouping",
        true,
        "bool"
    ],
    [
        "firstSheet",
        0,
        "int"
    ],
    [
        "minimized",
        false,
        "bool"
    ],
    [
        "showHorizontalScroll",
        true,
        "bool"
    ],
    [
        "showSheetTabs",
        true,
        "bool"
    ],
    [
        "showVerticalScroll",
        true,
        "bool"
    ],
    [
        "tabRatio",
        600,
        "int"
    ],
    [
        "visibility",
        "visible"
    ]
];
/* 18.2.19 (CT_Sheet) Defaults */ var $3ee4f50b1ae43a89$var$SheetDef = [];
/* 18.2.2  (CT_CalcPr) Defaults */ var $3ee4f50b1ae43a89$var$CalcPrDef = [
    [
        "calcCompleted",
        "true"
    ],
    [
        "calcMode",
        "auto"
    ],
    [
        "calcOnSave",
        "true"
    ],
    [
        "concurrentCalc",
        "true"
    ],
    [
        "fullCalcOnLoad",
        "false"
    ],
    [
        "fullPrecision",
        "true"
    ],
    [
        "iterate",
        "false"
    ],
    [
        "iterateCount",
        "100"
    ],
    [
        "iterateDelta",
        "0.001"
    ],
    [
        "refMode",
        "A1"
    ]
];
/* 18.2.3 (CT_CustomWorkbookView) Defaults */ /*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/ function $3ee4f50b1ae43a89$var$push_defaults_array(target, defaults) {
    for(var j = 0; j != target.length; ++j){
        var w = target[j];
        for(var i = 0; i != defaults.length; ++i){
            var z = defaults[i];
            if (w[z[0]] == null) w[z[0]] = z[1];
            else switch(z[2]){
                case "bool":
                    if (typeof w[z[0]] == "string") w[z[0]] = $3ee4f50b1ae43a89$var$parsexmlbool(w[z[0]]);
                    break;
                case "int":
                    if (typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10);
                    break;
            }
        }
    }
}
function $3ee4f50b1ae43a89$var$push_defaults(target, defaults) {
    for(var i = 0; i != defaults.length; ++i){
        var z = defaults[i];
        if (target[z[0]] == null) target[z[0]] = z[1];
        else switch(z[2]){
            case "bool":
                if (typeof target[z[0]] == "string") target[z[0]] = $3ee4f50b1ae43a89$var$parsexmlbool(target[z[0]]);
                break;
            case "int":
                if (typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10);
                break;
        }
    }
}
function $3ee4f50b1ae43a89$var$parse_wb_defaults(wb) {
    $3ee4f50b1ae43a89$var$push_defaults(wb.WBProps, $3ee4f50b1ae43a89$var$WBPropsDef);
    $3ee4f50b1ae43a89$var$push_defaults(wb.CalcPr, $3ee4f50b1ae43a89$var$CalcPrDef);
    $3ee4f50b1ae43a89$var$push_defaults_array(wb.WBView, $3ee4f50b1ae43a89$var$WBViewDef);
    $3ee4f50b1ae43a89$var$push_defaults_array(wb.Sheets, $3ee4f50b1ae43a89$var$SheetDef);
    $3ee4f50b1ae43a89$var$_ssfopts.date1904 = $3ee4f50b1ae43a89$var$parsexmlbool(wb.WBProps.date1904);
}
function $3ee4f50b1ae43a89$var$safe1904(wb /*:Workbook*/ ) /*:string*/ {
    /* TODO: store date1904 somewhere else */ if (!wb.Workbook) return "false";
    if (!wb.Workbook.WBProps) return "false";
    return $3ee4f50b1ae43a89$var$parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}
var $3ee4f50b1ae43a89$var$badchars = /*#__PURE__*/ "][*?/\\".split("");
function $3ee4f50b1ae43a89$var$check_ws_name(n /*:string*/ , safe /*:?boolean*/ ) /*:boolean*/ {
    if (n.length > 31) {
        if (safe) return false;
        throw new Error("Sheet names cannot exceed 31 chars");
    }
    var _good = true;
    $3ee4f50b1ae43a89$var$badchars.forEach(function(c) {
        if (n.indexOf(c) == -1) return;
        if (!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
        _good = false;
    });
    return _good;
}
function $3ee4f50b1ae43a89$var$check_wb_names(N, S, codes) {
    N.forEach(function(n, i) {
        $3ee4f50b1ae43a89$var$check_ws_name(n);
        for(var j = 0; j < i; ++j)if (n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
        if (codes) {
            var cn = S && S[i] && S[i].CodeName || n;
            if (cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
        }
    });
}
function $3ee4f50b1ae43a89$var$check_wb(wb) {
    if (!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
    if (!wb.SheetNames.length) throw new Error("Workbook is empty");
    var Sheets = wb.Workbook && wb.Workbook.Sheets || [];
    $3ee4f50b1ae43a89$var$check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
    for(var i = 0; i < wb.SheetNames.length; ++i)$3ee4f50b1ae43a89$var$check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
/* TODO: validate workbook */ }
/* 18.2 Workbook */ var $3ee4f50b1ae43a89$var$wbnsregex = /<\w+:workbook/;
function $3ee4f50b1ae43a89$var$parse_wb_xml(data, opts) /*:WorkbookFile*/ {
    if (!data) throw new Error("Could not find file");
    var wb = /*::(*/ {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        Names: [],
        xmlns: ""
    } /*::)*/ ;
    var pass = false, xmlns = "xmlns";
    var dname = {}, dnstart = 0;
    data.replace($3ee4f50b1ae43a89$var$tagregex, function xml_wb(x, idx) {
        var y /*:any*/  = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<?xml":
                break;
            /* 18.2.27 workbook CT_Workbook 1 */ case "<workbook":
                if (x.match($3ee4f50b1ae43a89$var$wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
                wb.xmlns = y[xmlns];
                break;
            case "</workbook>":
                break;
            /* 18.2.13 fileVersion CT_FileVersion ? */ case "<fileVersion":
                delete y[0];
                wb.AppVersion = y;
                break;
            case "<fileVersion/>":
            case "</fileVersion>":
                break;
            /* 18.2.12 fileSharing CT_FileSharing ? */ case "<fileSharing":
                break;
            case "<fileSharing/>":
                break;
            /* 18.2.28 workbookPr CT_WorkbookPr ? */ case "<workbookPr":
            case "<workbookPr/>":
                $3ee4f50b1ae43a89$var$WBPropsDef.forEach(function(w) {
                    if (y[w[0]] == null) return;
                    switch(w[2]){
                        case "bool":
                            wb.WBProps[w[0]] = $3ee4f50b1ae43a89$var$parsexmlbool(y[w[0]]);
                            break;
                        case "int":
                            wb.WBProps[w[0]] = parseInt(y[w[0]], 10);
                            break;
                        default:
                            wb.WBProps[w[0]] = y[w[0]];
                    }
                });
                if (y.codeName) wb.WBProps.CodeName = $3ee4f50b1ae43a89$var$utf8read(y.codeName);
                break;
            case "</workbookPr>":
                break;
            /* 18.2.29 workbookProtection CT_WorkbookProtection ? */ case "<workbookProtection":
                break;
            case "<workbookProtection/>":
                break;
            /* 18.2.1  bookViews CT_BookViews ? */ case "<bookViews":
            case "<bookViews>":
            case "</bookViews>":
                break;
            /* 18.2.30   workbookView CT_BookView + */ case "<workbookView":
            case "<workbookView/>":
                delete y[0];
                wb.WBView.push(y);
                break;
            case "</workbookView>":
                break;
            /* 18.2.20 sheets CT_Sheets 1 */ case "<sheets":
            case "<sheets>":
            case "</sheets>":
                break; // aggregate sheet
            /* 18.2.19   sheet CT_Sheet + */ case "<sheet":
                switch(y.state){
                    case "hidden":
                        y.Hidden = 1;
                        break;
                    case "veryHidden":
                        y.Hidden = 2;
                        break;
                    default:
                        y.Hidden = 0;
                }
                delete y.state;
                y.name = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(y.name));
                delete y[0];
                wb.Sheets.push(y);
                break;
            case "</sheet>":
                break;
            /* 18.2.15 functionGroups CT_FunctionGroups ? */ case "<functionGroups":
            case "<functionGroups/>":
                break;
            /* 18.2.14   functionGroup CT_FunctionGroup + */ case "<functionGroup":
                break;
            /* 18.2.9  externalReferences CT_ExternalReferences ? */ case "<externalReferences":
            case "</externalReferences>":
            case "<externalReferences>":
                break;
            /* 18.2.8    externalReference CT_ExternalReference + */ case "<externalReference":
                break;
            /* 18.2.6  definedNames CT_DefinedNames ? */ case "<definedNames/>":
                break;
            case "<definedNames>":
            case "<definedNames":
                pass = true;
                break;
            case "</definedNames>":
                pass = false;
                break;
            /* 18.2.5    definedName CT_DefinedName + */ case "<definedName":
                dname = {};
                dname.Name = $3ee4f50b1ae43a89$var$utf8read(y.name);
                if (y.comment) dname.Comment = y.comment;
                if (y.localSheetId) dname.Sheet = +y.localSheetId;
                if ($3ee4f50b1ae43a89$var$parsexmlbool(y.hidden || "0")) dname.Hidden = true;
                dnstart = idx + x.length;
                break;
            case "</definedName>":
                dname.Ref = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(data.slice(dnstart, idx)));
                wb.Names.push(dname);
                break;
            case "<definedName/>":
                break;
            /* 18.2.2  calcPr CT_CalcPr ? */ case "<calcPr":
                delete y[0];
                wb.CalcPr = y;
                break;
            case "<calcPr/>":
                delete y[0];
                wb.CalcPr = y;
                break;
            case "</calcPr>":
                break;
            /* 18.2.16 oleSize CT_OleSize ? (ref required) */ case "<oleSize":
                break;
            /* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */ case "<customWorkbookViews>":
            case "</customWorkbookViews>":
            case "<customWorkbookViews":
                break;
            /* 18.2.3  customWorkbookView CT_CustomWorkbookView + */ case "<customWorkbookView":
            case "</customWorkbookView>":
                break;
            /* 18.2.18 pivotCaches CT_PivotCaches ? */ case "<pivotCaches>":
            case "</pivotCaches>":
            case "<pivotCaches":
                break;
            /* 18.2.17 pivotCache CT_PivotCache ? */ case "<pivotCache":
                break;
            /* 18.2.21 smartTagPr CT_SmartTagPr ? */ case "<smartTagPr":
            case "<smartTagPr/>":
                break;
            /* 18.2.23 smartTagTypes CT_SmartTagTypes ? */ case "<smartTagTypes":
            case "<smartTagTypes>":
            case "</smartTagTypes>":
                break;
            /* 18.2.22 smartTagType CT_SmartTagType ? */ case "<smartTagType":
                break;
            /* 18.2.24 webPublishing CT_WebPublishing ? */ case "<webPublishing":
            case "<webPublishing/>":
                break;
            /* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */ case "<fileRecoveryPr":
            case "<fileRecoveryPr/>":
                break;
            /* 18.2.26 webPublishObjects CT_WebPublishObjects ? */ case "<webPublishObjects>":
            case "<webPublishObjects":
            case "</webPublishObjects>":
                break;
            /* 18.2.25 webPublishObject CT_WebPublishObject ? */ case "<webPublishObject":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            /* 18.2.7  ext CT_Extension + */ case "<ext":
                pass = true;
                break; //TODO: check with versions of excel
            case "</ext>":
                pass = false;
                break;
            /* Others */ case "<ArchID":
                break;
            case "<AlternateContent":
            case "<AlternateContent>":
                pass = true;
                break;
            case "</AlternateContent>":
                pass = false;
                break;
            /* TODO */ case "<revisionPtr":
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in workbook");
        }
        return x;
    });
    if ($3ee4f50b1ae43a89$var$XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
    $3ee4f50b1ae43a89$var$parse_wb_defaults(wb);
    return wb;
}
function $3ee4f50b1ae43a89$var$write_wb_xml(wb /*:Workbook*/  /*::, opts:?WriteOpts*/ ) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("workbook", null, {
        "xmlns": $3ee4f50b1ae43a89$var$XMLNS_main[0],
        //'xmlns:mx': XMLNS.mx,
        //'xmlns:s': XMLNS_main[0],
        "xmlns:r": $3ee4f50b1ae43a89$var$XMLNS.r
    });
    var write_names = wb.Workbook && (wb.Workbook.Names || []).length > 0;
    /* fileVersion */ /* fileSharing */ var workbookPr /*:any*/  = {
        codeName: "ThisWorkbook"
    } /*:any*/ ;
    if (wb.Workbook && wb.Workbook.WBProps) {
        $3ee4f50b1ae43a89$var$WBPropsDef.forEach(function(x) {
            /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps[x[0]] == null) return;
            if (wb.Workbook.WBProps[x[0]] == x[1]) return;
            workbookPr[x[0]] = wb.Workbook.WBProps[x[0]];
        });
        /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps.CodeName) {
            workbookPr.codeName = wb.Workbook.WBProps.CodeName;
            delete workbookPr.CodeName;
        }
    }
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("workbookPr", null, workbookPr);
    /* workbookProtection */ var sheets = wb.Workbook && wb.Workbook.Sheets || [];
    var i = 0;
    /* bookViews only written if first worksheet is hidden */ if (sheets && sheets[0] && !!sheets[0].Hidden) {
        o[o.length] = "<bookViews>";
        for(i = 0; i != wb.SheetNames.length; ++i){
            if (!sheets[i]) break;
            if (!sheets[i].Hidden) break;
        }
        if (i == wb.SheetNames.length) i = 0;
        o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
        o[o.length] = "</bookViews>";
    }
    o[o.length] = "<sheets>";
    for(i = 0; i != wb.SheetNames.length; ++i){
        var sht = {
            name: $3ee4f50b1ae43a89$var$escapexml(wb.SheetNames[i].slice(0, 31))
        } /*:any*/ ;
        sht.sheetId = "" + (i + 1);
        sht["r:id"] = "rId" + (i + 1);
        if (sheets[i]) switch(sheets[i].Hidden){
            case 1:
                sht.state = "hidden";
                break;
            case 2:
                sht.state = "veryHidden";
                break;
        }
        o[o.length] = $3ee4f50b1ae43a89$var$writextag("sheet", null, sht);
    }
    o[o.length] = "</sheets>";
    /* functionGroups */ /* externalReferences */ if (write_names) {
        o[o.length] = "<definedNames>";
        if (wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
            var d /*:any*/  = {
                name: n.Name
            };
            if (n.Comment) d.comment = n.Comment;
            if (n.Sheet != null) d.localSheetId = "" + n.Sheet;
            if (n.Hidden) d.hidden = "1";
            if (!n.Ref) return;
            o[o.length] = $3ee4f50b1ae43a89$var$writextag("definedName", $3ee4f50b1ae43a89$var$escapexml(n.Ref), d);
        });
        o[o.length] = "</definedNames>";
    }
    /* calcPr */ /* oleSize */ /* customWorkbookViews */ /* pivotCaches */ /* smartTagPr */ /* smartTagTypes */ /* webPublishing */ /* fileRecoveryPr */ /* webPublishObjects */ /* extLst */ if (o.length > 2) {
        o[o.length] = "</workbook>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */ function $3ee4f50b1ae43a89$var$parse_BrtBundleSh(data, length /*:number*/ ) {
    var z = {};
    z.Hidden = data.read_shift(4); //hsState ST_SheetState
    z.iTabID = data.read_shift(4);
    z.strRelID = $3ee4f50b1ae43a89$var$parse_RelID(data, length - 8);
    z.name = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    return z;
}
function $3ee4f50b1ae43a89$var$write_BrtBundleSh(data, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(127);
    o.write_shift(4, data.Hidden);
    o.write_shift(4, data.iTabID);
    $3ee4f50b1ae43a89$var$write_RelID(data.strRelID, o);
    $3ee4f50b1ae43a89$var$write_XLWideString(data.name.slice(0, 31), o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.815 BrtWbProp */ function $3ee4f50b1ae43a89$var$parse_BrtWbProp(data, length) /*:WBProps*/ {
    var o /*:WBProps*/  = {} /*:any*/ ;
    var flags = data.read_shift(4);
    o.defaultThemeVersion = data.read_shift(4);
    var strName = length > 8 ? $3ee4f50b1ae43a89$var$parse_XLWideString(data) : "";
    if (strName.length > 0) o.CodeName = strName;
    o.autoCompressPictures = !!(flags & 0x10000);
    o.backupFile = !!(flags & 0x40);
    o.checkCompatibility = !!(flags & 0x1000);
    o.date1904 = !!(flags & 0x01);
    o.filterPrivacy = !!(flags & 0x08);
    o.hidePivotFieldList = !!(flags & 0x400);
    o.promptedSolutions = !!(flags & 0x10);
    o.publishItems = !!(flags & 0x800);
    o.refreshAllConnections = !!(flags & 0x40000);
    o.saveExternalLinkValues = !!(flags & 0x80);
    o.showBorderUnselectedTables = !!(flags & 0x04);
    o.showInkAnnotation = !!(flags & 0x20);
    o.showObjects = [
        "all",
        "placeholders",
        "none"
    ][flags >> 13 & 0x03];
    o.showPivotChartFilter = !!(flags & 0x8000);
    o.updateLinks = [
        "userSet",
        "never",
        "always"
    ][flags >> 8 & 0x03];
    return o;
}
function $3ee4f50b1ae43a89$var$write_BrtWbProp(data /*:?WBProps*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(72);
    var flags = 0;
    if (data) /* TODO: mirror parse_BrtWbProp fields */ {
        if (data.filterPrivacy) flags |= 0x08;
    }
    o.write_shift(4, flags);
    o.write_shift(4, 0);
    $3ee4f50b1ae43a89$var$write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
    return o.slice(0, o.l);
}
function $3ee4f50b1ae43a89$var$parse_BrtFRTArchID$(data, length) {
    var o = {};
    data.read_shift(4);
    o.ArchID = data.read_shift(4);
    data.l += length - 8;
    return o;
}
/* [MS-XLSB] 2.4.687 BrtName */ function $3ee4f50b1ae43a89$var$parse_BrtName(data, length, opts) {
    var end = data.l + length;
    data.l += 4; //var flags = data.read_shift(4);
    data.l += 1; //var chKey = data.read_shift(1);
    var itab = data.read_shift(4);
    var name = $3ee4f50b1ae43a89$var$parse_XLNameWideString(data);
    var formula = $3ee4f50b1ae43a89$var$parse_XLSBNameParsedFormula(data, 0, opts);
    var comment = $3ee4f50b1ae43a89$var$parse_XLNullableWideString(data);
    //if(0 /* fProc */) {
    // unusedstring1: XLNullableWideString
    // description: XLNullableWideString
    // helpTopic: XLNullableWideString
    // unusedstring2: XLNullableWideString
    //}
    data.l = end;
    var out = {
        Name: name,
        Ptg: formula
    } /*:any*/ ;
    if (itab < 0xFFFFFFF) out.Sheet = itab;
    if (comment) out.Comment = comment;
    return out;
}
/* [MS-XLSB] 2.1.7.61 Workbook */ function $3ee4f50b1ae43a89$var$parse_wb_bin(data, opts) /*:WorkbookFile*/ {
    var wb = {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        xmlns: ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    if (!opts) opts = {};
    opts.biff = 12;
    var Names = [];
    var supbooks = [
        []
    ];
    supbooks.SheetNames = [];
    supbooks.XTI = [];
    $3ee4f50b1ae43a89$var$XLSBRecordEnum[0x0010] = {
        n: "BrtFRTArchID$",
        f: $3ee4f50b1ae43a89$var$parse_BrtFRTArchID$
    };
    $3ee4f50b1ae43a89$var$recordhopper(data, function hopper_wb(val, R, RT) {
        switch(RT){
            case 0x009C:
                /* 'BrtBundleSh' */ supbooks.SheetNames.push(val.name);
                wb.Sheets.push(val);
                break;
            case 0x0099:
                /* 'BrtWbProp' */ wb.WBProps = val;
                break;
            case 0x0027:
                /* 'BrtName' */ if (val.Sheet != null) opts.SID = val.Sheet;
                val.Ref = $3ee4f50b1ae43a89$var$stringify_formula(val.Ptg, null, null, supbooks, opts);
                delete opts.SID;
                delete val.Ptg;
                Names.push(val);
                break;
            case 0x040C:
                break;
            case 0x0165:
            /* 'BrtSupSelf' */ case 0x0166:
            /* 'BrtSupSame' */ case 0x0163:
            /* 'BrtSupBookSrc' */ case 0x029B:
                /* 'BrtSupAddin' */ if (!supbooks[0].length) supbooks[0] = [
                    RT,
                    val
                ];
                else supbooks.push([
                    RT,
                    val
                ]);
                supbooks[supbooks.length - 1].XTI = [];
                break;
            case 0x016A:
                /* 'BrtExternSheet' */ if (supbooks.length === 0) {
                    supbooks[0] = [];
                    supbooks[0].XTI = [];
                }
                supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                supbooks.XTI = supbooks.XTI.concat(val);
                break;
            case 0x0169:
                break;
            case 0x0817:
            /* 'BrtAbsPath15' */ case 0x009E:
            /* 'BrtBookView' */ case 0x008F:
            /* 'BrtBeginBundleShs' */ case 0x0298:
            /* 'BrtBeginFnGroup' */ case 0x0161:
                break;
            /* case 'BrtModelTimeGroupingCalcCol' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0C01:
            /* 'BrtRevisionPtr' */ case 0x0216:
            /* 'BrtBookProtection' */ case 0x02A5:
            /* 'BrtBookProtectionIso' */ case 0x009D:
            /* 'BrtCalcProp' */ case 0x0262:
            /* 'BrtCrashRecErr' */ case 0x0802:
            /* 'BrtDecoupledPivotCacheID' */ case 0x009B:
            /* 'BrtFileRecover' */ case 0x0224:
            /* 'BrtFileSharing' */ case 0x02A4:
            /* 'BrtFileSharingIso' */ case 0x0080:
            /* 'BrtFileVersion' */ case 0x0299:
            /* 'BrtFnGroup' */ case 0x0850:
            /* 'BrtModelRelationship' */ case 0x084D:
            /* 'BrtModelTable' */ case 0x0225:
            /* 'BrtOleSize' */ case 0x0805:
            /* 'BrtPivotTableRef' */ case 0x0254:
            /* 'BrtSmartTagType' */ case 0x081C:
            /* 'BrtTableSlicerCacheID' */ case 0x081B:
            /* 'BrtTableSlicerCacheIDs' */ case 0x0822:
            /* 'BrtTimelineCachePivotCacheID' */ case 0x018D:
            /* 'BrtUserBookView' */ case 0x009A:
            /* 'BrtWbFactoid' */ case 0x045D:
            /* 'BrtWbProp14' */ case 0x0229:
            /* 'BrtWebOpt' */ case 0x082B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ state.pop();
                pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            case 0x0010:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */  && state[state.length - 1] != 0x0023 /* BrtFRTBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    $3ee4f50b1ae43a89$var$parse_wb_defaults(wb);
    // $FlowIgnore
    wb.Names = Names;
    wb /*:any*/ .supbooks = supbooks;
    return wb;
}
function $3ee4f50b1ae43a89$var$write_BUNDLESHS(ba, wb /*::, opts*/ ) {
    $3ee4f50b1ae43a89$var$write_record(ba, 0x008F /* BrtBeginBundleShs */ );
    for(var idx = 0; idx != wb.SheetNames.length; ++idx){
        var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
        var d = {
            Hidden: viz,
            iTabID: idx + 1,
            strRelID: "rId" + (idx + 1),
            name: wb.SheetNames[idx]
        };
        $3ee4f50b1ae43a89$var$write_record(ba, 0x009C /* BrtBundleSh */ , $3ee4f50b1ae43a89$var$write_BrtBundleSh(d));
    }
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0090 /* BrtEndBundleShs */ );
}
/* [MS-XLSB] 2.4.649 BrtFileVersion */ function $3ee4f50b1ae43a89$var$write_BrtFileVersion(data, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(127);
    for(var i = 0; i != 4; ++i)o.write_shift(4, 0);
    $3ee4f50b1ae43a89$var$write_XLWideString("SheetJS", o);
    $3ee4f50b1ae43a89$var$write_XLWideString($3ee4f50b1ae43a89$var$XLSX.version, o);
    $3ee4f50b1ae43a89$var$write_XLWideString($3ee4f50b1ae43a89$var$XLSX.version, o);
    $3ee4f50b1ae43a89$var$write_XLWideString("7262", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.301 BrtBookView */ function $3ee4f50b1ae43a89$var$write_BrtBookView(idx, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(29);
    o.write_shift(-4, 0);
    o.write_shift(-4, 460);
    o.write_shift(4, 28800);
    o.write_shift(4, 17600);
    o.write_shift(4, 500);
    o.write_shift(4, idx);
    o.write_shift(4, idx);
    var flags = 0x78;
    o.write_shift(1, flags);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $3ee4f50b1ae43a89$var$write_BOOKVIEWS(ba, wb /*::, opts*/ ) {
    /* required if hidden tab appears before visible tab */ if (!wb.Workbook || !wb.Workbook.Sheets) return;
    var sheets = wb.Workbook.Sheets;
    var i = 0, vistab = -1, hidden = -1;
    for(; i < sheets.length; ++i){
        if (!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
        else if (sheets[i].Hidden == 1 && hidden == -1) hidden = i;
    }
    if (hidden > vistab) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0087 /* BrtBeginBookViews */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x009E /* BrtBookView */ , $3ee4f50b1ae43a89$var$write_BrtBookView(vistab));
    /* 1*(BrtBookView *FRT) */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0088 /* BrtEndBookViews */ );
}
/* [MS-XLSB] 2.4.305 BrtCalcProp */ /*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/ /* [MS-XLSB] 2.4.646 BrtFileRecover */ /*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/ /* [MS-XLSB] 2.1.7.61 Workbook */ function $3ee4f50b1ae43a89$var$write_wb_bin(wb, opts) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0083 /* BrtBeginBook */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0080 /* BrtFileVersion */ , $3ee4f50b1ae43a89$var$write_BrtFileVersion());
    /* [[BrtFileSharingIso] BrtFileSharing] */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0099 /* BrtWbProp */ , $3ee4f50b1ae43a89$var$write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
    /* [ACABSPATH] */ /* [[BrtBookProtectionIso] BrtBookProtection] */ $3ee4f50b1ae43a89$var$write_BOOKVIEWS(ba, wb, opts);
    $3ee4f50b1ae43a89$var$write_BUNDLESHS(ba, wb, opts);
    /* [FNGROUP] */ /* [EXTERNALS] */ /* *BrtName */ /* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */ /* [BrtOleSize] */ /* *(BrtUserBookView *FRT) */ /* [PIVOTCACHEIDS] */ /* [BrtWbFactoid] */ /* [SMARTTAGTYPES] */ /* [BrtWebOpt] */ /* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */ /* [WEBPUBITEMS] */ /* [CRERRS] */ /* FRTWORKBOOK */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0084 /* BrtEndBook */ );
    return ba.end();
}
function $3ee4f50b1ae43a89$var$parse_wb(data, name /*:string*/ , opts) /*:WorkbookFile*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_wb_bin(data /*:any*/ , opts);
    return $3ee4f50b1ae43a89$var$parse_wb_xml(data /*:any*/ , opts);
}
function $3ee4f50b1ae43a89$var$parse_ws(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_ws_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $3ee4f50b1ae43a89$var$parse_ws_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $3ee4f50b1ae43a89$var$parse_cs(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_cs_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $3ee4f50b1ae43a89$var$parse_cs_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $3ee4f50b1ae43a89$var$parse_ms(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_ms_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $3ee4f50b1ae43a89$var$parse_ms_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $3ee4f50b1ae43a89$var$parse_ds(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_ds_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $3ee4f50b1ae43a89$var$parse_ds_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $3ee4f50b1ae43a89$var$parse_sty(data, name /*:string*/ , themes, opts) {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_sty_bin(data /*:any*/ , themes, opts);
    return $3ee4f50b1ae43a89$var$parse_sty_xml(data /*:any*/ , themes, opts);
}
function $3ee4f50b1ae43a89$var$parse_theme(data /*:string*/ , name /*:string*/ , opts) {
    return $3ee4f50b1ae43a89$var$parse_theme_xml(data, opts);
}
function $3ee4f50b1ae43a89$var$parse_sst(data, name /*:string*/ , opts) /*:SST*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_sst_bin(data /*:any*/ , opts);
    return $3ee4f50b1ae43a89$var$parse_sst_xml(data /*:any*/ , opts);
}
function $3ee4f50b1ae43a89$var$parse_cmnt(data, name /*:string*/ , opts) /*:Array<RawComment>*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_comments_bin(data /*:any*/ , opts);
    return $3ee4f50b1ae43a89$var$parse_comments_xml(data /*:any*/ , opts);
}
function $3ee4f50b1ae43a89$var$parse_cc(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_cc_bin(data /*:any*/ , name, opts);
    return $3ee4f50b1ae43a89$var$parse_cc_xml(data /*:any*/ , name, opts);
}
function $3ee4f50b1ae43a89$var$parse_xlink(data, rel, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_xlink_bin(data /*:any*/ , rel, name, opts);
    return $3ee4f50b1ae43a89$var$parse_xlink_xml(data /*:any*/ , rel, name, opts);
}
function $3ee4f50b1ae43a89$var$parse_xlmeta(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_xlmeta_bin(data /*:any*/ , name, opts);
    return $3ee4f50b1ae43a89$var$parse_xlmeta_xml(data /*:any*/ , name, opts);
}
function $3ee4f50b1ae43a89$var$write_wb(wb, name /*:string*/ , opts) {
    return (name.slice(-4) === ".bin" ? $3ee4f50b1ae43a89$var$write_wb_bin : $3ee4f50b1ae43a89$var$write_wb_xml)(wb, opts);
}
function $3ee4f50b1ae43a89$var$write_ws(data /*:number*/ , name /*:string*/ , opts, wb /*:Workbook*/ , rels) {
    return (name.slice(-4) === ".bin" ? $3ee4f50b1ae43a89$var$write_ws_bin : $3ee4f50b1ae43a89$var$write_ws_xml)(data, opts, wb, rels);
}
// eslint-disable-next-line no-unused-vars
function $3ee4f50b1ae43a89$var$write_cs(data /*:number*/ , name /*:string*/ , opts, wb /*:Workbook*/ , rels) {
    return (name.slice(-4) === ".bin" ? $3ee4f50b1ae43a89$var$write_cs_bin : $3ee4f50b1ae43a89$var$write_cs_xml)(data, opts, wb, rels);
}
function $3ee4f50b1ae43a89$var$write_sty(data, name /*:string*/ , opts) {
    return (name.slice(-4) === ".bin" ? $3ee4f50b1ae43a89$var$write_sty_bin : $3ee4f50b1ae43a89$var$write_sty_xml)(data, opts);
}
function $3ee4f50b1ae43a89$var$write_sst(data /*:SST*/ , name /*:string*/ , opts) {
    return (name.slice(-4) === ".bin" ? $3ee4f50b1ae43a89$var$write_sst_bin : $3ee4f50b1ae43a89$var$write_sst_xml)(data, opts);
}
function $3ee4f50b1ae43a89$var$write_cmnt(data /*:Array<any>*/ , name /*:string*/ , opts) {
    return (name.slice(-4) === ".bin" ? $3ee4f50b1ae43a89$var$write_comments_bin : $3ee4f50b1ae43a89$var$write_comments_xml)(data, opts);
}
/*
function write_cc(data, name:string, opts) {
	return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
}
*/ function $3ee4f50b1ae43a89$var$write_xlmeta(name /*:string*/ ) {
    return (name.slice(-4) === ".bin" ? $3ee4f50b1ae43a89$var$write_xlmeta_bin : $3ee4f50b1ae43a89$var$write_xlmeta_xml)();
}
var $3ee4f50b1ae43a89$var$attregexg2 = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var $3ee4f50b1ae43a89$var$attregex2 = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function $3ee4f50b1ae43a89$var$xlml_parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ ) {
    var words = tag.split(/\s+/);
    var z /*:any*/  = [];
    if (!skip_root) z[0] = words[0];
    if (words.length === 1) return z;
    var m = tag.match($3ee4f50b1ae43a89$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($3ee4f50b1ae43a89$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
function $3ee4f50b1ae43a89$var$xlml_parsexmltagobj(tag /*:string*/ ) {
    var words = tag.split(/\s+/);
    var z = {};
    if (words.length === 1) return z;
    var m = tag.match($3ee4f50b1ae43a89$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($3ee4f50b1ae43a89$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
// ----
/* map from xlml named formats to SSF TODO: localize */ var $3ee4f50b1ae43a89$var$XLMLFormatMap /*: {[string]:string}*/ ;
function $3ee4f50b1ae43a89$var$xlml_format(format, value) /*:string*/ {
    var fmt = $3ee4f50b1ae43a89$var$XLMLFormatMap[format] || $3ee4f50b1ae43a89$var$unescapexml(format);
    if (fmt === "General") return $3ee4f50b1ae43a89$var$SSF_general(value);
    return $3ee4f50b1ae43a89$var$SSF_format(fmt, value);
}
function $3ee4f50b1ae43a89$var$xlml_set_custprop(Custprops, key, cp, val /*:string*/ ) {
    var oval /*:any*/  = val;
    switch((cp[0].match(/dt:dt="([\w.]+)"/) || [
        "",
        ""
    ])[1]){
        case "boolean":
            oval = $3ee4f50b1ae43a89$var$parsexmlbool(val);
            break;
        case "i2":
        case "int":
            oval = parseInt(val, 10);
            break;
        case "r4":
        case "float":
            oval = parseFloat(val);
            break;
        case "date":
        case "dateTime.tz":
            oval = $3ee4f50b1ae43a89$var$parseDate(val);
            break;
        case "i8":
        case "string":
        case "fixed":
        case "uuid":
        case "bin.base64":
            break;
        default:
            throw new Error("bad custprop:" + cp[0]);
    }
    Custprops[$3ee4f50b1ae43a89$var$unescapexml(key)] = oval;
}
function $3ee4f50b1ae43a89$var$safe_format_xlml(cell /*:Cell*/ , nf, o) {
    if (cell.t === "z") return;
    if (!o || o.cellText !== false) try {
        if (cell.t === "e") cell.w = cell.w || $3ee4f50b1ae43a89$var$BErr[cell.v];
        else if (nf === "General") {
            if (cell.t === "n") {
                if ((cell.v | 0) === cell.v) cell.w = cell.v.toString(10);
                else cell.w = $3ee4f50b1ae43a89$var$SSF_general_num(cell.v);
            } else cell.w = $3ee4f50b1ae43a89$var$SSF_general(cell.v);
        } else cell.w = $3ee4f50b1ae43a89$var$xlml_format(nf || "General", cell.v);
    } catch (e) {
        if (o.WTF) throw e;
    }
    try {
        var z = $3ee4f50b1ae43a89$var$XLMLFormatMap[nf] || nf || "General";
        if (o.cellNF) cell.z = z;
        if (o.cellDates && cell.t == "n" && $3ee4f50b1ae43a89$var$fmt_is_date(z)) {
            var _d = $3ee4f50b1ae43a89$var$SSF_parse_date_code(cell.v);
            if (_d) {
                cell.t = "d";
                cell.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
            }
        }
    } catch (e) {
        if (o.WTF) throw e;
    }
}
function $3ee4f50b1ae43a89$var$process_style_xlml(styles, stag, opts) {
    if (opts.cellStyles) {
        if (stag.Interior) {
            var I = stag.Interior;
            if (I.Pattern) I.patternType = $3ee4f50b1ae43a89$var$XLMLPatternTypeMap[I.Pattern] || I.Pattern;
        }
    }
    styles[stag.ID] = stag;
}
/* TODO: there must exist some form of OSP-blessed spec */ function $3ee4f50b1ae43a89$var$parse_xlml_data(xml, ss, data, cell /*:any*/ , base, styles, csty, row, arrayf, o) {
    var nf = "General", sid = cell.StyleID, S = {};
    o = o || {};
    var interiors = [];
    var i = 0;
    if (sid === undefined && row) sid = row.StyleID;
    if (sid === undefined && csty) sid = csty.StyleID;
    while(styles[sid] !== undefined){
        if (styles[sid].nf) nf = styles[sid].nf;
        if (styles[sid].Interior) interiors.push(styles[sid].Interior);
        if (!styles[sid].Parent) break;
        sid = styles[sid].Parent;
    }
    switch(data.Type){
        case "Boolean":
            cell.t = "b";
            cell.v = $3ee4f50b1ae43a89$var$parsexmlbool(xml);
            break;
        case "String":
            cell.t = "s";
            cell.r = $3ee4f50b1ae43a89$var$xlml_fixstr($3ee4f50b1ae43a89$var$unescapexml(xml));
            cell.v = xml.indexOf("<") > -1 ? $3ee4f50b1ae43a89$var$unescapexml(ss || xml).replace(/<.*?>/g, "") : cell.r; // todo: BR etc
            break;
        case "DateTime":
            if (xml.slice(-1) != "Z") xml += "Z";
            cell.v = ($3ee4f50b1ae43a89$var$parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / 86400000;
            if (cell.v !== cell.v) cell.v = $3ee4f50b1ae43a89$var$unescapexml(xml);
            else if (cell.v < 60) cell.v = cell.v - 1;
            if (!nf || nf == "General") nf = "yyyy-mm-dd";
        /* falls through */ case "Number":
            if (cell.v === undefined) cell.v = +xml;
            if (!cell.t) cell.t = "n";
            break;
        case "Error":
            cell.t = "e";
            cell.v = $3ee4f50b1ae43a89$var$RBErr[xml];
            if (o.cellText !== false) cell.w = xml;
            break;
        default:
            if (xml == "" && ss == "") cell.t = "z";
            else {
                cell.t = "s";
                cell.v = $3ee4f50b1ae43a89$var$xlml_fixstr(ss || xml);
            }
            break;
    }
    $3ee4f50b1ae43a89$var$safe_format_xlml(cell, nf, o);
    if (o.cellFormula !== false) {
        if (cell.Formula) {
            var fstr = $3ee4f50b1ae43a89$var$unescapexml(cell.Formula);
            /* strictly speaking, the leading = is required but some writers omit */ if (fstr.charCodeAt(0) == 61 /* = */ ) fstr = fstr.slice(1);
            cell.f = $3ee4f50b1ae43a89$var$rc_to_a1(fstr, base);
            delete cell.Formula;
            if (cell.ArrayRange == "RC") cell.F = $3ee4f50b1ae43a89$var$rc_to_a1("RC:RC", base);
            else if (cell.ArrayRange) {
                cell.F = $3ee4f50b1ae43a89$var$rc_to_a1(cell.ArrayRange, base);
                arrayf.push([
                    $3ee4f50b1ae43a89$var$safe_decode_range(cell.F),
                    cell.F
                ]);
            }
        } else {
            for(i = 0; i < arrayf.length; ++i)if (base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r) {
                if (base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c) cell.F = arrayf[i][1];
            }
        }
    }
    if (o.cellStyles) {
        interiors.forEach(function(x) {
            if (!S.patternType && x.patternType) S.patternType = x.patternType;
        });
        cell.s = S;
    }
    if (cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}
function $3ee4f50b1ae43a89$var$xlml_clean_comment(comment /*:any*/ ) {
    comment.t = comment.v || "";
    comment.t = comment.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    comment.v = comment.w = comment.ixfe = undefined;
}
/* TODO: Everything */ function $3ee4f50b1ae43a89$var$parse_xlml_xml(d, _opts) /*:Workbook*/ {
    var opts = _opts || {};
    $3ee4f50b1ae43a89$var$make_ssf();
    var str = $3ee4f50b1ae43a89$var$debom($3ee4f50b1ae43a89$var$xlml_normalize(d));
    if (opts.type == "binary" || opts.type == "array" || opts.type == "base64") {
        if (typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined") str = $3ee4f50b1ae43a89$var$$cptable.utils.decode(65001, $3ee4f50b1ae43a89$var$char_codes(str));
        else str = $3ee4f50b1ae43a89$var$utf8read(str);
    }
    var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
    opening = opening.replace(/".*?"/g, "");
    if ((opening.indexOf(">") & 1023) > Math.min(opening.indexOf(",") & 1023, opening.indexOf(";") & 1023)) {
        var _o = $3ee4f50b1ae43a89$var$dup(opts);
        _o.type = "string";
        return $3ee4f50b1ae43a89$var$PRN.to_workbook(str, _o);
    }
    if (opening.indexOf("<?xml") == -1) [
        "html",
        "table",
        "head",
        "meta",
        "script",
        "style",
        "div"
    ].forEach(function(tag) {
        if (opening.indexOf("<" + tag) >= 0) ishtml = true;
    });
    if (ishtml) return $3ee4f50b1ae43a89$var$html_to_workbook(str, opts);
    $3ee4f50b1ae43a89$var$XLMLFormatMap = {
        "General Number": "General",
        "General Date": $3ee4f50b1ae43a89$var$table_fmt[22],
        "Long Date": "dddd, mmmm dd, yyyy",
        "Medium Date": $3ee4f50b1ae43a89$var$table_fmt[15],
        "Short Date": $3ee4f50b1ae43a89$var$table_fmt[14],
        "Long Time": $3ee4f50b1ae43a89$var$table_fmt[19],
        "Medium Time": $3ee4f50b1ae43a89$var$table_fmt[18],
        "Short Time": $3ee4f50b1ae43a89$var$table_fmt[20],
        "Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        "Fixed": $3ee4f50b1ae43a89$var$table_fmt[2],
        "Standard": $3ee4f50b1ae43a89$var$table_fmt[4],
        "Percent": $3ee4f50b1ae43a89$var$table_fmt[10],
        "Scientific": $3ee4f50b1ae43a89$var$table_fmt[11],
        "Yes/No": '"Yes";"Yes";"No";@',
        "True/False": '"True";"True";"False";@',
        "On/Off": '"Yes";"Yes";"No";@'
    } /*:any*/ ;
    var Rn;
    var state = [], tmp;
    if ($3ee4f50b1ae43a89$var$DENSE != null && opts.dense == null) opts.dense = $3ee4f50b1ae43a89$var$DENSE;
    var sheets = {}, sheetnames /*:Array<string>*/  = [], cursheet /*:Worksheet*/  = opts.dense ? [] : {}, sheetname = "";
    var cell = {} /*:any*/ , row = {}; // eslint-disable-line no-unused-vars
    var dtag = $3ee4f50b1ae43a89$var$xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
    var c = 0, r = 0;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var styles = {}, stag = {};
    var ss = "", fidx = 0;
    var merges /*:Array<Range>*/  = [];
    var Props = {}, Custprops = {}, pidx = 0, cp = [];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var cstys = [], csty, seencol = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var rowinfo /*:Array<RowInfo>*/  = [], rowobj = {}, cc = 0, rr = 0;
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        }
    } /*:any*/ , wsprops = {};
    $3ee4f50b1ae43a89$var$xlmlregex.lastIndex = 0;
    str = str.replace(/<!--([\s\S]*?)-->/mg, "");
    var raw_Rn3 = "";
    while(Rn = $3ee4f50b1ae43a89$var$xlmlregex.exec(str))switch(Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase()){
        case "data" /*case 'Data'*/ :
            if (raw_Rn3 == "data") {
                if (Rn[1] === "/") {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                    Rn[3],
                    true
                ]);
                break;
            }
            if (state[state.length - 1][1]) break;
            if (Rn[1] === "/") $3ee4f50b1ae43a89$var$parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length - 1][0] == /*"Comment"*/ "comment" ? comment : cell, {
                c: c,
                r: r
            }, styles, cstys[c], row, arrayf, opts);
            else {
                ss = "";
                dtag = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                didx = Rn.index + Rn[0].length;
            }
            break;
        case "cell" /*case 'Cell'*/ :
            if (Rn[1] === "/") {
                if (comments.length > 0) cell.c = comments;
                if ((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
                    if (opts.dense) {
                        if (!cursheet[r]) cursheet[r] = [];
                        cursheet[r][c] = cell;
                    } else cursheet[$3ee4f50b1ae43a89$var$encode_col(c) + $3ee4f50b1ae43a89$var$encode_row(r)] = cell;
                }
                if (cell.HRef) {
                    cell.l = {
                        Target: $3ee4f50b1ae43a89$var$unescapexml(cell.HRef)
                    } /*:any*/ ;
                    if (cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
                    delete cell.HRef;
                    delete cell.HRefScreenTip;
                }
                if (cell.MergeAcross || cell.MergeDown) {
                    cc = c + (parseInt(cell.MergeAcross, 10) | 0);
                    rr = r + (parseInt(cell.MergeDown, 10) | 0);
                    merges.push({
                        s: {
                            c: c,
                            r: r
                        },
                        e: {
                            c: cc,
                            r: rr
                        }
                    });
                }
                if (!opts.sheetStubs) {
                    if (cell.MergeAcross) c = cc + 1;
                    else ++c;
                } else if (cell.MergeAcross || cell.MergeDown) {
                    /*:: if(!cc) cc = 0; if(!rr) rr = 0; */ for(var cma = c; cma <= cc; ++cma){
                        for(var cmd = r; cmd <= rr; ++cmd)if (cma > c || cmd > r) {
                            if (opts.dense) {
                                if (!cursheet[cmd]) cursheet[cmd] = [];
                                cursheet[cmd][cma] = {
                                    t: "z"
                                };
                            } else cursheet[$3ee4f50b1ae43a89$var$encode_col(cma) + $3ee4f50b1ae43a89$var$encode_row(cmd)] = {
                                t: "z"
                            };
                        }
                    }
                    c = cc + 1;
                } else ++c;
            } else {
                cell = $3ee4f50b1ae43a89$var$xlml_parsexmltagobj(Rn[0]);
                if (cell.Index) c = +cell.Index - 1;
                if (c < refguess.s.c) refguess.s.c = c;
                if (c > refguess.e.c) refguess.e.c = c;
                if (Rn[0].slice(-2) === "/>") ++c;
                comments = [];
            }
            break;
        case "row" /*case 'Row'*/ :
            if (Rn[1] === "/" || Rn[0].slice(-2) === "/>") {
                if (r < refguess.s.r) refguess.s.r = r;
                if (r > refguess.e.r) refguess.e.r = r;
                if (Rn[0].slice(-2) === "/>") {
                    row = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                    if (row.Index) r = +row.Index - 1;
                }
                c = 0;
                ++r;
            } else {
                row = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                if (row.Index) r = +row.Index - 1;
                rowobj = {};
                if (row.AutoFitHeight == "0" || row.Height) {
                    rowobj.hpx = parseInt(row.Height, 10);
                    rowobj.hpt = $3ee4f50b1ae43a89$var$px2pt(rowobj.hpx);
                    rowinfo[r] = rowobj;
                }
                if (row.Hidden == "1") {
                    rowobj.hidden = true;
                    rowinfo[r] = rowobj;
                }
            }
            break;
        case "worksheet" /*case 'Worksheet'*/ :
            /* TODO: read range from FullRows/FullColumns */ if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                sheetnames.push(sheetname);
                if (refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
                    cursheet["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
                    if (opts.sheetRows && opts.sheetRows <= refguess.e.r) {
                        cursheet["!fullref"] = cursheet["!ref"];
                        refguess.e.r = opts.sheetRows - 1;
                        cursheet["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
                    }
                }
                if (merges.length) cursheet["!merges"] = merges;
                if (cstys.length > 0) cursheet["!cols"] = cstys;
                if (rowinfo.length > 0) cursheet["!rows"] = rowinfo;
                sheets[sheetname] = cursheet;
            } else {
                refguess = {
                    s: {
                        r: 2000000,
                        c: 2000000
                    },
                    e: {
                        r: 0,
                        c: 0
                    }
                };
                r = c = 0;
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                sheetname = $3ee4f50b1ae43a89$var$unescapexml(tmp.Name);
                cursheet = opts.dense ? [] : {};
                merges = [];
                arrayf = [];
                rowinfo = [];
                wsprops = {
                    name: sheetname,
                    Hidden: 0
                };
                Workbook.Sheets.push(wsprops);
            }
            break;
        case "table" /*case 'Table'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].slice(-2) == "/>") break;
            else {
                state.push([
                    Rn[3],
                    false
                ]);
                cstys = [];
                seencol = false;
            }
            break;
        case "style" /*case 'Style'*/ :
            if (Rn[1] === "/") $3ee4f50b1ae43a89$var$process_style_xlml(styles, stag, opts);
            else stag = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
            break;
        case "numberformat" /*case 'NumberFormat'*/ :
            stag.nf = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]).Format || "General");
            if ($3ee4f50b1ae43a89$var$XLMLFormatMap[stag.nf]) stag.nf = $3ee4f50b1ae43a89$var$XLMLFormatMap[stag.nf];
            for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx)if ($3ee4f50b1ae43a89$var$table_fmt[ssfidx] == stag.nf) break;
            if (ssfidx == 0x188) {
                for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx)if ($3ee4f50b1ae43a89$var$table_fmt[ssfidx] == null) {
                    $3ee4f50b1ae43a89$var$SSF_load(stag.nf, ssfidx);
                    break;
                }
            }
            break;
        case "column" /*case 'Column'*/ :
            if (state[state.length - 1][0] !== /*'Table'*/ "table") break;
            csty = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
            if (csty.Hidden) {
                csty.hidden = true;
                delete csty.Hidden;
            }
            if (csty.Width) csty.wpx = parseInt(csty.Width, 10);
            if (!seencol && csty.wpx > 10) {
                seencol = true;
                $3ee4f50b1ae43a89$var$MDW = $3ee4f50b1ae43a89$var$DEF_MDW; //find_mdw_wpx(csty.wpx);
                for(var _col = 0; _col < cstys.length; ++_col)if (cstys[_col]) $3ee4f50b1ae43a89$var$process_col(cstys[_col]);
            }
            if (seencol) $3ee4f50b1ae43a89$var$process_col(csty);
            cstys[csty.Index - 1 || cstys.length] = csty;
            for(var i = 0; i < +csty.Span; ++i)cstys[cstys.length] = $3ee4f50b1ae43a89$var$dup(csty);
            break;
        case "namedrange" /*case 'NamedRange'*/ :
            if (Rn[1] === "/") break;
            if (!Workbook.Names) Workbook.Names = [];
            var _NamedRange = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0]);
            var _DefinedName /*:DefinedName*/  = {
                Name: _NamedRange.Name,
                Ref: $3ee4f50b1ae43a89$var$rc_to_a1(_NamedRange.RefersTo.slice(1), {
                    r: 0,
                    c: 0
                })
            } /*:any*/ ;
            if (Workbook.Sheets.length > 0) _DefinedName.Sheet = Workbook.Sheets.length - 1;
            /*:: if(Workbook.Names) */ Workbook.Names.push(_DefinedName);
            break;
        case "namedcell" /*case 'NamedCell'*/ :
            break;
        case "b" /*case 'B'*/ :
            break;
        case "i" /*case 'I'*/ :
            break;
        case "u" /*case 'U'*/ :
            break;
        case "s" /*case 'S'*/ :
            break;
        case "em" /*case 'EM'*/ :
            break;
        case "h2" /*case 'H2'*/ :
            break;
        case "h3" /*case 'H3'*/ :
            break;
        case "sub" /*case 'Sub'*/ :
            break;
        case "sup" /*case 'Sup'*/ :
            break;
        case "span" /*case 'Span'*/ :
            break;
        case "alignment" /*case 'Alignment'*/ :
            break;
        case "borders" /*case 'Borders'*/ :
            break;
        case "border" /*case 'Border'*/ :
            break;
        case "font" /*case 'Font'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") ss += str.slice(fidx, Rn.index);
            else fidx = Rn.index + Rn[0].length;
            break;
        case "interior" /*case 'Interior'*/ :
            if (!opts.cellStyles) break;
            stag.Interior = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
            break;
        case "protection" /*case 'Protection'*/ :
            break;
        case "author" /*case 'Author'*/ :
        case "title" /*case 'Title'*/ :
        case "description" /*case 'Description'*/ :
        case "created" /*case 'Created'*/ :
        case "keywords" /*case 'Keywords'*/ :
        case "subject" /*case 'Subject'*/ :
        case "category" /*case 'Category'*/ :
        case "company" /*case 'Company'*/ :
        case "lastauthor" /*case 'LastAuthor'*/ :
        case "lastsaved" /*case 'LastSaved'*/ :
        case "lastprinted" /*case 'LastPrinted'*/ :
        case "version" /*case 'Version'*/ :
        case "revision" /*case 'Revision'*/ :
        case "totaltime" /*case 'TotalTime'*/ :
        case "hyperlinkbase" /*case 'HyperlinkBase'*/ :
        case "manager" /*case 'Manager'*/ :
        case "contentstatus" /*case 'ContentStatus'*/ :
        case "identifier" /*case 'Identifier'*/ :
        case "language" /*case 'Language'*/ :
        case "appname" /*case 'AppName'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") $3ee4f50b1ae43a89$var$xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
            else pidx = Rn.index + Rn[0].length;
            break;
        case "paragraphs" /*case 'Paragraphs'*/ :
            break;
        case "styles" /*case 'Styles'*/ :
        case "workbook" /*case 'Workbook'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else state.push([
                Rn[3],
                false
            ]);
            break;
        case "comment" /*case 'Comment'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                $3ee4f50b1ae43a89$var$xlml_clean_comment(comment);
                comments.push(comment);
            } else {
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                comment = {
                    a: tmp.Author
                } /*:any*/ ;
            }
            break;
        case "autofilter" /*case 'AutoFilter'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                var AutoFilter = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                cursheet["!autofilter"] = {
                    ref: $3ee4f50b1ae43a89$var$rc_to_a1(AutoFilter.Range).replace(/\$/g, "")
                };
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case "name" /*case 'Name'*/ :
            break;
        case "datavalidation" /*case 'DataValidation'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                true
            ]);
            break;
        case "pixelsperinch" /*case 'PixelsPerInch'*/ :
            break;
        case "componentoptions" /*case 'ComponentOptions'*/ :
        case "documentproperties" /*case 'DocumentProperties'*/ :
        case "customdocumentproperties" /*case 'CustomDocumentProperties'*/ :
        case "officedocumentsettings" /*case 'OfficeDocumentSettings'*/ :
        case "pivottable" /*case 'PivotTable'*/ :
        case "pivotcache" /*case 'PivotCache'*/ :
        case "names" /*case 'Names'*/ :
        case "mapinfo" /*case 'MapInfo'*/ :
        case "pagebreaks" /*case 'PageBreaks'*/ :
        case "querytable" /*case 'QueryTable'*/ :
        case "sorting" /*case 'Sorting'*/ :
        case "schema" /*case 'Schema'*/ :
        case "conditionalformatting" /*case 'ConditionalFormatting'*/ :
        case "smarttagtype" /*case 'SmartTagType'*/ :
        case "smarttags" /*case 'SmartTags'*/ :
        case "excelworkbook" /*case 'ExcelWorkbook'*/ :
        case "workbookoptions" /*case 'WorkbookOptions'*/ :
        case "worksheetoptions" /*case 'WorksheetOptions'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                true
            ]);
            break;
        case "null" /*case 'Null'*/ :
            break;
        default:
            /* FODS file root is <office:document> */ if (state.length == 0 && Rn[3] == "document") return $3ee4f50b1ae43a89$var$parse_fods(str, opts);
            /* UOS file root is <uof:UOF> */ if (state.length == 0 && Rn[3] == "uof" /*"UOF"*/ ) return $3ee4f50b1ae43a89$var$parse_fods(str, opts);
            var seen = true;
            switch(state[state.length - 1][0]){
                /* OfficeDocumentSettings */ case "officedocumentsettings" /*case 'OfficeDocumentSettings'*/ :
                    switch(Rn[3]){
                        case "allowpng" /*case 'AllowPNG'*/ :
                            break;
                        case "removepersonalinformation" /*case 'RemovePersonalInformation'*/ :
                            break;
                        case "downloadcomponents" /*case 'DownloadComponents'*/ :
                            break;
                        case "locationofcomponents" /*case 'LocationOfComponents'*/ :
                            break;
                        case "colors" /*case 'Colors'*/ :
                            break;
                        case "color" /*case 'Color'*/ :
                            break;
                        case "index" /*case 'Index'*/ :
                            break;
                        case "rgb" /*case 'RGB'*/ :
                            break;
                        case "targetscreensize" /*case 'TargetScreenSize'*/ :
                            break;
                        case "readonlyrecommended" /*case 'ReadOnlyRecommended'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ComponentOptions */ case "componentoptions" /*case 'ComponentOptions'*/ :
                    switch(Rn[3]){
                        case "toolbar" /*case 'Toolbar'*/ :
                            break;
                        case "hideofficelogo" /*case 'HideOfficeLogo'*/ :
                            break;
                        case "spreadsheetautofit" /*case 'SpreadsheetAutoFit'*/ :
                            break;
                        case "label" /*case 'Label'*/ :
                            break;
                        case "caption" /*case 'Caption'*/ :
                            break;
                        case "maxheight" /*case 'MaxHeight'*/ :
                            break;
                        case "maxwidth" /*case 'MaxWidth'*/ :
                            break;
                        case "nextsheetnumber" /*case 'NextSheetNumber'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ExcelWorkbook */ case "excelworkbook" /*case 'ExcelWorkbook'*/ :
                    switch(Rn[3]){
                        case "date1904" /*case 'Date1904'*/ :
                            /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ Workbook.WBProps.date1904 = true;
                            break;
                        case "windowheight" /*case 'WindowHeight'*/ :
                            break;
                        case "windowwidth" /*case 'WindowWidth'*/ :
                            break;
                        case "windowtopx" /*case 'WindowTopX'*/ :
                            break;
                        case "windowtopy" /*case 'WindowTopY'*/ :
                            break;
                        case "tabratio" /*case 'TabRatio'*/ :
                            break;
                        case "protectstructure" /*case 'ProtectStructure'*/ :
                            break;
                        case "protectwindow" /*case 'ProtectWindow'*/ :
                            break;
                        case "protectwindows" /*case 'ProtectWindows'*/ :
                            break;
                        case "activesheet" /*case 'ActiveSheet'*/ :
                            break;
                        case "displayinknotes" /*case 'DisplayInkNotes'*/ :
                            break;
                        case "firstvisiblesheet" /*case 'FirstVisibleSheet'*/ :
                            break;
                        case "supbook" /*case 'SupBook'*/ :
                            break;
                        case "sheetname" /*case 'SheetName'*/ :
                            break;
                        case "sheetindex" /*case 'SheetIndex'*/ :
                            break;
                        case "sheetindexfirst" /*case 'SheetIndexFirst'*/ :
                            break;
                        case "sheetindexlast" /*case 'SheetIndexLast'*/ :
                            break;
                        case "dll" /*case 'Dll'*/ :
                            break;
                        case "acceptlabelsinformulas" /*case 'AcceptLabelsInFormulas'*/ :
                            break;
                        case "donotsavelinkvalues" /*case 'DoNotSaveLinkValues'*/ :
                            break;
                        case "iteration" /*case 'Iteration'*/ :
                            break;
                        case "maxiterations" /*case 'MaxIterations'*/ :
                            break;
                        case "maxchange" /*case 'MaxChange'*/ :
                            break;
                        case "path" /*case 'Path'*/ :
                            break;
                        case "xct" /*case 'Xct'*/ :
                            break;
                        case "count" /*case 'Count'*/ :
                            break;
                        case "selectedsheets" /*case 'SelectedSheets'*/ :
                            break;
                        case "calculation" /*case 'Calculation'*/ :
                            break;
                        case "uncalced" /*case 'Uncalced'*/ :
                            break;
                        case "startupprompt" /*case 'StartupPrompt'*/ :
                            break;
                        case "crn" /*case 'Crn'*/ :
                            break;
                        case "externname" /*case 'ExternName'*/ :
                            break;
                        case "formula" /*case 'Formula'*/ :
                            break;
                        case "colfirst" /*case 'ColFirst'*/ :
                            break;
                        case "collast" /*case 'ColLast'*/ :
                            break;
                        case "wantadvise" /*case 'WantAdvise'*/ :
                            break;
                        case "boolean" /*case 'Boolean'*/ :
                            break;
                        case "error" /*case 'Error'*/ :
                            break;
                        case "text" /*case 'Text'*/ :
                            break;
                        case "ole" /*case 'OLE'*/ :
                            break;
                        case "noautorecover" /*case 'NoAutoRecover'*/ :
                            break;
                        case "publishobjects" /*case 'PublishObjects'*/ :
                            break;
                        case "donotcalculatebeforesave" /*case 'DoNotCalculateBeforeSave'*/ :
                            break;
                        case "number" /*case 'Number'*/ :
                            break;
                        case "refmoder1c1" /*case 'RefModeR1C1'*/ :
                            break;
                        case "embedsavesmarttags" /*case 'EmbedSaveSmartTags'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorkbookOptions */ case "workbookoptions" /*case 'WorkbookOptions'*/ :
                    switch(Rn[3]){
                        case "owcversion" /*case 'OWCVersion'*/ :
                            break;
                        case "height" /*case 'Height'*/ :
                            break;
                        case "width" /*case 'Width'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorksheetOptions */ case "worksheetoptions" /*case 'WorksheetOptions'*/ :
                    switch(Rn[3]){
                        case "visible" /*case 'Visible'*/ :
                            if (Rn[0].slice(-2) === "/>") ;
                            else if (Rn[1] === "/") switch(str.slice(pidx, Rn.index)){
                                case "SheetHidden":
                                    wsprops.Hidden = 1;
                                    break;
                                case "SheetVeryHidden":
                                    wsprops.Hidden = 2;
                                    break;
                            }
                            else pidx = Rn.index + Rn[0].length;
                            break;
                        case "header" /*case 'Header'*/ :
                            if (!cursheet["!margins"]) $3ee4f50b1ae43a89$var$default_margins(cursheet["!margins"] = {}, "xlml");
                            if (!isNaN(+$3ee4f50b1ae43a89$var$parsexmltag(Rn[0]).Margin)) cursheet["!margins"].header = +$3ee4f50b1ae43a89$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case "footer" /*case 'Footer'*/ :
                            if (!cursheet["!margins"]) $3ee4f50b1ae43a89$var$default_margins(cursheet["!margins"] = {}, "xlml");
                            if (!isNaN(+$3ee4f50b1ae43a89$var$parsexmltag(Rn[0]).Margin)) cursheet["!margins"].footer = +$3ee4f50b1ae43a89$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case "pagemargins" /*case 'PageMargins'*/ :
                            var pagemargins = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0]);
                            if (!cursheet["!margins"]) $3ee4f50b1ae43a89$var$default_margins(cursheet["!margins"] = {}, "xlml");
                            if (!isNaN(+pagemargins.Top)) cursheet["!margins"].top = +pagemargins.Top;
                            if (!isNaN(+pagemargins.Left)) cursheet["!margins"].left = +pagemargins.Left;
                            if (!isNaN(+pagemargins.Right)) cursheet["!margins"].right = +pagemargins.Right;
                            if (!isNaN(+pagemargins.Bottom)) cursheet["!margins"].bottom = +pagemargins.Bottom;
                            break;
                        case "displayrighttoleft" /*case 'DisplayRightToLeft'*/ :
                            if (!Workbook.Views) Workbook.Views = [];
                            if (!Workbook.Views[0]) Workbook.Views[0] = {};
                            Workbook.Views[0].RTL = true;
                            break;
                        case "freezepanes" /*case 'FreezePanes'*/ :
                            break;
                        case "frozennosplit" /*case 'FrozenNoSplit'*/ :
                            break;
                        case "splithorizontal" /*case 'SplitHorizontal'*/ :
                        case "splitvertical" /*case 'SplitVertical'*/ :
                            break;
                        case "donotdisplaygridlines" /*case 'DoNotDisplayGridlines'*/ :
                            break;
                        case "activerow" /*case 'ActiveRow'*/ :
                            break;
                        case "activecol" /*case 'ActiveCol'*/ :
                            break;
                        case "toprowbottompane" /*case 'TopRowBottomPane'*/ :
                            break;
                        case "leftcolumnrightpane" /*case 'LeftColumnRightPane'*/ :
                            break;
                        case "unsynced" /*case 'Unsynced'*/ :
                            break;
                        case "print" /*case 'Print'*/ :
                            break;
                        case "printerrors" /*case 'PrintErrors'*/ :
                            break;
                        case "panes" /*case 'Panes'*/ :
                            break;
                        case "scale" /*case 'Scale'*/ :
                            break;
                        case "pane" /*case 'Pane'*/ :
                            break;
                        case "number" /*case 'Number'*/ :
                            break;
                        case "layout" /*case 'Layout'*/ :
                            break;
                        case "pagesetup" /*case 'PageSetup'*/ :
                            break;
                        case "selected" /*case 'Selected'*/ :
                            break;
                        case "protectobjects" /*case 'ProtectObjects'*/ :
                            break;
                        case "enableselection" /*case 'EnableSelection'*/ :
                            break;
                        case "protectscenarios" /*case 'ProtectScenarios'*/ :
                            break;
                        case "validprinterinfo" /*case 'ValidPrinterInfo'*/ :
                            break;
                        case "horizontalresolution" /*case 'HorizontalResolution'*/ :
                            break;
                        case "verticalresolution" /*case 'VerticalResolution'*/ :
                            break;
                        case "numberofcopies" /*case 'NumberofCopies'*/ :
                            break;
                        case "activepane" /*case 'ActivePane'*/ :
                            break;
                        case "toprowvisible" /*case 'TopRowVisible'*/ :
                            break;
                        case "leftcolumnvisible" /*case 'LeftColumnVisible'*/ :
                            break;
                        case "fittopage" /*case 'FitToPage'*/ :
                            break;
                        case "rangeselection" /*case 'RangeSelection'*/ :
                            break;
                        case "papersizeindex" /*case 'PaperSizeIndex'*/ :
                            break;
                        case "pagelayoutzoom" /*case 'PageLayoutZoom'*/ :
                            break;
                        case "pagebreakzoom" /*case 'PageBreakZoom'*/ :
                            break;
                        case "filteron" /*case 'FilterOn'*/ :
                            break;
                        case "fitwidth" /*case 'FitWidth'*/ :
                            break;
                        case "fitheight" /*case 'FitHeight'*/ :
                            break;
                        case "commentslayout" /*case 'CommentsLayout'*/ :
                            break;
                        case "zoom" /*case 'Zoom'*/ :
                            break;
                        case "lefttoright" /*case 'LeftToRight'*/ :
                            break;
                        case "gridlines" /*case 'Gridlines'*/ :
                            break;
                        case "allowsort" /*case 'AllowSort'*/ :
                            break;
                        case "allowfilter" /*case 'AllowFilter'*/ :
                            break;
                        case "allowinsertrows" /*case 'AllowInsertRows'*/ :
                            break;
                        case "allowdeleterows" /*case 'AllowDeleteRows'*/ :
                            break;
                        case "allowinsertcols" /*case 'AllowInsertCols'*/ :
                            break;
                        case "allowdeletecols" /*case 'AllowDeleteCols'*/ :
                            break;
                        case "allowinserthyperlinks" /*case 'AllowInsertHyperlinks'*/ :
                            break;
                        case "allowformatcells" /*case 'AllowFormatCells'*/ :
                            break;
                        case "allowsizecols" /*case 'AllowSizeCols'*/ :
                            break;
                        case "allowsizerows" /*case 'AllowSizeRows'*/ :
                            break;
                        case "nosummaryrowsbelowdetail" /*case 'NoSummaryRowsBelowDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].above = true;
                            break;
                        case "tabcolorindex" /*case 'TabColorIndex'*/ :
                            break;
                        case "donotdisplayheadings" /*case 'DoNotDisplayHeadings'*/ :
                            break;
                        case "showpagelayoutzoom" /*case 'ShowPageLayoutZoom'*/ :
                            break;
                        case "nosummarycolumnsrightdetail" /*case 'NoSummaryColumnsRightDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].left = true;
                            break;
                        case "blackandwhite" /*case 'BlackAndWhite'*/ :
                            break;
                        case "donotdisplayzeros" /*case 'DoNotDisplayZeros'*/ :
                            break;
                        case "displaypagebreak" /*case 'DisplayPageBreak'*/ :
                            break;
                        case "rowcolheadings" /*case 'RowColHeadings'*/ :
                            break;
                        case "donotdisplayoutline" /*case 'DoNotDisplayOutline'*/ :
                            break;
                        case "noorientation" /*case 'NoOrientation'*/ :
                            break;
                        case "allowusepivottables" /*case 'AllowUsePivotTables'*/ :
                            break;
                        case "zeroheight" /*case 'ZeroHeight'*/ :
                            break;
                        case "viewablerange" /*case 'ViewableRange'*/ :
                            break;
                        case "selection" /*case 'Selection'*/ :
                            break;
                        case "protectcontents" /*case 'ProtectContents'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PivotTable */ case "pivottable" /*case 'PivotTable'*/ :
                case "pivotcache" /*case 'PivotCache'*/ :
                    switch(Rn[3]){
                        case "immediateitemsondrop" /*case 'ImmediateItemsOnDrop'*/ :
                            break;
                        case "showpagemultipleitemlabel" /*case 'ShowPageMultipleItemLabel'*/ :
                            break;
                        case "compactrowindent" /*case 'CompactRowIndent'*/ :
                            break;
                        case "location" /*case 'Location'*/ :
                            break;
                        case "pivotfield" /*case 'PivotField'*/ :
                            break;
                        case "orientation" /*case 'Orientation'*/ :
                            break;
                        case "layoutform" /*case 'LayoutForm'*/ :
                            break;
                        case "layoutsubtotallocation" /*case 'LayoutSubtotalLocation'*/ :
                            break;
                        case "layoutcompactrow" /*case 'LayoutCompactRow'*/ :
                            break;
                        case "position" /*case 'Position'*/ :
                            break;
                        case "pivotitem" /*case 'PivotItem'*/ :
                            break;
                        case "datatype" /*case 'DataType'*/ :
                            break;
                        case "datafield" /*case 'DataField'*/ :
                            break;
                        case "sourcename" /*case 'SourceName'*/ :
                            break;
                        case "parentfield" /*case 'ParentField'*/ :
                            break;
                        case "ptlineitems" /*case 'PTLineItems'*/ :
                            break;
                        case "ptlineitem" /*case 'PTLineItem'*/ :
                            break;
                        case "countofsameitems" /*case 'CountOfSameItems'*/ :
                            break;
                        case "item" /*case 'Item'*/ :
                            break;
                        case "itemtype" /*case 'ItemType'*/ :
                            break;
                        case "ptsource" /*case 'PTSource'*/ :
                            break;
                        case "cacheindex" /*case 'CacheIndex'*/ :
                            break;
                        case "consolidationreference" /*case 'ConsolidationReference'*/ :
                            break;
                        case "filename" /*case 'FileName'*/ :
                            break;
                        case "reference" /*case 'Reference'*/ :
                            break;
                        case "nocolumngrand" /*case 'NoColumnGrand'*/ :
                            break;
                        case "norowgrand" /*case 'NoRowGrand'*/ :
                            break;
                        case "blanklineafteritems" /*case 'BlankLineAfterItems'*/ :
                            break;
                        case "hidden" /*case 'Hidden'*/ :
                            break;
                        case "subtotal" /*case 'Subtotal'*/ :
                            break;
                        case "basefield" /*case 'BaseField'*/ :
                            break;
                        case "mapchilditems" /*case 'MapChildItems'*/ :
                            break;
                        case "function" /*case 'Function'*/ :
                            break;
                        case "refreshonfileopen" /*case 'RefreshOnFileOpen'*/ :
                            break;
                        case "printsettitles" /*case 'PrintSetTitles'*/ :
                            break;
                        case "mergelabels" /*case 'MergeLabels'*/ :
                            break;
                        case "defaultversion" /*case 'DefaultVersion'*/ :
                            break;
                        case "refreshname" /*case 'RefreshName'*/ :
                            break;
                        case "refreshdate" /*case 'RefreshDate'*/ :
                            break;
                        case "refreshdatecopy" /*case 'RefreshDateCopy'*/ :
                            break;
                        case "versionlastrefresh" /*case 'VersionLastRefresh'*/ :
                            break;
                        case "versionlastupdate" /*case 'VersionLastUpdate'*/ :
                            break;
                        case "versionupdateablemin" /*case 'VersionUpdateableMin'*/ :
                            break;
                        case "versionrefreshablemin" /*case 'VersionRefreshableMin'*/ :
                            break;
                        case "calculation" /*case 'Calculation'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PageBreaks */ case "pagebreaks" /*case 'PageBreaks'*/ :
                    switch(Rn[3]){
                        case "colbreaks" /*case 'ColBreaks'*/ :
                            break;
                        case "colbreak" /*case 'ColBreak'*/ :
                            break;
                        case "rowbreaks" /*case 'RowBreaks'*/ :
                            break;
                        case "rowbreak" /*case 'RowBreak'*/ :
                            break;
                        case "colstart" /*case 'ColStart'*/ :
                            break;
                        case "colend" /*case 'ColEnd'*/ :
                            break;
                        case "rowend" /*case 'RowEnd'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* AutoFilter */ case "autofilter" /*case 'AutoFilter'*/ :
                    switch(Rn[3]){
                        case "autofiltercolumn" /*case 'AutoFilterColumn'*/ :
                            break;
                        case "autofiltercondition" /*case 'AutoFilterCondition'*/ :
                            break;
                        case "autofilterand" /*case 'AutoFilterAnd'*/ :
                            break;
                        case "autofilteror" /*case 'AutoFilterOr'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* QueryTable */ case "querytable" /*case 'QueryTable'*/ :
                    switch(Rn[3]){
                        case "id" /*case 'Id'*/ :
                            break;
                        case "autoformatfont" /*case 'AutoFormatFont'*/ :
                            break;
                        case "autoformatpattern" /*case 'AutoFormatPattern'*/ :
                            break;
                        case "querysource" /*case 'QuerySource'*/ :
                            break;
                        case "querytype" /*case 'QueryType'*/ :
                            break;
                        case "enableredirections" /*case 'EnableRedirections'*/ :
                            break;
                        case "refreshedinxl9" /*case 'RefreshedInXl9'*/ :
                            break;
                        case "urlstring" /*case 'URLString'*/ :
                            break;
                        case "htmltables" /*case 'HTMLTables'*/ :
                            break;
                        case "connection" /*case 'Connection'*/ :
                            break;
                        case "commandtext" /*case 'CommandText'*/ :
                            break;
                        case "refreshinfo" /*case 'RefreshInfo'*/ :
                            break;
                        case "notitles" /*case 'NoTitles'*/ :
                            break;
                        case "nextid" /*case 'NextId'*/ :
                            break;
                        case "columninfo" /*case 'ColumnInfo'*/ :
                            break;
                        case "overwritecells" /*case 'OverwriteCells'*/ :
                            break;
                        case "donotpromptforfile" /*case 'DoNotPromptForFile'*/ :
                            break;
                        case "textwizardsettings" /*case 'TextWizardSettings'*/ :
                            break;
                        case "source" /*case 'Source'*/ :
                            break;
                        case "number" /*case 'Number'*/ :
                            break;
                        case "decimal" /*case 'Decimal'*/ :
                            break;
                        case "thousandseparator" /*case 'ThousandSeparator'*/ :
                            break;
                        case "trailingminusnumbers" /*case 'TrailingMinusNumbers'*/ :
                            break;
                        case "formatsettings" /*case 'FormatSettings'*/ :
                            break;
                        case "fieldtype" /*case 'FieldType'*/ :
                            break;
                        case "delimiters" /*case 'Delimiters'*/ :
                            break;
                        case "tab" /*case 'Tab'*/ :
                            break;
                        case "comma" /*case 'Comma'*/ :
                            break;
                        case "autoformatname" /*case 'AutoFormatName'*/ :
                            break;
                        case "versionlastedit" /*case 'VersionLastEdit'*/ :
                            break;
                        case "versionlastrefresh" /*case 'VersionLastRefresh'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case "datavalidation" /*case 'DataValidation'*/ :
                    switch(Rn[3]){
                        case "range" /*case 'Range'*/ :
                            break;
                        case "type" /*case 'Type'*/ :
                            break;
                        case "min" /*case 'Min'*/ :
                            break;
                        case "max" /*case 'Max'*/ :
                            break;
                        case "sort" /*case 'Sort'*/ :
                            break;
                        case "descending" /*case 'Descending'*/ :
                            break;
                        case "order" /*case 'Order'*/ :
                            break;
                        case "casesensitive" /*case 'CaseSensitive'*/ :
                            break;
                        case "value" /*case 'Value'*/ :
                            break;
                        case "errorstyle" /*case 'ErrorStyle'*/ :
                            break;
                        case "errormessage" /*case 'ErrorMessage'*/ :
                            break;
                        case "errortitle" /*case 'ErrorTitle'*/ :
                            break;
                        case "inputmessage" /*case 'InputMessage'*/ :
                            break;
                        case "inputtitle" /*case 'InputTitle'*/ :
                            break;
                        case "combohide" /*case 'ComboHide'*/ :
                            break;
                        case "inputhide" /*case 'InputHide'*/ :
                            break;
                        case "condition" /*case 'Condition'*/ :
                            break;
                        case "qualifier" /*case 'Qualifier'*/ :
                            break;
                        case "useblank" /*case 'UseBlank'*/ :
                            break;
                        case "value1" /*case 'Value1'*/ :
                            break;
                        case "value2" /*case 'Value2'*/ :
                            break;
                        case "format" /*case 'Format'*/ :
                            break;
                        case "cellrangelist" /*case 'CellRangeList'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case "sorting" /*case 'Sorting'*/ :
                case "conditionalformatting" /*case 'ConditionalFormatting'*/ :
                    switch(Rn[3]){
                        case "range" /*case 'Range'*/ :
                            break;
                        case "type" /*case 'Type'*/ :
                            break;
                        case "min" /*case 'Min'*/ :
                            break;
                        case "max" /*case 'Max'*/ :
                            break;
                        case "sort" /*case 'Sort'*/ :
                            break;
                        case "descending" /*case 'Descending'*/ :
                            break;
                        case "order" /*case 'Order'*/ :
                            break;
                        case "casesensitive" /*case 'CaseSensitive'*/ :
                            break;
                        case "value" /*case 'Value'*/ :
                            break;
                        case "errorstyle" /*case 'ErrorStyle'*/ :
                            break;
                        case "errormessage" /*case 'ErrorMessage'*/ :
                            break;
                        case "errortitle" /*case 'ErrorTitle'*/ :
                            break;
                        case "cellrangelist" /*case 'CellRangeList'*/ :
                            break;
                        case "inputmessage" /*case 'InputMessage'*/ :
                            break;
                        case "inputtitle" /*case 'InputTitle'*/ :
                            break;
                        case "combohide" /*case 'ComboHide'*/ :
                            break;
                        case "inputhide" /*case 'InputHide'*/ :
                            break;
                        case "condition" /*case 'Condition'*/ :
                            break;
                        case "qualifier" /*case 'Qualifier'*/ :
                            break;
                        case "useblank" /*case 'UseBlank'*/ :
                            break;
                        case "value1" /*case 'Value1'*/ :
                            break;
                        case "value2" /*case 'Value2'*/ :
                            break;
                        case "format" /*case 'Format'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* MapInfo (schema) */ case "mapinfo" /*case 'MapInfo'*/ :
                case "schema" /*case 'Schema'*/ :
                case "data" /*case 'data'*/ :
                    switch(Rn[3]){
                        case "map" /*case 'Map'*/ :
                            break;
                        case "entry" /*case 'Entry'*/ :
                            break;
                        case "range" /*case 'Range'*/ :
                            break;
                        case "xpath" /*case 'XPath'*/ :
                            break;
                        case "field" /*case 'Field'*/ :
                            break;
                        case "xsdtype" /*case 'XSDType'*/ :
                            break;
                        case "filteron" /*case 'FilterOn'*/ :
                            break;
                        case "aggregate" /*case 'Aggregate'*/ :
                            break;
                        case "elementtype" /*case 'ElementType'*/ :
                            break;
                        case "attributetype" /*case 'AttributeType'*/ :
                            break;
                        /* These are from xsd (XML Schema Definition) */ case "schema" /*case 'schema'*/ :
                        case "element" /*case 'element'*/ :
                        case "complextype" /*case 'complexType'*/ :
                        case "datatype" /*case 'datatype'*/ :
                        case "all" /*case 'all'*/ :
                        case "attribute" /*case 'attribute'*/ :
                        case "extends" /*case 'extends'*/ :
                            break;
                        case "row" /*case 'row'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* SmartTags (can be anything) */ case "smarttags" /*case 'SmartTags'*/ :
                    break;
                default:
                    seen = false;
                    break;
            }
            if (seen) break;
            /* CustomDocumentProperties */ if (Rn[3].match(/!\[CDATA/)) break;
            if (!state[state.length - 1][1]) throw "Unrecognized tag: " + Rn[3] + "|" + state.join("|");
            if (state[state.length - 1][0] === /*'CustomDocumentProperties'*/ "customdocumentproperties") {
                if (Rn[0].slice(-2) === "/>") break;
                else if (Rn[1] === "/") $3ee4f50b1ae43a89$var$xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
                else {
                    cp = Rn;
                    pidx = Rn.index + Rn[0].length;
                }
                break;
            }
            if (opts.WTF) throw "Unrecognized tag: " + Rn[3] + "|" + state.join("|");
    }
    var out = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
    out.SheetNames = sheetnames;
    out.Workbook = Workbook;
    out.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    out.Props = Props;
    out.Custprops = Custprops;
    return out;
}
function $3ee4f50b1ae43a89$var$parse_xlml(data /*:RawBytes|string*/ , opts) /*:Workbook*/ {
    $3ee4f50b1ae43a89$var$fix_read_opts(opts = opts || {});
    switch(opts.type || "base64"){
        case "base64":
            return $3ee4f50b1ae43a89$var$parse_xlml_xml($3ee4f50b1ae43a89$var$Base64_decode(data), opts);
        case "binary":
        case "buffer":
        case "file":
            return $3ee4f50b1ae43a89$var$parse_xlml_xml(data, opts);
        case "array":
            return $3ee4f50b1ae43a89$var$parse_xlml_xml($3ee4f50b1ae43a89$var$a2s(data), opts);
    }
/*:: throw new Error("unsupported type " + opts.type); */ }
/* TODO */ function $3ee4f50b1ae43a89$var$write_props_xlml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o /*:Array<string>*/  = [];
    /* DocumentProperties */ if (wb.Props) o.push($3ee4f50b1ae43a89$var$xlml_write_docprops(wb.Props, opts));
    /* CustomDocumentProperties */ if (wb.Custprops) o.push($3ee4f50b1ae43a89$var$xlml_write_custprops(wb.Props, wb.Custprops, opts));
    return o.join("");
}
/* TODO */ function $3ee4f50b1ae43a89$var$write_wb_xlml() /*:string*/ {
    /* OfficeDocumentSettings */ /* ExcelWorkbook */ return "";
}
/* TODO */ function $3ee4f50b1ae43a89$var$write_sty_xlml(wb, opts) /*:string*/ {
    /* Styles */ var styles /*:Array<string>*/  = [
        '<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'
    ];
    opts.cellXfs.forEach(function(xf, id) {
        var payload /*:Array<string>*/  = [];
        payload.push($3ee4f50b1ae43a89$var$writextag("NumberFormat", null, {
            "ss:Format": $3ee4f50b1ae43a89$var$escapexml($3ee4f50b1ae43a89$var$table_fmt[xf.numFmtId])
        }));
        var o = /*::(*/ {
            "ss:ID": "s" + (21 + id)
        } /*:: :any)*/ ;
        styles.push($3ee4f50b1ae43a89$var$writextag("Style", payload.join(""), o));
    });
    return $3ee4f50b1ae43a89$var$writextag("Styles", styles.join(""));
}
function $3ee4f50b1ae43a89$var$write_name_xlml(n) {
    return $3ee4f50b1ae43a89$var$writextag("NamedRange", null, {
        "ss:Name": n.Name,
        "ss:RefersTo": "=" + $3ee4f50b1ae43a89$var$a1_to_rc(n.Ref, {
            r: 0,
            c: 0
        })
    });
}
function $3ee4f50b1ae43a89$var$write_names_xlml(wb /*::, opts*/ ) /*:string*/ {
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != null) continue;
        if (n.Name.match(/^_xlfn\./)) continue;
        out.push($3ee4f50b1ae43a89$var$write_name_xlml(n));
    }
    return $3ee4f50b1ae43a89$var$writextag("Names", out.join(""));
}
function $3ee4f50b1ae43a89$var$write_ws_xlml_names(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != idx) continue;
        /*switch(n.Name) {
			case "_": continue;
		}*/ if (n.Name.match(/^_xlfn\./)) continue;
        out.push($3ee4f50b1ae43a89$var$write_name_xlml(n));
    }
    return out.join("");
}
/* WorksheetOptions */ function $3ee4f50b1ae43a89$var$write_ws_xlml_wsopts(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    var o /*:Array<string>*/  = [];
    /* NOTE: spec technically allows any order, but stick with implied order */ /* FitToPage */ /* DoNotDisplayColHeaders */ /* DoNotDisplayRowHeaders */ /* ViewableRange */ /* Selection */ /* GridlineColor */ /* Name */ /* ExcelWorksheetType */ /* IntlMacro */ /* Unsynced */ /* Selected */ /* CodeName */ if (ws["!margins"]) {
        o.push("<PageSetup>");
        if (ws["!margins"].header) o.push($3ee4f50b1ae43a89$var$writextag("Header", null, {
            "x:Margin": ws["!margins"].header
        }));
        if (ws["!margins"].footer) o.push($3ee4f50b1ae43a89$var$writextag("Footer", null, {
            "x:Margin": ws["!margins"].footer
        }));
        o.push($3ee4f50b1ae43a89$var$writextag("PageMargins", null, {
            "x:Bottom": ws["!margins"].bottom || "0.75",
            "x:Left": ws["!margins"].left || "0.7",
            "x:Right": ws["!margins"].right || "0.7",
            "x:Top": ws["!margins"].top || "0.75"
        }));
        o.push("</PageSetup>");
    }
    /* PageSetup */ /* DisplayPageBreak */ /* TransitionExpressionEvaluation */ /* TransitionFormulaEntry */ /* Print */ /* Zoom */ /* PageLayoutZoom */ /* PageBreakZoom */ /* ShowPageBreakZoom */ /* DefaultRowHeight */ /* DefaultColumnWidth */ /* StandardWidth */ if (wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
        /* Visible */ if (wb.Workbook.Sheets[idx].Hidden) o.push($3ee4f50b1ae43a89$var$writextag("Visible", wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
        else {
            /* Selected */ for(var i = 0; i < idx; ++i)if (wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
            if (i == idx) o.push("<Selected/>");
        }
    }
    /* LeftColumnVisible */ if (((((wb || {}).Workbook || {}).Views || [])[0] || {}).RTL) o.push("<DisplayRightToLeft/>");
    /* GridlineColorIndex */ /* DisplayFormulas */ /* DoNotDisplayGridlines */ /* DoNotDisplayHeadings */ /* DoNotDisplayOutline */ /* ApplyAutomaticOutlineStyles */ /* NoSummaryRowsBelowDetail */ /* NoSummaryColumnsRightDetail */ /* DoNotDisplayZeros */ /* ActiveRow */ /* ActiveColumn */ /* FilterOn */ /* RangeSelection */ /* TopRowVisible */ /* TopRowBottomPane */ /* LeftColumnRightPane */ /* ActivePane */ /* SplitHorizontal */ /* SplitVertical */ /* FreezePanes */ /* FrozenNoSplit */ /* TabColorIndex */ /* Panes */ /* NOTE: Password not supported in XLML Format */ if (ws["!protect"]) {
        o.push($3ee4f50b1ae43a89$var$writetag("ProtectContents", "True"));
        if (ws["!protect"].objects) o.push($3ee4f50b1ae43a89$var$writetag("ProtectObjects", "True"));
        if (ws["!protect"].scenarios) o.push($3ee4f50b1ae43a89$var$writetag("ProtectScenarios", "True"));
        if (ws["!protect"].selectLockedCells != null && !ws["!protect"].selectLockedCells) o.push($3ee4f50b1ae43a89$var$writetag("EnableSelection", "NoSelection"));
        else if (ws["!protect"].selectUnlockedCells != null && !ws["!protect"].selectUnlockedCells) o.push($3ee4f50b1ae43a89$var$writetag("EnableSelection", "UnlockedCells"));
        [
            [
                "formatCells",
                "AllowFormatCells"
            ],
            [
                "formatColumns",
                "AllowSizeCols"
            ],
            [
                "formatRows",
                "AllowSizeRows"
            ],
            [
                "insertColumns",
                "AllowInsertCols"
            ],
            [
                "insertRows",
                "AllowInsertRows"
            ],
            [
                "insertHyperlinks",
                "AllowInsertHyperlinks"
            ],
            [
                "deleteColumns",
                "AllowDeleteCols"
            ],
            [
                "deleteRows",
                "AllowDeleteRows"
            ],
            [
                "sort",
                "AllowSort"
            ],
            [
                "autoFilter",
                "AllowFilter"
            ],
            [
                "pivotTables",
                "AllowUsePivotTables"
            ]
        ].forEach(function(x) {
            if (ws["!protect"][x[0]]) o.push("<" + x[1] + "/>");
        });
    }
    if (o.length == 0) return "";
    return $3ee4f50b1ae43a89$var$writextag("WorksheetOptions", o.join(""), {
        xmlns: $3ee4f50b1ae43a89$var$XLMLNS.x
    });
}
function $3ee4f50b1ae43a89$var$write_ws_xlml_comment(comments /*:Array<any>*/ ) /*:string*/ {
    return comments.map(function(c) {
        // TODO: formatted text
        var t = $3ee4f50b1ae43a89$var$xlml_unfixstr(c.t || "");
        var d = $3ee4f50b1ae43a89$var$writextag("ss:Data", t, {
            "xmlns": "http://www.w3.org/TR/REC-html40"
        });
        return $3ee4f50b1ae43a89$var$writextag("Comment", d, {
            "ss:Author": c.a
        });
    }).join("");
}
function $3ee4f50b1ae43a89$var$write_ws_xlml_cell(cell, ref /*:string*/ , ws, opts, idx /*:number*/ , wb, addr) /*:string*/ {
    if (!cell || cell.v == undefined && cell.f == undefined) return "";
    var attr = {};
    if (cell.f) attr["ss:Formula"] = "=" + $3ee4f50b1ae43a89$var$escapexml($3ee4f50b1ae43a89$var$a1_to_rc(cell.f, addr));
    if (cell.F && cell.F.slice(0, ref.length) == ref) {
        var end = $3ee4f50b1ae43a89$var$decode_cell(cell.F.slice(ref.length + 1));
        attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
    }
    if (cell.l && cell.l.Target) {
        attr["ss:HRef"] = $3ee4f50b1ae43a89$var$escapexml(cell.l.Target);
        if (cell.l.Tooltip) attr["x:HRefScreenTip"] = $3ee4f50b1ae43a89$var$escapexml(cell.l.Tooltip);
    }
    if (ws["!merges"]) {
        var marr = ws["!merges"];
        for(var mi = 0; mi != marr.length; ++mi){
            if (marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
            if (marr[mi].e.c > marr[mi].s.c) attr["ss:MergeAcross"] = marr[mi].e.c - marr[mi].s.c;
            if (marr[mi].e.r > marr[mi].s.r) attr["ss:MergeDown"] = marr[mi].e.r - marr[mi].s.r;
        }
    }
    var t = "", p = "";
    switch(cell.t){
        case "z":
            if (!opts.sheetStubs) return "";
            break;
        case "n":
            t = "Number";
            p = String(cell.v);
            break;
        case "b":
            t = "Boolean";
            p = cell.v ? "1" : "0";
            break;
        case "e":
            t = "Error";
            p = $3ee4f50b1ae43a89$var$BErr[cell.v];
            break;
        case "d":
            t = "DateTime";
            p = new Date(cell.v).toISOString();
            if (cell.z == null) cell.z = cell.z || $3ee4f50b1ae43a89$var$table_fmt[14];
            break;
        case "s":
            t = "String";
            p = $3ee4f50b1ae43a89$var$escapexlml(cell.v || "");
            break;
    }
    /* TODO: cell style */ var os = $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, cell, opts);
    attr["ss:StyleID"] = "s" + (21 + os);
    attr["ss:Index"] = addr.c + 1;
    var _v = cell.v != null ? p : "";
    var m = cell.t == "z" ? "" : '<Data ss:Type="' + t + '">' + _v + "</Data>";
    if ((cell.c || []).length > 0) m += $3ee4f50b1ae43a89$var$write_ws_xlml_comment(cell.c);
    return $3ee4f50b1ae43a89$var$writextag("Cell", m, attr);
}
function $3ee4f50b1ae43a89$var$write_ws_xlml_row(R /*:number*/ , row) /*:string*/ {
    var o = '<Row ss:Index="' + (R + 1) + '"';
    if (row) {
        if (row.hpt && !row.hpx) row.hpx = $3ee4f50b1ae43a89$var$pt2px(row.hpt);
        if (row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
        if (row.hidden) o += ' ss:Hidden="1"';
    }
    return o + ">";
}
/* TODO */ function $3ee4f50b1ae43a89$var$write_ws_xlml_table(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws["!ref"]) return "";
    var range /*:Range*/  = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]);
    var marr /*:Array<Range>*/  = ws["!merges"] || [], mi = 0;
    var o /*:Array<string>*/  = [];
    if (ws["!cols"]) ws["!cols"].forEach(function(n, i) {
        $3ee4f50b1ae43a89$var$process_col(n);
        var w = !!n.width;
        var p = $3ee4f50b1ae43a89$var$col_obj_w(i, n);
        var k /*:any*/  = {
            "ss:Index": i + 1
        };
        if (w) k["ss:Width"] = $3ee4f50b1ae43a89$var$width2px(p.width);
        if (n.hidden) k["ss:Hidden"] = "1";
        o.push($3ee4f50b1ae43a89$var$writextag("Column", null, k));
    });
    var dense = Array.isArray(ws);
    for(var R = range.s.r; R <= range.e.r; ++R){
        var row = [
            $3ee4f50b1ae43a89$var$write_ws_xlml_row(R, (ws["!rows"] || [])[R])
        ];
        for(var C = range.s.c; C <= range.e.c; ++C){
            var skip = false;
            for(mi = 0; mi != marr.length; ++mi){
                if (marr[mi].s.c > C) continue;
                if (marr[mi].s.r > R) continue;
                if (marr[mi].e.c < C) continue;
                if (marr[mi].e.r < R) continue;
                if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                break;
            }
            if (skip) continue;
            var addr = {
                r: R,
                c: C
            };
            var ref = $3ee4f50b1ae43a89$var$encode_cell(addr), cell = dense ? (ws[R] || [])[C] : ws[ref];
            row.push($3ee4f50b1ae43a89$var$write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
        }
        row.push("</Row>");
        if (row.length > 2) o.push(row.join(""));
    }
    return o.join("");
}
function $3ee4f50b1ae43a89$var$write_ws_xlml(idx /*:number*/ , opts, wb /*:Workbook*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    var s = wb.SheetNames[idx];
    var ws = wb.Sheets[s];
    var t /*:string*/  = ws ? $3ee4f50b1ae43a89$var$write_ws_xlml_names(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Names>" + t + "</Names>");
    /* Table */ t = ws ? $3ee4f50b1ae43a89$var$write_ws_xlml_table(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Table>" + t + "</Table>");
    /* WorksheetOptions */ o.push($3ee4f50b1ae43a89$var$write_ws_xlml_wsopts(ws, opts, idx, wb));
    return o.join("");
}
function $3ee4f50b1ae43a89$var$write_xlml(wb, opts) /*:string*/ {
    if (!opts) opts = {};
    if (!wb.SSF) wb.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    if (wb.SSF) {
        $3ee4f50b1ae43a89$var$make_ssf();
        $3ee4f50b1ae43a89$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $3ee4f50b1ae43a89$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    var d /*:Array<string>*/  = [];
    d.push($3ee4f50b1ae43a89$var$write_props_xlml(wb, opts));
    d.push($3ee4f50b1ae43a89$var$write_wb_xlml(wb, opts));
    d.push("");
    d.push("");
    for(var i = 0; i < wb.SheetNames.length; ++i)d.push($3ee4f50b1ae43a89$var$writextag("Worksheet", $3ee4f50b1ae43a89$var$write_ws_xlml(i, opts, wb), {
        "ss:Name": $3ee4f50b1ae43a89$var$escapexml(wb.SheetNames[i])
    }));
    d[2] = $3ee4f50b1ae43a89$var$write_sty_xlml(wb, opts);
    d[3] = $3ee4f50b1ae43a89$var$write_names_xlml(wb, opts);
    return $3ee4f50b1ae43a89$var$XML_HEADER + $3ee4f50b1ae43a89$var$writextag("Workbook", d.join(""), {
        "xmlns": $3ee4f50b1ae43a89$var$XLMLNS.ss,
        "xmlns:o": $3ee4f50b1ae43a89$var$XLMLNS.o,
        "xmlns:x": $3ee4f50b1ae43a89$var$XLMLNS.x,
        "xmlns:ss": $3ee4f50b1ae43a89$var$XLMLNS.ss,
        "xmlns:dt": $3ee4f50b1ae43a89$var$XLMLNS.dt,
        "xmlns:html": $3ee4f50b1ae43a89$var$XLMLNS.html
    });
}
/* [MS-OLEDS] 2.3.8 CompObjStream */ function $3ee4f50b1ae43a89$var$parse_compobj(obj /*:CFBEntry*/ ) {
    var v = {};
    var o = obj.content;
    /*:: if(o == null) return; */ /* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */ o.l = 28;
    v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
    v.AnsiClipboardFormat = $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrAnsiString(o);
    if (o.length - o.l <= 4) return v;
    var m /*:number*/  = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved1 = o.read_shift(0, "lpstr-ansi");
    if (o.length - o.l <= 4) return v;
    m = o.read_shift(4);
    if (m !== 0x71b239f4) return v;
    v.UnicodeClipboardFormat = $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrUnicodeString(o);
    m = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved2 = o.read_shift(0, "lpwstr");
}
/*
	Continue logic for:
	- 2.4.58 Continue          0x003c
	- 2.4.59 ContinueBigName   0x043c
	- 2.4.60 ContinueFrt       0x0812
	- 2.4.61 ContinueFrt11     0x0875
	- 2.4.62 ContinueFrt12     0x087f
*/ var $3ee4f50b1ae43a89$var$CONTINUE_RT = [
    0x003c,
    0x043c,
    0x0812,
    0x0875,
    0x087f
];
function $3ee4f50b1ae43a89$var$slurp(RecordType, R, blob, length /*:number*/ , opts) /*:any*/ {
    var l = length;
    var bufs = [];
    var d = blob.slice(blob.l, blob.l + l);
    if (opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType){
        case 0x0009:
        case 0x0209:
        case 0x0409:
        case 0x0809 /* BOF */ :
        case 0x002f /* FilePass */ :
        case 0x0195 /* FileLock */ :
        case 0x00e1 /* InterfaceHdr */ :
        case 0x0196 /* RRDInfo */ :
        case 0x0138 /* RRDHead */ :
        case 0x0194 /* UsrExcl */ :
        case 0x000a /* EOF */ :
            break;
        case 0x0085 /* BoundSheet8 */ :
            break;
        default:
            opts.enc.insitu(d);
    }
    bufs.push(d);
    blob.l += l;
    var nextrt = $3ee4f50b1ae43a89$var$__readUInt16LE(blob, blob.l), next = $3ee4f50b1ae43a89$var$XLSRecordEnum[nextrt];
    var start = 0;
    while(next != null && $3ee4f50b1ae43a89$var$CONTINUE_RT.indexOf(nextrt) > -1){
        l = $3ee4f50b1ae43a89$var$__readUInt16LE(blob, blob.l + 2);
        start = blob.l + 4;
        if (nextrt == 0x0812 /* ContinueFrt */ ) start += 4;
        else if (nextrt == 0x0875 || nextrt == 0x087f) start += 12;
        d = blob.slice(start, blob.l + 4 + l);
        bufs.push(d);
        blob.l += 4 + l;
        next = $3ee4f50b1ae43a89$var$XLSRecordEnum[nextrt = $3ee4f50b1ae43a89$var$__readUInt16LE(blob, blob.l)];
    }
    var b = $3ee4f50b1ae43a89$var$bconcat(bufs);
    $3ee4f50b1ae43a89$var$prep_blob(b, 0);
    var ll = 0;
    b.lens = [];
    for(var j = 0; j < bufs.length; ++j){
        b.lens.push(ll);
        ll += bufs[j].length;
    }
    if (b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
    return R.f(b, b.length, opts);
}
function $3ee4f50b1ae43a89$var$safe_format_xf(p /*:any*/ , opts /*:ParseOpts*/ , date1904 /*:?boolean*/ ) {
    if (p.t === "z") return;
    if (!p.XF) return;
    var fmtid = 0;
    try {
        fmtid = p.z || p.XF.numFmtId || 0;
        if (opts.cellNF) p.z = $3ee4f50b1ae43a89$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts || opts.cellText !== false) try {
        if (p.t === "e") p.w = p.w || $3ee4f50b1ae43a89$var$BErr[p.v];
        else if (fmtid === 0 || fmtid == "General") {
            if (p.t === "n") {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $3ee4f50b1ae43a89$var$SSF_general_num(p.v);
            } else p.w = $3ee4f50b1ae43a89$var$SSF_general(p.v);
        } else p.w = $3ee4f50b1ae43a89$var$SSF_format(fmtid, p.v, {
            date1904: !!date1904,
            dateNF: opts && opts.dateNF
        });
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (opts.cellDates && fmtid && p.t == "n" && $3ee4f50b1ae43a89$var$fmt_is_date($3ee4f50b1ae43a89$var$table_fmt[fmtid] || String(fmtid))) {
        var _d = $3ee4f50b1ae43a89$var$SSF_parse_date_code(p.v);
        if (_d) {
            p.t = "d";
            p.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
        }
    }
}
function $3ee4f50b1ae43a89$var$make_cell(val, ixfe, t) /*:Cell*/ {
    return {
        v: val,
        ixfe: ixfe,
        t: t
    } /*:any*/ ;
}
// 2.3.2
function $3ee4f50b1ae43a89$var$parse_workbook(blob, options /*:ParseOpts*/ ) /*:Workbook*/ {
    var wb = {
        opts: {}
    } /*:any*/ ;
    var Sheets = {};
    if ($3ee4f50b1ae43a89$var$DENSE != null && options.dense == null) options.dense = $3ee4f50b1ae43a89$var$DENSE;
    var out /*:Worksheet*/  = options.dense ? [] : {};
    var Directory = {};
    var range /*:Range*/  = {} /*:any*/ ;
    var last_formula = null;
    var sst /*:SST*/  = [];
    var cur_sheet = "";
    var Preamble = {};
    var lastcell, last_cell = "", cc /*:Cell*/ , cmnt, rngC, rngR;
    var sharedf = {};
    var arrayf /*:Array<[Range, string]>*/  = [];
    var temp_val /*:Cell*/ ;
    var country;
    var XFs = []; /* XF records */ 
    var palette /*:Array<[number, number, number]>*/  = [];
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        },
        Views: [
            {}
        ]
    } /*:any*/ , wsprops = {};
    var get_rgb = function getrgb(icv /*:number*/ ) /*:[number, number, number]*/ {
        if (icv < 8) return $3ee4f50b1ae43a89$var$XLSIcv[icv];
        if (icv < 64) return palette[icv - 8] || $3ee4f50b1ae43a89$var$XLSIcv[icv];
        return $3ee4f50b1ae43a89$var$XLSIcv[icv];
    };
    var process_cell_style = function pcs(cell, line /*:any*/ , options) {
        var xfd = line.XF.data;
        if (!xfd || !xfd.patternType || !options || !options.cellStyles) return;
        line.s = {} /*:any*/ ;
        line.s.patternType = xfd.patternType;
        var t;
        if (t = $3ee4f50b1ae43a89$var$rgb2Hex(get_rgb(xfd.icvFore))) line.s.fgColor = {
            rgb: t
        };
        if (t = $3ee4f50b1ae43a89$var$rgb2Hex(get_rgb(xfd.icvBack))) line.s.bgColor = {
            rgb: t
        };
    };
    var addcell = function addcell(cell /*:any*/ , line /*:any*/ , options /*:any*/ ) {
        if (file_depth > 1) return;
        if (options.sheetRows && cell.r >= options.sheetRows) return;
        if (options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
        delete line.ixfe;
        delete line.XF;
        lastcell = cell;
        last_cell = $3ee4f50b1ae43a89$var$encode_cell(cell);
        if (!range || !range.s || !range.e) range = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        if (cell.r < range.s.r) range.s.r = cell.r;
        if (cell.c < range.s.c) range.s.c = cell.c;
        if (cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
        if (cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
        if (options.cellFormula && line.f) for(var afi = 0; afi < arrayf.length; ++afi){
            if (arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
            if (arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
            line.F = $3ee4f50b1ae43a89$var$encode_range(arrayf[afi][0]);
            if (arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
            if (line.f) line.f = "" + $3ee4f50b1ae43a89$var$stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
            break;
        }
        if (options.dense) {
            if (!out[cell.r]) out[cell.r] = [];
            out[cell.r][cell.c] = line;
        } else out[last_cell] = line;
    };
    var opts = {
        enc: false,
        sbcch: 0,
        snames: [],
        sharedf: sharedf,
        arrayf: arrayf,
        rrtabid: [],
        lastuser: "",
        biff: 8,
        codepage: 0,
        winlocked: 0,
        cellStyles: !!options && !!options.cellStyles,
        WTF: !!options && !!options.wtf
    } /*:any*/ ;
    if (options.password) opts.password = options.password;
    var themes;
    var merges /*:Array<Range>*/  = [];
    var objects = [];
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    var supbooks = []; // 1-indexed, will hold extern names
    supbooks.SheetNames = opts.snames;
    supbooks.sharedf = opts.sharedf;
    supbooks.arrayf = opts.arrayf;
    supbooks.names = [];
    supbooks.XTI = [];
    var last_RT = 0;
    var file_depth = 0; /* TODO: make a real stack */ 
    var BIFF2Fmt = 0, BIFF2FmtTable /*:Array<string>*/  = [];
    var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */ 
    var last_lbl /*:?DefinedName*/ ;
    /* explicit override for some broken writers */ opts.codepage = 1200;
    $3ee4f50b1ae43a89$var$set_cp(1200);
    var seen_codepage = false;
    while(blob.l < blob.length - 1){
        var s = blob.l;
        var RecordType = blob.read_shift(2);
        if (RecordType === 0 && last_RT === 0x000a /* EOF */ ) break;
        var length = blob.l === blob.length ? 0 : blob.read_shift(2);
        var R = $3ee4f50b1ae43a89$var$XLSRecordEnum[RecordType];
        //console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
        //if(!R) console.log(blob.slice(blob.l, blob.l + length));
        if (R && R.f) {
            if (options.bookSheets) {
                if (last_RT === 0x0085 /* BoundSheet8 */  && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */ ) break;
            }
            last_RT = RecordType;
            if (R.r === 2 || R.r == 12) {
                var rt = blob.read_shift(2);
                length -= 2;
                if (!opts.enc && rt !== RecordType && ((rt & 0xFF) << 8 | rt >> 8) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
                if (R.r == 12) {
                    blob.l += 10;
                    length -= 10;
                } // skip FRT
            }
            //console.error(R,blob.l,length,blob.length);
            var val /*:any*/  = {} /*:any*/ ;
            if (RecordType === 0x000a /* EOF */ ) val = /*::(*/ R.f(blob, length, opts) /*:: :any)*/ ;
            else val = /*::(*/ $3ee4f50b1ae43a89$var$slurp(RecordType, R, blob, length, opts) /*:: :any)*/ ;
            /*:: val = (val:any); */ if (file_depth == 0 && [
                0x0009,
                0x0209,
                0x0409,
                0x0809
            ].indexOf(last_RT) === -1 /* 'BOF' */ ) continue;
            switch(RecordType){
                case 0x0022 /* Date1904 */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ wb.opts.Date1904 = Workbook.WBProps.date1904 = val;
                    break;
                case 0x0086 /* WriteProtect */ :
                    wb.opts.WriteProtect = true;
                    break;
                case 0x002f /* FilePass */ :
                    if (!opts.enc) blob.l = 0;
                    opts.enc = val;
                    if (!options.password) throw new Error("File is password-protected");
                    if (val.valid == null) throw new Error("Encryption scheme unsupported");
                    if (!val.valid) throw new Error("Password is incorrect");
                    break;
                case 0x005c /* WriteAccess */ :
                    opts.lastuser = val;
                    break;
                case 0x0042 /* CodePage */ :
                    var cpval = Number(val);
                    /* overrides based on test cases */ switch(cpval){
                        case 0x5212:
                            cpval = 1200;
                            break;
                        case 0x8000:
                            cpval = 10000;
                            break;
                        case 0x8001:
                            cpval = 1252;
                            break;
                    }
                    $3ee4f50b1ae43a89$var$set_cp(opts.codepage = cpval);
                    seen_codepage = true;
                    break;
                case 0x013d /* RRTabId */ :
                    opts.rrtabid = val;
                    break;
                case 0x0019 /* WinProtect */ :
                    opts.winlocked = val;
                    break;
                case 0x01b7 /* RefreshAll */ :
                    wb.opts["RefreshAll"] = val;
                    break;
                case 0x000c /* CalcCount */ :
                    wb.opts["CalcCount"] = val;
                    break;
                case 0x0010 /* CalcDelta */ :
                    wb.opts["CalcDelta"] = val;
                    break;
                case 0x0011 /* CalcIter */ :
                    wb.opts["CalcIter"] = val;
                    break;
                case 0x000d /* CalcMode */ :
                    wb.opts["CalcMode"] = val;
                    break;
                case 0x000e /* CalcPrecision */ :
                    wb.opts["CalcPrecision"] = val;
                    break;
                case 0x005f /* CalcSaveRecalc */ :
                    wb.opts["CalcSaveRecalc"] = val;
                    break;
                case 0x000f /* CalcRefMode */ :
                    opts.CalcRefMode = val;
                    break; // TODO: implement R1C1
                case 0x08a3 /* ForceFullCalculation */ :
                    wb.opts.FullCalc = val;
                    break;
                case 0x0081 /* WsBool */ :
                    if (val.fDialog) out["!type"] = "dialog";
                    if (!val.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
                    if (!val.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
                    break; // TODO
                case 0x00e0 /* XF */ :
                    XFs.push(val);
                    break;
                case 0x01ae /* SupBook */ :
                    supbooks.push([
                        val
                    ]);
                    supbooks[supbooks.length - 1].XTI = [];
                    break;
                case 0x0023:
                case 0x0223 /* ExternName */ :
                    supbooks[supbooks.length - 1].push(val);
                    break;
                case 0x0018:
                case 0x0218 /* Lbl */ :
                    last_lbl = {
                        Name: val.Name,
                        Ref: $3ee4f50b1ae43a89$var$stringify_formula(val.rgce, range, null, supbooks, opts)
                    } /*:DefinedName*/ ;
                    if (val.itab > 0) last_lbl.Sheet = val.itab - 1;
                    supbooks.names.push(last_lbl);
                    if (!supbooks[0]) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].push(val);
                    if (val.Name == "_xlnm._FilterDatabase" && val.itab > 0) {
                        if (val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == "PtgArea3d") FilterDatabases[val.itab - 1] = {
                            ref: $3ee4f50b1ae43a89$var$encode_range(val.rgce[0][0][1][2])
                        };
                    }
                    break;
                case 0x0016 /* ExternCount */ :
                    opts.ExternCount = val;
                    break;
                case 0x0017 /* ExternSheet */ :
                    if (supbooks.length == 0) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                    supbooks.XTI = supbooks.XTI.concat(val);
                    break;
                case 0x0894 /* NameCmt */ :
                    /* TODO: search for correct name */ if (opts.biff < 8) break;
                    if (last_lbl != null) last_lbl.Comment = val[1];
                    break;
                case 0x0012 /* Protect */ :
                    out["!protect"] = val;
                    break; /* for sheet or book */ 
                case 0x0013 /* Password */ :
                    if (val !== 0 && opts.WTF) console.error("Password verifier: " + val);
                    break;
                case 0x0085 /* BoundSheet8 */ :
                    Directory[val.pos] = val;
                    opts.snames.push(val.name);
                    break;
                case 0x000a /* EOF */ :
                    if (--file_depth) break;
                    if (range.e) {
                        if (range.e.r > 0 && range.e.c > 0) {
                            range.e.r--;
                            range.e.c--;
                            out["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
                            if (options.sheetRows && options.sheetRows <= range.e.r) {
                                var tmpri = range.e.r;
                                range.e.r = options.sheetRows - 1;
                                out["!fullref"] = out["!ref"];
                                out["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
                                range.e.r = tmpri;
                            }
                            range.e.r++;
                            range.e.c++;
                        }
                        if (merges.length > 0) out["!merges"] = merges;
                        if (objects.length > 0) out["!objects"] = objects;
                        if (colinfo.length > 0) out["!cols"] = colinfo;
                        if (rowinfo.length > 0) out["!rows"] = rowinfo;
                        Workbook.Sheets.push(wsprops);
                    }
                    if (cur_sheet === "") Preamble = out;
                    else Sheets[cur_sheet] = out;
                    out = options.dense ? [] : {};
                    break;
                case 0x0009:
                case 0x0209:
                case 0x0409:
                case 0x0809 /* BOF */ :
                    if (opts.biff === 8) opts.biff = ({
                        /*::[*/ 0x0009: 2,
                        /*::[*/ 0x0209: 3,
                        /*::[*/ 0x0409: 4
                    })[RecordType] || ({
                        /*::[*/ 0x0200: 2,
                        /*::[*/ 0x0300: 3,
                        /*::[*/ 0x0400: 4,
                        /*::[*/ 0x0500: 5,
                        /*::[*/ 0x0600: 8,
                        /*::[*/ 0x0002: 2,
                        /*::[*/ 0x0007: 2
                    })[val.BIFFVer] || 8;
                    opts.biffguess = val.BIFFVer == 0;
                    if (val.BIFFVer == 0 && val.dt == 0x1000) {
                        opts.biff = 5;
                        seen_codepage = true;
                        $3ee4f50b1ae43a89$var$set_cp(opts.codepage = 28591);
                    }
                    if (opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
                    if (file_depth++) break;
                    out = options.dense ? [] : {};
                    if (opts.biff < 8 && !seen_codepage) {
                        seen_codepage = true;
                        $3ee4f50b1ae43a89$var$set_cp(opts.codepage = options.codepage || 1252);
                    }
                    if (opts.biff < 5 || val.BIFFVer == 0 && val.dt == 0x1000) {
                        if (cur_sheet === "") cur_sheet = "Sheet1";
                        range = {
                            s: {
                                r: 0,
                                c: 0
                            },
                            e: {
                                r: 0,
                                c: 0
                            }
                        };
                        /* fake BoundSheet8 */ var fakebs8 = {
                            pos: blob.l - length,
                            name: cur_sheet
                        };
                        Directory[fakebs8.pos] = fakebs8;
                        opts.snames.push(cur_sheet);
                    } else cur_sheet = (Directory[s] || {
                        name: ""
                    }).name;
                    if (val.dt == 0x20) out["!type"] = "chart";
                    if (val.dt == 0x40) out["!type"] = "macro";
                    merges = [];
                    objects = [];
                    opts.arrayf = arrayf = [];
                    colinfo = [];
                    rowinfo = [];
                    seencol = false;
                    wsprops = {
                        Hidden: (Directory[s] || {
                            hs: 0
                        }).hs,
                        name: cur_sheet
                    };
                    break;
                case 0x0203 /* Number */ :
                case 0x0003 /* BIFF2NUM */ :
                case 0x0002 /* BIFF2INT */ :
                    if (out["!type"] == "chart") {
                        if (options.dense ? (out[val.r] || [])[val.c] : out[$3ee4f50b1ae43a89$var$encode_cell({
                            c: val.c,
                            r: val.r
                        })]) ++val.c;
                    }
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe] || {},
                        v: val.val,
                        t: "n"
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0005:
                case 0x0205 /* BoolErr */ :
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe],
                        v: val.val,
                        t: val.t
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x027e /* RK */ :
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe],
                        v: val.rknum,
                        t: "n"
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x00bd /* MulRk */ :
                    for(var j = val.c; j <= val.C; ++j){
                        var ixfe = val.rkrec[j - val.c][0];
                        temp_val = {
                            ixfe: ixfe,
                            XF: XFs[ixfe],
                            v: val.rkrec[j - val.c][1],
                            t: "n"
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: j,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x0006:
                case 0x0206:
                case 0x0406 /* Formula */ :
                    if (val.val == "String") {
                        last_formula = val;
                        break;
                    }
                    temp_val = $3ee4f50b1ae43a89$var$make_cell(val.val, val.cell.ixfe, val.tt);
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (options.cellFormula) {
                        var _f = val.formula;
                        if (_f && _f[0] && _f[0][0] && _f[0][0][0] == "PtgExp") {
                            var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
                            var _fe = $3ee4f50b1ae43a89$var$encode_cell({
                                r: _fr,
                                c: _fc
                            });
                            if (sharedf[_fe]) temp_val.f = "" + $3ee4f50b1ae43a89$var$stringify_formula(val.formula, range, val.cell, supbooks, opts);
                            else temp_val.F = ((options.dense ? (out[_fr] || [])[_fc] : out[_fe]) || {}).F;
                        } else temp_val.f = "" + $3ee4f50b1ae43a89$var$stringify_formula(val.formula, range, val.cell, supbooks, opts);
                    }
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell(val.cell, temp_val, options);
                    last_formula = val;
                    break;
                case 0x0007:
                case 0x0207 /* String */ :
                    if (last_formula) {
                        last_formula.val = val;
                        temp_val = $3ee4f50b1ae43a89$var$make_cell(val, last_formula.cell.ixfe, "s");
                        temp_val.XF = XFs[temp_val.ixfe];
                        if (options.cellFormula) temp_val.f = "" + $3ee4f50b1ae43a89$var$stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell(last_formula.cell, temp_val, options);
                        last_formula = null;
                    } else throw new Error("String record expects Formula");
                    break;
                case 0x0021:
                case 0x0221 /* Array */ :
                    arrayf.push(val);
                    var _arraystart = $3ee4f50b1ae43a89$var$encode_cell(val[0].s);
                    cc = options.dense ? (out[val[0].s.r] || [])[val[0].s.c] : out[_arraystart];
                    if (options.cellFormula && cc) {
                        if (!last_formula) break; /* technically unreachable */ 
                        if (!_arraystart || !cc) break;
                        cc.f = "" + $3ee4f50b1ae43a89$var$stringify_formula(val[1], range, val[0], supbooks, opts);
                        cc.F = $3ee4f50b1ae43a89$var$encode_range(val[0]);
                    }
                    break;
                case 0x04bc /* ShrFmla */ :
                    if (!options.cellFormula) break;
                    if (last_cell) {
                        /* TODO: capture range */ if (!last_formula) break; /* technically unreachable */ 
                        sharedf[$3ee4f50b1ae43a89$var$encode_cell(last_formula.cell)] = val[0];
                        cc = options.dense ? (out[last_formula.cell.r] || [])[last_formula.cell.c] : out[$3ee4f50b1ae43a89$var$encode_cell(last_formula.cell)];
                        (cc || {}).f = "" + $3ee4f50b1ae43a89$var$stringify_formula(val[0], range, lastcell, supbooks, opts);
                    }
                    break;
                case 0x00fd /* LabelSst */ :
                    temp_val = $3ee4f50b1ae43a89$var$make_cell(sst[val.isst].t, val.ixfe, "s");
                    if (sst[val.isst].h) temp_val.h = sst[val.isst].h;
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0201 /* Blank */ :
                    if (options.sheetStubs) {
                        temp_val = {
                            ixfe: val.ixfe,
                            XF: XFs[val.ixfe],
                            t: "z"
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val.c,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00be /* MulBlank */ :
                    if (options.sheetStubs) for(var _j = val.c; _j <= val.C; ++_j){
                        var _ixfe = val.ixfe[_j - val.c];
                        temp_val = {
                            ixfe: _ixfe,
                            XF: XFs[_ixfe],
                            t: "z"
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: _j,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00d6 /* RString */ :
                case 0x0204 /* Label */ :
                case 0x0004 /* BIFF2STR */ :
                    temp_val = $3ee4f50b1ae43a89$var$make_cell(val.val, val.ixfe, "s");
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0000:
                case 0x0200 /* Dimensions */ :
                    if (file_depth === 1) range = val; /* TODO: stack */ 
                    break;
                case 0x00fc /* SST */ :
                    sst = val;
                    break;
                case 0x041e /* Format */ :
                    if (opts.biff == 4) {
                        BIFF2FmtTable[BIFF2Fmt++] = val[1];
                        for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx)if ($3ee4f50b1ae43a89$var$table_fmt[b4idx] == val[1]) break;
                        if (b4idx >= 163) $3ee4f50b1ae43a89$var$SSF_load(val[1], BIFF2Fmt + 163);
                    } else $3ee4f50b1ae43a89$var$SSF_load(val[1], val[0]);
                    break;
                case 0x001e /* BIFF2FORMAT */ :
                    BIFF2FmtTable[BIFF2Fmt++] = val;
                    for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx)if ($3ee4f50b1ae43a89$var$table_fmt[b2idx] == val) break;
                    if (b2idx >= 163) $3ee4f50b1ae43a89$var$SSF_load(val, BIFF2Fmt + 163);
                    break;
                case 0x00e5 /* MergeCells */ :
                    merges = merges.concat(val);
                    break;
                case 0x005d /* Obj */ :
                    objects[val.cmo[0]] = opts.lastobj = val;
                    break;
                case 0x01b6 /* TxO */ :
                    opts.lastobj.TxO = val;
                    break;
                case 0x007f /* ImData */ :
                    opts.lastobj.ImData = val;
                    break;
                case 0x01b8 /* HLink */ :
                    for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                        cc = options.dense ? (out[rngR] || [])[rngC] : out[$3ee4f50b1ae43a89$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc) cc.l = val[1];
                    }
                    break;
                case 0x0800 /* HLinkTooltip */ :
                    for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                        cc = options.dense ? (out[rngR] || [])[rngC] : out[$3ee4f50b1ae43a89$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc && cc.l) cc.l.Tooltip = val[1];
                    }
                    break;
                case 0x001c /* Note */ :
                    if (opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */ 
                    cc = options.dense ? (out[val[0].r] || [])[val[0].c] : out[$3ee4f50b1ae43a89$var$encode_cell(val[0])];
                    var noteobj = objects[val[2]];
                    if (!cc) {
                        if (options.dense) {
                            if (!out[val[0].r]) out[val[0].r] = [];
                            cc = out[val[0].r][val[0].c] = {
                                t: "z"
                            } /*:any*/ ;
                        } else cc = out[$3ee4f50b1ae43a89$var$encode_cell(val[0])] = {
                            t: "z"
                        } /*:any*/ ;
                        range.e.r = Math.max(range.e.r, val[0].r);
                        range.s.r = Math.min(range.s.r, val[0].r);
                        range.e.c = Math.max(range.e.c, val[0].c);
                        range.s.c = Math.min(range.s.c, val[0].c);
                    }
                    if (!cc.c) cc.c = [];
                    cmnt = {
                        a: val[1],
                        t: noteobj.TxO.t
                    };
                    cc.c.push(cmnt);
                    break;
                case 0x087d /* XFExt */ :
                    $3ee4f50b1ae43a89$var$update_xfext(XFs[val.ixfe], val.ext);
                    break;
                case 0x007d /* ColInfo */ :
                    if (!opts.cellStyles) break;
                    while(val.e >= val.s){
                        colinfo[val.e--] = {
                            width: val.w / 256,
                            level: val.level || 0,
                            hidden: !!(val.flags & 1)
                        };
                        if (!seencol) {
                            seencol = true;
                            $3ee4f50b1ae43a89$var$find_mdw_colw(val.w / 256);
                        }
                        $3ee4f50b1ae43a89$var$process_col(colinfo[val.e + 1]);
                    }
                    break;
                case 0x0208 /* Row */ :
                    var rowobj = {};
                    if (val.level != null) {
                        rowinfo[val.r] = rowobj;
                        rowobj.level = val.level;
                    }
                    if (val.hidden) {
                        rowinfo[val.r] = rowobj;
                        rowobj.hidden = true;
                    }
                    if (val.hpt) {
                        rowinfo[val.r] = rowobj;
                        rowobj.hpt = val.hpt;
                        rowobj.hpx = $3ee4f50b1ae43a89$var$pt2px(val.hpt);
                    }
                    break;
                case 0x0026 /* LeftMargin */ :
                case 0x0027 /* RightMargin */ :
                case 0x0028 /* TopMargin */ :
                case 0x0029 /* BottomMargin */ :
                    if (!out["!margins"]) $3ee4f50b1ae43a89$var$default_margins(out["!margins"] = {});
                    out["!margins"][({
                        0x26: "left",
                        0x27: "right",
                        0x28: "top",
                        0x29: "bottom"
                    })[RecordType]] = val;
                    break;
                case 0x00a1 /* Setup */ :
                    if (!out["!margins"]) $3ee4f50b1ae43a89$var$default_margins(out["!margins"] = {});
                    out["!margins"].header = val.header;
                    out["!margins"].footer = val.footer;
                    break;
                case 0x023e /* Window2 */ :
                    // $FlowIgnore
                    if (val.RTL) Workbook.Views[0].RTL = true;
                    break;
                case 0x0092 /* Palette */ :
                    palette = val;
                    break;
                case 0x0896 /* Theme */ :
                    themes = val;
                    break;
                case 0x008c /* Country */ :
                    country = val;
                    break;
                case 0x01ba /* CodeName */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ if (!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
                    else wsprops.CodeName = val || wsprops.name;
                    break;
            }
        } else {
            if (!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
            blob.l += length;
        }
    }
    wb.SheetNames = $3ee4f50b1ae43a89$var$keys(Directory).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(x) {
        return Directory[x].name;
    });
    if (!options.bookSheets) wb.Sheets = Sheets;
    if (!wb.SheetNames.length && Preamble["!ref"]) {
        wb.SheetNames.push("Sheet1");
        /*jshint -W069 */ if (wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
    /*jshint +W069 */ } else wb.Preamble = Preamble;
    if (wb.Sheets) FilterDatabases.forEach(function(r, i) {
        wb.Sheets[wb.SheetNames[i]]["!autofilter"] = r;
    });
    wb.Strings = sst;
    wb.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    if (opts.enc) wb.Encryption = opts.enc;
    if (themes) wb.Themes = themes;
    wb.Metadata = {};
    if (country !== undefined) wb.Metadata.Country = country;
    if (supbooks.names.length > 0) Workbook.Names = supbooks.names;
    wb.Workbook = Workbook;
    return wb;
}
/* TODO: split props*/ var $3ee4f50b1ae43a89$var$PSCLSID = {
    SI: "e0859ff2f94f6810ab9108002b27b3d9",
    DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
    UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function $3ee4f50b1ae43a89$var$parse_xls_props(cfb /*:CFBContainer*/ , props, o) {
    /* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */ var DSI = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "/!DocumentSummaryInformation");
    if (DSI && DSI.size > 0) try {
        var DocSummary = $3ee4f50b1ae43a89$var$parse_PropertySetStream(DSI, $3ee4f50b1ae43a89$var$DocSummaryPIDDSI, $3ee4f50b1ae43a89$var$PSCLSID.DSI);
        for(var d in DocSummary)props[d] = DocSummary[d];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    /* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/ var SI = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "/!SummaryInformation");
    if (SI && SI.size > 0) try {
        var Summary = $3ee4f50b1ae43a89$var$parse_PropertySetStream(SI, $3ee4f50b1ae43a89$var$SummaryPIDSI, $3ee4f50b1ae43a89$var$PSCLSID.SI);
        for(var s in Summary)if (props[s] == null) props[s] = Summary[s];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    if (props.HeadingPairs && props.TitlesOfParts) {
        $3ee4f50b1ae43a89$var$load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
        delete props.HeadingPairs;
        delete props.TitlesOfParts;
    }
}
function $3ee4f50b1ae43a89$var$write_xls_props(wb /*:Workbook*/ , cfb /*:CFBContainer*/ ) {
    var DSEntries = [], SEntries = [], CEntries = [];
    var i = 0, Keys;
    var DocSummaryRE /*:{[key:string]:string}*/  = $3ee4f50b1ae43a89$var$evert_key($3ee4f50b1ae43a89$var$DocSummaryPIDDSI, "n");
    var SummaryRE /*:{[key:string]:string}*/  = $3ee4f50b1ae43a89$var$evert_key($3ee4f50b1ae43a89$var$SummaryPIDSI, "n");
    if (wb.Props) {
        Keys = $3ee4f50b1ae43a89$var$keys(wb.Props);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)(Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Props[Keys[i]]
        ]);
    }
    if (wb.Custprops) {
        Keys = $3ee4f50b1ae43a89$var$keys(wb.Custprops);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)if (!Object.prototype.hasOwnProperty.call(wb.Props || {}, Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Custprops[Keys[i]]
        ]);
    }
    var CEntries2 = [];
    for(i = 0; i < CEntries.length; ++i){
        if ($3ee4f50b1ae43a89$var$XLSPSSkip.indexOf(CEntries[i][0]) > -1 || $3ee4f50b1ae43a89$var$PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
        if (CEntries[i][1] == null) continue;
        CEntries2.push(CEntries[i]);
    }
    if (SEntries.length) $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\x05SummaryInformation", $3ee4f50b1ae43a89$var$write_PropertySetStream(SEntries, $3ee4f50b1ae43a89$var$PSCLSID.SI, SummaryRE, $3ee4f50b1ae43a89$var$SummaryPIDSI));
    if (DSEntries.length || CEntries2.length) $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\x05DocumentSummaryInformation", $3ee4f50b1ae43a89$var$write_PropertySetStream(DSEntries, $3ee4f50b1ae43a89$var$PSCLSID.DSI, DocSummaryRE, $3ee4f50b1ae43a89$var$DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, $3ee4f50b1ae43a89$var$PSCLSID.UDI));
}
function $3ee4f50b1ae43a89$export$b41972a043aba84c(cfb /*:any*/ , options /*:?ParseOpts*/ ) /*:Workbook*/ {
    if (!options) options = {};
    $3ee4f50b1ae43a89$var$fix_read_opts(options);
    $3ee4f50b1ae43a89$var$reset_cp();
    if (options.codepage) $3ee4f50b1ae43a89$var$set_ansi(options.codepage);
    var CompObj /*:?CFBEntry*/ , WB /*:?any*/ ;
    if (cfb.FullPaths) {
        if ($3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "/encryption")) throw new Error("File is password-protected");
        CompObj = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "!CompObj");
        WB = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "/Workbook") || $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "/Book");
    } else {
        switch(options.type){
            case "base64":
                cfb = $3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$Base64_decode(cfb));
                break;
            case "binary":
                cfb = $3ee4f50b1ae43a89$var$s2a(cfb);
                break;
            case "buffer":
                break;
            case "array":
                if (!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb);
                break;
        }
        $3ee4f50b1ae43a89$var$prep_blob(cfb, 0);
        WB = {
            content: cfb
        } /*:any*/ ;
    }
    var /*::CompObjP, */ WorkbookP /*:: :Workbook = XLSX.utils.book_new(); */ ;
    var _data /*:?any*/ ;
    if (CompObj) /*::CompObjP = */ $3ee4f50b1ae43a89$var$parse_compobj(CompObj);
    if (options.bookProps && !options.bookSheets) WorkbookP = {} /*:any*/ ;
    else /*:: if(cfb instanceof CFBContainer) */ {
        var T = $3ee4f50b1ae43a89$var$has_buf ? "buffer" : "array";
        if (WB && WB.content) WorkbookP = $3ee4f50b1ae43a89$var$parse_workbook(WB.content, options);
        else if ((_data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "PerfectOffice_MAIN")) && _data.content) WorkbookP = $3ee4f50b1ae43a89$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "NativeContent_MAIN")) && _data.content) WorkbookP = $3ee4f50b1ae43a89$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "MN0")) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
        else throw new Error("Cannot find Workbook stream");
        if (options.bookVBA && cfb.FullPaths && $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "/_VBA_PROJECT_CUR/VBA/dir")) WorkbookP.vbaraw = $3ee4f50b1ae43a89$var$make_vba_xls(cfb);
    }
    var props = {};
    if (cfb.FullPaths) $3ee4f50b1ae43a89$var$parse_xls_props(/*::((*/ cfb /*:: :any):CFBContainer)*/ , props, options);
    WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */ 
    if (options.bookFiles) WorkbookP.cfb = cfb;
    /*WorkbookP.CompObjP = CompObjP; // TODO: storage? */ return WorkbookP;
}
function $3ee4f50b1ae43a89$var$write_xlscfb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:CFBContainer*/ {
    var o = opts || {};
    var cfb = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    var wbpath = "/Workbook";
    switch(o.bookType || "xls"){
        case "xls":
            o.bookType = "biff8";
        /* falls through */ case "xla":
            if (!o.bookType) o.bookType = "xla";
        /* falls through */ case "biff8":
            wbpath = "/Workbook";
            o.biff = 8;
            break;
        case "biff5":
            wbpath = "/Book";
            o.biff = 5;
            break;
        default:
            throw new Error("invalid type " + o.bookType + " for XLS CFB");
    }
    $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(cfb, wbpath, $3ee4f50b1ae43a89$var$write_biff_buf(wb, o));
    if (o.biff == 8 && (wb.Props || wb.Custprops)) $3ee4f50b1ae43a89$var$write_xls_props(wb, cfb);
    // TODO: SI, DSI, CO
    if (o.biff == 8 && wb.vbaraw) $3ee4f50b1ae43a89$var$fill_vba_xls(cfb, $3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(wb.vbaraw, {
        type: typeof wb.vbaraw == "string" ? "binary" : "buffer"
    }));
    return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */ var $3ee4f50b1ae43a89$var$XLSBRecordEnum = {
    /*::[*/ 0x0000: {
        f: $3ee4f50b1ae43a89$var$parse_BrtRowHdr
    },
    /*::[*/ 0x0001: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellBlank
    },
    /*::[*/ 0x0002: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellRk
    },
    /*::[*/ 0x0003: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellError
    },
    /*::[*/ 0x0004: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellBool
    },
    /*::[*/ 0x0005: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellReal
    },
    /*::[*/ 0x0006: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellSt
    },
    /*::[*/ 0x0007: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellIsst
    },
    /*::[*/ 0x0008: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFmlaString
    },
    /*::[*/ 0x0009: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFmlaNum
    },
    /*::[*/ 0x000A: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFmlaBool
    },
    /*::[*/ 0x000B: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFmlaError
    },
    /*::[*/ 0x000C: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortBlank
    },
    /*::[*/ 0x000D: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortRk
    },
    /*::[*/ 0x000E: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortError
    },
    /*::[*/ 0x000F: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortBool
    },
    /*::[*/ 0x0010: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortReal
    },
    /*::[*/ 0x0011: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortSt
    },
    /*::[*/ 0x0012: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortIsst
    },
    /*::[*/ 0x0013: {
        f: $3ee4f50b1ae43a89$var$parse_RichStr
    },
    /*::[*/ 0x0014: {},
    /*::[*/ 0x0015: {},
    /*::[*/ 0x0016: {},
    /*::[*/ 0x0017: {},
    /*::[*/ 0x0018: {},
    /*::[*/ 0x0019: {},
    /*::[*/ 0x001A: {},
    /*::[*/ 0x001B: {},
    /*::[*/ 0x001C: {},
    /*::[*/ 0x001D: {},
    /*::[*/ 0x001E: {},
    /*::[*/ 0x001F: {},
    /*::[*/ 0x0020: {},
    /*::[*/ 0x0021: {},
    /*::[*/ 0x0022: {},
    /*::[*/ 0x0023: {
        T: 1
    },
    /*::[*/ 0x0024: {
        T: -1
    },
    /*::[*/ 0x0025: {
        T: 1
    },
    /*::[*/ 0x0026: {
        T: -1
    },
    /*::[*/ 0x0027: {
        f: $3ee4f50b1ae43a89$var$parse_BrtName
    },
    /*::[*/ 0x0028: {},
    /*::[*/ 0x002A: {},
    /*::[*/ 0x002B: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFont
    },
    /*::[*/ 0x002C: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFmt
    },
    /*::[*/ 0x002D: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFill
    },
    /*::[*/ 0x002E: {
        f: $3ee4f50b1ae43a89$var$parse_BrtBorder
    },
    /*::[*/ 0x002F: {
        f: $3ee4f50b1ae43a89$var$parse_BrtXF
    },
    /*::[*/ 0x0030: {},
    /*::[*/ 0x0031: {
        f: $3ee4f50b1ae43a89$var$parse_Int32LE
    },
    /*::[*/ 0x0032: {},
    /*::[*/ 0x0033: {
        f: $3ee4f50b1ae43a89$var$parse_BrtMdb
    },
    /*::[*/ 0x0034: {
        T: 1
    },
    /*::[*/ 0x0035: {
        T: -1
    },
    /*::[*/ 0x0036: {
        T: 1
    },
    /*::[*/ 0x0037: {
        T: -1
    },
    /*::[*/ 0x0038: {
        T: 1
    },
    /*::[*/ 0x0039: {
        T: -1
    },
    /*::[*/ 0x003A: {},
    /*::[*/ 0x003B: {},
    /*::[*/ 0x003C: {
        f: $3ee4f50b1ae43a89$var$parse_ColInfo
    },
    /*::[*/ 0x003E: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellRString
    },
    /*::[*/ 0x003F: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCalcChainItem$
    },
    /*::[*/ 0x0040: {
        f: $3ee4f50b1ae43a89$var$parse_BrtDVal
    },
    /*::[*/ 0x0041: {},
    /*::[*/ 0x0042: {},
    /*::[*/ 0x0043: {},
    /*::[*/ 0x0044: {},
    /*::[*/ 0x0045: {},
    /*::[*/ 0x0046: {},
    /*::[*/ 0x0080: {},
    /*::[*/ 0x0081: {
        T: 1
    },
    /*::[*/ 0x0082: {
        T: -1
    },
    /*::[*/ 0x0083: {
        T: 1,
        f: $3ee4f50b1ae43a89$var$parsenoop,
        p: 0
    },
    /*::[*/ 0x0084: {
        T: -1
    },
    /*::[*/ 0x0085: {
        T: 1
    },
    /*::[*/ 0x0086: {
        T: -1
    },
    /*::[*/ 0x0087: {
        T: 1
    },
    /*::[*/ 0x0088: {
        T: -1
    },
    /*::[*/ 0x0089: {
        T: 1,
        f: $3ee4f50b1ae43a89$var$parse_BrtBeginWsView
    },
    /*::[*/ 0x008A: {
        T: -1
    },
    /*::[*/ 0x008B: {
        T: 1
    },
    /*::[*/ 0x008C: {
        T: -1
    },
    /*::[*/ 0x008D: {
        T: 1
    },
    /*::[*/ 0x008E: {
        T: -1
    },
    /*::[*/ 0x008F: {
        T: 1
    },
    /*::[*/ 0x0090: {
        T: -1
    },
    /*::[*/ 0x0091: {
        T: 1
    },
    /*::[*/ 0x0092: {
        T: -1
    },
    /*::[*/ 0x0093: {
        f: $3ee4f50b1ae43a89$var$parse_BrtWsProp
    },
    /*::[*/ 0x0094: {
        f: $3ee4f50b1ae43a89$var$parse_BrtWsDim,
        p: 16
    },
    /*::[*/ 0x0097: {
        f: $3ee4f50b1ae43a89$var$parse_BrtPane
    },
    /*::[*/ 0x0098: {},
    /*::[*/ 0x0099: {
        f: $3ee4f50b1ae43a89$var$parse_BrtWbProp
    },
    /*::[*/ 0x009A: {},
    /*::[*/ 0x009B: {},
    /*::[*/ 0x009C: {
        f: $3ee4f50b1ae43a89$var$parse_BrtBundleSh
    },
    /*::[*/ 0x009D: {},
    /*::[*/ 0x009E: {},
    /*::[*/ 0x009F: {
        T: 1,
        f: $3ee4f50b1ae43a89$var$parse_BrtBeginSst
    },
    /*::[*/ 0x00A0: {
        T: -1
    },
    /*::[*/ 0x00A1: {
        T: 1,
        f: $3ee4f50b1ae43a89$var$parse_UncheckedRfX
    },
    /*::[*/ 0x00A2: {
        T: -1
    },
    /*::[*/ 0x00A3: {
        T: 1
    },
    /*::[*/ 0x00A4: {
        T: -1
    },
    /*::[*/ 0x00A5: {
        T: 1
    },
    /*::[*/ 0x00A6: {
        T: -1
    },
    /*::[*/ 0x00A7: {},
    /*::[*/ 0x00A8: {},
    /*::[*/ 0x00A9: {},
    /*::[*/ 0x00AA: {},
    /*::[*/ 0x00AB: {},
    /*::[*/ 0x00AC: {
        T: 1
    },
    /*::[*/ 0x00AD: {
        T: -1
    },
    /*::[*/ 0x00AE: {},
    /*::[*/ 0x00AF: {},
    /*::[*/ 0x00B0: {
        f: $3ee4f50b1ae43a89$var$parse_BrtMergeCell
    },
    /*::[*/ 0x00B1: {
        T: 1
    },
    /*::[*/ 0x00B2: {
        T: -1
    },
    /*::[*/ 0x00B3: {
        T: 1
    },
    /*::[*/ 0x00B4: {
        T: -1
    },
    /*::[*/ 0x00B5: {
        T: 1
    },
    /*::[*/ 0x00B6: {
        T: -1
    },
    /*::[*/ 0x00B7: {
        T: 1
    },
    /*::[*/ 0x00B8: {
        T: -1
    },
    /*::[*/ 0x00B9: {
        T: 1
    },
    /*::[*/ 0x00BA: {
        T: -1
    },
    /*::[*/ 0x00BB: {
        T: 1
    },
    /*::[*/ 0x00BC: {
        T: -1
    },
    /*::[*/ 0x00BD: {
        T: 1
    },
    /*::[*/ 0x00BE: {
        T: -1
    },
    /*::[*/ 0x00BF: {
        T: 1
    },
    /*::[*/ 0x00C0: {
        T: -1
    },
    /*::[*/ 0x00C1: {
        T: 1
    },
    /*::[*/ 0x00C2: {
        T: -1
    },
    /*::[*/ 0x00C3: {
        T: 1
    },
    /*::[*/ 0x00C4: {
        T: -1
    },
    /*::[*/ 0x00C5: {
        T: 1
    },
    /*::[*/ 0x00C6: {
        T: -1
    },
    /*::[*/ 0x00C7: {
        T: 1
    },
    /*::[*/ 0x00C8: {
        T: -1
    },
    /*::[*/ 0x00C9: {
        T: 1
    },
    /*::[*/ 0x00CA: {
        T: -1
    },
    /*::[*/ 0x00CB: {
        T: 1
    },
    /*::[*/ 0x00CC: {
        T: -1
    },
    /*::[*/ 0x00CD: {
        T: 1
    },
    /*::[*/ 0x00CE: {
        T: -1
    },
    /*::[*/ 0x00CF: {
        T: 1
    },
    /*::[*/ 0x00D0: {
        T: -1
    },
    /*::[*/ 0x00D1: {
        T: 1
    },
    /*::[*/ 0x00D2: {
        T: -1
    },
    /*::[*/ 0x00D3: {
        T: 1
    },
    /*::[*/ 0x00D4: {
        T: -1
    },
    /*::[*/ 0x00D5: {
        T: 1
    },
    /*::[*/ 0x00D6: {
        T: -1
    },
    /*::[*/ 0x00D7: {
        T: 1
    },
    /*::[*/ 0x00D8: {
        T: -1
    },
    /*::[*/ 0x00D9: {
        T: 1
    },
    /*::[*/ 0x00DA: {
        T: -1
    },
    /*::[*/ 0x00DB: {
        T: 1
    },
    /*::[*/ 0x00DC: {
        T: -1
    },
    /*::[*/ 0x00DD: {
        T: 1
    },
    /*::[*/ 0x00DE: {
        T: -1
    },
    /*::[*/ 0x00DF: {
        T: 1
    },
    /*::[*/ 0x00E0: {
        T: -1
    },
    /*::[*/ 0x00E1: {
        T: 1
    },
    /*::[*/ 0x00E2: {
        T: -1
    },
    /*::[*/ 0x00E3: {
        T: 1
    },
    /*::[*/ 0x00E4: {
        T: -1
    },
    /*::[*/ 0x00E5: {
        T: 1
    },
    /*::[*/ 0x00E6: {
        T: -1
    },
    /*::[*/ 0x00E7: {
        T: 1
    },
    /*::[*/ 0x00E8: {
        T: -1
    },
    /*::[*/ 0x00E9: {
        T: 1
    },
    /*::[*/ 0x00EA: {
        T: -1
    },
    /*::[*/ 0x00EB: {
        T: 1
    },
    /*::[*/ 0x00EC: {
        T: -1
    },
    /*::[*/ 0x00ED: {
        T: 1
    },
    /*::[*/ 0x00EE: {
        T: -1
    },
    /*::[*/ 0x00EF: {
        T: 1
    },
    /*::[*/ 0x00F0: {
        T: -1
    },
    /*::[*/ 0x00F1: {
        T: 1
    },
    /*::[*/ 0x00F2: {
        T: -1
    },
    /*::[*/ 0x00F3: {
        T: 1
    },
    /*::[*/ 0x00F4: {
        T: -1
    },
    /*::[*/ 0x00F5: {
        T: 1
    },
    /*::[*/ 0x00F6: {
        T: -1
    },
    /*::[*/ 0x00F7: {
        T: 1
    },
    /*::[*/ 0x00F8: {
        T: -1
    },
    /*::[*/ 0x00F9: {
        T: 1
    },
    /*::[*/ 0x00FA: {
        T: -1
    },
    /*::[*/ 0x00FB: {
        T: 1
    },
    /*::[*/ 0x00FC: {
        T: -1
    },
    /*::[*/ 0x00FD: {
        T: 1
    },
    /*::[*/ 0x00FE: {
        T: -1
    },
    /*::[*/ 0x00FF: {
        T: 1
    },
    /*::[*/ 0x0100: {
        T: -1
    },
    /*::[*/ 0x0101: {
        T: 1
    },
    /*::[*/ 0x0102: {
        T: -1
    },
    /*::[*/ 0x0103: {
        T: 1
    },
    /*::[*/ 0x0104: {
        T: -1
    },
    /*::[*/ 0x0105: {
        T: 1
    },
    /*::[*/ 0x0106: {
        T: -1
    },
    /*::[*/ 0x0107: {
        T: 1
    },
    /*::[*/ 0x0108: {
        T: -1
    },
    /*::[*/ 0x0109: {
        T: 1
    },
    /*::[*/ 0x010A: {
        T: -1
    },
    /*::[*/ 0x010B: {
        T: 1
    },
    /*::[*/ 0x010C: {
        T: -1
    },
    /*::[*/ 0x010D: {
        T: 1
    },
    /*::[*/ 0x010E: {
        T: -1
    },
    /*::[*/ 0x010F: {
        T: 1
    },
    /*::[*/ 0x0110: {
        T: -1
    },
    /*::[*/ 0x0111: {
        T: 1
    },
    /*::[*/ 0x0112: {
        T: -1
    },
    /*::[*/ 0x0113: {
        T: 1
    },
    /*::[*/ 0x0114: {
        T: -1
    },
    /*::[*/ 0x0115: {},
    /*::[*/ 0x0116: {
        T: 1
    },
    /*::[*/ 0x0117: {
        T: -1
    },
    /*::[*/ 0x0118: {
        T: 1
    },
    /*::[*/ 0x0119: {
        T: -1
    },
    /*::[*/ 0x011A: {
        T: 1
    },
    /*::[*/ 0x011B: {
        T: 1
    },
    /*::[*/ 0x011C: {
        T: -1
    },
    /*::[*/ 0x011D: {
        T: 1
    },
    /*::[*/ 0x011E: {
        T: -1
    },
    /*::[*/ 0x011F: {
        T: 1
    },
    /*::[*/ 0x0120: {
        T: -1
    },
    /*::[*/ 0x0121: {
        T: 1
    },
    /*::[*/ 0x0122: {
        T: -1
    },
    /*::[*/ 0x0123: {
        T: 1
    },
    /*::[*/ 0x0124: {
        T: -1
    },
    /*::[*/ 0x0125: {
        T: 1
    },
    /*::[*/ 0x0126: {
        T: -1
    },
    /*::[*/ 0x0127: {
        T: 1
    },
    /*::[*/ 0x0128: {
        T: -1
    },
    /*::[*/ 0x0129: {
        T: 1
    },
    /*::[*/ 0x012A: {
        T: -1
    },
    /*::[*/ 0x012B: {
        T: 1
    },
    /*::[*/ 0x012C: {
        T: -1
    },
    /*::[*/ 0x012D: {
        T: 1
    },
    /*::[*/ 0x012E: {
        T: -1
    },
    /*::[*/ 0x012F: {
        T: 1
    },
    /*::[*/ 0x0130: {
        T: -1
    },
    /*::[*/ 0x0131: {
        T: 1
    },
    /*::[*/ 0x0132: {
        T: -1
    },
    /*::[*/ 0x0133: {
        T: 1
    },
    /*::[*/ 0x0134: {
        T: -1
    },
    /*::[*/ 0x0135: {
        T: 1
    },
    /*::[*/ 0x0136: {
        T: -1
    },
    /*::[*/ 0x0137: {
        T: 1
    },
    /*::[*/ 0x0138: {
        T: -1
    },
    /*::[*/ 0x0139: {
        T: -1
    },
    /*::[*/ 0x013A: {
        T: 1
    },
    /*::[*/ 0x013B: {
        T: -1
    },
    /*::[*/ 0x013C: {
        T: 1
    },
    /*::[*/ 0x013D: {
        T: -1
    },
    /*::[*/ 0x013E: {
        T: 1
    },
    /*::[*/ 0x013F: {
        T: -1
    },
    /*::[*/ 0x0140: {
        T: 1
    },
    /*::[*/ 0x0141: {
        T: -1
    },
    /*::[*/ 0x0142: {
        T: 1
    },
    /*::[*/ 0x0143: {
        T: -1
    },
    /*::[*/ 0x0144: {
        T: 1
    },
    /*::[*/ 0x0145: {
        T: -1
    },
    /*::[*/ 0x0146: {
        T: 1
    },
    /*::[*/ 0x0147: {
        T: -1
    },
    /*::[*/ 0x0148: {
        T: 1
    },
    /*::[*/ 0x0149: {
        T: -1
    },
    /*::[*/ 0x014A: {
        T: 1
    },
    /*::[*/ 0x014B: {
        T: -1
    },
    /*::[*/ 0x014C: {
        T: 1
    },
    /*::[*/ 0x014D: {
        T: -1
    },
    /*::[*/ 0x014E: {
        T: 1
    },
    /*::[*/ 0x014F: {
        f: $3ee4f50b1ae43a89$var$parse_BrtMdtinfo
    },
    /*::[*/ 0x0150: {
        T: -1
    },
    /*::[*/ 0x0151: {
        f: $3ee4f50b1ae43a89$var$parse_BrtBeginEsmdb,
        T: 1
    },
    /*::[*/ 0x0152: {
        T: -1
    },
    /*::[*/ 0x0153: {
        T: 1
    },
    /*::[*/ 0x0154: {
        T: -1
    },
    /*::[*/ 0x0155: {
        T: 1
    },
    /*::[*/ 0x0156: {
        T: -1
    },
    /*::[*/ 0x0157: {
        T: 1
    },
    /*::[*/ 0x0158: {
        T: -1
    },
    /*::[*/ 0x0159: {
        T: 1
    },
    /*::[*/ 0x015A: {
        T: -1
    },
    /*::[*/ 0x015B: {
        T: 1
    },
    /*::[*/ 0x015C: {
        T: -1
    },
    /*::[*/ 0x015D: {
        T: 1
    },
    /*::[*/ 0x015E: {
        T: -1
    },
    /*::[*/ 0x015F: {},
    /*::[*/ 0x0160: {},
    /*::[*/ 0x0161: {
        T: 1
    },
    /*::[*/ 0x0162: {
        T: -1
    },
    /*::[*/ 0x0163: {
        f: $3ee4f50b1ae43a89$var$parse_RelID
    },
    /*::[*/ 0x0165: {},
    /*::[*/ 0x0166: {},
    /*::[*/ 0x0167: {},
    /*::[*/ 0x0168: {
        T: 1
    },
    /*::[*/ 0x0169: {},
    /*::[*/ 0x016A: {
        f: $3ee4f50b1ae43a89$var$parse_ExternSheet
    },
    /*::[*/ 0x016B: {},
    /*::[*/ 0x016C: {},
    /*::[*/ 0x016E: {},
    /*::[*/ 0x016F: {},
    /*::[*/ 0x0170: {},
    /*::[*/ 0x0171: {},
    /*::[*/ 0x0172: {},
    /*::[*/ 0x0173: {},
    /*::[*/ 0x0174: {
        T: 1
    },
    /*::[*/ 0x0175: {
        T: -1
    },
    /*::[*/ 0x0176: {
        T: 1
    },
    /*::[*/ 0x0177: {
        T: -1
    },
    /*::[*/ 0x0178: {
        T: 1
    },
    /*::[*/ 0x0179: {
        T: -1
    },
    /*::[*/ 0x017A: {
        T: 1
    },
    /*::[*/ 0x017B: {
        T: -1
    },
    /*::[*/ 0x017C: {
        T: 1
    },
    /*::[*/ 0x017D: {
        T: -1
    },
    /*::[*/ 0x017E: {
        T: 1
    },
    /*::[*/ 0x017F: {
        T: -1
    },
    /*::[*/ 0x0180: {
        T: 1
    },
    /*::[*/ 0x0181: {
        T: -1
    },
    /*::[*/ 0x0182: {
        T: 1
    },
    /*::[*/ 0x0183: {
        T: -1
    },
    /*::[*/ 0x0184: {
        T: 1
    },
    /*::[*/ 0x0185: {
        T: -1
    },
    /*::[*/ 0x0186: {
        T: 1
    },
    /*::[*/ 0x0187: {
        T: -1
    },
    /*::[*/ 0x0188: {
        T: 1
    },
    /*::[*/ 0x0189: {
        T: -1
    },
    /*::[*/ 0x018A: {
        T: 1
    },
    /*::[*/ 0x018B: {
        T: -1
    },
    /*::[*/ 0x018C: {},
    /*::[*/ 0x018D: {},
    /*::[*/ 0x018E: {},
    /*::[*/ 0x018F: {},
    /*::[*/ 0x0190: {},
    /*::[*/ 0x0191: {
        T: 1
    },
    /*::[*/ 0x0193: {},
    /*::[*/ 0x0194: {},
    /*::[*/ 0x0195: {},
    /*::[*/ 0x0196: {},
    /*::[*/ 0x0197: {},
    /*::[*/ 0x0198: {},
    /*::[*/ 0x0199: {},
    /*::[*/ 0x019A: {},
    /*::[*/ 0x019B: {},
    /*::[*/ 0x019C: {},
    /*::[*/ 0x019D: {},
    /*::[*/ 0x019E: {},
    /*::[*/ 0x019F: {},
    /*::[*/ 0x01A0: {},
    /*::[*/ 0x01A1: {},
    /*::[*/ 0x01A2: {},
    /*::[*/ 0x01A3: {},
    /*::[*/ 0x01A4: {},
    /*::[*/ 0x01A5: {},
    /*::[*/ 0x01A6: {
        T: 1
    },
    /*::[*/ 0x01A7: {
        T: 1
    },
    /*::[*/ 0x01A8: {
        T: -1
    },
    /*::[*/ 0x01A9: {
        T: -1
    },
    /*::[*/ 0x01AA: {
        f: $3ee4f50b1ae43a89$var$parse_BrtArrFmla
    },
    /*::[*/ 0x01AB: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShrFmla
    },
    /*::[*/ 0x01AC: {},
    /*::[*/ 0x01AD: {
        T: 1
    },
    /*::[*/ 0x01AE: {
        T: -1
    },
    /*::[*/ 0x01AF: {
        T: 1
    },
    /*::[*/ 0x01B0: {
        T: -1
    },
    /*::[*/ 0x01B1: {
        T: 1
    },
    /*::[*/ 0x01B2: {
        T: -1
    },
    /*::[*/ 0x01B3: {
        T: 1
    },
    /*::[*/ 0x01B4: {
        T: -1
    },
    /*::[*/ 0x01B5: {
        T: 1
    },
    /*::[*/ 0x01B6: {
        T: -1
    },
    /*::[*/ 0x01B7: {
        T: 1
    },
    /*::[*/ 0x01B8: {
        T: -1
    },
    /*::[*/ 0x01B9: {
        T: 1
    },
    /*::[*/ 0x01BA: {
        T: -1
    },
    /*::[*/ 0x01BB: {
        T: 1
    },
    /*::[*/ 0x01BC: {
        T: -1
    },
    /*::[*/ 0x01BD: {
        T: 1
    },
    /*::[*/ 0x01BE: {
        T: -1
    },
    /*::[*/ 0x01BF: {
        T: 1
    },
    /*::[*/ 0x01C0: {
        T: -1
    },
    /*::[*/ 0x01C1: {
        T: 1
    },
    /*::[*/ 0x01C2: {
        T: -1
    },
    /*::[*/ 0x01C3: {
        T: 1
    },
    /*::[*/ 0x01C4: {
        T: -1
    },
    /*::[*/ 0x01C5: {
        T: 1
    },
    /*::[*/ 0x01C6: {
        T: -1
    },
    /*::[*/ 0x01C7: {
        T: 1
    },
    /*::[*/ 0x01C8: {
        T: -1
    },
    /*::[*/ 0x01C9: {
        T: 1
    },
    /*::[*/ 0x01CA: {
        T: -1
    },
    /*::[*/ 0x01CB: {
        T: 1
    },
    /*::[*/ 0x01CC: {
        T: -1
    },
    /*::[*/ 0x01CD: {
        T: 1
    },
    /*::[*/ 0x01CE: {
        T: -1
    },
    /*::[*/ 0x01CF: {
        T: 1
    },
    /*::[*/ 0x01D0: {
        T: -1
    },
    /*::[*/ 0x01D1: {
        T: 1
    },
    /*::[*/ 0x01D2: {
        T: -1
    },
    /*::[*/ 0x01D3: {
        T: 1
    },
    /*::[*/ 0x01D4: {
        T: -1
    },
    /*::[*/ 0x01D5: {
        T: 1
    },
    /*::[*/ 0x01D6: {
        T: -1
    },
    /*::[*/ 0x01D7: {},
    /*::[*/ 0x01D8: {},
    /*::[*/ 0x01D9: {
        T: 1
    },
    /*::[*/ 0x01DA: {
        T: -1
    },
    /*::[*/ 0x01DB: {},
    /*::[*/ 0x01DC: {
        f: $3ee4f50b1ae43a89$var$parse_BrtMargins
    },
    /*::[*/ 0x01DD: {},
    /*::[*/ 0x01DE: {},
    /*::[*/ 0x01DF: {
        T: 1
    },
    /*::[*/ 0x01E0: {
        T: -1
    },
    /*::[*/ 0x01E1: {
        T: 1
    },
    /*::[*/ 0x01E2: {
        T: -1
    },
    /*::[*/ 0x01E3: {
        T: 1
    },
    /*::[*/ 0x01E4: {
        T: -1
    },
    /*::[*/ 0x01E5: {
        f: $3ee4f50b1ae43a89$var$parse_BrtWsFmtInfo
    },
    /*::[*/ 0x01E6: {
        T: 1
    },
    /*::[*/ 0x01E7: {
        T: -1
    },
    /*::[*/ 0x01E8: {
        T: 1
    },
    /*::[*/ 0x01E9: {
        T: -1
    },
    /*::[*/ 0x01EA: {
        T: 1
    },
    /*::[*/ 0x01EB: {
        T: -1
    },
    /*::[*/ 0x01EC: {
        T: 1
    },
    /*::[*/ 0x01ED: {
        T: -1
    },
    /*::[*/ 0x01EE: {
        f: $3ee4f50b1ae43a89$var$parse_BrtHLink
    },
    /*::[*/ 0x01EF: {
        T: 1
    },
    /*::[*/ 0x01F0: {
        T: -1
    },
    /*::[*/ 0x01F1: {
        T: 1
    },
    /*::[*/ 0x01F2: {
        T: -1
    },
    /*::[*/ 0x01F3: {},
    /*::[*/ 0x01F4: {
        T: 1
    },
    /*::[*/ 0x01F5: {
        T: -1
    },
    /*::[*/ 0x01F6: {
        T: 1
    },
    /*::[*/ 0x01F7: {
        T: -1
    },
    /*::[*/ 0x01F8: {},
    /*::[*/ 0x01F9: {
        T: 1
    },
    /*::[*/ 0x01FA: {
        T: -1
    },
    /*::[*/ 0x01FB: {},
    /*::[*/ 0x01FC: {
        T: 1
    },
    /*::[*/ 0x01FD: {
        T: -1
    },
    /*::[*/ 0x01FE: {
        T: 1
    },
    /*::[*/ 0x01FF: {
        T: -1
    },
    /*::[*/ 0x0200: {},
    /*::[*/ 0x0201: {},
    /*::[*/ 0x0202: {
        T: 1
    },
    /*::[*/ 0x0203: {
        T: -1
    },
    /*::[*/ 0x0204: {
        T: 1
    },
    /*::[*/ 0x0205: {
        T: -1
    },
    /*::[*/ 0x0206: {
        T: 1
    },
    /*::[*/ 0x0207: {
        T: -1
    },
    /*::[*/ 0x0208: {
        T: 1
    },
    /*::[*/ 0x0209: {
        T: -1
    },
    /*::[*/ 0x020A: {},
    /*::[*/ 0x020B: {},
    /*::[*/ 0x020C: {},
    /*::[*/ 0x020D: {},
    /*::[*/ 0x020E: {},
    /*::[*/ 0x020F: {},
    /*::[*/ 0x0210: {
        T: 1
    },
    /*::[*/ 0x0211: {
        T: -1
    },
    /*::[*/ 0x0212: {
        T: 1
    },
    /*::[*/ 0x0213: {
        T: -1
    },
    /*::[*/ 0x0214: {
        T: 1
    },
    /*::[*/ 0x0215: {
        T: -1
    },
    /*::[*/ 0x0216: {},
    /*::[*/ 0x0217: {},
    /*::[*/ 0x0218: {},
    /*::[*/ 0x0219: {},
    /*::[*/ 0x021A: {
        T: 1
    },
    /*::[*/ 0x021B: {
        T: -1
    },
    /*::[*/ 0x021C: {
        T: 1
    },
    /*::[*/ 0x021D: {
        T: -1
    },
    /*::[*/ 0x021E: {
        T: 1
    },
    /*::[*/ 0x0224: {},
    /*::[*/ 0x0225: {},
    /*::[*/ 0x0226: {
        f: $3ee4f50b1ae43a89$var$parse_RelID
    },
    /*::[*/ 0x0227: {},
    /*::[*/ 0x0228: {},
    /*::[*/ 0x0229: {},
    /*::[*/ 0x022A: {
        T: 1
    },
    /*::[*/ 0x022B: {
        T: -1
    },
    /*::[*/ 0x022C: {
        T: 1
    },
    /*::[*/ 0x022D: {
        T: -1
    },
    /*::[*/ 0x022E: {
        T: 1
    },
    /*::[*/ 0x022F: {
        T: -1
    },
    /*::[*/ 0x0230: {
        T: 1
    },
    /*::[*/ 0x0231: {
        T: -1
    },
    /*::[*/ 0x0232: {},
    /*::[*/ 0x0234: {},
    /*::[*/ 0x0235: {
        T: 1
    },
    /*::[*/ 0x0236: {
        T: -1
    },
    /*::[*/ 0x0239: {
        T: 1
    },
    /*::[*/ 0x023A: {
        T: -1
    },
    /*::[*/ 0x023C: {},
    /*::[*/ 0x023D: {
        T: 1
    },
    /*::[*/ 0x023E: {
        T: -1
    },
    /*::[*/ 0x0241: {},
    /*::[*/ 0x0242: {},
    /*::[*/ 0x0243: {},
    /*::[*/ 0x0244: {},
    /*::[*/ 0x0245: {},
    /*::[*/ 0x0246: {},
    /*::[*/ 0x0247: {},
    /*::[*/ 0x0248: {},
    /*::[*/ 0x0249: {},
    /*::[*/ 0x024A: {},
    /*::[*/ 0x024B: {},
    /*::[*/ 0x024C: {
        T: -1
    },
    /*::[*/ 0x024D: {},
    /*::[*/ 0x024E: {
        T: 1
    },
    /*::[*/ 0x024F: {
        T: -1
    },
    /*::[*/ 0x0250: {
        T: 1
    },
    /*::[*/ 0x0251: {
        T: -1
    },
    /*::[*/ 0x0252: {
        T: 1
    },
    /*::[*/ 0x0253: {
        T: -1
    },
    /*::[*/ 0x0254: {},
    /*::[*/ 0x0255: {
        T: 1
    },
    /*::[*/ 0x0256: {
        T: -1
    },
    /*::[*/ 0x0257: {
        T: 1
    },
    /*::[*/ 0x0258: {
        T: -1
    },
    /*::[*/ 0x0259: {
        T: 1
    },
    /*::[*/ 0x025A: {
        T: -1
    },
    /*::[*/ 0x025B: {
        T: 1
    },
    /*::[*/ 0x025C: {
        T: -1
    },
    /*::[*/ 0x025D: {
        T: 1
    },
    /*::[*/ 0x025E: {
        T: -1
    },
    /*::[*/ 0x025F: {},
    /*::[*/ 0x0260: {
        T: 1
    },
    /*::[*/ 0x0261: {
        T: -1
    },
    /*::[*/ 0x0262: {},
    /*::[*/ 0x0263: {
        T: 1
    },
    /*::[*/ 0x0264: {
        T: -1
    },
    /*::[*/ 0x0265: {
        T: 1
    },
    /*::[*/ 0x0266: {
        T: -1
    },
    /*::[*/ 0x0267: {
        T: 1
    },
    /*::[*/ 0x0268: {
        T: -1
    },
    /*::[*/ 0x0269: {
        T: 1
    },
    /*::[*/ 0x026A: {
        T: -1
    },
    /*::[*/ 0x026B: {
        T: 1
    },
    /*::[*/ 0x026C: {
        T: -1
    },
    /*::[*/ 0x0271: {},
    /*::[*/ 0x0272: {
        T: 1
    },
    /*::[*/ 0x0273: {
        T: -1
    },
    /*::[*/ 0x0274: {
        T: 1
    },
    /*::[*/ 0x0275: {
        T: -1
    },
    /*::[*/ 0x0276: {
        T: 1
    },
    /*::[*/ 0x0277: {
        T: -1
    },
    /*::[*/ 0x0278: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCommentAuthor
    },
    /*::[*/ 0x0279: {
        T: 1
    },
    /*::[*/ 0x027A: {
        T: -1
    },
    /*::[*/ 0x027B: {
        T: 1,
        f: $3ee4f50b1ae43a89$var$parse_BrtBeginComment
    },
    /*::[*/ 0x027C: {
        T: -1
    },
    /*::[*/ 0x027D: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCommentText
    },
    /*::[*/ 0x027E: {
        T: 1
    },
    /*::[*/ 0x027F: {},
    /*::[*/ 0x0280: {
        T: -1
    },
    /*::[*/ 0x0281: {
        T: 1
    },
    /*::[*/ 0x0282: {
        T: -1
    },
    /*::[*/ 0x0283: {
        T: 1
    },
    /*::[*/ 0x0284: {},
    /*::[*/ 0x0285: {
        T: -1
    },
    /*::[*/ 0x0286: {
        T: 1
    },
    /*::[*/ 0x0288: {
        T: 1
    },
    /*::[*/ 0x0289: {},
    /*::[*/ 0x028A: {
        T: -1
    },
    /*::[*/ 0x028B: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCsProp
    },
    /*::[*/ 0x028C: {},
    /*::[*/ 0x028D: {
        T: 1
    },
    /*::[*/ 0x028E: {
        T: -1
    },
    /*::[*/ 0x028F: {
        T: 1
    },
    /*::[*/ 0x0290: {
        T: -1
    },
    /*::[*/ 0x0291: {
        T: 1
    },
    /*::[*/ 0x0292: {
        T: -1
    },
    /*::[*/ 0x0293: {},
    /*::[*/ 0x0294: {
        T: 1
    },
    /*::[*/ 0x0295: {},
    /*::[*/ 0x0296: {
        T: -1
    },
    /*::[*/ 0x0297: {},
    /*::[*/ 0x0298: {
        T: 1
    },
    /*::[*/ 0x0299: {},
    /*::[*/ 0x029A: {
        T: -1
    },
    /*::[*/ 0x029B: {},
    /*::[*/ 0x029C: {},
    /*::[*/ 0x029D: {},
    /*::[*/ 0x029F: {
        T: 1
    },
    /*::[*/ 0x02A0: {
        T: -1
    },
    /*::[*/ 0x02A1: {
        T: 1
    },
    /*::[*/ 0x02A2: {
        T: -1
    },
    /*::[*/ 0x02A3: {},
    /*::[*/ 0x02A4: {},
    /*::[*/ 0x02A5: {},
    /*::[*/ 0x02A6: {},
    /*::[*/ 0x02A7: {},
    /*::[*/ 0x02A8: {},
    /*::[*/ 0x02A9: {},
    /*::[*/ 0x0400: {},
    /*::[*/ 0x0401: {},
    /*::[*/ 0x0402: {
        T: 1
    },
    /*::[*/ 0x0403: {
        T: -1
    },
    /*::[*/ 0x0404: {
        T: 1
    },
    /*::[*/ 0x0405: {
        T: -1
    },
    /*::[*/ 0x0406: {},
    /*::[*/ 0x0407: {
        T: 1
    },
    /*::[*/ 0x0408: {
        T: -1
    },
    /*::[*/ 0x0409: {
        T: 1
    },
    /*::[*/ 0x040A: {
        T: -1
    },
    /*::[*/ 0x040B: {},
    /*::[*/ 0x040C: {},
    /*::[*/ 0x040D: {},
    /*::[*/ 0x040E: {
        T: 1
    },
    /*::[*/ 0x040F: {
        T: -1
    },
    /*::[*/ 0x0410: {},
    /*::[*/ 0x0411: {
        T: 1
    },
    /*::[*/ 0x0412: {
        T: -1
    },
    /*::[*/ 0x0413: {},
    /*::[*/ 0x0414: {},
    /*::[*/ 0x0415: {},
    /*::[*/ 0x0416: {
        T: 1
    },
    /*::[*/ 0x0417: {
        T: -1
    },
    /*::[*/ 0x0418: {
        T: 1
    },
    /*::[*/ 0x0419: {
        T: -1
    },
    /*::[*/ 0x041A: {},
    /*::[*/ 0x041B: {
        T: 1
    },
    /*::[*/ 0x041C: {
        T: 1
    },
    /*::[*/ 0x041D: {
        f: $3ee4f50b1ae43a89$var$parse_BrtDVal14
    },
    /*::[*/ 0x041E: {
        T: 1
    },
    /*::[*/ 0x041F: {},
    /*::[*/ 0x0420: {
        T: 1
    },
    /*::[*/ 0x0421: {
        T: -1
    },
    /*::[*/ 0x0422: {
        T: 1
    },
    /*::[*/ 0x0423: {
        T: -1
    },
    /*::[*/ 0x0425: {},
    /*::[*/ 0x0426: {
        T: 1
    },
    /*::[*/ 0x0427: {
        T: -1
    },
    /*::[*/ 0x0428: {
        T: 1
    },
    /*::[*/ 0x0429: {
        T: -1
    },
    /*::[*/ 0x042A: {
        T: 1
    },
    /*::[*/ 0x042B: {
        T: -1
    },
    /*::[*/ 0x042C: {
        T: 1
    },
    /*::[*/ 0x042D: {
        T: -1
    },
    /*::[*/ 0x042E: {
        T: 1
    },
    /*::[*/ 0x042F: {
        T: -1
    },
    /*::[*/ 0x0430: {
        T: 1
    },
    /*::[*/ 0x0431: {
        T: -1
    },
    /*::[*/ 0x0433: {
        T: 1
    },
    /*::[*/ 0x0434: {
        T: -1
    },
    /*::[*/ 0x0435: {
        T: 1
    },
    /*::[*/ 0x0436: {
        T: -1
    },
    /*::[*/ 0x0437: {
        T: 1
    },
    /*::[*/ 0x0438: {
        T: -1
    },
    /*::[*/ 0x0439: {
        T: 1
    },
    /*::[*/ 0x043A: {
        T: -1
    },
    /*::[*/ 0x043B: {
        T: 1
    },
    /*::[*/ 0x043C: {
        T: -1
    },
    /*::[*/ 0x043D: {},
    /*::[*/ 0x043E: {
        T: 1
    },
    /*::[*/ 0x043F: {
        T: -1
    },
    /*::[*/ 0x0440: {
        T: 1
    },
    /*::[*/ 0x0441: {
        T: -1
    },
    /*::[*/ 0x0442: {
        T: 1
    },
    /*::[*/ 0x0443: {
        T: -1
    },
    /*::[*/ 0x0444: {
        T: 1
    },
    /*::[*/ 0x0445: {
        T: -1
    },
    /*::[*/ 0x0446: {
        T: 1
    },
    /*::[*/ 0x0447: {
        T: -1
    },
    /*::[*/ 0x0448: {},
    /*::[*/ 0x0449: {
        T: 1
    },
    /*::[*/ 0x044A: {},
    /*::[*/ 0x044B: {
        T: -1
    },
    /*::[*/ 0x044C: {
        T: 1
    },
    /*::[*/ 0x044D: {
        T: -1
    },
    /*::[*/ 0x044E: {},
    /*::[*/ 0x044F: {},
    /*::[*/ 0x0450: {},
    /*::[*/ 0x0451: {},
    /*::[*/ 0x0457: {},
    /*::[*/ 0x0458: {},
    /*::[*/ 0x0459: {
        T: 1
    },
    /*::[*/ 0x045A: {
        T: -1
    },
    /*::[*/ 0x045B: {
        T: 1
    },
    /*::[*/ 0x045C: {
        T: -1
    },
    /*::[*/ 0x045D: {},
    /*::[*/ 0x045E: {
        T: 1
    },
    /*::[*/ 0x045F: {
        T: -1
    },
    /*::[*/ 0x0460: {
        T: 1
    },
    /*::[*/ 0x0461: {
        T: -1
    },
    /*::[*/ 0x0462: {
        T: 1
    },
    /*::[*/ 0x0463: {
        T: -1
    },
    /*::[*/ 0x0464: {
        T: 1
    },
    /*::[*/ 0x0465: {
        T: -1
    },
    /*::[*/ 0x0466: {},
    /*::[*/ 0x0468: {
        T: 1
    },
    /*::[*/ 0x0469: {
        T: -1
    },
    /*::[*/ 0x046A: {},
    /*::[*/ 0x046B: {
        T: 1
    },
    /*::[*/ 0x046C: {
        T: -1
    },
    /*::[*/ 0x046D: {
        T: 1
    },
    /*::[*/ 0x046E: {
        T: -1
    },
    /*::[*/ 0x046F: {
        T: 1
    },
    /*::[*/ 0x0470: {
        T: -1
    },
    /*::[*/ 0x0471: {
        T: 1
    },
    /*::[*/ 0x0472: {
        T: -1
    },
    /*::[*/ 0x0473: {
        T: 1
    },
    /*::[*/ 0x0474: {
        T: -1
    },
    /*::[*/ 0x0475: {},
    /*::[*/ 0x0476: {
        T: 1
    },
    /*::[*/ 0x0477: {
        T: -1
    },
    /*::[*/ 0x0478: {
        T: 1
    },
    /*::[*/ 0x0479: {
        T: -1
    },
    /*::[*/ 0x047A: {},
    /*::[*/ 0x047B: {
        T: 1
    },
    /*::[*/ 0x047C: {
        T: -1
    },
    /*::[*/ 0x047D: {
        T: 1
    },
    /*::[*/ 0x047E: {
        T: -1
    },
    /*::[*/ 0x0480: {
        T: 1
    },
    /*::[*/ 0x0481: {
        T: -1
    },
    /*::[*/ 0x0482: {
        T: -1
    },
    /*::[*/ 0x0483: {
        T: -1
    },
    /*::[*/ 0x0484: {
        T: -1
    },
    /*::[*/ 0x0485: {
        T: 1
    },
    /*::[*/ 0x0486: {
        T: -1
    },
    /*::[*/ 0x0487: {
        T: 1
    },
    /*::[*/ 0x0488: {
        T: -1
    },
    /*::[*/ 0x0489: {
        T: 1
    },
    /*::[*/ 0x048A: {
        T: -1
    },
    /*::[*/ 0x048B: {
        T: 1
    },
    /*::[*/ 0x048C: {
        T: -1
    },
    /*::[*/ 0x048D: {
        T: 1
    },
    /*::[*/ 0x048E: {
        T: -1
    },
    /*::[*/ 0x048F: {
        T: 1
    },
    /*::[*/ 0x0490: {
        T: -1
    },
    /*::[*/ 0x0491: {
        T: 1
    },
    /*::[*/ 0x0492: {
        T: -1
    },
    /*::[*/ 0x0493: {},
    /*::[*/ 0x0494: {
        T: 1
    },
    /*::[*/ 0x0495: {
        T: -1
    },
    /*::[*/ 0x0499: {},
    /*::[*/ 0x049A: {
        T: 1
    },
    /*::[*/ 0x049C: {},
    /*::[*/ 0x049D: {},
    /*::[*/ 0x049E: {},
    /*::[*/ 0x0800: {
        T: 1
    },
    /*::[*/ 0x0801: {
        T: -1
    },
    /*::[*/ 0x0802: {},
    /*::[*/ 0x0803: {
        T: 1
    },
    /*::[*/ 0x0804: {
        T: -1
    },
    /*::[*/ 0x0805: {},
    /*::[*/ 0x0806: {},
    /*::[*/ 0x0807: {
        T: 1
    },
    /*::[*/ 0x0808: {
        T: -1
    },
    /*::[*/ 0x0809: {
        T: 1
    },
    /*::[*/ 0x080A: {
        T: -1
    },
    /*::[*/ 0x080C: {},
    /*::[*/ 0x0813: {},
    /*::[*/ 0x0814: {
        T: 1
    },
    /*::[*/ 0x0815: {
        T: -1
    },
    /*::[*/ 0x0816: {},
    /*::[*/ 0x0817: {},
    /*::[*/ 0x0818: {
        T: 1
    },
    /*::[*/ 0x0819: {
        T: -1
    },
    /*::[*/ 0x081B: {},
    /*::[*/ 0x081C: {},
    /*::[*/ 0x081D: {
        T: 1
    },
    /*::[*/ 0x081E: {
        T: -1
    },
    /*::[*/ 0x081F: {},
    /*::[*/ 0x0820: {
        T: 1
    },
    /*::[*/ 0x0821: {
        T: -1
    },
    /*::[*/ 0x0822: {},
    /*::[*/ 0x0823: {
        T: 1
    },
    /*::[*/ 0x0824: {
        T: -1
    },
    /*::[*/ 0x0825: {
        T: 1
    },
    /*::[*/ 0x0826: {
        T: -1
    },
    /*::[*/ 0x0827: {
        T: 1
    },
    /*::[*/ 0x0828: {
        T: -1
    },
    /*::[*/ 0x0829: {
        T: 1
    },
    /*::[*/ 0x082A: {
        T: -1
    },
    /*::[*/ 0x082B: {},
    /*::[*/ 0x082C: {},
    /*::[*/ 0x082D: {
        T: 1
    },
    /*::[*/ 0x082E: {
        T: -1
    },
    /*::[*/ 0x082F: {},
    /*::[*/ 0x0830: {
        T: 1
    },
    /*::[*/ 0x0831: {
        T: -1
    },
    /*::[*/ 0x0832: {
        T: 1
    },
    /*::[*/ 0x0833: {
        T: -1
    },
    /*::[*/ 0x0834: {
        T: 1
    },
    /*::[*/ 0x0835: {
        T: -1
    },
    /*::[*/ 0x0836: {},
    /*::[*/ 0x0837: {
        T: 1
    },
    /*::[*/ 0x0838: {
        T: -1
    },
    /*::[*/ 0x0839: {},
    /*::[*/ 0x083A: {
        T: 1
    },
    /*::[*/ 0x083B: {
        T: -1
    },
    /*::[*/ 0x083C: {},
    /*::[*/ 0x083D: {
        T: 1
    },
    /*::[*/ 0x083E: {
        T: -1
    },
    /*::[*/ 0x083F: {
        T: 1
    },
    /*::[*/ 0x0840: {
        T: -1
    },
    /*::[*/ 0x0841: {
        T: 1
    },
    /*::[*/ 0x0842: {
        T: -1
    },
    /*::[*/ 0x0843: {},
    /*::[*/ 0x0844: {},
    /*::[*/ 0x0845: {},
    /*::[*/ 0x0846: {
        T: 1
    },
    /*::[*/ 0x0847: {
        T: -1
    },
    /*::[*/ 0x0848: {},
    /*::[*/ 0x0849: {
        T: 1
    },
    /*::[*/ 0x084A: {
        T: -1
    },
    /*::[*/ 0x084B: {
        T: 1
    },
    /*::[*/ 0x084C: {
        T: -1
    },
    /*::[*/ 0x084D: {},
    /*::[*/ 0x084E: {
        T: 1
    },
    /*::[*/ 0x084F: {
        T: -1
    },
    /*::[*/ 0x0850: {},
    /*::[*/ 0x0851: {
        T: 1
    },
    /*::[*/ 0x0852: {
        T: -1
    },
    /*::[*/ 0x0853: {
        T: 1
    },
    /*::[*/ 0x0854: {
        T: -1
    },
    /*::[*/ 0x0855: {
        T: 1
    },
    /*::[*/ 0x0856: {},
    /*::[*/ 0x0857: {},
    /*::[*/ 0x0858: {},
    /*::[*/ 0x0859: {
        T: 1
    },
    /*::[*/ 0x085A: {
        T: -1
    },
    /*::[*/ 0x085B: {
        T: 1
    },
    /*::[*/ 0x085C: {
        T: -1
    },
    /*::[*/ 0x085D: {},
    /*::[*/ 0x0C00: {},
    /*::[*/ 0x0C01: {},
    /*::[*/ 0x1000: {
        T: 1
    },
    /*::[*/ 0x1001: {
        T: -1
    },
    /*::[*/ 0x138A: {
        T: 1
    },
    /*::[*/ 0x138B: {
        T: -1
    },
    /*::[*/ 0x13D9: {
        T: 1
    },
    /*::[*/ 0x13DA: {
        T: -1
    },
    /*::[*/ 0x13DB: {},
    /*::[*/ 0x13DC: {
        T: 1
    },
    /*::[*/ 0x13DD: {
        T: -1
    },
    /*::[*/ 0x13DE: {
        T: 1
    },
    /*::[*/ 0x13DF: {
        T: -1
    },
    /*::[*/ 0x13E0: {},
    /*::[*/ 0x13E1: {},
    /*::[*/ 0x13E2: {},
    /*::[*/ 0x13E4: {
        T: 1
    },
    /*::[*/ 0x13E5: {
        T: -1
    },
    /*::[*/ 0x13E6: {},
    /*::[*/ 0x13E7: {
        T: 1
    },
    /*::[*/ 0x13E8: {
        T: -1
    },
    /*::[*/ 0x13E9: {},
    /*::[*/ 0x13EB: {},
    /*::[*/ 0xFFFF: {
        n: ""
    }
};
/* [MS-XLS] 2.3 Record Enumeration (and other sources) */ var $3ee4f50b1ae43a89$var$XLSRecordEnum = {
    /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */ /*::[*/ 0x0006: {
        f: $3ee4f50b1ae43a89$var$parse_Formula
    },
    /*::[*/ 0x000a: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    /*::[*/ 0x000c: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x000d: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x000e: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x000f: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0010: {
        f: $3ee4f50b1ae43a89$var$parse_Xnum
    },
    /*::[*/ 0x0011: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0012: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0013: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x0014: {
        f: $3ee4f50b1ae43a89$var$parse_XLHeaderFooter
    },
    /*::[*/ 0x0015: {
        f: $3ee4f50b1ae43a89$var$parse_XLHeaderFooter
    },
    /*::[*/ 0x0017: {
        f: $3ee4f50b1ae43a89$var$parse_ExternSheet
    },
    /*::[*/ 0x0018: {
        f: $3ee4f50b1ae43a89$var$parse_Lbl
    },
    /*::[*/ 0x0019: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x001a: {},
    /*::[*/ 0x001b: {},
    /*::[*/ 0x001c: {
        f: $3ee4f50b1ae43a89$var$parse_Note
    },
    /*::[*/ 0x001d: {},
    /*::[*/ 0x0022: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0023: {
        f: $3ee4f50b1ae43a89$var$parse_ExternName
    },
    /*::[*/ 0x0026: {
        f: $3ee4f50b1ae43a89$var$parse_Xnum
    },
    /*::[*/ 0x0027: {
        f: $3ee4f50b1ae43a89$var$parse_Xnum
    },
    /*::[*/ 0x0028: {
        f: $3ee4f50b1ae43a89$var$parse_Xnum
    },
    /*::[*/ 0x0029: {
        f: $3ee4f50b1ae43a89$var$parse_Xnum
    },
    /*::[*/ 0x002a: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x002b: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x002f: {
        f: $3ee4f50b1ae43a89$var$parse_FilePass
    },
    /*::[*/ 0x0031: {
        f: $3ee4f50b1ae43a89$var$parse_Font
    },
    /*::[*/ 0x0033: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x003c: {},
    /*::[*/ 0x003d: {
        f: $3ee4f50b1ae43a89$var$parse_Window1
    },
    /*::[*/ 0x0040: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0041: {
        f: $3ee4f50b1ae43a89$var$parse_Pane
    },
    /*::[*/ 0x0042: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x004d: {},
    /*::[*/ 0x0050: {},
    /*::[*/ 0x0051: {},
    /*::[*/ 0x0052: {},
    /*::[*/ 0x0055: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x0059: {},
    /*::[*/ 0x005a: {},
    /*::[*/ 0x005b: {},
    /*::[*/ 0x005c: {
        f: $3ee4f50b1ae43a89$var$parse_WriteAccess
    },
    /*::[*/ 0x005d: {
        f: $3ee4f50b1ae43a89$var$parse_Obj
    },
    /*::[*/ 0x005e: {},
    /*::[*/ 0x005f: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0060: {},
    /*::[*/ 0x0061: {},
    /*::[*/ 0x0063: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x007d: {
        f: $3ee4f50b1ae43a89$var$parse_ColInfo
    },
    /*::[*/ 0x0080: {
        f: $3ee4f50b1ae43a89$var$parse_Guts
    },
    /*::[*/ 0x0081: {
        f: $3ee4f50b1ae43a89$var$parse_WsBool
    },
    /*::[*/ 0x0082: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x0083: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0084: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0085: {
        f: $3ee4f50b1ae43a89$var$parse_BoundSheet8
    },
    /*::[*/ 0x0086: {},
    /*::[*/ 0x008c: {
        f: $3ee4f50b1ae43a89$var$parse_Country
    },
    /*::[*/ 0x008d: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x0090: {},
    /*::[*/ 0x0092: {
        f: $3ee4f50b1ae43a89$var$parse_Palette
    },
    /*::[*/ 0x0097: {},
    /*::[*/ 0x0098: {},
    /*::[*/ 0x0099: {},
    /*::[*/ 0x009a: {},
    /*::[*/ 0x009b: {},
    /*::[*/ 0x009c: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x009d: {},
    /*::[*/ 0x009e: {},
    /*::[*/ 0x00a0: {
        f: $3ee4f50b1ae43a89$var$parse_Scl
    },
    /*::[*/ 0x00a1: {
        f: $3ee4f50b1ae43a89$var$parse_Setup
    },
    /*::[*/ 0x00ae: {},
    /*::[*/ 0x00af: {},
    /*::[*/ 0x00b0: {},
    /*::[*/ 0x00b1: {},
    /*::[*/ 0x00b2: {},
    /*::[*/ 0x00b4: {},
    /*::[*/ 0x00b5: {},
    /*::[*/ 0x00b6: {},
    /*::[*/ 0x00b8: {},
    /*::[*/ 0x00b9: {},
    /*::[*/ 0x00bd: {
        f: $3ee4f50b1ae43a89$var$parse_MulRk
    },
    /*::[*/ 0x00be: {
        f: $3ee4f50b1ae43a89$var$parse_MulBlank
    },
    /*::[*/ 0x00c1: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    /*::[*/ 0x00c5: {},
    /*::[*/ 0x00c6: {},
    /*::[*/ 0x00c7: {},
    /*::[*/ 0x00c8: {},
    /*::[*/ 0x00c9: {},
    /*::[*/ 0x00ca: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x00cb: {},
    /*::[*/ 0x00cc: {},
    /*::[*/ 0x00cd: {},
    /*::[*/ 0x00ce: {},
    /*::[*/ 0x00cf: {},
    /*::[*/ 0x00d0: {},
    /*::[*/ 0x00d1: {},
    /*::[*/ 0x00d2: {},
    /*::[*/ 0x00d3: {},
    /*::[*/ 0x00d5: {},
    /*::[*/ 0x00d7: {},
    /*::[*/ 0x00d8: {},
    /*::[*/ 0x00d9: {},
    /*::[*/ 0x00da: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x00dc: {},
    /*::[*/ 0x00dd: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x00de: {},
    /*::[*/ 0x00e0: {
        f: $3ee4f50b1ae43a89$var$parse_XF
    },
    /*::[*/ 0x00e1: {
        f: $3ee4f50b1ae43a89$var$parse_InterfaceHdr
    },
    /*::[*/ 0x00e2: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    /*::[*/ 0x00e3: {},
    /*::[*/ 0x00e5: {
        f: $3ee4f50b1ae43a89$var$parse_MergeCells
    },
    /*::[*/ 0x00e9: {},
    /*::[*/ 0x00eb: {},
    /*::[*/ 0x00ec: {},
    /*::[*/ 0x00ed: {},
    /*::[*/ 0x00ef: {},
    /*::[*/ 0x00f0: {},
    /*::[*/ 0x00f1: {},
    /*::[*/ 0x00f2: {},
    /*::[*/ 0x00f4: {},
    /*::[*/ 0x00f5: {},
    /*::[*/ 0x00f6: {},
    /*::[*/ 0x00f7: {},
    /*::[*/ 0x00f8: {},
    /*::[*/ 0x00f9: {},
    /*::[*/ 0x00fb: {},
    /*::[*/ 0x00fc: {
        f: $3ee4f50b1ae43a89$var$parse_SST
    },
    /*::[*/ 0x00fd: {
        f: $3ee4f50b1ae43a89$var$parse_LabelSst
    },
    /*::[*/ 0x00ff: {
        f: $3ee4f50b1ae43a89$var$parse_ExtSST
    },
    /*::[*/ 0x0100: {},
    /*::[*/ 0x0103: {},
    /*::[*/ 0x0122: {},
    /*::[*/ 0x0137: {},
    /*::[*/ 0x0138: {},
    /*::[*/ 0x013b: {},
    /*::[*/ 0x013d: {
        f: $3ee4f50b1ae43a89$var$parseuint16a
    },
    /*::[*/ 0x013e: {},
    /*::[*/ 0x013f: {},
    /*::[*/ 0x0140: {},
    /*::[*/ 0x014a: {},
    /*::[*/ 0x014b: {},
    /*::[*/ 0x014d: {},
    /*::[*/ 0x014e: {},
    /*::[*/ 0x014f: {},
    /*::[*/ 0x0150: {},
    /*::[*/ 0x0151: {},
    /*::[*/ 0x0152: {},
    /*::[*/ 0x0153: {},
    /*::[*/ 0x0154: {},
    /*::[*/ 0x015f: {},
    /*::[*/ 0x0160: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0161: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    /*::[*/ 0x0191: {},
    /*::[*/ 0x0192: {},
    /*::[*/ 0x0193: {},
    /*::[*/ 0x0194: {},
    /*::[*/ 0x0195: {},
    /*::[*/ 0x0196: {},
    /*::[*/ 0x0197: {},
    /*::[*/ 0x0198: {},
    /*::[*/ 0x01a9: {},
    /*::[*/ 0x01aa: {},
    /*::[*/ 0x01ab: {},
    /*::[*/ 0x01ac: {},
    /*::[*/ 0x01ad: {},
    /*::[*/ 0x01ae: {
        f: $3ee4f50b1ae43a89$var$parse_SupBook
    },
    /*::[*/ 0x01af: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x01b0: {},
    /*::[*/ 0x01b1: {},
    /*::[*/ 0x01b2: {},
    /*::[*/ 0x01b5: {},
    /*::[*/ 0x01b6: {
        f: $3ee4f50b1ae43a89$var$parse_TxO
    },
    /*::[*/ 0x01b7: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x01b8: {
        f: $3ee4f50b1ae43a89$var$parse_HLink
    },
    /*::[*/ 0x01b9: {},
    /*::[*/ 0x01ba: {
        f: $3ee4f50b1ae43a89$var$parse_XLUnicodeString
    },
    /*::[*/ 0x01bb: {},
    /*::[*/ 0x01bc: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x01bd: {},
    /*::[*/ 0x01be: {},
    /*::[*/ 0x01c0: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    /*::[*/ 0x01c1: {
        f: $3ee4f50b1ae43a89$var$parse_RecalcId,
        r: 2
    },
    /*::[*/ 0x01c2: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    /*::[*/ 0x0200: {
        f: $3ee4f50b1ae43a89$var$parse_Dimensions
    },
    /*::[*/ 0x0201: {
        f: $3ee4f50b1ae43a89$var$parse_Blank
    },
    /*::[*/ 0x0203: {
        f: $3ee4f50b1ae43a89$var$parse_Number
    },
    /*::[*/ 0x0204: {
        f: $3ee4f50b1ae43a89$var$parse_Label
    },
    /*::[*/ 0x0205: {
        f: $3ee4f50b1ae43a89$var$parse_BoolErr
    },
    /*::[*/ 0x0207: {
        f: $3ee4f50b1ae43a89$var$parse_String
    },
    /*::[*/ 0x0208: {
        f: $3ee4f50b1ae43a89$var$parse_Row
    },
    /*::[*/ 0x020b: {},
    /*::[*/ 0x0221: {
        f: $3ee4f50b1ae43a89$var$parse_Array
    },
    /*::[*/ 0x0225: {
        f: $3ee4f50b1ae43a89$var$parse_DefaultRowHeight
    },
    /*::[*/ 0x0236: {},
    /*::[*/ 0x023e: {
        f: $3ee4f50b1ae43a89$var$parse_Window2
    },
    /*::[*/ 0x027e: {
        f: $3ee4f50b1ae43a89$var$parse_RK
    },
    /*::[*/ 0x0293: {},
    /*::[*/ 0x0418: {},
    /*::[*/ 0x041e: {
        f: $3ee4f50b1ae43a89$var$parse_Format
    },
    /*::[*/ 0x043c: {},
    /*::[*/ 0x04bc: {
        f: $3ee4f50b1ae43a89$var$parse_ShrFmla
    },
    /*::[*/ 0x0800: {
        f: $3ee4f50b1ae43a89$var$parse_HLinkTooltip
    },
    /*::[*/ 0x0801: {},
    /*::[*/ 0x0802: {},
    /*::[*/ 0x0803: {},
    /*::[*/ 0x0804: {},
    /*::[*/ 0x0805: {},
    /*::[*/ 0x0806: {},
    /*::[*/ 0x0807: {},
    /*::[*/ 0x0808: {},
    /*::[*/ 0x0809: {
        f: $3ee4f50b1ae43a89$var$parse_BOF
    },
    /*::[*/ 0x080a: {},
    /*::[*/ 0x080b: {},
    /*::[*/ 0x080c: {},
    /*::[*/ 0x080d: {},
    /*::[*/ 0x080e: {},
    /*::[*/ 0x080f: {},
    /*::[*/ 0x0810: {},
    /*::[*/ 0x0812: {},
    /*::[*/ 0x0813: {},
    /*::[*/ 0x0850: {},
    /*::[*/ 0x0851: {},
    /*::[*/ 0x0852: {},
    /*::[*/ 0x0853: {},
    /*::[*/ 0x0854: {},
    /*::[*/ 0x0855: {},
    /*::[*/ 0x0856: {},
    /*::[*/ 0x0857: {},
    /*::[*/ 0x0858: {},
    /*::[*/ 0x0859: {},
    /*::[*/ 0x085a: {},
    /*::[*/ 0x0862: {},
    /*::[*/ 0x0863: {
        r: 12
    },
    /*::[*/ 0x0864: {},
    /*::[*/ 0x0865: {},
    /*::[*/ 0x0866: {},
    /*::[*/ 0x0867: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    /*::[*/ 0x0868: {},
    /*::[*/ 0x086a: {},
    /*::[*/ 0x086b: {},
    /*::[*/ 0x086c: {},
    /*::[*/ 0x0871: {},
    /*::[*/ 0x0872: {},
    /*::[*/ 0x0874: {},
    /*::[*/ 0x0875: {},
    /*::[*/ 0x0876: {},
    /*::[*/ 0x0877: {},
    /*::[*/ 0x0878: {},
    /*::[*/ 0x0879: {},
    /*::[*/ 0x087a: {},
    /*::[*/ 0x087b: {},
    /*::[*/ 0x087c: {
        f: $3ee4f50b1ae43a89$var$parse_XFCRC,
        r: 12
    },
    /*::[*/ 0x087d: {
        f: $3ee4f50b1ae43a89$var$parse_XFExt,
        r: 12
    },
    /*::[*/ 0x087e: {},
    /*::[*/ 0x087f: {},
    /*::[*/ 0x0884: {},
    /*::[*/ 0x0885: {},
    /*::[*/ 0x0886: {},
    /*::[*/ 0x0887: {},
    /*::[*/ 0x0888: {},
    /*::[*/ 0x0889: {},
    /*::[*/ 0x088a: {},
    /*::[*/ 0x088b: {},
    /*::[*/ 0x088c: {
        f: $3ee4f50b1ae43a89$var$parsebool,
        r: 12
    },
    /*::[*/ 0x088d: {},
    /*::[*/ 0x088e: {
        r: 12
    },
    /*::[*/ 0x088f: {},
    /*::[*/ 0x0890: {},
    /*::[*/ 0x0892: {},
    /*::[*/ 0x0893: {},
    /*::[*/ 0x0894: {
        f: $3ee4f50b1ae43a89$var$parse_NameCmt,
        r: 12
    },
    /*::[*/ 0x0895: {},
    /*::[*/ 0x0896: {
        f: $3ee4f50b1ae43a89$var$parse_Theme,
        r: 12
    },
    /*::[*/ 0x0897: {},
    /*::[*/ 0x0898: {},
    /*::[*/ 0x0899: {},
    /*::[*/ 0x089a: {
        f: $3ee4f50b1ae43a89$var$parse_MTRSettings,
        r: 12
    },
    /*::[*/ 0x089b: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    /*::[*/ 0x089c: {},
    /*::[*/ 0x089d: {},
    /*::[*/ 0x089e: {},
    /*::[*/ 0x089f: {},
    /*::[*/ 0x08a3: {
        f: $3ee4f50b1ae43a89$var$parse_ForceFullCalculation
    },
    /*::[*/ 0x08a4: {},
    /*::[*/ 0x08a5: {},
    /*::[*/ 0x08a6: {},
    /*::[*/ 0x08a7: {},
    /*::[*/ 0x1001: {},
    /*::[*/ 0x1002: {},
    /*::[*/ 0x1003: {},
    /*::[*/ 0x1006: {},
    /*::[*/ 0x1007: {},
    /*::[*/ 0x1009: {},
    /*::[*/ 0x100a: {},
    /*::[*/ 0x100b: {},
    /*::[*/ 0x100c: {},
    /*::[*/ 0x100d: {},
    /*::[*/ 0x1014: {},
    /*::[*/ 0x1015: {},
    /*::[*/ 0x1016: {},
    /*::[*/ 0x1017: {},
    /*::[*/ 0x1018: {},
    /*::[*/ 0x1019: {},
    /*::[*/ 0x101a: {},
    /*::[*/ 0x101b: {},
    /*::[*/ 0x101c: {},
    /*::[*/ 0x101d: {},
    /*::[*/ 0x101e: {},
    /*::[*/ 0x101f: {},
    /*::[*/ 0x1020: {},
    /*::[*/ 0x1021: {},
    /*::[*/ 0x1022: {},
    /*::[*/ 0x1024: {},
    /*::[*/ 0x1025: {},
    /*::[*/ 0x1026: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x1027: {},
    /*::[*/ 0x1032: {},
    /*::[*/ 0x1033: {},
    /*::[*/ 0x1034: {},
    /*::[*/ 0x1035: {},
    /*::[*/ 0x103a: {},
    /*::[*/ 0x103c: {},
    /*::[*/ 0x103d: {},
    /*::[*/ 0x103e: {},
    /*::[*/ 0x103f: {},
    /*::[*/ 0x1040: {},
    /*::[*/ 0x1041: {},
    /*::[*/ 0x1043: {},
    /*::[*/ 0x1044: {
        f: $3ee4f50b1ae43a89$var$parse_ShtProps
    },
    /*::[*/ 0x1045: {},
    /*::[*/ 0x1046: {},
    /*::[*/ 0x1048: {},
    /*::[*/ 0x104a: {},
    /*::[*/ 0x104b: {},
    /*::[*/ 0x104e: {},
    /*::[*/ 0x104f: {},
    /*::[*/ 0x1050: {},
    /*::[*/ 0x1051: {},
    /*::[*/ 0x105b: {},
    /*::[*/ 0x105c: {
        f: $3ee4f50b1ae43a89$var$parse_ClrtClient
    },
    /*::[*/ 0x105d: {},
    /*::[*/ 0x105f: {},
    /*::[*/ 0x1060: {},
    /*::[*/ 0x1061: {},
    /*::[*/ 0x1062: {},
    /*::[*/ 0x1063: {},
    /*::[*/ 0x1064: {},
    /*::[*/ 0x1065: {},
    /*::[*/ 0x1066: {},
    /*::[*/ 0x1067: {},
    /*::[*/ 0x1068: {},
    /*::[*/ 0x0000: {
        f: $3ee4f50b1ae43a89$var$parse_Dimensions
    },
    /*::[*/ 0x0001: {},
    /*::[*/ 0x0002: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2INT
    },
    /*::[*/ 0x0003: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2NUM
    },
    /*::[*/ 0x0004: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2STR
    },
    /*::[*/ 0x0005: {
        f: $3ee4f50b1ae43a89$var$parse_BoolErr
    },
    /*::[*/ 0x0007: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2STRING
    },
    /*::[*/ 0x0008: {},
    /*::[*/ 0x0009: {
        f: $3ee4f50b1ae43a89$var$parse_BOF
    },
    /*::[*/ 0x000b: {},
    /*::[*/ 0x0016: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x001e: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2Format
    },
    /*::[*/ 0x001f: {},
    /* 16-bit cnt of BIFF2FORMAT records */ /*::[*/ 0x0020: {},
    /*::[*/ 0x0021: {
        f: $3ee4f50b1ae43a89$var$parse_Array
    },
    /*::[*/ 0x0024: {},
    /*::[*/ 0x0025: {
        f: $3ee4f50b1ae43a89$var$parse_DefaultRowHeight
    },
    // 0x2c ??
    // 0x2d ??
    // 0x2e ??
    // 0x30 FONTCOUNT: number of fonts
    /*::[*/ 0x0032: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2FONTXTRA
    },
    // 0x35: INFOOPTS
    // 0x36: TABLE (BIFF2 only)
    // 0x37: TABLE2 (BIFF2 only)
    // 0x38: WNDESK
    // 0x39 ??
    // 0x3a: BEGINPREF
    // 0x3b: ENDPREF
    /*::[*/ 0x003e: {},
    // 0x3f ??
    // 0x46: SHOWSCROLL
    // 0x47: SHOWFORMULA
    // 0x48: STATUSBAR
    // 0x49: SHORTMENUS
    // 0x4A:
    // 0x4B:
    // 0x4C:
    // 0x4E:
    // 0x4F:
    // 0x58: TOOLBAR (BIFF3)
    /* - - - */ /*::[*/ 0x0034: {},
    /*::[*/ 0x0043: {},
    /*::[*/ 0x0044: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x0045: {},
    /*::[*/ 0x0056: {},
    /* 16-bit cnt, similar to BIFF2 */ /*::[*/ 0x007e: {},
    /* Not necessarily same as 0x027e */ /*::[*/ 0x007f: {
        f: $3ee4f50b1ae43a89$var$parse_ImData
    },
    /*::[*/ 0x0087: {},
    /*::[*/ 0x0088: {},
    /*::[*/ 0x0089: {},
    // 0x8A
    // 0x8B LH: alternate menu key flag (BIFF3/4)
    // 0x8E
    // 0x8F
    /*::[*/ 0x0091: {},
    // 0x93 STYLE
    /*::[*/ 0x0094: {},
    /*::[*/ 0x0095: {},
    /*::[*/ 0x0096: {},
    // 0xA2 FNPROTO: function prototypes (BIFF4)
    // 0xA3
    // 0xA8
    /*::[*/ 0x00a9: {},
    /*::[*/ 0x00ab: {},
    /*::[*/ 0x00bc: {},
    /* Not necessarily same as 0x04bc */ /*::[*/ 0x00bf: {},
    /*::[*/ 0x00c0: {},
    /*::[*/ 0x00c2: {},
    /*::[*/ 0x00c3: {},
    /*::[*/ 0x00d6: {
        f: $3ee4f50b1ae43a89$var$parse_RString
    },
    /*::[*/ 0x00df: {},
    /*::[*/ 0x00ea: {},
    /*::[*/ 0x0162: {},
    /*::[*/ 0x01a5: {},
    /*::[*/ 0x0206: {
        f: $3ee4f50b1ae43a89$var$parse_Formula
    },
    /*::[*/ 0x0209: {
        f: $3ee4f50b1ae43a89$var$parse_BOF
    },
    /*::[*/ 0x0218: {
        f: $3ee4f50b1ae43a89$var$parse_Lbl
    },
    /*::[*/ 0x0223: {
        f: $3ee4f50b1ae43a89$var$parse_ExternName
    },
    /*::[*/ 0x0231: {},
    /*::[*/ 0x0243: {},
    /*::[*/ 0x0406: {
        f: $3ee4f50b1ae43a89$var$parse_Formula
    },
    /*::[*/ 0x0409: {
        f: $3ee4f50b1ae43a89$var$parse_BOF
    },
    /*::[*/ 0x0443: {},
    /*::[*/ 0x086d: {},
    /*::[*/ 0x0873: {},
    /*::[*/ 0x0881: {},
    /*::[*/ 0x08c0: {},
    /*::[*/ 0x08c1: {},
    /*::[*/ 0x08c2: {},
    /*::[*/ 0x08c3: {},
    /*::[*/ 0x08c4: {},
    /*::[*/ 0x08c5: {},
    /*::[*/ 0x08c6: {},
    /*::[*/ 0x08c7: {},
    /*::[*/ 0x08c8: {},
    /*::[*/ 0x08c9: {},
    /*::[*/ 0x08ca: {},
    /*::[*/ 0x08cb: {},
    /*::[*/ 0x08d6: {
        r: 12
    },
    /*::[*/ 0x7262: {}
};
function $3ee4f50b1ae43a89$var$write_biff_rec(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var t /*:number*/  = type;
    if (isNaN(t)) return;
    var len = length || (payload || []).length || 0;
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, len);
    if (/*:: len != null &&*/ len > 0 && $3ee4f50b1ae43a89$var$is_buf(payload)) ba.push(payload);
}
function $3ee4f50b1ae43a89$var$write_biff_continue(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var len = length || (payload || []).length || 0;
    if (len <= 8224) return $3ee4f50b1ae43a89$var$write_biff_rec(ba, type, payload, len);
    var t = type;
    if (isNaN(t)) return;
    var parts = payload.parts || [], sidx = 0;
    var i = 0, w = 0;
    while(w + (parts[sidx] || 8224) <= 8224){
        w += parts[sidx] || 8224;
        sidx++;
    }
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, w);
    ba.push(payload.slice(i, i + w));
    i += w;
    while(i < len){
        o = ba.next(4);
        o.write_shift(2, 0x3c); // TODO: figure out correct continue type
        w = 0;
        while(w + (parts[sidx] || 8224) <= 8224){
            w += parts[sidx] || 8224;
            sidx++;
        }
        o.write_shift(2, w);
        ba.push(payload.slice(i, i + w));
        i += w;
    }
}
function $3ee4f50b1ae43a89$var$write_BIFF2Cell(out, r /*:number*/ , c /*:number*/ ) {
    if (!out) out = $3ee4f50b1ae43a89$var$new_buf(7);
    out.write_shift(2, r);
    out.write_shift(2, c);
    out.write_shift(2, 0);
    out.write_shift(1, 0);
    return out;
}
function $3ee4f50b1ae43a89$var$write_BIFF2BERR(r /*:number*/ , c /*:number*/ , val, t /*:?string*/ ) {
    var out = $3ee4f50b1ae43a89$var$new_buf(9);
    $3ee4f50b1ae43a89$var$write_BIFF2Cell(out, r, c);
    $3ee4f50b1ae43a89$var$write_Bes(val, t || "b", out);
    return out;
}
/* TODO: codepage, large strings */ function $3ee4f50b1ae43a89$var$write_BIFF2LABEL(r /*:number*/ , c /*:number*/ , val) {
    var out = $3ee4f50b1ae43a89$var$new_buf(8 + 2 * val.length);
    $3ee4f50b1ae43a89$var$write_BIFF2Cell(out, r, c);
    out.write_shift(1, val.length);
    out.write_shift(val.length, val, "sbcs");
    return out.l < out.length ? out.slice(0, out.l) : out;
}
function $3ee4f50b1ae43a89$var$write_ws_biff2_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/  /*::, opts*/ ) {
    if (cell.v != null) switch(cell.t){
        case "d":
        case "n":
            var v = cell.t == "d" ? $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v)) : cell.v;
            if (v == (v | 0) && v >= 0 && v < 65536) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0002, $3ee4f50b1ae43a89$var$write_BIFF2INT(R, C, v));
            else $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0003, $3ee4f50b1ae43a89$var$write_BIFF2NUM(R, C, v));
            return;
        case "b":
        case "e":
            $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0005, $3ee4f50b1ae43a89$var$write_BIFF2BERR(R, C, cell.v, cell.t));
            return;
        /* TODO: codepage, sst */ case "s":
        case "str":
            $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0004, $3ee4f50b1ae43a89$var$write_BIFF2LABEL(R, C, (cell.v || "").slice(0, 255)));
            return;
    }
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0001, $3ee4f50b1ae43a89$var$write_BIFF2Cell(null, R, C));
}
function $3ee4f50b1ae43a89$var$write_ws_biff2(ba /*:BufArray*/ , ws /*:Worksheet*/ , idx /*:number*/ , opts /*::, wb:Workbook*/ ) {
    var dense = Array.isArray(ws);
    var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"] || "A1"), ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    if (range.e.c > 0xFF || range.e.r > 0x3FFF) {
        if (opts.WTF) throw new Error("Range " + (ws["!ref"] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.c, 0x3FFF);
        ref = $3ee4f50b1ae43a89$var$encode_range(range);
    }
    for(var R = range.s.r; R <= range.e.r; ++R){
        rr = $3ee4f50b1ae43a89$var$encode_row(R);
        for(var C = range.s.c; C <= range.e.c; ++C){
            if (R === range.s.r) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
            ref = cols[C] + rr;
            var cell = dense ? (ws[R] || [])[C] : ws[ref];
            if (!cell) continue;
            /* write cell */ $3ee4f50b1ae43a89$var$write_ws_biff2_cell(ba, cell, R, C, opts);
        }
    }
}
/* Based on test files */ function $3ee4f50b1ae43a89$var$write_biff2_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    if ($3ee4f50b1ae43a89$var$DENSE != null && o.dense == null) o.dense = $3ee4f50b1ae43a89$var$DENSE;
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    var idx = 0;
    for(var i = 0; i < wb.SheetNames.length; ++i)if (wb.SheetNames[i] == o.sheet) idx = i;
    if (idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, o.biff == 4 ? 0x0409 : o.biff == 3 ? 0x0209 : 0x0009, $3ee4f50b1ae43a89$var$write_BOF(wb, 0x10, o));
    /* ... */ $3ee4f50b1ae43a89$var$write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
    /* ... */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x000A);
    return ba.end();
}
function $3ee4f50b1ae43a89$var$write_FONTS_biff8(ba, data, opts) {
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0031 /* Font */ , $3ee4f50b1ae43a89$var$write_Font({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Arial",
        family: 2,
        scheme: "minor"
    }, opts));
}
function $3ee4f50b1ae43a89$var$write_FMTS_biff8(ba, NF /*:?SSFTable*/ , opts) {
    if (!NF) return;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x041E /* Format */ , $3ee4f50b1ae43a89$var$write_Format(i, NF[i], opts));
    });
}
function $3ee4f50b1ae43a89$var$write_FEAT(ba, ws) {
    /* [MS-XLS] 2.4.112 */ var o = $3ee4f50b1ae43a89$var$new_buf(19);
    o.write_shift(4, 0x867);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 1);
    o.write_shift(4, 0);
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0867 /* FeatHdr */ , o);
    /* [MS-XLS] 2.4.111 */ o = $3ee4f50b1ae43a89$var$new_buf(39);
    o.write_shift(4, 0x868);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 1);
    o.write_shift(4, 4);
    o.write_shift(2, 0);
    $3ee4f50b1ae43a89$var$write_Ref8U($3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"] || "A1"), o);
    o.write_shift(4, 4);
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0868 /* Feat */ , o);
}
function $3ee4f50b1ae43a89$var$write_CELLXFS_biff8(ba, opts) {
    for(var i = 0; i < 16; ++i)$3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00e0 /* XF */ , $3ee4f50b1ae43a89$var$write_XF({
        numFmtId: 0,
        style: true
    }, 0, opts));
    opts.cellXfs.forEach(function(c) {
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00e0 /* XF */ , $3ee4f50b1ae43a89$var$write_XF(c, 0, opts));
    });
}
function $3ee4f50b1ae43a89$var$write_ws_biff8_hlinks(ba /*:BufArray*/ , ws) {
    for(var R = 0; R < ws["!links"].length; ++R){
        var HL = ws["!links"][R];
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x01b8 /* HLink */ , $3ee4f50b1ae43a89$var$write_HLink(HL));
        if (HL[1].Tooltip) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0800 /* HLinkTooltip */ , $3ee4f50b1ae43a89$var$write_HLinkTooltip(HL));
    }
    delete ws["!links"];
}
function $3ee4f50b1ae43a89$var$write_ws_cols_biff8(ba, cols) {
    if (!cols) return;
    var cnt = 0;
    cols.forEach(function(col, idx) {
        if (++cnt <= 256 && col) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x007d /* ColInfo */ , $3ee4f50b1ae43a89$var$write_ColInfo($3ee4f50b1ae43a89$var$col_obj_w(idx, col), idx));
    });
}
function $3ee4f50b1ae43a89$var$write_ws_biff8_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts) {
    var os = 16 + $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.v == null && !cell.bf) {
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0201 /* Blank */ , $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os));
        return;
    }
    if (cell.bf) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0006 /* Formula */ , $3ee4f50b1ae43a89$var$write_Formula(cell, R, C, opts, os));
    else switch(cell.t){
        case "d":
        case "n":
            var v = cell.t == "d" ? $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v)) : cell.v;
            /* TODO: emit RK as appropriate */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0203 /* Number */ , $3ee4f50b1ae43a89$var$write_Number(R, C, v, os, opts));
            break;
        case "b":
        case "e":
            $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $3ee4f50b1ae43a89$var$write_BoolErr(R, C, cell.v, os, opts, cell.t));
            break;
        /* TODO: codepage, sst */ case "s":
        case "str":
            if (opts.bookSST) {
                var isst = $3ee4f50b1ae43a89$var$get_sst_id(opts.Strings, cell.v, opts.revStrings);
                $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00fd /* LabelSst */ , $3ee4f50b1ae43a89$var$write_LabelSst(R, C, isst, os, opts));
            } else $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0204 /* Label */ , $3ee4f50b1ae43a89$var$write_Label(R, C, (cell.v || "").slice(0, 255), os, opts));
            break;
        default:
            $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0201 /* Blank */ , $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os));
    }
}
/* [MS-XLS] 2.1.7.20.5 */ function $3ee4f50b1ae43a89$var$write_ws_biff8(idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheet /*:WBWSProp*/  = (_WB.Sheets || [])[idx] || {} /*:any*/ ;
    var dense = Array.isArray(ws);
    var b8 = opts.biff == 8;
    var ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"] || "A1");
    var MAX_ROWS = b8 ? 65536 : 16384;
    if (range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
        if (opts.WTF) throw new Error("Range " + (ws["!ref"] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.c, MAX_ROWS - 1);
    }
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0809, $3ee4f50b1ae43a89$var$write_BOF(wb, 0x10, opts));
    /* [Uncalced] Index */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x000d /* CalcMode */ , $3ee4f50b1ae43a89$var$writeuint16(1));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x000c /* CalcCount */ , $3ee4f50b1ae43a89$var$writeuint16(100));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x000f /* CalcRefMode */ , $3ee4f50b1ae43a89$var$writebool(true));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0011 /* CalcIter */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0010 /* CalcDelta */ , $3ee4f50b1ae43a89$var$write_Xnum(0.001));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x005f /* CalcSaveRecalc */ , $3ee4f50b1ae43a89$var$writebool(true));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x002a /* PrintRowCol */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x002b /* PrintGrid */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0082 /* GridSet */ , $3ee4f50b1ae43a89$var$writeuint16(1));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0080 /* Guts */ , $3ee4f50b1ae43a89$var$write_Guts([
        0,
        0
    ]));
    /* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */ /* Header (string) */ /* Footer (string) */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0083 /* HCenter */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0084 /* VCenter */ , $3ee4f50b1ae43a89$var$writebool(false));
    /* ... */ if (b8) $3ee4f50b1ae43a89$var$write_ws_cols_biff8(ba, ws["!cols"]);
    /* ... */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x200, $3ee4f50b1ae43a89$var$write_Dimensions(range, opts));
    /* ... */ if (b8) ws["!links"] = [];
    for(var R = range.s.r; R <= range.e.r; ++R){
        rr = $3ee4f50b1ae43a89$var$encode_row(R);
        for(var C = range.s.c; C <= range.e.c; ++C){
            if (R === range.s.r) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
            ref = cols[C] + rr;
            var cell = dense ? (ws[R] || [])[C] : ws[ref];
            if (!cell) continue;
            /* write cell */ $3ee4f50b1ae43a89$var$write_ws_biff8_cell(ba, cell, R, C, opts);
            if (b8 && cell.l) ws["!links"].push([
                ref,
                cell.l
            ]);
        }
    }
    var cname /*:string*/  = _sheet.CodeName || _sheet.name || s;
    /* ... */ if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x023e /* Window2 */ , $3ee4f50b1ae43a89$var$write_Window2((_WB.Views || [])[0]));
    /* ... */ if (b8 && (ws["!merges"] || []).length) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00e5 /* MergeCells */ , $3ee4f50b1ae43a89$var$write_MergeCells(ws["!merges"]));
    /* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */ if (b8) $3ee4f50b1ae43a89$var$write_ws_biff8_hlinks(ba, ws);
    /* [DVAL] */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x01ba /* CodeName */ , $3ee4f50b1ae43a89$var$write_XLUnicodeString(cname, opts));
    /* *WebPub *CellWatch [SheetExt] */ if (b8) $3ee4f50b1ae43a89$var$write_FEAT(ba, ws);
    /* *FEAT11 *RECORD12 */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x000a /* EOF */ );
    return ba.end();
}
/* [MS-XLS] 2.1.7.20.3 */ function $3ee4f50b1ae43a89$var$write_biff8_global(wb /*:Workbook*/ , bufs, opts /*:WriteOpts*/ ) {
    var A = $3ee4f50b1ae43a89$var$buf_array();
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheets /*:Array<WBWSProp>*/  = _WB.Sheets || [];
    var _wb /*:WBProps*/  = /*::((*/ _WB.WBProps || {} /*:: ):any)*/ ;
    var b8 = opts.biff == 8, b5 = opts.biff == 5;
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0809, $3ee4f50b1ae43a89$var$write_BOF(wb, 0x05, opts));
    if (opts.bookType == "xla") $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0087 /* Addin */ );
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00e1 /* InterfaceHdr */ , b8 ? $3ee4f50b1ae43a89$var$writeuint16(0x04b0) : null);
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00c1 /* Mms */ , $3ee4f50b1ae43a89$var$writezeroes(2));
    if (b5) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00bf /* ToolbarHdr */ );
    if (b5) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00c0 /* ToolbarEnd */ );
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00e2 /* InterfaceEnd */ );
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x005c /* WriteAccess */ , $3ee4f50b1ae43a89$var$write_WriteAccess("SheetJS", opts));
    /* [FileSharing] */ $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0042 /* CodePage */ , $3ee4f50b1ae43a89$var$writeuint16(b8 ? 0x04b0 : 0x04E4));
    /* *2047 Lel */ if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0161 /* DSF */ , $3ee4f50b1ae43a89$var$writeuint16(0));
    if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x01c0 /* Excel9File */ );
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x013d /* RRTabId */ , $3ee4f50b1ae43a89$var$write_RRTabId(wb.SheetNames.length));
    if (b8 && wb.vbaraw) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00d3 /* ObProj */ );
    /* [ObNoMacros] */ if (b8 && wb.vbaraw) {
        var cname /*:string*/  = _wb.CodeName || "ThisWorkbook";
        $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x01ba /* CodeName */ , $3ee4f50b1ae43a89$var$write_XLUnicodeString(cname, opts));
    }
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */ , $3ee4f50b1ae43a89$var$writeuint16(0x11));
    /* *FnGroupName *FnGrp12 */ /* *Lbl */ /* [OleObjectSize] */ $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0019 /* WinProtect */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0012 /* Protect */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0013 /* Password */ , $3ee4f50b1ae43a89$var$writeuint16(0));
    if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x01af /* Prot4Rev */ , $3ee4f50b1ae43a89$var$writebool(false));
    if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x01bc /* Prot4RevPass */ , $3ee4f50b1ae43a89$var$writeuint16(0));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x003d /* Window1 */ , $3ee4f50b1ae43a89$var$write_Window1(opts));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0040 /* Backup */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x008d /* HideObj */ , $3ee4f50b1ae43a89$var$writeuint16(0));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0022 /* Date1904 */ , $3ee4f50b1ae43a89$var$writebool($3ee4f50b1ae43a89$var$safe1904(wb) == "true"));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x000e /* CalcPrecision */ , $3ee4f50b1ae43a89$var$writebool(true));
    if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x01b7 /* RefreshAll */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00DA /* BookBool */ , $3ee4f50b1ae43a89$var$writeuint16(0));
    /* ... */ $3ee4f50b1ae43a89$var$write_FONTS_biff8(A, wb, opts);
    $3ee4f50b1ae43a89$var$write_FMTS_biff8(A, wb.SSF, opts);
    $3ee4f50b1ae43a89$var$write_CELLXFS_biff8(A, opts);
    /* ... */ if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0160 /* UsesELFs */ , $3ee4f50b1ae43a89$var$writebool(false));
    var a = A.end();
    var C = $3ee4f50b1ae43a89$var$buf_array();
    /* METADATA [MTRSettings] [ForceFullCalculation] */ if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(C, 0x008C, $3ee4f50b1ae43a89$var$write_Country());
    /* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */ /* BIFF8: [SST *Continue] ExtSST */ if (b8 && opts.Strings) $3ee4f50b1ae43a89$var$write_biff_continue(C, 0x00FC, $3ee4f50b1ae43a89$var$write_SST(opts.Strings, opts));
    /* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */ $3ee4f50b1ae43a89$var$write_biff_rec(C, 0x000A /* EOF */ );
    var c = C.end();
    var B = $3ee4f50b1ae43a89$var$buf_array();
    var blen = 0, j = 0;
    for(j = 0; j < wb.SheetNames.length; ++j)blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
    var start = a.length + blen + c.length;
    for(j = 0; j < wb.SheetNames.length; ++j){
        var _sheet /*:WBWSProp*/  = _sheets[j] || {} /*:any*/ ;
        $3ee4f50b1ae43a89$var$write_biff_rec(B, 0x0085 /* BoundSheet8 */ , $3ee4f50b1ae43a89$var$write_BoundSheet8({
            pos: start,
            hs: _sheet.Hidden || 0,
            dt: 0,
            name: wb.SheetNames[j]
        }, opts));
        start += bufs[j].length;
    }
    /* 1*BoundSheet8 */ var b = B.end();
    if (blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
    var out = [];
    if (a.length) out.push(a);
    if (b.length) out.push(b);
    if (c.length) out.push(c);
    return $3ee4f50b1ae43a89$var$bconcat(out);
}
/* [MS-XLS] 2.1.7.20 Workbook Stream */ function $3ee4f50b1ae43a89$var$write_biff8_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var bufs = [];
    if (wb && !wb.SSF) wb.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    if (wb && wb.SSF) {
        $3ee4f50b1ae43a89$var$make_ssf();
        $3ee4f50b1ae43a89$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        o.revssf = $3ee4f50b1ae43a89$var$evert_num(wb.SSF);
        o.revssf[wb.SSF[65535]] = 0;
        o.ssf = wb.SSF;
    }
    o.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    o.Strings.Count = 0;
    o.Strings.Unique = 0;
    $3ee4f50b1ae43a89$var$fix_write_opts(o);
    o.cellXfs = [];
    $3ee4f50b1ae43a89$var$get_cell_style(o.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    for(var i = 0; i < wb.SheetNames.length; ++i)bufs[bufs.length] = $3ee4f50b1ae43a89$var$write_ws_biff8(i, o, wb);
    bufs.unshift($3ee4f50b1ae43a89$var$write_biff8_global(wb, bufs, o));
    return $3ee4f50b1ae43a89$var$bconcat(bufs);
}
function $3ee4f50b1ae43a89$var$write_biff_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    for(var i = 0; i <= wb.SheetNames.length; ++i){
        var ws = wb.Sheets[wb.SheetNames[i]];
        if (!ws || !ws["!ref"]) continue;
        var range = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
        if (range.e.c > 255) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
        }
    }
    var o = opts || {};
    switch(o.biff || 2){
        case 8:
        case 5:
            return $3ee4f50b1ae43a89$var$write_biff8_buf(wb, opts);
        case 4:
        case 3:
        case 2:
            return $3ee4f50b1ae43a89$var$write_biff2_buf(wb, opts);
    }
    throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */ function $3ee4f50b1ae43a89$var$html_to_sheet(str /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    if ($3ee4f50b1ae43a89$var$DENSE != null && opts.dense == null) opts.dense = $3ee4f50b1ae43a89$var$DENSE;
    var ws /*:Worksheet*/  = opts.dense ? [] : {} /*:any*/ ;
    str = str.replace(/<!--.*?-->/g, "");
    var mtch /*:any*/  = str.match(/<table/i);
    if (!mtch) throw new Error("Invalid HTML: could not find <table>");
    var mtch2 /*:any*/  = str.match(/<\/table/i);
    var i /*:number*/  = mtch.index, j /*:number*/  = mtch2 && mtch2.index || str.length;
    var rows = $3ee4f50b1ae43a89$var$split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
    var R = -1, C = 0, RS = 0, CS = 0;
    var range /*:Range*/  = {
        s: {
            r: 10000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var merges /*:Array<Range>*/  = [];
    for(i = 0; i < rows.length; ++i){
        var row = rows[i].trim();
        var hd = row.slice(0, 3).toLowerCase();
        if (hd == "<tr") {
            ++R;
            if (opts.sheetRows && opts.sheetRows <= R) {
                --R;
                break;
            }
            C = 0;
            continue;
        }
        if (hd != "<td" && hd != "<th") continue;
        var cells = row.split(/<\/t[dh]>/i);
        for(j = 0; j < cells.length; ++j){
            var cell = cells[j].trim();
            if (!cell.match(/<t[dh]/i)) continue;
            var m = cell, cc = 0;
            /* TODO: parse styles etc */ while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1)m = m.slice(cc + 1);
            for(var midx = 0; midx < merges.length; ++midx){
                var _merge /*:Range*/  = merges[midx];
                if (_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) {
                    C = _merge.e.c + 1;
                    midx = -1;
                }
            }
            var tag = $3ee4f50b1ae43a89$var$parsexmltag(cell.slice(0, cell.indexOf(">")));
            CS = tag.colspan ? +tag.colspan : 1;
            if ((RS = +tag.rowspan) > 1 || CS > 1) merges.push({
                s: {
                    r: R,
                    c: C
                },
                e: {
                    r: R + (RS || 1) - 1,
                    c: C + CS - 1
                }
            });
            var _t /*:string*/  = tag.t || tag["data-t"] || "";
            /* TODO: generate stub cells */ if (!m.length) {
                C += CS;
                continue;
            }
            m = $3ee4f50b1ae43a89$var$htmldecode(m);
            if (range.s.r > R) range.s.r = R;
            if (range.e.r < R) range.e.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.c < C) range.e.c = C;
            if (!m.length) {
                C += CS;
                continue;
            }
            var o /*:Cell*/  = {
                t: "s",
                v: m
            };
            if (opts.raw || !m.trim().length || _t == "s") ;
            else if (m === "TRUE") o = {
                t: "b",
                v: true
            };
            else if (m === "FALSE") o = {
                t: "b",
                v: false
            };
            else if (!isNaN($3ee4f50b1ae43a89$var$fuzzynum(m))) o = {
                t: "n",
                v: $3ee4f50b1ae43a89$var$fuzzynum(m)
            };
            else if (!isNaN($3ee4f50b1ae43a89$var$fuzzydate(m).getDate())) {
                o = {
                    t: "d",
                    v: $3ee4f50b1ae43a89$var$parseDate(m)
                } /*:any*/ ;
                if (!opts.cellDates) o = {
                    t: "n",
                    v: $3ee4f50b1ae43a89$var$datenum(o.v)
                } /*:any*/ ;
                o.z = opts.dateNF || $3ee4f50b1ae43a89$var$table_fmt[14];
            }
            if (opts.dense) {
                if (!ws[R]) ws[R] = [];
                ws[R][C] = o;
            } else ws[$3ee4f50b1ae43a89$var$encode_cell({
                r: R,
                c: C
            })] = o;
            C += CS;
        }
    }
    ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
    if (merges.length) ws["!merges"] = merges;
    return ws;
}
function $3ee4f50b1ae43a89$var$make_html_row(ws /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var M /*:Array<Range>*/  = ws["!merges"] || [];
    var oo /*:Array<string>*/  = [];
    for(var C = r.s.c; C <= r.e.c; ++C){
        var RS = 0, CS = 0;
        for(var j = 0; j < M.length; ++j){
            if (M[j].s.r > R || M[j].s.c > C) continue;
            if (M[j].e.r < R || M[j].e.c < C) continue;
            if (M[j].s.r < R || M[j].s.c < C) {
                RS = -1;
                break;
            }
            RS = M[j].e.r - M[j].s.r + 1;
            CS = M[j].e.c - M[j].s.c + 1;
            break;
        }
        if (RS < 0) continue;
        var coord = $3ee4f50b1ae43a89$var$encode_cell({
            r: R,
            c: C
        });
        var cell = o.dense ? (ws[R] || [])[C] : ws[coord];
        /* TODO: html entities */ var w = cell && cell.v != null && (cell.h || $3ee4f50b1ae43a89$var$escapehtml(cell.w || ($3ee4f50b1ae43a89$var$format_cell(cell), cell.w) || "")) || "";
        var sp = {} /*:any*/ ;
        if (RS > 1) sp.rowspan = RS;
        if (CS > 1) sp.colspan = CS;
        if (o.editable) w = '<span contenteditable="true">' + w + "</span>";
        else if (cell) {
            sp["data-t"] = cell && cell.t || "z";
            if (cell.v != null) sp["data-v"] = cell.v;
            if (cell.z != null) sp["data-z"] = cell.z;
            if (cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + cell.l.Target + '">' + w + "</a>";
        }
        sp.id = (o.id || "sjs") + "-" + coord;
        oo.push($3ee4f50b1ae43a89$var$writextag("td", w, sp));
    }
    var preamble = "<tr>";
    return preamble + oo.join("") + "</tr>";
}
var $3ee4f50b1ae43a89$var$HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
var $3ee4f50b1ae43a89$var$HTML_END = "</body></html>";
function $3ee4f50b1ae43a89$var$html_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
    var mtch = str.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
    if (!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
    if (mtch.length == 1) return $3ee4f50b1ae43a89$var$sheet_to_workbook($3ee4f50b1ae43a89$var$html_to_sheet(mtch[0], opts), opts);
    var wb = $3ee4f50b1ae43a89$var$book_new();
    mtch.forEach(function(s, idx) {
        $3ee4f50b1ae43a89$var$book_append_sheet(wb, $3ee4f50b1ae43a89$var$html_to_sheet(s, opts), "Sheet" + (idx + 1));
    });
    return wb;
}
function $3ee4f50b1ae43a89$var$make_html_preamble(ws /*:Worksheet*/ , R /*:Range*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    return out.join("") + "<table" + (o && o.id ? ' id="' + o.id + '"' : "") + ">";
}
function $3ee4f50b1ae43a89$var$sheet_to_html(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/  /*, wb:?Workbook*/ ) /*:string*/ {
    var o = opts || {};
    var header = o.header != null ? o.header : $3ee4f50b1ae43a89$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $3ee4f50b1ae43a89$var$HTML_END;
    var out /*:Array<string>*/  = [
        header
    ];
    var r = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
    o.dense = Array.isArray(ws);
    out.push($3ee4f50b1ae43a89$var$make_html_preamble(ws, r, o));
    for(var R = r.s.r; R <= r.e.r; ++R)out.push($3ee4f50b1ae43a89$var$make_html_row(ws, r, R, o));
    out.push("</table>" + footer);
    return out.join("");
}
function $3ee4f50b1ae43a89$var$sheet_add_dom(ws /*:Worksheet*/ , table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    if ($3ee4f50b1ae43a89$var$DENSE != null) opts.dense = $3ee4f50b1ae43a89$var$DENSE;
    var or_R = 0, or_C = 0;
    if (opts.origin != null) {
        if (typeof opts.origin == "number") or_R = opts.origin;
        else {
            var _origin /*:CellAddress*/  = typeof opts.origin == "string" ? $3ee4f50b1ae43a89$var$decode_cell(opts.origin) : opts.origin;
            or_R = _origin.r;
            or_C = _origin.c;
        }
    }
    var rows /*:HTMLCollection<HTMLTableRowElement>*/  = table.getElementsByTagName("tr");
    var sheetRows = Math.min(opts.sheetRows || 10000000, rows.length);
    var range /*:Range*/  = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: or_R,
            c: or_C
        }
    };
    if (ws["!ref"]) {
        var _range /*:Range*/  = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
        range.s.r = Math.min(range.s.r, _range.s.r);
        range.s.c = Math.min(range.s.c, _range.s.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        range.e.c = Math.max(range.e.c, _range.e.c);
        if (or_R == -1) range.e.r = or_R = _range.e.r + 1;
    }
    var merges /*:Array<Range>*/  = [], midx = 0;
    var rowinfo /*:Array<RowInfo>*/  = ws["!rows"] || (ws["!rows"] = []);
    var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
    if (!ws["!cols"]) ws["!cols"] = [];
    for(; _R < rows.length && R < sheetRows; ++_R){
        var row /*:HTMLTableRowElement*/  = rows[_R];
        if ($3ee4f50b1ae43a89$var$is_dom_element_hidden(row)) {
            if (opts.display) continue;
            rowinfo[R] = {
                hidden: true
            };
        }
        var elts /*:HTMLCollection<HTMLTableCellElement>*/  = row.children /*:any*/ ;
        for(_C = C = 0; _C < elts.length; ++_C){
            var elt /*:HTMLTableCellElement*/  = elts[_C];
            if (opts.display && $3ee4f50b1ae43a89$var$is_dom_element_hidden(elt)) continue;
            var v /*:?string*/  = elt.hasAttribute("data-v") ? elt.getAttribute("data-v") : elt.hasAttribute("v") ? elt.getAttribute("v") : $3ee4f50b1ae43a89$var$htmldecode(elt.innerHTML);
            var z /*:?string*/  = elt.getAttribute("data-z") || elt.getAttribute("z");
            for(midx = 0; midx < merges.length; ++midx){
                var m /*:Range*/  = merges[midx];
                if (m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) {
                    C = m.e.c + 1 - or_C;
                    midx = -1;
                }
            }
            /* TODO: figure out how to extract nonstandard mso- style */ CS = +elt.getAttribute("colspan") || 1;
            if ((RS = +elt.getAttribute("rowspan") || 1) > 1 || CS > 1) merges.push({
                s: {
                    r: R + or_R,
                    c: C + or_C
                },
                e: {
                    r: R + or_R + (RS || 1) - 1,
                    c: C + or_C + (CS || 1) - 1
                }
            });
            var o /*:Cell*/  = {
                t: "s",
                v: v
            };
            var _t /*:string*/  = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
            if (v != null) {
                if (v.length == 0) o.t = _t || "z";
                else if (opts.raw || v.trim().length == 0 || _t == "s") ;
                else if (v === "TRUE") o = {
                    t: "b",
                    v: true
                };
                else if (v === "FALSE") o = {
                    t: "b",
                    v: false
                };
                else if (!isNaN($3ee4f50b1ae43a89$var$fuzzynum(v))) o = {
                    t: "n",
                    v: $3ee4f50b1ae43a89$var$fuzzynum(v)
                };
                else if (!isNaN($3ee4f50b1ae43a89$var$fuzzydate(v).getDate())) {
                    o = {
                        t: "d",
                        v: $3ee4f50b1ae43a89$var$parseDate(v)
                    } /*:any*/ ;
                    if (!opts.cellDates) o = {
                        t: "n",
                        v: $3ee4f50b1ae43a89$var$datenum(o.v)
                    } /*:any*/ ;
                    o.z = opts.dateNF || $3ee4f50b1ae43a89$var$table_fmt[14];
                }
            }
            if (o.z === undefined && z != null) o.z = z;
            /* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */ var l = "", Aelts = elt.getElementsByTagName("A");
            if (Aelts && Aelts.length) {
                for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)if (Aelts[Aelti].hasAttribute("href")) {
                    l = Aelts[Aelti].getAttribute("href");
                    if (l.charAt(0) != "#") break;
                }
            }
            if (l && l.charAt(0) != "#") o.l = {
                Target: l
            };
            if (opts.dense) {
                if (!ws[R + or_R]) ws[R + or_R] = [];
                ws[R + or_R][C + or_C] = o;
            } else ws[$3ee4f50b1ae43a89$var$encode_cell({
                c: C + or_C,
                r: R + or_R
            })] = o;
            if (range.e.c < C + or_C) range.e.c = C + or_C;
            C += CS;
        }
        ++R;
    }
    if (merges.length) ws["!merges"] = (ws["!merges"] || []).concat(merges);
    range.e.r = Math.max(range.e.r, R - 1 + or_R);
    ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
    if (R >= sheetRows) ws["!fullref"] = $3ee4f50b1ae43a89$var$encode_range((range.e.r = rows.length - _R + R - 1 + or_R, range)); // We can count the real number of rows to parse but we don't to improve the performance
    return ws;
}
function $3ee4f50b1ae43a89$var$parse_dom_table(table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    var ws /*:Worksheet*/  = opts.dense ? [] : {} /*:any*/ ;
    return $3ee4f50b1ae43a89$var$sheet_add_dom(ws, table, _opts);
}
function $3ee4f50b1ae43a89$var$table_to_book(table /*:HTMLElement*/ , opts /*:?any*/ ) /*:Workbook*/ {
    return $3ee4f50b1ae43a89$var$sheet_to_workbook($3ee4f50b1ae43a89$var$parse_dom_table(table, opts), opts);
}
function $3ee4f50b1ae43a89$var$is_dom_element_hidden(element /*:HTMLElement*/ ) /*:boolean*/ {
    var display /*:string*/  = "";
    var get_computed_style /*:?function*/  = $3ee4f50b1ae43a89$var$get_get_computed_style_function(element);
    if (get_computed_style) display = get_computed_style(element).getPropertyValue("display");
    if (!display) display = element.style && element.style.display;
    return display === "none";
}
/* global getComputedStyle */ function $3ee4f50b1ae43a89$var$get_get_computed_style_function(element /*:HTMLElement*/ ) /*:?function*/ {
    // The proper getComputedStyle implementation is the one defined in the element window
    if (element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === "function") return element.ownerDocument.defaultView.getComputedStyle;
    // If it is not available, try to get one from the global namespace
    if (typeof getComputedStyle === "function") return getComputedStyle;
    return null;
}
/* OpenDocument */ function $3ee4f50b1ae43a89$var$parse_text_p(text /*:string*/  /*::, tag*/ ) /*:Array<any>*/ {
    /* 6.1.2 White Space Characters */ var fixed = text.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function($$, $1) {
        return Array(parseInt($1, 10) + 1).join(" ");
    }).replace(/<text:tab[^>]*\/>/g, "	").replace(/<text:line-break\/>/g, "\n");
    var v = $3ee4f50b1ae43a89$var$unescapexml(fixed.replace(/<[^>]*>/g, ""));
    return [
        v
    ];
}
var $3ee4f50b1ae43a89$var$number_formats_ods = {
    /* ods name: [short ssf fmt, long ssf fmt] */ day: [
        "d",
        "dd"
    ],
    month: [
        "m",
        "mm"
    ],
    year: [
        "y",
        "yy"
    ],
    hours: [
        "h",
        "hh"
    ],
    minutes: [
        "m",
        "mm"
    ],
    seconds: [
        "s",
        "ss"
    ],
    "am-pm": [
        "A/P",
        "AM/PM"
    ],
    "day-of-week": [
        "ddd",
        "dddd"
    ],
    era: [
        "e",
        "ee"
    ],
    /* there is no native representation of LO "Q" format */ quarter: [
        "\\Qm",
        'm\\"th quarter"'
    ]
};
function $3ee4f50b1ae43a89$var$parse_content_xml(d /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    if ($3ee4f50b1ae43a89$var$DENSE != null && opts.dense == null) opts.dense = $3ee4f50b1ae43a89$var$DENSE;
    var str = $3ee4f50b1ae43a89$var$xlml_normalize(d);
    var state /*:Array<any>*/  = [], tmp;
    var tag /*:: = {}*/ ;
    var NFtag = {
        name: ""
    }, NF = "", pidx = 0;
    var sheetag /*:: = {name:"", '名称':""}*/ ;
    var rowtag /*:: = {'行号':""}*/ ;
    var Sheets = {}, SheetNames /*:Array<string>*/  = [];
    var ws = opts.dense ? [] : {} /*:any*/ ;
    var Rn, q /*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/ ;
    var ctag = {
        value: ""
    } /*:any*/ ;
    var textp = "", textpidx = 0, textptag /*:: = {}*/ ;
    var textR = [];
    var R = -1, C = -1, range = {
        s: {
            r: 1000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var row_ol = 0;
    var number_format_map = {};
    var merges /*:Array<Range>*/  = [], mrange = {}, mR = 0, mC = 0;
    var rowinfo /*:Array<RowInfo>*/  = [], rowpeat = 1, colpeat = 1;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var WB = {
        Names: []
    };
    var atag = {} /*:any*/ ;
    var _Ref /*:[string, string]*/  = [
        "",
        ""
    ];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var creator = "", creatoridx = 0;
    var isstub = false, intable = false;
    var i = 0;
    $3ee4f50b1ae43a89$var$xlmlregex.lastIndex = 0;
    str = str.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
    while(Rn = $3ee4f50b1ae43a89$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_.*$/, "")){
        case "table":
        case "\u5DE5\u4F5C\u8868":
            if (Rn[1] === "/") {
                if (range.e.c >= range.s.c && range.e.r >= range.s.r) ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
                else ws["!ref"] = "A1:A1";
                if (opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
                    ws["!fullref"] = ws["!ref"];
                    range.e.r = opts.sheetRows - 1;
                    ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
                }
                if (merges.length) ws["!merges"] = merges;
                if (rowinfo.length) ws["!rows"] = rowinfo;
                sheetag.name = sheetag["\u540D\u79F0"] || sheetag.name;
                if (typeof JSON !== "undefined") JSON.stringify(sheetag);
                SheetNames.push(sheetag.name);
                Sheets[sheetag.name] = ws;
                intable = false;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                sheetag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                R = C = -1;
                range.s.r = range.s.c = 10000000;
                range.e.r = range.e.c = 0;
                ws = opts.dense ? [] : {} /*:any*/ ;
                merges = [];
                rowinfo = [];
                intable = true;
            }
            break;
        case "table-row-group":
            if (Rn[1] === "/") --row_ol;
            else ++row_ol;
            break;
        case "table-row":
        case "\u884C":
            if (Rn[1] === "/") {
                R += rowpeat;
                rowpeat = 1;
                break;
            }
            rowtag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            if (rowtag["\u884C\u53F7"]) R = rowtag["\u884C\u53F7"] - 1;
            else if (R == -1) R = 0;
            rowpeat = +rowtag["number-rows-repeated"] || 1;
            /* TODO: remove magic */ if (rowpeat < 10) {
                for(i = 0; i < rowpeat; ++i)if (row_ol > 0) rowinfo[R + i] = {
                    level: row_ol
                };
            }
            C = -1;
            break;
        case "covered-table-cell":
            if (Rn[1] !== "/") ++C;
            if (opts.sheetStubs) {
                if (opts.dense) {
                    if (!ws[R]) ws[R] = [];
                    ws[R][C] = {
                        t: "z"
                    };
                } else ws[$3ee4f50b1ae43a89$var$encode_cell({
                    r: R,
                    c: C
                })] = {
                    t: "z"
                };
            }
            textp = "";
            textR = [];
            break; /* stub */ 
        case "table-cell":
        case "\u6570\u636E":
            if (Rn[0].charAt(Rn[0].length - 2) === "/") {
                ++C;
                ctag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag["number-columns-repeated"] || "1", 10);
                q = {
                    t: "z",
                    v: null
                } /*:any*/ ;
                if (ctag.formula && opts.cellFormula != false) q.f = $3ee4f50b1ae43a89$var$ods_to_csf_formula($3ee4f50b1ae43a89$var$unescapexml(ctag.formula));
                if ((ctag["\u6570\u636E\u7C7B\u578B"] || ctag["value-type"]) == "string") {
                    q.t = "s";
                    q.v = $3ee4f50b1ae43a89$var$unescapexml(ctag["string-value"] || "");
                    if (opts.dense) {
                        if (!ws[R]) ws[R] = [];
                        ws[R][C] = q;
                    } else ws[$3ee4f50b1ae43a89$var$encode_cell({
                        r: R,
                        c: C
                    })] = q;
                }
                C += colpeat - 1;
            } else if (Rn[1] !== "/") {
                ++C;
                textp = "";
                textpidx = 0;
                textR = [];
                colpeat = 1;
                var rptR = rowpeat ? R + rowpeat - 1 : R;
                if (C > range.e.c) range.e.c = C;
                if (C < range.s.c) range.s.c = C;
                if (R < range.s.r) range.s.r = R;
                if (rptR > range.e.r) range.e.r = rptR;
                ctag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                comments = [];
                comment = {} /*:any*/ ;
                q = {
                    t: ctag["\u6570\u636E\u7C7B\u578B"] || ctag["value-type"],
                    v: null
                } /*:any*/ ;
                if (opts.cellFormula) {
                    if (ctag.formula) ctag.formula = $3ee4f50b1ae43a89$var$unescapexml(ctag.formula);
                    if (ctag["number-matrix-columns-spanned"] && ctag["number-matrix-rows-spanned"]) {
                        mR = parseInt(ctag["number-matrix-rows-spanned"], 10) || 0;
                        mC = parseInt(ctag["number-matrix-columns-spanned"], 10) || 0;
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        q.F = $3ee4f50b1ae43a89$var$encode_range(mrange);
                        arrayf.push([
                            mrange,
                            q.F
                        ]);
                    }
                    if (ctag.formula) q.f = $3ee4f50b1ae43a89$var$ods_to_csf_formula(ctag.formula);
                    else for(i = 0; i < arrayf.length; ++i)if (R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r) {
                        if (C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c) q.F = arrayf[i][1];
                    }
                }
                if (ctag["number-columns-spanned"] || ctag["number-rows-spanned"]) {
                    mR = parseInt(ctag["number-rows-spanned"], 10) || 0;
                    mC = parseInt(ctag["number-columns-spanned"], 10) || 0;
                    mrange = {
                        s: {
                            r: R,
                            c: C
                        },
                        e: {
                            r: R + mR - 1,
                            c: C + mC - 1
                        }
                    };
                    merges.push(mrange);
                }
                /* 19.675.2 table:number-columns-repeated */ if (ctag["number-columns-repeated"]) colpeat = parseInt(ctag["number-columns-repeated"], 10);
                /* 19.385 office:value-type */ switch(q.t){
                    case "boolean":
                        q.t = "b";
                        q.v = $3ee4f50b1ae43a89$var$parsexmlbool(ctag["boolean-value"]);
                        break;
                    case "float":
                        q.t = "n";
                        q.v = parseFloat(ctag.value);
                        break;
                    case "percentage":
                        q.t = "n";
                        q.v = parseFloat(ctag.value);
                        break;
                    case "currency":
                        q.t = "n";
                        q.v = parseFloat(ctag.value);
                        break;
                    case "date":
                        q.t = "d";
                        q.v = $3ee4f50b1ae43a89$var$parseDate(ctag["date-value"]);
                        if (!opts.cellDates) {
                            q.t = "n";
                            q.v = $3ee4f50b1ae43a89$var$datenum(q.v);
                        }
                        q.z = "m/d/yy";
                        break;
                    case "time":
                        q.t = "n";
                        q.v = $3ee4f50b1ae43a89$var$parse_isodur(ctag["time-value"]) / 86400;
                        if (opts.cellDates) {
                            q.t = "d";
                            q.v = $3ee4f50b1ae43a89$var$numdate(q.v);
                        }
                        q.z = "HH:MM:SS";
                        break;
                    case "number":
                        q.t = "n";
                        q.v = parseFloat(ctag["\u6570\u636E\u6570\u503C"]);
                        break;
                    default:
                        if (q.t === "string" || q.t === "text" || !q.t) {
                            q.t = "s";
                            if (ctag["string-value"] != null) {
                                textp = $3ee4f50b1ae43a89$var$unescapexml(ctag["string-value"]);
                                textR = [];
                            }
                        } else throw new Error("Unsupported value type " + q.t);
                }
            } else {
                isstub = false;
                if (q.t === "s") {
                    q.v = textp || "";
                    if (textR.length) q.R = textR;
                    isstub = textpidx == 0;
                }
                if (atag.Target) q.l = atag;
                if (comments.length > 0) {
                    q.c = comments;
                    comments = [];
                }
                if (textp && opts.cellText !== false) q.w = textp;
                if (isstub) {
                    q.t = "z";
                    delete q.v;
                }
                if (!isstub || opts.sheetStubs) {
                    if (!(opts.sheetRows && opts.sheetRows <= R)) for(var rpt = 0; rpt < rowpeat; ++rpt){
                        colpeat = parseInt(ctag["number-columns-repeated"] || "1", 10);
                        if (opts.dense) {
                            if (!ws[R + rpt]) ws[R + rpt] = [];
                            ws[R + rpt][C] = rpt == 0 ? q : $3ee4f50b1ae43a89$var$dup(q);
                            while(--colpeat > 0)ws[R + rpt][C + colpeat] = $3ee4f50b1ae43a89$var$dup(q);
                        } else {
                            ws[$3ee4f50b1ae43a89$var$encode_cell({
                                r: R + rpt,
                                c: C
                            })] = q;
                            while(--colpeat > 0)ws[$3ee4f50b1ae43a89$var$encode_cell({
                                r: R + rpt,
                                c: C + colpeat
                            })] = $3ee4f50b1ae43a89$var$dup(q);
                        }
                        if (range.e.c <= C) range.e.c = C;
                    }
                }
                colpeat = parseInt(ctag["number-columns-repeated"] || "1", 10);
                C += colpeat - 1;
                colpeat = 0;
                q = {};
                textp = "";
                textR = [];
            }
            atag = {} /*:any*/ ;
            break; // 9.1.4 <table:table-cell>
        /* pure state */ case "document":
        case "document-content":
        case "\u7535\u5B50\u8868\u683C\u6587\u6863":
        case "spreadsheet":
        case "\u4E3B\u4F53":
        case "scripts":
        case "styles":
        case "font-face-decls":
        case "master-styles":
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                true
            ]);
            break;
        case "annotation":
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                comment.t = textp;
                if (textR.length) /*::(*/ comment /*:: :any)*/ .R = textR;
                comment.a = creator;
                comments.push(comment);
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                false
            ]);
            creator = "";
            creatoridx = 0;
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case "creator":
            if (Rn[1] === "/") creator = str.slice(creatoridx, Rn.index);
            else creatoridx = Rn.index + Rn[0].length;
            break;
        /* ignore state */ case "meta":
        case "\u5143\u6570\u636E":
        case "settings":
        case "config-item-set":
        case "config-item-map-indexed":
        case "config-item-map-entry":
        case "config-item-map-named":
        case "shapes":
        case "frame":
        case "text-box":
        case "image":
        case "data-pilot-tables":
        case "list-style":
        case "form":
        case "dde-links":
        case "event-listeners":
        case "chart":
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                false
            ]);
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case "scientific-number":
            break;
        case "currency-symbol":
            break;
        case "currency-style":
            break;
        case "number-style":
        case "percentage-style":
        case "date-style":
        case "time-style":
            if (Rn[1] === "/") {
                number_format_map[NFtag.name] = NF;
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                NF = "";
                NFtag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case "script":
            break; // 3.13 <office:script>
        case "libraries":
            break; // TODO: <ooo:libraries>
        case "automatic-styles":
            break; // 3.15.3 <office:automatic-styles>
        case "default-style":
        case "page-layout":
            break; // TODO: <style:page-layout>
        case "style":
            break;
        case "map":
            break; // 16.3 <style:map>
        case "font-face":
            break; // 16.21 <style:font-face>
        case "paragraph-properties":
            break; // 17.6 <style:paragraph-properties>
        case "table-properties":
            break; // 17.15 <style:table-properties>
        case "table-column-properties":
            break; // 17.16 <style:table-column-properties>
        case "table-row-properties":
            break; // 17.17 <style:table-row-properties>
        case "table-cell-properties":
            break; // 17.18 <style:table-cell-properties>
        case "number":
            switch(state[state.length - 1][0]){
                case "time-style":
                case "date-style":
                    tag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                    NF += $3ee4f50b1ae43a89$var$number_formats_ods[Rn[3]][tag.style === "long" ? 1 : 0];
                    break;
            }
            break;
        case "fraction":
            break; // TODO 16.27.6 <number:fraction>
        case "day":
        case "month":
        case "year":
        case "era":
        case "day-of-week":
        case "week-of-year":
        case "quarter":
        case "hours":
        case "minutes":
        case "seconds":
        case "am-pm":
            switch(state[state.length - 1][0]){
                case "time-style":
                case "date-style":
                    tag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                    NF += $3ee4f50b1ae43a89$var$number_formats_ods[Rn[3]][tag.style === "long" ? 1 : 0];
                    break;
            }
            break;
        case "boolean-style":
            break; // 16.27.23 <number:boolean-style>
        case "boolean":
            break; // 16.27.24 <number:boolean>
        case "text-style":
            break; // 16.27.25 <number:text-style>
        case "text":
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") switch(state[state.length - 1][0]){
                case "number-style":
                case "date-style":
                case "time-style":
                    NF += str.slice(pidx, Rn.index);
                    break;
            }
            else pidx = Rn.index + Rn[0].length;
            break;
        case "named-range":
            tag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            _Ref = $3ee4f50b1ae43a89$var$ods_to_csf_3D(tag["cell-range-address"]);
            var nrange = {
                Name: tag.name,
                Ref: _Ref[0] + "!" + _Ref[1]
            } /*:any*/ ;
            if (intable) nrange.Sheet = SheetNames.length;
            WB.Names.push(nrange);
            break;
        case "text-content":
            break; // 16.27.27 <number:text-content>
        case "text-properties":
            break; // 16.27.27 <style:text-properties>
        case "embedded-text":
            break; // 16.27.4 <number:embedded-text>
        case "body":
        case "\u7535\u5B50\u8868\u683C":
            break; // 3.3 16.9.6 19.726.3
        case "forms":
            break; // 12.25.2 13.2
        case "table-column":
            break; // 9.1.6 <table:table-column>
        case "table-header-rows":
            break; // 9.1.7 <table:table-header-rows>
        case "table-rows":
            break; // 9.1.12 <table:table-rows>
        /* TODO: outline levels */ case "table-column-group":
            break; // 9.1.10 <table:table-column-group>
        case "table-header-columns":
            break; // 9.1.11 <table:table-header-columns>
        case "table-columns":
            break; // 9.1.12 <table:table-columns>
        case "null-date":
            break; // 9.4.2 <table:null-date> TODO: date1904
        case "graphic-properties":
            break; // 17.21 <style:graphic-properties>
        case "calculation-settings":
            break; // 9.4.1 <table:calculation-settings>
        case "named-expressions":
            break; // 9.4.11 <table:named-expressions>
        case "label-range":
            break; // 9.4.9 <table:label-range>
        case "label-ranges":
            break; // 9.4.10 <table:label-ranges>
        case "named-expression":
            break; // 9.4.13 <table:named-expression>
        case "sort":
            break; // 9.4.19 <table:sort>
        case "sort-by":
            break; // 9.4.20 <table:sort-by>
        case "sort-groups":
            break; // 9.4.22 <table:sort-groups>
        case "tab":
            break; // 6.1.4 <text:tab>
        case "line-break":
            break; // 6.1.5 <text:line-break>
        case "span":
            break; // 6.1.7 <text:span>
        case "p":
        case "\u6587\u672C\u4E32":
            if ([
                "master-styles"
            ].indexOf(state[state.length - 1][0]) > -1) break;
            if (Rn[1] === "/" && (!ctag || !ctag["string-value"])) {
                var ptp = $3ee4f50b1ae43a89$var$parse_text_p(str.slice(textpidx, Rn.index), textptag);
                textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
            } else {
                textptag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                textpidx = Rn.index + Rn[0].length;
            }
            break; // <text:p>
        case "s":
            break; // <text:s>
        case "database-range":
            if (Rn[1] === "/") break;
            try {
                _Ref = $3ee4f50b1ae43a89$var$ods_to_csf_3D($3ee4f50b1ae43a89$var$parsexmltag(Rn[0])["target-range-address"]);
                Sheets[_Ref[0]]["!autofilter"] = {
                    ref: _Ref[1]
                };
            } catch (e) {}
            break;
        case "date":
            break; // <*:date>
        case "object":
            break; // 10.4.6.2 <draw:object>
        case "title":
        case "\u6807\u9898":
            break; // <*:title> OR <uof:标题>
        case "desc":
            break; // <*:desc>
        case "binary-data":
            break; // 10.4.5 TODO: b64 blob
        /* 9.2 Advanced Tables */ case "table-source":
            break; // 9.2.6
        case "scenario":
            break; // 9.2.6
        case "iteration":
            break; // 9.4.3 <table:iteration>
        case "content-validations":
            break; // 9.4.4 <table:
        case "content-validation":
            break; // 9.4.5 <table:
        case "help-message":
            break; // 9.4.6 <table:
        case "error-message":
            break; // 9.4.7 <table:
        case "database-ranges":
            break; // 9.4.14 <table:database-ranges>
        case "filter":
            break; // 9.5.2 <table:filter>
        case "filter-and":
            break; // 9.5.3 <table:filter-and>
        case "filter-or":
            break; // 9.5.4 <table:filter-or>
        case "filter-condition":
            break; // 9.5.5 <table:filter-condition>
        case "list-level-style-bullet":
            break; // 16.31 <text:
        case "list-level-style-number":
            break; // 16.32 <text:
        case "list-level-properties":
            break; // 17.19 <style:
        /* 7.3 Document Fields */ case "sender-firstname":
        case "sender-lastname":
        case "sender-initials":
        case "sender-title":
        case "sender-position":
        case "sender-email":
        case "sender-phone-private":
        case "sender-fax":
        case "sender-company":
        case "sender-phone-work":
        case "sender-street":
        case "sender-city":
        case "sender-postal-code":
        case "sender-country":
        case "sender-state-or-province":
        case "author-name":
        case "author-initials":
        case "chapter":
        case "file-name":
        case "template-name":
        case "sheet-name":
            break;
        case "event-listener":
            break;
        /* TODO: FODS Properties */ case "initial-creator":
        case "creation-date":
        case "print-date":
        case "generator":
        case "document-statistic":
        case "user-defined":
        case "editing-duration":
        case "editing-cycles":
            break;
        /* TODO: FODS Config */ case "config-item":
            break;
        /* TODO: style tokens */ case "page-number":
            break; // TODO <text:page-number>
        case "page-count":
            break; // TODO <text:page-count>
        case "time":
            break; // TODO <text:time>
        /* 9.3 Advanced Table Cells */ case "cell-range-source":
            break; // 9.3.1 <table:
        case "detective":
            break; // 9.3.2 <table:
        case "operation":
            break; // 9.3.3 <table:
        case "highlighted-range":
            break; // 9.3.4 <table:
        /* 9.6 Data Pilot Tables <table: */ case "data-pilot-table":
        case "source-cell-range":
        case "source-service":
        case "data-pilot-field":
        case "data-pilot-level":
        case "data-pilot-subtotals":
        case "data-pilot-subtotal":
        case "data-pilot-members":
        case "data-pilot-member":
        case "data-pilot-display-info":
        case "data-pilot-sort-info":
        case "data-pilot-layout-info":
        case "data-pilot-field-reference":
        case "data-pilot-groups":
        case "data-pilot-group":
        case "data-pilot-group-member":
            break;
        /* 10.3 Drawing Shapes */ case "rect":
            break;
        /* 14.6 DDE Connections */ case "dde-connection-decls":
        case "dde-connection-decl":
        case "dde-link":
        case "dde-source":
            break;
        case "properties":
            break; // 13.7 <form:properties>
        case "property":
            break; // 13.8 <form:property>
        case "a":
            if (Rn[1] !== "/") {
                atag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                if (!atag.href) break;
                atag.Target = $3ee4f50b1ae43a89$var$unescapexml(atag.href);
                delete atag.href;
                if (atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
                    _Ref = $3ee4f50b1ae43a89$var$ods_to_csf_3D(atag.Target.slice(1));
                    atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
                } else if (atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
            }
            break;
        /* non-standard */ case "table-protection":
            break;
        case "data-pilot-grand-total":
            break; // <table:
        case "office-document-common-attrs":
            break; // bare
        default:
            switch(Rn[2]){
                case "dc:":
                case "calcext:":
                case "loext:":
                case "ooo:":
                case "chartooo:":
                case "draw:":
                case "style:":
                case "chart:":
                case "form:":
                case "uof:":
                case "\u8868:":
                case "\u5B57:":
                    break;
                default:
                    if (opts.WTF) throw new Error(Rn);
            }
    }
    var out /*:Workbook*/  = {
        Sheets: Sheets,
        SheetNames: SheetNames,
        Workbook: WB
    } /*:any*/ ;
    if (opts.bookSheets) delete /*::(*/ out /*:: :any)*/ .Sheets;
    return out;
}
function $3ee4f50b1ae43a89$var$parse_ods(zip /*:ZIPFile*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    opts = opts || {} /*:any*/ ;
    if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, "META-INF/manifest.xml")) $3ee4f50b1ae43a89$var$parse_manifest($3ee4f50b1ae43a89$var$getzipdata(zip, "META-INF/manifest.xml"), opts);
    var content = $3ee4f50b1ae43a89$var$getzipstr(zip, "content.xml");
    if (!content) throw new Error("Missing content.xml in ODS / UOF file");
    var wb = $3ee4f50b1ae43a89$var$parse_content_xml($3ee4f50b1ae43a89$var$utf8read(content), opts);
    if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, "meta.xml")) wb.Props = $3ee4f50b1ae43a89$var$parse_core_props($3ee4f50b1ae43a89$var$getzipdata(zip, "meta.xml"));
    return wb;
}
function $3ee4f50b1ae43a89$var$parse_fods(data /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    return $3ee4f50b1ae43a89$var$parse_content_xml(data, opts);
}
/* OpenDocument */ var $3ee4f50b1ae43a89$var$write_styles_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    var master_styles = [
        "<office:master-styles>",
        '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
        "<style:header/>",
        '<style:header-left style:display="false"/>',
        "<style:footer/>",
        '<style:footer-left style:display="false"/>',
        "</style:master-page>",
        "</office:master-styles>"
    ].join("");
    var payload = "<office:document-styles " + $3ee4f50b1ae43a89$var$wxt_helper({
        "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
        "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
        "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
        "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
        "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
        "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "xmlns:dc": "http://purl.org/dc/elements/1.1/",
        "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
        "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
        "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
        "office:version": "1.2"
    }) + ">" + master_styles + "</office:document-styles>";
    return function wso() {
        return $3ee4f50b1ae43a89$var$XML_HEADER + payload;
    };
}();
var $3ee4f50b1ae43a89$var$write_content_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    /* 6.1.2 White Space Characters */ var write_text_p = function(text /*:string*/ ) /*:string*/ {
        return $3ee4f50b1ae43a89$var$escapexml(text).replace(/  +/g, function($$) {
            return '<text:s text:c="' + $$.length + '"/>';
        }).replace(/\t/g, "<text:tab/>").replace(/\n/g, "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
    };
    var null_cell_xml = "          <table:table-cell />\n";
    var covered_cell_xml = "          <table:covered-table-cell/>\n";
    var write_ws = function(ws, wb /*:Workbook*/ , i /*:number*/  /*::, opts*/ ) /*:string*/ {
        /* Section 9 Tables */ var o /*:Array<string>*/  = [];
        o.push('      <table:table table:name="' + $3ee4f50b1ae43a89$var$escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
        var R = 0, C = 0, range = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"] || "A1");
        var marr /*:Array<Range>*/  = ws["!merges"] || [], mi = 0;
        var dense = Array.isArray(ws);
        if (ws["!cols"]) for(C = 0; C <= range.e.c; ++C)o.push("        <table:table-column" + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : "") + "></table:table-column>\n");
        var H = "", ROWS = ws["!rows"] || [];
        for(R = 0; R < range.s.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push("        <table:table-row" + H + "></table:table-row>\n");
        }
        for(; R <= range.e.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push("        <table:table-row" + H + ">\n");
            for(C = 0; C < range.s.c; ++C)o.push(null_cell_xml);
            for(; C <= range.e.c; ++C){
                var skip = false, ct = {}, textp = "";
                for(mi = 0; mi != marr.length; ++mi){
                    if (marr[mi].s.c > C) continue;
                    if (marr[mi].s.r > R) continue;
                    if (marr[mi].e.c < C) continue;
                    if (marr[mi].e.r < R) continue;
                    if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                    ct["table:number-columns-spanned"] = marr[mi].e.c - marr[mi].s.c + 1;
                    ct["table:number-rows-spanned"] = marr[mi].e.r - marr[mi].s.r + 1;
                    break;
                }
                if (skip) {
                    o.push(covered_cell_xml);
                    continue;
                }
                var ref = $3ee4f50b1ae43a89$var$encode_cell({
                    r: R,
                    c: C
                }), cell = dense ? (ws[R] || [])[C] : ws[ref];
                if (cell && cell.f) {
                    ct["table:formula"] = $3ee4f50b1ae43a89$var$escapexml($3ee4f50b1ae43a89$var$csf_to_ods_formula(cell.f));
                    if (cell.F) {
                        if (cell.F.slice(0, ref.length) == ref) {
                            var _Fref = $3ee4f50b1ae43a89$var$decode_range(cell.F);
                            ct["table:number-matrix-columns-spanned"] = _Fref.e.c - _Fref.s.c + 1;
                            ct["table:number-matrix-rows-spanned"] = _Fref.e.r - _Fref.s.r + 1;
                        }
                    }
                }
                if (!cell) {
                    o.push(null_cell_xml);
                    continue;
                }
                switch(cell.t){
                    case "b":
                        textp = cell.v ? "TRUE" : "FALSE";
                        ct["office:value-type"] = "boolean";
                        ct["office:boolean-value"] = cell.v ? "true" : "false";
                        break;
                    case "n":
                        textp = cell.w || String(cell.v || 0);
                        ct["office:value-type"] = "float";
                        ct["office:value"] = cell.v || 0;
                        break;
                    case "s":
                    case "str":
                        textp = cell.v == null ? "" : cell.v;
                        ct["office:value-type"] = "string";
                        break;
                    case "d":
                        textp = cell.w || $3ee4f50b1ae43a89$var$parseDate(cell.v).toISOString();
                        ct["office:value-type"] = "date";
                        ct["office:date-value"] = $3ee4f50b1ae43a89$var$parseDate(cell.v).toISOString();
                        ct["table:style-name"] = "ce1";
                        break;
                    //case 'e':
                    default:
                        o.push(null_cell_xml);
                        continue;
                }
                var text_p = write_text_p(textp);
                if (cell.l && cell.l.Target) {
                    var _tgt = cell.l.Target;
                    _tgt = _tgt.charAt(0) == "#" ? "#" + $3ee4f50b1ae43a89$var$csf_to_ods_3D(_tgt.slice(1)) : _tgt;
                    // TODO: choose correct parent path format based on link delimiters
                    if (_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = "../" + _tgt;
                    text_p = $3ee4f50b1ae43a89$var$writextag("text:a", text_p, {
                        "xlink:href": _tgt.replace(/&/g, "&amp;")
                    });
                }
                o.push("          " + $3ee4f50b1ae43a89$var$writextag("table:table-cell", $3ee4f50b1ae43a89$var$writextag("text:p", text_p, {}), ct) + "\n");
            }
            o.push("        </table:table-row>\n");
        }
        o.push("      </table:table>\n");
        return o.join("");
    };
    var write_automatic_styles_ods = function(o /*:Array<string>*/ , wb) {
        o.push(" <office:automatic-styles>\n");
        o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
        o.push('   <number:month number:style="long"/>\n');
        o.push("   <number:text>/</number:text>\n");
        o.push('   <number:day number:style="long"/>\n');
        o.push("   <number:text>/</number:text>\n");
        o.push("   <number:year/>\n");
        o.push("  </number:date-style>\n");
        /* column styles */ var cidx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!cols"]) {
                for(var C = 0; C < ws["!cols"].length; ++C)if (ws["!cols"][C]) {
                    var colobj = ws["!cols"][C];
                    if (colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
                    $3ee4f50b1ae43a89$var$process_col(colobj);
                    colobj.ods = cidx;
                    var w = ws["!cols"][C].wpx + "px";
                    o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
                    o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
                    o.push("  </style:style>\n");
                    ++cidx;
                }
            }
        });
        /* row styles */ var ridx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!rows"]) {
                for(var R = 0; R < ws["!rows"].length; ++R)if (ws["!rows"][R]) {
                    ws["!rows"][R].ods = ridx;
                    var h = ws["!rows"][R].hpx + "px";
                    o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
                    o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
                    o.push("  </style:style>\n");
                    ++ridx;
                }
            }
        });
        /* table */ o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
        o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
        o.push("  </style:style>\n");
        /* table cells, text */ o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
        /* page-layout */ o.push(" </office:automatic-styles>\n");
    };
    return function wcx(wb, opts) {
        var o = [
            $3ee4f50b1ae43a89$var$XML_HEADER
        ];
        /* 3.1.3.2 */ var attr = $3ee4f50b1ae43a89$var$wxt_helper({
            "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
            "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
            "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
            "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
            "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
            "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            "xmlns:dc": "http://purl.org/dc/elements/1.1/",
            "xmlns:meta": "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
            "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
            "xmlns:presentation": "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
            "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
            "xmlns:chart": "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
            "xmlns:dr3d": "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
            "xmlns:math": "http://www.w3.org/1998/Math/MathML",
            "xmlns:form": "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
            "xmlns:script": "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
            "xmlns:ooo": "http://openoffice.org/2004/office",
            "xmlns:ooow": "http://openoffice.org/2004/writer",
            "xmlns:oooc": "http://openoffice.org/2004/calc",
            "xmlns:dom": "http://www.w3.org/2001/xml-events",
            "xmlns:xforms": "http://www.w3.org/2002/xforms",
            "xmlns:xsd": "http://www.w3.org/2001/XMLSchema",
            "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
            "xmlns:sheet": "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
            "xmlns:rpt": "http://openoffice.org/2005/report",
            "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
            "xmlns:xhtml": "http://www.w3.org/1999/xhtml",
            "xmlns:grddl": "http://www.w3.org/2003/g/data-view#",
            "xmlns:tableooo": "http://openoffice.org/2009/table",
            "xmlns:drawooo": "http://openoffice.org/2010/draw",
            "xmlns:calcext": "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
            "xmlns:loext": "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
            "xmlns:field": "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
            "xmlns:formx": "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
            "xmlns:css3t": "http://www.w3.org/TR/css3-text/",
            "office:version": "1.2"
        });
        var fods = $3ee4f50b1ae43a89$var$wxt_helper({
            "xmlns:config": "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
            "office:mimetype": "application/vnd.oasis.opendocument.spreadsheet"
        });
        if (opts.bookType == "fods") {
            o.push("<office:document" + attr + fods + ">\n");
            o.push($3ee4f50b1ae43a89$var$write_meta_ods().replace(/office:document-meta/g, "office:meta"));
        // TODO: settings (equiv of settings.xml for ODS)
        } else o.push("<office:document-content" + attr + ">\n");
        // o.push('  <office:scripts/>\n');
        write_automatic_styles_ods(o, wb);
        o.push("  <office:body>\n");
        o.push("    <office:spreadsheet>\n");
        for(var i = 0; i != wb.SheetNames.length; ++i)o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts));
        o.push("    </office:spreadsheet>\n");
        o.push("  </office:body>\n");
        if (opts.bookType == "fods") o.push("</office:document>");
        else o.push("</office:document-content>");
        return o.join("");
    };
}();
function $3ee4f50b1ae43a89$var$write_ods(wb /*:any*/ , opts /*:any*/ ) {
    if (opts.bookType == "fods") return $3ee4f50b1ae43a89$var$write_content_ods(wb, opts);
    var zip = $3ee4f50b1ae43a89$var$zip_new();
    var f = "";
    var manifest /*:Array<Array<string> >*/  = [];
    var rdf /*:Array<[string, string]>*/  = [];
    /* Part 3 Section 3.3 MIME Media Type */ f = "mimetype";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
    /* Part 1 Section 2.2 Documents */ f = "content.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_content_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "ContentFile"
    ]);
    /* TODO: these are hard-coded styles to satiate excel */ f = "styles.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_styles_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "StylesFile"
    ]);
    /* TODO: this is hard-coded to satiate excel */ f = "meta.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$XML_HEADER + $3ee4f50b1ae43a89$var$write_meta_ods());
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "MetadataFile"
    ]);
    /* Part 3 Section 6 Metadata Manifest File */ f = "manifest.rdf";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_rdf(rdf /*, opts*/ ));
    manifest.push([
        f,
        "application/rdf+xml"
    ]);
    /* Part 3 Section 4 Manifest File */ f = "META-INF/manifest.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_manifest(manifest /*, opts*/ ));
    return zip;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */ function $3ee4f50b1ae43a89$var$u8_to_dataview(array) {
    return new DataView(array.buffer, array.byteOffset, array.byteLength);
}
function $3ee4f50b1ae43a89$var$u8str(u8) {
    return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : $3ee4f50b1ae43a89$var$utf8read($3ee4f50b1ae43a89$var$a2s(u8));
}
function $3ee4f50b1ae43a89$var$stru8(str) {
    return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : $3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$utf8write(str));
}
function $3ee4f50b1ae43a89$var$u8contains(body, search) {
    outer: for(var L = 0; L <= body.length - search.length; ++L){
        for(var j = 0; j < search.length; ++j)if (body[L + j] != search[j]) continue outer;
        return true;
    }
    return false;
}
function $3ee4f50b1ae43a89$var$u8concat(u8a) {
    var len = u8a.reduce(function(acc, x) {
        return acc + x.length;
    }, 0);
    var out = new Uint8Array(len);
    var off = 0;
    u8a.forEach(function(u8) {
        out.set(u8, off);
        off += u8.length;
    });
    return out;
}
function $3ee4f50b1ae43a89$var$popcnt(x) {
    x -= x >> 1 & 1431655765;
    x = (x & 858993459) + (x >> 2 & 858993459);
    return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
}
function $3ee4f50b1ae43a89$var$readDecimal128LE(buf, offset) {
    var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
    var mantissa = buf[offset + 14] & 1;
    for(var j = offset + 13; j >= offset; --j)mantissa = mantissa * 256 + buf[j];
    return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
}
function $3ee4f50b1ae43a89$var$writeDecimal128LE(buf, offset, value) {
    var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 20;
    var mantissa = value / Math.pow(10, exp - 6176);
    buf[offset + 15] |= exp >> 7;
    buf[offset + 14] |= (exp & 127) << 1;
    for(var i = 0; mantissa >= 1; ++i, mantissa /= 256)buf[offset + i] = mantissa & 255;
    buf[offset + 15] |= value >= 0 ? 0 : 128;
}
function $3ee4f50b1ae43a89$var$parse_varint49(buf, ptr) {
    var l = ptr ? ptr[0] : 0;
    var usz = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        usz |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 28);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 35);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 42);
        ++l;
        if (buf[l++] < 128) break varint;
    }
    if (ptr) ptr[0] = l;
    return usz;
}
function $3ee4f50b1ae43a89$var$write_varint49(v) {
    var usz = new Uint8Array(7);
    usz[0] = v & 127;
    var L = 1;
    sz: if (v > 127) {
        usz[L - 1] |= 128;
        usz[L] = v >> 7 & 127;
        ++L;
        if (v <= 16383) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 14 & 127;
        ++L;
        if (v <= 2097151) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 21 & 127;
        ++L;
        if (v <= 268435455) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 256 >>> 21 & 127;
        ++L;
        if (v <= 34359738367) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 65536 >>> 21 & 127;
        ++L;
        if (v <= 4398046511103) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 16777216 >>> 21 & 127;
        ++L;
    }
    return usz.slice(0, L);
}
function $3ee4f50b1ae43a89$var$varint_to_i32(buf) {
    var l = 0, i32 = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        i32 |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 28;
    }
    return i32;
}
function $3ee4f50b1ae43a89$var$parse_shallow(buf) {
    var out = [], ptr = [
        0
    ];
    while(ptr[0] < buf.length){
        var off = ptr[0];
        var num = $3ee4f50b1ae43a89$var$parse_varint49(buf, ptr);
        var type = num & 7;
        num = Math.floor(num / 8);
        var len = 0;
        var res;
        if (num == 0) break;
        switch(type){
            case 0:
                var l = ptr[0];
                while(buf[ptr[0]++] >= 128);
                res = buf.slice(l, ptr[0]);
                break;
            case 5:
                len = 4;
                res = buf.slice(ptr[0], ptr[0] + len);
                ptr[0] += len;
                break;
            case 1:
                len = 8;
                res = buf.slice(ptr[0], ptr[0] + len);
                ptr[0] += len;
                break;
            case 2:
                len = $3ee4f50b1ae43a89$var$parse_varint49(buf, ptr);
                res = buf.slice(ptr[0], ptr[0] + len);
                ptr[0] += len;
                break;
            case 3:
            case 4:
            default:
                throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
        }
        var v = {
            data: res,
            type: type
        };
        if (out[num] == null) out[num] = [
            v
        ];
        else out[num].push(v);
    }
    return out;
}
function $3ee4f50b1ae43a89$var$write_shallow(proto) {
    var out = [];
    proto.forEach(function(field, idx) {
        field.forEach(function(item) {
            if (!item.data) return;
            out.push($3ee4f50b1ae43a89$var$write_varint49(idx * 8 + item.type));
            if (item.type == 2) out.push($3ee4f50b1ae43a89$var$write_varint49(item.data.length));
            out.push(item.data);
        });
    });
    return $3ee4f50b1ae43a89$var$u8concat(out);
}
function $3ee4f50b1ae43a89$var$mappa(data, cb) {
    return (data == null ? void 0 : data.map(function(d) {
        return cb(d.data);
    })) || [];
}
function $3ee4f50b1ae43a89$var$parse_iwa_file(buf) {
    var _a;
    var out = [], ptr = [
        0
    ];
    while(ptr[0] < buf.length){
        var len = $3ee4f50b1ae43a89$var$parse_varint49(buf, ptr);
        var ai = $3ee4f50b1ae43a89$var$parse_shallow(buf.slice(ptr[0], ptr[0] + len));
        ptr[0] += len;
        var res = {
            id: $3ee4f50b1ae43a89$var$varint_to_i32(ai[1][0].data),
            messages: []
        };
        ai[2].forEach(function(b) {
            var mi = $3ee4f50b1ae43a89$var$parse_shallow(b.data);
            var fl = $3ee4f50b1ae43a89$var$varint_to_i32(mi[3][0].data);
            res.messages.push({
                meta: mi,
                data: buf.slice(ptr[0], ptr[0] + fl)
            });
            ptr[0] += fl;
        });
        if ((_a = ai[3]) == null ? void 0 : _a[0]) res.merge = $3ee4f50b1ae43a89$var$varint_to_i32(ai[3][0].data) >>> 0 > 0;
        out.push(res);
    }
    return out;
}
function $3ee4f50b1ae43a89$var$write_iwa_file(ias) {
    var bufs = [];
    ias.forEach(function(ia) {
        var ai = [];
        ai[1] = [
            {
                data: $3ee4f50b1ae43a89$var$write_varint49(ia.id),
                type: 0
            }
        ];
        ai[2] = [];
        if (ia.merge != null) ai[3] = [
            {
                data: $3ee4f50b1ae43a89$var$write_varint49(+!!ia.merge),
                type: 0
            }
        ];
        var midata = [];
        ia.messages.forEach(function(mi) {
            midata.push(mi.data);
            mi.meta[3] = [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(mi.data.length)
                }
            ];
            ai[2].push({
                data: $3ee4f50b1ae43a89$var$write_shallow(mi.meta),
                type: 2
            });
        });
        var aipayload = $3ee4f50b1ae43a89$var$write_shallow(ai);
        bufs.push($3ee4f50b1ae43a89$var$write_varint49(aipayload.length));
        bufs.push(aipayload);
        midata.forEach(function(mid) {
            return bufs.push(mid);
        });
    });
    return $3ee4f50b1ae43a89$var$u8concat(bufs);
}
function $3ee4f50b1ae43a89$var$parse_snappy_chunk(type, buf) {
    if (type != 0) throw new Error("Unexpected Snappy chunk type ".concat(type));
    var ptr = [
        0
    ];
    var usz = $3ee4f50b1ae43a89$var$parse_varint49(buf, ptr);
    var chunks = [];
    while(ptr[0] < buf.length){
        var tag = buf[ptr[0]] & 3;
        if (tag == 0) {
            var len = buf[ptr[0]++] >> 2;
            if (len < 60) ++len;
            else {
                var c = len - 59;
                len = buf[ptr[0]];
                if (c > 1) len |= buf[ptr[0] + 1] << 8;
                if (c > 2) len |= buf[ptr[0] + 2] << 16;
                if (c > 3) len |= buf[ptr[0] + 3] << 24;
                len >>>= 0;
                len++;
                ptr[0] += c;
            }
            chunks.push(buf.slice(ptr[0], ptr[0] + len));
            ptr[0] += len;
            continue;
        } else {
            var offset = 0, length = 0;
            if (tag == 1) {
                length = (buf[ptr[0]] >> 2 & 7) + 4;
                offset = (buf[ptr[0]++] & 224) << 3;
                offset |= buf[ptr[0]++];
            } else {
                length = (buf[ptr[0]++] >> 2) + 1;
                if (tag == 2) {
                    offset = buf[ptr[0]] | buf[ptr[0] + 1] << 8;
                    ptr[0] += 2;
                } else {
                    offset = (buf[ptr[0]] | buf[ptr[0] + 1] << 8 | buf[ptr[0] + 2] << 16 | buf[ptr[0] + 3] << 24) >>> 0;
                    ptr[0] += 4;
                }
            }
            chunks = [
                $3ee4f50b1ae43a89$var$u8concat(chunks)
            ];
            if (offset == 0) throw new Error("Invalid offset 0");
            if (offset > chunks[0].length) throw new Error("Invalid offset beyond length");
            if (length >= offset) {
                chunks.push(chunks[0].slice(-offset));
                length -= offset;
                while(length >= chunks[chunks.length - 1].length){
                    chunks.push(chunks[chunks.length - 1]);
                    length -= chunks[chunks.length - 1].length;
                }
            }
            chunks.push(chunks[0].slice(-offset, -offset + length));
        }
    }
    var o = $3ee4f50b1ae43a89$var$u8concat(chunks);
    if (o.length != usz) throw new Error("Unexpected length: ".concat(o.length, " != ").concat(usz));
    return o;
}
function $3ee4f50b1ae43a89$var$decompress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var t = buf[l++];
        var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
        l += 3;
        out.push($3ee4f50b1ae43a89$var$parse_snappy_chunk(t, buf.slice(l, l + len)));
        l += len;
    }
    if (l !== buf.length) throw new Error("data is not a valid framed stream!");
    return $3ee4f50b1ae43a89$var$u8concat(out);
}
function $3ee4f50b1ae43a89$var$compress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var c = Math.min(buf.length - l, 268435455);
        var frame = new Uint8Array(4);
        out.push(frame);
        var usz = $3ee4f50b1ae43a89$var$write_varint49(c);
        var L = usz.length;
        out.push(usz);
        if (c <= 60) {
            L++;
            out.push(new Uint8Array([
                c - 1 << 2
            ]));
        } else if (c <= 256) {
            L += 2;
            out.push(new Uint8Array([
                240,
                c - 1 & 255
            ]));
        } else if (c <= 65536) {
            L += 3;
            out.push(new Uint8Array([
                244,
                c - 1 & 255,
                c - 1 >> 8 & 255
            ]));
        } else if (c <= 16777216) {
            L += 4;
            out.push(new Uint8Array([
                248,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255
            ]));
        } else if (c <= 4294967296) {
            L += 5;
            out.push(new Uint8Array([
                252,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255,
                c - 1 >>> 24 & 255
            ]));
        }
        out.push(buf.slice(l, l + c));
        L += c;
        frame[0] = 0;
        frame[1] = L & 255;
        frame[2] = L >> 8 & 255;
        frame[3] = L >> 16 & 255;
        l += c;
    }
    return $3ee4f50b1ae43a89$var$u8concat(out);
}
function $3ee4f50b1ae43a89$var$parse_old_storage(buf, sst, rsst, v) {
    var dv = $3ee4f50b1ae43a89$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var data_offset = (v > 1 ? 12 : 8) + $3ee4f50b1ae43a89$var$popcnt(flags & (v > 1 ? 3470 : 398)) * 4;
    var ridx = -1, sidx = -1, ieee = NaN, dt = new Date(2001, 0, 1);
    if (flags & 512) {
        ridx = dv.getUint32(data_offset, true);
        data_offset += 4;
    }
    data_offset += $3ee4f50b1ae43a89$var$popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
    if (flags & 16) {
        sidx = dv.getUint32(data_offset, true);
        data_offset += 4;
    }
    if (flags & 32) {
        ieee = dv.getFloat64(data_offset, true);
        data_offset += 8;
    }
    if (flags & 64) {
        dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
        data_offset += 8;
    }
    var ret;
    switch(buf[2]){
        case 0:
            break;
        case 2:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: sst[sidx]
            };
            break;
        case 5:
            ret = {
                t: "d",
                v: dt
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee / 86400
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) ret = {
                t: "s",
                v: rsst[ridx]
            };
            else if (sidx > -1) ret = {
                t: "s",
                v: sst[sidx]
            };
            else if (!isNaN(ieee)) ret = {
                t: "n",
                v: ieee
            };
            else throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
    }
    return ret;
}
function $3ee4f50b1ae43a89$var$parse_new_storage(buf, sst, rsst) {
    var dv = $3ee4f50b1ae43a89$var$u8_to_dataview(buf);
    var flags = dv.getUint32(8, true);
    var data_offset = 12;
    var ridx = -1, sidx = -1, d128 = NaN, ieee = NaN, dt = new Date(2001, 0, 1);
    if (flags & 1) {
        d128 = $3ee4f50b1ae43a89$var$readDecimal128LE(buf, data_offset);
        data_offset += 16;
    }
    if (flags & 2) {
        ieee = dv.getFloat64(data_offset, true);
        data_offset += 8;
    }
    if (flags & 4) {
        dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
        data_offset += 8;
    }
    if (flags & 8) {
        sidx = dv.getUint32(data_offset, true);
        data_offset += 4;
    }
    if (flags & 16) {
        ridx = dv.getUint32(data_offset, true);
        data_offset += 4;
    }
    var ret;
    switch(buf[1]){
        case 0:
            break;
        case 2:
            ret = {
                t: "n",
                v: d128
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: sst[sidx]
            };
            break;
        case 5:
            ret = {
                t: "d",
                v: dt
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee / 86400
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) ret = {
                t: "s",
                v: rsst[ridx]
            };
            else throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
            break;
        case 10:
            ret = {
                t: "n",
                v: d128
            };
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
    }
    return ret;
}
function $3ee4f50b1ae43a89$var$write_new_storage(cell, sst) {
    var out = new Uint8Array(32), dv = $3ee4f50b1ae43a89$var$u8_to_dataview(out), l = 12, flags = 0;
    out[0] = 5;
    switch(cell.t){
        case "n":
            out[1] = 2;
            $3ee4f50b1ae43a89$var$writeDecimal128LE(out, l, cell.v);
            flags |= 1;
            l += 16;
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            flags |= 2;
            l += 8;
            break;
        case "s":
            if (sst.indexOf(cell.v) == -1) throw new Error("Value ".concat(cell.v, " missing from SST!"));
            out[1] = 3;
            dv.setUint32(l, sst.indexOf(cell.v), true);
            flags |= 8;
            l += 4;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(8, flags, true);
    return out.slice(0, l);
}
function $3ee4f50b1ae43a89$var$write_old_storage(cell, sst) {
    var out = new Uint8Array(32), dv = $3ee4f50b1ae43a89$var$u8_to_dataview(out), l = 12, flags = 0;
    out[0] = 3;
    switch(cell.t){
        case "n":
            out[2] = 2;
            dv.setFloat64(l, cell.v, true);
            flags |= 32;
            l += 8;
            break;
        case "b":
            out[2] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            flags |= 32;
            l += 8;
            break;
        case "s":
            if (sst.indexOf(cell.v) == -1) throw new Error("Value ".concat(cell.v, " missing from SST!"));
            out[2] = 3;
            dv.setUint32(l, sst.indexOf(cell.v), true);
            flags |= 16;
            l += 4;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(4, flags, true);
    return out.slice(0, l);
}
function $3ee4f50b1ae43a89$var$parse_cell_storage(buf, sst, rsst) {
    switch(buf[0]){
        case 0:
        case 1:
        case 2:
        case 3:
            return $3ee4f50b1ae43a89$var$parse_old_storage(buf, sst, rsst, buf[0]);
        case 5:
            return $3ee4f50b1ae43a89$var$parse_new_storage(buf, sst, rsst);
        default:
            throw new Error("Unsupported payload version ".concat(buf[0]));
    }
}
function $3ee4f50b1ae43a89$var$parse_TSP_Reference(buf) {
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(buf);
    return $3ee4f50b1ae43a89$var$parse_varint49(pb[1][0].data);
}
function $3ee4f50b1ae43a89$var$write_TSP_Reference(idx) {
    var out = [];
    out[1] = [
        {
            type: 0,
            data: $3ee4f50b1ae43a89$var$write_varint49(idx)
        }
    ];
    return $3ee4f50b1ae43a89$var$write_shallow(out);
}
function $3ee4f50b1ae43a89$var$parse_TST_TableDataList(M, root) {
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    var type = $3ee4f50b1ae43a89$var$varint_to_i32(pb[1][0].data);
    var entries = pb[3];
    var data = [];
    (entries || []).forEach(function(entry) {
        var le = $3ee4f50b1ae43a89$var$parse_shallow(entry.data);
        var key = $3ee4f50b1ae43a89$var$varint_to_i32(le[1][0].data) >>> 0;
        switch(type){
            case 1:
                data[key] = $3ee4f50b1ae43a89$var$u8str(le[3][0].data);
                break;
            case 8:
                var rt = M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(le[9][0].data)][0];
                var rtp = $3ee4f50b1ae43a89$var$parse_shallow(rt.data);
                var rtpref = M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(rtp[1][0].data)][0];
                var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(rtpref.meta[1][0].data);
                if (mtype != 2001) throw new Error("2000 unexpected reference to ".concat(mtype));
                var tswpsa = $3ee4f50b1ae43a89$var$parse_shallow(rtpref.data);
                data[key] = tswpsa[3].map(function(x) {
                    return $3ee4f50b1ae43a89$var$u8str(x.data);
                }).join("");
                break;
        }
    });
    return data;
}
function $3ee4f50b1ae43a89$var$parse_TST_TileRowInfo(u8, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(u8);
    var R = $3ee4f50b1ae43a89$var$varint_to_i32(pb[1][0].data) >>> 0;
    var cnt = $3ee4f50b1ae43a89$var$varint_to_i32(pb[2][0].data) >>> 0;
    var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && $3ee4f50b1ae43a89$var$varint_to_i32(pb[8][0].data) > 0 || false;
    var used_storage_u8, used_storage;
    if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
        used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
        used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
    } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
        used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
        used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
    } else throw "NUMBERS Tile missing ".concat(type, " cell storage");
    var width = wide_offsets ? 4 : 1;
    var used_storage_offsets = $3ee4f50b1ae43a89$var$u8_to_dataview(used_storage_u8);
    var offsets = [];
    for(var C = 0; C < used_storage_u8.length / 2; ++C){
        var off = used_storage_offsets.getUint16(C * 2, true);
        if (off < 65535) offsets.push([
            C,
            off
        ]);
    }
    if (offsets.length != cnt) throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
    var cells = [];
    for(C = 0; C < offsets.length - 1; ++C)cells[offsets[C][0]] = used_storage.subarray(offsets[C][1] * width, offsets[C + 1][1] * width);
    if (offsets.length >= 1) cells[offsets[offsets.length - 1][0]] = used_storage.subarray(offsets[offsets.length - 1][1] * width);
    return {
        R: R,
        cells: cells
    };
}
function $3ee4f50b1ae43a89$var$parse_TST_Tile(M, root) {
    var _a;
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    var storage = ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) ? $3ee4f50b1ae43a89$var$varint_to_i32(pb[7][0].data) >>> 0 > 0 ? 1 : 0 : -1;
    var ri = $3ee4f50b1ae43a89$var$mappa(pb[5], function(u8) {
        return $3ee4f50b1ae43a89$var$parse_TST_TileRowInfo(u8, storage);
    });
    return {
        nrows: $3ee4f50b1ae43a89$var$varint_to_i32(pb[4][0].data) >>> 0,
        data: ri.reduce(function(acc, x) {
            if (!acc[x.R]) acc[x.R] = [];
            x.cells.forEach(function(cell, C) {
                if (acc[x.R][C]) throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
                acc[x.R][C] = cell;
            });
            return acc;
        }, [])
    };
}
function $3ee4f50b1ae43a89$var$parse_TST_TableModelArchive(M, root, ws) {
    var _a;
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    var range = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    range.e.r = ($3ee4f50b1ae43a89$var$varint_to_i32(pb[6][0].data) >>> 0) - 1;
    if (range.e.r < 0) throw new Error("Invalid row varint ".concat(pb[6][0].data));
    range.e.c = ($3ee4f50b1ae43a89$var$varint_to_i32(pb[7][0].data) >>> 0) - 1;
    if (range.e.c < 0) throw new Error("Invalid col varint ".concat(pb[7][0].data));
    ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
    var store = $3ee4f50b1ae43a89$var$parse_shallow(pb[4][0].data);
    var sst = $3ee4f50b1ae43a89$var$parse_TST_TableDataList(M, M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(store[4][0].data)][0]);
    var rsst = ((_a = store[17]) == null ? void 0 : _a[0]) ? $3ee4f50b1ae43a89$var$parse_TST_TableDataList(M, M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(store[17][0].data)][0]) : [];
    var tile = $3ee4f50b1ae43a89$var$parse_shallow(store[3][0].data);
    var _R = 0;
    tile[1].forEach(function(t) {
        var tl = $3ee4f50b1ae43a89$var$parse_shallow(t.data);
        var ref = M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(tl[2][0].data)][0];
        var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(ref.meta[1][0].data);
        if (mtype != 6002) throw new Error("6001 unexpected reference to ".concat(mtype));
        var _tile = $3ee4f50b1ae43a89$var$parse_TST_Tile(M, ref);
        _tile.data.forEach(function(row, R) {
            row.forEach(function(buf, C) {
                var addr = $3ee4f50b1ae43a89$var$encode_cell({
                    r: _R + R,
                    c: C
                });
                var res = $3ee4f50b1ae43a89$var$parse_cell_storage(buf, sst, rsst);
                if (res) ws[addr] = res;
            });
        });
        _R += _tile.nrows;
    });
}
function $3ee4f50b1ae43a89$var$parse_TST_TableInfoArchive(M, root) {
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    var out = {
        "!ref": "A1"
    };
    var tableref = M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(pb[2][0].data)];
    var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(tableref[0].meta[1][0].data);
    if (mtype != 6001) throw new Error("6000 unexpected reference to ".concat(mtype));
    $3ee4f50b1ae43a89$var$parse_TST_TableModelArchive(M, tableref[0], out);
    return out;
}
function $3ee4f50b1ae43a89$var$parse_TN_SheetArchive(M, root) {
    var _a;
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    var out = {
        name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? $3ee4f50b1ae43a89$var$u8str(pb[1][0].data) : "",
        sheets: []
    };
    var shapeoffs = $3ee4f50b1ae43a89$var$mappa(pb[2], $3ee4f50b1ae43a89$var$parse_TSP_Reference);
    shapeoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 6e3) out.sheets.push($3ee4f50b1ae43a89$var$parse_TST_TableInfoArchive(M, m));
        });
    });
    return out;
}
function $3ee4f50b1ae43a89$var$parse_TN_DocumentArchive(M, root) {
    var out = $3ee4f50b1ae43a89$var$book_new();
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    var sheetoffs = $3ee4f50b1ae43a89$var$mappa(pb[1], $3ee4f50b1ae43a89$var$parse_TSP_Reference);
    sheetoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 2) {
                var root2 = $3ee4f50b1ae43a89$var$parse_TN_SheetArchive(M, m);
                root2.sheets.forEach(function(sheet, idx) {
                    $3ee4f50b1ae43a89$var$book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
                });
            }
        });
    });
    if (out.SheetNames.length == 0) throw new Error("Empty NUMBERS file");
    return out;
}
function $3ee4f50b1ae43a89$var$parse_numbers_iwa(cfb) {
    var _a, _b, _c, _d;
    var M = {}, indices = [];
    cfb.FullPaths.forEach(function(p) {
        if (p.match(/\.iwpv2/)) throw new Error("Unsupported password protection");
    });
    cfb.FileIndex.forEach(function(s) {
        if (!s.name.match(/\.iwa$/)) return;
        var o;
        try {
            o = $3ee4f50b1ae43a89$var$decompress_iwa_file(s.content);
        } catch (e) {
            return console.log("?? " + s.content.length + " " + (e.message || e));
        }
        var packets;
        try {
            packets = $3ee4f50b1ae43a89$var$parse_iwa_file(o);
        } catch (e) {
            return console.log("## " + (e.message || e));
        }
        packets.forEach(function(packet) {
            M[packet.id] = packet.messages;
            indices.push(packet.id);
        });
    });
    if (!indices.length) throw new Error("File has no messages");
    var docroot = ((_d = (_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0]) == null ? void 0 : _b.meta) == null ? void 0 : _c[1]) == null ? void 0 : _d[0].data) && $3ee4f50b1ae43a89$var$varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
    if (!docroot) indices.forEach(function(idx) {
        M[idx].forEach(function(iwam) {
            var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(iwam.meta[1][0].data) >>> 0;
            if (mtype == 1) {
                if (!docroot) docroot = iwam;
                else throw new Error("Document has multiple roots");
            }
        });
    });
    if (!docroot) throw new Error("Cannot find Document root");
    return $3ee4f50b1ae43a89$var$parse_TN_DocumentArchive(M, docroot);
}
function $3ee4f50b1ae43a89$var$write_tile_row(tri, data, SST) {
    var _a, _b, _c, _d;
    if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0])) throw "Mutation only works on post-BNC storages!";
    var wide_offsets = ((_d = (_c = tri[8]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && $3ee4f50b1ae43a89$var$varint_to_i32(tri[8][0].data) > 0 || false;
    if (wide_offsets) throw "Math only works with normal offsets";
    var cnt = 0;
    var dv = $3ee4f50b1ae43a89$var$u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
    var _dv = $3ee4f50b1ae43a89$var$u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
    for(var C = 0; C < data.length; ++C){
        if (data[C] == null) {
            dv.setUint16(C * 2, 65535, true);
            _dv.setUint16(C * 2, 65535);
            continue;
        }
        dv.setUint16(C * 2, last_offset, true);
        _dv.setUint16(C * 2, _last_offset, true);
        var celload, _celload;
        switch(typeof data[C]){
            case "string":
                celload = $3ee4f50b1ae43a89$var$write_new_storage({
                    t: "s",
                    v: data[C]
                }, SST);
                _celload = $3ee4f50b1ae43a89$var$write_old_storage({
                    t: "s",
                    v: data[C]
                }, SST);
                break;
            case "number":
                celload = $3ee4f50b1ae43a89$var$write_new_storage({
                    t: "n",
                    v: data[C]
                }, SST);
                _celload = $3ee4f50b1ae43a89$var$write_old_storage({
                    t: "n",
                    v: data[C]
                }, SST);
                break;
            case "boolean":
                celload = $3ee4f50b1ae43a89$var$write_new_storage({
                    t: "b",
                    v: data[C]
                }, SST);
                _celload = $3ee4f50b1ae43a89$var$write_old_storage({
                    t: "b",
                    v: data[C]
                }, SST);
                break;
            default:
                throw new Error("Unsupported value " + data[C]);
        }
        cell_storage.push(celload);
        last_offset += celload.length;
        _cell_storage.push(_celload);
        _last_offset += _celload.length;
        ++cnt;
    }
    tri[2][0].data = $3ee4f50b1ae43a89$var$write_varint49(cnt);
    for(; C < tri[7][0].data.length / 2; ++C){
        dv.setUint16(C * 2, 65535, true);
        _dv.setUint16(C * 2, 65535, true);
    }
    tri[6][0].data = $3ee4f50b1ae43a89$var$u8concat(cell_storage);
    tri[3][0].data = $3ee4f50b1ae43a89$var$u8concat(_cell_storage);
    return cnt;
}
function $3ee4f50b1ae43a89$var$write_numbers_iwa(wb, opts) {
    if (!opts || !opts.numbers) throw new Error("Must pass a `numbers` option -- check the README");
    var ws = wb.Sheets[wb.SheetNames[0]];
    if (wb.SheetNames.length > 1) console.error("The Numbers writer currently writes only the first table");
    var range = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
    range.s.r = range.s.c = 0;
    var trunc = false;
    if (range.e.c > 9) {
        trunc = true;
        range.e.c = 9;
    }
    if (range.e.r > 49) {
        trunc = true;
        range.e.r = 49;
    }
    if (trunc) console.error("The Numbers writer is currently limited to ".concat($3ee4f50b1ae43a89$var$encode_range(range)));
    var data = $3ee4f50b1ae43a89$var$sheet_to_json(ws, {
        range: range,
        header: 1
    });
    var SST = [
        "~Sh33tJ5~"
    ];
    data.forEach(function(row) {
        return row.forEach(function(cell) {
            if (typeof cell == "string") SST.push(cell);
        });
    });
    var dependents = {};
    var indices = [];
    var cfb = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(opts.numbers, {
        type: "base64"
    });
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (fi.type != 2) return;
        if (!fi.name.match(/\.iwa/)) return;
        var old_content = fi.content;
        var raw1 = $3ee4f50b1ae43a89$var$decompress_iwa_file(old_content);
        var x2 = $3ee4f50b1ae43a89$var$parse_iwa_file(raw1);
        x2.forEach(function(packet2) {
            indices.push(packet2.id);
            dependents[packet2.id] = {
                deps: [],
                location: fp,
                type: $3ee4f50b1ae43a89$var$varint_to_i32(packet2.messages[0].meta[1][0].data)
            };
        });
    });
    indices.sort(function(x2, y2) {
        return x2 - y2;
    });
    var indices_varint = indices.filter(function(x2) {
        return x2 > 1;
    }).map(function(x2) {
        return [
            x2,
            $3ee4f50b1ae43a89$var$write_varint49(x2)
        ];
    });
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (!fi.name.match(/\.iwa/)) return;
        var x2 = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(fi.content));
        x2.forEach(function(ia) {
            ia.messages.forEach(function(m) {
                indices_varint.forEach(function(ivi) {
                    if (ia.messages.some(function(mess) {
                        return $3ee4f50b1ae43a89$var$varint_to_i32(mess.meta[1][0].data) != 11006 && $3ee4f50b1ae43a89$var$u8contains(mess.data, ivi[1]);
                    })) dependents[ivi[0]].deps.push(ia.id);
                });
            });
        });
    });
    function get_unique_msgid() {
        for(var i = 927262; i < 2e6; ++i)if (!dependents[i]) return i;
        throw new Error("Too many messages");
    }
    var entry = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[1].location);
    var x = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(entry.content));
    var docroot;
    for(var xi = 0; xi < x.length; ++xi){
        var packet = x[xi];
        if (packet.id == 1) docroot = packet;
    }
    var sheetrootref = $3ee4f50b1ae43a89$var$parse_TSP_Reference($3ee4f50b1ae43a89$var$parse_shallow(docroot.messages[0].data)[1][0].data);
    entry = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[sheetrootref].location);
    x = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(entry.content));
    for(xi = 0; xi < x.length; ++xi){
        packet = x[xi];
        if (packet.id == sheetrootref) docroot = packet;
    }
    sheetrootref = $3ee4f50b1ae43a89$var$parse_TSP_Reference($3ee4f50b1ae43a89$var$parse_shallow(docroot.messages[0].data)[2][0].data);
    entry = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[sheetrootref].location);
    x = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(entry.content));
    for(xi = 0; xi < x.length; ++xi){
        packet = x[xi];
        if (packet.id == sheetrootref) docroot = packet;
    }
    sheetrootref = $3ee4f50b1ae43a89$var$parse_TSP_Reference($3ee4f50b1ae43a89$var$parse_shallow(docroot.messages[0].data)[2][0].data);
    entry = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[sheetrootref].location);
    x = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(entry.content));
    for(xi = 0; xi < x.length; ++xi){
        packet = x[xi];
        if (packet.id == sheetrootref) docroot = packet;
    }
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(docroot.messages[0].data);
    pb[6][0].data = $3ee4f50b1ae43a89$var$write_varint49(range.e.r + 1);
    pb[7][0].data = $3ee4f50b1ae43a89$var$write_varint49(range.e.c + 1);
    var cruidsref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(pb[46][0].data);
    var oldbucket = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[cruidsref].location);
    var _x = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(oldbucket.content));
    for(var j = 0; j < _x.length; ++j){
        if (_x[j].id == cruidsref) break;
    }
    if (_x[j].id != cruidsref) throw "Bad ColumnRowUIDMapArchive";
    var cruids = $3ee4f50b1ae43a89$var$parse_shallow(_x[j].messages[0].data);
    cruids[1] = [];
    cruids[2] = [], cruids[3] = [];
    for(var C = 0; C <= range.e.c; ++C){
        var uuid = [];
        uuid[1] = uuid[2] = [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(C + 420690)
            }
        ];
        cruids[1].push({
            type: 2,
            data: $3ee4f50b1ae43a89$var$write_shallow(uuid)
        });
        cruids[2].push({
            type: 0,
            data: $3ee4f50b1ae43a89$var$write_varint49(C)
        });
        cruids[3].push({
            type: 0,
            data: $3ee4f50b1ae43a89$var$write_varint49(C)
        });
    }
    cruids[4] = [];
    cruids[5] = [], cruids[6] = [];
    for(var R = 0; R <= range.e.r; ++R){
        uuid = [];
        uuid[1] = uuid[2] = [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(R + 726270)
            }
        ];
        cruids[4].push({
            type: 2,
            data: $3ee4f50b1ae43a89$var$write_shallow(uuid)
        });
        cruids[5].push({
            type: 0,
            data: $3ee4f50b1ae43a89$var$write_varint49(R)
        });
        cruids[6].push({
            type: 0,
            data: $3ee4f50b1ae43a89$var$write_varint49(R)
        });
    }
    _x[j].messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(cruids);
    oldbucket.content = $3ee4f50b1ae43a89$var$compress_iwa_file($3ee4f50b1ae43a89$var$write_iwa_file(_x));
    oldbucket.size = oldbucket.content.length;
    delete pb[46];
    var store = $3ee4f50b1ae43a89$var$parse_shallow(pb[4][0].data);
    store[7][0].data = $3ee4f50b1ae43a89$var$write_varint49(range.e.r + 1);
    var row_headers = $3ee4f50b1ae43a89$var$parse_shallow(store[1][0].data);
    var row_header_ref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(row_headers[2][0].data);
    oldbucket = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[row_header_ref].location);
    _x = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(oldbucket.content));
    if (_x[0].id != row_header_ref) throw "Bad HeaderStorageBucket";
    var base_bucket = $3ee4f50b1ae43a89$var$parse_shallow(_x[0].messages[0].data);
    for(R = 0; R < data.length; ++R){
        var _bucket = $3ee4f50b1ae43a89$var$parse_shallow(base_bucket[2][0].data);
        _bucket[1][0].data = $3ee4f50b1ae43a89$var$write_varint49(R);
        _bucket[4][0].data = $3ee4f50b1ae43a89$var$write_varint49(data[R].length);
        base_bucket[2][R] = {
            type: base_bucket[2][0].type,
            data: $3ee4f50b1ae43a89$var$write_shallow(_bucket)
        };
    }
    _x[0].messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(base_bucket);
    oldbucket.content = $3ee4f50b1ae43a89$var$compress_iwa_file($3ee4f50b1ae43a89$var$write_iwa_file(_x));
    oldbucket.size = oldbucket.content.length;
    var col_header_ref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(store[2][0].data);
    oldbucket = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[col_header_ref].location);
    _x = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(oldbucket.content));
    if (_x[0].id != col_header_ref) throw "Bad HeaderStorageBucket";
    base_bucket = $3ee4f50b1ae43a89$var$parse_shallow(_x[0].messages[0].data);
    for(C = 0; C <= range.e.c; ++C){
        _bucket = $3ee4f50b1ae43a89$var$parse_shallow(base_bucket[2][0].data);
        _bucket[1][0].data = $3ee4f50b1ae43a89$var$write_varint49(C);
        _bucket[4][0].data = $3ee4f50b1ae43a89$var$write_varint49(range.e.r + 1);
        base_bucket[2][C] = {
            type: base_bucket[2][0].type,
            data: $3ee4f50b1ae43a89$var$write_shallow(_bucket)
        };
    }
    _x[0].messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(base_bucket);
    oldbucket.content = $3ee4f50b1ae43a89$var$compress_iwa_file($3ee4f50b1ae43a89$var$write_iwa_file(_x));
    oldbucket.size = oldbucket.content.length;
    var sstref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(store[4][0].data);
    (function() {
        var sentry = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[sstref].location);
        var sx = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(sentry.content));
        var sstroot;
        for(var sxi = 0; sxi < sx.length; ++sxi){
            var packet2 = sx[sxi];
            if (packet2.id == sstref) sstroot = packet2;
        }
        var sstdata = $3ee4f50b1ae43a89$var$parse_shallow(sstroot.messages[0].data);
        sstdata[3] = [];
        var newsst = [];
        SST.forEach(function(str, i) {
            newsst[1] = [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(i)
                }
            ];
            newsst[2] = [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(1)
                }
            ];
            newsst[3] = [
                {
                    type: 2,
                    data: $3ee4f50b1ae43a89$var$stru8(str)
                }
            ];
            sstdata[3].push({
                type: 2,
                data: $3ee4f50b1ae43a89$var$write_shallow(newsst)
            });
        });
        sstroot.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(sstdata);
        var sy = $3ee4f50b1ae43a89$var$write_iwa_file(sx);
        var raw32 = $3ee4f50b1ae43a89$var$compress_iwa_file(sy);
        sentry.content = raw32;
        sentry.size = sentry.content.length;
    })();
    var tile = $3ee4f50b1ae43a89$var$parse_shallow(store[3][0].data);
    var t = tile[1][0];
    delete tile[2];
    var tl = $3ee4f50b1ae43a89$var$parse_shallow(t.data);
    var tileref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(tl[2][0].data);
    (function() {
        var tentry = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[tileref].location);
        var tx = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(tentry.content));
        var tileroot;
        for(var sxi = 0; sxi < tx.length; ++sxi){
            var packet2 = tx[sxi];
            if (packet2.id == tileref) tileroot = packet2;
        }
        var tiledata = $3ee4f50b1ae43a89$var$parse_shallow(tileroot.messages[0].data);
        delete tiledata[6];
        delete tile[7];
        var rowload = new Uint8Array(tiledata[5][0].data);
        tiledata[5] = [];
        var cnt = 0;
        for(var R2 = 0; R2 <= range.e.r; ++R2){
            var tilerow = $3ee4f50b1ae43a89$var$parse_shallow(rowload);
            cnt += $3ee4f50b1ae43a89$var$write_tile_row(tilerow, data[R2], SST);
            tilerow[1][0].data = $3ee4f50b1ae43a89$var$write_varint49(R2);
            tiledata[5].push({
                data: $3ee4f50b1ae43a89$var$write_shallow(tilerow),
                type: 2
            });
        }
        tiledata[1] = [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(range.e.c + 1)
            }
        ];
        tiledata[2] = [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(range.e.r + 1)
            }
        ];
        tiledata[3] = [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(cnt)
            }
        ];
        tiledata[4] = [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(range.e.r + 1)
            }
        ];
        tileroot.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(tiledata);
        var ty = $3ee4f50b1ae43a89$var$write_iwa_file(tx);
        var raw32 = $3ee4f50b1ae43a89$var$compress_iwa_file(ty);
        tentry.content = raw32;
        tentry.size = tentry.content.length;
    })();
    t.data = $3ee4f50b1ae43a89$var$write_shallow(tl);
    store[3][0].data = $3ee4f50b1ae43a89$var$write_shallow(tile);
    pb[4][0].data = $3ee4f50b1ae43a89$var$write_shallow(store);
    docroot.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(pb);
    var y = $3ee4f50b1ae43a89$var$write_iwa_file(x);
    var raw3 = $3ee4f50b1ae43a89$var$compress_iwa_file(y);
    entry.content = raw3;
    entry.size = entry.content.length;
    return cfb;
}
function $3ee4f50b1ae43a89$var$fix_opts_func(defaults /*:Array<Array<any> >*/ ) /*:{(o:any):void}*/ {
    return function fix_opts(opts) {
        for(var i = 0; i != defaults.length; ++i){
            var d = defaults[i];
            if (opts[d[0]] === undefined) opts[d[0]] = d[1];
            if (d[2] === "n") opts[d[0]] = Number(opts[d[0]]);
        }
    };
}
function $3ee4f50b1ae43a89$var$fix_read_opts(opts) {
    $3ee4f50b1ae43a89$var$fix_opts_func([
        [
            "cellNF",
            false
        ],
        /* emit cell number format string as .z */ [
            "cellHTML",
            true
        ],
        /* emit html string as .h */ [
            "cellFormula",
            true
        ],
        /* emit formulae as .f */ [
            "cellStyles",
            false
        ],
        /* emits style/theme as .s */ [
            "cellText",
            true
        ],
        /* emit formatted text as .w */ [
            "cellDates",
            false
        ],
        /* emit date cells with type `d` */ [
            "sheetStubs",
            false
        ],
        /* emit empty cells */ [
            "sheetRows",
            0,
            "n"
        ],
        /* read n rows (0 = read all rows) */ [
            "bookDeps",
            false
        ],
        /* parse calculation chains */ [
            "bookSheets",
            false
        ],
        /* only try to get sheet names (no Sheets) */ [
            "bookProps",
            false
        ],
        /* only try to get properties (no Sheets) */ [
            "bookFiles",
            false
        ],
        /* include raw file structure (keys, files, cfb) */ [
            "bookVBA",
            false
        ],
        /* include vba raw data (vbaraw) */ [
            "password",
            ""
        ],
        /* password */ [
            "WTF",
            false
        ]
    ])(opts);
}
function $3ee4f50b1ae43a89$var$fix_write_opts(opts) {
    $3ee4f50b1ae43a89$var$fix_opts_func([
        [
            "cellDates",
            false
        ],
        /* write date cells with type `d` */ [
            "bookSST",
            false
        ],
        /* Generate Shared String Table */ [
            "bookType",
            "xlsx"
        ],
        /* Type of workbook (xlsx/m/b) */ [
            "compression",
            false
        ],
        /* Use file compression */ [
            "WTF",
            false
        ]
    ])(opts);
}
function $3ee4f50b1ae43a89$var$get_sheet_type(n /*:string*/ ) /*:string*/ {
    if ($3ee4f50b1ae43a89$var$RELS.WS.indexOf(n) > -1) return "sheet";
    if ($3ee4f50b1ae43a89$var$RELS.CS && n == $3ee4f50b1ae43a89$var$RELS.CS) return "chart";
    if ($3ee4f50b1ae43a89$var$RELS.DS && n == $3ee4f50b1ae43a89$var$RELS.DS) return "dialog";
    if ($3ee4f50b1ae43a89$var$RELS.MS && n == $3ee4f50b1ae43a89$var$RELS.MS) return "macro";
    return n && n.length ? n : "sheet";
}
function $3ee4f50b1ae43a89$var$safe_parse_wbrels(wbrels, sheets) {
    if (!wbrels) return 0;
    try {
        wbrels = sheets.map(function pwbr(w) {
            if (!w.id) w.id = w.strRelID;
            return [
                w.name,
                wbrels["!id"][w.id].Target,
                $3ee4f50b1ae43a89$var$get_sheet_type(wbrels["!id"][w.id].Type)
            ];
        });
    } catch (e) {
        return null;
    }
    return !wbrels || wbrels.length === 0 ? null : wbrels;
}
function $3ee4f50b1ae43a89$var$safe_parse_sheet(zip, path /*:string*/ , relsPath /*:string*/ , sheet, idx /*:number*/ , sheetRels, sheets, stype /*:string*/ , opts, wb, themes, styles) {
    try {
        sheetRels[sheet] = $3ee4f50b1ae43a89$var$parse_rels($3ee4f50b1ae43a89$var$getzipstr(zip, relsPath, true), path);
        var data = $3ee4f50b1ae43a89$var$getzipdata(zip, path);
        var _ws;
        switch(stype){
            case "sheet":
                _ws = $3ee4f50b1ae43a89$var$parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case "chart":
                _ws = $3ee4f50b1ae43a89$var$parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                if (!_ws || !_ws["!drawel"]) break;
                var dfile = $3ee4f50b1ae43a89$var$resolve_path(_ws["!drawel"].Target, path);
                var drelsp = $3ee4f50b1ae43a89$var$get_rels_path(dfile);
                var draw = $3ee4f50b1ae43a89$var$parse_drawing($3ee4f50b1ae43a89$var$getzipstr(zip, dfile, true), $3ee4f50b1ae43a89$var$parse_rels($3ee4f50b1ae43a89$var$getzipstr(zip, drelsp, true), dfile));
                var chartp = $3ee4f50b1ae43a89$var$resolve_path(draw, dfile);
                var crelsp = $3ee4f50b1ae43a89$var$get_rels_path(chartp);
                _ws = $3ee4f50b1ae43a89$var$parse_chart($3ee4f50b1ae43a89$var$getzipstr(zip, chartp, true), chartp, opts, $3ee4f50b1ae43a89$var$parse_rels($3ee4f50b1ae43a89$var$getzipstr(zip, crelsp, true), chartp), wb, _ws);
                break;
            case "macro":
                _ws = $3ee4f50b1ae43a89$var$parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case "dialog":
                _ws = $3ee4f50b1ae43a89$var$parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            default:
                throw new Error("Unrecognized sheet type " + stype);
        }
        sheets[sheet] = _ws;
        /* scan rels for comments and threaded comments */ var tcomments = [];
        if (sheetRels && sheetRels[sheet]) $3ee4f50b1ae43a89$var$keys(sheetRels[sheet]).forEach(function(n) {
            var dfile = "";
            if (sheetRels[sheet][n].Type == $3ee4f50b1ae43a89$var$RELS.CMNT) {
                dfile = $3ee4f50b1ae43a89$var$resolve_path(sheetRels[sheet][n].Target, path);
                var comments = $3ee4f50b1ae43a89$var$parse_cmnt($3ee4f50b1ae43a89$var$getzipdata(zip, dfile, true), dfile, opts);
                if (!comments || !comments.length) return;
                $3ee4f50b1ae43a89$var$sheet_insert_comments(_ws, comments, false);
            }
            if (sheetRels[sheet][n].Type == $3ee4f50b1ae43a89$var$RELS.TCMNT) {
                dfile = $3ee4f50b1ae43a89$var$resolve_path(sheetRels[sheet][n].Target, path);
                tcomments = tcomments.concat($3ee4f50b1ae43a89$var$parse_tcmnt_xml($3ee4f50b1ae43a89$var$getzipdata(zip, dfile, true), opts));
            }
        });
        if (tcomments && tcomments.length) $3ee4f50b1ae43a89$var$sheet_insert_comments(_ws, tcomments, true, opts.people || []);
    } catch (e) {
        if (opts.WTF) throw e;
    }
}
function $3ee4f50b1ae43a89$var$strip_front_slash(x /*:string*/ ) /*:string*/ {
    return x.charAt(0) == "/" ? x.slice(1) : x;
}
function $3ee4f50b1ae43a89$export$b165387946f79a1(zip /*:ZIP*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $3ee4f50b1ae43a89$var$make_ssf();
    opts = opts || {};
    $3ee4f50b1ae43a89$var$fix_read_opts(opts);
    /* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */ if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, "META-INF/manifest.xml")) return $3ee4f50b1ae43a89$var$parse_ods(zip, opts);
    /* UOC */ if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, "objectdata.xml")) return $3ee4f50b1ae43a89$var$parse_ods(zip, opts);
    /* Numbers */ if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, "Index/Document.iwa")) {
        if (typeof Uint8Array == "undefined") throw new Error("NUMBERS file parsing requires Uint8Array support");
        if (typeof $3ee4f50b1ae43a89$var$parse_numbers_iwa != "undefined") {
            if (zip.FileIndex) return $3ee4f50b1ae43a89$var$parse_numbers_iwa(zip);
            var _zip = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_new();
            $3ee4f50b1ae43a89$var$zipentries(zip).forEach(function(e) {
                $3ee4f50b1ae43a89$var$zip_add_file(_zip, e, $3ee4f50b1ae43a89$var$getzipbin(zip, e));
            });
            return $3ee4f50b1ae43a89$var$parse_numbers_iwa(_zip);
        }
        throw new Error("Unsupported NUMBERS file");
    }
    if (!$3ee4f50b1ae43a89$var$safegetzipfile(zip, "[Content_Types].xml")) {
        if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, "index.xml.gz")) throw new Error("Unsupported NUMBERS 08 file");
        if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, "index.xml")) throw new Error("Unsupported NUMBERS 09 file");
        throw new Error("Unsupported ZIP file");
    }
    var entries = $3ee4f50b1ae43a89$var$zipentries(zip);
    var dir = $3ee4f50b1ae43a89$var$parse_ct($3ee4f50b1ae43a89$var$getzipstr(zip, "[Content_Types].xml"));
    var xlsb = false;
    var sheets, binname;
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.xml";
        if ($3ee4f50b1ae43a89$var$getzipdata(zip, binname, true)) dir.workbooks.push(binname);
    }
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.bin";
        if (!$3ee4f50b1ae43a89$var$getzipdata(zip, binname, true)) throw new Error("Could not find workbook");
        dir.workbooks.push(binname);
        xlsb = true;
    }
    if (dir.workbooks[0].slice(-3) == "bin") xlsb = true;
    var themes = {} /*:any*/ ;
    var styles = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) {
        $3ee4f50b1ae43a89$var$strs = [];
        if (dir.sst) try {
            $3ee4f50b1ae43a89$var$strs = $3ee4f50b1ae43a89$var$parse_sst($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.sst)), dir.sst, opts);
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (opts.cellStyles && dir.themes.length) themes = $3ee4f50b1ae43a89$var$parse_theme($3ee4f50b1ae43a89$var$getzipstr(zip, dir.themes[0].replace(/^\//, ""), true) || "", dir.themes[0], opts);
        if (dir.style) styles = $3ee4f50b1ae43a89$var$parse_sty($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.style)), dir.style, themes, opts);
    }
    /*var externbooks = */ dir.links.map(function(link) {
        try {
            var rels = $3ee4f50b1ae43a89$var$parse_rels($3ee4f50b1ae43a89$var$getzipstr(zip, $3ee4f50b1ae43a89$var$get_rels_path($3ee4f50b1ae43a89$var$strip_front_slash(link))), link);
            return $3ee4f50b1ae43a89$var$parse_xlink($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(link)), rels, link, opts);
        } catch (e) {}
    });
    var wb = $3ee4f50b1ae43a89$var$parse_wb($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
    var props = {}, propdata = "";
    if (dir.coreprops.length) {
        propdata = $3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.coreprops[0]), true);
        if (propdata) props = $3ee4f50b1ae43a89$var$parse_core_props(propdata);
        if (dir.extprops.length !== 0) {
            propdata = $3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.extprops[0]), true);
            if (propdata) $3ee4f50b1ae43a89$var$parse_ext_props(propdata, props, opts);
        }
    }
    var custprops = {};
    if (!opts.bookSheets || opts.bookProps) {
        if (dir.custprops.length !== 0) {
            propdata = $3ee4f50b1ae43a89$var$getzipstr(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.custprops[0]), true);
            if (propdata) custprops = $3ee4f50b1ae43a89$var$parse_cust_props(propdata, opts);
        }
    }
    var out = {} /*:any*/ ;
    if (opts.bookSheets || opts.bookProps) {
        if (wb.Sheets) sheets = wb.Sheets.map(function pluck(x) {
            return x.name;
        });
        else if (props.Worksheets && props.SheetNames.length > 0) sheets = props.SheetNames;
        if (opts.bookProps) {
            out.Props = props;
            out.Custprops = custprops;
        }
        if (opts.bookSheets && typeof sheets !== "undefined") out.SheetNames = sheets;
        if (opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
    }
    sheets = {};
    var deps = {};
    if (opts.bookDeps && dir.calcchain) deps = $3ee4f50b1ae43a89$var$parse_cc($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.calcchain)), dir.calcchain, opts);
    var i = 0;
    var sheetRels = {} /*:any*/ ;
    var path, relsPath;
    var wbsheets = wb.Sheets;
    props.Worksheets = wbsheets.length;
    props.SheetNames = [];
    for(var j = 0; j != wbsheets.length; ++j)props.SheetNames[j] = wbsheets[j].name;
    var wbext = xlsb ? "bin" : "xml";
    var wbrelsi = dir.workbooks[0].lastIndexOf("/");
    var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi + 1) + "_rels/" + dir.workbooks[0].slice(wbrelsi + 1) + ".rels").replace(/^\//, "");
    if (!$3ee4f50b1ae43a89$var$safegetzipfile(zip, wbrelsfile)) wbrelsfile = "xl/_rels/workbook." + wbext + ".rels";
    var wbrels = $3ee4f50b1ae43a89$var$parse_rels($3ee4f50b1ae43a89$var$getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
    if ((dir.metadata || []).length >= 1) /* TODO: MDX and other types of metadata */ opts.xlmeta = $3ee4f50b1ae43a89$var$parse_xlmeta($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.metadata[0])), dir.metadata[0], opts);
    if ((dir.people || []).length >= 1) opts.people = $3ee4f50b1ae43a89$var$parse_people_xml($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.people[0])), opts);
    if (wbrels) wbrels = $3ee4f50b1ae43a89$var$safe_parse_wbrels(wbrels, wb.Sheets);
    /* Numbers iOS hack */ var nmode = $3ee4f50b1ae43a89$var$getzipdata(zip, "xl/worksheets/sheet.xml", true) ? 1 : 0;
    wsloop: for(i = 0; i != props.Worksheets; ++i){
        var stype = "sheet";
        if (wbrels && wbrels[i]) {
            path = "xl/" + wbrels[i][1].replace(/[\/]?xl\//, "");
            if (!$3ee4f50b1ae43a89$var$safegetzipfile(zip, path)) path = wbrels[i][1];
            if (!$3ee4f50b1ae43a89$var$safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/, "") + wbrels[i][1];
            stype = wbrels[i][2];
        } else {
            path = "xl/worksheets/sheet" + (i + 1 - nmode) + "." + wbext;
            path = path.replace(/sheet0\./, "sheet.");
        }
        relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
        if (opts && opts.sheets != null) switch(typeof opts.sheets){
            case "number":
                if (i != opts.sheets) continue wsloop;
                break;
            case "string":
                if (props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop;
                break;
            default:
                if (Array.isArray && Array.isArray(opts.sheets)) {
                    var snjseen = false;
                    for(var snj = 0; snj != opts.sheets.length; ++snj){
                        if (typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen = 1;
                        if (typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
                    }
                    if (!snjseen) continue wsloop;
                }
        }
        $3ee4f50b1ae43a89$var$safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
    }
    out = {
        Directory: dir,
        Workbook: wb,
        Props: props,
        Custprops: custprops,
        Deps: deps,
        Sheets: sheets,
        SheetNames: props.SheetNames,
        Strings: $3ee4f50b1ae43a89$var$strs,
        Styles: styles,
        Themes: themes,
        SSF: $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt)
    } /*:any*/ ;
    if (opts && opts.bookFiles) {
        if (zip.files) {
            out.keys = entries;
            out.files = zip.files;
        } else {
            out.keys = [];
            out.files = {};
            zip.FullPaths.forEach(function(p, idx) {
                p = p.replace(/^Root Entry[\/]/, "");
                out.keys.push(p);
                out.files[p] = zip.FileIndex[idx];
            });
        }
    }
    if (opts && opts.bookVBA) {
        if (dir.vba.length > 0) out.vbaraw = $3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.vba[0]), true);
        else if (dir.defaults && dir.defaults.bin === $3ee4f50b1ae43a89$var$CT_VBA) out.vbaraw = $3ee4f50b1ae43a89$var$getzipdata(zip, "xl/vbaProject.bin", true);
    }
    return out;
}
/* [MS-OFFCRYPTO] 2.1.1 */ function $3ee4f50b1ae43a89$var$parse_xlsxcfb(cfb, _opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var opts = _opts || {};
    var f = "Workbook", data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
    try {
        f = "/!DataSpaces/Version";
        data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var version = */ $3ee4f50b1ae43a89$var$parse_DataSpaceVersionInfo(data.content);
        /* 2.3.4.1 */ f = "/!DataSpaces/DataSpaceMap";
        data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var dsm = $3ee4f50b1ae43a89$var$parse_DataSpaceMap(data.content);
        if (dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.2 */ f = "/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace";
        data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var seds = $3ee4f50b1ae43a89$var$parse_DataSpaceDefinition(data.content);
        if (seds.length != 1 || seds[0] != "StrongEncryptionTransform") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.3 */ f = "/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary";
        data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var hdr = */ $3ee4f50b1ae43a89$var$parse_Primary(data.content);
    } catch (e) {}
    f = "/EncryptionInfo";
    data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    var einfo = $3ee4f50b1ae43a89$var$parse_EncryptionInfo(data.content);
    /* 2.3.4.4 */ f = "/EncryptedPackage";
    data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    /*global decrypt_agile */ /*:: declare var decrypt_agile:any; */ if (einfo[0] == 0x04 && typeof decrypt_agile !== "undefined") return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
    /*global decrypt_std76 */ /*:: declare var decrypt_std76:any; */ if (einfo[0] == 0x02 && typeof decrypt_std76 !== "undefined") return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
    throw new Error("File is password-protected");
}
function $3ee4f50b1ae43a89$var$write_zip(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (opts.bookType == "ods") return $3ee4f50b1ae43a89$var$write_ods(wb, opts);
    if (opts.bookType == "numbers") return $3ee4f50b1ae43a89$var$write_numbers_iwa(wb, opts);
    if (opts.bookType == "xlsb") return $3ee4f50b1ae43a89$var$write_zip_xlsxb(wb, opts);
    return $3ee4f50b1ae43a89$var$write_zip_xlsx(wb, opts);
}
/* XLSX and XLSB writing are very similar.  Originally they were unified in one
   export function.  This is horrible for tree shaking in the common case (most
   applications need to export files in one format) so this function supports
   both formats while write_zip_xlsx only handles XLSX */ function $3ee4f50b1ae43a89$var$write_zip_xlsxb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    $3ee4f50b1ae43a89$var$_shapeid = 1024;
    if (wb && !wb.SSF) wb.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    if (wb && wb.SSF) {
        $3ee4f50b1ae43a89$var$make_ssf();
        $3ee4f50b1ae43a89$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $3ee4f50b1ae43a89$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($3ee4f50b1ae43a89$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
    var vbafmt = $3ee4f50b1ae43a89$var$VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = $3ee4f50b1ae43a89$var$new_ct();
    $3ee4f50b1ae43a89$var$fix_write_opts(opts = opts || {});
    var zip = $3ee4f50b1ae43a89$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 2, f, $3ee4f50b1ae43a89$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 3, f, $3ee4f50b1ae43a89$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $3ee4f50b1ae43a89$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.rels, 4, f, $3ee4f50b1ae43a89$var$RELS.CUST_PROPS);
    }
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            "!id": {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_ws(rId - 1, f, opts, wb, wsrels));
        ct.sheets.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $3ee4f50b1ae43a89$var$RELS.WS[0]);
        if (ws) {
            var comments = ws["!comments"];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                cf = "xl/comments" + rId + "." + wbext;
                $3ee4f50b1ae43a89$var$zip_add_file(zip, cf, $3ee4f50b1ae43a89$var$write_cmnt(comments, cf, opts));
                ct.comments.push(cf);
                $3ee4f50b1ae43a89$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $3ee4f50b1ae43a89$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws["!legacy"]) {
                if (need_vml) $3ee4f50b1ae43a89$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $3ee4f50b1ae43a89$var$write_comments_vml(rId, ws["!comments"]));
            }
            delete ws["!comments"];
            delete ws["!legacy"];
        }
        if (wsrels["!id"].rId1) $3ee4f50b1ae43a89$var$zip_add_file(zip, $3ee4f50b1ae43a89$var$get_rels_path(f), $3ee4f50b1ae43a89$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_sst(opts.Strings, f, opts));
        ct.strs.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $3ee4f50b1ae43a89$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_wb(wb, f, opts));
    ct.workbooks.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 1, f, $3ee4f50b1ae43a89$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_theme(wb.Themes, opts));
    ct.themes.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $3ee4f50b1ae43a89$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_sty(wb, f, opts));
    ct.styles.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "styles." + wbext, $3ee4f50b1ae43a89$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $3ee4f50b1ae43a89$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_xlmeta(f));
    ct.metadata.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $3ee4f50b1ae43a89$var$RELS.XLMETA);
    $3ee4f50b1ae43a89$var$zip_add_file(zip, "[Content_Types].xml", $3ee4f50b1ae43a89$var$write_ct(ct, opts));
    $3ee4f50b1ae43a89$var$zip_add_file(zip, "_rels/.rels", $3ee4f50b1ae43a89$var$write_rels(opts.rels));
    $3ee4f50b1ae43a89$var$zip_add_file(zip, "xl/_rels/workbook." + wbext + ".rels", $3ee4f50b1ae43a89$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $3ee4f50b1ae43a89$var$write_zip_xlsx(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    $3ee4f50b1ae43a89$var$_shapeid = 1024;
    if (wb && !wb.SSF) wb.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    if (wb && wb.SSF) {
        $3ee4f50b1ae43a89$var$make_ssf();
        $3ee4f50b1ae43a89$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $3ee4f50b1ae43a89$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($3ee4f50b1ae43a89$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "xml";
    var vbafmt = $3ee4f50b1ae43a89$var$VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = $3ee4f50b1ae43a89$var$new_ct();
    $3ee4f50b1ae43a89$var$fix_write_opts(opts = opts || {});
    var zip = $3ee4f50b1ae43a89$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 2, f, $3ee4f50b1ae43a89$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 3, f, $3ee4f50b1ae43a89$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $3ee4f50b1ae43a89$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.rels, 4, f, $3ee4f50b1ae43a89$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            "!id": {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_ws_xml(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $3ee4f50b1ae43a89$var$RELS.WS[0]);
        if (ws) {
            var comments = ws["!comments"];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + "." + wbext;
                    $3ee4f50b1ae43a89$var$zip_add_file(zip, cf, $3ee4f50b1ae43a89$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $3ee4f50b1ae43a89$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + "." + wbext, $3ee4f50b1ae43a89$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $3ee4f50b1ae43a89$var$zip_add_file(zip, cf, $3ee4f50b1ae43a89$var$write_comments_xml(comments, opts));
                ct.comments.push(cf);
                $3ee4f50b1ae43a89$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $3ee4f50b1ae43a89$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws["!legacy"]) {
                if (need_vml) $3ee4f50b1ae43a89$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $3ee4f50b1ae43a89$var$write_comments_vml(rId, ws["!comments"]));
            }
            delete ws["!comments"];
            delete ws["!legacy"];
        }
        if (wsrels["!id"].rId1) $3ee4f50b1ae43a89$var$zip_add_file(zip, $3ee4f50b1ae43a89$var$get_rels_path(f), $3ee4f50b1ae43a89$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_sst_xml(opts.Strings, opts));
        ct.strs.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $3ee4f50b1ae43a89$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_wb_xml(wb, opts));
    ct.workbooks.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 1, f, $3ee4f50b1ae43a89$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_theme(wb.Themes, opts));
    ct.themes.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $3ee4f50b1ae43a89$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_sty_xml(wb, opts));
    ct.styles.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "styles." + wbext, $3ee4f50b1ae43a89$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $3ee4f50b1ae43a89$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_xlmeta_xml());
    ct.metadata.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $3ee4f50b1ae43a89$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_people_xml(people, opts));
        ct.people.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "persons/person.xml", $3ee4f50b1ae43a89$var$RELS.PEOPLE);
    }
    $3ee4f50b1ae43a89$var$zip_add_file(zip, "[Content_Types].xml", $3ee4f50b1ae43a89$var$write_ct(ct, opts));
    $3ee4f50b1ae43a89$var$zip_add_file(zip, "_rels/.rels", $3ee4f50b1ae43a89$var$write_rels(opts.rels));
    $3ee4f50b1ae43a89$var$zip_add_file(zip, "xl/_rels/workbook." + wbext + ".rels", $3ee4f50b1ae43a89$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $3ee4f50b1ae43a89$var$firstbyte(f /*:RawData*/ , o /*:?TypeOpts*/ ) /*:Array<number>*/ {
    var x = "";
    switch((o || {}).type || "base64"){
        case "buffer":
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        case "base64":
            x = $3ee4f50b1ae43a89$var$Base64_decode(f.slice(0, 12));
            break;
        case "binary":
            x = f;
            break;
        case "array":
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        default:
            throw new Error("Unrecognized type " + (o && o.type || "undefined"));
    }
    return [
        x.charCodeAt(0),
        x.charCodeAt(1),
        x.charCodeAt(2),
        x.charCodeAt(3),
        x.charCodeAt(4),
        x.charCodeAt(5),
        x.charCodeAt(6),
        x.charCodeAt(7)
    ];
}
function $3ee4f50b1ae43a89$var$read_cfb(cfb /*:CFBContainer*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    if ($3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "EncryptedPackage")) return $3ee4f50b1ae43a89$var$parse_xlsxcfb(cfb, opts);
    return $3ee4f50b1ae43a89$export$b41972a043aba84c(cfb, opts);
}
function $3ee4f50b1ae43a89$var$read_zip(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var zip, d = data;
    var o = opts || {};
    if (!o.type) o.type = $3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    zip = $3ee4f50b1ae43a89$var$zip_read(d, o);
    return $3ee4f50b1ae43a89$export$b165387946f79a1(zip, o);
}
function $3ee4f50b1ae43a89$var$read_plaintext(data /*:string*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var i = 0;
    main: while(i < data.length)switch(data.charCodeAt(i)){
        case 0x0A:
        case 0x0D:
        case 0x20:
            ++i;
            break;
        case 0x3C:
            return $3ee4f50b1ae43a89$var$parse_xlml(data.slice(i), o);
        default:
            break main;
    }
    return $3ee4f50b1ae43a89$var$PRN.to_workbook(data, o);
}
function $3ee4f50b1ae43a89$var$read_plaintext_raw(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var str = "", bytes = $3ee4f50b1ae43a89$var$firstbyte(data, o);
    switch(o.type){
        case "base64":
            str = $3ee4f50b1ae43a89$var$Base64_decode(data);
            break;
        case "binary":
            str = data;
            break;
        case "buffer":
            str = data.toString("binary");
            break;
        case "array":
            str = $3ee4f50b1ae43a89$var$cc2str(data);
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $3ee4f50b1ae43a89$var$utf8read(str);
    o.type = "binary";
    return $3ee4f50b1ae43a89$var$read_plaintext(str, o);
}
function $3ee4f50b1ae43a89$var$read_utf16(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var d = data;
    if (o.type == "base64") d = $3ee4f50b1ae43a89$var$Base64_decode(d);
    d = $3ee4f50b1ae43a89$var$$cptable.utils.decode(1200, d.slice(2), "str");
    o.type = "binary";
    return $3ee4f50b1ae43a89$var$read_plaintext(d, o);
}
function $3ee4f50b1ae43a89$var$bstrify(data /*:string*/ ) /*:string*/ {
    return !data.match(/[^\x00-\x7F]/) ? data : $3ee4f50b1ae43a89$var$utf8write(data);
}
function $3ee4f50b1ae43a89$var$read_prn(data, d, o, str) {
    if (str) {
        o.type = "string";
        return $3ee4f50b1ae43a89$var$PRN.to_workbook(data, o);
    }
    return $3ee4f50b1ae43a89$var$PRN.to_workbook(d, o);
}
function $3ee4f50b1ae43a89$export$aafa59e2e03f2942(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $3ee4f50b1ae43a89$var$reset_cp();
    var o = opts || {};
    if (typeof ArrayBuffer !== "undefined" && data instanceof ArrayBuffer) return $3ee4f50b1ae43a89$export$aafa59e2e03f2942(new Uint8Array(data), (o = $3ee4f50b1ae43a89$var$dup(o), o.type = "array", o));
    if (typeof Uint8Array !== "undefined" && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
    var d = data, n = [
        0,
        0,
        0,
        0
    ], str = false;
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    $3ee4f50b1ae43a89$var$_ssfopts = {};
    if (o.dateNF) $3ee4f50b1ae43a89$var$_ssfopts.dateNF = o.dateNF;
    if (!o.type) o.type = $3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    if (o.type == "file") {
        o.type = $3ee4f50b1ae43a89$var$has_buf ? "buffer" : "binary";
        d = $3ee4f50b1ae43a89$var$read_binary(data);
        if (typeof Uint8Array !== "undefined" && !$3ee4f50b1ae43a89$var$has_buf) o.type = "array";
    }
    if (o.type == "string") {
        str = true;
        o.type = "binary";
        o.codepage = 65001;
        d = $3ee4f50b1ae43a89$var$bstrify(data);
    }
    if (o.type == "array" && typeof Uint8Array !== "undefined" && data instanceof Uint8Array && typeof ArrayBuffer !== "undefined") {
        // $FlowIgnore
        var ab = new ArrayBuffer(3), vu = new Uint8Array(ab);
        vu.foo = "bar";
        // $FlowIgnore
        if (!vu.foo) {
            o = $3ee4f50b1ae43a89$var$dup(o);
            o.type = "array";
            return $3ee4f50b1ae43a89$export$aafa59e2e03f2942($3ee4f50b1ae43a89$var$ab2a(d), o);
        }
    }
    switch((n = $3ee4f50b1ae43a89$var$firstbyte(d, o))[0]){
        case 0xD0:
            if (n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return $3ee4f50b1ae43a89$var$read_cfb($3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(d, o), o);
            break;
        case 0x09:
            if (n[1] <= 0x08) return $3ee4f50b1ae43a89$export$b41972a043aba84c(d, o);
            break;
        case 0x3C:
            return $3ee4f50b1ae43a89$var$parse_xlml(d, o);
        case 0x49:
            if (n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
            if (n[1] === 0x44) return $3ee4f50b1ae43a89$var$read_wb_ID(d, o);
            break;
        case 0x54:
            if (n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return $3ee4f50b1ae43a89$var$DIF.to_workbook(d, o);
            break;
        case 0x50:
            return n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09 ? $3ee4f50b1ae43a89$var$read_zip(d, o) : $3ee4f50b1ae43a89$var$read_prn(data, d, o, str);
        case 0xEF:
            return n[3] === 0x3C ? $3ee4f50b1ae43a89$var$parse_xlml(d, o) : $3ee4f50b1ae43a89$var$read_prn(data, d, o, str);
        case 0xFF:
            if (n[1] === 0xFE) return $3ee4f50b1ae43a89$var$read_utf16(d, o);
            else if (n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return $3ee4f50b1ae43a89$var$WK_.to_workbook(d, o);
            break;
        case 0x00:
            if (n[1] === 0x00) {
                if (n[2] >= 0x02 && n[3] === 0x00) return $3ee4f50b1ae43a89$var$WK_.to_workbook(d, o);
                if (n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return $3ee4f50b1ae43a89$var$WK_.to_workbook(d, o);
            }
            break;
        case 0x03:
        case 0x83:
        case 0x8B:
        case 0x8C:
            return $3ee4f50b1ae43a89$var$DBF.to_workbook(d, o);
        case 0x7B:
            if (n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return $3ee4f50b1ae43a89$var$RTF.to_workbook(d, o);
            break;
        case 0x0A:
        case 0x0D:
        case 0x20:
            return $3ee4f50b1ae43a89$var$read_plaintext_raw(d, o);
        case 0x89:
            if (n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet");
            break;
    }
    if ($3ee4f50b1ae43a89$var$DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return $3ee4f50b1ae43a89$var$DBF.to_workbook(d, o);
    return $3ee4f50b1ae43a89$var$read_prn(data, d, o, str);
}
function $3ee4f50b1ae43a89$export$72c04af63de9061a(filename /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var o = opts || {};
    o.type = "file";
    return $3ee4f50b1ae43a89$export$aafa59e2e03f2942(filename, o);
}
function $3ee4f50b1ae43a89$var$write_cfb_ctr(cfb /*:CFBContainer*/ , o /*:WriteOpts*/ ) /*:any*/ {
    switch(o.type){
        case "base64":
        case "binary":
            break;
        case "buffer":
        case "array":
            o.type = "";
            break;
        case "file":
            return $3ee4f50b1ae43a89$var$write_dl(o.file, $3ee4f50b1ae43a89$export$9f0e51cd97c572a.write(cfb, {
                type: $3ee4f50b1ae43a89$var$has_buf ? "buffer" : ""
            }));
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.write(cfb, o);
}
/*:: declare var encrypt_agile:any; */ function $3ee4f50b1ae43a89$var$write_zip_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $3ee4f50b1ae43a89$var$dup(opts || {});
    var z = $3ee4f50b1ae43a89$var$write_zip(wb, o);
    return $3ee4f50b1ae43a89$var$write_zip_denouement(z, o);
}
function $3ee4f50b1ae43a89$var$write_zip_typeXLSX(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $3ee4f50b1ae43a89$var$dup(opts || {});
    var z = $3ee4f50b1ae43a89$var$write_zip_xlsx(wb, o);
    return $3ee4f50b1ae43a89$var$write_zip_denouement(z, o);
}
function $3ee4f50b1ae43a89$var$write_zip_denouement(z /*:any*/ , o /*:?WriteOpts*/ ) /*:any*/ {
    var oopts = {};
    var ftype = $3ee4f50b1ae43a89$var$has_buf ? "nodebuffer" : typeof Uint8Array !== "undefined" ? "array" : "string";
    if (o.compression) oopts.compression = "DEFLATE";
    if (o.password) oopts.type = ftype;
    else switch(o.type){
        case "base64":
            oopts.type = "base64";
            break;
        case "binary":
            oopts.type = "string";
            break;
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        case "buffer":
        case "file":
            oopts.type = ftype;
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    var out = z.FullPaths ? $3ee4f50b1ae43a89$export$9f0e51cd97c572a.write(z, {
        fileType: "zip",
        type: /*::(*/ {
            "nodebuffer": "buffer",
            "string": "binary"
        } /*:: :any)*/ [oopts.type] || oopts.type,
        compression: !!o.compression
    }) : z.generate(oopts);
    if (typeof Deno !== "undefined") {
        if (typeof out == "string") {
            if (o.type == "binary" || o.type == "base64") return out;
            out = new Uint8Array($3ee4f50b1ae43a89$var$s2ab(out));
        }
    }
    /*jshint -W083 */ if (o.password && typeof encrypt_agile !== "undefined") return $3ee4f50b1ae43a89$var$write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
    /*jshint +W083 */ if (o.type === "file") return $3ee4f50b1ae43a89$var$write_dl(o.file, out);
    return o.type == "string" ? $3ee4f50b1ae43a89$var$utf8read(/*::(*/ out /*:: :any)*/ ) : out;
}
function $3ee4f50b1ae43a89$var$write_cfb_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = opts || {};
    var cfb /*:CFBContainer*/  = $3ee4f50b1ae43a89$var$write_xlscfb(wb, o);
    return $3ee4f50b1ae43a89$var$write_cfb_ctr(cfb, o);
}
function $3ee4f50b1ae43a89$var$write_string_type(out /*:string*/ , opts /*:WriteOpts*/ , bom /*:?string*/ ) /*:any*/ {
    if (!bom) bom = "";
    var o = bom + out;
    switch(opts.type){
        case "base64":
            return $3ee4f50b1ae43a89$var$Base64_encode($3ee4f50b1ae43a89$var$utf8write(o));
        case "binary":
            return $3ee4f50b1ae43a89$var$utf8write(o);
        case "string":
            return out;
        case "file":
            return $3ee4f50b1ae43a89$var$write_dl(opts.file, o, "utf8");
        case "buffer":
            if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$var$Buffer_from(o, "utf8");
            else if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
            else return $3ee4f50b1ae43a89$var$write_string_type(o, {
                type: "binary"
            }).split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $3ee4f50b1ae43a89$var$write_stxt_type(out /*:string*/ , opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "base64":
            return $3ee4f50b1ae43a89$var$Base64_encode(out);
        case "binary":
            return out;
        case "string":
            return out; /* override in sheet_to_txt */ 
        case "file":
            return $3ee4f50b1ae43a89$var$write_dl(opts.file, out, "binary");
        case "buffer":
            if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$var$Buffer_from(out, "binary");
            else return out.split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
/* TODO: test consistency */ function $3ee4f50b1ae43a89$var$write_binary_type(out, opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "string":
        case "base64":
        case "binary":
            var bstr = "";
            // $FlowIgnore
            for(var i = 0; i < out.length; ++i)bstr += String.fromCharCode(out[i]);
            return opts.type == "base64" ? $3ee4f50b1ae43a89$var$Base64_encode(bstr) : opts.type == "string" ? $3ee4f50b1ae43a89$var$utf8read(bstr) : bstr;
        case "file":
            return $3ee4f50b1ae43a89$var$write_dl(opts.file, out);
        case "buffer":
            return out;
        default:
            throw new Error("Unrecognized type " + opts.type);
    }
}
function $3ee4f50b1ae43a89$export$f6ca43591cb061b1(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $3ee4f50b1ae43a89$var$reset_cp();
    $3ee4f50b1ae43a89$var$check_wb(wb);
    var o = $3ee4f50b1ae43a89$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $3ee4f50b1ae43a89$export$f6ca43591cb061b1(wb, o);
        o.type = "array";
        return $3ee4f50b1ae43a89$var$s2ab(out);
    }
    return $3ee4f50b1ae43a89$var$write_zip_typeXLSX(wb, o);
}
function $3ee4f50b1ae43a89$export$68d8715fc104d294(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $3ee4f50b1ae43a89$var$reset_cp();
    $3ee4f50b1ae43a89$var$check_wb(wb);
    var o = $3ee4f50b1ae43a89$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $3ee4f50b1ae43a89$export$68d8715fc104d294(wb, o);
        o.type = "array";
        return $3ee4f50b1ae43a89$var$s2ab(out);
    }
    var idx = 0;
    if (o.sheet) {
        if (typeof o.sheet == "number") idx = o.sheet;
        else idx = wb.SheetNames.indexOf(o.sheet);
        if (!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + typeof o.sheet);
    }
    switch(o.bookType || "xlsb"){
        case "xml":
        case "xlml":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$write_xlml(wb, o), o);
        case "slk":
        case "sylk":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "htm":
        case "html":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "txt":
            return $3ee4f50b1ae43a89$var$write_stxt_type($3ee4f50b1ae43a89$var$sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "csv":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\uFEFF");
        case "dif":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "dbf":
            return $3ee4f50b1ae43a89$var$write_binary_type($3ee4f50b1ae43a89$var$DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "prn":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "rtf":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$RTF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "eth":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "fods":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$write_ods(wb, o), o);
        case "wk1":
            return $3ee4f50b1ae43a89$var$write_binary_type($3ee4f50b1ae43a89$var$WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "wk3":
            return $3ee4f50b1ae43a89$var$write_binary_type($3ee4f50b1ae43a89$var$WK_.book_to_wk3(wb, o), o);
        case "biff2":
            if (!o.biff) o.biff = 2; /* falls through */ 
        case "biff3":
            if (!o.biff) o.biff = 3; /* falls through */ 
        case "biff4":
            if (!o.biff) o.biff = 4;
            return $3ee4f50b1ae43a89$var$write_binary_type($3ee4f50b1ae43a89$var$write_biff_buf(wb, o), o);
        case "biff5":
            if (!o.biff) o.biff = 5; /* falls through */ 
        case "biff8":
        case "xla":
        case "xls":
            if (!o.biff) o.biff = 8;
            return $3ee4f50b1ae43a89$var$write_cfb_type(wb, o);
        case "xlsx":
        case "xlsm":
        case "xlam":
        case "xlsb":
        case "numbers":
        case "ods":
            return $3ee4f50b1ae43a89$var$write_zip_type(wb, o);
        default:
            throw new Error("Unrecognized bookType |" + o.bookType + "|");
    }
}
function $3ee4f50b1ae43a89$var$resolve_book_type(o /*:WriteFileOpts*/ ) {
    if (o.bookType) return;
    var _BT = {
        "xls": "biff8",
        "htm": "html",
        "slk": "sylk",
        "socialcalc": "eth",
        "Sh33tJS": "WTF"
    };
    var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
    if (ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
    o.bookType = _BT[o.bookType] || o.bookType;
}
function $3ee4f50b1ae43a89$export$552bfb764b5cd2b4(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = "file";
    o.file = filename;
    $3ee4f50b1ae43a89$var$resolve_book_type(o);
    return $3ee4f50b1ae43a89$export$68d8715fc104d294(wb, o);
}
function $3ee4f50b1ae43a89$export$40a06aea54ee074e(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = "file";
    o.file = filename;
    $3ee4f50b1ae43a89$var$resolve_book_type(o);
    return $3ee4f50b1ae43a89$export$f6ca43591cb061b1(wb, o);
}
function $3ee4f50b1ae43a89$export$25469296c4b8ebda(filename /*:string*/ , wb /*:Workbook*/ , opts /*:?WriteFileOpts*/ , cb /*:?(e?:ErrnoError)=>void*/ ) {
    var o = opts || {};
    o.type = "file";
    o.file = filename;
    $3ee4f50b1ae43a89$var$resolve_book_type(o);
    o.type = "buffer";
    var _cb = cb;
    if (!(_cb instanceof Function)) _cb = opts /*:any*/ ;
    return $3ee4f50b1ae43a89$var$_fs.writeFile(filename, $3ee4f50b1ae43a89$export$68d8715fc104d294(wb, o), _cb);
}
/*::
type MJRObject = {
	row: any;
	isempty: boolean;
};
*/ function $3ee4f50b1ae43a89$var$make_json_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , header /*:number*/ , hdr /*:Array<any>*/ , dense /*:boolean*/ , o /*:Sheet2JSONOpts*/ ) /*:MJRObject*/ {
    var rr = $3ee4f50b1ae43a89$var$encode_row(R);
    var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
    var isempty = true;
    var row /*:any*/  = header === 1 ? [] : {};
    if (header !== 1) {
        if (Object.defineProperty) try {
            Object.defineProperty(row, "__rowNum__", {
                value: R,
                enumerable: false
            });
        } catch (e) {
            row.__rowNum__ = R;
        }
        else row.__rowNum__ = R;
    }
    if (!dense || sheet[R]) for(var C = r.s.c; C <= r.e.c; ++C){
        var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
        if (val === undefined || val.t === undefined) {
            if (defval === undefined) continue;
            if (hdr[C] != null) row[hdr[C]] = defval;
            continue;
        }
        var v = val.v;
        switch(val.t){
            case "z":
                if (v == null) break;
                continue;
            case "e":
                v = v == 0 ? null : void 0;
                break;
            case "s":
            case "d":
            case "b":
            case "n":
                break;
            default:
                throw new Error("unrecognized type " + val.t);
        }
        if (hdr[C] != null) {
            if (v == null) {
                if (val.t == "e" && v === null) row[hdr[C]] = null;
                else if (defval !== undefined) row[hdr[C]] = defval;
                else if (raw && v === null) row[hdr[C]] = null;
                else continue;
            } else row[hdr[C]] = raw && (val.t !== "n" || val.t === "n" && o.rawNumbers !== false) ? v : $3ee4f50b1ae43a89$var$format_cell(val, v, o);
            if (v != null) isempty = false;
        }
    }
    return {
        row: row,
        isempty: isempty
    };
}
function $3ee4f50b1ae43a89$var$sheet_to_json(sheet /*:Worksheet*/ , opts /*:?Sheet2JSONOpts*/ ) {
    if (sheet == null || sheet["!ref"] == null) return [];
    var val = {
        t: "n",
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    else if (o.header == null) header = 0;
    switch(typeof range){
        case "string":
            r = $3ee4f50b1ae43a89$var$safe_decode_range(range);
            break;
        case "number":
            r = $3ee4f50b1ae43a89$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $3ee4f50b1ae43a89$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var out /*:Array<any>*/  = [];
    var outi = 0, counter = 0;
    var dense = Array.isArray(sheet);
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet[R]) sheet[R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
        val = dense ? sheet[R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val == null) val = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $3ee4f50b1ae43a89$var$format_cell(val, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    for(R = r.s.r + offset; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        var row = $3ee4f50b1ae43a89$var$make_json_row(sheet, r, R, cols, header, hdr, dense, o);
        if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
    }
    out.length = outi;
    return out;
}
var $3ee4f50b1ae43a89$var$qreg = /"/g;
function $3ee4f50b1ae43a89$var$make_csv_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , fs /*:number*/ , rs /*:number*/ , FS /*:string*/ , o /*:Sheet2CSVOpts*/ ) /*:?string*/ {
    var isempty = true;
    var row /*:Array<string>*/  = [], txt = "", rr = $3ee4f50b1ae43a89$var$encode_row(R);
    for(var C = r.s.c; C <= r.e.c; ++C){
        if (!cols[C]) continue;
        var val = o.dense ? (sheet[R] || [])[C] : sheet[cols[C] + rr];
        if (val == null) txt = "";
        else if (val.v != null) {
            isempty = false;
            txt = "" + (o.rawNumbers && val.t == "n" ? val.v : $3ee4f50b1ae43a89$var$format_cell(val, null, o));
            for(var i = 0, cc = 0; i !== txt.length; ++i)if ((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {
                txt = '"' + txt.replace($3ee4f50b1ae43a89$var$qreg, '""') + '"';
                break;
            }
            if (txt == "ID") txt = '"ID"';
        } else if (val.f != null && !val.F) {
            isempty = false;
            txt = "=" + val.f;
            if (txt.indexOf(",") >= 0) txt = '"' + txt.replace($3ee4f50b1ae43a89$var$qreg, '""') + '"';
        } else txt = "";
        /* NOTE: Excel CSV does not support array formulae */ row.push(txt);
    }
    if (o.blankrows === false && isempty) return null;
    return row.join(FS);
}
function $3ee4f50b1ae43a89$var$sheet_to_csv(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) return "";
    var r = $3ee4f50b1ae43a89$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var endregex = new RegExp((FS == "|" ? "\\|" : FS) + "+$");
    var row = "", cols /*:Array<string>*/  = [];
    o.dense = Array.isArray(sheet);
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
    var w = 0;
    for(var R = r.s.r; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        row = $3ee4f50b1ae43a89$var$make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
        if (row == null) continue;
        if (o.strip) row = row.replace(endregex, "");
        if (row || o.blankrows !== false) out.push((w++ ? RS : "") + row);
    }
    delete o.dense;
    return out.join("");
}
function $3ee4f50b1ae43a89$var$sheet_to_txt(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    if (!opts) opts = {};
    opts.FS = "	";
    opts.RS = "\n";
    var s = $3ee4f50b1ae43a89$var$sheet_to_csv(sheet, opts);
    if (typeof $3ee4f50b1ae43a89$var$$cptable == "undefined" || opts.type == "string") return s;
    var o = $3ee4f50b1ae43a89$var$$cptable.utils.encode(1200, s, "str");
    return String.fromCharCode(255) + String.fromCharCode(254) + o;
}
function $3ee4f50b1ae43a89$var$sheet_to_formulae(sheet /*:Worksheet*/ ) /*:Array<string>*/ {
    var y = "", x, val = "";
    if (sheet == null || sheet["!ref"] == null) return [];
    var r = $3ee4f50b1ae43a89$var$safe_decode_range(sheet["!ref"]), rr = "", cols /*:Array<string>*/  = [], C;
    var cmds /*:Array<string>*/  = [];
    var dense = Array.isArray(sheet);
    for(C = r.s.c; C <= r.e.c; ++C)cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
    for(var R = r.s.r; R <= r.e.r; ++R){
        rr = $3ee4f50b1ae43a89$var$encode_row(R);
        for(C = r.s.c; C <= r.e.c; ++C){
            y = cols[C] + rr;
            x = dense ? (sheet[R] || [])[C] : sheet[y];
            val = "";
            if (x === undefined) continue;
            else if (x.F != null) {
                y = x.F;
                if (!x.f) continue;
                val = x.f;
                if (y.indexOf(":") == -1) y = y + ":" + y;
            }
            if (x.f != null) val = x.f;
            else if (x.t == "z") continue;
            else if (x.t == "n" && x.v != null) val = "" + x.v;
            else if (x.t == "b") val = x.v ? "TRUE" : "FALSE";
            else if (x.w !== undefined) val = "'" + x.w;
            else if (x.v === undefined) continue;
            else if (x.t == "s") val = "'" + x.v;
            else val = "" + x.v;
            cmds[cmds.length] = y + "=" + val;
        }
    }
    return cmds;
}
function $3ee4f50b1ae43a89$var$sheet_add_json(_ws /*:?Worksheet*/ , js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    var o = opts || {};
    var offset = +!o.skipHeader;
    var ws /*:Worksheet*/  = _ws || {} /*:any*/ ;
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == "number") _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $3ee4f50b1ae43a89$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var cell /*:Cell*/ ;
    var range /*:Range*/  = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: _C,
            r: _R + js.length - 1 + offset
        }
    } /*:any*/ ;
    if (ws["!ref"]) {
        var _range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]);
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) {
            _R = _range.e.r + 1;
            range.e.r = _R + js.length - 1 + offset;
        }
    } else if (_R == -1) {
        _R = 0;
        range.e.r = js.length - 1 + offset;
    }
    var hdr /*:Array<string>*/  = o.header || [], C = 0;
    js.forEach(function(JS, R /*:number*/ ) {
        $3ee4f50b1ae43a89$var$keys(JS).forEach(function(k) {
            if ((C = hdr.indexOf(k)) == -1) hdr[C = hdr.length] = k;
            var v = JS[k];
            var t = "z";
            var z = "";
            var ref = $3ee4f50b1ae43a89$var$encode_cell({
                c: _C + C,
                r: _R + R + offset
            });
            cell = $3ee4f50b1ae43a89$var$ws_get_cell_stub(ws, ref);
            if (v && typeof v === "object" && !(v instanceof Date)) ws[ref] = v;
            else {
                if (typeof v == "number") t = "n";
                else if (typeof v == "boolean") t = "b";
                else if (typeof v == "string") t = "s";
                else if (v instanceof Date) {
                    t = "d";
                    if (!o.cellDates) {
                        t = "n";
                        v = $3ee4f50b1ae43a89$var$datenum(v);
                    }
                    z = o.dateNF || $3ee4f50b1ae43a89$var$table_fmt[14];
                } else if (v === null && o.nullError) {
                    t = "e";
                    v = 0;
                }
                if (!cell) ws[ref] = cell = {
                    t: t,
                    v: v
                } /*:any*/ ;
                else {
                    cell.t = t;
                    cell.v = v;
                    delete cell.w;
                    delete cell.R;
                    if (z) cell.z = z;
                }
                if (z) cell.z = z;
            }
        });
    });
    range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
    var __R = $3ee4f50b1ae43a89$var$encode_row(_R);
    if (offset) for(C = 0; C < hdr.length; ++C)ws[$3ee4f50b1ae43a89$var$encode_col(C + _C) + __R] = {
        t: "s",
        v: hdr[C]
    };
    ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
    return ws;
}
function $3ee4f50b1ae43a89$var$json_to_sheet(js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    return $3ee4f50b1ae43a89$var$sheet_add_json(null, js, opts);
}
/* get cell, creating a stub if necessary */ function $3ee4f50b1ae43a89$var$ws_get_cell_stub(ws /*:Worksheet*/ , R, C /*:?number*/ ) /*:Cell*/ {
    /* A1 cell address */ if (typeof R == "string") {
        /* dense */ if (Array.isArray(ws)) {
            var RC = $3ee4f50b1ae43a89$var$decode_cell(R);
            if (!ws[RC.r]) ws[RC.r] = [];
            return ws[RC.r][RC.c] || (ws[RC.r][RC.c] = {
                t: "z"
            });
        }
        return ws[R] || (ws[R] = {
            t: "z"
        });
    }
    /* cell address object */ if (typeof R != "number") return $3ee4f50b1ae43a89$var$ws_get_cell_stub(ws, $3ee4f50b1ae43a89$var$encode_cell(R));
    /* R and C are 0-based indices */ return $3ee4f50b1ae43a89$var$ws_get_cell_stub(ws, $3ee4f50b1ae43a89$var$encode_cell({
        r: R,
        c: C || 0
    }));
}
/* find sheet index for given name / validate index */ function $3ee4f50b1ae43a89$var$wb_sheet_idx(wb /*:Workbook*/ , sh /*:number|string*/ ) {
    if (typeof sh == "number") {
        if (sh >= 0 && wb.SheetNames.length > sh) return sh;
        throw new Error("Cannot find sheet # " + sh);
    } else if (typeof sh == "string") {
        var idx = wb.SheetNames.indexOf(sh);
        if (idx > -1) return idx;
        throw new Error("Cannot find sheet name |" + sh + "|");
    } else throw new Error("Cannot find sheet |" + sh + "|");
}
/* simple blank workbook object */ function $3ee4f50b1ae43a89$var$book_new() /*:Workbook*/ {
    return {
        SheetNames: [],
        Sheets: {}
    };
}
/* add a worksheet to the end of a given workbook */ function $3ee4f50b1ae43a89$var$book_append_sheet(wb /*:Workbook*/ , ws /*:Worksheet*/ , name /*:?string*/ , roll /*:?boolean*/ ) /*:string*/ {
    var i = 1;
    if (!name) {
        for(; i <= 0xFFFF; ++i, name = undefined)if (wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
    }
    if (!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
    if (roll && wb.SheetNames.indexOf(name) >= 0) {
        var m = name.match(/(^.*?)(\d+)$/);
        i = m && +m[2] || 0;
        var root = m && m[1] || name;
        for(++i; i <= 0xFFFF; ++i)if (wb.SheetNames.indexOf(name = root + i) == -1) break;
    }
    $3ee4f50b1ae43a89$var$check_ws_name(name);
    if (wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
    wb.SheetNames.push(name);
    wb.Sheets[name] = ws;
    return name;
}
/* set sheet visibility (visible/hidden/very hidden) */ function $3ee4f50b1ae43a89$var$book_set_sheet_visibility(wb /*:Workbook*/ , sh /*:number|string*/ , vis /*:number*/ ) {
    if (!wb.Workbook) wb.Workbook = {};
    if (!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
    var idx = $3ee4f50b1ae43a89$var$wb_sheet_idx(wb, sh);
    // $FlowIgnore
    if (!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
    switch(vis){
        case 0:
        case 1:
        case 2:
            break;
        default:
            throw new Error("Bad sheet visibility setting " + vis);
    }
    // $FlowIgnore
    wb.Workbook.Sheets[idx].Hidden = vis;
}
/* set number format */ function $3ee4f50b1ae43a89$var$cell_set_number_format(cell /*:Cell*/ , fmt /*:string|number*/ ) {
    cell.z = fmt;
    return cell;
}
/* set cell hyperlink */ function $3ee4f50b1ae43a89$var$cell_set_hyperlink(cell /*:Cell*/ , target /*:string*/ , tooltip /*:?string*/ ) {
    if (!target) delete cell.l;
    else {
        cell.l = {
            Target: target
        } /*:Hyperlink*/ ;
        if (tooltip) cell.l.Tooltip = tooltip;
    }
    return cell;
}
function $3ee4f50b1ae43a89$var$cell_set_internal_link(cell /*:Cell*/ , range /*:string*/ , tooltip /*:?string*/ ) {
    return $3ee4f50b1ae43a89$var$cell_set_hyperlink(cell, "#" + range, tooltip);
}
/* add to cell comments */ function $3ee4f50b1ae43a89$var$cell_add_comment(cell /*:Cell*/ , text /*:string*/ , author /*:?string*/ ) {
    if (!cell.c) cell.c = [];
    cell.c.push({
        t: text,
        a: author || "SheetJS"
    });
}
/* set array formula and flush related cells */ function $3ee4f50b1ae43a89$var$sheet_set_array_formula(ws /*:Worksheet*/ , range, formula /*:string*/ , dynamic /*:boolean*/ ) {
    var rng = typeof range != "string" ? range : $3ee4f50b1ae43a89$var$safe_decode_range(range);
    var rngstr = typeof range == "string" ? range : $3ee4f50b1ae43a89$var$encode_range(range);
    for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
        var cell = $3ee4f50b1ae43a89$var$ws_get_cell_stub(ws, R, C);
        cell.t = "n";
        cell.F = rngstr;
        delete cell.v;
        if (R == rng.s.r && C == rng.s.c) {
            cell.f = formula;
            if (dynamic) cell.D = true;
        }
    }
    return ws;
}
var $3ee4f50b1ae43a89$export$eab97d15b1788b8d /*:any*/  = {
    encode_col: $3ee4f50b1ae43a89$var$encode_col,
    encode_row: $3ee4f50b1ae43a89$var$encode_row,
    encode_cell: $3ee4f50b1ae43a89$var$encode_cell,
    encode_range: $3ee4f50b1ae43a89$var$encode_range,
    decode_col: $3ee4f50b1ae43a89$var$decode_col,
    decode_row: $3ee4f50b1ae43a89$var$decode_row,
    split_cell: $3ee4f50b1ae43a89$var$split_cell,
    decode_cell: $3ee4f50b1ae43a89$var$decode_cell,
    decode_range: $3ee4f50b1ae43a89$var$decode_range,
    format_cell: $3ee4f50b1ae43a89$var$format_cell,
    sheet_add_aoa: $3ee4f50b1ae43a89$var$sheet_add_aoa,
    sheet_add_json: $3ee4f50b1ae43a89$var$sheet_add_json,
    sheet_add_dom: $3ee4f50b1ae43a89$var$sheet_add_dom,
    aoa_to_sheet: $3ee4f50b1ae43a89$var$aoa_to_sheet,
    json_to_sheet: $3ee4f50b1ae43a89$var$json_to_sheet,
    table_to_sheet: $3ee4f50b1ae43a89$var$parse_dom_table,
    table_to_book: $3ee4f50b1ae43a89$var$table_to_book,
    sheet_to_csv: $3ee4f50b1ae43a89$var$sheet_to_csv,
    sheet_to_txt: $3ee4f50b1ae43a89$var$sheet_to_txt,
    sheet_to_json: $3ee4f50b1ae43a89$var$sheet_to_json,
    sheet_to_html: $3ee4f50b1ae43a89$var$sheet_to_html,
    sheet_to_formulae: $3ee4f50b1ae43a89$var$sheet_to_formulae,
    sheet_to_row_object_array: $3ee4f50b1ae43a89$var$sheet_to_json,
    sheet_get_cell: $3ee4f50b1ae43a89$var$ws_get_cell_stub,
    book_new: $3ee4f50b1ae43a89$var$book_new,
    book_append_sheet: $3ee4f50b1ae43a89$var$book_append_sheet,
    book_set_sheet_visibility: $3ee4f50b1ae43a89$var$book_set_sheet_visibility,
    cell_set_number_format: $3ee4f50b1ae43a89$var$cell_set_number_format,
    cell_set_hyperlink: $3ee4f50b1ae43a89$var$cell_set_hyperlink,
    cell_set_internal_link: $3ee4f50b1ae43a89$var$cell_set_internal_link,
    cell_add_comment: $3ee4f50b1ae43a89$var$cell_add_comment,
    sheet_set_array_formula: $3ee4f50b1ae43a89$var$sheet_set_array_formula,
    consts: {
        SHEET_VISIBLE: 0,
        SHEET_HIDDEN: 1,
        SHEET_VERY_HIDDEN: 2
    }
};
var $3ee4f50b1ae43a89$var$_Readable;
function $3ee4f50b1ae43a89$var$set_readable(R) {
    $3ee4f50b1ae43a89$var$_Readable = R;
}
function $3ee4f50b1ae43a89$var$write_csv_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $3ee4f50b1ae43a89$var$_Readable();
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var r = $3ee4f50b1ae43a89$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var endregex = new RegExp((FS == "|" ? "\\|" : FS) + "+$");
    var row /*:?string*/  = "", cols /*:Array<string>*/  = [];
    o.dense = Array.isArray(sheet);
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
    var R = r.s.r;
    var BOM = false, w = 0;
    stream._read = function() {
        if (!BOM) {
            BOM = true;
            return stream.push("\uFEFF");
        }
        while(R <= r.e.r){
            ++R;
            if ((rowinfo[R - 1] || {}).hidden) continue;
            row = $3ee4f50b1ae43a89$var$make_csv_row(sheet, r, R - 1, cols, fs, rs, FS, o);
            if (row != null) {
                if (o.strip) row = row.replace(endregex, "");
                if (row || o.blankrows !== false) return stream.push((w++ ? RS : "") + row);
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $3ee4f50b1ae43a89$var$write_html_stream(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/ ) {
    var stream = $3ee4f50b1ae43a89$var$_Readable();
    var o = opts || {};
    var header = o.header != null ? o.header : $3ee4f50b1ae43a89$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $3ee4f50b1ae43a89$var$HTML_END;
    stream.push(header);
    var r = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
    o.dense = Array.isArray(ws);
    stream.push($3ee4f50b1ae43a89$var$make_html_preamble(ws, r, o));
    var R = r.s.r;
    var end = false;
    stream._read = function() {
        if (R > r.e.r) {
            if (!end) {
                end = true;
                stream.push("</table>" + footer);
            }
            return stream.push(null);
        }
        while(R <= r.e.r){
            stream.push($3ee4f50b1ae43a89$var$make_html_row(ws, r, R, o));
            ++R;
            break;
        }
    };
    return stream;
}
function $3ee4f50b1ae43a89$var$write_json_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $3ee4f50b1ae43a89$var$_Readable({
        objectMode: true
    });
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var val = {
        t: "n",
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    switch(typeof range){
        case "string":
            r = $3ee4f50b1ae43a89$var$safe_decode_range(range);
            break;
        case "number":
            r = $3ee4f50b1ae43a89$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $3ee4f50b1ae43a89$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var counter = 0;
    var dense = Array.isArray(sheet);
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet[R]) sheet[R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
        val = dense ? sheet[R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val == null) val = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $3ee4f50b1ae43a89$var$format_cell(val, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    R = r.s.r + offset;
    stream._read = function() {
        while(R <= r.e.r){
            if ((rowinfo[R - 1] || {}).hidden) continue;
            var row = $3ee4f50b1ae43a89$var$make_json_row(sheet, r, R, cols, header, hdr, dense, o);
            ++R;
            if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
                stream.push(row.row);
                return;
            }
        }
        return stream.push(null);
    };
    return stream;
}
var $3ee4f50b1ae43a89$export$4938110305e6185f = {
    to_json: $3ee4f50b1ae43a89$var$write_json_stream,
    to_html: $3ee4f50b1ae43a89$var$write_html_stream,
    to_csv: $3ee4f50b1ae43a89$var$write_csv_stream,
    set_readable: $3ee4f50b1ae43a89$var$set_readable
};
const $3ee4f50b1ae43a89$export$83d89fbfd8236492 = $3ee4f50b1ae43a89$var$XLSX.version;

});
parcelRegister("5Io6y", function(module, exports) {
"use strict";

});



parcelRegister("ereuo", function(module, exports) {
/*! ics.js Wed Aug 20 2014 17:23:02 */ // prettier-ignore
// eslint-disable-next-line
var $a82ed3919474b801$var$saveAs = $a82ed3919474b801$var$saveAs || function(e) {
    "use strict";
    if (typeof e === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) return;
    var t = e.document, n = function() {
        return e.URL || e.webkitURL || e;
    }, r = t.createElementNS("http://www.w3.org/1999/xhtml", "a"), o = "download" in r, a = function(e) {
        var t = new MouseEvent("click");
        e.dispatchEvent(t);
    }, i = /constructor/i.test(e.HTMLElement) || e.safari, f = /CriOS\/[\d]+/.test(navigator.userAgent), u = function(t) {
        (e.setImmediate || e.setTimeout)(function() {
            throw t;
        }, 0);
    }, s = "application/octet-stream", d = 40000, c = function(e) {
        var t = function() {
            if (typeof e === "string") n().revokeObjectURL(e);
            else e.remove();
        };
        setTimeout(t, d);
    }, l = function(e, t, n) {
        t = [].concat(t);
        var r = t.length;
        while(r--){
            var o = e["on" + t[r]];
            if (typeof o === "function") try {
                o.call(e, n || e);
            } catch (a) {
                u(a);
            }
        }
    }, p = function(e) {
        if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type)) return new Blob([
            String.fromCharCode(65279),
            e
        ], {
            type: e.type
        });
        return e;
    }, v = function(t, u, d) {
        if (!d) t = p(t);
        var v = this, w = t.type, m = w === s, y, h = function() {
            l(v, "writestart progress write writeend".split(" "));
        }, S = function() {
            if ((f || m && i) && e.FileReader) {
                var r = new FileReader;
                r.onloadend = function() {
                    var t = f ? r.result : r.result.replace(/^data:[^;]*;/, "data:attachment/file;");
                    var n = e.open(t, "_blank");
                    if (!n) e.location.href = t;
                    t = undefined;
                    v.readyState = v.DONE;
                    h();
                };
                r.readAsDataURL(t);
                v.readyState = v.INIT;
                return;
            }
            if (!y) y = n().createObjectURL(t);
            if (m) e.location.href = y;
            else {
                var o = e.open(y, "_blank");
                if (!o) e.location.href = y;
            }
            v.readyState = v.DONE;
            h();
            c(y);
        };
        v.readyState = v.INIT;
        if (o) {
            y = n().createObjectURL(t);
            setTimeout(function() {
                r.href = y;
                r.download = u;
                a(r);
                h();
                c(y);
                v.readyState = v.DONE;
            });
            return;
        }
        S();
    }, w = v.prototype, m = function(e, t, n) {
        return new v(e, t || e.name || "download", n);
    };
    if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) return function(e, t, n) {
        t = t || e.name || "download";
        if (!n) e = p(e);
        return navigator.msSaveOrOpenBlob(e, t);
    };
    w.abort = function() {};
    w.readyState = w.INIT = 0;
    w.WRITING = 1;
    w.DONE = 2;
    w.error = w.onwritestart = w.onprogress = w.onwrite = w.onabort = w.onerror = w.onwriteend = null;
    return m;
}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || module.exports.content);
// prettier-ignore
if (0, module.exports) module.exports.saveAs = $a82ed3919474b801$var$saveAs;
else if (typeof define !== "undefined" && define !== null && define.amd !== null) define("FileSaver.js", function() {
    return $a82ed3919474b801$var$saveAs;
});
// prettier-ignore
// eslint-disable-next-line
var $a82ed3919474b801$var$ics = function(e, t) {
    "use strict";
    if (!(navigator.userAgent.indexOf("MSIE") > -1 && -1 == navigator.userAgent.indexOf("MSIE 10"))) {
        void 0 === e && (e = "default"), void 0 === t && (t = "Calendar");
        var r = -1 !== navigator.appVersion.indexOf("Win") ? "\r\n" : "\n", n = [], i = [
            "BEGIN:VCALENDAR",
            "PRODID:" + t,
            "VERSION:2.0"
        ].join(r), o = r + "END:VCALENDAR", a = [
            "SU",
            "MO",
            "TU",
            "WE",
            "TH",
            "FR",
            "SA"
        ];
        return {
            events: function() {
                return n;
            },
            calendar: function() {
                return i + r + n.join(r) + o;
            },
            addEvent: function(t, i, o, l, u, s) {
                if (void 0 === t || void 0 === i || void 0 === o || void 0 === l || void 0 === u) return !1;
                if (s && !s.rrule) {
                    if ("YEARLY" !== s.freq && "MONTHLY" !== s.freq && "WEEKLY" !== s.freq && "DAILY" !== s.freq) throw "Recurrence rrule frequency must be provided and be one of the following: 'YEARLY', 'MONTHLY', 'WEEKLY', or 'DAILY'";
                    if (s.until && isNaN(Date.parse(s.until))) throw "Recurrence rrule 'until' must be a valid date string";
                    if (s.interval && isNaN(parseInt(s.interval))) throw "Recurrence rrule 'interval' must be an integer";
                    if (s.count && isNaN(parseInt(s.count))) throw "Recurrence rrule 'count' must be an integer";
                    if (void 0 !== s.byday) {
                        if ("[object Array]" !== Object.prototype.toString.call(s.byday)) throw "Recurrence rrule 'byday' must be an array";
                        if (s.byday.length > 7) throw "Recurrence rrule 'byday' array must not be longer than the 7 days in a week";
                        s.byday = s.byday.filter(function(e, t) {
                            return s.byday.indexOf(e) == t;
                        });
                        for(var c in s.byday)if (a.indexOf(s.byday[c]) < 0) throw "Recurrence rrule 'byday' values must include only the following: 'SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'";
                    }
                }
                var g = new Date(l), d = new Date(u), f = new Date, S = ("0000" + g.getFullYear().toString()).slice(-4), E = ("00" + (g.getMonth() + 1).toString()).slice(-2), v = ("00" + g.getDate().toString()).slice(-2), y = ("00" + g.getHours().toString()).slice(-2), A = ("00" + g.getMinutes().toString()).slice(-2), T = ("00" + g.getSeconds().toString()).slice(-2), b = ("0000" + d.getFullYear().toString()).slice(-4), D = ("00" + (d.getMonth() + 1).toString()).slice(-2), N = ("00" + d.getDate().toString()).slice(-2), h = ("00" + d.getHours().toString()).slice(-2), I = ("00" + d.getMinutes().toString()).slice(-2), R = ("00" + d.getMinutes().toString()).slice(-2), M = ("0000" + f.getFullYear().toString()).slice(-4), w = ("00" + (f.getMonth() + 1).toString()).slice(-2), L = ("00" + f.getDate().toString()).slice(-2), O = ("00" + f.getHours().toString()).slice(-2), p = ("00" + f.getMinutes().toString()).slice(-2), Y = ("00" + f.getMinutes().toString()).slice(-2), U = "", V = "";
                y + A + T + h + I + R != 0 && (U = "T" + y + A + T, V = "T" + h + I + R);
                var B, C = S + E + v + U, j = b + D + N + V, m = M + w + L + ("T" + O + p + Y);
                if (s) {
                    if (s.rrule) B = s.rrule;
                    else {
                        if (B = "rrule:FREQ=" + s.freq, s.until) {
                            var x = new Date(Date.parse(s.until)).toISOString();
                            B += ";UNTIL=" + x.substring(0, x.length - 13).replace(/[-]/g, "") + "000000Z";
                        }
                        s.interval && (B += ";INTERVAL=" + s.interval), s.count && (B += ";COUNT=" + s.count), s.byday && s.byday.length > 0 && (B += ";BYDAY=" + s.byday.join(","));
                    }
                }
                (new Date).toISOString();
                var H = [
                    "BEGIN:VEVENT",
                    "UID:" + n.length + "@" + e,
                    "CLASS:PUBLIC",
                    "DESCRIPTION:" + i,
                    "DTSTAMP;VALUE=DATE-TIME:" + m,
                    "DTSTART;VALUE=DATE-TIME:" + C,
                    "DTEND;VALUE=DATE-TIME:" + j,
                    "LOCATION:" + o,
                    "SUMMARY;LANGUAGE=en-us:" + t,
                    "TRANSP:TRANSPARENT",
                    "END:VEVENT"
                ];
                return B && H.splice(4, 0, B), H = H.join(r), n.push(H), H;
            },
            download: function(e, t) {
                if (n.length < 1) return !1;
                t = void 0 !== t ? t : ".ics", e = void 0 !== e ? e : "calendar";
                var a, l = i + r + n.join(r) + o;
                if (-1 === navigator.userAgent.indexOf("MSIE 10")) a = new Blob([
                    l
                ]);
                else {
                    var u = new BlobBuilder;
                    u.append(l), a = u.getBlob("text/x-vCalendar;charset=" + document.characterSet);
                }
                return $a82ed3919474b801$var$saveAs(a, e + t), l;
            },
            build: function() {
                return !(n.length < 1) && i + r + n.join(r) + o;
            }
        };
    }
    console.log("Unsupported Browser");
};
module.exports = {
    ics: $a82ed3919474b801$var$ics
};

});

parcelRegister("e4eIN", function(module, exports) {

$parcel$export(module.exports, "MuiPickersAdapterContext", function () { return $a3dcdbc64884a405$export$544976378534cf9; });
$parcel$export(module.exports, "LocalizationProvider", function () { return $a3dcdbc64884a405$export$dc45bdc734ce6f1e; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $cNBED = parcelRequire("cNBED");

var $i71fw = parcelRequire("i71fw");

var $ih19M = parcelRequire("ih19M");
const $a3dcdbc64884a405$export$544976378534cf9 = /*#__PURE__*/ $bh6RR.createContext(null);
let $a3dcdbc64884a405$var$warnedOnce = false;
function $a3dcdbc64884a405$export$dc45bdc734ce6f1e(inProps) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiLocalizationProvider"
    });
    const { children: children, dateAdapter: Utils, dateFormats: dateFormats, dateLibInstance: dateLibInstance, locale: locale, adapterLocale: adapterLocale, localeText: localeText } = props;
    const utils = $bh6RR.useMemo(()=>new Utils({
            locale: adapterLocale != null ? adapterLocale : locale,
            formats: dateFormats,
            instance: dateLibInstance
        }), [
        Utils,
        locale,
        adapterLocale,
        dateFormats,
        dateLibInstance
    ]);
    const defaultDates = $bh6RR.useMemo(()=>{
        return {
            minDate: utils.date("1900-01-01T00:00:00.000"),
            maxDate: utils.date("2099-12-31T00:00:00.000")
        };
    }, [
        utils
    ]);
    const contextValue = $bh6RR.useMemo(()=>{
        return {
            utils: utils,
            defaultDates: defaultDates,
            localeText: (0, $4WYaH.default)({}, (0, $i71fw.DEFAULT_LOCALE), localeText != null ? localeText : {})
        };
    }, [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($a3dcdbc64884a405$export$544976378534cf9.Provider, {
        value: contextValue,
        children: children
    });
}

});
parcelRegister("i71fw", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", function () { return $d2f9d98c87fdaf98$export$1af4c7e47ad72f44; });

var $8poMo = parcelRequire("8poMo");
const $d2f9d98c87fdaf98$var$enUSPickers = {
    // Calendar navigation
    previousMonth: "Previous month",
    nextMonth: "Next month",
    // View navigation
    openPreviousView: "open previous view",
    openNextView: "open next view",
    calendarViewSwitchingButtonAriaLabel: (view)=>view === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
    inputModeToggleButtonAriaLabel: (isKeyboardInputOpen, viewType)=>isKeyboardInputOpen ? `text input view is open, go to ${viewType} view` : `${viewType} view is open, go to text input view`,
    // DateRange placeholders
    start: "Start",
    end: "End",
    // Action bar
    cancelButtonLabel: "Cancel",
    clearButtonLabel: "Clear",
    okButtonLabel: "OK",
    todayButtonLabel: "Today",
    // Toolbar titles
    datePickerDefaultToolbarTitle: "Select date",
    dateTimePickerDefaultToolbarTitle: "Select date & time",
    timePickerDefaultToolbarTitle: "Select time",
    dateRangePickerDefaultToolbarTitle: "Select date range",
    // Clock labels
    clockLabelText: (view, time, adapter)=>`Select ${view}. ${time === null ? "No time selected" : `Selected time is ${adapter.format(time, "fullTime")}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Open picker labels
    openDatePickerDialogue: (rawValue, utils)=>rawValue && utils.isValid(utils.date(rawValue)) ? `Choose date, selected date is ${utils.format(utils.date(rawValue), "fullDate")}` : "Choose date",
    openTimePickerDialogue: (rawValue, utils)=>rawValue && utils.isValid(utils.date(rawValue)) ? `Choose time, selected time is ${utils.format(utils.date(rawValue), "fullTime")}` : "Choose time",
    // Table labels
    timeTableLabel: "pick time",
    dateTableLabel: "pick date"
};
const $d2f9d98c87fdaf98$export$1af4c7e47ad72f44 = $d2f9d98c87fdaf98$var$enUSPickers;
const $d2f9d98c87fdaf98$export$137380d9ce54f7f = (0, $8poMo.getPickersLocalization)($d2f9d98c87fdaf98$var$enUSPickers);

});
parcelRegister("8poMo", function(module, exports) {

$parcel$export(module.exports, "getPickersLocalization", function () { return $61f3e13ea8dfab81$export$67c96d35a1b010b3; });

var $4WYaH = parcelRequire("4WYaH");
const $61f3e13ea8dfab81$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $4WYaH.default)({}, pickersTranslations)
                }
            }
        }
    };
};

});



parcelRegister("1Dn8S", function(module, exports) {

$parcel$export(module.exports, "AdapterDateFns", function () { return $130b627e88cf07ad$export$81f56c0329a1921d; });

var $6CHdR = parcelRequire("6CHdR");

var $eG059 = parcelRequire("eG059");

var $Js4Jx = parcelRequire("Js4Jx");
const $130b627e88cf07ad$var$formatTokenMap = {
    y: "year",
    yy: "year",
    yyy: "year",
    yyyy: "year",
    MMMM: "month",
    MM: "month",
    DD: "day",
    d: "day",
    dd: "day",
    H: "hour",
    HH: "hour",
    h: "hour",
    hh: "hour",
    mm: "minute",
    ss: "second",
    a: "am-pm",
    aa: "am-pm",
    aaa: "am-pm"
};
class $130b627e88cf07ad$export$81f56c0329a1921d extends (0, $6CHdR.default) {
    constructor(...args){
        super(...args);
        this.formatTokenMap = $130b627e88cf07ad$var$formatTokenMap;
        this.expandFormat = (format)=>{
            const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g; // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
            return format.match(longFormatRegexp).map((token)=>{
                const firstCharacter = token[0];
                if (firstCharacter === "p" || firstCharacter === "P") {
                    const longFormatter = (0, (/*@__PURE__*/$parcel$interopDefault($Js4Jx)))[firstCharacter];
                    const locale = this.locale || (0, $eG059.default);
                    return longFormatter(token, locale.formatLong, {});
                }
                return token;
            }).join("");
        };
        this.getFormatHelperText = (format)=>{
            return this.expandFormat(format).replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase();
        };
    }
}

});
parcelRegister("6CHdR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d27d1c559c8f4c2$export$2e2bcd8739ae039; });

var $igItr = parcelRequire("igItr");

var $3YcSb = parcelRequire("3YcSb");

var $8MQJ5 = parcelRequire("8MQJ5");

var $jmY8A = parcelRequire("jmY8A");

var $h8qn4 = parcelRequire("h8qn4");

var $4jKL6 = parcelRequire("4jKL6");

var $l7KXm = parcelRequire("l7KXm");

var $lF30Y = parcelRequire("lF30Y");

var $eKeKF = parcelRequire("eKeKF");

var $7F5Wv = parcelRequire("7F5Wv");

var $a3gV9 = parcelRequire("a3gV9");

var $94OR1 = parcelRequire("94OR1");

var $kZdzF = parcelRequire("kZdzF");

var $j3E5v = parcelRequire("j3E5v");

var $aEbeS = parcelRequire("aEbeS");

var $2Rsss = parcelRequire("2Rsss");

var $iez7c = parcelRequire("iez7c");

var $4tTuR = parcelRequire("4tTuR");

var $dRdrY = parcelRequire("dRdrY");

var $8SFqX = parcelRequire("8SFqX");

var $k0Sb0 = parcelRequire("k0Sb0");

var $i8Ftf = parcelRequire("i8Ftf");

var $dAPQy = parcelRequire("dAPQy");

var $ajF1O = parcelRequire("ajF1O");

var $iuIgx = parcelRequire("iuIgx");

var $bjv6P = parcelRequire("bjv6P");

var $g4Oj6 = parcelRequire("g4Oj6");

var $itOb4 = parcelRequire("itOb4");

var $7Qx6a = parcelRequire("7Qx6a");

var $jNzMQ = parcelRequire("jNzMQ");

var $22veB = parcelRequire("22veB");

var $f66eH = parcelRequire("f66eH");

var $gUIpT = parcelRequire("gUIpT");

var $etVP0 = parcelRequire("etVP0");

var $kqTgn = parcelRequire("kqTgn");

var $fgXdJ = parcelRequire("fgXdJ");

var $7pQzR = parcelRequire("7pQzR");

var $ejCCE = parcelRequire("ejCCE");

var $9Back = parcelRequire("9Back");

var $hBud4 = parcelRequire("hBud4");

var $kzEvi = parcelRequire("kzEvi");

var $jewTs = parcelRequire("jewTs");

var $j1vsN = parcelRequire("j1vsN");

var $585Rh = parcelRequire("585Rh");

var $h8HSd = parcelRequire("h8HSd");

var $krZy8 = parcelRequire("krZy8");

var $TDfe5 = parcelRequire("TDfe5");

var $a0b1b = parcelRequire("a0b1b");

var $cbgMD = parcelRequire("cbgMD");

var $25W9h = parcelRequire("25W9h");

var $2K4GI = parcelRequire("2K4GI");

var $gDyFX = parcelRequire("gDyFX");

var $Js4Jx = parcelRequire("Js4Jx");

var $eG059 = parcelRequire("eG059");
const $4d27d1c559c8f4c2$var$defaultFormats = {
    dayOfMonth: "d",
    fullDate: "PP",
    fullDateWithWeekday: "PPPP",
    fullDateTime: "PP p",
    fullDateTime12h: "PP hh:mm aaa",
    fullDateTime24h: "PP HH:mm",
    fullTime: "p",
    fullTime12h: "hh:mm aaa",
    fullTime24h: "HH:mm",
    hours12h: "hh",
    hours24h: "HH",
    keyboardDate: "P",
    keyboardDateTime: "P p",
    keyboardDateTime12h: "P hh:mm aaa",
    keyboardDateTime24h: "P HH:mm",
    minutes: "mm",
    month: "LLLL",
    monthAndDate: "MMMM d",
    monthAndYear: "LLLL yyyy",
    monthShort: "MMM",
    weekday: "EEEE",
    weekdayShort: "EEE",
    normalDate: "d MMMM",
    normalDateWithWeekday: "EEE, MMM d",
    seconds: "ss",
    shortDate: "MMM d",
    year: "yyyy"
};
class $4d27d1c559c8f4c2$export$2e2bcd8739ae039 {
    constructor({ locale: locale, formats: formats } = {}){
        this.lib = "date-fns";
        // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
        // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
        this.is12HourCycleInCurrentLocale = ()=>{
            var _a;
            if (this.locale) return /a/.test((_a = this.locale.formatLong) === null || _a === void 0 ? void 0 : _a.time());
            // By default date-fns is using en-US locale with am/pm enabled
            return true;
        };
        this.getFormatHelperText = (format)=>{
            var _a, _b;
            // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
            const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
            const locale = this.locale || (0, $eG059.default);
            return (_b = (_a = format.match(longFormatRegexp)) === null || _a === void 0 ? void 0 : _a.map((token)=>{
                const firstCharacter = token[0];
                if (firstCharacter === "p" || firstCharacter === "P") {
                    const longFormatter = (0, (/*@__PURE__*/$parcel$interopDefault($Js4Jx)))[firstCharacter];
                    return longFormatter(token, locale.formatLong, {});
                }
                return token;
            }).join("").replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase()) !== null && _b !== void 0 ? _b : format;
        };
        this.parseISO = (isoString)=>{
            return (0, $25W9h.default)(isoString);
        };
        this.toISO = (value)=>{
            return (0, $2K4GI.default)(value, {
                format: "extended"
            });
        };
        this.getCurrentLocaleCode = ()=>{
            var _a;
            return ((_a = this.locale) === null || _a === void 0 ? void 0 : _a.code) || "en-US";
        };
        this.addSeconds = (value, count)=>{
            return (0, $3YcSb.default)(value, count);
        };
        this.addMinutes = (value, count)=>{
            return (0, $8MQJ5.default)(value, count);
        };
        this.addHours = (value, count)=>{
            return (0, $jmY8A.default)(value, count);
        };
        this.addDays = (value, count)=>{
            return (0, $igItr.default)(value, count);
        };
        this.addWeeks = (value, count)=>{
            return (0, $h8qn4.default)(value, count);
        };
        this.addMonths = (value, count)=>{
            return (0, $4jKL6.default)(value, count);
        };
        this.addYears = (value, count)=>{
            return (0, $l7KXm.default)(value, count);
        };
        this.isValid = (value)=>{
            return (0, $7pQzR.default)(this.date(value));
        };
        this.getDiff = (value, comparing, unit)=>{
            var _a;
            // we output 0 if the compare date is string and parsing is not valid
            const dateToCompare = (_a = this.date(comparing)) !== null && _a !== void 0 ? _a : value;
            if (!this.isValid(dateToCompare)) return 0;
            switch(unit){
                case "years":
                    return (0, $lF30Y.default)(value, dateToCompare);
                case "quarters":
                    return (0, $eKeKF.default)(value, dateToCompare);
                case "months":
                    return (0, $7F5Wv.default)(value, dateToCompare);
                case "weeks":
                    return (0, $a3gV9.default)(value, dateToCompare);
                case "days":
                    return (0, $94OR1.default)(value, dateToCompare);
                case "hours":
                    return (0, $kZdzF.default)(value, dateToCompare);
                case "minutes":
                    return (0, $j3E5v.default)(value, dateToCompare);
                case "seconds":
                    return (0, $aEbeS.default)(value, dateToCompare);
                default:
                    return (0, $2Rsss.default)(value, dateToCompare);
            }
        };
        this.isAfter = (value, comparing)=>{
            return (0, $jNzMQ.default)(value, comparing);
        };
        this.isBefore = (value, comparing)=>{
            return (0, $22veB.default)(value, comparing);
        };
        this.startOfDay = (value)=>{
            return (0, $h8HSd.default)(value);
        };
        this.endOfDay = (value)=>{
            return (0, $4tTuR.default)(value);
        };
        this.getHours = (value)=>{
            return (0, $iuIgx.default)(value);
        };
        this.setHours = (value, count)=>{
            return (0, $hBud4.default)(value, count);
        };
        this.setMinutes = (value, count)=>{
            return (0, $kzEvi.default)(value, count);
        };
        this.getSeconds = (value)=>{
            return (0, $itOb4.default)(value);
        };
        this.setSeconds = (value, count)=>{
            return (0, $j1vsN.default)(value, count);
        };
        this.isSameDay = (value, comparing)=>{
            return (0, $gUIpT.default)(value, comparing);
        };
        this.isSameMonth = (value, comparing)=>{
            return (0, $kqTgn.default)(value, comparing);
        };
        this.isSameYear = (value, comparing)=>{
            return (0, $etVP0.default)(value, comparing);
        };
        this.isSameHour = (value, comparing)=>{
            return (0, $fgXdJ.default)(value, comparing);
        };
        this.startOfYear = (value)=>{
            return (0, $cbgMD.default)(value);
        };
        this.endOfYear = (value)=>{
            return (0, $8SFqX.default)(value);
        };
        this.startOfMonth = (value)=>{
            return (0, $krZy8.default)(value);
        };
        this.endOfMonth = (value)=>{
            return (0, $TDfe5.default)(value);
        };
        this.startOfWeek = (value)=>{
            return (0, $a0b1b.default)(value, {
                locale: this.locale
            });
        };
        this.endOfWeek = (value)=>{
            return (0, $dRdrY.default)(value, {
                locale: this.locale
            });
        };
        this.getYear = (value)=>{
            return (0, $7Qx6a.default)(value);
        };
        this.setYear = (value, count)=>{
            return (0, $585Rh.default)(value, count);
        };
        this.date = (value)=>{
            if (typeof value === "undefined") return new Date();
            if (value === null) return null;
            return new Date(value);
        };
        this.toJsDate = (value)=>{
            return value;
        };
        this.parse = (value, formatString)=>{
            if (value === "") return null;
            return (0, $ejCCE.default)(value, formatString, new Date(), {
                locale: this.locale
            });
        };
        this.format = (date, formatKey)=>{
            return this.formatByString(date, this.formats[formatKey]);
        };
        this.formatByString = (date, formatString)=>{
            return (0, $k0Sb0.default)(date, formatString, {
                locale: this.locale
            });
        };
        this.isEqual = (date, comparing)=>{
            if (date === null && comparing === null) return true;
            return (0, $f66eH.default)(date, comparing);
        };
        this.isNull = (date)=>{
            return date === null;
        };
        this.isAfterDay = (date, value)=>{
            return (0, $jNzMQ.default)(date, (0, $4tTuR.default)(value));
        };
        this.isBeforeDay = (date, value)=>{
            return (0, $22veB.default)(date, (0, $h8HSd.default)(value));
        };
        this.isBeforeYear = (date, value)=>{
            return (0, $22veB.default)(date, (0, $cbgMD.default)(value));
        };
        this.isAfterYear = (date, value)=>{
            return (0, $jNzMQ.default)(date, (0, $8SFqX.default)(value));
        };
        this.isWithinRange = (date, [start, end])=>{
            return (0, $gDyFX.default)(date, {
                start: start,
                end: end
            });
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.getMinutes = (date)=>{
            return (0, $bjv6P.default)(date);
        };
        this.getDate = (date)=>{
            return (0, $i8Ftf.default)(date);
        };
        this.setDate = (date, count)=>{
            return (0, $9Back.default)(date, count);
        };
        this.getMonth = (date)=>{
            return (0, $g4Oj6.default)(date);
        };
        this.getDaysInMonth = (date)=>{
            return (0, $ajF1O.default)(date);
        };
        this.setMonth = (date, count)=>{
            return (0, $jewTs.default)(date, count);
        };
        this.getMeridiemText = (ampm)=>{
            return ampm === "am" ? "AM" : "PM";
        };
        this.getNextMonth = (date)=>{
            return (0, $4jKL6.default)(date, 1);
        };
        this.getPreviousMonth = (date)=>{
            return (0, $4jKL6.default)(date, -1);
        };
        this.getMonthArray = (date)=>{
            const firstMonth = (0, $cbgMD.default)(date);
            const monthArray = [
                firstMonth
            ];
            while(monthArray.length < 12){
                const prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(this.getNextMonth(prevMonth));
            }
            return monthArray;
        };
        this.mergeDateAndTime = (date, time)=>{
            return this.setSeconds(this.setMinutes(this.setHours(date, this.getHours(time)), this.getMinutes(time)), this.getSeconds(time));
        };
        this.getWeekdays = ()=>{
            const now = new Date();
            return (0, $iez7c.default)({
                start: (0, $a0b1b.default)(now, {
                    locale: this.locale
                }),
                end: (0, $dRdrY.default)(now, {
                    locale: this.locale
                })
            }).map((day)=>this.formatByString(day, "EEEEEE"));
        };
        this.getWeekArray = (date)=>{
            const start = (0, $a0b1b.default)((0, $krZy8.default)(date), {
                locale: this.locale
            });
            const end = (0, $dRdrY.default)((0, $TDfe5.default)(date), {
                locale: this.locale
            });
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            let lastDay = null;
            while((0, $22veB.default)(current, end)){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                const day = (0, $dAPQy.default)(current);
                if (lastDay !== day) {
                    lastDay = day;
                    nestedWeeks[weekNumber].push(current);
                    count += 1;
                }
                current = (0, $igItr.default)(current, 1);
            }
            return nestedWeeks;
        };
        this.getYearRange = (start, end)=>{
            const startDate = (0, $cbgMD.default)(start);
            const endDate = (0, $8SFqX.default)(end);
            const years = [];
            let current = startDate;
            while((0, $22veB.default)(current, endDate)){
                years.push(current);
                current = (0, $l7KXm.default)(current, 1);
            }
            return years;
        };
        this.locale = locale;
        this.formats = Object.assign({}, $4d27d1c559c8f4c2$var$defaultFormats, formats);
    }
    isBeforeMonth(value, comparing) {
        return (0, $22veB.default)(value, (0, $krZy8.default)(comparing));
    }
    isAfterMonth(value, comparing) {
        return (0, $jNzMQ.default)(value, (0, $krZy8.default)(comparing));
    }
}

});
parcelRegister("igItr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4cc3831797a4057$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $d4cc3831797a4057$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});
parcelRegister("8d3vD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fa2427dbbbb369e$export$2e2bcd8739ae039; });
function $5fa2427dbbbb369e$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});

parcelRegister("le96L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f741f874145d0154$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");

var $6RzIO = parcelRequire("6RzIO");
function $f741f874145d0154$export$2e2bcd8739ae039(argument) {
    (0, $6RzIO.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $51lpG.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("6RzIO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ff366e58c33ccee$export$2e2bcd8739ae039; });
function $4ff366e58c33ccee$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

});



parcelRegister("3YcSb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e40f6038c08a6bf$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $egwKS = parcelRequire("egwKS");

var $6RzIO = parcelRequire("6RzIO");
function $2e40f6038c08a6bf$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return (0, $egwKS.default)(dirtyDate, amount * 1000);
}

});
parcelRegister("egwKS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a62bf7cf7b9521d9$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $a62bf7cf7b9521d9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var timestamp = (0, $le96L.default)(dirtyDate).getTime();
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});


parcelRegister("8MQJ5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $665bb4baa73432fa$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $egwKS = parcelRequire("egwKS");

var $6RzIO = parcelRequire("6RzIO");
var $665bb4baa73432fa$var$MILLISECONDS_IN_MINUTE = 60000;
function $665bb4baa73432fa$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return (0, $egwKS.default)(dirtyDate, amount * $665bb4baa73432fa$var$MILLISECONDS_IN_MINUTE);
}

});

parcelRegister("jmY8A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e19eb875fe23a456$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $egwKS = parcelRequire("egwKS");

var $6RzIO = parcelRequire("6RzIO");
var $e19eb875fe23a456$var$MILLISECONDS_IN_HOUR = 3600000;
function $e19eb875fe23a456$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return (0, $egwKS.default)(dirtyDate, amount * $e19eb875fe23a456$var$MILLISECONDS_IN_HOUR);
}

});

parcelRegister("h8qn4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c797a3ca3cdb5932$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $igItr = parcelRequire("igItr");

var $6RzIO = parcelRequire("6RzIO");
function $c797a3ca3cdb5932$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $igItr.default)(dirtyDate, days);
}

});

parcelRegister("4jKL6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $324d3518b1b08498$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $324d3518b1b08498$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("l7KXm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f60eacfe0e9716b8$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $4jKL6 = parcelRequire("4jKL6");

var $6RzIO = parcelRequire("6RzIO");
function $f60eacfe0e9716b8$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return (0, $4jKL6.default)(dirtyDate, amount * 12);
}

});

parcelRegister("lF30Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc4fc3f20c37ba4a$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $ckwmq = parcelRequire("ckwmq");

var $lNoyk = parcelRequire("lNoyk");

var $6RzIO = parcelRequire("6RzIO");
function $fc4fc3f20c37ba4a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeft = (0, $le96L.default)(dirtyDateLeft);
    var dateRight = (0, $le96L.default)(dirtyDateRight);
    var sign = (0, $lNoyk.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $ckwmq.default)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $lNoyk.default)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("ckwmq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fa074789f5a199e$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $8fa074789f5a199e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeft = (0, $le96L.default)(dirtyDateLeft);
    var dateRight = (0, $le96L.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

});

parcelRegister("lNoyk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fde13840f1779e0c$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $fde13840f1779e0c$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeft = (0, $le96L.default)(dirtyDateLeft);
    var dateRight = (0, $le96L.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});


parcelRegister("eKeKF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abc0cdf62385f3df$export$2e2bcd8739ae039; });

var $7F5Wv = parcelRequire("7F5Wv");

var $6RzIO = parcelRequire("6RzIO");

var $a2g9B = parcelRequire("a2g9B");
function $abc0cdf62385f3df$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $6RzIO.default)(2, arguments);
    var diff = (0, $7F5Wv.default)(dateLeft, dateRight) / 3;
    return (0, $a2g9B.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});
parcelRegister("7F5Wv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5940f8cea05b1caa$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $frPzN = parcelRequire("frPzN");

var $lNoyk = parcelRequire("lNoyk");

var $6RzIO = parcelRequire("6RzIO");

var $iY8AS = parcelRequire("iY8AS");
function $5940f8cea05b1caa$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeft = (0, $le96L.default)(dirtyDateLeft);
    var dateRight = (0, $le96L.default)(dirtyDateRight);
    var sign = (0, $lNoyk.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $frPzN.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $lNoyk.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $iY8AS.default)((0, $le96L.default)(dirtyDateLeft)) && difference === 1 && (0, $lNoyk.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("frPzN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3f16299565f3818$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $b3f16299565f3818$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeft = (0, $le96L.default)(dirtyDateLeft);
    var dateRight = (0, $le96L.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("iY8AS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcf47f214d273c42$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $4tTuR = parcelRequire("4tTuR");

var $TDfe5 = parcelRequire("TDfe5");

var $6RzIO = parcelRequire("6RzIO");
function $dcf47f214d273c42$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    return (0, $4tTuR.default)(date).getTime() === (0, $TDfe5.default)(date).getTime();
}

});
parcelRegister("4tTuR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3434eb5bab1e76df$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $3434eb5bab1e76df$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("TDfe5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a7394535777dacf$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $0a7394535777dacf$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});



parcelRegister("a2g9B", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", function () { return $74e69f179d1a936e$export$b6474a47258c1211; });
var $74e69f179d1a936e$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $74e69f179d1a936e$var$defaultRoundingMethod = "trunc";
function $74e69f179d1a936e$export$b6474a47258c1211(method) {
    return method ? $74e69f179d1a936e$var$roundingMap[method] : $74e69f179d1a936e$var$roundingMap[$74e69f179d1a936e$var$defaultRoundingMethod];
}

});


parcelRegister("a3gV9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75174f4971674d38$export$2e2bcd8739ae039; });

var $94OR1 = parcelRequire("94OR1");

var $6RzIO = parcelRequire("6RzIO");

var $a2g9B = parcelRequire("a2g9B");
function $75174f4971674d38$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $6RzIO.default)(2, arguments);
    var diff = (0, $94OR1.default)(dateLeft, dateRight) / 7;
    return (0, $a2g9B.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});
parcelRegister("94OR1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69bbef5abecd6c1f$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $fxy8a = parcelRequire("fxy8a");

var $6RzIO = parcelRequire("6RzIO");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $69bbef5abecd6c1f$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $69bbef5abecd6c1f$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeft = (0, $le96L.default)(dirtyDateLeft);
    var dateRight = (0, $le96L.default)(dirtyDateRight);
    var sign = $69bbef5abecd6c1f$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $fxy8a.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($69bbef5abecd6c1f$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("fxy8a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b50469c0909a5344$export$2e2bcd8739ae039; });

var $8zxzx = parcelRequire("8zxzx");

var $h8HSd = parcelRequire("h8HSd");

var $6RzIO = parcelRequire("6RzIO");
var $b50469c0909a5344$var$MILLISECONDS_IN_DAY = 86400000;
function $b50469c0909a5344$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var startOfDayLeft = (0, $h8HSd.default)(dirtyDateLeft);
    var startOfDayRight = (0, $h8HSd.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $8zxzx.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $8zxzx.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $b50469c0909a5344$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("8zxzx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63dba254cf419de0$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $63dba254cf419de0$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("h8HSd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7a5375f03b0a15d$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $c7a5375f03b0a15d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});




parcelRegister("kZdzF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f47408bd17f17a80$export$2e2bcd8739ae039; });

var $6QTFS = parcelRequire("6QTFS");

var $2Rsss = parcelRequire("2Rsss");

var $6RzIO = parcelRequire("6RzIO");

var $a2g9B = parcelRequire("a2g9B");
function $f47408bd17f17a80$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $6RzIO.default)(2, arguments);
    var diff = (0, $2Rsss.default)(dateLeft, dateRight) / (0, $6QTFS.millisecondsInHour);
    return (0, $a2g9B.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});
parcelRegister("6QTFS", function(module, exports) {

$parcel$export(module.exports, "millisecondsInMinute", function () { return $4fd2c93311e78e29$export$91246f0b9bd9beff; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $4fd2c93311e78e29$export$7f72910d6dfd237a; });
$parcel$export(module.exports, "millisecondsInSecond", function () { return $4fd2c93311e78e29$export$397c2d5776aa9055; });
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $4fd2c93311e78e29$export$dfd9b671c89acc8e = 7;
var $4fd2c93311e78e29$export$3913210603d8e9ae = 365.2425;
var $4fd2c93311e78e29$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $4fd2c93311e78e29$export$91246f0b9bd9beff = 60000;
var $4fd2c93311e78e29$export$7f72910d6dfd237a = 3600000;
var $4fd2c93311e78e29$export$397c2d5776aa9055 = 1000;
var $4fd2c93311e78e29$export$4dec998e48f9c246 = -$4fd2c93311e78e29$export$81caae6e1cc7a622;
var $4fd2c93311e78e29$export$f2f5ae5a8e2d8f9f = 60;
var $4fd2c93311e78e29$export$3c58128db900d44e = 3;
var $4fd2c93311e78e29$export$80d7e435f744f319 = 12;
var $4fd2c93311e78e29$export$4db7641526e3241f = 4;
var $4fd2c93311e78e29$export$698aec755e92c695 = 3600;
var $4fd2c93311e78e29$export$a77c1a7ebebe2a5a = 60;
var $4fd2c93311e78e29$export$815a9362476d2fe3 = $4fd2c93311e78e29$export$698aec755e92c695 * 24;
var $4fd2c93311e78e29$export$34804a017b31e2fe = $4fd2c93311e78e29$export$815a9362476d2fe3 * 7;
var $4fd2c93311e78e29$export$7271e9e3478110d1 = $4fd2c93311e78e29$export$815a9362476d2fe3 * $4fd2c93311e78e29$export$3913210603d8e9ae;
var $4fd2c93311e78e29$export$8e6600bbdee7dabb = $4fd2c93311e78e29$export$7271e9e3478110d1 / 12;
var $4fd2c93311e78e29$export$be1dccf2de902d31 = $4fd2c93311e78e29$export$8e6600bbdee7dabb * 3;

});

parcelRegister("2Rsss", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21569b2b04b706a2$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $21569b2b04b706a2$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $6RzIO.default)(2, arguments);
    return (0, $le96L.default)(dateLeft).getTime() - (0, $le96L.default)(dateRight).getTime();
}

});


parcelRegister("j3E5v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddfd64bc63331024$export$2e2bcd8739ae039; });

var $6QTFS = parcelRequire("6QTFS");

var $2Rsss = parcelRequire("2Rsss");

var $6RzIO = parcelRequire("6RzIO");

var $a2g9B = parcelRequire("a2g9B");
function $ddfd64bc63331024$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $6RzIO.default)(2, arguments);
    var diff = (0, $2Rsss.default)(dateLeft, dateRight) / (0, $6QTFS.millisecondsInMinute);
    return (0, $a2g9B.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("aEbeS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c065ba4df5aaae0$export$2e2bcd8739ae039; });

var $2Rsss = parcelRequire("2Rsss");

var $6RzIO = parcelRequire("6RzIO");

var $a2g9B = parcelRequire("a2g9B");
function $7c065ba4df5aaae0$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $6RzIO.default)(2, arguments);
    var diff = (0, $2Rsss.default)(dateLeft, dateRight) / 1000;
    return (0, $a2g9B.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("iez7c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d464c5edb4a88ee1$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $d464c5edb4a88ee1$export$2e2bcd8739ae039(dirtyInterval, options) {
    var _options$step;
    (0, $6RzIO.default)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $le96L.default)(interval.start);
    var endDate = (0, $le96L.default)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError("Invalid interval");
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError("`options.step` must be a number greater than 1");
    while(currentDate.getTime() <= endTime){
        dates.push((0, $le96L.default)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}

});

parcelRegister("dRdrY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a16aa884d52fc460$export$2e2bcd8739ae039; });

var $dCCOX = parcelRequire("dCCOX");

var $le96L = parcelRequire("le96L");

var $8d3vD = parcelRequire("8d3vD");

var $6RzIO = parcelRequire("6RzIO");
function $a16aa884d52fc460$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6RzIO.default)(1, arguments);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var weekStartsOn = (0, $8d3vD.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $le96L.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

});
parcelRegister("dCCOX", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $9eacf000ef47a2dd$export$430a3269e24b912e; });
var $9eacf000ef47a2dd$var$defaultOptions = {};
function $9eacf000ef47a2dd$export$430a3269e24b912e() {
    return $9eacf000ef47a2dd$var$defaultOptions;
}
function $9eacf000ef47a2dd$export$95365be1b0704abc(newOptions) {
    $9eacf000ef47a2dd$var$defaultOptions = newOptions;
}

});


parcelRegister("8SFqX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $677381c520e9594f$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $677381c520e9594f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("k0Sb0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e91dd50cc5cd7f0e$export$2e2bcd8739ae039; });

var $7pQzR = parcelRequire("7pQzR");

var $cfoI5 = parcelRequire("cfoI5");

var $le96L = parcelRequire("le96L");

var $3rsJw = parcelRequire("3rsJw");

var $dmQbx = parcelRequire("dmQbx");

var $8zxzx = parcelRequire("8zxzx");

var $xRN1E = parcelRequire("xRN1E");

var $8d3vD = parcelRequire("8d3vD");

var $6RzIO = parcelRequire("6RzIO");

var $dCCOX = parcelRequire("dCCOX");

var $fhQJu = parcelRequire("fhQJu");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $e91dd50cc5cd7f0e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $e91dd50cc5cd7f0e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $e91dd50cc5cd7f0e$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $e91dd50cc5cd7f0e$var$doubleQuoteRegExp = /''/g;
var $e91dd50cc5cd7f0e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e91dd50cc5cd7f0e$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $6RzIO.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $fhQJu.default);
    var firstWeekContainsDate = (0, $8d3vD.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $8d3vD.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $le96L.default)(dirtyDate);
    if (!(0, $7pQzR.default)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $8zxzx.default)(originalDate);
    var utcDate = (0, $cfoI5.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($e91dd50cc5cd7f0e$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $dmQbx.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($e91dd50cc5cd7f0e$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $e91dd50cc5cd7f0e$var$cleanEscapedString(substring);
        var formatter = (0, $3rsJw.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $xRN1E.isProtectedWeekYearToken)(substring)) (0, $xRN1E.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $xRN1E.isProtectedDayOfYearToken)(substring)) (0, $xRN1E.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($e91dd50cc5cd7f0e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $e91dd50cc5cd7f0e$var$cleanEscapedString(input) {
    var matched = input.match($e91dd50cc5cd7f0e$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($e91dd50cc5cd7f0e$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("7pQzR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5663a6fd5511e169$export$2e2bcd8739ae039; });

var $cmc1k = parcelRequire("cmc1k");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $5663a6fd5511e169$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    if (!(0, $cmc1k.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $le96L.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("cmc1k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ff0dd17621a97b7$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");

var $6RzIO = parcelRequire("6RzIO");
function $8ff0dd17621a97b7$export$2e2bcd8739ae039(value) {
    (0, $6RzIO.default)(1, arguments);
    return value instanceof Date || (0, $51lpG.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});


parcelRegister("cfoI5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eaa0dace66c235b$export$2e2bcd8739ae039; });

var $egwKS = parcelRequire("egwKS");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");
function $8eaa0dace66c235b$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return (0, $egwKS.default)(dirtyDate, -amount);
}

});

parcelRegister("3rsJw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $281a2e82d409b287$export$2e2bcd8739ae039; });

var $iUfDY = parcelRequire("iUfDY");

var $9rMx7 = parcelRequire("9rMx7");

var $iymSi = parcelRequire("iymSi");

var $bCYgf = parcelRequire("bCYgf");

var $e0HMe = parcelRequire("e0HMe");

var $jOrUI = parcelRequire("jOrUI");

var $bDYa5 = parcelRequire("bDYa5");
var $281a2e82d409b287$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $281a2e82d409b287$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $bDYa5.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $e0HMe.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $jOrUI.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $jOrUI.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $iymSi.default)(date);
        // Padding
        return (0, $jOrUI.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $jOrUI.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $jOrUI.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $jOrUI.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $bDYa5.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $jOrUI.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $bCYgf.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $jOrUI.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $9rMx7.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $jOrUI.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $bDYa5.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $iUfDY.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $jOrUI.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $jOrUI.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $jOrUI.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $jOrUI.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $bDYa5.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $bDYa5.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $jOrUI.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $jOrUI.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $bDYa5.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $bDYa5.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $bDYa5.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $281a2e82d409b287$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $281a2e82d409b287$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $281a2e82d409b287$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $281a2e82d409b287$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $281a2e82d409b287$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $281a2e82d409b287$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $jOrUI.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $jOrUI.default)(timestamp, token.length);
    }
};
function $281a2e82d409b287$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $jOrUI.default)(minutes, 2);
}
function $281a2e82d409b287$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $jOrUI.default)(Math.abs(offset) / 60, 2);
    }
    return $281a2e82d409b287$var$formatTimezone(offset, dirtyDelimiter);
}
function $281a2e82d409b287$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $jOrUI.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $jOrUI.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $281a2e82d409b287$export$2e2bcd8739ae039 = $281a2e82d409b287$var$formatters;

});
parcelRegister("iUfDY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc399780b2b0aec4$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
var $dc399780b2b0aec4$var$MILLISECONDS_IN_DAY = 86400000;
function $dc399780b2b0aec4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $dc399780b2b0aec4$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("9rMx7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e0c4858e45e9a69$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $byvVj = parcelRequire("byvVj");

var $60OYk = parcelRequire("60OYk");

var $6RzIO = parcelRequire("6RzIO");
var $6e0c4858e45e9a69$var$MILLISECONDS_IN_WEEK = 604800000;
function $6e0c4858e45e9a69$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var diff = (0, $byvVj.default)(date).getTime() - (0, $60OYk.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $6e0c4858e45e9a69$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("byvVj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $869ba20767f1348a$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $869ba20767f1348a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $le96L.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("60OYk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $460a48298a6e483f$export$2e2bcd8739ae039; });

var $iymSi = parcelRequire("iymSi");

var $byvVj = parcelRequire("byvVj");

var $6RzIO = parcelRequire("6RzIO");
function $460a48298a6e483f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var year = (0, $iymSi.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $byvVj.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("iymSi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d81d25690b2c97ba$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");

var $byvVj = parcelRequire("byvVj");
function $d81d25690b2c97ba$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $byvVj.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $byvVj.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("bCYgf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8771fceed12cf89e$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $j1YKz = parcelRequire("j1YKz");

var $2yvSN = parcelRequire("2yvSN");

var $6RzIO = parcelRequire("6RzIO");
var $8771fceed12cf89e$var$MILLISECONDS_IN_WEEK = 604800000;
function $8771fceed12cf89e$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var diff = (0, $j1YKz.default)(date, options).getTime() - (0, $2yvSN.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $8771fceed12cf89e$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("j1YKz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddad3c02657f84fd$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");

var $dCCOX = parcelRequire("dCCOX");
function $ddad3c02657f84fd$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6RzIO.default)(1, arguments);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var weekStartsOn = (0, $8d3vD.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $le96L.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("2yvSN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1dc77d031b6877e7$export$2e2bcd8739ae039; });

var $e0HMe = parcelRequire("e0HMe");

var $6RzIO = parcelRequire("6RzIO");

var $j1YKz = parcelRequire("j1YKz");

var $8d3vD = parcelRequire("8d3vD");

var $dCCOX = parcelRequire("dCCOX");
function $1dc77d031b6877e7$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6RzIO.default)(1, arguments);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var firstWeekContainsDate = (0, $8d3vD.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $e0HMe.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $j1YKz.default)(firstWeek, options);
    return date;
}

});
parcelRegister("e0HMe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a33305f247e30adc$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");

var $j1YKz = parcelRequire("j1YKz");

var $8d3vD = parcelRequire("8d3vD");

var $dCCOX = parcelRequire("dCCOX");
function $a33305f247e30adc$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var firstWeekContainsDate = (0, $8d3vD.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $j1YKz.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $j1YKz.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("jOrUI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6c856ebc9ae82ee$export$2e2bcd8739ae039; });
function $e6c856ebc9ae82ee$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}

});

parcelRegister("bDYa5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87a2011828c90e33$export$2e2bcd8739ae039; });

var $jOrUI = parcelRequire("jOrUI");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $87a2011828c90e33$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $jOrUI.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $jOrUI.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $jOrUI.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $jOrUI.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $jOrUI.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $jOrUI.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $jOrUI.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $jOrUI.default)(fractionalSeconds, token.length);
    }
};
var $87a2011828c90e33$export$2e2bcd8739ae039 = $87a2011828c90e33$var$formatters;

});


parcelRegister("dmQbx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bb5cf506dd06653$export$2e2bcd8739ae039; });
var $9bb5cf506dd06653$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $9bb5cf506dd06653$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $9bb5cf506dd06653$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $9bb5cf506dd06653$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $9bb5cf506dd06653$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $9bb5cf506dd06653$var$timeLongFormatter(timePattern, formatLong));
};
var $9bb5cf506dd06653$var$longFormatters = {
    p: $9bb5cf506dd06653$var$timeLongFormatter,
    P: $9bb5cf506dd06653$var$dateTimeLongFormatter
};
var $9bb5cf506dd06653$export$2e2bcd8739ae039 = $9bb5cf506dd06653$var$longFormatters;

});

parcelRegister("xRN1E", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $065cceb4149e3fc5$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $065cceb4149e3fc5$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $065cceb4149e3fc5$export$8073c1ae88f0e727; });
var $065cceb4149e3fc5$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $065cceb4149e3fc5$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $065cceb4149e3fc5$export$c6cc36aa33304772(token) {
    return $065cceb4149e3fc5$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $065cceb4149e3fc5$export$c6b49d6dceb604a1(token) {
    return $065cceb4149e3fc5$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $065cceb4149e3fc5$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("fhQJu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b211592c26324d97$export$2e2bcd8739ae039; });

var $eG059 = parcelRequire("eG059");
var $b211592c26324d97$export$2e2bcd8739ae039 = (0, $eG059.default);

});
parcelRegister("eG059", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aaf50d37016ddcb1$export$2e2bcd8739ae039; });

var $bvM2P = parcelRequire("bvM2P");

var $haCAZ = parcelRequire("haCAZ");

var $AVlzc = parcelRequire("AVlzc");

var $eiIUR = parcelRequire("eiIUR");

var $8rsbS = parcelRequire("8rsbS");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $aaf50d37016ddcb1$var$locale = {
    code: "en-US",
    formatDistance: (0, $bvM2P.default),
    formatLong: (0, $haCAZ.default),
    formatRelative: (0, $AVlzc.default),
    localize: (0, $eiIUR.default),
    match: (0, $8rsbS.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $aaf50d37016ddcb1$export$2e2bcd8739ae039 = $aaf50d37016ddcb1$var$locale;

});
parcelRegister("bvM2P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8617db99f2cb39a3$export$2e2bcd8739ae039; });
var $8617db99f2cb39a3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $8617db99f2cb39a3$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $8617db99f2cb39a3$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $8617db99f2cb39a3$export$2e2bcd8739ae039 = $8617db99f2cb39a3$var$formatDistance;

});

parcelRegister("haCAZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8014f25de2be27f$export$2e2bcd8739ae039; });

var $lbh04 = parcelRequire("lbh04");
var $c8014f25de2be27f$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $c8014f25de2be27f$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $c8014f25de2be27f$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $c8014f25de2be27f$var$formatLong = {
    date: (0, $lbh04.default)({
        formats: $c8014f25de2be27f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $lbh04.default)({
        formats: $c8014f25de2be27f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $lbh04.default)({
        formats: $c8014f25de2be27f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $c8014f25de2be27f$export$2e2bcd8739ae039 = $c8014f25de2be27f$var$formatLong;

});
parcelRegister("lbh04", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6b7cff3d084a1cf$export$2e2bcd8739ae039; });
function $f6b7cff3d084a1cf$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("AVlzc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06efd8cc10c4bd73$export$2e2bcd8739ae039; });
var $06efd8cc10c4bd73$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $06efd8cc10c4bd73$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $06efd8cc10c4bd73$var$formatRelativeLocale[token];
};
var $06efd8cc10c4bd73$export$2e2bcd8739ae039 = $06efd8cc10c4bd73$var$formatRelative;

});

parcelRegister("eiIUR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6959687464919d6$export$2e2bcd8739ae039; });

var $jZkn4 = parcelRequire("jZkn4");
var $a6959687464919d6$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $a6959687464919d6$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $a6959687464919d6$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $a6959687464919d6$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $a6959687464919d6$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $a6959687464919d6$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $a6959687464919d6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $a6959687464919d6$var$localize = {
    ordinalNumber: $a6959687464919d6$var$ordinalNumber,
    era: (0, $jZkn4.default)({
        values: $a6959687464919d6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $jZkn4.default)({
        values: $a6959687464919d6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $jZkn4.default)({
        values: $a6959687464919d6$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $jZkn4.default)({
        values: $a6959687464919d6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $jZkn4.default)({
        values: $a6959687464919d6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a6959687464919d6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $a6959687464919d6$export$2e2bcd8739ae039 = $a6959687464919d6$var$localize;

});
parcelRegister("jZkn4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8d3841961a689fd$export$2e2bcd8739ae039; });
function $e8d3841961a689fd$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("8rsbS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6256b66dca390462$export$2e2bcd8739ae039; });

var $gcy5I = parcelRequire("gcy5I");

var $jChsd = parcelRequire("jChsd");
var $6256b66dca390462$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $6256b66dca390462$var$parseOrdinalNumberPattern = /\d+/i;
var $6256b66dca390462$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $6256b66dca390462$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $6256b66dca390462$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $6256b66dca390462$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6256b66dca390462$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $6256b66dca390462$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $6256b66dca390462$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $6256b66dca390462$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $6256b66dca390462$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $6256b66dca390462$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $6256b66dca390462$var$match = {
    ordinalNumber: (0, $jChsd.default)({
        matchPattern: $6256b66dca390462$var$matchOrdinalNumberPattern,
        parsePattern: $6256b66dca390462$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gcy5I.default)({
        matchPatterns: $6256b66dca390462$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6256b66dca390462$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gcy5I.default)({
        matchPatterns: $6256b66dca390462$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6256b66dca390462$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gcy5I.default)({
        matchPatterns: $6256b66dca390462$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6256b66dca390462$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gcy5I.default)({
        matchPatterns: $6256b66dca390462$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6256b66dca390462$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gcy5I.default)({
        matchPatterns: $6256b66dca390462$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6256b66dca390462$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $6256b66dca390462$export$2e2bcd8739ae039 = $6256b66dca390462$var$match;

});
parcelRegister("gcy5I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcb83626ff750417$export$2e2bcd8739ae039; });
function $bcb83626ff750417$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $bcb83626ff750417$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $bcb83626ff750417$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $bcb83626ff750417$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $bcb83626ff750417$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("jChsd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03af782d2d1fcb5a$export$2e2bcd8739ae039; });
function $03af782d2d1fcb5a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});





parcelRegister("i8Ftf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3492493f9431cac$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $d3492493f9431cac$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}

});

parcelRegister("dAPQy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e56dad6a723865d$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $9e56dad6a723865d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var day = date.getDay();
    return day;
}

});

parcelRegister("ajF1O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $782b811855cace18$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $782b811855cace18$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});

parcelRegister("iuIgx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d76d5d942b6c7603$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $d76d5d942b6c7603$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var hours = date.getHours();
    return hours;
}

});

parcelRegister("bjv6P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83c999b24199fe93$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $83c999b24199fe93$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}

});

parcelRegister("g4Oj6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb440afc64012a62$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $bb440afc64012a62$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var month = date.getMonth();
    return month;
}

});

parcelRegister("itOb4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d741dbab944cfeba$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $d741dbab944cfeba$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}

});

parcelRegister("7Qx6a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b67106b80303158$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $5b67106b80303158$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    return (0, $le96L.default)(dirtyDate).getFullYear();
}

});

parcelRegister("jNzMQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e69e5a70118ffe6b$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $e69e5a70118ffe6b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var dateToCompare = (0, $le96L.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("22veB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17c3ff3944cd98da$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $17c3ff3944cd98da$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var dateToCompare = (0, $le96L.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("f66eH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afdc40e50ef8ccc8$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $afdc40e50ef8ccc8$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeft = (0, $le96L.default)(dirtyLeftDate);
    var dateRight = (0, $le96L.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

});

parcelRegister("gUIpT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5045487affbaf52$export$2e2bcd8739ae039; });

var $h8HSd = parcelRequire("h8HSd");

var $6RzIO = parcelRequire("6RzIO");
function $c5045487affbaf52$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeftStartOfDay = (0, $h8HSd.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $h8HSd.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("etVP0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8b0a05107fac9a4$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $a8b0a05107fac9a4$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeft = (0, $le96L.default)(dirtyDateLeft);
    var dateRight = (0, $le96L.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

});

parcelRegister("kqTgn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee011a7595cab906$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $ee011a7595cab906$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeft = (0, $le96L.default)(dirtyDateLeft);
    var dateRight = (0, $le96L.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

});

parcelRegister("fgXdJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1e64994583c1668$export$2e2bcd8739ae039; });

var $7FrEd = parcelRequire("7FrEd");

var $6RzIO = parcelRequire("6RzIO");
function $b1e64994583c1668$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeftStartOfHour = (0, $7FrEd.default)(dirtyDateLeft);
    var dateRightStartOfHour = (0, $7FrEd.default)(dirtyDateRight);
    return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}

});
parcelRegister("7FrEd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5951cef9cc975911$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $5951cef9cc975911$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}

});


parcelRegister("ejCCE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6c0cca4ba136238$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");

var $7octi = parcelRequire("7octi");

var $fhQJu = parcelRequire("fhQJu");

var $cfoI5 = parcelRequire("cfoI5");

var $le96L = parcelRequire("le96L");

var $5lXXI = parcelRequire("5lXXI");

var $dmQbx = parcelRequire("dmQbx");

var $8zxzx = parcelRequire("8zxzx");

var $xRN1E = parcelRequire("xRN1E");

var $8d3vD = parcelRequire("8d3vD");

var $6RzIO = parcelRequire("6RzIO");

var $bF26l = parcelRequire("bF26l");

var $dLP8x = parcelRequire("dLP8x");

var $dCCOX = parcelRequire("dCCOX");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $a6c0cca4ba136238$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $a6c0cca4ba136238$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $a6c0cca4ba136238$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $a6c0cca4ba136238$var$doubleQuoteRegExp = /''/g;
var $a6c0cca4ba136238$var$notWhitespaceRegExp = /\S/;
var $a6c0cca4ba136238$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $a6c0cca4ba136238$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $6RzIO.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $fhQJu.default);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, $8d3vD.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $8d3vD.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, $le96L.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $bF26l.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($a6c0cca4ba136238$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $dmQbx.default)) {
            var longFormatter = (0, $dmQbx.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($a6c0cca4ba136238$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $7octi.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $xRN1E.isProtectedWeekYearToken)(token)) (0, $xRN1E.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $xRN1E.isProtectedDayOfYearToken)(token)) (0, $xRN1E.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $dLP8x.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($a6c0cca4ba136238$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $a6c0cca4ba136238$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $51lpG.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $a6c0cca4ba136238$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $le96L.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $cfoI5.default)(date, (0, $8zxzx.default)(date));
    var flags = {};
    var _iterator2 = (0, $7octi.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $5lXXI.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $a6c0cca4ba136238$var$cleanEscapedString(input) {
    return input.match($a6c0cca4ba136238$var$escapedStringRegExp)[1].replace($a6c0cca4ba136238$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("7octi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $561472df61666821$export$2e2bcd8739ae039; });

var $9F6mQ = parcelRequire("9F6mQ");
function $561472df61666821$export$2e2bcd8739ae039(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = (0, $9F6mQ.default)(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}

});

parcelRegister("5lXXI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e5d6d2694ed7592$export$2e2bcd8739ae039; });
function $3e5d6d2694ed7592$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("bF26l", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", function () { return $87d5274f95235e24$export$9a09e32dd4990fd5; });
$parcel$export(module.exports, "DateToSystemTimezoneSetter", function () { return $87d5274f95235e24$export$5aaf7ff7f09ea4ee; });

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $2ryml = parcelRequire("2ryml");
var $87d5274f95235e24$var$TIMEZONE_UNIT_PRIORITY = 10;
var $87d5274f95235e24$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $fivc7.default)(this, Setter);
        (0, $2ryml.default)(this, "priority", void 0);
        (0, $2ryml.default)(this, "subPriority", 0);
    }
    (0, $kuNiL.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $87d5274f95235e24$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $7uMzR.default)(ValueSetter, _Setter);
    var _super = (0, $1JyKh.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $fivc7.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $kuNiL.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($87d5274f95235e24$export$81d53e3678089a6);
var $87d5274f95235e24$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $7uMzR.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $1JyKh.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $fivc7.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this2), "priority", $87d5274f95235e24$var$TIMEZONE_UNIT_PRIORITY);
        (0, $2ryml.default)((0, $hqR4t.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $kuNiL.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($87d5274f95235e24$export$81d53e3678089a6);

});
parcelRegister("7uMzR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5751042f9a4a77f6$export$2e2bcd8739ae039; });

var $hloi6 = parcelRequire("hloi6");
function $5751042f9a4a77f6$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $hloi6.default)(subClass, superClass);
}

});

parcelRegister("1JyKh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1434f224efb0ce22$export$2e2bcd8739ae039; });

var $k5JCq = parcelRequire("k5JCq");

var $1TADt = parcelRequire("1TADt");

var $gLqR5 = parcelRequire("gLqR5");
function $1434f224efb0ce22$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $1TADt.default)();
    return function _createSuperInternal() {
        var Super = (0, $k5JCq.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $k5JCq.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $gLqR5.default)(this, result);
    };
}

});
parcelRegister("k5JCq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea07a931d040ec2a$export$2e2bcd8739ae039; });
function $ea07a931d040ec2a$export$2e2bcd8739ae039(o) {
    $ea07a931d040ec2a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ea07a931d040ec2a$export$2e2bcd8739ae039(o);
}

});

parcelRegister("1TADt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1617589007256c62$export$2e2bcd8739ae039; });
function $1617589007256c62$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1617589007256c62$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("gLqR5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c345de07753d2fca$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");

var $hqR4t = parcelRequire("hqR4t");
function $c345de07753d2fca$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $51lpG.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hqR4t.default)(self);
}

});


parcelRegister("fivc7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b230bc0d4245014d$export$2e2bcd8739ae039; });
function $b230bc0d4245014d$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("2ryml", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c78c172f6af0e63$export$2e2bcd8739ae039; });

var $hTglg = parcelRequire("hTglg");
function $1c78c172f6af0e63$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $hTglg.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("dLP8x", function(module, exports) {

$parcel$export(module.exports, "parsers", function () { return $a06754d708967e28$export$19131010e7fd8373; });

var $kfK2H = parcelRequire("kfK2H");

var $7giry = parcelRequire("7giry");

var $bCjfP = parcelRequire("bCjfP");

var $erSGt = parcelRequire("erSGt");

var $b8jnr = parcelRequire("b8jnr");

var $9AuQQ = parcelRequire("9AuQQ");

var $fE7CR = parcelRequire("fE7CR");

var $4rJhG = parcelRequire("4rJhG");

var $l09IK = parcelRequire("l09IK");

var $kHjhn = parcelRequire("kHjhn");

var $ijC3v = parcelRequire("ijC3v");

var $k1agz = parcelRequire("k1agz");

var $hfumD = parcelRequire("hfumD");

var $34xUW = parcelRequire("34xUW");

var $1hrH9 = parcelRequire("1hrH9");

var $1y17U = parcelRequire("1y17U");

var $lAmiB = parcelRequire("lAmiB");

var $hBBos = parcelRequire("hBBos");

var $iaLki = parcelRequire("iaLki");

var $hjAYL = parcelRequire("hjAYL");

var $5c3u4 = parcelRequire("5c3u4");

var $gBHKn = parcelRequire("gBHKn");

var $iBp2S = parcelRequire("iBp2S");

var $5MoaU = parcelRequire("5MoaU");

var $4WIYq = parcelRequire("4WIYq");

var $pKJVW = parcelRequire("pKJVW");

var $9ieQT = parcelRequire("9ieQT");

var $58dhe = parcelRequire("58dhe");

var $5zhxn = parcelRequire("5zhxn");

var $ap9CX = parcelRequire("ap9CX");

var $iiRyl = parcelRequire("iiRyl");
var $a06754d708967e28$export$19131010e7fd8373 = {
    G: new (0, $kfK2H.EraParser)(),
    y: new (0, $7giry.YearParser)(),
    Y: new (0, $bCjfP.LocalWeekYearParser)(),
    R: new (0, $erSGt.ISOWeekYearParser)(),
    u: new (0, $b8jnr.ExtendedYearParser)(),
    Q: new (0, $9AuQQ.QuarterParser)(),
    q: new (0, $fE7CR.StandAloneQuarterParser)(),
    M: new (0, $4rJhG.MonthParser)(),
    L: new (0, $l09IK.StandAloneMonthParser)(),
    w: new (0, $kHjhn.LocalWeekParser)(),
    I: new (0, $ijC3v.ISOWeekParser)(),
    d: new (0, $k1agz.DateParser)(),
    D: new (0, $hfumD.DayOfYearParser)(),
    E: new (0, $34xUW.DayParser)(),
    e: new (0, $1hrH9.LocalDayParser)(),
    c: new (0, $1y17U.StandAloneLocalDayParser)(),
    i: new (0, $lAmiB.ISODayParser)(),
    a: new (0, $hBBos.AMPMParser)(),
    b: new (0, $iaLki.AMPMMidnightParser)(),
    B: new (0, $hjAYL.DayPeriodParser)(),
    h: new (0, $5c3u4.Hour1to12Parser)(),
    H: new (0, $gBHKn.Hour0to23Parser)(),
    K: new (0, $iBp2S.Hour0To11Parser)(),
    k: new (0, $5MoaU.Hour1To24Parser)(),
    m: new (0, $4WIYq.MinuteParser)(),
    s: new (0, $pKJVW.SecondParser)(),
    S: new (0, $9ieQT.FractionOfSecondParser)(),
    X: new (0, $58dhe.ISOTimezoneWithZParser)(),
    x: new (0, $5zhxn.ISOTimezoneParser)(),
    t: new (0, $ap9CX.TimestampSecondsParser)(),
    T: new (0, $iiRyl.TimestampMillisecondsParser)()
};

});
parcelRegister("kfK2H", function(module, exports) {

$parcel$export(module.exports, "EraParser", function () { return $ebe8ec790bf47813$export$8e5a1d3f85a9688; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");
var $ebe8ec790bf47813$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(EraParser, _Parser);
    var _super = (0, $1JyKh.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $fivc7.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 140);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $hUQxR.Parser));

});
parcelRegister("hUQxR", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $d0b06d02a4758be0$export$7acfa6ed01010e37; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $2ryml = parcelRequire("2ryml");

var $bF26l = parcelRequire("bF26l");
var $d0b06d02a4758be0$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $fivc7.default)(this, Parser);
        (0, $2ryml.default)(this, "incompatibleTokens", void 0);
        (0, $2ryml.default)(this, "priority", void 0);
        (0, $2ryml.default)(this, "subPriority", void 0);
    }
    (0, $kuNiL.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $bF26l.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("7giry", function(module, exports) {

$parcel$export(module.exports, "YearParser", function () { return $549855817f3e82c6$export$48d352de7cd4a988; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $549855817f3e82c6$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(YearParser, _Parser);
    var _super = (0, $1JyKh.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $fivc7.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 130);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(4, dateString), valueCallback);
                    case "yo":
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $34rIp.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $hUQxR.Parser));

});
parcelRegister("34rIp", function(module, exports) {

$parcel$export(module.exports, "mapValue", function () { return $23c73e81834f16a1$export$4f84e3a82c7b538; });
$parcel$export(module.exports, "parseNumericPattern", function () { return $23c73e81834f16a1$export$cc7cc9e2a3ff9388; });
$parcel$export(module.exports, "parseTimezonePattern", function () { return $23c73e81834f16a1$export$6497f4c0ecdfba8e; });
$parcel$export(module.exports, "parseAnyDigitsSigned", function () { return $23c73e81834f16a1$export$d931c43c4608a164; });
$parcel$export(module.exports, "parseNDigits", function () { return $23c73e81834f16a1$export$513bb01536146ab6; });
$parcel$export(module.exports, "parseNDigitsSigned", function () { return $23c73e81834f16a1$export$2c9307b2e29c533c; });
$parcel$export(module.exports, "dayPeriodEnumToHours", function () { return $23c73e81834f16a1$export$fb506d2676e7f207; });
$parcel$export(module.exports, "normalizeTwoDigitYear", function () { return $23c73e81834f16a1$export$29126f735cbf69f7; });
$parcel$export(module.exports, "isLeapYearIndex", function () { return $23c73e81834f16a1$export$3d50627710b84d75; });

var $6QTFS = parcelRequire("6QTFS");

var $hTmlY = parcelRequire("hTmlY");
function $23c73e81834f16a1$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $23c73e81834f16a1$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $23c73e81834f16a1$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $6QTFS.millisecondsInHour) + minutes * (0, $6QTFS.millisecondsInMinute) + seconds * (0, $6QTFS.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $23c73e81834f16a1$export$d931c43c4608a164(dateString) {
    return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).anyDigitsSigned, dateString);
}
function $23c73e81834f16a1$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).singleDigit, dateString);
        case 2:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).twoDigits, dateString);
        case 3:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).threeDigits, dateString);
        case 4:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).fourDigits, dateString);
        default:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $23c73e81834f16a1$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $23c73e81834f16a1$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $23c73e81834f16a1$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $23c73e81834f16a1$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("hTmlY", function(module, exports) {

$parcel$export(module.exports, "numericPatterns", function () { return $d068e9ab48ef4207$export$c123ee06d9da8480; });
$parcel$export(module.exports, "timezonePatterns", function () { return $d068e9ab48ef4207$export$a7ee192b982af9c1; });
var $d068e9ab48ef4207$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $d068e9ab48ef4207$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("bCjfP", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", function () { return $87522dd793180ae9$export$b8ef38dfcf05d5db; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");

var $e0HMe = parcelRequire("e0HMe");

var $j1YKz = parcelRequire("j1YKz");
var $87522dd793180ae9$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $1JyKh.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $fivc7.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 130);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $e0HMe.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $34rIp.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $j1YKz.default)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $j1YKz.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $hUQxR.Parser));

});

parcelRegister("erSGt", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", function () { return $a84e016bf722cd37$export$951d1df011fde06f; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");

var $byvVj = parcelRequire("byvVj");
var $a84e016bf722cd37$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $1JyKh.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $fivc7.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 130);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, $34rIp.parseNDigitsSigned)(4, dateString);
                return (0, $34rIp.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $byvVj.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $hUQxR.Parser));

});

parcelRegister("b8jnr", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", function () { return $81af78f43f454158$export$bad9d2ea38e8f1a; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $81af78f43f454158$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(ExtendedYearParser, _Parser);
    var _super = (0, $1JyKh.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $fivc7.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 130);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, $34rIp.parseNDigitsSigned)(4, dateString);
                return (0, $34rIp.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $hUQxR.Parser));

});

parcelRegister("9AuQQ", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", function () { return $6faf6842e3324a5b$export$5cb0f701186dde1d; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $6faf6842e3324a5b$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(QuarterParser, _Parser);
    var _super = (0, $1JyKh.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $fivc7.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 120);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $hUQxR.Parser));

});

parcelRegister("fE7CR", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", function () { return $b64081c42280f47c$export$300c0c2990e20e6d; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $b64081c42280f47c$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $1JyKh.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $fivc7.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 120);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $hUQxR.Parser));

});

parcelRegister("4rJhG", function(module, exports) {

$parcel$export(module.exports, "MonthParser", function () { return $33cccf8698e26325$export$400dd8b40ef138a3; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $34rIp = parcelRequire("34rIp");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");
var $33cccf8698e26325$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(MonthParser, _Parser);
    var _super = (0, $1JyKh.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $fivc7.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 110);
        return _this;
    }
    (0, $kuNiL.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $hUQxR.Parser));

});

parcelRegister("l09IK", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", function () { return $f4a12364ed86f021$export$1d7eaa53eaa5deba; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $f4a12364ed86f021$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $1JyKh.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $fivc7.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 110);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $hUQxR.Parser));

});

parcelRegister("kHjhn", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", function () { return $f116c747f72ce972$export$c4005ffc174e07c0; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");

var $dv4uq = parcelRequire("dv4uq");

var $j1YKz = parcelRequire("j1YKz");
var $f116c747f72ce972$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(LocalWeekParser, _Parser);
    var _super = (0, $1JyKh.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $fivc7.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 100);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $j1YKz.default)((0, $dv4uq.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $hUQxR.Parser));

});
parcelRegister("dv4uq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d41a7323856a4d2$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $bCYgf = parcelRequire("bCYgf");

var $6RzIO = parcelRequire("6RzIO");
function $9d41a7323856a4d2$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var week = (0, $8d3vD.default)(dirtyWeek);
    var diff = (0, $bCYgf.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("ijC3v", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", function () { return $d557856122cd2900$export$6fc8dbedd560a6af; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");

var $eK3pq = parcelRequire("eK3pq");

var $byvVj = parcelRequire("byvVj");
var $d557856122cd2900$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(ISOWeekParser, _Parser);
    var _super = (0, $1JyKh.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $fivc7.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 100);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $byvVj.default)((0, $eK3pq.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $hUQxR.Parser));

});
parcelRegister("eK3pq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abb8018924dbdc39$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $9rMx7 = parcelRequire("9rMx7");

var $6RzIO = parcelRequire("6RzIO");
function $abb8018924dbdc39$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var isoWeek = (0, $8d3vD.default)(dirtyISOWeek);
    var diff = (0, $9rMx7.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("k1agz", function(module, exports) {

$parcel$export(module.exports, "DateParser", function () { return $03c2c5a25468de8c$export$e8d4b28a20981dd2; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $34rIp = parcelRequire("34rIp");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");
var $03c2c5a25468de8c$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $03c2c5a25468de8c$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $03c2c5a25468de8c$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(DateParser, _Parser);
    var _super = (0, $1JyKh.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $fivc7.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 90);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "subPriority", 1);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $34rIp.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $03c2c5a25468de8c$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $03c2c5a25468de8c$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $hUQxR.Parser));

});

parcelRegister("hfumD", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", function () { return $c8eb640c9739e432$export$6cfe0d613455f615; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $c8eb640c9739e432$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(DayOfYearParser, _Parser);
    var _super = (0, $1JyKh.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $fivc7.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 90);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "subpriority", 1);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $34rIp.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $hUQxR.Parser));

});

parcelRegister("34xUW", function(module, exports) {

$parcel$export(module.exports, "DayParser", function () { return $23cc0e1fc897acb6$export$1b03c8b76262f7bd; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $crAxU = parcelRequire("crAxU");
var $23cc0e1fc897acb6$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(DayParser, _Parser);
    var _super = (0, $1JyKh.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $fivc7.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 90);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $crAxU.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $hUQxR.Parser));

});
parcelRegister("crAxU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90f45aecbf821b24$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");

var $dCCOX = parcelRequire("dCCOX");
function $90f45aecbf821b24$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6RzIO.default)(2, arguments);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var weekStartsOn = (0, $8d3vD.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $le96L.default)(dirtyDate);
    var day = (0, $8d3vD.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("1hrH9", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", function () { return $0eecdc9e9334cc90$export$44d1c127ab42c480; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");

var $crAxU = parcelRequire("crAxU");
var $0eecdc9e9334cc90$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(LocalDayParser, _Parser);
    var _super = (0, $1JyKh.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $fivc7.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 90);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $crAxU.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $hUQxR.Parser));

});

parcelRegister("1y17U", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", function () { return $1209d7268c6c9e45$export$e447a647caaaec1d; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");

var $crAxU = parcelRequire("crAxU");
var $1209d7268c6c9e45$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $1JyKh.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $fivc7.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 90);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $crAxU.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $hUQxR.Parser));

});

parcelRegister("lAmiB", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", function () { return $fb6e41e61f98589a$export$693fb1e525095b2a; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");

var $4QPB4 = parcelRequire("4QPB4");
var $fb6e41e61f98589a$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(ISODayParser, _Parser);
    var _super = (0, $1JyKh.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $fivc7.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 90);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, $34rIp.mapValue)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, $34rIp.mapValue)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, $34rIp.mapValue)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, $34rIp.mapValue)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $4QPB4.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $hUQxR.Parser));

});
parcelRegister("4QPB4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38840ad6986b421a$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");
function $38840ad6986b421a$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $6RzIO.default)(2, arguments);
    var day = (0, $8d3vD.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $le96L.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("hBBos", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", function () { return $cd12e5ead675216a$export$8d1e08492351df91; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $cd12e5ead675216a$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(AMPMParser, _Parser);
    var _super = (0, $1JyKh.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $fivc7.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 80);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $34rIp.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $hUQxR.Parser));

});

parcelRegister("iaLki", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", function () { return $d3addf314db295bf$export$73ca2bd0a17d273; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $d3addf314db295bf$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $1JyKh.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $fivc7.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 80);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $34rIp.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $hUQxR.Parser));

});

parcelRegister("hjAYL", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", function () { return $c9b0e545431616d4$export$bb9212adf05373db; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $c9b0e545431616d4$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(DayPeriodParser, _Parser);
    var _super = (0, $1JyKh.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $fivc7.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 80);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $34rIp.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $hUQxR.Parser));

});

parcelRegister("5c3u4", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", function () { return $3c80c6964acf8bae$export$8a04050a727a1756; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $3c80c6964acf8bae$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(Hour1to12Parser, _Parser);
    var _super = (0, $1JyKh.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $fivc7.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 70);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $hUQxR.Parser));

});

parcelRegister("gBHKn", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", function () { return $c1720943b4076094$export$e56f4dea2c3e56dd; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $c1720943b4076094$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(Hour0to23Parser, _Parser);
    var _super = (0, $1JyKh.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $fivc7.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 70);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $hUQxR.Parser));

});

parcelRegister("iBp2S", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", function () { return $d8af1c30a51245af$export$cbbe855312f87d77; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $d8af1c30a51245af$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(Hour0To11Parser, _Parser);
    var _super = (0, $1JyKh.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $fivc7.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 70);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $hUQxR.Parser));

});

parcelRegister("5MoaU", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", function () { return $43543015b40a6495$export$6008046d2b34b6a5; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $43543015b40a6495$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(Hour1To24Parser, _Parser);
    var _super = (0, $1JyKh.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $fivc7.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 70);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $hUQxR.Parser));

});

parcelRegister("4WIYq", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", function () { return $399f7706a432e843$export$2b52670d9e2be53; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $399f7706a432e843$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(MinuteParser, _Parser);
    var _super = (0, $1JyKh.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $fivc7.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 60);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $hUQxR.Parser));

});

parcelRegister("pKJVW", function(module, exports) {

$parcel$export(module.exports, "SecondParser", function () { return $04d6977a32f84464$export$94d46d540cf1366a; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $04d6977a32f84464$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(SecondParser, _Parser);
    var _super = (0, $1JyKh.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $fivc7.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 50);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $hUQxR.Parser));

});

parcelRegister("9ieQT", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", function () { return $6c4150d24044e0a5$export$b8e6f8b2d70893b1; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $6c4150d24044e0a5$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $1JyKh.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $fivc7.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 30);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $hUQxR.Parser));

});

parcelRegister("58dhe", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", function () { return $3bc7ffa050e36def$export$104d901d49fea29b; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $3bc7ffa050e36def$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $1JyKh.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $fivc7.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 10);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basic, dateString);
                    case "XXXX":
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $hUQxR.Parser));

});

parcelRegister("5zhxn", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", function () { return $40ddd330e4d7bdd4$export$12910e5204b52b9; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $40ddd330e4d7bdd4$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $1JyKh.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $fivc7.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 10);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, $kuNiL.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basic, dateString);
                    case "xxxx":
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $hUQxR.Parser));

});

parcelRegister("ap9CX", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", function () { return $7933b4f85229502e$export$2cd8bf877a05e96; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $7933b4f85229502e$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $1JyKh.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $fivc7.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 40);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $kuNiL.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $34rIp.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $hUQxR.Parser));

});

parcelRegister("iiRyl", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", function () { return $d53372f35b035150$export$6d8f69c6906d6368; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $d53372f35b035150$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $1JyKh.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $fivc7.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 20);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $kuNiL.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $34rIp.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $hUQxR.Parser));

});



parcelRegister("9Back", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fcf7ad129e71741$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $6fcf7ad129e71741$export$2e2bcd8739ae039(dirtyDate, dirtyDayOfMonth) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var dayOfMonth = (0, $8d3vD.default)(dirtyDayOfMonth);
    date.setDate(dayOfMonth);
    return date;
}

});

parcelRegister("hBud4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd0d536eff711dcf$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $cd0d536eff711dcf$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var hours = (0, $8d3vD.default)(dirtyHours);
    date.setHours(hours);
    return date;
}

});

parcelRegister("kzEvi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efa67eb820959ebb$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $efa67eb820959ebb$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var minutes = (0, $8d3vD.default)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}

});

parcelRegister("jewTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e008d718aba2e9eb$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $ajF1O = parcelRequire("ajF1O");

var $6RzIO = parcelRequire("6RzIO");
function $e008d718aba2e9eb$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var month = (0, $8d3vD.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $ajF1O.default)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

});

parcelRegister("j1vsN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd968448a852b241$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $dd968448a852b241$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var seconds = (0, $8d3vD.default)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}

});

parcelRegister("585Rh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bc23e7a7ee03bfe$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $3bc23e7a7ee03bfe$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var year = (0, $8d3vD.default)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

});

parcelRegister("krZy8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee3612bcc22c95f6$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $ee3612bcc22c95f6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("a0b1b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7482736b8e287f15$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $8d3vD = parcelRequire("8d3vD");

var $6RzIO = parcelRequire("6RzIO");

var $dCCOX = parcelRequire("dCCOX");
function $7482736b8e287f15$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6RzIO.default)(1, arguments);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var weekStartsOn = (0, $8d3vD.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $le96L.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("cbgMD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8de387f375648f3e$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $8de387f375648f3e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var cleanDate = (0, $le96L.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("25W9h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1869277eefbd126c$export$2e2bcd8739ae039; });

var $6QTFS = parcelRequire("6QTFS");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");
function $1869277eefbd126c$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $6RzIO.default)(1, arguments);
    var additionalDigits = (0, $8d3vD.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = $1869277eefbd126c$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $1869277eefbd126c$var$parseYear(dateStrings.date, additionalDigits);
        date = $1869277eefbd126c$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $1869277eefbd126c$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $1869277eefbd126c$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $1869277eefbd126c$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $1869277eefbd126c$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $1869277eefbd126c$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $1869277eefbd126c$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $1869277eefbd126c$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($1869277eefbd126c$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($1869277eefbd126c$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($1869277eefbd126c$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $1869277eefbd126c$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $1869277eefbd126c$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $1869277eefbd126c$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($1869277eefbd126c$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $1869277eefbd126c$var$parseDateUnit(captures[1]);
    var month = $1869277eefbd126c$var$parseDateUnit(captures[2]) - 1;
    var day = $1869277eefbd126c$var$parseDateUnit(captures[3]);
    var week = $1869277eefbd126c$var$parseDateUnit(captures[4]);
    var dayOfWeek = $1869277eefbd126c$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$1869277eefbd126c$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $1869277eefbd126c$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$1869277eefbd126c$var$validateDate(year, month, day) || !$1869277eefbd126c$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $1869277eefbd126c$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $1869277eefbd126c$var$parseTime(timeString) {
    var captures = timeString.match($1869277eefbd126c$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $1869277eefbd126c$var$parseTimeUnit(captures[1]);
    var minutes = $1869277eefbd126c$var$parseTimeUnit(captures[2]);
    var seconds = $1869277eefbd126c$var$parseTimeUnit(captures[3]);
    if (!$1869277eefbd126c$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $6QTFS.millisecondsInHour) + minutes * (0, $6QTFS.millisecondsInMinute) + seconds * 1000;
}
function $1869277eefbd126c$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $1869277eefbd126c$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match($1869277eefbd126c$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$1869277eefbd126c$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $6QTFS.millisecondsInHour) + minutes * (0, $6QTFS.millisecondsInMinute));
}
function $1869277eefbd126c$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $1869277eefbd126c$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $1869277eefbd126c$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $1869277eefbd126c$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($1869277eefbd126c$var$daysInMonths[month] || ($1869277eefbd126c$var$isLeapYearIndex(year) ? 29 : 28));
}
function $1869277eefbd126c$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($1869277eefbd126c$var$isLeapYearIndex(year) ? 366 : 365);
}
function $1869277eefbd126c$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $1869277eefbd126c$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $1869277eefbd126c$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("2K4GI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ff38398f48a5451$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $jOrUI = parcelRequire("jOrUI");

var $6RzIO = parcelRequire("6RzIO");
function $1ff38398f48a5451$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $6RzIO.default)(1, arguments);
    var originalDate = (0, $le96L.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError("Invalid time value");
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : "extended");
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : "complete");
    if (format !== "extended" && format !== "basic") throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== "date" && representation !== "time" && representation !== "complete") throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = "";
    var tzOffset = "";
    var dateDelimiter = format === "extended" ? "-" : "";
    var timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        var day = (0, $jOrUI.default)(originalDate.getDate(), 2);
        var month = (0, $jOrUI.default)(originalDate.getMonth() + 1, 2);
        var year = (0, $jOrUI.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $jOrUI.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $jOrUI.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? "+" : "-";
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = "Z";
        var hour = (0, $jOrUI.default)(originalDate.getHours(), 2);
        var minute = (0, $jOrUI.default)(originalDate.getMinutes(), 2);
        var second = (0, $jOrUI.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

});

parcelRegister("gDyFX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1cb2fb95fbd857a$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $c1cb2fb95fbd857a$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $6RzIO.default)(2, arguments);
    var time = (0, $le96L.default)(dirtyDate).getTime();
    var startTime = (0, $le96L.default)(interval.start).getTime();
    var endTime = (0, $le96L.default)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError("Invalid interval");
    return time >= startTime && time <= endTime;
}

});

parcelRegister("Js4Jx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $0889fb434ea81f23$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $0889fb434ea81f23$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $0889fb434ea81f23$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $0889fb434ea81f23$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $0889fb434ea81f23$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $0889fb434ea81f23$var$timeLongFormatter(timePattern, formatLong));
};
var $0889fb434ea81f23$var$longFormatters = {
    p: $0889fb434ea81f23$var$timeLongFormatter,
    P: $0889fb434ea81f23$var$dateTimeLongFormatter
};
var $0889fb434ea81f23$var$_default = $0889fb434ea81f23$var$longFormatters;
module.exports.default = $0889fb434ea81f23$var$_default;
module.exports = module.exports.default;

});



parcelRegister("91340", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96b0999b90de1887$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $cSuml = parcelRequire("cSuml");

var $hsjD5 = parcelRequire("hsjD5");

var $5LQ5V = parcelRequire("5LQ5V");

var $6L9uu = parcelRequire("6L9uu");
const $96b0999b90de1887$var$EpraDatePicker = ({ id: id, label: label, value: value, onChange: onChange, sx: sx, minDate: minDate, maxDate: maxDate, errorMsg: errorMsg, disabled: disabled = false, views: views, format: format = (0, $hsjD5.DATE_FORMAT), isWhite: isWhite, hideEndIcon: hideEndIcon = false, clearable: clearable = false })=>{
    const [open, setOpen] = (0, $bh6RR.useState)(false);
    const getParams = (params)=>{
        if (hideEndIcon) return {
            ...params.InputProps,
            endAdornment: ""
        };
        return {
            ...params.InputProps
        };
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cSuml.DesktopDatePicker), {
        label: label,
        inputFormat: format,
        value: value,
        open: open,
        onOpen: ()=>setOpen(true),
        onClose: ()=>setOpen(false),
        onChange: onChange,
        disabled: disabled,
        InputAdornmentProps: {
            sx: {
                marginLeft: 0,
                "& button": {
                    marginRight: 0
                }
            }
        },
        ...clearable && {
            componentsProps: {
                actionBar: {
                    actions: [
                        "clear"
                    ]
                }
            }
        },
        minDate: minDate,
        maxDate: maxDate,
        views: views,
        renderInput: (params)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $5LQ5V.default), {
                ...params,
                id: id,
                disabled: disabled,
                ...errorMsg !== undefined && {
                    error: errorMsg !== null,
                    helperText: errorMsg ?? "",
                    required: true
                },
                sx: {
                    color: errorMsg !== undefined && errorMsg !== null ? (0, $6L9uu.Colors).red : (0, $6L9uu.Colors).main,
                    backgroundColor: isWhite ? "white" : (0, $6L9uu.Colors).input_field_background,
                    height: "36px",
                    borderRadius: "9px",
                    "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                            border: "none"
                        }
                    },
                    ...sx
                },
                InputProps: {
                    ...getParams(params),
                    sx: {
                        paddingRight: 0,
                        position: "relative"
                    }
                },
                FormHelperTextProps: {
                    sx: {
                        marginX: 0
                    }
                },
                InputLabelProps: {
                    shrink: true,
                    sx: {
                        lineHeight: "22px",
                        top: "-9px",
                        color: errorMsg !== undefined && errorMsg !== null ? (0, $6L9uu.Colors).red : (0, $6L9uu.Colors).main
                    }
                },
                inputProps: {
                    ...params.inputProps,
                    sx: {
                        height: "36px",
                        paddingLeft: "15px",
                        paddingY: 0,
                        color: errorMsg !== undefined && errorMsg !== null ? (0, $6L9uu.Colors).red : (0, $6L9uu.Colors).main
                    }
                },
                onClick: ()=>{
                    if (!disabled) setOpen(true);
                }
            })
    });
};
var $96b0999b90de1887$export$2e2bcd8739ae039 = $96b0999b90de1887$var$EpraDatePicker;

});
parcelRegister("cSuml", function(module, exports) {

$parcel$export(module.exports, "DesktopDatePicker", function () { return $960213eaf4c427f6$export$5a73641f0156e1e4; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $7SGq0 = parcelRequire("7SGq0");

var $lOHGi = parcelRequire("lOHGi");

var $55r0a = parcelRequire("55r0a");

var $c8yp0 = parcelRequire("c8yp0");

var $hwnMM = parcelRequire("hwnMM");

var $42A3U = parcelRequire("42A3U");

var $kWl3f = parcelRequire("kWl3f");

var $ih19M = parcelRequire("ih19M");
const $960213eaf4c427f6$var$_excluded = [
    "onChange",
    "PopperProps",
    "PaperProps",
    "ToolbarComponent",
    "TransitionComponent",
    "value",
    "components",
    "componentsProps"
];
const $960213eaf4c427f6$export$5a73641f0156e1e4 = /*#__PURE__*/ $bh6RR.forwardRef(function DesktopDatePicker(inProps, ref) {
    const props = (0, $7SGq0.useDatePickerDefaultizedProps)(inProps, "MuiDesktopDatePicker");
    const validationError = (0, $hwnMM.useDateValidation)(props) !== null;
    const { pickerProps: pickerProps, inputProps: inputProps, wrapperProps: wrapperProps } = (0, $kWl3f.usePickerState)(props, (0, $7SGq0.datePickerValueManager));
    const { PopperProps: PopperProps, PaperProps: PaperProps, ToolbarComponent: ToolbarComponent = (0, $lOHGi.DatePickerToolbar), TransitionComponent: TransitionComponent, components: components, componentsProps: componentsProps } = props, other = (0, $hCIyK.default)(props, $960213eaf4c427f6$var$_excluded);
    const AllDateInputProps = (0, $4WYaH.default)({}, inputProps, other, {
        components: components,
        componentsProps: componentsProps,
        ref: ref,
        validationError: validationError
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $55r0a.DesktopWrapper), (0, $4WYaH.default)({}, wrapperProps, {
        DateInputProps: AllDateInputProps,
        KeyboardDateInputComponent: (0, $42A3U.KeyboardDateInput),
        PopperProps: PopperProps,
        PaperProps: PaperProps,
        TransitionComponent: TransitionComponent,
        components: components,
        componentsProps: componentsProps,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $c8yp0.CalendarOrClockPicker), (0, $4WYaH.default)({}, pickerProps, {
            autoFocus: true,
            toolbarTitle: props.label || props.toolbarTitle,
            ToolbarComponent: ToolbarComponent,
            DateInputProps: AllDateInputProps,
            components: components,
            componentsProps: componentsProps
        }, other))
    }));
});

});
parcelRegister("7SGq0", function(module, exports) {

$parcel$export(module.exports, "isYearOnlyView", function () { return $5bce7af567dc8cf4$export$eb577c89cfdd574a; });
$parcel$export(module.exports, "isYearAndMonthViews", function () { return $5bce7af567dc8cf4$export$2d2db6dbaaf33a55; });
$parcel$export(module.exports, "useDatePickerDefaultizedProps", function () { return $5bce7af567dc8cf4$export$a552c17ed3587731; });
$parcel$export(module.exports, "datePickerValueManager", function () { return $5bce7af567dc8cf4$export$31874dacbbc1e607; });

var $4WYaH = parcelRequire("4WYaH");

var $cNBED = parcelRequire("cNBED");

var $8aNCA = parcelRequire("8aNCA");

var $BN6Vh = parcelRequire("BN6Vh");
const $5bce7af567dc8cf4$export$eb577c89cfdd574a = (views)=>views.length === 1 && views[0] === "year";
const $5bce7af567dc8cf4$export$2d2db6dbaaf33a55 = (views)=>views.length === 2 && views.indexOf("month") !== -1 && views.indexOf("year") !== -1;
const $5bce7af567dc8cf4$var$getFormatAndMaskByViews = (views, utils)=>{
    if ($5bce7af567dc8cf4$export$eb577c89cfdd574a(views)) return {
        inputFormat: utils.formats.year
    };
    if ($5bce7af567dc8cf4$export$2d2db6dbaaf33a55(views)) return {
        disableMaskedInput: true,
        inputFormat: utils.formats.monthAndYear
    };
    return {
        inputFormat: utils.formats.keyboardDate
    };
};
function $5bce7af567dc8cf4$export$a552c17ed3587731(props, name) {
    var _themeProps$views;
    const utils = (0, $8aNCA.useUtils)();
    const defaultDates = (0, $8aNCA.useDefaultDates)(); // This is technically unsound if the type parameters appear in optional props.
    // Optional props can be filled by `useThemeProps` with types that don't match the type parameters.
    const themeProps = (0, $cNBED.default)({
        props: props,
        name: name
    });
    const views = (_themeProps$views = themeProps.views) != null ? _themeProps$views : [
        "year",
        "day"
    ];
    return (0, $4WYaH.default)({
        openTo: "day",
        disableFuture: false,
        disablePast: false
    }, $5bce7af567dc8cf4$var$getFormatAndMaskByViews(views, utils), themeProps, {
        views: views,
        minDate: (0, $BN6Vh.parseNonNullablePickerDate)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $BN6Vh.parseNonNullablePickerDate)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $5bce7af567dc8cf4$export$31874dacbbc1e607 = {
    emptyValue: null,
    getTodayValue: (utils)=>utils.date(),
    parseInput: (0, $BN6Vh.parsePickerInputValue),
    areValuesEqual: (utils, a, b)=>utils.isEqual(a, b)
};

});
parcelRegister("8aNCA", function(module, exports) {

$parcel$export(module.exports, "useLocalizationContext", function () { return $5f35bfaf97f9f986$export$4b5a24245de9f7f9; });
$parcel$export(module.exports, "useUtils", function () { return $5f35bfaf97f9f986$export$1163b47e39508a46; });
$parcel$export(module.exports, "useDefaultDates", function () { return $5f35bfaf97f9f986$export$7c38da3a2e90fa83; });
$parcel$export(module.exports, "useLocaleText", function () { return $5f35bfaf97f9f986$export$24fdeaa0f591a73e; });
$parcel$export(module.exports, "useNow", function () { return $5f35bfaf97f9f986$export$3a404aece3dff2fa; });

var $bh6RR = parcelRequire("bh6RR");

var $e4eIN = parcelRequire("e4eIN");
const $5f35bfaf97f9f986$export$4b5a24245de9f7f9 = ()=>{
    const localization = $bh6RR.useContext((0, $e4eIN.MuiPickersAdapterContext));
    if (localization === null) throw new Error("MUI: Can not find utils in context. It looks like you forgot to wrap your component in LocalizationProvider, or pass dateAdapter prop directly.");
    return localization;
};
const $5f35bfaf97f9f986$export$1163b47e39508a46 = ()=>$5f35bfaf97f9f986$export$4b5a24245de9f7f9().utils;
const $5f35bfaf97f9f986$export$7c38da3a2e90fa83 = ()=>$5f35bfaf97f9f986$export$4b5a24245de9f7f9().defaultDates;
const $5f35bfaf97f9f986$export$24fdeaa0f591a73e = ()=>$5f35bfaf97f9f986$export$4b5a24245de9f7f9().localeText;
const $5f35bfaf97f9f986$export$3a404aece3dff2fa = ()=>{
    const utils = $5f35bfaf97f9f986$export$1163b47e39508a46();
    const now = $bh6RR.useRef(utils.date());
    return now.current;
};

});

parcelRegister("BN6Vh", function(module, exports) {

$parcel$export(module.exports, "findClosestEnabledDate", function () { return $07198d2b91fb379d$export$ca1f317ae8db2ee8; });
$parcel$export(module.exports, "parsePickerInputValue", function () { return $07198d2b91fb379d$export$ec1af8323095accb; });
$parcel$export(module.exports, "parseNonNullablePickerDate", function () { return $07198d2b91fb379d$export$a69dec48c619d8fa; });
const $07198d2b91fb379d$export$ca1f317ae8db2ee8 = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, utils: utils })=>{
    const today = utils.startOfDay(utils.date());
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = utils.date(minDate);
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = utils.date(maxDate);
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    }
    return null;
};
const $07198d2b91fb379d$export$ec1af8323095accb = (utils, value)=>{
    const parsedValue = utils.date(value);
    return utils.isValid(parsedValue) ? parsedValue : null;
};
const $07198d2b91fb379d$export$a69dec48c619d8fa = (utils, value, defaultValue)=>{
    if (value == null) return defaultValue;
    const parsedValue = utils.date(value);
    const isDateValid = utils.isValid(parsedValue);
    if (isDateValid) return parsedValue;
    return defaultValue;
};

});


parcelRegister("lOHGi", function(module, exports) {

$parcel$export(module.exports, "DatePickerToolbar", function () { return $fe2026abbe9487ba$export$21b7f8ea763109eb; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $aitry = parcelRequire("aitry");

var $g4l1t = parcelRequire("g4l1t");
var $cNBED = parcelRequire("cNBED");

var $7J7Kn = parcelRequire("7J7Kn");

var $iFxFm = parcelRequire("iFxFm");

var $8aNCA = parcelRequire("8aNCA");

var $7SGq0 = parcelRequire("7SGq0");

var $l9kPl = parcelRequire("l9kPl");

var $ih19M = parcelRequire("ih19M");
const $fe2026abbe9487ba$var$_excluded = [
    "parsedValue",
    "isLandscape",
    "isMobileKeyboardViewOpen",
    "onChange",
    "toggleMobileKeyboardView",
    "toolbarFormat",
    "toolbarPlaceholder",
    "toolbarTitle",
    "views"
];
const $fe2026abbe9487ba$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        title: [
            "title"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $l9kPl.getDatePickerToolbarUtilityClass), classes);
};
const $fe2026abbe9487ba$var$DatePickerToolbarRoot = (0, $g4l1t.default)((0, $iFxFm.PickersToolbar), {
    name: "MuiDatePickerToolbar",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({});
const $fe2026abbe9487ba$var$DatePickerToolbarTitle = (0, $g4l1t.default)((0, $aitry.default), {
    name: "MuiDatePickerToolbar",
    slot: "Title",
    overridesResolver: (_, styles)=>styles.title
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({}, ownerState.isLandscape && {
        margin: "auto 16px auto auto"
    }));
const $fe2026abbe9487ba$export$21b7f8ea763109eb = /*#__PURE__*/ $bh6RR.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiDatePickerToolbar"
    });
    const { parsedValue: parsedValue, isLandscape: isLandscape, isMobileKeyboardViewOpen: isMobileKeyboardViewOpen, toggleMobileKeyboardView: toggleMobileKeyboardView, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", toolbarTitle: toolbarTitleProp, views: views } = props, other = (0, $hCIyK.default)(props, $fe2026abbe9487ba$var$_excluded);
    const utils = (0, $8aNCA.useUtils)();
    const localeText = (0, $8aNCA.useLocaleText)();
    const classes = $fe2026abbe9487ba$var$useUtilityClasses(props);
    const toolbarTitle = toolbarTitleProp != null ? toolbarTitleProp : localeText.datePickerDefaultToolbarTitle;
    const dateText = $bh6RR.useMemo(()=>{
        if (!parsedValue) return toolbarPlaceholder;
        if (toolbarFormat) return utils.formatByString(parsedValue, toolbarFormat);
        if ((0, $7SGq0.isYearOnlyView)(views)) return utils.format(parsedValue, "year");
        if ((0, $7SGq0.isYearAndMonthViews)(views)) return utils.format(parsedValue, "month");
         // Little localization hack (Google is doing the same for android native pickers):
        // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
        // For other locales using strings like "June 1", without weekday.
        return /en/.test(utils.getCurrentLocaleCode()) ? utils.format(parsedValue, "normalDateWithWeekday") : utils.format(parsedValue, "normalDate");
    }, [
        parsedValue,
        toolbarFormat,
        toolbarPlaceholder,
        utils,
        views
    ]);
    const ownerState = props;
    return /*#__PURE__*/ (0, $ih19M.jsx)($fe2026abbe9487ba$var$DatePickerToolbarRoot, (0, $4WYaH.default)({
        ref: ref,
        toolbarTitle: toolbarTitle,
        isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
        toggleMobileKeyboardView: toggleMobileKeyboardView,
        isLandscape: isLandscape,
        className: classes.root
    }, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)($fe2026abbe9487ba$var$DatePickerToolbarTitle, {
            variant: "h4",
            align: isLandscape ? "left" : "center",
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});

});
parcelRegister("iFxFm", function(module, exports) {

$parcel$export(module.exports, "PickersToolbar", function () { return $d9762bbd0bc22495$export$eb3c4d84783d6feb; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $d56pS = parcelRequire("d56pS");

var $ePCTs = parcelRequire("ePCTs");

var $aitry = parcelRequire("aitry");

var $am7GZ = parcelRequire("am7GZ");

var $g4l1t = parcelRequire("g4l1t");
var $cNBED = parcelRequire("cNBED");

var $7J7Kn = parcelRequire("7J7Kn");

var $7W0sU = parcelRequire("7W0sU");

var $8aNCA = parcelRequire("8aNCA");

var $ihv4a = parcelRequire("ihv4a");

var $ih19M = parcelRequire("ih19M");
const $d9762bbd0bc22495$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        content: [
            "content"
        ],
        penIconButton: [
            "penIconButton",
            isLandscape && "penIconButtonLandscape"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $ihv4a.getPickersToolbarUtilityClass), classes);
};
const $d9762bbd0bc22495$var$PickersToolbarRoot = (0, $g4l1t.default)("div", {
    name: "MuiPickersToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "space-between",
        padding: theme.spacing(2, 3)
    }, ownerState.isLandscape && {
        height: "auto",
        maxWidth: 160,
        padding: 16,
        justifyContent: "flex-start",
        flexWrap: "wrap"
    }));
const $d9762bbd0bc22495$var$PickersToolbarContent = (0, $g4l1t.default)((0, $ePCTs.default), {
    name: "MuiPickersToolbar",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        flex: 1
    }, !ownerState.isLandscape && {
        alignItems: "center"
    }));
const $d9762bbd0bc22495$var$PickersToolbarPenIconButton = (0, $g4l1t.default)((0, $am7GZ.default), {
    name: "MuiPickersToolbar",
    slot: "PenIconButton",
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $ihv4a.pickersToolbarClasses).penIconButtonLandscape}`]: styles.penIconButtonLandscape
            },
            styles.penIconButton
        ]
})({});
const $d9762bbd0bc22495$var$getViewTypeIcon = (viewType)=>viewType === "clock" ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $7W0sU.Clock), {
        color: "inherit"
    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $7W0sU.Calendar), {
        color: "inherit"
    });
const $d9762bbd0bc22495$export$eb3c4d84783d6feb = /*#__PURE__*/ $bh6RR.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiPickersToolbar"
    });
    const { children: children, className: className, getMobileKeyboardInputViewButtonText: getMobileKeyboardInputViewButtonText, isLandscape: isLandscape, isMobileKeyboardViewOpen: isMobileKeyboardViewOpen, landscapeDirection: landscapeDirection = "column", toggleMobileKeyboardView: toggleMobileKeyboardView, toolbarTitle: toolbarTitle, viewType: viewType = "calendar" } = props;
    const ownerState = props;
    const localeText = (0, $8aNCA.useLocaleText)();
    const classes = $d9762bbd0bc22495$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($d9762bbd0bc22495$var$PickersToolbarRoot, {
        ref: ref,
        className: (0, $d56pS.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), {
                color: "text.secondary",
                variant: "overline",
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)($d9762bbd0bc22495$var$PickersToolbarContent, {
                container: true,
                justifyContent: "space-between",
                className: classes.content,
                ownerState: ownerState,
                direction: isLandscape ? landscapeDirection : "row",
                alignItems: isLandscape ? "flex-start" : "flex-end",
                children: [
                    children,
                    /*#__PURE__*/ (0, $ih19M.jsx)($d9762bbd0bc22495$var$PickersToolbarPenIconButton, {
                        onClick: toggleMobileKeyboardView,
                        className: classes.penIconButton,
                        ownerState: ownerState,
                        color: "inherit",
                        "aria-label": getMobileKeyboardInputViewButtonText ? getMobileKeyboardInputViewButtonText(isMobileKeyboardViewOpen, viewType) : localeText.inputModeToggleButtonAriaLabel(isMobileKeyboardViewOpen, viewType),
                        children: isMobileKeyboardViewOpen ? $d9762bbd0bc22495$var$getViewTypeIcon(viewType) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $7W0sU.Pen), {
                            color: "inherit"
                        })
                    })
                ]
            })
        ]
    });
});

});
parcelRegister("d56pS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9860b829ea3e34f5$export$2e2bcd8739ae039; });
function $9860b829ea3e34f5$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $9860b829ea3e34f5$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $9860b829ea3e34f5$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $9860b829ea3e34f5$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $9860b829ea3e34f5$export$2e2bcd8739ae039 = $9860b829ea3e34f5$export$4f5d2d50c9deca37;

});

parcelRegister("7W0sU", function(module, exports) {

$parcel$export(module.exports, "ArrowDropDown", function () { return $5c6e4f92d208c12b$export$6243d250c3142fa2; });
$parcel$export(module.exports, "ArrowLeft", function () { return $5c6e4f92d208c12b$export$e4c291d45fea4cd0; });
$parcel$export(module.exports, "ArrowRight", function () { return $5c6e4f92d208c12b$export$acad20503ad73ac1; });
$parcel$export(module.exports, "Calendar", function () { return $5c6e4f92d208c12b$export$e1aef45b828286de; });
$parcel$export(module.exports, "Clock", function () { return $5c6e4f92d208c12b$export$9735c82c4bae3302; });
$parcel$export(module.exports, "Pen", function () { return $5c6e4f92d208c12b$export$54c11739735d3a0a; });

var $7B0TL = parcelRequire("7B0TL");

var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");
const $5c6e4f92d208c12b$export$6243d250c3142fa2 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
const $5c6e4f92d208c12b$export$e4c291d45fea4cd0 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft");
const $5c6e4f92d208c12b$export$acad20503ad73ac1 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight");
const $5c6e4f92d208c12b$export$e1aef45b828286de = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar");
const $5c6e4f92d208c12b$export$9735c82c4bae3302 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), "Clock");
const $5c6e4f92d208c12b$export$829bd850c745b6e = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
const $5c6e4f92d208c12b$export$54c11739735d3a0a = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), "Pen");
const $5c6e4f92d208c12b$export$680ea196effce5f = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), "Time");

});

parcelRegister("ihv4a", function(module, exports) {

$parcel$export(module.exports, "getPickersToolbarUtilityClass", function () { return $d4f1e9a490aad19e$export$b109c489973c3d80; });
$parcel$export(module.exports, "pickersToolbarClasses", function () { return $d4f1e9a490aad19e$export$59f09e5e2b3d9913; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
function $d4f1e9a490aad19e$export$b109c489973c3d80(slot) {
    return (0, $XybB6.default)("MuiPickersToolbar", slot);
}
const $d4f1e9a490aad19e$export$59f09e5e2b3d9913 = (0, $igcUF.default)("MuiPickersToolbar", [
    "root",
    "content",
    "penIconButton",
    "penIconButtonLandscape"
]);

});


parcelRegister("l9kPl", function(module, exports) {

$parcel$export(module.exports, "getDatePickerToolbarUtilityClass", function () { return $f65a980efb8b7921$export$a1c3879af2c3b694; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
function $f65a980efb8b7921$export$a1c3879af2c3b694(slot) {
    return (0, $XybB6.default)("MuiDatePickerToolbar", slot);
}
const $f65a980efb8b7921$export$2e35fa7d24ef4179 = (0, $igcUF.default)("MuiDatePickerToolbar", [
    "root",
    "title"
]);

});


parcelRegister("55r0a", function(module, exports) {

$parcel$export(module.exports, "DesktopWrapper", function () { return $3b425d60bb58530c$export$f368505c531184b6; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $erAkb = parcelRequire("erAkb");

var $gHJ0l = parcelRequire("gHJ0l");

var $6T0g8 = parcelRequire("6T0g8");

var $ih19M = parcelRequire("ih19M");
function $3b425d60bb58530c$export$f368505c531184b6(props) {
    const { children: children, DateInputProps: DateInputProps, KeyboardDateInputComponent: KeyboardDateInputComponent, onClear: onClear, onDismiss: onDismiss, onCancel: onCancel, onAccept: onAccept, onSetToday: onSetToday, open: open, PopperProps: PopperProps, PaperProps: PaperProps, TransitionComponent: TransitionComponent, components: components, componentsProps: componentsProps } = props;
    const ownInputRef = $bh6RR.useRef(null);
    const inputRef = (0, $erAkb.default)(DateInputProps.inputRef, ownInputRef);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $gHJ0l.WrapperVariantContext).Provider, {
        value: "desktop",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)(KeyboardDateInputComponent, (0, $4WYaH.default)({}, DateInputProps, {
                inputRef: inputRef
            })),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $6T0g8.PickersPopper), {
                role: "dialog",
                open: open,
                anchorEl: ownInputRef.current,
                TransitionComponent: TransitionComponent,
                PopperProps: PopperProps,
                PaperProps: PaperProps,
                onClose: onDismiss,
                onCancel: onCancel,
                onClear: onClear,
                onAccept: onAccept,
                onSetToday: onSetToday,
                components: components,
                componentsProps: componentsProps,
                children: children
            })
        ]
    });
}

});
parcelRegister("gHJ0l", function(module, exports) {

$parcel$export(module.exports, "WrapperVariantContext", function () { return $c29392775b4c1659$export$b4ddd57e25df14cc; });

var $bh6RR = parcelRequire("bh6RR");
const $c29392775b4c1659$export$b4ddd57e25df14cc = /*#__PURE__*/ $bh6RR.createContext(null);

});

parcelRegister("6T0g8", function(module, exports) {

$parcel$export(module.exports, "PickersPopper", function () { return $014b3a238f734e1b$export$96ce8482474de8a5; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $clZiP = parcelRequire("clZiP");

var $iTI7v = parcelRequire("iTI7v");

var $9tY0V = parcelRequire("9tY0V");

var $jfyRA = parcelRequire("jfyRA");

var $27yUY = parcelRequire("27yUY");
var $8M7SI = parcelRequire("8M7SI");
var $erAkb = parcelRequire("erAkb");

var $g4l1t = parcelRequire("g4l1t");
var $cNBED = parcelRequire("cNBED");

var $7J7Kn = parcelRequire("7J7Kn");

var $hA9zo = parcelRequire("hA9zo");

var $aIgPg = parcelRequire("aIgPg");

var $3xeL1 = parcelRequire("3xeL1");

var $ih19M = parcelRequire("ih19M");
const $014b3a238f734e1b$var$_excluded = [
    "onClick",
    "onTouchStart"
];
const $014b3a238f734e1b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $aIgPg.getPickersPopperUtilityClass), classes);
};
const $014b3a238f734e1b$var$PickersPopperRoot = (0, $g4l1t.default)((0, $9tY0V.default), {
    name: "MuiPickersPopper",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $014b3a238f734e1b$var$PickersPopperPaper = (0, $g4l1t.default)((0, $iTI7v.default), {
    name: "MuiPickersPopper",
    slot: "Paper",
    overridesResolver: (_, styles)=>styles.paper
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        transformOrigin: "top center",
        outline: 0
    }, ownerState.placement === "top" && {
        transformOrigin: "bottom center"
    }));
function $014b3a238f734e1b$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function $014b3a238f734e1b$var$useClickAwayListener(active, onClickAway) {
    const movedRef = $bh6RR.useRef(false);
    const syntheticEventRef = $bh6RR.useRef(false);
    const nodeRef = $bh6RR.useRef(null);
    const activatedRef = $bh6RR.useRef(false);
    $bh6RR.useEffect(()=>{
        if (!active) return undefined;
         // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener("mousedown", armClickAwayListener, true);
        document.addEventListener("touchstart", armClickAwayListener, true);
        return ()=>{
            document.removeEventListener("mousedown", armClickAwayListener, true);
            document.removeEventListener("touchstart", armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]); // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $8M7SI.default)((event)=>{
        if (!activatedRef.current) return;
         // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $27yUY.default)(nodeRef.current); // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        "clientX" in event && $014b3a238f734e1b$var$clickedRootScrollbar(event, doc)) return;
         // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    }); // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = ()=>{
        syntheticEventRef.current = true;
    };
    $bh6RR.useEffect(()=>{
        if (active) {
            const doc = (0, $27yUY.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener("touchstart", handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener("touchstart", handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    $bh6RR.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (e.g. setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, $27yUY.default)(nodeRef.current);
            doc.addEventListener("click", handleClickAway);
            return ()=>{
                doc.removeEventListener("click", handleClickAway); // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
function $014b3a238f734e1b$export$96ce8482474de8a5(inProps) {
    var _components$ActionBar;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiPickersPopper"
    });
    const { anchorEl: anchorEl, children: children, containerRef: containerRef = null, onBlur: onBlur, onClose: onClose, onClear: onClear, onAccept: onAccept, onCancel: onCancel, onSetToday: onSetToday, open: open, PopperProps: PopperProps, role: role, TransitionComponent: TransitionComponent = (0, $clZiP.default), TrapFocusProps: TrapFocusProps, PaperProps: PaperProps = {}, components: components, componentsProps: componentsProps } = props;
    $bh6RR.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (open && (nativeEvent.key === "Escape" || nativeEvent.key === "Esc")) onClose();
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        onClose,
        open
    ]);
    const lastFocusedElementRef = $bh6RR.useRef(null);
    $bh6RR.useEffect(()=>{
        if (role === "tooltip") return;
        if (open) lastFocusedElementRef.current = (0, $3xeL1.getActiveElement)(document);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        role
    ]);
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = $014b3a238f734e1b$var$useClickAwayListener(open, onBlur != null ? onBlur : onClose);
    const paperRef = $bh6RR.useRef(null);
    const handleRef = (0, $erAkb.default)(paperRef, containerRef);
    const handlePaperRef = (0, $erAkb.default)(handleRef, clickAwayRef);
    const ownerState = props;
    const classes = $014b3a238f734e1b$var$useUtilityClasses(ownerState);
    const { onClick: onPaperClickProp, onTouchStart: onPaperTouchStartProp } = PaperProps, otherPaperProps = (0, $hCIyK.default)(PaperProps, $014b3a238f734e1b$var$_excluded);
    const handleKeyDown = (event)=>{
        if (event.key === "Escape") {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            onClose();
        }
    };
    const ActionBar = (_components$ActionBar = components == null ? void 0 : components.ActionBar) != null ? _components$ActionBar : (0, $hA9zo.PickersActionBar);
    const PaperContent = (components == null ? void 0 : components.PaperContent) || $bh6RR.Fragment;
    return /*#__PURE__*/ (0, $ih19M.jsx)($014b3a238f734e1b$var$PickersPopperRoot, (0, $4WYaH.default)({
        transition: true,
        role: role,
        open: open,
        anchorEl: anchorEl,
        onKeyDown: handleKeyDown,
        className: classes.root
    }, PopperProps, {
        children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $jfyRA.FocusTrap), (0, $4WYaH.default)({
                open: open,
                disableAutoFocus: true // pickers are managing focus position manually
                ,
                disableRestoreFocus: true,
                disableEnforceFocus: role === "tooltip",
                isEnabled: ()=>true
            }, TrapFocusProps, {
                children: /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({}, TransitionProps, {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)($014b3a238f734e1b$var$PickersPopperPaper, (0, $4WYaH.default)({
                        tabIndex: -1,
                        elevation: 8,
                        ref: handlePaperRef,
                        onClick: (event)=>{
                            onPaperClick(event);
                            if (onPaperClickProp) onPaperClickProp(event);
                        },
                        onTouchStart: (event)=>{
                            onPaperTouchStart(event);
                            if (onPaperTouchStartProp) onPaperTouchStartProp(event);
                        },
                        ownerState: (0, $4WYaH.default)({}, ownerState, {
                            placement: placement
                        }),
                        className: classes.paper
                    }, otherPaperProps, {
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)(PaperContent, (0, $4WYaH.default)({}, componentsProps == null ? void 0 : componentsProps.paperContent, {
                            children: [
                                children,
                                /*#__PURE__*/ (0, $ih19M.jsx)(ActionBar, (0, $4WYaH.default)({
                                    onAccept: onAccept,
                                    onClear: onClear,
                                    onCancel: onCancel,
                                    onSetToday: onSetToday,
                                    actions: []
                                }, componentsProps == null ? void 0 : componentsProps.actionBar))
                            ]
                        }))
                    }))
                }))
            }))
    }));
}

});
parcelRegister("9tY0V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e755ffe50bec2db$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $4vuMJ = parcelRequire("4vuMJ");

var $kQpxx = parcelRequire("kQpxx");




var $bh6RR = parcelRequire("bh6RR");

var $g4l1t = parcelRequire("g4l1t");
var $cNBED = parcelRequire("cNBED");

var $ih19M = parcelRequire("ih19M");
"use client";
const $6e755ffe50bec2db$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $6e755ffe50bec2db$var$PopperRoot = (0, $g4l1t.default)((0, $4vuMJ.Popper), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $6e755ffe50bec2db$var$Popper = /*#__PURE__*/ $bh6RR.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($kQpxx)))();
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $hCIyK.default)(props, $6e755ffe50bec2db$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $4WYaH.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $ih19M.jsx)($6e755ffe50bec2db$var$PopperRoot, (0, $4WYaH.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $6e755ffe50bec2db$export$2e2bcd8739ae039 = $6e755ffe50bec2db$var$Popper;

});
parcelRegister("4vuMJ", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $3481eff2a151f79e$export$badac9ada3a0bdf9; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");

var $7TDiU = parcelRequire("7TDiU");
var $joJqx = parcelRequire("joJqx");
var $fpwfv = parcelRequire("fpwfv");

var $fZq58 = parcelRequire("fZq58");


var $7J7Kn = parcelRequire("7J7Kn");

var $8FFT1 = parcelRequire("8FFT1");

var $gQU2u = parcelRequire("gQU2u");

var $7ITag = parcelRequire("7ITag");

var $9qLIm = parcelRequire("9qLIm");

var $ih19M = parcelRequire("ih19M");
"use client";
const $3481eff2a151f79e$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $3481eff2a151f79e$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $3481eff2a151f79e$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $3481eff2a151f79e$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $3481eff2a151f79e$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $3481eff2a151f79e$var$isVirtualElement(element) {
    return !$3481eff2a151f79e$var$isHTMLElement(element);
}
const $3481eff2a151f79e$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $9qLIm.useClassNamesOverride)((0, $gQU2u.getPopperUtilityClass)));
};
const $3481eff2a151f79e$var$defaultPopperOptions = {};
const $3481eff2a151f79e$var$PopperTooltip = /*#__PURE__*/ $bh6RR.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $hCIyK.default)(props, $3481eff2a151f79e$var$_excluded);
    const tooltipRef = $bh6RR.useRef(null);
    const ownRef = (0, $fpwfv.default)(tooltipRef, forwardedRef);
    const popperRef = $bh6RR.useRef(null);
    const handlePopperRef = (0, $fpwfv.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $bh6RR.useRef(handlePopperRef);
    (0, $joJqx.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $bh6RR.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $3481eff2a151f79e$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $bh6RR.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $bh6RR.useState($3481eff2a151f79e$var$resolveAnchorEl(anchorEl));
    $bh6RR.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $bh6RR.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($3481eff2a151f79e$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $joJqx.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $fZq58.createPopper)(resolvedAnchorElement, tooltipRef.current, (0, $4WYaH.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $3481eff2a151f79e$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $7ITag.useSlotProps)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)(Root, (0, $4WYaH.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */ const $3481eff2a151f79e$export$badac9ada3a0bdf9 = /*#__PURE__*/ $bh6RR.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $3481eff2a151f79e$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $hCIyK.default)(props, $3481eff2a151f79e$var$_excluded2);
    const [exited, setExited] = $bh6RR.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $3481eff2a151f79e$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $3481eff2a151f79e$var$isHTMLElement(resolvedAnchorEl) ? (0, $7TDiU.default)(resolvedAnchorEl).body : (0, $7TDiU.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8FFT1.Portal), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($3481eff2a151f79e$var$PopperTooltip, (0, $4WYaH.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $4WYaH.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});

});
parcelRegister("fZq58", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $ba40c8d2bf74e5cd$export$8f7491d57c8f97a9; });

var $fTJao = parcelRequire("fTJao");

var $745n9 = parcelRequire("745n9");

var $4mt2C = parcelRequire("4mt2C");

var $2SszJ = parcelRequire("2SszJ");

var $5KdgE = parcelRequire("5KdgE");

var $eqE9J = parcelRequire("eqE9J");

var $5QuYB = parcelRequire("5QuYB");

var $fVANH = parcelRequire("fVANH");

var $7HVwH = parcelRequire("7HVwH");

var $9bSGP = parcelRequire("9bSGP");


var $ba40c8d2bf74e5cd$export$d34966752335dd47 = [
    (0, $745n9.default),
    (0, $4mt2C.default),
    (0, $2SszJ.default),
    (0, $5KdgE.default),
    (0, $eqE9J.default),
    (0, $5QuYB.default),
    (0, $fVANH.default),
    (0, $7HVwH.default),
    (0, $9bSGP.default)
];
var $ba40c8d2bf74e5cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $fTJao.popperGenerator)({
    defaultModifiers: $ba40c8d2bf74e5cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("fTJao", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $b92f073993d3fb52$export$ed5e13716264f202; });

var $2HKsI = parcelRequire("2HKsI");

var $7oVdA = parcelRequire("7oVdA");

var $iJYQU = parcelRequire("iJYQU");

var $aI24A = parcelRequire("aI24A");

var $2J8Wv = parcelRequire("2J8Wv");

var $1hlpY = parcelRequire("1hlpY");

var $jvpLE = parcelRequire("jvpLE");


var $1c9xk = parcelRequire("1c9xk");
var $b92f073993d3fb52$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $b92f073993d3fb52$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $b92f073993d3fb52$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b92f073993d3fb52$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $b92f073993d3fb52$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $1c9xk.isElement)(reference) ? (0, $iJYQU.default)(reference) : reference.contextElement ? (0, $iJYQU.default)(reference.contextElement) : [],
                    popper: (0, $iJYQU.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $2J8Wv.default)((0, $jvpLE.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b92f073993d3fb52$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $2HKsI.default)(reference, (0, $aI24A.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $7oVdA.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $1hlpY.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b92f073993d3fb52$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b92f073993d3fb52$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b92f073993d3fb52$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("2HKsI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f83a3590a58ca81$export$2e2bcd8739ae039; });

var $bsh7Q = parcelRequire("bsh7Q");

var $arVrm = parcelRequire("arVrm");

var $a72Qo = parcelRequire("a72Qo");

var $1c9xk = parcelRequire("1c9xk");

var $2vFiA = parcelRequire("2vFiA");

var $oVXMR = parcelRequire("oVXMR");

var $juuAX = parcelRequire("juuAX");

var $cQirN = parcelRequire("cQirN");
function $1f83a3590a58ca81$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $cQirN.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $cQirN.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $1f83a3590a58ca81$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $1c9xk.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $1c9xk.isHTMLElement)(offsetParent) && $1f83a3590a58ca81$var$isElementScaled(offsetParent);
    var documentElement = (0, $oVXMR.default)(offsetParent);
    var rect = (0, $bsh7Q.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $a72Qo.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $juuAX.default)(documentElement)) scroll = (0, $arVrm.default)(offsetParent);
        if ((0, $1c9xk.isHTMLElement)(offsetParent)) {
            offsets = (0, $bsh7Q.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $2vFiA.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("bsh7Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $856f97fdf7a31786$export$2e2bcd8739ae039; });

var $1c9xk = parcelRequire("1c9xk");

var $cQirN = parcelRequire("cQirN");

var $fWtCY = parcelRequire("fWtCY");

var $f2h41 = parcelRequire("f2h41");
function $856f97fdf7a31786$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $1c9xk.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $cQirN.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $cQirN.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $1c9xk.isElement)(element) ? (0, $fWtCY.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $f2h41.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("1c9xk", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $0dee4f2dddb22277$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $0dee4f2dddb22277$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $0dee4f2dddb22277$export$af51f0f06c0f328a; });

var $fWtCY = parcelRequire("fWtCY");
function $0dee4f2dddb22277$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $fWtCY.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $0dee4f2dddb22277$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $fWtCY.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $0dee4f2dddb22277$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $fWtCY.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("fWtCY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9b3413274c87e21$export$2e2bcd8739ae039; });
function $b9b3413274c87e21$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("cQirN", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $9598a69d154bbd1e$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $9598a69d154bbd1e$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $9598a69d154bbd1e$export$2077e0241d6afd3c; });
var $9598a69d154bbd1e$export$8960430cfd85939f = Math.max;
var $9598a69d154bbd1e$export$96ec731ed4dcb222 = Math.min;
var $9598a69d154bbd1e$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("f2h41", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af244778ac85956c$export$2e2bcd8739ae039; });

var $eFBAH = parcelRequire("eFBAH");
function $af244778ac85956c$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $eFBAH.default)());
}

});
parcelRegister("eFBAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aae20dd24c8de568$export$2e2bcd8739ae039; });
function $aae20dd24c8de568$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRegister("arVrm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01f698b37b56f293$export$2e2bcd8739ae039; });

var $6uoC5 = parcelRequire("6uoC5");

var $fWtCY = parcelRequire("fWtCY");

var $1c9xk = parcelRequire("1c9xk");

var $ea8tK = parcelRequire("ea8tK");
function $01f698b37b56f293$export$2e2bcd8739ae039(node) {
    if (node === (0, $fWtCY.default)(node) || !(0, $1c9xk.isHTMLElement)(node)) return (0, $6uoC5.default)(node);
    else return (0, $ea8tK.default)(node);
}

});
parcelRegister("6uoC5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b98a3172bacf8ec$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");
function $4b98a3172bacf8ec$export$2e2bcd8739ae039(node) {
    var win = (0, $fWtCY.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ea8tK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4f89398deb81d5a$export$2e2bcd8739ae039; });
function $a4f89398deb81d5a$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("a72Qo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75ccc39d2a806d7f$export$2e2bcd8739ae039; });
function $75ccc39d2a806d7f$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("2vFiA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d3e8317bca2b13b$export$2e2bcd8739ae039; });

var $bsh7Q = parcelRequire("bsh7Q");

var $oVXMR = parcelRequire("oVXMR");

var $6uoC5 = parcelRequire("6uoC5");
function $1d3e8317bca2b13b$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $bsh7Q.default)((0, $oVXMR.default)(element)).left + (0, $6uoC5.default)(element).scrollLeft;
}

});
parcelRegister("oVXMR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04af344fb3b2461e$export$2e2bcd8739ae039; });

var $1c9xk = parcelRequire("1c9xk");
function $04af344fb3b2461e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $1c9xk.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("juuAX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3088d3b293d3951$export$2e2bcd8739ae039; });

var $2L33g = parcelRequire("2L33g");
function $e3088d3b293d3951$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $2L33g.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("2L33g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $202256889fb084f4$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");
function $202256889fb084f4$export$2e2bcd8739ae039(element) {
    return (0, $fWtCY.default)(element).getComputedStyle(element);
}

});



parcelRegister("7oVdA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $563728a12da0f86b$export$2e2bcd8739ae039; });

var $bsh7Q = parcelRequire("bsh7Q");
function $563728a12da0f86b$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $bsh7Q.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("iJYQU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da4ba1ff29e25ddd$export$2e2bcd8739ae039; });

var $l4kGm = parcelRequire("l4kGm");

var $aSiof = parcelRequire("aSiof");

var $fWtCY = parcelRequire("fWtCY");

var $juuAX = parcelRequire("juuAX");
function $da4ba1ff29e25ddd$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $l4kGm.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $fWtCY.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $juuAX.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($da4ba1ff29e25ddd$export$2e2bcd8739ae039((0, $aSiof.default)(target)));
}

});
parcelRegister("l4kGm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f56a03bea423dc7d$export$2e2bcd8739ae039; });

var $aSiof = parcelRequire("aSiof");

var $juuAX = parcelRequire("juuAX");

var $a72Qo = parcelRequire("a72Qo");

var $1c9xk = parcelRequire("1c9xk");
function $f56a03bea423dc7d$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $a72Qo.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $1c9xk.isHTMLElement)(node) && (0, $juuAX.default)(node)) return node;
    return $f56a03bea423dc7d$export$2e2bcd8739ae039((0, $aSiof.default)(node));
}

});
parcelRegister("aSiof", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ead366da1fe435a$export$2e2bcd8739ae039; });

var $a72Qo = parcelRequire("a72Qo");

var $oVXMR = parcelRequire("oVXMR");

var $1c9xk = parcelRequire("1c9xk");
function $7ead366da1fe435a$export$2e2bcd8739ae039(element) {
    if ((0, $a72Qo.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $1c9xk.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $oVXMR.default)(element) // fallback
    );
}

});



parcelRegister("aI24A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cbf9f1a43b4b54b$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");

var $a72Qo = parcelRequire("a72Qo");

var $2L33g = parcelRequire("2L33g");

var $1c9xk = parcelRequire("1c9xk");

var $bJ3lS = parcelRequire("bJ3lS");

var $aSiof = parcelRequire("aSiof");

var $eFBAH = parcelRequire("eFBAH");
function $7cbf9f1a43b4b54b$var$getTrueOffsetParent(element) {
    if (!(0, $1c9xk.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $2L33g.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $7cbf9f1a43b4b54b$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $eFBAH.default)());
    var isIE = /Trident/i.test((0, $eFBAH.default)());
    if (isIE && (0, $1c9xk.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $2L33g.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $aSiof.default)(element);
    if ((0, $1c9xk.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $1c9xk.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $a72Qo.default)(currentNode)) < 0){
        var css = (0, $2L33g.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $7cbf9f1a43b4b54b$export$2e2bcd8739ae039(element) {
    var window = (0, $fWtCY.default)(element);
    var offsetParent = $7cbf9f1a43b4b54b$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $bJ3lS.default)(offsetParent) && (0, $2L33g.default)(offsetParent).position === "static")offsetParent = $7cbf9f1a43b4b54b$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $a72Qo.default)(offsetParent) === "html" || (0, $a72Qo.default)(offsetParent) === "body" && (0, $2L33g.default)(offsetParent).position === "static")) return window;
    return offsetParent || $7cbf9f1a43b4b54b$var$getContainingBlock(element) || window;
}

});
parcelRegister("bJ3lS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88967f4bf6e216d4$export$2e2bcd8739ae039; });

var $a72Qo = parcelRequire("a72Qo");
function $88967f4bf6e216d4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $a72Qo.default)(element)) >= 0;
}

});


parcelRegister("2J8Wv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fc6b88d850995f4$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");
function $1fc6b88d850995f4$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $1fc6b88d850995f4$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $1fc6b88d850995f4$var$order(modifiers); // order based on phase
    return (0, $5juCh.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("5juCh", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $3de679e4868fd918$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $3de679e4868fd918$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $3de679e4868fd918$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $3de679e4868fd918$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $3de679e4868fd918$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $3de679e4868fd918$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $3de679e4868fd918$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $3de679e4868fd918$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $3de679e4868fd918$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $3de679e4868fd918$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $3de679e4868fd918$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $3de679e4868fd918$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $3de679e4868fd918$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $3de679e4868fd918$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $3de679e4868fd918$export$d087d3878fdf71d5; });
var $3de679e4868fd918$export$1e95b668f3b82d = "top";
var $3de679e4868fd918$export$40e543e69a8b3fbb = "bottom";
var $3de679e4868fd918$export$79ffe56a765070d2 = "right";
var $3de679e4868fd918$export$eabcd2c8791e7bf4 = "left";
var $3de679e4868fd918$export$dfb5619354ba860 = "auto";
var $3de679e4868fd918$export$aec2ce47c367b8c3 = [
    $3de679e4868fd918$export$1e95b668f3b82d,
    $3de679e4868fd918$export$40e543e69a8b3fbb,
    $3de679e4868fd918$export$79ffe56a765070d2,
    $3de679e4868fd918$export$eabcd2c8791e7bf4
];
var $3de679e4868fd918$export$b3571188c770cc5a = "start";
var $3de679e4868fd918$export$bd5df0f255a350f8 = "end";
var $3de679e4868fd918$export$390fd549c5303b4d = "clippingParents";
var $3de679e4868fd918$export$d7b7311ec04a3e8f = "viewport";
var $3de679e4868fd918$export$ae5ab1c730825774 = "popper";
var $3de679e4868fd918$export$ca50aac9f3ba507f = "reference";
var $3de679e4868fd918$export$368f9a87e87fa4e1 = /*#__PURE__*/ $3de679e4868fd918$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $3de679e4868fd918$export$b3571188c770cc5a,
        placement + "-" + $3de679e4868fd918$export$bd5df0f255a350f8
    ]);
}, []);
var $3de679e4868fd918$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($3de679e4868fd918$export$aec2ce47c367b8c3, [
    $3de679e4868fd918$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $3de679e4868fd918$export$b3571188c770cc5a,
        placement + "-" + $3de679e4868fd918$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $3de679e4868fd918$export$421679a7c3d56e = "beforeRead";
var $3de679e4868fd918$export$aafa59e2e03f2942 = "read";
var $3de679e4868fd918$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $3de679e4868fd918$export$c65e99957a05207c = "beforeMain";
var $3de679e4868fd918$export$f22da7240b7add18 = "main";
var $3de679e4868fd918$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $3de679e4868fd918$export$8d4d2d70e7d46032 = "beforeWrite";
var $3de679e4868fd918$export$68d8715fc104d294 = "write";
var $3de679e4868fd918$export$70a6e5159acce2e6 = "afterWrite";
var $3de679e4868fd918$export$d087d3878fdf71d5 = [
    $3de679e4868fd918$export$421679a7c3d56e,
    $3de679e4868fd918$export$aafa59e2e03f2942,
    $3de679e4868fd918$export$6964f6c886723980,
    $3de679e4868fd918$export$c65e99957a05207c,
    $3de679e4868fd918$export$f22da7240b7add18,
    $3de679e4868fd918$export$bab79516f2d662fe,
    $3de679e4868fd918$export$8d4d2d70e7d46032,
    $3de679e4868fd918$export$68d8715fc104d294,
    $3de679e4868fd918$export$70a6e5159acce2e6
];

});


parcelRegister("1hlpY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ee7fe20308229e3$export$2e2bcd8739ae039; });
function $0ee7fe20308229e3$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("jvpLE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e334e679a8da4fd2$export$2e2bcd8739ae039; });
function $e334e679a8da4fd2$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("745n9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $524d12f5e3f410b7$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");
var $524d12f5e3f410b7$var$passive = {
    passive: true
};
function $524d12f5e3f410b7$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $fWtCY.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $524d12f5e3f410b7$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $524d12f5e3f410b7$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $524d12f5e3f410b7$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $524d12f5e3f410b7$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $524d12f5e3f410b7$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $524d12f5e3f410b7$var$effect,
    data: {}
};

});

parcelRegister("4mt2C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32cfbe7d0e900a5d$export$2e2bcd8739ae039; });

var $h8FhS = parcelRequire("h8FhS");
function $32cfbe7d0e900a5d$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $h8FhS.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $32cfbe7d0e900a5d$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $32cfbe7d0e900a5d$var$popperOffsets,
    data: {}
};

});
parcelRegister("h8FhS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7a335ce8d6c7e22$export$2e2bcd8739ae039; });

var $7HOne = parcelRequire("7HOne");

var $a9b5p = parcelRequire("a9b5p");

var $5JvSi = parcelRequire("5JvSi");

var $5juCh = parcelRequire("5juCh");
function $c7a335ce8d6c7e22$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $7HOne.default)(placement) : null;
    var variation = placement ? (0, $a9b5p.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $5juCh.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $5juCh.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $5juCh.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $5juCh.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $5JvSi.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $5juCh.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $5juCh.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("7HOne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59c39fbf33d0fa38$export$2e2bcd8739ae039; });

function $59c39fbf33d0fa38$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("a9b5p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $763358296bc7f0da$export$2e2bcd8739ae039; });
function $763358296bc7f0da$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("5JvSi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42c9e163adb38c23$export$2e2bcd8739ae039; });
function $42c9e163adb38c23$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("2SszJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2186ca614d1914c5$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $aI24A = parcelRequire("aI24A");

var $fWtCY = parcelRequire("fWtCY");

var $oVXMR = parcelRequire("oVXMR");

var $2L33g = parcelRequire("2L33g");

var $7HOne = parcelRequire("7HOne");

var $a9b5p = parcelRequire("a9b5p");

var $cQirN = parcelRequire("cQirN");
var $2186ca614d1914c5$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $2186ca614d1914c5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $cQirN.round)(x * dpr) / dpr || 0,
        y: (0, $cQirN.round)(y * dpr) / dpr || 0
    };
}
function $2186ca614d1914c5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $5juCh.left);
    var sideY = (0, $5juCh.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $aI24A.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $fWtCY.default)(popper)) {
            offsetParent = (0, $oVXMR.default)(popper);
            if ((0, $2L33g.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $5juCh.top) || (placement === (0, $5juCh.left) || placement === (0, $5juCh.right)) && variation === (0, $5juCh.end)) {
            sideY = (0, $5juCh.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $5juCh.left) || (placement === (0, $5juCh.top) || placement === (0, $5juCh.bottom)) && variation === (0, $5juCh.end)) {
            sideX = (0, $5juCh.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $2186ca614d1914c5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $2186ca614d1914c5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $fWtCY.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $2186ca614d1914c5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $7HOne.default)(state.placement),
        variation: (0, $a9b5p.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $2186ca614d1914c5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $2186ca614d1914c5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $2186ca614d1914c5$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $2186ca614d1914c5$var$computeStyles,
    data: {}
};

});

parcelRegister("5KdgE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42eb8a49ca42db39$export$2e2bcd8739ae039; });

var $a72Qo = parcelRequire("a72Qo");

var $1c9xk = parcelRequire("1c9xk");
// and applies them to the HTMLElements such as popper and arrow
function $42eb8a49ca42db39$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $1c9xk.isHTMLElement)(element) || !(0, $a72Qo.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $42eb8a49ca42db39$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $1c9xk.isHTMLElement)(element) || !(0, $a72Qo.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $42eb8a49ca42db39$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $42eb8a49ca42db39$var$applyStyles,
    effect: $42eb8a49ca42db39$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRegister("eqE9J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a812a48e30738572$export$2e2bcd8739ae039; });

var $7HOne = parcelRequire("7HOne");

var $5juCh = parcelRequire("5juCh");
function $a812a48e30738572$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $7HOne.default)(placement);
    var invertDistance = [
        (0, $5juCh.left),
        (0, $5juCh.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $5juCh.left),
        (0, $5juCh.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a812a48e30738572$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $5juCh.placements).reduce(function(acc, placement) {
        acc[placement] = $a812a48e30738572$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a812a48e30738572$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $a812a48e30738572$var$offset
};

});

parcelRegister("5QuYB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4419d659c5aee896$export$2e2bcd8739ae039; });

var $1rXBE = parcelRequire("1rXBE");

var $7HOne = parcelRequire("7HOne");

var $3PXal = parcelRequire("3PXal");

var $5uUmA = parcelRequire("5uUmA");

var $cPMZw = parcelRequire("cPMZw");

var $5juCh = parcelRequire("5juCh");

var $a9b5p = parcelRequire("a9b5p");
function $4419d659c5aee896$var$getExpandedFallbackPlacements(placement) {
    if ((0, $7HOne.default)(placement) === (0, $5juCh.auto)) return [];
    var oppositePlacement = (0, $1rXBE.default)(placement);
    return [
        (0, $3PXal.default)(placement),
        oppositePlacement,
        (0, $3PXal.default)(oppositePlacement)
    ];
}
function $4419d659c5aee896$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $7HOne.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $1rXBE.default)(preferredPlacement)
    ] : $4419d659c5aee896$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $7HOne.default)(placement) === (0, $5juCh.auto) ? (0, $cPMZw.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $7HOne.default)(placement);
        var isStartVariation = (0, $a9b5p.default)(placement) === (0, $5juCh.start);
        var isVertical = [
            (0, $5juCh.top),
            (0, $5juCh.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $5uUmA.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $5juCh.right) : (0, $5juCh.left) : isStartVariation ? (0, $5juCh.bottom) : (0, $5juCh.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $1rXBE.default)(mainVariationSide);
        var altVariationSide = (0, $1rXBE.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $4419d659c5aee896$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $4419d659c5aee896$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("1rXBE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10e68ca32d71e128$export$2e2bcd8739ae039; });
var $10e68ca32d71e128$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $10e68ca32d71e128$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $10e68ca32d71e128$var$hash[matched];
    });
}

});

parcelRegister("3PXal", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cb407a558844daa$export$2e2bcd8739ae039; });
var $2cb407a558844daa$var$hash = {
    start: "end",
    end: "start"
};
function $2cb407a558844daa$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $2cb407a558844daa$var$hash[matched];
    });
}

});

parcelRegister("5uUmA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $400b79aa76081eef$export$2e2bcd8739ae039; });

var $i1jxU = parcelRequire("i1jxU");

var $oVXMR = parcelRequire("oVXMR");

var $bsh7Q = parcelRequire("bsh7Q");

var $h8FhS = parcelRequire("h8FhS");

var $jWjgS = parcelRequire("jWjgS");

var $5juCh = parcelRequire("5juCh");

var $1c9xk = parcelRequire("1c9xk");

var $cg2ZW = parcelRequire("cg2ZW");

var $aSXwy = parcelRequire("aSXwy");
function $400b79aa76081eef$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $5juCh.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $5juCh.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $5juCh.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $cg2ZW.default)(typeof padding !== "number" ? padding : (0, $aSXwy.default)(padding, (0, $5juCh.basePlacements)));
    var altContext = elementContext === (0, $5juCh.popper) ? (0, $5juCh.reference) : (0, $5juCh.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $i1jxU.default)((0, $1c9xk.isElement)(element) ? element : element.contextElement || (0, $oVXMR.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $bsh7Q.default)(state.elements.reference);
    var popperOffsets = (0, $h8FhS.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $jWjgS.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $5juCh.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $5juCh.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $5juCh.right),
                (0, $5juCh.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $5juCh.top),
                (0, $5juCh.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("i1jxU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1e77b65493ae185$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $43VfI = parcelRequire("43VfI");

var $1xbC0 = parcelRequire("1xbC0");

var $iJYQU = parcelRequire("iJYQU");

var $aI24A = parcelRequire("aI24A");

var $oVXMR = parcelRequire("oVXMR");

var $2L33g = parcelRequire("2L33g");

var $1c9xk = parcelRequire("1c9xk");

var $bsh7Q = parcelRequire("bsh7Q");

var $aSiof = parcelRequire("aSiof");

var $jFWJP = parcelRequire("jFWJP");

var $a72Qo = parcelRequire("a72Qo");

var $jWjgS = parcelRequire("jWjgS");

var $cQirN = parcelRequire("cQirN");
function $d1e77b65493ae185$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $bsh7Q.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $d1e77b65493ae185$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $5juCh.viewport) ? (0, $jWjgS.default)((0, $43VfI.default)(element, strategy)) : (0, $1c9xk.isElement)(clippingParent) ? $d1e77b65493ae185$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $jWjgS.default)((0, $1xbC0.default)((0, $oVXMR.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $d1e77b65493ae185$var$getClippingParents(element) {
    var clippingParents = (0, $iJYQU.default)((0, $aSiof.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $2L33g.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $1c9xk.isHTMLElement)(element) ? (0, $aI24A.default)(element) : element;
    if (!(0, $1c9xk.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $1c9xk.isElement)(clippingParent) && (0, $jFWJP.default)(clippingParent, clipperElement) && (0, $a72Qo.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $d1e77b65493ae185$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $d1e77b65493ae185$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $d1e77b65493ae185$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $cQirN.max)(rect.top, accRect.top);
        accRect.right = (0, $cQirN.min)(rect.right, accRect.right);
        accRect.bottom = (0, $cQirN.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cQirN.max)(rect.left, accRect.left);
        return accRect;
    }, $d1e77b65493ae185$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("43VfI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f53da607b3746be$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");

var $oVXMR = parcelRequire("oVXMR");

var $2vFiA = parcelRequire("2vFiA");

var $f2h41 = parcelRequire("f2h41");
function $2f53da607b3746be$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $fWtCY.default)(element);
    var html = (0, $oVXMR.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $f2h41.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $2vFiA.default)(element),
        y: y
    };
}

});

parcelRegister("1xbC0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11e1e16d619599d0$export$2e2bcd8739ae039; });

var $oVXMR = parcelRequire("oVXMR");

var $2L33g = parcelRequire("2L33g");

var $2vFiA = parcelRequire("2vFiA");

var $6uoC5 = parcelRequire("6uoC5");

var $cQirN = parcelRequire("cQirN");
function $11e1e16d619599d0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $oVXMR.default)(element);
    var winScroll = (0, $6uoC5.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $cQirN.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $cQirN.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $2vFiA.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $2L33g.default)(body || html).direction === "rtl") x += (0, $cQirN.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("jFWJP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e52f68d10ea05d88$export$2e2bcd8739ae039; });

var $1c9xk = parcelRequire("1c9xk");
function $e52f68d10ea05d88$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $1c9xk.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("jWjgS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e84261f8276e3310$export$2e2bcd8739ae039; });
function $e84261f8276e3310$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("cg2ZW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ec94e005bd060d7$export$2e2bcd8739ae039; });

var $kGFu9 = parcelRequire("kGFu9");
function $8ec94e005bd060d7$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $kGFu9.default)(), paddingObject);
}

});
parcelRegister("kGFu9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0f7e8fd5f6df53a$export$2e2bcd8739ae039; });
function $f0f7e8fd5f6df53a$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("aSXwy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ecd1ec68ebe7fbd$export$2e2bcd8739ae039; });
function $7ecd1ec68ebe7fbd$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cPMZw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $958040209c61c1c6$export$2e2bcd8739ae039; });

var $a9b5p = parcelRequire("a9b5p");

var $5juCh = parcelRequire("5juCh");

var $5uUmA = parcelRequire("5uUmA");

var $7HOne = parcelRequire("7HOne");
function $958040209c61c1c6$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $5juCh.placements) : _options$allowedAutoP;
    var variation = (0, $a9b5p.default)(placement);
    var placements = variation ? flipVariations ? (0, $5juCh.variationPlacements) : (0, $5juCh.variationPlacements).filter(function(placement) {
        return (0, $a9b5p.default)(placement) === variation;
    }) : (0, $5juCh.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $5uUmA.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $7HOne.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("fVANH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b988b9b26e42e386$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $7HOne = parcelRequire("7HOne");

var $5JvSi = parcelRequire("5JvSi");

var $6Eqmz = parcelRequire("6Eqmz");

var $16lvl = parcelRequire("16lvl");

var $7oVdA = parcelRequire("7oVdA");

var $aI24A = parcelRequire("aI24A");

var $5uUmA = parcelRequire("5uUmA");

var $a9b5p = parcelRequire("a9b5p");

var $kGFu9 = parcelRequire("kGFu9");

var $cQirN = parcelRequire("cQirN");
function $b988b9b26e42e386$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $5uUmA.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $7HOne.default)(state.placement);
    var variation = (0, $a9b5p.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $5JvSi.default)(basePlacement);
    var altAxis = (0, $6Eqmz.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $5juCh.top) : (0, $5juCh.left);
        var altSide = mainAxis === "y" ? (0, $5juCh.bottom) : (0, $5juCh.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $5juCh.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $5juCh.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $7oVdA.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $kGFu9.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $16lvl.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $aI24A.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $16lvl.within)(tether ? (0, $cQirN.min)(min, tetherMin) : min, offset, tether ? (0, $cQirN.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $5juCh.top) : (0, $5juCh.left);
        var _altSide = mainAxis === "x" ? (0, $5juCh.bottom) : (0, $5juCh.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $5juCh.top),
            (0, $5juCh.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $16lvl.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $16lvl.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b988b9b26e42e386$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $b988b9b26e42e386$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("6Eqmz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d7aeda2d1cf8bc0$export$2e2bcd8739ae039; });
function $4d7aeda2d1cf8bc0$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("16lvl", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $0cd708593435dba4$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $0cd708593435dba4$export$86c8af6d3ef0b4a; });

var $cQirN = parcelRequire("cQirN");
function $0cd708593435dba4$export$f28d906d67a997f3(min, value, max) {
    return (0, $cQirN.max)(min, (0, $cQirN.min)(value, max));
}
function $0cd708593435dba4$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $0cd708593435dba4$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("7HVwH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59c92c1fc46a893e$export$2e2bcd8739ae039; });

var $7HOne = parcelRequire("7HOne");

var $7oVdA = parcelRequire("7oVdA");

var $jFWJP = parcelRequire("jFWJP");

var $aI24A = parcelRequire("aI24A");

var $5JvSi = parcelRequire("5JvSi");

var $16lvl = parcelRequire("16lvl");

var $cg2ZW = parcelRequire("cg2ZW");

var $aSXwy = parcelRequire("aSXwy");

var $5juCh = parcelRequire("5juCh");
var $59c92c1fc46a893e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $cg2ZW.default)(typeof padding !== "number" ? padding : (0, $aSXwy.default)(padding, (0, $5juCh.basePlacements)));
};
function $59c92c1fc46a893e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $7HOne.default)(state.placement);
    var axis = (0, $5JvSi.default)(basePlacement);
    var isVertical = [
        (0, $5juCh.left),
        (0, $5juCh.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $59c92c1fc46a893e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $7oVdA.default)(arrowElement);
    var minProp = axis === "y" ? (0, $5juCh.top) : (0, $5juCh.left);
    var maxProp = axis === "y" ? (0, $5juCh.bottom) : (0, $5juCh.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $aI24A.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $16lvl.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $59c92c1fc46a893e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $jFWJP.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $59c92c1fc46a893e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $59c92c1fc46a893e$var$arrow,
    effect: $59c92c1fc46a893e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("9bSGP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b0f9068ca75a57d$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $5uUmA = parcelRequire("5uUmA");
function $6b0f9068ca75a57d$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $6b0f9068ca75a57d$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $5juCh.top),
        (0, $5juCh.right),
        (0, $5juCh.bottom),
        (0, $5juCh.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $6b0f9068ca75a57d$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $5uUmA.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $5uUmA.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $6b0f9068ca75a57d$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $6b0f9068ca75a57d$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $6b0f9068ca75a57d$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $6b0f9068ca75a57d$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $6b0f9068ca75a57d$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $6b0f9068ca75a57d$var$hide
};

});


parcelRegister("gQU2u", function(module, exports) {

$parcel$export(module.exports, "getPopperUtilityClass", function () { return $c44cf8dd7a072fa6$export$1b69b6cd0fa638a1; });

var $1L7eH = parcelRequire("1L7eH");

var $lQUMu = parcelRequire("lQUMu");
const $c44cf8dd7a072fa6$var$COMPONENT_NAME = "Popper";
function $c44cf8dd7a072fa6$export$1b69b6cd0fa638a1(slot) {
    return (0, $1L7eH.generateUtilityClass)($c44cf8dd7a072fa6$var$COMPONENT_NAME, slot);
}
const $c44cf8dd7a072fa6$export$b6aa214021e734b0 = (0, $lQUMu.generateUtilityClasses)($c44cf8dd7a072fa6$var$COMPONENT_NAME, [
    "root"
]);

});
parcelRegister("1L7eH", function(module, exports) {

$parcel$export(module.exports, "generateUtilityClass", function () { return $147fcb3095faef89$export$1d132570e11858b0; });

var $XybB6 = parcelRequire("XybB6");
const $147fcb3095faef89$var$GLOBAL_CLASS_PREFIX = "base";
function $147fcb3095faef89$var$buildStateClass(state) {
    return `${$147fcb3095faef89$var$GLOBAL_CLASS_PREFIX}--${state}`;
}
function $147fcb3095faef89$var$buildSlotClass(componentName, slot) {
    return `${$147fcb3095faef89$var$GLOBAL_CLASS_PREFIX}-${componentName}-${slot}`;
}
function $147fcb3095faef89$export$1d132570e11858b0(componentName, slot) {
    const globalStateClass = (0, $XybB6.globalStateClasses)[slot];
    return globalStateClass ? $147fcb3095faef89$var$buildStateClass(globalStateClass) : $147fcb3095faef89$var$buildSlotClass(componentName, slot);
}
function $147fcb3095faef89$export$34c0130b1f3e8ae3(slot) {
    return (0, $XybB6.globalStateClasses)[slot] !== undefined;
}

});

parcelRegister("lQUMu", function(module, exports) {

$parcel$export(module.exports, "generateUtilityClasses", function () { return $fe8a7fd47fd599bd$export$de4f15803c389669; });

var $1L7eH = parcelRequire("1L7eH");
function $fe8a7fd47fd599bd$export$de4f15803c389669(componentName, slots) {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $1L7eH.generateUtilityClass)(componentName, slot);
    });
    return result;
}

});


parcelRegister("9qLIm", function(module, exports) {

$parcel$export(module.exports, "useClassNamesOverride", function () { return $6ddb8dde432e6936$export$b0f7603cd2f9ee15; });

var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");
"use client";
const $6ddb8dde432e6936$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $6ddb8dde432e6936$var$ClassNameConfiguratorContext = /*#__PURE__*/ $bh6RR.createContext($6ddb8dde432e6936$var$defaultContextValue);
function $6ddb8dde432e6936$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $bh6RR.useContext($6ddb8dde432e6936$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $6ddb8dde432e6936$export$2efe1f5e70172ae9(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $bh6RR.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($6ddb8dde432e6936$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}

});


parcelRegister("kQpxx", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2cc79ac60f066aa$var$React = $f2cc79ac60f066aa$var$_interopRequireWildcard((parcelRequire("bh6RR")));
parcelRequire("fPZvG");
var $k0FAg = parcelRequire("k0FAg");
function $f2cc79ac60f066aa$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f2cc79ac60f066aa$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $f2cc79ac60f066aa$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $f2cc79ac60f066aa$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $f2cc79ac60f066aa$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $f2cc79ac60f066aa$var$useTheme(defaultTheme = null) {
    const contextTheme = $f2cc79ac60f066aa$var$React.useContext($k0FAg.T);
    return !contextTheme || $f2cc79ac60f066aa$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $f2cc79ac60f066aa$var$_default = module.exports.default = $f2cc79ac60f066aa$var$useTheme;

});


parcelRegister("hA9zo", function(module, exports) {

$parcel$export(module.exports, "PickersActionBar", function () { return $cccd38d1a1190819$export$72ffda3bb7ecf665; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");

var $idMAb = parcelRequire("idMAb");

var $fl7Qe = parcelRequire("fl7Qe");

var $8aNCA = parcelRequire("8aNCA");

var $gHJ0l = parcelRequire("gHJ0l");

var $ih19M = parcelRequire("ih19M");
const $cccd38d1a1190819$var$_excluded = [
    "onAccept",
    "onClear",
    "onCancel",
    "onSetToday",
    "actions"
];
const $cccd38d1a1190819$export$72ffda3bb7ecf665 = (props)=>{
    const { onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, actions: actions } = props, other = (0, $hCIyK.default)(props, $cccd38d1a1190819$var$_excluded);
    const wrapperVariant = $bh6RR.useContext((0, $gHJ0l.WrapperVariantContext));
    const localeText = (0, $8aNCA.useLocaleText)();
    const actionsArray = typeof actions === "function" ? actions(wrapperVariant) : actions;
    if (actionsArray == null || actionsArray.length === 0) return null;
    const buttons = actionsArray == null ? void 0 : actionsArray.map((actionType)=>{
        switch(actionType){
            case "clear":
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                    onClick: onClear,
                    children: localeText.clearButtonLabel
                }, actionType);
            case "cancel":
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                    onClick: onCancel,
                    children: localeText.cancelButtonLabel
                }, actionType);
            case "accept":
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                    onClick: onAccept,
                    children: localeText.okButtonLabel
                }, actionType);
            case "today":
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                    onClick: onSetToday,
                    children: localeText.todayButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $fl7Qe.default), (0, $4WYaH.default)({}, other, {
        children: buttons
    }));
};

});
parcelRegister("fl7Qe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2aee6581442386f$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $56mE1 = parcelRequire("56mE1");

var $ih19M = parcelRequire("ih19M");
"use client";
const $b2aee6581442386f$var$_excluded = [
    "className",
    "disableSpacing"
];
const $b2aee6581442386f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $56mE1.getDialogActionsUtilityClass), classes);
};
const $b2aee6581442386f$var$DialogActionsRoot = (0, $g4l1t.default)("div", {
    name: "MuiDialogActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "flex",
        alignItems: "center",
        padding: 8,
        justifyContent: "flex-end",
        flex: "0 0 auto"
    }, !ownerState.disableSpacing && {
        "& > :not(style) ~ :not(style)": {
            marginLeft: 8
        }
    }));
const $b2aee6581442386f$var$DialogActions = /*#__PURE__*/ $bh6RR.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiDialogActions"
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $hCIyK.default)(props, $b2aee6581442386f$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $b2aee6581442386f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($b2aee6581442386f$var$DialogActionsRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $b2aee6581442386f$export$2e2bcd8739ae039 = $b2aee6581442386f$var$DialogActions;

});
parcelRegister("56mE1", function(module, exports) {

$parcel$export(module.exports, "getDialogActionsUtilityClass", function () { return $3b6f140b30c0de0f$export$5e57a444791c63be; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $3b6f140b30c0de0f$export$5e57a444791c63be(slot) {
    return (0, $XybB6.default)("MuiDialogActions", slot);
}
const $3b6f140b30c0de0f$var$dialogActionsClasses = (0, $igcUF.default)("MuiDialogActions", [
    "root",
    "spacing"
]);
var $3b6f140b30c0de0f$export$2e2bcd8739ae039 = $3b6f140b30c0de0f$var$dialogActionsClasses;

});



parcelRegister("aIgPg", function(module, exports) {

$parcel$export(module.exports, "getPickersPopperUtilityClass", function () { return $0203467673ee92b4$export$5519b4d4bf80ce6f; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
function $0203467673ee92b4$export$5519b4d4bf80ce6f(slot) {
    return (0, $XybB6.default)("MuiPickersPopper", slot);
}
const $0203467673ee92b4$export$46e9184c9b1af0ce = (0, $igcUF.default)("MuiPickersPopper", [
    "root",
    "paper"
]);

});

parcelRegister("3xeL1", function(module, exports) {

$parcel$export(module.exports, "arrayIncludes", function () { return $292fe6acb8a10c4c$export$22012a5c726bef55; });
$parcel$export(module.exports, "onSpaceOrEnter", function () { return $292fe6acb8a10c4c$export$4467fe8634707c85; });
$parcel$export(module.exports, "getActiveElement", function () { return $292fe6acb8a10c4c$export$cd4e5573fbe2b576; });
/* Use it instead of .includes method for IE support */ function $292fe6acb8a10c4c$export$22012a5c726bef55(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $292fe6acb8a10c4c$export$4467fe8634707c85 = (innerFn, onFocus)=>(event)=>{
        if (event.key === "Enter" || event.key === " ") {
            innerFn(event); // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (onFocus) onFocus(event);
    };
const $292fe6acb8a10c4c$export$2e03bc8dde24716b = (fn)=>{
    setTimeout(fn, 0);
};
const $292fe6acb8a10c4c$export$b3007168329c29c7 = ()=>{}; // https://www.abeautifulsite.net/posts/finding-the-active-element-in-a-shadow-root/
const $292fe6acb8a10c4c$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $292fe6acb8a10c4c$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};

});



parcelRegister("c8yp0", function(module, exports) {

$parcel$export(module.exports, "CalendarOrClockPicker", function () { return $8d60eaf6e79b80d1$export$1565360330d80aaf; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $g4l1t = parcelRequire("g4l1t");
var $cNBED = parcelRequire("cNBED");

var $7J7Kn = parcelRequire("7J7Kn");

var $9TMKV = parcelRequire("9TMKV");

var $cwvxX = parcelRequire("cwvxX");

var $aQxpZ = parcelRequire("aQxpZ");

var $42A3U = parcelRequire("42A3U");

var $Sro99 = parcelRequire("Sro99");

var $gHJ0l = parcelRequire("gHJ0l");

var $jjsSM = parcelRequire("jjsSM");

var $5nSom = parcelRequire("5nSom");

var $lCIvP = parcelRequire("lCIvP");

var $ih19M = parcelRequire("ih19M");
const $8d60eaf6e79b80d1$var$_excluded = [
    "autoFocus",
    "className",
    "parsedValue",
    "DateInputProps",
    "isMobileKeyboardViewOpen",
    "onDateChange",
    "onViewChange",
    "openTo",
    "orientation",
    "showToolbar",
    "toggleMobileKeyboardView",
    "ToolbarComponent",
    "toolbarFormat",
    "toolbarPlaceholder",
    "toolbarTitle",
    "views",
    "dateRangeIcon",
    "timeIcon",
    "hideTabs",
    "classes"
];
const $8d60eaf6e79b80d1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        mobileKeyboardInputView: [
            "mobileKeyboardInputView"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $lCIvP.getCalendarOrClockPickerUtilityClass), classes);
};
const $8d60eaf6e79b80d1$export$739a903982fd73c9 = (0, $g4l1t.default)("div", {
    name: "MuiCalendarOrClockPicker",
    slot: "MobileKeyboardInputView",
    overridesResolver: (_, styles)=>styles.mobileKeyboardInputView
})({
    padding: "16px 24px"
});
const $8d60eaf6e79b80d1$var$PickerRoot = (0, $g4l1t.default)("div", {
    name: "MuiCalendarOrClockPicker",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "flex",
        flexDirection: "column"
    }, ownerState.isLandscape && {
        flexDirection: "row"
    }));
const $8d60eaf6e79b80d1$var$MobileKeyboardTextFieldProps = {
    fullWidth: true
};
const $8d60eaf6e79b80d1$var$isDatePickerView = (view)=>view === "year" || view === "month" || view === "day";
const $8d60eaf6e79b80d1$var$isTimePickerView = (view)=>view === "hours" || view === "minutes" || view === "seconds";
let $8d60eaf6e79b80d1$var$warnedOnceNotValidOpenTo = false;
function $8d60eaf6e79b80d1$export$1565360330d80aaf(inProps) {
    var _other$components, _other$componentsProp;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiCalendarOrClockPicker"
    });
    const { autoFocus: autoFocus, parsedValue: parsedValue, DateInputProps: DateInputProps, isMobileKeyboardViewOpen: isMobileKeyboardViewOpen, onDateChange: onDateChange, onViewChange: onViewChange, openTo: openTo, orientation: orientation, showToolbar: showToolbar, toggleMobileKeyboardView: toggleMobileKeyboardView, ToolbarComponent: ToolbarComponent = ()=>null, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder, toolbarTitle: toolbarTitle, views: views, dateRangeIcon: dateRangeIcon, timeIcon: timeIcon, hideTabs: hideTabs } = props, other = (0, $hCIyK.default)(props, $8d60eaf6e79b80d1$var$_excluded);
    const TabsComponent = (_other$components = other.components) == null ? void 0 : _other$components.Tabs;
    const isLandscape = (0, $Sro99.useIsLandscape)(views, orientation);
    const wrapperVariant = $bh6RR.useContext((0, $gHJ0l.WrapperVariantContext));
    const classes = $8d60eaf6e79b80d1$var$useUtilityClasses(props);
    const toShowToolbar = showToolbar != null ? showToolbar : wrapperVariant !== "desktop";
    const showTabs = !hideTabs && typeof window !== "undefined" && window.innerHeight > 667;
    const handleDateChange = $bh6RR.useCallback((newDate, selectionState)=>{
        onDateChange(newDate, wrapperVariant, selectionState);
    }, [
        onDateChange,
        wrapperVariant
    ]);
    const handleViewChange = $bh6RR.useCallback((newView)=>{
        if (isMobileKeyboardViewOpen) toggleMobileKeyboardView();
        if (onViewChange) onViewChange(newView);
    }, [
        isMobileKeyboardViewOpen,
        onViewChange,
        toggleMobileKeyboardView
    ]);
    const { openView: openView, setOpenView: setOpenView, handleChangeAndOpenNext: handleChangeAndOpenNext } = (0, $9TMKV.useViews)({
        view: undefined,
        views: views,
        openTo: openTo,
        onChange: handleDateChange,
        onViewChange: handleViewChange
    });
    const { focusedView: focusedView, setFocusedView: setFocusedView } = (0, $5nSom.useFocusManagement)({
        autoFocus: autoFocus,
        openView: openView
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)($8d60eaf6e79b80d1$var$PickerRoot, {
        ownerState: {
            isLandscape: isLandscape
        },
        className: classes.root,
        children: [
            toShowToolbar && /*#__PURE__*/ (0, $ih19M.jsx)(ToolbarComponent, (0, $4WYaH.default)({}, other, {
                views: views,
                isLandscape: isLandscape,
                parsedValue: parsedValue,
                onChange: handleDateChange,
                setOpenView: setOpenView,
                openView: openView,
                toolbarTitle: toolbarTitle,
                toolbarFormat: toolbarFormat,
                toolbarPlaceholder: toolbarPlaceholder,
                isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
                toggleMobileKeyboardView: toggleMobileKeyboardView
            })),
            showTabs && !!TabsComponent && /*#__PURE__*/ (0, $ih19M.jsx)(TabsComponent, (0, $4WYaH.default)({
                dateRangeIcon: dateRangeIcon,
                timeIcon: timeIcon,
                view: openView,
                onChange: setOpenView
            }, (_other$componentsProp = other.componentsProps) == null ? void 0 : _other$componentsProp.tabs)),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jjsSM.PickerViewRoot), {
                children: isMobileKeyboardViewOpen ? /*#__PURE__*/ (0, $ih19M.jsx)($8d60eaf6e79b80d1$export$739a903982fd73c9, {
                    className: classes.mobileKeyboardInputView,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $42A3U.KeyboardDateInput), (0, $4WYaH.default)({}, DateInputProps, {
                        ignoreInvalidInputs: true,
                        disableOpenPicker: true,
                        TextFieldProps: $8d60eaf6e79b80d1$var$MobileKeyboardTextFieldProps
                    }))
                }) : /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
                    children: [
                        $8d60eaf6e79b80d1$var$isDatePickerView(openView) && /*#__PURE__*/ (0, $ih19M.jsx)((0, $aQxpZ.CalendarPicker), (0, $4WYaH.default)({
                            autoFocus: autoFocus,
                            date: parsedValue,
                            onViewChange: setOpenView,
                            onChange: handleChangeAndOpenNext,
                            view: openView // Unclear why the predicate `isDatePickerView` does not imply the casted type
                            ,
                            views: views.filter($8d60eaf6e79b80d1$var$isDatePickerView),
                            focusedView: focusedView,
                            onFocusedViewChange: setFocusedView
                        }, other)),
                        $8d60eaf6e79b80d1$var$isTimePickerView(openView) && /*#__PURE__*/ (0, $ih19M.jsx)((0, $cwvxX.ClockPicker), (0, $4WYaH.default)({}, other, {
                            autoFocus: autoFocus,
                            date: parsedValue,
                            view: openView // Unclear why the predicate `isDatePickerView` does not imply the casted type
                            ,
                            views: views.filter($8d60eaf6e79b80d1$var$isTimePickerView),
                            onChange: handleChangeAndOpenNext,
                            onViewChange: setOpenView,
                            showViewSwitcher: wrapperVariant === "desktop"
                        }))
                    ]
                })
            })
        ]
    });
}

});
parcelRegister("9TMKV", function(module, exports) {

$parcel$export(module.exports, "useViews", function () { return $734f12022d2dd2ce$export$9b46cba8f8ccd954; });

var $bh6RR = parcelRequire("bh6RR");

var $82V4F = parcelRequire("82V4F");

var $3xeL1 = parcelRequire("3xeL1");
function $734f12022d2dd2ce$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: view, views: views }) {
    var _views, _views2;
    const [openView, setOpenView] = (0, $82V4F.default)({
        name: "Picker",
        state: "view",
        controlled: view,
        default: openTo && (0, $3xeL1.arrayIncludes)(views, openTo) ? openTo : views[0]
    });
    const previousView = (_views = views[views.indexOf(openView) - 1]) != null ? _views : null;
    const nextView = (_views2 = views[views.indexOf(openView) + 1]) != null ? _views2 : null;
    const changeView = $bh6RR.useCallback((newView)=>{
        setOpenView(newView);
        if (onViewChange) onViewChange(newView);
    }, [
        setOpenView,
        onViewChange
    ]);
    const openNext = $bh6RR.useCallback(()=>{
        if (nextView) changeView(nextView);
    }, [
        nextView,
        changeView
    ]);
    const handleChangeAndOpenNext = $bh6RR.useCallback((date, currentViewSelectionState)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === "finish";
        const globalSelectionState = isSelectionFinishedOnCurrentView && Boolean(nextView) ? "partial" : currentViewSelectionState;
        onChange(date, globalSelectionState);
        if (isSelectionFinishedOnCurrentView) openNext();
    }, [
        nextView,
        onChange,
        openNext
    ]);
    return {
        handleChangeAndOpenNext: handleChangeAndOpenNext,
        nextView: nextView,
        previousView: previousView,
        openNext: openNext,
        openView: openView,
        setOpenView: changeView
    };
}

});

parcelRegister("cwvxX", function(module, exports) {

$parcel$export(module.exports, "ClockPicker", function () { return $91e0f1bc975df857$export$d86c07922195f713; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $d56pS = parcelRequire("d56pS");


var $5R8eh = parcelRequire("5R8eh");

var $g4l1t = parcelRequire("g4l1t");
var $cNBED = parcelRequire("cNBED");

var $7J7Kn = parcelRequire("7J7Kn");

var $bfvcJ = parcelRequire("bfvcJ");

var $8aNCA = parcelRequire("8aNCA");

var $h8ZyY = parcelRequire("h8ZyY");

var $ja9Be = parcelRequire("ja9Be");

var $7JmuG = parcelRequire("7JmuG");

var $iSi9v = parcelRequire("iSi9v");

var $9TMKV = parcelRequire("9TMKV");

var $3f8YG = parcelRequire("3f8YG");

var $8kk4k = parcelRequire("8kk4k");

var $jjsSM = parcelRequire("jjsSM");

var $ih19M = parcelRequire("ih19M");
const $91e0f1bc975df857$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        arrowSwitcher: [
            "arrowSwitcher"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $8kk4k.getClockPickerUtilityClass), classes);
};
const $91e0f1bc975df857$var$ClockPickerRoot = (0, $g4l1t.default)((0, $jjsSM.PickerViewRoot), {
    name: "MuiClockPicker",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "column"
});
const $91e0f1bc975df857$var$ClockPickerArrowSwitcher = (0, $g4l1t.default)((0, $7JmuG.PickersArrowSwitcher), {
    name: "MuiClockPicker",
    slot: "ArrowSwitcher",
    overridesResolver: (props, styles)=>styles.arrowSwitcher
})({
    position: "absolute",
    right: 12,
    top: 15
});
const $91e0f1bc975df857$var$deprecatedPropsWarning = (0, $h8ZyY.buildDeprecatedPropsWarning)("Props for translation are deprecated. See https://mui.com/x/react-date-pickers/localization for more information.");
const $91e0f1bc975df857$export$d86c07922195f713 = /*#__PURE__*/ $bh6RR.forwardRef(function ClockPicker(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiClockPicker"
    });
    const { ampm: ampm = false, ampmInClock: ampmInClock = false, autoFocus: autoFocus, components: components, componentsProps: componentsProps, date: date, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, getClockLabelText: getClockLabelTextProp, getHoursClockNumberText: getHoursClockNumberTextProp, getMinutesClockNumberText: getMinutesClockNumberTextProp, getSecondsClockNumberText: getSecondsClockNumberTextProp, leftArrowButtonText: leftArrowButtonTextProp, maxTime: maxTime, minTime: minTime, minutesStep: minutesStep = 1, rightArrowButtonText: rightArrowButtonTextProp, shouldDisableTime: shouldDisableTime, showViewSwitcher: showViewSwitcher, onChange: onChange, view: view, views: views = [
        "hours",
        "minutes"
    ], openTo: openTo, onViewChange: onViewChange, className: className, disabled: disabled, readOnly: readOnly } = props;
    $91e0f1bc975df857$var$deprecatedPropsWarning({
        leftArrowButtonText: leftArrowButtonTextProp,
        rightArrowButtonText: rightArrowButtonTextProp,
        getClockLabelText: getClockLabelTextProp,
        getHoursClockNumberText: getHoursClockNumberTextProp,
        getMinutesClockNumberText: getMinutesClockNumberTextProp,
        getSecondsClockNumberText: getSecondsClockNumberTextProp
    });
    const localeText = (0, $8aNCA.useLocaleText)();
    const leftArrowButtonText = leftArrowButtonTextProp != null ? leftArrowButtonTextProp : localeText.openPreviousView;
    const rightArrowButtonText = rightArrowButtonTextProp != null ? rightArrowButtonTextProp : localeText.openNextView;
    const getClockLabelText = getClockLabelTextProp != null ? getClockLabelTextProp : localeText.clockLabelText;
    const getHoursClockNumberText = getHoursClockNumberTextProp != null ? getHoursClockNumberTextProp : localeText.hoursClockNumberText;
    const getMinutesClockNumberText = getMinutesClockNumberTextProp != null ? getMinutesClockNumberTextProp : localeText.minutesClockNumberText;
    const getSecondsClockNumberText = getSecondsClockNumberTextProp != null ? getSecondsClockNumberTextProp : localeText.secondsClockNumberText;
    const { openView: openView, setOpenView: setOpenView, nextView: nextView, previousView: previousView, handleChangeAndOpenNext: handleChangeAndOpenNext } = (0, $9TMKV.useViews)({
        view: view,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: onChange
    });
    const now = (0, $8aNCA.useNow)();
    const utils = (0, $8aNCA.useUtils)();
    const dateOrMidnight = $bh6RR.useMemo(()=>date || utils.setSeconds(utils.setMinutes(utils.setHours(now, 0), 0), 0), [
        date,
        now,
        utils
    ]);
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $3f8YG.useMeridiemMode)(dateOrMidnight, ampm, handleChangeAndOpenNext);
    const isTimeDisabled = $bh6RR.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $iSi9v.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, utils);
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            return true;
        };
        const isValidValue = (value, step = 1)=>{
            if (value % step !== 0) return false;
            if (shouldDisableTime) return !shouldDisableTime(value, viewType);
            return true;
        };
        switch(viewType){
            case "hours":
                {
                    const value = (0, $iSi9v.convertValueToMeridiem)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(dateOrMidnight, value);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(value);
                }
            case "minutes":
                {
                    const dateWithNewMinutes = utils.setMinutes(dateOrMidnight, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case "seconds":
                {
                    const dateWithNewSeconds = utils.setSeconds(dateOrMidnight, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error("not supported");
        }
    }, [
        ampm,
        dateOrMidnight,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        utils
    ]);
    const selectedId = (0, $5R8eh.default)();
    const viewProps = $bh6RR.useMemo(()=>{
        switch(openView){
            case "hours":
                {
                    const handleHoursChange = (value, isFinish)=>{
                        const valueWithMeridiem = (0, $iSi9v.convertValueToMeridiem)(value, meridiemMode, ampm);
                        handleChangeAndOpenNext(utils.setHours(dateOrMidnight, valueWithMeridiem), isFinish);
                    };
                    return {
                        onChange: handleHoursChange,
                        value: utils.getHours(dateOrMidnight),
                        children: (0, $ja9Be.getHourNumbers)({
                            date: date,
                            utils: utils,
                            ampm: ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: getHoursClockNumberText,
                            isDisabled: (value)=>disabled || isTimeDisabled(value, "hours"),
                            selectedId: selectedId
                        })
                    };
                }
            case "minutes":
                {
                    const minutesValue = utils.getMinutes(dateOrMidnight);
                    const handleMinutesChange = (value, isFinish)=>{
                        handleChangeAndOpenNext(utils.setMinutes(dateOrMidnight, value), isFinish);
                    };
                    return {
                        value: minutesValue,
                        onChange: handleMinutesChange,
                        children: (0, $ja9Be.getMinutesNumbers)({
                            utils: utils,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: getMinutesClockNumberText,
                            isDisabled: (value)=>disabled || isTimeDisabled(value, "minutes"),
                            selectedId: selectedId
                        })
                    };
                }
            case "seconds":
                {
                    const secondsValue = utils.getSeconds(dateOrMidnight);
                    const handleSecondsChange = (value, isFinish)=>{
                        handleChangeAndOpenNext(utils.setSeconds(dateOrMidnight, value), isFinish);
                    };
                    return {
                        value: secondsValue,
                        onChange: handleSecondsChange,
                        children: (0, $ja9Be.getMinutesNumbers)({
                            utils: utils,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: getSecondsClockNumberText,
                            isDisabled: (value)=>disabled || isTimeDisabled(value, "seconds"),
                            selectedId: selectedId
                        })
                    };
                }
            default:
                throw new Error("You must provide the type for ClockView");
        }
    }, [
        openView,
        utils,
        date,
        ampm,
        getHoursClockNumberText,
        getMinutesClockNumberText,
        getSecondsClockNumberText,
        meridiemMode,
        handleChangeAndOpenNext,
        dateOrMidnight,
        isTimeDisabled,
        selectedId,
        disabled
    ]);
    const ownerState = props;
    const classes = $91e0f1bc975df857$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($91e0f1bc975df857$var$ClockPickerRoot, {
        ref: ref,
        className: (0, $d56pS.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            showViewSwitcher && /*#__PURE__*/ (0, $ih19M.jsx)($91e0f1bc975df857$var$ClockPickerArrowSwitcher, {
                className: classes.arrowSwitcher,
                leftArrowButtonText: leftArrowButtonText,
                rightArrowButtonText: rightArrowButtonText,
                components: components,
                componentsProps: componentsProps,
                onLeftClick: ()=>setOpenView(previousView),
                onRightClick: ()=>setOpenView(nextView),
                isLeftDisabled: !previousView,
                isRightDisabled: !nextView,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bfvcJ.Clock), (0, $4WYaH.default)({
                autoFocus: autoFocus,
                date: date,
                ampmInClock: ampmInClock,
                type: openView,
                ampm: ampm,
                getClockLabelText: getClockLabelText,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId,
                disabled: disabled,
                readOnly: readOnly
            }, viewProps))
        ]
    });
});

});
parcelRegister("bfvcJ", function(module, exports) {

$parcel$export(module.exports, "Clock", function () { return $83094cfbb5c9ccf8$export$9735c82c4bae3302; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $d56pS = parcelRequire("d56pS");

var $am7GZ = parcelRequire("am7GZ");

var $aitry = parcelRequire("aitry");

var $g4l1t = parcelRequire("g4l1t");
var $cNBED = parcelRequire("cNBED");

var $7J7Kn = parcelRequire("7J7Kn");
var $joJqx = parcelRequire("joJqx");

var $7dWb3 = parcelRequire("7dWb3");

var $8aNCA = parcelRequire("8aNCA");

var $gHJ0l = parcelRequire("gHJ0l");

var $alEnC = parcelRequire("alEnC");

var $h7s0O = parcelRequire("h7s0O");

var $ih19M = parcelRequire("ih19M");
const $83094cfbb5c9ccf8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        clock: [
            "clock"
        ],
        wrapper: [
            "wrapper"
        ],
        squareMask: [
            "squareMask"
        ],
        pin: [
            "pin"
        ],
        amButton: [
            "amButton"
        ],
        pmButton: [
            "pmButton"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $h7s0O.getClockUtilityClass), classes);
};
const $83094cfbb5c9ccf8$var$ClockRoot = (0, $g4l1t.default)("div", {
    name: "MuiClock",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: theme.spacing(2)
    }));
const $83094cfbb5c9ccf8$var$ClockClock = (0, $g4l1t.default)("div", {
    name: "MuiClock",
    slot: "Clock",
    overridesResolver: (_, styles)=>styles.clock
})({
    backgroundColor: "rgba(0,0,0,.07)",
    borderRadius: "50%",
    height: 220,
    width: 220,
    flexShrink: 0,
    position: "relative",
    pointerEvents: "none"
});
const $83094cfbb5c9ccf8$var$ClockWrapper = (0, $g4l1t.default)("div", {
    name: "MuiClock",
    slot: "Wrapper",
    overridesResolver: (_, styles)=>styles.wrapper
})({
    "&:focus": {
        outline: "none"
    }
});
const $83094cfbb5c9ccf8$var$ClockSquareMask = (0, $g4l1t.default)("div", {
    name: "MuiClock",
    slot: "SquareMask",
    overridesResolver: (_, styles)=>styles.squareMask
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        width: "100%",
        height: "100%",
        position: "absolute",
        pointerEvents: "auto",
        outline: 0,
        // Disable scroll capabilities.
        touchAction: "none",
        userSelect: "none"
    }, ownerState.disabled ? {} : {
        "@media (pointer: fine)": {
            cursor: "pointer",
            borderRadius: "50%"
        },
        "&:active": {
            cursor: "move"
        }
    }));
const $83094cfbb5c9ccf8$var$ClockPin = (0, $g4l1t.default)("div", {
    name: "MuiClock",
    slot: "Pin",
    overridesResolver: (_, styles)=>styles.pin
})(({ theme: theme })=>({
        width: 6,
        height: 6,
        borderRadius: "50%",
        backgroundColor: theme.palette.primary.main,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    }));
const $83094cfbb5c9ccf8$var$ClockAmButton = (0, $g4l1t.default)((0, $am7GZ.default), {
    name: "MuiClock",
    slot: "AmButton",
    overridesResolver: (_, styles)=>styles.amButton
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        zIndex: 1,
        position: "absolute",
        bottom: ownerState.ampmInClock ? 64 : 8,
        left: 8
    }, ownerState.meridiemMode === "am" && {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.primary.light
        }
    }));
const $83094cfbb5c9ccf8$var$ClockPmButton = (0, $g4l1t.default)((0, $am7GZ.default), {
    name: "MuiClock",
    slot: "PmButton",
    overridesResolver: (_, styles)=>styles.pmButton
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        zIndex: 1,
        position: "absolute",
        bottom: ownerState.ampmInClock ? 64 : 8,
        right: 8
    }, ownerState.meridiemMode === "pm" && {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.primary.light
        }
    }));
function $83094cfbb5c9ccf8$export$9735c82c4bae3302(inProps) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiClock"
    });
    const { ampm: ampm, ampmInClock: ampmInClock, autoFocus: autoFocus, children: children, date: date, getClockLabelText: getClockLabelText, handleMeridiemChange: handleMeridiemChange, isTimeDisabled: isTimeDisabled, meridiemMode: meridiemMode, minutesStep: minutesStep = 1, onChange: onChange, selectedId: selectedId, type: type, value: value, disabled: disabled, readOnly: readOnly, className: className } = props;
    const ownerState = props;
    const utils = (0, $8aNCA.useUtils)();
    const wrapperVariant = $bh6RR.useContext((0, $gHJ0l.WrapperVariantContext));
    const isMoving = $bh6RR.useRef(false);
    const classes = $83094cfbb5c9ccf8$var$useUtilityClasses(ownerState);
    const isSelectedTimeDisabled = isTimeDisabled(value, type);
    const isPointerInner = !ampm && type === "hours" && (value < 1 || value > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (disabled || readOnly) return;
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX: offsetX, offsetY: offsetY } = event;
        if (offsetX === undefined) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = type === "seconds" || type === "minutes" ? (0, $alEnC.getMinutes)(offsetX, offsetY, minutesStep) : (0, $alEnC.getHours)(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchMove = (event)=>{
        isMoving.current = true;
        setTime(event, "shallow");
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, "finish");
            isMoving.current = false;
        }
    };
    const handleMouseMove = (event)=>{
        // event.buttons & PRIMARY_MOUSE_BUTTON
        if (event.buttons > 0) setTime(event.nativeEvent, "shallow");
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, "finish");
    };
    const hasSelected = $bh6RR.useMemo(()=>{
        if (type === "hours") return true;
        return value % 5 === 0;
    }, [
        type,
        value
    ]);
    const keyboardControlStep = type === "minutes" ? minutesStep : 1;
    const listboxRef = $bh6RR.useRef(null); // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $joJqx.default)(()=>{
        if (autoFocus) // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const handleKeyDown = (event)=>{
        // TODO: Why this early exit?
        if (isMoving.current) return;
        switch(event.key){
            case "Home":
                // annulate both hours and minutes
                handleValueChange(0, "partial");
                event.preventDefault();
                break;
            case "End":
                handleValueChange(type === "minutes" ? 59 : 23, "partial");
                event.preventDefault();
                break;
            case "ArrowUp":
                handleValueChange(value + keyboardControlStep, "partial");
                event.preventDefault();
                break;
            case "ArrowDown":
                handleValueChange(value - keyboardControlStep, "partial");
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)($83094cfbb5c9ccf8$var$ClockRoot, {
        className: (0, $d56pS.default)(className, classes.root),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)($83094cfbb5c9ccf8$var$ClockClock, {
                className: classes.clock,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($83094cfbb5c9ccf8$var$ClockSquareMask, {
                        onTouchMove: handleTouchMove,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove,
                        ownerState: {
                            disabled: disabled
                        },
                        className: classes.squareMask
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)($83094cfbb5c9ccf8$var$ClockPin, {
                                className: classes.pin
                            }),
                            date && /*#__PURE__*/ (0, $ih19M.jsx)((0, $7dWb3.ClockPointer), {
                                type: type,
                                value: value,
                                isInner: isPointerInner,
                                hasSelected: hasSelected
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($83094cfbb5c9ccf8$var$ClockWrapper, {
                        "aria-activedescendant": selectedId,
                        "aria-label": getClockLabelText(type, date, utils),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        className: classes.wrapper,
                        children: children
                    })
                ]
            }),
            ampm && (wrapperVariant === "desktop" || ampmInClock) && /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($83094cfbb5c9ccf8$var$ClockAmButton, {
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("am"),
                        disabled: disabled || meridiemMode === null,
                        ownerState: ownerState,
                        className: classes.amButton,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), {
                            variant: "caption",
                            children: "AM"
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($83094cfbb5c9ccf8$var$ClockPmButton, {
                        disabled: disabled || meridiemMode === null,
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("pm"),
                        ownerState: ownerState,
                        className: classes.pmButton,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), {
                            variant: "caption",
                            children: "PM"
                        })
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("7dWb3", function(module, exports) {

$parcel$export(module.exports, "ClockPointer", function () { return $5426e01c3fc1df70$export$f257f213e6c08f97; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $d56pS = parcelRequire("d56pS");

var $g4l1t = parcelRequire("g4l1t");
var $cNBED = parcelRequire("cNBED");

var $7J7Kn = parcelRequire("7J7Kn");

var $alEnC = parcelRequire("alEnC");

var $KcZoB = parcelRequire("KcZoB");

var $ih19M = parcelRequire("ih19M");
const $5426e01c3fc1df70$var$_excluded = [
    "className",
    "hasSelected",
    "isInner",
    "type",
    "value"
];
const $5426e01c3fc1df70$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        thumb: [
            "thumb"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $KcZoB.getClockPointerUtilityClass), classes);
};
const $5426e01c3fc1df70$var$ClockPointerRoot = (0, $g4l1t.default)("div", {
    name: "MuiClockPointer",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        width: 2,
        backgroundColor: theme.palette.primary.main,
        position: "absolute",
        left: "calc(50% - 1px)",
        bottom: "50%",
        transformOrigin: "center bottom 0px"
    }, ownerState.shouldAnimate && {
        transition: theme.transitions.create([
            "transform",
            "height"
        ])
    }));
const $5426e01c3fc1df70$var$ClockPointerThumb = (0, $g4l1t.default)("div", {
    name: "MuiClockPointer",
    slot: "Thumb",
    overridesResolver: (_, styles)=>styles.thumb
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        width: 4,
        height: 4,
        backgroundColor: theme.palette.primary.contrastText,
        borderRadius: "50%",
        position: "absolute",
        top: -21,
        left: `calc(50% - ${(0, $alEnC.CLOCK_HOUR_WIDTH) / 2}px)`,
        border: `${((0, $alEnC.CLOCK_HOUR_WIDTH) - 4) / 2}px solid ${theme.palette.primary.main}`,
        boxSizing: "content-box"
    }, ownerState.hasSelected && {
        backgroundColor: theme.palette.primary.main
    }));
function $5426e01c3fc1df70$export$f257f213e6c08f97(inProps) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiClockPointer"
    });
    const { className: className, isInner: isInner, type: type, value: value } = props, other = (0, $hCIyK.default)(props, $5426e01c3fc1df70$var$_excluded);
    const previousType = $bh6RR.useRef(type);
    $bh6RR.useEffect(()=>{
        previousType.current = type;
    }, [
        type
    ]);
    const ownerState = (0, $4WYaH.default)({}, props, {
        shouldAnimate: previousType.current !== type
    });
    const classes = $5426e01c3fc1df70$var$useUtilityClasses(ownerState);
    const getAngleStyle = ()=>{
        const max = type === "hours" ? 12 : 60;
        let angle = 360 / max * value;
        if (type === "hours" && value > 12) angle -= 360; // round up angle to max 360 degrees
        return {
            height: Math.round((isInner ? 0.26 : 0.4) * (0, $alEnC.CLOCK_WIDTH)),
            transform: `rotateZ(${angle}deg)`
        };
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)($5426e01c3fc1df70$var$ClockPointerRoot, (0, $4WYaH.default)({
        style: getAngleStyle(),
        className: (0, $d56pS.default)(className, classes.root),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)($5426e01c3fc1df70$var$ClockPointerThumb, {
            ownerState: ownerState,
            className: classes.thumb
        })
    }));
}

});
parcelRegister("alEnC", function(module, exports) {

$parcel$export(module.exports, "CLOCK_WIDTH", function () { return $788b302511b12b94$export$8c8ec20d3854d7e6; });
$parcel$export(module.exports, "CLOCK_HOUR_WIDTH", function () { return $788b302511b12b94$export$729c0e543e4dc21d; });
$parcel$export(module.exports, "getMinutes", function () { return $788b302511b12b94$export$b7f1bc3ea3ac4145; });
$parcel$export(module.exports, "getHours", function () { return $788b302511b12b94$export$257b40f71c07d58f; });
const $788b302511b12b94$export$8c8ec20d3854d7e6 = 220;
const $788b302511b12b94$export$729c0e543e4dc21d = 36;
const $788b302511b12b94$var$clockCenter = {
    x: $788b302511b12b94$export$8c8ec20d3854d7e6 / 2,
    y: $788b302511b12b94$export$8c8ec20d3854d7e6 / 2
};
const $788b302511b12b94$var$baseClockPoint = {
    x: $788b302511b12b94$var$clockCenter.x,
    y: 0
};
const $788b302511b12b94$var$cx = $788b302511b12b94$var$baseClockPoint.x - $788b302511b12b94$var$clockCenter.x;
const $788b302511b12b94$var$cy = $788b302511b12b94$var$baseClockPoint.y - $788b302511b12b94$var$clockCenter.y;
const $788b302511b12b94$var$rad2deg = (rad)=>rad * (180 / Math.PI);
const $788b302511b12b94$var$getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - $788b302511b12b94$var$clockCenter.x;
    const y = offsetY - $788b302511b12b94$var$clockCenter.y;
    const atan = Math.atan2($788b302511b12b94$var$cx, $788b302511b12b94$var$cy) - Math.atan2(x, y);
    let deg = $788b302511b12b94$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
const $788b302511b12b94$export$b7f1bc3ea3ac4145 = (offsetX, offsetY, step = 1)=>{
    const angleStep = step * 6;
    let { value: value } = $788b302511b12b94$var$getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
const $788b302511b12b94$export$257b40f71c07d58f = (offsetX, offsetY, ampm)=>{
    const { value: value, distance: distance } = $788b302511b12b94$var$getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (!ampm) {
        if (distance < $788b302511b12b94$export$8c8ec20d3854d7e6 / 2 - $788b302511b12b94$export$729c0e543e4dc21d) {
            hour += 12;
            hour %= 24;
        }
    } else hour %= 12;
    return hour;
};

});

parcelRegister("KcZoB", function(module, exports) {

$parcel$export(module.exports, "getClockPointerUtilityClass", function () { return $08ae5f6365f0ae3e$export$12faa62796978e2f; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
function $08ae5f6365f0ae3e$export$12faa62796978e2f(slot) {
    return (0, $XybB6.default)("MuiClockPointer", slot);
}
const $08ae5f6365f0ae3e$export$64afeec9352615cb = (0, $igcUF.default)("MuiClockPointer", [
    "root",
    "thumb"
]);

});


parcelRegister("h7s0O", function(module, exports) {

$parcel$export(module.exports, "getClockUtilityClass", function () { return $c768d1bb806b9121$export$e44ecab24167799b; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
function $c768d1bb806b9121$export$e44ecab24167799b(slot) {
    return (0, $XybB6.default)("MuiClock", slot);
}
const $c768d1bb806b9121$export$4626e3a61e161c64 = (0, $igcUF.default)("MuiClock", [
    "root",
    "clock",
    "wrapper",
    "squareMask",
    "pin",
    "amButton",
    "pmButton"
]);

});


parcelRegister("h8ZyY", function(module, exports) {

$parcel$export(module.exports, "buildDeprecatedPropsWarning", function () { return $c7b2f0291a7173e2$export$be61413ca3629f52; });
const $c7b2f0291a7173e2$export$be61413ca3629f52 = (message)=>{
    let alreadyWarned = false;
    var deprecatedProps;
    return ()=>{};
};

});

parcelRegister("ja9Be", function(module, exports) {

$parcel$export(module.exports, "getHourNumbers", function () { return $df3665c464f06eea$export$10850582eda9a8c7; });
$parcel$export(module.exports, "getMinutesNumbers", function () { return $df3665c464f06eea$export$2c440057d7a731e4; });
parcelRequire("bh6RR");

var $fIiO6 = parcelRequire("fIiO6");

var $ih19M = parcelRequire("ih19M");
const $df3665c464f06eea$export$10850582eda9a8c7 = ({ ampm: ampm, date: date, getClockNumberText: getClockNumberText, isDisabled: isDisabled, selectedId: selectedId, utils: utils })=>{
    const currentHours = date ? utils.getHours(date) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (hour === 0) label = "00";
        const inner = !ampm && (hour === 0 || hour > 12);
        label = utils.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, $ih19M.jsx)((0, $fIiO6.ClockNumber), {
            id: selected ? selectedId : undefined,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
const $df3665c464f06eea$export$2c440057d7a731e4 = ({ utils: utils, value: value, isDisabled: isDisabled, getClockNumberText: getClockNumberText, selectedId: selectedId })=>{
    const f = utils.formatNumber;
    return [
        [
            5,
            f("05")
        ],
        [
            10,
            f("10")
        ],
        [
            15,
            f("15")
        ],
        [
            20,
            f("20")
        ],
        [
            25,
            f("25")
        ],
        [
            30,
            f("30")
        ],
        [
            35,
            f("35")
        ],
        [
            40,
            f("40")
        ],
        [
            45,
            f("45")
        ],
        [
            50,
            f("50")
        ],
        [
            55,
            f("55")
        ],
        [
            0,
            f("00")
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $fIiO6.ClockNumber), {
            label: label,
            id: selected ? selectedId : undefined,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};

});
parcelRegister("fIiO6", function(module, exports) {

$parcel$export(module.exports, "ClockNumber", function () { return $b7098dc1a77149dc$export$6d5c4c748c9cc92c; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");
parcelRequire("bh6RR");

var $d56pS = parcelRequire("d56pS");

var $g4l1t = parcelRequire("g4l1t");
var $cNBED = parcelRequire("cNBED");

var $7J7Kn = parcelRequire("7J7Kn");

var $alEnC = parcelRequire("alEnC");

var $1zf1N = parcelRequire("1zf1N");

var $ih19M = parcelRequire("ih19M");
const $b7098dc1a77149dc$var$_excluded = [
    "className",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const $b7098dc1a77149dc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            disabled && "disabled"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $1zf1N.getClockNumberUtilityClass), classes);
};
const $b7098dc1a77149dc$var$ClockNumberRoot = (0, $g4l1t.default)("span", {
    name: "MuiClockNumber",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $1zf1N.clockNumberClasses).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $1zf1N.clockNumberClasses).selected}`]: styles.selected
            }
        ]
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        height: (0, $alEnC.CLOCK_HOUR_WIDTH),
        width: (0, $alEnC.CLOCK_HOUR_WIDTH),
        position: "absolute",
        left: `calc((100% - ${(0, $alEnC.CLOCK_HOUR_WIDTH)}px) / 2)`,
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        color: theme.palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        "&:focused": {
            backgroundColor: theme.palette.background.paper
        },
        [`&.${(0, $1zf1N.clockNumberClasses).selected}`]: {
            color: theme.palette.primary.contrastText
        },
        [`&.${(0, $1zf1N.clockNumberClasses).disabled}`]: {
            pointerEvents: "none",
            color: theme.palette.text.disabled
        }
    }, ownerState.inner && (0, $4WYaH.default)({}, theme.typography.body2, {
        color: theme.palette.text.secondary
    })));
function $b7098dc1a77149dc$export$6d5c4c748c9cc92c(inProps) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiClockNumber"
    });
    const { className: className, disabled: disabled, index: index, inner: inner, label: label, selected: selected } = props, other = (0, $hCIyK.default)(props, $b7098dc1a77149dc$var$_excluded);
    const ownerState = props;
    const classes = $b7098dc1a77149dc$var$useUtilityClasses(ownerState);
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = ((0, $alEnC.CLOCK_WIDTH) - (0, $alEnC.CLOCK_HOUR_WIDTH) - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, $ih19M.jsx)($b7098dc1a77149dc$var$ClockNumberRoot, (0, $4WYaH.default)({
        className: (0, $d56pS.default)(className, classes.root),
        "aria-disabled": disabled ? true : undefined,
        "aria-selected": selected ? true : undefined,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + ((0, $alEnC.CLOCK_WIDTH) - (0, $alEnC.CLOCK_HOUR_WIDTH)) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}

});
parcelRegister("1zf1N", function(module, exports) {

$parcel$export(module.exports, "getClockNumberUtilityClass", function () { return $1244b7953be1b1ad$export$527226d166658911; });
$parcel$export(module.exports, "clockNumberClasses", function () { return $1244b7953be1b1ad$export$c8efb3a779c9844a; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
function $1244b7953be1b1ad$export$527226d166658911(slot) {
    return (0, $XybB6.default)("MuiClockNumber", slot);
}
const $1244b7953be1b1ad$export$c8efb3a779c9844a = (0, $igcUF.default)("MuiClockNumber", [
    "root",
    "selected",
    "disabled"
]);

});



parcelRegister("7JmuG", function(module, exports) {

$parcel$export(module.exports, "PickersArrowSwitcher", function () { return $5a0e2f2ee1732a29$export$597b7cbdb7b2a24c; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $d56pS = parcelRequire("d56pS");

var $aitry = parcelRequire("aitry");

var $g4l1t = parcelRequire("g4l1t");
var $8gyMY = parcelRequire("8gyMY");
var $cNBED = parcelRequire("cNBED");

var $7J7Kn = parcelRequire("7J7Kn");

var $am7GZ = parcelRequire("am7GZ");

var $7W0sU = parcelRequire("7W0sU");

var $583j9 = parcelRequire("583j9");

var $ih19M = parcelRequire("ih19M");
const $5a0e2f2ee1732a29$var$_excluded = [
    "children",
    "className",
    "components",
    "componentsProps",
    "isLeftDisabled",
    "isLeftHidden",
    "isRightDisabled",
    "isRightHidden",
    "leftArrowButtonText",
    "onLeftClick",
    "onRightClick",
    "rightArrowButtonText"
];
const $5a0e2f2ee1732a29$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        spacer: [
            "spacer"
        ],
        button: [
            "button"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $583j9.getPickersArrowSwitcherUtilityClass), classes);
};
const $5a0e2f2ee1732a29$var$PickersArrowSwitcherRoot = (0, $g4l1t.default)("div", {
    name: "MuiPickersArrowSwitcher",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex"
});
const $5a0e2f2ee1732a29$var$PickersArrowSwitcherSpacer = (0, $g4l1t.default)("div", {
    name: "MuiPickersArrowSwitcher",
    slot: "Spacer",
    overridesResolver: (props, styles)=>styles.spacer
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $5a0e2f2ee1732a29$var$PickersArrowSwitcherButton = (0, $g4l1t.default)((0, $am7GZ.default), {
    name: "MuiPickersArrowSwitcher",
    slot: "Button",
    overridesResolver: (props, styles)=>styles.button
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({}, ownerState.hidden && {
        visibility: "hidden"
    }));
const $5a0e2f2ee1732a29$export$597b7cbdb7b2a24c = /*#__PURE__*/ $bh6RR.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiPickersArrowSwitcher"
    });
    const { children: children, className: className, components: components, componentsProps: componentsProps, isLeftDisabled: isLeftDisabled, isLeftHidden: isLeftHidden, isRightDisabled: isRightDisabled, isRightHidden: isRightHidden, leftArrowButtonText: leftArrowButtonText, onLeftClick: onLeftClick, onRightClick: onRightClick, rightArrowButtonText: rightArrowButtonText } = props, other = (0, $hCIyK.default)(props, $5a0e2f2ee1732a29$var$_excluded);
    const theme = (0, $8gyMY.default)();
    const isRtl = theme.direction === "rtl";
    const leftArrowButtonProps = (componentsProps == null ? void 0 : componentsProps.leftArrowButton) || {};
    const LeftArrowIcon = (components == null ? void 0 : components.LeftArrowIcon) || (0, $7W0sU.ArrowLeft);
    const rightArrowButtonProps = (componentsProps == null ? void 0 : componentsProps.rightArrowButton) || {};
    const RightArrowIcon = (components == null ? void 0 : components.RightArrowIcon) || (0, $7W0sU.ArrowRight);
    const ownerState = props;
    const classes = $5a0e2f2ee1732a29$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($5a0e2f2ee1732a29$var$PickersArrowSwitcherRoot, (0, $4WYaH.default)({
        ref: ref,
        className: (0, $d56pS.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($5a0e2f2ee1732a29$var$PickersArrowSwitcherButton, (0, $4WYaH.default)({
                as: components == null ? void 0 : components.LeftArrowButton,
                size: "small",
                "aria-label": leftArrowButtonText,
                title: leftArrowButtonText,
                disabled: isLeftDisabled,
                edge: "end",
                onClick: onLeftClick
            }, leftArrowButtonProps, {
                className: (0, $d56pS.default)(classes.button, leftArrowButtonProps.className),
                ownerState: (0, $4WYaH.default)({}, ownerState, leftArrowButtonProps, {
                    hidden: isLeftHidden
                }),
                children: isRtl ? /*#__PURE__*/ (0, $ih19M.jsx)(RightArrowIcon, {}) : /*#__PURE__*/ (0, $ih19M.jsx)(LeftArrowIcon, {})
            })),
            children ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), {
                variant: "subtitle1",
                component: "span",
                children: children
            }) : /*#__PURE__*/ (0, $ih19M.jsx)($5a0e2f2ee1732a29$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)($5a0e2f2ee1732a29$var$PickersArrowSwitcherButton, (0, $4WYaH.default)({
                as: components == null ? void 0 : components.RightArrowButton,
                size: "small",
                "aria-label": rightArrowButtonText,
                title: rightArrowButtonText,
                edge: "start",
                disabled: isRightDisabled,
                onClick: onRightClick
            }, rightArrowButtonProps, {
                className: (0, $d56pS.default)(classes.button, rightArrowButtonProps.className),
                ownerState: (0, $4WYaH.default)({}, ownerState, rightArrowButtonProps, {
                    hidden: isRightHidden
                }),
                children: isRtl ? /*#__PURE__*/ (0, $ih19M.jsx)(LeftArrowIcon, {}) : /*#__PURE__*/ (0, $ih19M.jsx)(RightArrowIcon, {})
            }))
        ]
    }));
});

});
parcelRegister("583j9", function(module, exports) {

$parcel$export(module.exports, "getPickersArrowSwitcherUtilityClass", function () { return $3bc04401f6f821b1$export$cef978c25740de90; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
function $3bc04401f6f821b1$export$cef978c25740de90(slot) {
    return (0, $XybB6.default)("MuiPickersArrowSwitcher", slot);
}
const $3bc04401f6f821b1$export$f8819209558cd362 = (0, $igcUF.default)("MuiPickersArrowSwitcher", [
    "root",
    "spacer",
    "button"
]);

});


parcelRegister("iSi9v", function(module, exports) {

$parcel$export(module.exports, "getMeridiem", function () { return $dbdb59d685d6d9f4$export$c3352ead7b032236; });
$parcel$export(module.exports, "convertValueToMeridiem", function () { return $dbdb59d685d6d9f4$export$4159dc823695870e; });
$parcel$export(module.exports, "convertToMeridiem", function () { return $dbdb59d685d6d9f4$export$c368d4ff66779998; });
$parcel$export(module.exports, "createIsAfterIgnoreDatePart", function () { return $dbdb59d685d6d9f4$export$fb87c80b35a46b89; });
const $dbdb59d685d6d9f4$export$c3352ead7b032236 = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? "pm" : "am";
};
const $dbdb59d685d6d9f4$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? "pm" : "am";
        if (currentMeridiem !== meridiem) return meridiem === "am" ? value - 12 : value + 12;
    }
    return value;
};
const $dbdb59d685d6d9f4$export$c368d4ff66779998 = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = $dbdb59d685d6d9f4$export$4159dc823695870e(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
const $dbdb59d685d6d9f4$export$888a1ce13aa61986 = (date, utils)=>{
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const $dbdb59d685d6d9f4$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation = false, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return $dbdb59d685d6d9f4$export$888a1ce13aa61986(dateLeft, utils) > $dbdb59d685d6d9f4$export$888a1ce13aa61986(dateRight, utils);
    };

});

parcelRegister("3f8YG", function(module, exports) {

$parcel$export(module.exports, "useNextMonthDisabled", function () { return $25c9bc97a00f3d47$export$923e8cc135843169; });
$parcel$export(module.exports, "usePreviousMonthDisabled", function () { return $25c9bc97a00f3d47$export$3b46d38ff4932cf7; });
$parcel$export(module.exports, "useMeridiemMode", function () { return $25c9bc97a00f3d47$export$6aaabc31cb076d17; });

var $bh6RR = parcelRequire("bh6RR");

var $8aNCA = parcelRequire("8aNCA");

var $iSi9v = parcelRequire("iSi9v");
function $25c9bc97a00f3d47$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate }) {
    const utils = (0, $8aNCA.useUtils)();
    return $bh6RR.useMemo(()=>{
        const now = utils.date();
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils
    ]);
}
function $25c9bc97a00f3d47$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate }) {
    const utils = (0, $8aNCA.useUtils)();
    return $bh6RR.useMemo(()=>{
        const now = utils.date();
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils
    ]);
}
function $25c9bc97a00f3d47$export$6aaabc31cb076d17(date, ampm, onChange) {
    const utils = (0, $8aNCA.useUtils)();
    const meridiemMode = (0, $iSi9v.getMeridiem)(date, utils);
    const handleMeridiemChange = $bh6RR.useCallback((mode)=>{
        const timeWithMeridiem = date == null ? null : (0, $iSi9v.convertToMeridiem)(date, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, "partial");
    }, [
        ampm,
        date,
        onChange,
        utils
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}

});

parcelRegister("8kk4k", function(module, exports) {

$parcel$export(module.exports, "getClockPickerUtilityClass", function () { return $60ffc23aa0361c47$export$f8da5e3552abcf0a; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
function $60ffc23aa0361c47$export$f8da5e3552abcf0a(slot) {
    return (0, $XybB6.default)("MuiClockPicker", slot);
}
const $60ffc23aa0361c47$export$355e4a5f94c2b5f = (0, $igcUF.default)("MuiClockPicker", [
    "root",
    "arrowSwitcher"
]);

});

parcelRegister("jjsSM", function(module, exports) {

$parcel$export(module.exports, "PickerViewRoot", function () { return $e0f63229edcbbcab$export$512b066b8abdfde4; });

var $g4l1t = parcelRequire("g4l1t");

var $bsLZU = parcelRequire("bsLZU");
const $e0f63229edcbbcab$export$512b066b8abdfde4 = (0, $g4l1t.default)("div")({
    overflowX: "hidden",
    width: (0, $bsLZU.DIALOG_WIDTH),
    maxHeight: (0, $bsLZU.VIEW_HEIGHT),
    display: "flex",
    flexDirection: "column",
    margin: "0 auto"
});

});
parcelRegister("bsLZU", function(module, exports) {

$parcel$export(module.exports, "DAY_SIZE", function () { return $85878a8df92f978e$export$3f0060ce4cc8f4d0; });
$parcel$export(module.exports, "DAY_MARGIN", function () { return $85878a8df92f978e$export$dde58b009b497666; });
$parcel$export(module.exports, "DIALOG_WIDTH", function () { return $85878a8df92f978e$export$ee46b8a74d6c94d3; });
$parcel$export(module.exports, "VIEW_HEIGHT", function () { return $85878a8df92f978e$export$f2fef360e2df0cb7; });
const $85878a8df92f978e$export$3f0060ce4cc8f4d0 = 36;
const $85878a8df92f978e$export$dde58b009b497666 = 2;
const $85878a8df92f978e$export$ee46b8a74d6c94d3 = 320;
const $85878a8df92f978e$export$f2fef360e2df0cb7 = 358;

});



parcelRegister("aQxpZ", function(module, exports) {

$parcel$export(module.exports, "CalendarPicker", function () { return $7e58aed9f0e484cb$export$904d39b6b448e4e5; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $d56pS = parcelRequire("d56pS");

var $g4l1t = parcelRequire("g4l1t");
var $cNBED = parcelRequire("cNBED");

var $7J7Kn = parcelRequire("7J7Kn");

var $5R8eh = parcelRequire("5R8eh");
var $82V4F = parcelRequire("82V4F");
var $8M7SI = parcelRequire("8M7SI");

var $ecvPz = parcelRequire("ecvPz");

var $7lQph = parcelRequire("7lQph");

var $8aNCA = parcelRequire("8aNCA");

var $fv9Yp = parcelRequire("fv9Yp");

var $iruty = parcelRequire("iruty");

var $9TMKV = parcelRequire("9TMKV");

var $2l38V = parcelRequire("2l38V");

var $iWKGr = parcelRequire("iWKGr");

var $BN6Vh = parcelRequire("BN6Vh");

var $jjsSM = parcelRequire("jjsSM");

var $1rN44 = parcelRequire("1rN44");

var $1lA8j = parcelRequire("1lA8j");

var $ih19M = parcelRequire("ih19M");
const $7e58aed9f0e484cb$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "date",
    "disableFuture",
    "disablePast",
    "defaultCalendarMonth",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "classes"
];
const $7e58aed9f0e484cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        viewTransitionContainer: [
            "viewTransitionContainer"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $1lA8j.getCalendarPickerUtilityClass), classes);
};
function $7e58aed9f0e484cb$var$useCalendarPickerDefaultizedProps(props, name) {
    const utils = (0, $8aNCA.useUtils)();
    const defaultDates = (0, $8aNCA.useDefaultDates)();
    const themeProps = (0, $cNBED.default)({
        props: props,
        name: name
    });
    return (0, $4WYaH.default)({
        loading: false,
        disablePast: false,
        disableFuture: false,
        openTo: "day",
        views: [
            "year",
            "day"
        ],
        reduceAnimations: (0, $1rN44.defaultReduceAnimations),
        renderLoading: ()=>/*#__PURE__*/ (0, $ih19M.jsx)("span", {
                children: "..."
            })
    }, themeProps, {
        minDate: (0, $BN6Vh.parseNonNullablePickerDate)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $BN6Vh.parseNonNullablePickerDate)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $7e58aed9f0e484cb$var$CalendarPickerRoot = (0, $g4l1t.default)((0, $jjsSM.PickerViewRoot), {
    name: "MuiCalendarPicker",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "column"
});
const $7e58aed9f0e484cb$var$CalendarPickerViewTransitionContainer = (0, $g4l1t.default)((0, $fv9Yp.PickersFadeTransitionGroup), {
    name: "MuiCalendarPicker",
    slot: "ViewTransitionContainer",
    overridesResolver: (props, styles)=>styles.viewTransitionContainer
})({});
const $7e58aed9f0e484cb$export$904d39b6b448e4e5 = /*#__PURE__*/ $bh6RR.forwardRef(function CalendarPicker(inProps, ref) {
    const utils = (0, $8aNCA.useUtils)();
    const id = (0, $5R8eh.default)();
    const props = $7e58aed9f0e484cb$var$useCalendarPickerDefaultizedProps(inProps, "MuiCalendarPicker");
    const { autoFocus: autoFocus, onViewChange: onViewChange, date: date, disableFuture: disableFuture, disablePast: disablePast, defaultCalendarMonth: defaultCalendarMonth, onChange: onChange, onYearChange: onYearChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: view, views: views, openTo: openTo, className: className, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange } = props, other = (0, $hCIyK.default)(props, $7e58aed9f0e484cb$var$_excluded);
    const { openView: openView, setOpenView: setOpenView, openNext: openNext } = (0, $9TMKV.useViews)({
        view: view,
        views: views,
        openTo: openTo,
        onChange: onChange,
        onViewChange: onViewChange
    });
    const { calendarState: calendarState, changeFocusedDay: changeFocusedDay, changeMonth: changeMonth, handleChangeMonth: handleChangeMonth, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $7lQph.useCalendarState)({
        date: date,
        defaultCalendarMonth: defaultCalendarMonth,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture
    });
    const handleDateMonthChange = $bh6RR.useCallback((newDate, selectionState)=>{
        const startOfMonth = utils.startOfMonth(newDate);
        const endOfMonth = utils.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $BN6Vh.findClosestEnabledDate)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled
        }) : newDate;
        if (closestEnabledDate) {
            onChange(closestEnabledDate, selectionState);
            onMonthChange == null || onMonthChange(startOfMonth);
        } else {
            openNext();
            changeMonth(startOfMonth);
        }
        changeFocusedDay(closestEnabledDate, true);
    }, [
        changeFocusedDay,
        disableFuture,
        disablePast,
        isDateDisabled,
        maxDate,
        minDate,
        onChange,
        onMonthChange,
        changeMonth,
        openNext,
        utils
    ]);
    const handleDateYearChange = $bh6RR.useCallback((newDate, selectionState)=>{
        const startOfYear = utils.startOfYear(newDate);
        const endOfYear = utils.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $BN6Vh.findClosestEnabledDate)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled
        }) : newDate;
        if (closestEnabledDate) {
            onChange(closestEnabledDate, selectionState);
            onYearChange == null || onYearChange(closestEnabledDate);
        } else {
            openNext();
            changeMonth(startOfYear);
        }
        changeFocusedDay(closestEnabledDate, true);
    }, [
        changeFocusedDay,
        disableFuture,
        disablePast,
        isDateDisabled,
        maxDate,
        minDate,
        onChange,
        onYearChange,
        openNext,
        utils,
        changeMonth
    ]);
    const onSelectedDayChange = $bh6RR.useCallback((day, isFinish)=>{
        if (date && day) // If there is a date already selected, then we want to keep its time
        return onChange(utils.mergeDateAndTime(day, date), isFinish);
        return onChange(day, isFinish);
    }, [
        utils,
        date,
        onChange
    ]);
    $bh6RR.useEffect(()=>{
        if (date) changeMonth(date);
    }, [
        date
    ]); // eslint-disable-line
    const ownerState = props;
    const classes = $7e58aed9f0e484cb$var$useUtilityClasses(ownerState);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    }; // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && date || minDate;
    const maxDateWithDisabled = disabled && date || maxDate;
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled
    };
    const gridLabelId = `${id}-grid-label`;
    const [internalFocusedView, setInternalFocusedView] = (0, $82V4F.default)({
        name: "DayPicker",
        state: "focusedView",
        controlled: focusedView,
        default: autoFocus ? openView : null
    });
    const hasFocus = internalFocusedView !== null;
    const handleFocusedViewChange = (0, $8M7SI.default)((eventView)=>(newHasFocus)=>{
            if (onFocusedViewChange) {
                // Use the calendar or clock logic
                onFocusedViewChange(eventView)(newHasFocus);
                return;
            } // If alone, do the local modifications
            if (newHasFocus) setInternalFocusedView(eventView);
            else setInternalFocusedView((prevView)=>prevView === eventView ? null : prevView);
        });
    const prevOpenViewRef = $bh6RR.useRef(openView);
    $bh6RR.useEffect(()=>{
        // Set focus to the button when switching from a view to another
        if (prevOpenViewRef.current === openView) return;
        prevOpenViewRef.current = openView;
        handleFocusedViewChange(openView)(true);
    }, [
        openView,
        handleFocusedViewChange
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($7e58aed9f0e484cb$var$CalendarPickerRoot, {
        ref: ref,
        className: (0, $d56pS.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2l38V.PickersCalendarHeader), (0, $4WYaH.default)({}, other, {
                views: views,
                openView: openView,
                currentMonth: calendarState.currentMonth,
                onViewChange: setOpenView,
                onMonthChange: (newMonth, direction)=>handleChangeMonth({
                        newMonth: newMonth,
                        direction: direction
                    }),
                minDate: minDateWithDisabled,
                maxDate: maxDateWithDisabled,
                disabled: disabled,
                disablePast: disablePast,
                disableFuture: disableFuture,
                reduceAnimations: reduceAnimations,
                labelId: gridLabelId
            })),
            /*#__PURE__*/ (0, $ih19M.jsx)($7e58aed9f0e484cb$var$CalendarPickerViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: openView,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    children: [
                        openView === "year" && /*#__PURE__*/ (0, $ih19M.jsx)((0, $iWKGr.YearPicker), (0, $4WYaH.default)({}, other, baseDateValidationProps, commonViewProps, {
                            autoFocus: autoFocus,
                            date: date,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: handleFocusedViewChange("year")
                        })),
                        openView === "month" && /*#__PURE__*/ (0, $ih19M.jsx)((0, $ecvPz.MonthPicker), (0, $4WYaH.default)({}, baseDateValidationProps, commonViewProps, {
                            autoFocus: autoFocus,
                            hasFocus: hasFocus,
                            className: className,
                            date: date,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: handleFocusedViewChange("month")
                        })),
                        openView === "day" && /*#__PURE__*/ (0, $ih19M.jsx)((0, $iruty.DayPicker), (0, $4WYaH.default)({}, other, calendarState, baseDateValidationProps, commonViewProps, {
                            autoFocus: autoFocus,
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            selectedDays: [
                                date
                            ],
                            onSelectedDaysChange: onSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            hasFocus: hasFocus,
                            onFocusedViewChange: handleFocusedViewChange("day"),
                            gridLabelId: gridLabelId
                        }))
                    ]
                })
            })
        ]
    });
});

});
parcelRegister("ecvPz", function(module, exports) {

$parcel$export(module.exports, "MonthPicker", function () { return $a56ae09eb8ba1615$export$6e979f880d369f74; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $d56pS = parcelRequire("d56pS");

var $dm6dP = parcelRequire("dm6dP");

var $g4l1t = parcelRequire("g4l1t");
var $cNBED = parcelRequire("cNBED");

var $7J7Kn = parcelRequire("7J7Kn");
var $82V4F = parcelRequire("82V4F");
var $8M7SI = parcelRequire("8M7SI");

var $lcm8x = parcelRequire("lcm8x");

var $8aNCA = parcelRequire("8aNCA");

var $eVmCr = parcelRequire("eVmCr");

var $BN6Vh = parcelRequire("BN6Vh");

var $ih19M = parcelRequire("ih19M");
const $a56ae09eb8ba1615$var$_excluded = [
    "className",
    "date",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "autoFocus",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange"
];
const $a56ae09eb8ba1615$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $eVmCr.getMonthPickerUtilityClass), classes);
};
function $a56ae09eb8ba1615$export$433328f406bb2390(props, name) {
    const utils = (0, $8aNCA.useUtils)();
    const defaultDates = (0, $8aNCA.useDefaultDates)();
    const themeProps = (0, $cNBED.default)({
        props: props,
        name: name
    });
    return (0, $4WYaH.default)({
        disableFuture: false,
        disablePast: false
    }, themeProps, {
        minDate: (0, $BN6Vh.parseNonNullablePickerDate)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $BN6Vh.parseNonNullablePickerDate)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $a56ae09eb8ba1615$var$MonthPickerRoot = (0, $g4l1t.default)("div", {
    name: "MuiMonthPicker",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    width: 310,
    display: "flex",
    flexWrap: "wrap",
    alignContent: "stretch",
    margin: "0 4px"
});
const $a56ae09eb8ba1615$export$6e979f880d369f74 = /*#__PURE__*/ $bh6RR.forwardRef(function MonthPicker(inProps, ref) {
    const utils = (0, $8aNCA.useUtils)();
    const now = (0, $8aNCA.useNow)();
    const props = $a56ae09eb8ba1615$export$433328f406bb2390(inProps, "MuiMonthPicker");
    const { className: className, date: date, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, disableHighlightToday: disableHighlightToday, autoFocus: autoFocus = false, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange } = props, other = (0, $hCIyK.default)(props, $a56ae09eb8ba1615$var$_excluded);
    const ownerState = props;
    const classes = $a56ae09eb8ba1615$var$useUtilityClasses(ownerState);
    const theme = (0, $dm6dP.default)();
    const selectedDateOrStartOfMonth = $bh6RR.useMemo(()=>date != null ? date : utils.startOfMonth(now), [
        now,
        utils,
        date
    ]);
    const selectedMonth = $bh6RR.useMemo(()=>{
        if (date != null) return utils.getMonth(date);
        if (disableHighlightToday) return null;
        return utils.getMonth(now);
    }, [
        now,
        date,
        utils,
        disableHighlightToday
    ]);
    const [focusedMonth, setFocusedMonth] = $bh6RR.useState(()=>selectedMonth || utils.getMonth(now));
    const isMonthDisabled = $bh6RR.useCallback((month)=>{
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        if (utils.isBefore(month, firstEnabledMonth)) return true;
        if (utils.isAfter(month, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(month);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        utils
    ]);
    const onMonthSelect = (month)=>{
        if (readOnly) return;
        const newDate = utils.setMonth(selectedDateOrStartOfMonth, month);
        onChange(newDate, "finish");
    };
    const [internalHasFocus, setInternalHasFocus] = (0, $82V4F.default)({
        name: "MonthPicker",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus
    });
    const changeHasFocus = $bh6RR.useCallback((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    }, [
        setInternalHasFocus,
        onFocusedViewChange
    ]);
    const focusMonth = $bh6RR.useCallback((month)=>{
        if (!isMonthDisabled(utils.setMonth(selectedDateOrStartOfMonth, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    }, [
        isMonthDisabled,
        utils,
        selectedDateOrStartOfMonth,
        changeHasFocus,
        onMonthFocus
    ]);
    $bh6RR.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $8M7SI.default)((event)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case "ArrowUp":
                focusMonth((monthsInYear + focusedMonth - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowDown":
                focusMonth((monthsInYear + focusedMonth + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowLeft":
                focusMonth((monthsInYear + focusedMonth + (theme.direction === "ltr" ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowRight":
                focusMonth((monthsInYear + focusedMonth + (theme.direction === "ltr" ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = $bh6RR.useCallback((event, month)=>{
        focusMonth(month);
    }, [
        focusMonth
    ]);
    const handleMonthBlur = $bh6RR.useCallback(()=>{
        changeHasFocus(false);
    }, [
        changeHasFocus
    ]);
    const currentMonthNumber = utils.getMonth(now);
    return /*#__PURE__*/ (0, $ih19M.jsx)($a56ae09eb8ba1615$var$MonthPickerRoot, (0, $4WYaH.default)({
        ref: ref,
        className: (0, $d56pS.default)(classes.root, className),
        ownerState: ownerState,
        onKeyDown: handleKeyDown
    }, other, {
        children: utils.getMonthArray(selectedDateOrStartOfMonth).map((month)=>{
            const monthNumber = utils.getMonth(month);
            const monthText = utils.format(month, "monthShort");
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lcm8x.PickersMonth), {
                value: monthNumber,
                selected: monthNumber === selectedMonth,
                tabIndex: monthNumber === focusedMonth && !isDisabled ? 0 : -1,
                hasFocus: internalHasFocus && monthNumber === focusedMonth,
                onSelect: onMonthSelect,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                disabled: isDisabled,
                "aria-current": currentMonthNumber === monthNumber ? "date" : undefined,
                children: monthText
            }, monthText);
        })
    }));
});

});
parcelRegister("lcm8x", function(module, exports) {

$parcel$export(module.exports, "PickersMonth", function () { return $f6ebe3d9f1930ec3$export$bc52fdb7f02f591a; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $aitry = parcelRequire("aitry");

var $jS8gC = parcelRequire("jS8gC");
var $g4l1t = parcelRequire("g4l1t");

var $7J7Kn = parcelRequire("7J7Kn");

var $iWGrV = parcelRequire("iWGrV");

var $3xeL1 = parcelRequire("3xeL1");

var $8NbmW = parcelRequire("8NbmW");

var $ih19M = parcelRequire("ih19M");
const $f6ebe3d9f1930ec3$var$_excluded = [
    "disabled",
    "onSelect",
    "selected",
    "value",
    "tabIndex",
    "hasFocus",
    "onFocus",
    "onBlur"
];
const $f6ebe3d9f1930ec3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $8NbmW.getPickersMonthUtilityClass), classes);
};
const $f6ebe3d9f1930ec3$var$PickersMonthRoot = (0, $g4l1t.default)((0, $aitry.default), {
    name: "PrivatePickersMonth",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $8NbmW.pickersMonthClasses).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $4WYaH.default)({
        flex: "1 0 33.33%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "unset",
        backgroundColor: "transparent",
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: "8px 0",
        height: 36,
        borderRadius: 18,
        cursor: "pointer",
        "&:focus, &:hover": {
            backgroundColor: (0, $jS8gC.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:disabled": {
            pointerEvents: "none",
            color: theme.palette.text.secondary
        },
        [`&.${(0, $8NbmW.pickersMonthClasses).selected}`]: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            "&:focus, &:hover": {
                backgroundColor: theme.palette.primary.dark
            }
        }
    }));
const $f6ebe3d9f1930ec3$var$noop = ()=>{};
const $f6ebe3d9f1930ec3$export$bc52fdb7f02f591a = (props)=>{
    // TODO v6 add 'useThemeProps' once the component class names are aligned
    const { disabled: disabled, onSelect: onSelect, selected: selected, value: value, tabIndex: tabIndex, hasFocus: hasFocus, onFocus: onFocus = $f6ebe3d9f1930ec3$var$noop, onBlur: onBlur = $f6ebe3d9f1930ec3$var$noop } = props, other = (0, $hCIyK.default)(props, $f6ebe3d9f1930ec3$var$_excluded);
    const classes = $f6ebe3d9f1930ec3$var$useUtilityClasses(props);
    const handleSelection = ()=>{
        onSelect(value);
    };
    const ref = $bh6RR.useRef(null);
    (0, $iWGrV.default)(()=>{
        if (hasFocus) {
            var _ref$current;
            (_ref$current = ref.current) == null || _ref$current.focus();
        }
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($f6ebe3d9f1930ec3$var$PickersMonthRoot, (0, $4WYaH.default)({
        ref: ref,
        component: "button",
        type: "button",
        className: classes.root,
        tabIndex: tabIndex,
        onClick: handleSelection,
        onKeyDown: (0, $3xeL1.onSpaceOrEnter)(handleSelection),
        color: selected ? "primary" : undefined,
        variant: selected ? "h5" : "subtitle1",
        disabled: disabled,
        onFocus: (event)=>onFocus(event, value),
        onBlur: (event)=>onBlur(event, value)
    }, other));
};

});
parcelRegister("jS8gC", function(module, exports) {

$parcel$export(module.exports, "alpha", function () { return $e7797925b85e099e$export$58f0f39f63f3cf42; });

var $2ZqBj = parcelRequire("2ZqBj");

var $b4ZRC = parcelRequire("b4ZRC");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $e7797925b85e099e$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $b4ZRC.default)(value, min, max);
}
function $e7797925b85e099e$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $e7797925b85e099e$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $e7797925b85e099e$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $e7797925b85e099e$export$677b39864803984e($e7797925b85e099e$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $2ZqBj.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $2ZqBj.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $e7797925b85e099e$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $e7797925b85e099e$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $e7797925b85e099e$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $e7797925b85e099e$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $e7797925b85e099e$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $e7797925b85e099e$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $e7797925b85e099e$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$e7797925b85e099e$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $e7797925b85e099e$export$29fb7152bd3f781a(color) {
    color = $e7797925b85e099e$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $e7797925b85e099e$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $e7797925b85e099e$export$c852d90bf7403b62(color) {
    color = $e7797925b85e099e$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $e7797925b85e099e$export$677b39864803984e($e7797925b85e099e$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $e7797925b85e099e$export$d061e26956a60b0a(foreground, background) {
    const lumA = $e7797925b85e099e$export$c852d90bf7403b62(foreground);
    const lumB = $e7797925b85e099e$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $e7797925b85e099e$export$58f0f39f63f3cf42(color, value) {
    color = $e7797925b85e099e$export$677b39864803984e(color);
    value = $e7797925b85e099e$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $e7797925b85e099e$export$211a73f2b8c10ce4(color);
}
function $e7797925b85e099e$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $e7797925b85e099e$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $e7797925b85e099e$export$4b073707ff63303(color, coefficient) {
    color = $e7797925b85e099e$export$677b39864803984e(color);
    coefficient = $e7797925b85e099e$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $e7797925b85e099e$export$211a73f2b8c10ce4(color);
}
function $e7797925b85e099e$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $e7797925b85e099e$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $e7797925b85e099e$export$c0816ed86df316af(color, coefficient) {
    color = $e7797925b85e099e$export$677b39864803984e(color);
    coefficient = $e7797925b85e099e$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $e7797925b85e099e$export$211a73f2b8c10ce4(color);
}
function $e7797925b85e099e$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $e7797925b85e099e$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $e7797925b85e099e$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $e7797925b85e099e$export$c852d90bf7403b62(color) > 0.5 ? $e7797925b85e099e$export$4b073707ff63303(color, coefficient) : $e7797925b85e099e$export$c0816ed86df316af(color, coefficient);
}
function $e7797925b85e099e$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $e7797925b85e099e$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $e7797925b85e099e$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $e7797925b85e099e$export$677b39864803984e(background);
    const overlayColor = $e7797925b85e099e$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $e7797925b85e099e$export$211a73f2b8c10ce4({
        type: "rgb",
        values: rgb
    });
}

});

parcelRegister("8NbmW", function(module, exports) {

$parcel$export(module.exports, "getPickersMonthUtilityClass", function () { return $666bb7fa8fc92bb8$export$db90a620ac957a73; });
$parcel$export(module.exports, "pickersMonthClasses", function () { return $666bb7fa8fc92bb8$export$911e3973fa70a12b; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
function $666bb7fa8fc92bb8$export$db90a620ac957a73(slot) {
    // TODO v6 Rename 'PrivatePickersMonth' to 'MuiPickersMonth' to follow convention
    return (0, $XybB6.default)("PrivatePickersMonth", slot);
}
const $666bb7fa8fc92bb8$export$911e3973fa70a12b = (0, $igcUF.default)("PrivatePickersMonth", [
    "root",
    "selected"
]);

});


parcelRegister("eVmCr", function(module, exports) {

$parcel$export(module.exports, "getMonthPickerUtilityClass", function () { return $add7ef3bf6dc4760$export$c42c06ed5a8e405; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
function $add7ef3bf6dc4760$export$c42c06ed5a8e405(slot) {
    return (0, $XybB6.default)("MuiMonthPicker", slot);
}
const $add7ef3bf6dc4760$export$9dafc1a6d475c4d8 = (0, $igcUF.default)("MuiMonthPicker", [
    "root"
]);

});


parcelRegister("7lQph", function(module, exports) {

$parcel$export(module.exports, "useCalendarState", function () { return $55a325772e317e28$export$6d095e787d2b5e1f; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $hwnMM = parcelRequire("hwnMM");

var $8aNCA = parcelRequire("8aNCA");
const $55a325772e317e28$export$2aba07ea6b6cf430 = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils)=>(state, action)=>{
        switch(action.type){
            case "changeMonth":
                return (0, $4WYaH.default)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.newMonth,
                    isMonthSwitchingAnimating: !reduceAnimations
                });
            case "finishMonthSwitchingAnimation":
                return (0, $4WYaH.default)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            case "changeFocusedDay":
                {
                    if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) return state;
                    const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
                    return (0, $4WYaH.default)({}, state, {
                        focusedDay: action.focusedDay,
                        isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
                        currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
                        slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? "left" : "right"
                    });
                }
            default:
                throw new Error("missing support");
        }
    };
const $55a325772e317e28$export$6d095e787d2b5e1f = ({ date: date, defaultCalendarMonth: defaultCalendarMonth, disableFuture: disableFuture, disablePast: disablePast, disableSwitchToMonthOnDayFocus: disableSwitchToMonthOnDayFocus = false, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate })=>{
    var _ref;
    const now = (0, $8aNCA.useNow)();
    const utils = (0, $8aNCA.useUtils)();
    const reducerFn = $bh6RR.useRef($55a325772e317e28$export$2aba07ea6b6cf430(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
    const [calendarState, dispatch] = $bh6RR.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: date || now,
        currentMonth: utils.startOfMonth((_ref = date != null ? date : defaultCalendarMonth) != null ? _ref : now),
        slideDirection: "left"
    });
    const handleChangeMonth = $bh6RR.useCallback((payload)=>{
        dispatch((0, $4WYaH.default)({
            type: "changeMonth"
        }, payload));
        if (onMonthChange) onMonthChange(payload.newMonth);
    }, [
        onMonthChange
    ]);
    const changeMonth = $bh6RR.useCallback((newDate)=>{
        const newDateRequested = newDate != null ? newDate : now;
        if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) return;
        handleChangeMonth({
            newMonth: utils.startOfMonth(newDateRequested),
            direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? "left" : "right"
        });
    }, [
        calendarState.currentMonth,
        handleChangeMonth,
        now,
        utils
    ]);
    const isDateDisabled = (0, $hwnMM.useIsDayDisabled)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast
    });
    const onMonthSwitchingAnimationEnd = $bh6RR.useCallback(()=>{
        dispatch({
            type: "finishMonthSwitchingAnimation"
        });
    }, []);
    const changeFocusedDay = $bh6RR.useCallback((newFocusedDate, withoutMonthSwitchingAnimation)=>{
        if (!isDateDisabled(newFocusedDate)) dispatch({
            type: "changeFocusedDay",
            focusedDay: newFocusedDate,
            withoutMonthSwitchingAnimation: withoutMonthSwitchingAnimation
        });
    }, [
        isDateDisabled
    ]);
    return {
        calendarState: calendarState,
        changeMonth: changeMonth,
        changeFocusedDay: changeFocusedDay,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
        handleChangeMonth: handleChangeMonth
    };
};

});
parcelRegister("hwnMM", function(module, exports) {

$parcel$export(module.exports, "useIsDayDisabled", function () { return $cc17e0363ea51269$export$a09328bc56100216; });
$parcel$export(module.exports, "useDateValidation", function () { return $cc17e0363ea51269$export$23305e90c90aec3f; });

var $bh6RR = parcelRequire("bh6RR");

var $5tdBa = parcelRequire("5tdBa");

var $8aNCA = parcelRequire("8aNCA");

var $BN6Vh = parcelRequire("BN6Vh");
const $cc17e0363ea51269$export$ffb3d0046ef3a2 = ({ props: props, value: value, adapter: adapter })=>{
    const now = adapter.utils.date();
    const date = adapter.utils.date(value);
    const minDate = (0, $BN6Vh.parseNonNullablePickerDate)(adapter.utils, props.minDate, adapter.defaultDates.minDate);
    const maxDate = (0, $BN6Vh.parseNonNullablePickerDate)(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
    if (date === null) return null;
    switch(true){
        case !adapter.utils.isValid(value):
            return "invalidDate";
        case Boolean(props.shouldDisableDate && props.shouldDisableDate(date)):
            return "shouldDisableDate";
        case Boolean(props.disableFuture && adapter.utils.isAfterDay(date, now)):
            return "disableFuture";
        case Boolean(props.disablePast && adapter.utils.isBeforeDay(date, now)):
            return "disablePast";
        case Boolean(minDate && adapter.utils.isBeforeDay(date, minDate)):
            return "minDate";
        case Boolean(maxDate && adapter.utils.isAfterDay(date, maxDate)):
            return "maxDate";
        default:
            return null;
    }
};
const $cc17e0363ea51269$export$a09328bc56100216 = ({ shouldDisableDate: shouldDisableDate, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast })=>{
    const adapter = (0, $8aNCA.useLocalizationContext)();
    return $bh6RR.useCallback((day)=>$cc17e0363ea51269$export$ffb3d0046ef3a2({
            adapter: adapter,
            value: day,
            props: {
                shouldDisableDate: shouldDisableDate,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        minDate,
        maxDate,
        disableFuture,
        disablePast
    ]);
};
const $cc17e0363ea51269$export$1fc3f7983deb8467 = (a, b)=>a === b;
const $cc17e0363ea51269$export$23305e90c90aec3f = (props)=>(0, $5tdBa.useValidation)(props, $cc17e0363ea51269$export$ffb3d0046ef3a2, $cc17e0363ea51269$export$1fc3f7983deb8467);

});
parcelRegister("5tdBa", function(module, exports) {

$parcel$export(module.exports, "useValidation", function () { return $3fba358bf580256e$export$87fe492f99f25a20; });

var $bh6RR = parcelRequire("bh6RR");

var $8aNCA = parcelRequire("8aNCA");
function $3fba358bf580256e$export$87fe492f99f25a20(props, validate, isSameError) {
    const { value: value, onError: onError } = props;
    const adapter = (0, $8aNCA.useLocalizationContext)();
    const previousValidationErrorRef = $bh6RR.useRef(null);
    const validationError = validate({
        adapter: adapter,
        value: value,
        props: props
    });
    $bh6RR.useEffect(()=>{
        if (onError && !isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        isSameError,
        onError,
        previousValidationErrorRef,
        validationError,
        value
    ]);
    return validationError;
}

});



parcelRegister("fv9Yp", function(module, exports) {

$parcel$export(module.exports, "PickersFadeTransitionGroup", function () { return $b4917cc42574e7a3$export$5262185daf493fee; });
parcelRequire("bh6RR");

var $d56pS = parcelRequire("d56pS");

var $9q08x = parcelRequire("9q08x");

var $g4l1t = parcelRequire("g4l1t");
var $cNBED = parcelRequire("cNBED");

var $7J7Kn = parcelRequire("7J7Kn");

var $bm1aQ = parcelRequire("bm1aQ");

var $j5JPa = parcelRequire("j5JPa");

var $ih19M = parcelRequire("ih19M");
const $b4917cc42574e7a3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $j5JPa.getPickersFadeTransitionGroupUtilityClass), classes);
};
const $b4917cc42574e7a3$var$animationDuration = 500;
const $b4917cc42574e7a3$var$PickersFadeTransitionGroupRoot = (0, $g4l1t.default)((0, $bm1aQ.default), {
    name: "MuiPickersFadeTransitionGroup",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    display: "block",
    position: "relative"
});
function $b4917cc42574e7a3$export$5262185daf493fee(inProps) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiPickersFadeTransitionGroup"
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props;
    const classes = $b4917cc42574e7a3$var$useUtilityClasses(props);
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $ih19M.jsx)($b4917cc42574e7a3$var$PickersFadeTransitionGroupRoot, {
        className: (0, $d56pS.default)(classes.root, className),
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9q08x.default), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: $b4917cc42574e7a3$var$animationDuration,
                enter: $b4917cc42574e7a3$var$animationDuration / 2,
                exit: 0
            },
            children: children
        }, transKey)
    });
}

});
parcelRegister("j5JPa", function(module, exports) {

$parcel$export(module.exports, "getPickersFadeTransitionGroupUtilityClass", function () { return $de6207ac7dfb163b$export$5b0bb0174eb448ca; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
const $de6207ac7dfb163b$export$5b0bb0174eb448ca = (slot)=>(0, $XybB6.default)("MuiPickersFadeTransitionGroup", slot);
const $de6207ac7dfb163b$export$1461f245817ac559 = (0, $igcUF.default)("MuiPickersFadeTransitionGroup", [
    "root"
]);

});


parcelRegister("iruty", function(module, exports) {

$parcel$export(module.exports, "DayPicker", function () { return $d6d26378b5e54d56$export$97e6db89a86ff7ab; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $aitry = parcelRequire("aitry");

var $g4l1t = parcelRequire("g4l1t");
var $8gyMY = parcelRequire("8gyMY");
var $cNBED = parcelRequire("cNBED");

var $7J7Kn = parcelRequire("7J7Kn");

var $d56pS = parcelRequire("d56pS");

var $bl26q = parcelRequire("bl26q");

var $8aNCA = parcelRequire("8aNCA");

var $bsLZU = parcelRequire("bsLZU");

var $9zsP0 = parcelRequire("9zsP0");

var $hwnMM = parcelRequire("hwnMM");

var $BN6Vh = parcelRequire("BN6Vh");

var $ifKxu = parcelRequire("ifKxu");

var $ih19M = parcelRequire("ih19M");
const $d6d26378b5e54d56$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        header: [
            "header"
        ],
        weekDayLabel: [
            "weekDayLabel"
        ],
        loadingContainer: [
            "loadingContainer"
        ],
        slideTransition: [
            "slideTransition"
        ],
        monthContainer: [
            "monthContainer"
        ],
        weekContainer: [
            "weekContainer"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $ifKxu.getDayPickerUtilityClass), classes);
};
const $d6d26378b5e54d56$var$defaultDayOfWeekFormatter = (day)=>day.charAt(0).toUpperCase();
const $d6d26378b5e54d56$var$weeksContainerHeight = ((0, $bsLZU.DAY_SIZE) + (0, $bsLZU.DAY_MARGIN) * 2) * 6;
const $d6d26378b5e54d56$var$PickersCalendarDayHeader = (0, $g4l1t.default)("div", {
    name: "MuiDayPicker",
    slot: "Header",
    overridesResolver: (_, styles)=>styles.header
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $d6d26378b5e54d56$var$PickersCalendarWeekDayLabel = (0, $g4l1t.default)((0, $aitry.default), {
    name: "MuiDayPicker",
    slot: "WeekDayLabel",
    overridesResolver: (_, styles)=>styles.weekDayLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: "0 2px",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: theme.palette.text.secondary
    }));
const $d6d26378b5e54d56$var$PickersCalendarLoadingContainer = (0, $g4l1t.default)("div", {
    name: "MuiDayPicker",
    slot: "LoadingContainer",
    overridesResolver: (_, styles)=>styles.loadingContainer
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: $d6d26378b5e54d56$var$weeksContainerHeight
});
const $d6d26378b5e54d56$var$PickersCalendarSlideTransition = (0, $g4l1t.default)((0, $9zsP0.PickersSlideTransition), {
    name: "MuiDayPicker",
    slot: "SlideTransition",
    overridesResolver: (_, styles)=>styles.slideTransition
})({
    minHeight: $d6d26378b5e54d56$var$weeksContainerHeight
});
const $d6d26378b5e54d56$var$PickersCalendarWeekContainer = (0, $g4l1t.default)("div", {
    name: "MuiDayPicker",
    slot: "MonthContainer",
    overridesResolver: (_, styles)=>styles.monthContainer
})({
    overflow: "hidden"
});
const $d6d26378b5e54d56$var$PickersCalendarWeek = (0, $g4l1t.default)("div", {
    name: "MuiDayPicker",
    slot: "WeekContainer",
    overridesResolver: (_, styles)=>styles.weekContainer
})({
    margin: `${(0, $bsLZU.DAY_MARGIN)}px 0`,
    display: "flex",
    justifyContent: "center"
});
function $d6d26378b5e54d56$export$97e6db89a86ff7ab(inProps) {
    const now = (0, $8aNCA.useNow)();
    const utils = (0, $8aNCA.useUtils)();
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiDayPicker"
    });
    const classes = $d6d26378b5e54d56$var$useUtilityClasses(props);
    const { onFocusedDayChange: onFocusedDayChange, className: className, currentMonth: currentMonth, selectedDays: selectedDays, disabled: disabled, disableHighlightToday: disableHighlightToday, focusedDay: focusedDay, isMonthSwitchingAnimating: isMonthSwitchingAnimating, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderDay: renderDay, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $ih19M.jsx)("span", {
            children: "..."
        }), showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, dayOfWeekFormatter: dayOfWeekFormatter = $d6d26378b5e54d56$var$defaultDayOfWeekFormatter, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId } = props;
    const isDateDisabled = (0, $hwnMM.useIsDayDisabled)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture
    });
    const [internalFocusedDay, setInternalFocusedDay] = $bh6RR.useState(()=>focusedDay || now);
    const changeHasFocus = $bh6RR.useCallback((newHasFocus)=>{
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    }, [
        onFocusedViewChange
    ]);
    const handleDaySelect = $bh6RR.useCallback((day, isFinish = "finish")=>{
        if (readOnly) return;
        onSelectedDaysChange(day, isFinish);
    }, [
        onSelectedDaysChange,
        readOnly
    ]);
    const focusDay = $bh6RR.useCallback((day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            setInternalFocusedDay(day);
            changeHasFocus(true);
        }
    }, [
        isDateDisabled,
        onFocusedDayChange,
        changeHasFocus
    ]);
    const theme = (0, $8gyMY.default)();
    function handleKeyDown(event, day) {
        switch(event.key){
            case "ArrowUp":
                focusDay(utils.addDays(day, -7));
                event.preventDefault();
                break;
            case "ArrowDown":
                focusDay(utils.addDays(day, 7));
                event.preventDefault();
                break;
            case "ArrowLeft":
                {
                    const newFocusedDayDefault = utils.addDays(day, theme.direction === "ltr" ? -1 : 1);
                    const nextAvailableMonth = theme.direction === "ltr" ? utils.getPreviousMonth(day) : utils.getNextMonth(day);
                    const closestDayToFocus = (0, $BN6Vh.findClosestEnabledDate)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: theme.direction === "ltr" ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: theme.direction === "ltr" ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case "ArrowRight":
                {
                    const newFocusedDayDefault = utils.addDays(day, theme.direction === "ltr" ? 1 : -1);
                    const nextAvailableMonth = theme.direction === "ltr" ? utils.getNextMonth(day) : utils.getPreviousMonth(day);
                    const closestDayToFocus = (0, $BN6Vh.findClosestEnabledDate)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: theme.direction === "ltr" ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
                        maxDate: theme.direction === "ltr" ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case "Home":
                focusDay(utils.startOfWeek(day));
                event.preventDefault();
                break;
            case "End":
                focusDay(utils.endOfWeek(day));
                event.preventDefault();
                break;
            case "PageUp":
                focusDay(utils.getNextMonth(day));
                event.preventDefault();
                break;
            case "PageDown":
                focusDay(utils.getPreviousMonth(day));
                event.preventDefault();
                break;
            default:
                break;
        }
    }
    function handleFocus(event, day) {
        focusDay(day);
    }
    function handleBlur(event, day) {
        if (hasFocus && utils.isSameDay(internalFocusedDay, day)) changeHasFocus(false);
    }
    const currentMonthNumber = utils.getMonth(currentMonth);
    const validSelectedDays = selectedDays.filter((day)=>!!day).map((day)=>utils.startOfDay(day)); // need a new ref whenever the `key` of the transition changes: http://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = currentMonthNumber; // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $bh6RR.useMemo(()=>/*#__PURE__*/ $bh6RR.createRef(), [
        transitionKey
    ]);
    const startOfCurrentWeek = utils.startOfWeek(now);
    const focusableDay = $bh6RR.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(currentMonth);
        const endOfMonth = utils.endOfMonth(currentMonth);
        if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) return (0, $BN6Vh.findClosestEnabledDate)({
            utils: utils,
            date: internalFocusedDay,
            minDate: startOfMonth,
            maxDate: endOfMonth,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled
        });
        return internalFocusedDay;
    }, [
        currentMonth,
        disableFuture,
        disablePast,
        internalFocusedDay,
        isDateDisabled,
        utils
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        role: "grid",
        "aria-labelledby": gridLabelId,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($d6d26378b5e54d56$var$PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: utils.getWeekdays().map((day, i)=>{
                    var _dayOfWeekFormatter;
                    return /*#__PURE__*/ (0, $ih19M.jsx)($d6d26378b5e54d56$var$PickersCalendarWeekDayLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": utils.format(utils.addDays(startOfCurrentWeek, i), "weekday"),
                        className: classes.weekDayLabel,
                        children: (_dayOfWeekFormatter = dayOfWeekFormatter == null ? void 0 : dayOfWeekFormatter(day)) != null ? _dayOfWeekFormatter : day
                    }, day + i.toString());
                })
            }),
            loading ? /*#__PURE__*/ (0, $ih19M.jsx)($d6d26378b5e54d56$var$PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $ih19M.jsx)($d6d26378b5e54d56$var$PickersCalendarSlideTransition, (0, $4WYaH.default)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $d56pS.default)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $ih19M.jsx)($d6d26378b5e54d56$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: utils.getWeekArray(currentMonth).map((week)=>/*#__PURE__*/ (0, $ih19M.jsx)($d6d26378b5e54d56$var$PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            children: week.map((day)=>{
                                const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
                                const isSelected = validSelectedDays.some((selectedDay)=>utils.isSameDay(selectedDay, day));
                                const isToday = utils.isSameDay(day, now);
                                const pickersDayProps = {
                                    key: day == null ? void 0 : day.toString(),
                                    day: day,
                                    isAnimating: isMonthSwitchingAnimating,
                                    disabled: disabled || isDateDisabled(day),
                                    autoFocus: hasFocus && isFocusableDay,
                                    today: isToday,
                                    outsideCurrentMonth: utils.getMonth(day) !== currentMonthNumber,
                                    selected: isSelected,
                                    disableHighlightToday: disableHighlightToday,
                                    showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                                    onKeyDown: handleKeyDown,
                                    onFocus: handleFocus,
                                    onBlur: handleBlur,
                                    onDaySelect: handleDaySelect,
                                    tabIndex: isFocusableDay ? 0 : -1,
                                    role: "gridcell",
                                    "aria-selected": isSelected
                                };
                                if (isToday) pickersDayProps["aria-current"] = "date";
                                return renderDay ? renderDay(day, validSelectedDays, pickersDayProps) : /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bl26q.PickersDay), (0, $4WYaH.default)({}, pickersDayProps, {
                                    key: pickersDayProps.key
                                }));
                            })
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}

});
parcelRegister("bl26q", function(module, exports) {

$parcel$export(module.exports, "PickersDay", function () { return $8413496e4df96329$export$d7378e6e864346fa; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $d56pS = parcelRequire("d56pS");

var $aEoM0 = parcelRequire("aEoM0");

var $joJqx = parcelRequire("joJqx");

var $7J7Kn = parcelRequire("7J7Kn");

var $jS8gC = parcelRequire("jS8gC");
var $g4l1t = parcelRequire("g4l1t");
var $cNBED = parcelRequire("cNBED");

var $erAkb = parcelRequire("erAkb");

var $8aNCA = parcelRequire("8aNCA");

var $bsLZU = parcelRequire("bsLZU");

var $cHQRr = parcelRequire("cHQRr");

var $ih19M = parcelRequire("ih19M");
const $8413496e4df96329$var$_excluded = [
    "autoFocus",
    "className",
    "day",
    "disabled",
    "disableHighlightToday",
    "disableMargin",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "outsideCurrentMonth",
    "selected",
    "showDaysOutsideCurrentMonth",
    "children",
    "today"
];
const $8413496e4df96329$var$useUtilityClasses = (ownerState)=>{
    const { selected: selected, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, today: today, disabled: disabled, outsideCurrentMonth: outsideCurrentMonth, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            disabled && "disabled",
            !disableMargin && "dayWithMargin",
            !disableHighlightToday && today && "today",
            outsideCurrentMonth && showDaysOutsideCurrentMonth && "dayOutsideMonth",
            outsideCurrentMonth && !showDaysOutsideCurrentMonth && "hiddenDaySpacingFiller"
        ],
        hiddenDaySpacingFiller: [
            "hiddenDaySpacingFiller"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $cHQRr.getPickersDayUtilityClass), classes);
};
const $8413496e4df96329$var$styleArg = ({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({}, theme.typography.caption, {
        width: (0, $bsLZU.DAY_SIZE),
        height: (0, $bsLZU.DAY_SIZE),
        borderRadius: "50%",
        padding: 0,
        // background required here to prevent collides with the other days when animating with transition group
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        "&:hover": {
            backgroundColor: (0, $jS8gC.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:focus": {
            backgroundColor: (0, $jS8gC.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            [`&.${(0, $cHQRr.pickersDayClasses).selected}`]: {
                willChange: "background-color",
                backgroundColor: theme.palette.primary.dark
            }
        },
        [`&.${(0, $cHQRr.pickersDayClasses).selected}`]: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.short
            }),
            "&:hover": {
                willChange: "background-color",
                backgroundColor: theme.palette.primary.dark
            }
        },
        [`&.${(0, $cHQRr.pickersDayClasses).disabled}`]: {
            color: theme.palette.text.disabled
        }
    }, !ownerState.disableMargin && {
        margin: `0 ${0, $bsLZU.DAY_MARGIN}px`
    }, ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && {
        color: theme.palette.text.secondary
    }, !ownerState.disableHighlightToday && ownerState.today && {
        [`&:not(.${(0, $cHQRr.pickersDayClasses).selected})`]: {
            border: `1px solid ${theme.palette.text.secondary}`
        }
    });
const $8413496e4df96329$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.today && styles.today,
        !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $8413496e4df96329$var$PickersDayRoot = (0, $g4l1t.default)((0, $aEoM0.default), {
    name: "MuiPickersDay",
    slot: "Root",
    overridesResolver: $8413496e4df96329$var$overridesResolver
})($8413496e4df96329$var$styleArg);
const $8413496e4df96329$var$PickersDayFiller = (0, $g4l1t.default)("div", {
    name: "MuiPickersDay",
    slot: "Root",
    overridesResolver: $8413496e4df96329$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({}, $8413496e4df96329$var$styleArg({
        theme: theme,
        ownerState: ownerState
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: "none"
    }));
const $8413496e4df96329$var$noop = ()=>{};
const $8413496e4df96329$var$PickersDayRaw = /*#__PURE__*/ $bh6RR.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiPickersDay"
    });
    const { autoFocus: autoFocus = false, className: className, day: day, disabled: disabled = false, disableHighlightToday: disableHighlightToday = false, disableMargin: disableMargin = false, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $8413496e4df96329$var$noop, onBlur: onBlur = $8413496e4df96329$var$noop, onKeyDown: onKeyDown = $8413496e4df96329$var$noop, onMouseDown: onMouseDown, outsideCurrentMonth: outsideCurrentMonth, selected: selected = false, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth = false, children: children, today: isToday = false } = props, other = (0, $hCIyK.default)(props, $8413496e4df96329$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        autoFocus: autoFocus,
        disabled: disabled,
        disableHighlightToday: disableHighlightToday,
        disableMargin: disableMargin,
        selected: selected,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        today: isToday
    });
    const classes = $8413496e4df96329$var$useUtilityClasses(ownerState);
    const utils = (0, $8aNCA.useUtils)();
    const ref = $bh6RR.useRef(null);
    const handleRef = (0, $erAkb.default)(ref, forwardedRef); // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $joJqx.default)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]); // For day outside of current month, move focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        if (onMouseDown) onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        if (!disabled) onDaySelect(day, "finish");
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $ih19M.jsx)($8413496e4df96329$var$PickersDayFiller, {
        className: (0, $d56pS.default)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)($8413496e4df96329$var$PickersDayRoot, (0, $4WYaH.default)({
        className: (0, $d56pS.default)(classes.root, className),
        ownerState: ownerState,
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        children: !children ? utils.format(day, "dayOfMonth") : children
    }));
});
const $8413496e4df96329$export$1fa4d5e98414e66a = (prevProps, nextProps)=>{
    return prevProps.autoFocus === nextProps.autoFocus && prevProps.isAnimating === nextProps.isAnimating && prevProps.today === nextProps.today && prevProps.disabled === nextProps.disabled && prevProps.selected === nextProps.selected && prevProps.disableMargin === nextProps.disableMargin && prevProps.showDaysOutsideCurrentMonth === nextProps.showDaysOutsideCurrentMonth && prevProps.disableHighlightToday === nextProps.disableHighlightToday && prevProps.className === nextProps.className && prevProps.sx === nextProps.sx && prevProps.outsideCurrentMonth === nextProps.outsideCurrentMonth && prevProps.onFocus === nextProps.onFocus && prevProps.onBlur === nextProps.onBlur && prevProps.onDaySelect === nextProps.onDaySelect;
};
const $8413496e4df96329$export$d7378e6e864346fa = /*#__PURE__*/ $bh6RR.memo($8413496e4df96329$var$PickersDayRaw, $8413496e4df96329$export$1fa4d5e98414e66a);

});
parcelRegister("cHQRr", function(module, exports) {

$parcel$export(module.exports, "getPickersDayUtilityClass", function () { return $0263231e1cf8fe6c$export$4b25deb0350d3e53; });
$parcel$export(module.exports, "pickersDayClasses", function () { return $0263231e1cf8fe6c$export$68b221ad3c35e288; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
function $0263231e1cf8fe6c$export$4b25deb0350d3e53(slot) {
    return (0, $XybB6.default)("MuiPickersDay", slot);
}
const $0263231e1cf8fe6c$export$68b221ad3c35e288 = (0, $igcUF.default)("MuiPickersDay", [
    "root",
    "dayWithMargin",
    "dayOutsideMonth",
    "hiddenDaySpacingFiller",
    "today",
    "selected",
    "disabled"
]);

});


parcelRegister("9zsP0", function(module, exports) {

$parcel$export(module.exports, "PickersSlideTransition", function () { return $6f7dbd565f0e0b1e$export$e868fcc7557d3a06; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");

var $d56pS = parcelRequire("d56pS");

var $g4l1t = parcelRequire("g4l1t");

var $7J7Kn = parcelRequire("7J7Kn");

var $5sC4T = parcelRequire("5sC4T");
var $bm1aQ = parcelRequire("bm1aQ");

var $kfZkq = parcelRequire("kfZkq");

var $ih19M = parcelRequire("ih19M");
const $6f7dbd565f0e0b1e$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey"
];
const $6f7dbd565f0e0b1e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $kfZkq.getPickersSlideTransitionUtilityClass), classes);
};
const $6f7dbd565f0e0b1e$export$ee7cc8ee8a5215ec = 350;
const $6f7dbd565f0e0b1e$var$PickersSlideTransitionRoot = (0, $g4l1t.default)((0, $bm1aQ.default), {
    name: "PrivatePickersSlideTransition",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${(0, $kfZkq.pickersSlideTransitionClasses)["slideEnter-left"]}`]: styles["slideEnter-left"]
            },
            {
                [`.${(0, $kfZkq.pickersSlideTransitionClasses)["slideEnter-right"]}`]: styles["slideEnter-right"]
            },
            {
                [`.${(0, $kfZkq.pickersSlideTransitionClasses).slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${(0, $kfZkq.pickersSlideTransitionClasses).slideExit}`]: styles.slideExit
            },
            {
                [`.${(0, $kfZkq.pickersSlideTransitionClasses)["slideExitActiveLeft-left"]}`]: styles["slideExitActiveLeft-left"]
            },
            {
                [`.${(0, $kfZkq.pickersSlideTransitionClasses)["slideExitActiveLeft-right"]}`]: styles["slideExitActiveLeft-right"]
            }
        ]
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create("transform", {
        duration: $6f7dbd565f0e0b1e$export$ee7cc8ee8a5215ec,
        easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
    });
    return {
        display: "block",
        position: "relative",
        overflowX: "hidden",
        "& > *": {
            position: "absolute",
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, $kfZkq.pickersSlideTransitionClasses)["slideEnter-left"]}`]: {
            willChange: "transform",
            transform: "translate(100%)",
            zIndex: 1
        },
        [`& .${(0, $kfZkq.pickersSlideTransitionClasses)["slideEnter-right"]}`]: {
            willChange: "transform",
            transform: "translate(-100%)",
            zIndex: 1
        },
        [`& .${(0, $kfZkq.pickersSlideTransitionClasses).slideEnterActive}`]: {
            transform: "translate(0%)",
            transition: slideTransition
        },
        [`& .${(0, $kfZkq.pickersSlideTransitionClasses).slideExit}`]: {
            transform: "translate(0%)"
        },
        [`& .${(0, $kfZkq.pickersSlideTransitionClasses)["slideExitActiveLeft-left"]}`]: {
            willChange: "transform",
            transform: "translate(-100%)",
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, $kfZkq.pickersSlideTransitionClasses)["slideExitActiveLeft-right"]}`]: {
            willChange: "transform",
            transform: "translate(100%)",
            transition: slideTransition,
            zIndex: 0
        }
    };
});
const $6f7dbd565f0e0b1e$export$e868fcc7557d3a06 = (props)=>{
    // TODO v6: add 'useThemeProps' once the component class names are aligned
    const { children: children, className: className, reduceAnimations: reduceAnimations, slideDirection: slideDirection, transKey: transKey } = props, other = (0, $hCIyK.default)(props, $6f7dbd565f0e0b1e$var$_excluded);
    const classes = $6f7dbd565f0e0b1e$var$useUtilityClasses(props);
    if (reduceAnimations) return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: (0, $d56pS.default)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: (0, $kfZkq.pickersSlideTransitionClasses).slideExit,
        enterActive: (0, $kfZkq.pickersSlideTransitionClasses).slideEnterActive,
        enter: (0, $kfZkq.pickersSlideTransitionClasses)[`slideEnter-${slideDirection}`],
        exitActive: (0, $kfZkq.pickersSlideTransitionClasses)[`slideExitActiveLeft-${slideDirection}`]
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)($6f7dbd565f0e0b1e$var$PickersSlideTransitionRoot, {
        className: (0, $d56pS.default)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $bh6RR.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5sC4T.default), (0, $4WYaH.default)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: $6f7dbd565f0e0b1e$export$ee7cc8ee8a5215ec,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
};

});
parcelRegister("5sC4T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f9d1ac65d00d46c$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $gMqD6 = parcelRequire("gMqD6");


var $2R1GF = parcelRequire("2R1GF");

var $5sqfH = parcelRequire("5sqfH");

var $bh6RR = parcelRequire("bh6RR");

var $7ARPd = parcelRequire("7ARPd");


var $klu5V = parcelRequire("klu5V");
var $3f9d1ac65d00d46c$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $2R1GF.default)(node, c);
    });
};
var $3f9d1ac65d00d46c$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $5sqfH.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $3f9d1ac65d00d46c$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $gMqD6.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, $klu5V.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $3f9d1ac65d00d46c$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $3f9d1ac65d00d46c$var$removeClass(node, baseClassName);
        if (activeClassName) $3f9d1ac65d00d46c$var$removeClass(node, activeClassName);
        if (doneClassName) $3f9d1ac65d00d46c$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $hCIyK.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $7ARPd.default), (0, $4WYaH.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$3f9d1ac65d00d46c$var$CSSTransition.defaultProps = {
    classNames: ""
};
$3f9d1ac65d00d46c$var$CSSTransition.propTypes = {};
var $3f9d1ac65d00d46c$export$2e2bcd8739ae039 = $3f9d1ac65d00d46c$var$CSSTransition;

});
parcelRegister("2R1GF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2141d70f922d7814$export$2e2bcd8739ae039; });

var $4r8ik = parcelRequire("4r8ik");
function $2141d70f922d7814$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $4r8ik.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}

});
parcelRegister("4r8ik", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33b01e299dbd30cd$export$2e2bcd8739ae039; });
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $33b01e299dbd30cd$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("5sqfH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f93ee659ef6c470$export$2e2bcd8739ae039; });
function $3f93ee659ef6c470$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $3f93ee659ef6c470$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $3f93ee659ef6c470$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $3f93ee659ef6c470$var$replaceClassName(element.className && element.className.baseVal || "", className));
}

});


parcelRegister("kfZkq", function(module, exports) {

$parcel$export(module.exports, "getPickersSlideTransitionUtilityClass", function () { return $03ce4549f5a4714f$export$e98c1b6c3bbc3c59; });
$parcel$export(module.exports, "pickersSlideTransitionClasses", function () { return $03ce4549f5a4714f$export$d251a58673156a67; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
const $03ce4549f5a4714f$export$e98c1b6c3bbc3c59 = (slot)=>(0, $XybB6.default)("PrivatePickersSlideTransition", slot);
const $03ce4549f5a4714f$export$d251a58673156a67 = (0, $igcUF.default)("PrivatePickersSlideTransition", [
    "root",
    "slideEnter-left",
    "slideEnter-right",
    "slideEnterActive",
    "slideExit",
    "slideExitActiveLeft-left",
    "slideExitActiveLeft-right"
]);

});


parcelRegister("ifKxu", function(module, exports) {

$parcel$export(module.exports, "getDayPickerUtilityClass", function () { return $d49dba66cf1ddf93$export$7735989980a2c0b6; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
const $d49dba66cf1ddf93$export$7735989980a2c0b6 = (slot)=>(0, $XybB6.default)("MuiDayPicker", slot);
const $d49dba66cf1ddf93$export$e0770f35b28ac552 = (0, $igcUF.default)("MuiDayPicker", [
    "header",
    "weekDayLabel",
    "loadingContainer",
    "slideTransition",
    "monthContainer",
    "weekContainer"
]);

});


parcelRegister("2l38V", function(module, exports) {

$parcel$export(module.exports, "PickersCalendarHeader", function () { return $1b3ffb14e928933f$export$6801ffebb353f473; });

var $4WYaH = parcelRequire("4WYaH");
parcelRequire("bh6RR");

var $9q08x = parcelRequire("9q08x");

var $g4l1t = parcelRequire("g4l1t");
var $cNBED = parcelRequire("cNBED");

var $7J7Kn = parcelRequire("7J7Kn");

var $am7GZ = parcelRequire("am7GZ");

var $8aNCA = parcelRequire("8aNCA");

var $fv9Yp = parcelRequire("fv9Yp");

var $7W0sU = parcelRequire("7W0sU");

var $7JmuG = parcelRequire("7JmuG");

var $3f8YG = parcelRequire("3f8YG");

var $h8ZyY = parcelRequire("h8ZyY");

var $bScT7 = parcelRequire("bScT7");

var $ih19M = parcelRequire("ih19M");
const $1b3ffb14e928933f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        labelContainer: [
            "labelContainer"
        ],
        label: [
            "label"
        ],
        switchViewButton: [
            "switchViewButton"
        ],
        switchViewIcon: [
            "switchViewIcon"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $bScT7.getPickersCalendarHeaderUtilityClass), classes);
};
const $1b3ffb14e928933f$var$PickersCalendarHeaderRoot = (0, $g4l1t.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    display: "flex",
    alignItems: "center",
    marginTop: 16,
    marginBottom: 8,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 30,
    minHeight: 30
});
const $1b3ffb14e928933f$var$PickersCalendarHeaderLabelContainer = (0, $g4l1t.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "LabelContainer",
    overridesResolver: (_, styles)=>styles.labelContainer
})(({ theme: theme })=>(0, $4WYaH.default)({
        display: "flex",
        maxHeight: 30,
        overflow: "hidden",
        alignItems: "center",
        cursor: "pointer",
        marginRight: "auto"
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $1b3ffb14e928933f$var$PickersCalendarHeaderLabel = (0, $g4l1t.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "Label",
    overridesResolver: (_, styles)=>styles.label
})({
    marginRight: 6
});
const $1b3ffb14e928933f$var$PickersCalendarHeaderSwitchViewButton = (0, $g4l1t.default)((0, $am7GZ.default), {
    name: "MuiPickersCalendarHeader",
    slot: "SwitchViewButton",
    overridesResolver: (_, styles)=>styles.switchViewButton
})({
    marginRight: "auto"
});
const $1b3ffb14e928933f$var$PickersCalendarHeaderSwitchViewIcon = (0, $g4l1t.default)((0, $7W0sU.ArrowDropDown), {
    name: "MuiPickersCalendarHeader",
    slot: "SwitchViewIcon",
    overridesResolver: (_, styles)=>styles.switchViewIcon
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        willChange: "transform",
        transition: theme.transitions.create("transform"),
        transform: "rotate(0deg)"
    }, ownerState.openView === "year" && {
        transform: "rotate(180deg)"
    }));
const $1b3ffb14e928933f$var$deprecatedPropsWarning = (0, $h8ZyY.buildDeprecatedPropsWarning)("Props for translation are deprecated. See https://mui.com/x/react-date-pickers/localization for more information.");
function $1b3ffb14e928933f$export$6801ffebb353f473(inProps) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiPickersCalendarHeader"
    });
    const { components: components = {}, componentsProps: componentsProps = {}, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, getViewSwitchingButtonText: getViewSwitchingButtonTextProp, leftArrowButtonText: leftArrowButtonTextProp, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, openView: currentView, reduceAnimations: reduceAnimations, rightArrowButtonText: rightArrowButtonTextProp, views: views, labelId: labelId } = props;
    $1b3ffb14e928933f$var$deprecatedPropsWarning({
        leftArrowButtonText: leftArrowButtonTextProp,
        rightArrowButtonText: rightArrowButtonTextProp,
        getViewSwitchingButtonText: getViewSwitchingButtonTextProp
    });
    const localeText = (0, $8aNCA.useLocaleText)();
    const leftArrowButtonText = leftArrowButtonTextProp != null ? leftArrowButtonTextProp : localeText.previousMonth;
    const rightArrowButtonText = rightArrowButtonTextProp != null ? rightArrowButtonTextProp : localeText.nextMonth;
    const getViewSwitchingButtonText = getViewSwitchingButtonTextProp != null ? getViewSwitchingButtonTextProp : localeText.calendarViewSwitchingButtonAriaLabel;
    const utils = (0, $8aNCA.useUtils)();
    const classes = $1b3ffb14e928933f$var$useUtilityClasses(props);
    const switchViewButtonProps = componentsProps.switchViewButton || {};
    const selectNextMonth = ()=>onMonthChange(utils.getNextMonth(month), "left");
    const selectPreviousMonth = ()=>onMonthChange(utils.getPreviousMonth(month), "right");
    const isNextMonthDisabled = (0, $3f8YG.useNextMonthDisabled)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate
    });
    const isPreviousMonthDisabled = (0, $3f8YG.usePreviousMonthDisabled)(month, {
        disablePast: disablePast,
        minDate: minDate
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((view)=>view !== currentView) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(currentView) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    }; // No need to display more information
    if (views.length === 1 && views[0] === "year") return null;
    const ownerState = props;
    return /*#__PURE__*/ (0, $ih19M.jsxs)($1b3ffb14e928933f$var$PickersCalendarHeaderRoot, {
        ownerState: ownerState,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)($1b3ffb14e928933f$var$PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState // putting this on the label item element below breaks when using transition
                ,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $fv9Yp.PickersFadeTransitionGroup), {
                        reduceAnimations: reduceAnimations,
                        transKey: utils.format(month, "monthAndYear"),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)($1b3ffb14e928933f$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: utils.format(month, "monthAndYear")
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $ih19M.jsx)($1b3ffb14e928933f$var$PickersCalendarHeaderSwitchViewButton, (0, $4WYaH.default)({
                        size: "small",
                        as: components.SwitchViewButton,
                        "aria-label": getViewSwitchingButtonText(currentView),
                        className: classes.switchViewButton
                    }, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)($1b3ffb14e928933f$var$PickersCalendarHeaderSwitchViewIcon, {
                            as: components.SwitchViewIcon,
                            ownerState: ownerState,
                            className: classes.switchViewIcon
                        })
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $9q08x.default), {
                in: currentView === "day",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7JmuG.PickersArrowSwitcher), {
                    leftArrowButtonText: leftArrowButtonText,
                    rightArrowButtonText: rightArrowButtonText,
                    components: components,
                    componentsProps: componentsProps,
                    onLeftClick: selectPreviousMonth,
                    onRightClick: selectNextMonth,
                    isLeftDisabled: isPreviousMonthDisabled,
                    isRightDisabled: isNextMonthDisabled
                })
            })
        ]
    });
}

});
parcelRegister("bScT7", function(module, exports) {

$parcel$export(module.exports, "getPickersCalendarHeaderUtilityClass", function () { return $8a4ebc1fe62e182f$export$457ac4d3a1ad92b4; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
const $8a4ebc1fe62e182f$export$457ac4d3a1ad92b4 = (slot)=>(0, $XybB6.default)("MuiPickersCalendarHeader", slot);
const $8a4ebc1fe62e182f$export$63db7afb9247cb91 = (0, $igcUF.default)("MuiPickersCalendarHeader", [
    "root",
    "labelContainer",
    "label",
    "switchViewButton",
    "switchViewIcon"
]);

});


parcelRegister("iWKGr", function(module, exports) {

$parcel$export(module.exports, "YearPicker", function () { return $dcb1db2aa9a24e89$export$8fb3d2631255548c; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $g4l1t = parcelRequire("g4l1t");
var $8gyMY = parcelRequire("8gyMY");
var $cNBED = parcelRequire("cNBED");

var $7J7Kn = parcelRequire("7J7Kn");

var $d56pS = parcelRequire("d56pS");

var $erAkb = parcelRequire("erAkb");

var $dI1ry = parcelRequire("dI1ry");

var $3nHUi = parcelRequire("3nHUi");

var $8aNCA = parcelRequire("8aNCA");

var $gHJ0l = parcelRequire("gHJ0l");

var $fUZNd = parcelRequire("fUZNd");

var $BN6Vh = parcelRequire("BN6Vh");

var $ih19M = parcelRequire("ih19M");
const $dcb1db2aa9a24e89$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $fUZNd.getYearPickerUtilityClass), classes);
};
function $dcb1db2aa9a24e89$var$useYearPickerDefaultizedProps(props, name) {
    const utils = (0, $8aNCA.useUtils)();
    const defaultDates = (0, $8aNCA.useDefaultDates)();
    const themeProps = (0, $cNBED.default)({
        props: props,
        name: name
    });
    return (0, $4WYaH.default)({
        disablePast: false,
        disableFuture: false
    }, themeProps, {
        minDate: (0, $BN6Vh.parseNonNullablePickerDate)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $BN6Vh.parseNonNullablePickerDate)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $dcb1db2aa9a24e89$var$YearPickerRoot = (0, $g4l1t.default)("div", {
    name: "MuiYearPicker",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    overflowY: "auto",
    height: "100%",
    padding: "0 4px",
    maxHeight: "304px"
});
const $dcb1db2aa9a24e89$export$8fb3d2631255548c = /*#__PURE__*/ $bh6RR.forwardRef(function YearPicker(inProps, ref) {
    const now = (0, $8aNCA.useNow)();
    const theme = (0, $8gyMY.default)();
    const utils = (0, $8aNCA.useUtils)();
    const props = $dcb1db2aa9a24e89$var$useYearPickerDefaultizedProps(inProps, "MuiYearPicker");
    const { autoFocus: autoFocus, className: className, date: date, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, disableHighlightToday: disableHighlightToday, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange } = props;
    const ownerState = props;
    const classes = $dcb1db2aa9a24e89$var$useUtilityClasses(ownerState);
    const selectedDateOrStartOfYear = $bh6RR.useMemo(()=>date != null ? date : utils.startOfYear(now), [
        now,
        utils,
        date
    ]);
    const currentYear = $bh6RR.useMemo(()=>{
        if (date != null) return utils.getYear(date);
        if (disableHighlightToday) return null;
        return utils.getYear(now);
    }, [
        now,
        date,
        utils,
        disableHighlightToday
    ]);
    const wrapperVariant = $bh6RR.useContext((0, $gHJ0l.WrapperVariantContext));
    const selectedYearRef = $bh6RR.useRef(null);
    const [focusedYear, setFocusedYear] = $bh6RR.useState(()=>currentYear || utils.getYear(now));
    const [internalHasFocus, setInternalHasFocus] = (0, $dI1ry.default)({
        name: "YearPicker",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus
    });
    const changeHasFocus = $bh6RR.useCallback((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    }, [
        setInternalHasFocus,
        onFocusedViewChange
    ]);
    const isYearDisabled = $bh6RR.useCallback((dateToValidate)=>{
        if (disablePast && utils.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && utils.isAfterYear(dateToValidate, now)) return true;
        if (minDate && utils.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) return true;
        if (shouldDisableYear && shouldDisableYear(dateToValidate)) return true;
        return false;
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        utils
    ]);
    const handleYearSelection = (event, year, isFinish = "finish")=>{
        if (readOnly) return;
        const newDate = utils.setYear(selectedDateOrStartOfYear, year);
        onChange(newDate, isFinish);
    };
    const focusYear = $bh6RR.useCallback((year)=>{
        if (!isYearDisabled(utils.setYear(selectedDateOrStartOfYear, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus == null || onYearFocus(year);
        }
    }, [
        isYearDisabled,
        utils,
        selectedDateOrStartOfYear,
        changeHasFocus,
        onYearFocus
    ]);
    $bh6RR.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>currentYear !== null && prevFocusedYear !== currentYear ? currentYear : prevFocusedYear);
    }, [
        currentYear
    ]);
    const yearsInRow = wrapperVariant === "desktop" ? 4 : 3;
    const handleKeyDown = $bh6RR.useCallback((event, year)=>{
        switch(event.key){
            case "ArrowUp":
                focusYear(year - yearsInRow);
                event.preventDefault();
                break;
            case "ArrowDown":
                focusYear(year + yearsInRow);
                event.preventDefault();
                break;
            case "ArrowLeft":
                focusYear(year + (theme.direction === "ltr" ? -1 : 1));
                event.preventDefault();
                break;
            case "ArrowRight":
                focusYear(year + (theme.direction === "ltr" ? 1 : -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    }, [
        focusYear,
        theme.direction,
        yearsInRow
    ]);
    const handleFocus = $bh6RR.useCallback((event, year)=>{
        focusYear(year);
    }, [
        focusYear
    ]);
    const handleBlur = $bh6RR.useCallback((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    }, [
        focusedYear,
        changeHasFocus
    ]);
    const nowYear = utils.getYear(now);
    const scrollerRef = $bh6RR.useRef(null);
    const handleRef = (0, $erAkb.default)(ref, scrollerRef);
    $bh6RR.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
         // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($dcb1db2aa9a24e89$var$YearPickerRoot, {
        ref: handleRef,
        className: (0, $d56pS.default)(classes.root, className),
        ownerState: ownerState,
        children: utils.getYearRange(minDate, maxDate).map((year)=>{
            const yearNumber = utils.getYear(year);
            const selected = yearNumber === currentYear;
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $3nHUi.PickersYear), {
                selected: selected,
                value: yearNumber,
                onClick: handleYearSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && yearNumber === focusedYear,
                ref: selected ? selectedYearRef : undefined,
                disabled: disabled || isYearDisabled(year),
                tabIndex: yearNumber === focusedYear ? 0 : -1,
                onFocus: handleFocus,
                onBlur: handleBlur,
                "aria-current": nowYear === yearNumber ? "date" : undefined,
                children: utils.format(year, "year")
            }, utils.format(year, "year"));
        })
    });
});

});
parcelRegister("3nHUi", function(module, exports) {

$parcel$export(module.exports, "PickersYear", function () { return $2765941673e886d5$export$261f3fbd5fd5814d; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $d56pS = parcelRequire("d56pS");

var $fGH8N = parcelRequire("fGH8N");
var $erAkb = parcelRequire("erAkb");

var $jS8gC = parcelRequire("jS8gC");
var $g4l1t = parcelRequire("g4l1t");

var $7J7Kn = parcelRequire("7J7Kn");

var $gHJ0l = parcelRequire("gHJ0l");

var $lvkAx = parcelRequire("lvkAx");

var $ih19M = parcelRequire("ih19M");
const $2765941673e886d5$var$_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "onClick",
    "onKeyDown",
    "value",
    "tabIndex",
    "onFocus",
    "onBlur"
];
const $2765941673e886d5$var$useUtilityClasses = (ownerState)=>{
    const { wrapperVariant: wrapperVariant, disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            wrapperVariant && `mode${(0, $fGH8N.default)(wrapperVariant)}`
        ],
        yearButton: [
            "yearButton",
            disabled && "disabled",
            selected && "selected"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $lvkAx.getPickersYearUtilityClass), classes);
};
const $2765941673e886d5$var$PickersYearRoot = (0, $g4l1t.default)("div", {
    name: "PrivatePickersYear",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $lvkAx.pickersYearClasses).modeDesktop}`]: styles.modeDesktop
            },
            {
                [`&.${(0, $lvkAx.pickersYearClasses).modeMobile}`]: styles.modeMobile
            }
        ]
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        flexBasis: "33.3%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, (ownerState == null ? void 0 : ownerState.wrapperVariant) === "desktop" && {
        flexBasis: "25%"
    }));
const $2765941673e886d5$var$PickersYearButton = (0, $g4l1t.default)("button", {
    name: "PrivatePickersYear",
    slot: "Button",
    overridesResolver: (_, styles)=>[
            styles.button,
            {
                [`&.${(0, $lvkAx.pickersYearClasses).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $lvkAx.pickersYearClasses).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $4WYaH.default)({
        color: "unset",
        backgroundColor: "transparent",
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: "8px 0",
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: "pointer",
        "&:focus, &:hover": {
            backgroundColor: (0, $jS8gC.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $lvkAx.pickersYearClasses).disabled}`]: {
            color: theme.palette.text.secondary
        },
        [`&.${(0, $lvkAx.pickersYearClasses).selected}`]: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            "&:focus, &:hover": {
                backgroundColor: theme.palette.primary.dark
            }
        }
    }));
const $2765941673e886d5$var$noop = ()=>{};
const $2765941673e886d5$export$261f3fbd5fd5814d = /*#__PURE__*/ $bh6RR.forwardRef(function PickersYear(props, forwardedRef) {
    // TODO v6: add 'useThemeProps' once the component class names are aligned
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, onClick: onClick, onKeyDown: onKeyDown, value: value, tabIndex: tabIndex, onFocus: onFocus = $2765941673e886d5$var$noop, onBlur: onBlur = $2765941673e886d5$var$noop } = props, other = (0, $hCIyK.default)(props, $2765941673e886d5$var$_excluded);
    const ref = $bh6RR.useRef(null);
    const refHandle = (0, $erAkb.default)(ref, forwardedRef);
    const wrapperVariant = $bh6RR.useContext((0, $gHJ0l.WrapperVariantContext));
    const ownerState = (0, $4WYaH.default)({}, props, {
        wrapperVariant: wrapperVariant
    });
    const classes = $2765941673e886d5$var$useUtilityClasses(ownerState); // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    $bh6RR.useEffect(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current.focus();
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($2765941673e886d5$var$PickersYearRoot, {
        className: (0, $d56pS.default)(classes.root, className),
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($2765941673e886d5$var$PickersYearButton, (0, $4WYaH.default)({
            ref: refHandle,
            disabled: disabled,
            type: "button",
            tabIndex: disabled ? -1 : tabIndex,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.yearButton,
            ownerState: ownerState
        }, other, {
            children: children
        }))
    });
});

});
parcelRegister("lvkAx", function(module, exports) {

$parcel$export(module.exports, "getPickersYearUtilityClass", function () { return $fa7c76a32bcae59a$export$183c9f339a61cd79; });
$parcel$export(module.exports, "pickersYearClasses", function () { return $fa7c76a32bcae59a$export$4ef58a3d9c6f4296; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
function $fa7c76a32bcae59a$export$183c9f339a61cd79(slot) {
    // TODO v6: Rename 'PrivatePickersYear' to 'MuiPickersYear' to follow convention
    return (0, $XybB6.default)("PrivatePickersYear", slot);
} // TODO v6: Rename 'PrivatePickersYear' to 'MuiPickersYear' to follow convention
const $fa7c76a32bcae59a$export$4ef58a3d9c6f4296 = (0, $igcUF.default)("PrivatePickersYear", [
    "root",
    "modeDesktop",
    "modeMobile",
    "yearButton",
    "selected",
    "disabled"
]);

});


parcelRegister("fUZNd", function(module, exports) {

$parcel$export(module.exports, "getYearPickerUtilityClass", function () { return $b96c04b70c1f30de$export$f2ff97d66516573; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
function $b96c04b70c1f30de$export$f2ff97d66516573(slot) {
    return (0, $XybB6.default)("MuiYearPicker", slot);
}
const $b96c04b70c1f30de$export$bb4597d20e91e1c2 = (0, $igcUF.default)("MuiYearPicker", [
    "root"
]);

});


parcelRegister("1rN44", function(module, exports) {

$parcel$export(module.exports, "defaultReduceAnimations", function () { return $10de5f42fc60bd10$export$96ab2969580bcdae; });
const $10de5f42fc60bd10$export$96ab2969580bcdae = typeof navigator !== "undefined" && /(android)/i.test(navigator.userAgent);

});

parcelRegister("1lA8j", function(module, exports) {

$parcel$export(module.exports, "getCalendarPickerUtilityClass", function () { return $0fb3c7dec35a2e0c$export$e590ef7d5266b255; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
const $0fb3c7dec35a2e0c$export$e590ef7d5266b255 = (slot)=>(0, $XybB6.default)("MuiCalendarPicker", slot);
const $0fb3c7dec35a2e0c$export$54d6b142efe8f412 = (0, $igcUF.default)("MuiCalendarPicker", [
    "root",
    "viewTransitionContainer"
]);

});


parcelRegister("42A3U", function(module, exports) {

$parcel$export(module.exports, "KeyboardDateInput", function () { return $2f13527c55715bbf$export$aa5e86c6cf7f6de8; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");

var $am7GZ = parcelRequire("am7GZ");

var $hPZm5 = parcelRequire("hPZm5");

var $8aNCA = parcelRequire("8aNCA");

var $7W0sU = parcelRequire("7W0sU");

var $eYMiu = parcelRequire("eYMiu");

var $ih19M = parcelRequire("ih19M");
const $2f13527c55715bbf$var$_excluded = [
    "className",
    "components",
    "disableOpenPicker",
    "getOpenDialogAriaText",
    "InputAdornmentProps",
    "InputProps",
    "inputRef",
    "openPicker",
    "OpenPickerButtonProps",
    "renderInput"
];
const $2f13527c55715bbf$export$aa5e86c6cf7f6de8 = /*#__PURE__*/ $bh6RR.forwardRef(function KeyboardDateInput(props, ref) {
    const { className: className, components: components = {}, disableOpenPicker: disableOpenPicker, getOpenDialogAriaText: getOpenDialogAriaTextProp, InputAdornmentProps: InputAdornmentProps, InputProps: InputProps, inputRef: inputRef, openPicker: openPicker, OpenPickerButtonProps: OpenPickerButtonProps, renderInput: renderInput } = props, other = (0, $hCIyK.default)(props, $2f13527c55715bbf$var$_excluded);
    const localeText = (0, $8aNCA.useLocaleText)();
    const getOpenDialogAriaText = getOpenDialogAriaTextProp != null ? getOpenDialogAriaTextProp : localeText.openDatePickerDialogue;
    const utils = (0, $8aNCA.useUtils)();
    const textFieldProps = (0, $eYMiu.useMaskedInput)(other);
    const adornmentPosition = (InputAdornmentProps == null ? void 0 : InputAdornmentProps.position) || "end";
    const OpenPickerIcon = components.OpenPickerIcon || (0, $7W0sU.Calendar);
    return renderInput((0, $4WYaH.default)({
        ref: ref,
        inputRef: inputRef,
        className: className
    }, textFieldProps, {
        InputProps: (0, $4WYaH.default)({}, InputProps, {
            [`${adornmentPosition}Adornment`]: disableOpenPicker ? undefined : /*#__PURE__*/ (0, $ih19M.jsx)((0, $hPZm5.default), (0, $4WYaH.default)({
                position: adornmentPosition
            }, InputAdornmentProps, {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $am7GZ.default), (0, $4WYaH.default)({
                    edge: adornmentPosition,
                    disabled: other.disabled || other.readOnly,
                    "aria-label": getOpenDialogAriaText(other.rawValue, utils)
                }, OpenPickerButtonProps, {
                    onClick: openPicker,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)(OpenPickerIcon, {})
                }))
            }))
        })
    }));
});

});
parcelRegister("hPZm5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfc6cafb8a2ce472$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $fGH8N = parcelRequire("fGH8N");

var $aitry = parcelRequire("aitry");

var $fbHce = parcelRequire("fbHce");

var $djfcj = parcelRequire("djfcj");

var $g4l1t = parcelRequire("g4l1t");

var $eUONZ = parcelRequire("eUONZ");

var $cNBED = parcelRequire("cNBED");

var $ih19M = parcelRequire("ih19M");
"use client";
var $cfc6cafb8a2ce472$var$_span;
const $cfc6cafb8a2ce472$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $cfc6cafb8a2ce472$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $fGH8N.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $cfc6cafb8a2ce472$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, $fGH8N.default)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, $fGH8N.default)(size)}`
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $eUONZ.getInputAdornmentUtilityClass), classes);
};
const $cfc6cafb8a2ce472$var$InputAdornmentRoot = (0, $g4l1t.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver: $cfc6cafb8a2ce472$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $eUONZ.default).positionStart}&:not(.${(0, $eUONZ.default).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const $cfc6cafb8a2ce472$var$InputAdornment = /*#__PURE__*/ $bh6RR.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children: children, className: className, component: component = "div", disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $hCIyK.default)(props, $cfc6cafb8a2ce472$var$_excluded);
    const muiFormControl = (0, $djfcj.default)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $4WYaH.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $cfc6cafb8a2ce472$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $fbHce.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($cfc6cafb8a2ce472$var$InputAdornmentRoot, (0, $4WYaH.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $aPsoC.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $cfc6cafb8a2ce472$var$_span || ($cfc6cafb8a2ce472$var$_span = /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $cfc6cafb8a2ce472$export$2e2bcd8739ae039 = $cfc6cafb8a2ce472$var$InputAdornment;

});
parcelRegister("eUONZ", function(module, exports) {

$parcel$export(module.exports, "getInputAdornmentUtilityClass", function () { return $adbdb4842cb2e2cb$export$4b135a4b3a6c4550; });
$parcel$export(module.exports, "default", function () { return $adbdb4842cb2e2cb$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $adbdb4842cb2e2cb$export$4b135a4b3a6c4550(slot) {
    return (0, $XybB6.default)("MuiInputAdornment", slot);
}
const $adbdb4842cb2e2cb$var$inputAdornmentClasses = (0, $igcUF.default)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
var $adbdb4842cb2e2cb$export$2e2bcd8739ae039 = $adbdb4842cb2e2cb$var$inputAdornmentClasses;

});


parcelRegister("eYMiu", function(module, exports) {

$parcel$export(module.exports, "useMaskedInput", function () { return $ae7c221e44cfc6c5$export$3be87d890b5aa1ad; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $9cINx = parcelRequire("9cINx");

var $8aNCA = parcelRequire("8aNCA");

var $58UED = parcelRequire("58UED");
const $ae7c221e44cfc6c5$export$3be87d890b5aa1ad = ({ acceptRegex: acceptRegex = /[\d]/gi, disabled: disabled, disableMaskedInput: disableMaskedInput, ignoreInvalidInputs: ignoreInvalidInputs, inputFormat: inputFormat, inputProps: inputProps, label: label, mask: mask, onChange: onChange, rawValue: rawValue, readOnly: readOnly, rifmFormatter: rifmFormatter, TextFieldProps: TextFieldProps, validationError: validationError })=>{
    const utils = (0, $8aNCA.useUtils)();
    const formatHelperText = utils.getFormatHelperText(inputFormat);
    const { shouldUseMaskedInput: shouldUseMaskedInput, maskToUse: maskToUse } = $bh6RR.useMemo(()=>{
        // formatting of dates is a quite slow thing, so do not make useless .format calls
        if (disableMaskedInput) return {
            shouldUseMaskedInput: false,
            maskToUse: ""
        };
        const computedMaskToUse = (0, $58UED.getMaskFromCurrentFormat)(mask, inputFormat, acceptRegex, utils);
        return {
            shouldUseMaskedInput: (0, $58UED.checkMaskIsValidForCurrentFormat)(computedMaskToUse, inputFormat, acceptRegex, utils),
            maskToUse: computedMaskToUse
        };
    }, [
        acceptRegex,
        disableMaskedInput,
        inputFormat,
        mask,
        utils
    ]);
    const formatter = $bh6RR.useMemo(()=>shouldUseMaskedInput && maskToUse ? (0, $58UED.maskedDateFormatter)(maskToUse, acceptRegex) : (st)=>st, [
        acceptRegex,
        maskToUse,
        shouldUseMaskedInput
    ]); // TODO: Implement with controlled vs uncontrolled `rawValue`
    const parsedValue = rawValue === null ? null : utils.date(rawValue); // Track the value of the input
    const [innerInputValue, setInnerInputValue] = $bh6RR.useState(parsedValue); // control the input text
    const [innerDisplayedInputValue, setInnerDisplayedInputValue] = $bh6RR.useState((0, $58UED.getDisplayDate)(utils, rawValue, inputFormat)); // Inspired from autocomplete: https://github.com/mui/material-ui/blob/2c89d036dc2e16f100528f161600dffc83241768/packages/mui-base/src/AutocompleteUnstyled/useAutocomplete.js#L185:L201
    const prevRawValue = $bh6RR.useRef();
    const prevLocale = $bh6RR.useRef(utils.locale);
    const prevInputFormat = $bh6RR.useRef(inputFormat);
    $bh6RR.useEffect(()=>{
        const rawValueHasChanged = rawValue !== prevRawValue.current;
        const localeHasChanged = utils.locale !== prevLocale.current;
        const inputFormatHasChanged = inputFormat !== prevInputFormat.current;
        prevRawValue.current = rawValue;
        prevLocale.current = utils.locale;
        prevInputFormat.current = inputFormat;
        if (!rawValueHasChanged && !localeHasChanged && !inputFormatHasChanged) return;
        const newParsedValue = rawValue === null ? null : utils.date(rawValue);
        const isAcceptedValue = rawValue === null || utils.isValid(newParsedValue);
        let innerEqualsParsed = innerInputValue === null && newParsedValue === null; // equal by being both null
        if (innerInputValue !== null && newParsedValue !== null) {
            const areEqual = utils.isEqual(innerInputValue, newParsedValue);
            if (areEqual) innerEqualsParsed = true;
            else {
                const diff = Math.abs(utils.getDiff(innerInputValue, newParsedValue)); // diff in ms
                innerEqualsParsed = diff === 0 ? areEqual // if no diff, use equal to test the time-zone
                 : diff < 1000; // accept a difference bellow 1s
            }
        }
        if (!localeHasChanged && !inputFormatHasChanged && (!isAcceptedValue || innerEqualsParsed)) return;
         // When dev set a new valid value, we trust them
        const newDisplayDate = (0, $58UED.getDisplayDate)(utils, rawValue, inputFormat);
        setInnerInputValue(newParsedValue);
        setInnerDisplayedInputValue(newDisplayDate);
    }, [
        utils,
        rawValue,
        inputFormat,
        innerInputValue
    ]);
    const handleChange = (text)=>{
        const finalString = text === "" || text === mask ? "" : text;
        setInnerDisplayedInputValue(finalString);
        const date = finalString === null ? null : utils.parse(finalString, inputFormat);
        if (ignoreInvalidInputs && !utils.isValid(date)) return;
        setInnerInputValue(date);
        onChange(date, finalString || undefined);
    };
    const rifmProps = (0, $9cINx.useRifm)({
        value: innerDisplayedInputValue,
        onChange: handleChange,
        format: rifmFormatter || formatter
    });
    const inputStateArgs = shouldUseMaskedInput ? rifmProps : {
        value: innerDisplayedInputValue,
        onChange: (event)=>{
            handleChange(event.currentTarget.value);
        }
    };
    return (0, $4WYaH.default)({
        label: label,
        disabled: disabled,
        error: validationError,
        inputProps: (0, $4WYaH.default)({}, inputStateArgs, {
            disabled: disabled,
            placeholder: formatHelperText,
            readOnly: readOnly,
            type: shouldUseMaskedInput ? "tel" : "text"
        }, inputProps)
    }, TextFieldProps);
};

});
parcelRegister("9cINx", function(module, exports) {

$parcel$export(module.exports, "useRifm", function () { return $6b37fbff052e6a56$export$9a2620970bbf44b7; });

var $bh6RR = parcelRequire("bh6RR");
const $6b37fbff052e6a56$export$9a2620970bbf44b7 = (props)=>{
    const [, refresh] = (0, $bh6RR.useReducer)((c)=>c + 1, 0);
    const valueRef = (0, $bh6RR.useRef)(null);
    const { replace: replace, append: append } = props;
    const userValue = replace ? replace(props.format(props.value)) : props.format(props.value); // state of delete button see comments below about inputType support
    const isDeleleteButtonDownRef = (0, $bh6RR.useRef)(false);
    const onChange = (evt)=>{
        const eventValue = evt.target.value;
        valueRef.current = [
            eventValue,
            evt.target,
            eventValue.length > userValue.length,
            isDeleleteButtonDownRef.current,
            userValue === props.format(eventValue) // isNoOperation
        ];
        // that allows us to calculate right cursor position after formatting (see getCursorPosition)
        // then we format new value and call props.onChange with masked/formatted value
        // and finally we are able to set cursor position into right place
        refresh();
    }; // React prints warn on server in non production mode about useLayoutEffect usage
    (0, $bh6RR.useLayoutEffect)(()=>{
        if (valueRef.current == null) return;
        let [eventValue, input, isSizeIncreaseOperation, isDeleleteButtonDown, isNoOperation] = valueRef.current;
        valueRef.current = null; // this usually occurs on deleting special symbols like ' here 123'123.00
        // in case of isDeleleteButtonDown cursor should move differently vs backspace
        const deleteWasNoOp = isDeleleteButtonDown && isNoOperation;
        const valueAfterSelectionStart = eventValue.slice(input.selectionStart);
        const acceptedCharIndexAfterDelete = valueAfterSelectionStart.search(props.accept || /\d/g);
        const charsToSkipAfterDelete = acceptedCharIndexAfterDelete !== -1 ? acceptedCharIndexAfterDelete : 0; // Create string from only accepted symbols
        const clean = (str)=>(str.match(props.accept || /\d/g) || []).join("");
        const valueBeforeSelectionStart = clean(eventValue.substr(0, input.selectionStart)); // trying to find cursor position in formatted value having knowledge about valueBeforeSelectionStart
        // This works because we assume that format doesn't change the order of accepted symbols.
        // Imagine we have formatter which adds ' symbol between numbers, and by default we refuse all non numeric symbols
        // for example we had input = 1'2|'4 (| means cursor position) then user entered '3' symbol
        // inputValue = 1'23'|4 so valueBeforeSelectionStart = 123 and formatted value = 1'2'3'4
        // calling getCursorPosition("1'2'3'4") will give us position after 3, 1'2'3|'4
        // so for formatting just this function to determine cursor position after formatting is enough
        // with masking we need to do some additional checks see `mask` below
        const getCursorPosition = (val)=>{
            let start = 0;
            let cleanPos = 0;
            for(let i = 0; i !== valueBeforeSelectionStart.length; ++i){
                let newPos = val.indexOf(valueBeforeSelectionStart[i], start) + 1;
                let newCleanPos = clean(val).indexOf(valueBeforeSelectionStart[i], cleanPos) + 1; // this skips position change if accepted symbols order was broken
                // For example fixes edge case with fixed point numbers:
                // You have '0|.00', then press 1, it becomes 01|.00 and after format 1.00, this breaks our assumption
                // that order of accepted symbols is not changed after format,
                // so here we don't update start position if other accepted symbols was inbetween current and new position
                if (newCleanPos - cleanPos > 1) {
                    newPos = start;
                    newCleanPos = cleanPos;
                }
                cleanPos = Math.max(newCleanPos, cleanPos);
                start = Math.max(start, newPos);
            }
            return start;
        }; // Masking part, for masks if size of mask is above some value
        // we need to replace symbols instead of do nothing as like in format
        if (props.mask === true && isSizeIncreaseOperation && !isNoOperation) {
            let start = getCursorPosition(eventValue);
            const c = clean(eventValue.substr(start))[0];
            start = eventValue.indexOf(c, start);
            eventValue = `${eventValue.substr(0, start)}${eventValue.substr(start + 1)}`;
        }
        let formattedValue = props.format(eventValue);
        if (append != null && // cursor at the end
        input.selectionStart === eventValue.length && !isNoOperation) {
            if (isSizeIncreaseOperation) formattedValue = append(formattedValue);
            else // If after delete last char is special character and we use append
            // delete it too
            // was: "12-3|" backspace pressed, then should be "12|"
            if (clean(formattedValue.slice(-1)) === "") formattedValue = formattedValue.slice(0, -1);
        }
        const replacedValue = replace ? replace(formattedValue) : formattedValue;
        if (userValue === replacedValue) // if nothing changed for formatted value, just refresh so userValue will be used at render
        refresh();
        else props.onChange(replacedValue);
        return ()=>{
            let start = getCursorPosition(formattedValue); // Visually improves working with masked values,
            // like cursor jumping over refused symbols
            // as an example date mask: was "5|1-24-3" then user pressed "6"
            // it becomes "56-|12-43" with this code, and "56|-12-43" without
            if (props.mask != null && (isSizeIncreaseOperation || isDeleleteButtonDown && !deleteWasNoOp)) while(formattedValue[start] && clean(formattedValue[start]) === "")start += 1;
            input.selectionStart = input.selectionEnd = start + (deleteWasNoOp ? 1 + charsToSkipAfterDelete : 0);
        };
    });
    (0, $bh6RR.useEffect)(()=>{
        // until https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported
        // by all major browsers (now supported by: +chrome, +safari, ?edge, !firefox)
        // there is no way I found to distinguish in onChange
        // backspace or delete was called in some situations
        // firefox track https://bugzilla.mozilla.org/show_bug.cgi?id=1447239
        const handleKeyDown = (evt)=>{
            if (evt.code === "Delete") isDeleleteButtonDownRef.current = true;
        };
        const handleKeyUp = (evt)=>{
            if (evt.code === "Delete") isDeleleteButtonDownRef.current = false;
        };
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, []);
    return {
        value: valueRef.current != null ? valueRef.current[0] : userValue,
        onChange: onChange
    };
};
const $6b37fbff052e6a56$export$5519909ee832c7c = (props)=>{
    const renderProps = $6b37fbff052e6a56$export$9a2620970bbf44b7(props);
    return props.children(renderProps);
};

});

parcelRegister("58UED", function(module, exports) {

$parcel$export(module.exports, "getDisplayDate", function () { return $3be9a57d87663736$export$61abca328afe490a; });
$parcel$export(module.exports, "getMaskFromCurrentFormat", function () { return $3be9a57d87663736$export$4b5431a6d21283e4; });
$parcel$export(module.exports, "checkMaskIsValidForCurrentFormat", function () { return $3be9a57d87663736$export$17b3b67b7ed6b51d; });
$parcel$export(module.exports, "maskedDateFormatter", function () { return $3be9a57d87663736$export$bd2dd9a8014709bf; });
const $3be9a57d87663736$export$61abca328afe490a = (utils, rawValue, inputFormat)=>{
    const date = utils.date(rawValue);
    const isEmpty = rawValue === null;
    if (isEmpty) return "";
    return utils.isValid(date) ? utils.formatByString(// Either we allow `TDate | null` to be valid and guard against calling `formatByString` with `null`.
    // Or we ensure `formatByString` is callable with `null`.
    date, inputFormat) : "";
};
const $3be9a57d87663736$var$MASK_USER_INPUT_SYMBOL = "_";
const $3be9a57d87663736$var$staticDateWith2DigitTokens = "2019-11-21T22:30:00.000";
const $3be9a57d87663736$var$staticDateWith1DigitTokens = "2019-01-01T09:00:00.000";
function $3be9a57d87663736$export$4b5431a6d21283e4(mask, format, acceptRegex, utils) {
    if (mask) return mask;
    const formattedDateWith1Digit = utils.formatByString(utils.date($3be9a57d87663736$var$staticDateWith1DigitTokens), format);
    const inferredFormatPatternWith1Digits = formattedDateWith1Digit.replace(acceptRegex, $3be9a57d87663736$var$MASK_USER_INPUT_SYMBOL);
    const inferredFormatPatternWith2Digits = utils.formatByString(utils.date($3be9a57d87663736$var$staticDateWith2DigitTokens), format).replace(acceptRegex, "_");
    if (inferredFormatPatternWith1Digits === inferredFormatPatternWith2Digits) return inferredFormatPatternWith1Digits;
    return "";
}
function $3be9a57d87663736$export$17b3b67b7ed6b51d(mask, format, acceptRegex, utils) {
    if (!mask) return false;
    const formattedDateWith1Digit = utils.formatByString(utils.date($3be9a57d87663736$var$staticDateWith1DigitTokens), format);
    const inferredFormatPatternWith1Digits = formattedDateWith1Digit.replace(acceptRegex, $3be9a57d87663736$var$MASK_USER_INPUT_SYMBOL);
    const inferredFormatPatternWith2Digits = utils.formatByString(utils.date($3be9a57d87663736$var$staticDateWith2DigitTokens), format).replace(acceptRegex, "_");
    const isMaskValid = inferredFormatPatternWith2Digits === inferredFormatPatternWith1Digits && mask === inferredFormatPatternWith2Digits;
    !isMaskValid && utils.lib;
    return isMaskValid;
}
const $3be9a57d87663736$export$bd2dd9a8014709bf = (mask, acceptRegexp)=>(value)=>{
        let outputCharIndex = 0;
        return value.split("").map((char, inputCharIndex)=>{
            acceptRegexp.lastIndex = 0;
            if (outputCharIndex > mask.length - 1) return "";
            const maskChar = mask[outputCharIndex];
            const nextMaskChar = mask[outputCharIndex + 1];
            const acceptedChar = acceptRegexp.test(char) ? char : "";
            const formattedChar = maskChar === $3be9a57d87663736$var$MASK_USER_INPUT_SYMBOL ? acceptedChar : maskChar + acceptedChar;
            outputCharIndex += formattedChar.length;
            const isLastCharacter = inputCharIndex === value.length - 1;
            if (isLastCharacter && nextMaskChar && nextMaskChar !== $3be9a57d87663736$var$MASK_USER_INPUT_SYMBOL) // when cursor at the end of mask part (e.g. month) prerender next symbol "21" -> "21/"
            return formattedChar ? formattedChar + nextMaskChar : "";
            return formattedChar;
        }).join("");
    };

});



parcelRegister("Sro99", function(module, exports) {

$parcel$export(module.exports, "useIsLandscape", function () { return $0a3a4a09b9c1f9c0$export$6f60b24e37af6448; });

var $bh6RR = parcelRequire("bh6RR");

var $joJqx = parcelRequire("joJqx");

var $3xeL1 = parcelRequire("3xeL1");
function $0a3a4a09b9c1f9c0$var$getOrientation() {
    if (typeof window === "undefined") return "portrait";
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait";
     // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
    return "portrait";
}
const $0a3a4a09b9c1f9c0$export$6f60b24e37af6448 = (views, customOrientation)=>{
    const [orientation, setOrientation] = $bh6RR.useState($0a3a4a09b9c1f9c0$var$getOrientation);
    (0, $joJqx.default)(()=>{
        const eventHandler = ()=>{
            setOrientation($0a3a4a09b9c1f9c0$var$getOrientation());
        };
        window.addEventListener("orientationchange", eventHandler);
        return ()=>{
            window.removeEventListener("orientationchange", eventHandler);
        };
    }, []);
    if ((0, $3xeL1.arrayIncludes)(views, [
        "hours",
        "minutes",
        "seconds"
    ])) // could not display 13:34:44 in landscape mode
    return false;
    const orientationToUse = customOrientation || orientation;
    return orientationToUse === "landscape";
};

});

parcelRegister("5nSom", function(module, exports) {

$parcel$export(module.exports, "useFocusManagement", function () { return $3eb94ad04173db1c$export$a82d382c0b37f9cc; });

var $bh6RR = parcelRequire("bh6RR");
const $3eb94ad04173db1c$export$a82d382c0b37f9cc = ({ autoFocus: autoFocus, openView: openView })=>{
    const [focusedView, setFocusedView] = $bh6RR.useState(autoFocus ? openView : null);
    const setFocusedViewCallback = $bh6RR.useCallback((view)=>(newHasFocus)=>{
            if (newHasFocus) setFocusedView(view);
            else setFocusedView((prevFocusedView)=>view === prevFocusedView ? null : prevFocusedView);
        }, []);
    return {
        focusedView: focusedView,
        setFocusedView: setFocusedViewCallback
    };
};

});

parcelRegister("lCIvP", function(module, exports) {

$parcel$export(module.exports, "getCalendarOrClockPickerUtilityClass", function () { return $fbdfaccb047ffdc8$export$585697e91ac63d80; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
function $fbdfaccb047ffdc8$export$585697e91ac63d80(slot) {
    return (0, $XybB6.default)("MuiCalendarOrClockPicker", slot);
}
const $fbdfaccb047ffdc8$export$4d7e84bf47c0a26d = (0, $igcUF.default)("MuiCalendarOrClockPicker", [
    "root",
    "mobileKeyboardInputView"
]);

});


parcelRegister("kWl3f", function(module, exports) {

$parcel$export(module.exports, "usePickerState", function () { return $f3e98dd00c934fd8$export$68b76ad63c1c3f8f; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $468iC = parcelRequire("468iC");

var $8aNCA = parcelRequire("8aNCA");
const $f3e98dd00c934fd8$export$68b76ad63c1c3f8f = (props, valueManager)=>{
    const { onAccept: onAccept, onChange: onChange, value: value, closeOnSelect: closeOnSelect } = props;
    const utils = (0, $8aNCA.useUtils)();
    const { isOpen: isOpen, setIsOpen: setIsOpen } = (0, $468iC.useOpenState)(props);
    const parsedDateValue = $bh6RR.useMemo(()=>valueManager.parseInput(utils, value), [
        valueManager,
        utils,
        value
    ]);
    const [lastValidDateValue, setLastValidDateValue] = $bh6RR.useState(parsedDateValue);
    const [dateState, setDateState] = $bh6RR.useState(()=>({
            committed: parsedDateValue,
            draft: parsedDateValue,
            resetFallback: parsedDateValue
        }));
    const setDate = $bh6RR.useCallback((params)=>{
        setDateState((prev)=>{
            switch(params.action){
                case "setAll":
                case "acceptAndClose":
                    return {
                        draft: params.value,
                        committed: params.value,
                        resetFallback: params.value
                    };
                case "setCommitted":
                    return (0, $4WYaH.default)({}, prev, {
                        draft: params.value,
                        committed: params.value
                    });
                case "setDraft":
                    return (0, $4WYaH.default)({}, prev, {
                        draft: params.value
                    });
                default:
                    return prev;
            }
        });
        if (params.forceOnChangeCall || !params.skipOnChangeCall && !valueManager.areValuesEqual(utils, dateState.committed, params.value)) onChange(params.value);
        if (params.action === "acceptAndClose") {
            setIsOpen(false);
            if (onAccept && !valueManager.areValuesEqual(utils, dateState.resetFallback, params.value)) onAccept(params.value);
        }
    }, [
        onAccept,
        onChange,
        setIsOpen,
        dateState,
        utils,
        valueManager
    ]);
    $bh6RR.useEffect(()=>{
        if (utils.isValid(parsedDateValue)) setLastValidDateValue(parsedDateValue);
    }, [
        utils,
        parsedDateValue
    ]);
    $bh6RR.useEffect(()=>{
        if (isOpen) // Update all dates in state to equal the current prop value
        setDate({
            action: "setAll",
            value: parsedDateValue,
            skipOnChangeCall: true
        });
    }, [
        isOpen
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Set the draft and committed date to equal the new prop value.
    if (!valueManager.areValuesEqual(utils, dateState.committed, parsedDateValue)) setDate({
        action: "setCommitted",
        value: parsedDateValue,
        skipOnChangeCall: true
    });
    const wrapperProps = $bh6RR.useMemo(()=>({
            open: isOpen,
            onClear: ()=>{
                // Reset all date in state to the empty value and close picker.
                setDate({
                    value: valueManager.emptyValue,
                    action: "acceptAndClose",
                    // force `onChange` in cases like input (value) === `Invalid date`
                    forceOnChangeCall: !valueManager.areValuesEqual(utils, value, valueManager.emptyValue)
                });
            },
            onAccept: ()=>{
                // Set all date in state to equal the current draft value and close picker.
                setDate({
                    value: dateState.draft,
                    action: "acceptAndClose",
                    // force `onChange` in cases like input (value) === `Invalid date`
                    forceOnChangeCall: !valueManager.areValuesEqual(utils, value, parsedDateValue)
                });
            },
            onDismiss: ()=>{
                // Set all dates in state to equal the last committed date.
                // e.g. Reset the state to the last committed value.
                setDate({
                    value: dateState.committed,
                    action: "acceptAndClose"
                });
            },
            onCancel: ()=>{
                // Set all dates in state to equal the last accepted date and close picker.
                // e.g. Reset the state to the last accepted value
                setDate({
                    value: dateState.resetFallback,
                    action: "acceptAndClose"
                });
            },
            onSetToday: ()=>{
                // Set all dates in state to equal today and close picker.
                setDate({
                    value: valueManager.getTodayValue(utils),
                    action: "acceptAndClose"
                });
            }
        }), [
        setDate,
        isOpen,
        utils,
        dateState,
        valueManager,
        value,
        parsedDateValue
    ]); // Mobile keyboard view is a special case.
    // When it's open picker should work like closed, because we are just showing text field
    const [isMobileKeyboardViewOpen, setMobileKeyboardViewOpen] = $bh6RR.useState(false);
    const pickerProps = $bh6RR.useMemo(()=>({
            parsedValue: dateState.draft,
            isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
            toggleMobileKeyboardView: ()=>setMobileKeyboardViewOpen(!isMobileKeyboardViewOpen),
            onDateChange: (newDate, wrapperVariant, selectionState = "partial")=>{
                switch(selectionState){
                    case "shallow":
                        // Update the `draft` state but do not fire `onChange`
                        return setDate({
                            action: "setDraft",
                            value: newDate,
                            skipOnChangeCall: true
                        });
                    case "partial":
                        // Update the `draft` state and fire `onChange`
                        return setDate({
                            action: "setDraft",
                            value: newDate
                        });
                    case "finish":
                        if (closeOnSelect != null ? closeOnSelect : wrapperVariant === "desktop") // Set all dates in state to equal the new date and close picker.
                        return setDate({
                            value: newDate,
                            action: "acceptAndClose"
                        });
                         // Updates the `committed` state and fire `onChange`
                        return setDate({
                            value: newDate,
                            action: "setCommitted"
                        });
                    default:
                        throw new Error("MUI: Invalid selectionState passed to `onDateChange`");
                }
            }
        }), [
        setDate,
        isMobileKeyboardViewOpen,
        dateState.draft,
        closeOnSelect
    ]);
    const handleInputChange = $bh6RR.useCallback((newParsedValue, keyboardInputValue)=>{
        const cleanParsedValue = valueManager.valueReducer ? valueManager.valueReducer(utils, lastValidDateValue, newParsedValue) : newParsedValue;
        onChange(cleanParsedValue, keyboardInputValue);
    }, [
        onChange,
        valueManager,
        lastValidDateValue,
        utils
    ]);
    const inputProps = $bh6RR.useMemo(()=>({
            onChange: handleInputChange,
            open: isOpen,
            rawValue: value,
            openPicker: ()=>setIsOpen(true)
        }), [
        handleInputChange,
        isOpen,
        value,
        setIsOpen
    ]);
    const pickerState = {
        pickerProps: pickerProps,
        inputProps: inputProps,
        wrapperProps: wrapperProps
    };
    $bh6RR.useDebugValue(pickerState, ()=>({
            MuiPickerState: {
                dateState: dateState,
                other: pickerState
            }
        }));
    return pickerState;
};

});
parcelRegister("468iC", function(module, exports) {

$parcel$export(module.exports, "useOpenState", function () { return $2fbe290dae2f9c6b$export$7d3a09d5141ab1f4; });

var $bh6RR = parcelRequire("bh6RR");
const $2fbe290dae2f9c6b$export$7d3a09d5141ab1f4 = ({ open: open, onOpen: onOpen, onClose: onClose })=>{
    const isControllingOpenProp = $bh6RR.useRef(typeof open === "boolean").current;
    const [openState, setIsOpenState] = $bh6RR.useState(false); // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (e.g. initially opened)
    $bh6RR.useEffect(()=>{
        if (isControllingOpenProp) {
            if (typeof open !== "boolean") throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
            setIsOpenState(open);
        }
    }, [
        isControllingOpenProp,
        open
    ]);
    const setIsOpen = $bh6RR.useCallback((newIsOpen)=>{
        if (!isControllingOpenProp) setIsOpenState(newIsOpen);
        if (newIsOpen && onOpen) onOpen();
        if (!newIsOpen && onClose) onClose();
    }, [
        isControllingOpenProp,
        onOpen,
        onClose
    ]);
    return {
        isOpen: openState,
        setIsOpen: setIsOpen
    };
};

});




parcelRegister("jTwFz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b088c9ac60ed2dc4$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $gFVvY = parcelRequire("gFVvY");

var $dqRXb = parcelRequire("dqRXb");

var $6L9uu = parcelRequire("6L9uu");

var $d13i8 = parcelRequire("d13i8");

var $bSbwb = parcelRequire("bSbwb");

var $1ZlXU = parcelRequire("1ZlXU");

var $bilGR = parcelRequire("bilGR");

var $91340 = parcelRequire("91340");

var $ehzwo = parcelRequire("ehzwo");

var $5PJ2i = parcelRequire("5PJ2i");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $gF9d2 = parcelRequire("gF9d2");
const $b088c9ac60ed2dc4$var$defaultErrorsObj = {
    calendarTitle: null,
    calendarLocation: null,
    calendarCompany: null,
    calendarCreator: null,
    calendarStartDate: null,
    calendarEndDate: null,
    calendarType: null,
    startDate: null,
    startTime: null,
    endDate: null,
    endTime: null
};
const $b088c9ac60ed2dc4$export$1067ba46601ca091 = {
    calendarTitle: "Title field is required",
    calendarCompany: "Please select an option from the menu",
    calendarCreator: "Please select creator option from the menu",
    calendarStartDate: "Please select Starting date",
    calendarEndDate: "Please select End date",
    calendarType: "Please select Calendar Type",
    dateInPast: "Selected date should not be in the past",
    timeInPast: "Selected time should not be in the past",
    startDate: "Select Start date",
    startTime: "Select Time",
    endDate: "Select End Date",
    endTime: "Select Time",
    endTimeBeforeStartTime: "End time should be after start time",
    startTimeInPast: "Selected time should not be in the past",
    endDateAfterStart: "End date should be after start date"
};
const $b088c9ac60ed2dc4$var$CalendarForm = ({ handleClose: handleClose, isEditMode: isEditMode, calendarEvent: calendarEvent })=>{
    const { state: state, dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const allCompanies = (0, $hjfla.useCompaniesNamesQuery)();
    const allCreators = (0, $hjfla.useContactBasicDataQuery)();
    const allTypes = (0, $hjfla.useCalendarTypesQuery)();
    const [selectedCompany, setSelectedCompany] = (0, $bh6RR.useState)(calendarEvent?.company ?? null);
    const [selectedCreator, setSelectedCreator] = (0, $bh6RR.useState)(calendarEvent?.creator ?? null);
    const [selectedType, setSelectedType] = (0, $bh6RR.useState)(calendarEvent?.type ?? null);
    const [title, setTitle] = (0, $bh6RR.useState)(calendarEvent?.title ?? "");
    const [location, setLocation] = (0, $bh6RR.useState)(calendarEvent?.location ?? "");
    const [startDate, setStartDate] = (0, $bh6RR.useState)(isEditMode ? (0, $gFVvY.parseDate)(calendarEvent?.start_date) : null);
    const [startTime, setStartTime] = (0, $bh6RR.useState)(isEditMode ? (0, $gFVvY.parseDate)(calendarEvent?.start_date) : null);
    const [endDate, setEndDate] = (0, $bh6RR.useState)(isEditMode ? (0, $gFVvY.parseDate)(calendarEvent?.end_date) : null);
    const [endTime, setEndTime] = (0, $bh6RR.useState)(isEditMode ? (0, $gFVvY.parseDate)(calendarEvent?.end_date) : null);
    const [description, setDescription] = (0, $bh6RR.useState)(calendarEvent?.description ?? "");
    const [addEvent, addEventResult] = (0, $hjfla.useAddEventMutation)();
    const [updateEvent, updateEventResult] = (0, $hjfla.useUpdateEventMutation)();
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($b088c9ac60ed2dc4$var$defaultErrorsObj);
    const [editEnabled, setEditEnabled] = (0, $bh6RR.useState)(calendarEvent === null);
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).CalendarEvent);
    const handleTitleChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value.length > 1) setFormErrors({
            ...formErrors,
            calendarTitle: null
        });
        else setFormErrors({
            ...formErrors,
            calendarTitle: $b088c9ac60ed2dc4$export$1067ba46601ca091.calendarTitle
        });
        setTitle(value);
    };
    const handleDescriptionChange = (event)=>{
        const { value: value } = event.currentTarget;
        setDescription(value);
    };
    const handleLocationChange = (event)=>{
        const { value: value } = event.currentTarget;
        setLocation(value);
    };
    const handleCalendarCompanyChange = (_, newValue)=>{
        if (newValue) setFormErrors({
            ...formErrors,
            calendarCompany: null
        });
        else setFormErrors({
            ...formErrors,
            calendarCompany: $b088c9ac60ed2dc4$export$1067ba46601ca091.calendarCompany
        });
        setSelectedCompany(newValue);
    };
    const handleCalendarCreatorChange = (_, newValue)=>{
        if (newValue) setFormErrors({
            ...formErrors,
            calendarCreator: null
        });
        else setFormErrors({
            ...formErrors,
            calendarCreator: $b088c9ac60ed2dc4$export$1067ba46601ca091.calendarCreator
        });
        setSelectedCreator(newValue);
    };
    const handleCalendarTypeChange = (_, newValue)=>{
        if (newValue) setFormErrors({
            ...formErrors,
            calendarType: null
        });
        else setFormErrors({
            ...formErrors,
            calendarType: $b088c9ac60ed2dc4$export$1067ba46601ca091.calendarType
        });
        setSelectedType(newValue);
    };
    const handleStartDateChange = (dateInput)=>{
        let errors = formErrors;
        errors = {
            ...errors,
            startDate: null
        };
        if (dateInput) {
            if (startTime) {
                if (getCurrentDateTime(dateInput, startTime).getTime() < new Date().getTime()) errors = {
                    ...errors,
                    startTime: $b088c9ac60ed2dc4$export$1067ba46601ca091.startTimeInPast
                };
            }
            if (endDate) {
                if (endDate < dateInput) errors = {
                    ...errors,
                    endDate: $b088c9ac60ed2dc4$export$1067ba46601ca091.endDateAfterStart
                };
                else errors = {
                    ...errors,
                    endDate: null
                };
                if (endTime) {
                    if (getCurrentDateTime(dateInput, startTime).getTime() > getCurrentDateTime(endDate, endTime).getTime()) {
                        errors = {
                            ...errors,
                            endTime: $b088c9ac60ed2dc4$export$1067ba46601ca091.endTimeBeforeStartTime
                        };
                        errors = {
                            ...errors,
                            endDate: null
                        };
                    }
                } else errors = {
                    ...errors,
                    endTime: null
                };
            }
        } else errors = {
            ...errors,
            startDate: $b088c9ac60ed2dc4$export$1067ba46601ca091.startDate
        };
        setFormErrors(errors);
        setStartDate(dateInput);
    };
    const handleStartTimeChanged = (timeInput)=>{
        let errors = formErrors;
        errors = {
            ...errors,
            startTime: null
        };
        if (timeInput) {
            if (startDate) {
                if (getCurrentDateTime(startDate, timeInput).getTime() < new Date().getTime()) errors = {
                    ...errors,
                    startTime: $b088c9ac60ed2dc4$export$1067ba46601ca091.startTimeInPast
                };
                if (endDate && endTime) {
                    if (getCurrentDateTime(startDate, timeInput).getTime() > getCurrentDateTime(endDate, endTime).getTime()) errors = {
                        ...errors,
                        endTime: $b088c9ac60ed2dc4$export$1067ba46601ca091.endTimeBeforeStartTime
                    };
                }
            }
        }
        setFormErrors(errors);
        setStartTime(timeInput);
    };
    const handleEndDateChange = (dateInput)=>{
        let errors = formErrors;
        errors = {
            ...errors,
            endDate: null,
            endTime: null
        };
        if (dateInput) {
            if (startDate) {
                if (getCurrentDateTime(startDate, startTime).getTime() > getCurrentDateTime(dateInput, endTime).getTime()) errors = {
                    ...errors,
                    endTime: $b088c9ac60ed2dc4$export$1067ba46601ca091.endTimeBeforeStartTime
                };
            }
        } else errors = {
            ...errors,
            endDate: $b088c9ac60ed2dc4$export$1067ba46601ca091.endDate
        };
        setFormErrors(errors);
        setEndDate(dateInput);
    };
    const handleEndTimeChange = (timeInput)=>{
        let errors = formErrors;
        errors = {
            ...errors,
            endTime: null
        };
        if (timeInput) {
            if (startDate && endDate) {
                if (getCurrentDateTime(startDate, startTime).getTime() > getCurrentDateTime(endDate, timeInput).getTime()) errors = {
                    ...errors,
                    endTime: $b088c9ac60ed2dc4$export$1067ba46601ca091.endTimeBeforeStartTime
                };
            }
        }
        setFormErrors(errors);
        setEndTime(timeInput);
    };
    const handleCreateButton = ()=>{
        const errors = {
            calendarTitle: null,
            calendarLocation: null,
            calendarCompany: null,
            calendarCreator: null,
            calendarStartDate: null,
            calendarEndDate: null,
            calendarType: null,
            startDate: null,
            startTime: null,
            endDate: null,
            endTime: null
        };
        let hasErrors = false;
        if (!title || title.length < 2) {
            hasErrors = true;
            errors.calendarTitle = "Title is too short!";
        }
        if (!selectedCompany) {
            hasErrors = true;
            errors.calendarCompany = "Company field is required!";
        }
        if (!selectedCreator) {
            hasErrors = true;
            errors.calendarCreator = "Creator field is required!";
        }
        if (!selectedType) {
            hasErrors = true;
            errors.calendarType = "Type field is required!";
        }
        if (!startDate) {
            hasErrors = true;
            errors.startDate = "Start Date field is required!";
        }
        if (!endDate) {
            hasErrors = true;
            errors.endDate = "End Date field is required!";
        }
        if (startDate && endDate) {
            if (startDate?.getTime() > endDate?.getTime()) {
                hasErrors = true;
                errors.startDate = "Start Date should be before End Date";
                errors.endDate = "Start Date should be before End Date";
            }
            if (startTime && endTime) {
                const start = getCurrentDateTime(startDate, startTime).getTime();
                const end = getCurrentDateTime(endDate, endTime).getTime();
                if (start > end) {
                    hasErrors = true;
                    errors.endDate = "End Date should be after Start Date";
                    errors.endTime = "End Date should be after Start Date";
                } else {
                    errors.endDate = null;
                    errors.endTime = null;
                }
            }
        }
        if (hasErrors) setFormErrors({
            ...errors
        });
        else handleAddNewEvent();
    };
    const handleAddNewEvent = ()=>{
        if (isEditMode) updateEvent({
            variables: {
                id: parseInt(calendarEvent?.id),
                input: getCalendarDto()
            },
            update () {
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Successfully updated ${title}`,
                        severity: "success"
                    }
                });
                handleClose();
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: e.message,
                    severity: "error",
                    autoHide: 6000
                }
            });
        });
        else addEvent({
            variables: {
                input: getCalendarDto()
            },
            update (_, { data: data }) {
                if (data?.result) (0, $gFVvY.addEventToCache)(data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Event ${data?.result.title} created`,
                        severity: "success"
                    }
                });
                handleClose();
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: e.message,
                    severity: "error",
                    autoHide: 6000
                }
            });
        });
    };
    const getCalendarDto = ()=>{
        return {
            title: title,
            location: location,
            company_id: parseInt(selectedCompany?.id),
            creator_id: parseInt(selectedCreator?.id),
            type_id: parseInt(selectedType?.id),
            description: description,
            start_date: getUTCDateAndTime(startDate, startTime).toString(),
            end_date: getUTCDateAndTime(endDate, endTime).toString()
        };
    };
    const getUTCDateAndTime = (date, time)=>{
        const res = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), time ? time.getHours() : 0, time ? time.getMinutes() : 0, 0, 0));
        return res;
    };
    const getCurrentDateTime = (date, time)=>{
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), time ? time.getHours() : 0, time ? time.getMinutes() : 0, 0, 0);
    };
    const handleCancel = ()=>{
        if (editEnabled && isEditMode && calendarEvent) {
            setTitle(calendarEvent.title);
            setLocation(calendarEvent.location ?? "");
            setSelectedCompany(calendarEvent.company);
            setSelectedCreator(calendarEvent.creator);
            setSelectedType(calendarEvent.type);
            setDescription(calendarEvent.description ?? "");
            setStartDate((0, $gFVvY.parseDate)(calendarEvent.start_date));
            setEditEnabled(false);
            setFormErrors($b088c9ac60ed2dc4$var$defaultErrorsObj);
        } else handleClose();
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5PJ2i.default), {
        id: "new-calendar-meeting-dialog",
        width: 689,
        height: 860,
        title: isEditMode ? "Event Details" : "Create Event",
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                padding: "80px",
                position: "relative"
            },
            children: [
                isEditMode && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        position: "absolute",
                        top: "24px",
                        right: "24px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                        id: "create-event-edit-button",
                        onClick: ()=>setEditEnabled(true),
                        disabled: !canEdit || editEnabled || !calendarEvent,
                        editButtonColor: !canEdit || editEnabled || !calendarEvent ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    sx: {
                        display: "flex",
                        flexFlow: "column",
                        rowGap: "35px",
                        mt: "27px",
                        mX: "37px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "title-name",
                            label: "Title",
                            value: title,
                            onChange: handleTitleChange,
                            errorMsg: formErrors.calendarTitle,
                            disabled: isEditMode && !editEnabled
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "calendar-location",
                            label: "Location",
                            value: location,
                            onChange: handleLocationChange,
                            disabled: isEditMode && !editEnabled
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                            id: "calendar-creator-autocomplete",
                            options: allCompanies.data?.result || [],
                            getOptionLabel: (option)=>option.name,
                            values: selectedCompany,
                            onChange: handleCalendarCompanyChange,
                            errorMsg: formErrors.calendarCompany,
                            label: "Company",
                            disabled: isEditMode && !editEnabled
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                            id: "calendar-company-autocomplete",
                            options: allCreators.data?.result || [],
                            getOptionLabel: (option)=>option.fullName,
                            values: selectedCreator,
                            onChange: handleCalendarCreatorChange,
                            errorMsg: formErrors.calendarCreator,
                            label: "Creator",
                            disabled: isEditMode && !editEnabled
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                            id: "calendar-type-autocomplete",
                            options: allTypes.data?.result || [],
                            getOptionLabel: (option)=>option.type,
                            values: selectedType,
                            onChange: handleCalendarTypeChange,
                            label: "Type",
                            errorMsg: formErrors.calendarType,
                            disabled: isEditMode && !editEnabled
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "calendar-description",
                            label: "Description",
                            value: description,
                            onChange: handleDescriptionChange,
                            disabled: isEditMode && !editEnabled,
                            multiline: true,
                            rows: 3
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                            sx: {
                                display: "flex",
                                columnGap: "20px"
                            },
                            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $e4eIN.LocalizationProvider), {
                                dateAdapter: (0, $1Dn8S.AdapterDateFns),
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                        id: "create-event-time-picker",
                                        label: "Start Date",
                                        minDate: new Date(),
                                        value: startDate,
                                        disabled: isEditMode && !editEnabled,
                                        errorMsg: formErrors.startDate,
                                        onChange: (t)=>handleStartDateChange(t),
                                        sx: {
                                            flexBasis: "58%"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gF9d2.default), {
                                        id: "create-event-time-picker",
                                        label: "Start Time",
                                        value: startTime,
                                        onChange: (t)=>handleStartTimeChanged(t),
                                        disabled: isEditMode && !editEnabled,
                                        errorMsg: formErrors.startTime,
                                        sx: {
                                            flexBasis: "42%"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                        id: "calendar-end-date-picker",
                                        label: "End Date",
                                        minDate: startDate ? startDate : new Date(),
                                        value: endDate,
                                        onChange: (d)=>handleEndDateChange(d),
                                        disabled: isEditMode && !editEnabled,
                                        errorMsg: formErrors.endDate,
                                        sx: {
                                            flexBasis: "58%"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $gF9d2.default), {
                                        id: "create-event-end-time-picker",
                                        label: "End Time",
                                        value: endTime,
                                        onChange: (t)=>handleEndTimeChange(t),
                                        disabled: isEditMode && !editEnabled,
                                        errorMsg: formErrors.endTime,
                                        sx: {
                                            flexBasis: "42%"
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                }),
                editEnabled && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize",
                    sx: {
                        marginTop: "70px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                            id: "cancel-button",
                            onClick: handleCancel,
                            text: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                            id: "save-button",
                            onClick: handleCreateButton,
                            disabled: isEditMode && !editEnabled,
                            text: isEditMode ? "Save" : "Create"
                        })
                    ]
                })
            ]
        })
    });
};
var $b088c9ac60ed2dc4$export$2e2bcd8739ae039 = $b088c9ac60ed2dc4$var$CalendarForm;

});
parcelRegister("gFVvY", function(module, exports) {

$parcel$export(module.exports, "similarCompanyNameExists", function () { return $320420f2b3c24003$export$acbe4bb306871dbb; });
$parcel$export(module.exports, "sameCompanyNameExists", function () { return $320420f2b3c24003$export$ffbedb023e827218; });
$parcel$export(module.exports, "sameRecipientListExists", function () { return $320420f2b3c24003$export$112563d8281acff1; });
$parcel$export(module.exports, "fullNameExists", function () { return $320420f2b3c24003$export$ef9623ec14fcf71; });
$parcel$export(module.exports, "sameUsernameExists", function () { return $320420f2b3c24003$export$33d93d42f1d4ce5e; });
$parcel$export(module.exports, "sameTemplateTitleExists", function () { return $320420f2b3c24003$export$9d82bd81427817fa; });
$parcel$export(module.exports, "sameProductNameExists", function () { return $320420f2b3c24003$export$e0dc05f7009da1b9; });
$parcel$export(module.exports, "sameIndexCodeExists", function () { return $320420f2b3c24003$export$760fe525abab56e1; });
$parcel$export(module.exports, "sameFtseFileNameExists", function () { return $320420f2b3c24003$export$e6b3184dc78aee4a; });
$parcel$export(module.exports, "indexSerieWithThatNameExists", function () { return $320420f2b3c24003$export$5baebb76d36ed107; });
$parcel$export(module.exports, "addCompanyToCache", function () { return $320420f2b3c24003$export$464829923432ad29; });
$parcel$export(module.exports, "updateCompanyInCache", function () { return $320420f2b3c24003$export$125db73dbec469eb; });
$parcel$export(module.exports, "removeCompanyFromCache", function () { return $320420f2b3c24003$export$c7f45efc55334dcb; });
$parcel$export(module.exports, "createUserToCache", function () { return $320420f2b3c24003$export$877aa318b01369b5; });
$parcel$export(module.exports, "updateUserGroupsInCache", function () { return $320420f2b3c24003$export$a70878da5a670f9d; });
$parcel$export(module.exports, "removeUserFromCache", function () { return $320420f2b3c24003$export$394462c21cfd9d79; });
$parcel$export(module.exports, "removeContactFromCache", function () { return $320420f2b3c24003$export$6550902528c0a209; });
$parcel$export(module.exports, "removeProductFromCache", function () { return $320420f2b3c24003$export$e80f89d399469b8c; });
$parcel$export(module.exports, "removeTemplateFromCache", function () { return $320420f2b3c24003$export$b182bf333117fabf; });
$parcel$export(module.exports, "addTemplateInCache", function () { return $320420f2b3c24003$export$e521f8a9465ef9dd; });
$parcel$export(module.exports, "updateTemplateInCache", function () { return $320420f2b3c24003$export$448000d512a325c8; });
$parcel$export(module.exports, "removeMembershipFromCache", function () { return $320420f2b3c24003$export$38f553e3bef65188; });
$parcel$export(module.exports, "addContactToCache", function () { return $320420f2b3c24003$export$a50cf41dbad25096; });
$parcel$export(module.exports, "updateContactInCache", function () { return $320420f2b3c24003$export$aaa7568408cb306; });
$parcel$export(module.exports, "addProductToCache", function () { return $320420f2b3c24003$export$4de807863634a27f; });
$parcel$export(module.exports, "updateProductInCache", function () { return $320420f2b3c24003$export$4d812a765f927d18; });
$parcel$export(module.exports, "sameMembershipNameExist", function () { return $320420f2b3c24003$export$6ece2514ace2d184; });
$parcel$export(module.exports, "sameSchedulerNameExist", function () { return $320420f2b3c24003$export$98dc730e95852410; });
$parcel$export(module.exports, "addMembershipToCache", function () { return $320420f2b3c24003$export$5b5dd58d6f3a5ab0; });
$parcel$export(module.exports, "updateMembershipInCache", function () { return $320420f2b3c24003$export$c543199c5225d874; });
$parcel$export(module.exports, "addInvoiceInCache", function () { return $320420f2b3c24003$export$76e4bed642dd1010; });
$parcel$export(module.exports, "updateInvoiceInCache", function () { return $320420f2b3c24003$export$b439ad625c8499f8; });
$parcel$export(module.exports, "removeInvoiceFromCache", function () { return $320420f2b3c24003$export$4dda5be5de985ae2; });
$parcel$export(module.exports, "parseDate", function () { return $320420f2b3c24003$export$6b862160d295c8e; });
$parcel$export(module.exports, "updateUserInCache", function () { return $320420f2b3c24003$export$30382e5d4cb3d226; });
$parcel$export(module.exports, "addUsersToGroupInCache", function () { return $320420f2b3c24003$export$ff6b4c55a1b1c84b; });
$parcel$export(module.exports, "addValuesToCache", function () { return $320420f2b3c24003$export$8b39b860888e2ebd; });
$parcel$export(module.exports, "addInterestsToCache", function () { return $320420f2b3c24003$export$d3b26404e0a37c98; });
$parcel$export(module.exports, "remoteInterestInCache", function () { return $320420f2b3c24003$export$85334f222fc6bea2; });
$parcel$export(module.exports, "removeRecipientListFromCache", function () { return $320420f2b3c24003$export$bd3a917648d3adfc; });
$parcel$export(module.exports, "addSchedulerToCache", function () { return $320420f2b3c24003$export$5c1e23da1d3f4d9; });
$parcel$export(module.exports, "addEventToCache", function () { return $320420f2b3c24003$export$cf3d6a43a8af801a; });
$parcel$export(module.exports, "updateEventInCache", function () { return $320420f2b3c24003$export$2305f680fc135b5d; });
$parcel$export(module.exports, "removeEventFromCache", function () { return $320420f2b3c24003$export$592bbab78c614c02; });
$parcel$export(module.exports, "updateSchedulerInCache", function () { return $320420f2b3c24003$export$31007f8511d95633; });
$parcel$export(module.exports, "removeSchedulerFromCache", function () { return $320420f2b3c24003$export$48633f11e5a03ee6; });
$parcel$export(module.exports, "addRecipientListInCache", function () { return $320420f2b3c24003$export$19e641f4e2da264b; });
$parcel$export(module.exports, "updateRecipientListInCache", function () { return $320420f2b3c24003$export$f797a84e4a3422c2; });
$parcel$export(module.exports, "removeValueFromCache", function () { return $320420f2b3c24003$export$9238043f26dda290; });
$parcel$export(module.exports, "addStockInCache", function () { return $320420f2b3c24003$export$56a1d22221682876; });
$parcel$export(module.exports, "addFtseFileInCache", function () { return $320420f2b3c24003$export$1df9c29a565d76f0; });
$parcel$export(module.exports, "updateFtseFileInCache", function () { return $320420f2b3c24003$export$5e281deef44951b9; });
$parcel$export(module.exports, "removeFtseFileFromCache", function () { return $320420f2b3c24003$export$97c337aee0c81ebb; });
$parcel$export(module.exports, "addIndexInCache", function () { return $320420f2b3c24003$export$43fc271e28fc8c92; });
$parcel$export(module.exports, "removeIndexFromCache", function () { return $320420f2b3c24003$export$28548e847c66da9a; });
$parcel$export(module.exports, "updateIndexInCache", function () { return $320420f2b3c24003$export$866414977599f44b; });
$parcel$export(module.exports, "stockCodeExists", function () { return $320420f2b3c24003$export$49f67e06db3f0295; });
$parcel$export(module.exports, "removeIndexSerieFromCache", function () { return $320420f2b3c24003$export$4712913e6750cf87; });
$parcel$export(module.exports, "addIndexSerieInCache", function () { return $320420f2b3c24003$export$97a7abb2d881979c; });
$parcel$export(module.exports, "updateIndexSerieInCache", function () { return $320420f2b3c24003$export$a5dc09d3a65cd208; });
$parcel$export(module.exports, "addEtfInCache", function () { return $320420f2b3c24003$export$2bf3d08ca0abbe55; });
$parcel$export(module.exports, "updateEtfInCache", function () { return $320420f2b3c24003$export$4c3f269346b8bed4; });
$parcel$export(module.exports, "removeEtfFromChache", function () { return $320420f2b3c24003$export$6d23740d93ac2af4; });
$parcel$export(module.exports, "updateFtseConfigurationInCache", function () { return $320420f2b3c24003$export$e2aa083c3d30daec; });
$parcel$export(module.exports, "sameSiteSectionNameExists", function () { return $320420f2b3c24003$export$4786dca3e23a3e07; });
$parcel$export(module.exports, "removeDocumentFromCache", function () { return $320420f2b3c24003$export$6e8359a385993595; });
$parcel$export(module.exports, "updateDocumentInCache", function () { return $320420f2b3c24003$export$2fc4a5b081a4d8a9; });
$parcel$export(module.exports, "addDocumentInCache", function () { return $320420f2b3c24003$export$737ae00f20d3bc88; });
$parcel$export(module.exports, "addSiteSectionInCache", function () { return $320420f2b3c24003$export$93f2e7709d24ce; });
$parcel$export(module.exports, "removeSiteSectionFromCache", function () { return $320420f2b3c24003$export$eff3dd410867f1b6; });
$parcel$export(module.exports, "updateSiteSectionInCache", function () { return $320420f2b3c24003$export$80813710cd512a37; });
$parcel$export(module.exports, "getStringInput", function () { return $320420f2b3c24003$export$59ba0bb3b4e5def2; });
$parcel$export(module.exports, "getNumberInput", function () { return $320420f2b3c24003$export$e2396ddab11279c4; });
$parcel$export(module.exports, "getNullableNumberInput", function () { return $320420f2b3c24003$export$2a54aca3dae44f69; });
$parcel$export(module.exports, "getNullableDateString", function () { return $320420f2b3c24003$export$c4bc403ac436aaee; });
$parcel$export(module.exports, "getObjectInputId", function () { return $320420f2b3c24003$export$ffe11b6ddea720db; });

var $dHPFu = parcelRequire("dHPFu");

var $fmUFE = parcelRequire("fmUFE");

var $hjfla = parcelRequire("hjfla");
const $320420f2b3c24003$export$acbe4bb306871dbb = (name, id)=>{
    try {
        const companiesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.CompaniesDocument)
        });
        if (companiesQuery.result) {
            const companies = companiesQuery.result.filter((c)=>c?.name.toLowerCase().includes(name.toLowerCase()));
            if (companies.length === 0) return false;
            else {
                if (id) {
                    const refinedComapnies = companies.filter((c)=>parseInt(c?.id) !== id);
                    return refinedComapnies.length > 0;
                }
                return true;
            }
        }
    } catch (e) {
        return false;
    }
    return false;
};
const $320420f2b3c24003$export$ffbedb023e827218 = (name, id)=>{
    try {
        const companiesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.CompaniesDocument)
        });
        if (companiesQuery.result) {
            const companies = companiesQuery.result.filter((c)=>c?.name.toLowerCase() === name.toLowerCase());
            if (companies.length === 0) return false;
            else {
                if (id) {
                    const refinedComapnies = companies.filter((c)=>parseInt(c?.id) !== id);
                    return refinedComapnies.length > 0;
                }
                return true;
            }
        }
    } catch (e) {
        return false;
    }
    return false;
};
const $320420f2b3c24003$export$112563d8281acff1 = (name, id)=>{
    try {
        const recipientListQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.RecipientListsDocument)
        });
        if (recipientListQuery.result) {
            const listName = recipientListQuery.result.filter((rl)=>rl?.name?.toLocaleLowerCase() === name.toLowerCase());
            if (listName.length === 0) return false;
            else {
                if (id) {
                    const refinedList = listName.filter((rl)=>parseInt(rl?.id) !== id);
                    return refinedList.length > 0;
                }
                return true;
            }
        }
    } catch (e) {
        return false;
    }
    return false;
};
const $320420f2b3c24003$export$56ba7de411f0ff4b = (email)=>{
    let result = false;
    try {
        const contactsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.ContactsDocument)
        });
        // Check if contactsQuery and contactsQuery.result exist before proceeding
        if (contactsQuery && contactsQuery.result) {
            const contact = contactsQuery.result.find((c)=>c?.email?.toLowerCase() === email.toLowerCase());
            result = contact ? true : false;
            return result;
        }
    } catch (e) {
        return result;
    }
    return result;
};
const $320420f2b3c24003$export$ef9623ec14fcf71 = (firstName, lastName, companyName)=>{
    let result = false;
    if (!firstName || !lastName || !companyName) return result;
    try {
        const contactsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.ContactsDocument)
        });
        // Check if contactsQuery and contactsQuery.result exist before proceeding
        if (contactsQuery && contactsQuery.result) {
            const contact = contactsQuery.result.find((c)=>c?.company.name === companyName && c.fullName.toLowerCase() === `${firstName.toLowerCase()} ${lastName.toLowerCase()}`);
            result = contact ? true : false;
            return result;
        }
    } catch (e) {
        return result;
    }
    return result;
};
const $320420f2b3c24003$export$33d93d42f1d4ce5e = (name, id)=>{
    try {
        const usersQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetUsersDocument)
        });
        if (usersQuery.result) {
            const users = usersQuery.result.filter((u)=>u?.username.toLowerCase() === name.toLowerCase());
            if (users.length === 0) return false;
            else {
                if (id) {
                    const refinedUsers = users.filter((u)=>parseInt(u?.id) !== parseInt(id));
                    return refinedUsers.length > 0;
                }
                return true;
            }
        }
    } catch (e) {
        return false;
    }
    return false;
};
const $320420f2b3c24003$export$9d82bd81427817fa = (title, id)=>{
    try {
        const templatesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.TemplatesDocument)
        });
        if (templatesQuery.result) {
            const templates = templatesQuery.result.filter((t)=>t?.title.toLowerCase() === title.trim().toLowerCase());
            if (templates.length === 0) return false;
            else {
                if (id) {
                    const refinedTempaltes = templates.filter((t)=>parseInt(t?.id) !== parseInt(id));
                    return refinedTempaltes.length > 0;
                }
                return true;
            }
        }
    } catch (e) {
        return false;
    }
    return false;
};
const $320420f2b3c24003$export$e0dc05f7009da1b9 = (name, id)=>{
    try {
        const productsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.ProductsDocument)
        });
        if (productsQuery.result) {
            const products = productsQuery.result.filter((p)=>p?.name.toLowerCase() === name.toLowerCase());
            if (products.length === 0) return false;
            else if (id) {
                const refinedProducts = products.filter((p)=>p?.id === id);
                return refinedProducts.length > 0;
            }
            return true;
        }
        return false;
    } catch (e) {
        return false;
    }
};
const $320420f2b3c24003$export$760fe525abab56e1 = (code, id)=>{
    try {
        const indicesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.IndicesDocument)
        });
        if (indicesQuery.result) {
            const indices = indicesQuery.result.filter((i)=>i?.code.toUpperCase() === code.toUpperCase().trim());
            if (indices.length === 0) return false;
            else if (id) {
                const refinedIndex = indices.filter((i)=>i?.id !== id);
                return refinedIndex.length > 0;
            }
            return true;
        }
        return false;
    } catch (e) {
        return false;
    }
};
const $320420f2b3c24003$export$e6b3184dc78aee4a = (name, id)=>{
    try {
        const ftseFilesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetFtseFilesDocument)
        });
        if (ftseFilesQuery.result) {
            const ftseFiles = ftseFilesQuery.result.filter((ftse)=>ftse?.name.toUpperCase() === name.toUpperCase().trim());
            if (ftseFiles.length === 0) return false;
            else if (id) {
                const refinedFtseFile = ftseFiles.filter((ftse)=>ftse?.id !== id);
                return refinedFtseFile.length > 0;
            }
            return true;
        }
        return false;
    } catch (e) {
        return false;
    }
};
const $320420f2b3c24003$export$5baebb76d36ed107 = (indexSerie, id)=>{
    try {
        const indexSerieQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.IndexSeriesDocument)
        });
        if (indexSerieQuery.result) {
            const indexSeries = indexSerieQuery.result.filter((is)=>is?.name.toUpperCase() === indexSerie.toUpperCase().trim());
            if (indexSeries.length === 0) return false;
            else if (id) {
                const refinedIndexSerie = indexSeries.filter((is)=>is?.id !== id);
                return refinedIndexSerie.length > 0;
            }
            return true;
        }
        return false;
    } catch (e) {
        return false;
    }
};
const $320420f2b3c24003$export$464829923432ad29 = (company)=>{
    try {
        const companiesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.CompaniesDocument)
        });
        if (companiesQuery.result) {
            const cacheCompany = companiesQuery.result.find((c)=>c?.id === company.id);
            if (!cacheCompany) {
                const data = [
                    company,
                    ...companiesQuery.result
                ];
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.CompaniesDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$125db73dbec469eb = (company)=>{
    try {
        const companiesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.CompaniesDocument)
        });
        if (companiesQuery?.result) {
            const data = companiesQuery.result.map((c)=>c?.id === company.id ? company : c);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.CompaniesDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$c7f45efc55334dcb = (company)=>{
    try {
        // Remove from CompaniesDocument cache
        const companiesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.CompaniesDocument)
        });
        if (companiesQuery.result) {
            const cacheCompany = companiesQuery.result.find((c)=>c?.id === company.id);
            if (cacheCompany) {
                const data = companiesQuery.result.filter(function(el) {
                    return el?.id !== company.id;
                });
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.CompaniesDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
        // Also remove from CompaniesNamesDocument cache (used for name filter)
        try {
            const companiesNamesQuery = (0, $dHPFu.default).cache.readQuery({
                query: (0, $hjfla.CompaniesNamesDocument)
            });
            if (companiesNamesQuery.result) {
                const cacheCompany = companiesNamesQuery.result.find((c)=>c?.id === company.id);
                if (cacheCompany) {
                    const data = companiesNamesQuery.result.filter(function(el) {
                        return el?.id !== company.id;
                    });
                    (0, $dHPFu.default).writeQuery({
                        query: (0, $hjfla.CompaniesNamesDocument),
                        data: {
                            result: data
                        }
                    });
                }
            }
        } catch (namesError) {
        // If CompaniesNamesDocument doesn't exist or query fails, ignore
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$877aa318b01369b5 = (user)=>{
    try {
        const usersQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetUsersDocument)
        });
        if (usersQuery.result) {
            const cacheUser = usersQuery.result.find((u)=>u?.id === user.id);
            if (!cacheUser) {
                const data = [
                    user,
                    ...usersQuery.result
                ];
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.GetUsersDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {} finally{
        $320420f2b3c24003$export$a70878da5a670f9d(user);
    }
};
const $320420f2b3c24003$export$394462c21cfd9d79 = (user)=>{
    try {
        const usersQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetUsersDocument)
        });
        if (usersQuery.result) {
            const cacheUser = usersQuery.result.find((u)=>u?.id === user.id);
            if (cacheUser) {
                const data = usersQuery.result.filter(function(el) {
                    return el?.id !== user.id;
                });
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.GetUsersDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {} finally{
        $320420f2b3c24003$export$b0b0f88c58c53fdc(user.id);
    }
};
const $320420f2b3c24003$export$6550902528c0a209 = (contact)=>{
    try {
        const contactsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.ContactsDocument)
        });
        // Check if contactsQuery and contactsQuery.result exist before proceeding
        if (contactsQuery && contactsQuery.result) {
            const cacheContact = contactsQuery.result.find((c)=>c?.id === contact.id);
            if (cacheContact) {
                const data = contactsQuery.result.filter(function(el) {
                    return el?.id !== contact.id;
                });
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.ContactsDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$e80f89d399469b8c = (product)=>{
    try {
        const productsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.ProductsDocument)
        });
        if (productsQuery.result) {
            const cacheProduct = productsQuery.result.find((p)=>p?.id === product.id);
            if (cacheProduct) {
                const data = productsQuery.result.filter(function(el) {
                    return el?.id !== product.id;
                });
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.ProductsDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$b182bf333117fabf = (template)=>{
    try {
        const templatesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.TemplatesDocument)
        });
        if (templatesQuery.result) {
            const cacheTemplate = templatesQuery.result.find((t)=>t?.id === template.id);
            if (cacheTemplate) {
                const data = templatesQuery.result.filter(function(el) {
                    return el?.id !== template.id;
                });
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.TemplatesDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$e521f8a9465ef9dd = (template)=>{
    try {
        const templatesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.TemplatesDocument)
        });
        if (templatesQuery.result) {
            const cacheTemplate = templatesQuery.result.find((t)=>t?.id === template.id);
            if (!cacheTemplate) {
                const newData = [
                    template,
                    ...templatesQuery.result
                ];
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.TemplatesDocument),
                    data: {
                        result: newData
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$448000d512a325c8 = (template)=>{
    try {
        const templatesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.TemplatesDocument)
        });
        if (templatesQuery.result) {
            const data = templatesQuery.result.map((t)=>t?.id === template.id ? template : t);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.TemplatesDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$38f553e3bef65188 = (membership)=>{
    try {
        const membershipsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.MembershipsDocument)
        });
        if (membershipsQuery.result) {
            const cacheMembership = membershipsQuery.result.find((m)=>m?.id === membership.id);
            if (cacheMembership) {
                const data = membershipsQuery.result.filter(function(el) {
                    return el?.id !== membership.id;
                });
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.MembershipsDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$a50cf41dbad25096 = (contact)=>{
    try {
        const contactsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.ContactsDocument)
        });
        // Check if contactsQuery and contactsQuery.result exist before proceeding
        if (contactsQuery && contactsQuery.result) {
            const cacheContact = contactsQuery.result.find((c)=>c?.id === contact.id);
            if (!cacheContact) {
                const data = [
                    contact,
                    ...contactsQuery.result
                ];
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.ContactsDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$aaa7568408cb306 = (contact)=>{
    try {
        const contactsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.ContactsDocument)
        });
        // Check if contactsQuery and contactsQuery.result exist before proceeding
        if (contactsQuery && contactsQuery.result) {
            const data = contactsQuery.result.map((c)=>c?.id === contact.id ? contact : c);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.ContactsDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$4de807863634a27f = (product)=>{
    try {
        const productQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.ProductsDocument)
        });
        if (productQuery.result) {
            const cacheProduct = productQuery.result.find((p)=>p?.id === product.id);
            if (!cacheProduct) {
                const data = [
                    product,
                    ...productQuery.result
                ];
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.ProductsDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$4d812a765f927d18 = (product)=>{
    try {
        const productQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.ProductsDocument)
        });
        if (productQuery.result) {
            const data = productQuery.result.map((p)=>p?.id === product.id ? product : p);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.ProductsDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$6ece2514ace2d184 = (name, id)=>{
    let result = false;
    try {
        const membershipsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.MembershipsDocument)
        });
        if (membershipsQuery.result) {
            if (id) {
                const memberships = membershipsQuery.result.filter((m)=>m?.name.trim().toLocaleLowerCase() === name.trim().toLocaleLowerCase());
                const sameMembershipNames = memberships.filter((m)=>m?.id !== id);
                return sameMembershipNames.length > 0;
            } else {
                const membership = membershipsQuery.result.find((m)=>m?.name.trim().toLocaleLowerCase() === name.trim().toLocaleLowerCase());
                result = membership ? true : false;
                return result;
            }
        }
    } catch (e) {
        return result;
    }
    return result;
};
const $320420f2b3c24003$export$98dc730e95852410 = (name, id)=>{
    let result = false;
    try {
        const schedulersQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetAllScheduledDocument)
        });
        if (schedulersQuery.result) {
            if (id) {
                const schedulers = schedulersQuery.result.filter((s)=>s?.name.trim().toLowerCase() === name.trim().toLowerCase());
                const sameSchedulersNames = schedulers.filter((s)=>s?.id !== id);
                return sameSchedulersNames.length > 0;
            } else {
                const scheduler = schedulersQuery.result.find((s)=>s?.name.trim().toLowerCase() === name.trim().toLowerCase());
                result = scheduler ? true : false;
                return result;
            }
        }
    } catch (e) {
        return result;
    }
    return result;
};
const $320420f2b3c24003$export$5b5dd58d6f3a5ab0 = (membership)=>{
    try {
        const membershipQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.MembershipsDocument)
        });
        if (membershipQuery.result) {
            const cacheMembership = membershipQuery.result.find((m)=>m?.id === membership.id);
            if (!cacheMembership) {
                const data = [
                    membership,
                    ...membershipQuery.result
                ];
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.MembershipsDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$c543199c5225d874 = (membership)=>{
    try {
        const membershipQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.MembershipsDocument)
        });
        if (membershipQuery.result) {
            const data = membershipQuery.result.map((m)=>m?.id === membership.id ? membership : m);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.MembershipsDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$76e4bed642dd1010 = (invoice)=>{
    try {
        const invoiceQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.InvoicesDocument)
        });
        if (invoiceQuery.result) {
            const cacheInvoice = invoiceQuery.result.find((i)=>i?.id === invoice.id);
            if (!cacheInvoice) {
                const data = [
                    invoice,
                    ...invoiceQuery.result
                ];
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.InvoicesDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$b439ad625c8499f8 = (invoice)=>{
    try {
        const invoiceQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.InvoicesDocument)
        });
        if (invoiceQuery.result) {
            const data = invoiceQuery.result.map((i)=>i?.id === invoice.id ? invoice : i);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.InvoicesDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$4dda5be5de985ae2 = (invoice)=>{
    try {
        const invoiceQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.InvoicesDocument)
        });
        if (invoiceQuery.result) {
            const cacheInvoice = invoiceQuery.result.find((i)=>i?.id === invoice.id);
            if (cacheInvoice) {
                const data = invoiceQuery.result.filter((el)=>{
                    return el?.id !== invoice.id;
                });
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.InvoicesDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$6b862160d295c8e = (input)=>{
    if (input !== null && input !== undefined) return new Date(Number(input));
    return null;
};
const $320420f2b3c24003$export$30382e5d4cb3d226 = (user)=>{
    try {
        const usersQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetUsersDocument)
        });
        if (usersQuery.result) {
            const data = usersQuery.result.map((u)=>u?.id === user.id ? user : u);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.GetUsersDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (e) {} finally{
        $320420f2b3c24003$export$a70878da5a670f9d(user);
    }
};
const $320420f2b3c24003$export$a70878da5a670f9d = (user)=>{
    try {
        const groupsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetRolesDocument)
        });
        if (groupsQuery.result) {
            const data = groupsQuery.result.map((gr)=>{
                if (user.roles.includes(gr?.name)) {
                    if (gr.users.filter((u)=>u?.id === user.id).length > 0) return gr;
                    else return {
                        ...gr,
                        users: [
                            user,
                            ...gr.users
                        ]
                    };
                } else {
                    if (gr.users.filter((u)=>u?.id === user.id).length > 0) return {
                        ...gr,
                        users: gr.users.filter((us)=>us?.id !== user.id)
                    };
                    else return gr;
                }
            });
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.GetRolesDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (error) {}
};
const $320420f2b3c24003$export$b0b0f88c58c53fdc = (userId)=>{
    try {
        const groupsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetRolesDocument)
        });
        if (groupsQuery.result) {
            const data = groupsQuery.result.map((gr)=>{
                return {
                    ...gr,
                    users: gr.users.filter((us)=>us?.id !== userId)
                };
            });
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.GetRolesDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (error) {}
};
const $320420f2b3c24003$export$ff6b4c55a1b1c84b = (roleId, users)=>{
    try {
        const groupsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetRolesDocument)
        });
        if (groupsQuery.result) {
            const data = groupsQuery.result.map((gr)=>gr?.id === roleId ? {
                    ...gr,
                    users: [
                        ...users,
                        ...gr.users
                    ]
                } : gr);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.GetRolesDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (error) {}
};
const $320420f2b3c24003$export$8b39b860888e2ebd = (valueListName, newValues)=>{
    switch(valueListName){
        case (0, $fmUFE.ValueLists).CompanyType:
            $320420f2b3c24003$var$addCompanyTypesToCache(newValues);
            break;
        case (0, $fmUFE.ValueLists).MarketActivity:
            $320420f2b3c24003$var$addMarketActivitiesToCache(newValues);
            break;
        case (0, $fmUFE.ValueLists).MembershipType:
            $320420f2b3c24003$var$addMembershipTypesToCache(newValues);
            break;
        case (0, $fmUFE.ValueLists).ProductCode:
            $320420f2b3c24003$var$addProductCodesToCache(newValues);
            break;
        case (0, $fmUFE.ValueLists).TitleInternal:
            $320420f2b3c24003$var$addTitlesInternalToCache(newValues);
            break;
        default:
            break;
    }
};
const $320420f2b3c24003$export$d3b26404e0a37c98 = (id, newInterests)=>{
    if (newInterests.length > 0) try {
        const interestsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetInterestGroupsDocument)
        });
        if (interestsQuery.result) {
            const interestsToAdd = newInterests;
            const result = interestsQuery.result.map((ig)=>ig?.id === id ? {
                    ...ig,
                    interests: [
                        ...interestsToAdd,
                        ...ig.interests
                    ]
                } : ig);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.GetInterestGroupsDocument),
                data: {
                    result: result
                }
            });
        }
    } catch  {}
};
const $320420f2b3c24003$export$85334f222fc6bea2 = (interest)=>{
    try {
        const interestGroups = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetInterestGroupsDocument)
        });
        if (interestGroups.result) {
            const data = interestGroups.result.map((gr)=>{
                if (gr?.id === interest.interest_group.id) return {
                    ...gr,
                    interests: gr.interests.filter((i)=>i?.id !== interest.id)
                };
                else return gr;
            });
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.GetInterestGroupsDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (error) {}
};
const $320420f2b3c24003$export$bd3a917648d3adfc = (recipientListId)=>{
    try {
        const recipientListsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.RecipientListsDocument)
        });
        if (recipientListsQuery.result) {
            const cacheRecipientList = recipientListsQuery.result.find((r)=>r?.id === recipientListId);
            if (cacheRecipientList) {
                const data = recipientListsQuery.result.filter((r)=>r?.id !== recipientListId);
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.RecipientListsDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$5c1e23da1d3f4d9 = (scheduler)=>{
    try {
        const schedulerQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetAllScheduledDocument)
        });
        if (schedulerQuery.result) {
            const cacheScheduler = schedulerQuery.result.find((s)=>s?.id === scheduler.id);
            if (!cacheScheduler) {
                const data = [
                    scheduler,
                    ...schedulerQuery.result
                ];
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.GetAllScheduledDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$cf3d6a43a8af801a = (event)=>{
    try {
        const eventQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.EventsDocument)
        });
        if (eventQuery.result) {
            const cacheEvent = eventQuery.result.find((s)=>s?.id === event.id);
            if (!cacheEvent) {
                const data = [
                    event,
                    ...eventQuery.result
                ];
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.EventsDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$2305f680fc135b5d = (event)=>{
    try {
        const eventquery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.EventsDocument)
        });
        if (eventquery.result) {
            const data = eventquery.result.map((e)=>e?.id === event.id ? event : e);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.EventsDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$592bbab78c614c02 = (eventId)=>{
    try {
        const eventQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.EventsDocument)
        });
        if (eventQuery.result) {
            const cacheEvent = eventQuery.result.find((e)=>e?.id === eventId);
            if (cacheEvent) {
                const data = eventQuery.result.filter((e)=>e?.id !== eventId);
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.EventsDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$31007f8511d95633 = (scheduler)=>{
    try {
        const schedulerQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetAllScheduledDocument)
        });
        if (schedulerQuery.result) {
            const data = schedulerQuery.result.map((s)=>s?.id === scheduler.id ? scheduler : s);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.GetAllScheduledDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$48633f11e5a03ee6 = (schedulerId)=>{
    try {
        const schedulerQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetAllScheduledDocument)
        });
        if (schedulerQuery.result) {
            const cacheScheduler = schedulerQuery.result.find((s)=>s?.id === schedulerId);
            if (cacheScheduler) {
                const data = schedulerQuery.result.filter((s)=>s?.id !== schedulerId);
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.GetAllScheduledDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$19e641f4e2da264b = (recipientList)=>{
    try {
        const recipientListQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.RecipientListsDocument)
        });
        if (recipientListQuery.result) {
            const cacheRecipientList = recipientListQuery.result.find((r)=>r?.id === recipientList.id);
            if (!cacheRecipientList) {
                const data = [
                    recipientList,
                    ...recipientListQuery.result
                ];
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.RecipientListsDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$f797a84e4a3422c2 = (recipientList)=>{
    try {
        const recipientListQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.RecipientListsDocument)
        });
        if (recipientListQuery.result) {
            const data = recipientListQuery.result.map((r)=>r?.id === recipientList.id ? recipientList : r);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.RecipientListsDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (error) {}
};
const $320420f2b3c24003$var$addCompanyTypesToCache = (newValues)=>{
    if (newValues.length > 0) try {
        const companyTypesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.CompanyTypesDocument)
        });
        if (companyTypesQuery.result) {
            const valuesToAdd = newValues.map((nv)=>({
                    ...nv,
                    __typename: "CompanyType"
                }));
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.CompanyTypesDocument),
                data: {
                    result: [
                        ...valuesToAdd,
                        ...companyTypesQuery.result
                    ]
                }
            });
        }
    } catch (error) {}
};
const $320420f2b3c24003$var$addMarketActivitiesToCache = (newValues)=>{
    if (newValues.length > 0) try {
        const marketActivitiesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.MarketActivitiesDocument)
        });
        if (marketActivitiesQuery.result) {
            const valuesToAdd = newValues.map((nv)=>({
                    ...nv,
                    __typename: "MarketActivity"
                }));
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.CompanyTypesDocument),
                data: {
                    result: [
                        ...valuesToAdd,
                        ...marketActivitiesQuery.result
                    ]
                }
            });
        }
    } catch (error) {}
};
const $320420f2b3c24003$var$addMembershipTypesToCache = (newValues)=>{
    if (newValues.length > 0) try {
        const membershipTypesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.MembershipTypesDocument)
        });
        if (membershipTypesQuery.result) {
            const valuesToAdd = newValues.map((nv)=>({
                    ...nv,
                    __typename: "MembershipType"
                }));
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.MembershipTypesDocument),
                data: {
                    result: [
                        ...valuesToAdd,
                        ...membershipTypesQuery.result
                    ]
                }
            });
        }
    } catch (error) {}
};
const $320420f2b3c24003$var$addProductCodesToCache = (newValues)=>{
    if (newValues.length > 0) try {
        const productCodesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.ProductCodesDocument)
        });
        if (productCodesQuery.result) {
            const valuesToAdd = newValues.map((nv)=>({
                    ...nv,
                    __typename: "ProductCode"
                }));
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.ProductCodesDocument),
                data: {
                    result: [
                        ...valuesToAdd,
                        ...productCodesQuery.result
                    ]
                }
            });
        }
    } catch (error) {}
};
const $320420f2b3c24003$var$addTitlesInternalToCache = (newValues)=>{
    if (newValues.length > 0) try {
        const titlesInternalQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.TitlesInternalDocument)
        });
        if (titlesInternalQuery.result) {
            const valuesToAdd = newValues.map((nv)=>({
                    ...nv,
                    __typename: "TitleInternal"
                }));
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.TitlesInternalDocument),
                data: {
                    result: [
                        ...valuesToAdd,
                        ...titlesInternalQuery.result
                    ]
                }
            });
        }
    } catch (error) {}
};
const $320420f2b3c24003$export$9238043f26dda290 = (valueListName, valueToRemove)=>{
    const { id: id } = valueToRemove;
    switch(valueListName){
        case (0, $fmUFE.ValueLists).CompanyType:
            $320420f2b3c24003$var$removeCompanyTypeFromCache(id);
            break;
        case (0, $fmUFE.ValueLists).MarketActivity:
            $320420f2b3c24003$var$removeMarketActivityFromCache(id);
            break;
        case (0, $fmUFE.ValueLists).MembershipType:
            $320420f2b3c24003$var$removeMembershipTypeFromCache(id);
            break;
        case (0, $fmUFE.ValueLists).ProductCode:
            $320420f2b3c24003$var$removeProductCodeFromCache(id);
            break;
        case (0, $fmUFE.ValueLists).TitleInternal:
            $320420f2b3c24003$var$removeTitleInternalFromCache(id);
            break;
        default:
            break;
    }
};
const $320420f2b3c24003$var$removeCompanyTypeFromCache = (id)=>{
    try {
        const companyTypesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.CompanyTypesDocument)
        });
        if (companyTypesQuery.result) (0, $dHPFu.default).writeQuery({
            query: (0, $hjfla.CompanyTypesDocument),
            data: {
                result: companyTypesQuery.result.filter((ct)=>ct?.id !== id)
            }
        });
    } catch (error) {}
};
const $320420f2b3c24003$var$removeMarketActivityFromCache = (id)=>{
    try {
        const marketActivitiesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.MarketActivitiesDocument)
        });
        if (marketActivitiesQuery.result) (0, $dHPFu.default).writeQuery({
            query: (0, $hjfla.MarketActivitiesDocument),
            data: {
                result: marketActivitiesQuery.result.filter((ma)=>ma?.id !== id)
            }
        });
    } catch (error) {}
};
const $320420f2b3c24003$var$removeMembershipTypeFromCache = (id)=>{
    try {
        const membershipTypesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.MembershipTypesDocument)
        });
        if (membershipTypesQuery.result) (0, $dHPFu.default).writeQuery({
            query: (0, $hjfla.MembershipTypesDocument),
            data: {
                result: membershipTypesQuery.result.filter((m)=>m?.id !== id)
            }
        });
    } catch (error) {}
};
const $320420f2b3c24003$var$removeProductCodeFromCache = (id)=>{
    try {
        const productCodesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.ProductCodesDocument)
        });
        if (productCodesQuery.result) (0, $dHPFu.default).writeQuery({
            query: (0, $hjfla.ProductCodesDocument),
            data: {
                result: productCodesQuery.result.filter((pc)=>pc?.id !== id)
            }
        });
    } catch (error) {}
};
const $320420f2b3c24003$var$removeTitleInternalFromCache = (id)=>{
    try {
        const titlesInternalQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.TitlesInternalDocument)
        });
        if (titlesInternalQuery.result) (0, $dHPFu.default).writeQuery({
            query: (0, $hjfla.TitlesInternalDocument),
            data: {
                result: titlesInternalQuery.result.filter((ti)=>ti?.id !== id)
            }
        });
    } catch (error) {}
};
const $320420f2b3c24003$export$56a1d22221682876 = (stock)=>{
    try {
        const stocksQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.StocksDocument)
        });
        if (stocksQuery.result) {
            const cacheStock = stocksQuery.result.find((s)=>s?.id === stock.id);
            if (!cacheStock) {
                const data = [
                    stock,
                    ...stocksQuery.result
                ];
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.StocksDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {
        console.log("addStockInCache error: ", e);
    }
};
const $320420f2b3c24003$export$1df9c29a565d76f0 = (ftse)=>{
    try {
        const ftseQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetFtseFilesDocument)
        });
        if (ftseQuery.result) {
            const cacheFtse = ftseQuery.result.find((fts)=>fts?.id === ftse.id);
            if (!cacheFtse) {
                const data = [
                    ftse,
                    ...ftseQuery.result
                ];
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.GetFtseFilesDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {
        console.log("createIndexCache error:", e);
    }
};
const $320420f2b3c24003$export$5e281deef44951b9 = (ftse)=>{
    try {
        const ftseQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetFtseFilesDocument)
        });
        if (ftseQuery.result) {
            const data = ftseQuery.result.map((fts)=>fts?.id === ftse.id ? ftse : fts);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.GetFtseFilesDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$97c337aee0c81ebb = (ftseFile)=>{
    try {
        const ftseFilesQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetFtseFilesDocument)
        });
        if (ftseFilesQuery.result) {
            const cacheFtseFileIndex = ftseFilesQuery.result.findIndex((c)=>c?.id === ftseFile.id);
            if (cacheFtseFileIndex > -1) {
                const data = ftseFilesQuery.result.filter(function(el) {
                    return el?.id !== ftseFile.id;
                });
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.GetFtseFilesDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {
        console.log("deteledFtseFileCache error:", e);
    }
};
const $320420f2b3c24003$export$43fc271e28fc8c92 = (index)=>{
    try {
        const indexQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.IndicesDocument)
        });
        if (indexQuery.result) {
            const cacheIndex = indexQuery.result.find((i)=>i?.id === index.id);
            if (!cacheIndex) {
                const data = [
                    index,
                    ...indexQuery.result
                ];
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.IndicesDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {
        console.log("createIndexCache error:", e);
    }
};
const $320420f2b3c24003$export$28548e847c66da9a = (index)=>{
    try {
        const indexQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.IndicesDocument)
        });
        if (indexQuery.result) (0, $dHPFu.default).writeQuery({
            query: (0, $hjfla.IndicesDocument),
            data: {
                result: indexQuery.result.filter((i)=>i?.id !== index.id)
            }
        });
    } catch (e) {
        console.log("createIndexCache error:", e);
    }
};
const $320420f2b3c24003$export$866414977599f44b = (index)=>{
    try {
        const indexQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.IndicesDocument)
        });
        if (indexQuery.result) {
            const data = indexQuery.result.map((i)=>i?.id === index.id ? index : i);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.IndicesDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$3b62db3b4cf1931d = (stock)=>{
    try {
        const stocksQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.StocksDocument)
        });
        if (stocksQuery.result) {
            const data = stocksQuery.result.map((s)=>s?.id === stock.id ? stock : s);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.StocksDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (e) {
        console.log("updateStockInCache error: ", e);
    }
};
const $320420f2b3c24003$export$49f67e06db3f0295 = (code, id)=>{
    try {
        const stocksQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.StocksDocument)
        });
        if (stocksQuery.result) {
            const stocks = stocksQuery.result.filter((s)=>s?.code?.toLowerCase() === code.trim().toLowerCase());
            if (stocks.length === 0) return false;
            else {
                if (id) {
                    const refinedStocks = stocks.filter((s)=>parseInt(s?.id) !== id);
                    return refinedStocks.length > 0;
                }
                return true;
            }
        }
    } catch (e) {
        return false;
    }
    return false;
};
const $320420f2b3c24003$export$4712913e6750cf87 = (indexSerie)=>{
    try {
        const indexSerieQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.IndexSeriesDocument)
        });
        if (indexSerieQuery.result) {
            const updatedData = indexSerieQuery.result.filter((i)=>i?.id !== indexSerie.id);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.IndexSeriesDocument),
                data: {
                    result: updatedData
                }
            });
        }
    } catch (e) {
        console.log("deleteIndexSerieCache error:", e);
    }
};
const $320420f2b3c24003$export$97a7abb2d881979c = (indexSerie)=>{
    try {
        const indexSerieQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.IndexSeriesDocument)
        });
        if (indexSerieQuery.result) {
            const cacheIndexSerie = indexSerieQuery.result.find((is)=>is?.id === indexSerie.id);
            if (!cacheIndexSerie) {
                const data = [
                    indexSerie,
                    ...indexSerieQuery.result
                ];
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.IndexSeriesDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {
        console.log("createIndexSerieCache error:", e);
    }
};
const $320420f2b3c24003$export$a5dc09d3a65cd208 = (indexSerie)=>{
    try {
        const indexSerieQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.IndexSeriesDocument)
        });
        if (indexSerieQuery.result) {
            const data = indexSerieQuery.result.map((is)=>is?.id === indexSerie.id ? indexSerie : is);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.IndexSeriesDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$2bf3d08ca0abbe55 = (etf)=>{
    try {
        const etfQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetEtfsDocument)
        });
        if (etfQuery.result) {
            const cacheEtfSerie = etfQuery.result.find((e)=>e?.id === etf.id);
            if (!cacheEtfSerie) {
                const data = [
                    etf,
                    ...etfQuery.result
                ];
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.GetEtfsDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$4c3f269346b8bed4 = (etf)=>{
    try {
        const etfQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetEtfsDocument)
        });
        if (etfQuery.result) {
            const data = etfQuery.result.map((e)=>e?.id === etf.id ? etf : e);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.GetEtfsDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$6d23740d93ac2af4 = (etf)=>{
    try {
        const etfsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetEtfsDocument)
        });
        if (etfsQuery.result) (0, $dHPFu.default).writeQuery({
            query: (0, $hjfla.GetEtfsDocument),
            data: {
                result: etfsQuery.result.filter((e)=>e?.id !== etf.id)
            }
        });
    } catch (e) {}
};
const $320420f2b3c24003$export$e2aa083c3d30daec = (ftseConfiguration)=>{
    try {
        const ftseConfigurationsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetFtseConfigurationsDocument)
        });
        if (ftseConfigurationsQuery.result) {
            const data = ftseConfigurationsQuery.result.map((f)=>f?.id === ftseConfiguration.id ? ftseConfiguration : f);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.GetFtseConfigurationsDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$4786dca3e23a3e07 = (name, id)=>{
    try {
        const sectionsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetSiteSectionsDocument)
        });
        if (sectionsQuery.result) {
            const sections = sectionsQuery.result.filter((s)=>s?.name.toUpperCase() === name.toUpperCase());
            if (sections.length === 0) return false;
            else {
                if (id) {
                    const refinedSections = sections.filter((s)=>s?.id !== id);
                    return refinedSections.length > 0;
                }
                return true;
            }
        }
    } catch (error) {
        return false;
    }
    return false;
};
const $320420f2b3c24003$export$6e8359a385993595 = (document)=>{
    try {
        const docsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.DocumentsDocument)
        });
        if (docsQuery.result) (0, $dHPFu.default).writeQuery({
            query: (0, $hjfla.DocumentsDocument),
            data: {
                result: docsQuery.result.filter((d)=>d?.id !== document.id)
            }
        });
    } catch (e) {}
};
const $320420f2b3c24003$export$2fc4a5b081a4d8a9 = (document)=>{
    try {
        const docsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.DocumentsDocument)
        });
        if (docsQuery.result) (0, $dHPFu.default).writeQuery({
            query: (0, $hjfla.DocumentsDocument),
            data: {
                result: docsQuery.result.map((d)=>d?.id === document.id ? document : d)
            }
        });
    } catch (e) {}
};
const $320420f2b3c24003$export$737ae00f20d3bc88 = (document)=>{
    try {
        const docsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.DocumentsDocument)
        });
        if (docsQuery.result) {
            const cacheDoc = docsQuery.result.find((d)=>d?.id === document.id);
            if (!cacheDoc) {
                const data = [
                    document,
                    ...docsQuery.result
                ];
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.DocumentsDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$93f2e7709d24ce = (siteSection)=>{
    try {
        const sectionsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetSiteSectionsDocument)
        });
        if (sectionsQuery.result) {
            const cacheSection = sectionsQuery.result.find((s)=>s?.id === siteSection.id);
            if (!cacheSection) {
                const data = [
                    siteSection,
                    ...sectionsQuery.result
                ];
                (0, $dHPFu.default).writeQuery({
                    query: (0, $hjfla.GetSiteSectionsDocument),
                    data: {
                        result: data
                    }
                });
            }
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$eff3dd410867f1b6 = (siteSection)=>{
    try {
        const sectionsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetSiteSectionsDocument)
        });
        if (sectionsQuery.result) (0, $dHPFu.default).writeQuery({
            query: (0, $hjfla.GetSiteSectionsDocument),
            data: {
                result: sectionsQuery.result.filter((s)=>s?.id !== siteSection.id)
            }
        });
    } catch (e) {}
};
const $320420f2b3c24003$export$80813710cd512a37 = (siteSection)=>{
    try {
        const sectionsQuery = (0, $dHPFu.default).cache.readQuery({
            query: (0, $hjfla.GetSiteSectionsDocument)
        });
        if (sectionsQuery.result) {
            const data = sectionsQuery.result.map((s)=>s?.id === siteSection.id ? siteSection : s);
            (0, $dHPFu.default).writeQuery({
                query: (0, $hjfla.GetSiteSectionsDocument),
                data: {
                    result: data
                }
            });
        }
    } catch (e) {}
};
const $320420f2b3c24003$export$59ba0bb3b4e5def2 = (input)=>{
    if (input && input.length > 0) return input;
    return undefined;
};
const $320420f2b3c24003$export$e2396ddab11279c4 = (input)=>{
    if (input.length > 0) return Number(input);
    return undefined;
};
const $320420f2b3c24003$export$2a54aca3dae44f69 = (input)=>{
    if (input.length > 0) return Number(input);
    return null;
};
const $320420f2b3c24003$export$c4bc403ac436aaee = (input)=>{
    if (input) return input.toString();
    return undefined;
};
const $320420f2b3c24003$export$ffe11b6ddea720db = (input)=>{
    return input ? Number(input) : undefined;
};

});
parcelRegister("dHPFu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc6406c8bfe1d538$export$2e2bcd8739ae039; });

var $aM783 = parcelRequire("aM783");

var $g4nO4 = parcelRequire("g4nO4");
var $4B3dP = parcelRequire("4B3dP");
var $1ceGN = parcelRequire("1ceGN");

var $epiqS = parcelRequire("epiqS");

var $5Naeb = parcelRequire("5Naeb");

var $j6URj = parcelRequire("j6URj");

var $29Gnu = parcelRequire("29Gnu");

var $5v0ib = parcelRequire("5v0ib");
let $fc6406c8bfe1d538$var$httpLink;
$fc6406c8bfe1d538$var$httpLink = (0, (/*@__PURE__*/$parcel$interopDefault($5v0ib)))({
    uri: "https://crm-backend.epra.com/"
});
const $fc6406c8bfe1d538$var$wsLink = new (0, $epiqS.WebSocketLink)(new (0, $5Naeb.SubscriptionClient)("wss://crm-backend.epra.com/graphql", {
    reconnect: true,
    connectionParams: ()=>{
        const token = localStorage.getItem((0, $aM783.AppConsts).AccessToken);
        return {
            authToken: token
        };
    }
}));
const $fc6406c8bfe1d538$var$authLink = (0, $j6URj.setContext)((_, { headers: headers })=>{
    // get the authentication token from local storage if it exists
    const token = localStorage.getItem((0, $aM783.AppConsts).AccessToken);
    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            authorization: token ?? ""
        }
    };
});
const $fc6406c8bfe1d538$var$link = (0, $1ceGN.split)(({ query: query })=>{
    const definition = (0, $29Gnu.getMainDefinition)(query);
    return definition.kind === "OperationDefinition" && definition.operation === "subscription";
}, $fc6406c8bfe1d538$var$wsLink, $fc6406c8bfe1d538$var$authLink.concat($fc6406c8bfe1d538$var$httpLink));
const $fc6406c8bfe1d538$var$cache = new (0, $4B3dP.InMemoryCache)({
    addTypename: true
});
const $fc6406c8bfe1d538$var$client = new (0, $g4nO4.ApolloClient)({
    cache: $fc6406c8bfe1d538$var$cache,
    link: $fc6406c8bfe1d538$var$link
});
var $fc6406c8bfe1d538$export$2e2bcd8739ae039 = $fc6406c8bfe1d538$var$client;

});
parcelRegister("g4nO4", function(module, exports) {

$parcel$export(module.exports, "ApolloClient", function () { return $bb2f7c87a2595601$export$13f5a5f0f1dbab88; });

var $l73V3 = parcelRequire("l73V3");
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $bdl4J = parcelRequire("bdl4J");
var $aBGMx = parcelRequire("aBGMx");

var $bE7kj = parcelRequire("bE7kj");

var $jMekh = parcelRequire("jMekh");

var $hF1vZ = parcelRequire("hF1vZ");

var $eLbT8 = parcelRequire("eLbT8");

var $2ZAj9 = parcelRequire("2ZAj9");

var $3qXPo = parcelRequire("3qXPo");
var $bb2f7c87a2595601$var$hasSuggestedDevtools = false;
/**
 * This is the primary Apollo Client class. It is used to send GraphQL documents (i.e. queries
 * and mutations) to a GraphQL spec-compliant server over an {@link ApolloLink} instance,
 * receive results from the server and cache the results in a store. It also delivers updates
 * to GraphQL queries through {@link Observable} instances.
 */ var $bb2f7c87a2595601$export$13f5a5f0f1dbab88 = /** @class */ function() {
    /**
     * Constructs an instance of {@link ApolloClient}.
     *
     * @example
     * ```js
     * import { ApolloClient, InMemoryCache } from '@apollo/client';
     *
     * const cache = new InMemoryCache();
     *
     * const client = new ApolloClient({
     *   // Provide required constructor fields
     *   cache: cache,
     *   uri: 'http://localhost:4000/',
     *
     *   // Provide some optional constructor fields
     *   name: 'react-web-client',
     *   version: '1.3',
     *   queryDeduplication: false,
     *   defaultOptions: {
     *     watchQuery: {
     *       fetchPolicy: 'cache-and-network',
     *     },
     *   },
     * });
     * ```
     */ function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        if (!options.cache) throw (0, $kJ26n.newInvariantError)(15);
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, documentTransform = options.documentTransform, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        _c = options.connectToDevTools, // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        connectToDevTools = _c === void 0 ? typeof window === "object" && !window.__APOLLO_CLIENT__ && globalThis.__DEV__ !== false : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, defaultContext = options.defaultContext, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? cache.assumeImmutableResults : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) link = uri ? new (0, $jMekh.HttpLink)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, $bdl4J.ApolloLink).empty();
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        this.version = (0, $bE7kj.version);
        this.localState = new (0, $eLbT8.LocalState)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, $hF1vZ.QueryManager)({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            defaultContext: defaultContext,
            documentTransform: documentTransform,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore || {}
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            } : void 0
        });
        if (connectToDevTools) this.connectToDevTools();
    }
    ApolloClient.prototype.connectToDevTools = function() {
        if (typeof window === "object") {
            var windowWithDevTools = window;
            var devtoolsSymbol = Symbol.for("apollo.devtools");
            (windowWithDevTools[devtoolsSymbol] = windowWithDevTools[devtoolsSymbol] || []).push(this);
            windowWithDevTools.__APOLLO_CLIENT__ = this;
        }
        /**
         * Suggest installing the devtools for developers who don't have them
         */ if (!$bb2f7c87a2595601$var$hasSuggestedDevtools && globalThis.__DEV__ !== false) {
            $bb2f7c87a2595601$var$hasSuggestedDevtools = true;
            setTimeout(function() {
                if (typeof window !== "undefined" && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                    var nav = window.navigator;
                    var ua = nav && nav.userAgent;
                    var url = void 0;
                    if (typeof ua === "string") {
                        if (ua.indexOf("Chrome/") > -1) url = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                        else if (ua.indexOf("Firefox/") > -1) url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                    if (url) globalThis.__DEV__ !== false && (0, $kJ26n.invariant).log("Download the Apollo DevTools for a better development experience: %s", url);
                }
            }, 10000);
        }
    };
    Object.defineProperty(ApolloClient.prototype, "documentTransform", {
        /**
         * The `DocumentTransform` used to modify GraphQL documents before a request
         * is made. If a custom `DocumentTransform` is not provided, this will be the
         * default document transform.
         */ get: function() {
            return this.queryManager.documentTransform;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Call this method to terminate any active client processes, making it safe
     * to dispose of this `ApolloClient` instance.
     */ ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    /**
     * This watches the cache store of the query according to the options specified and
     * returns an {@link ObservableQuery}. We can subscribe to this {@link ObservableQuery} and
     * receive updated results through a GraphQL observer when the cache store changes.
     *
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     *
     * For example, suppose you call watchQuery on a GraphQL query that fetches a person's
     * first and last name and this person has a particular object identifier, provided by
     * dataIdFromObject. Later, a different query fetches that same person's
     * first and last name and the first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     *
     * Note that if the cache does not change, the subscriber will *not* be notified.
     *
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     */ ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $2ZAj9.mergeOptions)(this.defaultOptions.watchQuery, options);
        // XXX Overwriting options is probably not the best way to do this long term...
        if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.watchQuery(options);
    };
    /**
     * This resolves a single query according to the options specified and
     * returns a `Promise` which is either resolved with the resulting data
     * or rejected with an error.
     *
     * @param options - An object of type {@link QueryOptions} that allows us to
     * describe how this query should be treated e.g. whether it should hit the
     * server at all or just resolve from the cache, etc.
     */ ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $2ZAj9.mergeOptions)(this.defaultOptions.query, options);
        (0, $kJ26n.invariant)(options.fetchPolicy !== "cache-and-network", 16);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") options = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.query(options);
    };
    /**
     * This resolves a single mutation according to the options specified and returns a
     * Promise which is either resolved with the resulting data or rejected with an
     * error. In some cases both `data` and `errors` might be undefined, for example
     * when `errorPolicy` is set to `'ignore'`.
     *
     * It takes options as an object with the following keys and values:
     */ ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $2ZAj9.mergeOptions)(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * {@link Observable} which either emits received data or an error.
     */ ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL query without making a network request. This method will start at
     * the root query. To start at a specific id returned by `dataIdFromObject`
     * use `readFragment`.
     *
     * @param optimistic - Set to `true` to allow `readQuery` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL fragment without making a network request. This method will read a
     * GraphQL fragment from any arbitrary id that is currently cached, unlike
     * `readQuery` which will only read from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @param optimistic - Set to `true` to allow `readFragment` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a
     * specific id returned by `dataIdFromObject` then use `writeFragment`.
     */ ApolloClient.prototype.writeQuery = function(options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */ ApolloClient.prototype.writeFragment = function(options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $aBGMx.execute)(this.link, payload);
    };
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: false
            });
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    /**
     * Remove all data from the store. Unlike `resetStore`, `clearStore` will
     * not refetch any active queries.
     */ ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: true
            });
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * reset. `onResetStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * cleared. `onClearStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     */ ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    /**
     * Refetches specified active queries. Similar to "reFetchObservableQueries()" but with a specific list of queries.
     *
     * `refetchQueries()` is useful for use cases to imperatively refresh a selection of queries.
     *
     * It is important to remember that `refetchQueries()` *will* refetch specified active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.refetchQueries = function(options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function(result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        // In case you need the raw results immediately, without awaiting
        // Promise.all(results):
        result.queries = queries;
        result.results = results;
        // If you decide to ignore the result Promise because you're using
        // result.queries and result.results instead, you shouldn't have to worry
        // about preventing uncaught rejections for the Promise.all result.
        result.catch(function(error) {
            globalThis.__DEV__ !== false && (0, $kJ26n.invariant).debug(17, error);
        });
        return result;
    };
    /**
     * Get all currently active `ObservableQuery` objects, in a `Map` keyed by
     * query ID strings.
     *
     * An "active" query is one that has observers and a `fetchPolicy` other than
     * "standby" or "cache-only".
     *
     * You can include all `ObservableQuery` objects (including the inactive ones)
     * by passing "all" instead of "active", or you can include just a subset of
     * active queries by passing an array of query names or DocumentNode objects.
     */ ApolloClient.prototype.getObservableQueries = function(include) {
        if (include === void 0) include = "active";
        return this.queryManager.getObservableQueries(include);
    };
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     */ ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */ ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    /**
     * Add additional local resolvers.
     */ ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    /**
     * Set (override existing) local resolvers.
     */ ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    /**
     * Get all registered local resolvers.
     */ ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    /**
     * Set a custom local state fragment matcher.
     */ ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    /**
     * Define a new ApolloLink (or link chain) that Apollo Client will use.
     */ ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    Object.defineProperty(ApolloClient.prototype, "defaultContext", {
        get: function() {
            return this.queryManager.defaultContext;
        },
        enumerable: false,
        configurable: true
    });
    return ApolloClient;
}();
if (globalThis.__DEV__ !== false) $bb2f7c87a2595601$export$13f5a5f0f1dbab88.prototype.getMemoryInternals = (0, $3qXPo.getApolloClientMemoryInternals);

});
parcelRegister("bdl4J", function(module, exports) {

$parcel$export(module.exports, "ApolloLink", function () { return $82a141befce13668$export$2fed3d61f740bc7f; });
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");
parcelRequire("5Xksu");
var $bMbZ0 = parcelRequire("bMbZ0");

var $cfanc = parcelRequire("cfanc");
var $2Kbo3 = parcelRequire("2Kbo3");
var $8fyUO = parcelRequire("8fyUO");
function $82a141befce13668$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $bMbZ0.Observable).of();
}
function $82a141befce13668$var$toLink(handler) {
    return typeof handler === "function" ? new $82a141befce13668$export$2fed3d61f740bc7f(handler) : handler;
}
function $82a141befce13668$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $82a141befce13668$export$2fed3d61f740bc7f = /** @class */ function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, $bMbZ0.Observable).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($82a141befce13668$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $82a141befce13668$var$toLink(left);
        var rightLink = $82a141befce13668$var$toLink(right || new ApolloLink($82a141befce13668$var$passthrough));
        var ret;
        if ($82a141befce13668$var$isTerminating(leftLink) && $82a141befce13668$var$isTerminating(rightLink)) ret = new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, $bMbZ0.Observable).of() : rightLink.request(operation) || (0, $bMbZ0.Observable).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, $bMbZ0.Observable).of() : rightLink.request(operation, forward) || (0, $bMbZ0.Observable).of();
        });
        return Object.assign(ret, {
            left: leftLink,
            right: rightLink
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $cfanc.createOperation)(operation.context, (0, $2Kbo3.transformOperation)((0, $8fyUO.validateOperation)(operation)))) || (0, $bMbZ0.Observable).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $82a141befce13668$var$toLink(first);
        if ($82a141befce13668$var$isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && (0, $kJ26n.invariant).warn(35, firstLink);
            return firstLink;
        }
        var nextLink = $82a141befce13668$var$toLink(second);
        var ret;
        if ($82a141befce13668$var$isTerminating(nextLink)) ret = new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, $bMbZ0.Observable).of();
            }) || (0, $bMbZ0.Observable).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, $bMbZ0.Observable).of();
            }) || (0, $bMbZ0.Observable).of();
        });
        return Object.assign(ret, {
            left: firstLink,
            right: nextLink
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($82a141befce13668$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw (0, $kJ26n.newInvariantError)(36);
    };
    ApolloLink.prototype.onError = function(error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            // Returning false indicates that observer.error does not need to be
            // called again, since it was already called (on the previous line).
            // Calling observer.error again would not cause any real problems,
            // since only the first call matters, but custom onError functions
            // might have other reasons for wanting to prevent the default
            // behavior by returning false.
            return false;
        }
        // Throw errors will be passed to observer.error.
        throw error;
    };
    ApolloLink.prototype.setOnError = function(fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();

});
parcelRegister("5Xksu", function(module, exports) {

$parcel$export(module.exports, "Observable", function () { return (parcelRequire("bMbZ0")).Observable; });

var $bMbZ0 = parcelRequire("bMbZ0");
parcelRequire("frWs0");
// The zen-observable package defines Observable.prototype[Symbol.observable]
// when Symbol is supported, but RxJS interop depends on also setting this fake
// '@@observable' string as a polyfill for Symbol.observable.
var $45625514b922935e$var$prototype = (0, $bMbZ0.Observable).prototype;
var $45625514b922935e$var$fakeObsSymbol = "@@observable";
if (!$45625514b922935e$var$prototype[$45625514b922935e$var$fakeObsSymbol]) // @ts-expect-error
$45625514b922935e$var$prototype[$45625514b922935e$var$fakeObsSymbol] = function() {
    return this;
};

});
parcelRegister("bMbZ0", function(module, exports) {

$parcel$export(module.exports, "Observable", function () { return $892d78fc0bd12baa$export$77cea355fa80b5f4; });
function $892d78fc0bd12baa$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $892d78fc0bd12baa$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $892d78fc0bd12baa$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $892d78fc0bd12baa$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $892d78fc0bd12baa$var$_arrayLikeToArray(o, minLen);
}
function $892d78fc0bd12baa$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $892d78fc0bd12baa$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $892d78fc0bd12baa$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $892d78fc0bd12baa$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $892d78fc0bd12baa$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var $892d78fc0bd12baa$var$hasSymbols = function() {
    return typeof Symbol === "function";
};
var $892d78fc0bd12baa$var$hasSymbol = function(name) {
    return $892d78fc0bd12baa$var$hasSymbols() && Boolean(Symbol[name]);
};
var $892d78fc0bd12baa$var$getSymbol = function(name) {
    return $892d78fc0bd12baa$var$hasSymbol(name) ? Symbol[name] : "@@" + name;
};
if ($892d78fc0bd12baa$var$hasSymbols() && !$892d78fc0bd12baa$var$hasSymbol("observable")) Symbol.observable = Symbol("observable");
var $892d78fc0bd12baa$var$SymbolIterator = $892d78fc0bd12baa$var$getSymbol("iterator");
var $892d78fc0bd12baa$var$SymbolObservable = $892d78fc0bd12baa$var$getSymbol("observable");
var $892d78fc0bd12baa$var$SymbolSpecies = $892d78fc0bd12baa$var$getSymbol("species"); // === Abstract Operations ===
function $892d78fc0bd12baa$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== "function") throw new TypeError(value + " is not a function");
    return value;
}
function $892d78fc0bd12baa$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$892d78fc0bd12baa$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $892d78fc0bd12baa$export$77cea355fa80b5f4;
}
function $892d78fc0bd12baa$var$isObservable(x) {
    return x instanceof $892d78fc0bd12baa$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $892d78fc0bd12baa$var$hostReportError(e) {
    if ($892d78fc0bd12baa$var$hostReportError.log) $892d78fc0bd12baa$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $892d78fc0bd12baa$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $892d78fc0bd12baa$var$hostReportError(e);
        }
    });
}
function $892d78fc0bd12baa$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === "function") cleanup();
        else {
            var unsubscribe = $892d78fc0bd12baa$var$getMethod(cleanup, "unsubscribe");
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $892d78fc0bd12baa$var$hostReportError(e);
    }
}
function $892d78fc0bd12baa$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = "closed";
}
function $892d78fc0bd12baa$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = "ready";
    for(var i = 0; i < queue.length; ++i){
        $892d78fc0bd12baa$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === "closed") break;
    }
}
function $892d78fc0bd12baa$var$notifySubscription(subscription, type, value) {
    subscription._state = "running";
    var observer = subscription._observer;
    try {
        var m = $892d78fc0bd12baa$var$getMethod(observer, type);
        switch(type){
            case "next":
                if (m) m.call(observer, value);
                break;
            case "error":
                $892d78fc0bd12baa$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case "complete":
                $892d78fc0bd12baa$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $892d78fc0bd12baa$var$hostReportError(e);
    }
    if (subscription._state === "closed") $892d78fc0bd12baa$var$cleanupSubscription(subscription);
    else if (subscription._state === "running") subscription._state = "ready";
}
function $892d78fc0bd12baa$var$onNotify(subscription, type, value) {
    if (subscription._state === "closed") return;
    if (subscription._state === "buffering") {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== "ready") {
        subscription._state = "buffering";
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $892d78fc0bd12baa$var$enqueue(function() {
            return $892d78fc0bd12baa$var$flushSubscription(subscription);
        });
        return;
    }
    $892d78fc0bd12baa$var$notifySubscription(subscription, type, value);
}
var $892d78fc0bd12baa$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = "initializing";
        var subscriptionObserver = new $892d78fc0bd12baa$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === "initializing") this._state = "ready";
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== "closed") {
            $892d78fc0bd12baa$var$closeSubscription(this);
            $892d78fc0bd12baa$var$cleanupSubscription(this);
        }
    };
    $892d78fc0bd12baa$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === "closed";
            }
        }
    ]);
    return Subscription;
}();
var $892d78fc0bd12baa$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $892d78fc0bd12baa$var$onNotify(this._subscription, "next", value);
    };
    _proto2.error = function error(value) {
        $892d78fc0bd12baa$var$onNotify(this._subscription, "error", value);
    };
    _proto2.complete = function complete() {
        $892d78fc0bd12baa$var$onNotify(this._subscription, "complete");
    };
    $892d78fc0bd12baa$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === "closed";
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $892d78fc0bd12baa$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
        if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== "object" || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $892d78fc0bd12baa$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== "function") {
                reject(new TypeError(fn + " is not a function"));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $892d78fc0bd12baa$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $892d78fc0bd12baa$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $892d78fc0bd12baa$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $892d78fc0bd12baa$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $892d78fc0bd12baa$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$892d78fc0bd12baa$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === "function" ? this : Observable;
        if (x == null) throw new TypeError(x + " is not an object");
        var method = $892d78fc0bd12baa$var$getMethod(x, $892d78fc0bd12baa$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + " is not an object");
            if ($892d78fc0bd12baa$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($892d78fc0bd12baa$var$hasSymbol("iterator")) {
            method = $892d78fc0bd12baa$var$getMethod(x, $892d78fc0bd12baa$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $892d78fc0bd12baa$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $892d78fc0bd12baa$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $892d78fc0bd12baa$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + " is not observable");
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === "function" ? this : Observable;
        return new C(function(observer) {
            $892d78fc0bd12baa$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $892d78fc0bd12baa$var$_createClass(Observable, null, [
        {
            key: $892d78fc0bd12baa$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($892d78fc0bd12baa$var$hasSymbols()) Object.defineProperty($892d78fc0bd12baa$export$77cea355fa80b5f4, Symbol("extensions"), {
    value: {
        symbol: $892d78fc0bd12baa$var$SymbolObservable,
        hostReportError: $892d78fc0bd12baa$var$hostReportError
    },
    configurable: true
});

});

parcelRegister("frWs0", function(module, exports) {
/* global window */ 
var $2o9g9 = parcelRequire("2o9g9");
var root;
if (typeof self !== "undefined") root = self;
else if (typeof window !== "undefined") root = window;
else if (typeof $parcel$global !== "undefined") root = $parcel$global;
else root = module;
var result = (0, $2o9g9.default)(root);
var $b3f6b7b651414f31$export$2e2bcd8739ae039 = result;

});
parcelRegister("2o9g9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bd5016cb15f1cd5$export$2e2bcd8739ae039; });
function $1bd5016cb15f1cd5$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === "function") // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for("https://github.com/benlesh/symbol-observable");
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol("https://github.com/benlesh/symbol-observable");
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = "@@observable";
    return result;
}

});



parcelRegister("cfanc", function(module, exports) {

$parcel$export(module.exports, "createOperation", function () { return $8e9eeea4d2dbb4a4$export$f29bedd62f56fcb2; });

var $l73V3 = parcelRequire("l73V3");
function $8e9eeea4d2dbb4a4$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $l73V3.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, context), next(context));
        else context = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, context), next);
    };
    var getContext = function() {
        return (0, $l73V3.__assign)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    return operation;
}

});

parcelRegister("2Kbo3", function(module, exports) {

$parcel$export(module.exports, "transformOperation", function () { return $1ff8b5e3a83f286a$export$4f3f7df1b558c729; });

var $29Gnu = parcelRequire("29Gnu");
function $1ff8b5e3a83f286a$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    // Best guess at an operation name
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, $29Gnu.getOperationName)(transformedOperation.query) || undefined : "";
    return transformedOperation;
}

});
parcelRegister("29Gnu", function(module, exports) {

$parcel$export(module.exports, "checkDocument", function () { return $191d4b6931859b8b$export$a7d0d8111d2386df; });
$parcel$export(module.exports, "getOperationDefinition", function () { return $191d4b6931859b8b$export$7a5b1fa979d2c158; });
$parcel$export(module.exports, "getOperationName", function () { return $191d4b6931859b8b$export$41bca9dc6871dd4e; });
$parcel$export(module.exports, "getFragmentDefinitions", function () { return $191d4b6931859b8b$export$5320a7ba9466a3df; });
$parcel$export(module.exports, "getQueryDefinition", function () { return $191d4b6931859b8b$export$d96b2213c1b9d3a9; });
$parcel$export(module.exports, "getFragmentDefinition", function () { return $191d4b6931859b8b$export$772111caef41b3f5; });
$parcel$export(module.exports, "getMainDefinition", function () { return $191d4b6931859b8b$export$f431198736b7f96d; });
$parcel$export(module.exports, "getDefaultValues", function () { return $191d4b6931859b8b$export$84c19026e616569e; });
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $RzHRn = parcelRequire("RzHRn");
function $191d4b6931859b8b$export$a7d0d8111d2386df(doc) {
    (0, $kJ26n.invariant)(doc && doc.kind === "Document", 74);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw (0, $kJ26n.newInvariantError)(75, definition.kind);
        return definition;
    });
    (0, $kJ26n.invariant)(operations.length <= 1, 76, operations.length);
    return doc;
}
function $191d4b6931859b8b$export$7a5b1fa979d2c158(doc) {
    $191d4b6931859b8b$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function $191d4b6931859b8b$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $191d4b6931859b8b$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function $191d4b6931859b8b$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $191d4b6931859b8b$export$7a5b1fa979d2c158(doc);
    (0, $kJ26n.invariant)(queryDef && queryDef.operation === "query", 77);
    return queryDef;
}
function $191d4b6931859b8b$export$772111caef41b3f5(doc) {
    (0, $kJ26n.invariant)(doc.kind === "Document", 78);
    (0, $kJ26n.invariant)(doc.definitions.length <= 1, 79);
    var fragmentDef = doc.definitions[0];
    (0, $kJ26n.invariant)(fragmentDef.kind === "FragmentDefinition", 80);
    return fragmentDef;
}
function $191d4b6931859b8b$export$f431198736b7f96d(queryDoc) {
    $191d4b6931859b8b$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) // we do this because we want to allow multiple fragment definitions
        // to precede an operation definition.
        fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw (0, $kJ26n.newInvariantError)(81);
}
function $191d4b6931859b8b$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $RzHRn.valueToObjectRepresentation)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}

});
parcelRegister("RzHRn", function(module, exports) {

$parcel$export(module.exports, "makeReference", function () { return $0a10a5e70d9bbe64$export$634ae0e932e9be99; });
$parcel$export(module.exports, "isReference", function () { return $0a10a5e70d9bbe64$export$fa99cac1c0883c47; });
$parcel$export(module.exports, "isDocumentNode", function () { return $0a10a5e70d9bbe64$export$540432d49fcec6c9; });
$parcel$export(module.exports, "valueToObjectRepresentation", function () { return $0a10a5e70d9bbe64$export$a1dab82d368d6525; });
$parcel$export(module.exports, "storeKeyNameFromField", function () { return $0a10a5e70d9bbe64$export$54be8689c65f3b56; });
$parcel$export(module.exports, "getStoreKeyName", function () { return $0a10a5e70d9bbe64$export$3cdb6c178b88cabe; });
$parcel$export(module.exports, "argumentsObjectFromField", function () { return $0a10a5e70d9bbe64$export$3f5a60fb6a781b4f; });
$parcel$export(module.exports, "resultKeyNameFromField", function () { return $0a10a5e70d9bbe64$export$7d1ad22471852218; });
$parcel$export(module.exports, "getTypenameFromResult", function () { return $0a10a5e70d9bbe64$export$cf7bf7e4f289cc26; });
$parcel$export(module.exports, "isField", function () { return $0a10a5e70d9bbe64$export$fb56ad75dd311c12; });
$parcel$export(module.exports, "isInlineFragment", function () { return $0a10a5e70d9bbe64$export$22a1cdafaf27bcff; });
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $dmNot = parcelRequire("dmNot");

var $hrny3 = parcelRequire("hrny3");

var $gGpvG = parcelRequire("gGpvG");
function $0a10a5e70d9bbe64$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $0a10a5e70d9bbe64$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function $0a10a5e70d9bbe64$export$540432d49fcec6c9(value) {
    return (0, $dmNot.isNonNullObject)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function $0a10a5e70d9bbe64$var$isStringValue(value) {
    return value.kind === "StringValue";
}
function $0a10a5e70d9bbe64$var$isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function $0a10a5e70d9bbe64$var$isIntValue(value) {
    return value.kind === "IntValue";
}
function $0a10a5e70d9bbe64$var$isFloatValue(value) {
    return value.kind === "FloatValue";
}
function $0a10a5e70d9bbe64$var$isVariable(value) {
    return value.kind === "Variable";
}
function $0a10a5e70d9bbe64$var$isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function $0a10a5e70d9bbe64$var$isListValue(value) {
    return value.kind === "ListValue";
}
function $0a10a5e70d9bbe64$var$isEnumValue(value) {
    return value.kind === "EnumValue";
}
function $0a10a5e70d9bbe64$var$isNullValue(value) {
    return value.kind === "NullValue";
}
function $0a10a5e70d9bbe64$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($0a10a5e70d9bbe64$var$isIntValue(value) || $0a10a5e70d9bbe64$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($0a10a5e70d9bbe64$var$isBooleanValue(value) || $0a10a5e70d9bbe64$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($0a10a5e70d9bbe64$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $0a10a5e70d9bbe64$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($0a10a5e70d9bbe64$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($0a10a5e70d9bbe64$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $0a10a5e70d9bbe64$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($0a10a5e70d9bbe64$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($0a10a5e70d9bbe64$var$isNullValue(value)) argObj[name.value] = null;
    else throw (0, $kJ26n.newInvariantError)(82, name.value, value.kind);
}
function $0a10a5e70d9bbe64$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $0a10a5e70d9bbe64$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $0a10a5e70d9bbe64$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $0a10a5e70d9bbe64$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $0a10a5e70d9bbe64$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive"
];
// Default stable JSON.stringify implementation used by getStoreKeyName. Can be
// updated/replaced with something better by calling
// getStoreKeyName.setStringify(newStringifyFunction).
var $0a10a5e70d9bbe64$var$storeKeyNameStringify = (0, $gGpvG.canonicalStringify);
var $0a10a5e70d9bbe64$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat($0a10a5e70d9bbe64$var$storeKeyNameStringify(filteredArgs_1), ")");
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        var stringifiedArgs = $0a10a5e70d9bbe64$var$storeKeyNameStringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($0a10a5e70d9bbe64$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat($0a10a5e70d9bbe64$var$storeKeyNameStringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = $0a10a5e70d9bbe64$var$storeKeyNameStringify;
        $0a10a5e70d9bbe64$var$storeKeyNameStringify = s;
        return previous;
    }
});
function $0a10a5e70d9bbe64$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $0a10a5e70d9bbe64$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $0a10a5e70d9bbe64$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $0a10a5e70d9bbe64$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    var fragments;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($0a10a5e70d9bbe64$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === "__typename") return result[$0a10a5e70d9bbe64$export$7d1ad22471852218(selection)];
        } else if (fragments) fragments.push(selection);
        else fragments = [
            selection
        ];
    }
    if (typeof result.__typename === "string") return result.__typename;
    if (fragments) for(var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++){
        var selection = fragments_1[_b];
        var typename = $0a10a5e70d9bbe64$export$cf7bf7e4f289cc26(result, (0, $hrny3.getFragmentFromSelection)(selection, fragmentMap).selectionSet, fragmentMap);
        if (typeof typename === "string") return typename;
    }
}
function $0a10a5e70d9bbe64$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}
function $0a10a5e70d9bbe64$export$22a1cdafaf27bcff(selection) {
    return selection.kind === "InlineFragment";
}

});
parcelRegister("hrny3", function(module, exports) {

$parcel$export(module.exports, "getFragmentQueryDocument", function () { return $cb27397a4448afe2$export$abbf37c7cf644e41; });
$parcel$export(module.exports, "createFragmentMap", function () { return $cb27397a4448afe2$export$193789b4c8246dd4; });
$parcel$export(module.exports, "getFragmentFromSelection", function () { return $cb27397a4448afe2$export$f80bdb85f299186; });

var $l73V3 = parcelRequire("l73V3");
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");
function $cb27397a4448afe2$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function(definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") throw (0, $kJ26n.newInvariantError)(71, definition.operation, definition.name ? " named '".concat(definition.name.value, "'") : "");
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        (0, $kJ26n.invariant)(fragments.length === 1, 72, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, document), {
        definitions: (0, $l73V3.__spreadArray)([
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function $cb27397a4448afe2$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $cb27397a4448afe2$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case "InlineFragment":
            return selection;
        case "FragmentSpread":
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            (0, $kJ26n.invariant)(fragment, 73, fragmentName);
            return fragment || null;
        default:
            return null;
    }
}

});

parcelRegister("gGpvG", function(module, exports) {

$parcel$export(module.exports, "canonicalStringify", function () { return $c2545b5aca48c577$export$88a0ad9b6f961b51; });

var $7L6nN = parcelRequire("7L6nN");
var $iOXJM = parcelRequire("iOXJM");

var $3qXPo = parcelRequire("3qXPo");
var $c2545b5aca48c577$export$88a0ad9b6f961b51 = Object.assign(function canonicalStringify(value) {
    return JSON.stringify(value, $c2545b5aca48c577$var$stableObjectReplacer);
}, {
    reset: function() {
        // Clearing the sortingMap will reclaim all cached memory, without
        // affecting the logical results of canonicalStringify, but potentially
        // sacrificing performance until the cache is refilled.
        $c2545b5aca48c577$var$sortingMap = new (0, $7L6nN.AutoCleanedStrongCache)((0, $iOXJM.cacheSizes).canonicalStringify || 1000 /* defaultCacheSizes.canonicalStringify */ );
    }
});
if (globalThis.__DEV__ !== false) (0, $3qXPo.registerGlobalCache)("canonicalStringify", function() {
    return $c2545b5aca48c577$var$sortingMap.size;
});
// Values are JSON-serialized arrays of object keys (in any order), and values
// are sorted arrays of the same keys.
var $c2545b5aca48c577$var$sortingMap;
$c2545b5aca48c577$export$88a0ad9b6f961b51.reset();
// The JSON.stringify function takes an optional second argument called a
// replacer function. This function is called for each key-value pair in the
// object being stringified, and its return value is used instead of the
// original value. If the replacer function returns a new value, that value is
// stringified as JSON instead of the original value of the property.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
function $c2545b5aca48c577$var$stableObjectReplacer(key, value) {
    if (value && typeof value === "object") {
        var proto = Object.getPrototypeOf(value);
        // We don't want to mess with objects that are not "plain" objects, which
        // means their prototype is either Object.prototype or null. This check also
        // prevents needlessly rearranging the indices of arrays.
        if (proto === Object.prototype || proto === null) {
            var keys = Object.keys(value);
            // If keys is already sorted, let JSON.stringify serialize the original
            // value instead of creating a new object with keys in the same order.
            if (keys.every($c2545b5aca48c577$var$everyKeyInOrder)) return value;
            var unsortedKey = JSON.stringify(keys);
            var sortedKeys = $c2545b5aca48c577$var$sortingMap.get(unsortedKey);
            if (!sortedKeys) {
                keys.sort();
                var sortedKey = JSON.stringify(keys);
                // Checking for sortedKey in the sortingMap allows us to share the same
                // sorted array reference for all permutations of the same set of keys.
                sortedKeys = $c2545b5aca48c577$var$sortingMap.get(sortedKey) || keys;
                $c2545b5aca48c577$var$sortingMap.set(unsortedKey, sortedKeys);
                $c2545b5aca48c577$var$sortingMap.set(sortedKey, sortedKeys);
            }
            var sortedObject_1 = Object.create(proto);
            // Reassigning the keys in sorted order will cause JSON.stringify to
            // serialize them in sorted order.
            sortedKeys.forEach(function(key) {
                sortedObject_1[key] = value[key];
            });
            return sortedObject_1;
        }
    }
    return value;
}
// Since everything that happens in stableObjectReplacer benefits from being as
// efficient as possible, we use a static function as the callback for
// keys.every in order to test if the provided keys are already sorted without
// allocating extra memory for a callback.
function $c2545b5aca48c577$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}

});




parcelRegister("8fyUO", function(module, exports) {

$parcel$export(module.exports, "validateOperation", function () { return $601acee52c605983$export$a92a48117d546c9; });
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");
function $601acee52c605983$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw (0, $kJ26n.newInvariantError)(43, key);
    }
    return operation;
}

});


parcelRegister("aBGMx", function(module, exports) {

$parcel$export(module.exports, "execute", function () { return $7b8e8ba622948b05$export$51396ec711da548b; });

var $bdl4J = parcelRequire("bdl4J");
var $7b8e8ba622948b05$export$51396ec711da548b = (0, $bdl4J.ApolloLink).execute;

});

parcelRegister("jMekh", function(module, exports) {

$parcel$export(module.exports, "HttpLink", function () { return $e65d9ce04ada1851$export$f4bbf1aec241cc1; });

var $l73V3 = parcelRequire("l73V3");

var $bdl4J = parcelRequire("bdl4J");

var $6D48U = parcelRequire("6D48U");
var $e65d9ce04ada1851$export$f4bbf1aec241cc1 = /** @class */ function(_super) {
    (0, $l73V3.__extends)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, $6D48U.createHttpLink)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, $bdl4J.ApolloLink));

});
parcelRegister("6D48U", function(module, exports) {

$parcel$export(module.exports, "createHttpLink", function () { return $4d39993f8ce1baad$export$95180a16573d6675; });

var $l73V3 = parcelRequire("l73V3");
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $bdl4J = parcelRequire("bdl4J");

var $29Gnu = parcelRequire("29Gnu");
var $iRdoS = parcelRequire("iRdoS");parcelRequire("cGdze");
var $a3uyB = parcelRequire("a3uyB");parcelRequire("5Xksu");
var $bMbZ0 = parcelRequire("bMbZ0");
var $2a3Iu = parcelRequire("2a3Iu");

var $gTTdj = parcelRequire("gTTdj");

var $1JmNc = parcelRequire("1JmNc");

var $1hxOH = parcelRequire("1hxOH");

var $f1IEM = parcelRequire("f1IEM");

var $dUbO8 = parcelRequire("dUbO8");

var $eok7C = parcelRequire("eok7C");

var $04YJ8 = parcelRequire("04YJ8");
var $jbfil = parcelRequire("jbfil");
var $4d39993f8ce1baad$var$backupFetch = (0, $a3uyB.maybe)(function() {
    return fetch;
});
var $4d39993f8ce1baad$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, // use default global fetch if nothing passed in
    preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? (0, $dUbO8.defaultPrinter) : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0, $l73V3.__rest)(linkOptions, [
        "uri",
        "fetch",
        "print",
        "includeExtensions",
        "preserveHeaderCase",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    if (globalThis.__DEV__ !== false) // Make sure at least one of preferredFetch, window.fetch, or backupFetch is
    // defined, so requests won't fail at runtime.
    (0, $f1IEM.checkFetcher)(preferredFetch || $4d39993f8ce1baad$var$backupFetch);
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions,
            preserveHeaderCase: preserveHeaderCase
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $bdl4J.ApolloLink)(function(operation) {
        var chosenURI = (0, $1JmNc.selectURI)(operation, uri);
        var context = operation.getContext();
        // `apollographql-client-*` headers are automatically set if a
        // `clientAwareness` object is found in the context. These headers are
        // set first, followed by the rest of the headers pulled from
        // `context.headers`. If desired, `apollographql-client-*` headers set by
        // the `clientAwareness` object can be overridden by
        // `apollographql-client-*` headers set in `context.headers`.
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders["apollographql-client-name"] = name_1;
            if (version) clientAwarenessHeaders["apollographql-client-version"] = version;
        }
        var contextHeaders = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        if ((0, $iRdoS.hasDirectives)([
            "client"
        ], operation.query)) {
            var transformedQuery = (0, $2a3Iu.removeClientSetsFromDocument)(operation.query);
            if (!transformedQuery) return (0, $jbfil.fromError)(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
            operation.query = transformedQuery;
        }
        //uses fallback, link, and then context to build options
        var _b = (0, $dUbO8.selectHttpOptionsAndBodyInternal)(operation, print, (0, $dUbO8.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) body.variables = (0, $04YJ8.filterOperationVariables)(body.variables, operation.query);
        var controller;
        if (!options.signal && typeof AbortController !== "undefined") {
            controller = new AbortController();
            options.signal = controller.signal;
        }
        // If requested, set method to GET if there are no mutations.
        var definitionIsMutation = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription((0, $29Gnu.getMainDefinition)(operation.query));
        // does not match custom directives beginning with @defer
        var hasDefer = (0, $iRdoS.hasDirectives)([
            "defer"
        ], operation.query);
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = "GET";
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            // Omit defer-specific headers if the user attempts to defer a selection
            // set on a subscription and log a warning.
            if (isSubscription && hasDefer) globalThis.__DEV__ !== false && (0, $kJ26n.invariant).warn(38);
            if (isSubscription) acceptHeader += "boundary=graphql;subscriptionSpec=1.0,application/json";
            else if (hasDefer) acceptHeader += "deferSpec=20220824,application/json";
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _c = (0, $eok7C.rewriteURIForGET)(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) return (0, $jbfil.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $gTTdj.serializeFetchParameter)(body, "Payload");
        } catch (parseError) {
            return (0, $jbfil.fromError)(parseError);
        }
        return new (0, $bMbZ0.Observable)(function(observer) {
            // Prefer linkOptions.fetch (preferredFetch) if provided, and otherwise
            // fall back to the *current* global window.fetch function (see issue
            // #7832), or (if all else fails) the backupFetch function we saved when
            // this module was first evaluated. This last option protects against the
            // removal of window.fetch, which is unlikely but not impossible.
            var currentFetch = preferredFetch || (0, $a3uyB.maybe)(function() {
                return fetch;
            }) || $4d39993f8ce1baad$var$backupFetch;
            var observerNext = observer.next.bind(observer);
            currentFetch(chosenURI, options).then(function(response) {
                var _a;
                operation.setContext({
                    response: response
                });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, $1hxOH.readMultipartBody)(response, observerNext);
                else return (0, $1hxOH.parseAndCheckHttpResponse)(operation)(response).then(observerNext);
            }).then(function() {
                controller = undefined;
                observer.complete();
            }).catch(function(err) {
                controller = undefined;
                (0, $1hxOH.handleError)(err, observer);
            });
            return function() {
                // XXX support canceling this request
                // https://developers.google.com/web/updates/2017/09/abortable-fetch
                if (controller) controller.abort();
            };
        });
    });
};

});
parcelRegister("iRdoS", function(module, exports) {

$parcel$export(module.exports, "shouldInclude", function () { return $dba7923f24b9f399$export$3dc388a5f013b4a5; });
$parcel$export(module.exports, "hasDirectives", function () { return $dba7923f24b9f399$export$2dafb573e282fe8d; });
$parcel$export(module.exports, "hasClientExports", function () { return $dba7923f24b9f399$export$8d1e9e5bbfa5d09a; });
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $gwqJN = parcelRequire("gwqJN");
function $dba7923f24b9f399$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $dba7923f24b9f399$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables && variables[ifArgument.value.name.value];
            (0, $kJ26n.invariant)(evaledValue !== void 0, 67, directive.name.value);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function $dba7923f24b9f399$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $gwqJN.visit)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
var $dba7923f24b9f399$export$528b5e7d8ba07fbf = function(names, root) {
    return $dba7923f24b9f399$export$2dafb573e282fe8d(names, root, false);
};
var $dba7923f24b9f399$export$ad1b63b26c1a9b76 = function(names, root) {
    return $dba7923f24b9f399$export$2dafb573e282fe8d(names, root, true);
};
function $dba7923f24b9f399$export$2dafb573e282fe8d(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0, $gwqJN.visit)(root, {
        Directive: function(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, $gwqJN.BREAK;
        }
    });
    // If we found all the names, nameSet will be empty. If we only care about
    // finding some of them, the < condition is sufficient.
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function $dba7923f24b9f399$export$8d1e9e5bbfa5d09a(document) {
    return document && $dba7923f24b9f399$export$2dafb573e282fe8d([
        "client",
        "export"
    ], document, true);
}
function $dba7923f24b9f399$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function $dba7923f24b9f399$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$dba7923f24b9f399$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $kJ26n.invariant)(directiveArguments && directiveArguments.length === 1, 68, directiveName);
        var ifArgument = directiveArguments[0];
        (0, $kJ26n.invariant)(ifArgument.name && ifArgument.name.value === "if", 69, directiveName);
        var ifValue = ifArgument.value;
        // means it has to be a variable value if this is a valid @skip or @include directive
        (0, $kJ26n.invariant)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 70, directiveName);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}

});
parcelRegister("gwqJN", function(module, exports) {

$parcel$export(module.exports, "BREAK", function () { return $e56fe1a8cf40f4b5$export$a89c95c098ac2a58; });
$parcel$export(module.exports, "visit", function () { return $e56fe1a8cf40f4b5$export$bf638b60ea8b89b7; });

var $hHpno = parcelRequire("hHpno");

var $1aask = parcelRequire("1aask");

var $1oqsB = parcelRequire("1oqsB");

var $kKcD5 = parcelRequire("kKcD5");
const $e56fe1a8cf40f4b5$export$a89c95c098ac2a58 = Object.freeze({});
function $e56fe1a8cf40f4b5$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $1oqsB.QueryDocumentKeys)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $kKcD5.Kind)))enterLeaveMap.set(kind, $e56fe1a8cf40f4b5$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $1oqsB.isNode)(node) || (0, $hHpno.devAssert)(false, `Invalid AST Node: ${(0, $1aask.inspect)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $e56fe1a8cf40f4b5$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $1oqsB.isNode)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $e56fe1a8cf40f4b5$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $kKcD5.Kind))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $e56fe1a8cf40f4b5$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $e56fe1a8cf40f4b5$export$a89c95c098ac2a58) skipping[i] = $e56fe1a8cf40f4b5$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $e56fe1a8cf40f4b5$export$a89c95c098ac2a58) skipping[i] = $e56fe1a8cf40f4b5$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $e56fe1a8cf40f4b5$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === "object") // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === "function") // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $e56fe1a8cf40f4b5$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $e56fe1a8cf40f4b5$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}

});


parcelRegister("2a3Iu", function(module, exports) {

$parcel$export(module.exports, "removeDirectivesFromDocument", function () { return $192f65f988b9d17f$export$e5ae0530da5fe96c; });
$parcel$export(module.exports, "addTypenameToDocument", function () { return $192f65f988b9d17f$export$43b332f87950a467; });
$parcel$export(module.exports, "buildQueryFromSelectionSet", function () { return $192f65f988b9d17f$export$57c368c23873f32b; });
$parcel$export(module.exports, "removeClientSetsFromDocument", function () { return $192f65f988b9d17f$export$8eae69e876ee321e; });

var $l73V3 = parcelRequire("l73V3");
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $kKcD5 = parcelRequire("kKcD5");
var $gwqJN = parcelRequire("gwqJN");

var $29Gnu = parcelRequire("29Gnu");

var $RzHRn = parcelRequire("RzHRn");

var $hrny3 = parcelRequire("hrny3");

var $2emDS = parcelRequire("2emDS");
var $192f65f988b9d17f$var$TYPENAME_FIELD = {
    kind: (0, $kKcD5.Kind).FIELD,
    name: {
        kind: (0, $kKcD5.Kind).NAME,
        value: "__typename"
    }
};
function $192f65f988b9d17f$var$isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function(selection) {
        return selection.kind === (0, $kKcD5.Kind).FRAGMENT_SPREAD && $192f65f988b9d17f$var$isEmpty(fragmentMap[selection.name.value], fragmentMap);
    });
}
function $192f65f988b9d17f$var$nullIfDocIsEmpty(doc) {
    return $192f65f988b9d17f$var$isEmpty((0, $29Gnu.getOperationDefinition)(doc) || (0, $29Gnu.getFragmentDefinition)(doc), (0, $hrny3.createFragmentMap)((0, $29Gnu.getFragmentDefinitions)(doc))) ? null : doc;
}
function $192f65f988b9d17f$var$getDirectiveMatcher(configs) {
    var names = new Map();
    var tests = new Map();
    configs.forEach(function(directive) {
        if (directive) {
            if (directive.name) names.set(directive.name, directive);
            else if (directive.test) tests.set(directive.test, directive);
        }
    });
    return function(directive) {
        var config = names.get(directive.name.value);
        if (!config && tests.size) tests.forEach(function(testConfig, test) {
            if (test(directive)) config = testConfig;
        });
        return config;
    };
}
function $192f65f988b9d17f$var$makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) key = defaultKey;
        var inUse = map.get(key);
        if (!inUse) map.set(key, inUse = {
            // Variable and fragment spread names used directly within this
            // operation or fragment definition, as identified by key. These sets
            // will be populated during the first traversal of the document in
            // removeDirectivesFromDocument below.
            variables: new Set(),
            fragmentSpreads: new Set()
        });
        return inUse;
    };
}
function $192f65f988b9d17f$export$e5ae0530da5fe96c(directives, doc) {
    (0, $29Gnu.checkDocument)(doc);
    // Passing empty strings to makeInUseGetterFunction means we handle anonymous
    // operations as if their names were "". Anonymous fragment definitions are
    // not supposed to be possible, but the same default naming strategy seems
    // appropriate for that case as well.
    var getInUseByOperationName = $192f65f988b9d17f$var$makeInUseGetterFunction("");
    var getInUseByFragmentName = $192f65f988b9d17f$var$makeInUseGetterFunction("");
    var getInUse = function(ancestors) {
        for(var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p){
            if ((0, $2emDS.isArray)(ancestor)) continue;
            if (ancestor.kind === (0, $kKcD5.Kind).OPERATION_DEFINITION) // If an operation is anonymous, we use the empty string as its key.
            return getInUseByOperationName(ancestor.name && ancestor.name.value);
            if (ancestor.kind === (0, $kKcD5.Kind).FRAGMENT_DEFINITION) return getInUseByFragmentName(ancestor.name.value);
        }
        globalThis.__DEV__ !== false && (0, $kJ26n.invariant).error(83);
        return null;
    };
    var operationCount = 0;
    for(var i = doc.definitions.length - 1; i >= 0; --i)if (doc.definitions[i].kind === (0, $kKcD5.Kind).OPERATION_DEFINITION) ++operationCount;
    var directiveMatcher = $192f65f988b9d17f$var$getDirectiveMatcher(directives);
    var shouldRemoveField = function(nodeDirectives) {
        return (0, $2emDS.isNonEmptyArray)(nodeDirectives) && nodeDirectives.map(directiveMatcher).some(function(config) {
            return config && config.remove;
        });
    };
    var originalFragmentDefsByPath = new Map();
    // Any time the first traversal of the document below makes a change like
    // removing a fragment (by returning null), this variable should be set to
    // true. Once it becomes true, it should never be set to false again. If this
    // variable remains false throughout the traversal, then we can return the
    // original doc immediately without any modifications.
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function(node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        }
    };
    var docWithoutDirectiveSubtrees = (0, $gwqJN.visit)(doc, {
        // These two AST node types share the same implementation, defined above.
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function() {
                // VariableDefinition nodes do not count as variables in use, though
                // they do contain Variable nodes that might be visited below. To avoid
                // counting variable declarations as usages, we skip visiting the
                // contents of this VariableDefinition node by returning false.
                return false;
            }
        },
        Variable: {
            enter: function(node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) inUse.variables.add(node.name.value);
            }
        },
        FragmentSpread: {
            enter: function(node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) inUse.fragmentSpreads.add(node.name.value);
            // We might like to remove this FragmentSpread by returning null here if
            // the corresponding FragmentDefinition node is also going to be removed
            // by the logic below, but we can't control the relative order of those
            // events, so we have to postpone the removal of dangling FragmentSpread
            // nodes until after the current visit of the document has finished.
            }
        },
        FragmentDefinition: {
            enter: function(node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function(node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) // If the FragmentNode received by this leave function is identical to
                // the one received by the corresponding enter function (above), then
                // the visitor must not have made any changes within this
                // FragmentDefinition node. This fragment definition may still be
                // removed if there are no ...spread references to it, but it won't be
                // removed just because it has only a __typename field.
                return node;
                if (// This logic applies only if the document contains one or more
                // operations, since removing all fragments from a document containing
                // only fragments makes the document useless.
                operationCount > 0 && node.selectionSet.selections.every(function(selection) {
                    return selection.kind === (0, $kKcD5.Kind).FIELD && selection.name.value === "__typename";
                })) {
                    // This is a somewhat opinionated choice: if a FragmentDefinition ends
                    // up having no fields other than __typename, we remove the whole
                    // fragment definition, and later prune ...spread references to it.
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        },
        Directive: {
            leave: function(node) {
                // If a matching directive is found, remove the directive itself. Note
                // that this does not remove the target (field, argument, etc) of the
                // directive, but only the directive itself.
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        }
    });
    if (!firstVisitMadeChanges) // If our first pass did not change anything about the document, then there
    // is no cleanup we need to do, and we can return the original doc.
    return doc;
    // Utility for making sure inUse.transitiveVars is recursively populated.
    // Because this logic assumes inUse.fragmentSpreads has been completely
    // populated and inUse.removed has been set if appropriate,
    // populateTransitiveVars must be called after that information has been
    // collected by the first traversal of the document.
    var populateTransitiveVars = function(inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) inUse.fragmentSpreads.forEach(function(childFragmentName) {
                populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function(varName) {
                    inUse.transitiveVars.add(varName);
                });
            });
        }
        return inUse;
    };
    // Since we've been keeping track of fragment spreads used by particular
    // operations and fragment definitions, we now need to compute the set of all
    // spreads used (transitively) by any operations in the document.
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function(def) {
        if (def.kind === (0, $kKcD5.Kind).OPERATION_DEFINITION) populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
        else if (def.kind === (0, $kKcD5.Kind).FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
        // definitions count as usages of their own fragment names. This heuristic
        // prevents accidentally removing all fragment definitions from the
        // document just because it contains no operations that use the fragments.
        operationCount === 0 && !getInUseByFragmentName(def.name.value).removed) allFragmentNamesUsed.add(def.name.value);
    });
    // Now that we have added all fragment spreads used by operations to the
    // allFragmentNamesUsed set, we can complete the set by transitively adding
    // all fragment spreads used by those fragments, and so on.
    allFragmentNamesUsed.forEach(function(fragmentName) {
        // Once all the childFragmentName strings added here have been seen already,
        // the top-level allFragmentNamesUsed.forEach loop will terminate.
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function(fragmentName) {
        return !!// A fragment definition will be removed if there are no spreads that refer
        // to it, or the fragment was explicitly removed because it had no fields
        // other than __typename.
        (!allFragmentNamesUsed.has(fragmentName) || getInUseByFragmentName(fragmentName).removed);
    };
    var enterVisitor = {
        enter: function(node) {
            if (fragmentWillBeRemoved(node.name.value)) return null;
        }
    };
    return $192f65f988b9d17f$var$nullIfDocIsEmpty((0, $gwqJN.visit)(docWithoutDirectiveSubtrees, {
        // If the fragment is going to be removed, then leaving any dangling
        // FragmentSpread nodes with the same name would be a mistake.
        FragmentSpread: enterVisitor,
        // This is where the fragment definition is actually removed.
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function(node) {
                // Upon leaving each operation in the depth-first AST traversal, prune
                // any variables that are declared by the operation but unused within.
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(// If an operation is anonymous, we use the empty string as its key.
                    getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    // According to the GraphQL spec, all variables declared by an
                    // operation must either be used by that operation or used by some
                    // fragment included transitively into that operation:
                    // https://spec.graphql.org/draft/#sec-All-Variables-Used
                    //
                    // To stay on the right side of this validation rule, if/when we
                    // remove the last $var references from an operation or its fragments,
                    // we must also remove the corresponding $var declaration from the
                    // enclosing operation. This pruning applies only to operations and
                    // not fragment definitions, at the moment. Fragments may be able to
                    // declare variables eventually, but today they can only consume them.
                    if (usedVariableNames_1.size < node.variableDefinitions.length) return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return usedVariableNames_1.has(varDef.variable.name.value);
                        })
                    });
                }
            }
        }
    }));
}
var $192f65f988b9d17f$export$43b332f87950a467 = Object.assign(function(doc) {
    return (0, $gwqJN.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, parent) {
                // Don't add __typename to OperationDefinitions.
                if (parent && parent.kind === (0, $kKcD5.Kind).OPERATION_DEFINITION) return;
                // No changes if no selections.
                var selections = node.selections;
                if (!selections) return;
                // If selections already have a __typename, or are part of an
                // introspection query, do nothing.
                var skip = selections.some(function(selection) {
                    return (0, $RzHRn.isField)(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                // If this SelectionSet is @export-ed as an input variable, it should
                // not have a __typename field (see issue #4691).
                var field = parent;
                if ((0, $RzHRn.isField)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                // Create and return a new SelectionSet with a __typename Field.
                return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, node), {
                    selections: (0, $l73V3.__spreadArray)((0, $l73V3.__spreadArray)([], selections, true), [
                        $192f65f988b9d17f$var$TYPENAME_FIELD
                    ], false)
                });
            }
        }
    });
}, {
    added: function(field) {
        return field === $192f65f988b9d17f$var$TYPENAME_FIELD;
    }
});
var $192f65f988b9d17f$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) {
            if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === "key";
            })) globalThis.__DEV__ !== false && (0, $kJ26n.invariant).warn(84);
        }
        return willRemove;
    }
};
function $192f65f988b9d17f$export$74985f3324559867(doc) {
    return $192f65f988b9d17f$export$e5ae0530da5fe96c([
        $192f65f988b9d17f$var$connectionRemoveConfig
    ], (0, $29Gnu.checkDocument)(doc));
}
function $192f65f988b9d17f$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $192f65f988b9d17f$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $192f65f988b9d17f$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $RzHRn.isField)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($192f65f988b9d17f$var$getDirectiveMatcher(directives)) || nestedCheck && $192f65f988b9d17f$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $192f65f988b9d17f$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === (0, $kKcD5.Kind).VARIABLE && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $192f65f988b9d17f$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $192f65f988b9d17f$var$getArgumentMatcher(config);
    return $192f65f988b9d17f$var$nullIfDocIsEmpty((0, $gwqJN.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, node), {
                    // Remove matching top level variables definitions.
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                // If `remove` is set to true for an argument, and an argument match
                // is found for a field, remove the field as well.
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                // Remove all matching arguments.
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $192f65f988b9d17f$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $192f65f988b9d17f$var$nullIfDocIsEmpty((0, $gwqJN.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $192f65f988b9d17f$export$57c368c23873f32b(document) {
    var definition = (0, $29Gnu.getMainDefinition)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") // Already a query, so return the existing document.
    return document;
    // Build a new query using the selection set of the main operation.
    var modifiedDoc = (0, $gwqJN.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function $192f65f988b9d17f$export$8eae69e876ee321e(document) {
    (0, $29Gnu.checkDocument)(document);
    var modifiedDoc = $192f65f988b9d17f$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    return modifiedDoc;
}

});

parcelRegister("gTTdj", function(module, exports) {

$parcel$export(module.exports, "serializeFetchParameter", function () { return $c4dc9caebe3ecb15$export$5f8e80ac52052e28; });
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");
var $c4dc9caebe3ecb15$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = (0, $kJ26n.newInvariantError)(39, label, e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};

});

parcelRegister("1JmNc", function(module, exports) {

$parcel$export(module.exports, "selectURI", function () { return $142bac8566ba79ba$export$63ccc2571850f81a; });
var $142bac8566ba79ba$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};

});

parcelRegister("1hxOH", function(module, exports) {

$parcel$export(module.exports, "readMultipartBody", function () { return $0ef19c4411b38826$export$ccb60864026baf09; });
$parcel$export(module.exports, "handleError", function () { return $0ef19c4411b38826$export$d3da1ecaf1206c58; });
$parcel$export(module.exports, "parseAndCheckHttpResponse", function () { return $0ef19c4411b38826$export$d4051215bea0639f; });

var $l73V3 = parcelRequire("l73V3");

var $5GQHc = parcelRequire("5GQHc");

var $9vdJj = parcelRequire("9vdJj");

var $408uN = parcelRequire("408uN");

var $kavKO = parcelRequire("kavKO");
var $0ef19c4411b38826$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $0ef19c4411b38826$export$ccb60864026baf09(response, nextValue) {
    var _a;
    return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _b, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _c, _d;
        return (0, $l73V3.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    if (TextDecoder === undefined) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    decoder = new TextDecoder("utf-8");
                    contentType = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = (0, $5GQHc.responseIterator)(response);
                    running = true;
                    _e.label = 1;
                case 1:
                    if (!running) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        iterator.next()
                    ];
                case 2:
                    _b = _e.sent(), value = _b.value, done = _b.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while(bi > -1){
                        message = void 0;
                        _c = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length)
                        ], message = _c[0], buffer = _c[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = $0ef19c4411b38826$export$eea2c1c5e1a37e50(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                        body = message.slice(i);
                        if (body) {
                            result = $0ef19c4411b38826$export$759bcb35b0d1bf81(response, body);
                            if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result || "payload" in result) {
                                if ((0, $kavKO.isApolloPayloadResult)(result)) {
                                    next = {};
                                    if ("payload" in result) next = (0, $l73V3.__assign)({}, result.payload);
                                    if ("errors" in result) next = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, next), {
                                        extensions: (0, $l73V3.__assign)((0, $l73V3.__assign)({}, "extensions" in next ? next.extensions : null), (_d = {}, _d[0, $408uN.PROTOCOL_ERRORS_SYMBOL] = result.errors, _d))
                                    });
                                    nextValue(next);
                                } else // for the last chunk with only `hasNext: false`
                                // we don't need to call observer.next as there is no data/errors
                                nextValue(result);
                            } else if (// If the chunk contains only a "hasNext: false", we can call
                            // observer.complete() immediately.
                            Object.keys(result).length === 1 && "hasNext" in result && !result.hasNext) return [
                                2 /*return*/ 
                            ];
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $0ef19c4411b38826$export$eea2c1c5e1a37e50(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function(line) {
        var i = line.indexOf(":");
        if (i > -1) {
            // normalize headers to lowercase
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function $0ef19c4411b38826$export$759bcb35b0d1bf81(response, bodyText) {
    if (response.status >= 300) {
        // Network error
        var getResult = function() {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                return bodyText;
            }
        };
        (0, $9vdJj.throwServerError)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function $0ef19c4411b38826$export$d3da1ecaf1206c58(err, observer) {
    // if it is a network error, BUT there is graphql result info fire
    // the next observer before calling error this gives apollo-client
    // (and react-apollo) the `graphqlErrors` and `networkErrors` to
    // pass to UI this should only happen if we *also* have data as
    // part of the response key per the spec
    if (err.result && err.result.errors && err.result.data) // if we don't call next, the UI can only show networkError
    // because AC didn't get any graphqlErrors this is graphql
    // execution result info (i.e errors and possibly data) this is
    // because there is no formal spec how errors should translate to
    // http status codes. So an auth error (401) could have both data
    // from a public field, errors from a private field, and a status
    // of 401
    // {
    //  user { // this will have errors
    //    firstName
    //  }
    //  products { // this is public so will have data
    //    cost
    //  }
    // }
    //
    // the result of above *could* look like this:
    // {
    //   data: { products: [{ cost: "$10" }] },
    //   errors: [{
    //      message: 'your session has timed out',
    //      path: []
    //   }]
    // }
    // status code of above would be a 401
    // in the UI you want to show data where you can, errors as data where you can
    // and use correct http status codes
    observer.next(err.result);
    observer.error(err);
}
function $0ef19c4411b38826$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            return $0ef19c4411b38826$export$759bcb35b0d1bf81(response, bodyText);
        }).then(function(result) {
            if (!Array.isArray(result) && !$0ef19c4411b38826$var$hasOwnProperty.call(result, "data") && !$0ef19c4411b38826$var$hasOwnProperty.call(result, "errors")) // Data error
            (0, $9vdJj.throwServerError)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName, "'."));
            return result;
        });
    };
}

});
parcelRegister("5GQHc", function(module, exports) {

$parcel$export(module.exports, "responseIterator", function () { return $4249c04c732511cb$export$7e4ac9ed9577f145; });
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/index.ts
 */ 
var $8L3vO = parcelRequire("8L3vO");

var $bbXOM = parcelRequire("bbXOM");

var $dzyZ4 = parcelRequire("dzyZ4");

var $g8YIp = parcelRequire("g8YIp");

var $8mze2 = parcelRequire("8mze2");
function $4249c04c732511cb$var$isNodeResponse(value) {
    return !!value.body;
}
function $4249c04c732511cb$var$isReadableStream(value) {
    return !!value.getReader;
}
function $4249c04c732511cb$var$isAsyncIterableIterator(value) {
    return !!((0, $8L3vO.canUseAsyncIteratorSymbol) && value[Symbol.asyncIterator]);
}
function $4249c04c732511cb$var$isStreamableBlob(value) {
    return !!value.stream;
}
function $4249c04c732511cb$var$isBlob(value) {
    return !!value.arrayBuffer;
}
function $4249c04c732511cb$var$isNodeReadableStream(value) {
    return !!value.pipe;
}
function $4249c04c732511cb$export$7e4ac9ed9577f145(response) {
    var body = response;
    if ($4249c04c732511cb$var$isNodeResponse(response)) body = response.body;
    if ($4249c04c732511cb$var$isAsyncIterableIterator(body)) return (0, $bbXOM.default)(body);
    if ($4249c04c732511cb$var$isReadableStream(body)) return (0, $8mze2.default)(body.getReader());
    // this errors without casting to ReadableStream<T>
    // because Blob.stream() returns a NodeJS ReadableStream
    if ($4249c04c732511cb$var$isStreamableBlob(body)) return (0, $8mze2.default)(body.stream().getReader());
    if ($4249c04c732511cb$var$isBlob(body)) return (0, $g8YIp.default)(body.arrayBuffer());
    if ($4249c04c732511cb$var$isNodeReadableStream(body)) return (0, $dzyZ4.default)(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}

});
parcelRegister("bbXOM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $825f1f6173fa2f74$export$2e2bcd8739ae039; });
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/async.ts
 */ function $825f1f6173fa2f74$export$2e2bcd8739ae039(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
        next: function() {
            return iterator.next();
        }
    }, _a[Symbol.asyncIterator] = function() {
        return this;
    }, _a;
}

});

parcelRegister("dzyZ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e19ae5809239d74$export$2e2bcd8739ae039; });
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/nodeStream.ts
 */ 
var $8L3vO = parcelRequire("8L3vO");
function $9e19ae5809239d74$export$2e2bcd8739ae039(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error) return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) return shiftedArr[0]({
                value: chunk,
                done: false
            });
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[0]({
                value: undefined,
                done: true
            });
        });
        !cleanup || cleanup();
    }
    cleanup = function() {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function(resolve, reject) {
            if (error) return reject(error);
            if (data.length) return resolve({
                value: data.shift(),
                done: false
            });
            if (done) return resolve({
                value: undefined,
                done: true
            });
            waiting.push([
                resolve,
                reject
            ]);
        });
    }
    var iterator = {
        next: function() {
            return getNext();
        }
    };
    if (0, $8L3vO.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

});

parcelRegister("g8YIp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc0c7d8093eb35e9$export$2e2bcd8739ae039; });
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/promise.ts
 */ 
var $8L3vO = parcelRequire("8L3vO");
function $bc0c7d8093eb35e9$export$2e2bcd8739ae039(promise) {
    var resolved = false;
    var iterator = {
        next: function() {
            if (resolved) return Promise.resolve({
                value: undefined,
                done: true
            });
            resolved = true;
            return new Promise(function(resolve, reject) {
                promise.then(function(value) {
                    resolve({
                        value: value,
                        done: false
                    });
                }).catch(reject);
            });
        }
    };
    if (0, $8L3vO.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

});

parcelRegister("8mze2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $616bb3d826e84749$export$2e2bcd8739ae039; });
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/reader.ts
 */ 
var $8L3vO = parcelRequire("8L3vO");
function $616bb3d826e84749$export$2e2bcd8739ae039(reader) {
    var iterator = {
        next: function() {
            return reader.read();
        }
    };
    if (0, $8L3vO.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

});


parcelRegister("9vdJj", function(module, exports) {

$parcel$export(module.exports, "throwServerError", function () { return $6eb1a8cb22b088f8$export$c33ef9219f27efd7; });
var $6eb1a8cb22b088f8$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};

});

parcelRegister("kavKO", function(module, exports) {

$parcel$export(module.exports, "isExecutionPatchIncrementalResult", function () { return $eaed5f7cbb3cc45d$export$879767c5cdf33cb3; });
$parcel$export(module.exports, "isExecutionPatchResult", function () { return $eaed5f7cbb3cc45d$export$f90dc0a3531b8b83; });
$parcel$export(module.exports, "isApolloPayloadResult", function () { return $eaed5f7cbb3cc45d$export$3f32b6369f408f33; });
$parcel$export(module.exports, "mergeIncrementalData", function () { return $eaed5f7cbb3cc45d$export$9a905f57d6393874; });

var $dmNot = parcelRequire("dmNot");

var $2emDS = parcelRequire("2emDS");

var $bYdjZ = parcelRequire("bYdjZ");
function $eaed5f7cbb3cc45d$export$879767c5cdf33cb3(value) {
    return "incremental" in value;
}
function $eaed5f7cbb3cc45d$export$6c17a45d8c64ff02(value) {
    return "hasNext" in value && "data" in value;
}
function $eaed5f7cbb3cc45d$export$f90dc0a3531b8b83(value) {
    return $eaed5f7cbb3cc45d$export$879767c5cdf33cb3(value) || $eaed5f7cbb3cc45d$export$6c17a45d8c64ff02(value);
}
function $eaed5f7cbb3cc45d$export$3f32b6369f408f33(value) {
    return (0, $dmNot.isNonNullObject)(value) && "payload" in value;
}
function $eaed5f7cbb3cc45d$export$9a905f57d6393874(prevResult, result) {
    var mergedData = prevResult;
    var merger = new (0, $bYdjZ.DeepMerger)();
    if ($eaed5f7cbb3cc45d$export$879767c5cdf33cb3(result) && (0, $2emDS.isNonEmptyArray)(result.incremental)) result.incremental.forEach(function(_a) {
        var data = _a.data, path = _a.path;
        for(var i = path.length - 1; i >= 0; --i){
            var key = path[i];
            var isNumericKey = !isNaN(+key);
            var parent_1 = isNumericKey ? [] : {};
            parent_1[key] = data;
            data = parent_1;
        }
        mergedData = merger.merge(mergedData, data);
    });
    return mergedData;
}

});
parcelRegister("bYdjZ", function(module, exports) {

$parcel$export(module.exports, "mergeDeep", function () { return $8b6fa1a62c026a08$export$dd702b3c8240390c; });
$parcel$export(module.exports, "mergeDeepArray", function () { return $8b6fa1a62c026a08$export$160070228be94b08; });
$parcel$export(module.exports, "DeepMerger", function () { return $8b6fa1a62c026a08$export$509e11c221f576c0; });

var $l73V3 = parcelRequire("l73V3");

var $dmNot = parcelRequire("dmNot");
var $8b6fa1a62c026a08$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $8b6fa1a62c026a08$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $8b6fa1a62c026a08$export$160070228be94b08(sources);
}
function $8b6fa1a62c026a08$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $8b6fa1a62c026a08$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
var $8b6fa1a62c026a08$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $8b6fa1a62c026a08$export$509e11c221f576c0 = /** @class */ function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $8b6fa1a62c026a08$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = (0, $dmNot.isNonNullObject);
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ((0, $dmNot.isNonNullObject)(source) && (0, $dmNot.isNonNullObject)(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($8b6fa1a62c026a08$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $l73V3.__spreadArray)([
                            target,
                            source,
                            sourceKey
                        ], context, false));
                        // A well-implemented reconciler may return targetValue to indicate
                        // the merge changed nothing about the structure of the target.
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    // If there is no collision, the target can safely share memory with
                    // the source, and the recursion can terminate here.
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        // If source (or target) is not an object, let source replace target.
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ((0, $dmNot.isNonNullObject)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = (0, $l73V3.__assign)({
                    __proto__: Object.getPrototypeOf(value)
                }, value);
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}();

});



parcelRegister("f1IEM", function(module, exports) {

$parcel$export(module.exports, "checkFetcher", function () { return $af0996ee5783930b$export$8423f0cd3773115e; });
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");
var $af0996ee5783930b$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === "undefined") throw (0, $kJ26n.newInvariantError)(37);
};

});

parcelRegister("dUbO8", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", function () { return $a1f9aa10afa028bc$export$dd86f00dc866e75d; });
$parcel$export(module.exports, "defaultPrinter", function () { return $a1f9aa10afa028bc$export$e88934976ca4fd65; });
$parcel$export(module.exports, "selectHttpOptionsAndBody", function () { return $a1f9aa10afa028bc$export$a00ebfd5f1eebfb1; });
$parcel$export(module.exports, "selectHttpOptionsAndBodyInternal", function () { return $a1f9aa10afa028bc$export$12d90ccf75844275; });

var $l73V3 = parcelRequire("l73V3");

var $3owxW = parcelRequire("3owxW");
var $a1f9aa10afa028bc$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false
};
var $a1f9aa10afa028bc$var$defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "*/*",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json"
};
var $a1f9aa10afa028bc$var$defaultOptions = {
    method: "POST"
};
var $a1f9aa10afa028bc$export$dd86f00dc866e75d = {
    http: $a1f9aa10afa028bc$var$defaultHttpOptions,
    headers: $a1f9aa10afa028bc$var$defaultHeaders,
    options: $a1f9aa10afa028bc$var$defaultOptions
};
var $a1f9aa10afa028bc$export$e88934976ca4fd65 = function(ast, printer) {
    return printer(ast);
};
function $a1f9aa10afa028bc$export$a00ebfd5f1eebfb1(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    configs.unshift(fallbackConfig);
    return $a1f9aa10afa028bc$export$12d90ccf75844275.apply(void 0, (0, $l73V3.__spreadArray)([
        operation,
        $a1f9aa10afa028bc$export$e88934976ca4fd65
    ], configs, false));
}
function $a1f9aa10afa028bc$export$12d90ccf75844275(operation, printer) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = {};
    var http = {};
    configs.forEach(function(config) {
        options = (0, $l73V3.__assign)((0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), config.options), {
            headers: (0, $l73V3.__assign)((0, $l73V3.__assign)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, http), config.http);
    });
    if (options.headers) options.headers = $a1f9aa10afa028bc$var$removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery) body.query = printer(query, (0, $3owxW.print));
    return {
        options: options,
        body: body
    };
}
// Remove potential duplicate header names, preserving last (by insertion order).
// This is done to prevent unintentionally duplicating a header instead of
// overwriting it (See #8447 and #8449).
function $a1f9aa10afa028bc$var$removeDuplicateHeaders(headers, preserveHeaderCase) {
    // If we're not preserving the case, just remove duplicates w/ normalization.
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function(name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    // If we are preserving the case, remove duplicates w/ normalization,
    // preserving the original name.
    // This allows for non-http-spec-compliant servers that expect intentionally
    // capitalized header names (See #6741).
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function(name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function(name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}

});
parcelRegister("3owxW", function(module, exports) {

$parcel$export(module.exports, "print", function () { return $278cdc095ac62095$export$c2d084dc44961371; });

var $5R27n = parcelRequire("5R27n");

var $7L6nN = parcelRequire("7L6nN");
var $iOXJM = parcelRequire("iOXJM");

var $3qXPo = parcelRequire("3qXPo");
var $278cdc095ac62095$var$printCache;
var $278cdc095ac62095$export$c2d084dc44961371 = Object.assign(function(ast) {
    var result = $278cdc095ac62095$var$printCache.get(ast);
    if (!result) {
        result = (0, $5R27n.print)(ast);
        $278cdc095ac62095$var$printCache.set(ast, result);
    }
    return result;
}, {
    reset: function() {
        $278cdc095ac62095$var$printCache = new (0, $7L6nN.AutoCleanedWeakCache)((0, $iOXJM.cacheSizes).print || 2000 /* defaultCacheSizes.print */ );
    }
});
$278cdc095ac62095$export$c2d084dc44961371.reset();
if (globalThis.__DEV__ !== false) (0, $3qXPo.registerGlobalCache)("print", function() {
    return $278cdc095ac62095$var$printCache ? $278cdc095ac62095$var$printCache.size : 0;
});

});
parcelRegister("5R27n", function(module, exports) {

$parcel$export(module.exports, "print", function () { return $52eb5fe94d9527de$export$c2d084dc44961371; });

var $7M3sn = parcelRequire("7M3sn");

var $6E1UJ = parcelRequire("6E1UJ");

var $gwqJN = parcelRequire("gwqJN");
function $52eb5fe94d9527de$export$c2d084dc44961371(ast) {
    return (0, $gwqJN.visit)(ast, $52eb5fe94d9527de$var$printDocASTReducer);
}
const $52eb5fe94d9527de$var$MAX_LINE_LENGTH = 80;
const $52eb5fe94d9527de$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>"$" + node.name
    },
    // Document
    Document: {
        leave: (node)=>$52eb5fe94d9527de$var$join(node.definitions, "\n\n")
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $52eb5fe94d9527de$var$wrap("(", $52eb5fe94d9527de$var$join(node.variableDefinitions, ", "), ")");
            const prefix = $52eb5fe94d9527de$var$join([
                node.operation,
                $52eb5fe94d9527de$var$join([
                    node.name,
                    varDefs
                ]),
                $52eb5fe94d9527de$var$join(node.directives, " ")
            ], " "); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ": " + type + $52eb5fe94d9527de$var$wrap(" = ", defaultValue) + $52eb5fe94d9527de$var$wrap(" ", $52eb5fe94d9527de$var$join(directives, " "))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$52eb5fe94d9527de$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $52eb5fe94d9527de$var$wrap("", alias, ": ") + name;
            let argsLine = prefix + $52eb5fe94d9527de$var$wrap("(", $52eb5fe94d9527de$var$join(args, ", "), ")");
            if (argsLine.length > $52eb5fe94d9527de$var$MAX_LINE_LENGTH) argsLine = prefix + $52eb5fe94d9527de$var$wrap("(\n", $52eb5fe94d9527de$var$indent($52eb5fe94d9527de$var$join(args, "\n")), "\n)");
            return $52eb5fe94d9527de$var$join([
                argsLine,
                $52eb5fe94d9527de$var$join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>"..." + name + $52eb5fe94d9527de$var$wrap(" ", $52eb5fe94d9527de$var$join(directives, " "))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$52eb5fe94d9527de$var$join([
                "...",
                $52eb5fe94d9527de$var$wrap("on ", typeCondition),
                $52eb5fe94d9527de$var$join(directives, " "),
                selectionSet
            ], " ")
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$52eb5fe94d9527de$var$wrap("(", $52eb5fe94d9527de$var$join(variableDefinitions, ", "), ")")} ` + `on ${typeCondition} ${$52eb5fe94d9527de$var$wrap("", $52eb5fe94d9527de$var$join(directives, " "), " ")}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $7M3sn.printBlockString)(value) : (0, $6E1UJ.printString)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? "true" : "false"
    },
    NullValue: {
        leave: ()=>"null"
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>"[" + $52eb5fe94d9527de$var$join(values, ", ") + "]"
    },
    ObjectValue: {
        leave: ({ fields: fields })=>"{" + $52eb5fe94d9527de$var$join(fields, ", ") + "}"
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>"@" + name + $52eb5fe94d9527de$var$wrap("(", $52eb5fe94d9527de$var$join(args, ", "), ")")
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>"[" + type + "]"
    },
    NonNullType: {
        leave: ({ type: type })=>type + "!"
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$52eb5fe94d9527de$var$wrap("", description, "\n") + $52eb5fe94d9527de$var$join([
                "schema",
                $52eb5fe94d9527de$var$join(directives, " "),
                $52eb5fe94d9527de$var$block(operationTypes)
            ], " ")
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ": " + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$52eb5fe94d9527de$var$wrap("", description, "\n") + $52eb5fe94d9527de$var$join([
                "scalar",
                name,
                $52eb5fe94d9527de$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$52eb5fe94d9527de$var$wrap("", description, "\n") + $52eb5fe94d9527de$var$join([
                "type",
                name,
                $52eb5fe94d9527de$var$wrap("implements ", $52eb5fe94d9527de$var$join(interfaces, " & ")),
                $52eb5fe94d9527de$var$join(directives, " "),
                $52eb5fe94d9527de$var$block(fields)
            ], " ")
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$52eb5fe94d9527de$var$wrap("", description, "\n") + name + ($52eb5fe94d9527de$var$hasMultilineItems(args) ? $52eb5fe94d9527de$var$wrap("(\n", $52eb5fe94d9527de$var$indent($52eb5fe94d9527de$var$join(args, "\n")), "\n)") : $52eb5fe94d9527de$var$wrap("(", $52eb5fe94d9527de$var$join(args, ", "), ")")) + ": " + type + $52eb5fe94d9527de$var$wrap(" ", $52eb5fe94d9527de$var$join(directives, " "))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$52eb5fe94d9527de$var$wrap("", description, "\n") + $52eb5fe94d9527de$var$join([
                name + ": " + type,
                $52eb5fe94d9527de$var$wrap("= ", defaultValue),
                $52eb5fe94d9527de$var$join(directives, " ")
            ], " ")
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$52eb5fe94d9527de$var$wrap("", description, "\n") + $52eb5fe94d9527de$var$join([
                "interface",
                name,
                $52eb5fe94d9527de$var$wrap("implements ", $52eb5fe94d9527de$var$join(interfaces, " & ")),
                $52eb5fe94d9527de$var$join(directives, " "),
                $52eb5fe94d9527de$var$block(fields)
            ], " ")
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$52eb5fe94d9527de$var$wrap("", description, "\n") + $52eb5fe94d9527de$var$join([
                "union",
                name,
                $52eb5fe94d9527de$var$join(directives, " "),
                $52eb5fe94d9527de$var$wrap("= ", $52eb5fe94d9527de$var$join(types, " | "))
            ], " ")
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$52eb5fe94d9527de$var$wrap("", description, "\n") + $52eb5fe94d9527de$var$join([
                "enum",
                name,
                $52eb5fe94d9527de$var$join(directives, " "),
                $52eb5fe94d9527de$var$block(values)
            ], " ")
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$52eb5fe94d9527de$var$wrap("", description, "\n") + $52eb5fe94d9527de$var$join([
                name,
                $52eb5fe94d9527de$var$join(directives, " ")
            ], " ")
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$52eb5fe94d9527de$var$wrap("", description, "\n") + $52eb5fe94d9527de$var$join([
                "input",
                name,
                $52eb5fe94d9527de$var$join(directives, " "),
                $52eb5fe94d9527de$var$block(fields)
            ], " ")
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$52eb5fe94d9527de$var$wrap("", description, "\n") + "directive @" + name + ($52eb5fe94d9527de$var$hasMultilineItems(args) ? $52eb5fe94d9527de$var$wrap("(\n", $52eb5fe94d9527de$var$indent($52eb5fe94d9527de$var$join(args, "\n")), "\n)") : $52eb5fe94d9527de$var$wrap("(", $52eb5fe94d9527de$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $52eb5fe94d9527de$var$join(locations, " | ")
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$52eb5fe94d9527de$var$join([
                "extend schema",
                $52eb5fe94d9527de$var$join(directives, " "),
                $52eb5fe94d9527de$var$block(operationTypes)
            ], " ")
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$52eb5fe94d9527de$var$join([
                "extend scalar",
                name,
                $52eb5fe94d9527de$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$52eb5fe94d9527de$var$join([
                "extend type",
                name,
                $52eb5fe94d9527de$var$wrap("implements ", $52eb5fe94d9527de$var$join(interfaces, " & ")),
                $52eb5fe94d9527de$var$join(directives, " "),
                $52eb5fe94d9527de$var$block(fields)
            ], " ")
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$52eb5fe94d9527de$var$join([
                "extend interface",
                name,
                $52eb5fe94d9527de$var$wrap("implements ", $52eb5fe94d9527de$var$join(interfaces, " & ")),
                $52eb5fe94d9527de$var$join(directives, " "),
                $52eb5fe94d9527de$var$block(fields)
            ], " ")
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$52eb5fe94d9527de$var$join([
                "extend union",
                name,
                $52eb5fe94d9527de$var$join(directives, " "),
                $52eb5fe94d9527de$var$wrap("= ", $52eb5fe94d9527de$var$join(types, " | "))
            ], " ")
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$52eb5fe94d9527de$var$join([
                "extend enum",
                name,
                $52eb5fe94d9527de$var$join(directives, " "),
                $52eb5fe94d9527de$var$block(values)
            ], " ")
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$52eb5fe94d9527de$var$join([
                "extend input",
                name,
                $52eb5fe94d9527de$var$join(directives, " "),
                $52eb5fe94d9527de$var$block(fields)
            ], " ")
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $52eb5fe94d9527de$var$join(maybeArray, separator = "") {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $52eb5fe94d9527de$var$block(array) {
    return $52eb5fe94d9527de$var$wrap("{\n", $52eb5fe94d9527de$var$indent($52eb5fe94d9527de$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $52eb5fe94d9527de$var$wrap(start, maybeString, end = "") {
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $52eb5fe94d9527de$var$indent(str) {
    return $52eb5fe94d9527de$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $52eb5fe94d9527de$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes("\n"))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}

});
parcelRegister("6E1UJ", function(module, exports) {

$parcel$export(module.exports, "printString", function () { return $3a245644ef2ad03a$export$3cdec7cf614a0ecc; });
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $3a245644ef2ad03a$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($3a245644ef2ad03a$var$escapedRegExp, $3a245644ef2ad03a$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $3a245644ef2ad03a$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $3a245644ef2ad03a$var$escapedReplacer(str) {
    return $3a245644ef2ad03a$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $3a245644ef2ad03a$var$escapeSequences = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
];

});




parcelRegister("eok7C", function(module, exports) {

$parcel$export(module.exports, "rewriteURIForGET", function () { return $a7a2ea5f09fef9d9$export$fb82bb094b6f76b5; });

var $gTTdj = parcelRequire("gTTdj");
function $a7a2ea5f09fef9d9$export$fb82bb094b6f76b5(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $gTTdj.serializeFetchParameter)(body.variables, "Variables map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $gTTdj.serializeFetchParameter)(body.extensions, "Extensions map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}

});

parcelRegister("04YJ8", function(module, exports) {

$parcel$export(module.exports, "filterOperationVariables", function () { return $00ef7af359bb663a$export$de246493ae27fe3f; });

var $l73V3 = parcelRequire("l73V3");

var $gwqJN = parcelRequire("gwqJN");
function $00ef7af359bb663a$export$de246493ae27fe3f(variables, query) {
    var result = (0, $l73V3.__assign)({}, variables);
    var unusedNames = new Set(Object.keys(variables));
    (0, $gwqJN.visit)(query, {
        Variable: function(node, _key, parent) {
            // A variable type definition at the top level of a query is not
            // enough to silence server-side errors about the variable being
            // unused, so variable definitions do not count as usage.
            // https://spec.graphql.org/draft/#sec-All-Variables-Used
            if (parent && parent.kind !== "VariableDefinition") unusedNames.delete(node.name.value);
        }
    });
    unusedNames.forEach(function(name) {
        delete result[name];
    });
    return result;
}

});

parcelRegister("jbfil", function(module, exports) {

$parcel$export(module.exports, "fromError", function () { return $df6ae8a3b3894f14$export$4fd972edbe7450d3; });
parcelRequire("5Xksu");
var $bMbZ0 = parcelRequire("bMbZ0");
function $df6ae8a3b3894f14$export$4fd972edbe7450d3(errorValue) {
    return new (0, $bMbZ0.Observable)(function(observer) {
        observer.error(errorValue);
    });
}

});



parcelRegister("hF1vZ", function(module, exports) {

$parcel$export(module.exports, "QueryManager", function () { return $cdb770d6b0b54ae0$export$b986383a50b53ea4; });

var $l73V3 = parcelRequire("l73V3");
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $62dod = parcelRequire("62dod");

var $aBGMx = parcelRequire("aBGMx");

var $dvQ3t = parcelRequire("dvQ3t");
var $7L6nN = parcelRequire("7L6nN");
var $iOXJM = parcelRequire("iOXJM");
var $cBe3I = parcelRequire("cBe3I");
var $ipGXK = parcelRequire("ipGXK");
var $29Gnu = parcelRequire("29Gnu");
var $fjRIS = parcelRequire("fjRIS");
var $iRdoS = parcelRequire("iRdoS");
var $RzHRn = parcelRequire("RzHRn");
var $kavKO = parcelRequire("kavKO");
var $2emDS = parcelRequire("2emDS");
var $dmNot = parcelRequire("dmNot");
var $7AXen = parcelRequire("7AXen");parcelRequire("5Xksu");
var $bMbZ0 = parcelRequire("bMbZ0");
var $3owxW = parcelRequire("3owxW");
var $2a3Iu = parcelRequire("2a3Iu");

var $gGpvG = parcelRequire("gGpvG");

var $kavKO = parcelRequire("kavKO");

var $408uN = parcelRequire("408uN");

var $holO6 = parcelRequire("holO6");

var $8LKEl = parcelRequire("8LKEl");

var $eLbT8 = parcelRequire("eLbT8");

var $hXKAm = parcelRequire("hXKAm");

var $1U0aA = parcelRequire("1U0aA");
var $cdb770d6b0b54ae0$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $cdb770d6b0b54ae0$var$IGNORE = Object.create(null);
var $cdb770d6b0b54ae0$export$b986383a50b53ea4 = /** @class */ function() {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, documentTransform = _a.documentTransform, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, _e = _a.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? !!cache.assumeImmutableResults : _e, defaultContext = _a.defaultContext;
        var _this = this;
        this.clientAwareness = {};
        // All the queries that the QueryManager is currently managing (not
        // including mutations and subscriptions).
        this.queries = new Map();
        // Maps from queryId strings to Promise rejection functions for
        // currently active queries and fetches.
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.fetchCancelFns = new Map();
        this.transformCache = new (0, $7L6nN.AutoCleanedWeakCache)((0, $iOXJM.cacheSizes)["queryManager.getDocumentInfo"] || 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ );
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.inFlightLinkObservables = new (0, $1U0aA.Trie)(false);
        var defaultDocumentTransform = new (0, $ipGXK.DocumentTransform)(function(document) {
            return _this.cache.transformDocument(document);
        }, // Allow the apollo cache to manage its own transform caches
        {
            cache: false
        });
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new (0, $eLbT8.LocalState)({
            cache: cache
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = assumeImmutableResults;
        this.documentTransform = documentTransform ? defaultDocumentTransform.concat(documentTransform)// The custom document transform may add new fragment spreads or new
        // field selections, so we want to give the cache a chance to run
        // again. For example, the InMemoryCache adds __typename to field
        // selections and fragments from the fragment registry.
        .concat(defaultDocumentTransform) : defaultDocumentTransform;
        this.defaultContext = defaultContext || Object.create(null);
        if (this.onBroadcast = onBroadcast) this.mutationStore = Object.create(null);
    }
    /**
     * Call this method to terminate any active query processes, making it safe
     * to dispose of this QueryManager instance.
     */ QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches((0, $kJ26n.newInvariantError)(25));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        var _b, _c;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _d = _a.refetchQueries, refetchQueries = _d === void 0 ? [] : _d, _e = _a.awaitRefetchQueries, awaitRefetchQueries = _e === void 0 ? false : _e, updateWithProxyFn = _a.update, onQueryUpdated = _a.onQueryUpdated, _f = _a.fetchPolicy, fetchPolicy = _f === void 0 ? ((_b = this.defaultOptions.mutate) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "network-only" : _f, _g = _a.errorPolicy, errorPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.errorPolicy) || "none" : _g, keepRootFields = _a.keepRootFields, context = _a.context;
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var mutationId, hasClientExports, mutationStoreValue, isOptimistic, self;
            return (0, $l73V3.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        (0, $kJ26n.invariant)(mutation, 26);
                        (0, $kJ26n.invariant)(fetchPolicy === "network-only" || fetchPolicy === "no-cache", 27);
                        mutationId = this.generateMutationId();
                        mutation = this.cache.transformForLink(this.transform(mutation));
                        hasClientExports = this.getDocumentInfo(mutation).hasClientExports;
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _h.sent();
                        _h.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
                            mutation: mutation,
                            variables: variables,
                            loading: true,
                            error: null
                        });
                        isOptimistic = optimisticResponse && this.markMutationOptimistic(optimisticResponse, {
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            fetchPolicy: fetchPolicy,
                            errorPolicy: errorPolicy,
                            context: context,
                            updateQueries: updateQueries,
                            update: updateWithProxyFn,
                            keepRootFields: keepRootFields
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                return (0, $dvQ3t.asyncMap)(self.getObservableFromLink(mutation, (0, $l73V3.__assign)((0, $l73V3.__assign)({}, context), {
                                    optimisticResponse: isOptimistic ? optimisticResponse : void 0
                                }), variables, false), function(result) {
                                    if ((0, $fjRIS.graphQLResultHasError)(result) && errorPolicy === "none") throw new (0, $408uN.ApolloError)({
                                        graphQLErrors: (0, $fjRIS.getGraphQLErrorsFromResult)(result)
                                    });
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0, $l73V3.__assign)({}, result);
                                    if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                    if (errorPolicy === "ignore" && (0, $fjRIS.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: isOptimistic ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields
                                    });
                                }).subscribe({
                                    next: function(storeResult) {
                                        self.broadcastQueries();
                                        // Since mutations might receive multiple payloads from the
                                        // ApolloLink chain (e.g. when used with @defer),
                                        // we resolve with a SingleExecutionResult or after the final
                                        // ExecutionPatchResult has arrived and we have assembled the
                                        // multipart response into a single result.
                                        if (!("hasNext" in storeResult) || storeResult.hasNext === false) resolve(storeResult);
                                    },
                                    error: function(err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (isOptimistic) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(err instanceof (0, $408uN.ApolloError) ? err : new (0, $408uN.ApolloError)({
                                            networkError: err
                                        }));
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function(mutation, cache) {
        var _this = this;
        if (cache === void 0) cache = this.cache;
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && (0, $hXKAm.shouldWriteResult)(result, mutation.errorPolicy)) {
            if (!(0, $kavKO.isExecutionPatchIncrementalResult)(result)) cacheWrites.push({
                result: result.data,
                dataId: "ROOT_MUTATION",
                query: mutation.document,
                variables: mutation.variables
            });
            if ((0, $kavKO.isExecutionPatchIncrementalResult)(result) && (0, $2emDS.isNonEmptyArray)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    // The cache complains if passed a mutation where it expects a
                    // query, so we transform mutations and subscriptions to queries
                    // (only once, thanks to this.transformCache).
                    query: this.getDocumentInfo(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true
                });
                var mergedData = void 0;
                if (diff.result) mergedData = (0, $kavKO.mergeIncrementalData)(diff.result, result);
                if (typeof mergedData !== "undefined") {
                    // cast the ExecutionPatchResult to FetchResult here since
                    // ExecutionPatchResult never has `data` when returned from the server
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: "ROOT_MUTATION",
                        query: mutation.document,
                        variables: mutation.variables
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                var queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !$cdb770d6b0b54ae0$var$hasOwnProperty.call(updateQueries_1, queryName)) return;
                var updater = updateQueries_1[queryName];
                var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                // Read the current query result from the store.
                var _c = cache.diff({
                    query: document,
                    variables: variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _c.result, complete = _c.complete;
                if (complete && currentQueryResult) {
                    // Run our reducer using the current query result and the mutation result.
                    var nextQueryResult = updater(currentQueryResult, {
                        mutationResult: result,
                        queryName: document && (0, $29Gnu.getOperationName)(document) || void 0,
                        queryVariables: variables
                    });
                    // Write the modified result back into the store if we got a new result.
                    if (nextQueryResult) cacheWrites.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: document,
                        variables: variables
                    });
                }
            });
        }
        if (cacheWrites.length > 0 || (mutation.refetchQueries || "").length > 0 || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function(cache) {
                    if (!skipCache) cacheWrites.forEach(function(write) {
                        return cache.write(write);
                    });
                    // If the mutation has some writes associated with it then we need to
                    // apply those writes to the store by running this reducer again with
                    // a write action.
                    var update = mutation.update;
                    // Determine whether result is a SingleExecutionResult,
                    // or the final ExecutionPatchResult.
                    var isFinalResult = !(0, $kavKO.isExecutionPatchResult)(result) || (0, $kavKO.isExecutionPatchIncrementalResult)(result) && !result.hasNext;
                    if (update) {
                        if (!skipCache) {
                            // Re-read the ROOT_MUTATION data we just wrote into the cache
                            // (the first cache.write call in the cacheWrites.forEach loop
                            // above), so field read functions have a chance to run for
                            // fields within mutation result objects.
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                // The cache complains if passed a mutation where it expects a
                                // query, so we transform mutations and subscriptions to queries
                                // (only once, thanks to this.transformCache).
                                query: _this.getDocumentInfo(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true
                            });
                            if (diff.complete) {
                                result = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, result), {
                                    data: diff.result
                                });
                                if ("incremental" in result) delete result.incremental;
                                if ("hasNext" in result) delete result.hasNext;
                            }
                        }
                        // If we've received the whole response,
                        // either a SingleExecutionResult or the final ExecutionPatchResult,
                        // call the update function.
                        if (isFinalResult) update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables
                        });
                    }
                    // TODO Do this with cache.evict({ id: 'ROOT_MUTATION' }) but make it
                    // shallow to allow rolling back optimistic evictions.
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) cache.modify({
                        id: "ROOT_MUTATION",
                        fields: function(value, _a) {
                            var fieldName = _a.fieldName, DELETE = _a.DELETE;
                            return fieldName === "__typename" ? value : DELETE;
                        }
                    });
                },
                include: mutation.refetchQueries,
                // Write the final mutation.result to the root layer of the cache.
                optimistic: false,
                // Remove the corresponding optimistic layer at the same time as we
                // write the final non-optimistic result.
                removeOptimistic: mutation.removeOptimistic,
                // Let the caller of client.mutate optionally determine the refetching
                // behavior for watched queries after the mutation.update function runs.
                // If no onQueryUpdated function was provided for this mutation, pass
                // null instead of undefined to disable the default refetching behavior.
                onQueryUpdated: mutation.onQueryUpdated || null
            }).forEach(function(result) {
                return results_1.push(result);
            });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) // Returning a promise here makes the mutation await that promise, so we
            // include results in that promise's work if awaitRefetchQueries or an
            // onQueryUpdated function was specified.
            return Promise.all(results_1).then(function() {
                return result;
            });
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function(optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables, {
            IGNORE: $cdb770d6b0b54ae0$var$IGNORE
        }) : optimisticResponse;
        if (data === $cdb770d6b0b54ae0$var$IGNORE) return false;
        this.cache.recordOptimisticTransaction(function(cache) {
            try {
                _this.markMutationResult((0, $l73V3.__assign)((0, $l73V3.__assign)({}, mutation), {
                    result: {
                        data: data
                    }
                }), cache);
            } catch (error) {
                globalThis.__DEV__ !== false && (0, $kJ26n.invariant).error(error);
            }
        }, mutation.mutationId);
        return true;
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(queryId, options, networkStatus).concast.promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        return this.documentTransform.transformDocument(document);
    };
    QueryManager.prototype.getDocumentInfo = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cacheEntry = {
                // TODO These three calls (hasClientExports, shouldForceResolvers, and
                // usesNonreactiveDirective) are performing independent full traversals
                // of the transformed document. We should consider merging these
                // traversals into a single pass in the future, though the work is
                // cached after the first time.
                hasClientExports: (0, $iRdoS.hasClientExports)(document),
                hasForcedResolvers: this.localState.shouldForceResolvers(document),
                hasNonreactiveDirective: (0, $iRdoS.hasDirectives)([
                    "nonreactive"
                ], document),
                clientQuery: this.localState.clientQuery(document),
                serverQuery: (0, $2a3Iu.removeDirectivesFromDocument)([
                    {
                        name: "client",
                        remove: true
                    },
                    {
                        name: "connection"
                    },
                    {
                        name: "nonreactive"
                    }
                ], document),
                defaultVars: (0, $29Gnu.getDefaultValues)((0, $29Gnu.getOperationDefinition)(document)),
                // Transform any mutation or subscription operations to query operations
                // so we can read/write them from/to the cache.
                asQuery: (0, $l73V3.__assign)((0, $l73V3.__assign)({}, document), {
                    definitions: document.definitions.map(function(def) {
                        if (def.kind === "OperationDefinition" && def.operation !== "query") return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, def), {
                            operation: "query"
                        });
                        return def;
                    })
                })
            };
            transformCache.set(document, cacheEntry);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, this.getDocumentInfo(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        var query = this.transform(options.query);
        // assign variable default values if supplied
        // NOTE: We don't modify options.query here with the transformed query to
        // ensure observable.options.query is set to the raw untransformed query.
        options = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
            variables: this.getVariables(query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === "undefined") options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, $hXKAm.QueryInfo)(this);
        var observable = new (0, $holO6.ObservableQuery)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        observable["lastQuery"] = query;
        this.queries.set(observable.queryId, queryInfo);
        // We give queryInfo the transformed query to ensure the first cache diff
        // uses the transformed query instead of the raw query
        queryInfo.init({
            document: query,
            observableQuery: observable,
            variables: observable.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options, queryId) {
        var _this = this;
        if (queryId === void 0) queryId = this.generateQueryId();
        (0, $kJ26n.invariant)(options.query, 28);
        (0, $kJ26n.invariant)(options.query.kind === "Document", 29);
        (0, $kJ26n.invariant)(!options.returnPartialData, 30);
        (0, $kJ26n.invariant)(!options.pollInterval, 31);
        return this.fetchQuery(queryId, (0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
            query: this.transform(options.query)
        })).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function(options) {
        if (options === void 0) options = {
            discardWatches: true
        };
        // Before we have sent the reset action to the store, we can no longer
        // rely on the results returned by in-flight requests since these may
        // depend on values that previously existed in the data portion of the
        // store. So, we cancel the promises and observers that we have issued
        // so far and not yet resolved (in the case of queries).
        this.cancelPendingFetches((0, $kJ26n.newInvariantError)(32));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) // Set loading to true so listeners don't trigger unless they want
            // results with partial data.
            queryInfo.networkStatus = (0, $8LKEl.NetworkStatus).loading;
            else queryInfo.stop();
        });
        if (this.mutationStore) this.mutationStore = Object.create(null);
        // begin removing data from the store
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function(include) {
        var _this = this;
        if (include === void 0) include = "active";
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) include.forEach(function(desc) {
            if (typeof desc === "string") queryNamesAndDocs.set(desc, false);
            else if ((0, $RzHRn.isDocumentNode)(desc)) queryNamesAndDocs.set(_this.transform(desc), false);
            else if ((0, $dmNot.isNonNullObject)(desc) && desc.query) legacyQueryOptions.add(desc);
        });
        this.queries.forEach(function(_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" || include === "active" && !oq.hasObservers()) return;
                if (include === "active" || queryName && queryNamesAndDocs.has(queryName) || document && queryNamesAndDocs.has(document)) {
                    queries.set(queryId, oq);
                    if (queryName) queryNamesAndDocs.set(queryName, true);
                    if (document) queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) legacyQueryOptions.forEach(function(options) {
            // We will be issuing a fresh network request for this query, so we
            // pre-allocate a new query ID here, using a special prefix to enable
            // cleaning up these temporary queries later, after fetching.
            var queryId = (0, $7AXen.makeUniqueId)("legacyOneTimeQuery");
            var queryInfo = _this.getQuery(queryId).init({
                document: options.query,
                variables: options.variables
            });
            var oq = new (0, $holO6.ObservableQuery)({
                queryManager: _this,
                queryInfo: queryInfo,
                options: (0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
                    fetchPolicy: "network-only"
                })
            });
            (0, $kJ26n.invariant)(oq.queryId === queryId);
            queryInfo.setObservableQuery(oq);
            queries.set(queryId, oq);
        });
        if (globalThis.__DEV__ !== false && queryNamesAndDocs.size) queryNamesAndDocs.forEach(function(included, nameOrDoc) {
            if (!included) globalThis.__DEV__ !== false && (0, $kJ26n.invariant).warn(typeof nameOrDoc === "string" ? 33 : 34, nameOrDoc);
        });
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function(observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby || fetchPolicy !== "standby" && fetchPolicy !== "cache-only") observableQueryPromises.push(observableQuery.refetch());
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function(observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, _b = _a.errorPolicy, errorPolicy = _b === void 0 ? "none" : _b, variables = _a.variables, _c = _a.context, context = _c === void 0 ? {} : _c;
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables).map(function(result) {
                if (fetchPolicy !== "no-cache") {
                    // the subscription interface should handle not sending us results we no longer subscribe to.
                    // XXX I don't think we ever send in an object with errors, but we might in the future...
                    if ((0, $hXKAm.shouldWriteResult)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: "ROOT_SUBSCRIPTION",
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                var hasErrors = (0, $fjRIS.graphQLResultHasError)(result);
                var hasProtocolErrors = (0, $408uN.graphQLResultHasProtocolErrors)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) errors.graphQLErrors = result.errors;
                    if (hasProtocolErrors) errors.protocolErrors = result.extensions[0, $408uN.PROTOCOL_ERRORS_SYMBOL];
                    // `errorPolicy` is a mechanism for handling GraphQL errors, according
                    // to our documentation, so we throw protocol errors regardless of the
                    // set error policy.
                    if (errorPolicy === "none" || hasProtocolErrors) throw new (0, $408uN.ApolloError)(errors);
                }
                if (errorPolicy === "ignore") delete result.errors;
                return result;
            });
        };
        if (this.getDocumentInfo(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, $bMbZ0.Observable)(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        // teardown all links
        // Both `QueryManager.fetchRequest` and `QueryManager.query` create separate promises
        // that each add their reject functions to fetchCancelFns.
        // A query created with `QueryManager.query()` could trigger a `QueryManager.fetchRequest`.
        // The same queryId could have two rejection fns for two promises
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function() {
        if (this.onBroadcast) this.onBroadcast();
        this.queries.forEach(function(info) {
            return info.notify();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, // Prefer context.queryDeduplication if specified.
    deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var _b = this.getDocumentInfo(query), serverQuery = _b.serverQuery, clientQuery = _b.clientQuery;
        if (serverQuery) {
            var _c = this, inFlightLinkObservables_1 = _c.inFlightLinkObservables, link = _c.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $29Gnu.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $l73V3.__assign)((0, $l73V3.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var printedServerQuery_1 = (0, $3owxW.print)(serverQuery);
                var varJson_1 = (0, $gGpvG.canonicalStringify)(variables);
                var entry = inFlightLinkObservables_1.lookup(printedServerQuery_1, varJson_1);
                observable = entry.observable;
                if (!observable) {
                    var concast = new (0, $cBe3I.Concast)([
                        (0, $aBGMx.execute)(link, operation)
                    ]);
                    observable = entry.observable = concast;
                    concast.beforeNext(function() {
                        inFlightLinkObservables_1.remove(printedServerQuery_1, varJson_1);
                    });
                }
            } else observable = new (0, $cBe3I.Concast)([
                (0, $aBGMx.execute)(link, operation)
            ]);
        } else {
            observable = new (0, $cBe3I.Concast)([
                (0, $bMbZ0.Observable).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        if (clientQuery) observable = (0, $dvQ3t.asyncMap)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        // Performing transformForLink here gives this.cache a chance to fill in
        // missing fragment definitions (for example) before sending this document
        // through the link chain.
        var linkDocument = this.cache.transformForLink(options.query);
        return (0, $dvQ3t.asyncMap)(this.getObservableFromLink(linkDocument, options.context, options.variables), function(result) {
            var graphQLErrors = (0, $fjRIS.getGraphQLErrorsFromResult)(result);
            var hasErrors = graphQLErrors.length > 0;
            // If we interrupted this request by calling getResultsFromLink again
            // with the same QueryInfo object, we ignore the old results.
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") // Throwing here effectively calls observer.error.
                throw queryInfo.markError(new (0, $408uN.ApolloError)({
                    graphQLErrors: graphQLErrors
                }));
                // Use linkDocument rather than queryInfo.document so the
                // operation/fragments used to write the result are the same as the
                // ones used to obtain it from the link.
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: (0, $8LKEl.NetworkStatus).ready
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = (0, $8LKEl.NetworkStatus).error;
            }
            return aqr;
        }, function(networkError) {
            var error = (0, $408uN.isApolloError)(networkError) ? networkError : new (0, $408uN.ApolloError)({
                networkError: networkError
            });
            // Avoid storing errors from older interrupted queries.
            if (requestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchConcastWithInfo = function(queryId, options, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus, query) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, $8LKEl.NetworkStatus).loading;
        if (query === void 0) query = options.query;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            // Since normalized is always a fresh copy of options, it's safe to
            // modify its properties here, rather than creating yet another new
            // WatchQueryOptions object.
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (// If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            normalized.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
            // this is another way to detect when nothing was done/fetched.
            sourcesWithInfo.sources.length > 0 && queryInfo.observableQuery) queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            return sourcesWithInfo;
        };
        // This cancel function needs to be set before the concast is created,
        // in case concast creation synchronously cancels the request.
        var cleanupCancelFn = function() {
            return _this.fetchCancelFns.delete(queryId);
        };
        this.fetchCancelFns.set(queryId, function(reason) {
            cleanupCancelFn();
            // This delay ensures the concast variable has been initialized.
            setTimeout(function() {
                return concast.cancel(reason);
            });
        });
        var concast, containsDataFromLink;
        // If the query has @export(as: ...) directives, then we need to
        // process those directives asynchronously. When there are no
        // @export directives (the common case), we deliberately avoid
        // wrapping the result of this.fetchQueryByPolicy in a Promise,
        // since the timing of result delivery is (unfortunately) important
        // for backwards compatibility. TODO This code could be simpler if
        // we deprecated and removed LocalState.
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            concast = new (0, $cBe3I.Concast)(this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables).then(function(sourcesWithInfo) {
                return sourcesWithInfo.sources;
            }));
            // there is just no way we can synchronously get the *right* value here,
            // so we will assume `true`, which is the behaviour before the bug fix in
            // #10597. This means that bug is not fixed in that case, and is probably
            // un-fixable with reasonable effort for the edge case of @export as
            // directives.
            containsDataFromLink = true;
        } else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new (0, $cBe3I.Concast)(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink
        };
    };
    QueryManager.prototype.refetchQueries = function(_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0, $7AXen.makeUniqueId)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) this.getObservableQueries(include).forEach(function(oq, queryId) {
            includedQueriesById.set(queryId, {
                oq: oq,
                lastDiff: _this.getQuery(queryId).getDiff()
            });
        });
        var results = new Map();
        if (updateCache) this.cache.batch({
            update: updateCache,
            // Since you can perform any combination of cache reads and/or writes in
            // the cache.batch update function, its optimistic option can be either
            // a boolean or a string, representing three distinct modes of
            // operation:
            //
            // * false: read/write only the root layer
            // * true: read/write the topmost layer
            // * string: read/write a fresh optimistic layer with that ID string
            //
            // When typeof optimistic === "string", a new optimistic layer will be
            // temporarily created within cache.batch with that string as its ID. If
            // we then pass that same string as the removeOptimistic option, we can
            // make cache.batch immediately remove the optimistic layer after
            // running the updateCache function, triggering only one broadcast.
            //
            // However, the refetchQueries method accepts only true or false for its
            // optimistic option (not string). We interpret true to mean a temporary
            // optimistic layer should be created, to allow efficiently rolling back
            // the effect of the updateCache function, which involves passing a
            // string instead of true as the optimistic option to cache.batch, when
            // refetchQueries receives optimistic: true.
            //
            // In other words, we are deliberately not supporting the use case of
            // writing to an *existing* optimistic layer (using the refetchQueries
            // updateCache function), since that would potentially interfere with
            // other optimistic updates in progress. Instead, you can read/write
            // only the root layer by passing optimistic: false to refetchQueries,
            // or you can read/write a brand new optimistic layer that will be
            // automatically removed by passing optimistic: true.
            optimistic: optimistic && removeOptimistic || false,
            // The removeOptimistic option can also be provided by itself, even if
            // optimistic === false, to remove some previously-added optimistic
            // layer safely and efficiently, like we do in markMutationResult.
            //
            // If an explicit removeOptimistic string is provided with optimistic:
            // true, the removeOptimistic string will determine the ID of the
            // temporary optimistic layer, in case that ever matters.
            removeOptimistic: removeOptimistic,
            onWatchUpdated: function(watch, diff, lastDiff) {
                var oq = watch.watcher instanceof (0, $hXKAm.QueryInfo) && watch.watcher.observableQuery;
                if (oq) {
                    if (onQueryUpdated) {
                        // Since we're about to handle this query now, remove it from
                        // includedQueriesById, in case it was added earlier because of
                        // options.include.
                        includedQueriesById.delete(oq.queryId);
                        var result = onQueryUpdated(oq, diff, lastDiff);
                        if (result === true) // The onQueryUpdated function requested the default refetching
                        // behavior by returning true.
                        result = oq.refetch();
                        // Record the result in the results Map, as long as onQueryUpdated
                        // did not return false to skip/ignore this result.
                        if (result !== false) results.set(oq, result);
                        // Allow the default cache broadcast to happen, except when
                        // onQueryUpdated returns false.
                        return result;
                    }
                    if (onQueryUpdated !== null) // If we don't have an onQueryUpdated function, and onQueryUpdated
                    // was not disabled by passing null, make sure this query is
                    // "included" like any other options.include-specified query.
                    includedQueriesById.set(oq.queryId, {
                        oq: oq,
                        lastDiff: lastDiff,
                        diff: diff
                    });
                }
            }
        });
        if (includedQueriesById.size) includedQueriesById.forEach(function(_a, queryId) {
            var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
            var result;
            // If onQueryUpdated is provided, we want to use it for all included
            // queries, even the QueryOptions ones.
            if (onQueryUpdated) {
                if (!diff) {
                    var info = oq["queryInfo"];
                    info.reset(); // Force info.getDiff() to read from cache.
                    diff = info.getDiff();
                }
                result = onQueryUpdated(oq, diff, lastDiff);
            }
            // Otherwise, we fall back to refetching.
            if (!onQueryUpdated || result === true) result = oq.refetch();
            if (result !== false) results.set(oq, result);
            if (queryId.indexOf("legacyOneTimeQuery") >= 0) _this.stopQueryNoBroadcast(queryId);
        });
        if (removeOptimistic) // In case no updateCache callback was provided (so cache.batch was not
        // called above, and thus did not already remove the optimistic layer),
        // remove it here. Since this is a no-op when the layer has already been
        // removed, we do it even if we called cache.batch above, since it's
        // possible this.cache is an instance of some ApolloCache subclass other
        // than InMemoryCache, and does not fully support the removeOptimistic
        // option for cache.batch.
        this.cache.removeOptimistic(removeOptimistic);
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, _a, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: query,
            variables: variables,
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff();
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, $8LKEl.NetworkStatus).loading;
            var data = diff.result;
            if (globalThis.__DEV__ !== false && !returnPartialData && !(0, $62dod.equal)(data, {})) (0, $holO6.logMissingFieldErrors)(diff.missing);
            var fromData = function(data) {
                return (0, $bMbZ0.Observable).of((0, $l73V3.__assign)({
                    data: data,
                    loading: (0, $8LKEl.isNetworkRequestInFlight)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (data && _this.getDocumentInfo(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data || void 0);
            });
            // Resolves https://github.com/apollographql/apollo-client/issues/10317.
            // If errorPolicy is 'none' and notifyOnNetworkStatusChange is true,
            // data was incorrectly returned from the cache on refetch:
            // if diff.missing exists, we should not return cache data.
            if (errorPolicy === "none" && networkStatus === (0, $8LKEl.NetworkStatus).refetch && Array.isArray(diff.missing)) return fromData(void 0);
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */  : networkStatus === (0, $8LKEl.NetworkStatus).refetch && refetchWritePolicy !== "merge" ? 1 /* CacheWriteBehavior.OVERWRITE */  : 2 /* CacheWriteBehavior.MERGE */ ;
        var resultsFromLink = function() {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                query: query,
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, $8LKEl.isNetworkRequestInFlight)(networkStatus);
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(diff, queryInfo.markReady())
                    ]
                };
                if (returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-only":
                return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(readCache(), queryInfo.markReady())
                    ]
                };
            case "network-only":
                if (shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(readCache()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "no-cache":
                if (shouldNotify) return {
                    fromLink: true,
                    // Note that queryInfo.getDiff() for no-cache queries does not call
                    // cache.diff, but instead returns a { complete: false } stub result
                    // when there is no queryInfo.diff already defined.
                    sources: [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "standby":
                return {
                    fromLink: false,
                    sources: []
                };
        }
    };
    QueryManager.prototype.getQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, $hXKAm.QueryInfo)(this, queryId));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $l73V3.__assign)((0, $l73V3.__assign)((0, $l73V3.__assign)({}, this.defaultContext), newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();

});
parcelRegister("dvQ3t", function(module, exports) {

$parcel$export(module.exports, "asyncMap", function () { return $9d668ca1a5263a16$export$707ee4c4c95d39e3; });
parcelRequire("5Xksu");
var $bMbZ0 = parcelRequire("bMbZ0");
function $9d668ca1a5263a16$export$707ee4c4c95d39e3(observable, mapFn, catchFn) {
    return new (0, $bMbZ0.Observable)(function(observer) {
        var promiseQueue = {
            // Normally we would initialize promiseQueue to Promise.resolve(), but
            // in this case, for backwards compatibility, we need to be careful to
            // invoke the first callback synchronously.
            then: function(callback) {
                return new Promise(function(resolve) {
                    return resolve(callback());
                });
            }
        };
        function makeCallback(examiner, key) {
            return function(arg) {
                if (examiner) {
                    var both = function() {
                        // If the observer is closed, we don't want to continue calling the
                        // mapping function - it's result will be swallowed anyways.
                        return observer.closed ? /* will be swallowed */ 0 : examiner(arg);
                    };
                    promiseQueue = promiseQueue.then(both, both).then(function(result) {
                        return observer.next(result);
                    }, function(error) {
                        return observer.error(error);
                    });
                } else observer[key](arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, "next"),
            error: makeCallback(catchFn, "error"),
            complete: function() {
                // no need to reassign `promiseQueue`, after `observer.complete`,
                // the observer will be closed and short-circuit everything anyways
                /*promiseQueue = */ promiseQueue.then(function() {
                    return observer.complete();
                });
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}

});

parcelRegister("cBe3I", function(module, exports) {

$parcel$export(module.exports, "Concast", function () { return $92c3d88837128523$export$ae0cf2ec7a6fa78e; });

var $l73V3 = parcelRequire("l73V3");
parcelRequire("5Xksu");
var $bMbZ0 = parcelRequire("bMbZ0");

var $bX6rj = parcelRequire("bX6rj");

var $7beJZ = parcelRequire("7beJZ");
function $92c3d88837128523$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// A Concast<T> observable concatenates the given sources into a single
// non-overlapping sequence of Ts, automatically unwrapping any promises,
// and broadcasts the T elements of that sequence to any number of
// subscribers, all without creating a bunch of intermediary Observable
// wrapper objects.
//
// Even though any number of observers can subscribe to the Concast, each
// source observable is guaranteed to receive at most one subscribe call,
// and the results are multicast to all observers.
//
// In addition to broadcasting every next/error message to this.observers,
// the Concast stores the most recent message using this.latest, so any
// new observers can immediately receive the latest message, even if it
// was originally delivered in the past. This behavior means we can assume
// every active observer in this.observers has received the same most
// recent message.
//
// With the exception of this.latest replay, a Concast is a "hot"
// observable in the sense that it does not replay past results from the
// beginning of time for each new observer.
//
// Could we have used some existing RxJS class instead? Concast<T> is
// similar to a BehaviorSubject<T>, because it is multicast and redelivers
// the latest next/error message to new subscribers. Unlike Subject<T>,
// Concast<T> does not expose an Observer<T> interface (this.handlers is
// intentionally private), since Concast<T> gets its inputs from the
// concatenated sources. If we ever switch to RxJS, there may be some
// value in reusing their code, but for now we use zen-observable, which
// does not contain any Subject implementations.
var $92c3d88837128523$export$ae0cf2ec7a6fa78e = /** @class */ function(_super) {
    (0, $l73V3.__extends)(Concast, _super);
    // Not only can the individual elements of the iterable be promises, but
    // also the iterable itself can be wrapped in a promise.
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        // Active observers receiving broadcast messages. Thanks to this.latest,
        // we can assume all observers in this Set have received the same most
        // recent message, though possibly at different times in the past.
        _this.observers = new Set();
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        // Bound handler functions that can be reused for every internal
        // subscription.
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    _this.notify("next", result);
                    (0, $bX6rj.iterateObserversSafely)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                var sub = _this.sub;
                if (sub !== null) {
                    // Delay unsubscribing from the underlying subscription slightly,
                    // so that immediately subscribing another observer can keep the
                    // subscription active.
                    if (sub) setTimeout(function() {
                        return sub.unsubscribe();
                    });
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0, $bX6rj.iterateObserversSafely)(_this.observers, "error", error);
                }
            },
            complete: function() {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    // If complete is called before concast.start, this.sources may be
                    // undefined, so we use a default value of [] for sources. That works
                    // here because it falls into the if (!value) {...} block, which
                    // appropriately terminates the Concast, even if this.sources might
                    // eventually have been initialized to a non-empty array.
                    var value = sources.shift();
                    if (!value) {
                        if (sub) setTimeout(function() {
                            return sub.unsubscribe();
                        });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        _this.notify("complete");
                        // We do not store this.latest = ["complete"], because doing so
                        // discards useful information about the previous next (or
                        // error) message. Instead, if new observers subscribe after
                        // this Concast has completed, they will receive the final
                        // 'next' message (unless there was an error) immediately
                        // followed by a 'complete' message (see addObserver).
                        (0, $bX6rj.iterateObserversSafely)(_this.observers, "complete");
                    } else if ($92c3d88837128523$var$isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    }, _this.handlers.error);
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.nextResultListeners = new Set();
        // A public way to abort observation and broadcast.
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        // Suppress rejection warnings for this.promise, since it's perfectly
        // acceptable to pay no attention to this.promise if you're consuming
        // the results through the normal observable API.
        _this.promise.catch(function(_) {});
        // If someone accidentally tries to create a Concast using a subscriber
        // function, recover by creating an Observable from that subscriber and
        // using it as the source.
        if (typeof sources === "function") sources = [
            new (0, $bMbZ0.Observable)(sources)
        ];
        if ($92c3d88837128523$var$isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        // In practice, sources is most often simply an Array of observables.
        // TODO Consider using sources[Symbol.iterator]() to take advantage
        // of the laziness of non-Array iterables.
        this.sources = Array.from(sources);
        // Calling this.handlers.complete() kicks off consumption of the first
        // source observable. It's tempting to do this step lazily in
        // addObserver, but this.promise can be accessed without calling
        // addObserver, so consumption needs to begin eagerly.
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function(observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) method.call(observer, this.latest[1]);
            // If the subscription is already closed, and the last message was
            // a 'next' message, simulate delivery of the final 'complete'
            // message again.
            if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
        }
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            // Immediately deliver the most recent message, so we can always
            // be sure all observers have the latest information.
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function(observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) // In case there are still any listeners in this.nextResultListeners, and
        // no error or completion has been broadcast yet, make sure those
        // observers have a chance to run and then remove themselves from
        // this.observers.
        this.handlers.complete();
    };
    Concast.prototype.notify = function(method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            // Replacing this.nextResultListeners first ensures it does not grow while
            // we are iterating over it, potentially leading to infinite loops.
            this.nextResultListeners = new Set();
            nextResultListeners.forEach(function(listener) {
                return listener(method, arg);
            });
        }
    };
    // We need a way to run callbacks just *before* the next result (or error or
    // completion) is delivered by this Concast, so we can be sure any code that
    // runs as a result of delivering that result/error observes the effects of
    // running the callback(s). It was tempting to reuse the Observer type instead
    // of introducing NextResultListener, but that messes with the sizing and
    // maintenance of this.observers, and ends up being more code overall.
    Concast.prototype.beforeNext = function(callback) {
        var called = false;
        this.nextResultListeners.add(function(method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}((0, $bMbZ0.Observable));
// Necessary because the Concast constructor has a different signature
// than the Observable constructor.
(0, $7beJZ.fixObservableSubclass)($92c3d88837128523$export$ae0cf2ec7a6fa78e);

});
parcelRegister("bX6rj", function(module, exports) {

$parcel$export(module.exports, "iterateObserversSafely", function () { return $8b3a3324300fbfdf$export$9f6c99ae166dbeca; });
function $8b3a3324300fbfdf$export$9f6c99ae166dbeca(observers, method, argument) {
    // In case observers is modified during iteration, we need to commit to the
    // original elements, which also provides an opportunity to filter them down
    // to just the observers with the given method.
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}

});

parcelRegister("7beJZ", function(module, exports) {

$parcel$export(module.exports, "fixObservableSubclass", function () { return $53a4feb038afa965$export$33c8bd820eece9b2; });
parcelRequire("5Xksu");
var $bMbZ0 = parcelRequire("bMbZ0");

var $8L3vO = parcelRequire("8L3vO");
function $53a4feb038afa965$export$33c8bd820eece9b2(subclass) {
    function set(key) {
        // Object.defineProperty is necessary because the Symbol.species
        // property is a getter by default in modern JS environments, so we
        // can't assign to it with a normal assignment expression.
        Object.defineProperty(subclass, key, {
            value: (0, $bMbZ0.Observable)
        });
    }
    if ((0, $8L3vO.canUseSymbol) && Symbol.species) set(Symbol.species);
    // The "@@species" string is used as a fake Symbol.species value in some
    // polyfill systems (including the SymbolSpecies variable used by
    // zen-observable), so we should set it as well, to be safe.
    set("@@species");
    return subclass;
}

});


parcelRegister("ipGXK", function(module, exports) {

$parcel$export(module.exports, "DocumentTransform", function () { return $d67be34ce76b60eb$export$f887060e48e5dc1b; });

var $1U0aA = parcelRequire("1U0aA");

var $8L3vO = parcelRequire("8L3vO");

var $29Gnu = parcelRequire("29Gnu");
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $9ouSO = parcelRequire("9ouSO");

var $kMsgy = parcelRequire("kMsgy");

var $iOXJM = parcelRequire("iOXJM");
function $d67be34ce76b60eb$var$identity(document) {
    return document;
}
var $d67be34ce76b60eb$export$f887060e48e5dc1b = /** @class */ function() {
    function DocumentTransform(transform, options) {
        if (options === void 0) options = Object.create(null);
        this.resultCache = (0, $8L3vO.canUseWeakSet) ? new WeakSet() : new Set();
        this.transform = transform;
        if (options.getCacheKey) // Override default `getCacheKey` function, which returns [document].
        this.getCacheKey = options.getCacheKey;
        this.cached = options.cache !== false;
        this.resetCache();
    }
    // This default implementation of getCacheKey can be overridden by providing
    // options.getCacheKey to the DocumentTransform constructor. In general, a
    // getCacheKey function may either return an array of keys (often including
    // the document) to be used as a cache key, or undefined to indicate the
    // transform for this document should not be cached.
    DocumentTransform.prototype.getCacheKey = function(document) {
        return [
            document
        ];
    };
    DocumentTransform.identity = function() {
        // No need to cache this transform since it just returns the document
        // unchanged. This should save a bit of memory that would otherwise be
        // needed to populate the `documentCache` of this transform.
        return new DocumentTransform($d67be34ce76b60eb$var$identity, {
            cache: false
        });
    };
    DocumentTransform.split = function(predicate, left, right) {
        if (right === void 0) right = DocumentTransform.identity();
        return Object.assign(new DocumentTransform(function(document) {
            var documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, // Reasonably assume both `left` and `right` transforms handle their own caching
        {
            cache: false
        }), {
            left: left,
            right: right
        });
    };
    /**
     * Resets the internal cache of this transform, if it has one.
     */ DocumentTransform.prototype.resetCache = function() {
        var _this = this;
        if (this.cached) {
            var stableCacheKeys_1 = new (0, $1U0aA.Trie)((0, $8L3vO.canUseWeakMap));
            this.performWork = (0, $kMsgy.wrap)(DocumentTransform.prototype.performWork.bind(this), {
                makeCacheKey: function(document) {
                    var cacheKeys = _this.getCacheKey(document);
                    if (cacheKeys) {
                        (0, $kJ26n.invariant)(Array.isArray(cacheKeys), 66);
                        return stableCacheKeys_1.lookupArray(cacheKeys);
                    }
                },
                max: (0, $iOXJM.cacheSizes)["documentTransform.cache"],
                cache: (0, $9ouSO.WeakCache)
            });
        }
    };
    DocumentTransform.prototype.performWork = function(document) {
        (0, $29Gnu.checkDocument)(document);
        return this.transform(document);
    };
    DocumentTransform.prototype.transformDocument = function(document) {
        // If a user passes an already transformed result back to this function,
        // immediately return it.
        if (this.resultCache.has(document)) return document;
        var transformedDocument = this.performWork(document);
        this.resultCache.add(transformedDocument);
        return transformedDocument;
    };
    DocumentTransform.prototype.concat = function(otherTransform) {
        var _this = this;
        return Object.assign(new DocumentTransform(function(document) {
            return otherTransform.transformDocument(_this.transformDocument(document));
        }, // Reasonably assume both transforms handle their own caching
        {
            cache: false
        }), {
            left: this,
            right: otherTransform
        });
    };
    return DocumentTransform;
}();

});
parcelRegister("1U0aA", function(module, exports) {

$parcel$export(module.exports, "Trie", function () { return $162b272082cde232$export$73571c50d0f2507e; });
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $162b272082cde232$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $162b272082cde232$var$forEach, slice: $162b272082cde232$var$slice } = Array.prototype;
const { hasOwnProperty: $162b272082cde232$var$hasOwnProperty } = Object.prototype;
class $162b272082cde232$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $162b272082cde232$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup() {
        return this.lookupArray(arguments);
    }
    lookupArray(array) {
        let node = this;
        $162b272082cde232$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $162b272082cde232$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($162b272082cde232$var$slice.call(array));
    }
    peek() {
        return this.peekArray(arguments);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = node.mapFor(array[i], false);
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    remove() {
        return this.removeArray(arguments);
    }
    removeArray(array) {
        let data;
        if (array.length) {
            const head = array[0];
            const map = this.mapFor(head, false);
            const child = map && map.get(head);
            if (child) {
                data = child.removeArray($162b272082cde232$var$slice.call(array, 1));
                if (!child.data && !child.weak && !(child.strong && child.strong.size)) map.delete(head);
            }
        } else {
            data = this.data;
            delete this.data;
        }
        return data;
    }
    getChildTrie(key) {
        const map = this.mapFor(key, true);
        let child = map.get(key);
        if (!child) map.set(key, child = new $162b272082cde232$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
    mapFor(key, create) {
        return this.weakness && $162b272082cde232$var$isObjRef(key) ? this.weak || (create ? this.weak = new WeakMap : void 0) : this.strong || (create ? this.strong = new Map : void 0);
    }
}
function $162b272082cde232$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}

});

parcelRegister("kMsgy", function(module, exports) {

$parcel$export(module.exports, "wrap", function () { return $f20e37639511b497$export$4997ffc0176396a6; });
$parcel$export(module.exports, "Slot", function () { return (parcelRequire("JEzHp")).Slot; });
$parcel$export(module.exports, "dep", function () { return (parcelRequire("3Nd2v")).dep; });

var $lnHWl = parcelRequire("lnHWl");

var $komyO = parcelRequire("komyO");

var $cfeqW = parcelRequire("cfeqW");

var $1jpzx = parcelRequire("1jpzx");
var $JEzHp = parcelRequire("JEzHp");

var $3Nd2v = parcelRequire("3Nd2v");
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let $f20e37639511b497$var$defaultKeyTrie;
function $f20e37639511b497$export$cd3144f8dd136006(...args) {
    const trie = $f20e37639511b497$var$defaultKeyTrie || ($f20e37639511b497$var$defaultKeyTrie = new (0, $lnHWl.Trie)(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
const $f20e37639511b497$var$caches = new Set();
function $f20e37639511b497$export$4997ffc0176396a6(originalFunction, { max: max = Math.pow(2, 16), keyArgs: keyArgs, makeCacheKey: makeCacheKey = $f20e37639511b497$export$cd3144f8dd136006, normalizeResult: normalizeResult, subscribe: subscribe, cache: cacheOption = (0, $komyO.StrongCache) } = Object.create(null)) {
    const cache = typeof cacheOption === "function" ? new cacheOption(max, (entry)=>entry.dispose()) : cacheOption;
    const optimistic = function() {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new (0, $cfeqW.Entry)(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = ()=>cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $f20e37639511b497$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!(0, $1jpzx.parentEntrySlot).hasValue()) {
            $f20e37639511b497$var$caches.forEach((cache)=>cache.clean());
            $f20e37639511b497$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: ()=>cache.size,
        configurable: false,
        enumerable: false
    });
    Object.freeze(optimistic.options = {
        max: max,
        keyArgs: keyArgs,
        makeCacheKey: makeCacheKey,
        normalizeResult: normalizeResult,
        subscribe: subscribe,
        cache: cache
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}

});
parcelRegister("lnHWl", function(module, exports) {

$parcel$export(module.exports, "Trie", function () { return $f90dd48709b8a7bb$export$73571c50d0f2507e; });
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $f90dd48709b8a7bb$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $f90dd48709b8a7bb$var$forEach, slice: $f90dd48709b8a7bb$var$slice } = Array.prototype;
const { hasOwnProperty: $f90dd48709b8a7bb$var$hasOwnProperty } = Object.prototype;
class $f90dd48709b8a7bb$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $f90dd48709b8a7bb$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup(...array) {
        return this.lookupArray(array);
    }
    lookupArray(array) {
        let node = this;
        $f90dd48709b8a7bb$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $f90dd48709b8a7bb$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($f90dd48709b8a7bb$var$slice.call(array));
    }
    peek(...array) {
        return this.peekArray(array);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = this.weakness && $f90dd48709b8a7bb$var$isObjRef(array[i]) ? node.weak : node.strong;
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    getChildTrie(key) {
        const map = this.weakness && $f90dd48709b8a7bb$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        let child = map.get(key);
        if (!child) map.set(key, child = new $f90dd48709b8a7bb$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
}
function $f90dd48709b8a7bb$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}

});

parcelRegister("cfeqW", function(module, exports) {

$parcel$export(module.exports, "Entry", function () { return $8ea214f8ad0df90f$export$3bb977b3ba9d3b59; });

var $1jpzx = parcelRequire("1jpzx");

var $7T4IT = parcelRequire("7T4IT");
const $8ea214f8ad0df90f$var$emptySetPool = [];
const $8ea214f8ad0df90f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $8ea214f8ad0df90f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $8ea214f8ad0df90f$var$valueIs(a, b) {
    const len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $8ea214f8ad0df90f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $8ea214f8ad0df90f$var$valueCopy(value) {
    return value.slice(0);
}
class $8ea214f8ad0df90f$export$3bb977b3ba9d3b59 {
    constructor(fn){
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++$8ea214f8ad0df90f$export$3bb977b3ba9d3b59.count;
    }
    peek() {
        if (this.value.length === 1 && !$8ea214f8ad0df90f$var$mightBeDirty(this)) {
            $8ea214f8ad0df90f$var$rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        $8ea214f8ad0df90f$var$assert(!this.recomputing, "already recomputing");
        $8ea214f8ad0df90f$var$rememberParent(this);
        return $8ea214f8ad0df90f$var$mightBeDirty(this) ? $8ea214f8ad0df90f$var$reallyRecompute(this, args) : $8ea214f8ad0df90f$var$valueGet(this.value);
    }
    setDirty() {
        if (this.dirty) return;
        this.dirty = true;
        $8ea214f8ad0df90f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        (0, $7T4IT.maybeUnsubscribe)(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $8ea214f8ad0df90f$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $8ea214f8ad0df90f$var$eachParent(this, (parent, child)=>{
            parent.setDirty();
            $8ea214f8ad0df90f$var$forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $8ea214f8ad0df90f$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            (0, $7T4IT.arrayFromSet)(this.deps).forEach((dep)=>dep.delete(this));
            this.deps.clear();
            $8ea214f8ad0df90f$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
$8ea214f8ad0df90f$export$3bb977b3ba9d3b59.count = 0;
function $8ea214f8ad0df90f$var$rememberParent(child) {
    const parent = (0, $1jpzx.parentEntrySlot).getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($8ea214f8ad0df90f$var$mightBeDirty(child)) $8ea214f8ad0df90f$var$reportDirtyChild(parent, child);
        else $8ea214f8ad0df90f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $8ea214f8ad0df90f$var$reallyRecompute(entry, args) {
    $8ea214f8ad0df90f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    (0, $1jpzx.parentEntrySlot).withValue(entry, $8ea214f8ad0df90f$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($8ea214f8ad0df90f$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $8ea214f8ad0df90f$var$setClean(entry);
    return $8ea214f8ad0df90f$var$valueGet(entry.value);
}
function $8ea214f8ad0df90f$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult: normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) oldValueCopy = $8ea214f8ad0df90f$var$valueCopy(entry.value);
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !$8ea214f8ad0df90f$var$valueIs(oldValueCopy, entry.value)) try {
            entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
        } catch (_a) {
        // If normalizeResult throws, just use the newer value, rather than
        // saving the exception as entry.value[1].
        }
    } catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $8ea214f8ad0df90f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $8ea214f8ad0df90f$var$setClean(entry) {
    entry.dirty = false;
    if ($8ea214f8ad0df90f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $8ea214f8ad0df90f$var$reportClean(entry);
}
function $8ea214f8ad0df90f$var$reportDirty(child) {
    $8ea214f8ad0df90f$var$eachParent(child, $8ea214f8ad0df90f$var$reportDirtyChild);
}
function $8ea214f8ad0df90f$var$reportClean(child) {
    $8ea214f8ad0df90f$var$eachParent(child, $8ea214f8ad0df90f$var$reportCleanChild);
}
function $8ea214f8ad0df90f$var$eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = (0, $7T4IT.arrayFromSet)(child.parents);
        for(let i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $8ea214f8ad0df90f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $8ea214f8ad0df90f$var$assert(parent.childValues.has(child));
    $8ea214f8ad0df90f$var$assert($8ea214f8ad0df90f$var$mightBeDirty(child));
    const parentWasClean = !$8ea214f8ad0df90f$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $8ea214f8ad0df90f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $8ea214f8ad0df90f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $8ea214f8ad0df90f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $8ea214f8ad0df90f$var$assert(parent.childValues.has(child));
    $8ea214f8ad0df90f$var$assert(!$8ea214f8ad0df90f$var$mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $8ea214f8ad0df90f$var$valueCopy(child.value));
    else if (!$8ea214f8ad0df90f$var$valueIs(childValue, child.value)) parent.setDirty();
    $8ea214f8ad0df90f$var$removeDirtyChild(parent, child);
    if ($8ea214f8ad0df90f$var$mightBeDirty(parent)) return;
    $8ea214f8ad0df90f$var$reportClean(parent);
}
function $8ea214f8ad0df90f$var$removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($8ea214f8ad0df90f$var$emptySetPool.length < $8ea214f8ad0df90f$var$POOL_TARGET_SIZE) $8ea214f8ad0df90f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $8ea214f8ad0df90f$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach((_value, child)=>{
        $8ea214f8ad0df90f$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $8ea214f8ad0df90f$var$assert(parent.dirtyChildren === null);
}
function $8ea214f8ad0df90f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $8ea214f8ad0df90f$var$removeDirtyChild(parent, child);
}
function $8ea214f8ad0df90f$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        (0, $7T4IT.maybeUnsubscribe)(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}

});
parcelRegister("1jpzx", function(module, exports) {

$parcel$export(module.exports, "parentEntrySlot", function () { return $0f4b66e193fbe1cd$export$11fa9682b6ba79b1; });
$parcel$export(module.exports, "Slot", function () { return (parcelRequire("JEzHp")).Slot; });
parcelRequire("htLXo");
var $JEzHp = parcelRequire("JEzHp");
const $0f4b66e193fbe1cd$export$11fa9682b6ba79b1 = new (0, $JEzHp.Slot)();
function $0f4b66e193fbe1cd$export$d906efd39458576(fn) {
    return $0f4b66e193fbe1cd$export$11fa9682b6ba79b1.withValue(void 0, fn);
}

});
parcelRegister("htLXo", function(module, exports) {

$parcel$export(module.exports, "Slot", function () { return (parcelRequire("JEzHp")).Slot; });

var $JEzHp = parcelRequire("JEzHp");
const { bind: $cb9a5856e13a154e$export$2385a24977818dd0, noContext: $cb9a5856e13a154e$export$9fa6f2e300a97f8 } = (0, $JEzHp.Slot);
function $cb9a5856e13a154e$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($cb9a5856e13a154e$export$2385a24977818dd0(callback), delay);
}
function $cb9a5856e13a154e$export$d5d7536e965c82da(genFn) {
    return function() {
        const gen = genFn.apply(this, arguments);
        const boundNext = $cb9a5856e13a154e$export$2385a24977818dd0(gen.next);
        const boundThrow = $cb9a5856e13a154e$export$2385a24977818dd0(gen.throw);
        return new Promise((resolve, reject)=>{
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if ($cb9a5856e13a154e$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            const invokeNext = (value)=>invoke(boundNext, value);
            const invokeThrow = (error)=>invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function $cb9a5856e13a154e$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const $cb9a5856e13a154e$var$wrappedFibers = [];
function $cb9a5856e13a154e$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($cb9a5856e13a154e$var$wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method)=>{
            const fn = obj[method];
            obj[method] = function() {
                return $cb9a5856e13a154e$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $cb9a5856e13a154e$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});
parcelRegister("JEzHp", function(module, exports) {

$parcel$export(module.exports, "Slot", function () { return $0893ad647920ed87$export$8c6ed5c666ac1360; });
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let $0893ad647920ed87$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const $0893ad647920ed87$var$MISSING_VALUE = {};
let $0893ad647920ed87$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const $0893ad647920ed87$var$makeSlotClass = ()=>class Slot {
        constructor(){
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $0893ad647920ed87$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        hasValue() {
            for(let context = $0893ad647920ed87$var$currentContext; context; context = context.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === $0893ad647920ed87$var$MISSING_VALUE) break;
                if (context !== $0893ad647920ed87$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $0893ad647920ed87$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($0893ad647920ed87$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $0893ad647920ed87$var$currentContext.slots[this.id] = $0893ad647920ed87$var$MISSING_VALUE;
            return false;
        }
        getValue() {
            if (this.hasValue()) return $0893ad647920ed87$var$currentContext.slots[this.id];
        }
        withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            const slots = {
                __proto__: null,
                [this.id]: value
            };
            const parent = $0893ad647920ed87$var$currentContext;
            $0893ad647920ed87$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $0893ad647920ed87$var$currentContext = parent;
            }
        }
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        static bind(callback) {
            const context = $0893ad647920ed87$var$currentContext;
            return function() {
                const saved = $0893ad647920ed87$var$currentContext;
                try {
                    $0893ad647920ed87$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $0893ad647920ed87$var$currentContext = saved;
                }
            };
        }
        // Immediately run a callback function without any captured context.
        static noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($0893ad647920ed87$var$currentContext) {
                const saved = $0893ad647920ed87$var$currentContext;
                try {
                    $0893ad647920ed87$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $0893ad647920ed87$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        }
    };
function $0893ad647920ed87$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const $0893ad647920ed87$var$globalKey = "@wry/context:Slot";
const $0893ad647920ed87$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$0893ad647920ed87$var$maybe(()=>globalThis) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$0893ad647920ed87$var$maybe(()=>$parcel$global) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const $0893ad647920ed87$var$globalHost = $0893ad647920ed87$var$host;
const $0893ad647920ed87$export$8c6ed5c666ac1360 = $0893ad647920ed87$var$globalHost[$0893ad647920ed87$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$0893ad647920ed87$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($0893ad647920ed87$var$globalHost, $0893ad647920ed87$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($0893ad647920ed87$var$makeSlotClass());

});



parcelRegister("7T4IT", function(module, exports) {

$parcel$export(module.exports, "hasOwnProperty", function () { return $5be15558d6779290$export$5a15a386532a5ea4; });
$parcel$export(module.exports, "arrayFromSet", function () { return $5be15558d6779290$export$1eb72f2488cedd93; });
$parcel$export(module.exports, "maybeUnsubscribe", function () { return $5be15558d6779290$export$50527b97338c0f71; });
const { hasOwnProperty: $5be15558d6779290$export$5a15a386532a5ea4 } = Object.prototype;
const $5be15558d6779290$export$1eb72f2488cedd93 = Array.from || function(set) {
    const array = [];
    set.forEach((item)=>array.push(item));
    return array;
};
function $5be15558d6779290$export$50527b97338c0f71(entryOrDep) {
    const { unsubscribe: unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}

});


parcelRegister("3Nd2v", function(module, exports) {

$parcel$export(module.exports, "dep", function () { return $2c301013d2c8a540$export$c723b7eff9d8f870; });

var $1jpzx = parcelRequire("1jpzx");

var $7T4IT = parcelRequire("7T4IT");
const $2c301013d2c8a540$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $2c301013d2c8a540$export$c723b7eff9d8f870(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = (0, $1jpzx.parentEntrySlot).getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) depsByKey.set(key, dep = new Set);
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                (0, $7T4IT.maybeUnsubscribe)(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = entryMethodName && (0, $7T4IT.hasOwnProperty).call($2c301013d2c8a540$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            (0, $7T4IT.arrayFromSet)(dep).forEach((entry)=>entry[m]());
            depsByKey.delete(key);
            (0, $7T4IT.maybeUnsubscribe)(dep);
        }
    };
    return depend;
}

});



parcelRegister("fjRIS", function(module, exports) {

$parcel$export(module.exports, "graphQLResultHasError", function () { return $b2724d943d2e7c70$export$b4df399e879e53ab; });
$parcel$export(module.exports, "getGraphQLErrorsFromResult", function () { return $b2724d943d2e7c70$export$a163557155188b6e; });

var $2emDS = parcelRequire("2emDS");

var $kavKO = parcelRequire("kavKO");
function $b2724d943d2e7c70$export$b4df399e879e53ab(result) {
    var errors = $b2724d943d2e7c70$export$a163557155188b6e(result);
    return (0, $2emDS.isNonEmptyArray)(errors);
}
function $b2724d943d2e7c70$export$a163557155188b6e(result) {
    var graphQLErrors = (0, $2emDS.isNonEmptyArray)(result.errors) ? result.errors.slice(0) : [];
    if ((0, $kavKO.isExecutionPatchIncrementalResult)(result) && (0, $2emDS.isNonEmptyArray)(result.incremental)) result.incremental.forEach(function(incrementalResult) {
        if (incrementalResult.errors) graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
    });
    return graphQLErrors;
}

});

parcelRegister("holO6", function(module, exports) {

$parcel$export(module.exports, "ObservableQuery", function () { return $ca95980509c394dd$export$6c1b56eac59c9584; });
$parcel$export(module.exports, "logMissingFieldErrors", function () { return $ca95980509c394dd$export$b7e1973aacac3ae7; });
$parcel$export(module.exports, "reobserveCacheFirst", function () { return $ca95980509c394dd$export$419171d60552792a; });

var $l73V3 = parcelRequire("l73V3");
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $62dod = parcelRequire("62dod");

var $8LKEl = parcelRequire("8LKEl");

var $2dQsV = parcelRequire("2dQsV");
var $am4bq = parcelRequire("am4bq");
var $7beJZ = parcelRequire("7beJZ");
var $29Gnu = parcelRequire("29Gnu");
var $bX6rj = parcelRequire("bX6rj");parcelRequire("5Xksu");
var $bMbZ0 = parcelRequire("bMbZ0");

var $evGq7 = parcelRequire("evGq7");
var $ca95980509c394dd$var$assign = Object.assign, $ca95980509c394dd$var$hasOwnProperty = Object.hasOwnProperty;
var $ca95980509c394dd$export$6c1b56eac59c9584 = /** @class */ function(_super) {
    (0, $l73V3.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function(observer) {
            // Zen Observable has its own error function, so in order to log correctly
            // we need to provide a custom error callback.
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $ca95980509c394dd$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !_this.observers.size;
            _this.observers.add(observer);
            // Deliver most recent error or result.
            var last = _this.last;
            if (last && last.error) observer.error && observer.error(last.error);
            else if (last && last.result) observer.next && observer.next(last.result);
            // Initiate observation of this query if it hasn't been reported to
            // the QueryManager yet.
            if (first) // Blindly catching here prevents unhandled promise rejections,
            // and is safe because the ObservableQuery handles this error with
            // this.observer.error, so we're not just swallowing the error by
            // ignoring it here.
            _this.reobserve().catch(function() {});
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        // related classes
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        // active state
        _this.waitForOwnResult = $ca95980509c394dd$var$skipCacheDataFor(options.fetchPolicy);
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, // Make sure we don't store "standby" as the initialFetchPolicy.
        _f = options.initialFetchPolicy, // Make sure we don't store "standby" as the initialFetchPolicy.
        initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy : _f;
        _this.options = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
            // Remember the initial options.fetchPolicy so we can revert back to this
            // policy when variables change. This information can also be specified
            // (or overridden) by providing options.initialFetchPolicy explicitly.
            initialFetchPolicy: initialFetchPolicy,
            // This ensures this.options.fetchPolicy always has a string value, in
            // case options.fetchPolicy was not provided.
            fetchPolicy: fetchPolicy
        });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0, $29Gnu.getOperationDefinition)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        // The `query` computed property will always reflect the document transformed
        // by the last run query. `this.options.query` will always reflect the raw
        // untransformed query to ensure document transforms with runtime conditionals
        // are run on the original document.
        get: function() {
            return this.lastQuery || this.options.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        // Computed shorthand for this.options.variables, preserved for
        // backwards compatibility.
        /**
         * An object containing the variables that were provided for the query.
         */ get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            // TODO: this code doesn’t actually make sense insofar as the observer
            // will never exist in this.observers due how zen-observable wraps observables.
            // https://github.com/zenparsing/zen-observable/blob/master/src/Observable.js#L169
            var observer = {
                next: function(result) {
                    resolve(result);
                    // Stop the query within the QueryManager if we can before
                    // this function returns.
                    //
                    // We do this in order to prevent observers piling up within
                    // the QueryManager. Notice that we only fully unsubscribe
                    // from the subscription in a setTimeout(..., 0)  call. This call can
                    // actually be handled by the browser at a much later time. If queries
                    // are fired in the meantime, observers that should have been removed
                    // from the QueryManager will continue to fire, causing an unnecessary
                    // performance hit.
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    /** @internal */ ObservableQuery.prototype.resetDiff = function() {
        this.queryInfo.resetDiff();
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        // Use the last result as long as the variables match this.variables.
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, $8LKEl.NetworkStatus).ready;
        var result = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, lastResult), {
            loading: (0, $8LKEl.isNetworkRequestInFlight)(networkStatus),
            networkStatus: networkStatus
        });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (// These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        $ca95980509c394dd$var$skipCacheDataFor(fetchPolicy) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers) ;
        else if (this.waitForOwnResult) // This would usually be a part of `QueryInfo.getDiff()`.
        // which we skip in the waitForOwnResult case since we are not
        // interested in the diff.
        this.queryInfo["updateWatch"]();
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) result.data = diff.result;
            if ((0, $62dod.equal)(result.data, {})) result.data = void 0;
            if (diff.complete) {
                // Similar to setting result.partial to false, but taking advantage of the
                // falsiness of missing fields.
                delete result.partial;
                // If the diff is complete, and we're using a FetchPolicy that
                // terminates after a complete cache read, we can assume the next result
                // we receive will have NetworkStatus.ready and !loading.
                if (diff.complete && result.networkStatus === (0, $8LKEl.NetworkStatus).loading && (fetchPolicy === "cache-first" || fetchPolicy === "cache-only")) {
                    result.networkStatus = (0, $8LKEl.NetworkStatus).ready;
                    result.loading = false;
                }
            } else result.partial = true;
            if (globalThis.__DEV__ !== false && !diff.complete && !this.options.partialRefetch && !result.loading && !result.data && !result.error) $ca95980509c394dd$export$b7e1973aacac3ae7(diff.missing);
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    // Compares newResult to the snapshot we took of this.lastResult when it was
    // first received.
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult, variables) {
        if (!this.last) return true;
        var resultIsDifferent = this.queryManager.getDocumentInfo(this.query).hasNonreactiveDirective ? !(0, $evGq7.equalByQuery)(this.query, this.last.result, newResult, this.variables) : !(0, $62dod.equal)(this.last.result, newResult);
        return resultIsDifferent || variables && !(0, $62dod.equal)(this.last.variables, variables);
    };
    ObservableQuery.prototype.getLast = function(key, variablesMustMatch) {
        var last = this.last;
        if (last && last[key] && (!variablesMustMatch || (0, $62dod.equal)(last.variables, this.variables))) return last[key];
    };
    ObservableQuery.prototype.getLastResult = function(variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function(variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        this.queryManager.resetErrors(this.queryId);
    };
    /**
     * Update the variables of this observable query, and fetch the new results.
     * This method should be preferred over `setVariables` in most use cases.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.refetch = function(variables) {
        var _a;
        var reobserveOptions = {
            // Always disable polling for refetches.
            pollInterval: 0
        };
        // Unless the provided fetchPolicy always consults the network
        // (no-cache, network-only, or cache-and-network), override it with
        // network-only to force the refetch for this fetchQuery call.
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "cache-and-network") reobserveOptions.fetchPolicy = fetchPolicy;
        else if (fetchPolicy === "no-cache") reobserveOptions.fetchPolicy = "no-cache";
        else reobserveOptions.fetchPolicy = "network-only";
        if (globalThis.__DEV__ !== false && variables && $ca95980509c394dd$var$hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0, $29Gnu.getQueryDefinition)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function(v) {
                return v.variable.name.value === "variables";
            })) globalThis.__DEV__ !== false && (0, $kJ26n.invariant).warn(20, variables, ((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || queryDef);
        }
        if (variables && !(0, $62dod.equal)(this.options.variables, variables)) // Update the existing options with new variables
        reobserveOptions.variables = this.options.variables = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, this.options.variables), variables);
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, (0, $8LKEl.NetworkStatus).refetch);
    };
    /**
     * A function that helps you fetch the next set of results for a [paginated list field](https://www.apollographql.com/docs/react/pagination/core-api/).
     */ ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $l73V3.__assign)((0, $l73V3.__assign)((0, $l73V3.__assign)((0, $l73V3.__assign)({}, this.options), {
            query: this.options.query
        }), fetchMoreOptions), {
            variables: (0, $l73V3.__assign)((0, $l73V3.__assign)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            // The fetchMore request goes immediately to the network and does
            // not automatically write its result to the cache (hence no-cache
            // instead of network-only), because we allow the caller of
            // fetchMore to provide an updateQuery callback that determines how
            // the data gets written to the cache.
            fetchPolicy: "no-cache"
        });
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        var qid = this.queryManager.generateQueryId();
        // If a temporary query is passed to `fetchMore`, we don't want to store
        // it as the last query result since it may be an optimized query for
        // pagination. We will however run the transforms on the original document
        // as well as the document passed in `fetchMoreOptions` to ensure the cache
        // uses the most up-to-date document which may rely on runtime conditionals.
        this.lastQuery = fetchMoreOptions.query ? this.transformDocument(this.options.query) : combinedOptions.query;
        // Simulate a loading result for the original query with
        // result.networkStatus === NetworkStatus.fetchMore.
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = (0, $8LKEl.NetworkStatus).fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) this.observe();
        var updatedQuerySet = new Set();
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, $8LKEl.NetworkStatus).fetchMore).then(function(fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === (0, $8LKEl.NetworkStatus).fetchMore) queryInfo.networkStatus = originalNetworkStatus;
            // Performing this cache update inside a cache.batch transaction ensures
            // any affected cache.watch watchers are notified at most once about any
            // updates. Most watchers will be using the QueryInfo class, which
            // responds to notifications by calling reobserveCacheFirst to deliver
            // fetchMore cache results back to this ObservableQuery.
            _this.queryManager.cache.batch({
                update: function(cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) cache.updateQuery({
                        query: _this.query,
                        variables: _this.variables,
                        returnPartialData: true,
                        optimistic: false
                    }, function(previous) {
                        return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables
                        });
                    });
                    else // If we're using a field policy instead of updateQuery, the only
                    // thing we need to do is write the new data to the cache using
                    // combinedOptions.variables (instead of this.variables, which is
                    // what this.updateQuery uses, because it works by abusing the
                    // original field value, keyed by the original variables).
                    cache.writeQuery({
                        query: combinedOptions.query,
                        variables: combinedOptions.variables,
                        data: fetchMoreResult.data
                    });
                },
                onWatchUpdated: function(watch) {
                    // Record the DocumentNode associated with any watched query whose
                    // data were updated by the cache writes above.
                    updatedQuerySet.add(watch.query);
                }
            });
            return fetchMoreResult;
        }).finally(function() {
            // In case the cache writes above did not generate a broadcast
            // notification (which would have been intercepted by onWatchUpdated),
            // likely because the written data were the same as what was already in
            // the cache, we still want fetchMore to deliver its final loading:false
            // result with the unchanged data.
            if (!updatedQuerySet.has(_this.query)) $ca95980509c394dd$export$419171d60552792a(_this);
        });
    };
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    /**
     * A function that enables you to execute a [subscription](https://www.apollographql.com/docs/react/data/subscriptions/), usually to subscribe to specific fields that were included in the query.
     *
     * This function returns _another_ function that you can call to terminate the subscription.
     */ ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                globalThis.__DEV__ !== false && (0, $kJ26n.invariant).error(21, err);
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.silentSetOptions = function(newOptions) {
        var mergedOptions = (0, $am4bq.compact)(this.options, newOptions || {});
        $ca95980509c394dd$var$assign(this.options, mergedOptions);
    };
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. Most users should prefer `refetch` instead of
     * `setVariables` in order to to be properly notified of results even when
     * they come from the cache.
     *
     * Note: the `next` callback will *not* fire if the variables have not changed
     * or if the result is coming from cache.
     *
     * Note: the promise will return the old results immediately if the variables
     * have not changed.
     *
     * Note: the promise will return null immediately if the query is not active
     * (there are no subscribers).
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.setVariables = function(variables) {
        if ((0, $62dod.equal)(this.variables, variables)) // If we have no observers, then we don't actually want to make a network
        // request. As soon as someone observes the query, the request will kick
        // off. For now, we just store any changes. (See #1077)
        return this.observers.size ? this.result() : Promise.resolve();
        this.options.variables = variables;
        // See comment above
        if (!this.observers.size) return Promise.resolve();
        return this.reobserve({
            // Reset options.fetchPolicy to its original value.
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables
        }, (0, $8LKEl.NetworkStatus).setVariables);
    };
    /**
     * A function that enables you to update the query's cached result without executing a followup GraphQL operation.
     *
     * See [using updateQuery and updateFragment](https://www.apollographql.com/docs/react/caching/cache-interaction/#using-updatequery-and-updatefragment) for additional information.
     */ ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    /**
     * A function that instructs the query to begin re-executing at a specified interval (in milliseconds).
     */ ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    /**
     * A function that instructs the query to stop polling after a previous call to `startPolling`.
     */ ObservableQuery.prototype.stopPolling = function() {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    // Update options.fetchPolicy according to options.nextFetchPolicy.
    ObservableQuery.prototype.applyNextFetchPolicy = function(reason, // It's possible to use this method to apply options.nextFetchPolicy to
    // options.fetchPolicy even if options !== this.options, though that happens
    // most often when the options are temporary, used for only one request and
    // then thrown away, so nextFetchPolicy may not end up mattering.
    options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") // When someone chooses "cache-and-network" or "network-only" as their
            // initial FetchPolicy, they often do not want future cache updates to
            // trigger unconditional network requests, which is what repeatedly
            // applying the "cache-and-network" or "network-only" policies would
            // seem to imply. Instead, when the cache reports an update after the
            // initial network request, it may be desirable for subsequent network
            // requests to be triggered only if the cache result is incomplete. To
            // that end, the options.nextFetchPolicy option provides an easy way to
            // update options.fetchPolicy after the initial network request, without
            // having to call observableQuery.setOptions.
            options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                reason: reason,
                options: options,
                observable: this,
                initialFetchPolicy: initialFetchPolicy
            });
            else if (reason === "variables-changed") options.fetchPolicy = initialFetchPolicy;
            else options.fetchPolicy = options.nextFetchPolicy;
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function(options, newNetworkStatus, query) {
        // TODO Make sure we update the networkStatus (and infer fetchVariables)
        // before actually committing to the fetch.
        this.queryManager.setObservableQuery(this);
        return this.queryManager["fetchConcastWithInfo"](this.queryId, options, newNetworkStatus, query);
    };
    // Turns polling on or off based on this.options.pollInterval.
    ObservableQuery.prototype.updatePolling = function() {
        var _this = this;
        // Avoid polling in SSR mode
        if (this.queryManager.ssrMode) return;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        (0, $kJ26n.invariant)(pollInterval, 22);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            var _a, _b;
            if (_this.pollingInfo) {
                if (!(0, $8LKEl.isNetworkRequestInFlight)(_this.queryInfo.networkStatus) && !((_b = (_a = _this.options).skipPollAttempt) === null || _b === void 0 ? void 0 : _b.call(_a))) _this.reobserve({
                    // Most fetchPolicy options don't make sense to use in a polling context, as
                    // users wouldn't want to be polling the cache directly. However, network-only and
                    // no-cache are both useful for when the user wants to control whether or not the
                    // polled results are written to the cache.
                    fetchPolicy: _this.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
                }, (0, $8LKEl.NetworkStatus).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function(newResult, variables) {
        if (variables === void 0) variables = this.variables;
        var error = this.getLastError();
        // Preserve this.last.error unless the variables have changed.
        if (error && this.last && !(0, $62dod.equal)(variables, this.last.variables)) error = void 0;
        return this.last = (0, $l73V3.__assign)({
            result: this.queryManager.assumeImmutableResults ? newResult : (0, $2dQsV.cloneDeep)(newResult),
            variables: variables
        }, error ? {
            error: error
        } : null);
    };
    ObservableQuery.prototype.reobserveAsConcast = function(newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        newNetworkStatus === (0, $8LKEl.NetworkStatus).refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        newNetworkStatus === (0, $8LKEl.NetworkStatus).fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        newNetworkStatus === (0, $8LKEl.NetworkStatus).poll;
        // Save the old variables, since Object.assign may modify them below.
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0, $am4bq.compact)(this.options, newOptions || {});
        var options = useDisposableConcast ? // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        mergedOptions : $ca95980509c394dd$var$assign(this.options, mergedOptions);
        // Don't update options.query with the transformed query to avoid
        // overwriting this.options.query when we aren't using a disposable concast.
        // We want to ensure we can re-run the custom document transforms the next
        // time a request is made against the original query.
        var query = this.transformDocument(options.query);
        this.lastQuery = query;
        if (!useDisposableConcast) {
            // We can skip calling updatePolling if we're not changing this.options.
            this.updatePolling();
            // Reset options.fetchPolicy to its original value when variables change,
            // unless a new fetchPolicy was provided by newOptions.
            if (newOptions && newOptions.variables && !(0, $62dod.equal)(newOptions.variables, oldVariables) && // Don't mess with the fetchPolicy if it's currently "standby".
            options.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
            // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
            options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) newNetworkStatus = (0, $8LKEl.NetworkStatus).setVariables;
            }
        }
        this.waitForOwnResult && (this.waitForOwnResult = $ca95980509c394dd$var$skipCacheDataFor(options.fetchPolicy));
        var finishWaitingForOwnResult = function() {
            if (_this.concast === concast) _this.waitForOwnResult = false;
        };
        var variables = options.variables && (0, $l73V3.__assign)({}, options.variables);
        var _a = this.fetch(options, newNetworkStatus, query), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function(result) {
                if ((0, $62dod.equal)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportResult(result, variables);
                }
            },
            error: function(error) {
                if ((0, $62dod.equal)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportError(error, variables);
                }
            }
        };
        if (!useDisposableConcast && (fromLink || !this.concast)) {
            // We use the {add,remove}Observer methods directly to avoid wrapping
            // observer with an unnecessary SubscriptionObserver object.
            if (this.concast && this.observer) this.concast.removeObserver(this.observer);
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        return this.reobserveAsConcast(newOptions, newNetworkStatus).promise;
    };
    ObservableQuery.prototype.resubscribeAfterError = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // If `lastError` is set in the current when the subscription is re-created,
        // the subscription will immediately receive the error, which will
        // cause it to terminate again. To avoid this, we first clear
        // the last error/result from the `observableQuery` before re-starting
        // the subscription, and restore the last value afterwards so that the
        // subscription has a chance to stay open.
        var last = this.last;
        this.resetLastResults();
        var subscription = this.subscribe.apply(this, args);
        this.last = last;
        return subscription;
    };
    // (Re)deliver the current result to this.observers without applying fetch
    // policies or making network requests.
    ObservableQuery.prototype.observe = function() {
        this.reportResult(// Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function(result, variables) {
        var lastError = this.getLastError();
        var isDifferent = this.isDifferentFromLastResult(result, variables);
        // Update the last result even when isDifferentFromLastResult returns false,
        // because the query may be using the @nonreactive directive, and we want to
        // save the the latest version of any nonreactive subtrees (in case
        // getCurrentResult is called), even though we skip broadcasting changes.
        if (lastError || !result.partial || this.options.returnPartialData) this.updateLastResult(result, variables);
        if (lastError || isDifferent) (0, $bX6rj.iterateObserversSafely)(this.observers, "next", result);
    };
    ObservableQuery.prototype.reportError = function(error, variables) {
        // Since we don't get the current result on errors, only the error, we
        // must mirror the updates that occur in QueryStore.markQueryError here
        var errorResult = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, this.getLastResult()), {
            error: error,
            errors: error.graphQLErrors,
            networkStatus: (0, $8LKEl.NetworkStatus).error,
            loading: false
        });
        this.updateLastResult(errorResult, variables);
        (0, $bX6rj.iterateObserversSafely)(this.observers, "error", this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        if (this.isTornDown) return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        // stop all active GraphQL subscriptions
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    ObservableQuery.prototype.transformDocument = function(document) {
        return this.queryManager.transform(document);
    };
    return ObservableQuery;
}((0, $bMbZ0.Observable));
// Necessary because the ObservableQuery constructor has a different
// signature than the Observable constructor.
(0, $7beJZ.fixObservableSubclass)($ca95980509c394dd$export$6c1b56eac59c9584);
function $ca95980509c394dd$export$419171d60552792a(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") return obsQuery.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(currentFetchPolicy, context) {
            // Replace this nextFetchPolicy function in the options object with the
            // original this.options.nextFetchPolicy value.
            this.nextFetchPolicy = nextFetchPolicy;
            // If the original nextFetchPolicy value was a function, give it a
            // chance to decide what happens here.
            if (typeof this.nextFetchPolicy === "function") return this.nextFetchPolicy(currentFetchPolicy, context);
            // Otherwise go back to the original this.options.fetchPolicy.
            return fetchPolicy;
        }
    });
    return obsQuery.reobserve();
}
function $ca95980509c394dd$var$defaultSubscriptionObserverErrorCallback(error) {
    globalThis.__DEV__ !== false && (0, $kJ26n.invariant).error(23, error.message, error.stack);
}
function $ca95980509c394dd$export$b7e1973aacac3ae7(missing) {
    if (globalThis.__DEV__ !== false && missing) globalThis.__DEV__ !== false && (0, $kJ26n.invariant).debug(24, missing);
}
function $ca95980509c394dd$var$skipCacheDataFor(fetchPolicy /* `undefined` would mean `"cache-first"` */ ) {
    return fetchPolicy === "network-only" || fetchPolicy === "no-cache" || fetchPolicy === "standby";
}

});
parcelRegister("2dQsV", function(module, exports) {

$parcel$export(module.exports, "cloneDeep", function () { return $19e57e41b80c71d5$export$629a2bd3f5a49ecc; });
var $19e57e41b80c71d5$var$toString = Object.prototype.toString;
function $19e57e41b80c71d5$export$629a2bd3f5a49ecc(value) {
    return $19e57e41b80c71d5$var$cloneDeepHelper(value);
}
function $19e57e41b80c71d5$var$cloneDeepHelper(val, seen) {
    switch($19e57e41b80c71d5$var$toString.call(val)){
        case "[object Array]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $19e57e41b80c71d5$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            // High fidelity polyfills of Object.create and Object.getPrototypeOf are
            // possible in all JS environments, so we will assume they exist/work.
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $19e57e41b80c71d5$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}

});

parcelRegister("evGq7", function(module, exports) {

$parcel$export(module.exports, "equalByQuery", function () { return $a904ddbdb6fde9d0$export$5e40714c5ad44445; });

var $l73V3 = parcelRequire("l73V3");

var $62dod = parcelRequire("62dod");

var $hrny3 = parcelRequire("hrny3");
var $29Gnu = parcelRequire("29Gnu");
var $RzHRn = parcelRequire("RzHRn");
var $iRdoS = parcelRequire("iRdoS");
function $a904ddbdb6fde9d0$export$5e40714c5ad44445(query, _a, _b, variables) {
    var aData = _a.data, aRest = (0, $l73V3.__rest)(_a, [
        "data"
    ]);
    var bData = _b.data, bRest = (0, $l73V3.__rest)(_b, [
        "data"
    ]);
    return (0, $62dod.default)(aRest, bRest) && $a904ddbdb6fde9d0$var$equalBySelectionSet((0, $29Gnu.getMainDefinition)(query).selectionSet, aData, bData, {
        fragmentMap: (0, $hrny3.createFragmentMap)((0, $29Gnu.getFragmentDefinitions)(query)),
        variables: variables
    });
}
function $a904ddbdb6fde9d0$var$equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) return true;
    var seenSelections = new Set();
    // Returning true from this Array.prototype.every callback function skips the
    // current field/subtree. Returning false aborts the entire traversal
    // immediately, causing equalBySelectionSet to return false.
    return selectionSet.selections.every(function(selection) {
        // Avoid re-processing the same selection at the same level of recursion, in
        // case the same field gets included via multiple indirect fragment spreads.
        if (seenSelections.has(selection)) return true;
        seenSelections.add(selection);
        // Ignore @skip(if: true) and @include(if: false) fields.
        if (!(0, $iRdoS.shouldInclude)(selection, context.variables)) return true;
        // If the field or (named) fragment spread has a @nonreactive directive on
        // it, we don't care if it's different, so we pretend it's the same.
        if ($a904ddbdb6fde9d0$var$selectionHasNonreactiveDirective(selection)) return true;
        if ((0, $RzHRn.isField)(selection)) {
            var resultKey = (0, $RzHRn.resultKeyNameFromField)(selection);
            var aResultChild = aResult && aResult[resultKey];
            var bResultChild = bResult && bResult[resultKey];
            var childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) // These are scalar values, so we can compare them with deep equal
            // without redoing the main recursive work.
            return (0, $62dod.default)(aResultChild, bResultChild);
            var aChildIsArray = Array.isArray(aResultChild);
            var bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray) return false;
            if (aChildIsArray && bChildIsArray) {
                var length_1 = aResultChild.length;
                if (bResultChild.length !== length_1) return false;
                for(var i = 0; i < length_1; ++i){
                    if (!$a904ddbdb6fde9d0$var$equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) return false;
                }
                return true;
            }
            return $a904ddbdb6fde9d0$var$equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        } else {
            var fragment = (0, $hrny3.getFragmentFromSelection)(selection, context.fragmentMap);
            if (fragment) {
                // The fragment might === selection if it's an inline fragment, but
                // could be !== if it's a named fragment ...spread.
                if ($a904ddbdb6fde9d0$var$selectionHasNonreactiveDirective(fragment)) return true;
                return $a904ddbdb6fde9d0$var$equalBySelectionSet(fragment.selectionSet, // Notice that we reuse the same aResult and bResult values here,
                // since the fragment ...spread does not specify a field name, but
                // consists of multiple fields (within the fragment's selection set)
                // that should be applied to the current result value(s).
                aResult, bResult, context);
            }
        }
    });
}
function $a904ddbdb6fde9d0$var$selectionHasNonreactiveDirective(selection) {
    return !!selection.directives && selection.directives.some($a904ddbdb6fde9d0$var$directiveIsNonreactive);
}
function $a904ddbdb6fde9d0$var$directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}

});


parcelRegister("eLbT8", function(module, exports) {

$parcel$export(module.exports, "LocalState", function () { return $abeead3fb6fd8339$export$19901bcd339c3ded; });

var $l73V3 = parcelRequire("l73V3");
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $gwqJN = parcelRequire("gwqJN");
var $ckRKY = parcelRequire("ckRKY");

var $RzHRn = parcelRequire("RzHRn");
var $2a3Iu = parcelRequire("2a3Iu");
var $hrny3 = parcelRequire("hrny3");
var $29Gnu = parcelRequire("29Gnu");
var $iRdoS = parcelRequire("iRdoS");
var $bYdjZ = parcelRequire("bYdjZ");

var $2Iyn4 = parcelRequire("2Iyn4");
var $abeead3fb6fd8339$export$19901bcd339c3ded = /** @class */ function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $bYdjZ.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $bYdjZ.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    // Run local client resolvers against the incoming query and remote data.
    // Locally resolved field values are merged with the incoming remote data,
    // and returned. Note that locally resolved fields will overwrite
    // remote data using the same field name.
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            return (0, $l73V3.__generator)(this, function(_c) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2 /*return*/ ,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    // Client queries contain everything in the incoming document (if a @client
    // directive is found).
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $iRdoS.hasDirectives)([
            "client"
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    // Server queries are stripped of all @client based selection sets.
    LocalState.prototype.serverQuery = function(document) {
        return (0, $2a3Iu.removeClientSetsFromDocument)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, context), {
            cache: cache,
            // Getting an entry's cache key is useful for local state resolvers.
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    // To support `@client @export(as: "someVar")` syntax, we'll first resolve
    // @client @export fields locally, then pass the resolved values back to be
    // used alongside the original operation variables.
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            return (0, $l73V3.__generator)(this, function(_a) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2 /*return*/ ,
                    (0, $l73V3.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $gwqJN.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $gwqJN.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    // Query the cache and return matching data.
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $2a3Iu.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            return (0, $l73V3.__generator)(this, function(_b) {
                mainDefinition = (0, $29Gnu.getMainDefinition)(document);
                fragments = (0, $29Gnu.getFragmentDefinitions)(document);
                fragmentMap = (0, $hrny3.createFragmentMap)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $l73V3.__assign)((0, $l73V3.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                isClientFieldDescendant = false;
                return [
                    2 /*return*/ ,
                    this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $l73V3.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $l73V3.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $l73V3.__generator)(this, function(_a) {
                            if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) // Skip selections without @client directives
                            // (still processing if one of the ancestors or one of the child fields has @client directive)
                            return [
                                2 /*return*/ 
                            ];
                            if (!(0, $iRdoS.shouldInclude)(selection, variables)) // Skip this entirely.
                            return [
                                2 /*return*/ 
                            ];
                            if ((0, $RzHRn.isField)(selection)) return [
                                2 /*return*/ ,
                                this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") resultsToMerge.push((_a = {}, _a[(0, $RzHRn.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $RzHRn.isInlineFragment)(selection)) fragment = selection;
                            else {
                                // This is a named fragment.
                                fragment = fragmentMap[selection.name.value];
                                (0, $kJ26n.invariant)(fragment, 18, selection.name.value);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2 /*return*/ ,
                                    this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                return [
                    2 /*return*/ ,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $bYdjZ.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, isClientFieldDescendant, rootValue, execContext) {
        return (0, $l73V3.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $l73V3.__generator)(this, function(_a) {
                if (!rootValue) return [
                    2 /*return*/ ,
                    null
                ];
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $RzHRn.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                // Usually all local resolvers are run when passing through here, but
                // if we've specifically identified that we only want to run forced
                // resolvers (that is, resolvers for fields marked with
                // `@client(always: true)`), then we'll skip running non-forced resolvers.
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(// In case the resolve function accesses reactive variables,
                        // set cacheSlot to the current cache instance.
                        (0, $2Iyn4.cacheSlot).withValue(this.cache, resolve, [
                            rootValue,
                            (0, $RzHRn.argumentsObjectFromField)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2 /*return*/ ,
                    resultPromise.then(function(result) {
                        var _a, _b;
                        if (result === void 0) result = defaultResult;
                        // If an @export directive is associated with the current field, store
                        // the `as` export variable name and current result for later use.
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === "export" && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === "as" && arg.value.kind === "StringValue") execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        // Handle all scalar types here.
                        if (!field.selectionSet) return result;
                        // From here down, the field has a selection set, which means it's trying
                        // to query a GraphQLObjectType.
                        if (result == null) // Basically any field in a GraphQL response can be null, or missing
                        return result;
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function(d) {
                            return d.name.value === "client";
                        })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        // Returned value is an object, and the query has a sub-selection. Recurse.
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            // This is a nested array, recurse.
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            // This is an object, run the selection set on it.
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
        }));
    };
    // Collect selection nodes on paths from document root down to all @client directives.
    // This function takes into account transitive fragment spreads.
    // Complexity equals to a single `visit` over the full document.
    LocalState.prototype.collectSelectionsToResolve = function(mainDefinition, fragmentMap) {
        var isSingleASTNode = function(node) {
            return !Array.isArray(node);
        };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0, $gwqJN.visit)(definitionNode, {
                    Directive: function(node, _, __, ___, ancestors) {
                        if (node.name.value === "client") ancestors.forEach(function(node) {
                            if (isSingleASTNode(node) && (0, $ckRKY.isSelectionNode)(node)) matches_1.add(node);
                        });
                    },
                    FragmentSpread: function(spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        (0, $kJ26n.invariant)(fragment, 19, spread.name.value);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            // Fragment for this spread contains @client directive (either directly or transitively)
                            // Collect selection nodes on paths from the root down to fields with the @client directive
                            ancestors.forEach(function(node) {
                                if (isSingleASTNode(node) && (0, $ckRKY.isSelectionNode)(node)) matches_1.add(node);
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function(selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}();

});
parcelRegister("ckRKY", function(module, exports) {

$parcel$export(module.exports, "isSelectionNode", function () { return $2b06d986fb002bd1$export$65772b71e1d017ba; });

var $kKcD5 = parcelRequire("kKcD5");
function $2b06d986fb002bd1$export$e7ecd7c16613ccfd(node) {
    return $2b06d986fb002bd1$export$4cedd8740794bd78(node) || $2b06d986fb002bd1$export$b05c7141ec7770ba(node) || $2b06d986fb002bd1$export$fbc18e88163d676d(node);
}
function $2b06d986fb002bd1$export$4cedd8740794bd78(node) {
    return node.kind === (0, $kKcD5.Kind).OPERATION_DEFINITION || node.kind === (0, $kKcD5.Kind).FRAGMENT_DEFINITION;
}
function $2b06d986fb002bd1$export$65772b71e1d017ba(node) {
    return node.kind === (0, $kKcD5.Kind).FIELD || node.kind === (0, $kKcD5.Kind).FRAGMENT_SPREAD || node.kind === (0, $kKcD5.Kind).INLINE_FRAGMENT;
}
function $2b06d986fb002bd1$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $kKcD5.Kind).VARIABLE || node.kind === (0, $kKcD5.Kind).INT || node.kind === (0, $kKcD5.Kind).FLOAT || node.kind === (0, $kKcD5.Kind).STRING || node.kind === (0, $kKcD5.Kind).BOOLEAN || node.kind === (0, $kKcD5.Kind).NULL || node.kind === (0, $kKcD5.Kind).ENUM || node.kind === (0, $kKcD5.Kind).LIST || node.kind === (0, $kKcD5.Kind).OBJECT;
}
function $2b06d986fb002bd1$export$f95bfad9e6aea45f(node) {
    return $2b06d986fb002bd1$export$ab65b54ec7cbe9e4(node) && (node.kind === (0, $kKcD5.Kind).LIST ? node.values.some($2b06d986fb002bd1$export$f95bfad9e6aea45f) : node.kind === (0, $kKcD5.Kind).OBJECT ? node.fields.some((field)=>$2b06d986fb002bd1$export$f95bfad9e6aea45f(field.value)) : node.kind !== (0, $kKcD5.Kind).VARIABLE);
}
function $2b06d986fb002bd1$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $kKcD5.Kind).NAMED_TYPE || node.kind === (0, $kKcD5.Kind).LIST_TYPE || node.kind === (0, $kKcD5.Kind).NON_NULL_TYPE;
}
function $2b06d986fb002bd1$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $kKcD5.Kind).SCHEMA_DEFINITION || $2b06d986fb002bd1$export$a3584bba04f5bfe0(node) || node.kind === (0, $kKcD5.Kind).DIRECTIVE_DEFINITION;
}
function $2b06d986fb002bd1$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $kKcD5.Kind).SCALAR_TYPE_DEFINITION || node.kind === (0, $kKcD5.Kind).OBJECT_TYPE_DEFINITION || node.kind === (0, $kKcD5.Kind).INTERFACE_TYPE_DEFINITION || node.kind === (0, $kKcD5.Kind).UNION_TYPE_DEFINITION || node.kind === (0, $kKcD5.Kind).ENUM_TYPE_DEFINITION || node.kind === (0, $kKcD5.Kind).INPUT_OBJECT_TYPE_DEFINITION;
}
function $2b06d986fb002bd1$export$fbc18e88163d676d(node) {
    return node.kind === (0, $kKcD5.Kind).SCHEMA_EXTENSION || $2b06d986fb002bd1$export$d7907721b241e11f(node);
}
function $2b06d986fb002bd1$export$d7907721b241e11f(node) {
    return node.kind === (0, $kKcD5.Kind).SCALAR_TYPE_EXTENSION || node.kind === (0, $kKcD5.Kind).OBJECT_TYPE_EXTENSION || node.kind === (0, $kKcD5.Kind).INTERFACE_TYPE_EXTENSION || node.kind === (0, $kKcD5.Kind).UNION_TYPE_EXTENSION || node.kind === (0, $kKcD5.Kind).ENUM_TYPE_EXTENSION || node.kind === (0, $kKcD5.Kind).INPUT_OBJECT_TYPE_EXTENSION;
}

});

parcelRegister("2Iyn4", function(module, exports) {

$parcel$export(module.exports, "cacheSlot", function () { return $1faa5a327a0fb537$export$ac9723609f5c76c2; });
$parcel$export(module.exports, "forgetCache", function () { return $1faa5a327a0fb537$export$cbe12faed7725318; });
$parcel$export(module.exports, "recallCache", function () { return $1faa5a327a0fb537$export$f342bdd61b3e9412; });
$parcel$export(module.exports, "makeVar", function () { return $1faa5a327a0fb537$export$5345c8ac69b4a9db; });
parcelRequire("kMsgy");
var $3Nd2v = parcelRequire("3Nd2v");
var $JEzHp = parcelRequire("JEzHp");
var $1faa5a327a0fb537$export$ac9723609f5c76c2 = new (0, $JEzHp.Slot)();
var $1faa5a327a0fb537$var$cacheInfoMap = new WeakMap();
function $1faa5a327a0fb537$var$getCacheInfo(cache) {
    var info = $1faa5a327a0fb537$var$cacheInfoMap.get(cache);
    if (!info) $1faa5a327a0fb537$var$cacheInfoMap.set(cache, info = {
        vars: new Set(),
        dep: (0, $3Nd2v.dep)()
    });
    return info;
}
function $1faa5a327a0fb537$export$cbe12faed7725318(cache) {
    $1faa5a327a0fb537$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.forgetCache(cache);
    });
}
function $1faa5a327a0fb537$export$f342bdd61b3e9412(cache) {
    $1faa5a327a0fb537$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.attachCache(cache);
    });
}
function $1faa5a327a0fb537$export$5345c8ac69b4a9db(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function(cache) {
                    // Invalidate any fields with custom read functions that
                    // consumed this variable, so query results involving those
                    // fields will be recomputed the next time we read them.
                    $1faa5a327a0fb537$var$getCacheInfo(cache).dep.dirty(rv);
                    // Broadcast changes to any caches that have previously read
                    // from this variable.
                    $1faa5a327a0fb537$var$broadcast(cache);
                });
                // Finally, notify any listeners added via rv.onNextChange.
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function(listener) {
                    return listener(value);
                });
            }
        } else {
            // When reading from the variable, obtain the current cache from
            // context via cacheSlot. This isn't entirely foolproof, but it's
            // the same system that powers varDep.
            var cache = $1faa5a327a0fb537$export$ac9723609f5c76c2.getValue();
            if (cache) {
                attach(cache);
                $1faa5a327a0fb537$var$getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function(cache) {
        caches.add(cache);
        $1faa5a327a0fb537$var$getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function(cache) {
        return caches.delete(cache);
    };
    return rv;
}
function $1faa5a327a0fb537$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}

});


parcelRegister("hXKAm", function(module, exports) {

$parcel$export(module.exports, "QueryInfo", function () { return $d13c153f0fd63b8a$export$79a6120a39c90b6a; });
$parcel$export(module.exports, "shouldWriteResult", function () { return $d13c153f0fd63b8a$export$5f47a9fb9a521654; });

var $l73V3 = parcelRequire("l73V3");

var $62dod = parcelRequire("62dod");

var $8L3vO = parcelRequire("8L3vO");
var $bYdjZ = parcelRequire("bYdjZ");
var $fjRIS = parcelRequire("fjRIS");
var $2emDS = parcelRequire("2emDS");
var $kavKO = parcelRequire("kavKO");

var $holO6 = parcelRequire("holO6");

var $8LKEl = parcelRequire("8LKEl");
var $d13c153f0fd63b8a$var$destructiveMethodCounts = new ((0, $8L3vO.canUseWeakMap) ? WeakMap : Map)();
function $d13c153f0fd63b8a$var$wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") // @ts-expect-error this is just too generic to be typed correctly
    cache[methodName] = function() {
        $d13c153f0fd63b8a$var$destructiveMethodCounts.set(cache, // The %1e15 allows the count to wrap around to 0 safely every
        // quadrillion evictions, so there's no risk of overflow. To be
        // clear, this is more of a pedantic principle than something
        // that matters in any conceivable practical scenario.
        ($d13c153f0fd63b8a$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        // @ts-expect-error this is just too generic to be typed correctly
        return original.apply(this, arguments);
    };
}
function $d13c153f0fd63b8a$var$cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
// A QueryInfo object represents a single query managed by the
// QueryManager, which tracks all QueryInfo objects by queryId in its
// this.queries Map. QueryInfo objects store the latest results and errors
// for the given query, and are responsible for reporting those results to
// the corresponding ObservableQuery, via the QueryInfo.notify method.
// Results are reported asynchronously whenever setDiff marks the
// QueryInfo object as dirty, though a call to the QueryManager's
// broadcastQueries method may trigger the notification before it happens
// automatically. This class used to be a simple interface type without
// any field privacy or meaningful methods, which is why it still has so
// many public fields. The effort to lock down and simplify the QueryInfo
// interface is ongoing, and further improvements are welcome.
var $d13c153f0fd63b8a$export$79a6120a39c90b6a = /** @class */ function() {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) queryId = queryManager.generateQueryId();
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        // Track how often cache.evict is called, since we want eviction to
        // override the feud-stopping logic in the markResult method, by
        // causing shouldWrite to return true. Wrapping the cache.evict method
        // is a bit of a hack, but it saves us from having to make eviction
        // counting an official part of the ApolloCache API.
        if (!$d13c153f0fd63b8a$var$destructiveMethodCounts.has(cache)) {
            $d13c153f0fd63b8a$var$destructiveMethodCounts.set(cache, 0);
            $d13c153f0fd63b8a$var$wrapDestructiveCacheMethod(cache, "evict");
            $d13c153f0fd63b8a$var$wrapDestructiveCacheMethod(cache, "modify");
            $d13c153f0fd63b8a$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, $8LKEl.NetworkStatus).loading;
        if (this.variables && this.networkStatus !== (0, $8LKEl.NetworkStatus).loading && !(0, $62dod.equal)(this.variables, query.variables)) networkStatus = (0, $8LKEl.NetworkStatus).setVariables;
        if (!(0, $62dod.equal)(query.variables, this.variables)) this.lastDiff = void 0;
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.reset = function() {
        $d13c153f0fd63b8a$var$cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.resetDiff = function() {
        this.lastDiff = void 0;
    };
    QueryInfo.prototype.getDiff = function() {
        var options = this.getDiffOptions();
        if (this.lastDiff && (0, $62dod.equal)(options, this.lastDiff.options)) return this.lastDiff.diff;
        this.updateWatch(this.variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return {
            complete: false
        };
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function(diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions()
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function(variables) {
        var _a;
        if (variables === void 0) variables = this.variables;
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults
        };
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _this = this;
        var _a;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        // If we do not tolerate partial results, skip this update to prevent it
        // from being reported. This prevents a situtuation where a query that
        // errors and another succeeds with overlapping data does not report the
        // partial data result to the errored query.
        //
        // See https://github.com/apollographql/apollo-client/issues/11400 for more
        // information on this issue.
        if (diff && !diff.complete && !((_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.returnPartialData) && // In the case of a cache eviction, the diff will become partial so we
        // schedule a notification to send a network request (this.oqListener) to
        // go and fetch the missing data.
        !(oldDiff && oldDiff.complete)) return;
        this.updateLastDiff(diff);
        if (!this.dirty && !(0, $62dod.equal)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
                return _this.notify();
            }, 0);
        }
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        var _this = this;
        if (oq === this.observableQuery) return;
        if (this.oqListener) this.listeners.delete(this.oqListener);
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function() {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) // If this diff came from an optimistic transaction, deliver the
                // current cache data to the ObservableQuery, but don't perform a
                // reobservation, since oq.reobserveCacheFirst might make a network
                // request, and we never want to trigger network requests in the
                // middle of optimistic updates.
                oq["observe"]();
                else // Otherwise, make the ObservableQuery "reobserve" the latest data
                // using a temporary fetch policy of "cache-first", so complete cache
                // results have a chance to be delivered without triggering additional
                // network requests, even when options.fetchPolicy is "network-only"
                // or "cache-and-network". All other fetch policies are preserved by
                // this method, and are handled by calling oq.reobserve(). If this
                // reobservation is spurious, isDifferentFromLastResult still has a
                // chance to catch it before delivery to ObservableQuery subscribers.
                (0, $holO6.reobserveCacheFirst)(oq);
            });
        } else delete this.oqListener;
    };
    QueryInfo.prototype.notify = function() {
        var _this = this;
        $d13c153f0fd63b8a$var$cancelNotifyTimeout(this);
        if (this.shouldNotify()) this.listeners.forEach(function(listener) {
            return listener(_this);
        });
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function() {
        if (!this.dirty || !this.listeners.size) return false;
        if ((0, $8LKEl.isNetworkRequestInFlight)(this.networkStatus) && this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") return false;
        }
        return true;
    };
    QueryInfo.prototype.stop = function() {
        if (!this.stopped) {
            this.stopped = true;
            // Cancel the pending notify timeout
            this.reset();
            this.cancel();
            // Revert back to the no-op version of cancel inherited from
            // QueryInfo.prototype.
            this.cancel = QueryInfo.prototype.cancel;
            var oq = this.observableQuery;
            if (oq) oq.stopPolling();
        }
    };
    // This method is a no-op by default, until/unless overridden by the
    // updateWatch method.
    QueryInfo.prototype.cancel = function() {};
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        var watchOptions = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, this.getDiffOptions(variables)), {
            watcher: this,
            callback: function(diff) {
                return _this.setDiff(diff);
            }
        });
        if (!this.lastWatch || !(0, $62dod.equal)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && // If cache.evict has been called since the last time we wrote this
        // data into the cache, there's a chance writing this result into
        // the cache will repair what was evicted.
        lastWrite.dmCount === $d13c153f0fd63b8a$var$destructiveMethodCounts.get(this.cache) && (0, $62dod.equal)(variables, lastWrite.variables) && (0, $62dod.equal)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, document, options, cacheWriteBehavior) {
        var _this = this;
        var merger = new (0, $bYdjZ.DeepMerger)();
        var graphQLErrors = (0, $2emDS.isNonEmptyArray)(result.errors) ? result.errors.slice(0) : [];
        // Cancel the pending notify timeout (if it exists) to prevent extraneous network
        // requests. To allow future notify timeouts, diff and dirty are reset as well.
        this.reset();
        if ("incremental" in result && (0, $2emDS.isNonEmptyArray)(result.incremental)) {
            var mergedData = (0, $kavKO.mergeIncrementalData)(this.getDiff().result, result);
            result.data = mergedData;
        // Detect the first chunk of a deferred query and merge it with existing
        // cache data. This ensures a `cache-first` fetch policy that returns
        // partial cache data or a `cache-and-network` fetch policy that already
        // has full data in the cache does not complain when trying to merge the
        // initial deferred server data with existing cache data.
        } else if ("hasNext" in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === "no-cache") this.updateLastDiff({
            result: result.data,
            complete: true
        }, this.getDiffOptions(options.variables));
        else if (cacheWriteBehavior !== 0 /* CacheWriteBehavior.FORBID */ ) {
            if ($d13c153f0fd63b8a$export$5f47a9fb9a521654(result, options.errorPolicy)) // Using a transaction here so we have a chance to read the result
            // back from the cache before the watch callback fires as a result
            // of writeQuery, so we can store the new diff quietly and ignore
            // it when we receive it redundantly from the watch callback.
            this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: document,
                        data: result.data,
                        variables: options.variables,
                        overwrite: cacheWriteBehavior === 1 /* CacheWriteBehavior.OVERWRITE */ 
                    });
                    _this.lastWrite = {
                        result: result,
                        variables: options.variables,
                        dmCount: $d13c153f0fd63b8a$var$destructiveMethodCounts.get(_this.cache)
                    };
                } else // If result is the same as the last result we received from
                // the network (and the variables match too), avoid writing
                // result into the cache again. The wisdom of skipping this
                // cache write is far from obvious, since any cache write
                // could be the one that puts the cache back into a desired
                // state, fixing corruption or missing data. However, if we
                // always write every network result into the cache, we enable
                // feuds between queries competing to update the same data in
                // incompatible ways, which can lead to an endless cycle of
                // cache broadcasts and useless network requests. As with any
                // feud, eventually one side must step back from the brink,
                // letting the other side(s) have the last word(s). There may
                // be other points where we could break this cycle, such as
                // silencing the broadcast for cache.writeQuery (not a good
                // idea, since it just delays the feud a bit) or somehow
                // avoiding the network request that just happened (also bad,
                // because the server could return useful new data). All
                // options considered, skipping this cache write seems to be
                // the least damaging place to break the cycle, because it
                // reflects the intuition that we recently wrote this exact
                // result into the cache, so the cache *should* already/still
                // contain this data. If some other query has clobbered that
                // data in the meantime, that's too bad, but there will be no
                // winners if every query blindly reverts to its own version
                // of the data. This approach also gives the network a chance
                // to return new data, which will be written into the cache as
                // usual, notifying only those queries that are directly
                // affected by the cache updates, as usual. In the future, an
                // even more sophisticated cache could perhaps prevent or
                // mitigate the clobbering somehow, but that would make this
                // particular cache write even less important, and thus
                // skipping it would be even safer than it is today.
                if (_this.lastDiff && _this.lastDiff.diff.complete) {
                    // Reuse data from the last good (complete) diff that we
                    // received, when possible.
                    result.data = _this.lastDiff.diff.result;
                    return;
                }
                var diffOptions = _this.getDiffOptions(options.variables);
                var diff = cache.diff(diffOptions);
                // In case the QueryManager stops this QueryInfo before its
                // results are delivered, it's important to avoid restarting the
                // cache watch when markResult is called. We also avoid updating
                // the watch if we are writing a result that doesn't match the current
                // variables to avoid race conditions from broadcasting the wrong
                // result.
                if (!_this.stopped && (0, $62dod.equal)(_this.variables, options.variables)) // Any time we're about to update this.diff, we need to make
                // sure we've started watching the cache.
                _this.updateWatch(options.variables);
                // If we're allowed to write to the cache, and we can read a
                // complete result from the cache, update result.data to be the
                // result from the cache, rather than the raw network result.
                // Set without setDiff to avoid triggering a notify call, since
                // we have other ways of notifying for this result.
                _this.updateLastDiff(diff, diffOptions);
                if (diff.complete) result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, $8LKEl.NetworkStatus).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        this.networkStatus = (0, $8LKEl.NetworkStatus).error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function $d13c153f0fd63b8a$export$5f47a9fb9a521654(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, $fjRIS.graphQLResultHasError)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}

});



parcelRegister("4B3dP", function(module, exports) {

$parcel$export(module.exports, "InMemoryCache", function () { return $358d1df74a24a3aa$export$467265324939f47f; });

var $l73V3 = parcelRequire("l73V3");
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");


var $kMsgy = parcelRequire("kMsgy");

var $62dod = parcelRequire("62dod");

var $lm9Ep = parcelRequire("lm9Ep");

var $1SEYm = parcelRequire("1SEYm");

var $2a3Iu = parcelRequire("2a3Iu");
var $iOXJM = parcelRequire("iOXJM");
var $gGpvG = parcelRequire("gGpvG");
var $ipGXK = parcelRequire("ipGXK");
var $RzHRn = parcelRequire("RzHRn");
var $3owxW = parcelRequire("3owxW");

var $9noZ5 = parcelRequire("9noZ5");

var $joD5f = parcelRequire("joD5f");

var $8iWhK = parcelRequire("8iWhK");

var $2Iyn4 = parcelRequire("2Iyn4");

var $3I2FA = parcelRequire("3I2FA");

var $bZkp6 = parcelRequire("bZkp6");

var $3qXPo = parcelRequire("3qXPo");
var $358d1df74a24a3aa$export$467265324939f47f = /** @class */ function(_super) {
    (0, $l73V3.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.addTypenameTransform = new (0, $ipGXK.DocumentTransform)((0, $2a3Iu.addTypenameToDocument));
        // Override the default value, since InMemoryCache result objects are frozen
        // in development and expected to remain logically immutable in production.
        _this.assumeImmutableResults = true;
        _this.makeVar = (0, $2Iyn4.makeVar);
        _this.txCount = 0;
        _this.config = (0, $bZkp6.normalizeConfig)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new (0, $3I2FA.Policies)({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function() {
        // Passing { resultCaching: false } in the InMemoryCache constructor options
        // will completely disable dependency tracking, which will improve memory
        // usage but worsen the performance of repeated reads.
        var rootStore = this.data = new (0, $8iWhK.EntityStore).Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching
        });
        // When no optimistic writes are currently active, cache.optimisticData ===
        // cache.data, so there are no additional layers on top of the actual data.
        // When an optimistic update happens, this.optimisticData will become a
        // linked list of EntityStore Layer objects that terminates with the
        // original this.data cache object.
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function(resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        // The StoreWriter is mostly stateless and so doesn't really need to be
        // reset, but it does need to have its writer.storeReader reference updated,
        // so it's simpler to update this.storeWriter as well.
        this.storeWriter = new (0, $joD5f.StoreWriter)(this, this.storeReader = new (0, $9noZ5.StoreReader)({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0, $bZkp6.shouldCanonizeResults)(this.config),
            canon: resetResultIdentities ? void 0 : previousReader && previousReader.canon,
            fragments: fragments
        }), fragments);
        this.maybeBroadcastWatch = (0, $kMsgy.wrap)(function(c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $iOXJM.cacheSizes)["inMemoryCache.maybeBroadcastWatch"] || 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
            makeCacheKey: function(c) {
                // Return a cache key (thus enabling result caching) only if we're
                // currently using a data store that can track cache dependencies.
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if ((0, $8iWhK.supportsResultCaching)(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, // Different watches can have the same query, optimistic
                    // status, rootId, and variables, but if their callbacks are
                    // different, the (identical) result needs to be delivered to
                    // each distinct callback. The easiest way to achieve that
                    // separation is to include c.callback in the cache key for
                    // maybeBroadcastWatch calls. See issue #5733.
                    c.callback, (0, $gGpvG.canonicalStringify)({
                        optimistic: optimistic,
                        id: id,
                        variables: variables
                    }));
                }
            }
        });
        // Since we have thrown away all the cached functions that depend on the
        // CacheGroup dependencies maintained by EntityStore, we should also reset
        // all CacheGroup dependency information.
        new Set([
            this.data.group,
            this.optimisticData.group
        ]).forEach(function(group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function(data) {
        this.init();
        // Since calling this.init() discards/replaces the entire StoreReader, along
        // with the result caches it maintains, this.data.replace(data) won't have
        // to bother deleting the old data.
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function(options) {
        var // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        _a = options.returnPartialData, // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
                store: options.optimistic ? this.optimisticData : this.data,
                config: this.config,
                returnPartialData: returnPartialData
            })).result || null;
        } catch (e) {
            if (e instanceof (0, $1SEYm.MissingFieldError)) // Swallow MissingFieldError and return null, so callers do not need to
            // worry about catching "normal" exceptions resulting from incomplete
            // cache data. Unexpected errors will be re-thrown. If you need more
            // information about which fields were missing, use cache.diff instead,
            // and examine diffResult.missing.
            return null;
            throw e;
        }
    };
    InMemoryCache.prototype.write = function(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.modify = function(options) {
        if ((0, $bZkp6.hasOwn).call(options, "id") && !options.id) // To my knowledge, TypeScript does not currently provide a way to
        // enforce that an optional property?:type must *not* be undefined
        // when present. That ability would be useful here, because we want
        // options.id to default to ROOT_QUERY only when no options.id was
        // provided. If the caller attempts to pass options.id with a
        // falsy/undefined value (perhaps because cache.identify failed), we
        // should not assume the goal was to modify the ROOT_QUERY object.
        // We could throw, but it seems natural to return false to indicate
        // that nothing was modified.
        return false;
        var store = options.optimistic // Defaults to false.
         ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.diff = function(options) {
        return this.storeReader.diffQueryAgainstStore((0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            config: this.config
        }));
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        if (!this.watches.size) // In case we previously called forgetCache(this) because
        // this.watches became empty (see below), reattach this cache to any
        // reactive variables on which it previously depended. It might seem
        // paradoxical that we're able to recall something we supposedly
        // forgot, but the point of calling forgetCache(this) is to silence
        // useless broadcasts while this.watches is empty, and to allow the
        // cache to be garbage collected. If, however, we manage to call
        // recallCache(this) here, this cache object must not have been
        // garbage collected yet, and should resume receiving updates from
        // reactive variables, now that it has a watcher to notify.
        (0, $2Iyn4.recallCache)(this);
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return function() {
            // Once we remove the last watch from this.watches, cache.broadcastWatches
            // no longer does anything, so we preemptively tell the reactive variable
            // system to exclude this cache from future broadcasts.
            if (_this.watches.delete(watch) && !_this.watches.size) (0, $2Iyn4.forgetCache)(_this);
            // Remove this watch from the LRU cache managed by the
            // maybeBroadcastWatch OptimisticWrapperFunction, to prevent memory
            // leaks involving the closure of watch.callback.
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function(options) {
        var _a;
        (0, $gGpvG.canonicalStringify).reset();
        (0, $3owxW.print).reset();
        this.addTypenameTransform.resetCache();
        (_a = this.config.fragments) === null || _a === void 0 || _a.resetCaches();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) this.resetResultCache(options.resetResultIdentities);
            else if (options.resetResultIdentities) this.storeReader.resetCanon();
        }
        return ids;
    };
    // Call this method to ensure the given root ID remains in the cache after
    // garbage collection, along with its transitive child entities. Note that
    // the cache automatically retains all directly written entities. By default,
    // the retainment persists after optimistic updates are removed. Pass true
    // for the optimistic argument if you would prefer for the retainment to be
    // discarded when the top-most optimistic layer is removed. Returns the
    // resulting (non-negative) retainment count.
    InMemoryCache.prototype.retain = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    // Call this method to undo the effect of the retain method, above. Once the
    // retainment count falls to zero, the given ID will no longer be preserved
    // during garbage collection, though it may still be preserved by other safe
    // entities that refer to it. Returns the resulting (non-negative) retainment
    // count, in case that's useful.
    InMemoryCache.prototype.release = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    // Returns the canonical ID for a given StoreObject, obeying typePolicies
    // and keyFields (and dataIdFromObject, if you still use that). At minimum,
    // the object must contain a __typename and any primary key fields required
    // to identify entities of that type. If you pass a query result object, be
    // sure that none of the primary key fields have been renamed by aliasing.
    // If you pass a Reference object, its __ref ID string will be returned.
    InMemoryCache.prototype.identify = function(object) {
        if ((0, $RzHRn.isReference)(object)) return object.__ref;
        try {
            return this.policies.identify(object)[0];
        } catch (e) {
            globalThis.__DEV__ !== false && (0, $kJ26n.invariant).warn(e);
        }
    };
    InMemoryCache.prototype.evict = function(options) {
        if (!options.id) {
            if ((0, $bZkp6.hasOwn).call(options, "id")) // See comment in modify method about why we return false when
            // options.id exists but is falsy/undefined.
            return false;
            options = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
                id: "ROOT_QUERY"
            });
        }
        try {
            // It's unlikely that the eviction will end up invoking any other
            // cache update operations while it's running, but {in,de}crementing
            // this.txCount still seems like a good idea, for uniformity with
            // the other update methods.
            ++this.txCount;
            // Pass this.data as a limit on the depth of the eviction, so evictions
            // during optimistic updates (when this.data is temporarily set equal to
            // this.optimisticData) do not escape their optimistic Layer.
            return this.optimisticData.evict(options, this.data);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.reset = function(options) {
        var _this = this;
        this.init();
        (0, $gGpvG.canonicalStringify).reset();
        if (options && options.discardWatches) {
            // Similar to what happens in the unsubscribe function returned by
            // cache.watch, applied to all current watches.
            this.watches.forEach(function(watch) {
                return _this.maybeBroadcastWatch.forget(watch);
            });
            this.watches.clear();
            (0, $2Iyn4.forgetCache)(this);
        } else // Calling this.init() above unblocks all maybeBroadcastWatch caching, so
        // this.broadcastWatches() triggers a broadcast to every current watcher
        // (letting them know their data is now missing). This default behavior is
        // convenient because it means the watches do not have to be manually
        // reestablished after resetting the cache. To prevent this broadcast and
        // cancel all watches, pass true for options.discardWatches.
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function(options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function(layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) _this.data = _this.optimisticData = layer;
            try {
                return updateResult = update(_this);
            } finally{
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) // If an options.onWatchUpdated callback is provided, we want to call it
        // with only the Cache.WatchOptions objects affected by options.update,
        // but there might be dirty watchers already waiting to be broadcast that
        // have nothing to do with the update. To prevent including those watchers
        // in the post-update broadcast, we perform this initial broadcast to
        // collect the dirty watchers, so we can re-dirty them later, after the
        // post-update broadcast, allowing them to receive their pending
        // broadcasts the next time broadcastWatches is called, just as they would
        // if we never called cache.batch.
        this.broadcastWatches((0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
            onWatchUpdated: function(watch) {
                alreadyDirty.add(watch);
                return false;
            }
        }));
        if (typeof optimistic === "string") // Note that there can be multiple layers with the same optimistic ID.
        // When removeOptimistic(id) is called for that id, all matching layers
        // will be removed, and the remaining layers will be reapplied.
        this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        else if (optimistic === false) // Ensure both this.data and this.optimisticData refer to the root
        // (non-optimistic) layer of the cache during the update. Note that
        // this.data could be a Layer if we are currently executing an optimistic
        // update function, but otherwise will always be an EntityStore.Root
        // instance.
        perform(this.data);
        else // Otherwise, leave this.data and this.optimisticData unchanged and run
        // the update with broadcast batching.
        perform();
        if (typeof removeOptimistic === "string") this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        // Note: if this.txCount > 0, then alreadyDirty.size === 0, so this code
        // takes the else branch and calls this.broadcastWatches(options), which
        // does nothing when this.txCount > 0.
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
                onWatchUpdated: function(watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) // Since onWatchUpdated did not return false, this diff is
                    // about to be broadcast to watch.callback, so we don't need
                    // to re-dirty it with the other alreadyDirty watches below.
                    alreadyDirty.delete(watch);
                    return result;
                }
            }));
            // Silently re-dirty any watches that were already dirty before the update
            // was performed, and were not broadcast just now.
            if (alreadyDirty.size) alreadyDirty.forEach(function(watch) {
                return _this.maybeBroadcastWatch.dirty(watch);
            });
        } else // If alreadyDirty is empty or we don't have an onWatchUpdated
        // function, we don't need to go to the trouble of wrapping
        // options.onWatchUpdated.
        this.broadcastWatches(options);
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function(update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null
        });
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(document));
    };
    InMemoryCache.prototype.broadcastWatches = function(options) {
        var _this = this;
        if (!this.txCount) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c, options);
        });
    };
    InMemoryCache.prototype.addFragmentsToDocument = function(document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.addTypenameToDocument = function(document) {
        if (this.addTypename) return this.addTypenameTransform.transformDocument(document);
        return document;
    };
    // This method is wrapped by maybeBroadcastWatch, which is called by
    // broadcastWatches, so that we compute and broadcast results only when
    // the data that would be broadcast might have changed. It would be
    // simpler to check for changes after recomputing a result but before
    // broadcasting it, but this wrapping approach allows us to skip both
    // the recomputation and the broadcast, in most cases.
    InMemoryCache.prototype.broadcastWatch = function(c, options) {
        var lastDiff = c.lastDiff;
        // Both WatchOptions and DiffOptions extend ReadOptions, and DiffOptions
        // currently requires no additional properties, so we can use c (a
        // WatchOptions object) as DiffOptions, without having to allocate a new
        // object, and without having to enumerate the relevant properties (query,
        // variables, etc.) explicitly. There will be some additional properties
        // (lastDiff, callback, etc.), but cache.diff ignores them.
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") diff.fromOptimisticTransaction = true;
            if (options.onWatchUpdated && options.onWatchUpdated.call(this, c, diff, lastDiff) === false) // Returning false from the onWatchUpdated callback will prevent
            // calling c.callback(diff) for this watcher.
            return;
        }
        if (!lastDiff || !(0, $62dod.equal)(lastDiff.result, diff.result)) c.callback(c.lastDiff = diff, lastDiff);
    };
    return InMemoryCache;
}((0, $lm9Ep.ApolloCache));
if (globalThis.__DEV__ !== false) $358d1df74a24a3aa$export$467265324939f47f.prototype.getMemoryInternals = (0, $3qXPo.getInMemoryCacheMemoryInternals);

});
parcelRegister("lm9Ep", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", function () { return $f8c3237c16baa64a$export$5fc74f25506aa9c; });

var $l73V3 = parcelRequire("l73V3");

var $kMsgy = parcelRequire("kMsgy");

var $iOXJM = parcelRequire("iOXJM");
var $hrny3 = parcelRequire("hrny3");

var $9ouSO = parcelRequire("9ouSO");

var $3qXPo = parcelRequire("3qXPo");
var $f8c3237c16baa64a$export$5fc74f25506aa9c = /** @class */ function() {
    function ApolloCache() {
        this.assumeImmutableResults = false;
        // Make sure we compute the same (===) fragment query document every
        // time we receive the same fragment in readFragment.
        this.getFragmentDoc = (0, $kMsgy.wrap)((0, $hrny3.getFragmentQueryDocument), {
            max: (0, $iOXJM.cacheSizes)["cache.fragmentQueryDocuments"] || 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
            cache: (0, $9ouSO.WeakCache)
        });
    }
    // Transactional API
    // The batch method is intended to replace/subsume both performTransaction
    // and recordOptimisticTransaction, but performTransaction came first, so we
    // provide a default batch implementation that's just another way of calling
    // performTransaction. Subclasses of ApolloCache (such as InMemoryCache) can
    // override the batch method to do more interesting things with its options.
    ApolloCache.prototype.batch = function(options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic : options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function() {
            return updateResult = options.update(_this);
        }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    // Optional API
    // Called once per input document, allowing the cache to make static changes
    // to the query, such as adding __typename fields.
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    // Called before each ApolloLink request, allowing the cache to make dynamic
    // changes to the query, such as filling in missing fragment definitions.
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.identify = function(object) {
        return;
    };
    ApolloCache.prototype.gc = function() {
        return [];
    };
    ApolloCache.prototype.modify = function(options) {
        return false;
    };
    // DataProxy API
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
            rootId: options.id || "ROOT_QUERY",
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            rootId: options.id,
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.writeQuery = function(_a) {
        var id = _a.id, data = _a.data, options = (0, $l73V3.__rest)(_a, [
            "id",
            "data"
        ]);
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data
        }));
    };
    ApolloCache.prototype.writeFragment = function(_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0, $l73V3.__rest)(_a, [
            "id",
            "data",
            "fragment",
            "fragmentName"
        ]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data
        }));
    };
    ApolloCache.prototype.updateQuery = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeQuery((0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    ApolloCache.prototype.updateFragment = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeFragment((0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    return ApolloCache;
}();
if (globalThis.__DEV__ !== false) $f8c3237c16baa64a$export$5fc74f25506aa9c.prototype.getMemoryInternals = (0, $3qXPo.getApolloCacheMemoryInternals);

});

parcelRegister("1SEYm", function(module, exports) {

$parcel$export(module.exports, "MissingFieldError", function () { return $15ea9de78729a403$export$257c68286583b0f9; });

var $l73V3 = parcelRequire("l73V3");
var $15ea9de78729a403$export$257c68286583b0f9 = /** @class */ function(_super) {
    (0, $l73V3.__extends)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        // 'Error' breaks prototype chain here
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for(var i = _this.path.length - 1; i >= 0; --i)_this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
        } else _this.missing = _this.path;
        // We're not using `Object.setPrototypeOf` here as it isn't fully supported
        // on Android (see issue #3236).
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error);

});

parcelRegister("9noZ5", function(module, exports) {

$parcel$export(module.exports, "StoreReader", function () { return $6d39a469e296e49b$export$628ef07ba8965f12; });

var $l73V3 = parcelRequire("l73V3");
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $kKcD5 = parcelRequire("kKcD5");

var $kMsgy = parcelRequire("kMsgy");

var $2a3Iu = parcelRequire("2a3Iu");
var $iOXJM = parcelRequire("iOXJM");
var $gGpvG = parcelRequire("gGpvG");
var $8L3vO = parcelRequire("8L3vO");
var $am4bq = parcelRequire("am4bq");
var $bYdjZ = parcelRequire("bYdjZ");
var $29Gnu = parcelRequire("29Gnu");
var $hrny3 = parcelRequire("hrny3");
var $RzHRn = parcelRequire("RzHRn");
var $dmNot = parcelRequire("dmNot");
var $a7LxD = parcelRequire("a7LxD");
var $iRdoS = parcelRequire("iRdoS");

var $8iWhK = parcelRequire("8iWhK");

var $bZkp6 = parcelRequire("bZkp6");
var $2emDS = parcelRequire("2emDS");

var $1SEYm = parcelRequire("1SEYm");

var $gBOaX = parcelRequire("gBOaX");
function $6d39a469e296e49b$var$execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        // We split out this property so we can pass different values
        // independently without modifying options.context itself.
        options.context.canonizeResults
    ];
}
var $6d39a469e296e49b$export$628ef07ba8965f12 = /** @class */ function() {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new ((0, $8L3vO.canUseWeakMap) ? WeakMap : Map)();
        this.config = (0, $am4bq.compact)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0, $bZkp6.shouldCanonizeResults)(config)
        });
        this.canon = config.canon || new (0, $gBOaX.ObjectCanon)();
        // memoized functions in this class will be "garbage-collected"
        // by recreating the whole `StoreReader` in
        // `InMemoryCache.resetResultsCache`
        // (triggered from `InMemoryCache.gc` with `resetResultCache: true`)
        this.executeSelectionSet = (0, $kMsgy.wrap)(function(options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = $6d39a469e296e49b$var$execSelectionSetKeyArgs(options);
            // Negate this boolean option so we can find out if we've already read
            // this result using the other boolean value.
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, other), {
                    // If we previously read this result without canonizing it, we can
                    // reuse that result simply by canonizing it now.
                    result: _this.canon.admit(other.result)
                });
                // If we previously read this result with canonization enabled, we can
                // return that canonized result as-is.
                return other;
            }
            (0, $8iWhK.maybeDependOnExistenceOfEntity)(options.context.store, options.enclosingRef.__ref);
            // Finally, if we didn't find any useful previous results, run the real
            // execSelectionSetImpl method with the given options.
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $iOXJM.cacheSizes)["inMemoryCache.executeSelectionSet"] || 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
            keyArgs: $6d39a469e296e49b$var$execSelectionSetKeyArgs,
            // Note that the parameters of makeCacheKey are determined by the
            // array returned by keyArgs.
            makeCacheKey: function(selectionSet, parent, context, canonizeResults) {
                if ((0, $8iWhK.supportsResultCaching)(context.store)) return context.store.makeCacheKey(selectionSet, (0, $RzHRn.isReference)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
            }
        });
        this.executeSubSelectedArray = (0, $kMsgy.wrap)(function(options) {
            (0, $8iWhK.maybeDependOnExistenceOfEntity)(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $iOXJM.cacheSizes)["inMemoryCache.executeSubSelectedArray"] || 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ ,
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if ((0, $8iWhK.supportsResultCaching)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
    }
    StoreReader.prototype.resetCanon = function() {
        this.canon = new (0, $gBOaX.ObjectCanon)();
    };
    /**
     * Given a store and a query, return as much of the result as possible and
     * identify if any data was missing from the store.
     */ StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? "ROOT_QUERY" : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, (0, $29Gnu.getDefaultValues)((0, $29Gnu.getQueryDefinition)(query))), variables);
        var rootRef = (0, $RzHRn.makeReference)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0, $29Gnu.getMainDefinition)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0, $l73V3.__assign)({
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: (0, $gGpvG.canonicalStringify)(variables),
                canonizeResults: canonizeResults
            }, (0, $bZkp6.extractFragmentContext)(query, this.config.fragments))
        });
        var missing;
        if (execResult.missing) {
            // For backwards compatibility we still report an array of
            // MissingFieldError objects, even though there will only ever be at most
            // one of them, now that all missing field error messages are grouped
            // together in the execResult.missing tree.
            missing = [
                new (0, $1SEYm.MissingFieldError)($6d39a469e296e49b$var$firstMissing(execResult.missing), execResult.missing, query, variables)
            ];
            if (!returnPartialData) throw missing[0];
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing
        };
    };
    StoreReader.prototype.isFresh = function(result, parent, selectionSet, context) {
        if ((0, $8iWhK.supportsResultCaching)(context.store) && this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, // If result is canonical, then it could only have been previously
            // cached by the canonizing version of executeSelectionSet, so we can
            // avoid checking both possibilities here.
            this.canon.isKnown(result));
            if (latest && result === latest.result) return true;
        }
        return false;
    };
    // Uncached version of executeSelectionSet.
    StoreReader.prototype.execSelectionSetImpl = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0, $RzHRn.isReference)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: this.canon.empty,
            missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object")
        };
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new (0, $bYdjZ.DeepMerger)();
        if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) // Ensure we always include a default value for the __typename
        // field, if we have one, and this.config.addTypename is true. Note
        // that this field can be overridden by other merged objects.
        objectsToMerge.push({
            __typename: typename
        });
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a, _b;
            // Omit fields with directives @skip(if: <truthy value>) or
            // @include(if: <falsy value>).
            if (!(0, $iRdoS.shouldInclude)(selection, variables)) return;
            if ((0, $RzHRn.isField)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                var resultName = (0, $RzHRn.resultKeyNameFromField)(selection);
                if (fieldValue === void 0) {
                    if (!(0, $2a3Iu.addTypenameToDocument).added(selection)) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0, $RzHRn.isReference)(objectOrReference) ? objectOrReference.__ref + " object" : "object " + JSON.stringify(objectOrReference, null, 2)), _a));
                } else if ((0, $2emDS.isArray)(fieldValue)) fieldValue = handleMissing(_this.executeSubSelectedArray({
                    field: selection,
                    array: fieldValue,
                    enclosingRef: enclosingRef,
                    context: context
                }), resultName);
                else if (!selection.selectionSet) // If the field does not have a selection set, then we handle it
                // as a scalar value. To keep this.canon from canonicalizing
                // this value, we use this.canon.pass to wrap fieldValue in a
                // Pass object that this.canon.admit will later unwrap as-is.
                {
                    if (context.canonizeResults) fieldValue = _this.canon.pass(fieldValue);
                } else if (fieldValue != null) // In this case, because we know the field has a selection set,
                // it must be trying to query a GraphQLObjectType, which is why
                // fieldValue must be != null.
                fieldValue = handleMissing(_this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    enclosingRef: (0, $RzHRn.isReference)(fieldValue) ? fieldValue : enclosingRef,
                    context: context
                }), resultName);
                if (fieldValue !== void 0) objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
            } else {
                var fragment = (0, $hrny3.getFragmentFromSelection)(selection, context.lookupFragment);
                if (!fragment && selection.kind === (0, $kKcD5.Kind).FRAGMENT_SPREAD) throw (0, $kJ26n.newInvariantError)(9, selection.name.value);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        var result = (0, $bYdjZ.mergeDeepArray)(objectsToMerge);
        var finalResult = {
            result: result,
            missing: missing
        };
        var frozen = context.canonizeResults ? this.canon.admit(finalResult) : (0, $a7LxD.maybeDeepFreeze)(finalResult);
        // Store this result with its selection set so that we can quickly
        // recognize it again in the StoreReader#isFresh method.
        if (frozen.result) this.knownResults.set(frozen.result, selectionSet);
        return frozen;
    };
    // Uncached version of executeSubSelectedArray.
    StoreReader.prototype.execSubSelectedArrayImpl = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new (0, $bYdjZ.DeepMerger)();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter(context.store.canRead);
        array = array.map(function(item, i) {
            // null value in array
            if (item === null) return null;
            // This is a nested array, recurse
            if ((0, $2emDS.isArray)(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                enclosingRef: enclosingRef,
                context: context
            }), i);
            // This is an object, run the selection set on it
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                enclosingRef: (0, $RzHRn.isReference)(item) ? item : enclosingRef,
                context: context
            }), i);
            if (globalThis.__DEV__ !== false) $6d39a469e296e49b$var$assertSelectionSetForIdValue(context.store, field, item);
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $6d39a469e296e49b$var$firstMissing(tree) {
    try {
        JSON.stringify(tree, function(_, value) {
            if (typeof value === "string") throw value;
            return value;
        });
    } catch (result) {
        return result;
    }
}
function $6d39a469e296e49b$var$assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([
            fieldValue
        ]);
        workSet_1.forEach(function(value) {
            if ((0, $dmNot.isNonNullObject)(value)) {
                (0, $kJ26n.invariant)(!(0, $RzHRn.isReference)(value), 10, (0, $bZkp6.getTypenameFromStoreObject)(store, value), field.name.value);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}

});
parcelRegister("8iWhK", function(module, exports) {

$parcel$export(module.exports, "EntityStore", function () { return $60bd3765424d1419$export$cb507f57054c7321; });
$parcel$export(module.exports, "maybeDependOnExistenceOfEntity", function () { return $60bd3765424d1419$export$f8068a30967ddc18; });
$parcel$export(module.exports, "supportsResultCaching", function () { return $60bd3765424d1419$export$488c0743feab3d61; });

var $l73V3 = parcelRequire("l73V3");
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");
parcelRequire("kMsgy");
var $3Nd2v = parcelRequire("3Nd2v");

var $62dod = parcelRequire("62dod");

var $1U0aA = parcelRequire("1U0aA");

var $8L3vO = parcelRequire("8L3vO");
var $bYdjZ = parcelRequire("bYdjZ");
var $dmNot = parcelRequire("dmNot");
var $RzHRn = parcelRequire("RzHRn");
var $a7LxD = parcelRequire("a7LxD");

var $bZkp6 = parcelRequire("bZkp6");
var $60bd3765424d1419$var$DELETE = Object.create(null);
var $60bd3765424d1419$var$delModifier = function() {
    return $60bd3765424d1419$var$DELETE;
};
var $60bd3765424d1419$var$INVALIDATE = Object.create(null);
var $60bd3765424d1419$export$cb507f57054c7321 = /** @class */ function() {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        // Maps root entity IDs to the number of times they have been retained, minus
        // the number of times they have been released. Retained entities keep other
        // entities they reference (even indirectly) from being garbage collected.
        this.rootIds = Object.create(null);
        // Lazily tracks { __ref: <dataId> } strings contained by this.data[dataId].
        this.refs = Object.create(null);
        // Bound function that can be passed around to provide easy access to fields
        // of Reference objects as well as ordinary objects.
        this.getFieldValue = function(objectOrReference, storeFieldName) {
            return (0, $a7LxD.maybeDeepFreeze)((0, $RzHRn.isReference)(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
        };
        // Returns true for non-normalized StoreObjects and non-dangling
        // References, indicating that readField(name, objOrRef) has a chance of
        // working. Useful for filtering out dangling references from lists.
        this.canRead = function(objOrRef) {
            return (0, $RzHRn.isReference)(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
        };
        // Bound function that converts an id or an object with a __typename and
        // primary key fields to a Reference object. If called with a Reference object,
        // that same Reference object is returned. Pass true for mergeIntoStore to persist
        // an object into the store.
        this.toReference = function(objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") return (0, $RzHRn.makeReference)(objOrIdOrRef);
            if ((0, $RzHRn.isReference)(objOrIdOrRef)) return objOrIdOrRef;
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0, $RzHRn.makeReference)(id);
                if (mergeIntoStore) _this.merge(id, objOrIdOrRef);
                return ref;
            }
        };
    }
    // Although the EntityStore class is abstract, it contains concrete
    // implementations of the various NormalizedCache interface methods that
    // are inherited by the Root and Layer subclasses.
    EntityStore.prototype.toObject = function() {
        return (0, $l73V3.__assign)({}, this.data);
    };
    EntityStore.prototype.has = function(dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, $bZkp6.hasOwn).call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && (0, $bZkp6.hasOwn).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, $bZkp6.hasOwn).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof $60bd3765424d1419$var$Layer) return this.parent.get(dataId, fieldName);
    };
    EntityStore.prototype.lookup = function(dataId, dependOnExistence) {
        // The has method (above) calls lookup with dependOnExistence = true, so
        // that it can later be invalidated when we add or remove a StoreObject for
        // this dataId. Any consumer who cares about the contents of the StoreObject
        // should not rely on this dependency, since the contents could change
        // without the object being added or removed.
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        if ((0, $bZkp6.hasOwn).call(this.data, dataId)) return this.data[dataId];
        if (this instanceof $60bd3765424d1419$var$Layer) return this.parent.lookup(dataId, dependOnExistence);
        if (this.policies.rootTypenamesById[dataId]) return Object.create(null);
    };
    EntityStore.prototype.merge = function(older, newer) {
        var _this = this;
        var dataId;
        // Convert unexpected references to ID strings.
        if ((0, $RzHRn.isReference)(older)) older = older.__ref;
        if ((0, $RzHRn.isReference)(newer)) newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup(dataId = older) : older;
        var incoming = typeof newer === "string" ? this.lookup(dataId = newer) : newer;
        // If newer was a string ID, but that ID was not defined in this store,
        // then there are no fields to be merged, so we're done.
        if (!incoming) return;
        (0, $kJ26n.invariant)(typeof dataId === "string", 1);
        var merged = new (0, $bYdjZ.DeepMerger)($60bd3765424d1419$var$storeObjectReconciler).merge(existing, incoming);
        // Even if merged === existing, existing may have come from a lower
        // layer, so we always need to set this.data[dataId] on this level.
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                // If we added a new StoreObject where there was previously none, dirty
                // anything that depended on the existence of this dataId, such as the
                // EntityStore#has method.
                if (!existing) fieldsToDirty_1.__exists = 1;
                // Now invalidate dependents who called getFieldValue for any fields
                // that are changing as a result of this merge.
                Object.keys(incoming).forEach(function(storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        // Always dirty the full storeFieldName, which may include
                        // serialized arguments following the fieldName prefix.
                        fieldsToDirty_1[storeFieldName] = 1;
                        // Also dirty fieldNameFromStoreName(storeFieldName) if it's
                        // different from storeFieldName and this field does not have
                        // keyArgs configured, because that means the cache can't make
                        // any assumptions about how field values with the same field
                        // name but different arguments might be interrelated, so it
                        // must err on the side of invalidating all field values that
                        // share the same short fieldName, regardless of arguments.
                        var fieldName = (0, $bZkp6.fieldNameFromStoreName)(storeFieldName);
                        if (fieldName !== storeFieldName && !_this.policies.hasKeyArgs(merged.__typename, fieldName)) fieldsToDirty_1[fieldName] = 1;
                        // If merged[storeFieldName] has become undefined, and this is the
                        // Root layer, actually delete the property from the merged object,
                        // which is guaranteed to have been created fresh in this method.
                        if (merged[storeFieldName] === void 0 && !(_this instanceof $60bd3765424d1419$var$Layer)) delete merged[storeFieldName];
                    }
                });
                if (fieldsToDirty_1.__typename && !(existing && existing.__typename) && // Since we return default root __typename strings
                // automatically from store.get, we don't need to dirty the
                // ROOT_QUERY.__typename field if merged.__typename is equal
                // to the default string (usually "Query").
                this.policies.rootTypenamesById[dataId] === merged.__typename) delete fieldsToDirty_1.__typename;
                Object.keys(fieldsToDirty_1).forEach(function(fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function(dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: $60bd3765424d1419$var$DELETE,
                INVALIDATE: $60bd3765424d1419$var$INVALIDATE,
                isReference: (0, $RzHRn.isReference),
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function(fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, $RzHRn.makeReference)(dataId)
                    } : fieldNameOrOptions, {
                        store: _this
                    });
                }
            };
            Object.keys(storeObject).forEach(function(storeFieldName) {
                var fieldName = (0, $bZkp6.fieldNameFromStoreName)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === $60bd3765424d1419$var$delModifier ? $60bd3765424d1419$var$DELETE : modify((0, $a7LxD.maybeDeepFreeze)(fieldValue), (0, $l73V3.__assign)((0, $l73V3.__assign)({}, sharedDetails_1), {
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: _this.getStorage(dataId, storeFieldName)
                    }));
                    if (newValue === $60bd3765424d1419$var$INVALIDATE) _this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === $60bd3765424d1419$var$DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                            if (globalThis.__DEV__ !== false) {
                                var checkReference = function(ref) {
                                    if (_this.lookup(ref.__ref) === undefined) {
                                        globalThis.__DEV__ !== false && (0, $kJ26n.invariant).warn(2, ref);
                                        return true;
                                    }
                                };
                                if ((0, $RzHRn.isReference)(newValue)) checkReference(newValue);
                                else if (Array.isArray(newValue)) {
                                    // Warn about writing "mixed" arrays of Reference and non-Reference objects
                                    var seenReference = false;
                                    var someNonReference = void 0;
                                    for(var _i = 0, newValue_1 = newValue; _i < newValue_1.length; _i++){
                                        var value = newValue_1[_i];
                                        if ((0, $RzHRn.isReference)(value)) {
                                            seenReference = true;
                                            if (checkReference(value)) break;
                                        } else // Do not warn on primitive values, since those could never be represented
                                        // by a reference. This is a valid (albeit uncommon) use case.
                                        if (typeof value === "object" && !!value) {
                                            var id = _this.policies.identify(value)[0];
                                            // check if object could even be referenced, otherwise we are not interested in it for this warning
                                            if (id) someNonReference = value;
                                        }
                                        if (seenReference && someNonReference !== undefined) {
                                            globalThis.__DEV__ !== false && (0, $kJ26n.invariant).warn(3, someNonReference);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted_1 = false;
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof $60bd3765424d1419$var$Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    // If called with only one argument, removes the entire entity
    // identified by dataId. If called with a fieldName as well, removes all
    // fields of that entity whose names match fieldName according to the
    // fieldNameFromStoreName helper function. If called with a fieldName
    // and variables, removes all fields of that entity whose names match fieldName
    // and whose arguments when cached exactly match the variables passed.
    EntityStore.prototype.delete = function(dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = $60bd3765424d1419$var$delModifier, _a) : $60bd3765424d1419$var$delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function(options, limit) {
        var evicted = false;
        if (options.id) {
            if ((0, $bZkp6.hasOwn).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof $60bd3765424d1419$var$Layer && this !== limit) evicted = this.parent.evict(options, limit) || evicted;
            // Always invalidate the field to trigger rereading of watched
            // queries, even if no cache data was modified by the eviction,
            // because queries may depend on computed fields with custom read
            // functions, whose values are not stored in the EntityStore.
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    };
    EntityStore.prototype.clear = function() {
        this.replace(null);
    };
    EntityStore.prototype.extract = function() {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function(id) {
            if (!(0, $bZkp6.hasOwn).call(_this.policies.rootTypenamesById, id)) extraRootIds.push(id);
        });
        if (extraRootIds.length) obj.__META = {
            extraRootIds: extraRootIds.sort()
        };
        return obj;
    };
    EntityStore.prototype.replace = function(newData) {
        var _this = this;
        Object.keys(this.data).forEach(function(dataId) {
            if (!(newData && (0, $bZkp6.hasOwn).call(newData, dataId))) _this.delete(dataId);
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0, $l73V3.__rest)(newData, [
                "__META"
            ]);
            Object.keys(rest_1).forEach(function(dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) __META.extraRootIds.forEach(this.retain, this);
        }
    };
    EntityStore.prototype.retain = function(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function(rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    // Return a Set<string> of all the ID strings that have been retained by
    // this layer/root *and* any layers/roots beneath it.
    EntityStore.prototype.getRootIdSet = function(ids) {
        if (ids === void 0) ids = new Set();
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof $60bd3765424d1419$var$Layer) this.parent.getRootIdSet(ids);
        else // Official singleton IDs like ROOT_QUERY and ROOT_MUTATION are
        // always considered roots for garbage collection, regardless of
        // their retainment counts in this.rootIds.
        Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        return ids;
    };
    // The goal of garbage collection is to remove IDs from the Root layer of the
    // store that are no longer reachable starting from any IDs that have been
    // explicitly retained (see retain and release, above). Returns an array of
    // dataId strings that were removed from the store.
    EntityStore.prototype.gc = function() {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function(id) {
            if ((0, $bZkp6.hasOwn).call(snapshot, id)) {
                // Because we are iterating over an ECMAScript Set, the IDs we add here
                // will be visited in later iterations of the forEach loop only if they
                // were not previously contained by the Set.
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                // By removing IDs from the snapshot object here, we protect them from
                // getting removed from the root store layer below.
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while(root_1 instanceof $60bd3765424d1419$var$Layer)root_1 = root_1.parent;
            idsToRemove.forEach(function(id) {
                return root_1.delete(id);
            });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function(dataId) {
        if (!(0, $bZkp6.hasOwn).call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root) return found_1;
            var workSet_1 = new Set([
                root
            ]);
            // Within the store, only arrays and objects can contain child entity
            // references, so we can prune the traversal using this predicate:
            workSet_1.forEach(function(obj) {
                if ((0, $RzHRn.isReference)(obj)) found_1[obj.__ref] = true;
                if ((0, $dmNot.isNonNullObject)(obj)) Object.keys(obj).forEach(function(key) {
                    var child = obj[key];
                    // No need to add primitive values to the workSet, since they cannot
                    // contain reference objects.
                    if ((0, $dmNot.isNonNullObject)(child)) workSet_1.add(child);
                });
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function() {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}();
// A single CacheGroup represents a set of one or more EntityStore objects,
// typically the Root store in a CacheGroup by itself, and all active Layer
// stores in a group together. A single EntityStore object belongs to only
// one CacheGroup, store.group. The CacheGroup is responsible for tracking
// dependencies, so store.group is helpful for generating unique keys for
// cached results that need to be invalidated when/if those dependencies
// change. If we used the EntityStore objects themselves as cache keys (that
// is, store rather than store.group), the cache would become unnecessarily
// fragmented by all the different Layer objects. Instead, the CacheGroup
// approach allows all optimistic Layer objects in the same linked list to
// belong to one CacheGroup, with the non-optimistic Root object belonging
// to another CacheGroup, allowing resultCaching dependencies to be tracked
// separately for optimistic and non-optimistic entity data.
var $60bd3765424d1419$var$CacheGroup = /** @class */ function() {
    function CacheGroup(caching, parent) {
        if (parent === void 0) parent = null;
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function() {
        this.d = this.caching ? (0, $3Nd2v.dep)() : null;
        this.keyMaker = new (0, $1U0aA.Trie)((0, $8L3vO.canUseWeakMap));
    };
    CacheGroup.prototype.depend = function(dataId, storeFieldName) {
        if (this.d) {
            this.d($60bd3765424d1419$var$makeDepKey(dataId, storeFieldName));
            var fieldName = (0, $bZkp6.fieldNameFromStoreName)(storeFieldName);
            if (fieldName !== storeFieldName) // Fields with arguments that contribute extra identifying
            // information to the fieldName (thus forming the storeFieldName)
            // depend not only on the full storeFieldName but also on the
            // short fieldName, so the field can be invalidated using either
            // level of specificity.
            this.d($60bd3765424d1419$var$makeDepKey(dataId, fieldName));
            if (this.parent) this.parent.depend(dataId, storeFieldName);
        }
    };
    CacheGroup.prototype.dirty = function(dataId, storeFieldName) {
        if (this.d) this.d.dirty($60bd3765424d1419$var$makeDepKey(dataId, storeFieldName), // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        storeFieldName === "__exists" ? "forget" : "setDirty");
    };
    return CacheGroup;
}();
function $60bd3765424d1419$var$makeDepKey(dataId, storeFieldName) {
    // Since field names cannot have '#' characters in them, this method
    // of joining the field name and the ID should be unambiguous, and much
    // cheaper than JSON.stringify([dataId, fieldName]).
    return storeFieldName + "#" + dataId;
}
function $60bd3765424d1419$export$f8068a30967ddc18(store, entityId) {
    if ($60bd3765424d1419$export$488c0743feab3d61(store)) // We use this pseudo-field __exists elsewhere in the EntityStore code to
    // represent changes in the existence of the entity object identified by
    // entityId. This dependency gets reliably dirtied whenever an object with
    // this ID is deleted (or newly created) within this group, so any result
    // cache entries (for example, StoreReader#executeSelectionSet results) that
    // depend on __exists for this entityId will get dirtied as well, leading to
    // the eventual recomputation (instead of reuse) of those result objects the
    // next time someone reads them from the cache.
    store.group.depend(entityId, "__exists");
}
(function(EntityStore) {
    // Refer to this class as EntityStore.Root outside this namespace.
    var Root = /** @class */ function(_super) {
        (0, $l73V3.__extends)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new $60bd3765424d1419$var$CacheGroup(resultCaching)) || this;
            _this.stump = new $60bd3765424d1419$var$Stump(_this);
            _this.storageTrie = new (0, $1U0aA.Trie)((0, $8L3vO.canUseWeakMap));
            if (seed) _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function(layerId, replay) {
            // Adding an optimistic Layer on top of the Root actually adds the Layer
            // on top of the Stump, so the Stump always comes between the Root and
            // any Layer objects that we've added.
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function() {
            // Never remove the root layer.
            return this;
        };
        Root.prototype.getStorage = function() {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore);
    EntityStore.Root = Root;
})($60bd3765424d1419$export$cb507f57054c7321 || ($60bd3765424d1419$export$cb507f57054c7321 = {}));
// Not exported, since all Layer instances are created by the addLayer method
// of the EntityStore.Root class.
var $60bd3765424d1419$var$Layer = /** @class */ function(_super) {
    (0, $l73V3.__extends)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function(layerId) {
        var _this = this;
        // Remove all instances of the given id, not just the first one.
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) // Dirty every ID we're removing. Technically we might be able to avoid
            // dirtying fields that have values in higher layers, but we don't have
            // easy access to higher layers here, and we're about to recreate those
            // layers anyway (see parent.addLayer below).
            Object.keys(this.data).forEach(function(dataId) {
                var ownStoreObject = _this.data[dataId];
                var parentStoreObject = parent["lookup"](dataId);
                if (!parentStoreObject) // The StoreObject identified by dataId was defined in this layer
                // but will be undefined in the parent layer, so we can delete the
                // whole entity using this.delete(dataId). Since we're about to
                // throw this layer away, the only goal of this deletion is to dirty
                // the removed fields.
                _this.delete(dataId);
                else if (!ownStoreObject) {
                    // This layer had an entry for dataId but it was undefined, which
                    // means the entity was deleted in this layer, and it's about to
                    // become undeleted when we remove this layer, so we need to dirty
                    // all fields that are about to be reexposed.
                    _this.group.dirty(dataId, "__exists");
                    Object.keys(parentStoreObject).forEach(function(storeFieldName) {
                        _this.group.dirty(dataId, storeFieldName);
                    });
                } else if (ownStoreObject !== parentStoreObject) // If ownStoreObject is not exactly the same as parentStoreObject,
                // dirty any fields whose values will change as a result of this
                // removal.
                Object.keys(ownStoreObject).forEach(function(storeFieldName) {
                    if (!(0, $62dod.equal)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) _this.group.dirty(dataId, storeFieldName);
                });
            });
            return parent;
        }
        // No changes are necessary if the parent chain remains identical.
        if (parent === this.parent) return this;
        // Recreate this layer on top of the new parent.
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function() {
        return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function(dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return (0, $bZkp6.hasOwn).call(this.data, dataId) ? (0, $l73V3.__assign)((0, $l73V3.__assign)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function() {
        var p = this.parent;
        while(p.parent)p = p.parent;
        return p.getStorage.apply(p, // @ts-expect-error
        arguments);
    };
    return Layer;
}($60bd3765424d1419$export$cb507f57054c7321);
// Represents a Layer permanently installed just above the Root, which allows
// reading optimistically (and registering optimistic dependencies) even when
// no optimistic layers are currently active. The stump.group CacheGroup object
// is shared by any/all Layer objects added on top of the Stump.
var $60bd3765424d1419$var$Stump = /** @class */ function(_super) {
    (0, $l73V3.__extends)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function() {}, new $60bd3765424d1419$var$CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function() {
        // Never remove the Stump layer.
        return this;
    };
    Stump.prototype.merge = function(older, newer) {
        // We never want to write any data into the Stump, so we forward any merge
        // calls to the Root instead. Another option here would be to throw an
        // exception, but the toReference(object, true) function can sometimes
        // trigger Stump writes (which used to be Root writes, before the Stump
        // concept was introduced).
        return this.parent.merge(older, newer);
    };
    return Stump;
}($60bd3765424d1419$var$Layer);
function $60bd3765424d1419$var$storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    // Wherever there is a key collision, prefer the incoming value, unless
    // it is deeply equal to the existing value. It's worth checking deep
    // equality here (even though blindly returning incoming would be
    // logically correct) because preserving the referential identity of
    // existing data can prevent needless rereading and rerendering.
    return (0, $62dod.equal)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function $60bd3765424d1419$export$488c0743feab3d61(store) {
    // When result caching is disabled, store.depend will be null.
    return !!(store instanceof $60bd3765424d1419$export$cb507f57054c7321 && store.group.caching);
}

});
parcelRegister("bZkp6", function(module, exports) {

$parcel$export(module.exports, "hasOwn", function () { return $8ba537fa990cf076$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "defaultDataIdFromObject", function () { return $8ba537fa990cf076$export$bd03c5a9c99d6bce; });
$parcel$export(module.exports, "normalizeConfig", function () { return $8ba537fa990cf076$export$fa542f9ee3f7f4e2; });
$parcel$export(module.exports, "shouldCanonizeResults", function () { return $8ba537fa990cf076$export$3ac2a95fbd99c479; });
$parcel$export(module.exports, "getTypenameFromStoreObject", function () { return $8ba537fa990cf076$export$fdef206c83ff2c09; });
$parcel$export(module.exports, "TypeOrFieldNameRegExp", function () { return $8ba537fa990cf076$export$6ed54d4784f1ce28; });
$parcel$export(module.exports, "fieldNameFromStoreName", function () { return $8ba537fa990cf076$export$37874422037b6029; });
$parcel$export(module.exports, "selectionSetMatchesResult", function () { return $8ba537fa990cf076$export$60bd1cbb09c1a4a2; });
$parcel$export(module.exports, "storeValueIsStoreObject", function () { return $8ba537fa990cf076$export$4f39afca21bd938e; });
$parcel$export(module.exports, "makeProcessedFieldsMerger", function () { return $8ba537fa990cf076$export$b874a818f7a2fa6d; });
$parcel$export(module.exports, "extractFragmentContext", function () { return $8ba537fa990cf076$export$3a33c00f0ae4a480; });
$parcel$export(module.exports, "isArray", function () { return (parcelRequire("2emDS")).isArray; });

var $am4bq = parcelRequire("am4bq");
var $hrny3 = parcelRequire("hrny3");
var $bYdjZ = parcelRequire("bYdjZ");
var $29Gnu = parcelRequire("29Gnu");
var $2emDS = parcelRequire("2emDS");
var $RzHRn = parcelRequire("RzHRn");
var $dmNot = parcelRequire("dmNot");
var $iRdoS = parcelRequire("iRdoS");
var $8ba537fa990cf076$export$b5a638e9b3fff9f3 = Object.prototype.hasOwnProperty;
function $8ba537fa990cf076$export$b931b78cbb3caf86(value) {
    return value === null || value === void 0;
}
function $8ba537fa990cf076$export$bd03c5a9c99d6bce(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = !$8ba537fa990cf076$export$b931b78cbb3caf86(id) ? {
            id: id
        } : !$8ba537fa990cf076$export$b931b78cbb3caf86(_id) ? {
            _id: _id
        } : void 0;
        // If there is no object.id, fall back to object._id.
        if ($8ba537fa990cf076$export$b931b78cbb3caf86(id) && !$8ba537fa990cf076$export$b931b78cbb3caf86(_id)) id = _id;
        if (!$8ba537fa990cf076$export$b931b78cbb3caf86(id)) return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
}
var $8ba537fa990cf076$var$defaultConfig = {
    dataIdFromObject: $8ba537fa990cf076$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    // Thanks to the shouldCanonizeResults helper, this should be the only line
    // you have to change to reenable canonization by default in the future.
    canonizeResults: false
};
function $8ba537fa990cf076$export$fa542f9ee3f7f4e2(config) {
    return (0, $am4bq.compact)($8ba537fa990cf076$var$defaultConfig, config);
}
function $8ba537fa990cf076$export$3ac2a95fbd99c479(config) {
    var value = config.canonizeResults;
    return value === void 0 ? $8ba537fa990cf076$var$defaultConfig.canonizeResults : value;
}
function $8ba537fa990cf076$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $RzHRn.isReference)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var $8ba537fa990cf076$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $8ba537fa990cf076$export$37874422037b6029(storeFieldName) {
    var match = storeFieldName.match($8ba537fa990cf076$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $8ba537fa990cf076$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if ((0, $dmNot.isNonNullObject)(result)) return (0, $2emDS.isArray)(result) ? result.every(function(item) {
        return $8ba537fa990cf076$export$60bd1cbb09c1a4a2(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, $RzHRn.isField)(field) && (0, $iRdoS.shouldInclude)(field, variables)) {
            var key = (0, $RzHRn.resultKeyNameFromField)(field);
            return $8ba537fa990cf076$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $8ba537fa990cf076$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        // If the selection has been skipped with @skip(true) or
        // @include(false), it should not count against the matching. If
        // the selection is not a field, it must be a fragment (inline or
        // named). We will determine if selectionSetMatchesResult for that
        // fragment when we get to it, so for now we return true.
        return true;
    });
    return false;
}
function $8ba537fa990cf076$export$4f39afca21bd938e(value) {
    return (0, $dmNot.isNonNullObject)(value) && !(0, $RzHRn.isReference)(value) && !(0, $2emDS.isArray)(value);
}
function $8ba537fa990cf076$export$b874a818f7a2fa6d() {
    return new (0, $bYdjZ.DeepMerger)();
}
function $8ba537fa990cf076$export$3a33c00f0ae4a480(document, fragments) {
    // FragmentMap consisting only of fragments defined directly in document, not
    // including other fragments registered in the FragmentRegistry.
    var fragmentMap = (0, $hrny3.createFragmentMap)((0, $29Gnu.getFragmentDefinitions)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function(name) {
            var def = fragmentMap[name];
            if (!def && fragments) def = fragments.lookup(name);
            return def || null;
        }
    };
}

});


parcelRegister("gBOaX", function(module, exports) {

$parcel$export(module.exports, "ObjectCanon", function () { return $c17705e9b931ba99$export$c2e7fdd82233f4a4; });

var $l73V3 = parcelRequire("l73V3");

var $1U0aA = parcelRequire("1U0aA");

var $8L3vO = parcelRequire("8L3vO");
var $dmNot = parcelRequire("dmNot");
parcelRequire("bZkp6");
var $2emDS = parcelRequire("2emDS");
function $c17705e9b931ba99$var$shallowCopy(value) {
    if ((0, $dmNot.isNonNullObject)(value)) return (0, $2emDS.isArray)(value) ? value.slice(0) : (0, $l73V3.__assign)({
        __proto__: Object.getPrototypeOf(value)
    }, value);
    return value;
}
// When programmers talk about the "canonical form" of an object, they
// usually have the following meaning in mind, which I've copied from
// https://en.wiktionary.org/wiki/canonical_form:
//
// 1. A standard or normal presentation of a mathematical entity [or
//    object]. A canonical form is an element of a set of representatives
//    of equivalence classes of forms such that there is a function or
//    procedure which projects every element of each equivalence class
//    onto that one element, the canonical form of that equivalence
//    class. The canonical form is expected to be simpler than the rest of
//    the forms in some way.
//
// That's a long-winded way of saying any two objects that have the same
// canonical form may be considered equivalent, even if they are !==,
// which usually means the objects are structurally equivalent (deeply
// equal), but don't necessarily use the same memory.
//
// Like a literary or musical canon, this ObjectCanon class represents a
// collection of unique canonical items (JavaScript objects), with the
// important property that canon.admit(a) === canon.admit(b) if a and b
// are deeply equal to each other. In terms of the definition above, the
// canon.admit method is the "function or procedure which projects every"
// object "onto that one element, the canonical form."
//
// In the worst case, the canonicalization process may involve looking at
// every property in the provided object tree, so it takes the same order
// of time as deep equality checking. Fortunately, already-canonicalized
// objects are returned immediately from canon.admit, so the presence of
// canonical subtrees tends to speed up canonicalization.
//
// Since consumers of canonical objects can check for deep equality in
// constant time, canonicalizing cache results can massively improve the
// performance of application code that skips re-rendering unchanged
// results, such as "pure" UI components in a framework like React.
//
// Of course, since canonical objects may be shared widely between
// unrelated consumers, it's important to think of them as immutable, even
// though they are not actually frozen with Object.freeze in production,
// due to the extra performance overhead that comes with frozen objects.
//
// Custom scalar objects whose internal class name is neither Array nor
// Object can be included safely in the admitted tree, but they will not
// be replaced with a canonical version (to put it another way, they are
// assumed to be canonical already).
//
// If we ignore custom objects, no detection of cycles or repeated object
// references is currently required by the StoreReader class, since
// GraphQL result objects are JSON-serializable trees (and thus contain
// neither cycles nor repeated subtrees), so we can avoid the complexity
// of keeping track of objects we've already seen during the recursion of
// the admit method.
//
// In the future, we may consider adding additional cases to the switch
// statement to handle other common object types, such as "[object Date]"
// objects, as needed.
var $c17705e9b931ba99$export$c2e7fdd82233f4a4 = /** @class */ function() {
    function ObjectCanon() {
        // Set of all canonical objects this ObjectCanon has admitted, allowing
        // canon.admit to return previously-canonicalized objects immediately.
        this.known = new ((0, $8L3vO.canUseWeakSet) ? WeakSet : Set)();
        // Efficient storage/lookup structure for canonical objects.
        this.pool = new (0, $1U0aA.Trie)((0, $8L3vO.canUseWeakMap));
        // Make the ObjectCanon assume this value has already been
        // canonicalized.
        this.passes = new WeakMap();
        // Arrays that contain the same elements in a different order can share
        // the same SortedKeysInfo object, to save memory.
        this.keysByJSON = new Map();
        // This has to come last because it depends on keysByJSON.
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function(value) {
        return (0, $dmNot.isNonNullObject)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function(value) {
        if ((0, $dmNot.isNonNullObject)(value)) {
            var copy = $c17705e9b931ba99$var$shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function(value) {
        var _this = this;
        if ((0, $dmNot.isNonNullObject)(value)) {
            var original = this.passes.get(value);
            if (original) return original;
            var proto = Object.getPrototypeOf(value);
            switch(proto){
                case Array.prototype:
                    if (this.known.has(value)) return value;
                    var array = value.map(this.admit, this);
                    // Arrays are looked up in the Trie using their recursively
                    // canonicalized elements, and the known version of the array is
                    // preserved as node.array.
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        // Since canonical arrays may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(array);
                    }
                    return node.array;
                case null:
                case Object.prototype:
                    if (this.known.has(value)) return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [
                        proto_1
                    ];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function(key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    // Objects are looked up in the Trie by their prototype (which
                    // is *not* recursively canonicalized), followed by a JSON
                    // representation of their (sorted) keys, followed by the
                    // sequence of recursively canonicalized values corresponding to
                    // those keys. To keep the final results unambiguous with other
                    // sequences (such as arrays that just happen to contain [proto,
                    // keys.json, value1, value2, ...]), the known version of the
                    // object is stored as node.object.
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function(key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        // Since canonical objects may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(obj_1);
                    }
                    return node.object;
            }
        }
        return value;
    };
    // It's worthwhile to cache the sorting of arrays of strings, since the
    // same initial unsorted arrays tend to be encountered many times.
    // Fortunately, we can reuse the Trie machinery to look up the sorted
    // arrays in linear time (which is faster than sorting large arrays).
    ObjectCanon.prototype.sortedKeys = function(obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) this.keysByJSON.set(json, node.keys = {
                sorted: keys,
                json: json
            });
        }
        return node.keys;
    };
    return ObjectCanon;
}();

});


parcelRegister("joD5f", function(module, exports) {

$parcel$export(module.exports, "StoreWriter", function () { return $e1ee936405fb801a$export$eb8361c5d132fb8f; });

var $l73V3 = parcelRequire("l73V3");
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $62dod = parcelRequire("62dod");

var $1U0aA = parcelRequire("1U0aA");

var $kKcD5 = parcelRequire("kKcD5");

var $2a3Iu = parcelRequire("2a3Iu");
var $RzHRn = parcelRequire("RzHRn");
var $gGpvG = parcelRequire("gGpvG");
var $2dQsV = parcelRequire("2dQsV");
var $29Gnu = parcelRequire("29Gnu");
var $hrny3 = parcelRequire("hrny3");
var $2emDS = parcelRequire("2emDS");
var $iRdoS = parcelRequire("iRdoS");

var $bZkp6 = parcelRequire("bZkp6");
var $2emDS = parcelRequire("2emDS");

var $3I2FA = parcelRequire("3I2FA");
// Since there are only four possible combinations of context.clientOnly and
// context.deferred values, we should need at most four "flavors" of any given
// WriteContext. To avoid creating multiple copies of the same context, we cache
// the contexts in the context.flavors Map (shared by all flavors) according to
// their clientOnly and deferred values (always in that order).
function $e1ee936405fb801a$var$getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) context.flavors.set(key, flavored = context.clientOnly === clientOnly && context.deferred === deferred ? context : (0, $l73V3.__assign)((0, $l73V3.__assign)({}, context), {
        clientOnly: clientOnly,
        deferred: deferred
    }));
    return flavored;
}
var $e1ee936405fb801a$export$eb8361c5d132fb8f = /** @class */ function() {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function(store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0, $29Gnu.getOperationDefinition)(query);
        var merger = (0, $bZkp6.makeProcessedFieldsMerger)();
        variables = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, (0, $29Gnu.getDefaultValues)(operationDefinition)), variables);
        var context = (0, $l73V3.__assign)((0, $l73V3.__assign)({
            store: store,
            written: Object.create(null),
            merge: function(existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: (0, $gGpvG.canonicalStringify)(variables)
        }, (0, $bZkp6.extractFragmentContext)(query, this.fragments)), {
            overwrite: !!overwrite,
            incomingById: new Map(),
            clientOnly: false,
            deferred: false,
            flavors: new Map()
        });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: {
                map: new Map()
            },
            context: context
        });
        if (!(0, $RzHRn.isReference)(ref)) throw (0, $kJ26n.newInvariantError)(11, result);
        // So far, the store has not been modified, so now it's time to process
        // context.incomingById and merge those incoming fields into context.store.
        context.incomingById.forEach(function(_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0, $RzHRn.makeReference)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0, $RzHRn.isReference)(applied)) // Assume References returned by applyMerges have already been merged
                // into the store. See makeMergeObjectsFunction in policies.ts for an
                // example of how this can happen.
                return;
                // Otherwise, applyMerges returned a StoreObject, whose fields we should
                // merge into the store (see store.merge statement below).
                storeObject = applied;
            }
            if (globalThis.__DEV__ !== false && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function(field) {
                    if (field.selectionSet) fieldsWithSelectionSets_1[field.name.value] = true;
                });
                var hasSelectionSet_1 = function(storeFieldName) {
                    return fieldsWithSelectionSets_1[(0, $bZkp6.fieldNameFromStoreName)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function(storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function(storeFieldName) {
                    // If a merge function was defined for this field, trust that it
                    // did the right thing about (not) clobbering data. If the field
                    // has no selection set, it's a scalar field, so it doesn't need
                    // a merge function (even if it's an object, like JSON data).
                    if (hasSelectionSet_1(storeFieldName) && !hasMergeFunction_1(storeFieldName)) $e1ee936405fb801a$var$warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                });
            }
            store.merge(dataId, storeObject);
        });
        // Any IDs written explicitly to the cache will be retained as
        // reachable root IDs for garbage collection purposes. Although this
        // logic includes root IDs like ROOT_QUERY and ROOT_MUTATION, their
        // retainment counts are effectively ignored because cache.gc() always
        // includes them in its root ID set.
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function(_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, // This object allows processSelectionSet to report useful information
        // to its callers without explicitly returning that information.
        mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        // This variable will be repeatedly updated using context.merge to
        // accumulate all fields that need to be written into the store.
        var incoming = Object.create(null);
        // If typename was not passed in, infer it. Note that typename is
        // always passed in for tricky-to-infer cases such as "Query" for
        // ROOT_QUERY.
        var typename = dataId && policies.rootTypenamesById[dataId] || (0, $RzHRn.getTypenameFromResult)(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) incoming.__typename = typename;
        // This readField function will be passed as context.readField in the
        // KeyFieldsContext object created within policies.identify (called below).
        // In addition to reading from the existing context.store (thanks to the
        // policies.readField(options, context) line at the very bottom), this
        // version of readField can read from Reference objects that are currently
        // pending in context.incomingById, which is important whenever keyFields
        // need to be extracted from a child object that processSelectionSet has
        // turned into a Reference.
        var readField = function() {
            var options = (0, $3I2FA.normalizeReadFieldOptions)(arguments, incoming, context.variables);
            if ((0, $RzHRn.isReference)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0, $l73V3.__assign)((0, $l73V3.__assign)({}, options), {
                        from: info.storeObject
                    }), context);
                    if (result_1 !== void 0) return result_1;
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        context, typename).forEach(function(context, field) {
            var _a;
            var resultFieldKey = (0, $RzHRn.resultKeyNameFromField)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables
                });
                var childTree = $e1ee936405fb801a$var$getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, // Reset context.clientOnly and context.deferred to their default
                // values before processing nested selection sets.
                field.selectionSet ? $e1ee936405fb801a$var$getContextFlavor(context, false, false) : context, childTree);
                // To determine if this field holds a child object with a merge function
                // defined in its type policy (see PR #7070), we need to figure out the
                // child object's __typename.
                var childTypename = void 0;
                // The field's value can be an object that has a __typename only if the
                // field has a selection set. Otherwise incomingValue is scalar.
                if (field.selectionSet && ((0, $RzHRn.isReference)(incomingValue) || (0, $bZkp6.storeValueIsStoreObject)(incomingValue))) childTypename = readField("__typename", incomingValue);
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) childTree.info = {
                    // TODO Check compatibility against any existing childTree.field?
                    field: field,
                    typename: typename,
                    merge: merge
                };
                else $e1ee936405fb801a$var$maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                incoming = context.merge(incoming, (_a = {}, _a[storeFieldName] = incomingValue, _a));
            } else if (globalThis.__DEV__ !== false && !context.clientOnly && !context.deferred && !(0, $2a3Iu.addTypenameToDocument).added(field) && // If the field has a read function, it may be a synthetic field or
            // provide a default value, so its absence from the written data should
            // not be cause for alarm.
            !policies.getReadFunction(typename, field.name.value)) globalThis.__DEV__ !== false && (0, $kJ26n.invariant).error(12, (0, $RzHRn.resultKeyNameFromField)(field), result);
        });
        // Identify the result object, even if dataId was already provided,
        // since we always need keyObject below.
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField
            }), id = _b[0], keyObject = _b[1];
            // If dataId was not provided, fall back to the id just generated by
            // policies.identify.
            dataId = dataId || id;
            // Write any key fields that were used during identification, even if
            // they were not mentioned in the original query.
            if (keyObject) // TODO Reverse the order of the arguments?
            incoming = context.merge(incoming, keyObject);
        } catch (e) {
            // If dataId was provided, tolerate failure of policies.identify.
            if (!dataId) throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0, $RzHRn.makeReference)(dataId);
            // Avoid processing the same entity object using the same selection
            // set more than once. We use an array instead of a Set since most
            // entity IDs will be written using only one selection set, so the
            // size of this array is likely to be very small, meaning indexOf is
            // likely to be faster than Set.prototype.has.
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0) return dataRef;
            sets.push(selectionSet);
            // If we're about to write a result object into the store, but we
            // happen to know that the exact same (===) result object would be
            // returned if we were to reread the result with the same inputs,
            // then we can skip the rest of the processSelectionSet work for
            // this object, and immediately return a Reference to it.
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) return dataRef;
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = $e1ee936405fb801a$var$mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function(field) {
                    return previous_1.fieldNodeSet.add(field);
                });
            } else context.incomingById.set(dataId, {
                storeObject: incoming,
                // Save a reference to mergeTree only if it is not empty, because
                // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
                // reused for entirely different parts of the result tree.
                mergeTree: $e1ee936405fb801a$var$mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                fieldNodeSet: fieldNodeSet
            });
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function(value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) // In development, we need to clone scalar values so that they can be
        // safely frozen with maybeDeepFreeze in readFromStore.ts. In production,
        // it's cheaper to store the scalar values directly in the cache.
        return globalThis.__DEV__ !== false ? (0, $2dQsV.cloneDeep)(value) : value;
        if ((0, $2emDS.isArray)(value)) return value.map(function(item, i) {
            var value = _this.processFieldValue(item, field, context, $e1ee936405fb801a$var$getChildMergeTree(mergeTree, i));
            $e1ee936405fb801a$var$maybeRecycleChildMergeTree(mergeTree, i);
            return value;
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree
        });
    };
    // Implements https://spec.graphql.org/draft/#sec-Field-Collection, but with
    // some additions for tracking @client and @defer directives.
    StoreWriter.prototype.flattenFields = function(selectionSet, result, context, typename) {
        if (typename === void 0) typename = (0, $RzHRn.getTypenameFromResult)(result, selectionSet, context.fragmentMap);
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new (0, $1U0aA.Trie)(false); // No need for WeakMap, since limitingTrie does not escape.
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited) return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function(selection) {
                if (!(0, $iRdoS.shouldInclude)(selection, context.variables)) return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (// Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(clientOnly && deferred) && (0, $2emDS.isNonEmptyArray)(selection.directives)) selection.directives.forEach(function(dir) {
                    var name = dir.name.value;
                    if (name === "client") clientOnly = true;
                    if (name === "defer") {
                        var args = (0, $RzHRn.argumentsObjectFromField)(dir, context.variables);
                        // The @defer directive takes an optional args.if boolean
                        // argument, similar to @include(if: boolean). Note that
                        // @defer(if: false) does not make context.deferred false, but
                        // instead behaves as if there was no @defer directive.
                        if (!args || args.if !== false) deferred = true;
                    // TODO In the future, we may want to record args.label using
                    // context.deferred, if a label is specified.
                    }
                });
                if ((0, $RzHRn.isField)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        // If this field has been visited along another recursive path
                        // before, the final context should have clientOnly or deferred set
                        // to true only if *all* paths have the directive (hence the &&).
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, $e1ee936405fb801a$var$getContextFlavor(context, clientOnly, deferred));
                } else {
                    var fragment = (0, $hrny3.getFragmentFromSelection)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === (0, $kKcD5.Kind).FRAGMENT_SPREAD) throw (0, $kJ26n.newInvariantError)(13, selection.name.value);
                    if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) flatten(fragment.selectionSet, $e1ee936405fb801a$var$getContextFlavor(context, clientOnly, deferred));
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function(mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0, $RzHRn.isReference)(incoming)) {
            var e_1 = // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            !(0, $2emDS.isArray)(incoming) && // Likewise, existing must be either a Reference or a StoreObject
            // in order for its fields to be safe to merge with the fields of
            // the incoming object.
            ((0, $RzHRn.isReference)(existing) || (0, $bZkp6.storeValueIsStoreObject)(existing)) ? existing : void 0;
            // This narrowing is implied by mergeTree.map.size > 0 and
            // !isReference(incoming), though TypeScript understandably cannot
            // hope to infer this type.
            var i_1 = incoming;
            // The options.storage objects provided to read and merge functions
            // are derived from the identity of the parent object plus a
            // sequence of storeFieldName strings/numbers identifying the nested
            // field name path of each field value to be merged.
            if (e_1 && !getStorageArgs) getStorageArgs = [
                (0, $RzHRn.isReference)(e_1) ? e_1.__ref : e_1
            ];
            // It's possible that applying merge functions to this subtree will
            // not change the incoming data, so this variable tracks the fields
            // that did change, so we can create a new incoming object when (and
            // only when) at least one incoming field has changed. We use a Map
            // to preserve the type of numeric keys.
            var changedFields_1;
            var getValue_1 = function(from, name) {
                return (0, $2emDS.isArray)(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function(childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                // If we have no incoming data, leave any existing data untouched.
                if (void 0 === iVal) return;
                if (getStorageArgs) getStorageArgs.push(storeFieldName);
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map();
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) (0, $kJ26n.invariant)(getStorageArgs.pop() === storeFieldName);
            });
            if (changedFields_1) {
                // Shallow clone i so we can add changed fields to it.
                incoming = (0, $2emDS.isArray)(i_1) ? i_1.slice(0) : (0, $l73V3.__assign)({}, i_1);
                changedFields_1.forEach(function(value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        return incoming;
    };
    return StoreWriter;
}();
var $e1ee936405fb801a$var$emptyMergeTreePool = [];
function $e1ee936405fb801a$var$getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) map.set(name, $e1ee936405fb801a$var$emptyMergeTreePool.pop() || {
        map: new Map()
    });
    return map.get(name);
}
function $e1ee936405fb801a$var$mergeMergeTrees(left, right) {
    if (left === right || !right || $e1ee936405fb801a$var$mergeTreeIsEmpty(right)) return left;
    if (!left || $e1ee936405fb801a$var$mergeTreeIsEmpty(left)) return right;
    var info = left.info && right.info ? (0, $l73V3.__assign)((0, $l73V3.__assign)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map() : left.map.size ? left.map : right.map;
    var merged = {
        info: info,
        map: map
    };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function(leftTree, key) {
            merged.map.set(key, $e1ee936405fb801a$var$mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function(key) {
            merged.map.set(key, $e1ee936405fb801a$var$mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function $e1ee936405fb801a$var$mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function $e1ee936405fb801a$var$maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && $e1ee936405fb801a$var$mergeTreeIsEmpty(childTree)) {
        $e1ee936405fb801a$var$emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var $e1ee936405fb801a$var$warnings = new Set();
// Note that this function is unused in production, and thus should be
// pruned by any well-configured minifier.
function $e1ee936405fb801a$var$warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function(objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing) return;
    var incoming = getChild(incomingObj);
    if (!incoming) return;
    // It's always safe to replace a reference, since it refers to data
    // safely stored elsewhere.
    if ((0, $RzHRn.isReference)(existing)) return;
    // If the values are structurally equivalent, we do not need to worry
    // about incoming replacing existing.
    if ((0, $62dod.equal)(existing, incoming)) return;
    // If we're replacing every key of the existing object, then the
    // existing data would be overwritten even if the objects were
    // normalized, so warning would not be helpful here.
    if (Object.keys(existing).every(function(key) {
        return store.getFieldValue(incoming, key) !== void 0;
    })) return;
    var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0, $bZkp6.fieldNameFromStoreName)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    // Avoid warning more than once for the same type and field name.
    if ($e1ee936405fb801a$var$warnings.has(typeDotName)) return;
    $e1ee936405fb801a$var$warnings.add(typeDotName);
    var childTypenames = [];
    // Arrays do not have __typename fields, and always need a custom merge
    // function, even if their elements are normalized entities.
    if (!(0, $2emDS.isArray)(existing) && !(0, $2emDS.isArray)(incoming)) [
        existing,
        incoming
    ].forEach(function(child) {
        var typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
    globalThis.__DEV__ !== false && (0, $kJ26n.invariant).warn(14, fieldName, parentType, childTypenames.length ? "either ensure all objects of type " + childTypenames.join(" and ") + " have an ID or a custom merge function, or " : "", typeDotName, existing, incoming);
}

});
parcelRegister("3I2FA", function(module, exports) {

$parcel$export(module.exports, "Policies", function () { return $2b378d4b43830d1a$export$e9859ad90648930b; });
$parcel$export(module.exports, "normalizeReadFieldOptions", function () { return $2b378d4b43830d1a$export$1ad7a877581bdf2e; });

var $l73V3 = parcelRequire("l73V3");
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $RzHRn = parcelRequire("RzHRn");
var $dmNot = parcelRequire("dmNot");
var $czO9u = parcelRequire("czO9u");

var $bZkp6 = parcelRequire("bZkp6");
var $2emDS = parcelRequire("2emDS");

var $2Iyn4 = parcelRequire("2Iyn4");

var $3IFTa = parcelRequire("3IFTa");
function $2b378d4b43830d1a$var$argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, $RzHRn.argumentsObjectFromField)(spec.field, spec.variables) : null;
}
var $2b378d4b43830d1a$var$nullKeyFieldsFn = function() {
    return void 0;
};
var $2b378d4b43830d1a$var$simpleKeyArgsFn = function(_args, context) {
    return context.fieldName;
};
// These merge functions can be selected by specifying merge:true or
// merge:false in a field policy.
var $2b378d4b43830d1a$var$mergeTrueFn = function(existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var $2b378d4b43830d1a$var$mergeFalseFn = function(_, incoming) {
    return incoming;
};
var $2b378d4b43830d1a$export$e9859ad90648930b = /** @class */ function() {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        // Map from subtype names to sets of supertype names. Note that this
        // representation inverts the structure of possibleTypes (whose keys are
        // supertypes and whose values are arrays of subtypes) because it tends
        // to be much more efficient to search upwards than downwards.
        this.supertypeMap = new Map();
        // Any fuzzy subtypes specified by possibleTypes will be converted to
        // RegExp objects and recorded here. Every key of this map can also be
        // found in supertypeMap. In many cases this Map will be empty, which
        // means no fuzzy subtype checking will happen in fragmentMatches.
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0, $l73V3.__assign)({
            dataIdFromObject: (0, $bZkp6.defaultDataIdFromObject)
        }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    Policies.prototype.identify = function(object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        // It should be possible to write root Query fields with writeFragment,
        // using { __typename: "Query", ... } as the data, but it does not make
        // sense to allow the same identification behavior for the Mutation and
        // Subscription types, since application code should never be writing
        // directly to (or reading directly from) those root objects.
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        // Default context.storeObject to object if not otherwise provided.
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0, $l73V3.__assign)((0, $l73V3.__assign)({}, partialContext), {
            typename: typename,
            storeObject: storeObject,
            readField: partialContext && partialContext.readField || function() {
                var options = $2b378d4b43830d1a$export$1ad7a877581bdf2e(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables
                });
            }
        });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while(keyFn){
            var specifierOrId = keyFn((0, $l73V3.__assign)((0, $l73V3.__assign)({}, object), storeObject), context);
            if ((0, $2emDS.isArray)(specifierOrId)) keyFn = (0, $3IFTa.keyFieldsFnFromSpecifier)(specifierOrId);
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    };
    Policies.prototype.addTypePolicies = function(typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function(typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0, $l73V3.__rest)(_a, [
                "queryType",
                "mutationType",
                "subscriptionType"
            ]);
            // Though {query,mutation,subscription}Type configurations are rare,
            // it's important to call setRootTypename as early as possible,
            // since these configurations should apply consistently for the
            // entire lifetime of the cache. Also, since only one __typename can
            // qualify as one of these root types, these three properties cannot
            // be inherited, unlike the rest of the incoming properties. That
            // restriction is convenient, because the purpose of this.toBeAdded
            // is to delay the processing of type/field policies until the first
            // time they're used, allowing policies to be added in any order as
            // long as all relevant policies (including policies for supertypes)
            // have been added by the time a given policy is used for the first
            // time. In other words, since inheritance doesn't matter for these
            // properties, there's also no need to delay their processing using
            // the this.toBeAdded queue.
            if (queryType) _this.setRootTypename("Query", typename);
            if (mutationType) _this.setRootTypename("Mutation", typename);
            if (subscriptionType) _this.setRootTypename("Subscription", typename);
            if ((0, $bZkp6.hasOwn).call(_this.toBeAdded, typename)) _this.toBeAdded[typename].push(incoming);
            else _this.toBeAdded[typename] = [
                incoming
            ];
        });
    };
    Policies.prototype.updateTypePolicy = function(typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge = typeof merge === "function" ? merge : merge === true ? $2b378d4b43830d1a$var$mergeTrueFn : merge === false ? $2b378d4b43830d1a$var$mergeFalseFn : existing.merge;
        }
        // Type policies can define merge functions, as an alternative to
        // using field policies to merge child objects.
        setMerge(existing, incoming.merge);
        existing.keyFn = // Pass false to disable normalization for this typename.
        keyFields === false ? $2b378d4b43830d1a$var$nullKeyFieldsFn : (0, $2emDS.isArray)(keyFields) ? (0, $3IFTa.keyFieldsFnFromSpecifier)(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
        if (fields) Object.keys(fields).forEach(function(fieldName) {
            var existing = _this.getFieldPolicy(typename, fieldName, true);
            var incoming = fields[fieldName];
            if (typeof incoming === "function") existing.read = incoming;
            else {
                var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                existing.keyFn = // Pass false to disable argument-based differentiation of
                // field identities.
                keyArgs === false ? $2b378d4b43830d1a$var$simpleKeyArgsFn : (0, $2emDS.isArray)(keyArgs) ? (0, $3IFTa.keyArgsFnFromSpecifier)(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                if (typeof read === "function") existing.read = read;
                setMerge(existing, merge);
            }
            if (existing.read && existing.merge) // If we have both a read and a merge function, assume
            // keyArgs:false, because read and merge together can take
            // responsibility for interpreting arguments in and out. This
            // default assumption can always be overridden by specifying
            // keyArgs explicitly in the FieldPolicy.
            existing.keyFn = existing.keyFn || $2b378d4b43830d1a$var$simpleKeyArgsFn;
        });
    };
    Policies.prototype.setRootTypename = function(which, typename) {
        if (typename === void 0) typename = which;
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0, $kJ26n.invariant)(!old || old === which, 5, which);
            // First, delete any old __typename associated with this rootId from
            // rootIdsByTypename.
            if (old) delete this.rootIdsByTypename[old];
            // Now make this the only __typename that maps to this rootId.
            this.rootIdsByTypename[typename] = rootId;
            // Finally, update the __typename associated with this rootId.
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function(possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function(supertype) {
            // Make sure all types have an entry in this.supertypeMap, even if
            // their supertype set is empty, so we can return false immediately
            // from policies.fragmentMatches for unknown supertypes.
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function(subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match((0, $bZkp6.TypeOrFieldNameRegExp));
                if (!match || match[0] !== subtype) // TODO Don't interpret just any invalid typename as a RegExp.
                _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    };
    Policies.prototype.getTypePolicy = function(typename) {
        var _this = this;
        if (!(0, $bZkp6.hasOwn).call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            // When the TypePolicy for typename is first accessed, instead of
            // starting with an empty policy object, inherit any properties or
            // fields from the type policies of the supertypes of typename.
            //
            // Any properties or fields defined explicitly within the TypePolicy
            // for typename will take precedence, and if there are multiple
            // supertypes, the properties of policies whose types were added
            // later via addPossibleTypes will take precedence over those of
            // earlier supertypes. TODO Perhaps we should warn about these
            // conflicts in development, and recommend defining the property
            // explicitly in the subtype policy?
            //
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            //
            // Once the TypePolicy for typename has been accessed, its properties can
            // still be updated directly using addTypePolicies, but future changes to
            // inherited supertype policies will not be reflected in this subtype
            // policy, because this code runs at most once per typename.
            var supertypes_1 = this.supertypeMap.get(typename);
            if (!supertypes_1 && this.fuzzySubtypes.size) {
                // To make the inheritance logic work for unknown typename strings that
                // may have fuzzy supertypes, we give this typename an empty supertype
                // set and then populate it with any fuzzy supertypes that match.
                supertypes_1 = this.getSupertypeSet(typename, true);
                // This only works for typenames that are directly matched by a fuzzy
                // supertype. What if there is an intermediate chain of supertypes?
                // While possible, that situation can only be solved effectively by
                // specifying the intermediate relationships via possibleTypes, manually
                // and in a non-fuzzy way.
                this.fuzzySubtypes.forEach(function(regExp, fuzzy) {
                    if (regExp.test(typename)) {
                        // The fuzzy parameter is just the original string version of regExp
                        // (not a valid __typename string), but we can look up the
                        // associated supertype(s) in this.supertypeMap.
                        var fuzzySupertypes = _this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) fuzzySupertypes.forEach(function(supertype) {
                            return supertypes_1.add(supertype);
                        });
                    }
                });
            }
            if (supertypes_1 && supertypes_1.size) supertypes_1.forEach(function(supertype) {
                var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0, $l73V3.__rest)(_a, [
                    "fields"
                ]);
                Object.assign(policy_1, rest);
                Object.assign(policy_1.fields, fields);
            });
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) // Merge the pending policies into this.typePolicies, in the order they
        // were originally passed to addTypePolicy.
        inbox.splice(0).forEach(function(policy) {
            _this.updateTypePolicy(typename, policy);
        });
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function(typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || createIfMissing && (fieldPolicies[fieldName] = Object.create(null));
        }
    };
    Policies.prototype.getSupertypeSet = function(subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function(fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition) return true;
        // If the fragment has a type condition but the object we're matching
        // against does not have a __typename, the fragment cannot match.
        if (!typename) return false;
        var supertype = fragment.typeCondition.name.value;
        // Common case: fragment type condition and __typename are the same.
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [
                typenameSupertypeSet
            ];
            var maybeEnqueue_1 = function(subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) workQueue_1.push(supertypeSet);
            };
            // We need to check fuzzy subtypes only if we encountered fuzzy
            // subtype strings in addPossibleTypes, and only while writing to
            // the cache, since that's when selectionSetMatchesResult gives a
            // strong signal of fragment matching. The StoreReader class calls
            // policies.fragmentMatches without passing a result object, so
            // needToCheckFuzzySubtypes is always false while reading.
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            // It's important to keep evaluating workQueue.length each time through
            // the loop, because the queue can grow while we're iterating over it.
            for(var i = 0; i < workQueue_1.length; ++i){
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) globalThis.__DEV__ !== false && (0, $kJ26n.invariant).warn(6, typename, supertype);
                        // Record positive results for faster future lookup.
                        // Unfortunately, we cannot safely cache negative results,
                        // because new possibleTypes data could always be added to the
                        // Policies class.
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes && // Start checking fuzzy subtypes only after exhausting all
                // non-fuzzy subtypes (after the final iteration of the loop).
                i === workQueue_1.length - 1 && // We could wait to compare fragment.selectionSet to result
                // after we verify the supertype, but this check is often less
                // expensive than that search, and we will have to do the
                // comparison anyway whenever we find a potential match.
                (0, $bZkp6.selectionSetMatchesResult)(fragment.selectionSet, result, variables)) {
                    // We don't always need to check fuzzy subtypes (if no result
                    // was provided, or !this.fuzzySubtypes.size), but, when we do,
                    // we only want to check them once.
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    // If we find any fuzzy subtypes that match typename, extend the
                    // workQueue to search through the supertypes of those fuzzy
                    // subtypes. Otherwise the for-loop will terminate and we'll
                    // return false below.
                    this.fuzzySubtypes.forEach(function(regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue_1(fuzzyString);
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function(fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            var args = $2b378d4b43830d1a$var$argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                var specifierOrString = keyFn(args, context);
                if ((0, $2emDS.isArray)(specifierOrString)) keyFn = (0, $3IFTa.keyArgsFnFromSpecifier)(specifierOrString);
                else {
                    // If the custom keyFn returns a falsy value, fall back to
                    // fieldName instead.
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, $RzHRn.storeKeyNameFromField)(fieldSpec.field, fieldSpec.variables) : (0, $RzHRn.getStoreKeyName)(fieldName, $2b378d4b43830d1a$var$argsFromFieldSpecifier(fieldSpec));
        // Returning false from a keyArgs function is like configuring
        // keyArgs: false, but more dynamic.
        if (storeFieldName === false) return fieldName;
        // Make sure custom field names start with the actual field.name.value
        // of the field, so we can always figure out which properties of a
        // StoreObject correspond to which original field names.
        return fieldName === (0, $bZkp6.fieldNameFromStoreName)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function(options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference) return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0, $bZkp6.fieldNameFromStoreName)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = $2b378d4b43830d1a$var$makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, $RzHRn.isReference)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            // Call read(existing, readOptions) with cacheSlot holding this.cache.
            return (0, $2Iyn4.cacheSlot).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function(parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function(existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === $2b378d4b43830d1a$var$mergeTrueFn) // Instead of going to the trouble of creating a full
        // FieldFunctionOptions object and calling mergeTrueFn, we can
        // simply call mergeObjects, as mergeTrueFn would.
        return $2b378d4b43830d1a$var$makeMergeObjectsFunction(context.store)(existing, incoming);
        if (merge === $2b378d4b43830d1a$var$mergeFalseFn) // Likewise for mergeFalseFn, whose implementation is even simpler.
        return incoming;
        // If cache.writeQuery or cache.writeFragment was called with
        // options.overwrite set to true, we still call merge functions, but
        // the existing data is always undefined, so the merge function will
        // not attempt to combine the incoming data with the existing data.
        if (context.overwrite) existing = void 0;
        return merge(existing, incoming, $2b378d4b43830d1a$var$makeFieldFunctionOptions(this, // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables
        }, context, storage || Object.create(null)));
    };
    return Policies;
}();
function $2b378d4b43830d1a$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0, $bZkp6.fieldNameFromStoreName)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: $2b378d4b43830d1a$var$argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: (0, $RzHRn.isReference),
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function() {
            return policies.readField($2b378d4b43830d1a$export$1ad7a877581bdf2e(arguments, objectOrReference, variables), context);
        },
        mergeObjects: $2b378d4b43830d1a$var$makeMergeObjectsFunction(context.store)
    };
}
function $2b378d4b43830d1a$export$1ad7a877581bdf2e(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") options = {
        fieldName: fieldNameOrOptions,
        // Default to objectOrReference only when no second argument was
        // passed for the from parameter, not when undefined is explicitly
        // passed as the second argument.
        from: argc > 1 ? from : objectOrReference
    };
    else {
        options = (0, $l73V3.__assign)({}, fieldNameOrOptions);
        // Default to objectOrReference only when fieldNameOrOptions.from is
        // actually omitted, rather than just undefined.
        if (!(0, $bZkp6.hasOwn).call(options, "from")) options.from = objectOrReference;
    }
    if (globalThis.__DEV__ !== false && options.from === void 0) globalThis.__DEV__ !== false && (0, $kJ26n.invariant).warn(7, (0, $czO9u.stringifyForDisplay)(Array.from(readFieldArgs)));
    if (void 0 === options.variables) options.variables = variables;
    return options;
}
function $2b378d4b43830d1a$var$makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0, $2emDS.isArray)(existing) || (0, $2emDS.isArray)(incoming)) throw (0, $kJ26n.newInvariantError)(8);
        // These dynamic checks are necessary because the parameters of a
        // custom merge function can easily have the any type, so the type
        // system cannot always enforce the StoreObject | Reference parameter
        // types of options.mergeObjects.
        if ((0, $dmNot.isNonNullObject)(existing) && (0, $dmNot.isNonNullObject)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) return incoming;
            if ((0, $RzHRn.isReference)(existing) && (0, $bZkp6.storeValueIsStoreObject)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // existing.__ref, preferring/overwriting any fields contributed by the
                // newer incoming StoreObject.
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0, $bZkp6.storeValueIsStoreObject)(existing) && (0, $RzHRn.isReference)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // incoming.__ref, taking fields from the older existing object only if
                // those fields are not already present in the newer StoreObject
                // identified by incoming.__ref.
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0, $bZkp6.storeValueIsStoreObject)(existing) && (0, $bZkp6.storeValueIsStoreObject)(incoming)) return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, existing), incoming);
        }
        return incoming;
    };
}

});
parcelRegister("3IFTa", function(module, exports) {

$parcel$export(module.exports, "keyFieldsFnFromSpecifier", function () { return $2b55f96b00f7dd87$export$f1953a0407594d2c; });
$parcel$export(module.exports, "keyArgsFnFromSpecifier", function () { return $2b55f96b00f7dd87$export$550737ee0cc371ac; });
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $RzHRn = parcelRequire("RzHRn");
var $bYdjZ = parcelRequire("bYdjZ");
var $2emDS = parcelRequire("2emDS");
var $dmNot = parcelRequire("dmNot");

var $bZkp6 = parcelRequire("bZkp6");
var $2emDS = parcelRequire("2emDS");
// Mapping from JSON-encoded KeySpecifier strings to associated information.
var $2b55f96b00f7dd87$var$specifierInfoCache = Object.create(null);
function $2b55f96b00f7dd87$var$lookupSpecifierInfo(spec) {
    // It's safe to encode KeySpecifier arrays with JSON.stringify, since they're
    // just arrays of strings or nested KeySpecifier arrays, and the order of the
    // array elements is important (and suitably preserved by JSON.stringify).
    var cacheKey = JSON.stringify(spec);
    return $2b55f96b00f7dd87$var$specifierInfoCache[cacheKey] || ($2b55f96b00f7dd87$var$specifierInfoCache[cacheKey] = Object.create(null));
}
function $2b55f96b00f7dd87$export$f1953a0407594d2c(specifier) {
    var info = $2b55f96b00f7dd87$var$lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function(object, context) {
        var extract = function(from, key) {
            return context.readField(key, from);
        };
        var keyObject = context.keyObject = $2b55f96b00f7dd87$export$2db31da99613c21f(specifier, function(schemaKeyPath) {
            var extracted = $2b55f96b00f7dd87$export$e8f64f7a025887d3(context.storeObject, schemaKeyPath, // Using context.readField to extract paths from context.storeObject
            // allows the extraction to see through Reference objects and respect
            // custom read functions.
            extract);
            if (extracted === void 0 && object !== context.storeObject && (0, $bZkp6.hasOwn).call(object, schemaKeyPath[0])) // If context.storeObject fails to provide a value for the requested
            // path, fall back to the raw result object, if it has a top-level key
            // matching the first key in the path (schemaKeyPath[0]). This allows
            // key fields included in the written data to be saved in the cache
            // even if they are not selected explicitly in context.selectionSet.
            // Not being mentioned by context.selectionSet is convenient here,
            // since it means these extra fields cannot be affected by field
            // aliasing, which is why we can use extractKey instead of
            // context.readField for this extraction.
            extracted = $2b55f96b00f7dd87$export$e8f64f7a025887d3(object, schemaKeyPath, $2b55f96b00f7dd87$var$extractKey);
            (0, $kJ26n.invariant)(extracted !== void 0, 4, schemaKeyPath.join("."), object);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function $2b55f96b00f7dd87$export$550737ee0cc371ac(specifier) {
    var info = $2b55f96b00f7dd87$var$lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function(args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = $2b55f96b00f7dd87$export$2db31da99613c21f(specifier, function(keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0, $2emDS.isNonEmptyArray)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    // If the directive appears multiple times, only the first
                    // occurrence's arguments will be used. TODO Allow repetition?
                    // TODO Cache this work somehow, a la aliasMap?
                    var d = field.directives.find(function(d) {
                        return d.name.value === directiveName_1;
                    });
                    // Fortunately argumentsObjectFromField works for DirectiveNode!
                    var directiveArgs = d && (0, $RzHRn.argumentsObjectFromField)(d, variables);
                    // For directives without arguments (d defined, but directiveArgs ===
                    // null), the presence or absence of the directive still counts as
                    // part of the field key, so we return null in those cases. If no
                    // directive with this name was found for this field (d undefined and
                    // thus directiveArgs undefined), we return undefined, which causes
                    // this value to be omitted from the key object returned by
                    // collectSpecifierPaths.
                    return directiveArgs && $2b55f96b00f7dd87$export$e8f64f7a025887d3(directiveArgs, // If keyPath.length === 1, this code calls extractKeyPath with an
                    // empty path, which works because it uses directiveArgs as the
                    // extracted value.
                    keyPath.slice(1));
                }
                // If the key started with @ but there was no corresponding directive,
                // we want to omit this value from the key object, not fall through to
                // treating @whatever as a normal argument name.
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && (0, $bZkp6.hasOwn).call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return $2b55f96b00f7dd87$export$e8f64f7a025887d3(variables, varKeyPath);
                }
                // If the key started with $ but there was no corresponding variable, we
                // want to omit this value from the key object, not fall through to
                // treating $whatever as a normal argument name.
                return;
            }
            if (args) return $2b55f96b00f7dd87$export$e8f64f7a025887d3(args, keyPath);
        });
        var suffix = JSON.stringify(collected);
        // If no arguments were passed to this field, and it didn't have any other
        // field key contributions from directives or variables, hide the empty
        // :{} suffix from the field key. However, a field passed no arguments can
        // still end up with a non-empty :{...} suffix if its key configuration
        // refers to directives or variables.
        if (args || suffix !== "{}") fieldName += ":" + suffix;
        return fieldName;
    });
}
function $2b55f96b00f7dd87$export$2db31da99613c21f(specifier, extractor) {
    // For each path specified by specifier, invoke the extractor, and repeatedly
    // merge the results together, with appropriate ancestor context.
    var merger = new (0, $bYdjZ.DeepMerger)();
    return $2b55f96b00f7dd87$export$eca459f173e85801(specifier).reduce(function(collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            // This path is not expected to contain array indexes, so the toMerge
            // reconstruction will not contain arrays. TODO Fix this?
            for(var i = path.length - 1; i >= 0; --i)toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function $2b55f96b00f7dd87$export$eca459f173e85801(spec) {
    var info = $2b55f96b00f7dd87$var$lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function(s, i) {
            if ((0, $2emDS.isArray)(s)) {
                $2b55f96b00f7dd87$export$eca459f173e85801(s).forEach(function(p) {
                    return paths_1.push(currentPath_1.concat(p));
                });
                currentPath_1.length = 0;
            } else {
                currentPath_1.push(s);
                if (!(0, $2emDS.isArray)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function $2b55f96b00f7dd87$var$extractKey(object, key) {
    return object[key];
}
function $2b55f96b00f7dd87$export$e8f64f7a025887d3(object, path, extract) {
    // For each key in path, extract the corresponding child property from obj,
    // flattening arrays if encountered (uncommon for keyFields and keyArgs, but
    // possible). The final result of path.reduce is normalized so unexpected leaf
    // objects have their keys safely sorted. That final result is difficult to
    // type as anything other than any. You're welcome to try to improve the
    // return type, but keep in mind extractKeyPath is not a public function
    // (exported only for testing), so the effort may not be worthwhile unless the
    // limited set of actual callers (see above) pass arguments that TypeScript
    // can statically type. If we know only that path is some array of strings
    // (and not, say, a specific tuple of statically known strings), any (or
    // possibly unknown) is the honest answer.
    extract = extract || $2b55f96b00f7dd87$var$extractKey;
    return $2b55f96b00f7dd87$var$normalize(path.reduce(function reducer(obj, key) {
        return (0, $2emDS.isArray)(obj) ? obj.map(function(child) {
            return reducer(child, key);
        }) : obj && extract(obj, key);
    }, object));
}
function $2b55f96b00f7dd87$var$normalize(value) {
    // Usually the extracted value will be a scalar value, since most primary
    // key fields are scalar, but just in case we get an object or an array, we
    // need to do some normalization of the order of (nested) keys.
    if ((0, $dmNot.isNonNullObject)(value)) {
        if ((0, $2emDS.isArray)(value)) return value.map($2b55f96b00f7dd87$var$normalize);
        return $2b55f96b00f7dd87$export$2db31da99613c21f(Object.keys(value).sort(), function(path) {
            return $2b55f96b00f7dd87$export$e8f64f7a025887d3(value, path);
        });
    }
    return value;
}

});




parcelRegister("1ceGN", function(module, exports) {

$parcel$export(module.exports, "split", function () { return $0df24e6fcab07a98$export$65980d18b75784e2; });

var $bdl4J = parcelRequire("bdl4J");
var $0df24e6fcab07a98$export$65980d18b75784e2 = (0, $bdl4J.ApolloLink).split;

});

parcelRegister("epiqS", function(module, exports) {

$parcel$export(module.exports, "WebSocketLink", function () { return $a7d1b2cfdcff3965$export$c6ec1f112bd949a0; });

var $l73V3 = parcelRequire("l73V3");

var $5Naeb = parcelRequire("5Naeb");

var $bdl4J = parcelRequire("bdl4J");
var $a7d1b2cfdcff3965$export$c6ec1f112bd949a0 = /** @class */ function(_super) {
    (0, $l73V3.__extends)(WebSocketLink, _super);
    function WebSocketLink(paramsOrClient) {
        var _this = _super.call(this) || this;
        if (paramsOrClient instanceof (0, $5Naeb.SubscriptionClient)) _this.subscriptionClient = paramsOrClient;
        else _this.subscriptionClient = new (0, $5Naeb.SubscriptionClient)(paramsOrClient.uri, paramsOrClient.options, paramsOrClient.webSocketImpl);
        return _this;
    }
    WebSocketLink.prototype.request = function(operation) {
        return this.subscriptionClient.request(operation);
    };
    return WebSocketLink;
}((0, $bdl4J.ApolloLink));

});
parcelRegister("5Naeb", function(module, exports) {
"use strict";
var $4379765e4b6543b7$var$__assign = module.exports && module.exports.__assign || function() {
    $4379765e4b6543b7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4379765e4b6543b7$var$__assign.apply(this, arguments);
};
var $4379765e4b6543b7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4379765e4b6543b7$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $4379765e4b6543b7$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SubscriptionClient = void 0;
var $4379765e4b6543b7$var$_global = typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : {};
var $4379765e4b6543b7$var$NativeWebSocket = $4379765e4b6543b7$var$_global.WebSocket || $4379765e4b6543b7$var$_global.MozWebSocket;

var $7TikV = parcelRequire("7TikV");

var $6p5EE = parcelRequire("6p5EE");

var $b3gMK = parcelRequire("b3gMK");

var $6sZ8r = parcelRequire("6sZ8r");

var $1WF7p = parcelRequire("1WF7p");

var $3801j = parcelRequire("3801j");

var $jnl2b = parcelRequire("jnl2b");

var $jNgRn = parcelRequire("jNgRn");

var $ikLy9 = parcelRequire("ikLy9");

var $41mq9 = parcelRequire("41mq9");
var $4379765e4b6543b7$var$SubscriptionClient = function() {
    function SubscriptionClient(url, options, webSocketImpl, webSocketProtocols) {
        var _a = options || {}, _b = _a.connectionCallback, connectionCallback = _b === void 0 ? undefined : _b, _c = _a.connectionParams, connectionParams = _c === void 0 ? {} : _c, _d = _a.minTimeout, minTimeout = _d === void 0 ? $ikLy9.MIN_WS_TIMEOUT : _d, _e = _a.timeout, timeout = _e === void 0 ? $ikLy9.WS_TIMEOUT : _e, _f = _a.reconnect, reconnect = _f === void 0 ? false : _f, _g = _a.reconnectionAttempts, reconnectionAttempts = _g === void 0 ? Infinity : _g, _h = _a.lazy, lazy = _h === void 0 ? false : _h, _j = _a.inactivityTimeout, inactivityTimeout = _j === void 0 ? 0 : _j, _k = _a.wsOptionArguments, wsOptionArguments = _k === void 0 ? [] : _k;
        this.wsImpl = webSocketImpl || $4379765e4b6543b7$var$NativeWebSocket;
        if (!this.wsImpl) throw new Error("Unable to find native implementation, or alternative implementation for WebSocket!");
        this.wsProtocols = webSocketProtocols || $jNgRn.GRAPHQL_WS;
        this.connectionCallback = connectionCallback;
        this.url = url;
        this.operations = {};
        this.nextOperationId = 0;
        this.minWsTimeout = minTimeout;
        this.wsTimeout = timeout;
        this.unsentMessagesQueue = [];
        this.reconnect = reconnect;
        this.reconnecting = false;
        this.reconnectionAttempts = reconnectionAttempts;
        this.lazy = !!lazy;
        this.inactivityTimeout = inactivityTimeout;
        this.closedByUser = false;
        this.backoff = new $7TikV({
            jitter: 0.5
        });
        this.eventEmitter = new $6p5EE.EventEmitter();
        this.middlewares = [];
        this.client = null;
        this.maxConnectTimeGenerator = this.createMaxConnectTimeGenerator();
        this.connectionParams = this.getConnectionParams(connectionParams);
        this.wsOptionArguments = wsOptionArguments;
        if (!this.lazy) this.connect();
    }
    Object.defineProperty(SubscriptionClient.prototype, "status", {
        get: function() {
            if (this.client === null) return this.wsImpl.CLOSED;
            return this.client.readyState;
        },
        enumerable: false,
        configurable: true
    });
    SubscriptionClient.prototype.close = function(isForced, closedByUser) {
        if (isForced === void 0) isForced = true;
        if (closedByUser === void 0) closedByUser = true;
        this.clearInactivityTimeout();
        if (this.client !== null) {
            this.closedByUser = closedByUser;
            if (isForced) {
                this.clearCheckConnectionInterval();
                this.clearMaxConnectTimeout();
                this.clearTryReconnectTimeout();
                this.unsubscribeAll();
                this.sendMessage(undefined, $41mq9.default.GQL_CONNECTION_TERMINATE, null);
            }
            this.client.close();
            this.client.onopen = null;
            this.client.onclose = null;
            this.client.onerror = null;
            this.client.onmessage = null;
            this.client = null;
            this.eventEmitter.emit("disconnected");
            if (!isForced) this.tryReconnect();
        }
    };
    SubscriptionClient.prototype.request = function(request) {
        var _a;
        var getObserver = this.getObserver.bind(this);
        var executeOperation = this.executeOperation.bind(this);
        var unsubscribe = this.unsubscribe.bind(this);
        var opId;
        this.clearInactivityTimeout();
        return _a = {}, _a[$jnl2b.default] = function() {
            return this;
        }, _a.subscribe = function(observerOrNext, onError, onComplete) {
            var observer = getObserver(observerOrNext, onError, onComplete);
            opId = executeOperation(request, function(error, result) {
                if (error === null && result === null) {
                    if (observer.complete) observer.complete();
                } else if (error) {
                    if (observer.error) observer.error(error[0]);
                } else if (observer.next) observer.next(result);
            });
            return {
                unsubscribe: function() {
                    if (opId) {
                        unsubscribe(opId);
                        opId = null;
                    }
                }
            };
        }, _a;
    };
    SubscriptionClient.prototype.on = function(eventName, callback, context) {
        var handler = this.eventEmitter.on(eventName, callback, context);
        return function() {
            handler.off(eventName, callback, context);
        };
    };
    SubscriptionClient.prototype.onConnected = function(callback, context) {
        return this.on("connected", callback, context);
    };
    SubscriptionClient.prototype.onConnecting = function(callback, context) {
        return this.on("connecting", callback, context);
    };
    SubscriptionClient.prototype.onDisconnected = function(callback, context) {
        return this.on("disconnected", callback, context);
    };
    SubscriptionClient.prototype.onReconnected = function(callback, context) {
        return this.on("reconnected", callback, context);
    };
    SubscriptionClient.prototype.onReconnecting = function(callback, context) {
        return this.on("reconnecting", callback, context);
    };
    SubscriptionClient.prototype.onError = function(callback, context) {
        return this.on("error", callback, context);
    };
    SubscriptionClient.prototype.unsubscribeAll = function() {
        var _this = this;
        Object.keys(this.operations).forEach(function(subId) {
            _this.unsubscribe(subId);
        });
    };
    SubscriptionClient.prototype.applyMiddlewares = function(options) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var queue = function(funcs, scope) {
                var next = function(error) {
                    if (error) reject(error);
                    else if (funcs.length > 0) {
                        var f = funcs.shift();
                        if (f) f.applyMiddleware.apply(scope, [
                            options,
                            next
                        ]);
                    } else resolve(options);
                };
                next();
            };
            queue($4379765e4b6543b7$var$__spreadArray([], _this.middlewares, true), _this);
        });
    };
    SubscriptionClient.prototype.use = function(middlewares) {
        var _this = this;
        middlewares.map(function(middleware) {
            if (typeof middleware.applyMiddleware === "function") _this.middlewares.push(middleware);
            else throw new Error("Middleware must implement the applyMiddleware function.");
        });
        return this;
    };
    SubscriptionClient.prototype.getConnectionParams = function(connectionParams) {
        return function() {
            return new Promise(function(resolve, reject) {
                if (typeof connectionParams === "function") try {
                    return resolve(connectionParams.call(null));
                } catch (error) {
                    return reject(error);
                }
                resolve(connectionParams);
            });
        };
    };
    SubscriptionClient.prototype.executeOperation = function(options, handler) {
        var _this = this;
        if (this.client === null) this.connect();
        var opId = this.generateOperationId();
        this.operations[opId] = {
            options: options,
            handler: handler
        };
        this.applyMiddlewares(options).then(function(processedOptions) {
            _this.checkOperationOptions(processedOptions, handler);
            if (_this.operations[opId]) {
                _this.operations[opId] = {
                    options: processedOptions,
                    handler: handler
                };
                _this.sendMessage(opId, $41mq9.default.GQL_START, processedOptions);
            }
        }).catch(function(error) {
            _this.unsubscribe(opId);
            handler(_this.formatErrors(error));
        });
        return opId;
    };
    SubscriptionClient.prototype.getObserver = function(observerOrNext, error, complete) {
        if (typeof observerOrNext === "function") return {
            next: function(v) {
                return observerOrNext(v);
            },
            error: function(e) {
                return error && error(e);
            },
            complete: function() {
                return complete && complete();
            }
        };
        return observerOrNext;
    };
    SubscriptionClient.prototype.createMaxConnectTimeGenerator = function() {
        var minValue = this.minWsTimeout;
        var maxValue = this.wsTimeout;
        return new $7TikV({
            min: minValue,
            max: maxValue,
            factor: 1.2
        });
    };
    SubscriptionClient.prototype.clearCheckConnectionInterval = function() {
        if (this.checkConnectionIntervalId) {
            clearInterval(this.checkConnectionIntervalId);
            this.checkConnectionIntervalId = null;
        }
    };
    SubscriptionClient.prototype.clearMaxConnectTimeout = function() {
        if (this.maxConnectTimeoutId) {
            clearTimeout(this.maxConnectTimeoutId);
            this.maxConnectTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.clearTryReconnectTimeout = function() {
        if (this.tryReconnectTimeoutId) {
            clearTimeout(this.tryReconnectTimeoutId);
            this.tryReconnectTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.clearInactivityTimeout = function() {
        if (this.inactivityTimeoutId) {
            clearTimeout(this.inactivityTimeoutId);
            this.inactivityTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.setInactivityTimeout = function() {
        var _this = this;
        if (this.inactivityTimeout > 0 && Object.keys(this.operations).length === 0) this.inactivityTimeoutId = setTimeout(function() {
            if (Object.keys(_this.operations).length === 0) _this.close();
        }, this.inactivityTimeout);
    };
    SubscriptionClient.prototype.checkOperationOptions = function(options, handler) {
        var query = options.query, variables = options.variables, operationName = options.operationName;
        if (!query) throw new Error("Must provide a query.");
        if (!handler) throw new Error("Must provide an handler.");
        if (!(0, $b3gMK.default)(query) && !(0, $3801j.getOperationAST)(query, operationName) || operationName && !(0, $b3gMK.default)(operationName) || variables && !(0, $6sZ8r.default)(variables)) throw new Error("Incorrect option types. query must be a string or a document,`operationName` must be a string, and `variables` must be an object.");
    };
    SubscriptionClient.prototype.buildMessage = function(id, type, payload) {
        var payloadToReturn = payload && payload.query ? $4379765e4b6543b7$var$__assign($4379765e4b6543b7$var$__assign({}, payload), {
            query: typeof payload.query === "string" ? payload.query : (0, $1WF7p.print)(payload.query)
        }) : payload;
        return {
            id: id,
            type: type,
            payload: payloadToReturn
        };
    };
    SubscriptionClient.prototype.formatErrors = function(errors) {
        if (Array.isArray(errors)) return errors;
        if (errors && errors.errors) return this.formatErrors(errors.errors);
        if (errors && errors.message) return [
            errors
        ];
        return [
            {
                name: "FormatedError",
                message: "Unknown error",
                originalError: errors
            }
        ];
    };
    SubscriptionClient.prototype.sendMessage = function(id, type, payload) {
        this.sendMessageRaw(this.buildMessage(id, type, payload));
    };
    SubscriptionClient.prototype.sendMessageRaw = function(message) {
        switch(this.status){
            case this.wsImpl.OPEN:
                var serializedMessage = JSON.stringify(message);
                try {
                    JSON.parse(serializedMessage);
                } catch (e) {
                    this.eventEmitter.emit("error", new Error("Message must be JSON-serializable. Got: " + message));
                }
                this.client.send(serializedMessage);
                break;
            case this.wsImpl.CONNECTING:
                this.unsentMessagesQueue.push(message);
                break;
            default:
                if (!this.reconnecting) this.eventEmitter.emit("error", new Error("A message was not sent because socket is not connected, is closing or is already closed. Message was: " + JSON.stringify(message)));
        }
    };
    SubscriptionClient.prototype.generateOperationId = function() {
        return String(++this.nextOperationId);
    };
    SubscriptionClient.prototype.tryReconnect = function() {
        var _this = this;
        if (!this.reconnect || this.backoff.attempts >= this.reconnectionAttempts) return;
        if (!this.reconnecting) {
            Object.keys(this.operations).forEach(function(key) {
                _this.unsentMessagesQueue.push(_this.buildMessage(key, $41mq9.default.GQL_START, _this.operations[key].options));
            });
            this.reconnecting = true;
        }
        this.clearTryReconnectTimeout();
        var delay = this.backoff.duration();
        this.tryReconnectTimeoutId = setTimeout(function() {
            _this.connect();
        }, delay);
    };
    SubscriptionClient.prototype.flushUnsentMessagesQueue = function() {
        var _this = this;
        this.unsentMessagesQueue.forEach(function(message) {
            _this.sendMessageRaw(message);
        });
        this.unsentMessagesQueue = [];
    };
    SubscriptionClient.prototype.checkConnection = function() {
        if (this.wasKeepAliveReceived) {
            this.wasKeepAliveReceived = false;
            return;
        }
        if (!this.reconnecting) this.close(false, true);
    };
    SubscriptionClient.prototype.checkMaxConnectTimeout = function() {
        var _this = this;
        this.clearMaxConnectTimeout();
        this.maxConnectTimeoutId = setTimeout(function() {
            if (_this.status !== _this.wsImpl.OPEN) {
                _this.reconnecting = true;
                _this.close(false, true);
            }
        }, this.maxConnectTimeGenerator.duration());
    };
    SubscriptionClient.prototype.connect = function() {
        var _a;
        var _this = this;
        this.client = new ((_a = this.wsImpl).bind.apply(_a, $4379765e4b6543b7$var$__spreadArray([
            void 0,
            this.url,
            this.wsProtocols
        ], this.wsOptionArguments, false)))();
        this.checkMaxConnectTimeout();
        this.client.onopen = function() {
            return $4379765e4b6543b7$var$__awaiter(_this, void 0, void 0, function() {
                var connectionParams, error_1;
                return $4379765e4b6543b7$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(this.status === this.wsImpl.OPEN)) return [
                                3,
                                4
                            ];
                            this.clearMaxConnectTimeout();
                            this.closedByUser = false;
                            this.eventEmitter.emit(this.reconnecting ? "reconnecting" : "connecting");
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                this.connectionParams()
                            ];
                        case 2:
                            connectionParams = _a.sent();
                            this.sendMessage(undefined, $41mq9.default.GQL_CONNECTION_INIT, connectionParams);
                            this.flushUnsentMessagesQueue();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error_1 = _a.sent();
                            this.sendMessage(undefined, $41mq9.default.GQL_CONNECTION_ERROR, error_1);
                            this.flushUnsentMessagesQueue();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
        };
        this.client.onclose = function() {
            if (!_this.closedByUser) _this.close(false, false);
        };
        this.client.onerror = function(err) {
            _this.eventEmitter.emit("error", err);
        };
        this.client.onmessage = function(_a) {
            var data = _a.data;
            _this.processReceivedData(data);
        };
    };
    SubscriptionClient.prototype.processReceivedData = function(receivedData) {
        var parsedMessage;
        var opId;
        try {
            parsedMessage = JSON.parse(receivedData);
            opId = parsedMessage.id;
        } catch (e) {
            throw new Error("Message must be JSON-parseable. Got: " + receivedData);
        }
        if ([
            $41mq9.default.GQL_DATA,
            $41mq9.default.GQL_COMPLETE,
            $41mq9.default.GQL_ERROR
        ].indexOf(parsedMessage.type) !== -1 && !this.operations[opId]) {
            this.unsubscribe(opId);
            return;
        }
        switch(parsedMessage.type){
            case $41mq9.default.GQL_CONNECTION_ERROR:
                if (this.connectionCallback) this.connectionCallback(parsedMessage.payload);
                break;
            case $41mq9.default.GQL_CONNECTION_ACK:
                this.eventEmitter.emit(this.reconnecting ? "reconnected" : "connected", parsedMessage.payload);
                this.reconnecting = false;
                this.backoff.reset();
                this.maxConnectTimeGenerator.reset();
                if (this.connectionCallback) this.connectionCallback();
                break;
            case $41mq9.default.GQL_COMPLETE:
                var handler = this.operations[opId].handler;
                delete this.operations[opId];
                handler.call(this, null, null);
                break;
            case $41mq9.default.GQL_ERROR:
                this.operations[opId].handler(this.formatErrors(parsedMessage.payload), null);
                delete this.operations[opId];
                break;
            case $41mq9.default.GQL_DATA:
                var parsedPayload = !parsedMessage.payload.errors ? parsedMessage.payload : $4379765e4b6543b7$var$__assign($4379765e4b6543b7$var$__assign({}, parsedMessage.payload), {
                    errors: this.formatErrors(parsedMessage.payload.errors)
                });
                this.operations[opId].handler(null, parsedPayload);
                break;
            case $41mq9.default.GQL_CONNECTION_KEEP_ALIVE:
                var firstKA = typeof this.wasKeepAliveReceived === "undefined";
                this.wasKeepAliveReceived = true;
                if (firstKA) this.checkConnection();
                if (this.checkConnectionIntervalId) {
                    clearInterval(this.checkConnectionIntervalId);
                    this.checkConnection();
                }
                this.checkConnectionIntervalId = setInterval(this.checkConnection.bind(this), this.wsTimeout);
                break;
            default:
                throw new Error("Invalid message type!");
        }
    };
    SubscriptionClient.prototype.unsubscribe = function(opId) {
        if (this.operations[opId]) {
            delete this.operations[opId];
            this.setInactivityTimeout();
            this.sendMessage(opId, $41mq9.default.GQL_STOP, undefined);
        }
    };
    return SubscriptionClient;
}();
module.exports.SubscriptionClient = $4379765e4b6543b7$var$SubscriptionClient;

});
parcelRegister("7TikV", function(module, exports) {
/**
 * Expose `Backoff`.
 */ module.exports = $5bebe4ba9c9fda1f$var$Backoff;
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $5bebe4ba9c9fda1f$var$Backoff(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $5bebe4ba9c9fda1f$var$Backoff.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $5bebe4ba9c9fda1f$var$Backoff.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $5bebe4ba9c9fda1f$var$Backoff.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $5bebe4ba9c9fda1f$var$Backoff.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $5bebe4ba9c9fda1f$var$Backoff.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};

});

parcelRegister("6p5EE", function(module, exports) {
"use strict";
var $4a9976ca6ebf6735$var$has = Object.prototype.hasOwnProperty, $4a9976ca6ebf6735$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $4a9976ca6ebf6735$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $4a9976ca6ebf6735$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $4a9976ca6ebf6735$var$Events().__proto__) $4a9976ca6ebf6735$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $4a9976ca6ebf6735$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $4a9976ca6ebf6735$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $4a9976ca6ebf6735$var$EE(fn, context || emitter, once), evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $4a9976ca6ebf6735$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $4a9976ca6ebf6735$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $4a9976ca6ebf6735$var$EventEmitter() {
    this._events = new $4a9976ca6ebf6735$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($4a9976ca6ebf6735$var$has.call(events, name)) names.push($4a9976ca6ebf6735$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $4a9976ca6ebf6735$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $4a9976ca6ebf6735$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $4a9976ca6ebf6735$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $4a9976ca6ebf6735$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $4a9976ca6ebf6735$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
        if (this._events[evt]) $4a9976ca6ebf6735$var$clearEvent(this, evt);
    } else {
        this._events = new $4a9976ca6ebf6735$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$4a9976ca6ebf6735$var$EventEmitter.prototype.off = $4a9976ca6ebf6735$var$EventEmitter.prototype.removeListener;
$4a9976ca6ebf6735$var$EventEmitter.prototype.addListener = $4a9976ca6ebf6735$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$4a9976ca6ebf6735$var$EventEmitter.prefixed = $4a9976ca6ebf6735$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$4a9976ca6ebf6735$var$EventEmitter.EventEmitter = $4a9976ca6ebf6735$var$EventEmitter;
module.exports = $4a9976ca6ebf6735$var$EventEmitter;

});

parcelRegister("b3gMK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $80bcfebc37a282b6$var$isString(value) {
    return typeof value === "string";
}
module.exports.default = $80bcfebc37a282b6$var$isString;

});

parcelRegister("6sZ8r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $4b54c7c3ad119f95$var$isObject(value) {
    return value !== null && typeof value === "object";
}
module.exports.default = $4b54c7c3ad119f95$var$isObject;

});

parcelRegister("1WF7p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.print = $16ab1a80d501f8a0$var$print;

var $cdmvh = parcelRequire("cdmvh");

var $4oRt0 = parcelRequire("4oRt0");

var $eYGJs = parcelRequire("eYGJs");
/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ function $16ab1a80d501f8a0$var$print(ast) {
    return (0, $eYGJs.visit)(ast, $16ab1a80d501f8a0$var$printDocASTReducer);
}
const $16ab1a80d501f8a0$var$MAX_LINE_LENGTH = 80;
const $16ab1a80d501f8a0$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>"$" + node.name
    },
    // Document
    Document: {
        leave: (node)=>$16ab1a80d501f8a0$var$join(node.definitions, "\n\n")
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $16ab1a80d501f8a0$var$wrap("(", $16ab1a80d501f8a0$var$join(node.variableDefinitions, ", "), ")");
            const prefix = $16ab1a80d501f8a0$var$join([
                node.operation,
                $16ab1a80d501f8a0$var$join([
                    node.name,
                    varDefs
                ]),
                $16ab1a80d501f8a0$var$join(node.directives, " ")
            ], " "); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ": " + type + $16ab1a80d501f8a0$var$wrap(" = ", defaultValue) + $16ab1a80d501f8a0$var$wrap(" ", $16ab1a80d501f8a0$var$join(directives, " "))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$16ab1a80d501f8a0$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $16ab1a80d501f8a0$var$wrap("", alias, ": ") + name;
            let argsLine = prefix + $16ab1a80d501f8a0$var$wrap("(", $16ab1a80d501f8a0$var$join(args, ", "), ")");
            if (argsLine.length > $16ab1a80d501f8a0$var$MAX_LINE_LENGTH) argsLine = prefix + $16ab1a80d501f8a0$var$wrap("(\n", $16ab1a80d501f8a0$var$indent($16ab1a80d501f8a0$var$join(args, "\n")), "\n)");
            return $16ab1a80d501f8a0$var$join([
                argsLine,
                $16ab1a80d501f8a0$var$join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>"..." + name + $16ab1a80d501f8a0$var$wrap(" ", $16ab1a80d501f8a0$var$join(directives, " "))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$16ab1a80d501f8a0$var$join([
                "...",
                $16ab1a80d501f8a0$var$wrap("on ", typeCondition),
                $16ab1a80d501f8a0$var$join(directives, " "),
                selectionSet
            ], " ")
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$16ab1a80d501f8a0$var$wrap("(", $16ab1a80d501f8a0$var$join(variableDefinitions, ", "), ")")} ` + `on ${typeCondition} ${$16ab1a80d501f8a0$var$wrap("", $16ab1a80d501f8a0$var$join(directives, " "), " ")}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $cdmvh.printBlockString)(value) : (0, $4oRt0.printString)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? "true" : "false"
    },
    NullValue: {
        leave: ()=>"null"
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>"[" + $16ab1a80d501f8a0$var$join(values, ", ") + "]"
    },
    ObjectValue: {
        leave: ({ fields: fields })=>"{" + $16ab1a80d501f8a0$var$join(fields, ", ") + "}"
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>"@" + name + $16ab1a80d501f8a0$var$wrap("(", $16ab1a80d501f8a0$var$join(args, ", "), ")")
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>"[" + type + "]"
    },
    NonNullType: {
        leave: ({ type: type })=>type + "!"
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$16ab1a80d501f8a0$var$wrap("", description, "\n") + $16ab1a80d501f8a0$var$join([
                "schema",
                $16ab1a80d501f8a0$var$join(directives, " "),
                $16ab1a80d501f8a0$var$block(operationTypes)
            ], " ")
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ": " + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$16ab1a80d501f8a0$var$wrap("", description, "\n") + $16ab1a80d501f8a0$var$join([
                "scalar",
                name,
                $16ab1a80d501f8a0$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$16ab1a80d501f8a0$var$wrap("", description, "\n") + $16ab1a80d501f8a0$var$join([
                "type",
                name,
                $16ab1a80d501f8a0$var$wrap("implements ", $16ab1a80d501f8a0$var$join(interfaces, " & ")),
                $16ab1a80d501f8a0$var$join(directives, " "),
                $16ab1a80d501f8a0$var$block(fields)
            ], " ")
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$16ab1a80d501f8a0$var$wrap("", description, "\n") + name + ($16ab1a80d501f8a0$var$hasMultilineItems(args) ? $16ab1a80d501f8a0$var$wrap("(\n", $16ab1a80d501f8a0$var$indent($16ab1a80d501f8a0$var$join(args, "\n")), "\n)") : $16ab1a80d501f8a0$var$wrap("(", $16ab1a80d501f8a0$var$join(args, ", "), ")")) + ": " + type + $16ab1a80d501f8a0$var$wrap(" ", $16ab1a80d501f8a0$var$join(directives, " "))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$16ab1a80d501f8a0$var$wrap("", description, "\n") + $16ab1a80d501f8a0$var$join([
                name + ": " + type,
                $16ab1a80d501f8a0$var$wrap("= ", defaultValue),
                $16ab1a80d501f8a0$var$join(directives, " ")
            ], " ")
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$16ab1a80d501f8a0$var$wrap("", description, "\n") + $16ab1a80d501f8a0$var$join([
                "interface",
                name,
                $16ab1a80d501f8a0$var$wrap("implements ", $16ab1a80d501f8a0$var$join(interfaces, " & ")),
                $16ab1a80d501f8a0$var$join(directives, " "),
                $16ab1a80d501f8a0$var$block(fields)
            ], " ")
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$16ab1a80d501f8a0$var$wrap("", description, "\n") + $16ab1a80d501f8a0$var$join([
                "union",
                name,
                $16ab1a80d501f8a0$var$join(directives, " "),
                $16ab1a80d501f8a0$var$wrap("= ", $16ab1a80d501f8a0$var$join(types, " | "))
            ], " ")
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$16ab1a80d501f8a0$var$wrap("", description, "\n") + $16ab1a80d501f8a0$var$join([
                "enum",
                name,
                $16ab1a80d501f8a0$var$join(directives, " "),
                $16ab1a80d501f8a0$var$block(values)
            ], " ")
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$16ab1a80d501f8a0$var$wrap("", description, "\n") + $16ab1a80d501f8a0$var$join([
                name,
                $16ab1a80d501f8a0$var$join(directives, " ")
            ], " ")
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$16ab1a80d501f8a0$var$wrap("", description, "\n") + $16ab1a80d501f8a0$var$join([
                "input",
                name,
                $16ab1a80d501f8a0$var$join(directives, " "),
                $16ab1a80d501f8a0$var$block(fields)
            ], " ")
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$16ab1a80d501f8a0$var$wrap("", description, "\n") + "directive @" + name + ($16ab1a80d501f8a0$var$hasMultilineItems(args) ? $16ab1a80d501f8a0$var$wrap("(\n", $16ab1a80d501f8a0$var$indent($16ab1a80d501f8a0$var$join(args, "\n")), "\n)") : $16ab1a80d501f8a0$var$wrap("(", $16ab1a80d501f8a0$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $16ab1a80d501f8a0$var$join(locations, " | ")
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$16ab1a80d501f8a0$var$join([
                "extend schema",
                $16ab1a80d501f8a0$var$join(directives, " "),
                $16ab1a80d501f8a0$var$block(operationTypes)
            ], " ")
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$16ab1a80d501f8a0$var$join([
                "extend scalar",
                name,
                $16ab1a80d501f8a0$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$16ab1a80d501f8a0$var$join([
                "extend type",
                name,
                $16ab1a80d501f8a0$var$wrap("implements ", $16ab1a80d501f8a0$var$join(interfaces, " & ")),
                $16ab1a80d501f8a0$var$join(directives, " "),
                $16ab1a80d501f8a0$var$block(fields)
            ], " ")
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$16ab1a80d501f8a0$var$join([
                "extend interface",
                name,
                $16ab1a80d501f8a0$var$wrap("implements ", $16ab1a80d501f8a0$var$join(interfaces, " & ")),
                $16ab1a80d501f8a0$var$join(directives, " "),
                $16ab1a80d501f8a0$var$block(fields)
            ], " ")
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$16ab1a80d501f8a0$var$join([
                "extend union",
                name,
                $16ab1a80d501f8a0$var$join(directives, " "),
                $16ab1a80d501f8a0$var$wrap("= ", $16ab1a80d501f8a0$var$join(types, " | "))
            ], " ")
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$16ab1a80d501f8a0$var$join([
                "extend enum",
                name,
                $16ab1a80d501f8a0$var$join(directives, " "),
                $16ab1a80d501f8a0$var$block(values)
            ], " ")
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$16ab1a80d501f8a0$var$join([
                "extend input",
                name,
                $16ab1a80d501f8a0$var$join(directives, " "),
                $16ab1a80d501f8a0$var$block(fields)
            ], " ")
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $16ab1a80d501f8a0$var$join(maybeArray, separator = "") {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $16ab1a80d501f8a0$var$block(array) {
    return $16ab1a80d501f8a0$var$wrap("{\n", $16ab1a80d501f8a0$var$indent($16ab1a80d501f8a0$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $16ab1a80d501f8a0$var$wrap(start, maybeString, end = "") {
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $16ab1a80d501f8a0$var$indent(str) {
    return $16ab1a80d501f8a0$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $16ab1a80d501f8a0$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes("\n"))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}

});
parcelRegister("cdmvh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dedentBlockStringLines = $8e4827a7adffb48f$var$dedentBlockStringLines;
module.exports.isPrintableAsBlockString = $8e4827a7adffb48f$var$isPrintableAsBlockString;
module.exports.printBlockString = $8e4827a7adffb48f$var$printBlockString;

var $iwqkI = parcelRequire("iwqkI");
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $8e4827a7adffb48f$var$dedentBlockStringLines(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $8e4827a7adffb48f$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $8e4827a7adffb48f$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $iwqkI.isWhiteSpace)(str.charCodeAt(i)))++i;
    return i;
}
/**
 * @internal
 */ function $8e4827a7adffb48f$var$isPrintableAsBlockString(value) {
    if (value === "") return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */ function $8e4827a7adffb48f$var$printBlockString(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $iwqkI.isWhiteSpace)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith("\\");
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ""; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $iwqkI.isWhiteSpace)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += "\n";
    return '"""' + result + '"""';
}

});
parcelRegister("iwqkI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isDigit = $d7bfa4623fe4a536$var$isDigit;
module.exports.isLetter = $d7bfa4623fe4a536$var$isLetter;
module.exports.isNameContinue = $d7bfa4623fe4a536$var$isNameContinue;
module.exports.isNameStart = $d7bfa4623fe4a536$var$isNameStart;
module.exports.isWhiteSpace = $d7bfa4623fe4a536$var$isWhiteSpace;
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $d7bfa4623fe4a536$var$isWhiteSpace(code) {
    return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */ function $d7bfa4623fe4a536$var$isDigit(code) {
    return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */ function $d7bfa4623fe4a536$var$isLetter(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */ function $d7bfa4623fe4a536$var$isNameStart(code) {
    return $d7bfa4623fe4a536$var$isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */ function $d7bfa4623fe4a536$var$isNameContinue(code) {
    return $d7bfa4623fe4a536$var$isLetter(code) || $d7bfa4623fe4a536$var$isDigit(code) || code === 0x005f;
}

});


parcelRegister("4oRt0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.printString = $3342e0b8401af835$var$printString;
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $3342e0b8401af835$var$printString(str) {
    return `"${str.replace($3342e0b8401af835$var$escapedRegExp, $3342e0b8401af835$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $3342e0b8401af835$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $3342e0b8401af835$var$escapedReplacer(str) {
    return $3342e0b8401af835$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $3342e0b8401af835$var$escapeSequences = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
];

});

parcelRegister("eYGJs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BREAK = void 0;
module.exports.getEnterLeaveForKind = $ae77d0ffa02a986d$var$getEnterLeaveForKind;
module.exports.getVisitFn = $ae77d0ffa02a986d$var$getVisitFn;
module.exports.visit = $ae77d0ffa02a986d$var$visit;
module.exports.visitInParallel = $ae77d0ffa02a986d$var$visitInParallel;

var $7HjRa = parcelRequire("7HjRa");

var $71PGy = parcelRequire("71PGy");

var $e5z7V = parcelRequire("e5z7V");

var $7FejQ = parcelRequire("7FejQ");
const $ae77d0ffa02a986d$var$BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */ module.exports.BREAK = $ae77d0ffa02a986d$var$BREAK;
function $ae77d0ffa02a986d$var$visit(root, visitor, visitorKeys = $e5z7V.QueryDocumentKeys) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values($7FejQ.Kind))enterLeaveMap.set(kind, $ae77d0ffa02a986d$var$getEnterLeaveForKind(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $e5z7V.isNode)(node) || (0, $7HjRa.devAssert)(false, `Invalid AST Node: ${(0, $71PGy.inspect)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $ae77d0ffa02a986d$var$BREAK) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $e5z7V.isNode)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ function $ae77d0ffa02a986d$var$visitInParallel(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values($7FejQ.Kind)){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $ae77d0ffa02a986d$var$getEnterLeaveForKind(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $ae77d0ffa02a986d$var$BREAK) skipping[i] = $ae77d0ffa02a986d$var$BREAK;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $ae77d0ffa02a986d$var$BREAK) skipping[i] = $ae77d0ffa02a986d$var$BREAK;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */ function $ae77d0ffa02a986d$var$getEnterLeaveForKind(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === "object") // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === "function") // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */ /* c8 ignore next 8 */ function $ae77d0ffa02a986d$var$getVisitFn(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $ae77d0ffa02a986d$var$getEnterLeaveForKind(visitor, kind);
    return isLeaving ? leave : enter;
}

});
parcelRegister("7HjRa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.devAssert = $59abf3a445c1ae0e$var$devAssert;
function $59abf3a445c1ae0e$var$devAssert(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("71PGy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.inspect = $51e0b8072b11f88a$var$inspect;
const $51e0b8072b11f88a$var$MAX_ARRAY_LENGTH = 10;
const $51e0b8072b11f88a$var$MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */ function $51e0b8072b11f88a$var$inspect(value) {
    return $51e0b8072b11f88a$var$formatValue(value, []);
}
function $51e0b8072b11f88a$var$formatValue(value, seenValues) {
    switch(typeof value){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? `[function ${value.name}]` : "[function]";
        case "object":
            return $51e0b8072b11f88a$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $51e0b8072b11f88a$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($51e0b8072b11f88a$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : $51e0b8072b11f88a$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $51e0b8072b11f88a$var$formatArray(value, seenValues);
    return $51e0b8072b11f88a$var$formatObject(value, seenValues);
}
function $51e0b8072b11f88a$var$isJSONable(value) {
    return typeof value.toJSON === "function";
}
function $51e0b8072b11f88a$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > $51e0b8072b11f88a$var$MAX_RECURSIVE_DEPTH) return "[" + $51e0b8072b11f88a$var$getObjectTag(object) + "]";
    const properties = entries.map(([key, value])=>key + ": " + $51e0b8072b11f88a$var$formatValue(value, seenValues));
    return "{ " + properties.join(", ") + " }";
}
function $51e0b8072b11f88a$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $51e0b8072b11f88a$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    const len = Math.min($51e0b8072b11f88a$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($51e0b8072b11f88a$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return "[" + items.join(", ") + "]";
}
function $51e0b8072b11f88a$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        const name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}

});

parcelRegister("e5z7V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Token = module.exports.QueryDocumentKeys = module.exports.OperationTypeNode = module.exports.Location = void 0;
module.exports.isNode = $a41cc7c893a34191$var$isNode;
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $a41cc7c893a34191$var$Location {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return "Location";
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */ module.exports.Location = $a41cc7c893a34191$var$Location;
class $a41cc7c893a34191$var$Token {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return "Token";
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
/**
 * The list of all possible AST node types.
 */ module.exports.Token = $a41cc7c893a34191$var$Token;
/**
 * @internal
 */ const $a41cc7c893a34191$var$QueryDocumentKeys = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
module.exports.QueryDocumentKeys = $a41cc7c893a34191$var$QueryDocumentKeys;
const $a41cc7c893a34191$var$kindValues = new Set(Object.keys($a41cc7c893a34191$var$QueryDocumentKeys));
/**
 * @internal
 */ function $a41cc7c893a34191$var$isNode(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === "string" && $a41cc7c893a34191$var$kindValues.has(maybeKind);
}
/** Name */ var $a41cc7c893a34191$var$OperationTypeNode;
module.exports.OperationTypeNode = $a41cc7c893a34191$var$OperationTypeNode;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})($a41cc7c893a34191$var$OperationTypeNode || (module.exports.OperationTypeNode = $a41cc7c893a34191$var$OperationTypeNode = {}));

});

parcelRegister("7FejQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Kind = void 0;
/**
 * The set of allowed kind values for AST nodes.
 */ var $5947783ab14cbdbe$var$Kind;
module.exports.Kind = $5947783ab14cbdbe$var$Kind;
(function(Kind) {
    Kind["NAME"] = "Name";
    Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    Kind["DIRECTIVE"] = "Directive";
    Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})($5947783ab14cbdbe$var$Kind || (module.exports.Kind = $5947783ab14cbdbe$var$Kind = {})); /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 

});



parcelRegister("3801j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getOperationAST = $2472227aaf111d7a$var$getOperationAST;

var $7FejQ = parcelRequire("7FejQ");
/**
 * Returns an operation AST given a document AST and optionally an operation
 * name. If a name is not provided, an operation is only returned if only one is
 * provided in the document.
 */ function $2472227aaf111d7a$var$getOperationAST(documentAST, operationName) {
    let operation = null;
    for (const definition of documentAST.definitions)if (definition.kind === $7FejQ.Kind.OPERATION_DEFINITION) {
        var _definition$name;
        if (operationName == null) {
            // If no operation name was provided, only return an Operation if there
            // is one defined in the document. Upon encountering the second, return
            // null.
            if (operation) return null;
            operation = definition;
        } else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) return definition;
    }
    return operation;
}

});

parcelRegister("jnl2b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1b07b445b33eaea$export$2e2bcd8739ae039; });
/* global window */ 
var $lgGTS = parcelRequire("lgGTS");
var root;
if (typeof self !== "undefined") root = self;
else if (typeof window !== "undefined") root = window;
else if (typeof $parcel$global !== "undefined") root = $parcel$global;
else root = module;
var result = (0, $lgGTS.default)(root);
var $e1b07b445b33eaea$export$2e2bcd8739ae039 = result;

});
parcelRegister("lgGTS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7bc5eae92bc36f1$export$2e2bcd8739ae039; });
function $f7bc5eae92bc36f1$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol("observable");
            Symbol.observable = result;
        }
    } else result = "@@observable";
    return result;
}

});


parcelRegister("jNgRn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GRAPHQL_SUBSCRIPTIONS = module.exports.GRAPHQL_WS = void 0;
var $e68fabedb65c4fc8$var$GRAPHQL_WS = "graphql-ws";
module.exports.GRAPHQL_WS = $e68fabedb65c4fc8$var$GRAPHQL_WS;
var $e68fabedb65c4fc8$var$GRAPHQL_SUBSCRIPTIONS = "graphql-subscriptions";
module.exports.GRAPHQL_SUBSCRIPTIONS = $e68fabedb65c4fc8$var$GRAPHQL_SUBSCRIPTIONS;

});

parcelRegister("ikLy9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WS_TIMEOUT = module.exports.MIN_WS_TIMEOUT = void 0;
var $d58efaadc0e1a20d$var$MIN_WS_TIMEOUT = 1000;
module.exports.MIN_WS_TIMEOUT = $d58efaadc0e1a20d$var$MIN_WS_TIMEOUT;
var $d58efaadc0e1a20d$var$WS_TIMEOUT = 30000;
module.exports.WS_TIMEOUT = $d58efaadc0e1a20d$var$WS_TIMEOUT;

});

parcelRegister("41mq9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2ed8a5bf69f29854$var$MessageTypes = function() {
    function MessageTypes() {
        throw new Error("Static Class");
    }
    MessageTypes.GQL_CONNECTION_INIT = "connection_init";
    MessageTypes.GQL_CONNECTION_ACK = "connection_ack";
    MessageTypes.GQL_CONNECTION_ERROR = "connection_error";
    MessageTypes.GQL_CONNECTION_KEEP_ALIVE = "ka";
    MessageTypes.GQL_CONNECTION_TERMINATE = "connection_terminate";
    MessageTypes.GQL_START = "start";
    MessageTypes.GQL_DATA = "data";
    MessageTypes.GQL_ERROR = "error";
    MessageTypes.GQL_COMPLETE = "complete";
    MessageTypes.GQL_STOP = "stop";
    MessageTypes.SUBSCRIPTION_START = "subscription_start";
    MessageTypes.SUBSCRIPTION_DATA = "subscription_data";
    MessageTypes.SUBSCRIPTION_SUCCESS = "subscription_success";
    MessageTypes.SUBSCRIPTION_FAIL = "subscription_fail";
    MessageTypes.SUBSCRIPTION_END = "subscription_end";
    MessageTypes.INIT = "init";
    MessageTypes.INIT_SUCCESS = "init_success";
    MessageTypes.INIT_FAIL = "init_fail";
    MessageTypes.KEEP_ALIVE = "keepalive";
    return MessageTypes;
}();
module.exports.default = $2ed8a5bf69f29854$var$MessageTypes;

});



parcelRegister("j6URj", function(module, exports) {

$parcel$export(module.exports, "setContext", function () { return $de9aaed669033cc0$export$2f04de43fe27971a; });

var $l73V3 = parcelRequire("l73V3");

var $bdl4J = parcelRequire("bdl4J");
parcelRequire("5Xksu");
var $bMbZ0 = parcelRequire("bMbZ0");
function $de9aaed669033cc0$export$2f04de43fe27971a(setter) {
    return new (0, $bdl4J.ApolloLink)(function(operation, forward) {
        var request = (0, $l73V3.__rest)(operation, []);
        return new (0, $bMbZ0.Observable)(function(observer) {
            var handle;
            var closed = false;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                // if the observer is already closed, no need to subscribe.
                if (closed) return;
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                closed = true;
                if (handle) handle.unsubscribe();
            };
        });
    });
}

});

parcelRegister("5v0ib", function(module, exports) {
"use strict";

var $bdl4J = parcelRequire("bdl4J");parcelRequire("5Xksu");
var $bMbZ0 = parcelRequire("bMbZ0");
var $40101307367df2d7$require$ApolloLink = $bdl4J.ApolloLink;
var $40101307367df2d7$require$Observable = $bMbZ0.Observable;

var $3RM84 = parcelRequire("3RM84");
var $dUbO8 = parcelRequire("dUbO8");
var $1hxOH = parcelRequire("1hxOH");
var $eok7C = parcelRequire("eok7C");
var $1JmNc = parcelRequire("1JmNc");
var $gTTdj = parcelRequire("gTTdj");
var $40101307367df2d7$require$createSignalIfSupported = $3RM84.createSignalIfSupported;
var $40101307367df2d7$require$fallbackHttpConfig = $dUbO8.fallbackHttpConfig;
var $40101307367df2d7$require$parseAndCheckHttpResponse = $1hxOH.parseAndCheckHttpResponse;
var $40101307367df2d7$require$rewriteURIForGET = $eok7C.rewriteURIForGET;
var $40101307367df2d7$require$selectHttpOptionsAndBody = $dUbO8.selectHttpOptionsAndBody;
var $40101307367df2d7$require$selectURI = $1JmNc.selectURI;
var $40101307367df2d7$require$serializeFetchParameter = $gTTdj.serializeFetchParameter;

var $30ElS = parcelRequire("30ElS");

var $7dPxZ = parcelRequire("7dPxZ");

var $LWnE2 = parcelRequire("LWnE2");
/**
 * Creates a
 * [terminating Apollo Link](https://apollographql.com/docs/react/api/link/introduction/#the-terminating-link)
 * for [Apollo Client](https://apollographql.com/docs/react) that fetches a
 * [GraphQL multipart request](https://github.com/jaydenseric/graphql-multipart-request-spec)
 * if the GraphQL variables contain files (by default
 * [`FileList`](https://developer.mozilla.org/en-US/docs/Web/API/FileList),
 * [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File),
 * [`Blob`](https://developer.mozilla.org/en-US/docs/Web/API/Blob), or
 * [`ReactNativeFile`](#class-reactnativefile) instances), or else fetches a
 * regular
 * [GraphQL POST or GET request](https://apollographql.com/docs/apollo-server/requests)
 * (depending on the config and GraphQL operation).
 *
 * Some of the options are similar to the
 * [`createHttpLink` options](https://apollographql.com/docs/react/api/link/apollo-link-http/#httplink-constructor-options).
 * @see [GraphQL multipart request spec](https://github.com/jaydenseric/graphql-multipart-request-spec).
 * @kind function
 * @name createUploadLink
 * @param {object} options Options.
 * @param {string} [options.uri="/graphql"] GraphQL endpoint URI.
 * @param {boolean} [options.useGETForQueries] Should GET be used to fetch queries, if there are no files to upload.
 * @param {ExtractableFileMatcher} [options.isExtractableFile=isExtractableFile] Customizes how files are matched in the GraphQL operation for extraction.
 * @param {class} [options.FormData] [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) implementation to use, defaulting to the [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) global.
 * @param {FormDataFileAppender} [options.formDataAppendFile=formDataAppendFile] Customizes how extracted files are appended to the [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) instance.
 * @param {Function} [options.fetch] [`fetch`](https://fetch.spec.whatwg.org) implementation to use, defaulting to the [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch) global.
 * @param {FetchOptions} [options.fetchOptions] [`fetch` options]{@link FetchOptions}; overridden by upload requirements.
 * @param {string} [options.credentials] Overrides `options.fetchOptions.credentials`.
 * @param {object} [options.headers] Merges with and overrides `options.fetchOptions.headers`.
 * @param {boolean} [options.includeExtensions=false] Toggles sending `extensions` fields to the GraphQL server.
 * @returns {ApolloLink} A [terminating Apollo Link](https://apollographql.com/docs/react/api/link/introduction/#the-terminating-link).
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { createUploadLink } from "apollo-upload-client";
 * ```
 *
 * ```js
 * import createUploadLink from "apollo-upload-client/public/createUploadLink.js";
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { createUploadLink } = require("apollo-upload-client");
 * ```
 *
 * ```js
 * const createUploadLink = require("apollo-upload-client/public/createUploadLink.js");
 * ```
 * @example <caption>A basic Apollo Client setup.</caption>
 * ```js
 * import { ApolloClient, InMemoryCache } from "@apollo/client";
 * import createUploadLink from "apollo-upload-client/public/createUploadLink.js";
 *
 * const client = new ApolloClient({
 *   cache: new InMemoryCache(),
 *   link: createUploadLink(),
 * });
 * ```
 */ module.exports = function createUploadLink({ uri: fetchUri = "/graphql", useGETForQueries: useGETForQueries, isExtractableFile: customIsExtractableFile = $LWnE2, FormData: CustomFormData, formDataAppendFile: customFormDataAppendFile = $7dPxZ, fetch: customFetch, fetchOptions: fetchOptions, credentials: credentials, headers: headers, includeExtensions: includeExtensions } = {}) {
    const linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: fetchOptions,
        credentials: credentials,
        headers: headers
    };
    return new $40101307367df2d7$require$ApolloLink((operation)=>{
        const context = operation.getContext();
        const { // Apollo Studio client awareness `name` and `version` can be configured
        // via `ApolloClient` constructor options:
        // https://apollographql.com/docs/studio/client-awareness/#using-apollo-server-and-apollo-client
        clientAwareness: { name: name, version: version } = {}, headers: headers } = context;
        const contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: {
                // Client awareness headers can be overridden by context `headers`.
                ...name && {
                    "apollographql-client-name": name
                },
                ...version && {
                    "apollographql-client-version": version
                },
                ...headers
            }
        };
        const { options: options, body: body } = $40101307367df2d7$require$selectHttpOptionsAndBody(operation, $40101307367df2d7$require$fallbackHttpConfig, linkConfig, contextConfig);
        const { clone: clone, files: files } = $30ElS(body, "", customIsExtractableFile);
        let uri = $40101307367df2d7$require$selectURI(operation, fetchUri);
        if (files.size) {
            // Automatically set by `fetch` when the `body` is a `FormData` instance.
            delete options.headers["content-type"];
            // GraphQL multipart request spec:
            // https://github.com/jaydenseric/graphql-multipart-request-spec
            const RuntimeFormData = CustomFormData || FormData;
            const form = new RuntimeFormData();
            form.append("operations", $40101307367df2d7$require$serializeFetchParameter(clone, "Payload"));
            const map = {};
            let i = 0;
            files.forEach((paths)=>{
                map[++i] = paths;
            });
            form.append("map", JSON.stringify(map));
            i = 0;
            files.forEach((paths, file)=>{
                customFormDataAppendFile(form, ++i, file);
            });
            options.body = form;
        } else {
            if (useGETForQueries && // If the operation contains some mutations GET shouldn’t be used.
            !operation.query.definitions.some((definition)=>definition.kind === "OperationDefinition" && definition.operation === "mutation")) options.method = "GET";
            if (options.method === "GET") {
                const { newURI: newURI, parseError: parseError } = $40101307367df2d7$require$rewriteURIForGET(uri, body);
                if (parseError) // Apollo’s `HttpLink` uses `fromError` for this, but it’s not
                // exported from `@apollo/client/link/http`.
                return new $40101307367df2d7$require$Observable((observer)=>{
                    observer.error(parseError);
                });
                uri = newURI;
            } else options.body = $40101307367df2d7$require$serializeFetchParameter(clone, "Payload");
        }
        const { controller: controller } = $40101307367df2d7$require$createSignalIfSupported();
        if (controller) {
            if (options.signal) // Respect the user configured abort controller signal.
            options.signal.aborted ? controller.abort() : // does.
            options.signal.addEventListener("abort", ()=>{
                controller.abort();
            }, {
                // Prevent a memory leak if the user configured abort controller
                // is long lasting, or controls multiple things.
                once: true
            });
            options.signal = controller.signal;
        }
        const runtimeFetch = customFetch || fetch;
        return new $40101307367df2d7$require$Observable((observer)=>{
            // Used to track if the observable is being cleaned up.
            let cleaningUp;
            runtimeFetch(uri, options).then((response)=>{
                // Forward the response on the context.
                operation.setContext({
                    response: response
                });
                return response;
            }).then($40101307367df2d7$require$parseAndCheckHttpResponse(operation)).then((result)=>{
                observer.next(result);
                observer.complete();
            }).catch((error)=>{
                // If the observable is being cleaned up, there is no need to call
                // next or error because there are no more subscribers. An error after
                // cleanup begins is likely from the cleanup function aborting the
                // fetch.
                if (!cleaningUp) {
                    // For errors such as an invalid fetch URI there will be no GraphQL
                    // result with errors or data to forward.
                    if (error.result && error.result.errors && error.result.data) observer.next(error.result);
                    observer.error(error);
                }
            });
            // Cleanup function.
            return ()=>{
                cleaningUp = true;
                // Abort fetch. It’s ok to signal an abort even when not fetching.
                if (controller) controller.abort();
            };
        });
    });
};

});
parcelRegister("3RM84", function(module, exports) {

$parcel$export(module.exports, "createSignalIfSupported", function () { return $2d0ba7c71e19d499$export$f5853cd1fc39aea6; });
/**
 * @deprecated
 * This is not used internally any more and will be removed in
 * the next major version of Apollo Client.
 */ var $2d0ba7c71e19d499$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === "undefined") return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};

});

parcelRegister("30ElS", function(module, exports) {
"use strict";

var $je1S6 = parcelRequire("je1S6");
/**
 * Clones a value, recursively extracting
 * [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File),
 * [`Blob`](https://developer.mozilla.org/en-US/docs/Web/API/Blob) and
 * [`ReactNativeFile`]{@link ReactNativeFile} instances with their
 * [object paths]{@link ObjectPath}, replacing them with `null`.
 * [`FileList`](https://developer.mozilla.org/en-US/docs/Web/API/Filelist) instances
 * are treated as [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File)
 * instance arrays.
 * @kind function
 * @name extractFiles
 * @param {*} value Value (typically an object tree) to extract files from.
 * @param {ObjectPath} [path=''] Prefix for object paths for extracted files.
 * @param {ExtractableFileMatcher} [isExtractableFile=isExtractableFile] The function used to identify extractable files.
 * @returns {ExtractFilesResult} Result.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { extractFiles } from 'extract-files';
 * ```
 *
 * ```js
 * import extractFiles from 'extract-files/public/extractFiles.js';
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { extractFiles } = require('extract-files');
 * ```
 *
 * ```js
 * const extractFiles = require('extract-files/public/extractFiles.js');
 * ```
 * @example <caption>Extract files from an object.</caption>
 * For the following:
 *
 * ```js
 * const file1 = new File(['1'], '1.txt', { type: 'text/plain' });
 * const file2 = new File(['2'], '2.txt', { type: 'text/plain' });
 * const value = {
 *   a: file1,
 *   b: [file1, file2],
 * };
 *
 * const { clone, files } = extractFiles(value, 'prefix');
 * ```
 *
 * `value` remains the same.
 *
 * `clone` is:
 *
 * ```json
 * {
 *   "a": null,
 *   "b": [null, null]
 * }
 * ```
 *
 * `files` is a [`Map`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map) instance containing:
 *
 * | Key     | Value                        |
 * | :------ | :--------------------------- |
 * | `file1` | `['prefix.a', 'prefix.b.0']` |
 * | `file2` | `['prefix.b.1']`             |
 */ module.exports = function extractFiles(value, path = "", isExtractableFile = $je1S6) {
    // Map of extracted files and their object paths within the input value.
    const files = new Map();
    // Map of arrays and objects recursed within the input value and their clones,
    // for reusing clones of values that are referenced multiple times within the
    // input value.
    const clones = new Map();
    /**
   * Recursively clones the value, extracting files.
   * @kind function
   * @name extractFiles~recurse
   * @param {*} value Value to extract files from.
   * @param {ObjectPath} path Prefix for object paths for extracted files.
   * @param {Set} recursed Recursed arrays and objects for avoiding infinite recursion of circular references within the input value.
   * @returns {*} Clone of the value with files replaced with `null`.
   * @ignore
   */ function recurse(value, path, recursed) {
        let clone = value;
        if (isExtractableFile(value)) {
            clone = null;
            const filePaths = files.get(value);
            filePaths ? filePaths.push(path) : files.set(value, [
                path
            ]);
        } else {
            const isList = Array.isArray(value) || typeof FileList !== "undefined" && value instanceof FileList;
            const isObject = value && value.constructor === Object;
            if (isList || isObject) {
                const hasClone = clones.has(value);
                if (hasClone) clone = clones.get(value);
                else {
                    clone = isList ? [] : {};
                    clones.set(value, clone);
                }
                if (!recursed.has(value)) {
                    const pathPrefix = path ? `${path}.` : "";
                    const recursedDeeper = new Set(recursed).add(value);
                    if (isList) {
                        let index = 0;
                        for (const item of value){
                            const itemClone = recurse(item, pathPrefix + index++, recursedDeeper);
                            if (!hasClone) clone.push(itemClone);
                        }
                    } else for(const key in value){
                        const propertyClone = recurse(value[key], pathPrefix + key, recursedDeeper);
                        if (!hasClone) clone[key] = propertyClone;
                    }
                }
            }
        }
        return clone;
    }
    return {
        clone: recurse(value, path, new Set()),
        files: files
    };
};

});
parcelRegister("je1S6", function(module, exports) {
"use strict";

var $gtDV3 = parcelRequire("gtDV3");
/**
 * Checks if a value is an [extractable file]{@link ExtractableFile}.
 * @kind function
 * @name isExtractableFile
 * @type {ExtractableFileMatcher}
 * @param {*} value Value to check.
 * @returns {boolean} Is the value an [extractable file]{@link ExtractableFile}.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { isExtractableFile } from 'extract-files';
 * ```
 *
 * ```js
 * import isExtractableFile from 'extract-files/public/isExtractableFile.js';
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { isExtractableFile } = require('extract-files');
 * ```
 *
 * ```js
 * const isExtractableFile = require('extract-files/public/isExtractableFile.js');
 * ```
 */ module.exports = function isExtractableFile(value) {
    return typeof File !== "undefined" && value instanceof File || typeof Blob !== "undefined" && value instanceof Blob || value instanceof $gtDV3;
};

});
parcelRegister("gtDV3", function(module, exports) {
"use strict";
/**
 * Used to mark a
 * [React Native `File` substitute]{@link ReactNativeFileSubstitute}
 * in an object tree for [`extractFiles`]{@link extractFiles}. It’s too risky to
 * assume all objects with `uri`, `type` and `name` properties are files to
 * extract.
 * @kind class
 * @name ReactNativeFile
 * @param {ReactNativeFileSubstitute} file A [React Native](https://reactnative.dev) [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File) substitute.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { ReactNativeFile } from 'extract-files';
 * ```
 *
 * ```js
 * import ReactNativeFile from 'extract-files/public/ReactNativeFile.js';
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { ReactNativeFile } = require('extract-files');
 * ```
 *
 * ```js
 * const ReactNativeFile = require('extract-files/public/ReactNativeFile.js');
 * ```
 * @example <caption>An extractable file in [React Native](https://reactnative.dev).</caption>
 * ```js
 * const file = new ReactNativeFile({
 *   uri: uriFromCameraRoll,
 *   name: 'a.jpg',
 *   type: 'image/jpeg',
 * });
 * ```
 */ module.exports = class ReactNativeFile {
    constructor({ uri: uri, name: name, type: type }){
        this.uri = uri;
        this.name = name;
        this.type = type;
    }
};

});



parcelRegister("7dPxZ", function(module, exports) {
"use strict";
/**
 * The default implementation for [`createUploadLink`]{@link createUploadLink}
 * `options.formDataAppendFile` that uses the standard
 * [`FormData.append`](https://developer.mozilla.org/en-US/docs/Web/API/FormData/append)
 * method.
 * @kind function
 * @name formDataAppendFile
 * @type {FormDataFileAppender}
 * @param {FormData} formData [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) instance to append the specified file to.
 * @param {string} fieldName Field name for the file.
 * @param {*} file File to append.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { formDataAppendFile } from "apollo-upload-client";
 * ```
 *
 * ```js
 * import formDataAppendFile from "apollo-upload-client/public/formDataAppendFile.js";
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { formDataAppendFile } = require("apollo-upload-client");
 * ```
 *
 * ```js
 * const formDataAppendFile = require("apollo-upload-client/public/formDataAppendFile.js");
 * ```
 */ module.exports = function formDataAppendFile(formData, fieldName, file) {
    formData.append(fieldName, file, file.name);
};

});

parcelRegister("LWnE2", function(module, exports) {
"use strict";

/**
 * The default implementation for [`createUploadLink`]{@link createUploadLink}
 * `options.isExtractableFile`.
 * @kind function
 * @name isExtractableFile
 * @type {ExtractableFileMatcher}
 * @param {*} value Value to check.
 * @returns {boolean} Is the value an extractable file.
 * @see [`extract-files` `isExtractableFile` docs](https://github.com/jaydenseric/extract-files#function-isextractablefile).
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { isExtractableFile } from "apollo-upload-client";
 * ```
 *
 * ```js
 * import isExtractableFile from "apollo-upload-client/public/isExtractableFile.js";
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { isExtractableFile } = require("apollo-upload-client");
 * ```
 *
 * ```js
 * const isExtractableFile = require("apollo-upload-client/public/isExtractableFile.js");
 * ```
 */ module.exports = (parcelRequire("je1S6"));

});




parcelRegister("d13i8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $508689a00ee7d3ce$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $idMAb = parcelRequire("idMAb");

var $6L9uu = parcelRequire("6L9uu");
const $508689a00ee7d3ce$var$CancelButton = ({ id: id, text: text, disabled: disabled = false, onClick: onClick, sx: sx })=>{
    const getStyle = ()=>{
        let result = (0, $6L9uu.buttons).cancel;
        if (sx) result = {
            ...result,
            ...sx
        };
        return result;
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
        id: id,
        "data-testid": id,
        sx: getStyle(),
        disabled: disabled,
        onClick: onClick,
        children: text
    });
};
var $508689a00ee7d3ce$export$2e2bcd8739ae039 = $508689a00ee7d3ce$var$CancelButton;

});

parcelRegister("bSbwb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e212dbe1811fded$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $9WP8Q = parcelRequire("9WP8Q");

var $idMAb = parcelRequire("idMAb");
var $gDp1O = parcelRequire("gDp1O");
parcelRequire("bh6RR");

var $6L9uu = parcelRequire("6L9uu");
const $1e212dbe1811fded$var$EditButton = ({ id: id, onClick: onClick, disabled: disabled = false, editButtonColor: editButtonColor = (0, $6L9uu.Colors).skyBlue })=>{
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
        id: id,
        "data-testid": id,
        component: (0, $gDp1O.default),
        onClick: onClick,
        disabled: disabled,
        sx: {
            ...(0, $6L9uu.buttons).edit
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $9WP8Q.default), {
                sx: {
                    fontSize: "medium",
                    color: editButtonColor,
                    marginRight: "3px"
                }
            }),
            "EDIT"
        ]
    });
};
var $1e212dbe1811fded$export$2e2bcd8739ae039 = $1e212dbe1811fded$var$EditButton;

});
parcelRegister("9WP8Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73e133871d7f4dc8$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $73e133871d7f4dc8$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), "Edit");

});

parcelRegister("gDp1O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1c3b3eeb700ae14$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $7J7Kn = parcelRequire("7J7Kn");

var $fGH8N = parcelRequire("fGH8N");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $kVG1h = parcelRequire("kVG1h");

var $erAkb = parcelRequire("erAkb");

var $aitry = parcelRequire("aitry");

var $iRpKu = parcelRequire("iRpKu");

var $1ibNF = parcelRequire("1ibNF");

var $ih19M = parcelRequire("ih19M");
"use client";
const $c1c3b3eeb700ae14$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $c1c3b3eeb700ae14$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            "root",
            `underline${(0, $fGH8N.default)(underline)}`,
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $iRpKu.getLinkUtilityClass), classes);
};
const $c1c3b3eeb700ae14$var$LinkRoot = (0, $g4l1t.default)((0, $aitry.default), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $fGH8N.default)(ownerState.underline)}`],
            ownerState.component === "button" && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $4WYaH.default)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && (0, $4WYaH.default)({
        textDecoration: "underline"
    }, ownerState.color !== "inherit" && {
        textDecorationColor: (0, $1ibNF.default)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }), ownerState.component === "button" && {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        [`&.${(0, $iRpKu.default).focusVisible}`]: {
            outline: "auto"
        }
    });
});
const $c1c3b3eeb700ae14$var$Link = /*#__PURE__*/ $bh6RR.forwardRef(function Link(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiLink"
    });
    const { className: className, color: color = "primary", component: component = "a", onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = "always", variant: variant = "inherit", sx: sx } = props, other = (0, $hCIyK.default)(props, $c1c3b3eeb700ae14$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $kVG1h.default)();
    const [focusVisible, setFocusVisible] = $bh6RR.useState(false);
    const handlerRef = (0, $erAkb.default)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $c1c3b3eeb700ae14$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($c1c3b3eeb700ae14$var$LinkRoot, (0, $4WYaH.default)({
        color: color,
        className: (0, $aPsoC.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $1ibNF.colorTransformations)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $c1c3b3eeb700ae14$export$2e2bcd8739ae039 = $c1c3b3eeb700ae14$var$Link;

});
parcelRegister("iRpKu", function(module, exports) {

$parcel$export(module.exports, "getLinkUtilityClass", function () { return $dbb12663c27bfb2c$export$d6efab9620b78fec; });
$parcel$export(module.exports, "default", function () { return $dbb12663c27bfb2c$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $dbb12663c27bfb2c$export$d6efab9620b78fec(slot) {
    return (0, $XybB6.default)("MuiLink", slot);
}
const $dbb12663c27bfb2c$var$linkClasses = (0, $igcUF.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
var $dbb12663c27bfb2c$export$2e2bcd8739ae039 = $dbb12663c27bfb2c$var$linkClasses;

});

parcelRegister("1ibNF", function(module, exports) {

$parcel$export(module.exports, "colorTransformations", function () { return $0f10a022a711eccf$export$c4e140d5d351182b; });
$parcel$export(module.exports, "default", function () { return $0f10a022a711eccf$export$2e2bcd8739ae039; });

var $8ZvsC = parcelRequire("8ZvsC");

var $cG3EF = parcelRequire("cG3EF");
const $0f10a022a711eccf$export$c4e140d5d351182b = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $0f10a022a711eccf$var$transformDeprecatedColors = (color)=>{
    return $0f10a022a711eccf$export$c4e140d5d351182b[color] || color;
};
const $0f10a022a711eccf$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $0f10a022a711eccf$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $8ZvsC.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $8ZvsC.getPath)(theme, `palette.${transformedColor}Channel`);
    if ("vars" in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $cG3EF.alpha)(color, 0.4);
};
var $0f10a022a711eccf$export$2e2bcd8739ae039 = $0f10a022a711eccf$var$getTextDecoration;

});



parcelRegister("1ZlXU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73d4569322a38d81$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $idMAb = parcelRequire("idMAb");

var $6L9uu = parcelRequire("6L9uu");
const $73d4569322a38d81$var$SaveButton = ({ id: id, sx: sx, text: text, disabled: disabled = false, onClick: onClick })=>{
    const getStyle = ()=>{
        let result = (0, $6L9uu.buttons).save;
        if (sx) result = {
            ...result,
            ...sx
        };
        return result;
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
        id: id,
        "data-testid": id,
        sx: getStyle(),
        disabled: disabled,
        onClick: onClick,
        children: text
    });
};
var $73d4569322a38d81$export$2e2bcd8739ae039 = $73d4569322a38d81$var$SaveButton;

});

parcelRegister("bilGR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc35d977e93f4f33$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $dFfRw = parcelRequire("dFfRw");
var $5LQ5V = parcelRequire("5LQ5V");

var $6L9uu = parcelRequire("6L9uu");
const $fc35d977e93f4f33$var$AutocompleteComponent = ({ id: id, label: label, values: values, onChange: onChange, options: options, isSingle: isSingle = true, errorMsg: errorMsg, additionalStyle: additionalStyle, disabled: disabled = false, isWhite: isWhite = false, getOptionLabel: getOptionLabel, startAdornment: startAdornment, renderTags: renderTags, isOptionEqualToValue: isOptionEqualToValue })=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $dFfRw.default), {
        id: `${id}-autocomplete`,
        "data-testid": `${id}-autocomplete`,
        multiple: isSingle === true ? false : true,
        value: values,
        fullWidth: true,
        ...getOptionLabel && {
            getOptionLabel: getOptionLabel
        },
        filterSelectedOptions: true,
        onChange: onChange,
        disabled: disabled,
        renderOption: (props, option)=>{
            // Use option.id if available, otherwise use a combination of props
            const key = option?.id || option?.name || (typeof option === "string" ? option : props.id);
            return /*#__PURE__*/ (0, $bh6RR.createElement)("li", {
                ...props,
                key: key
            }, getOptionLabel ? getOptionLabel(option) : String(option));
        },
        options: options,
        sx: {
            minHeight: "36px",
            padding: 0,
            ...additionalStyle
        },
        ...isOptionEqualToValue && {
            isOptionEqualToValue: isOptionEqualToValue
        },
        renderInput: (params)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $5LQ5V.default), {
                ...params,
                id: id,
                label: label,
                disabled: disabled,
                ...errorMsg !== undefined && {
                    error: errorMsg !== null,
                    helperText: errorMsg ?? "",
                    required: true
                },
                sx: {
                    color: errorMsg !== undefined && errorMsg !== null ? (0, $6L9uu.Colors).red : (0, $6L9uu.Colors).main,
                    backgroundColor: isWhite ? (0, $6L9uu.Colors).white : (0, $6L9uu.Colors).input_field_background,
                    minHeight: "36px",
                    ...isSingle && {
                        maxHeight: "36px"
                    },
                    borderRadius: "9px",
                    "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                            border: "none"
                        }
                    }
                },
                InputProps: {
                    ...params.InputProps,
                    sx: {
                        paddingY: "0 !important",
                        position: "relative",
                        paddingLeft: `${startAdornment ? "5" : "12"}px !important`
                    },
                    startAdornment: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                        children: [
                            startAdornment,
                            params.InputProps.startAdornment
                        ]
                    })
                },
                FormHelperTextProps: {
                    sx: {
                        marginX: 0
                    }
                },
                InputLabelProps: {
                    sx: {
                        lineHeight: "22px",
                        top: "-9px",
                        color: errorMsg !== undefined && errorMsg !== null ? (0, $6L9uu.Colors).red : (0, $6L9uu.Colors).main
                    }
                },
                inputProps: {
                    ...params.inputProps,
                    sx: {
                        height: "36px",
                        padding: "0 !important",
                        color: errorMsg !== undefined && errorMsg !== null ? (0, $6L9uu.Colors).red : (0, $6L9uu.Colors).main
                    }
                }
            }),
        renderTags: renderTags
    });
};
var $fc35d977e93f4f33$export$2e2bcd8739ae039 = $fc35d977e93f4f33$var$AutocompleteComponent;

});
parcelRegister("dFfRw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f2b689a0491b6c3$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");



var $gMiUv = parcelRequire("gMiUv");

var $7J7Kn = parcelRequire("7J7Kn");

var $cG3EF = parcelRequire("cG3EF");

var $9tY0V = parcelRequire("9tY0V");

var $cy5H8 = parcelRequire("cy5H8");

var $iTI7v = parcelRequire("iTI7v");

var $am7GZ = parcelRequire("am7GZ");

var $gu8wR = parcelRequire("gu8wR");

var $lIfEy = parcelRequire("lIfEy");

var $k1IMo = parcelRequire("k1IMo");

var $fjIjG = parcelRequire("fjIjG");

var $lDuMV = parcelRequire("lDuMV");

var $9Nyb2 = parcelRequire("9Nyb2");

var $4bgmh = parcelRequire("4bgmh");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $bY3JP = parcelRequire("bY3JP");

var $fGH8N = parcelRequire("fGH8N");

var $erAkb = parcelRequire("erAkb");

var $ih19M = parcelRequire("ih19M");
"use client";
var $9f2b689a0491b6c3$var$_ClearIcon, $9f2b689a0491b6c3$var$_ArrowDropDownIcon;
const $9f2b689a0491b6c3$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionKey",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $9f2b689a0491b6c3$var$_excluded2 = [
    "ref"
];
const $9f2b689a0491b6c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            expanded && "expanded",
            focused && "focused",
            fullWidth && "fullWidth",
            hasClearIcon && "hasClearIcon",
            hasPopupIcon && "hasPopupIcon"
        ],
        inputRoot: [
            "inputRoot"
        ],
        input: [
            "input",
            inputFocused && "inputFocused"
        ],
        tag: [
            "tag",
            `tagSize${(0, $fGH8N.default)(size)}`
        ],
        endAdornment: [
            "endAdornment"
        ],
        clearIndicator: [
            "clearIndicator"
        ],
        popupIndicator: [
            "popupIndicator",
            popupOpen && "popupIndicatorOpen"
        ],
        popper: [
            "popper",
            disablePortal && "popperDisablePortal"
        ],
        paper: [
            "paper"
        ],
        listbox: [
            "listbox"
        ],
        loading: [
            "loading"
        ],
        noOptions: [
            "noOptions"
        ],
        option: [
            "option"
        ],
        groupLabel: [
            "groupLabel"
        ],
        groupUl: [
            "groupUl"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $bY3JP.getAutocompleteUtilityClass), classes);
};
const $9f2b689a0491b6c3$var$AutocompleteRoot = (0, $g4l1t.default)("div", {
    name: "MuiAutocomplete",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $bY3JP.default).tag}`]: styles.tag
            },
            {
                [`& .${(0, $bY3JP.default).tag}`]: styles[`tagSize${(0, $fGH8N.default)(size)}`]
            },
            {
                [`& .${(0, $bY3JP.default).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $bY3JP.default).input}`]: styles.input
            },
            {
                [`& .${(0, $bY3JP.default).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        [`&.${(0, $bY3JP.default).focused} .${(0, $bY3JP.default).clearIndicator}`]: {
            visibility: "visible"
        },
        /* Avoid double tap issue on iOS */ "@media (pointer: fine)": {
            [`&:hover .${(0, $bY3JP.default).clearIndicator}`]: {
                visibility: "visible"
            }
        }
    }, ownerState.fullWidth && {
        width: "100%"
    }, {
        [`& .${(0, $bY3JP.default).tag}`]: (0, $4WYaH.default)({
            margin: 3,
            maxWidth: "calc(100% - 6px)"
        }, ownerState.size === "small" && {
            margin: 2,
            maxWidth: "calc(100% - 4px)"
        }),
        [`& .${(0, $bY3JP.default).inputRoot}`]: {
            flexWrap: "wrap",
            [`.${(0, $bY3JP.default).hasPopupIcon}&, .${(0, $bY3JP.default).hasClearIcon}&`]: {
                paddingRight: 30
            },
            [`.${(0, $bY3JP.default).hasPopupIcon}.${(0, $bY3JP.default).hasClearIcon}&`]: {
                paddingRight: 56
            },
            [`& .${(0, $bY3JP.default).input}`]: {
                width: 0,
                minWidth: 30
            }
        },
        [`& .${(0, $lIfEy.default).root}`]: {
            paddingBottom: 1,
            "& .MuiInput-input": {
                padding: "4px 4px 4px 0px"
            }
        },
        [`& .${(0, $lIfEy.default).root}.${(0, $k1IMo.default).sizeSmall}`]: {
            [`& .${(0, $lIfEy.default).input}`]: {
                padding: "2px 4px 3px 0"
            }
        },
        [`& .${(0, $fjIjG.default).root}`]: {
            padding: 9,
            [`.${(0, $bY3JP.default).hasPopupIcon}&, .${(0, $bY3JP.default).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $bY3JP.default).hasPopupIcon}.${(0, $bY3JP.default).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $bY3JP.default).input}`]: {
                padding: "7.5px 4px 7.5px 5px"
            },
            [`& .${(0, $bY3JP.default).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $fjIjG.default).root}.${(0, $k1IMo.default).sizeSmall}`]: {
            // Don't specify paddingRight, as it overrides the default value set when there is only
            // one of the popup or clear icon as the specificity is equal so the latter one wins
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            [`& .${(0, $bY3JP.default).input}`]: {
                padding: "2.5px 4px 2.5px 8px"
            }
        },
        [`& .${(0, $lDuMV.default).root}`]: {
            paddingTop: 19,
            paddingLeft: 8,
            [`.${(0, $bY3JP.default).hasPopupIcon}&, .${(0, $bY3JP.default).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $bY3JP.default).hasPopupIcon}.${(0, $bY3JP.default).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $lDuMV.default).input}`]: {
                padding: "7px 4px"
            },
            [`& .${(0, $bY3JP.default).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $lDuMV.default).root}.${(0, $k1IMo.default).sizeSmall}`]: {
            paddingBottom: 1,
            [`& .${(0, $lDuMV.default).input}`]: {
                padding: "2.5px 4px"
            }
        },
        [`& .${(0, $k1IMo.default).hiddenLabel}`]: {
            paddingTop: 8
        },
        [`& .${(0, $lDuMV.default).root}.${(0, $k1IMo.default).hiddenLabel}`]: {
            paddingTop: 0,
            paddingBottom: 0,
            [`& .${(0, $bY3JP.default).input}`]: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        [`& .${(0, $lDuMV.default).root}.${(0, $k1IMo.default).hiddenLabel}.${(0, $k1IMo.default).sizeSmall}`]: {
            [`& .${(0, $bY3JP.default).input}`]: {
                paddingTop: 8,
                paddingBottom: 9
            }
        },
        [`& .${(0, $bY3JP.default).input}`]: (0, $4WYaH.default)({
            flexGrow: 1,
            textOverflow: "ellipsis",
            opacity: 0
        }, ownerState.inputFocused && {
            opacity: 1
        })
    }));
const $9f2b689a0491b6c3$var$AutocompleteEndAdornment = (0, $g4l1t.default)("div", {
    name: "MuiAutocomplete",
    slot: "EndAdornment",
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translate(0, -50%)"
});
const $9f2b689a0491b6c3$var$AutocompleteClearIndicator = (0, $g4l1t.default)((0, $am7GZ.default), {
    name: "MuiAutocomplete",
    slot: "ClearIndicator",
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: "hidden"
});
const $9f2b689a0491b6c3$var$AutocompletePopupIndicator = (0, $g4l1t.default)((0, $am7GZ.default), {
    name: "MuiAutocomplete",
    slot: "PopupIndicator",
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $4WYaH.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        padding: 2,
        marginRight: -2
    }, ownerState.popupOpen && {
        transform: "rotate(180deg)"
    }));
const $9f2b689a0491b6c3$var$AutocompletePopper = (0, $g4l1t.default)((0, $9tY0V.default), {
    name: "MuiAutocomplete",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $bY3JP.default).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        zIndex: (theme.vars || theme).zIndex.modal
    }, ownerState.disablePortal && {
        position: "absolute"
    }));
const $9f2b689a0491b6c3$var$AutocompletePaper = (0, $g4l1t.default)((0, $iTI7v.default), {
    name: "MuiAutocomplete",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $4WYaH.default)({}, theme.typography.body1, {
        overflow: "auto"
    }));
const $9f2b689a0491b6c3$var$AutocompleteLoading = (0, $g4l1t.default)("div", {
    name: "MuiAutocomplete",
    slot: "Loading",
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $9f2b689a0491b6c3$var$AutocompleteNoOptions = (0, $g4l1t.default)("div", {
    name: "MuiAutocomplete",
    slot: "NoOptions",
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $9f2b689a0491b6c3$var$AutocompleteListbox = (0, $g4l1t.default)("div", {
    name: "MuiAutocomplete",
    slot: "Listbox",
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: "none",
        margin: 0,
        padding: "8px 0",
        maxHeight: "40vh",
        overflow: "auto",
        position: "relative",
        [`& .${(0, $bY3JP.default).option}`]: {
            minHeight: 48,
            display: "flex",
            overflow: "hidden",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: 6,
            boxSizing: "border-box",
            outline: "0",
            WebkitTapHighlightColor: "transparent",
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up("sm")]: {
                minHeight: "auto"
            },
            [`&.${(0, $bY3JP.default).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: "none"
            },
            [`&.${(0, $bY3JP.default).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cG3EF.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $bY3JP.default).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $cG3EF.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $bY3JP.default).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cG3EF.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $9f2b689a0491b6c3$var$AutocompleteGroupLabel = (0, $g4l1t.default)((0, $cy5H8.default), {
    name: "MuiAutocomplete",
    slot: "GroupLabel",
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $9f2b689a0491b6c3$var$AutocompleteGroupUl = (0, $g4l1t.default)("ul", {
    name: "MuiAutocomplete",
    slot: "GroupUl",
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $bY3JP.default).option}`]: {
        paddingLeft: 24
    }
});
const $9f2b689a0491b6c3$var$Autocomplete = /*#__PURE__*/ $bh6RR.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiAutocomplete"
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $9f2b689a0491b6c3$var$_ClearIcon || ($9f2b689a0491b6c3$var$_ClearIcon = /*#__PURE__*/ (0, $ih19M.jsx)((0, $9Nyb2.default), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = "Clear", closeText: closeText = "Close", componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = "auto", freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = "ul", ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = "No options", openOnFocus: openOnFocus = false, openText: openText = "Open", PaperComponent: PaperComponent = (0, $iTI7v.default), PopperComponent: PopperComponent = (0, $9tY0V.default), popupIcon: popupIcon = $9f2b689a0491b6c3$var$_ArrowDropDownIcon || ($9f2b689a0491b6c3$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $ih19M.jsx)((0, $4bgmh.default), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = "medium", slotProps: slotProps = {} } = props, other = (0, $hCIyK.default)(props, $9f2b689a0491b6c3$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $gMiUv.useAutocomplete)((0, $4WYaH.default)({}, props, {
        componentName: "Autocomplete"
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $hCIyK.default)(_getListboxProps, $9f2b689a0491b6c3$var$_excluded2);
    const combinedListboxRef = (0, $erAkb.default)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $4WYaH.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $9f2b689a0491b6c3$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $4WYaH.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), (0, $4WYaH.default)({
                label: getOptionLabel(option),
                size: size
            }, getCustomizedTagProps({
                index: index
            }), ChipProps)));
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $ih19M.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)($9f2b689a0491b6c3$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)($9f2b689a0491b6c3$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        return /*#__PURE__*/ (0, $bh6RR.createElement)("li", (0, $4WYaH.default)({}, props2, {
            key: props2.key
        }), getOptionLabel(option));
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $4WYaH.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps["aria-selected"],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($9f2b689a0491b6c3$var$AutocompleteRoot, (0, $4WYaH.default)({
                ref: ref,
                className: (0, $aPsoC.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === "small" ? "small" : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $4WYaH.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $ih19M.jsxs)($9f2b689a0491b6c3$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $ih19M.jsx)($9f2b689a0491b6c3$var$AutocompleteClearIndicator, (0, $4WYaH.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $aPsoC.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $ih19M.jsx)($9f2b689a0491b6c3$var$AutocompletePopupIndicator, (0, $4WYaH.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $aPsoC.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $4WYaH.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? /*#__PURE__*/ (0, $ih19M.jsx)($9f2b689a0491b6c3$var$AutocompletePopper, (0, $4WYaH.default)({
                as: PopperComponent,
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: popupOpen
            }, popperSlotProps, {
                className: (0, $aPsoC.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
                children: /*#__PURE__*/ (0, $ih19M.jsxs)($9f2b689a0491b6c3$var$AutocompletePaper, (0, $4WYaH.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, paperSlotProps, {
                    className: (0, $aPsoC.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $ih19M.jsx)($9f2b689a0491b6c3$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $ih19M.jsx)($9f2b689a0491b6c3$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $ih19M.jsx)($9f2b689a0491b6c3$var$AutocompleteListbox, (0, $4WYaH.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, otherListboxProps, ListboxProps, {
                            ref: combinedListboxRef,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            })) : null
        ]
    });
});
var $9f2b689a0491b6c3$export$2e2bcd8739ae039 = $9f2b689a0491b6c3$var$Autocomplete;

});
parcelRegister("gMiUv", function(module, exports) {

$parcel$export(module.exports, "useAutocomplete", function () { return $c36fcc418c3bdd61$export$1e40b3ca02d92d21; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $gzLMq = parcelRequire("gzLMq");
var $dI1ry = parcelRequire("dI1ry");
var $5EGAX = parcelRequire("5EGAX");
var $fVi1O = parcelRequire("fVi1O");
var $aab6n = parcelRequire("aab6n");
"use client";
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $c36fcc418c3bdd61$var$stripDiacritics(string) {
    return typeof string.normalize !== "undefined" ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : string;
}
function $c36fcc418c3bdd61$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = "any", stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $c36fcc418c3bdd61$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $c36fcc418c3bdd61$var$stripDiacritics(candidate);
            return matchFrom === "start" ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $c36fcc418c3bdd61$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $c36fcc418c3bdd61$var$defaultFilterOptions = $c36fcc418c3bdd61$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $c36fcc418c3bdd61$var$pageSize = 5;
const $c36fcc418c3bdd61$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
function $c36fcc418c3bdd61$export$1e40b3ca02d92d21(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $c36fcc418c3bdd61$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = "Mui", autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = "useAutocomplete", defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $c36fcc418c3bdd61$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $fVi1O.default)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== "string") return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $bh6RR.useRef(false);
    const firstFocus = $bh6RR.useRef(true);
    const inputRef = $bh6RR.useRef(null);
    const listboxRef = $bh6RR.useRef(null);
    const [anchorEl, setAnchorEl] = $bh6RR.useState(null);
    const [focusedTag, setFocusedTag] = $bh6RR.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $bh6RR.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $dI1ry.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $dI1ry.default)({
        controlled: inputValueProp,
        default: "",
        name: componentName,
        state: "inputValue"
    });
    const [focused, setFocused] = $bh6RR.useState(false);
    const resetInputValue = $bh6RR.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = "";
        else if (newValue == null) newInputValue = "";
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === "string" ? optionLabel : "";
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, "reset");
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $dI1ry.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: "open"
    });
    const [inputPristine, setInputPristine] = $bh6RR.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? "" : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $aab6n.default)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $bh6RR.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $5EGAX.default)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $bh6RR.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute("aria-disabled") === "true";
            if (option && option.hasAttribute("tabindex") && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === "next") nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $5EGAX.default)(({ event: event, index: index, reason: reason = "auto" })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute("aria-activedescendant");
        else inputRef.current.setAttribute("aria-activedescendant", `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute("role") !== "listbox") listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === "keyboard") option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== "mouse" && reason !== "touch") {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $5EGAX.default)(({ event: event, diff: diff, direction: direction = "next", reason: reason = "auto" })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === "reset") return defaultHighlighted;
            if (diff === "start") return 0;
            if (diff === "end") return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== "reset") {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const checkHighlightedOptionExists = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : "";
            const label2 = value2 ? getOptionLabel(value2) : "";
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) {
                const previousHighlightedOptionExists = filteredOptions.some((option)=>{
                    return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
                });
                if (previousHighlightedOptionExists) return true;
            }
        }
        return false;
    };
    const syncHighlightedIndex = $bh6RR.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, return, otherwise continue execution
        if (checkHighlightedOptionExists()) return;
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: "reset"
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $c36fcc418c3bdd61$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $c36fcc418c3bdd61$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: "reset"
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $5EGAX.default)((node)=>{
        (0, $gzLMq.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $bh6RR.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $bh6RR.useRef(false);
    const selectNewValue = (event, option, reasonProp = "selectOption", origin = "options")=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $c36fcc418c3bdd61$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== "freeSolo") {
                newValue.splice(itemIndex, 1);
                reason = "removeOption";
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === "touch" && isTouch.current || blurOnSelect === "mouse" && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === value.length || direction === "previous" && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute("tabindex") || option.disabled || option.getAttribute("aria-disabled") === "true") nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === "") handleClose(event, "toggleInput");
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === "" && direction === "previous") nextTag = value.length - 1;
        } else {
            nextTag += direction === "next" ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState("");
        if (onInputChange) onInputChange(event, "", "clear");
        handleValue(event, multiple ? [] : null, "clear");
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                "ArrowLeft",
                "ArrowRight"
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case "Home":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "start",
                            direction: "next",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "End":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "end",
                            direction: "previous",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "PageUp":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$c36fcc418c3bdd61$var$pageSize,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "PageDown":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $c36fcc418c3bdd61$var$pageSize,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowDown":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowUp":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowLeft":
                    handleFocusTag(event, "previous");
                    break;
                case "ArrowRight":
                    handleFocusTag(event, "next");
                    break;
                case "Enter":
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, "selectOption");
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== "" && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, "createOption", "freeSolo");
                    }
                    break;
                case "Escape":
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, "escape");
                    } else if (clearOnEscape && (inputValue !== "" || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case "Backspace":
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === "" && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                case "Delete":
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === "" && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], "blur");
        else if (autoSelect && freeSolo && inputValue !== "") selectNewValue(event, inputValue, "blur", "freeSolo");
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, "blur");
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, "input");
        }
        if (newValue === "") {
            if (!disableClearable && !multiple) handleValue(event, null, "clear");
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: "mouse"
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute("data-option-index")),
            reason: "touch"
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        selectNewValue(event, filteredOptions[index], "selectOption");
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, "removeOption", {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, "toggleInput");
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute("id") !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === "" || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $4WYaH.default)({
                "aria-owns": listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                "aria-activedescendant": popupOpen ? "" : null,
                "aria-autocomplete": autoComplete ? "both" : "list",
                "aria-controls": listboxAvailable ? `${id}-listbox` : undefined,
                "aria-expanded": listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: "off",
                ref: inputRef,
                autoCapitalize: "none",
                spellCheck: "false",
                role: "combobox",
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $4WYaH.default)({
                key: index,
                "data-tag-index": index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: "listbox",
                id: `${id}-listbox`,
                "aria-labelledby": `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            var _getOptionKey;
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: "option",
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                "data-option-index": index,
                "aria-disabled": disabled,
                "aria-selected": selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}

});
parcelRegister("aab6n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7663732c5bd19fbe$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
"use client";
const $7663732c5bd19fbe$var$usePreviousProps = (value)=>{
    const ref = $bh6RR.useRef({});
    $bh6RR.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $7663732c5bd19fbe$export$2e2bcd8739ae039 = $7663732c5bd19fbe$var$usePreviousProps;

});


parcelRegister("cy5H8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $922d13e2d1180e07$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $fGH8N = parcelRequire("fGH8N");

var $kKgpU = parcelRequire("kKgpU");

var $ih19M = parcelRequire("ih19M");
"use client";
const $922d13e2d1180e07$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $922d13e2d1180e07$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "default" && `color${(0, $fGH8N.default)(color)}`,
            !disableGutters && "gutters",
            inset && "inset",
            !disableSticky && "sticky"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $kKgpU.getListSubheaderUtilityClass), classes);
};
const $922d13e2d1180e07$var$ListSubheaderRoot = (0, $g4l1t.default)("li", {
    name: "MuiListSubheader",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $fGH8N.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        boxSizing: "border-box",
        lineHeight: "48px",
        listStyle: "none",
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === "primary" && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $922d13e2d1180e07$var$ListSubheader = /*#__PURE__*/ $bh6RR.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiListSubheader"
    });
    const { className: className, color: color = "default", component: component = "li", disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $hCIyK.default)(props, $922d13e2d1180e07$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $922d13e2d1180e07$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($922d13e2d1180e07$var$ListSubheaderRoot, (0, $4WYaH.default)({
        as: component,
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$922d13e2d1180e07$var$ListSubheader.muiSkipListHighlight = true;
var $922d13e2d1180e07$export$2e2bcd8739ae039 = $922d13e2d1180e07$var$ListSubheader;

});
parcelRegister("kKgpU", function(module, exports) {

$parcel$export(module.exports, "getListSubheaderUtilityClass", function () { return $f1a4d69163b88267$export$6816d4fc0981ec7; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $f1a4d69163b88267$export$6816d4fc0981ec7(slot) {
    return (0, $XybB6.default)("MuiListSubheader", slot);
}
const $f1a4d69163b88267$var$listSubheaderClasses = (0, $igcUF.default)("MuiListSubheader", [
    "root",
    "colorPrimary",
    "colorInherit",
    "gutters",
    "inset",
    "sticky"
]);
var $f1a4d69163b88267$export$2e2bcd8739ae039 = $f1a4d69163b88267$var$listSubheaderClasses;

});


parcelRegister("gu8wR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c006105814d3ce35$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $cG3EF = parcelRequire("cG3EF");

var $5V7S3 = parcelRequire("5V7S3");

var $erAkb = parcelRequire("erAkb");


var $fGH8N = parcelRequire("fGH8N");

var $aEoM0 = parcelRequire("aEoM0");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $lLxkV = parcelRequire("lLxkV");

var $ih19M = parcelRequire("ih19M");
"use client";
const $c006105814d3ce35$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $c006105814d3ce35$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, $fGH8N.default)(size)}`,
            `color${(0, $fGH8N.default)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, $fGH8N.default)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, $fGH8N.default)(color)}`,
            `${variant}${(0, $fGH8N.default)(color)}`
        ],
        label: [
            "label",
            `label${(0, $fGH8N.default)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, $fGH8N.default)(size)}`,
            `avatarColor${(0, $fGH8N.default)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, $fGH8N.default)(size)}`,
            `iconColor${(0, $fGH8N.default)(iconColor)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, $fGH8N.default)(size)}`,
            `deleteIconColor${(0, $fGH8N.default)(color)}`,
            `deleteIcon${(0, $fGH8N.default)(variant)}Color${(0, $fGH8N.default)(color)}`
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $lLxkV.getChipUtilityClass), classes);
};
const $c006105814d3ce35$var$ChipRoot = (0, $g4l1t.default)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $lLxkV.default).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $lLxkV.default).avatar}`]: styles[`avatar${(0, $fGH8N.default)(size)}`]
            },
            {
                [`& .${(0, $lLxkV.default).avatar}`]: styles[`avatarColor${(0, $fGH8N.default)(color)}`]
            },
            {
                [`& .${(0, $lLxkV.default).icon}`]: styles.icon
            },
            {
                [`& .${(0, $lLxkV.default).icon}`]: styles[`icon${(0, $fGH8N.default)(size)}`]
            },
            {
                [`& .${(0, $lLxkV.default).icon}`]: styles[`iconColor${(0, $fGH8N.default)(iconColor)}`]
            },
            {
                [`& .${(0, $lLxkV.default).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $lLxkV.default).deleteIcon}`]: styles[`deleteIcon${(0, $fGH8N.default)(size)}`]
            },
            {
                [`& .${(0, $lLxkV.default).deleteIcon}`]: styles[`deleteIconColor${(0, $fGH8N.default)(color)}`]
            },
            {
                [`& .${(0, $lLxkV.default).deleteIcon}`]: styles[`deleteIcon${(0, $fGH8N.default)(variant)}Color${(0, $fGH8N.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $fGH8N.default)(size)}`],
            styles[`color${(0, $fGH8N.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, $fGH8N.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, $fGH8N.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $fGH8N.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $4WYaH.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: "unset",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, $lLxkV.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, $lLxkV.default).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $lLxkV.default).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $lLxkV.default).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $lLxkV.default).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $lLxkV.default).icon}`]: (0, $4WYaH.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $4WYaH.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== "default" && {
            color: "inherit"
        })),
        [`& .${(0, $lLxkV.default).deleteIcon}`]: (0, $4WYaH.default)({
            WebkitTapHighlightColor: "transparent",
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $cG3EF.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $cG3EF.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $cG3EF.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $lLxkV.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cG3EF.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, $lLxkV.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $cG3EF.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $lLxkV.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cG3EF.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, $lLxkV.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $lLxkV.default).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $lLxkV.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $lLxkV.default).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $lLxkV.default).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $lLxkV.default).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $lLxkV.default).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $lLxkV.default).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $lLxkV.default).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $cG3EF.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $lLxkV.default).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cG3EF.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $lLxkV.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $cG3EF.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $lLxkV.default).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $cG3EF.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $c006105814d3ce35$var$ChipLabel = (0, $g4l1t.default)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $fGH8N.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.variant === "outlined" && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $c006105814d3ce35$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $c006105814d3ce35$var$Chip = /*#__PURE__*/ $bh6RR.forwardRef(function Chip(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = "default", component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = "medium", variant: variant = "filled", tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $hCIyK.default)(props, $c006105814d3ce35$var$_excluded);
    const chipRef = $bh6RR.useRef(null);
    const handleRef = (0, $erAkb.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $c006105814d3ce35$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $c006105814d3ce35$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $aEoM0.default) : ComponentProp || "div";
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $bh6RR.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $c006105814d3ce35$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $aEoM0.default) ? (0, $4WYaH.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $bh6RR.isValidElement(deleteIconProp) ? /*#__PURE__*/ $bh6RR.cloneElement(deleteIconProp, {
        className: (0, $aPsoC.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $5V7S3.default), {
        className: (0, $aPsoC.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $bh6RR.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $bh6RR.cloneElement(avatarProp, {
        className: (0, $aPsoC.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $bh6RR.isValidElement(iconProp)) icon = /*#__PURE__*/ $bh6RR.cloneElement(iconProp, {
        className: (0, $aPsoC.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)($c006105814d3ce35$var$ChipRoot, (0, $4WYaH.default)({
        as: component,
        className: (0, $aPsoC.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $ih19M.jsx)($c006105814d3ce35$var$ChipLabel, {
                className: (0, $aPsoC.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $c006105814d3ce35$export$2e2bcd8739ae039 = $c006105814d3ce35$var$Chip;

});
parcelRegister("5V7S3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44f86198119aa73f$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $44f86198119aa73f$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");

});

parcelRegister("lLxkV", function(module, exports) {

$parcel$export(module.exports, "getChipUtilityClass", function () { return $fd87d8adf0590d8e$export$31444911e4ee6fdd; });
$parcel$export(module.exports, "default", function () { return $fd87d8adf0590d8e$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $fd87d8adf0590d8e$export$31444911e4ee6fdd(slot) {
    return (0, $XybB6.default)("MuiChip", slot);
}
const $fd87d8adf0590d8e$var$chipClasses = (0, $igcUF.default)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "filledPrimary",
    "filledSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "deleteIconFilledColorPrimary",
    "deleteIconFilledColorSecondary",
    "focusVisible"
]);
var $fd87d8adf0590d8e$export$2e2bcd8739ae039 = $fd87d8adf0590d8e$var$chipClasses;

});


parcelRegister("9Nyb2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72233380a191cb0e$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $72233380a191cb0e$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");

});

parcelRegister("bY3JP", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteUtilityClass", function () { return $8b68329d14afc7d7$export$8ee01529667e66d9; });
$parcel$export(module.exports, "default", function () { return $8b68329d14afc7d7$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $8b68329d14afc7d7$export$8ee01529667e66d9(slot) {
    return (0, $XybB6.default)("MuiAutocomplete", slot);
}
const $8b68329d14afc7d7$var$autocompleteClasses = (0, $igcUF.default)("MuiAutocomplete", [
    "root",
    "expanded",
    "fullWidth",
    "focused",
    "focusVisible",
    "tag",
    "tagSizeSmall",
    "tagSizeMedium",
    "hasPopupIcon",
    "hasClearIcon",
    "inputRoot",
    "input",
    "inputFocused",
    "endAdornment",
    "clearIndicator",
    "popupIndicator",
    "popupIndicatorOpen",
    "popper",
    "popperDisablePortal",
    "paper",
    "listbox",
    "loading",
    "noOptions",
    "option",
    "groupLabel",
    "groupUl"
]);
var $8b68329d14afc7d7$export$2e2bcd8739ae039 = $8b68329d14afc7d7$var$autocompleteClasses;

});



parcelRegister("ehzwo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57ae23f055b7d3d3$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $5LQ5V = parcelRequire("5LQ5V");

var $6L9uu = parcelRequire("6L9uu");
const $57ae23f055b7d3d3$var$InputComponent = ({ id: id, label: label, value: value, onChange: onChange, type: type = "text", disabled: disabled = false, placeholder: placeholder, errorMsg: errorMsg, isEditable: isEditable = true, additionalStyle: additionalStyle, multiline: multiline = false, rows: rows, onKeyPress: onKeyPress, required: required, startAdornment: startAdornment, endAdornment: endAdornment, withoutBackground: withoutBackground = false, inputLabelProps: inputLabelProps, boldText: boldText = false, isWhite: isWhite = false })=>{
    const defaultLabelProps = {
        shrink: true,
        sx: {
            lineHeight: "22px",
            top: "-14px",
            left: "15px",
            color: errorMsg !== undefined && errorMsg !== null ? (0, $6L9uu.Colors).red : isEditable ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray
        }
    };
    const getBackGround = ()=>{
        if (isWhite) return "white";
        else if (withoutBackground) return "none";
        else return (0, $6L9uu.Colors).input_background;
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5LQ5V.default), {
        variant: "standard",
        id: id,
        "data-testid": id,
        name: id,
        label: label,
        type: type,
        fullWidth: true,
        multiline: multiline,
        required: required ?? false,
        value: value,
        rows: rows,
        onKeyPress: onKeyPress,
        onChange: onChange,
        disabled: disabled,
        ...placeholder && {
            placeholder: placeholder
        },
        ...errorMsg !== undefined && {
            error: errorMsg !== null,
            helperText: errorMsg ?? "",
            required: required ?? true
        },
        sx: {
            background: getBackGround(),
            borderRadius: "9px",
            height: multiline ? "auto" : "36px",
            pl: startAdornment ? "5px" : "12px",
            pr: "15px",
            ...additionalStyle
        },
        InputProps: {
            disableUnderline: true,
            sx: {
                margin: "0 !important",
                fontWeight: boldText ? "bold" : "normal"
            },
            startAdornment: startAdornment,
            endAdornment: endAdornment
        },
        inputProps: {
            sx: {
                height: multiline ? "auto" : "36px",
                paddingY: 0,
                color: isEditable ? errorMsg !== undefined && errorMsg !== null ? (0, $6L9uu.Colors).red : (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).dark_gray
            },
            "data-testid": `${id}-value`
        },
        InputLabelProps: inputLabelProps ?? defaultLabelProps
    });
};
var $57ae23f055b7d3d3$export$2e2bcd8739ae039 = $57ae23f055b7d3d3$var$InputComponent;

});

parcelRegister("5PJ2i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9e305f333834d1d$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $7opAt = parcelRequire("7opAt");
var $am7GZ = parcelRequire("am7GZ");

var $6L9uu = parcelRequire("6L9uu");

var $3Xpkr = parcelRequire("3Xpkr");
const $e9e305f333834d1d$var$DialogBox = ({ id: id, title: title = "", width: width, height: height, children: children, onClose: onClose, childrenSx: childrenSx, hideTitle: hideTitle })=>{
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $7opAt.default), {
        id: `${id}-dialog`,
        open: true,
        sx: {
            "& .MuiDialog-container": {
                alignItems: "center",
                display: "flex"
            }
        },
        PaperProps: {
            sx: {
                m: 0,
                maxWidth: `${width}px`,
                width: `${width}px`,
                ...height && {
                    height: height
                }
            }
        },
        BackdropProps: {
            sx: {
                background: (0, $6L9uu.Colors).modalBackground
            }
        },
        onClose: hideTitle ? onClose : undefined,
        children: [
            !hideTitle && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                id: `${id}-dialog-title`,
                className: "centralize",
                sx: {
                    borderBottom: `1px solid ${(0, $6L9uu.Colors).skyBlue}`,
                    color: (0, $6L9uu.Colors).skyBlue,
                    fontSize: "22px",
                    fontWeight: "bold",
                    minHeight: "62px"
                },
                children: [
                    title,
                    onClose ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $am7GZ.default), {
                        "aria-label": "close",
                        onClick: onClose,
                        sx: {
                            position: "absolute",
                            right: "15px",
                            top: "18px",
                            color: (theme)=>theme.palette.primary.main,
                            boxShadow: (theme)=>`0px 0px 5px ${theme.palette.primary.main}`
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3Xpkr.default), {
                            sx: {
                                width: 10,
                                height: 10
                            }
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: childrenSx,
                children: children
            })
        ]
    });
};
var $e9e305f333834d1d$export$2e2bcd8739ae039 = $e9e305f333834d1d$var$DialogBox;

});
parcelRegister("7opAt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $561e9f5f7ec53bec$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $fVi1O = parcelRequire("fVi1O");

var $fGH8N = parcelRequire("fGH8N");

var $cXsrx = parcelRequire("cXsrx");

var $9q08x = parcelRequire("9q08x");

var $iTI7v = parcelRequire("iTI7v");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $6Dwk8 = parcelRequire("6Dwk8");

var $b78ua = parcelRequire("b78ua");

var $74PV0 = parcelRequire("74PV0");

var $8gyMY = parcelRequire("8gyMY");

var $ih19M = parcelRequire("ih19M");
"use client";
const $561e9f5f7ec53bec$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $561e9f5f7ec53bec$var$DialogBackdrop = (0, $g4l1t.default)((0, $74PV0.default), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $561e9f5f7ec53bec$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $fGH8N.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $fGH8N.default)(scroll)}`,
            `paperWidth${(0, $fGH8N.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $6Dwk8.getDialogUtilityClass), classes);
};
const $561e9f5f7ec53bec$var$DialogRoot = (0, $g4l1t.default)((0, $cXsrx.default), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $561e9f5f7ec53bec$var$DialogContainer = (0, $g4l1t.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $fGH8N.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&::after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $561e9f5f7ec53bec$var$DialogPaper = (0, $g4l1t.default)((0, $iTI7v.default), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $fGH8N.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $fGH8N.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $6Dwk8.default).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $6Dwk8.default).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $6Dwk8.default).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $561e9f5f7ec53bec$var$Dialog = /*#__PURE__*/ $bh6RR.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $8gyMY.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $iTI7v.default), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $9q08x.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $hCIyK.default)(props, $561e9f5f7ec53bec$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $561e9f5f7ec53bec$var$useUtilityClasses(ownerState);
    const backdropClick = $bh6RR.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $fVi1O.default)(ariaLabelledbyProp);
    const dialogContextValue = $bh6RR.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($561e9f5f7ec53bec$var$DialogRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $561e9f5f7ec53bec$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $4WYaH.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ih19M.jsx)($561e9f5f7ec53bec$var$DialogContainer, {
                className: (0, $aPsoC.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ih19M.jsx)($561e9f5f7ec53bec$var$DialogPaper, (0, $4WYaH.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $aPsoC.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b78ua.default).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $561e9f5f7ec53bec$export$2e2bcd8739ae039 = $561e9f5f7ec53bec$var$Dialog;

});
parcelRegister("6Dwk8", function(module, exports) {

$parcel$export(module.exports, "getDialogUtilityClass", function () { return $4d4f7569a139d850$export$2177af0aa15c34c2; });
$parcel$export(module.exports, "default", function () { return $4d4f7569a139d850$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $4d4f7569a139d850$export$2177af0aa15c34c2(slot) {
    return (0, $XybB6.default)("MuiDialog", slot);
}
const $4d4f7569a139d850$var$dialogClasses = (0, $igcUF.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $4d4f7569a139d850$export$2e2bcd8739ae039 = $4d4f7569a139d850$var$dialogClasses;

});

parcelRegister("b78ua", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8176ee30e609649d$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
const $8176ee30e609649d$var$DialogContext = /*#__PURE__*/ $bh6RR.createContext({});
var $8176ee30e609649d$export$2e2bcd8739ae039 = $8176ee30e609649d$var$DialogContext;

});



parcelRegister("gF9d2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6407749dfa45d5cc$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $5LQ5V = parcelRequire("5LQ5V");

var $imgsA = parcelRequire("imgsA");

var $6L9uu = parcelRequire("6L9uu");
const $6407749dfa45d5cc$var$EpraTimePicker = ({ id: id, label: label, value: value, onChange: onChange, sx: sx, errorMsg: errorMsg, disabled: disabled = false })=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $imgsA.MobileTimePicker), {
        label: label,
        value: value,
        onChange: onChange,
        disabled: disabled,
        renderInput: (params)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $5LQ5V.default), {
                ...params,
                id: id,
                disabled: disabled,
                ...errorMsg !== undefined && {
                    error: errorMsg !== null,
                    helperText: errorMsg ?? "",
                    required: true
                },
                sx: {
                    color: errorMsg !== undefined && errorMsg !== null ? (0, $6L9uu.Colors).red : (0, $6L9uu.Colors).main,
                    backgroundColor: (0, $6L9uu.Colors).input_field_background,
                    height: "36px",
                    borderRadius: "9px",
                    "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                            border: "none"
                        }
                    },
                    ...sx
                },
                InputProps: {
                    ...params.InputProps
                },
                FormHelperTextProps: {
                    sx: {
                        marginX: 0
                    }
                },
                InputLabelProps: {
                    shrink: true,
                    sx: {
                        lineHeight: "22px",
                        top: "-9px",
                        color: errorMsg !== undefined && errorMsg !== null ? (0, $6L9uu.Colors).red : (0, $6L9uu.Colors).main
                    }
                },
                inputProps: {
                    ...params.inputProps,
                    sx: {
                        height: "36px",
                        paddingLeft: "15px",
                        paddingY: 0,
                        color: errorMsg !== undefined && errorMsg !== null ? (0, $6L9uu.Colors).red : (0, $6L9uu.Colors).main
                    }
                }
            })
    });
};
var $6407749dfa45d5cc$export$2e2bcd8739ae039 = $6407749dfa45d5cc$var$EpraTimePicker;

});
parcelRegister("imgsA", function(module, exports) {

$parcel$export(module.exports, "MobileTimePicker", function () { return $d5d70caf634213ad$export$984018df37898b81; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $cJU0b = parcelRequire("cJU0b");

var $ert7l = parcelRequire("ert7l");

var $9jUBC = parcelRequire("9jUBC");

var $c8yp0 = parcelRequire("c8yp0");

var $5vQoE = parcelRequire("5vQoE");

var $48l9K = parcelRequire("48l9K");

var $kWl3f = parcelRequire("kWl3f");

var $ih19M = parcelRequire("ih19M");
const $d5d70caf634213ad$var$_excluded = [
    "ToolbarComponent",
    "value",
    "onChange",
    "components",
    "componentsProps"
];
const $d5d70caf634213ad$export$984018df37898b81 = /*#__PURE__*/ $bh6RR.forwardRef(function MobileTimePicker(inProps, ref) {
    const props = (0, $cJU0b.useTimePickerDefaultizedProps)(inProps, "MuiMobileTimePicker");
    const validationError = (0, $5vQoE.useTimeValidation)(props) !== null;
    const { pickerProps: pickerProps, inputProps: inputProps, wrapperProps: wrapperProps } = (0, $kWl3f.usePickerState)(props, (0, $cJU0b.timePickerValueManager)); // Note that we are passing down all the value without spread.
    // It saves us >1kb gzip and make any prop available automatically on any level down.
    const { ToolbarComponent: ToolbarComponent = (0, $ert7l.TimePickerToolbar), components: components, componentsProps: componentsProps } = props, other = (0, $hCIyK.default)(props, $d5d70caf634213ad$var$_excluded);
    const DateInputProps = (0, $4WYaH.default)({}, inputProps, other, {
        components: components,
        componentsProps: componentsProps,
        ref: ref,
        validationError: validationError
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $9jUBC.MobileWrapper), (0, $4WYaH.default)({}, other, wrapperProps, {
        DateInputProps: DateInputProps,
        PureDateInputComponent: (0, $48l9K.PureDateInput),
        components: components,
        componentsProps: componentsProps,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $c8yp0.CalendarOrClockPicker), (0, $4WYaH.default)({}, pickerProps, {
            autoFocus: true,
            toolbarTitle: props.label || props.toolbarTitle,
            ToolbarComponent: ToolbarComponent,
            DateInputProps: DateInputProps,
            components: components,
            componentsProps: componentsProps
        }, other))
    }));
});

});
parcelRegister("cJU0b", function(module, exports) {

$parcel$export(module.exports, "useTimePickerDefaultizedProps", function () { return $946520d85569c63b$export$586c31b46cc238ba; });
$parcel$export(module.exports, "timePickerValueManager", function () { return $946520d85569c63b$export$d61bc0fc2de603bd; });

var $4WYaH = parcelRequire("4WYaH");

var $cNBED = parcelRequire("cNBED");

var $7W0sU = parcelRequire("7W0sU");

var $8aNCA = parcelRequire("8aNCA");

var $BN6Vh = parcelRequire("BN6Vh");
function $946520d85569c63b$export$586c31b46cc238ba(props, name) {
    var _themeProps$ampm;
    // This is technically unsound if the type parameters appear in optional props.
    // Optional props can be filled by `useThemeProps` with types that don't match the type parameters.
    const themeProps = (0, $cNBED.default)({
        props: props,
        name: name
    });
    const utils = (0, $8aNCA.useUtils)();
    const ampm = (_themeProps$ampm = themeProps.ampm) != null ? _themeProps$ampm : utils.is12HourCycleInCurrentLocale();
    const localeText = (0, $8aNCA.useLocaleText)();
    const getOpenDialogAriaText = localeText.openTimePickerDialogue;
    return (0, $4WYaH.default)({
        ampm: ampm,
        openTo: "hours",
        views: [
            "hours",
            "minutes"
        ],
        acceptRegex: ampm ? /[\dapAP]/gi : /\d/gi,
        disableMaskedInput: false,
        getOpenDialogAriaText: getOpenDialogAriaText,
        inputFormat: ampm ? utils.formats.fullTime12h : utils.formats.fullTime24h
    }, themeProps, {
        components: (0, $4WYaH.default)({
            OpenPickerIcon: (0, $7W0sU.Clock)
        }, themeProps.components)
    });
}
const $946520d85569c63b$export$d61bc0fc2de603bd = {
    emptyValue: null,
    parseInput: (0, $BN6Vh.parsePickerInputValue),
    getTodayValue: (utils)=>utils.date(),
    areValuesEqual: (utils, a, b)=>utils.isEqual(a, b),
    valueReducer: (utils, lastValidValue, newValue)=>{
        if (!lastValidValue || !utils.isValid(newValue)) return newValue;
        return utils.mergeDateAndTime(lastValidValue, newValue);
    }
};

});

parcelRegister("ert7l", function(module, exports) {

$parcel$export(module.exports, "TimePickerToolbar", function () { return $a83a2c674f73047e$export$76f7aa019fd43cd9; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");
parcelRequire("bh6RR");

var $g4l1t = parcelRequire("g4l1t");
var $8gyMY = parcelRequire("8gyMY");
var $cNBED = parcelRequire("cNBED");

var $7J7Kn = parcelRequire("7J7Kn");

var $4V1Q0 = parcelRequire("4V1Q0");

var $kFFow = parcelRequire("kFFow");

var $iFxFm = parcelRequire("iFxFm");

var $ihv4a = parcelRequire("ihv4a");

var $3xeL1 = parcelRequire("3xeL1");

var $8aNCA = parcelRequire("8aNCA");

var $3f8YG = parcelRequire("3f8YG");

var $04RB7 = parcelRequire("04RB7");

var $ih19M = parcelRequire("ih19M");
const $a83a2c674f73047e$var$_excluded = [
    "ampm",
    "ampmInClock",
    "parsedValue",
    "isLandscape",
    "isMobileKeyboardViewOpen",
    "onChange",
    "openView",
    "setOpenView",
    "toggleMobileKeyboardView",
    "toolbarTitle",
    "views",
    "disabled",
    "readOnly"
];
const $a83a2c674f73047e$var$useUtilityClasses = (ownerState)=>{
    const { theme: theme, isLandscape: isLandscape, classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        separator: [
            "separator"
        ],
        hourMinuteLabel: [
            "hourMinuteLabel",
            isLandscape && "hourMinuteLabelLandscape",
            theme.direction === "rtl" && "hourMinuteLabelReverse"
        ],
        ampmSelection: [
            "ampmSelection",
            isLandscape && "ampmLandscape"
        ],
        ampmLabel: [
            "ampmLabel"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $04RB7.getTimePickerToolbarUtilityClass), classes);
};
const $a83a2c674f73047e$var$TimePickerToolbarRoot = (0, $g4l1t.default)((0, $iFxFm.PickersToolbar), {
    name: "MuiTimePickerToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    [`& .${(0, $ihv4a.pickersToolbarClasses).penIconButtonLandscape}`]: {
        marginTop: "auto"
    }
});
const $a83a2c674f73047e$var$TimePickerToolbarSeparator = (0, $g4l1t.default)((0, $4V1Q0.PickersToolbarText), {
    name: "MuiTimePickerToolbar",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})({
    outline: 0,
    margin: "0 4px 0 2px",
    cursor: "default"
});
const $a83a2c674f73047e$var$TimePickerToolbarHourMinuteLabel = (0, $g4l1t.default)("div", {
    name: "MuiTimePickerToolbar",
    slot: "HourMinuteLabel",
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $04RB7.timePickerToolbarClasses).hourMinuteLabelLandscape}`]: styles.hourMinuteLabelLandscape,
                [`&.${(0, $04RB7.timePickerToolbarClasses).hourMinuteLabelReverse}`]: styles.hourMinuteLabelReverse
            },
            styles.hourMinuteLabel
        ]
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end"
    }, ownerState.isLandscape && {
        marginTop: "auto"
    }, theme.direction === "rtl" && {
        flexDirection: "row-reverse"
    }));
const $a83a2c674f73047e$var$TimePickerToolbarAmPmSelection = (0, $g4l1t.default)("div", {
    name: "MuiTimePickerToolbar",
    slot: "AmPmSelection",
    overridesResolver: (props, styles)=>[
            {
                [`.${(0, $04RB7.timePickerToolbarClasses).ampmLabel}`]: styles.ampmLabel
            },
            {
                [`&.${(0, $04RB7.timePickerToolbarClasses).ampmLandscape}`]: styles.ampmLandscape
            },
            styles.ampmSelection
        ]
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "flex",
        flexDirection: "column",
        marginRight: "auto",
        marginLeft: 12
    }, ownerState.isLandscape && {
        margin: "4px 0 auto",
        flexDirection: "row",
        justifyContent: "space-around",
        flexBasis: "100%"
    }, {
        [`& .${(0, $04RB7.timePickerToolbarClasses).ampmLabel}`]: {
            fontSize: 17
        }
    }));
function $a83a2c674f73047e$export$76f7aa019fd43cd9(inProps) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTimePickerToolbar"
    });
    const { ampm: ampm, ampmInClock: ampmInClock, parsedValue: parsedValue, isLandscape: isLandscape, isMobileKeyboardViewOpen: isMobileKeyboardViewOpen, onChange: onChange, openView: openView, setOpenView: setOpenView, toggleMobileKeyboardView: toggleMobileKeyboardView, toolbarTitle: toolbarTitleProp, views: views, disabled: disabled, readOnly: readOnly } = props, other = (0, $hCIyK.default)(props, $a83a2c674f73047e$var$_excluded);
    const utils = (0, $8aNCA.useUtils)();
    const localeText = (0, $8aNCA.useLocaleText)();
    const toolbarTitle = toolbarTitleProp != null ? toolbarTitleProp : localeText.timePickerDefaultToolbarTitle;
    const theme = (0, $8gyMY.default)();
    const showAmPmControl = Boolean(ampm && !ampmInClock);
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $3f8YG.useMeridiemMode)(parsedValue, ampm, onChange);
    const formatHours = (time)=>ampm ? utils.format(time, "hours12h") : utils.format(time, "hours24h");
    const ownerState = props;
    const classes = $a83a2c674f73047e$var$useUtilityClasses((0, $4WYaH.default)({}, ownerState, {
        theme: theme
    }));
    const separator = /*#__PURE__*/ (0, $ih19M.jsx)($a83a2c674f73047e$var$TimePickerToolbarSeparator, {
        tabIndex: -1,
        value: ":",
        variant: "h3",
        selected: false,
        className: classes.separator
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)($a83a2c674f73047e$var$TimePickerToolbarRoot, (0, $4WYaH.default)({
        viewType: "clock",
        landscapeDirection: "row",
        toolbarTitle: toolbarTitle,
        isLandscape: isLandscape,
        isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
        toggleMobileKeyboardView: toggleMobileKeyboardView,
        ownerState: ownerState,
        className: classes.root
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)($a83a2c674f73047e$var$TimePickerToolbarHourMinuteLabel, {
                className: classes.hourMinuteLabel,
                ownerState: ownerState,
                children: [
                    (0, $3xeL1.arrayIncludes)(views, "hours") && /*#__PURE__*/ (0, $ih19M.jsx)((0, $kFFow.PickersToolbarButton), {
                        tabIndex: -1,
                        variant: "h3",
                        onClick: ()=>setOpenView("hours"),
                        selected: openView === "hours",
                        value: parsedValue ? formatHours(parsedValue) : "--"
                    }),
                    (0, $3xeL1.arrayIncludes)(views, [
                        "hours",
                        "minutes"
                    ]) && separator,
                    (0, $3xeL1.arrayIncludes)(views, "minutes") && /*#__PURE__*/ (0, $ih19M.jsx)((0, $kFFow.PickersToolbarButton), {
                        tabIndex: -1,
                        variant: "h3",
                        onClick: ()=>setOpenView("minutes"),
                        selected: openView === "minutes",
                        value: parsedValue ? utils.format(parsedValue, "minutes") : "--"
                    }),
                    (0, $3xeL1.arrayIncludes)(views, [
                        "minutes",
                        "seconds"
                    ]) && separator,
                    (0, $3xeL1.arrayIncludes)(views, "seconds") && /*#__PURE__*/ (0, $ih19M.jsx)((0, $kFFow.PickersToolbarButton), {
                        variant: "h3",
                        onClick: ()=>setOpenView("seconds"),
                        selected: openView === "seconds",
                        value: parsedValue ? utils.format(parsedValue, "seconds") : "--"
                    })
                ]
            }),
            showAmPmControl && /*#__PURE__*/ (0, $ih19M.jsxs)($a83a2c674f73047e$var$TimePickerToolbarAmPmSelection, {
                className: classes.ampmSelection,
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $kFFow.PickersToolbarButton), {
                        disableRipple: true,
                        variant: "subtitle2",
                        selected: meridiemMode === "am",
                        typographyClassName: classes.ampmLabel,
                        value: utils.getMeridiemText("am"),
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("am"),
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $kFFow.PickersToolbarButton), {
                        disableRipple: true,
                        variant: "subtitle2",
                        selected: meridiemMode === "pm",
                        typographyClassName: classes.ampmLabel,
                        value: utils.getMeridiemText("pm"),
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("pm"),
                        disabled: disabled
                    })
                ]
            })
        ]
    }));
}

});
parcelRegister("4V1Q0", function(module, exports) {

$parcel$export(module.exports, "PickersToolbarText", function () { return $394de942ff675294$export$2006bc630443fa2; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");

var $d56pS = parcelRequire("d56pS");

var $aitry = parcelRequire("aitry");

var $g4l1t = parcelRequire("g4l1t");

var $7J7Kn = parcelRequire("7J7Kn");

var $l22e1 = parcelRequire("l22e1");

var $ih19M = parcelRequire("ih19M");
const $394de942ff675294$var$_excluded = [
    "className",
    "selected",
    "value"
];
const $394de942ff675294$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $l22e1.getPickersToolbarTextUtilityClass), classes);
};
const $394de942ff675294$var$PickersToolbarTextRoot = (0, $g4l1t.default)((0, $aitry.default), {
    name: "PrivatePickersToolbarText",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $l22e1.pickersToolbarTextClasses).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>({
        transition: theme.transitions.create("color"),
        color: theme.palette.text.secondary,
        [`&.${(0, $l22e1.pickersToolbarTextClasses).selected}`]: {
            color: theme.palette.text.primary
        }
    }));
const $394de942ff675294$export$2006bc630443fa2 = /*#__PURE__*/ $bh6RR.forwardRef(function PickersToolbarText(props, ref) {
    // TODO v6: add 'useThemeProps' once the component class names are aligned
    const { className: className, value: value } = props, other = (0, $hCIyK.default)(props, $394de942ff675294$var$_excluded);
    const classes = $394de942ff675294$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $ih19M.jsx)($394de942ff675294$var$PickersToolbarTextRoot, (0, $4WYaH.default)({
        ref: ref,
        className: (0, $d56pS.default)(className, classes.root),
        component: "span"
    }, other, {
        children: value
    }));
});

});
parcelRegister("l22e1", function(module, exports) {

$parcel$export(module.exports, "getPickersToolbarTextUtilityClass", function () { return $f4fb82c27d713f66$export$2aab7addfa1bc589; });
$parcel$export(module.exports, "pickersToolbarTextClasses", function () { return $f4fb82c27d713f66$export$4ca7b92014bf2e56; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
function $f4fb82c27d713f66$export$2aab7addfa1bc589(slot) {
    // TODO v6: Rename 'PrivatePickersToolbarText' to 'MuiPickersToolbarText' to follow convention
    return (0, $XybB6.default)("PrivatePickersToolbarText", slot);
} // TODO v6: Rename 'PrivatePickersToolbarText' to 'MuiPickersToolbarText' to follow convention
const $f4fb82c27d713f66$export$4ca7b92014bf2e56 = (0, $igcUF.default)("PrivatePickersToolbarText", [
    "root",
    "selected"
]);

});


parcelRegister("kFFow", function(module, exports) {

$parcel$export(module.exports, "PickersToolbarButton", function () { return $f0c7bf0fd6cf3865$export$614ed940168c780c; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");

var $d56pS = parcelRequire("d56pS");

var $idMAb = parcelRequire("idMAb");

var $g4l1t = parcelRequire("g4l1t");
var $cNBED = parcelRequire("cNBED");

var $7J7Kn = parcelRequire("7J7Kn");

var $4V1Q0 = parcelRequire("4V1Q0");

var $ihv4a = parcelRequire("ihv4a");

var $ih19M = parcelRequire("ih19M");
const $f0c7bf0fd6cf3865$var$_excluded = [
    "align",
    "className",
    "selected",
    "typographyClassName",
    "value",
    "variant"
];
const $f0c7bf0fd6cf3865$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $ihv4a.getPickersToolbarUtilityClass), classes);
};
const $f0c7bf0fd6cf3865$var$PickersToolbarButtonRoot = (0, $g4l1t.default)((0, $idMAb.default), {
    name: "MuiPickersToolbarButton",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    padding: 0,
    minWidth: 16,
    textTransform: "none"
});
const $f0c7bf0fd6cf3865$export$614ed940168c780c = /*#__PURE__*/ $bh6RR.forwardRef(function PickersToolbarButton(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiPickersToolbarButton"
    });
    const { align: align, className: className, selected: selected, typographyClassName: typographyClassName, value: value, variant: variant } = props, other = (0, $hCIyK.default)(props, $f0c7bf0fd6cf3865$var$_excluded);
    const classes = $f0c7bf0fd6cf3865$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $ih19M.jsx)($f0c7bf0fd6cf3865$var$PickersToolbarButtonRoot, (0, $4WYaH.default)({
        variant: "text",
        ref: ref,
        className: (0, $d56pS.default)(className, classes.root)
    }, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4V1Q0.PickersToolbarText), {
            align: align,
            className: typographyClassName,
            variant: variant,
            value: value,
            selected: selected
        })
    }));
});

});

parcelRegister("04RB7", function(module, exports) {

$parcel$export(module.exports, "getTimePickerToolbarUtilityClass", function () { return $00e9f332d8a40698$export$56e751cdf7deddcb; });
$parcel$export(module.exports, "timePickerToolbarClasses", function () { return $00e9f332d8a40698$export$b6febfcac6caa550; });

var $XybB6 = parcelRequire("XybB6");
var $igcUF = parcelRequire("igcUF");
function $00e9f332d8a40698$export$56e751cdf7deddcb(slot) {
    return (0, $XybB6.default)("MuiTimePickerToolbar", slot);
}
const $00e9f332d8a40698$export$b6febfcac6caa550 = (0, $igcUF.default)("MuiTimePickerToolbar", [
    "root",
    "separator",
    "hourMinuteLabel",
    "hourMinuteLabelLandscape",
    "hourMinuteLabelReverse",
    "ampmSelection",
    "ampmLandscape",
    "ampmLabel"
]);

});


parcelRegister("9jUBC", function(module, exports) {

$parcel$export(module.exports, "MobileWrapper", function () { return $6c91cc201ccfc97d$export$170a55317307b99f; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");
parcelRequire("bh6RR");

var $gHJ0l = parcelRequire("gHJ0l");

var $68dwK = parcelRequire("68dwK");

var $ih19M = parcelRequire("ih19M");
const $6c91cc201ccfc97d$var$_excluded = [
    "children",
    "DateInputProps",
    "DialogProps",
    "onAccept",
    "onClear",
    "onDismiss",
    "onCancel",
    "onSetToday",
    "open",
    "PureDateInputComponent",
    "components",
    "componentsProps"
];
function $6c91cc201ccfc97d$export$170a55317307b99f(props) {
    const { children: children, DateInputProps: DateInputProps, DialogProps: DialogProps, onAccept: onAccept, onClear: onClear, onDismiss: onDismiss, onCancel: onCancel, onSetToday: onSetToday, open: open, PureDateInputComponent: PureDateInputComponent, components: components, componentsProps: componentsProps } = props, other = (0, $hCIyK.default)(props, $6c91cc201ccfc97d$var$_excluded);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $gHJ0l.WrapperVariantContext).Provider, {
        value: "mobile",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)(PureDateInputComponent, (0, $4WYaH.default)({
                components: components
            }, other, DateInputProps)),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $68dwK.PickersModalDialog), {
                DialogProps: DialogProps,
                onAccept: onAccept,
                onClear: onClear,
                onDismiss: onDismiss,
                onCancel: onCancel,
                onSetToday: onSetToday,
                open: open,
                components: components,
                componentsProps: componentsProps,
                children: children
            })
        ]
    });
}

});
parcelRegister("68dwK", function(module, exports) {

$parcel$export(module.exports, "PickersModalDialog", function () { return $476dfba69e09bedd$export$99f83c99e1491f77; });

var $4WYaH = parcelRequire("4WYaH");
parcelRequire("bh6RR");

var $8ECDX = parcelRequire("8ECDX");

var $7opAt = parcelRequire("7opAt");
var $6Dwk8 = parcelRequire("6Dwk8");

var $g4l1t = parcelRequire("g4l1t");

var $bsLZU = parcelRequire("bsLZU");

var $hA9zo = parcelRequire("hA9zo");

var $ih19M = parcelRequire("ih19M");
const $476dfba69e09bedd$var$PickersModalDialogRoot = (0, $g4l1t.default)((0, $7opAt.default))({
    [`& .${(0, $6Dwk8.default).container}`]: {
        outline: 0
    },
    [`& .${(0, $6Dwk8.default).paper}`]: {
        outline: 0,
        minWidth: (0, $bsLZU.DIALOG_WIDTH)
    }
});
const $476dfba69e09bedd$var$PickersModalDialogContent = (0, $g4l1t.default)((0, $8ECDX.default))({
    "&:first-of-type": {
        padding: 0
    }
});
const $476dfba69e09bedd$export$99f83c99e1491f77 = (props)=>{
    var _components$ActionBar;
    const { children: children, DialogProps: DialogProps = {}, onAccept: onAccept, onClear: onClear, onDismiss: onDismiss, onCancel: onCancel, onSetToday: onSetToday, open: open, components: components, componentsProps: componentsProps } = props;
    const ActionBar = (_components$ActionBar = components == null ? void 0 : components.ActionBar) != null ? _components$ActionBar : (0, $hA9zo.PickersActionBar);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($476dfba69e09bedd$var$PickersModalDialogRoot, (0, $4WYaH.default)({
        open: open,
        onClose: onDismiss
    }, DialogProps, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($476dfba69e09bedd$var$PickersModalDialogContent, {
                children: children
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)(ActionBar, (0, $4WYaH.default)({
                onAccept: onAccept,
                onClear: onClear,
                onCancel: onCancel,
                onSetToday: onSetToday,
                actions: [
                    "cancel",
                    "accept"
                ]
            }, componentsProps == null ? void 0 : componentsProps.actionBar))
        ]
    }));
};

});
parcelRegister("8ECDX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64d008f25a771e76$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $fE3c5 = parcelRequire("fE3c5");

var $hK1jR = parcelRequire("hK1jR");

var $ih19M = parcelRequire("ih19M");
"use client";
const $64d008f25a771e76$var$_excluded = [
    "className",
    "dividers"
];
const $64d008f25a771e76$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $fE3c5.getDialogContentUtilityClass), classes);
};
const $64d008f25a771e76$var$DialogContentRoot = (0, $g4l1t.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $hK1jR.default).root} + &`]: {
            paddingTop: 0
        }
    }));
const $64d008f25a771e76$var$DialogContent = /*#__PURE__*/ $bh6RR.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $hCIyK.default)(props, $64d008f25a771e76$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        dividers: dividers
    });
    const classes = $64d008f25a771e76$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($64d008f25a771e76$var$DialogContentRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $64d008f25a771e76$export$2e2bcd8739ae039 = $64d008f25a771e76$var$DialogContent;

});
parcelRegister("fE3c5", function(module, exports) {

$parcel$export(module.exports, "getDialogContentUtilityClass", function () { return $b63d11b7eba28cf3$export$61b0ee1f05fb344e; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $b63d11b7eba28cf3$export$61b0ee1f05fb344e(slot) {
    return (0, $XybB6.default)("MuiDialogContent", slot);
}
const $b63d11b7eba28cf3$var$dialogContentClasses = (0, $igcUF.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $b63d11b7eba28cf3$export$2e2bcd8739ae039 = $b63d11b7eba28cf3$var$dialogContentClasses;

});

parcelRegister("hK1jR", function(module, exports) {

$parcel$export(module.exports, "getDialogTitleUtilityClass", function () { return $0355495094662690$export$f5d2ec7e4c47e088; });
$parcel$export(module.exports, "default", function () { return $0355495094662690$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $0355495094662690$export$f5d2ec7e4c47e088(slot) {
    return (0, $XybB6.default)("MuiDialogTitle", slot);
}
const $0355495094662690$var$dialogTitleClasses = (0, $igcUF.default)("MuiDialogTitle", [
    "root"
]);
var $0355495094662690$export$2e2bcd8739ae039 = $0355495094662690$var$dialogTitleClasses;

});




parcelRegister("5vQoE", function(module, exports) {

$parcel$export(module.exports, "useTimeValidation", function () { return $40387dda00766e3b$export$6913080731fabed9; });

var $iSi9v = parcelRequire("iSi9v");

var $5tdBa = parcelRequire("5tdBa");
const $40387dda00766e3b$export$7bd013ac69eb590c = ({ adapter: adapter, value: value, props: props })=>{
    const { minTime: minTime, maxTime: maxTime, minutesStep: minutesStep, shouldDisableTime: shouldDisableTime, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation } = props;
    const date = adapter.utils.date(value);
    const isAfter = (0, $iSi9v.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, adapter.utils);
    if (value === null) return null;
    switch(true){
        case !adapter.utils.isValid(value):
            return "invalidDate";
        case Boolean(minTime && isAfter(minTime, date)):
            return "minTime";
        case Boolean(maxTime && isAfter(date, maxTime)):
            return "maxTime";
        case Boolean(shouldDisableTime && shouldDisableTime(adapter.utils.getHours(date), "hours")):
            return "shouldDisableTime-hours";
        case Boolean(shouldDisableTime && shouldDisableTime(adapter.utils.getMinutes(date), "minutes")):
            return "shouldDisableTime-minutes";
        case Boolean(shouldDisableTime && shouldDisableTime(adapter.utils.getSeconds(date), "seconds")):
            return "shouldDisableTime-seconds";
        case Boolean(minutesStep && adapter.utils.getMinutes(date) % minutesStep !== 0):
            return "minutesStep";
        default:
            return null;
    }
};
const $40387dda00766e3b$var$isSameTimeError = (a, b)=>a === b;
const $40387dda00766e3b$export$6913080731fabed9 = (props)=>(0, $5tdBa.useValidation)(props, $40387dda00766e3b$export$7bd013ac69eb590c, $40387dda00766e3b$var$isSameTimeError);

});

parcelRegister("48l9K", function(module, exports) {

$parcel$export(module.exports, "PureDateInput", function () { return $302851fc39ae11af$export$b6fcc7785a24bca1; });

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $8M7SI = parcelRequire("8M7SI");

var $3xeL1 = parcelRequire("3xeL1");

var $8aNCA = parcelRequire("8aNCA");

var $58UED = parcelRequire("58UED");
const $302851fc39ae11af$export$b6fcc7785a24bca1 = /*#__PURE__*/ $bh6RR.forwardRef(function PureDateInput(props, ref) {
    const { disabled: disabled, getOpenDialogAriaText: getOpenDialogAriaTextProp, inputFormat: inputFormat, InputProps: InputProps, inputRef: inputRef, label: label, openPicker: onOpen, rawValue: rawValue, renderInput: renderInput, TextFieldProps: TextFieldProps = {}, validationError: validationError, className: className } = props;
    const localeText = (0, $8aNCA.useLocaleText)(); // The prop can not be deprecated
    // Default is "Choose date, ...", but time pickers override it with "Choose time, ..."
    const getOpenDialogAriaText = getOpenDialogAriaTextProp != null ? getOpenDialogAriaTextProp : localeText.openDatePickerDialogue;
    const utils = (0, $8aNCA.useUtils)();
    const PureDateInputProps = $bh6RR.useMemo(()=>(0, $4WYaH.default)({}, InputProps, {
            readOnly: true
        }), [
        InputProps
    ]);
    const inputValue = (0, $58UED.getDisplayDate)(utils, rawValue, inputFormat);
    const handleOnClick = (0, $8M7SI.default)((event)=>{
        event.stopPropagation();
        onOpen();
    });
    return renderInput((0, $4WYaH.default)({
        label: label,
        disabled: disabled,
        ref: ref,
        inputRef: inputRef,
        error: validationError,
        InputProps: PureDateInputProps,
        className: className
    }, !props.readOnly && !props.disabled && {
        onClick: handleOnClick
    }, {
        inputProps: (0, $4WYaH.default)({
            disabled: disabled,
            readOnly: true,
            "aria-readonly": true,
            "aria-label": getOpenDialogAriaText(rawValue, utils),
            value: inputValue
        }, !props.readOnly && {
            onClick: handleOnClick
        }, {
            onKeyDown: (0, $3xeL1.onSpaceOrEnter)(onOpen)
        })
    }, TextFieldProps));
});

});





parcelRegister("9lt9Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $225230b7cb484a56$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $8d818 = parcelRequire("8d818");

var $hjfla = parcelRequire("hjfla");

var $bu31C = parcelRequire("bu31C");

var $b1v75 = parcelRequire("b1v75");

var $aM783 = parcelRequire("aM783");

var $ayVxz = parcelRequire("ayVxz");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $aitry = parcelRequire("aitry");

var $6L9uu = parcelRequire("6L9uu");

var $fzKHb = parcelRequire("fzKHb");

var $ehzwo = parcelRequire("ehzwo");
const $225230b7cb484a56$var$errors = {
    username: null,
    password: null,
    login: null
};
const $225230b7cb484a56$var$errorTexts = {
    username: "Username is required!",
    password: "Password is required!",
    login: "Invalid username or password"
};
const $225230b7cb484a56$var$Login = ()=>{
    const navigate = (0, $99w1R.useNavigate)();
    const [username, setUsername] = (0, $bh6RR.useState)("");
    const [password, setPassword] = (0, $bh6RR.useState)("");
    const [singin, signinResult] = (0, $hjfla.useSinginMutation)();
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($225230b7cb484a56$var$errors);
    const { state: state, dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    (0, $bh6RR.useEffect)(()=>{
        if (state.user.data) navigate((0, $b1v75.AuthRoutes).Home);
    }, []);
    const login = (event)=>{
        event.preventDefault();
        const isValid = username.length > 0 && password.length > 0;
        setFormErrors({
            ...formErrors,
            username: username.length === 0 ? $225230b7cb484a56$var$errorTexts.username : null,
            password: password.length === 0 ? $225230b7cb484a56$var$errorTexts.password : null
        });
        if (isValid) singin({
            variables: {
                input: {
                    username: username,
                    password: password
                }
            },
            update (_, { data: data }) {
                if (data) {
                    const { token: token, user: user } = data.result;
                    localStorage.setItem((0, $aM783.AppConsts).AccessToken, token);
                    dispatch({
                        type: (0, $ayVxz.Actions).SetUser,
                        payload: {
                            data: user,
                            token: token
                        }
                    });
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    navigate(location.state?.path ?? (0, $b1v75.AuthRoutes).Home);
                }
            }
        }).catch(()=>setFormErrors({
                ...formErrors,
                login: "Invalid username or password"
            }));
    };
    const handleUsernameChange = (event)=>{
        const { value: value } = event.currentTarget;
        setFormErrors({
            ...formErrors,
            login: null,
            username: value.length > 0 ? null : $225230b7cb484a56$var$errorTexts.username
        });
        setUsername(value);
    };
    const handlePasswordChange = (event)=>{
        const { value: value } = event.currentTarget;
        setFormErrors({
            ...formErrors,
            login: null,
            password: value.length > 0 ? null : $225230b7cb484a56$var$errorTexts.password
        });
        setPassword(value);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            width: "100%",
            minHeight: "100vh",
            background: "transparent linear-gradient(270deg, #2274BC 0%, #12497F 100%) 0% 0% no-repeat padding-box",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                component: "form",
                noValidate: true,
                onSubmit: login,
                sx: {
                    padding: "100px 88px",
                    background: (0, $6L9uu.Colors).white,
                    borderRadius: "12px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    sx: {
                        width: "265px",
                        display: "flex",
                        flexFlow: "column",
                        gap: "70px",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                            component: "img",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fzKHb))),
                            alt: "logo",
                            sx: {
                                width: "71px",
                                height: "81px"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                            sx: {
                                display: "flex",
                                gap: "30px",
                                flexFlow: "column",
                                width: "100%",
                                position: "relative",
                                alignItems: "center",
                                justifyContent: "center"
                            },
                            children: [
                                formErrors.login && /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), {
                                    "data-testid": "error-input-field",
                                    color: "error",
                                    sx: {
                                        position: "absolute",
                                        top: "-45px"
                                    },
                                    children: formErrors.login
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "username",
                                    label: "Username",
                                    value: username,
                                    onChange: handleUsernameChange,
                                    errorMsg: formErrors.username
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "password",
                                    label: "Password",
                                    type: "password",
                                    value: password,
                                    onChange: handlePasswordChange,
                                    errorMsg: formErrors.password
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                            "data-testid": "login-button",
                            variant: "contained",
                            color: "primary",
                            "aria-label": "LOG IN",
                            type: "submit",
                            fullWidth: true,
                            sx: {
                                ...(0, $6L9uu.buttons).loginButton,
                                width: "100%",
                                margin: 0
                            },
                            children: "LOGIN"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                loading: signinResult.loading
            })
        ]
    });
};
var $225230b7cb484a56$export$2e2bcd8739ae039 = $225230b7cb484a56$var$Login;

});
parcelRegister("fzKHb", function(module, exports) {
module.exports = new URL("logo_blue.6d2f8c86.svg", import.meta.url).toString();

});


parcelRegister("lC26g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64493e5204b3e32e$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $gUBkJ = parcelRequire("gUBkJ");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $d7fM7 = parcelRequire("d7fM7");

var $ktnmN = parcelRequire("ktnmN");
const $64493e5204b3e32e$var$ProductList = ()=>{
    const history = (0, $99w1R.useNavigate)();
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [openProductForm, setOpenProductForm] = (0, $bh6RR.useState)(false);
    const [deleteProduct] = (0, $hjfla.useDeleteProductMutation)();
    const { data: data, loading: loading } = (0, $hjfla.useProductsQuery)();
    const canCreate = (0, $dqRXb.canUserCreate)(state.user, (0, $gUBkJ.Types).Product);
    const openFormMethod = ()=>{
        setOpenProductForm(true);
    };
    const handleDetails = (rowData)=>{
        history(`/products/${rowData.id}`, {
            state: {
                ...rowData
            }
        });
    };
    const remove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${rowData.name}?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleDelete = (rowData)=>{
        if (!rowData.id) return;
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteProduct({
            variables: {
                id: parseInt(rowData.id)
            },
            update (cache) {
                const productQuery = cache.readQuery({
                    query: (0, $hjfla.ProductsDocument)
                });
                if (productQuery.result) {
                    const cacheProductIndex = productQuery.result.findIndex((c)=>c?.id === rowData.id);
                    if (cacheProductIndex > -1) {
                        const data = productQuery.result.filter(function(el) {
                            return el?.id !== rowData.id;
                        });
                        cache.writeQuery({
                            query: (0, $hjfla.ProductsDocument),
                            data: {
                                result: data
                            }
                        });
                    }
                }
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Product deleted ${rowData.name}`,
                        severity: "success"
                    }
                });
            }
        }).catch((error)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: error.message,
                    severity: "error"
                }
            });
        });
    };
    const columns = [
        {
            title: "Details",
            width: 63,
            sorting: false
        },
        {
            title: "ID",
            field: "id",
            type: "numeric",
            width: 71
        },
        {
            title: "Name",
            field: "name",
            width: 800
        },
        {
            title: "Product Code",
            field: "product_code.name",
            width: 171
        },
        {
            title: "Price",
            field: "price",
            type: "numeric",
            width: 192
        },
        {
            title: "Belgian VAT",
            field: "vat",
            type: "numeric",
            width: 149
        },
        {
            title: "Accounting Code",
            field: "membership_type.name",
            width: 277
        },
        {
            title: "Remove",
            width: 93,
            sorting: false
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "overviewPage",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "print\\:w-full",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                    columns: columns,
                    data: data?.result || [],
                    loading: loading,
                    handleDetails: handleDetails,
                    handleRemove: remove,
                    pageSize: 15,
                    createButtonProps: {
                        id: "create-product-button",
                        onClick: openFormMethod,
                        text: "Create Product",
                        disabled: !canCreate
                    }
                }),
                openProductForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $ktnmN.default), {
                    handleClose: ()=>setOpenProductForm(false)
                })
            ]
        })
    });
};
var $64493e5204b3e32e$export$2e2bcd8739ae039 = $64493e5204b3e32e$var$ProductList;

});
parcelRegister("ktnmN", function(module, exports) {

$parcel$export(module.exports, "defaultErrorsObj", function () { return $796c4b50c788e15a$export$d19119f0474d967d; });
$parcel$export(module.exports, "ErrorTexts", function () { return $796c4b50c788e15a$export$1067ba46601ca091; });
$parcel$export(module.exports, "default", function () { return $796c4b50c788e15a$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $2cvMN = parcelRequire("2cvMN");

var $hjfla = parcelRequire("hjfla");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $5PJ2i = parcelRequire("5PJ2i");

var $bu31C = parcelRequire("bu31C");

var $gFVvY = parcelRequire("gFVvY");

var $ayVxz = parcelRequire("ayVxz");

var $ehzwo = parcelRequire("ehzwo");

var $bilGR = parcelRequire("bilGR");

var $aMeZy = parcelRequire("aMeZy");

var $6L9uu = parcelRequire("6L9uu");

var $g1rUG = parcelRequire("g1rUG");
const $796c4b50c788e15a$export$d19119f0474d967d = {
    name: null,
    productCode: null,
    price: null,
    vatRange: null
};
const $796c4b50c788e15a$export$1067ba46601ca091 = {
    name: "Name is required",
    nameExists: "Name already exists",
    productCode: "Product code is required",
    price: "Price should be 0 or more",
    vatRange: "Vat should be more than 0"
};
const $796c4b50c788e15a$var$imageContainerDimensions = {
    height: "320px",
    backupMarginTop: 85
};
const $796c4b50c788e15a$var$NewProduct = ({ handleClose: handleClose })=>{
    const productCodes = (0, $hjfla.useProductCodesQuery)();
    const membershipTypes = (0, $hjfla.useMembershipTypeOptionsQuery)({
        fetchPolicy: "no-cache"
    });
    const [name, setName] = (0, $bh6RR.useState)("");
    const [productCode, setProductCode] = (0, $bh6RR.useState)(null);
    const [membershipType, setMembershipType] = (0, $bh6RR.useState)(null);
    const [price, setPrice] = (0, $bh6RR.useState)("");
    const [vat, setVat] = (0, $bh6RR.useState)("");
    const [emailBottomNotes, setEmailBottomNotes] = (0, $bh6RR.useState)("");
    const [emailSubject, setEmailSubject] = (0, $bh6RR.useState)("");
    const [emailBody, setEmailBody] = (0, $bh6RR.useState)("");
    const [emailBanner, setEmailBanner] = (0, $bh6RR.useState)(null);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($796c4b50c788e15a$export$d19119f0474d967d);
    const [createProduct, createProductResult] = (0, $hjfla.useCreateProductMutation)();
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const handleNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!value || value.length < 2) setFormErrors({
            ...formErrors,
            name: $796c4b50c788e15a$export$1067ba46601ca091.name
        });
        else setFormErrors({
            ...formErrors,
            name: null
        });
        setName(value);
    };
    const handleProductCodeChange = (_, newValue)=>{
        setMembershipType(null);
        if (newValue) setFormErrors({
            ...formErrors,
            productCode: null
        });
        else setFormErrors({
            ...formErrors,
            productCode: $796c4b50c788e15a$export$1067ba46601ca091.productCode
        });
        setProductCode(newValue);
    };
    const handlePriceChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value && Number(value) >= 0) setFormErrors({
            ...formErrors,
            price: null
        });
        else setFormErrors({
            ...formErrors,
            price: $796c4b50c788e15a$export$1067ba46601ca091.price
        });
        setPrice(value);
    };
    const handleVatChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value && (Number(value) < 0 || Number(value) > 100)) setFormErrors({
            ...formErrors,
            vatRange: $796c4b50c788e15a$export$1067ba46601ca091.vatRange
        });
        else setFormErrors({
            ...formErrors,
            vatRange: null
        });
        setVat(value);
    };
    const submitForm = ()=>{
        const errors = {
            name: null,
            productCode: null,
            price: null,
            vatRange: null
        };
        let hasErrors = false;
        if (!name || name.length < 2) {
            hasErrors = true;
            errors.name = $796c4b50c788e15a$export$1067ba46601ca091.name;
        }
        if (!productCode) {
            hasErrors = true;
            errors.productCode = $796c4b50c788e15a$export$1067ba46601ca091.productCode;
        }
        if (!price) {
            hasErrors = true;
            errors.price = $796c4b50c788e15a$export$1067ba46601ca091.price;
        }
        if (vat && (parseInt(vat) < 0 || parseInt(vat) > 100)) {
            hasErrors = true;
            errors.vatRange = $796c4b50c788e15a$export$1067ba46601ca091.vatRange;
        }
        if (!hasErrors && (0, $gFVvY.sameProductNameExists)(name.trim())) {
            hasErrors = true;
            errors.name = $796c4b50c788e15a$export$1067ba46601ca091.nameExists;
        }
        if (hasErrors) setFormErrors(errors);
        else submitProduct();
    };
    const submitProduct = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        createProduct({
            variables: {
                input: {
                    name: name.trim(),
                    price: parseFloat(price),
                    product_code_id: parseInt(productCode?.id),
                    vat: parseFloat(vat),
                    membership_type_id: membershipType ? Number(membershipType.id) : null,
                    email_subject: emailSubject ? emailSubject.trim() : null,
                    email_body: emailBody ? emailBody.trim() : null,
                    bottom_notes: emailBottomNotes ? emailBottomNotes.trim() : null,
                    email_banner: emailBanner ? emailBanner.trim() : null
                }
            },
            update (cache, { data: data }) {
                if (data?.result) {
                    const productQuery = cache.readQuery({
                        query: (0, $hjfla.ProductsDocument)
                    });
                    if (productQuery.result) {
                        const cacheProduct = productQuery.result.find((p)=>p?.id === data.result.id);
                        if (!cacheProduct) {
                            const newData = [
                                data.result,
                                ...productQuery.result
                            ];
                            cache.writeQuery({
                                query: (0, $hjfla.ProductsDocument),
                                data: {
                                    result: newData
                                }
                            });
                        }
                    }
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            text: `Product ${data.result.name} created`,
                            severity: "success",
                            autoHide: 2000
                        }
                    });
                    handleClose();
                }
            }
        }).catch((error)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: error.message,
                    severity: "error",
                    autoHide: 6000
                }
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "new-product",
        width: 1400,
        title: "Create Product",
        onClose: handleClose,
        childrenSx: {
            padding: "40px 80px"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
                    gap: "60px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            gridColumn: "span 2",
                            display: "grid",
                            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                            gap: "35px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "new-product-name",
                                label: "Name",
                                value: name,
                                onChange: handleNameChange,
                                disabled: createProductResult.loading,
                                errorMsg: formErrors.name,
                                additionalStyle: {
                                    gridColumn: "span 2"
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "new-product-product-code",
                                label: "Product Code",
                                options: productCodes.data?.result || [],
                                getOptionLabel: (option)=>option.name,
                                disabled: createProductResult.loading,
                                values: productCode,
                                onChange: handleProductCodeChange,
                                errorMsg: formErrors.productCode
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "new-product-membership-type",
                                label: "Membership type",
                                options: membershipTypes.data?.result.membership_types || [],
                                getOptionLabel: (option)=>option?.name,
                                disabled: productCode?.name !== (0, $aMeZy.RB_NAME) || createProductResult.loading,
                                values: membershipType,
                                onChange: (_, value)=>setMembershipType(value)
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "new-product-price",
                                label: "Price",
                                type: "number",
                                value: price,
                                onChange: handlePriceChange,
                                disabled: createProductResult.loading,
                                errorMsg: formErrors.price
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "new-product-vat",
                                label: "VAT %",
                                type: "number",
                                value: vat,
                                onChange: handleVatChange,
                                disabled: createProductResult.loading,
                                errorMsg: formErrors.vatRange,
                                required: false
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "new-product-email-bottom-notes",
                                label: "Bottom Notes",
                                value: emailBottomNotes,
                                onChange: (e)=>setEmailBottomNotes(e.currentTarget.value),
                                multiline: true,
                                rows: 5,
                                disabled: createProductResult.loading,
                                additionalStyle: {
                                    gridColumn: "span 2"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            gridColumn: "span 2",
                            display: "flex",
                            flexFlow: "column",
                            gap: "35px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "new-product-email-subject",
                                label: "Email Subject",
                                value: emailSubject,
                                onChange: (e)=>setEmailSubject(e.currentTarget.value),
                                disabled: createProductResult.loading
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "new-product-email-body",
                                label: "Email Body",
                                value: emailBody,
                                onChange: (e)=>setEmailBody(e.currentTarget.value),
                                multiline: true,
                                rows: 12,
                                disabled: createProductResult.loading
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        id: "new-product-email-banner-container",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                                id: "new-product-email-banner-header",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                                        style: {
                                            color: (0, $6L9uu.Colors).main
                                        },
                                        children: "Email Banner"
                                    }),
                                    emailBanner && /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                                        id: "new-product-clear-banner",
                                        style: {
                                            width: "auto",
                                            float: "right",
                                            marginTop: "-10px"
                                        },
                                        onClick: ()=>setEmailBanner(null),
                                        disabled: !emailBanner || createProductResult.loading,
                                        children: "Clear"
                                    })
                                ]
                            }),
                            emailBanner ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $2cvMN.default), {
                                sx: {
                                    height: $796c4b50c788e15a$var$imageContainerDimensions.height,
                                    mt: "12px"
                                },
                                component: "img",
                                src: emailBanner
                            }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $g1rUG.default), {
                                editable: true,
                                loading: createProductResult.loading,
                                setImage: setEmailBanner,
                                dimensions: $796c4b50c788e15a$var$imageContainerDimensions
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    marginTop: "60px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-new-product-button",
                        disabled: createProductResult.loading,
                        onClick: handleClose,
                        text: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "create-new-product-button",
                        disabled: createProductResult.loading,
                        onClick: submitForm,
                        text: "Create"
                    })
                ]
            })
        ]
    });
};
var $796c4b50c788e15a$export$2e2bcd8739ae039 = $796c4b50c788e15a$var$NewProduct;

});
parcelRegister("2cvMN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19a55bd24a7527fc$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $7J7Kn = parcelRequire("7J7Kn");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $id8R1 = parcelRequire("id8R1");

var $ih19M = parcelRequire("ih19M");
"use client";
const $19a55bd24a7527fc$var$_excluded = [
    "children",
    "className",
    "component",
    "image",
    "src",
    "style"
];
const $19a55bd24a7527fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
    const slots = {
        root: [
            "root",
            isMediaComponent && "media",
            isImageComponent && "img"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $id8R1.getCardMediaUtilityClass), classes);
};
const $19a55bd24a7527fc$var$CardMediaRoot = (0, $g4l1t.default)("div", {
    name: "MuiCardMedia",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
        return [
            styles.root,
            isMediaComponent && styles.media,
            isImageComponent && styles.img
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "block",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
    }, ownerState.isMediaComponent && {
        width: "100%"
    }, ownerState.isImageComponent && {
        // ⚠️ object-fit is not supported by IE11.
        objectFit: "cover"
    }));
const $19a55bd24a7527fc$var$MEDIA_COMPONENTS = [
    "video",
    "audio",
    "picture",
    "iframe",
    "img"
];
const $19a55bd24a7527fc$var$IMAGE_COMPONENTS = [
    "picture",
    "img"
];
const $19a55bd24a7527fc$var$CardMedia = /*#__PURE__*/ $bh6RR.forwardRef(function CardMedia(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiCardMedia"
    });
    const { children: children, className: className, component: component = "div", image: image, src: src, style: style } = props, other = (0, $hCIyK.default)(props, $19a55bd24a7527fc$var$_excluded);
    const isMediaComponent = $19a55bd24a7527fc$var$MEDIA_COMPONENTS.indexOf(component) !== -1;
    const composedStyle = !isMediaComponent && image ? (0, $4WYaH.default)({
        backgroundImage: `url("${image}")`
    }, style) : style;
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component,
        isMediaComponent: isMediaComponent,
        isImageComponent: $19a55bd24a7527fc$var$IMAGE_COMPONENTS.indexOf(component) !== -1
    });
    const classes = $19a55bd24a7527fc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($19a55bd24a7527fc$var$CardMediaRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        as: component,
        role: !isMediaComponent && image ? "img" : undefined,
        ref: ref,
        style: composedStyle,
        ownerState: ownerState,
        src: isMediaComponent ? image || src : undefined
    }, other, {
        children: children
    }));
});
var $19a55bd24a7527fc$export$2e2bcd8739ae039 = $19a55bd24a7527fc$var$CardMedia;

});
parcelRegister("id8R1", function(module, exports) {

$parcel$export(module.exports, "getCardMediaUtilityClass", function () { return $d4204f28f7f8c53f$export$5f5333fe417019a7; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $d4204f28f7f8c53f$export$5f5333fe417019a7(slot) {
    return (0, $XybB6.default)("MuiCardMedia", slot);
}
const $d4204f28f7f8c53f$var$cardMediaClasses = (0, $igcUF.default)("MuiCardMedia", [
    "root",
    "media",
    "img"
]);
var $d4204f28f7f8c53f$export$2e2bcd8739ae039 = $d4204f28f7f8c53f$var$cardMediaClasses;

});


parcelRegister("aMeZy", function(module, exports) {

$parcel$export(module.exports, "RB_NAME", function () { return $8691dc1360f3270c$export$df0e1b7672e145; });
$parcel$export(module.exports, "AC_NAME", function () { return $8691dc1360f3270c$export$86ca004062f4dceb; });
const $8691dc1360f3270c$export$df0e1b7672e145 = "RB";
const $8691dc1360f3270c$export$86ca004062f4dceb = "AC";

});

parcelRegister("g1rUG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $337243c4e7d23dfc$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $b85VG = parcelRequire("b85VG");

var $chLJv = parcelRequire("chLJv");
var $kD8Wp = parcelRequire("kD8Wp");

var $6L9uu = parcelRequire("6L9uu");
const $337243c4e7d23dfc$var$EmailBannerUploader = ({ editable: editable, loading: loading, dimensions: dimensions, setImage: setImage })=>{
    const handleChange = (event)=>{
        if (event && event.target && event.target.files) {
            const file = event.target.files[0];
            processFile(file);
        }
    };
    const handleDrop = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (editable && event && event.dataTransfer.files) {
            const file = event.dataTransfer.files[0];
            processFile(file);
            event.dataTransfer.clearData();
        }
    };
    const processFile = (file)=>{
        if (file) {
            const render = new FileReader();
            render.readAsDataURL(file);
            render.onload = (e)=>{
                if (e && e.target) setImage(e.target.result);
            };
        }
    };
    const handleDragEnter = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    const handleDragLeave = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    const handleDragOver = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        id: "product-email-banner-body",
        sx: {
            textAlign: "center",
            border: "1px solid #DFDFE0",
            borderRadius: "12px",
            marginTop: "12px",
            height: dimensions.height
        },
        onDrop: (e)=>handleDrop(e),
        onDragOver: (e)=>handleDragOver(e),
        onDragEnter: (e)=>handleDragEnter(e),
        onDragLeave: (e)=>handleDragLeave(e),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                accept: "image/*",
                id: "product-email-banner",
                type: "file",
                onChange: handleChange,
                style: {
                    display: "none"
                },
                disabled: !editable || loading
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("label", {
                htmlFor: "product-email-banner",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $kD8Wp.default), {
                        component: "span",
                        style: {
                            color: "white",
                            width: 84,
                            height: 84,
                            marginTop: dimensions.backupMarginTop,
                            marginBottom: 17
                        },
                        disabled: !editable || loading,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b85VG.default), {
                            style: {
                                width: 50,
                                height: 41
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        style: {
                            textDecoration: "underline",
                            cursor: "pointer",
                            display: "block",
                            textAlign: "center",
                            color: editable ? (0, $6L9uu.Colors).skyBlue : (0, $6L9uu.Colors).gray
                        },
                        children: "Upload Banner"
                    })
                ]
            })
        ]
    });
};
var $337243c4e7d23dfc$export$2e2bcd8739ae039 = $337243c4e7d23dfc$var$EmailBannerUploader;

});
parcelRegister("b85VG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81a50a86cbdd13f1$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $81a50a86cbdd13f1$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M14 13v4h-4v-4H7l5-5 5 5z"
}), "Backup");

});

parcelRegister("kD8Wp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f04e62adeea5c99d$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $aEoM0 = parcelRequire("aEoM0");

var $fGH8N = parcelRequire("fGH8N");

var $cNBED = parcelRequire("cNBED");

var $gioqQ = parcelRequire("gioqQ");

var $g4l1t = parcelRequire("g4l1t");

var $ih19M = parcelRequire("ih19M");
"use client";
const $f04e62adeea5c99d$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "disableFocusRipple",
    "focusVisibleClassName",
    "size",
    "variant"
];
const $f04e62adeea5c99d$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `size${(0, $fGH8N.default)(size)}`,
            color === "inherit" ? "colorInherit" : color
        ]
    };
    const composedClasses = (0, $7J7Kn.default)(slots, (0, $gioqQ.getFabUtilityClass), classes);
    return (0, $4WYaH.default)({}, classes, composedClasses);
};
const $f04e62adeea5c99d$var$FabRoot = (0, $g4l1t.default)((0, $aEoM0.default), {
    name: "MuiFab",
    slot: "Root",
    shouldForwardProp: (prop)=>(0, $g4l1t.rootShouldForwardProp)(prop) || prop === "classes",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $fGH8N.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            styles[(0, $fGH8N.default)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    return (0, $4WYaH.default)({}, theme.typography.button, {
        minHeight: 36,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: "50%",
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: "none"
        },
        [`&.${(0, $gioqQ.default).focusVisible}`]: {
            boxShadow: (theme.vars || theme).shadows[6]
        }
    }, ownerState.size === "small" && {
        width: 40,
        height: 40
    }, ownerState.size === "medium" && {
        width: 48,
        height: 48
    }, ownerState.variant === "extended" && {
        borderRadius: 24,
        padding: "0 16px",
        width: "auto",
        minHeight: "auto",
        minWidth: 48,
        height: 48
    }, ownerState.variant === "extended" && ownerState.size === "small" && {
        width: "auto",
        padding: "0 8px",
        borderRadius: 17,
        minWidth: 34,
        height: 34
    }, ownerState.variant === "extended" && ownerState.size === "medium" && {
        width: "auto",
        padding: "0 16px",
        borderRadius: 20,
        minWidth: 40,
        height: 40
    }, ownerState.color === "inherit" && {
        color: "inherit"
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({}, ownerState.color !== "inherit" && ownerState.color !== "default" && (theme.vars || theme).palette[ownerState.color] != null && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }), ({ theme: theme })=>({
        [`&.${(0, $gioqQ.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    }));
const $f04e62adeea5c99d$var$Fab = /*#__PURE__*/ $bh6RR.forwardRef(function Fab(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiFab"
    });
    const { children: children, className: className, color: color = "default", component: component = "button", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, focusVisibleClassName: focusVisibleClassName, size: size = "large", variant: variant = "circular" } = props, other = (0, $hCIyK.default)(props, $f04e62adeea5c99d$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    });
    const classes = $f04e62adeea5c99d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($f04e62adeea5c99d$var$FabRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $aPsoC.default)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref
    }, other, {
        classes: classes,
        children: children
    }));
});
var $f04e62adeea5c99d$export$2e2bcd8739ae039 = $f04e62adeea5c99d$var$Fab;

});
parcelRegister("gioqQ", function(module, exports) {

$parcel$export(module.exports, "getFabUtilityClass", function () { return $bdd147759088006f$export$e2cfa0ca4bce1fc2; });
$parcel$export(module.exports, "default", function () { return $bdd147759088006f$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $bdd147759088006f$export$e2cfa0ca4bce1fc2(slot) {
    return (0, $XybB6.default)("MuiFab", slot);
}
const $bdd147759088006f$var$fabClasses = (0, $igcUF.default)("MuiFab", [
    "root",
    "primary",
    "secondary",
    "extended",
    "circular",
    "focusVisible",
    "disabled",
    "colorInherit",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge",
    "info",
    "error",
    "warning",
    "success"
]);
var $bdd147759088006f$export$2e2bcd8739ae039 = $bdd147759088006f$var$fabClasses;

});





parcelRegister("gsaCA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e15c8637c913bb27$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $b1v75 = parcelRequire("b1v75");

var $bu31C = parcelRequire("bu31C");

var $hjfla = parcelRequire("hjfla");

var $ayVxz = parcelRequire("ayVxz");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $8QeQV = parcelRequire("8QeQV");
var $bwbWe = parcelRequire("bwbWe");
var $5FZaQ = parcelRequire("5FZaQ");
var $8jEtO = parcelRequire("8jEtO");
var $dgmqH = parcelRequire("dgmqH");

var $8d818 = parcelRequire("8d818");

var $ahwrv = parcelRequire("ahwrv");

var $64aQd = parcelRequire("64aQd");

var $j5ie7 = parcelRequire("j5ie7");

var $chLJv = parcelRequire("chLJv");

var $eBMvL = parcelRequire("eBMvL");

var $9frLO = parcelRequire("9frLO");

var $8XxJW = parcelRequire("8XxJW");

var $6ah9Q = parcelRequire("6ah9Q");
const $e15c8637c913bb27$var$MembershipInfoWrapper = ()=>{
    const location = (0, $99w1R.useLocation)();
    const history = (0, $99w1R.useNavigate)();
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [membership, setMembership] = (0, $bh6RR.useState)(null);
    const [value, setValue] = (0, $bh6RR.useState)(0);
    const locationElements = location.pathname.split("/").filter((e)=>e);
    const { data: data } = (0, $hjfla.useMembershipQuery)({
        variables: {
            id: parseInt(locationElements[locationElements.length - 1])
        },
        fetchPolicy: "no-cache"
    });
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            dispatch({
                type: (0, $ayVxz.Actions).SetSelectedMembership,
                payload: {
                    id: data.result.id,
                    name: data.result.name,
                    start_date: data.result.start_date ?? null,
                    end_date: data.result.end_date ?? null
                }
            });
            setMembership(data.result);
        }
    }, [
        data
    ]);
    const handleToMembershipsOverview = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).ResetSelectedMembership
        });
        history((0, $b1v75.AuthRoutes).Memberships);
    };
    const handleChange = (_, newValue)=>{
        setValue(newValue);
    };
    const updateCommentsCount = (isRemoved)=>{
        const currentMembership = membership;
        if (isRemoved) setMembership({
            ...currentMembership,
            comments_count: currentMembership.comments_count - 1
        });
        else setMembership({
            ...currentMembership,
            comments_count: currentMembership.comments_count + 1
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ahwrv.default), {
                handleToOverview: handleToMembershipsOverview,
                navName: (0, $b1v75.RouteNames).Memberships,
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $8QeQV.default), {
                            sx: {
                                marginRight: "7px"
                            }
                        }),
                        state.selectedMembership?.name || membership?.name
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eBMvL.default), {
                        value: value,
                        handleChange: handleChange,
                        tabProps: [
                            {
                                id: "membership-details",
                                title: "Details",
                                icon: (0, $8jEtO.default)
                            },
                            {
                                id: "membership-companies",
                                title: "Companies",
                                icon: (0, $bwbWe.default)
                            },
                            {
                                id: "membership-contacts",
                                title: "Contacts",
                                icon: (0, $5FZaQ.default)
                            },
                            {
                                id: "membership-invoices",
                                title: "Invoices",
                                icon: (0, $dgmqH.default)
                            }
                        ]
                    }),
                    membership ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                                value: value,
                                index: 0,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8XxJW.default), {
                                    membership: membership,
                                    updateCommentsCount: updateCommentsCount
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                                value: value,
                                index: 1,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $64aQd.default), {
                                    membershipId: parseInt(membership.id)
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                                value: value,
                                index: 2,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9frLO.default), {
                                    membershipId: parseInt(membership.id)
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                                value: value,
                                index: 3,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $6ah9Q.default), {
                                    membershipId: parseInt(membership.id)
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                        loading: true
                    })
                ]
            })
        ]
    });
};
var $e15c8637c913bb27$export$2e2bcd8739ae039 = $e15c8637c913bb27$var$MembershipInfoWrapper;

});
parcelRegister("8QeQV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66feb3788a5e0ef0$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $66feb3788a5e0ef0$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3m6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1z"
}), "AssignmentInd");

});

parcelRegister("bwbWe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $862bf188b2fbfb88$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $862bf188b2fbfb88$export$2e2bcd8739ae039 = (0, $7B0TL.default)([
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M1 11v10h5v-6h4v6h5V11L8 6z"
    }, "0"),
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M10 3v1.97l7 5V11h2v2h-2v2h2v2h-2v4h6V3zm9 6h-2V7h2z"
    }, "1")
], "HomeWork");

});

parcelRegister("5FZaQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42203bef086fd916$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $42203bef086fd916$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M17.5 4.5c-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .65.73.45.75.45C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.41.21.75-.19.75-.45V6c-1.49-1.12-3.63-1.5-5.5-1.5m3.5 14c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5z"
}), "ImportContacts");

});

parcelRegister("8jEtO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60df7f8a3c3bd6b5$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $60df7f8a3c3bd6b5$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z"
}), "Info");

});

parcelRegister("dgmqH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a7e2b08173e7c84$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $9a7e2b08173e7c84$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M18 17H6v-2h12zm0-4H6v-2h12zm0-4H6V7h12zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2z"
}), "Receipt");

});

parcelRegister("ahwrv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ba205305d021893$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $eJOwd = parcelRequire("eJOwd");

var $6L9uu = parcelRequire("6L9uu");

var $b7oAt = parcelRequire("b7oAt");
const $4ba205305d021893$var$OverviewToolbar = (props)=>{
    const { children: children, navName: navName, handleToOverview: handleToOverview, isManualStyles: isManualStyles } = props;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $eJOwd.default), {
        sx: {
            background: (0, $6L9uu.Colors).gradient,
            minHeight: "60px",
            padding: 0,
            zIndex: 2,
            position: "relative",
            color: (0, $6L9uu.Colors).white
        },
        children: [
            handleToOverview && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                id: `to-${navName}-overview`,
                onClick: handleToOverview,
                sx: {
                    height: 60,
                    width: "auto",
                    position: "absolute",
                    left: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $b7oAt.default), {
                        sx: {
                            color: (0, $6L9uu.Colors).white,
                            marginRight: "4px"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        component: "h3",
                        sx: {
                            color: (0, $6L9uu.Colors).white
                        },
                        children: navName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                // sx={isManualStyles ? { width: '100%', color: 'white' } : { margin: 'auto', color: 'white' }}
                sx: {
                    width: "100%",
                    display: "flex",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bh6RR.Fragment), {
                    children: children
                })
            })
        ]
    });
};
var $4ba205305d021893$export$2e2bcd8739ae039 = $4ba205305d021893$var$OverviewToolbar;

});
parcelRegister("b7oAt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81836ba89f7a94e6$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $81836ba89f7a94e6$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "ChevronLeft");

});


parcelRegister("64aQd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47cf4df1b54aca67$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $lGURI = parcelRequire("lGURI");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $hsjD5 = parcelRequire("hsjD5");

var $5DXc5 = parcelRequire("5DXc5");

var $b42dh = parcelRequire("b42dh");

var $iH4a7 = parcelRequire("iH4a7");

var $gFVvY = parcelRequire("gFVvY");
const $47cf4df1b54aca67$var$CompaniesTab = ({ membershipId: membershipId })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [openNewCompany, setOpenNewCompany] = (0, $bh6RR.useState)(false);
    const { data: data, loading: loading } = (0, $hjfla.useMembershipCompaniesQuery)({
        variables: {
            membership_id: membershipId
        },
        fetchPolicy: "no-cache"
    });
    const [companies, setCompanies] = (0, $bh6RR.useState)([]);
    const [updateMainMember, updateMainMemberResult] = (0, $hjfla.useUpdateCompanyMainMemberForMembershipMutation)();
    const history = (0, $99w1R.useNavigate)();
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Membership);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setCompanies(data.result);
    }, [
        data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (updateMainMemberResult.error) dispatch({
            type: (0, $ayVxz.Actions).ShowMessage,
            payload: {
                severity: "error",
                text: updateMainMemberResult.error.message,
                autoHide: 6000
            }
        });
    }, [
        updateMainMemberResult.error
    ]);
    const handleChangeMainMember = (rowData)=>{
        const main = !rowData.is_main_member;
        updateMainMember({
            variables: {
                id: parseInt(rowData.id),
                membership_id: parseInt(membershipId.toString()),
                is_main_member: main
            },
            update () {
                const updatedCompany = {
                    ...rowData,
                    is_main_member: main
                };
                (0, $gFVvY.updateCompanyInCache)(updatedCompany);
                const message = main ? `Company ${rowData.name} set as main company` : `Company ${rowData.name} no longer main`;
                const updatedCompanies = companies.map((c)=>c.id === rowData.id ? {
                        ...rowData,
                        is_main_member: main
                    } : main ? {
                        ...c,
                        is_main_member: false
                    } : c);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: message
                    }
                });
                setCompanies(updatedCompanies);
            }
        });
    };
    const isMainStatus = (rowData)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $lGURI.default), {
            id: "is_main_member_switch",
            disableRipple: true,
            name: "checkIsMainMember",
            disabled: !canEdit,
            onChange: ()=>handleChangeMainMember(rowData),
            checked: rowData.is_main_member || false
        });
    const handleDetails = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).SetSelectedContact,
            payload: {
                name: "contact name",
                company_name: rowData.name
            }
        });
        history(`/companies/${rowData.id}`, {
            state: {
                ...rowData
            }
        });
    };
    const columns = [
        {
            title: "Details",
            sorting: false,
            width: 51
        },
        {
            title: "Main",
            field: "is_main_member",
            sorting: false,
            render: isMainStatus,
            width: 90,
            type: "boolean"
        },
        {
            title: "Company Name",
            field: "name",
            width: 386
        },
        {
            title: "Street",
            field: "main_address.street",
            width: 322
        },
        {
            title: "City",
            field: "main_address.city",
            width: 179
        },
        {
            title: "Country",
            field: "main_address.country.name",
            width: 276
        }
    ];
    const handleNewCompany = (company)=>{
        setCompanies([
            company,
            ...companies || []
        ]);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        className: "centralize",
        sx: {
            width: "100%",
            paddingTop: "80px"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5DXc5.default), {
            headerText: "Companies",
            width: "82%",
            createButtonProps: {
                id: "Add-Company-Button-Companies-Tab",
                onClick: ()=>setOpenNewCompany(true),
                text: "+ Add Company"
            },
            additionalStyle: {
                height: "680px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
                    columns: columns,
                    data: (0, $hsjD5.FormatTableData)(companies),
                    loading: loading,
                    handleDetails: handleDetails,
                    handleRemove: ()=>true,
                    pageSize: 10,
                    crudType: (0, $gUBkJ.Types).Membership,
                    additionalToolbar: true,
                    fixedHeaders: true
                }),
                openNewCompany && /*#__PURE__*/ (0, $ih19M.jsx)((0, $iH4a7.default), {
                    handleClose: ()=>setOpenNewCompany(false),
                    membershipId: membershipId,
                    addNewCompany: handleNewCompany
                })
            ]
        })
    });
};
var $47cf4df1b54aca67$export$2e2bcd8739ae039 = $47cf4df1b54aca67$var$CompaniesTab;

});
parcelRegister("lGURI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fca9a183587b97ac$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $7J7Kn = parcelRequire("7J7Kn");

var $cG3EF = parcelRequire("cG3EF");

var $fGH8N = parcelRequire("fGH8N");

var $jcZYJ = parcelRequire("jcZYJ");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $vqwiT = parcelRequire("vqwiT");

var $ih19M = parcelRequire("ih19M");
"use client";
const $fca9a183587b97ac$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $fca9a183587b97ac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            edge && `edge${(0, $fGH8N.default)(edge)}`,
            `size${(0, $fGH8N.default)(size)}`
        ],
        switchBase: [
            "switchBase",
            `color${(0, $fGH8N.default)(color)}`,
            checked && "checked",
            disabled && "disabled"
        ],
        thumb: [
            "thumb"
        ],
        track: [
            "track"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $7J7Kn.default)(slots, (0, $vqwiT.getSwitchUtilityClass), classes);
    return (0, $4WYaH.default)({}, classes, composedClasses);
};
const $fca9a183587b97ac$var$SwitchRoot = (0, $g4l1t.default)("span", {
    name: "MuiSwitch",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $fGH8N.default)(ownerState.edge)}`],
            styles[`size${(0, $fGH8N.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "inline-flex",
        width: 58,
        height: 38,
        overflow: "hidden",
        padding: 12,
        boxSizing: "border-box",
        position: "relative",
        flexShrink: 0,
        zIndex: 0,
        // Reset the stacking context.
        verticalAlign: "middle",
        // For correct alignment with the text.
        "@media print": {
            colorAdjust: "exact"
        }
    }, ownerState.edge === "start" && {
        marginLeft: -8
    }, ownerState.edge === "end" && {
        marginRight: -8
    }, ownerState.size === "small" && {
        width: 40,
        height: 24,
        padding: 7,
        [`& .${(0, $vqwiT.default).thumb}`]: {
            width: 16,
            height: 16
        },
        [`& .${(0, $vqwiT.default).switchBase}`]: {
            padding: 4,
            [`&.${(0, $vqwiT.default).checked}`]: {
                transform: "translateX(16px)"
            }
        }
    }));
const $fca9a183587b97ac$var$SwitchSwitchBase = (0, $g4l1t.default)((0, $jcZYJ.default), {
    name: "MuiSwitch",
    slot: "SwitchBase",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $vqwiT.default).input}`]: styles.input
            },
            ownerState.color !== "default" && styles[`color${(0, $fGH8N.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            "left",
            "transform"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $vqwiT.default).checked}`]: {
            transform: "translateX(20px)"
        },
        [`&.${(0, $vqwiT.default).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $vqwiT.default).checked} + .${(0, $vqwiT.default).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $vqwiT.default).disabled} + .${(0, $vqwiT.default).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === "light" ? 0.12 : 0.2}`
        },
        [`& .${(0, $vqwiT.default).input}`]: {
            left: "-100%",
            width: "300%"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cG3EF.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $vqwiT.default).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cG3EF.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, $vqwiT.default).disabled}`]: {
                color: theme.vars ? theme.vars.palette.Switch[`${ownerState.color}DisabledColor`] : `${theme.palette.mode === "light" ? (0, $cG3EF.lighten)(theme.palette[ownerState.color].main, 0.62) : (0, $cG3EF.darken)(theme.palette[ownerState.color].main, 0.55)}`
            }
        },
        [`&.${(0, $vqwiT.default).checked} + .${(0, $vqwiT.default).track}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main
        }
    }));
const $fca9a183587b97ac$var$SwitchTrack = (0, $g4l1t.default)("span", {
    name: "MuiSwitch",
    slot: "Track",
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: "100%",
        width: "100%",
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            "opacity",
            "background-color"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === "light" ? 0.38 : 0.3}`
    }));
const $fca9a183587b97ac$var$SwitchThumb = (0, $g4l1t.default)("span", {
    name: "MuiSwitch",
    slot: "Thumb",
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: "currentColor",
        width: 20,
        height: 20,
        borderRadius: "50%"
    }));
const $fca9a183587b97ac$var$Switch = /*#__PURE__*/ $bh6RR.forwardRef(function Switch(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiSwitch"
    });
    const { className: className, color: color = "primary", edge: edge = false, size: size = "medium", sx: sx } = props, other = (0, $hCIyK.default)(props, $fca9a183587b97ac$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $fca9a183587b97ac$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $ih19M.jsx)($fca9a183587b97ac$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)($fca9a183587b97ac$var$SwitchRoot, {
        className: (0, $aPsoC.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($fca9a183587b97ac$var$SwitchSwitchBase, (0, $4WYaH.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $4WYaH.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $ih19M.jsx)($fca9a183587b97ac$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $fca9a183587b97ac$export$2e2bcd8739ae039 = $fca9a183587b97ac$var$Switch;

});
parcelRegister("jcZYJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfbf36fa14586e5f$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $7J7Kn = parcelRequire("7J7Kn");

var $fGH8N = parcelRequire("fGH8N");

var $g4l1t = parcelRequire("g4l1t");

var $82V4F = parcelRequire("82V4F");

var $djfcj = parcelRequire("djfcj");

var $aEoM0 = parcelRequire("aEoM0");

var $2881s = parcelRequire("2881s");

var $ih19M = parcelRequire("ih19M");
"use client";
const $dfbf36fa14586e5f$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $dfbf36fa14586e5f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $fGH8N.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $2881s.getSwitchBaseUtilityClass), classes);
};
const $dfbf36fa14586e5f$var$SwitchBaseRoot = (0, $g4l1t.default)((0, $aEoM0.default))(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $dfbf36fa14586e5f$var$SwitchBaseInput = (0, $g4l1t.default)("input", {
    shouldForwardProp: (0, $g4l1t.rootShouldForwardProp)
})({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $dfbf36fa14586e5f$var$SwitchBase = /*#__PURE__*/ $bh6RR.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $hCIyK.default)(props, $dfbf36fa14586e5f$var$_excluded);
    const [checked, setCheckedState] = (0, $82V4F.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $djfcj.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $4WYaH.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $dfbf36fa14586e5f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($dfbf36fa14586e5f$var$SwitchBaseRoot, (0, $4WYaH.default)({
        component: "span",
        className: (0, $aPsoC.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($dfbf36fa14586e5f$var$SwitchBaseInput, (0, $4WYaH.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $dfbf36fa14586e5f$export$2e2bcd8739ae039 = $dfbf36fa14586e5f$var$SwitchBase;

});
parcelRegister("2881s", function(module, exports) {

$parcel$export(module.exports, "getSwitchBaseUtilityClass", function () { return $18d28d40c0590fcc$export$baa0faa0c7ad8085; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $18d28d40c0590fcc$export$baa0faa0c7ad8085(slot) {
    return (0, $XybB6.default)("PrivateSwitchBase", slot);
}
const $18d28d40c0590fcc$var$switchBaseClasses = (0, $igcUF.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $18d28d40c0590fcc$export$2e2bcd8739ae039 = $18d28d40c0590fcc$var$switchBaseClasses;

});


parcelRegister("vqwiT", function(module, exports) {

$parcel$export(module.exports, "getSwitchUtilityClass", function () { return $05e777b0b1f83834$export$39f6debbec19b3ba; });
$parcel$export(module.exports, "default", function () { return $05e777b0b1f83834$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $05e777b0b1f83834$export$39f6debbec19b3ba(slot) {
    return (0, $XybB6.default)("MuiSwitch", slot);
}
const $05e777b0b1f83834$var$switchClasses = (0, $igcUF.default)("MuiSwitch", [
    "root",
    "edgeStart",
    "edgeEnd",
    "switchBase",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium",
    "checked",
    "disabled",
    "input",
    "thumb",
    "track"
]);
var $05e777b0b1f83834$export$2e2bcd8739ae039 = $05e777b0b1f83834$var$switchClasses;

});


parcelRegister("5DXc5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b38432ea05b4d20a$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $lZnEL = parcelRequire("lZnEL");
var $iTI7v = parcelRequire("iTI7v");

var $6L9uu = parcelRequire("6L9uu");

var $79Qyg = parcelRequire("79Qyg");
const $b38432ea05b4d20a$var$PaperCard = ({ width: width, children: children, additionalStyle: additionalStyle, headerText: headerText, createButtonProps: createButtonProps, navigationButton: navigationButton })=>{
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $iTI7v.default), {
        square: true,
        sx: {
            width: width,
            boxShadow: "0px 10px 20px " + (0, $6L9uu.Colors).third + "66",
            ...additionalStyle
        },
        children: [
            (headerText || createButtonProps) && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    ...(0, $79Qyg.fonts).Predefined.Bold["22px33px"],
                    borderBottom: `2px solid ${(0, $6L9uu.Colors).skyBlue}`,
                    color: (0, $6L9uu.Colors).skyBlue,
                    paddingY: "7px",
                    position: "relative"
                },
                children: [
                    navigationButton && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                        id: navigationButton.id,
                        "data-testid": navigationButton.id,
                        onClick: navigationButton.onClick,
                        sx: {
                            position: "absolute",
                            left: "20px",
                            top: "7px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lZnEL.default), {
                                sx: {
                                    color: (t)=>t.palette.primary.main,
                                    marginRight: "4px"
                                },
                                children: "chevron_left"
                            }),
                            navigationButton.text
                        ]
                    }),
                    createButtonProps && /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                        id: createButtonProps.id,
                        "data-testid": createButtonProps.id,
                        sx: {
                            ...(0, $6L9uu.buttons).createSecondary,
                            position: "absolute",
                            left: navigationButton ? "150px" : "20px",
                            top: "7px"
                        },
                        onClick: ()=>createButtonProps.onClick(),
                        disabled: createButtonProps.disabled ?? false,
                        children: createButtonProps.text
                    }),
                    headerText
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    height: "100%"
                },
                children: children
            })
        ]
    });
};
var $b38432ea05b4d20a$export$2e2bcd8739ae039 = $b38432ea05b4d20a$var$PaperCard;

});
parcelRegister("lZnEL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0421932e31259028$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $fGH8N = parcelRequire("fGH8N");

var $lUbE3 = parcelRequire("lUbE3");

var $ih19M = parcelRequire("ih19M");
"use client";
const $0421932e31259028$var$_excluded = [
    "baseClassName",
    "className",
    "color",
    "component",
    "fontSize"
];
const $0421932e31259028$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $fGH8N.default)(color)}`,
            `fontSize${(0, $fGH8N.default)(fontSize)}`
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $lUbE3.getIconUtilityClass), classes);
};
const $0421932e31259028$var$IconRoot = (0, $g4l1t.default)("span", {
    name: "MuiIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $fGH8N.default)(ownerState.color)}`],
            styles[`fontSize${(0, $fGH8N.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>({
        userSelect: "none",
        width: "1em",
        height: "1em",
        // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
        // To remove at some point.
        overflow: "hidden",
        display: "inline-block",
        // allow overflow hidden to take action
        textAlign: "center",
        // support non-square icon
        flexShrink: 0,
        fontSize: ({
            inherit: "inherit",
            small: theme.typography.pxToRem(20),
            medium: theme.typography.pxToRem(24),
            large: theme.typography.pxToRem(36)
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: ({
            primary: (theme.vars || theme).palette.primary.main,
            secondary: (theme.vars || theme).palette.secondary.main,
            info: (theme.vars || theme).palette.info.main,
            success: (theme.vars || theme).palette.success.main,
            warning: (theme.vars || theme).palette.warning.main,
            action: (theme.vars || theme).palette.action.active,
            error: (theme.vars || theme).palette.error.main,
            disabled: (theme.vars || theme).palette.action.disabled,
            inherit: undefined
        })[ownerState.color]
    }));
const $0421932e31259028$var$Icon = /*#__PURE__*/ $bh6RR.forwardRef(function Icon(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiIcon"
    });
    const { baseClassName: baseClassName = "material-icons", className: className, color: color = "inherit", component: Component = "span", fontSize: fontSize = "medium" } = props, other = (0, $hCIyK.default)(props, $0421932e31259028$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        baseClassName: baseClassName,
        color: color,
        component: Component,
        fontSize: fontSize
    });
    const classes = $0421932e31259028$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($0421932e31259028$var$IconRoot, (0, $4WYaH.default)({
        as: Component,
        className: (0, $aPsoC.default)(baseClassName, // Prevent the translation of the text content.
        // The font relies on the exact text content to render the icon.
        "notranslate", classes.root, className),
        ownerState: ownerState,
        "aria-hidden": true,
        ref: ref
    }, other));
});
$0421932e31259028$var$Icon.muiName = "Icon";
var $0421932e31259028$export$2e2bcd8739ae039 = $0421932e31259028$var$Icon;

});
parcelRegister("lUbE3", function(module, exports) {

$parcel$export(module.exports, "getIconUtilityClass", function () { return $ff27dc62ca11abc3$export$e7545bb336f9a5fc; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $ff27dc62ca11abc3$export$e7545bb336f9a5fc(slot) {
    return (0, $XybB6.default)("MuiIcon", slot);
}
const $ff27dc62ca11abc3$var$iconClasses = (0, $igcUF.default)("MuiIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $ff27dc62ca11abc3$export$2e2bcd8739ae039 = $ff27dc62ca11abc3$var$iconClasses;

});



parcelRegister("b42dh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7df622ac20939d4$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $am7GZ = parcelRequire("am7GZ");
var $iTI7v = parcelRequire("iTI7v");
var $4AJYG = parcelRequire("4AJYG");
var $77DVl = parcelRequire("77DVl");
var $6RrdM = parcelRequire("6RrdM");
var $jsf2t = parcelRequire("jsf2t");
var $hEr3D = parcelRequire("hEr3D");
var $gExfQ = parcelRequire("gExfQ");
var $6GPiu = parcelRequire("6GPiu");
var $1swyP = parcelRequire("1swyP");
var $5LQ5V = parcelRequire("5LQ5V");

var $bt9fX = parcelRequire("bt9fX");
var $dRSqV = parcelRequire("dRSqV");
var $3Xpkr = parcelRequire("3Xpkr");
var $fQfP9 = parcelRequire("fQfP9");
var $3OBHq = parcelRequire("3OBHq");
var $eFKxo = parcelRequire("eFKxo");
var $jIOsh = parcelRequire("jIOsh");

var $6L9uu = parcelRequire("6L9uu");

var $gSGmk = parcelRequire("gSGmk");

var $8d818 = parcelRequire("8d818");

var $lfYlj = parcelRequire("lfYlj");

var $3A2xv = parcelRequire("3A2xv");

var $b5b48 = parcelRequire("b5b48");

var $8Oiq1 = parcelRequire("8Oiq1");

var $gUBkJ = parcelRequire("gUBkJ");

var $dqRXb = parcelRequire("dqRXb");

var $bu31C = parcelRequire("bu31C");

var $aM783 = parcelRequire("aM783");

var $d7fM7 = parcelRequire("d7fM7");
const $b7df622ac20939d4$var$getTableRowCellStyle = (index, width)=>({
        border: "none",
        left: 0,
        textAlign: "center",
        color: "primary.main",
        padding: 0,
        width: width ? `${width}px` : "auto",
        zIndex: index === 0 ? 2 : 1
    });
const $b7df622ac20939d4$var$tableRowStyle = {
    padding: 0,
    height: "40px",
    color: (0, $6L9uu.Colors).main,
    textAlign: "center",
    opacity: 1,
    border: "none"
};
const $b7df622ac20939d4$var$tableHeaderCellFontStyle = {
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "15px",
    zIndex: 1,
    textAlign: "center",
    color: (0, $6L9uu.Colors).main,
    border: "none"
};
const $b7df622ac20939d4$var$tableHeaderCellStyle = {
    ...$b7df622ac20939d4$var$tableHeaderCellFontStyle,
    borderRight: "1px solid #FFFFFF"
};
const $b7df622ac20939d4$var$actionButtonIconStyle = {
    marginRight: "7px"
};
const $b7df622ac20939d4$var$TableHeaders = ({ columns: columns, order: order, orderBy: orderBy, onRequestSort: onRequestSort, extraCol: extraCol, fixedHeaders: fixedHeaders })=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $hEr3D.default), {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $6GPiu.default), {
            sx: {
                background: "#B4D4F9",
                height: "22px",
                ...fixedHeaders && {
                    position: "sticky",
                    top: 0,
                    zIndex: 2
                }
            },
            children: [
                extraCol && /*#__PURE__*/ (0, $ih19M.jsx)((0, $6RrdM.default), {
                    padding: "none",
                    sx: {
                        ...$b7df622ac20939d4$var$tableHeaderCellStyle,
                        width: "60px"
                    }
                }),
                columns.map((col, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $6RrdM.default), {
                        align: col.type === "numeric" ? "right" : "left",
                        padding: "none",
                        sortDirection: orderBy === col ? order : false,
                        sx: {
                            ...$b7df622ac20939d4$var$tableHeaderCellStyle,
                            padding: col.sorting !== false ? 0 : "0 13px",
                            width: col.width ? `${col.width}px` : "auto"
                        },
                        children: col.sorting !== false ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $1swyP.default), {
                            active: orderBy === col,
                            direction: orderBy === col ? order : "asc",
                            onClick: ()=>onRequestSort(col),
                            sx: {
                                marginLeft: col.type === "numeric" ? 0 : "26px",
                                marginRight: col.type !== "numeric" ? 0 : "26px"
                            },
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                sx: {
                                    ...$b7df622ac20939d4$var$tableHeaderCellFontStyle
                                },
                                children: col.title
                            })
                        }) : col.title
                    }, index))
            ]
        })
    });
const $b7df622ac20939d4$var$DenseTable = ({ columns: columns, data: data, hidePagination: hidePagination, rowsPerPageOptions: rowsPerPageOptions, pageSize: pageSize, createButtonProps: createButtonProps, exportButtonProps: exportButtonProps, showSearch: showSearch, handleDetails: handleDetails, handleRemove: handleRemove, loading: loading = false, crudType: crudType, additionalFilters: additionalFilters, additionalToolbar: additionalToolbar, removeButtonStyle: removeButtonStyle = "basket", detailPanel: detailPanel, fixedHeaders: fixedHeaders = false })=>{
    const { state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const deletableItems = !data || data.length === 0 ? false : (0, $dqRXb.canUserDelete)(state.user, crudType);
    const itemsPerPageOptions = rowsPerPageOptions ?? [
        10,
        15,
        25,
        50
    ];
    const [order, setOrder] = (0, $bh6RR.useState)("asc");
    const [orderBy, setOrderBy] = (0, $bh6RR.useState)(null);
    const [page, setPage] = (0, $bh6RR.useState)(0);
    const [itemsPerPage, setItemsPerPage] = (0, $bh6RR.useState)(pageSize ?? itemsPerPageOptions.length > 1 ? itemsPerPageOptions[1] : itemsPerPageOptions[0]);
    const [searchValue, setSearchValue] = (0, $bh6RR.useState)("");
    const [filteredData, setFilteredData] = (0, $bh6RR.useState)(data);
    const [selectedRowId, setSelectedRowId] = (0, $bh6RR.useState)(null);
    (0, $bh6RR.useEffect)(()=>{
        setFilteredData(data);
        filterData(searchValue);
        setPage(0);
    }, [
        data
    ]);
    const handleRequestSort = (property)=>{
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        const newOrderBy = isAsc ? property : orderBy !== property ? property : null;
        setOrderBy(newOrderBy);
    };
    const getReadyToUseData = ()=>{
        let rows = filteredData.slice();
        if (orderBy !== null) rows = rows.sort((0, $d7fM7.getComparator)(order, orderBy));
        if (hidePagination !== true) rows = rows.slice(page * itemsPerPage, page * itemsPerPage + itemsPerPage);
        return rows;
    };
    const handleChangePage = (event, newPage)=>{
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event)=>{
        setItemsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleValueChange = (event)=>{
        const { value: value } = event.currentTarget;
        setSearchValue(value);
        filterData(value);
        setPage(0);
    };
    const filterData = (filter)=>{
        const trimmedSearchText = filter.trim();
        setFilteredData(data.filter((row)=>{
            return columns.filter((columnDef)=>{
                return columnDef.searchable === undefined ? true : columnDef.searchable;
            }).some((columnDef)=>{
                if (columnDef.customFilterAndSearch) return !!columnDef.customFilterAndSearch(trimmedSearchText, row, columnDef);
                else if (columnDef.field) {
                    const value = (0, $d7fM7.getCellValue)(row, columnDef.field);
                    return value?.toString().toUpperCase().includes(trimmedSearchText.toUpperCase());
                }
            });
        }));
    };
    const generateToolbar = ()=>{
        return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                display: "flex",
                alignItems: "end",
                marginBottom: "14px",
                padding: "0 24px",
                gap: "20px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        flexGrow: 0
                    },
                    children: showSearch === true && /*#__PURE__*/ (0, $ih19M.jsx)((0, $5LQ5V.default), {
                        id: "table-search-field",
                        value: searchValue,
                        onChange: handleValueChange,
                        sx: {
                            color: (0, $6L9uu.Colors).main,
                            backgroundColor: (0, $6L9uu.Colors).input_field_background,
                            width: "365px",
                            height: "36px",
                            borderRadius: "9px",
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                    border: "none"
                                }
                            }
                        },
                        placeholder: "Search...",
                        InputProps: {
                            startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $jIOsh.default), {
                                sx: {
                                    color: (0, $6L9uu.Colors).main,
                                    width: "20px",
                                    height: "20px",
                                    marginRight: "10px",
                                    input: {
                                        "&::placeholder": {
                                            color: (0, $6L9uu.Colors).main
                                        }
                                    }
                                }
                            }),
                            endAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $am7GZ.default), {
                                disabled: !Boolean(searchValue),
                                onClick: ()=>{
                                    setSearchValue("");
                                    filterData("");
                                    setPage(0);
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3Xpkr.default), {
                                    sx: {
                                        color: searchValue ? (0, $6L9uu.Colors).main : "#9CA3AE",
                                        width: "20px",
                                        height: "20px"
                                    }
                                })
                            }),
                            style: {
                                height: "36px",
                                color: (0, $6L9uu.Colors).main,
                                paddingRight: "4px"
                            }
                        },
                        className: "custom-search"
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        flexGrow: 1
                    },
                    children: additionalFilters
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    sx: {
                        flexGrow: 0,
                        display: "flex",
                        gap: "10px"
                    },
                    children: [
                        exportButtonProps && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                            id: exportButtonProps.id,
                            "data-testid": exportButtonProps.id,
                            onClick: ()=>exportButtonProps.onClick(),
                            sx: (0, $6L9uu.buttons).cancel,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $dRSqV.default), {
                                    sx: $b7df622ac20939d4$var$actionButtonIconStyle
                                }),
                                "Export"
                            ]
                        }),
                        createButtonProps && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                            id: createButtonProps.id,
                            onClick: ()=>createButtonProps.onClick(),
                            disabled: createButtonProps.disabled || false,
                            variant: "contained",
                            color: "primary",
                            sx: (0, $6L9uu.buttons).overviewCreate,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $bt9fX.default), {
                                    sx: $b7df622ac20939d4$var$actionButtonIconStyle
                                }),
                                createButtonProps.text
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const shouldShowToolbar = showSearch === true || createButtonProps || exportButtonProps || additionalFilters;
    const detailsButton = (rowData)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: rowData.name ? rowData.name : rowData.number ? rowData.number : `${rowData.email}-${rowData.company?.name}`,
            "data-testid": rowData.id,
            sx: {
                width: "auto"
            },
            onClick: ()=>handleDetails ? handleDetails(rowData) : console.log("Missing handle details function", rowData),
            children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($lfYlj))),
                alt: "detailsButton"
            })
        });
    const removeButton = (rowData)=>{
        const disableDelete = shouldDisableDelete(rowData);
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: rowData.name ? `${rowData.name}-delete` : `${rowData.email}-delete`,
            "data-testid": `${rowData.id}-delete`,
            sx: {
                width: "auto"
            },
            disabled: disableDelete,
            onClick: ()=>handleRemove ? handleRemove(rowData) : console.log("Missing handle remove function", rowData),
            children: disableDelete ? removeButtonStyle === "basket" ? /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($b5b48))),
                alt: "removeButtonGray"
            }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $eFKxo.default), {
                sx: {
                    color: (0, $6L9uu.Colors).gray,
                    width: 20,
                    height: 21
                }
            }) : removeButtonStyle === "basket" ? /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3A2xv))),
                alt: "removeButton"
            }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $eFKxo.default), {
                sx: {
                    color: (0, $6L9uu.Colors).skyBlue,
                    width: 20,
                    height: 21
                }
            })
        });
    };
    const shouldDisableDelete = (rowData)=>{
        if (rowData.__typename === (0, $gUBkJ.Types).Invoice && rowData.status.name === (0, $aM783.INVOICE_STATUS_CONFIRMED)) return true;
        else if (rowData.__typename === (0, $gUBkJ.Types).Nav || rowData.__typename === (0, $gUBkJ.Types).DividendGross || rowData.__typename === (0, $gUBkJ.Types).HistoryLtv || rowData.__typename === (0, $gUBkJ.Types).HistoryKpi || rowData.__typename === (0, $gUBkJ.Types).HistoryAward || rowData.__typename === (0, $gUBkJ.Types).AllocationSector || rowData.__typename === (0, $gUBkJ.Types).HistoryAllocationCountry || rowData.__typename === (0, $gUBkJ.Types).HistoryRecalc) {
            const restrictedRoles = [
                (0, $8Oiq1.Roles).Admin,
                (0, $8Oiq1.Roles).IndexOperator
            ];
            return !restrictedRoles.some((r)=>state.user.data?.roles.includes(r));
        } else return !deletableItems;
    };
    const styledColumns = columns.map((column)=>{
        let res = {
            ...column
        };
        if (column.title === "Details") res = {
            ...res,
            render: detailsButton
        };
        else if (column.title === "Remove") res = {
            ...res,
            render: removeButton
        };
        return res;
    });
    const shouldShowPanel = Boolean(detailPanel);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $iTI7v.default), {
        sx: {
            width: "100%",
            height: additionalToolbar ? "calc(100% - 50px)" : "100%",
            padding: 0,
            boxShadow: "0px 10px 15px rgba(8, 79, 180, 0.05)",
            borderRadius: "8px"
        },
        children: [
            shouldShowToolbar && generateToolbar(),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $jsf2t.default), {
                sx: {
                    height: hidePagination !== true ? "calc(100% - 52px)" : "100%"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $4AJYG.default), {
                    "aria-labelledby": "tableTitle",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)($b7df622ac20939d4$var$TableHeaders, {
                            order: order,
                            orderBy: orderBy,
                            onRequestSort: handleRequestSort,
                            columns: columns,
                            extraCol: shouldShowPanel,
                            fixedHeaders: fixedHeaders
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $77DVl.default), {
                            children: getReadyToUseData().map((rowData, index)=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $6GPiu.default), {
                                            // hover
                                            onClick: detailPanel ? ()=>setSelectedRowId(rowData.id === selectedRowId ? null : rowData.id) : undefined,
                                            sx: {
                                                ...$b7df622ac20939d4$var$tableRowStyle,
                                                cursor: handleDetails ? "pointer" : "default",
                                                background: index % 2 === 0 ? "#DFDFE033" : "white"
                                            },
                                            children: [
                                                shouldShowPanel && /*#__PURE__*/ (0, $ih19M.jsx)((0, $6RrdM.default), {
                                                    sx: {
                                                        border: "none",
                                                        padding: 0,
                                                        textAlign: "center"
                                                    },
                                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $am7GZ.default), {
                                                        children: selectedRowId !== rowData.id ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $3OBHq.default), {
                                                            style: {
                                                                color: (0, $6L9uu.Colors).skyBlue
                                                            }
                                                        }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $fQfP9.default), {
                                                            style: {
                                                                color: (0, $6L9uu.Colors).skyBlue
                                                            }
                                                        })
                                                    })
                                                }),
                                                styledColumns.map((col, index2)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $6RrdM.default), {
                                                        sx: $b7df622ac20939d4$var$getTableRowCellStyle(index2, col.width),
                                                        children: col.render ? col.render(rowData) : (0, $gSGmk.displayText)((0, $d7fM7.getCellValue)(rowData, col.field ?? ""), col.type)
                                                    }, index2))
                                            ]
                                        }),
                                        selectedRowId === rowData.id && detailPanel && /*#__PURE__*/ (0, $ih19M.jsx)((0, $6GPiu.default), {
                                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $6RrdM.default), {
                                                colspan: (columns.length + 1).toString(),
                                                children: detailPanel(rowData)
                                            })
                                        })
                                    ]
                                }, index))
                        })
                    ]
                })
            }),
            hidePagination !== true && /*#__PURE__*/ (0, $ih19M.jsx)((0, $gExfQ.default), {
                rowsPerPageOptions: itemsPerPageOptions,
                showFirstButton: true,
                showLastButton: true,
                component: "div",
                count: filteredData.length,
                rowsPerPage: itemsPerPage,
                page: page,
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage,
                backIconButtonProps: {
                    contextMenu: "back",
                    color: "info",
                    title: "Previous"
                },
                labelDisplayedRows: ({ count: count })=>{
                    const pageCount = count > itemsPerPage ? Math.floor(count / itemsPerPage + 1) : 1;
                    return `${page + 1} of ${pageCount}`;
                },
                nextIconButtonProps: {
                    color: "info",
                    title: "Next"
                },
                labelRowsPerPage: /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                    style: {
                        fontSize: "14px",
                        lineHeight: "17px",
                        color: (0, $6L9uu.Colors).gray
                    },
                    children: [
                        "Total:",
                        " ",
                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            style: {
                                color: (0, $6L9uu.Colors).skyBlue,
                                fontSize: "12px",
                                fontWeight: 700
                            },
                            children: data.length
                        })
                    ]
                }),
                SelectProps: {
                    renderValue: (props)=>`${props} Rows/Page`,
                    sx: {
                        color: (0, $6L9uu.Colors).main,
                        border: `1px solid ${(0, $6L9uu.Colors).main}`,
                        borderRadius: `${(0, $6L9uu.shapes).borderRadius}px`,
                        backgroundColor: (0, $6L9uu.Colors).white,
                        fontSize: "12px",
                        lineHeight: "16px",
                        fontWeight: 700,
                        marginRight: "20px",
                        "&.Mui-focused div": {
                            borderRadius: `${(0, $6L9uu.shapes).borderRadius}px`,
                            backgroundColor: (0, $6L9uu.Colors).white
                        }
                    }
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                loading: loading
            })
        ]
    });
};
var $b7df622ac20939d4$export$2e2bcd8739ae039 = $b7df622ac20939d4$var$DenseTable;

});
parcelRegister("fQfP9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b887fcac5d535ac2$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $b887fcac5d535ac2$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), "ExpandLess");

});

parcelRegister("3OBHq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c7348e7ce2374cc$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $2c7348e7ce2374cc$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");

});

parcelRegister("eFKxo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aae8fe6e27d861f4$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $aae8fe6e27d861f4$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m4 11H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1"
}), "RemoveCircleRounded");

});


parcelRegister("iH4a7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9463897b7201c39$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $8ECDX = parcelRequire("8ECDX");
var $iTI7v = parcelRequire("iTI7v");
var $eJOwd = parcelRequire("eJOwd");

var $hjfla = parcelRequire("hjfla");

var $5PJ2i = parcelRequire("5PJ2i");

var $d13i8 = parcelRequire("d13i8");

var $bilGR = parcelRequire("bilGR");

var $6L9uu = parcelRequire("6L9uu");

var $bwbWe = parcelRequire("bwbWe");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $1ZlXU = parcelRequire("1ZlXU");

var $ehzwo = parcelRequire("ehzwo");
const $c9463897b7201c39$var$MembershipAddCompany = ({ handleClose: handleClose, membershipId: membershipId, addNewCompany: addNewCompany })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [company, setCompany] = (0, $bh6RR.useState)(null);
    const companies = (0, $hjfla.useCompaniesQuery)();
    const [addCompanyToMembership, addCompanyToMembershipResult] = (0, $hjfla.useAddCompanyToMembershipMutation)();
    const handleCompanyChange = (_, newValue)=>{
        setCompany(newValue);
    };
    const getStreetValue = ()=>{
        let result = "";
        if (company && company.main_address) result = company.main_address.street;
        return result;
    };
    const getCityValue = ()=>{
        let result = "";
        if (company && company.main_address) result = company.main_address.city;
        return result;
    };
    const getCountryValue = ()=>{
        let result = "";
        if (company && company.main_address) result = company.main_address.country.name;
        return result;
    };
    const getInvoiceToValue = ()=>{
        let result = "";
        if (company) result = company.main_contacts.map((c)=>c?.fullName).join(", ");
        return result;
    };
    const handleSubmit = ()=>{
        if (company) {
            if (membershipId === Number(company.membership.id)) dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "info",
                    text: `${company.name} is already part of ${company.membership.name} membership`
                }
            });
            else if (company.is_main_member) {
                const membershipCompanies = companies.data?.result.filter((c)=>c?.membership.id === company.membership.id);
                const membershipMainCompanies = membershipCompanies?.filter((c)=>c?.is_main_member === true && c.id !== company.id);
                if (membershipMainCompanies?.length === 0) dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "warning",
                        text: `You should select another main company for ${company.membership.name} first`,
                        autoHide: 6000
                    }
                });
                else triggerAddConfirmation(company);
            } else triggerAddConfirmation(company);
        }
    };
    const triggerAddConfirmation = (company)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                agreeAction: addToMembership,
                params: company,
                text: `Are you sure you want to add ${company.name} to ${state.selectedMembership?.name} membership?`
            }
        });
    };
    const addToMembership = (company)=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        addCompanyToMembership({
            variables: {
                id: parseInt(company.id),
                membership_id: membershipId
            },
            update (_, { data: data }) {
                if (data?.result) {
                    addNewCompany(data.result);
                    handleClose();
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `You have successfully added ${data.result.name} to the list of membership companies`
                        }
                    });
                }
            }
        }).catch((e)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            }));
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "add-company-to-membership-dialog",
        title: "Add Company",
        width: 1400,
        onClose: handleClose,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8ECDX.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    sx: {
                        display: "grid",
                        padding: "80px 25%",
                        gap: "66px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                            id: "company-options",
                            "data-testid": "membership-company-autocomplete",
                            label: "Choose company",
                            options: companies.data?.result || [],
                            disabled: addCompanyToMembershipResult.loading,
                            values: company,
                            onChange: handleCompanyChange,
                            getOptionLabel: (option)=>option?.name
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $iTI7v.default), {
                            square: true,
                            sx: {
                                height: 216,
                                boxShadow: "0px 10px 20px " + (0, $6L9uu.Colors).third + "66",
                                borderRadius: 2
                            },
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $eJOwd.default), {
                                    sx: {
                                        height: 60,
                                        minHeight: 60,
                                        paddingLeft: 18,
                                        textAlign: "left",
                                        background: (0, $6L9uu.Colors).third + "1F 0% 0% no-repeat padding-box",
                                        borderRadius: "inherit"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bwbWe.default), {
                                            style: {
                                                color: (0, $6L9uu.Colors).main,
                                                marginRight: "6px",
                                                marginTop: "-4px"
                                            }
                                        }),
                                        company ? /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            style: {
                                                color: (0, $6L9uu.Colors).main
                                            },
                                            children: company.name
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                                    sx: {
                                        display: "grid",
                                        gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                                        padding: "20px",
                                        gap: "20px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                            id: "membership-company-street",
                                            "data-testid": "membership-company-street-input-label",
                                            label: "Street",
                                            value: getStreetValue(),
                                            disabled: true,
                                            additionalStyle: {
                                                gridColumn: "span 2"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                            id: "membership-company-city",
                                            "data-testid": "membership-company-city-input-label",
                                            label: "City",
                                            value: getCityValue(),
                                            disabled: true
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                            id: "membership-company-country",
                                            "data-testid": "membership-company-country-input-label",
                                            label: "Country",
                                            value: getCountryValue(),
                                            disabled: true
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                            id: "membership-company-invoice-to",
                                            "data-testid": "membership-company-invoice-to-input-label",
                                            label: "Invoice to",
                                            value: getInvoiceToValue(),
                                            disabled: true,
                                            additionalStyle: {
                                                gridColumn: "span 4"
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    gridColumn: "span 3",
                    marginTop: "100px",
                    marginBottom: "40px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-add-company-to-membership-button",
                        "data-testid": "cancel-add-company-to-membership-button",
                        onClick: handleClose,
                        text: "cancel"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "create-add-company-to-membership-button",
                        "data-testid": "create-add-company-to-membership-button",
                        disabled: !company || addCompanyToMembershipResult.loading,
                        onClick: handleSubmit,
                        text: "Add"
                    })
                ]
            })
        ]
    });
};
var $c9463897b7201c39$export$2e2bcd8739ae039 = $c9463897b7201c39$var$MembershipAddCompany;

});


parcelRegister("j5ie7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $049ea749369973ef$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");
var $aitry = parcelRequire("aitry");
parcelRequire("bh6RR");
const $049ea749369973ef$var$TabPanel = (props)=>{
    const { children: children, value: value, index: index } = props;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        role: "tabpanel",
        hidden: value !== index,
        id: `full-width-tabpanel-${index}`,
        "aria-labelledby": `full-width-tab-${index}`,
        children: value === index && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), {
                component: "span",
                variant: "body2",
                children: children
            })
        })
    });
};
var $049ea749369973ef$export$2e2bcd8739ae039 = $049ea749369973ef$var$TabPanel;

});

parcelRegister("eBMvL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22b8f3f9773ba6b4$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $dqPsF = parcelRequire("dqPsF");
var $chLJv = parcelRequire("chLJv");
var $35wch = parcelRequire("35wch");
var $km2xR = parcelRequire("km2xR");
var $da7cf = parcelRequire("da7cf");

var $6L9uu = parcelRequire("6L9uu");

var $hsjD5 = parcelRequire("hsjD5");
const $22b8f3f9773ba6b4$var$CustomAppBar = ({ value: value, handleChange: handleChange, tabProps: tabProps, type: type = "second" })=>{
    const textColoring = type === "first" ? "inherit" : "primary";
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $dqPsF.default), {
        position: "static",
        sx: {
            backgroundColor: type === "first" ? (0, $6L9uu.Colors).gradient : "white",
            boxShadow: type === "third" ? "none" : "default"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $da7cf.default), {
            value: value,
            onChange: handleChange,
            indicatorColor: "primary",
            textColor: textColoring,
            variant: "fullWidth",
            TabIndicatorProps: {
                sx: type === "first" ? {
                    background: (0, $6L9uu.Colors).skyBlue,
                    height: "6px"
                } : type === "second" ? {
                    background: (0, $6L9uu.Colors).main
                } : {
                    background: (0, $6L9uu.Colors).white
                }
            },
            children: tabProps.map((tab, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $km2xR.default), {
                    id: tab.id,
                    label: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        className: "centralize",
                        children: [
                            tab.icon && /*#__PURE__*/ (0, $ih19M.jsx)((0, $35wch.default), {
                                component: tab.icon,
                                sx: {
                                    marginRight: "5px"
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                children: tab.title
                            })
                        ]
                    }),
                    sx: type === "first" ? (0, $hsjD5.getInfoWrapperTabStyle)(index, value) : type === "second" ? (0, $hsjD5.getOuterStyle)(index, value) : (0, $hsjD5.getTabStyle)(index, value)
                }, index))
        })
    });
};
var $22b8f3f9773ba6b4$export$2e2bcd8739ae039 = $22b8f3f9773ba6b4$var$CustomAppBar;

});
parcelRegister("dqPsF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c759f36690415be$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $fGH8N = parcelRequire("fGH8N");

var $iTI7v = parcelRequire("iTI7v");

var $37ctc = parcelRequire("37ctc");

var $ih19M = parcelRequire("ih19M");
"use client";
const $9c759f36690415be$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $9c759f36690415be$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $fGH8N.default)(color)}`,
            `position${(0, $fGH8N.default)(position)}`
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $37ctc.getAppBarUtilityClass), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $9c759f36690415be$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(")", "")}, ${var2})` : var2;
const $9c759f36690415be$var$AppBarRoot = (0, $g4l1t.default)((0, $iTI7v.default), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $fGH8N.default)(ownerState.position)}`],
            styles[`color${(0, $fGH8N.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $4WYaH.default)({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === "fixed" && {
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0,
        "@media print": {
            // Prevent the app bar to be visible on each printed page.
            position: "absolute"
        }
    }, ownerState.position === "absolute" && {
        position: "absolute",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "sticky" && {
        // ⚠️ sticky is not supported by IE11.
        position: "sticky",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "static" && {
        position: "static"
    }, ownerState.position === "relative" && {
        position: "relative"
    }, !theme.vars && (0, $4WYaH.default)({}, ownerState.color === "default" && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== "default" && ownerState.color !== "inherit" && ownerState.color !== "transparent" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, theme.palette.mode === "dark" && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === "transparent" && (0, $4WYaH.default)({
        backgroundColor: "transparent",
        color: "inherit"
    }, theme.palette.mode === "dark" && {
        backgroundImage: "none"
    })), theme.vars && (0, $4WYaH.default)({}, ownerState.color === "default" && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $9c759f36690415be$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $9c759f36690415be$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $9c759f36690415be$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $9c759f36690415be$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, {
        backgroundColor: "var(--AppBar-background)",
        color: ownerState.color === "inherit" ? "inherit" : "var(--AppBar-color)"
    }, ownerState.color === "transparent" && {
        backgroundImage: "none",
        backgroundColor: "transparent",
        color: "inherit"
    }));
});
const $9c759f36690415be$var$AppBar = /*#__PURE__*/ $bh6RR.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiAppBar"
    });
    const { className: className, color: color = "primary", enableColorOnDark: enableColorOnDark = false, position: position = "fixed" } = props, other = (0, $hCIyK.default)(props, $9c759f36690415be$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $9c759f36690415be$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($9c759f36690415be$var$AppBarRoot, (0, $4WYaH.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $aPsoC.default)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
var $9c759f36690415be$export$2e2bcd8739ae039 = $9c759f36690415be$var$AppBar;

});
parcelRegister("37ctc", function(module, exports) {

$parcel$export(module.exports, "getAppBarUtilityClass", function () { return $244bb2cccaa2b71c$export$47a2da616e55e8e9; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $244bb2cccaa2b71c$export$47a2da616e55e8e9(slot) {
    return (0, $XybB6.default)("MuiAppBar", slot);
}
const $244bb2cccaa2b71c$var$appBarClasses = (0, $igcUF.default)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning"
]);
var $244bb2cccaa2b71c$export$2e2bcd8739ae039 = $244bb2cccaa2b71c$var$appBarClasses;

});


parcelRegister("km2xR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed17d61be6186e42$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $aEoM0 = parcelRequire("aEoM0");

var $fGH8N = parcelRequire("fGH8N");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");


var $2hVEx = parcelRequire("2hVEx");

var $ih19M = parcelRequire("ih19M");
"use client";
const $ed17d61be6186e42$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $ed17d61be6186e42$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            icon && label && "labelIcon",
            `textColor${(0, $fGH8N.default)(textColor)}`,
            fullWidth && "fullWidth",
            wrapped && "wrapped",
            selected && "selected",
            disabled && "disabled"
        ],
        iconWrapper: [
            "iconWrapper"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $2hVEx.getTabUtilityClass), classes);
};
const $ed17d61be6186e42$var$TabRoot = (0, $g4l1t.default)((0, $aEoM0.default), {
    name: "MuiTab",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $fGH8N.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: "relative",
        minHeight: 48,
        flexShrink: 0,
        padding: "12px 16px",
        overflow: "hidden",
        whiteSpace: "normal",
        textAlign: "center"
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === "top" || ownerState.iconPosition === "bottom" ? "column" : "row"
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $2hVEx.default).iconWrapper}`]: (0, $4WYaH.default)({}, ownerState.iconPosition === "top" && {
            marginBottom: 6
        }, ownerState.iconPosition === "bottom" && {
            marginTop: 6
        }, ownerState.iconPosition === "start" && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === "end" && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === "inherit" && {
        color: "inherit",
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $2hVEx.default).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $2hVEx.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === "primary" && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $2hVEx.default).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $2hVEx.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === "secondary" && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $2hVEx.default).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $2hVEx.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: "none"
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $ed17d61be6186e42$var$Tab = /*#__PURE__*/ $bh6RR.forwardRef(function Tab(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTab"
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = "top", indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = "inherit", value: value, wrapped: wrapped = false } = props, other = (0, $hCIyK.default)(props, $ed17d61be6186e42$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $ed17d61be6186e42$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $bh6RR.isValidElement(iconProp) ? /*#__PURE__*/ $bh6RR.cloneElement(iconProp, {
        className: (0, $aPsoC.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)($ed17d61be6186e42$var$TabRoot, (0, $4WYaH.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === "top" || iconPosition === "start" ? /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $ed17d61be6186e42$export$2e2bcd8739ae039 = $ed17d61be6186e42$var$Tab;

});
parcelRegister("2hVEx", function(module, exports) {

$parcel$export(module.exports, "getTabUtilityClass", function () { return $1aa9e3f2bed003af$export$72aef224d6115253; });
$parcel$export(module.exports, "default", function () { return $1aa9e3f2bed003af$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $1aa9e3f2bed003af$export$72aef224d6115253(slot) {
    return (0, $XybB6.default)("MuiTab", slot);
}
const $1aa9e3f2bed003af$var$tabClasses = (0, $igcUF.default)("MuiTab", [
    "root",
    "labelIcon",
    "textColorInherit",
    "textColorPrimary",
    "textColorSecondary",
    "selected",
    "disabled",
    "fullWidth",
    "wrapped",
    "iconWrapper"
]);
var $1aa9e3f2bed003af$export$2e2bcd8739ae039 = $1aa9e3f2bed003af$var$tabClasses;

});


parcelRegister("da7cf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9951ca9fa74954e4$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("f5Ssd");


var $aPsoC = parcelRequire("aPsoC");


var $7ITag = parcelRequire("7ITag");

var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $8gyMY = parcelRequire("8gyMY");

var $4lWVQ = parcelRequire("4lWVQ");

var $9Wsmw = parcelRequire("9Wsmw");

var $eQy7c = parcelRequire("eQy7c");

var $1uv4n = parcelRequire("1uv4n");

var $gDxd8 = parcelRequire("gDxd8");

var $8M7SI = parcelRequire("8M7SI");

var $5WdMx = parcelRequire("5WdMx");

var $27yUY = parcelRequire("27yUY");

var $kPbNB = parcelRequire("kPbNB");

var $ih19M = parcelRequire("ih19M");
"use client";
const $9951ca9fa74954e4$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $9951ca9fa74954e4$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $9951ca9fa74954e4$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $9951ca9fa74954e4$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $9951ca9fa74954e4$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            vertical && "vertical"
        ],
        scroller: [
            "scroller",
            fixed && "fixed",
            hideScrollbar && "hideScrollbar",
            scrollableX && "scrollableX",
            scrollableY && "scrollableY"
        ],
        flexContainer: [
            "flexContainer",
            vertical && "flexContainerVertical",
            centered && "centered"
        ],
        indicator: [
            "indicator"
        ],
        scrollButtons: [
            "scrollButtons",
            scrollButtonsHideMobile && "scrollButtonsHideMobile"
        ],
        scrollableX: [
            scrollableX && "scrollableX"
        ],
        hideScrollbar: [
            hideScrollbar && "hideScrollbar"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $5WdMx.getTabsUtilityClass), classes);
};
const $9951ca9fa74954e4$var$TabsRoot = (0, $g4l1t.default)("div", {
    name: "MuiTabs",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $5WdMx.default).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $5WdMx.default).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $4WYaH.default)({
        overflow: "hidden",
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $5WdMx.default).scrollButtons}`]: {
            [theme.breakpoints.down("sm")]: {
                display: "none"
            }
        }
    }));
const $9951ca9fa74954e4$var$TabsScroller = (0, $g4l1t.default)("div", {
    name: "MuiTabs",
    slot: "Scroller",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        position: "relative",
        display: "inline-block",
        flex: "1 1 auto",
        whiteSpace: "nowrap"
    }, ownerState.fixed && {
        overflowX: "hidden",
        width: "100%"
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: "none",
        // Firefox
        "&::-webkit-scrollbar": {
            display: "none" // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: "auto",
        overflowY: "hidden"
    }, ownerState.scrollableY && {
        overflowY: "auto",
        overflowX: "hidden"
    }));
const $9951ca9fa74954e4$var$FlexContainer = (0, $g4l1t.default)("div", {
    name: "MuiTabs",
    slot: "FlexContainer",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.centered && {
        justifyContent: "center"
    }));
const $9951ca9fa74954e4$var$TabsIndicator = (0, $g4l1t.default)("span", {
    name: "MuiTabs",
    slot: "Indicator",
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $4WYaH.default)({
        position: "absolute",
        height: 2,
        bottom: 0,
        width: "100%",
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === "primary" && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === "secondary" && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: "100%",
        width: 2,
        right: 0
    }));
const $9951ca9fa74954e4$var$TabsScrollbarSize = (0, $g4l1t.default)((0, $1uv4n.default))({
    overflowX: "auto",
    overflowY: "hidden",
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: "none",
    // Firefox
    "&::-webkit-scrollbar": {
        display: "none" // Safari + Chrome
    }
});
const $9951ca9fa74954e4$var$defaultIndicatorStyle = {};
let $9951ca9fa74954e4$var$warnedOnceTabPresent = false;
const $9951ca9fa74954e4$var$Tabs = /*#__PURE__*/ $bh6RR.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTabs"
    });
    const theme = (0, $8gyMY.default)();
    const isRtl = theme.direction === "rtl";
    const { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = "div", allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = "primary", onChange: onChange, orientation: orientation = "horizontal", ScrollButtonComponent: ScrollButtonComponent = (0, $gDxd8.default), scrollButtons: scrollButtons = "auto", selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = "primary", value: value, variant: variant = "standard", visibleScrollbar: visibleScrollbar = false } = props, other = (0, $hCIyK.default)(props, $9951ca9fa74954e4$var$_excluded);
    const scrollable = variant === "scrollable";
    const vertical = orientation === "vertical";
    const scrollStart = vertical ? "scrollTop" : "scrollLeft";
    const start = vertical ? "top" : "left";
    const end = vertical ? "bottom" : "right";
    const clientSize = vertical ? "clientHeight" : "clientWidth";
    const size = vertical ? "height" : "width";
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $9951ca9fa74954e4$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $7ITag.useSlotProps)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $7ITag.useSlotProps)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $bh6RR.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $bh6RR.useState($9951ca9fa74954e4$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $bh6RR.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $bh6RR.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $bh6RR.useState(false);
    const [scrollerStyle, setScrollerStyle] = $bh6RR.useState({
        overflow: "hidden",
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $bh6RR.useRef(null);
    const tabListRef = $bh6RR.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $9Wsmw.getNormalizedScrollLeft)(tabsNode, theme.direction),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $8M7SI.default)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = "top";
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? "right" : "left";
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $eQy7c.default)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $9Wsmw.detectScrollType)() === "reverse" ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $bh6RR.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $ih19M.jsx)($9951ca9fa74954e4$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $aPsoC.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === "auto" && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $ih19M.jsx)(ScrollButtonComponent, (0, $4WYaH.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? "right" : "left",
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $aPsoC.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $ih19M.jsx)(ScrollButtonComponent, (0, $4WYaH.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? "left" : "right",
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $aPsoC.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $8M7SI.default)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $8M7SI.default)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $bh6RR.useEffect(()=>{
        const handleResize = (0, $4lWVQ.default)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $kPbNB.default)(tabsRef.current);
        win.addEventListener("resize", handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== "undefined") {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener("resize", handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $bh6RR.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== "undefined" && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $bh6RR.useEffect(()=>{
        setMounted(true);
    }, []);
    $bh6RR.useEffect(()=>{
        updateIndicatorState();
    });
    $bh6RR.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($9951ca9fa74954e4$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $bh6RR.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $ih19M.jsx)($9951ca9fa74954e4$var$TabsIndicator, (0, $4WYaH.default)({}, TabIndicatorProps, {
        className: (0, $aPsoC.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $4WYaH.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $bh6RR.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $bh6RR.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $bh6RR.cloneElement(child, (0, $4WYaH.default)({
            fullWidth: variant === "fullWidth",
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $27yUY.default)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute("role");
        if (role !== "tab") return;
        let previousItemKey = orientation === "horizontal" ? "ArrowLeft" : "ArrowUp";
        let nextItemKey = orientation === "horizontal" ? "ArrowRight" : "ArrowDown";
        if (orientation === "horizontal" && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = "ArrowRight";
            nextItemKey = "ArrowLeft";
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $9951ca9fa74954e4$var$moveFocus(list, currentFocus, $9951ca9fa74954e4$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $9951ca9fa74954e4$var$moveFocus(list, currentFocus, $9951ca9fa74954e4$var$nextItem);
                break;
            case "Home":
                event.preventDefault();
                $9951ca9fa74954e4$var$moveFocus(list, null, $9951ca9fa74954e4$var$nextItem);
                break;
            case "End":
                event.preventDefault();
                $9951ca9fa74954e4$var$moveFocus(list, null, $9951ca9fa74954e4$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $ih19M.jsxs)($9951ca9fa74954e4$var$TabsRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $ih19M.jsxs)($9951ca9fa74954e4$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? "Left" : "Right"}` : "marginBottom"]: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($9951ca9fa74954e4$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === "vertical" ? "vertical" : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $9951ca9fa74954e4$export$2e2bcd8739ae039 = $9951ca9fa74954e4$var$Tabs;

});
parcelRegister("9Wsmw", function(module, exports) {

$parcel$export(module.exports, "detectScrollType", function () { return $73cf8801f255911d$export$a10970ffb6510128; });
$parcel$export(module.exports, "getNormalizedScrollLeft", function () { return $73cf8801f255911d$export$3c615b88e5d7e4f6; });
// Source from https://github.com/alitaheri/normalize-scroll-left
let $73cf8801f255911d$var$cachedType;
function $73cf8801f255911d$export$a10970ffb6510128() {
    if ($73cf8801f255911d$var$cachedType) return $73cf8801f255911d$var$cachedType;
    const dummy = document.createElement("div");
    const container = document.createElement("div");
    container.style.width = "10px";
    container.style.height = "1px";
    dummy.appendChild(container);
    dummy.dir = "rtl";
    dummy.style.fontSize = "14px";
    dummy.style.width = "4px";
    dummy.style.height = "1px";
    dummy.style.position = "absolute";
    dummy.style.top = "-1000px";
    dummy.style.overflow = "scroll";
    document.body.appendChild(dummy);
    $73cf8801f255911d$var$cachedType = "reverse";
    if (dummy.scrollLeft > 0) $73cf8801f255911d$var$cachedType = "default";
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $73cf8801f255911d$var$cachedType = "negative";
    }
    document.body.removeChild(dummy);
    return $73cf8801f255911d$var$cachedType;
}
function $73cf8801f255911d$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== "rtl") return scrollLeft;
    const type = $73cf8801f255911d$export$a10970ffb6510128();
    switch(type){
        case "negative":
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case "reverse":
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}

});

parcelRegister("eQy7c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acf06294bd42fb49$export$2e2bcd8739ae039; });
function $acf06294bd42fb49$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $acf06294bd42fb49$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $acf06294bd42fb49$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error("Animation cancelled"));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error("Element already at target position"));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}

});

parcelRegister("1uv4n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1160b19145240724$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $4lWVQ = parcelRequire("4lWVQ");

var $kPbNB = parcelRequire("kPbNB");
var $iWGrV = parcelRequire("iWGrV");

var $ih19M = parcelRequire("ih19M");
"use client";
const $1160b19145240724$var$_excluded = [
    "onChange"
];
const $1160b19145240724$var$styles = {
    width: 99,
    height: 99,
    position: "absolute",
    top: -9999,
    overflow: "scroll"
};
function $1160b19145240724$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $hCIyK.default)(props, $1160b19145240724$var$_excluded);
    const scrollbarHeight = $bh6RR.useRef();
    const nodeRef = $bh6RR.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $iWGrV.default)(()=>{
        const handleResize = (0, $4lWVQ.default)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $kPbNB.default)(nodeRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        onChange
    ]);
    $bh6RR.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", (0, $4WYaH.default)({
        style: $1160b19145240724$var$styles,
        ref: nodeRef
    }, other));
}

});

parcelRegister("gDxd8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1ca0cdc254616e3$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7ITag = parcelRequire("7ITag");

var $7J7Kn = parcelRequire("7J7Kn");

var $1R8zt = parcelRequire("1R8zt");

var $6BGOB = parcelRequire("6BGOB");

var $aEoM0 = parcelRequire("aEoM0");

var $8gyMY = parcelRequire("8gyMY");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $1TMHz = parcelRequire("1TMHz");

var $ih19M = parcelRequire("ih19M");
"use client";
const $c1ca0cdc254616e3$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $c1ca0cdc254616e3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            disabled && "disabled"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $1TMHz.getTabScrollButtonUtilityClass), classes);
};
const $c1ca0cdc254616e3$var$TabScrollButtonRoot = (0, $g4l1t.default)((0, $aEoM0.default), {
    name: "MuiTabScrollButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $1TMHz.default).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === "vertical" && {
        width: "100%",
        height: 40,
        "& svg": {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $c1ca0cdc254616e3$var$TabScrollButton = /*#__PURE__*/ $bh6RR.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTabScrollButton"
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $hCIyK.default)(props, $c1ca0cdc254616e3$var$_excluded);
    const theme = (0, $8gyMY.default)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $4WYaH.default)({
        isRtl: isRtl
    }, props);
    const classes = $c1ca0cdc254616e3$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $1R8zt.default);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $6BGOB.default);
    const startButtonIconProps = (0, $7ITag.useSlotProps)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $7ITag.useSlotProps)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)($c1ca0cdc254616e3$var$TabScrollButtonRoot, (0, $4WYaH.default)({
        component: "div",
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === "left" ? /*#__PURE__*/ (0, $ih19M.jsx)(StartButtonIcon, (0, $4WYaH.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $ih19M.jsx)(EndButtonIcon, (0, $4WYaH.default)({}, endButtonIconProps))
    }));
});
var $c1ca0cdc254616e3$export$2e2bcd8739ae039 = $c1ca0cdc254616e3$var$TabScrollButton;

});
parcelRegister("1TMHz", function(module, exports) {

$parcel$export(module.exports, "getTabScrollButtonUtilityClass", function () { return $1620b4a8e6ac1e55$export$34861783d3c2eef8; });
$parcel$export(module.exports, "default", function () { return $1620b4a8e6ac1e55$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $1620b4a8e6ac1e55$export$34861783d3c2eef8(slot) {
    return (0, $XybB6.default)("MuiTabScrollButton", slot);
}
const $1620b4a8e6ac1e55$var$tabScrollButtonClasses = (0, $igcUF.default)("MuiTabScrollButton", [
    "root",
    "vertical",
    "horizontal",
    "disabled"
]);
var $1620b4a8e6ac1e55$export$2e2bcd8739ae039 = $1620b4a8e6ac1e55$var$tabScrollButtonClasses;

});


parcelRegister("5WdMx", function(module, exports) {

$parcel$export(module.exports, "getTabsUtilityClass", function () { return $452d0f516f4a9752$export$cdd93bd054dec359; });
$parcel$export(module.exports, "default", function () { return $452d0f516f4a9752$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $452d0f516f4a9752$export$cdd93bd054dec359(slot) {
    return (0, $XybB6.default)("MuiTabs", slot);
}
const $452d0f516f4a9752$var$tabsClasses = (0, $igcUF.default)("MuiTabs", [
    "root",
    "vertical",
    "flexContainer",
    "flexContainerVertical",
    "centered",
    "scroller",
    "fixed",
    "scrollableX",
    "scrollableY",
    "hideScrollbar",
    "scrollButtons",
    "scrollButtonsHideMobile",
    "indicator"
]);
var $452d0f516f4a9752$export$2e2bcd8739ae039 = $452d0f516f4a9752$var$tabsClasses;

});



parcelRegister("9frLO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $229dc16f7ea75804$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");
var $lGURI = parcelRequire("lGURI");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $hsjD5 = parcelRequire("hsjD5");

var $5DXc5 = parcelRequire("5DXc5");

var $b42dh = parcelRequire("b42dh");
const $229dc16f7ea75804$var$MembershipContactsTab = ({ membershipId: membershipId })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const history = (0, $99w1R.useNavigate)();
    const { data: data, loading: loading } = (0, $hjfla.useMembershipContactsQuery)({
        variables: {
            id: membershipId
        },
        fetchPolicy: "no-cache"
    });
    const [setInvoiceTo, setInvoiceToResult] = (0, $hjfla.useSetInvoiceToContactMutation)();
    const [contacts, setContacts] = (0, $bh6RR.useState)([]);
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Membership);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setContacts(data?.result);
    }, [
        data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (setInvoiceToResult.data && setInvoiceToResult.data.result) {
            const { result: result } = setInvoiceToResult.data;
            setContacts(contacts.map((c)=>c.id === result.id ? result : c));
            const message = result.is_main ? `Contact ${result.fullName} set as invoice to` : `Contact ${result.fullName} removed from invoice to`;
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "success",
                    text: message
                }
            });
        }
        if (setInvoiceToResult.error) dispatch({
            type: (0, $ayVxz.Actions).ShowMessage,
            payload: {
                severity: "error",
                text: setInvoiceToResult.error.message,
                autoHide: 6000
            }
        });
    }, [
        setInvoiceToResult
    ]);
    const handleDetails = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).SetSelectedContact,
            payload: {
                name: rowData.fullName,
                company_name: rowData.company.name
            }
        });
        history(`/contacts/${rowData.id}`, {
            state: {
                ...rowData
            }
        });
    };
    const handleInvoiceTo = (rowData)=>{
        setInvoiceTo({
            variables: {
                id: parseInt(rowData.id),
                is_main: !rowData.is_main
            }
        });
    };
    const renderInvoiceTo = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lGURI.default), {
            id: "is-website",
            disableRipple: true,
            name: "checkeWebSite",
            disabled: !canEdit,
            onChange: ()=>handleInvoiceTo(rowData),
            checked: rowData.is_main || false
        });
    };
    const columns = [
        {
            title: "Details",
            sorting: false,
            width: 66
        },
        {
            title: "Invoice to",
            sorting: false,
            render: renderInvoiceTo,
            width: 86
        },
        {
            title: "ID",
            width: 89,
            field: "id",
            type: "numeric"
        },
        {
            title: "Name",
            field: "fullName",
            width: 203
        },
        {
            title: "Title General",
            field: "titleInternal.name",
            width: 172
        },
        {
            title: "Address",
            field: "address.street",
            width: 265
        },
        {
            title: "Company",
            field: "company.name",
            width: 265
        },
        {
            title: "Email",
            field: "email",
            width: 270
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        className: "centralize",
        sx: {
            width: "100%",
            paddingTop: "80px"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5DXc5.default), {
            headerText: "Contacts",
            width: "82%",
            additionalStyle: {
                height: "680px"
            },
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
                columns: columns,
                data: (0, $hsjD5.FormatTableData)(contacts),
                loading: loading,
                handleDetails: handleDetails,
                handleRemove: ()=>true,
                pageSize: 10,
                crudType: (0, $gUBkJ.Types).Membership,
                additionalToolbar: true,
                fixedHeaders: true
            })
        })
    });
};
var $229dc16f7ea75804$export$2e2bcd8739ae039 = $229dc16f7ea75804$var$MembershipContactsTab;

});

parcelRegister("8XxJW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b3dcf1946308acd$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $3vIfq = parcelRequire("3vIfq");

var $51oSn = parcelRequire("51oSn");
var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $fyVOI = parcelRequire("fyVOI");
var $bIyvl = parcelRequire("bIyvl");
var $g7vB6 = parcelRequire("g7vB6");
var $1sQVT = parcelRequire("1sQVT");
var $dNZ9A = parcelRequire("dNZ9A");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $6L9uu = parcelRequire("6L9uu");

var $bilGR = parcelRequire("bilGR");

var $91340 = parcelRequire("91340");

var $ehzwo = parcelRequire("ehzwo");

var $3wrhr = parcelRequire("3wrhr");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $ayVxz = parcelRequire("ayVxz");

var $gFVvY = parcelRequire("gFVvY");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $5DXc5 = parcelRequire("5DXc5");

var $bSbwb = parcelRequire("bSbwb");

var $fAmb3 = parcelRequire("fAmb3");
const $0b3dcf1946308acd$var$defaultErrorsObj = {
    name: null,
    type: null,
    discount: null,
    startDate: null,
    renewalDate: null,
    endDate: null
};
const $0b3dcf1946308acd$var$minDate = new Date("01.01.2000");
const $0b3dcf1946308acd$var$startMinDateMessage = `date should be after ${$0b3dcf1946308acd$var$minDate}`;
const $0b3dcf1946308acd$var$renewalMinDateMessage = "renewal date should be after start date";
const $0b3dcf1946308acd$var$endMinDateMessage = "end date should be after start date";
const $0b3dcf1946308acd$var$endDateBeforeRenewalMessage = "end date should be after renewal date";
const $0b3dcf1946308acd$var$MembershipDetailsTab = ({ membership: membership, updateCommentsCount: updateCommentsCount })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [openComments, setOpenComments] = (0, $bh6RR.useState)(false);
    const [getMembershipTypes, { data: data }] = (0, $hjfla.useMembershipProductsLazyQuery)();
    const [editable, setEditable] = (0, $bh6RR.useState)(false);
    const [name, setName] = (0, $bh6RR.useState)(membership.name);
    const [badDeptor, setBadDeptor] = (0, $bh6RR.useState)(membership.is_bad_debtor);
    const [discount, setDiscount] = (0, $bh6RR.useState)(membership.discount);
    const [type, setType] = (0, $bh6RR.useState)(membership.product);
    const [options, setOptions] = (0, $bh6RR.useState)([
        membership.product
    ]);
    const [startDate, setStartDate] = (0, $bh6RR.useState)((0, $gFVvY.parseDate)(membership.start_date));
    const [renewalDate, setRenewalDate] = (0, $bh6RR.useState)((0, $gFVvY.parseDate)(membership.renewable_date));
    const [endDate, setEndDate] = (0, $bh6RR.useState)((0, $gFVvY.parseDate)(membership.end_date));
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($0b3dcf1946308acd$var$defaultErrorsObj);
    const [updateMembership, updateMembershipResult] = (0, $hjfla.useUpdateMembershipMutation)();
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Membership);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setOptions(data.result);
    }, [
        data?.result
    ]);
    const submitForm = ()=>{
        const errors = {
            name: null,
            type: null,
            discount: null,
            startDate: null,
            renewalDate: null,
            endDate: null
        };
        let hasErrors = false;
        if (!name || name.length < 2) {
            hasErrors = true;
            errors.name = (0, $3wrhr.ErrorTexts).name;
        }
        if (!type) {
            hasErrors = true;
            errors.type = (0, $3wrhr.ErrorTexts).type;
        }
        const productPrice = type?.price;
        if (discount && (discount < 0 || discount > productPrice)) {
            hasErrors = true;
            errors.discount = (0, $3wrhr.ErrorTexts).discount;
        }
        if (!startDate) {
            hasErrors = true;
            errors.startDate = (0, $3wrhr.ErrorTexts).startDate;
        } else if (!Date.parse(startDate.toString())) {
            hasErrors = true;
            errors.startDate = (0, $3wrhr.ErrorTexts).startDateInvalidDate;
        }
        if (renewalDate) {
            if (Date.parse(renewalDate.toString())) {
                if (startDate && startDate > renewalDate) {
                    hasErrors = true;
                    errors.renewalDate = $0b3dcf1946308acd$var$renewalMinDateMessage;
                }
            } else {
                hasErrors = true;
                errors.renewalDate = "invalid renewal date";
            }
        }
        if (endDate) {
            if (Date.parse(endDate.toString())) {
                if (renewalDate && renewalDate > endDate) {
                    hasErrors = true;
                    errors.endDate = $0b3dcf1946308acd$var$endDateBeforeRenewalMessage;
                }
                if (startDate && startDate > endDate) {
                    hasErrors = true;
                    errors.endDate = $0b3dcf1946308acd$var$endMinDateMessage;
                }
            } else hasErrors = true;
        }
        if (!hasErrors && (0, $gFVvY.sameMembershipNameExist)(name, membership.id)) {
            hasErrors = true;
            errors.name = (0, $3wrhr.ErrorTexts).nameExists;
        }
        if (hasErrors) setFormErrors(errors);
        else submitMembership();
    };
    const submitMembership = ()=>{
        const variables = {
            id: parseInt(membership.id),
            input: {
                name: name,
                product_id: parseInt(type?.id),
                start_date: startDate ? startDate.toString() : "",
                end_date: endDate ? endDate.toString() : "",
                renewable_date: renewalDate ? renewalDate.toString() : "",
                discount: discount ? parseFloat(discount.toString()) : null,
                total: parseFloat(getTotalCost().toString()),
                is_bad_debtor: badDeptor
            }
        };
        updateMembership({
            variables: variables,
            update (_, { data: data }) {
                if (data && data.result) {
                    setEditable(false);
                    dispatch({
                        type: (0, $ayVxz.Actions).SetSelectedMembership,
                        payload: {
                            id: data.result.id,
                            name: data.result.name,
                            start_date: data.result.start_date ?? null,
                            end_date: data.result.end_date ?? null
                        }
                    });
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            text: `Successfully updated ${data.result.name}`,
                            severity: "success",
                            autoHide: 2000
                        }
                    });
                }
            }
        }).catch((e)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: e.message,
                    severity: "error",
                    autoHide: 6000
                }
            }));
    };
    const handleCancel = ()=>{
        setName(membership.name);
        setBadDeptor(membership.is_bad_debtor);
        setDiscount(membership.discount);
        setType(membership.product);
        setStartDate((0, $gFVvY.parseDate)(membership.start_date));
        setRenewalDate((0, $gFVvY.parseDate)(membership.renewable_date));
        setEndDate((0, $gFVvY.parseDate)(membership.end_date));
        setFormErrors($0b3dcf1946308acd$var$defaultErrorsObj);
        setEditable(false);
    };
    const getTotalCost = ()=>{
        return type ? type.price - Number(discount) : "";
    };
    const handleEditPressed = ()=>{
        getMembershipTypes();
        setEditable(true);
    };
    const handleMembershipTypeChange = (_, newValue)=>{
        setDiscount(null);
        if (newValue) {
            const product = newValue;
            (0, $3wrhr.ErrorTexts).discount = `discount should be between 0 and ${product.price}`;
            setFormErrors({
                ...formErrors,
                type: null,
                discount: null
            });
        } else {
            (0, $3wrhr.ErrorTexts).discount = `discount should be bigger than 0`;
            setFormErrors({
                ...formErrors,
                type: (0, $3wrhr.ErrorTexts).type,
                discount: null
            });
        }
        setType(newValue);
    };
    const handleNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!value || value.length < 2) setFormErrors({
            ...formErrors,
            name: (0, $3wrhr.ErrorTexts).name
        });
        else setFormErrors({
            ...formErrors,
            name: null
        });
        setName(value);
    };
    const handleDiscountChange = (event)=>{
        const { value: value } = event.currentTarget;
        const disc = Number(value);
        const productPrice = type?.price;
        if (disc && disc < 0 || disc > productPrice) setFormErrors({
            ...formErrors,
            discount: type ? `discount should be between 0 and ${type.price}` : "invalid discount"
        });
        else setFormErrors({
            ...formErrors,
            discount: null
        });
        setDiscount(isNaN(disc) ? null : disc);
    };
    const handleEndDateChange = (value)=>{
        if (value && startDate && value <= startDate) setFormErrors({
            ...formErrors,
            endDate: $0b3dcf1946308acd$var$endMinDateMessage
        });
        else if (value && renewalDate && value < renewalDate) setFormErrors({
            ...formErrors,
            endDate: $0b3dcf1946308acd$var$endDateBeforeRenewalMessage
        });
        else setFormErrors({
            ...formErrors,
            endDate: null
        });
        setEndDate(value);
    };
    const handleRenewalDateChange = (value)=>{
        if (value) {
            const dateErrors = {
                renewalDate: formErrors.renewalDate,
                endDate: formErrors.endDate
            };
            if (startDate && startDate > value) dateErrors.renewalDate = $0b3dcf1946308acd$var$renewalMinDateMessage;
            else dateErrors.renewalDate = null;
            if (endDate && endDate < value) dateErrors.endDate = $0b3dcf1946308acd$var$endDateBeforeRenewalMessage;
            else if (dateErrors.endDate === $0b3dcf1946308acd$var$endDateBeforeRenewalMessage) dateErrors.endDate = null;
            setFormErrors({
                ...formErrors,
                ...dateErrors
            });
        } else setFormErrors({
            ...formErrors,
            renewalDate: null,
            endDate: formErrors.endDate === $0b3dcf1946308acd$var$endDateBeforeRenewalMessage ? null : formErrors.endDate
        });
        setRenewalDate(value);
    };
    const handleStartDateChange = (value)=>{
        if (value) {
            const dateErrors = {
                startDate: null,
                renewalDate: formErrors.renewalDate,
                endDate: formErrors.endDate
            };
            if (value < new Date($0b3dcf1946308acd$var$minDate)) dateErrors.startDate = $0b3dcf1946308acd$var$startMinDateMessage;
            else if (dateErrors.startDate === $0b3dcf1946308acd$var$startMinDateMessage) dateErrors.startDate = null;
            if (endDate && value >= endDate) dateErrors.endDate = $0b3dcf1946308acd$var$endMinDateMessage;
            else if (endDate && dateErrors.endDate && dateErrors.endDate === $0b3dcf1946308acd$var$endMinDateMessage && value < endDate) dateErrors.endDate = null;
            if (renewalDate && renewalDate < value) dateErrors.renewalDate = $0b3dcf1946308acd$var$renewalMinDateMessage;
            else dateErrors.renewalDate = null;
            setFormErrors({
                ...formErrors,
                ...dateErrors
            });
        } else setFormErrors({
            ...formErrors,
            startDate: (0, $3wrhr.ErrorTexts).startDate
        });
        setStartDate(value);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        className: "centralize",
        sx: {
            width: "100%",
            paddingTop: "80px"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5DXc5.default), {
            width: "82%",
            headerText: "Details",
            additionalStyle: {
                height: "680px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        textAlign: "right",
                        width: "100%",
                        marginTop: "28px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                        id: "membership-details-edit-button",
                        onClick: handleEditPressed,
                        disabled: !canEdit || editable,
                        editButtonColor: !canEdit || editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        display: "grid",
                        gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
                        gap: "48px 100px",
                        paddingX: "20%",
                        paddingBottom: "210px",
                        gridAutoRows: "36px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $e4eIN.LocalizationProvider), {
                        dateAdapter: (0, $1Dn8S.AdapterDateFns),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "membership-details-name",
                                label: "Membership Name",
                                "data-testid": "membership-details-name-input-label",
                                value: name,
                                onChange: handleNameChange,
                                disabled: !editable || updateMembershipResult.loading,
                                errorMsg: formErrors.name,
                                additionalStyle: {
                                    gridColumn: "span 3"
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "membership-details-type-autocomplete",
                                "data-testid": "membership-details-type-autocomplete",
                                disabled: !editable || updateMembershipResult.loading,
                                label: "Type",
                                options: options || [],
                                getOptionLabel: (option)=>option?.membership_type?.name,
                                values: type,
                                onChange: handleMembershipTypeChange,
                                errorMsg: formErrors.type,
                                additionalStyle: {
                                    gridColumn: "span 2"
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "membership-details-price",
                                label: "Price",
                                value: type?.price ?? "",
                                disabled: true,
                                "data-testid": "membership-details-price-input-label",
                                additionalStyle: {
                                    gridColumn: "span 3"
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                id: "membership-details-start-date",
                                label: "Date Started",
                                disabled: !editable || updateMembershipResult.loading,
                                value: startDate,
                                onChange: handleStartDateChange,
                                minDate: $0b3dcf1946308acd$var$minDate,
                                errorMsg: formErrors.startDate,
                                sx: {
                                    gridColumn: "span 2"
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "membership-details-discount",
                                "data-testid": "membership-details-discount-input-label",
                                label: "Discount",
                                onChange: handleDiscountChange,
                                value: discount || "",
                                disabled: !editable || updateMembershipResult.loading,
                                additionalStyle: {
                                    gridColumn: "span 3"
                                },
                                errorMsg: formErrors.discount ?? undefined
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                id: "membership-details-renewal-date",
                                label: "Date Renewal",
                                value: renewalDate,
                                onChange: handleRenewalDateChange,
                                minDate: startDate || $0b3dcf1946308acd$var$minDate,
                                errorMsg: formErrors.renewalDate ?? undefined,
                                disabled: !editable || updateMembershipResult.loading,
                                sx: {
                                    gridColumn: "span 2"
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "membership-details-total",
                                "data-testid": "membership-details-total-input-label",
                                label: "Total",
                                value: getTotalCost(),
                                onChange: ()=>{},
                                disabled: true,
                                additionalStyle: {
                                    gridColumn: "span 3"
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                id: "membership-details-end-date",
                                label: "Date End",
                                value: endDate,
                                onChange: handleEndDateChange,
                                minDate: renewalDate ? renewalDate : startDate ? startDate : $0b3dcf1946308acd$var$minDate,
                                errorMsg: formErrors.endDate ?? undefined,
                                disabled: !editable || updateMembershipResult.loading,
                                sx: {
                                    gridColumn: "span 2"
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                sx: {
                                    gridColumn: "span 3"
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $fyVOI.default), {
                                    component: "fieldset",
                                    disabled: !editable || updateMembershipResult.loading,
                                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dNZ9A.default), {
                                        row: true,
                                        "aria-label": "position",
                                        name: "membreship-details-bad-debptor",
                                        "data-testid": "membership-details-bad-debptor",
                                        value: badDeptor,
                                        onChange: (e)=>setBadDeptor(e.currentTarget.value === "true"),
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $g7vB6.default), {
                                                "data-testid": "company-index",
                                                sx: {
                                                    marginTop: "13px",
                                                    marginRight: "40px",
                                                    color: editable ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray
                                                },
                                                component: "legend",
                                                children: "Bad Deptor"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bIyvl.default), {
                                                value: true,
                                                control: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1sQVT.default), {
                                                    color: "primary"
                                                }),
                                                label: "Yes",
                                                labelPlacement: "end"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bIyvl.default), {
                                                value: false,
                                                control: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1sQVT.default), {
                                                    color: "primary"
                                                }),
                                                label: "No",
                                                labelPlacement: "end"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                sx: {
                                    gridColumn: "span 2"
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                                    onClick: ()=>setOpenComments(true),
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $51oSn.default), {
                                            badgeContent: membership.comments_count,
                                            color: "primary",
                                            showZero: true,
                                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3vIfq.default), {
                                                style: {
                                                    color: (0, $6L9uu.Colors).skyBlue
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                            sx: {
                                                paddingLeft: "10%",
                                                color: (0, $6L9uu.Colors).main
                                            },
                                            children: "comments"
                                        })
                                    ]
                                })
                            }),
                            editable && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                                className: "centralize",
                                sx: {
                                    gridColumn: "span 5"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                                        id: "cancel-button",
                                        disabled: updateMembershipResult.loading,
                                        onClick: handleCancel,
                                        text: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                                        id: "save-button",
                                        disabled: updateMembershipResult.loading,
                                        onClick: submitForm,
                                        text: "Save"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                openComments && /*#__PURE__*/ (0, $ih19M.jsx)((0, $fAmb3.default), {
                    handleClose: ()=>setOpenComments(false),
                    membership: membership,
                    updateCommentsCount: updateCommentsCount
                })
            ]
        })
    });
};
var $0b3dcf1946308acd$export$2e2bcd8739ae039 = $0b3dcf1946308acd$var$MembershipDetailsTab;

});
parcelRegister("3vIfq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28e6970e4f62f426$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $28e6970e4f62f426$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4z"
}), "ModeComment");

});

parcelRegister("51oSn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a80579c9efedd58$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $aab6n = parcelRequire("aab6n");

var $7J7Kn = parcelRequire("7J7Kn");

var $kZ8ah = parcelRequire("kZ8ah");

var $7ITag = parcelRequire("7ITag");

var $6S0MN = parcelRequire("6S0MN");
var $g4l1t = parcelRequire("g4l1t");

var $fGH8N = parcelRequire("fGH8N");

var $1QllE = parcelRequire("1QllE");

var $ih19M = parcelRequire("ih19M");
"use client";
const $3a80579c9efedd58$var$_excluded = [
    "anchorOrigin",
    "className",
    "classes",
    "component",
    "components",
    "componentsProps",
    "children",
    "overlap",
    "color",
    "invisible",
    "max",
    "badgeContent",
    "slots",
    "slotProps",
    "showZero",
    "variant"
];
const $3a80579c9efedd58$var$RADIUS_STANDARD = 10;
const $3a80579c9efedd58$var$RADIUS_DOT = 4;
const $3a80579c9efedd58$var$useThemeProps = (0, $6S0MN.createUseThemeProps)("MuiBadge");
const $3a80579c9efedd58$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        badge: [
            "badge",
            variant,
            invisible && "invisible",
            `anchorOrigin${(0, $fGH8N.default)(anchorOrigin.vertical)}${(0, $fGH8N.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $fGH8N.default)(anchorOrigin.vertical)}${(0, $fGH8N.default)(anchorOrigin.horizontal)}${(0, $fGH8N.default)(overlap)}`,
            `overlap${(0, $fGH8N.default)(overlap)}`,
            color !== "default" && `color${(0, $fGH8N.default)(color)}`
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $1QllE.getBadgeUtilityClass), classes);
};
const $3a80579c9efedd58$var$BadgeRoot = (0, $g4l1t.default)("span", {
    name: "MuiBadge",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    position: "relative",
    display: "inline-flex",
    // For correct alignment with the text.
    verticalAlign: "middle",
    flexShrink: 0
});
const $3a80579c9efedd58$var$BadgeBadge = (0, $g4l1t.default)("span", {
    name: "MuiBadge",
    slot: "Badge",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $fGH8N.default)(ownerState.anchorOrigin.vertical)}${(0, $fGH8N.default)(ownerState.anchorOrigin.horizontal)}${(0, $fGH8N.default)(ownerState.overlap)}`],
            ownerState.color !== "default" && styles[`color${(0, $fGH8N.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars;
    return {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        position: "absolute",
        boxSizing: "border-box",
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $3a80579c9efedd58$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: "0 6px",
        height: $3a80579c9efedd58$var$RADIUS_STANDARD * 2,
        borderRadius: $3a80579c9efedd58$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter((key)=>{
                var _theme$vars2, _theme$vars3;
                return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main && ((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette[key].contrastText;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: "dot"
                },
                style: {
                    borderRadius: $3a80579c9efedd58$var$RADIUS_DOT,
                    height: $3a80579c9efedd58$var$RADIUS_DOT * 2,
                    minWidth: $3a80579c9efedd58$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "rectangular",
                style: {
                    top: 0,
                    right: 0,
                    transform: "scale(1) translate(50%, -50%)",
                    transformOrigin: "100% 0%",
                    [`&.${(0, $1QllE.default).invisible}`]: {
                        transform: "scale(0) translate(50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "rectangular",
                style: {
                    bottom: 0,
                    right: 0,
                    transform: "scale(1) translate(50%, 50%)",
                    transformOrigin: "100% 100%",
                    [`&.${(0, $1QllE.default).invisible}`]: {
                        transform: "scale(0) translate(50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "rectangular",
                style: {
                    top: 0,
                    left: 0,
                    transform: "scale(1) translate(-50%, -50%)",
                    transformOrigin: "0% 0%",
                    [`&.${(0, $1QllE.default).invisible}`]: {
                        transform: "scale(0) translate(-50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "rectangular",
                style: {
                    bottom: 0,
                    left: 0,
                    transform: "scale(1) translate(-50%, 50%)",
                    transformOrigin: "0% 100%",
                    [`&.${(0, $1QllE.default).invisible}`]: {
                        transform: "scale(0) translate(-50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "circular",
                style: {
                    top: "14%",
                    right: "14%",
                    transform: "scale(1) translate(50%, -50%)",
                    transformOrigin: "100% 0%",
                    [`&.${(0, $1QllE.default).invisible}`]: {
                        transform: "scale(0) translate(50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "circular",
                style: {
                    bottom: "14%",
                    right: "14%",
                    transform: "scale(1) translate(50%, 50%)",
                    transformOrigin: "100% 100%",
                    [`&.${(0, $1QllE.default).invisible}`]: {
                        transform: "scale(0) translate(50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "circular",
                style: {
                    top: "14%",
                    left: "14%",
                    transform: "scale(1) translate(-50%, -50%)",
                    transformOrigin: "0% 0%",
                    [`&.${(0, $1QllE.default).invisible}`]: {
                        transform: "scale(0) translate(-50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "circular",
                style: {
                    bottom: "14%",
                    left: "14%",
                    transform: "scale(1) translate(-50%, 50%)",
                    transformOrigin: "0% 100%",
                    [`&.${(0, $1QllE.default).invisible}`]: {
                        transform: "scale(0) translate(-50%, 50%)"
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create("transform", {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    };
});
const $3a80579c9efedd58$var$Badge = /*#__PURE__*/ $bh6RR.forwardRef(function Badge(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$badge, _slotProps$root, _slotProps$badge;
    const props = $3a80579c9efedd58$var$useThemeProps({
        props: inProps,
        name: "MuiBadge"
    });
    const { anchorOrigin: anchorOriginProp = {
        vertical: "top",
        horizontal: "right"
    }, className: className, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = "rectangular", color: colorProp = "default", invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = "standard" } = props, other = (0, $hCIyK.default)(props, $3a80579c9efedd58$var$_excluded);
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $kZ8ah.useBadge)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $aab6n.default)({
        anchorOrigin: anchorOriginProp,
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== "dot";
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOrigin = anchorOriginProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const displayValue = variant !== "dot" ? displayValueFromHook : undefined;
    const ownerState = (0, $4WYaH.default)({}, props, {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    });
    const classes = $3a80579c9efedd58$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $3a80579c9efedd58$var$BadgeRoot;
    const BadgeSlot = (_ref2 = (_slots$badge = slots == null ? void 0 : slots.badge) != null ? _slots$badge : components.Badge) != null ? _ref2 : $3a80579c9efedd58$var$BadgeBadge;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const badgeSlotProps = (_slotProps$badge = slotProps == null ? void 0 : slotProps.badge) != null ? _slotProps$badge : componentsProps.badge;
    const rootProps = (0, $7ITag.useSlotProps)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $aPsoC.default)(rootSlotProps == null ? void 0 : rootSlotProps.className, classes.root, className)
    });
    const badgeProps = (0, $7ITag.useSlotProps)({
        elementType: BadgeSlot,
        externalSlotProps: badgeSlotProps,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.badge, badgeSlotProps == null ? void 0 : badgeSlotProps.className)
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)(RootSlot, (0, $4WYaH.default)({}, rootProps, {
        children: [
            children,
            /*#__PURE__*/ (0, $ih19M.jsx)(BadgeSlot, (0, $4WYaH.default)({}, badgeProps, {
                children: displayValue
            }))
        ]
    }));
});
var $3a80579c9efedd58$export$2e2bcd8739ae039 = $3a80579c9efedd58$var$Badge;

});
parcelRegister("kZ8ah", function(module, exports) {

$parcel$export(module.exports, "useBadge", function () { return $f46fd6823d81c412$export$6105a25a68f1d9ae; });

var $aab6n = parcelRequire("aab6n");
"use client";
function $f46fd6823d81c412$export$6105a25a68f1d9ae(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $aab6n.default)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}

});

parcelRegister("6S0MN", function(module, exports) {

$parcel$export(module.exports, "createUseThemeProps", function () { return $500865549f8bb6d5$export$ff8356348e0cc878; });

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");
function $500865549f8bb6d5$export$ff8356348e0cc878(name) {
    return 0, $cNBED.default;
}

});

parcelRegister("1QllE", function(module, exports) {

$parcel$export(module.exports, "getBadgeUtilityClass", function () { return $157b35185c1dc5f9$export$aaccef17e6dab084; });
$parcel$export(module.exports, "default", function () { return $157b35185c1dc5f9$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $157b35185c1dc5f9$export$aaccef17e6dab084(slot) {
    return (0, $XybB6.default)("MuiBadge", slot);
}
const $157b35185c1dc5f9$var$badgeClasses = (0, $igcUF.default)("MuiBadge", [
    "root",
    "badge",
    "dot",
    "standard",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft",
    "invisible",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "overlapRectangular",
    "overlapCircular",
    // TODO: v6 remove the overlap value from these class keys
    "anchorOriginTopLeftCircular",
    "anchorOriginTopLeftRectangular",
    "anchorOriginTopRightCircular",
    "anchorOriginTopRightRectangular",
    "anchorOriginBottomLeftCircular",
    "anchorOriginBottomLeftRectangular",
    "anchorOriginBottomRightCircular",
    "anchorOriginBottomRightRectangular"
]);
var $157b35185c1dc5f9$export$2e2bcd8739ae039 = $157b35185c1dc5f9$var$badgeClasses;

});


parcelRegister("bIyvl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $887e91a26aeb59bc$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $7J7Kn = parcelRequire("7J7Kn");

var $djfcj = parcelRequire("djfcj");

var $60MWm = parcelRequire("60MWm");

var $aitry = parcelRequire("aitry");

var $fGH8N = parcelRequire("fGH8N");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $8yXhq = parcelRequire("8yXhq");

var $jjSic = parcelRequire("jjSic");

var $ih19M = parcelRequire("ih19M");
"use client";
const $887e91a26aeb59bc$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $887e91a26aeb59bc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, $fGH8N.default)(labelPlacement)}`,
            error && "error",
            required && "required"
        ],
        label: [
            "label",
            disabled && "disabled"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $8yXhq.getFormControlLabelUtilityClasses), classes);
};
const $887e91a26aeb59bc$export$1b479270917a5676 = (0, $g4l1t.default)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $8yXhq.default).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $fGH8N.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $8yXhq.default).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.labelPlacement === "start" && {
        flexDirection: "row-reverse",
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === "top" && {
        flexDirection: "column-reverse",
        marginLeft: 16
    }, ownerState.labelPlacement === "bottom" && {
        flexDirection: "column",
        marginLeft: 16
    }, {
        [`& .${(0, $8yXhq.default).label}`]: {
            [`&.${(0, $8yXhq.default).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $887e91a26aeb59bc$var$AsteriskComponent = (0, $g4l1t.default)("span", {
    name: "MuiFormControlLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $8yXhq.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $887e91a26aeb59bc$var$FormControlLabel = /*#__PURE__*/ $bh6RR.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = "end", required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $hCIyK.default)(props, $887e91a26aeb59bc$var$_excluded);
    const muiFormControl = (0, $djfcj.default)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, $jjSic.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $4WYaH.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $887e91a26aeb59bc$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $aitry.default) && !disableTypography) label = /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), (0, $4WYaH.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $aPsoC.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $ih19M.jsxs)($887e91a26aeb59bc$export$1b479270917a5676, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $bh6RR.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $60MWm.default), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $ih19M.jsxs)($887e91a26aeb59bc$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            "*"
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $887e91a26aeb59bc$export$2e2bcd8739ae039 = $887e91a26aeb59bc$var$FormControlLabel;

});
parcelRegister("60MWm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4608b4aece268e2a$export$2e2bcd8739ae039; });


var $aRCSC = parcelRequire("aRCSC");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");
"use client";
const $4608b4aece268e2a$var$Stack = (0, $aRCSC.default)({
    createStyledComponent: (0, $g4l1t.default)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $cNBED.default)({
            props: inProps,
            name: "MuiStack"
        })
});
var $4608b4aece268e2a$export$2e2bcd8739ae039 = $4608b4aece268e2a$var$Stack;

});
parcelRegister("aRCSC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e8d036039a387ac$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $cseKH = parcelRequire("cseKH");

var $XybB6 = parcelRequire("XybB6");

var $7J7Kn = parcelRequire("7J7Kn");

var $kjJAC = parcelRequire("kjJAC");

var $2DXvq = parcelRequire("2DXvq");

var $gIHYf = parcelRequire("gIHYf");

var $1zcRx = parcelRequire("1zcRx");

var $eP4dZ = parcelRequire("eP4dZ");

var $lqJyU = parcelRequire("lqJyU");

var $ih19M = parcelRequire("ih19M");
const $7e8d036039a387ac$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $7e8d036039a387ac$var$defaultTheme = (0, $1zcRx.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $7e8d036039a387ac$var$defaultCreateStyledComponent = (0, $kjJAC.default)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $7e8d036039a387ac$var$useThemePropsDefault(props) {
    return (0, $2DXvq.default)({
        props: props,
        name: "MuiStack",
        defaultTheme: $7e8d036039a387ac$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $7e8d036039a387ac$var$joinChildren(children, separator) {
    const childrenArray = $bh6RR.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $bh6RR.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $7e8d036039a387ac$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $7e8d036039a387ac$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $4WYaH.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $eP4dZ.handleBreakpoints)({
        theme: theme
    }, (0, $eP4dZ.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $lqJyU.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $eP4dZ.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $eP4dZ.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $lqJyU.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                "& > :not(style):not(style)": {
                    margin: 0
                },
                "& > :not(style) ~ :not(style)": {
                    [`margin${$7e8d036039a387ac$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $lqJyU.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $cseKH.default)(styles, (0, $eP4dZ.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $eP4dZ.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $7e8d036039a387ac$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $7e8d036039a387ac$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $7e8d036039a387ac$var$useThemePropsDefault, componentName: componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $7J7Kn.default)(slots, (slot)=>(0, $XybB6.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($7e8d036039a387ac$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $bh6RR.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $gIHYf.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $hCIyK.default)(props, $7e8d036039a387ac$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ih19M.jsx)(StackRoot, (0, $4WYaH.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $aPsoC.default)(classes.root, className)
        }, other, {
            children: divider ? $7e8d036039a387ac$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}

});
parcelRegister("kjJAC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eca8f224892218e4$export$2e2bcd8739ae039; });

var $kX6Uk = parcelRequire("kX6Uk");
const $eca8f224892218e4$var$styled = (0, $kX6Uk.default)();
var $eca8f224892218e4$export$2e2bcd8739ae039 = $eca8f224892218e4$var$styled;

});
parcelRegister("kX6Uk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f40ead0023894a05$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $8BdII = parcelRequire("8BdII");

var $cseKH = parcelRequire("cseKH");



var $1zcRx = parcelRequire("1zcRx");

var $f9NmP = parcelRequire("f9NmP");
const $f40ead0023894a05$var$_excluded = [
    "ownerState"
], $f40ead0023894a05$var$_excluded2 = [
    "variants"
], $f40ead0023894a05$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $f40ead0023894a05$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $f40ead0023894a05$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $f40ead0023894a05$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $f40ead0023894a05$export$35e57303dbd8a66 = (0, $1zcRx.default)();
const $f40ead0023894a05$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $f40ead0023894a05$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $f40ead0023894a05$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $f40ead0023894a05$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $f40ead0023894a05$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $hCIyK.default)(_ref, $f40ead0023894a05$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $4WYaH.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$f40ead0023894a05$var$processStyleArg(resolvedStyle, (0, $4WYaH.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $hCIyK.default)(resolvedStylesArg, $f40ead0023894a05$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $4WYaH.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $4WYaH.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $f40ead0023894a05$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $f40ead0023894a05$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $f40ead0023894a05$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $f40ead0023894a05$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $f9NmP.default)((0, $4WYaH.default)({}, props, {
            theme: $f40ead0023894a05$var$resolveTheme((0, $4WYaH.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $8BdII.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $f40ead0023894a05$var$defaultOverridesResolver($f40ead0023894a05$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $hCIyK.default)(inputOptions, $f40ead0023894a05$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $f40ead0023894a05$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($f40ead0023894a05$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $8BdII.default)(tag, (0, $4WYaH.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $cseKH.isPlainObject)(stylesArg)) return (props)=>$f40ead0023894a05$var$processStyleArg(stylesArg, (0, $4WYaH.default)({}, props, {
                    theme: $f40ead0023894a05$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $f40ead0023894a05$var$resolveTheme((0, $4WYaH.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $f40ead0023894a05$var$processStyleArg(slotStyle, (0, $4WYaH.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $f40ead0023894a05$var$resolveTheme((0, $4WYaH.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $f40ead0023894a05$var$processStyleArg({
                    variants: themeVariants
                }, (0, $4WYaH.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});




parcelRegister("8yXhq", function(module, exports) {

$parcel$export(module.exports, "getFormControlLabelUtilityClasses", function () { return $63bf7b7f96992216$export$717666c39ec07e12; });
$parcel$export(module.exports, "default", function () { return $63bf7b7f96992216$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $63bf7b7f96992216$export$717666c39ec07e12(slot) {
    return (0, $XybB6.default)("MuiFormControlLabel", slot);
}
const $63bf7b7f96992216$var$formControlLabelClasses = (0, $igcUF.default)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error",
    "required",
    "asterisk"
]);
var $63bf7b7f96992216$export$2e2bcd8739ae039 = $63bf7b7f96992216$var$formControlLabelClasses;

});


parcelRegister("1sQVT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $111177567904bb83$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $7J7Kn = parcelRequire("7J7Kn");

var $cG3EF = parcelRequire("cG3EF");

var $jcZYJ = parcelRequire("jcZYJ");

var $cNBED = parcelRequire("cNBED");

var $f98Zf = parcelRequire("f98Zf");

var $fGH8N = parcelRequire("fGH8N");

var $joVbN = parcelRequire("joVbN");

var $j75HX = parcelRequire("j75HX");

var $1367q = parcelRequire("1367q");

var $g4l1t = parcelRequire("g4l1t");

var $ih19M = parcelRequire("ih19M");
"use client";
const $111177567904bb83$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size",
    "className"
];
const $111177567904bb83$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $fGH8N.default)(color)}`,
            size !== "medium" && `size${(0, $fGH8N.default)(size)}`
        ]
    };
    return (0, $4WYaH.default)({}, classes, (0, $7J7Kn.default)(slots, (0, $1367q.getRadioUtilityClass), classes));
};
const $111177567904bb83$var$RadioRoot = (0, $g4l1t.default)((0, $jcZYJ.default), {
    shouldForwardProp: (prop)=>(0, $g4l1t.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiRadio",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== "medium" && styles[`size${(0, $fGH8N.default)(ownerState.size)}`],
            styles[`color${(0, $fGH8N.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cG3EF.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $1367q.default).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $1367q.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function $111177567904bb83$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $111177567904bb83$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ih19M.jsx)((0, $f98Zf.default), {
    checked: true
});
const $111177567904bb83$var$defaultIcon = /*#__PURE__*/ (0, $ih19M.jsx)((0, $f98Zf.default), {});
const $111177567904bb83$var$Radio = /*#__PURE__*/ $bh6RR.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiRadio"
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $111177567904bb83$var$defaultCheckedIcon, color: color = "primary", icon: icon = $111177567904bb83$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = "medium", className: className } = props, other = (0, $hCIyK.default)(props, $111177567904bb83$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $111177567904bb83$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $j75HX.default)();
    let checked = checkedProp;
    const onChange = (0, $joVbN.default)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === "undefined") checked = $111177567904bb83$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === "undefined") name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $ih19M.jsx)($111177567904bb83$var$RadioRoot, (0, $4WYaH.default)({
        type: "radio",
        icon: /*#__PURE__*/ $bh6RR.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $111177567904bb83$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $bh6RR.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $111177567904bb83$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $aPsoC.default)(classes.root, className)
    }, other));
});
var $111177567904bb83$export$2e2bcd8739ae039 = $111177567904bb83$var$Radio;

});
parcelRegister("f98Zf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b06eaadfa10a15c7$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");
parcelRequire("bh6RR");


var $cKKqy = parcelRequire("cKKqy");

var $klqIH = parcelRequire("klqIH");

var $g4l1t = parcelRequire("g4l1t");

var $ih19M = parcelRequire("ih19M");
"use client";
const $b06eaadfa10a15c7$var$RadioButtonIconRoot = (0, $g4l1t.default)("span", {
    shouldForwardProp: (0, $g4l1t.rootShouldForwardProp)
})({
    position: "relative",
    display: "flex"
});
const $b06eaadfa10a15c7$var$RadioButtonIconBackground = (0, $g4l1t.default)((0, $cKKqy.default))({
    // Scale applied to prevent dot misalignment in Safari
    transform: "scale(1)"
});
const $b06eaadfa10a15c7$var$RadioButtonIconDot = (0, $g4l1t.default)((0, $klqIH.default))(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        left: 0,
        position: "absolute",
        transform: "scale(0)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: "scale(1)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $b06eaadfa10a15c7$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $4WYaH.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)($b06eaadfa10a15c7$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($b06eaadfa10a15c7$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)($b06eaadfa10a15c7$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $b06eaadfa10a15c7$export$2e2bcd8739ae039 = $b06eaadfa10a15c7$var$RadioButtonIcon;

});
parcelRegister("cKKqy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $948dcb6cc7c1947a$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $948dcb6cc7c1947a$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked");

});

parcelRegister("klqIH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecfa7ed8ea26fd86$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $ecfa7ed8ea26fd86$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked");

});


parcelRegister("joVbN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1fc9ecc9d54fedd$export$2e2bcd8739ae039; });

var $keUKf = parcelRequire("keUKf");
var $e1fc9ecc9d54fedd$export$2e2bcd8739ae039 = (0, $keUKf.default);

});

parcelRegister("j75HX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dea31942ba4e69ee$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $4ykRs = parcelRequire("4ykRs");
"use client";
function $dea31942ba4e69ee$export$2e2bcd8739ae039() {
    return $bh6RR.useContext((0, $4ykRs.default));
}

});
parcelRegister("4ykRs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $350a84fd7edaa65d$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
/**
 * @ignore - internal component.
 */ const $350a84fd7edaa65d$var$RadioGroupContext = /*#__PURE__*/ $bh6RR.createContext(undefined);
var $350a84fd7edaa65d$export$2e2bcd8739ae039 = $350a84fd7edaa65d$var$RadioGroupContext;

});


parcelRegister("1367q", function(module, exports) {

$parcel$export(module.exports, "getRadioUtilityClass", function () { return $0c3ad14f8b4f8687$export$192f7b2363c77155; });
$parcel$export(module.exports, "default", function () { return $0c3ad14f8b4f8687$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $0c3ad14f8b4f8687$export$192f7b2363c77155(slot) {
    return (0, $XybB6.default)("MuiRadio", slot);
}
const $0c3ad14f8b4f8687$var$radioClasses = (0, $igcUF.default)("MuiRadio", [
    "root",
    "checked",
    "disabled",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall"
]);
var $0c3ad14f8b4f8687$export$2e2bcd8739ae039 = $0c3ad14f8b4f8687$var$radioClasses;

});


parcelRegister("dNZ9A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0cf49cef29ce75c$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $ghoWy = parcelRequire("ghoWy");

var $erAkb = parcelRequire("erAkb");

var $82V4F = parcelRequire("82V4F");

var $4ykRs = parcelRequire("4ykRs");

var $5R8eh = parcelRequire("5R8eh");

var $ih19M = parcelRequire("ih19M");
"use client";
const $a0cf49cef29ce75c$var$_excluded = [
    "actions",
    "children",
    "defaultValue",
    "name",
    "onChange",
    "value"
];
const $a0cf49cef29ce75c$var$RadioGroup = /*#__PURE__*/ $bh6RR.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp } = props, other = (0, $hCIyK.default)(props, $a0cf49cef29ce75c$var$_excluded);
    const rootRef = $bh6RR.useRef(null);
    const [value, setValueState] = (0, $82V4F.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "RadioGroup"
    });
    $bh6RR.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector("input:not(:disabled):checked");
                if (!input) input = rootRef.current.querySelector("input:not(:disabled)");
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $erAkb.default)(ref, rootRef);
    const name = (0, $5R8eh.default)(nameProp);
    const contextValue = $bh6RR.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $4ykRs.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ghoWy.default), (0, $4WYaH.default)({
            role: "radiogroup",
            ref: handleRef
        }, other, {
            children: children
        }))
    });
});
var $a0cf49cef29ce75c$export$2e2bcd8739ae039 = $a0cf49cef29ce75c$var$RadioGroup;

});
parcelRegister("ghoWy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bda1951e06fd3fd5$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $f09VE = parcelRequire("f09VE");

var $djfcj = parcelRequire("djfcj");

var $jjSic = parcelRequire("jjSic");

var $ih19M = parcelRequire("ih19M");
"use client";
const $bda1951e06fd3fd5$var$_excluded = [
    "className",
    "row"
];
const $bda1951e06fd3fd5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            row && "row",
            error && "error"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $f09VE.getFormGroupUtilityClass), classes);
};
const $bda1951e06fd3fd5$var$FormGroupRoot = (0, $g4l1t.default)("div", {
    name: "MuiFormGroup",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap"
    }, ownerState.row && {
        flexDirection: "row"
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $bda1951e06fd3fd5$var$FormGroup = /*#__PURE__*/ $bh6RR.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiFormGroup"
    });
    const { className: className, row: row = false } = props, other = (0, $hCIyK.default)(props, $bda1951e06fd3fd5$var$_excluded);
    const muiFormControl = (0, $djfcj.default)();
    const fcs = (0, $jjSic.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $4WYaH.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $bda1951e06fd3fd5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($bda1951e06fd3fd5$var$FormGroupRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $bda1951e06fd3fd5$export$2e2bcd8739ae039 = $bda1951e06fd3fd5$var$FormGroup;

});
parcelRegister("f09VE", function(module, exports) {

$parcel$export(module.exports, "getFormGroupUtilityClass", function () { return $aebe8ec7f199cee3$export$d72d4cbdc30b331f; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $aebe8ec7f199cee3$export$d72d4cbdc30b331f(slot) {
    return (0, $XybB6.default)("MuiFormGroup", slot);
}
const $aebe8ec7f199cee3$var$formGroupClasses = (0, $igcUF.default)("MuiFormGroup", [
    "root",
    "row",
    "error"
]);
var $aebe8ec7f199cee3$export$2e2bcd8739ae039 = $aebe8ec7f199cee3$var$formGroupClasses;

});



parcelRegister("3wrhr", function(module, exports) {

$parcel$export(module.exports, "ErrorTexts", function () { return $732578f1f3e393af$export$1067ba46601ca091; });
$parcel$export(module.exports, "default", function () { return $732578f1f3e393af$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $gFVvY = parcelRequire("gFVvY");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");

var $ehzwo = parcelRequire("ehzwo");

var $91340 = parcelRequire("91340");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $bilGR = parcelRequire("bilGR");
const $732578f1f3e393af$export$1067ba46601ca091 = {
    name: "Name is required",
    nameExists: "Name already exists",
    type: "Type is required",
    discount: "Discount should be bigger than 0",
    startDate: "Start date is required",
    startDateInvalidDate: "Invalid Date Format",
    renewalDateBeforeMin: "Renewal date should not be before start date",
    endDateBeforeMin: "End date should not be before start date"
};
const $732578f1f3e393af$var$defaultErrorsObj = {
    name: null,
    type: null,
    discount: null,
    startDate: null,
    renewalDate: null,
    endDate: null
};
const $732578f1f3e393af$var$minAllowedDate = new Date(2000, 0, 1);
const $732578f1f3e393af$var$NewMembership = ({ handleClose: handleClose })=>{
    const membershipProducts = (0, $hjfla.useMembershipProductsQuery)();
    const [name, setName] = (0, $bh6RR.useState)("");
    const [membershipType, setMembershipType] = (0, $bh6RR.useState)(null);
    const [discount, setDiscount] = (0, $bh6RR.useState)("");
    const [startDate, setStartDate] = (0, $bh6RR.useState)(null);
    const [renewalDate, setRenewalDate] = (0, $bh6RR.useState)(null);
    const [endDate, setEndDate] = (0, $bh6RR.useState)(null);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($732578f1f3e393af$var$defaultErrorsObj);
    const [createMembership, createMembershipResult] = (0, $hjfla.useCreateMembershipMutation)();
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const handleNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!value || value.length < 2) setFormErrors({
            ...formErrors,
            name: $732578f1f3e393af$export$1067ba46601ca091.name
        });
        else setFormErrors({
            ...formErrors,
            name: null
        });
        setName(value);
    };
    const handleMembershipTypeChange = (_, newValue)=>{
        setDiscount("");
        if (newValue) {
            const product = newValue;
            $732578f1f3e393af$export$1067ba46601ca091.discount = `Discount should be between 0 and ${product.price}`;
            setFormErrors({
                ...formErrors,
                type: null,
                discount: null
            });
        } else {
            $732578f1f3e393af$export$1067ba46601ca091.discount = `Discount should be bigger than 0`;
            setFormErrors({
                ...formErrors,
                type: $732578f1f3e393af$export$1067ba46601ca091.type,
                discount: null
            });
        }
        setMembershipType(newValue);
    };
    const handleDiscountChange = (event)=>{
        const { value: value } = event.currentTarget;
        const productPrice = membershipType?.price;
        if (value && (Number(value) < 0 || Number(value) > productPrice)) setFormErrors({
            ...formErrors,
            discount: $732578f1f3e393af$export$1067ba46601ca091.discount
        });
        else setFormErrors({
            ...formErrors,
            discount: null
        });
        setDiscount(value);
    };
    const getTotalCost = ()=>{
        return membershipType ? (membershipType.price - Number(discount)).toString() : "";
    };
    const handleStartDateChange = (value)=>{
        if (value) {
            let errorDto = {
                ...formErrors,
                startDate: null
            };
            if (renewalDate) {
                if (value >= renewalDate) errorDto = {
                    ...errorDto,
                    renewalDate: $732578f1f3e393af$export$1067ba46601ca091.renewalDateBeforeMin
                };
            }
            if (endDate) {
                if (value >= endDate) errorDto = {
                    ...errorDto,
                    endDate: $732578f1f3e393af$export$1067ba46601ca091.endDateBeforeMin
                };
            }
            setFormErrors(errorDto);
        } else setFormErrors({
            ...formErrors,
            startDate: $732578f1f3e393af$export$1067ba46601ca091.startDate
        });
        setStartDate(value);
    };
    const handleRenewalDateChange = (value)=>{
        let errorDbo = {
            ...formErrors
        };
        if (value) {
            if (startDate && value >= startDate) errorDbo = {
                ...errorDbo,
                renewalDate: null
            };
            if (endDate && value > endDate) {
                const newEndDateErrorMsg = `End date should not be before renewal date`;
                errorDbo = {
                    ...errorDbo,
                    endDate: newEndDateErrorMsg
                };
            }
        } else errorDbo = {
            ...errorDbo,
            renewalDate: null
        };
        setFormErrors(errorDbo);
        setRenewalDate(value);
    };
    const handleEndDateChange = (value)=>{
        if (value) {
            if (renewalDate) {
                if (value >= renewalDate) setFormErrors({
                    ...formErrors,
                    endDate: null
                });
            } else {
                if (startDate) {
                    if (value >= startDate) setFormErrors({
                        ...formErrors,
                        endDate: null
                    });
                } else setFormErrors({
                    ...formErrors,
                    endDate: null
                });
            }
        }
        setEndDate(value);
    };
    const submitForm = ()=>{
        const errors = {
            name: null,
            type: null,
            discount: null,
            startDate: null
        };
        let hasErrors = false;
        if (!name || name.length < 2) {
            hasErrors = true;
            errors.name = $732578f1f3e393af$export$1067ba46601ca091.name;
        }
        if (!membershipType) {
            hasErrors = true;
            errors.type = $732578f1f3e393af$export$1067ba46601ca091.type;
        }
        const productPrice = membershipType?.price;
        if (discount && (Number(discount) < 0 || Number(discount) > productPrice)) {
            hasErrors = true;
            errors.discount = $732578f1f3e393af$export$1067ba46601ca091.discount;
        }
        if (!startDate) {
            hasErrors = true;
            errors.startDate = $732578f1f3e393af$export$1067ba46601ca091.startDate;
        } else if (!Date.parse(startDate.toString())) {
            hasErrors = true;
            errors.startDate = $732578f1f3e393af$export$1067ba46601ca091.startDateInvalidDate;
        }
        if (renewalDate) {
            if (Date.parse(renewalDate.toString())) {
                if (startDate) {
                    if (startDate > renewalDate) hasErrors = true;
                }
            } else hasErrors = true;
        }
        if (endDate) {
            if (Date.parse(endDate.toString())) {
                if (renewalDate) {
                    if (renewalDate > endDate) hasErrors = true;
                } else {
                    if (startDate) {
                        if (startDate > endDate) hasErrors = true;
                    }
                }
            } else hasErrors = true;
        }
        if (!hasErrors && (0, $gFVvY.sameMembershipNameExist)(name)) {
            hasErrors = true;
            errors.name = $732578f1f3e393af$export$1067ba46601ca091.nameExists;
        }
        if (hasErrors) setFormErrors(errors);
        else submitMembership();
    };
    const submitMembership = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        const input = {
            name: name.trim(),
            product_id: parseInt(membershipType?.id),
            start_date: startDate ? startDate.toString() : "",
            end_date: endDate ? endDate.toString() : "",
            renewable_date: renewalDate ? renewalDate.toString() : "",
            discount: discount ? parseFloat(discount) : null,
            total: parseFloat(getTotalCost())
        };
        createMembership({
            variables: {
                input: input
            },
            update (_, { data: data }) {
                if (data?.result) {
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            text: `Membership ${data.result.name} created`,
                            severity: "success",
                            autoHide: 2000
                        }
                    });
                    handleClose();
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5PJ2i.default), {
        id: "new-membership",
        width: 880,
        title: "Create Membership",
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                display: "grid",
                gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                gap: "40px 22px",
                padding: "50px 210px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                    id: "new-membership-name",
                    label: "Name",
                    value: name,
                    onChange: handleNameChange,
                    errorMsg: formErrors.name,
                    disabled: createMembershipResult.loading,
                    additionalStyle: {
                        gridColumn: "span 3",
                        marginTop: "50px"
                    }
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                    id: "new-membership-type",
                    label: "Type",
                    options: membershipProducts.data?.result || [],
                    disabled: createMembershipResult.loading,
                    values: membershipType,
                    onChange: handleMembershipTypeChange,
                    getOptionLabel: (option)=>option?.membership_type?.name,
                    errorMsg: formErrors.type,
                    additionalStyle: {
                        gridColumn: "span 3"
                    }
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                    id: "new-membership-price",
                    label: "Price",
                    value: membershipType ? membershipType.price : "",
                    disabled: true
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                    id: "new-membership-discount",
                    type: "number",
                    label: "Discount",
                    value: discount,
                    onChange: handleDiscountChange,
                    errorMsg: formErrors.discount,
                    disabled: createMembershipResult.loading
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                    id: "new-membership-total-cost",
                    label: "Total Cost",
                    value: getTotalCost(),
                    disabled: true
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $e4eIN.LocalizationProvider), {
                    dateAdapter: (0, $1Dn8S.AdapterDateFns),
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                            id: "new-membership-renewal-date",
                            label: "Start",
                            value: startDate,
                            onChange: handleStartDateChange,
                            errorMsg: formErrors.startDate,
                            minDate: $732578f1f3e393af$var$minAllowedDate,
                            disabled: createMembershipResult.loading
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                            id: "new-membership-start-date",
                            label: "Renewal",
                            value: renewalDate,
                            onChange: handleRenewalDateChange,
                            minDate: startDate ?? undefined,
                            errorMsg: formErrors.renewalDate ?? undefined,
                            disabled: createMembershipResult.loading
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                            id: "new-membership-end-date",
                            label: "End",
                            value: endDate,
                            onChange: handleEndDateChange,
                            minDate: (renewalDate ? Date.parse(renewalDate.toString()) ? renewalDate : startDate : startDate) ?? undefined,
                            errorMsg: formErrors.endDate ?? undefined,
                            disabled: createMembershipResult.loading
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize",
                    sx: {
                        gridColumn: "span 3",
                        marginTop: "100px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                            id: "cancel-new-membership-button",
                            disabled: createMembershipResult.loading,
                            onClick: handleClose,
                            text: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                            id: "create-new-membership-button",
                            disabled: createMembershipResult.loading,
                            onClick: submitForm,
                            text: "Create"
                        })
                    ]
                })
            ]
        })
    });
};
var $732578f1f3e393af$export$2e2bcd8739ae039 = $732578f1f3e393af$var$NewMembership;

});

parcelRegister("fAmb3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa82c702d3b4b194$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $9Fskr = parcelRequire("9Fskr");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hjfla = parcelRequire("hjfla");

var $gFVvY = parcelRequire("gFVvY");

var $6L9uu = parcelRequire("6L9uu");

var $lC4lc = parcelRequire("lC4lc");
var $7opAt = parcelRequire("7opAt");
var $fl7Qe = parcelRequire("fl7Qe");
var $8ECDX = parcelRequire("8ECDX");
var $3q83T = parcelRequire("3q83T");
var $i04rf = parcelRequire("i04rf");
var $5LQ5V = parcelRequire("5LQ5V");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $8lfqJ = parcelRequire("8lfqJ");
const $fa82c702d3b4b194$var$commentsPerPage = 4;
const $fa82c702d3b4b194$var$CommentsList = ({ handleClose: handleClose, membership: membership, updateCommentsCount: updateCommentsCount })=>{
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const { data: data, loading: loading } = (0, $hjfla.useMembershipCommentsQuery)({
        variables: {
            membership_id: parseInt(membership?.id)
        },
        fetchPolicy: "no-cache"
    });
    const [addComment, addCommentResult] = (0, $hjfla.useAddCommentMutation)();
    const [deleteComment] = (0, $hjfla.useDeleteCommentMutation)();
    const [commentsCount, setCommentsCount] = (0, $bh6RR.useState)(membership?.comments_count);
    const [newComment, setNewComment] = (0, $bh6RR.useState)("");
    const [comments, setComments] = (0, $bh6RR.useState)([]);
    const [pageComments, setPageComments] = (0, $bh6RR.useState)([]);
    const [pages, setPages] = (0, $bh6RR.useState)(0);
    const [currentPage, setCurrentPage] = (0, $bh6RR.useState)(1);
    const isLoading = loading || addCommentResult.loading;
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            const comments = data.result;
            setComments(comments);
            setPages(comments.length > $fa82c702d3b4b194$var$commentsPerPage ? Math.ceil(comments.length / $fa82c702d3b4b194$var$commentsPerPage) : 0);
            setPageComments(comments.slice(0, $fa82c702d3b4b194$var$commentsPerPage));
        }
    }, [
        data?.result
    ]);
    const handleKeyPressed = (event)=>{
        if (event.key === "Enter") {
            event.preventDefault();
            if (event.shiftKey) setNewComment(newComment + "\n");
            else addNewComment();
        }
    };
    const handlePageChange = (_, value)=>{
        const start = (value - 1) * $fa82c702d3b4b194$var$commentsPerPage;
        setPageComments(comments.slice(start, start + $fa82c702d3b4b194$var$commentsPerPage));
        setCurrentPage(value);
    };
    const handleRemove = (comment)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete the following comment: ${comment.text}`,
                agreeAction: removeComment,
                params: comment
            }
        });
    };
    const removeComment = (comment)=>{
        deleteComment({
            variables: {
                id: parseInt(comment.id),
                membership_id: parseInt(membership?.id)
            },
            update (_, { data: data }) {
                if (data?.result) {
                    (0, $gFVvY.updateMembershipInCache)(data.result);
                    updateComments(comment, false);
                    if (updateCommentsCount) updateCommentsCount(true);
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `Deleted ${comment.text} comment`,
                            autoHide: 3000
                        }
                    });
                }
            }
        }).catch((error)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            }));
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
    };
    const addNewComment = ()=>{
        if (newComment.trim().length === 0) {
            setNewComment("");
            return;
        }
        addComment({
            variables: {
                membership_id: parseInt(membership?.id),
                text: newComment
            },
            update (_, { data: data }) {
                if (data?.result) {
                    (0, $gFVvY.updateMembershipInCache)(data.result.membership);
                    updateComments(data.result.comment, true);
                    setNewComment("");
                    if (updateCommentsCount) updateCommentsCount(false);
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `Comment ${data.result.comment.text} added`
                        }
                    });
                }
            }
        }).catch((error)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            });
        });
    };
    const updateComments = (comment, isNew)=>{
        const newCommentsList = isNew ? [
            comment,
            ...comments
        ] : comments.filter((c)=>c.id !== comment.id);
        const pageCount = newCommentsList.length <= $fa82c702d3b4b194$var$commentsPerPage ? 0 : Math.ceil(newCommentsList.length / $fa82c702d3b4b194$var$commentsPerPage);
        const newCurrentPage = pageCount === 0 ? 1 : currentPage > pageCount ? currentPage - 1 : currentPage;
        setComments(newCommentsList);
        setCommentsCount(newCommentsList.length);
        const start = (newCurrentPage - 1) * $fa82c702d3b4b194$var$commentsPerPage;
        setPageComments(newCommentsList.slice(start, start + $fa82c702d3b4b194$var$commentsPerPage));
        setPages(pageCount);
        setCurrentPage(newCurrentPage);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $7opAt.default), {
        id: "comment-dialog",
        open: true,
        sx: {
            "& .MuiDialog-container": {
                alignItems: "center",
                display: "flex"
            }
        },
        PaperProps: {
            sx: {
                m: 0,
                maxWidth: "600px",
                width: "600px",
                height: "92.6%"
            }
        },
        BackdropProps: {
            sx: {
                background: (0, $6L9uu.Colors).modalBackground
            }
        },
        onClose: handleClose,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $3q83T.default), {
                id: "comment-title",
                style: {
                    borderBottom: "1px solid " + (0, $6L9uu.Colors).skyBlue,
                    textAlign: "center",
                    paddingTop: "7px",
                    paddingBottom: "21px",
                    height: "50px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9Fskr.default), {
                    id: "comment-count",
                    "data-testid": "comment-count",
                    component: "span",
                    sx: {
                        margin: "auto",
                        color: (0, $6L9uu.Colors).skyBlue,
                        letterSpacing: "-0.01px",
                        fontSize: "22px",
                        fontWeight: "bold"
                    },
                    children: [
                        "Comments (",
                        commentsCount,
                        ")"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $3q83T.default), {
                id: "comment-dialog-title",
                style: {
                    backgroundColor: "#F4F9FE",
                    textAlign: "center",
                    paddingTop: "8px",
                    paddingBottom: "13px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9Fskr.default), {
                    id: "comment-membership-name",
                    "data-testid": "comment-membership-name",
                    component: "span",
                    sx: {
                        margin: "auto",
                        color: (0, $6L9uu.Colors).main,
                        letterSpacing: "-0.01px",
                        fontSize: "16px",
                        fontWeight: "bold"
                    },
                    children: membership?.name
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8ECDX.default), {
                sx: {
                    padding: 0
                },
                children: isLoading ? /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lC4lc.default), {})
                }) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9Fskr.default), {
                    sx: {
                        display: "grid",
                        gridTemplateColumns: "repeat(1, minmax(0, 1fr))"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $9Fskr.default), {
                            sx: {
                                padding: "5% 6.66%"
                            },
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5LQ5V.default), {
                                id: "comments-new-comment",
                                label: "Write a comment",
                                name: "comments-new-comment",
                                variant: "standard",
                                value: newComment,
                                onChange: (e)=>setNewComment(e.currentTarget.value),
                                multiline: true,
                                rows: 5,
                                fullWidth: true,
                                onKeyPress: handleKeyPressed,
                                InputLabelProps: {
                                    style: {
                                        color: (0, $6L9uu.Colors).main
                                    }
                                },
                                inputProps: {
                                    style: {
                                        color: (0, $6L9uu.Colors).main
                                    },
                                    "data-testid": "comments-new-comment-input-field"
                                },
                                disabled: isLoading
                            })
                        }),
                        pageComments.map((comment, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $9Fskr.default), {
                                sx: {
                                    borderTop: index === 0 ? "1px solid #6CA6F2" : "",
                                    borderBottom: "1px solid #6CA6F2",
                                    backgroundColor: index % 2 === 0 ? "#F4F9FE" : "white"
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8lfqJ.default), {
                                    comment: comment,
                                    remove: handleRemove,
                                    index: index + 1
                                })
                            }))
                    ]
                })
            }),
            pages > 0 && /*#__PURE__*/ (0, $ih19M.jsx)((0, $fl7Qe.default), {
                sx: {
                    justifyContent: "start"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $i04rf.default), {
                    id: "comment-pagination",
                    "data-testid": "comment-pagination",
                    count: pages,
                    page: currentPage,
                    onChange: handlePageChange,
                    color: "primary",
                    disabled: isLoading
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $fl7Qe.default), {
                sx: {
                    marginBottom: "30px",
                    justifyContent: "center",
                    gap: "20px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-comment-button",
                        "data-testid": "cancel-comment-button",
                        onClick: handleClose,
                        disabled: isLoading,
                        text: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "save-comment-button",
                        "data-testid": "save-comment-button",
                        onClick: addNewComment,
                        disabled: isLoading,
                        text: "Save"
                    })
                ]
            })
        ]
    });
};
var $fa82c702d3b4b194$export$2e2bcd8739ae039 = $fa82c702d3b4b194$var$CommentsList;

});
parcelRegister("9Fskr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $709deadcd04aff52$export$2e2bcd8739ae039; });


var $3TEEB = parcelRequire("3TEEB");

var $4f9bW = parcelRequire("4f9bW");

var $6IyNM = parcelRequire("6IyNM");
"use client";
const $709deadcd04aff52$var$Box = (0, $4f9bW.default)({
    defaultClassName: (0, $6IyNM.default).root,
    generateClassName: (0, $3TEEB.default).generate
});
var $709deadcd04aff52$export$2e2bcd8739ae039 = $709deadcd04aff52$var$Box;

});
parcelRegister("6IyNM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e41d90f6a3a3cc2$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");
const $4e41d90f6a3a3cc2$var$boxClasses = (0, $igcUF.default)("MuiBox", [
    "root"
]);
var $4e41d90f6a3a3cc2$export$2e2bcd8739ae039 = $4e41d90f6a3a3cc2$var$boxClasses;

});


parcelRegister("lC4lc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbc0839b019d85cb$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $7J7Kn = parcelRequire("7J7Kn");

var $fPZvG = parcelRequire("fPZvG");

var $fGH8N = parcelRequire("fGH8N");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $2JdtB = parcelRequire("2JdtB");

var $ih19M = parcelRequire("ih19M");
"use client";
const $fbc0839b019d85cb$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $fbc0839b019d85cb$var$_ = (t)=>t, $fbc0839b019d85cb$var$_t, $fbc0839b019d85cb$var$_t2, $fbc0839b019d85cb$var$_t3, $fbc0839b019d85cb$var$_t4;
const $fbc0839b019d85cb$var$SIZE = 44;
const $fbc0839b019d85cb$var$circularRotateKeyframe = (0, $fPZvG.keyframes)($fbc0839b019d85cb$var$_t || ($fbc0839b019d85cb$var$_t = $fbc0839b019d85cb$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $fbc0839b019d85cb$var$circularDashKeyframe = (0, $fPZvG.keyframes)($fbc0839b019d85cb$var$_t2 || ($fbc0839b019d85cb$var$_t2 = $fbc0839b019d85cb$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $fbc0839b019d85cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $fGH8N.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $fGH8N.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $2JdtB.getCircularProgressUtilityClass), classes);
};
const $fbc0839b019d85cb$var$CircularProgressRoot = (0, $g4l1t.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $fGH8N.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $4WYaH.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && (0, $fPZvG.css)($fbc0839b019d85cb$var$_t3 || ($fbc0839b019d85cb$var$_t3 = $fbc0839b019d85cb$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $fbc0839b019d85cb$var$circularRotateKeyframe));
const $fbc0839b019d85cb$var$CircularProgressSVG = (0, $g4l1t.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $fbc0839b019d85cb$var$CircularProgressCircle = (0, $g4l1t.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $fGH8N.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $4WYaH.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $fPZvG.css)($fbc0839b019d85cb$var$_t4 || ($fbc0839b019d85cb$var$_t4 = $fbc0839b019d85cb$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $fbc0839b019d85cb$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $fbc0839b019d85cb$var$CircularProgress = /*#__PURE__*/ $bh6RR.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate" } = props, other = (0, $hCIyK.default)(props, $fbc0839b019d85cb$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $fbc0839b019d85cb$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($fbc0839b019d85cb$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $ih19M.jsx)($fbc0839b019d85cb$var$CircularProgressRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        style: (0, $4WYaH.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)($fbc0839b019d85cb$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$fbc0839b019d85cb$var$SIZE / 2} ${$fbc0839b019d85cb$var$SIZE / 2} ${$fbc0839b019d85cb$var$SIZE} ${$fbc0839b019d85cb$var$SIZE}`,
            children: /*#__PURE__*/ (0, $ih19M.jsx)($fbc0839b019d85cb$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $fbc0839b019d85cb$var$SIZE,
                cy: $fbc0839b019d85cb$var$SIZE,
                r: ($fbc0839b019d85cb$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $fbc0839b019d85cb$export$2e2bcd8739ae039 = $fbc0839b019d85cb$var$CircularProgress;

});
parcelRegister("2JdtB", function(module, exports) {

$parcel$export(module.exports, "getCircularProgressUtilityClass", function () { return $1fca3cdfd0dc88eb$export$29cad1383b3f235d; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $1fca3cdfd0dc88eb$export$29cad1383b3f235d(slot) {
    return (0, $XybB6.default)("MuiCircularProgress", slot);
}
const $1fca3cdfd0dc88eb$var$circularProgressClasses = (0, $igcUF.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $1fca3cdfd0dc88eb$export$2e2bcd8739ae039 = $1fca3cdfd0dc88eb$var$circularProgressClasses;

});


parcelRegister("3q83T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27da0db86b3f2a3b$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $aitry = parcelRequire("aitry");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $hK1jR = parcelRequire("hK1jR");

var $b78ua = parcelRequire("b78ua");

var $ih19M = parcelRequire("ih19M");
"use client";
const $27da0db86b3f2a3b$var$_excluded = [
    "className",
    "id"
];
const $27da0db86b3f2a3b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $hK1jR.getDialogTitleUtilityClass), classes);
};
const $27da0db86b3f2a3b$var$DialogTitleRoot = (0, $g4l1t.default)((0, $aitry.default), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const $27da0db86b3f2a3b$var$DialogTitle = /*#__PURE__*/ $bh6RR.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className: className, id: idProp } = props, other = (0, $hCIyK.default)(props, $27da0db86b3f2a3b$var$_excluded);
    const ownerState = props;
    const classes = $27da0db86b3f2a3b$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $bh6RR.useContext((0, $b78ua.default));
    return /*#__PURE__*/ (0, $ih19M.jsx)($27da0db86b3f2a3b$var$DialogTitleRoot, (0, $4WYaH.default)({
        component: "h2",
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $27da0db86b3f2a3b$export$2e2bcd8739ae039 = $27da0db86b3f2a3b$var$DialogTitle;

});

parcelRegister("i04rf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1abab766890081d$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");


var $cNBED = parcelRequire("cNBED");

var $8kJoH = parcelRequire("8kJoH");

var $l9pwU = parcelRequire("l9pwU");

var $lUFQY = parcelRequire("lUFQY");

var $g4l1t = parcelRequire("g4l1t");

var $ih19M = parcelRequire("ih19M");
"use client";
const $d1abab766890081d$var$_excluded = [
    "boundaryCount",
    "className",
    "color",
    "count",
    "defaultPage",
    "disabled",
    "getItemAriaLabel",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "renderItem",
    "shape",
    "showFirstButton",
    "showLastButton",
    "siblingCount",
    "size",
    "variant"
];
const $d1abab766890081d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant
        ],
        ul: [
            "ul"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $8kJoH.getPaginationUtilityClass), classes);
};
const $d1abab766890081d$var$PaginationRoot = (0, $g4l1t.default)("nav", {
    name: "MuiPagination",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const $d1abab766890081d$var$PaginationUl = (0, $g4l1t.default)("ul", {
    name: "MuiPagination",
    slot: "Ul",
    overridesResolver: (props, styles)=>styles.ul
})({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
});
function $d1abab766890081d$var$defaultGetAriaLabel(type, page, selected) {
    if (type === "page") return `${selected ? "" : "Go to "}page ${page}`;
    return `Go to ${type} page`;
}
const $d1abab766890081d$var$Pagination = /*#__PURE__*/ $bh6RR.forwardRef(function Pagination(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiPagination"
    });
    const { boundaryCount: boundaryCount = 1, className: className, color: color = "standard", count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $d1abab766890081d$var$defaultGetAriaLabel, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, renderItem: renderItem = (item)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $lUFQY.default), (0, $4WYaH.default)({}, item)), shape: shape = "circular", showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1, size: size = "medium", variant: variant = "text" } = props, other = (0, $hCIyK.default)(props, $d1abab766890081d$var$_excluded);
    const { items: items } = (0, $l9pwU.default)((0, $4WYaH.default)({}, props, {
        componentName: "Pagination"
    }));
    const ownerState = (0, $4WYaH.default)({}, props, {
        boundaryCount: boundaryCount,
        color: color,
        count: count,
        defaultPage: defaultPage,
        disabled: disabled,
        getItemAriaLabel: getItemAriaLabel,
        hideNextButton: hideNextButton,
        hidePrevButton: hidePrevButton,
        renderItem: renderItem,
        shape: shape,
        showFirstButton: showFirstButton,
        showLastButton: showLastButton,
        siblingCount: siblingCount,
        size: size,
        variant: variant
    });
    const classes = $d1abab766890081d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($d1abab766890081d$var$PaginationRoot, (0, $4WYaH.default)({
        "aria-label": "pagination navigation",
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)($d1abab766890081d$var$PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, $ih19M.jsx)("li", {
                    children: renderItem((0, $4WYaH.default)({}, item, {
                        color: color,
                        "aria-label": getItemAriaLabel(item.type, item.page, item.selected),
                        shape: shape,
                        size: size,
                        variant: variant
                    }))
                }, index))
        })
    }));
});
var $d1abab766890081d$export$2e2bcd8739ae039 = $d1abab766890081d$var$Pagination;

});
parcelRegister("8kJoH", function(module, exports) {

$parcel$export(module.exports, "getPaginationUtilityClass", function () { return $611367f379e9878d$export$427f1c1e2e839f85; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $611367f379e9878d$export$427f1c1e2e839f85(slot) {
    return (0, $XybB6.default)("MuiPagination", slot);
}
const $611367f379e9878d$var$paginationClasses = (0, $igcUF.default)("MuiPagination", [
    "root",
    "ul",
    "outlined",
    "text"
]);
var $611367f379e9878d$export$2e2bcd8739ae039 = $611367f379e9878d$var$paginationClasses;

});

parcelRegister("l9pwU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f65e3debf64cdecc$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $dI1ry = parcelRequire("dI1ry");
"use client";
const $f65e3debf64cdecc$var$_excluded = [
    "boundaryCount",
    "componentName",
    "count",
    "defaultPage",
    "disabled",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "showFirstButton",
    "showLastButton",
    "siblingCount"
];
function $f65e3debf64cdecc$export$2e2bcd8739ae039(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount: boundaryCount = 1, componentName: componentName = "usePagination", count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1 } = props, other = (0, $hCIyK.default)(props, $f65e3debf64cdecc$var$_excluded);
    const [page, setPageState] = (0, $dI1ry.default)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: "page"
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length: length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    endPages.length > 0 ? endPages[0] - 2 : count - 1);
    // Basic list of items to render
    // e.g. itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            "first"
        ] : [],
        ...hidePrevButton ? [] : [
            "previous"
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            "start-ellipsis"
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            "end-ellipsis"
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            "next"
        ],
        ...showLastButton ? [
            "last"
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case "first":
                return 1;
            case "previous":
                return page - 1;
            case "next":
                return page + 1;
            case "last":
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === "number" ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: "page",
            page: item,
            selected: item === page,
            disabled: disabled,
            "aria-current": item === page ? "true" : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || item.indexOf("ellipsis") === -1 && (item === "next" || item === "last" ? page >= count : page <= 1)
        };
    });
    return (0, $4WYaH.default)({
        items: items
    }, other);
}

});

parcelRegister("lUFQY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff3f4b29d29e5952$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $cG3EF = parcelRequire("cG3EF");

var $cNBED = parcelRequire("cNBED");

var $fEYR7 = parcelRequire("fEYR7");

var $8gyMY = parcelRequire("8gyMY");

var $aEoM0 = parcelRequire("aEoM0");

var $fGH8N = parcelRequire("fGH8N");

var $gRSzM = parcelRequire("gRSzM");

var $dQLGO = parcelRequire("dQLGO");

var $5APnw = parcelRequire("5APnw");

var $9Sbss = parcelRequire("9Sbss");

var $g4l1t = parcelRequire("g4l1t");

var $ih19M = parcelRequire("ih19M");
"use client";
const $ff3f4b29d29e5952$var$_excluded = [
    "className",
    "color",
    "component",
    "components",
    "disabled",
    "page",
    "selected",
    "shape",
    "size",
    "slots",
    "type",
    "variant"
];
const $ff3f4b29d29e5952$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, $fGH8N.default)(ownerState.size)}`],
        ownerState.variant === "text" && styles[`text${(0, $fGH8N.default)(ownerState.color)}`],
        ownerState.variant === "outlined" && styles[`outlined${(0, $fGH8N.default)(ownerState.color)}`],
        ownerState.shape === "rounded" && styles.rounded,
        ownerState.type === "page" && styles.page,
        (ownerState.type === "start-ellipsis" || ownerState.type === "end-ellipsis") && styles.ellipsis,
        (ownerState.type === "previous" || ownerState.type === "next") && styles.previousNext,
        (ownerState.type === "first" || ownerState.type === "last") && styles.firstLast
    ];
};
const $ff3f4b29d29e5952$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, selected: selected, size: size, shape: shape, type: type, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            `size${(0, $fGH8N.default)(size)}`,
            variant,
            shape,
            color !== "standard" && `color${(0, $fGH8N.default)(color)}`,
            color !== "standard" && `${variant}${(0, $fGH8N.default)(color)}`,
            disabled && "disabled",
            selected && "selected",
            {
                page: "page",
                first: "firstLast",
                last: "firstLast",
                "start-ellipsis": "ellipsis",
                "end-ellipsis": "ellipsis",
                previous: "previousNext",
                next: "previousNext"
            }[type]
        ],
        icon: [
            "icon"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $fEYR7.getPaginationItemUtilityClass), classes);
};
const $ff3f4b29d29e5952$var$PaginationItemEllipsis = (0, $g4l1t.default)("div", {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver: $ff3f4b29d29e5952$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: "center",
        boxSizing: "border-box",
        minWidth: 32,
        padding: "0 6px",
        margin: "0 3px",
        color: (theme.vars || theme).palette.text.primary,
        height: "auto",
        [`&.${(0, $fEYR7.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.size === "small" && {
        minWidth: 26,
        borderRadius: 13,
        margin: "0 1px",
        padding: "0 4px"
    }, ownerState.size === "large" && {
        minWidth: 40,
        borderRadius: 20,
        padding: "0 10px",
        fontSize: theme.typography.pxToRem(15)
    }));
const $ff3f4b29d29e5952$var$PaginationItemPage = (0, $g4l1t.default)((0, $aEoM0.default), {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver: $ff3f4b29d29e5952$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: "center",
        boxSizing: "border-box",
        minWidth: 32,
        height: 32,
        padding: "0 6px",
        margin: "0 3px",
        color: (theme.vars || theme).palette.text.primary,
        [`&.${(0, $fEYR7.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $fEYR7.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            "color",
            "background-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $fEYR7.default).selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $cG3EF.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${(0, $fEYR7.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cG3EF.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            },
            [`&.${(0, $fEYR7.default).disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        }
    }, ownerState.size === "small" && {
        minWidth: 26,
        height: 26,
        borderRadius: 13,
        margin: "0 1px",
        padding: "0 4px"
    }, ownerState.size === "large" && {
        minWidth: 40,
        height: 40,
        borderRadius: 20,
        padding: "0 10px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.shape === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }), ({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({}, ownerState.variant === "text" && {
        [`&.${(0, $fEYR7.default).selected}`]: (0, $4WYaH.default)({}, ownerState.color !== "standard" && {
            color: (theme.vars || theme).palette[ownerState.color].contrastText,
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
                }
            },
            [`&.${(0, $fEYR7.default).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
            }
        }, {
            [`&.${(0, $fEYR7.default).disabled}`]: {
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }, ownerState.variant === "outlined" && {
        border: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${(0, $fEYR7.default).selected}`]: (0, $4WYaH.default)({}, ownerState.color !== "standard" && {
            color: (theme.vars || theme).palette[ownerState.color].main,
            border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $cG3EF.alpha)(theme.palette[ownerState.color].main, 0.5)}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.activatedOpacity})` : (0, $cG3EF.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cG3EF.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, $fEYR7.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cG3EF.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
            }
        }, {
            [`&.${(0, $fEYR7.default).disabled}`]: {
                borderColor: (theme.vars || theme).palette.action.disabledBackground,
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }));
const $ff3f4b29d29e5952$var$PaginationItemPageIcon = (0, $g4l1t.default)("div", {
    name: "MuiPaginationItem",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        fontSize: theme.typography.pxToRem(20),
        margin: "0 -8px"
    }, ownerState.size === "small" && {
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        fontSize: theme.typography.pxToRem(22)
    }));
const $ff3f4b29d29e5952$var$PaginationItem = /*#__PURE__*/ $bh6RR.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiPaginationItem"
    });
    const { className: className, color: color = "standard", component: component, components: components = {}, disabled: disabled = false, page: page, selected: selected = false, shape: shape = "circular", size: size = "medium", slots: slots = {}, type: type = "page", variant: variant = "text" } = props, other = (0, $hCIyK.default)(props, $ff3f4b29d29e5952$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        disabled: disabled,
        selected: selected,
        shape: shape,
        size: size,
        type: type,
        variant: variant
    });
    const theme = (0, $8gyMY.default)();
    const classes = $ff3f4b29d29e5952$var$useUtilityClasses(ownerState);
    const normalizedIcons = theme.direction === "rtl" ? {
        previous: slots.next || components.next || (0, $9Sbss.default),
        next: slots.previous || components.previous || (0, $5APnw.default),
        last: slots.first || components.first || (0, $gRSzM.default),
        first: slots.last || components.last || (0, $dQLGO.default)
    } : {
        previous: slots.previous || components.previous || (0, $5APnw.default),
        next: slots.next || components.next || (0, $9Sbss.default),
        first: slots.first || components.first || (0, $gRSzM.default),
        last: slots.last || components.last || (0, $dQLGO.default)
    };
    const Icon = normalizedIcons[type];
    return type === "start-ellipsis" || type === "end-ellipsis" ? /*#__PURE__*/ (0, $ih19M.jsx)($ff3f4b29d29e5952$var$PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, $ih19M.jsxs)($ff3f4b29d29e5952$var$PaginationItemPage, (0, $4WYaH.default)({
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, $aPsoC.default)(classes.root, className)
    }, other, {
        children: [
            type === "page" && page,
            Icon ? /*#__PURE__*/ (0, $ih19M.jsx)($ff3f4b29d29e5952$var$PaginationItemPageIcon, {
                as: Icon,
                ownerState: ownerState,
                className: classes.icon
            }) : null
        ]
    }));
});
var $ff3f4b29d29e5952$export$2e2bcd8739ae039 = $ff3f4b29d29e5952$var$PaginationItem;

});
parcelRegister("fEYR7", function(module, exports) {

$parcel$export(module.exports, "getPaginationItemUtilityClass", function () { return $b669cc272a2761c3$export$e4ce0a775adf2f74; });
$parcel$export(module.exports, "default", function () { return $b669cc272a2761c3$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $b669cc272a2761c3$export$e4ce0a775adf2f74(slot) {
    return (0, $XybB6.default)("MuiPaginationItem", slot);
}
const $b669cc272a2761c3$var$paginationItemClasses = (0, $igcUF.default)("MuiPaginationItem", [
    "root",
    "page",
    "sizeSmall",
    "sizeLarge",
    "text",
    "textPrimary",
    "textSecondary",
    "outlined",
    "outlinedPrimary",
    "outlinedSecondary",
    "rounded",
    "ellipsis",
    "firstLast",
    "previousNext",
    "focusVisible",
    "disabled",
    "selected",
    "icon",
    "colorPrimary",
    "colorSecondary"
]);
var $b669cc272a2761c3$export$2e2bcd8739ae039 = $b669cc272a2761c3$var$paginationItemClasses;

});

parcelRegister("5APnw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41282b3eaf043b19$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $41282b3eaf043b19$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore");

});

parcelRegister("9Sbss", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73020b87ac366e5b$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $73020b87ac366e5b$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext");

});



parcelRegister("8lfqJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5969344f1e9f2bba$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $4MYBr = parcelRequire("4MYBr");
var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");

var $cxTnx = parcelRequire("cxTnx");

var $bu31C = parcelRequire("bu31C");

var $8Oiq1 = parcelRequire("8Oiq1");

var $6L9uu = parcelRequire("6L9uu");

var $3A2xv = parcelRequire("3A2xv");

var $b5b48 = parcelRequire("b5b48");
const $5969344f1e9f2bba$var$Comment = ({ comment: comment, remove: remove, index: index })=>{
    const namesFirstLetters = comment.author.first_name[0] + comment.author.last_name[0];
    const fullName = `${comment.author.first_name} ${comment.author.last_name}`;
    const { state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const canDeleteComment = state.user.data?.roles.includes((0, $8Oiq1.Roles).Admin);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            display: "grid",
            paddingLeft: "5.5%",
            paddingTop: "20px",
            paddingRight: "3.3%"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    gridColumn: "span 1"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4MYBr.default), {
                    id: `comment-${index}-avatar`,
                    "data-testid": `comment-${index}-avatar`,
                    sx: {
                        backgroundColor: "#DFDFE0",
                        border: `4px solid ${(0, $6L9uu.Colors).skyBlue}`,
                        color: (0, $6L9uu.Colors).skyBlue,
                        width: "45px",
                        height: "44px"
                    },
                    children: namesFirstLetters
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    gridColumn: "span 10"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        id: `comment-${index}-author-name`,
                        "data-testid": `comment-${index}-author-name`,
                        sx: {
                            color: (0, $6L9uu.Colors).skyBlue
                        },
                        children: fullName
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        id: `comment-${index}-creation-date`,
                        "data-testid": `comment-${index}-creation-date`,
                        sx: {
                            color: (0, $6L9uu.Colors).gray
                        },
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(parseInt(comment.date)).format("DD.MM.YYYY HH:mm")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                display: "flex",
                justifyContent: "end",
                sx: {
                    gridColumn: "span 1"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                    id: `remove-comment-${index}-button`,
                    sx: {
                        width: "10px"
                    },
                    onClick: ()=>remove(comment),
                    "data-testid": `remove-comment-${index}-button`,
                    disabled: !canDeleteComment,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                        src: canDeleteComment ? (0, (/*@__PURE__*/$parcel$interopDefault($3A2xv))) : (0, (/*@__PURE__*/$parcel$interopDefault($b5b48))),
                        alt: "removeButton"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                id: `comment-${index}-text`,
                "data-testid": `comment-${index}-text`,
                sx: {
                    color: (0, $6L9uu.Colors).main,
                    gridColumn: "span 12",
                    paddingBottom: "10px"
                },
                children: comment.text
            })
        ]
    });
};
var $5969344f1e9f2bba$export$2e2bcd8739ae039 = $5969344f1e9f2bba$var$Comment;

});
parcelRegister("4MYBr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37caa79c366b9bc0$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $6S0MN = parcelRequire("6S0MN");
var $g4l1t = parcelRequire("g4l1t");

var $kyfAc = parcelRequire("kyfAc");

var $a1tqT = parcelRequire("a1tqT");

var $25BP8 = parcelRequire("25BP8");

var $ih19M = parcelRequire("ih19M");
"use client";
const $37caa79c366b9bc0$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $37caa79c366b9bc0$var$useThemeProps = (0, $6S0MN.createUseThemeProps)("MuiAvatar");
const $37caa79c366b9bc0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            colorDefault && "colorDefault"
        ],
        img: [
            "img"
        ],
        fallback: [
            "fallback"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $a1tqT.getAvatarUtilityClass), classes);
};
const $37caa79c366b9bc0$var$AvatarRoot = (0, $g4l1t.default)("div", {
    name: "MuiAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme })=>({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: "50%",
        overflow: "hidden",
        userSelect: "none",
        variants: [
            {
                props: {
                    variant: "rounded"
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: "square"
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: (0, $4WYaH.default)({
                    color: (theme.vars || theme).palette.background.default
                }, theme.vars ? {
                    backgroundColor: theme.vars.palette.Avatar.defaultBg
                } : (0, $4WYaH.default)({
                    backgroundColor: theme.palette.grey[400]
                }, theme.applyStyles("dark", {
                    backgroundColor: theme.palette.grey[600]
                })))
            }
        ]
    }));
const $37caa79c366b9bc0$var$AvatarImg = (0, $g4l1t.default)("img", {
    name: "MuiAvatar",
    slot: "Img",
    overridesResolver: (props, styles)=>styles.img
})({
    width: "100%",
    height: "100%",
    textAlign: "center",
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: "cover",
    // Hide alt text.
    color: "transparent",
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $37caa79c366b9bc0$var$AvatarFallback = (0, $g4l1t.default)((0, $kyfAc.default), {
    name: "MuiAvatar",
    slot: "Fallback",
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: "75%",
    height: "75%"
});
function $37caa79c366b9bc0$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $bh6RR.useState(false);
    $bh6RR.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded("error");
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $37caa79c366b9bc0$var$Avatar = /*#__PURE__*/ $bh6RR.forwardRef(function Avatar(inProps, ref) {
    const props = $37caa79c366b9bc0$var$useThemeProps({
        props: inProps,
        name: "MuiAvatar"
    });
    const { alt: alt, children: childrenProp, className: className, component: component = "div", slots: slots = {}, slotProps: slotProps = {}, imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = "circular" } = props, other = (0, $hCIyK.default)(props, $37caa79c366b9bc0$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $37caa79c366b9bc0$var$useLoaded((0, $4WYaH.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== "error";
    const ownerState = (0, $4WYaH.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $37caa79c366b9bc0$var$useUtilityClasses(ownerState);
    const [ImgSlot, imgSlotProps] = (0, $25BP8.default)("img", {
        className: classes.img,
        elementType: $37caa79c366b9bc0$var$AvatarImg,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                img: (0, $4WYaH.default)({}, imgProps, slotProps.img)
            }
        },
        additionalProps: {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes
        },
        ownerState: ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $ih19M.jsx)(ImgSlot, (0, $4WYaH.default)({}, imgSlotProps));
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $ih19M.jsx)($37caa79c366b9bc0$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)($37caa79c366b9bc0$var$AvatarRoot, (0, $4WYaH.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $37caa79c366b9bc0$export$2e2bcd8739ae039 = $37caa79c366b9bc0$var$Avatar;

});
parcelRegister("kyfAc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef63120d1c484e5d$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $ef63120d1c484e5d$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");

});

parcelRegister("a1tqT", function(module, exports) {

$parcel$export(module.exports, "getAvatarUtilityClass", function () { return $74c0d41f780877f5$export$ffd560f22c0ecf04; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $74c0d41f780877f5$export$ffd560f22c0ecf04(slot) {
    return (0, $XybB6.default)("MuiAvatar", slot);
}
const $74c0d41f780877f5$var$avatarClasses = (0, $igcUF.default)("MuiAvatar", [
    "root",
    "colorDefault",
    "circular",
    "rounded",
    "square",
    "img",
    "fallback"
]);
var $74c0d41f780877f5$export$2e2bcd8739ae039 = $74c0d41f780877f5$var$avatarClasses;

});

parcelRegister("25BP8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1859636e012a28a8$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $fpwfv = parcelRequire("fpwfv");

var $95U3o = parcelRequire("95U3o");
var $7NHbQ = parcelRequire("7NHbQ");
var $4Mv5B = parcelRequire("4Mv5B");
"use client";
const $1859636e012a28a8$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $1859636e012a28a8$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $1859636e012a28a8$var$_excluded3 = [
    "component"
];
function $1859636e012a28a8$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $hCIyK.default)(parameters, $1859636e012a28a8$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $hCIyK.default)(externalForwardedProps, $1859636e012a28a8$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $4Mv5B.resolveComponentProps)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $7NHbQ.mergeSlotProps)((0, $4WYaH.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === "root" ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $hCIyK.default)(_mergeSlotProps.props, $1859636e012a28a8$var$_excluded3);
    const ref = (0, $fpwfv.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $4WYaH.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === "root" ? slotComponent || rootComponent : slotComponent;
    const props = (0, $95U3o.appendOwnerState)(elementType, (0, $4WYaH.default)({}, name === "root" && !rootComponent && !slots[name] && internalForwardedProps, name !== "root" && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}

});





parcelRegister("6ah9Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c59a88074ef1534$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $5DXc5 = parcelRequire("5DXc5");

var $gFVvY = parcelRequire("gFVvY");

var $aM783 = parcelRequire("aM783");

var $cxTnx = parcelRequire("cxTnx");

var $6L9uu = parcelRequire("6L9uu");

var $ifSrq = parcelRequire("ifSrq");

var $bm7ia = parcelRequire("bm7ia");

var $2OHqK = parcelRequire("2OHqK");

var $b42dh = parcelRequire("b42dh");

var $hsjD5 = parcelRequire("hsjD5");

var $e2ibc = parcelRequire("e2ibc");

var $91340 = parcelRequire("91340");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $7pnqR = parcelRequire("7pnqR");
const $4c59a88074ef1534$var$MembershipInvoicesTab = ({ membershipId: membershipId })=>{
    const [openWizard, setOpenWizard] = (0, $bh6RR.useState)(false);
    const { data: data, loading: loading } = (0, $hjfla.useInvoicesForMembershipQuery)({
        variables: {
            membership_id: membershipId
        },
        fetchPolicy: "no-cache"
    });
    const [invoices, setInvoices] = (0, $bh6RR.useState)([]);
    const [deleteInvoice, deleteInvoiceResult] = (0, $hjfla.useDeleteInvoiceMutation)();
    const [updatePaidDate, updatePaidDateResult] = (0, $hjfla.usePayInvoiceMutation)();
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [createCreditNote, createCreditResult] = (0, $hjfla.useCreateCreditNoteMutation)();
    const canCreate = (0, $dqRXb.canUserCreate)(state.user, (0, $gUBkJ.Types).Invoice);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setInvoices(data.result);
    }, [
        data
    ]);
    const handlePayDateChange = (datePaid, rowData)=>{
        const createdDate = (0, $gFVvY.parseDate)(rowData.created_date);
        if (rowData.status.name === (0, $aM783.INVOICE_STATUS_CONFIRMED)) {
            if (datePaid !== null) updatePaidDate({
                variables: {
                    id: parseInt(rowData.id),
                    date_paid: datePaid.toString()
                },
                update (_, { data: data }) {
                    updatePaidDateFinished(data);
                }
            });
            else updatePaidDate({
                variables: {
                    id: parseInt(rowData.id)
                },
                update (_, { data: data }) {
                    updatePaidDateFinished(data);
                }
            });
        }
    };
    const updatePaidDateFinished = (data)=>{
        if (data && data.result) {
            const { result: result } = data;
            const updatedInvoice = invoices.map((i)=>i.id === result.id ? result : i);
            setInvoices(updatedInvoice);
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "success",
                    text: `Invoice ${result.number} updated`,
                    autoHide: 6000
                }
            });
        }
    };
    const formatDate = (rowData, name)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return rowData[name] ? // @ts-ignore
        (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(parseInt(rowData[name])).format((0, $e2ibc.DATE_TIME_FORMATS).DATE) : "";
    };
    const renderStatus = (status)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)("p", {
            style: {
                color: status === (0, $aM783.INVOICE_STATUS_CONFIRMED) ? (0, $6L9uu.Colors).green : (0, $6L9uu.Colors).red
            },
            children: status
        });
    };
    const renderCreditButton = (id, isCredit, statusName)=>{
        if (statusName === (0, $aM783.INVOICE_STATUS_CONFIRMED) && !isCredit) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: `credit-button-${id}`,
            sx: {
                height: "38px",
                width: "auto"
            },
            onClick: ()=>handleCreditPressed(id),
            disabled: !canCreate,
            children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                className: "credit",
                src: canCreate ? (0, (/*@__PURE__*/$parcel$interopDefault($ifSrq))) : (0, (/*@__PURE__*/$parcel$interopDefault($bm7ia))),
                alt: "creditStatus"
            })
        });
    };
    const handleCreditPressed = (id)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: "Are you sure you want to create credit note?",
                agreeAction: handleCreateCredit,
                params: id
            }
        });
    };
    const handleCreateCredit = (id)=>{
        createCreditNote({
            variables: {
                id: Number(id)
            },
            update (_, { data: data }) {
                if (data?.result) {
                    dispatch({
                        type: (0, $ayVxz.Actions).SetInvoice,
                        payload: {
                            invoice: data.result,
                            productInfo: (0, $2OHqK.getInvoiceProductInfoDto)(data.result)
                        }
                    });
                    handleNewInvoice(data.result);
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `You have successfully created new credit note`
                        }
                    });
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        }).finally(()=>{
            dispatch({
                type: (0, $ayVxz.Actions).HideConfirmation
            });
        });
    };
    const handleDetails = (rowData)=>{
        setOpenWizard(true);
        dispatch({
            type: (0, $ayVxz.Actions).SetInvoice,
            payload: {
                invoice: rowData,
                productInfo: (0, $2OHqK.getInvoiceProductInfoDto)(rowData)
            }
        });
    };
    const renderCalendar = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
            dateAdapter: (0, $1Dn8S.AdapterDateFns),
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                id: "membership-tab-invoices-date-paid-picker",
                disabled: false,
                label: "",
                value: rowData?.date_paid ? (0, $gFVvY.parseDate)(rowData.date_paid) : null,
                onChange: (newPaidDate)=>handlePayDateChange(newPaidDate, rowData)
            })
        });
    };
    const boldNumber = (invoiceNumber)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)("b", {
            children: invoiceNumber
        });
    };
    const remove = (rowData)=>dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete current pending invoice?`,
                agreeAction: handleDelete,
                params: rowData.id
            }
        });
    const handleDelete = (id)=>{
        if (!id) return;
        deleteInvoice({
            variables: {
                id: parseInt(id)
            },
            update () {
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Invoice deleted ${id}`,
                        severity: "success"
                    }
                });
                const deletedInvoice = invoices.find((i)=>i.id === id);
                (0, $gFVvY.removeInvoiceFromCache)(deletedInvoice);
                setInvoices(invoices.filter((i)=>i.id !== id));
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        }).finally(()=>{
            dispatch({
                type: (0, $ayVxz.Actions).HideConfirmation
            });
        });
    };
    const handleNewInvoice = (invoice)=>{
        setInvoices([
            invoice,
            ...invoices || []
        ]);
    };
    const handleCreateNewPressed = ()=>{
        setOpenWizard(true);
        dispatch({
            type: (0, $ayVxz.Actions).SetInvoice,
            payload: {
                invoice: null
            }
        });
    };
    const handleEditInvoice = (invoice)=>{
        setInvoices(invoices?.map((i)=>i?.id === invoice.id ? invoice : i));
    };
    const columns = [
        {
            title: "Details",
            sorting: false,
            width: 51
        },
        {
            title: "Invoice",
            field: "number",
            sorting: false,
            width: 95,
            render: (rowData)=>boldNumber(rowData.number || "")
        },
        {
            title: "Date",
            field: "created_date",
            type: "date",
            width: 77,
            render: (rowData)=>formatDate(rowData, "created_date")
        },
        {
            title: "Due",
            field: "due_date",
            type: "date",
            render: (rowData)=>formatDate(rowData, "due_date"),
            width: 85
        },
        {
            title: "Total",
            field: "total",
            width: 56
        },
        {
            title: "Membership",
            field: "membership.id",
            sorting: false,
            width: 48
        },
        {
            title: "Product",
            field: "product.product_code.name",
            width: 21
        },
        {
            title: "Date Paid",
            width: 455,
            render: (rowData)=>renderCalendar(rowData)
        },
        {
            title: "Status",
            field: "status.name",
            width: 80,
            render: (rowData)=>renderStatus(rowData.status.name)
        },
        {
            title: "Company",
            field: "details.company_name",
            width: 133
        },
        {
            title: "Contact",
            field: "details.fullName",
            width: 135
        },
        {
            title: "Street",
            field: "details.street",
            width: 136
        },
        {
            title: "City",
            field: "details.city",
            width: 78
        },
        {
            title: "Credit",
            field: "is_credit",
            width: 58,
            render: (rowData)=>renderCreditButton(rowData.id, rowData.is_credit, rowData.status.name)
        },
        {
            title: "Remove",
            sorting: false,
            field: "status.name",
            width: 71
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "centralize",
        sx: {
            width: "100%",
            paddingTop: "80px"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $5DXc5.default), {
                headerText: "Invoices",
                width: "82%",
                additionalStyle: {
                    height: "680px"
                },
                createButtonProps: {
                    id: "create-invoice-button-membership-details-invoices-tab",
                    onClick: ()=>handleCreateNewPressed(),
                    text: "+ CREATE INVOICE",
                    disabled: !canCreate
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
                    columns: columns,
                    data: (0, $hsjD5.FormatTableData)(invoices),
                    loading: loading,
                    handleDetails: handleDetails,
                    handleRemove: remove,
                    pageSize: 10,
                    crudType: (0, $gUBkJ.Types).Membership,
                    additionalToolbar: true,
                    fixedHeaders: true
                })
            }),
            openWizard && /*#__PURE__*/ (0, $ih19M.jsx)((0, $7pnqR.default), {
                onClose: ()=>setOpenWizard(false),
                addNewInvoice: handleNewInvoice,
                editInvoice: handleEditInvoice
            })
        ]
    });
};
var $4c59a88074ef1534$export$2e2bcd8739ae039 = $4c59a88074ef1534$var$MembershipInvoicesTab;

});
parcelRegister("ifSrq", function(module, exports) {
module.exports = new URL("credit.5e8d8905.svg", import.meta.url).toString();

});

parcelRegister("bm7ia", function(module, exports) {
module.exports = new URL("credit_gray.c21bd4d1.svg", import.meta.url).toString();

});

parcelRegister("2OHqK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getInvoiceProductInfoDto", function () { return $79065bcf5625e11c$export$fb01acb62b8c4cba; });
$parcel$export(module.exports, "default", function () { return $79065bcf5625e11c$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $bu31C = parcelRequire("bu31C");

var $oZMqz = parcelRequire("oZMqz");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $1u9dM = parcelRequire("1u9dM");
var $gu8wR = parcelRequire("gu8wR");

var $d7fM7 = parcelRequire("d7fM7");

var $cxTnx = parcelRequire("cxTnx");

var $6L9uu = parcelRequire("6L9uu");

var $e2ibc = parcelRequire("e2ibc");

var $ayVxz = parcelRequire("ayVxz");

var $gFVvY = parcelRequire("gFVvY");

var $8d818 = parcelRequire("8d818");

var $7pnqR = parcelRequire("7pnqR");

var $bilGR = parcelRequire("bilGR");

var $ehzwo = parcelRequire("ehzwo");

var $d13i8 = parcelRequire("d13i8");
const $79065bcf5625e11c$export$fb01acb62b8c4cba = (invoice)=>{
    return {
        discount: invoice.discount ?? 0,
        discountPercent: (0, $oZMqz.calculateDiscountPercent)(invoice.product.price, invoice.discount),
        vatPercent: invoice.vat ?? null,
        vat: (0, $oZMqz.calculateVat)(invoice.product.price, invoice.discount, invoice.vat),
        product: invoice.product,
        total: invoice.total
    };
};
const $79065bcf5625e11c$var$ProductCodes = {
    AC: "AC",
    BPR: "BPR",
    RB: "RB"
};
const $79065bcf5625e11c$var$groupButtonWidth = "90px";
const $79065bcf5625e11c$var$InvoiceList = ()=>{
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const companyData = (0, $hjfla.useCompaniesQuery)();
    // Filter states
    const [pending, setPending] = (0, $bh6RR.useState)(false);
    const [dueAndUnpaid, setDueAndUnpaid] = (0, $bh6RR.useState)(false);
    const [number, setNumber] = (0, $bh6RR.useState)("");
    const [company, setCompany] = (0, $bh6RR.useState)(null);
    const [contactName, setContactName] = (0, $bh6RR.useState)("");
    const [city, setCity] = (0, $bh6RR.useState)("");
    const [invoiceYears, setInvoiceYears] = (0, $bh6RR.useState)([]);
    const [ac, setAc] = (0, $bh6RR.useState)(false);
    const [bpr, setBpr] = (0, $bh6RR.useState)(false);
    const [rb, setRb] = (0, $bh6RR.useState)(false);
    // Pagination states
    const [page, setPage] = (0, $bh6RR.useState)(0);
    const [pageSize, setPageSize] = (0, $bh6RR.useState)(15);
    const [total, setTotal] = (0, $bh6RR.useState)(0);
    // Sorting states
    const [orderBy, setOrderBy] = (0, $bh6RR.useState)(null);
    const [orderDirection, setOrderDirection] = (0, $bh6RR.useState)("asc");
    // Local state for displayed invoices (updated by query and subscriptions)
    const [displayedInvoices, setDisplayedInvoices] = (0, $bh6RR.useState)([]);
    const [yearsOptions, setYearsOptions] = (0, $bh6RR.useState)([]);
    const [openWizard, setOpenWizard] = (0, $bh6RR.useState)(false);
    const [deleteInvoice, deleteInvoiceResult] = (0, $hjfla.useDeleteInvoiceMutation)();
    const [fetchInvoices, { data: data, loading: loading, refetch: refetch }] = (0, $hjfla.useInvoicesFilteredLazyQuery)();
    // Subscriptions for real-time updates
    const createInvoiceSubscription = (0, $hjfla.useInvoiceCreatedSubscription)();
    const updateInvoiceSubscription = (0, $hjfla.useInvoiceUpdatedSubscription)();
    const deleteInvoiceSubscription = (0, $hjfla.useInvoiceDeletedSubscription)();
    // Refs for tracking state
    const hasMounted = (0, $bh6RR.useRef)(false);
    const filterTimeoutRef = (0, $bh6RR.useRef)(null);
    const isFilterChangeRef = (0, $bh6RR.useRef)(false);
    const isInitialMount = (0, $bh6RR.useRef)(true);
    const lastPageRef = (0, $bh6RR.useRef)(page);
    const lastPageSizeRef = (0, $bh6RR.useRef)(pageSize);
    (0, $bh6RR.useEffect)(()=>{
        const now = new Date();
        const years = [];
        for(let index = 2010; index <= now.getFullYear(); index++)years.push(index);
        setYearsOptions(years);
    }, []);
    // Helper function to check if an invoice matches current filters
    const invoiceMatchesFilters = (0, $bh6RR.useCallback)((invoice)=>{
        // Check pending filter
        if (pending && invoice.status?.name !== "Pending") return false;
        // Check due and unpaid filter
        if (dueAndUnpaid) {
            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            const dueDate = invoice.due_date ? new Date(parseInt(invoice.due_date)) : null;
            if (!dueDate || invoice.date_paid !== null || dueDate >= today) return false;
        }
        // Check number filter
        if (number && number.trim().length > 0) {
            const invoiceNumber = invoice.number?.toLowerCase() || "";
            if (!invoiceNumber.includes(number.trim().toLowerCase())) return false;
        }
        // Check company filter
        if (company && company.id != null) {
            const invoiceCompanyName = invoice.details?.company_name?.toLowerCase() || "";
            const companyName = company.name?.toLowerCase() || "";
            if (!invoiceCompanyName.includes(companyName)) return false;
        }
        // Check contact name filter
        if (contactName && contactName.trim().length > 0) {
            const firstName = invoice.details?.contact_first_name?.toLowerCase() || "";
            const lastName = invoice.details?.contact_last_name?.toLowerCase() || "";
            const fullName = `${firstName} ${lastName}`.trim();
            if (!fullName.includes(contactName.trim().toLowerCase())) return false;
        }
        // Check city filter
        if (city && city.trim().length > 0) {
            const invoiceCity = invoice.details?.city?.toLowerCase() || "";
            if (!invoiceCity.includes(city.trim().toLowerCase())) return false;
        }
        // Check years filter
        if (invoiceYears.length > 0) {
            const invoiceYear = invoice.created_date ? new Date(parseInt(invoice.created_date)).getFullYear() : null;
            if (!invoiceYear || !invoiceYears.includes(invoiceYear)) return false;
        }
        // Check product codes filter
        const selectedProductCodes = [];
        if (ac) selectedProductCodes.push($79065bcf5625e11c$var$ProductCodes.AC);
        if (bpr) selectedProductCodes.push($79065bcf5625e11c$var$ProductCodes.BPR);
        if (rb) selectedProductCodes.push($79065bcf5625e11c$var$ProductCodes.RB);
        if (selectedProductCodes.length > 0) {
            const invoiceProductCode = invoice.product?.product_code?.name;
            if (!invoiceProductCode || !selectedProductCodes.includes(invoiceProductCode)) return false;
        }
        return true;
    }, [
        pending,
        dueAndUnpaid,
        number,
        company,
        contactName,
        city,
        invoiceYears,
        ac,
        bpr,
        rb
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (data?.result) {
            const newTotal = data.result.total || 0;
            setTotal(newTotal);
            // Filter out null/undefined values from the invoices array
            const validInvoices = (data.result.invoices || []).filter((invoice)=>invoice !== null && invoice !== undefined);
            setDisplayedInvoices(validInvoices);
            // Only reset page if it's actually invalid (only when filters change and we get fewer results)
            if (newTotal > 0) {
                const maxPage = Math.max(0, Math.ceil(newTotal / pageSize) - 1);
                if (page > maxPage && isFilterChangeRef.current) setPage(0);
            } else if (newTotal === 0 && page > 0 && isFilterChangeRef.current) setPage(0);
        }
    }, [
        data,
        pageSize,
        page
    ]);
    // Handle subscription events - update local state directly
    (0, $bh6RR.useEffect)(()=>{
        if (!hasMounted.current) return;
        if (createInvoiceSubscription.data?.result) {
            const newInvoice = createInvoiceSubscription.data.result;
            // Check if new invoice matches current filters
            if (invoiceMatchesFilters(newInvoice)) {
                setDisplayedInvoices((prev)=>{
                    // Only add if it doesn't already exist
                    const exists = prev.some((i)=>i.id === newInvoice.id);
                    if (!exists) {
                        setTotal((currentTotal)=>currentTotal + 1);
                        return [
                            newInvoice,
                            ...prev
                        ];
                    }
                    return prev;
                });
                setPage(0);
            }
        }
        if (updateInvoiceSubscription.data?.result) {
            const updatedInvoice = updateInvoiceSubscription.data.result;
            setDisplayedInvoices((prev)=>{
                return prev.map((i)=>i.id === updatedInvoice.id ? updatedInvoice : i);
            });
        }
        if (deleteInvoiceSubscription.data?.result?.id) {
            const deletedInvoiceId = deleteInvoiceSubscription.data.result.id;
            setDisplayedInvoices((prev)=>{
                const invoiceToRemove = prev.find((i)=>i.id === deletedInvoiceId);
                if (invoiceToRemove) {
                    (0, $gFVvY.removeInvoiceFromCache)(invoiceToRemove);
                    setTotal((currentTotal)=>Math.max(0, currentTotal - 1));
                    return prev.filter((i)=>i.id !== deletedInvoiceId);
                }
                return prev;
            });
        }
    }, [
        createInvoiceSubscription.data,
        updateInvoiceSubscription.data,
        deleteInvoiceSubscription.data,
        invoiceMatchesFilters
    ]);
    // Initial load - only run once on mount
    (0, $bh6RR.useEffect)(()=>{
        if (!hasMounted.current) {
            hasMounted.current = true;
            // Initial load with default filter
            const filter = {
                limit: pageSize,
                offset: 0
            };
            // Add sorting parameters if set
            if (orderBy) {
                filter.orderBy = orderBy;
                filter.orderDirection = orderDirection;
            }
            fetchInvoices({
                variables: {
                    filter: filter
                }
            });
        }
    }, [
        fetchInvoices,
        pageSize
    ]);
    // Debounce filter changes to avoid too many requests
    (0, $bh6RR.useEffect)(()=>{
        // Skip if this is the initial mount
        if (!hasMounted.current) return;
        // Clear any existing timeout
        if (filterTimeoutRef.current) clearTimeout(filterTimeoutRef.current);
        isFilterChangeRef.current = true;
        filterTimeoutRef.current = setTimeout(()=>{
            // Reset to first page when filters change and reload
            setPage(0);
            // Build filter object directly here
            const filter = {
                limit: pageSize,
                offset: 0
            };
            if (pending) filter.pending = true;
            if (dueAndUnpaid) filter.dueAndUnpaid = true;
            if (number && number.trim().length > 0) filter.number = number.trim();
            if (contactName && contactName.trim().length > 0) filter.contact_name = contactName.trim();
            if (city && city.trim().length > 0) filter.city = city.trim();
            if (invoiceYears.length > 0) filter.years = invoiceYears;
            if (company && company.name) filter.company_name = company.name.trim();
            // Add product codes filter
            const selectedProductCodes = [];
            if (ac) selectedProductCodes.push($79065bcf5625e11c$var$ProductCodes.AC);
            if (bpr) selectedProductCodes.push($79065bcf5625e11c$var$ProductCodes.BPR);
            if (rb) selectedProductCodes.push($79065bcf5625e11c$var$ProductCodes.RB);
            if (selectedProductCodes.length > 0) filter.productCodes = selectedProductCodes;
            // Add sorting parameters
            if (orderBy) {
                filter.orderBy = orderBy;
                filter.orderDirection = orderDirection;
            }
            fetchInvoices({
                variables: {
                    filter: filter
                }
            });
            // Reset flag after a short delay
            setTimeout(()=>{
                isFilterChangeRef.current = false;
            }, 100);
        }, 500); // 500ms debounce
        return ()=>{
            if (filterTimeoutRef.current) clearTimeout(filterTimeoutRef.current);
        };
    }, [
        pending,
        dueAndUnpaid,
        number,
        company,
        contactName,
        city,
        invoiceYears,
        ac,
        bpr,
        rb,
        pageSize,
        orderBy,
        orderDirection,
        fetchInvoices
    ]);
    // Reload when sorting changes
    const lastOrderByRef = (0, $bh6RR.useRef)(orderBy);
    const lastOrderDirectionRef = (0, $bh6RR.useRef)(orderDirection);
    (0, $bh6RR.useEffect)(()=>{
        // Skip if this is the initial mount or if values haven't changed
        if (!hasMounted.current) {
            lastOrderByRef.current = orderBy;
            lastOrderDirectionRef.current = orderDirection;
            return;
        }
        const isOrderByChange = lastOrderByRef.current !== orderBy;
        const isOrderDirectionChange = lastOrderDirectionRef.current !== orderDirection;
        if (isOrderByChange || isOrderDirectionChange) {
            // Build filter object with current filters and sorting
            const filter = {
                limit: pageSize,
                offset: 0 // Reset to first page when sorting changes
            };
            if (pending) filter.pending = true;
            if (dueAndUnpaid) filter.dueAndUnpaid = true;
            if (number && number.trim().length > 0) filter.number = number.trim();
            if (contactName && contactName.trim().length > 0) filter.contact_name = contactName.trim();
            if (city && city.trim().length > 0) filter.city = city.trim();
            if (invoiceYears.length > 0) filter.years = invoiceYears;
            if (company && company.name) filter.company_name = company.name.trim();
            // Add product codes filter
            const selectedProductCodes2 = [];
            if (ac) selectedProductCodes2.push($79065bcf5625e11c$var$ProductCodes.AC);
            if (bpr) selectedProductCodes2.push($79065bcf5625e11c$var$ProductCodes.BPR);
            if (rb) selectedProductCodes2.push($79065bcf5625e11c$var$ProductCodes.RB);
            if (selectedProductCodes2.length > 0) filter.productCodes = selectedProductCodes2;
            // Add sorting parameters
            if (orderBy) {
                filter.orderBy = orderBy;
                filter.orderDirection = orderDirection;
            }
            setPage(0); // Reset to first page
            fetchInvoices({
                variables: {
                    filter: filter
                }
            });
            lastOrderByRef.current = orderBy;
            lastOrderDirectionRef.current = orderDirection;
        }
    }, [
        orderBy,
        orderDirection,
        pageSize,
        pending,
        dueAndUnpaid,
        number,
        company,
        contactName,
        city,
        invoiceYears,
        ac,
        bpr,
        rb,
        fetchInvoices
    ]);
    // Reload when pagination changes (user clicks next/previous)
    (0, $bh6RR.useEffect)(()=>{
        if (isInitialMount.current) {
            isInitialMount.current = false;
            lastPageRef.current = page;
            lastPageSizeRef.current = pageSize;
            return;
        }
        // Check if this is a page change or pageSize change (not a filter change)
        const isPageChange = lastPageRef.current !== page;
        const isPageSizeChange = lastPageSizeRef.current !== pageSize;
        // If filters just changed and we're on page 0, skip this effect
        if (isFilterChangeRef.current && page === 0 && !isPageSizeChange) {
            lastPageRef.current = page;
            lastPageSizeRef.current = pageSize;
            return;
        }
        // Normal pagination change - fetch the new page explicitly
        if (isPageChange || isPageSizeChange) {
            const filter = {
                limit: pageSize,
                offset: page * pageSize
            };
            if (pending) filter.pending = true;
            if (dueAndUnpaid) filter.dueAndUnpaid = true;
            if (number && number.trim().length > 0) filter.number = number.trim();
            if (contactName && contactName.trim().length > 0) filter.contact_name = contactName.trim();
            if (city && city.trim().length > 0) filter.city = city.trim();
            if (invoiceYears.length > 0) filter.years = invoiceYears;
            if (company && company.name) filter.company_name = company.name.trim();
            // Add product codes filter
            const selectedProductCodes4 = [];
            if (ac) selectedProductCodes4.push($79065bcf5625e11c$var$ProductCodes.AC);
            if (bpr) selectedProductCodes4.push($79065bcf5625e11c$var$ProductCodes.BPR);
            if (rb) selectedProductCodes4.push($79065bcf5625e11c$var$ProductCodes.RB);
            if (selectedProductCodes4.length > 0) filter.productCodes = selectedProductCodes4;
            // Add sorting parameters
            if (orderBy) {
                filter.orderBy = orderBy;
                filter.orderDirection = orderDirection;
            }
            fetchInvoices({
                variables: {
                    filter: filter
                }
            });
            lastPageRef.current = page;
            lastPageSizeRef.current = pageSize;
        }
    }, [
        page,
        pageSize,
        pending,
        dueAndUnpaid,
        number,
        company,
        contactName,
        city,
        invoiceYears,
        ac,
        bpr,
        rb,
        orderBy,
        orderDirection,
        fetchInvoices
    ]);
    const handlePageChange = (_event, newPage)=>{
        setPage(newPage);
    };
    const handleRowsPerPageChange = (event)=>{
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPage(0);
    };
    const handleSortChange = (0, $bh6RR.useCallback)((newOrderBy, newOrderDirection)=>{
        setOrderBy(newOrderBy);
        setOrderDirection(newOrderDirection);
        setPage(0);
    }, []);
    const formatDate = (rowData, name)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return rowData[name] ? // @ts-ignore
        (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(parseInt(rowData[name])).format((0, $e2ibc.DATE_TIME_FORMATS).DATE) : "";
    };
    const renderStatus = (status)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)("p", {
            style: {
                color: status === (0, $e2ibc.INVOICE_STATUS_CONFIRMED) ? (0, $6L9uu.Colors).green : (0, $6L9uu.Colors).red
            },
            children: status
        });
    };
    const handlePendingPresses = ()=>{
        setPending(!pending);
        setDueAndUnpaid(false);
    };
    const handleDueAndUnpaidPressed = ()=>{
        setDueAndUnpaid(!dueAndUnpaid);
        setPending(false);
    };
    const handleProductCodePressed = (event)=>{
        const { name: name } = event.currentTarget;
        if (name === $79065bcf5625e11c$var$ProductCodes.AC) setAc(!ac);
        else if (name === $79065bcf5625e11c$var$ProductCodes.BPR) setBpr(!bpr);
        else if (name === $79065bcf5625e11c$var$ProductCodes.RB) setRb(!rb);
    };
    const handleYearChange = (_, years)=>{
        setInvoiceYears(years);
    };
    const resetFilters = ()=>{
        setPending(false);
        setDueAndUnpaid(false);
        setNumber("");
        setCompany(null);
        setContactName("");
        setCity("");
        setInvoiceYears([]);
        setAc(false);
        setBpr(false);
        setRb(false);
    };
    const handleDetails = (rowData)=>{
        setOpenWizard(true);
        dispatch({
            type: (0, $ayVxz.Actions).SetInvoice,
            payload: {
                invoice: rowData,
                productInfo: $79065bcf5625e11c$export$fb01acb62b8c4cba(rowData)
            }
        });
        dispatch({
            type: (0, $ayVxz.Actions).SetSelectedMembership,
            payload: {
                id: rowData.membership?.id,
                name: rowData.membership?.name,
                start_date: rowData.membership?.start_date ?? null,
                end_date: rowData.membership?.end_date ?? null
            }
        });
    };
    const removeInvoice = (rowData)=>dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete current pending invoice?`,
                agreeAction: handleDelete,
                params: Number(rowData.id)
            }
        });
    const handleDelete = (id)=>{
        deleteInvoice({
            variables: {
                id: id
            },
            update () {
                const invoiceToDelete = displayedInvoices.find((i)=>i.id === id.toString());
                (0, $gFVvY.removeInvoiceFromCache)(invoiceToDelete);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Invoice deleted ${id}`,
                        severity: "success"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        }).finally(()=>{
            dispatch({
                type: (0, $ayVxz.Actions).HideConfirmation
            });
        });
    };
    const columns = [
        {
            title: "Details",
            width: 63,
            sorting: false
        },
        {
            title: "Number",
            field: "number",
            width: 122
        },
        {
            title: "Date",
            field: "created_date",
            width: 97,
            type: "date",
            render: (rowData)=>formatDate(rowData, "created_date")
        },
        {
            title: "Due",
            field: "due_date",
            width: 97,
            type: "date",
            render: (rowData)=>formatDate(rowData, "due_date")
        },
        {
            title: "Date Paid",
            field: "due_date",
            width: 97,
            type: "date",
            render: (rowData)=>formatDate(rowData, "date_paid")
        },
        {
            title: "Status",
            field: "status.name",
            width: 97,
            type: "date",
            render: (rowData)=>renderStatus(rowData.status.name)
        },
        {
            title: "Invoice Total",
            field: "total",
            type: "numeric",
            width: 69
        },
        {
            title: "Company",
            field: "details.company_name",
            width: 231
        },
        {
            title: "Contact",
            width: 180,
            customSort: (a, b)=>{
                const firstContactName = `${a.details?.contact_first_name ?? ""} ${a.details?.contact_last_name ?? ""}`;
                const secondContactName = `${b.details?.contact_first_name ?? ""} ${b.details?.contact_last_name ?? ""}`;
                return firstContactName.localeCompare(secondContactName);
            },
            render: (rowData)=>`${rowData.details?.contact_first_name ?? ""} ${rowData.details?.contact_last_name ?? ""}`
        },
        {
            title: "Street",
            field: "details.street",
            width: 231
        },
        {
            title: "Product Code",
            field: "product.product_code.name",
            width: 70
        },
        {
            title: "City",
            field: "details.city",
            width: 166
        },
        {
            title: "Remove",
            width: 73,
            sorting: false
        }
    ];
    const companies = companyData.data?.result || [];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "overviewPage",
        sx: {
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                columns: columns,
                data: displayedInvoices,
                loading: loading,
                handleDetails: handleDetails,
                handleRemove: removeInvoice,
                hideSearch: true,
                additionalFilters: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    id: "filters",
                    sx: {
                        display: "flex",
                        gap: "20px",
                        flexWrap: "wrap"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                            id: "pending-filter-button",
                            "data-testid": "pending-filter-button",
                            variant: "contained",
                            onClick: handlePendingPresses,
                            sx: pending ? (0, $6L9uu.buttons).selected : (0, $6L9uu.buttons).deSelected,
                            color: "primary",
                            name: "pending",
                            children: "Pending"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                            id: "due-and-unpaid-filter-button",
                            "data-testid": "due-and-unpaid-filter-button",
                            variant: "contained",
                            sx: dueAndUnpaid ? (0, $6L9uu.buttons).selected : (0, $6L9uu.buttons).deSelected,
                            onClick: handleDueAndUnpaidPressed,
                            color: "primary",
                            name: "dueAndUnpaid",
                            children: "Due & Unpaid"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1u9dM.default), {
                            color: "inherit",
                            "aria-label": "outlined primary button group",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                                    id: "product-code-ac-filter-button",
                                    "data-testid": "product-code-ac-filter-button",
                                    variant: "contained",
                                    sx: ac ? {
                                        ...(0, $6L9uu.buttons).selected,
                                        width: $79065bcf5625e11c$var$groupButtonWidth
                                    } : {
                                        ...(0, $6L9uu.buttons).deSelected,
                                        width: $79065bcf5625e11c$var$groupButtonWidth
                                    },
                                    onClick: handleProductCodePressed,
                                    color: "primary",
                                    name: $79065bcf5625e11c$var$ProductCodes.AC,
                                    children: "AC"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                                    id: "product-code-bpr-filter-button",
                                    "data-testid": "product-code-bpr-filter-button",
                                    variant: "contained",
                                    sx: bpr ? {
                                        ...(0, $6L9uu.buttons).selected,
                                        width: $79065bcf5625e11c$var$groupButtonWidth
                                    } : {
                                        ...(0, $6L9uu.buttons).deSelected,
                                        width: $79065bcf5625e11c$var$groupButtonWidth
                                    },
                                    onClick: handleProductCodePressed,
                                    color: "primary",
                                    name: $79065bcf5625e11c$var$ProductCodes.BPR,
                                    children: "BPR"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                                    id: "product-code-rb-filter-button",
                                    "data-testid": "product-code-rb-filter-button",
                                    variant: "contained",
                                    sx: rb ? {
                                        ...(0, $6L9uu.buttons).selected,
                                        width: $79065bcf5625e11c$var$groupButtonWidth
                                    } : {
                                        ...(0, $6L9uu.buttons).deSelected,
                                        width: $79065bcf5625e11c$var$groupButtonWidth
                                    },
                                    onClick: handleProductCodePressed,
                                    color: "primary",
                                    name: $79065bcf5625e11c$var$ProductCodes.RB,
                                    children: "RB"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "invoice-number-filter",
                            label: "Number",
                            value: number,
                            onChange: (e)=>setNumber(e.target.value),
                            additionalStyle: {
                                width: "200px"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                            id: "company-filter",
                            label: "Company",
                            values: company,
                            options: companies,
                            onChange: (_, newValue)=>setCompany(newValue),
                            getOptionLabel: (option)=>option.name || "",
                            isSingle: true,
                            additionalStyle: {
                                width: "200px"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "contact-name-filter",
                            label: "Contact Name",
                            value: contactName,
                            onChange: (e)=>setContactName(e.target.value),
                            additionalStyle: {
                                width: "200px"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "city-filter",
                            label: "City",
                            value: city,
                            onChange: (e)=>setCity(e.target.value),
                            additionalStyle: {
                                width: "200px"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                            id: "invoice-year-label",
                            "data-testid": "invoice-year-label",
                            label: "Invoice Year",
                            values: invoiceYears,
                            options: yearsOptions,
                            isSingle: false,
                            onChange: handleYearChange,
                            getOptionLabel: (option)=>option.toString(),
                            additionalStyle: {
                                width: "200px"
                            },
                            renderTags: (value, getTagProps)=>value.map((option, index)=>{
                                    const { key: key, ...tagProps } = getTagProps({
                                        index: index
                                    });
                                    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                                        sx: {
                                            backgroundColor: (t)=>t.palette.grey[50],
                                            borderColor: (0, $6L9uu.Colors).skyBlue,
                                            height: "24px",
                                            color: (0, $6L9uu.Colors).main,
                                            "& .MuiChip-deleteIcon": {
                                                width: "20px",
                                                height: "20px",
                                                color: (0, $6L9uu.Colors).skyBlue,
                                                "&:hover": {
                                                    color: (0, $6L9uu.Colors).main
                                                }
                                            }
                                        },
                                        variant: "outlined",
                                        label: option,
                                        onMouseDown: (event)=>{
                                            event.stopPropagation();
                                        },
                                        ...tagProps
                                    }, option);
                                })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                            id: "clear-filter-button",
                            "data-testid": "clear-filter-button",
                            onClick: resetFilters,
                            text: "clear all",
                            sx: {
                                textDecoration: "underline",
                                "&:hover": {
                                    textDecoration: "underline",
                                    background: (theme)=>theme.palette.primary.main,
                                    color: (0, $6L9uu.Colors).white,
                                    border: "none"
                                }
                            }
                        })
                    ]
                }),
                page: page,
                onPageChange: handlePageChange,
                onRowsPerPageChange: handleRowsPerPageChange,
                totalCount: total,
                pageSize: pageSize,
                orderBy: orderBy,
                orderDirection: orderDirection,
                onSortChange: handleSortChange
            }),
            openWizard && /*#__PURE__*/ (0, $ih19M.jsx)((0, $7pnqR.default), {
                onClose: ()=>setOpenWizard(false)
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                loading: deleteInvoiceResult.loading
            })
        ]
    });
};
var $79065bcf5625e11c$export$2e2bcd8739ae039 = $79065bcf5625e11c$var$InvoiceList;

});
parcelRegister("oZMqz", function(module, exports) {

$parcel$export(module.exports, "calculateDiscountPercent", function () { return $93aada2f4f007a9c$export$565fa06a2df82f01; });
$parcel$export(module.exports, "calculateVat", function () { return $93aada2f4f007a9c$export$2e68bcf74ba69727; });
$parcel$export(module.exports, "weightCalculation", function () { return $93aada2f4f007a9c$export$2cb4f22f646e0fbc; });
$parcel$export(module.exports, "sumWeightPercentageCalculation", function () { return $93aada2f4f007a9c$export$3b0ab32fbb737e80; });
$parcel$export(module.exports, "normalizePercentInput", function () { return $93aada2f4f007a9c$export$6cd13d5bbbb321b7; });
$parcel$export(module.exports, "objectsAreEquel", function () { return $93aada2f4f007a9c$export$2072bbbe594598e0; });
$parcel$export(module.exports, "calculateMeetingDuration", function () { return $93aada2f4f007a9c$export$9f04ee47a21a543e; });
$parcel$export(module.exports, "numberWithCommas", function () { return $93aada2f4f007a9c$export$a2db1876938cd11d; });
const $93aada2f4f007a9c$export$565fa06a2df82f01 = (price, discount)=>{
    if (discount) return discount / price * 100;
    return 0;
};
const $93aada2f4f007a9c$export$2e68bcf74ba69727 = (price, discount, vatPercent)=>{
    if (vatPercent) {
        const disc = discount ? discount : 0;
        return (price - disc) * vatPercent / 100;
    }
    return 0;
};
const $93aada2f4f007a9c$export$2cb4f22f646e0fbc = (array)=>{
    let sum = 0;
    array.map((hc)=>typeof Number(hc.weighting) === "number" ? sum += Number(hc.weighting) : sum += 0);
    if (sum !== null) return sum;
    else return 0;
};
const $93aada2f4f007a9c$export$3b0ab32fbb737e80 = (array)=>{
    let percentageSum = 0;
    array.map((hc)=>typeof Number(hc.weight_perc) === "number" ? percentageSum += Number(hc.weight_perc) : percentageSum += 0);
    if (percentageSum !== null) return Number(percentageSum.toFixed(2));
    else return 0;
};
const $93aada2f4f007a9c$export$6cd13d5bbbb321b7 = (input)=>{
    let result = input;
    if (input < 0) result = 0;
    if (input > 100) result = 100;
    return Number(result.toFixed(2));
};
const $93aada2f4f007a9c$export$2072bbbe594598e0 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (obj1 === null || obj2 === null || typeof obj1 !== "object" || typeof obj2 !== "object") return false;
    const obj1Keys = Object.keys(obj1);
    const obj2Keys = Object.keys(obj2);
    if (obj1Keys.length !== obj2Keys.length) return false;
    for (const key of obj1Keys){
        if (!obj2Keys.includes(key)) return false;
        if (typeof obj1[key] === "object") {
            if (!$93aada2f4f007a9c$export$2072bbbe594598e0(obj1[key], obj2[key])) return false;
        } else if (typeof obj1[key] !== typeof obj2[key] || obj1[key] !== obj2[key]) return false;
    }
    return true;
};
const $93aada2f4f007a9c$export$9f04ee47a21a543e = (startTime, endTime)=>{
    const startDate = $93aada2f4f007a9c$var$parseDate(startTime);
    const endDate = $93aada2f4f007a9c$var$parseDate(endTime);
    if (startDate && endDate) {
        // Calculate the time difference in milliseconds
        const timeDifference = endDate.getTime() - startDate.getTime();
        // Convert milliseconds to HH:MM format
        const hours = Math.floor(timeDifference / 3600000);
        const minutes = Math.floor(timeDifference % 3600000 / 60000);
        // Format the result
        const formattedDuration = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
        return formattedDuration;
    }
    return "Invalid date format";
};
const $93aada2f4f007a9c$var$parseDate = (dateTime)=>{
    const [day, month, year, hour, minute] = dateTime.match(/\d+/g)?.map(Number) || [];
    if (day && month && year && hour !== undefined && minute !== undefined) return new Date(year, month - 1, day, hour, minute);
    return null;
};
const $93aada2f4f007a9c$export$a2db1876938cd11d = (x)=>{
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

});

parcelRegister("1u9dM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $114fbeed02f1f806$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $cG3EF = parcelRequire("cG3EF");

var $axlbu = parcelRequire("axlbu");

var $fGH8N = parcelRequire("fGH8N");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $4kIql = parcelRequire("4kIql");

var $lGzv4 = parcelRequire("lGzv4");

var $14scH = parcelRequire("14scH");

var $ih19M = parcelRequire("ih19M");
"use client";
const $114fbeed02f1f806$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "disableRipple",
    "fullWidth",
    "orientation",
    "size",
    "variant"
];
const $114fbeed02f1f806$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $4kIql.default).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $4kIql.default).grouped}`]: styles[`grouped${(0, $fGH8N.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $4kIql.default).grouped}`]: styles[`grouped${(0, $fGH8N.default)(ownerState.variant)}`]
        },
        {
            [`& .${(0, $4kIql.default).grouped}`]: styles[`grouped${(0, $fGH8N.default)(ownerState.variant)}${(0, $fGH8N.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $4kIql.default).grouped}`]: styles[`grouped${(0, $fGH8N.default)(ownerState.variant)}${(0, $fGH8N.default)(ownerState.color)}`]
        },
        {
            [`& .${(0, $4kIql.default).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $4kIql.default).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $4kIql.default).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === "vertical" && styles.vertical
    ];
};
const $114fbeed02f1f806$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            orientation === "vertical" && "vertical",
            fullWidth && "fullWidth",
            disableElevation && "disableElevation"
        ],
        grouped: [
            "grouped",
            `grouped${(0, $fGH8N.default)(orientation)}`,
            `grouped${(0, $fGH8N.default)(variant)}`,
            `grouped${(0, $fGH8N.default)(variant)}${(0, $fGH8N.default)(orientation)}`,
            `grouped${(0, $fGH8N.default)(variant)}${(0, $fGH8N.default)(color)}`,
            disabled && "disabled"
        ],
        firstButton: [
            "firstButton"
        ],
        lastButton: [
            "lastButton"
        ],
        middleButton: [
            "middleButton"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $4kIql.getButtonGroupUtilityClass), classes);
};
const $114fbeed02f1f806$var$ButtonGroupRoot = (0, $g4l1t.default)("div", {
    name: "MuiButtonGroup",
    slot: "Root",
    overridesResolver: $114fbeed02f1f806$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "inline-flex",
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.variant === "contained" && {
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.disableElevation && {
        boxShadow: "none"
    }, ownerState.fullWidth && {
        width: "100%"
    }, ownerState.orientation === "vertical" && {
        flexDirection: "column"
    }, {
        [`& .${(0, $4kIql.default).grouped}`]: (0, $4WYaH.default)({
            minWidth: 40,
            "&:hover": (0, $4WYaH.default)({}, ownerState.variant === "contained" && {
                boxShadow: "none"
            })
        }, ownerState.variant === "contained" && {
            boxShadow: "none"
        }),
        [`& .${(0, $4kIql.default).firstButton},& .${(0, $4kIql.default).middleButton}`]: (0, $4WYaH.default)({}, ownerState.orientation === "horizontal" && {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        }, ownerState.orientation === "vertical" && {
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0
        }, ownerState.variant === "text" && ownerState.orientation === "horizontal" && {
            borderRight: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
            [`&.${(0, $4kIql.default).disabled}`]: {
                borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === "text" && ownerState.orientation === "vertical" && {
            borderBottom: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
            [`&.${(0, $4kIql.default).disabled}`]: {
                borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            borderColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $cG3EF.alpha)(theme.palette[ownerState.color].main, 0.5)
        }, ownerState.variant === "outlined" && ownerState.orientation === "horizontal" && {
            borderRightColor: "transparent"
        }, ownerState.variant === "outlined" && ownerState.orientation === "vertical" && {
            borderBottomColor: "transparent"
        }, ownerState.variant === "contained" && ownerState.orientation === "horizontal" && {
            borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
            [`&.${(0, $4kIql.default).disabled}`]: {
                borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === "contained" && ownerState.orientation === "vertical" && {
            borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
            [`&.${(0, $4kIql.default).disabled}`]: {
                borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            borderColor: (theme.vars || theme).palette[ownerState.color].dark
        }, {
            "&:hover": (0, $4WYaH.default)({}, ownerState.variant === "outlined" && ownerState.orientation === "horizontal" && {
                borderRightColor: "currentColor"
            }, ownerState.variant === "outlined" && ownerState.orientation === "vertical" && {
                borderBottomColor: "currentColor"
            })
        }),
        [`& .${(0, $4kIql.default).lastButton},& .${(0, $4kIql.default).middleButton}`]: (0, $4WYaH.default)({}, ownerState.orientation === "horizontal" && {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }, ownerState.orientation === "vertical" && {
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0
        }, ownerState.variant === "outlined" && ownerState.orientation === "horizontal" && {
            marginLeft: -1
        }, ownerState.variant === "outlined" && ownerState.orientation === "vertical" && {
            marginTop: -1
        })
    }));
const $114fbeed02f1f806$var$ButtonGroup = /*#__PURE__*/ $bh6RR.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiButtonGroup"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = "horizontal", size: size = "medium", variant: variant = "outlined" } = props, other = (0, $hCIyK.default)(props, $114fbeed02f1f806$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    });
    const classes = $114fbeed02f1f806$var$useUtilityClasses(ownerState);
    const context = $bh6RR.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $axlbu.default)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return "";
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)($114fbeed02f1f806$var$ButtonGroupRoot, (0, $4WYaH.default)({
        as: component,
        role: "group",
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lGzv4.default).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $14scH.default).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
var $114fbeed02f1f806$export$2e2bcd8739ae039 = $114fbeed02f1f806$var$ButtonGroup;

});
parcelRegister("axlbu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7abd6b32c7c9b11e$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
function $7abd6b32c7c9b11e$export$2e2bcd8739ae039(children) {
    return $bh6RR.Children.toArray(children).filter((child)=>/*#__PURE__*/ $bh6RR.isValidElement(child));
}

});

parcelRegister("4kIql", function(module, exports) {

$parcel$export(module.exports, "getButtonGroupUtilityClass", function () { return $327b7d584bcddf0f$export$b85c003f960b1f3a; });
$parcel$export(module.exports, "default", function () { return $327b7d584bcddf0f$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $327b7d584bcddf0f$export$b85c003f960b1f3a(slot) {
    return (0, $XybB6.default)("MuiButtonGroup", slot);
}
const $327b7d584bcddf0f$var$buttonGroupClasses = (0, $igcUF.default)("MuiButtonGroup", [
    "root",
    "contained",
    "outlined",
    "text",
    "disableElevation",
    "disabled",
    "firstButton",
    "fullWidth",
    "vertical",
    "grouped",
    "groupedHorizontal",
    "groupedVertical",
    "groupedText",
    "groupedTextHorizontal",
    "groupedTextVertical",
    "groupedTextPrimary",
    "groupedTextSecondary",
    "groupedOutlined",
    "groupedOutlinedHorizontal",
    "groupedOutlinedVertical",
    "groupedOutlinedPrimary",
    "groupedOutlinedSecondary",
    "groupedContained",
    "groupedContainedHorizontal",
    "groupedContainedVertical",
    "groupedContainedPrimary",
    "groupedContainedSecondary",
    "lastButton",
    "middleButton"
]);
var $327b7d584bcddf0f$export$2e2bcd8739ae039 = $327b7d584bcddf0f$var$buttonGroupClasses;

});


parcelRegister("7pnqR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5ee45d4590ab2b0$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");

var $2glCg = parcelRequire("2glCg");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hjfla = parcelRequire("hjfla");

var $jvWbt = parcelRequire("jvWbt");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $72HIx = parcelRequire("72HIx");

var $cnCqi = parcelRequire("cnCqi");

var $cAzF9 = parcelRequire("cAzF9");

var $2OHqK = parcelRequire("2OHqK");

var $dqRXb = parcelRequire("dqRXb");

var $gUBkJ = parcelRequire("gUBkJ");

var $8d818 = parcelRequire("8d818");

var $2lD0z = parcelRequire("2lD0z");
const $f5ee45d4590ab2b0$var$steps = [
    "My Details",
    "Client",
    "Product & Pricing",
    "Invoice"
];
const $f5ee45d4590ab2b0$var$InvoiceStepper = ({ onClose: onClose, addNewInvoice: addNewInvoice, editInvoice: editInvoice, cventContact: cventContact })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [activeStep, setActiveStep] = (0, $bh6RR.useState)(state.selectedInvoice?.status === (0, $2glCg.InvoiceStatus).New ? 1 : 3);
    const [getDbPaymentDetails, dbPaymentDetails] = (0, $hjfla.usePaymentDetailsLazyQuery)({
        fetchPolicy: "no-cache"
    });
    const [createInvoice, createInvoiceResult] = (0, $hjfla.useCreateInvoiceMutation)();
    const [updateInvoice, updateInvoiceResult] = (0, $hjfla.useUpdateInvoiceMutation)();
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Invoice);
    const [currentPoNumber, setCurrentPoNumber] = (0, $bh6RR.useState)("");
    const [currentRemarks, setNewRemarks] = (0, $bh6RR.useState)("");
    const [currentInvoiceContact, setCurrentInvoiceContact] = (0, $bh6RR.useState)(null);
    const isPoNumberEdited = currentPoNumber !== state.selectedInvoice?.po_nr;
    const isRemarkInputEdited = currentRemarks !== state.selectedInvoice?.remarks;
    const isContactEdited = currentInvoiceContact !== state.selectedInvoice?.contact;
    const [dbContact, setDbContact] = (0, $bh6RR.useState)(null);
    const dbContactData = (0, $hjfla.useContactByEmailAndFullNameQuery)({
        variables: {
            fullName: state.selectedInvoice?.contact?.fullName,
            email: state.selectedInvoice?.contact?.email
        },
        fetchPolicy: "no-cache"
    });
    (0, $bh6RR.useEffect)(()=>{
        if (dbContactData && dbContactData.data?.result) setDbContact(dbContactData.data?.result);
    }, [
        dbContactData.data?.result
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (!state.selectedInvoice?.paymentDetails) getDbPaymentDetails();
        setCurrentPoNumber(state.selectedInvoice?.po_nr);
        setNewRemarks(state.selectedInvoice?.remarks);
        setCurrentInvoiceContact(state.selectedInvoice?.contact);
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (dbPaymentDetails.data && dbPaymentDetails.data.result) {
            const data = dbPaymentDetails.data.result;
            dispatch({
                type: (0, $ayVxz.Actions).SetInvoicePaymentDetails,
                payload: data
            });
        }
    }, [
        dbPaymentDetails.data
    ]);
    const getStepContent = (stepIndex)=>{
        switch(stepIndex){
            case 0:
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $jvWbt.default), {});
            case 1:
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $72HIx.default), {
                    cventContact: cventContact
                });
            case 2:
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cnCqi.default), {});
            case 3:
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cAzF9.default), {
                    editInvoice: editInvoice,
                    dbContact: dbContact
                });
            default:
                return "Unknown stepIndex";
        }
    };
    const handleNext = ()=>{
        if (activeStep === 0) {
            const selectedInvoice = state.selectedInvoice;
            if (selectedInvoice.isPaymentDetailsInEditMode) dispatch({
                type: (0, $ayVxz.Actions).SetInvoiceErrors,
                payload: {
                    ...selectedInvoice.errors,
                    isPaymentDetailsInEditMode: true
                }
            });
            else setActiveStep((prevActiveStep)=>prevActiveStep + 1);
        } else if (activeStep === 1) {
            const { errors: errors } = state.selectedInvoice;
            let hasErrors = errors.company && errors.company !== null || errors.contact && errors.contact !== null || errors.address && errors.address !== null;
            const stepErrors = errors;
            if (!hasErrors) {
                if (!state.selectedInvoice?.company) {
                    hasErrors = true;
                    stepErrors.company = "Select company";
                }
                if (!state.selectedInvoice?.contact) {
                    hasErrors = true;
                    stepErrors.contact = "Select contact";
                }
                if (!state.selectedInvoice?.address) {
                    hasErrors = true;
                    stepErrors.address = "Select address";
                }
            }
            if (hasErrors) dispatch({
                type: (0, $ayVxz.Actions).SetInvoiceErrors,
                payload: {
                    ...stepErrors
                }
            });
            else setActiveStep((prevActiveStep)=>prevActiveStep + 1);
        } else if (activeStep === 2) {
            if (!state.selectedInvoice?.productInfo?.product) dispatch({
                type: (0, $ayVxz.Actions).SetInvoiceErrors,
                payload: {
                    product: "Select product"
                }
            });
            else {
                dispatch({
                    type: (0, $ayVxz.Actions).ResetInvoiceErrors
                });
                setActiveStep((prevActiveStep)=>prevActiveStep + 1);
            }
        } else if (activeStep === 3) {
            const selectedInvoice = state.selectedInvoice;
            if (selectedInvoice.status === (0, $2glCg.InvoiceStatus).New) {
                if (isValidInvoice(selectedInvoice)) {
                    const input = getInvoiceInputDto(selectedInvoice);
                    createInvoice({
                        variables: {
                            input: input
                        },
                        update (_, { data: data }) {
                            if (data?.result) {
                                dispatch({
                                    type: (0, $ayVxz.Actions).SetInvoice,
                                    payload: {
                                        invoice: data.result,
                                        productInfo: (0, $2OHqK.getInvoiceProductInfoDto)(data.result)
                                    }
                                });
                                if (addNewInvoice) addNewInvoice(data.result);
                                dispatch({
                                    type: (0, $ayVxz.Actions).ShowMessage,
                                    payload: {
                                        severity: "success",
                                        text: `You have successfully created new invoice`
                                    }
                                });
                            }
                        }
                    }).catch((e)=>{
                        dispatch({
                            type: (0, $ayVxz.Actions).ShowMessage,
                            payload: {
                                severity: "error",
                                text: e.message,
                                autoHide: 6000
                            }
                        });
                    });
                }
            } else if (state.selectedInvoice?.status === (0, $2glCg.InvoiceStatus).Pending || state.selectedInvoice?.status === (0, $2glCg.InvoiceStatus).Confirmed) {
                if (isValidInvoice(selectedInvoice)) {
                    if (!hasInvoiceChanged(selectedInvoice) && !isPoNumberEdited && !isRemarkInputEdited) dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "warning",
                            text: `There is no new information to save`
                        }
                    });
                    else updateInvoice({
                        variables: {
                            id: parseInt(selectedInvoice.invoice_full?.id),
                            input: getInvoiceInputDto(selectedInvoice, selectedInvoice.invoice_full)
                        },
                        update (_, { data: data }) {
                            if (data?.result) {
                                dispatch({
                                    type: (0, $ayVxz.Actions).SetInvoice,
                                    payload: {
                                        invoice: data.result,
                                        productInfo: (0, $2OHqK.getInvoiceProductInfoDto)(data.result)
                                    }
                                });
                                if (editInvoice) editInvoice(data.result);
                                dispatch({
                                    type: (0, $ayVxz.Actions).ShowMessage,
                                    payload: {
                                        severity: "success",
                                        text: `You have successfully updated invoice`
                                    }
                                });
                            }
                        }
                    }).catch((e)=>{
                        dispatch({
                            type: (0, $ayVxz.Actions).ShowMessage,
                            payload: {
                                severity: "error",
                                text: e.message,
                                autoHide: 6000
                            }
                        });
                    });
                }
            }
        }
    };
    const isValidInvoice = (selectedInvoice)=>{
        if (!selectedInvoice.productInfo) return false;
        if (!selectedInvoice.paymentDetails) return false;
        if (!selectedInvoice.company) return false;
        if (!selectedInvoice.contact) return false;
        if (!selectedInvoice.address) return false;
        return true;
    };
    const hasInvoiceChanged = (selectedInvoice)=>{
        const originalInvoice = selectedInvoice.invoice_full;
        // Payment Details Step
        if (selectedInvoice.paymentDetails?.id !== originalInvoice.paymentDetails.id) return true;
        // Client Step
        if (selectedInvoice.company?.name !== originalInvoice.details.company_name) return true;
        if (selectedInvoice.contact?.fullName !== `${originalInvoice.details.contact_first_name} ${originalInvoice.details.contact_last_name}`) return true;
        if (selectedInvoice.contact.email !== originalInvoice.details.contact_email) return true;
        if (selectedInvoice.address?.name !== originalInvoice.details.address_name) return true;
        // Product Step
        if (selectedInvoice.productInfo?.product?.id !== originalInvoice.product.id) return true;
        if (selectedInvoice.productInfo.discount !== originalInvoice.discount) return true;
        if (selectedInvoice.productInfo.vatPercent !== originalInvoice.vat) return true;
        if (selectedInvoice.notes !== originalInvoice.notes) return true;
        return false;
    };
    const getInvoiceInputDto = (selectedInvoice, originalInvoice)=>{
        const res = {
            product_id: parseInt(selectedInvoice.productInfo?.product?.id),
            membership_id: parseInt(state.selectedMembership?.id),
            payment_details_id: parseInt(selectedInvoice.paymentDetails?.id),
            total: selectedInvoice.productInfo?.total,
            discount: selectedInvoice.productInfo?.discount ?? 0,
            vat: selectedInvoice.productInfo?.vatPercent ?? 0,
            details: getPaymentDetailsDto(selectedInvoice, originalInvoice),
            notes: selectedInvoice.notes,
            po_nr: selectedInvoice.po_nr,
            remarks: selectedInvoice.remarks
        };
        return res;
    };
    const getPaymentDetailsDto = (selectedInvoice, originalInvoice)=>{
        return {
            company_name: selectedInvoice.company?.name ?? originalInvoice?.details?.company_name,
            company_address_vat: selectedInvoice.company?.main_address?.complete_vat_number ?? originalInvoice?.details?.company_address_vat,
            contact_first_name: selectedInvoice.contact?.first_name ?? originalInvoice?.details?.contact_first_name,
            contact_last_name: selectedInvoice.contact?.last_name ?? originalInvoice?.details?.contact_last_name,
            contact_email: selectedInvoice.contact?.email ?? originalInvoice?.details?.contact_email,
            address_name: selectedInvoice.address?.name ?? originalInvoice?.details?.address_name,
            street: selectedInvoice.address?.street ?? originalInvoice?.details?.street,
            city: selectedInvoice.address?.city ?? originalInvoice?.details?.city,
            zip: selectedInvoice.address?.zip ?? originalInvoice?.details?.zip,
            country: selectedInvoice.address?.country?.name ?? originalInvoice?.details?.country,
            region: selectedInvoice.address?.country?.region?.name ?? originalInvoice?.details?.region,
            title_external: selectedInvoice.invoice_full?.details.title_external ?? dbContact?.title_external,
            prefix: selectedInvoice.invoice_full?.details.prefix ?? dbContact?.prefix,
            vat_countrycode: originalInvoice?.details.vat_countrycode
        };
    };
    const handleBack = ()=>{
        setActiveStep((prevActiveStep)=>prevActiveStep - 1);
    };
    const handleClose = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).ResetInvoice
        });
        onClose();
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "invoice-wizard-stepper",
        title: state.selectedInvoice?.status === (0, $2glCg.InvoiceStatus).New ? "Create Invoice" : "Invoice",
        width: 1200,
        onClose: handleClose,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2lD0z.default), {
                steps: $f5ee45d4590ab2b0$var$steps,
                activeStep: activeStep
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    minHeight: "370px"
                },
                children: getStepContent(activeStep)
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    gridColumn: "span 3",
                    marginTop: "100px",
                    marginBottom: "40px"
                },
                children: [
                    activeStep !== 0 && /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "invoice-stepper-back-button",
                        onClick: handleBack,
                        text: "Back"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "invoice-stepper-save-next-button",
                        disabled: activeStep === $f5ee45d4590ab2b0$var$steps.length - 1 && (!canEdit || state.selectedInvoice?.status !== (0, $2glCg.InvoiceStatus).New && state.selectedInvoice?.status !== (0, $2glCg.InvoiceStatus).Pending && !isPoNumberEdited && !isRemarkInputEdited && !isContactEdited),
                        onClick: handleNext,
                        text: activeStep === $f5ee45d4590ab2b0$var$steps.length - 1 ? "Save" : "Next"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                loading: createInvoiceResult.loading || updateInvoiceResult.loading
            })
        ]
    });
};
var $f5ee45d4590ab2b0$export$2e2bcd8739ae039 = $f5ee45d4590ab2b0$var$InvoiceStepper;

});
parcelRegister("jvWbt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5b8b4ed77d68e0b$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");

var $bSbwb = parcelRequire("bSbwb");

var $6L9uu = parcelRequire("6L9uu");

var $ayVxz = parcelRequire("ayVxz");

var $bu31C = parcelRequire("bu31C");

var $dqRXb = parcelRequire("dqRXb");

var $gUBkJ = parcelRequire("gUBkJ");

var $2glCg = parcelRequire("2glCg");

var $hKISe = parcelRequire("hKISe");
var $3Xpkr = parcelRequire("3Xpkr");
var $bwbWe = parcelRequire("bwbWe");
var $kso7N = parcelRequire("kso7N");
var $cSN6l = parcelRequire("cSN6l");
var $dgmqH = parcelRequire("dgmqH");
var $64mWt = parcelRequire("64mWt");

var $hjfla = parcelRequire("hjfla");

var $79Qyg = parcelRequire("79Qyg");

var $ehzwo = parcelRequire("ehzwo");

var $hsjD5 = parcelRequire("hsjD5");
const $d5b8b4ed77d68e0b$export$1067ba46601ca091 = {
    contactAddressName: "Contact address name is required",
    contactAddress: "Contact address is required",
    contactPhone: "Contact phone number is required",
    contactPhoneFormat: "Contact phone should start with +",
    contactFax: "Contact fax is required",
    contactFaxFormat: "Contact fax should start with +",
    contactVat: "VAT number is required",
    bankName: "Bank is required",
    bankAffiliate: "Bank affiliate is required",
    bankAddress: "Bank address is required",
    bankBic: "Bank BIC is required",
    bankIban: "Bank IBAN is required"
};
const $d5b8b4ed77d68e0b$var$defaultErrorsObj = {
    contactAddressName: null,
    contactAddress: null,
    contactPhone: null,
    contactFax: null,
    contactVat: null,
    bankName: null,
    bankAffiliate: null,
    bankAddress: null,
    bankBic: null,
    bankIban: null
};
const $d5b8b4ed77d68e0b$var$defaultPaymentDto = {
    id: "",
    contact_address_name: "",
    contact_address: "",
    contact_phone: "",
    contact_fax: "",
    contact_vat: "",
    bank_name: "",
    bank_affiliate: "",
    bank_address: "",
    bank_bic: "",
    bank_iban: ""
};
const $d5b8b4ed77d68e0b$var$PaymentDetailsStep = ({ paymentDetailsInput: paymentDetailsInput, updateDetails: updateDetails })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [addPaymentDetails, addPaymentDetailsResult] = (0, $hjfla.useAddPaymentDetailsMutation)();
    const [originalPaymentDetails, setOriginalPaymentDetails] = (0, $bh6RR.useState)(state.selectedInvoice?.paymentDetails || paymentDetailsInput || $d5b8b4ed77d68e0b$var$defaultPaymentDto);
    const [editable, setEditable] = (0, $bh6RR.useState)(false);
    const [addressName, setAddressName] = (0, $bh6RR.useState)(originalPaymentDetails.contact_address_name);
    const [address, setAddress] = (0, $bh6RR.useState)(originalPaymentDetails.contact_address);
    const [phone, setPhone] = (0, $bh6RR.useState)(originalPaymentDetails.contact_phone);
    const [fax, setFax] = (0, $bh6RR.useState)(originalPaymentDetails.contact_fax);
    const [vat, setVat] = (0, $bh6RR.useState)(originalPaymentDetails.contact_vat);
    const [bankName, setBankName] = (0, $bh6RR.useState)(originalPaymentDetails.bank_name);
    const [bankAffiliate, setBankAffiliate] = (0, $bh6RR.useState)(originalPaymentDetails.bank_affiliate);
    const [bankAddress, setBankAddress] = (0, $bh6RR.useState)(originalPaymentDetails.bank_address);
    const [bankBic, setBankBic] = (0, $bh6RR.useState)(originalPaymentDetails.bank_bic);
    const [bankIban, setBankIban] = (0, $bh6RR.useState)(originalPaymentDetails.bank_iban);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($d5b8b4ed77d68e0b$var$defaultErrorsObj);
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Invoice);
    (0, $bh6RR.useEffect)(()=>{
        if (paymentDetailsInput) {
            setAddressName(paymentDetailsInput.contact_address_name);
            setAddress(paymentDetailsInput.contact_address);
            setPhone(paymentDetailsInput.contact_phone);
            setFax(paymentDetailsInput.contact_fax);
            setVat(paymentDetailsInput.contact_vat);
            setBankName(paymentDetailsInput.bank_name);
            setBankAffiliate(paymentDetailsInput.bank_affiliate);
            setBankAddress(paymentDetailsInput.bank_address);
            setBankBic(paymentDetailsInput.bank_bic);
            setBankIban(paymentDetailsInput.bank_iban);
        }
    }, [
        paymentDetailsInput
    ]);
    const setEditMode = (value)=>{
        dispatch({
            type: (0, $ayVxz.Actions).SetInvoicePaymentDetailsMode,
            payload: value
        });
        setEditable(value);
        if (!value) {
            const errors = {
                ...state.selectedInvoice?.errors
            };
            delete errors.isPaymentDetailsInEditMode;
            dispatch({
                type: (0, $ayVxz.Actions).SetInvoiceErrors,
                payload: {
                    ...errors
                }
            });
        }
    };
    const resetInputFieldsValue = (data)=>{
        setAddressName(data.contact_address_name);
        setAddress(data.contact_address);
        setPhone(data.contact_phone);
        setFax(data.contact_fax);
        setVat(data.contact_vat);
        setBankName(data.bank_name);
        setBankAffiliate(data.bank_affiliate);
        setBankAddress(data.bank_address);
        setBankBic(data.bank_bic);
        setBankIban(data.bank_iban);
    };
    const shouldEditPage = ()=>{
        let result = false;
        const invoiceStatus = state.selectedInvoice?.status;
        if (canEdit && (invoiceStatus === (0, $2glCg.InvoiceStatus).New || invoiceStatus === (0, $2glCg.InvoiceStatus).Pending)) result = true;
        return result;
    };
    const handleCancelEdit = ()=>{
        resetInputFieldsValue(originalPaymentDetails);
        setFormErrors($d5b8b4ed77d68e0b$var$defaultErrorsObj);
        setEditMode(false);
    };
    const handleSave = ()=>{
        let hasErrors = false;
        if (!isValidValue(addressName)) hasErrors = true;
        if (!isValidValue(address)) hasErrors = true;
        if (!isValidValue(phone)) hasErrors = true;
        if (!isValidPhoneFormat(phone)) hasErrors = true;
        if (!isValidValue(fax)) hasErrors = true;
        if (!isValidPhoneFormat(fax)) hasErrors = true;
        if (!isValidValue(vat)) hasErrors = true;
        if (!isValidValue(bankName)) hasErrors = true;
        if (!isValidValue(bankAffiliate)) hasErrors = true;
        if (!isValidValue(bankAddress)) hasErrors = true;
        if (!isValidValue(bankBic)) hasErrors = true;
        if (!isValidValue(bankIban)) hasErrors = true;
        if (!hasErrors) {
            if (!hasPaymentDetailsChanged()) dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "warning",
                    text: `There is no new information to save`
                }
            });
            else addPaymentDetails({
                variables: {
                    input: {
                        contact_address_name: addressName.trim(),
                        contact_address: address.trim(),
                        contact_phone: phone.trim(),
                        contact_fax: fax.trim(),
                        contact_vat: vat.trim(),
                        bank_name: bankName.trim(),
                        bank_affiliate: bankAffiliate.trim(),
                        bank_address: bankAddress.trim(),
                        bank_bic: bankBic.trim(),
                        bank_iban: bankIban.trim()
                    }
                },
                update (_, { data: data }) {
                    if (data?.result) {
                        setOriginalPaymentDetails(data.result);
                        dispatch({
                            type: (0, $ayVxz.Actions).SetInvoicePaymentDetails,
                            payload: data.result
                        });
                        dispatch({
                            type: (0, $ayVxz.Actions).ShowMessage,
                            payload: {
                                severity: "success",
                                text: `You have successfully added new payment details`
                            }
                        });
                        if (updateDetails) updateDetails(data.result);
                        setEditMode(false);
                    }
                }
            }).catch((e)=>dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "error",
                        text: e.message,
                        autoHide: 6000
                    }
                }));
        }
    };
    const hasPaymentDetailsChanged = ()=>{
        if (originalPaymentDetails.contact_address_name.trim() !== addressName.trim()) return true;
        if (originalPaymentDetails.contact_address.trim() !== address.trim()) return true;
        if (originalPaymentDetails.contact_phone.trim() !== phone.trim()) return true;
        if (originalPaymentDetails.contact_fax.trim() !== fax.trim()) return true;
        if (originalPaymentDetails.contact_vat.trim() !== vat.trim()) return true;
        if (originalPaymentDetails.bank_name.trim() !== bankName.trim()) return true;
        if (originalPaymentDetails.bank_affiliate.trim() !== bankAffiliate.trim()) return true;
        if (originalPaymentDetails.bank_address.trim() !== bankAddress.trim()) return true;
        if (originalPaymentDetails.bank_bic.trim() !== bankBic.trim()) return true;
        if (originalPaymentDetails.bank_iban.trim() !== bankIban.trim()) return true;
        return false;
    };
    const isValidValue = (value)=>{
        return value.trim() && value.trim().length >= 2 ? true : false;
    };
    const isValidPhoneFormat = (value)=>{
        return value.trim()[0] === "+";
    };
    const handleAddressNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!isValidValue(value)) setFormErrors({
            ...formErrors,
            contactAddressName: $d5b8b4ed77d68e0b$export$1067ba46601ca091.contactAddressName
        });
        else setFormErrors({
            ...formErrors,
            contactAddressName: null
        });
        setAddressName(value);
    };
    const handleAddressChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!isValidValue(value)) setFormErrors({
            ...formErrors,
            contactAddress: $d5b8b4ed77d68e0b$export$1067ba46601ca091.contactAddress
        });
        else setFormErrors({
            ...formErrors,
            contactAddress: null
        });
        setAddress(value);
    };
    const handlePhoneChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!isValidValue(value)) setFormErrors({
            ...formErrors,
            contactPhone: $d5b8b4ed77d68e0b$export$1067ba46601ca091.contactPhone
        });
        else if (!isValidPhoneFormat(value)) setFormErrors({
            ...formErrors,
            contactPhone: $d5b8b4ed77d68e0b$export$1067ba46601ca091.contactPhoneFormat
        });
        else setFormErrors({
            ...formErrors,
            contactPhone: null
        });
        setPhone(value);
    };
    const handleFaxChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!isValidValue(value)) setFormErrors({
            ...formErrors,
            contactFax: $d5b8b4ed77d68e0b$export$1067ba46601ca091.contactFax
        });
        else if (!isValidPhoneFormat(value)) setFormErrors({
            ...formErrors,
            contactFax: $d5b8b4ed77d68e0b$export$1067ba46601ca091.contactFaxFormat
        });
        else setFormErrors({
            ...formErrors,
            contactFax: null
        });
        setFax(value);
    };
    const handleVatChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!isValidValue(value)) setFormErrors({
            ...formErrors,
            contactVat: $d5b8b4ed77d68e0b$export$1067ba46601ca091.contactVat
        });
        else setFormErrors({
            ...formErrors,
            contactVat: null
        });
        setVat(value);
    };
    const handleBankNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!isValidValue(value)) setFormErrors({
            ...formErrors,
            bankName: $d5b8b4ed77d68e0b$export$1067ba46601ca091.bankName
        });
        else setFormErrors({
            ...formErrors,
            bankName: null
        });
        setBankName(value);
    };
    const handleBankAffiliateChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!isValidValue(value)) setFormErrors({
            ...formErrors,
            bankAffiliate: $d5b8b4ed77d68e0b$export$1067ba46601ca091.bankAffiliate
        });
        else setFormErrors({
            ...formErrors,
            bankAffiliate: null
        });
        setBankAffiliate(value);
    };
    const handleBankAddressChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!isValidValue(value)) setFormErrors({
            ...formErrors,
            bankAddress: $d5b8b4ed77d68e0b$export$1067ba46601ca091.bankAddress
        });
        else setFormErrors({
            ...formErrors,
            bankAddress: null
        });
        setBankAddress(value);
    };
    const handleBankBicChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!isValidValue(value)) setFormErrors({
            ...formErrors,
            bankBic: $d5b8b4ed77d68e0b$export$1067ba46601ca091.bankBic
        });
        else setFormErrors({
            ...formErrors,
            bankBic: null
        });
        setBankBic(value);
    };
    const handleBankIbanChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!isValidValue(value)) setFormErrors({
            ...formErrors,
            bankIban: $d5b8b4ed77d68e0b$export$1067ba46601ca091.bankIban
        });
        else setFormErrors({
            ...formErrors,
            bankIban: null
        });
        setBankIban(value);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    textAlign: "right",
                    width: "100%",
                    marginTop: "28px"
                },
                children: [
                    state.selectedInvoice?.errors.isPaymentDetailsInEditMode && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        style: {
                            color: "red",
                            marginRight: 20
                        },
                        children: "Exit edit mode before going to the next step"
                    }),
                    editable && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                        id: "invoice-wizard-payment-details-save-button",
                        "data-testid": "invoice-wizard-payment-details-save-button",
                        onClick: handleSave,
                        disabled: addPaymentDetailsResult.loading,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $64mWt.default), {
                                style: {
                                    fontSize: "medium",
                                    color: (0, $6L9uu.Colors).main,
                                    marginRight: 3
                                }
                            }),
                            "SAVE"
                        ]
                    }),
                    editable && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                        id: "invoice-wizard-payment-details-cancel-button",
                        "data-testid": "invoice-wizard-payment-details-cancel-button",
                        onClick: handleCancelEdit,
                        disabled: addPaymentDetailsResult.loading,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $3Xpkr.default), {
                                style: {
                                    fontSize: "medium",
                                    color: "red",
                                    marginRight: 3
                                }
                            }),
                            "CANCEL"
                        ]
                    }),
                    shouldEditPage() && /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                        id: "invoice-wizard-payment-details-edit-button",
                        "data-testid": "invoice-wizard-payment-details-edit-button",
                        onClick: ()=>setEditMode(true),
                        disabled: editable,
                        editButtonColor: editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    gap: "30px 8.33%",
                    padding: "20px 10.4% 0px 9.17%"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            ...(0, $79Qyg.predefinedFonts).Bold["14px22px"],
                            color: (0, $6L9uu.Colors).main
                        },
                        children: "CONTACT DETAILS"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            ...(0, $79Qyg.predefinedFonts).Bold["14px22px"],
                            color: (0, $6L9uu.Colors).main
                        },
                        children: "BANK ACCOUNT DETAILS"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "invoice-wizard-payment-details-address-name",
                        "data-testid": "invoice-wizard-payment-details-address-name-input-label",
                        label: "Co.address Name",
                        required: true,
                        value: addressName,
                        onChange: handleAddressNameChange,
                        disabled: !editable || addPaymentDetailsResult.loading,
                        errorMsg: formErrors.contactAddressName ?? undefined,
                        startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bwbWe.default), {
                            sx: {
                                color: (0, $hsjD5.getLabelColor)(editable),
                                ml: "5px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "invoice-wizard-payment-details-bank-name",
                        "data-testid": "invoice-wizard-payment-details-bank-name-input-label",
                        label: "Bank",
                        required: true,
                        value: bankName,
                        onChange: handleBankNameChange,
                        disabled: !editable || addPaymentDetailsResult.loading,
                        errorMsg: formErrors.bankName ?? undefined
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "invoice-wizard-payment-details-address",
                        "data-testid": "invoice-wizard-payment-details-address-input-label",
                        label: "Address",
                        required: true,
                        value: address,
                        onChange: handleAddressChange,
                        disabled: !editable || addPaymentDetailsResult.loading,
                        errorMsg: formErrors.contactAddress ?? undefined,
                        startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kso7N.default), {
                            sx: {
                                color: (0, $hsjD5.getLabelColor)(editable)
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "invoice-wizard-payment-details-bank-affiliate",
                        "data-testid": "invoice-wizard-payment-details-bank-affiliate-input-label",
                        label: "Affiliate",
                        required: true,
                        value: bankAffiliate,
                        onChange: handleBankAffiliateChange,
                        disabled: !editable || addPaymentDetailsResult.loading,
                        errorMsg: formErrors.bankAffiliate ?? undefined
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "invoice-wizard-payment-details-phone",
                        "data-testid": "invoice-wizard-payment-details-phone-input-label",
                        label: "Phone Number",
                        required: true,
                        value: phone,
                        onChange: handlePhoneChange,
                        disabled: !editable || addPaymentDetailsResult.loading,
                        errorMsg: formErrors.contactPhone ?? undefined,
                        startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hKISe.default), {
                            sx: {
                                color: (0, $hsjD5.getLabelColor)(editable)
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "invoice-wizard-payment-details-bank-address",
                        "data-testid": "invoice-wizard-payment-details-bank-address-input-label",
                        label: "Address",
                        required: true,
                        value: bankAddress,
                        onChange: handleBankAddressChange,
                        disabled: !editable || addPaymentDetailsResult.loading,
                        errorMsg: formErrors.bankAddress ?? undefined
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "invoice-wizard-payment-details-fax",
                        "data-testid": "invoice-wizard-payment-details-fax-input-label",
                        label: "Fax (direct)",
                        required: true,
                        value: fax,
                        onChange: handleFaxChange,
                        disabled: !editable || addPaymentDetailsResult.loading,
                        errorMsg: formErrors.contactFax ?? undefined,
                        startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cSN6l.default), {
                            sx: {
                                color: (0, $hsjD5.getLabelColor)(editable)
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "invoice-wizard-payment-details-bank-bic",
                        "data-testid": "invoice-wizard-payment-details-bank-bic-input-label",
                        label: "BIC",
                        required: true,
                        value: bankBic,
                        onChange: handleBankBicChange,
                        disabled: !editable || addPaymentDetailsResult.loading,
                        errorMsg: formErrors.bankBic ?? undefined
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "invoice-wizard-payment-details-vat",
                        "data-testid": "invoice-wizard-payment-details-vat-input-label",
                        label: "VAT Number",
                        required: true,
                        value: vat,
                        onChange: handleVatChange,
                        disabled: !editable || addPaymentDetailsResult.loading,
                        errorMsg: formErrors.contactVat ?? undefined,
                        startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $dgmqH.default), {
                            sx: {
                                color: (0, $hsjD5.getLabelColor)(editable)
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "invoice-wizard-payment-details-bank-iban",
                        "data-testid": "invoice-wizard-payment-details-bank-iban-input-label",
                        label: "IBAN",
                        required: true,
                        value: bankIban,
                        onChange: handleBankIbanChange,
                        disabled: !editable || addPaymentDetailsResult.loading,
                        errorMsg: formErrors.bankIban ?? undefined
                    })
                ]
            })
        ]
    });
};
var $d5b8b4ed77d68e0b$export$2e2bcd8739ae039 = $d5b8b4ed77d68e0b$var$PaymentDetailsStep;

});
parcelRegister("hKISe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cec98a847f8ee505$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $cec98a847f8ee505$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99"
}), "Call");

});

parcelRegister("kso7N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee4922dc5efce4c4$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $ee4922dc5efce4c4$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5"
}), "LocationOn");

});

parcelRegister("cSN6l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96109dad86d9b61e$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $96109dad86d9b61e$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3m-3 11H8v-5h8zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m-1-9H6v4h12z"
}), "Print");

});

parcelRegister("64mWt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46b4e9a4179adaaa$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $46b4e9a4179adaaa$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m3-10H5V5h10z"
}), "Save");

});


parcelRegister("72HIx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $129ddb8df4907622$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");

var $bilGR = parcelRequire("bilGR");

var $dqRXb = parcelRequire("dqRXb");

var $2glCg = parcelRequire("2glCg");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $bwbWe = parcelRequire("bwbWe");
var $kso7N = parcelRequire("kso7N");
var $iR1LU = parcelRequire("iR1LU");
const $129ddb8df4907622$var$ClientStep = (cventContact)=>{
    const hasCventContact = cventContact.cventContact !== null && cventContact.cventContact !== undefined;
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [clientOptions, setClientOptions] = (0, $bh6RR.useState)(null);
    const [companyOptions, setCompanyOptions] = (0, $bh6RR.useState)([]);
    const [contactOptions, setContactOptions] = (0, $bh6RR.useState)([]);
    const [addressOptions, setAddressOptions] = (0, $bh6RR.useState)([]);
    const [getInvoiceOptions, { data: data }] = (0, $hjfla.useInvoiceClientOptionsLazyQuery)({
        variables: {
            membership_id: parseInt(state.selectedMembership?.id)
        },
        fetchPolicy: "no-cache"
    });
    const [company, setCompany] = (0, $bh6RR.useState)(state.selectedInvoice?.company ?? cventContact.cventContact?.company ?? null);
    const [contact, setContact] = (0, $bh6RR.useState)(state.selectedInvoice?.contact ?? cventContact.cventContact ?? null);
    const [address, setAddress] = (0, $bh6RR.useState)(state.selectedInvoice?.address ?? cventContact.cventContact?.address ?? null);
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Invoice);
    const editable = canEdit && (state.selectedInvoice?.status === (0, $2glCg.InvoiceStatus).New || state.selectedInvoice?.status === (0, $2glCg.InvoiceStatus).Pending) && !hasCventContact;
    (0, $bh6RR.useEffect)(()=>{
        if (editable && !clientOptions && !hasCventContact) getInvoiceOptions();
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (state.selectedInvoice?.status === (0, $2glCg.InvoiceStatus).Confirmed) getInvoiceOptions();
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (hasCventContact && (contact === null || contact?.id !== cventContact.cventContact?.id)) {
            setContact(cventContact.cventContact);
            setCompany(cventContact.cventContact?.company);
            setAddress(cventContact.cventContact?.address);
            dispatch({
                type: (0, $ayVxz.Actions).SetInvoiceClientDetails,
                payload: {
                    company: cventContact.cventContact?.company,
                    address: cventContact.cventContact?.address,
                    contact: cventContact.cventContact
                }
            });
        }
    }, [
        cventContact
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const errors = {
            ...state.selectedInvoice?.errors
        };
        if (company) delete errors.company;
        if (contact) delete errors.contact;
        if (address) delete errors.address;
        dispatch({
            type: (0, $ayVxz.Actions).SetInvoiceErrors,
            payload: {
                ...errors
            }
        });
    }, [
        company,
        contact,
        address
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result && !hasCventContact) {
            const companyOpts = data.result.companies;
            const contactOpts = data.result.contacts;
            const addressOpts = [
                ...new Set(data.result.contacts.map((c)=>c?.address).filter((a)=>a != null))
            ];
            const errors = {
                ...state.selectedInvoice?.errors
            };
            if (company && companyOpts.findIndex((c)=>c?.name === company.name) === -1) errors.company = "Company has been deleted. Please select another one";
            if (contact && contactOpts.findIndex((c)=>c?.fullName === contact.fullName) === -1) errors.contact = "Contact has been deleted. Please select another one";
            if (address && addressOpts.findIndex((a)=>a?.name === address.name) === -1) errors.address = "Address  has been deleted. Please select another one";
            dispatch({
                type: (0, $ayVxz.Actions).SetInvoiceErrors,
                payload: {
                    ...errors
                }
            });
            setClientOptions(data.result);
            setCompanyOptions(companyOpts);
            setContactOptions(contactOpts);
            setAddressOptions(addressOpts);
        }
    }, [
        data?.result
    ]);
    const handleCompanyChanged = (_, newValue)=>{
        setCompany(newValue);
        let contactValue = null;
        let addressValue = null;
        let contactOpts = [];
        let addressOpts = [];
        if (newValue) {
            const possibleContacts = clientOptions?.contacts.filter((c)=>c?.company.id === newValue.id);
            contactOpts = possibleContacts;
            addressOpts = possibleContacts.map((c)=>c.address);
            addressOpts = [
                ...new Set(addressOpts.filter((a)=>a != null))
            ];
            if (contactOpts?.length === 1) {
                setContact(contactOpts[0]);
                contactValue = contactOpts[0];
            } else {
                setContact(null);
                contactValue = null;
            }
            if (addressOpts.length === 1) {
                setAddress(addressOpts[0]);
                addressValue = addressOpts[0];
            } else {
                setAddress(null);
                addressValue = null;
            }
        } else {
            setContact(null);
            contactValue = null;
            setAddress(null);
            addressValue = null;
            contactOpts = clientOptions?.contacts;
            addressOpts = [
                ...new Set(clientOptions?.contacts.map((c)=>c?.address).filter((a)=>a != null))
            ];
        }
        dispatch({
            type: (0, $ayVxz.Actions).SetInvoiceClientDetails,
            payload: {
                company: newValue,
                address: addressValue,
                contact: contactValue
            }
        });
        dispatch({
            type: (0, $ayVxz.Actions).ResetInvoiceErrors
        });
        setContactOptions(contactOpts);
        setAddressOptions(addressOpts);
    };
    const handleContactChanged = (_, newValue)=>{
        setContact(newValue);
        let companyValue = company;
        let addressValue = address;
        let clientOption = null;
        if (newValue) {
            if (newValue.address) {
                addressValue = newValue.address;
                setAddress(newValue.address);
            }
            clientOption = clientOptions?.contacts.find((c)=>c?.id === newValue.id);
            if (!company) {
                setCompany(clientOption?.company);
                companyValue = clientOption?.company;
                const addresses = [
                    ...new Set(clientOptions?.contacts.filter((c)=>c?.company.id === clientOption?.company.id).map((c)=>c?.address).filter((a)=>a != null))
                ];
                if (addresses.length === 1 && !newValue.address) {
                    addressValue = addresses[0];
                    setAddress(addresses[0]);
                }
                setAddressOptions(addresses);
            }
        }
        dispatch({
            type: (0, $ayVxz.Actions).SetInvoiceClientDetails,
            payload: {
                company: companyValue,
                contact: newValue,
                address: addressValue
            }
        });
    };
    const handleAddressChanged = (_, newValue)=>{
        setAddress(newValue);
        dispatch({
            type: (0, $ayVxz.Actions).SetInvoiceClientDetails,
            payload: {
                address: newValue
            }
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            pt: "142px",
            px: "31.25%",
            display: "grid",
            gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
            gap: "60px"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                id: "invoice-company",
                "data-testid": "invoice-company",
                label: "Company",
                options: companyOptions,
                disabled: !editable || state.selectedInvoice?.status === (0, $2glCg.InvoiceStatus).ConfirmedCredit,
                values: company,
                onChange: handleCompanyChanged,
                getOptionLabel: (option)=>option?.name,
                isOptionEqualToValue: (option, value)=>option.id === value.id,
                errorMsg: state.selectedInvoice?.errors?.company,
                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bwbWe.default), {
                    sx: {
                        color: (theme)=>state.selectedInvoice?.errors?.company ? theme.palette.error.main : theme.palette.primary.main
                    }
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                id: "invoice-contact-name",
                "data-testid": "invoice-contact-name",
                label: "Contact name",
                options: contactOptions,
                disabled: !editable && state.selectedInvoice?.status !== (0, $2glCg.InvoiceStatus).Confirmed || state.selectedInvoice?.status === (0, $2glCg.InvoiceStatus).ConfirmedCredit,
                values: contact,
                onChange: handleContactChanged,
                getOptionLabel: (option)=>option.fullName,
                isOptionEqualToValue: (option, value)=>option.fullName === value.fullName,
                errorMsg: state.selectedInvoice?.errors?.contact,
                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $iR1LU.default), {
                    sx: {
                        color: (theme)=>state.selectedInvoice?.errors?.contact ? theme.palette.error.main : theme.palette.primary.main
                    }
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                id: "invoice-contact-address",
                "data-testid": "invoice-contact-address",
                label: "Contact address",
                options: addressOptions,
                disabled: !editable || state.selectedInvoice?.status === (0, $2glCg.InvoiceStatus).ConfirmedCredit,
                onChange: handleAddressChanged,
                values: address,
                getOptionLabel: (option)=>option.name,
                isOptionEqualToValue: (option, value)=>option.name === value.name,
                errorMsg: state.selectedInvoice?.errors?.address,
                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kso7N.default), {
                    sx: {
                        color: (theme)=>state.selectedInvoice?.errors?.address ? theme.palette.error.main : theme.palette.primary.main
                    }
                })
            })
        ]
    });
};
var $129ddb8df4907622$export$2e2bcd8739ae039 = $129ddb8df4907622$var$ClientStep;

});
parcelRegister("iR1LU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db9e8d15e25ce594$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $db9e8d15e25ce594$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"
}), "Person");

});


parcelRegister("cnCqi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a682374aea77aad$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $2glCg = parcelRequire("2glCg");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $oZMqz = parcelRequire("oZMqz");

var $bilGR = parcelRequire("bilGR");

var $ehzwo = parcelRequire("ehzwo");

var $6L9uu = parcelRequire("6L9uu");

var $40Qwb = parcelRequire("40Qwb");
const $2a682374aea77aad$var$ProductAndPricingStep = ({ productInfoInput: productInfoInput, setProductInfo: setProductInfo })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [productOptions, setProductOptions] = (0, $bh6RR.useState)([]);
    const [getProducts, productsData] = (0, $hjfla.useProductsLazyQuery)();
    const [product, setProduct] = (0, $bh6RR.useState)(null);
    const [discountPercent, setDiscountPercent] = (0, $bh6RR.useState)(null);
    const [vatPercent, setVatPercent] = (0, $bh6RR.useState)(null);
    const [price, setPrice] = (0, $bh6RR.useState)(0);
    const [discount, setDiscount] = (0, $bh6RR.useState)(0);
    const [vat, setVat] = (0, $bh6RR.useState)(0);
    const [total, setTotal] = (0, $bh6RR.useState)(0);
    const [notes, setNotes] = (0, $bh6RR.useState)("");
    const [poNumber, setPoNumber] = (0, $bh6RR.useState)("");
    const [startDate, setStartDate] = (0, $bh6RR.useState)("");
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Invoice);
    const editable = canEdit && (state.selectedInvoice?.status === (0, $2glCg.InvoiceStatus).New || state.selectedInvoice?.status === (0, $2glCg.InvoiceStatus).Pending);
    (0, $bh6RR.useEffect)(()=>{
        setVat(vatPercent ? (price - discount) * vatPercent : 0);
        if (editable) getProducts();
        const productInfo = productInfoInput ?? state.selectedInvoice?.productInfo ?? (0, $40Qwb.defaultProductInfo);
        setProduct(productInfo?.product);
        setPrice(Number(productInfo?.product?.price));
        setDiscountPercent(Number(productInfo.discountPercent));
        setDiscount(Number(productInfo.discount));
        setVatPercent(Number(productInfo.vatPercent));
        setVat(Number(productInfo.vat));
        setTotal(Number(productInfo.total));
        setNotes(state.selectedInvoice?.notes ?? "");
        setPoNumber(state.selectedInvoice?.po_nr ?? "");
        setStartDate(state.selectedInvoice?.invoice_full?.remarks ?? "");
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (productsData.data && productsData.data.result) setProductOptions(productsData.data.result);
    }, [
        productsData
    ]);
    const calculateTotal = (price, discount, vat)=>{
        const newTotal = numberToFixed(price === 0 ? 0 : price - discount + vat / 100);
        setTotal(newTotal);
        return newTotal;
    };
    const handleProductChanged = (_, newValue)=>{
        const productInfo = getProductInfo(newValue);
        if (newValue) {
            dispatch({
                type: (0, $ayVxz.Actions).ResetInvoiceErrors
            });
            dispatch({
                type: (0, $ayVxz.Actions).SetInvoiceProductInfo,
                payload: {
                    product: productInfo.product,
                    discount: productInfo.discount,
                    discountPercent: discountPercent ?? 0,
                    total: productInfo.total,
                    vat: productInfo.vat,
                    vatPercent: productInfo.vatPercent ?? 0
                }
            });
        } else dispatch({
            type: (0, $ayVxz.Actions).ResetInvoiceProductInfo
        });
        setDiscount(productInfo.discount);
        setVat(productInfo.vat);
        setVatPercent(productInfo.vatPercent);
        setPrice(productInfo.product?.price ?? 0);
        setProduct(newValue);
        setDiscountPercent(productInfo.discountPercent);
        setTotal(productInfo.total);
        if (setProductInfo) setProductInfo(productInfo);
    };
    const getProductInfo = (product)=>{
        const result = {
            ...(0, $40Qwb.defaultProductInfo)
        };
        if (product) {
            result.product = product;
            const newDiscount = numberToFixed(discountPercent && discountPercent > 0 ? product.price * discountPercent / 100 : 0);
            const newVatPercent = numberToFixed(product.vat && product.vat > 0 ? (product.price - newDiscount) * product.vat / 100 : 0);
            const newVat = newVatPercent * 100;
            const newTotal = calculateTotal(product.price, result.discount, newVat);
            result.discount = newDiscount;
            result.vat = newVatPercent ?? 0;
            result.vatPercent = product.vat ?? newVatPercent ?? 0;
            result.total = newTotal;
        }
        return result;
    };
    const handleVatPercentChange = (event)=>{
        const { value: value } = event.currentTarget;
        const valueAsNumber = Number(value);
        const newVatPercent = (0, $oZMqz.normalizePercentInput)(valueAsNumber);
        let newVat = 0;
        if (value) newVat = numberToFixed((price - discount) * newVatPercent / 100);
        setVat(newVat);
        setVatPercent(newVatPercent);
        const newTotal = calculateTotal(price, discount, newVat * 100);
        dispatch({
            type: (0, $ayVxz.Actions).SetInvoiceProductInfo,
            payload: {
                ...state.selectedInvoice?.productInfo,
                total: newTotal,
                vat: newVat,
                vatPercent: newVatPercent
            }
        });
        if (productInfoInput && setProductInfo) setProductInfo({
            ...productInfoInput,
            vat: newVat,
            vatPercent: newVatPercent,
            total: newTotal
        });
    };
    const handleDiscountPercentChange = (event)=>{
        const { value: value } = event.currentTarget;
        const valueAsNumber = Number(value);
        const newDiscountPercent = (0, $oZMqz.normalizePercentInput)(valueAsNumber);
        const newDiscount = numberToFixed(newDiscountPercent === 0 ? newDiscountPercent : price * newDiscountPercent / 100);
        let newVat = 0;
        if (vatPercent) {
            newVat = numberToFixed((price - newDiscount) * vatPercent / 100);
            setVat(newVat);
        }
        setDiscountPercent(newDiscountPercent);
        setDiscount(newDiscount);
        const newTotal = calculateTotal(price, newDiscount, newVat * 100);
        dispatch({
            type: (0, $ayVxz.Actions).SetInvoiceProductInfo,
            payload: {
                ...state.selectedInvoice?.productInfo,
                vat: newVat,
                discount: newDiscount,
                discountPercent: newDiscountPercent,
                total: newTotal
            }
        });
        if (productInfoInput && setProductInfo) setProductInfo({
            ...productInfoInput,
            discountPercent: newDiscountPercent,
            discount: newDiscount,
            total: newTotal,
            vat: newVat
        });
    };
    const numberToFixed = (input, decimalPlaces)=>{
        const places = decimalPlaces ?? 2;
        return Number(input.toFixed(places));
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            pt: "153px",
            px: "28.25%",
            display: "grid",
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
            gap: "30px"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                id: "product-name",
                "data-testid": "invoice-product-name",
                label: "Product",
                options: productOptions,
                disabled: !editable,
                values: product,
                onChange: handleProductChanged,
                getOptionLabel: (option)=>option?.name,
                isOptionEqualToValue: (option, value)=>option.id === value.id,
                errorMsg: state.selectedInvoice?.errors?.product,
                additionalStyle: {
                    gridColumn: "span 3"
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                id: "invoice-price",
                label: "Price",
                value: price,
                disabled: true,
                type: "number"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                id: "invoice-discount-percent",
                label: "Discount %",
                "data-testid": "invoice-discount-percent",
                type: "number",
                onChange: handleDiscountPercentChange,
                additionalStyle: {
                    color: !editable || !product ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).main
                },
                value: discountPercent || "",
                disabled: !editable || !product
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                id: "invoice-vat-percent",
                onChange: handleVatPercentChange,
                label: "VAT %",
                "data-testid": "invoice-vat-percent",
                type: "number",
                additionalStyle: {
                    color: !editable || !product ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).main
                },
                value: vatPercent || "",
                disabled: !editable || !product
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                id: "invoice-discount",
                "data-testid": "invoice-discount-label",
                label: "Discount",
                disabled: true,
                value: discount,
                type: "number"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                id: "invoice-vat",
                "data-testid": "invoice-vat-label",
                label: "VAT",
                value: vat,
                disabled: true,
                type: "number"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                id: "invoice-po",
                "data-testid": "invoice-product-po",
                value: poNumber || "",
                onChange: (e)=>{
                    setPoNumber(e.currentTarget.value);
                    dispatch({
                        type: (0, $ayVxz.Actions).SetInvoicePoNumber,
                        payload: {
                            text: e.currentTarget.value
                        }
                    });
                },
                label: "PO",
                disabled: !editable && state.selectedInvoice?.status !== (0, $2glCg.InvoiceStatus).Confirmed,
                additionalStyle: {
                    gridColumn: "span 3"
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                id: "invoice-total",
                value: total,
                "data-testid": "invoice-total-input-label",
                label: "Total",
                disabled: true,
                additionalStyle: {
                    font: "bold"
                },
                type: "number"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                id: "membership-period-start-date",
                label: "Start Date",
                value: startDate || "",
                onChange: (e)=>{
                    setStartDate(e.currentTarget.value);
                    dispatch({
                        type: (0, $ayVxz.Actions).SetMembershipStartDate,
                        payload: {
                            text: e.currentTarget.value
                        }
                    });
                },
                disabled: !editable && state.selectedInvoice?.status !== (0, $2glCg.InvoiceStatus).Confirmed,
                additionalStyle: {
                    gridColumn: "span 4"
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                id: "invoice-notes",
                value: notes,
                onChange: (e)=>{
                    setNotes(e.currentTarget.value);
                    dispatch({
                        type: (0, $ayVxz.Actions).SetInvoiceNotes,
                        payload: {
                            text: e.currentTarget.value
                        }
                    });
                },
                label: "Notes",
                additionalStyle: {
                    gridColumn: "span 4"
                },
                disabled: !editable
            })
        ]
    });
};
var $2a682374aea77aad$export$2e2bcd8739ae039 = $2a682374aea77aad$var$ProductAndPricingStep;

});
parcelRegister("40Qwb", function(module, exports) {

$parcel$export(module.exports, "defaultPaymentDto", function () { return $0c3b4cfd87415351$export$dc5687397bdf5dd9; });
$parcel$export(module.exports, "defaultProductInfo", function () { return $0c3b4cfd87415351$export$f4e6c9fa1bd05cfb; });
const $0c3b4cfd87415351$export$dc5687397bdf5dd9 = {
    id: "",
    contact_address_name: "",
    contact_address: "",
    contact_phone: "",
    contact_fax: "",
    contact_vat: "",
    bank_name: "",
    bank_affiliate: "",
    bank_address: "",
    bank_bic: "",
    bank_iban: ""
};
const $0c3b4cfd87415351$export$f4e6c9fa1bd05cfb = {
    product: null,
    discount: 0,
    discountPercent: null,
    vat: 0,
    total: 0,
    vatPercent: null
};

});


parcelRegister("cAzF9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e22a6de2a2fd3051$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $cxTnx = parcelRequire("cxTnx");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $2glCg = parcelRequire("2glCg");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $e2ibc = parcelRequire("e2ibc");

var $dqRXb = parcelRequire("dqRXb");

var $2OHqK = parcelRequire("2OHqK");

var $fziws = parcelRequire("fziws");

var $isGUU = parcelRequire("isGUU");

var $cY1Od = parcelRequire("cY1Od");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $ePpmI = parcelRequire("ePpmI");
var $gDp1O = parcelRequire("gDp1O");
var $iTI7v = parcelRequire("iTI7v");

var $8d818 = parcelRequire("8d818");

var $10zXY = parcelRequire("10zXY");

var $6L9uu = parcelRequire("6L9uu");

var $89CnP = parcelRequire("89CnP");

var $g8u5J = parcelRequire("g8u5J");

var $ehzwo = parcelRequire("ehzwo");

var $4XrUr = parcelRequire("4XrUr");
var $9rvkQ = parcelRequire("9rvkQ");
var $cSN6l = parcelRequire("cSN6l");
var $jjVT0 = parcelRequire("jjVT0");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $6wWvz = parcelRequire("6wWvz");

var $1ELi8 = parcelRequire("1ELi8");
const $e22a6de2a2fd3051$var$InvoiceStep = ({ editInvoice: editInvoice, children: children, setPreview: setPreview, dbContact: dbContact })=>{
    const buttonWidth = "130px";
    const { state: state, dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [hover, setHover] = (0, $bh6RR.useState)(false);
    const [openPreview, setOpenPreview] = (0, $bh6RR.useState)(false);
    const { selectedInvoice: selectedInvoice } = state;
    const isCredit = selectedInvoice?.invoice_full?.is_credit;
    const isConfirmed = selectedInvoice?.status?.includes((0, $2glCg.InvoiceStatus).Confirmed);
    const isNew = selectedInvoice?.status === (0, $2glCg.InvoiceStatus).New;
    const [confirmInvoice, { loading: loading }] = (0, $hjfla.useConfirmInvoiceMutation)();
    const [sendInvoiceForApproval, sendInvoiceForApprovalResult] = (0, $hjfla.useSendInvoiceForApprovalMutation)();
    const [sendInvoiceToCustomer, sendInvoiceToCustomerResult] = (0, $hjfla.useSendInvoiceToCustomerMutation)();
    const [openCcInput, setOpenCcInput] = (0, $bh6RR.useState)(false);
    const [ccRecipients, setCcRecipients] = (0, $bh6RR.useState)([]);
    const invoiceRef = (0, $bh6RR.useRef)(null);
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Invoice);
    const disableSend = !canEdit || !isConfirmed || !selectedInvoice?.contact || !selectedInvoice?.contact.email || selectedInvoice?.contact.email.length === 0;
    const formatInputDate = (input)=>{
        if (input) return (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(parseInt(input)).format((0, $e2ibc.DATE_TIME_FORMATS).DATE);
        return "";
    };
    const handlePreviewClicked = (e)=>{
        e.preventDefault();
        setOpenPreview(!openPreview);
        if (setPreview) setPreview();
    };
    const handleConfirmClicked = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: "Are you sure you want to confirm this invoice?",
                agreeAction: handleConfirmInvoice
            }
        });
    };
    const handleConfirmInvoice = ()=>{
        if (selectedInvoice) confirmInvoice({
            variables: {
                id: parseInt(selectedInvoice.id)
            },
            update (_, { data: data }) {
                if (data?.result) {
                    const invoice = data.result;
                    dispatch({
                        type: (0, $ayVxz.Actions).SetInvoice,
                        payload: {
                            invoice: invoice,
                            productInfo: (0, $2OHqK.getInvoiceProductInfoDto)(invoice)
                        }
                    });
                    if (editInvoice) editInvoice(invoice);
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `You have successfully confirmed invoice`
                        }
                    });
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        }).finally(()=>{
            dispatch({
                type: (0, $ayVxz.Actions).HideConfirmation
            });
        });
    };
    const handlePrint = (0, $fziws.useReactToPrint)({
        content: ()=>invoiceRef.current
    });
    const sendForApprove = ()=>{
        handleSendingInvoice(sendInvoiceForApproval, true);
    };
    const sendToCustomer = ()=>{
        handleSendingInvoice(sendInvoiceToCustomer, false);
    };
    const handleSendingInvoice = (sendMethod, isForApproval)=>{
        //SVG icons hack for canvas capturing
        const svgElements = document.body.querySelectorAll("svg");
        svgElements.forEach((item)=>{
            item.setAttribute("width", item.getBoundingClientRect().width.toString());
            if (item.className.animVal.indexOf("invoice-confirmed-circle-icon") > -1) item.setAttribute("fill", "rgb(130, 205, 43)");
            else item.setAttribute("fill", "rgb(105, 170, 243)");
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($isGUU)))(invoiceRef.current, {
            scale: 2
        }).then((canvas)=>{
            const imgData = canvas.toDataURL("image/png");
            const pdf = new (0, $cY1Od.default)();
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
            // pdf.save('download.pdf');
            const base64 = pdf.output("datauristring");
            const vars = {
                id: parseInt(selectedInvoice?.id),
                pdf_content: base64,
                cc_emails: ccRecipients
            };
            sendMethod({
                variables: vars,
                update (_, { data: data }) {
                    if (data?.result) dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `You have successfully sent invoice ${isForApproval ? "for approval" : "to customer"}`
                        }
                    });
                    else dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "error",
                            text: `Invoice not sent`
                        }
                    });
                }
            }).catch((e)=>{
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "error",
                        text: e.message,
                        autoHide: 6000
                    }
                });
            }).finally(()=>{
                dispatch({
                    type: (0, $ayVxz.Actions).HideConfirmation
                });
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    pt: "6px",
                    pl: "17%",
                    display: "grid",
                    gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
                    gap: "8.24%"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            gridColumn: "span 2"
                        },
                        children: [
                            hover && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                component: "img",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($10zXY))),
                                onClick: handlePreviewClicked,
                                sx: {
                                    position: "absolute",
                                    zIndex: 2,
                                    top: "42%",
                                    left: "24%",
                                    pointerEvents: "none"
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $iTI7v.default), {
                                id: "invoice-preview-paper",
                                "data-testid": "invoice-preview-paper",
                                onMouseEnter: ()=>setHover(true),
                                onMouseLeave: ()=>setHover(false),
                                onClick: handlePreviewClicked,
                                sx: {
                                    width: "100%",
                                    height: "410px",
                                    boxShadow: "0px 2px 5px " + (0, $6L9uu.Colors).third + "66",
                                    cursor: "pointer"
                                },
                                className: hover ? "blurred-invoice-paper" : "",
                                children: children || /*#__PURE__*/ (0, $ih19M.jsx)((0, $89CnP.default), {
                                    dbContact: dbContact
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            gridColumn: "span 3",
                            marginTop: isConfirmed ? "0px" : "33px"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                            sx: {
                                display: "grid",
                                gridTemplateColumns: "30% 70%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                                    component: "p",
                                    id: "invoice-title",
                                    "data-testid": "invoice-title",
                                    sx: {
                                        color: isCredit ? (0, $6L9uu.Colors).orange : (0, $6L9uu.Colors).main,
                                        fontWeight: "bold",
                                        fontSize: "20px",
                                        fontFamily: "Segoe UI",
                                        gridColumn: "span 2"
                                    },
                                    children: [
                                        isCredit ? "CREDIT" : "INVOICE",
                                        isConfirmed && ` ${selectedInvoice?.invoice_full?.number ?? ""}`
                                    ]
                                }),
                                isCredit && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                                    component: "p",
                                    sx: {
                                        gridColumn: "span 2",
                                        mt: "-25px",
                                        fontSize: "14px",
                                        color: (0, $6L9uu.Colors).gray
                                    },
                                    children: [
                                        "/Ref: INVOICE ",
                                        selectedInvoice?.invoice_full?.debit_invoice_nr,
                                        "/"
                                    ]
                                }),
                                isConfirmed && /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "invoice-date-paid",
                                    "data-testid": "invoice-date-paid",
                                    label: "Date Paid",
                                    value: formatInputDate(selectedInvoice?.invoice_full?.date_paid),
                                    disabled: true,
                                    withoutBackground: true,
                                    inputLabelProps: {
                                        shrink: true,
                                        style: {
                                            top: "-7px",
                                            color: (0, $6L9uu.Colors).main,
                                            fontFamily: "Overpass"
                                        }
                                    },
                                    additionalStyle: {
                                        p: 0,
                                        mt: "24px",
                                        "& .MuiInputBase-input.Mui-disabled": {
                                            WebkitTextFillColor: (0, $6L9uu.Colors).main
                                        }
                                    }
                                }),
                                isConfirmed && /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "invoice-due-date",
                                    "data-testid": "invoice-due-date",
                                    label: "Due Date",
                                    value: formatInputDate(selectedInvoice?.invoice_full?.due_date),
                                    disabled: true,
                                    withoutBackground: true,
                                    inputLabelProps: {
                                        shrink: true,
                                        style: {
                                            top: "-7px",
                                            color: (0, $6L9uu.Colors).main,
                                            fontFamily: "Overpass"
                                        }
                                    },
                                    additionalStyle: {
                                        pl: 0,
                                        mt: "24px",
                                        "& .MuiInputBase-input.Mui-disabled": {
                                            WebkitTextFillColor: (0, $6L9uu.Colors).main
                                        }
                                    }
                                }),
                                isConfirmed && /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {
                                    sx: {
                                        backgroundColor: isConfirmed ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).third,
                                        mt: "26px",
                                        gridColumn: "span 2"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                                    id: "invoice-send-for-approval-button",
                                    "data-testid": "invoice-send-for-approval-button",
                                    component: (0, $gDp1O.default),
                                    disabled: !canEdit || isNew,
                                    onClick: sendForApprove,
                                    sx: {
                                        mt: "31px",
                                        fontSize: 14,
                                        fontWeight: "bold",
                                        textTransform: "none",
                                        color: (0, $6L9uu.Colors).skyBlue + "CC",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        textDecoration: "underline",
                                        width: "145px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $jjVT0.default), {
                                            sx: {
                                                fontSize: "medium",
                                                color: !canEdit || isNew ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue,
                                                mr: "3px",
                                                mb: "6px",
                                                transform: "rotate(-48deg)"
                                            }
                                        }),
                                        "Send for approval"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                                    id: "invoice-print-button",
                                    "data-testid": "invoice-print-button",
                                    component: (0, $gDp1O.default),
                                    onClick: handlePrint,
                                    sx: {
                                        mt: "31px",
                                        fontSize: 14,
                                        fontWeight: "bold",
                                        textTransform: "none",
                                        color: (0, $6L9uu.Colors).skyBlue + "CC",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        textDecoration: "underline",
                                        width: "60px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $cSN6l.default), {
                                            sx: {
                                                fontSize: "medium",
                                                color: (0, $6L9uu.Colors).skyBlue,
                                                mr: "3px"
                                            }
                                        }),
                                        "Print"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {
                                    sx: {
                                        backgroundColor: isConfirmed ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).third,
                                        mt: "26px",
                                        gridColumn: "span 2"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                                    id: "confirm-invoice-button",
                                    "data-testid": "confirm-invoice-button",
                                    disabled: !canEdit || isNew || isConfirmed,
                                    onClick: handleConfirmClicked,
                                    text: "confirm",
                                    sx: {
                                        mt: "30px",
                                        width: buttonWidth,
                                        "&:hover": {
                                            background: (theme)=>theme.palette.primary.main,
                                            color: (0, $6L9uu.Colors).white,
                                            border: "none"
                                        },
                                        "&:disabled": {
                                            borderColor: (theme)=>theme.palette.grey[300]
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "invoice-status",
                                    label: "Status",
                                    value: isNew ? "unsaved" : isConfirmed ? "confirmed" : "pending",
                                    disabled: true,
                                    withoutBackground: true,
                                    additionalStyle: {
                                        mt: "39px",
                                        "& .MuiInputBase-input.Mui-disabled": {
                                            WebkitTextFillColor: isNew ? (0, $6L9uu.Colors).warning : isConfirmed ? (0, $6L9uu.Colors).green : (0, $6L9uu.Colors).orange,
                                            fontFamily: "Overpass"
                                        }
                                    },
                                    inputLabelProps: {
                                        style: {
                                            top: "-12px",
                                            left: "6px"
                                        }
                                    },
                                    startAdornment: !isNew && (isConfirmed ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $4XrUr.default), {
                                        sx: {
                                            mr: "7px",
                                            color: (0, $6L9uu.Colors).green
                                        }
                                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $9rvkQ.default), {
                                        sx: {
                                            mr: "7px",
                                            color: (0, $6L9uu.Colors).orange
                                        }
                                    }))
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                                    id: "send-invoice-button",
                                    "data-testid": "send-invoice-button",
                                    disabled: disableSend,
                                    onClick: sendToCustomer,
                                    text: "send invoice",
                                    sx: {
                                        mt: "30px",
                                        width: buttonWidth,
                                        ml: 0,
                                        background: (theme)=>theme.palette.primary.main,
                                        "&:hover": {
                                            background: "white",
                                            border: "1px solid " + (0, $6L9uu.Colors).main,
                                            color: (0, $6L9uu.Colors).main,
                                            boxShadow: "none"
                                        },
                                        "&:disabled": {
                                            background: (theme)=>theme.palette.grey[300]
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "invoice-email-receiver",
                                    "data-testid": "invoice-email-receiver",
                                    label: "This invoice wii be sent to:",
                                    value: selectedInvoice?.contact?.email ?? "",
                                    disabled: true,
                                    withoutBackground: true,
                                    additionalStyle: {
                                        mt: "39px",
                                        pl: "2%"
                                    },
                                    inputLabelProps: {
                                        style: {
                                            top: "-12px",
                                            left: "7px"
                                        }
                                    }
                                }),
                                !disableSend && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                                            id: "add-cc",
                                            onClick: ()=>setOpenCcInput(true),
                                            text: "add cc",
                                            sx: {
                                                maxWidth: buttonWidth
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                            sx: {
                                                display: "flex",
                                                flexWrap: "wrap",
                                                gap: "8px"
                                            },
                                            children: ccRecipients.map((recipient, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $1ELi8.default), {
                                                    id: `${recipient}-chip-${index}`,
                                                    label: recipient,
                                                    onDelete: ()=>setCcRecipients(ccRecipients.filter((r)=>r !== recipient))
                                                }, `${recipient}-chip-${index}`))
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            openPreview && /*#__PURE__*/ (0, $ih19M.jsx)((0, $g8u5J.default), {
                handleClose: ()=>{
                    if (setPreview) setPreview();
                    setOpenPreview(false);
                },
                children: children || /*#__PURE__*/ (0, $ih19M.jsx)((0, $89CnP.default), {
                    fullscreen: true
                })
            }),
            openCcInput && /*#__PURE__*/ (0, $ih19M.jsx)((0, $6wWvz.default), {
                onClose: ()=>setOpenCcInput(false),
                recientsInput: ccRecipients,
                setCcRecipients: (rec)=>setCcRecipients(rec)
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                loading: loading || sendInvoiceForApprovalResult.loading || sendInvoiceToCustomerResult.loading
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    overflow: "hidden",
                    height: 0
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    ref: invoiceRef,
                    style: {
                        height: "1150px",
                        width: "815px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $89CnP.default), {
                        fullscreen: true
                    })
                })
            })
        ]
    });
};
var $e22a6de2a2fd3051$export$2e2bcd8739ae039 = $e22a6de2a2fd3051$var$InvoiceStep;

});
parcelRegister("fziws", function(module, exports) {


!function(e, t) {
    module.exports = t((parcelRequire("bh6RR")), (parcelRequire("6afFj")));
}("undefined" != typeof self ? self : module.exports, function(e, t) {
    return function() {
        "use strict";
        var r = {
            328: function(e, t, r) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.PrintContextConsumer = t.PrintContext = void 0;
                var n = r(496), o = Object.prototype.hasOwnProperty.call(n, "createContext");
                t.PrintContext = o ? n.createContext({}) : null, t.PrintContextConsumer = t.PrintContext ? t.PrintContext.Consumer : function() {
                    return null;
                };
            },
            428: function(e, t, r) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ReactToPrint = void 0;
                var n = r(316), o = r(496), i = r(190), a = r(328), c = r(940), s = function(e) {
                    function t() {
                        var t = e.apply(this, n.__spreadArray([], n.__read(arguments), !1)) || this;
                        return t.startPrint = function(e) {
                            var r = t.props, n = r.onAfterPrint, o = r.onPrintError, i = r.print, a = r.documentTitle;
                            setTimeout(function() {
                                var r, c;
                                if (e.contentWindow) {
                                    if (e.contentWindow.focus(), i) i(e).then(function() {
                                        return null == n ? void 0 : n();
                                    }).then(function() {
                                        return t.handleRemoveIframe();
                                    }).catch(function(e) {
                                        o ? o("print", e) : t.logMessages([
                                            "An error was thrown by the specified `print` function"
                                        ]);
                                    });
                                    else {
                                        if (e.contentWindow.print) {
                                            var s = null !== (c = null === (r = e.contentDocument) || void 0 === r ? void 0 : r.title) && void 0 !== c ? c : "", u = e.ownerDocument.title;
                                            a && (e.ownerDocument.title = a, e.contentDocument && (e.contentDocument.title = a)), e.contentWindow.print(), a && (e.ownerDocument.title = u, e.contentDocument && (e.contentDocument.title = s));
                                        } else t.logMessages([
                                            "Printing for this browser is not currently possible: the browser does not have a `print` method available for iframes."
                                        ]);
                                        null == n || n(), t.handleRemoveIframe();
                                    }
                                } else t.logMessages([
                                    "Printing failed because the `contentWindow` of the print iframe did not load. This is possibly an error with `react-to-print`. Please file an issue: https://github.com/gregnb/react-to-print/issues/"
                                ]);
                            }, 500);
                        }, t.triggerPrint = function(e) {
                            var r = t.props, n = r.onBeforePrint, o = r.onPrintError;
                            if (n) {
                                var i = n();
                                i && "function" == typeof i.then ? i.then(function() {
                                    t.startPrint(e);
                                }).catch(function(e) {
                                    o && o("onBeforePrint", e);
                                }) : t.startPrint(e);
                            } else t.startPrint(e);
                        }, t.handlePrint = function(e) {
                            var r = t.props, o = r.bodyClass, a = r.content, c = r.copyStyles, s = r.fonts, u = r.pageStyle, l = r.nonce, f = "function" == typeof e ? e() : null;
                            if (f && "function" == typeof a && t.logMessages([
                                '"react-to-print" received a `content` prop and a content param passed the callback return by `useReactToPrint. The `content` prop will be ignored.'
                            ], "warning"), f || "function" != typeof a || (f = a()), void 0 !== f) {
                                if (null !== f) {
                                    var d = document.createElement("iframe");
                                    d.width = "".concat(document.documentElement.clientWidth, "px"), d.height = "".concat(document.documentElement.clientHeight, "px"), d.style.position = "absolute", d.style.top = "-".concat(document.documentElement.clientHeight + 100, "px"), d.style.left = "-".concat(document.documentElement.clientWidth + 100, "px"), d.id = "printWindow", d.srcdoc = "<!DOCTYPE html>";
                                    var p = (0, i.findDOMNode)(f);
                                    if (p) {
                                        var h = p.cloneNode(!0), y = h instanceof Text, b = document.querySelectorAll("link[rel~='stylesheet'], link[as='style']"), v = y ? [] : h.querySelectorAll("img"), g = y ? [] : h.querySelectorAll("video"), m = s ? s.length : 0;
                                        t.numResourcesToLoad = b.length + v.length + g.length + m, t.resourcesLoaded = [], t.resourcesErrored = [];
                                        var _ = function(e, r) {
                                            t.resourcesLoaded.includes(e) ? t.logMessages([
                                                "Tried to mark a resource that has already been handled",
                                                e
                                            ], "debug") : (r ? (t.logMessages(n.__spreadArray([
                                                '"react-to-print" was unable to load a resource but will continue attempting to print the page'
                                            ], n.__read(r), !1)), t.resourcesErrored.push(e)) : t.resourcesLoaded.push(e), t.resourcesLoaded.length + t.resourcesErrored.length === t.numResourcesToLoad && t.triggerPrint(d));
                                        };
                                        d.onload = function() {
                                            var e, r, i, a;
                                            d.onload = null;
                                            var f = d.contentDocument || (null === (r = d.contentWindow) || void 0 === r ? void 0 : r.document);
                                            if (f) {
                                                f.body.appendChild(h), s && ((null === (i = d.contentDocument) || void 0 === i ? void 0 : i.fonts) && (null === (a = d.contentWindow) || void 0 === a ? void 0 : a.FontFace) ? s.forEach(function(e) {
                                                    var t = new FontFace(e.family, e.source, {
                                                        weight: e.weight,
                                                        style: e.style
                                                    });
                                                    d.contentDocument.fonts.add(t), t.loaded.then(function() {
                                                        _(t);
                                                    }).catch(function(e) {
                                                        _(t, [
                                                            "Failed loading the font:",
                                                            t,
                                                            "Load error:",
                                                            e
                                                        ]);
                                                    });
                                                }) : (s.forEach(function(e) {
                                                    return _(e);
                                                }), t.logMessages([
                                                    '"react-to-print" is not able to load custom fonts because the browser does not support the FontFace API but will continue attempting to print the page'
                                                ])));
                                                var b = "function" == typeof u ? u() : u;
                                                if ("string" != typeof b) t.logMessages([
                                                    '"react-to-print" expected a "string" from `pageStyle` but received "'.concat(typeof b, '". Styles from `pageStyle` will not be applied.')
                                                ]);
                                                else {
                                                    var m = f.createElement("style");
                                                    l && (m.setAttribute("nonce", l), f.head.setAttribute("nonce", l)), m.appendChild(f.createTextNode(b)), f.head.appendChild(m);
                                                }
                                                if (o && (e = f.body.classList).add.apply(e, n.__spreadArray([], n.__read(o.split(" ")), !1)), !y) {
                                                    for(var w = y ? [] : p.querySelectorAll("canvas"), P = f.querySelectorAll("canvas"), O = 0; O < w.length; ++O){
                                                        var x = w[O], S = P[O].getContext("2d");
                                                        S && S.drawImage(x, 0, 0);
                                                    }
                                                    var E = function(e) {
                                                        var t = v[e], r = t.getAttribute("src");
                                                        if (r) {
                                                            var n = new Image;
                                                            n.onload = function() {
                                                                return _(t);
                                                            }, n.onerror = function(e, r, n, o, i) {
                                                                return _(t, [
                                                                    "Error loading <img>",
                                                                    t,
                                                                    "Error",
                                                                    i
                                                                ]);
                                                            }, n.src = r;
                                                        } else _(t, [
                                                            'Found an <img> tag with an empty "src" attribute. This prevents pre-loading it. The <img> is:',
                                                            t
                                                        ]);
                                                    };
                                                    for(O = 0; O < v.length; O++)E(O);
                                                    var T = function(e) {
                                                        var t = g[e];
                                                        t.preload = "auto";
                                                        var r = t.getAttribute("poster");
                                                        if (r) {
                                                            var n = new Image;
                                                            n.onload = function() {
                                                                return _(t);
                                                            }, n.onerror = function(e, n, o, i, a) {
                                                                return _(t, [
                                                                    "Error loading video poster",
                                                                    r,
                                                                    "for video",
                                                                    t,
                                                                    "Error:",
                                                                    a
                                                                ]);
                                                            }, n.src = r;
                                                        } else t.readyState >= 2 ? _(t) : (t.onloadeddata = function() {
                                                            return _(t);
                                                        }, t.onerror = function(e, r, n, o, i) {
                                                            return _(t, [
                                                                "Error loading video",
                                                                t,
                                                                "Error",
                                                                i
                                                            ]);
                                                        }, t.onstalled = function() {
                                                            return _(t, [
                                                                "Loading video stalled, skipping",
                                                                t
                                                            ]);
                                                        });
                                                    };
                                                    for(O = 0; O < g.length; O++)T(O);
                                                    var j = "input", C = p.querySelectorAll(j), A = f.querySelectorAll(j);
                                                    for(O = 0; O < C.length; O++)A[O].value = C[O].value;
                                                    var k = "input[type=checkbox],input[type=radio]", R = p.querySelectorAll(k), M = f.querySelectorAll(k);
                                                    for(O = 0; O < R.length; O++)M[O].checked = R[O].checked;
                                                    var D = "select", I = p.querySelectorAll(D), q = f.querySelectorAll(D);
                                                    for(O = 0; O < I.length; O++)q[O].value = I[O].value;
                                                }
                                                if (c) for(var F = document.querySelectorAll("style, link[rel~='stylesheet'], link[as='style']"), W = function(e, r) {
                                                    var n = F[e];
                                                    if ("style" === n.tagName.toLowerCase()) {
                                                        var o = f.createElement(n.tagName), i = n.sheet;
                                                        if (i) {
                                                            var a = "";
                                                            try {
                                                                for(var c = i.cssRules.length, s = 0; s < c; ++s)"string" == typeof i.cssRules[s].cssText && (a += "".concat(i.cssRules[s].cssText, "\r\n"));
                                                            } catch (e) {
                                                                t.logMessages([
                                                                    "A stylesheet could not be accessed. This is likely due to the stylesheet having cross-origin imports, and many browsers block script access to cross-origin stylesheets. See https://github.com/gregnb/react-to-print/issues/429 for details. You may be able to load the sheet by both marking the stylesheet with the cross `crossorigin` attribute, and setting the `Access-Control-Allow-Origin` header on the server serving the stylesheet. Alternatively, host the stylesheet on your domain to avoid this issue entirely.",
                                                                    n
                                                                ], "warning");
                                                            }
                                                            o.setAttribute("id", "react-to-print-".concat(e)), l && o.setAttribute("nonce", l), o.appendChild(f.createTextNode(a)), f.head.appendChild(o);
                                                        }
                                                    } else if (n.getAttribute("href")) {
                                                        if (n.hasAttribute("disabled")) t.logMessages([
                                                            "`react-to-print` encountered a <link> tag with a `disabled` attribute and will ignore it. Note that the `disabled` attribute is deprecated, and some browsers ignore it. You should stop using it. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link#attr-disabled. The <link> is:",
                                                            n
                                                        ], "warning"), _(n);
                                                        else {
                                                            for(var u = f.createElement(n.tagName), d = (s = 0, n.attributes.length); s < d; ++s){
                                                                var p = n.attributes[s];
                                                                p && u.setAttribute(p.nodeName, p.nodeValue || "");
                                                            }
                                                            u.onload = function() {
                                                                return _(u);
                                                            }, u.onerror = function(e, t, r, n, o) {
                                                                return _(u, [
                                                                    "Failed to load",
                                                                    u,
                                                                    "Error:",
                                                                    o
                                                                ]);
                                                            }, l && u.setAttribute("nonce", l), f.head.appendChild(u);
                                                        }
                                                    } else t.logMessages([
                                                        "`react-to-print` encountered a <link> tag with an empty `href` attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:",
                                                        n
                                                    ], "warning"), _(n);
                                                }, L = (O = 0, F.length); O < L; ++O)W(O);
                                            }
                                            0 !== t.numResourcesToLoad && c || t.triggerPrint(d);
                                        }, t.handleRemoveIframe(!0), document.body.appendChild(d);
                                    } else t.logMessages([
                                        '"react-to-print" could not locate the DOM node corresponding with the `content` prop'
                                    ]);
                                } else t.logMessages([
                                    'There is nothing to print because the "content" prop returned "null". Please ensure "content" is renderable before allowing "react-to-print" to be called.'
                                ]);
                            } else t.logMessages([
                                "To print a functional component ensure it is wrapped with `React.forwardRef`, and ensure the forwarded ref is used. See the README for an example: https://github.com/gregnb/react-to-print#examples"
                            ]);
                        }, t.handleRemoveIframe = function(e) {
                            var r = t.props.removeAfterPrint;
                            if (e || r) {
                                var n = document.getElementById("printWindow");
                                n && document.body.removeChild(n);
                            }
                        }, t.logMessages = function(e, r) {
                            void 0 === r && (r = "error"), t.props.suppressErrors || ("error" === r ? console.error(e) : "warning" === r ? console.warn(e) : "debug" === r && console.debug(e));
                        }, t;
                    }
                    return n.__extends(t, e), t.prototype.handleClick = function(e, t) {
                        var r = this, n = this.props, o = n.onBeforeGetContent, i = n.onPrintError;
                        if (o) {
                            var a = o();
                            a && "function" == typeof a.then ? a.then(function() {
                                return r.handlePrint(t);
                            }).catch(function(e) {
                                i && i("onBeforeGetContent", e);
                            }) : this.handlePrint(t);
                        } else this.handlePrint(t);
                    }, t.prototype.render = function() {
                        var e = this.props, t = e.children, r = e.trigger;
                        if (r) return o.cloneElement(r(), {
                            onClick: this.handleClick.bind(this)
                        });
                        if (!a.PrintContext) return this.logMessages([
                            '"react-to-print" requires React ^16.3.0 to be able to use "PrintContext"'
                        ]), null;
                        var n = {
                            handlePrint: this.handleClick.bind(this)
                        };
                        return o.createElement(a.PrintContext.Provider, {
                            value: n
                        }, t);
                    }, t.defaultProps = c.defaultProps, t;
                }(o.Component);
                t.ReactToPrint = s;
            },
            940: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.defaultProps = void 0, t.defaultProps = {
                    copyStyles: !0,
                    pageStyle: "\n        @page {\n            /* Remove browser default header (title) and footer (url) */\n            margin: 0;\n        }\n        @media print {\n            body {\n                /* Tell browsers to print background colors */\n                -webkit-print-color-adjust: exact; /* Chrome/Safari/Edge/Opera */\n                color-adjust: exact; /* Firefox */\n            }\n        }\n    ",
                    removeAfterPrint: !1,
                    suppressErrors: !1
                };
            },
            892: function(e, t, r) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.useReactToPrint = void 0;
                var n = r(316), o = r(496), i = r(428), a = r(940), c = r(860), s = Object.prototype.hasOwnProperty.call(o, "useMemo") && Object.prototype.hasOwnProperty.call(o, "useCallback");
                t.useReactToPrint = function(e) {
                    if (!s) return e.suppressErrors || console.error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"'), function() {
                        throw new Error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"');
                    };
                    var t = o.useMemo(function() {
                        return new i.ReactToPrint(n.__assign(n.__assign({}, a.defaultProps), e));
                    }, [
                        e
                    ]);
                    return o.useCallback(function(e, r) {
                        return (0, c.wrapCallbackWithArgs)(t, t.handleClick, r)(e);
                    }, [
                        t
                    ]);
                };
            },
            860: function(e, t, r) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.wrapCallbackWithArgs = void 0;
                var n = r(316);
                t.wrapCallbackWithArgs = function(e, t) {
                    for(var r = [], o = 2; o < arguments.length; o++)r[o - 2] = arguments[o];
                    return function() {
                        for(var o = [], i = 0; i < arguments.length; i++)o[i] = arguments[i];
                        return t.apply(e, n.__spreadArray(n.__spreadArray([], n.__read(o), !1), n.__read(r), !1));
                    };
                };
            },
            496: function(t) {
                t.exports = e;
            },
            190: function(e) {
                e.exports = t;
            },
            316: function(e, t, r) {
                r.r(t), r.d(t, {
                    __addDisposableResource: function() {
                        return D;
                    },
                    __assign: function() {
                        return i;
                    },
                    __asyncDelegator: function() {
                        return S;
                    },
                    __asyncGenerator: function() {
                        return x;
                    },
                    __asyncValues: function() {
                        return E;
                    },
                    __await: function() {
                        return O;
                    },
                    __awaiter: function() {
                        return h;
                    },
                    __classPrivateFieldGet: function() {
                        return k;
                    },
                    __classPrivateFieldIn: function() {
                        return M;
                    },
                    __classPrivateFieldSet: function() {
                        return R;
                    },
                    __createBinding: function() {
                        return b;
                    },
                    __decorate: function() {
                        return c;
                    },
                    __disposeResources: function() {
                        return q;
                    },
                    __esDecorate: function() {
                        return u;
                    },
                    __exportStar: function() {
                        return v;
                    },
                    __extends: function() {
                        return o;
                    },
                    __generator: function() {
                        return y;
                    },
                    __importDefault: function() {
                        return A;
                    },
                    __importStar: function() {
                        return C;
                    },
                    __makeTemplateObject: function() {
                        return T;
                    },
                    __metadata: function() {
                        return p;
                    },
                    __param: function() {
                        return s;
                    },
                    __propKey: function() {
                        return f;
                    },
                    __read: function() {
                        return m;
                    },
                    __rest: function() {
                        return a;
                    },
                    __runInitializers: function() {
                        return l;
                    },
                    __setFunctionName: function() {
                        return d;
                    },
                    __spread: function() {
                        return _;
                    },
                    __spreadArray: function() {
                        return P;
                    },
                    __spreadArrays: function() {
                        return w;
                    },
                    __values: function() {
                        return g;
                    }
                });
                var n = function(e, t) {
                    return n = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(e, t) {
                        e.__proto__ = t;
                    } || function(e, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                    }, n(e, t);
                };
                function o(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function r() {
                        this.constructor = e;
                    }
                    n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }
                var i = function() {
                    return i = Object.assign || function(e) {
                        for(var t, r = 1, n = arguments.length; r < n; r++)for(var o in t = arguments[r])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                        return e;
                    }, i.apply(this, arguments);
                };
                function a(e, t) {
                    var r = {};
                    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var o = 0;
                        for(n = Object.getOwnPropertySymbols(e); o < n.length; o++)t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
                    }
                    return r;
                }
                function c(e, t, r, n) {
                    var o, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, r, n);
                    else for(var c = e.length - 1; c >= 0; c--)(o = e[c]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, r, a) : o(t, r)) || a);
                    return i > 3 && a && Object.defineProperty(t, r, a), a;
                }
                function s(e, t) {
                    return function(r, n) {
                        t(r, n, e);
                    };
                }
                function u(e, t, r, n, o, i) {
                    function a(e) {
                        if (void 0 !== e && "function" != typeof e) throw new TypeError("Function expected");
                        return e;
                    }
                    for(var c, s = n.kind, u = "getter" === s ? "get" : "setter" === s ? "set" : "value", l = !t && e ? n.static ? e : e.prototype : null, f = t || (l ? Object.getOwnPropertyDescriptor(l, n.name) : {}), d = !1, p = r.length - 1; p >= 0; p--){
                        var h = {};
                        for(var y in n)h[y] = "access" === y ? {} : n[y];
                        for(var y in n.access)h.access[y] = n.access[y];
                        h.addInitializer = function(e) {
                            if (d) throw new TypeError("Cannot add initializers after decoration has completed");
                            i.push(a(e || null));
                        };
                        var b = (0, r[p])("accessor" === s ? {
                            get: f.get,
                            set: f.set
                        } : f[u], h);
                        if ("accessor" === s) {
                            if (void 0 === b) continue;
                            if (null === b || "object" != typeof b) throw new TypeError("Object expected");
                            (c = a(b.get)) && (f.get = c), (c = a(b.set)) && (f.set = c), (c = a(b.init)) && o.unshift(c);
                        } else (c = a(b)) && ("field" === s ? o.unshift(c) : f[u] = c);
                    }
                    l && Object.defineProperty(l, n.name, f), d = !0;
                }
                function l(e, t, r) {
                    for(var n = arguments.length > 2, o = 0; o < t.length; o++)r = n ? t[o].call(e, r) : t[o].call(e);
                    return n ? r : void 0;
                }
                function f(e) {
                    return "symbol" == typeof e ? e : "".concat(e);
                }
                function d(e, t, r) {
                    return "symbol" == typeof t && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
                        configurable: !0,
                        value: r ? "".concat(r, " ", t) : t
                    });
                }
                function p(e, t) {
                    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
                }
                function h(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function a(e) {
                            try {
                                s(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            try {
                                s(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function s(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(a, c);
                        }
                        s((n = n.apply(e, t || [])).next());
                    });
                }
                function y(e, t) {
                    var r, n, o, i, a = {
                        label: 0,
                        sent: function() {
                            if (1 & o[0]) throw o[1];
                            return o[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return i = {
                        next: c(0),
                        throw: c(1),
                        return: c(2)
                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                        return this;
                    }), i;
                    function c(c) {
                        return function(s) {
                            return function(c) {
                                if (r) throw new TypeError("Generator is already executing.");
                                for(; i && (i = 0, c[0] && (a = 0)), a;)try {
                                    if (r = 1, n && (o = 2 & c[0] ? n.return : c[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, c[1])).done) return o;
                                    switch(n = 0, o && (c = [
                                        2 & c[0],
                                        o.value
                                    ]), c[0]){
                                        case 0:
                                        case 1:
                                            o = c;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: c[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, n = c[1], c = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            c = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((o = (o = a.trys).length > 0 && o[o.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === c[0] && (!o || c[1] > o[0] && c[1] < o[3])) {
                                                a.label = c[1];
                                                break;
                                            }
                                            if (6 === c[0] && a.label < o[1]) {
                                                a.label = o[1], o = c;
                                                break;
                                            }
                                            if (o && a.label < o[2]) {
                                                a.label = o[2], a.ops.push(c);
                                                break;
                                            }
                                            o[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    c = t.call(e, a);
                                } catch (e) {
                                    c = [
                                        6,
                                        e
                                    ], n = 0;
                                } finally{
                                    r = o = 0;
                                }
                                if (5 & c[0]) throw c[1];
                                return {
                                    value: c[0] ? c[1] : void 0,
                                    done: !0
                                };
                            }([
                                c,
                                s
                            ]);
                        };
                    }
                }
                var b = Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                };
                function v(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || b(t, e, r);
                }
                function g(e) {
                    var t = "function" == typeof Symbol && Symbol.iterator, r = t && e[t], n = 0;
                    if (r) return r.call(e);
                    if (e && "number" == typeof e.length) return {
                        next: function() {
                            return e && n >= e.length && (e = void 0), {
                                value: e && e[n++],
                                done: !e
                            };
                        }
                    };
                    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                }
                function m(e, t) {
                    var r = "function" == typeof Symbol && e[Symbol.iterator];
                    if (!r) return e;
                    var n, o, i = r.call(e), a = [];
                    try {
                        for(; (void 0 === t || t-- > 0) && !(n = i.next()).done;)a.push(n.value);
                    } catch (e) {
                        o = {
                            error: e
                        };
                    } finally{
                        try {
                            n && !n.done && (r = i.return) && r.call(i);
                        } finally{
                            if (o) throw o.error;
                        }
                    }
                    return a;
                }
                function _() {
                    for(var e = [], t = 0; t < arguments.length; t++)e = e.concat(m(arguments[t]));
                    return e;
                }
                function w() {
                    for(var e = 0, t = 0, r = arguments.length; t < r; t++)e += arguments[t].length;
                    var n = Array(e), o = 0;
                    for(t = 0; t < r; t++)for(var i = arguments[t], a = 0, c = i.length; a < c; a++, o++)n[o] = i[a];
                    return n;
                }
                function P(e, t, r) {
                    if (r || 2 === arguments.length) for(var n, o = 0, i = t.length; o < i; o++)!n && o in t || (n || (n = Array.prototype.slice.call(t, 0, o)), n[o] = t[o]);
                    return e.concat(n || Array.prototype.slice.call(t));
                }
                function O(e) {
                    return this instanceof O ? (this.v = e, this) : new O(e);
                }
                function x(e, t, r) {
                    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                    var n, o = r.apply(e, t || []), i = [];
                    return n = {}, a("next"), a("throw"), a("return"), n[Symbol.asyncIterator] = function() {
                        return this;
                    }, n;
                    function a(e) {
                        o[e] && (n[e] = function(t) {
                            return new Promise(function(r, n) {
                                i.push([
                                    e,
                                    t,
                                    r,
                                    n
                                ]) > 1 || c(e, t);
                            });
                        });
                    }
                    function c(e, t) {
                        try {
                            (r = o[e](t)).value instanceof O ? Promise.resolve(r.value.v).then(s, u) : l(i[0][2], r);
                        } catch (e) {
                            l(i[0][3], e);
                        }
                        var r;
                    }
                    function s(e) {
                        c("next", e);
                    }
                    function u(e) {
                        c("throw", e);
                    }
                    function l(e, t) {
                        e(t), i.shift(), i.length && c(i[0][0], i[0][1]);
                    }
                }
                function S(e) {
                    var t, r;
                    return t = {}, n("next"), n("throw", function(e) {
                        throw e;
                    }), n("return"), t[Symbol.iterator] = function() {
                        return this;
                    }, t;
                    function n(n, o) {
                        t[n] = e[n] ? function(t) {
                            return (r = !r) ? {
                                value: O(e[n](t)),
                                done: !1
                            } : o ? o(t) : t;
                        } : o;
                    }
                }
                function E(e) {
                    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                    var t, r = e[Symbol.asyncIterator];
                    return r ? r.call(e) : (e = g(e), t = {}, n("next"), n("throw"), n("return"), t[Symbol.asyncIterator] = function() {
                        return this;
                    }, t);
                    function n(r) {
                        t[r] = e[r] && function(t) {
                            return new Promise(function(n, o) {
                                !function(e, t, r, n) {
                                    Promise.resolve(n).then(function(t) {
                                        e({
                                            value: t,
                                            done: r
                                        });
                                    }, t);
                                }(n, o, (t = e[r](t)).done, t.value);
                            });
                        };
                    }
                }
                function T(e, t) {
                    return Object.defineProperty ? Object.defineProperty(e, "raw", {
                        value: t
                    }) : e.raw = t, e;
                }
                var j = Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                };
                function C(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && b(t, e, r);
                    return j(t, e), t;
                }
                function A(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function k(e, t, r, n) {
                    if ("a" === r && !n) throw new TypeError("Private accessor was defined without a getter");
                    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
                    return "m" === r ? n : "a" === r ? n.call(e) : n ? n.value : t.get(e);
                }
                function R(e, t, r, n, o) {
                    if ("m" === n) throw new TypeError("Private method is not writable");
                    if ("a" === n && !o) throw new TypeError("Private accessor was defined without a setter");
                    if ("function" == typeof t ? e !== t || !o : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
                    return "a" === n ? o.call(e, r) : o ? o.value = r : t.set(e, r), r;
                }
                function M(e, t) {
                    if (null === t || "object" != typeof t && "function" != typeof t) throw new TypeError("Cannot use 'in' operator on non-object");
                    return "function" == typeof e ? t === e : e.has(t);
                }
                function D(e, t, r) {
                    if (null != t) {
                        if ("object" != typeof t && "function" != typeof t) throw new TypeError("Object expected.");
                        var n;
                        if (r) {
                            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
                            n = t[Symbol.asyncDispose];
                        }
                        if (void 0 === n) {
                            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
                            n = t[Symbol.dispose];
                        }
                        if ("function" != typeof n) throw new TypeError("Object not disposable.");
                        e.stack.push({
                            value: t,
                            dispose: n,
                            async: r
                        });
                    } else r && e.stack.push({
                        async: !0
                    });
                    return t;
                }
                var I = "function" == typeof SuppressedError ? SuppressedError : function(e, t, r) {
                    var n = new Error(r);
                    return n.name = "SuppressedError", n.error = e, n.suppressed = t, n;
                };
                function q(e) {
                    function t(t) {
                        e.error = e.hasError ? new I(t, e.error, "An error was suppressed during disposal.") : t, e.hasError = !0;
                    }
                    return function r() {
                        for(; e.stack.length;){
                            var n = e.stack.pop();
                            try {
                                var o = n.dispose && n.dispose.call(n.value);
                                if (n.async) return Promise.resolve(o).then(r, function(e) {
                                    return t(e), r();
                                });
                            } catch (e) {
                                t(e);
                            }
                        }
                        if (e.hasError) throw e.error;
                    }();
                }
                t.default = {
                    __extends: o,
                    __assign: i,
                    __rest: a,
                    __decorate: c,
                    __param: s,
                    __metadata: p,
                    __awaiter: h,
                    __generator: y,
                    __createBinding: b,
                    __exportStar: v,
                    __values: g,
                    __read: m,
                    __spread: _,
                    __spreadArrays: w,
                    __spreadArray: P,
                    __await: O,
                    __asyncGenerator: x,
                    __asyncDelegator: S,
                    __asyncValues: E,
                    __makeTemplateObject: T,
                    __importStar: C,
                    __importDefault: A,
                    __classPrivateFieldGet: k,
                    __classPrivateFieldSet: R,
                    __classPrivateFieldIn: M,
                    __addDisposableResource: D,
                    __disposeResources: q
                };
            }
        }, n = {};
        function o(e) {
            var t = n[e];
            if (void 0 !== t) return t.exports;
            var i = n[e] = {
                exports: {}
            };
            return r[e](i, i.exports, o), i.exports;
        }
        o.d = function(e, t) {
            for(var r in t)o.o(t, r) && !o.o(e, r) && Object.defineProperty(e, r, {
                enumerable: !0,
                get: t[r]
            });
        }, o.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, o.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var i = {};
        return function() {
            var e = i;
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.useReactToPrint = e.ReactToPrint = e.PrintContextConsumer = void 0;
            var t = o(328);
            Object.defineProperty(e, "PrintContextConsumer", {
                enumerable: !0,
                get: function() {
                    return t.PrintContextConsumer;
                }
            });
            var r = o(428);
            Object.defineProperty(e, "ReactToPrint", {
                enumerable: !0,
                get: function() {
                    return r.ReactToPrint;
                }
            });
            var n = o(892);
            Object.defineProperty(e, "useReactToPrint", {
                enumerable: !0,
                get: function() {
                    return n.useReactToPrint;
                }
            });
            var a = o(428);
            e.default = a.ReactToPrint;
        }(), i;
    }();
});

});

parcelRegister("isGUU", function(module, exports) {
/*!
 * html2canvas 1.0.0-rc.13 <https://html2canvas.hertzen.com>
 * Copyright (c) 2020 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : new P(function(resolve) {
                    resolve(result.value);
                }).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    var Bounds = /** @class */ function() {
        function Bounds(x, y, w, h) {
            this.left = x;
            this.top = y;
            this.width = w;
            this.height = h;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(clientRect) {
            return new Bounds(clientRect.left, clientRect.top, clientRect.width, clientRect.height);
        };
        return Bounds;
    }();
    var parseBounds = function(node) {
        return Bounds.fromClientRect(node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 1.1.1 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2019 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup[base64.charCodeAt(i)];
            encoded2 = lookup[base64.charCodeAt(i + 1)];
            encoded3 = lookup[base64.charCodeAt(i + 2)];
            encoded4 = lookup[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    var base64 = "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";
    /* @flow */ var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR = 2; //  Cause a line break (after), except between CR and LF
    var LF = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var BREAK_MANDATORY = "!";
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var UnicodeTrie = createTrieFromBase64(base64);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR,
        LF,
        NL
    ];
    var SPACE = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = "strict";
        var types = [];
        var indicies = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                "normal",
                "auto",
                "loose"
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indicies.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indicies.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indicies.push(indicies[index - 1]);
                    return types.push(prev);
                }
                indicies.push(index);
                return types.push(AL);
            }
            indicies.push(index);
            if (classType === CJ) return types.push(lineBreak === "strict" ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indicies,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE.indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED;
        // LB8a Do not break between a zero width joiner and an ideograph, emoji base or emoji modifier.
        if (UnicodeTrie.get(codePoints[currentIndex]) === ZWJ && (next === ID || next === EB || next === EM)) return BREAK_NOT_ALLOWED;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED;
        // LB22 Do not break between two ellipses, or between letters, numbers or exclamations and ellipsis.
        if (next === IN && ALPHABETICS.concat(IN, EX, NU, ID, EB, EM).indexOf(current) !== -1) return BREAK_NOT_ALLOWED;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI && next === RI) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED;
        return BREAK_ALLOWED;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: "normal",
            wordBreak: "normal"
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === "break-all" || options.wordBreak === "break-word") classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === "keep-all" ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED);
                if (lineBreak !== BREAK_NOT_ALLOWED || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var TokenType;
    (function(TokenType) {
        TokenType[TokenType["STRING_TOKEN"] = 0] = "STRING_TOKEN";
        TokenType[TokenType["BAD_STRING_TOKEN"] = 1] = "BAD_STRING_TOKEN";
        TokenType[TokenType["LEFT_PARENTHESIS_TOKEN"] = 2] = "LEFT_PARENTHESIS_TOKEN";
        TokenType[TokenType["RIGHT_PARENTHESIS_TOKEN"] = 3] = "RIGHT_PARENTHESIS_TOKEN";
        TokenType[TokenType["COMMA_TOKEN"] = 4] = "COMMA_TOKEN";
        TokenType[TokenType["HASH_TOKEN"] = 5] = "HASH_TOKEN";
        TokenType[TokenType["DELIM_TOKEN"] = 6] = "DELIM_TOKEN";
        TokenType[TokenType["AT_KEYWORD_TOKEN"] = 7] = "AT_KEYWORD_TOKEN";
        TokenType[TokenType["PREFIX_MATCH_TOKEN"] = 8] = "PREFIX_MATCH_TOKEN";
        TokenType[TokenType["DASH_MATCH_TOKEN"] = 9] = "DASH_MATCH_TOKEN";
        TokenType[TokenType["INCLUDE_MATCH_TOKEN"] = 10] = "INCLUDE_MATCH_TOKEN";
        TokenType[TokenType["LEFT_CURLY_BRACKET_TOKEN"] = 11] = "LEFT_CURLY_BRACKET_TOKEN";
        TokenType[TokenType["RIGHT_CURLY_BRACKET_TOKEN"] = 12] = "RIGHT_CURLY_BRACKET_TOKEN";
        TokenType[TokenType["SUFFIX_MATCH_TOKEN"] = 13] = "SUFFIX_MATCH_TOKEN";
        TokenType[TokenType["SUBSTRING_MATCH_TOKEN"] = 14] = "SUBSTRING_MATCH_TOKEN";
        TokenType[TokenType["DIMENSION_TOKEN"] = 15] = "DIMENSION_TOKEN";
        TokenType[TokenType["PERCENTAGE_TOKEN"] = 16] = "PERCENTAGE_TOKEN";
        TokenType[TokenType["NUMBER_TOKEN"] = 17] = "NUMBER_TOKEN";
        TokenType[TokenType["FUNCTION"] = 18] = "FUNCTION";
        TokenType[TokenType["FUNCTION_TOKEN"] = 19] = "FUNCTION_TOKEN";
        TokenType[TokenType["IDENT_TOKEN"] = 20] = "IDENT_TOKEN";
        TokenType[TokenType["COLUMN_TOKEN"] = 21] = "COLUMN_TOKEN";
        TokenType[TokenType["URL_TOKEN"] = 22] = "URL_TOKEN";
        TokenType[TokenType["BAD_URL_TOKEN"] = 23] = "BAD_URL_TOKEN";
        TokenType[TokenType["CDC_TOKEN"] = 24] = "CDC_TOKEN";
        TokenType[TokenType["CDO_TOKEN"] = 25] = "CDO_TOKEN";
        TokenType[TokenType["COLON_TOKEN"] = 26] = "COLON_TOKEN";
        TokenType[TokenType["SEMICOLON_TOKEN"] = 27] = "SEMICOLON_TOKEN";
        TokenType[TokenType["LEFT_SQUARE_BRACKET_TOKEN"] = 28] = "LEFT_SQUARE_BRACKET_TOKEN";
        TokenType[TokenType["RIGHT_SQUARE_BRACKET_TOKEN"] = 29] = "RIGHT_SQUARE_BRACKET_TOKEN";
        TokenType[TokenType["UNICODE_RANGE_TOKEN"] = 30] = "UNICODE_RANGE_TOKEN";
        TokenType[TokenType["WHITESPACE_TOKEN"] = 31] = "WHITESPACE_TOKEN";
        TokenType[TokenType["EOF_TOKEN"] = 32] = "EOF_TOKEN";
    })(TokenType || (TokenType = {}));
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE$1 = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE$1;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: TokenType.LEFT_PARENTHESIS_TOKEN
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: TokenType.RIGHT_PARENTHESIS_TOKEN
    };
    var COMMA_TOKEN = {
        type: TokenType.COMMA_TOKEN
    };
    var SUFFIX_MATCH_TOKEN = {
        type: TokenType.SUFFIX_MATCH_TOKEN
    };
    var PREFIX_MATCH_TOKEN = {
        type: TokenType.PREFIX_MATCH_TOKEN
    };
    var COLUMN_TOKEN = {
        type: TokenType.COLUMN_TOKEN
    };
    var DASH_MATCH_TOKEN = {
        type: TokenType.DASH_MATCH_TOKEN
    };
    var INCLUDE_MATCH_TOKEN = {
        type: TokenType.INCLUDE_MATCH_TOKEN
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: TokenType.LEFT_CURLY_BRACKET_TOKEN
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: TokenType.RIGHT_CURLY_BRACKET_TOKEN
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: TokenType.SUBSTRING_MATCH_TOKEN
    };
    var BAD_URL_TOKEN = {
        type: TokenType.BAD_URL_TOKEN
    };
    var BAD_STRING_TOKEN = {
        type: TokenType.BAD_STRING_TOKEN
    };
    var CDO_TOKEN = {
        type: TokenType.CDO_TOKEN
    };
    var CDC_TOKEN = {
        type: TokenType.CDC_TOKEN
    };
    var COLON_TOKEN = {
        type: TokenType.COLON_TOKEN
    };
    var SEMICOLON_TOKEN = {
        type: TokenType.SEMICOLON_TOKEN
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: TokenType.LEFT_SQUARE_BRACKET_TOKEN
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: TokenType.RIGHT_SQUARE_BRACKET_TOKEN
    };
    var WHITESPACE_TOKEN = {
        type: TokenType.WHITESPACE_TOKEN
    };
    var EOF_TOKEN = {
        type: TokenType.EOF_TOKEN
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: TokenType.HASH_TOKEN,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: TokenType.AT_KEYWORD_TOKEN,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: TokenType.DELIM_TOKEN,
                value: fromCodePoint(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === "undefined" ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: TokenType.UNICODE_RANGE_TOKEN,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint.apply(void 0, endDigits), 16);
                return {
                    type: TokenType.UNICODE_RANGE_TOKEN,
                    start: start,
                    end: end
                };
            } else return {
                type: TokenType.UNICODE_RANGE_TOKEN,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === "url" && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: TokenType.FUNCTION_TOKEN,
                    value: value
                };
            }
            return {
                type: TokenType.IDENT_TOKEN,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: TokenType.URL_TOKEN,
                value: ""
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === TokenType.STRING_TOKEN) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: TokenType.URL_TOKEN,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: TokenType.URL_TOKEN,
                    value: fromCodePoint.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: TokenType.URL_TOKEN,
                            value: fromCodePoint.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 60000;
            var value = "";
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = "";
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: TokenType.STRING_TOKEN,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: TokenType.DIMENSION_TOKEN,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: TokenType.PERCENTAGE_TOKEN,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: TokenType.NUMBER_TOKEN,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = "";
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === TokenType.WHITESPACE_TOKEN)token = this.consumeToken();
            if (token.type === TokenType.EOF_TOKEN) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === TokenType.WHITESPACE_TOKEN);
            if (token.type === TokenType.EOF_TOKEN) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === TokenType.EOF_TOKEN) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case TokenType.LEFT_CURLY_BRACKET_TOKEN:
                case TokenType.LEFT_SQUARE_BRACKET_TOKEN:
                case TokenType.LEFT_PARENTHESIS_TOKEN:
                    return this.consumeSimpleBlock(token.type);
                case TokenType.FUNCTION_TOKEN:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === TokenType.EOF_TOKEN || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: TokenType.FUNCTION
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === TokenType.EOF_TOKEN || token.type === TokenType.RIGHT_PARENTHESIS_TOKEN) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === "undefined" ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === TokenType.DIMENSION_TOKEN;
    };
    var isNumberToken = function(token) {
        return token.type === TokenType.NUMBER_TOKEN;
    };
    var isIdentToken = function(token) {
        return token.type === TokenType.IDENT_TOKEN;
    };
    var isStringToken = function(token) {
        return token.type === TokenType.STRING_TOKEN;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== TokenType.WHITESPACE_TOKEN;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== TokenType.WHITESPACE_TOKEN && token.type !== TokenType.COMMA_TOKEN;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === TokenType.COMMA_TOKEN) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== TokenType.WHITESPACE_TOKEN) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === TokenType.LEFT_CURLY_BRACKET_TOKEN && token.type === TokenType.RIGHT_CURLY_BRACKET_TOKEN) return true;
        if (type === TokenType.LEFT_SQUARE_BRACKET_TOKEN && token.type === TokenType.RIGHT_SQUARE_BRACKET_TOKEN) return true;
        return type === TokenType.LEFT_PARENTHESIS_TOKEN && token.type === TokenType.RIGHT_PARENTHESIS_TOKEN;
    };
    var isLength = function(token) {
        return token.type === TokenType.NUMBER_TOKEN || token.type === TokenType.DIMENSION_TOKEN;
    };
    var isLengthPercentage = function(token) {
        return token.type === TokenType.PERCENTAGE_TOKEN || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: TokenType.NUMBER_TOKEN,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== "undefined" ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === TokenType.PERCENTAGE_TOKEN) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case "rem":
            case "em":
                return 16 * token.number; // TODO use correct font-size
            case "px":
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = "deg";
    var GRAD = "grad";
    var RAD = "rad";
    var TURN = "turn";
    var angle = {
        name: "angle",
        parse: function(value) {
            if (value.type === TokenType.DIMENSION_TOKEN) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === TokenType.DIMENSION_TOKEN) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(" ");
        switch(sideOrCorner){
            case "to bottom right":
            case "to right bottom":
            case "left top":
            case "top left":
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case "to top":
            case "bottom":
                return deg(0);
            case "to bottom left":
            case "to left bottom":
            case "right top":
            case "top right":
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case "to right":
            case "left":
                return deg(90);
            case "to top left":
            case "to left top":
            case "right bottom":
            case "bottom right":
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case "to bottom":
            case "top":
                return deg(180);
            case "to top right":
            case "to right top":
            case "left bottom":
            case "bottom left":
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case "to left":
            case "right":
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color = {
        name: "color",
        parse: function(value) {
            if (value.type === TokenType.FUNCTION) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === "undefined") throw new Error('Attempting to parse an unsupported color function "' + value.name + '"');
                return colorFunction(value.values);
            }
            if (value.type === TokenType.HASH_TOKEN) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === TokenType.IDENT_TOKEN) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== "undefined") return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === TokenType.NUMBER_TOKEN) return token.number;
        if (token.type === TokenType.PERCENTAGE_TOKEN) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === TokenType.NUMBER_TOKEN ? deg(hue.number) : angle.parse(hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== "undefined" && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var PropertyDescriptorParsingType;
    (function(PropertyDescriptorParsingType) {
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["VALUE"] = 0] = "VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["LIST"] = 1] = "LIST";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["IDENT_VALUE"] = 2] = "IDENT_VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["TYPE_VALUE"] = 3] = "TYPE_VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["TOKEN_VALUE"] = 4] = "TOKEN_VALUE";
    })(PropertyDescriptorParsingType || (PropertyDescriptorParsingType = {}));
    var BACKGROUND_CLIP;
    (function(BACKGROUND_CLIP) {
        BACKGROUND_CLIP[BACKGROUND_CLIP["BORDER_BOX"] = 0] = "BORDER_BOX";
        BACKGROUND_CLIP[BACKGROUND_CLIP["PADDING_BOX"] = 1] = "PADDING_BOX";
        BACKGROUND_CLIP[BACKGROUND_CLIP["CONTENT_BOX"] = 2] = "CONTENT_BOX";
    })(BACKGROUND_CLIP || (BACKGROUND_CLIP = {}));
    var backgroundClip = {
        name: "background-clip",
        initialValue: "border-box",
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function(tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return BACKGROUND_CLIP.PADDING_BOX;
                    case "content-box":
                        return BACKGROUND_CLIP.CONTENT_BOX;
                }
                return BACKGROUND_CLIP.BORDER_BOX;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: "transparent",
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: "color"
    };
    var parseColorStop = function(args) {
        var color$1 = color.parse(args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color$1,
            stop: stop
        } : {
            color: color$1,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === "number" ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case CSSRadialExtent.CLOSEST_SIDE:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === CSSRadialShape.CIRCLE) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case CSSRadialExtent.CLOSEST_CORNER:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === CSSRadialShape.CIRCLE) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case CSSRadialExtent.FARTHEST_SIDE:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === CSSRadialShape.CIRCLE) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case CSSRadialExtent.FARTHEST_CORNER:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === CSSRadialShape.CIRCLE) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === TokenType.IDENT_TOKEN && firstToken.value === "to") {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: CSSImageType.LINEAR_GRADIENT
        };
    };
    var prefixLinearGradient = function(tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === TokenType.IDENT_TOKEN && [
                    "top",
                    "left",
                    "right",
                    "bottom"
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: CSSImageType.LINEAR_GRADIENT
        };
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement("boundtest");
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = "block";
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== "undefined";
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === "string";
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement("canvas");
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext("2d");
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = "rgb(0, 255, 0)";
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = "red";
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = "red";
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement("div");
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = "http://www.w3.org/2000/svg";
        var svg = document.createElementNS(xmlns, "svg");
        var foreignObject = document.createElementNS(xmlns, "foreignObject");
        svg.setAttributeNS(null, "width", width.toString());
        svg.setAttributeNS(null, "height", height.toString());
        foreignObject.setAttributeNS(null, "width", "100%");
        foreignObject.setAttributeNS(null, "height", "100%");
        foreignObject.setAttributeNS(null, "x", x.toString());
        foreignObject.setAttributeNS(null, "y", y.toString());
        foreignObject.setAttributeNS(null, "externalResourcesRequired", "true");
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, "SUPPORT_RANGE_BOUNDS", {
                value: value
            });
            return value;
        },
        get SUPPORT_SVG_DRAWING () {
            var value1 = testSVG(document);
            Object.defineProperty(FEATURES, "SUPPORT_SVG_DRAWING", {
                value: value1
            });
            return value1;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value2 = typeof Array.from === "function" && typeof window.fetch === "function" ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, "SUPPORT_FOREIGNOBJECT_DRAWING", {
                value: value2
            });
            return value2;
        },
        get SUPPORT_CORS_IMAGES () {
            var value3 = testCORS();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_IMAGES", {
                value: value3
            });
            return value3;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value4 = testResponseType();
            Object.defineProperty(FEATURES, "SUPPORT_RESPONSE_TYPE", {
                value: value4
            });
            return value4;
        },
        get SUPPORT_CORS_XHR () {
            var value5 = "withCredentials" in new XMLHttpRequest();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_XHR", {
                value: value5
            });
            return value5;
        }
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.debug === "function") // eslint-disable-next-line no-console
                console.debug.apply(console, [
                    this.id,
                    this.getTime() + "ms"
                ].concat(args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        Logger.create = function(options) {
            Logger.instances[options.id] = new Logger(options);
        };
        Logger.destroy = function(id) {
            delete Logger.instances[id];
        };
        Logger.getInstance = function(id) {
            var instance = Logger.instances[id];
            if (typeof instance === "undefined") throw new Error("No logger instance found with id " + id);
            return instance;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== "undefined" && window.console && typeof console.info === "function") // eslint-disable-next-line no-console
                console.info.apply(console, [
                    this.id,
                    this.getTime() + "ms"
                ].concat(args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.error === "function") // eslint-disable-next-line no-console
                console.error.apply(console, [
                    this.id,
                    this.getTime() + "ms"
                ].concat(args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.create = function(name, options) {
            return CacheStorage._caches[name] = new Cache(name, options);
        };
        CacheStorage.destroy = function(name) {
            delete CacheStorage._caches[name];
        };
        CacheStorage.open = function(name) {
            var cache = CacheStorage._caches[name];
            if (typeof cache !== "undefined") return cache;
            throw new Error('Cache with key "' + name + '" not found');
        };
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return "about:blank";
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement("a");
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage.getInstance = function() {
            var current = CacheStorage._current;
            if (current === null) throw new Error("No cache instance attached");
            return current;
        };
        CacheStorage.attachInstance = function(cache) {
            CacheStorage._current = cache;
        };
        CacheStorage.detachInstance = function() {
            CacheStorage._current = null;
        };
        CacheStorage._caches = {};
        CacheStorage._origin = "about:blank";
        CacheStorage._current = null;
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(id, options) {
            this.id = id;
            this._options = options;
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                this._cache[src] = this.loadImage(src);
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && typeof this._options.proxy === "string" && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            Logger.getInstance(this.id).debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = "anonymous";
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== "undefined";
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error("No proxy defined");
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? "blob" : "text";
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === "text") resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener("load", function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener("error", function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                xhr.open("GET", proxy + "?url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== "text" && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === "blob";
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === "svg" || INLINE_SVG.test(src);
    };
    var webkitGradient = function(tokens) {
        var angle = deg(180);
        var stops = [];
        var type = CSSImageType.LINEAR_GRADIENT;
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === "linear") {
                    type = CSSImageType.LINEAR_GRADIENT;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === "radial") {
                    type = CSSImageType.RADIAL_GRADIENT;
                    return;
                }
            }
            if (firstToken.type === TokenType.FUNCTION) {
                if (firstToken.name === "from") {
                    var color$1 = color.parse(firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color$1
                    });
                } else if (firstToken.name === "to") {
                    var color$1 = color.parse(firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color$1
                    });
                } else if (firstToken.name === "color-stop") {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color$1 = color.parse(values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: TokenType.PERCENTAGE_TOKEN,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color$1
                        });
                    }
                }
            }
        });
        return type === CSSImageType.LINEAR_GRADIENT ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = "closest-side";
    var FARTHEST_SIDE = "farthest-side";
    var CLOSEST_CORNER = "closest-corner";
    var FARTHEST_CORNER = "farthest-corner";
    var CIRCLE = "circle";
    var ELLIPSE = "ellipse";
    var COVER = "cover";
    var CONTAIN = "contain";
    var radialGradient = function(tokens) {
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case "center":
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case "top":
                            case "left":
                                position.push(ZERO_LENGTH);
                                return acc;
                            case "right":
                            case "bottom":
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = CSSRadialShape.CIRCLE;
                            return false;
                        case ELLIPSE:
                            shape = CSSRadialShape.ELLIPSE;
                            return false;
                        case "at":
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = CSSRadialExtent.CLOSEST_SIDE;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = CSSRadialExtent.FARTHEST_SIDE;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = CSSRadialExtent.CLOSEST_CORNER;
                            return false;
                        case FARTHEST_CORNER:
                            size = CSSRadialExtent.FARTHEST_CORNER;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: CSSImageType.RADIAL_GRADIENT
        };
    };
    var prefixRadialGradient = function(tokens) {
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case "center":
                        position.push(FIFTY_PERCENT);
                        return false;
                    case "top":
                    case "left":
                        position.push(ZERO_LENGTH);
                        return false;
                    case "right":
                    case "bottom":
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = CSSRadialShape.CIRCLE;
                        return false;
                    case ELLIPSE:
                        shape = CSSRadialShape.ELLIPSE;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = CSSRadialExtent.CLOSEST_SIDE;
                        return false;
                    case FARTHEST_SIDE:
                        size = CSSRadialExtent.FARTHEST_SIDE;
                        return false;
                    case CLOSEST_CORNER:
                        size = CSSRadialExtent.CLOSEST_CORNER;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = CSSRadialExtent.FARTHEST_CORNER;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: CSSImageType.RADIAL_GRADIENT
        };
    };
    var CSSImageType;
    (function(CSSImageType) {
        CSSImageType[CSSImageType["URL"] = 0] = "URL";
        CSSImageType[CSSImageType["LINEAR_GRADIENT"] = 1] = "LINEAR_GRADIENT";
        CSSImageType[CSSImageType["RADIAL_GRADIENT"] = 2] = "RADIAL_GRADIENT";
    })(CSSImageType || (CSSImageType = {}));
    var isLinearGradient = function(background) {
        return background.type === CSSImageType.LINEAR_GRADIENT;
    };
    var isRadialGradient = function(background) {
        return background.type === CSSImageType.RADIAL_GRADIENT;
    };
    var CSSRadialShape;
    (function(CSSRadialShape) {
        CSSRadialShape[CSSRadialShape["CIRCLE"] = 0] = "CIRCLE";
        CSSRadialShape[CSSRadialShape["ELLIPSE"] = 1] = "ELLIPSE";
    })(CSSRadialShape || (CSSRadialShape = {}));
    var CSSRadialExtent;
    (function(CSSRadialExtent) {
        CSSRadialExtent[CSSRadialExtent["CLOSEST_SIDE"] = 0] = "CLOSEST_SIDE";
        CSSRadialExtent[CSSRadialExtent["FARTHEST_SIDE"] = 1] = "FARTHEST_SIDE";
        CSSRadialExtent[CSSRadialExtent["CLOSEST_CORNER"] = 2] = "CLOSEST_CORNER";
        CSSRadialExtent[CSSRadialExtent["FARTHEST_CORNER"] = 3] = "FARTHEST_CORNER";
    })(CSSRadialExtent || (CSSRadialExtent = {}));
    var image = {
        name: "image",
        parse: function(value) {
            if (value.type === TokenType.URL_TOKEN) {
                var image_1 = {
                    url: value.value,
                    type: CSSImageType.URL
                };
                CacheStorage.getInstance().addImage(value.value);
                return image_1;
            }
            if (value.type === TokenType.FUNCTION) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === "undefined") throw new Error('Attempting to parse an unsupported image function "' + value.name + '"');
                return imageFunction(value.values);
            }
            throw new Error("Unsupported image type");
        }
    };
    function isSupportedImage(value) {
        return value.type !== TokenType.FUNCTION || SUPPORTED_IMAGE_FUNCTIONS[value.name];
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        "linear-gradient": linearGradient,
        "-moz-linear-gradient": prefixLinearGradient,
        "-ms-linear-gradient": prefixLinearGradient,
        "-o-linear-gradient": prefixLinearGradient,
        "-webkit-linear-gradient": prefixLinearGradient,
        "radial-gradient": radialGradient,
        "-moz-radial-gradient": prefixRadialGradient,
        "-ms-radial-gradient": prefixRadialGradient,
        "-o-radial-gradient": prefixRadialGradient,
        "-webkit-radial-gradient": prefixRadialGradient,
        "-webkit-gradient": webkitGradient
    };
    var backgroundImage = {
        name: "background-image",
        initialValue: "none",
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function(tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === "none") return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(image.parse);
        }
    };
    var backgroundOrigin = {
        name: "background-origin",
        initialValue: "border-box",
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function(tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: "background-position",
        initialValue: "0% 0%",
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function(tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var BACKGROUND_REPEAT;
    (function(BACKGROUND_REPEAT) {
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT"] = 0] = "REPEAT";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["NO_REPEAT"] = 1] = "NO_REPEAT";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT_X"] = 2] = "REPEAT_X";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT_Y"] = 3] = "REPEAT_Y";
    })(BACKGROUND_REPEAT || (BACKGROUND_REPEAT = {}));
    var backgroundRepeat = {
        name: "background-repeat",
        initialValue: "repeat",
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function(tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(" ");
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case "no-repeat":
                return BACKGROUND_REPEAT.NO_REPEAT;
            case "repeat-x":
            case "repeat no-repeat":
                return BACKGROUND_REPEAT.REPEAT_X;
            case "repeat-y":
            case "no-repeat repeat":
                return BACKGROUND_REPEAT.REPEAT_Y;
            case "repeat":
            default:
                return BACKGROUND_REPEAT.REPEAT;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: "background-size",
        initialValue: "0",
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function(tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: "transparent",
            prefix: false,
            type: PropertyDescriptorParsingType.TYPE_VALUE,
            format: "color"
        };
    };
    var borderTopColor = borderColorForSide("top");
    var borderRightColor = borderColorForSide("right");
    var borderBottomColor = borderColorForSide("bottom");
    var borderLeftColor = borderColorForSide("left");
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: "0 0",
            prefix: false,
            type: PropertyDescriptorParsingType.LIST,
            parse: function(tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide("top-left");
    var borderTopRightRadius = borderRadiusForSide("top-right");
    var borderBottomRightRadius = borderRadiusForSide("bottom-right");
    var borderBottomLeftRadius = borderRadiusForSide("bottom-left");
    var BORDER_STYLE;
    (function(BORDER_STYLE) {
        BORDER_STYLE[BORDER_STYLE["NONE"] = 0] = "NONE";
        BORDER_STYLE[BORDER_STYLE["SOLID"] = 1] = "SOLID";
    })(BORDER_STYLE || (BORDER_STYLE = {}));
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: "solid",
            prefix: false,
            type: PropertyDescriptorParsingType.IDENT_VALUE,
            parse: function(style) {
                switch(style){
                    case "none":
                        return BORDER_STYLE.NONE;
                }
                return BORDER_STYLE.SOLID;
            }
        };
    };
    var borderTopStyle = borderStyleForSide("top");
    var borderRightStyle = borderStyleForSide("right");
    var borderBottomStyle = borderStyleForSide("bottom");
    var borderLeftStyle = borderStyleForSide("left");
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: "0",
            type: PropertyDescriptorParsingType.VALUE,
            prefix: false,
            parse: function(token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide("top");
    var borderRightWidth = borderWidthForSide("right");
    var borderBottomWidth = borderWidthForSide("bottom");
    var borderLeftWidth = borderWidthForSide("left");
    var color$1 = {
        name: "color",
        initialValue: "transparent",
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: "color"
    };
    var display = {
        name: "display",
        initialValue: "inline-block",
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function(tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case "block":
                return 2 /* BLOCK */ ;
            case "inline":
                return 4 /* INLINE */ ;
            case "run-in":
                return 8 /* RUN_IN */ ;
            case "flow":
                return 16 /* FLOW */ ;
            case "flow-root":
                return 32 /* FLOW_ROOT */ ;
            case "table":
                return 64 /* TABLE */ ;
            case "flex":
            case "-webkit-flex":
                return 128 /* FLEX */ ;
            case "grid":
            case "-ms-grid":
                return 256 /* GRID */ ;
            case "ruby":
                return 512 /* RUBY */ ;
            case "subgrid":
                return 1024 /* SUBGRID */ ;
            case "list-item":
                return 2048 /* LIST_ITEM */ ;
            case "table-row-group":
                return 4096 /* TABLE_ROW_GROUP */ ;
            case "table-header-group":
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case "table-footer-group":
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case "table-row":
                return 32768 /* TABLE_ROW */ ;
            case "table-cell":
                return 65536 /* TABLE_CELL */ ;
            case "table-column-group":
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case "table-column":
                return 262144 /* TABLE_COLUMN */ ;
            case "table-caption":
                return 524288 /* TABLE_CAPTION */ ;
            case "ruby-base":
                return 1048576 /* RUBY_BASE */ ;
            case "ruby-text":
                return 2097152 /* RUBY_TEXT */ ;
            case "ruby-base-container":
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case "ruby-text-container":
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case "contents":
                return 16777216 /* CONTENTS */ ;
            case "inline-block":
                return 33554432 /* INLINE_BLOCK */ ;
            case "inline-list-item":
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case "inline-table":
                return 134217728 /* INLINE_TABLE */ ;
            case "inline-flex":
                return 268435456 /* INLINE_FLEX */ ;
            case "inline-grid":
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var FLOAT;
    (function(FLOAT) {
        FLOAT[FLOAT["NONE"] = 0] = "NONE";
        FLOAT[FLOAT["LEFT"] = 1] = "LEFT";
        FLOAT[FLOAT["RIGHT"] = 2] = "RIGHT";
        FLOAT[FLOAT["INLINE_START"] = 3] = "INLINE_START";
        FLOAT[FLOAT["INLINE_END"] = 4] = "INLINE_END";
    })(FLOAT || (FLOAT = {}));
    var float = {
        name: "float",
        initialValue: "none",
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function(float) {
            switch(float){
                case "left":
                    return FLOAT.LEFT;
                case "right":
                    return FLOAT.RIGHT;
                case "inline-start":
                    return FLOAT.INLINE_START;
                case "inline-end":
                    return FLOAT.INLINE_END;
            }
            return FLOAT.NONE;
        }
    };
    var letterSpacing = {
        name: "letter-spacing",
        initialValue: "0",
        prefix: false,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function(token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === "normal") return 0;
            if (token.type === TokenType.NUMBER_TOKEN) return token.number;
            if (token.type === TokenType.DIMENSION_TOKEN) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: "line-break",
        initialValue: "normal",
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function(lineBreak) {
            switch(lineBreak){
                case "strict":
                    return LINE_BREAK.STRICT;
                case "normal":
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: "line-height",
        initialValue: "normal",
        prefix: false,
        type: PropertyDescriptorParsingType.TOKEN_VALUE
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === "normal") return 1.2 * fontSize;
        else if (token.type === TokenType.NUMBER_TOKEN) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: "list-style-image",
        initialValue: "none",
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function(token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === "none") return null;
            return image.parse(token);
        }
    };
    var LIST_STYLE_POSITION;
    (function(LIST_STYLE_POSITION) {
        LIST_STYLE_POSITION[LIST_STYLE_POSITION["INSIDE"] = 0] = "INSIDE";
        LIST_STYLE_POSITION[LIST_STYLE_POSITION["OUTSIDE"] = 1] = "OUTSIDE";
    })(LIST_STYLE_POSITION || (LIST_STYLE_POSITION = {}));
    var listStylePosition = {
        name: "list-style-position",
        initialValue: "outside",
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function(position) {
            switch(position){
                case "inside":
                    return LIST_STYLE_POSITION.INSIDE;
                case "outside":
                default:
                    return LIST_STYLE_POSITION.OUTSIDE;
            }
        }
    };
    var LIST_STYLE_TYPE;
    (function(LIST_STYLE_TYPE) {
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["NONE"] = -1] = "NONE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISC"] = 0] = "DISC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CIRCLE"] = 1] = "CIRCLE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SQUARE"] = 2] = "SQUARE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DECIMAL"] = 3] = "DECIMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_DECIMAL"] = 4] = "CJK_DECIMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DECIMAL_LEADING_ZERO"] = 5] = "DECIMAL_LEADING_ZERO";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ROMAN"] = 6] = "LOWER_ROMAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ROMAN"] = 7] = "UPPER_ROMAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_GREEK"] = 8] = "LOWER_GREEK";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ALPHA"] = 9] = "LOWER_ALPHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ALPHA"] = 10] = "UPPER_ALPHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ARABIC_INDIC"] = 11] = "ARABIC_INDIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ARMENIAN"] = 12] = "ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["BENGALI"] = 13] = "BENGALI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CAMBODIAN"] = 14] = "CAMBODIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_EARTHLY_BRANCH"] = 15] = "CJK_EARTHLY_BRANCH";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_HEAVENLY_STEM"] = 16] = "CJK_HEAVENLY_STEM";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_IDEOGRAPHIC"] = 17] = "CJK_IDEOGRAPHIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DEVANAGARI"] = 18] = "DEVANAGARI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ETHIOPIC_NUMERIC"] = 19] = "ETHIOPIC_NUMERIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GEORGIAN"] = 20] = "GEORGIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GUJARATI"] = 21] = "GUJARATI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GURMUKHI"] = 22] = "GURMUKHI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HEBREW"] = 22] = "HEBREW";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HIRAGANA"] = 23] = "HIRAGANA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HIRAGANA_IROHA"] = 24] = "HIRAGANA_IROHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["JAPANESE_FORMAL"] = 25] = "JAPANESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["JAPANESE_INFORMAL"] = 26] = "JAPANESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KANNADA"] = 27] = "KANNADA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KATAKANA"] = 28] = "KATAKANA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KATAKANA_IROHA"] = 29] = "KATAKANA_IROHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KHMER"] = 30] = "KHMER";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANGUL_FORMAL"] = 31] = "KOREAN_HANGUL_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANJA_FORMAL"] = 32] = "KOREAN_HANJA_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANJA_INFORMAL"] = 33] = "KOREAN_HANJA_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LAO"] = 34] = "LAO";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ARMENIAN"] = 35] = "LOWER_ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MALAYALAM"] = 36] = "MALAYALAM";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MONGOLIAN"] = 37] = "MONGOLIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MYANMAR"] = 38] = "MYANMAR";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ORIYA"] = 39] = "ORIYA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["PERSIAN"] = 40] = "PERSIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SIMP_CHINESE_FORMAL"] = 41] = "SIMP_CHINESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SIMP_CHINESE_INFORMAL"] = 42] = "SIMP_CHINESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TAMIL"] = 43] = "TAMIL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TELUGU"] = 44] = "TELUGU";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["THAI"] = 45] = "THAI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TIBETAN"] = 46] = "TIBETAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TRAD_CHINESE_FORMAL"] = 47] = "TRAD_CHINESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TRAD_CHINESE_INFORMAL"] = 48] = "TRAD_CHINESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ARMENIAN"] = 49] = "UPPER_ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISCLOSURE_OPEN"] = 50] = "DISCLOSURE_OPEN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISCLOSURE_CLOSED"] = 51] = "DISCLOSURE_CLOSED";
    })(LIST_STYLE_TYPE || (LIST_STYLE_TYPE = {}));
    var listStyleType = {
        name: "list-style-type",
        initialValue: "none",
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function(type) {
            switch(type){
                case "disc":
                    return LIST_STYLE_TYPE.DISC;
                case "circle":
                    return LIST_STYLE_TYPE.CIRCLE;
                case "square":
                    return LIST_STYLE_TYPE.SQUARE;
                case "decimal":
                    return LIST_STYLE_TYPE.DECIMAL;
                case "cjk-decimal":
                    return LIST_STYLE_TYPE.CJK_DECIMAL;
                case "decimal-leading-zero":
                    return LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO;
                case "lower-roman":
                    return LIST_STYLE_TYPE.LOWER_ROMAN;
                case "upper-roman":
                    return LIST_STYLE_TYPE.UPPER_ROMAN;
                case "lower-greek":
                    return LIST_STYLE_TYPE.LOWER_GREEK;
                case "lower-alpha":
                    return LIST_STYLE_TYPE.LOWER_ALPHA;
                case "upper-alpha":
                    return LIST_STYLE_TYPE.UPPER_ALPHA;
                case "arabic-indic":
                    return LIST_STYLE_TYPE.ARABIC_INDIC;
                case "armenian":
                    return LIST_STYLE_TYPE.ARMENIAN;
                case "bengali":
                    return LIST_STYLE_TYPE.BENGALI;
                case "cambodian":
                    return LIST_STYLE_TYPE.CAMBODIAN;
                case "cjk-earthly-branch":
                    return LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH;
                case "cjk-heavenly-stem":
                    return LIST_STYLE_TYPE.CJK_HEAVENLY_STEM;
                case "cjk-ideographic":
                    return LIST_STYLE_TYPE.CJK_IDEOGRAPHIC;
                case "devanagari":
                    return LIST_STYLE_TYPE.DEVANAGARI;
                case "ethiopic-numeric":
                    return LIST_STYLE_TYPE.ETHIOPIC_NUMERIC;
                case "georgian":
                    return LIST_STYLE_TYPE.GEORGIAN;
                case "gujarati":
                    return LIST_STYLE_TYPE.GUJARATI;
                case "gurmukhi":
                    return LIST_STYLE_TYPE.GURMUKHI;
                case "hebrew":
                    return LIST_STYLE_TYPE.HEBREW;
                case "hiragana":
                    return LIST_STYLE_TYPE.HIRAGANA;
                case "hiragana-iroha":
                    return LIST_STYLE_TYPE.HIRAGANA_IROHA;
                case "japanese-formal":
                    return LIST_STYLE_TYPE.JAPANESE_FORMAL;
                case "japanese-informal":
                    return LIST_STYLE_TYPE.JAPANESE_INFORMAL;
                case "kannada":
                    return LIST_STYLE_TYPE.KANNADA;
                case "katakana":
                    return LIST_STYLE_TYPE.KATAKANA;
                case "katakana-iroha":
                    return LIST_STYLE_TYPE.KATAKANA_IROHA;
                case "khmer":
                    return LIST_STYLE_TYPE.KHMER;
                case "korean-hangul-formal":
                    return LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL;
                case "korean-hanja-formal":
                    return LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL;
                case "korean-hanja-informal":
                    return LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL;
                case "lao":
                    return LIST_STYLE_TYPE.LAO;
                case "lower-armenian":
                    return LIST_STYLE_TYPE.LOWER_ARMENIAN;
                case "malayalam":
                    return LIST_STYLE_TYPE.MALAYALAM;
                case "mongolian":
                    return LIST_STYLE_TYPE.MONGOLIAN;
                case "myanmar":
                    return LIST_STYLE_TYPE.MYANMAR;
                case "oriya":
                    return LIST_STYLE_TYPE.ORIYA;
                case "persian":
                    return LIST_STYLE_TYPE.PERSIAN;
                case "simp-chinese-formal":
                    return LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL;
                case "simp-chinese-informal":
                    return LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL;
                case "tamil":
                    return LIST_STYLE_TYPE.TAMIL;
                case "telugu":
                    return LIST_STYLE_TYPE.TELUGU;
                case "thai":
                    return LIST_STYLE_TYPE.THAI;
                case "tibetan":
                    return LIST_STYLE_TYPE.TIBETAN;
                case "trad-chinese-formal":
                    return LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL;
                case "trad-chinese-informal":
                    return LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL;
                case "upper-armenian":
                    return LIST_STYLE_TYPE.UPPER_ARMENIAN;
                case "disclosure-open":
                    return LIST_STYLE_TYPE.DISCLOSURE_OPEN;
                case "disclosure-closed":
                    return LIST_STYLE_TYPE.DISCLOSURE_CLOSED;
                case "none":
                default:
                    return LIST_STYLE_TYPE.NONE;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: "0",
            prefix: false,
            type: PropertyDescriptorParsingType.TOKEN_VALUE
        };
    };
    var marginTop = marginForSide("top");
    var marginRight = marginForSide("right");
    var marginBottom = marginForSide("bottom");
    var marginLeft = marginForSide("left");
    var OVERFLOW;
    (function(OVERFLOW) {
        OVERFLOW[OVERFLOW["VISIBLE"] = 0] = "VISIBLE";
        OVERFLOW[OVERFLOW["HIDDEN"] = 1] = "HIDDEN";
        OVERFLOW[OVERFLOW["SCROLL"] = 2] = "SCROLL";
        OVERFLOW[OVERFLOW["AUTO"] = 3] = "AUTO";
    })(OVERFLOW || (OVERFLOW = {}));
    var overflow = {
        name: "overflow",
        initialValue: "visible",
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function(tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case "hidden":
                        return OVERFLOW.HIDDEN;
                    case "scroll":
                        return OVERFLOW.SCROLL;
                    case "auto":
                        return OVERFLOW.AUTO;
                    case "visible":
                    default:
                        return OVERFLOW.VISIBLE;
                }
            });
        }
    };
    var OVERFLOW_WRAP;
    (function(OVERFLOW_WRAP) {
        OVERFLOW_WRAP["NORMAL"] = "normal";
        OVERFLOW_WRAP["BREAK_WORD"] = "break-word";
    })(OVERFLOW_WRAP || (OVERFLOW_WRAP = {}));
    var overflowWrap = {
        name: "overflow-wrap",
        initialValue: "normal",
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function(overflow) {
            switch(overflow){
                case "break-word":
                    return OVERFLOW_WRAP.BREAK_WORD;
                case "normal":
                default:
                    return OVERFLOW_WRAP.NORMAL;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: "0",
            prefix: false,
            type: PropertyDescriptorParsingType.TYPE_VALUE,
            format: "length-percentage"
        };
    };
    var paddingTop = paddingForSide("top");
    var paddingRight = paddingForSide("right");
    var paddingBottom = paddingForSide("bottom");
    var paddingLeft = paddingForSide("left");
    var TEXT_ALIGN;
    (function(TEXT_ALIGN) {
        TEXT_ALIGN[TEXT_ALIGN["LEFT"] = 0] = "LEFT";
        TEXT_ALIGN[TEXT_ALIGN["CENTER"] = 1] = "CENTER";
        TEXT_ALIGN[TEXT_ALIGN["RIGHT"] = 2] = "RIGHT";
    })(TEXT_ALIGN || (TEXT_ALIGN = {}));
    var textAlign = {
        name: "text-align",
        initialValue: "left",
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function(textAlign) {
            switch(textAlign){
                case "right":
                    return TEXT_ALIGN.RIGHT;
                case "center":
                case "justify":
                    return TEXT_ALIGN.CENTER;
                case "left":
                default:
                    return TEXT_ALIGN.LEFT;
            }
        }
    };
    var POSITION;
    (function(POSITION) {
        POSITION[POSITION["STATIC"] = 0] = "STATIC";
        POSITION[POSITION["RELATIVE"] = 1] = "RELATIVE";
        POSITION[POSITION["ABSOLUTE"] = 2] = "ABSOLUTE";
        POSITION[POSITION["FIXED"] = 3] = "FIXED";
        POSITION[POSITION["STICKY"] = 4] = "STICKY";
    })(POSITION || (POSITION = {}));
    var position = {
        name: "position",
        initialValue: "static",
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function(position) {
            switch(position){
                case "relative":
                    return POSITION.RELATIVE;
                case "absolute":
                    return POSITION.ABSOLUTE;
                case "fixed":
                    return POSITION.FIXED;
                case "sticky":
                    return POSITION.STICKY;
            }
            return POSITION.STATIC;
        }
    };
    var textShadow = {
        name: "text-shadow",
        initialValue: "none",
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function(tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color.parse(token);
                }
                return shadow;
            });
        }
    };
    var TEXT_TRANSFORM;
    (function(TEXT_TRANSFORM) {
        TEXT_TRANSFORM[TEXT_TRANSFORM["NONE"] = 0] = "NONE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["LOWERCASE"] = 1] = "LOWERCASE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["UPPERCASE"] = 2] = "UPPERCASE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["CAPITALIZE"] = 3] = "CAPITALIZE";
    })(TEXT_TRANSFORM || (TEXT_TRANSFORM = {}));
    var textTransform = {
        name: "text-transform",
        initialValue: "none",
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function(textTransform) {
            switch(textTransform){
                case "uppercase":
                    return TEXT_TRANSFORM.UPPERCASE;
                case "lowercase":
                    return TEXT_TRANSFORM.LOWERCASE;
                case "capitalize":
                    return TEXT_TRANSFORM.CAPITALIZE;
            }
            return TEXT_TRANSFORM.NONE;
        }
    };
    var transform = {
        name: "transform",
        initialValue: "none",
        prefix: true,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function(token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === "none") return null;
            if (token.type === TokenType.FUNCTION) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === "undefined") throw new Error('Attempting to parse an unsupported transform function "' + token.name + '"');
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === TokenType.NUMBER_TOKEN;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === TokenType.NUMBER_TOKEN;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1], _a = values[2], _b = values[3], a2 = values[4], b2 = values[5], _c = values[6], _d = values[7], _e = values[8], _f = values[9], _g = values[10], _h = values[11], a4 = values[12], b4 = values[13], _j = values[14], _k = values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: "transform-origin",
        initialValue: "50% 50%",
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function(tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var VISIBILITY;
    (function(VISIBILITY) {
        VISIBILITY[VISIBILITY["VISIBLE"] = 0] = "VISIBLE";
        VISIBILITY[VISIBILITY["HIDDEN"] = 1] = "HIDDEN";
        VISIBILITY[VISIBILITY["COLLAPSE"] = 2] = "COLLAPSE";
    })(VISIBILITY || (VISIBILITY = {}));
    var visibility = {
        name: "visible",
        initialValue: "none",
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function(visibility) {
            switch(visibility){
                case "hidden":
                    return VISIBILITY.HIDDEN;
                case "collapse":
                    return VISIBILITY.COLLAPSE;
                case "visible":
                default:
                    return VISIBILITY.VISIBLE;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: "word-break",
        initialValue: "normal",
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function(wordBreak) {
            switch(wordBreak){
                case "break-all":
                    return WORD_BREAK.BREAK_ALL;
                case "keep-all":
                    return WORD_BREAK.KEEP_ALL;
                case "normal":
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: "z-index",
        initialValue: "auto",
        prefix: false,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function(token) {
            if (token.type === TokenType.IDENT_TOKEN) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var duration = {
        name: "duration",
        parse: function(value) {
            if (value.type === TokenType.DIMENSION_TOKEN) switch(value.unit.toLowerCase()){
                case "s":
                    return 1000 * value.number;
                case "ms":
                    return value.number;
            }
            throw new Error("Unsupported duration type");
        }
    };
    var opacity = {
        name: "opacity",
        initialValue: "1",
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function(token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: "transparent",
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: "color"
    };
    var textDecorationLine = {
        name: "text-decoration-line",
        initialValue: "none",
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function(tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case "underline":
                        return 1 /* UNDERLINE */ ;
                    case "overline":
                        return 2 /* OVERLINE */ ;
                    case "line-through":
                        return 3 /* LINE_THROUGH */ ;
                    case "none":
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: "",
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function(tokens) {
            return tokens.filter(isStringToken$1).map(function(token) {
                return token.value;
            });
        }
    };
    var isStringToken$1 = function(token) {
        return token.type === TokenType.STRING_TOKEN || token.type === TokenType.IDENT_TOKEN;
    };
    var fontSize = {
        name: "font-size",
        initialValue: "0",
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: "length"
    };
    var fontWeight = {
        name: "font-weight",
        initialValue: "normal",
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function(token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case "bold":
                    return 700;
                case "normal":
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: "font-variant",
        initialValue: "none",
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function(tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var FONT_STYLE;
    (function(FONT_STYLE) {
        FONT_STYLE["NORMAL"] = "normal";
        FONT_STYLE["ITALIC"] = "italic";
        FONT_STYLE["OBLIQUE"] = "oblique";
    })(FONT_STYLE || (FONT_STYLE = {}));
    var fontStyle = {
        name: "font-style",
        initialValue: "normal",
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function(overflow) {
            switch(overflow){
                case "oblique":
                    return FONT_STYLE.OBLIQUE;
                case "italic":
                    return FONT_STYLE.ITALIC;
                case "normal":
                default:
                    return FONT_STYLE.NORMAL;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: "content",
        initialValue: "none",
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function(tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === "none") return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: "counter-increment",
        initialValue: "none",
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function(tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === "none") return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === TokenType.IDENT_TOKEN) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: "counter-reset",
        initialValue: "none",
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function(tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== "none") {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var quotes = {
        name: "quotes",
        initialValue: "none",
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function(tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === "none") return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return "";
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return "";
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: "box-shadow",
        initialValue: "none",
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function(tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, "inset")) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color.parse(token);
                }
                return shadow;
            });
        }
    };
    var duration$1 = {
        name: "duration",
        initialValue: "0s",
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: "duration"
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(declaration) {
            this.animationDuration = parse(duration$1, declaration.animationDuration);
            this.backgroundClip = parse(backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(boxShadow, declaration.boxShadow);
            this.color = parse(color$1, declaration.color);
            this.display = parse(display, declaration.display);
            this.float = parse(float, declaration.cssFloat);
            this.fontFamily = parse(fontFamily, declaration.fontFamily);
            this.fontSize = parse(fontSize, declaration.fontSize);
            this.fontStyle = parse(fontStyle, declaration.fontStyle);
            this.fontVariant = parse(fontVariant, declaration.fontVariant);
            this.fontWeight = parse(fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(lineBreak, declaration.lineBreak);
            this.lineHeight = parse(lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(listStyleType, declaration.listStyleType);
            this.marginTop = parse(marginTop, declaration.marginTop);
            this.marginRight = parse(marginRight, declaration.marginRight);
            this.marginBottom = parse(marginBottom, declaration.marginBottom);
            this.marginLeft = parse(marginLeft, declaration.marginLeft);
            this.opacity = parse(opacity, declaration.opacity);
            var overflowTuple = parse(overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(paddingTop, declaration.paddingTop);
            this.paddingRight = parse(paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(paddingLeft, declaration.paddingLeft);
            this.position = parse(position, declaration.position);
            this.textAlign = parse(textAlign, declaration.textAlign);
            this.textDecorationColor = parse(textDecorationColor, declaration.textDecorationColor || declaration.color);
            this.textDecorationLine = parse(textDecorationLine, declaration.textDecorationLine);
            this.textShadow = parse(textShadow, declaration.textShadow);
            this.textTransform = parse(textTransform, declaration.textTransform);
            this.transform = parse(transform, declaration.transform);
            this.transformOrigin = parse(transformOrigin, declaration.transformOrigin);
            this.transitionDuration = parse(duration$1, declaration.transitionDuration);
            this.visibility = parse(visibility, declaration.visibility);
            this.wordBreak = parse(wordBreak, declaration.wordBreak);
            this.zIndex = parse(zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === VISIBILITY.VISIBLE;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== POSITION.STATIC;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== FLOAT.NONE;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(declaration) {
            this.content = parse(content, declaration.content);
            this.quotes = parse(quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(declaration) {
            this.counterIncrement = parse(counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== "undefined" ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case PropertyDescriptorParsingType.IDENT_VALUE:
                var token = parser.parseComponentValue();
                return descriptor.parse(isIdentToken(token) ? token.value : descriptor.initialValue);
            case PropertyDescriptorParsingType.VALUE:
                return descriptor.parse(parser.parseComponentValue());
            case PropertyDescriptorParsingType.LIST:
                return descriptor.parse(parser.parseComponentValues());
            case PropertyDescriptorParsingType.TOKEN_VALUE:
                return parser.parseComponentValue();
            case PropertyDescriptorParsingType.TYPE_VALUE:
                switch(descriptor.format){
                    case "angle":
                        return angle.parse(parser.parseComponentValue());
                    case "color":
                        return color.parse(parser.parseComponentValue());
                    case "image":
                        return image.parse(parser.parseComponentValue());
                    case "length":
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case "length-percentage":
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case "duration":
                        return duration.parse(parser.parseComponentValue());
                }
        }
        throw new Error("Attempting to parse unsupported css format type " + descriptor.format);
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(element) {
            this.styles = new CSSParsedDeclaration(window.getComputedStyle(element, null));
            this.textNodes = [];
            this.elements = [];
            if (this.styles.transform !== null && isHTMLElementNode(element)) // getBoundingClientRect takes transforms into account
            element.style.transform = "none";
            var ad = this.styles.animationDuration;
            var td = this.styles.transitionDuration;
            var style = element.style;
            if (style && (ad || td)) {
                style.animationDuration = "0ms";
                style.transitionDuration = "0ms";
            }
            this.bounds = parseBounds(element);
            this.flags = 0;
        }
        return ElementContainer;
    }();
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) textBounds.push(new TextBounds(text, getRangeBounds(node, offset, text.length)));
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement("html2canvaswrapper");
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return new Bounds(0, 0, 0, 0);
    };
    var getRangeBounds = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error("Node has no owner document");
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return Bounds.fromClientRect(range.getBoundingClientRect());
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? toCodePoints(value).map(function(i) {
            return fromCodePoint(i);
        }) : breakWords(value, styles);
    };
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === OVERFLOW_WRAP.BREAK_WORD ? "break-word" : styles.wordBreak
        });
        var words = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) words.push(bk.value.slice());
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(node, styles) {
            this.text = transform$1(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform$1 = function(text, transform) {
        switch(transform){
            case TEXT_TRANSFORM.LOWERCASE:
                return text.toLowerCase();
            case TEXT_TRANSFORM.CAPITALIZE:
                return text.replace(CAPITALIZE, capitalize);
            case TEXT_TRANSFORM.UPPERCASE:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(img) {
            var _this = _super.call(this, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            CacheStorage.getInstance().addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(canvas) {
            var _this = _super.call(this, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(img) {
            var _this = _super.call(this, img) || this;
            var textElem = img.getElementsByTagName("text");
            for(var i = 0; i < textElem.length; i++){
                var e = textElem[i];
                if (window.getComputedStyle(img, null).getPropertyValue("font-family")) {
                    e.setAttribute("font-family", window.getComputedStyle(img, null).getPropertyValue("font-family"));
                    e.replaceWith(e);
                }
            }
            var s = new XMLSerializer();
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            CacheStorage.getInstance().addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === "boolean" && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: TokenType.DIMENSION_TOKEN,
            flags: 0,
            unit: "px",
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: TokenType.PERCENTAGE_TOKEN,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join("\u2022") : node.value;
        return value.length === 0 ? node.placeholder || "" : value;
    };
    var CHECKBOX = "checkbox";
    var RADIO = "radio";
    var PASSWORD = "password";
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(input) {
            var _this = _super.call(this, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = BORDER_STYLE.SOLID;
                _this.styles.backgroundClip = [
                    BACKGROUND_CLIP.BORDER_BOX
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(element) {
            var _this = _super.call(this, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || "" : "";
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var parseColor = function(value) {
        return color.parse(Parser.create(value).parseComponentValue());
    };
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(iframe) {
            var _this = _super.call(this, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        "OL",
        "UL",
        "MENU"
    ];
    var parseNodeTree = function(node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(childNode, parent.styles));
            else if (isElementNode(childNode)) {
                var container = createContainer(childNode);
                if (container.styles.isVisible()) {
                    if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                    else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                    if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                    parent.elements.push(container);
                    if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(childNode, container, root);
                }
            }
        }
    };
    var createContainer = function(element) {
        if (isImageElement(element)) return new ImageElementContainer(element);
        if (isCanvasElement(element)) return new CanvasElementContainer(element);
        if (isSVGElement(element)) return new SVGElementContainer(element);
        if (isLIElement(element)) return new LIElementContainer(element);
        if (isOLElement(element)) return new OLElementContainer(element);
        if (isInputElement(element)) return new InputElementContainer(element);
        if (isSelectElement(element)) return new SelectElementContainer(element);
        if (isTextareaElement(element)) return new TextareaElementContainer(element);
        if (isIFrameElement(element)) return new IFrameElementContainer(element);
        return new ElementContainer(element);
    };
    var parseTree = function(element) {
        var container = createContainer(element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return typeof node.style !== "undefined";
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === "object";
    };
    var isLIElement = function(node) {
        return node.tagName === "LI";
    };
    var isOLElement = function(node) {
        return node.tagName === "OL";
    };
    var isInputElement = function(node) {
        return node.tagName === "INPUT";
    };
    var isHTMLElement = function(node) {
        return node.tagName === "HTML";
    };
    var isSVGElement = function(node) {
        return node.tagName === "svg";
    };
    var isBodyElement = function(node) {
        return node.tagName === "BODY";
    };
    var isCanvasElement = function(node) {
        return node.tagName === "CANVAS";
    };
    var isImageElement = function(node) {
        return node.tagName === "IMG";
    };
    var isIFrameElement = function(node) {
        return node.tagName === "IFRAME";
    };
    var isStyleElement = function(node) {
        return node.tagName === "STYLE";
    };
    var isScriptElement = function(node) {
        return node.tagName === "SCRIPT";
    };
    var isTextareaElement = function(node) {
        return node.tagName === "TEXTAREA";
    };
    var isSelectElement = function(node) {
        return node.tagName === "SELECT";
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            "M",
            "CM",
            "D",
            "CD",
            "C",
            "XC",
            "L",
            "XL",
            "X",
            "IX",
            "V",
            "IV",
            "I"
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, "") + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = "";
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? "-" : "") + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = ". ";
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, LIST_STYLE_TYPE.CJK_DECIMAL, suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== "") string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : "") + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : "") + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? ". " : "";
        var cjkSuffix = appendSuffix ? "\u3001" : "";
        var koreanSuffix = appendSuffix ? ", " : "";
        var spaceSuffix = appendSuffix ? " " : "";
        switch(type){
            case LIST_STYLE_TYPE.DISC:
                return "\u2022" + spaceSuffix;
            case LIST_STYLE_TYPE.CIRCLE:
                return "\u25E6" + spaceSuffix;
            case LIST_STYLE_TYPE.SQUARE:
                return "\u25FE" + spaceSuffix;
            case LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case LIST_STYLE_TYPE.CJK_DECIMAL:
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case LIST_STYLE_TYPE.LOWER_ROMAN:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
            case LIST_STYLE_TYPE.UPPER_ROMAN:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_GREEK:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_ALPHA:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case LIST_STYLE_TYPE.UPPER_ALPHA:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case LIST_STYLE_TYPE.ARABIC_INDIC:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case LIST_STYLE_TYPE.ARMENIAN:
            case LIST_STYLE_TYPE.UPPER_ARMENIAN:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_ARMENIAN:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
            case LIST_STYLE_TYPE.BENGALI:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case LIST_STYLE_TYPE.CAMBODIAN:
            case LIST_STYLE_TYPE.KHMER:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH:
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case LIST_STYLE_TYPE.CJK_HEAVENLY_STEM:
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case LIST_STYLE_TYPE.CJK_IDEOGRAPHIC:
            case LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL:
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL:
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL:
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL:
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.JAPANESE_INFORMAL:
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case LIST_STYLE_TYPE.JAPANESE_FORMAL:
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL:
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL:
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL:
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.DEVANAGARI:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case LIST_STYLE_TYPE.GEORGIAN:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.GUJARATI:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case LIST_STYLE_TYPE.GURMUKHI:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.HEBREW:
                return createAdditiveCounter(value, 1, 10999, HEBREW, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.HIRAGANA:
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case LIST_STYLE_TYPE.HIRAGANA_IROHA:
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case LIST_STYLE_TYPE.KANNADA:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case LIST_STYLE_TYPE.KATAKANA:
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case LIST_STYLE_TYPE.KATAKANA_IROHA:
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case LIST_STYLE_TYPE.LAO:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case LIST_STYLE_TYPE.MONGOLIAN:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case LIST_STYLE_TYPE.MYANMAR:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case LIST_STYLE_TYPE.ORIYA:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.PERSIAN:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case LIST_STYLE_TYPE.TAMIL:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case LIST_STYLE_TYPE.TELUGU:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.THAI:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case LIST_STYLE_TYPE.TIBETAN:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case LIST_STYLE_TYPE.DECIMAL:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = "data-html2canvas-ignore";
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(element, options) {
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error("Cloned element does not have an owner document");
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        documentClone.documentElement.style.top = -windowSize.top + "px";
                                        documentClone.documentElement.style.left = -windowSize.left + "px";
                                        documentClone.documentElement.style.position = "absolute";
                                    }
                                }
                                onclone = this.options.onclone;
                                if (typeof this.clonedReferenceElement === "undefined") return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (typeof onclone === "function") return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            /*
            if (isIFrameElement(node)) {
                return this.createIFrameClone(node);
            }
    */ if (isStyleElement(node)) return this.createStyleClone(node);
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === "string") return css + rule.cssText;
                        return css;
                    }, "");
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                Logger.getInstance(this.options.id).error("Unable to access cssRules property", e);
                if (e.name !== "SecurityError") throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement("img");
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    Logger.getInstance(this.options.id).info("Unable to clone canvas contents, canvas is tainted");
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext("2d");
                var clonedCtx = clonedCanvas.getContext("2d");
                if (clonedCtx) {
                    if (ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else clonedCtx.drawImage(canvas, 0, 0);
                }
                return clonedCanvas;
            } catch (e) {}
            return clonedCanvas;
        };
        /*
        createIFrameClone(iframe: HTMLIFrameElement) {
            const tempIframe = <HTMLIFrameElement>iframe.cloneNode(false);
            const iframeKey = generateIframeKey();
            tempIframe.setAttribute('data-html2canvas-internal-iframe-key', iframeKey);

            const {width, height} = parseBounds(iframe);

            this.resourceLoader.cache[iframeKey] = getIframeDocumentElement(iframe, this.options)
                .then(documentElement => {
                    return this.renderer(
                        documentElement,
                        {
                            allowTaint: this.options.allowTaint,
                            backgroundColor: '#ffffff',
                            canvas: null,
                            imageTimeout: this.options.imageTimeout,
                            logging: this.options.logging,
                            proxy: this.options.proxy,
                            removeContainer: this.options.removeContainer,
                            scale: this.options.scale,
                            foreignObjectRendering: this.options.foreignObjectRendering,
                            useCORS: this.options.useCORS,
                            target: new CanvasRenderer(),
                            width,
                            height,
                            x: 0,
                            y: 0,
                            windowWidth: documentElement.ownerDocument.defaultView.innerWidth,
                            windowHeight: documentElement.ownerDocument.defaultView.innerHeight,
                            scrollX: documentElement.ownerDocument.defaultView.pageXOffset,
                            scrollY: documentElement.ownerDocument.defaultView.pageYOffset
                        },
                    );
                })
                .then(
                    (canvas: HTMLCanvasElement) =>
                        new Promise((resolve, reject) => {
                            const iframeCanvas = document.createElement('img');
                            iframeCanvas.onload = () => resolve(canvas);
                            iframeCanvas.onerror = (event) => {
                                // Empty iframes may result in empty "data:," URLs, which are invalid from the <img>'s point of view
                                // and instead of `onload` cause `onerror` and unhandled rejection warnings
                                // https://github.com/niklasvh/html2canvas/issues/1502
                                iframeCanvas.src == 'data:,' ? resolve(canvas) : reject(event);
                            };
                            iframeCanvas.src = canvas.toDataURL();
                            if (tempIframe.parentNode && iframe.ownerDocument && iframe.ownerDocument.defaultView) {
                                tempIframe.parentNode.replaceChild(
                                    copyCSSStyles(
                                        iframe.ownerDocument.defaultView.getComputedStyle(iframe),
                                        iframeCanvas
                                    ),
                                    tempIframe
                                );
                            }
                        })
                );
            return tempIframe;
        }
    */ DocumentCloner.prototype.cloneNode = function(node) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (isHTMLElementNode(node) && window1) {
                var clone = this.createElementClone(node);
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ":before");
                var styleAfter = window1.getComputedStyle(node, ":after");
                if (this.referenceElement === node) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                for(var child = node.firstChild; child; child = child.nextSibling){
                    if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== "function" || !this.options.ignoreElements(child))) {
                        if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child));
                    }
                }
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && this.options.copyStyles && !isIFrameElement(node)) copyCSSStyles(style, clone);
                //this.inlineAllImages(clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === "none" || value === "-moz-alt-content" || style.display === "none") return;
            this.counters.parse(new CSSParsedCounterDeclaration(style));
            var declaration = new CSSParsedPseudoDeclaration(style);
            var anonymousReplacedElement = document1.createElement("html2canvaspseudoelement");
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === TokenType.STRING_TOKEN) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === TokenType.URL_TOKEN) {
                    var img = document1.createElement("img");
                    img.src = token.value;
                    img.style.opacity = "1";
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === TokenType.FUNCTION) {
                    if (token.name === "attr") {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ""));
                    } else if (token.name === "counter") {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(counterStyle.value) : LIST_STYLE_TYPE.DECIMAL;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === "counters") {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(counterStyle.value) : LIST_STYLE_TYPE.DECIMAL;
                            var separator = delim && delim.type === TokenType.STRING_TOKEN ? delim.value : "";
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === TokenType.IDENT_TOKEN) switch(token.value){
                    case "open-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case "close-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement("iframe");
        cloneIframeContainer.className = "html2canvas-container";
        cloneIframeContainer.style.visibility = "hidden";
        cloneIframeContainer.style.position = "fixed";
        cloneIframeContainer.style.left = "-10000px";
        cloneIframeContainer.style.top = "0px";
        cloneIframeContainer.style.border = "0";
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = "no"; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, "true");
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = documentClone.onreadystatechange = function() {
                cloneWindow.onload = iframe.onload = documentClone.onreadystatechange = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === "complete") {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            // Safari shows pseudoelements if content is set
            if (property !== "content") target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = "";
        if (doctype) {
            str += "<!DOCTYPE ";
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += '"' + doctype.publicId + '"';
            if (doctype.systemId) str += '"' + doctype.systemId + '"';
            str += ">";
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ":before";
    var PSEUDO_AFTER = ":after";
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";
    var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement("style");
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var PathType;
    (function(PathType) {
        PathType[PathType["VECTOR"] = 0] = "VECTOR";
        PathType[PathType["BEZIER_CURVE"] = 1] = "BEZIER_CURVE";
    })(PathType || (PathType = {}));
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = PathType.VECTOR;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = PathType.BEZIER_CURVE;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === PathType.BEZIER_CURVE;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderLeftWidth ? 0 : trh - borderLeftWidth, trv - borderTopWidth, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth), Math.max(0, brh - borderRightWidth), brv - borderBottomWidth, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + leftHeight, Math.max(0, blh - borderLeftWidth), blv - borderBottomWidth, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.type = 0 /* TRANSFORM */ ;
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.type = 1 /* CLIP */ ;
            this.target = target;
            this.path = path;
        }
        return ClipEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(element, parentStack) {
            this.container = element;
            this.effects = parentStack.slice(0);
            this.curves = new BoundCurves(element);
            if (element.styles.transform !== null) {
                var offsetX = element.bounds.left + element.styles.transformOrigin[0].number;
                var offsetY = element.bounds.top + element.styles.transformOrigin[1].number;
                var matrix = element.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (element.styles.overflowX !== OVERFLOW.VISIBLE) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getParentEffects = function() {
            var effects = this.effects.slice(0);
            if (this.container.styles.overflowX !== OVERFLOW.VISIBLE) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (!equalPath(borderBox, paddingBox)) effects.push(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
            }
            return effects;
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent.getParentEffects());
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === "number" && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, []);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === BACKGROUND_CLIP.BORDER_BOX) return element.bounds;
        if (backgroundClip === BACKGROUND_CLIP.CONTENT_BOX) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === "number";
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === "undefined") return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case BACKGROUND_REPEAT.REPEAT_X:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case BACKGROUND_REPEAT.REPEAT_Y:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case BACKGROUND_REPEAT.NO_REPEAT:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    var SAMPLE_TEXT = "Hidden Text";
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement("div");
            var img = this._document.createElement("img");
            var span = this._document.createElement("span");
            var body = this._document.body;
            container.style.visibility = "hidden";
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = "0";
            container.style.padding = "0";
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = "0";
            img.style.padding = "0";
            img.style.verticalAlign = "baseline";
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = "0";
            span.style.padding = "0";
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = "normal";
            img.style.verticalAlign = "super";
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === "undefined") this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    function layout(chars, width, measure) {
        var pos = [];
        var line = 0;
        var lineString = "";
        var lineLen = 0;
        for(var i = 0; i < chars.length; i++)if (chars[i] === "\n") {
            pos.push([
                -1,
                line
            ]);
            line++;
            setLine(0, 0);
        } else {
            addChar(i);
            var lineWidth = measure(lineString, lineLen);
            pos.push([
                lineWidth - measure(chars[i], 1),
                line
            ]);
            if (lineWidth > width) {
                if (chars[i] === " ") {
                    var p = i;
                    while(p > 0 && pos[p][1] === line && chars[p] === " ")p--;
                    for(var j = i; j > p; j--)pos[j][0] = -1;
                    line++;
                    setLine(0, 0);
                    while(i < chars.length + 1 && chars[i + 1] === " "){
                        pos.push([
                            -1,
                            line
                        ]);
                        i++;
                    }
                } else if (chars[i] === "-") {
                    line++;
                    setLine(i, i + 1);
                    pos[i] = [
                        0,
                        line
                    ];
                } else {
                    var p = i;
                    while(p > 0 && pos[p][1] === line && chars[p] !== " " && chars[p] !== "-")p--;
                    line++;
                    if (chars[p] === " " || chars[p] === "-") {
                        setLine(p + 1, i + 1);
                        for(var j = i; j > p; j--)pos[j] = [
                            pos[j][0] - pos[p + 1][0],
                            line
                        ];
                        if (chars[p] === " ") pos[p][0] = -1;
                    } else {
                        setLine(i, i + 1);
                        pos[i] = [
                            0,
                            line
                        ];
                    }
                }
            }
        }
        return pos;
        function addChar(pos) {
            lineString += chars[pos];
            lineLen++;
        }
        function setLine(from, to) {
            lineString = "";
            for(var i = from; i < to; i++)lineString += chars[i];
            lineLen = to - from;
        }
    }
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function() {
        function CanvasRenderer(options) {
            this._activeEffects = [];
            this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            this.ctx = this.canvas.getContext("2d");
            this.options = options;
            if (!options.canvas) {
                this.canvas.width = Math.floor(options.width * options.scale);
                this.canvas.height = Math.floor(options.height * options.scale);
                this.canvas.style.width = options.width + "px";
                this.canvas.style.height = options.height + "px";
            }
            this.fontMetrics = new FontMetrics(document);
            this.ctx.scale(this.options.scale, this.options.scale);
            this.ctx.translate(-options.x + options.scrollX, -options.y + options.scrollY);
            this.ctx.textBaseline = "bottom";
            this._activeEffects = [];
            Logger.getInstance(options.id).debug("Canvas renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
        }
        CanvasRenderer.prototype.applyEffects = function(effects, target) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.filter(function(effect) {
                return contains(effect.target, target);
            }).forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.globalAlpha = styles.opacity;
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, lineHeight) {
            var _this = this;
            if (lineHeight === undefined) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
            else {
                var chars = toCodePoints(text.text).map(function(i) {
                    return fromCodePoint(i);
                });
                var pos = layout(chars, text.bounds.width, function(s, len) {
                    return _this.ctx.measureText(s).width + letterSpacing * (len - 1);
                });
                var dx = text.bounds.left;
                var dy = text.bounds.top + lineHeight / 2;
                for(var i = 0; i < pos.length; i++)if (pos[i][0] >= 0) this.ctx.fillText(chars[i], pos[i][0] + dx, pos[i][1] * lineHeight + dy);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === "normal" || variant === "small-caps";
            }).join("");
            var fontFamily = styles.fontFamily.join(", ");
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(" "),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize;
                var _this = this;
                return __generator(this, function(_b) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    text.textBounds.forEach(function(text) {
                        _this.ctx.fillStyle = asString(styles.color);
                        _this.renderTextWithLetterSpacing(text, styles.letterSpacing);
                        var textShadows = styles.textShadow;
                        if (textShadows.length && text.text.trim().length) {
                            textShadows.slice(0).reverse().forEach(function(textShadow) {
                                _this.ctx.shadowColor = asString(textShadow.color);
                                _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                _this.ctx.shadowBlur = textShadow.blur.number;
                                _this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
                            });
                            _this.ctx.shadowColor = "";
                            _this.ctx.shadowOffsetX = 0;
                            _this.ctx.shadowOffsetY = 0;
                            _this.ctx.shadowBlur = 0;
                        }
                        if (styles.textDecorationLine.length) {
                            _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                            styles.textDecorationLine.forEach(function(textDecorationLine) {
                                switch(textDecorationLine){
                                    case 1 /* UNDERLINE */ :
                                        // Draws a line at the baseline of the font
                                        // TODO As some browsers display the line as more than 1px if the font-size is big,
                                        // need to take that into account both in position and size
                                        var baseline = _this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                        _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                        break;
                                    case 2 /* OVERLINE */ :
                                        _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                        break;
                                    case 3 /* LINE_THROUGH */ :
                                        // TODO try and find exact position for line-through
                                        var middle = _this.fontMetrics.getMetrics(fontFamily, fontSize).middle;
                                        _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                        break;
                                }
                            });
                        }
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, e_1, image, e_2, iframeRenderer, canvas, size, bounds, x, textBounds, lineHeight, img, image, url, e_3, bounds;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.applyEffects(paint.effects, 4 /* CONTENT */ );
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _b.label = 5;
                        case 5:
                            _b.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.options.cache.match(container.src)
                            ];
                        case 6:
                            image = _b.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            e_1 = _b.sent();
                            Logger.getInstance(this.options.id).error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _b.label = 9;
                        case 9:
                            _b.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.options.cache.match(container.svg)
                            ];
                        case 10:
                            image = _b.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            e_2 = _b.sent();
                            Logger.getInstance(this.options.id).error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer({
                                id: this.options.id,
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                scrollX: 0,
                                scrollY: 0,
                                width: container.width,
                                height: container.height,
                                cache: this.options.cache,
                                windowWidth: container.width,
                                windowHeight: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _b.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _b.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                this.ctx.font = this.createFontStyle(styles)[0];
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "middle";
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case TEXT_ALIGN.CENTER:
                                        x += bounds.width / 2;
                                        break;
                                    case TEXT_ALIGN.RIGHT:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                lineHeight = container instanceof TextareaElementContainer ? computeLineHeight(styles.lineHeight, styles.fontSize.number) : undefined;
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, lineHeight);
                                this.ctx.restore();
                                this.ctx.textBaseline = "bottom";
                                this.ctx.textAlign = "left";
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === CSSImageType.URL)) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _b.label = 15;
                        case 15:
                            _b.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.options.cache.match(url)
                            ];
                        case 16:
                            image = _b.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            e_3 = _b.sent();
                            Logger.getInstance(this.options.id).error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== LIST_STYLE_TYPE.NONE) {
                                this.ctx.font = this.createFontStyle(styles)[0];
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "middle";
                                this.ctx.textAlign = "right";
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing);
                                this.ctx.textBaseline = "bottom";
                                this.ctx.textAlign = "left";
                            }
                            _b.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            if (image.width === width && image.height === height) return image;
            var canvas = this.canvas.ownerDocument.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, e_4, _a, path, x, y, width, height, pattern, _b, path, x, y, width, height, _c, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _d, path, left, top_1, width, height, position, x, y, _e, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_f) {
                                    switch(_f.label){
                                        case 0:
                                            if (!(backgroundImage.type === CSSImageType.URL)) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _f.label = 1;
                                        case 1:
                                            _f.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.options.cache.match(url)
                                            ];
                                        case 2:
                                            image = _f.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            e_4 = _f.sent();
                                            Logger.getInstance(this_1.options.id).error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _a = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _a[0], x = _a[1], y = _a[2], width = _a[3], height = _a[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), "repeat");
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _b = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _b[0], x = _b[1], y = _b[2], width = _b[3], height = _b[4];
                                                _c = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _c[0], x0 = _c[1], x1 = _c[2], y0 = _c[3], y1 = _c[4];
                                                canvas = document.createElement("canvas");
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext("2d");
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, "repeat");
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], left = _d[1], top_1 = _d[2], width = _d[3], height = _d[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _e = calculateRadius(backgroundImage, x, y, width, height), rx = _e[0], ry = _e[1];
                                                if (rx > 0 && rx > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _f.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.effects, 2 /* BACKGROUND_BORDERS */ );
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : "rgba(0,0,0,1)";
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                7
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== BORDER_STYLE.NONE && !isTransparent(border.color))) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderBorder(border.color, side, paint.curves)
                            ];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5:
                            side++;
                            _a.label = 6;
                        case 6:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 7:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x - this.options.scrollX, this.options.y - this.options.scrollY, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([], 2 /* BACKGROUND_BORDERS */ );
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }();
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case BACKGROUND_CLIP.BORDER_BOX:
                return calculateBorderBoxPath(curves);
            case BACKGROUND_CLIP.CONTENT_BOX:
                return calculateContentBoxPath(curves);
            case BACKGROUND_CLIP.PADDING_BOX:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case TEXT_ALIGN.CENTER:
                return "center";
            case TEXT_ALIGN.RIGHT:
                return "right";
            case TEXT_ALIGN.LEFT:
            default:
                return "left";
        }
    };
    var ForeignObjectRenderer = /** @class */ function() {
        function ForeignObjectRenderer(options) {
            this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            this.ctx = this.canvas.getContext("2d");
            this.options = options;
            this.canvas.width = Math.floor(options.width * options.scale);
            this.canvas.height = Math.floor(options.height * options.scale);
            this.canvas.style.width = options.width + "px";
            this.canvas.style.height = options.height + "px";
            this.ctx.scale(this.options.scale, this.options.scale);
            this.ctx.translate(-options.x + options.scrollX, -options.y + options.scrollY);
            Logger.getInstance(options.id).debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(Math.max(this.options.windowWidth, this.options.width) * this.options.scale, Math.max(this.options.windowHeight, this.options.height) * this.options.scale, this.options.scrollX * this.options.scale, this.options.scrollY * this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG$1(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }();
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var _this = undefined;
    var parseColor$1 = function(value) {
        return color.parse(Parser.create(value).parseComponentValue());
    };
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== "undefined") CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(_this, void 0, void 0, function() {
            var ownerDocument, defaultView, instanceName, _a, width, height, left, top, defaultResourceOptions, resourceOptions, defaultOptions, options, windowBounds, documentCloner, clonedElement, container, documentBackgroundColor, bodyBackgroundColor, bgColor, defaultBackgroundColor, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        instanceName = (Math.round(Math.random() * 1000) + Date.now()).toString(16);
                        _a = isBodyElement(element) || isHTMLElement(element) ? parseDocumentSize(ownerDocument) : parseBounds(element), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        defaultResourceOptions = {
                            allowTaint: false,
                            imageTimeout: 15000,
                            proxy: undefined,
                            useCORS: false
                        };
                        resourceOptions = __assign({}, defaultResourceOptions, opts);
                        defaultOptions = {
                            backgroundColor: "#ffffff",
                            cache: opts.cache ? opts.cache : CacheStorage.create(instanceName, resourceOptions),
                            logging: true,
                            removeContainer: true,
                            foreignObjectRendering: false,
                            scale: defaultView.devicePixelRatio || 1,
                            windowWidth: defaultView.innerWidth,
                            windowHeight: defaultView.innerHeight,
                            scrollX: defaultView.pageXOffset,
                            scrollY: defaultView.pageYOffset,
                            x: left,
                            y: top,
                            width: Math.ceil(width),
                            height: Math.ceil(height),
                            id: instanceName
                        };
                        options = __assign({}, defaultOptions, resourceOptions, opts);
                        windowBounds = new Bounds(options.scrollX, options.scrollY, options.windowWidth, options.windowHeight);
                        Logger.create({
                            id: instanceName,
                            enabled: options.logging
                        });
                        Logger.getInstance(instanceName).debug("Starting document clone");
                        documentCloner = new DocumentCloner(element, {
                            id: instanceName,
                            onclone: options.onclone,
                            ignoreElements: options.ignoreElements,
                            inlineImages: options.foreignObjectRendering,
                            copyStyles: options.foreignObjectRendering
                        });
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _b.sent();
                        documentBackgroundColor = ownerDocument.documentElement ? parseColor$1(getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                        bodyBackgroundColor = ownerDocument.body ? parseColor$1(getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
                        bgColor = opts.backgroundColor;
                        defaultBackgroundColor = typeof bgColor === "string" ? parseColor$1(bgColor) : bgColor === null ? COLORS.TRANSPARENT : 0xffffffff;
                        backgroundColor = element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
                        renderOptions = {
                            id: instanceName,
                            cache: options.cache,
                            canvas: options.canvas,
                            backgroundColor: backgroundColor,
                            scale: options.scale,
                            x: options.x,
                            y: options.y,
                            scrollX: options.scrollX,
                            scrollY: options.scrollY,
                            width: options.width,
                            height: options.height,
                            windowWidth: options.windowWidth,
                            windowHeight: options.windowHeight
                        };
                        if (!options.foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        Logger.getInstance(instanceName).debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _b.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        Logger.getInstance(instanceName).debug("Document cloned, using computed rendering");
                        CacheStorage.attachInstance(options.cache);
                        Logger.getInstance(instanceName).debug("Starting DOM parsing");
                        root = parseTree(clonedElement);
                        CacheStorage.detachInstance();
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        Logger.getInstance(instanceName).debug("Starting renderer");
                        renderer = new CanvasRenderer(renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _b.sent();
                        _b.label = 5;
                    case 5:
                        if (options.removeContainer === true) {
                            if (!DocumentCloner.destroy(container)) Logger.getInstance(instanceName).error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        Logger.getInstance(instanceName).debug("Finished rendering");
                        Logger.destroy(instanceName);
                        CacheStorage.destroy(instanceName);
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    return html2canvas;
});

});

parcelRegister("cY1Od", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $970c7ddf83730f06$export$2e2bcd8739ae039; });
/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 2.1.0 Built on 2020-08-25T16:02:38.141Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2020 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2020 yWorks GmbH, http://www.yworks.com
 *               2015-2020 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, willow-systems.com
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */ var $970c7ddf83730f06$var$t = function() {
    return "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : this;
}();
function $970c7ddf83730f06$var$e() {
    $970c7ddf83730f06$var$t.console && "function" == typeof $970c7ddf83730f06$var$t.console.log && $970c7ddf83730f06$var$t.console.log.apply($970c7ddf83730f06$var$t.console, arguments);
}
var $970c7ddf83730f06$var$n = {
    log: $970c7ddf83730f06$var$e,
    warn: function(n) {
        $970c7ddf83730f06$var$t.console && ("function" == typeof $970c7ddf83730f06$var$t.console.warn ? $970c7ddf83730f06$var$t.console.warn.apply($970c7ddf83730f06$var$t.console, arguments) : $970c7ddf83730f06$var$e.call(null, arguments));
    },
    error: function(n) {
        $970c7ddf83730f06$var$t.console && ("function" == typeof $970c7ddf83730f06$var$t.console.error ? $970c7ddf83730f06$var$t.console.error.apply($970c7ddf83730f06$var$t.console, arguments) : $970c7ddf83730f06$var$e(n));
    }
};
/**
 * @license
 * FileSaver.js
 * A saveAs() FileSaver implementation.
 *
 * By Eli Grey, http://eligrey.com
 *
 * License : https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md (MIT)
 * source  : http://purl.eligrey.com/github/FileSaver.js
 */ function $970c7ddf83730f06$var$r(t, e, r) {
    var i = new XMLHttpRequest;
    i.open("GET", t), i.responseType = "blob", i.onload = function() {
        $970c7ddf83730f06$var$u(i.response, e, r);
    }, i.onerror = function() {
        $970c7ddf83730f06$var$n.error("could not download file");
    }, i.send();
}
function $970c7ddf83730f06$var$i(t) {
    var e = new XMLHttpRequest;
    e.open("HEAD", t, !1);
    try {
        e.send();
    } catch (t) {}
    return e.status >= 200 && e.status <= 299;
}
function $970c7ddf83730f06$var$a(t) {
    try {
        t.dispatchEvent(new MouseEvent("click"));
    } catch (n) {
        var e = document.createEvent("MouseEvents");
        e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(e);
    }
}
var $970c7ddf83730f06$var$o, $970c7ddf83730f06$var$s, $970c7ddf83730f06$var$u = $970c7ddf83730f06$var$t.saveAs || ("object" != typeof window || window !== $970c7ddf83730f06$var$t ? function() {} : "download" in HTMLAnchorElement.prototype ? function(e, n, o) {
    var s = $970c7ddf83730f06$var$t.URL || $970c7ddf83730f06$var$t.webkitURL, u = document.createElement("a");
    n = n || e.name || "download", u.download = n, u.rel = "noopener", "string" == typeof e ? (u.href = e, u.origin !== location.origin ? $970c7ddf83730f06$var$i(u.href) ? $970c7ddf83730f06$var$r(e, n, o) : $970c7ddf83730f06$var$a(u, u.target = "_blank") : $970c7ddf83730f06$var$a(u)) : (u.href = s.createObjectURL(e), setTimeout(function() {
        s.revokeObjectURL(u.href);
    }, 4e4), setTimeout(function() {
        $970c7ddf83730f06$var$a(u);
    }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(t, e, o) {
    if (e = e || t.name || "download", "string" == typeof t) {
        if ($970c7ddf83730f06$var$i(t)) $970c7ddf83730f06$var$r(t, e, o);
        else {
            var s = document.createElement("a");
            s.href = t, s.target = "_blank", setTimeout(function() {
                $970c7ddf83730f06$var$a(s);
            });
        }
    } else navigator.msSaveOrOpenBlob(function(t, e) {
        return void 0 === e ? e = {
            autoBom: !1
        } : "object" != typeof e && ($970c7ddf83730f06$var$n.warn("Deprecated: Expected third argument to be a object"), e = {
            autoBom: !e
        }), e.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type) ? new Blob([
            String.fromCharCode(65279),
            t
        ], {
            type: t.type
        }) : t;
    }(t, o), e);
} : function(e, n, i, a) {
    if ((a = a || open("", "_blank")) && (a.document.title = a.document.body.innerText = "downloading..."), "string" == typeof e) return $970c7ddf83730f06$var$r(e, n, i);
    var o = "application/octet-stream" === e.type, s = /constructor/i.test($970c7ddf83730f06$var$t.HTMLElement) || $970c7ddf83730f06$var$t.safari, u = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((u || o && s) && "object" == typeof FileReader) {
        var c = new FileReader;
        c.onloadend = function() {
            var t = c.result;
            t = u ? t : t.replace(/^data:[^;]*;/, "data:attachment/file;"), a ? a.location.href = t : location = t, a = null;
        }, c.readAsDataURL(e);
    } else {
        var h = $970c7ddf83730f06$var$t.URL || $970c7ddf83730f06$var$t.webkitURL, l = h.createObjectURL(e);
        a ? a.location = l : location.href = l, a = null, setTimeout(function() {
            h.revokeObjectURL(l);
        }, 4e4);
    }
});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */ function $970c7ddf83730f06$var$c(t) {
    var e;
    t = t || "", this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6));
    t = ({
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "00ffff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000000",
        blanchedalmond: "ffebcd",
        blue: "0000ff",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "00ffff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dodgerblue: "1e90ff",
        feldspar: "d19275",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "ff00ff",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgrey: "d3d3d3",
        lightgreen: "90ee90",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslateblue: "8470ff",
        lightslategray: "778899",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "00ff00",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "ff00ff",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370d8",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "d87093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        red: "ff0000",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        violetred: "d02090",
        wheat: "f5deb3",
        white: "ffffff",
        whitesmoke: "f5f5f5",
        yellow: "ffff00",
        yellowgreen: "9acd32"
    })[t = (t = t.replace(/ /g, "")).toLowerCase()] || t;
    for(var n = [
        {
            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            example: [
                "rgb(123, 234, 45)",
                "rgb(255,234,245)"
            ],
            process: function(t) {
                return [
                    parseInt(t[1]),
                    parseInt(t[2]),
                    parseInt(t[3])
                ];
            }
        },
        {
            re: /^(\w{2})(\w{2})(\w{2})$/,
            example: [
                "#00ff00",
                "336699"
            ],
            process: function(t) {
                return [
                    parseInt(t[1], 16),
                    parseInt(t[2], 16),
                    parseInt(t[3], 16)
                ];
            }
        },
        {
            re: /^(\w{1})(\w{1})(\w{1})$/,
            example: [
                "#fb0",
                "f0f"
            ],
            process: function(t) {
                return [
                    parseInt(t[1] + t[1], 16),
                    parseInt(t[2] + t[2], 16),
                    parseInt(t[3] + t[3], 16)
                ];
            }
        }
    ], r = 0; r < n.length; r++){
        var i = n[r].re, a = n[r].process, o = i.exec(t);
        o && (e = a(o), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
    }
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
        return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    }, this.toHex = function() {
        var t = this.r.toString(16), e = this.g.toString(16), n = this.b.toString(16);
        return 1 == t.length && (t = "0" + t), 1 == e.length && (e = "0" + e), 1 == n.length && (n = "0" + n), "#" + t + e + n;
    };
}
function $970c7ddf83730f06$var$h(e) {
    if ("object" != typeof e) throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
    var r = {};
    this.subscribe = function(t, e, n) {
        if (n = n || !1, "string" != typeof t || "function" != typeof e || "boolean" != typeof n) throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
        r.hasOwnProperty(t) || (r[t] = {});
        var i = Math.random().toString(35);
        return r[t][i] = [
            e,
            !!n
        ], i;
    }, this.unsubscribe = function(t) {
        for(var e in r)if (r[e][t]) return delete r[e][t], 0 === Object.keys(r[e]).length && delete r[e], !0;
        return !1;
    }, this.publish = function(i) {
        if (r.hasOwnProperty(i)) {
            var a = Array.prototype.slice.call(arguments, 1), o = [];
            for(var s in r[i]){
                var u = r[i][s];
                try {
                    u[0].apply(e, a);
                } catch (e) {
                    $970c7ddf83730f06$var$t.console && $970c7ddf83730f06$var$n.error("jsPDF PubSub Error", e.message, e);
                }
                u[1] && o.push(s);
            }
            o.length && o.forEach(this.unsubscribe);
        }
    }, this.getTopics = function() {
        return r;
    };
}
function $970c7ddf83730f06$export$1bc649ab427a02ba(t) {
    if (!(this instanceof $970c7ddf83730f06$export$1bc649ab427a02ba)) return new $970c7ddf83730f06$export$1bc649ab427a02ba(t);
    var e = "opacity,stroke-opacity".split(",");
    for(var n in t)t.hasOwnProperty(n) && e.indexOf(n) >= 0 && (this[n] = t[n]);
    this.id = "", this.objectNumber = -1;
}
function $970c7ddf83730f06$var$f(t, e) {
    this.gState = t, this.matrix = e, this.id = "", this.objectNumber = -1;
}
function $970c7ddf83730f06$export$7235f0ad083cb4c6(t, e, n, r, i) {
    if (!(this instanceof $970c7ddf83730f06$export$7235f0ad083cb4c6)) return new $970c7ddf83730f06$export$7235f0ad083cb4c6(t, e, n, r, i);
    this.type = "axial" === t ? 2 : 3, this.coords = e, this.colors = n, $970c7ddf83730f06$var$f.call(this, r, i);
}
function $970c7ddf83730f06$export$549f717800d2b57f(t, e, n, r, i) {
    if (!(this instanceof $970c7ddf83730f06$export$549f717800d2b57f)) return new $970c7ddf83730f06$export$549f717800d2b57f(t, e, n, r, i);
    this.boundingBox = t, this.xStep = e, this.yStep = n, this.stream = "", this.cloneIndex = 0, $970c7ddf83730f06$var$f.call(this, r, i);
}
function $970c7ddf83730f06$export$ba1e2ffc633a60f5(e) {
    var r, i = "string" == typeof arguments[0] ? arguments[0] : "p", a = arguments[1], o = arguments[2], f = arguments[3], m = [], v = 1, b = 16, y = "S";
    "object" == typeof (e = e || {}) && (i = e.orientation, a = e.unit || a, o = e.format || o, f = e.compress || e.compressPdf || f, v = "number" == typeof e.userUnit ? Math.abs(e.userUnit) : 1, void 0 !== e.precision && (r = e.precision), void 0 !== e.floatPrecision && (b = e.floatPrecision), y = e.defaultPathOperation || "S"), m = e.filters || (!0 === f ? [
        "FlateEncode"
    ] : m), a = a || "mm", i = ("" + (i || "P")).toLowerCase();
    var w = e.putOnlyUsedFonts || !1, N = {}, L = {
        internal: {},
        __private__: {}
    };
    L.__private__.PubSub = $970c7ddf83730f06$var$h;
    var x = "1.3", A = L.__private__.getPdfVersion = function() {
        return x;
    };
    L.__private__.setPdfVersion = function(t) {
        x = t;
    };
    var _ = {
        a0: [
            2383.94,
            3370.39
        ],
        a1: [
            1683.78,
            2383.94
        ],
        a2: [
            1190.55,
            1683.78
        ],
        a3: [
            841.89,
            1190.55
        ],
        a4: [
            595.28,
            841.89
        ],
        a5: [
            419.53,
            595.28
        ],
        a6: [
            297.64,
            419.53
        ],
        a7: [
            209.76,
            297.64
        ],
        a8: [
            147.4,
            209.76
        ],
        a9: [
            104.88,
            147.4
        ],
        a10: [
            73.7,
            104.88
        ],
        b0: [
            2834.65,
            4008.19
        ],
        b1: [
            2004.09,
            2834.65
        ],
        b2: [
            1417.32,
            2004.09
        ],
        b3: [
            1000.63,
            1417.32
        ],
        b4: [
            708.66,
            1000.63
        ],
        b5: [
            498.9,
            708.66
        ],
        b6: [
            354.33,
            498.9
        ],
        b7: [
            249.45,
            354.33
        ],
        b8: [
            175.75,
            249.45
        ],
        b9: [
            124.72,
            175.75
        ],
        b10: [
            87.87,
            124.72
        ],
        c0: [
            2599.37,
            3676.54
        ],
        c1: [
            1836.85,
            2599.37
        ],
        c2: [
            1298.27,
            1836.85
        ],
        c3: [
            918.43,
            1298.27
        ],
        c4: [
            649.13,
            918.43
        ],
        c5: [
            459.21,
            649.13
        ],
        c6: [
            323.15,
            459.21
        ],
        c7: [
            229.61,
            323.15
        ],
        c8: [
            161.57,
            229.61
        ],
        c9: [
            113.39,
            161.57
        ],
        c10: [
            79.37,
            113.39
        ],
        dl: [
            311.81,
            623.62
        ],
        letter: [
            612,
            792
        ],
        "government-letter": [
            576,
            756
        ],
        legal: [
            612,
            1008
        ],
        "junior-legal": [
            576,
            360
        ],
        ledger: [
            1224,
            792
        ],
        tabloid: [
            792,
            1224
        ],
        "credit-card": [
            153,
            243
        ]
    };
    L.__private__.getPageFormats = function() {
        return _;
    };
    var S = L.__private__.getPageFormat = function(t) {
        return _[t];
    };
    o = o || "a4";
    var P = {
        COMPAT: "compat",
        ADVANCED: "advanced"
    }, k = P.COMPAT;
    function F() {
        this.saveGraphicsState(), ot(new Dt(Nt, 0, 0, -Nt, 0, Cn() * Nt).toString() + " cm"), this.setFontSize(this.getFontSize() / Nt), y = "n", k = P.ADVANCED;
    }
    function I() {
        this.restoreGraphicsState(), y = "S", k = P.COMPAT;
    }
    L.advancedAPI = function(t) {
        var e = k === P.COMPAT;
        return e && F.call(this), "function" != typeof t || (t(this), e && I.call(this)), this;
    }, L.compatAPI = function(t) {
        var e = k === P.ADVANCED;
        return e && I.call(this), "function" != typeof t || (t(this), e && F.call(this)), this;
    }, L.isAdvancedAPI = function() {
        return k === P.ADVANCED;
    };
    var C, j = function(t) {
        if (k !== P.ADVANCED) throw new Error(t + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
    }, B = L.roundToPrecision = L.__private__.roundToPrecision = function(t, e) {
        var n = r || e;
        if (isNaN(t) || isNaN(n)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
        return t.toFixed(n).replace(/0+$/, "");
    };
    C = L.hpf = L.__private__.hpf = "number" == typeof b ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return B(t, b);
    } : "smart" === b ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return B(t, t > -1 && t < 1 ? 16 : 5);
    } : function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return B(t, 16);
    };
    var O = L.f2 = L.__private__.f2 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
        return B(t, 2);
    }, M = L.__private__.f3 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f3");
        return B(t, 3);
    }, E = L.scale = L.__private__.scale = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.scale");
        return k === P.COMPAT ? t * Nt : k === P.ADVANCED ? t : void 0;
    }, q = function(t) {
        return k === P.COMPAT ? Cn() - t : k === P.ADVANCED ? t : void 0;
    }, R = function(t) {
        return E(q(t));
    };
    L.__private__.setPrecision = L.setPrecision = function(t) {
        "number" == typeof parseInt(t, 10) && (r = parseInt(t, 10));
    };
    var T, D = "00000000000000000000000000000000", U = L.__private__.getFileId = function() {
        return D;
    }, z = L.__private__.setFileId = function(t) {
        return D = void 0 !== t && /^[a-fA-F0-9]{32}$/.test(t) ? t.toUpperCase() : D.split("").map(function() {
            return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
        }).join("");
    };
    L.setFileId = function(t) {
        return z(t), this;
    }, L.getFileId = function() {
        return U();
    };
    var H = L.__private__.convertDateToPDFDate = function(t) {
        var e = t.getTimezoneOffset(), n = e < 0 ? "+" : "-", r = Math.floor(Math.abs(e / 60)), i = Math.abs(e % 60), a = [
            n,
            J(r),
            "'",
            J(i),
            "'"
        ].join("");
        return [
            "D:",
            t.getFullYear(),
            J(t.getMonth() + 1),
            J(t.getDate()),
            J(t.getHours()),
            J(t.getMinutes()),
            J(t.getSeconds()),
            a
        ].join("");
    }, W = L.__private__.convertPDFDateToDate = function(t) {
        var e = parseInt(t.substr(2, 4), 10), n = parseInt(t.substr(6, 2), 10) - 1, r = parseInt(t.substr(8, 2), 10), i = parseInt(t.substr(10, 2), 10), a = parseInt(t.substr(12, 2), 10), o = parseInt(t.substr(14, 2), 10);
        return new Date(e, n, r, i, a, o, 0);
    }, V = L.__private__.setCreationDate = function(t) {
        var e;
        if (void 0 === t && (t = new Date), t instanceof Date) e = H(t);
        else {
            if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
            e = t;
        }
        return T = e;
    }, G = L.__private__.getCreationDate = function(t) {
        var e = T;
        return "jsDate" === t && (e = W(T)), e;
    };
    L.setCreationDate = function(t) {
        return V(t), this;
    }, L.getCreationDate = function(t) {
        return G(t);
    };
    var Y, J = L.__private__.padd2 = function(t) {
        return ("0" + parseInt(t)).slice(-2);
    }, X = L.__private__.padd2Hex = function(t) {
        return ("00" + (t = t.toString())).substr(t.length);
    }, K = 0, Z = [], $ = [], Q = 0, tt = [], et = [], nt = !1, rt = $, it = function() {
        K = 0, Q = 0, $ = [], Z = [], tt = [], Jt = Vt(), Xt = Vt();
    };
    L.__private__.setCustomOutputDestination = function(t) {
        nt = !0, rt = t;
    };
    var at = function(t) {
        nt || (rt = t);
    };
    L.__private__.resetCustomOutputDestination = function() {
        nt = !1, rt = $;
    };
    var ot = L.__private__.out = function(t) {
        return t = t.toString(), Q += t.length + 1, rt.push(t), rt;
    }, st = L.__private__.write = function(t) {
        return ot(1 === arguments.length ? t.toString() : Array.prototype.join.call(arguments, " "));
    }, ut = L.__private__.getArrayBuffer = function(t) {
        for(var e = t.length, n = new ArrayBuffer(e), r = new Uint8Array(n); e--;)r[e] = t.charCodeAt(e);
        return n;
    }, ct = [
        [
            "Helvetica",
            "helvetica",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Bold",
            "helvetica",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Oblique",
            "helvetica",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-BoldOblique",
            "helvetica",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Courier",
            "courier",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Bold",
            "courier",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Oblique",
            "courier",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Courier-BoldOblique",
            "courier",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Times-Roman",
            "times",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Times-Bold",
            "times",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Times-Italic",
            "times",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Times-BoldItalic",
            "times",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "ZapfDingbats",
            "zapfdingbats",
            "normal",
            null
        ],
        [
            "Symbol",
            "symbol",
            "normal",
            null
        ]
    ];
    L.__private__.getStandardFonts = function() {
        return ct;
    };
    var ht = e.fontSize || 16;
    L.__private__.setFontSize = L.setFontSize = function(t) {
        return ht = k === P.ADVANCED ? t / Nt : t, this;
    };
    var lt, ft = L.__private__.getFontSize = L.getFontSize = function() {
        return k === P.COMPAT ? ht : ht * Nt;
    }, dt = e.R2L || !1;
    L.__private__.setR2L = L.setR2L = function(t) {
        return dt = t, this;
    }, L.__private__.getR2L = L.getR2L = function() {
        return dt;
    };
    var pt, gt = L.__private__.setZoomMode = function(t) {
        var e = [
            void 0,
            null,
            "fullwidth",
            "fullheight",
            "fullpage",
            "original"
        ];
        if (/^\d*\.?\d*%$/.test(t)) lt = t;
        else if (isNaN(t)) {
            if (-1 === e.indexOf(t)) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + t + '" is not recognized.');
            lt = t;
        } else lt = parseInt(t, 10);
    };
    L.__private__.getZoomMode = function() {
        return lt;
    };
    var mt, vt = L.__private__.setPageMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "UseNone",
            "UseOutlines",
            "UseThumbs",
            "FullScreen"
        ].indexOf(t)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + t + '" is not recognized.');
        pt = t;
    };
    L.__private__.getPageMode = function() {
        return pt;
    };
    var bt = L.__private__.setLayoutMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "continuous",
            "single",
            "twoleft",
            "tworight",
            "two"
        ].indexOf(t)) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + t + '" is not recognized.');
        mt = t;
    };
    L.__private__.getLayoutMode = function() {
        return mt;
    }, L.__private__.setDisplayMode = L.setDisplayMode = function(t, e, n) {
        return gt(t), bt(e), vt(n), this;
    };
    var yt = {
        title: "",
        subject: "",
        author: "",
        keywords: "",
        creator: ""
    };
    L.__private__.getDocumentProperty = function(t) {
        if (-1 === Object.keys(yt).indexOf(t)) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
        return yt[t];
    }, L.__private__.getDocumentProperties = function() {
        return yt;
    }, L.__private__.setDocumentProperties = L.setProperties = L.setDocumentProperties = function(t) {
        for(var e in yt)yt.hasOwnProperty(e) && t[e] && (yt[e] = t[e]);
        return this;
    }, L.__private__.setDocumentProperty = function(t, e) {
        if (-1 === Object.keys(yt).indexOf(t)) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
        return yt[t] = e;
    };
    var wt, Nt, Lt, xt, At, _t = {}, St = {}, Pt = [], kt = {}, Ft = {}, It = {}, Ct = {}, jt = null, Bt = 0, Ot = [], Mt = new $970c7ddf83730f06$var$h(L), Et = e.hotfixes || [], qt = {}, Rt = {}, Tt = [], Dt = function(t, e, n, r, i, a) {
        if (!(this instanceof Dt)) return new Dt(t, e, n, r, i, a);
        isNaN(t) && (t = 1), isNaN(e) && (e = 0), isNaN(n) && (n = 0), isNaN(r) && (r = 1), isNaN(i) && (i = 0), isNaN(a) && (a = 0), this._matrix = [
            t,
            e,
            n,
            r,
            i,
            a
        ];
    };
    Object.defineProperty(Dt.prototype, "sx", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Dt.prototype, "shy", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Dt.prototype, "shx", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Dt.prototype, "sy", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Dt.prototype, "tx", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Dt.prototype, "ty", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Dt.prototype, "a", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Dt.prototype, "b", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Dt.prototype, "c", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Dt.prototype, "d", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Dt.prototype, "e", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Dt.prototype, "f", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Dt.prototype, "rotation", {
        get: function() {
            return Math.atan2(this.shx, this.sx);
        }
    }), Object.defineProperty(Dt.prototype, "scaleX", {
        get: function() {
            return this.decompose().scale.sx;
        }
    }), Object.defineProperty(Dt.prototype, "scaleY", {
        get: function() {
            return this.decompose().scale.sy;
        }
    }), Object.defineProperty(Dt.prototype, "isIdentity", {
        get: function() {
            return 1 === this.sx && 0 === this.shy && 0 === this.shx && 1 === this.sy && 0 === this.tx && 0 === this.ty;
        }
    }), Dt.prototype.join = function(t) {
        return [
            this.sx,
            this.shy,
            this.shx,
            this.sy,
            this.tx,
            this.ty
        ].map(C).join(t);
    }, Dt.prototype.multiply = function(t) {
        var e = t.sx * this.sx + t.shy * this.shx, n = t.sx * this.shy + t.shy * this.sy, r = t.shx * this.sx + t.sy * this.shx, i = t.shx * this.shy + t.sy * this.sy, a = t.tx * this.sx + t.ty * this.shx + this.tx, o = t.tx * this.shy + t.ty * this.sy + this.ty;
        return new Dt(e, n, r, i, a, o);
    }, Dt.prototype.decompose = function() {
        var t = this.sx, e = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty, o = Math.sqrt(t * t + e * e), s = (t /= o) * n + (e /= o) * r;
        n -= t * s, r -= e * s;
        var u = Math.sqrt(n * n + r * r);
        return s /= u, t * (r /= u) < e * (n /= u) && (t = -t, e = -e, s = -s, o = -o), {
            scale: new Dt(o, 0, 0, u, 0, 0),
            translate: new Dt(1, 0, 0, 1, i, a),
            rotate: new Dt(t, e, -e, t, 0, 0),
            skew: new Dt(1, 0, s, 1, 0, 0)
        };
    }, Dt.prototype.toString = function(t) {
        return this.join(" ");
    }, Dt.prototype.inversed = function() {
        var t = this.sx, e = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty, o = 1 / (t * r - e * n), s = r * o, u = -e * o, c = -n * o, h = t * o;
        return new Dt(s, u, c, h, -s * i - c * a, -u * i - h * a);
    }, Dt.prototype.applyToPoint = function(t) {
        var e = t.x * this.sx + t.y * this.shx + this.tx, n = t.x * this.shy + t.y * this.sy + this.ty;
        return new xn(e, n);
    }, Dt.prototype.applyToRectangle = function(t) {
        var e = this.applyToPoint(t), n = this.applyToPoint(new xn(t.x + t.w, t.y + t.h));
        return new An(e.x, e.y, n.x - e.x, n.y - e.y);
    }, Dt.prototype.clone = function() {
        var t = this.sx, e = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty;
        return new Dt(t, e, n, r, i, a);
    }, L.Matrix = Dt;
    var Ut = L.matrixMult = function(t, e) {
        return e.multiply(t);
    }, zt = new Dt(1, 0, 0, 1, 0, 0);
    L.unitMatrix = L.identityMatrix = zt;
    var Ht = function(t, e) {
        if (!Ft[t]) {
            var n = (e instanceof $970c7ddf83730f06$export$7235f0ad083cb4c6 ? "Sh" : "P") + (Object.keys(kt).length + 1).toString(10);
            e.id = n, Ft[t] = n, kt[n] = e, Mt.publish("addPattern", e);
        }
    };
    L.ShadingPattern = $970c7ddf83730f06$export$7235f0ad083cb4c6, L.TilingPattern = $970c7ddf83730f06$export$549f717800d2b57f, L.addShadingPattern = function(t, e) {
        return j("addShadingPattern()"), Ht(t, e), this;
    }, L.beginTilingPattern = function(t) {
        j("beginTilingPattern()"), Sn(t.boundingBox[0], t.boundingBox[1], t.boundingBox[2] - t.boundingBox[0], t.boundingBox[3] - t.boundingBox[1], t.matrix);
    }, L.endTilingPattern = function(t, e) {
        j("endTilingPattern()"), e.stream = et[Y].join("\n"), Ht(t, e), Mt.publish("endTilingPattern", e), Tt.pop().restore();
    };
    var Wt = L.__private__.newObject = function() {
        var t = Vt();
        return Gt(t, !0), t;
    }, Vt = L.__private__.newObjectDeferred = function() {
        return K++, Z[K] = function() {
            return Q;
        }, K;
    }, Gt = function(t, e) {
        return e = "boolean" == typeof e && e, Z[t] = Q, e && ot(t + " 0 obj"), t;
    }, Yt = L.__private__.newAdditionalObject = function() {
        var t = {
            objId: Vt(),
            content: ""
        };
        return tt.push(t), t;
    }, Jt = Vt(), Xt = Vt(), Kt = L.__private__.decodeColorString = function(t) {
        var e = t.split(" ");
        if (2 !== e.length || "g" !== e[1] && "G" !== e[1]) {
            if (5 === e.length && ("k" === e[4] || "K" === e[4])) e = [
                (1 - e[0]) * (1 - e[3]),
                (1 - e[1]) * (1 - e[3]),
                (1 - e[2]) * (1 - e[3]),
                "r"
            ];
        } else {
            var n = parseFloat(e[0]);
            e = [
                n,
                n,
                n,
                "r"
            ];
        }
        for(var r = "#", i = 0; i < 3; i++)r += ("0" + Math.floor(255 * parseFloat(e[i])).toString(16)).slice(-2);
        return r;
    }, Zt = L.__private__.encodeColorString = function(t) {
        var e;
        "string" == typeof t && (t = {
            ch1: t
        });
        var n = t.ch1, r = t.ch2, i = t.ch3, a = t.ch4, o = "draw" === t.pdfColorType ? [
            "G",
            "RG",
            "K"
        ] : [
            "g",
            "rg",
            "k"
        ];
        if ("string" == typeof n && "#" !== n.charAt(0)) {
            var s = new $970c7ddf83730f06$var$c(n);
            if (s.ok) n = s.toHex();
            else if (!/^\d*\.?\d*$/.test(n)) throw new Error('Invalid color "' + n + '" passed to jsPDF.encodeColorString.');
        }
        if ("string" == typeof n && /^#[0-9A-Fa-f]{3}$/.test(n) && (n = "#" + n[1] + n[1] + n[2] + n[2] + n[3] + n[3]), "string" == typeof n && /^#[0-9A-Fa-f]{6}$/.test(n)) {
            var u = parseInt(n.substr(1), 16);
            n = u >> 16 & 255, r = u >> 8 & 255, i = 255 & u;
        }
        if (void 0 === r || void 0 === a && n === r && r === i) {
            if ("string" == typeof n) e = n + " " + o[0];
            else switch(t.precision){
                case 2:
                    e = O(n / 255) + " " + o[0];
                    break;
                case 3:
                default:
                    e = M(n / 255) + " " + o[0];
            }
        } else if (void 0 === a || "object" == typeof a) {
            if (a && !isNaN(a.a) && 0 === a.a) return e = [
                "1.",
                "1.",
                "1.",
                o[1]
            ].join(" ");
            if ("string" == typeof n) e = [
                n,
                r,
                i,
                o[1]
            ].join(" ");
            else switch(t.precision){
                case 2:
                    e = [
                        O(n / 255),
                        O(r / 255),
                        O(i / 255),
                        o[1]
                    ].join(" ");
                    break;
                default:
                case 3:
                    e = [
                        M(n / 255),
                        M(r / 255),
                        M(i / 255),
                        o[1]
                    ].join(" ");
            }
        } else if ("string" == typeof n) e = [
            n,
            r,
            i,
            a,
            o[2]
        ].join(" ");
        else switch(t.precision){
            case 2:
                e = [
                    O(n),
                    O(r),
                    O(i),
                    O(a),
                    o[2]
                ].join(" ");
                break;
            case 3:
            default:
                e = [
                    M(n),
                    M(r),
                    M(i),
                    M(a),
                    o[2]
                ].join(" ");
        }
        return e;
    }, $t = L.__private__.getFilters = function() {
        return m;
    }, Qt = L.__private__.putStream = function(t) {
        var e = (t = t || {}).data || "", n = t.filters || $t(), r = t.alreadyAppliedFilters || [], i = t.addLength1 || !1, a = e.length, o = {};
        !0 === n && (n = [
            "FlateEncode"
        ]);
        var s = t.additionalKeyValues || [], u = (o = void 0 !== $970c7ddf83730f06$export$ba1e2ffc633a60f5.API.processDataByFilters ? $970c7ddf83730f06$export$ba1e2ffc633a60f5.API.processDataByFilters(e, n) : {
            data: e,
            reverseChain: []
        }).reverseChain + (Array.isArray(r) ? r.join(" ") : r.toString());
        if (0 !== o.data.length && (s.push({
            key: "Length",
            value: o.data.length
        }), !0 === i && s.push({
            key: "Length1",
            value: a
        })), 0 != u.length) {
            if (u.split("/").length - 1 == 1) s.push({
                key: "Filter",
                value: u
            });
            else {
                s.push({
                    key: "Filter",
                    value: "[" + u + "]"
                });
                for(var c = 0; c < s.length; c += 1)if ("DecodeParms" === s[c].key) {
                    for(var h = [], l = 0; l < o.reverseChain.split("/").length - 1; l += 1)h.push("null");
                    h.push(s[c].value), s[c].value = "[" + h.join(" ") + "]";
                }
            }
        }
        ot("<<");
        for(var f = 0; f < s.length; f++)ot("/" + s[f].key + " " + s[f].value);
        ot(">>"), 0 !== o.data.length && (ot("stream"), ot(o.data), ot("endstream"));
    }, te = L.__private__.putPage = function(t) {
        var e = t.number, n = t.data, r = t.objId, i = t.contentsObjId;
        Gt(r, !0), ot("<</Type /Page"), ot("/Parent " + t.rootDictionaryObjId + " 0 R"), ot("/Resources " + t.resourceDictionaryObjId + " 0 R"), ot("/MediaBox [" + parseFloat(C(t.mediaBox.bottomLeftX)) + " " + parseFloat(C(t.mediaBox.bottomLeftY)) + " " + C(t.mediaBox.topRightX) + " " + C(t.mediaBox.topRightY) + "]"), null !== t.cropBox && ot("/CropBox [" + C(t.cropBox.bottomLeftX) + " " + C(t.cropBox.bottomLeftY) + " " + C(t.cropBox.topRightX) + " " + C(t.cropBox.topRightY) + "]"), null !== t.bleedBox && ot("/BleedBox [" + C(t.bleedBox.bottomLeftX) + " " + C(t.bleedBox.bottomLeftY) + " " + C(t.bleedBox.topRightX) + " " + C(t.bleedBox.topRightY) + "]"), null !== t.trimBox && ot("/TrimBox [" + C(t.trimBox.bottomLeftX) + " " + C(t.trimBox.bottomLeftY) + " " + C(t.trimBox.topRightX) + " " + C(t.trimBox.topRightY) + "]"), null !== t.artBox && ot("/ArtBox [" + C(t.artBox.bottomLeftX) + " " + C(t.artBox.bottomLeftY) + " " + C(t.artBox.topRightX) + " " + C(t.artBox.topRightY) + "]"), "number" == typeof t.userUnit && 1 !== t.userUnit && ot("/UserUnit " + t.userUnit), Mt.publish("putPage", {
            objId: r,
            pageContext: Ot[e],
            pageNumber: e,
            page: n
        }), ot("/Contents " + i + " 0 R"), ot(">>"), ot("endobj");
        var a = n.join("\n");
        return k === P.ADVANCED && (a += "\nQ"), Gt(i, !0), Qt({
            data: a,
            filters: $t()
        }), ot("endobj"), r;
    }, ee = L.__private__.putPages = function() {
        var t, e, n = [];
        for(t = 1; t <= Bt; t++)Ot[t].objId = Vt(), Ot[t].contentsObjId = Vt();
        for(t = 1; t <= Bt; t++)n.push(te({
            number: t,
            data: et[t],
            objId: Ot[t].objId,
            contentsObjId: Ot[t].contentsObjId,
            mediaBox: Ot[t].mediaBox,
            cropBox: Ot[t].cropBox,
            bleedBox: Ot[t].bleedBox,
            trimBox: Ot[t].trimBox,
            artBox: Ot[t].artBox,
            userUnit: Ot[t].userUnit,
            rootDictionaryObjId: Jt,
            resourceDictionaryObjId: Xt
        }));
        Gt(Jt, !0), ot("<</Type /Pages");
        var r = "/Kids [";
        for(e = 0; e < Bt; e++)r += n[e] + " 0 R ";
        ot(r + "]"), ot("/Count " + Bt), ot(">>"), ot("endobj"), Mt.publish("postPutPages");
    }, ne = function(t) {
        var e = function(t, e) {
            return -1 !== t.indexOf(" ") ? "(" + _e(t, e) + ")" : _e(t, e);
        };
        Mt.publish("putFont", {
            font: t,
            out: ot,
            newObject: Wt,
            putStream: Qt,
            pdfEscapeWithNeededParanthesis: e
        }), !0 !== t.isAlreadyPutted && (t.objectNumber = Wt(), ot("<<"), ot("/Type /Font"), ot("/BaseFont /" + e(t.postScriptName)), ot("/Subtype /Type1"), "string" == typeof t.encoding && ot("/Encoding /" + t.encoding), ot("/FirstChar 32"), ot("/LastChar 255"), ot(">>"), ot("endobj"));
    }, re = function() {
        for(var t in _t)_t.hasOwnProperty(t) && (!1 === w || !0 === w && N.hasOwnProperty(t)) && ne(_t[t]);
    }, ie = function(t) {
        t.objectNumber = Wt();
        var e = [];
        e.push({
            key: "Type",
            value: "/XObject"
        }), e.push({
            key: "Subtype",
            value: "/Form"
        }), e.push({
            key: "BBox",
            value: "[" + [
                C(t.x),
                C(t.y),
                C(t.x + t.width),
                C(t.y + t.height)
            ].join(" ") + "]"
        }), e.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        });
        var n = t.pages[1].join("\n");
        Qt({
            data: n,
            additionalKeyValues: e
        }), ot("endobj");
    }, ae = function() {
        for(var t in qt)qt.hasOwnProperty(t) && ie(qt[t]);
    }, oe = function(t, e) {
        var n, r = [], i = 1 / (e - 1);
        for(n = 0; n < 1; n += i)r.push(n);
        if (r.push(1), 0 != t[0].offset) {
            var a = {
                offset: 0,
                color: t[0].color
            };
            t.unshift(a);
        }
        if (1 != t[t.length - 1].offset) {
            var o = {
                offset: 1,
                color: t[t.length - 1].color
            };
            t.push(o);
        }
        for(var s = "", u = 0, c = 0; c < r.length; c++){
            for(n = r[c]; n > t[u + 1].offset;)u++;
            var h = t[u].offset, l = (n - h) / (t[u + 1].offset - h), f = t[u].color, d = t[u + 1].color;
            s += X(Math.round((1 - l) * f[0] + l * d[0]).toString(16)) + X(Math.round((1 - l) * f[1] + l * d[1]).toString(16)) + X(Math.round((1 - l) * f[2] + l * d[2]).toString(16));
        }
        return s.trim();
    }, se = function(t, e) {
        e || (e = 21);
        var n = Wt(), r = oe(t.colors, e), i = [];
        i.push({
            key: "FunctionType",
            value: "0"
        }), i.push({
            key: "Domain",
            value: "[0.0 1.0]"
        }), i.push({
            key: "Size",
            value: "[" + e + "]"
        }), i.push({
            key: "BitsPerSample",
            value: "8"
        }), i.push({
            key: "Range",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), i.push({
            key: "Decode",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), Qt({
            data: r,
            additionalKeyValues: i,
            alreadyAppliedFilters: [
                "/ASCIIHexDecode"
            ]
        }), ot("endobj"), t.objectNumber = Wt(), ot("<< /ShadingType " + t.type), ot("/ColorSpace /DeviceRGB");
        var a = "/Coords [" + C(parseFloat(t.coords[0])) + " " + C(parseFloat(t.coords[1])) + " ";
        2 === t.type ? a += C(parseFloat(t.coords[2])) + " " + C(parseFloat(t.coords[3])) : a += C(parseFloat(t.coords[2])) + " " + C(parseFloat(t.coords[3])) + " " + C(parseFloat(t.coords[4])) + " " + C(parseFloat(t.coords[5])), ot(a += "]"), t.matrix && ot("/Matrix [" + t.matrix.toString() + "]"), ot("/Function " + n + " 0 R"), ot("/Extend [true true]"), ot(">>"), ot("endobj");
    }, ue = function(t, e) {
        var n = Vt(), r = Wt();
        e.push({
            resourcesOid: n,
            objectOid: r
        }), t.objectNumber = r;
        var i = [];
        i.push({
            key: "Type",
            value: "/Pattern"
        }), i.push({
            key: "PatternType",
            value: "1"
        }), i.push({
            key: "PaintType",
            value: "1"
        }), i.push({
            key: "TilingType",
            value: "1"
        }), i.push({
            key: "BBox",
            value: "[" + t.boundingBox.map(C).join(" ") + "]"
        }), i.push({
            key: "XStep",
            value: C(t.xStep)
        }), i.push({
            key: "YStep",
            value: C(t.yStep)
        }), i.push({
            key: "Resources",
            value: n + " 0 R"
        }), t.matrix && i.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        }), Qt({
            data: t.stream,
            additionalKeyValues: i
        }), ot("endobj");
    }, ce = function(t) {
        var e;
        for(e in kt)kt.hasOwnProperty(e) && (kt[e] instanceof $970c7ddf83730f06$export$7235f0ad083cb4c6 ? se(kt[e]) : kt[e] instanceof $970c7ddf83730f06$export$549f717800d2b57f && ue(kt[e], t));
    }, he = function(t) {
        for(var e in t.objectNumber = Wt(), ot("<<"), t)switch(e){
            case "opacity":
                ot("/ca " + O(t[e]));
                break;
            case "stroke-opacity":
                ot("/CA " + O(t[e]));
        }
        ot(">>"), ot("endobj");
    }, le = function() {
        var t;
        for(t in It)It.hasOwnProperty(t) && he(It[t]);
    }, fe = function() {
        for(var t in ot("/XObject <<"), qt)qt.hasOwnProperty(t) && qt[t].objectNumber >= 0 && ot("/" + t + " " + qt[t].objectNumber + " 0 R");
        Mt.publish("putXobjectDict"), ot(">>");
    }, de = function() {
        for(var t in ot("/Font <<"), _t)_t.hasOwnProperty(t) && (!1 === w || !0 === w && N.hasOwnProperty(t)) && ot("/" + t + " " + _t[t].objectNumber + " 0 R");
        ot(">>");
    }, pe = function() {
        if (Object.keys(kt).length > 0) {
            for(var t in ot("/Shading <<"), kt)kt.hasOwnProperty(t) && kt[t] instanceof $970c7ddf83730f06$export$7235f0ad083cb4c6 && kt[t].objectNumber >= 0 && ot("/" + t + " " + kt[t].objectNumber + " 0 R");
            Mt.publish("putShadingPatternDict"), ot(">>");
        }
    }, ge = function(t) {
        if (Object.keys(kt).length > 0) {
            for(var e in ot("/Pattern <<"), kt)kt.hasOwnProperty(e) && kt[e] instanceof L.TilingPattern && kt[e].objectNumber >= 0 && kt[e].objectNumber < t && ot("/" + e + " " + kt[e].objectNumber + " 0 R");
            Mt.publish("putTilingPatternDict"), ot(">>");
        }
    }, me = function() {
        if (Object.keys(It).length > 0) {
            var t;
            for(t in ot("/ExtGState <<"), It)It.hasOwnProperty(t) && It[t].objectNumber >= 0 && ot("/" + t + " " + It[t].objectNumber + " 0 R");
            Mt.publish("putGStateDict"), ot(">>");
        }
    }, ve = function(t) {
        Gt(t.resourcesOid, !0), ot("<<"), ot("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), de(), pe(), ge(t.objectOid), me(), fe(), ot(">>"), ot("endobj");
    }, be = function() {
        var t = [];
        re(), le(), ae(), ce(t), Mt.publish("putResources"), t.forEach(ve), ve({
            resourcesOid: Xt,
            objectOid: Number.MAX_SAFE_INTEGER
        }), Mt.publish("postPutResources");
    }, ye = function() {
        Mt.publish("putAdditionalObjects");
        for(var t = 0; t < tt.length; t++){
            var e = tt[t];
            Gt(e.objId, !0), ot(e.content), ot("endobj");
        }
        Mt.publish("postPutAdditionalObjects");
    }, we = function(t) {
        St[t.fontName] = St[t.fontName] || {}, St[t.fontName][t.fontStyle] = t.id;
    }, Ne = function(t, e, n, r, i) {
        var a = {
            id: "F" + (Object.keys(_t).length + 1).toString(10),
            postScriptName: t,
            fontName: e,
            fontStyle: n,
            encoding: r,
            isStandardFont: i || !1,
            metadata: {}
        };
        return Mt.publish("addFont", {
            font: a,
            instance: this
        }), _t[a.id] = a, we(a), a.id;
    }, Le = function(t) {
        for(var e = 0, n = ct.length; e < n; e++){
            var r = Ne.call(this, t[e][0], t[e][1], t[e][2], ct[e][3], !0);
            !1 === w && (N[r] = !0);
            var i = t[e][0].split("-");
            we({
                id: r,
                fontName: i[0],
                fontStyle: i[1] || ""
            });
        }
        Mt.publish("addFonts", {
            fonts: _t,
            dictionary: St
        });
    }, xe = function(e) {
        return e.foo = function() {
            try {
                return e.apply(this, arguments);
            } catch (e) {
                var n = e.stack || "";
                ~n.indexOf(" at ") && (n = n.split(" at ")[1]);
                var r = "Error in function " + n.split("\n")[0].split("<")[0] + ": " + e.message;
                if (!$970c7ddf83730f06$var$t.console) throw new Error(r);
                $970c7ddf83730f06$var$t.console.error(r, e), $970c7ddf83730f06$var$t.alert && alert(r);
            }
        }, e.foo.bar = e, e.foo;
    }, Ae = function(t, e) {
        var n, r, i, a, o, s, u, c, h;
        if (i = (e = e || {}).sourceEncoding || "Unicode", o = e.outputEncoding, (e.autoencode || o) && _t[wt].metadata && _t[wt].metadata[i] && _t[wt].metadata[i].encoding && (a = _t[wt].metadata[i].encoding, !o && _t[wt].encoding && (o = _t[wt].encoding), !o && a.codePages && (o = a.codePages[0]), "string" == typeof o && (o = a[o]), o)) {
            for(u = !1, s = [], n = 0, r = t.length; n < r; n++)(c = o[t.charCodeAt(n)]) ? s.push(String.fromCharCode(c)) : s.push(t[n]), s[n].charCodeAt(0) >> 8 && (u = !0);
            t = s.join("");
        }
        for(n = t.length; void 0 === u && 0 !== n;)t.charCodeAt(n - 1) >> 8 && (u = !0), n--;
        if (!u) return t;
        for(s = e.noBOM ? [] : [
            254,
            255
        ], n = 0, r = t.length; n < r; n++){
            if ((h = (c = t.charCodeAt(n)) >> 8) >> 8) throw new Error("Character at position " + n + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
            s.push(h), s.push(c - (h << 8));
        }
        return String.fromCharCode.apply(void 0, s);
    }, _e = L.__private__.pdfEscape = L.pdfEscape = function(t, e) {
        return Ae(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
    }, Se = L.__private__.beginPage = function(t) {
        et[++Bt] = [], Ot[Bt] = {
            objId: 0,
            contentsObjId: 0,
            userUnit: Number(v),
            artBox: null,
            bleedBox: null,
            cropBox: null,
            trimBox: null,
            mediaBox: {
                bottomLeftX: 0,
                bottomLeftY: 0,
                topRightX: Number(t[0]),
                topRightY: Number(t[1])
            }
        }, Fe(Bt), at(et[Y]);
    }, Pe = function(t, e) {
        var r, a, s;
        switch(i = e || i, "string" == typeof t && (r = S(t.toLowerCase()), Array.isArray(r) && (a = r[0], s = r[1])), Array.isArray(t) && (a = t[0] * Nt, s = t[1] * Nt), isNaN(a) && (a = o[0], s = o[1]), (a > 14400 || s > 14400) && ($970c7ddf83730f06$var$n.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), a = Math.min(14400, a), s = Math.min(14400, s)), o = [
            a,
            s
        ], i.substr(0, 1)){
            case "l":
                s > a && (o = [
                    s,
                    a
                ]);
                break;
            case "p":
                a > s && (o = [
                    s,
                    a
                ]);
        }
        Se(o), on(an), ot(pn), 0 !== wn && ot(wn + " J"), 0 !== Nn && ot(Nn + " j"), Mt.publish("addPage", {
            pageNumber: Bt
        });
    }, ke = function(t) {
        t > 0 && t <= Bt && (et.splice(t, 1), Ot.splice(t, 1), Bt--, Y > Bt && (Y = Bt), this.setPage(Y));
    }, Fe = function(t) {
        t > 0 && t <= Bt && (Y = t);
    }, Ie = L.__private__.getNumberOfPages = L.getNumberOfPages = function() {
        return et.length - 1;
    }, Ce = function(t, e, r) {
        var i, a = void 0;
        return r = r || {}, t = void 0 !== t ? t : _t[wt].fontName, e = void 0 !== e ? e : _t[wt].fontStyle, i = t.toLowerCase(), void 0 !== St[i] && void 0 !== St[i][e] ? a = St[i][e] : void 0 !== St[t] && void 0 !== St[t][e] ? a = St[t][e] : !1 === r.disableWarning && $970c7ddf83730f06$var$n.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), a || r.noFallback || null == (a = St.times[e]) && (a = St.times.normal), a;
    }, je = L.__private__.putInfo = function() {
        for(var t in Wt(), ot("<<"), ot("/Producer (jsPDF " + $970c7ddf83730f06$export$ba1e2ffc633a60f5.version + ")"), yt)yt.hasOwnProperty(t) && yt[t] && ot("/" + t.substr(0, 1).toUpperCase() + t.substr(1) + " (" + _e(yt[t]) + ")");
        ot("/CreationDate (" + T + ")"), ot(">>"), ot("endobj");
    }, Be = L.__private__.putCatalog = function(t) {
        var e = (t = t || {}).rootDictionaryObjId || Jt;
        switch(Wt(), ot("<<"), ot("/Type /Catalog"), ot("/Pages " + e + " 0 R"), lt || (lt = "fullwidth"), lt){
            case "fullwidth":
                ot("/OpenAction [3 0 R /FitH null]");
                break;
            case "fullheight":
                ot("/OpenAction [3 0 R /FitV null]");
                break;
            case "fullpage":
                ot("/OpenAction [3 0 R /Fit]");
                break;
            case "original":
                ot("/OpenAction [3 0 R /XYZ null null 1]");
                break;
            default:
                var n = "" + lt;
                "%" === n.substr(n.length - 1) && (lt = parseInt(lt) / 100), "number" == typeof lt && ot("/OpenAction [3 0 R /XYZ null null " + O(lt) + "]");
        }
        switch(mt || (mt = "continuous"), mt){
            case "continuous":
                ot("/PageLayout /OneColumn");
                break;
            case "single":
                ot("/PageLayout /SinglePage");
                break;
            case "two":
            case "twoleft":
                ot("/PageLayout /TwoColumnLeft");
                break;
            case "tworight":
                ot("/PageLayout /TwoColumnRight");
        }
        pt && ot("/PageMode /" + pt), Mt.publish("putCatalog"), ot(">>"), ot("endobj");
    }, Oe = L.__private__.putTrailer = function() {
        ot("trailer"), ot("<<"), ot("/Size " + (K + 1)), ot("/Root " + K + " 0 R"), ot("/Info " + (K - 1) + " 0 R"), ot("/ID [ <" + D + "> <" + D + "> ]"), ot(">>");
    }, Me = L.__private__.putHeader = function() {
        ot("%PDF-" + x), ot("%\xba\xdf\xac\xe0");
    }, Ee = L.__private__.putXRef = function() {
        var t = "0000000000";
        ot("xref"), ot("0 " + (K + 1)), ot("0000000000 65535 f ");
        for(var e = 1; e <= K; e++)"function" == typeof Z[e] ? ot((t + Z[e]()).slice(-10) + " 00000 n ") : void 0 !== Z[e] ? ot((t + Z[e]).slice(-10) + " 00000 n ") : ot("0000000000 00000 n ");
    }, qe = L.__private__.buildDocument = function() {
        it(), at($), Mt.publish("buildDocument"), Me(), ee(), ye(), be(), je(), Be();
        var t = Q;
        return Ee(), Oe(), ot("startxref"), ot("" + t), ot("%%EOF"), at(et[Y]), $.join("\n");
    }, Re = L.__private__.getBlob = function(t) {
        return new Blob([
            ut(t)
        ], {
            type: "application/pdf"
        });
    }, Te = L.output = L.__private__.output = xe(function(e, r) {
        switch("string" == typeof (r = r || {}) ? r = {
            filename: r
        } : r.filename = r.filename || "generated.pdf", e){
            case void 0:
                return qe();
            case "save":
                L.save(r.filename);
                break;
            case "arraybuffer":
                return ut(qe());
            case "blob":
                return Re(qe());
            case "bloburi":
            case "bloburl":
                if (void 0 !== $970c7ddf83730f06$var$t.URL && "function" == typeof $970c7ddf83730f06$var$t.URL.createObjectURL) return $970c7ddf83730f06$var$t.URL && $970c7ddf83730f06$var$t.URL.createObjectURL(Re(qe())) || void 0;
                $970c7ddf83730f06$var$n.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
                break;
            case "datauristring":
            case "dataurlstring":
                var i = "", a = qe();
                try {
                    i = $970c7ddf83730f06$var$s(a);
                } catch (t) {
                    i = $970c7ddf83730f06$var$s(unescape(encodeURIComponent(a)));
                }
                return "data:application/pdf;filename=" + r.filename + ";base64," + i;
            case "pdfobjectnewwindow":
                if ("[object Window]" === Object.prototype.toString.call($970c7ddf83730f06$var$t)) {
                    var o = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + (r.pdfObjectUrl || "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js") + '"></script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(r) + ");</script></body></html>", u = $970c7ddf83730f06$var$t.open();
                    return null !== u && u.document.write(o), u;
                }
                throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
            case "pdfjsnewwindow":
                if ("[object Window]" === Object.prototype.toString.call($970c7ddf83730f06$var$t)) {
                    var c = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (r.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + r.filename + '" width="500px" height="400px" /></body></html>', h = $970c7ddf83730f06$var$t.open();
                    if (null !== h) {
                        h.document.write(c);
                        var l = this;
                        h.document.documentElement.querySelector("#pdfViewer").onload = function() {
                            h.document.title = r.filename, h.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(l.output("bloburl"));
                        };
                    }
                    return h;
                }
                throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
            case "dataurlnewwindow":
                if ("[object Window]" !== Object.prototype.toString.call($970c7ddf83730f06$var$t)) throw new Error("The option dataurlnewwindow just works in a browser-environment.");
                var f = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", r) + '"></iframe></body></html>', d = $970c7ddf83730f06$var$t.open();
                if (null !== d && (d.document.write(f), d.document.title = r.filename), d || "undefined" == typeof safari) return d;
                break;
            case "datauri":
            case "dataurl":
                return $970c7ddf83730f06$var$t.document.location.href = this.output("datauristring", r);
            default:
                return null;
        }
    }), De = function(t) {
        return !0 === Array.isArray(Et) && Et.indexOf(t) > -1;
    };
    switch(a){
        case "pt":
            Nt = 1;
            break;
        case "mm":
            Nt = 72 / 25.4;
            break;
        case "cm":
            Nt = 72 / 2.54;
            break;
        case "in":
            Nt = 72;
            break;
        case "px":
            Nt = 1 == De("px_scaling") ? .75 : 96 / 72;
            break;
        case "pc":
        case "em":
            Nt = 12;
            break;
        case "ex":
            Nt = 6;
            break;
        default:
            throw new Error("Invalid unit: " + a);
    }
    V(), z();
    var Ue = L.__private__.getPageInfo = L.getPageInfo = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
        return {
            objId: Ot[t].objId,
            pageNumber: t,
            pageContext: Ot[t]
        };
    }, ze = L.__private__.getPageInfoByObjId = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
        for(var e in Ot)if (Ot[e].objId === t) break;
        return Ue(e);
    }, He = L.__private__.getCurrentPageInfo = L.getCurrentPageInfo = function() {
        return {
            objId: Ot[Y].objId,
            pageNumber: Y,
            pageContext: Ot[Y]
        };
    };
    L.addPage = function() {
        return Pe.apply(this, arguments), this;
    }, L.setPage = function() {
        return Fe.apply(this, arguments), at.call(this, et[Y]), this;
    }, L.insertPage = function(t) {
        return this.addPage(), this.movePage(Y, t), this;
    }, L.movePage = function(t, e) {
        var n, r;
        if (t > e) {
            n = et[t], r = Ot[t];
            for(var i = t; i > e; i--)et[i] = et[i - 1], Ot[i] = Ot[i - 1];
            et[e] = n, Ot[e] = r, this.setPage(e);
        } else if (t < e) {
            n = et[t], r = Ot[t];
            for(var a = t; a < e; a++)et[a] = et[a + 1], Ot[a] = Ot[a + 1];
            et[e] = n, Ot[e] = r, this.setPage(e);
        }
        return this;
    }, L.deletePage = function() {
        return ke.apply(this, arguments), this;
    }, L.__private__.text = L.text = function(t, e, n, r, i) {
        var a, o, s, u, c, h, l, f, d = (r = r || {}).scope || this;
        if ("number" == typeof t && "number" == typeof e && ("string" == typeof n || Array.isArray(n))) {
            var p = n;
            n = e, e = t, t = p;
        }
        if (arguments[3] instanceof Dt == !1 ? (s = arguments[4], u = arguments[5], "object" == typeof (l = arguments[3]) && null !== l || ("string" == typeof s && (u = s, s = null), "string" == typeof l && (u = l, l = null), "number" == typeof l && (s = l, l = null), r = {
            flags: l,
            angle: s,
            align: u
        })) : (j("The transform parameter of text() with a Matrix value"), f = i), isNaN(e) || isNaN(n) || null == t) throw new Error("Invalid arguments passed to jsPDF.text");
        if (0 === t.length) return d;
        var g = "", m = !1, v = "number" == typeof r.lineHeightFactor ? r.lineHeightFactor : rn, b = d.internal.scaleFactor;
        function y(t) {
            return t = t.split("	").join(Array(r.TabLen || 9).join(" ")), _e(t, l);
        }
        function w(t) {
            for(var e, n = t.concat(), r = [], i = n.length; i--;)"string" == typeof (e = n.shift()) ? r.push(e) : Array.isArray(t) && (1 === e.length || void 0 === e[1] && void 0 === e[2]) ? r.push(e[0]) : r.push([
                e[0],
                e[1],
                e[2]
            ]);
            return r;
        }
        function L(t, e) {
            var n;
            if ("string" == typeof t) n = e(t)[0];
            else if (Array.isArray(t)) {
                for(var r, i, a = t.concat(), o = [], s = a.length; s--;)"string" == typeof (r = a.shift()) ? o.push(e(r)[0]) : Array.isArray(r) && "string" == typeof r[0] && (i = e(r[0], r[1], r[2]), o.push([
                    i[0],
                    i[1],
                    i[2]
                ]));
                n = o;
            }
            return n;
        }
        var x = !1, A = !0;
        if ("string" == typeof t) x = !0;
        else if (Array.isArray(t)) {
            var _ = t.concat();
            o = [];
            for(var S, F = _.length; F--;)("string" != typeof (S = _.shift()) || Array.isArray(S) && "string" != typeof S[0]) && (A = !1);
            x = A;
        }
        if (!1 === x) throw new Error('Type of text must be string or Array. "' + t + '" is not recognized.');
        "string" == typeof t && (t = t.match(/[\r?\n]/) ? t.split(/\r\n|\r|\n/g) : [
            t
        ]);
        var I = ht / d.internal.scaleFactor, B = I * (rn - 1);
        switch(r.baseline){
            case "bottom":
                n -= B;
                break;
            case "top":
                n += I - B;
                break;
            case "hanging":
                n += I - 2 * B;
                break;
            case "middle":
                n += I / 2 - B;
        }
        if ((h = r.maxWidth || 0) > 0 && ("string" == typeof t ? t = d.splitTextToSize(t, h) : "[object Array]" === Object.prototype.toString.call(t) && (t = d.splitTextToSize(t.join(" "), h))), a = {
            text: t,
            x: e,
            y: n,
            options: r,
            mutex: {
                pdfEscape: _e,
                activeFontKey: wt,
                fonts: _t,
                activeFontSize: ht
            }
        }, Mt.publish("preProcessText", a), t = a.text, s = (r = a.options).angle, f instanceof Dt == !1 && s && "number" == typeof s) {
            s *= Math.PI / 180, 0 === r.rotationDirection && (s = -s), k === P.ADVANCED && (s = -s);
            var O = Math.cos(s), M = Math.sin(s);
            f = new Dt(O, M, -M, O, 0, 0);
        } else s && s instanceof Dt && (f = s);
        k !== P.ADVANCED || f || (f = zt), void 0 !== (c = r.charSpace || bn) && (g += C(E(c)) + " Tc\n", this.setCharSpace(this.getCharSpace() || 0));
        r.lang;
        var q = -1, R = void 0 !== r.renderingMode ? r.renderingMode : r.stroke, T = d.internal.getCurrentPageInfo().pageContext;
        switch(R){
            case 0:
            case !1:
            case "fill":
                q = 0;
                break;
            case 1:
            case !0:
            case "stroke":
                q = 1;
                break;
            case 2:
            case "fillThenStroke":
                q = 2;
                break;
            case 3:
            case "invisible":
                q = 3;
                break;
            case 4:
            case "fillAndAddForClipping":
                q = 4;
                break;
            case 5:
            case "strokeAndAddPathForClipping":
                q = 5;
                break;
            case 6:
            case "fillThenStrokeAndAddToPathForClipping":
                q = 6;
                break;
            case 7:
            case "addToPathForClipping":
                q = 7;
        }
        var D = void 0 !== T.usedRenderingMode ? T.usedRenderingMode : -1;
        -1 !== q ? g += q + " Tr\n" : -1 !== D && (g += "0 Tr\n"), -1 !== q && (T.usedRenderingMode = q), u = r.align || "left";
        var U, z = ht * v, H = d.internal.pageSize.getWidth(), W = _t[wt];
        c = r.charSpace || bn, h = r.maxWidth || 0, l = {};
        var V = [];
        if ("[object Array]" === Object.prototype.toString.call(t)) {
            var G;
            o = w(t), "left" !== u && (U = o.map(function(t) {
                return d.getStringUnitWidth(t, {
                    font: W,
                    charSpace: c,
                    fontSize: ht,
                    doKerning: !1
                }) * ht / b;
            }));
            var Y, J = 0;
            if ("right" === u) {
                e -= U[0], t = [], F = o.length;
                for(var X = 0; X < F; X++)0 === X ? (Y = hn(e), G = ln(n)) : (Y = E(J - U[X]), G = -z), t.push([
                    o[X],
                    Y,
                    G
                ]), J = U[X];
            } else if ("center" === u) {
                e -= U[0] / 2, t = [], F = o.length;
                for(var K = 0; K < F; K++)0 === K ? (Y = hn(e), G = ln(n)) : (Y = E((J - U[K]) / 2), G = -z), t.push([
                    o[K],
                    Y,
                    G
                ]), J = U[K];
            } else if ("left" === u) {
                t = [], F = o.length;
                for(var Z = 0; Z < F; Z++)t.push(o[Z]);
            } else {
                if ("justify" !== u) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
                t = [], F = o.length, h = 0 !== h ? h : H;
                for(var $ = 0; $ < F; $++)G = 0 === $ ? ln(n) : -z, Y = 0 === $ ? hn(e) : 0, $ < F - 1 && V.push(C(E((h - U[$]) / (o[$].split(" ").length - 1)))), t.push([
                    o[$],
                    Y,
                    G
                ]);
            }
        }
        var Q = "boolean" == typeof r.R2L ? r.R2L : dt;
        !0 === Q && (t = L(t, function(t, e, n) {
            return [
                t.split("").reverse().join(""),
                e,
                n
            ];
        })), a = {
            text: t,
            x: e,
            y: n,
            options: r,
            mutex: {
                pdfEscape: _e,
                activeFontKey: wt,
                fonts: _t,
                activeFontSize: ht
            }
        }, Mt.publish("postProcessText", a), t = a.text, m = a.mutex.isHex || !1;
        var tt = _t[wt].encoding;
        "WinAnsiEncoding" !== tt && "StandardEncoding" !== tt || (t = L(t, function(t, e, n) {
            return [
                y(t),
                e,
                n
            ];
        })), o = w(t), t = [];
        for(var et, nt, rt, it = 0, at = 1, st = Array.isArray(o[0]) ? at : it, ut = "", ct = function(t, e, n) {
            var i = "";
            return n instanceof Dt ? (n = "number" == typeof r.angle ? Ut(n, new Dt(1, 0, 0, 1, t, e)) : Ut(new Dt(1, 0, 0, 1, t, e), n), k === P.ADVANCED && (n = Ut(new Dt(1, 0, 0, -1, 0, 0), n)), i = n.join(" ") + " Tm\n") : i = C(t) + " " + C(e) + " Td\n", i;
        }, lt = 0; lt < o.length; lt++){
            switch(ut = "", st){
                case at:
                    rt = (m ? "<" : "(") + o[lt][0] + (m ? ">" : ")"), et = parseFloat(o[lt][1]), nt = parseFloat(o[lt][2]);
                    break;
                case it:
                    rt = (m ? "<" : "(") + o[lt] + (m ? ">" : ")"), et = hn(e), nt = ln(n);
            }
            void 0 !== V && void 0 !== V[lt] && (ut = V[lt] + " Tw\n"), 0 === lt ? t.push(ut + ct(et, nt, f) + rt) : st === it ? t.push(ut + rt) : st === at && t.push(ut + ct(et, nt, f) + rt);
        }
        t = st === it ? t.join(" Tj\nT* ") : t.join(" Tj\n"), t += " Tj\n";
        var ft = "BT\n/";
        return ft += wt + " " + ht + " Tf\n", ft += C(ht * v) + " TL\n", ft += mn + "\n", ft += g, ft += t, ot(ft += "ET"), N[wt] = !0, d;
    };
    var We = L.__private__.clip = L.clip = function(t) {
        return ot("evenodd" === t ? "W*" : "W"), this;
    };
    L.clipEvenOdd = function() {
        return We("evenodd");
    }, L.__private__.discardPath = L.discardPath = function() {
        return ot("n"), this;
    };
    var Ve = L.__private__.isValidStyle = function(t) {
        var e = !1;
        return -1 !== [
            void 0,
            null,
            "S",
            "D",
            "F",
            "DF",
            "FD",
            "f",
            "f*",
            "B",
            "B*",
            "n"
        ].indexOf(t) && (e = !0), e;
    };
    L.__private__.setDefaultPathOperation = L.setDefaultPathOperation = function(t) {
        return Ve(t) && (y = t), this;
    };
    var Ge = L.__private__.getStyle = L.getStyle = function(t) {
        var e = y;
        switch(t){
            case "D":
            case "S":
                e = "S";
                break;
            case "F":
                e = "f";
                break;
            case "FD":
            case "DF":
                e = "B";
                break;
            case "f":
            case "f*":
            case "B":
            case "B*":
                e = t;
        }
        return e;
    }, Ye = L.close = function() {
        return ot("h"), this;
    };
    L.stroke = function() {
        return ot("S"), this;
    }, L.fill = function(t) {
        return Je("f", t), this;
    }, L.fillEvenOdd = function(t) {
        return Je("f*", t), this;
    }, L.fillStroke = function(t) {
        return Je("B", t), this;
    }, L.fillStrokeEvenOdd = function(t) {
        return Je("B*", t), this;
    };
    var Je = function(t, e) {
        "object" == typeof e ? Ze(e, t) : ot(t);
    }, Xe = function(t) {
        null === t || k === P.ADVANCED && void 0 === t || (t = Ge(t), ot(t));
    };
    function Ke(t, e, n, r, i) {
        var a = new $970c7ddf83730f06$export$549f717800d2b57f(e || this.boundingBox, n || this.xStep, r || this.yStep, this.gState, i || this.matrix);
        a.stream = this.stream;
        var o = t + "$$" + this.cloneIndex++ + "$$";
        return Ht(o, a), a;
    }
    var Ze = function(t, e) {
        var n = Ft[t.key], r = kt[n];
        if (r instanceof $970c7ddf83730f06$export$7235f0ad083cb4c6) ot("q"), ot($e(e)), r.gState && L.setGState(r.gState), ot(t.matrix.toString() + " cm"), ot("/" + n + " sh"), ot("Q");
        else if (r instanceof $970c7ddf83730f06$export$549f717800d2b57f) {
            var i = new Dt(1, 0, 0, -1, 0, Cn());
            t.matrix && (i = i.multiply(t.matrix || zt), n = Ke.call(r, t.key, t.boundingBox, t.xStep, t.yStep, i).id), ot("q"), ot("/Pattern cs"), ot("/" + n + " scn"), r.gState && L.setGState(r.gState), ot(e), ot("Q");
        }
    }, $e = function(t) {
        switch(t){
            case "f":
            case "F":
                return "W n";
            case "f*":
                return "W* n";
            case "B":
                return "W S";
            case "B*":
                return "W* S";
            case "S":
                return "W S";
            case "n":
                return "W n";
        }
    }, Qe = L.moveTo = function(t, e) {
        return ot(C(E(t)) + " " + C(R(e)) + " m"), this;
    }, tn = L.lineTo = function(t, e) {
        return ot(C(E(t)) + " " + C(R(e)) + " l"), this;
    }, en = L.curveTo = function(t, e, n, r, i, a) {
        return ot([
            C(E(t)),
            C(R(e)),
            C(E(n)),
            C(R(r)),
            C(E(i)),
            C(R(a)),
            "c"
        ].join(" ")), this;
    };
    L.__private__.line = L.line = function(t, e, n, r, i) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || !Ve(i)) throw new Error("Invalid arguments passed to jsPDF.line");
        return k === P.COMPAT ? this.lines([
            [
                n - t,
                r - e
            ]
        ], t, e, [
            1,
            1
        ], i || "S") : this.lines([
            [
                n - t,
                r - e
            ]
        ], t, e, [
            1,
            1
        ]).stroke();
    }, L.__private__.lines = L.lines = function(t, e, n, r, i, a) {
        var o, s, u, c, h, l, f, d, p, g, m, v;
        if ("number" == typeof t && (v = n, n = e, e = t, t = v), r = r || [
            1,
            1
        ], a = a || !1, isNaN(e) || isNaN(n) || !Array.isArray(t) || !Array.isArray(r) || !Ve(i) || "boolean" != typeof a) throw new Error("Invalid arguments passed to jsPDF.lines");
        for(Qe(e, n), o = r[0], s = r[1], c = t.length, g = e, m = n, u = 0; u < c; u++)2 === (h = t[u]).length ? (g = h[0] * o + g, m = h[1] * s + m, tn(g, m)) : (l = h[0] * o + g, f = h[1] * s + m, d = h[2] * o + g, p = h[3] * s + m, g = h[4] * o + g, m = h[5] * s + m, en(l, f, d, p, g, m));
        return a && Ye(), Xe(i), this;
    }, L.path = function(t) {
        for(var e = 0; e < t.length; e++){
            var n = t[e], r = n.c;
            switch(n.op){
                case "m":
                    Qe(r[0], r[1]);
                    break;
                case "l":
                    tn(r[0], r[1]);
                    break;
                case "c":
                    en.apply(this, r);
                    break;
                case "h":
                    Ye();
            }
        }
        return this;
    }, L.__private__.rect = L.rect = function(t, e, n, r, i) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || !Ve(i)) throw new Error("Invalid arguments passed to jsPDF.rect");
        return k === P.COMPAT && (r = -r), ot([
            C(E(t)),
            C(R(e)),
            C(E(n)),
            C(E(r)),
            "re"
        ].join(" ")), Xe(i), this;
    }, L.__private__.triangle = L.triangle = function(t, e, n, r, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(a) || !Ve(o)) throw new Error("Invalid arguments passed to jsPDF.triangle");
        return this.lines([
            [
                n - t,
                r - e
            ],
            [
                i - n,
                a - r
            ],
            [
                t - i,
                e - a
            ]
        ], t, e, [
            1,
            1
        ], o, !0), this;
    }, L.__private__.roundedRect = L.roundedRect = function(t, e, n, r, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(a) || !Ve(o)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
        var s = 4 / 3 * (Math.SQRT2 - 1);
        return i = Math.min(i, .5 * n), a = Math.min(a, .5 * r), this.lines([
            [
                n - 2 * i,
                0
            ],
            [
                i * s,
                0,
                i,
                a - a * s,
                i,
                a
            ],
            [
                0,
                r - 2 * a
            ],
            [
                0,
                a * s,
                -i * s,
                a,
                -i,
                a
            ],
            [
                2 * i - n,
                0
            ],
            [
                -i * s,
                0,
                -i,
                -a * s,
                -i,
                -a
            ],
            [
                0,
                2 * a - r
            ],
            [
                0,
                -a * s,
                i * s,
                -a,
                i,
                -a
            ]
        ], t + i, e, [
            1,
            1
        ], o, !0), this;
    }, L.__private__.ellipse = L.ellipse = function(t, e, n, r, i) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || !Ve(i)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
        var a = 4 / 3 * (Math.SQRT2 - 1) * n, o = 4 / 3 * (Math.SQRT2 - 1) * r;
        return Qe(t + n, e), en(t + n, e - o, t + a, e - r, t, e - r), en(t - a, e - r, t - n, e - o, t - n, e), en(t - n, e + o, t - a, e + r, t, e + r), en(t + a, e + r, t + n, e + o, t + n, e), Xe(i), this;
    }, L.__private__.circle = L.circle = function(t, e, n, r) {
        if (isNaN(t) || isNaN(e) || isNaN(n) || !Ve(r)) throw new Error("Invalid arguments passed to jsPDF.circle");
        return this.ellipse(t, e, n, n, r);
    }, L.setFont = function(t, e) {
        return wt = Ce(t, e, {
            disableWarning: !1
        }), this;
    };
    var nn = L.__private__.getFont = L.getFont = function() {
        return _t[Ce.apply(L, arguments)];
    };
    L.__private__.getFontList = L.getFontList = function() {
        var t, e, n = {};
        for(t in St)if (St.hasOwnProperty(t)) for(e in n[t] = [], St[t])St[t].hasOwnProperty(e) && n[t].push(e);
        return n;
    }, L.addFont = function(t, e, n, r) {
        return r = r || "Identity-H", Ne.call(this, t, e, n, r);
    };
    var rn, an = e.lineWidth || .200025, on = L.__private__.setLineWidth = L.setLineWidth = function(t) {
        return ot(C(E(t)) + " w"), this;
    };
    L.__private__.setLineDash = $970c7ddf83730f06$export$ba1e2ffc633a60f5.API.setLineDash = $970c7ddf83730f06$export$ba1e2ffc633a60f5.API.setLineDashPattern = function(t, e) {
        if (t = t || [], e = e || 0, isNaN(e) || !Array.isArray(t)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
        return t = t.map(function(t) {
            return C(E(t));
        }).join(" "), e = C(E(e)), ot("[" + t + "] " + e + " d"), this;
    };
    var sn = L.__private__.getLineHeight = L.getLineHeight = function() {
        return ht * rn;
    };
    L.__private__.getLineHeight = L.getLineHeight = function() {
        return ht * rn;
    };
    var un = L.__private__.setLineHeightFactor = L.setLineHeightFactor = function(t) {
        return "number" == typeof (t = t || 1.15) && (rn = t), this;
    }, cn = L.__private__.getLineHeightFactor = L.getLineHeightFactor = function() {
        return rn;
    };
    un(e.lineHeight);
    var hn = L.__private__.getHorizontalCoordinate = function(t) {
        return E(t);
    }, ln = L.__private__.getVerticalCoordinate = function(t) {
        return k === P.ADVANCED ? t : Ot[Y].mediaBox.topRightY - Ot[Y].mediaBox.bottomLeftY - E(t);
    }, fn = L.__private__.getHorizontalCoordinateString = L.getHorizontalCoordinateString = function(t) {
        return C(hn(t));
    }, dn = L.__private__.getVerticalCoordinateString = L.getVerticalCoordinateString = function(t) {
        return C(ln(t));
    }, pn = e.strokeColor || "0 G";
    L.__private__.getStrokeColor = L.getDrawColor = function() {
        return Kt(pn);
    }, L.__private__.setStrokeColor = L.setDrawColor = function(t, e, n, r) {
        return pn = Zt({
            ch1: t,
            ch2: e,
            ch3: n,
            ch4: r,
            pdfColorType: "draw",
            precision: 2
        }), ot(pn), this;
    };
    var gn = e.fillColor || "0 g";
    L.__private__.getFillColor = L.getFillColor = function() {
        return Kt(gn);
    }, L.__private__.setFillColor = L.setFillColor = function(t, e, n, r) {
        return gn = Zt({
            ch1: t,
            ch2: e,
            ch3: n,
            ch4: r,
            pdfColorType: "fill",
            precision: 2
        }), ot(gn), this;
    };
    var mn = e.textColor || "0 g", vn = L.__private__.getTextColor = L.getTextColor = function() {
        return Kt(mn);
    };
    L.__private__.setTextColor = L.setTextColor = function(t, e, n, r) {
        return mn = Zt({
            ch1: t,
            ch2: e,
            ch3: n,
            ch4: r,
            pdfColorType: "text",
            precision: 3
        }), this;
    };
    var bn = e.charSpace, yn = L.__private__.getCharSpace = L.getCharSpace = function() {
        return parseFloat(bn || 0);
    };
    L.__private__.setCharSpace = L.setCharSpace = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
        return bn = t, this;
    };
    var wn = 0;
    L.CapJoinStyles = {
        0: 0,
        butt: 0,
        but: 0,
        miter: 0,
        1: 1,
        round: 1,
        rounded: 1,
        circle: 1,
        2: 2,
        projecting: 2,
        project: 2,
        square: 2,
        bevel: 2
    }, L.__private__.setLineCap = L.setLineCap = function(t) {
        var e = L.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return wn = e, ot(e + " J"), this;
    };
    var Nn = 0;
    L.__private__.setLineJoin = L.setLineJoin = function(t) {
        var e = L.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return Nn = e, ot(e + " j"), this;
    }, L.__private__.setLineMiterLimit = L.__private__.setMiterLimit = L.setLineMiterLimit = L.setMiterLimit = function(t) {
        if (t = t || 0, isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
        return ot(C(E(t)) + " M"), this;
    }, L.GState = $970c7ddf83730f06$export$1bc649ab427a02ba, L.setGState = function(t) {
        (t = "string" == typeof t ? It[Ct[t]] : Ln(null, t)).equals(jt) || (ot("/" + t.id + " gs"), jt = t);
    };
    var Ln = function(t, e) {
        if (!t || !Ct[t]) {
            var n = !1;
            for(var r in It)if (It.hasOwnProperty(r) && It[r].equals(e)) {
                n = !0;
                break;
            }
            if (n) e = It[r];
            else {
                var i = "GS" + (Object.keys(It).length + 1).toString(10);
                It[i] = e, e.id = i;
            }
            return t && (Ct[t] = e.id), Mt.publish("addGState", e), e;
        }
    };
    L.addGState = function(t, e) {
        return Ln(t, e), this;
    }, L.saveGraphicsState = function() {
        return ot("q"), Pt.push({
            key: wt,
            size: ht,
            color: mn
        }), this;
    }, L.restoreGraphicsState = function() {
        ot("Q");
        var t = Pt.pop();
        return wt = t.key, ht = t.size, mn = t.color, jt = null, this;
    }, L.setCurrentTransformationMatrix = function(t) {
        return ot(t.toString() + " cm"), this;
    }, L.comment = function(t) {
        return ot("#" + t), this;
    };
    var xn = function(t, e) {
        var n = t || 0;
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                isNaN(t) || (n = parseFloat(t));
            }
        });
        var r = e || 0;
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                isNaN(t) || (r = parseFloat(t));
            }
        });
        var i = "pt";
        return Object.defineProperty(this, "type", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t.toString();
            }
        }), this;
    }, An = function(t, e, n, r) {
        xn.call(this, t, e), this.type = "rect";
        var i = n || 0;
        Object.defineProperty(this, "w", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = parseFloat(t));
            }
        });
        var a = r || 0;
        return Object.defineProperty(this, "h", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = parseFloat(t));
            }
        }), this;
    }, _n = function() {
        this.page = Bt, this.currentPage = Y, this.pages = et.slice(0), this.pagesContext = Ot.slice(0), this.x = Lt, this.y = xt, this.matrix = At, this.width = Fn(Y), this.height = Cn(Y), this.outputDestination = rt, this.id = "", this.objectNumber = -1;
    };
    _n.prototype.restore = function() {
        Bt = this.page, Y = this.currentPage, Ot = this.pagesContext, et = this.pages, Lt = this.x, xt = this.y, At = this.matrix, In(Y, this.width), jn(Y, this.height), rt = this.outputDestination;
    };
    var Sn = function(t, e, n, r, i) {
        Tt.push(new _n), Bt = Y = 0, et = [], Lt = t, xt = e, At = i, Se([
            n,
            r
        ]);
    }, Pn = function(t) {
        if (!Rt[t]) {
            var e = new _n, n = "Xo" + (Object.keys(qt).length + 1).toString(10);
            e.id = n, Rt[t] = n, qt[n] = e, Mt.publish("addFormObject", e), Tt.pop().restore();
        }
    };
    for(var kn in L.beginFormObject = function(t, e, n, r, i) {
        return Sn(t, e, n, r, i), this;
    }, L.endFormObject = function(t) {
        return Pn(t), this;
    }, L.doFormObject = function(t, e) {
        var n = qt[Rt[t]];
        return ot("q"), ot(e.toString() + " cm"), ot("/" + n.id + " Do"), ot("Q"), this;
    }, L.getFormObject = function(t) {
        var e = qt[Rt[t]];
        return {
            x: e.x,
            y: e.y,
            width: e.width,
            height: e.height,
            matrix: e.matrix
        };
    }, L.save = function(e, n) {
        return e = e || "generated.pdf", (n = n || {}).returnPromise = n.returnPromise || !1, !1 === n.returnPromise ? ($970c7ddf83730f06$var$u(Re(qe()), e), "function" == typeof $970c7ddf83730f06$var$u.unload && $970c7ddf83730f06$var$t.setTimeout && setTimeout($970c7ddf83730f06$var$u.unload, 911), this) : new Promise(function(n, r) {
            try {
                var i = $970c7ddf83730f06$var$u(Re(qe()), e);
                "function" == typeof $970c7ddf83730f06$var$u.unload && $970c7ddf83730f06$var$t.setTimeout && setTimeout($970c7ddf83730f06$var$u.unload, 911), n(i);
            } catch (t) {
                r(t.message);
            }
        });
    }, $970c7ddf83730f06$export$ba1e2ffc633a60f5.API)$970c7ddf83730f06$export$ba1e2ffc633a60f5.API.hasOwnProperty(kn) && ("events" === kn && $970c7ddf83730f06$export$ba1e2ffc633a60f5.API.events.length ? function(t, e) {
        var n, r, i;
        for(i = e.length - 1; -1 !== i; i--)n = e[i][0], r = e[i][1], t.subscribe.apply(t, [
            n
        ].concat("function" == typeof r ? [
            r
        ] : r));
    }(Mt, $970c7ddf83730f06$export$ba1e2ffc633a60f5.API.events) : L[kn] = $970c7ddf83730f06$export$ba1e2ffc633a60f5.API[kn]);
    var Fn = L.getPageWidth = function(t) {
        return (Ot[t = t || Y].mediaBox.topRightX - Ot[t].mediaBox.bottomLeftX) / Nt;
    }, In = L.setPageWidth = function(t, e) {
        Ot[t].mediaBox.topRightX = e * Nt + Ot[t].mediaBox.bottomLeftX;
    }, Cn = L.getPageHeight = function(t) {
        return (Ot[t = t || Y].mediaBox.topRightY - Ot[t].mediaBox.bottomLeftY) / Nt;
    }, jn = L.setPageHeight = function(t, e) {
        Ot[t].mediaBox.topRightY = e * Nt + Ot[t].mediaBox.bottomLeftY;
    };
    return L.internal = {
        pdfEscape: _e,
        getStyle: Ge,
        getFont: nn,
        getFontSize: ft,
        getCharSpace: yn,
        getTextColor: vn,
        getLineHeight: sn,
        getLineHeightFactor: cn,
        write: st,
        getHorizontalCoordinate: hn,
        getVerticalCoordinate: ln,
        getCoordinateString: fn,
        getVerticalCoordinateString: dn,
        collections: {},
        newObject: Wt,
        newAdditionalObject: Yt,
        newObjectDeferred: Vt,
        newObjectDeferredBegin: Gt,
        getFilters: $t,
        putStream: Qt,
        events: Mt,
        scaleFactor: Nt,
        pageSize: {
            getWidth: function() {
                return Fn(Y);
            },
            setWidth: function(t) {
                In(Y, t);
            },
            getHeight: function() {
                return Cn(Y);
            },
            setHeight: function(t) {
                jn(Y, t);
            }
        },
        output: Te,
        getNumberOfPages: Ie,
        pages: et,
        out: ot,
        f2: O,
        f3: M,
        getPageInfo: Ue,
        getPageInfoByObjId: ze,
        getCurrentPageInfo: He,
        getPDFVersion: A,
        Point: xn,
        Rectangle: An,
        Matrix: Dt,
        hasHotfix: De
    }, Object.defineProperty(L.internal.pageSize, "width", {
        get: function() {
            return Fn(Y);
        },
        set: function(t) {
            In(Y, t);
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(L.internal.pageSize, "height", {
        get: function() {
            return Cn(Y);
        },
        set: function(t) {
            jn(Y, t);
        },
        enumerable: !0,
        configurable: !0
    }), Le.call(L, ct), wt = "F1", Pe(o, i), Mt.publish("initialized"), L;
}
$970c7ddf83730f06$var$o = $970c7ddf83730f06$var$t.atob, $970c7ddf83730f06$var$s = $970c7ddf83730f06$var$t.btoa, $970c7ddf83730f06$export$1bc649ab427a02ba.prototype.equals = function(t) {
    var e, n = "id,objectNumber,equals";
    if (!t || typeof t != typeof this) return !1;
    var r = 0;
    for(e in this)if (!(n.indexOf(e) >= 0)) {
        if (this.hasOwnProperty(e) && !t.hasOwnProperty(e)) return !1;
        if (this[e] !== t[e]) return !1;
        r++;
    }
    for(e in t)t.hasOwnProperty(e) && n.indexOf(e) < 0 && r--;
    return 0 === r;
}, $970c7ddf83730f06$export$ba1e2ffc633a60f5.API = {
    events: []
}, $970c7ddf83730f06$export$ba1e2ffc633a60f5.version = "2.1.0";
var $970c7ddf83730f06$var$m, $970c7ddf83730f06$var$v = $970c7ddf83730f06$export$ba1e2ffc633a60f5.API, $970c7ddf83730f06$var$b = 1, $970c7ddf83730f06$var$y = function(t) {
    return t.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, $970c7ddf83730f06$var$w = function(t) {
    return t.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, $970c7ddf83730f06$var$N = function(t) {
    return t.toFixed(2);
}, $970c7ddf83730f06$var$L = function(t) {
    return t.toFixed(5);
};
$970c7ddf83730f06$var$v.__acroform__ = {};
var $970c7ddf83730f06$var$x = function(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
}, $970c7ddf83730f06$var$A = function(t) {
    return t * $970c7ddf83730f06$var$b;
}, $970c7ddf83730f06$var$_ = function(t) {
    var e = new $970c7ddf83730f06$var$J, n = $970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t) || 0, r = $970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t) || 0;
    return e.BBox = [
        0,
        0,
        Number($970c7ddf83730f06$var$N(r)),
        Number($970c7ddf83730f06$var$N(n))
    ], e;
}, $970c7ddf83730f06$var$S = $970c7ddf83730f06$var$v.__acroform__.setBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
    return t |= 1 << e;
}, $970c7ddf83730f06$var$P = $970c7ddf83730f06$var$v.__acroform__.clearBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
    return t &= ~(1 << e);
}, $970c7ddf83730f06$var$k = $970c7ddf83730f06$var$v.__acroform__.getBit = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
    return 0 == (t & 1 << e) ? 0 : 1;
}, $970c7ddf83730f06$var$F = $970c7ddf83730f06$var$v.__acroform__.getBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
    return $970c7ddf83730f06$var$k(t, e - 1);
}, $970c7ddf83730f06$var$I = $970c7ddf83730f06$var$v.__acroform__.setBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
    return $970c7ddf83730f06$var$S(t, e - 1);
}, $970c7ddf83730f06$var$C = $970c7ddf83730f06$var$v.__acroform__.clearBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
    return $970c7ddf83730f06$var$P(t, e - 1);
}, $970c7ddf83730f06$var$j = $970c7ddf83730f06$var$v.__acroform__.calculateCoordinates = function(t) {
    var e = this.internal.getHorizontalCoordinate, n = this.internal.getVerticalCoordinate, r = t[0], i = t[1], a = t[2], o = t[3], s = {};
    return s.lowerLeft_X = e(r) || 0, s.lowerLeft_Y = n(i + o) || 0, s.upperRight_X = e(r + a) || 0, s.upperRight_Y = n(i) || 0, [
        Number($970c7ddf83730f06$var$N(s.lowerLeft_X)),
        Number($970c7ddf83730f06$var$N(s.lowerLeft_Y)),
        Number($970c7ddf83730f06$var$N(s.upperRight_X)),
        Number($970c7ddf83730f06$var$N(s.upperRight_Y))
    ];
}, $970c7ddf83730f06$var$B = function(t) {
    if (t.appearanceStreamContent) return t.appearanceStreamContent;
    if (t.V || t.DV) {
        var e = [], n = t.V || t.DV, r = $970c7ddf83730f06$var$O(t, n), i = $970c7ddf83730f06$var$m.internal.getFont(t.fontName, t.fontStyle).id;
        e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push($970c7ddf83730f06$var$m.__private__.encodeColorString(t.color)), e.push("/" + i + " " + $970c7ddf83730f06$var$N(r.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(r.text), e.push("ET"), e.push("Q"), e.push("EMC");
        var a = new $970c7ddf83730f06$var$_(t);
        return a.stream = e.join("\n"), a;
    }
}, $970c7ddf83730f06$var$O = function(t, e) {
    var n = 0 === t.fontSize ? t.maxFontSize : t.fontSize, r = {
        text: "",
        fontSize: ""
    }, i = (e = ")" == (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(e.length - 1) ? e.substr(0, e.length - 1) : e).split(" "), a = n, o = $970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t) || 0;
    o = o < 0 ? -o : o;
    var s = $970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t) || 0;
    s = s < 0 ? -s : s;
    var u = function(e, n, r) {
        if (e + 1 < i.length) {
            var a = n + " " + i[e + 1];
            return $970c7ddf83730f06$var$M(a, t, r).width <= s - 4;
        }
        return !1;
    };
    a++;
    t: for(; a > 0;){
        e = "", a--;
        var c, h, l = $970c7ddf83730f06$var$M("3", t, a).height, f = t.multiline ? o - a : (o - l) / 2, d = f += 2, p = 0, g = 0;
        if (a <= 0) {
            e = "(...) Tj\n", e += "% Width of Text: " + $970c7ddf83730f06$var$M(e, t, a = 12).width + ", FieldWidth:" + s + "\n";
            break;
        }
        var m = "", v = 0;
        for(var b in i)if (i.hasOwnProperty(b)) {
            m = " " == (m += i[b] + " ").substr(m.length - 1) ? m.substr(0, m.length - 1) : m;
            var w = parseInt(b), L = u(w, m, a), x = b >= i.length - 1;
            if (L && !x) {
                m += " ";
                continue;
            }
            if (L || x) {
                if (x) g = w;
                else if (t.multiline && (l + 2) * (v + 2) + 2 > o) continue t;
            } else {
                if (!t.multiline) continue t;
                if ((l + 2) * (v + 2) + 2 > o) continue t;
                g = w;
            }
            for(var A = "", _ = p; _ <= g; _++)A += i[_] + " ";
            switch(A = " " == A.substr(A.length - 1) ? A.substr(0, A.length - 1) : A, h = $970c7ddf83730f06$var$M(A, t, a).width, t.textAlign){
                case "right":
                    c = s - h - 2;
                    break;
                case "center":
                    c = (s - h) / 2;
                    break;
                case "left":
                default:
                    c = 2;
            }
            e += $970c7ddf83730f06$var$N(c) + " " + $970c7ddf83730f06$var$N(d) + " Td\n", e += "(" + $970c7ddf83730f06$var$y(A) + ") Tj\n", e += -$970c7ddf83730f06$var$N(c) + " 0 Td\n", d = -(a + 2), h = 0, p = g + 1, v++, m = "";
        }
        break;
    }
    return r.text = e, r.fontSize = a, r;
}, $970c7ddf83730f06$var$M = function(t, e, n) {
    var r = $970c7ddf83730f06$var$m.internal.getFont(e.fontName, e.fontStyle), i = $970c7ddf83730f06$var$m.getStringUnitWidth(t, {
        font: r,
        fontSize: parseFloat(n),
        charSpace: 0
    }) * parseFloat(n);
    return {
        height: $970c7ddf83730f06$var$m.getStringUnitWidth("3", {
            font: r,
            fontSize: parseFloat(n),
            charSpace: 0
        }) * parseFloat(n) * 1.5,
        width: i
    };
}, $970c7ddf83730f06$var$E = {
    fields: [],
    xForms: [],
    acroFormDictionaryRoot: null,
    printedOut: !1,
    internal: null,
    isInitialized: !1
}, $970c7ddf83730f06$var$q = function() {
    $970c7ddf83730f06$var$m.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
    var t = $970c7ddf83730f06$var$m.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
    for(var e in t)if (t.hasOwnProperty(e)) {
        var n = t[e];
        n.objId = void 0, n.hasAnnotation && $970c7ddf83730f06$var$T.call($970c7ddf83730f06$var$m, n);
    }
}, $970c7ddf83730f06$var$R = function(t) {
    $970c7ddf83730f06$var$m.internal.acroformPlugin.printedOut && ($970c7ddf83730f06$var$m.internal.acroformPlugin.printedOut = !1, $970c7ddf83730f06$var$m.internal.acroformPlugin.acroFormDictionaryRoot = null), $970c7ddf83730f06$var$m.internal.acroformPlugin.acroFormDictionaryRoot || $970c7ddf83730f06$var$W.call($970c7ddf83730f06$var$m), $970c7ddf83730f06$var$m.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t);
}, $970c7ddf83730f06$var$T = function(t) {
    var e = {
        type: "reference",
        object: t
    };
    void 0 === $970c7ddf83730f06$var$m.internal.getPageInfo(t.page).pageContext.annotations.find(function(t) {
        return t.type === e.type && t.object === e.object;
    }) && $970c7ddf83730f06$var$m.internal.getPageInfo(t.page).pageContext.annotations.push(e);
}, $970c7ddf83730f06$var$D = function() {
    if (void 0 === $970c7ddf83730f06$var$m.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("putCatalogCallback: Root missing.");
    $970c7ddf83730f06$var$m.internal.write("/AcroForm " + $970c7ddf83730f06$var$m.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
}, $970c7ddf83730f06$var$U = function() {
    $970c7ddf83730f06$var$m.internal.events.unsubscribe($970c7ddf83730f06$var$m.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete $970c7ddf83730f06$var$m.internal.acroformPlugin.acroFormDictionaryRoot._eventID, $970c7ddf83730f06$var$m.internal.acroformPlugin.printedOut = !0;
}, $970c7ddf83730f06$var$z = function(t) {
    var e = !t;
    for(var n in t || ($970c7ddf83730f06$var$m.internal.newObjectDeferredBegin($970c7ddf83730f06$var$m.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), $970c7ddf83730f06$var$m.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), t = t || $970c7ddf83730f06$var$m.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if (t.hasOwnProperty(n)) {
        var r = t[n], i = [], a = r.Rect;
        if (r.Rect && (r.Rect = $970c7ddf83730f06$var$j.call(this, r.Rect)), $970c7ddf83730f06$var$m.internal.newObjectDeferredBegin(r.objId, !0), r.DA = $970c7ddf83730f06$export$7d753ad993606f45.createDefaultAppearanceStream(r), "object" == typeof r && "function" == typeof r.getKeyValueListForStream && (i = r.getKeyValueListForStream()), r.Rect = a, r.hasAppearanceStream && !r.appearanceStreamContent) {
            var o = $970c7ddf83730f06$var$B.call(this, r);
            i.push({
                key: "AP",
                value: "<</N " + o + ">>"
            }), $970c7ddf83730f06$var$m.internal.acroformPlugin.xForms.push(o);
        }
        if (r.appearanceStreamContent) {
            var s = "";
            for(var u in r.appearanceStreamContent)if (r.appearanceStreamContent.hasOwnProperty(u)) {
                var c = r.appearanceStreamContent[u];
                if (s += "/" + u + " ", s += "<<", Object.keys(c).length >= 1 || Array.isArray(c)) {
                    for(var n in c)if (c.hasOwnProperty(n)) {
                        var h = c[n];
                        "function" == typeof h && (h = h.call(this, r)), s += "/" + n + " " + h + " ", $970c7ddf83730f06$var$m.internal.acroformPlugin.xForms.indexOf(h) >= 0 || $970c7ddf83730f06$var$m.internal.acroformPlugin.xForms.push(h);
                    }
                } else "function" == typeof (h = c) && (h = h.call(this, r)), s += "/" + n + " " + h, $970c7ddf83730f06$var$m.internal.acroformPlugin.xForms.indexOf(h) >= 0 || $970c7ddf83730f06$var$m.internal.acroformPlugin.xForms.push(h);
                s += ">>";
            }
            i.push({
                key: "AP",
                value: "<<\n" + s + ">>"
            });
        }
        $970c7ddf83730f06$var$m.internal.putStream({
            additionalKeyValues: i
        }), $970c7ddf83730f06$var$m.internal.out("endobj");
    }
    e && $970c7ddf83730f06$var$H.call(this, $970c7ddf83730f06$var$m.internal.acroformPlugin.xForms);
}, $970c7ddf83730f06$var$H = function(t) {
    for(var e in t)if (t.hasOwnProperty(e)) {
        var n = e, r = t[e];
        $970c7ddf83730f06$var$m.internal.newObjectDeferredBegin(r && r.objId, !0), "object" == typeof r && "function" == typeof r.putStream && r.putStream(), delete t[n];
    }
}, $970c7ddf83730f06$var$W = function() {
    if (void 0 !== this.internal && (void 0 === this.internal.acroformPlugin || !1 === this.internal.acroformPlugin.isInitialized)) {
        if ($970c7ddf83730f06$var$m = this, $970c7ddf83730f06$var$K.FieldNum = 0, this.internal.acroformPlugin = JSON.parse(JSON.stringify($970c7ddf83730f06$var$E)), this.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
        $970c7ddf83730f06$var$b = $970c7ddf83730f06$var$m.internal.scaleFactor, $970c7ddf83730f06$var$m.internal.acroformPlugin.acroFormDictionaryRoot = new $970c7ddf83730f06$var$X, $970c7ddf83730f06$var$m.internal.acroformPlugin.acroFormDictionaryRoot._eventID = $970c7ddf83730f06$var$m.internal.events.subscribe("postPutResources", $970c7ddf83730f06$var$U), $970c7ddf83730f06$var$m.internal.events.subscribe("buildDocument", $970c7ddf83730f06$var$q), $970c7ddf83730f06$var$m.internal.events.subscribe("putCatalog", $970c7ddf83730f06$var$D), $970c7ddf83730f06$var$m.internal.events.subscribe("postPutPages", $970c7ddf83730f06$var$z), $970c7ddf83730f06$var$m.internal.acroformPlugin.isInitialized = !0;
    }
}, $970c7ddf83730f06$var$V = $970c7ddf83730f06$var$v.__acroform__.arrayToPdfArray = function(t) {
    if (Array.isArray(t)) {
        for(var e = "[", n = 0; n < t.length; n++)switch(0 !== n && (e += " "), typeof t[n]){
            case "boolean":
            case "number":
            case "object":
                e += t[n].toString();
                break;
            case "string":
                "/" !== t[n].substr(0, 1) ? e += "(" + $970c7ddf83730f06$var$y(t[n].toString()) + ")" : e += t[n].toString();
        }
        return e += "]";
    }
    throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
};
var $970c7ddf83730f06$var$G = function(t) {
    return (t = t || "").toString(), t = "(" + $970c7ddf83730f06$var$y(t) + ")";
}, $970c7ddf83730f06$var$Y = function() {
    var t;
    Object.defineProperty(this, "objId", {
        configurable: !0,
        get: function() {
            return t || (t = $970c7ddf83730f06$var$m.internal.newObjectDeferred()), t;
        },
        set: function(e) {
            t = e;
        }
    });
};
$970c7ddf83730f06$var$Y.prototype.toString = function() {
    return this.objId + " 0 R";
}, $970c7ddf83730f06$var$Y.prototype.putStream = function() {
    var t = this.getKeyValueListForStream();
    $970c7ddf83730f06$var$m.internal.putStream({
        data: this.stream,
        additionalKeyValues: t
    }), $970c7ddf83730f06$var$m.internal.out("endobj");
}, $970c7ddf83730f06$var$Y.prototype.getKeyValueListForStream = function() {
    return function(t) {
        var e = [], n = Object.getOwnPropertyNames(t).filter(function(t) {
            return "content" != t && "appearanceStreamContent" != t && "_" != t.substring(0, 1);
        });
        for(var r in n)if (!1 === Object.getOwnPropertyDescriptor(t, n[r]).configurable) {
            var i = n[r], a = t[i];
            a && (Array.isArray(a) ? e.push({
                key: i,
                value: $970c7ddf83730f06$var$V(a)
            }) : a instanceof $970c7ddf83730f06$var$Y ? e.push({
                key: i,
                value: a.objId + " 0 R"
            }) : "function" != typeof a && e.push({
                key: i,
                value: a
            }));
        }
        return e;
    }(this);
};
var $970c7ddf83730f06$var$J = function() {
    $970c7ddf83730f06$var$Y.call(this), Object.defineProperty(this, "Type", {
        value: "/XObject",
        configurable: !1,
        writeable: !0
    }), Object.defineProperty(this, "Subtype", {
        value: "/Form",
        configurable: !1,
        writeable: !0
    }), Object.defineProperty(this, "FormType", {
        value: 1,
        configurable: !1,
        writeable: !0
    });
    var t, e = [];
    Object.defineProperty(this, "BBox", {
        configurable: !1,
        writeable: !0,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "Resources", {
        value: "2 0 R",
        configurable: !1,
        writeable: !0
    }), Object.defineProperty(this, "stream", {
        enumerable: !1,
        configurable: !0,
        set: function(e) {
            t = e.trim();
        },
        get: function() {
            return t || null;
        }
    });
};
$970c7ddf83730f06$var$x($970c7ddf83730f06$var$J, $970c7ddf83730f06$var$Y);
var $970c7ddf83730f06$var$X = function() {
    $970c7ddf83730f06$var$Y.call(this);
    var t, e = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return e.length > 0 ? e : void 0;
        }
    }), Object.defineProperty(this, "Fields", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        }
    }), Object.defineProperty(this, "DA", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (t) return "(" + t + ")";
        },
        set: function(e) {
            t = e;
        }
    });
};
$970c7ddf83730f06$var$x($970c7ddf83730f06$var$X, $970c7ddf83730f06$var$Y);
var $970c7ddf83730f06$var$K = function() {
    $970c7ddf83730f06$var$Y.call(this);
    var t = 4;
    Object.defineProperty(this, "F", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            if (isNaN(e)) throw new Error('Invalid value "' + e + '" for attribute F supplied.');
            t = e;
        }
    }), Object.defineProperty(this, "showWhenPrinted", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(t, 3));
        },
        set: function(e) {
            !0 === Boolean(e) ? this.F = $970c7ddf83730f06$var$I(t, 3) : this.F = $970c7ddf83730f06$var$C(t, 3);
        }
    });
    var e = 0;
    Object.defineProperty(this, "Ff", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute Ff supplied.');
            e = t;
        }
    });
    var n = [];
    Object.defineProperty(this, "Rect", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (0 !== n.length) return n;
        },
        set: function(t) {
            n = void 0 !== t ? t : [];
        }
    }), Object.defineProperty(this, "x", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[0]) ? 0 : n[0];
        },
        set: function(t) {
            n[0] = t;
        }
    }), Object.defineProperty(this, "y", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[1]) ? 0 : n[1];
        },
        set: function(t) {
            n[1] = t;
        }
    }), Object.defineProperty(this, "width", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[2]) ? 0 : n[2];
        },
        set: function(t) {
            n[2] = t;
        }
    }), Object.defineProperty(this, "height", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[3]) ? 0 : n[3];
        },
        set: function(t) {
            n[3] = t;
        }
    });
    var r = "";
    Object.defineProperty(this, "FT", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return r;
        },
        set: function(t) {
            switch(t){
                case "/Btn":
                case "/Tx":
                case "/Ch":
                case "/Sig":
                    r = t;
                    break;
                default:
                    throw new Error('Invalid value "' + t + '" for attribute FT supplied.');
            }
        }
    });
    var i = null;
    Object.defineProperty(this, "T", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!i || i.length < 1) {
                if (this instanceof $970c7ddf83730f06$var$it) return;
                i = "FieldObject" + $970c7ddf83730f06$var$K.FieldNum++;
            }
            return "(" + $970c7ddf83730f06$var$y(i) + ")";
        },
        set: function(t) {
            i = t.toString();
        }
    }), Object.defineProperty(this, "fieldName", {
        configurable: !0,
        enumerable: !0,
        get: function() {
            return i;
        },
        set: function(t) {
            i = t;
        }
    });
    var a = "helvetica";
    Object.defineProperty(this, "fontName", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return a;
        },
        set: function(t) {
            a = t;
        }
    });
    var o = "normal";
    Object.defineProperty(this, "fontStyle", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return o;
        },
        set: function(t) {
            o = t;
        }
    });
    var s = 0;
    Object.defineProperty(this, "fontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return s;
        },
        set: function(t) {
            s = t;
        }
    });
    var u = void 0;
    Object.defineProperty(this, "maxFontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return void 0 === u ? 50 / $970c7ddf83730f06$var$b : u;
        },
        set: function(t) {
            u = t;
        }
    });
    var c = "black";
    Object.defineProperty(this, "color", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return c;
        },
        set: function(t) {
            c = t;
        }
    });
    var h = "/F1 0 Tf 0 g";
    Object.defineProperty(this, "DA", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!(!h || this instanceof $970c7ddf83730f06$var$it || this instanceof $970c7ddf83730f06$export$9d1b52e7fab50c84)) return $970c7ddf83730f06$var$G(h);
        },
        set: function(t) {
            t = t.toString(), h = t;
        }
    });
    var l = null;
    Object.defineProperty(this, "DV", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (l) return this instanceof $970c7ddf83730f06$export$6aae594af76bbb7b == !1 ? $970c7ddf83730f06$var$G(l) : l;
        },
        set: function(t) {
            t = t.toString(), l = this instanceof $970c7ddf83730f06$export$6aae594af76bbb7b == !1 ? "(" === t.substr(0, 1) ? $970c7ddf83730f06$var$w(t.substr(1, t.length - 2)) : $970c7ddf83730f06$var$w(t) : t;
        }
    }), Object.defineProperty(this, "defaultValue", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof $970c7ddf83730f06$export$6aae594af76bbb7b == !0 ? $970c7ddf83730f06$var$w(l.substr(1, l.length - 1)) : l;
        },
        set: function(t) {
            t = t.toString(), l = this instanceof $970c7ddf83730f06$export$6aae594af76bbb7b == !0 ? "/" + t : t;
        }
    });
    var f = null;
    Object.defineProperty(this, "V", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (f) return this instanceof $970c7ddf83730f06$export$6aae594af76bbb7b == !1 ? $970c7ddf83730f06$var$G(f) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof $970c7ddf83730f06$export$6aae594af76bbb7b == !1 ? "(" === t.substr(0, 1) ? $970c7ddf83730f06$var$w(t.substr(1, t.length - 2)) : $970c7ddf83730f06$var$w(t) : t;
        }
    }), Object.defineProperty(this, "value", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof $970c7ddf83730f06$export$6aae594af76bbb7b == !0 ? $970c7ddf83730f06$var$w(f.substr(1, f.length - 1)) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof $970c7ddf83730f06$export$6aae594af76bbb7b == !0 ? "/" + t : t;
        }
    }), Object.defineProperty(this, "hasAnnotation", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.Rect;
        }
    }), Object.defineProperty(this, "Type", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Annot" : null;
        }
    }), Object.defineProperty(this, "Subtype", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Widget" : null;
        }
    });
    var d, p = !1;
    Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        writeable: !0,
        get: function() {
            return p;
        },
        set: function(t) {
            t = Boolean(t), p = t;
        }
    }), Object.defineProperty(this, "page", {
        enumerable: !0,
        configurable: !0,
        writeable: !0,
        get: function() {
            if (d) return d;
        },
        set: function(t) {
            d = t;
        }
    }), Object.defineProperty(this, "readOnly", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 1));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 1) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 1);
        }
    }), Object.defineProperty(this, "required", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 2));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 2) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 2);
        }
    }), Object.defineProperty(this, "noExport", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 3));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 3) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 3);
        }
    });
    var g = null;
    Object.defineProperty(this, "Q", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (null !== g) return g;
        },
        set: function(t) {
            if (-1 === [
                0,
                1,
                2
            ].indexOf(t)) throw new Error('Invalid value "' + t + '" for attribute Q supplied.');
            g = t;
        }
    }), Object.defineProperty(this, "textAlign", {
        get: function() {
            var t;
            switch(g){
                case 0:
                default:
                    t = "left";
                    break;
                case 1:
                    t = "center";
                    break;
                case 2:
                    t = "right";
            }
            return t;
        },
        configurable: !0,
        enumerable: !0,
        set: function(t) {
            switch(t){
                case "right":
                case 2:
                    g = 2;
                    break;
                case "center":
                case 1:
                    g = 1;
                    break;
                case "left":
                case 0:
                default:
                    g = 0;
            }
        }
    });
};
$970c7ddf83730f06$var$x($970c7ddf83730f06$var$K, $970c7ddf83730f06$var$Y);
var $970c7ddf83730f06$export$a47202eb3f827bb2 = function() {
    $970c7ddf83730f06$var$K.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
    var t = 0;
    Object.defineProperty(this, "TI", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "topIndex", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    });
    var e = [];
    Object.defineProperty(this, "Opt", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return $970c7ddf83730f06$var$V(e);
        },
        set: function(t) {
            var n, r;
            r = [], "string" == typeof (n = t) && (r = function(t, e, n) {
                n || (n = 1);
                for(var r, i = []; r = e.exec(t);)i.push(r[n]);
                return i;
            }(n, /\((.*?)\)/g)), e = r;
        }
    }), this.getOptions = function() {
        return e;
    }, this.setOptions = function(t) {
        e = t, this.sort && e.sort();
    }, this.addOption = function(t) {
        t = (t = t || "").toString(), e.push(t), this.sort && e.sort();
    }, this.removeOption = function(t, n) {
        for(n = n || !1, t = (t = t || "").toString(); -1 !== e.indexOf(t) && (e.splice(e.indexOf(t), 1), !1 !== n););
    }, Object.defineProperty(this, "combo", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 18));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 18) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 18);
        }
    }), Object.defineProperty(this, "edit", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 19));
        },
        set: function(t) {
            !0 === this.combo && (!0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 19) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 19));
        }
    }), Object.defineProperty(this, "sort", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 20));
        },
        set: function(t) {
            !0 === Boolean(t) ? (this.Ff = $970c7ddf83730f06$var$I(this.Ff, 20), e.sort()) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 20);
        }
    }), Object.defineProperty(this, "multiSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 22));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 22) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 22);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 23) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 23);
        }
    }), Object.defineProperty(this, "commitOnSelChange", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 27));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 27) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 27);
        }
    }), this.hasAppearanceStream = !1;
};
$970c7ddf83730f06$var$x($970c7ddf83730f06$export$a47202eb3f827bb2, $970c7ddf83730f06$var$K);
var $970c7ddf83730f06$export$9e021dd9568dc486 = function() {
    $970c7ddf83730f06$export$a47202eb3f827bb2.call(this), this.fontName = "helvetica", this.combo = !1;
};
$970c7ddf83730f06$var$x($970c7ddf83730f06$export$9e021dd9568dc486, $970c7ddf83730f06$export$a47202eb3f827bb2);
var $970c7ddf83730f06$export$f2239d28df5f43bd = function() {
    $970c7ddf83730f06$export$9e021dd9568dc486.call(this), this.combo = !0;
};
$970c7ddf83730f06$var$x($970c7ddf83730f06$export$f2239d28df5f43bd, $970c7ddf83730f06$export$9e021dd9568dc486);
var $970c7ddf83730f06$export$4af052e7e598ad1a = function() {
    $970c7ddf83730f06$export$f2239d28df5f43bd.call(this), this.edit = !0;
};
$970c7ddf83730f06$var$x($970c7ddf83730f06$export$4af052e7e598ad1a, $970c7ddf83730f06$export$f2239d28df5f43bd);
var $970c7ddf83730f06$export$6aae594af76bbb7b = function() {
    $970c7ddf83730f06$var$K.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 15));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 15) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 15);
        }
    }), Object.defineProperty(this, "radio", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 16));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 16) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 16);
        }
    }), Object.defineProperty(this, "pushButton", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 17));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 17) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 17);
        }
    }), Object.defineProperty(this, "radioIsUnison", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 26) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 26);
        }
    });
    var t, e = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (0 !== Object.keys(e).length) {
                var t, n = [];
                for(t in n.push("<<"), e)n.push("/" + t + " (" + e[t] + ")");
                return n.push(">>"), n.join("\n");
            }
        },
        set: function(t) {
            "object" == typeof t && (e = t);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return e.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (e.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t.substr(1, t.length - 1);
        },
        set: function(e) {
            t = "/" + e;
        }
    });
};
$970c7ddf83730f06$var$x($970c7ddf83730f06$export$6aae594af76bbb7b, $970c7ddf83730f06$var$K);
var $970c7ddf83730f06$export$98b7c3ef37465410 = function() {
    $970c7ddf83730f06$export$6aae594af76bbb7b.call(this), this.pushButton = !0;
};
$970c7ddf83730f06$var$x($970c7ddf83730f06$export$98b7c3ef37465410, $970c7ddf83730f06$export$6aae594af76bbb7b);
var $970c7ddf83730f06$export$bc1318bc7e5f1315 = function() {
    $970c7ddf83730f06$export$6aae594af76bbb7b.call(this), this.radio = !0, this.pushButton = !1;
    var t = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = void 0 !== e ? e : [];
        }
    });
};
$970c7ddf83730f06$var$x($970c7ddf83730f06$export$bc1318bc7e5f1315, $970c7ddf83730f06$export$6aae594af76bbb7b);
var $970c7ddf83730f06$var$it = function() {
    var t, e;
    $970c7ddf83730f06$var$K.call(this), Object.defineProperty(this, "Parent", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "optionName", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    });
    var n, r = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            var t, e = [];
            for(t in e.push("<<"), r)e.push("/" + t + " (" + r[t] + ")");
            return e.push(">>"), e.join("\n");
        },
        set: function(t) {
            "object" == typeof t && (r = t);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return r.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (r.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return n;
        },
        set: function(t) {
            n = t;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return n.substr(1, n.length - 1);
        },
        set: function(t) {
            n = "/" + t;
        }
    }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = $970c7ddf83730f06$export$7d753ad993606f45.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
$970c7ddf83730f06$var$x($970c7ddf83730f06$var$it, $970c7ddf83730f06$var$K), $970c7ddf83730f06$export$bc1318bc7e5f1315.prototype.setAppearance = function(t) {
    if (!("createAppearanceStream" in t) || !("getCA" in t)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
    for(var e in this.Kids)if (this.Kids.hasOwnProperty(e)) {
        var n = this.Kids[e];
        n.appearanceStreamContent = t.createAppearanceStream(n.optionName), n.caption = t.getCA();
    }
}, $970c7ddf83730f06$export$bc1318bc7e5f1315.prototype.createOption = function(t) {
    var e = new $970c7ddf83730f06$var$it;
    return e.Parent = this, e.optionName = t, this.Kids.push(e), $970c7ddf83730f06$var$ct.call(this, e), e;
};
var $970c7ddf83730f06$export$5fd5db01c4615478 = function() {
    $970c7ddf83730f06$export$6aae594af76bbb7b.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = $970c7ddf83730f06$export$7d753ad993606f45.CheckBox.createAppearanceStream();
};
$970c7ddf83730f06$var$x($970c7ddf83730f06$export$5fd5db01c4615478, $970c7ddf83730f06$export$6aae594af76bbb7b);
var $970c7ddf83730f06$export$9d1b52e7fab50c84 = function() {
    $970c7ddf83730f06$var$K.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 13));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 13) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 13);
        }
    }), Object.defineProperty(this, "fileSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 21));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 21) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 21);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 23) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 23);
        }
    }), Object.defineProperty(this, "doNotScroll", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 24));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 24) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 24);
        }
    }), Object.defineProperty(this, "comb", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 25));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 25) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 25);
        }
    }), Object.defineProperty(this, "richText", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 26) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 26);
        }
    });
    var t = null;
    Object.defineProperty(this, "MaxLen", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "maxLength", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            Number.isInteger(e) && (t = e);
        }
    }), Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.V || this.DV;
        }
    });
};
$970c7ddf83730f06$var$x($970c7ddf83730f06$export$9d1b52e7fab50c84, $970c7ddf83730f06$var$K);
var $970c7ddf83730f06$export$c48d8668f8cea64d = function() {
    $970c7ddf83730f06$export$9d1b52e7fab50c84.call(this), Object.defineProperty(this, "password", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($970c7ddf83730f06$var$F(this.Ff, 14));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $970c7ddf83730f06$var$I(this.Ff, 14) : this.Ff = $970c7ddf83730f06$var$C(this.Ff, 14);
        }
    }), this.password = !0;
};
$970c7ddf83730f06$var$x($970c7ddf83730f06$export$c48d8668f8cea64d, $970c7ddf83730f06$export$9d1b52e7fab50c84);
var $970c7ddf83730f06$export$7d753ad993606f45 = {
    CheckBox: {
        createAppearanceStream: function() {
            return {
                N: {
                    On: $970c7ddf83730f06$export$7d753ad993606f45.CheckBox.YesNormal
                },
                D: {
                    On: $970c7ddf83730f06$export$7d753ad993606f45.CheckBox.YesPushDown,
                    Off: $970c7ddf83730f06$export$7d753ad993606f45.CheckBox.OffPushDown
                }
            };
        },
        YesPushDown: function(t) {
            var e = new $970c7ddf83730f06$var$_(t), n = [], r = $970c7ddf83730f06$var$m.internal.getFont(t.fontName, t.fontStyle).id, i = $970c7ddf83730f06$var$m.__private__.encodeColorString(t.color), a = $970c7ddf83730f06$var$O(t, t.caption);
            return n.push("0.749023 g"), n.push("0 0 " + $970c7ddf83730f06$var$N($970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t)) + " " + $970c7ddf83730f06$var$N($970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t)) + " re"), n.push("f"), n.push("BMC"), n.push("q"), n.push("0 0 1 rg"), n.push("/" + r + " " + $970c7ddf83730f06$var$N(a.fontSize) + " Tf " + i), n.push("BT"), n.push(a.text), n.push("ET"), n.push("Q"), n.push("EMC"), e.stream = n.join("\n"), e;
        },
        YesNormal: function(t) {
            var e = new $970c7ddf83730f06$var$_(t), n = $970c7ddf83730f06$var$m.internal.getFont(t.fontName, t.fontStyle).id, r = $970c7ddf83730f06$var$m.__private__.encodeColorString(t.color), i = [], a = $970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t), o = $970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t), s = $970c7ddf83730f06$var$O(t, t.caption);
            return i.push("1 g"), i.push("0 0 " + $970c7ddf83730f06$var$N(o) + " " + $970c7ddf83730f06$var$N(a) + " re"), i.push("f"), i.push("q"), i.push("0 0 1 rg"), i.push("0 0 " + $970c7ddf83730f06$var$N(o - 1) + " " + $970c7ddf83730f06$var$N(a - 1) + " re"), i.push("W"), i.push("n"), i.push("0 g"), i.push("BT"), i.push("/" + n + " " + $970c7ddf83730f06$var$N(s.fontSize) + " Tf " + r), i.push(s.text), i.push("ET"), i.push("Q"), e.stream = i.join("\n"), e;
        },
        OffPushDown: function(t) {
            var e = new $970c7ddf83730f06$var$_(t), n = [];
            return n.push("0.749023 g"), n.push("0 0 " + $970c7ddf83730f06$var$N($970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t)) + " " + $970c7ddf83730f06$var$N($970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t)) + " re"), n.push("f"), e.stream = n.join("\n"), e;
        }
    },
    RadioButton: {
        Circle: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: $970c7ddf83730f06$export$7d753ad993606f45.RadioButton.Circle.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = $970c7ddf83730f06$export$7d753ad993606f45.RadioButton.Circle.YesNormal, e.D[t] = $970c7ddf83730f06$export$7d753ad993606f45.RadioButton.Circle.YesPushDown, e;
            },
            getCA: function() {
                return "l";
            },
            YesNormal: function(t) {
                var e = new $970c7ddf83730f06$var$_(t), n = [], r = $970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t) <= $970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t) ? $970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t) / 4 : $970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t) / 4;
                r = Number((.9 * r).toFixed(5));
                var i = $970c7ddf83730f06$export$7d753ad993606f45.internal.Bezier_C, a = Number((r * i).toFixed(5));
                return n.push("q"), n.push("1 0 0 1 " + $970c7ddf83730f06$var$L($970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $970c7ddf83730f06$var$L($970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + a + " " + a + " " + r + " 0 " + r + " c"), n.push("-" + a + " " + r + " -" + r + " " + a + " -" + r + " 0 c"), n.push("-" + r + " -" + a + " -" + a + " -" + r + " 0 -" + r + " c"), n.push(a + " -" + r + " " + r + " -" + a + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = new $970c7ddf83730f06$var$_(t), n = [], r = $970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t) <= $970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t) ? $970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t) / 4 : $970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t) / 4, i = (r = Number((.9 * r).toFixed(5)), Number((2 * r).toFixed(5))), a = Number((i * $970c7ddf83730f06$export$7d753ad993606f45.internal.Bezier_C).toFixed(5)), o = Number((r * $970c7ddf83730f06$export$7d753ad993606f45.internal.Bezier_C).toFixed(5));
                return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + $970c7ddf83730f06$var$L($970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $970c7ddf83730f06$var$L($970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), n.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), n.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), n.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), n.push("f"), n.push("Q"), n.push("0 g"), n.push("q"), n.push("1 0 0 1 " + $970c7ddf83730f06$var$L($970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $970c7ddf83730f06$var$L($970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + o + " " + o + " " + r + " 0 " + r + " c"), n.push("-" + o + " " + r + " -" + r + " " + o + " -" + r + " 0 c"), n.push("-" + r + " -" + o + " -" + o + " -" + r + " 0 -" + r + " c"), n.push(o + " -" + r + " " + r + " -" + o + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = new $970c7ddf83730f06$var$_(t), n = [], r = $970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t) <= $970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t) ? $970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t) / 4 : $970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t) / 4;
                r = Number((.9 * r).toFixed(5));
                var i = Number((2 * r).toFixed(5)), a = Number((i * $970c7ddf83730f06$export$7d753ad993606f45.internal.Bezier_C).toFixed(5));
                return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + $970c7ddf83730f06$var$L($970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $970c7ddf83730f06$var$L($970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), n.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), n.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), n.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
            }
        },
        Cross: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: $970c7ddf83730f06$export$7d753ad993606f45.RadioButton.Cross.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = $970c7ddf83730f06$export$7d753ad993606f45.RadioButton.Cross.YesNormal, e.D[t] = $970c7ddf83730f06$export$7d753ad993606f45.RadioButton.Cross.YesPushDown, e;
            },
            getCA: function() {
                return "8";
            },
            YesNormal: function(t) {
                var e = new $970c7ddf83730f06$var$_(t), n = [], r = $970c7ddf83730f06$export$7d753ad993606f45.internal.calculateCross(t);
                return n.push("q"), n.push("1 1 " + $970c7ddf83730f06$var$N($970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t) - 2) + " " + $970c7ddf83730f06$var$N($970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t) - 2) + " re"), n.push("W"), n.push("n"), n.push($970c7ddf83730f06$var$N(r.x1.x) + " " + $970c7ddf83730f06$var$N(r.x1.y) + " m"), n.push($970c7ddf83730f06$var$N(r.x2.x) + " " + $970c7ddf83730f06$var$N(r.x2.y) + " l"), n.push($970c7ddf83730f06$var$N(r.x4.x) + " " + $970c7ddf83730f06$var$N(r.x4.y) + " m"), n.push($970c7ddf83730f06$var$N(r.x3.x) + " " + $970c7ddf83730f06$var$N(r.x3.y) + " l"), n.push("s"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = new $970c7ddf83730f06$var$_(t), n = $970c7ddf83730f06$export$7d753ad993606f45.internal.calculateCross(t), r = [];
                return r.push("0.749023 g"), r.push("0 0 " + $970c7ddf83730f06$var$N($970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t)) + " " + $970c7ddf83730f06$var$N($970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), r.push("q"), r.push("1 1 " + $970c7ddf83730f06$var$N($970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t) - 2) + " " + $970c7ddf83730f06$var$N($970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t) - 2) + " re"), r.push("W"), r.push("n"), r.push($970c7ddf83730f06$var$N(n.x1.x) + " " + $970c7ddf83730f06$var$N(n.x1.y) + " m"), r.push($970c7ddf83730f06$var$N(n.x2.x) + " " + $970c7ddf83730f06$var$N(n.x2.y) + " l"), r.push($970c7ddf83730f06$var$N(n.x4.x) + " " + $970c7ddf83730f06$var$N(n.x4.y) + " m"), r.push($970c7ddf83730f06$var$N(n.x3.x) + " " + $970c7ddf83730f06$var$N(n.x3.y) + " l"), r.push("s"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = new $970c7ddf83730f06$var$_(t), n = [];
                return n.push("0.749023 g"), n.push("0 0 " + $970c7ddf83730f06$var$N($970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t)) + " " + $970c7ddf83730f06$var$N($970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t)) + " re"), n.push("f"), e.stream = n.join("\n"), e;
            }
        }
    },
    createDefaultAppearanceStream: function(t) {
        var e = $970c7ddf83730f06$var$m.internal.getFont(t.fontName, t.fontStyle).id, n = $970c7ddf83730f06$var$m.__private__.encodeColorString(t.color);
        return "/" + e + " " + t.fontSize + " Tf " + n;
    }
};
$970c7ddf83730f06$export$7d753ad993606f45.internal = {
    Bezier_C: .551915024494,
    calculateCross: function(t) {
        var e = $970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth(t), n = $970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight(t), r = Math.min(e, n);
        return {
            x1: {
                x: (e - r) / 2,
                y: (n - r) / 2 + r
            },
            x2: {
                x: (e - r) / 2 + r,
                y: (n - r) / 2
            },
            x3: {
                x: (e - r) / 2,
                y: (n - r) / 2
            },
            x4: {
                x: (e - r) / 2 + r,
                y: (n - r) / 2 + r
            }
        };
    }
}, $970c7ddf83730f06$export$7d753ad993606f45.internal.getWidth = function(t) {
    var e = 0;
    return "object" == typeof t && (e = $970c7ddf83730f06$var$A(t.Rect[2])), e;
}, $970c7ddf83730f06$export$7d753ad993606f45.internal.getHeight = function(t) {
    var e = 0;
    return "object" == typeof t && (e = $970c7ddf83730f06$var$A(t.Rect[3])), e;
};
var $970c7ddf83730f06$var$ct = $970c7ddf83730f06$var$v.addField = function(t) {
    if ($970c7ddf83730f06$var$W.call(this), !(t instanceof $970c7ddf83730f06$var$K)) throw new Error("Invalid argument passed to jsPDF.addField.");
    return $970c7ddf83730f06$var$R.call(this, t), t.page = $970c7ddf83730f06$var$m.internal.getCurrentPageInfo().pageNumber, this;
};
$970c7ddf83730f06$var$v.AcroFormChoiceField = $970c7ddf83730f06$export$a47202eb3f827bb2, $970c7ddf83730f06$var$v.AcroFormListBox = $970c7ddf83730f06$export$9e021dd9568dc486, $970c7ddf83730f06$var$v.AcroFormComboBox = $970c7ddf83730f06$export$f2239d28df5f43bd, $970c7ddf83730f06$var$v.AcroFormEditBox = $970c7ddf83730f06$export$4af052e7e598ad1a, $970c7ddf83730f06$var$v.AcroFormButton = $970c7ddf83730f06$export$6aae594af76bbb7b, $970c7ddf83730f06$var$v.AcroFormPushButton = $970c7ddf83730f06$export$98b7c3ef37465410, $970c7ddf83730f06$var$v.AcroFormRadioButton = $970c7ddf83730f06$export$bc1318bc7e5f1315, $970c7ddf83730f06$var$v.AcroFormCheckBox = $970c7ddf83730f06$export$5fd5db01c4615478, $970c7ddf83730f06$var$v.AcroFormTextField = $970c7ddf83730f06$export$9d1b52e7fab50c84, $970c7ddf83730f06$var$v.AcroFormPasswordField = $970c7ddf83730f06$export$c48d8668f8cea64d, $970c7ddf83730f06$var$v.AcroFormAppearance = $970c7ddf83730f06$export$7d753ad993606f45, $970c7ddf83730f06$var$v.AcroForm = {
    ChoiceField: $970c7ddf83730f06$export$a47202eb3f827bb2,
    ListBox: $970c7ddf83730f06$export$9e021dd9568dc486,
    ComboBox: $970c7ddf83730f06$export$f2239d28df5f43bd,
    EditBox: $970c7ddf83730f06$export$4af052e7e598ad1a,
    Button: $970c7ddf83730f06$export$6aae594af76bbb7b,
    PushButton: $970c7ddf83730f06$export$98b7c3ef37465410,
    RadioButton: $970c7ddf83730f06$export$bc1318bc7e5f1315,
    CheckBox: $970c7ddf83730f06$export$5fd5db01c4615478,
    TextField: $970c7ddf83730f06$export$9d1b52e7fab50c84,
    PasswordField: $970c7ddf83730f06$export$c48d8668f8cea64d,
    Appearance: $970c7ddf83730f06$export$7d753ad993606f45
}, $970c7ddf83730f06$export$ba1e2ffc633a60f5.AcroForm = {
    ChoiceField: $970c7ddf83730f06$export$a47202eb3f827bb2,
    ListBox: $970c7ddf83730f06$export$9e021dd9568dc486,
    ComboBox: $970c7ddf83730f06$export$f2239d28df5f43bd,
    EditBox: $970c7ddf83730f06$export$4af052e7e598ad1a,
    Button: $970c7ddf83730f06$export$6aae594af76bbb7b,
    PushButton: $970c7ddf83730f06$export$98b7c3ef37465410,
    RadioButton: $970c7ddf83730f06$export$bc1318bc7e5f1315,
    CheckBox: $970c7ddf83730f06$export$5fd5db01c4615478,
    TextField: $970c7ddf83730f06$export$9d1b52e7fab50c84,
    PasswordField: $970c7ddf83730f06$export$c48d8668f8cea64d,
    Appearance: $970c7ddf83730f06$export$7d753ad993606f45
};
var $970c7ddf83730f06$export$9cf40f67b77f45f4 = $970c7ddf83730f06$export$ba1e2ffc633a60f5.AcroForm;
/** @license
 * jsPDF addImage plugin
 * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
 *               2013 Chris Dowling, https://github.com/gingerchris
 *               2013 Trinh Ho, https://github.com/ineedfat
 *               2013 Edwin Alejandro Perez, https://github.com/eaparango
 *               2013 Norah Smith, https://github.com/burnburnrocket
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ !function(t) {
    t.__addimage__ = {};
    var e = "UNKNOWN", n = {
        PNG: [
            [
                137,
                80,
                78,
                71
            ]
        ],
        TIFF: [
            [
                77,
                77,
                0,
                42
            ],
            [
                73,
                73,
                42,
                0
            ]
        ],
        JPEG: [
            [
                255,
                216,
                255,
                224,
                void 0,
                void 0,
                74,
                70,
                73,
                70,
                0
            ],
            [
                255,
                216,
                255,
                225,
                void 0,
                void 0,
                69,
                120,
                105,
                102,
                0,
                0
            ],
            [
                255,
                216,
                255,
                219
            ],
            [
                255,
                216,
                255,
                238
            ]
        ],
        JPEG2000: [
            [
                0,
                0,
                0,
                12,
                106,
                80,
                32,
                32
            ]
        ],
        GIF87a: [
            [
                71,
                73,
                70,
                56,
                55,
                97
            ]
        ],
        GIF89a: [
            [
                71,
                73,
                70,
                56,
                57,
                97
            ]
        ],
        WEBP: [
            [
                82,
                73,
                70,
                70,
                void 0,
                void 0,
                void 0,
                void 0,
                87,
                69,
                66,
                80
            ]
        ],
        BMP: [
            [
                66,
                77
            ],
            [
                66,
                65
            ],
            [
                67,
                73
            ],
            [
                67,
                80
            ],
            [
                73,
                67
            ],
            [
                80,
                84
            ]
        ]
    }, r = t.__addimage__.getImageFileTypeByImageData = function(t, r) {
        var i, a;
        r = r || e;
        var o, s, u, c = e;
        if (A(t)) for(u in n)for(o = n[u], i = 0; i < o.length; i += 1){
            for(s = !0, a = 0; a < o[i].length; a += 1)if (void 0 !== o[i][a] && o[i][a] !== t[a]) {
                s = !1;
                break;
            }
            if (!0 === s) {
                c = u;
                break;
            }
        }
        else for(u in n)for(o = n[u], i = 0; i < o.length; i += 1){
            for(s = !0, a = 0; a < o[i].length; a += 1)if (void 0 !== o[i][a] && o[i][a] !== t.charCodeAt(a)) {
                s = !1;
                break;
            }
            if (!0 === s) {
                c = u;
                break;
            }
        }
        return c === e && r !== e && (c = r), c;
    }, i = function(t) {
        for(var e = this.internal.write, n = this.internal.putStream, r = (0, this.internal.getFilters)(); -1 !== r.indexOf("FlateEncode");)r.splice(r.indexOf("FlateEncode"), 1);
        t.objectId = this.internal.newObject();
        var a = [];
        if (a.push({
            key: "Type",
            value: "/XObject"
        }), a.push({
            key: "Subtype",
            value: "/Image"
        }), a.push({
            key: "Width",
            value: t.width
        }), a.push({
            key: "Height",
            value: t.height
        }), t.colorSpace === b.INDEXED ? a.push({
            key: "ColorSpace",
            value: "[/Indexed /DeviceRGB " + (t.palette.length / 3 - 1) + " " + ("sMask" in t && void 0 !== t.sMask ? t.objectId + 2 : t.objectId + 1) + " 0 R]"
        }) : (a.push({
            key: "ColorSpace",
            value: "/" + t.colorSpace
        }), t.colorSpace === b.DEVICE_CMYK && a.push({
            key: "Decode",
            value: "[1 0 1 0 1 0 1 0]"
        })), a.push({
            key: "BitsPerComponent",
            value: t.bitsPerComponent
        }), "decodeParameters" in t && void 0 !== t.decodeParameters && a.push({
            key: "DecodeParms",
            value: "<<" + t.decodeParameters + ">>"
        }), "transparency" in t && Array.isArray(t.transparency)) {
            for(var o = "", s = 0, u = t.transparency.length; s < u; s++)o += t.transparency[s] + " " + t.transparency[s] + " ";
            a.push({
                key: "Mask",
                value: "[" + o + "]"
            });
        }
        void 0 !== t.sMask && a.push({
            key: "SMask",
            value: t.objectId + 1 + " 0 R"
        });
        var c = void 0 !== t.filter ? [
            "/" + t.filter
        ] : void 0;
        if (n({
            data: t.data,
            additionalKeyValues: a,
            alreadyAppliedFilters: c
        }), e("endobj"), "sMask" in t && void 0 !== t.sMask) {
            var h = "/Predictor " + t.predictor + " /Colors 1 /BitsPerComponent " + t.bitsPerComponent + " /Columns " + t.width, l = {
                width: t.width,
                height: t.height,
                colorSpace: "DeviceGray",
                bitsPerComponent: t.bitsPerComponent,
                decodeParameters: h,
                data: t.sMask
            };
            "filter" in t && (l.filter = t.filter), i.call(this, l);
        }
        t.colorSpace === b.INDEXED && (this.internal.newObject(), n({
            data: S(new Uint8Array(t.palette))
        }), e("endobj"));
    }, a = function() {
        var t = this.internal.collections.addImage_images;
        for(var e in t)i.call(this, t[e]);
    }, u = function() {
        var t, e = this.internal.collections.addImage_images, n = this.internal.write;
        for(var r in e)n("/I" + (t = e[r]).index, t.objectId, "0", "R");
    }, c = function() {
        this.internal.collections.addImage_images || (this.internal.collections.addImage_images = {}, this.internal.events.subscribe("putResources", a), this.internal.events.subscribe("putXobjectDict", u));
    }, h = function() {
        var t = this.internal.collections.addImage_images;
        return c.call(this), t;
    }, l = function() {
        return Object.keys(this.internal.collections.addImage_images).length;
    }, f = function(e) {
        return "function" == typeof t["process" + e.toUpperCase()];
    }, d = function(t) {
        return "object" == typeof t && 1 === t.nodeType;
    }, p = function(e, n) {
        if ("IMG" === e.nodeName && e.hasAttribute("src")) {
            var r = "" + e.getAttribute("src");
            if (0 === r.indexOf("data:image/")) return $970c7ddf83730f06$var$o(unescape(r).split("base64,").pop());
            var i = t.loadFile(r, !0);
            if (void 0 !== i) return i;
        }
        if ("CANVAS" === e.nodeName) {
            var a;
            switch(n){
                case "PNG":
                    a = "image/png";
                    break;
                case "WEBP":
                    a = "image/webp";
                    break;
                case "JPEG":
                case "JPG":
                default:
                    a = "image/jpeg";
            }
            return $970c7ddf83730f06$var$o(e.toDataURL(a, 1).split("base64,").pop());
        }
    }, g = function(t) {
        var e = this.internal.collections.addImage_images;
        if (e) {
            for(var n in e)if (t === e[n].alias) return e[n];
        }
    }, m = function(t, e, n) {
        return t || e || (t = -96, e = -96), t < 0 && (t = -1 * n.width * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * n.height * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * n.width / n.height), 0 === e && (e = t * n.height / n.width), [
            t,
            e
        ];
    }, v = function(t, e, n, r, i, a) {
        var o = m.call(this, n, r, i), s = this.internal.getCoordinateString, u = this.internal.getVerticalCoordinateString, c = h.call(this);
        if (n = o[0], r = o[1], c[i.index] = i, a) {
            a *= Math.PI / 180;
            var l = Math.cos(a), f = Math.sin(a), d = function(t) {
                return t.toFixed(4);
            }, p = [
                d(l),
                d(f),
                d(-1 * f),
                d(l),
                0,
                0,
                "cm"
            ];
        }
        this.internal.write("q"), a ? (this.internal.write([
            1,
            "0",
            "0",
            1,
            s(t),
            u(e + r),
            "cm"
        ].join(" ")), this.internal.write(p.join(" ")), this.internal.write([
            s(n),
            "0",
            "0",
            s(r),
            "0",
            "0",
            "cm"
        ].join(" "))) : this.internal.write([
            s(n),
            "0",
            "0",
            s(r),
            s(t),
            u(e + r),
            "cm"
        ].join(" ")), this.isAdvancedAPI() && this.internal.write([
            1,
            0,
            0,
            -1,
            0,
            0,
            "cm"
        ].join(" ")), this.internal.write("/I" + i.index + " Do"), this.internal.write("Q");
    }, b = t.color_spaces = {
        DEVICE_RGB: "DeviceRGB",
        DEVICE_GRAY: "DeviceGray",
        DEVICE_CMYK: "DeviceCMYK",
        CAL_GREY: "CalGray",
        CAL_RGB: "CalRGB",
        LAB: "Lab",
        ICC_BASED: "ICCBased",
        INDEXED: "Indexed",
        PATTERN: "Pattern",
        SEPARATION: "Separation",
        DEVICE_N: "DeviceN"
    };
    t.decode = {
        DCT_DECODE: "DCTDecode",
        FLATE_DECODE: "FlateDecode",
        LZW_DECODE: "LZWDecode",
        JPX_DECODE: "JPXDecode",
        JBIG2_DECODE: "JBIG2Decode",
        ASCII85_DECODE: "ASCII85Decode",
        ASCII_HEX_DECODE: "ASCIIHexDecode",
        RUN_LENGTH_DECODE: "RunLengthDecode",
        CCITT_FAX_DECODE: "CCITTFaxDecode"
    };
    var y = t.image_compression = {
        NONE: "NONE",
        FAST: "FAST",
        MEDIUM: "MEDIUM",
        SLOW: "SLOW"
    }, w = t.__addimage__.sHashCode = function(t) {
        var e, n, r = 0;
        if ("string" == typeof t) for(n = t.length, e = 0; e < n; e++)r = (r << 5) - r + t.charCodeAt(e), r |= 0;
        else if (A(t)) for(n = t.byteLength / 2, e = 0; e < n; e++)r = (r << 5) - r + t[e], r |= 0;
        return r;
    }, N = t.__addimage__.validateStringAsBase64 = function(t) {
        (t = t || "").toString().trim();
        var e = !0;
        return 0 === t.length && (e = !1), t.length % 4 != 0 && (e = !1), !1 === /^[A-Za-z0-9+/]+$/.test(t.substr(0, t.length - 2)) && (e = !1), !1 === /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2)) && (e = !1), e;
    }, L = t.__addimage__.extractImageFromDataUrl = function(t) {
        var e = (t = t || "").split("base64,"), n = null;
        if (2 === e.length) {
            var r = /^data:(\w*\/\w*);*(charset=[\w=-]*)*;*$/.exec(e[0]);
            Array.isArray(r) && (n = {
                mimeType: r[1],
                charset: r[2],
                data: e[1]
            });
        }
        return n;
    }, x = t.__addimage__.supportsArrayBuffer = function() {
        return "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array;
    };
    t.__addimage__.isArrayBuffer = function(t) {
        return x() && t instanceof ArrayBuffer;
    };
    var A = t.__addimage__.isArrayBufferView = function(t) {
        return x() && "undefined" != typeof Uint32Array && (t instanceof Int8Array || t instanceof Uint8Array || "undefined" != typeof Uint8ClampedArray && t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array);
    }, _ = t.__addimage__.binaryStringToUint8Array = function(t) {
        for(var e = t.length, n = new Uint8Array(e), r = 0; r < e; r++)n[r] = t.charCodeAt(r);
        return n;
    }, S = t.__addimage__.arrayBufferToBinaryString = function(t) {
        try {
            return $970c7ddf83730f06$var$o($970c7ddf83730f06$var$s(String.fromCharCode.apply(null, t)));
        } catch (e) {
            if ("undefined" != typeof Uint8Array && void 0 !== Uint8Array.prototype.reduce) return new Uint8Array(t).reduce(function(t, e) {
                return t.push(String.fromCharCode(e)), t;
            }, []).join("");
        }
    };
    t.addImage = function() {
        var t, n, r, i, a, o, s, u, h;
        if ("number" == typeof arguments[1] ? (n = e, r = arguments[1], i = arguments[2], a = arguments[3], o = arguments[4], s = arguments[5], u = arguments[6], h = arguments[7]) : (n = arguments[1], r = arguments[2], i = arguments[3], a = arguments[4], o = arguments[5], s = arguments[6], u = arguments[7], h = arguments[8]), "object" == typeof (t = arguments[0]) && !d(t) && "imageData" in t) {
            var l = t;
            t = l.imageData, n = l.format || n || e, r = l.x || r || 0, i = l.y || i || 0, a = l.w || l.width || a, o = l.h || l.height || o, s = l.alias || s, u = l.compression || u, h = l.rotation || l.angle || h;
        }
        var f = this.internal.getFilters();
        if (void 0 === u && -1 !== f.indexOf("FlateEncode") && (u = "SLOW"), isNaN(r) || isNaN(i)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
        c.call(this);
        var p = P.call(this, t, n, s, u);
        return v.call(this, r, i, a, o, p, h), this;
    };
    var P = function(n, i, a, o) {
        var s, u, c;
        if ("string" == typeof n && r(n) === e) {
            n = unescape(n);
            var h = k(n, !1);
            ("" !== h || void 0 !== (h = t.loadFile(n, !0))) && (n = h);
        }
        if (d(n) && (n = p(n, i)), i = r(n, i), !f(i)) throw new Error("addImage does not support files of type '" + i + "', please ensure that a plugin for '" + i + "' support is added.");
        if ((null == (c = a) || 0 === c.length) && (a = function(t) {
            return "string" == typeof t || A(t) ? w(t) : null;
        }(n)), (s = g.call(this, a)) || (x() && (n instanceof Uint8Array || (u = n, n = _(n))), s = this["process" + i.toUpperCase()](n, l.call(this), a, function(e) {
            return e && "string" == typeof e && (e = e.toUpperCase()), e in t.image_compression ? e : y.NONE;
        }(o), u)), !s) throw new Error("An unknown error occurred whilst processing the image.");
        return s;
    }, k = t.__addimage__.convertBase64ToBinaryString = function(t, e) {
        var n;
        e = "boolean" != typeof e || e;
        var r, i = "";
        if ("string" == typeof t) {
            r = null !== (n = L(t)) ? n.data : t;
            try {
                i = $970c7ddf83730f06$var$o(r);
            } catch (t) {
                if (e) throw N(r) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + t.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
            }
        }
        return i;
    };
    t.getImageProperties = function(n) {
        var i, a, o = "";
        if (d(n) && (n = p(n)), "string" == typeof n && r(n) === e && ("" === (o = k(n, !1)) && (o = t.loadFile(n) || ""), n = o), a = r(n), !f(a)) throw new Error("addImage does not support files of type '" + a + "', please ensure that a plugin for '" + a + "' support is added.");
        if (!x() || n instanceof Uint8Array || (n = _(n)), !(i = this["process" + a.toUpperCase()](n))) throw new Error("An unknown error occurred whilst processing the image");
        return i.fileType = a, i;
    };
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        if (void 0 !== t && "" != t) return !0;
    };
    $970c7ddf83730f06$export$ba1e2ffc633a60f5.API.events.push([
        "addPage",
        function(t) {
            this.internal.getPageInfo(t.pageNumber).pageContext.annotations = [];
        }
    ]), t.events.push([
        "putPage",
        function(t) {
            for(var n, r, i, a = this.internal.getCoordinateString, o = this.internal.getVerticalCoordinateString, s = this.internal.getPageInfoByObjId(t.objId), u = t.pageContext.annotations, c = !1, h = 0; h < u.length && !c; h++)switch((n = u[h]).type){
                case "link":
                    (e(n.options.url) || e(n.options.pageNumber)) && (c = !0);
                    break;
                case "reference":
                case "text":
                case "freetext":
                    c = !0;
            }
            if (0 != c) {
                this.internal.write("/Annots [");
                for(var l = 0; l < u.length; l++)switch((n = u[l]).type){
                    case "reference":
                        this.internal.write(" " + n.object.objId + " 0 R ");
                        break;
                    case "text":
                        var f = this.internal.newAdditionalObject(), d = this.internal.newAdditionalObject(), p = n.title || "Note";
                        i = "<</Type /Annot /Subtype /Text " + (r = "/Rect [" + a(n.bounds.x) + " " + o(n.bounds.y + n.bounds.h) + " " + a(n.bounds.x + n.bounds.w) + " " + o(n.bounds.y) + "] ") + "/Contents (" + n.contents + ")", i += " /Popup " + d.objId + " 0 R", i += " /P " + s.objId + " 0 R", i += " /T (" + p + ") >>", f.content = i;
                        var g = f.objId + " 0 R";
                        i = "<</Type /Annot /Subtype /Popup " + (r = "/Rect [" + a(n.bounds.x + 30) + " " + o(n.bounds.y + n.bounds.h) + " " + a(n.bounds.x + n.bounds.w + 30) + " " + o(n.bounds.y) + "] ") + " /Parent " + g, n.open && (i += " /Open true"), i += " >>", d.content = i, this.internal.write(f.objId, "0 R", d.objId, "0 R");
                        break;
                    case "freetext":
                        r = "/Rect [" + a(n.bounds.x) + " " + o(n.bounds.y) + " " + a(n.bounds.x + n.bounds.w) + " " + o(n.bounds.y + n.bounds.h) + "] ";
                        var m = n.color || "#000000";
                        i = "<</Type /Annot /Subtype /FreeText " + r + "/Contents (" + n.contents + ")", i += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + m + ")", i += " /Border [0 0 0]", i += " >>", this.internal.write(i);
                        break;
                    case "link":
                        if (n.options.name) {
                            var v = this.annotations._nameMap[n.options.name];
                            n.options.pageNumber = v.page, n.options.top = v.y;
                        } else n.options.top || (n.options.top = 0);
                        if (r = "/Rect [" + a(n.x) + " " + o(n.y) + " " + a(n.x + n.w) + " " + o(n.y + n.h) + "] ", i = "", n.options.url) i = "<</Type /Annot /Subtype /Link " + r + "/Border [0 0 0] /A <</S /URI /URI (" + n.options.url + ") >>";
                        else if (n.options.pageNumber) switch(i = "<</Type /Annot /Subtype /Link " + r + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(n.options.pageNumber).objId + " 0 R", n.options.magFactor = n.options.magFactor || "XYZ", n.options.magFactor){
                            case "Fit":
                                i += " /Fit]";
                                break;
                            case "FitH":
                                i += " /FitH " + n.options.top + "]";
                                break;
                            case "FitV":
                                n.options.left = n.options.left || 0, i += " /FitV " + n.options.left + "]";
                                break;
                            case "XYZ":
                            default:
                                var b = o(n.options.top);
                                n.options.left = n.options.left || 0, void 0 === n.options.zoom && (n.options.zoom = 0), i += " /XYZ " + n.options.left + " " + b + " " + n.options.zoom + "]";
                        }
                        "" != i && (i += " >>", this.internal.write(i));
                }
                this.internal.write("]");
            }
        }
    ]), t.createAnnotation = function(t) {
        var e = this.internal.getCurrentPageInfo();
        switch(t.type){
            case "link":
                this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
                break;
            case "text":
            case "freetext":
                e.pageContext.annotations.push(t);
        }
    }, t.link = function(t, e, n, r, i) {
        this.internal.getCurrentPageInfo().pageContext.annotations.push({
            x: t,
            y: e,
            w: n,
            h: r,
            options: i,
            type: "link"
        });
    }, t.textWithLink = function(t, e, n, r) {
        var i = this.getTextWidth(t), a = this.internal.getLineHeight() / this.internal.scaleFactor;
        return this.text(t, e, n, r), n += .2 * a, this.link(e, n - a, i, a, r), i;
    }, t.getTextWidth = function(t) {
        var e = this.internal.getFontSize();
        return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
    };
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = {
        1569: [
            65152
        ],
        1570: [
            65153,
            65154
        ],
        1571: [
            65155,
            65156
        ],
        1572: [
            65157,
            65158
        ],
        1573: [
            65159,
            65160
        ],
        1574: [
            65161,
            65162,
            65163,
            65164
        ],
        1575: [
            65165,
            65166
        ],
        1576: [
            65167,
            65168,
            65169,
            65170
        ],
        1577: [
            65171,
            65172
        ],
        1578: [
            65173,
            65174,
            65175,
            65176
        ],
        1579: [
            65177,
            65178,
            65179,
            65180
        ],
        1580: [
            65181,
            65182,
            65183,
            65184
        ],
        1581: [
            65185,
            65186,
            65187,
            65188
        ],
        1582: [
            65189,
            65190,
            65191,
            65192
        ],
        1583: [
            65193,
            65194
        ],
        1584: [
            65195,
            65196
        ],
        1585: [
            65197,
            65198
        ],
        1586: [
            65199,
            65200
        ],
        1587: [
            65201,
            65202,
            65203,
            65204
        ],
        1588: [
            65205,
            65206,
            65207,
            65208
        ],
        1589: [
            65209,
            65210,
            65211,
            65212
        ],
        1590: [
            65213,
            65214,
            65215,
            65216
        ],
        1591: [
            65217,
            65218,
            65219,
            65220
        ],
        1592: [
            65221,
            65222,
            65223,
            65224
        ],
        1593: [
            65225,
            65226,
            65227,
            65228
        ],
        1594: [
            65229,
            65230,
            65231,
            65232
        ],
        1601: [
            65233,
            65234,
            65235,
            65236
        ],
        1602: [
            65237,
            65238,
            65239,
            65240
        ],
        1603: [
            65241,
            65242,
            65243,
            65244
        ],
        1604: [
            65245,
            65246,
            65247,
            65248
        ],
        1605: [
            65249,
            65250,
            65251,
            65252
        ],
        1606: [
            65253,
            65254,
            65255,
            65256
        ],
        1607: [
            65257,
            65258,
            65259,
            65260
        ],
        1608: [
            65261,
            65262
        ],
        1609: [
            65263,
            65264,
            64488,
            64489
        ],
        1610: [
            65265,
            65266,
            65267,
            65268
        ],
        1649: [
            64336,
            64337
        ],
        1655: [
            64477
        ],
        1657: [
            64358,
            64359,
            64360,
            64361
        ],
        1658: [
            64350,
            64351,
            64352,
            64353
        ],
        1659: [
            64338,
            64339,
            64340,
            64341
        ],
        1662: [
            64342,
            64343,
            64344,
            64345
        ],
        1663: [
            64354,
            64355,
            64356,
            64357
        ],
        1664: [
            64346,
            64347,
            64348,
            64349
        ],
        1667: [
            64374,
            64375,
            64376,
            64377
        ],
        1668: [
            64370,
            64371,
            64372,
            64373
        ],
        1670: [
            64378,
            64379,
            64380,
            64381
        ],
        1671: [
            64382,
            64383,
            64384,
            64385
        ],
        1672: [
            64392,
            64393
        ],
        1676: [
            64388,
            64389
        ],
        1677: [
            64386,
            64387
        ],
        1678: [
            64390,
            64391
        ],
        1681: [
            64396,
            64397
        ],
        1688: [
            64394,
            64395
        ],
        1700: [
            64362,
            64363,
            64364,
            64365
        ],
        1702: [
            64366,
            64367,
            64368,
            64369
        ],
        1705: [
            64398,
            64399,
            64400,
            64401
        ],
        1709: [
            64467,
            64468,
            64469,
            64470
        ],
        1711: [
            64402,
            64403,
            64404,
            64405
        ],
        1713: [
            64410,
            64411,
            64412,
            64413
        ],
        1715: [
            64406,
            64407,
            64408,
            64409
        ],
        1722: [
            64414,
            64415
        ],
        1723: [
            64416,
            64417,
            64418,
            64419
        ],
        1726: [
            64426,
            64427,
            64428,
            64429
        ],
        1728: [
            64420,
            64421
        ],
        1729: [
            64422,
            64423,
            64424,
            64425
        ],
        1733: [
            64480,
            64481
        ],
        1734: [
            64473,
            64474
        ],
        1735: [
            64471,
            64472
        ],
        1736: [
            64475,
            64476
        ],
        1737: [
            64482,
            64483
        ],
        1739: [
            64478,
            64479
        ],
        1740: [
            64508,
            64509,
            64510,
            64511
        ],
        1744: [
            64484,
            64485,
            64486,
            64487
        ],
        1746: [
            64430,
            64431
        ],
        1747: [
            64432,
            64433
        ]
    }, n = {
        65247: {
            65154: 65269,
            65156: 65271,
            65160: 65273,
            65166: 65275
        },
        65248: {
            65154: 65270,
            65156: 65272,
            65160: 65274,
            65166: 65276
        },
        65165: {
            65247: {
                65248: {
                    65258: 65010
                }
            }
        },
        1617: {
            1612: 64606,
            1613: 64607,
            1614: 64608,
            1615: 64609,
            1616: 64610
        }
    }, r = {
        1612: 64606,
        1613: 64607,
        1614: 64608,
        1615: 64609,
        1616: 64610
    }, i = [
        1570,
        1571,
        1573,
        1575
    ];
    t.__arabicParser__ = {};
    var a = t.__arabicParser__.isInArabicSubstitutionA = function(t) {
        return void 0 !== e[t.charCodeAt(0)];
    }, o = t.__arabicParser__.isArabicLetter = function(t) {
        return "string" == typeof t && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t);
    }, s = t.__arabicParser__.isArabicEndLetter = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length <= 2;
    }, u = t.__arabicParser__.isArabicAlfLetter = function(t) {
        return o(t) && i.indexOf(t.charCodeAt(0)) >= 0;
    };
    t.__arabicParser__.arabicLetterHasIsolatedForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 1;
    };
    var c = t.__arabicParser__.arabicLetterHasFinalForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 2;
    };
    t.__arabicParser__.arabicLetterHasInitialForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 3;
    };
    var h = t.__arabicParser__.arabicLetterHasMedialForm = function(t) {
        return o(t) && a(t) && 4 == e[t.charCodeAt(0)].length;
    }, l = t.__arabicParser__.resolveLigatures = function(t) {
        var e = 0, r = n, i = "", a = 0;
        for(e = 0; e < t.length; e += 1)void 0 !== r[t.charCodeAt(e)] ? (a++, "number" == typeof (r = r[t.charCodeAt(e)]) && (i += String.fromCharCode(r), r = n, a = 0), e === t.length - 1 && (r = n, i += t.charAt(e - (a - 1)), e -= a - 1, a = 0)) : (r = n, i += t.charAt(e - a), e -= a, a = 0);
        return i;
    };
    t.__arabicParser__.isArabicDiacritic = function(t) {
        return void 0 !== t && void 0 !== r[t.charCodeAt(0)];
    };
    var f = t.__arabicParser__.getCorrectForm = function(t, e, n) {
        return o(t) ? !1 === a(t) ? -1 : !c(t) || !o(e) && !o(n) || !o(n) && s(e) || s(t) && !o(e) || s(t) && u(e) || s(t) && s(e) ? 0 : h(t) && o(e) && !s(e) && o(n) && c(n) ? 3 : s(t) || !o(n) ? 1 : 2 : -1;
    }, d = function(t) {
        var n = 0, r = 0, i = 0, a = "", s = "", u = "", c = (t = t || "").split("\\s+"), h = [];
        for(n = 0; n < c.length; n += 1){
            for(h.push(""), r = 0; r < c[n].length; r += 1)a = c[n][r], s = c[n][r - 1], u = c[n][r + 1], o(a) ? (i = f(a, s, u), h[n] += -1 !== i ? String.fromCharCode(e[a.charCodeAt(0)][i]) : a) : h[n] += a;
            h[n] = l(h[n]);
        }
        return h.join(" ");
    }, p = t.__arabicParser__.processArabic = t.processArabic = function() {
        var t, e = "string" == typeof arguments[0] ? arguments[0] : arguments[0].text, n = [];
        if (Array.isArray(e)) {
            var r = 0;
            for(n = [], r = 0; r < e.length; r += 1)Array.isArray(e[r]) ? n.push([
                d(e[r][0]),
                e[r][1],
                e[r][2]
            ]) : n.push([
                d(e[r])
            ]);
            t = n;
        } else t = d(e);
        return "string" == typeof arguments[0] ? t : (arguments[0].text = t, arguments[0]);
    };
    t.events.push([
        "preProcessText",
        p
    ]);
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API), $970c7ddf83730f06$export$ba1e2ffc633a60f5.API.autoPrint = function(t) {
    var e;
    switch((t = t || {}).variant = t.variant || "non-conform", t.variant){
        case "javascript":
            this.addJS("print({});");
            break;
        case "non-conform":
        default:
            this.internal.events.subscribe("postPutResources", function() {
                e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
            }), this.internal.events.subscribe("putCatalog", function() {
                this.internal.out("/OpenAction " + e + " 0 R");
            });
    }
    return this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        var t = void 0;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = 150;
        Object.defineProperty(this, "width", {
            get: function() {
                return e;
            },
            set: function(t) {
                e = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 150 : t, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = e + 1);
            }
        });
        var n = 300;
        Object.defineProperty(this, "height", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 300 : t, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = n + 1);
            }
        });
        var r = [];
        Object.defineProperty(this, "childNodes", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = t;
            }
        });
        var i = {};
        Object.defineProperty(this, "style", {
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        }), Object.defineProperty(this, "parentNode", {});
    };
    e.prototype.getContext = function(t, e) {
        var n;
        if ("2d" !== (t = t || "2d")) return null;
        for(n in e)this.pdf.context2d.hasOwnProperty(n) && (this.pdf.context2d[n] = e[n]);
        return this.pdf.context2d._canvas = this, this.pdf.context2d;
    }, e.prototype.toDataURL = function() {
        throw new Error("toDataURL is not implemented.");
    }, t.events.push([
        "initialized",
        function() {
            this.canvas = new e, this.canvas.pdf = this;
        }
    ]);
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API), /**
 * @license
 * ====================================================================
 * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
 *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Hall, james@parall.ax
 *               2014 Diego Casorran, https://github.com/diegocr
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(t) {
    var e = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
    }, n = !1, r = function() {
        void 0 === this.internal.__cell__ && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, e), this.internal.__cell__.margins.width = this.getPageWidth(), i.call(this));
    }, i = function() {
        this.internal.__cell__.lastCell = new a, this.internal.__cell__.pages = 1;
    }, a = function() {
        var t = arguments[0];
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = arguments[1];
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return e;
            },
            set: function(t) {
                e = t;
            }
        });
        var n = arguments[2];
        Object.defineProperty(this, "width", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                n = t;
            }
        });
        var r = arguments[3];
        Object.defineProperty(this, "height", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                r = t;
            }
        });
        var i = arguments[4];
        Object.defineProperty(this, "text", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        });
        var a = arguments[5];
        Object.defineProperty(this, "lineNumber", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                a = t;
            }
        });
        var o = arguments[6];
        return Object.defineProperty(this, "align", {
            enumerable: !0,
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        }), this;
    };
    a.prototype.clone = function() {
        return new a(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
    }, a.prototype.toArray = function() {
        return [
            this.x,
            this.y,
            this.width,
            this.height,
            this.text,
            this.lineNumber,
            this.align
        ];
    }, t.setHeaderFunction = function(t) {
        return r.call(this), this.internal.__cell__.headerFunction = "function" == typeof t ? t : void 0, this;
    }, t.getTextDimensions = function(t, e) {
        r.call(this);
        var n = (e = e || {}).fontSize || this.getFontSize(), i = e.font || this.getFont(), a = e.scaleFactor || this.internal.scaleFactor, o = 0, s = 0, u = 0;
        if (!Array.isArray(t) && "string" != typeof t) {
            if ("number" != typeof t) throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
            t = String(t);
        }
        const c = e.maxWidth;
        c > 0 ? "string" == typeof t ? t = this.splitTextToSize(t, c) : "[object Array]" === Object.prototype.toString.call(t) && (t = this.splitTextToSize(t.join(" "), c)) : t = Array.isArray(t) ? t : [
            t
        ];
        for(var h = 0; h < t.length; h++)o < (u = this.getStringUnitWidth(t[h], {
            font: i
        }) * n) && (o = u);
        return 0 !== o && (s = t.length), {
            w: o /= a,
            h: Math.max((s * n * this.getLineHeightFactor() - n * (this.getLineHeightFactor() - 1)) / a, 0)
        };
    }, t.cellAddPage = function() {
        r.call(this), this.addPage();
        var t = this.internal.__cell__.margins || e;
        return this.internal.__cell__.lastCell = new a(t.left, t.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
    };
    var o = t.cell = function() {
        var t;
        t = arguments[0] instanceof a ? arguments[0] : new a(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]), r.call(this);
        var i = this.internal.__cell__.lastCell, o = this.internal.__cell__.padding, s = this.internal.__cell__.margins || e, u = this.internal.__cell__.tableHeaderRow, c = this.internal.__cell__.printHeaders;
        return void 0 !== i.lineNumber && (i.lineNumber === t.lineNumber ? (t.x = (i.x || 0) + (i.width || 0), t.y = i.y || 0) : i.y + i.height + t.height + s.bottom > this.getPageHeight() ? (this.cellAddPage(), t.y = s.top, c && u && (this.printHeaderRow(t.lineNumber, !0), t.y += u[0].height)) : t.y = i.y + i.height || t.y), void 0 !== t.text[0] && (this.rect(t.x, t.y, t.width, t.height, !0 === n ? "FD" : void 0), "right" === t.align ? this.text(t.text, t.x + t.width - o, t.y + o, {
            align: "right",
            baseline: "top"
        }) : "center" === t.align ? this.text(t.text, t.x + t.width / 2, t.y + o, {
            align: "center",
            baseline: "top",
            maxWidth: t.width - o - o
        }) : this.text(t.text, t.x + o, t.y + o, {
            align: "left",
            baseline: "top",
            maxWidth: t.width - o - o
        })), this.internal.__cell__.lastCell = t, this;
    };
    t.table = function(t, n, u, c, h) {
        if (r.call(this), !u) throw new Error("No data for PDF table.");
        var l, f, d, p, g = [], m = [], v = [], b = {}, y = {}, w = [], N = [], L = (h = h || {}).autoSize || !1, x = !1 !== h.printHeaders, A = h.css && void 0 !== h.css["font-size"] ? 16 * h.css["font-size"] : h.fontSize || 12, _ = h.margins || Object.assign({
            width: this.getPageWidth()
        }, e), S = "number" == typeof h.padding ? h.padding : 3, P = h.headerBackgroundColor || "#c8c8c8";
        if (i.call(this), this.internal.__cell__.printHeaders = x, this.internal.__cell__.margins = _, this.internal.__cell__.table_font_size = A, this.internal.__cell__.padding = S, this.internal.__cell__.headerBackgroundColor = P, this.setFontSize(A), null == c) m = g = Object.keys(u[0]), v = g.map(function() {
            return "left";
        });
        else if (Array.isArray(c) && "object" == typeof c[0]) for(g = c.map(function(t) {
            return t.name;
        }), m = c.map(function(t) {
            return t.prompt || t.name || "";
        }), v = g.map(function(t) {
            return t.align || "left";
        }), l = 0; l < c.length; l += 1)y[c[l].name] = c[l].width * (19.049976 / 25.4);
        else Array.isArray(c) && "string" == typeof c[0] && (m = g = c, v = g.map(function() {
            return "left";
        }));
        if (L) for(l = 0; l < g.length; l += 1){
            for(b[p = g[l]] = u.map(function(t) {
                return t[p];
            }), this.setFont(void 0, "bold"), w.push(this.getTextDimensions(m[l], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w), f = b[p], this.setFont(void 0, "normal"), d = 0; d < f.length; d += 1)w.push(this.getTextDimensions(f[d], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w);
            y[p] = Math.max.apply(null, w) + S + S, w = [];
        }
        if (x) {
            var k = {};
            for(l = 0; l < g.length; l += 1)k[g[l]] = {}, k[g[l]].text = m[l], k[g[l]].align = v[l];
            var F = s.call(this, k, y);
            N = g.map(function(e) {
                return new a(t, n, y[e], F, k[e].text, void 0, k[e].align);
            }), this.setTableHeaderRow(N), this.printHeaderRow(1, !1);
        }
        var I = c.reduce(function(t, e) {
            return t[e.name] = e.align, t;
        }, {});
        for(l = 0; l < u.length; l += 1){
            var C = s.call(this, u[l], y);
            for(d = 0; d < g.length; d += 1)o.call(this, new a(t, n, y[g[d]], C, u[l][g[d]], l + 2, I[g[d]]));
        }
        return this.internal.__cell__.table_x = t, this.internal.__cell__.table_y = n, this;
    };
    var s = function(t, e) {
        var n = this.internal.__cell__.padding, r = this.internal.__cell__.table_font_size, i = this.internal.scaleFactor;
        return Object.keys(t).map(function(e) {
            return [
                e,
                t[e]
            ];
        }).map(function(t) {
            var e = t[0], n = t[1];
            return "object" == typeof n ? [
                e,
                n.text
            ] : [
                e,
                n
            ];
        }).map(function(t) {
            var r = t[0], i = t[1];
            return this.splitTextToSize(i, e[r] - n - n);
        }, this).map(function(t) {
            return this.getLineHeightFactor() * t.length * r / i + n + n;
        }, this).reduce(function(t, e) {
            return Math.max(t, e);
        }, 0);
    };
    t.setTableHeaderRow = function(t) {
        r.call(this), this.internal.__cell__.tableHeaderRow = t;
    }, t.printHeaderRow = function(t, e) {
        if (r.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
        var i;
        if (n = !0, "function" == typeof this.internal.__cell__.headerFunction) {
            var s = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
            this.internal.__cell__.lastCell = new a(s[0], s[1], s[2], s[3], void 0, -1);
        }
        this.setFont(void 0, "bold");
        for(var u = [], c = 0; c < this.internal.__cell__.tableHeaderRow.length; c += 1)i = this.internal.__cell__.tableHeaderRow[c].clone(), e && (i.y = this.internal.__cell__.margins.top || 0, u.push(i)), i.lineNumber = t, this.setFillColor(this.internal.__cell__.headerBackgroundColor), o.call(this, i);
        u.length > 0 && this.setTableHeaderRow(u), this.setFont(void 0, "normal"), n = !1;
    };
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API), function(t) {
    var e, r, i, a, o, s, u, h, l, f = function(t) {
        return t = t || {}, this.isStrokeTransparent = t.isStrokeTransparent || !1, this.strokeOpacity = t.strokeOpacity || 1, this.strokeStyle = t.strokeStyle || "#000000", this.fillStyle = t.fillStyle || "#000000", this.isFillTransparent = t.isFillTransparent || !1, this.fillOpacity = t.fillOpacity || 1, this.font = t.font || "10px sans-serif", this.textBaseline = t.textBaseline || "alphabetic", this.textAlign = t.textAlign || "left", this.lineWidth = t.lineWidth || 1, this.lineJoin = t.lineJoin || "miter", this.lineCap = t.lineCap || "butt", this.path = t.path || [], this.transform = void 0 !== t.transform ? t.transform.clone() : new h, this.globalCompositeOperation = t.globalCompositeOperation || "normal", this.globalAlpha = t.globalAlpha || 1, this.clip_path = t.clip_path || [], this.currentPoint = t.currentPoint || new s, this.miterLimit = t.miterLimit || 10, this.lastPoint = t.lastPoint || new s, this.ignoreClearRect = "boolean" != typeof t.ignoreClearRect || t.ignoreClearRect, this;
    };
    t.events.push([
        "initialized",
        function() {
            this.context2d = new d(this), e = this.internal.f2, r = this.internal.getCoordinateString, i = this.internal.getVerticalCoordinateString, a = this.internal.getHorizontalCoordinate, o = this.internal.getVerticalCoordinate, s = this.internal.Point, u = this.internal.Rectangle, h = this.internal.Matrix, l = new f;
        }
    ]);
    var d = function(t) {
        Object.defineProperty(this, "canvas", {
            get: function() {
                return {
                    parentNode: !1,
                    style: !1
                };
            }
        });
        var e = t;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return e;
            }
        });
        var n = !1;
        Object.defineProperty(this, "pageWrapXEnabled", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = Boolean(t);
            }
        });
        var r = !1;
        Object.defineProperty(this, "pageWrapYEnabled", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = Boolean(t);
            }
        });
        var i = 0;
        Object.defineProperty(this, "posX", {
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = t);
            }
        });
        var a = 0;
        Object.defineProperty(this, "posY", {
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = t);
            }
        });
        var o = !1;
        Object.defineProperty(this, "autoPaging", {
            get: function() {
                return o;
            },
            set: function(t) {
                o = Boolean(t);
            }
        });
        var s = 0;
        Object.defineProperty(this, "lastBreak", {
            get: function() {
                return s;
            },
            set: function(t) {
                s = t;
            }
        });
        var u = [];
        Object.defineProperty(this, "pageBreaks", {
            get: function() {
                return u;
            },
            set: function(t) {
                u = t;
            }
        }), Object.defineProperty(this, "ctx", {
            get: function() {
                return l;
            },
            set: function(t) {
                t instanceof f && (l = t);
            }
        }), Object.defineProperty(this, "path", {
            get: function() {
                return l.path;
            },
            set: function(t) {
                l.path = t;
            }
        });
        var c = [];
        Object.defineProperty(this, "ctxStack", {
            get: function() {
                return c;
            },
            set: function(t) {
                c = t;
            }
        }), Object.defineProperty(this, "fillStyle", {
            get: function() {
                return this.ctx.fillStyle;
            },
            set: function(t) {
                var e;
                e = p(t), this.ctx.fillStyle = e.style, this.ctx.isFillTransparent = 0 === e.a, this.ctx.fillOpacity = e.a, this.pdf.setFillColor(e.r, e.g, e.b, {
                    a: e.a
                }), this.pdf.setTextColor(e.r, e.g, e.b, {
                    a: e.a
                });
            }
        }), Object.defineProperty(this, "strokeStyle", {
            get: function() {
                return this.ctx.strokeStyle;
            },
            set: function(t) {
                var e = p(t);
                this.ctx.strokeStyle = e.style, this.ctx.isStrokeTransparent = 0 === e.a, this.ctx.strokeOpacity = e.a, 0 === e.a ? this.pdf.setDrawColor(255, 255, 255) : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
            }
        }), Object.defineProperty(this, "lineCap", {
            get: function() {
                return this.ctx.lineCap;
            },
            set: function(t) {
                -1 !== [
                    "butt",
                    "round",
                    "square"
                ].indexOf(t) && (this.ctx.lineCap = t, this.pdf.setLineCap(t));
            }
        }), Object.defineProperty(this, "lineWidth", {
            get: function() {
                return this.ctx.lineWidth;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.lineWidth = t, this.pdf.setLineWidth(t));
            }
        }), Object.defineProperty(this, "lineJoin", {
            get: function() {
                return this.ctx.lineJoin;
            },
            set: function(t) {
                -1 !== [
                    "bevel",
                    "round",
                    "miter"
                ].indexOf(t) && (this.ctx.lineJoin = t, this.pdf.setLineJoin(t));
            }
        }), Object.defineProperty(this, "miterLimit", {
            get: function() {
                return this.ctx.miterLimit;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.miterLimit = t, this.pdf.setMiterLimit(t));
            }
        }), Object.defineProperty(this, "textBaseline", {
            get: function() {
                return this.ctx.textBaseline;
            },
            set: function(t) {
                this.ctx.textBaseline = t;
            }
        }), Object.defineProperty(this, "textAlign", {
            get: function() {
                return this.ctx.textAlign;
            },
            set: function(t) {
                -1 !== [
                    "right",
                    "end",
                    "center",
                    "left",
                    "start"
                ].indexOf(t) && (this.ctx.textAlign = t);
            }
        }), Object.defineProperty(this, "font", {
            get: function() {
                return this.ctx.font;
            },
            set: function(t) {
                var e;
                if (this.ctx.font = t, null !== (e = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))) {
                    var n = e[1], r = (e[2], e[3]), i = e[4], a = (e[5], e[6]), o = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];
                    i = "px" === o ? Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor) : "em" === o ? Math.floor(parseFloat(i) * this.pdf.getFontSize()) : Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(i);
                    var s = "";
                    ("bold" === r || parseInt(r, 10) >= 700 || "bold" === n) && (s = "bold"), "italic" === n && (s += "italic"), 0 === s.length && (s = "normal");
                    for(var u = "", c = a.replace(/"|'/g, "").split(/\s*,\s*/), h = {
                        arial: "Helvetica",
                        Arial: "Helvetica",
                        verdana: "Helvetica",
                        Verdana: "Helvetica",
                        helvetica: "Helvetica",
                        Helvetica: "Helvetica",
                        "sans-serif": "Helvetica",
                        fixed: "Courier",
                        monospace: "Courier",
                        terminal: "Courier",
                        cursive: "Times",
                        fantasy: "Times",
                        serif: "Times"
                    }, l = 0; l < c.length; l++){
                        if (void 0 !== this.pdf.internal.getFont(c[l], s, {
                            noFallback: !0,
                            disableWarning: !0
                        })) {
                            u = c[l];
                            break;
                        }
                        if ("bolditalic" === s && void 0 !== this.pdf.internal.getFont(c[l], "bold", {
                            noFallback: !0,
                            disableWarning: !0
                        })) u = c[l], s = "bold";
                        else if (void 0 !== this.pdf.internal.getFont(c[l], "normal", {
                            noFallback: !0,
                            disableWarning: !0
                        })) {
                            u = c[l], s = "normal";
                            break;
                        }
                    }
                    if ("" === u) {
                        for(var f = 0; f < c.length; f++)if (h[c[f]]) {
                            u = h[c[f]];
                            break;
                        }
                    }
                    u = "" === u ? "Times" : u, this.pdf.setFont(u, s);
                }
            }
        }), Object.defineProperty(this, "globalCompositeOperation", {
            get: function() {
                return this.ctx.globalCompositeOperation;
            },
            set: function(t) {
                this.ctx.globalCompositeOperation = t;
            }
        }), Object.defineProperty(this, "globalAlpha", {
            get: function() {
                return this.ctx.globalAlpha;
            },
            set: function(t) {
                this.ctx.globalAlpha = t;
            }
        }), Object.defineProperty(this, "ignoreClearRect", {
            get: function() {
                return this.ctx.ignoreClearRect;
            },
            set: function(t) {
                this.ctx.ignoreClearRect = Boolean(t);
            }
        });
    };
    d.prototype.fill = function() {
        N.call(this, "fill", !1);
    }, d.prototype.stroke = function() {
        N.call(this, "stroke", !1);
    }, d.prototype.beginPath = function() {
        this.path = [
            {
                type: "begin"
            }
        ];
    }, d.prototype.moveTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $970c7ddf83730f06$var$n.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
        var r = this.ctx.transform.applyToPoint(new s(t, e));
        this.path.push({
            type: "mt",
            x: r.x,
            y: r.y
        }), this.ctx.lastPoint = new s(t, e);
    }, d.prototype.closePath = function() {
        var t = new s(0, 0), e = 0;
        for(e = this.path.length - 1; -1 !== e; e--)if ("begin" === this.path[e].type && "object" == typeof this.path[e + 1] && "number" == typeof this.path[e + 1].x) {
            t = new s(this.path[e + 1].x, this.path[e + 1].y), this.path.push({
                type: "lt",
                x: t.x,
                y: t.y
            });
            break;
        }
        "object" == typeof this.path[e + 2] && "number" == typeof this.path[e + 2].x && this.path.push(JSON.parse(JSON.stringify(this.path[e + 2]))), this.path.push({
            type: "close"
        }), this.ctx.lastPoint = new s(t.x, t.y);
    }, d.prototype.lineTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $970c7ddf83730f06$var$n.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
        var r = this.ctx.transform.applyToPoint(new s(t, e));
        this.path.push({
            type: "lt",
            x: r.x,
            y: r.y
        }), this.ctx.lastPoint = new s(r.x, r.y);
    }, d.prototype.clip = function() {
        this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), N.call(this, null, !0);
    }, d.prototype.quadraticCurveTo = function(t, e, r, i) {
        if (isNaN(r) || isNaN(i) || isNaN(t) || isNaN(e)) throw $970c7ddf83730f06$var$n.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
        var a = this.ctx.transform.applyToPoint(new s(r, i)), o = this.ctx.transform.applyToPoint(new s(t, e));
        this.path.push({
            type: "qct",
            x1: o.x,
            y1: o.y,
            x: a.x,
            y: a.y
        }), this.ctx.lastPoint = new s(a.x, a.y);
    }, d.prototype.bezierCurveTo = function(t, e, r, i, a, o) {
        if (isNaN(a) || isNaN(o) || isNaN(t) || isNaN(e) || isNaN(r) || isNaN(i)) throw $970c7ddf83730f06$var$n.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
        var u = this.ctx.transform.applyToPoint(new s(a, o)), c = this.ctx.transform.applyToPoint(new s(t, e)), h = this.ctx.transform.applyToPoint(new s(r, i));
        this.path.push({
            type: "bct",
            x1: c.x,
            y1: c.y,
            x2: h.x,
            y2: h.y,
            x: u.x,
            y: u.y
        }), this.ctx.lastPoint = new s(u.x, u.y);
    }, d.prototype.arc = function(t, e, r, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(i) || isNaN(a)) throw $970c7ddf83730f06$var$n.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
        if (o = Boolean(o), !this.ctx.transform.isIdentity) {
            var u = this.ctx.transform.applyToPoint(new s(t, e));
            t = u.x, e = u.y;
            var c = this.ctx.transform.applyToPoint(new s(0, r)), h = this.ctx.transform.applyToPoint(new s(0, 0));
            r = Math.sqrt(Math.pow(c.x - h.x, 2) + Math.pow(c.y - h.y, 2));
        }
        Math.abs(a - i) >= 2 * Math.PI && (i = 0, a = 2 * Math.PI), this.path.push({
            type: "arc",
            x: t,
            y: e,
            radius: r,
            startAngle: i,
            endAngle: a,
            counterclockwise: o
        });
    }, d.prototype.arcTo = function(t, e, n, r, i) {
        throw new Error("arcTo not implemented.");
    }, d.prototype.rect = function(t, e, r, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(i)) throw $970c7ddf83730f06$var$n.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
        this.moveTo(t, e), this.lineTo(t + r, e), this.lineTo(t + r, e + i), this.lineTo(t, e + i), this.lineTo(t, e), this.lineTo(t + r, e), this.lineTo(t, e);
    }, d.prototype.fillRect = function(t, e, r, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(i)) throw $970c7ddf83730f06$var$n.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
        if (!g.call(this)) {
            var a = {};
            "butt" !== this.lineCap && (a.lineCap = this.lineCap, this.lineCap = "butt"), "miter" !== this.lineJoin && (a.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(t, e, r, i), this.fill(), a.hasOwnProperty("lineCap") && (this.lineCap = a.lineCap), a.hasOwnProperty("lineJoin") && (this.lineJoin = a.lineJoin);
        }
    }, d.prototype.strokeRect = function(t, e, r, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(i)) throw $970c7ddf83730f06$var$n.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
        m.call(this) || (this.beginPath(), this.rect(t, e, r, i), this.stroke());
    }, d.prototype.clearRect = function(t, e, r, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(i)) throw $970c7ddf83730f06$var$n.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
        this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(t, e, r, i));
    }, d.prototype.save = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, n = 0; n < this.pdf.internal.getNumberOfPages(); n++)this.pdf.setPage(n + 1), this.pdf.internal.out("q");
        if (this.pdf.setPage(e), t) {
            this.ctx.fontSize = this.pdf.internal.getFontSize();
            var r = new f(this.ctx);
            this.ctxStack.push(this.ctx), this.ctx = r;
        }
    }, d.prototype.restore = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, n = 0; n < this.pdf.internal.getNumberOfPages(); n++)this.pdf.setPage(n + 1), this.pdf.internal.out("Q");
        this.pdf.setPage(e), t && 0 !== this.ctxStack.length && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin);
    }, d.prototype.toDataURL = function() {
        throw new Error("toDataUrl not implemented.");
    };
    var p = function(t) {
        var e, n, r, i;
        if (!0 === t.isCanvasGradient && (t = t.getColor()), !t) return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            style: t
        };
        if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t)) e = 0, n = 0, r = 0, i = 0;
        else {
            var a = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);
            if (null !== a) e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = 1;
            else if (null !== (a = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t))) e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = parseFloat(a[4]);
            else {
                if (i = 1, "string" == typeof t && "#" !== t.charAt(0)) {
                    var o = new $970c7ddf83730f06$var$c(t);
                    t = o.ok ? o.toHex() : "#000000";
                }
                4 === t.length ? (e = t.substring(1, 2), e += e, n = t.substring(2, 3), n += n, r = t.substring(3, 4), r += r) : (e = t.substring(1, 3), n = t.substring(3, 5), r = t.substring(5, 7)), e = parseInt(e, 16), n = parseInt(n, 16), r = parseInt(r, 16);
            }
        }
        return {
            r: e,
            g: n,
            b: r,
            a: i,
            style: t
        };
    }, g = function() {
        return this.ctx.isFillTransparent || 0 == this.globalAlpha;
    }, m = function() {
        return Boolean(this.ctx.isStrokeTransparent || 0 == this.globalAlpha);
    };
    d.prototype.fillText = function(t, e, r, i) {
        if (isNaN(e) || isNaN(r) || "string" != typeof t) throw $970c7ddf83730f06$var$n.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
        if (i = isNaN(i) ? void 0 : i, !g.call(this)) {
            r = x.call(this, r);
            var a = O(this.ctx.transform.rotation), o = this.ctx.transform.scaleX;
            k.call(this, {
                text: t,
                x: e,
                y: r,
                scale: o,
                angle: a,
                align: this.textAlign,
                maxWidth: i
            });
        }
    }, d.prototype.strokeText = function(t, e, r, i) {
        if (isNaN(e) || isNaN(r) || "string" != typeof t) throw $970c7ddf83730f06$var$n.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
        if (!m.call(this)) {
            i = isNaN(i) ? void 0 : i, r = x.call(this, r);
            var a = O(this.ctx.transform.rotation), o = this.ctx.transform.scaleX;
            k.call(this, {
                text: t,
                x: e,
                y: r,
                scale: o,
                renderingMode: "stroke",
                angle: a,
                align: this.textAlign,
                maxWidth: i
            });
        }
    }, d.prototype.measureText = function(t) {
        if ("string" != typeof t) throw $970c7ddf83730f06$var$n.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
        var e = this.pdf, r = this.pdf.internal.scaleFactor, i = e.internal.getFontSize(), a = e.getStringUnitWidth(t) * i / e.internal.scaleFactor, o = function(t) {
            var e = (t = t || {}).width || 0;
            return Object.defineProperty(this, "width", {
                get: function() {
                    return e;
                }
            }), this;
        };
        return new o({
            width: a *= Math.round(96 * r / 72 * 1e4) / 1e4
        });
    }, d.prototype.scale = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $970c7ddf83730f06$var$n.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
        var r = new h(t, 0, 0, e, 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(r);
    }, d.prototype.rotate = function(t) {
        if (isNaN(t)) throw $970c7ddf83730f06$var$n.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
        var e = new h(Math.cos(t), Math.sin(t), -Math.sin(t), Math.cos(t), 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(e);
    }, d.prototype.translate = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $970c7ddf83730f06$var$n.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
        var r = new h(1, 0, 0, 1, t, e);
        this.ctx.transform = this.ctx.transform.multiply(r);
    }, d.prototype.transform = function(t, e, r, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(i) || isNaN(a) || isNaN(o)) throw $970c7ddf83730f06$var$n.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
        var s = new h(t, e, r, i, a, o);
        this.ctx.transform = this.ctx.transform.multiply(s);
    }, d.prototype.setTransform = function(t, e, n, r, i, a) {
        t = isNaN(t) ? 1 : t, e = isNaN(e) ? 0 : e, n = isNaN(n) ? 0 : n, r = isNaN(r) ? 1 : r, i = isNaN(i) ? 0 : i, a = isNaN(a) ? 0 : a, this.ctx.transform = new h(t, e, n, r, i, a);
    }, d.prototype.drawImage = function(t, e, n, r, i, a, o, s, c) {
        var l = this.pdf.getImageProperties(t), f = 1, d = 1, p = 1, g = 1;
        void 0 !== r && void 0 !== s && (p = s / r, g = c / i, f = l.width / r * s / r, d = l.height / i * c / i), void 0 === a && (a = e, o = n, e = 0, n = 0), void 0 !== r && void 0 === s && (s = r, c = i), void 0 === r && void 0 === s && (s = l.width, c = l.height);
        for(var m, b = this.ctx.transform.decompose(), N = O(b.rotate.shx), x = new h, A = (x = (x = (x = x.multiply(b.translate)).multiply(b.skew)).multiply(b.scale)).applyToRectangle(new u(a - e * p, o - n * g, r * f, i * d)), _ = v.call(this, A), S = [], P = 0; P < _.length; P += 1)-1 === S.indexOf(_[P]) && S.push(_[P]);
        if (w(S), this.autoPaging) for(var k = S[0], F = S[S.length - 1], I = k; I < F + 1; I++){
            if (this.pdf.setPage(I), 0 !== this.ctx.clip_path.length) {
                var C = this.path;
                m = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = y(m, this.posX, -1 * this.pdf.internal.pageSize.height * (I - 1) + this.posY), L.call(this, "fill", !0), this.path = C;
            }
            var j = JSON.parse(JSON.stringify(A));
            j = y([
                j
            ], this.posX, -1 * this.pdf.internal.pageSize.height * (I - 1) + this.posY)[0], this.pdf.addImage(t, "JPEG", j.x, j.y, j.w, j.h, null, null, N);
        }
        else this.pdf.addImage(t, "JPEG", A.x, A.y, A.w, A.h, null, null, N);
    };
    var v = function(t, e, n) {
        var r = [];
        switch(e = e || this.pdf.internal.pageSize.width, n = n || this.pdf.internal.pageSize.height, t.type){
            default:
            case "mt":
            case "lt":
                r.push(Math.floor((t.y + this.posY) / n) + 1);
                break;
            case "arc":
                r.push(Math.floor((t.y + this.posY - t.radius) / n) + 1), r.push(Math.floor((t.y + this.posY + t.radius) / n) + 1);
                break;
            case "qct":
                var i = M(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x, t.y);
                r.push(Math.floor(i.y / n) + 1), r.push(Math.floor((i.y + i.h) / n) + 1);
                break;
            case "bct":
                var a = E(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x2, t.y2, t.x, t.y);
                r.push(Math.floor(a.y / n) + 1), r.push(Math.floor((a.y + a.h) / n) + 1);
                break;
            case "rect":
                r.push(Math.floor((t.y + this.posY) / n) + 1), r.push(Math.floor((t.y + t.h + this.posY) / n) + 1);
        }
        for(var o = 0; o < r.length; o += 1)for(; this.pdf.internal.getNumberOfPages() < r[o];)b.call(this);
        return r;
    }, b = function() {
        var t = this.fillStyle, e = this.strokeStyle, n = this.font, r = this.lineCap, i = this.lineWidth, a = this.lineJoin;
        this.pdf.addPage(), this.fillStyle = t, this.strokeStyle = e, this.font = n, this.lineCap = r, this.lineWidth = i, this.lineJoin = a;
    }, y = function(t, e, n) {
        for(var r = 0; r < t.length; r++)switch(t[r].type){
            case "bct":
                t[r].x2 += e, t[r].y2 += n;
            case "qct":
                t[r].x1 += e, t[r].y1 += n;
            case "mt":
            case "lt":
            case "arc":
            default:
                t[r].x += e, t[r].y += n;
        }
        return t;
    }, w = function(t) {
        return t.sort(function(t, e) {
            return t - e;
        });
    }, N = function(t, e) {
        for(var n, r, i = this.fillStyle, a = this.strokeStyle, o = this.lineCap, s = this.lineWidth, u = s * this.ctx.transform.scaleX, c = this.lineJoin, h = JSON.parse(JSON.stringify(this.path)), l = JSON.parse(JSON.stringify(this.path)), f = [], d = 0; d < l.length; d++)if (void 0 !== l[d].x) for(var p = v.call(this, l[d]), g = 0; g < p.length; g += 1)-1 === f.indexOf(p[g]) && f.push(p[g]);
        for(var m = 0; m < f.length; m++)for(; this.pdf.internal.getNumberOfPages() < f[m];)b.call(this);
        if (w(f), this.autoPaging) for(var N = f[0], x = f[f.length - 1], A = N; A < x + 1; A++){
            if (this.pdf.setPage(A), this.fillStyle = i, this.strokeStyle = a, this.lineCap = o, this.lineWidth = u, this.lineJoin = c, 0 !== this.ctx.clip_path.length) {
                var _ = this.path;
                n = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = y(n, this.posX, -1 * this.pdf.internal.pageSize.height * (A - 1) + this.posY), L.call(this, t, !0), this.path = _;
            }
            r = JSON.parse(JSON.stringify(h)), this.path = y(r, this.posX, -1 * this.pdf.internal.pageSize.height * (A - 1) + this.posY), !1 !== e && 0 !== A || L.call(this, t, e), this.lineWidth = s;
        }
        else this.lineWidth = u, L.call(this, t, e), this.lineWidth = s;
        this.path = h;
    }, L = function(t, e) {
        if (("stroke" !== t || e || !m.call(this)) && ("stroke" === t || e || !g.call(this))) {
            for(var n, r, i = [], a = this.path, o = 0; o < a.length; o++){
                var s = a[o];
                switch(s.type){
                    case "begin":
                        i.push({
                            begin: !0
                        });
                        break;
                    case "close":
                        i.push({
                            close: !0
                        });
                        break;
                    case "mt":
                        i.push({
                            start: s,
                            deltas: [],
                            abs: []
                        });
                        break;
                    case "lt":
                        var u = i.length;
                        if (!isNaN(a[o - 1].x) && (n = [
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], u > 0)) {
                            for(; u >= 0; u--)if (!0 !== i[u - 1].close && !0 !== i[u - 1].begin) {
                                i[u - 1].deltas.push(n), i[u - 1].abs.push(s);
                                break;
                            }
                        }
                        break;
                    case "bct":
                        n = [
                            s.x1 - a[o - 1].x,
                            s.y1 - a[o - 1].y,
                            s.x2 - a[o - 1].x,
                            s.y2 - a[o - 1].y,
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], i[i.length - 1].deltas.push(n);
                        break;
                    case "qct":
                        var c = a[o - 1].x + 2 / 3 * (s.x1 - a[o - 1].x), h = a[o - 1].y + 2 / 3 * (s.y1 - a[o - 1].y), l = s.x + 2 / 3 * (s.x1 - s.x), f = s.y + 2 / 3 * (s.y1 - s.y), d = s.x, p = s.y;
                        n = [
                            c - a[o - 1].x,
                            h - a[o - 1].y,
                            l - a[o - 1].x,
                            f - a[o - 1].y,
                            d - a[o - 1].x,
                            p - a[o - 1].y
                        ], i[i.length - 1].deltas.push(n);
                        break;
                    case "arc":
                        i.push({
                            deltas: [],
                            abs: [],
                            arc: !0
                        }), Array.isArray(i[i.length - 1].abs) && i[i.length - 1].abs.push(s);
                }
            }
            r = e ? null : "stroke" === t ? "stroke" : "fill";
            for(var v = 0; v < i.length; v++){
                if (i[v].arc) {
                    for(var b = i[v].abs, y = 0; y < b.length; y++){
                        var w = b[y];
                        "arc" === w.type ? A.call(this, w.x, w.y, w.radius, w.startAngle, w.endAngle, w.counterclockwise, void 0, e) : F.call(this, w.x, w.y);
                    }
                    _.call(this, r), this.pdf.internal.out("h");
                }
                if (!i[v].arc && !0 !== i[v].close && !0 !== i[v].begin) {
                    var N = i[v].start.x, L = i[v].start.y;
                    I.call(this, i[v].deltas, N, L);
                }
            }
            r && _.call(this, r), e && S.call(this);
        }
    }, x = function(t) {
        var e = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, n = e * (this.pdf.internal.getLineHeightFactor() - 1);
        switch(this.ctx.textBaseline){
            case "bottom":
                return t - n;
            case "top":
                return t + e - n;
            case "hanging":
                return t + e - 2 * n;
            case "middle":
                return t + e / 2 - n;
            case "ideographic":
                return t;
            case "alphabetic":
            default:
                return t;
        }
    };
    d.prototype.createLinearGradient = function() {
        var t = function() {};
        return t.colorStops = [], t.addColorStop = function(t, e) {
            this.colorStops.push([
                t,
                e
            ]);
        }, t.getColor = function() {
            return 0 === this.colorStops.length ? "#000000" : this.colorStops[0][1];
        }, t.isCanvasGradient = !0, t;
    }, d.prototype.createPattern = function() {
        return this.createLinearGradient();
    }, d.prototype.createRadialGradient = function() {
        return this.createLinearGradient();
    };
    var A = function(t, e, n, r, i, a, o, s) {
        for(var u = j.call(this, n, r, i, a), c = 0; c < u.length; c++){
            var h = u[c];
            0 === c && P.call(this, h.x1 + t, h.y1 + e), C.call(this, t, e, h.x2, h.y2, h.x3, h.y3, h.x4, h.y4);
        }
        s ? S.call(this) : _.call(this, o);
    }, _ = function(t) {
        switch(t){
            case "stroke":
                this.pdf.internal.out("S");
                break;
            case "fill":
                this.pdf.internal.out("f");
        }
    }, S = function() {
        this.pdf.clip(), this.pdf.discardPath();
    }, P = function(t, e) {
        this.pdf.internal.out(r(t) + " " + i(e) + " m");
    }, k = function(t) {
        var e;
        switch(t.align){
            case "right":
            case "end":
                e = "right";
                break;
            case "center":
                e = "center";
                break;
            case "left":
            case "start":
            default:
                e = "left";
        }
        var n = this.ctx.transform.applyToPoint(new s(t.x, t.y)), r = this.ctx.transform.decompose(), i = new h;
        i = (i = (i = i.multiply(r.translate)).multiply(r.skew)).multiply(r.scale);
        for(var a, o, c, l = this.pdf.getTextDimensions(t.text), f = this.ctx.transform.applyToRectangle(new u(t.x, t.y, l.w, l.h)), d = i.applyToRectangle(new u(t.x, t.y - l.h, l.w, l.h)), p = v.call(this, d), g = [], m = 0; m < p.length; m += 1)-1 === g.indexOf(p[m]) && g.push(p[m]);
        if (w(g), !0 === this.autoPaging) for(var b = g[0], N = g[g.length - 1], x = b; x < N + 1; x++){
            if (this.pdf.setPage(x), 0 !== this.ctx.clip_path.length) {
                var A = this.path;
                a = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = y(a, this.posX, -1 * this.pdf.internal.pageSize.height * (x - 1) + this.posY), L.call(this, "fill", !0), this.path = A;
            }
            var _ = JSON.parse(JSON.stringify(f));
            _ = y([
                _
            ], this.posX, -1 * this.pdf.internal.pageSize.height * (x - 1) + this.posY)[0], t.scale >= .01 && (o = this.pdf.internal.getFontSize(), this.pdf.setFontSize(o * t.scale), c = this.lineWidth, this.lineWidth = c * t.scale), this.pdf.text(t.text, _.x, _.y, {
                angle: t.angle,
                align: e,
                renderingMode: t.renderingMode,
                maxWidth: t.maxWidth
            }), t.scale >= .01 && (this.pdf.setFontSize(o), this.lineWidth = c);
        }
        else t.scale >= .01 && (o = this.pdf.internal.getFontSize(), this.pdf.setFontSize(o * t.scale), c = this.lineWidth, this.lineWidth = c * t.scale), this.pdf.text(t.text, n.x + this.posX, n.y + this.posY, {
            angle: t.angle,
            align: e,
            renderingMode: t.renderingMode,
            maxWidth: t.maxWidth
        }), t.scale >= .01 && (this.pdf.setFontSize(o), this.lineWidth = c);
    }, F = function(t, e, n, a) {
        n = n || 0, a = a || 0, this.pdf.internal.out(r(t + n) + " " + i(e + a) + " l");
    }, I = function(t, e, n) {
        return this.pdf.lines(t, e, n, null, null);
    }, C = function(t, n, r, i, s, u, c, h) {
        this.pdf.internal.out([
            e(a(r + t)),
            e(o(i + n)),
            e(a(s + t)),
            e(o(u + n)),
            e(a(c + t)),
            e(o(h + n)),
            "c"
        ].join(" "));
    }, j = function(t, e, n, r) {
        for(var i = 2 * Math.PI, a = Math.PI / 2; e > n;)e -= i;
        var o = Math.abs(n - e);
        o < i && r && (o = i - o);
        for(var s = [], u = r ? -1 : 1, c = e; o > 1e-5;){
            var h = c + u * Math.min(o, a);
            s.push(B.call(this, t, c, h)), o -= Math.abs(h - c), c = h;
        }
        return s;
    }, B = function(t, e, n) {
        var r = (n - e) / 2, i = t * Math.cos(r), a = t * Math.sin(r), o = i, s = -a, u = o * o + s * s, c = u + o * i + s * a, h = 4 / 3 * (Math.sqrt(2 * u * c) - c) / (o * a - s * i), l = o - h * s, f = s + h * o, d = l, p = -f, g = r + e, m = Math.cos(g), v = Math.sin(g);
        return {
            x1: t * Math.cos(e),
            y1: t * Math.sin(e),
            x2: l * m - f * v,
            y2: l * v + f * m,
            x3: d * m - p * v,
            y3: d * v + p * m,
            x4: t * Math.cos(n),
            y4: t * Math.sin(n)
        };
    }, O = function(t) {
        return 180 * t / Math.PI;
    }, M = function(t, e, n, r, i, a) {
        var o = t + .5 * (n - t), s = e + .5 * (r - e), c = i + .5 * (n - i), h = a + .5 * (r - a), l = Math.min(t, i, o, c), f = Math.max(t, i, o, c), d = Math.min(e, a, s, h), p = Math.max(e, a, s, h);
        return new u(l, d, f - l, p - d);
    }, E = function(t, e, n, r, i, a, o, s) {
        var c, h, l, f, d, p, g, m, v, b, y, w, N, L, x = n - t, A = r - e, _ = i - n, S = a - r, P = o - i, k = s - a;
        for(h = 0; h < 41; h++)v = (g = (l = t + (c = h / 40) * x) + c * ((d = n + c * _) - l)) + c * (d + c * (i + c * P - d) - g), b = (m = (f = e + c * A) + c * ((p = r + c * S) - f)) + c * (p + c * (a + c * k - p) - m), 0 == h ? (y = v, w = b, N = v, L = b) : (y = Math.min(y, v), w = Math.min(w, b), N = Math.max(N, v), L = Math.max(L, b));
        return new u(Math.round(y), Math.round(w), Math.round(N - y), Math.round(L - w));
    };
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API);
/**
 * @license
 Copyright (c) 2013 Gildas Lormeau. All rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are met:

 1. Redistributions of source code must retain the above copyright notice,
 this list of conditions and the following disclaimer.

 2. Redistributions in binary form must reproduce the above copyright 
 notice, this list of conditions and the following disclaimer in 
 the documentation and/or other materials provided with the distribution.

 3. The names of the authors may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ var $970c7ddf83730f06$var$lt = [
    0,
    1,
    2,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    6,
    6,
    7,
    7,
    7,
    7,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    11,
    11,
    11,
    11,
    11,
    11,
    11,
    11,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    15,
    0,
    0,
    16,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    28,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29,
    29
];
function $970c7ddf83730f06$var$ft() {
    var t = this;
    function e(t, e) {
        var n = 0;
        do n |= 1 & t, t >>>= 1, n <<= 1;
        while (--e > 0);
        return n >>> 1;
    }
    t.build_tree = function(n) {
        var r, i, a, o = t.dyn_tree, s = t.stat_desc.static_tree, u = t.stat_desc.elems, c = -1;
        for(n.heap_len = 0, n.heap_max = 573, r = 0; r < u; r++)0 !== o[2 * r] ? (n.heap[++n.heap_len] = c = r, n.depth[r] = 0) : o[2 * r + 1] = 0;
        for(; n.heap_len < 2;)o[2 * (a = n.heap[++n.heap_len] = c < 2 ? ++c : 0)] = 1, n.depth[a] = 0, n.opt_len--, s && (n.static_len -= s[2 * a + 1]);
        for(t.max_code = c, r = Math.floor(n.heap_len / 2); r >= 1; r--)n.pqdownheap(o, r);
        a = u;
        do r = n.heap[1], n.heap[1] = n.heap[n.heap_len--], n.pqdownheap(o, 1), i = n.heap[1], n.heap[--n.heap_max] = r, n.heap[--n.heap_max] = i, o[2 * a] = o[2 * r] + o[2 * i], n.depth[a] = Math.max(n.depth[r], n.depth[i]) + 1, o[2 * r + 1] = o[2 * i + 1] = a, n.heap[1] = a++, n.pqdownheap(o, 1);
        while (n.heap_len >= 2);
        n.heap[--n.heap_max] = n.heap[1], function(e) {
            var n, r, i, a, o, s, u = t.dyn_tree, c = t.stat_desc.static_tree, h = t.stat_desc.extra_bits, l = t.stat_desc.extra_base, f = t.stat_desc.max_length, d = 0;
            for(a = 0; a <= 15; a++)e.bl_count[a] = 0;
            for(u[2 * e.heap[e.heap_max] + 1] = 0, n = e.heap_max + 1; n < 573; n++)(a = u[2 * u[2 * (r = e.heap[n]) + 1] + 1] + 1) > f && (a = f, d++), u[2 * r + 1] = a, r > t.max_code || (e.bl_count[a]++, o = 0, r >= l && (o = h[r - l]), s = u[2 * r], e.opt_len += s * (a + o), c && (e.static_len += s * (c[2 * r + 1] + o)));
            if (0 !== d) {
                do {
                    for(a = f - 1; 0 === e.bl_count[a];)a--;
                    e.bl_count[a]--, e.bl_count[a + 1] += 2, e.bl_count[f]--, d -= 2;
                }while (d > 0);
                for(a = f; 0 !== a; a--)for(r = e.bl_count[a]; 0 !== r;)(i = e.heap[--n]) > t.max_code || (u[2 * i + 1] !== a && (e.opt_len += (a - u[2 * i + 1]) * u[2 * i], u[2 * i + 1] = a), r--);
            }
        }(n), function(t, n, r) {
            var i, a, o, s = [], u = 0;
            for(i = 1; i <= 15; i++)s[i] = u = u + r[i - 1] << 1;
            for(a = 0; a <= n; a++)0 !== (o = t[2 * a + 1]) && (t[2 * a] = e(s[o]++, o));
        }(o, t.max_code, n.bl_count);
    };
}
function $970c7ddf83730f06$var$dt(t, e, n, r, i) {
    this.static_tree = t, this.extra_bits = e, this.extra_base = n, this.elems = r, this.max_length = i;
}
$970c7ddf83730f06$var$ft._length_code = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    25,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    26,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    27,
    28
], $970c7ddf83730f06$var$ft.base_length = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    10,
    12,
    14,
    16,
    20,
    24,
    28,
    32,
    40,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    160,
    192,
    224,
    0
], $970c7ddf83730f06$var$ft.base_dist = [
    0,
    1,
    2,
    3,
    4,
    6,
    8,
    12,
    16,
    24,
    32,
    48,
    64,
    96,
    128,
    192,
    256,
    384,
    512,
    768,
    1024,
    1536,
    2048,
    3072,
    4096,
    6144,
    8192,
    12288,
    16384,
    24576
], $970c7ddf83730f06$var$ft.d_code = function(t) {
    return t < 256 ? $970c7ddf83730f06$var$lt[t] : $970c7ddf83730f06$var$lt[256 + (t >>> 7)];
}, $970c7ddf83730f06$var$ft.extra_lbits = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
], $970c7ddf83730f06$var$ft.extra_dbits = [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
], $970c7ddf83730f06$var$ft.extra_blbits = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
], $970c7ddf83730f06$var$ft.bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
], $970c7ddf83730f06$var$dt.static_ltree = [
    12,
    8,
    140,
    8,
    76,
    8,
    204,
    8,
    44,
    8,
    172,
    8,
    108,
    8,
    236,
    8,
    28,
    8,
    156,
    8,
    92,
    8,
    220,
    8,
    60,
    8,
    188,
    8,
    124,
    8,
    252,
    8,
    2,
    8,
    130,
    8,
    66,
    8,
    194,
    8,
    34,
    8,
    162,
    8,
    98,
    8,
    226,
    8,
    18,
    8,
    146,
    8,
    82,
    8,
    210,
    8,
    50,
    8,
    178,
    8,
    114,
    8,
    242,
    8,
    10,
    8,
    138,
    8,
    74,
    8,
    202,
    8,
    42,
    8,
    170,
    8,
    106,
    8,
    234,
    8,
    26,
    8,
    154,
    8,
    90,
    8,
    218,
    8,
    58,
    8,
    186,
    8,
    122,
    8,
    250,
    8,
    6,
    8,
    134,
    8,
    70,
    8,
    198,
    8,
    38,
    8,
    166,
    8,
    102,
    8,
    230,
    8,
    22,
    8,
    150,
    8,
    86,
    8,
    214,
    8,
    54,
    8,
    182,
    8,
    118,
    8,
    246,
    8,
    14,
    8,
    142,
    8,
    78,
    8,
    206,
    8,
    46,
    8,
    174,
    8,
    110,
    8,
    238,
    8,
    30,
    8,
    158,
    8,
    94,
    8,
    222,
    8,
    62,
    8,
    190,
    8,
    126,
    8,
    254,
    8,
    1,
    8,
    129,
    8,
    65,
    8,
    193,
    8,
    33,
    8,
    161,
    8,
    97,
    8,
    225,
    8,
    17,
    8,
    145,
    8,
    81,
    8,
    209,
    8,
    49,
    8,
    177,
    8,
    113,
    8,
    241,
    8,
    9,
    8,
    137,
    8,
    73,
    8,
    201,
    8,
    41,
    8,
    169,
    8,
    105,
    8,
    233,
    8,
    25,
    8,
    153,
    8,
    89,
    8,
    217,
    8,
    57,
    8,
    185,
    8,
    121,
    8,
    249,
    8,
    5,
    8,
    133,
    8,
    69,
    8,
    197,
    8,
    37,
    8,
    165,
    8,
    101,
    8,
    229,
    8,
    21,
    8,
    149,
    8,
    85,
    8,
    213,
    8,
    53,
    8,
    181,
    8,
    117,
    8,
    245,
    8,
    13,
    8,
    141,
    8,
    77,
    8,
    205,
    8,
    45,
    8,
    173,
    8,
    109,
    8,
    237,
    8,
    29,
    8,
    157,
    8,
    93,
    8,
    221,
    8,
    61,
    8,
    189,
    8,
    125,
    8,
    253,
    8,
    19,
    9,
    275,
    9,
    147,
    9,
    403,
    9,
    83,
    9,
    339,
    9,
    211,
    9,
    467,
    9,
    51,
    9,
    307,
    9,
    179,
    9,
    435,
    9,
    115,
    9,
    371,
    9,
    243,
    9,
    499,
    9,
    11,
    9,
    267,
    9,
    139,
    9,
    395,
    9,
    75,
    9,
    331,
    9,
    203,
    9,
    459,
    9,
    43,
    9,
    299,
    9,
    171,
    9,
    427,
    9,
    107,
    9,
    363,
    9,
    235,
    9,
    491,
    9,
    27,
    9,
    283,
    9,
    155,
    9,
    411,
    9,
    91,
    9,
    347,
    9,
    219,
    9,
    475,
    9,
    59,
    9,
    315,
    9,
    187,
    9,
    443,
    9,
    123,
    9,
    379,
    9,
    251,
    9,
    507,
    9,
    7,
    9,
    263,
    9,
    135,
    9,
    391,
    9,
    71,
    9,
    327,
    9,
    199,
    9,
    455,
    9,
    39,
    9,
    295,
    9,
    167,
    9,
    423,
    9,
    103,
    9,
    359,
    9,
    231,
    9,
    487,
    9,
    23,
    9,
    279,
    9,
    151,
    9,
    407,
    9,
    87,
    9,
    343,
    9,
    215,
    9,
    471,
    9,
    55,
    9,
    311,
    9,
    183,
    9,
    439,
    9,
    119,
    9,
    375,
    9,
    247,
    9,
    503,
    9,
    15,
    9,
    271,
    9,
    143,
    9,
    399,
    9,
    79,
    9,
    335,
    9,
    207,
    9,
    463,
    9,
    47,
    9,
    303,
    9,
    175,
    9,
    431,
    9,
    111,
    9,
    367,
    9,
    239,
    9,
    495,
    9,
    31,
    9,
    287,
    9,
    159,
    9,
    415,
    9,
    95,
    9,
    351,
    9,
    223,
    9,
    479,
    9,
    63,
    9,
    319,
    9,
    191,
    9,
    447,
    9,
    127,
    9,
    383,
    9,
    255,
    9,
    511,
    9,
    0,
    7,
    64,
    7,
    32,
    7,
    96,
    7,
    16,
    7,
    80,
    7,
    48,
    7,
    112,
    7,
    8,
    7,
    72,
    7,
    40,
    7,
    104,
    7,
    24,
    7,
    88,
    7,
    56,
    7,
    120,
    7,
    4,
    7,
    68,
    7,
    36,
    7,
    100,
    7,
    20,
    7,
    84,
    7,
    52,
    7,
    116,
    7,
    3,
    8,
    131,
    8,
    67,
    8,
    195,
    8,
    35,
    8,
    163,
    8,
    99,
    8,
    227,
    8
], $970c7ddf83730f06$var$dt.static_dtree = [
    0,
    5,
    16,
    5,
    8,
    5,
    24,
    5,
    4,
    5,
    20,
    5,
    12,
    5,
    28,
    5,
    2,
    5,
    18,
    5,
    10,
    5,
    26,
    5,
    6,
    5,
    22,
    5,
    14,
    5,
    30,
    5,
    1,
    5,
    17,
    5,
    9,
    5,
    25,
    5,
    5,
    5,
    21,
    5,
    13,
    5,
    29,
    5,
    3,
    5,
    19,
    5,
    11,
    5,
    27,
    5,
    7,
    5,
    23,
    5
], $970c7ddf83730f06$var$dt.static_l_desc = new $970c7ddf83730f06$var$dt($970c7ddf83730f06$var$dt.static_ltree, $970c7ddf83730f06$var$ft.extra_lbits, 257, 286, 15), $970c7ddf83730f06$var$dt.static_d_desc = new $970c7ddf83730f06$var$dt($970c7ddf83730f06$var$dt.static_dtree, $970c7ddf83730f06$var$ft.extra_dbits, 0, 30, 15), $970c7ddf83730f06$var$dt.static_bl_desc = new $970c7ddf83730f06$var$dt(null, $970c7ddf83730f06$var$ft.extra_blbits, 0, 19, 7);
function $970c7ddf83730f06$var$pt(t, e, n, r, i) {
    this.good_length = t, this.max_lazy = e, this.nice_length = n, this.max_chain = r, this.func = i;
}
var $970c7ddf83730f06$var$gt, $970c7ddf83730f06$var$mt, $970c7ddf83730f06$var$vt, $970c7ddf83730f06$var$bt = [
    new $970c7ddf83730f06$var$pt(0, 0, 0, 0, 0),
    new $970c7ddf83730f06$var$pt(4, 4, 8, 4, 1),
    new $970c7ddf83730f06$var$pt(4, 5, 16, 8, 1),
    new $970c7ddf83730f06$var$pt(4, 6, 32, 32, 1),
    new $970c7ddf83730f06$var$pt(4, 4, 16, 16, 2),
    new $970c7ddf83730f06$var$pt(8, 16, 32, 32, 2),
    new $970c7ddf83730f06$var$pt(8, 16, 128, 128, 2),
    new $970c7ddf83730f06$var$pt(8, 32, 128, 256, 2),
    new $970c7ddf83730f06$var$pt(32, 128, 258, 1024, 2),
    new $970c7ddf83730f06$var$pt(32, 258, 258, 4096, 2)
], $970c7ddf83730f06$var$yt = [
    "need dictionary",
    "stream end",
    "",
    "",
    "stream error",
    "data error",
    "",
    "buffer error",
    "",
    ""
];
function $970c7ddf83730f06$var$wt(t, e, n, r) {
    var i = t[2 * e], a = t[2 * n];
    return i < a || i === a && r[e] <= r[n];
}
function $970c7ddf83730f06$var$Nt() {
    var t, e, n, r, i, a, o, s, u, c, h, l, f, d, p, g, m, v, b, y, w, N, L, x, A, _, S, P, k, F, I, C, j, B, O, M, E, q, R, T, D, U = this, z = new $970c7ddf83730f06$var$ft, H = new $970c7ddf83730f06$var$ft, W = new $970c7ddf83730f06$var$ft;
    function V() {
        var t;
        for(t = 0; t < 286; t++)I[2 * t] = 0;
        for(t = 0; t < 30; t++)C[2 * t] = 0;
        for(t = 0; t < 19; t++)j[2 * t] = 0;
        I[512] = 1, U.opt_len = U.static_len = 0, M = q = 0;
    }
    function G(t, e) {
        var n, r, i = -1, a = t[1], o = 0, s = 7, u = 4;
        for(0 === a && (s = 138, u = 3), t[2 * (e + 1) + 1] = 65535, n = 0; n <= e; n++)r = a, a = t[2 * (n + 1) + 1], ++o < s && r === a || (o < u ? j[2 * r] += o : 0 !== r ? (r !== i && j[2 * r]++, j[32]++) : o <= 10 ? j[34]++ : j[36]++, o = 0, i = r, 0 === a ? (s = 138, u = 3) : r === a ? (s = 6, u = 3) : (s = 7, u = 4));
    }
    function Y(t) {
        U.pending_buf[U.pending++] = t;
    }
    function J(t) {
        Y(255 & t), Y(t >>> 8 & 255);
    }
    function X(t, e) {
        var n, r = e;
        D > 16 - r ? (J(T |= (n = t) << D & 65535), T = n >>> 16 - D, D += r - 16) : (T |= t << D & 65535, D += r);
    }
    function K(t, e) {
        var n = 2 * t;
        X(65535 & e[n], 65535 & e[n + 1]);
    }
    function Z(t, e) {
        var n, r, i = -1, a = t[1], o = 0, s = 7, u = 4;
        for(0 === a && (s = 138, u = 3), n = 0; n <= e; n++)if (r = a, a = t[2 * (n + 1) + 1], !(++o < s && r === a)) {
            if (o < u) do K(r, j);
            while (0 != --o);
            else 0 !== r ? (r !== i && (K(r, j), o--), K(16, j), X(o - 3, 2)) : o <= 10 ? (K(17, j), X(o - 3, 3)) : (K(18, j), X(o - 11, 7));
            o = 0, i = r, 0 === a ? (s = 138, u = 3) : r === a ? (s = 6, u = 3) : (s = 7, u = 4);
        }
    }
    function $() {
        16 === D ? (J(T), T = 0, D = 0) : D >= 8 && (Y(255 & T), T >>>= 8, D -= 8);
    }
    function Q(t, e) {
        var n, r, i;
        if (U.pending_buf[E + 2 * M] = t >>> 8 & 255, U.pending_buf[E + 2 * M + 1] = 255 & t, U.pending_buf[B + M] = 255 & e, M++, 0 === t ? I[2 * e]++ : (q++, t--, I[2 * ($970c7ddf83730f06$var$ft._length_code[e] + 256 + 1)]++, C[2 * $970c7ddf83730f06$var$ft.d_code(t)]++), 0 == (8191 & M) && S > 2) {
            for(n = 8 * M, r = w - m, i = 0; i < 30; i++)n += C[2 * i] * (5 + $970c7ddf83730f06$var$ft.extra_dbits[i]);
            if (n >>>= 3, q < Math.floor(M / 2) && n < Math.floor(r / 2)) return !0;
        }
        return M === O - 1;
    }
    function tt(t, e) {
        var n, r, i, a, o = 0;
        if (0 !== M) do n = U.pending_buf[E + 2 * o] << 8 & 65280 | 255 & U.pending_buf[E + 2 * o + 1], r = 255 & U.pending_buf[B + o], o++, 0 === n ? K(r, t) : (K((i = $970c7ddf83730f06$var$ft._length_code[r]) + 256 + 1, t), 0 !== (a = $970c7ddf83730f06$var$ft.extra_lbits[i]) && X(r -= $970c7ddf83730f06$var$ft.base_length[i], a), n--, K(i = $970c7ddf83730f06$var$ft.d_code(n), e), 0 !== (a = $970c7ddf83730f06$var$ft.extra_dbits[i]) && X(n -= $970c7ddf83730f06$var$ft.base_dist[i], a));
        while (o < M);
        K(256, t), R = t[513];
    }
    function et() {
        D > 8 ? J(T) : D > 0 && Y(255 & T), T = 0, D = 0;
    }
    function nt(t, e, n) {
        X(0 + (n ? 1 : 0), 3), function(t, e, n) {
            et(), R = 8, n && (J(e), J(~e)), U.pending_buf.set(s.subarray(t, t + e), U.pending), U.pending += e;
        }(t, e, !0);
    }
    function rt(t, e, n) {
        var r, i, a = 0;
        S > 0 ? (z.build_tree(U), H.build_tree(U), a = function() {
            var t;
            for(G(I, z.max_code), G(C, H.max_code), W.build_tree(U), t = 18; t >= 3 && 0 === j[2 * $970c7ddf83730f06$var$ft.bl_order[t] + 1]; t--);
            return U.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
        }(), r = U.opt_len + 3 + 7 >>> 3, (i = U.static_len + 3 + 7 >>> 3) <= r && (r = i)) : r = i = e + 5, e + 4 <= r && -1 !== t ? nt(t, e, n) : i === r ? (X(2 + (n ? 1 : 0), 3), tt($970c7ddf83730f06$var$dt.static_ltree, $970c7ddf83730f06$var$dt.static_dtree)) : (X(4 + (n ? 1 : 0), 3), function(t, e, n) {
            var r;
            for(X(t - 257, 5), X(e - 1, 5), X(n - 4, 4), r = 0; r < n; r++)X(j[2 * $970c7ddf83730f06$var$ft.bl_order[r] + 1], 3);
            Z(I, t - 1), Z(C, e - 1);
        }(z.max_code + 1, H.max_code + 1, a + 1), tt(I, C)), V(), n && et();
    }
    function it(e) {
        rt(m >= 0 ? m : -1, w - m, e), m = w, t.flush_pending();
    }
    function at() {
        var e, n, r, a;
        do {
            if (0 === (a = u - L - w) && 0 === w && 0 === L) a = i;
            else if (-1 === a) a--;
            else if (w >= i + i - 262) {
                s.set(s.subarray(i, i + i), 0), N -= i, w -= i, m -= i, r = e = f;
                do n = 65535 & h[--r], h[r] = n >= i ? n - i : 0;
                while (0 != --e);
                r = e = i;
                do n = 65535 & c[--r], c[r] = n >= i ? n - i : 0;
                while (0 != --e);
                a += i;
            }
            if (0 === t.avail_in) return;
            e = t.read_buf(s, w + L, a), (L += e) >= 3 && (l = ((l = 255 & s[w]) << g ^ 255 & s[w + 1]) & p);
        }while (L < 262 && 0 !== t.avail_in);
    }
    function ot(t) {
        var e, n, r = A, a = w, u = x, h = w > i - 262 ? w - (i - 262) : 0, l = F, f = o, d = w + 258, p = s[a + u - 1], g = s[a + u];
        x >= k && (r >>= 2), l > L && (l = L);
        do if (s[(e = t) + u] === g && s[e + u - 1] === p && s[e] === s[a] && s[++e] === s[a + 1]) {
            a += 2, e++;
            do ;
            while (s[++a] === s[++e] && s[++a] === s[++e] && s[++a] === s[++e] && s[++a] === s[++e] && s[++a] === s[++e] && s[++a] === s[++e] && s[++a] === s[++e] && s[++a] === s[++e] && a < d);
            if (n = 258 - (d - a), a = d - 258, n > u) {
                if (N = t, u = n, n >= l) break;
                p = s[a + u - 1], g = s[a + u];
            }
        }
        while ((t = 65535 & c[t & f]) > h && 0 != --r);
        return u <= L ? u : L;
    }
    function st(t) {
        return t.total_in = t.total_out = 0, t.msg = null, U.pending = 0, U.pending_out = 0, e = 113, r = 0, z.dyn_tree = I, z.stat_desc = $970c7ddf83730f06$var$dt.static_l_desc, H.dyn_tree = C, H.stat_desc = $970c7ddf83730f06$var$dt.static_d_desc, W.dyn_tree = j, W.stat_desc = $970c7ddf83730f06$var$dt.static_bl_desc, T = 0, D = 0, R = 8, V(), function() {
            var t;
            for(u = 2 * i, h[f - 1] = 0, t = 0; t < f - 1; t++)h[t] = 0;
            _ = $970c7ddf83730f06$var$bt[S].max_lazy, k = $970c7ddf83730f06$var$bt[S].good_length, F = $970c7ddf83730f06$var$bt[S].nice_length, A = $970c7ddf83730f06$var$bt[S].max_chain, w = 0, m = 0, L = 0, v = x = 2, y = 0, l = 0;
        }(), 0;
    }
    U.depth = [], U.bl_count = [], U.heap = [], I = [], C = [], j = [], U.pqdownheap = function(t, e) {
        for(var n = U.heap, r = n[e], i = e << 1; i <= U.heap_len && (i < U.heap_len && $970c7ddf83730f06$var$wt(t, n[i + 1], n[i], U.depth) && i++, !$970c7ddf83730f06$var$wt(t, r, n[i], U.depth));)n[e] = n[i], e = i, i <<= 1;
        n[e] = r;
    }, U.deflateInit = function(t, e, r, u, l, m) {
        return u || (u = 8), l || (l = 8), m || (m = 0), t.msg = null, -1 === e && (e = 6), l < 1 || l > 9 || 8 !== u || r < 9 || r > 15 || e < 0 || e > 9 || m < 0 || m > 2 ? -2 : (t.dstate = U, o = (i = 1 << (a = r)) - 1, p = (f = 1 << (d = l + 7)) - 1, g = Math.floor((d + 3 - 1) / 3), s = new Uint8Array(2 * i), c = [], h = [], O = 1 << l + 6, U.pending_buf = new Uint8Array(4 * O), n = 4 * O, E = Math.floor(O / 2), B = 3 * O, S = e, P = m, st(t));
    }, U.deflateEnd = function() {
        return 42 !== e && 113 !== e && 666 !== e ? -2 : (U.pending_buf = null, h = null, c = null, s = null, U.dstate = null, 113 === e ? -3 : 0);
    }, U.deflateParams = function(t, e, n) {
        var r = 0;
        return -1 === e && (e = 6), e < 0 || e > 9 || n < 0 || n > 2 ? -2 : ($970c7ddf83730f06$var$bt[S].func !== $970c7ddf83730f06$var$bt[e].func && 0 !== t.total_in && (r = t.deflate(1)), S !== e && (_ = $970c7ddf83730f06$var$bt[S = e].max_lazy, k = $970c7ddf83730f06$var$bt[S].good_length, F = $970c7ddf83730f06$var$bt[S].nice_length, A = $970c7ddf83730f06$var$bt[S].max_chain), P = n, r);
    }, U.deflateSetDictionary = function(t, n, r) {
        var a, u = r, f = 0;
        if (!n || 42 !== e) return -2;
        if (u < 3) return 0;
        for(u > i - 262 && (f = r - (u = i - 262)), s.set(n.subarray(f, f + u), 0), w = u, m = u, l = ((l = 255 & s[0]) << g ^ 255 & s[1]) & p, a = 0; a <= u - 3; a++)l = (l << g ^ 255 & s[a + 2]) & p, c[a & o] = h[l], h[l] = a;
        return 0;
    }, U.deflate = function(u, d) {
        var A, k, F, I, C, j;
        if (d > 4 || d < 0) return -2;
        if (!u.next_out || !u.next_in && 0 !== u.avail_in || 666 === e && 4 !== d) return u.msg = $970c7ddf83730f06$var$yt[4], -2;
        if (0 === u.avail_out) return u.msg = $970c7ddf83730f06$var$yt[7], -5;
        if (t = u, I = r, r = d, 42 === e && (k = 8 + (a - 8 << 4) << 8, (F = (S - 1 & 255) >> 1) > 3 && (F = 3), k |= F << 6, 0 !== w && (k |= 32), e = 113, Y((j = k += 31 - k % 31) >> 8 & 255), Y(255 & j)), 0 !== U.pending) {
            if (t.flush_pending(), 0 === t.avail_out) return r = -1, 0;
        } else if (0 === t.avail_in && d <= I && 4 !== d) return t.msg = $970c7ddf83730f06$var$yt[7], -5;
        if (666 === e && 0 !== t.avail_in) return u.msg = $970c7ddf83730f06$var$yt[7], -5;
        if (0 !== t.avail_in || 0 !== L || 0 !== d && 666 !== e) {
            switch(C = -1, $970c7ddf83730f06$var$bt[S].func){
                case 0:
                    C = function(e) {
                        var r, a = 65535;
                        for(a > n - 5 && (a = n - 5);;){
                            if (L <= 1) {
                                if (at(), 0 === L && 0 === e) return 0;
                                if (0 === L) break;
                            }
                            if (w += L, L = 0, r = m + a, (0 === w || w >= r) && (L = w - r, w = r, it(!1), 0 === t.avail_out)) return 0;
                            if (w - m >= i - 262 && (it(!1), 0 === t.avail_out)) return 0;
                        }
                        return it(4 === e), 0 === t.avail_out ? 4 === e ? 2 : 0 : 4 === e ? 3 : 1;
                    }(d);
                    break;
                case 1:
                    C = function(e) {
                        for(var n, r = 0;;){
                            if (L < 262) {
                                if (at(), L < 262 && 0 === e) return 0;
                                if (0 === L) break;
                            }
                            if (L >= 3 && (l = (l << g ^ 255 & s[w + 2]) & p, r = 65535 & h[l], c[w & o] = h[l], h[l] = w), 0 !== r && (w - r & 65535) <= i - 262 && 2 !== P && (v = ot(r)), v >= 3) {
                                if (n = Q(w - N, v - 3), L -= v, v <= _ && L >= 3) {
                                    v--;
                                    do w++, l = (l << g ^ 255 & s[w + 2]) & p, r = 65535 & h[l], c[w & o] = h[l], h[l] = w;
                                    while (0 != --v);
                                    w++;
                                } else w += v, v = 0, l = ((l = 255 & s[w]) << g ^ 255 & s[w + 1]) & p;
                            } else n = Q(0, 255 & s[w]), L--, w++;
                            if (n && (it(!1), 0 === t.avail_out)) return 0;
                        }
                        return it(4 === e), 0 === t.avail_out ? 4 === e ? 2 : 0 : 4 === e ? 3 : 1;
                    }(d);
                    break;
                case 2:
                    C = function(e) {
                        for(var n, r, a = 0;;){
                            if (L < 262) {
                                if (at(), L < 262 && 0 === e) return 0;
                                if (0 === L) break;
                            }
                            if (L >= 3 && (l = (l << g ^ 255 & s[w + 2]) & p, a = 65535 & h[l], c[w & o] = h[l], h[l] = w), x = v, b = N, v = 2, 0 !== a && x < _ && (w - a & 65535) <= i - 262 && (2 !== P && (v = ot(a)), v <= 5 && (1 === P || 3 === v && w - N > 4096) && (v = 2)), x >= 3 && v <= x) {
                                r = w + L - 3, n = Q(w - 1 - b, x - 3), L -= x - 1, x -= 2;
                                do ++w <= r && (l = (l << g ^ 255 & s[w + 2]) & p, a = 65535 & h[l], c[w & o] = h[l], h[l] = w);
                                while (0 != --x);
                                if (y = 0, v = 2, w++, n && (it(!1), 0 === t.avail_out)) return 0;
                            } else if (0 !== y) {
                                if ((n = Q(0, 255 & s[w - 1])) && it(!1), w++, L--, 0 === t.avail_out) return 0;
                            } else y = 1, w++, L--;
                        }
                        return 0 !== y && (n = Q(0, 255 & s[w - 1]), y = 0), it(4 === e), 0 === t.avail_out ? 4 === e ? 2 : 0 : 4 === e ? 3 : 1;
                    }(d);
            }
            if (2 !== C && 3 !== C || (e = 666), 0 === C || 2 === C) return 0 === t.avail_out && (r = -1), 0;
            if (1 === C) {
                if (1 === d) X(2, 3), K(256, $970c7ddf83730f06$var$dt.static_ltree), $(), 1 + R + 10 - D < 9 && (X(2, 3), K(256, $970c7ddf83730f06$var$dt.static_ltree), $()), R = 7;
                else if (nt(0, 0, !1), 3 === d) for(A = 0; A < f; A++)h[A] = 0;
                if (t.flush_pending(), 0 === t.avail_out) return r = -1, 0;
            }
        }
        return 4 !== d ? 0 : 1;
    };
}
function $970c7ddf83730f06$var$Lt() {
    this.next_in_index = 0, this.next_out_index = 0, this.avail_in = 0, this.total_in = 0, this.avail_out = 0, this.total_out = 0;
}
function $970c7ddf83730f06$var$xt(t) {
    var e = new $970c7ddf83730f06$var$Lt, n = new Uint8Array(512), r = t ? t.level : -1;
    void 0 === r && (r = -1), e.deflateInit(r), e.next_out = n, this.append = function(t, r) {
        var i, a = [], o = 0, s = 0, u = 0;
        if (t.length) {
            e.next_in_index = 0, e.next_in = t, e.avail_in = t.length;
            do {
                if (e.next_out_index = 0, e.avail_out = 512, 0 !== e.deflate(0)) throw new Error("deflating: " + e.msg);
                e.next_out_index && (512 === e.next_out_index ? a.push(new Uint8Array(n)) : a.push(new Uint8Array(n.subarray(0, e.next_out_index)))), u += e.next_out_index, r && e.next_in_index > 0 && e.next_in_index !== o && (r(e.next_in_index), o = e.next_in_index);
            }while (e.avail_in > 0 || 0 === e.avail_out);
            return i = new Uint8Array(u), a.forEach(function(t) {
                i.set(t, s), s += t.length;
            }), i;
        }
    }, this.flush = function() {
        var t, r, i = [], a = 0, o = 0;
        do {
            if (e.next_out_index = 0, e.avail_out = 512, 1 !== (t = e.deflate(4)) && 0 !== t) throw new Error("deflating: " + e.msg);
            512 - e.avail_out > 0 && i.push(new Uint8Array(n.subarray(0, e.next_out_index))), o += e.next_out_index;
        }while (e.avail_in > 0 || 0 === e.avail_out);
        return e.deflateEnd(), r = new Uint8Array(o), i.forEach(function(t) {
            r.set(t, a), a += t.length;
        }), r;
    };
}


/**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ $970c7ddf83730f06$var$Lt.prototype = {
    deflateInit: function(t, e) {
        return this.dstate = new $970c7ddf83730f06$var$Nt, e || (e = 15), this.dstate.deflateInit(this, t, e);
    },
    deflate: function(t) {
        return this.dstate ? this.dstate.deflate(this, t) : -2;
    },
    deflateEnd: function() {
        if (!this.dstate) return -2;
        var t = this.dstate.deflateEnd();
        return this.dstate = null, t;
    },
    deflateParams: function(t, e) {
        return this.dstate ? this.dstate.deflateParams(this, t, e) : -2;
    },
    deflateSetDictionary: function(t, e) {
        return this.dstate ? this.dstate.deflateSetDictionary(this, t, e) : -2;
    },
    read_buf: function(t, e, n) {
        var r = this.avail_in;
        return r > n && (r = n), 0 === r ? 0 : (this.avail_in -= r, t.set(this.next_in.subarray(this.next_in_index, this.next_in_index + r), e), this.next_in_index += r, this.total_in += r, r);
    },
    flush_pending: function() {
        var t = this.dstate.pending;
        t > this.avail_out && (t = this.avail_out), 0 !== t && (this.next_out.set(this.dstate.pending_buf.subarray(this.dstate.pending_out, this.dstate.pending_out + t), this.next_out_index), this.next_out_index += t, this.dstate.pending_out += t, this.total_out += t, this.avail_out -= t, this.dstate.pending -= t, 0 === this.dstate.pending && (this.dstate.pending_out = 0));
    }
}, function(t) {
    var e = function(t) {
        var e, n, r, i, a, o, s, u, c, h;
        for(/[^\x00-\xFF]/.test(t), n = [], r = 0, i = (t += e = "\0\0\0\0".slice(t.length % 4 || 4)).length; i > r; r += 4)0 !== (a = (t.charCodeAt(r) << 24) + (t.charCodeAt(r + 1) << 16) + (t.charCodeAt(r + 2) << 8) + t.charCodeAt(r + 3)) ? (o = (a = ((a = ((a = ((a = (a - (h = a % 85)) / 85) - (c = a % 85)) / 85) - (u = a % 85)) / 85) - (s = a % 85)) / 85) % 85, n.push(o + 33, s + 33, u + 33, c + 33, h + 33)) : n.push(122);
        return function(t, e) {
            for(var n = e; n > 0; n--)t.pop();
        }(n, e.length), String.fromCharCode.apply(String, n) + "~>";
    }, n = function(t) {
        var e, n, r, i, a, o = String, s = "length", u = 255, c = "charCodeAt", h = "slice", l = "replace";
        for(t[h](-2), t = t[h](0, -2)[l](/\s/g, "")[l]("z", "!!!!!"), r = [], i = 0, a = (t += e = "uuuuu"[h](t[s] % 5 || 5))[s]; a > i; i += 5)n = 52200625 * (t[c](i) - 33) + 614125 * (t[c](i + 1) - 33) + 7225 * (t[c](i + 2) - 33) + 85 * (t[c](i + 3) - 33) + (t[c](i + 4) - 33), r.push(u & n >> 24, u & n >> 16, u & n >> 8, u & n);
        return function(t, e) {
            for(var n = e; n > 0; n--)t.pop();
        }(r, e[s]), o.fromCharCode.apply(o, r);
    }, r = function(t) {
        var e = new RegExp(/^([0-9A-Fa-f]{2})+$/);
        if (-1 !== (t = t.replace(/\s/g, "")).indexOf(">") && (t = t.substr(0, t.indexOf(">"))), t.length % 2 && (t += "0"), !1 === e.test(t)) return "";
        for(var n = "", r = 0; r < t.length; r += 2)n += String.fromCharCode("0x" + (t[r] + t[r + 1]));
        return n;
    }, i = function(e) {
        for(var n, r, i, a, o, s = [], u = e.length; u--;)s[u] = e.charCodeAt(u);
        return n = t.adler32cs.from(e), e = (r = new $970c7ddf83730f06$var$xt(6)).append(new Uint8Array(s)), i = e, a = r.flush(), (o = new Uint8Array(i.byteLength + a.byteLength)).set(new Uint8Array(i), 0), o.set(new Uint8Array(a), i.byteLength), e = o, (s = new Uint8Array(e.byteLength + 6)).set(new Uint8Array([
            120,
            156
        ])), s.set(e, 2), s.set(new Uint8Array([
            255 & n,
            n >> 8 & 255,
            n >> 16 & 255,
            n >> 24 & 255
        ]), e.byteLength + 2), e = s.reduce(function(t, e) {
            return t + String.fromCharCode(e);
        }, "");
    };
    t.processDataByFilters = function(t, a) {
        var o = 0, s = t || "", u = [];
        for("string" == typeof (a = a || []) && (a = [
            a
        ]), o = 0; o < a.length; o += 1)switch(a[o]){
            case "ASCII85Decode":
            case "/ASCII85Decode":
                s = n(s), u.push("/ASCII85Encode");
                break;
            case "ASCII85Encode":
            case "/ASCII85Encode":
                s = e(s), u.push("/ASCII85Decode");
                break;
            case "ASCIIHexDecode":
            case "/ASCIIHexDecode":
                s = r(s), u.push("/ASCIIHexEncode");
                break;
            case "ASCIIHexEncode":
            case "/ASCIIHexEncode":
                s = s.split("").map(function(t) {
                    return ("0" + t.charCodeAt().toString(16)).slice(-2);
                }).join("") + ">", u.push("/ASCIIHexDecode");
                break;
            case "FlateEncode":
            case "/FlateEncode":
                s = i(s), u.push("/FlateDecode");
                break;
            default:
                throw new Error('The filter: "' + a[o] + '" is not implemented');
        }
        return {
            data: s,
            reverseChain: u.reverse().join(" ")
        };
    };
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.loadFile = function(t, e, n) {
        return function(t, e, n) {
            e = !1 !== e, n = "function" == typeof n ? n : function() {};
            var r = void 0;
            try {
                r = function(t, e, n) {
                    var r = new XMLHttpRequest, i = 0, a = function(t) {
                        var e = t.length, n = [], r = String.fromCharCode;
                        for(i = 0; i < e; i += 1)n.push(r(255 & t.charCodeAt(i)));
                        return n.join("");
                    };
                    if (r.open("GET", t, !e), r.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (r.onload = function() {
                        200 === r.status ? n(a(this.responseText)) : n(void 0);
                    }), r.send(null), e && 200 === r.status) return a(r.responseText);
                }(t, e, n);
            } catch (t) {}
            return r;
        }(t, e, n);
    }, t.loadImageFile = t.loadFile;
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API), /**
 * @license
 * Copyright (c) 2018 Erik Koopmans
 * Released under the MIT License.
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(e) {
    function n() {
        return ($970c7ddf83730f06$var$t.html2canvas ? Promise.resolve($970c7ddf83730f06$var$t.html2canvas) : (parcelRequire("fEJ1R"))).catch(function(t) {
            return Promise.reject(new Error("Could not load dompurify: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    function r() {
        return ($970c7ddf83730f06$var$t.DOMPurify ? Promise.resolve($970c7ddf83730f06$var$t.DOMPurify) : (parcelRequire("3wVZe"))).catch(function(t) {
            return Promise.reject(new Error("Could not load dompurify: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    var i = function(t) {
        var e = typeof t;
        return "undefined" === e ? "undefined" : "string" === e || t instanceof String ? "string" : "number" === e || t instanceof Number ? "number" : "function" === e || t instanceof Function ? "function" : t && t.constructor === Array ? "array" : t && 1 === t.nodeType ? "element" : "object" === e ? "object" : "unknown";
    }, a = function(t, e) {
        var n = document.createElement(t);
        for(var r in e.className && (n.className = e.className), e.innerHTML && e.dompurify && (n.innerHTML = e.dompurify.sanitize(e.innerHTML)), e.style)n.style[r] = e.style[r];
        return n;
    }, o = function(t, e) {
        for(var n = 3 === t.nodeType ? document.createTextNode(t.nodeValue) : t.cloneNode(!1), r = t.firstChild; r; r = r.nextSibling)!0 !== e && 1 === r.nodeType && "SCRIPT" === r.nodeName || n.appendChild(o(r, e));
        return 1 === t.nodeType && ("CANVAS" === t.nodeName ? (n.width = t.width, n.height = t.height, n.getContext("2d").drawImage(t, 0, 0)) : "TEXTAREA" !== t.nodeName && "SELECT" !== t.nodeName || (n.value = t.value), n.addEventListener("load", function() {
            n.scrollTop = t.scrollTop, n.scrollLeft = t.scrollLeft;
        }, !0)), n;
    }, s = function t(e) {
        var n = Object.assign(t.convert(Promise.resolve()), JSON.parse(JSON.stringify(t.template))), r = t.convert(Promise.resolve(), n);
        return r = (r = r.setProgress(1, t, 1, [
            t
        ])).set(e);
    };
    (s.prototype = Object.create(Promise.prototype)).constructor = s, s.convert = function(t, e) {
        return t.__proto__ = e || s.prototype, t;
    }, s.template = {
        prop: {
            src: null,
            container: null,
            overlay: null,
            canvas: null,
            img: null,
            pdf: null,
            pageSize: null,
            callback: function() {}
        },
        progress: {
            val: 0,
            state: null,
            n: 0,
            stack: []
        },
        opt: {
            filename: "file.pdf",
            margin: [
                0,
                0,
                0,
                0
            ],
            enableLinks: !0,
            x: 0,
            y: 0,
            html2canvas: {},
            jsPDF: {},
            backgroundColor: "transparent"
        }
    }, s.prototype.from = function(t, e) {
        return this.then(function() {
            switch(e = e || function(t) {
                switch(i(t)){
                    case "string":
                        return "string";
                    case "element":
                        return "canvas" === t.nodeName.toLowerCase ? "canvas" : "element";
                    default:
                        return "unknown";
                }
            }(t)){
                case "string":
                    return this.then(r).then(function(e) {
                        return this.set({
                            src: a("div", {
                                innerHTML: t,
                                dompurify: e
                            })
                        });
                    });
                case "element":
                    return this.set({
                        src: t
                    });
                case "canvas":
                    return this.set({
                        canvas: t
                    });
                case "img":
                    return this.set({
                        img: t
                    });
                default:
                    return this.error("Unknown source type.");
            }
        });
    }, s.prototype.to = function(t) {
        switch(t){
            case "container":
                return this.toContainer();
            case "canvas":
                return this.toCanvas();
            case "img":
                return this.toImg();
            case "pdf":
                return this.toPdf();
            default:
                return this.error("Invalid target.");
        }
    }, s.prototype.toContainer = function() {
        return this.thenList([
            function() {
                return this.prop.src || this.error("Cannot duplicate - no source HTML.");
            },
            function() {
                return this.prop.pageSize || this.setPageSize();
            }
        ]).then(function() {
            var t = {
                position: "relative",
                display: "inline-block",
                width: Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) + "px",
                left: 0,
                right: 0,
                top: 0,
                margin: "auto",
                backgroundColor: this.opt.backgroundColor
            }, e = o(this.prop.src, this.opt.html2canvas.javascriptEnabled);
            "BODY" === e.tagName && (t.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = a("div", {
                className: "html2pdf__overlay",
                style: {
                    position: "fixed",
                    overflow: "hidden",
                    zIndex: 1e3,
                    left: "-100000px",
                    right: 0,
                    bottom: 0,
                    top: 0
                }
            }), this.prop.container = a("div", {
                className: "html2pdf__container",
                style: t
            }), this.prop.container.appendChild(e), this.prop.container.firstChild.appendChild(a("div", {
                style: {
                    clear: "both",
                    border: "0 none transparent",
                    margin: 0,
                    padding: 0,
                    height: 0
                }
            })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
        });
    }, s.prototype.toCanvas = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(n).then(function(t) {
            var e = Object.assign({}, this.opt.html2canvas);
            return delete e.onrendered, t(this.prop.container, e);
        }).then(function(t) {
            (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, s.prototype.toContext2d = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(n).then(function(t) {
            var e = this.opt.jsPDF, n = Object.assign({
                async: !0,
                allowTaint: !0,
                scale: 1,
                scrollX: this.opt.scrollX || 0,
                scrollY: this.opt.scrollY || 0,
                backgroundColor: "#ffffff",
                imageTimeout: 15e3,
                logging: !0,
                proxy: null,
                removeContainer: !0,
                foreignObjectRendering: !1,
                useCORS: !1
            }, this.opt.html2canvas);
            return delete n.onrendered, e.context2d.autoPaging = !0, e.context2d.posX = this.opt.x, e.context2d.posY = this.opt.y, n.windowHeight = n.windowHeight || 0, n.windowHeight = 0 == n.windowHeight ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : n.windowHeight, t(this.prop.container, n);
        }).then(function(t) {
            (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, s.prototype.toImg = function() {
        return this.thenList([
            function() {
                return this.prop.canvas || this.toCanvas();
            }
        ]).then(function() {
            var t = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
            this.prop.img = document.createElement("img"), this.prop.img.src = t;
        });
    }, s.prototype.toPdf = function() {
        return this.thenList([
            function() {
                return this.toContext2d();
            }
        ]).then(function() {
            this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
        });
    }, s.prototype.output = function(t, e, n) {
        return "img" === (n = n || "pdf").toLowerCase() || "image" === n.toLowerCase() ? this.outputImg(t, e) : this.outputPdf(t, e);
    }, s.prototype.outputPdf = function(t, e) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            return this.prop.pdf.output(t, e);
        });
    }, s.prototype.outputImg = function(t) {
        return this.thenList([
            function() {
                return this.prop.img || this.toImg();
            }
        ]).then(function() {
            switch(t){
                case void 0:
                case "img":
                    return this.prop.img;
                case "datauristring":
                case "dataurlstring":
                    return this.prop.img.src;
                case "datauri":
                case "dataurl":
                    return document.location.href = this.prop.img.src;
                default:
                    throw 'Image output type "' + t + '" is not supported.';
            }
        });
    }, s.prototype.save = function(t) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).set(t ? {
            filename: t
        } : null).then(function() {
            this.prop.pdf.save(this.opt.filename);
        });
    }, s.prototype.doCallback = function() {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            this.prop.callback(this.prop.pdf);
        });
    }, s.prototype.set = function(t) {
        if ("object" !== i(t)) return this;
        var e = Object.keys(t || {}).map(function(e) {
            if (e in s.template.prop) return function() {
                this.prop[e] = t[e];
            };
            switch(e){
                case "margin":
                    return this.setMargin.bind(this, t.margin);
                case "jsPDF":
                    return function() {
                        return this.opt.jsPDF = t.jsPDF, this.setPageSize();
                    };
                case "pageSize":
                    return this.setPageSize.bind(this, t.pageSize);
                default:
                    return function() {
                        this.opt[e] = t[e];
                    };
            }
        }, this);
        return this.then(function() {
            return this.thenList(e);
        });
    }, s.prototype.get = function(t, e) {
        return this.then(function() {
            var n = t in s.template.prop ? this.prop[t] : this.opt[t];
            return e ? e(n) : n;
        });
    }, s.prototype.setMargin = function(t) {
        return this.then(function() {
            switch(i(t)){
                case "number":
                    t = [
                        t,
                        t,
                        t,
                        t
                    ];
                case "array":
                    if (2 === t.length && (t = [
                        t[0],
                        t[1],
                        t[0],
                        t[1]
                    ]), 4 === t.length) break;
                default:
                    return this.error("Invalid margin array.");
            }
            this.opt.margin = t;
        }).then(this.setPageSize);
    }, s.prototype.setPageSize = function(t) {
        function e(t, e) {
            return Math.floor(t * e / 72 * 96);
        }
        return this.then(function() {
            (t = t || $970c7ddf83730f06$export$ba1e2ffc633a60f5.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (t.inner = {
                width: t.width - this.opt.margin[1] - this.opt.margin[3],
                height: t.height - this.opt.margin[0] - this.opt.margin[2]
            }, t.inner.px = {
                width: e(t.inner.width, t.k),
                height: e(t.inner.height, t.k)
            }, t.inner.ratio = t.inner.height / t.inner.width), this.prop.pageSize = t;
        });
    }, s.prototype.setProgress = function(t, e, n, r) {
        return null != t && (this.progress.val = t), null != e && (this.progress.state = e), null != n && (this.progress.n = n), null != r && (this.progress.stack = r), this.progress.ratio = this.progress.val / this.progress.state, this;
    }, s.prototype.updateProgress = function(t, e, n, r) {
        return this.setProgress(t ? this.progress.val + t : null, e || null, n ? this.progress.n + n : null, r ? this.progress.stack.concat(r) : null);
    }, s.prototype.then = function(t, e) {
        var n = this;
        return this.thenCore(t, e, function(t, e) {
            return n.updateProgress(null, null, 1, [
                t
            ]), Promise.prototype.then.call(this, function(e) {
                return n.updateProgress(null, t), e;
            }).then(t, e).then(function(t) {
                return n.updateProgress(1), t;
            });
        });
    }, s.prototype.thenCore = function(t, e, n) {
        n = n || Promise.prototype.then;
        t && (t = t.bind(this)), e && (e = e.bind(this));
        var r = -1 !== Promise.toString().indexOf("[native code]") && "Promise" === Promise.name ? this : s.convert(Object.assign({}, this), Promise.prototype), i = n.call(r, t, e);
        return s.convert(i, this.__proto__);
    }, s.prototype.thenExternal = function(t, e) {
        return Promise.prototype.then.call(this, t, e);
    }, s.prototype.thenList = function(t) {
        var e = this;
        return t.forEach(function(t) {
            e = e.thenCore(t);
        }), e;
    }, s.prototype.catch = function(t) {
        t && (t = t.bind(this));
        var e = Promise.prototype.catch.call(this, t);
        return s.convert(e, this);
    }, s.prototype.catchExternal = function(t) {
        return Promise.prototype.catch.call(this, t);
    }, s.prototype.error = function(t) {
        return this.then(function() {
            throw new Error(t);
        });
    }, s.prototype.using = s.prototype.set, s.prototype.saveAs = s.prototype.save, s.prototype.export = s.prototype.output, s.prototype.run = s.prototype.then, $970c7ddf83730f06$export$ba1e2ffc633a60f5.getPageSize = function(t, e, n) {
        if ("object" == typeof t) {
            var r = t;
            t = r.orientation, e = r.unit || e, n = r.format || n;
        }
        e = e || "mm", n = n || "a4", t = ("" + (t || "P")).toLowerCase();
        var i, a = ("" + n).toLowerCase(), o = {
            a0: [
                2383.94,
                3370.39
            ],
            a1: [
                1683.78,
                2383.94
            ],
            a2: [
                1190.55,
                1683.78
            ],
            a3: [
                841.89,
                1190.55
            ],
            a4: [
                595.28,
                841.89
            ],
            a5: [
                419.53,
                595.28
            ],
            a6: [
                297.64,
                419.53
            ],
            a7: [
                209.76,
                297.64
            ],
            a8: [
                147.4,
                209.76
            ],
            a9: [
                104.88,
                147.4
            ],
            a10: [
                73.7,
                104.88
            ],
            b0: [
                2834.65,
                4008.19
            ],
            b1: [
                2004.09,
                2834.65
            ],
            b2: [
                1417.32,
                2004.09
            ],
            b3: [
                1000.63,
                1417.32
            ],
            b4: [
                708.66,
                1000.63
            ],
            b5: [
                498.9,
                708.66
            ],
            b6: [
                354.33,
                498.9
            ],
            b7: [
                249.45,
                354.33
            ],
            b8: [
                175.75,
                249.45
            ],
            b9: [
                124.72,
                175.75
            ],
            b10: [
                87.87,
                124.72
            ],
            c0: [
                2599.37,
                3676.54
            ],
            c1: [
                1836.85,
                2599.37
            ],
            c2: [
                1298.27,
                1836.85
            ],
            c3: [
                918.43,
                1298.27
            ],
            c4: [
                649.13,
                918.43
            ],
            c5: [
                459.21,
                649.13
            ],
            c6: [
                323.15,
                459.21
            ],
            c7: [
                229.61,
                323.15
            ],
            c8: [
                161.57,
                229.61
            ],
            c9: [
                113.39,
                161.57
            ],
            c10: [
                79.37,
                113.39
            ],
            dl: [
                311.81,
                623.62
            ],
            letter: [
                612,
                792
            ],
            "government-letter": [
                576,
                756
            ],
            legal: [
                612,
                1008
            ],
            "junior-legal": [
                576,
                360
            ],
            ledger: [
                1224,
                792
            ],
            tabloid: [
                792,
                1224
            ],
            "credit-card": [
                153,
                243
            ]
        };
        switch(e){
            case "pt":
                i = 1;
                break;
            case "mm":
                i = 72 / 25.4;
                break;
            case "cm":
                i = 72 / 2.54;
                break;
            case "in":
                i = 72;
                break;
            case "px":
                i = .75;
                break;
            case "pc":
            case "em":
                i = 12;
                break;
            case "ex":
                i = 6;
                break;
            default:
                throw "Invalid unit: " + e;
        }
        var s, u = 0, c = 0;
        if (o.hasOwnProperty(a)) u = o[a][1] / i, c = o[a][0] / i;
        else try {
            u = n[1], c = n[0];
        } catch (t) {
            throw new Error("Invalid format: " + n);
        }
        if ("p" === t || "portrait" === t) t = "p", c > u && (s = c, c = u, u = s);
        else {
            if ("l" !== t && "landscape" !== t) throw "Invalid orientation: " + t;
            t = "l", u > c && (s = c, c = u, u = s);
        }
        return {
            width: c,
            height: u,
            unit: e,
            k: i,
            orientation: t
        };
    }, e.html = function(t, e) {
        (e = e || {}).callback = e.callback || function() {}, e.html2canvas = e.html2canvas || {}, e.html2canvas.canvas = e.html2canvas.canvas || this.canvas, e.jsPDF = e.jsPDF || this;
        var n = new s(e);
        return e.worker ? n : n.from(t).doCallback();
    };
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API), $970c7ddf83730f06$export$ba1e2ffc633a60f5.API.addJS = function(t) {
    return $970c7ddf83730f06$var$vt = t, this.internal.events.subscribe("postPutResources", function() {
        $970c7ddf83730f06$var$gt = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + ($970c7ddf83730f06$var$gt + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), $970c7ddf83730f06$var$mt = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + $970c7ddf83730f06$var$vt + ")"), this.internal.out(">>"), this.internal.out("endobj");
    }), this.internal.events.subscribe("putCatalog", function() {
        void 0 !== $970c7ddf83730f06$var$gt && void 0 !== $970c7ddf83730f06$var$mt && this.internal.out("/Names <</JavaScript " + $970c7ddf83730f06$var$gt + " 0 R>>");
    }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e;
    t.events.push([
        "postPutResources",
        function() {
            var t = this, n = /^(\d+) 0 obj$/;
            if (this.outline.root.children.length > 0) for(var r = t.outline.render().split(/\r\n/), i = 0; i < r.length; i++){
                var a = r[i], o = n.exec(a);
                if (null != o) {
                    var s = o[1];
                    t.internal.newObjectDeferredBegin(s, !1);
                }
                t.internal.write(a);
            }
            if (this.outline.createNamedDestinations) {
                var u = this.internal.pages.length, c = [];
                for(i = 0; i < u; i++){
                    var h = t.internal.newObject();
                    c.push(h);
                    var l = t.internal.getPageInfo(i + 1);
                    t.internal.write("<< /D[" + l.objId + " 0 R /XYZ null null null]>> endobj");
                }
                var f = t.internal.newObject();
                t.internal.write("<< /Names [ ");
                for(i = 0; i < c.length; i++)t.internal.write("(page_" + (i + 1) + ")" + c[i] + " 0 R");
                t.internal.write(" ] >>", "endobj"), e = t.internal.newObject(), t.internal.write("<< /Dests " + f + " 0 R"), t.internal.write(">>", "endobj");
            }
        }
    ]), t.events.push([
        "putCatalog",
        function() {
            this.outline.root.children.length > 0 && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + e + " 0 R"));
        }
    ]), t.events.push([
        "initialized",
        function() {
            var t = this;
            t.outline = {
                createNamedDestinations: !1,
                root: {
                    children: []
                }
            }, t.outline.add = function(t, e, n) {
                var r = {
                    title: e,
                    options: n,
                    children: []
                };
                return null == t && (t = this.root), t.children.push(r), r;
            }, t.outline.render = function() {
                return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = t, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
            }, t.outline.genIds_r = function(e) {
                e.id = t.internal.newObjectDeferred();
                for(var n = 0; n < e.children.length; n++)this.genIds_r(e.children[n]);
            }, t.outline.renderRoot = function(t) {
                this.objStart(t), this.line("/Type /Outlines"), t.children.length > 0 && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
                    count: 0
                }, t)), this.objEnd();
            }, t.outline.renderItems = function(e) {
                for(var n = this.ctx.pdf.internal.getVerticalCoordinateString, r = 0; r < e.children.length; r++){
                    var i = e.children[r];
                    this.objStart(i), this.line("/Title " + this.makeString(i.title)), this.line("/Parent " + this.makeRef(e)), r > 0 && this.line("/Prev " + this.makeRef(e.children[r - 1])), r < e.children.length - 1 && this.line("/Next " + this.makeRef(e.children[r + 1])), i.children.length > 0 && (this.line("/First " + this.makeRef(i.children[0])), this.line("/Last " + this.makeRef(i.children[i.children.length - 1])));
                    var a = this.count = this.count_r({
                        count: 0
                    }, i);
                    if (a > 0 && this.line("/Count " + a), i.options && i.options.pageNumber) {
                        var o = t.internal.getPageInfo(i.options.pageNumber);
                        this.line("/Dest [" + o.objId + " 0 R /XYZ 0 " + n(0) + " 0]");
                    }
                    this.objEnd();
                }
                for(var s = 0; s < e.children.length; s++)this.renderItems(e.children[s]);
            }, t.outline.line = function(t) {
                this.ctx.val += t + "\r\n";
            }, t.outline.makeRef = function(t) {
                return t.id + " 0 R";
            }, t.outline.makeString = function(e) {
                return "(" + t.internal.pdfEscape(e) + ")";
            }, t.outline.objStart = function(t) {
                this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
            }, t.outline.objEnd = function() {
                this.ctx.val += ">> \r\nendobj\r\n";
            }, t.outline.count_r = function(t, e) {
                for(var n = 0; n < e.children.length; n++)t.count++, this.count_r(t, e.children[n]);
                return t.count;
            };
        }
    ]);
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = [
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199
    ];
    t.processJPEG = function(t, n, r, i, a, o) {
        var s, u = this.decode.DCT_DECODE, c = null;
        if ("string" == typeof t || this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) {
            switch(t = a || t, t = this.__addimage__.isArrayBuffer(t) ? new Uint8Array(t) : t, (s = function(t) {
                for(var n, r = 256 * t.charCodeAt(4) + t.charCodeAt(5), i = t.length, a = {
                    width: 0,
                    height: 0,
                    numcomponents: 1
                }, o = 4; o < i; o += 2){
                    if (o += r, -1 !== e.indexOf(t.charCodeAt(o + 1))) {
                        n = 256 * t.charCodeAt(o + 5) + t.charCodeAt(o + 6), a = {
                            width: 256 * t.charCodeAt(o + 7) + t.charCodeAt(o + 8),
                            height: n,
                            numcomponents: t.charCodeAt(o + 9)
                        };
                        break;
                    }
                    r = 256 * t.charCodeAt(o + 2) + t.charCodeAt(o + 3);
                }
                return a;
            }(t = this.__addimage__.isArrayBufferView(t) ? this.__addimage__.arrayBufferToBinaryString(t) : t)).numcomponents){
                case 1:
                    o = this.color_spaces.DEVICE_GRAY;
                    break;
                case 4:
                    o = this.color_spaces.DEVICE_CMYK;
                    break;
                case 3:
                    o = this.color_spaces.DEVICE_RGB;
            }
            c = {
                data: t,
                width: s.width,
                height: s.height,
                colorSpace: o,
                bitsPerComponent: 8,
                filter: u,
                index: n,
                alias: r
            };
        }
        return c;
    };
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API);
/**
 * @license
 * Extracted from pdf.js
 * https://github.com/andreasgal/pdf.js
 *
 * Copyright (c) 2011 Mozilla Foundation
 *
 * Contributors: Andreas Gal <gal@mozilla.com>
 *               Chris G Jones <cjones@mozilla.com>
 *               Shaon Barman <shaon.barman@gmail.com>
 *               Vivien Nicolas <21@vingtetun.org>
 *               Justin D'Arcangelo <justindarc@gmail.com>
 *               Yury Delendik
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ var $970c7ddf83730f06$var$At, $970c7ddf83730f06$var$_t, $970c7ddf83730f06$var$St, $970c7ddf83730f06$var$Pt, $970c7ddf83730f06$var$kt, $970c7ddf83730f06$var$Ft = function() {
    function t() {
        this.pos = 0, this.bufferLength = 0, this.eof = !1, this.buffer = null;
    }
    return t.prototype = {
        ensureBuffer: function(t) {
            var e = this.buffer, n = e ? e.byteLength : 0;
            if (t < n) return e;
            for(var r = 512; r < t;)r <<= 1;
            for(var i = new Uint8Array(r), a = 0; a < n; ++a)i[a] = e[a];
            return this.buffer = i;
        },
        getByte: function() {
            for(var t = this.pos; this.bufferLength <= t;){
                if (this.eof) return null;
                this.readBlock();
            }
            return this.buffer[this.pos++];
        },
        getBytes: function(t) {
            var e = this.pos;
            if (t) {
                this.ensureBuffer(e + t);
                for(var n = e + t; !this.eof && this.bufferLength < n;)this.readBlock();
                var r = this.bufferLength;
                n > r && (n = r);
            } else {
                for(; !this.eof;)this.readBlock();
                n = this.bufferLength;
            }
            return this.pos = n, this.buffer.subarray(e, n);
        },
        lookChar: function() {
            for(var t = this.pos; this.bufferLength <= t;){
                if (this.eof) return null;
                this.readBlock();
            }
            return String.fromCharCode(this.buffer[this.pos]);
        },
        getChar: function() {
            for(var t = this.pos; this.bufferLength <= t;){
                if (this.eof) return null;
                this.readBlock();
            }
            return String.fromCharCode(this.buffer[this.pos++]);
        },
        makeSubStream: function(t, e, n) {
            for(var r = t + e; this.bufferLength <= r && !this.eof;)this.readBlock();
            return new Stream(this.buffer, t, e, n);
        },
        skip: function(t) {
            t || (t = 1), this.pos += t;
        },
        reset: function() {
            this.pos = 0;
        }
    }, t;
}(), $970c7ddf83730f06$var$It = ("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")()).FlateStream = function() {
    if ("undefined" != typeof Uint32Array) {
        var t = new Uint32Array([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]), e = new Uint32Array([
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            65547,
            65549,
            65551,
            65553,
            131091,
            131095,
            131099,
            131103,
            196643,
            196651,
            196659,
            196667,
            262211,
            262227,
            262243,
            262259,
            327811,
            327843,
            327875,
            327907,
            258,
            258,
            258
        ]), n = new Uint32Array([
            1,
            2,
            3,
            4,
            65541,
            65543,
            131081,
            131085,
            196625,
            196633,
            262177,
            262193,
            327745,
            327777,
            393345,
            393409,
            459009,
            459137,
            524801,
            525057,
            590849,
            591361,
            657409,
            658433,
            724993,
            727041,
            794625,
            798721,
            868353,
            876545
        ]), r = [
            new Uint32Array([
                459008,
                524368,
                524304,
                524568,
                459024,
                524400,
                524336,
                590016,
                459016,
                524384,
                524320,
                589984,
                524288,
                524416,
                524352,
                590048,
                459012,
                524376,
                524312,
                589968,
                459028,
                524408,
                524344,
                590032,
                459020,
                524392,
                524328,
                59e4,
                524296,
                524424,
                524360,
                590064,
                459010,
                524372,
                524308,
                524572,
                459026,
                524404,
                524340,
                590024,
                459018,
                524388,
                524324,
                589992,
                524292,
                524420,
                524356,
                590056,
                459014,
                524380,
                524316,
                589976,
                459030,
                524412,
                524348,
                590040,
                459022,
                524396,
                524332,
                590008,
                524300,
                524428,
                524364,
                590072,
                459009,
                524370,
                524306,
                524570,
                459025,
                524402,
                524338,
                590020,
                459017,
                524386,
                524322,
                589988,
                524290,
                524418,
                524354,
                590052,
                459013,
                524378,
                524314,
                589972,
                459029,
                524410,
                524346,
                590036,
                459021,
                524394,
                524330,
                590004,
                524298,
                524426,
                524362,
                590068,
                459011,
                524374,
                524310,
                524574,
                459027,
                524406,
                524342,
                590028,
                459019,
                524390,
                524326,
                589996,
                524294,
                524422,
                524358,
                590060,
                459015,
                524382,
                524318,
                589980,
                459031,
                524414,
                524350,
                590044,
                459023,
                524398,
                524334,
                590012,
                524302,
                524430,
                524366,
                590076,
                459008,
                524369,
                524305,
                524569,
                459024,
                524401,
                524337,
                590018,
                459016,
                524385,
                524321,
                589986,
                524289,
                524417,
                524353,
                590050,
                459012,
                524377,
                524313,
                589970,
                459028,
                524409,
                524345,
                590034,
                459020,
                524393,
                524329,
                590002,
                524297,
                524425,
                524361,
                590066,
                459010,
                524373,
                524309,
                524573,
                459026,
                524405,
                524341,
                590026,
                459018,
                524389,
                524325,
                589994,
                524293,
                524421,
                524357,
                590058,
                459014,
                524381,
                524317,
                589978,
                459030,
                524413,
                524349,
                590042,
                459022,
                524397,
                524333,
                590010,
                524301,
                524429,
                524365,
                590074,
                459009,
                524371,
                524307,
                524571,
                459025,
                524403,
                524339,
                590022,
                459017,
                524387,
                524323,
                589990,
                524291,
                524419,
                524355,
                590054,
                459013,
                524379,
                524315,
                589974,
                459029,
                524411,
                524347,
                590038,
                459021,
                524395,
                524331,
                590006,
                524299,
                524427,
                524363,
                590070,
                459011,
                524375,
                524311,
                524575,
                459027,
                524407,
                524343,
                590030,
                459019,
                524391,
                524327,
                589998,
                524295,
                524423,
                524359,
                590062,
                459015,
                524383,
                524319,
                589982,
                459031,
                524415,
                524351,
                590046,
                459023,
                524399,
                524335,
                590014,
                524303,
                524431,
                524367,
                590078,
                459008,
                524368,
                524304,
                524568,
                459024,
                524400,
                524336,
                590017,
                459016,
                524384,
                524320,
                589985,
                524288,
                524416,
                524352,
                590049,
                459012,
                524376,
                524312,
                589969,
                459028,
                524408,
                524344,
                590033,
                459020,
                524392,
                524328,
                590001,
                524296,
                524424,
                524360,
                590065,
                459010,
                524372,
                524308,
                524572,
                459026,
                524404,
                524340,
                590025,
                459018,
                524388,
                524324,
                589993,
                524292,
                524420,
                524356,
                590057,
                459014,
                524380,
                524316,
                589977,
                459030,
                524412,
                524348,
                590041,
                459022,
                524396,
                524332,
                590009,
                524300,
                524428,
                524364,
                590073,
                459009,
                524370,
                524306,
                524570,
                459025,
                524402,
                524338,
                590021,
                459017,
                524386,
                524322,
                589989,
                524290,
                524418,
                524354,
                590053,
                459013,
                524378,
                524314,
                589973,
                459029,
                524410,
                524346,
                590037,
                459021,
                524394,
                524330,
                590005,
                524298,
                524426,
                524362,
                590069,
                459011,
                524374,
                524310,
                524574,
                459027,
                524406,
                524342,
                590029,
                459019,
                524390,
                524326,
                589997,
                524294,
                524422,
                524358,
                590061,
                459015,
                524382,
                524318,
                589981,
                459031,
                524414,
                524350,
                590045,
                459023,
                524398,
                524334,
                590013,
                524302,
                524430,
                524366,
                590077,
                459008,
                524369,
                524305,
                524569,
                459024,
                524401,
                524337,
                590019,
                459016,
                524385,
                524321,
                589987,
                524289,
                524417,
                524353,
                590051,
                459012,
                524377,
                524313,
                589971,
                459028,
                524409,
                524345,
                590035,
                459020,
                524393,
                524329,
                590003,
                524297,
                524425,
                524361,
                590067,
                459010,
                524373,
                524309,
                524573,
                459026,
                524405,
                524341,
                590027,
                459018,
                524389,
                524325,
                589995,
                524293,
                524421,
                524357,
                590059,
                459014,
                524381,
                524317,
                589979,
                459030,
                524413,
                524349,
                590043,
                459022,
                524397,
                524333,
                590011,
                524301,
                524429,
                524365,
                590075,
                459009,
                524371,
                524307,
                524571,
                459025,
                524403,
                524339,
                590023,
                459017,
                524387,
                524323,
                589991,
                524291,
                524419,
                524355,
                590055,
                459013,
                524379,
                524315,
                589975,
                459029,
                524411,
                524347,
                590039,
                459021,
                524395,
                524331,
                590007,
                524299,
                524427,
                524363,
                590071,
                459011,
                524375,
                524311,
                524575,
                459027,
                524407,
                524343,
                590031,
                459019,
                524391,
                524327,
                589999,
                524295,
                524423,
                524359,
                590063,
                459015,
                524383,
                524319,
                589983,
                459031,
                524415,
                524351,
                590047,
                459023,
                524399,
                524335,
                590015,
                524303,
                524431,
                524367,
                590079
            ]),
            9
        ], i = [
            new Uint32Array([
                327680,
                327696,
                327688,
                327704,
                327684,
                327700,
                327692,
                327708,
                327682,
                327698,
                327690,
                327706,
                327686,
                327702,
                327694,
                0,
                327681,
                327697,
                327689,
                327705,
                327685,
                327701,
                327693,
                327709,
                327683,
                327699,
                327691,
                327707,
                327687,
                327703,
                327695,
                0
            ]),
            5
        ];
        return o.prototype = Object.create($970c7ddf83730f06$var$Ft.prototype), o.prototype.getBits = function(t) {
            for(var e, n = this.codeSize, r = this.codeBuf, i = this.bytes, o = this.bytesPos; n < t;)void 0 === (e = i[o++]) && a("Bad encoding in flate stream"), r |= e << n, n += 8;
            return e = r & (1 << t) - 1, this.codeBuf = r >> t, this.codeSize = n -= t, this.bytesPos = o, e;
        }, o.prototype.getCode = function(t) {
            for(var e = t[0], n = t[1], r = this.codeSize, i = this.codeBuf, o = this.bytes, s = this.bytesPos; r < n;){
                var u;
                void 0 === (u = o[s++]) && a("Bad encoding in flate stream"), i |= u << r, r += 8;
            }
            var c = e[i & (1 << n) - 1], h = c >> 16, l = 65535 & c;
            return (0 == r || r < h || 0 == h) && a("Bad encoding in flate stream"), this.codeBuf = i >> h, this.codeSize = r - h, this.bytesPos = s, l;
        }, o.prototype.generateHuffmanTable = function(t) {
            for(var e = t.length, n = 0, r = 0; r < e; ++r)t[r] > n && (n = t[r]);
            for(var i = 1 << n, a = new Uint32Array(i), o = 1, s = 0, u = 2; o <= n; ++o, s <<= 1, u <<= 1)for(var c = 0; c < e; ++c)if (t[c] == o) {
                var h = 0, l = s;
                for(r = 0; r < o; ++r)h = h << 1 | 1 & l, l >>= 1;
                for(r = h; r < i; r += u)a[r] = o << 16 | c;
                ++s;
            }
            return [
                a,
                n
            ];
        }, o.prototype.readBlock = function() {
            function o(t, e, n, r, i) {
                for(var a = t.getBits(n) + r; a-- > 0;)e[p++] = i;
            }
            var s = this.getBits(3);
            if (1 & s && (this.eof = !0), 0 != (s >>= 1)) {
                var u, c;
                if (1 == s) u = r, c = i;
                else if (2 == s) {
                    for(var h = this.getBits(5) + 257, l = this.getBits(5) + 1, f = this.getBits(4) + 4, d = Array(t.length), p = 0; p < f;)d[t[p++]] = this.getBits(3);
                    for(var g = this.generateHuffmanTable(d), m = 0, v = (p = 0, h + l), b = new Array(v); p < v;){
                        var y = this.getCode(g);
                        16 == y ? o(this, b, 2, 3, m) : 17 == y ? o(this, b, 3, 3, m = 0) : 18 == y ? o(this, b, 7, 11, m = 0) : b[p++] = m = y;
                    }
                    u = this.generateHuffmanTable(b.slice(0, h)), c = this.generateHuffmanTable(b.slice(h, v));
                } else a("Unknown block type in flate stream");
                for(var w = (j = this.buffer) ? j.length : 0, N = this.bufferLength;;){
                    var L = this.getCode(u);
                    if (L < 256) N + 1 >= w && (w = (j = this.ensureBuffer(N + 1)).length), j[N++] = L;
                    else {
                        if (256 == L) return void (this.bufferLength = N);
                        var x = (L = e[L -= 257]) >> 16;
                        x > 0 && (x = this.getBits(x));
                        m = (65535 & L) + x;
                        L = this.getCode(c), (x = (L = n[L]) >> 16) > 0 && (x = this.getBits(x));
                        var A = (65535 & L) + x;
                        N + m >= w && (w = (j = this.ensureBuffer(N + m)).length);
                        for(var _ = 0; _ < m; ++_, ++N)j[N] = j[N - A];
                    }
                }
            } else {
                var S, P = this.bytes, k = this.bytesPos;
                void 0 === (S = P[k++]) && a("Bad block header in flate stream");
                var F = S;
                void 0 === (S = P[k++]) && a("Bad block header in flate stream"), F |= S << 8, void 0 === (S = P[k++]) && a("Bad block header in flate stream");
                var I = S;
                void 0 === (S = P[k++]) && a("Bad block header in flate stream"), (I |= S << 8) != (65535 & ~F) && a("Bad uncompressed block length in flate stream"), this.codeBuf = 0, this.codeSize = 0;
                var C = this.bufferLength, j = this.ensureBuffer(C + F), B = C + F;
                this.bufferLength = B;
                for(var O = C; O < B; ++O){
                    if (void 0 === (S = P[k++])) {
                        this.eof = !0;
                        break;
                    }
                    j[O] = S;
                }
                this.bytesPos = k;
            }
        }, o;
    }
    function a(t) {
        throw new Error(t);
    }
    function o(t) {
        var e = 0, n = t[e++], r = t[e++];
        -1 != n && -1 != r || a("Invalid header in flate stream"), 8 != (15 & n) && a("Unknown compression method in flate stream"), ((n << 8) + r) % 31 != 0 && a("Bad FCHECK in flate stream"), 32 & r && a("FDICT bit set in flate stream"), this.bytes = t, this.bytesPos = 2, this.codeSize = 0, this.codeBuf = 0, $970c7ddf83730f06$var$Ft.call(this);
    }
}(), $970c7ddf83730f06$var$Ct = function() {
    var e, n, r;
    function i(t) {
        var e, n, r, i, a, o, s, u, c, h, l, f, d, p;
        for(this.data = t, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, o = null;;){
            switch(e = this.readUInt32(), c = (function() {
                var t, e;
                for(e = [], t = 0; t < 4; ++t)e.push(String.fromCharCode(this.data[this.pos++]));
                return e;
            }).call(this).join("")){
                case "IHDR":
                    this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
                    break;
                case "acTL":
                    this.animation = {
                        numFrames: this.readUInt32(),
                        numPlays: this.readUInt32() || 1 / 0,
                        frames: []
                    };
                    break;
                case "PLTE":
                    this.palette = this.read(e);
                    break;
                case "fcTL":
                    o && this.animation.frames.push(o), this.pos += 4, o = {
                        width: this.readUInt32(),
                        height: this.readUInt32(),
                        xOffset: this.readUInt32(),
                        yOffset: this.readUInt32()
                    }, a = this.readUInt16(), i = this.readUInt16() || 100, o.delay = 1e3 * a / i, o.disposeOp = this.data[this.pos++], o.blendOp = this.data[this.pos++], o.data = [];
                    break;
                case "IDAT":
                case "fdAT":
                    for("fdAT" === c && (this.pos += 4, e -= 4), t = (null != o ? o.data : void 0) || this.imgData, f = 0; 0 <= e ? f < e : f > e; 0 <= e ? ++f : --f)t.push(this.data[this.pos++]);
                    break;
                case "tRNS":
                    switch(this.transparency = {}, this.colorType){
                        case 3:
                            if (r = this.palette.length / 3, this.transparency.indexed = this.read(e), this.transparency.indexed.length > r) throw new Error("More transparent colors than palette size");
                            if ((h = r - this.transparency.indexed.length) > 0) for(d = 0; 0 <= h ? d < h : d > h; 0 <= h ? ++d : --d)this.transparency.indexed.push(255);
                            break;
                        case 0:
                            this.transparency.grayscale = this.read(e)[0];
                            break;
                        case 2:
                            this.transparency.rgb = this.read(e);
                    }
                    break;
                case "tEXt":
                    s = (l = this.read(e)).indexOf(0), u = String.fromCharCode.apply(String, l.slice(0, s)), this.text[u] = String.fromCharCode.apply(String, l.slice(s + 1));
                    break;
                case "IEND":
                    return o && this.animation.frames.push(o), this.colors = (function() {
                        switch(this.colorType){
                            case 0:
                            case 3:
                            case 4:
                                return 1;
                            case 2:
                            case 6:
                                return 3;
                        }
                    }).call(this), this.hasAlphaChannel = 4 === (p = this.colorType) || 6 === p, n = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * n, this.colorSpace = (function() {
                        switch(this.colors){
                            case 1:
                                return "DeviceGray";
                            case 3:
                                return "DeviceRGB";
                        }
                    }).call(this), void (this.imgData = new Uint8Array(this.imgData));
                default:
                    this.pos += e;
            }
            if (this.pos += 4, this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
        }
    }
    i.prototype.read = function(t) {
        var e, n;
        for(n = [], e = 0; 0 <= t ? e < t : e > t; 0 <= t ? ++e : --e)n.push(this.data[this.pos++]);
        return n;
    }, i.prototype.readUInt32 = function() {
        return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
    }, i.prototype.readUInt16 = function() {
        return this.data[this.pos++] << 8 | this.data[this.pos++];
    }, i.prototype.decodePixels = function(t) {
        var e = this.pixelBitlength / 8, n = new Uint8Array(this.width * this.height * e), r = 0, i = this;
        if (null == t && (t = this.imgData), 0 === t.length) return new Uint8Array(0);
        function a(a, o, s, u) {
            var c, h, l, f, d, p, g, m, v, b, y, w, N, L, x, A, _, S, P, k, F, I = Math.ceil((i.width - a) / s), C = Math.ceil((i.height - o) / u), j = i.width == I && i.height == C;
            for(L = e * I, w = j ? n : new Uint8Array(L * C), p = t.length, N = 0, h = 0; N < C && r < p;){
                switch(t[r++]){
                    case 0:
                        for(f = _ = 0; _ < L; f = _ += 1)w[h++] = t[r++];
                        break;
                    case 1:
                        for(f = S = 0; S < L; f = S += 1)c = t[r++], d = f < e ? 0 : w[h - e], w[h++] = (c + d) % 256;
                        break;
                    case 2:
                        for(f = P = 0; P < L; f = P += 1)c = t[r++], l = (f - f % e) / e, x = N && w[(N - 1) * L + l * e + f % e], w[h++] = (x + c) % 256;
                        break;
                    case 3:
                        for(f = k = 0; k < L; f = k += 1)c = t[r++], l = (f - f % e) / e, d = f < e ? 0 : w[h - e], x = N && w[(N - 1) * L + l * e + f % e], w[h++] = (c + Math.floor((d + x) / 2)) % 256;
                        break;
                    case 4:
                        for(f = F = 0; F < L; f = F += 1)c = t[r++], l = (f - f % e) / e, d = f < e ? 0 : w[h - e], 0 === N ? x = A = 0 : (x = w[(N - 1) * L + l * e + f % e], A = l && w[(N - 1) * L + (l - 1) * e + f % e]), g = d + x - A, m = Math.abs(g - d), b = Math.abs(g - x), y = Math.abs(g - A), v = m <= b && m <= y ? d : b <= y ? x : A, w[h++] = (c + v) % 256;
                        break;
                    default:
                        throw new Error("Invalid filter algorithm: " + t[r - 1]);
                }
                if (!j) {
                    var B = ((o + N * u) * i.width + a) * e, O = N * L;
                    for(f = 0; f < I; f += 1){
                        for(var M = 0; M < e; M += 1)n[B++] = w[O++];
                        B += (s - 1) * e;
                    }
                }
                N++;
            }
        }
        return t = (t = new $970c7ddf83730f06$var$It(t)).getBytes(), 1 == i.interlaceMethod ? (a(0, 0, 8, 8), a(4, 0, 8, 8), a(0, 4, 4, 8), a(2, 0, 4, 4), a(0, 2, 2, 4), a(1, 0, 2, 2), a(0, 1, 1, 2)) : a(0, 0, 1, 1), n;
    }, i.prototype.decodePalette = function() {
        var t, e, n, r, i, a, o, s, u;
        for(n = this.palette, a = this.transparency.indexed || [], i = new Uint8Array((a.length || 0) + n.length), r = 0, t = 0, e = o = 0, s = n.length; o < s; e = o += 3)i[r++] = n[e], i[r++] = n[e + 1], i[r++] = n[e + 2], i[r++] = null != (u = a[t++]) ? u : 255;
        return i;
    }, i.prototype.copyToImageData = function(t, e) {
        var n, r, i, a, o, s, u, c, h, l, f;
        if (r = this.colors, h = null, n = this.hasAlphaChannel, this.palette.length && (h = null != (f = this._decodedPalette) ? f : this._decodedPalette = this.decodePalette(), r = 4, n = !0), c = (i = t.data || t).length, o = h || e, a = s = 0, 1 === r) for(; a < c;)u = h ? 4 * e[a / 4] : s, l = o[u++], i[a++] = l, i[a++] = l, i[a++] = l, i[a++] = n ? o[u++] : 255, s = u;
        else for(; a < c;)u = h ? 4 * e[a / 4] : s, i[a++] = o[u++], i[a++] = o[u++], i[a++] = o[u++], i[a++] = n ? o[u++] : 255, s = u;
    }, i.prototype.decode = function() {
        var t;
        return t = new Uint8Array(this.width * this.height * 4), this.copyToImageData(t, this.decodePixels()), t;
    };
    var a = function() {
        if ("[object Window]" === Object.prototype.toString.call($970c7ddf83730f06$var$t)) {
            try {
                n = $970c7ddf83730f06$var$t.document.createElement("canvas"), r = n.getContext("2d");
            } catch (t) {
                return !1;
            }
            return !0;
        }
        return !1;
    };
    return a(), e = function(t) {
        var e;
        if (!0 === a()) return r.width = t.width, r.height = t.height, r.clearRect(0, 0, t.width, t.height), r.putImageData(t, 0, 0), (e = new Image).src = n.toDataURL(), e;
        throw new Error("This method requires a Browser with Canvas-capability.");
    }, i.prototype.decodeFrames = function(t) {
        var n, r, i, a, o, s, u, c;
        if (this.animation) {
            for(c = [], r = o = 0, s = (u = this.animation.frames).length; o < s; r = ++o)n = u[r], i = t.createImageData(n.width, n.height), a = this.decodePixels(new Uint8Array(n.data)), this.copyToImageData(i, a), n.imageData = i, c.push(n.image = e(i));
            return c;
        }
    }, i.prototype.renderFrame = function(t, e) {
        var n, r, i;
        return n = (r = this.animation.frames)[e], i = r[e - 1], 0 === e && t.clearRect(0, 0, this.width, this.height), 1 === (null != i ? i.disposeOp : void 0) ? t.clearRect(i.xOffset, i.yOffset, i.width, i.height) : 2 === (null != i ? i.disposeOp : void 0) && t.putImageData(i.imageData, i.xOffset, i.yOffset), 0 === n.blendOp && t.clearRect(n.xOffset, n.yOffset, n.width, n.height), t.drawImage(n.image, n.xOffset, n.yOffset);
    }, i.prototype.animate = function(t) {
        var e, n, r, i, a, o, s = this;
        return n = 0, o = this.animation, i = o.numFrames, r = o.frames, a = o.numPlays, (e = function() {
            var o, u;
            if (o = n++ % i, u = r[o], s.renderFrame(t, o), i > 1 && n / i < a) return s.animation._timeout = setTimeout(e, u.delay);
        })();
    }, i.prototype.stopAnimation = function() {
        var t;
        return clearTimeout(null != (t = this.animation) ? t._timeout : void 0);
    }, i.prototype.render = function(t) {
        var e, n;
        return t._png && t._png.stopAnimation(), t._png = this, t.width = this.width, t.height = this.height, e = t.getContext("2d"), this.animation ? (this.decodeFrames(e), this.animate(e)) : (n = e.createImageData(this.width, this.height), this.copyToImageData(n, this.decodePixels()), e.putImageData(n, 0, 0));
    }, i;
}();
/**
 * @license
 * (c) Dean McNamee <dean@gmail.com>, 2013.
 *
 * https://github.com/deanm/omggif
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
 * including animation and compression.  It does not rely on any specific
 * underlying system, so should run in the browser, Node, or Plask.
 */ function $970c7ddf83730f06$var$jt(t) {
    var e = 0;
    if (71 !== t[e++] || 73 !== t[e++] || 70 !== t[e++] || 56 !== t[e++] || 56 != (t[e++] + 1 & 253) || 97 !== t[e++]) throw new Error("Invalid GIF 87a/89a header.");
    var n = t[e++] | t[e++] << 8, r = t[e++] | t[e++] << 8, i = t[e++], a = i >> 7, o = 1 << (7 & i) + 1;
    t[e++];
    t[e++];
    var s = null, u = null;
    a && (s = e, u = o, e += 3 * o);
    var c = !0, h = [], l = 0, f = null, d = 0, p = null;
    for(this.width = n, this.height = r; c && e < t.length;)switch(t[e++]){
        case 33:
            switch(t[e++]){
                case 255:
                    if (11 !== t[e] || 78 == t[e + 1] && 69 == t[e + 2] && 84 == t[e + 3] && 83 == t[e + 4] && 67 == t[e + 5] && 65 == t[e + 6] && 80 == t[e + 7] && 69 == t[e + 8] && 50 == t[e + 9] && 46 == t[e + 10] && 48 == t[e + 11] && 3 == t[e + 12] && 1 == t[e + 13] && 0 == t[e + 16]) e += 14, p = t[e++] | t[e++] << 8, e++;
                    else for(e += 12;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                case 249:
                    if (4 !== t[e++] || 0 !== t[e + 4]) throw new Error("Invalid graphics extension block.");
                    var g = t[e++];
                    l = t[e++] | t[e++] << 8, f = t[e++], 0 == (1 & g) && (f = null), d = g >> 2 & 7, e++;
                    break;
                case 254:
                    for(;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                default:
                    throw new Error("Unknown graphic control label: 0x" + t[e - 1].toString(16));
            }
            break;
        case 44:
            var m = t[e++] | t[e++] << 8, v = t[e++] | t[e++] << 8, b = t[e++] | t[e++] << 8, y = t[e++] | t[e++] << 8, w = t[e++], N = w >> 6 & 1, L = 1 << (7 & w) + 1, x = s, A = u, _ = !1;
            if (w >> 7) {
                _ = !0;
                x = e, A = L, e += 3 * L;
            }
            var S = e;
            for(e++;;){
                var P;
                if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                if (0 === P) break;
                e += P;
            }
            h.push({
                x: m,
                y: v,
                width: b,
                height: y,
                has_local_palette: _,
                palette_offset: x,
                palette_size: A,
                data_offset: S,
                data_length: e - S,
                transparent_index: f,
                interlaced: !!N,
                delay: l,
                disposal: d
            });
            break;
        case 59:
            c = !1;
            break;
        default:
            throw new Error("Unknown gif block: 0x" + t[e - 1].toString(16));
    }
    this.numFrames = function() {
        return h.length;
    }, this.loopCount = function() {
        return p;
    }, this.frameInfo = function(t) {
        if (t < 0 || t >= h.length) throw new Error("Frame index out of range.");
        return h[t];
    }, this.decodeAndBlitFrameBGRA = function(e, r) {
        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
        $970c7ddf83730f06$var$Bt(t, i.data_offset, o, a);
        var s = i.palette_offset, u = i.transparent_index;
        null === u && (u = 256);
        var c = i.width, h = n - c, l = c, f = 4 * (i.y * n + i.x), d = 4 * ((i.y + i.height) * n + i.x), p = f, g = 4 * h;
        !0 === i.interlaced && (g += 4 * n * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === l && (l = c, (p += g) >= d && (g = 4 * h + 4 * n * (m - 1), p = f + (c + h) * (m << 1), m >>= 1)), y === u) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                r[p++] = L, r[p++] = N, r[p++] = w, r[p++] = 255;
            }
            --l;
        }
    }, this.decodeAndBlitFrameRGBA = function(e, r) {
        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
        $970c7ddf83730f06$var$Bt(t, i.data_offset, o, a);
        var s = i.palette_offset, u = i.transparent_index;
        null === u && (u = 256);
        var c = i.width, h = n - c, l = c, f = 4 * (i.y * n + i.x), d = 4 * ((i.y + i.height) * n + i.x), p = f, g = 4 * h;
        !0 === i.interlaced && (g += 4 * n * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === l && (l = c, (p += g) >= d && (g = 4 * h + 4 * n * (m - 1), p = f + (c + h) * (m << 1), m >>= 1)), y === u) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                r[p++] = w, r[p++] = N, r[p++] = L, r[p++] = 255;
            }
            --l;
        }
    };
}
function $970c7ddf83730f06$var$Bt(t, e, r, i) {
    for(var a = t[e++], o = 1 << a, s = o + 1, u = s + 1, c = a + 1, h = (1 << c) - 1, l = 0, f = 0, d = 0, p = t[e++], g = new Int32Array(4096), m = null;;){
        for(; l < 16 && 0 !== p;)f |= t[e++] << l, l += 8, 1 === p ? p = t[e++] : --p;
        if (l < c) break;
        var v = f & h;
        if (f >>= c, l -= c, v !== o) {
            if (v === s) break;
            for(var b = v < u ? v : m, y = 0, w = b; w > o;)w = g[w] >> 8, ++y;
            var N = w;
            if (d + y + (b !== v ? 1 : 0) > i) return void $970c7ddf83730f06$var$n.log("Warning, gif stream longer than expected.");
            r[d++] = N;
            var L = d += y;
            for(b !== v && (r[d++] = N), w = b; y--;)w = g[w], r[--L] = 255 & w, w >>= 8;
            null !== m && u < 4096 && (g[u++] = m << 8 | N, u >= h + 1 && c < 12 && (++c, h = h << 1 | 1)), m = v;
        } else u = s + 1, h = (1 << (c = a + 1)) - 1, m = null;
    }
    return d !== i && $970c7ddf83730f06$var$n.log("Warning, gif stream shorter than expected."), r;
}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ function $970c7ddf83730f06$var$Ot(t) {
    var e, n, r, i, a, o = Math.floor, s = new Array(64), u = new Array(64), c = new Array(64), h = new Array(64), l = new Array(65535), f = new Array(65535), d = new Array(64), p = new Array(64), g = [], m = 0, v = 7, b = new Array(64), y = new Array(64), w = new Array(64), N = new Array(256), L = new Array(2048), x = [
        0,
        1,
        5,
        6,
        14,
        15,
        27,
        28,
        2,
        4,
        7,
        13,
        16,
        26,
        29,
        42,
        3,
        8,
        12,
        17,
        25,
        30,
        41,
        43,
        9,
        11,
        18,
        24,
        31,
        40,
        44,
        53,
        10,
        19,
        23,
        32,
        39,
        45,
        52,
        54,
        20,
        22,
        33,
        38,
        46,
        51,
        55,
        60,
        21,
        34,
        37,
        47,
        50,
        56,
        59,
        61,
        35,
        36,
        48,
        49,
        57,
        58,
        62,
        63
    ], A = [
        0,
        0,
        1,
        5,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ], _ = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], S = [
        0,
        0,
        2,
        1,
        3,
        3,
        2,
        4,
        3,
        5,
        5,
        4,
        4,
        0,
        0,
        1,
        125
    ], P = [
        1,
        2,
        3,
        0,
        4,
        17,
        5,
        18,
        33,
        49,
        65,
        6,
        19,
        81,
        97,
        7,
        34,
        113,
        20,
        50,
        129,
        145,
        161,
        8,
        35,
        66,
        177,
        193,
        21,
        82,
        209,
        240,
        36,
        51,
        98,
        114,
        130,
        9,
        10,
        22,
        23,
        24,
        25,
        26,
        37,
        38,
        39,
        40,
        41,
        42,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ], k = [
        0,
        0,
        3,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0
    ], F = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], I = [
        0,
        0,
        2,
        1,
        2,
        4,
        4,
        3,
        4,
        7,
        5,
        4,
        4,
        0,
        1,
        2,
        119
    ], C = [
        0,
        1,
        2,
        3,
        17,
        4,
        5,
        33,
        49,
        6,
        18,
        65,
        81,
        7,
        97,
        113,
        19,
        34,
        50,
        129,
        8,
        20,
        66,
        145,
        161,
        177,
        193,
        9,
        35,
        51,
        82,
        240,
        21,
        98,
        114,
        209,
        10,
        22,
        36,
        52,
        225,
        37,
        241,
        23,
        24,
        25,
        26,
        38,
        39,
        40,
        41,
        42,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ];
    function j(t, e) {
        for(var n = 0, r = 0, i = new Array, a = 1; a <= 16; a++){
            for(var o = 1; o <= t[a]; o++)i[e[r]] = [], i[e[r]][0] = n, i[e[r]][1] = a, r++, n++;
            n *= 2;
        }
        return i;
    }
    function B(t) {
        for(var e = t[0], n = t[1] - 1; n >= 0;)e & 1 << n && (m |= 1 << v), n--, --v < 0 && (255 == m ? (O(255), O(0)) : O(m), v = 7, m = 0);
    }
    function O(t) {
        g.push(t);
    }
    function M(t) {
        O(t >> 8 & 255), O(255 & t);
    }
    function E(t, e, n, r, i) {
        for(var a, o = i[0], s = i[240], u = function(t, e) {
            var n, r, i, a, o, s, u, c, h, l, f = 0;
            for(h = 0; h < 8; ++h){
                n = t[f], r = t[f + 1], i = t[f + 2], a = t[f + 3], o = t[f + 4], s = t[f + 5], u = t[f + 6];
                var p = n + (c = t[f + 7]), g = n - c, m = r + u, v = r - u, b = i + s, y = i - s, w = a + o, N = a - o, L = p + w, x = p - w, A = m + b, _ = m - b;
                t[f] = L + A, t[f + 4] = L - A;
                var S = .707106781 * (_ + x);
                t[f + 2] = x + S, t[f + 6] = x - S;
                var P = .382683433 * ((L = N + y) - (_ = v + g)), k = .5411961 * L + P, F = 1.306562965 * _ + P, I = .707106781 * (A = y + v), C = g + I, j = g - I;
                t[f + 5] = j + k, t[f + 3] = j - k, t[f + 1] = C + F, t[f + 7] = C - F, f += 8;
            }
            for(f = 0, h = 0; h < 8; ++h){
                n = t[f], r = t[f + 8], i = t[f + 16], a = t[f + 24], o = t[f + 32], s = t[f + 40], u = t[f + 48];
                var B = n + (c = t[f + 56]), O = n - c, M = r + u, E = r - u, q = i + s, R = i - s, T = a + o, D = a - o, U = B + T, z = B - T, H = M + q, W = M - q;
                t[f] = U + H, t[f + 32] = U - H;
                var V = .707106781 * (W + z);
                t[f + 16] = z + V, t[f + 48] = z - V;
                var G = .382683433 * ((U = D + R) - (W = E + O)), Y = .5411961 * U + G, J = 1.306562965 * W + G, X = .707106781 * (H = R + E), K = O + X, Z = O - X;
                t[f + 40] = Z + Y, t[f + 24] = Z - Y, t[f + 8] = K + J, t[f + 56] = K - J, f++;
            }
            for(h = 0; h < 64; ++h)l = t[h] * e[h], d[h] = l > 0 ? l + .5 | 0 : l - .5 | 0;
            return d;
        }(t, e), c = 0; c < 64; ++c)p[x[c]] = u[c];
        var h = p[0] - n;
        n = p[0], 0 == h ? B(r[0]) : (B(r[f[a = 32767 + h]]), B(l[a]));
        for(var g = 63; g > 0 && 0 == p[g];)g--;
        if (0 == g) return B(o), n;
        for(var m, v = 1; v <= g;){
            for(var b = v; 0 == p[v] && v <= g;)++v;
            var y = v - b;
            if (y >= 16) {
                m = y >> 4;
                for(var w = 1; w <= m; ++w)B(s);
                y &= 15;
            }
            a = 32767 + p[v], B(i[(y << 4) + f[a]]), B(l[a]), v++;
        }
        return 63 != g && B(o), n;
    }
    function q(t) {
        (t = Math.min(Math.max(t, 1), 100), a != t) && (!function(t) {
            for(var e = [
                16,
                11,
                10,
                16,
                24,
                40,
                51,
                61,
                12,
                12,
                14,
                19,
                26,
                58,
                60,
                55,
                14,
                13,
                16,
                24,
                40,
                57,
                69,
                56,
                14,
                17,
                22,
                29,
                51,
                87,
                80,
                62,
                18,
                22,
                37,
                56,
                68,
                109,
                103,
                77,
                24,
                35,
                55,
                64,
                81,
                104,
                113,
                92,
                49,
                64,
                78,
                87,
                103,
                121,
                120,
                101,
                72,
                92,
                95,
                98,
                112,
                100,
                103,
                99
            ], n = 0; n < 64; n++){
                var r = o((e[n] * t + 50) / 100);
                r = Math.min(Math.max(r, 1), 255), s[x[n]] = r;
            }
            for(var i = [
                17,
                18,
                24,
                47,
                99,
                99,
                99,
                99,
                18,
                21,
                26,
                66,
                99,
                99,
                99,
                99,
                24,
                26,
                56,
                99,
                99,
                99,
                99,
                99,
                47,
                66,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99
            ], a = 0; a < 64; a++){
                var l = o((i[a] * t + 50) / 100);
                l = Math.min(Math.max(l, 1), 255), u[x[a]] = l;
            }
            for(var f = [
                1,
                1.387039845,
                1.306562965,
                1.175875602,
                1,
                .785694958,
                .5411961,
                .275899379
            ], d = 0, p = 0; p < 8; p++)for(var g = 0; g < 8; g++)c[d] = 1 / (s[x[d]] * f[p] * f[g] * 8), h[d] = 1 / (u[x[d]] * f[p] * f[g] * 8), d++;
        }(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), a = t);
    }
    this.encode = function(t, a) {
        a && q(a), g = new Array, m = 0, v = 7, M(65496), M(65504), M(16), O(74), O(70), O(73), O(70), O(0), O(1), O(1), O(0), M(1), M(1), O(0), O(0), function() {
            M(65499), M(132), O(0);
            for(var t = 0; t < 64; t++)O(s[t]);
            O(1);
            for(var e = 0; e < 64; e++)O(u[e]);
        }(), function(t, e) {
            M(65472), M(17), O(8), M(e), M(t), O(3), O(1), O(17), O(0), O(2), O(17), O(1), O(3), O(17), O(1);
        }(t.width, t.height), function() {
            M(65476), M(418), O(0);
            for(var t = 0; t < 16; t++)O(A[t + 1]);
            for(var e = 0; e <= 11; e++)O(_[e]);
            O(16);
            for(var n = 0; n < 16; n++)O(S[n + 1]);
            for(var r = 0; r <= 161; r++)O(P[r]);
            O(1);
            for(var i = 0; i < 16; i++)O(k[i + 1]);
            for(var a = 0; a <= 11; a++)O(F[a]);
            O(17);
            for(var o = 0; o < 16; o++)O(I[o + 1]);
            for(var s = 0; s <= 161; s++)O(C[s]);
        }(), M(65498), M(12), O(3), O(1), O(0), O(2), O(17), O(3), O(17), O(0), O(63), O(0);
        var o = 0, l = 0, f = 0;
        m = 0, v = 7, this.encode.displayName = "_encode_";
        for(var d, p, N, x, j, R, T, D, U, z = t.data, H = t.width, W = t.height, V = 4 * H, G = 0; G < W;){
            for(d = 0; d < V;){
                for(j = V * G + d, T = -1, D = 0, U = 0; U < 64; U++)R = j + (D = U >> 3) * V + (T = 4 * (7 & U)), G + D >= W && (R -= V * (G + 1 + D - W)), d + T >= V && (R -= d + T - V + 4), p = z[R++], N = z[R++], x = z[R++], b[U] = (L[p] + L[N + 256 >> 0] + L[x + 512 >> 0] >> 16) - 128, y[U] = (L[p + 768 >> 0] + L[N + 1024 >> 0] + L[x + 1280 >> 0] >> 16) - 128, w[U] = (L[p + 1280 >> 0] + L[N + 1536 >> 0] + L[x + 1792 >> 0] >> 16) - 128;
                o = E(b, c, o, e, r), l = E(y, h, l, n, i), f = E(w, h, f, n, i), d += 32;
            }
            G += 8;
        }
        if (v >= 0) {
            var Y = [];
            Y[1] = v + 1, Y[0] = (1 << v + 1) - 1, B(Y);
        }
        return M(65497), new Uint8Array(g);
    }, t = t || 50, function() {
        for(var t = String.fromCharCode, e = 0; e < 256; e++)N[e] = t(e);
    }(), e = j(A, _), n = j(k, F), r = j(S, P), i = j(I, C), function() {
        for(var t = 1, e = 2, n = 1; n <= 15; n++){
            for(var r = t; r < e; r++)f[32767 + r] = n, l[32767 + r] = [], l[32767 + r][1] = n, l[32767 + r][0] = r;
            for(var i = -(e - 1); i <= -t; i++)f[32767 + i] = n, l[32767 + i] = [], l[32767 + i][1] = n, l[32767 + i][0] = e - 1 + i;
            t <<= 1, e <<= 1;
        }
    }(), function() {
        for(var t = 0; t < 256; t++)L[t] = 19595 * t, L[t + 256 >> 0] = 38470 * t, L[t + 512 >> 0] = 7471 * t + 32768, L[t + 768 >> 0] = -11059 * t, L[t + 1024 >> 0] = -21709 * t, L[t + 1280 >> 0] = 32768 * t + 8421375, L[t + 1536 >> 0] = -27439 * t, L[t + 1792 >> 0] = -5329 * t;
    }(), q(t);
}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function $970c7ddf83730f06$var$Mt(t, e) {
    if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === [
        "BM",
        "BA",
        "CI",
        "CP",
        "IC",
        "PT"
    ].indexOf(this.flag)) throw new Error("Invalid BMP File");
    this.parseHeader(), this.parseBGR();
}
function $970c7ddf83730f06$var$Et(t) {
    function e(t) {
        if (!t) throw Error("assert :P");
    }
    function n(t, e, n) {
        for(var r = 0; 4 > r; r++)if (t[e + r] != n.charCodeAt(r)) return !0;
        return !1;
    }
    function r(t, e, n, r, i) {
        for(var a = 0; a < i; a++)t[e + a] = n[r + a];
    }
    function i(t, e, n, r) {
        for(var i = 0; i < r; i++)t[e + i] = n;
    }
    function a(t) {
        return new Int32Array(t);
    }
    function o(t, e) {
        for(var n = [], r = 0; r < t; r++)n.push(new e);
        return n;
    }
    function s(t, e) {
        var n = [];
        return function t(n, r, i) {
            for(var a = i[r], o = 0; o < a && (n.push(i.length > r + 1 ? [] : new e), !(i.length < r + 1)); o++)t(n[o], r + 1, i);
        }(n, 0, t), n;
    }
    function u(t, e) {
        for(var n = "", r = 0; r < 4; r++)n += String.fromCharCode(t[e++]);
        return n;
    }
    function c(t, e) {
        return (t[e + 0] << 0 | t[e + 1] << 8 | t[e + 2] << 16) >>> 0;
    }
    function h(t, e) {
        return (t[e + 0] << 0 | t[e + 1] << 8 | t[e + 2] << 16 | t[e + 3] << 24) >>> 0;
    }
    new ($970c7ddf83730f06$var$Et = function() {
        var t = this;
        function u(t, e) {
            for(var n = 1 << e - 1 >>> 0; t & n;)n >>>= 1;
            return n ? (t & n - 1) + n : t;
        }
        function c(t, n, r, i, a) {
            e(!(i % r));
            do t[n + (i -= r)] = a;
            while (0 < i);
        }
        function h(t, n, r, i, o) {
            if (e(2328 >= o), 512 >= o) var s = a(512);
            else if (null == (s = a(o))) return 0;
            return function(t, n, r, i, o, s) {
                var h, f, d = n, p = 1 << r, g = a(16), m = a(16);
                for(e(0 != o), e(null != i), e(null != t), e(0 < r), f = 0; f < o; ++f){
                    if (15 < i[f]) return 0;
                    ++g[i[f]];
                }
                if (g[0] == o) return 0;
                for(m[1] = 0, h = 1; 15 > h; ++h){
                    if (g[h] > 1 << h) return 0;
                    m[h + 1] = m[h] + g[h];
                }
                for(f = 0; f < o; ++f)h = i[f], 0 < i[f] && (s[m[h]++] = f);
                if (1 == m[15]) return (i = new l).g = 0, i.value = s[0], c(t, d, 1, p, i), p;
                var v, b = -1, y = p - 1, w = 0, N = 1, L = 1, x = 1 << r;
                for(f = 0, h = 1, o = 2; h <= r; ++h, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[h])) return 0;
                    for(; 0 < g[h]; --g[h])(i = new l).g = h, i.value = s[f++], c(t, d + w, o, x, i), w = u(w, h);
                }
                for(h = r + 1, o = 2; 15 >= h; ++h, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[h])) return 0;
                    for(; 0 < g[h]; --g[h]){
                        if (i = new l, (w & y) != b) {
                            for(d += x, v = 1 << (b = h) - r; 15 > b && !(0 >= (v -= g[b]));)++b, v <<= 1;
                            p += x = 1 << (v = b - r), t[n + (b = w & y)].g = v + r, t[n + b].value = d - n - b;
                        }
                        i.g = h - r, i.value = s[f++], c(t, d + (w >> r), o, x, i), w = u(w, h);
                    }
                }
                return N != 2 * m[15] - 1 ? 0 : p;
            }(t, n, r, i, o, s);
        }
        function l() {
            this.value = this.g = 0;
        }
        function f() {
            this.value = this.g = 0;
        }
        function d() {
            this.G = o(5, l), this.H = a(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = o(Tn, f);
        }
        function p(t, n, r, i) {
            e(null != t), e(null != n), e(2147483648 > i), t.Ca = 254, t.I = 0, t.b = -8, t.Ka = 0, t.oa = n, t.pa = r, t.Jd = n, t.Yc = r + i, t.Zc = 4 <= i ? r + i - 4 + 1 : r, S(t);
        }
        function g(t, e) {
            for(var n = 0; 0 < e--;)n |= k(t, 128) << e;
            return n;
        }
        function m(t, e) {
            var n = g(t, e);
            return P(t) ? -n : n;
        }
        function v(t, n, r, i) {
            var a, o = 0;
            for(e(null != t), e(null != n), e(4294967288 > i), t.Sb = i, t.Ra = 0, t.u = 0, t.h = 0, 4 < i && (i = 4), a = 0; a < i; ++a)o += n[r + a] << 8 * a;
            t.Ra = o, t.bb = i, t.oa = n, t.pa = r;
        }
        function b(t) {
            for(; 8 <= t.u && t.bb < t.Sb;)t.Ra >>>= 8, t.Ra += t.oa[t.pa + t.bb] << zn - 8 >>> 0, ++t.bb, t.u -= 8;
            x(t) && (t.h = 1, t.u = 0);
        }
        function y(t, n) {
            if (e(0 <= n), !t.h && n <= Un) {
                var r = L(t) & Dn[n];
                return t.u += n, b(t), r;
            }
            return t.h = 1, t.u = 0;
        }
        function w() {
            this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
        }
        function N() {
            this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
        }
        function L(t) {
            return t.Ra >>> (t.u & zn - 1) >>> 0;
        }
        function x(t) {
            return e(t.bb <= t.Sb), t.h || t.bb == t.Sb && t.u > zn;
        }
        function A(t, e) {
            t.u = e, t.h = x(t);
        }
        function _(t) {
            t.u >= Hn && (e(t.u >= Hn), b(t));
        }
        function S(t) {
            e(null != t && null != t.oa), t.pa < t.Zc ? (t.I = (t.oa[t.pa++] | t.I << 8) >>> 0, t.b += 8) : (e(null != t && null != t.oa), t.pa < t.Yc ? (t.b += 8, t.I = t.oa[t.pa++] | t.I << 8) : t.Ka ? t.b = 0 : (t.I <<= 8, t.b += 8, t.Ka = 1));
        }
        function P(t) {
            return g(t, 1);
        }
        function k(t, e) {
            var n = t.Ca;
            0 > t.b && S(t);
            var r = t.b, i = n * e >>> 8, a = (t.I >>> r > i) + 0;
            for(a ? (n -= i, t.I -= i + 1 << r >>> 0) : n = i + 1, r = n, i = 0; 256 <= r;)i += 8, r >>= 8;
            return r = 7 ^ i + Wn[r], t.b -= r, t.Ca = (n << r) - 1, a;
        }
        function F(t, e, n) {
            t[e + 0] = n >> 24 & 255, t[e + 1] = n >> 16 & 255, t[e + 2] = n >> 8 & 255, t[e + 3] = n >> 0 & 255;
        }
        function I(t, e) {
            return t[e + 0] << 0 | t[e + 1] << 8;
        }
        function C(t, e) {
            return I(t, e) | t[e + 2] << 16;
        }
        function j(t, e) {
            return I(t, e) | I(t, e + 2) << 16;
        }
        function B(t, n) {
            var r = 1 << n;
            return e(null != t), e(0 < n), t.X = a(r), null == t.X ? 0 : (t.Mb = 32 - n, t.Xa = n, 1);
        }
        function O(t, n) {
            e(null != t), e(null != n), e(t.Xa == n.Xa), r(n.X, 0, t.X, 0, 1 << n.Xa);
        }
        function M() {
            this.X = [], this.Xa = this.Mb = 0;
        }
        function E(t, n, r, i) {
            e(null != r), e(null != i);
            var a = r[0], o = i[0];
            return 0 == a && (a = (t * o + n / 2) / n), 0 == o && (o = (n * a + t / 2) / t), 0 >= a || 0 >= o ? 0 : (r[0] = a, i[0] = o, 1);
        }
        function q(t, e) {
            return t + (1 << e) - 1 >>> e;
        }
        function R(t, e) {
            return ((4278255360 & t) + (4278255360 & e) >>> 0 & 4278255360) + ((16711935 & t) + (16711935 & e) >>> 0 & 16711935) >>> 0;
        }
        function T(e, n) {
            t[n] = function(n, r, i, a, o, s, u) {
                var c;
                for(c = 0; c < o; ++c){
                    var h = t[e](s[u + c - 1], i, a + c);
                    s[u + c] = R(n[r + c], h);
                }
            };
        }
        function D() {
            this.ud = this.hd = this.jd = 0;
        }
        function U(t, e) {
            return ((4278124286 & (t ^ e)) >>> 1) + (t & e) >>> 0;
        }
        function z(t) {
            return 0 <= t && 256 > t ? t : 0 > t ? 0 : 255 < t ? 255 : void 0;
        }
        function H(t, e) {
            return z(t + (t - e + .5 >> 1));
        }
        function W(t, e, n) {
            return Math.abs(e - n) - Math.abs(t - n);
        }
        function V(t, e, n, r, i, a, o) {
            for(r = a[o - 1], n = 0; n < i; ++n)a[o + n] = r = R(t[e + n], r);
        }
        function G(t, e, n, r, i) {
            var a;
            for(a = 0; a < n; ++a){
                var o = t[e + a], s = o >> 8 & 255, u = 16711935 & (u = (u = 16711935 & o) + ((s << 16) + s));
                r[i + a] = (4278255360 & o) + u >>> 0;
            }
        }
        function Y(t, e) {
            e.jd = t >> 0 & 255, e.hd = t >> 8 & 255, e.ud = t >> 16 & 255;
        }
        function J(t, e, n, r, i, a) {
            var o;
            for(o = 0; o < r; ++o){
                var s = e[n + o], u = s >>> 8, c = s, h = 255 & (h = (h = s >>> 16) + ((t.jd << 24 >> 24) * (u << 24 >> 24) >>> 5));
                c = 255 & (c = (c = c + ((t.hd << 24 >> 24) * (u << 24 >> 24) >>> 5)) + ((t.ud << 24 >> 24) * (h << 24 >> 24) >>> 5));
                i[a + o] = (4278255360 & s) + (h << 16) + c;
            }
        }
        function X(e, n, r, i, a) {
            t[n] = function(t, e, n, r, o, s, u, c, h) {
                for(r = u; r < c; ++r)for(u = 0; u < h; ++u)o[s++] = a(n[i(t[e++])]);
            }, t[e] = function(e, n, o, s, u, c, h) {
                var l = 8 >> e.b, f = e.Ea, d = e.K[0], p = e.w;
                if (8 > l) for(e = (1 << e.b) - 1, p = (1 << l) - 1; n < o; ++n){
                    var g, m = 0;
                    for(g = 0; g < f; ++g)g & e || (m = i(s[u++])), c[h++] = a(d[m & p]), m >>= l;
                }
                else t["VP8LMapColor" + r](s, u, d, p, c, h, n, o, f);
            };
        }
        function K(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = t[e++];
                r[i++] = a >> 16 & 255, r[i++] = a >> 8 & 255, r[i++] = a >> 0 & 255;
            }
        }
        function Z(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = t[e++];
                r[i++] = a >> 16 & 255, r[i++] = a >> 8 & 255, r[i++] = a >> 0 & 255, r[i++] = a >> 24 & 255;
            }
        }
        function $(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = (o = t[e++]) >> 16 & 240 | o >> 12 & 15, o = o >> 0 & 240 | o >> 28 & 15;
                r[i++] = a, r[i++] = o;
            }
        }
        function Q(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = (o = t[e++]) >> 16 & 248 | o >> 13 & 7, o = o >> 5 & 224 | o >> 3 & 31;
                r[i++] = a, r[i++] = o;
            }
        }
        function tt(t, e, n, r, i) {
            for(n = e + n; e < n;){
                var a = t[e++];
                r[i++] = a >> 0 & 255, r[i++] = a >> 8 & 255, r[i++] = a >> 16 & 255;
            }
        }
        function et(t, e, n, i, a, o) {
            if (0 == o) for(n = e + n; e < n;)F(i, ((o = t[e++])[0] >> 24 | o[1] >> 8 & 65280 | o[2] << 8 & 16711680 | o[3] << 24) >>> 0), a += 32;
            else r(i, a, t, e, n);
        }
        function nt(e, n) {
            t[n][0] = t[e + "0"], t[n][1] = t[e + "1"], t[n][2] = t[e + "2"], t[n][3] = t[e + "3"], t[n][4] = t[e + "4"], t[n][5] = t[e + "5"], t[n][6] = t[e + "6"], t[n][7] = t[e + "7"], t[n][8] = t[e + "8"], t[n][9] = t[e + "9"], t[n][10] = t[e + "10"], t[n][11] = t[e + "11"], t[n][12] = t[e + "12"], t[n][13] = t[e + "13"], t[n][14] = t[e + "0"], t[n][15] = t[e + "0"];
        }
        function rt(t) {
            return t == Hr || t == Wr || t == Vr || t == Gr;
        }
        function it() {
            this.eb = [], this.size = this.A = this.fb = 0;
        }
        function at() {
            this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
        }
        function ot() {
            this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new it, this.f.kb = new at, this.sd = null;
        }
        function st() {
            this.width = [
                0
            ], this.height = [
                0
            ], this.Pd = [
                0
            ], this.Qd = [
                0
            ], this.format = [
                0
            ];
        }
        function ut() {
            this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
        }
        function ct(t) {
            return alert("todo:WebPSamplerProcessPlane"), t.T;
        }
        function ht(t, e) {
            var n = t.T, i = e.ba.f.RGBA, a = i.eb, o = i.fb + t.ka * i.A, s = vi[e.ba.S], u = t.y, c = t.O, h = t.f, l = t.N, f = t.ea, d = t.W, p = e.cc, g = e.dc, m = e.Mc, v = e.Nc, b = t.ka, y = t.ka + t.T, w = t.U, N = w + 1 >> 1;
            for(0 == b ? s(u, c, null, null, h, l, f, d, h, l, f, d, a, o, null, null, w) : (s(e.ec, e.fc, u, c, p, g, m, v, h, l, f, d, a, o - i.A, a, o, w), ++n); b + 2 < y; b += 2)p = h, g = l, m = f, v = d, l += t.Rc, d += t.Rc, o += 2 * i.A, s(u, (c += 2 * t.fa) - t.fa, u, c, p, g, m, v, h, l, f, d, a, o - i.A, a, o, w);
            return c += t.fa, t.j + y < t.o ? (r(e.ec, e.fc, u, c, w), r(e.cc, e.dc, h, l, N), r(e.Mc, e.Nc, f, d, N), n--) : 1 & y || s(u, c, null, null, h, l, f, d, h, l, f, d, a, o + i.A, null, null, w), n;
        }
        function lt(t, n, r) {
            var i = t.F, a = [
                t.J
            ];
            if (null != i) {
                var o = t.U, s = n.ba.S, u = s == Dr || s == Vr;
                n = n.ba.f.RGBA;
                var c = [
                    0
                ], h = t.ka;
                c[0] = t.T, t.Kb && (0 == h ? --c[0] : (--h, a[0] -= t.width), t.j + t.ka + t.T == t.o && (c[0] = t.o - t.j - h));
                var l = n.eb;
                h = n.fb + h * n.A;
                t = _r(i, a[0], t.width, o, c, l, h + (u ? 0 : 3), n.A), e(r == c), t && rt(s) && xr(l, h, u, o, c, n.A);
            }
            return 0;
        }
        function ft(t) {
            var e = t.ma, n = e.ba.S, r = 11 > n, i = n == qr || n == Tr || n == Dr || n == Ur || 12 == n || rt(n);
            if (e.memory = null, e.Ib = null, e.Jb = null, e.Nd = null, !En(e.Oa, t, i ? 11 : 12)) return 0;
            if (i && rt(n) && yn(), t.da) alert("todo:use_scaling");
            else {
                if (r) {
                    if (e.Ib = ct, t.Kb) {
                        if (n = t.U + 1 >> 1, e.memory = a(t.U + 2 * n), null == e.memory) return 0;
                        e.ec = e.memory, e.fc = 0, e.cc = e.ec, e.dc = e.fc + t.U, e.Mc = e.cc, e.Nc = e.dc + n, e.Ib = ht, yn();
                    }
                } else alert("todo:EmitYUV");
                i && (e.Jb = lt, r && vn());
            }
            if (r && !Ci) {
                for(t = 0; 256 > t; ++t)ji[t] = 89858 * (t - 128) + Si >> _i, Mi[t] = -22014 * (t - 128) + Si, Oi[t] = -45773 * (t - 128), Bi[t] = 113618 * (t - 128) + Si >> _i;
                for(t = Pi; t < ki; ++t)e = 76283 * (t - 16) + Si >> _i, Ei[t - Pi] = Vt(e, 255), qi[t - Pi] = Vt(e + 8 >> 4, 15);
                Ci = 1;
            }
            return 1;
        }
        function dt(t) {
            var n = t.ma, r = t.U, i = t.T;
            return e(!(1 & t.ka)), 0 >= r || 0 >= i ? 0 : (r = n.Ib(t, n), null != n.Jb && n.Jb(t, n, r), n.Dc += r, 1);
        }
        function pt(t) {
            t.ma.memory = null;
        }
        function gt(t, e, n, r) {
            return 47 != y(t, 8) ? 0 : (e[0] = y(t, 14) + 1, n[0] = y(t, 14) + 1, r[0] = y(t, 1), 0 != y(t, 3) ? 0 : !t.h);
        }
        function mt(t, e) {
            if (4 > t) return t + 1;
            var n = t - 2 >> 1;
            return (2 + (1 & t) << n) + y(e, n) + 1;
        }
        function vt(t, e) {
            var n;
            return 120 < e ? e - 120 : 1 <= (n = ((n = $r[e - 1]) >> 4) * t + (8 - (15 & n))) ? n : 1;
        }
        function bt(t, e, n) {
            var r = L(n), i = t[e += 255 & r].g - 8;
            return 0 < i && (A(n, n.u + 8), r = L(n), e += t[e].value, e += r & (1 << i) - 1), A(n, n.u + t[e].g), t[e].value;
        }
        function yt(t, n, r) {
            return r.g += t.g, r.value += t.value << n >>> 0, e(8 >= r.g), t.g;
        }
        function wt(t, n, r) {
            var i = t.xc;
            return e((n = 0 == i ? 0 : t.vc[t.md * (r >> i) + (n >> i)]) < t.Wb), t.Ya[n];
        }
        function Nt(t, n, i, a) {
            var o = t.ab, s = t.c * n, u = t.C;
            n = u + n;
            var c = i, h = a;
            for(a = t.Ta, i = t.Ua; 0 < o--;){
                var l = t.gc[o], f = u, d = n, p = c, g = h, m = (h = a, c = i, l.Ea);
                switch(e(f < d), e(d <= l.nc), l.hc){
                    case 2:
                        Yn(p, g, (d - f) * m, h, c);
                        break;
                    case 0:
                        var v = f, b = d, y = h, w = c, N = (S = l).Ea;
                        0 == v && (Vn(p, g, null, null, 1, y, w), V(p, g + 1, 0, 0, N - 1, y, w + 1), g += N, w += N, ++v);
                        for(var L = 1 << S.b, x = L - 1, A = q(N, S.b), _ = S.K, S = S.w + (v >> S.b) * A; v < b;){
                            var P = _, k = S, F = 1;
                            for(Gn(p, g, y, w - N, 1, y, w); F < N;){
                                var I = (F & ~x) + L;
                                I > N && (I = N), (0, $n[P[k++] >> 8 & 15])(p, g + +F, y, w + F - N, I - F, y, w + F), F = I;
                            }
                            g += N, w += N, ++v & x || (S += A);
                        }
                        d != l.nc && r(h, c - m, h, c + (d - f - 1) * m, m);
                        break;
                    case 1:
                        for(m = p, b = g, N = (p = l.Ea) - (w = p & ~(y = (g = 1 << l.b) - 1)), v = q(p, l.b), L = l.K, l = l.w + (f >> l.b) * v; f < d;){
                            for(x = L, A = l, _ = new D, S = b + w, P = b + p; b < S;)Y(x[A++], _), Qn(_, m, b, g, h, c), b += g, c += g;
                            b < P && (Y(x[A++], _), Qn(_, m, b, N, h, c), b += N, c += N), ++f & y || (l += v);
                        }
                        break;
                    case 3:
                        if (p == h && g == c && 0 < l.b) {
                            for(b = h, p = m = c + (d - f) * m - (w = (d - f) * q(l.Ea, l.b)), g = h, y = c, v = [], w = (N = w) - 1; 0 <= w; --w)v[w] = g[y + w];
                            for(w = N - 1; 0 <= w; --w)b[p + w] = v[w];
                            Jn(l, f, d, h, m, h, c);
                        } else Jn(l, f, d, p, g, h, c);
                }
                c = a, h = i;
            }
            h != i && r(a, i, c, h, s);
        }
        function Lt(t, n) {
            var r = t.V, i = t.Ba + t.c * t.C, a = n - t.C;
            if (e(n <= t.l.o), e(16 >= a), 0 < a) {
                var o = t.l, s = t.Ta, u = t.Ua, c = o.width;
                if (Nt(t, a, r, i), a = u = [
                    u
                ], e((r = t.C) < (i = n)), e(o.v < o.va), i > o.o && (i = o.o), r < o.j) {
                    var h = o.j - r;
                    r = o.j;
                    a[0] += h * c;
                }
                if (r >= i ? r = 0 : (a[0] += 4 * o.v, o.ka = r - o.j, o.U = o.va - o.v, o.T = i - r, r = 1), r) {
                    if (u = u[0], 11 > (r = t.ca).S) {
                        var l = r.f.RGBA, f = (i = r.S, a = o.U, o = o.T, h = l.eb, l.A), d = o;
                        for(l = l.fb + t.Ma * l.A; 0 < d--;){
                            var p = s, g = u, m = a, v = h, b = l;
                            switch(i){
                                case Er:
                                    tr(p, g, m, v, b);
                                    break;
                                case qr:
                                    er(p, g, m, v, b);
                                    break;
                                case Hr:
                                    er(p, g, m, v, b), xr(v, b, 0, m, 1, 0);
                                    break;
                                case Rr:
                                    ir(p, g, m, v, b);
                                    break;
                                case Tr:
                                    et(p, g, m, v, b, 1);
                                    break;
                                case Wr:
                                    et(p, g, m, v, b, 1), xr(v, b, 0, m, 1, 0);
                                    break;
                                case Dr:
                                    et(p, g, m, v, b, 0);
                                    break;
                                case Vr:
                                    et(p, g, m, v, b, 0), xr(v, b, 1, m, 1, 0);
                                    break;
                                case Ur:
                                    nr(p, g, m, v, b);
                                    break;
                                case Gr:
                                    nr(p, g, m, v, b), Ar(v, b, m, 1, 0);
                                    break;
                                case zr:
                                    rr(p, g, m, v, b);
                                    break;
                                default:
                                    e(0);
                            }
                            u += c, l += f;
                        }
                        t.Ma += o;
                    } else alert("todo:EmitRescaledRowsYUVA");
                    e(t.Ma <= r.height);
                }
            }
            t.C = n, e(t.C <= t.i);
        }
        function xt(t) {
            var e;
            if (0 < t.ua) return 0;
            for(e = 0; e < t.Wb; ++e){
                var n = t.Ya[e].G, r = t.Ya[e].H;
                if (0 < n[1][r[1] + 0].g || 0 < n[2][r[2] + 0].g || 0 < n[3][r[3] + 0].g) return 0;
            }
            return 1;
        }
        function At(t, n, r, i, a, o) {
            if (0 != t.Z) {
                var s = t.qd, u = t.rd;
                for(e(null != mi[t.Z]); n < r; ++n)mi[t.Z](s, u, i, a, i, a, o), s = i, u = a, a += o;
                t.qd = s, t.rd = u;
            }
        }
        function _t(t, n) {
            var r = t.l.ma, i = 0 == r.Z || 1 == r.Z ? t.l.j : t.C;
            i = t.C < i ? i : t.C;
            if (e(n <= t.l.o), n > i) {
                var a = t.l.width, o = r.ca, s = r.tb + a * i, u = t.V, c = t.Ba + t.c * i, h = t.gc;
                e(1 == t.ab), e(3 == h[0].hc), Kn(h[0], i, n, u, c, o, s), At(r, i, n, o, s, a);
            }
            t.C = t.Ma = n;
        }
        function St(t, n, r, i, a, o, s) {
            var u = t.$ / i, c = t.$ % i, h = t.m, l = t.s, f = r + t.$, d = f;
            a = r + i * a;
            var p = r + i * o, g = 280 + l.ua, m = t.Pb ? u : 16777216, v = 0 < l.ua ? l.Wa : null, b = l.wc, y = f < p ? wt(l, c, u) : null;
            e(t.C < o), e(p <= a);
            var w = !1;
            t: for(;;){
                for(; w || f < p;){
                    var N = 0;
                    if (u >= m) {
                        var S = f - r;
                        e((m = t).Pb), m.wd = m.m, m.xd = S, 0 < m.s.ua && O(m.s.Wa, m.s.vb), m = u + ti;
                    }
                    if (c & b || (y = wt(l, c, u)), e(null != y), y.Qb && (n[f] = y.qb, w = !0), !w) {
                        if (_(h), y.jc) {
                            N = h, S = n;
                            var P = f, k = y.pd[L(N) & Tn - 1];
                            e(y.jc), 256 > k.g ? (A(N, N.u + k.g), S[P] = k.value, N = 0) : (A(N, N.u + k.g - 256), e(256 <= k.value), N = k.value), 0 == N && (w = !0);
                        } else N = bt(y.G[0], y.H[0], h);
                    }
                    if (h.h) break;
                    if (w || 256 > N) {
                        if (!w) {
                            if (y.nd) n[f] = (y.qb | N << 8) >>> 0;
                            else {
                                if (_(h), w = bt(y.G[1], y.H[1], h), _(h), S = bt(y.G[2], y.H[2], h), P = bt(y.G[3], y.H[3], h), h.h) break;
                                n[f] = (P << 24 | w << 16 | N << 8 | S) >>> 0;
                            }
                        }
                        if (w = !1, ++f, ++c >= i && (c = 0, ++u, null != s && u <= o && !(u % 16) && s(t, u), null != v)) for(; d < f;)N = n[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else if (280 > N) {
                        if (N = mt(N - 256, h), S = bt(y.G[4], y.H[4], h), _(h), S = vt(i, S = mt(S, h)), h.h) break;
                        if (f - r < S || a - f < N) break t;
                        for(P = 0; P < N; ++P)n[f + P] = n[f + P - S];
                        for(f += N, c += N; c >= i;)c -= i, ++u, null != s && u <= o && !(u % 16) && s(t, u);
                        if (e(f <= a), c & b && (y = wt(l, c, u)), null != v) for(; d < f;)N = n[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else {
                        if (!(N < g)) break t;
                        for(w = N - 280, e(null != v); d < f;)N = n[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                        N = f, e(!(w >>> (S = v).Xa)), n[N] = S.X[w], w = !0;
                    }
                    w || e(h.h == x(h));
                }
                if (t.Pb && h.h && f < a) e(t.m.h), t.a = 5, t.m = t.wd, t.$ = t.xd, 0 < t.s.ua && O(t.s.vb, t.s.Wa);
                else {
                    if (h.h) break t;
                    null != s && s(t, u > o ? o : u), t.a = 0, t.$ = f - r;
                }
                return 1;
            }
            return t.a = 3, 0;
        }
        function Pt(t) {
            e(null != t), t.vc = null, t.yc = null, t.Ya = null;
            var n = t.Wa;
            null != n && (n.X = null), t.vb = null, e(null != t);
        }
        function kt() {
            var e = new sn;
            return null == e ? null : (e.a = 0, e.xb = gi, nt("Predictor", "VP8LPredictors"), nt("Predictor", "VP8LPredictors_C"), nt("PredictorAdd", "VP8LPredictorsAdd"), nt("PredictorAdd", "VP8LPredictorsAdd_C"), Yn = G, Qn = J, tr = K, er = Z, nr = $, rr = Q, ir = tt, t.VP8LMapColor32b = Xn, t.VP8LMapColor8b = Zn, e);
        }
        function Ft(t, n, r, s, u) {
            var c = 1, f = [
                t
            ], p = [
                n
            ], g = s.m, m = s.s, v = null, b = 0;
            t: for(;;){
                if (r) for(; c && y(g, 1);){
                    var w = f, N = p, x = s, S = 1, P = x.m, k = x.gc[x.ab], F = y(P, 2);
                    if (x.Oc & 1 << F) c = 0;
                    else {
                        switch(x.Oc |= 1 << F, k.hc = F, k.Ea = w[0], k.nc = N[0], k.K = [
                            null
                        ], ++x.ab, e(4 >= x.ab), F){
                            case 0:
                            case 1:
                                k.b = y(P, 3) + 2, S = Ft(q(k.Ea, k.b), q(k.nc, k.b), 0, x, k.K), k.K = k.K[0];
                                break;
                            case 3:
                                var I, C = y(P, 8) + 1, j = 16 < C ? 0 : 4 < C ? 1 : 2 < C ? 2 : 3;
                                if (w[0] = q(k.Ea, j), k.b = j, I = S = Ft(C, 1, 0, x, k.K)) {
                                    var O, M = C, E = k, T = 1 << (8 >> E.b), D = a(T);
                                    if (null == D) I = 0;
                                    else {
                                        var U = E.K[0], z = E.w;
                                        for(D[0] = E.K[0][0], O = 1; O < 1 * M; ++O)D[O] = R(U[z + O], D[O - 1]);
                                        for(; O < 4 * T; ++O)D[O] = 0;
                                        E.K[0] = null, E.K[0] = D, I = 1;
                                    }
                                }
                                S = I;
                                break;
                            case 2:
                                break;
                            default:
                                e(0);
                        }
                        c = S;
                    }
                }
                if (f = f[0], p = p[0], c && y(g, 1) && !(c = 1 <= (b = y(g, 4)) && 11 >= b)) {
                    s.a = 3;
                    break t;
                }
                var H;
                if (H = c) e: {
                    var W, V, G, Y = s, J = f, X = p, K = b, Z = r, $ = Y.m, Q = Y.s, tt = [
                        null
                    ], et = 1, nt = 0, rt = Qr[K];
                    n: for(;;){
                        if (Z && y($, 1)) {
                            var it = y($, 3) + 2, at = q(J, it), ot = q(X, it), st = at * ot;
                            if (!Ft(at, ot, 0, Y, tt)) break n;
                            for(tt = tt[0], Q.xc = it, W = 0; W < st; ++W){
                                var ut = tt[W] >> 8 & 65535;
                                tt[W] = ut, ut >= et && (et = ut + 1);
                            }
                        }
                        if ($.h) break n;
                        for(V = 0; 5 > V; ++V){
                            var ct = Xr[V];
                            !V && 0 < K && (ct += 1 << K), nt < ct && (nt = ct);
                        }
                        var ht = o(et * rt, l), lt = et, ft = o(lt, d);
                        if (null == ft) var dt = null;
                        else e(65536 >= lt), dt = ft;
                        var pt = a(nt);
                        if (null == dt || null == pt || null == ht) {
                            Y.a = 1;
                            break n;
                        }
                        var gt = ht;
                        for(W = G = 0; W < et; ++W){
                            var mt = dt[W], vt = mt.G, bt = mt.H, wt = 0, Nt = 1, Lt = 0;
                            for(V = 0; 5 > V; ++V){
                                ct = Xr[V], vt[V] = gt, bt[V] = G, !V && 0 < K && (ct += 1 << K);
                                r: {
                                    var xt, At = ct, _t = Y, kt = pt, It = gt, Ct = G, jt = 0, Bt = _t.m, Ot = y(Bt, 1);
                                    if (i(kt, 0, 0, At), Ot) {
                                        var Mt = y(Bt, 1) + 1, Et = y(Bt, 1), qt = y(Bt, 0 == Et ? 1 : 8);
                                        kt[qt] = 1, 2 == Mt && (kt[qt = y(Bt, 8)] = 1);
                                        var Rt = 1;
                                    } else {
                                        var Tt = a(19), Dt = y(Bt, 4) + 4;
                                        if (19 < Dt) {
                                            _t.a = 3;
                                            var Ut = 0;
                                            break r;
                                        }
                                        for(xt = 0; xt < Dt; ++xt)Tt[Zr[xt]] = y(Bt, 3);
                                        var zt = void 0, Ht = void 0, Wt = _t, Vt = Tt, Gt = At, Yt = kt, Jt = 0, Xt = Wt.m, Kt = 8, Zt = o(128, l);
                                        i: for(; h(Zt, 0, 7, Vt, 19);){
                                            if (y(Xt, 1)) {
                                                var $t = 2 + 2 * y(Xt, 3);
                                                if ((zt = 2 + y(Xt, $t)) > Gt) break i;
                                            } else zt = Gt;
                                            for(Ht = 0; Ht < Gt && zt--;){
                                                _(Xt);
                                                var Qt = Zt[0 + (127 & L(Xt))];
                                                A(Xt, Xt.u + Qt.g);
                                                var te = Qt.value;
                                                if (16 > te) Yt[Ht++] = te, 0 != te && (Kt = te);
                                                else {
                                                    var ee = 16 == te, ne = te - 16, re = Jr[ne], ie = y(Xt, Yr[ne]) + re;
                                                    if (Ht + ie > Gt) break i;
                                                    for(var ae = ee ? Kt : 0; 0 < ie--;)Yt[Ht++] = ae;
                                                }
                                            }
                                            Jt = 1;
                                            break i;
                                        }
                                        Jt || (Wt.a = 3), Rt = Jt;
                                    }
                                    (Rt = Rt && !Bt.h) && (jt = h(It, Ct, 8, kt, At)), Rt && 0 != jt ? Ut = jt : (_t.a = 3, Ut = 0);
                                }
                                if (0 == Ut) break n;
                                if (Nt && 1 == Kr[V] && (Nt = 0 == gt[G].g), wt += gt[G].g, G += Ut, 3 >= V) {
                                    var oe, se = pt[0];
                                    for(oe = 1; oe < ct; ++oe)pt[oe] > se && (se = pt[oe]);
                                    Lt += se;
                                }
                            }
                            if (mt.nd = Nt, mt.Qb = 0, Nt && (mt.qb = (vt[3][bt[3] + 0].value << 24 | vt[1][bt[1] + 0].value << 16 | vt[2][bt[2] + 0].value) >>> 0, 0 == wt && 256 > vt[0][bt[0] + 0].value && (mt.Qb = 1, mt.qb += vt[0][bt[0] + 0].value << 8)), mt.jc = !mt.Qb && 6 > Lt, mt.jc) {
                                var ue, ce = mt;
                                for(ue = 0; ue < Tn; ++ue){
                                    var he = ue, le = ce.pd[he], fe = ce.G[0][ce.H[0] + he];
                                    256 <= fe.value ? (le.g = fe.g + 256, le.value = fe.value) : (le.g = 0, le.value = 0, he >>= yt(fe, 8, le), he >>= yt(ce.G[1][ce.H[1] + he], 16, le), he >>= yt(ce.G[2][ce.H[2] + he], 0, le), yt(ce.G[3][ce.H[3] + he], 24, le));
                                }
                            }
                        }
                        Q.vc = tt, Q.Wb = et, Q.Ya = dt, Q.yc = ht, H = 1;
                        break e;
                    }
                    H = 0;
                }
                if (!(c = H)) {
                    s.a = 3;
                    break t;
                }
                if (0 < b) {
                    if (m.ua = 1 << b, !B(m.Wa, b)) {
                        s.a = 1, c = 0;
                        break t;
                    }
                } else m.ua = 0;
                var de = s, pe = f, ge = p, me = de.s, ve = me.xc;
                if (de.c = pe, de.i = ge, me.md = q(pe, ve), me.wc = 0 == ve ? -1 : (1 << ve) - 1, r) {
                    s.xb = pi;
                    break t;
                }
                if (null == (v = a(f * p))) {
                    s.a = 1, c = 0;
                    break t;
                }
                c = (c = St(s, v, 0, f, p, p, null)) && !g.h;
                break t;
            }
            return c ? (null != u ? u[0] = v : (e(null == v), e(r)), s.$ = 0, r || Pt(m)) : Pt(m), c;
        }
        function It(t, n) {
            var r = t.c * t.i, i = r + n + 16 * n;
            return e(t.c <= n), t.V = a(i), null == t.V ? (t.Ta = null, t.Ua = 0, t.a = 1, 0) : (t.Ta = t.V, t.Ua = t.Ba + r + n, 1);
        }
        function Ct(t, n) {
            var r = t.C, i = n - r, a = t.V, o = t.Ba + t.c * r;
            for(e(n <= t.l.o); 0 < i;){
                var s = 16 < i ? 16 : i, u = t.l.ma, c = t.l.width, h = c * s, l = u.ca, f = u.tb + c * r, d = t.Ta, p = t.Ua;
                Nt(t, s, a, o), Sr(d, p, l, f, h), At(u, r, r + s, l, f, c), i -= s, a += s * t.c, r += s;
            }
            e(r == n), t.C = t.Ma = n;
        }
        function jt() {
            this.ub = this.yd = this.td = this.Rb = 0;
        }
        function Bt() {
            this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
        }
        function Ot() {
            this.Fb = this.Bb = this.Cb = 0, this.Zb = a(4), this.Lb = a(4);
        }
        function Mt() {
            this.Yb = function() {
                var t = [];
                return function t(e, n, r) {
                    for(var i = r[n], a = 0; a < i && (e.push(r.length > n + 1 ? [] : 0), !(r.length < n + 1)); a++)t(e[a], n + 1, r);
                }(t, 0, [
                    3,
                    11
                ]), t;
            }();
        }
        function Et() {
            this.jb = a(3), this.Wc = s([
                4,
                8
            ], Mt), this.Xc = s([
                4,
                17
            ], Mt);
        }
        function qt() {
            this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new a(4), this.od = new a(4);
        }
        function Rt() {
            this.ld = this.La = this.dd = this.tc = 0;
        }
        function Tt() {
            this.Na = this.la = 0;
        }
        function Dt() {
            this.Sc = [
                0,
                0
            ], this.Eb = [
                0,
                0
            ], this.Qc = [
                0,
                0
            ], this.ia = this.lc = 0;
        }
        function Ut() {
            this.ad = a(384), this.Za = 0, this.Ob = a(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
        }
        function zt() {
            this.uc = this.M = this.Nb = 0, this.wa = Array(new Rt), this.Y = 0, this.ya = Array(new Ut), this.aa = 0, this.l = new Gt;
        }
        function Ht() {
            this.y = a(16), this.f = a(8), this.ea = a(8);
        }
        function Wt() {
            this.cb = this.a = 0, this.sc = "", this.m = new w, this.Od = new jt, this.Kc = new Bt, this.ed = new qt, this.Qa = new Ot, this.Ic = this.$c = this.Aa = 0, this.D = new zt, this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = o(8, w), this.ia = 0, this.pb = o(4, Dt), this.Pa = new Et, this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [
                0,
                0,
                0,
                0
            ], this.Gd = Array(new Ht), this.Hd = 0, this.rb = Array(new Tt), this.sb = 0, this.wa = Array(new Rt), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new Ut), this.L = this.aa = 0, this.gd = s([
                4,
                2
            ], Rt), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function Gt() {
            this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
        }
        function Yt() {
            var t = new Wt;
            return null != t && (t.a = 0, t.sc = "OK", t.cb = 0, t.Xb = 0, ri || (ri = Zt)), t;
        }
        function Jt(t, e, n) {
            return 0 == t.a && (t.a = e, t.sc = n, t.cb = 0), 0;
        }
        function Xt(t, e, n) {
            return 3 <= n && 157 == t[e + 0] && 1 == t[e + 1] && 42 == t[e + 2];
        }
        function Kt(t, n) {
            if (null == t) return 0;
            if (t.a = 0, t.sc = "OK", null == n) return Jt(t, 2, "null VP8Io passed to VP8GetHeaders()");
            var r = n.data, a = n.w, o = n.ha;
            if (4 > o) return Jt(t, 7, "Truncated header.");
            var s = r[a + 0] | r[a + 1] << 8 | r[a + 2] << 16, u = t.Od;
            if (u.Rb = !(1 & s), u.td = s >> 1 & 7, u.yd = s >> 4 & 1, u.ub = s >> 5, 3 < u.td) return Jt(t, 3, "Incorrect keyframe parameters.");
            if (!u.yd) return Jt(t, 4, "Frame not displayable.");
            a += 3, o -= 3;
            var c = t.Kc;
            if (u.Rb) {
                if (7 > o) return Jt(t, 7, "cannot parse picture header");
                if (!Xt(r, a, o)) return Jt(t, 3, "Bad code word");
                c.c = 16383 & (r[a + 4] << 8 | r[a + 3]), c.Td = r[a + 4] >> 6, c.i = 16383 & (r[a + 6] << 8 | r[a + 5]), c.Ud = r[a + 6] >> 6, a += 7, o -= 7, t.za = c.c + 15 >> 4, t.Ub = c.i + 15 >> 4, n.width = c.c, n.height = c.i, n.Da = 0, n.j = 0, n.v = 0, n.va = n.width, n.o = n.height, n.da = 0, n.ib = n.width, n.hb = n.height, n.U = n.width, n.T = n.height, i((s = t.Pa).jb, 0, 255, s.jb.length), e(null != (s = t.Qa)), s.Cb = 0, s.Bb = 0, s.Fb = 1, i(s.Zb, 0, 0, s.Zb.length), i(s.Lb, 0, 0, s.Lb);
            }
            if (u.ub > o) return Jt(t, 7, "bad partition length");
            p(s = t.m, r, a, u.ub), a += u.ub, o -= u.ub, u.Rb && (c.Ld = P(s), c.Kd = P(s)), c = t.Qa;
            var h, l = t.Pa;
            if (e(null != s), e(null != c), c.Cb = P(s), c.Cb) {
                if (c.Bb = P(s), P(s)) {
                    for(c.Fb = P(s), h = 0; 4 > h; ++h)c.Zb[h] = P(s) ? m(s, 7) : 0;
                    for(h = 0; 4 > h; ++h)c.Lb[h] = P(s) ? m(s, 6) : 0;
                }
                if (c.Bb) for(h = 0; 3 > h; ++h)l.jb[h] = P(s) ? g(s, 8) : 255;
            } else c.Bb = 0;
            if (s.Ka) return Jt(t, 3, "cannot parse segment header");
            if ((c = t.ed).zd = P(s), c.Tb = g(s, 6), c.wb = g(s, 3), c.Pc = P(s), c.Pc && P(s)) {
                for(l = 0; 4 > l; ++l)P(s) && (c.vd[l] = m(s, 6));
                for(l = 0; 4 > l; ++l)P(s) && (c.od[l] = m(s, 6));
            }
            if (t.L = 0 == c.Tb ? 0 : c.zd ? 1 : 2, s.Ka) return Jt(t, 3, "cannot parse filter header");
            var f = o;
            if (o = h = a, a = h + f, c = f, t.Xb = (1 << g(t.m, 2)) - 1, f < 3 * (l = t.Xb)) r = 7;
            else {
                for(h += 3 * l, c -= 3 * l, f = 0; f < l; ++f){
                    var d = r[o + 0] | r[o + 1] << 8 | r[o + 2] << 16;
                    d > c && (d = c), p(t.Jc[+f], r, h, d), h += d, c -= d, o += 3;
                }
                p(t.Jc[+l], r, h, c), r = h < a ? 0 : 5;
            }
            if (0 != r) return Jt(t, r, "cannot parse partitions");
            for(r = g(h = t.m, 7), o = P(h) ? m(h, 4) : 0, a = P(h) ? m(h, 4) : 0, c = P(h) ? m(h, 4) : 0, l = P(h) ? m(h, 4) : 0, h = P(h) ? m(h, 4) : 0, f = t.Qa, d = 0; 4 > d; ++d){
                if (f.Cb) {
                    var v = f.Zb[d];
                    f.Fb || (v += r);
                } else {
                    if (0 < d) {
                        t.pb[d] = t.pb[0];
                        continue;
                    }
                    v = r;
                }
                var b = t.pb[d];
                b.Sc[0] = ei[Vt(v + o, 127)], b.Sc[1] = ni[Vt(v + 0, 127)], b.Eb[0] = 2 * ei[Vt(v + a, 127)], b.Eb[1] = 101581 * ni[Vt(v + c, 127)] >> 16, 8 > b.Eb[1] && (b.Eb[1] = 8), b.Qc[0] = ei[Vt(v + l, 117)], b.Qc[1] = ni[Vt(v + h, 127)], b.lc = v + h;
            }
            if (!u.Rb) return Jt(t, 4, "Not a key frame.");
            for(P(s), u = t.Pa, r = 0; 4 > r; ++r){
                for(o = 0; 8 > o; ++o)for(a = 0; 3 > a; ++a)for(c = 0; 11 > c; ++c)l = k(s, ci[r][o][a][c]) ? g(s, 8) : si[r][o][a][c], u.Wc[r][o].Yb[a][c] = l;
                for(o = 0; 17 > o; ++o)u.Xc[r][o] = u.Wc[r][hi[o]];
            }
            return t.kc = P(s), t.kc && (t.Bd = g(s, 8)), t.cb = 1;
        }
        function Zt(t, e, n, r, i, a, o) {
            var s = e[i].Yb[n];
            for(n = 0; 16 > i; ++i){
                if (!k(t, s[n + 0])) return i;
                for(; !k(t, s[n + 1]);)if (s = e[++i].Yb[0], n = 0, 16 == i) return 16;
                var u = e[i + 1].Yb;
                if (k(t, s[n + 2])) {
                    var c = t, h = 0;
                    if (k(c, (f = s)[(l = n) + 3])) {
                        if (k(c, f[l + 6])) {
                            for(s = 0, l = 2 * (h = k(c, f[l + 8])) + (f = k(c, f[l + 9 + h])), h = 0, f = ii[l]; f[s]; ++s)h += h + k(c, f[s]);
                            h += 3 + (8 << l);
                        } else k(c, f[l + 7]) ? (h = 7 + 2 * k(c, 165), h += k(c, 145)) : h = 5 + k(c, 159);
                    } else h = k(c, f[l + 4]) ? 3 + k(c, f[l + 5]) : 2;
                    s = u[2];
                } else h = 1, s = u[1];
                u = o + ai[i], 0 > (c = t).b && S(c);
                var l, f = c.b, d = (l = c.Ca >> 1) - (c.I >> f) >> 31;
                --c.b, c.Ca += d, c.Ca |= 1, c.I -= (l + 1 & d) << f, a[u] = ((h ^ d) - d) * r[(0 < i) + 0];
            }
            return 16;
        }
        function $t(t) {
            var e = t.rb[t.sb - 1];
            e.la = 0, e.Na = 0, i(t.zc, 0, 0, t.zc.length), t.ja = 0;
        }
        function Qt(t, n) {
            if (null == t) return 0;
            if (null == n) return Jt(t, 2, "NULL VP8Io parameter in VP8Decode().");
            if (!t.cb && !Kt(t, n)) return 0;
            if (e(t.cb), null == n.ac || n.ac(n)) {
                n.ob && (t.L = 0);
                var s = Ti[t.L];
                if (2 == t.L ? (t.yb = 0, t.zb = 0) : (t.yb = n.v - s >> 4, t.zb = n.j - s >> 4, 0 > t.yb && (t.yb = 0), 0 > t.zb && (t.zb = 0)), t.Va = n.o + 15 + s >> 4, t.Hb = n.va + 15 + s >> 4, t.Hb > t.za && (t.Hb = t.za), t.Va > t.Ub && (t.Va = t.Ub), 0 < t.L) {
                    var u = t.ed;
                    for(s = 0; 4 > s; ++s){
                        var c;
                        if (t.Qa.Cb) {
                            var h = t.Qa.Lb[s];
                            t.Qa.Fb || (h += u.Tb);
                        } else h = u.Tb;
                        for(c = 0; 1 >= c; ++c){
                            var l = t.gd[s][c], f = h;
                            if (u.Pc && (f += u.vd[0], c && (f += u.od[0])), 0 < (f = 0 > f ? 0 : 63 < f ? 63 : f)) {
                                var d = f;
                                0 < u.wb && (d = 4 < u.wb ? d >> 2 : d >> 1) > 9 - u.wb && (d = 9 - u.wb), 1 > d && (d = 1), l.dd = d, l.tc = 2 * f + d, l.ld = 40 <= f ? 2 : 15 <= f ? 1 : 0;
                            } else l.tc = 0;
                            l.La = c;
                        }
                    }
                }
                s = 0;
            } else Jt(t, 6, "Frame setup failed"), s = t.a;
            if (s = 0 == s) {
                if (s) {
                    t.$c = 0, 0 < t.Aa || (t.Ic = Ui);
                    t: {
                        s = t.Ic;
                        u = 4 * (d = t.za);
                        var p = 32 * d, g = d + 1, m = 0 < t.L ? d * (0 < t.Aa ? 2 : 1) : 0, v = (2 == t.Aa ? 2 : 1) * d;
                        if ((l = u + 832 + (c = 3 * (16 * s + Ti[t.L]) / 2 * p) + (h = null != t.Fa && 0 < t.Fa.length ? t.Kc.c * t.Kc.i : 0)) != l) s = 0;
                        else {
                            if (l > t.Vb) {
                                if (t.Vb = 0, t.Ec = a(l), t.Fc = 0, null == t.Ec) {
                                    s = Jt(t, 1, "no memory during frame initialization.");
                                    break t;
                                }
                                t.Vb = l;
                            }
                            l = t.Ec, f = t.Fc, t.Ac = l, t.Bc = f, f += u, t.Gd = o(p, Ht), t.Hd = 0, t.rb = o(g + 1, Tt), t.sb = 1, t.wa = m ? o(m, Rt) : null, t.Y = 0, t.D.Nb = 0, t.D.wa = t.wa, t.D.Y = t.Y, 0 < t.Aa && (t.D.Y += d), e(!0), t.oc = l, t.pc = f, f += 832, t.ya = o(v, Ut), t.aa = 0, t.D.ya = t.ya, t.D.aa = t.aa, 2 == t.Aa && (t.D.aa += d), t.R = 16 * d, t.B = 8 * d, d = (p = Ti[t.L]) * t.R, p = p / 2 * t.B, t.sa = l, t.ta = f + d, t.qa = t.sa, t.ra = t.ta + 16 * s * t.R + p, t.Ha = t.qa, t.Ia = t.ra + 8 * s * t.B + p, t.$c = 0, f += c, t.mb = h ? l : null, t.nb = h ? f : null, e(f + h <= t.Fc + t.Vb), $t(t), i(t.Ac, t.Bc, 0, u), s = 1;
                        }
                    }
                    if (s) {
                        if (n.ka = 0, n.y = t.sa, n.O = t.ta, n.f = t.qa, n.N = t.ra, n.ea = t.Ha, n.Vd = t.Ia, n.fa = t.R, n.Rc = t.B, n.F = null, n.J = 0, !Cr) {
                            for(s = -255; 255 >= s; ++s)Pr[255 + s] = 0 > s ? -s : s;
                            for(s = -1020; 1020 >= s; ++s)kr[1020 + s] = -128 > s ? -128 : 127 < s ? 127 : s;
                            for(s = -112; 112 >= s; ++s)Fr[112 + s] = -16 > s ? -16 : 15 < s ? 15 : s;
                            for(s = -255; 510 >= s; ++s)Ir[255 + s] = 0 > s ? 0 : 255 < s ? 255 : s;
                            Cr = 1;
                        }
                        ar = ce, or = ae, ur = oe, cr = se, hr = ue, sr = ie, lr = Je, fr = Xe, dr = $e, pr = Qe, gr = Ke, mr = Ze, vr = tn, br = en, yr = ze, wr = He, Nr = We, Lr = Ve, fi[0] = Ae, fi[1] = le, fi[2] = Le, fi[3] = xe, fi[4] = _e, fi[5] = Pe, fi[6] = Se, fi[7] = ke, fi[8] = Ie, fi[9] = Fe, li[0] = ve, li[1] = de, li[2] = pe, li[3] = ge, li[4] = be, li[5] = ye, li[6] = we, di[0] = Oe, di[1] = fe, di[2] = Ce, di[3] = je, di[4] = Ee, di[5] = Me, di[6] = qe, s = 1;
                    } else s = 0;
                }
                s && (s = function(t, n) {
                    for(t.M = 0; t.M < t.Va; ++t.M){
                        var o, s = t.Jc[t.M & t.Xb], u = t.m, c = t;
                        for(o = 0; o < c.za; ++o){
                            var h = u, l = c, f = l.Ac, d = l.Bc + 4 * o, p = l.zc, g = l.ya[l.aa + o];
                            if (l.Qa.Bb ? g.$b = k(h, l.Pa.jb[0]) ? 2 + k(h, l.Pa.jb[2]) : k(h, l.Pa.jb[1]) : g.$b = 0, l.kc && (g.Ad = k(h, l.Bd)), g.Za = !k(h, 145) + 0, g.Za) {
                                var m = g.Ob, v = 0;
                                for(l = 0; 4 > l; ++l){
                                    var b, y = p[0 + l];
                                    for(b = 0; 4 > b; ++b){
                                        y = ui[f[d + b]][y];
                                        for(var w = oi[k(h, y[0])]; 0 < w;)w = oi[2 * w + k(h, y[w])];
                                        y = -w, f[d + b] = y;
                                    }
                                    r(m, v, f, d, 4), v += 4, p[0 + l] = y;
                                }
                            } else y = k(h, 156) ? k(h, 128) ? 1 : 3 : k(h, 163) ? 2 : 0, g.Ob[0] = y, i(f, d, y, 4), i(p, 0, y, 4);
                            g.Dd = k(h, 142) ? k(h, 114) ? k(h, 183) ? 1 : 3 : 2 : 0;
                        }
                        if (c.m.Ka) return Jt(t, 7, "Premature end-of-partition0 encountered.");
                        for(; t.ja < t.za; ++t.ja){
                            if (c = s, h = (u = t).rb[u.sb - 1], f = u.rb[u.sb + u.ja], o = u.ya[u.aa + u.ja], d = u.kc ? o.Ad : 0) h.la = f.la = 0, o.Za || (h.Na = f.Na = 0), o.Hc = 0, o.Gc = 0, o.ia = 0;
                            else {
                                var N, L;
                                h = f, f = c, d = u.Pa.Xc, p = u.ya[u.aa + u.ja], g = u.pb[p.$b];
                                if (l = p.ad, m = 0, v = u.rb[u.sb - 1], y = b = 0, i(l, m, 0, 384), p.Za) var x = 0, A = d[3];
                                else {
                                    w = a(16);
                                    var _ = h.Na + v.Na;
                                    if (_ = ri(f, d[1], _, g.Eb, 0, w, 0), h.Na = v.Na = (0 < _) + 0, 1 < _) ar(w, 0, l, m);
                                    else {
                                        var S = w[0] + 3 >> 3;
                                        for(w = 0; 256 > w; w += 16)l[m + w] = S;
                                    }
                                    x = 1, A = d[0];
                                }
                                var P = 15 & h.la, F = 15 & v.la;
                                for(w = 0; 4 > w; ++w){
                                    var I = 1 & F;
                                    for(S = L = 0; 4 > S; ++S)P = P >> 1 | (I = (_ = ri(f, A, _ = I + (1 & P), g.Sc, x, l, m)) > x) << 7, L = L << 2 | (3 < _ ? 3 : 1 < _ ? 2 : 0 != l[m + 0]), m += 16;
                                    P >>= 4, F = F >> 1 | I << 7, b = (b << 8 | L) >>> 0;
                                }
                                for(A = P, x = F >> 4, N = 0; 4 > N; N += 2){
                                    for(L = 0, P = h.la >> 4 + N, F = v.la >> 4 + N, w = 0; 2 > w; ++w){
                                        for(I = 1 & F, S = 0; 2 > S; ++S)_ = I + (1 & P), P = P >> 1 | (I = 0 < (_ = ri(f, d[2], _, g.Qc, 0, l, m))) << 3, L = L << 2 | (3 < _ ? 3 : 1 < _ ? 2 : 0 != l[m + 0]), m += 16;
                                        P >>= 2, F = F >> 1 | I << 5;
                                    }
                                    y |= L << 4 * N, A |= P << 4 << N, x |= (240 & F) << N;
                                }
                                h.la = A, v.la = x, p.Hc = b, p.Gc = y, p.ia = 43690 & y ? 0 : g.ia, d = !(b | y);
                            }
                            if (0 < u.L && (u.wa[u.Y + u.ja] = u.gd[o.$b][o.Za], u.wa[u.Y + u.ja].La |= !d), c.Ka) return Jt(t, 7, "Premature end-of-file encountered.");
                        }
                        if ($t(t), u = n, c = 1, o = (s = t).D, h = 0 < s.L && s.M >= s.zb && s.M <= s.Va, 0 == s.Aa) t: {
                            if (o.M = s.M, o.uc = h, On(s, o), c = 1, o = (L = s.D).Nb, h = (y = Ti[s.L]) * s.R, f = y / 2 * s.B, w = 16 * o * s.R, S = 8 * o * s.B, d = s.sa, p = s.ta - h + w, g = s.qa, l = s.ra - f + S, m = s.Ha, v = s.Ia - f + S, F = 0 == (P = L.M), b = P >= s.Va - 1, 2 == s.Aa && On(s, L), L.uc) for(I = (_ = s).D.M, e(_.D.uc), L = _.yb; L < _.Hb; ++L){
                                x = L, A = I;
                                var C = (j = (U = _).D).Nb;
                                N = U.R;
                                var j = j.wa[j.Y + x], B = U.sa, O = U.ta + 16 * C * N + 16 * x, M = j.dd, E = j.tc;
                                if (0 != E) {
                                    if (e(3 <= E), 1 == U.L) 0 < x && wr(B, O, N, E + 4), j.La && Lr(B, O, N, E), 0 < A && yr(B, O, N, E + 4), j.La && Nr(B, O, N, E);
                                    else {
                                        var q = U.B, R = U.qa, T = U.ra + 8 * C * q + 8 * x, D = U.Ha, U = U.Ia + 8 * C * q + 8 * x;
                                        C = j.ld;
                                        0 < x && (fr(B, O, N, E + 4, M, C), pr(R, T, D, U, q, E + 4, M, C)), j.La && (mr(B, O, N, E, M, C), br(R, T, D, U, q, E, M, C)), 0 < A && (lr(B, O, N, E + 4, M, C), dr(R, T, D, U, q, E + 4, M, C)), j.La && (gr(B, O, N, E, M, C), vr(R, T, D, U, q, E, M, C));
                                    }
                                }
                            }
                            if (s.ia && alert("todo:DitherRow"), null != u.put) {
                                if (L = 16 * P, P = 16 * (P + 1), F ? (u.y = s.sa, u.O = s.ta + w, u.f = s.qa, u.N = s.ra + S, u.ea = s.Ha, u.W = s.Ia + S) : (L -= y, u.y = d, u.O = p, u.f = g, u.N = l, u.ea = m, u.W = v), b || (P -= y), P > u.o && (P = u.o), u.F = null, u.J = null, null != s.Fa && 0 < s.Fa.length && L < P && (u.J = fn(s, u, L, P - L), u.F = s.mb, null == u.F && 0 == u.F.length)) {
                                    c = Jt(s, 3, "Could not decode alpha data.");
                                    break t;
                                }
                                L < u.j && (y = u.j - L, L = u.j, e(!(1 & y)), u.O += s.R * y, u.N += s.B * (y >> 1), u.W += s.B * (y >> 1), null != u.F && (u.J += u.width * y)), L < P && (u.O += u.v, u.N += u.v >> 1, u.W += u.v >> 1, null != u.F && (u.J += u.v), u.ka = L - u.j, u.U = u.va - u.v, u.T = P - L, c = u.put(u));
                            }
                            o + 1 != s.Ic || b || (r(s.sa, s.ta - h, d, p + 16 * s.R, h), r(s.qa, s.ra - f, g, l + 8 * s.B, f), r(s.Ha, s.Ia - f, m, v + 8 * s.B, f));
                        }
                        if (!c) return Jt(t, 6, "Output aborted.");
                    }
                    return 1;
                }(t, n)), null != n.bc && n.bc(n), s &= 1;
            }
            return s ? (t.cb = 0, s) : 0;
        }
        function te(t, e, n, r, i) {
            i = t[e + n + 32 * r] + (i >> 3), t[e + n + 32 * r] = -256 & i ? 0 > i ? 0 : 255 : i;
        }
        function ee(t, e, n, r, i, a) {
            te(t, e, 0, n, r + i), te(t, e, 1, n, r + a), te(t, e, 2, n, r - a), te(t, e, 3, n, r - i);
        }
        function ne(t) {
            return (20091 * t >> 16) + t;
        }
        function re(t, e, n, r) {
            var i, o = 0, s = a(16);
            for(i = 0; 4 > i; ++i){
                var u = t[e + 0] + t[e + 8], c = t[e + 0] - t[e + 8], h = (35468 * t[e + 4] >> 16) - ne(t[e + 12]), l = ne(t[e + 4]) + (35468 * t[e + 12] >> 16);
                s[o + 0] = u + l, s[o + 1] = c + h, s[o + 2] = c - h, s[o + 3] = u - l, o += 4, e++;
            }
            for(i = o = 0; 4 > i; ++i)u = (t = s[o + 0] + 4) + s[o + 8], c = t - s[o + 8], h = (35468 * s[o + 4] >> 16) - ne(s[o + 12]), te(n, r, 0, 0, u + (l = ne(s[o + 4]) + (35468 * s[o + 12] >> 16))), te(n, r, 1, 0, c + h), te(n, r, 2, 0, c - h), te(n, r, 3, 0, u - l), o++, r += 32;
        }
        function ie(t, e, n, r) {
            var i = t[e + 0] + 4, a = 35468 * t[e + 4] >> 16, o = ne(t[e + 4]), s = 35468 * t[e + 1] >> 16;
            ee(n, r, 0, i + o, t = ne(t[e + 1]), s), ee(n, r, 1, i + a, t, s), ee(n, r, 2, i - a, t, s), ee(n, r, 3, i - o, t, s);
        }
        function ae(t, e, n, r, i) {
            re(t, e, n, r), i && re(t, e + 16, n, r + 4);
        }
        function oe(t, e, n, r) {
            or(t, e + 0, n, r, 1), or(t, e + 32, n, r + 128, 1);
        }
        function se(t, e, n, r) {
            var i;
            for(t = t[e + 0] + 4, i = 0; 4 > i; ++i)for(e = 0; 4 > e; ++e)te(n, r, e, i, t);
        }
        function ue(t, e, n, r) {
            t[e + 0] && cr(t, e + 0, n, r), t[e + 16] && cr(t, e + 16, n, r + 4), t[e + 32] && cr(t, e + 32, n, r + 128), t[e + 48] && cr(t, e + 48, n, r + 128 + 4);
        }
        function ce(t, e, n, r) {
            var i, o = a(16);
            for(i = 0; 4 > i; ++i){
                var s = t[e + 0 + i] + t[e + 12 + i], u = t[e + 4 + i] + t[e + 8 + i], c = t[e + 4 + i] - t[e + 8 + i], h = t[e + 0 + i] - t[e + 12 + i];
                o[0 + i] = s + u, o[8 + i] = s - u, o[4 + i] = h + c, o[12 + i] = h - c;
            }
            for(i = 0; 4 > i; ++i)s = (t = o[0 + 4 * i] + 3) + o[3 + 4 * i], u = o[1 + 4 * i] + o[2 + 4 * i], c = o[1 + 4 * i] - o[2 + 4 * i], h = t - o[3 + 4 * i], n[r + 0] = s + u >> 3, n[r + 16] = h + c >> 3, n[r + 32] = s - u >> 3, n[r + 48] = h - c >> 3, r += 64;
        }
        function he(t, e, n) {
            var r, i = e - 32, a = Or, o = 255 - t[i - 1];
            for(r = 0; r < n; ++r){
                var s, u = a, c = o + t[e - 1];
                for(s = 0; s < n; ++s)t[e + s] = u[c + t[i + s]];
                e += 32;
            }
        }
        function le(t, e) {
            he(t, e, 4);
        }
        function fe(t, e) {
            he(t, e, 8);
        }
        function de(t, e) {
            he(t, e, 16);
        }
        function pe(t, e) {
            var n;
            for(n = 0; 16 > n; ++n)r(t, e + 32 * n, t, e - 32, 16);
        }
        function ge(t, e) {
            var n;
            for(n = 16; 0 < n; --n)i(t, e, t[e - 1], 16), e += 32;
        }
        function me(t, e, n) {
            var r;
            for(r = 0; 16 > r; ++r)i(e, n + 32 * r, t, 16);
        }
        function ve(t, e) {
            var n, r = 16;
            for(n = 0; 16 > n; ++n)r += t[e - 1 + 32 * n] + t[e + n - 32];
            me(r >> 5, t, e);
        }
        function be(t, e) {
            var n, r = 8;
            for(n = 0; 16 > n; ++n)r += t[e - 1 + 32 * n];
            me(r >> 4, t, e);
        }
        function ye(t, e) {
            var n, r = 8;
            for(n = 0; 16 > n; ++n)r += t[e + n - 32];
            me(r >> 4, t, e);
        }
        function we(t, e) {
            me(128, t, e);
        }
        function Ne(t, e, n) {
            return t + 2 * e + n + 2 >> 2;
        }
        function Le(t, e) {
            var n, i = e - 32;
            i = new Uint8Array([
                Ne(t[i - 1], t[i + 0], t[i + 1]),
                Ne(t[i + 0], t[i + 1], t[i + 2]),
                Ne(t[i + 1], t[i + 2], t[i + 3]),
                Ne(t[i + 2], t[i + 3], t[i + 4])
            ]);
            for(n = 0; 4 > n; ++n)r(t, e + 32 * n, i, 0, i.length);
        }
        function xe(t, e) {
            var n = t[e - 1], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            F(t, e + 0, 16843009 * Ne(t[e - 1 - 32], n, r)), F(t, e + 32, 16843009 * Ne(n, r, i)), F(t, e + 64, 16843009 * Ne(r, i, a)), F(t, e + 96, 16843009 * Ne(i, a, a));
        }
        function Ae(t, e) {
            var n, r = 4;
            for(n = 0; 4 > n; ++n)r += t[e + n - 32] + t[e - 1 + 32 * n];
            for(r >>= 3, n = 0; 4 > n; ++n)i(t, e + 32 * n, r, 4);
        }
        function _e(t, e) {
            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], u = t[e + 2 - 32], c = t[e + 3 - 32];
            t[e + 0 + 96] = Ne(r, i, t[e - 1 + 96]), t[e + 1 + 96] = t[e + 0 + 64] = Ne(n, r, i), t[e + 2 + 96] = t[e + 1 + 64] = t[e + 0 + 32] = Ne(a, n, r), t[e + 3 + 96] = t[e + 2 + 64] = t[e + 1 + 32] = t[e + 0 + 0] = Ne(o, a, n), t[e + 3 + 64] = t[e + 2 + 32] = t[e + 1 + 0] = Ne(s, o, a), t[e + 3 + 32] = t[e + 2 + 0] = Ne(u, s, o), t[e + 3 + 0] = Ne(c, u, s);
        }
        function Se(t, e) {
            var n = t[e + 1 - 32], r = t[e + 2 - 32], i = t[e + 3 - 32], a = t[e + 4 - 32], o = t[e + 5 - 32], s = t[e + 6 - 32], u = t[e + 7 - 32];
            t[e + 0 + 0] = Ne(t[e + 0 - 32], n, r), t[e + 1 + 0] = t[e + 0 + 32] = Ne(n, r, i), t[e + 2 + 0] = t[e + 1 + 32] = t[e + 0 + 64] = Ne(r, i, a), t[e + 3 + 0] = t[e + 2 + 32] = t[e + 1 + 64] = t[e + 0 + 96] = Ne(i, a, o), t[e + 3 + 32] = t[e + 2 + 64] = t[e + 1 + 96] = Ne(a, o, s), t[e + 3 + 64] = t[e + 2 + 96] = Ne(o, s, u), t[e + 3 + 96] = Ne(s, u, u);
        }
        function Pe(t, e) {
            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], u = t[e + 2 - 32], c = t[e + 3 - 32];
            t[e + 0 + 0] = t[e + 1 + 64] = a + o + 1 >> 1, t[e + 1 + 0] = t[e + 2 + 64] = o + s + 1 >> 1, t[e + 2 + 0] = t[e + 3 + 64] = s + u + 1 >> 1, t[e + 3 + 0] = u + c + 1 >> 1, t[e + 0 + 96] = Ne(i, r, n), t[e + 0 + 64] = Ne(r, n, a), t[e + 0 + 32] = t[e + 1 + 96] = Ne(n, a, o), t[e + 1 + 32] = t[e + 2 + 96] = Ne(a, o, s), t[e + 2 + 32] = t[e + 3 + 96] = Ne(o, s, u), t[e + 3 + 32] = Ne(s, u, c);
        }
        function ke(t, e) {
            var n = t[e + 0 - 32], r = t[e + 1 - 32], i = t[e + 2 - 32], a = t[e + 3 - 32], o = t[e + 4 - 32], s = t[e + 5 - 32], u = t[e + 6 - 32], c = t[e + 7 - 32];
            t[e + 0 + 0] = n + r + 1 >> 1, t[e + 1 + 0] = t[e + 0 + 64] = r + i + 1 >> 1, t[e + 2 + 0] = t[e + 1 + 64] = i + a + 1 >> 1, t[e + 3 + 0] = t[e + 2 + 64] = a + o + 1 >> 1, t[e + 0 + 32] = Ne(n, r, i), t[e + 1 + 32] = t[e + 0 + 96] = Ne(r, i, a), t[e + 2 + 32] = t[e + 1 + 96] = Ne(i, a, o), t[e + 3 + 32] = t[e + 2 + 96] = Ne(a, o, s), t[e + 3 + 64] = Ne(o, s, u), t[e + 3 + 96] = Ne(s, u, c);
        }
        function Fe(t, e) {
            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            t[e + 0 + 0] = n + r + 1 >> 1, t[e + 2 + 0] = t[e + 0 + 32] = r + i + 1 >> 1, t[e + 2 + 32] = t[e + 0 + 64] = i + a + 1 >> 1, t[e + 1 + 0] = Ne(n, r, i), t[e + 3 + 0] = t[e + 1 + 32] = Ne(r, i, a), t[e + 3 + 32] = t[e + 1 + 64] = Ne(i, a, a), t[e + 3 + 64] = t[e + 2 + 64] = t[e + 0 + 96] = t[e + 1 + 96] = t[e + 2 + 96] = t[e + 3 + 96] = a;
        }
        function Ie(t, e) {
            var n = t[e - 1 + 0], r = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96], o = t[e - 1 - 32], s = t[e + 0 - 32], u = t[e + 1 - 32], c = t[e + 2 - 32];
            t[e + 0 + 0] = t[e + 2 + 32] = n + o + 1 >> 1, t[e + 0 + 32] = t[e + 2 + 64] = r + n + 1 >> 1, t[e + 0 + 64] = t[e + 2 + 96] = i + r + 1 >> 1, t[e + 0 + 96] = a + i + 1 >> 1, t[e + 3 + 0] = Ne(s, u, c), t[e + 2 + 0] = Ne(o, s, u), t[e + 1 + 0] = t[e + 3 + 32] = Ne(n, o, s), t[e + 1 + 32] = t[e + 3 + 64] = Ne(r, n, o), t[e + 1 + 64] = t[e + 3 + 96] = Ne(i, r, n), t[e + 1 + 96] = Ne(a, i, r);
        }
        function Ce(t, e) {
            var n;
            for(n = 0; 8 > n; ++n)r(t, e + 32 * n, t, e - 32, 8);
        }
        function je(t, e) {
            var n;
            for(n = 0; 8 > n; ++n)i(t, e, t[e - 1], 8), e += 32;
        }
        function Be(t, e, n) {
            var r;
            for(r = 0; 8 > r; ++r)i(e, n + 32 * r, t, 8);
        }
        function Oe(t, e) {
            var n, r = 8;
            for(n = 0; 8 > n; ++n)r += t[e + n - 32] + t[e - 1 + 32 * n];
            Be(r >> 4, t, e);
        }
        function Me(t, e) {
            var n, r = 4;
            for(n = 0; 8 > n; ++n)r += t[e + n - 32];
            Be(r >> 3, t, e);
        }
        function Ee(t, e) {
            var n, r = 4;
            for(n = 0; 8 > n; ++n)r += t[e - 1 + 32 * n];
            Be(r >> 3, t, e);
        }
        function qe(t, e) {
            Be(128, t, e);
        }
        function Re(t, e, n) {
            var r = t[e - n], i = t[e + 0], a = 3 * (i - r) + jr[1020 + t[e - 2 * n] - t[e + n]], o = Br[112 + (a + 4 >> 3)];
            t[e - n] = Or[255 + r + Br[112 + (a + 3 >> 3)]], t[e + 0] = Or[255 + i - o];
        }
        function Te(t, e, n, r) {
            var i = t[e + 0], a = t[e + n];
            return Mr[255 + t[e - 2 * n] - t[e - n]] > r || Mr[255 + a - i] > r;
        }
        function De(t, e, n, r) {
            return 4 * Mr[255 + t[e - n] - t[e + 0]] + Mr[255 + t[e - 2 * n] - t[e + n]] <= r;
        }
        function Ue(t, e, n, r, i) {
            var a = t[e - 3 * n], o = t[e - 2 * n], s = t[e - n], u = t[e + 0], c = t[e + n], h = t[e + 2 * n], l = t[e + 3 * n];
            return 4 * Mr[255 + s - u] + Mr[255 + o - c] > r ? 0 : Mr[255 + t[e - 4 * n] - a] <= i && Mr[255 + a - o] <= i && Mr[255 + o - s] <= i && Mr[255 + l - h] <= i && Mr[255 + h - c] <= i && Mr[255 + c - u] <= i;
        }
        function ze(t, e, n, r) {
            var i = 2 * r + 1;
            for(r = 0; 16 > r; ++r)De(t, e + r, n, i) && Re(t, e + r, n);
        }
        function He(t, e, n, r) {
            var i = 2 * r + 1;
            for(r = 0; 16 > r; ++r)De(t, e + r * n, 1, i) && Re(t, e + r * n, 1);
        }
        function We(t, e, n, r) {
            var i;
            for(i = 3; 0 < i; --i)ze(t, e += 4 * n, n, r);
        }
        function Ve(t, e, n, r) {
            var i;
            for(i = 3; 0 < i; --i)He(t, e += 4, n, r);
        }
        function Ge(t, e, n, r, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Ue(t, e, n, a, o)) {
                    if (Te(t, e, n, s)) Re(t, e, n);
                    else {
                        var u = t, c = e, h = n, l = u[c - 2 * h], f = u[c - h], d = u[c + 0], p = u[c + h], g = u[c + 2 * h], m = 27 * (b = jr[1020 + 3 * (d - f) + jr[1020 + l - p]]) + 63 >> 7, v = 18 * b + 63 >> 7, b = 9 * b + 63 >> 7;
                        u[c - 3 * h] = Or[255 + u[c - 3 * h] + b], u[c - 2 * h] = Or[255 + l + v], u[c - h] = Or[255 + f + m], u[c + 0] = Or[255 + d - m], u[c + h] = Or[255 + p - v], u[c + 2 * h] = Or[255 + g - b];
                    }
                }
                e += r;
            }
        }
        function Ye(t, e, n, r, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Ue(t, e, n, a, o)) {
                    if (Te(t, e, n, s)) Re(t, e, n);
                    else {
                        var u = t, c = e, h = n, l = u[c - h], f = u[c + 0], d = u[c + h], p = Br[112 + ((g = 3 * (f - l)) + 4 >> 3)], g = Br[112 + (g + 3 >> 3)], m = p + 1 >> 1;
                        u[c - 2 * h] = Or[255 + u[c - 2 * h] + m], u[c - h] = Or[255 + l + g], u[c + 0] = Or[255 + f - p], u[c + h] = Or[255 + d - m];
                    }
                }
                e += r;
            }
        }
        function Je(t, e, n, r, i, a) {
            Ge(t, e, n, 1, 16, r, i, a);
        }
        function Xe(t, e, n, r, i, a) {
            Ge(t, e, 1, n, 16, r, i, a);
        }
        function Ke(t, e, n, r, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ye(t, e += 4 * n, n, 1, 16, r, i, a);
        }
        function Ze(t, e, n, r, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ye(t, e += 4, 1, n, 16, r, i, a);
        }
        function $e(t, e, n, r, i, a, o, s) {
            Ge(t, e, i, 1, 8, a, o, s), Ge(n, r, i, 1, 8, a, o, s);
        }
        function Qe(t, e, n, r, i, a, o, s) {
            Ge(t, e, 1, i, 8, a, o, s), Ge(n, r, 1, i, 8, a, o, s);
        }
        function tn(t, e, n, r, i, a, o, s) {
            Ye(t, e + 4 * i, i, 1, 8, a, o, s), Ye(n, r + 4 * i, i, 1, 8, a, o, s);
        }
        function en(t, e, n, r, i, a, o, s) {
            Ye(t, e + 4, 1, i, 8, a, o, s), Ye(n, r + 4, 1, i, 8, a, o, s);
        }
        function nn() {
            this.ba = new ot, this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new ut, this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
        }
        function rn() {
            this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
        }
        function an() {
            this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
        }
        function on() {
            this.ua = 0, this.Wa = new M, this.vb = new M, this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new d, this.yc = new l;
        }
        function sn() {
            this.xb = this.a = 0, this.l = new Gt, this.ca = new ot, this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new N, this.Pb = 0, this.wd = new N, this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new on, this.ab = 0, this.gc = o(4, an), this.Oc = 0;
        }
        function un() {
            this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Gt, this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
        }
        function cn(t, e, n, r, i, a, o) {
            for(t = null == t ? 0 : t[e + 0], e = 0; e < o; ++e)i[a + e] = t + n[r + e] & 255, t = i[a + e];
        }
        function hn(t, e, n, r, i, a, o) {
            var s;
            if (null == t) cn(null, null, n, r, i, a, o);
            else for(s = 0; s < o; ++s)i[a + s] = t[e + s] + n[r + s] & 255;
        }
        function ln(t, e, n, r, i, a, o) {
            if (null == t) cn(null, null, n, r, i, a, o);
            else {
                var s, u = t[e + 0], c = u, h = u;
                for(s = 0; s < o; ++s)c = h + (u = t[e + s]) - c, h = n[r + s] + (-256 & c ? 0 > c ? 0 : 255 : c) & 255, c = u, i[a + s] = h;
            }
        }
        function fn(t, n, i, o) {
            var s = n.width, u = n.o;
            if (e(null != t && null != n), 0 > i || 0 >= o || i + o > u) return null;
            if (!t.Cc) {
                if (null == t.ga) {
                    var c;
                    if (t.ga = new un, (c = null == t.ga) || (c = n.width * n.o, e(0 == t.Gb.length), t.Gb = a(c), t.Uc = 0, null == t.Gb ? c = 0 : (t.mb = t.Gb, t.nb = t.Uc, t.rc = null, c = 1), c = !c), !c) {
                        c = t.ga;
                        var h = t.Fa, l = t.P, f = t.qc, d = t.mb, p = t.nb, g = l + 1, m = f - 1, b = c.l;
                        if (e(null != h && null != d && null != n), mi[0] = null, mi[1] = cn, mi[2] = hn, mi[3] = ln, c.ca = d, c.tb = p, c.c = n.width, c.i = n.height, e(0 < c.c && 0 < c.i), 1 >= f) n = 0;
                        else if (c.$a = h[l + 0] >> 0 & 3, c.Z = h[l + 0] >> 2 & 3, c.Lc = h[l + 0] >> 4 & 3, l = h[l + 0] >> 6 & 3, 0 > c.$a || 1 < c.$a || 4 <= c.Z || 1 < c.Lc || l) n = 0;
                        else if (b.put = dt, b.ac = ft, b.bc = pt, b.ma = c, b.width = n.width, b.height = n.height, b.Da = n.Da, b.v = n.v, b.va = n.va, b.j = n.j, b.o = n.o, c.$a) t: {
                            e(1 == c.$a), n = kt();
                            e: for(;;){
                                if (null == n) {
                                    n = 0;
                                    break t;
                                }
                                if (e(null != c), c.mc = n, n.c = c.c, n.i = c.i, n.l = c.l, n.l.ma = c, n.l.width = c.c, n.l.height = c.i, n.a = 0, v(n.m, h, g, m), !Ft(c.c, c.i, 1, n, null)) break e;
                                if (1 == n.ab && 3 == n.gc[0].hc && xt(n.s) ? (c.ic = 1, h = n.c * n.i, n.Ta = null, n.Ua = 0, n.V = a(h), n.Ba = 0, null == n.V ? (n.a = 1, n = 0) : n = 1) : (c.ic = 0, n = It(n, c.c)), !n) break e;
                                n = 1;
                                break t;
                            }
                            c.mc = null, n = 0;
                        }
                        else n = m >= c.c * c.i;
                        c = !n;
                    }
                    if (c) return null;
                    1 != t.ga.Lc ? t.Ga = 0 : o = u - i;
                }
                e(null != t.ga), e(i + o <= u);
                t: {
                    if (n = (h = t.ga).c, u = h.l.o, 0 == h.$a) {
                        if (g = t.rc, m = t.Vc, b = t.Fa, l = t.P + 1 + i * n, f = t.mb, d = t.nb + i * n, e(l <= t.P + t.qc), 0 != h.Z) for(e(null != mi[h.Z]), c = 0; c < o; ++c)mi[h.Z](g, m, b, l, f, d, n), g = f, m = d, d += n, l += n;
                        else for(c = 0; c < o; ++c)r(f, d, b, l, n), g = f, m = d, d += n, l += n;
                        t.rc = g, t.Vc = m;
                    } else {
                        if (e(null != h.mc), n = i + o, e(null != (c = h.mc)), e(n <= c.i), c.C >= n) n = 1;
                        else if (h.ic || vn(), h.ic) {
                            h = c.V, g = c.Ba, m = c.c;
                            var y = c.i, w = (b = 1, l = c.$ / m, f = c.$ % m, d = c.m, p = c.s, c.$), N = m * y, L = m * n, A = p.wc, S = w < L ? wt(p, f, l) : null;
                            e(w <= N), e(n <= y), e(xt(p));
                            e: for(;;){
                                for(; !d.h && w < L;){
                                    if (f & A || (S = wt(p, f, l)), e(null != S), _(d), 256 > (y = bt(S.G[0], S.H[0], d))) h[g + w] = y, ++w, ++f >= m && (f = 0, ++l <= n && !(l % 16) && _t(c, l));
                                    else {
                                        if (!(280 > y)) {
                                            b = 0;
                                            break e;
                                        }
                                        y = mt(y - 256, d);
                                        var P, k = bt(S.G[4], S.H[4], d);
                                        if (_(d), !(w >= (k = vt(m, k = mt(k, d))) && N - w >= y)) {
                                            b = 0;
                                            break e;
                                        }
                                        for(P = 0; P < y; ++P)h[g + w + P] = h[g + w + P - k];
                                        for(w += y, f += y; f >= m;)f -= m, ++l <= n && !(l % 16) && _t(c, l);
                                        w < L && f & A && (S = wt(p, f, l));
                                    }
                                    e(d.h == x(d));
                                }
                                _t(c, l > n ? n : l);
                                break e;
                            }
                            !b || d.h && w < N ? (b = 0, c.a = d.h ? 5 : 3) : c.$ = w, n = b;
                        } else n = St(c, c.V, c.Ba, c.c, c.i, n, Ct);
                        if (!n) {
                            o = 0;
                            break t;
                        }
                    }
                    i + o >= u && (t.Cc = 1), o = 1;
                }
                if (!o) return null;
                if (t.Cc && (null != (o = t.ga) && (o.mc = null), t.ga = null, 0 < t.Ga)) return alert("todo:WebPDequantizeLevels"), null;
            }
            return t.nb + i * s;
        }
        function dn(t, e, n, r, i, a) {
            for(; 0 < i--;){
                var o, s = t, u = e + (n ? 1 : 0), c = t, h = e + (n ? 0 : 3);
                for(o = 0; o < r; ++o){
                    var l = c[h + 4 * o];
                    255 != l && (l *= 32897, s[u + 4 * o + 0] = s[u + 4 * o + 0] * l >> 23, s[u + 4 * o + 1] = s[u + 4 * o + 1] * l >> 23, s[u + 4 * o + 2] = s[u + 4 * o + 2] * l >> 23);
                }
                e += a;
            }
        }
        function pn(t, e, n, r, i) {
            for(; 0 < r--;){
                var a;
                for(a = 0; a < n; ++a){
                    var o = t[e + 2 * a + 0], s = 15 & (c = t[e + 2 * a + 1]), u = 4369 * s, c = (240 & c | c >> 4) * u >> 16;
                    t[e + 2 * a + 0] = (240 & o | o >> 4) * u >> 16 & 240 | (15 & o | o << 4) * u >> 16 >> 4 & 15, t[e + 2 * a + 1] = 240 & c | s;
                }
                e += i;
            }
        }
        function gn(t, e, n, r, i, a, o, s) {
            var u, c, h = 255;
            for(c = 0; c < i; ++c){
                for(u = 0; u < r; ++u){
                    var l = t[e + u];
                    a[o + 4 * u] = l, h &= l;
                }
                e += n, o += s;
            }
            return 255 != h;
        }
        function mn(t, e, n, r, i) {
            var a;
            for(a = 0; a < i; ++a)n[r + a] = t[e + a] >> 8;
        }
        function vn() {
            xr = dn, Ar = pn, _r = gn, Sr = mn;
        }
        function bn(n, r, i) {
            t[n] = function(t, n, a, o, s, u, c, h, l, f, d, p, g, m, v, b, y) {
                var w, N = y - 1 >> 1, L = s[u + 0] | c[h + 0] << 16, x = l[f + 0] | d[p + 0] << 16;
                e(null != t);
                var A = 3 * L + x + 131074 >> 2;
                for(r(t[n + 0], 255 & A, A >> 16, g, m), null != a && (A = 3 * x + L + 131074 >> 2, r(a[o + 0], 255 & A, A >> 16, v, b)), w = 1; w <= N; ++w){
                    var _ = s[u + w] | c[h + w] << 16, S = l[f + w] | d[p + w] << 16, P = L + _ + x + S + 524296, k = P + 2 * (_ + x) >> 3;
                    A = k + L >> 1, L = (P = P + 2 * (L + S) >> 3) + _ >> 1, r(t[n + 2 * w - 1], 255 & A, A >> 16, g, m + (2 * w - 1) * i), r(t[n + 2 * w - 0], 255 & L, L >> 16, g, m + (2 * w - 0) * i), null != a && (A = P + x >> 1, L = k + S >> 1, r(a[o + 2 * w - 1], 255 & A, A >> 16, v, b + (2 * w - 1) * i), r(a[o + 2 * w + 0], 255 & L, L >> 16, v, b + (2 * w + 0) * i)), L = _, x = S;
                }
                1 & y || (A = 3 * L + x + 131074 >> 2, r(t[n + y - 1], 255 & A, A >> 16, g, m + (y - 1) * i), null != a && (A = 3 * x + L + 131074 >> 2, r(a[o + y - 1], 255 & A, A >> 16, v, b + (y - 1) * i)));
            };
        }
        function yn() {
            vi[Er] = bi, vi[qr] = wi, vi[Rr] = yi, vi[Tr] = Ni, vi[Dr] = Li, vi[Ur] = xi, vi[zr] = Ai, vi[Hr] = wi, vi[Wr] = Ni, vi[Vr] = Li, vi[Gr] = xi;
        }
        function wn(t) {
            return t & ~Ii ? 0 > t ? 0 : 255 : t >> Fi;
        }
        function Nn(t, e) {
            return wn((19077 * t >> 8) + (26149 * e >> 8) - 14234);
        }
        function Ln(t, e, n) {
            return wn((19077 * t >> 8) - (6419 * e >> 8) - (13320 * n >> 8) + 8708);
        }
        function xn(t, e) {
            return wn((19077 * t >> 8) + (33050 * e >> 8) - 17685);
        }
        function An(t, e, n, r, i) {
            r[i + 0] = Nn(t, n), r[i + 1] = Ln(t, e, n), r[i + 2] = xn(t, e);
        }
        function _n(t, e, n, r, i) {
            r[i + 0] = xn(t, e), r[i + 1] = Ln(t, e, n), r[i + 2] = Nn(t, n);
        }
        function Sn(t, e, n, r, i) {
            var a = Ln(t, e, n);
            e = a << 3 & 224 | xn(t, e) >> 3, r[i + 0] = 248 & Nn(t, n) | a >> 5, r[i + 1] = e;
        }
        function Pn(t, e, n, r, i) {
            var a = 240 & xn(t, e) | 15;
            r[i + 0] = 240 & Nn(t, n) | Ln(t, e, n) >> 4, r[i + 1] = a;
        }
        function kn(t, e, n, r, i) {
            r[i + 0] = 255, An(t, e, n, r, i + 1);
        }
        function Fn(t, e, n, r, i) {
            _n(t, e, n, r, i), r[i + 3] = 255;
        }
        function In(t, e, n, r, i) {
            An(t, e, n, r, i), r[i + 3] = 255;
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function Cn(e, n, r) {
            t[e] = function(t, e, i, a, o, s, u, c, h) {
                for(var l = c + (-2 & h) * r; c != l;)n(t[e + 0], i[a + 0], o[s + 0], u, c), n(t[e + 1], i[a + 0], o[s + 0], u, c + r), e += 2, ++a, ++s, c += 2 * r;
                1 & h && n(t[e + 0], i[a + 0], o[s + 0], u, c);
            };
        }
        function jn(t, e, n) {
            return 0 == n ? 0 == t ? 0 == e ? 6 : 5 : 0 == e ? 4 : 0 : n;
        }
        function Bn(t, e, n, r, i) {
            switch(t >>> 30){
                case 3:
                    or(e, n, r, i, 0);
                    break;
                case 2:
                    sr(e, n, r, i);
                    break;
                case 1:
                    cr(e, n, r, i);
            }
        }
        function On(t, e) {
            var n, a, o = e.M, s = e.Nb, u = t.oc, c = t.pc + 40, h = t.oc, l = t.pc + 584, f = t.oc, d = t.pc + 600;
            for(n = 0; 16 > n; ++n)u[c + 32 * n - 1] = 129;
            for(n = 0; 8 > n; ++n)h[l + 32 * n - 1] = 129, f[d + 32 * n - 1] = 129;
            for(0 < o ? u[c - 1 - 32] = h[l - 1 - 32] = f[d - 1 - 32] = 129 : (i(u, c - 32 - 1, 127, 21), i(h, l - 32 - 1, 127, 9), i(f, d - 32 - 1, 127, 9)), a = 0; a < t.za; ++a){
                var p = e.ya[e.aa + a];
                if (0 < a) {
                    for(n = -1; 16 > n; ++n)r(u, c + 32 * n - 4, u, c + 32 * n + 12, 4);
                    for(n = -1; 8 > n; ++n)r(h, l + 32 * n - 4, h, l + 32 * n + 4, 4), r(f, d + 32 * n - 4, f, d + 32 * n + 4, 4);
                }
                var g = t.Gd, m = t.Hd + a, v = p.ad, b = p.Hc;
                if (0 < o && (r(u, c - 32, g[m].y, 0, 16), r(h, l - 32, g[m].f, 0, 8), r(f, d - 32, g[m].ea, 0, 8)), p.Za) {
                    var y = u, w = c - 32 + 16;
                    for(0 < o && (a >= t.za - 1 ? i(y, w, g[m].y[15], 4) : r(y, w, g[m + 1].y, 0, 4)), n = 0; 4 > n; n++)y[w + 128 + n] = y[w + 256 + n] = y[w + 384 + n] = y[w + 0 + n];
                    for(n = 0; 16 > n; ++n, b <<= 2)y = u, w = c + Ri[n], fi[p.Ob[n]](y, w), Bn(b, v, 16 * +n, y, w);
                } else if (y = jn(a, o, p.Ob[0]), li[y](u, c), 0 != b) for(n = 0; 16 > n; ++n, b <<= 2)Bn(b, v, 16 * +n, u, c + Ri[n]);
                for(n = p.Gc, y = jn(a, o, p.Dd), di[y](h, l), di[y](f, d), b = v, y = h, w = l, 255 & (p = n >> 0) && (170 & p ? ur(b, 256, y, w) : hr(b, 256, y, w)), p = f, b = d, 255 & (n >>= 8) && (170 & n ? ur(v, 320, p, b) : hr(v, 320, p, b)), o < t.Ub - 1 && (r(g[m].y, 0, u, c + 480, 16), r(g[m].f, 0, h, l + 224, 8), r(g[m].ea, 0, f, d + 224, 8)), n = 8 * s * t.B, g = t.sa, m = t.ta + 16 * a + 16 * s * t.R, v = t.qa, p = t.ra + 8 * a + n, b = t.Ha, y = t.Ia + 8 * a + n, n = 0; 16 > n; ++n)r(g, m + n * t.R, u, c + 32 * n, 16);
                for(n = 0; 8 > n; ++n)r(v, p + n * t.B, h, l + 32 * n, 8), r(b, y + n * t.B, f, d + 32 * n, 8);
            }
        }
        function Mn(t, r, i, a, o, s, u, c, h) {
            var l = [
                0
            ], f = [
                0
            ], d = 0, p = null != h ? h.kd : 0, g = null != h ? h : new rn;
            if (null == t || 12 > i) return 7;
            g.data = t, g.w = r, g.ha = i, r = [
                r
            ], i = [
                i
            ], g.gb = [
                g.gb
            ];
            t: {
                var m = r, b = i, y = g.gb;
                if (e(null != t), e(null != b), e(null != y), y[0] = 0, 12 <= b[0] && !n(t, m[0], "RIFF")) {
                    if (n(t, m[0] + 8, "WEBP")) {
                        y = 3;
                        break t;
                    }
                    var w = j(t, m[0] + 4);
                    if (12 > w || 4294967286 < w) {
                        y = 3;
                        break t;
                    }
                    if (p && w > b[0] - 8) {
                        y = 7;
                        break t;
                    }
                    y[0] = w, m[0] += 12, b[0] -= 12;
                }
                y = 0;
            }
            if (0 != y) return y;
            for(w = 0 < g.gb[0], i = i[0];;){
                t: {
                    var L = t;
                    b = r, y = i;
                    var x = l, A = f, _ = m = [
                        0
                    ];
                    if ((k = d = [
                        d
                    ])[0] = 0, 8 > y[0]) y = 7;
                    else {
                        if (!n(L, b[0], "VP8X")) {
                            if (10 != j(L, b[0] + 4)) {
                                y = 3;
                                break t;
                            }
                            if (18 > y[0]) {
                                y = 7;
                                break t;
                            }
                            var S = j(L, b[0] + 8), P = 1 + C(L, b[0] + 12);
                            if (2147483648 <= P * (L = 1 + C(L, b[0] + 15))) {
                                y = 3;
                                break t;
                            }
                            null != _ && (_[0] = S), null != x && (x[0] = P), null != A && (A[0] = L), b[0] += 18, y[0] -= 18, k[0] = 1;
                        }
                        y = 0;
                    }
                }
                if (d = d[0], m = m[0], 0 != y) return y;
                if (b = !!(2 & m), !w && d) return 3;
                if (null != s && (s[0] = !!(16 & m)), null != u && (u[0] = b), null != c && (c[0] = 0), u = l[0], m = f[0], d && b && null == h) {
                    y = 0;
                    break;
                }
                if (4 > i) {
                    y = 7;
                    break;
                }
                if (w && d || !w && !d && !n(t, r[0], "ALPH")) {
                    i = [
                        i
                    ], g.na = [
                        g.na
                    ], g.P = [
                        g.P
                    ], g.Sa = [
                        g.Sa
                    ];
                    t: {
                        S = t, y = r, w = i;
                        var k = g.gb;
                        x = g.na, A = g.P, _ = g.Sa;
                        P = 22, e(null != S), e(null != w), L = y[0];
                        var F = w[0];
                        for(e(null != x), e(null != _), x[0] = null, A[0] = null, _[0] = 0;;){
                            if (y[0] = L, w[0] = F, 8 > F) {
                                y = 7;
                                break t;
                            }
                            var I = j(S, L + 4);
                            if (4294967286 < I) {
                                y = 3;
                                break t;
                            }
                            var B = 8 + I + 1 & -2;
                            if (P += B, 0 < k && P > k) {
                                y = 3;
                                break t;
                            }
                            if (!n(S, L, "VP8 ") || !n(S, L, "VP8L")) {
                                y = 0;
                                break t;
                            }
                            if (F[0] < B) {
                                y = 7;
                                break t;
                            }
                            n(S, L, "ALPH") || (x[0] = S, A[0] = L + 8, _[0] = I), L += B, F -= B;
                        }
                    }
                    if (i = i[0], g.na = g.na[0], g.P = g.P[0], g.Sa = g.Sa[0], 0 != y) break;
                }
                i = [
                    i
                ], g.Ja = [
                    g.Ja
                ], g.xa = [
                    g.xa
                ];
                t: if (k = t, y = r, w = i, x = g.gb[0], A = g.Ja, _ = g.xa, S = y[0], L = !n(k, S, "VP8 "), P = !n(k, S, "VP8L"), e(null != k), e(null != w), e(null != A), e(null != _), 8 > w[0]) y = 7;
                else {
                    if (L || P) {
                        if (k = j(k, S + 4), 12 <= x && k > x - 12) {
                            y = 3;
                            break t;
                        }
                        if (p && k > w[0] - 8) {
                            y = 7;
                            break t;
                        }
                        A[0] = k, y[0] += 8, w[0] -= 8, _[0] = P;
                    } else _[0] = 5 <= w[0] && 47 == k[S + 0] && !(k[S + 4] >> 5), A[0] = w[0];
                    y = 0;
                }
                if (i = i[0], g.Ja = g.Ja[0], g.xa = g.xa[0], r = r[0], 0 != y) break;
                if (4294967286 < g.Ja) return 3;
                if (null == c || b || (c[0] = g.xa ? 2 : 1), u = [
                    u
                ], m = [
                    m
                ], g.xa) {
                    if (5 > i) {
                        y = 7;
                        break;
                    }
                    c = u, p = m, b = s, null == t || 5 > i ? t = 0 : 5 <= i && 47 == t[r + 0] && !(t[r + 4] >> 5) ? (w = [
                        0
                    ], k = [
                        0
                    ], x = [
                        0
                    ], v(A = new N, t, r, i), gt(A, w, k, x) ? (null != c && (c[0] = w[0]), null != p && (p[0] = k[0]), null != b && (b[0] = x[0]), t = 1) : t = 0) : t = 0;
                } else {
                    if (10 > i) {
                        y = 7;
                        break;
                    }
                    c = m, null == t || 10 > i || !Xt(t, r + 3, i - 3) ? t = 0 : (p = t[r + 0] | t[r + 1] << 8 | t[r + 2] << 16, b = 16383 & (t[r + 7] << 8 | t[r + 6]), t = 16383 & (t[r + 9] << 8 | t[r + 8]), 1 & p || 3 < (p >> 1 & 7) || !(p >> 4 & 1) || p >> 5 >= g.Ja || !b || !t ? t = 0 : (u && (u[0] = b), c && (c[0] = t), t = 1));
                }
                if (!t) return 3;
                if (u = u[0], m = m[0], d && (l[0] != u || f[0] != m)) return 3;
                null != h && (h[0] = g, h.offset = r - h.w, e(4294967286 > r - h.w), e(h.offset == h.ha - i));
                break;
            }
            return 0 == y || 7 == y && d && null == h ? (null != s && (s[0] |= null != g.na && 0 < g.na.length), null != a && (a[0] = u), null != o && (o[0] = m), 0) : y;
        }
        function En(t, e, n) {
            var r = e.width, i = e.height, a = 0, o = 0, s = r, u = i;
            if (e.Da = null != t && 0 < t.Da, e.Da && (s = t.cd, u = t.bd, a = t.v, o = t.j, 11 > n || (a &= -2, o &= -2), 0 > a || 0 > o || 0 >= s || 0 >= u || a + s > r || o + u > i)) return 0;
            if (e.v = a, e.j = o, e.va = a + s, e.o = o + u, e.U = s, e.T = u, e.da = null != t && 0 < t.da, e.da) {
                if (!E(s, u, n = [
                    t.ib
                ], a = [
                    t.hb
                ])) return 0;
                e.ib = n[0], e.hb = a[0];
            }
            return e.ob = null != t && t.ob, e.Kb = null == t || !t.Sd, e.da && (e.ob = e.ib < 3 * r / 4 && e.hb < 3 * i / 4, e.Kb = 0), 1;
        }
        function qn(t) {
            if (null == t) return 2;
            if (11 > t.S) {
                var e = t.f.RGBA;
                e.fb += (t.height - 1) * e.A, e.A = -e.A;
            } else e = t.f.kb, t = t.height, e.O += (t - 1) * e.fa, e.fa = -e.fa, e.N += (t - 1 >> 1) * e.Ab, e.Ab = -e.Ab, e.W += (t - 1 >> 1) * e.Db, e.Db = -e.Db, null != e.F && (e.J += (t - 1) * e.lb, e.lb = -e.lb);
            return 0;
        }
        function Rn(t, e, n, r) {
            if (null == r || 0 >= t || 0 >= e) return 2;
            if (null != n) {
                if (n.Da) {
                    var i = n.cd, o = n.bd, s = -2 & n.v, u = -2 & n.j;
                    if (0 > s || 0 > u || 0 >= i || 0 >= o || s + i > t || u + o > e) return 2;
                    t = i, e = o;
                }
                if (n.da) {
                    if (!E(t, e, i = [
                        n.ib
                    ], o = [
                        n.hb
                    ])) return 2;
                    t = i[0], e = o[0];
                }
            }
            r.width = t, r.height = e;
            t: {
                var c = r.width, h = r.height;
                if (t = r.S, 0 >= c || 0 >= h || !(t >= Er && 13 > t)) t = 2;
                else {
                    if (0 >= r.Rd && null == r.sd) {
                        s = o = i = e = 0;
                        var l = (u = c * zi[t]) * h;
                        if (11 > t || (o = (h + 1) / 2 * (e = (c + 1) / 2), 12 == t && (s = (i = c) * h)), null == (h = a(l + 2 * o + s))) {
                            t = 1;
                            break t;
                        }
                        r.sd = h, 11 > t ? ((c = r.f.RGBA).eb = h, c.fb = 0, c.A = u, c.size = l) : ((c = r.f.kb).y = h, c.O = 0, c.fa = u, c.Fd = l, c.f = h, c.N = 0 + l, c.Ab = e, c.Cd = o, c.ea = h, c.W = 0 + l + o, c.Db = e, c.Ed = o, 12 == t && (c.F = h, c.J = 0 + l + 2 * o), c.Tc = s, c.lb = i);
                    }
                    if (e = 1, i = r.S, o = r.width, s = r.height, i >= Er && 13 > i) {
                        if (11 > i) t = r.f.RGBA, e &= (u = Math.abs(t.A)) * (s - 1) + o <= t.size, e &= u >= o * zi[i], e &= null != t.eb;
                        else {
                            t = r.f.kb, u = (o + 1) / 2, l = (s + 1) / 2, c = Math.abs(t.fa);
                            h = Math.abs(t.Ab);
                            var f = Math.abs(t.Db), d = Math.abs(t.lb), p = d * (s - 1) + o;
                            e &= c * (s - 1) + o <= t.Fd, e &= h * (l - 1) + u <= t.Cd, e = (e &= f * (l - 1) + u <= t.Ed) & c >= o & h >= u & f >= u, e &= null != t.y, e &= null != t.f, e &= null != t.ea, 12 == i && (e &= d >= o, e &= p <= t.Tc, e &= null != t.F);
                        }
                    } else e = 0;
                    t = e ? 0 : 2;
                }
            }
            return 0 != t || null != n && n.fd && (t = qn(r)), t;
        }
        var Tn = 64, Dn = [
            0,
            1,
            3,
            7,
            15,
            31,
            63,
            127,
            255,
            511,
            1023,
            2047,
            4095,
            8191,
            16383,
            32767,
            65535,
            131071,
            262143,
            524287,
            1048575,
            2097151,
            4194303,
            8388607,
            16777215
        ], Un = 24, zn = 32, Hn = 8, Wn = [
            0,
            0,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7
        ];
        T("Predictor0", "PredictorAdd0"), t.Predictor0 = function() {
            return 4278190080;
        }, t.Predictor1 = function(t) {
            return t;
        }, t.Predictor2 = function(t, e, n) {
            return e[n + 0];
        }, t.Predictor3 = function(t, e, n) {
            return e[n + 1];
        }, t.Predictor4 = function(t, e, n) {
            return e[n - 1];
        }, t.Predictor5 = function(t, e, n) {
            return U(U(t, e[n + 1]), e[n + 0]);
        }, t.Predictor6 = function(t, e, n) {
            return U(t, e[n - 1]);
        }, t.Predictor7 = function(t, e, n) {
            return U(t, e[n + 0]);
        }, t.Predictor8 = function(t, e, n) {
            return U(e[n - 1], e[n + 0]);
        }, t.Predictor9 = function(t, e, n) {
            return U(e[n + 0], e[n + 1]);
        }, t.Predictor10 = function(t, e, n) {
            return U(U(t, e[n - 1]), U(e[n + 0], e[n + 1]));
        }, t.Predictor11 = function(t, e, n) {
            var r = e[n + 0];
            return 0 >= W(r >> 24 & 255, t >> 24 & 255, (e = e[n - 1]) >> 24 & 255) + W(r >> 16 & 255, t >> 16 & 255, e >> 16 & 255) + W(r >> 8 & 255, t >> 8 & 255, e >> 8 & 255) + W(255 & r, 255 & t, 255 & e) ? r : t;
        }, t.Predictor12 = function(t, e, n) {
            var r = e[n + 0];
            return (z((t >> 24 & 255) + (r >> 24 & 255) - ((e = e[n - 1]) >> 24 & 255)) << 24 | z((t >> 16 & 255) + (r >> 16 & 255) - (e >> 16 & 255)) << 16 | z((t >> 8 & 255) + (r >> 8 & 255) - (e >> 8 & 255)) << 8 | z((255 & t) + (255 & r) - (255 & e))) >>> 0;
        }, t.Predictor13 = function(t, e, n) {
            var r = e[n - 1];
            return (H((t = U(t, e[n + 0])) >> 24 & 255, r >> 24 & 255) << 24 | H(t >> 16 & 255, r >> 16 & 255) << 16 | H(t >> 8 & 255, r >> 8 & 255) << 8 | H(t >> 0 & 255, r >> 0 & 255)) >>> 0;
        };
        var Vn = t.PredictorAdd0;
        t.PredictorAdd1 = V, T("Predictor2", "PredictorAdd2"), T("Predictor3", "PredictorAdd3"), T("Predictor4", "PredictorAdd4"), T("Predictor5", "PredictorAdd5"), T("Predictor6", "PredictorAdd6"), T("Predictor7", "PredictorAdd7"), T("Predictor8", "PredictorAdd8"), T("Predictor9", "PredictorAdd9"), T("Predictor10", "PredictorAdd10"), T("Predictor11", "PredictorAdd11"), T("Predictor12", "PredictorAdd12"), T("Predictor13", "PredictorAdd13");
        var Gn = t.PredictorAdd2;
        X("ColorIndexInverseTransform", "MapARGB", "32b", function(t) {
            return t >> 8 & 255;
        }, function(t) {
            return t;
        }), X("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(t) {
            return t;
        }, function(t) {
            return t >> 8 & 255;
        });
        var Yn, Jn = t.ColorIndexInverseTransform, Xn = t.MapARGB, Kn = t.VP8LColorIndexInverseTransformAlpha, Zn = t.MapAlpha, $n = t.VP8LPredictorsAdd = [];
        $n.length = 16, (t.VP8LPredictors = []).length = 16, (t.VP8LPredictorsAdd_C = []).length = 16, (t.VP8LPredictors_C = []).length = 16;
        var Qn, tr, er, nr, rr, ir, ar, or, sr, ur, cr, hr, lr, fr, dr, pr, gr, mr, vr, br, yr, wr, Nr, Lr, xr, Ar, _r, Sr, Pr = a(511), kr = a(2041), Fr = a(225), Ir = a(767), Cr = 0, jr = kr, Br = Fr, Or = Ir, Mr = Pr, Er = 0, qr = 1, Rr = 2, Tr = 3, Dr = 4, Ur = 5, zr = 6, Hr = 7, Wr = 8, Vr = 9, Gr = 10, Yr = [
            2,
            3,
            7
        ], Jr = [
            3,
            3,
            11
        ], Xr = [
            280,
            256,
            256,
            256,
            40
        ], Kr = [
            0,
            1,
            1,
            1,
            0
        ], Zr = [
            17,
            18,
            0,
            1,
            2,
            3,
            4,
            5,
            16,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15
        ], $r = [
            24,
            7,
            23,
            25,
            40,
            6,
            39,
            41,
            22,
            26,
            38,
            42,
            56,
            5,
            55,
            57,
            21,
            27,
            54,
            58,
            37,
            43,
            72,
            4,
            71,
            73,
            20,
            28,
            53,
            59,
            70,
            74,
            36,
            44,
            88,
            69,
            75,
            52,
            60,
            3,
            87,
            89,
            19,
            29,
            86,
            90,
            35,
            45,
            68,
            76,
            85,
            91,
            51,
            61,
            104,
            2,
            103,
            105,
            18,
            30,
            102,
            106,
            34,
            46,
            84,
            92,
            67,
            77,
            101,
            107,
            50,
            62,
            120,
            1,
            119,
            121,
            83,
            93,
            17,
            31,
            100,
            108,
            66,
            78,
            118,
            122,
            33,
            47,
            117,
            123,
            49,
            63,
            99,
            109,
            82,
            94,
            0,
            116,
            124,
            65,
            79,
            16,
            32,
            98,
            110,
            48,
            115,
            125,
            81,
            95,
            64,
            114,
            126,
            97,
            111,
            80,
            113,
            127,
            96,
            112
        ], Qr = [
            2954,
            2956,
            2958,
            2962,
            2970,
            2986,
            3018,
            3082,
            3212,
            3468,
            3980,
            5004
        ], ti = 8, ei = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            17,
            18,
            19,
            20,
            20,
            21,
            21,
            22,
            22,
            23,
            23,
            24,
            25,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            91,
            93,
            95,
            96,
            98,
            100,
            101,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            118,
            122,
            124,
            126,
            128,
            130,
            132,
            134,
            136,
            138,
            140,
            143,
            145,
            148,
            151,
            154,
            157
        ], ni = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            60,
            62,
            64,
            66,
            68,
            70,
            72,
            74,
            76,
            78,
            80,
            82,
            84,
            86,
            88,
            90,
            92,
            94,
            96,
            98,
            100,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            119,
            122,
            125,
            128,
            131,
            134,
            137,
            140,
            143,
            146,
            149,
            152,
            155,
            158,
            161,
            164,
            167,
            170,
            173,
            177,
            181,
            185,
            189,
            193,
            197,
            201,
            205,
            209,
            213,
            217,
            221,
            225,
            229,
            234,
            239,
            245,
            249,
            254,
            259,
            264,
            269,
            274,
            279,
            284
        ], ri = null, ii = [
            [
                173,
                148,
                140,
                0
            ],
            [
                176,
                155,
                140,
                135,
                0
            ],
            [
                180,
                157,
                141,
                134,
                130,
                0
            ],
            [
                254,
                254,
                243,
                230,
                196,
                177,
                153,
                140,
                133,
                130,
                129,
                0
            ]
        ], ai = [
            0,
            1,
            4,
            8,
            5,
            2,
            3,
            6,
            9,
            12,
            13,
            10,
            7,
            11,
            14,
            15
        ], oi = [
            -0,
            1,
            -1,
            2,
            -2,
            3,
            4,
            6,
            -3,
            5,
            -4,
            -5,
            -6,
            7,
            -7,
            8,
            -8,
            -9
        ], si = [
            [
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        253,
                        136,
                        254,
                        255,
                        228,
                        219,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        189,
                        129,
                        242,
                        255,
                        227,
                        213,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        106,
                        126,
                        227,
                        252,
                        214,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        98,
                        248,
                        255,
                        236,
                        226,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        181,
                        133,
                        238,
                        254,
                        221,
                        234,
                        255,
                        154,
                        128,
                        128,
                        128
                    ],
                    [
                        78,
                        134,
                        202,
                        247,
                        198,
                        180,
                        255,
                        219,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        185,
                        249,
                        255,
                        243,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        150,
                        247,
                        255,
                        236,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        77,
                        110,
                        216,
                        255,
                        236,
                        230,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        101,
                        251,
                        255,
                        241,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        170,
                        139,
                        241,
                        252,
                        236,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        37,
                        116,
                        196,
                        243,
                        228,
                        255,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        204,
                        254,
                        255,
                        245,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        207,
                        160,
                        250,
                        255,
                        238,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        102,
                        103,
                        231,
                        255,
                        211,
                        171,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        152,
                        252,
                        255,
                        240,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        177,
                        135,
                        243,
                        255,
                        234,
                        225,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        80,
                        129,
                        211,
                        255,
                        194,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        246,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        198,
                        35,
                        237,
                        223,
                        193,
                        187,
                        162,
                        160,
                        145,
                        155,
                        62
                    ],
                    [
                        131,
                        45,
                        198,
                        221,
                        172,
                        176,
                        220,
                        157,
                        252,
                        221,
                        1
                    ],
                    [
                        68,
                        47,
                        146,
                        208,
                        149,
                        167,
                        221,
                        162,
                        255,
                        223,
                        128
                    ]
                ],
                [
                    [
                        1,
                        149,
                        241,
                        255,
                        221,
                        224,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        141,
                        234,
                        253,
                        222,
                        220,
                        255,
                        199,
                        128,
                        128,
                        128
                    ],
                    [
                        81,
                        99,
                        181,
                        242,
                        176,
                        190,
                        249,
                        202,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        129,
                        232,
                        253,
                        214,
                        197,
                        242,
                        196,
                        255,
                        255,
                        128
                    ],
                    [
                        99,
                        121,
                        210,
                        250,
                        201,
                        198,
                        255,
                        202,
                        128,
                        128,
                        128
                    ],
                    [
                        23,
                        91,
                        163,
                        242,
                        170,
                        187,
                        247,
                        210,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        200,
                        246,
                        255,
                        234,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        109,
                        178,
                        241,
                        255,
                        231,
                        245,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        44,
                        130,
                        201,
                        253,
                        205,
                        192,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        132,
                        239,
                        251,
                        219,
                        209,
                        255,
                        165,
                        128,
                        128,
                        128
                    ],
                    [
                        94,
                        136,
                        225,
                        251,
                        218,
                        190,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        22,
                        100,
                        174,
                        245,
                        186,
                        161,
                        255,
                        199,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        249,
                        255,
                        232,
                        235,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        124,
                        143,
                        241,
                        255,
                        227,
                        234,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        35,
                        77,
                        181,
                        251,
                        193,
                        211,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        157,
                        247,
                        255,
                        236,
                        231,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        121,
                        141,
                        235,
                        255,
                        225,
                        227,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        45,
                        99,
                        188,
                        251,
                        195,
                        217,
                        255,
                        224,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        251,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        203,
                        1,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        137,
                        1,
                        177,
                        255,
                        224,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        253,
                        9,
                        248,
                        251,
                        207,
                        208,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        175,
                        13,
                        224,
                        243,
                        193,
                        185,
                        249,
                        198,
                        255,
                        255,
                        128
                    ],
                    [
                        73,
                        17,
                        171,
                        221,
                        161,
                        179,
                        236,
                        167,
                        255,
                        234,
                        128
                    ]
                ],
                [
                    [
                        1,
                        95,
                        247,
                        253,
                        212,
                        183,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        239,
                        90,
                        244,
                        250,
                        211,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        155,
                        77,
                        195,
                        248,
                        188,
                        195,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        24,
                        239,
                        251,
                        218,
                        219,
                        255,
                        205,
                        128,
                        128,
                        128
                    ],
                    [
                        201,
                        51,
                        219,
                        255,
                        196,
                        186,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        69,
                        46,
                        190,
                        239,
                        201,
                        218,
                        255,
                        228,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        191,
                        251,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        223,
                        165,
                        249,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        124,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        16,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        190,
                        36,
                        230,
                        255,
                        236,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        226,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        247,
                        192,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        240,
                        128,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        134,
                        252,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        213,
                        62,
                        250,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        55,
                        93,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        202,
                        24,
                        213,
                        235,
                        186,
                        191,
                        220,
                        160,
                        240,
                        175,
                        255
                    ],
                    [
                        126,
                        38,
                        182,
                        232,
                        169,
                        184,
                        228,
                        174,
                        255,
                        187,
                        128
                    ],
                    [
                        61,
                        46,
                        138,
                        219,
                        151,
                        178,
                        240,
                        170,
                        255,
                        216,
                        128
                    ]
                ],
                [
                    [
                        1,
                        112,
                        230,
                        250,
                        199,
                        191,
                        247,
                        159,
                        255,
                        255,
                        128
                    ],
                    [
                        166,
                        109,
                        228,
                        252,
                        211,
                        215,
                        255,
                        174,
                        128,
                        128,
                        128
                    ],
                    [
                        39,
                        77,
                        162,
                        232,
                        172,
                        180,
                        245,
                        178,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        52,
                        220,
                        246,
                        198,
                        199,
                        249,
                        220,
                        255,
                        255,
                        128
                    ],
                    [
                        124,
                        74,
                        191,
                        243,
                        183,
                        193,
                        250,
                        221,
                        255,
                        255,
                        128
                    ],
                    [
                        24,
                        71,
                        130,
                        219,
                        154,
                        170,
                        243,
                        182,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        225,
                        249,
                        219,
                        240,
                        255,
                        224,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        150,
                        226,
                        252,
                        216,
                        205,
                        255,
                        171,
                        128,
                        128,
                        128
                    ],
                    [
                        28,
                        108,
                        170,
                        242,
                        183,
                        194,
                        254,
                        223,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        81,
                        230,
                        252,
                        204,
                        203,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        123,
                        102,
                        209,
                        247,
                        188,
                        196,
                        255,
                        233,
                        128,
                        128,
                        128
                    ],
                    [
                        20,
                        95,
                        153,
                        243,
                        164,
                        173,
                        255,
                        203,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        222,
                        248,
                        255,
                        216,
                        213,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        168,
                        175,
                        246,
                        252,
                        235,
                        205,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        47,
                        116,
                        215,
                        255,
                        211,
                        212,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        121,
                        236,
                        253,
                        212,
                        214,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        84,
                        213,
                        252,
                        201,
                        202,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        42,
                        80,
                        160,
                        240,
                        162,
                        185,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        244,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        238,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ]
        ], ui = [
            [
                [
                    231,
                    120,
                    48,
                    89,
                    115,
                    113,
                    120,
                    152,
                    112
                ],
                [
                    152,
                    179,
                    64,
                    126,
                    170,
                    118,
                    46,
                    70,
                    95
                ],
                [
                    175,
                    69,
                    143,
                    80,
                    85,
                    82,
                    72,
                    155,
                    103
                ],
                [
                    56,
                    58,
                    10,
                    171,
                    218,
                    189,
                    17,
                    13,
                    152
                ],
                [
                    114,
                    26,
                    17,
                    163,
                    44,
                    195,
                    21,
                    10,
                    173
                ],
                [
                    121,
                    24,
                    80,
                    195,
                    26,
                    62,
                    44,
                    64,
                    85
                ],
                [
                    144,
                    71,
                    10,
                    38,
                    171,
                    213,
                    144,
                    34,
                    26
                ],
                [
                    170,
                    46,
                    55,
                    19,
                    136,
                    160,
                    33,
                    206,
                    71
                ],
                [
                    63,
                    20,
                    8,
                    114,
                    114,
                    208,
                    12,
                    9,
                    226
                ],
                [
                    81,
                    40,
                    11,
                    96,
                    182,
                    84,
                    29,
                    16,
                    36
                ]
            ],
            [
                [
                    134,
                    183,
                    89,
                    137,
                    98,
                    101,
                    106,
                    165,
                    148
                ],
                [
                    72,
                    187,
                    100,
                    130,
                    157,
                    111,
                    32,
                    75,
                    80
                ],
                [
                    66,
                    102,
                    167,
                    99,
                    74,
                    62,
                    40,
                    234,
                    128
                ],
                [
                    41,
                    53,
                    9,
                    178,
                    241,
                    141,
                    26,
                    8,
                    107
                ],
                [
                    74,
                    43,
                    26,
                    146,
                    73,
                    166,
                    49,
                    23,
                    157
                ],
                [
                    65,
                    38,
                    105,
                    160,
                    51,
                    52,
                    31,
                    115,
                    128
                ],
                [
                    104,
                    79,
                    12,
                    27,
                    217,
                    255,
                    87,
                    17,
                    7
                ],
                [
                    87,
                    68,
                    71,
                    44,
                    114,
                    51,
                    15,
                    186,
                    23
                ],
                [
                    47,
                    41,
                    14,
                    110,
                    182,
                    183,
                    21,
                    17,
                    194
                ],
                [
                    66,
                    45,
                    25,
                    102,
                    197,
                    189,
                    23,
                    18,
                    22
                ]
            ],
            [
                [
                    88,
                    88,
                    147,
                    150,
                    42,
                    46,
                    45,
                    196,
                    205
                ],
                [
                    43,
                    97,
                    183,
                    117,
                    85,
                    38,
                    35,
                    179,
                    61
                ],
                [
                    39,
                    53,
                    200,
                    87,
                    26,
                    21,
                    43,
                    232,
                    171
                ],
                [
                    56,
                    34,
                    51,
                    104,
                    114,
                    102,
                    29,
                    93,
                    77
                ],
                [
                    39,
                    28,
                    85,
                    171,
                    58,
                    165,
                    90,
                    98,
                    64
                ],
                [
                    34,
                    22,
                    116,
                    206,
                    23,
                    34,
                    43,
                    166,
                    73
                ],
                [
                    107,
                    54,
                    32,
                    26,
                    51,
                    1,
                    81,
                    43,
                    31
                ],
                [
                    68,
                    25,
                    106,
                    22,
                    64,
                    171,
                    36,
                    225,
                    114
                ],
                [
                    34,
                    19,
                    21,
                    102,
                    132,
                    188,
                    16,
                    76,
                    124
                ],
                [
                    62,
                    18,
                    78,
                    95,
                    85,
                    57,
                    50,
                    48,
                    51
                ]
            ],
            [
                [
                    193,
                    101,
                    35,
                    159,
                    215,
                    111,
                    89,
                    46,
                    111
                ],
                [
                    60,
                    148,
                    31,
                    172,
                    219,
                    228,
                    21,
                    18,
                    111
                ],
                [
                    112,
                    113,
                    77,
                    85,
                    179,
                    255,
                    38,
                    120,
                    114
                ],
                [
                    40,
                    42,
                    1,
                    196,
                    245,
                    209,
                    10,
                    25,
                    109
                ],
                [
                    88,
                    43,
                    29,
                    140,
                    166,
                    213,
                    37,
                    43,
                    154
                ],
                [
                    61,
                    63,
                    30,
                    155,
                    67,
                    45,
                    68,
                    1,
                    209
                ],
                [
                    100,
                    80,
                    8,
                    43,
                    154,
                    1,
                    51,
                    26,
                    71
                ],
                [
                    142,
                    78,
                    78,
                    16,
                    255,
                    128,
                    34,
                    197,
                    171
                ],
                [
                    41,
                    40,
                    5,
                    102,
                    211,
                    183,
                    4,
                    1,
                    221
                ],
                [
                    51,
                    50,
                    17,
                    168,
                    209,
                    192,
                    23,
                    25,
                    82
                ]
            ],
            [
                [
                    138,
                    31,
                    36,
                    171,
                    27,
                    166,
                    38,
                    44,
                    229
                ],
                [
                    67,
                    87,
                    58,
                    169,
                    82,
                    115,
                    26,
                    59,
                    179
                ],
                [
                    63,
                    59,
                    90,
                    180,
                    59,
                    166,
                    93,
                    73,
                    154
                ],
                [
                    40,
                    40,
                    21,
                    116,
                    143,
                    209,
                    34,
                    39,
                    175
                ],
                [
                    47,
                    15,
                    16,
                    183,
                    34,
                    223,
                    49,
                    45,
                    183
                ],
                [
                    46,
                    17,
                    33,
                    183,
                    6,
                    98,
                    15,
                    32,
                    183
                ],
                [
                    57,
                    46,
                    22,
                    24,
                    128,
                    1,
                    54,
                    17,
                    37
                ],
                [
                    65,
                    32,
                    73,
                    115,
                    28,
                    128,
                    23,
                    128,
                    205
                ],
                [
                    40,
                    3,
                    9,
                    115,
                    51,
                    192,
                    18,
                    6,
                    223
                ],
                [
                    87,
                    37,
                    9,
                    115,
                    59,
                    77,
                    64,
                    21,
                    47
                ]
            ],
            [
                [
                    104,
                    55,
                    44,
                    218,
                    9,
                    54,
                    53,
                    130,
                    226
                ],
                [
                    64,
                    90,
                    70,
                    205,
                    40,
                    41,
                    23,
                    26,
                    57
                ],
                [
                    54,
                    57,
                    112,
                    184,
                    5,
                    41,
                    38,
                    166,
                    213
                ],
                [
                    30,
                    34,
                    26,
                    133,
                    152,
                    116,
                    10,
                    32,
                    134
                ],
                [
                    39,
                    19,
                    53,
                    221,
                    26,
                    114,
                    32,
                    73,
                    255
                ],
                [
                    31,
                    9,
                    65,
                    234,
                    2,
                    15,
                    1,
                    118,
                    73
                ],
                [
                    75,
                    32,
                    12,
                    51,
                    192,
                    255,
                    160,
                    43,
                    51
                ],
                [
                    88,
                    31,
                    35,
                    67,
                    102,
                    85,
                    55,
                    186,
                    85
                ],
                [
                    56,
                    21,
                    23,
                    111,
                    59,
                    205,
                    45,
                    37,
                    192
                ],
                [
                    55,
                    38,
                    70,
                    124,
                    73,
                    102,
                    1,
                    34,
                    98
                ]
            ],
            [
                [
                    125,
                    98,
                    42,
                    88,
                    104,
                    85,
                    117,
                    175,
                    82
                ],
                [
                    95,
                    84,
                    53,
                    89,
                    128,
                    100,
                    113,
                    101,
                    45
                ],
                [
                    75,
                    79,
                    123,
                    47,
                    51,
                    128,
                    81,
                    171,
                    1
                ],
                [
                    57,
                    17,
                    5,
                    71,
                    102,
                    57,
                    53,
                    41,
                    49
                ],
                [
                    38,
                    33,
                    13,
                    121,
                    57,
                    73,
                    26,
                    1,
                    85
                ],
                [
                    41,
                    10,
                    67,
                    138,
                    77,
                    110,
                    90,
                    47,
                    114
                ],
                [
                    115,
                    21,
                    2,
                    10,
                    102,
                    255,
                    166,
                    23,
                    6
                ],
                [
                    101,
                    29,
                    16,
                    10,
                    85,
                    128,
                    101,
                    196,
                    26
                ],
                [
                    57,
                    18,
                    10,
                    102,
                    102,
                    213,
                    34,
                    20,
                    43
                ],
                [
                    117,
                    20,
                    15,
                    36,
                    163,
                    128,
                    68,
                    1,
                    26
                ]
            ],
            [
                [
                    102,
                    61,
                    71,
                    37,
                    34,
                    53,
                    31,
                    243,
                    192
                ],
                [
                    69,
                    60,
                    71,
                    38,
                    73,
                    119,
                    28,
                    222,
                    37
                ],
                [
                    68,
                    45,
                    128,
                    34,
                    1,
                    47,
                    11,
                    245,
                    171
                ],
                [
                    62,
                    17,
                    19,
                    70,
                    146,
                    85,
                    55,
                    62,
                    70
                ],
                [
                    37,
                    43,
                    37,
                    154,
                    100,
                    163,
                    85,
                    160,
                    1
                ],
                [
                    63,
                    9,
                    92,
                    136,
                    28,
                    64,
                    32,
                    201,
                    85
                ],
                [
                    75,
                    15,
                    9,
                    9,
                    64,
                    255,
                    184,
                    119,
                    16
                ],
                [
                    86,
                    6,
                    28,
                    5,
                    64,
                    255,
                    25,
                    248,
                    1
                ],
                [
                    56,
                    8,
                    17,
                    132,
                    137,
                    255,
                    55,
                    116,
                    128
                ],
                [
                    58,
                    15,
                    20,
                    82,
                    135,
                    57,
                    26,
                    121,
                    40
                ]
            ],
            [
                [
                    164,
                    50,
                    31,
                    137,
                    154,
                    133,
                    25,
                    35,
                    218
                ],
                [
                    51,
                    103,
                    44,
                    131,
                    131,
                    123,
                    31,
                    6,
                    158
                ],
                [
                    86,
                    40,
                    64,
                    135,
                    148,
                    224,
                    45,
                    183,
                    128
                ],
                [
                    22,
                    26,
                    17,
                    131,
                    240,
                    154,
                    14,
                    1,
                    209
                ],
                [
                    45,
                    16,
                    21,
                    91,
                    64,
                    222,
                    7,
                    1,
                    197
                ],
                [
                    56,
                    21,
                    39,
                    155,
                    60,
                    138,
                    23,
                    102,
                    213
                ],
                [
                    83,
                    12,
                    13,
                    54,
                    192,
                    255,
                    68,
                    47,
                    28
                ],
                [
                    85,
                    26,
                    85,
                    85,
                    128,
                    128,
                    32,
                    146,
                    171
                ],
                [
                    18,
                    11,
                    7,
                    63,
                    144,
                    171,
                    4,
                    4,
                    246
                ],
                [
                    35,
                    27,
                    10,
                    146,
                    174,
                    171,
                    12,
                    26,
                    128
                ]
            ],
            [
                [
                    190,
                    80,
                    35,
                    99,
                    180,
                    80,
                    126,
                    54,
                    45
                ],
                [
                    85,
                    126,
                    47,
                    87,
                    176,
                    51,
                    41,
                    20,
                    32
                ],
                [
                    101,
                    75,
                    128,
                    139,
                    118,
                    146,
                    116,
                    128,
                    85
                ],
                [
                    56,
                    41,
                    15,
                    176,
                    236,
                    85,
                    37,
                    9,
                    62
                ],
                [
                    71,
                    30,
                    17,
                    119,
                    118,
                    255,
                    17,
                    18,
                    138
                ],
                [
                    101,
                    38,
                    60,
                    138,
                    55,
                    70,
                    43,
                    26,
                    142
                ],
                [
                    146,
                    36,
                    19,
                    30,
                    171,
                    255,
                    97,
                    27,
                    20
                ],
                [
                    138,
                    45,
                    61,
                    62,
                    219,
                    1,
                    81,
                    188,
                    64
                ],
                [
                    32,
                    41,
                    20,
                    117,
                    151,
                    142,
                    20,
                    21,
                    163
                ],
                [
                    112,
                    19,
                    12,
                    61,
                    195,
                    128,
                    48,
                    4,
                    24
                ]
            ]
        ], ci = [
            [
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        176,
                        246,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        241,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        244,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        246,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        239,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        217,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        225,
                        252,
                        241,
                        253,
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        250,
                        241,
                        250,
                        253,
                        255,
                        253,
                        254,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        238,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        247,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        186,
                        251,
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        251,
                        244,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        251,
                        243,
                        253,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        236,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        253,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        248,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        254,
                        252,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        249,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        246,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        254,
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        245,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ]
        ], hi = [
            0,
            1,
            2,
            3,
            6,
            4,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            0
        ], li = [], fi = [], di = [], pi = 1, gi = 2, mi = [], vi = [];
        bn("UpsampleRgbLinePair", An, 3), bn("UpsampleBgrLinePair", _n, 3), bn("UpsampleRgbaLinePair", In, 4), bn("UpsampleBgraLinePair", Fn, 4), bn("UpsampleArgbLinePair", kn, 4), bn("UpsampleRgba4444LinePair", Pn, 2), bn("UpsampleRgb565LinePair", Sn, 2);
        var bi = t.UpsampleRgbLinePair, yi = t.UpsampleBgrLinePair, wi = t.UpsampleRgbaLinePair, Ni = t.UpsampleBgraLinePair, Li = t.UpsampleArgbLinePair, xi = t.UpsampleRgba4444LinePair, Ai = t.UpsampleRgb565LinePair, _i = 16, Si = 1 << _i - 1, Pi = -227, ki = 482, Fi = 6, Ii = (256 << Fi) - 1, Ci = 0, ji = a(256), Bi = a(256), Oi = a(256), Mi = a(256), Ei = a(ki - Pi), qi = a(ki - Pi);
        Cn("YuvToRgbRow", An, 3), Cn("YuvToBgrRow", _n, 3), Cn("YuvToRgbaRow", In, 4), Cn("YuvToBgraRow", Fn, 4), Cn("YuvToArgbRow", kn, 4), Cn("YuvToRgba4444Row", Pn, 2), Cn("YuvToRgb565Row", Sn, 2);
        var Ri = [
            0,
            4,
            8,
            12,
            128,
            132,
            136,
            140,
            256,
            260,
            264,
            268,
            384,
            388,
            392,
            396
        ], Ti = [
            0,
            2,
            8
        ], Di = [
            8,
            7,
            6,
            4,
            4,
            2,
            2,
            2,
            1,
            1,
            1,
            1
        ], Ui = 1;
        this.WebPDecodeRGBA = function(t, n, r, i, a) {
            var o = qr, s = new nn, u = new ot;
            s.ba = u, u.S = o, u.width = [
                u.width
            ], u.height = [
                u.height
            ];
            var c = u.width, h = u.height, l = new st;
            if (null == l || null == t) var f = 2;
            else e(null != l), f = Mn(t, n, r, l.width, l.height, l.Pd, l.Qd, l.format, null);
            if (0 != f ? c = 0 : (null != c && (c[0] = l.width[0]), null != h && (h[0] = l.height[0]), c = 1), c) {
                u.width = u.width[0], u.height = u.height[0], null != i && (i[0] = u.width), null != a && (a[0] = u.height);
                t: {
                    if (i = new Gt, (a = new rn).data = t, a.w = n, a.ha = r, a.kd = 1, n = [
                        0
                    ], e(null != a), (0 == (t = Mn(a.data, a.w, a.ha, null, null, null, n, null, a)) || 7 == t) && n[0] && (t = 4), 0 == (n = t)) {
                        if (e(null != s), i.data = a.data, i.w = a.w + a.offset, i.ha = a.ha - a.offset, i.put = dt, i.ac = ft, i.bc = pt, i.ma = s, a.xa) {
                            if (null == (t = kt())) {
                                s = 1;
                                break t;
                            }
                            if (function(t, n) {
                                var r = [
                                    0
                                ], i = [
                                    0
                                ], a = [
                                    0
                                ];
                                e: for(;;){
                                    if (null == t) return 0;
                                    if (null == n) return t.a = 2, 0;
                                    if (t.l = n, t.a = 0, v(t.m, n.data, n.w, n.ha), !gt(t.m, r, i, a)) {
                                        t.a = 3;
                                        break e;
                                    }
                                    if (t.xb = gi, n.width = r[0], n.height = i[0], !Ft(r[0], i[0], 1, t, null)) break e;
                                    return 1;
                                }
                                return e(0 != t.a), 0;
                            }(t, i)) {
                                if (i = 0 == (n = Rn(i.width, i.height, s.Oa, s.ba))) {
                                    e: {
                                        i = t;
                                        n: for(;;){
                                            if (null == i) {
                                                i = 0;
                                                break e;
                                            }
                                            if (e(null != i.s.yc), e(null != i.s.Ya), e(0 < i.s.Wb), e(null != (r = i.l)), e(null != (a = r.ma)), 0 != i.xb) {
                                                if (i.ca = a.ba, i.tb = a.tb, e(null != i.ca), !En(a.Oa, r, Tr)) {
                                                    i.a = 2;
                                                    break n;
                                                }
                                                if (!It(i, r.width)) break n;
                                                if (r.da) break n;
                                                if ((r.da || rt(i.ca.S)) && vn(), 11 > i.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), null != i.ca.f.kb.F && vn()), i.Pb && 0 < i.s.ua && null == i.s.vb.X && !B(i.s.vb, i.s.Wa.Xa)) {
                                                    i.a = 1;
                                                    break n;
                                                }
                                                i.xb = 0;
                                            }
                                            if (!St(i, i.V, i.Ba, i.c, i.i, r.o, Lt)) break n;
                                            a.Dc = i.Ma, i = 1;
                                            break e;
                                        }
                                        e(0 != i.a), i = 0;
                                    }
                                    i = !i;
                                }
                                i && (n = t.a);
                            } else n = t.a;
                        } else {
                            t = new Yt;
                            if (t.Fa = a.na, t.P = a.P, t.qc = a.Sa, Kt(t, i)) {
                                if (0 == (n = Rn(i.width, i.height, s.Oa, s.ba))) {
                                    if (t.Aa = 0, r = s.Oa, e(null != (a = t)), null != r) {
                                        if (0 < (c = 0 > (c = r.Md) ? 0 : 100 < c ? 255 : 255 * c / 100)) {
                                            for(h = l = 0; 4 > h; ++h)12 > (f = a.pb[h]).lc && (f.ia = c * Di[0 > f.lc ? 0 : f.lc] >> 3), l |= f.ia;
                                            l && (alert("todo:VP8InitRandom"), a.ia = 1);
                                        }
                                        a.Ga = r.Id, 100 < a.Ga ? a.Ga = 100 : 0 > a.Ga && (a.Ga = 0);
                                    }
                                    Qt(t, i) || (n = t.a);
                                }
                            } else n = t.a;
                        }
                        0 == n && null != s.Oa && s.Oa.fd && (n = qn(s.ba));
                    }
                    s = n;
                }
                o = 0 != s ? null : 11 > o ? u.f.RGBA.eb : u.f.kb.y;
            } else o = null;
            return o;
        };
        var zi = [
            3,
            4,
            3,
            4,
            4,
            2,
            2,
            4,
            4,
            4,
            2,
            1,
            1
        ];
    });
    var l = [
        0
    ], f = [
        0
    ], d = [], p = new $970c7ddf83730f06$var$Et, g = t, m = function(t, e) {
        var n = {}, r = 0, i = !1, a = 0, o = 0;
        if (n.frames = [], !/** @license
   * Copyright (c) 2017 Dominik Homberger

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

https://webpjs.appspot.com
WebPRiffParser dominikhlbg@gmail.com
*/ function(t, e, n, r) {
            for(var i = 0; i < r; i++)if (t[e + i] != n.charCodeAt(i)) return !0;
            return !1;
        }(t, e, "RIFF", 4)) {
            var s, l;
            h(t, e += 4);
            for(e += 8; e < t.length;){
                var f = u(t, e), d = h(t, e += 4);
                e += 4;
                var p = d + (1 & d);
                switch(f){
                    case "VP8 ":
                    case "VP8L":
                        void 0 === n.frames[r] && (n.frames[r] = {});
                        (v = n.frames[r]).src_off = i ? o : e - 8, v.src_size = a + d + 8, r++, i && (i = !1, a = 0, o = 0);
                        break;
                    case "VP8X":
                        (v = n.header = {}).feature_flags = t[e];
                        var g = e + 4;
                        v.canvas_width = 1 + c(t, g);
                        g += 3;
                        v.canvas_height = 1 + c(t, g);
                        g += 3;
                        break;
                    case "ALPH":
                        i = !0, a = p + 8, o = e - 8;
                        break;
                    case "ANIM":
                        (v = n.header).bgcolor = h(t, e);
                        g = e + 4;
                        v.loop_count = (s = t)[(l = g) + 0] << 0 | s[l + 1] << 8;
                        g += 2;
                        break;
                    case "ANMF":
                        var m, v;
                        (v = n.frames[r] = {}).offset_x = 2 * c(t, e), e += 3, v.offset_y = 2 * c(t, e), e += 3, v.width = 1 + c(t, e), e += 3, v.height = 1 + c(t, e), e += 3, v.duration = c(t, e), e += 3, m = t[e++], v.dispose = 1 & m, v.blend = m >> 1 & 1;
                }
                "ANMF" != f && (e += p);
            }
            return n;
        }
    }(g, 0);
    m.response = g, m.rgbaoutput = !0, m.dataurl = !1;
    var v = m.header ? m.header : null, b = m.frames ? m.frames : null;
    if (v) {
        v.loop_counter = v.loop_count, l = [
            v.canvas_height
        ], f = [
            v.canvas_width
        ];
        for(var y = 0; y < b.length && 0 != b[y].blend; y++);
    }
    var w = b[0], N = p.WebPDecodeRGBA(g, w.src_off, w.src_size, f, l);
    w.rgba = N, w.imgwidth = f[0], w.imgheight = l[0];
    for(var L = 0; L < f[0] * l[0] * 4; L++)d[L] = N[L];
    return this.width = f, this.height = l, this.data = d, this;
}

/**
 * @license
 *
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ !function(t) {
    var e = function() {
        return !0;
    }, n = function(e, n, a, h) {
        var l = 5, f = s;
        switch(h){
            case t.image_compression.FAST:
                l = 3, f = o;
                break;
            case t.image_compression.MEDIUM:
                l = 6, f = u;
                break;
            case t.image_compression.SLOW:
                l = 9, f = c;
        }
        e = i(e, n, a, f);
        var d = new Uint8Array(r(l)), p = $970c7ddf83730f06$export$ba1e2ffc633a60f5.API.adler32cs.fromBuffer(e.buffer), m = new $970c7ddf83730f06$var$xt(l), v = m.append(e), b = m.flush(), y = d.length + v.length + b.length, w = new Uint8Array(y + 4);
        return w.set(d), w.set(v, d.length), w.set(b, d.length + v.length), w[y++] = p >>> 24 & 255, w[y++] = p >>> 16 & 255, w[y++] = p >>> 8 & 255, w[y++] = 255 & p, t.__addimage__.arrayBufferToBinaryString(w);
    }, r = function(t) {
        var e = 30720;
        return e |= Math.min(3, (t - 1 & 255) >> 1) << 6, e |= 0, [
            120,
            255 & (e += 31 - e % 31)
        ];
    }, i = function(t, e, n, r) {
        for(var i, a, o, s = t.length / e, u = new Uint8Array(t.length + s), c = l(), h = 0; h < s; h += 1){
            if (o = h * e, i = t.subarray(o, o + e), r) u.set(r(i, n, a), o + h);
            else {
                for(var d, p = c.length, g = []; d < p; d += 1)g[d] = c[d](i, n, a);
                var m = f(g.concat());
                u.set(g[m], o + h);
            }
            a = i;
        }
        return u;
    }, a = function(t) {
        var e = Array.apply([], t);
        return e.unshift(0), e;
    }, o = function(t, e) {
        var n, r = [], i = t.length;
        r[0] = 1;
        for(var a = 0; a < i; a += 1)n = t[a - e] || 0, r[a + 1] = t[a] - n + 256 & 255;
        return r;
    }, s = function(t, e, n) {
        var r, i = [], a = t.length;
        i[0] = 2;
        for(var o = 0; o < a; o += 1)r = n && n[o] || 0, i[o + 1] = t[o] - r + 256 & 255;
        return i;
    }, u = function(t, e, n) {
        var r, i, a = [], o = t.length;
        a[0] = 3;
        for(var s = 0; s < o; s += 1)r = t[s - e] || 0, i = n && n[s] || 0, a[s + 1] = t[s] + 256 - (r + i >>> 1) & 255;
        return a;
    }, c = function(t, e, n) {
        var r, i, a, o, s = [], u = t.length;
        s[0] = 4;
        for(var c = 0; c < u; c += 1)r = t[c - e] || 0, i = n && n[c] || 0, a = n && n[c - e] || 0, o = h(r, i, a), s[c + 1] = t[c] - o + 256 & 255;
        return s;
    }, h = function(t, e, n) {
        if (t === e && e === n) return t;
        var r = Math.abs(e - n), i = Math.abs(t - n), a = Math.abs(t + e - n - n);
        return r <= i && r <= a ? t : i <= a ? e : n;
    }, l = function() {
        return [
            a,
            o,
            s,
            u,
            c
        ];
    }, f = function(t) {
        var e = t.map(function(t) {
            return t.reduce(function(t, e) {
                return t + Math.abs(e);
            }, 0);
        });
        return e.indexOf(Math.min.apply(null, e));
    };
    t.processPNG = function(r, i, a, o) {
        var s, u, c, h, l, f, d, p, g, m, v, b, y, w, N, L = this.decode.FLATE_DECODE, x = "";
        if (this.__addimage__.isArrayBuffer(r) && (r = new Uint8Array(r)), this.__addimage__.isArrayBufferView(r)) {
            if (r = (c = new $970c7ddf83730f06$var$Ct(r)).imgData, u = c.bits, s = c.colorSpace, l = c.colors, -1 !== [
                4,
                6
            ].indexOf(c.colorType)) {
                if (8 === c.bits) {
                    g = (p = 32 == c.pixelBitlength ? new Uint32Array(c.decodePixels().buffer) : 16 == c.pixelBitlength ? new Uint16Array(c.decodePixels().buffer) : new Uint8Array(c.decodePixels().buffer)).length, v = new Uint8Array(g * c.colors), m = new Uint8Array(g);
                    var A, _ = c.pixelBitlength - c.bits;
                    for(w = 0, N = 0; w < g; w++){
                        for(y = p[w], A = 0; A < _;)v[N++] = y >>> A & 255, A += c.bits;
                        m[w] = y >>> A & 255;
                    }
                }
                if (16 === c.bits) {
                    g = (p = new Uint32Array(c.decodePixels().buffer)).length, v = new Uint8Array(g * (32 / c.pixelBitlength) * c.colors), m = new Uint8Array(g * (32 / c.pixelBitlength)), b = c.colors > 1, w = 0, N = 0;
                    for(var S = 0; w < g;)y = p[w++], v[N++] = y >>> 0 & 255, b && (v[N++] = y >>> 16 & 255, y = p[w++], v[N++] = y >>> 0 & 255), m[S++] = y >>> 16 & 255;
                    u = 8;
                }
                o !== t.image_compression.NONE && e() ? (r = n(v, c.width * c.colors, c.colors, o), d = n(m, c.width, 1, o)) : (r = v, d = m, L = void 0);
            }
            if (3 === c.colorType && (s = this.color_spaces.INDEXED, f = c.palette, c.transparency.indexed)) {
                var P = c.transparency.indexed, k = 0;
                for(w = 0, g = P.length; w < g; ++w)k += P[w];
                if ((k /= 255) === g - 1 && -1 !== P.indexOf(0)) h = [
                    P.indexOf(0)
                ];
                else if (k !== g) {
                    for(p = c.decodePixels(), m = new Uint8Array(p.length), w = 0, g = p.length; w < g; w++)m[w] = P[p[w]];
                    d = n(m, c.width, 1);
                }
            }
            var F = function(e) {
                var n;
                switch(e){
                    case t.image_compression.FAST:
                        n = 11;
                        break;
                    case t.image_compression.MEDIUM:
                        n = 13;
                        break;
                    case t.image_compression.SLOW:
                        n = 14;
                        break;
                    default:
                        n = 12;
                }
                return n;
            }(o);
            return L === this.decode.FLATE_DECODE && (x = "/Predictor " + F + " "), x += "/Colors " + l + " /BitsPerComponent " + u + " /Columns " + c.width, (this.__addimage__.isArrayBuffer(r) || this.__addimage__.isArrayBufferView(r)) && (r = this.__addimage__.arrayBufferToBinaryString(r)), (d && this.__addimage__.isArrayBuffer(d) || this.__addimage__.isArrayBufferView(d)) && (d = this.__addimage__.arrayBufferToBinaryString(d)), {
                alias: a,
                data: r,
                index: i,
                filter: L,
                decodeParameters: x,
                transparency: h,
                palette: f,
                sMask: d,
                predictor: F,
                width: c.width,
                height: c.height,
                bitsPerComponent: u,
                colorSpace: s
            };
        }
    };
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API), function(t) {
    t.processGIF89A = function(e, n, r, i) {
        var a = new $970c7ddf83730f06$var$jt(e), o = a.width, s = a.height, u = [];
        a.decodeAndBlitFrameRGBA(0, u);
        var c = {
            data: u,
            width: o,
            height: s
        }, h = new $970c7ddf83730f06$var$Ot(100).encode(c, 100);
        return t.processJPEG.call(this, h, n, r, i);
    }, t.processGIF87A = t.processGIF89A;
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API), $970c7ddf83730f06$var$Mt.prototype.parseHeader = function() {
    if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
        var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
        this.palette = new Array(t);
        for(var e = 0; e < t; e++){
            var n = this.datav.getUint8(this.pos++, !0), r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0);
            this.palette[e] = {
                red: i,
                green: r,
                blue: n,
                quad: a
            };
        }
    }
    this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, $970c7ddf83730f06$var$Mt.prototype.parseBGR = function() {
    this.pos = this.offset;
    try {
        var t = "bit" + this.bitPP, e = this.width * this.height * 4;
        this.data = new Uint8Array(e), this[t]();
    } catch (t) {
        $970c7ddf83730f06$var$n.log("bit decode error:" + t);
    }
}, $970c7ddf83730f06$var$Mt.prototype.bit1 = function() {
    var t, e = Math.ceil(this.width / 8), n = e % 4;
    for(t = this.height - 1; t >= 0; t--){
        for(var r = this.bottom_up ? t : this.height - 1 - t, i = 0; i < e; i++)for(var a = this.datav.getUint8(this.pos++, !0), o = r * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++){
            var u = this.palette[a >> 7 - s & 1];
            this.data[o + 4 * s] = u.blue, this.data[o + 4 * s + 1] = u.green, this.data[o + 4 * s + 2] = u.red, this.data[o + 4 * s + 3] = 255;
        }
        0 !== n && (this.pos += 4 - n);
    }
}, $970c7ddf83730f06$var$Mt.prototype.bit4 = function() {
    for(var t = Math.ceil(this.width / 2), e = t % 4, n = this.height - 1; n >= 0; n--){
        for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < t; i++){
            var a = this.datav.getUint8(this.pos++, !0), o = r * this.width * 4 + 2 * i * 4, s = a >> 4, u = 15 & a, c = this.palette[s];
            if (this.data[o] = c.blue, this.data[o + 1] = c.green, this.data[o + 2] = c.red, this.data[o + 3] = 255, 2 * i + 1 >= this.width) break;
            c = this.palette[u], this.data[o + 4] = c.blue, this.data[o + 4 + 1] = c.green, this.data[o + 4 + 2] = c.red, this.data[o + 4 + 3] = 255;
        }
        0 !== e && (this.pos += 4 - e);
    }
}, $970c7ddf83730f06$var$Mt.prototype.bit8 = function() {
    for(var t = this.width % 4, e = this.height - 1; e >= 0; e--){
        for(var n = this.bottom_up ? e : this.height - 1 - e, r = 0; r < this.width; r++){
            var i = this.datav.getUint8(this.pos++, !0), a = n * this.width * 4 + 4 * r;
            if (i < this.palette.length) {
                var o = this.palette[i];
                this.data[a] = o.red, this.data[a + 1] = o.green, this.data[a + 2] = o.blue, this.data[a + 3] = 255;
            } else this.data[a] = 255, this.data[a + 1] = 255, this.data[a + 2] = 255, this.data[a + 3] = 255;
        }
        0 !== t && (this.pos += 4 - t);
    }
}, $970c7ddf83730f06$var$Mt.prototype.bit15 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), n = this.height - 1; n >= 0; n--){
        for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < this.width; i++){
            var a = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var o = (a & e) / e * 255 | 0, s = (a >> 5 & e) / e * 255 | 0, u = (a >> 10 & e) / e * 255 | 0, c = a >> 15 ? 255 : 0, h = r * this.width * 4 + 4 * i;
            this.data[h] = u, this.data[h + 1] = s, this.data[h + 2] = o, this.data[h + 3] = c;
        }
        this.pos += t;
    }
}, $970c7ddf83730f06$var$Mt.prototype.bit16 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), n = parseInt("111111", 2), r = this.height - 1; r >= 0; r--){
        for(var i = this.bottom_up ? r : this.height - 1 - r, a = 0; a < this.width; a++){
            var o = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var s = (o & e) / e * 255 | 0, u = (o >> 5 & n) / n * 255 | 0, c = (o >> 11) / e * 255 | 0, h = i * this.width * 4 + 4 * a;
            this.data[h] = c, this.data[h + 1] = u, this.data[h + 2] = s, this.data[h + 3] = 255;
        }
        this.pos += t;
    }
}, $970c7ddf83730f06$var$Mt.prototype.bit24 = function() {
    for(var t = this.height - 1; t >= 0; t--){
        for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
            var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = e * this.width * 4 + 4 * n;
            this.data[o] = a, this.data[o + 1] = i, this.data[o + 2] = r, this.data[o + 3] = 255;
        }
        this.pos += this.width % 4;
    }
}, $970c7ddf83730f06$var$Mt.prototype.bit32 = function() {
    for(var t = this.height - 1; t >= 0; t--)for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
        var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * n;
        this.data[s] = a, this.data[s + 1] = i, this.data[s + 2] = r, this.data[s + 3] = o;
    }
}, $970c7ddf83730f06$var$Mt.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processBMP = function(e, n, r, i) {
        var a = new $970c7ddf83730f06$var$Mt(e, !1), o = a.width, s = a.height, u = {
            data: a.getData(),
            width: o,
            height: s
        }, c = new $970c7ddf83730f06$var$Ot(100).encode(u, 100);
        return t.processJPEG.call(this, c, n, r, i);
    };
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API), $970c7ddf83730f06$var$Et.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processWEBP = function(e, n, r, i) {
        var a = new $970c7ddf83730f06$var$Et(e, !1), o = a.width, s = a.height, u = {
            data: a.getData(),
            width: o,
            height: s
        }, c = new $970c7ddf83730f06$var$Ot(100).encode(u, 100);
        return t.processJPEG.call(this, c, n, r, i);
    };
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API), $970c7ddf83730f06$export$ba1e2ffc633a60f5.API.setLanguage = function(t) {
    return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== ({
        af: "Afrikaans",
        sq: "Albanian",
        ar: "Arabic (Standard)",
        "ar-DZ": "Arabic (Algeria)",
        "ar-BH": "Arabic (Bahrain)",
        "ar-EG": "Arabic (Egypt)",
        "ar-IQ": "Arabic (Iraq)",
        "ar-JO": "Arabic (Jordan)",
        "ar-KW": "Arabic (Kuwait)",
        "ar-LB": "Arabic (Lebanon)",
        "ar-LY": "Arabic (Libya)",
        "ar-MA": "Arabic (Morocco)",
        "ar-OM": "Arabic (Oman)",
        "ar-QA": "Arabic (Qatar)",
        "ar-SA": "Arabic (Saudi Arabia)",
        "ar-SY": "Arabic (Syria)",
        "ar-TN": "Arabic (Tunisia)",
        "ar-AE": "Arabic (U.A.E.)",
        "ar-YE": "Arabic (Yemen)",
        an: "Aragonese",
        hy: "Armenian",
        as: "Assamese",
        ast: "Asturian",
        az: "Azerbaijani",
        eu: "Basque",
        be: "Belarusian",
        bn: "Bengali",
        bs: "Bosnian",
        br: "Breton",
        bg: "Bulgarian",
        my: "Burmese",
        ca: "Catalan",
        ch: "Chamorro",
        ce: "Chechen",
        zh: "Chinese",
        "zh-HK": "Chinese (Hong Kong)",
        "zh-CN": "Chinese (PRC)",
        "zh-SG": "Chinese (Singapore)",
        "zh-TW": "Chinese (Taiwan)",
        cv: "Chuvash",
        co: "Corsican",
        cr: "Cree",
        hr: "Croatian",
        cs: "Czech",
        da: "Danish",
        nl: "Dutch (Standard)",
        "nl-BE": "Dutch (Belgian)",
        en: "English",
        "en-AU": "English (Australia)",
        "en-BZ": "English (Belize)",
        "en-CA": "English (Canada)",
        "en-IE": "English (Ireland)",
        "en-JM": "English (Jamaica)",
        "en-NZ": "English (New Zealand)",
        "en-PH": "English (Philippines)",
        "en-ZA": "English (South Africa)",
        "en-TT": "English (Trinidad & Tobago)",
        "en-GB": "English (United Kingdom)",
        "en-US": "English (United States)",
        "en-ZW": "English (Zimbabwe)",
        eo: "Esperanto",
        et: "Estonian",
        fo: "Faeroese",
        fj: "Fijian",
        fi: "Finnish",
        fr: "French (Standard)",
        "fr-BE": "French (Belgium)",
        "fr-CA": "French (Canada)",
        "fr-FR": "French (France)",
        "fr-LU": "French (Luxembourg)",
        "fr-MC": "French (Monaco)",
        "fr-CH": "French (Switzerland)",
        fy: "Frisian",
        fur: "Friulian",
        gd: "Gaelic (Scots)",
        "gd-IE": "Gaelic (Irish)",
        gl: "Galacian",
        ka: "Georgian",
        de: "German (Standard)",
        "de-AT": "German (Austria)",
        "de-DE": "German (Germany)",
        "de-LI": "German (Liechtenstein)",
        "de-LU": "German (Luxembourg)",
        "de-CH": "German (Switzerland)",
        el: "Greek",
        gu: "Gujurati",
        ht: "Haitian",
        he: "Hebrew",
        hi: "Hindi",
        hu: "Hungarian",
        is: "Icelandic",
        id: "Indonesian",
        iu: "Inuktitut",
        ga: "Irish",
        it: "Italian (Standard)",
        "it-CH": "Italian (Switzerland)",
        ja: "Japanese",
        kn: "Kannada",
        ks: "Kashmiri",
        kk: "Kazakh",
        km: "Khmer",
        ky: "Kirghiz",
        tlh: "Klingon",
        ko: "Korean",
        "ko-KP": "Korean (North Korea)",
        "ko-KR": "Korean (South Korea)",
        la: "Latin",
        lv: "Latvian",
        lt: "Lithuanian",
        lb: "Luxembourgish",
        mk: "FYRO Macedonian",
        ms: "Malay",
        ml: "Malayalam",
        mt: "Maltese",
        mi: "Maori",
        mr: "Marathi",
        mo: "Moldavian",
        nv: "Navajo",
        ng: "Ndonga",
        ne: "Nepali",
        no: "Norwegian",
        nb: "Norwegian (Bokmal)",
        nn: "Norwegian (Nynorsk)",
        oc: "Occitan",
        or: "Oriya",
        om: "Oromo",
        fa: "Persian",
        "fa-IR": "Persian/Iran",
        pl: "Polish",
        pt: "Portuguese",
        "pt-BR": "Portuguese (Brazil)",
        pa: "Punjabi",
        "pa-IN": "Punjabi (India)",
        "pa-PK": "Punjabi (Pakistan)",
        qu: "Quechua",
        rm: "Rhaeto-Romanic",
        ro: "Romanian",
        "ro-MO": "Romanian (Moldavia)",
        ru: "Russian",
        "ru-MO": "Russian (Moldavia)",
        sz: "Sami (Lappish)",
        sg: "Sango",
        sa: "Sanskrit",
        sc: "Sardinian",
        sd: "Sindhi",
        si: "Singhalese",
        sr: "Serbian",
        sk: "Slovak",
        sl: "Slovenian",
        so: "Somani",
        sb: "Sorbian",
        es: "Spanish",
        "es-AR": "Spanish (Argentina)",
        "es-BO": "Spanish (Bolivia)",
        "es-CL": "Spanish (Chile)",
        "es-CO": "Spanish (Colombia)",
        "es-CR": "Spanish (Costa Rica)",
        "es-DO": "Spanish (Dominican Republic)",
        "es-EC": "Spanish (Ecuador)",
        "es-SV": "Spanish (El Salvador)",
        "es-GT": "Spanish (Guatemala)",
        "es-HN": "Spanish (Honduras)",
        "es-MX": "Spanish (Mexico)",
        "es-NI": "Spanish (Nicaragua)",
        "es-PA": "Spanish (Panama)",
        "es-PY": "Spanish (Paraguay)",
        "es-PE": "Spanish (Peru)",
        "es-PR": "Spanish (Puerto Rico)",
        "es-ES": "Spanish (Spain)",
        "es-UY": "Spanish (Uruguay)",
        "es-VE": "Spanish (Venezuela)",
        sx: "Sutu",
        sw: "Swahili",
        sv: "Swedish",
        "sv-FI": "Swedish (Finland)",
        "sv-SV": "Swedish (Sweden)",
        ta: "Tamil",
        tt: "Tatar",
        te: "Teluga",
        th: "Thai",
        tig: "Tigre",
        ts: "Tsonga",
        tn: "Tswana",
        tr: "Turkish",
        tk: "Turkmen",
        uk: "Ukrainian",
        hsb: "Upper Sorbian",
        ur: "Urdu",
        ve: "Venda",
        vi: "Vietnamese",
        vo: "Volapuk",
        wa: "Walloon",
        cy: "Welsh",
        xh: "Xhosa",
        ji: "Yiddish",
        zu: "Zulu"
    })[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
    }), this.internal.languageSettings.isSubscribed = !0)), this;
}, /** @license
 * MIT license.
 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
 *               2014 Diego Casorran, https://github.com/diegocr
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ $970c7ddf83730f06$var$At = $970c7ddf83730f06$export$ba1e2ffc633a60f5.API, $970c7ddf83730f06$var$_t = $970c7ddf83730f06$var$At.getCharWidthsArray = function(t, e) {
    var n, r, i = (e = e || {}).font || this.internal.getFont(), a = e.fontSize || this.internal.getFontSize(), o = e.charSpace || this.internal.getCharSpace(), s = e.widths ? e.widths : i.metadata.Unicode.widths, u = s.fof ? s.fof : 1, c = e.kerning ? e.kerning : i.metadata.Unicode.kerning, h = c.fof ? c.fof : 1, l = !1 !== e.doKerning, f = 0, d = t.length, p = 0, g = s[0] || u, m = [];
    for(n = 0; n < d; n++)r = t.charCodeAt(n), "function" == typeof i.metadata.widthOfString ? m.push((i.metadata.widthOfGlyph(i.metadata.characterToGlyph(r)) + o * (1e3 / a) || 0) / 1e3) : (f = l && "object" == typeof c[r] && !isNaN(parseInt(c[r][p], 10)) ? c[r][p] / h : 0, m.push((s[r] || g) / u + f)), p = r;
    return m;
}, $970c7ddf83730f06$var$St = $970c7ddf83730f06$var$At.getStringUnitWidth = function(t, e) {
    var n = (e = e || {}).fontSize || this.internal.getFontSize(), r = e.font || this.internal.getFont(), i = e.charSpace || this.internal.getCharSpace();
    return $970c7ddf83730f06$var$At.processArabic && (t = $970c7ddf83730f06$var$At.processArabic(t)), "function" == typeof r.metadata.widthOfString ? r.metadata.widthOfString(t, n, i) / n : $970c7ddf83730f06$var$_t.apply(this, arguments).reduce(function(t, e) {
        return t + e;
    }, 0);
}, $970c7ddf83730f06$var$Pt = function(t, e, n, r) {
    for(var i = [], a = 0, o = t.length, s = 0; a !== o && s + e[a] < n;)s += e[a], a++;
    i.push(t.slice(0, a));
    var u = a;
    for(s = 0; a !== o;)s + e[a] > r && (i.push(t.slice(u, a)), s = 0, u = a), s += e[a], a++;
    return u !== a && i.push(t.slice(u, a)), i;
}, $970c7ddf83730f06$var$kt = function(t, e, n) {
    n || (n = {});
    var r, i, a, o, s, u, c, h = [], l = [
        h
    ], f = n.textIndent || 0, d = 0, p = 0, g = t.split(" "), m = $970c7ddf83730f06$var$_t.apply(this, [
        " ",
        n
    ])[0];
    if (u = -1 === n.lineIndent ? g[0].length + 2 : n.lineIndent || 0) {
        var v = Array(u).join(" "), b = [];
        g.map(function(t) {
            (t = t.split(/\s*\n/)).length > 1 ? b = b.concat(t.map(function(t, e) {
                return (e && t.length ? "\n" : "") + t;
            })) : b.push(t[0]);
        }), g = b, u = $970c7ddf83730f06$var$St.apply(this, [
            v,
            n
        ]);
    }
    for(a = 0, o = g.length; a < o; a++){
        var y = 0;
        if (r = g[a], u && "\n" == r[0] && (r = r.substr(1), y = 1), f + d + (p = (i = $970c7ddf83730f06$var$_t.apply(this, [
            r,
            n
        ])).reduce(function(t, e) {
            return t + e;
        }, 0)) > e || y) {
            if (p > e) {
                for(s = $970c7ddf83730f06$var$Pt.apply(this, [
                    r,
                    i,
                    e - (f + d),
                    e
                ]), h.push(s.shift()), h = [
                    s.pop()
                ]; s.length;)l.push([
                    s.shift()
                ]);
                p = i.slice(r.length - (h[0] ? h[0].length : 0)).reduce(function(t, e) {
                    return t + e;
                }, 0);
            } else h = [
                r
            ];
            l.push(h), f = p + u, d = m;
        } else h.push(r), f += d + p, d = m;
    }
    return c = u ? function(t, e) {
        return (e ? v : "") + t.join(" ");
    } : function(t) {
        return t.join(" ");
    }, l.map(c);
}, $970c7ddf83730f06$var$At.splitTextToSize = function(t, e, n) {
    var r, i = (n = n || {}).fontSize || this.internal.getFontSize(), a = (function(t) {
        if (t.widths && t.kerning) return {
            widths: t.widths,
            kerning: t.kerning
        };
        var e = this.internal.getFont(t.fontName, t.fontStyle);
        return e.metadata.Unicode ? {
            widths: e.metadata.Unicode.widths || {
                0: 1
            },
            kerning: e.metadata.Unicode.kerning || {}
        } : {
            font: e.metadata,
            fontSize: this.internal.getFontSize(),
            charSpace: this.internal.getCharSpace()
        };
    }).call(this, n);
    r = Array.isArray(t) ? t : String(t).split(/\r?\n/);
    var o = 1 * this.internal.scaleFactor * e / i;
    a.textIndent = n.textIndent ? 1 * n.textIndent * this.internal.scaleFactor / i : 0, a.lineIndent = n.lineIndent;
    var s, u, c = [];
    for(s = 0, u = r.length; s < u; s++)c = c.concat($970c7ddf83730f06$var$kt.apply(this, [
        r[s],
        o,
        a
    ]));
    return c;
}, /** @license
 jsPDF standard_fonts_metrics plugin
 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
 * MIT license.
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 * 
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(t) {
    t.__fontmetrics__ = t.__fontmetrics__ || {};
    for(var e = "klmnopqrstuvwxyz", n = {}, r = {}, i = 0; i < e.length; i++)n[e[i]] = "0123456789abcdef"[i], r["0123456789abcdef"[i]] = e[i];
    var a = function(t) {
        return "0x" + parseInt(t, 10).toString(16);
    }, o = t.__fontmetrics__.compress = function(t) {
        var e, n, i, s, u = [
            "{"
        ];
        for(var c in t){
            if (e = t[c], isNaN(parseInt(c, 10)) ? n = "'" + c + "'" : (c = parseInt(c, 10), n = (n = a(c).slice(2)).slice(0, -1) + r[n.slice(-1)]), "number" == typeof e) e < 0 ? (i = a(e).slice(3), s = "-") : (i = a(e).slice(2), s = ""), i = s + i.slice(0, -1) + r[i.slice(-1)];
            else {
                if ("object" != typeof e) throw new Error("Don't know what to do with value type " + typeof e + ".");
                i = o(e);
            }
            u.push(n + i);
        }
        return u.push("}"), u.join("");
    }, s = t.__fontmetrics__.uncompress = function(t) {
        if ("string" != typeof t) throw new Error("Invalid argument passed to uncompress.");
        for(var e, r, i, a, o = {}, s = 1, u = o, c = [], h = "", l = "", f = t.length - 1, d = 1; d < f; d += 1)"'" == (a = t[d]) ? e ? (i = e.join(""), e = void 0) : e = [] : e ? e.push(a) : "{" == a ? (c.push([
            u,
            i
        ]), u = {}, i = void 0) : "}" == a ? ((r = c.pop())[0][r[1]] = u, i = void 0, u = r[0]) : "-" == a ? s = -1 : void 0 === i ? n.hasOwnProperty(a) ? (h += n[a], i = parseInt(h, 16) * s, s = 1, h = "") : h += a : n.hasOwnProperty(a) ? (l += n[a], u[i] = parseInt(l, 16) * s, s = 1, i = void 0, l = "") : l += a;
        return o;
    }, u = {
        codePages: [
            "WinAnsiEncoding"
        ],
        WinAnsiEncoding: s("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
    }, c = {
        Unicode: {
            Courier: u,
            "Courier-Bold": u,
            "Courier-BoldOblique": u,
            "Courier-Oblique": u,
            Helvetica: u,
            "Helvetica-Bold": u,
            "Helvetica-BoldOblique": u,
            "Helvetica-Oblique": u,
            "Times-Roman": u,
            "Times-Bold": u,
            "Times-BoldItalic": u,
            "Times-Italic": u
        }
    }, h = {
        Unicode: {
            "Courier-Oblique": s("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-BoldItalic": s("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
            "Helvetica-Bold": s("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            Courier: s("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-BoldOblique": s("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Bold": s("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
            Symbol: s("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
            Helvetica: s("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
            "Helvetica-BoldOblique": s("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            ZapfDingbats: s("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-Bold": s("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Italic": s("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
            "Times-Roman": s("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
            "Helvetica-Oblique": s("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
        }
    };
    t.events.push([
        "addFont",
        function(t) {
            var e = t.font, n = h.Unicode[e.postScriptName];
            n && (e.metadata.Unicode = {}, e.metadata.Unicode.widths = n.widths, e.metadata.Unicode.kerning = n.kerning);
            var r = c.Unicode[e.postScriptName];
            r && (e.metadata.Unicode.encoding = r, e.encoding = r.codePages[0]);
        }
    ]);
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        for(var e = t.length, n = new Uint8Array(e), r = 0; r < e; r++)n[r] = t.charCodeAt(r);
        return n;
    };
    t.API.events.push([
        "addFont",
        function(n) {
            var r = void 0, i = n.font, a = n.instance;
            if (!i.isStandardFont) {
                if (void 0 === a) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                if ("string" != typeof (r = !1 === a.existsFileInVFS(i.postScriptName) ? a.loadFile(i.postScriptName) : a.getFileFromVFS(i.postScriptName))) throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                !function(n, r) {
                    r = /^\x00\x01\x00\x00/.test(r) ? e(r) : e($970c7ddf83730f06$var$o(r)), n.metadata = t.API.TTFFont.open(r), n.metadata.Unicode = n.metadata.Unicode || {
                        encoding: {},
                        kerning: {},
                        widths: []
                    }, n.metadata.glyIdsUsed = [
                        0
                    ];
                }(i, r);
            }
        }
    ]);
}($970c7ddf83730f06$export$ba1e2ffc633a60f5), /** @license
 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(e) {
    function r() {
        return ($970c7ddf83730f06$var$t.canvg ? Promise.resolve($970c7ddf83730f06$var$t.canvg) : (parcelRequire("84PN1"))).catch(function(t) {
            return Promise.reject(new Error("Could not load dompurify: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    $970c7ddf83730f06$export$ba1e2ffc633a60f5.API.addSvgAsImage = function(t, e, i, a, o, s, u, c) {
        if (isNaN(e) || isNaN(i)) throw $970c7ddf83730f06$var$n.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
        if (isNaN(a) || isNaN(o)) throw $970c7ddf83730f06$var$n.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
        var h = document.createElement("canvas");
        h.width = a, h.height = o;
        var l = h.getContext("2d");
        l.fillStyle = "#fff", l.fillRect(0, 0, h.width, h.height);
        var f = {
            ignoreMouse: !0,
            ignoreAnimation: !0,
            ignoreDimensions: !0
        }, d = this;
        return r().then(function(e) {
            return e.Canvg.fromString(l, t, f);
        }, function() {
            return Promise.reject(new Error("Could not load canvg."));
        }).then(function(t) {
            return t.render(f);
        }).then(function() {
            d.addImage(h.toDataURL("image/jpeg", 1), e, i, a, o, u, c);
        });
    };
}(), $970c7ddf83730f06$export$ba1e2ffc633a60f5.API.putTotalPages = function(t) {
    var e, n = 0;
    parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(t, "g"), n = this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(t, this.internal.getFont()), "g"), n = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
    for(var r = 1; r <= this.internal.getNumberOfPages(); r++)for(var i = 0; i < this.internal.pages[r].length; i++)this.internal.pages[r][i] = this.internal.pages[r][i].replace(e, n);
    return this;
}, $970c7ddf83730f06$export$ba1e2ffc633a60f5.API.viewerPreferences = function(t, e) {
    var n;
    t = t || {}, e = e || !1;
    var r, i, a, o = {
        HideToolbar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideMenubar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideWindowUI: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        FitWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        CenterWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        DisplayDocTitle: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.4
        },
        NonFullScreenPageMode: {
            defaultValue: "UseNone",
            value: "UseNone",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "UseNone",
                "UseOutlines",
                "UseThumbs",
                "UseOC"
            ],
            pdfVersion: 1.3
        },
        Direction: {
            defaultValue: "L2R",
            value: "L2R",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "L2R",
                "R2L"
            ],
            pdfVersion: 1.3
        },
        ViewArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        ViewClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintScaling: {
            defaultValue: "AppDefault",
            value: "AppDefault",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "AppDefault",
                "None"
            ],
            pdfVersion: 1.6
        },
        Duplex: {
            defaultValue: "",
            value: "none",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "Simplex",
                "DuplexFlipShortEdge",
                "DuplexFlipLongEdge",
                "none"
            ],
            pdfVersion: 1.7
        },
        PickTrayByPDFSize: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.7
        },
        PrintPageRange: {
            defaultValue: "",
            value: "",
            type: "array",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        },
        NumCopies: {
            defaultValue: 1,
            value: 1,
            type: "integer",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        }
    }, s = Object.keys(o), u = [], c = 0, h = 0, l = 0;
    function f(t, e) {
        var n, r = !1;
        for(n = 0; n < t.length; n += 1)t[n] === e && (r = !0);
        return r;
    }
    if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(o)), this.internal.viewerpreferences.isSubscribed = !1), n = this.internal.viewerpreferences.configuration, "reset" === t || !0 === e) {
        var d = s.length;
        for(l = 0; l < d; l += 1)n[s[l]].value = n[s[l]].defaultValue, n[s[l]].explicitSet = !1;
    }
    if ("object" == typeof t) {
        for(i in t)if (a = t[i], f(s, i) && void 0 !== a) {
            if ("boolean" === n[i].type && "boolean" == typeof a) n[i].value = a;
            else if ("name" === n[i].type && f(n[i].valueSet, a)) n[i].value = a;
            else if ("integer" === n[i].type && Number.isInteger(a)) n[i].value = a;
            else if ("array" === n[i].type) {
                for(c = 0; c < a.length; c += 1)if (r = !0, 1 === a[c].length && "number" == typeof a[c][0]) u.push(String(a[c] - 1));
                else if (a[c].length > 1) {
                    for(h = 0; h < a[c].length; h += 1)"number" != typeof a[c][h] && (r = !1);
                    !0 === r && u.push([
                        a[c][0] - 1,
                        a[c][1] - 1
                    ].join(" "));
                }
                n[i].value = "[" + u.join(" ") + "]";
            } else n[i].value = n[i].defaultValue;
            n[i].explicitSet = !0;
        }
    }
    return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        var t, e = [];
        for(t in n)!0 === n[t].explicitSet && ("name" === n[t].type ? e.push("/" + t + " /" + n[t].value) : e.push("/" + t + " " + n[t].value));
        0 !== e.length && this.internal.write("/ViewerPreferences\n<<\n" + e.join("\n") + "\n>>");
    }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = n, this;
}, /** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(t) {
    var e = function() {
        var t = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', e = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), n = unescape(encodeURIComponent(t)), r = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), i = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), a = unescape(encodeURIComponent("</x:xmpmeta>")), o = n.length + r.length + i.length + e.length + a.length;
        this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + o + " >>"), this.internal.write("stream"), this.internal.write(e + n + r + i + a), this.internal.write("endstream"), this.internal.write("endobj");
    }, n = function() {
        this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
    };
    t.addMetadata = function(t, r) {
        return void 0 === this.internal.__metadata__ && (this.internal.__metadata__ = {
            metadata: t,
            namespaceuri: r || "http://jspdf.default.namespaceuri/"
        }, this.internal.events.subscribe("putCatalog", n), this.internal.events.subscribe("postPutResources", e)), this;
    };
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API), function(t) {
    var e = t.API, n = e.pdfEscape16 = function(t, e) {
        for(var n, r = e.metadata.Unicode.widths, i = [
            "",
            "0",
            "00",
            "000",
            "0000"
        ], a = [
            ""
        ], o = 0, s = t.length; o < s; ++o){
            if (n = e.metadata.characterToGlyph(t.charCodeAt(o)), e.metadata.glyIdsUsed.push(n), e.metadata.toUnicode[n] = t.charCodeAt(o), -1 == r.indexOf(n) && (r.push(n), r.push([
                parseInt(e.metadata.widthOfGlyph(n), 10)
            ])), "0" == n) return a.join("");
            n = n.toString(16), a.push(i[4 - n.length], n);
        }
        return a.join("");
    }, r = function(t) {
        var e, n, r, i, a, o, s;
        for(a = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange", r = [], o = 0, s = (n = Object.keys(t).sort(function(t, e) {
            return t - e;
        })).length; o < s; o++)e = n[o], r.length >= 100 && (a += "\n" + r.length + " beginbfchar\n" + r.join("\n") + "\nendbfchar", r = []), void 0 !== t[e] && null !== t[e] && "function" == typeof t[e].toString && (i = ("0000" + t[e].toString(16)).slice(-4), e = ("0000" + (+e).toString(16)).slice(-4), r.push("<" + e + "><" + i + ">"));
        return r.length && (a += "\n" + r.length + " beginbfchar\n" + r.join("\n") + "\nendbfchar\n"), a += "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
    };
    e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var n = e.font, i = e.out, a = e.newObject, o = e.putStream, s = e.pdfEscapeWithNeededParanthesis;
                if (n.metadata instanceof t.API.TTFFont && "Identity-H" === n.encoding) {
                    for(var u = n.metadata.Unicode.widths, c = n.metadata.subset.encode(n.metadata.glyIdsUsed, 1), h = "", l = 0; l < c.length; l++)h += String.fromCharCode(c[l]);
                    var f = a();
                    o({
                        data: h,
                        addLength1: !0
                    }), i("endobj");
                    var d = a();
                    o({
                        data: r(n.metadata.toUnicode),
                        addLength1: !0
                    }), i("endobj");
                    var p = a();
                    i("<<"), i("/Type /FontDescriptor"), i("/FontName /" + s(n.fontName)), i("/FontFile2 " + f + " 0 R"), i("/FontBBox " + t.API.PDFObject.convert(n.metadata.bbox)), i("/Flags " + n.metadata.flags), i("/StemV " + n.metadata.stemV), i("/ItalicAngle " + n.metadata.italicAngle), i("/Ascent " + n.metadata.ascender), i("/Descent " + n.metadata.decender), i("/CapHeight " + n.metadata.capHeight), i(">>"), i("endobj");
                    var g = a();
                    i("<<"), i("/Type /Font"), i("/BaseFont /" + s(n.fontName)), i("/FontDescriptor " + p + " 0 R"), i("/W " + t.API.PDFObject.convert(u)), i("/CIDToGIDMap /Identity"), i("/DW 1000"), i("/Subtype /CIDFontType2"), i("/CIDSystemInfo"), i("<<"), i("/Supplement 0"), i("/Registry (Adobe)"), i("/Ordering (" + n.encoding + ")"), i(">>"), i(">>"), i("endobj"), n.objectNumber = a(), i("<<"), i("/Type /Font"), i("/Subtype /Type0"), i("/ToUnicode " + d + " 0 R"), i("/BaseFont /" + s(n.fontName)), i("/Encoding /" + n.encoding), i("/DescendantFonts [" + g + " 0 R]"), i(">>"), i("endobj"), n.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]);
    e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var n = e.font, i = e.out, a = e.newObject, o = e.putStream, s = e.pdfEscapeWithNeededParanthesis;
                if (n.metadata instanceof t.API.TTFFont && "WinAnsiEncoding" === n.encoding) {
                    for(var u = n.metadata.rawData, c = "", h = 0; h < u.length; h++)c += String.fromCharCode(u[h]);
                    var l = a();
                    o({
                        data: c,
                        addLength1: !0
                    }), i("endobj");
                    var f = a();
                    o({
                        data: r(n.metadata.toUnicode),
                        addLength1: !0
                    }), i("endobj");
                    var d = a();
                    i("<<"), i("/Descent " + n.metadata.decender), i("/CapHeight " + n.metadata.capHeight), i("/StemV " + n.metadata.stemV), i("/Type /FontDescriptor"), i("/FontFile2 " + l + " 0 R"), i("/Flags 96"), i("/FontBBox " + t.API.PDFObject.convert(n.metadata.bbox)), i("/FontName /" + s(n.fontName)), i("/ItalicAngle " + n.metadata.italicAngle), i("/Ascent " + n.metadata.ascender), i(">>"), i("endobj"), n.objectNumber = a();
                    for(var p = 0; p < n.metadata.hmtx.widths.length; p++)n.metadata.hmtx.widths[p] = parseInt(n.metadata.hmtx.widths[p] * (1e3 / n.metadata.head.unitsPerEm));
                    i("<</Subtype/TrueType/Type/Font/ToUnicode " + f + " 0 R/BaseFont/" + n.fontName + "/FontDescriptor " + d + " 0 R/Encoding/" + n.encoding + " /FirstChar 29 /LastChar 255 /Widths " + t.API.PDFObject.convert(n.metadata.hmtx.widths) + ">>"), i("endobj"), n.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]);
    var i = function(t) {
        var e, r = t.text || "", i = t.x, a = t.y, o = t.options || {}, s = t.mutex || {}, u = s.pdfEscape, c = s.activeFontKey, h = s.fonts, l = c, f = "", d = 0, p = "", g = h[l].encoding;
        if ("Identity-H" !== h[l].encoding) return {
            text: r,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
        for(p = r, l = c, Array.isArray(r) && (p = r[0]), d = 0; d < p.length; d += 1)h[l].metadata.hasOwnProperty("cmap") && (e = h[l].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]), e || p[d].charCodeAt(0) < 256 && h[l].metadata.hasOwnProperty("Unicode") ? f += p[d] : f += "";
        var m = "";
        return parseInt(l.slice(1)) < 14 || "WinAnsiEncoding" === g ? m = u(f, l).split("").map(function(t) {
            return t.charCodeAt(0).toString(16);
        }).join("") : "Identity-H" === g && (m = n(f, h[l])), s.isHex = !0, {
            text: m,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
    };
    e.events.push([
        "postProcessText",
        function(t) {
            var e = t.text || "", n = [], r = {
                text: e,
                x: t.x,
                y: t.y,
                options: t.options,
                mutex: t.mutex
            };
            if (Array.isArray(e)) {
                var a = 0;
                for(a = 0; a < e.length; a += 1)Array.isArray(e[a]) && 3 === e[a].length ? n.push([
                    i(Object.assign({}, r, {
                        text: e[a][0]
                    })).text,
                    e[a][1],
                    e[a][2]
                ]) : n.push(i(Object.assign({}, r, {
                    text: e[a]
                })).text);
                t.text = n;
            } else t.text = i(Object.assign({}, r, {
                text: e
            })).text;
        }
    ]);
}($970c7ddf83730f06$export$ba1e2ffc633a60f5), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        return void 0 === this.internal.vFS && (this.internal.vFS = {}), !0;
    };
    t.existsFileInVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t];
    }, t.addFileToVFS = function(t, n) {
        return e.call(this), this.internal.vFS[t] = n, this;
    }, t.getFileFromVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t] ? this.internal.vFS[t] : null;
    };
}($970c7ddf83730f06$export$ba1e2ffc633a60f5.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */ function(t) {
    t.__bidiEngine__ = t.prototype.__bidiEngine__ = function(t) {
        var n, r, i, a, o, s, u, c = e, h = [
            [
                0,
                3,
                0,
                1,
                0,
                0,
                0
            ],
            [
                0,
                3,
                0,
                1,
                2,
                2,
                0
            ],
            [
                0,
                3,
                0,
                17,
                2,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                1,
                0
            ],
            [
                0,
                3,
                21,
                21,
                4,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                2,
                0
            ]
        ], l = [
            [
                2,
                0,
                1,
                1,
                0,
                1,
                0
            ],
            [
                2,
                0,
                1,
                1,
                0,
                2,
                0
            ],
            [
                2,
                0,
                2,
                1,
                3,
                2,
                0
            ],
            [
                2,
                0,
                2,
                33,
                3,
                1,
                1
            ]
        ], f = {
            L: 0,
            R: 1,
            EN: 2,
            AN: 3,
            N: 4,
            B: 5,
            S: 6
        }, d = {
            0: 0,
            5: 1,
            6: 2,
            7: 3,
            32: 4,
            251: 5,
            254: 6,
            255: 7
        }, p = [
            "(",
            ")",
            "(",
            "<",
            ">",
            "<",
            "[",
            "]",
            "[",
            "{",
            "}",
            "{",
            "\xab",
            "\xbb",
            "\xab",
            "\u2039",
            "\u203A",
            "\u2039",
            "\u2045",
            "\u2046",
            "\u2045",
            "\u207D",
            "\u207E",
            "\u207D",
            "\u208D",
            "\u208E",
            "\u208D",
            "\u2264",
            "\u2265",
            "\u2264",
            "\u2329",
            "\u232A",
            "\u2329",
            "\uFE59",
            "\uFE5A",
            "\uFE59",
            "\uFE5B",
            "\uFE5C",
            "\uFE5B",
            "\uFE5D",
            "\uFE5E",
            "\uFE5D",
            "\uFE64",
            "\uFE65",
            "\uFE64"
        ], g = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), m = !1, v = 0;
        this.__bidiEngine__ = {};
        var b = function(t) {
            var e = t.charCodeAt(), n = e >> 8, r = d[n];
            return void 0 !== r ? c[256 * r + (255 & e)] : 252 === n || 253 === n ? "AL" : g.test(n) ? "L" : 8 === n ? "R" : "N";
        }, y = function(t) {
            for(var e, n = 0; n < t.length; n++){
                if ("L" === (e = b(t.charAt(n)))) return !1;
                if ("R" === e) return !0;
            }
            return !1;
        }, w = function(t, e, o, s) {
            var u, c, h, l, f = e[s];
            switch(f){
                case "L":
                case "R":
                    m = !1;
                    break;
                case "N":
                case "AN":
                    break;
                case "EN":
                    m && (f = "AN");
                    break;
                case "AL":
                    m = !0, f = "R";
                    break;
                case "WS":
                    f = "N";
                    break;
                case "CS":
                    s < 1 || s + 1 >= e.length || "EN" !== (u = o[s - 1]) && "AN" !== u || "EN" !== (c = e[s + 1]) && "AN" !== c ? f = "N" : m && (c = "AN"), f = c === u ? c : "N";
                    break;
                case "ES":
                    f = "EN" === (u = s > 0 ? o[s - 1] : "B") && s + 1 < e.length && "EN" === e[s + 1] ? "EN" : "N";
                    break;
                case "ET":
                    if (s > 0 && "EN" === o[s - 1]) {
                        f = "EN";
                        break;
                    }
                    if (m) {
                        f = "N";
                        break;
                    }
                    for(h = s + 1, l = e.length; h < l && "ET" === e[h];)h++;
                    f = h < l && "EN" === e[h] ? "EN" : "N";
                    break;
                case "NSM":
                    if (i && !a) {
                        for(l = e.length, h = s + 1; h < l && "NSM" === e[h];)h++;
                        if (h < l) {
                            var d = t[s], p = d >= 1425 && d <= 2303 || 64286 === d;
                            if (u = e[h], p && ("R" === u || "AL" === u)) {
                                f = "R";
                                break;
                            }
                        }
                    }
                    f = s < 1 || "B" === (u = e[s - 1]) ? "N" : o[s - 1];
                    break;
                case "B":
                    m = !1, n = !0, f = v;
                    break;
                case "S":
                    r = !0, f = "N";
                    break;
                case "LRE":
                case "RLE":
                case "LRO":
                case "RLO":
                case "PDF":
                    m = !1;
                    break;
                case "BN":
                    f = "N";
            }
            return f;
        }, N = function(t, e, n) {
            var r = t.split("");
            return n && L(r, n, {
                hiLevel: v
            }), r.reverse(), e && e.reverse(), r.join("");
        }, L = function(t, e, i) {
            var a, o, s, u, c, d = -1, p = t.length, g = 0, y = [], N = v ? l : h, L = [];
            for(m = !1, n = !1, r = !1, o = 0; o < p; o++)L[o] = b(t[o]);
            for(s = 0; s < p; s++){
                if (c = g, y[s] = w(t, L, y, s), a = 240 & (g = N[c][f[y[s]]]), g &= 15, e[s] = u = N[g][5], a > 0) {
                    if (16 === a) {
                        for(o = d; o < s; o++)e[o] = 1;
                        d = -1;
                    } else d = -1;
                }
                if (N[g][6]) -1 === d && (d = s);
                else if (d > -1) {
                    for(o = d; o < s; o++)e[o] = u;
                    d = -1;
                }
                "B" === L[s] && (e[s] = 0), i.hiLevel |= u;
            }
            r && function(t, e, n) {
                for(var r = 0; r < n; r++)if ("S" === t[r]) {
                    e[r] = v;
                    for(var i = r - 1; i >= 0 && "WS" === t[i]; i--)e[i] = v;
                }
            }(L, e, p);
        }, x = function(t, e, r, i, a) {
            if (!(a.hiLevel < t)) {
                if (1 === t && 1 === v && !n) return e.reverse(), void (r && r.reverse());
                for(var o, s, u, c, h = e.length, l = 0; l < h;){
                    if (i[l] >= t) {
                        for(u = l + 1; u < h && i[u] >= t;)u++;
                        for(c = l, s = u - 1; c < s; c++, s--)o = e[c], e[c] = e[s], e[s] = o, r && (o = r[c], r[c] = r[s], r[s] = o);
                        l = u;
                    }
                    l++;
                }
            }
        }, A = function(t, e, n) {
            var r = t.split(""), i = {
                hiLevel: v
            };
            return n || (n = []), L(r, n, i), function(t, e, n) {
                if (0 !== n.hiLevel && u) for(var r, i = 0; i < t.length; i++)1 === e[i] && (r = p.indexOf(t[i])) >= 0 && (t[i] = p[r + 1]);
            }(r, n, i), x(2, r, e, n, i), x(1, r, e, n, i), r.join("");
        };
        return this.__bidiEngine__.doBidiReorder = function(t, e, n) {
            if (function(t, e) {
                if (e) for(var n = 0; n < t.length; n++)e[n] = n;
                void 0 === a && (a = y(t)), void 0 === s && (s = y(t));
            }(t, e), i || !o || s) {
                if (i && o && a ^ s) v = a ? 1 : 0, t = N(t, e, n);
                else if (!i && o && s) v = a ? 1 : 0, t = A(t, e, n), t = N(t, e);
                else if (!i || a || o || s) {
                    if (i && !o && a ^ s) t = N(t, e), a ? (v = 0, t = A(t, e, n)) : (v = 1, t = A(t, e, n), t = N(t, e));
                    else if (i && a && !o && s) v = 1, t = A(t, e, n), t = N(t, e);
                    else if (!i && !o && a ^ s) {
                        var r = u;
                        a ? (v = 1, t = A(t, e, n), v = 0, u = !1, t = A(t, e, n), u = r) : (v = 0, t = A(t, e, n), t = N(t, e), v = 1, u = !1, t = A(t, e, n), u = r, t = N(t, e));
                    }
                } else v = 0, t = A(t, e, n);
            } else v = a ? 1 : 0, t = A(t, e, n);
            return t;
        }, this.__bidiEngine__.setOptions = function(t) {
            t && (i = t.isInputVisual, o = t.isOutputVisual, a = t.isInputRtl, s = t.isOutputRtl, u = t.isSymmetricSwapping);
        }, this.__bidiEngine__.setOptions(t), this.__bidiEngine__;
    };
    var e = [
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "S",
        "B",
        "S",
        "WS",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "B",
        "B",
        "S",
        "WS",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "CS",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "L",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "ET",
        "ET",
        "EN",
        "EN",
        "N",
        "L",
        "N",
        "N",
        "N",
        "EN",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "N",
        "N",
        "AL",
        "ET",
        "ET",
        "AL",
        "CS",
        "AL",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "ET",
        "AN",
        "AN",
        "AL",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "BN",
        "BN",
        "BN",
        "L",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "B",
        "LRE",
        "RLE",
        "PDF",
        "LRO",
        "RLO",
        "CS",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "N",
        "LRI",
        "RLI",
        "FSI",
        "PDI",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "EN",
        "L",
        "N",
        "N",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "L",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "NSM",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "ES",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "CS",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "N",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N"
    ], n = new t.__bidiEngine__({
        isInputVisual: !0
    });
    t.API.events.push([
        "postProcessText",
        function(t) {
            var e = t.text, r = (t.x, t.y, t.options || {}), i = (t.mutex, r.lang, []);
            if (r.isInputVisual = "boolean" != typeof r.isInputVisual || r.isInputVisual, n.setOptions(r), "[object Array]" === Object.prototype.toString.call(e)) {
                var a = 0;
                for(i = [], a = 0; a < e.length; a += 1)"[object Array]" === Object.prototype.toString.call(e[a]) ? i.push([
                    n.doBidiReorder(e[a][0]),
                    e[a][1],
                    e[a][2]
                ]) : i.push([
                    n.doBidiReorder(e[a])
                ]);
                t.text = i;
            } else t.text = n.doBidiReorder(e);
            n.setOptions({
                isInputVisual: !0
            });
        }
    ]);
}($970c7ddf83730f06$export$ba1e2ffc633a60f5), $970c7ddf83730f06$export$ba1e2ffc633a60f5.API.TTFFont = function() {
    function t(t) {
        var e;
        if (this.rawData = t, e = this.contents = new $970c7ddf83730f06$var$Rt(t), this.contents.pos = 4, "ttcf" === e.readString(4)) throw new Error("TTCF not supported.");
        e.pos = 0, this.parse(), this.subset = new $970c7ddf83730f06$var$re(this), this.registerTTF();
    }
    return t.open = function(e) {
        return new t(e);
    }, t.prototype.parse = function() {
        return this.directory = new $970c7ddf83730f06$var$Tt(this.contents), this.head = new $970c7ddf83730f06$var$zt(this), this.name = new $970c7ddf83730f06$var$Xt(this), this.cmap = new $970c7ddf83730f06$var$Wt(this), this.toUnicode = {}, this.hhea = new $970c7ddf83730f06$var$Vt(this), this.maxp = new $970c7ddf83730f06$var$Kt(this), this.hmtx = new $970c7ddf83730f06$var$Zt(this), this.post = new $970c7ddf83730f06$var$Yt(this), this.os2 = new $970c7ddf83730f06$var$Gt(this), this.loca = new $970c7ddf83730f06$var$ne(this), this.glyf = new $970c7ddf83730f06$var$Qt(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [
            this.head.xMin,
            this.head.yMin,
            this.head.xMax,
            this.head.yMax
        ];
    }, t.prototype.registerTTF = function() {
        var t, e, n, r, i;
        if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
            var e, n, r, i;
            for(i = [], e = 0, n = (r = this.bbox).length; e < n; e++)t = r[e], i.push(Math.round(t * this.scaleFactor));
            return i;
        }).call(this), this.stemV = 0, this.post.exists ? (n = 255 & (r = this.post.italic_angle), 0 != (32768 & (e = r >> 16)) && (e = -(1 + (65535 ^ e))), this.italicAngle = +(e + "." + n)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (i = this.familyClass) || 2 === i || 3 === i || 4 === i || 5 === i || 7 === i, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
    }, t.prototype.characterToGlyph = function(t) {
        var e;
        return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
    }, t.prototype.widthOfGlyph = function(t) {
        var e;
        return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
    }, t.prototype.widthOfString = function(t, e, n) {
        var r, i, a, o;
        for(a = 0, i = 0, o = (t = "" + t).length; 0 <= o ? i < o : i > o; i = 0 <= o ? ++i : --i)r = t.charCodeAt(i), a += this.widthOfGlyph(this.characterToGlyph(r)) + n * (1e3 / e) || 0;
        return a * (e / 1e3);
    }, t.prototype.lineHeight = function(t, e) {
        var n;
        return null == e && (e = !1), n = e ? this.lineGap : 0, (this.ascender + n - this.decender) / 1e3 * t;
    }, t;
}();
var $970c7ddf83730f06$var$qt, $970c7ddf83730f06$var$Rt = function() {
    function t(t) {
        this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
    }
    return t.prototype.readByte = function() {
        return this.data[this.pos++];
    }, t.prototype.writeByte = function(t) {
        return this.data[this.pos++] = t;
    }, t.prototype.readUInt32 = function() {
        return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
    }, t.prototype.writeUInt32 = function(t) {
        return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt32 = function() {
        var t;
        return (t = this.readUInt32()) >= 2147483648 ? t - 4294967296 : t;
    }, t.prototype.writeInt32 = function(t) {
        return t < 0 && (t += 4294967296), this.writeUInt32(t);
    }, t.prototype.readUInt16 = function() {
        return this.readByte() << 8 | this.readByte();
    }, t.prototype.writeUInt16 = function(t) {
        return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt16 = function() {
        var t;
        return (t = this.readUInt16()) >= 32768 ? t - 65536 : t;
    }, t.prototype.writeInt16 = function(t) {
        return t < 0 && (t += 65536), this.writeUInt16(t);
    }, t.prototype.readString = function(t) {
        var e, n;
        for(n = [], e = 0; 0 <= t ? e < t : e > t; e = 0 <= t ? ++e : --e)n[e] = String.fromCharCode(this.readByte());
        return n.join("");
    }, t.prototype.writeString = function(t) {
        var e, n, r;
        for(r = [], e = 0, n = t.length; 0 <= n ? e < n : e > n; e = 0 <= n ? ++e : --e)r.push(this.writeByte(t.charCodeAt(e)));
        return r;
    }, t.prototype.readShort = function() {
        return this.readInt16();
    }, t.prototype.writeShort = function(t) {
        return this.writeInt16(t);
    }, t.prototype.readLongLong = function() {
        var t, e, n, r, i, a, o, s;
        return t = this.readByte(), e = this.readByte(), n = this.readByte(), r = this.readByte(), i = this.readByte(), a = this.readByte(), o = this.readByte(), s = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ n) + 4294967296 * (255 ^ r) + 16777216 * (255 ^ i) + 65536 * (255 ^ a) + 256 * (255 ^ o) + (255 ^ s) + 1) : 72057594037927940 * t + 281474976710656 * e + 1099511627776 * n + 4294967296 * r + 16777216 * i + 65536 * a + 256 * o + s;
    }, t.prototype.writeLongLong = function(t) {
        var e, n;
        return e = Math.floor(t / 4294967296), n = 4294967295 & t, this.writeByte(e >> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e), this.writeByte(n >> 24 & 255), this.writeByte(n >> 16 & 255), this.writeByte(n >> 8 & 255), this.writeByte(255 & n);
    }, t.prototype.readInt = function() {
        return this.readInt32();
    }, t.prototype.writeInt = function(t) {
        return this.writeInt32(t);
    }, t.prototype.read = function(t) {
        var e, n;
        for(e = [], n = 0; 0 <= t ? n < t : n > t; n = 0 <= t ? ++n : --n)e.push(this.readByte());
        return e;
    }, t.prototype.write = function(t) {
        var e, n, r, i;
        for(i = [], n = 0, r = t.length; n < r; n++)e = t[n], i.push(this.writeByte(e));
        return i;
    }, t;
}(), $970c7ddf83730f06$var$Tt = function() {
    var t;
    function e(t) {
        var e, n, r;
        for(this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, n = 0, r = this.tableCount; 0 <= r ? n < r : n > r; n = 0 <= r ? ++n : --n)e = {
            tag: t.readString(4),
            checksum: t.readInt(),
            offset: t.readInt(),
            length: t.readInt()
        }, this.tables[e.tag] = e;
    }
    return e.prototype.encode = function(e) {
        var n, r, i, a, o, s, u, c, h, l, f, d, p;
        for(p in f = Object.keys(e).length, s = Math.log(2), h = 16 * Math.floor(Math.log(f) / s), a = Math.floor(h / s), c = 16 * f - h, (r = new $970c7ddf83730f06$var$Rt).writeInt(this.scalarType), r.writeShort(f), r.writeShort(h), r.writeShort(a), r.writeShort(c), i = 16 * f, u = r.pos + i, o = null, d = [], e)for(l = e[p], r.writeString(p), r.writeInt(t(l)), r.writeInt(u), r.writeInt(l.length), d = d.concat(l), "head" === p && (o = u), u += l.length; u % 4;)d.push(0), u++;
        return r.write(d), n = 2981146554 - t(r.data), r.pos = o + 8, r.writeUInt32(n), r.data;
    }, t = function(t) {
        var e, n, r, i;
        for(t = $970c7ddf83730f06$var$$t.call(t); t.length % 4;)t.push(0);
        for(r = new $970c7ddf83730f06$var$Rt(t), n = 0, e = 0, i = t.length; e < i; e = e += 4)n += r.readUInt32();
        return 4294967295 & n;
    }, e;
}(), $970c7ddf83730f06$var$Dt = {}.hasOwnProperty, $970c7ddf83730f06$var$Ut = function(t, e) {
    for(var n in e)$970c7ddf83730f06$var$Dt.call(e, n) && (t[n] = e[n]);
    function r() {
        this.constructor = t;
    }
    return r.prototype = e.prototype, t.prototype = new r, t.__super__ = e.prototype, t;
};
$970c7ddf83730f06$var$qt = function() {
    function t(t) {
        var e;
        this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
    }
    return t.prototype.parse = function() {}, t.prototype.encode = function() {}, t.prototype.raw = function() {
        return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
    }, t;
}();
var $970c7ddf83730f06$var$zt = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $970c7ddf83730f06$var$Ut(e, $970c7ddf83730f06$var$qt), e.prototype.tag = "head", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
    }, e.prototype.encode = function(t) {
        var e;
        return (e = new $970c7ddf83730f06$var$Rt).writeInt(this.version), e.writeInt(this.revision), e.writeInt(this.checkSumAdjustment), e.writeInt(this.magicNumber), e.writeShort(this.flags), e.writeShort(this.unitsPerEm), e.writeLongLong(this.created), e.writeLongLong(this.modified), e.writeShort(this.xMin), e.writeShort(this.yMin), e.writeShort(this.xMax), e.writeShort(this.yMax), e.writeShort(this.macStyle), e.writeShort(this.lowestRecPPEM), e.writeShort(this.fontDirectionHint), e.writeShort(t), e.writeShort(this.glyphDataFormat), e.data;
    }, e;
}(), $970c7ddf83730f06$var$Ht = function() {
    function t(t, e) {
        var n, r, i, a, o, s, u, c, h, l, f, d, p, g, m, v, b;
        switch(this.platformID = t.readUInt16(), this.encodingID = t.readShort(), this.offset = e + t.readInt(), h = t.pos, t.pos = this.offset, this.format = t.readUInt16(), this.length = t.readUInt16(), this.language = t.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format){
            case 0:
                for(s = 0; s < 256; ++s)this.codeMap[s] = t.readByte();
                break;
            case 4:
                for(f = t.readUInt16(), l = f / 2, t.pos += 6, i = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), t.pos += 2, p = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), u = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), c = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), r = (this.length - t.pos + this.offset) / 2, o = function() {
                    var e, n;
                    for(n = [], s = e = 0; 0 <= r ? e < r : e > r; s = 0 <= r ? ++e : --e)n.push(t.readUInt16());
                    return n;
                }(), s = m = 0, b = i.length; m < b; s = ++m)for(g = i[s], n = v = d = p[s]; d <= g ? v <= g : v >= g; n = d <= g ? ++v : --v)0 === c[s] ? a = n + u[s] : 0 !== (a = o[c[s] / 2 + (n - d) - (l - s)] || 0) && (a += u[s]), this.codeMap[n] = 65535 & a;
        }
        t.pos = h;
    }
    return t.encode = function(t, e) {
        var n, r, i, a, o, s, u, c, h, l, f, d, p, g, m, v, b, y, w, N, L, x, A, _, S, P, k, F, I, C, j, B, O, M, E, q, R, T, D, U, z, H, W, V, G, Y;
        switch(F = new $970c7ddf83730f06$var$Rt, a = Object.keys(t).sort(function(t, e) {
            return t - e;
        }), e){
            case "macroman":
                for(p = 0, g = function() {
                    var t = [];
                    for(d = 0; d < 256; ++d)t.push(0);
                    return t;
                }(), v = {
                    0: 0
                }, i = {}, I = 0, O = a.length; I < O; I++)null == v[W = t[r = a[I]]] && (v[W] = ++p), i[r] = {
                    old: t[r],
                    new: v[t[r]]
                }, g[r] = v[t[r]];
                return F.writeUInt16(1), F.writeUInt16(0), F.writeUInt32(12), F.writeUInt16(0), F.writeUInt16(262), F.writeUInt16(0), F.write(g), {
                    charMap: i,
                    subtable: F.data,
                    maxGlyphID: p + 1
                };
            case "unicode":
                for(P = [], h = [], b = 0, v = {}, n = {}, m = u = null, C = 0, M = a.length; C < M; C++)null == v[w = t[r = a[C]]] && (v[w] = ++b), n[r] = {
                    old: w,
                    new: v[w]
                }, o = v[w] - r, null != m && o === u || (m && h.push(m), P.push(r), u = o), m = r;
                for(m && h.push(m), h.push(65535), P.push(65535), _ = 2 * (A = P.length), x = 2 * Math.pow(Math.log(A) / Math.LN2, 2), l = Math.log(x / 2) / Math.LN2, L = 2 * A - x, s = [], N = [], f = [], d = j = 0, E = P.length; j < E; d = ++j){
                    if (S = P[d], c = h[d], 65535 === S) {
                        s.push(0), N.push(0);
                        break;
                    }
                    if (S - (k = n[S].new) >= 32768) for(s.push(0), N.push(2 * (f.length + A - d)), r = B = S; S <= c ? B <= c : B >= c; r = S <= c ? ++B : --B)f.push(n[r].new);
                    else s.push(k - S), N.push(0);
                }
                for(F.writeUInt16(3), F.writeUInt16(1), F.writeUInt32(12), F.writeUInt16(4), F.writeUInt16(16 + 8 * A + 2 * f.length), F.writeUInt16(0), F.writeUInt16(_), F.writeUInt16(x), F.writeUInt16(l), F.writeUInt16(L), z = 0, q = h.length; z < q; z++)r = h[z], F.writeUInt16(r);
                for(F.writeUInt16(0), H = 0, R = P.length; H < R; H++)r = P[H], F.writeUInt16(r);
                for(V = 0, T = s.length; V < T; V++)o = s[V], F.writeUInt16(o);
                for(G = 0, D = N.length; G < D; G++)y = N[G], F.writeUInt16(y);
                for(Y = 0, U = f.length; Y < U; Y++)p = f[Y], F.writeUInt16(p);
                return {
                    charMap: n,
                    subtable: F.data,
                    maxGlyphID: b + 1
                };
        }
    }, t;
}(), $970c7ddf83730f06$var$Wt = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $970c7ddf83730f06$var$Ut(e, $970c7ddf83730f06$var$qt), e.prototype.tag = "cmap", e.prototype.parse = function(t) {
        var e, n, r;
        for(t.pos = this.offset, this.version = t.readUInt16(), r = t.readUInt16(), this.tables = [], this.unicode = null, n = 0; 0 <= r ? n < r : n > r; n = 0 <= r ? ++n : --n)e = new $970c7ddf83730f06$var$Ht(t, this.offset), this.tables.push(e), e.isUnicode && null == this.unicode && (this.unicode = e);
        return !0;
    }, e.encode = function(t, e) {
        var n, r;
        return null == e && (e = "macroman"), n = $970c7ddf83730f06$var$Ht.encode(t, e), (r = new $970c7ddf83730f06$var$Rt).writeUInt16(0), r.writeUInt16(1), n.table = r.data.concat(n.subtable), n;
    }, e;
}(), $970c7ddf83730f06$var$Vt = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $970c7ddf83730f06$var$Ut(e, $970c7ddf83730f06$var$qt), e.prototype.tag = "hhea", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
    }, e;
}(), $970c7ddf83730f06$var$Gt = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $970c7ddf83730f06$var$Ut(e, $970c7ddf83730f06$var$qt), e.prototype.tag = "OS/2", e.prototype.parse = function(t) {
        if (t.pos = this.offset, this.version = t.readUInt16(), this.averageCharWidth = t.readShort(), this.weightClass = t.readUInt16(), this.widthClass = t.readUInt16(), this.type = t.readShort(), this.ySubscriptXSize = t.readShort(), this.ySubscriptYSize = t.readShort(), this.ySubscriptXOffset = t.readShort(), this.ySubscriptYOffset = t.readShort(), this.ySuperscriptXSize = t.readShort(), this.ySuperscriptYSize = t.readShort(), this.ySuperscriptXOffset = t.readShort(), this.ySuperscriptYOffset = t.readShort(), this.yStrikeoutSize = t.readShort(), this.yStrikeoutPosition = t.readShort(), this.familyClass = t.readShort(), this.panose = function() {
            var e, n;
            for(n = [], e = 0; e < 10; ++e)n.push(t.readByte());
            return n;
        }(), this.charRange = function() {
            var e, n;
            for(n = [], e = 0; e < 4; ++e)n.push(t.readInt());
            return n;
        }(), this.vendorID = t.readString(4), this.selection = t.readShort(), this.firstCharIndex = t.readShort(), this.lastCharIndex = t.readShort(), this.version > 0 && (this.ascent = t.readShort(), this.descent = t.readShort(), this.lineGap = t.readShort(), this.winAscent = t.readShort(), this.winDescent = t.readShort(), this.codePageRange = function() {
            var e, n;
            for(n = [], e = 0; e < 2; e = ++e)n.push(t.readInt());
            return n;
        }(), this.version > 1)) return this.xHeight = t.readShort(), this.capHeight = t.readShort(), this.defaultChar = t.readShort(), this.breakChar = t.readShort(), this.maxContext = t.readShort();
    }, e;
}(), $970c7ddf83730f06$var$Yt = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $970c7ddf83730f06$var$Ut(e, $970c7ddf83730f06$var$qt), e.prototype.tag = "post", e.prototype.parse = function(t) {
        var e, n, r;
        switch(t.pos = this.offset, this.format = t.readInt(), this.italicAngle = t.readInt(), this.underlinePosition = t.readShort(), this.underlineThickness = t.readShort(), this.isFixedPitch = t.readInt(), this.minMemType42 = t.readInt(), this.maxMemType42 = t.readInt(), this.minMemType1 = t.readInt(), this.maxMemType1 = t.readInt(), this.format){
            case 65536:
                break;
            case 131072:
                var i;
                for(n = t.readUInt16(), this.glyphNameIndex = [], i = 0; 0 <= n ? i < n : i > n; i = 0 <= n ? ++i : --i)this.glyphNameIndex.push(t.readUInt16());
                for(this.names = [], r = []; t.pos < this.offset + this.length;)e = t.readByte(), r.push(this.names.push(t.readString(e)));
                return r;
            case 151552:
                return n = t.readUInt16(), this.offsets = t.read(n);
            case 196608:
                break;
            case 262144:
                return this.map = (function() {
                    var e, n, r;
                    for(r = [], i = e = 0, n = this.file.maxp.numGlyphs; 0 <= n ? e < n : e > n; i = 0 <= n ? ++e : --e)r.push(t.readUInt32());
                    return r;
                }).call(this);
        }
    }, e;
}(), $970c7ddf83730f06$var$Jt = function(t, e) {
    this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
}, $970c7ddf83730f06$var$Xt = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $970c7ddf83730f06$var$Ut(e, $970c7ddf83730f06$var$qt), e.prototype.tag = "name", e.prototype.parse = function(t) {
        var e, n, r, i, a, o, s, u, c, h, l;
        for(t.pos = this.offset, t.readShort(), e = t.readShort(), o = t.readShort(), n = [], i = 0; 0 <= e ? i < e : i > e; i = 0 <= e ? ++i : --i)n.push({
            platformID: t.readShort(),
            encodingID: t.readShort(),
            languageID: t.readShort(),
            nameID: t.readShort(),
            length: t.readShort(),
            offset: this.offset + o + t.readShort()
        });
        for(s = {}, i = c = 0, h = n.length; c < h; i = ++c)r = n[i], t.pos = r.offset, u = t.readString(r.length), a = new $970c7ddf83730f06$var$Jt(u, r), null == s[l = r.nameID] && (s[l] = []), s[r.nameID].push(a);
        this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5];
        try {
            this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        } catch (t) {
            this.postscriptName = s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        }
        return this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
    }, e;
}(), $970c7ddf83730f06$var$Kt = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $970c7ddf83730f06$var$Ut(e, $970c7ddf83730f06$var$qt), e.prototype.tag = "maxp", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
    }, e;
}(), $970c7ddf83730f06$var$Zt = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $970c7ddf83730f06$var$Ut(e, $970c7ddf83730f06$var$qt), e.prototype.tag = "hmtx", e.prototype.parse = function(t) {
        var e, n, r, i, a, o, s;
        for(t.pos = this.offset, this.metrics = [], e = 0, o = this.file.hhea.numberOfMetrics; 0 <= o ? e < o : e > o; e = 0 <= o ? ++e : --e)this.metrics.push({
            advance: t.readUInt16(),
            lsb: t.readInt16()
        });
        for(r = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
            var n, i;
            for(i = [], e = n = 0; 0 <= r ? n < r : n > r; e = 0 <= r ? ++n : --n)i.push(t.readInt16());
            return i;
        }(), this.widths = (function() {
            var t, e, n, r;
            for(r = [], t = 0, e = (n = this.metrics).length; t < e; t++)i = n[t], r.push(i.advance);
            return r;
        }).call(this), n = this.widths[this.widths.length - 1], s = [], e = a = 0; 0 <= r ? a < r : a > r; e = 0 <= r ? ++a : --a)s.push(this.widths.push(n));
        return s;
    }, e.prototype.forGlyph = function(t) {
        return t in this.metrics ? this.metrics[t] : {
            advance: this.metrics[this.metrics.length - 1].advance,
            lsb: this.leftSideBearings[t - this.metrics.length]
        };
    }, e;
}(), $970c7ddf83730f06$var$$t = [].slice, $970c7ddf83730f06$var$Qt = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $970c7ddf83730f06$var$Ut(e, $970c7ddf83730f06$var$qt), e.prototype.tag = "glyf", e.prototype.parse = function() {
        return this.cache = {};
    }, e.prototype.glyphFor = function(t) {
        var e, n, r, i, a, o, s, u, c, h;
        return t in this.cache ? this.cache[t] : (i = this.file.loca, e = this.file.contents, n = i.indexOf(t), 0 === (r = i.lengthOf(t)) ? this.cache[t] = null : (e.pos = this.offset + n, a = (o = new $970c7ddf83730f06$var$Rt(e.read(r))).readShort(), u = o.readShort(), h = o.readShort(), s = o.readShort(), c = o.readShort(), this.cache[t] = -1 === a ? new $970c7ddf83730f06$var$ee(o, u, h, s, c) : new $970c7ddf83730f06$var$te(o, a, u, h, s, c), this.cache[t]));
    }, e.prototype.encode = function(t, e, n) {
        var r, i, a, o, s;
        for(a = [], i = [], o = 0, s = e.length; o < s; o++)r = t[e[o]], i.push(a.length), r && (a = a.concat(r.encode(n)));
        return i.push(a.length), {
            table: a,
            offsets: i
        };
    }, e;
}(), $970c7ddf83730f06$var$te = function() {
    function t(t, e, n, r, i, a) {
        this.raw = t, this.numberOfContours = e, this.xMin = n, this.yMin = r, this.xMax = i, this.yMax = a, this.compound = !1;
    }
    return t.prototype.encode = function() {
        return this.raw.data;
    }, t;
}(), $970c7ddf83730f06$var$ee = function() {
    function t(t, e, n, r, i) {
        var a, o;
        for(this.raw = t, this.xMin = e, this.yMin = n, this.xMax = r, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], a = this.raw; o = a.readShort(), this.glyphOffsets.push(a.pos), this.glyphIDs.push(a.readUInt16()), 32 & o;)a.pos += 1 & o ? 4 : 2, 128 & o ? a.pos += 8 : 64 & o ? a.pos += 4 : 8 & o && (a.pos += 2);
    }
    return t.prototype.encode = function() {
        var t, e, n;
        for(e = new $970c7ddf83730f06$var$Rt($970c7ddf83730f06$var$$t.call(this.raw.data)), t = 0, n = this.glyphIDs.length; t < n; ++t)e.pos = this.glyphOffsets[t];
        return e.data;
    }, t;
}(), $970c7ddf83730f06$var$ne = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $970c7ddf83730f06$var$Ut(e, $970c7ddf83730f06$var$qt), e.prototype.tag = "loca", e.prototype.parse = function(t) {
        var e, n;
        return t.pos = this.offset, e = this.file.head.indexToLocFormat, this.offsets = 0 === e ? (function() {
            var e, r;
            for(r = [], n = 0, e = this.length; n < e; n += 2)r.push(2 * t.readUInt16());
            return r;
        }).call(this) : (function() {
            var e, r;
            for(r = [], n = 0, e = this.length; n < e; n += 4)r.push(t.readUInt32());
            return r;
        }).call(this);
    }, e.prototype.indexOf = function(t) {
        return this.offsets[t];
    }, e.prototype.lengthOf = function(t) {
        return this.offsets[t + 1] - this.offsets[t];
    }, e.prototype.encode = function(t, e) {
        for(var n = new Uint32Array(this.offsets.length), r = 0, i = 0, a = 0; a < n.length; ++a)if (n[a] = r, i < e.length && e[i] == a) {
            ++i, n[a] = r;
            var o = this.offsets[a], s = this.offsets[a + 1] - o;
            s > 0 && (r += s);
        }
        for(var u = new Array(4 * n.length), c = 0; c < n.length; ++c)u[4 * c + 3] = 255 & n[c], u[4 * c + 2] = (65280 & n[c]) >> 8, u[4 * c + 1] = (16711680 & n[c]) >> 16, u[4 * c] = (4278190080 & n[c]) >> 24;
        return u;
    }, e;
}(), $970c7ddf83730f06$var$re = function() {
    function t(t) {
        this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
    }
    return t.prototype.generateCmap = function() {
        var t, e, n, r, i;
        for(e in r = this.font.cmap.tables[0].codeMap, t = {}, i = this.subset)n = i[e], t[e] = r[n];
        return t;
    }, t.prototype.glyphsFor = function(t) {
        var e, n, r, i, a, o, s;
        for(r = {}, a = 0, o = t.length; a < o; a++)r[i = t[a]] = this.font.glyf.glyphFor(i);
        for(i in e = [], r)(null != (n = r[i]) ? n.compound : void 0) && e.push.apply(e, n.glyphIDs);
        if (e.length > 0) for(i in s = this.glyphsFor(e))n = s[i], r[i] = n;
        return r;
    }, t.prototype.encode = function(t, e) {
        var n, r, i, a, o, s, u, c, h, l, f, d, p, g, m;
        for(r in n = $970c7ddf83730f06$var$Wt.encode(this.generateCmap(), "unicode"), a = this.glyphsFor(t), f = {
            0: 0
        }, m = n.charMap)f[(s = m[r]).old] = s.new;
        for(d in l = n.maxGlyphID, a)d in f || (f[d] = l++);
        return c = function(t) {
            var e, n;
            for(e in n = {}, t)n[t[e]] = e;
            return n;
        }(f), h = Object.keys(c).sort(function(t, e) {
            return t - e;
        }), p = function() {
            var t, e, n;
            for(n = [], t = 0, e = h.length; t < e; t++)o = h[t], n.push(c[o]);
            return n;
        }(), i = this.font.glyf.encode(a, p, f), u = this.font.loca.encode(i.offsets, p), g = {
            cmap: this.font.cmap.raw(),
            glyf: i.table,
            loca: u,
            hmtx: this.font.hmtx.raw(),
            hhea: this.font.hhea.raw(),
            maxp: this.font.maxp.raw(),
            post: this.font.post.raw(),
            name: this.font.name.raw(),
            head: this.font.head.encode(e)
        }, this.font.os2.exists && (g["OS/2"] = this.font.os2.raw()), this.font.directory.encode(g);
    }, t;
}();
$970c7ddf83730f06$export$ba1e2ffc633a60f5.API.PDFObject = function() {
    var t;
    function e() {}
    return t = function(t, e) {
        return (Array(e + 1).join("0") + t).slice(-e);
    }, e.convert = function(n) {
        var r, i, a, o;
        if (Array.isArray(n)) return "[" + (function() {
            var t, i, a;
            for(a = [], t = 0, i = n.length; t < i; t++)r = n[t], a.push(e.convert(r));
            return a;
        })().join(" ") + "]";
        if ("string" == typeof n) return "/" + n;
        if (null != n ? n.isString : void 0) return "(" + n + ")";
        if (n instanceof Date) return "(D:" + t(n.getUTCFullYear(), 4) + t(n.getUTCMonth(), 2) + t(n.getUTCDate(), 2) + t(n.getUTCHours(), 2) + t(n.getUTCMinutes(), 2) + t(n.getUTCSeconds(), 2) + "Z)";
        if ("[object Object]" === ({}).toString.call(n)) {
            for(i in a = [
                "<<"
            ], n)o = n[i], a.push("/" + i + " " + e.convert(o));
            return a.push(">>"), a.join("\n");
        }
        return "" + n;
    }, e;
}(), /**
 * @license
 * Copyright (c) 2012 chick307 <chick307@gmail.com>
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t, e) {
    t.API.adler32cs = function() {
        var t = "function" == typeof ArrayBuffer && "function" == typeof Uint8Array, e = null, n = function() {
            if (!t) return function() {
                return !1;
            };
            try {
                var n = {};
                "function" == typeof n.Buffer && (e = n.Buffer);
            } catch (t) {}
            return function(t) {
                return t instanceof ArrayBuffer || null !== e && t instanceof e;
            };
        }(), r = null !== e ? function(t) {
            return new e(t, "utf8").toString("binary");
        } : function(t) {
            return unescape(encodeURIComponent(t));
        }, i = function(t, e) {
            for(var n = 65535 & t, r = t >>> 16, i = 0, a = e.length; i < a; i++)r = (r + (n = (n + (255 & e.charCodeAt(i))) % 65521)) % 65521;
            return (r << 16 | n) >>> 0;
        }, a = function(t, e) {
            for(var n = 65535 & t, r = t >>> 16, i = 0, a = e.length; i < a; i++)r = (r + (n = (n + e[i]) % 65521)) % 65521;
            return (r << 16 | n) >>> 0;
        }, o = {}, s = o.Adler32 = (l = function(t) {
            if (!(this instanceof l)) throw new TypeError("Constructor cannot called be as a function.");
            if (!isFinite(t = null === t ? 1 : +t)) throw new Error("First arguments needs to be a finite number.");
            this.checksum = t >>> 0;
        }, f = l.prototype = {}, f.constructor = l, l.from = ((u = function(t) {
            if (!(this instanceof l)) throw new TypeError("Constructor cannot called be as a function.");
            if (null === t) throw new Error("First argument needs to be a string.");
            this.checksum = i(1, t.toString());
        }).prototype = f, u), l.fromUtf8 = ((c = function(t) {
            if (!(this instanceof l)) throw new TypeError("Constructor cannot called be as a function.");
            if (null === t) throw new Error("First argument needs to be a string.");
            var e = r(t.toString());
            this.checksum = i(1, e);
        }).prototype = f, c), t && (l.fromBuffer = ((h = function(t) {
            if (!(this instanceof l)) throw new TypeError("Constructor cannot called be as a function.");
            if (!n(t)) throw new Error("First argument needs to be ArrayBuffer.");
            var e = new Uint8Array(t);
            return this.checksum = a(1, e);
        }).prototype = f, h)), f.update = function(t) {
            if (null === t) throw new Error("First argument needs to be a string.");
            return t = t.toString(), this.checksum = i(this.checksum, t);
        }, f.updateUtf8 = function(t) {
            if (null === t) throw new Error("First argument needs to be a string.");
            var e = r(t.toString());
            return this.checksum = i(this.checksum, e);
        }, t && (f.updateBuffer = function(t) {
            if (!n(t)) throw new Error("First argument needs to be ArrayBuffer.");
            var e = new Uint8Array(t);
            return this.checksum = a(this.checksum, e);
        }), f.clone = function() {
            return new s(this.checksum);
        }, l);
        var u, c, h, l, f;
        o.from = function(t) {
            if (null === t) throw new Error("First argument needs to be a string.");
            return i(1, t.toString());
        }, o.fromUtf8 = function(t) {
            if (null === t) throw new Error("First argument needs to be a string.");
            var e = r(t.toString());
            return i(1, e);
        }, t && (o.fromBuffer = function(t) {
            if (!n(t)) throw new Error("First argument need to be ArrayBuffer.");
            var e = new Uint8Array(t);
            return a(1, e);
        });
        return o;
    }();
}($970c7ddf83730f06$export$ba1e2ffc633a60f5);
var $970c7ddf83730f06$export$2e2bcd8739ae039 = $970c7ddf83730f06$export$ba1e2ffc633a60f5;

});
parcelRegister("fEJ1R", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("cvQVd").then(()=>parcelRequire("9DKAX"));

});
parcelRegister("hffE7", function(module, exports) {
"use strict";

function $c8dff9588896671a$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("kyEFX")).resolve(id));
}
module.exports = $c8dff9588896671a$var$load;

});


parcelRegister("3wVZe", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("6GF5t").then(()=>parcelRequire("9P5Ui"));

});

parcelRegister("84PN1", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("ddqwU").then(()=>parcelRequire("7S9uF"));

});


parcelRegister("ePpmI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acb981253ce8f920$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $cG3EF = parcelRequire("cG3EF");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $iQvLk = parcelRequire("iQvLk");

var $ih19M = parcelRequire("ih19M");
"use client";
const $acb981253ce8f920$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $acb981253ce8f920$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $iQvLk.getDividerUtilityClass), classes);
};
const $acb981253ce8f920$var$DividerRoot = (0, $g4l1t.default)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: "thin"
    }, ownerState.absolute && {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%"
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $cG3EF.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === "inset" && {
        marginLeft: 72
    }, ownerState.variant === "middle" && ownerState.orientation === "horizontal" && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === "middle" && ownerState.orientation === "vertical" && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        borderBottomWidth: 0,
        borderRightWidth: "thin"
    }, ownerState.flexItem && {
        alignSelf: "stretch",
        height: "auto"
    }), ({ ownerState: ownerState })=>(0, $4WYaH.default)({}, ownerState.children && {
        display: "flex",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        "&::before, &::after": {
            content: '""',
            alignSelf: "center"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({}, ownerState.children && ownerState.orientation !== "vertical" && {
        "&::before, &::after": {
            width: "100%",
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({}, ownerState.children && ownerState.orientation === "vertical" && {
        flexDirection: "column",
        "&::before, &::after": {
            height: "100%",
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState: ownerState })=>(0, $4WYaH.default)({}, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "90%"
        },
        "&::after": {
            width: "10%"
        }
    }, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "10%"
        },
        "&::after": {
            width: "90%"
        }
    }));
const $acb981253ce8f920$var$DividerWrapper = (0, $g4l1t.default)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === "vertical" && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $acb981253ce8f920$var$Divider = /*#__PURE__*/ $bh6RR.forwardRef(function Divider(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? "div" : "hr", flexItem: flexItem = false, light: light = false, orientation: orientation = "horizontal", role: role = component !== "hr" ? "separator" : undefined, textAlign: textAlign = "center", variant: variant = "fullWidth" } = props, other = (0, $hCIyK.default)(props, $acb981253ce8f920$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $acb981253ce8f920$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($acb981253ce8f920$var$DividerRoot, (0, $4WYaH.default)({
        as: component,
        className: (0, $aPsoC.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $ih19M.jsx)($acb981253ce8f920$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $acb981253ce8f920$var$Divider.muiSkipListHighlight = true;
var $acb981253ce8f920$export$2e2bcd8739ae039 = $acb981253ce8f920$var$Divider;

});

parcelRegister("10zXY", function(module, exports) {
module.exports = new URL("center_focus_strong.2957aec6.svg", import.meta.url).toString();

});

parcelRegister("89CnP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19b6c2b5e358d5c8$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $6L9uu = parcelRequire("6L9uu");

var $cxTnx = parcelRequire("cxTnx");

var $ewFui = parcelRequire("ewFui");

var $aMeZy = parcelRequire("aMeZy");

var $chLJv = parcelRequire("chLJv");
var $76C60 = parcelRequire("76C60");
var $80t3L = parcelRequire("80t3L");
var $ePpmI = parcelRequire("ePpmI");
var $ePCTs = parcelRequire("ePCTs");
var $dNs2U = parcelRequire("dNs2U");
var $4AJYG = parcelRequire("4AJYG");
var $77DVl = parcelRequire("77DVl");
var $6RrdM = parcelRequire("6RrdM");
var $hEr3D = parcelRequire("hEr3D");
var $6GPiu = parcelRequire("6GPiu");

var $1YMtv = parcelRequire("1YMtv");

var $4XrUr = parcelRequire("4XrUr");
var $1dAUG = parcelRequire("1dAUG");
var $bwbWe = parcelRequire("bwbWe");
var $kso7N = parcelRequire("kso7N");
var $i7aBD = parcelRequire("i7aBD");
var $cSN6l = parcelRequire("cSN6l");
var $dgmqH = parcelRequire("dgmqH");
var $aanxD = parcelRequire("aanxD");
const $19b6c2b5e358d5c8$var$Invoice = ({ fullscreen: fullscreen, cventData: cventData, dbContact: dbContact })=>{
    const { state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const { selectedInvoice: selectedInvoice } = state;
    const isCredit = selectedInvoice?.invoice_full?.is_credit;
    const isConfirmed = selectedInvoice?.status?.includes("confirmed");
    const fontSize = fullscreen ? 12 : 4;
    const labelImageSize = fullscreen ? 14 : 6;
    const invoicePaymentDetails = cventData?.paymentDetails ?? selectedInvoice?.paymentDetails;
    const productInfo = cventData?.productInfo ?? selectedInvoice?.productInfo;
    const membershipPeriodStartDate = selectedInvoice?.remarks;
    const currencyForProduct = productInfo?.product?.product_code.name.toLowerCase() == "esg" ? "GBP" : "EUR";
    const parentInputStyle = {
        fontSize: // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fontSize,
        padding: 0,
        maxHeight: "20%",
        minHeight: "20%"
    };
    const rightParentInputStyle = {
        ...parentInputStyle,
        maxHeight: "16%",
        minHeight: "16%"
    };
    const labelIconStyle = {
        marginRight: "4.7%",
        marginBottom: "1%",
        color: (0, $6L9uu.Colors).third,
        width: `${labelImageSize}px`,
        height: `${labelImageSize}px`
    };
    const headerStyle = {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fontSize: fullscreen ? 18 : 6,
        color: (0, $6L9uu.Colors).third,
        fontWeight: "bold",
        fontFamily: "Overpass"
    };
    const labelStyle = {
        color: (0, $6L9uu.Colors).main,
        fontFamily: "Overpass",
        fontSize: // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fontSize,
        "&:disabled": (0, $6L9uu.Colors).main
    };
    const smallTableCell = {
        fontSize: // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fontSize,
        padding: "6px 16px 6px 16px",
        color: (0, $6L9uu.Colors).main
    };
    const prefixAndFullName = (invoiceFull, invoiceContact)=>{
        if (!invoiceFull) {
            if (invoiceContact?.prefix === null) return `${invoiceContact?.fullName}`;
            return `${invoiceContact?.prefix} ${invoiceContact?.fullName}`;
        }
        if (invoiceFull.details.prefix === null) return `${invoiceFull.details.fullName}`;
        return `${invoiceFull?.details.prefix} ${invoiceFull?.details.fullName}`;
    };
    const getContactAddress = ()=>{
        return cventData ? `${cventData?.contact.address?.street}, ${cventData?.contact?.address?.zip}, ${cventData?.contact.address?.city} , ${cventData?.contact?.address?.country.name} ` : selectedInvoice?.invoice_full ? `${(selectedInvoice.invoice_full.details.street + ", ") ?? ""} ${selectedInvoice.invoice_full.details.zip ? selectedInvoice.invoice_full.details.zip + ", " : ""} ${(selectedInvoice.invoice_full.details.city + ", ") ?? ""} ${selectedInvoice.invoice_full.details.country ?? ""}` : `${selectedInvoice?.address?.country.name ?? ""}, ${selectedInvoice?.address?.street ?? ""}`;
    };
    const getDate = (input)=>{
        if (selectedInvoice?.invoice_full?.[input]) return (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(parseInt(selectedInvoice?.invoice_full?.[input])).format("D MMM YYYY");
    };
    const getVatComment = ()=>{
        let result = "";
        const country = selectedInvoice?.invoice_full ? selectedInvoice.invoice_full.details.country : selectedInvoice?.address?.country?.name;
        if (country) {
            if (productInfo?.product?.product_code?.name === (0, $aMeZy.RB_NAME)) {
                if (country.toLocaleLowerCase() === (0, $ewFui.BELGIUM)) result = "";
                else if ((0, $ewFui.EU_COUNTRIES).indexOf(country.toLocaleLowerCase()) > -1) result = "Service located abroad - Article 44 of Directive 2006/112/EG - Reverse charge - Article 196 of Directive 2006/112/EG";
                else result = "Service located abroad - Article 59(b) of Directive 2006/112/EG";
            } else if (productInfo?.product?.product_code?.name === (0, $aMeZy.AC_NAME)) {
                if ((0, $ewFui.EU_COUNTRIES).indexOf(country.toLocaleLowerCase()) === -1) result = "Service located abroad - Article 59(b) of Directive 2006/112/EG";
            }
        }
        return result;
    };
    const getBottomNotes = (input)=>{
        if (input) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            let result = input.replaceAll("<font", "<span");
            result = result.replaceAll("<p", "<span");
            result = result.replaceAll("font-size", "");
            result = result.replaceAll("<br>", " ");
            result = result.replaceAll("b>", "p>");
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return result.replaceAll("size=", "");
        }
        return "";
    };
    const getCompleteVat = (countryCode, vatNumber)=>{
        let completeVat = "";
        if (countryCode) {
            if (vatNumber) {
                if (vatNumber.startsWith(countryCode)) completeVat = vatNumber;
                else completeVat = `${countryCode}${vatNumber}`;
            }
        } else completeVat = vatNumber ? vatNumber : "";
        return completeVat;
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $76C60.default), {
        style: {
            border: "none",
            boxShadow: "none",
            height: "100%",
            borderRadius: 0
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $80t3L.default), {
            style: {
                padding: 0,
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
                    container: true,
                    style: {
                        padding: "5.42% 5.67% 6.78% 4.66%",
                        height: "26.6%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                            item: true,
                            xs: 3,
                            style: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                style: {
                                    width: fullscreen ? 163 : 75
                                },
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($1YMtv))),
                                alt: "logo",
                                "data-testid": "invoice-epra-logo"
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                            item: true,
                            xs: 1,
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {
                                orientation: "vertical",
                                "data-testid": "invoice-header-divider",
                                style: {
                                    marginLeft: "auto",
                                    marginRight: "auto"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                            item: true,
                            xs: 8,
                            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
                                container: true,
                                style: {
                                    height: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
                                        item: true,
                                        xs: 7,
                                        style: {
                                            paddingRight: "6%",
                                            lineHeight: fullscreen ? "auto" : "15px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                                id: "invoice-contact-address",
                                                "data-testid": "invoice-contact-address",
                                                value: invoicePaymentDetails?.contact_address_name,
                                                disabled: true,
                                                fullWidth: true,
                                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bwbWe.default), {
                                                    style: labelIconStyle
                                                }),
                                                inputProps: {
                                                    style: {
                                                        ...labelStyle,
                                                        fontWeight: "bold"
                                                    }
                                                },
                                                multiline: true,
                                                style: parentInputStyle
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                                id: "invoice-address",
                                                "data-testid": "invoice-address",
                                                value: invoicePaymentDetails?.contact_address,
                                                disabled: true,
                                                fullWidth: true,
                                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kso7N.default), {
                                                    style: labelIconStyle
                                                }),
                                                inputProps: {
                                                    style: labelStyle
                                                },
                                                multiline: true,
                                                style: parentInputStyle
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                                id: "invoice-contact-phone",
                                                "data-testid": "invoice-contact-phone",
                                                value: invoicePaymentDetails?.contact_phone,
                                                disabled: true,
                                                fullWidth: true,
                                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $i7aBD.default), {
                                                    style: labelIconStyle
                                                }),
                                                inputProps: {
                                                    style: labelStyle
                                                },
                                                multiline: true,
                                                style: parentInputStyle
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                                id: "invoice-contact-fax",
                                                "data-testid": "invoice-contact-fax",
                                                value: invoicePaymentDetails?.contact_fax,
                                                disabled: true,
                                                fullWidth: true,
                                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cSN6l.default), {
                                                    style: labelIconStyle
                                                }),
                                                inputProps: {
                                                    style: labelStyle
                                                },
                                                multiline: true,
                                                style: parentInputStyle
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                                id: "invoice-contact-vat",
                                                "data-testid": "invoice-contact-vat",
                                                value: `VAT: ${invoicePaymentDetails?.contact_vat}`,
                                                disabled: true,
                                                fullWidth: true,
                                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $dgmqH.default), {
                                                    style: labelIconStyle
                                                }),
                                                inputProps: {
                                                    style: labelStyle
                                                },
                                                multiline: true,
                                                style: parentInputStyle
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
                                        item: true,
                                        xs: 5,
                                        style: {
                                            lineHeight: fullscreen ? "auto" : "9px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                style: {
                                                    fontFamily: "Overpass",
                                                    color: (0, $6L9uu.Colors).white,
                                                    fontWeight: "bold",
                                                    backgroundColor: (0, $6L9uu.Colors).main,
                                                    fontSize: fontSize,
                                                    minHeight: "15%",
                                                    maxHeight: "15%",
                                                    marginLeft: "-4.1%",
                                                    paddingLeft: "4.1%",
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: "BANK ACCOUNT"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                                id: "invoice-bank-affiliate",
                                                "data-testid": "invoice-bank-affiliate",
                                                value: invoicePaymentDetails?.bank_affiliate,
                                                disabled: true,
                                                fullWidth: true,
                                                inputProps: {
                                                    style: {
                                                        ...labelStyle,
                                                        fontWeight: "bold"
                                                    }
                                                },
                                                multiline: true,
                                                style: rightParentInputStyle
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                                id: "invoice-bank-name",
                                                "data-testid": "invoice-bank-name",
                                                value: invoicePaymentDetails?.bank_name,
                                                disabled: true,
                                                fullWidth: true,
                                                inputProps: {
                                                    style: labelStyle
                                                },
                                                multiline: true,
                                                style: rightParentInputStyle
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                                id: "invoice-bank-address",
                                                "data-testid": "invoice-bank-address",
                                                value: invoicePaymentDetails?.bank_address,
                                                disabled: true,
                                                fullWidth: true,
                                                inputProps: {
                                                    style: labelStyle
                                                },
                                                multiline: true,
                                                style: rightParentInputStyle
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                                id: "invoice-bank-pic",
                                                "data-testid": "invoice-bank-pic",
                                                value: invoicePaymentDetails?.bank_bic,
                                                disabled: true,
                                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                    style: {
                                                        ...labelStyle,
                                                        fontWeight: "bold",
                                                        marginRight: "3%"
                                                    },
                                                    children: "BIC:"
                                                }),
                                                fullWidth: true,
                                                inputProps: {
                                                    style: labelStyle
                                                },
                                                multiline: true,
                                                style: rightParentInputStyle
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                                id: "invoice-bank-iban",
                                                "data-testid": "invoice-bank-iban",
                                                value: invoicePaymentDetails?.bank_iban,
                                                disabled: true,
                                                fullWidth: true,
                                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                    style: {
                                                        ...labelStyle,
                                                        fontWeight: "bold",
                                                        marginRight: "3%"
                                                    },
                                                    children: "IBAN:"
                                                }),
                                                inputProps: {
                                                    style: labelStyle
                                                },
                                                multiline: true,
                                                style: rightParentInputStyle
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
                    container: true,
                    style: {
                        height: "4.65%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                            item: true,
                            xs: 5,
                            style: {
                                background: isCredit ? (0, $6L9uu.Colors).orange : (0, $6L9uu.Colors).third,
                                paddingLeft: "4.66%",
                                paddingTop: "0.3%",
                                display: "flex",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                id: "invoice-preview-title",
                                "data-testid": "invoice-preview-title",
                                style: {
                                    color: (0, $6L9uu.Colors).white,
                                    fontWeight: "bold",
                                    fontSize: fullscreen ? 22 : 9,
                                    fontFamily: "Overpass"
                                },
                                children: `${isCredit ? "CREDIT" : "INVOICE"} ${isConfirmed ? selectedInvoice?.invoice_full?.number : ""}`
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                            item: true,
                            xs: 7,
                            style: {
                                marginTop: "auto",
                                marginBottom: "auto",
                                paddingRight: "5.13%"
                            },
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {
                                style: {
                                    background: isCredit ? (0, $6L9uu.Colors).orange : (0, $6L9uu.Colors).main
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
                    container: true,
                    style: {
                        padding: "0 5.67% 0 4.66%",
                        height: fullscreen ? "19.9%" : "14.9%",
                        lineHeight: fullscreen ? "1.5" : "10px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                            item: true,
                            xs: 12,
                            style: {
                                height: "17%",
                                color: (0, $6L9uu.Colors).orange,
                                fontSize: fullscreen ? 14 : 4,
                                display: "flex",
                                alignItems: "center"
                            },
                            children: isCredit && `/REF: INVOICE  ${selectedInvoice?.invoice_full?.debit_invoice_nr ?? ""}/`
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
                            container: true,
                            style: {
                                height: "83%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
                                    item: true,
                                    xs: 4,
                                    style: {
                                        paddingRight: "6%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                            value: "To:",
                                            disabled: true,
                                            fullWidth: true,
                                            inputProps: {
                                                style: {
                                                    fontFamily: "Overpass",
                                                    fontSize: fontSize
                                                }
                                            },
                                            multiline: true,
                                            style: {
                                                padding: 0,
                                                fontSize: fontSize
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                            id: "invoice-contact-fullname",
                                            "data-testid": "invoice-contact-fullname",
                                            value: prefixAndFullName(selectedInvoice?.invoice_full || null, selectedInvoice?.contact || null),
                                            disabled: true,
                                            fullWidth: true,
                                            multiline: true,
                                            style: headerStyle
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                            id: "invoice-contact-email",
                                            "data-testid": "invoice-contact-email",
                                            value: selectedInvoice?.contact?.email,
                                            disabled: true,
                                            fullWidth: true,
                                            inputProps: {
                                                style: labelStyle
                                            },
                                            multiline: true,
                                            style: {
                                                padding: 0,
                                                fontSize: fontSize
                                            },
                                            startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1dAUG.default), {
                                                style: {
                                                    ...labelIconStyle,
                                                    marginBottom: 0
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                            id: "invoice-contact-title",
                                            "data-testid": "invoice-contact-title",
                                            value: selectedInvoice?.invoice_full?.details?.title_external || selectedInvoice?.contact?.title_external || dbContact?.title_external || "",
                                            disabled: true,
                                            fullWidth: true,
                                            inputProps: {
                                                style: labelStyle
                                            },
                                            multiline: true,
                                            style: {
                                                padding: 0,
                                                fontSize: fontSize
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
                                    item: true,
                                    xs: 4,
                                    style: {
                                        paddingRight: "6%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                            value: "Company:",
                                            disabled: true,
                                            fullWidth: true,
                                            inputProps: {
                                                style: {
                                                    fontFamily: "Overpass",
                                                    fontSize: fontSize
                                                }
                                            },
                                            multiline: true,
                                            style: {
                                                padding: 0,
                                                fontSize: fontSize
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                            id: "invoice-company-name",
                                            "data-testid": "invoice-company-name",
                                            value: selectedInvoice?.company?.name,
                                            disabled: true,
                                            fullWidth: true,
                                            multiline: true,
                                            style: headerStyle
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                            id: "invoice-contact-address",
                                            "data-testid": "invoice-contact-address",
                                            value: getContactAddress(),
                                            disabled: true,
                                            fullWidth: true,
                                            inputProps: {
                                                style: labelStyle
                                            },
                                            multiline: true,
                                            style: {
                                                padding: 0,
                                                fontSize: fontSize
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                            id: "invoice-address-vat",
                                            "data-testid": "invoice-address-vat",
                                            value: `VAT: ${!selectedInvoice?.invoice_full ? selectedInvoice?.company?.main_address?.complete_vat_number : getCompleteVat(selectedInvoice?.invoice_full?.details.vat_countrycode, selectedInvoice?.invoice_full?.details.company_address_vat) ?? cventData?.paymentDetails?.contact_vat ?? ""}`,
                                            disabled: true,
                                            fullWidth: true,
                                            inputProps: {
                                                style: labelStyle
                                            },
                                            multiline: true,
                                            style: {
                                                padding: 0,
                                                fontSize: fontSize,
                                                marginTop: "5%"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
                                    item: true,
                                    xs: 4,
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                            value: "",
                                            disabled: true,
                                            fullWidth: true,
                                            inputProps: {
                                                style: {
                                                    fontFamily: "Overpass",
                                                    fontSize: fontSize
                                                }
                                            },
                                            multiline: true,
                                            style: {
                                                padding: 0,
                                                fontSize: fontSize
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                            id: "invoice-confirmed-circle",
                                            "data-testid": "invoice-confirmed-circle",
                                            value: isConfirmed ? "confirmed" : "",
                                            disabled: true,
                                            fullWidth: true,
                                            startAdornment: isConfirmed ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $4XrUr.default), {
                                                className: "invoice-confirmed-circle-icon",
                                                "data-testid": "invoice-confirmed-circle-icon",
                                                style: {
                                                    ...labelIconStyle,
                                                    color: (0, $6L9uu.Colors).green
                                                }
                                            }) : null,
                                            multiline: true,
                                            style: {
                                                ...headerStyle,
                                                color: (0, $6L9uu.Colors).green
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                            id: "invoice-created-date",
                                            "data-testid": "invoice-created-date",
                                            value: getDate("created_date"),
                                            disabled: true,
                                            fullWidth: true,
                                            startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                                value: "Invoice date:",
                                                disabled: true,
                                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aanxD.default), {
                                                    style: {
                                                        ...labelIconStyle,
                                                        marginRight: "8%"
                                                    }
                                                }),
                                                inputProps: {
                                                    style: {
                                                        ...labelStyle,
                                                        color: (0, $6L9uu.Colors).third,
                                                        padding: 0
                                                    }
                                                },
                                                style: {
                                                    padding: 0,
                                                    width: "100%"
                                                }
                                            }),
                                            inputProps: {
                                                style: {
                                                    ...labelStyle,
                                                    fontWeight: "bold",
                                                    marginLeft: "-14%"
                                                }
                                            },
                                            multiline: true,
                                            style: {
                                                padding: 0,
                                                fontSize: fontSize,
                                                marginTop: "2.2%"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                            id: "invoice-due-date",
                                            "data-testid": "invoice-due-date",
                                            value: getDate("due_date"),
                                            disabled: true,
                                            fullWidth: true,
                                            startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                                value: "Invoice due:",
                                                disabled: true,
                                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aanxD.default), {
                                                    style: {
                                                        ...labelIconStyle,
                                                        marginRight: "8%"
                                                    }
                                                }),
                                                inputProps: {
                                                    style: {
                                                        ...labelStyle,
                                                        color: (0, $6L9uu.Colors).third,
                                                        padding: 0
                                                    }
                                                },
                                                style: {
                                                    padding: 0,
                                                    width: "100%"
                                                }
                                            }),
                                            inputProps: {
                                                style: {
                                                    ...labelStyle,
                                                    fontWeight: "bold",
                                                    marginLeft: "-14%"
                                                }
                                            },
                                            multiline: true,
                                            style: {
                                                padding: 0,
                                                fontSize: fontSize,
                                                marginTop: "2.4%"
                                            }
                                        }),
                                        selectedInvoice?.po_nr && /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                            id: "invoice-po-nr",
                                            "data-testid": "invoice-po-nr",
                                            value: `PO: ${selectedInvoice?.po_nr || ""}`,
                                            disabled: true,
                                            fullWidth: true,
                                            inputProps: {
                                                style: labelStyle
                                            },
                                            multiline: true,
                                            style: {
                                                padding: 0,
                                                fontSize: fontSize,
                                                marginTop: "5%"
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                    container: true,
                    id: "invoice-additional-details",
                    style: {
                        padding: "0 5.67% 0 4.66%",
                        height: fullscreen ? "26.85%" : "31.8%"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
                        item: true,
                        xs: 12,
                        style: {
                            height: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $4AJYG.default), {
                                "aria-label": "spanning table",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hEr3D.default), {
                                        children: membershipPeriodStartDate && /*#__PURE__*/ (0, $ih19M.jsx)((0, $6GPiu.default), {
                                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $6RrdM.default), {
                                                style: {
                                                    ...smallTableCell,
                                                    fontWeight: "bold",
                                                    paddingLeft: 0,
                                                    paddingBottom: 0,
                                                    borderBottom: "none",
                                                    width: "20%",
                                                    lineHeight: fullscreen ? "auto" : "6px",
                                                    fontSize: fullscreen ? "10px" : "3px",
                                                    color: (0, $6L9uu.Colors).main
                                                },
                                                children: membershipPeriodStartDate || ""
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $hEr3D.default), {
                                        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $6GPiu.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $6RrdM.default), {
                                                    style: {
                                                        ...smallTableCell,
                                                        fontWeight: "bold",
                                                        paddingLeft: 0,
                                                        borderBottom: `1px solid ${(0, $6L9uu.Colors).main}`,
                                                        width: "60%",
                                                        lineHeight: fullscreen ? "auto" : "6px",
                                                        padding: "0"
                                                    },
                                                    children: "Description"
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $6RrdM.default), {
                                                    colSpan: 3,
                                                    align: "right",
                                                    style: {
                                                        ...smallTableCell,
                                                        fontWeight: "bold",
                                                        borderBottom: `1px solid ${(0, $6L9uu.Colors).main}`,
                                                        width: "40%",
                                                        lineHeight: fullscreen ? "auto" : "6px"
                                                    },
                                                    children: "Price"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $77DVl.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $6GPiu.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $6RrdM.default), {
                                                        "data-testid": "invoice-product-name",
                                                        style: {
                                                            ...smallTableCell,
                                                            paddingLeft: 0,
                                                            borderBottom: `1px solid ${(0, $6L9uu.Colors).main}`
                                                        },
                                                        children: productInfo?.product?.name
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $6RrdM.default), {
                                                        "data-testid": "invoice-price",
                                                        colSpan: 3,
                                                        align: "right",
                                                        style: {
                                                            ...smallTableCell,
                                                            borderBottom: `1px solid ${(0, $6L9uu.Colors).main}`
                                                        },
                                                        children: productInfo?.product?.price.toLocaleString(undefined, {
                                                            minimumFractionDigits: 2
                                                        }) + " " + currencyForProduct
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $6GPiu.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $6RrdM.default), {
                                                        rowSpan: 3,
                                                        style: {
                                                            border: "none"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $6RrdM.default), {
                                                        "data-testid": "invoice-discount-percent",
                                                        colSpan: 2,
                                                        style: {
                                                            ...smallTableCell,
                                                            borderBottom: `1px solid ${(0, $6L9uu.Colors).third}`,
                                                            paddingLeft: 0
                                                        },
                                                        children: [
                                                            "Discount(",
                                                            productInfo?.discountPercent,
                                                            "%)"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $6RrdM.default), {
                                                        "data-testid": "invoice-discount",
                                                        align: "right",
                                                        style: {
                                                            ...smallTableCell,
                                                            borderBottom: `1px solid ${(0, $6L9uu.Colors).third}`,
                                                            paddingLeft: 0
                                                        },
                                                        children: productInfo?.discount.toFixed(2) + " " + currencyForProduct
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $6GPiu.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $6RrdM.default), {
                                                        "data-testid": "invoice-vat-percent",
                                                        colSpan: 2,
                                                        style: {
                                                            ...smallTableCell,
                                                            borderBottom: `1px solid ${(0, $6L9uu.Colors).third}`,
                                                            paddingLeft: 0
                                                        },
                                                        children: [
                                                            "VAT(",
                                                            productInfo?.vatPercent,
                                                            "%)"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $6RrdM.default), {
                                                        "data-testid": "invoice-vat",
                                                        align: "right",
                                                        style: {
                                                            ...smallTableCell,
                                                            borderBottom: `1px solid ${(0, $6L9uu.Colors).third}`,
                                                            paddingLeft: 0
                                                        },
                                                        children: productInfo?.vat.toFixed(2) + " " + currencyForProduct
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $6GPiu.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $6RrdM.default), {
                                                        colSpan: 2,
                                                        style: {
                                                            ...smallTableCell,
                                                            fontWeight: "bold",
                                                            borderBottom: "none",
                                                            paddingLeft: 0
                                                        },
                                                        children: "TOTAL:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $6RrdM.default), {
                                                        "data-testid": "invoice-total",
                                                        align: "right",
                                                        style: {
                                                            ...smallTableCell,
                                                            fontWeight: "bold",
                                                            borderBottom: "none",
                                                            paddingLeft: 0
                                                        },
                                                        children: productInfo?.total.toLocaleString(undefined, {
                                                            minimumFractionDigits: 2
                                                        }) + " " + currencyForProduct
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                style: {
                                    color: (0, $6L9uu.Colors).main,
                                    fontFamily: "Overpass",
                                    fontSize: fullscreen ? "9px" : "6px"
                                },
                                children: getVatComment()
                            }),
                            selectedInvoice?.notes && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                sx: {
                                    labelStyle: labelStyle,
                                    fontSize: fullscreen ? "9px" : "6px"
                                },
                                children: selectedInvoice?.notes
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
                    container: true,
                    style: {
                        padding: "0% 5.67% 0 4.66%",
                        paddingBottom: "0",
                        height: "24.1%",
                        backgroundColor: (0, $6L9uu.Colors).third,
                        alignContent: "flex-start"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                            item: true,
                            xs: 12,
                            id: "invoice-bottom-notes",
                            "data-testid": "invoice-bottom-notes",
                            style: {
                                color: (0, $6L9uu.Colors).white,
                                fontSize: fullscreen ? "12px" : "5px",
                                minHeight: "50%"
                            },
                            dangerouslySetInnerHTML: {
                                __html: getBottomNotes(productInfo?.product?.bottom_notes)
                            }
                        }),
                        !productInfo?.product?.name?.toLowerCase()?.includes("invoice credit card") ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
                            item: true,
                            xs: 12,
                            style: {
                                color: (0, $6L9uu.Colors).white,
                                fontSize: fontSize,
                                fontStyle: "italic",
                                borderTop: "1px solid #B4D5F9",
                                height: "15%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            },
                            children: [
                                "We kindly request you to pay the above total amount in",
                                " ",
                                productInfo?.product?.product_code.name.toLowerCase() === "esg" ? "GBP" : "Euros",
                                " ",
                                '("charges to the payer")'
                            ]
                        }) : ""
                    ]
                })
            ]
        })
    });
};
var $19b6c2b5e358d5c8$export$2e2bcd8739ae039 = $19b6c2b5e358d5c8$var$Invoice;

});
parcelRegister("ewFui", function(module, exports) {

$parcel$export(module.exports, "EU_COUNTRIES", function () { return $cfa68ec2e810e26a$export$df38b2ebbaed2836; });
$parcel$export(module.exports, "BELGIUM", function () { return $cfa68ec2e810e26a$export$c041731c4a3f0b63; });
const $cfa68ec2e810e26a$export$df38b2ebbaed2836 = [
    "austria",
    "belgium",
    "bulgaria",
    "croatia",
    "cyprus",
    "czechia",
    "denmark",
    "estonia",
    "finland",
    "france",
    "germany",
    "greece",
    "hungary",
    "ireland",
    "italy",
    "latvia",
    "lithuania",
    "luxembourg",
    "malta",
    "netherlands",
    "poland",
    "portugal",
    "romania",
    "slovakia",
    "slovenia",
    "spain",
    "sweden"
];
const $cfa68ec2e810e26a$export$c041731c4a3f0b63 = "belgium";

});

parcelRegister("76C60", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52c6a50065cb46df$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $iTI7v = parcelRequire("iTI7v");

var $a3rOM = parcelRequire("a3rOM");

var $ih19M = parcelRequire("ih19M");
"use client";
const $52c6a50065cb46df$var$_excluded = [
    "className",
    "raised"
];
const $52c6a50065cb46df$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $a3rOM.getCardUtilityClass), classes);
};
const $52c6a50065cb46df$var$CardRoot = (0, $g4l1t.default)((0, $iTI7v.default), {
    name: "MuiCard",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: "hidden"
    };
});
const $52c6a50065cb46df$var$Card = /*#__PURE__*/ $bh6RR.forwardRef(function Card(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiCard"
    });
    const { className: className, raised: raised = false } = props, other = (0, $hCIyK.default)(props, $52c6a50065cb46df$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        raised: raised
    });
    const classes = $52c6a50065cb46df$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($52c6a50065cb46df$var$CardRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $52c6a50065cb46df$export$2e2bcd8739ae039 = $52c6a50065cb46df$var$Card;

});
parcelRegister("a3rOM", function(module, exports) {

$parcel$export(module.exports, "getCardUtilityClass", function () { return $751fc34437edd90e$export$f3b76d2cce458caa; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $751fc34437edd90e$export$f3b76d2cce458caa(slot) {
    return (0, $XybB6.default)("MuiCard", slot);
}
const $751fc34437edd90e$var$cardClasses = (0, $igcUF.default)("MuiCard", [
    "root"
]);
var $751fc34437edd90e$export$2e2bcd8739ae039 = $751fc34437edd90e$var$cardClasses;

});


parcelRegister("80t3L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d44dd73f7bda1c6$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $4NMvw = parcelRequire("4NMvw");

var $ih19M = parcelRequire("ih19M");
"use client";
const $5d44dd73f7bda1c6$var$_excluded = [
    "className",
    "component"
];
const $5d44dd73f7bda1c6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $4NMvw.getCardContentUtilityClass), classes);
};
const $5d44dd73f7bda1c6$var$CardContentRoot = (0, $g4l1t.default)("div", {
    name: "MuiCardContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        "&:last-child": {
            paddingBottom: 24
        }
    };
});
const $5d44dd73f7bda1c6$var$CardContent = /*#__PURE__*/ $bh6RR.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiCardContent"
    });
    const { className: className, component: component = "div" } = props, other = (0, $hCIyK.default)(props, $5d44dd73f7bda1c6$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        component: component
    });
    const classes = $5d44dd73f7bda1c6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($5d44dd73f7bda1c6$var$CardContentRoot, (0, $4WYaH.default)({
        as: component,
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $5d44dd73f7bda1c6$export$2e2bcd8739ae039 = $5d44dd73f7bda1c6$var$CardContent;

});
parcelRegister("4NMvw", function(module, exports) {

$parcel$export(module.exports, "getCardContentUtilityClass", function () { return $37f15d938147e1e9$export$964336739a8c7119; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $37f15d938147e1e9$export$964336739a8c7119(slot) {
    return (0, $XybB6.default)("MuiCardContent", slot);
}
const $37f15d938147e1e9$var$cardContentClasses = (0, $igcUF.default)("MuiCardContent", [
    "root"
]);
var $37f15d938147e1e9$export$2e2bcd8739ae039 = $37f15d938147e1e9$var$cardContentClasses;

});


parcelRegister("1YMtv", function(module, exports) {
module.exports = new URL("epra_logo.79e8998a.svg", import.meta.url).toString();

});

parcelRegister("4XrUr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39c25255c3605617$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $39c25255c3605617$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), "CheckCircle");

});

parcelRegister("1dAUG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e33a387ac76b464$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $0e33a387ac76b464$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 4-8 5-8-5V6l8 5 8-5z"
}), "Email");

});

parcelRegister("i7aBD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3011b8f8a364a67$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $d3011b8f8a364a67$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02z"
}), "Phone");

});


parcelRegister("g8u5J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a40f11b36fd05b42$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $7opAt = parcelRequire("7opAt");
var $hVuP7 = parcelRequire("hVuP7");

var $6L9uu = parcelRequire("6L9uu");
const $a40f11b36fd05b42$var$Transition = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(function Transition(props, ref) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $hVuP7.default), {
        direction: "up",
        ref: ref,
        ...props
    });
});
const $a40f11b36fd05b42$var$InvoicePreview = ({ handleClose: handleClose, children: children })=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $7opAt.default), {
        open: true,
        TransitionComponent: $a40f11b36fd05b42$var$Transition,
        keepMounted: true,
        onClose: handleClose,
        sx: {
            "& .MuiDialog-container": {
                alignItems: "center",
                display: "flex"
            }
        },
        PaperProps: {
            sx: {
                m: 0,
                maxWidth: "794px",
                width: "794px",
                height: "1032px",
                borderRadius: "0px"
            }
        },
        BackdropProps: {
            style: {
                background: (0, $6L9uu.Colors).modalBackground
            }
        },
        children: children
    });
};
var $a40f11b36fd05b42$export$2e2bcd8739ae039 = $a40f11b36fd05b42$var$InvoicePreview;

});
parcelRegister("hVuP7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0cfab75ff391e0d$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $7ARPd = parcelRequire("7ARPd");




var $4lWVQ = parcelRequire("4lWVQ");

var $erAkb = parcelRequire("erAkb");

var $8gyMY = parcelRequire("8gyMY");

var $6SHzw = parcelRequire("6SHzw");

var $kPbNB = parcelRequire("kPbNB");

var $ih19M = parcelRequire("ih19M");
"use client";
const $d0cfab75ff391e0d$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $d0cfab75ff391e0d$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $kPbNB.default)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== "none" && typeof transform === "string") {
        const transformValues = transform.split("(")[1].split(")")[0].split(",");
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === "left") {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === "right") {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === "up") {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $d0cfab75ff391e0d$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === "function" ? containerPropProp() : containerPropProp;
}
function $d0cfab75ff391e0d$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $d0cfab75ff391e0d$var$resolveContainer(containerProp);
    const transform = $d0cfab75ff391e0d$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d0cfab75ff391e0d$var$Slide = /*#__PURE__*/ $bh6RR.forwardRef(function Slide(props, ref) {
    const theme = (0, $8gyMY.default)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = "down", easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $7ARPd.default) } = props, other = (0, $hCIyK.default)(props, $d0cfab75ff391e0d$var$_excluded);
    const childrenRef = $bh6RR.useRef(null);
    const handleRef = (0, $erAkb.default)(children.ref, childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $d0cfab75ff391e0d$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $6SHzw.reflow)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $6SHzw.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", (0, $4WYaH.default)({}, transitionProps));
        node.style.transition = theme.transitions.create("transform", (0, $4WYaH.default)({}, transitionProps));
        node.style.webkitTransform = "none";
        node.style.transform = "none";
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $6SHzw.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", transitionProps);
        node.style.transition = theme.transitions.create("transform", transitionProps);
        $d0cfab75ff391e0d$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = "";
        node.style.transition = "";
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $bh6RR.useCallback(()=>{
        if (childrenRef.current) $d0cfab75ff391e0d$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $bh6RR.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === "down" || direction === "right") return undefined;
        const handleResize = (0, $4lWVQ.default)(()=>{
            if (childrenRef.current) $d0cfab75ff391e0d$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $kPbNB.default)(childrenRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $bh6RR.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $bh6RR.cloneElement(children, (0, $4WYaH.default)({
                ref: handleRef,
                style: (0, $4WYaH.default)({
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
var $d0cfab75ff391e0d$export$2e2bcd8739ae039 = $d0cfab75ff391e0d$var$Slide;

});


parcelRegister("9rvkQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6dfef134e22a56c8$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $6dfef134e22a56c8$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), "Error");

});

parcelRegister("jjVT0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e10cb1a6db9832c2$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $e10cb1a6db9832c2$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M2.01 21 23 12 2.01 3 2 10l15 2-15 2z"
}), "Send");

});

parcelRegister("6wWvz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdd32ee6a97ea2c4$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $ehzwo = parcelRequire("ehzwo");

var $bt9fX = parcelRequire("bt9fX");

var $6L9uu = parcelRequire("6L9uu");

var $1ELi8 = parcelRequire("1ELi8");

var $gSGmk = parcelRequire("gSGmk");
const $bdd32ee6a97ea2c4$var$CcInput = ({ onClose: onClose, setCcRecipients: setCcRecipients, recientsInput: recientsInput })=>{
    const buttonSize = 30;
    const [emailValue, setEmailValue] = (0, $bh6RR.useState)("");
    const [recipients, setRecipients] = (0, $bh6RR.useState)(recientsInput);
    const isValidEmail = emailValue.match((0, $gSGmk.validEmailRegex));
    const addRecipient = ()=>{
        if (isValidEmail && !recipients.includes(emailValue)) {
            setRecipients([
                ...recipients,
                emailValue
            ]);
            setEmailValue("");
        }
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5PJ2i.default), {
        id: "cc-dialog",
        width: 640,
        onClose: onClose,
        title: "Add bcc recipients",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                p: "5%",
                display: "flex",
                flexDirection: "column",
                gap: "12px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    sx: {
                        display: "flex",
                        gap: "8px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "invoice-email-receiver",
                            "data-testid": "invoice-email-receiver",
                            label: "Email",
                            value: emailValue,
                            onChange: (e)=>setEmailValue(e.currentTarget.value)
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bt9fX.default), {
                            onClick: addRecipient,
                            style: {
                                color: isValidEmail ? (0, $6L9uu.Colors).skyBlue : (0, $6L9uu.Colors).dark_gray,
                                height: buttonSize,
                                width: buttonSize,
                                cursor: isValidEmail ? "pointer" : ""
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "8px"
                        },
                        children: recipients.map((recipient, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $1ELi8.default), {
                                id: `${recipient}-form-chip-${index}`,
                                label: recipient,
                                onDelete: ()=>setRecipients(recipients.filter((r)=>r !== recipient))
                            }, `${recipient}-form-chip-${index}`))
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    sx: {
                        display: "flex",
                        justifyContent: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                            id: "cancel-cc-button",
                            onClick: onClose,
                            text: "cancel"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                            id: "save-cc-button",
                            onClick: ()=>{
                                setCcRecipients(recipients);
                                onClose();
                            },
                            text: "finish"
                        })
                    ]
                })
            ]
        })
    });
};
var $bdd32ee6a97ea2c4$export$2e2bcd8739ae039 = $bdd32ee6a97ea2c4$var$CcInput;

});
parcelRegister("1ELi8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6376783f2eca99cf$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $gu8wR = parcelRequire("gu8wR");

var $6L9uu = parcelRequire("6L9uu");
const $6376783f2eca99cf$var$chipStyles = {
    color: (0, $6L9uu.Colors).main,
    fontSize: 14,
    fontWeight: "normal",
    background: "#69AAF333",
    "&:active, &:focus": {
        background: "#69AAF333"
    }
};
const $6376783f2eca99cf$var$deleteIconStyles = {
    color: (0, $6L9uu.Colors).skyBlue,
    width: 28,
    height: 28,
    "&:hover": {
        color: (0, $6L9uu.Colors).main
    }
};
const $6376783f2eca99cf$var$EpraChip = ({ id: id, label: label, onDelete: onDelete })=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
        id: id,
        "data-testid": id,
        label: label,
        onDelete: onDelete,
        sx: {
            ...$6376783f2eca99cf$var$chipStyles,
            ".MuiChip-deleteIcon": $6376783f2eca99cf$var$deleteIconStyles
        }
    });
};
var $6376783f2eca99cf$export$2e2bcd8739ae039 = $6376783f2eca99cf$var$EpraChip;

});



parcelRegister("2lD0z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01b5d8ae6314d688$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $gap43 = parcelRequire("gap43");
var $7ISdU = parcelRequire("7ISdU");
var $4F9C5 = parcelRequire("4F9C5");

var $bsGRh = parcelRequire("bsGRh");
var $ddVQH = parcelRequire("ddVQH");

var $g4l1t = parcelRequire("g4l1t");

var $6L9uu = parcelRequire("6L9uu");
const $01b5d8ae6314d688$var$QontoConnector = (0, $g4l1t.default)((0, $bsGRh.default))(({ theme: theme })=>({
        [`&.${(0, $ddVQH.default).alternativeLabel}`]: {
            top: 10,
            left: "calc(-50% + 16px)",
            right: "calc(50% + 16px)"
        },
        [`&.${(0, $ddVQH.default).active}`]: {
            [`& .${(0, $ddVQH.default).line}`]: {
                borderColor: (0, $6L9uu.Colors).green
            }
        },
        [`&.${(0, $ddVQH.default).completed}`]: {
            [`& .${(0, $ddVQH.default).line}`]: {
                borderColor: (0, $6L9uu.Colors).green
            }
        },
        [`& .${(0, $ddVQH.default).line}`]: {
            borderColor: (0, $6L9uu.Colors).gray,
            borderTopWidth: 2
        }
    }));
const $01b5d8ae6314d688$var$FormStepper = ({ steps: steps, activeStep: activeStep })=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        sx: {
            pt: "30px"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4F9C5.default), {
            activeStep: activeStep,
            alternativeLabel: true,
            connector: /*#__PURE__*/ (0, $ih19M.jsx)($01b5d8ae6314d688$var$QontoConnector, {}),
            children: steps.map((label)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $gap43.default), {
                    sx: {
                        padding: 0,
                        "& .MuiStepLabel-root .Mui-completed": {
                            color: (0, $6L9uu.Colors).green // circle color (COMPLETED)
                        },
                        "& .MuiStepLabel-root .Mui-active": {
                            color: "#caedff" // circle color (ACTIVE)
                        },
                        "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel": {
                            color: "primary.main" // Just text label (ACTIVE)
                        },
                        "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
                            fill: (0, $6L9uu.Colors).main,
                            fontWeight: "bold" // circle's number (ACTIVE)
                        }
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7ISdU.default), {
                        children: label
                    })
                }, label))
        })
    });
};
var $01b5d8ae6314d688$export$2e2bcd8739ae039 = $01b5d8ae6314d688$var$FormStepper;

});
parcelRegister("gap43", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc5105c5a2910b11$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $7J7Kn = parcelRequire("7J7Kn");

var $5gLOS = parcelRequire("5gLOS");

var $3flqJ = parcelRequire("3flqJ");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $aYw3D = parcelRequire("aYw3D");

var $ih19M = parcelRequire("ih19M");
"use client";
const $bc5105c5a2910b11$var$_excluded = [
    "active",
    "children",
    "className",
    "component",
    "completed",
    "disabled",
    "expanded",
    "index",
    "last"
];
const $bc5105c5a2910b11$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, completed: completed } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel",
            completed && "completed"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $aYw3D.getStepUtilityClass), classes);
};
const $bc5105c5a2910b11$var$StepRoot = (0, $g4l1t.default)("div", {
    name: "MuiStep",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({}, ownerState.orientation === "horizontal" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.alternativeLabel && {
        flex: 1,
        position: "relative"
    }));
const $bc5105c5a2910b11$var$Step = /*#__PURE__*/ $bh6RR.forwardRef(function Step(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiStep"
    });
    const { active: activeProp, children: children, className: className, component: component = "div", completed: completedProp, disabled: disabledProp, expanded: expanded = false, index: index, last: last } = props, other = (0, $hCIyK.default)(props, $bc5105c5a2910b11$var$_excluded);
    const { activeStep: activeStep, connector: connector, alternativeLabel: alternativeLabel, orientation: orientation, nonLinear: nonLinear } = $bh6RR.useContext((0, $5gLOS.default));
    let [active = false, completed = false, disabled = false] = [
        activeProp,
        completedProp,
        disabledProp
    ];
    if (activeStep === index) active = activeProp !== undefined ? activeProp : true;
    else if (!nonLinear && activeStep > index) completed = completedProp !== undefined ? completedProp : true;
    else if (!nonLinear && activeStep < index) disabled = disabledProp !== undefined ? disabledProp : true;
    const contextValue = $bh6RR.useMemo(()=>({
            index: index,
            last: last,
            expanded: expanded,
            icon: index + 1,
            active: active,
            completed: completed,
            disabled: disabled
        }), [
        index,
        last,
        expanded,
        active,
        completed,
        disabled
    ]);
    const ownerState = (0, $4WYaH.default)({}, props, {
        active: active,
        orientation: orientation,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        expanded: expanded,
        component: component
    });
    const classes = $bc5105c5a2910b11$var$useUtilityClasses(ownerState);
    const newChildren = /*#__PURE__*/ (0, $ih19M.jsxs)($bc5105c5a2910b11$var$StepRoot, (0, $4WYaH.default)({
        as: component,
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            connector && alternativeLabel && index !== 0 ? connector : null,
            children
        ]
    }));
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $3flqJ.default).Provider, {
        value: contextValue,
        children: connector && !alternativeLabel && index !== 0 ? /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
            children: [
                connector,
                newChildren
            ]
        }) : newChildren
    });
});
var $bc5105c5a2910b11$export$2e2bcd8739ae039 = $bc5105c5a2910b11$var$Step;

});
parcelRegister("5gLOS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d638a57c5512868$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
/**
 * Provides information about the current step in Stepper.
 */ const $3d638a57c5512868$var$StepperContext = /*#__PURE__*/ $bh6RR.createContext({});
function $3d638a57c5512868$export$1ff9b16b13b0447() {
    return $bh6RR.useContext($3d638a57c5512868$var$StepperContext);
}
var $3d638a57c5512868$export$2e2bcd8739ae039 = $3d638a57c5512868$var$StepperContext;

});

parcelRegister("3flqJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25d36569ebb7d565$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
/**
 * Provides information about the current step in Stepper.
 */ const $25d36569ebb7d565$var$StepContext = /*#__PURE__*/ $bh6RR.createContext({});
function $25d36569ebb7d565$export$90d5f24cfecec416() {
    return $bh6RR.useContext($25d36569ebb7d565$var$StepContext);
}
var $25d36569ebb7d565$export$2e2bcd8739ae039 = $25d36569ebb7d565$var$StepContext;

});

parcelRegister("aYw3D", function(module, exports) {

$parcel$export(module.exports, "getStepUtilityClass", function () { return $7fd85ff29b5ca624$export$8977e0f3c012cfac; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $7fd85ff29b5ca624$export$8977e0f3c012cfac(slot) {
    return (0, $XybB6.default)("MuiStep", slot);
}
const $7fd85ff29b5ca624$var$stepClasses = (0, $igcUF.default)("MuiStep", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel",
    "completed"
]);
var $7fd85ff29b5ca624$export$2e2bcd8739ae039 = $7fd85ff29b5ca624$var$stepClasses;

});


parcelRegister("7ISdU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59f6b416fe14eb18$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $kegFR = parcelRequire("kegFR");

var $5gLOS = parcelRequire("5gLOS");

var $3flqJ = parcelRequire("3flqJ");

var $gWPjx = parcelRequire("gWPjx");

var $ih19M = parcelRequire("ih19M");
"use client";
const $59f6b416fe14eb18$var$_excluded = [
    "children",
    "className",
    "componentsProps",
    "error",
    "icon",
    "optional",
    "slotProps",
    "StepIconComponent",
    "StepIconProps"
];
const $59f6b416fe14eb18$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, active: active, completed: completed, error: error, disabled: disabled, alternativeLabel: alternativeLabel } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            error && "error",
            disabled && "disabled",
            alternativeLabel && "alternativeLabel"
        ],
        label: [
            "label",
            active && "active",
            completed && "completed",
            error && "error",
            disabled && "disabled",
            alternativeLabel && "alternativeLabel"
        ],
        iconContainer: [
            "iconContainer",
            active && "active",
            completed && "completed",
            error && "error",
            disabled && "disabled",
            alternativeLabel && "alternativeLabel"
        ],
        labelContainer: [
            "labelContainer",
            alternativeLabel && "alternativeLabel"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $gWPjx.getStepLabelUtilityClass), classes);
};
const $59f6b416fe14eb18$var$StepLabelRoot = (0, $g4l1t.default)("span", {
    name: "MuiStepLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "flex",
        alignItems: "center",
        [`&.${(0, $gWPjx.default).alternativeLabel}`]: {
            flexDirection: "column"
        },
        [`&.${(0, $gWPjx.default).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.orientation === "vertical" && {
        textAlign: "left",
        padding: "8px 0"
    }));
const $59f6b416fe14eb18$var$StepLabelLabel = (0, $g4l1t.default)("span", {
    name: "MuiStepLabel",
    slot: "Label",
    overridesResolver: (props, styles)=>styles.label
})(({ theme: theme })=>(0, $4WYaH.default)({}, theme.typography.body2, {
        display: "block",
        transition: theme.transitions.create("color", {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $gWPjx.default).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $gWPjx.default).completed}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $gWPjx.default).alternativeLabel}`]: {
            marginTop: 16
        },
        [`&.${(0, $gWPjx.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $59f6b416fe14eb18$var$StepLabelIconContainer = (0, $g4l1t.default)("span", {
    name: "MuiStepLabel",
    slot: "IconContainer",
    overridesResolver: (props, styles)=>styles.iconContainer
})(()=>({
        flexShrink: 0,
        // Fix IE11 issue
        display: "flex",
        paddingRight: 8,
        [`&.${(0, $gWPjx.default).alternativeLabel}`]: {
            paddingRight: 0
        }
    }));
const $59f6b416fe14eb18$var$StepLabelLabelContainer = (0, $g4l1t.default)("span", {
    name: "MuiStepLabel",
    slot: "LabelContainer",
    overridesResolver: (props, styles)=>styles.labelContainer
})(({ theme: theme })=>({
        width: "100%",
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $gWPjx.default).alternativeLabel}`]: {
            textAlign: "center"
        }
    }));
const $59f6b416fe14eb18$var$StepLabel = /*#__PURE__*/ $bh6RR.forwardRef(function StepLabel(inProps, ref) {
    var _slotProps$label;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiStepLabel"
    });
    const { children: children, className: className, componentsProps: componentsProps = {}, error: error = false, icon: iconProp, optional: optional, slotProps: slotProps = {}, StepIconComponent: StepIconComponentProp, StepIconProps: StepIconProps } = props, other = (0, $hCIyK.default)(props, $59f6b416fe14eb18$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation } = $bh6RR.useContext((0, $5gLOS.default));
    const { active: active, disabled: disabled, completed: completed, icon: iconContext } = $bh6RR.useContext((0, $3flqJ.default));
    const icon = iconProp || iconContext;
    let StepIconComponent = StepIconComponentProp;
    if (icon && !StepIconComponent) StepIconComponent = (0, $kegFR.default);
    const ownerState = (0, $4WYaH.default)({}, props, {
        active: active,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        error: error,
        orientation: orientation
    });
    const classes = $59f6b416fe14eb18$var$useUtilityClasses(ownerState);
    const labelSlotProps = (_slotProps$label = slotProps.label) != null ? _slotProps$label : componentsProps.label;
    return /*#__PURE__*/ (0, $ih19M.jsxs)($59f6b416fe14eb18$var$StepLabelRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            icon || StepIconComponent ? /*#__PURE__*/ (0, $ih19M.jsx)($59f6b416fe14eb18$var$StepLabelIconContainer, {
                className: classes.iconContainer,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ih19M.jsx)(StepIconComponent, (0, $4WYaH.default)({
                    completed: completed,
                    active: active,
                    error: error,
                    icon: icon
                }, StepIconProps))
            }) : null,
            /*#__PURE__*/ (0, $ih19M.jsxs)($59f6b416fe14eb18$var$StepLabelLabelContainer, {
                className: classes.labelContainer,
                ownerState: ownerState,
                children: [
                    children ? /*#__PURE__*/ (0, $ih19M.jsx)($59f6b416fe14eb18$var$StepLabelLabel, (0, $4WYaH.default)({
                        ownerState: ownerState
                    }, labelSlotProps, {
                        className: (0, $aPsoC.default)(classes.label, labelSlotProps == null ? void 0 : labelSlotProps.className),
                        children: children
                    })) : null,
                    optional
                ]
            })
        ]
    }));
});
$59f6b416fe14eb18$var$StepLabel.muiName = "StepLabel";
var $59f6b416fe14eb18$export$2e2bcd8739ae039 = $59f6b416fe14eb18$var$StepLabel;

});
parcelRegister("kegFR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eba20c92d7a2dec1$export$2e2bcd8739ae039; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $7VpyN = parcelRequire("7VpyN");

var $5YRAi = parcelRequire("5YRAi");

var $35wch = parcelRequire("35wch");

var $2Rs8L = parcelRequire("2Rs8L");

var $ih19M = parcelRequire("ih19M");
"use client";
var $eba20c92d7a2dec1$var$_circle;
const $eba20c92d7a2dec1$var$_excluded = [
    "active",
    "className",
    "completed",
    "error",
    "icon"
];
const $eba20c92d7a2dec1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, active: active, completed: completed, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            active && "active",
            completed && "completed",
            error && "error"
        ],
        text: [
            "text"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $2Rs8L.getStepIconUtilityClass), classes);
};
const $eba20c92d7a2dec1$var$StepIconRoot = (0, $g4l1t.default)((0, $35wch.default), {
    name: "MuiStepIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: "block",
        transition: theme.transitions.create("color", {
            duration: theme.transitions.duration.shortest
        }),
        color: (theme.vars || theme).palette.text.disabled,
        [`&.${(0, $2Rs8L.default).completed}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $2Rs8L.default).active}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $2Rs8L.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $eba20c92d7a2dec1$var$StepIconText = (0, $g4l1t.default)("text", {
    name: "MuiStepIcon",
    slot: "Text",
    overridesResolver: (props, styles)=>styles.text
})(({ theme: theme })=>({
        fill: (theme.vars || theme).palette.primary.contrastText,
        fontSize: theme.typography.caption.fontSize,
        fontFamily: theme.typography.fontFamily
    }));
const $eba20c92d7a2dec1$var$StepIcon = /*#__PURE__*/ $bh6RR.forwardRef(function StepIcon(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiStepIcon"
    });
    const { active: active = false, className: classNameProp, completed: completed = false, error: error = false, icon: icon } = props, other = (0, $hCIyK.default)(props, $eba20c92d7a2dec1$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        active: active,
        completed: completed,
        error: error
    });
    const classes = $eba20c92d7a2dec1$var$useUtilityClasses(ownerState);
    if (typeof icon === "number" || typeof icon === "string") {
        const className = (0, $aPsoC.default)(classNameProp, classes.root);
        if (error) return /*#__PURE__*/ (0, $ih19M.jsx)($eba20c92d7a2dec1$var$StepIconRoot, (0, $4WYaH.default)({
            as: (0, $5YRAi.default),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        if (completed) return /*#__PURE__*/ (0, $ih19M.jsx)($eba20c92d7a2dec1$var$StepIconRoot, (0, $4WYaH.default)({
            as: (0, $7VpyN.default),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        return /*#__PURE__*/ (0, $ih19M.jsxs)($eba20c92d7a2dec1$var$StepIconRoot, (0, $4WYaH.default)({
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                $eba20c92d7a2dec1$var$_circle || ($eba20c92d7a2dec1$var$_circle = /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "12"
                })),
                /*#__PURE__*/ (0, $ih19M.jsx)($eba20c92d7a2dec1$var$StepIconText, {
                    className: classes.text,
                    x: "12",
                    y: "12",
                    textAnchor: "middle",
                    dominantBaseline: "central",
                    ownerState: ownerState,
                    children: icon
                })
            ]
        }));
    }
    return icon;
});
var $eba20c92d7a2dec1$export$2e2bcd8739ae039 = $eba20c92d7a2dec1$var$StepIcon;

});
parcelRegister("7VpyN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c51af06132f09c6$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $5c51af06132f09c6$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), "CheckCircle");

});

parcelRegister("5YRAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45ac1f1ae5efa7f4$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $45ac1f1ae5efa7f4$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning");

});

parcelRegister("2Rs8L", function(module, exports) {

$parcel$export(module.exports, "getStepIconUtilityClass", function () { return $21565c18d10189ee$export$62a6e0748bec9297; });
$parcel$export(module.exports, "default", function () { return $21565c18d10189ee$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $21565c18d10189ee$export$62a6e0748bec9297(slot) {
    return (0, $XybB6.default)("MuiStepIcon", slot);
}
const $21565c18d10189ee$var$stepIconClasses = (0, $igcUF.default)("MuiStepIcon", [
    "root",
    "active",
    "completed",
    "error",
    "text"
]);
var $21565c18d10189ee$export$2e2bcd8739ae039 = $21565c18d10189ee$var$stepIconClasses;

});


parcelRegister("gWPjx", function(module, exports) {

$parcel$export(module.exports, "getStepLabelUtilityClass", function () { return $c569de09d0cffecf$export$9625a725551d158a; });
$parcel$export(module.exports, "default", function () { return $c569de09d0cffecf$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $c569de09d0cffecf$export$9625a725551d158a(slot) {
    return (0, $XybB6.default)("MuiStepLabel", slot);
}
const $c569de09d0cffecf$var$stepLabelClasses = (0, $igcUF.default)("MuiStepLabel", [
    "root",
    "horizontal",
    "vertical",
    "label",
    "active",
    "completed",
    "error",
    "disabled",
    "iconContainer",
    "alternativeLabel",
    "labelContainer"
]);
var $c569de09d0cffecf$export$2e2bcd8739ae039 = $c569de09d0cffecf$var$stepLabelClasses;

});


parcelRegister("4F9C5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $365272c71a1bbd03$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $7J7Kn = parcelRequire("7J7Kn");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $bdze5 = parcelRequire("bdze5");

var $bsGRh = parcelRequire("bsGRh");

var $5gLOS = parcelRequire("5gLOS");

var $ih19M = parcelRequire("ih19M");
"use client";
const $365272c71a1bbd03$var$_excluded = [
    "activeStep",
    "alternativeLabel",
    "children",
    "className",
    "component",
    "connector",
    "nonLinear",
    "orientation"
];
const $365272c71a1bbd03$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, alternativeLabel: alternativeLabel, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $bdze5.getStepperUtilityClass), classes);
};
const $365272c71a1bbd03$var$StepperRoot = (0, $g4l1t.default)("div", {
    name: "MuiStepper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "flex"
    }, ownerState.orientation === "horizontal" && {
        flexDirection: "row",
        alignItems: "center"
    }, ownerState.orientation === "vertical" && {
        flexDirection: "column"
    }, ownerState.alternativeLabel && {
        alignItems: "flex-start"
    }));
const $365272c71a1bbd03$var$defaultConnector = /*#__PURE__*/ (0, $ih19M.jsx)((0, $bsGRh.default), {});
const $365272c71a1bbd03$var$Stepper = /*#__PURE__*/ $bh6RR.forwardRef(function Stepper(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiStepper"
    });
    const { activeStep: activeStep = 0, alternativeLabel: alternativeLabel = false, children: children, className: className, component: component = "div", connector: connector = $365272c71a1bbd03$var$defaultConnector, nonLinear: nonLinear = false, orientation: orientation = "horizontal" } = props, other = (0, $hCIyK.default)(props, $365272c71a1bbd03$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        component: component
    });
    const classes = $365272c71a1bbd03$var$useUtilityClasses(ownerState);
    const childrenArray = $bh6RR.Children.toArray(children).filter(Boolean);
    const steps = childrenArray.map((step, index)=>{
        return /*#__PURE__*/ $bh6RR.cloneElement(step, (0, $4WYaH.default)({
            index: index,
            last: index + 1 === childrenArray.length
        }, step.props));
    });
    const contextValue = $bh6RR.useMemo(()=>({
            activeStep: activeStep,
            alternativeLabel: alternativeLabel,
            connector: connector,
            nonLinear: nonLinear,
            orientation: orientation
        }), [
        activeStep,
        alternativeLabel,
        connector,
        nonLinear,
        orientation
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5gLOS.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ih19M.jsx)($365272c71a1bbd03$var$StepperRoot, (0, $4WYaH.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $aPsoC.default)(classes.root, className),
            ref: ref
        }, other, {
            children: steps
        }))
    });
});
var $365272c71a1bbd03$export$2e2bcd8739ae039 = $365272c71a1bbd03$var$Stepper;

});
parcelRegister("bdze5", function(module, exports) {

$parcel$export(module.exports, "getStepperUtilityClass", function () { return $82ac3bc82c07ca77$export$797947b6292e28e1; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $82ac3bc82c07ca77$export$797947b6292e28e1(slot) {
    return (0, $XybB6.default)("MuiStepper", slot);
}
const $82ac3bc82c07ca77$var$stepperClasses = (0, $igcUF.default)("MuiStepper", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel"
]);
var $82ac3bc82c07ca77$export$2e2bcd8739ae039 = $82ac3bc82c07ca77$var$stepperClasses;

});

parcelRegister("bsGRh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85838e04f64c6c02$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $fGH8N = parcelRequire("fGH8N");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $5gLOS = parcelRequire("5gLOS");

var $3flqJ = parcelRequire("3flqJ");

var $ddVQH = parcelRequire("ddVQH");

var $ih19M = parcelRequire("ih19M");
"use client";
const $85838e04f64c6c02$var$_excluded = [
    "className"
];
const $85838e04f64c6c02$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, active: active, completed: completed, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel",
            active && "active",
            completed && "completed",
            disabled && "disabled"
        ],
        line: [
            "line",
            `line${(0, $fGH8N.default)(orientation)}`
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $ddVQH.getStepConnectorUtilityClass), classes);
};
const $85838e04f64c6c02$var$StepConnectorRoot = (0, $g4l1t.default)("div", {
    name: "MuiStepConnector",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        flex: "1 1 auto"
    }, ownerState.orientation === "vertical" && {
        marginLeft: 12 // half icon
    }, ownerState.alternativeLabel && {
        position: "absolute",
        top: 12,
        left: "calc(-50% + 20px)",
        right: "calc(50% + 20px)"
    }));
const $85838e04f64c6c02$var$StepConnectorLine = (0, $g4l1t.default)("span", {
    name: "MuiStepConnector",
    slot: "Line",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.line,
            styles[`line${(0, $fGH8N.default)(ownerState.orientation)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[600];
    return (0, $4WYaH.default)({
        display: "block",
        borderColor: theme.vars ? theme.vars.palette.StepConnector.border : borderColor
    }, ownerState.orientation === "horizontal" && {
        borderTopStyle: "solid",
        borderTopWidth: 1
    }, ownerState.orientation === "vertical" && {
        borderLeftStyle: "solid",
        borderLeftWidth: 1,
        minHeight: 24
    });
});
const $85838e04f64c6c02$var$StepConnector = /*#__PURE__*/ $bh6RR.forwardRef(function StepConnector(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiStepConnector"
    });
    const { className: className } = props, other = (0, $hCIyK.default)(props, $85838e04f64c6c02$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation = "horizontal" } = $bh6RR.useContext((0, $5gLOS.default));
    const { active: active, disabled: disabled, completed: completed } = $bh6RR.useContext((0, $3flqJ.default));
    const ownerState = (0, $4WYaH.default)({}, props, {
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        active: active,
        completed: completed,
        disabled: disabled
    });
    const classes = $85838e04f64c6c02$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($85838e04f64c6c02$var$StepConnectorRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)($85838e04f64c6c02$var$StepConnectorLine, {
            className: classes.line,
            ownerState: ownerState
        })
    }));
});
var $85838e04f64c6c02$export$2e2bcd8739ae039 = $85838e04f64c6c02$var$StepConnector;

});
parcelRegister("ddVQH", function(module, exports) {

$parcel$export(module.exports, "getStepConnectorUtilityClass", function () { return $9a095cdc65f409ac$export$6fbaff484b0d9308; });
$parcel$export(module.exports, "default", function () { return $9a095cdc65f409ac$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $9a095cdc65f409ac$export$6fbaff484b0d9308(slot) {
    return (0, $XybB6.default)("MuiStepConnector", slot);
}
const $9a095cdc65f409ac$var$stepConnectorClasses = (0, $igcUF.default)("MuiStepConnector", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel",
    "active",
    "completed",
    "disabled",
    "line",
    "lineHorizontal",
    "lineVertical"
]);
var $9a095cdc65f409ac$export$2e2bcd8739ae039 = $9a095cdc65f409ac$var$stepConnectorClasses;

});








parcelRegister("edHg5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $838b101cfd7eca2b$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $8QeQV = parcelRequire("8QeQV");
var $8jEtO = parcelRequire("8jEtO");

var $chLJv = parcelRequire("chLJv");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $b1v75 = parcelRequire("b1v75");

var $hjfla = parcelRequire("hjfla");

var $eBMvL = parcelRequire("eBMvL");

var $ahwrv = parcelRequire("ahwrv");

var $j5ie7 = parcelRequire("j5ie7");

var $8d818 = parcelRequire("8d818");

var $gN2iE = parcelRequire("gN2iE");
const $838b101cfd7eca2b$var$ProductInfoWrapper = ()=>{
    const location = (0, $99w1R.useLocation)();
    const navigate = (0, $99w1R.useNavigate)();
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [product, setProduct] = (0, $bh6RR.useState)(null);
    const [tabValue, setTabValue] = (0, $bh6RR.useState)(0);
    const locationElements = location.pathname.split("/").filter((e)=>e);
    const { data: data } = (0, $hjfla.useProductQuery)({
        variables: {
            id: parseInt(locationElements[locationElements.length - 1])
        },
        fetchPolicy: "no-cache"
    });
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            dispatch({
                type: (0, $ayVxz.Actions).SetSelectedProduct,
                payload: {
                    name: data.result.name
                }
            });
            setProduct(data.result);
        }
    }, [
        data
    ]);
    const handleToProductsOverview = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).ResetSelectedProduct
        });
        navigate((0, $b1v75.AuthRoutes).Products);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ahwrv.default), {
                handleToOverview: handleToProductsOverview,
                navName: (0, $b1v75.RouteNames).Products,
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $8QeQV.default), {
                            sx: {
                                marginRight: "7px"
                            }
                        }),
                        state.selectedProduct || product?.name
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eBMvL.default), {
                        value: tabValue,
                        handleChange: (_, newValue)=>setTabValue(newValue),
                        tabProps: [
                            {
                                id: "product-details",
                                title: "Details",
                                icon: (0, $8jEtO.default)
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                            value: tabValue,
                            index: 0,
                            children: product ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $gN2iE.default), {
                                product: product
                            }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                                loading: true
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $838b101cfd7eca2b$export$2e2bcd8739ae039 = $838b101cfd7eca2b$var$ProductInfoWrapper;

});
parcelRegister("gN2iE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6b86798cedb8121$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");

var $eBMvL = parcelRequire("eBMvL");

var $5DXc5 = parcelRequire("5DXc5");

var $j5ie7 = parcelRequire("j5ie7");

var $6zpgu = parcelRequire("6zpgu");

var $fXFpy = parcelRequire("fXFpy");
const $e6b86798cedb8121$var$ProductDetailsTabs = ({ product: product })=>{
    const [value, setValue] = (0, $bh6RR.useState)(0);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        className: "centralize",
        sx: {
            width: "100%",
            paddingTop: "80px"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5DXc5.default), {
            width: "82%",
            additionalStyle: {
                height: "680px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $eBMvL.default), {
                    type: "third",
                    value: value,
                    handleChange: (_, newValue)=>setValue(newValue),
                    tabProps: [
                        {
                            id: "product-general-tab",
                            title: "General"
                        },
                        {
                            id: "product-email-tab",
                            title: "Email"
                        }
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                    value: value,
                    index: 0,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $6zpgu.default), {
                        product: product
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                    value: value,
                    index: 1,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $fXFpy.default), {
                        product: product
                    })
                })
            ]
        })
    });
};
var $e6b86798cedb8121$export$2e2bcd8739ae039 = $e6b86798cedb8121$var$ProductDetailsTabs;

});
parcelRegister("6zpgu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd2fe340453e2535$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");

var $hjfla = parcelRequire("hjfla");

var $bSbwb = parcelRequire("bSbwb");

var $bu31C = parcelRequire("bu31C");

var $dqRXb = parcelRequire("dqRXb");

var $gUBkJ = parcelRequire("gUBkJ");

var $6L9uu = parcelRequire("6L9uu");

var $ktnmN = parcelRequire("ktnmN");

var $ayVxz = parcelRequire("ayVxz");

var $gFVvY = parcelRequire("gFVvY");

var $ehzwo = parcelRequire("ehzwo");

var $bilGR = parcelRequire("bilGR");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $aMeZy = parcelRequire("aMeZy");
const $bd2fe340453e2535$var$ProductGeneralTab = ({ product: product })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const membershipTypes = (0, $hjfla.useMembershipTypeOptionsQuery)({
        fetchPolicy: "no-cache"
    });
    const [getProductCodes, productCodesResult] = (0, $hjfla.useProductCodesLazyQuery)();
    const [editable, setEditable] = (0, $bh6RR.useState)(false);
    const [name, setName] = (0, $bh6RR.useState)(product.name);
    const [productCode, setProductCode] = (0, $bh6RR.useState)(product.product_code);
    const [membershipType, setMembershipType] = (0, $bh6RR.useState)(product.membership_type);
    const [price, setPrice] = (0, $bh6RR.useState)(product.price);
    const [vat, setVat] = (0, $bh6RR.useState)(product.vat);
    const [bottomNotes, setBottomNotes] = (0, $bh6RR.useState)(product.bottom_notes || "");
    const [productCodesOptions, setProductCodesOptions] = (0, $bh6RR.useState)([
        product.product_code
    ]);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)((0, $ktnmN.defaultErrorsObj));
    const [updateProduct, { data: data, loading: loading }] = (0, $hjfla.useUpdateProductGeneralInfoMutation)();
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Product);
    const handleEditClicked = ()=>{
        getProductCodes();
        setEditable(true);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (productCodesResult.data && productCodesResult.data.result) setProductCodesOptions(productCodesResult.data.result);
    }, [
        productCodesResult.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            setEditable(false);
            dispatch({
                type: (0, $ayVxz.Actions).SetSelectedProduct,
                payload: {
                    name: data.result.name
                }
            });
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: `Product ${data.result.name} updated`,
                    severity: "success"
                }
            });
        }
    }, [
        data
    ]);
    const handleProductCodeChanged = (_, newValue)=>{
        if (newValue) setFormErrors({
            ...formErrors,
            productCode: null
        });
        else setFormErrors({
            ...formErrors,
            productCode: (0, $ktnmN.ErrorTexts).productCode
        });
        setMembershipType(null);
        setProductCode(newValue);
    };
    const handleNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!value || value.length < 2) setFormErrors({
            ...formErrors,
            name: (0, $ktnmN.ErrorTexts).name
        });
        else setFormErrors({
            ...formErrors,
            name: null
        });
        setName(value);
    };
    const handlePriceChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value && Number(value) >= 0) setFormErrors({
            ...formErrors,
            price: null
        });
        else setFormErrors({
            ...formErrors,
            price: (0, $ktnmN.ErrorTexts).price
        });
        setPrice(Number(value));
    };
    const handleVatChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value && (Number(value) < 0 || Number(value) > 100)) setFormErrors({
            ...formErrors,
            vatRange: (0, $ktnmN.ErrorTexts).vatRange
        });
        else setFormErrors({
            ...formErrors,
            vatRange: null
        });
        setVat(Number(value));
    };
    const handleCancel = ()=>{
        setName(product.name);
        setProductCode(product.product_code);
        setBottomNotes(product.bottom_notes);
        setMembershipType(product.membership_type);
        setVat(product.vat);
        setPrice(product.price);
        setFormErrors((0, $ktnmN.defaultErrorsObj));
        setEditable(false);
    };
    const submitForm = ()=>{
        const errors = {
            name: null,
            productCode: null,
            price: null,
            vatRange: null
        };
        let hasErrors = false;
        if (!name || name.length < 2) {
            hasErrors = true;
            errors.name = (0, $ktnmN.ErrorTexts).name;
        }
        if (!productCode) {
            hasErrors = true;
            errors.productCode = (0, $ktnmN.ErrorTexts).productCode;
        }
        if (!price || price < 0) {
            hasErrors = true;
            errors.price = (0, $ktnmN.ErrorTexts).price;
        }
        if (vat && (vat < 0 || vat > 100)) {
            hasErrors = true;
            errors.vatRange = (0, $ktnmN.ErrorTexts).vatRange;
        }
        if (!hasErrors && name.trim().toUpperCase() !== product.name.toUpperCase() && (0, $gFVvY.sameProductNameExists)(name.trim(), product.id)) {
            hasErrors = true;
            errors.name = (0, $ktnmN.ErrorTexts).nameExists;
        }
        if (hasErrors) setFormErrors(errors);
        else submitProduct();
    };
    const submitProduct = ()=>{
        const { email_subject: email_subject, email_banner: email_banner, email_body: email_body } = product;
        updateProduct({
            variables: {
                id: parseInt(product.id),
                input: {
                    name: name.trim(),
                    product_code_id: parseInt(productCode?.id),
                    price: price,
                    vat: vat,
                    membership_type_id: membershipType ? Number(membershipType.id) : null,
                    bottom_notes: bottomNotes ? bottomNotes.trim() : null,
                    email_subject: email_subject,
                    email_banner: email_banner,
                    email_body: email_body
                }
            }
        }).catch((e)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message.slice(15),
                    autoHide: 6000
                }
            }));
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            pt: "150px",
            px: "12%",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    position: "absolute",
                    top: "24px",
                    right: "24px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "contact-general-edit-button",
                    onClick: handleEditClicked,
                    disabled: !canEdit || editable,
                    editButtonColor: !canEdit || editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    columnGap: "10%"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            display: "grid",
                            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                            gap: "45px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "product-general-name",
                                label: "Name",
                                value: name,
                                onChange: handleNameChange,
                                disabled: !editable || loading,
                                errorMsg: formErrors.name,
                                additionalStyle: {
                                    gridColumn: "span 2"
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "product-general-product-code",
                                label: "Product Code",
                                options: productCodesOptions,
                                getOptionLabel: (option)=>option.name,
                                disabled: !editable || loading,
                                onChange: handleProductCodeChanged,
                                values: productCode,
                                errorMsg: formErrors.productCode
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "product-general-membership-type",
                                label: "Membership type",
                                options: membershipTypes.data?.result.membership_types || [],
                                getOptionLabel: (option)=>option?.name,
                                disabled: !editable || productCode?.name !== (0, $aMeZy.RB_NAME) || loading,
                                values: membershipType,
                                onChange: (_, newValue)=>setMembershipType(newValue)
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "product-general-price",
                                label: "Price",
                                type: "number",
                                value: price,
                                onChange: handlePriceChange,
                                disabled: !editable || loading,
                                errorMsg: formErrors.price
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "product-general-vat",
                                label: "VAT %",
                                type: "number",
                                value: vat || "",
                                onChange: handleVatChange,
                                disabled: !editable || loading,
                                errorMsg: formErrors.vatRange,
                                required: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "product-general-bottom-notes",
                        label: "Bottom notes",
                        value: bottomNotes || "",
                        onChange: (e)=>setBottomNotes(e.currentTarget.value),
                        multiline: true,
                        rows: 9,
                        disabled: !editable || loading
                    })
                ]
            }),
            editable && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    marginTop: "60px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "product-general-cancel-button",
                        disabled: loading,
                        onClick: handleCancel,
                        text: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "product-general-save-button",
                        disabled: loading,
                        onClick: submitForm,
                        text: "Save"
                    })
                ]
            })
        ]
    });
};
var $bd2fe340453e2535$export$2e2bcd8739ae039 = $bd2fe340453e2535$var$ProductGeneralTab;

});

parcelRegister("fXFpy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00a51a63a78fa200$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $2cvMN = parcelRequire("2cvMN");

var $hjfla = parcelRequire("hjfla");

var $bSbwb = parcelRequire("bSbwb");

var $bu31C = parcelRequire("bu31C");

var $gUBkJ = parcelRequire("gUBkJ");

var $dqRXb = parcelRequire("dqRXb");

var $ayVxz = parcelRequire("ayVxz");

var $6L9uu = parcelRequire("6L9uu");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $ehzwo = parcelRequire("ehzwo");

var $hsjD5 = parcelRequire("hsjD5");

var $g1rUG = parcelRequire("g1rUG");
const $00a51a63a78fa200$var$imageContainerDimensions = {
    height: "210px",
    backupMarginTop: 42
};
const $00a51a63a78fa200$var$ProductEmailTab = ({ product: product })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [editable, setEditable] = (0, $bh6RR.useState)(false);
    const [subject, setSubject] = (0, $bh6RR.useState)(product.email_subject);
    const [emailBanner, setEmailBanner] = (0, $bh6RR.useState)(product.email_banner);
    const [emailBody, setEmailBody] = (0, $bh6RR.useState)(product.email_body || "");
    const [updateProduct, { data: data, loading: loading }] = (0, $hjfla.useUpdateProductEmailInfoMutation)();
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Product);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            setEditable(false);
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: `Product ${data.result.name} updated`,
                    severity: "success"
                }
            });
        }
    }, [
        data
    ]);
    const handleCancel = ()=>{
        setSubject(product.email_subject);
        setEmailBanner(product.email_banner);
        setEditable(false);
        setEmailBody(product.email_body || "");
    };
    const submitForm = ()=>{
        updateProduct({
            variables: {
                id: parseInt(product.id),
                input: {
                    email_subject: subject ? subject.trim() : null,
                    email_body: emailBody ? emailBody.trim() : null,
                    email_banner: emailBanner ? emailBanner.trim() : null
                }
            }
        }).catch((e)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message.slice(15),
                    autoHide: 6000
                }
            }));
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            pt: "150px",
            px: "12%",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    position: "absolute",
                    top: "24px",
                    right: "24px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "contact-general-edit-button",
                    onClick: ()=>setEditable(true),
                    disabled: !canEdit || editable,
                    editButtonColor: !canEdit || editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    columnGap: "10%"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "50px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "product-email-subject",
                                label: "Email Subject",
                                value: subject || "",
                                onChange: (e)=>setSubject(e.currentTarget.value),
                                disabled: !editable || loading
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                                id: "product-email-banner-container",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                                        id: "product-email-banner-header",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                                                style: {
                                                    color: (0, $hsjD5.getLabelColor)(editable)
                                                },
                                                children: "Email Banner"
                                            }),
                                            editable && emailBanner && /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                                                id: "product-clear-banner",
                                                style: {
                                                    width: "auto",
                                                    float: "right",
                                                    marginTop: "-10px"
                                                },
                                                onClick: ()=>setEmailBanner(null),
                                                disabled: !emailBanner || loading,
                                                children: "Clear"
                                            })
                                        ]
                                    }),
                                    emailBanner ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $2cvMN.default), {
                                        style: {
                                            maxHeight: $00a51a63a78fa200$var$imageContainerDimensions.height,
                                            marginTop: "12px"
                                        },
                                        component: "img",
                                        src: emailBanner
                                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $g1rUG.default), {
                                        editable: editable,
                                        loading: loading,
                                        setImage: setEmailBanner,
                                        dimensions: $00a51a63a78fa200$var$imageContainerDimensions
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "product-email-body",
                        label: "Email body",
                        value: emailBody,
                        onChange: (e)=>setEmailBody(e.currentTarget.value),
                        multiline: true,
                        rows: 14,
                        disabled: !editable || loading
                    })
                ]
            }),
            editable && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    marginTop: "60px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "product-email-cancel-button",
                        disabled: loading,
                        onClick: handleCancel,
                        text: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "product-email-save-button",
                        disabled: loading,
                        onClick: submitForm,
                        text: "Save"
                    })
                ]
            })
        ]
    });
};
var $00a51a63a78fa200$export$2e2bcd8739ae039 = $00a51a63a78fa200$var$ProductEmailTab;

});



parcelRegister("j5zPy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f639a15ccb68e8e9$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");

var $eBMvL = parcelRequire("eBMvL");

var $jIjZr = parcelRequire("jIjZr");

var $iphId = parcelRequire("iphId");

var $iobYD = parcelRequire("iobYD");

var $j5ie7 = parcelRequire("j5ie7");

var $76U2c = parcelRequire("76U2c");

var $lDzda = parcelRequire("lDzda");
const $f639a15ccb68e8e9$var$IndexInfoWrapper = ()=>{
    const [value, setValue] = (0, $bh6RR.useState)(0);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        style: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $eBMvL.default), {
                    value: value,
                    handleChange: (_, newValue)=>setValue(newValue),
                    type: "first",
                    tabProps: [
                        {
                            id: "membership-details",
                            title: "Indexes",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jIjZr)))
                        },
                        {
                            id: "membership-companies",
                            title: "Index series",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iphId)))
                        },
                        {
                            id: "membership-contacts",
                            title: "Data history",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iobYD)))
                        }
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                        value: value,
                        index: 0,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $76U2c.default), {})
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                    value: value,
                    index: 1,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lDzda.default), {})
                })
            ]
        })
    });
};
var $f639a15ccb68e8e9$export$2e2bcd8739ae039 = $f639a15ccb68e8e9$var$IndexInfoWrapper;

});
parcelRegister("jIjZr", function(module, exports) {
"use strict";
"use client";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5a1a1f8bb875832$var$_createSvgIcon = $2ZnTs((parcelRequire("lpAdr")));

var $ih19M = parcelRequire("ih19M");
var $e5a1a1f8bb875832$var$_default = module.exports.default = (0, $e5a1a1f8bb875832$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5m0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5m0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5M7 19h14v-2H7zm0-6h14v-2H7zm0-8v2h14V5z"
}), "FormatListBulleted");

});
parcelRegister("lpAdr", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7B0TL.default;
    }
});

var $7B0TL = parcelRequire("7B0TL");

});


parcelRegister("iphId", function(module, exports) {
"use strict";
"use client";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d6684d10e5dd0516$var$_createSvgIcon = $2ZnTs((parcelRequire("lpAdr")));

var $ih19M = parcelRequire("ih19M");
var $d6684d10e5dd0516$var$_default = module.exports.default = (0, $d6684d10e5dd0516$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M17.5 4.5c-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .65.73.45.75.45C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.41.21.75-.19.75-.45V6c-1.49-1.12-3.63-1.5-5.5-1.5m3.5 14c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5z"
}), "ImportContacts");

});

parcelRegister("iobYD", function(module, exports) {
"use strict";
"use client";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d633c23e876dd1bf$var$_createSvgIcon = $2ZnTs((parcelRequire("lpAdr")));

var $ih19M = parcelRequire("ih19M");
var $d633c23e876dd1bf$var$_default = module.exports.default = (0, $d633c23e876dd1bf$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9m-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8z"
}), "History");

});

parcelRegister("76U2c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a64f6c72c9c66c6$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $22Joh = parcelRequire("22Joh");

var $lNwVA = parcelRequire("lNwVA");

var $2Mzms = parcelRequire("2Mzms");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");

var $ayVxz = parcelRequire("ayVxz");

var $d7fM7 = parcelRequire("d7fM7");

var $hsjD5 = parcelRequire("hsjD5");

var $lPOf7 = parcelRequire("lPOf7");

var $bbr3I = parcelRequire("bbr3I");

var $89Htj = parcelRequire("89Htj");

var $6QTYz = parcelRequire("6QTYz");

var $hO5gu = parcelRequire("hO5gu");
const $4a64f6c72c9c66c6$var$IndexList = ()=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const { data: data, loading: loading } = (0, $hjfla.useIndicesQuery)();
    const [deleteIndex] = (0, $hjfla.useDeleteIndexMutation)();
    const [allData, setAllData] = (0, $bh6RR.useState)([]);
    const [index, setIndex] = (0, $bh6RR.useState)(null);
    const [openCreateIndexForm, setOpenCreateIndexForm] = (0, $bh6RR.useState)(false);
    const [openConstituentsForm, setOpenConstituentsForm] = (0, $bh6RR.useState)(false);
    const canCreate = (0, $dqRXb.canUserCreate)(state.user, (0, $gUBkJ.Types).Index);
    const [openUpload, setOpenUpload] = (0, $bh6RR.useState)(false);
    const [openExportHIDataForm, setOpenExportHIDataForm] = (0, $bh6RR.useState)(false);
    const [selectedIndex, setSelectedIndex] = (0, $bh6RR.useState)(null);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setAllData(data.result);
    }, [
        data
    ]);
    const handleConstituentsClicked = (rowData)=>{
        setIndex(rowData);
        setOpenConstituentsForm(true);
    };
    const handleConstituentsClosed = ()=>{
        setOpenConstituentsForm(false);
    };
    const isOnlineStatus = (rowData)=>/*#__PURE__*/ (0, $ih19M.jsx)("img", {
            className: "m-auto",
            src: rowData.is_online ? (0, (/*@__PURE__*/$parcel$interopDefault($22Joh))) : (0, (/*@__PURE__*/$parcel$interopDefault($lNwVA))),
            alt: "mainStatus"
        });
    const renderConstituentsColumn = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: rowData.id,
            onClick: ()=>handleConstituentsClicked(rowData),
            children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($2Mzms))),
                alt: "excelButton"
            })
        });
    };
    const handleClose = (saved, isNew, indexInput)=>{
        if (saved && indexInput) {
            if (isNew) addIndex(indexInput);
        }
        setIndex(null);
        setOpenCreateIndexForm(false);
    };
    const addIndex = (input)=>{
        const existing = allData.find((d)=>d.id === input.id);
        if (!existing) setAllData([
            input,
            ...allData
        ]);
    };
    const handleDetails = (rowData)=>{
        setIndex(rowData);
        setOpenCreateIndexForm(true);
    };
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${rowData.name} index?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleDelete = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteIndex({
            variables: {
                id: rowData.id
            },
            update (cache) {
                const indexListQuery = cache.readQuery({
                    query: (0, $hjfla.IndicesDocument)
                });
                if (indexListQuery.result) {
                    const cachedIndex = indexListQuery.result.findIndex((i)=>i?.id === rowData.id);
                    if (cachedIndex > -1) {
                        const data = indexListQuery.result.filter((i)=>i?.id !== rowData.id);
                        cache.writeQuery({
                            query: (0, $hjfla.IndicesDocument),
                            data: {
                                result: data
                            }
                        });
                    }
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: e.message,
                    severity: "error"
                }
            });
        });
        dispatch({
            type: (0, $ayVxz.Actions).ShowMessage,
            payload: {
                text: `${rowData.name} index deleted`,
                severity: "success"
            }
        });
    };
    const renderExportHIData = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: rowData.id,
            sx: {
                width: "auto"
            },
            onClick: ()=>{
                setOpenExportHIDataForm(true);
                setSelectedIndex(rowData);
            },
            children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6QTYz))),
                alt: "removeButton"
            })
        });
    };
    const columns = [
        {
            title: "Details",
            width: 64,
            sorting: false
        },
        {
            title: "ID",
            field: "id",
            type: "numeric",
            width: 53
        },
        {
            title: "Constituents",
            width: 101,
            render: renderConstituentsColumn
        },
        {
            title: "Online",
            field: "is_online",
            render: isOnlineStatus,
            type: "boolean",
            width: 61
        },
        {
            title: "Country",
            field: "country.name",
            width: 110
        },
        {
            title: "Local Currency",
            field: "currency.code",
            width: 135
        },
        {
            title: "Code",
            field: "code",
            width: 111
        },
        {
            title: "Net Code",
            field: "net_code",
            width: 137
        },
        {
            title: "Name",
            field: "name",
            width: 500
        },
        {
            title: "Name Identifier",
            field: "identifier",
            width: 377
        },
        {
            title: "Export HI Data",
            width: 30,
            sorting: false,
            render: renderExportHIData
        },
        {
            title: "Remove",
            width: 71,
            sorting: false
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "overviewPage",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                columns: columns,
                data: (0, $hsjD5.FormatTableData)(allData),
                loading: loading,
                handleDetails: handleDetails,
                handleRemove: handleRemove,
                pageSize: 15,
                createButtonProps: {
                    id: "create-index-button",
                    onClick: ()=>setOpenCreateIndexForm(true),
                    text: "Create index",
                    disabled: !canCreate
                },
                importButtonProps: {
                    id: "import-index-data",
                    onClick: ()=>setOpenUpload(true)
                }
            }),
            openCreateIndexForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $lPOf7.default), {
                handleClose: handleClose,
                indexInput: index
            }),
            openConstituentsForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $bbr3I.default), {
                handleClose: handleConstituentsClosed,
                indexId: index?.id
            }),
            openUpload && /*#__PURE__*/ (0, $ih19M.jsx)((0, $89Htj.default), {
                handleClose: ()=>setOpenUpload(false),
                isIndexFile: true
            }),
            openExportHIDataForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $hO5gu.default), {
                handleClose: ()=>{
                    setOpenExportHIDataForm(false);
                    setSelectedIndex(null);
                },
                selectedIndex: selectedIndex
            })
        ]
    });
};
var $4a64f6c72c9c66c6$export$2e2bcd8739ae039 = $4a64f6c72c9c66c6$var$IndexList;

});
parcelRegister("22Joh", function(module, exports) {
module.exports = new URL("online.191cb243.svg", import.meta.url).toString();

});

parcelRegister("lNwVA", function(module, exports) {
module.exports = new URL("offline.52808a26.svg", import.meta.url).toString();

});

parcelRegister("2Mzms", function(module, exports) {
module.exports = new URL("Stocks_icon_blue.cda281a3.svg", import.meta.url).toString();

});

parcelRegister("lPOf7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad5ea9a079d06922$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");
var $bIyvl = parcelRequire("bIyvl");
var $lGURI = parcelRequire("lGURI");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $gFVvY = parcelRequire("gFVvY");

var $dqRXb = parcelRequire("dqRXb");

var $6L9uu = parcelRequire("6L9uu");

var $d13i8 = parcelRequire("d13i8");

var $bSbwb = parcelRequire("bSbwb");

var $1ZlXU = parcelRequire("1ZlXU");

var $bilGR = parcelRequire("bilGR");

var $ehzwo = parcelRequire("ehzwo");

var $5PJ2i = parcelRequire("5PJ2i");
const $ad5ea9a079d06922$var$defaultErrorsObj = {
    indexName: null,
    country: null,
    currency: null,
    identifier: null,
    code: null
};
const $ad5ea9a079d06922$var$errorTexts = {
    indexName: "Index name is required",
    country: "Country is required",
    currency: "Currency is required",
    identifier: "Index identifier is required",
    code: "Index code is required",
    existingCode: "Index code already exists"
};
const $ad5ea9a079d06922$var$IndexForm = ({ handleClose: handleClose, indexInput: indexInput })=>{
    const [editable, setEditable] = (0, $bh6RR.useState)(indexInput === null);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($ad5ea9a079d06922$var$defaultErrorsObj);
    const [indexName, setIndexName] = (0, $bh6RR.useState)(indexInput?.name || null);
    const [indexCountry, setIndexCountry] = (0, $bh6RR.useState)(indexInput?.country || null);
    const [indexCurrency, setIndexCurrency] = (0, $bh6RR.useState)(indexInput?.currency || null);
    const [indexIdentifier, setIndexIdentifier] = (0, $bh6RR.useState)(indexInput?.identifier || null);
    const [indexCode, setIndexCode] = (0, $bh6RR.useState)(indexInput?.code || null);
    const [indexNetCode, setIndexNetCode] = (0, $bh6RR.useState)(indexInput?.net_code || null);
    const [isOnline, setIsOnline] = (0, $bh6RR.useState)(indexInput?.is_online || false);
    const [createIndex, createIndexResult] = (0, $hjfla.useCreateIndexMutation)();
    const [updateIndex, updateIndexResult] = (0, $hjfla.useUpdateIndexMutation)();
    const indexCountries = (0, $hjfla.useCountriesQuery)();
    const indexCurrencies = (0, $hjfla.useCurrenciesQuery)();
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Index);
    const handleCancel = ()=>{
        if (editable && indexInput !== null) {
            setIndexName(indexInput?.name);
            setIndexCountry(indexInput?.country || null);
            setIndexCurrency(indexInput?.currency || null);
            setIndexIdentifier(indexInput?.identifier || null);
            setIndexCode(indexInput?.code || null);
            setIndexNetCode(indexInput?.net_code || null);
            setIsOnline(indexInput?.is_online || false);
            setFormErrors($ad5ea9a079d06922$var$defaultErrorsObj);
            setEditable(false);
        } else handleClose(false);
    };
    const handleSubmit = ()=>{
        let hasErrors = false;
        const errors = {
            code: null,
            country: null,
            currency: null,
            identifier: null,
            indexName: null
        };
        if (!indexName) {
            hasErrors = true;
            errors.indexName = $ad5ea9a079d06922$var$errorTexts.indexName;
        }
        if (!indexCode) {
            hasErrors = true;
            errors.code = $ad5ea9a079d06922$var$errorTexts.code;
        }
        if (!indexCountry) {
            hasErrors = true;
            errors.country = $ad5ea9a079d06922$var$errorTexts.country;
        }
        if (!indexCurrency) {
            hasErrors = true;
            errors.currency = $ad5ea9a079d06922$var$errorTexts.currency;
        }
        if (!indexIdentifier) {
            hasErrors = true;
            errors.identifier = $ad5ea9a079d06922$var$errorTexts.identifier;
        }
        if (hasErrors) setFormErrors(errors);
        else {
            const codeExists = (0, $gFVvY.sameIndexCodeExists)(indexCode, indexInput?.id);
            if (codeExists) setFormErrors({
                ...formErrors,
                code: codeExists ? $ad5ea9a079d06922$var$errorTexts.existingCode : null
            });
            else handleSave(indexInput === null ? "create" : "update");
        }
    };
    const handleSave = (type)=>{
        if (type === "create") createIndex({
            variables: {
                input: {
                    code: indexCode,
                    currency: Number(indexCurrency?.id),
                    identifier: indexIdentifier,
                    is_online: isOnline,
                    name: indexName,
                    net_code: indexNetCode,
                    country: Number(indexCountry?.id)
                }
            },
            update (_, { data: data }) {
                handleClose(true, true, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Index created"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
        else updateIndex({
            variables: {
                id: indexInput?.id,
                input: {
                    code: indexCode,
                    currency: Number(indexCurrency?.id),
                    identifier: indexIdentifier,
                    is_online: isOnline,
                    name: indexName,
                    net_code: indexNetCode,
                    country: Number(indexCountry?.id)
                }
            },
            update (_, { data: data }) {
                handleClose(true, false, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Index Updated"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
    };
    const handleIndexNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value) setFormErrors({
            ...formErrors,
            indexName: null
        });
        else setFormErrors({
            ...formErrors,
            indexName: $ad5ea9a079d06922$var$errorTexts.indexName
        });
        setIndexName(value);
    };
    const handleCountryChange = (_, newValue)=>{
        if (newValue) setFormErrors({
            ...formErrors,
            country: null
        });
        else setFormErrors({
            ...formErrors,
            country: $ad5ea9a079d06922$var$errorTexts.country
        });
        setIndexCountry(newValue);
    };
    const handleCurrencyChange = (_, newValue)=>{
        setFormErrors({
            ...formErrors,
            currency: newValue === null ? $ad5ea9a079d06922$var$errorTexts.currency : null
        });
        setIndexCurrency(newValue);
    };
    const handleIndexNameIdentifierChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value) setFormErrors({
            ...formErrors,
            identifier: null
        });
        else setFormErrors({
            ...formErrors,
            identifier: $ad5ea9a079d06922$var$errorTexts.identifier
        });
        setIndexIdentifier(value);
    };
    const handleIndexCodeChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value) setFormErrors({
            ...formErrors,
            code: null
        });
        else setFormErrors({
            ...formErrors,
            code: $ad5ea9a079d06922$var$errorTexts.code
        });
        setIndexCode(value);
    };
    const handleIndexNetCodeChange = (event)=>{
        const { value: value } = event.currentTarget;
        setIndexNetCode(value);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "new-index",
        width: 689,
        title: "Create Index",
        onClose: handleCancel,
        children: [
            indexInput && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    textAlign: "right",
                    width: "100%",
                    marginTop: "28px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "index-form-edit-button",
                    onClick: ()=>setEditable(true),
                    disabled: editable || !canEdit,
                    editButtonColor: !canEdit || editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                    gap: "40px 22px",
                    padding: "42px 42px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "index-form-index-name",
                        label: "Index Name",
                        value: indexName || "",
                        onChange: handleIndexNameChange,
                        errorMsg: formErrors.indexName,
                        disabled: !editable || createIndexResult.loading || updateIndexResult.loading,
                        additionalStyle: {
                            gridColumn: "span 4"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                        id: "index-country-autocomplete",
                        label: "Country",
                        options: indexCountries.data?.result || [],
                        disabled: createIndexResult.loading || !editable || updateIndexResult.loading,
                        values: indexCountry,
                        onChange: handleCountryChange,
                        getOptionLabel: (option)=>option?.name,
                        errorMsg: formErrors.country,
                        additionalStyle: {
                            gridColumn: "span 3"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                        id: "index-currency-autocomplete",
                        label: "Currency",
                        options: indexCurrencies.data?.result || [],
                        disabled: !editable || createIndexResult.loading || updateIndexResult.loading,
                        values: indexCurrency,
                        onChange: handleCurrencyChange,
                        getOptionLabel: (option)=>option.code,
                        errorMsg: formErrors.currency,
                        additionalStyle: {
                            gridColumn: "span 1"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "index-form-index-name-identifier",
                        label: "Index Name Identifier",
                        value: indexIdentifier || "",
                        onChange: handleIndexNameIdentifierChange,
                        errorMsg: formErrors.identifier,
                        disabled: !editable || createIndexResult.loading || updateIndexResult.loading,
                        additionalStyle: {
                            gridColumn: "span 4"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "index-form-index-code",
                        label: "Index code",
                        value: indexCode || "",
                        onChange: handleIndexCodeChange,
                        errorMsg: formErrors.code,
                        disabled: !editable || createIndexResult.loading || updateIndexResult.loading,
                        additionalStyle: {
                            gridColumn: "span 2"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "index-form-index-net-code",
                        label: "Index NET code",
                        value: indexNetCode || "",
                        onChange: handleIndexNetCodeChange,
                        disabled: !editable || createIndexResult.loading || updateIndexResult.loading,
                        additionalStyle: {
                            gridColumn: "span 2"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            gridColumn: "span 1"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bIyvl.default), {
                            control: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lGURI.default), {
                                id: "is_online",
                                // disableRipple
                                // classes={{
                                //   root: theme.MuiSwitch,
                                //   switchBase: classes.switchBase,
                                //   thumb: classes.thumb,
                                //   track: classes.track,
                                //   checked: classes.checked
                                // }}
                                sx: {},
                                checked: isOnline,
                                onChange: ()=>setIsOnline(!isOnline),
                                name: "checkOnline"
                            }),
                            label: "Online",
                            labelPlacement: "start",
                            style: {
                                color: editable ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).dark_gray
                            },
                            disabled: !editable || createIndexResult.loading || updateIndexResult.loading
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    gridColumn: "span 3",
                    marginTop: "100px",
                    paddingBottom: "45px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-index-button",
                        disabled: createIndexResult.loading || updateIndexResult.loading,
                        onClick: handleCancel,
                        text: indexInput === null || editable ? "Cancel" : "Close"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "save-index-button",
                        disabled: !editable || createIndexResult.loading || updateIndexResult.loading,
                        onClick: handleSubmit,
                        text: indexInput === null ? "Create" : "Save"
                    })
                ]
            })
        ]
    });
};
var $ad5ea9a079d06922$export$2e2bcd8739ae039 = $ad5ea9a079d06922$var$IndexForm;

});

parcelRegister("bbr3I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be76d700372dbc2f$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $oZMqz = parcelRequire("oZMqz");

var $hsjD5 = parcelRequire("hsjD5");

var $2eJeT = parcelRequire("2eJeT");

var $chLJv = parcelRequire("chLJv");

var $5DXc5 = parcelRequire("5DXc5");

var $b42dh = parcelRequire("b42dh");

var $6L9uu = parcelRequire("6L9uu");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");

var $ehzwo = parcelRequire("ehzwo");

var $5PJ2i = parcelRequire("5PJ2i");
const $be76d700372dbc2f$var$ConstituentsForm = ({ handleClose: handleClose, indexId: indexId })=>{
    const [date, setDate] = (0, $bh6RR.useState)(null);
    const [numberOfRecords, setNumberOfRecords] = (0, $bh6RR.useState)();
    const [sumWeight, setSumWeight] = (0, $bh6RR.useState)();
    const [sumWeightPerc, setSumWeightPerc] = (0, $bh6RR.useState)();
    const [getIndex, { data: data, loading: loading }] = (0, $hjfla.useGetHistoryConstituentsByIndexLazyQuery)({
        fetchPolicy: "no-cache"
    });
    (0, $bh6RR.useEffect)(()=>{
        getIndex({
            variables: {
                index_id: parseInt(indexId)
            }
        });
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        getIndex({
            variables: {
                index_id: parseInt(indexId),
                date: date ? (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(date).format("YYYY-MM-DD") : null
            }
        });
    }, [
        date
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            setNumberOfRecords(data.result.length);
            setSumWeight((0, $oZMqz.weightCalculation)(data.result));
            setSumWeightPerc((0, $oZMqz.sumWeightPercentageCalculation)(data.result));
        }
    }, [
        data
    ]);
    const columns = [
        {
            title: "Date day",
            width: 175,
            type: "date",
            field: "date",
            render: (rowData)=>(0, $hsjD5.renderDate)(rowData.date)
        },
        {
            title: "Full mkt cap",
            width: 121,
            type: "numeric",
            field: "stock.historyStock.engl_mkt_cap"
        },
        {
            title: "Free float mkt cap",
            width: 152,
            type: "numeric",
            field: "stock.historyStock.free_float_market_cap"
        },
        {
            title: "Stock Name",
            width: 546,
            field: "stock.name"
        },
        {
            title: "Weight Perc",
            width: 229,
            type: "numeric",
            field: "weight_perc"
        },
        {
            title: "Weighting",
            width: 178,
            type: "numeric",
            field: "weighting"
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5PJ2i.default), {
        id: "new-index",
        width: 1400,
        title: "",
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
            className: "centralize",
            sx: {
                width: "100%",
                paddingTop: "80px"
            },
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5DXc5.default), {
                headerText: "Constituents",
                width: "82%",
                additionalStyle: {
                    height: "680px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            width: "100%",
                            paddingTop: "20px",
                            paddingBottom: "20px",
                            paddingLeft: "20px",
                            background: (0, $6L9uu.Colors).lightBlue,
                            display: "grid",
                            gridTemplateColumns: "repeat(8, minmax(0, 1fr))",
                            gap: "42px 25px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                                dateAdapter: (0, $1Dn8S.AdapterDateFns),
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                    id: "index-constituents-date-picker",
                                    label: "Date",
                                    value: date,
                                    onChange: (value)=>setDate(value),
                                    disabled: false,
                                    sx: {
                                        background: (0, $6L9uu.Colors).white,
                                        gridColumn: "span 1"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "index-constituents-records-number-of-records",
                                label: "Records",
                                value: numberOfRecords || "",
                                disabled: true,
                                additionalStyle: {
                                    gridColumn: "span 1",
                                    background: (0, $6L9uu.Colors).white
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "index-constituents-sum-weight",
                                label: "Sum weight",
                                value: Number(sumWeight),
                                disabled: true,
                                additionalStyle: {
                                    gridColumn: "span 1",
                                    background: (0, $6L9uu.Colors).white
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "index-constituents-sum-weight-percentage",
                                label: "Sum weight %",
                                value: sumWeightPerc || "",
                                disabled: true,
                                additionalStyle: {
                                    gridColumn: "span 1",
                                    background: (0, $6L9uu.Colors).white
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
                        columns: columns,
                        data: (0, $hsjD5.FormatTableData)(data?.result || []),
                        loading: loading,
                        handleDetails: ()=>true,
                        handleRemove: ()=>true,
                        pageSize: 10,
                        crudType: "",
                        additionalToolbar: true,
                        fixedHeaders: true
                    })
                ]
            })
        })
    });
};
var $be76d700372dbc2f$export$2e2bcd8739ae039 = $be76d700372dbc2f$var$ConstituentsForm;

});

parcelRegister("89Htj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c349dc4d261f0fa2$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");

var $5PJ2i = parcelRequire("5PJ2i");

var $ehzwo = parcelRequire("ehzwo");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $b85VG = parcelRequire("b85VG");

var $6L9uu = parcelRequire("6L9uu");

var $hjfla = parcelRequire("hjfla");
const $c349dc4d261f0fa2$export$d19119f0474d967d = {
    fileName: null
};
const $c349dc4d261f0fa2$export$1067ba46601ca091 = {
    fileName: "File is required"
};
const $c349dc4d261f0fa2$var$CLEAR_TOKEN = "NULL";
const $c349dc4d261f0fa2$var$indexNumericFields = [
    "mkt_cap_eur",
    "mkt_cap_usd",
    "mkt_cap_gbp",
    "mkt_cap_jpy",
    "mkt_cap_aud",
    "price_close_eur",
    "price_close_usd",
    "price_close_gbp",
    "price_close_jpy",
    "price_close_aud",
    "price_return_eur",
    "price_return_usd",
    "price_return_gbp",
    "price_return_jpy",
    "price_return_aud",
    "price_net_eur",
    "price_net_usd",
    "price_net_gbp",
    "price_net_jpy",
    "price_net_aud"
];
const $c349dc4d261f0fa2$var$stockNumericFields = [
    "close_price",
    "engl_mkt_cap",
    "engl_mkt_cap_after_inv_wght",
    "gross_div_yield",
    "div_net",
    "epra_shares"
];
const $c349dc4d261f0fa2$var$indexAllowedHeaders = new Set([
    "index_code",
    "date_day",
    ...$c349dc4d261f0fa2$var$indexNumericFields
]);
const $c349dc4d261f0fa2$var$stockAllowedHeaders = new Set([
    "unique_stock_code",
    "date_day",
    ...$c349dc4d261f0fa2$var$stockNumericFields
]);
const $c349dc4d261f0fa2$var$splitCsvRows = (content)=>content.replace(/^\uFEFF/, "").split(/\r?\n/).filter((row)=>row.trim() !== "");
const $c349dc4d261f0fa2$var$splitCsvCells = (row)=>row.split(",").map((cell)=>cell.trim());
const $c349dc4d261f0fa2$var$parseNumericCell = (raw)=>{
    if (raw === "") return undefined;
    if (raw.toUpperCase() === $c349dc4d261f0fa2$var$CLEAR_TOKEN) return null;
    const value = Number(raw);
    return Number.isFinite(value) ? value : undefined;
};
const $c349dc4d261f0fa2$var$HistoryUpload = ({ handleClose: handleClose, isIndexFile: isIndexFile })=>{
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [fileName, setFileName] = (0, $bh6RR.useState)("");
    const [fileHistoryStocks, setFileHistoryStocks] = (0, $bh6RR.useState)([]);
    const [fileHistoryIndieces, setFileHistoryIndices] = (0, $bh6RR.useState)([]);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($c349dc4d261f0fa2$export$d19119f0474d967d);
    const [uploadHistoryStocks] = (0, $hjfla.useCreateHistoryStocksMutation)();
    const [uploadHistoryIndices] = (0, $hjfla.useCreateHistoryIndicesMutation)();
    const showMessage = (severity, text, autoHide = 4000)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowMessage,
            payload: {
                severity: severity,
                text: text,
                ...severity === "error" ? {
                    autoHide: 6000
                } : autoHide !== 4000 ? {
                    autoHide: autoHide
                } : {}
            }
        });
    };
    const importHistoryStocks = ()=>{
        const errors = {
            fileName: null
        };
        let hasErrors = false;
        if (!fileName) {
            hasErrors = true;
            errors.fileName = $c349dc4d261f0fa2$export$1067ba46601ca091.fileName;
        }
        if (hasErrors) setFormErrors(errors);
        else if (isIndexFile) uploadHistoryIndices({
            variables: {
                input: fileHistoryIndieces
            },
            update (_, { data: data }) {
                if (data?.result) {
                    showMessage("success", `Successfully imported data`);
                    handleClose();
                }
            }
        }).catch((e)=>{
            showMessage("error", e.message);
        });
        else uploadHistoryStocks({
            variables: {
                input: fileHistoryStocks
            },
            update (_, { data: data }) {
                if (data?.result) {
                    showMessage("success", `Successfully imported data`);
                    handleClose();
                }
            }
        }).catch((e)=>{
            showMessage("error", e.message);
        });
    };
    const handleFileUpload = (event)=>{
        if (event && event.target && event.target.files) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.readAsBinaryString(file);
                reader.onload = (e)=>{
                    if (e && e.target && e.target.result) {
                        const rows = $c349dc4d261f0fa2$var$splitCsvRows(e.target.result);
                        if (rows.length < 2) {
                            showMessage("info", "no data to upload");
                            return;
                        }
                        const headers = $c349dc4d261f0fa2$var$splitCsvCells(rows[0]);
                        const dataRows = rows.slice(1);
                        if (isIndexFile) {
                            if (!headers.includes("index_code") || !headers.includes("date_day")) {
                                showMessage("error", "CSV must include index_code and date_day columns");
                                return;
                            }
                            const historyIndices = dataRows.map((row)=>{
                                const values = $c349dc4d261f0fa2$var$splitCsvCells(row);
                                const record = {
                                    index_code: "",
                                    date_day: ""
                                };
                                headers.forEach((header, i)=>{
                                    if (!$c349dc4d261f0fa2$var$indexAllowedHeaders.has(header)) return;
                                    const raw = values[i] ?? "";
                                    if (header === "index_code" || header === "date_day") {
                                        record[header] = raw;
                                        return;
                                    }
                                    const parsed = $c349dc4d261f0fa2$var$parseNumericCell(raw);
                                    if (parsed !== undefined) record[header] = parsed;
                                });
                                return record;
                            });
                            setFileName(file.name);
                            setFileHistoryIndices(historyIndices);
                        } else {
                            if (!headers.includes("unique_stock_code") || !headers.includes("date_day")) {
                                showMessage("error", "CSV must include unique_stock_code and date_day columns");
                                return;
                            }
                            const historyStocks = dataRows.map((row)=>{
                                const values = $c349dc4d261f0fa2$var$splitCsvCells(row);
                                const record = {
                                    unique_stock_code: "",
                                    date_day: ""
                                };
                                headers.forEach((header, i)=>{
                                    if (!$c349dc4d261f0fa2$var$stockAllowedHeaders.has(header)) return;
                                    const raw = values[i] ?? "";
                                    if (header === "unique_stock_code" || header === "date_day") {
                                        record[header] = raw;
                                        return;
                                    }
                                    const parsed = $c349dc4d261f0fa2$var$parseNumericCell(raw);
                                    if (parsed !== undefined) record[header] = parsed;
                                });
                                return record;
                            });
                            setFileName(file.name);
                            setFileHistoryStocks(historyStocks);
                        }
                    }
                };
            } else setFormErrors({
                ...formErrors,
                fileName: $c349dc4d261f0fa2$export$1067ba46601ca091.fileName
            });
        }
        event.target.value = "";
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5PJ2i.default), {
        id: "history-upload-form-dialog",
        width: 380,
        title: isIndexFile ? "Import Index Data" : "Import Stock Data",
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                display: "flex",
                flexDirection: "column",
                m: "30px",
                gap: "10px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                    id: "history-upload-file",
                    label: "",
                    value: fileName,
                    onChange: handleFileUpload,
                    errorMsg: formErrors.fileName,
                    disabled: true,
                    endAdornment: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            position: "relative",
                            bottom: "3px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                accept: "text/csv",
                                id: "event-file",
                                type: "file",
                                onChange: handleFileUpload,
                                style: {
                                    display: "none"
                                },
                                multiple: true
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                                htmlFor: "event-file",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b85VG.default), {
                                    style: {
                                        cursor: "pointer",
                                        paddingRight: "5%",
                                        paddingTop: "5px",
                                        color: (0, $6L9uu.Colors).main
                                    }
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize",
                    sx: {
                        gridColumn: "span 3",
                        marginBottom: "15px",
                        mt: "20px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                            id: "cancel-history-upload-button",
                            onClick: handleClose,
                            text: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                            id: "add-history-data-button",
                            onClick: ()=>importHistoryStocks(),
                            text: "Import"
                        })
                    ]
                })
            ]
        })
    });
};
var $c349dc4d261f0fa2$export$2e2bcd8739ae039 = $c349dc4d261f0fa2$var$HistoryUpload;

});

parcelRegister("6QTYz", function(module, exports) {
module.exports = new URL("excel_icon.af040e11.svg", import.meta.url).toString();

});

parcelRegister("hO5gu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3785982f9cc87d54$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hjfla = parcelRequire("hjfla");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $daKAK = parcelRequire("daKAK");
const $3785982f9cc87d54$var$defaultErrorsObj = {
    exportStartDate: null,
    exportEndDate: null,
    exportDateInvalidDate: null
};
const $3785982f9cc87d54$var$errorTexts = {
    exportStartDate: "Export Start Date is required",
    exportEndDate: "Export End Date is required",
    exportDateInvalidDate: "Invalid Date Format"
};
const $3785982f9cc87d54$var$maxDate = new Date();
const $3785982f9cc87d54$var$ExportHIDataForm = ({ handleClose: handleClose, selectedIndex: selectedIndex })=>{
    const [exportStartDate, setExportStartDate] = (0, $bh6RR.useState)(new Date());
    const [exportEndDate, setExportEndDate] = (0, $bh6RR.useState)(new Date());
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($3785982f9cc87d54$var$defaultErrorsObj);
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [getHistoryIndicesByIdAndPeriodData, { data: data }] = (0, $hjfla.useHistoryIndicesByIdAndPeriodLazyQuery)();
    const [historyIndicesData, setHistoryIndicesData] = (0, $bh6RR.useState)([]);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            setHistoryIndicesData(data.result);
            handleExport(data.result);
        }
    }, [
        data
    ]);
    const handleCancel = ()=>{
        setExportStartDate(null);
        setExportEndDate(null);
        handleClose();
    };
    const convertTimestampToDate = (timestamp)=>{
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    };
    const handleExport = (exportData)=>{
        const fileName = "HistoryIndicesData";
        const csvData = exportData.map((hi)=>({
                Id: hi.id,
                index_id: hi.index_id,
                date: convertTimestampToDate(Number(hi.date)),
                file_name: hi.file_name,
                dividend_yield: hi.dividend_yield,
                mkt_cap_aud: hi.mkt_cap_aud,
                mkt_cap_eur: hi.mkt_cap_eur,
                mkt_cap_jpy: hi.mkt_cap_jpy,
                mkt_cap_local: hi.mkt_cap_local,
                mkt_cap_usd: hi.mkt_cap_usd,
                price_close_aud: hi.price_close_aud,
                price_close_eur: hi.price_close_eur,
                price_close_gbp: hi.price_close_gbp,
                price_close_jpy: hi.price_close_jpy,
                price_close_local: hi.price_close_local,
                price_close_usd: hi.price_close_usd,
                price_net_aud: hi.price_net_aud,
                price_net_eur: hi.price_net_eur,
                price_net_gbp: hi.price_net_gbp,
                price_net_jpy: hi.price_net_jpy,
                price_net_local: hi.price_net_local,
                price_net_usd: hi.price_net_usd,
                price_return_aud: hi.price_return_aud,
                price_return_eur: hi.price_return_eur,
                price_return_gbp: hi.price_return_gbp,
                price_return_jpy: hi.price_return_jpy,
                price_return_local: hi.price_return_local,
                price_return_usd: hi.price_return_usd,
                dividend_net_yield: hi.dividend_net_yield,
                mkt_cap_hkd: hi.mkt_cap_hkd,
                price_close_hkd: hi.price_close_hkd,
                price_net_hkd: hi.price_net_hkd,
                price_return_hkd: hi.price_return_hkd,
                price_return_epra_local: hi.price_return_epra_local,
                price_close_epra_local: hi.price_close_epra_local
            }));
        (0, $daKAK.exportDataAsExcel)(csvData, fileName);
        handleClose();
    };
    const getPureDate = (date)=>{
        const getMonthWithTwoDigit = (date)=>{
            return ("0" + (date?.getMonth() + 1)).slice(-2);
        };
        const getDateWithTwoDigit = (date)=>{
            return ("0" + date?.getDate()).slice(-2);
        };
        const pureDate = `${date?.getFullYear()}-${getMonthWithTwoDigit(date)}-${getDateWithTwoDigit(date)}`;
        return pureDate;
    };
    const exportMaxDateMessage = `Date should be before ${getPureDate($3785982f9cc87d54$var$maxDate)}`;
    const exportEndDateErrorMessage = `End Date should be after Start Date`;
    const handleExportHIData = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `'Are you sure you want to export History Indices Data for period ${getPureDate(exportStartDate)} and ${getPureDate(exportEndDate)} ?'`,
                agreeAction: exportHSdata
            }
        });
    };
    const exportHSdata = async ()=>{
        const index_id = selectedIndex?.id;
        await getHistoryIndicesByIdAndPeriodData({
            variables: {
                input: {
                    index_id: Number(index_id),
                    start_date: exportStartDate?.toString(),
                    end_date: exportEndDate?.toString()
                }
            }
        }).catch((error)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            });
        });
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
    };
    const handleExportStartDateChange = (value)=>{
        if (value) {
            if (getPureDate(value) > getPureDate($3785982f9cc87d54$var$maxDate)) {
                $3785982f9cc87d54$var$errorTexts.exportStartDate = exportMaxDateMessage;
                setFormErrors({
                    ...formErrors,
                    exportStartDate: $3785982f9cc87d54$var$errorTexts.exportStartDate
                });
            } else setFormErrors({
                ...formErrors,
                exportStartDate: null
            });
        } else setFormErrors({
            ...formErrors,
            exportStartDate: $3785982f9cc87d54$var$errorTexts.exportStartDate
        });
        setExportStartDate(value);
    };
    const handleExportEndDateChange = (value)=>{
        if (value) {
            if (getPureDate(value) > getPureDate($3785982f9cc87d54$var$maxDate)) {
                $3785982f9cc87d54$var$errorTexts.exportEndDate = exportMaxDateMessage;
                setFormErrors({
                    ...formErrors,
                    exportEndDate: $3785982f9cc87d54$var$errorTexts.exportEndDate
                });
            } else if (getPureDate(value) < getPureDate(exportStartDate)) {
                $3785982f9cc87d54$var$errorTexts.exportEndDate = exportEndDateErrorMessage;
                setFormErrors({
                    ...formErrors,
                    exportEndDate: $3785982f9cc87d54$var$errorTexts.exportEndDate
                });
            } else setFormErrors({
                ...formErrors,
                exportEndDate: null
            });
        } else setFormErrors({
            ...formErrors,
            exportEndDate: $3785982f9cc87d54$var$errorTexts.exportEndDate
        });
        setExportEndDate(value);
    };
    const handleSubmit = ()=>{
        const errors = {
            exportStartDate: null,
            exportEndDate: null,
            exportDateInvalidDate: null
        };
        let hasErrors = false;
        if (!exportStartDate) {
            hasErrors = true;
            errors.exportStartDate = $3785982f9cc87d54$var$errorTexts.exportStartDate;
        } else if (!Date.parse(exportStartDate.toString())) {
            hasErrors = true;
            errors.exportStartDate = $3785982f9cc87d54$var$errorTexts.exportDateInvalidDate;
        }
        if (!exportEndDate) {
            hasErrors = true;
            errors.exportEndDate = $3785982f9cc87d54$var$errorTexts.exportEndDate;
        } else if (!Date.parse(exportEndDate.toString())) {
            hasErrors = true;
            errors.exportEndDate = $3785982f9cc87d54$var$errorTexts.exportDateInvalidDate;
        }
        if (hasErrors) setFormErrors(errors);
        else handleExportHIData();
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5PJ2i.default), {
        id: "history-indices-export-form",
        width: 375,
        title: "Export History Indices Data",
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                margin: "50px",
                display: "flex",
                flexDirection: "column",
                gap: "45px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $e4eIN.LocalizationProvider), {
                    dateAdapter: (0, $1Dn8S.AdapterDateFns),
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                            id: "export-start-date-picker",
                            label: "Start Date",
                            value: exportStartDate,
                            onChange: (date)=>handleExportStartDateChange(date),
                            errorMsg: formErrors.exportStartDate,
                            sx: {
                                width: "100%"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                            id: "export-end-date-picker",
                            label: "End Date",
                            value: exportEndDate,
                            onChange: (date)=>handleExportEndDateChange(date),
                            errorMsg: formErrors.exportEndDate,
                            sx: {
                                width: "100%"
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                            id: "cancel-export-button",
                            onClick: handleCancel,
                            text: "Close"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                            id: "save-export-button",
                            onClick: handleSubmit,
                            text: "Export"
                        })
                    ]
                })
            ]
        })
    });
};
var $3785982f9cc87d54$export$2e2bcd8739ae039 = $3785982f9cc87d54$var$ExportHIDataForm;

});


parcelRegister("lDzda", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82d1980e7e56a2f0$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $hsjD5 = parcelRequire("hsjD5");

var $d7fM7 = parcelRequire("d7fM7");

var $itPTi = parcelRequire("itPTi");
const $82d1980e7e56a2f0$var$IndexSerieList = ()=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const { data: data, loading: loading } = (0, $hjfla.useIndexSeriesQuery)();
    const [allData, setAllData] = (0, $bh6RR.useState)([]);
    const [deleteIndexSerie] = (0, $hjfla.useDeleteIndexSerieMutation)();
    const [openCreateIndexSerie, setOpenCreateIndexSerie] = (0, $bh6RR.useState)(false);
    const [indexSerie, setIndexSerie] = (0, $bh6RR.useState)(null);
    const canCreate = (0, $dqRXb.canUserCreate)(state.user, (0, $gUBkJ.Types).IndexSeries);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setAllData(data.result);
    }, [
        data
    ]);
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${rowData.name} index serie?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleClose = (saved, isNew, indexSerieInput)=>{
        if (saved && indexSerieInput) {
            if (isNew) addIndexSerie(indexSerieInput);
        }
        setIndexSerie(null);
        setOpenCreateIndexSerie(false);
    };
    const addIndexSerie = (input)=>{
        const existing = allData.find((d)=>d.id === input.id);
        if (!existing) setAllData([
            input,
            ...allData
        ]);
    };
    const handleDetails = (rowData)=>{
        setIndexSerie(rowData);
        setOpenCreateIndexSerie(true);
    };
    const handleDelete = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteIndexSerie({
            variables: {
                id: rowData.id
            },
            update (cache) {
                const indexSeriesListQuery = cache.readQuery({
                    query: (0, $hjfla.IndexSeriesDocument)
                });
                if (indexSeriesListQuery.result) {
                    const cachedIndex = indexSeriesListQuery.result.findIndex((is)=>is?.id === rowData.id);
                    if (cachedIndex > -1) {
                        const data = indexSeriesListQuery.result.filter((is)=>is?.id !== rowData.id);
                        cache.writeQuery({
                            query: (0, $hjfla.IndexSeriesDocument),
                            data: {
                                result: data
                            }
                        });
                    }
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: e.message,
                    severity: "error"
                }
            });
        });
        dispatch({
            type: (0, $ayVxz.Actions).ShowMessage,
            payload: {
                text: `${rowData.name} index deleted`,
                severity: "success"
            }
        });
    };
    const columns = [
        {
            title: "Details",
            width: 64,
            sorting: false
        },
        {
            title: "Index Serie Name",
            field: "name",
            width: 1565
        },
        {
            title: "Remove",
            width: 71,
            sorting: false
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "overviewPage",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                columns: columns,
                data: (0, $hsjD5.FormatTableData)(allData),
                loading: loading,
                handleDetails: handleDetails,
                handleRemove: handleRemove,
                pageSize: 15,
                createButtonProps: {
                    id: "create-index-serie-button",
                    onClick: ()=>setOpenCreateIndexSerie(true),
                    text: "Create Serie",
                    disabled: !canCreate
                }
            }),
            openCreateIndexSerie && /*#__PURE__*/ (0, $ih19M.jsx)((0, $itPTi.default), {
                handleClose: handleClose,
                indexSerieInput: indexSerie
            })
        ]
    });
};
var $82d1980e7e56a2f0$export$2e2bcd8739ae039 = $82d1980e7e56a2f0$var$IndexSerieList;

});
parcelRegister("itPTi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b283fcda3b1a385$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $eFKxo = parcelRequire("eFKxo");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $ePpmI = parcelRequire("ePpmI");
var $dNs2U = parcelRequire("dNs2U");
var $i04rf = parcelRequire("i04rf");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $gFVvY = parcelRequire("gFVvY");

var $dqRXb = parcelRequire("dqRXb");

var $6L9uu = parcelRequire("6L9uu");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $bilGR = parcelRequire("bilGR");

var $ehzwo = parcelRequire("ehzwo");

var $5PJ2i = parcelRequire("5PJ2i");

var $bog98 = parcelRequire("bog98");
const $3b283fcda3b1a385$var$defaultErrorsObj = {
    indexSerieName: null
};
const $3b283fcda3b1a385$var$errorTexts = {
    indexSerieName: "Index serie name is required"
};
const $3b283fcda3b1a385$var$indexesPerPage = 9;
const $3b283fcda3b1a385$var$firstPartOfMessage = `There are currently no indices in this serie.\n`;
const $3b283fcda3b1a385$var$secondPartOfMessage = `Please select indices from the index menu on top.`;
const $3b283fcda3b1a385$var$userMessage = $3b283fcda3b1a385$var$firstPartOfMessage + $3b283fcda3b1a385$var$secondPartOfMessage;
const $3b283fcda3b1a385$var$indexSeriesForm = ({ handleClose: handleClose, indexSerieInput: indexSerieInput })=>{
    const [editable, setEditable] = (0, $bh6RR.useState)(false);
    const [indexSerieName, setIndexSerieName] = (0, $bh6RR.useState)(indexSerieInput?.name || "");
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($3b283fcda3b1a385$var$defaultErrorsObj);
    const [displayedIndexes, setDisplayedIndexes] = (0, $bh6RR.useState)([]);
    const allIndexes = (0, $hjfla.useIndicesQuery)();
    const [indexList, setIndexList] = (0, $bh6RR.useState)([]);
    const [pages, setPages] = (0, $bh6RR.useState)(0);
    const [searchText, setSearchText] = (0, $bh6RR.useState)("");
    const [currentPage, setCurrentPage] = (0, $bh6RR.useState)(1);
    const [key, setKey] = (0, $bh6RR.useState)("0");
    const [options, setOptions] = (0, $bh6RR.useState)([]);
    const [createIndexSerie, createIndexSerieResult] = (0, $hjfla.useCreateIndexSerieMutation)();
    const [updateIndexSerie, updateIndexSerieResult] = (0, $hjfla.useUpdateIndexSerieMutation)();
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).IndexSeries);
    (0, $bh6RR.useEffect)(()=>{
        if (allIndexes.data && allIndexes.data.result) {
            const indices = allIndexes.data.result;
            if (indexSerieInput && indexSerieInput.indices && indexSerieInput.indices.length > 0) {
                const currentIndexIds = indexSerieInput.indices.map((i)=>i?.id);
                setOptions(indices.filter((i)=>!currentIndexIds.includes(i.id)));
            } else setOptions(indices);
        }
    }, [
        allIndexes.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (indexSerieInput && indexSerieInput.indices) {
            const indexes = indexSerieInput.indices;
            const indexIds = indexSerieInput.indices.map((i)=>i?.id);
            const data = allIndexes.data?.result;
            setIndexList(indexes);
            setDisplayedIndexes(indexes.slice(0, $3b283fcda3b1a385$var$indexesPerPage));
            setPages(indexes.length > $3b283fcda3b1a385$var$indexesPerPage ? Math.ceil(indexes.length / $3b283fcda3b1a385$var$indexesPerPage) : 0);
            setOptions(data.filter((i)=>!indexIds.includes(i?.id)));
        }
    }, [
        indexSerieInput
    ]);
    const handleCancel = ()=>{
        if (editable && indexSerieInput !== null) {
            setIndexSerieName(indexSerieInput?.name);
            setFormErrors($3b283fcda3b1a385$var$defaultErrorsObj);
            setEditable(false);
        } else handleClose(false);
    };
    const handleIndexSerieNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value) setFormErrors({
            ...formErrors,
            indexSerieName: null
        });
        else setFormErrors({
            ...formErrors,
            indexSerieName: $3b283fcda3b1a385$var$errorTexts.indexSerieName
        });
        setIndexSerieName(value);
    };
    const handleSearchChange = (text)=>{
        setSearchText(text);
        setCurrentPage(1);
        const filtered = filterIndexes(indexList, text);
        setPages(filtered.length > $3b283fcda3b1a385$var$indexesPerPage ? Math.ceil(filtered.length / $3b283fcda3b1a385$var$indexesPerPage) : 0);
        setDisplayedIndexes(filtered.slice(0, $3b283fcda3b1a385$var$indexesPerPage));
    };
    const filterIndexes = (input, text)=>{
        if (text.length === 0) return input;
        else {
            const loweredText = text.toLowerCase();
            const filtered = input.filter((i)=>i.name.toLowerCase().includes(loweredText));
            return filtered;
        }
    };
    const handleAddIndex = (_, indexObj)=>{
        if (indexObj !== null) {
            const isNew = indexSerieInput ? indexSerieInput?.indices.findIndex((i)=>i?.id === indexObj.id) > -1 ? false : true : true;
            const newData = [
                {
                    ...indexObj,
                    isNew: isNew
                },
                ...indexList
            ];
            setIndexList(newData);
            const filteredData = filterIndexes(newData, searchText);
            if (newData.length > $3b283fcda3b1a385$var$indexesPerPage) setDisplayedIndexes(filteredData.slice(0, $3b283fcda3b1a385$var$indexesPerPage));
            else setDisplayedIndexes(filteredData);
            setOptions(options.filter((i)=>i.id !== indexObj.id));
            setPages(filteredData.length > $3b283fcda3b1a385$var$indexesPerPage ? Math.ceil(filteredData.length / $3b283fcda3b1a385$var$indexesPerPage) : 0);
            setKey(indexObj.id);
        } else setKey("0");
    };
    const handleRemoveFromList = (index)=>{
        setKey("0");
        const newData = indexList.filter((i)=>i.id !== index.id);
        setIndexList(newData);
        const filteredData = filterIndexes(newData, searchText);
        const start = (currentPage - ((currentPage - 1) * $3b283fcda3b1a385$var$indexesPerPage == filteredData.length ? 2 : 1)) * $3b283fcda3b1a385$var$indexesPerPage;
        setDisplayedIndexes(filteredData.slice(start, start + $3b283fcda3b1a385$var$indexesPerPage));
        setPages(filteredData.length > $3b283fcda3b1a385$var$indexesPerPage ? Math.ceil(filteredData.length / $3b283fcda3b1a385$var$indexesPerPage) : 0);
        setOptions([
            index,
            ...options
        ]);
        if (start + $3b283fcda3b1a385$var$indexesPerPage == filteredData.length && currentPage !== 1 && currentPage == pages) setCurrentPage(currentPage - 1);
    };
    const handlePageChange = (_, value)=>{
        const start = (value - 1) * $3b283fcda3b1a385$var$indexesPerPage;
        setDisplayedIndexes(indexList.slice(start, start + $3b283fcda3b1a385$var$indexesPerPage));
        setCurrentPage(value);
    };
    const handleSubmit = ()=>{
        let hasErrors = false;
        const errors = {
            indexSerieName: null
        };
        if (!indexSerieName) {
            hasErrors = true;
            errors.indexSerieName = $3b283fcda3b1a385$var$errorTexts.indexSerieName;
        }
        if (hasErrors) setFormErrors(errors);
        else {
            const indexSerieExists = (0, $gFVvY.indexSerieWithThatNameExists)(indexSerieName, indexSerieInput?.id);
            if (indexSerieExists) setFormErrors({
                ...formErrors,
                indexSerieName: indexSerieExists ? "Index serie with that name already exists" : null
            });
            else handleSave(indexSerieInput === null ? "create" : "update");
        }
    };
    const handleSave = (type)=>{
        if (type === "create") createIndexSerie({
            variables: {
                input: {
                    name: indexSerieName.trim(),
                    index_ids: indexList.map((i)=>Number(i.id))
                }
            },
            update (_, { data: data }) {
                handleClose(true, true, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Index serie created"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
        else updateIndexSerie({
            variables: {
                id: indexSerieInput?.id,
                input: {
                    name: indexSerieName.trim(),
                    index_ids: indexList.map((i)=>Number(i.id))
                }
            },
            update (_, { data: data }) {
                handleClose(true, false, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Index Serie Updated"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "create-new-index-serie",
        width: 1280,
        onClose: handleCancel,
        title: indexSerieInput ? `${indexSerieInput?.name} Details` : "Create Index Serie",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                    gap: "40px 22px",
                    padding: "42px 80px",
                    background: (0, $6L9uu.Colors).lightBlue
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                    id: "index-serie-name",
                    label: "Index Serie Name",
                    value: indexSerieName || "",
                    onChange: handleIndexSerieNameChange,
                    errorMsg: formErrors.indexSerieName,
                    disabled: createIndexSerieResult.loading || updateIndexSerieResult.loading || !canEdit,
                    additionalStyle: {
                        gridColumn: "span 3",
                        background: (0, $6L9uu.Colors).white,
                        paddingLeft: "15px"
                    }
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "flex",
                    gap: "80px",
                    background: (0, $6L9uu.Colors).lightBlue,
                    padding: "25px 80px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bog98.default), {
                        filter: handleSearchChange,
                        id: "overview-step-search-input",
                        additionalStyleInputProps: {
                            boxSizing: "unset"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {
                        orientation: "vertical",
                        style: {
                            background: (0, $6L9uu.Colors).white,
                            width: 2,
                            paddingBottom: "7px",
                            height: "36px",
                            border: "none"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                        id: "add-index-autocomplete",
                        label: "Add index",
                        options: options,
                        disabled: createIndexSerieResult.loading || updateIndexSerieResult.loading || !canEdit,
                        values: undefined,
                        onChange: handleAddIndex,
                        getOptionLabel: (option)=>option.name,
                        additionalStyle: {
                            border: "none"
                        },
                        isWhite: true
                    }, key)
                ]
            }),
            displayedIndexes.length > 0 ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    minHeight: "450px",
                    height: "450px",
                    paddingTop: "30px"
                },
                children: displayedIndexes.map((rec, index)=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "3.5%",
                            height: "40px",
                            marginLeft: "6%",
                            width: "88%",
                            borderRadius: "9px",
                            marginBottom: "8px",
                            background: rec.isNew ? (0, $6L9uu.Colors).lightBlue : "none",
                            boxShadow: !rec.isNew ? "0px 3px 20px #12497F12" : "none"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                sx: {
                                    textAlign: "left",
                                    flexGrow: 1,
                                    color: (0, $6L9uu.Colors).main
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                    id: "index-" + rec.id + "name",
                                    "data-testid": "index-" + rec.id + "name",
                                    value: rec.name,
                                    disabled: true,
                                    fullWidth: true,
                                    sx: {
                                        fontSize: "14px",
                                        fontFamily: "Overpass",
                                        "& .MuiInputBase-input.Mui-disabled": {
                                            WebkitTextFillColor: (0, $6L9uu.Colors).main
                                        }
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                                    disabled: !canEdit,
                                    onClick: ()=>handleRemoveFromList(rec),
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eFKxo.default), {
                                        style: {
                                            color: (0, $6L9uu.Colors).skyBlue,
                                            width: 20,
                                            height: 21
                                        }
                                    })
                                })
                            })
                        ]
                    }, `${index}-${rec.id}`))
            }) : /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                style: {
                    color: (0, $6L9uu.Colors).main,
                    fontSize: "16px",
                    fontFamily: "Overpass",
                    height: "450px",
                    letterSpacing: "0",
                    opacity: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                },
                children: $3b283fcda3b1a385$var$userMessage
            }),
            pages > 0 && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    paddingLeft: "5%",
                    paddingTop: "12px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $i04rf.default), {
                    id: "index-serie-pagination",
                    "data-testid": "index-serie-pagination",
                    style: {
                        margin: "auto"
                    },
                    count: pages,
                    page: currentPage,
                    color: "primary",
                    onChange: handlePageChange
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    gridColumn: "span 3",
                    marginTop: pages > 0 ? "56px" : "100px",
                    paddingBottom: "45px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-create-index-serie-button",
                        disabled: createIndexSerieResult.loading || updateIndexSerieResult.loading,
                        onClick: handleCancel,
                        text: indexSerieInput === null ? "Cancel" : "Close"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "create-new-membership-button",
                        disabled: createIndexSerieResult.loading || updateIndexSerieResult.loading || !canEdit,
                        onClick: handleSubmit,
                        text: indexSerieInput === null ? "Create" : "Save"
                    })
                ]
            })
        ]
    });
};
var $3b283fcda3b1a385$export$2e2bcd8739ae039 = $3b283fcda3b1a385$var$indexSeriesForm;

});
parcelRegister("bog98", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00b5d5609b9c3c19$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $jIOsh = parcelRequire("jIOsh");

var $5LQ5V = parcelRequire("5LQ5V");

var $bh6RR = parcelRequire("bh6RR");

var $6L9uu = parcelRequire("6L9uu");
const $00b5d5609b9c3c19$var$SearchInput = ({ id: id, filter: filter, additionalStyleInputProps: additionalStyleInputProps })=>{
    const [searchValue, setSearchValue] = (0, $bh6RR.useState)("");
    const handleValueChange = (event)=>{
        const { value: value } = event.currentTarget;
        filter(value);
        setSearchValue(value);
    };
    // , border: 'none'
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5LQ5V.default), {
        id: id,
        "data-testid": id,
        value: searchValue,
        onChange: handleValueChange,
        size: "small",
        sx: {
            color: (0, $6L9uu.Colors).main,
            background: (0, $6L9uu.Colors).white,
            // width: '59.6%',
            width: "100%",
            height: "36px",
            borderRadius: "9px",
            "& .MuiOutlinedInput-root": {
                "& fieldset": {
                    border: "none"
                }
            }
        },
        placeholder: "Search...",
        InputProps: {
            endAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $jIOsh.default), {
                style: {
                    color: (0, $6L9uu.Colors).main,
                    width: "18px",
                    height: "18px"
                }
            }),
            disableUnderline: true,
            sx: {
                marginTop: "auto",
                marginBottom: "auto"
            }
        },
        inputProps: {
            sx: {
                ...additionalStyleInputProps
            }
        },
        className: "custom-search"
    });
};
var $00b5d5609b9c3c19$export$2e2bcd8739ae039 = $00b5d5609b9c3c19$var$SearchInput;

});




parcelRegister("1EALQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d39d0d7ee40ff51d$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $bu31C = parcelRequire("bu31C");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $hsjD5 = parcelRequire("hsjD5");

var $bilGR = parcelRequire("bilGR");

var $91340 = parcelRequire("91340");

var $d7fM7 = parcelRequire("d7fM7");

var $lKX46 = parcelRequire("lKX46");

var $89Htj = parcelRequire("89Htj");

var $3A2xv = parcelRequire("3A2xv");

var $gQDXO = parcelRequire("gQDXO");

var $ehzwo = parcelRequire("ehzwo");

var $d13i8 = parcelRequire("d13i8");
const $d39d0d7ee40ff51d$var$StockList = ()=>{
    const history = (0, $99w1R.useNavigate)();
    const { state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    // Filter states
    const [name, setName] = (0, $bh6RR.useState)("");
    const [isin, setIsin] = (0, $bh6RR.useState)("");
    const [exchangeCode, setExchangeCode] = (0, $bh6RR.useState)("");
    const [country, setCountry] = (0, $bh6RR.useState)(null);
    const [currency, setCurrency] = (0, $bh6RR.useState)(null);
    const [sector, setSector] = (0, $bh6RR.useState)(null);
    const [tradingDate, setTradingDate] = (0, $bh6RR.useState)(null);
    // Pagination states
    const [page, setPage] = (0, $bh6RR.useState)(0);
    const [pageSize, setPageSize] = (0, $bh6RR.useState)(15);
    const [total, setTotal] = (0, $bh6RR.useState)(0);
    // Sorting states
    const [orderBy, setOrderBy] = (0, $bh6RR.useState)(null);
    const [orderDirection, setOrderDirection] = (0, $bh6RR.useState)("asc");
    // Local state for displayed stocks (updated by query and subscriptions)
    const [displayedStocks, setDisplayedStocks] = (0, $bh6RR.useState)([]);
    const [openUpload, setOpenUpload] = (0, $bh6RR.useState)(false);
    const [openDeleteHSDataForm, setOpenDeleteHSDataForm] = (0, $bh6RR.useState)(false);
    const [selectedStock, setSelectedStock] = (0, $bh6RR.useState)(null);
    const [openStockForm, setOpenStockForm] = (0, $bh6RR.useState)(false);
    const canCreate = (0, $dqRXb.canUserCreate)(state.user, (0, $gUBkJ.Types).Stock);
    const countriesQuery = (0, $hjfla.useCountriesQuery)();
    const currenciesQuery = (0, $hjfla.useCurrenciesQuery)();
    const sectorsQuery = (0, $hjfla.useSectorsQuery)();
    const [fetchStocks, { data: data, loading: loading }] = (0, $hjfla.useStocksFilteredLazyQuery)();
    // Subscriptions for real-time updates
    const createStockSubscription = (0, $hjfla.useStockCreatedSubscription)();
    const updateStockSubscription = (0, $hjfla.useStockUpdatedSubscription)();
    // Refs for tracking state
    const hasMounted = (0, $bh6RR.useRef)(false);
    const filterTimeoutRef = (0, $bh6RR.useRef)(null);
    const isFilterChangeRef = (0, $bh6RR.useRef)(false);
    const isInitialMount = (0, $bh6RR.useRef)(true);
    const lastPageRef = (0, $bh6RR.useRef)(page);
    const lastPageSizeRef = (0, $bh6RR.useRef)(pageSize);
    // Set hasMounted immediately on mount
    (0, $bh6RR.useEffect)(()=>{
        hasMounted.current = true;
    }, []);
    // Helper function to check if a stock matches current filters
    const stockMatchesFilters = (0, $bh6RR.useCallback)((stock)=>{
        // Check name filter
        if (name && name.trim().length > 0) {
            const stockName = stock.name?.toLowerCase() || "";
            if (!stockName.includes(name.trim().toLowerCase())) return false;
        }
        // Check ISIN filter
        if (isin && isin.trim().length > 0) {
            const stockIsin = stock.isin_code?.toLowerCase() || "";
            if (!stockIsin.includes(isin.trim().toLowerCase())) return false;
        }
        // Check exchange code filter
        if (exchangeCode && exchangeCode.trim().length > 0) {
            const stockExchangeCode = stock.exchange_code?.toLowerCase() || "";
            if (!stockExchangeCode.includes(exchangeCode.trim().toLowerCase())) return false;
        }
        // Check country filter
        if (country && country.id != null) {
            if (stock.country?.id !== country.id) return false;
        }
        // Check currency filter
        if (currency && currency.id != null) {
            if (stock.currency?.id !== currency.id) return false;
        }
        // Check sector filter
        if (sector && sector.id != null) {
            if (stock.sector?.id !== sector.id) return false;
        }
        // Note: trading_date is handled server-side for historyStock loading
        // We don't need to filter client-side for it
        return true;
    }, [
        name,
        isin,
        exchangeCode,
        country,
        currency,
        sector
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (data?.result) {
            const newTotal = data.result.total || 0;
            setTotal(newTotal);
            // Filter out null/undefined values from the stocks array
            const validStocks = (data.result.stocks || []).filter((stock)=>stock !== null && stock !== undefined);
            setDisplayedStocks(validStocks);
            // Only reset page if it's actually invalid (only when filters change and we get fewer results)
            if (newTotal > 0) {
                const maxPage = Math.max(0, Math.ceil(newTotal / pageSize) - 1);
                if (page > maxPage && isFilterChangeRef.current) setPage(0);
            } else if (newTotal === 0 && page > 0 && isFilterChangeRef.current) setPage(0);
        }
    }, [
        data,
        pageSize,
        page
    ]);
    // Initial load on mount
    (0, $bh6RR.useEffect)(()=>{
        if (isInitialMount.current) {
            isInitialMount.current = false;
            const filter = {
                limit: pageSize,
                offset: 0
            };
            if (orderBy) {
                filter.orderBy = orderBy;
                filter.orderDirection = orderDirection;
            }
            fetchStocks({
                variables: {
                    filter: filter
                }
            });
        }
    }, []);
    // Debounced filter changes
    (0, $bh6RR.useEffect)(()=>{
        if (isInitialMount.current) return;
        if (filterTimeoutRef.current) clearTimeout(filterTimeoutRef.current);
        isFilterChangeRef.current = true;
        filterTimeoutRef.current = setTimeout(()=>{
            // Build filter object
            const filter = {
                limit: pageSize,
                offset: 0
            };
            if (name && name.trim().length > 0) filter.name = name.trim();
            if (isin && isin.trim().length > 0) filter.isin_code = isin.trim();
            if (exchangeCode && exchangeCode.trim().length > 0) filter.exchange_code = exchangeCode.trim();
            if (country && country.id != null) filter.country_id = parseInt(country.id);
            if (currency && currency.id != null) filter.currency_id = parseInt(currency.id);
            if (sector && sector.id != null) filter.sector_id = parseInt(sector.id);
            if (tradingDate) {
                // Format trading date for server (subtract 1 day as per original logic)
                const filterDate = new Date(tradingDate);
                filterDate.setDate(filterDate.getDate() - 1);
                filter.trading_date = filterDate.toISOString().slice(0, 10) + " 00:00:00";
            }
            // Add sorting parameters
            if (orderBy) {
                filter.orderBy = orderBy;
                filter.orderDirection = orderDirection;
            }
            fetchStocks({
                variables: {
                    filter: filter
                }
            });
            // Reset flag after a short delay
            setTimeout(()=>{
                isFilterChangeRef.current = false;
            }, 100);
        }, 500); // 500ms debounce
        return ()=>{
            if (filterTimeoutRef.current) clearTimeout(filterTimeoutRef.current);
        };
    }, [
        name,
        isin,
        exchangeCode,
        country,
        currency,
        sector,
        tradingDate,
        pageSize,
        orderBy,
        orderDirection,
        fetchStocks
    ]);
    // Reload when sorting changes
    const lastOrderByRef = (0, $bh6RR.useRef)(orderBy);
    const lastOrderDirectionRef = (0, $bh6RR.useRef)(orderDirection);
    (0, $bh6RR.useEffect)(()=>{
        // Skip if this is the initial mount or if values haven't changed
        if (isInitialMount.current) {
            lastOrderByRef.current = orderBy;
            lastOrderDirectionRef.current = orderDirection;
            return;
        }
        if (lastOrderByRef.current === orderBy && lastOrderDirectionRef.current === orderDirection) return;
        lastOrderByRef.current = orderBy;
        lastOrderDirectionRef.current = orderDirection;
        const filter = {
            limit: pageSize,
            offset: page * pageSize
        };
        if (name && name.trim().length > 0) filter.name = name.trim();
        if (isin && isin.trim().length > 0) filter.isin_code = isin.trim();
        if (exchangeCode && exchangeCode.trim().length > 0) filter.exchange_code = exchangeCode.trim();
        if (country && country.id != null) filter.country_id = parseInt(country.id);
        if (currency && currency.id != null) filter.currency_id = parseInt(currency.id);
        if (sector && sector.id != null) filter.sector_id = parseInt(sector.id);
        if (tradingDate) {
            const filterDate = new Date(tradingDate);
            filterDate.setDate(filterDate.getDate() - 1);
            filter.trading_date = filterDate.toISOString().slice(0, 10) + " 00:00:00";
        }
        if (orderBy) {
            filter.orderBy = orderBy;
            filter.orderDirection = orderDirection;
        }
        fetchStocks({
            variables: {
                filter: filter
            }
        });
    }, [
        orderBy,
        orderDirection,
        page,
        pageSize,
        name,
        isin,
        exchangeCode,
        country,
        currency,
        sector,
        tradingDate,
        fetchStocks
    ]);
    // Reload when pagination changes
    (0, $bh6RR.useEffect)(()=>{
        if (isInitialMount.current) {
            isInitialMount.current = false;
            lastPageRef.current = page;
            lastPageSizeRef.current = pageSize;
            return;
        }
        const isPageChange = lastPageRef.current !== page;
        const isPageSizeChange = lastPageSizeRef.current !== pageSize;
        if (isFilterChangeRef.current && page === 0 && !isPageSizeChange) {
            lastPageRef.current = page;
            lastPageSizeRef.current = pageSize;
            return;
        }
        if (isPageChange || isPageSizeChange) {
            const filter = {
                limit: pageSize,
                offset: page * pageSize
            };
            if (name && name.trim().length > 0) filter.name = name.trim();
            if (isin && isin.trim().length > 0) filter.isin_code = isin.trim();
            if (exchangeCode && exchangeCode.trim().length > 0) filter.exchange_code = exchangeCode.trim();
            if (country && country.id != null) filter.country_id = parseInt(country.id);
            if (currency && currency.id != null) filter.currency_id = parseInt(currency.id);
            if (sector && sector.id != null) filter.sector_id = parseInt(sector.id);
            if (tradingDate) {
                const filterDate = new Date(tradingDate);
                filterDate.setDate(filterDate.getDate() - 1);
                filter.trading_date = filterDate.toISOString().slice(0, 10) + " 00:00:00";
            }
            if (orderBy) {
                filter.orderBy = orderBy;
                filter.orderDirection = orderDirection;
            }
            fetchStocks({
                variables: {
                    filter: filter
                }
            });
            lastPageRef.current = page;
            lastPageSizeRef.current = pageSize;
        }
    }, [
        page,
        pageSize,
        name,
        isin,
        exchangeCode,
        country,
        currency,
        sector,
        tradingDate,
        orderBy,
        orderDirection,
        fetchStocks
    ]);
    // Handle subscription updates
    (0, $bh6RR.useEffect)(()=>{
        if (!hasMounted.current) return;
        if (createStockSubscription.data?.result) {
            const newStock = createStockSubscription.data.result;
            // Check if new stock matches current filters
            if (stockMatchesFilters(newStock)) {
                setDisplayedStocks((prev)=>{
                    const exists = prev.some((s)=>s.id === newStock.id);
                    if (!exists) {
                        setTotal((currentTotal)=>currentTotal + 1);
                        return [
                            newStock,
                            ...prev
                        ];
                    }
                    return prev;
                });
                lastPageRef.current = 0;
                setPage(0);
            }
        }
    }, [
        createStockSubscription.data,
        stockMatchesFilters
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (!hasMounted.current) return;
        if (updateStockSubscription.data?.result) {
            const updatedStock = updateStockSubscription.data.result;
            setDisplayedStocks((prev)=>{
                return prev.map((s)=>{
                    if (s.id === updatedStock.id) {
                        // Preserve historyStock if it exists
                        const stockWithHistory = {
                            ...updatedStock,
                            historyStock: s.historyStock
                        };
                        return stockWithHistory;
                    }
                    return s;
                });
            });
        }
    }, [
        updateStockSubscription.data
    ]);
    const handlePageChange = (_, newPage)=>{
        setPage(newPage);
    };
    const handleRowsPerPageChange = (event)=>{
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPage(0);
    };
    const handleSortChange = (newOrderBy, newOrderDirection)=>{
        setOrderBy(newOrderBy);
        setOrderDirection(newOrderDirection);
        setPage(0);
    };
    const resetFilters = ()=>{
        setName("");
        setIsin("");
        setExchangeCode("");
        setCountry(null);
        setCurrency(null);
        setSector(null);
        setTradingDate(null);
        setPage(0);
    };
    const renderDeleteHSdata = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: rowData.id,
            sx: {
                width: "auto"
            },
            onClick: ()=>{
                setOpenDeleteHSDataForm(true);
                setSelectedStock(rowData);
            },
            children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3A2xv))),
                alt: "removeButton"
            })
        });
    };
    const columns = [
        {
            title: "Details",
            sorting: false,
            width: 63
        },
        {
            title: "Stock name",
            field: "name",
            width: 600
        },
        {
            title: "Country_code",
            field: "country.code",
            width: 50
        },
        {
            title: "Sector classification",
            field: "sector.name",
            width: 50
        },
        {
            title: "Close price",
            field: "historyStock.close_price",
            type: "numeric",
            width: 104,
            sorting: false
        },
        {
            title: "Engl Mkt Cap",
            field: "historyStock.engl_mkt_cap",
            type: "numeric",
            width: 126,
            sorting: false
        },
        {
            title: "EPRA Shares",
            width: 121,
            field: "historyStock.epra_shares",
            type: "numeric",
            sorting: false
        },
        {
            title: "Price Discount",
            width: 50,
            field: "historyStock.price_discount",
            type: "numeric",
            sorting: false
        },
        {
            title: "ISIN",
            field: "isin_code",
            width: 155
        },
        {
            title: "Bloomberg",
            width: 150,
            field: "bloomberg_ticker"
        },
        {
            title: "Exchange Code",
            field: "exchange_code",
            width: 139
        },
        {
            title: "Currency",
            field: "currency.code",
            width: 110
        },
        {
            title: "Delete HS Data",
            width: 30,
            sorting: false,
            render: renderDeleteHSdata
        }
    ];
    const handleDetails = (rowData)=>{
        history(`/stocks/${rowData.id}`, {
            state: {
                ...rowData
            }
        });
    };
    const countries = countriesQuery.data?.result || [];
    const currencies = currenciesQuery.data?.result || [];
    const sectors = sectorsQuery.data?.result || [];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "overviewPage",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                columns: columns,
                data: (0, $hsjD5.FormatTableData)(displayedStocks),
                loading: loading || countriesQuery.loading || currenciesQuery.loading || sectorsQuery.loading,
                handleDetails: handleDetails,
                handleRemove: ()=>true,
                hideSearch: true,
                page: page,
                onPageChange: handlePageChange,
                onRowsPerPageChange: handleRowsPerPageChange,
                totalCount: total,
                orderBy: orderBy,
                orderDirection: orderDirection,
                onSortChange: handleSortChange,
                createButtonProps: {
                    id: "create-stock-button",
                    onClick: ()=>setOpenStockForm(true),
                    text: "Create stock",
                    disabled: !canCreate
                },
                importButtonProps: {
                    id: "import-stock-data",
                    onClick: ()=>setOpenUpload(true)
                },
                additionalFilters: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    id: "filters",
                    sx: {
                        display: "flex",
                        gap: "20px",
                        flexWrap: "wrap"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "stock-name-filter",
                            label: "Name",
                            value: name,
                            onChange: (e)=>setName(e.target.value),
                            additionalStyle: {
                                width: "200px"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "stock-isin-filter",
                            label: "ISIN",
                            value: isin,
                            onChange: (e)=>setIsin(e.target.value),
                            additionalStyle: {
                                width: "200px"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "stock-exchange-code-filter",
                            label: "Exchange Code",
                            value: exchangeCode,
                            onChange: (e)=>setExchangeCode(e.target.value),
                            additionalStyle: {
                                width: "200px"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                            id: "stock-country-filter",
                            label: "Country",
                            values: country,
                            options: countries,
                            onChange: (_, newValue)=>setCountry(newValue),
                            getOptionLabel: (option)=>option?.name || "",
                            isSingle: true,
                            additionalStyle: {
                                width: "200px"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                            id: "stock-currency-filter",
                            label: "Currency",
                            values: currency,
                            options: currencies,
                            onChange: (_, newValue)=>setCurrency(newValue),
                            getOptionLabel: (option)=>option?.code || "",
                            isSingle: true,
                            additionalStyle: {
                                width: "200px"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                            id: "stock-sector-filter",
                            label: "Sector",
                            values: sector,
                            options: sectors,
                            onChange: (_, newValue)=>setSector(newValue),
                            getOptionLabel: (option)=>option?.name || "",
                            isSingle: true,
                            additionalStyle: {
                                width: "200px"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                            dateAdapter: (0, $1Dn8S.AdapterDateFns),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                id: "stock-trading-date-filter",
                                label: "Trading Date",
                                value: tradingDate,
                                clearable: true,
                                onChange: (value)=>setTradingDate(value),
                                format: "dd/MM/yyyy",
                                sx: {
                                    width: "200px"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                            id: "clear-filter-button",
                            "data-testid": "clear-filter-button",
                            onClick: resetFilters,
                            text: "clear all",
                            sx: {
                                textDecoration: "underline",
                                "&:hover": {
                                    textDecoration: "underline",
                                    background: (theme)=>theme.palette.primary.main,
                                    color: "#fff",
                                    border: "none"
                                }
                            }
                        })
                    ]
                })
            }),
            openStockForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $lKX46.default), {
                handleClose: ()=>setOpenStockForm(false)
            }),
            openUpload && /*#__PURE__*/ (0, $ih19M.jsx)((0, $89Htj.default), {
                handleClose: ()=>setOpenUpload(false),
                isIndexFile: false
            }),
            openDeleteHSDataForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $gQDXO.default), {
                handleClose: ()=>{
                    setOpenDeleteHSDataForm(false);
                    setSelectedStock(null);
                },
                selectedStock: selectedStock
            })
        ]
    });
};
var $d39d0d7ee40ff51d$export$2e2bcd8739ae039 = $d39d0d7ee40ff51d$var$StockList;

});
parcelRegister("lKX46", function(module, exports) {

$parcel$export(module.exports, "errorTexts", function () { return $bb2e3dc924cb23fd$export$b7274df26cc8ada; });
$parcel$export(module.exports, "default", function () { return $bb2e3dc924cb23fd$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $bIyvl = parcelRequire("bIyvl");
var $lGURI = parcelRequire("lGURI");

var $6L9uu = parcelRequire("6L9uu");

var $bilGR = parcelRequire("bilGR");

var $hjfla = parcelRequire("hjfla");

var $e4eIN = parcelRequire("e4eIN");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gFVvY = parcelRequire("gFVvY");

var $5PJ2i = parcelRequire("5PJ2i");

var $1ZlXU = parcelRequire("1ZlXU");

var $d13i8 = parcelRequire("d13i8");

var $ehzwo = parcelRequire("ehzwo");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");

var $8d818 = parcelRequire("8d818");
const $bb2e3dc924cb23fd$var$defaultErrorsObj = {
    stockCode: null,
    stockName: null,
    company: null,
    inclusion: null
};
const $bb2e3dc924cb23fd$export$b7274df26cc8ada = {
    stockName: "Stock Name too short!",
    stockCode: "Stock code should start with C!",
    stockCodeExists: "Stock code already exists!",
    company: "Company is required!",
    inclusion: "Index Inclusion is required!"
};
const $bb2e3dc924cb23fd$var$StockForm = ({ handleClose: handleClose })=>{
    const countries = (0, $hjfla.useCountriesQuery)();
    const currencies = (0, $hjfla.useCurrenciesQuery)();
    const companies = (0, $hjfla.useCompaniesNamesQuery)();
    const sectors = (0, $hjfla.useSectorsQuery)();
    const investmentFocuses = (0, $hjfla.useInvestmentFocusesQuery)();
    const [country, setCountry] = (0, $bh6RR.useState)(null);
    const [currency, setCurrency] = (0, $bh6RR.useState)(null);
    const [cusip, setCusip] = (0, $bh6RR.useState)("");
    const [isinCode, setIsinCode] = (0, $bh6RR.useState)("");
    const [bloomergTicker, setBloomergTicker] = (0, $bh6RR.useState)("");
    const [stockCode, setStockCode] = (0, $bh6RR.useState)("");
    const [exchangeCode, setExchangeCode] = (0, $bh6RR.useState)("");
    const [stockName, setStockName] = (0, $bh6RR.useState)("");
    const [reit, setReit] = (0, $bh6RR.useState)(false);
    const [inclusionDate, setInclusionDate] = (0, $bh6RR.useState)(null);
    const [icbSupersectorCode, setIcbSupersectorCode] = (0, $bh6RR.useState)("");
    const [icbIndustryCode, setIcbIndustryCode] = (0, $bh6RR.useState)("");
    const [icbSectorCode, setIcbSectorCode] = (0, $bh6RR.useState)("");
    const [icbSubsectorSectorCode, setIcbSubsectorCode] = (0, $bh6RR.useState)("");
    const [sedol, setSedol] = (0, $bh6RR.useState)("");
    const [reutersCode, setReutersCode] = (0, $bh6RR.useState)("");
    const [sAndP, setSAndP] = (0, $bh6RR.useState)("");
    const [company, setCompany] = (0, $bh6RR.useState)(null);
    const [sector, setSector] = (0, $bh6RR.useState)(null);
    const [subsector, setSubsector] = (0, $bh6RR.useState)(null);
    const [investmentFocus, setInvestmentFocus] = (0, $bh6RR.useState)(null);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($bb2e3dc924cb23fd$var$defaultErrorsObj);
    const [createStock, { loading: createStockLoading }] = (0, $hjfla.useCreateStockMutation)();
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const handleStockCodeChange = (event)=>{
        const { value: value } = event.target;
        if (value.length > 0) {
            if (value[0].toLowerCase() === "c") setFormErrors({
                ...formErrors,
                stockCode: null
            });
            else setFormErrors({
                ...formErrors,
                stockCode: $bb2e3dc924cb23fd$export$b7274df26cc8ada.stockCode
            });
        } else setFormErrors({
            ...formErrors,
            stockCode: null
        });
        setStockCode(value.trimStart());
    };
    const handleStockNameChange = (event)=>{
        const { value: value } = event.target;
        setFormErrors({
            ...formErrors,
            stockName: value.trim().length < 2 ? $bb2e3dc924cb23fd$export$b7274df26cc8ada.stockName : null
        });
        setStockName(value.trimStart());
    };
    const handleCompanyChange = (_, newValue)=>{
        if (newValue) setFormErrors({
            ...formErrors,
            company: null
        });
        else setFormErrors({
            ...formErrors,
            company: $bb2e3dc924cb23fd$export$b7274df26cc8ada.company
        });
        setCompany(newValue);
    };
    const handleDateChange = (dateInput)=>{
        if (dateInput !== null) setFormErrors({
            ...formErrors,
            inclusion: null
        });
        else setFormErrors({
            ...formErrors,
            inclusion: $bb2e3dc924cb23fd$export$b7274df26cc8ada.inclusion
        });
        setInclusionDate(dateInput);
    };
    const handleSubmit = ()=>{
        let hasErrors = false;
        const errors = {
            company: null,
            stockCode: null,
            stockName: null,
            inclusion: null
        };
        if (stockName.trim().length < 2) {
            hasErrors = true;
            errors.stockName = $bb2e3dc924cb23fd$export$b7274df26cc8ada.stockName;
        }
        if (stockCode.trim().length > 0) {
            if (stockCode[0].toLowerCase() !== "c") {
                hasErrors = true;
                errors.stockCode = $bb2e3dc924cb23fd$export$b7274df26cc8ada.stockCode;
            } else {
                const codeExists = (0, $gFVvY.stockCodeExists)(stockCode);
                if (codeExists) {
                    hasErrors = true;
                    errors.stockCode = $bb2e3dc924cb23fd$export$b7274df26cc8ada.stockCodeExists;
                }
            }
        }
        if (company === null) {
            hasErrors = true;
            errors.company = $bb2e3dc924cb23fd$export$b7274df26cc8ada.company;
        }
        if (inclusionDate === null) {
            hasErrors = true;
            errors.inclusion = $bb2e3dc924cb23fd$export$b7274df26cc8ada.inclusion;
        }
        if (hasErrors) setFormErrors(errors);
        else submitStock();
    };
    const submitStock = ()=>{
        const input = {
            name: stockName,
            company_id: parseInt(company?.id),
            is_reit: reit,
            start_date: inclusionDate.toString(),
            bloomberg_ticker: (0, $gFVvY.getStringInput)(bloomergTicker),
            cusip: (0, $gFVvY.getStringInput)(cusip),
            country_id: (0, $gFVvY.getObjectInputId)(country?.id),
            currency_id: (0, $gFVvY.getObjectInputId)(currency?.id),
            isin_code: (0, $gFVvY.getStringInput)(isinCode),
            reuters_code: (0, $gFVvY.getStringInput)(reutersCode),
            code: (0, $gFVvY.getStringInput)(stockCode),
            exchange_code: (0, $gFVvY.getStringInput)(exchangeCode),
            sedol: (0, $gFVvY.getStringInput)(sedol),
            snl_code: (0, $gFVvY.getStringInput)(sAndP),
            investment_focus_id: (0, $gFVvY.getObjectInputId)(investmentFocus?.id),
            icb_industry_code: (0, $gFVvY.getNumberInput)(icbIndustryCode),
            icb_sector_code: (0, $gFVvY.getNumberInput)(icbSectorCode),
            icb_subsector_code: (0, $gFVvY.getNumberInput)(icbSubsectorSectorCode),
            icb_supersector_code: (0, $gFVvY.getNumberInput)(icbSupersectorCode),
            sector_id: (0, $gFVvY.getObjectInputId)(sector?.id),
            subsector_id: (0, $gFVvY.getObjectInputId)(subsector?.id)
        };
        createStock({
            variables: {
                input: input
            },
            update () {
            // Subscription will handle updating the list
            }
        }).then((result)=>{
            if (result.data?.result) {
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Stock ${result.data.result.name} created`,
                        severity: "success",
                        autoHide: 2000
                    }
                });
                handleClose();
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "stock-form",
        width: 1400,
        title: "Create Stock",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    display: "flex"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    sx: {
                        display: "grid",
                        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                        height: "420px",
                        pt: "60px",
                        gap: "24px 104px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                            sx: {
                                gridColumn: "span 1",
                                display: "grid",
                                gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
                                pl: "80px",
                                gap: "0px 24px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                    id: "country-autocomplete",
                                    label: "Country",
                                    options: countries.data?.result || [],
                                    values: country,
                                    onChange: (_, newValue)=>setCountry(newValue),
                                    getOptionLabel: (option)=>option?.name,
                                    additionalStyle: {
                                        gridColumn: "span 6"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                    id: "currency-autocomplete",
                                    label: "Currency Code",
                                    options: currencies.data?.result || [],
                                    values: currency,
                                    onChange: (_, newValue)=>setCurrency(newValue),
                                    getOptionLabel: (option)=>option?.code,
                                    additionalStyle: {
                                        gridColumn: "span 6"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                    id: "investment-focus-autocomplete",
                                    label: "Investment Focus",
                                    options: investmentFocuses.data?.result || [],
                                    values: investmentFocus,
                                    onChange: (_, newValue)=>setInvestmentFocus(newValue),
                                    getOptionLabel: (option)=>option?.name,
                                    additionalStyle: {
                                        gridColumn: "span 6"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "cusip",
                                    label: "CUSIP",
                                    value: cusip || "",
                                    onChange: (e)=>setCusip(e.target.value),
                                    additionalStyle: {
                                        gridColumn: "span 6"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "isin-code",
                                    label: "ISIN code",
                                    value: isinCode || "",
                                    onChange: (e)=>setIsinCode(e.target.value),
                                    additionalStyle: {
                                        gridColumn: "span 6"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "bloomberg-ticker",
                                    label: "Bloomberg Ticker",
                                    value: bloomergTicker || "",
                                    onChange: (e)=>setBloomergTicker(e.target.value),
                                    additionalStyle: {
                                        gridColumn: "span 6"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "stock-code",
                                    label: "Stock Code",
                                    value: stockCode || "",
                                    onChange: handleStockCodeChange,
                                    additionalStyle: {
                                        gridColumn: "span 6"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "exchange-code",
                                    label: "Exchange Code",
                                    value: exchangeCode || "",
                                    onChange: (e)=>setExchangeCode(e.target.value),
                                    additionalStyle: {
                                        gridColumn: "span 6"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "stock-name",
                                    label: "Stock Name",
                                    value: stockName || "",
                                    onChange: handleStockNameChange,
                                    errorMsg: formErrors.stockName,
                                    additionalStyle: {
                                        gridColumn: "span 12"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                            sx: {
                                gridColumn: "span 1",
                                display: "grid",
                                gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
                                pr: "80px",
                                gap: "0px 24px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "icb-supersector-code",
                                    label: "ICB Supersector Code",
                                    value: icbSupersectorCode || "",
                                    type: "number",
                                    onChange: (e)=>setIcbSupersectorCode(e.target.value),
                                    additionalStyle: {
                                        gridColumn: "span 6"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "icb-industry-code",
                                    label: "ICB Industry Code",
                                    value: icbIndustryCode || "",
                                    type: "number",
                                    onChange: (e)=>setIcbIndustryCode(e.target.value),
                                    additionalStyle: {
                                        gridColumn: "span 6"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "icb-sector-code",
                                    label: "ICB Sector Code",
                                    value: icbSectorCode || "",
                                    type: "number",
                                    onChange: (e)=>setIcbSectorCode(e.target.value),
                                    additionalStyle: {
                                        gridColumn: "span 6"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "icb-subsector-code",
                                    label: "ICB Subsector Code",
                                    value: icbSubsectorSectorCode || "",
                                    type: "number",
                                    onChange: (e)=>setIcbSubsectorCode(e.target.value),
                                    additionalStyle: {
                                        gridColumn: "span 6"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                    id: "sectors-autocomplete",
                                    label: "Sector",
                                    options: sectors.data?.result || [],
                                    values: sector,
                                    onChange: (_, newValue)=>setSector(newValue),
                                    getOptionLabel: (option)=>option?.name,
                                    additionalStyle: {
                                        gridColumn: "span 6"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                    id: "subsectors-autocomplete",
                                    label: "Subsector",
                                    options: sectors.data?.result || [],
                                    values: subsector,
                                    onChange: (_, newValue)=>setSubsector(newValue),
                                    getOptionLabel: (option)=>option?.name,
                                    additionalStyle: {
                                        gridColumn: "span 6"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "sedol",
                                    label: "SEDOL",
                                    value: sedol || "",
                                    onChange: (e)=>setSedol(e.target.value),
                                    additionalStyle: {
                                        gridColumn: "span 4"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "reuters-code",
                                    label: "Reuters Code",
                                    value: reutersCode || "",
                                    onChange: (e)=>setReutersCode(e.target.value),
                                    additionalStyle: {
                                        gridColumn: "span 4"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "s-and-p",
                                    label: "S&P",
                                    value: sAndP || "",
                                    onChange: (e)=>setSAndP(e.target.value),
                                    additionalStyle: {
                                        gridColumn: "span 4"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                    id: "companies-autocomplete",
                                    label: "Company name",
                                    options: companies.data?.result || [],
                                    values: company,
                                    errorMsg: formErrors.company,
                                    onChange: handleCompanyChange,
                                    getOptionLabel: (option)=>option?.name,
                                    additionalStyle: {
                                        gridColumn: "span 7"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                                    dateAdapter: (0, $1Dn8S.AdapterDateFns),
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                        id: "index-inclusion-picker",
                                        label: "Index Inclusion",
                                        value: inclusionDate,
                                        format: "dd/MM/yyyy",
                                        errorMsg: formErrors.inclusion,
                                        clearable: false,
                                        onChange: handleDateChange,
                                        sx: {
                                            gridColumn: "span 5"
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            pl: "80px"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bIyvl.default), {
                            value: reit,
                            control: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lGURI.default), {
                                color: "primary",
                                checked: reit,
                                onChange: ()=>setReit(!reit)
                            }),
                            id: "reit",
                            label: "REIT",
                            labelPlacement: "start",
                            style: {
                                marginLeft: 0,
                                color: (0, $6L9uu.Colors).main,
                                fontSize: "18px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        className: "centralize",
                        sx: {
                            pb: "40px",
                            pt: "110px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                                id: "cancel-stock-button",
                                "data-testid": "cancel-stock-button",
                                onClick: handleClose,
                                text: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                                id: "save-stock-button",
                                "data-testid": "save-stock-button",
                                onClick: handleSubmit,
                                text: "Create"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                loading: countries.loading || companies.loading || currencies.loading || sectors.loading || investmentFocuses.loading || createStockLoading
            })
        ]
    });
};
var $bb2e3dc924cb23fd$export$2e2bcd8739ae039 = $bb2e3dc924cb23fd$var$StockForm;

});

parcelRegister("gQDXO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25cc069c91e717d4$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hjfla = parcelRequire("hjfla");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");
const $25cc069c91e717d4$var$defaultErrorsObj = {
    deleteEndDate: null,
    deleteEndDateInvalidDate: null
};
const $25cc069c91e717d4$var$errorTexts = {
    deleteEndDate: "Delete End Date is required",
    deleteEndDateInvalidDate: "Invalid Date Format"
};
const $25cc069c91e717d4$var$minDate = new Date(1970, 0, 1);
const $25cc069c91e717d4$var$deleteMinDateMessage = `date should be after ${$25cc069c91e717d4$var$minDate}`;
const $25cc069c91e717d4$var$DeleteHSDataForm = ({ handleClose: handleClose, selectedStock: selectedStock })=>{
    const [deleteEndDate, setDeleteEndDate] = (0, $bh6RR.useState)(new Date());
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($25cc069c91e717d4$var$defaultErrorsObj);
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [deleteHSDATA] = (0, $hjfla.useDeleteHsDataMutation)();
    const handleCancel = ()=>{
        setDeleteEndDate(null);
        handleClose();
    };
    const getPureDate = (date)=>{
        const getMonthWithTwoDigit = (date)=>{
            return ("0" + (date?.getMonth() + 1)).slice(-2);
        };
        const getDateWithTwoDigit = (date)=>{
            return ("0" + date?.getDate()).slice(-2);
        };
        const pureDate = `${date?.getFullYear()}-${getMonthWithTwoDigit(date)}-${getDateWithTwoDigit(date)}`;
        return pureDate;
    };
    const handleDeleteHSData = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `'Are you sure you want to delete History Stocks Data until ${getPureDate(deleteEndDate)} included ?'`,
                agreeAction: deleteHSData
            }
        });
    };
    const deleteHSData = async ()=>{
        const pureDate = getPureDate(deleteEndDate);
        const stock_id = selectedStock?.id;
        deleteHSDATA({
            variables: {
                id: stock_id,
                input: {
                    endDate: pureDate
                }
            },
            update (_, { data: data }) {
                if (data?.result) dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: `Successfully deleted History Stocks Data for stock ${selectedStock?.name} until ${pureDate}`,
                        autoHide: 4000
                    }
                });
            }
        }).catch((error)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            }));
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
    };
    const handleDeleteEndDateChange = (value)=>{
        if (value) {
            if (value < new Date($25cc069c91e717d4$var$minDate)) $25cc069c91e717d4$var$errorTexts.deleteEndDate = $25cc069c91e717d4$var$deleteMinDateMessage;
            else if ($25cc069c91e717d4$var$errorTexts.deleteEndDate === $25cc069c91e717d4$var$deleteMinDateMessage) $25cc069c91e717d4$var$errorTexts.deleteEndDate = null;
            setFormErrors({
                ...formErrors,
                deleteEndDate: null
            });
        } else setFormErrors({
            ...formErrors,
            deleteEndDate: $25cc069c91e717d4$var$errorTexts.deleteEndDate
        });
        setDeleteEndDate(value);
    };
    const handleSubmit = ()=>{
        const errors = {
            deleteEndDate: null,
            deleteEndDateInvalidDate: null
        };
        let hasErrors = false;
        if (!deleteEndDate) {
            hasErrors = true;
            errors.deleteEndDate = $25cc069c91e717d4$var$errorTexts.deleteEndDate;
        } else if (!Date.parse(deleteEndDate.toString())) {
            hasErrors = true;
            errors.deleteEndDate = $25cc069c91e717d4$var$errorTexts.deleteEndDateInvalidDate;
        }
        if (hasErrors) setFormErrors(errors);
        else {
            handleDeleteHSData();
            handleClose();
        }
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5PJ2i.default), {
        id: "history-stocks-delete-form",
        width: 375,
        title: "Delete History Stocks Data",
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                margin: "50px",
                display: "flex",
                flexDirection: "column",
                gap: "35px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                    dateAdapter: (0, $1Dn8S.AdapterDateFns),
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                        id: "delete-end-date-picker",
                        label: "End Date",
                        value: deleteEndDate,
                        onChange: (date)=>handleDeleteEndDateChange(date),
                        errorMsg: formErrors.deleteEndDate,
                        minDate: $25cc069c91e717d4$var$minDate,
                        sx: {
                            width: "100%"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                            id: "cancel-delete-button",
                            onClick: handleCancel,
                            text: "Close"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                            id: "save-delete-button",
                            onClick: handleSubmit,
                            text: "Submit"
                        })
                    ]
                })
            ]
        })
    });
};
var $25cc069c91e717d4$export$2e2bcd8739ae039 = $25cc069c91e717d4$var$DeleteHSDataForm;

});


parcelRegister("gduAv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e452f117c14457b8$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $d7fM7 = parcelRequire("d7fM7");

var $cxTnx = parcelRequire("cxTnx");

var $aM783 = parcelRequire("aM783");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $2EMvp = parcelRequire("2EMvp");

var $chLJv = parcelRequire("chLJv");
var $am7GZ = parcelRequire("am7GZ");
var $lGURI = parcelRequire("lGURI");

var $bilGR = parcelRequire("bilGR");

var $daKAK = parcelRequire("daKAK");

var $b6HeH = parcelRequire("b6HeH");

var $dgmqH = parcelRequire("dgmqH");

var $6oiUE = parcelRequire("6oiUE");

var $9hpRw = parcelRequire("9hpRw");
const $e452f117c14457b8$var$CventList = ()=>{
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [filteredContacts, setFilteredContacts] = (0, $bh6RR.useState)([]);
    const [eventId, setEventId] = (0, $bh6RR.useState)("");
    const [selectedLocation, setSelectedLocation] = (0, $bh6RR.useState)(null);
    const [openEventForm, setOpenEventForm] = (0, $bh6RR.useState)(false);
    const [eventName, setEventName] = (0, $bh6RR.useState)(null);
    const [deleteCventContact] = (0, $hjfla.useDeleteCventContactMutation)();
    const eventsData = (0, $hjfla.useGetAllCventEventsQuery)();
    const [allEvents, setAllEvents] = (0, $bh6RR.useState)([]);
    const [locationsData, setLocationsData] = (0, $bh6RR.useState)([]);
    const [toggleIsApproved] = (0, $hjfla.useToggleIsApprovedMutation)();
    const [getOverviewData, overviewData] = (0, $hjfla.useGetAllCventContactsForLocationLazyQuery)();
    const [getLocations, locationsQueryData] = (0, $hjfla.useGetAllLocationsForEventLazyQuery)();
    const [openCreateInvoiceForm, setOpenCreateInvoiceForm] = (0, $bh6RR.useState)(false);
    const [openNameSelectionForm, setOpenNameSelectionForm] = (0, $bh6RR.useState)(false);
    const [selectedCventContact, setSelectedCventContact] = (0, $bh6RR.useState)(null);
    const [unlinkContact] = (0, $hjfla.useUnLinkContactMutation)();
    const [openUpload, setOpenUpload] = (0, $bh6RR.useState)(false);
    const handleUpdateEvents = (event)=>{
        if (eventName?.name !== event.name && eventName) setAllEvents([
            event,
            ...allEvents || []
        ]);
    };
    const handleUpdateLocationContacts = (update)=>{
        if (update) getOverviewData({
            variables: {
                id: selectedLocation?.id
            },
            fetchPolicy: "no-cache"
        });
    };
    const handleUpdateLocations = (location)=>{
        if (location !== null) setLocationsData([
            location,
            ...locationsData || []
        ]);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (eventsData && eventsData.data?.result) setAllEvents(eventsData.data.result);
    }, [
        eventsData
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (locationsQueryData && locationsQueryData.data?.result) setLocationsData(locationsQueryData.data.result);
    }, [
        locationsQueryData
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (eventId.length > 0) getLocations({
            variables: {
                event_id: eventId
            }
        });
        else setLocationsData([]);
    }, [
        eventId
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (overviewData && overviewData.data?.result) setFilteredContacts(overviewData.data?.result);
    }, [
        overviewData
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (selectedLocation) getOverviewData({
            variables: {
                id: selectedLocation?.id
            }
        });
    }, [
        selectedLocation
    ]);
    const handleAddContact = (contact)=>{
        setFilteredContacts([
            contact,
            ...filteredContacts || []
        ]);
    };
    const handleEdit = (editedContact)=>{
        setFilteredContacts(filteredContacts?.map((c)=>c?.id === editedContact.id ? editedContact : c));
    };
    const handleEventChange = (_, newValue)=>{
        if (newValue) {
            setEventName(newValue);
            setEventId(newValue.id);
            setSelectedLocation(null);
        } else {
            setEventName(null);
            setEventId("");
            setSelectedLocation(null);
            setFilteredContacts([]);
        }
    };
    const handleLocationChange = (_, newValue)=>{
        if (newValue) setSelectedLocation(newValue);
        else {
            setSelectedLocation(null);
            setFilteredContacts([]);
        }
    };
    const handleExport = ()=>{
        const fileName = "Cvent_Contacts";
        const csvData = filteredContacts.map((c)=>({
                Id: c.id,
                Created: c.date_created,
                Role: c.role?.name,
                Name: c.first_name,
                "Last Name": c.last_name,
                Company: c.company_name,
                Email: c.email,
                Status: c.is_approved,
                "Full Name": c.fullName,
                "Date Paid": c.date_paid,
                "Invoice Number": c.invoice
            }));
        (0, $daKAK.exportDataAsExcel)(csvData, fileName);
    };
    const formatDate = (rowData, name)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return rowData[name] ? // @ts-ignore
        (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(parseInt(rowData[name])).format((0, $aM783.DATE_TIME_FORMATS).DATE_AND_TIME) : "";
    };
    const formatDateTwo = (rowData, name)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return rowData[name] ? // @ts-ignore
        (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(parseInt(rowData[name])).format((0, $aM783.DATE_TIME_FORMATS).DATE_AND_TIME) : "";
    };
    const openCreateEventMethod = ()=>{
        setOpenEventForm(true);
    };
    const handleCloseForm = ()=>{
        setOpenEventForm(false);
        setSelectedCventContact(null);
    };
    const handleDetails = (rowData)=>{
        setSelectedCventContact(rowData);
        setOpenEventForm(true);
    };
    const handleDelete = (rowData)=>{
        if (!rowData) return;
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteCventContact({
            variables: {
                id: Number(rowData.id)
            },
            update (_, { data: data }) {
                if (data?.result) {
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            text: `Record deleted ${rowData.fullName}`,
                            severity: "success"
                        }
                    });
                    const updatedContacts = filteredContacts?.filter((c)=>c?.id !== rowData.id);
                    setFilteredContacts(updatedContacts);
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: e.message,
                    severity: "error"
                }
            });
        });
    };
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${rowData.fullName}?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleIsApproved = (rowData)=>{
        const is_approved = !rowData.is_approved;
        toggleIsApproved({
            variables: {
                id: rowData.id,
                input: {
                    is_approved: is_approved
                }
            },
            update () {
                const message = is_approved ? `${rowData.fullName} is approved` : `${rowData.fullName} is not approved`;
                const updatedContacts = filteredContacts?.map((c)=>c?.id === rowData.id ? {
                        ...c,
                        is_approved: is_approved
                    } : c);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: message
                    }
                });
                setFilteredContacts(updatedContacts);
            }
        }).catch((e)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            }));
    };
    const isLinked = (rowData)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $lGURI.default), {
            id: "is_linked_contact_switch",
            "data-testid": "is_linked_contact_switch",
            disableRipple: true,
            name: "checkIsLinkedContact",
            onChange: ()=>handleLinkContact(rowData),
            checked: rowData.is_linked || false
        });
    const updateContact = (rowData, is_linked)=>{
        const message = is_linked ? `${rowData.fullName} is linked` : `${rowData.fullName} is unlinked`;
        const updatedContacts = filteredContacts?.map((c)=>c?.id === rowData.id ? {
                ...c,
                is_linked: is_linked
            } : c);
        dispatch({
            type: (0, $ayVxz.Actions).ShowMessage,
            payload: {
                severity: "success",
                text: message
            }
        });
        setFilteredContacts(updatedContacts);
    };
    const handleLinkContact = (cventContact)=>{
        const is_linked = !cventContact.is_linked;
        if (!cventContact.is_linked) {
            setSelectedCventContact(cventContact);
            setOpenNameSelectionForm(true);
        } else unlinkContact({
            variables: {
                id: cventContact.id
            },
            update () {
                updateContact(cventContact, is_linked);
            }
        }).catch((e)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            }));
    };
    const renderIsApproved = (rowData)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $lGURI.default), {
            id: "is_approved_contact_switch",
            "data-testid": "is_approved_contact_switch",
            disableRipple: true,
            name: "checkIsApprovedContact",
            onChange: ()=>handleIsApproved(rowData),
            checked: rowData.is_approved || false
        });
    const renderCreateInvoice = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $am7GZ.default), {
            id: `${rowData.fullName}`,
            disabled: !rowData.is_linked || rowData.invoice !== null,
            onClick: ()=>{
                setSelectedCventContact(rowData);
                dispatch({
                    type: (0, $ayVxz.Actions).SetInvoice,
                    payload: {
                        invoice: null
                    }
                });
                setOpenCreateInvoiceForm(true);
            },
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $dgmqH.default), {})
        });
    };
    const columns = [
        {
            title: "Details",
            width: 63.5,
            sorting: false
        },
        {
            title: "Created",
            width: 200,
            field: "date_created",
            type: "date",
            render: (rowData)=>formatDate(rowData, "date_created")
        },
        {
            title: "Role",
            width: 160,
            field: "role.name_short"
        },
        {
            title: "Link",
            field: "is_linked",
            sorting: false,
            render: isLinked,
            width: 100,
            type: "boolean"
        },
        {
            title: "Name",
            width: 200,
            field: "first_name"
        },
        {
            title: "Last Name",
            width: 200,
            field: "last_name"
        },
        {
            title: "Company",
            width: 200,
            field: "company_name"
        },
        {
            title: "Email",
            width: 195,
            field: "email"
        },
        {
            title: "Status",
            width: 100,
            sorting: false,
            field: "is_approved",
            render: renderIsApproved,
            type: "boolean"
        },
        {
            title: "Full Name",
            width: 185,
            field: "fullName"
        },
        {
            title: "Date Paid",
            width: 200,
            field: "date_paid",
            type: "date",
            render: (rowData)=>formatDateTwo(rowData.invoice ? rowData.invoice : rowData, "date_paid")
        },
        {
            title: "Invoice Number",
            width: 70,
            field: "invoice.number"
        },
        {
            title: "Create Invoice",
            width: 30,
            sorting: false,
            render: renderCreateInvoice
        },
        {
            title: "Remove",
            width: 71.5,
            sorting: false
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        className: "overviewPage",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                    columns: columns,
                    data: filteredContacts,
                    loading: overviewData.loading,
                    pageSize: 10,
                    handleRemove: handleRemove,
                    handleDetails: handleDetails,
                    createButtonProps: {
                        id: "create-registrant",
                        onClick: openCreateEventMethod,
                        text: "Create Registrant",
                        disabled: selectedLocation === null || eventName === null
                    },
                    importButtonProps: {
                        id: "import-ftse-button",
                        onClick: ()=>setOpenUpload(true)
                    },
                    exportButtonProps: {
                        id: "export-contacts--button",
                        onClick: ()=>handleExport()
                    },
                    additionalFilters: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        id: "fitlers",
                        sx: {
                            display: "flex",
                            gap: "40px",
                            marginLeft: "20px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "cvent-event-autocomplete-filter",
                                label: "Event Name",
                                options: allEvents || [],
                                values: eventName,
                                onChange: handleEventChange,
                                getOptionLabel: (option)=>option?.name,
                                additionalStyle: {
                                    width: "280px"
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "cvent-locations-autocomplete-filter",
                                label: "Event Location",
                                options: locationsData || [],
                                values: selectedLocation,
                                onChange: handleLocationChange,
                                getOptionLabel: (option)=>option?.name,
                                additionalStyle: {
                                    width: "280px"
                                },
                                disabled: locationsData?.length === 0
                            })
                        ]
                    })
                }),
                openEventForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $2EMvp.default), {
                    handleClose: handleCloseForm,
                    cventContact: selectedCventContact,
                    locationId: Number(selectedLocation?.id),
                    updateList: handleAddContact,
                    editList: handleEdit
                }),
                openCreateInvoiceForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $b6HeH.default), {
                    cventContact: selectedCventContact,
                    onClose: ()=>setOpenCreateInvoiceForm(false),
                    handleUpdateLocationContacts: handleUpdateLocationContacts
                }),
                openUpload && /*#__PURE__*/ (0, $ih19M.jsx)((0, $6oiUE.default), {
                    handleClose: ()=>setOpenUpload(false),
                    updateEvents: handleUpdateEvents,
                    updateLocations: handleUpdateLocations
                }),
                openNameSelectionForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $9hpRw.default), {
                    handleClose: ()=>setOpenNameSelectionForm(false),
                    cventContact: selectedCventContact
                })
            ]
        })
    });
};
var $e452f117c14457b8$export$2e2bcd8739ae039 = $e452f117c14457b8$var$CventList;

});
parcelRegister("2EMvp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfd0230f4b84fc67$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");

var $bSbwb = parcelRequire("bSbwb");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $gFVvY = parcelRequire("gFVvY");

var $e4eIN = parcelRequire("e4eIN");

var $91340 = parcelRequire("91340");

var $bilGR = parcelRequire("bilGR");

var $ehzwo = parcelRequire("ehzwo");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $1Dn8S = parcelRequire("1Dn8S");

var $6L9uu = parcelRequire("6L9uu");
const $bfd0230f4b84fc67$var$defaultErrorsObj = {
    createdDate: null,
    first_name: null,
    last_name: null,
    company_name: null,
    email: null
};
//
const $bfd0230f4b84fc67$var$errorTexts = {
    createdDate: "Created date is required!",
    first_name: "First name is required!",
    last_name: "Last name is required",
    company_name: "Company name is required",
    email: "Email is required"
};
const $bfd0230f4b84fc67$var$CventForm = ({ handleClose: handleClose, cventContact: cventContact, locationId: locationId, updateList: updateList, editList: editList })=>{
    const [editEnabled, setEditEnabled] = (0, $bh6RR.useState)(cventContact === null);
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [createdDate, setCreatedDate] = (0, $bh6RR.useState)(cventContact ? (0, $gFVvY.parseDate)(cventContact.date_created) : null);
    const allRoles = (0, $hjfla.useGetAllCventRolesQuery)();
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($bfd0230f4b84fc67$var$defaultErrorsObj);
    const [selectedRole, setSelectedRole] = (0, $bh6RR.useState)(cventContact?.role || null);
    const [firstName, setFirstName] = (0, $bh6RR.useState)(cventContact?.first_name || "");
    const [lastName, setLastName] = (0, $bh6RR.useState)(cventContact?.last_name || "");
    const [companyName, setCompanyName] = (0, $bh6RR.useState)(cventContact?.company_name || null);
    const [email, setEmail] = (0, $bh6RR.useState)(cventContact?.email || null);
    const [createCventContact, createCventContactResult] = (0, $hjfla.useCreateCventContactMutation)();
    const [updateCventContact, updateCventContactResult] = (0, $hjfla.useUpdateCventContactMutation)();
    const handleDateChange = (input)=>{
        if (input) {
            if (!Number.isNaN(input.getDate())) setFormErrors({
                ...formErrors,
                createdDate: null
            });
        } else setFormErrors({
            ...formErrors,
            createdDate: $bfd0230f4b84fc67$var$errorTexts.createdDate
        });
        setCreatedDate(input);
    };
    const handleRoleChange = (_, newValue)=>{
        setSelectedRole(newValue);
    };
    const handleFirstNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!value || value.length < 2) setFormErrors({
            ...formErrors,
            first_name: $bfd0230f4b84fc67$var$errorTexts.first_name
        });
        else setFormErrors({
            ...formErrors,
            first_name: null
        });
        setFirstName(value);
    };
    const handleLastNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!value || value.length < 2) setFormErrors({
            ...formErrors,
            last_name: $bfd0230f4b84fc67$var$errorTexts.last_name
        });
        else setFormErrors({
            ...formErrors,
            last_name: null
        });
        setLastName(value);
    };
    const handleCompanyNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!value || value.length < 2) setFormErrors({
            ...formErrors,
            company_name: $bfd0230f4b84fc67$var$errorTexts.company_name
        });
        else setFormErrors({
            ...formErrors,
            company_name: null
        });
        setCompanyName(value);
    };
    const handleEmailChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!value || value.length < 2) setFormErrors({
            ...formErrors,
            email: $bfd0230f4b84fc67$var$errorTexts.email
        });
        else setFormErrors({
            ...formErrors,
            email: null
        });
        setEmail(value);
    };
    const handleSave = ()=>{
        let hasErrors = false;
        const errs = {
            createdDate: null,
            first_name: null,
            last_name: null,
            company_name: null,
            email: null
        };
        if (firstName.length < 2) {
            hasErrors = true;
            errs.first_name = $bfd0230f4b84fc67$var$errorTexts.first_name;
        }
        if (lastName.length < 2) {
            hasErrors = true;
            errs.last_name = $bfd0230f4b84fc67$var$errorTexts.last_name;
        }
        if (createdDate === null) {
            hasErrors = true;
            errs.createdDate = $bfd0230f4b84fc67$var$errorTexts.createdDate;
        }
        if (hasErrors) setFormErrors(errs);
        else submitContact();
    };
    const submitContact = ()=>{
        const input = {
            first_name: firstName,
            last_name: lastName,
            company_name: companyName,
            role_id: Number(selectedRole?.id),
            email: email,
            date_created: (0, $gFVvY.getNullableDateString)(createdDate),
            location_id: locationId,
            is_approved: false
        };
        if (cventContact !== null) updateCventContact({
            variables: {
                id: cventContact.id,
                input: input
            },
            update (_, { data: data }) {
                if (data?.result) {
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `You have successfully updated ${input.first_name} ${input.last_name}`
                        }
                    });
                    handleClose();
                    editList(data?.result);
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        });
        else createCventContact({
            variables: {
                input: input
            },
            update (_, { data: data }) {
                if (data?.result) {
                    updateList(data.result);
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `Registrant ${input.first_name} ${input.last_name} created`
                        }
                    });
                    handleClose();
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5PJ2i.default), {
        id: "new-cvent-contact-registree-dialog",
        width: 589,
        height: 640,
        title: cventContact ? "Cvent Contact Details" : "Create Registrant",
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                padding: "70px",
                position: "relative"
            },
            children: [
                cventContact && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        position: "absolute",
                        top: "24px",
                        right: "24px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                        id: "create-registrant-edit-button",
                        onClick: ()=>setEditEnabled(true),
                        disabled: editEnabled,
                        editButtonColor: editEnabled ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    sx: {
                        display: "grid",
                        gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                        gap: "62px 22px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "first-name",
                            label: "First Name",
                            value: firstName,
                            onChange: handleFirstNameChange,
                            errorMsg: formErrors.first_name,
                            disabled: !editEnabled || createCventContactResult.loading || updateCventContactResult.loading,
                            additionalStyle: {
                                gridColumn: "span 2"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "last-name",
                            label: "Last Name",
                            value: lastName,
                            onChange: handleLastNameChange,
                            errorMsg: formErrors.last_name,
                            disabled: !editEnabled || createCventContactResult.loading || updateCventContactResult.loading,
                            additionalStyle: {
                                gridColumn: "span 2"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                            dateAdapter: (0, $1Dn8S.AdapterDateFns),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                id: "cvent-create-registrant-created-date",
                                label: "Created Date",
                                value: createdDate,
                                format: "dd/MM/yyyy",
                                errorMsg: formErrors.createdDate,
                                clearable: true,
                                onChange: (d)=>handleDateChange(d),
                                disabled: !editEnabled || createCventContactResult.loading || updateCventContactResult.loading,
                                sx: {
                                    gridColumn: "span 2"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                            id: "cvent-registrant-role-autocomplete",
                            options: allRoles.data?.result || [],
                            getOptionLabel: (option)=>option.name,
                            values: selectedRole,
                            onChange: handleRoleChange,
                            label: "Role",
                            disabled: !editEnabled || createCventContactResult.loading || updateCventContactResult.loading,
                            additionalStyle: {
                                gridColumn: "span 2"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "company-name",
                            label: "Company Name",
                            value: companyName,
                            onChange: handleCompanyNameChange,
                            disabled: !editEnabled || createCventContactResult.loading || updateCventContactResult.loading,
                            additionalStyle: {
                                gridColumn: "span 4"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "email",
                            label: "Email",
                            value: email,
                            onChange: handleEmailChange,
                            disabled: !editEnabled || createCventContactResult.loading || updateCventContactResult.loading,
                            additionalStyle: {
                                gridColumn: "span 4"
                            },
                            errorMsg: formErrors.email
                        })
                    ]
                }),
                editEnabled && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize",
                    sx: {
                        marginTop: "60px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                            id: "cancel-button",
                            onClick: handleClose,
                            text: cventContact === null || editEnabled ? "Cancel" : "Close"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                            id: "save-button",
                            onClick: handleSave,
                            disabled: !editEnabled || createCventContactResult.loading || updateCventContactResult.loading,
                            text: cventContact ? "Save" : "Create"
                        })
                    ]
                })
            ]
        })
    });
};
var $bfd0230f4b84fc67$export$2e2bcd8739ae039 = $bfd0230f4b84fc67$var$CventForm;

});

parcelRegister("b6HeH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41124352b6ded986$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $5PJ2i = parcelRequire("5PJ2i");

var $hjfla = parcelRequire("hjfla");

var $2lD0z = parcelRequire("2lD0z");

var $chLJv = parcelRequire("chLJv");

var $jvWbt = parcelRequire("jvWbt");

var $72HIx = parcelRequire("72HIx");

var $cnCqi = parcelRequire("cnCqi");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $cAzF9 = parcelRequire("cAzF9");

var $89CnP = parcelRequire("89CnP");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $40Qwb = parcelRequire("40Qwb");

var $2glCg = parcelRequire("2glCg");

var $2OHqK = parcelRequire("2OHqK");

var $8d818 = parcelRequire("8d818");

const $41124352b6ded986$var$steps = [
    "My Details",
    "Client",
    "Product & Pricing",
    "Invoice"
];
const $41124352b6ded986$var$InvoiceStepper = ({ onClose: onClose, cventContact: cventContact, invoice: invoice, handleUpdateLocationContacts: handleUpdateLocationContacts })=>{
    const { data: data } = (0, $hjfla.usePaymentDetailsQuery)();
    const { state: state, dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [activeStep, setActiveStep] = (0, $bh6RR.useState)(1);
    const [paymentDetails, setPaymentDetails] = (0, $bh6RR.useState)(data?.result ?? (0, $40Qwb.defaultPaymentDto));
    const [productInfo, setProductInfo] = (0, $bh6RR.useState)((0, $40Qwb.defaultProductInfo));
    const [invoiceFullScreen, setInvoiceFullScreen] = (0, $bh6RR.useState)(false);
    const [contact, setContact] = (0, $bh6RR.useState)(null);
    const [createInvoice, createInvoiceResult] = (0, $hjfla.useCreateInvoiceMutation)();
    const contactQuery = (0, $hjfla.useContactQuery)({
        variables: {
            id: Number(cventContact.contact_id)
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        const invoice = state.selectedInvoice;
        if (data && data.result) {
            setPaymentDetails(data.result);
            if (invoice) invoice.paymentDetails = data.result;
        }
        if (contactQuery.data && contactQuery.data.result) setContact(contactQuery.data.result);
    }, [
        data,
        contactQuery.data
    ]);
    const handleInvoiceConfirm = ()=>{
        if (handleUpdateLocationContacts) handleUpdateLocationContacts(true);
    };
    const getStepContent = ()=>{
        switch(activeStep){
            case 0:
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $jvWbt.default), {
                    paymentDetailsInput: paymentDetails,
                    updateDetails: setPaymentDetails
                });
            case 1:
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $72HIx.default), {
                    cventContact: contact
                });
            case 2:
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cnCqi.default), {
                    productInfoInput: productInfo,
                    setProductInfo: setProductInfo
                });
            case 3:
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $cAzF9.default), {
                    setPreview: ()=>setInvoiceFullScreen(!invoiceFullScreen),
                    editInvoice: handleInvoiceConfirm,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $89CnP.default), {
                        fullscreen: invoiceFullScreen,
                        cventData: {
                            contact: contact,
                            paymentDetails: paymentDetails,
                            productInfo: productInfo
                        }
                    })
                });
            default:
                return /*#__PURE__*/ (0, $ih19M.jsx)("h1", {
                    children: "unknown"
                });
        }
    };
    const isValidInvoice = (selectedInvoice)=>{
        if (!selectedInvoice.productInfo) return false;
        if (!selectedInvoice.paymentDetails) return false;
        if (!selectedInvoice.company) return false;
        if (!selectedInvoice.contact) return false;
        if (!selectedInvoice.address) return false;
        return true;
    };
    const getInvoiceInputDto = (selectedInvoice, originalInvoice)=>{
        const res = {
            product_id: parseInt(selectedInvoice.productInfo?.product?.id),
            membership_id: parseInt(contact?.company?.membership?.id),
            payment_details_id: parseInt(selectedInvoice.paymentDetails?.id),
            total: selectedInvoice.productInfo?.total,
            discount: selectedInvoice.productInfo?.discount ?? 0,
            vat: selectedInvoice.productInfo?.vatPercent ?? 0,
            details: getPaymentDetailsDto(selectedInvoice, originalInvoice),
            notes: selectedInvoice.notes,
            cvent_contact_id: Number(cventContact?.id)
        };
        return res;
    };
    const getPaymentDetailsDto = (selectedInvoice, originalInvoice)=>{
        return {
            company_name: selectedInvoice.company?.name ?? originalInvoice?.details?.company_name,
            company_address_vat: selectedInvoice.company?.main_address?.complete_vat_number ?? originalInvoice?.details?.company_address_vat,
            contact_first_name: selectedInvoice.contact?.first_name ?? originalInvoice?.details?.contact_first_name,
            contact_last_name: selectedInvoice.contact?.last_name ?? originalInvoice?.details?.contact_last_name,
            contact_email: selectedInvoice.contact?.email ?? originalInvoice?.details?.contact_email,
            address_name: selectedInvoice.address?.name ?? originalInvoice?.details?.address_name,
            street: selectedInvoice.address?.street ?? originalInvoice?.details?.street,
            city: contact?.address?.city ?? originalInvoice?.details?.city,
            zip: selectedInvoice.address?.zip ?? originalInvoice?.details?.zip,
            country: selectedInvoice.address?.country?.name ?? originalInvoice?.details?.country,
            region: contact?.address?.country?.region?.name ?? originalInvoice?.details?.region,
            title_external: selectedInvoice.contact?.title_external ?? originalInvoice?.details?.title_external,
            prefix: selectedInvoice?.contact?.prefix ?? originalInvoice?.details?.prefix
        };
    };
    const handleNext = ()=>{
        if (activeStep === 2 && productInfo.product === null) dispatch({
            type: (0, $ayVxz.Actions).ShowMessage,
            payload: {
                severity: "error",
                text: "You should select a product"
            }
        });
        else if (activeStep < $41124352b6ded986$var$steps.length - 1) setActiveStep(activeStep + 1);
        else if (activeStep === $41124352b6ded986$var$steps.length - 1) {
            const selectedInvoice = state.selectedInvoice;
            if (selectedInvoice.status === (0, $2glCg.InvoiceStatus).New) {
                if (isValidInvoice(selectedInvoice)) {
                    const input = getInvoiceInputDto(selectedInvoice);
                    createInvoice({
                        variables: {
                            input: input
                        },
                        update (_, { data: data }) {
                            if (data?.result) {
                                dispatch({
                                    type: (0, $ayVxz.Actions).SetInvoice,
                                    payload: {
                                        invoice: data.result,
                                        productInfo: (0, $2OHqK.getInvoiceProductInfoDto)(data.result)
                                    }
                                });
                                dispatch({
                                    type: (0, $ayVxz.Actions).ShowMessage,
                                    payload: {
                                        severity: "success",
                                        text: `You have successfully created new invoice for contact: ${contact?.fullName}`
                                    }
                                });
                            }
                        }
                    }).catch((e)=>{
                        dispatch({
                            type: (0, $ayVxz.Actions).ShowMessage,
                            payload: {
                                severity: "error",
                                text: e.message,
                                autoHide: 6000
                            }
                        });
                    });
                }
            }
        }
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "cvent-invoice-stepper",
        width: 1200,
        onClose: onClose,
        title: invoice ? "Create invoice" : "Invoice",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2lD0z.default), {
                steps: $41124352b6ded986$var$steps,
                activeStep: activeStep
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                children: getStepContent()
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize buttons-container",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "invoice-stepper-back-button",
                        onClick: ()=>setActiveStep(activeStep - 1),
                        disabled: activeStep === 0,
                        text: "Back"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "invoice-stepper-save-next-button",
                        onClick: handleNext,
                        text: activeStep === $41124352b6ded986$var$steps.length - 1 ? "Save" : "Next"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                loading: createInvoiceResult.loading
            })
        ]
    });
};
var $41124352b6ded986$export$2e2bcd8739ae039 = $41124352b6ded986$var$InvoiceStepper;

});

parcelRegister("6oiUE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3548dfc3d30117ef$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");

var $5PJ2i = parcelRequire("5PJ2i");

var $ehzwo = parcelRequire("ehzwo");

var $b85VG = parcelRequire("b85VG");

var $6L9uu = parcelRequire("6L9uu");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $TDoiN = parcelRequire("TDoiN");

var $hjfla = parcelRequire("hjfla");

var $ayVxz = parcelRequire("ayVxz");

var $bu31C = parcelRequire("bu31C");
const $3548dfc3d30117ef$export$d19119f0474d967d = {
    location: null,
    fileName: null
};
const $3548dfc3d30117ef$export$1067ba46601ca091 = {
    location: "Location is required",
    fileName: "File is required"
};
function $3548dfc3d30117ef$export$2e2bcd8739ae039({ handleClose: handleClose, updateEvents: updateEvents, updateLocations: updateLocations }) {
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [uploadContacts] = (0, $hjfla.useUploadCventContactsMutation)();
    const [fileName, setFileName] = (0, $bh6RR.useState)("");
    const [fileContacts, setFileContacts] = (0, $bh6RR.useState)([]);
    const fileHeaders = "event_name, first_name, last_name, company_name, title, email, role";
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($3548dfc3d30117ef$export$d19119f0474d967d);
    const [location, setLocation] = (0, $bh6RR.useState)("");
    const allRoles = (0, $hjfla.useGetAllCventRolesQuery)();
    const [roles, setRoles] = (0, $bh6RR.useState)([]);
    (0, $bh6RR.useEffect)(()=>{
        if (allRoles.data && allRoles.data.result) setRoles(allRoles.data?.result);
    }, [
        allRoles.data
    ]);
    const handleNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!value || value.length < 2) setFormErrors({
            ...formErrors,
            location: $3548dfc3d30117ef$export$1067ba46601ca091.location
        });
        else setFormErrors({
            ...formErrors,
            location: null
        });
        setLocation(value);
    };
    const handleFileUpload = (event)=>{
        if (event && event.target && event.target.files) {
            const { value: value } = event.currentTarget;
            if (!value) setFormErrors({
                ...formErrors,
                fileName: $3548dfc3d30117ef$export$1067ba46601ca091.fileName
            });
            else setFormErrors({
                ...formErrors,
                fileName: null
            });
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e)=>{
                    if (e && e.target && e.target.result) {
                        const data = new Uint8Array(e.target.result);
                        const workbook = $TDoiN.read(data, {
                            type: "array"
                        });
                        const sheetName = workbook.SheetNames[0];
                        const sheet = workbook.Sheets[sheetName];
                        const rows = $TDoiN.utils.sheet_to_json(sheet, {
                            header: 1,
                            blankrows: false
                        });
                        setFileName(file.name);
                        if (rows.length > 1) {
                            const headers = fileHeaders.split(",").map((column)=>column.trim());
                            const data = rows.slice(1).map((row)=>{
                                const rowArr = row;
                                return headers.reduce((obj, key, i)=>{
                                    if (key === "role") {
                                        const roleName = rowArr[i]?.toString().trim().toLowerCase();
                                        const matchedRole = roles.find((r)=>r.name_short && r.name_short.trim().toLowerCase() === roleName?.toLowerCase());
                                        if (!matchedRole && roleName) dispatch({
                                            type: (0, $ayVxz.Actions).ShowMessage,
                                            payload: {
                                                severity: "warning",
                                                text: `Role "${roleName}" not found. This contact will not have a role assigned.`
                                            }
                                        });
                                        return {
                                            ...obj,
                                            role_id: matchedRole ? Number(matchedRole.id) : null
                                        };
                                    }
                                    return {
                                        ...obj,
                                        [key]: rowArr[i]
                                    };
                                }, {});
                            });
                            const raw = data;
                            setFileContacts(raw);
                        } else dispatch({
                            type: (0, $ayVxz.Actions).ShowMessage,
                            payload: {
                                severity: "info",
                                text: "No contacts to upload"
                            }
                        });
                    }
                };
                reader.readAsArrayBuffer(file);
            }
        }
        event.target.value = "";
        setFileName("");
    };
    const importContacts = ()=>{
        const errors = {
            location: null,
            fileName: null
        };
        let hasErrors = false;
        if (!location || location.length < 2) {
            hasErrors = true;
            errors.location = $3548dfc3d30117ef$export$1067ba46601ca091.location;
        }
        if (!fileName) {
            hasErrors = true;
            errors.fileName = $3548dfc3d30117ef$export$1067ba46601ca091.fileName;
        }
        if (hasErrors) setFormErrors(errors);
        else uploadContacts({
            variables: {
                location: location,
                input: fileContacts
            },
            update (_, { data: data }) {
                if (data?.result) {
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `Successfully imported file`
                        }
                    });
                    updateEvents(data?.result.event);
                    updateLocations(data?.result.location);
                    handleClose();
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5PJ2i.default), {
        id: "event-upload-form-dialog",
        width: 380,
        title: "Import event file",
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                display: "flex",
                flexDirection: "column",
                m: "30px",
                gap: "10px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                    id: "new-location-name",
                    label: "Location",
                    value: location,
                    onChange: handleNameChange,
                    errorMsg: formErrors.location,
                    additionalStyle: {
                        marginBottom: "5%"
                    }
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                    id: "event-upload-file",
                    label: "",
                    value: fileName,
                    onChange: handleFileUpload,
                    errorMsg: formErrors.fileName,
                    disabled: true,
                    endAdornment: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            position: "relative",
                            bottom: "3px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                id: "event-file",
                                type: "file",
                                onChange: handleFileUpload,
                                style: {
                                    display: "none"
                                },
                                multiple: true
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                                htmlFor: "event-file",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b85VG.default), {
                                    style: {
                                        cursor: "pointer",
                                        paddingRight: "5%",
                                        paddingTop: "5px",
                                        color: (0, $6L9uu.Colors).main
                                    }
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize",
                    sx: {
                        gridColumn: "span 3",
                        marginBottom: "15px",
                        mt: "20px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                            id: "cancel-event-upload-button",
                            onClick: handleClose,
                            text: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                            id: "add-new-event-button",
                            onClick: ()=>importContacts(),
                            text: "Import"
                        })
                    ]
                })
            ]
        })
    });
}

});

parcelRegister("9hpRw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $166e7712700e8266$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");
var $bIyvl = parcelRequire("bIyvl");
var $g7vB6 = parcelRequire("g7vB6");
var $1sQVT = parcelRequire("1sQVT");
var $dNZ9A = parcelRequire("dNZ9A");

var $5PJ2i = parcelRequire("5PJ2i");

var $bh6RR = parcelRequire("bh6RR");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $hjfla = parcelRequire("hjfla");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");
const $166e7712700e8266$var$CventNameSelectionForm = ({ handleClose: handleClose, cventContact: cventContact })=>{
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [updateLinkedContact, updateLinkedContactResult] = (0, $hjfla.useLinkContactMutation)();
    const [matchingContacts, setMatchingContacts] = (0, $bh6RR.useState)([]);
    const [selectedMatchingContact, setSelectedMatchingContact] = (0, $bh6RR.useState)(null);
    const dbMatchingContactsByEmail = (0, $hjfla.useGetMatchedDbContactsByEmailQuery)({
        variables: {
            id: cventContact.id,
            input: {
                email: cventContact.email
            }
        }
    });
    const showMatchingContacts = matchingContacts.length > 0 || dbMatchingContactsByEmail.loading;
    (0, $bh6RR.useEffect)(()=>{
        if (dbMatchingContactsByEmail.data && dbMatchingContactsByEmail.data?.result) {
            const data = dbMatchingContactsByEmail.data.result;
            setMatchingContacts(data);
            setSelectedMatchingContact(data[0]);
        }
    }, [
        dbMatchingContactsByEmail
    ]);
    const handleMathincgContactChange = (contactName)=>{
        if (contactName) {
            const matchingContact = matchingContacts.find((c)=>c.fullName === contactName);
            if (matchingContact) setSelectedMatchingContact(matchingContact);
        }
    };
    const updateContact = (rowData, is_linked)=>{
        const message = is_linked ? `${rowData.fullName} is linked` : `${rowData.fullName} is unlinked`;
        dispatch({
            type: (0, $ayVxz.Actions).ShowMessage,
            payload: {
                severity: "success",
                text: message
            }
        });
        handleClose();
    };
    const handleLinkContact = (rowData)=>{
        const is_linked = !rowData.is_linked;
        if (is_linked) updateLinkedContact({
            variables: {
                id: rowData.id,
                input: {
                    email: rowData.email,
                    id: Number(selectedMatchingContact.id)
                }
            },
            update () {
                updateContact(rowData, is_linked);
            }
        }).catch((e)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            }));
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5PJ2i.default), {
        id: "link-contact-mail-select",
        width: 500,
        title: "Link Cvent Contact To DB Contact",
        onClose: handleClose,
        children: showMatchingContacts ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                margin: "30px",
                display: "flex",
                flexFlow: "column",
                gap: "35px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dNZ9A.default), {
                    defaultValue: matchingContacts[0]?.fullName,
                    onChange: (event)=>handleMathincgContactChange(event.currentTarget.value),
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $g7vB6.default), {
                            sx: {
                                color: (t)=>t.palette.primary.main,
                                marginTop: "13px",
                                marginRight: "40px",
                                marginBottom: "25px"
                            },
                            component: "legend",
                            children: "LINK CVENT CONTACT TO DB CONTACT"
                        }),
                        matchingContacts.map((contact, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $bIyvl.default), {
                                value: contact.fullName,
                                control: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1sQVT.default), {
                                    color: "primary",
                                    disabled: updateLinkedContactResult.loading
                                }),
                                label: contact.fullName
                            }, index))
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize",
                    sx: {
                        mt: "25px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                            id: "cancel-link-contact-button",
                            disabled: updateLinkedContactResult.loading,
                            onClick: handleClose,
                            text: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                            id: "save-link-contact-button",
                            disabled: updateLinkedContactResult.loading || dbMatchingContactsByEmail.loading,
                            onClick: ()=>handleLinkContact(cventContact),
                            text: "Link"
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
            sx: {
                margin: "30px",
                display: "flex",
                flexFlow: "column",
                gap: "35px",
                color: (t)=>t.palette.error.main,
                textAlign: "center",
                fontWeight: "bolder"
            },
            children: "THERE ARE NO MATCHING CONTACTS IN DATABASE!"
        })
    });
};
var $166e7712700e8266$export$2e2bcd8739ae039 = $166e7712700e8266$var$CventNameSelectionForm;

});


parcelRegister("jqVnU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e25cf56cd3a1e9c6$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $e25cf56cd3a1e9c6$export$2e2bcd8739ae039 = (0, $7B0TL.default)([
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M17 11c.34 0 .67.04 1 .09V6.27L10.5 3 3 6.27v4.91c0 4.54 3.2 8.79 7.5 9.82.55-.13 1.08-.32 1.6-.55-.69-.98-1.1-2.17-1.1-3.45 0-3.31 2.69-6 6-6"
    }, "0"),
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M17 13c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 1.38c.62 0 1.12.51 1.12 1.12s-.51 1.12-1.12 1.12-1.12-.51-1.12-1.12.5-1.12 1.12-1.12m0 5.37c-.93 0-1.74-.46-2.24-1.17.05-.72 1.51-1.08 2.24-1.08s2.19.36 2.24 1.08c-.5.71-1.31 1.17-2.24 1.17"
    }, "1")
], "AdminPanelSettings");

});

parcelRegister("hXcYG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d122037250b20fe2$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $d122037250b20fe2$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6m6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26"
}), "Autorenew");

});

parcelRegister("bc6Ci", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8265f2a669dc63a2$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $8265f2a669dc63a2$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "m13.7826 15.1719 2.1213-2.1213 5.9963 5.9962-2.1213 2.1213zM17.5 10c1.93 0 3.5-1.57 3.5-3.5 0-.58-.16-1.12-.41-1.6l-2.7 2.7-1.49-1.49 2.7-2.7c-.48-.25-1.02-.41-1.6-.41C15.57 3 14 4.57 14 6.5c0 .41.08.8.21 1.16l-1.85 1.85-1.78-1.78.71-.71-1.41-1.41L12 3.49c-1.17-1.17-3.07-1.17-4.24 0L4.22 7.03l1.41 1.41H2.81l-.71.71 3.54 3.54.71-.71V9.15l1.41 1.41.71-.71 1.78 1.78-7.41 7.41 2.12 2.12L16.34 9.79c.36.13.75.21 1.16.21"
}), "Construction");

});

parcelRegister("aeLGi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $774032b1c88372b3$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $774032b1c88372b3$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M3 13h8V3H3zm0 8h8v-6H3zm10 0h8V11h-8zm0-18v6h8V3z"
}), "Dashboard");

});

parcelRegister("4Uy8o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3936dec72622ca88$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $3936dec72622ca88$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M9 11H7v2h2zm4 0h-2v2h2zm4 0h-2v2h2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 16H5V9h14z"
}), "DateRange");

});

parcelRegister("bOZ0B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89b3b044e1873834$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $89b3b044e1873834$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm2 16H8v-2h8zm0-4H8v-2h8zm-3-5V3.5L18.5 9z"
}), "Description");

});

parcelRegister("2xkbE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d8e52884b55f174$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $1d8e52884b55f174$export$2e2bcd8739ae039 = (0, $7B0TL.default)([
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M3 2h8v2H3zm3 9h2V7h3V5H3v2h3zm6.4036 9.1819 7.7782-7.7782 1.4142 1.4142-7.7782 7.7782z"
    }, "0"),
    /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
        cx: "14.5",
        cy: "14.5",
        r: "1.5"
    }, "1"),
    /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
        cx: "19.5",
        cy: "19.5",
        r: "1.5"
    }, "2"),
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M15.5 11c1.38 0 2.5-1.12 2.5-2.5V4h3V2h-4v4.51c-.42-.32-.93-.51-1.5-.51C14.12 6 13 7.12 13 8.5s1.12 2.5 2.5 2.5m-5.76 4.96-1.41 1.41-.71-.71.35-.35c.98-.98.98-2.56 0-3.54-.49-.49-1.13-.73-1.77-.73-.64 0-1.28.24-1.77.73-.98.98-.98 2.56 0 3.54l.35.35-1.06 1.06c-.98.98-.98 2.56 0 3.54.5.5 1.14.74 1.78.74s1.28-.24 1.77-.73l1.06-1.06 1.41 1.41 1.41-1.41-1.41-1.41 1.41-1.41zM5.85 14.2c.12-.12.26-.15.35-.15s.23.03.35.15c.19.2.19.51 0 .71l-.35.35-.35-.36c-.19-.19-.19-.51 0-.7m0 5.65c-.12.12-.26.15-.35.15s-.23-.03-.35-.15c-.19-.19-.19-.51 0-.71l1.06-1.06.71.71z"
    }, "3")
], "EmojiSymbols");

});

parcelRegister("gZWM8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5ffef6af0f5e66e$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $c5ffef6af0f5e66e$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5m0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5m0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5M7 19h14v-2H7zm0-6h14v-2H7zm0-8v2h14V5z"
}), "FormatListBulleted");

});

parcelRegister("ihmL0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4eb779da58d5a11$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $d4eb779da58d5a11$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M9 17H7v-7h2zm4 0h-2V7h2zm4 0h-2v-4h2z"
}), "InsertChart");

});

parcelRegister("hyMYB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc8b9a5b0fca81b8$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $cc8b9a5b0fca81b8$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3m0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5"
}), "LocalMall");

});

parcelRegister("lM6pF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fda30e2d1752063d$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $fda30e2d1752063d$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 4-8 5-8-5V6l8 5 8-5z"
}), "Mail");

});

parcelRegister("7OO4z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b140b50981ebd36$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $5b140b50981ebd36$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3m-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3m0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5m8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5"
}), "People");

});

parcelRegister("8AYU5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6420edb2ba613eee$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $6420edb2ba613eee$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"
}), "Settings");

});

parcelRegister("jnNNx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1c6cb1ff7c1b2ef$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $e1c6cb1ff7c1b2ef$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "m3.5 18.49 6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"
}), "ShowChart");

});

parcelRegister("bDeQg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $877ed98b018c8b4c$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $877ed98b018c8b4c$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M15 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V9zM8 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m0-4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m0-4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m6 1V4.5l5.5 5.5z"
}), "Summarize");

});

parcelRegister("8EfWV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64be6e6714ff0933$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $64be6e6714ff0933$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-5 14H4v-4h11zm0-5H4V9h11zm5 5h-4V9h4z"
}), "Web");

});

parcelRegister("1RKRu", function(module, exports) {
"use strict";
"use client";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $15bf177900a6a5e2$var$_createSvgIcon = $2ZnTs((parcelRequire("lpAdr")));

var $ih19M = parcelRequire("ih19M");
var $15bf177900a6a5e2$var$_default = module.exports.default = (0, $15bf177900a6a5e2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M17 12h-5v5h5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1zm3 18H5V8h14z"
}), "Event");

});

parcelRegister("9pjPY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c946adbb2c1a757$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $8AYU5 = parcelRequire("8AYU5");

var $ahwrv = parcelRequire("ahwrv");

var $loNey = parcelRequire("loNey");
const $4c946adbb2c1a757$var$FtseConfigWrapper = ()=>{
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        style: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ahwrv.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $8AYU5.default), {
                        style: {
                            marginRight: "7px"
                        }
                    }),
                    "FTSE Config"
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $loNey.default), {})
            })
        ]
    });
};
var $4c946adbb2c1a757$export$2e2bcd8739ae039 = $4c946adbb2c1a757$var$FtseConfigWrapper;

});
parcelRegister("loNey", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2239b834a2af5c2$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $chLJv = parcelRequire("chLJv");

var $d7fM7 = parcelRequire("d7fM7");

var $hsjD5 = parcelRequire("hsjD5");

var $8nccm = parcelRequire("8nccm");
const $d2239b834a2af5c2$var$FtseConfigList = ()=>{
    const { data: data, loading: loading } = (0, $hjfla.useGetFtseConfigurationsQuery)();
    const [allData, setAllData] = (0, $bh6RR.useState)([]);
    const [ftseConfiguration, setFtseConfiguration] = (0, $bh6RR.useState)(null);
    const [openFtseConfigForm, setOpenFtseConfigForm] = (0, $bh6RR.useState)(false);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setAllData(data.result);
    }, [
        data
    ]);
    const handleClose = ()=>{
        setOpenFtseConfigForm(false);
    };
    const handleDetails = (rowData)=>{
        setFtseConfiguration(rowData);
        setOpenFtseConfigForm(true);
    };
    const columns = [
        {
            title: "Details",
            width: 42,
            sorting: false
        },
        {
            title: "Property Name",
            field: "property",
            width: 792
        },
        {
            title: "Property Value",
            field: "value",
            width: 792
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "overviewPage",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "print\\:w-full"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                columns: columns,
                data: (0, $hsjD5.FormatTableData)(allData),
                loading: loading,
                handleDetails: handleDetails,
                handleRemove: ()=>true,
                pageSize: 15,
                hideSearch: true
            }),
            openFtseConfigForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $8nccm.default), {
                handleClose: handleClose,
                ftseConfigurationInput: ftseConfiguration
            })
        ]
    });
};
var $d2239b834a2af5c2$export$2e2bcd8739ae039 = $d2239b834a2af5c2$var$FtseConfigList;

});
parcelRegister("8nccm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3de6f9509f08de98$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");

var $ehzwo = parcelRequire("ehzwo");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $bSbwb = parcelRequire("bSbwb");

var $6L9uu = parcelRequire("6L9uu");
const $3de6f9509f08de98$var$defaultErrorsObj = {
    value: null
};
const $3de6f9509f08de98$var$errorTexts = {
    value: "Value is required"
};
const $3de6f9509f08de98$var$FtseConfigForm = ({ handleClose: handleClose, ftseConfigurationInput: ftseConfigurationInput })=>{
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($3de6f9509f08de98$var$defaultErrorsObj);
    const [editable, setEditable] = (0, $bh6RR.useState)(false);
    const [property] = (0, $bh6RR.useState)(ftseConfigurationInput.property);
    const [value, setValue] = (0, $bh6RR.useState)(ftseConfigurationInput.value);
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [updateFtseConfiguration, updateFtseConfigurationResult] = (0, $hjfla.useUpdateFtseConfigurationMutation)();
    const handleCancel = ()=>{
        if (editable) {
            setValue(ftseConfigurationInput.value);
            setFormErrors($3de6f9509f08de98$var$defaultErrorsObj);
            setEditable(false);
        } else handleClose();
    };
    const handleSubmit = ()=>{
        let hasErrors = false;
        const errors = {
            value: null
        };
        if (!value || value.length < 1) {
            hasErrors = true;
            errors.value = $3de6f9509f08de98$var$errorTexts.value;
        }
        if (hasErrors) setFormErrors(errors);
        else handleSave(ftseConfigurationInput);
    };
    const handleSave = (ftseConfigurationInput)=>{
        updateFtseConfiguration({
            variables: {
                id: ftseConfigurationInput.id,
                input: {
                    value: value
                }
            },
            update () {
                handleClose();
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Ftse configuration updated"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
    };
    const handleFtseConfigurationValueChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value && value.length > 0) setFormErrors({
            ...formErrors,
            value: null
        });
        else setFormErrors({
            ...formErrors,
            value: $3de6f9509f08de98$var$errorTexts.value
        });
        setValue(value);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "ftseConfig-form-dialog-title",
        width: 689,
        title: "Details",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    textAlign: "right",
                    width: "100%",
                    marginTop: "10px",
                    marginRight: "15px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "ftseConfig-form-edit-button",
                    onClick: ()=>setEditable(true),
                    disabled: editable,
                    editButtonColor: editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                    gap: "20px 18px",
                    padding: "60px 30px",
                    height: "370px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "ftseConfig-form-property",
                        label: "Property name",
                        value: property || "",
                        disabled: true,
                        additionalStyle: {
                            gridColumn: "span 4"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "ftseConfig-form-value",
                        label: "Property value",
                        value: value || "",
                        disabled: !editable || updateFtseConfigurationResult.loading,
                        errorMsg: formErrors.value,
                        additionalStyle: {
                            gridColumn: "span 4"
                        },
                        onChange: handleFtseConfigurationValueChange
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        className: "centralize",
                        sx: {
                            gridColumn: "span 4",
                            marginTop: "50px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                                id: "cancel-ftse-configuration-button",
                                disabled: updateFtseConfigurationResult.loading,
                                onClick: handleCancel,
                                text: ftseConfigurationInput === null || editable ? "Cancel" : "Close"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                                id: "save-ftse-configuration-button",
                                disabled: !editable || updateFtseConfigurationResult.loading,
                                onClick: handleSubmit,
                                text: "Save"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $3de6f9509f08de98$export$2e2bcd8739ae039 = $3de6f9509f08de98$var$FtseConfigForm;

});



parcelRegister("5lpiZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a1b2815e1884430$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hjfla = parcelRequire("hjfla");

var $8d818 = parcelRequire("8d818");

var $d7fM7 = parcelRequire("d7fM7");

var $jgVbZ = parcelRequire("jgVbZ");
const $0a1b2815e1884430$var$SiteSectionList = ()=>{
    const { data: data, loading: loading } = (0, $hjfla.useGetSiteSectionsQuery)();
    const [allData, setAllData] = (0, $bh6RR.useState)([]);
    const [openForm, setOpenForm] = (0, $bh6RR.useState)(false);
    const [siteSection, setSiteSection] = (0, $bh6RR.useState)(null);
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [deleteSiteSection] = (0, $hjfla.useDeleteSiteSectionMutation)();
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setAllData(data.result);
    }, [
        data
    ]);
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${rowData.name} site section?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleDelete = (rowData)=>{
        if (!rowData.id) return;
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteSiteSection({
            variables: {
                id: rowData.id
            },
            update (cache) {
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Site Section ${rowData.name} deleted`,
                        severity: "success"
                    }
                });
                const sectionsQuery = cache.readQuery({
                    query: (0, $hjfla.GetSiteSectionsDocument)
                });
                if (sectionsQuery.result) {
                    const cachedSiteSection = sectionsQuery.result.findIndex((s)=>s?.id === rowData.id);
                    if (cachedSiteSection > -1) {
                        const data = sectionsQuery.result.filter(function(el) {
                            return el?.id !== rowData.id;
                        });
                        cache.writeQuery({
                            query: (0, $hjfla.GetSiteSectionsDocument),
                            data: {
                                result: data
                            }
                        });
                    }
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: e.message,
                    severity: "error",
                    autoHide: 6000
                }
            });
        });
    };
    const columns = [
        {
            title: "Details",
            width: 63,
            sorting: false
        },
        {
            title: "Id",
            field: "id",
            type: "numeric",
            width: 130
        },
        {
            title: "Section Name",
            field: "name",
            width: 1455
        },
        {
            title: "Remove",
            width: 73,
            sorting: false
        }
    ];
    const handleDetails = (rowData)=>{
        setSiteSection(rowData);
        setOpenForm(true);
    };
    const handleClose = ()=>{
        setSiteSection(null);
        setOpenForm(false);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        className: "overviewPage",
        sx: {
            height: "100%"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            className: "print\\:w-full",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                    columns: columns,
                    data: allData,
                    loading: loading,
                    handleDetails: handleDetails,
                    handleRemove: handleRemove,
                    pageSize: 15,
                    createButtonProps: {
                        id: "create-site-section-button",
                        onClick: ()=>setOpenForm(true),
                        text: "Create Section",
                        disabled: false
                    }
                }),
                openForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $jgVbZ.default), {
                    siteSectionInput: siteSection,
                    handleClose: handleClose
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                    loading: loading
                })
            ]
        })
    });
};
var $0a1b2815e1884430$export$2e2bcd8739ae039 = $0a1b2815e1884430$var$SiteSectionList;

});
parcelRegister("jgVbZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9f2350afef9529c$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $gFVvY = parcelRequire("gFVvY");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");

var $ehzwo = parcelRequire("ehzwo");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $bSbwb = parcelRequire("bSbwb");

var $dqRXb = parcelRequire("dqRXb");

var $6L9uu = parcelRequire("6L9uu");
const $d9f2350afef9529c$var$defaultErrorsObj = {
    name: null
};
const $d9f2350afef9529c$var$errorTexts = {
    name: "Section name too short!",
    nameExists: "Section name already exists"
};
const $d9f2350afef9529c$var$SiteSectionForm = ({ handleClose: handleClose, siteSectionInput: siteSectionInput })=>{
    const [editable, setEditable] = (0, $bh6RR.useState)(siteSectionInput === null);
    const [name, setName] = (0, $bh6RR.useState)(siteSectionInput?.name || "");
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($d9f2350afef9529c$var$defaultErrorsObj);
    const [createSection, createResult] = (0, $hjfla.useCreateSiteSectionMutation)();
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [updateSiteSection, updateSiteSectionResult] = (0, $hjfla.useUpdateSiteSectionMutation)();
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Index);
    const handleNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        setFormErrors({
            name: value && value.length > 0 ? null : $d9f2350afef9529c$var$errorTexts.name
        });
        setName(value);
    };
    const handleCancel = ()=>{
        if (editable && siteSectionInput !== null) {
            setName(siteSectionInput?.name);
            setFormErrors($d9f2350afef9529c$var$defaultErrorsObj);
            setEditable(false);
        } else handleClose(false);
    };
    const handleSubmit = ()=>{
        const trimmedName = name ? name.trim() : "";
        const errors = {
            name: null
        };
        let hasErrors = false;
        if (trimmedName.length === 0) {
            hasErrors = true;
            errors.name = $d9f2350afef9529c$var$errorTexts.name;
        } else if ((0, $gFVvY.sameSiteSectionNameExists)(trimmedName, siteSectionInput?.id)) {
            hasErrors = true;
            errors.name = $d9f2350afef9529c$var$errorTexts.nameExists;
        }
        if (hasErrors) setFormErrors(errors);
        else handleSave(siteSectionInput === null ? "create" : "update");
    };
    const handleSave = (type)=>{
        if (type === "create") createSection({
            variables: {
                name: name.trim()
            },
            update (_, { data: data }) {
                handleClose(true, true, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: `Site section ${name} created`
                    }
                });
            }
        }).catch((error)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            });
        });
        else updateSiteSection({
            variables: {
                id: siteSectionInput?.id,
                name: name.trim()
            },
            update (_, { data: data }) {
                handleClose(true, false, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Site section updated"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "new-siteSection",
        width: 500,
        title: siteSectionInput ? `${siteSectionInput.name} Details` : "Create Site Section",
        onClose: handleClose,
        children: [
            siteSectionInput && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    textAlign: "right",
                    width: "100%",
                    marginTop: "10px",
                    marginRight: "15px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "site-section-form-edit-button",
                    onClick: ()=>setEditable(true),
                    disabled: editable || !canEdit,
                    editButtonColor: !canEdit || editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
                    padding: "32px 30px",
                    height: siteSectionInput ? "200px" : "240px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "siteSection-form-name",
                        label: "Section Name",
                        value: name || "",
                        onChange: handleNameChange,
                        errorMsg: formErrors.name,
                        disabled: !editable || createResult.loading || updateSiteSectionResult.loading,
                        additionalStyle: {
                            gridColumn: "span 1"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        className: "centralize",
                        sx: {
                            gridColumn: "span 1"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                                id: "cancel-site-section-button",
                                disabled: createResult.loading || updateSiteSectionResult.loading,
                                onClick: handleCancel,
                                text: siteSectionInput === null || editable ? "Cancel" : "Close"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                                id: "save-site-section-button",
                                disabled: !editable || createResult.loading || updateSiteSectionResult.loading,
                                onClick: handleSubmit,
                                text: siteSectionInput === null ? "Create" : "Save"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $d9f2350afef9529c$export$2e2bcd8739ae039 = $d9f2350afef9529c$var$SiteSectionForm;

});


parcelRegister("1TRYK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea82c630a2bcd346$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hjfla = parcelRequire("hjfla");

var $8d818 = parcelRequire("8d818");

var $d7fM7 = parcelRequire("d7fM7");

var $kmn41 = parcelRequire("kmn41");
const $ea82c630a2bcd346$var$MeetingTypeList = ()=>{
    const { data: data, loading: loading } = (0, $hjfla.useGetMeetingTypesQuery)();
    const [allData, setAllData] = (0, $bh6RR.useState)([]);
    const [openForm, setOpenForm] = (0, $bh6RR.useState)(false);
    const [meetingType, setMeetingType] = (0, $bh6RR.useState)(null);
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [deleteMeetingType] = (0, $hjfla.useDeleteMeetingTypeMutation)();
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setAllData(data.result);
    }, [
        data
    ]);
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${rowData.name} meeting type?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleDelete = (rowData)=>{
        if (!rowData.id) return;
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteMeetingType({
            variables: {
                id: rowData.id
            },
            update (cache) {
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Meeting Type ${rowData.name} deleted`,
                        severity: "success"
                    }
                });
                setAllData((prevData)=>prevData.filter((m)=>m?.id !== rowData.id));
                const meetingTypesQuery = cache.readQuery({
                    query: (0, $hjfla.GetMeetingTypesDocument)
                });
                if (meetingTypesQuery.result) {
                    const cachedMeetingType = meetingTypesQuery.result.findIndex((m)=>m?.id === rowData.id);
                    if (cachedMeetingType > -1) {
                        const updatedData = meetingTypesQuery.result.filter(function(el) {
                            return el?.id !== rowData.id;
                        });
                        cache.writeQuery({
                            query: (0, $hjfla.GetMeetingTypesDocument),
                            data: {
                                result: updatedData
                            }
                        });
                    }
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: e.message,
                    severity: "error",
                    autoHide: 6000
                }
            });
        });
    };
    const columns = [
        {
            title: "Details",
            width: 63,
            sorting: false
        },
        {
            title: "Id",
            field: "id",
            type: "numeric",
            width: 130
        },
        {
            title: "Meeting Type Name",
            field: "name",
            width: 1455
        },
        {
            title: "Remove",
            width: 73,
            sorting: false
        }
    ];
    const handleDetails = (rowData)=>{
        setMeetingType(rowData);
        setOpenForm(true);
    };
    const handleClose = (saved, isNew, meetingTypeInput)=>{
        if (saved && meetingTypeInput) {
            if (isNew) setAllData([
                meetingTypeInput,
                ...allData
            ]);
            else setAllData(allData.map((m)=>m?.id === meetingTypeInput.id ? meetingTypeInput : m));
        }
        setMeetingType(null);
        setOpenForm(false);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        className: "overviewPage",
        sx: {
            height: "100%"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            className: "print\\:w-full",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                    columns: columns,
                    data: allData,
                    loading: loading,
                    handleDetails: handleDetails,
                    handleRemove: handleRemove,
                    pageSize: 15,
                    createButtonProps: {
                        id: "create-meeting-type-button",
                        onClick: ()=>setOpenForm(true),
                        text: "Create Meeting Type",
                        disabled: false
                    }
                }),
                openForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $kmn41.default), {
                    meetingTypeInput: meetingType,
                    handleClose: handleClose
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                    loading: loading
                })
            ]
        })
    });
};
var $ea82c630a2bcd346$export$2e2bcd8739ae039 = $ea82c630a2bcd346$var$MeetingTypeList;

});
parcelRegister("kmn41", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f41e5d1a43a8c1c2$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");

var $ehzwo = parcelRequire("ehzwo");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $bSbwb = parcelRequire("bSbwb");

var $dqRXb = parcelRequire("dqRXb");

var $6L9uu = parcelRequire("6L9uu");
const $f41e5d1a43a8c1c2$var$defaultErrorsObj = {
    name: null
};
const $f41e5d1a43a8c1c2$var$errorTexts = {
    name: "Name is required!",
    nameExists: "Meeting type name already exists"
};
const $f41e5d1a43a8c1c2$var$MeetingTypeForm = ({ handleClose: handleClose, meetingTypeInput: meetingTypeInput })=>{
    const [editable, setEditable] = (0, $bh6RR.useState)(meetingTypeInput === null);
    const [name, setName] = (0, $bh6RR.useState)(meetingTypeInput?.name || "");
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($f41e5d1a43a8c1c2$var$defaultErrorsObj);
    const [createMeetingType, createResult] = (0, $hjfla.useCreateMeetingTypeMutation)();
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [updateMeetingType, updateMeetingTypeResult] = (0, $hjfla.useUpdateMeetingTypeMutation)();
    const { data: meetingTypesData } = (0, $hjfla.useGetMeetingTypesQuery)();
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Index);
    const handleNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value && value.length > 0) setFormErrors({
            name: null
        });
        else setFormErrors({
            name: $f41e5d1a43a8c1c2$var$errorTexts.name
        });
        setName(value);
    };
    const handleCancel = ()=>{
        if (editable && meetingTypeInput !== null) {
            setName(meetingTypeInput?.name || "");
            setFormErrors($f41e5d1a43a8c1c2$var$defaultErrorsObj);
            setEditable(false);
        } else handleClose(false);
    };
    const checkNameExists = (nameToCheck, excludeId)=>{
        if (!meetingTypesData?.result) return false;
        return meetingTypesData.result.some((mt)=>mt && mt.name.toLowerCase() === nameToCheck.toLowerCase().trim() && mt.id !== excludeId);
    };
    const handleSubmit = ()=>{
        const trimmedName = name ? name.trim() : "";
        const errors = {
            name: null
        };
        let hasErrors = false;
        if (trimmedName.length === 0) {
            hasErrors = true;
            errors.name = $f41e5d1a43a8c1c2$var$errorTexts.name;
        } else if (checkNameExists(trimmedName, meetingTypeInput?.id)) {
            hasErrors = true;
            errors.name = $f41e5d1a43a8c1c2$var$errorTexts.nameExists;
        }
        if (hasErrors) setFormErrors(errors);
        else handleSave(meetingTypeInput === null ? "create" : "update");
    };
    const handleSave = (type)=>{
        if (type === "create") createMeetingType({
            variables: {
                name: name.trim()
            },
            update (cache, { data: data }) {
                const newMeetingType = data?.result;
                // Update getMeetingTypes cache (used by MeetingTypeList)
                try {
                    const meetingTypesQuery = cache.readQuery({
                        query: (0, $hjfla.GetMeetingTypesDocument)
                    });
                    if (meetingTypesQuery && meetingTypesQuery.result) cache.writeQuery({
                        query: (0, $hjfla.GetMeetingTypesDocument),
                        data: {
                            result: [
                                newMeetingType,
                                ...meetingTypesQuery.result
                            ]
                        }
                    });
                } catch (error) {}
                // Update meetingsMeetingType cache (used by NewMeeting component)
                try {
                    const meetingsMeetingTypeQuery = cache.readQuery({
                        query: (0, $hjfla.MeetingsMeetingTypeDocument)
                    });
                    if (meetingsMeetingTypeQuery && meetingsMeetingTypeQuery.result) cache.writeQuery({
                        query: (0, $hjfla.MeetingsMeetingTypeDocument),
                        data: {
                            result: [
                                newMeetingType,
                                ...meetingsMeetingTypeQuery.result
                            ]
                        }
                    });
                } catch (error) {}
                handleClose(true, true, newMeetingType);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: `Meeting type ${name} created`
                    }
                });
            }
        }).catch((error)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            });
        });
        else updateMeetingType({
            variables: {
                id: meetingTypeInput?.id,
                name: name.trim()
            },
            update (cache, { data: data }) {
                const updatedMeetingType = data?.result;
                // Update getMeetingTypes cache (used by MeetingTypeList)
                try {
                    const meetingTypesQuery = cache.readQuery({
                        query: (0, $hjfla.GetMeetingTypesDocument)
                    });
                    if (meetingTypesQuery && meetingTypesQuery.result) {
                        const updatedData = meetingTypesQuery.result.map((m)=>m?.id === updatedMeetingType.id ? updatedMeetingType : m);
                        cache.writeQuery({
                            query: (0, $hjfla.GetMeetingTypesDocument),
                            data: {
                                result: updatedData
                            }
                        });
                    }
                } catch (error) {}
                // Update meetingsMeetingType cache (used by NewMeeting component)
                try {
                    const meetingsMeetingTypeQuery = cache.readQuery({
                        query: (0, $hjfla.MeetingsMeetingTypeDocument)
                    });
                    if (meetingsMeetingTypeQuery && meetingsMeetingTypeQuery.result) {
                        const updatedData = meetingsMeetingTypeQuery.result.map((m)=>m?.id === updatedMeetingType.id ? updatedMeetingType : m);
                        cache.writeQuery({
                            query: (0, $hjfla.MeetingsMeetingTypeDocument),
                            data: {
                                result: updatedData
                            }
                        });
                    }
                } catch (error) {}
                handleClose(true, false, updatedMeetingType);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Meeting type updated"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "new-meeting-type",
        width: 500,
        title: meetingTypeInput ? `${meetingTypeInput.name} Details` : "Create Meeting Type",
        onClose: ()=>handleClose(false),
        children: [
            meetingTypeInput && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    textAlign: "right",
                    width: "100%",
                    marginTop: "10px",
                    marginRight: "15px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "meeting-type-form-edit-button",
                    onClick: ()=>setEditable(true),
                    disabled: editable || !canEdit,
                    editButtonColor: !canEdit || editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
                    padding: "32px 30px",
                    height: meetingTypeInput ? "200px" : "240px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "meeting-type-form-name",
                        label: "Name",
                        value: name || "",
                        onChange: handleNameChange,
                        errorMsg: formErrors.name,
                        disabled: !editable || createResult.loading || updateMeetingTypeResult.loading,
                        additionalStyle: {
                            gridColumn: "span 1"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        className: "centralize",
                        sx: {
                            gridColumn: "span 1"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                                id: "cancel-meeting-type-button",
                                disabled: createResult.loading || updateMeetingTypeResult.loading,
                                onClick: handleCancel,
                                text: meetingTypeInput === null || editable ? "Cancel" : "Close"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                                id: "save-meeting-type-button",
                                disabled: !editable || createResult.loading || updateMeetingTypeResult.loading,
                                onClick: handleSubmit,
                                text: meetingTypeInput === null ? "Create" : "Save"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $f41e5d1a43a8c1c2$export$2e2bcd8739ae039 = $f41e5d1a43a8c1c2$var$MeetingTypeForm;

});


parcelRegister("9Vnzc", function(module, exports) {

$parcel$export(module.exports, "colorings", function () { return $d5e2b8fbf0ba7f82$export$9f13fd2a631ebf9; });
$parcel$export(module.exports, "coloring", function () { return $d5e2b8fbf0ba7f82$export$e0ffe7b3fb404148; });
$parcel$export(module.exports, "makeFirstLetterCapital", function () { return $d5e2b8fbf0ba7f82$export$a2927ee3c9150604; });
$parcel$export(module.exports, "default", function () { return $d5e2b8fbf0ba7f82$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $ePpmI = parcelRequire("ePpmI");
var $aitry = parcelRequire("aitry");

var $hjfla = parcelRequire("hjfla");

var $8Oiq1 = parcelRequire("8Oiq1");

var $6L9uu = parcelRequire("6L9uu");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $ihjAy = parcelRequire("ihjAy");
var $iR1LU = parcelRequire("iR1LU");

var $d7fM7 = parcelRequire("d7fM7");

var $8d818 = parcelRequire("8d818");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $ahwrv = parcelRequire("ahwrv");

var $6P9Zs = parcelRequire("6P9Zs");
const $d5e2b8fbf0ba7f82$export$9f13fd2a631ebf9 = (category)=>{
    switch(category){
        case (0, $8Oiq1.Categories).Comminications:
            return (0, $6L9uu.Colors).warning;
        case (0, $8Oiq1.Categories).Research:
            return (0, $6L9uu.Colors).secondary;
        default:
            return "";
    }
};
const $d5e2b8fbf0ba7f82$export$e0ffe7b3fb404148 = (role)=>{
    switch(role){
        case (0, $8Oiq1.Roles).Admin:
            return (0, $6L9uu.Colors).warning;
        case (0, $8Oiq1.Roles).InvoiceEditor:
            return (0, $6L9uu.Colors).main;
        case (0, $8Oiq1.Roles).Operator:
            return (0, $6L9uu.Colors).third;
        case (0, $8Oiq1.Roles).EsgOperator:
            return (0, $6L9uu.Colors).pink;
        case (0, $8Oiq1.Roles).IndexOperator:
            return (0, $6L9uu.Colors).dark_green;
        case (0, $8Oiq1.Roles).MarketingOperator:
            return (0, $6L9uu.Colors).purple;
        default:
            return "";
    }
};
const $d5e2b8fbf0ba7f82$export$a2927ee3c9150604 = (takesRole)=>{
    if (takesRole) {
        const capitalized = takesRole.charAt(0).toUpperCase() + takesRole.slice(1);
        return capitalized.replace("_", " ");
    }
    return "";
};
const $d5e2b8fbf0ba7f82$var$initialFilter = {
    operator: false,
    admin: false,
    esgOperator: false,
    invoiceEditor: false,
    indexOperator: false,
    marketingOperator: false
};
const $d5e2b8fbf0ba7f82$var$Users = ()=>{
    const navigate = (0, $99w1R.useNavigate)();
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const { data: data, loading: loading } = (0, $hjfla.useGetUsersQuery)();
    const [users, setUsers] = (0, $bh6RR.useState)([]);
    const [operator, setOperator] = (0, $bh6RR.useState)(false);
    const [admin, setAdmin] = (0, $bh6RR.useState)(false);
    const [esgOperator, setEsgOperator] = (0, $bh6RR.useState)(false);
    const [invoiceEditor, setInvoiceEditor] = (0, $bh6RR.useState)(false);
    const [indexOperator, setIndexOperator] = (0, $bh6RR.useState)(false);
    const [marketingOperator, setMarketingOperator] = (0, $bh6RR.useState)(false);
    const [filter, setFilter] = (0, $bh6RR.useState)($d5e2b8fbf0ba7f82$var$initialFilter);
    const [allUsers, setAllUsers] = (0, $bh6RR.useState)([]);
    const [openCreateUserForm, setOpenCreateUserForm] = (0, $bh6RR.useState)(false);
    const [deleteUser] = (0, $hjfla.useDeleteUserMutation)();
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            setUsers(data.result);
            setAllUsers(data.result);
        }
    }, [
        data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        filterUsers(filter);
    }, [
        allUsers
    ]);
    const filterUsers = (filter)=>{
        let filteredUsers = allUsers;
        if (filter.operator) filteredUsers = filteredUsers.filter((user)=>user.roles.includes((0, $8Oiq1.Roles).Operator));
        if (filter.admin) filteredUsers = filteredUsers.filter((user)=>user.roles.includes((0, $8Oiq1.Roles).Admin));
        if (filter.esgOperator) filteredUsers = filteredUsers.filter((user)=>user.roles.includes((0, $8Oiq1.Roles).EsgOperator));
        if (filter.invoiceEditor) filteredUsers = filteredUsers.filter((user)=>user.roles.includes((0, $8Oiq1.Roles).InvoiceEditor));
        if (filter.indexOperator) filteredUsers = filteredUsers.filter((user)=>user.roles.includes((0, $8Oiq1.Roles).IndexOperator));
        if (filter.marketingOperator) filteredUsers = filteredUsers.filter((user)=>user.roles.includes((0, $8Oiq1.Roles).MarketingOperator));
        setFilter(filter);
        setUsers(filteredUsers);
    };
    const handleOperatorPressed = ()=>{
        const newFilter = {
            ...filter,
            operator: !operator
        };
        setOperator(!operator);
        filterUsers(newFilter);
    };
    const handleAdminPressed = ()=>{
        const newFilter = {
            ...filter,
            admin: !admin
        };
        setAdmin(!admin);
        filterUsers(newFilter);
    };
    const handleEsgOperatorPressed = ()=>{
        const newFilter = {
            ...filter,
            esgOperator: !esgOperator
        };
        setEsgOperator(!esgOperator);
        filterUsers(newFilter);
    };
    const handleInvoiceEditorPressed = ()=>{
        const newFilter = {
            ...filter,
            invoiceEditor: !invoiceEditor
        };
        setInvoiceEditor(!invoiceEditor);
        filterUsers(newFilter);
    };
    const handleIndexOperatorPressed = ()=>{
        const newFilter = {
            ...filter,
            indexOperator: !indexOperator
        };
        setIndexOperator(!indexOperator);
        filterUsers(newFilter);
    };
    const handleMarketingOperatorPressed = ()=>{
        const newFilter = {
            ...filter,
            marketingOperator: !marketingOperator
        };
        setMarketingOperator(!marketingOperator);
        filterUsers(newFilter);
    };
    const renderUsername = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
            style: {
                fontSize: 14
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $iR1LU.default), {}),
                " ",
                rowData.username
            ]
        });
    };
    const remove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${rowData.username}?`,
                agreeAction: handleDelete,
                params: [
                    rowData.id,
                    rowData
                ]
            }
        });
    };
    const handleDelete = (params)=>{
        const id = params[0];
        const rowData = params[1];
        if (!id) return;
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteUser({
            variables: {
                id: parseInt(id)
            },
            update (cache) {
                const usersQuery = cache.readQuery({
                    query: (0, $hjfla.GetUsersDocument)
                });
                if (usersQuery.result) {
                    const cacheUserIndex = usersQuery.result.findIndex((u)=>u?.id === id);
                    if (cacheUserIndex > -1) {
                        const data = usersQuery.result.filter(function(el) {
                            return el?.id !== id;
                        });
                        cache.writeQuery({
                            query: (0, $hjfla.GetUsersDocument),
                            data: {
                                result: data
                            }
                        });
                    }
                }
                const rowDataUsername = rowData.username.charAt(0).toUpperCase() + rowData.username.slice(1);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `User ${rowDataUsername} deleted.`,
                        severity: "success"
                    }
                });
            }
        }).catch((error)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            }));
    };
    const renderUserGroups = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
            sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            },
            children: rowData.roles.map((role, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    style: {
                        marginRight: 25
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ihjAy.default), {
                                style: {
                                    color: $d5e2b8fbf0ba7f82$export$e0ffe7b3fb404148(role),
                                    marginRight: 10
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), {
                                style: {
                                    fontSize: 14,
                                    fontFamily: "Overpass",
                                    color: $d5e2b8fbf0ba7f82$export$e0ffe7b3fb404148(role),
                                    marginTop: 5,
                                    marginRight: 25
                                },
                                children: $d5e2b8fbf0ba7f82$export$a2927ee3c9150604(role)
                            }),
                            index + 1 < rowData.roles.length && /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {
                                orientation: "vertical",
                                flexItem: true,
                                sx: {
                                    background: "#B4D5F9"
                                }
                            })
                        ]
                    })
                }, index))
        });
    };
    const columns = [
        {
            title: "Details",
            width: 83,
            sorting: false
        },
        {
            title: "Username",
            field: "username",
            render: renderUsername,
            width: 507
        },
        {
            title: "User Groups",
            field: "roles",
            render: renderUserGroups,
            width: 992
        },
        {
            title: "Remove",
            width: 140,
            sorting: false
        }
    ];
    const handleDetails = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).SetSelectedUser,
            payload: {
                user: rowData
            }
        });
        navigateTo(rowData);
    };
    const navigateTo = (rowData)=>{
        navigate(`/users/${rowData.id}`);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "overviewPage",
        sx: {
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ahwrv.default), {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $iR1LU.default), {
                            sx: {
                                marginRight: "7px"
                            }
                        }),
                        " Users"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                        columns: columns,
                        data: users,
                        loading: loading,
                        handleDetails: handleDetails,
                        handleRemove: remove,
                        pageSize: 15,
                        createButtonProps: {
                            id: "create-user-button",
                            onClick: ()=>setOpenCreateUserForm(true),
                            text: "Create User",
                            disabled: false
                        },
                        additionalFilters: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                            sx: {
                                marginLeft: "40px",
                                marginRight: "226px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                                    id: "operator-filter-button",
                                    "data-testid": "operator-filter-button",
                                    variant: "contained",
                                    sx: operator ? (0, $6L9uu.buttons).selected : (0, $6L9uu.buttons).deSelected,
                                    color: "primary",
                                    name: "operator button",
                                    onClick: handleOperatorPressed,
                                    children: "OPERATOR"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                                    id: "admin-filter-button",
                                    "data-testid": "admin-filter-button",
                                    variant: "contained",
                                    sx: admin ? (0, $6L9uu.buttons).selected : (0, $6L9uu.buttons).deSelected,
                                    color: "primary",
                                    name: "admin button",
                                    onClick: handleAdminPressed,
                                    children: "ADMIN"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                                    id: "esg-operator-filter-button",
                                    "data-testid": "esg-operator-filter-button",
                                    variant: "contained",
                                    sx: esgOperator ? (0, $6L9uu.buttons).selected : (0, $6L9uu.buttons).deSelected,
                                    color: "primary",
                                    name: "esg operator button",
                                    onClick: handleEsgOperatorPressed,
                                    children: "ESG OPERATOR"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                                    id: "invoice-editor-filter-button",
                                    "data-testid": "invoice-editor-filter-button",
                                    variant: "contained",
                                    sx: invoiceEditor ? (0, $6L9uu.buttons).selected : (0, $6L9uu.buttons).deSelected,
                                    color: "primary",
                                    name: "invoice editor button",
                                    onClick: handleInvoiceEditorPressed,
                                    children: "INVOICE EDITOR"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                                    id: "index-operator-filter-button",
                                    "data-testid": "index-operator-filter-button",
                                    variant: "contained",
                                    sx: indexOperator ? (0, $6L9uu.buttons).selected : (0, $6L9uu.buttons).deSelected,
                                    color: "primary",
                                    name: "index operator button",
                                    onClick: handleIndexOperatorPressed,
                                    children: "INDEX OPERATOR"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                                    id: "marketing-operator-filter-button",
                                    "data-testid": "marketing-operator-filter-button",
                                    variant: "contained",
                                    sx: marketingOperator ? (0, $6L9uu.buttons).selected : (0, $6L9uu.buttons).deSelected,
                                    color: "primary",
                                    name: "marketing operator button",
                                    onClick: handleMarketingOperatorPressed,
                                    children: "MARKETING OPERATOR"
                                })
                            ]
                        })
                    }),
                    openCreateUserForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $6P9Zs.default), {
                        handleClose: ()=>setOpenCreateUserForm(false)
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                        loading: loading
                    })
                ]
            })
        ]
    });
};
var $d5e2b8fbf0ba7f82$export$2e2bcd8739ae039 = $d5e2b8fbf0ba7f82$var$Users;

});
parcelRegister("ihjAy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4e9026ab268cf74$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $d4e9026ab268cf74$export$2e2bcd8739ae039 = (0, $7B0TL.default)([
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        fillRule: "evenodd",
        d: "M16.67 13.13C18.04 14.06 19 15.32 19 17v3h4v-3c0-2.18-3.57-3.47-6.33-3.87"
    }, "0"),
    /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
        cx: "9",
        cy: "8",
        r: "4",
        fillRule: "evenodd"
    }, "1"),
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        fillRule: "evenodd",
        d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4c-.47 0-.91.1-1.33.24C14.5 5.27 15 6.58 15 8s-.5 2.73-1.33 3.76c.42.14.86.24 1.33.24m-6 1c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4"
    }, "2")
], "PeopleAlt");

});

parcelRegister("6P9Zs", function(module, exports) {

$parcel$export(module.exports, "ErrorTexts", function () { return $0986d67f16070921$export$1067ba46601ca091; });
$parcel$export(module.exports, "default", function () { return $0986d67f16070921$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $2f3Zb = parcelRequire("2f3Zb");
var $ihjAy = parcelRequire("ihjAy");
var $iR1LU = parcelRequire("iR1LU");
var $6MOqF = parcelRequire("6MOqF");
var $2zpN0 = parcelRequire("2zpN0");

var $hjfla = parcelRequire("hjfla");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gFVvY = parcelRequire("gFVvY");

var $hsjD5 = parcelRequire("hsjD5");

var $8Oiq1 = parcelRequire("8Oiq1");

var $chLJv = parcelRequire("chLJv");
var $gu8wR = parcelRequire("gu8wR");
var $am7GZ = parcelRequire("am7GZ");

var $5PJ2i = parcelRequire("5PJ2i");

var $ehzwo = parcelRequire("ehzwo");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $bilGR = parcelRequire("bilGR");

var $9Vnzc = parcelRequire("9Vnzc");

var $6L9uu = parcelRequire("6L9uu");
const $0986d67f16070921$export$1067ba46601ca091 = {
    username: "Username is required",
    usernameExist: "Username already exist",
    firstName: "First name is required",
    lastName: "Last name is required",
    password: "Password is required",
    confirmPassword: "Confirm password is required",
    passwordMismatch: "Passwords do not match"
};
const $0986d67f16070921$var$defaultErrorObj = {
    username: null,
    firstName: null,
    lastName: null,
    userGroup: null,
    password: null,
    confirmPassword: null
};
const $0986d67f16070921$var$CreateUser = ({ handleClose: handleClose })=>{
    const { data: data } = (0, $hjfla.useGetRolesQuery)();
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [username, setUsername] = (0, $bh6RR.useState)("");
    const [firstName, setFirstName] = (0, $bh6RR.useState)("");
    const [lastName, setLastName] = (0, $bh6RR.useState)("");
    const [password, setPassword] = (0, $bh6RR.useState)("");
    const [confirmPassword, setConfirmPassword] = (0, $bh6RR.useState)("");
    const [userGroup, setUserGroup] = (0, $bh6RR.useState)([]);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($0986d67f16070921$var$defaultErrorObj);
    const [addUser, addUserResult] = (0, $hjfla.useCreateUserMutation)();
    const [showPassword, setShowPassword] = (0, $bh6RR.useState)(false);
    const [showConfirmPassword, setShowConfirmPassword] = (0, $bh6RR.useState)(false);
    const handleUsernameInput = (event)=>{
        const { value: value } = event.currentTarget;
        const trimedValue = value.trim();
        if (trimedValue && trimedValue.length > 1) setFormErrors({
            ...formErrors,
            username: null
        });
        else setFormErrors({
            ...formErrors,
            username: $0986d67f16070921$export$1067ba46601ca091.username
        });
        setUsername(value);
    };
    const handleFirstNameInput = (event)=>{
        const { value: value } = event.currentTarget;
        const trimedValue = value.trim();
        if (trimedValue && trimedValue.length > 1) setFormErrors({
            ...formErrors,
            firstName: null
        });
        else setFormErrors({
            ...formErrors,
            firstName: $0986d67f16070921$export$1067ba46601ca091.firstName
        });
        const finalValue = value.charAt(0).toUpperCase() + value.slice(1);
        setFirstName(finalValue);
    };
    const handleLastNameInput = (event)=>{
        const { value: value } = event.currentTarget;
        const trimedValue = value.trim();
        if (trimedValue && trimedValue.length > 1) setFormErrors({
            ...formErrors,
            lastName: null
        });
        else setFormErrors({
            ...formErrors,
            lastName: $0986d67f16070921$export$1067ba46601ca091.lastName
        });
        const finalValue = value.charAt(0).toUpperCase() + value.slice(1);
        setLastName(finalValue);
    };
    const handlePasswordInput = (event)=>{
        const { value: value } = event.currentTarget;
        const trimedValue = value.trim();
        if (trimedValue && trimedValue.length > 1) setFormErrors({
            ...formErrors,
            password: null
        });
        else setFormErrors({
            ...formErrors,
            password: $0986d67f16070921$export$1067ba46601ca091.password
        });
        setPassword(value);
    };
    const handleConfirmPasswordInput = (event)=>{
        const { value: value } = event.currentTarget;
        const trimedValue = value.trim();
        if (trimedValue && trimedValue.length > 1) setFormErrors({
            ...formErrors,
            confirmPassword: null
        });
        else setFormErrors({
            ...formErrors,
            confirmPassword: $0986d67f16070921$export$1067ba46601ca091.confirmPassword
        });
        setConfirmPassword(value);
    };
    const passEqualityChecker = (firstPassEntry, secondPassEntry)=>{
        return firstPassEntry === secondPassEntry;
    };
    const submitForm = ()=>{
        const errors = {
            username: null,
            firstName: null,
            lastName: null,
            password: null,
            confirmPassword: null
        };
        let areErrors = false;
        if (!username || username.length < 2) {
            areErrors = true;
            errors.username = $0986d67f16070921$export$1067ba46601ca091.username;
        }
        if (!firstName || firstName.length < 2) {
            areErrors = true;
            errors.firstName = $0986d67f16070921$export$1067ba46601ca091.firstName;
        }
        if (!lastName || lastName.length < 2) {
            areErrors = true;
            errors.lastName = $0986d67f16070921$export$1067ba46601ca091.lastName;
        }
        if (!password || password.length < 2) {
            areErrors = true;
            errors.password = $0986d67f16070921$export$1067ba46601ca091.password;
        }
        if (!confirmPassword || confirmPassword.length < 2) {
            areErrors = true;
            errors.confirmPassword = $0986d67f16070921$export$1067ba46601ca091.confirmPassword;
        }
        if (!areErrors && (0, $gFVvY.sameUsernameExists)(username.trim())) {
            areErrors = true;
            errors.username = $0986d67f16070921$export$1067ba46601ca091.usernameExist;
        }
        if (!areErrors && password !== confirmPassword) {
            areErrors = true;
            errors.confirmPassword = $0986d67f16070921$export$1067ba46601ca091.passwordMismatch;
            errors.password = $0986d67f16070921$export$1067ba46601ca091.passwordMismatch;
        }
        if (areErrors) setFormErrors(errors);
        else handleCreate();
    };
    const handleCreate = ()=>{
        if (!passEqualityChecker(password, confirmPassword)) setFormErrors({
            ...formErrors,
            password: "Passwords do not match",
            confirmPassword: "Passwords do not match"
        });
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        addUser({
            variables: {
                input: {
                    username: username.trim(),
                    first_name: firstName.trim(),
                    last_name: lastName.trim(),
                    password: password.trim(),
                    confirm_password: confirmPassword.trim(),
                    user_role_ids: converter(userGroup)
                }
            },
            update (cache, { data: data }) {
                if (data?.result) {
                    const userQuery = cache.readQuery({
                        query: (0, $hjfla.GetUsersDocument)
                    });
                    if (userQuery.result) {
                        const cacheUser = userQuery.result.find((u)=>u?.id === data.result.id);
                        if (!cacheUser) {
                            const newData = [
                                data.result,
                                ...userQuery.result
                            ];
                            cache.writeQuery({
                                query: (0, $hjfla.GetUsersDocument),
                                data: {
                                    result: newData
                                }
                            });
                        }
                    }
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            text: `User ${data.result.username} created`,
                            severity: "success",
                            autoHide: 2000
                        }
                    });
                    handleClose();
                }
            }
        });
    };
    const converter = (arrOfObj)=>{
        const res = [];
        for(let i = 0; i < arrOfObj.length; i++)res.push(parseInt(arrOfObj[i].id));
        return res;
    };
    const handleUserGroupsChange = (_, newValue)=>{
        setUserGroup(newValue);
    };
    //   const handleRoleDelete = (role: IRole) => {
    //     setUserGroup(userGroup.filter((g) => g.id !== role.id));
    //   };
    const getOptionLabel = (option)=>{
        if (option && option.name) return option.name.replace("_", " ");
        else return "";
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5PJ2i.default), {
        id: "new-user-dialog",
        width: 1400,
        title: "Create User",
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                display: "grid",
                gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                gap: "20px 44px",
                padding: "45px 395px",
                height: "626px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                    id: "create-user-username",
                    label: "Username",
                    value: username,
                    onChange: handleUsernameInput,
                    errorMsg: formErrors.username,
                    disabled: addUserResult.loading,
                    additionalStyle: {
                        gridColumn: "span 2",
                        marginTop: "50px"
                    },
                    startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $iR1LU.default), {
                        style: {
                            marginRight: "12px",
                            color: (0, $hsjD5.getRequiredFieldLabelColor)(!addUserResult.loading, formErrors.username)
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                    id: "create-user-firstName",
                    label: "First Name",
                    value: firstName,
                    onChange: handleFirstNameInput,
                    errorMsg: formErrors.firstName,
                    disabled: addUserResult.loading,
                    additionalStyle: {
                        gridColumn: "span 1"
                    },
                    startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $iR1LU.default), {
                        style: {
                            marginRight: "12px",
                            color: (0, $hsjD5.getRequiredFieldLabelColor)(!addUserResult.loading, formErrors.firstName)
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                    id: "create-user-last-name",
                    label: "Last Name",
                    value: lastName,
                    onChange: handleLastNameInput,
                    errorMsg: formErrors.lastName,
                    disabled: addUserResult.loading,
                    additionalStyle: {
                        gridColumn: "span 1"
                    },
                    startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $iR1LU.default), {
                        style: {
                            marginRight: "12px",
                            color: (0, $hsjD5.getRequiredFieldLabelColor)(!addUserResult.loading, formErrors.lastName)
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                    id: "create-user-password",
                    label: "Password",
                    value: password,
                    type: showPassword ? "text" : "password",
                    onChange: handlePasswordInput,
                    errorMsg: formErrors.password,
                    disabled: addUserResult.loading,
                    additionalStyle: {
                        gridColumn: "span 2"
                    },
                    startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $2f3Zb.default), {
                        style: {
                            marginRight: "12px",
                            color: (0, $hsjD5.getRequiredFieldLabelColor)(!addUserResult.loading, formErrors.password)
                        }
                    }),
                    endAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $am7GZ.default), {
                        "aria-label": "toggle password visibility",
                        onClick: ()=>setShowPassword(!showPassword),
                        edge: "end",
                        children: showPassword ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $6MOqF.default), {}) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $2zpN0.default), {})
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                    id: "create-user-confirm-password",
                    label: "Confirm Password",
                    value: confirmPassword,
                    onChange: handleConfirmPasswordInput,
                    errorMsg: formErrors.confirmPassword,
                    type: showConfirmPassword ? "text" : "password",
                    disabled: addUserResult.loading,
                    additionalStyle: {
                        gridColumn: "span 2"
                    },
                    startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $2f3Zb.default), {
                        sx: {
                            marginRight: "12px",
                            color: (0, $hsjD5.getRequiredFieldLabelColor)(!addUserResult.loading, formErrors.confirmPassword)
                        }
                    }),
                    endAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $am7GZ.default), {
                        "aria-label": "toggle confirm password visibility",
                        onClick: ()=>setShowConfirmPassword(!showConfirmPassword),
                        edge: "end",
                        children: showConfirmPassword ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $6MOqF.default), {}) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $2zpN0.default), {})
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                    id: "create-user-assign-user-group-autocomplete",
                    label: "User Groups",
                    values: userGroup,
                    options: data?.result.filter((r)=>r?.name !== (0, $8Oiq1.Roles).Admin && r?.name !== (0, $8Oiq1.Roles).InvoiceEditor) || [],
                    isSingle: false,
                    onChange: handleUserGroupsChange,
                    disabled: addUserResult.loading,
                    getOptionLabel: (option)=>getOptionLabel(option),
                    additionalStyle: {
                        gridColumn: "span 2"
                    },
                    renderTags: (value, getTagProps)=>value.map((option, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                                sx: {
                                    backgroundColor: (0, $6L9uu.Colors).white,
                                    color: (0, $9Vnzc.coloring)(option.name),
                                    "& .MuiChip-deleteIcon": {
                                        width: "20px",
                                        height: "20px",
                                        color: (0, $6L9uu.Colors).skyBlue,
                                        "&:hover": {
                                            color: (0, $6L9uu.Colors).main
                                        }
                                    }
                                },
                                variant: "outlined",
                                label: `${option.name.replace("_", " ")}`,
                                ...getTagProps({
                                    index: index
                                })
                            })),
                    startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ihjAy.default), {
                        style: {
                            marginRight: "12px",
                            color: (0, $hsjD5.getLabelColor)(!addUserResult.loading)
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize",
                    sx: {
                        gridColumn: "span 2",
                        marginTop: "50px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                            id: "cancel-create-user-button",
                            disabled: addUserResult.loading,
                            onClick: handleClose,
                            text: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                            id: "save-create-user-button",
                            disabled: addUserResult.loading,
                            onClick: submitForm,
                            text: "Create"
                        })
                    ]
                })
            ]
        })
    });
};
var $0986d67f16070921$export$2e2bcd8739ae039 = $0986d67f16070921$var$CreateUser;

});
parcelRegister("2f3Zb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a2012f98f009bf4$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $1a2012f98f009bf4$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1z"
}), "Lock");

});

parcelRegister("6MOqF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f0e57ee27f32827$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $4f0e57ee27f32827$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), "Visibility");

});

parcelRegister("2zpN0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1df2dae69998a0e5$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $1df2dae69998a0e5$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
}), "VisibilityOff");

});



parcelRegister("izFem", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb259a0dd3874add$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $8jEtO = parcelRequire("8jEtO");
var $iR1LU = parcelRequire("iR1LU");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $b1v75 = parcelRequire("b1v75");

var $ahwrv = parcelRequire("ahwrv");

var $dqPsF = parcelRequire("dqPsF");
var $chLJv = parcelRequire("chLJv");
var $km2xR = parcelRequire("km2xR");
var $da7cf = parcelRequire("da7cf");

var $6L9uu = parcelRequire("6L9uu");

var $hsjD5 = parcelRequire("hsjD5");

var $hjfla = parcelRequire("hjfla");

var $j5ie7 = parcelRequire("j5ie7");

var $8d818 = parcelRequire("8d818");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $awzd1 = parcelRequire("awzd1");
const $eb259a0dd3874add$var$UserInfoWrapper = ()=>{
    const navigate = (0, $99w1R.useNavigate)();
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [value, setValue] = (0, $bh6RR.useState)(0);
    const [getUser, { data: data, loading: loading }] = (0, $hjfla.useGetUserLazyQuery)();
    const locationElements = location.pathname.split("/").filter((e)=>e);
    (0, $bh6RR.useEffect)(()=>{
        if (!state.selectedUser) getUser({
            variables: {
                id: parseInt(locationElements[locationElements.length - 1])
            }
        });
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) dispatch({
            type: (0, $ayVxz.Actions).SetSelectedUser,
            payload: {
                user: data.result
            }
        });
    }, [
        data
    ]);
    const handleChange = (_, newValue)=>{
        setValue(newValue);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ahwrv.default), {
                handleToOverview: ()=>navigate((0, $b1v75.AdminRoutes).Users),
                navName: (0, $b1v75.RouteNames).AdminUsers,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $iR1LU.default), {
                        sx: {
                            marginRight: "7px"
                        }
                    }),
                    state.selectedUser?.username ?? ""
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $dqPsF.default), {
                        position: "static",
                        sx: {
                            backgroundColor: "white"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $da7cf.default), {
                            value: value,
                            onChange: handleChange,
                            indicatorColor: "primary",
                            textColor: "primary",
                            variant: "fullWidth",
                            TabIndicatorProps: {
                                sx: {
                                    background: (0, $6L9uu.Colors).main
                                }
                            },
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $km2xR.default), {
                                id: "membership-details",
                                label: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $8jEtO.default), {
                                            sx: {
                                                verticalAlign: "middle"
                                            }
                                        }),
                                        " Details"
                                    ]
                                }),
                                sx: (0, $hsjD5.getOuterStyle)(0, value)
                            })
                        })
                    }),
                    state.selectedUser ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                            value: value,
                            index: 0,
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $awzd1.default), {})
                        })
                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                        loading: loading
                    })
                ]
            })
        ]
    });
};
var $eb259a0dd3874add$export$2e2bcd8739ae039 = $eb259a0dd3874add$var$UserInfoWrapper;

});
parcelRegister("awzd1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4af1123f4a4d97c$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $6L9uu = parcelRequire("6L9uu");

var $j5ie7 = parcelRequire("j5ie7");

var $7P2Ve = parcelRequire("7P2Ve");

var $hsjD5 = parcelRequire("hsjD5");

var $iTI7v = parcelRequire("iTI7v");
var $km2xR = parcelRequire("km2xR");
var $da7cf = parcelRequire("da7cf");

var $3UddS = parcelRequire("3UddS");
const $d4af1123f4a4d97c$var$UserDetails = ()=>{
    const [value, setValue] = (0, $bh6RR.useState)(0);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $iTI7v.default), {
        square: true,
        style: {
            width: "83.6%",
            margin: "auto",
            marginTop: 57,
            height: 680,
            boxShadow: "0px 10px 20px " + (0, $6L9uu.Colors).third + "66"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $da7cf.default), {
                value: value,
                indicatorColor: "primary",
                textColor: "primary",
                onChange: (_, newValue)=>setValue(newValue),
                "aria-label": "detail-tabs",
                variant: "fullWidth",
                centered: true,
                TabIndicatorProps: {
                    style: {
                        background: "white"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $km2xR.default), {
                        id: "user-general-tab",
                        "data-testid": "user-general-tab",
                        label: "General",
                        style: (0, $hsjD5.getTabStyle)(0, value)
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $km2xR.default), {
                        id: "user-password-tab",
                        "data-testid": "user-password-tab",
                        label: "Password",
                        style: (0, $hsjD5.getTabStyle)(1, value)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                value: value,
                index: 0,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7P2Ve.default), {})
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                value: value,
                index: 1,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3UddS.default), {})
            })
        ]
    });
};
var $d4af1123f4a4d97c$export$2e2bcd8739ae039 = $d4af1123f4a4d97c$var$UserDetails;

});
parcelRegister("7P2Ve", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e36ace6e8b0fa892$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $gu8wR = parcelRequire("gu8wR");

var $hjfla = parcelRequire("hjfla");

var $6L9uu = parcelRequire("6L9uu");

var $ihjAy = parcelRequire("ihjAy");
var $iR1LU = parcelRequire("iR1LU");

var $hsjD5 = parcelRequire("hsjD5");

var $9Vnzc = parcelRequire("9Vnzc");

var $6P9Zs = parcelRequire("6P9Zs");

var $gFVvY = parcelRequire("gFVvY");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $8Oiq1 = parcelRequire("8Oiq1");

var $bSbwb = parcelRequire("bSbwb");

var $ehzwo = parcelRequire("ehzwo");

var $bilGR = parcelRequire("bilGR");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");
const $e36ace6e8b0fa892$var$defaultErrorObj = {
    username: null,
    firstName: null,
    lastName: null
};
const $e36ace6e8b0fa892$var$UserGeneralTab = ()=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [editable, setEditable] = (0, $bh6RR.useState)(false);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($e36ace6e8b0fa892$var$defaultErrorObj);
    const [userDetails, setUserDetails] = (0, $bh6RR.useState)({
        username: state.selectedUser?.username || "",
        firstName: state.selectedUser?.first_name || "",
        lastName: state.selectedUser?.last_name || ""
    });
    const [userGroups, setUserGroups] = (0, $bh6RR.useState)([]);
    const { data: data } = (0, $hjfla.useGetRolesQuery)();
    const [updateUser] = (0, $hjfla.useUpdateUserDetailsMutation)();
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result && state.selectedUser && state.selectedUser.roles.length > 0) setUserGroups((data?.result).filter((r)=>state.selectedUser?.roles.includes(r?.name)));
    }, [
        data
    ]);
    const handleCancelEdit = ()=>{
        setEditable(false);
        setFormErrors($e36ace6e8b0fa892$var$defaultErrorObj);
        setUserDetails({
            username: state.selectedUser?.username || "",
            firstName: state.selectedUser?.first_name || "",
            lastName: state.selectedUser?.last_name || ""
        });
        setUserGroups((data?.result).filter((r)=>state.selectedUser?.roles.includes(r?.name)));
    };
    const handleInputChange = (event)=>{
        const { name: name, value: value } = event.currentTarget;
        const trimedValue = value.trim();
        if (trimedValue && trimedValue.length > 1) setFormErrors({
            ...formErrors,
            [name]: null
        });
        else // eslint-disable-next-line
        // @ts-ignore
        setFormErrors({
            ...formErrors,
            [name]: (0, $6P9Zs.ErrorTexts)[name]
        });
        setUserDetails({
            ...userDetails,
            [name]: value
        });
    };
    const handleUserGroupsChange = (_, newValue)=>{
        setUserGroups(newValue);
    };
    const handleSaveEdit = ()=>{
        let hasErrors = false;
        const errors = {
            username: null,
            firstName: null,
            lastName: null
        };
        if (userDetails.username.length < 2) {
            hasErrors = true;
            errors.username = (0, $6P9Zs.ErrorTexts).username;
        }
        if (userDetails.firstName.length < 2) {
            hasErrors = true;
            errors.firstName = (0, $6P9Zs.ErrorTexts).firstName;
        }
        if (userDetails.lastName.length < 2) {
            hasErrors = true;
            errors.lastName = (0, $6P9Zs.ErrorTexts).lastName;
        }
        if (hasErrors) setFormErrors(errors);
        else {
            const usernameExists = (0, $gFVvY.sameUsernameExists)(userDetails.username, state?.selectedUser?.id);
            if (usernameExists) dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: `Username ${userDetails.username} already exists`
                }
            });
            else updateUser({
                variables: {
                    id: parseInt(state?.selectedUser?.id),
                    input: {
                        username: userDetails.username,
                        first_name: userDetails.firstName,
                        last_name: userDetails.lastName,
                        user_role_ids: userGroups.map((ug)=>parseInt(ug.id))
                    }
                },
                update (_, { data: data }) {
                    if (data && data?.result) {
                        (0, $gFVvY.updateUserGroupsInCache)(data.result);
                        dispatch({
                            type: (0, $ayVxz.Actions).SetSelectedUser,
                            payload: {
                                user: data.result
                            }
                        });
                        setEditable(false);
                        dispatch({
                            type: (0, $ayVxz.Actions).ShowMessage,
                            payload: {
                                severity: "success",
                                text: `Successfully updated details for ${data.result.username}`
                            }
                        });
                    }
                }
            }).catch((e)=>console.log(e.message));
        }
    };
    const getOptionLabel = (option)=>{
        if (option && option.name) return option.name.replace("_", " ");
        else return "";
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        id: "user-details",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    textAlign: "right",
                    width: "100%",
                    paddingTop: "40px",
                    paddingRight: "35px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "user-details-edit-button",
                    onClick: ()=>setEditable(true),
                    disabled: editable,
                    editButtonColor: editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    paddingTop: "30px",
                    paddingLeft: "25%",
                    paddingRight: "25%",
                    gap: "20px 80px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "username",
                        label: "Username",
                        value: userDetails.username,
                        onChange: handleInputChange,
                        errorMsg: formErrors.username,
                        disabled: !editable,
                        additionalStyle: {
                            gridColumn: "span 2",
                            marginTop: "30px"
                        },
                        startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $iR1LU.default), {
                            style: {
                                marginRight: "12px",
                                color: (0, $hsjD5.getRequiredFieldLabelColor)(editable, formErrors.username)
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "firstName",
                        label: "First Name",
                        value: userDetails.firstName,
                        onChange: handleInputChange,
                        errorMsg: formErrors.firstName,
                        disabled: !editable,
                        additionalStyle: {
                            gridColumn: "span 1",
                            marginTop: "30px"
                        },
                        startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $iR1LU.default), {
                            style: {
                                marginRight: "12px",
                                color: (0, $hsjD5.getRequiredFieldLabelColor)(editable, formErrors.firstName)
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "lastName",
                        label: "Last Name",
                        value: userDetails.lastName,
                        onChange: handleInputChange,
                        errorMsg: formErrors.lastName,
                        disabled: !editable,
                        additionalStyle: {
                            gridColumn: "span 1",
                            marginTop: "30px"
                        },
                        startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $iR1LU.default), {
                            style: {
                                marginRight: "12px",
                                color: (0, $hsjD5.getRequiredFieldLabelColor)(editable, formErrors.lastName)
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                        id: "user-details-assign-user-group-autocomplete",
                        label: "User Groups",
                        values: userGroups,
                        options: data?.result.filter((r)=>r?.name !== (0, $8Oiq1.Roles).Admin && r?.name !== (0, $8Oiq1.Roles).InvoiceEditor) || [],
                        isSingle: false,
                        onChange: handleUserGroupsChange,
                        disabled: !editable,
                        getOptionLabel: (option)=>getOptionLabel(option),
                        additionalStyle: {
                            gridColumn: "span 2",
                            marginTop: "30px"
                        },
                        renderTags: (value, getTagProps)=>value.map((option, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                                    sx: {
                                        backgroundColor: (0, $6L9uu.Colors).white,
                                        color: (0, $9Vnzc.coloring)(option.name),
                                        "& .MuiChip-deleteIcon": {
                                            width: "20px",
                                            height: "20px",
                                            color: (0, $6L9uu.Colors).skyBlue,
                                            "&:hover": {
                                                color: (0, $6L9uu.Colors).main
                                            }
                                        }
                                    },
                                    variant: "outlined",
                                    label: `${option.name.replace("_", " ")}`,
                                    ...getTagProps({
                                        index: index
                                    })
                                })),
                        startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ihjAy.default), {
                            style: {
                                marginRight: "12px",
                                color: (0, $hsjD5.getLabelColor)(editable)
                            }
                        })
                    }),
                    editable && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        className: "centralize",
                        sx: {
                            gridColumn: "span 2",
                            marginTop: "190px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                                id: "cancel-edit-user-button",
                                onClick: handleCancelEdit,
                                text: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                                id: "save-edit-user-button",
                                onClick: handleSaveEdit,
                                text: "Save"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e36ace6e8b0fa892$export$2e2bcd8739ae039 = $e36ace6e8b0fa892$var$UserGeneralTab;

});

parcelRegister("3UddS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $663c066fe925f81d$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $chLJv = parcelRequire("chLJv");
var $am7GZ = parcelRequire("am7GZ");

var $2f3Zb = parcelRequire("2f3Zb");
var $6MOqF = parcelRequire("6MOqF");
var $2zpN0 = parcelRequire("2zpN0");

var $6L9uu = parcelRequire("6L9uu");

var $6P9Zs = parcelRequire("6P9Zs");

var $hsjD5 = parcelRequire("hsjD5");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $ehzwo = parcelRequire("ehzwo");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");
const $663c066fe925f81d$var$defaultErrorObj = {
    password: null,
    confirmPassword: null
};
const $663c066fe925f81d$var$errorTexts = {
    pass: "Password too short",
    confirmPass: "Confirm password too short"
};
const $663c066fe925f81d$var$UserPasswordTab = ()=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [showPassword, setShowPassword] = (0, $bh6RR.useState)(false);
    const [password, setPassword] = (0, $bh6RR.useState)("");
    const [confirmPassword, setConfirmPassword] = (0, $bh6RR.useState)("");
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($663c066fe925f81d$var$defaultErrorObj);
    const [updatePass, { loading: loading }] = (0, $hjfla.useUpdatePasswordMutation)();
    const handlePassChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value.trim().length > 1) setFormErrors({
            ...formErrors,
            password: null
        });
        else setFormErrors({
            ...formErrors,
            password: $663c066fe925f81d$var$errorTexts.pass
        });
        setPassword(value.trim());
    };
    const handleConfirmPassChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value.trim().length > 1) setFormErrors({
            ...formErrors,
            confirmPassword: null
        });
        else setFormErrors({
            ...formErrors,
            confirmPassword: $663c066fe925f81d$var$errorTexts.confirmPass
        });
        setConfirmPassword(value);
    };
    const resetForm = ()=>{
        setPassword("");
        setConfirmPassword("");
        setFormErrors($663c066fe925f81d$var$defaultErrorObj);
    };
    const handleSaveClicked = ()=>{
        let hasErrors = false;
        const errors = {
            password: null,
            confirmPassword: null
        };
        if (password.length < 2) {
            hasErrors = true;
            errors.password = "Password too short";
        }
        if (confirmPassword.length < 2) {
            hasErrors = true;
            errors.confirmPassword = "Confirm password too short";
        }
        if (!hasErrors && password !== confirmPassword) {
            hasErrors = true;
            errors.confirmPassword = (0, $6P9Zs.ErrorTexts).passwordMismatch;
        }
        if (hasErrors) setFormErrors(errors);
        else dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to create new password for ${state?.selectedUser?.username}?`,
                agreeAction: submitForm
            }
        });
    };
    const submitForm = ()=>{
        updatePass({
            variables: {
                id: parseInt(state?.selectedUser?.id),
                newPass: password
            },
            update () {
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: `You have successfully updated ${state?.selectedUser?.username}'s password`
                    }
                });
                resetForm();
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        });
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        id: "user-details",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                display: "grid",
                gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
                paddingTop: "250px",
                paddingLeft: "25%",
                paddingRight: "25%",
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                    id: "user-new-password",
                    label: "New Password",
                    value: password,
                    type: showPassword ? "text" : "password",
                    onChange: handlePassChange,
                    errorMsg: formErrors.password,
                    disabled: loading,
                    additionalStyle: {
                        gridColumn: "span 1",
                        height: "46px"
                    },
                    startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $2f3Zb.default), {
                        style: {
                            marginRight: "12px",
                            color: (0, $hsjD5.getRequiredFieldLabelColor)(!loading, formErrors.password)
                        }
                    }),
                    endAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $am7GZ.default), {
                        "aria-label": "toggle password visibility",
                        onClick: ()=>setShowPassword(!showPassword),
                        edge: "end",
                        children: showPassword ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $6MOqF.default), {
                            style: {
                                color: (0, $6L9uu.Colors).skyBlue
                            }
                        }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $2zpN0.default), {
                            style: {
                                color: (0, $6L9uu.Colors).skyBlue
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                    id: "user-new-confirmpassword",
                    label: "Confirm New Password",
                    value: confirmPassword,
                    type: showPassword ? "text" : "password",
                    onChange: handleConfirmPassChange,
                    errorMsg: formErrors.confirmPassword,
                    disabled: loading,
                    additionalStyle: {
                        gridColumn: "span 1",
                        marginTop: "30px",
                        height: "46px"
                    },
                    startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $2f3Zb.default), {
                        style: {
                            marginRight: "12px",
                            color: (0, $hsjD5.getRequiredFieldLabelColor)(!loading, formErrors.confirmPassword)
                        }
                    }),
                    endAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $am7GZ.default), {
                        "aria-label": "toggle password visibility",
                        onClick: ()=>setShowPassword(!showPassword),
                        edge: "end",
                        children: showPassword ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $6MOqF.default), {
                            style: {
                                color: (0, $6L9uu.Colors).skyBlue
                            }
                        }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $2zpN0.default), {
                            style: {
                                color: (0, $6L9uu.Colors).skyBlue
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize",
                    sx: {
                        gridColumn: "span 1",
                        marginTop: "130px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                            id: "cancel-user-new-password-button",
                            onClick: resetForm,
                            text: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                            id: "save-user-new-password-button",
                            onClick: handleSaveClicked,
                            text: "Save"
                        })
                    ]
                })
            ]
        })
    });
};
var $663c066fe925f81d$export$2e2bcd8739ae039 = $663c066fe925f81d$var$UserPasswordTab;

});



parcelRegister("lWrBs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b9c1572ef8f391f$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bt9fX = parcelRequire("bt9fX");
var $7OO4z = parcelRequire("7OO4z");
var $ihjAy = parcelRequire("ihjAy");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $gu8wR = parcelRequire("gu8wR");
var $ePpmI = parcelRequire("ePpmI");
var $aitry = parcelRequire("aitry");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $8Oiq1 = parcelRequire("8Oiq1");

var $hjfla = parcelRequire("hjfla");

var $6L9uu = parcelRequire("6L9uu");

var $9Vnzc = parcelRequire("9Vnzc");

var $ayVxz = parcelRequire("ayVxz");

var $ahwrv = parcelRequire("ahwrv");

var $d7fM7 = parcelRequire("d7fM7");

var $3rhIF = parcelRequire("3rhIF");
const $3b9c1572ef8f391f$var$adminStyles = {
    color: (0, $6L9uu.Colors).main,
    fontSize: 14,
    background: "#FCF2DD",
    "&:active, &:focus": {
        background: "#FCF2DD"
    }
};
const $3b9c1572ef8f391f$var$invoiceEditorStyles = {
    color: (0, $6L9uu.Colors).main,
    fontSize: 14,
    background: "#E2E9EF",
    "&:active, &:focus": {
        background: "#E2E9EF"
    }
};
// const operatorStyles: SxProps = {
//   color: Colors.main,
//   fontSize: 14,
//   background: '#E8F2FE',
//   '&:active, &:focus': {
//     background: '#E8F2FE'
//   }
// };
const $3b9c1572ef8f391f$var$esg_operatorStyles = {
    color: (0, $6L9uu.Colors).main,
    fontSize: 14,
    background: "#FDE9FD",
    "&:active, &:focus": {
        background: "#FDE9FD"
    }
};
const $3b9c1572ef8f391f$var$index_operatorStyles = {
    color: (0, $6L9uu.Colors).main,
    fontSize: 14,
    background: "#E5F8F6",
    "&:active, &:focus": {
        background: "#E5F8F6"
    }
};
const $3b9c1572ef8f391f$var$marketing_operatorStyles = {
    color: (0, $6L9uu.Colors).main,
    fontSize: 14,
    background: "#EDE5F8",
    "&:active, &:focus": {
        background: "#EDE5F8"
    }
};
// const adminDeleteIconStyles: SxProps = {
//   color: '#bf8104',
//   width: 28,
//   height: 28,
//   '&:hover': {
//     color: '#EBA61C'
//   }
// };
const $3b9c1572ef8f391f$var$operatorDeleteIconStyles = {
    color: (0, $6L9uu.Colors).third,
    width: 28,
    height: 28,
    "&:hover": {
        color: (0, $6L9uu.Colors).main
    }
};
const $3b9c1572ef8f391f$var$esg_operatorDeleteIconStyles = {
    color: (0, $6L9uu.Colors).pink,
    width: 28,
    height: 28,
    "&:hover": {
        color: "#9e199e"
    }
};
const $3b9c1572ef8f391f$var$index_operatorDeleteIconStyles = {
    color: (0, $6L9uu.Colors).dark_green,
    width: 28,
    height: 28,
    "&:hover": {
        color: "#009e8e"
    }
};
const $3b9c1572ef8f391f$var$marketing_operatorDeleteIconStyles = {
    color: (0, $6L9uu.Colors).purple,
    width: 28,
    height: 28,
    "&:hover": {
        color: "#8639ed"
    }
};
const $3b9c1572ef8f391f$var$UserGroups = ()=>{
    const { data: data, loading: loading } = (0, $hjfla.useGetRolesQuery)();
    const [removeRoleFromUser] = (0, $hjfla.useRemoveRoleFromUserMutation)();
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [openAddUserForm, setOpenAddUserForm] = (0, $bh6RR.useState)(false);
    const [selectedValueList, setSelectedValueList] = (0, $bh6RR.useState)("");
    const [values, setValues] = (0, $bh6RR.useState)([]);
    const [selectedRoleId, setSelectedRoleId] = (0, $bh6RR.useState)("");
    const getChipStyles = (name)=>{
        switch(name){
            case (0, $8Oiq1.Roles).Admin:
                return $3b9c1572ef8f391f$var$adminStyles;
            case (0, $8Oiq1.Roles).InvoiceEditor:
            case (0, $8Oiq1.Roles).Operator:
                return $3b9c1572ef8f391f$var$invoiceEditorStyles;
            case (0, $8Oiq1.Roles).EsgOperator:
                return $3b9c1572ef8f391f$var$esg_operatorStyles;
            case (0, $8Oiq1.Roles).IndexOperator:
                return $3b9c1572ef8f391f$var$index_operatorStyles;
            case (0, $8Oiq1.Roles).MarketingOperator:
                return $3b9c1572ef8f391f$var$marketing_operatorStyles;
            default:
                return "";
        }
    };
    const getChipDeleteIconStyles = (name)=>{
        switch(name){
            case (0, $8Oiq1.Roles).Operator:
                return $3b9c1572ef8f391f$var$operatorDeleteIconStyles;
            case (0, $8Oiq1.Roles).EsgOperator:
                return $3b9c1572ef8f391f$var$esg_operatorDeleteIconStyles;
            case (0, $8Oiq1.Roles).IndexOperator:
                return $3b9c1572ef8f391f$var$index_operatorDeleteIconStyles;
            case (0, $8Oiq1.Roles).MarketingOperator:
                return $3b9c1572ef8f391f$var$marketing_operatorDeleteIconStyles;
            default:
                return "";
        }
    };
    const renderUsers = ({ id: id, name: name, users: users })=>{
        const canDelete = name !== (0, $8Oiq1.Roles).Admin && name !== (0, $8Oiq1.Roles).InvoiceEditor;
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
            sx: {
                display: "flex"
            },
            children: users.map((user, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        margin: "10px",
                        alignItems: "center"
                    },
                    children: canDelete ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                        id: `user-${user?.username}-username`,
                        "data-testid": `user-${user?.username}-username`,
                        label: user?.username,
                        onDelete: ()=>handleRemoveUser(user, id, name),
                        sx: {
                            ...getChipStyles(name),
                            ".MuiChip-deleteIcon": getChipDeleteIconStyles(name)
                        }
                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                        id: `user-${user?.username}-username`,
                        "data-testid": `user-${user?.username}-username`,
                        label: user?.username,
                        sx: {
                            ...getChipStyles(name),
                            ".MuiChip-deleteIcon": getChipDeleteIconStyles(name)
                        }
                    })
                }, index))
        });
    };
    const renderAddUser = ({ id: id, name: name, users: users })=>{
        const disable = name === (0, $8Oiq1.Roles).Admin || name === (0, $8Oiq1.Roles).InvoiceEditor;
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: `${id}-${name}-add-user-button`,
            "data-testid": `${id}-${name}-add-user-button`,
            onClick: ()=>handleOpenAddUserToGroup(id, name, users),
            disabled: disable,
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bt9fX.default), {
                sx: {
                    color: disable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue,
                    height: "42px",
                    width: "42px"
                }
            })
        });
    };
    const renderGroupName = ({ name: name })=>{
        return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                display: "grid",
                gridTemplateColumns: "repeat(12, minmax(0, 1fr))"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        height: "50px",
                        gridColumn: "span 1"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {
                        orientation: "vertical",
                        sx: {
                            background: (0, $9Vnzc.coloring)(name),
                            width: "3px"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        marginTop: "10px",
                        gridColumn: "span 11"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ihjAy.default), {
                                sx: {
                                    color: (0, $9Vnzc.coloring)(name),
                                    marginRight: "10px"
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), {
                                id: `${name}-group`,
                                "data-testid": `${name}-group`,
                                sx: {
                                    fontFamily: "Overpass",
                                    fontSize: "14px",
                                    color: (0, $9Vnzc.coloring)(name),
                                    marginTop: "5px",
                                    marginRight: "25px"
                                },
                                children: (0, $9Vnzc.makeFirstLetterCapital)(name.replace("_", " "))
                            })
                        ]
                    })
                })
            ]
        });
    };
    const columns = [
        {
            title: "User Group",
            width: 350,
            sorting: false,
            render: renderGroupName
        },
        {
            title: "Users",
            width: 1232,
            sorting: false,
            render: renderUsers
        },
        {
            title: "Add User",
            width: 140,
            sorting: false,
            render: renderAddUser
        }
    ];
    const handleRemoveUser = (user, roleId, roleName)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to remove ${user.username} from ${roleName.replace("_", " ")} group?`,
                agreeAction: removeUserConfirmed,
                params: [
                    user,
                    roleId,
                    roleName
                ]
            }
        });
    };
    const removeUserConfirmed = (params)=>{
        const user = params[0];
        const userId = user.id;
        const roleId = params[1];
        const roleName = params[2];
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        removeRoleFromUser({
            variables: {
                input: {
                    user_id: parseInt(userId),
                    role_id: parseInt(roleId)
                }
            },
            update (cache) {
                const groupsQuery = cache.readQuery({
                    query: (0, $hjfla.GetRolesDocument)
                });
                if (groupsQuery.result) {
                    const data = groupsQuery.result.map((gr)=>{
                        if (gr?.id === roleId) return {
                            ...gr,
                            users: gr.users.filter((u)=>u?.id !== userId)
                        };
                        else return gr;
                    });
                    cache.writeQuery({
                        query: (0, $hjfla.GetRolesDocument),
                        data: {
                            result: data
                        }
                    });
                }
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `User ${user.username} removed from ${roleName} group`,
                        severity: "success"
                    }
                });
            }
        }).catch((error)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            }));
    };
    const handleOpenAddUserToGroup = (selectedRoleId, name, values)=>{
        setSelectedValueList(name);
        setValues(values);
        setSelectedRoleId(selectedRoleId);
        setOpenAddUserForm(true);
    };
    const handleCloseAddUserToGroup = ()=>{
        setSelectedValueList("");
        setValues([]);
        setSelectedRoleId("");
        setOpenAddUserForm(false);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "overviewPage",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    width: "100%",
                    zIndex: 2
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ahwrv.default), {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $7OO4z.default), {
                            sx: {
                                marginRight: "7px"
                            }
                        }),
                        " User Groups"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                    columns: columns,
                    data: data?.result || [],
                    loading: loading,
                    handleDetails: ()=>true,
                    handleRemove: ()=>true,
                    pageSize: 10,
                    hideSearch: true
                })
            }),
            openAddUserForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $3rhIF.default), {
                name: selectedValueList,
                values: values,
                id: selectedRoleId,
                handleClose: handleCloseAddUserToGroup
            })
        ]
    });
};
var $3b9c1572ef8f391f$export$2e2bcd8739ae039 = $3b9c1572ef8f391f$var$UserGroups;

});
parcelRegister("3rhIF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47c28f0c101ed059$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $gu8wR = parcelRequire("gu8wR");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hjfla = parcelRequire("hjfla");

var $gFVvY = parcelRequire("gFVvY");

var $6L9uu = parcelRequire("6L9uu");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $bilGR = parcelRequire("bilGR");

var $5PJ2i = parcelRequire("5PJ2i");
const $47c28f0c101ed059$var$chipStyles = {
    color: (0, $6L9uu.Colors).main,
    fontSize: 14,
    background: "#69AAF333",
    "&:active, &:focus": {
        background: "#69AAF333"
    }
};
const $47c28f0c101ed059$var$newChipStyles = {
    color: (0, $6L9uu.Colors).skyBlue,
    background: (0, $6L9uu.Colors).white,
    fontSize: 14,
    border: "1px solid " + (0, $6L9uu.Colors).skyBlue,
    "&:active, &:focus": {
        background: (0, $6L9uu.Colors).white
    }
};
const $47c28f0c101ed059$var$deleteIconStyles = {
    color: (0, $6L9uu.Colors).skyBlue,
    width: 28,
    height: 28,
    "&:hover": {
        color: (0, $6L9uu.Colors).main
    }
};
const $47c28f0c101ed059$export$1067ba46601ca091 = {
    chooseUser: "Please select user!"
};
const $47c28f0c101ed059$var$defaultErrorObj = {
    chooseUser: null
};
const $47c28f0c101ed059$var$AddUserToGroup = ({ id: id, name: name, values: values, handleClose: handleClose })=>{
    const { data: data } = (0, $hjfla.useGetUsersQuery)();
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [addRoleToUsers, { loading: loading }] = (0, $hjfla.useAddRoleToUserMutation)();
    const [currentValues, setCurrentValues] = (0, $bh6RR.useState)(values);
    const [addedUsers, setAddedUsers] = (0, $bh6RR.useState)([]);
    const [selectedUser, setSelectedUser] = (0, $bh6RR.useState)(null);
    const [usersOptions, setUsersOptions] = (0, $bh6RR.useState)([]);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($47c28f0c101ed059$var$defaultErrorObj);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setUsersOptions(data.result.filter((r)=>!r?.roles.includes(name)));
    }, [
        data
    ]);
    const handleUserChange = (_, newValue)=>{
        if (newValue) setFormErrors({
            ...formErrors,
            chooseUser: null
        });
        else setFormErrors({
            ...formErrors,
            chooseUser: $47c28f0c101ed059$export$1067ba46601ca091.chooseUser
        });
        setSelectedUser(newValue);
    };
    const handleAddUserButtonPressed = ()=>{
        if (selectedUser) {
            setCurrentValues([
                {
                    ...selectedUser,
                    isNew: true
                },
                ...currentValues
            ]);
            setAddedUsers([
                ...addedUsers,
                selectedUser
            ]);
            setSelectedUser(null);
            setUsersOptions(usersOptions.filter((u)=>u.id !== selectedUser.id));
        }
    };
    const handleRemoveUser = (user)=>{
        setCurrentValues(currentValues.filter((v)=>v.id !== user.id));
        setAddedUsers(addedUsers.filter((v)=>v.id !== user.id));
        setUsersOptions([
            ...usersOptions,
            user
        ]);
    };
    const submitForm = ()=>{
        const errors = {
            chooseUser: null
        };
        if (addedUsers.length > 0) addRoleToUsers({
            variables: {
                role_id: parseInt(id),
                user_ids: addedUsers.map((u)=>parseInt(u.id))
            },
            update () {
                setCurrentValues(currentValues.map((v)=>v.isNew ? {
                        ...v,
                        isNew: false
                    } : v));
                setAddedUsers([]);
                (0, $gFVvY.addUsersToGroupInCache)(id, addedUsers);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: `User(s) added to ${name} group successfully`
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        });
        else {
            errors.chooseUser = $47c28f0c101ed059$export$1067ba46601ca091.chooseUser;
            setFormErrors(errors);
        }
    };
    const handleCancelPressed = ()=>{
        if (addedUsers.length > 0) dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: "There are unsaved changes. Are you sure you want to proceed?",
                agreeAction: closeDialog
            }
        });
        else handleClose();
    };
    const closeDialog = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        handleClose();
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5PJ2i.default), {
        id: "new-user-dialog",
        width: 886,
        title: "Add User",
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                height: "668px",
                display: "flex",
                flexFlow: "column",
                paddingY: "70px",
                gap: "50px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        color: (0, $6L9uu.Colors).skyBlue,
                        fontSize: "18px",
                        lineHeight: "19px",
                        fontWeight: "bold",
                        textAlign: "center"
                    },
                    children: name.replace(/([A-Z][a-z])/g, " $1").replace(/(\d)/g, " $1")
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    sx: {
                        display: "grid",
                        gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
                        gap: "20px 24px",
                        paddingLeft: "13%",
                        paddingRight: "13%",
                        flexGrow: 1,
                        gridTemplateRows: "max-content"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                            id: "add-user-to-user-group-autocomplete",
                            label: "Choose User",
                            values: selectedUser,
                            options: usersOptions,
                            onChange: handleUserChange,
                            errorMsg: formErrors.chooseUser,
                            disabled: loading,
                            getOptionLabel: (option)=>option?.username,
                            additionalStyle: {
                                gridColumn: "span 8"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                            id: "add-user-to-user-group-button",
                            "data-testid": "add-user-to-user-group-button",
                            sx: {
                                width: 126,
                                height: "36px",
                                border: "1px solid " + (0, $6L9uu.Colors).secondary,
                                color: (0, $6L9uu.Colors).secondary,
                                gridColumn: "span 3"
                            },
                            onClick: handleAddUserButtonPressed,
                            disabled: loading,
                            children: "Add User"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                            sx: {
                                gridColumn: "span 12",
                                display: "flex",
                                gap: "10px",
                                marginTop: "50px"
                            },
                            children: currentValues.map((val, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                    children: val.isNew ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                                        id: `${name}-${val.first_name} ${val.last_name}-val`,
                                        "data-testid": `${val.first_name} ${val.last_name}-${val}-val`,
                                        label: `${val.first_name} ${val.last_name}`,
                                        sx: {
                                            ...$47c28f0c101ed059$var$newChipStyles,
                                            ".MuiChip-deleteIcon": $47c28f0c101ed059$var$deleteIconStyles
                                        },
                                        onDelete: ()=>handleRemoveUser(val)
                                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                                        id: `${name}-${val.first_name} ${val.last_name}-val`,
                                        "data-testid": `${val.first_name}-${val.last_name}-val`,
                                        label: `${val.first_name} ${val.last_name}`,
                                        sx: $47c28f0c101ed059$var$chipStyles
                                    })
                                }, index))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                            id: "cancel-new-role-to-user-button",
                            disabled: loading,
                            onClick: handleCancelPressed,
                            text: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                            id: "save-new-role-to-user-button",
                            disabled: loading,
                            onClick: submitForm,
                            text: "Save"
                        })
                    ]
                })
            ]
        })
    });
};
var $47c28f0c101ed059$export$2e2bcd8739ae039 = $47c28f0c101ed059$var$AddUserToGroup;

});


parcelRegister("gEbRq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41ac6d36a93a875b$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bt9fX = parcelRequire("bt9fX");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $gu8wR = parcelRequire("gu8wR");
var $lZnEL = parcelRequire("lZnEL");
var $gDp1O = parcelRequire("gDp1O");
var $aitry = parcelRequire("aitry");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hjfla = parcelRequire("hjfla");

var $gFVvY = parcelRequire("gFVvY");

var $e2ibc = parcelRequire("e2ibc");

var $6L9uu = parcelRequire("6L9uu");

var $ahwrv = parcelRequire("ahwrv");

var $d7fM7 = parcelRequire("d7fM7");

var $u2HDP = parcelRequire("u2HDP");
const $41ac6d36a93a875b$var$chipStyles = {
    color: (0, $6L9uu.Colors).main,
    fontSize: 14,
    fontWeight: "normal",
    background: "#69AAF333",
    "&:active, &:focus": {
        background: "#69AAF333"
    }
};
const $41ac6d36a93a875b$var$deleteIconStyles = {
    color: (0, $6L9uu.Colors).skyBlue,
    width: 28,
    height: 28,
    "&:hover": {
        color: (0, $6L9uu.Colors).main
    }
};
const $41ac6d36a93a875b$var$Customization = ()=>{
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [tableData, setTableData] = (0, $bh6RR.useState)([]);
    const [selectedValueList, setSelectedValueList] = (0, $bh6RR.useState)("");
    const [values, setValues] = (0, $bh6RR.useState)([]);
    const [openValueList, setOpenValueList] = (0, $bh6RR.useState)(false);
    const [addNewValue, setAddNewValue] = (0, $bh6RR.useState)(false);
    const companyTypes = (0, $hjfla.useCompanyTypesQuery)();
    const marketActivities = (0, $hjfla.useMarketActivitiesQuery)();
    const membershipTypes = (0, $hjfla.useMembershipTypesQuery)();
    const productCodes = (0, $hjfla.useProductCodesQuery)();
    const titlesInternal = (0, $hjfla.useTitlesInternalQuery)();
    const [deleteValueMutation] = (0, $hjfla.useDeleteValueMutation)();
    (0, $bh6RR.useEffect)(()=>{
        let res = [
            ...tableData
        ];
        if (marketActivities.data && marketActivities.data.result.length) {
            if (res.filter((i)=>i.name === marketActivities?.data?.result[0]?.__typename).length === 0) res = [
                ...res,
                {
                    name: marketActivities.data.result[0]?.__typename,
                    values: marketActivities.data.result
                }
            ];
            else res = res.map((r)=>r.name === marketActivities?.data?.result[0]?.__typename ? {
                    ...r,
                    values: marketActivities.data.result
                } : r);
        }
        if (membershipTypes.data && membershipTypes.data.result.length) {
            if (res.filter((i)=>i.name === membershipTypes?.data?.result[0]?.__typename).length === 0) res = [
                ...res,
                {
                    name: membershipTypes.data.result[0]?.__typename,
                    values: membershipTypes.data.result
                }
            ];
            else res = res.map((r)=>r.name === membershipTypes?.data?.result[0]?.__typename ? {
                    ...r,
                    values: membershipTypes.data.result
                } : r);
        }
        if (companyTypes.data && companyTypes.data.result.length) {
            if (res.filter((i)=>i.name === companyTypes?.data?.result[0]?.__typename).length === 0) res = [
                ...res,
                {
                    name: companyTypes.data.result[0]?.__typename,
                    values: companyTypes.data.result
                }
            ];
            else res = res.map((r)=>r.name === companyTypes?.data?.result[0]?.__typename ? {
                    ...r,
                    values: companyTypes.data.result
                } : r);
        }
        if (productCodes.data && productCodes.data.result.length) {
            if (res.filter((i)=>i.name === productCodes?.data?.result[0]?.__typename).length === 0) res = [
                ...res,
                {
                    name: productCodes.data.result[0]?.__typename,
                    values: productCodes.data.result
                }
            ];
            else res = res.map((r)=>r.name === productCodes?.data?.result[0]?.__typename ? {
                    ...r,
                    values: productCodes.data.result
                } : r);
        }
        if (titlesInternal.data && titlesInternal.data.result.length) {
            if (res.filter((i)=>i.name === titlesInternal?.data?.result[0]?.__typename).length === 0) res = [
                ...res,
                {
                    name: titlesInternal.data.result[0]?.__typename,
                    values: titlesInternal.data.result
                }
            ];
            else res = res.map((r)=>r.name === titlesInternal?.data?.result[0]?.__typename ? {
                    ...r,
                    values: titlesInternal.data.result
                } : r);
        }
        setTableData(res.sort(function(a, b) {
            const x = a.name.toLowerCase();
            const y = b.name.toLowerCase();
            if (x < y) return -1;
            if (x > y) return 1;
            return 0;
        }));
    }, [
        companyTypes.data,
        marketActivities.data,
        membershipTypes.data,
        productCodes.data,
        titlesInternal.data
    ]);
    const renderValueListName = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
            sx: {
                fontWeight: "normal",
                fontSize: 14
            },
            children: rowData.name?.replace(/([A-Z][a-z])/g, " $1").replace(/(\d)/g, " $1")
        });
    };
    const renderValues = (rowData)=>{
        const { name: name, values: values } = rowData;
        const count = values.length;
        const result = values.map((v)=>v.name).slice(0, 10);
        return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                display: "grid",
                gridTemplateColumns: "repeat(12, minmax(0, 1fr))"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        gridColumn: "span 11",
                        display: "flex",
                        gap: "10px",
                        margin: "15px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            gridColumn: "span 11",
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "20px"
                        },
                        children: result.map((val, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                                    id: `${name}-${val}-val`,
                                    "data-testid": `${name}-${val}-val`,
                                    label: val,
                                    onDelete: ()=>dispatch({
                                            type: (0, $ayVxz.Actions).ShowConfirmation,
                                            payload: {
                                                text: `Are you sure you want to delete ${val} from ${name.replace(/([A-Z][a-z])/g, " $1").replace(/(\d)/g, " $1")} value list?`,
                                                agreeAction: handleDeleteValueItem,
                                                params: {
                                                    val: val,
                                                    rowData: rowData
                                                }
                                            }
                                        }),
                                    sx: {
                                        ...$41ac6d36a93a875b$var$chipStyles,
                                        ".MuiChip-deleteIcon": $41ac6d36a93a875b$var$deleteIconStyles
                                    }
                                })
                            }, index))
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        gridColumn: "span 1"
                    },
                    children: count > 10 && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        style: {
                            margin: 10
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gDp1O.default), {
                            underline: "always",
                            onClick: ()=>handleOpenValueList(rowData.name, rowData.values),
                            children: "View all..."
                        })
                    }, count)
                })
            ]
        });
    };
    const handleDeleteValueItem = ({ val: val, rowData: rowData })=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        const valueItem = rowData.values.find((v)=>v.name === val);
        if (valueItem) deleteValueMutation({
            variables: {
                value_list_name: (0, $e2ibc.ValueListNames)[valueItem?.__typename],
                value_id: parseInt(valueItem?.id)
            },
            update () {
                (0, $gFVvY.removeValueFromCache)(valueItem.__typename, valueItem);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Value ${val} deleted`,
                        severity: "success"
                    }
                });
            }
        }).catch((e)=>{
            const message = e.message.includes("update or delete on table") ? `Value ${val} cannot be deleted!` : e.message;
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: message,
                    autoHide: 6000
                }
            });
        });
    };
    const renderAddValue = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: `${rowData.name}-add-value-button`,
            "data-testid": `${rowData.name}-add-value-button`,
            onClick: ()=>handleOpenValueList(rowData.name, rowData.values, true),
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bt9fX.default), {
                style: {
                    color: (0, $6L9uu.Colors).skyBlue,
                    height: 42,
                    width: 42
                }
            })
        });
    };
    const handleOpenValueList = (name, values, addNew = false)=>{
        setSelectedValueList(name);
        setValues(values);
        setAddNewValue(addNew);
        setOpenValueList(true);
    };
    const handleCloseValueList = ()=>{
        setSelectedValueList("");
        setValues([]);
        setAddNewValue(false);
        setOpenValueList(false);
    };
    const columns = [
        {
            title: "Value List Name",
            width: 350,
            sorting: false,
            render: renderValueListName
        },
        {
            title: "Values",
            width: 1232,
            sorting: false,
            render: renderValues
        },
        {
            title: "Add Value",
            width: 140,
            sorting: false,
            render: renderAddValue
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "overviewPage",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    width: "100%",
                    zIndex: 2
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ahwrv.default), {
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            display: "flex",
                            flexWrap: "wrap"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lZnEL.default), {
                                sx: {
                                    marginRight: "7px"
                                },
                                children: "construction"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), {
                                children: "Customization"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                    columns: columns,
                    data: tableData,
                    loading: companyTypes.loading || marketActivities.loading || membershipTypes.loading || productCodes.loading || titlesInternal.loading,
                    handleDetails: ()=>true,
                    handleRemove: ()=>true,
                    pageSize: 10,
                    hideSearch: true
                })
            }),
            openValueList && /*#__PURE__*/ (0, $ih19M.jsx)((0, $u2HDP.default), {
                name: selectedValueList,
                values: values,
                addNew: addNewValue,
                handleClose: handleCloseValueList
            })
        ]
    });
};
var $41ac6d36a93a875b$export$2e2bcd8739ae039 = $41ac6d36a93a875b$var$Customization;

});
parcelRegister("u2HDP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9155c4cc78c6025d$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hjfla = parcelRequire("hjfla");

var $gFVvY = parcelRequire("gFVvY");

var $e2ibc = parcelRequire("e2ibc");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $gu8wR = parcelRequire("gu8wR");

var $ehzwo = parcelRequire("ehzwo");

var $6L9uu = parcelRequire("6L9uu");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");
const $9155c4cc78c6025d$var$chipStyles = {
    color: (0, $6L9uu.Colors).main,
    fontSize: 14,
    background: "#69AAF333",
    "&:active, &:focus": {
        background: "#69AAF333"
    }
};
const $9155c4cc78c6025d$var$newChipStyles = {
    color: (0, $6L9uu.Colors).skyBlue,
    background: (0, $6L9uu.Colors).white,
    fontSize: 14,
    border: "1px solid " + (0, $6L9uu.Colors).skyBlue,
    "&:active, &:focus": {
        background: (0, $6L9uu.Colors).white
    }
};
const $9155c4cc78c6025d$var$deleteIconStyles = {
    color: (0, $6L9uu.Colors).skyBlue,
    width: 28,
    height: 28,
    "&:hover": {
        color: (0, $6L9uu.Colors).main
    }
};
const $9155c4cc78c6025d$var$ValueList = ({ name: name, values: values, addNew: addNew, handleClose: handleClose })=>{
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [items, setItems] = (0, $bh6RR.useState)(values);
    const [newItems, setNewItems] = (0, $bh6RR.useState)([]);
    const [newValue, setNewValue] = (0, $bh6RR.useState)("");
    const [addNewValue] = (0, $hjfla.useAddValueMutation)();
    const [deleteValueMutation] = (0, $hjfla.useDeleteValueMutation)();
    const handleAddValuePressed = ()=>{
        if (newValue.length > 0) {
            const canAddValue = canAddNewValue(newValue.trim());
            if (canAddValue) {
                const item = {
                    id: newValue,
                    name: newValue.trim(),
                    isNew: true
                };
                setItems([
                    item,
                    ...items
                ]);
                setNewItems([
                    item,
                    ...newItems
                ]);
                setNewValue("");
            } else dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: `Value ${newValue} already exists`,
                    severity: "warning",
                    autoHide: 2000
                }
            });
        }
    };
    const handleDeleteItemPressed = (item)=>{
        const { id: id, isNew: isNew } = item;
        if (isNew) {
            setItems(items.filter((i)=>i.id !== id));
            setNewItems(newItems.filter((i)=>i.id !== id));
        } else dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${item.name} from ${name.replace(/([A-Z][a-z])/g, " $1").replace(/(\d)/g, " $1")} value list?`,
                params: item,
                agreeAction: handleDeleteValueItem
            }
        });
    };
    const handleDeleteValueItem = (valueItem)=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteValueMutation({
            variables: {
                value_list_name: (0, $e2ibc.ValueListNames)[name],
                value_id: parseInt(valueItem?.id)
            },
            update () {
                setItems(items.filter((i)=>i.id !== valueItem.id));
                (0, $gFVvY.removeValueFromCache)(name, valueItem);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Value ${valueItem.name} deleted`,
                        severity: "success"
                    }
                });
            }
        }).catch((e)=>{
            const message = e.message.includes("update or delete on table") ? `Value ${valueItem.name} cannot be deleted!` : e.message;
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: message,
                    autoHide: 6000
                }
            });
        });
    };
    const handleSavePressed = ()=>{
        if (newItems.length > 0) {
            const valuesArray = newItems.map((i)=>i.name);
            addNewValue({
                variables: {
                    input: {
                        value_list_name: (0, $e2ibc.ValueListNames)[name],
                        new_values: valuesArray
                    }
                },
                update (_, { data: data }) {
                    setNewItems([]);
                    const updatedValues = [];
                    if (data && data.result) (0, $gFVvY.addValuesToCache)(name, data?.result);
                    items.forEach((item)=>{
                        const index = Number(data?.result.findIndex((i)=>i?.name === item.id));
                        if (index > -1) updatedValues.push({
                            id: Number(data?.result[index]?.id).toString(),
                            name: data?.result[index]?.name
                        });
                        else updatedValues.push(item);
                    });
                    setItems(updatedValues);
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: "Values saved successfully"
                        }
                    });
                }
            }).catch((e)=>dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "error",
                        text: e.message,
                        autoHide: 6000
                    }
                }));
        }
    };
    const hanldeCancelPressed = ()=>{
        if (newItems.length > 0) dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: "There are unsaved values. Are you sure you want to proceed?",
                agreeAction: executeClose
            }
        });
        else executeClose();
    };
    const executeClose = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        handleClose();
    };
    const handleKeyPressed = (event)=>{
        if (event.key === "Enter") {
            event.preventDefault();
            handleAddValuePressed();
        }
    };
    const canAddNewValue = (value)=>{
        let result = true;
        result = newItems.filter((i)=>i.name.toUpperCase() === value.toUpperCase()).length === 0;
        if (result) result = items.filter((i)=>i.name.toUpperCase() === value.toUpperCase()).length === 0;
        return result;
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "new-user-dialog",
        width: 886,
        title: name.replace(/([A-Z][a-z])/g, " $1").replace(/(\d)/g, " $1") + " Value List",
        onClose: handleClose,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    height: "618px",
                    display: "flex",
                    flexFlow: "column",
                    paddingY: "50px",
                    gap: "50px",
                    overflow: "auto"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    sx: {
                        display: "grid",
                        gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
                        gap: "20px 24px",
                        paddingLeft: "13%",
                        paddingRight: "13%",
                        flexGrow: 1,
                        gridTemplateRows: "max-content"
                    },
                    children: [
                        addNew && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "new-value",
                                    "data-testid": "new-value-input-label",
                                    label: "New Value",
                                    value: newValue,
                                    onChange: (e)=>setNewValue(e.currentTarget.value),
                                    onKeyPress: handleKeyPressed,
                                    additionalStyle: {
                                        gridColumn: "span 8"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                                    id: "add-new-value-button",
                                    "data-testid": "add-new-value-button",
                                    sx: {
                                        width: "126px",
                                        height: "36px",
                                        border: "1px solid " + (0, $6L9uu.Colors).secondary,
                                        color: (0, $6L9uu.Colors).secondary,
                                        gridColumn: "span 3"
                                    },
                                    onClick: handleAddValuePressed,
                                    children: "Add Value"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                            sx: {
                                gridColumn: "span 11",
                                display: "flex",
                                gap: "20px",
                                marginTop: "50px",
                                flexWrap: "wrap"
                            },
                            children: items.map((val, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                                        id: `${name}-${val.name.split(" ").join("-")}-val`,
                                        "data-testid": `${val.name.split(" ").join("-")}-val`,
                                        label: val.name,
                                        onDelete: ()=>handleDeleteItemPressed(val),
                                        sx: {
                                            ...val.isNew ? $9155c4cc78c6025d$var$newChipStyles : $9155c4cc78c6025d$var$chipStyles,
                                            ".MuiChip-deleteIcon": $9155c4cc78c6025d$var$deleteIconStyles
                                        }
                                    })
                                }, index))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    gridColumn: "span 12",
                    margin: "15px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-new-value-button",
                        "data-testid": "cancel-new-value-button",
                        onClick: hanldeCancelPressed,
                        text: addNew ? "Cancel" : "Close"
                    }),
                    addNew && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "create-new-value-button",
                        "data-testid": "create-new-value-button",
                        onClick: handleSavePressed,
                        text: "Save"
                    })
                ]
            })
        ]
    });
};
var $9155c4cc78c6025d$export$2e2bcd8739ae039 = $9155c4cc78c6025d$var$ValueList;

});


parcelRegister("6mUJD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80b4577d0126a866$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bt9fX = parcelRequire("bt9fX");
var $szYlj = parcelRequire("szYlj");
var $2xkbE = parcelRequire("2xkbE");
var $2dpcs = parcelRequire("2dpcs");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $ePpmI = parcelRequire("ePpmI");
var $aitry = parcelRequire("aitry");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $8Oiq1 = parcelRequire("8Oiq1");

var $hjfla = parcelRequire("hjfla");

var $6L9uu = parcelRequire("6L9uu");

var $ahwrv = parcelRequire("ahwrv");

var $d7fM7 = parcelRequire("d7fM7");

var $9Vnzc = parcelRequire("9Vnzc");

var $e8Thq = parcelRequire("e8Thq");

var $1ELi8 = parcelRequire("1ELi8");
const $80b4577d0126a866$var$iconAndColor = (categoryFromList)=>{
    switch(categoryFromList){
        case (0, $8Oiq1.Categories).Comminications:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $szYlj.default), {
                style: {
                    color: (0, $9Vnzc.colorings)(categoryFromList),
                    marginRight: 10
                }
            });
        case (0, $8Oiq1.Categories).Research:
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $2dpcs.default), {
                style: {
                    color: (0, $9Vnzc.colorings)(categoryFromList),
                    marginRight: 10
                }
            });
    }
};
const $80b4577d0126a866$var$Interests = ()=>{
    const { data: data, loading: loading } = (0, $hjfla.useGetInterestGroupsQuery)();
    const [deleteInterest] = (0, $hjfla.useDeleteInterestMutation)();
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [openAddInterestForm, setOpenAddInterestForm] = (0, $bh6RR.useState)(false);
    const [selectedInterestList, setSelectedInterestList] = (0, $bh6RR.useState)("");
    const [selectedCategoryId, setSelectedCategoryId] = (0, $bh6RR.useState)("");
    const renderCategories = ({ name: name })=>{
        return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                display: "grid",
                gridTemplateColumns: "repeat(12, minmax(0, 1fr))"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        gridColumn: "span 1",
                        height: "50px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {
                        orientation: "vertical",
                        sx: {
                            background: (0, $9Vnzc.colorings)(name),
                            width: "3px"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        gridColumn: "span 11",
                        marginTop: "10px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            $80b4577d0126a866$var$iconAndColor(name),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), {
                                id: `${name}-category`,
                                "data-testid": `${name}-category`,
                                sx: {
                                    fontFamily: "Overpass",
                                    fontSize: "14px",
                                    color: (0, $9Vnzc.colorings)(name),
                                    marginTop: "5px",
                                    marginRight: "25px"
                                },
                                children: (0, $9Vnzc.makeFirstLetterCapital)(name)
                            })
                        ]
                    })
                })
            ]
        });
    };
    const renderInterests = ({ id: id, name: name, interests: interests })=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
            sx: {
                display: "flex",
                flexWrap: "wrap"
            },
            children: interests.map((interest, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        margin: "10px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ELi8.default), {
                        id: `${interest?.name}-interest`,
                        "data-testid": `${interest?.name}-interest`,
                        label: interest?.name ?? "",
                        onDelete: ()=>handleRemoveInterest(interest, id, name)
                    })
                }, index))
        });
    };
    const handleRemoveInterest = (interest, groupId, groupName)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to remove ${interest.name} from ${groupName} group?`,
                agreeAction: removeInterestConfirmed,
                params: [
                    interest,
                    groupId,
                    groupName
                ]
            }
        });
    };
    const removeInterestConfirmed = (params)=>{
        const interest = params[0];
        const interestId = interest.id;
        const groupId = params[1];
        const groupName = params[2];
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteInterest({
            variables: {
                id: parseInt(interestId)
            },
            update (cache) {
                const interestGroups = cache.readQuery({
                    query: (0, $hjfla.GetInterestGroupsDocument)
                });
                if (interestGroups.result) {
                    const data = interestGroups.result.map((gr)=>{
                        if (gr?.id === groupId) return {
                            ...gr,
                            interests: gr.interests.filter((i)=>i?.id !== interestId)
                        };
                        else return gr;
                    });
                    cache.writeQuery({
                        query: (0, $hjfla.GetInterestGroupsDocument),
                        data: {
                            result: data
                        }
                    });
                }
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Interest ${interest.name} removed from ${groupName} group`,
                        severity: "success"
                    }
                });
            }
        }).catch((error)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            }));
    };
    const renderAddInterest = ({ id: id, name: name })=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: `${id}-${name}-add-interest-button`,
            "data-testid": `${id}=${name}-add-interest-button`,
            onClick: ()=>handleOpenAddInterestToCategory(id, name),
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bt9fX.default), {
                style: {
                    color: (0, $6L9uu.Colors).skyBlue,
                    height: 42,
                    width: 42
                }
            })
        });
    };
    const handleOpenAddInterestToCategory = (selectedCategoryId, name)=>{
        setOpenAddInterestForm(true);
        setSelectedCategoryId(selectedCategoryId);
        setSelectedInterestList(name.toUpperCase());
    };
    const handleCloseAddInterestToCategory = ()=>{
        setOpenAddInterestForm(false);
        setSelectedCategoryId("");
        setSelectedInterestList("");
    };
    const columns = [
        {
            title: "Interest Category",
            width: 457,
            sorting: false,
            render: renderCategories
        },
        {
            title: "Interests",
            width: 1314,
            sorting: false,
            render: renderInterests
        },
        {
            title: "Add Interest",
            width: 140,
            sorting: false,
            render: renderAddInterest
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "overviewPage",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    width: "100%",
                    zIndex: 2
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ahwrv.default), {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $2xkbE.default), {
                            style: {
                                marginRight: "7px"
                            }
                        }),
                        " Interests"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                    columns: columns,
                    data: data?.result || [],
                    loading: loading,
                    handleDetails: ()=>true,
                    handleRemove: ()=>true,
                    pageSize: 10,
                    hideSearch: true
                })
            }),
            openAddInterestForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $e8Thq.default), {
                name: selectedInterestList,
                interests: data?.result.find((ig)=>ig?.name.toUpperCase() === selectedInterestList.toUpperCase())?.interests,
                id: selectedCategoryId,
                handleClose: handleCloseAddInterestToCategory
            })
        ]
    });
};
var $80b4577d0126a866$export$2e2bcd8739ae039 = $80b4577d0126a866$var$Interests;

});
parcelRegister("szYlj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $055e84fb9733fe0e$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $055e84fb9733fe0e$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2"
}), "ChatBubble");

});

parcelRegister("2dpcs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19d057ddc5b8f781$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $19d057ddc5b8f781$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M11.5 9C10.12 9 9 10.12 9 11.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S12.88 9 11.5 9M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-3.21 14.21-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9z"
}), "Pageview");

});

parcelRegister("e8Thq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbd730d90bee3288$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $gu8wR = parcelRequire("gu8wR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hjfla = parcelRequire("hjfla");

var $gFVvY = parcelRequire("gFVvY");

var $6L9uu = parcelRequire("6L9uu");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $ehzwo = parcelRequire("ehzwo");

var $5PJ2i = parcelRequire("5PJ2i");
const $fbd730d90bee3288$var$chipStyles = {
    color: (0, $6L9uu.Colors).main,
    fontSize: 14,
    background: "#69AAF333",
    "&:active, &:focus": {
        background: "#69AAF333"
    }
};
const $fbd730d90bee3288$var$newChipStyles = {
    color: (0, $6L9uu.Colors).skyBlue,
    background: (0, $6L9uu.Colors).white,
    fontSize: 14,
    border: "1px solid " + (0, $6L9uu.Colors).skyBlue,
    "&:active, &:focus": {
        background: (0, $6L9uu.Colors).white
    }
};
const $fbd730d90bee3288$var$deleteIconStyles = {
    color: (0, $6L9uu.Colors).skyBlue,
    width: 28,
    height: 28,
    "&:hover": {
        color: (0, $6L9uu.Colors).main
    }
};
const $fbd730d90bee3288$var$AddCategoryInterests = ({ id: id, name: name, interests: interests, handleClose: handleClose })=>{
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [addInterestToCategory, { loading: loading }] = (0, $hjfla.useAddInterestToGroupMutation)();
    const [newInterest, setNewInterest] = (0, $bh6RR.useState)("");
    const [items, setItems] = (0, $bh6RR.useState)(interests ?? []);
    const [newItems, setNewItems] = (0, $bh6RR.useState)([]);
    const [deleteInterestMutation] = (0, $hjfla.useDeleteInterestMutation)();
    const handleCancelPressed = ()=>{
        if (newItems.length > 0) dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: "There are unsaved changes. Are you sure you want to proceed?",
                agreeAction: closeDialog
            }
        });
        else handleClose();
    };
    const handleSavePressed = ()=>{
        if (newItems.length > 0) {
            const interestsArray = newItems.map((i)=>i.name);
            addInterestToCategory({
                variables: {
                    input: {
                        category_id: id,
                        new_values: interestsArray
                    }
                },
                update (_, { data: data }) {
                    setNewItems([]);
                    const updatedInterests = [];
                    if (data && data.result) (0, $gFVvY.addInterestsToCache)(id, data?.result);
                    items.forEach((item)=>{
                        const index = Number(data?.result.findIndex((i)=>i?.name === item.id));
                        if (index > -1) updatedInterests.push({
                            id: Number(data?.result[index]?.id).toString(),
                            name: data?.result[index]?.name,
                            interest_group: {
                                id: id
                            }
                        });
                        else updatedInterests.push(item);
                    });
                    setItems(updatedInterests);
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: "Interests saved successfully"
                        }
                    });
                }
            }).catch((e)=>dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "error",
                        text: e.message,
                        autoHide: 6000
                    }
                }));
        }
    };
    const handleDeleteInterestPressed = (item)=>{
        const { id: id, isNew: isNew } = item;
        if (isNew) {
            setItems(items.filter((i)=>i.id !== id));
            setNewItems(newItems.filter((i)=>i.id !== id));
        } else dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${item.name} from ${name.replace(/([A-Z][a-z])/g, " $1").replace(/(\d)/g, " $1")} category?`,
                params: item,
                agreeAction: handleDeleteInterestItem
            }
        });
    };
    const handleDeleteInterestItem = (interestItem)=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteInterestMutation({
            variables: {
                id: parseInt(interestItem?.id)
            },
            update (cache) {
                const interestGroups = cache.readQuery({
                    query: (0, $hjfla.GetInterestGroupsDocument)
                });
                if (interestGroups.result) {
                    const data = interestGroups.result.map((gr)=>{
                        if (gr?.id === interestItem.interest_group.id) return {
                            ...gr,
                            interests: gr.interests.filter((i)=>i?.id !== interestItem.id)
                        };
                        else return gr;
                    });
                    cache.writeQuery({
                        query: (0, $hjfla.GetInterestGroupsDocument),
                        data: {
                            result: data
                        }
                    });
                }
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Interest ${interestItem.name} removed from ${name} category`,
                        severity: "success"
                    }
                });
            }
        });
    };
    const handleAddInterestPressed = ()=>{
        if (newInterest.length > 0) {
            const canAddInterest = canAddNewInterest(newInterest.trim());
            if (canAddInterest) {
                const item = {
                    id: newInterest,
                    name: newInterest.trim(),
                    interest_group_id: id,
                    isNew: true,
                    interest_group: {
                        id: id,
                        name: "1",
                        interests: []
                    }
                };
                setItems([
                    item,
                    ...items
                ]);
                setNewItems([
                    item,
                    ...newItems
                ]);
                setNewInterest("");
            } else dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: `Interest ${newInterest} already exists`,
                    severity: "warning",
                    autoHide: 2000
                }
            });
        }
    };
    const closeDialog = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        handleClose();
    };
    const canAddNewInterest = (value)=>{
        let result = true;
        for(let i = 0; i < items.length; i++)if (items[i].name.toUpperCase() === value.toUpperCase()) result = false;
        return result;
    };
    const handleKeyPressed = (event)=>{
        if (event.key === "Enter") {
            event.preventDefault();
            handleAddInterestPressed();
        }
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5PJ2i.default), {
        id: "add-interest-to-category-title",
        width: 886,
        title: "Add Interest",
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                height: "668px",
                display: "flex",
                flexFlow: "column",
                paddingY: "70px",
                gap: "50px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        color: (0, $6L9uu.Colors).skyBlue,
                        fontSize: "18px",
                        lineHeight: "19px",
                        fontWeight: "bold",
                        textAlign: "center"
                    },
                    children: name.replace(/([A-Z][a-z])/g, " $1").replace(/(\d)/g, " $1")
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    sx: {
                        display: "grid",
                        gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
                        gap: "20px 24px",
                        marginLeft: "13%",
                        marginRight: "13%",
                        flexGrow: 1,
                        gridTemplateRows: "max-content"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "new-interest",
                            label: "Type Interest Name",
                            value: newInterest,
                            onChange: (e)=>setNewInterest(e.currentTarget.value),
                            onKeyPress: handleKeyPressed,
                            additionalStyle: {
                                gridColumn: "span 8"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                            id: "add-new-interest-button",
                            "data-testid": "add-new-interest-button",
                            sx: {
                                width: 126,
                                height: "36px",
                                border: "1px solid " + (0, $6L9uu.Colors).secondary,
                                color: (0, $6L9uu.Colors).secondary,
                                gridColumn: "span 3"
                            },
                            onClick: handleAddInterestPressed,
                            disabled: loading,
                            children: "Add Interest"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                            sx: {
                                gridColumn: "span 12",
                                display: "flex",
                                gap: "20px",
                                marginTop: "50px",
                                flexWrap: "wrap",
                                maxHeight: "30px"
                            },
                            children: items.map((val, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                    children: val.isNew ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                                        id: `${name}-val`,
                                        "data-testid": `${val.name}-val`,
                                        label: `${val.name}`,
                                        sx: {
                                            ...$fbd730d90bee3288$var$newChipStyles,
                                            ".MuiChip-deleteIcon": $fbd730d90bee3288$var$deleteIconStyles
                                        },
                                        onDelete: ()=>handleDeleteInterestPressed(val)
                                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                                        id: `${name}-val`,
                                        "data-testid": `${val.name}-val`,
                                        label: `${val.name}`,
                                        sx: $fbd730d90bee3288$var$chipStyles
                                    })
                                }, index))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                            id: "cancel-new-interest-to-category-button",
                            disabled: loading,
                            onClick: handleCancelPressed,
                            text: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                            id: "save-new-interest-to-category-button",
                            disabled: loading,
                            onClick: handleSavePressed,
                            text: "Save"
                        })
                    ]
                })
            ]
        })
    });
};
var $fbd730d90bee3288$export$2e2bcd8739ae039 = $fbd730d90bee3288$var$AddCategoryInterests;

});


parcelRegister("jbIBu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1bdcf04b6aea5c3$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $6L9uu = parcelRequire("6L9uu");

var $b1v75 = parcelRequire("b1v75");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $chLJv = parcelRequire("chLJv");

var $ahwrv = parcelRequire("ahwrv");

var $bwbWe = parcelRequire("bwbWe");
var $8jEtO = parcelRequire("8jEtO");
var $5HWve = parcelRequire("5HWve");

var $eBMvL = parcelRequire("eBMvL");

var $7cfBj = parcelRequire("7cfBj");

var $8d818 = parcelRequire("8d818");

var $hjfla = parcelRequire("hjfla");
const $c1bdcf04b6aea5c3$var$ContactDetails = ()=>{
    const location = (0, $99w1R.useLocation)();
    const history = (0, $99w1R.useNavigate)();
    const { state: state, dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [contact, setContact] = (0, $bh6RR.useState)(null);
    const locationElements = location.pathname.split("/").filter((e)=>e);
    const { data: data, loading: loading } = (0, $hjfla.useContactDetailsQuery)({
        variables: {
            id: parseInt(locationElements[locationElements.length - 1])
        },
        fetchPolicy: "no-cache"
    });
    const [value, setValue] = (0, $bh6RR.useState)(0);
    const handleChange = (_, newValue)=>{
        setValue(newValue);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            dispatch({
                type: (0, $ayVxz.Actions).SetSelectedContact,
                payload: {
                    name: data.result.fullName,
                    company_name: data.result.company.name
                }
            });
            setContact(data.result);
        }
    }, [
        data
    ]);
    const handleToContactsOverview = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).ResetSelectedContact
        });
        history((0, $b1v75.AuthRoutes).Contacts);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ahwrv.default), {
                handleToOverview: handleToContactsOverview,
                navName: (0, $b1v75.RouteNames).Contacts,
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize",
                    sx: {
                        gap: "5px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $5HWve.default), {}),
                        state.selectedContact?.name || contact?.fullName,
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                            sx: {
                                borderRight: `1px solid ${(0, $6L9uu.Colors).white}`,
                                width: "1px",
                                height: "100%"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bwbWe.default), {}),
                        state.selectedContact?.company_name || contact?.company.name
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eBMvL.default), {
                        value: value,
                        handleChange: handleChange,
                        tabProps: [
                            {
                                id: "contact-details",
                                title: "Details",
                                icon: (0, $8jEtO.default)
                            }
                        ]
                    }),
                    contact && /*#__PURE__*/ (0, $ih19M.jsx)((0, $7cfBj.default), {
                        contact: contact
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                loading: loading
            })
        ]
    });
};
var $c1bdcf04b6aea5c3$export$2e2bcd8739ae039 = $c1bdcf04b6aea5c3$var$ContactDetails;

});
parcelRegister("5HWve", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $427e595889b6443a$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $427e595889b6443a$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4"
}), "PersonRounded");

});

parcelRegister("7cfBj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9be170ac21837f15$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");

var $bh6RR = parcelRequire("bh6RR");

var $eBMvL = parcelRequire("eBMvL");

var $5DXc5 = parcelRequire("5DXc5");

var $j5ie7 = parcelRequire("j5ie7");

var $hUWBI = parcelRequire("hUWBI");

var $kX3J4 = parcelRequire("kX3J4");

var $6b2Pw = parcelRequire("6b2Pw");

var $jbKiD = parcelRequire("jbKiD");

var $6bE0k = parcelRequire("6bE0k");
const $9be170ac21837f15$var$ContactDetailsTabs = ({ contact: contact })=>{
    const [value, setValue] = (0, $bh6RR.useState)(0);
    const handleChange = (_, newValue)=>{
        setValue(newValue);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        className: "centralize",
        sx: {
            width: "100%",
            paddingTop: "80px"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5DXc5.default), {
            width: "82%",
            additionalStyle: {
                height: "680px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $eBMvL.default), {
                    type: "third",
                    value: value,
                    handleChange: handleChange,
                    tabProps: [
                        {
                            id: "contact-general-tab",
                            title: "General"
                        },
                        {
                            id: "contact-office-tab",
                            title: "Office"
                        },
                        {
                            id: "contact-interests-tab",
                            title: "Interests"
                        },
                        {
                            id: "contact-assistant-tab",
                            title: "Assistant"
                        },
                        {
                            id: "contact-meetings-tab",
                            title: "Meetings"
                        }
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                    value: value,
                    index: 0,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kX3J4.default), {
                        contact: contact
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                    value: value,
                    index: 1,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $jbKiD.default), {
                        contact: contact
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                    value: value,
                    index: 2,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $6b2Pw.default), {
                        id: contact.id
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                    value: value,
                    index: 3,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hUWBI.default), {
                        contact: contact
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                    value: value,
                    index: 4,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $6bE0k.default), {
                        contact: contact
                    })
                })
            ]
        })
    });
};
var $9be170ac21837f15$export$2e2bcd8739ae039 = $9be170ac21837f15$var$ContactDetailsTabs;

});
parcelRegister("hUWBI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $243fa5b835127fdf$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $1dAUG = parcelRequire("1dAUG");
var $aPODr = parcelRequire("aPODr");
var $5HWve = parcelRequire("5HWve");
var $lddg5 = parcelRequire("lddg5");

var $chLJv = parcelRequire("chLJv");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $6L9uu = parcelRequire("6L9uu");

var $d13i8 = parcelRequire("d13i8");

var $bSbwb = parcelRequire("bSbwb");

var $1ZlXU = parcelRequire("1ZlXU");

var $bilGR = parcelRequire("bilGR");

var $ehzwo = parcelRequire("ehzwo");
const $243fa5b835127fdf$var$ContactAssistantTab = ({ contact: contact })=>{
    const [editable, setEditable] = (0, $bh6RR.useState)(false);
    const [assistantOptions, setAssistantOptions] = (0, $bh6RR.useState)([]);
    const [assistant, setAssistant] = (0, $bh6RR.useState)(contact.assistant);
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Contact);
    const [getPossibleAssistants, getPossibleAssistantsResult] = (0, $hjfla.useAssistantContactsFromSameCompanyLazyQuery)();
    const [updateAssistant, updateAssistantResult] = (0, $hjfla.useUpdateContactAssistantMutation)();
    (0, $bh6RR.useEffect)(()=>{
        if (getPossibleAssistantsResult.data && getPossibleAssistantsResult.data.result) setAssistantOptions(getPossibleAssistantsResult.data.result);
    }, [
        getPossibleAssistantsResult
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (updateAssistantResult.data && updateAssistantResult.data.result) {
            setEditable(false);
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: `Successfully updated ${updateAssistantResult.data.result.fullName} assistant`,
                    severity: "success"
                }
            });
        }
    }, [
        updateAssistantResult.data
    ]);
    const handleCancel = ()=>{
        setEditable(false);
        setAssistant(contact.assistant);
    };
    const handleSave = ()=>{
        if (contact.assistant?.id !== assistant?.id) updateAssistant({
            variables: {
                id: parseInt(contact.id),
                assistantId: assistant !== null ? parseInt(assistant?.id) : null
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        });
        else setEditable(false);
    };
    const handleAssistantChanged = (_, newValue)=>{
        setAssistant(newValue);
    };
    const handleEditClicked = ()=>{
        getPossibleAssistants({
            variables: {
                id: parseInt(contact.id),
                company_id: parseInt(contact.company.id)
            }
        });
        setEditable(true);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            padding: "80px 25%",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    position: "absolute",
                    top: "24px",
                    right: "24px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "contact-assistant-edit-button",
                    onClick: handleEditClicked,
                    disabled: !canEdit || editable,
                    editButtonColor: !canEdit || editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "flex",
                    flexFlow: "column",
                    gap: "50px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                        id: "contact-assistant-name",
                        label: "Assistant",
                        options: assistantOptions,
                        getOptionLabel: (option)=>option?.fullName,
                        disabled: !editable || updateAssistantResult.loading,
                        values: assistant,
                        onChange: handleAssistantChanged,
                        startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5HWve.default), {
                            sx: {
                                marginRight: "12px",
                                color: !editable || updateAssistantResult.loading ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).main
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "contact-assistant-email",
                        label: "Email",
                        value: assistant?.email || "",
                        disabled: true,
                        startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1dAUG.default), {
                            sx: {
                                marginRight: "12px",
                                color: (0, $6L9uu.Colors).gray
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "contact-assistant-phone",
                        label: "Phone Number",
                        value: assistant?.phone_direct || "",
                        disabled: true,
                        startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aPODr.default), {
                            sx: {
                                marginRight: "12px",
                                color: (0, $6L9uu.Colors).gray
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "contact-assistant-mobile",
                        label: "Mobile",
                        value: assistant?.phone_mobile || "",
                        disabled: true,
                        startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lddg5.default), {
                            sx: {
                                marginRight: "12px",
                                color: (0, $6L9uu.Colors).gray
                            }
                        })
                    })
                ]
            }),
            editable && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    marginTop: "160px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "contact-assistant-cancel-button",
                        disabled: !editable || updateAssistantResult.loading,
                        onClick: handleCancel,
                        text: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "contact-assistant-save-button",
                        disabled: !editable || updateAssistantResult.loading,
                        onClick: handleSave,
                        text: "Save"
                    })
                ]
            })
        ]
    });
};
var $243fa5b835127fdf$export$2e2bcd8739ae039 = $243fa5b835127fdf$var$ContactAssistantTab;

});
parcelRegister("aPODr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e35f1e86741dc80$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $7e35f1e86741dc80$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02z"
}), "LocalPhone");

});

parcelRegister("lddg5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f71518bd881a9a4c$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $f71518bd881a9a4c$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M17 1.01 7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99M17 19H7V5h10z"
}), "Smartphone");

});


parcelRegister("kX3J4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42f870de5449b6d0$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $hKISe = parcelRequire("hKISe");
var $1dAUG = parcelRequire("1dAUG");
var $kso7N = parcelRequire("kso7N");
var $cSN6l = parcelRequire("cSN6l");
var $2hHIX = parcelRequire("2hHIX");

var $chLJv = parcelRequire("chLJv");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $aSEpM = parcelRequire("aSEpM");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $gFVvY = parcelRequire("gFVvY");

var $dqRXb = parcelRequire("dqRXb");

var $hsjD5 = parcelRequire("hsjD5");

var $6L9uu = parcelRequire("6L9uu");

var $gSGmk = parcelRequire("gSGmk");

var $d13i8 = parcelRequire("d13i8");

var $bSbwb = parcelRequire("bSbwb");

var $1ZlXU = parcelRequire("1ZlXU");

var $bilGR = parcelRequire("bilGR");

var $ehzwo = parcelRequire("ehzwo");

var $8d818 = parcelRequire("8d818");

var $6pynQ = parcelRequire("6pynQ");

var $dbGcj = parcelRequire("dbGcj");
const $42f870de5449b6d0$var$defaultErrorsObj = {
    firstName: null,
    lastName: null,
    titleInternal: null,
    company: null,
    email: null,
    updateError: undefined,
    interests: null
};
const $42f870de5449b6d0$var$ContactGeneralTab = ({ contact: contact })=>{
    const [getTitlesInternal, titlesInternal] = (0, $hjfla.useTitlesInternalLazyQuery)();
    const [getCompaniesNames, companiesNames] = (0, $hjfla.useCompaniesNamesLazyQuery)();
    const [updateContactDetails, updateContactDetailsResult] = (0, $hjfla.useUpdateContactDetailsMutation)();
    const [editable, setEditable] = (0, $bh6RR.useState)(false);
    const [companiesNamesOptions, setCompaniesNamesOptions] = (0, $bh6RR.useState)([]);
    const [titlesInternalOptions, setTitlesInternalOptions] = (0, $bh6RR.useState)([]);
    const [prefix, setPrefix] = (0, $bh6RR.useState)(contact.prefix || null);
    const [suffix, setSuffix] = (0, $bh6RR.useState)(contact.suffix || null);
    const [titleInternal, setTitleInternal] = (0, $bh6RR.useState)(contact.titleInternal);
    const [company, setCompany] = (0, $bh6RR.useState)(contact.company);
    const [firstName, setFirstName] = (0, $bh6RR.useState)(contact.first_name);
    const [middleName, setMiddleName] = (0, $bh6RR.useState)(contact.middle_name || "");
    const [lastName, setLastName] = (0, $bh6RR.useState)(contact.last_name);
    const [informalName, setInformalName] = (0, $bh6RR.useState)(contact.informal_name || "");
    const [titleExternal, setTitleExternal] = (0, $bh6RR.useState)(contact.title_external || "");
    const [notes, setNotes] = (0, $bh6RR.useState)(contact.notes || "");
    const [phoneDirect, setPhoneDirect] = (0, $bh6RR.useState)(contact.phone_direct || "");
    const [mobilePhone, setMobilePhone] = (0, $bh6RR.useState)(contact.phone_mobile || "");
    const [faxDirect, setFaxDirect] = (0, $bh6RR.useState)(contact.fax || "");
    const [email, setEmail] = (0, $bh6RR.useState)(contact.email || "");
    const [location, setLocation] = (0, $bh6RR.useState)(contact.location_of_contact || "");
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($42f870de5449b6d0$var$defaultErrorsObj);
    const [linkedIn, setLinkedIn] = (0, $bh6RR.useState)(contact.linkedin || "");
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Contact);
    (0, $bh6RR.useEffect)(()=>{
        if (titlesInternal.data && titlesInternal.data.result) setTitlesInternalOptions(titlesInternal.data.result);
    }, [
        titlesInternal
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (companiesNames.data && companiesNames.data.result) setCompaniesNamesOptions(companiesNames.data.result);
    }, [
        companiesNames
    ]);
    const handleEditClicked = ()=>{
        if (companiesNamesOptions.length === 0 || titlesInternalOptions.length === 0) {
            getTitlesInternal();
            getCompaniesNames();
        }
        setEditable(true);
    };
    const handleFirstNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!value || value.length < 2) setFormErrors({
            ...formErrors,
            firstName: (0, $6pynQ.ErrorTexts).firstName
        });
        else setFormErrors({
            ...formErrors,
            firstName: null
        });
        setFirstName(value);
    };
    const handleLastNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!value || value.length < 2) setFormErrors({
            ...formErrors,
            lastName: (0, $6pynQ.ErrorTexts).lastName
        });
        else setFormErrors({
            ...formErrors,
            lastName: null
        });
        setLastName(value);
    };
    const handleTitleInternalChange = (_, newValue)=>{
        if (newValue) setFormErrors({
            ...formErrors,
            titleInternal: null
        });
        else setFormErrors({
            ...formErrors,
            titleInternal: (0, $6pynQ.ErrorTexts).titleInternal
        });
        setTitleInternal(newValue);
    };
    const handleCompanyChange = (_, newValue)=>{
        if (newValue) setFormErrors({
            ...formErrors,
            company: null
        });
        else setFormErrors({
            ...formErrors,
            company: (0, $6pynQ.ErrorTexts).company
        });
        setCompany(newValue);
    };
    const handleEmailChange = (event)=>{
        const { value: value } = event.currentTarget;
        const isValidEmail = value.match((0, $gSGmk.validEmailRegex));
        if (!isValidEmail) setFormErrors({
            ...formErrors,
            email: (0, $6pynQ.ErrorTexts).email
        });
        else setFormErrors({
            ...formErrors,
            email: null
        });
        setEmail(value);
    };
    const getFullName = ()=>{
        const result = [];
        if (prefix) result.push(prefix);
        if (firstName) result.push(firstName);
        if (middleName) result.push(middleName);
        if (lastName) result.push(lastName);
        if (suffix) result.push(suffix);
        return result.join(" ");
    };
    const handleCancel = ()=>{
        setPrefix(contact.prefix || null);
        setSuffix(contact.suffix || null);
        setTitleInternal(contact.titleInternal);
        setCompany(contact.company);
        setFirstName(contact.first_name);
        setMiddleName(contact.middle_name || "");
        setLastName(contact.last_name);
        setInformalName(contact.informal_name || "");
        setTitleExternal(contact.title_external || "");
        setNotes(contact.notes || "");
        setPhoneDirect(contact.phone_direct || "");
        setMobilePhone(contact.phone_mobile || "");
        setFaxDirect(contact.fax || "");
        setEmail(contact.email || "");
        setLocation(contact.location_of_contact || "");
        setEditable(false);
        setFormErrors($42f870de5449b6d0$var$defaultErrorsObj);
        setLinkedIn(contact.linkedin || "");
    };
    const handleSave = ()=>{
        const errors = {
            company: null,
            email: null,
            firstName: null,
            lastName: null,
            titleInternal: null
        };
        let hasErrors = false;
        if (!company) {
            hasErrors = true;
            errors.company = (0, $6pynQ.ErrorTexts).company;
        }
        if (!titleInternal) {
            hasErrors = true;
            errors.titleInternal = (0, $6pynQ.ErrorTexts).titleInternal;
        }
        if (!firstName || firstName.length < 2) {
            hasErrors = true;
            errors.firstName = (0, $6pynQ.ErrorTexts).firstName;
        }
        if (!lastName || lastName.length < 2) {
            hasErrors = true;
            errors.lastName = (0, $6pynQ.ErrorTexts).lastName;
        }
        if (email) {
            if (contact.email !== email) {
                const isValidEmail = email.match((0, $gSGmk.validEmailRegex));
                if (!isValidEmail) {
                    hasErrors = true;
                    errors.email = (0, $6pynQ.ErrorTexts).email;
                }
            // Email uniqueness is checked on the backend - frontend cache check is unreliable with filtered/paginated queries
            }
        } else {
            hasErrors = true;
            errors.email = (0, $6pynQ.ErrorTexts).email;
        }
        if (hasErrors) setFormErrors(errors);
        else {
            const isNameChanged = isContactNameAndCompanyChanged();
            const nameExists = isNameChanged ? (0, $gFVvY.fullNameExists)(firstName, lastName, company?.name) : false;
            if (nameExists) dispatch({
                type: (0, $ayVxz.Actions).ShowConfirmation,
                payload: {
                    text: "There is a contact with the same first and last name. Are you sure you want to continue?",
                    agreeAction: submitContact
                }
            });
            else submitContact();
        }
    };
    const isContactNameAndCompanyChanged = ()=>{
        if (contact.first_name !== firstName) return true;
        if (contact.last_name !== lastName) return true;
        if (contact.company.id !== company?.id) return true;
        return false;
    };
    const submitContact = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        updateContactDetails({
            variables: {
                id: parseInt(contact.id),
                input: {
                    prefix: prefix,
                    first_name: firstName,
                    middle_name: middleName,
                    last_name: lastName,
                    suffix: suffix,
                    informal_name: informalName,
                    title_internal_id: parseInt(titleInternal?.id),
                    title_external: titleExternal,
                    company_id: parseInt(company?.id),
                    notes: notes,
                    phone_direct: phoneDirect,
                    phone_mobile: mobilePhone,
                    fax: faxDirect,
                    email: email,
                    location_of_contact: location,
                    linkedin: linkedIn
                }
            },
            update (_, { data: data }) {
                if (data && data.result) {
                    setEditable(false);
                    dispatch({
                        type: (0, $ayVxz.Actions).SetSelectedContact,
                        payload: {
                            name: data.result.fullName,
                            company_name: data.result.company.name
                        }
                    });
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            text: `Successfully updated ${data.result.fullName}`,
                            severity: "success",
                            autoHide: 2000
                        }
                    });
                }
            }
        }).catch((e)=>setFormErrors({
                ...formErrors,
                updateError: e.message.slice(15)
            }));
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            padding: "80px",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    position: "absolute",
                    top: "24px",
                    right: "24px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "contact-general-edit-button",
                    onClick: handleEditClicked,
                    disabled: !canEdit || editable,
                    editButtonColor: !canEdit || editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
                    gap: "60px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            gridColumn: "span 3",
                            display: "flex",
                            flexFlow: "column",
                            gap: "35px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "contact-general-prefix",
                                label: "Prefix",
                                options: (0, $aSEpM.Prefixes),
                                getOptionLabel: (option)=>option,
                                disabled: !editable,
                                values: prefix,
                                onChange: (_, value)=>setPrefix(value)
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-general-first-name",
                                label: "First Name",
                                value: firstName,
                                onChange: handleFirstNameChange,
                                disabled: !editable,
                                errorMsg: formErrors.firstName
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-general-middle-name",
                                label: "Middle Name",
                                value: middleName,
                                onChange: (e)=>setMiddleName(e.currentTarget.value),
                                disabled: !editable
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-general-last-name",
                                label: "Last Name",
                                value: lastName,
                                onChange: handleLastNameChange,
                                disabled: !editable,
                                errorMsg: formErrors.lastName
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "contact-general-suffix",
                                label: "Suffix",
                                options: (0, $aSEpM.Suffixes),
                                getOptionLabel: (option)=>option,
                                disabled: !editable,
                                values: suffix,
                                onChange: (_, value)=>setSuffix(value)
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-general-informal-name",
                                label: "Informal Name",
                                value: informalName,
                                onChange: (e)=>setInformalName(e.currentTarget.value),
                                disabled: !editable
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            gridColumn: "span 5",
                            display: "flex",
                            flexFlow: "column",
                            gap: "35px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "contact-general-title-internal",
                                label: "Title external",
                                options: titlesInternalOptions,
                                getOptionLabel: (option)=>option?.name,
                                disabled: !editable,
                                values: titleInternal,
                                onChange: handleTitleInternalChange,
                                errorMsg: formErrors.titleInternal
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-general-title-external",
                                label: "Title external",
                                value: titleExternal,
                                onChange: (e)=>setTitleExternal(e.currentTarget.value),
                                disabled: !editable
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "contact-general-company",
                                label: "Choose company",
                                options: companiesNamesOptions,
                                getOptionLabel: (option)=>option?.name,
                                disabled: !editable,
                                values: company,
                                onChange: handleCompanyChange,
                                errorMsg: formErrors.company
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-general-full-name",
                                label: "Full Name",
                                value: getFullName(),
                                disabled: true
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-general-notes",
                                label: "Notes",
                                value: notes,
                                onChange: (e)=>setNotes(e.currentTarget.value),
                                disabled: !editable,
                                multiline: true,
                                rows: 4
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            gridColumn: "span 4",
                            display: "flex",
                            flexFlow: "column",
                            gap: "35px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-general-phone-direct",
                                label: "Phone (direct)",
                                value: phoneDirect,
                                onChange: (e)=>setPhoneDirect(e.currentTarget.value),
                                disabled: !editable,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hKISe.default), {
                                    sx: {
                                        marginRight: "13px",
                                        color: (0, $hsjD5.getLabelColor)(editable)
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-general-mobile-phone",
                                label: "Mobile phone",
                                value: mobilePhone,
                                onChange: (e)=>setMobilePhone(e.currentTarget.value),
                                disabled: !editable,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $2hHIX.default), {
                                    sx: {
                                        marginRight: "13px",
                                        color: (0, $hsjD5.getLabelColor)(editable)
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-general-fax-direct",
                                label: "Fax (direct)",
                                value: faxDirect,
                                onChange: (e)=>setFaxDirect(e.currentTarget.value),
                                disabled: !editable,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cSN6l.default), {
                                    sx: {
                                        marginRight: "13px",
                                        color: (0, $hsjD5.getLabelColor)(editable)
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-general-email",
                                label: "Email (direct)",
                                value: email,
                                onChange: handleEmailChange,
                                disabled: !editable,
                                errorMsg: formErrors.email,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1dAUG.default), {
                                    sx: {
                                        marginRight: "13px",
                                        color: (0, $hsjD5.getRequiredFieldLabelColor)(editable, formErrors.email)
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-general-location",
                                label: "Location",
                                value: location,
                                onChange: (e)=>setLocation(e.currentTarget.value),
                                disabled: !editable,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kso7N.default), {
                                    sx: {
                                        marginRight: "13px",
                                        color: (0, $hsjD5.getLabelColor)(editable)
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-general-linkedIn",
                                label: "LinkedIn",
                                value: linkedIn,
                                onChange: (e)=>setLinkedIn(e.currentTarget.value),
                                disabled: !editable,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dbGcj))), {
                                    sx: {
                                        marginRight: "13px",
                                        color: (0, $hsjD5.getLabelColor)(editable)
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            editable && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    marginTop: "60px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-new-contact-button",
                        disabled: !editable,
                        onClick: handleCancel,
                        text: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "contact-general-save-button",
                        disabled: !editable,
                        onClick: handleSave,
                        text: "Save"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                loading: updateContactDetailsResult.loading
            })
        ]
    });
};
var $42f870de5449b6d0$export$2e2bcd8739ae039 = $42f870de5449b6d0$var$ContactGeneralTab;

});
parcelRegister("2hHIX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a9f1600b193c6b4$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $1a9f1600b193c6b4$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M17 1.01 7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99M17 19H7V5h10z"
}), "StayCurrentPortrait");

});

parcelRegister("aSEpM", function(module, exports) {

$parcel$export(module.exports, "Prefixes", function () { return $5184a936e6b616b7$export$626f57dc55053e3b; });
$parcel$export(module.exports, "Suffixes", function () { return $5184a936e6b616b7$export$4f0f432bdeb6118e; });
const $5184a936e6b616b7$export$626f57dc55053e3b = [
    "Dr.",
    "Dr. Ing.",
    "Drs.",
    "Drs. Ing.",
    "Hog.",
    "Ing.",
    "Ir.",
    "Ir. Drs.",
    "Mr.",
    "Mrs.",
    "Ms.",
    "Prof.",
    "Prof. Dr.",
    "Rev.",
    "Sir."
];
const $5184a936e6b616b7$export$4f0f432bdeb6118e = [
    "CFA",
    "CP",
    "MA",
    "MA MRE",
    "MBA",
    "MBE",
    "MFE",
    "MMRE",
    "MRE",
    "MSRE",
    "OBE",
    "PE MFE",
    "PhD",
    "PMFE",
    "RA",
    "RBA"
];

});

parcelRegister("6pynQ", function(module, exports) {

$parcel$export(module.exports, "ErrorTexts", function () { return $45732ece044a297f$export$1067ba46601ca091; });
$parcel$export(module.exports, "default", function () { return $45732ece044a297f$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $aSEpM = parcelRequire("aSEpM");

var $hjfla = parcelRequire("hjfla");

var $gFVvY = parcelRequire("gFVvY");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hsjD5 = parcelRequire("hsjD5");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");
var $ePpmI = parcelRequire("ePpmI");

var $bilGR = parcelRequire("bilGR");

var $ehzwo = parcelRequire("ehzwo");

var $hKISe = parcelRequire("hKISe");
var $1dAUG = parcelRequire("1dAUG");
var $kso7N = parcelRequire("kso7N");
var $cSN6l = parcelRequire("cSN6l");
var $2hHIX = parcelRequire("2hHIX");

var $dbGcj = parcelRequire("dbGcj");

var $6L9uu = parcelRequire("6L9uu");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $eldXE = parcelRequire("eldXE");

var $gSGmk = parcelRequire("gSGmk");
const $45732ece044a297f$export$1067ba46601ca091 = {
    company: "Company is required",
    titleInternal: "Title internal is required",
    email: "Invalid email",
    emailExists: "Email is taken",
    firstName: "First name too short",
    lastName: "Last name too short",
    interests: "*Please select at least one interest"
};
const $45732ece044a297f$var$defaultErrorsObj = {
    firstName: null,
    lastName: null,
    titleInternal: null,
    company: null,
    email: null,
    interests: null
};
const $45732ece044a297f$var$NewContact = ({ handleClose: handleClose })=>{
    // const classes = useStyles();
    const titlesInternal = (0, $hjfla.useTitlesInternalQuery)();
    const companies = (0, $hjfla.useCompaniesNamesQuery)();
    const interests = (0, $hjfla.useGetInterestsQuery)({
        fetchPolicy: "no-cache"
    });
    const [allInterests, setAllInterests] = (0, $bh6RR.useState)([]);
    const [prefix, setPrefix] = (0, $bh6RR.useState)(null);
    const [suffix, setSuffix] = (0, $bh6RR.useState)(null);
    const [titleInternal, setTitleInternal] = (0, $bh6RR.useState)(null);
    const [company, setCompany] = (0, $bh6RR.useState)(null);
    const [firstName, setFirstName] = (0, $bh6RR.useState)("");
    const [middleName, setMiddleName] = (0, $bh6RR.useState)("");
    const [lastName, setLastName] = (0, $bh6RR.useState)("");
    const [informalName, setInformalName] = (0, $bh6RR.useState)("");
    const [titleExternal, setTitleExternal] = (0, $bh6RR.useState)("");
    const [notes, setNotes] = (0, $bh6RR.useState)("");
    const [phoneDirect, setPhoneDirect] = (0, $bh6RR.useState)("");
    const [mobilePhone, setMobilePhone] = (0, $bh6RR.useState)("");
    const [faxDirect, setFaxDirect] = (0, $bh6RR.useState)("");
    const [email, setEmail] = (0, $bh6RR.useState)("");
    const [location, setLocation] = (0, $bh6RR.useState)("");
    const [linkedIn, setLinkedIn] = (0, $bh6RR.useState)("");
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($45732ece044a297f$var$defaultErrorsObj);
    const [createContact, createContactResult] = (0, $hjfla.useCreateContactMutation)();
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [contactInterestIds, setContactInterestIds] = (0, $bh6RR.useState)([]);
    (0, $bh6RR.useEffect)(()=>{
        if (interests.data?.result) {
            const dbInterests = interests.data.result;
            setAllInterests(dbInterests);
            setContactInterestIds(dbInterests.map((i)=>i.id));
        }
    }, [
        interests.data
    ]);
    const handleCheckClicked = (interest_id)=>{
        if (contactInterestIds.includes(interest_id)) {
            setContactInterestIds(contactInterestIds.filter((id)=>id !== interest_id));
            if (contactInterestIds.length === 1 || contactInterestIds.length === 0) setFormErrors({
                ...formErrors,
                interests: $45732ece044a297f$export$1067ba46601ca091.interests
            });
        } else {
            setContactInterestIds([
                interest_id,
                ...contactInterestIds
            ]);
            setFormErrors({
                ...formErrors,
                interests: null
            });
        }
    };
    const handlePrefixChange = (_, newValue)=>{
        setPrefix(newValue);
    };
    const handleSuffixChange = (_, newValue)=>{
        setSuffix(newValue);
    };
    const handleTitleInternalChange = (_, newValue)=>{
        if (newValue) setFormErrors({
            ...formErrors,
            titleInternal: null
        });
        else setFormErrors({
            ...formErrors,
            titleInternal: $45732ece044a297f$export$1067ba46601ca091.titleInternal
        });
        setTitleInternal(newValue);
    };
    const handleCompanyChange = (_, newValue)=>{
        if (newValue) setFormErrors({
            ...formErrors,
            company: null
        });
        else setFormErrors({
            ...formErrors,
            company: $45732ece044a297f$export$1067ba46601ca091.company
        });
        setCompany(newValue);
    };
    const handleFirstNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!value || value.length < 2) setFormErrors({
            ...formErrors,
            firstName: $45732ece044a297f$export$1067ba46601ca091.firstName
        });
        else setFormErrors({
            ...formErrors,
            firstName: null
        });
        setFirstName(value);
    };
    const handleLastNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!value || value.length < 2) setFormErrors({
            ...formErrors,
            lastName: $45732ece044a297f$export$1067ba46601ca091.lastName
        });
        else setFormErrors({
            ...formErrors,
            lastName: null
        });
        setLastName(value);
    };
    const handleEmailChange = (event)=>{
        const { value: value } = event.currentTarget;
        const isValidEmail = value.match((0, $gSGmk.validEmailRegex));
        if (!isValidEmail) setFormErrors({
            ...formErrors,
            email: $45732ece044a297f$export$1067ba46601ca091.email
        });
        else setFormErrors({
            ...formErrors,
            email: null
        });
        setEmail(value);
    };
    const submitForm = ()=>{
        const errors = {
            company: null,
            email: null,
            firstName: null,
            lastName: null,
            titleInternal: null,
            interests: null
        };
        let hasErrors = false;
        if (!company) {
            hasErrors = true;
            errors.company = $45732ece044a297f$export$1067ba46601ca091.company;
        }
        if (!titleInternal) {
            hasErrors = true;
            errors.titleInternal = $45732ece044a297f$export$1067ba46601ca091.titleInternal;
        }
        if (!firstName || firstName.length < 2) {
            hasErrors = true;
            errors.firstName = $45732ece044a297f$export$1067ba46601ca091.firstName;
        }
        if (contactInterestIds.length === 0) {
            hasErrors = true;
            errors.interests = $45732ece044a297f$export$1067ba46601ca091.interests;
        }
        if (!lastName || lastName.length < 2) {
            hasErrors = true;
            errors.lastName = $45732ece044a297f$export$1067ba46601ca091.lastName;
        }
        const isValidEmail = email.match((0, $gSGmk.validEmailRegex));
        if (!isValidEmail) {
            hasErrors = true;
            errors.email = $45732ece044a297f$export$1067ba46601ca091.email;
        }
        // Email uniqueness is checked on the backend - frontend cache check is unreliable with filtered/paginated queries
        if (hasErrors) setFormErrors(errors);
        else {
            const nameExists = (0, $gFVvY.fullNameExists)(firstName, lastName, company?.name);
            if (nameExists) dispatch({
                type: (0, $ayVxz.Actions).ShowConfirmation,
                payload: {
                    text: "There is a contact with the same first and last name. Are you sure you want to continue?",
                    agreeAction: submitContact
                }
            });
            else submitContact();
        }
    };
    const submitContact = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        createContact({
            variables: {
                input: {
                    prefix: prefix,
                    first_name: firstName,
                    middle_name: middleName,
                    last_name: lastName,
                    suffix: suffix,
                    informal_name: informalName,
                    title_internal_id: parseInt(titleInternal?.id),
                    title_external: titleExternal,
                    company_id: parseInt(company?.id),
                    notes: notes,
                    phone_direct: phoneDirect,
                    phone_mobile: mobilePhone,
                    fax: faxDirect,
                    email: email,
                    location_of_contact: location,
                    interest_ids: contactInterestIds.map((i)=>parseInt(i)),
                    linkedin: linkedIn
                }
            },
            update (cache, { data: data }) {
                if (data?.result) {
                    const contactsQuery = cache.readQuery({
                        query: (0, $hjfla.ContactsDocument)
                    });
                    // Check if contactsQuery and contactsQuery.result exist before proceeding
                    if (contactsQuery && contactsQuery.result) {
                        const cacheContact = contactsQuery.result.find((c)=>c?.id === data.result.id);
                        if (!cacheContact) {
                            const newData = [
                                data.result,
                                ...contactsQuery.result
                            ];
                            cache.writeQuery({
                                query: (0, $hjfla.ContactsDocument),
                                data: {
                                    result: newData
                                }
                            });
                        }
                    } else // If no existing contacts in cache, create a new array with just this contact
                    cache.writeQuery({
                        query: (0, $hjfla.ContactsDocument),
                        data: {
                            result: [
                                data.result
                            ]
                        }
                    });
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            text: `Contact ${data.result.fullName} created`,
                            severity: "success",
                            autoHide: 2000
                        }
                    });
                    handleClose();
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "new-contact",
        width: 1400,
        title: "Create Contact",
        onClose: handleClose,
        childrenSx: {
            padding: "40px 80px"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
                    gap: "60px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            gridColumn: "span 3",
                            display: "flex",
                            flexFlow: "column",
                            gap: "35px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "contact-prefix",
                                label: "Prefix",
                                options: (0, $aSEpM.Prefixes),
                                getOptionLabel: (option)=>option,
                                disabled: createContactResult.loading,
                                values: prefix,
                                onChange: handlePrefixChange
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "first-name",
                                label: "First Name",
                                value: firstName,
                                onChange: handleFirstNameChange,
                                disabled: createContactResult.loading,
                                errorMsg: formErrors.firstName
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "middle-name",
                                label: "Middle Name",
                                value: middleName,
                                onChange: (e)=>setMiddleName(e.currentTarget.value),
                                disabled: createContactResult.loading
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "last-name",
                                label: "Last Name",
                                value: lastName,
                                onChange: handleLastNameChange,
                                disabled: createContactResult.loading,
                                errorMsg: formErrors.lastName
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "contact-suffix",
                                label: "Suffix",
                                options: (0, $aSEpM.Suffixes),
                                getOptionLabel: (option)=>option,
                                disabled: createContactResult.loading,
                                values: suffix,
                                onChange: handleSuffixChange
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "informal-name",
                                label: "Informal Name",
                                value: informalName,
                                onChange: (e)=>setInformalName(e.currentTarget.value),
                                disabled: createContactResult.loading
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            gridColumn: "span 5",
                            display: "flex",
                            flexFlow: "column",
                            gap: "35px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "title-internal",
                                label: "Title internal",
                                options: titlesInternal.data?.result || [],
                                getOptionLabel: (option)=>option?.name,
                                disabled: createContactResult.loading,
                                values: titleInternal,
                                onChange: handleTitleInternalChange,
                                errorMsg: formErrors.titleInternal
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "title-external",
                                label: "Title external",
                                value: titleExternal,
                                onChange: (e)=>setTitleExternal(e.currentTarget.value),
                                disabled: createContactResult.loading
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "company",
                                label: "Choose company",
                                options: companies.data?.result || [],
                                getOptionLabel: (option)=>option?.name,
                                disabled: createContactResult.loading,
                                values: company,
                                onChange: handleCompanyChange,
                                errorMsg: formErrors.company
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "notes",
                                label: "Notes",
                                value: notes,
                                onChange: (e)=>setNotes(e.currentTarget.value),
                                disabled: createContactResult.loading,
                                multiline: true,
                                rows: 4
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            gridColumn: "span 4",
                            display: "flex",
                            flexFlow: "column",
                            gap: "35px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "phone-direct",
                                label: "Phone (direct)",
                                value: phoneDirect,
                                onChange: (e)=>setPhoneDirect(e.currentTarget.value),
                                disabled: createContactResult.loading,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hKISe.default), {
                                    sx: {
                                        marginRight: "13px",
                                        color: (0, $hsjD5.getLabelColor)(!createContactResult.loading)
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "mobile-phone",
                                label: "Mobile phone",
                                value: mobilePhone,
                                onChange: (e)=>setMobilePhone(e.currentTarget.value),
                                disabled: createContactResult.loading,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $2hHIX.default), {
                                    sx: {
                                        marginRight: "13px",
                                        color: (0, $hsjD5.getLabelColor)(!createContactResult.loading)
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "fax-direct",
                                label: "Fax (direct)",
                                value: faxDirect,
                                onChange: (e)=>setFaxDirect(e.currentTarget.value),
                                disabled: createContactResult.loading,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cSN6l.default), {
                                    sx: {
                                        marginRight: "13px",
                                        color: (0, $hsjD5.getLabelColor)(!createContactResult.loading)
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "email",
                                label: "Email (direct)",
                                value: email,
                                onChange: handleEmailChange,
                                disabled: createContactResult.loading,
                                errorMsg: formErrors.email,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1dAUG.default), {
                                    sx: {
                                        marginRight: "13px",
                                        color: (0, $hsjD5.getRequiredFieldLabelColor)(!createContactResult.loading, formErrors.email)
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "location",
                                label: "Location",
                                value: location,
                                onChange: (e)=>setLocation(e.currentTarget.value),
                                disabled: createContactResult.loading,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kso7N.default), {
                                    sx: {
                                        marginRight: "13px",
                                        color: (0, $hsjD5.getLabelColor)(!createContactResult.loading)
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "linkedIn",
                                label: "LinkedIn",
                                value: linkedIn,
                                onChange: (e)=>setLinkedIn(e.currentTarget.value),
                                disabled: createContactResult.loading,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dbGcj))), {
                                    sx: {
                                        marginRight: "13px",
                                        color: (0, $hsjD5.getLabelColor)(!createContactResult.loading)
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    marginTop: "43px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {
                        style: {
                            background: "#69AAF34A"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            marginTop: "12px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                sx: {
                                    textAlign: "left",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    color: (0, $6L9uu.Colors).main
                                },
                                children: "ADD INTEREST"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                sx: {
                                    marginTop: "20px",
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "0 60px"
                                },
                                children: allInterests.map((i, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $eldXE.default), {
                                        id: i.id,
                                        label: i.name,
                                        value: contactInterestIds.includes(i.id),
                                        onChange: ()=>handleCheckClicked(i?.id),
                                        disabled: createContactResult.loading
                                    }, index))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    color: (0, $6L9uu.Colors).red,
                    marginTop: "20px",
                    height: "18px"
                },
                children: formErrors.interests
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    marginTop: "60px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-new-contact-button",
                        disabled: createContactResult.loading,
                        onClick: handleClose,
                        text: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "create-new-contact-button",
                        disabled: createContactResult.loading,
                        onClick: submitForm,
                        text: "Create"
                    })
                ]
            })
        ]
    });
};
var $45732ece044a297f$export$2e2bcd8739ae039 = $45732ece044a297f$var$NewContact;

});
parcelRegister("dbGcj", function(module, exports) {
"use strict";
"use client";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $999d0907c0162ae5$var$React = $999d0907c0162ae5$var$_interopRequireWildcard((parcelRequire("bh6RR")));

var $999d0907c0162ae5$var$_createSvgIcon = $2ZnTs((parcelRequire("lpAdr")));

var $ih19M = parcelRequire("ih19M");
function $999d0907c0162ae5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($999d0907c0162ae5$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $999d0907c0162ae5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $999d0907c0162ae5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
var $999d0907c0162ae5$var$_default = module.exports.default = (0, $999d0907c0162ae5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"
}), "LinkedIn");

});

parcelRegister("eldXE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09917b032050f1c3$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $7btqX = parcelRequire("7btqX");
var $bIyvl = parcelRequire("bIyvl");

var $6L9uu = parcelRequire("6L9uu");
const $09917b032050f1c3$var$CheckboxComponent = ({ id: id, label: label, value: value, onChange: onChange, disabled: disabled = false, sx: sx })=>{
    const labelWithoutSpaces = label.replaceAll(" ", "-");
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $bIyvl.default), {
        className: value ? "checked-interest" : "interest",
        control: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7btqX.default), {
            id: `${id}-${labelWithoutSpaces}-checkbox`,
            "data-testid": `${id}-${labelWithoutSpaces}-checkbox`,
            checked: value,
            onChange: onChange,
            name: `check-${labelWithoutSpaces}`,
            color: "primary",
            disabled: disabled,
            icon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                component: "span",
                sx: {
                    borderRadius: "3px",
                    width: "18px",
                    height: "18px",
                    margin: "3px",
                    backgroundColor: "#C5ECFF",
                    "&:hover": {
                        backgroundColor: "#C5ECFF"
                    },
                    "input:disabled ~ &": {
                        boxShadow: "none",
                        background: (0, $6L9uu.Colors).gray
                    }
                }
            })
        }),
        label: label,
        sx: {
            color: (0, $6L9uu.Colors).main,
            ...sx
        }
    });
};
var $09917b032050f1c3$export$2e2bcd8739ae039 = $09917b032050f1c3$var$CheckboxComponent;

});
parcelRegister("7btqX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53b06470b3da280d$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $7J7Kn = parcelRequire("7J7Kn");

var $cG3EF = parcelRequire("cG3EF");

var $jcZYJ = parcelRequire("jcZYJ");

var $7UuNW = parcelRequire("7UuNW");

var $iUvQo = parcelRequire("iUvQo");

var $hiXdf = parcelRequire("hiXdf");

var $fGH8N = parcelRequire("fGH8N");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $4YVfv = parcelRequire("4YVfv");

var $ih19M = parcelRequire("ih19M");
"use client";
const $53b06470b3da280d$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $53b06470b3da280d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            indeterminate && "indeterminate",
            `color${(0, $fGH8N.default)(color)}`,
            `size${(0, $fGH8N.default)(size)}`
        ]
    };
    const composedClasses = (0, $7J7Kn.default)(slots, (0, $4YVfv.getCheckboxUtilityClass), classes);
    return (0, $4WYaH.default)({}, classes, composedClasses);
};
const $53b06470b3da280d$var$CheckboxRoot = (0, $g4l1t.default)((0, $jcZYJ.default), {
    shouldForwardProp: (prop)=>(0, $g4l1t.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiCheckbox",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $fGH8N.default)(ownerState.size)}`],
            ownerState.color !== "default" && styles[`color${(0, $fGH8N.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cG3EF.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $4YVfv.default).checked}, &.${(0, $4YVfv.default).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $4YVfv.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $53b06470b3da280d$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ih19M.jsx)((0, $iUvQo.default), {});
const $53b06470b3da280d$var$defaultIcon = /*#__PURE__*/ (0, $ih19M.jsx)((0, $7UuNW.default), {});
const $53b06470b3da280d$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $ih19M.jsx)((0, $hiXdf.default), {});
const $53b06470b3da280d$var$Checkbox = /*#__PURE__*/ $bh6RR.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiCheckbox"
    });
    const { checkedIcon: checkedIcon = $53b06470b3da280d$var$defaultCheckedIcon, color: color = "primary", icon: iconProp = $53b06470b3da280d$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $53b06470b3da280d$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = "medium", className: className } = props, other = (0, $hCIyK.default)(props, $53b06470b3da280d$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $53b06470b3da280d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($53b06470b3da280d$var$CheckboxRoot, (0, $4WYaH.default)({
        type: "checkbox",
        inputProps: (0, $4WYaH.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $bh6RR.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $bh6RR.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $aPsoC.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $53b06470b3da280d$export$2e2bcd8739ae039 = $53b06470b3da280d$var$Checkbox;

});
parcelRegister("7UuNW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c25a880cdc6e5bb$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $5c25a880cdc6e5bb$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");

});

parcelRegister("iUvQo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc46287f4f01760d$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $dc46287f4f01760d$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");

});

parcelRegister("hiXdf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9920c8042a29f36$export$2e2bcd8739ae039; });
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $c9920c8042a29f36$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");

});

parcelRegister("4YVfv", function(module, exports) {

$parcel$export(module.exports, "getCheckboxUtilityClass", function () { return $3a092c84bce5b090$export$6c57c6e16b4063b; });
$parcel$export(module.exports, "default", function () { return $3a092c84bce5b090$export$2e2bcd8739ae039; });

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $3a092c84bce5b090$export$6c57c6e16b4063b(slot) {
    return (0, $XybB6.default)("MuiCheckbox", slot);
}
const $3a092c84bce5b090$var$checkboxClasses = (0, $igcUF.default)("MuiCheckbox", [
    "root",
    "checked",
    "disabled",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium"
]);
var $3a092c84bce5b090$export$2e2bcd8739ae039 = $3a092c84bce5b090$var$checkboxClasses;

});





parcelRegister("6b2Pw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3305bfd9cb8d6b99$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");

var $ePpmI = parcelRequire("ePpmI");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $6L9uu = parcelRequire("6L9uu");

var $d13i8 = parcelRequire("d13i8");

var $bSbwb = parcelRequire("bSbwb");

var $1ZlXU = parcelRequire("1ZlXU");

var $eldXE = parcelRequire("eldXE");
const $3305bfd9cb8d6b99$var$ContactInterestsTab = ({ id: id })=>{
    const { state: state, dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const { data: data } = (0, $hjfla.useContactInterestsQuery)({
        variables: {
            contact_id: parseInt(id)
        },
        fetchPolicy: "no-cache"
    });
    const [initialContactInterestIds, setInitialContactInterestIds] = (0, $bh6RR.useState)([]);
    const [contactInterestIds, setContactInterestIds] = (0, $bh6RR.useState)([]);
    const interestGroups = (0, $hjfla.useGetInterestGroupsQuery)();
    const [updateContactInterests, updateContactInterestsResult] = (0, $hjfla.useUpdateContactInterestsMutation)();
    const [editable, setEditable] = (0, $bh6RR.useState)(false);
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Contact);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result && data.result.length > 0) {
            setContactInterestIds(data.result.map((i)=>i?.interest_id));
            setInitialContactInterestIds(data.result.map((i)=>i?.interest_id));
        }
    }, [
        data
    ]);
    const handleEditClicked = ()=>{
        setEditable(true);
    };
    const handleCheckClicked = (interest_id)=>{
        if (contactInterestIds.includes(interest_id)) setContactInterestIds(contactInterestIds.filter((id)=>id !== interest_id));
        else setContactInterestIds([
            interest_id,
            ...contactInterestIds
        ]);
    };
    const handleCancelClicked = ()=>{
        setEditable(false);
        setContactInterestIds(initialContactInterestIds);
    };
    const handleSaveClicked = ()=>{
        setEditable(false);
        updateContactInterests({
            variables: {
                id: parseInt(id),
                interest_ids: contactInterestIds.map((i)=>parseInt(i))
            },
            update (_, { data: data }) {
                if (data?.result) {
                    setContactInterestIds(data.result);
                    setInitialContactInterestIds(data.result);
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `You have successfully updated ${state.selectedContact.name}'s interests`
                        }
                    });
                }
            }
        }).catch((e)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            }));
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            padding: "80px",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    position: "absolute",
                    top: "24px",
                    right: "24px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "contact-interest-edit-button",
                    onClick: handleEditClicked,
                    disabled: !canEdit || editable,
                    editButtonColor: !canEdit || editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    display: "flex",
                    flexFlow: "column",
                    gap: "80px"
                },
                children: interestGroups.data?.result.map((ig, index)=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                id: `interest-group-${ig?.name.replaceAll(" ", "-")}`,
                                sx: {
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    color: editable ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray
                                },
                                children: ig?.name.toUpperCase()
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                sx: {
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "0 60px"
                                },
                                children: ig?.interests.map((i, index2)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $eldXE.default), {
                                        id: i?.id || "",
                                        label: i?.name || "",
                                        value: i ? contactInterestIds.includes(i.id) : false,
                                        onChange: ()=>handleCheckClicked(i?.id),
                                        disabled: !editable
                                    }, index2))
                            }),
                            interestGroups.data && interestGroups.data?.result.length - 1 > index && /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {
                                sx: {
                                    background: "#69AAF34A",
                                    marginTop: "80px"
                                }
                            })
                        ]
                    }, index))
            }),
            editable && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    marginTop: "160px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "contact-interests-cancel-button",
                        disabled: !editable || updateContactInterestsResult.loading,
                        onClick: handleCancelClicked,
                        text: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "contact-interests-save-button",
                        disabled: !editable || updateContactInterestsResult.loading,
                        onClick: handleSaveClicked,
                        text: "Save"
                    })
                ]
            })
        ]
    });
};
var $3305bfd9cb8d6b99$export$2e2bcd8739ae039 = $3305bfd9cb8d6b99$var$ContactInterestsTab;

});

parcelRegister("jbKiD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d16ee61dc3aa657$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $hKISe = parcelRequire("hKISe");
var $ckDWJ = parcelRequire("ckDWJ");
var $bwbWe = parcelRequire("bwbWe");
var $kso7N = parcelRequire("kso7N");
var $lM6pF = parcelRequire("lM6pF");
var $cSN6l = parcelRequire("cSN6l");
var $9O6Nb = parcelRequire("9O6Nb");

var $chLJv = parcelRequire("chLJv");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $6L9uu = parcelRequire("6L9uu");

var $d13i8 = parcelRequire("d13i8");

var $bSbwb = parcelRequire("bSbwb");

var $1ZlXU = parcelRequire("1ZlXU");

var $bilGR = parcelRequire("bilGR");

var $ehzwo = parcelRequire("ehzwo");
const $4d16ee61dc3aa657$var$ContactOfficeTab = ({ contact: contact })=>{
    const [updateContactAddress, updateContactAddressResult] = (0, $hjfla.useUpdateContactAddressMutation)();
    const [getCompanyAddresses, companyAddressesResult] = (0, $hjfla.useCompanyAddressesLazyQuery)({
        fetchPolicy: "no-cache"
    });
    const [address, setAddress] = (0, $bh6RR.useState)(contact.address);
    const [addressesOptions, setAddressesOption] = (0, $bh6RR.useState)([]);
    const [editable, setEditable] = (0, $bh6RR.useState)(false);
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Contact);
    (0, $bh6RR.useEffect)(()=>{
        if (companyAddressesResult.data && companyAddressesResult.data.result) setAddressesOption(companyAddressesResult.data.result);
    }, [
        companyAddressesResult.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (updateContactAddressResult.data && updateContactAddressResult.data.result) {
            setEditable(false);
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: `Successfully updated ${updateContactAddressResult.data.result.fullName} office`,
                    severity: "success"
                }
            });
        }
    }, [
        updateContactAddressResult.data
    ]);
    const handleAddressChanged = (_, newValue)=>{
        setAddress(newValue);
    };
    const handleEditClicked = ()=>{
        getCompanyAddresses({
            variables: {
                company_id: parseInt(contact.company.id)
            }
        });
        setEditable(true);
    };
    const handleCancel = ()=>{
        setAddress(contact.address);
        setEditable(false);
    };
    const handleSave = ()=>{
        if (contact.address?.id !== address?.id) updateContactAddress({
            variables: {
                id: parseInt(contact.id),
                company_id: parseInt(contact.company.id),
                address_id: address ? parseInt(address.id) : null
            }
        }).catch((e)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: e.message,
                    severity: "error",
                    autoHide: 6000
                }
            }));
        else setEditable(false);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            padding: "80px",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    position: "absolute",
                    top: "24px",
                    right: "24px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "contact-general-edit-button",
                    onClick: handleEditClicked,
                    disabled: !canEdit || editable,
                    editButtonColor: !canEdit || editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    gap: "60px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            display: "flex",
                            flexFlow: "column",
                            gap: "50px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-office-address-name",
                                label: "Co.address Name",
                                value: address?.name || "",
                                disabled: true,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bwbWe.default), {
                                    sx: {
                                        marginRight: "12px",
                                        color: (0, $6L9uu.Colors).gray
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "contact-office-address",
                                label: "Address",
                                options: addressesOptions,
                                getOptionLabel: (option)=>option.address_name,
                                disabled: !editable || updateContactAddressResult.loading,
                                values: address,
                                onChange: handleAddressChanged,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kso7N.default), {
                                    sx: {
                                        marginRight: "12px",
                                        color: !editable || updateContactAddressResult.loading ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).main
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-office-street",
                                label: "Street",
                                value: address?.street || "",
                                disabled: true,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ckDWJ.default), {
                                    sx: {
                                        marginRight: "12px",
                                        color: (0, $6L9uu.Colors).gray
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-office-country",
                                label: "Country",
                                value: address?.country.name || "",
                                disabled: true,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9O6Nb.default), {
                                    sx: {
                                        marginRight: "12px",
                                        color: (0, $6L9uu.Colors).gray
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            display: "flex",
                            flexFlow: "column",
                            gap: "50px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-office-phone",
                                label: "Phone (direct)",
                                value: address?.phone || "",
                                disabled: true,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hKISe.default), {
                                    sx: {
                                        marginRight: "12px",
                                        color: (0, $6L9uu.Colors).gray
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-office-fax",
                                label: "Fax (direct)",
                                value: address?.fax || "",
                                disabled: true,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cSN6l.default), {
                                    sx: {
                                        marginRight: "12px",
                                        color: (0, $6L9uu.Colors).gray
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "contact-office-email",
                                label: "Email (general)",
                                value: address?.email || "",
                                disabled: true,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lM6pF.default), {
                                    sx: {
                                        marginRight: "12px",
                                        color: (0, $6L9uu.Colors).gray
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                                sx: {
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                                    gap: "60px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                        id: "contact-office-city",
                                        label: "City",
                                        value: address?.city || "",
                                        disabled: true
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                        id: "contact-office-zip",
                                        label: "ZIP Code",
                                        value: address?.zip || "",
                                        disabled: true
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            editable && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    marginTop: "160px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "contact-office-cancel-button",
                        disabled: !editable || updateContactAddressResult.loading,
                        onClick: handleCancel,
                        text: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "contact-office-save-button",
                        disabled: !editable || updateContactAddressResult.loading,
                        onClick: handleSave,
                        text: "Save"
                    })
                ]
            })
        ]
    });
};
var $4d16ee61dc3aa657$export$2e2bcd8739ae039 = $4d16ee61dc3aa657$var$ContactOfficeTab;

});
parcelRegister("ckDWJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fa656d09c763f77$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $8fa656d09c763f77$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M18 4h-2v7.9l2-2zM4 4h2v16H4zm6 0h2v4h-2zm0 6h2v4h-2zm0 6h2v4h-2zm12.56-3.41-1.15-1.15c-.59-.59-1.54-.59-2.12 0L14 16.73V20h3.27l5.29-5.29c.59-.59.59-1.54 0-2.12m-5.98 5.86h-1.03v-1.03L19 13.97 20.03 15z"
}), "EditRoad");

});

parcelRegister("9O6Nb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $723e0d5a29929443$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $723e0d5a29929443$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39"
}), "Public");

});


parcelRegister("6bE0k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03cf7817d727a7a0$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");

var $hjfla = parcelRequire("hjfla");

var $d7fM7 = parcelRequire("d7fM7");

var $5RlrN = parcelRequire("5RlrN");

var $ayVxz = parcelRequire("ayVxz");

var $bu31C = parcelRequire("bu31C");

var $2eJeT = parcelRequire("2eJeT");

var $e2ibc = parcelRequire("e2ibc");

var $oZMqz = parcelRequire("oZMqz");
const $03cf7817d727a7a0$var$ContactMeetingsTab = ({ contact: contact })=>{
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [allMeetings, setAllMeetings] = (0, $bh6RR.useState)([]);
    const [openContactMeetingForm, setOpenContactMeetingForm] = (0, $bh6RR.useState)(false);
    const [selectedMeeting, setSelectedMeeting] = (0, $bh6RR.useState)(null);
    const [deleteMeeting] = (0, $hjfla.useDeleteMeetingMutation)();
    const { data: data, loading: loading } = (0, $hjfla.useAllMeetingsForContactQuery)({
        variables: {
            contact_id: Number(contact.id)
        },
        fetchPolicy: "no-cache"
    });
    const handleAddMeeting = (meeting)=>{
        setAllMeetings([
            meeting,
            ...allMeetings || []
        ]);
    };
    const handleEdit = (editedMeeting)=>{
        setAllMeetings(allMeetings?.map((m)=>m?.id === editedMeeting.id ? editedMeeting : m));
    };
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            const all = data.result;
            setAllMeetings(all);
        }
    }, [
        data
    ]);
    const handleDetails = (rowData)=>{
        setSelectedMeeting(rowData);
        setOpenContactMeetingForm(true);
    };
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${rowData.name}?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleDelete = (rowData)=>{
        if (!rowData.id) return;
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteMeeting({
            variables: {
                id: rowData.id
            },
            update (_, { data: data }) {
                if (data?.result) {
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            text: `Meeting deleted ${rowData.name}`,
                            severity: "success"
                        }
                    });
                    const filteredMeetings = allMeetings?.filter((m)=>m?.id !== rowData.id);
                    setAllMeetings(filteredMeetings);
                }
            }
        }).catch((error)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: error.message,
                    severity: "error",
                    autoHide: 6000
                }
            });
        });
    };
    const formatDate = (rowData, name)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return rowData[name] ? // @ts-ignore
        (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(parseInt(rowData[name])).format((0, $e2ibc.DATE_TIME_FORMATS).DATE_AND_TIME) : "";
    };
    const columns = [
        {
            title: "Details",
            sorting: false,
            width: 51
        },
        {
            title: "Meeting Name",
            field: "name",
            width: 51
        },
        {
            title: "Location",
            field: "location",
            width: 51
        },
        {
            title: "Subject",
            field: "subject",
            width: 51
        },
        {
            title: "Type",
            field: "meeting_type.name",
            width: 51
        },
        {
            title: "Start Time",
            field: "start_time",
            width: 51,
            type: "date",
            render: (rowData)=>formatDate(rowData, "start_time")
        },
        {
            title: "End Time",
            field: "end_time",
            width: 51,
            type: "date",
            render: (rowData)=>formatDate(rowData, "end_time")
        },
        {
            title: "Duration",
            field: "duration",
            width: 51,
            type: "date",
            render: (rowData)=>(0, $oZMqz.calculateMeetingDuration)(formatDate(rowData, "start_time"), formatDate(rowData, "end_time"))
        },
        {
            title: "Remove",
            sorting: false,
            width: 70
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        className: "overviewPage",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            className: "print\\:w-full",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                    columns: columns,
                    data: allMeetings || [],
                    loading: loading,
                    handleDetails: handleDetails,
                    handleRemove: handleRemove,
                    pageSize: 15,
                    createButtonProps: {
                        id: "create-contact-meeting-button",
                        onClick: ()=>setOpenContactMeetingForm(true),
                        text: "Create Meeting"
                    }
                }),
                openContactMeetingForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $5RlrN.default), {
                    handleClose: ()=>{
                        setOpenContactMeetingForm(false);
                        setSelectedMeeting(null);
                    },
                    meetingInput: selectedMeeting,
                    contactId: Number(contact.id),
                    updateList: handleAddMeeting,
                    editList: handleEdit
                })
            ]
        })
    });
};
var $03cf7817d727a7a0$export$2e2bcd8739ae039 = $03cf7817d727a7a0$var$ContactMeetingsTab;

});
parcelRegister("5RlrN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ee9774a9c235a71$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $bu31C = parcelRequire("bu31C");

var $gFVvY = parcelRequire("gFVvY");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");
var $gu8wR = parcelRequire("gu8wR");
var $dNs2U = parcelRequire("dNs2U");

var $bSbwb = parcelRequire("bSbwb");

var $6L9uu = parcelRequire("6L9uu");

var $ehzwo = parcelRequire("ehzwo");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $bilGR = parcelRequire("bilGR");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");

var $gF9d2 = parcelRequire("gF9d2");

var $8jEtO = parcelRequire("8jEtO");

var $ayVxz = parcelRequire("ayVxz");
parcelRequire("egIx1");
var $evoXX = parcelRequire("evoXX");

var $cxTnx = parcelRequire("cxTnx");
const $1ee9774a9c235a71$var$defaultErrorsObj = {
    name: null,
    meetingType: null,
    date: null,
    startTime: null,
    endTime: null
};
const $1ee9774a9c235a71$var$errorTexts = {
    name: "Name is required!",
    meetingType: "Meeting Type is required!",
    date: "Select date",
    startTime: "Select start time",
    startTimeInPast: "Selected time should not be in the past",
    endTime: "Select end time",
    endTimeInPast: "Selected time should not be in the past",
    endTimeBeforeStart: "The end time should not be before start time"
};
const $1ee9774a9c235a71$var$NewMeeting = ({ handleClose: handleClose, meetingInput: meetingInput, contactId: contactId, updateList: updateList, editList: editList })=>{
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($1ee9774a9c235a71$var$defaultErrorsObj);
    const meetingTypes = (0, $hjfla.useMeetingsMeetingTypeQuery)();
    // Use cache-first to avoid refetching all contacts if already cached
    const contactsOptions = (0, $hjfla.useContactsQuery)({
        fetchPolicy: "cache-first"
    });
    const [editable, setEditable] = (0, $bh6RR.useState)(meetingInput === null);
    const [name, setName] = (0, $bh6RR.useState)(meetingInput?.name || "");
    const [subject, setSubject] = (0, $bh6RR.useState)(meetingInput?.subject || null);
    const [meetingType, setMeetingType] = (0, $bh6RR.useState)(meetingInput?.meeting_type || null);
    const [meetingDetails, setMeetingDetails] = (0, $bh6RR.useState)(meetingInput?.meeting_details || null);
    const [location, setLocation] = (0, $bh6RR.useState)(meetingInput?.location || null);
    const [date, setDate] = (0, $bh6RR.useState)((0, $gFVvY.parseDate)(meetingInput?.start_time) || null);
    const [startTime, setStartTime] = (0, $bh6RR.useState)((0, $gFVvY.parseDate)(meetingInput?.start_time) || null);
    const [endTime, setEndTime] = (0, $bh6RR.useState)((0, $gFVvY.parseDate)(meetingInput?.end_time) || null);
    const [contacts, setContacts] = (0, $bh6RR.useState)(meetingInput?.contacts || []);
    const [createMeeting, createMeetingResult] = (0, $hjfla.useCreateMeetingMutation)();
    const [updateMeeting, updateMeetingResult] = (0, $hjfla.useUpdateMeetingMutation)();
    const handleNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value && value.length > 0) setFormErrors({
            ...formErrors,
            name: null
        });
        else setFormErrors({
            ...formErrors,
            name: $1ee9774a9c235a71$var$errorTexts.name
        });
        setName(value);
    };
    const handleDateChange = (dateInput)=>{
        if (dateInput === null) setFormErrors({
            ...formErrors,
            date: $1ee9774a9c235a71$var$errorTexts.date
        });
        setDate(dateInput);
    };
    const handleStartTimeChange = (timeInput)=>{
        if (timeInput !== null) setFormErrors({
            ...formErrors,
            startTime: null
        });
        setStartTime(timeInput);
    };
    const handleEndTimeChange = (timeInput)=>{
        if (timeInput !== null) {
            setFormErrors({
                ...formErrors,
                endTime: null
            });
            if (date) {
                if (startTime) {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(timeInput).isSameOrBefore(startTime)) setFormErrors({
                        ...formErrors,
                        endTime: $1ee9774a9c235a71$var$errorTexts.endTimeBeforeStart
                    });
                }
            } else setFormErrors({
                ...formErrors,
                endTime: $1ee9774a9c235a71$var$errorTexts.endTimeInPast
            });
        }
        setEndTime(timeInput);
    };
    const handleSubjectChange = (event)=>{
        const { value: value } = event.currentTarget;
        setSubject(value);
    };
    const handleLocationChange = (event)=>{
        const { value: value } = event.currentTarget;
        setLocation(value);
    };
    const handleMeetingTypeChange = (_, newValue)=>{
        setFormErrors({
            ...formErrors,
            meetingType: newValue === null ? $1ee9774a9c235a71$var$errorTexts.meetingType : null
        });
        setMeetingType(newValue);
    };
    const handleContactsChange = (_, contacts)=>{
        setContacts(contacts);
    };
    const takeContactIds = (contacts)=>{
        const contactIds = contacts.map((c)=>c.id);
        return contactIds;
    };
    const handleSave = ()=>{
        let hasErrors = false;
        const errs = {
            name: null,
            meetingType: null,
            date: null,
            startTime: null,
            endTime: null
        };
        if (name.length < 2) {
            hasErrors = true;
            errs.name = $1ee9774a9c235a71$var$errorTexts.name;
        }
        if (meetingType === null) {
            hasErrors = true;
            errs.meetingType = $1ee9774a9c235a71$var$errorTexts.meetingType;
        }
        if (date === null) {
            hasErrors = true;
            errs.date = $1ee9774a9c235a71$var$errorTexts.date;
        }
        if (startTime === null) {
            hasErrors = true;
            errs.startTime = $1ee9774a9c235a71$var$errorTexts.startTime;
        }
        if (endTime === null) {
            hasErrors = true;
            errs.endTime = $1ee9774a9c235a71$var$errorTexts.endTime;
        }
        if (hasErrors) setFormErrors(errs);
        else sumbitMeeting();
    };
    const sumbitMeeting = ()=>{
        const meetingStartDateTime = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), startTime.getHours(), startTime.getMinutes(), 0, 0));
        const meetingEndDateTime = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), endTime.getHours(), endTime.getMinutes(), 0, 0));
        const input = {
            name: name,
            subject: subject,
            meeting_type_id: Number(meetingType?.id),
            meeting_details: meetingDetails,
            location: location,
            start_time: (0, $gFVvY.getNullableDateString)(meetingStartDateTime),
            end_time: (0, $gFVvY.getNullableDateString)(meetingEndDateTime),
            contacts: contacts.map((c)=>Number(c.id))
        };
        // Only include contact_id if contactId is provided (for contacts tab)
        if (contactId !== undefined) input.contact_id = contactId;
        if (meetingInput !== null) updateMeeting({
            variables: {
                id: meetingInput.id,
                input: input
            },
            update (_, { data: data }) {
                if (data?.result) {
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `You have successfully updated ${data.result.name}'s meeting data`
                        }
                    });
                    handleClose();
                    editList(data?.result);
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        });
        else createMeeting({
            variables: {
                input: input
            },
            update (_, { data: data }) {
                if (data?.result) {
                    // Only call updateList if provided (for components without subscriptions)
                    if (updateList) updateList(data.result);
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `Meeting ${input.name} created`
                        }
                    });
                    handleClose();
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "contact-meeting-form",
        "data-testid": "contact-meeting-form",
        title: meetingInput ? "Meeting Details" : "Create Meeting",
        width: 1400,
        height: 940,
        onClose: handleClose,
        children: [
            meetingInput && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    position: "absolute",
                    right: "24px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "contact-meeting-form-edit-button",
                    onClick: ()=>setEditable(true),
                    disabled: editable,
                    editButtonColor: editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "flex",
                    mt: "46px",
                    px: "3.93%",
                    gap: "3.78%"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "45px",
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                            sx: {
                                display: "grid",
                                gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                                gap: "66px 22px",
                                padding: "22px 22px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "contact-meeting-form-name",
                                    label: "Meeting Name",
                                    value: name || "",
                                    onChange: handleNameChange,
                                    errorMsg: formErrors.name,
                                    additionalStyle: {
                                        gridColumn: "span 2"
                                    },
                                    disabled: !editable || createMeetingResult.loading || updateMeetingResult.loading
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "contact-meeting-form-subject",
                                    label: "Subject",
                                    value: subject || "",
                                    onChange: handleSubjectChange,
                                    additionalStyle: {
                                        gridColumn: "span 2"
                                    },
                                    disabled: !editable || createMeetingResult.loading || updateMeetingResult.loading
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                    id: "contact-meeting-form-type",
                                    label: "Meeting Type",
                                    options: meetingTypes.data?.result ?? [],
                                    getOptionLabel: (option)=>option.name,
                                    values: meetingType,
                                    onChange: handleMeetingTypeChange,
                                    errorMsg: formErrors.meetingType,
                                    additionalStyle: {
                                        gridColumn: "span 2"
                                    },
                                    disabled: !editable || createMeetingResult.loading || updateMeetingResult.loading
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "contact-meeting-form-location",
                                    label: "Location",
                                    value: location || "",
                                    onChange: handleLocationChange,
                                    additionalStyle: {
                                        gridColumn: "span 2"
                                    },
                                    disabled: !editable || createMeetingResult.loading || updateMeetingResult.loading
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $e4eIN.LocalizationProvider), {
                                    dateAdapter: (0, $1Dn8S.AdapterDateFns),
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                            id: "contact-meeting-form-date",
                                            label: "Date",
                                            value: date,
                                            format: "dd/MM/yyyy",
                                            onChange: (d)=>handleDateChange(d),
                                            disabled: !editable || createMeetingResult.loading || updateMeetingResult.loading,
                                            errorMsg: formErrors.date,
                                            sx: {
                                                gridColumn: "span 2"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $gF9d2.default), {
                                            id: "contact-meeting-form-start-time",
                                            label: "Start Time",
                                            value: startTime,
                                            onChange: (t)=>handleStartTimeChange(t),
                                            disabled: !editable || createMeetingResult.loading || updateMeetingResult.loading,
                                            errorMsg: formErrors.startTime,
                                            sx: {
                                                gridColumn: "span 3"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                            id: "contact-meeting-form-start-time-info",
                                            "data-testid": "contact-meeting-form-start-time-info",
                                            value: `Based on UTC`,
                                            disabled: true,
                                            fullWidth: true,
                                            sx: {
                                                gridColumn: "span 1"
                                            },
                                            startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8jEtO.default), {
                                                sx: {
                                                    width: "17px",
                                                    height: "17px",
                                                    marginTop: "-3px",
                                                    paddingRight: "3px"
                                                }
                                            }),
                                            inputProps: {
                                                style: {
                                                    fontSize: "12px",
                                                    fontFamily: "Overpass"
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $gF9d2.default), {
                                            id: "contact-meeting-form-end-time",
                                            label: "End Time",
                                            value: endTime,
                                            onChange: (t)=>handleEndTimeChange(t),
                                            disabled: !editable || createMeetingResult.loading || updateMeetingResult.loading,
                                            errorMsg: formErrors.endTime,
                                            sx: {
                                                gridColumn: "span 3"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                            id: "contact-meeting-form-end-time-info",
                                            "data-testid": "contact-meeting-form-end-time-info",
                                            value: `Based on UTC`,
                                            disabled: true,
                                            sx: {
                                                gridColumn: "span 1"
                                            },
                                            fullWidth: true,
                                            startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8jEtO.default), {
                                                sx: {
                                                    width: "17px",
                                                    height: "17px",
                                                    marginTop: "-3px",
                                                    paddingRight: "3px"
                                                }
                                            }),
                                            inputProps: {
                                                style: {
                                                    fontSize: "12px",
                                                    fontFamily: "Overpass"
                                                }
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                    id: "contact-meeting-form-contacts",
                                    label: "Contacts",
                                    options: contactsOptions.data?.result.filter((c)=>!takeContactIds(contacts).includes(c?.id)) || [],
                                    values: contacts.filter((c)=>contactId === undefined || Number(c.id) !== contactId),
                                    isSingle: false,
                                    onChange: handleContactsChange,
                                    getOptionLabel: (option)=>option.fullName,
                                    disabled: !editable || createMeetingResult.loading || updateMeetingResult.loading,
                                    additionalStyle: {
                                        gridColumn: "span 4"
                                    },
                                    renderTags: (value, getTagProps)=>value.map((option, index)=>// eslint-disable-next-line react/jsx-key
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                                                sx: {
                                                    backgroundColor: (0, $6L9uu.Colors).white,
                                                    color: (0, $6L9uu.Colors).main,
                                                    "& .MuiChip-deleteIcon": {
                                                        width: "20px",
                                                        height: "20px",
                                                        color: (0, $6L9uu.Colors).skyBlue,
                                                        "&:hover": {
                                                            color: (0, $6L9uu.Colors).main
                                                        }
                                                    }
                                                },
                                                variant: "outlined",
                                                label: `${option.fullName}`,
                                                ...getTagProps({
                                                    index: index
                                                })
                                            }))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            width: "100%",
                            padding: "22px 22px"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $evoXX.Editor), {
                            apiKey: "t5l2zdfj93i0j7jhpf2arppkijlh4uu5a21w93j5i8d4ehkf",
                            disabled: !editable || createMeetingResult.loading || updateMeetingResult.loading,
                            initialValue: meetingInput?.meeting_details ?? "",
                            value: meetingDetails || "",
                            onEditorChange: (newValue)=>setMeetingDetails(newValue),
                            init: {
                                plugins: "link image preview imagetools code ",
                                toolbar: "undo redo | bold italic underline | fontselect | alignleft aligncenter alignright | image link | preview",
                                visual: false
                            }
                        })
                    })
                ]
            }),
            editable && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    gridColumn: "span 3",
                    mt: "40px",
                    mb: "20px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-document-form-button",
                        onClick: handleClose,
                        disabled: !editable || createMeetingResult.loading || updateMeetingResult.loading,
                        text: meetingInput === null || editable ? "Cancel" : "Close"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "save-document-form-button",
                        onClick: handleSave,
                        disabled: !editable || createMeetingResult.loading || updateMeetingResult.loading,
                        text: meetingInput === null ? "Create" : "Save"
                    })
                ]
            })
        ]
    });
};
var $1ee9774a9c235a71$export$2e2bcd8739ae039 = $1ee9774a9c235a71$var$NewMeeting;

});
parcelRegister("egIx1", function(module, exports) {

$parcel$export(module.exports, "Editor", function () { return (parcelRequire("evoXX")).Editor; });

var $evoXX = parcelRequire("evoXX");

});
parcelRegister("evoXX", function(module, exports) {

$parcel$export(module.exports, "Editor", function () { return $a8f753ae4a7af26a$export$7cda8d932e2f33c0; });

var $bh6RR = parcelRequire("bh6RR");

var $cQa4K = parcelRequire("cQa4K");

var $0fR6P = parcelRequire("0fR6P");

var $8PvuF = parcelRequire("8PvuF");

var $35Wql = parcelRequire("35Wql");
var $a8f753ae4a7af26a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a8f753ae4a7af26a$var$__assign = undefined && undefined.__assign || function() {
    $a8f753ae4a7af26a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a8f753ae4a7af26a$var$__assign.apply(this, arguments);
};
var $a8f753ae4a7af26a$export$7cda8d932e2f33c0 = /** @class */ function(_super) {
    $a8f753ae4a7af26a$var$__extends(Editor, _super);
    function Editor(props) {
        var _a, _b, _c;
        var _this = _super.call(this, props) || this;
        _this.rollbackTimer = undefined;
        _this.valueCursor = undefined;
        _this.rollbackChange = function() {
            var editor = _this.editor;
            var value = _this.props.value;
            if (editor && value && value !== _this.currentContent) editor.undoManager.ignore(function() {
                editor.setContent(value);
                // only restore cursor on inline editors when they are focused
                // as otherwise it will cause a focus grab
                if (_this.valueCursor && (!_this.inline || editor.hasFocus())) try {
                    editor.selection.moveToBookmark(_this.valueCursor);
                } catch (e) {}
            });
            _this.rollbackTimer = undefined;
        };
        _this.handleBeforeInput = function(_evt) {
            if (_this.props.value !== undefined && _this.props.value === _this.currentContent && _this.editor) {
                if (!_this.inline || _this.editor.hasFocus()) try {
                    // getBookmark throws exceptions when the editor has not been focused
                    // possibly only in inline mode but I'm not taking chances
                    _this.valueCursor = _this.editor.selection.getBookmark(3);
                } catch (e) {}
            }
        };
        _this.handleBeforeInputSpecial = function(evt) {
            if (evt.key === "Enter" || evt.key === "Backspace" || evt.key === "Delete") _this.handleBeforeInput(evt);
        };
        _this.handleEditorChange = function(_evt) {
            var editor = _this.editor;
            if (editor && editor.initialized) {
                var newContent = editor.getContent();
                if (_this.props.value !== undefined && _this.props.value !== newContent && _this.props.rollback !== false) // start a timer and revert to the value if not applied in time
                {
                    if (!_this.rollbackTimer) _this.rollbackTimer = window.setTimeout(_this.rollbackChange, typeof _this.props.rollback === "number" ? _this.props.rollback : 200);
                }
                if (newContent !== _this.currentContent) {
                    _this.currentContent = newContent;
                    if ((0, $8PvuF.isFunction)(_this.props.onEditorChange)) _this.props.onEditorChange(newContent, editor);
                }
            }
        };
        _this.handleEditorChangeSpecial = function(evt) {
            if (evt.key === "Backspace" || evt.key === "Delete") _this.handleEditorChange(evt);
        };
        _this.initialise = function(attempts) {
            var _a, _b, _c;
            if (attempts === void 0) attempts = 0;
            var target = _this.elementRef.current;
            if (!target) return; // Editor has been unmounted
            if (!(0, $8PvuF.isInDoc)(target)) {
                // this is probably someone trying to help by rendering us offscreen
                // but we can't do that because the editor iframe must be in the document
                // in order to have state
                if (attempts === 0) // we probably just need to wait for the current events to be processed
                setTimeout(function() {
                    return _this.initialise(1);
                }, 1);
                else if (attempts < 100) // wait for ten seconds, polling every tenth of a second
                setTimeout(function() {
                    return _this.initialise(attempts + 1);
                }, 100);
                else // give up, at this point it seems that more polling is unlikely to help
                throw new Error("tinymce can only be initialised when in a document");
                return;
            }
            var tinymce = (0, $0fR6P.getTinymce)(_this.view);
            if (!tinymce) throw new Error("tinymce should have been loaded into global scope");
            var finalInit = $a8f753ae4a7af26a$var$__assign($a8f753ae4a7af26a$var$__assign({}, _this.props.init), {
                selector: undefined,
                target: target,
                readonly: _this.props.disabled,
                inline: _this.inline,
                plugins: (0, $8PvuF.mergePlugins)((_a = _this.props.init) === null || _a === void 0 ? void 0 : _a.plugins, _this.props.plugins),
                toolbar: (_b = _this.props.toolbar) !== null && _b !== void 0 ? _b : (_c = _this.props.init) === null || _c === void 0 ? void 0 : _c.toolbar,
                setup: function(editor) {
                    _this.editor = editor;
                    _this.bindHandlers({});
                    // When running in inline mode the editor gets the initial value
                    // from the innerHTML of the element it is initialized on.
                    // However we don't want to take on the responsibility of sanitizing
                    // to remove XSS in the react integration so we have a chicken and egg
                    // problem... We avoid it by sneaking in a set content before the first
                    // "official" setContent and using TinyMCE to do the sanitization.
                    if (_this.inline && !(0, $8PvuF.isTextareaOrInput)(target)) editor.once("PostRender", function(_evt) {
                        editor.setContent(_this.getInitialValue(), {
                            no_events: true
                        });
                    });
                    if (_this.props.init && (0, $8PvuF.isFunction)(_this.props.init.setup)) _this.props.init.setup(editor);
                },
                init_instance_callback: function(editor) {
                    var _a, _b;
                    // check for changes that happened since tinymce.init() was called
                    var initialValue = _this.getInitialValue();
                    _this.currentContent = (_a = _this.currentContent) !== null && _a !== void 0 ? _a : editor.getContent();
                    if (_this.currentContent !== initialValue) {
                        _this.currentContent = initialValue;
                        // same as resetContent in TinyMCE 5
                        editor.setContent(initialValue);
                        editor.undoManager.clear();
                        editor.undoManager.add();
                        editor.setDirty(false);
                    }
                    var disabled = (_b = _this.props.disabled) !== null && _b !== void 0 ? _b : false;
                    (0, $8PvuF.setMode)(_this.editor, disabled ? "readonly" : "design");
                    // ensure existing init_instance_callback is called
                    if (_this.props.init && (0, $8PvuF.isFunction)(_this.props.init.init_instance_callback)) _this.props.init.init_instance_callback(editor);
                }
            });
            if (!_this.inline) target.style.visibility = "";
            if ((0, $8PvuF.isTextareaOrInput)(target)) target.value = _this.getInitialValue();
            tinymce.init(finalInit);
        };
        _this.id = _this.props.id || (0, $8PvuF.uuid)("tiny-react");
        _this.elementRef = $bh6RR.createRef();
        _this.inline = (_c = (_a = _this.props.inline) !== null && _a !== void 0 ? _a : (_b = _this.props.init) === null || _b === void 0 ? void 0 : _b.inline) !== null && _c !== void 0 ? _c : false;
        _this.boundHandlers = {};
        return _this;
    }
    Object.defineProperty(Editor.prototype, "view", {
        get: function() {
            var _a, _b;
            return (_b = (_a = this.elementRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument.defaultView) !== null && _b !== void 0 ? _b : window;
        },
        enumerable: false,
        configurable: true
    });
    Editor.prototype.componentDidUpdate = function(prevProps) {
        var _this = this;
        var _a, _b;
        if (this.rollbackTimer) {
            clearTimeout(this.rollbackTimer);
            this.rollbackTimer = undefined;
        }
        if (this.editor) {
            this.bindHandlers(prevProps);
            if (this.editor.initialized) {
                this.currentContent = (_a = this.currentContent) !== null && _a !== void 0 ? _a : this.editor.getContent();
                if (typeof this.props.initialValue === "string" && this.props.initialValue !== prevProps.initialValue) {
                    // same as resetContent in TinyMCE 5
                    this.editor.setContent(this.props.initialValue);
                    this.editor.undoManager.clear();
                    this.editor.undoManager.add();
                    this.editor.setDirty(false);
                } else if (typeof this.props.value === "string" && this.props.value !== this.currentContent) {
                    var localEditor_1 = this.editor;
                    localEditor_1.undoManager.transact(function() {
                        // inline editors grab focus when restoring selection
                        // so we don't try to keep their selection unless they are currently focused
                        var cursor;
                        if (!_this.inline || localEditor_1.hasFocus()) try {
                            // getBookmark throws exceptions when the editor has not been focused
                            // possibly only in inline mode but I'm not taking chances
                            cursor = localEditor_1.selection.getBookmark(3);
                        } catch (e) {}
                        var valueCursor = _this.valueCursor;
                        localEditor_1.setContent(_this.props.value);
                        if (!_this.inline || localEditor_1.hasFocus()) for(var _i = 0, _a = [
                            cursor,
                            valueCursor
                        ]; _i < _a.length; _i++){
                            var bookmark = _a[_i];
                            if (bookmark) try {
                                localEditor_1.selection.moveToBookmark(bookmark);
                                _this.valueCursor = bookmark;
                                break;
                            } catch (e) {}
                        }
                    });
                }
                if (this.props.disabled !== prevProps.disabled) {
                    var disabled = (_b = this.props.disabled) !== null && _b !== void 0 ? _b : false;
                    (0, $8PvuF.setMode)(this.editor, disabled ? "readonly" : "design");
                }
            }
        }
    };
    Editor.prototype.componentDidMount = function() {
        var _this = this;
        var _a, _b, _c, _d, _e;
        if ((0, $0fR6P.getTinymce)(this.view) !== null) this.initialise();
        else if (Array.isArray(this.props.tinymceScriptSrc) && this.props.tinymceScriptSrc.length === 0) (_b = (_a = this.props).onScriptsLoadError) === null || _b === void 0 || _b.call(_a, new Error("No `tinymce` global is present but the `tinymceScriptSrc` prop was an empty array."));
        else if ((_c = this.elementRef.current) === null || _c === void 0 ? void 0 : _c.ownerDocument) {
            var successHandler = function() {
                var _a, _b;
                (_b = (_a = _this.props).onScriptsLoad) === null || _b === void 0 || _b.call(_a);
                _this.initialise();
            };
            var errorHandler = function(err) {
                var _a, _b;
                (_b = (_a = _this.props).onScriptsLoadError) === null || _b === void 0 || _b.call(_a, err);
            };
            (0, $cQa4K.ScriptLoader).loadList(this.elementRef.current.ownerDocument, this.getScriptSources(), (_e = (_d = this.props.scriptLoading) === null || _d === void 0 ? void 0 : _d.delay) !== null && _e !== void 0 ? _e : 0, successHandler, errorHandler);
        }
    };
    Editor.prototype.componentWillUnmount = function() {
        var _this = this;
        var editor = this.editor;
        if (editor) {
            editor.off(this.changeEvents(), this.handleEditorChange);
            editor.off(this.beforeInputEvent(), this.handleBeforeInput);
            editor.off("keypress", this.handleEditorChangeSpecial);
            editor.off("keydown", this.handleBeforeInputSpecial);
            editor.off("NewBlock", this.handleEditorChange);
            Object.keys(this.boundHandlers).forEach(function(eventName) {
                editor.off(eventName, _this.boundHandlers[eventName]);
            });
            this.boundHandlers = {};
            editor.remove();
            this.editor = undefined;
        }
    };
    Editor.prototype.render = function() {
        return this.inline ? this.renderInline() : this.renderIframe();
    };
    Editor.prototype.changeEvents = function() {
        var _a, _b, _c;
        var isIE = (_c = (_b = (_a = (0, $0fR6P.getTinymce)(this.view)) === null || _a === void 0 ? void 0 : _a.Env) === null || _b === void 0 ? void 0 : _b.browser) === null || _c === void 0 ? void 0 : _c.isIE();
        return isIE ? "change keyup compositionend setcontent CommentChange" : "change input compositionend setcontent CommentChange";
    };
    Editor.prototype.beforeInputEvent = function() {
        return (0, $8PvuF.isBeforeInputEventAvailable)() ? "beforeinput SelectionChange" : "SelectionChange";
    };
    Editor.prototype.renderInline = function() {
        var _a = this.props.tagName, tagName = _a === void 0 ? "div" : _a;
        return $bh6RR.createElement(tagName, {
            ref: this.elementRef,
            id: this.id
        });
    };
    Editor.prototype.renderIframe = function() {
        return $bh6RR.createElement("textarea", {
            ref: this.elementRef,
            style: {
                visibility: "hidden"
            },
            name: this.props.textareaName,
            id: this.id
        });
    };
    Editor.prototype.getScriptSources = function() {
        var _a, _b;
        var async = (_a = this.props.scriptLoading) === null || _a === void 0 ? void 0 : _a.async;
        var defer = (_b = this.props.scriptLoading) === null || _b === void 0 ? void 0 : _b.defer;
        if (this.props.tinymceScriptSrc !== undefined) {
            if (typeof this.props.tinymceScriptSrc === "string") return [
                {
                    src: this.props.tinymceScriptSrc,
                    async: async,
                    defer: defer
                }
            ];
            // multiple scripts can be specified which allows for hybrid mode
            return this.props.tinymceScriptSrc.map(function(item) {
                if (typeof item === "string") // async does not make sense for multiple items unless
                // they are not dependent (which will be unlikely)
                return {
                    src: item,
                    async: async,
                    defer: defer
                };
                else return item;
            });
        }
        // fallback to the cloud when the tinymceScriptSrc is not specified
        var channel = this.props.cloudChannel;
        var apiKey = this.props.apiKey ? this.props.apiKey : "no-api-key";
        var cloudTinyJs = "https://cdn.tiny.cloud/1/".concat(apiKey, "/tinymce/").concat(channel, "/tinymce.min.js");
        return [
            {
                src: cloudTinyJs,
                async: async,
                defer: defer
            }
        ];
    };
    Editor.prototype.getInitialValue = function() {
        if (typeof this.props.initialValue === "string") return this.props.initialValue;
        else if (typeof this.props.value === "string") return this.props.value;
        else return "";
    };
    Editor.prototype.bindHandlers = function(prevProps) {
        var _this = this;
        if (this.editor !== undefined) {
            // typescript chokes trying to understand the type of the lookup function
            (0, $8PvuF.configHandlers)(this.editor, prevProps, this.props, this.boundHandlers, function(key) {
                return _this.props[key];
            });
            // check if we should monitor editor changes
            var isValueControlled = function(p) {
                return p.onEditorChange !== undefined || p.value !== undefined;
            };
            var wasControlled = isValueControlled(prevProps);
            var nowControlled = isValueControlled(this.props);
            if (!wasControlled && nowControlled) {
                this.editor.on(this.changeEvents(), this.handleEditorChange);
                this.editor.on(this.beforeInputEvent(), this.handleBeforeInput);
                this.editor.on("keydown", this.handleBeforeInputSpecial);
                this.editor.on("keyup", this.handleEditorChangeSpecial);
                this.editor.on("NewBlock", this.handleEditorChange);
            } else if (wasControlled && !nowControlled) {
                this.editor.off(this.changeEvents(), this.handleEditorChange);
                this.editor.off(this.beforeInputEvent(), this.handleBeforeInput);
                this.editor.off("keydown", this.handleBeforeInputSpecial);
                this.editor.off("keyup", this.handleEditorChangeSpecial);
                this.editor.off("NewBlock", this.handleEditorChange);
            }
        }
    };
    Editor.propTypes = (0, $35Wql.EditorPropTypes);
    Editor.defaultProps = {
        cloudChannel: "6"
    };
    return Editor;
}($bh6RR.Component);

});
parcelRegister("cQa4K", function(module, exports) {

$parcel$export(module.exports, "ScriptLoader", function () { return $95922824bb90087f$export$7c69a55d426f4de9; });

var $8PvuF = parcelRequire("8PvuF");
var $95922824bb90087f$var$__assign = undefined && undefined.__assign || function() {
    $95922824bb90087f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $95922824bb90087f$var$__assign.apply(this, arguments);
};
var $95922824bb90087f$var$injectScriptTag = function(doc, item, handler) {
    var _a, _b;
    var scriptTag = doc.createElement("script");
    scriptTag.referrerPolicy = "origin";
    scriptTag.type = "application/javascript";
    scriptTag.id = item.id;
    scriptTag.src = item.src;
    scriptTag.async = (_a = item.async) !== null && _a !== void 0 ? _a : false;
    scriptTag.defer = (_b = item.defer) !== null && _b !== void 0 ? _b : false;
    var loadHandler = function() {
        scriptTag.removeEventListener("load", loadHandler);
        scriptTag.removeEventListener("error", errorHandler);
        handler(item.src);
    };
    var errorHandler = function(err) {
        scriptTag.removeEventListener("load", loadHandler);
        scriptTag.removeEventListener("error", errorHandler);
        handler(item.src, err);
    };
    scriptTag.addEventListener("load", loadHandler);
    scriptTag.addEventListener("error", errorHandler);
    if (doc.head) doc.head.appendChild(scriptTag);
};
var $95922824bb90087f$var$createDocumentScriptLoader = function(doc) {
    var lookup = {};
    var scriptLoadOrErrorHandler = function(src, err) {
        var item = lookup[src];
        item.done = true;
        item.error = err;
        for(var _i = 0, _a = item.handlers; _i < _a.length; _i++){
            var h = _a[_i];
            h(src, err);
        }
        item.handlers = [];
    };
    var loadScripts = function(items, success, failure) {
        // eslint-disable-next-line no-console
        var failureOrLog = function(err) {
            return failure !== undefined ? failure(err) : console.error(err);
        };
        if (items.length === 0) {
            failureOrLog(new Error("At least one script must be provided"));
            return;
        }
        var successCount = 0;
        var failed = false;
        var loaded = function(_src, err) {
            if (failed) return;
            if (err) {
                failed = true;
                failureOrLog(err);
            } else if (++successCount === items.length) success();
        };
        for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
            var item = items_1[_i];
            var existing = lookup[item.src];
            if (existing) {
                if (existing.done) loaded(item.src, existing.error);
                else existing.handlers.push(loaded);
            } else {
                // create a new entry
                var id = (0, $8PvuF.uuid)("tiny-");
                lookup[item.src] = {
                    id: id,
                    src: item.src,
                    done: false,
                    error: null,
                    handlers: [
                        loaded
                    ]
                };
                $95922824bb90087f$var$injectScriptTag(doc, $95922824bb90087f$var$__assign({
                    id: id
                }, item), scriptLoadOrErrorHandler);
            }
        }
    };
    var deleteScripts = function() {
        var _a;
        for(var _i = 0, _b = Object.values(lookup); _i < _b.length; _i++){
            var item = _b[_i];
            var scriptTag = doc.getElementById(item.id);
            if (scriptTag != null && scriptTag.tagName === "SCRIPT") (_a = scriptTag.parentNode) === null || _a === void 0 || _a.removeChild(scriptTag);
        }
        lookup = {};
    };
    var getDocument = function() {
        return doc;
    };
    return {
        loadScripts: loadScripts,
        deleteScripts: deleteScripts,
        getDocument: getDocument
    };
};
var $95922824bb90087f$var$createScriptLoader = function() {
    var cache = [];
    var getDocumentScriptLoader = function(doc) {
        var loader = cache.find(function(l) {
            return l.getDocument() === doc;
        });
        if (loader === undefined) {
            loader = $95922824bb90087f$var$createDocumentScriptLoader(doc);
            cache.push(loader);
        }
        return loader;
    };
    var loadList = function(doc, items, delay, success, failure) {
        var doLoad = function() {
            return getDocumentScriptLoader(doc).loadScripts(items, success, failure);
        };
        if (delay > 0) setTimeout(doLoad, delay);
        else doLoad();
    };
    var reinitialize = function() {
        for(var loader = cache.pop(); loader != null; loader = cache.pop())loader.deleteScripts();
    };
    return {
        loadList: loadList,
        reinitialize: reinitialize
    };
};
var $95922824bb90087f$export$7c69a55d426f4de9 = $95922824bb90087f$var$createScriptLoader();

});
parcelRegister("8PvuF", function(module, exports) {

$parcel$export(module.exports, "isFunction", function () { return $66db84201f6cb8a3$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "configHandlers", function () { return $66db84201f6cb8a3$export$976afb4c0973ace0; });
$parcel$export(module.exports, "uuid", function () { return $66db84201f6cb8a3$export$31b40729666a4ae0; });
$parcel$export(module.exports, "isTextareaOrInput", function () { return $66db84201f6cb8a3$export$36d79ba83ca332ee; });
$parcel$export(module.exports, "mergePlugins", function () { return $66db84201f6cb8a3$export$baf513ab02aa4139; });
$parcel$export(module.exports, "isBeforeInputEventAvailable", function () { return $66db84201f6cb8a3$export$db95927f7c59b055; });
$parcel$export(module.exports, "isInDoc", function () { return $66db84201f6cb8a3$export$7f84f389cd79ac30; });
$parcel$export(module.exports, "setMode", function () { return $66db84201f6cb8a3$export$d4f039427a1beff1; });

var $35Wql = parcelRequire("35Wql");
var $66db84201f6cb8a3$export$f6e2535fb5126e54 = function(x) {
    return typeof x === "function";
};
var $66db84201f6cb8a3$var$isEventProp = function(name) {
    return name in (0, $35Wql.eventPropTypes);
};
var $66db84201f6cb8a3$var$eventAttrToEventName = function(attrName) {
    return attrName.substr(2);
};
var $66db84201f6cb8a3$export$af36139ef88769c2 = function(handlerLookup, on, off, adapter, prevProps, props, boundHandlers) {
    var prevEventKeys = Object.keys(prevProps).filter($66db84201f6cb8a3$var$isEventProp);
    var currEventKeys = Object.keys(props).filter($66db84201f6cb8a3$var$isEventProp);
    var removedKeys = prevEventKeys.filter(function(key) {
        return props[key] === undefined;
    });
    var addedKeys = currEventKeys.filter(function(key) {
        return prevProps[key] === undefined;
    });
    removedKeys.forEach(function(key) {
        // remove event handler
        var eventName = $66db84201f6cb8a3$var$eventAttrToEventName(key);
        var wrappedHandler = boundHandlers[eventName];
        off(eventName, wrappedHandler);
        delete boundHandlers[eventName];
    });
    addedKeys.forEach(function(key) {
        var wrappedHandler = adapter(handlerLookup, key);
        var eventName = $66db84201f6cb8a3$var$eventAttrToEventName(key);
        boundHandlers[eventName] = wrappedHandler;
        on(eventName, wrappedHandler);
    });
};
var $66db84201f6cb8a3$export$976afb4c0973ace0 = function(editor, prevProps, props, boundHandlers, lookup) {
    return $66db84201f6cb8a3$export$af36139ef88769c2(lookup, editor.on.bind(editor), editor.off.bind(editor), // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    function(handlerLookup, key) {
        return function(e) {
            var _a;
            return (_a = handlerLookup(key)) === null || _a === void 0 ? void 0 : _a(e, editor);
        };
    }, prevProps, props, boundHandlers);
};
var $66db84201f6cb8a3$var$unique = 0;
var $66db84201f6cb8a3$export$31b40729666a4ae0 = function(prefix) {
    var time = Date.now();
    var random = Math.floor(Math.random() * 1000000000);
    $66db84201f6cb8a3$var$unique++;
    return prefix + "_" + random + $66db84201f6cb8a3$var$unique + String(time);
};
var $66db84201f6cb8a3$export$36d79ba83ca332ee = function(element) {
    return element !== null && (element.tagName.toLowerCase() === "textarea" || element.tagName.toLowerCase() === "input");
};
var $66db84201f6cb8a3$var$normalizePluginArray = function(plugins) {
    if (typeof plugins === "undefined" || plugins === "") return [];
    return Array.isArray(plugins) ? plugins : plugins.split(" ");
};
var $66db84201f6cb8a3$export$baf513ab02aa4139 = function(initPlugins, inputPlugins) {
    return $66db84201f6cb8a3$var$normalizePluginArray(initPlugins).concat($66db84201f6cb8a3$var$normalizePluginArray(inputPlugins));
};
var $66db84201f6cb8a3$export$db95927f7c59b055 = function() {
    return window.InputEvent && typeof InputEvent.prototype.getTargetRanges === "function";
};
var $66db84201f6cb8a3$export$7f84f389cd79ac30 = function(elem) {
    if (!("isConnected" in Node.prototype)) {
        // Fallback for IE and old Edge
        var current = elem;
        var parent_1 = elem.parentNode;
        while(parent_1 != null){
            current = parent_1;
            parent_1 = current.parentNode;
        }
        return current === elem.ownerDocument;
    }
    return elem.isConnected;
};
var $66db84201f6cb8a3$export$d4f039427a1beff1 = function(editor, mode) {
    if (editor !== undefined) {
        if (editor.mode != null && typeof editor.mode === "object" && typeof editor.mode.set === "function") editor.mode.set(mode);
        else editor.setMode(mode);
    }
};

});
parcelRegister("35Wql", function(module, exports) {

$parcel$export(module.exports, "eventPropTypes", function () { return $240f287e656dd483$export$55f393ee5b65665e; });
$parcel$export(module.exports, "EditorPropTypes", function () { return $240f287e656dd483$export$b925e942c73cf435; });

var $eCfBx = parcelRequire("eCfBx");
var $240f287e656dd483$var$__assign = undefined && undefined.__assign || function() {
    $240f287e656dd483$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $240f287e656dd483$var$__assign.apply(this, arguments);
};
var $240f287e656dd483$export$55f393ee5b65665e = {
    onActivate: $eCfBx.func,
    onAddUndo: $eCfBx.func,
    onBeforeAddUndo: $eCfBx.func,
    onBeforeExecCommand: $eCfBx.func,
    onBeforeGetContent: $eCfBx.func,
    onBeforeRenderUI: $eCfBx.func,
    onBeforeSetContent: $eCfBx.func,
    onBeforePaste: $eCfBx.func,
    onBlur: $eCfBx.func,
    onChange: $eCfBx.func,
    onClearUndos: $eCfBx.func,
    onClick: $eCfBx.func,
    onContextMenu: $eCfBx.func,
    onCommentChange: $eCfBx.func,
    onCopy: $eCfBx.func,
    onCut: $eCfBx.func,
    onDblclick: $eCfBx.func,
    onDeactivate: $eCfBx.func,
    onDirty: $eCfBx.func,
    onDrag: $eCfBx.func,
    onDragDrop: $eCfBx.func,
    onDragEnd: $eCfBx.func,
    onDragGesture: $eCfBx.func,
    onDragOver: $eCfBx.func,
    onDrop: $eCfBx.func,
    onExecCommand: $eCfBx.func,
    onFocus: $eCfBx.func,
    onFocusIn: $eCfBx.func,
    onFocusOut: $eCfBx.func,
    onGetContent: $eCfBx.func,
    onHide: $eCfBx.func,
    onInit: $eCfBx.func,
    onKeyDown: $eCfBx.func,
    onKeyPress: $eCfBx.func,
    onKeyUp: $eCfBx.func,
    onLoadContent: $eCfBx.func,
    onMouseDown: $eCfBx.func,
    onMouseEnter: $eCfBx.func,
    onMouseLeave: $eCfBx.func,
    onMouseMove: $eCfBx.func,
    onMouseOut: $eCfBx.func,
    onMouseOver: $eCfBx.func,
    onMouseUp: $eCfBx.func,
    onNodeChange: $eCfBx.func,
    onObjectResizeStart: $eCfBx.func,
    onObjectResized: $eCfBx.func,
    onObjectSelected: $eCfBx.func,
    onPaste: $eCfBx.func,
    onPostProcess: $eCfBx.func,
    onPostRender: $eCfBx.func,
    onPreProcess: $eCfBx.func,
    onProgressState: $eCfBx.func,
    onRedo: $eCfBx.func,
    onRemove: $eCfBx.func,
    onReset: $eCfBx.func,
    onSaveContent: $eCfBx.func,
    onSelectionChange: $eCfBx.func,
    onSetAttrib: $eCfBx.func,
    onSetContent: $eCfBx.func,
    onShow: $eCfBx.func,
    onSubmit: $eCfBx.func,
    onUndo: $eCfBx.func,
    onVisualAid: $eCfBx.func,
    onSkinLoadError: $eCfBx.func,
    onThemeLoadError: $eCfBx.func,
    onModelLoadError: $eCfBx.func,
    onPluginLoadError: $eCfBx.func,
    onIconsLoadError: $eCfBx.func,
    onLanguageLoadError: $eCfBx.func,
    onScriptsLoad: $eCfBx.func,
    onScriptsLoadError: $eCfBx.func
};
var $240f287e656dd483$export$b925e942c73cf435 = $240f287e656dd483$var$__assign({
    apiKey: $eCfBx.string,
    id: $eCfBx.string,
    inline: $eCfBx.bool,
    init: $eCfBx.object,
    initialValue: $eCfBx.string,
    onEditorChange: $eCfBx.func,
    value: $eCfBx.string,
    tagName: $eCfBx.string,
    cloudChannel: $eCfBx.string,
    plugins: $eCfBx.oneOfType([
        $eCfBx.string,
        $eCfBx.array
    ]),
    toolbar: $eCfBx.oneOfType([
        $eCfBx.string,
        $eCfBx.array
    ]),
    disabled: $eCfBx.bool,
    textareaName: $eCfBx.string,
    tinymceScriptSrc: $eCfBx.oneOfType([
        $eCfBx.string,
        $eCfBx.arrayOf($eCfBx.string),
        $eCfBx.arrayOf($eCfBx.shape({
            src: $eCfBx.string,
            async: $eCfBx.bool,
            defer: $eCfBx.bool
        }))
    ]),
    rollback: $eCfBx.oneOfType([
        $eCfBx.number,
        $eCfBx.oneOf([
            false
        ])
    ]),
    scriptLoading: $eCfBx.shape({
        async: $eCfBx.bool,
        defer: $eCfBx.bool,
        delay: $eCfBx.number
    })
}, $240f287e656dd483$export$55f393ee5b65665e);

});



parcelRegister("0fR6P", function(module, exports) {

$parcel$export(module.exports, "getTinymce", function () { return $000c4ccb2035d60e$export$d996549f383e26d7; });
var $000c4ccb2035d60e$export$d996549f383e26d7 = function(view) {
    var global = view;
    return global && global.tinymce ? global.tinymce : null;
};

});







parcelRegister("auZDP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eae55200b340697a$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");

var $ayVxz = parcelRequire("ayVxz");

var $b1v75 = parcelRequire("b1v75");

var $ahwrv = parcelRequire("ahwrv");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $bu31C = parcelRequire("bu31C");

var $bwbWe = parcelRequire("bwbWe");
var $8jEtO = parcelRequire("8jEtO");
var $kso7N = parcelRequire("kso7N");

var $6L9uu = parcelRequire("6L9uu");

var $hjfla = parcelRequire("hjfla");

var $eBMvL = parcelRequire("eBMvL");

var $8d818 = parcelRequire("8d818");

var $9ME2c = parcelRequire("9ME2c");

var $j5ie7 = parcelRequire("j5ie7");

var $g0F20 = parcelRequire("g0F20");
const $eae55200b340697a$var$CompanyInfoWrapper = ()=>{
    const location = (0, $99w1R.useLocation)();
    const history = (0, $99w1R.useNavigate)();
    const { state: state, dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [company, setCompany] = (0, $bh6RR.useState)(null);
    const [getCompany, { data: data, loading: loading }] = (0, $hjfla.useCompanyLazyQuery)();
    const [value, setValue] = (0, $bh6RR.useState)(0);
    const handleChange = (_, newValue)=>{
        setValue(newValue);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (!company) {
            const locationElements = location.pathname.split("/").filter((e)=>e);
            getCompany({
                variables: {
                    id: parseInt(locationElements[locationElements.length - 1])
                }
            });
        }
        if (data && data.result) {
            dispatch({
                type: (0, $ayVxz.Actions).SetSelectedCompany,
                payload: {
                    name: data.result.name,
                    address_name: data.result.main_address?.name
                }
            });
            setCompany(data.result);
        }
    }, [
        data
    ]);
    const handleToCompaniesOverview = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).ResetSelectedCompany
        });
        history((0, $b1v75.AuthRoutes).Companies);
    };
    const updateMembership = (mem)=>{
        setCompany({
            ...company,
            membership: mem
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ahwrv.default), {
                handleToOverview: handleToCompaniesOverview,
                navName: (0, $b1v75.RouteNames).Companies,
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize",
                    sx: {
                        gap: "5px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bwbWe.default), {}),
                        state.selectedCompany.name || company?.name,
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                            sx: {
                                borderRight: `1px solid ${(0, $6L9uu.Colors).white}`,
                                width: "1px",
                                height: "100%"
                            }
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $kso7N.default), {}),
                        state.selectedCompany.address_name || company?.main_address?.name
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eBMvL.default), {
                        value: value,
                        handleChange: handleChange,
                        tabProps: [
                            {
                                id: "company-details",
                                title: "Details",
                                icon: (0, $8jEtO.default)
                            },
                            {
                                id: "company-addresses",
                                title: "Addresses",
                                icon: (0, $kso7N.default)
                            }
                        ]
                    }),
                    company && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                                value: value,
                                index: 0,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9ME2c.default), {
                                    company: company,
                                    updateMembershipProperty: updateMembership
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                                value: value,
                                index: 1,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $g0F20.default), {
                                    companyId: parseInt(company.id)
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                loading: loading
            })
        ]
    });
};
var $eae55200b340697a$export$2e2bcd8739ae039 = $eae55200b340697a$var$CompanyInfoWrapper;

});
parcelRegister("9ME2c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e436a4e38505943$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");

var $5DXc5 = parcelRequire("5DXc5");

var $eBMvL = parcelRequire("eBMvL");

var $j5ie7 = parcelRequire("j5ie7");

var $b4Jmy = parcelRequire("b4Jmy");

var $6e6jx = parcelRequire("6e6jx");

var $1pXcI = parcelRequire("1pXcI");
const $8e436a4e38505943$var$CompanyDetailsTabs = ({ company: company, updateMembershipProperty: updateMembershipProperty })=>{
    const [value, setValue] = (0, $bh6RR.useState)(0);
    const handleChange = (_, newValue)=>{
        setValue(newValue);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        className: "centralize",
        sx: {
            width: "100%",
            paddingTop: "80px"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5DXc5.default), {
            width: "82%",
            additionalStyle: {
                height: "680px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $eBMvL.default), {
                    type: "third",
                    value: value,
                    handleChange: handleChange,
                    tabProps: [
                        {
                            id: "General-Tab",
                            title: "General"
                        },
                        {
                            id: "Contacts-Tab",
                            title: "Contacts"
                        },
                        {
                            id: "Membership-Tab",
                            title: "Membership"
                        }
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                    value: value,
                    index: 0,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b4Jmy.default), {
                        company: company
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                    value: value,
                    index: 1,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $6e6jx.default), {
                        companyId: parseInt(company.id)
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                    value: value,
                    index: 2,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1pXcI.default), {
                        membership: company.membership,
                        companyName: company.name,
                        companyId: company.id,
                        updateMembershipProperty: updateMembershipProperty
                    })
                })
            ]
        })
    });
};
var $8e436a4e38505943$export$2e2bcd8739ae039 = $8e436a4e38505943$var$CompanyDetailsTabs;

});
parcelRegister("b4Jmy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cdddde4cbe50ea4$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $bIyvl = parcelRequire("bIyvl");
var $g7vB6 = parcelRequire("g7vB6");
var $1sQVT = parcelRequire("1sQVT");
var $dNZ9A = parcelRequire("dNZ9A");
var $aitry = parcelRequire("aitry");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $gFVvY = parcelRequire("gFVvY");

var $dqRXb = parcelRequire("dqRXb");

var $6L9uu = parcelRequire("6L9uu");

var $bSbwb = parcelRequire("bSbwb");

var $gSGmk = parcelRequire("gSGmk");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $ehzwo = parcelRequire("ehzwo");

var $bilGR = parcelRequire("bilGR");
const $7cdddde4cbe50ea4$var$defaultErrorsObj = {
    companyName: null,
    website: null,
    companyType: null,
    marketActivity: null
};
const $7cdddde4cbe50ea4$var$CompanyGeneralTab = ({ company: company })=>{
    const [editable, setEditable] = (0, $bh6RR.useState)(false);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($7cdddde4cbe50ea4$var$defaultErrorsObj);
    const [companyName, setCompanyName] = (0, $bh6RR.useState)(company.name);
    const [website, setWebsite] = (0, $bh6RR.useState)(company.website);
    const [stockCode, setStockCode] = (0, $bh6RR.useState)(company.unique_stock_code);
    const [companyType, setCompanyType] = (0, $bh6RR.useState)(company.company_type || null);
    const [marketActivity, setMarketActivity] = (0, $bh6RR.useState)(company.market_activity || null);
    const [info, setInfo] = (0, $bh6RR.useState)(company.info);
    const [memberIndex, setMemberIndex] = (0, $bh6RR.useState)(company.member_index);
    const [marketSecondSpecialty, setMarketSecondSpecialty] = (0, $bh6RR.useState)(company.market_second_specialty);
    const [companyTypesOptions, setCompanyTypesOptions] = (0, $bh6RR.useState)([]);
    const [marketActivitiesOptions, setMarketActivitiesOptions] = (0, $bh6RR.useState)([]);
    const [getCompanyTypes, companyTypesData] = (0, $hjfla.useCompanyTypesLazyQuery)();
    const [getMarketActivities, marketActivitiesData] = (0, $hjfla.useMarketActivitiesLazyQuery)();
    const [updateCompany, updateCompanyResult] = (0, $hjfla.useUpdateCompanyMutation)();
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Company);
    (0, $bh6RR.useEffect)(()=>{
        if (companyTypesData.data && companyTypesData.data.result) setCompanyTypesOptions(companyTypesData.data.result);
        if (marketActivitiesData.data && marketActivitiesData.data.result) setMarketActivitiesOptions(marketActivitiesData.data.result);
    }, [
        companyTypesData,
        marketActivitiesData
    ]);
    const handleCompanyNameChange = (event)=>{
        const { name: name, value: value } = event.currentTarget;
        if (value.length < 2) setFormErrors({
            ...formErrors,
            [name]: "Company name too short"
        });
        else setFormErrors({
            ...formErrors,
            [name]: null
        });
        setCompanyName(value);
    };
    const handleWebsiteChange = (event)=>{
        const { name: name, value: value } = event.currentTarget;
        const isValidWebsite = value?.match((0, $gSGmk.validWebsiteRegex));
        if (isValidWebsite || value.length === 0) setFormErrors({
            ...formErrors,
            [name]: null
        });
        else setFormErrors({
            ...formErrors,
            [name]: "Invalid website"
        });
        setWebsite(value);
    };
    const handleStockCodeChange = (event)=>{
        const { value: value } = event.currentTarget;
        setStockCode(value);
    };
    const handleInfoChange = (event)=>{
        const { value: value } = event.currentTarget;
        setInfo(value);
    };
    const handleMemberIndexChange = (event)=>{
        const { value: value } = event.target;
        setMemberIndex(value === "true" ? true : false);
    };
    const handleMarketSecondSpecialtyChange = (event)=>{
        const { value: value } = event.target;
        setMarketSecondSpecialty(value);
    };
    const handleEditClicked = ()=>{
        if (companyTypesOptions.length === 0 || marketActivitiesOptions.length === 0) {
            getCompanyTypes();
            getMarketActivities();
        }
        setEditable(true);
    };
    const handleCompanyTypeChanged = (_, newValue)=>{
        if (newValue) setFormErrors({
            ...formErrors,
            companyType: null
        });
        else setFormErrors({
            ...formErrors,
            companyType: "Company type is required"
        });
        setCompanyType(newValue);
    };
    const handleMarketActivityChanged = (_, newValue)=>{
        if (newValue) setFormErrors({
            ...formErrors,
            marketActivity: null
        });
        else setFormErrors({
            ...formErrors,
            marketActivity: "Market activity is required"
        });
        setMarketActivity(newValue);
    };
    const handleCancel = ()=>{
        setCompanyName(company.name);
        setWebsite(company.website);
        setInfo(company.info);
        setCompanyType(company.company_type || null);
        setMarketActivity(company.market_activity || null);
        setMemberIndex(company.member_index);
        setMarketSecondSpecialty(company.market_second_specialty);
        setEditable(false);
        setFormErrors($7cdddde4cbe50ea4$var$defaultErrorsObj);
    };
    const handleSave = ()=>{
        let hasErrors = false;
        const errors = {
            companyName: null,
            website: null,
            companyType: null,
            marketActivity: null
        };
        if (!companyName || companyName.length < 2) {
            hasErrors = true;
            errors.companyName = "Company name too short";
        }
        const isValidWebsite = website?.match((0, $gSGmk.validWebsiteRegex));
        if (website && website?.length > 0 && !isValidWebsite) {
            hasErrors = true;
            errors.website = "Invalid website";
        }
        if (companyType === null) {
            hasErrors = true;
            errors.companyType = "Company type is required";
        }
        if (marketActivity === null) {
            hasErrors = true;
            errors.marketActivity = "Market activity is required";
        }
        if (hasErrors) setFormErrors({
            ...errors
        });
        else {
            const nameChanged = company.name !== companyName;
            const nameExists = nameChanged ? (0, $gFVvY.sameCompanyNameExists)(companyName, parseInt(company.id)) : false;
            if (nameExists) {
                setFormErrors({
                    ...formErrors,
                    companyName: "Company name exists"
                });
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: "Company name exists",
                        severity: "error"
                    }
                });
            } else {
                const hasSimilarCompanyName = nameChanged ? (0, $gFVvY.similarCompanyNameExists)(companyName, parseInt(company.id)) : false;
                if (hasSimilarCompanyName) dispatch({
                    type: (0, $ayVxz.Actions).ShowConfirmation,
                    payload: {
                        text: "There is company with similar name. Are you sure you want to continue?",
                        agreeAction: handleUpdateCompany
                    }
                });
                else handleUpdateCompany();
            }
        }
    };
    const handleUpdateCompany = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        updateCompany({
            variables: {
                id: parseInt(company.id),
                input: {
                    name: companyName,
                    company_type_id: parseInt(companyType?.id),
                    market_activity_id: parseInt(marketActivity?.id),
                    website: website,
                    member_index: memberIndex,
                    market_second_specialty: marketSecondSpecialty,
                    unique_stock_code: stockCode
                }
            },
            update (_, { data: data }) {
                if (data && data.result) {
                    setEditable(false);
                    dispatch({
                        type: (0, $ayVxz.Actions).SetSelectedCompany,
                        payload: {
                            name: data.result.name,
                            address_name: data.result.main_address?.name
                        }
                    });
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            text: `Successfully updated ${companyName}`,
                            severity: "success",
                            autoHide: 2000
                        }
                    });
                }
            }
        }).catch((e)=>setFormErrors({
                ...formErrors,
                updateError: e.message.slice(15)
            }));
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            padding: "80px",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    position: "absolute",
                    top: "24px",
                    right: "24px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "contact-general-edit-button",
                    onClick: handleEditClicked,
                    disabled: !canEdit || editable,
                    editButtonColor: !canEdit || editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            formErrors.updateError && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), {
                    color: "error",
                    children: formErrors.updateError.message
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    columnGap: "7.2%",
                    paddingX: "5%"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            display: "flex",
                            flexFlow: "column",
                            gap: "35px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "name",
                                label: "Company Name(full)",
                                value: companyName,
                                onChange: handleCompanyNameChange,
                                disabled: !editable,
                                errorMsg: formErrors.companyName
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "company-type",
                                label: "Company type",
                                options: companyTypesOptions,
                                getOptionLabel: (option)=>option.name,
                                disabled: !editable,
                                values: companyType,
                                onChange: handleCompanyTypeChanged,
                                errorMsg: formErrors.companyType
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "market-activity",
                                label: "Market activity",
                                options: marketActivitiesOptions,
                                getOptionLabel: (option)=>option.name,
                                disabled: !editable,
                                values: marketActivity,
                                onChange: handleMarketActivityChanged,
                                errorMsg: formErrors.marketActivity
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "market-second-specialty",
                                label: "Market Second Specialty",
                                value: marketSecondSpecialty ?? "-",
                                onChange: handleMarketSecondSpecialtyChange,
                                disabled: !editable
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $dNZ9A.default), {
                                    row: true,
                                    value: memberIndex,
                                    onChange: handleMemberIndexChange,
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $g7vB6.default), {
                                            sx: {
                                                color: (t)=>editable ? t.palette.primary.main : (0, $6L9uu.Colors).gray,
                                                marginTop: "13px",
                                                marginRight: "40px"
                                            },
                                            component: "legend",
                                            children: "Epra Watch Index"
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bIyvl.default), {
                                            value: true,
                                            control: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1sQVT.default), {
                                                color: "primary",
                                                disabled: !editable
                                            }),
                                            label: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $bIyvl.default), {
                                            value: false,
                                            control: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1sQVT.default), {
                                                color: "primary",
                                                disabled: !editable
                                            }),
                                            label: "No"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            display: "flex",
                            flexFlow: "column",
                            gap: "35px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "website",
                                label: "Website",
                                value: website ?? "-",
                                onChange: handleWebsiteChange,
                                disabled: !editable,
                                errorMsg: formErrors.website
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "stock-code",
                                label: "Unique Stock Code",
                                value: stockCode ?? "-",
                                onChange: handleStockCodeChange,
                                disabled: !editable
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "company-info",
                                label: "Company Info",
                                value: info ?? "",
                                onChange: handleInfoChange,
                                disabled: !editable,
                                multiline: true,
                                rows: 4,
                                additionalStyle: {
                                    "& .MuiInputBase-root": {
                                        height: 106
                                    }
                                }
                            })
                        ]
                    })
                ]
            }),
            editable && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    marginTop: "140px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-button",
                        disabled: updateCompanyResult.loading,
                        onClick: handleCancel,
                        text: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "save-button",
                        disabled: updateCompanyResult.loading,
                        onClick: handleSave,
                        text: "Save"
                    })
                ]
            })
        ]
    });
};
var $7cdddde4cbe50ea4$export$2e2bcd8739ae039 = $7cdddde4cbe50ea4$var$CompanyGeneralTab;

});

parcelRegister("6e6jx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f5457eefc5d9ba5$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $lGURI = parcelRequire("lGURI");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $b42dh = parcelRequire("b42dh");
const $8f5457eefc5d9ba5$var$CompanyContactsTab = ({ companyId: companyId })=>{
    const { data: data, loading: loading } = (0, $hjfla.useCompanyContactsQuery)({
        variables: {
            company_id: companyId
        },
        fetchPolicy: "no-cache"
    });
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const history = (0, $99w1R.useNavigate)();
    const [deleteContact] = (0, $hjfla.useDeleteContactMutation)();
    const [contacts, setContacts] = (0, $bh6RR.useState)([]);
    const [updateMainContact] = (0, $hjfla.useUpdateCompanyMainContactMutation)();
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Company);
    const handleDetails = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).SetSelectedContact,
            payload: {
                name: rowData.fullName,
                company_name: rowData.company.name
            }
        });
        history(`/contacts/${rowData.id}`, {
            state: {
                ...rowData
            }
        });
    };
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${rowData.fullName}?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    (0, $bh6RR.useEffect)(()=>{
        if (data?.result) setContacts(data.result);
    }, [
        data
    ]);
    const handleDelete = (rowData)=>{
        deleteContact({
            variables: {
                id: parseInt(rowData.id)
            },
            update (_, { data: data }) {
                dispatch({
                    type: (0, $ayVxz.Actions).HideConfirmation
                });
                if (data?.result) {
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `Successfully deleted ${rowData.fullName}`,
                            autoHide: 4000
                        }
                    });
                    const filteredContacts = Array.from(contacts);
                    const index = filteredContacts.findIndex((a)=>a?.id === rowData.id);
                    filteredContacts.splice(index, 1);
                    //const filteredContacts = contacts?.filter((a) => a?.id !== rowData.id);
                    setContacts(filteredContacts);
                } else dispatch({
                    type: (0, $ayVxz.Actions).ShowConfirmation,
                    payload: {
                        text: "This is company last contact. Are you sure you want to delete it?",
                        agreeAction: deleteLastContact,
                        params: rowData
                    }
                });
            }
        });
    };
    const deleteLastContact = (rowData)=>{
        deleteContact({
            variables: {
                id: parseInt(rowData.id),
                can_delete_last: true
            },
            update (_, { data: data }) {
                dispatch({
                    type: (0, $ayVxz.Actions).HideConfirmation
                });
                if (data?.result) {
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `Successfully deleted ${rowData.fullName}`,
                            autoHide: 4000
                        }
                    });
                    const filteredContacts = Array.from(contacts);
                    const index = filteredContacts.findIndex((a)=>a?.id);
                    filteredContacts.splice(index, 1);
                    setContacts(filteredContacts);
                }
            }
        });
    };
    const isMainStatus = (rowData)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $lGURI.default), {
            id: "is_main_contact_switch",
            "data-testid": "is_main_contact_switch",
            disableRipple: true,
            name: "checkIsMainContact",
            onChange: ()=>handleMainChange(rowData),
            checked: rowData.is_main || false,
            disabled: !canEdit
        });
    const handleMainChange = (rowData)=>{
        const is_main = !rowData.is_main;
        updateMainContact({
            variables: {
                id: companyId,
                contact_id: parseInt(rowData.id),
                is_main: is_main
            },
            update () {
                const message = is_main ? `${rowData.fullName} set as main contact` : `${rowData.fullName} no longer main`;
                const updatedContacts = contacts?.map((c)=>c?.id === rowData.id ? {
                        ...c,
                        is_main: is_main
                    } : c);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: message
                    }
                });
                setContacts(updatedContacts);
            }
        }).catch((e)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            }));
    };
    const columns = [
        {
            title: "Details",
            sorting: false,
            width: 68
        },
        {
            title: "ID",
            field: "id",
            width: 52,
            type: "numeric"
        },
        {
            title: "Main",
            field: "is_main",
            sorting: false,
            render: isMainStatus,
            width: 71,
            type: "boolean"
        },
        {
            title: "Name",
            field: "fullName",
            width: 277
        },
        {
            title: "Title General",
            field: "titleInternal.name",
            width: 209
        },
        {
            title: "Title",
            field: "title_external",
            width: 110
        },
        {
            title: "Address",
            field: "address.name",
            width: 234
        },
        {
            title: "Email",
            field: "email",
            width: 295
        },
        {
            title: "Remove",
            sorting: false,
            width: 73
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
        columns: columns,
        data: contacts,
        loading: loading,
        handleDetails: handleDetails,
        handleRemove: handleRemove,
        crudType: (0, $gUBkJ.Types).Company
    });
};
var $8f5457eefc5d9ba5$export$2e2bcd8739ae039 = $8f5457eefc5d9ba5$var$CompanyContactsTab;

});

parcelRegister("1pXcI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c268bd8cb09e55a$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hjfla = parcelRequire("hjfla");

var $6L9uu = parcelRequire("6L9uu");

var $bSbwb = parcelRequire("bSbwb");

var $2eJeT = parcelRequire("2eJeT");

var $bilGR = parcelRequire("bilGR");

var $ehzwo = parcelRequire("ehzwo");

var $ixY8K = parcelRequire("ixY8K");

var $113NZ = parcelRequire("113NZ");

var $aanxD = parcelRequire("aanxD");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");
const $5c268bd8cb09e55a$var$defaultErrorsObj = {
    membershipName: null
};
const $5c268bd8cb09e55a$var$CompanyMembershipTab = ({ membership: membership, companyName: companyName, companyId: companyId, updateMembershipProperty: updateMembershipProperty })=>{
    const [editable, setEditable] = (0, $bh6RR.useState)(false);
    const getMemberships = (0, $hjfla.useMembershipsQuery)();
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [formErrors, setFormErroes] = (0, $bh6RR.useState)($5c268bd8cb09e55a$var$defaultErrorsObj);
    const [membershipNameOptions, setMembershipNameOptions] = (0, $bh6RR.useState)([]);
    const [membershipName, setMembershipName] = (0, $bh6RR.useState)(membership);
    const [updateMembershipName, updateMembershipNameResult] = (0, $hjfla.useUpdateCompanyMembershipMutation)();
    (0, $bh6RR.useEffect)(()=>{
        if (getMemberships.data && getMemberships.data.result) setMembershipNameOptions(getMemberships.data.result);
    }, [
        getMemberships.data
    ]);
    const getMembershipStartData = ()=>{
        return membershipName?.start_date ? (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(parseInt(membershipName.start_date)).format("MMM D, YYYY") : "";
    };
    const getMembershipEndData = ()=>{
        return membershipName?.end_date ? (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(parseInt(membershipName.end_date)).format("MMM D, YYYY") : "";
    };
    const handleEditClicked = ()=>{
        setEditable(true);
    };
    const handleMembershipChanged = (_, newValue)=>{
        if (newValue) setFormErroes({
            ...formErrors,
            membershipName: null
        });
        else setFormErroes({
            ...formErrors,
            membershipName: "Membership is required"
        });
        setMembershipName(newValue);
    };
    const handleCancel = ()=>{
        setMembershipName(membership);
        setFormErroes($5c268bd8cb09e55a$var$defaultErrorsObj);
        setEditable(false);
    };
    const handleSave = ()=>{
        const errors = {
            membershipName: null
        };
        let hasErrors = false;
        if (membershipName === null) {
            hasErrors = true;
            errors.membershipName = "Membership is required!";
        }
        if (hasErrors) setFormErroes({
            ...errors
        });
        else if (membershipName?.id) updateMembershipName({
            variables: {
                id: parseInt(companyId),
                membershipId: membershipName?.id !== null ? parseInt(membershipName?.id) : parseInt(membership.id)
            },
            update (_, { data: data }) {
                if (data?.result) {
                    updateMembershipProperty(data.result.membership);
                    setEditable(false);
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            text: `Successfylly updated ${data.result.name}`,
                            severity: "success"
                        }
                    });
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        });
        else setEditable(false);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            padding: "80px",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    position: "absolute",
                    top: "24px",
                    right: "24px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "company-membership-edit-button",
                    onClick: handleEditClicked,
                    disabled: editable,
                    editButtonColor: editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    gap: "50px 6.5%",
                    paddingX: "23.5%",
                    pt: "80px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                        id: "membership-name",
                        label: "Membership Name",
                        options: membershipNameOptions,
                        getOptionLabel: (option)=>option.name,
                        disabled: !editable,
                        values: membershipName,
                        onChange: handleMembershipChanged,
                        errorMsg: formErrors.membershipName,
                        additionalStyle: {
                            gridColumn: "span 2"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "membership-id",
                        label: "Membership ID",
                        value: membershipName !== null ? membershipName?.id : "",
                        disabled: true,
                        startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ixY8K))),
                            alt: "hashtagButton",
                            style: {
                                marginRight: "12px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "company-name",
                        label: "Company Name",
                        value: companyName ?? "",
                        disabled: true,
                        startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($113NZ))),
                            alt: "lineStyleButton",
                            style: {
                                marginRight: "12px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "membership-start-date",
                        label: "Membership Start Date",
                        value: getMembershipStartData(),
                        disabled: true,
                        startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aanxD.default), {
                            style: {
                                marginRight: "12px",
                                color: (0, $6L9uu.Colors).gray
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "membership-end-date",
                        label: "Membership End Date",
                        value: getMembershipEndData(),
                        disabled: true,
                        startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aanxD.default), {
                            style: {
                                marginRight: "12px",
                                color: (0, $6L9uu.Colors).gray
                            }
                        })
                    })
                ]
            }),
            editable && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    marginTop: "100px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "company-membership-cancel-button",
                        disabled: updateMembershipNameResult.loading,
                        onClick: handleCancel,
                        text: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "company-membership-save-button",
                        disabled: updateMembershipNameResult.loading,
                        onClick: handleSave,
                        text: "Save"
                    })
                ]
            })
        ]
    });
};
var $5c268bd8cb09e55a$export$2e2bcd8739ae039 = $5c268bd8cb09e55a$var$CompanyMembershipTab;

});
parcelRegister("ixY8K", function(module, exports) {
module.exports = new URL("hashtag.93ed38a6.svg", import.meta.url).toString();

});

parcelRegister("113NZ", function(module, exports) {
module.exports = new URL("line_style.bd78ca6c.svg", import.meta.url).toString();

});



parcelRegister("g0F20", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d1b4727f00a0b0d$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $lNwVA = parcelRequire("lNwVA");

var $22Joh = parcelRequire("22Joh");

var $chLJv = parcelRequire("chLJv");

var $5DXc5 = parcelRequire("5DXc5");

var $b42dh = parcelRequire("b42dh");

var $hNYtd = parcelRequire("hNYtd");

var $lyqvf = parcelRequire("lyqvf");
const $7d1b4727f00a0b0d$var$CompanyAddressesTabs = ({ companyId: companyId })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [isEditMode, setIsEditMode] = (0, $bh6RR.useState)(false);
    const [selectedAddress, setSelectedAddress] = (0, $bh6RR.useState)(null);
    const [openNewAddress, setOpenNewAddress] = (0, $bh6RR.useState)(false);
    const { data: data, loading: loading } = (0, $hjfla.useCompanyAddressesQuery)({
        variables: {
            company_id: companyId
        },
        fetchPolicy: "no-cache"
    });
    const [deleteAddress] = (0, $hjfla.useDeleteAddressMutation)();
    const [addresses, setAddresses] = (0, $bh6RR.useState)([]);
    const canCreate = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Company);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setAddresses(data.result);
    }, [
        data
    ]);
    const navStatus = (rowData)=>/*#__PURE__*/ (0, $ih19M.jsx)("img", {
            className: "m-auto",
            src: rowData.is_nav ? (0, (/*@__PURE__*/$parcel$interopDefault($22Joh))) : (0, (/*@__PURE__*/$parcel$interopDefault($lNwVA))),
            alt: "navStatus"
        });
    const isMainStatus = (rowData)=>/*#__PURE__*/ (0, $ih19M.jsx)("img", {
            className: "m-auto",
            src: rowData.is_main ? (0, (/*@__PURE__*/$parcel$interopDefault($22Joh))) : (0, (/*@__PURE__*/$parcel$interopDefault($lNwVA))),
            alt: "mainStatus"
        });
    const handleDetails = (rowData)=>{
        setIsEditMode(true);
        setSelectedAddress(rowData);
    };
    const handleClose = ()=>{
        setIsEditMode(false);
    };
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${rowData.name}?`,
                agreeAction: handleDelete,
                params: rowData.id
            }
        });
    };
    const handleDelete = (id)=>{
        deleteAddress({
            variables: {
                id: parseInt(id)
            },
            update (_, { data: data }) {
                if (data?.result) {
                    const deletedAddress = addresses?.find((a)=>a?.id === id);
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `Successfully deleted ${deletedAddress?.name}`,
                            autoHide: 4000
                        }
                    });
                    const filteredAddresses = addresses?.filter((a)=>a?.id !== id);
                    setAddresses(filteredAddresses);
                }
            }
        }).catch((error)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            }));
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
    };
    const handleAddAdress = (address)=>{
        setAddresses([
            address,
            ...addresses || []
        ]);
    };
    const handleEdit = (editedAddress)=>{
        setAddresses(addresses?.map((a)=>a?.id === editedAddress.id ? editedAddress : a));
    };
    const columns = [
        {
            title: "Details",
            sorting: false,
            width: 65
        },
        {
            title: "Nav",
            field: "is_nav",
            sorting: false,
            render: navStatus,
            width: 50,
            type: "boolean"
        },
        {
            title: "Main",
            field: "is_main",
            sorting: false,
            render: isMainStatus,
            width: 50,
            type: "boolean"
        },
        {
            title: "Address Name",
            field: "name",
            width: 300
        },
        {
            title: "Street",
            field: "street",
            width: 131
        },
        {
            title: "City",
            field: "city",
            width: 90
        },
        {
            title: "Country",
            field: "country.name",
            width: 100
        },
        {
            title: "Region",
            field: "country.region.name",
            width: 95
        },
        {
            title: "VAT",
            field: "vat_number",
            width: 125
        },
        {
            title: "Phone",
            field: "phone",
            width: 125
        },
        {
            title: "Email",
            field: "email",
            width: 180
        },
        {
            title: "Remove",
            sorting: false,
            width: 80
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        className: "centralize",
        sx: {
            width: "100%",
            paddingTop: "80px"
        },
        children: isEditMode ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $hNYtd.default), {
            handleClose: handleClose,
            address: selectedAddress,
            handleEdit: handleEdit
        }) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5DXc5.default), {
            headerText: "Addresses",
            width: "82%",
            additionalStyle: {
                height: "680px"
            },
            createButtonProps: {
                id: "Add-Address-Button",
                onClick: ()=>setOpenNewAddress(true),
                text: "+ ADD ADDRESS",
                disabled: !canCreate || loading
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
                    columns: columns,
                    data: addresses,
                    loading: loading,
                    handleDetails: handleDetails,
                    handleRemove: handleRemove,
                    pageSize: 10,
                    crudType: (0, $gUBkJ.Types).Company
                }),
                openNewAddress && /*#__PURE__*/ (0, $ih19M.jsx)((0, $lyqvf.default), {
                    handleClose: ()=>setOpenNewAddress(false),
                    updateList: handleAddAdress,
                    companyId: companyId
                })
            ]
        })
    });
};
var $7d1b4727f00a0b0d$export$2e2bcd8739ae039 = $7d1b4727f00a0b0d$var$CompanyAddressesTabs;

});
parcelRegister("hNYtd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ebf5dcec5b8d54f$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $5DXc5 = parcelRequire("5DXc5");

var $eAEaz = parcelRequire("eAEaz");
const $6ebf5dcec5b8d54f$var$AddressDetails = ({ handleClose: handleClose, address: address, handleEdit: handleEdit })=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5DXc5.default), {
        headerText: "Details",
        width: "82%",
        additionalStyle: {
            height: "680px"
        },
        navigationButton: {
            id: "Back-to-Addresses",
            text: "Addresses",
            onClick: handleClose
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eAEaz.default), {
            addressInput: address,
            handleClose: handleClose,
            updateList: handleEdit
        })
    });
};
var $6ebf5dcec5b8d54f$export$2e2bcd8739ae039 = $6ebf5dcec5b8d54f$var$AddressDetails;

});
parcelRegister("eAEaz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8132eccff1f48a9c$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $4XrUr = parcelRequire("4XrUr");
var $1dAUG = parcelRequire("1dAUG");
var $24g3l = parcelRequire("24g3l");
var $5N10K = parcelRequire("5N10K");
var $bwbWe = parcelRequire("bwbWe");
var $jZ25f = parcelRequire("jZ25f");
var $aPODr = parcelRequire("aPODr");
var $cSN6l = parcelRequire("cSN6l");
var $9O6Nb = parcelRequire("9O6Nb");
var $8fqhx = parcelRequire("8fqhx");
var $dgmqH = parcelRequire("dgmqH");
var $4HYDE = parcelRequire("4HYDE");

var $chLJv = parcelRequire("chLJv");
var $7btqX = parcelRequire("7btqX");
var $bIyvl = parcelRequire("bIyvl");
var $lGURI = parcelRequire("lGURI");
var $aitry = parcelRequire("aitry");

var $hjfla = parcelRequire("hjfla");

var $6L9uu = parcelRequire("6L9uu");

var $d13i8 = parcelRequire("d13i8");

var $bSbwb = parcelRequire("bSbwb");

var $1ZlXU = parcelRequire("1ZlXU");

var $bilGR = parcelRequire("bilGR");

var $ehzwo = parcelRequire("ehzwo");

var $dqRXb = parcelRequire("dqRXb");

var $bu31C = parcelRequire("bu31C");

var $gUBkJ = parcelRequire("gUBkJ");

var $k74RJ = parcelRequire("k74RJ");

var $QN5OM = parcelRequire("QN5OM");

var $ayVxz = parcelRequire("ayVxz");
var $8132eccff1f48a9c$var$FormErrorEnums;
(function(FormErrorEnums) {
    FormErrorEnums["Name"] = "Address name too short!";
    FormErrorEnums["Street"] = "Street too short!";
    FormErrorEnums["Country"] = "Country is required!";
    FormErrorEnums["City"] = "City too short!";
    FormErrorEnums["Region"] = "Region is required!";
})($8132eccff1f48a9c$var$FormErrorEnums || ($8132eccff1f48a9c$var$FormErrorEnums = {}));
const $8132eccff1f48a9c$var$defaultErrorsObj = {
    name: null,
    street: null,
    country: null,
    city: null,
    region: null
};
const $8132eccff1f48a9c$var$AddressForm = ({ addressInput: addressInput, handleClose: handleClose, updateList: updateList, companyId: companyId })=>{
    const [editable, setEditable] = (0, $bh6RR.useState)(addressInput === undefined);
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Company);
    const [regionOptions, setRegionOptions] = (0, $bh6RR.useState)([]);
    const [countyOptions, setCountryOptions] = (0, $bh6RR.useState)([]);
    const countries = (0, $hjfla.useCountriesQuery)();
    const regions = (0, $hjfla.useRegionsQuery)();
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($8132eccff1f48a9c$var$defaultErrorsObj);
    const [name, setName] = (0, $bh6RR.useState)(addressInput?.name || "");
    const [street, setStreet] = (0, $bh6RR.useState)(addressInput?.street || "");
    const [city, setCity] = (0, $bh6RR.useState)(addressInput?.city || "");
    const [zip, setZip] = (0, $bh6RR.useState)(addressInput?.zip || "");
    const [phone, setPhone] = (0, $bh6RR.useState)(addressInput?.phone || "");
    const [fax, setFax] = (0, $bh6RR.useState)(addressInput?.fax || "");
    const [email, setEmail] = (0, $bh6RR.useState)(addressInput?.email || "");
    const [vat_number, setVat] = (0, $bh6RR.useState)(addressInput?.vat_number || "");
    const [vat_country_code, setVatCountryCode] = (0, $bh6RR.useState)(addressInput?.vat_country_code || "");
    const [is_website, setIsWebsite] = (0, $bh6RR.useState)(addressInput?.is_website);
    const [is_main, setIsMain] = (0, $bh6RR.useState)(addressInput?.is_main);
    const [is_nav, setIsNav] = (0, $bh6RR.useState)(addressInput?.is_nav);
    const [country, setCountry] = (0, $bh6RR.useState)(addressInput?.country || null);
    const [region, setRegion] = (0, $bh6RR.useState)(addressInput?.country.region || null);
    const [updateAddress] = (0, $hjfla.useUpdateAddressMutation)();
    const [addAddress] = (0, $hjfla.useAddAddressMutation)();
    (0, $bh6RR.useEffect)(()=>{
        if (countries.data && countries.data.result) setCountryOptions(countries.data.result);
        if (regions.data && regions.data.result) setRegionOptions(regions.data.result);
    }, [
        countries.data,
        regions.data
    ]);
    const handleCancel = ()=>{
        if (editable && addressInput) {
            setName(addressInput.name);
            setStreet(addressInput.street);
            setCountry(addressInput.country || null);
            setCity(addressInput.city);
            setZip(addressInput.zip || "");
            setRegion(addressInput.country.region || null);
            setPhone(addressInput.phone || "");
            setFax(addressInput.fax || "");
            setEmail(addressInput.email || "");
            setVat(addressInput.vat_number || "");
            setVatCountryCode(addressInput.vat_country_code || "");
            setIsWebsite(addressInput.is_website);
            setIsMain(addressInput.is_main);
            setIsNav(addressInput.is_nav);
            setEditable(false);
            setFormErrors($8132eccff1f48a9c$var$defaultErrorsObj);
        } else handleClose();
    };
    const handleNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!value || value.length < 2) setFormErrors({
            ...formErrors,
            name: "Address name too short!"
        });
        else setFormErrors({
            ...formErrors,
            name: null
        });
        setName(value);
    };
    const handleCityChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!value || value.length < 2) setFormErrors({
            ...formErrors,
            city: "City too short!"
        });
        else setFormErrors({
            ...formErrors,
            city: null
        });
        setCity(value);
    };
    const handleStreetChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!value || value.length < 2) setFormErrors({
            ...formErrors,
            street: "Street too short!"
        });
        else setFormErrors({
            ...formErrors,
            street: null
        });
        setStreet(value);
    };
    const handleCountryChange = (_, newValue)=>{
        if (newValue) {
            const country = newValue;
            setFormErrors({
                ...formErrors,
                country: null,
                region: null
            });
            const region = regions.data?.result.find((r)=>r?.id === country.region?.id);
            setRegion(region);
        } else setFormErrors({
            ...formErrors,
            country: "Country is required!"
        });
        setCountry(newValue);
    };
    const handleRegionChange = (_, newValue)=>{
        if (newValue) {
            const region = newValue;
            const possibleCountryOptions = countries.data?.result.filter((c)=>c?.region?.id === region.id);
            setCountryOptions(possibleCountryOptions);
            setFormErrors({
                ...formErrors,
                region: null
            });
        } else {
            setCountryOptions(countries.data?.result);
            setFormErrors({
                ...formErrors,
                region: "Region is required!"
            });
        }
        setCountry(null);
        setRegion(newValue);
    };
    const handleSubmit = ()=>{
        const errors = {
            name: null,
            street: null,
            country: null,
            city: null,
            region: null
        };
        let hasErrors = false;
        if (!name || name.length < 2) {
            errors.name = "Address name too short!";
            hasErrors = true;
        }
        if (!street || street.length < 2) {
            errors.street = "Street too short!";
            hasErrors = true;
        }
        if (!country) {
            errors.country = "Country is required!";
            hasErrors = true;
        }
        if (!city || city.length < 2) {
            errors.city = "City too short!";
            hasErrors = true;
        }
        if (hasErrors) setFormErrors(errors);
        else handleSave(addressInput === undefined ? "create" : "update");
    };
    const handleSave = (type)=>{
        const countryInput = country;
        const input = {
            zip: zip,
            fax: fax,
            country_id: parseInt(countryInput.id),
            name: name,
            street: street,
            city: city,
            vat_number: vat_number,
            phone: phone,
            email: email,
            is_main: is_main,
            is_nav: is_nav,
            is_website: is_website,
            vat_country_code: vat_country_code
        };
        if (type === "create") addAddress({
            variables: {
                company_id: companyId,
                input: input
            },
            update (_, { data: data }) {
                if (data?.result) {
                    updateList(data.result);
                    handleClose();
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `You have successfully added ${data.result.name} to the list of addresses`
                        }
                    });
                }
            }
        }).catch((e)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            }));
        else updateAddress({
            variables: {
                id: parseInt(addressInput.id),
                input: input
            },
            update (_, { data: data }) {
                if (data?.result) {
                    handleClose();
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `You have successfully updated ${data.result.name}'s address data`
                        }
                    });
                    updateList(data?.result);
                }
            }
        }).catch((e)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            }));
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            padding: "80px",
            position: "relative"
        },
        children: [
            addressInput && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    position: "absolute",
                    top: "24px",
                    right: "24px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "edit-address-button",
                    onClick: ()=>setEditable(true),
                    disabled: !canEdit || editable,
                    editButtonColor: !canEdit || editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            formErrors.updateError && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                style: {
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), {
                    color: "error",
                    children: formErrors.updateError.message
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    columnGap: "7.2%",
                    paddingX: "5%"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            display: "grid",
                            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                            gap: "35px 14%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "address-name",
                                label: "Address Name",
                                value: name,
                                onChange: handleNameChange,
                                disabled: !editable,
                                errorMsg: formErrors.name,
                                additionalStyle: {
                                    gridColumn: "span 2"
                                },
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bwbWe.default), {
                                    sx: {
                                        mr: "12px",
                                        color: editable ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "street",
                                label: "Street",
                                value: street,
                                onChange: handleStreetChange,
                                disabled: !editable,
                                errorMsg: formErrors.street,
                                additionalStyle: {
                                    gridColumn: "span 2"
                                },
                                startAdornment: editable ? /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($k74RJ))),
                                    alt: "addRoadButton",
                                    style: {
                                        marginRight: "12px"
                                    }
                                }) : /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($QN5OM))),
                                    alt: "addRoadButton",
                                    style: {
                                        marginRight: "12px"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "countries",
                                label: "Country",
                                options: countyOptions,
                                getOptionLabel: (option)=>option?.name,
                                disabled: !editable,
                                values: country,
                                onChange: handleCountryChange,
                                errorMsg: formErrors.country,
                                additionalStyle: {
                                    gridColumn: "span 2"
                                },
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9O6Nb.default), {
                                    sx: {
                                        mr: "12px",
                                        color: editable ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "city",
                                label: "City",
                                value: city,
                                onChange: handleCityChange,
                                disabled: !editable,
                                errorMsg: formErrors.city,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4HYDE.default), {
                                    sx: {
                                        mr: "12px",
                                        color: editable ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "zip",
                                label: "ZIP Code",
                                value: zip ?? "",
                                onChange: (e)=>setZip(e.target.value),
                                disabled: !editable,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $24g3l.default), {
                                    sx: {
                                        mr: "12px",
                                        color: editable ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                                id: "regions",
                                label: "Region",
                                options: regionOptions,
                                getOptionLabel: (option)=>option?.name,
                                disabled: !editable,
                                values: region,
                                onChange: handleRegionChange,
                                errorMsg: formErrors.region,
                                additionalStyle: {
                                    gridColumn: "span 2"
                                },
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5N10K.default), {
                                    sx: {
                                        mr: "12px",
                                        color: editable ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            display: "grid",
                            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                            gap: "35px 5%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "phone",
                                label: "Phone (direct)",
                                value: phone ?? "",
                                onChange: (e)=>setPhone(e.target.value),
                                disabled: !editable,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aPODr.default), {
                                    sx: {
                                        mr: "12px",
                                        color: editable ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "fax",
                                label: "Fax (direct)",
                                value: fax ?? "",
                                onChange: (e)=>setFax(e.target.value),
                                disabled: !editable,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cSN6l.default), {
                                    sx: {
                                        mr: "12px",
                                        color: editable ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "email",
                                label: "Email (direct)",
                                value: email ?? "",
                                onChange: (e)=>setEmail(e.target.value),
                                disabled: !editable,
                                additionalStyle: {
                                    gridColumn: "span 2"
                                },
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1dAUG.default), {
                                    sx: {
                                        mr: "12px",
                                        color: editable ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "vat-code",
                                label: "VAT Country Code",
                                value: vat_country_code ?? "",
                                onChange: (e)=>setVatCountryCode(e.target.value),
                                disabled: !editable,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $jZ25f.default), {
                                    sx: {
                                        mr: "12px",
                                        color: editable ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "vat",
                                label: "VAT Number",
                                value: vat_number ?? "",
                                onChange: (e)=>setVat(e.target.value),
                                disabled: !editable,
                                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $dgmqH.default), {
                                    sx: {
                                        mr: "12px",
                                        color: editable ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bIyvl.default), {
                                control: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lGURI.default), {
                                    id: "is-website",
                                    checked: is_website || false,
                                    onChange: ()=>setIsWebsite(!is_website)
                                }),
                                label: "Show address on EPRA website",
                                labelPlacement: "start",
                                sx: {
                                    color: editable ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray,
                                    gridColumn: "span 2",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    ml: 0
                                },
                                disabled: !editable
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bIyvl.default), {
                                control: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7btqX.default), {
                                    id: "is-main",
                                    icon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8fqhx.default), {}),
                                    checkedIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4XrUr.default), {}),
                                    checked: is_main || false,
                                    onChange: ()=>setIsMain(!is_main),
                                    color: "success"
                                }),
                                label: "Main Address",
                                labelPlacement: "end",
                                style: {
                                    color: editable ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray
                                },
                                disabled: !editable
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bIyvl.default), {
                                control: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7btqX.default), {
                                    id: "is-nav",
                                    icon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8fqhx.default), {}),
                                    checkedIcon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4XrUr.default), {}),
                                    checked: is_nav || false,
                                    onChange: ()=>setIsNav(!is_nav),
                                    color: "success"
                                }),
                                label: "Nav Address",
                                labelPlacement: "end",
                                style: {
                                    color: editable ? (0, $6L9uu.Colors).main : (0, $6L9uu.Colors).gray,
                                    marginLeft: "-25%"
                                },
                                disabled: !editable
                            })
                        ]
                    })
                ]
            }),
            editable && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    marginTop: "140px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-button",
                        onClick: handleCancel,
                        text: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "save-button",
                        onClick: handleSubmit,
                        text: "Save"
                    })
                ]
            })
        ]
    });
};
var $8132eccff1f48a9c$export$2e2bcd8739ae039 = $8132eccff1f48a9c$var$AddressForm;

});
parcelRegister("24g3l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18186840bdfdc979$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $18186840bdfdc979$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2m0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), "FilterCenterFocus");

});

parcelRegister("5N10K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43725021756afca5$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $43725021756afca5$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7"
}), "GpsFixed");

});

parcelRegister("jZ25f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8c5549afc572402$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $e8c5549afc572402$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2m6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56M12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96M4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56m2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8M12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96M14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2m.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56M16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2z"
}), "Language");

});

parcelRegister("8fqhx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60141c7436f6e9b1$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $60141c7436f6e9b1$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "RadioButtonUnchecked");

});

parcelRegister("4HYDE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36da371a76b81950$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $36da371a76b81950$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5"
}), "Room");

});

parcelRegister("k74RJ", function(module, exports) {
module.exports = new URL("add_road.aa3feb06.svg", import.meta.url).toString();

});

parcelRegister("QN5OM", function(module, exports) {
module.exports = new URL("add_road_grey.1526d3a4.svg", import.meta.url).toString();

});



parcelRegister("lyqvf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35b5c2cd711da4f7$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $5PJ2i = parcelRequire("5PJ2i");

var $eAEaz = parcelRequire("eAEaz");
const $35b5c2cd711da4f7$var$NewAddress = ({ handleClose: handleClose, updateList: updateList, companyId: companyId })=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5PJ2i.default), {
        id: "alert",
        width: 1400,
        title: "New Address",
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eAEaz.default), {
            handleClose: handleClose,
            updateList: updateList,
            companyId: companyId
        })
    });
};
var $35b5c2cd711da4f7$export$2e2bcd8739ae039 = $35b5c2cd711da4f7$var$NewAddress;

});



parcelRegister("hySdq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30b4ace32bb793f1$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");

var $eBMvL = parcelRequire("eBMvL");

var $j5ie7 = parcelRequire("j5ie7");

var $1QUJb = parcelRequire("1QUJb");

var $iphId = parcelRequire("iphId");

var $iobYD = parcelRequire("iobYD");

var $bOult = parcelRequire("bOult");

var $cjvPL = parcelRequire("cjvPL");

var $a3FvN = parcelRequire("a3FvN");
const $30b4ace32bb793f1$var$MassMailInfoWrapper = ()=>{
    const [value, setValue] = (0, $bh6RR.useState)(0);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        style: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $eBMvL.default), {
                    value: value,
                    handleChange: (_, newValue)=>setValue(newValue),
                    type: "first",
                    tabProps: [
                        {
                            id: "recipient-list-tab",
                            title: "Recipient List",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1QUJb)))
                        },
                        {
                            id: "templates-tab",
                            title: "Templates",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iphId)))
                        },
                        {
                            id: "scheduler-tab",
                            title: "Scheduler",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iobYD)))
                        }
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                        value: value,
                        index: 0,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bOult.default), {})
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                    value: value,
                    index: 1,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cjvPL.default), {})
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                    value: value,
                    index: 2,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $a3FvN.default), {})
                })
            ]
        })
    });
};
var $30b4ace32bb793f1$export$2e2bcd8739ae039 = $30b4ace32bb793f1$var$MassMailInfoWrapper;

});
parcelRegister("1QUJb", function(module, exports) {
"use strict";
"use client";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1596a6b84d73d518$var$_createSvgIcon = $2ZnTs((parcelRequire("lpAdr")));

var $ih19M = parcelRequire("ih19M");
var $1596a6b84d73d518$var$_default = module.exports.default = (0, $1596a6b84d73d518$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M18 17H6v-2h12zm0-4H6v-2h12zm0-4H6V7h12zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2z"
}), "Receipt");

});

parcelRegister("bOult", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72d81431ae6f0a55$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $6L9uu = parcelRequire("6L9uu");

var $6QTYz = parcelRequire("6QTYz");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hjfla = parcelRequire("hjfla");

var $2eJeT = parcelRequire("2eJeT");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");

var $7OO4z = parcelRequire("7OO4z");
var $8AYU5 = parcelRequire("8AYU5");

var $d7fM7 = parcelRequire("d7fM7");

var $8d818 = parcelRequire("8d818");

var $daKAK = parcelRequire("daKAK");

var $5GMbf = parcelRequire("5GMbf");

var $jygxi = parcelRequire("jygxi");
const $72d81431ae6f0a55$var$RecipientList = ()=>{
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [openWizard, setOpenWizard] = (0, $bh6RR.useState)(false);
    const [opentRecipientsTabs, setOpentRecipientsTabs] = (0, $bh6RR.useState)(false);
    const { data: data, loading: loading } = (0, $hjfla.useRecipientListsQuery)();
    const [deleteRecipientList] = (0, $hjfla.useDeleteRecipientListMutation)();
    const [getRecipients, getRecipientsResult] = (0, $hjfla.useRecipientsLazyQuery)({
        fetchPolicy: "no-cache"
    });
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${rowData.name}?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleDelete = (rowData)=>{
        if (!rowData.id) return;
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteRecipientList({
            variables: {
                id: parseInt(rowData.id)
            },
            update (cache) {
                const recipientListQuery = cache.readQuery({
                    query: (0, $hjfla.RecipientListsDocument)
                });
                if (recipientListQuery.result) {
                    const cacheRecipientListIndex = recipientListQuery.result.findIndex((r)=>r?.id === rowData.id);
                    if (cacheRecipientListIndex > -1) {
                        const data = recipientListQuery.result.filter((r)=>r?.id !== rowData.id);
                        cache.writeQuery({
                            query: (0, $hjfla.RecipientListsDocument),
                            data: {
                                result: data
                            }
                        });
                    }
                }
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Recipient list deleted ${rowData.name}`,
                        severity: "success"
                    }
                });
            }
        }).catch((error)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            }));
    };
    const handleAddNewPressed = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).SetRecipientList,
            payload: {
                recipientList: {
                    id: undefined,
                    name: undefined,
                    contactTitleIds: [],
                    companyTypeIds: [],
                    membershipTypeIds: [],
                    interestIds: [],
                    countryIds: [],
                    excludedContactIds: [],
                    includedContactIds: []
                }
            }
        });
        setOpenWizard(true);
    };
    const handleSettingsPressed = (rowData)=>{
        setSelectedRecipientList(rowData);
        setOpenWizard(true);
    };
    const setSelectedRecipientList = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).SetRecipientList,
            payload: {
                recipientList: {
                    id: rowData.id,
                    name: rowData.name,
                    contactTitleIds: rowData.contact_titles.map((ct)=>ct?.id),
                    companyTypeIds: rowData.company_types.map((ct)=>ct?.id),
                    membershipTypeIds: rowData.membership_types.map((mt)=>mt?.id),
                    interestIds: rowData.interests.map((i)=>i?.id),
                    countryIds: rowData.countries.map((c)=>c?.id),
                    excludedContactIds: rowData.excluded_contact_ids ? JSON.parse(rowData.excluded_contact_ids) : [],
                    includedContactIds: rowData.included_contact_ids ? JSON.parse(rowData.included_contact_ids) : []
                }
            }
        });
    };
    const handleRecipientsPressed = (rowData)=>{
        setSelectedRecipientList(rowData);
        setOpentRecipientsTabs(true);
    };
    const renderRecipientsColumn = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: rowData.id,
            onClick: ()=>handleRecipientsPressed(rowData),
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7OO4z.default), {
                style: {
                    color: (0, $6L9uu.Colors).skyBlue
                }
            })
        });
    };
    const renderSettingsColumn = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: rowData.id,
            onClick: ()=>handleSettingsPressed(rowData),
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8AYU5.default), {
                style: {
                    color: (0, $6L9uu.Colors).skyBlue
                }
            })
        });
    };
    const renderExcelColumn = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: rowData.id,
            onClick: ()=>exportRecipientListContacts(rowData),
            children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6QTYz))),
                alt: "excelButton"
            })
        });
    };
    const exportRecipientListContacts = async (rowData)=>{
        try {
            // Use the same query as the Recipients tab so export matches what the user sees
            const { data: data, error: error } = await getRecipients({
                variables: {
                    id: parseInt(rowData.id)
                }
            });
            if (error) {
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "error",
                        text: error.message || "Failed to download recipient list",
                        autoHide: 6000
                    }
                });
                return;
            }
            const recipients = data?.result?.filter((r)=>r != null) ?? [];
            if (recipients.length === 0) {
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "error",
                        text: "No recipients found to export",
                        autoHide: 6000
                    }
                });
                return;
            }
            const listName = (rowData.name || "recipient_list").replaceAll(" ", "_");
            const fileName = `${(0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(new Date()).format("YYYY_MM_DD")}_${listName}`;
            const csvData = recipients.map((r)=>({
                    "First Name": r?.first_name || "",
                    "Last Name": r?.last_name || "",
                    Title: r?.titleInternal?.name || "",
                    Email: r?.email || ""
                }));
            (0, $daKAK.exportDataAsExcel)(csvData, fileName);
        } catch (error) {
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error?.message || "Failed to download recipient list",
                    autoHide: 6000
                }
            });
        }
    };
    const formatColumnData = (input)=>{
        const names = input.map((i)=>i.name);
        return names.join(", ");
    };
    const handleCloseWizard = ()=>{
        setOpenWizard(false);
        dispatch({
            type: (0, $ayVxz.Actions).ResetRecipientList
        });
    };
    const handleCloseRecipientsTabs = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).ResetRecipientList
        });
        setOpentRecipientsTabs(false);
    };
    const columns = [
        {
            title: "Recipients",
            width: 85,
            sorting: false,
            render: renderRecipientsColumn
        },
        {
            title: "Configure",
            width: 80,
            sorting: false,
            render: renderSettingsColumn
        },
        {
            title: "Name",
            field: "name",
            width: 180.5
        },
        {
            title: "Contact title",
            field: "contact_titles",
            width: 368,
            render: (rowData)=>formatColumnData(rowData.contact_titles)
        },
        {
            title: "Company type",
            field: "company_types",
            render: (rowData)=>formatColumnData(rowData.company_types),
            width: 234
        },
        {
            title: "Membership type",
            field: "membership_types",
            render: (rowData)=>formatColumnData(rowData.membership_types),
            width: 210
        },
        {
            title: "Country",
            field: "countries",
            render: (rowData)=>formatColumnData(rowData.countries),
            width: 150
        },
        {
            title: "Interest",
            field: "interest",
            render: (rowData)=>formatColumnData(rowData.interests),
            width: 273
        },
        {
            title: "Excel",
            width: 69,
            sorting: false,
            render: renderExcelColumn
        },
        {
            title: "Remove",
            width: 71.5,
            sorting: false
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        className: "overviewPage",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            className: "print\\:w-full",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                    columns: columns,
                    data: data?.result || [],
                    loading: loading,
                    handleDetails: ()=>true,
                    handleRemove: handleRemove,
                    pageSize: 15,
                    createButtonProps: {
                        id: "create-recipient-list-button",
                        onClick: ()=>handleAddNewPressed(),
                        text: "Add List",
                        disabled: false
                    }
                }),
                openWizard && /*#__PURE__*/ (0, $ih19M.jsx)((0, $5GMbf.default), {
                    onClose: handleCloseWizard
                }),
                opentRecipientsTabs && /*#__PURE__*/ (0, $ih19M.jsx)((0, $jygxi.default), {
                    onClose: handleCloseRecipientsTabs
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                    loading: getRecipientsResult.loading
                })
            ]
        })
    });
};
var $72d81431ae6f0a55$export$2e2bcd8739ae039 = $72d81431ae6f0a55$var$RecipientList;

});
parcelRegister("5GMbf", function(module, exports) {

$parcel$export(module.exports, "ErrorTexts", function () { return $690b9ae182906463$export$1067ba46601ca091; });
$parcel$export(module.exports, "default", function () { return $690b9ae182906463$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $gFVvY = parcelRequire("gFVvY");

var $oZMqz = parcelRequire("oZMqz");

var $dqRXb = parcelRequire("dqRXb");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $5PJ2i = parcelRequire("5PJ2i");

var $2lD0z = parcelRequire("2lD0z");

var $8d818 = parcelRequire("8d818");

var $lLIkj = parcelRequire("lLIkj");

var $CEFZW = parcelRequire("CEFZW");

var $fkrEC = parcelRequire("fkrEC");

var $9nru0 = parcelRequire("9nru0");

var $5niUC = parcelRequire("5niUC");
const $690b9ae182906463$var$defaultErrorsObj = {
    name: null,
    interest: null,
    membership: null
};
const $690b9ae182906463$export$1067ba46601ca091 = {
    name: "Recipient List name is required and should be more than 2 symbols.",
    nameExists: "This Recipient List name already exists",
    interest: "*Please select at least one interest",
    membership: "*Please select at least one membership"
};
const $690b9ae182906463$var$steps = [
    "General details",
    "Contact Title",
    "Company Type",
    "Country",
    "Recipients"
];
const $690b9ae182906463$var$RecipientListStepper = ({ onClose: onClose })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [initialRecipientlist] = (0, $bh6RR.useState)(state.selectedRecipientList);
    const [activeStep, setActiveStep] = (0, $bh6RR.useState)(0);
    const titlesInternalQuery = (0, $hjfla.useTitlesInternalQuery)({
        fetchPolicy: "no-cache"
    });
    const [titlesInternal, setTitlesInternal] = (0, $bh6RR.useState)([]);
    const membershipTypesQuery = (0, $hjfla.useMembershipTypesQuery)({
        fetchPolicy: "no-cache"
    });
    const [membershipTypes, setMembershipTypes] = (0, $bh6RR.useState)([]);
    const interestsQuery = (0, $hjfla.useGetInterestsQuery)({
        fetchPolicy: "no-cache"
    });
    const [interests, setInterests] = (0, $bh6RR.useState)([]);
    const companyTypesQuery = (0, $hjfla.useCompanyTypesQuery)({
        fetchPolicy: "no-cache"
    });
    const [companyTypes, setCompanyTypes] = (0, $bh6RR.useState)([]);
    const countriesQuery = (0, $hjfla.useCountriesQuery)({
        fetchPolicy: "no-cache"
    });
    const [countries, setCountries] = (0, $bh6RR.useState)([]);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($690b9ae182906463$var$defaultErrorsObj);
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).RecipientList);
    const [createRecipientList, createRecipientListResult] = (0, $hjfla.useCreateRecipientListMutation)();
    const [updateRecipientList, updateRecipientListResult] = (0, $hjfla.useUpdateRecipientListMutation)();
    (0, $bh6RR.useEffect)(()=>{
        if (titlesInternalQuery.data && titlesInternalQuery.data.result) setTitlesInternal(titlesInternalQuery.data.result);
        if (companyTypesQuery.data && companyTypesQuery.data.result) setCompanyTypes(companyTypesQuery.data.result);
        if (membershipTypesQuery.data && membershipTypesQuery.data.result) setMembershipTypes(membershipTypesQuery.data.result);
        if (interestsQuery.data && interestsQuery.data.result) setInterests(interestsQuery.data.result);
        if (countriesQuery.data && countriesQuery.data.result) setCountries(countriesQuery.data.result);
    }, [
        titlesInternalQuery.data,
        companyTypesQuery.data,
        membershipTypesQuery.data,
        interestsQuery.data,
        countriesQuery.data
    ]);
    const getStepContent = (stepIndex)=>{
        switch(stepIndex){
            case 0:
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $9nru0.default), {
                    membershipTypes: membershipTypes,
                    interests: interests,
                    formErrors: formErrors,
                    setFormErrors: setFormErrors
                });
            case 1:
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $CEFZW.default), {
                    data: titlesInternal
                });
            case 2:
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lLIkj.default), {
                    data: companyTypes
                });
            case 3:
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $fkrEC.default), {
                    countries: countries
                });
            case 4:
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5niUC.default), {});
            default:
                return "Unknown stepIndex";
        }
    };
    const handleBack = ()=>{
        setActiveStep((prevActiveStep)=>prevActiveStep - 1);
    };
    const handleNext = ()=>{
        if (activeStep === 0) {
            let hasErrors = formErrors.interest || formErrors.name || formErrors.membership ? true : false;
            let currentErrors = formErrors;
            if (formErrors.name === null) {
                if (state.selectedRecipientList?.name && state.selectedRecipientList.name.length > 1) {
                    if ((0, $gFVvY.sameRecipientListExists)(state.selectedRecipientList.name.trim(), parseInt(state.selectedRecipientList?.id ?? ""))) {
                        hasErrors = true;
                        currentErrors = {
                            ...currentErrors,
                            name: $690b9ae182906463$export$1067ba46601ca091.nameExists
                        };
                    }
                } else {
                    hasErrors = true;
                    currentErrors = {
                        ...currentErrors,
                        name: $690b9ae182906463$export$1067ba46601ca091.name
                    };
                }
            }
            if (formErrors.interest === null) {
                if (state.selectedRecipientList?.interestIds.length === 0) {
                    hasErrors = true;
                    currentErrors = {
                        ...currentErrors,
                        interest: $690b9ae182906463$export$1067ba46601ca091.interest
                    };
                }
            }
            if (formErrors.membership === null) {
                if (state.selectedRecipientList?.membershipTypeIds.length === 0) {
                    hasErrors = true;
                    currentErrors = {
                        ...currentErrors,
                        membership: $690b9ae182906463$export$1067ba46601ca091.membership
                    };
                }
            }
            if (hasErrors) setFormErrors(currentErrors);
            else setActiveStep((prevActiveStep)=>prevActiveStep + 1);
        } else if (activeStep === 4) {
            const selectedRecipientList = state.selectedRecipientList;
            // Check if recipient list is new or old!
            if (selectedRecipientList.id) {
                if (isValidRecipientList(selectedRecipientList)) {
                    if ((0, $oZMqz.objectsAreEquel)(initialRecipientlist, state.selectedRecipientList)) {
                        dispatch({
                            type: (0, $ayVxz.Actions).ShowMessage,
                            payload: {
                                severity: "success",
                                text: `You have successfully updated recipient list ${selectedRecipientList.name}`
                            }
                        });
                        onClose();
                    } else updateRecipientList({
                        variables: {
                            input: getRecipientListDto(selectedRecipientList, false)
                        },
                        update (_, { data: data }) {
                            if (data?.result) {
                                dispatch({
                                    type: (0, $ayVxz.Actions).ShowMessage,
                                    payload: {
                                        severity: "success",
                                        text: `You have successfully updated recipient list ${selectedRecipientList.name}`
                                    }
                                });
                                onClose();
                            }
                        }
                    }).catch((e)=>{
                        dispatch({
                            type: (0, $ayVxz.Actions).ShowMessage,
                            payload: {
                                severity: "error",
                                text: e.message,
                                autoHide: 6000
                            }
                        });
                    });
                }
            } else if (isValidRecipientList(selectedRecipientList)) createRecipientList({
                variables: {
                    input: getRecipientListDto(selectedRecipientList, true)
                },
                update (_, { data: data }) {
                    if (data?.result) {
                        dispatch({
                            type: (0, $ayVxz.Actions).ShowMessage,
                            payload: {
                                severity: "success",
                                text: `You have successfully created new recipient list ${selectedRecipientList.name}`
                            }
                        });
                        onClose();
                    }
                }
            }).catch((e)=>{
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "error",
                        text: e.message,
                        autoHide: 6000
                    }
                });
            });
        } else setActiveStep((prevActiveStep)=>prevActiveStep + 1);
    };
    const isValidRecipientList = (selectedRecipientList)=>{
        if (!selectedRecipientList.name || selectedRecipientList.name.length < 2) return false;
        if (!selectedRecipientList.membershipTypeIds.length) return false;
        if (!selectedRecipientList.interestIds.length) return false;
        return true;
    };
    const getRecipientListDto = (selectedRecipientList, isNew)=>{
        const result = {
            name: selectedRecipientList.name,
            membership_type_ids: selectedRecipientList.membershipTypeIds.map((m)=>parseInt(m)),
            interest_ids: selectedRecipientList.interestIds.map((i)=>parseInt(i)),
            company_type_ids: selectedRecipientList.companyTypeIds.map((c)=>parseInt(c)),
            contact_title_ids: selectedRecipientList.contactTitleIds.map((c)=>parseInt(c)),
            country_ids: selectedRecipientList.countryIds.map((c)=>parseInt(c)),
            excluded_contact_ids: selectedRecipientList.excludedContactIds,
            included_contact_ids: selectedRecipientList.includedContactIds
        };
        if (!isNew) result.id = parseInt(selectedRecipientList.id);
        return result;
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "recipient-list-wizard-stepper",
        title: state.selectedRecipientList?.id ? "List Configuration" : "Create List",
        width: 1200,
        height: 843,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2lD0z.default), {
                steps: $690b9ae182906463$var$steps,
                activeStep: activeStep
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    minHeight: "370px"
                },
                children: getStepContent(activeStep)
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    gridColumn: "span 3",
                    mt: "20px"
                },
                children: [
                    activeStep !== 0 && /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "recipient-list-wizard-back-button",
                        onClick: handleBack,
                        text: "Back"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: `recipient-list-wizard-${activeStep === $690b9ae182906463$var$steps.length - 1 ? "save" : "next"}-button`,
                        disabled: activeStep === $690b9ae182906463$var$steps.length - 1 && !canEdit,
                        onClick: handleNext,
                        text: activeStep === $690b9ae182906463$var$steps.length - 1 ? "Save" : "Next"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                loading: titlesInternalQuery.loading || companyTypesQuery.loading || countriesQuery.loading || membershipTypesQuery.loading || createRecipientListResult.loading || updateRecipientListResult.loading
            })
        ]
    });
};
var $690b9ae182906463$export$2e2bcd8739ae039 = $690b9ae182906463$var$RecipientListStepper;

});
parcelRegister("lLIkj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d0754796e303b8a$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $gu8wR = parcelRequire("gu8wR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $jJUYF = parcelRequire("jJUYF");

var $3RBiD = parcelRequire("3RBiD");


var $1NlP3 = parcelRequire("1NlP3");
const $9d0754796e303b8a$var$CompanyTypeStep = ({ data: data })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [displayedTypes, setDisplayedTypes] = (0, $bh6RR.useState)(data);
    const [selectedTypeIds, setSelectedTypeIds] = (0, $bh6RR.useState)(state.selectedRecipientList?.companyTypeIds || []);
    const handleCheckClicked = (typeId)=>{
        let companyTypeIds = [];
        if (selectedTypeIds.includes(typeId)) {
            companyTypeIds = selectedTypeIds.filter((id)=>id !== typeId);
            setSelectedTypeIds(companyTypeIds);
        } else {
            companyTypeIds = [
                typeId,
                ...selectedTypeIds
            ];
            setSelectedTypeIds(companyTypeIds);
        }
        dispatch({
            type: (0, $ayVxz.Actions).SetRecipientListCompanyTypes,
            payload: {
                companyTypeIds: companyTypeIds
            }
        });
    };
    const filterValues = (text)=>{
        const filtered = data.filter((t)=>t.name.toLowerCase().includes(text.toLowerCase()));
        setDisplayedTypes(filtered);
    };
    const handleAllClicked = ()=>{
        const companyTypeIds = data?.map((t)=>t.id);
        setSelectedTypeIds(companyTypeIds);
        dispatch({
            type: (0, $ayVxz.Actions).SetRecipientListCompanyTypes,
            payload: {
                companyTypeIds: companyTypeIds
            }
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "step-container",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "section-header",
                sx: {
                    height: "80px",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $jJUYF.default), {
                        id: "company-type-step-search-input",
                        filter: filterValues,
                        sx: {
                            width: "40%"
                        }
                    }),
                    selectedTypeIds.length > 0 ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                        id: "selected-company-types-count",
                        "data-testid": "selected-company-types-count",
                        size: "small",
                        className: "header-chip",
                        label: `${selectedTypeIds.length} company ${selectedTypeIds.length === 1 ? "type" : "types"} selected`,
                        onDelete: ()=>{
                            setSelectedTypeIds([]);
                            dispatch({
                                type: (0, $ayVxz.Actions).SetRecipientListCompanyTypes,
                                payload: {
                                    companyTypeIds: []
                                }
                            });
                        }
                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $1NlP3.default), {
                        onClick: handleAllClicked,
                        text: `${data.length} company types`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                className: "step-content-container",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3RBiD.default), {
                    data: displayedTypes,
                    clickedValues: selectedTypeIds,
                    handleCheckClicked: handleCheckClicked,
                    editable: true,
                    staticGrid: true
                })
            })
        ]
    });
};
var $9d0754796e303b8a$export$2e2bcd8739ae039 = $9d0754796e303b8a$var$CompanyTypeStep;

});
parcelRegister("jJUYF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5ad6b9f4d9182b0$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $jIOsh = parcelRequire("jIOsh");

var $5LQ5V = parcelRequire("5LQ5V");

var $bh6RR = parcelRequire("bh6RR");

var $6L9uu = parcelRequire("6L9uu");
const $b5ad6b9f4d9182b0$var$SearchInput = ({ id: id, filter: filter, sx: sx })=>{
    const [searchValue, setSearchValue] = (0, $bh6RR.useState)("");
    const handleValueChange = (event)=>{
        const { value: value } = event.currentTarget;
        filter(value);
        setSearchValue(value);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5LQ5V.default), {
        id: id,
        variant: "standard",
        "data-testid": id,
        value: searchValue,
        onChange: handleValueChange,
        size: "small",
        sx: {
            color: (0, $6L9uu.Colors).main,
            background: (0, $6L9uu.Colors).white,
            borderRadius: "9px",
            width: "100%",
            height: 36,
            ...sx
        },
        placeholder: "Search...",
        InputProps: {
            endAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $jIOsh.default), {
                style: {
                    color: (0, $6L9uu.Colors).main,
                    width: 18,
                    height: 18
                }
            }),
            disableUnderline: true,
            style: {
                marginTop: "auto",
                marginBottom: "auto",
                marginLeft: 24,
                marginRight: 16.5
            }
        },
        className: "custom-search"
    });
};
var $b5ad6b9f4d9182b0$export$2e2bcd8739ae039 = $b5ad6b9f4d9182b0$var$SearchInput;

});

parcelRegister("3RBiD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $958142e39d83cf6a$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");

var $eldXE = parcelRequire("eldXE");
const $958142e39d83cf6a$var$ContentGrid = ({ data: data, handleCheckClicked: handleCheckClicked, clickedValues: clickedValues, editable: editable, staticGrid: staticGrid = false })=>{
    const getCleanName = (name)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return name.replaceAll(" ", "-");
    };
    const getContainerStyle = ()=>{
        const notStatic = {
            display: "flex",
            flexWrap: "wrap",
            columnGap: "12px"
        };
        const staticFlex = {
            display: "grid",
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
            columnGap: "12px"
        };
        return staticGrid ? staticFlex : notStatic;
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        sx: getContainerStyle(),
        children: data.map((value, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $eldXE.default), {
                id: `${value.id}-${getCleanName(value.name)}-checkbox`,
                disabled: !editable,
                onChange: ()=>handleCheckClicked(value?.id),
                value: clickedValues.includes(value.id),
                label: value.name
            }, index))
    });
};
var $958142e39d83cf6a$export$2e2bcd8739ae039 = $958142e39d83cf6a$var$ContentGrid;

});

parcelRegister("1NlP3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $125960636eb6d0ec$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
parcelRequire("bh6RR");

const $125960636eb6d0ec$var$SelectAllButton = ({ onClick: onClick, text: text })=>{
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "button-container",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                className: "button-container__button-width",
                onClick: onClick,
                children: "All"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "section-header-info-text",
                children: text
            })
        ]
    });
};
var $125960636eb6d0ec$export$2e2bcd8739ae039 = $125960636eb6d0ec$var$SelectAllButton;

});


parcelRegister("CEFZW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7205bae78b79973c$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $gu8wR = parcelRequire("gu8wR");

var $jJUYF = parcelRequire("jJUYF");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $3RBiD = parcelRequire("3RBiD");


var $1NlP3 = parcelRequire("1NlP3");
const $7205bae78b79973c$var$ContactTitleStep = ({ data: data })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [currentTitles, setCurrentTitles] = (0, $bh6RR.useState)(data);
    const [selectedTitlesIds, setSelectedTitlesIds] = (0, $bh6RR.useState)(state.selectedRecipientList?.contactTitleIds || []);
    (0, $bh6RR.useEffect)(()=>{
        setCurrentTitles(data);
    }, [
        data
    ]);
    const handleCheckClicked = (titleId)=>{
        let titles = [];
        if (selectedTitlesIds.includes(titleId)) {
            titles = selectedTitlesIds.filter((id)=>id !== titleId);
            setSelectedTitlesIds(titles);
        } else {
            titles = [
                titleId,
                ...selectedTitlesIds
            ];
            setSelectedTitlesIds(titles);
        }
        dispatch({
            type: (0, $ayVxz.Actions).SetRecipientListContactTitles,
            payload: {
                contactTitleIds: titles
            }
        });
    };
    const filterValues = (text)=>{
        const filtered = data.filter((t)=>t.name.toLowerCase().includes(text.toLowerCase()));
        setCurrentTitles(filtered);
    };
    const handleAllClicked = ()=>{
        const titles = data?.map((t)=>t.id);
        setSelectedTitlesIds(titles);
        dispatch({
            type: (0, $ayVxz.Actions).SetRecipientListContactTitles,
            payload: {
                contactTitleIds: titles
            }
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "step-container",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "section-header",
                sx: {
                    height: "80px",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $jJUYF.default), {
                        id: "contact-title-step-search-input",
                        filter: filterValues,
                        sx: {
                            width: "40%"
                        }
                    }),
                    selectedTitlesIds.length > 0 ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                        id: "selected-contact-types-count",
                        "data-testid": "selected-contact-types-count",
                        size: "small",
                        className: "header-chip",
                        label: `${selectedTitlesIds.length} contact ${selectedTitlesIds.length === 1 ? "title" : "titles"} selected`,
                        onDelete: ()=>{
                            setSelectedTitlesIds([]);
                            dispatch({
                                type: (0, $ayVxz.Actions).SetRecipientListContactTitles,
                                payload: {
                                    contactTitleIds: []
                                }
                            });
                        }
                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $1NlP3.default), {
                        onClick: handleAllClicked,
                        text: `${data.length} contact titles`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                className: "step-content-container",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3RBiD.default), {
                    data: currentTitles,
                    clickedValues: selectedTitlesIds,
                    handleCheckClicked: handleCheckClicked,
                    editable: true,
                    staticGrid: true
                })
            })
        ]
    });
};
var $7205bae78b79973c$export$2e2bcd8739ae039 = $7205bae78b79973c$var$ContactTitleStep;

});

parcelRegister("fkrEC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e633659f24a74d0$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $gu8wR = parcelRequire("gu8wR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $3RBiD = parcelRequire("3RBiD");

var $jJUYF = parcelRequire("jJUYF");

const $7e633659f24a74d0$var$CountryStep = ({ countries: countries })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [selectedCountryIds, setSelectedCountryIds] = (0, $bh6RR.useState)(state.selectedRecipientList?.countryIds || []);
    const [currentCountries, setCurrentCountries] = (0, $bh6RR.useState)(countries);
    (0, $bh6RR.useEffect)(()=>{
        setCurrentCountries(countries);
    }, [
        countries
    ]);
    const handleCheckClickedCountries = (typeId)=>{
        let countryIds = [];
        if (selectedCountryIds.includes(typeId)) {
            countryIds = selectedCountryIds.filter((id)=>id !== typeId);
            setSelectedCountryIds(countryIds);
        } else {
            countryIds = [
                typeId,
                ...selectedCountryIds
            ];
            setSelectedCountryIds(countryIds);
        }
        dispatch({
            type: (0, $ayVxz.Actions).SetRecipientListCountries,
            payload: {
                countryIds: countryIds
            }
        });
    };
    const filterValues = (text)=>{
        const filtered = countries.filter((c)=>c.name.toLowerCase().includes(text.toLowerCase()));
        setCurrentCountries(filtered);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "step-container",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "section-header",
                sx: {
                    height: "80px",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $jJUYF.default), {
                        id: "country-step-search-input",
                        filter: filterValues,
                        sx: {
                            width: "40%"
                        }
                    }),
                    selectedCountryIds.length > 0 ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                        id: "selected-countries-count",
                        "data-testid": "selected-countries-count",
                        size: "small",
                        className: "header-chip",
                        label: `${selectedCountryIds.length} ${selectedCountryIds.length === 1 ? "country" : "countries"} selected`,
                        onDelete: ()=>{
                            setSelectedCountryIds([]);
                            dispatch({
                                type: (0, $ayVxz.Actions).SetRecipientListCountries,
                                payload: {
                                    countryIds: []
                                }
                            });
                        }
                    }) : /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                        className: "section-header-info-text",
                        children: [
                            countries.length,
                            " countries"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                className: "step-content-container",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3RBiD.default), {
                    data: currentCountries,
                    clickedValues: selectedCountryIds,
                    handleCheckClicked: handleCheckClickedCountries,
                    editable: true,
                    staticGrid: true
                })
            })
        ]
    });
};
var $7e633659f24a74d0$export$2e2bcd8739ae039 = $7e633659f24a74d0$var$CountryStep;

});

parcelRegister("9nru0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ccab03b5c08e646$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $gu8wR = parcelRequire("gu8wR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $6L9uu = parcelRequire("6L9uu");

var $ehzwo = parcelRequire("ehzwo");

var $5GMbf = parcelRequire("5GMbf");

var $3RBiD = parcelRequire("3RBiD");

var $yv2bX = parcelRequire("yv2bX");


var $1NlP3 = parcelRequire("1NlP3");
const $7ccab03b5c08e646$var$sidePadding = "5%";
const $7ccab03b5c08e646$var$innerPadding = "10px";
const $7ccab03b5c08e646$var$GeneralDetailsTab = ({ membershipTypes: membershipTypes, interests: interests, formErrors: formErrors, setFormErrors: setFormErrors })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [selectedInterestsIds, setSelectedInterestsIds] = (0, $bh6RR.useState)(state.selectedRecipientList?.interestIds || []);
    const [selectedMembershipTypesIds, setSelectedMembershipTypesIds] = (0, $bh6RR.useState)(state.selectedRecipientList?.membershipTypeIds || []);
    const [currentMembershipTypes, setCurrentMembershipTypes] = (0, $bh6RR.useState)(membershipTypes);
    const [currentInterests, setCurrentInterests] = (0, $bh6RR.useState)(interests);
    const [name, setName] = (0, $bh6RR.useState)(state.selectedRecipientList?.name ?? "");
    (0, $bh6RR.useEffect)(()=>{
        setCurrentMembershipTypes(membershipTypes.filter((m)=>m.name != "PENSION FUND"));
    }, [
        membershipTypes
    ]);
    (0, $bh6RR.useEffect)(()=>{
        setCurrentInterests(interests);
    }, [
        interests
    ]);
    const handleNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (!value || value.length < 2) setFormErrors({
            ...formErrors,
            name: (0, $5GMbf.ErrorTexts).name
        });
        else setFormErrors({
            ...formErrors,
            name: null
        });
        setName(value);
        dispatch({
            type: (0, $ayVxz.Actions).SetRecipientListName,
            payload: {
                name: value
            }
        });
    };
    const handleCheckClickedForMembershipTypes = (typeId)=>{
        let membershipTypeIds = [];
        if (selectedMembershipTypesIds.includes(typeId)) {
            membershipTypeIds = selectedMembershipTypesIds.filter((id)=>id !== typeId);
            if (!membershipTypeIds.length) setFormErrors({
                ...formErrors,
                membership: (0, $5GMbf.ErrorTexts).membership
            });
            setSelectedMembershipTypesIds(membershipTypeIds);
        } else {
            membershipTypeIds = [
                typeId,
                ...selectedMembershipTypesIds
            ];
            setFormErrors({
                ...formErrors,
                membership: null
            });
            setSelectedMembershipTypesIds(membershipTypeIds);
        }
        dispatch({
            type: (0, $ayVxz.Actions).SetRecipientListMemberships,
            payload: {
                membershipTypeIds: membershipTypeIds
            }
        });
    };
    const handleCheckClickedForInterests = (interestId)=>{
        let interestIds = [];
        if (selectedInterestsIds.includes(interestId)) {
            interestIds = selectedInterestsIds.filter((id)=>id !== interestId);
            if (!interestIds.length) setFormErrors({
                ...formErrors,
                interest: (0, $5GMbf.ErrorTexts).interest
            });
            setSelectedInterestsIds(interestIds);
        } else {
            interestIds = [
                interestId,
                ...selectedInterestsIds
            ];
            setFormErrors({
                ...formErrors,
                interest: null
            });
            setSelectedInterestsIds(interestIds);
        }
        dispatch({
            type: (0, $ayVxz.Actions).SetRecipientListInterests,
            payload: {
                interestIds: interestIds
            }
        });
    };
    const handleAllClicked = (section)=>{
        if (section === (0, $yv2bX.RecipientListEnums).Memberships) {
            const membershipTypeIds = membershipTypes?.map((mt)=>mt.id);
            setSelectedMembershipTypesIds(membershipTypeIds);
            setFormErrors({
                ...formErrors,
                membership: null
            });
            dispatch({
                type: (0, $ayVxz.Actions).SetRecipientListMemberships,
                payload: {
                    membershipTypeIds: membershipTypeIds
                }
            });
        } else if (section === (0, $yv2bX.RecipientListEnums).Interests) {
            const interestIds = interests?.map((i)=>i.id);
            setSelectedInterestsIds(interestIds);
            setFormErrors({
                ...formErrors,
                interest: null
            });
            dispatch({
                type: (0, $ayVxz.Actions).SetRecipientListInterests,
                payload: {
                    interestIds: interestIds
                }
            });
        }
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "step-container",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                className: "section-header",
                children: "GENERAL INFO"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    px: $7ccab03b5c08e646$var$sidePadding,
                    height: "105px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                    id: "name",
                    label: "Recipient list name",
                    value: name,
                    onChange: handleNameChange,
                    errorMsg: formErrors.name
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "section-header",
                sx: {
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        children: [
                            "MEMBERSHIP",
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: "section-header-info-text",
                                style: {
                                    marginLeft: "5px",
                                    fontStyle: "italic"
                                },
                                children: "(please select at least one membership)"
                            })
                        ]
                    }),
                    selectedMembershipTypesIds.length > 0 ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                        id: "selected-membership-types-count",
                        "data-testid": "selected-membership-types-count",
                        size: "small",
                        label: `${selectedMembershipTypesIds.length} membership ${selectedMembershipTypesIds.length === 1 ? "option" : "options"} selected`,
                        className: "header-chip",
                        onDelete: ()=>{
                            setSelectedMembershipTypesIds([]);
                            setFormErrors({
                                ...formErrors,
                                membership: (0, $5GMbf.ErrorTexts).membership
                            });
                            dispatch({
                                type: (0, $ayVxz.Actions).SetRecipientListMemberships,
                                payload: {
                                    membershipTypeIds: []
                                }
                            });
                        }
                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $1NlP3.default), {
                        onClick: ()=>handleAllClicked((0, $yv2bX.RecipientListEnums).Memberships),
                        text: `${currentMembershipTypes.length} membership options`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    px: $7ccab03b5c08e646$var$sidePadding,
                    py: $7ccab03b5c08e646$var$innerPadding,
                    height: "245px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $3RBiD.default), {
                        data: currentMembershipTypes,
                        clickedValues: selectedMembershipTypesIds,
                        handleCheckClicked: handleCheckClickedForMembershipTypes,
                        editable: true
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            color: (0, $6L9uu.Colors).red
                        },
                        children: formErrors.membership
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "section-header",
                sx: {
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        children: [
                            "INTERESTS",
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: "section-header-info-text",
                                style: {
                                    marginLeft: "5px",
                                    fontStyle: "italic"
                                },
                                children: "(please select at least one interest)"
                            })
                        ]
                    }),
                    selectedInterestsIds.length > 0 ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                        id: "selected-interest-types-count",
                        "data-testid": "selected-interest-types-count",
                        size: "small",
                        label: `${selectedInterestsIds.length} interest ${selectedInterestsIds.length === 1 ? "option" : "options"} selected`,
                        className: "header-chip",
                        onDelete: ()=>{
                            setSelectedInterestsIds([]);
                            setFormErrors({
                                ...formErrors,
                                interest: (0, $5GMbf.ErrorTexts).interest
                            });
                            dispatch({
                                type: (0, $ayVxz.Actions).SetRecipientListInterests,
                                payload: {
                                    interestIds: []
                                }
                            });
                        }
                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $1NlP3.default), {
                        onClick: ()=>handleAllClicked((0, $yv2bX.RecipientListEnums).Interests),
                        text: `${currentInterests.length} interest options`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "step-content-container",
                sx: {
                    height: "119px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $3RBiD.default), {
                        data: currentInterests,
                        clickedValues: selectedInterestsIds,
                        handleCheckClicked: handleCheckClickedForInterests,
                        editable: true
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            color: (0, $6L9uu.Colors).red
                        },
                        children: formErrors.interest
                    })
                ]
            })
        ]
    });
};
var $7ccab03b5c08e646$export$2e2bcd8739ae039 = $7ccab03b5c08e646$var$GeneralDetailsTab;

});
parcelRegister("yv2bX", function(module, exports) {

$parcel$export(module.exports, "RecipientListEnums", function () { return $e5edab130edb023c$export$f6ca437ef218752d; });
var $e5edab130edb023c$export$f6ca437ef218752d;
(function(RecipientListEnums) {
    RecipientListEnums["Memberships"] = "memberships";
    RecipientListEnums["Interests"] = "interests";
})($e5edab130edb023c$export$f6ca437ef218752d || ($e5edab130edb023c$export$f6ca437ef218752d = {}));

});


parcelRegister("5niUC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83f9c0b82b06f8bc$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $ePpmI = parcelRequire("ePpmI");
var $dNs2U = parcelRequire("dNs2U");
var $i04rf = parcelRequire("i04rf");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hjfla = parcelRequire("hjfla");

var $bilGR = parcelRequire("bilGR");

var $jJUYF = parcelRequire("jJUYF");

var $6L9uu = parcelRequire("6L9uu");


var $3QjFj = parcelRequire("3QjFj");
const $83f9c0b82b06f8bc$var$recipientsPerPage = 9;
const $83f9c0b82b06f8bc$var$RecipientsStep = ()=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const { contactTitleIds: contactTitleIds, companyTypeIds: companyTypeIds, membershipTypeIds: membershipTypeIds, interestIds: interestIds, countryIds: countryIds, excludedContactIds: excludedContactIds } = state.selectedRecipientList;
    const variablesObj = {
        countryIds: countryIds.map((c)=>parseInt(c)),
        interestIds: interestIds.map((i)=>parseInt(i)),
        membershipTypeIds: membershipTypeIds.map((m)=>parseInt(m)),
        companyTypeIds: companyTypeIds.map((ct)=>parseInt(ct)),
        contactTitleIds: contactTitleIds.map((ct)=>parseInt(ct))
    };
    if (state.selectedRecipientList?.id) variablesObj.recipientListId = parseInt(state.selectedRecipientList?.id);
    const recipientListContacts = (0, $hjfla.useRecipientListContactsQuery)({
        variables: {
            ...variablesObj
        },
        fetchPolicy: "no-cache"
    });
    const additionalContactsQuery = (0, $hjfla.useContactsByInterestsQuery)({
        variables: {
            interestIds: interestIds.map((i)=>parseInt(i))
        },
        fetchPolicy: "no-cache"
    });
    const [additionalContacts, setAdditionalContacts] = (0, $bh6RR.useState)([]);
    const [recipientList, setRecipientList] = (0, $bh6RR.useState)([]);
    const [displayedRecipients, setDisplayedRecipients] = (0, $bh6RR.useState)([]);
    const [options, setOptions] = (0, $bh6RR.useState)([]);
    const [key, setKey] = (0, $bh6RR.useState)("0");
    const [pages, setPages] = (0, $bh6RR.useState)(0);
    const [currentPage, setCurrentPage] = (0, $bh6RR.useState)(1);
    const [searchText, setSearchText] = (0, $bh6RR.useState)("");
    const [excludedList, setExcludedList] = (0, $bh6RR.useState)(excludedContactIds);
    (0, $bh6RR.useEffect)(()=>{
        if (excludedList != excludedContactIds) dispatch({
            type: (0, $ayVxz.Actions).SetRecipientListExcludedContacts,
            payload: {
                excludedContactIds: excludedList
            }
        });
    }, [
        excludedList
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (additionalContactsQuery.data && additionalContactsQuery.data.result) {
            const contacts = additionalContactsQuery.data.result;
            setAdditionalContacts(contacts);
            if (recipientListContacts.data && recipientListContacts.data.result) {
                const res = recipientListContacts.data.result;
                const resIds = res.map((r)=>r.id);
                setOptions(contacts.filter((i)=>!resIds.includes(i.id)));
            } else setOptions(contacts);
        }
    }, [
        additionalContactsQuery.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (recipientListContacts.data && recipientListContacts.data.result) {
            const res = recipientListContacts.data.result;
            const resIds = res.map((r)=>r.id);
            setRecipientList(res);
            setDisplayedRecipients(res.slice(0, $83f9c0b82b06f8bc$var$recipientsPerPage));
            setPages(res.length > $83f9c0b82b06f8bc$var$recipientsPerPage ? Math.ceil(res.length / $83f9c0b82b06f8bc$var$recipientsPerPage) : 0);
            setOptions(additionalContacts.filter((i)=>!resIds.includes(i.id)));
        }
    }, [
        recipientListContacts.data
    ]);
    const handleAddRecipient = (_, newValue)=>{
        if (newValue) {
            const isNew = !excludedList.includes(parseInt(newValue.id));
            if (!isNew) setExcludedList(excludedList.filter((i)=>i !== parseInt(newValue.id)));
            else dispatch({
                type: (0, $ayVxz.Actions).RecipientListIncludeContact,
                payload: {
                    contactId: parseInt(newValue.id)
                }
            });
            const newData = [
                {
                    ...newValue,
                    isNew: isNew
                },
                ...recipientList
            ];
            setRecipientList(newData);
            const filtered = filterRecipients(newData, searchText);
            if (newData.length > $83f9c0b82b06f8bc$var$recipientsPerPage) setDisplayedRecipients(filtered.slice(0, $83f9c0b82b06f8bc$var$recipientsPerPage));
            else setDisplayedRecipients(filtered);
            setOptions(options.filter((o)=>o.id !== newValue.id));
            setKey(newValue.id);
            setPages(filtered.length > $83f9c0b82b06f8bc$var$recipientsPerPage ? Math.ceil(newData.length / $83f9c0b82b06f8bc$var$recipientsPerPage) : 0);
        } else setKey("0");
    };
    const handleRemoveFromList = (value)=>{
        setKey("0");
        if (!value.isNew) {
            if (!state.selectedRecipientList?.includedContactIds.includes(parseInt(value.id))) setExcludedList([
                parseInt(value.id),
                ...excludedList
            ]);
        }
        if (state.selectedRecipientList?.includedContactIds.includes(parseInt(value.id))) dispatch({
            type: (0, $ayVxz.Actions).RecipientListRemoveIncludedContact,
            payload: {
                contactId: parseInt(value.id)
            }
        });
        const newData = recipientList.filter((r)=>r.id !== value.id);
        const filtered = filterRecipients(newData, searchText);
        setRecipientList(newData);
        setDisplayedRecipients(filtered.slice(0, $83f9c0b82b06f8bc$var$recipientsPerPage));
        setPages(filtered.length > $83f9c0b82b06f8bc$var$recipientsPerPage ? Math.ceil(filtered.length / $83f9c0b82b06f8bc$var$recipientsPerPage) : 0);
        setOptions([
            value,
            ...options
        ]);
        if (newData.length <= $83f9c0b82b06f8bc$var$recipientsPerPage) setCurrentPage(1);
    };
    const handleSearchChange = (text)=>{
        setSearchText(text);
        setCurrentPage(1);
        const filtered = filterRecipients(recipientList, text);
        setPages(filtered.length > $83f9c0b82b06f8bc$var$recipientsPerPage ? Math.ceil(filtered.length / $83f9c0b82b06f8bc$var$recipientsPerPage) : 0);
        setDisplayedRecipients(filtered.slice(0, $83f9c0b82b06f8bc$var$recipientsPerPage));
    };
    const filterRecipients = (input, text)=>{
        if (text.length === 0) return input;
        else {
            const loweredText = text.toLowerCase();
            const filtered = input.filter((r)=>r.fullName.toLowerCase().includes(loweredText) || r.email?.toLowerCase().includes(loweredText) || r.titleInternal.name.toLowerCase().includes(loweredText));
            return filtered;
        }
    };
    const handlePageChange = (_, value)=>{
        const start = (value - 1) * $83f9c0b82b06f8bc$var$recipientsPerPage;
        setDisplayedRecipients(recipientList.slice(start, start + $83f9c0b82b06f8bc$var$recipientsPerPage));
        setCurrentPage(value);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "step-container",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "section-header",
                sx: {
                    height: "80px",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $jJUYF.default), {
                        id: "overview-step-search-input",
                        filter: handleSearchChange,
                        sx: {
                            width: "40%"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {
                        orientation: "vertical",
                        sx: {
                            background: (0, $6L9uu.Colors).white,
                            width: 2,
                            height: "60%",
                            borderColor: (0, $6L9uu.Colors).white
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                        id: "add-recipient-autocomplete",
                        label: "",
                        onChange: handleAddRecipient,
                        values: undefined,
                        options: options,
                        getOptionLabel: (option)=>option.fullName,
                        additionalStyle: {
                            width: "40%"
                        },
                        isWhite: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "step-content-container",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            display: "flex",
                            justifyContent: "space-between",
                            my: "5px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                value: "RECIPIENTS",
                                style: {
                                    fontSize: 14,
                                    fontWeight: "bold",
                                    color: (0, $6L9uu.Colors).main
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                style: {
                                    fontSize: 14,
                                    color: (0, $6L9uu.Colors).gray
                                },
                                children: `${recipientList.length}` + (recipientList.length === 1 ? " Recipient" : " Recipients")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        display: "flex",
                        gap: "8px",
                        flexDirection: "column",
                        children: displayedRecipients.map((rec, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $3QjFj.default), {
                                recipient: rec,
                                removeFromList: handleRemoveFromList
                            }, `${index}-${rec.id}`))
                    }),
                    pages > 0 && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            mt: "10px"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $i04rf.default), {
                            id: "recipients-pagination",
                            "data-testid": "recipients-pagination",
                            style: {
                                margin: "auto"
                            },
                            count: pages,
                            page: currentPage,
                            color: "primary",
                            onChange: handlePageChange
                        })
                    })
                ]
            })
        ]
    });
};
var $83f9c0b82b06f8bc$export$2e2bcd8739ae039 = $83f9c0b82b06f8bc$var$RecipientsStep;

});
parcelRegister("3QjFj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f75016f00a7f4b8$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $dNs2U = parcelRequire("dNs2U");

var $6L9uu = parcelRequire("6L9uu");

var $lM6pF = parcelRequire("lM6pF");
var $dSYch = parcelRequire("dSYch");
var $iR1LU = parcelRequire("iR1LU");
var $eFKxo = parcelRequire("eFKxo");

const $8f75016f00a7f4b8$var$iconStyle = {
    marginRight: "1%",
    marginBottom: "0.4%",
    color: (0, $6L9uu.Colors).main,
    height: "16px"
};
const $8f75016f00a7f4b8$var$textStyle = {
    WebkitTextFillColor: (0, $6L9uu.Colors).main,
    fontSize: "14px",
    fontFamily: "Overpass"
};
const $8f75016f00a7f4b8$var$RecipientItem = ({ recipient: recipient, removeFromList: removeFromList })=>{
    const { isNew: isNew } = recipient;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "recipient-item",
        sx: {
            background: isNew ? (0, $6L9uu.Colors).lightBlue : (0, $6L9uu.Colors).white,
            boxShadow: isNew ? "" : "0px 3px 20px #12497F12"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                id: "contact-" + recipient.id + "-fullname",
                "data-testid": "contact-" + recipient.id + "-fullname",
                value: recipient.fullName,
                disabled: true,
                fullWidth: true,
                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $iR1LU.default), {
                    style: {
                        ...$8f75016f00a7f4b8$var$iconStyle,
                        width: "14px"
                    }
                }),
                inputProps: {
                    style: $8f75016f00a7f4b8$var$textStyle
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                id: "contact-" + recipient.id + "-titleInternal",
                "data-testid": "contact-" + recipient.id + "-titleInternal",
                value: recipient.titleInternal.name,
                disabled: true,
                fullWidth: true,
                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $dSYch.default), {
                    style: {
                        ...$8f75016f00a7f4b8$var$iconStyle,
                        width: "12px"
                    }
                }),
                inputProps: {
                    style: $8f75016f00a7f4b8$var$textStyle
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                id: "contact-" + recipient.id + "-email",
                "data-testid": "contact-" + recipient.id + "-email",
                value: recipient.email,
                disabled: true,
                fullWidth: true,
                startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lM6pF.default), {
                    style: {
                        ...$8f75016f00a7f4b8$var$iconStyle,
                        width: "16px"
                    }
                }),
                inputProps: {
                    style: $8f75016f00a7f4b8$var$textStyle
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                onClick: ()=>removeFromList(recipient),
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eFKxo.default), {
                    sx: {
                        color: (0, $6L9uu.Colors).skyBlue,
                        width: "20px",
                        height: "21px"
                    }
                })
            })
        ]
    });
};
var $8f75016f00a7f4b8$export$2e2bcd8739ae039 = $8f75016f00a7f4b8$var$RecipientItem;

});
parcelRegister("dSYch", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1bf0364cd2dc320$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $a1bf0364cd2dc320$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3m6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1z"
}), "PermContactCalendar");

});




parcelRegister("jygxi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8fa108a1c5b1bcd$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $km2xR = parcelRequire("km2xR");
var $da7cf = parcelRequire("da7cf");

var $dqPsF = parcelRequire("dqPsF");

var $5PJ2i = parcelRequire("5PJ2i");

var $6L9uu = parcelRequire("6L9uu");

var $bK8bT = parcelRequire("bK8bT");

var $2O2A3 = parcelRequire("2O2A3");

var $d13i8 = parcelRequire("d13i8");
const $e8fa108a1c5b1bcd$var$tabStyle = {
    tab: {
        fontSize: 14,
        borderBottom: "1px solid " + (0, $6L9uu.Colors).skyBlue
    },
    active_tab: {
        fontSize: 14,
        fontWeight: "bold"
    }
};
const $e8fa108a1c5b1bcd$var$RecipientsTabs = ({ onClose: onClose })=>{
    const [value, setValue] = (0, $bh6RR.useState)(0);
    const getTabStyle = (index, tabValue)=>{
        const result = index === tabValue ? {
            ...$e8fa108a1c5b1bcd$var$tabStyle.active_tab
        } : {
            ...$e8fa108a1c5b1bcd$var$tabStyle.tab
        };
        return result;
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5PJ2i.default), {
        id: "recipients-tabs",
        hideTitle: true,
        width: 1400,
        height: 840,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                height: "790px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $dqPsF.default), {
                            position: "static",
                            style: {
                                backgroundColor: (0, $6L9uu.Colors).white,
                                color: (0, $6L9uu.Colors).skyBlue,
                                boxShadow: "none"
                            },
                            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $da7cf.default), {
                                value: value,
                                onChange: (_, newValue)=>setValue(newValue),
                                variant: "fullWidth",
                                TabIndicatorProps: {
                                    style: {
                                        background: (0, $6L9uu.Colors).skyBlue,
                                        height: "3px"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $km2xR.default), {
                                        id: "recipients-tab",
                                        "data-testid": "recipients-tab",
                                        label: "Recipients",
                                        style: getTabStyle(0, value)
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $km2xR.default), {
                                        id: "excluded-recipients-tab",
                                        "data-testid": "excluded-recipients-tab",
                                        label: "Excluded Recipients",
                                        style: getTabStyle(1, value)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                            sx: {
                                maxHeight: "755px",
                                overflow: "auto"
                            },
                            children: [
                                value === 0 && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bK8bT.default), {})
                                }),
                                value === 1 && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $2O2A3.default), {})
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    className: "centralize",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "close-recipients-tabs-button",
                        text: "Close",
                        onClick: onClose
                    })
                })
            ]
        })
    });
};
var $e8fa108a1c5b1bcd$export$2e2bcd8739ae039 = $e8fa108a1c5b1bcd$var$RecipientsTabs;

});
parcelRegister("bK8bT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aea59910c102c3ce$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hjfla = parcelRequire("hjfla");

var $b42dh = parcelRequire("b42dh");
const $aea59910c102c3ce$var$Recipients = ()=>{
    const { state: state, dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [recipients, setRecipients] = (0, $bh6RR.useState)([]);
    const [excludeRecipient] = (0, $hjfla.useExcludeRecipientMutation)();
    const constactsQuery = (0, $hjfla.useRecipientsQuery)({
        variables: {
            id: parseInt(state.selectedRecipientList?.id)
        },
        fetchPolicy: "no-cache"
    });
    const [recipientsCount, setRecipientsCount] = (0, $bh6RR.useState)(0);
    (0, $bh6RR.useEffect)(()=>{
        if (constactsQuery.data?.result) {
            setRecipients(constactsQuery.data.result);
            setRecipientsCount(constactsQuery.data.result.length);
        }
    }, [
        constactsQuery.data
    ]);
    const columns = [
        {
            title: "First Name",
            width: 350,
            field: "first_name"
        },
        {
            title: "Last Name",
            width: 350,
            field: "last_name"
        },
        {
            title: "Title",
            width: 268,
            field: "titleInternal.name"
        },
        {
            title: "Email",
            width: 293,
            field: "email"
        },
        {
            title: "Remove",
            sorting: false,
            width: 80
        }
    ];
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to exclude ${rowData.first_name} ${rowData.last_name} from ${state.selectedRecipientList?.name} recipient list?`,
                params: rowData,
                agreeAction: handleRemoveConfirmed
            }
        });
    };
    const handleRemoveConfirmed = (rowData)=>{
        excludeRecipient({
            variables: {
                contact_id: parseInt(rowData.id),
                recipient_list_id: parseInt(state.selectedRecipientList?.id)
            },
            update () {
                setRecipients(recipients.filter((r)=>r.id !== rowData.id));
                setRecipientsCount(recipientsCount - 1);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `${rowData.first_name} ${rowData.last_name} removed from ${state.selectedRecipientList?.name} recipient list`,
                        severity: "success"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    autoHide: 6000,
                    text: e.message
                }
            });
        }).finally(()=>{
            dispatch({
                type: (0, $ayVxz.Actions).HideConfirmation
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
        columns: columns,
        data: recipients,
        loading: constactsQuery.loading,
        handleDetails: ()=>true,
        handleRemove: handleRemove,
        pageSize: 15,
        removeButtonStyle: "minus",
        title: `${recipientsCount} Recipients`
    });
};
var $aea59910c102c3ce$export$2e2bcd8739ae039 = $aea59910c102c3ce$var$Recipients;

});

parcelRegister("2O2A3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d24f1398f648c07a$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $hjfla = parcelRequire("hjfla");

var $b42dh = parcelRequire("b42dh");
const $d24f1398f648c07a$var$ExcludedRecipients = ()=>{
    const { state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const excludedContacts = (0, $hjfla.useExcludedContactsQuery)({
        variables: {
            id: parseInt(state.selectedRecipientList?.id)
        },
        fetchPolicy: "no-cache"
    });
    const columns = [
        {
            title: "First Name",
            width: 350,
            field: "first_name"
        },
        {
            title: "Last Name",
            width: 350,
            field: "last_name"
        },
        {
            title: "Title",
            width: 268,
            field: "titleInternal.name"
        },
        {
            title: "Email",
            width: 373,
            field: "email"
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
        columns: columns,
        data: excludedContacts.data?.result || [],
        loading: excludedContacts.loading,
        handleDetails: ()=>true,
        handleRemove: ()=>true,
        pageSize: 15,
        removeButtonStyle: "minus",
        title: `${excludedContacts.data?.result.length ?? 0} Excluded Recipients`
    });
};
var $d24f1398f648c07a$export$2e2bcd8739ae039 = $d24f1398f648c07a$var$ExcludedRecipients;

});



parcelRegister("cjvPL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a23201e71e1aa3c$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hjfla = parcelRequire("hjfla");

var $d7fM7 = parcelRequire("d7fM7");

var $T4Yy9 = parcelRequire("T4Yy9");
const $5a23201e71e1aa3c$var$Templates = ()=>{
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [deleteTemplate] = (0, $hjfla.useDeleteTemplateMutation)();
    const { data: data, loading: loading } = (0, $hjfla.useTemplatesQuery)();
    const [openTemplateEditor, setOpenTemplateEditor] = (0, $bh6RR.useState)(false);
    const [selectedTempalte, setSelectedTempalte] = (0, $bh6RR.useState)(null);
    const handleDelete = (rowData)=>{
        if (!rowData.id) return;
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteTemplate({
            variables: {
                id: parseInt(rowData.id)
            },
            update (cache) {
                const templateQuery = cache.readQuery({
                    query: (0, $hjfla.TemplatesDocument)
                });
                if (templateQuery.result) {
                    const cacheTemplateIndex = templateQuery.result.findIndex((c)=>c?.id === rowData.id);
                    if (cacheTemplateIndex > -1) {
                        const data = templateQuery.result.filter(function(el) {
                            return el?.id !== rowData.id;
                        });
                        cache.writeQuery({
                            query: (0, $hjfla.TemplatesDocument),
                            data: {
                                result: data
                            }
                        });
                    }
                }
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Template ${rowData.title} deleted`,
                        severity: "success"
                    }
                });
            }
        }).catch((error)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            }));
    };
    const remove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${rowData.title}?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleDetailsPressed = (rowData)=>{
        setSelectedTempalte(rowData);
        setOpenTemplateEditor(true);
    };
    const handleCloseEditor = ()=>{
        setSelectedTempalte(null);
        setOpenTemplateEditor(false);
    };
    const columns = [
        {
            title: "Details",
            width: 62.5,
            sorting: false
        },
        {
            title: "Name",
            field: "title",
            width: 499
        },
        {
            title: "Email Subject",
            field: "subject",
            width: 1088
        },
        {
            title: "Remove",
            width: 71.5,
            sorting: false
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        className: "overviewPage",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            className: "print\\:w-full",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                    columns: columns,
                    data: data?.result || [],
                    loading: loading,
                    handleDetails: handleDetailsPressed,
                    handleRemove: remove,
                    pageSize: 15,
                    createButtonProps: {
                        id: "create-template-button",
                        onClick: ()=>setOpenTemplateEditor(true),
                        text: "Create Template",
                        disabled: false
                    }
                }),
                openTemplateEditor && /*#__PURE__*/ (0, $ih19M.jsx)((0, $T4Yy9.default), {
                    handleClose: handleCloseEditor,
                    template: selectedTempalte
                })
            ]
        })
    });
};
var $5a23201e71e1aa3c$export$2e2bcd8739ae039 = $5a23201e71e1aa3c$var$Templates;

});
parcelRegister("T4Yy9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23499166270fad9d$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");
var $ePpmI = parcelRequire("ePpmI");
parcelRequire("egIx1");
var $evoXX = parcelRequire("evoXX");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $hjfla = parcelRequire("hjfla");

var $gFVvY = parcelRequire("gFVvY");

var $6L9uu = parcelRequire("6L9uu");

var $bSbwb = parcelRequire("bSbwb");

var $5PJ2i = parcelRequire("5PJ2i");

var $ehzwo = parcelRequire("ehzwo");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");
const $23499166270fad9d$var$ErrorTexts = {
    shortTitle: "Title too short",
    shortSubject: "Subject too short",
    shortContent: "Content too short"
};
const $23499166270fad9d$var$defaultErrorsObj = {
    shortTitle: null,
    shortSubject: null,
    shortContent: null
};
const $23499166270fad9d$var$TemplateEditor = ({ template: template, handleClose: handleClose })=>{
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [title, setTitle] = (0, $bh6RR.useState)(template ? template.title : "");
    const [subject, setSubject] = (0, $bh6RR.useState)(template ? template.subject : "");
    const [htmlValue, setHtmlValue] = (0, $bh6RR.useState)(template?.content ?? "");
    const htmlInputRows = 17;
    const isNew = template === null;
    const [editable, setEditable] = (0, $bh6RR.useState)(false);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($23499166270fad9d$var$defaultErrorsObj);
    const [createTemplate] = (0, $hjfla.useCreateTemplateMutation)();
    const [updateTemplate] = (0, $hjfla.useUpdateTemplateMutation)();
    const handleTitleChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value.length > 2) setFormErrors({
            ...formErrors,
            shortTitle: null
        });
        setTitle(value);
    };
    const handleSubjectChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value.length > 2) setFormErrors({
            ...formErrors,
            shortSubject: null
        });
        setSubject(value);
    };
    const handleCancelPressed = ()=>{
        if (isNew) handleClose();
        else {
            setTitle(template?.title || "");
            setSubject(template?.subject || "");
            setHtmlValue(template?.content ?? "");
            setFormErrors($23499166270fad9d$var$defaultErrorsObj);
            setEditable(false);
        }
    };
    const submitTemplate = ()=>{
        if (isNew) createTemplate({
            variables: {
                input: {
                    subject: subject,
                    title: title,
                    content: htmlValue
                }
            },
            update (cache, { data: data }) {
                if (data?.result) {
                    const templateQuery = cache.readQuery({
                        query: (0, $hjfla.TemplatesDocument)
                    });
                    if (templateQuery.result) {
                        const cachedTemplate = templateQuery.result.find((t)=>t?.id === data.result.id);
                        if (!cachedTemplate) {
                            const newData = [
                                data.result,
                                ...templateQuery.result
                            ];
                            cache.writeQuery({
                                query: (0, $hjfla.TemplatesDocument),
                                data: {
                                    result: newData
                                }
                            });
                        }
                    }
                    handleClose();
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `You have successfully created template`
                        }
                    });
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        });
        else updateTemplate({
            variables: {
                id: parseInt(template.id),
                input: {
                    subject: subject,
                    title: title,
                    content: htmlValue
                }
            },
            update () {
                handleClose();
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Template updated successfully"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    autoHide: 6000,
                    text: e.message
                }
            });
        });
    };
    const handleSave = ()=>{
        const errors = {
            shortTitle: null,
            shortSubject: null,
            shortContent: null
        };
        let hasErrors = false;
        if (title.length < 2) {
            hasErrors = true;
            errors.shortTitle = $23499166270fad9d$var$ErrorTexts.shortTitle;
        }
        if (subject.length < 2) {
            hasErrors = true;
            errors.shortSubject = $23499166270fad9d$var$ErrorTexts.shortSubject;
        }
        if (htmlValue.length < 4) {
            hasErrors = true;
            errors.shortContent = $23499166270fad9d$var$ErrorTexts.shortContent;
        }
        if (hasErrors) setFormErrors(errors);
        else {
            const titleExists = (0, $gFVvY.sameTemplateTitleExists)(title, template?.id);
            if (titleExists) dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: "There is a template with same title",
                    severity: "warning"
                }
            });
            else submitTemplate();
        }
    };
    const handleHtmlChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value.length > 3) setFormErrors({
            ...formErrors,
            shortContent: null
        });
        setHtmlValue(value);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "template-editor-dialog",
        "data-testid": "template-editor-dialog",
        title: template ? template.title : "New Template",
        width: 1400,
        height: 1002,
        onClose: handleClose,
        children: [
            template && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    position: "absolute",
                    right: "24px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "template-editor-edit-button",
                    onClick: ()=>setEditable(true),
                    disabled: editable,
                    editButtonColor: editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "flex",
                    mt: "46px",
                    px: "3.93%",
                    gap: "3.78%"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "45px",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "template-editor-title",
                                label: "Title",
                                value: title,
                                onChange: handleTitleChange,
                                disabled: !isNew && !editable,
                                errorMsg: formErrors.shortTitle
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "template-subject",
                                label: "Subject",
                                value: subject,
                                onChange: handleSubjectChange,
                                disabled: !isNew && !editable,
                                errorMsg: formErrors.shortSubject
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {
                                sx: {
                                    my: "20px"
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "template-html",
                                label: "HTML",
                                value: htmlValue,
                                onChange: handleHtmlChange,
                                disabled: !isNew && !editable,
                                errorMsg: formErrors.shortContent,
                                multiline: true,
                                rows: htmlInputRows
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $evoXX.Editor), {
                            apiKey: "t5l2zdfj93i0j7jhpf2arppkijlh4uu5a21w93j5i8d4ehkf",
                            disabled: !isNew && !editable,
                            initialValue: template?.content ?? "",
                            value: htmlValue,
                            onEditorChange: (newValue)=>setHtmlValue(newValue),
                            init: {
                                plugins: "link image preview imagetools code ",
                                toolbar: "undo redo | bold italic underline | fontselect | alignleft aligncenter alignright | image link | preview",
                                visual: false
                            }
                        })
                    })
                ]
            }),
            (isNew || editable) && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    gridColumn: "span 3",
                    mt: "40px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-template-button",
                        onClick: handleCancelPressed,
                        text: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "create-template-button",
                        onClick: handleSave,
                        text: isNew ? "Create" : "Save"
                    })
                ]
            })
        ]
    });
};
var $23499166270fad9d$export$2e2bcd8739ae039 = $23499166270fad9d$var$TemplateEditor;

});


parcelRegister("a3FvN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81057c769fe4f294$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $hjfla = parcelRequire("hjfla");

var $dRSqV = parcelRequire("dRSqV");
var $k8Qyd = parcelRequire("k8Qyd");
var $hk4Uv = parcelRequire("hk4Uv");
var $8AYU5 = parcelRequire("8AYU5");

var $cxTnx = parcelRequire("cxTnx");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $daKAK = parcelRequire("daKAK");

var $dqRXb = parcelRequire("dqRXb");

var $6L9uu = parcelRequire("6L9uu");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $gu8wR = parcelRequire("gu8wR");
var $ePCTs = parcelRequire("ePCTs");

var $d7fM7 = parcelRequire("d7fM7");

var $91340 = parcelRequire("91340");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $lNwVA = parcelRequire("lNwVA");

var $22Joh = parcelRequire("22Joh");

var $8d818 = parcelRequire("8d818");

var $8juot = parcelRequire("8juot");

var $6V2JL = parcelRequire("6V2JL");
const $81057c769fe4f294$var$deleteIconStyles = {
    color: (0, $6L9uu.Colors).skyBlue,
    width: 28,
    height: 28,
    "&:hover": {
        color: (0, $6L9uu.Colors).main
    }
};
const $81057c769fe4f294$var$chipStyles = {
    color: (0, $6L9uu.Colors).main,
    fontSize: 14,
    fontWeight: "normal",
    background: "#69AAF333",
    "&:active, &:focus": {
        background: "#69AAF333"
    }
};
const $81057c769fe4f294$var$Scheduler = ()=>{
    const minAllowedDate = new Date(2000, 0, 1);
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const { data: data, loading: loading } = (0, $hjfla.useGetAllScheduledQuery)();
    const [deleteRecipientListFromScheduler] = (0, $hjfla.useDeleteRecipientListFromSchedulerMutation)();
    const [allScheduled, setAllScheduled] = (0, $bh6RR.useState)([]);
    const [startDate, setStartDate] = (0, $bh6RR.useState)(null);
    const [endDate, setEndDate] = (0, $bh6RR.useState)(null);
    const [filteredScheduled, setFilteredScheduled] = (0, $bh6RR.useState)([]);
    const [openSchedulerForm, setOpenSchedulerForm] = (0, $bh6RR.useState)(false);
    const [openActivityLogForm, setOpenActivityLogForm] = (0, $bh6RR.useState)(false);
    const [isEditMode, setIsEditMode] = (0, $bh6RR.useState)(false);
    const [deleteScheduler] = (0, $hjfla.useDeleteSchedulerMutation)();
    const [selectedScheduler, setSelectedScheduler] = (0, $bh6RR.useState)(null);
    const [getMailActivityLog, mailActivityLogResult] = (0, $hjfla.useGetSendGridDataForExcelLazyQuery)({
        fetchPolicy: "no-cache"
    });
    const canCreate = (0, $dqRXb.canUserCreate)(state.user, (0, $gUBkJ.Types).Scheduler);
    (0, $bh6RR.useEffect)(()=>{
        if (mailActivityLogResult.data && mailActivityLogResult.data.result && mailActivityLogResult.data.result.length) {
            const fileName = `${(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(new Date()).format("YYYY_MM_DD")}_${mailActivityLogResult.data.result[0]?.scheduler.name.replaceAll(" ", "_")}`;
            const csvData = mailActivityLogResult.data.result.map((r)=>({
                    Email: r?.email,
                    Status: r?.status,
                    "Opens Count": r?.opens_count,
                    "Clicks Count": r?.clicks_count
                }));
            (0, $daKAK.exportDataAsExcel)(csvData, fileName);
        }
    }, [
        mailActivityLogResult
    ]);
    (0, $bh6RR.useEffect)(()=>{
        let filteredByDate = allScheduled;
        const currentStartDate = startDate ? new Date(startDate) : null;
        const currentEndDate = endDate ? new Date(endDate) : null;
        const cleanStartDate = currentStartDate ? new Date(currentStartDate.getFullYear(), currentStartDate.getMonth(), currentStartDate.getDate(), 0, 0, 0).getTime() : null;
        const cleanEndDate = currentEndDate ? new Date(currentEndDate.getFullYear(), currentEndDate.getMonth(), currentEndDate.getDate() + 1, 0, 0, 0).getTime() : null;
        if (currentStartDate && currentEndDate) {
            if (currentStartDate > currentEndDate) filteredByDate = allScheduled.filter((allS)=>new Date(parseInt(allS.scheduled_date)).getTime() >= cleanStartDate);
            else filteredByDate = allScheduled.filter((allS)=>{
                const scheduledDate = new Date(parseInt(allS.scheduled_date)).getTime();
                return scheduledDate >= cleanStartDate && scheduledDate < cleanEndDate;
            });
        } else if (currentEndDate && !currentStartDate) filteredByDate = allScheduled.filter((allS)=>new Date(parseInt(allS.scheduled_date)).getTime() < cleanEndDate);
        else if (currentStartDate && !currentEndDate) filteredByDate = allScheduled.filter((allS)=>new Date(parseInt(allS.scheduled_date)).getTime() >= cleanStartDate);
        setFilteredScheduled(filteredByDate);
    }, [
        startDate,
        endDate
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            setAllScheduled(data.result);
            setFilteredScheduled(data.result);
        }
    }, [
        data
    ]);
    const handleDelete = (rowData)=>{
        if (!rowData.id) return;
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteScheduler({
            variables: {
                id: parseInt(rowData.id)
            },
            update (cache) {
                const schedulerQuery = cache.readQuery({
                    query: (0, $hjfla.GetAllScheduledDocument)
                });
                if (schedulerQuery.result) {
                    const cacheSchedulerIndex = schedulerQuery.result.findIndex((s)=>s?.id === rowData.id);
                    if (cacheSchedulerIndex > -1) {
                        const data = schedulerQuery.result.filter((s)=>s?.id !== rowData.id);
                        cache.writeQuery({
                            query: (0, $hjfla.GetAllScheduledDocument),
                            data: {
                                result: data
                            }
                        });
                    }
                }
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Scheduler deleted ${rowData.name}`,
                        severity: "success"
                    }
                });
            }
        }).catch((error)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            }));
    };
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${rowData.name}?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleDetails = (rowData)=>{
        setSelectedScheduler(rowData);
        setOpenActivityLogForm(true);
    };
    const handleCloseActivityLogForm = ()=>{
        setSelectedScheduler(null);
        setOpenActivityLogForm(false);
        setIsEditMode(false);
    };
    const handleEdit = (rowData)=>{
        setSelectedScheduler(rowData);
        setIsEditMode(true);
        setOpenSchedulerForm(true);
    };
    const handleDuplicate = (rowData)=>{
        setSelectedScheduler(rowData);
        setIsEditMode(false);
        setOpenSchedulerForm(true);
    };
    const handleCloseForm = ()=>{
        setSelectedScheduler(null);
        setIsEditMode(false);
        setOpenSchedulerForm(false);
    };
    const handleExport = (rowData)=>{
        getMailActivityLog({
            variables: {
                scheduler_id: parseInt(rowData.id)
            }
        });
    };
    const isEmailSent = (rowData)=>rowData.is_success === null ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $hk4Uv.default), {}) : /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            className: "m-auto",
            src: rowData.is_success ? (0, (/*@__PURE__*/$parcel$interopDefault($22Joh))) : rowData.is_success === null ? "" : (0, (/*@__PURE__*/$parcel$interopDefault($lNwVA)))
        });
    const formatDate = (rowData, name)=>{
        const raw = rowData[name];
        if (raw == null || raw === "") return "";
        const value = String(raw);
        // Supports epoch ms strings from API and ISO dates
        const parsed = /^\d+$/.test(value) ? (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(parseInt(value, 10)) : (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(value);
        return parsed.isValid() ? parsed.format("MM/DD/YYYY HH:mm") : "";
    };
    const renderSettingsColumn = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: `settings-${rowData.id}`,
            onClick: ()=>handleEdit(rowData),
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8AYU5.default), {
                style: {
                    color: (0, $6L9uu.Colors).skyBlue
                }
            })
        });
    };
    const renderExportColumn = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: `export-${rowData.id}`,
            onClick: ()=>handleExport(rowData),
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $dRSqV.default), {
                style: {
                    color: (0, $6L9uu.Colors).skyBlue
                }
            })
        });
    };
    const renderDuplicateColumn = (rowData)=>{
        const scheduler = {
            ...rowData,
            name: ""
        };
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: `duplicate-${rowData.id}`,
            onClick: ()=>handleDuplicate(scheduler),
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $k8Qyd.default), {
                style: {
                    color: (0, $6L9uu.Colors).skyBlue
                }
            })
        });
    };
    const renderRecipientLists = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
            container: true,
            children: rowData.recipient_lists?.map((rl)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                    item: true,
                    xs: "auto",
                    style: {
                        margin: 5
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                        id: `${rowData.id}-${rl?.id}-chip`,
                        label: rl?.name,
                        onDelete: ()=>{
                            dispatch({
                                type: (0, $ayVxz.Actions).ShowConfirmation,
                                payload: {
                                    text: `Are you sure you want to remove ${rl.name} from ${rowData.name} scheduler`,
                                    agreeAction: handleRemoveRecipientListFromScheduler,
                                    params: {
                                        scheduler_id: rowData.id,
                                        recipient_list_id: rl.id
                                    }
                                }
                            });
                        },
                        sx: {
                            ...$81057c769fe4f294$var$chipStyles,
                            ".MuiChip-deleteIcon": $81057c769fe4f294$var$deleteIconStyles
                        }
                    })
                }, `${rowData.id}-${rl?.id}-recipient_list`))
        });
    };
    const handleRemoveRecipientListFromScheduler = (input)=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteRecipientListFromScheduler({
            variables: {
                scheduler_id: input.scheduler_id,
                recipient_list_id: input.recipient_list_id
            },
            update (cache, { data: data }) {
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Recipient List removed from scheduler`,
                        severity: "success"
                    }
                });
                if (data && data.result) {
                    const updatedScheduler = data.result;
                    const schedulersQuery = cache.readQuery({
                        query: (0, $hjfla.GetAllScheduledDocument)
                    });
                    if (schedulersQuery.result) {
                        const cachedSchedulers = schedulersQuery.result.findIndex((s)=>s?.id === updatedScheduler.id);
                        if (cachedSchedulers > -1) {
                            const updatedData = schedulersQuery.result.map((s)=>s?.id == updatedScheduler.id ? updatedScheduler : s);
                            cache.writeQuery({
                                query: (0, $hjfla.GetAllScheduledDocument),
                                data: {
                                    result: updatedData
                                }
                            });
                        }
                    }
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: e.message,
                    severity: "error",
                    autoHide: 6000
                }
            });
        });
    };
    const columns = [
        {
            title: "Details",
            width: 62.5,
            sorting: false
        },
        {
            title: "Configure",
            width: 80,
            sorting: false,
            render: renderSettingsColumn
        },
        {
            title: "Duplicate",
            width: 93,
            sorting: false,
            render: renderDuplicateColumn
        },
        {
            title: "Name",
            width: 290,
            field: "name"
        },
        {
            title: "Sender",
            width: 300,
            field: "sender.email"
        },
        {
            title: "Email Status",
            width: 130,
            field: "is_success",
            sorting: false,
            render: isEmailSent,
            type: "boolean"
        },
        {
            title: "Template",
            width: 295,
            field: "template.title"
        },
        {
            title: "Recipient Lists",
            width: 246,
            render: (rowData)=>renderRecipientLists(rowData)
        },
        {
            title: "Scheduled Date",
            width: 250,
            field: "scheduled_date",
            type: "date",
            render: (rowData)=>formatDate(rowData, "scheduled_date")
        },
        {
            title: "Export",
            width: 85,
            render: renderExportColumn,
            sorting: false
        },
        {
            title: "Remove",
            width: 71.5,
            sorting: false
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        className: "overviewPage",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                    columns: columns,
                    data: filteredScheduled || [],
                    loading: loading,
                    handleRemove: handleRemove,
                    handleDetails: handleDetails,
                    pageSize: 10,
                    createButtonProps: {
                        id: "create-scheduler-button",
                        onClick: ()=>setOpenSchedulerForm(true),
                        text: "Create Scheduler",
                        disabled: !canCreate
                    },
                    additionalFilters: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        container: true,
                        style: {
                            maxWidth: "350px"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $e4eIN.LocalizationProvider), {
                            dateAdapter: (0, $1Dn8S.AdapterDateFns),
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                                    item: true,
                                    xs: 6,
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                        id: "start-date-picker",
                                        label: "Start Date",
                                        value: startDate,
                                        onChange: (date)=>setStartDate(date),
                                        sx: {
                                            maxWidth: "175px",
                                            marginRight: "10px"
                                        },
                                        minDate: minAllowedDate
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                                    xs: 6,
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                        id: "end-date-picker",
                                        label: "End Date",
                                        value: endDate,
                                        onChange: (date)=>setEndDate(date),
                                        minDate: startDate || minAllowedDate,
                                        sx: {
                                            maxWidth: "175px",
                                            marginLeft: "10px"
                                        }
                                    })
                                })
                            ]
                        })
                    })
                }),
                openSchedulerForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $8juot.default), {
                    handleClose: handleCloseForm,
                    scheduler: selectedScheduler,
                    isEditMode: isEditMode
                }),
                openActivityLogForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $6V2JL.default), {
                    scheduler: selectedScheduler,
                    handleClose: handleCloseActivityLogForm
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                    loading: mailActivityLogResult.loading
                })
            ]
        })
    });
};
var $81057c769fe4f294$export$2e2bcd8739ae039 = $81057c769fe4f294$var$Scheduler;

});
parcelRegister("k8Qyd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea9d5183fd159765$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $ea9d5183fd159765$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm-1 4 6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2zm-1 7h5.5L14 6.5z"
}), "FileCopy");

});

parcelRegister("hk4Uv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9c81d05732d2c91$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $c9c81d05732d2c91$export$2e2bcd8739ae039 = (0, $7B0TL.default)([
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
    }, "0"),
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    }, "1")
], "Schedule");

});

parcelRegister("8juot", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5728c4fec2a1029b$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $gFVvY = parcelRequire("gFVvY");

var $dqRXb = parcelRequire("dqRXb");

var $gSGmk = parcelRequire("gSGmk");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");
var $gu8wR = parcelRequire("gu8wR");
var $ePpmI = parcelRequire("ePpmI");
var $dNs2U = parcelRequire("dNs2U");

var $bSbwb = parcelRequire("bSbwb");

var $6L9uu = parcelRequire("6L9uu");

var $ehzwo = parcelRequire("ehzwo");

var $bilGR = parcelRequire("bilGR");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");

var $gF9d2 = parcelRequire("gF9d2");

var $8jEtO = parcelRequire("8jEtO");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");
const $5728c4fec2a1029b$var$defaultErrorsObj = {
    name: null,
    recipientLists: null,
    template: null,
    sender: null,
    date: null,
    time: null
};
const $5728c4fec2a1029b$var$ErrorTexts = {
    name: "Job name too short",
    nameAlreadyExist: "Job name already exists",
    recipientLists: "Select Recipient List",
    template: "Select Template",
    sender: "Select Sender",
    date: "Select date",
    dateInPast: "Selected date should not be in the past",
    time: "Select time",
    timeInPast: "Selected time should not be in the past"
};
/** Build scheduled Date in the user's local timezone (picker hours = local clock). */ const $5728c4fec2a1029b$var$buildLocalScheduledDate = (datePart, timePart)=>new Date(datePart.getFullYear(), datePart.getMonth(), datePart.getDate(), timePart.getHours(), timePart.getMinutes(), 0, 0);
const $5728c4fec2a1029b$var$SchedulerForm = ({ handleClose: handleClose, scheduler: scheduler, isEditMode: isEditMode = false })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const recipientListsOptions = (0, $hjfla.useRecipientListsQuery)();
    const templates = (0, $hjfla.useTemplatesQuery)();
    const senders = (0, $hjfla.useGetAllSendersQuery)({
        fetchPolicy: "no-cache"
    });
    const [jobName, setJobName] = (0, $bh6RR.useState)(scheduler?.name ?? "");
    const [date, setDate] = (0, $bh6RR.useState)(isEditMode ? (0, $gFVvY.parseDate)(scheduler?.scheduled_date) : null);
    const [time, setTime] = (0, $bh6RR.useState)(isEditMode ? (0, $gFVvY.parseDate)(scheduler?.scheduled_date) : null);
    const [recipientLists, setRecipientLists] = (0, $bh6RR.useState)(scheduler?.recipient_lists || []);
    const [selectedTemplate, setSelectedTemplate] = (0, $bh6RR.useState)(scheduler?.template ?? null);
    const [selectedSender, setSelectedSender] = (0, $bh6RR.useState)(scheduler?.sender ?? null);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($5728c4fec2a1029b$var$defaultErrorsObj);
    const [createScheduler] = (0, $hjfla.useCreateSchedulerMutation)();
    const [updateScheduler] = (0, $hjfla.useUpdateSchedulerMutation)();
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Scheduler);
    const [editEnabled, setEditEnabled] = (0, $bh6RR.useState)(false);
    const [testEmailRecipient, setTestEmailRecipient] = (0, $bh6RR.useState)("");
    const [sendTestScheduler, sendTestEmailResult] = (0, $hjfla.useSendTestEmailMutation)();
    (0, $bh6RR.useEffect)(()=>{
        if (scheduler && senders.data) {
            if (senders.data.result.findIndex((s)=>s?.id === scheduler.sender.id) === -1) {
                setSelectedSender(null);
                setFormErrors({
                    ...formErrors,
                    sender: "Sender has been removed. Please select another one"
                });
            }
        }
    }, [
        senders.data
    ]);
    const handleJobNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value.length > 1) setFormErrors({
            ...formErrors,
            name: null
        });
        else setFormErrors({
            ...formErrors,
            name: $5728c4fec2a1029b$var$ErrorTexts.name
        });
        setJobName(value);
    };
    const handleRecipientListChange = (_, recipientLists)=>{
        if (recipientLists.length > 0) setFormErrors({
            ...formErrors,
            recipientLists: null
        });
        else setFormErrors({
            ...formErrors,
            recipientLists: $5728c4fec2a1029b$var$ErrorTexts.recipientLists
        });
        setRecipientLists(recipientLists);
    };
    const handleTemplateChange = (_, newValue)=>{
        if (newValue !== null) setFormErrors({
            ...formErrors,
            template: null
        });
        else setFormErrors({
            ...formErrors,
            template: $5728c4fec2a1029b$var$ErrorTexts.template
        });
        setSelectedTemplate(newValue);
    };
    const handleSenderChange = (_, newValue)=>{
        if (newValue !== null) setFormErrors({
            ...formErrors,
            sender: null
        });
        else setFormErrors({
            ...formErrors,
            sender: $5728c4fec2a1029b$var$ErrorTexts.sender
        });
        setSelectedSender(newValue);
    };
    const handleSave = ()=>{
        let hasErrors = false;
        const errs = {
            name: null,
            recipientLists: null,
            date: null,
            sender: null,
            template: null,
            time: null
        };
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        if (jobName.length < 2) {
            hasErrors = true;
            errs.name = $5728c4fec2a1029b$var$ErrorTexts.name;
        }
        if (recipientLists.length === 0) {
            hasErrors = true;
            errs.recipientLists = $5728c4fec2a1029b$var$ErrorTexts.recipientLists;
        }
        if (selectedTemplate === null) {
            hasErrors = true;
            errs.template = $5728c4fec2a1029b$var$ErrorTexts.template;
        }
        if (selectedSender === null) {
            hasErrors = true;
            errs.sender = $5728c4fec2a1029b$var$ErrorTexts.sender;
        }
        if (date === null) {
            hasErrors = true;
            errs.date = $5728c4fec2a1029b$var$ErrorTexts.date;
        } else if (date < now) {
            hasErrors = true;
            errs.date = $5728c4fec2a1029b$var$ErrorTexts.dateInPast;
        }
        if (time === null) {
            hasErrors = true;
            errs.time = $5728c4fec2a1029b$var$ErrorTexts.time;
        }
        if (date && time) {
            // Use local timezone (not Date.UTC) so the picked clock time matches the user's intent
            const selectedDate = $5728c4fec2a1029b$var$buildLocalScheduledDate(date, time);
            const currentDate = new Date();
            if (currentDate.getTime() >= selectedDate.getTime()) {
                hasErrors = true;
                errs.time = $5728c4fec2a1029b$var$ErrorTexts.timeInPast;
            }
        }
        if ((0, $gFVvY.sameSchedulerNameExist)(jobName, isEditMode ? scheduler?.id : null)) {
            hasErrors = true;
            errs.name = $5728c4fec2a1029b$var$ErrorTexts.nameAlreadyExist;
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "warning",
                    text: "A scheduler with the same name already exists",
                    autoHide: 6000
                }
            });
        }
        if (hasErrors) setFormErrors(errs);
        else submitScheduler();
    };
    const submitScheduler = ()=>{
        // Local date/time → absolute instant (ISO). Previously Date.UTC treated picker hours as UTC,
        // so BG users had to schedule 3h early and UK (BST) users 1h early.
        const sc_date = $5728c4fec2a1029b$var$buildLocalScheduledDate(date, time);
        const scheduledDateIso = sc_date.toISOString();
        if (isEditMode) updateScheduler({
            variables: {
                id: parseInt(scheduler?.id),
                input: {
                    name: jobName,
                    recipient_lists: recipientLists.map((rl)=>Number(rl.id)),
                    template_id: parseInt(selectedTemplate?.id),
                    sender_id: selectedSender?.id,
                    scheduled_date: scheduledDateIso
                }
            },
            update () {
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Successfully updated ${jobName}`,
                        severity: "success"
                    }
                });
                handleClose();
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: e.message,
                    severity: "error",
                    autoHide: 6000
                }
            });
        });
        else createScheduler({
            variables: {
                input: {
                    name: jobName,
                    recipient_lists: recipientLists.map((rl)=>Number(rl.id)),
                    template_id: parseInt(selectedTemplate?.id),
                    sender_id: selectedSender?.id,
                    scheduled_date: scheduledDateIso
                }
            },
            update (_, { data: data }) {
                if (data?.result) (0, $gFVvY.addSchedulerToCache)(data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Scheduler ${data?.result.name} created`,
                        severity: "success"
                    }
                });
                handleClose();
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: e.message,
                    severity: "error",
                    autoHide: 6000
                }
            });
        });
    };
    const handleTimeChanged = (timeInput)=>{
        if (timeInput !== null) {
            setFormErrors({
                ...formErrors,
                time: null
            });
            if (date) {
                const selectedDate = $5728c4fec2a1029b$var$buildLocalScheduledDate(date, timeInput);
                const currentDate = new Date();
                if (currentDate.getTime() >= selectedDate.getTime()) setFormErrors({
                    ...formErrors,
                    time: $5728c4fec2a1029b$var$ErrorTexts.timeInPast
                });
            }
        } else setFormErrors({
            ...formErrors,
            time: $5728c4fec2a1029b$var$ErrorTexts.time
        });
        setTime(timeInput);
    };
    const handleDateChanged = (dateInput)=>{
        if (dateInput !== null) {
            const now = new Date();
            now.setHours(0, 0, 0, 0);
            let errorDto = formErrors;
            if (dateInput < now) errorDto = {
                ...errorDto,
                date: $5728c4fec2a1029b$var$ErrorTexts.dateInPast
            };
            else errorDto = {
                ...errorDto,
                date: null
            };
            if (time) {
                const selectedDate = $5728c4fec2a1029b$var$buildLocalScheduledDate(dateInput, time);
                const currentDate = new Date();
                if (currentDate.getTime() >= selectedDate.getTime()) errorDto = {
                    ...errorDto,
                    time: $5728c4fec2a1029b$var$ErrorTexts.timeInPast
                };
            }
            setFormErrors(errorDto);
        } else setFormErrors({
            ...formErrors,
            date: $5728c4fec2a1029b$var$ErrorTexts.date
        });
        setDate(dateInput);
    };
    const handleRecipientChange = (event)=>{
        const { value: value } = event.currentTarget;
        const trimmedValue = value.trim();
        setTestEmailRecipient(trimmedValue);
    };
    const chceckIfTestCanBeSend = ()=>{
        let result = false;
        if (selectedTemplate !== null && selectedSender !== null && testEmailRecipient.length > 1 && testEmailRecipient.match((0, $gSGmk.validEmailRegex))) result = true;
        return result;
    };
    const onSendTestEmailButtonClicked = ()=>{
        if (chceckIfTestCanBeSend()) sendTestScheduler({
            variables: {
                template_id: parseInt(selectedTemplate?.id),
                sender_id: selectedSender?.id,
                recipient: testEmailRecipient
            },
            update () {
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Test email sent to ${testEmailRecipient}`,
                        severity: "success"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: e.message,
                    severity: "error",
                    autoHide: 6000
                }
            });
        });
    };
    const isTheSchedulerEditable = ()=>{
        if (!scheduler?.is_success) return false;
        else return true;
    };
    const takeRecipientListIds = (recipientLists)=>{
        const recipientListIds = recipientLists.map((rl)=>rl.id);
        return recipientListIds;
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "scheduler-form",
        title: "Scheduled Mass Email",
        width: 690,
        height: 880,
        onClose: handleClose,
        children: [
            isEditMode && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    position: "absolute",
                    right: "24px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "scheduler-edit-button",
                    disabled: editEnabled || isTheSchedulerEditable() || !canEdit || !scheduler,
                    onClick: ()=>setEditEnabled(true),
                    editButtonColor: editEnabled || isTheSchedulerEditable() || !canEdit || !scheduler ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    mt: "37px",
                    px: "7%",
                    gap: "45px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "job-name",
                        value: jobName,
                        onChange: handleJobNameChange,
                        errorMsg: formErrors.name,
                        label: "Job Name",
                        disabled: isEditMode && !editEnabled
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                        id: "recipient-list-autocomplete",
                        label: "Recipient List",
                        options: recipientListsOptions.data?.result.filter((rl)=>!takeRecipientListIds(recipientLists).includes(rl?.id)) || [],
                        disabled: isEditMode && !editEnabled,
                        errorMsg: formErrors.recipientLists,
                        values: recipientLists,
                        isSingle: false,
                        onChange: handleRecipientListChange,
                        getOptionLabel: (option)=>option.name.replace("_", " "),
                        additionalStyle: {
                            gridColumn: "span 4"
                        },
                        renderTags: (value, getTagProps)=>value.map((option, index)=>// eslint-disable-next-line react/jsx-key
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $gu8wR.default), {
                                    sx: {
                                        backgroundColor: (0, $6L9uu.Colors).white,
                                        color: (0, $6L9uu.Colors).main,
                                        "& .MuiChip-deleteIcon": {
                                            width: "20px",
                                            height: "20px",
                                            color: (0, $6L9uu.Colors).skyBlue,
                                            "&:hover": {
                                                color: (0, $6L9uu.Colors).main
                                            }
                                        }
                                    },
                                    variant: "outlined",
                                    label: `${option.name.replace("_", " ")}`,
                                    ...getTagProps({
                                        index: index
                                    })
                                }))
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                        id: "template-autocomplete",
                        label: "Template",
                        options: templates.data?.result ?? [],
                        getOptionLabel: (option)=>option.title,
                        values: selectedTemplate,
                        onChange: handleTemplateChange,
                        errorMsg: formErrors.template,
                        disabled: isEditMode && !editEnabled
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                        id: "sender-autocomplete",
                        label: "Sender",
                        options: senders.data?.result ?? [],
                        getOptionLabel: (option)=>option.email,
                        values: selectedSender,
                        onChange: handleSenderChange,
                        errorMsg: formErrors.sender,
                        disabled: isEditMode && !editEnabled
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            display: "flex",
                            gap: "15px"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $e4eIN.LocalizationProvider), {
                            dateAdapter: (0, $1Dn8S.AdapterDateFns),
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                    id: "scheduler-date-picker",
                                    label: "Date",
                                    value: date,
                                    onChange: (d)=>handleDateChanged(d),
                                    disabled: isEditMode && !editEnabled,
                                    minDate: new Date(),
                                    errorMsg: formErrors.date,
                                    sx: {
                                        width: "70%"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $gF9d2.default), {
                                    id: "scheduler-time-picker",
                                    label: "Job Time",
                                    value: time,
                                    onChange: (t)=>handleTimeChanged(t),
                                    disabled: isEditMode && !editEnabled,
                                    errorMsg: formErrors.time,
                                    sx: {
                                        width: "70%"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                    id: "date-time-info",
                                    "data-testid": "date-time-info",
                                    value: `Based on your local time`,
                                    disabled: true,
                                    fullWidth: true,
                                    startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8jEtO.default), {
                                        sx: {
                                            width: "17px",
                                            height: "17px",
                                            marginTop: "-3px",
                                            paddingRight: "3px"
                                        }
                                    }),
                                    inputProps: {
                                        style: {
                                            fontSize: "12px",
                                            fontFamily: "Overpass"
                                        }
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {}),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            display: "flex",
                            gap: "10px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "test-email-recipient",
                                value: testEmailRecipient,
                                onChange: handleRecipientChange,
                                label: "Test Email Recipient"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                                id: "send-test-email-button",
                                disabled: chceckIfTestCanBeSend() ? false : true,
                                onClick: onSendTestEmailButtonClicked,
                                text: "Send Test Email",
                                sx: {
                                    width: "200px",
                                    "&:hover": {
                                        width: "200px"
                                    }
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    gridColumn: "span 3",
                    mt: "140px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-scheduler-button",
                        onClick: handleClose,
                        text: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "create-template-button",
                        onClick: handleSave,
                        text: isEditMode ? "Save" : "Create",
                        disabled: isEditMode && !editEnabled
                    })
                ]
            })
        ]
    });
};
var $5728c4fec2a1029b$export$2e2bcd8739ae039 = $5728c4fec2a1029b$var$SchedulerForm;

});

parcelRegister("6V2JL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d867dda12a3cc02a$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $ePpmI = parcelRequire("ePpmI");
var $dNs2U = parcelRequire("dNs2U");

var $6L9uu = parcelRequire("6L9uu");

var $64ct2 = parcelRequire("64ct2");

var $8d818 = parcelRequire("8d818");

var $5PJ2i = parcelRequire("5PJ2i");

var $b42dh = parcelRequire("b42dh");

var $ehzwo = parcelRequire("ehzwo");

var $eOHvN = parcelRequire("eOHvN");

var $bog98 = parcelRequire("bog98");
const $d867dda12a3cc02a$var$button = {
    borderRadius: "15px",
    width: "95px",
    height: "30px",
    fontSize: "12px",
    fontFamily: "Overpass"
};
const $d867dda12a3cc02a$var$buttonColors = {
    lightGreen: "#D3F7A8",
    darkGreen: "#67A026",
    lightRed: "#FFDCDC",
    darkRed: "#D13E3E"
};
const $d867dda12a3cc02a$var$SchedulerDetails = ({ scheduler: scheduler, handleClose: handleClose })=>{
    const [successCount, setSuccessCount] = (0, $bh6RR.useState)(0);
    const [failureCount, setFailureCount] = (0, $bh6RR.useState)(0);
    const [sentPressed, setSentPressed] = (0, $bh6RR.useState)(false);
    const [failedPressed, setFailedPressed] = (0, $bh6RR.useState)(false);
    const [allActivityLogs, setAllActivityLogs] = (0, $bh6RR.useState)([]);
    const [filteredLogs, setFilteredLogs] = (0, $bh6RR.useState)([]);
    const { data: data, loading: loading } = (0, $hjfla.useGetSendGridMessagesQuery)({
        variables: {
            scheduler_id: Number(scheduler.id)
        },
        fetchPolicy: "no-cache"
    });
    (0, $bh6RR.useEffect)(()=>{
        if (data?.result && data.result.length) {
            const successes = data.result.filter((d)=>d?.status === "delivered");
            setAllActivityLogs(data.result);
            setFilteredLogs(data.result);
            setSuccessCount(successes.length);
            setFailureCount(data.result.length - successes.length);
        }
    }, [
        data
    ]);
    const detailPanel = (rowData)=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $64ct2.default), {
            messageId: rowData.sg_message_id
        });
    };
    const handleSentButtonClicked = ()=>{
        if (sentPressed) setFilteredLogs(allActivityLogs);
        else {
            setFilteredLogs(allActivityLogs.filter((al)=>al.status === "delivered"));
            setFailedPressed(false);
        }
        setSentPressed(!sentPressed);
    };
    const handleFailedClicked = ()=>{
        if (failedPressed) setFilteredLogs(allActivityLogs);
        else {
            setFilteredLogs(allActivityLogs.filter((al)=>al.status === "not delivered"));
            setSentPressed(false);
        }
        setFailedPressed(!failedPressed);
    };
    const renderStatus = (status)=>{
        let color = "";
        if (status === "processed") color = (0, $6L9uu.Colors).warning;
        else if (status === "delivered") color = (0, $6L9uu.Colors).green;
        else color = (0, $6L9uu.Colors).red;
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
            value: status,
            style: {
                color: color,
                fontWeight: "bold"
            }
        });
    };
    const columns = [
        {
            title: "Email",
            field: "email",
            width: 500
        },
        {
            title: "Status",
            field: "status",
            width: 300,
            render: (rowData)=>renderStatus(rowData.status)
        },
        {
            title: "Click Count",
            field: "clicks_count",
            width: 200
        },
        {
            title: "Opens Count",
            field: "opens_count",
            width: 200
        }
    ];
    const filterValues = (text)=>{
        if (allActivityLogs) {
            const filtered = allActivityLogs.filter((el)=>el.email.toLocaleLowerCase().includes(text.toLocaleLowerCase()));
            setFilteredLogs(filtered);
        }
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        children: loading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
            loading: loading
        }) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
            id: "scheduler-details-log",
            title: "Job Details",
            width: 1240,
            height: 900,
            onClose: handleClose,
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    sx: {
                        height: "180px",
                        background: (0, $6L9uu.Colors).lightBlue,
                        px: "2.5%",
                        py: "25px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "25px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                            sx: {
                                display: "flex",
                                justifyContent: "space-evenly"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "job-title",
                                    label: "Job Title",
                                    value: scheduler.name,
                                    disabled: true,
                                    withoutBackground: true,
                                    boldText: true
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {
                                    orientation: "vertical",
                                    flexItem: true
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "template-title",
                                    label: "Template Title",
                                    value: scheduler.template.title,
                                    disabled: true,
                                    withoutBackground: true,
                                    boldText: true
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {
                                    orientation: "vertical",
                                    flexItem: true
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "total-recipients",
                                    label: "Total Recipients",
                                    value: scheduler.mails_sent,
                                    disabled: true,
                                    withoutBackground: true
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {
                                    orientation: "vertical",
                                    flexItem: true
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "success-count",
                                    label: "Success Count",
                                    value: successCount,
                                    disabled: true,
                                    withoutBackground: true,
                                    startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eOHvN.default), {
                                        fontSize: "small",
                                        style: {
                                            color: (0, $6L9uu.Colors).green
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                    id: "failure-count",
                                    label: "Failure Count",
                                    value: failureCount,
                                    disabled: true,
                                    withoutBackground: true,
                                    startAdornment: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eOHvN.default), {
                                        fontSize: "small",
                                        style: {
                                            color: (0, $6L9uu.Colors).red
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {}),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                            sx: {
                                display: "flex"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $bog98.default), {
                                    filter: filterValues,
                                    id: "scheduler-details-search-input"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                                    sx: {
                                        display: "flex",
                                        width: "500px",
                                        alignItems: "center",
                                        gap: "10px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $dNs2U.default), {
                                            id: "job-details-filter-by",
                                            "data-testid": "job-details-filter-by",
                                            value: "Filter by:",
                                            disabled: true,
                                            style: {
                                                fontSize: "12px",
                                                fontFamily: "Overpass"
                                            },
                                            inputProps: {
                                                style: {
                                                    textAlign: "right",
                                                    marginTop: "7px"
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                                            id: "sent-button",
                                            "data-testid": "sent-button",
                                            onClick: handleSentButtonClicked,
                                            sx: {
                                                ...$d867dda12a3cc02a$var$button,
                                                background: sentPressed ? $d867dda12a3cc02a$var$buttonColors.darkGreen : $d867dda12a3cc02a$var$buttonColors.lightGreen,
                                                color: sentPressed ? $d867dda12a3cc02a$var$buttonColors.lightGreen : $d867dda12a3cc02a$var$buttonColors.darkGreen,
                                                "&:hover": {
                                                    ...$d867dda12a3cc02a$var$button,
                                                    background: sentPressed ? $d867dda12a3cc02a$var$buttonColors.lightGreen : $d867dda12a3cc02a$var$buttonColors.darkGreen,
                                                    color: sentPressed ? $d867dda12a3cc02a$var$buttonColors.darkGreen : $d867dda12a3cc02a$var$buttonColors.lightGreen
                                                }
                                            },
                                            children: [
                                                "SENT (",
                                                successCount,
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                                            id: "failed-button",
                                            "data-testid": "failed-button",
                                            onClick: handleFailedClicked,
                                            sx: {
                                                ...$d867dda12a3cc02a$var$button,
                                                background: failedPressed ? $d867dda12a3cc02a$var$buttonColors.darkRed : $d867dda12a3cc02a$var$buttonColors.lightRed,
                                                color: failedPressed ? $d867dda12a3cc02a$var$buttonColors.lightRed : $d867dda12a3cc02a$var$buttonColors.darkRed,
                                                "&:hover": {
                                                    ...$d867dda12a3cc02a$var$button,
                                                    background: failedPressed ? $d867dda12a3cc02a$var$buttonColors.lightRed : $d867dda12a3cc02a$var$buttonColors.darkRed,
                                                    color: failedPressed ? $d867dda12a3cc02a$var$buttonColors.darkRed : $d867dda12a3cc02a$var$buttonColors.lightRed
                                                }
                                            },
                                            children: [
                                                "FAILED (",
                                                failureCount,
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        height: "655px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
                        columns: columns,
                        data: filteredLogs,
                        loading: false,
                        handleDetails: ()=>console.log("details"),
                        handleRemove: ()=>console.log("remove"),
                        detailPanel: detailPanel
                    })
                })
            ]
        })
    });
};
var $d867dda12a3cc02a$export$2e2bcd8739ae039 = $d867dda12a3cc02a$var$SchedulerDetails;

});
parcelRegister("64ct2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9fed169c8e2ae91$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $6L9uu = parcelRequire("6L9uu");

var $chLJv = parcelRequire("chLJv");
var $lC4lc = parcelRequire("lC4lc");

var $aQxBx = parcelRequire("aQxBx");
const $c9fed169c8e2ae91$var$MessageDetails = ({ messageId: messageId })=>{
    const [messageDetails, setMessageDetails] = (0, $bh6RR.useState)(null);
    const { data: data, loading: loading } = (0, $hjfla.useGetSendGridEventsQuery)({
        variables: {
            sg_message_id: messageId
        },
        fetchPolicy: "no-cache"
    });
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setMessageDetails(data.result);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        children: loading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
            style: {
                textAlign: "center",
                color: (0, $6L9uu.Colors).main
            },
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lC4lc.default), {
                color: "inherit"
            })
        }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
            children: messageDetails?.map((e, i)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $aQxBx.default), {
                    event: e
                }, i))
        }, messageId)
    });
};
var $c9fed169c8e2ae91$export$2e2bcd8739ae039 = $c9fed169c8e2ae91$var$MessageDetails;

});
parcelRegister("aQxBx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6df02ed932607905$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $6L9uu = parcelRequire("6L9uu");

var $ePCTs = parcelRequire("ePCTs");

var $cxTnx = parcelRequire("cxTnx");
const $6df02ed932607905$var$EventDetail = ({ event: event })=>{
    const getStatusColor = (status)=>{
        if (status === "processed") return (0, $6L9uu.Colors).warning;
        else if (status === "spam_report") return (0, $6L9uu.Colors).red;
        else return (0, $6L9uu.Colors).green;
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
        container: true,
        style: {
            marginTop: "2px",
            height: "40px",
            background: (0, $6L9uu.Colors).lightBlue,
            marginBottom: "4px",
            width: "99%"
        },
        className: "event-details-container",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                item: true,
                xs: 3,
                style: {
                    fontSize: "14px",
                    fontFamily: "Overpass",
                    fontWeight: "bold",
                    color: (0, $6L9uu.Colors).dark_gray,
                    paddingLeft: "2.83%",
                    paddingTop: "12px"
                },
                children: (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(parseInt(event.timestamp, 10)).format("yyyy-MM-DD HH:mm:ss")
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                item: true,
                xs: 2,
                style: {
                    fontSize: "14px",
                    fontFamily: "Overpass",
                    fontWeight: "bold",
                    color: getStatusColor(event.name),
                    paddingTop: "12px",
                    textAlign: "center"
                },
                children: event.name
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                item: true,
                xs: 7,
                style: {
                    textAlign: "right",
                    paddingRight: "2%",
                    marginTop: "auto"
                },
                children: event.url && /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                    target: "_blank",
                    rel: "noreferrer",
                    href: event.url,
                    style: {
                        color: (0, $6L9uu.Colors).main
                    },
                    children: event.url
                })
            })
        ]
    });
};
var $6df02ed932607905$export$2e2bcd8739ae039 = $6df02ed932607905$var$EventDetail;

});


parcelRegister("eOHvN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac977cc33bb56168$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $ac977cc33bb56168$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("circle", {
    cx: "12",
    cy: "12",
    r: "8"
}), "FiberManualRecord");

});




parcelRegister("ISRgu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9385bbd79dd3062$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $bu31C = parcelRequire("bu31C");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $b1v75 = parcelRequire("b1v75");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $am7GZ = parcelRequire("am7GZ");
var $gDp1O = parcelRequire("gDp1O");

var $ahwrv = parcelRequire("ahwrv");

var $6L9uu = parcelRequire("6L9uu");

var $7BEkV = parcelRequire("7BEkV");
var $9WP8Q = parcelRequire("9WP8Q");

var $eA6af = parcelRequire("eA6af");

var $igRxE = parcelRequire("igRxE");

var $8d818 = parcelRequire("8d818");

var $eKW6M = parcelRequire("eKW6M");
const $c9385bbd79dd3062$var$StockInfoWrapper = ()=>{
    const location = (0, $99w1R.useLocation)();
    console.log("location state: ", location.state);
    const history = (0, $99w1R.useNavigate)();
    const [isEditMode, setIsEditMode] = (0, $bh6RR.useState)(false);
    const [open, setOpen] = (0, $bh6RR.useState)(true);
    const [stock, setStock] = (0, $bh6RR.useState)(null);
    const [triggerSave, setTriggerSave] = (0, $bh6RR.useState)(0);
    const { state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Stock);
    const locationElements = location.pathname.split("/").filter((e)=>e);
    const { data: data, loading: loading } = (0, $hjfla.useStockQuery)({
        variables: {
            id: parseInt(locationElements[locationElements.length - 1])
        },
        fetchPolicy: "no-cache"
    });
    (0, $bh6RR.useEffect)(()=>{
        if (data?.result) setStock(data.result);
    }, [
        data
    ]);
    const handleToStocksOverview = ()=>{
        history((0, $b1v75.AuthRoutes).Stocks);
    };
    const handleUpdatedStock = (input)=>{
        setStock(input);
        setIsEditMode(false);
        setTriggerSave(0);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            width: "100%",
            height: "100vh",
            display: "flex",
            flexFlow: "column"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ahwrv.default), {
                handleToOverview: handleToStocksOverview,
                navName: (0, $b1v75.RouteNames).Stocks,
                isManualStyles: true,
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    sx: {
                        width: "100%",
                        pl: "40%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            children: stock?.name
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            style: {
                                color: (0, $6L9uu.Colors).white
                            },
                            children: isEditMode ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                                style: {
                                    width: "260px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eA6af.default), {
                                        id: "cancel-stock-button",
                                        "data-testid": "cancel-stock-button",
                                        onClick: ()=>setIsEditMode(false),
                                        text: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eA6af.default), {
                                        id: "save-stock-button",
                                        "data-testid": "save-stock-button",
                                        onClick: ()=>setTriggerSave(triggerSave + 1),
                                        text: isEditMode ? "Save" : "Create",
                                        type: "secondary"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                style: {
                                    width: "260px",
                                    textAlign: "right"
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                                    id: "stock-edit-button",
                                    "data-testid": "stock-edit-button",
                                    component: (0, $gDp1O.default),
                                    disabled: !canEdit,
                                    onClick: ()=>setIsEditMode(true),
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $9WP8Q.default), {
                                            style: {
                                                fontSize: "medium",
                                                color: (0, $6L9uu.Colors).white,
                                                marginRight: 3
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            style: {
                                                color: (0, $6L9uu.Colors).white,
                                                textDecoration: "underline"
                                            },
                                            children: "EDIT"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    position: "relative",
                    background: "#0EAEFF1A",
                    borderBottom: `1px solid ${(0, $6L9uu.Colors).skyBlue}`,
                    height: open ? "235px" : "20px",
                    transition: "height 1s, transform 1s;"
                },
                children: [
                    open && /*#__PURE__*/ (0, $ih19M.jsx)((0, $igRxE.default), {
                        stock: stock,
                        editable: isEditMode,
                        saveTriggered: triggerSave,
                        refreshStock: handleUpdatedStock,
                        historyStock: location.state.historyStock
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $am7GZ.default), {
                        onClick: ()=>setOpen(!open),
                        "aria-label": "delete",
                        size: "small",
                        style: {
                            width: "20px",
                            height: "20px",
                            background: (0, $6L9uu.Colors).white,
                            boxShadow: "0px 3px 6px #2274BC96",
                            opacity: 1,
                            marginRight: "5%",
                            alignSelf: "end",
                            zIndex: 3,
                            position: "absolute",
                            bottom: "-10px",
                            right: 0
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7BEkV.default), {
                            style: {
                                fontSize: "small",
                                color: (0, $6L9uu.Colors).skyBlue,
                                transform: open ? "rotate(270deg)" : "rotate(90deg)"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eKW6M.default), {
                stockId: stock?.id,
                stockName: stock?.name,
                currencyCode: stock?.currency?.code,
                companyName: stock?.company.name
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                loading: loading
            })
        ]
    });
};
var $c9385bbd79dd3062$export$2e2bcd8739ae039 = $c9385bbd79dd3062$var$StockInfoWrapper;

});
parcelRegister("7BEkV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $589b471bbae35a34$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $589b471bbae35a34$export$2e2bcd8739ae039 = (0, $7B0TL.default)([
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M15.5 5H11l5 7-5 7h4.5l5-7z"
    }, "0"),
    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
        d: "M8.5 5H4l5 7-5 7h4.5l5-7z"
    }, "1")
], "DoubleArrow");

});

parcelRegister("eA6af", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $353ef7cd0a4a8df2$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $idMAb = parcelRequire("idMAb");

var $6L9uu = parcelRequire("6L9uu");

var $79Qyg = parcelRequire("79Qyg");
const $353ef7cd0a4a8df2$var$ToolBarButton = ({ id: id, text: text, disabled: disabled = false, onClick: onClick, sx: sx, type: type = "transperant" })=>{
    const getStyle = ()=>{
        if (type === "transperant") return {
            width: "125px",
            height: "36px",
            color: (0, $6L9uu.Colors).white,
            border: "1px solid " + (0, $6L9uu.Colors).white,
            background: "transparent",
            marginRight: "10px",
            textTransform: "uppercase",
            borderRadius: "10px",
            ...(0, $79Qyg.predefinedFonts).semiBold14px22px,
            ...sx
        };
        else return {
            ...(0, $6L9uu.createMainButton),
            width: "125px",
            height: "36px",
            color: (0, $6L9uu.Colors).white,
            ...sx
        };
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
        id: id,
        "data-testid": id,
        sx: getStyle(),
        disabled: disabled,
        onClick: onClick,
        children: text
    });
};
var $353ef7cd0a4a8df2$export$2e2bcd8739ae039 = $353ef7cd0a4a8df2$var$ToolBarButton;

});

parcelRegister("igRxE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9aafa4229a0b0bf5$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $hjfla = parcelRequire("hjfla");

var $bIyvl = parcelRequire("bIyvl");
var $ePCTs = parcelRequire("ePCTs");
var $lGURI = parcelRequire("lGURI");

var $ehzwo = parcelRequire("ehzwo");

var $gFVvY = parcelRequire("gFVvY");

var $ayVxz = parcelRequire("ayVxz");

var $lKX46 = parcelRequire("lKX46");

var $bilGR = parcelRequire("bilGR");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");
const $9aafa4229a0b0bf5$var$defaultErrorsObj = {
    stockCode: null,
    stockName: null,
    company: null,
    inclusion: null
};
const $9aafa4229a0b0bf5$var$StockDetails = ({ stock: stock, editable: editable, saveTriggered: saveTriggered, refreshStock: refreshStock, historyStock: historyStock })=>{
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const countries = (0, $hjfla.useCountriesQuery)();
    const currencies = (0, $hjfla.useCurrenciesQuery)();
    const companies = (0, $hjfla.useCompaniesNamesQuery)();
    const sectors = (0, $hjfla.useSectorsQuery)();
    const investmentFocuses = (0, $hjfla.useInvestmentFocusesQuery)();
    const [stockDraft, setStockDraft] = (0, $bh6RR.useState)(stock);
    const [errors, setErrors] = (0, $bh6RR.useState)($9aafa4229a0b0bf5$var$defaultErrorsObj);
    const [updateStock] = (0, $hjfla.useUpdateStockMutation)();
    (0, $bh6RR.useEffect)(()=>{
        setStockDraft(stock);
        setErrors($9aafa4229a0b0bf5$var$defaultErrorsObj);
    }, [
        stock,
        editable
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (saveTriggered > 0 && isValidStock()) {
            const stockToUpdate = stockDraft;
            const input = {
                name: stockToUpdate.name,
                company_id: parseInt(stockToUpdate.company?.id),
                is_reit: stockToUpdate.is_reit,
                start_date: (0, $gFVvY.parseDate)(stockToUpdate.start_date).toString(),
                bloomberg_ticker: (0, $gFVvY.getStringInput)(stockToUpdate.bloomberg_ticker),
                cusip: (0, $gFVvY.getStringInput)(stockToUpdate.cusip),
                country_id: (0, $gFVvY.getObjectInputId)(stockToUpdate.country?.id),
                currency_id: (0, $gFVvY.getObjectInputId)(stockToUpdate.currency?.id),
                isin_code: (0, $gFVvY.getStringInput)(stockToUpdate.isin_code),
                reuters_code: (0, $gFVvY.getStringInput)(stockToUpdate.reuters_code),
                code: (0, $gFVvY.getStringInput)(stockToUpdate.code),
                exchange_code: (0, $gFVvY.getStringInput)(stockToUpdate.exchange_code),
                sedol: (0, $gFVvY.getStringInput)(stockToUpdate.sedol),
                snl_code: (0, $gFVvY.getStringInput)(stockToUpdate.snl_code),
                investment_focus_id: (0, $gFVvY.getObjectInputId)(stockToUpdate.investment_focus?.id),
                icb_industry_code: stockToUpdate.icb_industry_code,
                icb_sector_code: stockToUpdate.icb_sector_code,
                icb_subsector_code: stockToUpdate.icb_subsector_code,
                icb_supersector_code: stockToUpdate.icb_supersector_code,
                sector_id: (0, $gFVvY.getObjectInputId)(stockToUpdate.sector?.id),
                subsector_id: (0, $gFVvY.getObjectInputId)(stockToUpdate.subsector?.id)
            };
            const result = {
                ...stockToUpdate,
                historyStock: historyStock
            };
            updateStock({
                variables: {
                    id: stock?.id,
                    input: input
                },
                optimisticResponse: {
                    result: result
                }
            }).catch((e)=>{
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "error",
                        text: e.message,
                        autoHide: 6000
                    }
                });
            });
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "success",
                    text: `${result.name} updated`
                }
            });
            refreshStock(result);
        }
    }, [
        saveTriggered
    ]);
    const handleNameChange = (event)=>{
        const { value: value } = event.target;
        setErrors({
            ...errors,
            stockName: value.trim().length < 2 ? (0, $lKX46.errorTexts).stockName : null
        });
        setStockDraft({
            ...stockDraft,
            name: value.trimStart()
        });
    };
    const handleStockCodeChange = (event)=>{
        const { value: value } = event.target;
        if (value.length > 0) {
            if (value[0].toLowerCase() === "c") setErrors({
                ...errors,
                stockCode: null
            });
            else setErrors({
                ...errors,
                stockCode: (0, $lKX46.errorTexts).stockCode
            });
        } else setErrors({
            ...errors,
            stockCode: null
        });
        setStockDraft({
            ...stockDraft,
            code: value.trimStart()
        });
    };
    const handleCompanyChange = (_, newValue)=>{
        if (newValue) setErrors({
            ...errors,
            company: null
        });
        else setErrors({
            ...errors,
            company: (0, $lKX46.errorTexts).company
        });
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        setStockDraft({
            ...stockDraft,
            company: newValue
        });
    };
    const handleDateChange = (newValue)=>{
        if (newValue) {
            if (!Number.isNaN(newValue.getDate())) setErrors({
                ...errors,
                inclusion: null
            });
        } else setErrors({
            ...errors,
            inclusion: (0, $lKX46.errorTexts).inclusion
        });
        setStockDraft({
            ...stockDraft,
            start_date: newValue?.getTime().toString() || ""
        });
    };
    const isValidStock = ()=>{
        let valid = true;
        const stockToChack = stockDraft;
        const errors = {
            company: null,
            stockCode: null,
            stockName: null,
            inclusion: null
        };
        if (stockToChack.code && stockToChack.code?.length > 0) {
            if (stockToChack.code[0].toLowerCase() !== "c") {
                errors.stockCode = (0, $lKX46.errorTexts).stockCode;
                valid = false;
            } else {
                const codeExist = (0, $gFVvY.stockCodeExists)(stockToChack.code, parseInt(stock?.id));
                if (codeExist) {
                    errors.stockCode = (0, $lKX46.errorTexts).stockCodeExists;
                    valid = false;
                }
            }
        }
        if (stockToChack.name.trim().length < 2) {
            valid = false;
            errors.stockName = (0, $lKX46.errorTexts).stockName;
        }
        if (stockToChack.company === null) {
            valid = false;
            errors.company = (0, $lKX46.errorTexts).company;
        }
        if (stockToChack.start_date === null) {
            valid = false;
            errors.inclusion = (0, $lKX46.errorTexts).inclusion;
        }
        setErrors(errors);
        return valid;
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
        container: true,
        sx: {
            mt: "35px",
            paddingX: "10px"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 3,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "stock-name",
                            "data-testid": "stock-name",
                            value: stockDraft?.name || "",
                            onChange: handleNameChange,
                            errorMsg: errors.stockName,
                            label: "Stock Name",
                            disabled: !editable,
                            isWhite: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 2,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "stock-code",
                            "data-testid": "stock-code",
                            value: stockDraft?.code || "",
                            onChange: handleStockCodeChange,
                            errorMsg: errors.stockCode,
                            label: "Stock Code",
                            disabled: !editable,
                            isWhite: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 2,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "isin-code",
                            "data-testid": "isin-code",
                            value: stockDraft?.isin_code || "",
                            onChange: (e)=>setStockDraft({
                                    ...stockDraft,
                                    isin_code: e.currentTarget.value
                                }),
                            disabled: !editable,
                            label: "ISIN Code",
                            isWhite: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 1,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "sedol",
                            "data-testid": "sedol",
                            value: stockDraft?.sedol ?? "",
                            onChange: (e)=>setStockDraft({
                                    ...stockDraft,
                                    sedol: e.currentTarget.value
                                }),
                            disabled: !editable,
                            label: "SEDOL",
                            isWhite: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 1,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "cusip",
                            "data-testid": "cusip",
                            value: stockDraft?.cusip ?? "",
                            onChange: (e)=>setStockDraft({
                                    ...stockDraft,
                                    cusip: e.currentTarget.value
                                }),
                            disabled: !editable,
                            label: "CUSIP",
                            isWhite: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 1,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                            id: "country-autocomplete",
                            "data-testid": "country-autocomplete",
                            options: countries.data?.result || [],
                            getOptionLabel: (option)=>option?.code ?? "",
                            values: stockDraft?.country || null,
                            onChange: (_, newValue)=>setStockDraft({
                                    ...stockDraft,
                                    country: newValue
                                }),
                            disabled: !editable,
                            label: "Country Code",
                            isWhite: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 1,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                            id: "currency-autocomplete",
                            "data-testid": "currency-autocomplete",
                            options: currencies.data?.result || [],
                            getOptionLabel: (option)=>option?.code,
                            values: stockDraft?.currency || null,
                            onChange: (_, newValue)=>setStockDraft({
                                    ...stockDraft,
                                    currency: newValue
                                }),
                            disabled: !editable,
                            label: "Currency Code",
                            isWhite: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 1,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "exchange-code",
                            "data-testid": "exchange-code",
                            value: stockDraft?.exchange_code || "",
                            onChange: (e)=>setStockDraft({
                                    ...stockDraft,
                                    exchange_code: e.currentTarget.value
                                }),
                            disabled: !editable,
                            label: "Exchange Code",
                            isWhite: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
                container: true,
                spacing: 2,
                style: {
                    paddingTop: 35
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 1,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                            id: "investment-focus-autocomplete",
                            "data-testid": "investment-focus-autocomplete",
                            options: investmentFocuses.data?.result || [],
                            getOptionLabel: (option)=>option?.name ?? "",
                            values: stockDraft?.investment_focus || null,
                            onChange: (_, newValue)=>setStockDraft({
                                    ...stockDraft,
                                    investment_focus: newValue
                                }),
                            label: "Investment Focus",
                            disabled: !editable,
                            isWhite: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 1,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                            dateAdapter: (0, $1Dn8S.AdapterDateFns),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                id: "start-date-picker",
                                "data-testid": "start-date-picker",
                                value: (0, $gFVvY.parseDate)(stockDraft?.start_date),
                                onChange: (d)=>handleDateChange(d),
                                label: "Index Inclusion",
                                disabled: !editable,
                                isWhite: true,
                                hideEndIcon: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 1,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "reuters-code",
                            "data-testid": "reuters-code",
                            value: stockDraft?.reuters_code ?? "",
                            onChange: (e)=>setStockDraft({
                                    ...stockDraft,
                                    reuters_code: e.currentTarget.value
                                }),
                            disabled: !editable,
                            label: "Reuters Code",
                            isWhite: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 2,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "icb-sector-code",
                            "data-testid": "icb-sector-code",
                            type: "number",
                            value: stockDraft?.icb_sector_code || "",
                            onChange: (e)=>setStockDraft({
                                    ...stockDraft,
                                    icb_sector_code: parseInt(e.currentTarget.value)
                                }),
                            disabled: !editable,
                            label: "ICB Sector Code",
                            isWhite: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 2,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "icb-subsector-code",
                            "data-testid": "icb-subsector-code",
                            type: "number",
                            value: stockDraft?.icb_subsector_code || "",
                            onChange: (e)=>setStockDraft({
                                    ...stockDraft,
                                    icb_subsector_code: parseInt(e.currentTarget.value)
                                }),
                            disabled: !editable,
                            label: "ICB Subsector Code",
                            isWhite: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 3,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                            id: "sector-autocomplete",
                            "data-testid": "sector-autocomplete",
                            options: sectors.data?.result || [],
                            getOptionLabel: (option)=>option?.name,
                            values: stockDraft?.sector || null,
                            onChange: (_, newValue)=>setStockDraft({
                                    ...stockDraft,
                                    sector: newValue
                                }),
                            disabled: !editable,
                            label: "Sector",
                            isWhite: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 1,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "bloomberg-ticker",
                            "data-testid": "bloomberg-ticker",
                            value: stockDraft?.bloomberg_ticker || "",
                            onChange: (e)=>setStockDraft({
                                    ...stockDraft,
                                    bloomberg_ticker: e.currentTarget.value
                                }),
                            disabled: !editable,
                            label: "Bloomberg Ticker",
                            isWhite: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 1,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "s-and-p",
                            "data-testid": "s-and-p",
                            value: stockDraft?.snl_code || "",
                            onChange: (e)=>setStockDraft({
                                    ...stockDraft,
                                    snl_code: e.currentTarget.value
                                }),
                            disabled: !editable,
                            label: "S&P",
                            isWhite: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
                container: true,
                spacing: 2,
                style: {
                    paddingTop: 35
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 3,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                            id: "company-autocomplete",
                            "data-testid": "company-autocomplete",
                            options: companies.data?.result || [],
                            getOptionLabel: (option)=>option?.name,
                            values: stockDraft?.company || null,
                            onChange: handleCompanyChange,
                            disabled: !editable,
                            label: "Company name",
                            isWhite: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 2,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "icb-industry-code",
                            "data-testid": "icb-industry-code",
                            type: "number",
                            value: stockDraft?.icb_industry_code ?? "",
                            onChange: (e)=>setStockDraft({
                                    ...stockDraft,
                                    icb_industry_code: parseInt(e.currentTarget.value)
                                }),
                            disabled: !editable,
                            label: "ICB Industry Code",
                            isWhite: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 2,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                            id: "icb-supersector-code",
                            "data-testid": "icb-supersector-code",
                            type: "number",
                            value: stockDraft?.icb_supersector_code ?? "",
                            onChange: (e)=>setStockDraft({
                                    ...stockDraft,
                                    icb_supersector_code: parseInt(e.currentTarget.value)
                                }),
                            disabled: !editable,
                            label: "ICB Supersector Code",
                            isWhite: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 4,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                            id: "subsector-autocomplete",
                            "data-testid": "subsector-autocomplete",
                            options: sectors.data?.result || [],
                            getOptionLabel: (option)=>option?.name,
                            values: stockDraft?.subsector || null,
                            onChange: (_, newValue)=>setStockDraft({
                                    ...stockDraft,
                                    subsector: newValue
                                }),
                            disabled: !editable,
                            label: "Subsector",
                            isWhite: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                        item: true,
                        xs: 1,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bIyvl.default), {
                            control: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lGURI.default), {
                                id: "reit",
                                disableRipple: true,
                                disabled: !editable,
                                lang: "reit",
                                sx: {
                                    mt: "2px"
                                },
                                onChange: ()=>setStockDraft({
                                        ...stockDraft,
                                        is_reit: !stockDraft?.is_reit
                                    }),
                                checked: stockDraft?.is_reit || false
                            }),
                            label: "REIT",
                            labelPlacement: "start",
                            sx: {
                                ml: 0,
                                mt: "5px"
                            }
                        })
                    })
                ]
            })
        ]
    });
};
var $9aafa4229a0b0bf5$export$2e2bcd8739ae039 = $9aafa4229a0b0bf5$var$StockDetails;

});

parcelRegister("eKW6M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ea78ef650fcd174$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $dqPsF = parcelRequire("dqPsF");
var $chLJv = parcelRequire("chLJv");
var $km2xR = parcelRequire("km2xR");
var $da7cf = parcelRequire("da7cf");

var $6L9uu = parcelRequire("6L9uu");

var $j5ie7 = parcelRequire("j5ie7");

var $kgYpv = parcelRequire("kgYpv");

var $j2Uyx = parcelRequire("j2Uyx");

var $gR5mU = parcelRequire("gR5mU");

var $8fKXL = parcelRequire("8fKXL");

var $dryKX = parcelRequire("dryKX");

var $8GMRO = parcelRequire("8GMRO");

var $5604T = parcelRequire("5604T");

var $kJTnB = parcelRequire("kJTnB");

var $LJwaH = parcelRequire("LJwaH");

var $1rZiL = parcelRequire("1rZiL");
const $8ea78ef650fcd174$var$StockTabs = ({ stockId: stockId, stockName: stockName, currencyCode: currencyCode, companyName: companyName })=>{
    const [value, setValue] = (0, $bh6RR.useState)(0);
    const getTabStyle = (index)=>{
        return {
            fontFamily: "Overpass",
            fontSize: "14px",
            fontWeight: value === index ? "bold" : "normal",
            color: value === index ? (0, $6L9uu.Colors).skyBlue : (0, $6L9uu.Colors).main
        };
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $dqPsF.default), {
                position: "static",
                sx: {
                    backgroundColor: "white",
                    boxShadow: "none",
                    borderBottom: `1px solid #AACEF8`
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $da7cf.default), {
                    value: value,
                    onChange: (_, newValue)=>setValue(newValue),
                    indicatorColor: "primary",
                    textColor: "primary",
                    variant: "fullWidth",
                    TabIndicatorProps: {
                        style: {
                            background: (0, $6L9uu.Colors).skyBlue
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $km2xR.default), {
                            id: "stock-navs",
                            label: `NAV's`,
                            style: getTabStyle(0)
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $km2xR.default), {
                            id: "stock-constituents",
                            label: "Constituents",
                            style: getTabStyle(1)
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $km2xR.default), {
                            id: "stock-close-prices",
                            label: "Close Prices",
                            style: getTabStyle(2)
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $km2xR.default), {
                            id: "dividend-gross",
                            label: "Dividend Gross",
                            style: getTabStyle(3)
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $km2xR.default), {
                            id: "stock-ltv",
                            label: "LTV",
                            style: getTabStyle(4)
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $km2xR.default), {
                            id: "stock-kpi",
                            label: "KPI",
                            style: getTabStyle(5)
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $km2xR.default), {
                            id: "stock-awards",
                            label: "Awards",
                            style: getTabStyle(6)
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $km2xR.default), {
                            id: "stock-sector-allocation",
                            label: "Sector Allocation",
                            style: getTabStyle(7)
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $km2xR.default), {
                            id: "stock-allocation-countries",
                            label: "Allocation Countries",
                            style: getTabStyle(8)
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $km2xR.default), {
                            id: "stock-recalcs",
                            label: "Recalcs",
                            style: getTabStyle(9)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                value: value,
                index: 0,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kgYpv.default), {
                    stockId: stockId,
                    stockName: stockName
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                value: value,
                index: 1,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $j2Uyx.default), {
                    stockId: stockId,
                    stockName: stockName
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                value: value,
                index: 2,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $gR5mU.default), {
                    stockId: stockId,
                    stockName: stockName,
                    currencyCode: currencyCode
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                value: value,
                index: 3,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8fKXL.default), {
                    stockId: stockId,
                    stockName: stockName
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                value: value,
                index: 4,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $dryKX.default), {
                    stockId: stockId,
                    stockName: stockName
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                value: value,
                index: 5,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8GMRO.default), {
                    stockId: stockId,
                    currencyCode: currencyCode,
                    companyName: companyName
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                value: value,
                index: 6,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5604T.default), {
                    stockId: stockId
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                value: value,
                index: 7,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $kJTnB.default), {
                    stockId: stockId,
                    companyName: companyName
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                value: value,
                index: 8,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $LJwaH.default), {
                    stockId: stockId
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                value: value,
                index: 9,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1rZiL.default), {
                    stockId: stockId
                })
            })
        ]
    });
};
var $8ea78ef650fcd174$export$2e2bcd8739ae039 = $8ea78ef650fcd174$var$StockTabs;

});
parcelRegister("kgYpv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91be9b9340209d3c$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $hjfla = parcelRequire("hjfla");

var $cxTnx = parcelRequire("cxTnx");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $daKAK = parcelRequire("daKAK");

var $dqRXb = parcelRequire("dqRXb");

var $hsjD5 = parcelRequire("hsjD5");

var $chLJv = parcelRequire("chLJv");

var $b42dh = parcelRequire("b42dh");

var $6L9uu = parcelRequire("6L9uu");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");

var $erX4s = parcelRequire("erX4s");

var $ft8Mg = parcelRequire("ft8Mg");
const $91be9b9340209d3c$var$NavTab = ({ stockId: stockId, stockName: stockName })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [getNavs, { data: data, loading: loading }] = (0, $hjfla.useGetNavsLazyQuery)({
        fetchPolicy: "no-cache"
    });
    const [allData, setAllData] = (0, $bh6RR.useState)([]);
    const [fileteredData, setFileteredData] = (0, $bh6RR.useState)([]);
    const [date, setDate] = (0, $bh6RR.useState)(null);
    const [openNavForm, setOpenNavForm] = (0, $bh6RR.useState)(false);
    const [nav, setNav] = (0, $bh6RR.useState)(null);
    const [deleteNav] = (0, $hjfla.useDeleteNavMutation)();
    const canCreate = (0, $dqRXb.canUserCreate)(state.user, (0, $gUBkJ.Types).Stock);
    const createNavSubscription = (0, $hjfla.useNavCreatedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    const updateNavSubscription = (0, $hjfla.useNavUpdatedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    const deleteNavSubscription = (0, $hjfla.useNavDeletedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        if (stockId) getNavs({
            variables: {
                stock_id: parseInt(stockId)
            }
        });
    }, [
        stockId
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            const parsedData = data.result.map((n)=>{
                return {
                    ...n,
                    filter_date: new Date(parseInt(n?.created_date)).toISOString().slice(0, 10)
                };
            });
            setAllData(parsedData);
            setFileteredData(parsedData);
        }
    }, [
        data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createNavSubscription.data?.result) addNav(createNavSubscription.data?.result);
        if (updateNavSubscription.data?.result) updateNav(updateNavSubscription.data?.result);
        if (deleteNavSubscription.data?.result) removeNav(deleteNavSubscription.data?.result);
    }, [
        createNavSubscription.data,
        deleteNavSubscription.data,
        updateNavSubscription.data
    ]);
    const sortDateColumn = (a, b, column)=>{
        const first = new Date(parseInt(column === "created" ? a.created_date : a.start_date));
        const second = new Date(parseInt(column === "created" ? b.created_date : b.start_date));
        return first.getTime() - second.getTime();
    };
    const columns = [
        {
            title: "Details",
            sorting: false,
            width: 82
        },
        {
            title: "Date",
            field: "created_date",
            width: 167,
            type: "date",
            render: (rowData)=>(0, $hsjD5.renderDate)(rowData.created_date),
            customSort: (a, b)=>sortDateColumn(a, b, "created")
        },
        {
            title: "Date Start",
            field: "start_date",
            width: 178,
            type: "date",
            render: (rowData)=>(0, $hsjD5.renderDate)(rowData.start_date),
            customSort: (a, b)=>sortDateColumn(a, b, "start")
        },
        {
            title: "TA",
            field: "ta",
            type: "numeric",
            width: 138
        },
        {
            title: "TL",
            width: 129,
            field: "tl",
            type: "numeric"
        },
        {
            title: "NAV",
            field: "nav",
            type: "numeric",
            width: 133
        },
        {
            title: "NAV EPRA",
            width: 99,
            field: "nav_epra",
            type: "numeric"
        },
        {
            title: "NAV Epra History",
            width: 184,
            field: "nav_epra_history",
            type: "numeric"
        },
        {
            title: "NRA",
            field: "nra",
            width: 104
        },
        {
            title: "NTA",
            width: 102,
            field: "nta"
        },
        {
            title: "NDV",
            field: "ndv",
            width: 123
        },
        {
            title: "Average",
            field: "average",
            width: 172
        },
        {
            title: "Remove",
            sorting: false,
            field: "status.name",
            width: 71
        }
    ];
    const handleDateChange = (input)=>{
        if (input) {
            if (!Number.isNaN(input.getDate())) {
                // hack to prevent changing day due to time zones and using isoString
                input.setHours(12);
                const isoInput = input.toISOString().slice(0, 10);
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                setFileteredData(allData.filter((n)=>(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(isoInput).isSame(n.filter_date)));
            }
        } else setFileteredData(allData);
        setDate(input);
    };
    const exportCurrentNavs = ()=>{
        const fileName = `${stockName}-Nav-${date ? `${(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(date).format("YYYY_MM_DD")}` : `${(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(new Date()).format("YYYY_MM_DD")}`}`;
        const csvData = fileteredData.map((n)=>({
                Date: (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(parseInt(n.created_date)).format("DD-MM-yy"),
                "Date Start": (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(parseInt(n.start_date)).format("DD-MM-yy"),
                TA: n.ta,
                TL: n.tl,
                NAV: n.nav,
                "NAV EPRA": n.nav_epra,
                "NAV EPRA HISTORY": n.nav_epra_history,
                NRA: n.nra,
                NTA: n.nta,
                NDV: n.ndv,
                Average: n.average
            }));
        (0, $daKAK.exportDataAsExcel)(csvData, fileName);
    };
    const handleClose = (saved, isNew, nav)=>{
        if (saved && nav) {
            if (isNew) addNav(nav);
            else updateNav(nav);
        }
        setNav(null);
        setOpenNavForm(false);
    };
    const updateNav = (nav)=>{
        const updatedNav = {
            ...nav,
            filter_date: new Date(parseInt(nav?.created_date)).toISOString().slice(0, 10)
        };
        const updated = allData.map((n)=>n.id === nav.id ? updatedNav : n);
        setAllData(updated);
        if (date) {
            const isoDate = date.toISOString().slice(0, 10);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            setFileteredData(updated.filter((n)=>(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(isoDate).isSame(n.filter_date)));
        } else setFileteredData(updated);
    };
    const addNav = (nav)=>{
        setAllData([
            nav,
            ...allData
        ]);
        if (date) {
            const navDate = new Date(parseInt(nav.created_date)).toISOString().slice(0, 10);
            const isoDate = date.toISOString().slice(0, 10);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(isoDate).isSame(navDate)) setFileteredData([
                nav,
                ...fileteredData
            ]);
        } else setFileteredData([
            nav,
            ...fileteredData
        ]);
    };
    const removeNav = (nav)=>{
        setAllData(allData.filter((n)=>n.id !== nav.id));
        setFileteredData(fileteredData.filter((n)=>n.id !== nav.id));
    };
    const handleDetails = (rowData)=>{
        setNav(rowData);
        setOpenNavForm(true);
    };
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete nav from ${(0, $hsjD5.renderDate)(rowData.created_date)}?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleDelete = (nav)=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteNav({
            variables: {
                id: nav.id
            },
            update () {
                removeNav(nav);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: `Nav from ${(0, $hsjD5.renderDate)(nav.created_date)} deleted`
                    }
                });
            }
        }).catch((error)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            }));
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        children: loading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $ft8Mg.default), {}) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            className: "print\\:w-full",
            sx: {
                pt: "25px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        position: "absolute",
                        pl: "25px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                        dateAdapter: (0, $1Dn8S.AdapterDateFns),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                            id: "navs-date-picker",
                            label: "Date",
                            value: date,
                            onChange: handleDateChange
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
                    columns: columns,
                    data: fileteredData,
                    handleDetails: handleDetails,
                    handleRemove: handleRemove,
                    toolbarBackground: (0, $6L9uu.Colors).white,
                    createButtonProps: {
                        id: "create-nav-button",
                        onClick: ()=>setOpenNavForm(true),
                        text: "Create",
                        disabled: !canCreate
                    },
                    exportButtonProps: {
                        id: "export-navs-button",
                        onClick: exportCurrentNavs
                    },
                    maxHeight: 600,
                    pageSize: 15
                }),
                openNavForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $erX4s.default), {
                    stockId: stockId,
                    handleClose: handleClose,
                    navInput: nav
                })
            ]
        })
    });
};
var $91be9b9340209d3c$export$2e2bcd8739ae039 = $91be9b9340209d3c$var$NavTab;

});
parcelRegister("erX4s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a71e00460afe9a51$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $dqRXb = parcelRequire("dqRXb");

var $gFVvY = parcelRequire("gFVvY");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");

var $bSbwb = parcelRequire("bSbwb");

var $6L9uu = parcelRequire("6L9uu");

var $ehzwo = parcelRequire("ehzwo");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");
const $a71e00460afe9a51$var$defaultErrorsObj = {
    date: null,
    dateStart: null
};
const $a71e00460afe9a51$var$NavForm = ({ stockId: stockId, navInput: navInput, handleClose: handleClose })=>{
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($a71e00460afe9a51$var$defaultErrorsObj);
    const [dateCreated, setDateCreated] = (0, $bh6RR.useState)(navInput ? (0, $gFVvY.parseDate)(navInput.created_date) : new Date());
    const [dateStart, setDateStart] = (0, $bh6RR.useState)(navInput ? (0, $gFVvY.parseDate)(navInput.start_date) : null);
    const [navElement, setNavElement] = (0, $bh6RR.useState)(navInput);
    const [createNav, createNavResult] = (0, $hjfla.useCreateNavMutation)();
    const [updateNav, updateNavResult] = (0, $hjfla.useUpdateNavMutation)();
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [editable, setEditable] = (0, $bh6RR.useState)(navInput === null);
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Stock);
    const handleDateChange = (input)=>{
        if (input) {
            if (!Number.isNaN(input.getDate())) setFormErrors({
                ...formErrors,
                date: null
            });
        } else setFormErrors({
            ...formErrors,
            date: "Date is required!"
        });
        setDateCreated(input);
    };
    const handleDateStartChange = (input)=>{
        if (input) {
            if (!Number.isNaN(input.getDate())) setFormErrors({
                ...formErrors,
                dateStart: null
            });
        } else setFormErrors({
            ...formErrors,
            dateStart: "Date Start is required!"
        });
        setDateStart(input);
    };
    const handleSave = (type)=>{
        if (type === "create") createNav({
            variables: {
                stock_id: stockId,
                input: {
                    ...navElement,
                    start_date: dateStart.toString(),
                    created_date: dateCreated.toString()
                }
            },
            update (_, { data: data }) {
                handleClose(true, true, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Nav created"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
        else {
            const { id: id, average: average, nav: nav, nav_epra: nav_epra, nav_epra_history: nav_epra_history, ndv: ndv, nra: nra, nta: nta, ta: ta, tl: tl } = navElement;
            updateNav({
                variables: {
                    id: id,
                    input: {
                        average: average,
                        nav: nav,
                        nav_epra: nav_epra,
                        nav_epra_history: nav_epra_history,
                        ndv: ndv,
                        nra: nra,
                        nta: nta,
                        ta: ta,
                        tl: tl,
                        start_date: dateStart.toString(),
                        created_date: dateCreated.toString()
                    }
                },
                update (_, { data: data }) {
                    handleClose(true, false, data?.result);
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: "Nav updated"
                        }
                    });
                }
            }).catch((e)=>{
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "error",
                        text: e.message
                    }
                });
            });
        }
    };
    const handleSubmit = ()=>{
        let hasErrors = false;
        const errors = {
            date: null,
            dateStart: null
        };
        if (!dateCreated) {
            hasErrors = true;
            errors.date = "Date is required!";
        }
        if (!dateStart) {
            hasErrors = true;
            errors.dateStart = "Date Start is required!";
        }
        if (hasErrors) setFormErrors(errors);
        else if (navInput) handleSave("update");
        else handleSave("create");
    };
    const handleCancel = ()=>{
        if (editable && navInput !== null) {
            setNavElement(navInput);
            setDateCreated((0, $gFVvY.parseDate)(navInput.created_date));
            setDateStart((0, $gFVvY.parseDate)(navInput.start_date));
            setFormErrors($a71e00460afe9a51$var$defaultErrorsObj);
            setEditable(false);
        } else handleClose(false);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "nav-dialog",
        width: 690,
        title: navInput ? "NAV Details" : "Create NAV",
        onClose: handleClose,
        childrenSx: {
            px: "40px",
            py: "20px"
        },
        children: [
            navInput && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    textAlign: "right",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "nav-form-edit-button",
                    onClick: ()=>setEditable(true),
                    disabled: editable || !canEdit,
                    editButtonColor: editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                display: "flex",
                gap: "40px",
                flexDirection: "column",
                sx: {
                    my: "20px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        display: "flex",
                        gap: "24px",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                type: "number",
                                id: "total-assets",
                                label: "Total Assets",
                                value: navElement?.ta || "",
                                disabled: createNavResult.loading || updateNavResult.loading || !editable,
                                onChange: (e)=>setNavElement({
                                        ...navElement,
                                        ta: e.currentTarget.value === "" ? null : Number(e.currentTarget.value)
                                    })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "total-liabilities",
                                label: "Total Liabilities",
                                type: "number",
                                value: navElement?.tl || "",
                                disabled: createNavResult.loading || updateNavResult.loading || !editable,
                                onChange: (e)=>setNavElement({
                                        ...navElement,
                                        tl: e.currentTarget.value === "" ? null : Number(e.currentTarget.value)
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        display: "flex",
                        gap: "24px",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "nav",
                                type: "number",
                                label: "NAV",
                                value: navElement?.nav || "",
                                disabled: createNavResult.loading || updateNavResult.loading || !editable,
                                onChange: (e)=>setNavElement({
                                        ...navElement,
                                        nav: e.currentTarget.value === "" ? null : Number(e.currentTarget.value)
                                    })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "nav-epra",
                                label: "NAV Epra",
                                type: "number",
                                value: navElement?.nav_epra || "",
                                disabled: createNavResult.loading || updateNavResult.loading || !editable,
                                onChange: (e)=>setNavElement({
                                        ...navElement,
                                        nav_epra: e.currentTarget.value === "" ? null : Number(e.currentTarget.value)
                                    })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "nav-epra-history",
                                label: "NAV Epra History",
                                type: "number",
                                value: navElement?.nav_epra_history || "",
                                disabled: createNavResult.loading || updateNavResult.loading || !editable,
                                onChange: (e)=>setNavElement({
                                        ...navElement,
                                        nav_epra_history: e.currentTarget.value === "" ? null : Number(e.currentTarget.value)
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        display: "flex",
                        gap: "24px",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "nra",
                                label: "NRA",
                                type: "number",
                                value: navElement?.nra || "",
                                disabled: createNavResult.loading || updateNavResult.loading || !editable,
                                onChange: (e)=>setNavElement({
                                        ...navElement,
                                        nra: e.currentTarget.value === "" ? null : Number(e.currentTarget.value)
                                    })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "ndv",
                                label: "NDV",
                                type: "number",
                                value: navElement?.ndv || "",
                                disabled: createNavResult.loading || updateNavResult.loading || !editable,
                                onChange: (e)=>setNavElement({
                                        ...navElement,
                                        ndv: e.currentTarget.value === "" ? null : Number(e.currentTarget.value)
                                    })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "nta",
                                label: "NTA",
                                type: "number",
                                value: navElement?.nta || "",
                                disabled: createNavResult.loading || updateNavResult.loading || !editable,
                                onChange: (e)=>setNavElement({
                                        ...navElement,
                                        nta: e.currentTarget.value === "" ? null : Number(e.currentTarget.value)
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        display: "flex",
                        gap: "24px",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                                id: "average",
                                label: "Average",
                                type: "number",
                                value: navElement?.average || "",
                                disabled: createNavResult.loading || updateNavResult.loading || !editable,
                                onChange: (e)=>setNavElement({
                                        ...navElement,
                                        average: e.currentTarget.value === "" ? null : Number(e.currentTarget.value)
                                    })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                sx: {
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                                    dateAdapter: (0, $1Dn8S.AdapterDateFns),
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                        id: "date-created-picker",
                                        label: "Date",
                                        value: dateCreated,
                                        onChange: handleDateChange,
                                        errorMsg: formErrors.date,
                                        disabled: createNavResult.loading || updateNavResult.loading || !editable,
                                        sx: {
                                            width: "100%"
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                sx: {
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                                    dateAdapter: (0, $1Dn8S.AdapterDateFns),
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                        id: "date-start-picker",
                                        label: "Date Start",
                                        value: dateStart,
                                        onChange: handleDateStartChange,
                                        errorMsg: formErrors.dateStart,
                                        disabled: createNavResult.loading || updateNavResult.loading || !editable
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        className: "centralize",
                        sx: {
                            gridColumn: "span 3",
                            marginTop: "50px",
                            paddingBottom: "45px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                                id: "cancel-new-contact-button",
                                disabled: createNavResult.loading || updateNavResult.loading,
                                onClick: handleCancel,
                                text: navInput === null || editable ? "Cancel" : "Close"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                                id: "create-new-contact-button",
                                "data-testid": "create-new-contact-button",
                                text: navInput === null ? "Create" : "Save",
                                disabled: createNavResult.loading || updateNavResult.loading || !editable,
                                onClick: handleSubmit
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $a71e00460afe9a51$export$2e2bcd8739ae039 = $a71e00460afe9a51$var$NavForm;

});

parcelRegister("ft8Mg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3288f94379f4c5c$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $lC4lc = parcelRequire("lC4lc");

var $6L9uu = parcelRequire("6L9uu");
const $c3288f94379f4c5c$var$InnerLoader = ()=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: (0, $6L9uu.Colors).main,
            marginTop: "14%"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lC4lc.default), {
            color: "inherit"
        })
    });
};
var $c3288f94379f4c5c$export$2e2bcd8739ae039 = $c3288f94379f4c5c$var$InnerLoader;

});


parcelRegister("j2Uyx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59221ed8fdebeb19$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $hjfla = parcelRequire("hjfla");

var $cxTnx = parcelRequire("cxTnx");

var $hsjD5 = parcelRequire("hsjD5");

var $ayVxz = parcelRequire("ayVxz");

var $daKAK = parcelRequire("daKAK");

var $chLJv = parcelRequire("chLJv");

var $ft8Mg = parcelRequire("ft8Mg");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");

var $b42dh = parcelRequire("b42dh");
const $59221ed8fdebeb19$var$ConstituentTab = ({ stockId: stockId, stockName: stockName })=>{
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [date, setDate] = (0, $bh6RR.useState)(null);
    const [getConst, { data: data, loading: loading }] = (0, $hjfla.useGetHistoryConstituentsLazyQuery)({
        fetchPolicy: "no-cache"
    });
    (0, $bh6RR.useEffect)(()=>{
        getConst({
            variables: {
                stock_id: parseInt(stockId)
            }
        });
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        getConst({
            variables: {
                stock_id: parseInt(stockId),
                date: date ? (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(date).format("YYYY-MM-DD") : null
            }
        });
    }, [
        date
    ]);
    const exportHistoryConstituents = ()=>{
        if (data && data.result.length) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const fileName = `${stockName.replaceAll(" ", "-")}-history-constituents-${date ? `${(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(date).format("YYYY_MM_DD")}` : "latest"}`;
            const csvData = data.result.map((d)=>({
                    "Date Day": (0, $hsjD5.renderDate)(d?.date),
                    "Weight Perc": d?.weight_perc,
                    Index: d?.index.name,
                    "Dividend Yield": d?.history_index?.dividend_yield,
                    "Full mkt cap rank": d?.rank
                }));
            (0, $daKAK.exportDataAsExcel)(csvData, fileName);
        } else dispatch({
            type: (0, $ayVxz.Actions).ShowMessage,
            payload: {
                severity: "warning",
                text: "Missing history constituents data",
                autoHide: 6000
            }
        });
    };
    const columns = [
        {
            title: "Details",
            sorting: false,
            width: 82
        },
        {
            title: "Date Day",
            field: "date",
            width: 167,
            type: "date",
            render: (rowData)=>(0, $hsjD5.renderDate)(rowData.date)
        },
        {
            title: "Weight Perc",
            field: "weight_perc",
            type: "numeric",
            width: 178
        },
        {
            title: "Index",
            width: 809,
            field: "index.name"
        },
        {
            title: "DivYield",
            field: "history_index.dividend_yield",
            type: "numeric",
            width: 153
        },
        {
            title: "Full mkt cap rank",
            field: "rank",
            type: "numeric",
            width: 153
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        children: loading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $ft8Mg.default), {}) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            className: "print\\:w-full",
            sx: {
                pt: "25px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        position: "absolute",
                        pl: "25px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                        dateAdapter: (0, $1Dn8S.AdapterDateFns),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                            id: "constituent-date-picker",
                            label: "Date",
                            value: date,
                            onChange: (value)=>setDate(value)
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
                    columns: columns,
                    data: data?.result || [],
                    handleDetails: ()=>true,
                    handleRemove: ()=>true,
                    exportButtonProps: {
                        id: "export-constituent-button",
                        onClick: exportHistoryConstituents
                    },
                    maxHeight: 1050,
                    pageSize: 15
                })
            ]
        })
    });
};
var $59221ed8fdebeb19$export$2e2bcd8739ae039 = $59221ed8fdebeb19$var$ConstituentTab;

});

parcelRegister("gR5mU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f555b66e27bc6c9$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $cxTnx = parcelRequire("cxTnx");

var $oZMqz = parcelRequire("oZMqz");

var $daKAK = parcelRequire("daKAK");

var $chLJv = parcelRequire("chLJv");

var $ft8Mg = parcelRequire("ft8Mg");

var $b42dh = parcelRequire("b42dh");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");
const $9f555b66e27bc6c9$var$ClosePriceTab = ({ stockId: stockId, currencyCode: currencyCode, stockName: stockName })=>{
    const [allData, setAllData] = (0, $bh6RR.useState)([]);
    const [fileteredData, setFileteredData] = (0, $bh6RR.useState)([]);
    const [date, setDate] = (0, $bh6RR.useState)(null);
    const [startDate, setStartDate] = (0, $bh6RR.useState)(null);
    const [endDate, setEndDate] = (0, $bh6RR.useState)(null);
    const { data: data, loading: loading } = (0, $hjfla.useGetClosePricesQuery)({
        variables: {
            stock_id: parseInt(stockId)
        },
        fetchPolicy: "no-cache"
    });
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            const parsedData = data.result;
            setAllData(parsedData);
            setFileteredData(parsedData);
        }
    }, [
        data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (allData.length > 0) {
            let filteredByDate = allData;
            const currentStartDate = startDate ? new Date(startDate) : null;
            const currentEndDate = endDate ? new Date(endDate) : null;
            const cleanStartDate = currentStartDate ? new Date(currentStartDate.getFullYear(), currentStartDate.getMonth(), currentStartDate.getDate(), 0, 0, 0).getTime() : null;
            const cleanEndDate = currentEndDate ? new Date(currentEndDate.getFullYear(), currentEndDate.getMonth(), currentEndDate.getDate() + 1, 0, 0, 0).getTime() : null;
            if (currentStartDate && currentEndDate) {
                if (currentStartDate > currentEndDate) filteredByDate = allData.filter((e)=>new Date(e.date).getTime() >= cleanStartDate);
                else filteredByDate = allData.filter((e)=>{
                    const scheduledDate = new Date(parseInt(e.date)).getTime();
                    return scheduledDate >= cleanStartDate && scheduledDate < cleanEndDate;
                });
            } else if (currentEndDate && !currentStartDate) filteredByDate = allData.filter((e)=>new Date(parseInt(e.date)).getTime() < cleanEndDate);
            else if (currentStartDate && !currentEndDate) filteredByDate = allData.filter((e)=>new Date(parseInt(e.date)).getTime() >= cleanStartDate);
            setFileteredData(filteredByDate);
        }
    }, [
        startDate,
        endDate
    ]);
    const exportCurrentClosePrices = ()=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const fileName = `${stockName.replaceAll(" ", "-")}-close-prices-${date ? `${(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(date).format("YYYY_MM_DD")}` : `${(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(new Date()).format("YYYY_MM_DD")}`}`;
        const csvData = fileteredData.map((d)=>({
                "Date Day": renderDate(d.date),
                Currency: currencyCode,
                "Close Price": d.close_price ? (0, $oZMqz.numberWithCommas)(d.close_price) : null,
                "Full Mkt Cap": d.engl_mkt_cap ? (0, $oZMqz.numberWithCommas)(d.engl_mkt_cap) : null,
                "Free Float Market Cap": d.free_float_market_cap ? (0, $oZMqz.numberWithCommas)(d.free_float_market_cap) : null,
                "Epra Shares": d.epra_shares ? (0, $oZMqz.numberWithCommas)(d.epra_shares) : null,
                "NAV Epra": d.nav_epra,
                "NAV Ifrs": d.nav_ifrs,
                NRA: d.nra,
                NTA: d.nta,
                NDV: d.ndv,
                Average: d.average,
                "Premium Discount": d.price_discount,
                "Div Gross": d.div_gross,
                "Gross Div Yield": d.gross_div_yield,
                "Div Net": d.div_net
            }));
        (0, $daKAK.exportDataAsExcel)(csvData, fileName);
    };
    const renderDate = (input)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(parseInt(input)).format("DD-MM-yy");
    };
    const sortDateColumn = (a, b)=>{
        const first = new Date(parseInt(a.date));
        const second = new Date(parseInt(b.date));
        return first.getTime() - second.getTime();
    };
    const columns = [
        {
            title: "Date Day",
            field: "date",
            width: 97,
            type: "date",
            render: (rowData)=>renderDate(rowData.date),
            customSort: (a, b)=>sortDateColumn(a, b)
        },
        {
            title: "Currency",
            width: 77,
            render: ()=>currencyCode,
            sorting: false
        },
        {
            title: "Close Price",
            width: 90,
            render: (rowData)=>rowData.close_price ? (0, $oZMqz.numberWithCommas)(rowData.close_price) : null,
            type: "numeric",
            sorting: false
        },
        {
            title: "Full Mkt Cap",
            width: 101,
            render: (rowData)=>rowData.engl_mkt_cap ? (0, $oZMqz.numberWithCommas)(rowData.engl_mkt_cap) : null,
            type: "numeric",
            sorting: false
        },
        {
            title: "Free Float Market Cap",
            width: 156,
            field: "div_net",
            render: (rowData)=>rowData.free_float_market_cap ? (0, $oZMqz.numberWithCommas)(rowData.free_float_market_cap) : null,
            sorting: false
        },
        {
            title: "Epra Shares",
            width: 94,
            render: (rowData)=>rowData.epra_shares ? (0, $oZMqz.numberWithCommas)(rowData.epra_shares) : null,
            type: "numeric",
            sorting: false
        },
        {
            title: "NAV Epra",
            width: 78,
            field: "nav_epra",
            type: "numeric",
            sorting: false
        },
        {
            title: "NAV Ifrs",
            width: 69,
            field: "nav_ifrs",
            type: "numeric",
            sorting: false
        },
        {
            title: "NRA",
            width: 69,
            field: "nra",
            type: "numeric",
            sorting: false
        },
        {
            title: "NTA",
            width: 46,
            field: "nta",
            type: "numeric",
            sorting: false
        },
        {
            title: "NDV",
            width: 48,
            field: "ndv",
            type: "numeric",
            sorting: false
        },
        {
            title: "Average",
            width: 70,
            field: "average",
            type: "numeric",
            sorting: false
        },
        {
            title: "Premium Discount",
            width: 110,
            field: "price_discount",
            type: "numeric",
            sorting: false
        },
        {
            title: "Div Gross",
            width: 79,
            field: "div_gross",
            type: "numeric",
            sorting: false
        },
        {
            title: "Gross Div Yield",
            width: 134,
            field: "gross_div_yield",
            type: "numeric",
            sorting: false
        },
        {
            title: "Div Net",
            width: 87,
            field: "div_net",
            type: "numeric",
            sorting: false
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        children: loading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $ft8Mg.default), {}) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            className: "print\\:w-full",
            sx: {
                pt: "25px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        display: "flex",
                        position: "absolute",
                        pl: "25px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $e4eIN.LocalizationProvider), {
                        dateAdapter: (0, $1Dn8S.AdapterDateFns),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                    id: "close-prices-start-date-picker",
                                    label: "Start Date",
                                    value: startDate,
                                    clearable: true,
                                    onChange: (date)=>setStartDate(date),
                                    minDate: new Date(1980, 0, 1)
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                sx: {
                                    pl: "25px"
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                    id: "close-prices-end-date-picker",
                                    label: "End Date",
                                    value: endDate,
                                    clearable: true,
                                    onChange: (date)=>setEndDate(date),
                                    minDate: startDate || new Date(1980, 0, 1)
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
                    columns: columns,
                    data: fileteredData || [],
                    handleDetails: ()=>true,
                    handleRemove: ()=>true,
                    exportButtonProps: {
                        id: "export-close-prices-button",
                        onClick: exportCurrentClosePrices
                    },
                    maxHeight: 1050,
                    pageSize: 15
                })
            ]
        })
    });
};
var $9f555b66e27bc6c9$export$2e2bcd8739ae039 = $9f555b66e27bc6c9$var$ClosePriceTab;

});

parcelRegister("8fKXL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7792a2071f57cae8$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $cxTnx = parcelRequire("cxTnx");

var $hjfla = parcelRequire("hjfla");

var $daKAK = parcelRequire("daKAK");

var $chLJv = parcelRequire("chLJv");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");

var $ft8Mg = parcelRequire("ft8Mg");

var $b42dh = parcelRequire("b42dh");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $dqRXb = parcelRequire("dqRXb");

var $hsjD5 = parcelRequire("hsjD5");

var $3yqB3 = parcelRequire("3yqB3");
const $7792a2071f57cae8$var$DividendGrossTab = ({ stockId: stockId, stockName: stockName })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [date, setDate] = (0, $bh6RR.useState)(null);
    const [allData, setAllData] = (0, $bh6RR.useState)([]);
    const [fileteredData, setFileteredData] = (0, $bh6RR.useState)([]);
    const [openDividendForm, setOpenDividendForm] = (0, $bh6RR.useState)(false);
    const [dividend, setDividend] = (0, $bh6RR.useState)(null);
    const canCreate = (0, $dqRXb.canUserCreate)(state.user, (0, $gUBkJ.Types).Stock);
    const { data: data, loading: loading } = (0, $hjfla.useGetDividendsGrossQuery)({
        fetchPolicy: "no-cache",
        variables: {
            stock_id: parseInt(stockId)
        }
    });
    const [deleteDividend] = (0, $hjfla.useDeleteDividendMutation)();
    const createDividendSubscription = (0, $hjfla.useDividendCreatedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    const updateDividendSubscription = (0, $hjfla.useDividendUpdatedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    const deleteDividendSubscription = (0, $hjfla.useDividendDeletedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            const parsedData = data.result.map((n)=>{
                const date = new Date(parseInt(n?.start_date));
                date.setHours(12);
                return {
                    ...n,
                    filter_date: date.toISOString().slice(0, 10)
                };
            });
            setAllData(parsedData);
            setFileteredData(parsedData);
        }
    }, [
        data?.result
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createDividendSubscription.data?.result) addDividend(createDividendSubscription.data.result);
        if (deleteDividendSubscription.data?.result) removeDividend(deleteDividendSubscription.data.result);
        if (updateDividendSubscription.data?.result) updateDividend(updateDividendSubscription.data?.result);
    }, [
        createDividendSubscription.data,
        deleteDividendSubscription.data,
        updateDividendSubscription.data
    ]);
    const columns = [
        {
            title: "Details",
            sorting: false,
            width: 82
        },
        {
            title: "Date Day",
            field: "start_date",
            width: 167,
            type: "date",
            render: (rowData)=>(0, $hsjD5.renderDate)(rowData.start_date)
        },
        {
            title: "Dividend Gross",
            field: "value",
            width: 1321
        },
        {
            title: "Remove",
            sorting: false,
            field: "status.name",
            width: 71
        }
    ];
    const handleDateChange = (input)=>{
        if (input) {
            if (!Number.isNaN(input.getDate())) {
                // hack to prevent changing day due to time zones and using isoString
                input.setHours(12);
                const isoInput = input.toISOString().slice(0, 10);
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                setFileteredData(allData.filter((n)=>(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(isoInput).isSame(n.filter_date)));
            }
        } else setFileteredData(allData);
        setDate(input);
    };
    const exportCurrentDividends = ()=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const fileName = `${stockName.replaceAll(" ", "-")}-dividend-gross-${date ? `${(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(date).format("YYYY_MM_DD")}` : `${(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(new Date()).format("YYYY_MM_DD")}`}`;
        const csvData = fileteredData.map((d)=>({
                "Date Day": (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(parseInt(d.start_date)).format("DD-MM-yy"),
                "Dividend Gross": d.value
            }));
        (0, $daKAK.exportDataAsExcel)(csvData, fileName);
    };
    const handleClose = (saved, isNew, dividend)=>{
        if (saved && dividend) {
            if (isNew) addDividend(dividend);
        // updateNav(nav);
        }
        setDividend(null);
        setOpenDividendForm(false);
    };
    const handleDetails = (rowData)=>{
        setDividend(rowData);
        setOpenDividendForm(true);
    };
    const addDividend = (dividend)=>{
        const dividendDate = new Date(parseInt(dividend?.start_date));
        dividendDate.setHours(12);
        const dividendInput = {
            ...dividend,
            filter_date: dividendDate.toISOString().slice(0, 10)
        };
        setAllData([
            dividendInput,
            ...allData
        ]);
        if (date) {
            const dividendDate = new Date(parseInt(dividend.start_date)).toISOString().slice(0, 10);
            const isoDate = date.toISOString().slice(0, 10);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(isoDate).isSame(dividendDate)) setFileteredData([
                dividendInput,
                ...fileteredData
            ]);
        } else setFileteredData([
            dividendInput,
            ...fileteredData
        ]);
    };
    const updateDividend = (dividend)=>{
        const dividendDate = new Date(parseInt(dividend?.start_date));
        dividendDate.setHours(12);
        const updatedDividend = {
            ...dividend,
            filter_date: dividendDate.toISOString().slice(0, 10)
        };
        const updated = allData.map((d)=>d.id === dividend.id ? updatedDividend : d);
        setAllData(updated);
        if (date) {
            const isoDate = date.toISOString().slice(0, 10);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            setFileteredData(updated.filter((n)=>(0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(isoDate).isSame(n.filter_date)));
        } else setFileteredData(updated);
    };
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete dividend from ${(0, $hsjD5.renderDate)(rowData.start_date)}?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleDelete = (dividend)=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteDividend({
            variables: {
                id: dividend.id
            },
            update () {
                removeDividend(dividend);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: `Dividend from ${(0, $hsjD5.renderDate)(dividend.start_date)} deleted`
                    }
                });
            }
        }).catch((error)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            }));
    };
    const removeDividend = (dividend)=>{
        setAllData(allData.filter((d)=>d.id !== dividend.id));
        setFileteredData(fileteredData.filter((d)=>d.id !== dividend.id));
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        children: loading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $ft8Mg.default), {}) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            className: "print\\:w-full",
            sx: {
                pt: "25px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        position: "absolute",
                        pl: "25px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                        dateAdapter: (0, $1Dn8S.AdapterDateFns),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                            id: "divident-gross-date-picker",
                            label: "Date",
                            value: date,
                            onChange: handleDateChange
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
                    columns: columns,
                    data: fileteredData,
                    handleDetails: handleDetails,
                    handleRemove: handleRemove,
                    createButtonProps: {
                        id: "create-dividend-button",
                        onClick: ()=>setOpenDividendForm(true),
                        text: "Create",
                        disabled: !canCreate
                    },
                    exportButtonProps: {
                        id: "export-divident-gross-button",
                        onClick: exportCurrentDividends
                    },
                    maxHeight: 1050,
                    pageSize: 15
                }),
                openDividendForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $3yqB3.default), {
                    stockId: stockId,
                    handleClose: handleClose,
                    dividendInput: dividend
                })
            ]
        })
    });
};
var $7792a2071f57cae8$export$2e2bcd8739ae039 = $7792a2071f57cae8$var$DividendGrossTab;

});
parcelRegister("3yqB3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b456a3e91e95e28$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $5PJ2i = parcelRequire("5PJ2i");

var $hjfla = parcelRequire("hjfla");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $dqRXb = parcelRequire("dqRXb");

var $gFVvY = parcelRequire("gFVvY");

var $chLJv = parcelRequire("chLJv");

var $bSbwb = parcelRequire("bSbwb");

var $6L9uu = parcelRequire("6L9uu");

var $ehzwo = parcelRequire("ehzwo");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");
const $1b456a3e91e95e28$var$defaultErrorsObj = {
    value: null,
    date: null
};
const $1b456a3e91e95e28$var$errorTexts = {
    date: "Date is required!",
    value: "Dividend Gross is required!"
};
const $1b456a3e91e95e28$var$DividendGrossForm = ({ dividendInput: dividendInput, stockId: stockId, handleClose: handleClose })=>{
    const [editable, setEditable] = (0, $bh6RR.useState)(dividendInput === null);
    const [dividendValue, setDividendValue] = (0, $bh6RR.useState)(dividendInput?.value || null);
    const [date, setDate] = (0, $bh6RR.useState)(dividendInput ? (0, $gFVvY.parseDate)(dividendInput.start_date) : new Date());
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($1b456a3e91e95e28$var$defaultErrorsObj);
    const [createDividend, createDividendResult] = (0, $hjfla.useCreateDividendMutation)();
    const [updateDividend, updateDividendResult] = (0, $hjfla.useUpdateDividendMutation)();
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Stock);
    const handleCancel = ()=>{
        if (editable && dividendInput !== null) {
            setDividendValue(dividendInput?.value || null);
            setDate((0, $gFVvY.parseDate)(dividendInput.start_date));
            setFormErrors($1b456a3e91e95e28$var$defaultErrorsObj);
            setEditable(false);
        } else handleClose(false);
    };
    const handleValueChange = (event)=>{
        const value = event.currentTarget.value === "" ? null : Number(event.currentTarget.value);
        if (value === null) setFormErrors({
            ...formErrors,
            value: $1b456a3e91e95e28$var$errorTexts.value
        });
        else setFormErrors({
            ...formErrors,
            value: null
        });
        setDividendValue(value);
    };
    const handleDateChange = (input)=>{
        if (input) {
            if (!Number.isNaN(input.getDate())) setFormErrors({
                ...formErrors,
                date: null
            });
        } else setFormErrors({
            ...formErrors,
            date: $1b456a3e91e95e28$var$errorTexts.date
        });
        setDate(input);
    };
    const handleSubmit = ()=>{
        let hasErrors = false;
        const errors = {
            date: null,
            value: null
        };
        if (!date) {
            hasErrors = true;
            errors.date = $1b456a3e91e95e28$var$errorTexts.date;
        }
        if (!dividendValue) {
            hasErrors = true;
            errors.value = $1b456a3e91e95e28$var$errorTexts.value;
        }
        if (hasErrors) setFormErrors(errors);
        else handleSave(dividendInput === null ? "create" : "update");
    };
    const handleSave = (type)=>{
        if (type === "create") createDividend({
            variables: {
                stock_id: stockId,
                input: {
                    start_date: date.toString(),
                    value: dividendValue
                }
            },
            update (_, { data: data }) {
                handleClose(true, true, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Dividend created"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
        else updateDividend({
            variables: {
                id: dividendInput?.id,
                input: {
                    value: Number(dividendValue),
                    start_date: date.toString()
                }
            },
            update (_, { data: data }) {
                handleClose(true, false, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Dividend updated"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "dividend-dialog",
        width: 410,
        title: dividendInput ? "Dividend Details" : "Create Dividend",
        onClose: handleClose,
        childrenSx: {
            px: "40px",
            py: "20px"
        },
        children: [
            dividendInput && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    textAlign: "right",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "divident-gross-form-edit-button",
                    onClick: ()=>setEditable(true),
                    disabled: editable || !canEdit,
                    editButtonColor: editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                display: "flex",
                gap: "15px",
                sx: {
                    my: "20px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "divident-value",
                        label: "Divident Gross",
                        type: "number",
                        value: dividendValue,
                        onChange: handleValueChange,
                        disabled: createDividendResult.loading || updateDividendResult.loading || !editable,
                        errorMsg: formErrors.value
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                            dateAdapter: (0, $1Dn8S.AdapterDateFns),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                id: "dividend-date-picker",
                                label: "Date",
                                value: date,
                                disabled: createDividendResult.loading || updateDividendResult.loading || !editable,
                                onChange: (d)=>handleDateChange(d),
                                errorMsg: formErrors.date
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    gridColumn: "span 3",
                    marginTop: "50px",
                    paddingBottom: "45px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-dividend-gross-button",
                        onClick: handleCancel,
                        disabled: createDividendResult.loading || updateDividendResult.loading,
                        text: dividendInput === null || editable ? "Cancel" : "Close"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "save-dividend-gross-button",
                        "data-testid": "save-dividend-gross-button",
                        onClick: handleSubmit,
                        disabled: createDividendResult.loading || updateDividendResult.loading || !editable,
                        text: dividendInput === null ? "Create" : "Save"
                    })
                ]
            })
        ]
    });
};
var $1b456a3e91e95e28$export$2e2bcd8739ae039 = $1b456a3e91e95e28$var$DividendGrossForm;

});


parcelRegister("dryKX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8d020b7aa0017bc$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $hsjD5 = parcelRequire("hsjD5");

var $chLJv = parcelRequire("chLJv");

var $ft8Mg = parcelRequire("ft8Mg");

var $b42dh = parcelRequire("b42dh");

var $ceAsM = parcelRequire("ceAsM");
const $f8d020b7aa0017bc$var$LtvTab = ({ stockId: stockId, stockName: stockName })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [allData, setAllData] = (0, $bh6RR.useState)([]);
    const [openLtvForm, setOpenLtvForm] = (0, $bh6RR.useState)(false);
    const [ltv, setLtv] = (0, $bh6RR.useState)(null);
    const canCreate = (0, $dqRXb.canUserCreate)(state.user, (0, $gUBkJ.Types).Stock);
    const { data: data, loading: loading } = (0, $hjfla.useGetHistoryLtvsQuery)({
        fetchPolicy: "no-cache",
        variables: {
            stock_id: parseInt(stockId)
        }
    });
    const [deleteLtv] = (0, $hjfla.useDeleteLtvMutation)();
    const createLtvSubscription = (0, $hjfla.useLtvCreatedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    const deleteLtvSubscription = (0, $hjfla.useLtvDeletedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    const updateLtvSubscription = (0, $hjfla.useLtvUpdatedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            const parsedData = data.result.map((n)=>{
                const date = new Date(parseInt(n?.start_date));
                date.setHours(12);
                return {
                    ...n,
                    filter_date: date.toISOString().slice(0, 10)
                };
            });
            setAllData(parsedData);
        }
    }, [
        data?.result
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createLtvSubscription.data?.result) setAllData([
            createLtvSubscription.data?.result,
            ...allData
        ]);
        if (deleteLtvSubscription.data?.result) removeLtv(deleteLtvSubscription.data.result);
        if (updateLtvSubscription.data?.result) {
            const updated = updateLtvSubscription.data?.result;
            const data = allData;
            const result = data.map((d)=>d.id === updated.id ? updated : d);
            setAllData(result);
        }
    }, [
        createLtvSubscription.data,
        deleteLtvSubscription.data,
        updateLtvSubscription.data
    ]);
    const columns = [
        {
            title: "Details",
            sorting: false,
            width: 82
        },
        {
            title: "Date Day",
            field: "start_date",
            width: 167,
            type: "date",
            render: (rowData)=>(0, $hsjD5.renderDate)(rowData.start_date)
        },
        {
            title: "LTV value",
            field: "value",
            width: 1321
        },
        {
            title: "Remove",
            sorting: false,
            field: "status.name",
            width: 71
        }
    ];
    const handleClose = (saved, isNew, ltv)=>{
        if (saved && ltv) {
            if (isNew) setAllData([
                ltv,
                ...allData
            ]);
        }
        setLtv(null);
        setOpenLtvForm(false);
    };
    const handeDetails = (rowData)=>{
        setLtv(rowData);
        setOpenLtvForm(true);
    };
    const removeLtv = (input)=>{
        const result = allData.filter((l)=>l.id !== input.id);
        setAllData(result);
    };
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ltv from ${(0, $hsjD5.renderDate)(rowData.start_date)}?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleDelete = (ltv)=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteLtv({
            variables: {
                id: ltv.id
            },
            update () {
                removeLtv(ltv);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: `Ltv from ${(0, $hsjD5.renderDate)(ltv.start_date)} deleted`
                    }
                });
            }
        }).catch((error)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            }));
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        children: loading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $ft8Mg.default), {}) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            className: "print\\:w-full",
            sx: {
                pt: "25px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
                    columns: columns,
                    data: allData,
                    handleDetails: handeDetails,
                    handleRemove: handleRemove,
                    maxHeight: 1050,
                    pageSize: 15,
                    createButtonProps: {
                        id: "create-ltv-button",
                        onClick: ()=>setOpenLtvForm(true),
                        text: "Create",
                        disabled: !canCreate
                    }
                }),
                openLtvForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $ceAsM.default), {
                    stockId: stockId,
                    ltvInput: ltv,
                    handleClose: handleClose
                })
            ]
        })
    });
};
var $f8d020b7aa0017bc$export$2e2bcd8739ae039 = $f8d020b7aa0017bc$var$LtvTab;

});
parcelRegister("ceAsM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4607f6700bcd9702$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $dqRXb = parcelRequire("dqRXb");

var $gFVvY = parcelRequire("gFVvY");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");

var $bSbwb = parcelRequire("bSbwb");

var $ehzwo = parcelRequire("ehzwo");

var $6L9uu = parcelRequire("6L9uu");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");
const $4607f6700bcd9702$var$defaultErrorsObj = {
    value: null,
    dateStart: null
};
const $4607f6700bcd9702$var$errorTexts = {
    date: "Date is required!",
    value: "Ltv value is required!"
};
const $4607f6700bcd9702$var$LtvForm = ({ stockId: stockId, ltvInput: ltvInput, handleClose: handleClose })=>{
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($4607f6700bcd9702$var$defaultErrorsObj);
    const [ltvValue, setLtvValue] = (0, $bh6RR.useState)(ltvInput?.value || null);
    const [dateStart, setDateStart] = (0, $bh6RR.useState)(ltvInput ? (0, $gFVvY.parseDate)(ltvInput.start_date) : new Date());
    const [createLtv, createLtvResult] = (0, $hjfla.useCreateLtvMutation)();
    const [updateLtv, updateLtvResult] = (0, $hjfla.useUpdateLtvMutation)();
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [editable, setEditable] = (0, $bh6RR.useState)(ltvInput === null);
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Stock);
    const handleValueChange = (event)=>{
        const value = event.currentTarget.value === "" ? null : Number(event.currentTarget.value);
        if (value === null) setFormErrors({
            ...formErrors,
            value: $4607f6700bcd9702$var$errorTexts.value
        });
        else setFormErrors({
            ...formErrors,
            value: null
        });
        setLtvValue(value);
    };
    const handleDateChange = (input)=>{
        if (input) {
            if (!Number.isNaN(input.getDate())) setFormErrors({
                ...formErrors,
                dateStart: null
            });
        } else setFormErrors({
            ...formErrors,
            dateStart: $4607f6700bcd9702$var$errorTexts.date
        });
        setDateStart(input);
    };
    const handleSubmit = ()=>{
        let hasErrors = false;
        const errors = {
            dateStart: null,
            value: null
        };
        if (!dateStart) {
            hasErrors = true;
            errors.dateStart = $4607f6700bcd9702$var$errorTexts.date;
        }
        if (!ltvValue) {
            hasErrors = true;
            errors.value = $4607f6700bcd9702$var$errorTexts.value;
        }
        if (hasErrors) setFormErrors(errors);
        else handleSave(ltvInput === null ? "create" : "update");
    };
    const handleSave = (type)=>{
        if (type === "create") createLtv({
            variables: {
                stock_id: stockId,
                input: {
                    start_date: dateStart.toString(),
                    value: ltvValue
                }
            },
            update (_, { data: data }) {
                handleClose(true, true, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Ltv created"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
        else updateLtv({
            variables: {
                id: ltvInput?.id,
                input: {
                    start_date: dateStart.toString(),
                    value: ltvValue
                }
            },
            update (_, { data: data }) {
                handleClose(true, false, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Ltv updated"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
    };
    const handleCancel = ()=>{
        if (editable && ltvInput !== null) {
            setLtvValue(ltvInput?.value || null);
            setDateStart((0, $gFVvY.parseDate)(ltvInput.start_date));
            setFormErrors($4607f6700bcd9702$var$defaultErrorsObj);
            setEditable(false);
        } else handleClose(false);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "ltv-dialog",
        width: 410,
        title: ltvInput ? "Ltv Details" : "Create Ltv",
        onClose: handleClose,
        childrenSx: {
            px: "40px",
            py: "20px"
        },
        children: [
            ltvInput && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    textAlign: "right",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "ltv-form-edit-button",
                    onClick: ()=>setEditable(true),
                    disabled: editable || !canEdit,
                    editButtonColor: editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                display: "flex",
                gap: "15px",
                sx: {
                    my: "20px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "ltv-value",
                        label: "LTV Value",
                        type: "number",
                        value: ltvValue,
                        onChange: handleValueChange,
                        disabled: createLtvResult.loading || updateLtvResult.loading || !editable,
                        errorMsg: formErrors.value
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                            dateAdapter: (0, $1Dn8S.AdapterDateFns),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                id: "ltv-date-picker",
                                label: "Date",
                                value: dateStart,
                                disabled: createLtvResult.loading || updateLtvResult.loading || !editable,
                                onChange: (d)=>handleDateChange(d),
                                errorMsg: formErrors.dateStart
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    gridColumn: "span 3",
                    marginTop: "50px",
                    paddingBottom: "45px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-ltv-button",
                        onClick: handleCancel,
                        disabled: createLtvResult.loading || updateLtvResult.loading,
                        text: ltvInput === null || editable ? "Cancel" : "Close"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "save-ltv-button",
                        "data-testid": "save-ltv-button",
                        onClick: handleSubmit,
                        disabled: createLtvResult.loading || updateLtvResult.loading,
                        text: ltvInput === null ? "Create" : "Save"
                    })
                ]
            })
        ]
    });
};
var $4607f6700bcd9702$export$2e2bcd8739ae039 = $4607f6700bcd9702$var$LtvForm;

});


parcelRegister("8GMRO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea2d7145a52c3419$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $hsjD5 = parcelRequire("hsjD5");

var $chLJv = parcelRequire("chLJv");

var $ft8Mg = parcelRequire("ft8Mg");

var $b42dh = parcelRequire("b42dh");

var $b3PhA = parcelRequire("b3PhA");
const $ea2d7145a52c3419$var$KpiTab = ({ stockId: stockId, currencyCode: currencyCode, companyName: companyName })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [kpi, setKpi] = (0, $bh6RR.useState)(null);
    const [openKpiForm, setOpenKpiForm] = (0, $bh6RR.useState)(false);
    const [allData, setAllData] = (0, $bh6RR.useState)([]);
    const [deleteKpi] = (0, $hjfla.useDeleteKpiMutation)();
    const canCreate = (0, $dqRXb.canUserCreate)(state.user, (0, $gUBkJ.Types).Stock);
    const createKpiSubscription = (0, $hjfla.useKpiCreatedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    const updateKpiSubscription = (0, $hjfla.useKpiUpdatedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    const deleteKpiSubscription = (0, $hjfla.useKpiDeletedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    const { data: data, loading: loading } = (0, $hjfla.useGetHistoryKpisQuery)({
        fetchPolicy: "no-cache",
        variables: {
            stock_id: parseInt(stockId)
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setAllData(data.result);
    }, [
        data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createKpiSubscription.data?.result) addKpi(createKpiSubscription.data?.result);
        if (updateKpiSubscription.data?.result) updateKpi(updateKpiSubscription.data?.result);
        if (deleteKpiSubscription.data?.result) removeKpi(deleteKpiSubscription.data.result);
    }, [
        createKpiSubscription.data,
        updateKpiSubscription.data,
        deleteKpiSubscription.data
    ]);
    const columns = [
        {
            title: "Details",
            sorting: false,
            width: 82
        },
        {
            title: "Date Day",
            field: "date",
            width: 93,
            type: "date",
            render: (rowData)=>(0, $hsjD5.renderDate)(rowData.date)
        },
        {
            title: "Company",
            width: 392,
            render: ()=>companyName,
            sorting: false
        },
        {
            title: "Currency",
            width: 98,
            render: ()=>currencyCode,
            sorting: false
        },
        {
            title: "eps",
            field: "eps",
            width: 62
        },
        {
            title: "NAV",
            field: "nav",
            width: 62
        },
        {
            title: "nnnnav",
            field: "nnnav",
            width: 86
        },
        {
            title: "niy %",
            field: "niy",
            width: 74
        },
        {
            title: "vacancy %",
            field: "vacancy",
            width: 106
        },
        {
            title: "Cost Ratio (incl.)",
            field: "cost_ratio_incl",
            width: 143
        },
        {
            title: "Cost Ratio (excl.)",
            field: "cost_ratio_excl",
            width: 146
        },
        {
            title: "NRA",
            field: "nra",
            width: 68
        },
        {
            title: "NTA",
            field: "nta",
            width: 66
        },
        {
            title: "NDV",
            field: "ndv",
            width: 68
        },
        {
            title: "Average",
            field: "average",
            width: 92
        },
        {
            title: "Remove",
            sorting: false,
            width: 104
        }
    ];
    const handleDetails = (rowData)=>{
        setKpi(rowData);
        setOpenKpiForm(true);
    };
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete kpi from ${(0, $hsjD5.renderDate)(rowData.date)}?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleDelete = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteKpi({
            variables: {
                id: rowData.id
            },
            update () {
                removeKpi(rowData);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: `Kpi from ${(0, $hsjD5.renderDate)(rowData.date)} deleted`
                    }
                });
            }
        }).catch((error)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            }));
    };
    const handleClose = (saved, isNew, kpi)=>{
        if (saved && kpi) {
            if (isNew) addKpi(kpi);
            else updateKpi(kpi);
        }
        setKpi(null);
        setOpenKpiForm(false);
    };
    const addKpi = (kpi)=>setAllData([
            kpi,
            ...allData
        ]);
    const updateKpi = (kpi)=>setAllData(allData.map((k)=>k.id === kpi.id ? kpi : k));
    const removeKpi = (kpi)=>setAllData(allData.filter((k)=>k.id !== kpi.id));
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        children: loading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $ft8Mg.default), {}) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            className: "print\\:w-full",
            sx: {
                pt: "25px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
                    columns: columns,
                    data: allData,
                    handleDetails: handleDetails,
                    handleRemove: handleRemove,
                    createButtonProps: {
                        id: "create-kpi-button",
                        onClick: ()=>setOpenKpiForm(true),
                        text: "Create",
                        disabled: !canCreate
                    },
                    maxHeight: 1050,
                    pageSize: 15
                }),
                openKpiForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $b3PhA.default), {
                    stockId: stockId,
                    companyName: companyName,
                    handleClose: handleClose,
                    kpiInput: kpi
                })
            ]
        })
    });
};
var $ea2d7145a52c3419$export$2e2bcd8739ae039 = $ea2d7145a52c3419$var$KpiTab;

});
parcelRegister("b3PhA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $462d626dabd1555d$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $dqRXb = parcelRequire("dqRXb");

var $gFVvY = parcelRequire("gFVvY");

var $6L9uu = parcelRequire("6L9uu");

var $ehzwo = parcelRequire("ehzwo");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");

var $bSbwb = parcelRequire("bSbwb");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");
const $462d626dabd1555d$var$defaultErrorsObj = {
    date: null
};
const $462d626dabd1555d$var$errorTexts = {
    date: "Date is required!"
};
const $462d626dabd1555d$var$KpiForm = ({ stockId: stockId, companyName: companyName, handleClose: handleClose, kpiInput: kpiInput })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($462d626dabd1555d$var$defaultErrorsObj);
    const [editable, setEditable] = (0, $bh6RR.useState)(kpiInput === null);
    const [date, setDate] = (0, $bh6RR.useState)(kpiInput ? (0, $gFVvY.parseDate)(kpiInput.date) : new Date());
    const [eps, setEps] = (0, $bh6RR.useState)(kpiInput?.eps || null);
    const [nav, setNav] = (0, $bh6RR.useState)(kpiInput?.nav || null);
    const [nnnav, setNnnav] = (0, $bh6RR.useState)(kpiInput?.nnnav || null);
    const [niy, setNiy] = (0, $bh6RR.useState)(kpiInput?.niy || null);
    const [vacancy, setVacancy] = (0, $bh6RR.useState)(kpiInput?.vacancy || null);
    const [costRationIncl, setCostRationIncl] = (0, $bh6RR.useState)(kpiInput?.cost_ratio_incl || null);
    const [costRationExcl, setCostRationExcl] = (0, $bh6RR.useState)(kpiInput?.cost_ratio_excl || null);
    const [nra, setNra] = (0, $bh6RR.useState)(kpiInput?.nra || null);
    const [nta, setNta] = (0, $bh6RR.useState)(kpiInput?.nta || null);
    const [ndv, setNdv] = (0, $bh6RR.useState)(kpiInput?.ndv || null);
    const [average, setAverage] = (0, $bh6RR.useState)(kpiInput?.average || null);
    const [createKpi, createKpiResult] = (0, $hjfla.useCreateKpiMutation)();
    const [updateKpi, updateKpiResult] = (0, $hjfla.useUpdateKpiMutation)();
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Stock);
    const isEditable = ()=>createKpiResult.loading || updateKpiResult.loading || !editable;
    const getNumericInputField = (id, label, value, onChange)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
            id: `kpi-form-${id}`,
            label: label,
            type: "number",
            value: value || "",
            disabled: isEditable(),
            onChange: (e)=>onChange(e)
        });
    const handleDateChange = (input)=>{
        if (input) {
            if (!Number.isNaN(input.getDate())) setFormErrors({
                ...formErrors,
                date: null
            });
        } else setFormErrors({
            ...formErrors,
            date: $462d626dabd1555d$var$errorTexts.date
        });
        setDate(input);
    };
    const getCleanValue = (e)=>e.currentTarget.value === "" ? null : Number(e.currentTarget.value);
    const handleCancel = ()=>{
        if (editable && kpiInput !== null) {
            setDate((0, $gFVvY.parseDate)(kpiInput.date));
            setEps(kpiInput.eps || null);
            setNav(kpiInput.nav || null);
            setNnnav(kpiInput.nnnav || null);
            setNiy(kpiInput.niy || null);
            setVacancy(kpiInput.vacancy || null);
            setCostRationIncl(kpiInput.cost_ratio_incl || null);
            setCostRationExcl(kpiInput.cost_ratio_excl || null);
            setNra(kpiInput.nra || null);
            setNta(kpiInput.nta || null);
            setNdv(kpiInput.ndv || null);
            setAverage(kpiInput.average || null);
            setFormErrors($462d626dabd1555d$var$defaultErrorsObj);
            setEditable(false);
        } else handleClose(false);
    };
    const handleSubmit = ()=>{
        let hasErrors = false;
        const errors = {
            date: null
        };
        if (!date) {
            hasErrors = true;
            errors.date = $462d626dabd1555d$var$errorTexts.date;
        }
        if (hasErrors) setFormErrors(errors);
        else if (kpiInput) updateKpi({
            variables: {
                id: kpiInput.id,
                input: getKpiInput()
            },
            update (_, { data: data }) {
                handleClose(true, false, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Kpi updated"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
        else createKpi({
            variables: {
                stock_id: stockId,
                input: getKpiInput()
            },
            update (_, { data: data }) {
                handleClose(true, true, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Kpi created"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
    };
    const getKpiInput = ()=>({
            date: date.toString(),
            eps: eps,
            nav: nav,
            nnnav: nnnav,
            niy: niy,
            vacancy: vacancy,
            cost_ratio_incl: costRationIncl,
            cost_ratio_excl: costRationExcl,
            nra: nra,
            nta: nta,
            ndv: ndv,
            average: average
        });
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "dividend-dialog",
        width: 690,
        title: kpiInput ? "Kpi Details" : "Create Kpi",
        onClose: handleClose,
        childrenSx: {
            px: "30px",
            py: "20px"
        },
        children: [
            kpiInput && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    textAlign: "right",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "kpi-form-edit-button",
                    onClick: ()=>setEditable(true),
                    disabled: editable || !canEdit,
                    editButtonColor: editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    mt: "20px",
                    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                    gap: "24px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "kpi-form-company",
                        label: "Company",
                        value: companyName,
                        disabled: true,
                        additionalStyle: {
                            gridColumn: "span 4"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                        dateAdapter: (0, $1Dn8S.AdapterDateFns),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                            id: "kpi-date-picker",
                            label: "Date",
                            value: date,
                            disabled: isEditable(),
                            onChange: (d)=>handleDateChange(d),
                            errorMsg: formErrors.date
                        })
                    }),
                    getNumericInputField("eps", "Eps", eps, (e)=>setEps(getCleanValue(e))),
                    getNumericInputField("nav", "NAV", nav, (e)=>setNav(getCleanValue(e))),
                    getNumericInputField("nnnav", "NnnAv", nnnav, (e)=>setNnnav(getCleanValue(e))),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            gridColumn: "span 2"
                        },
                        children: getNumericInputField("niy", "Niy %", niy, (e)=>setNiy(getCleanValue(e)))
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            gridColumn: "span 2"
                        },
                        children: getNumericInputField("vacancy", "Vacancy %", vacancy, (e)=>setVacancy(getCleanValue(e)))
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            gridColumn: "span 2"
                        },
                        children: getNumericInputField("cost-ratio-incl", "Cost Ratio (Incl.)", costRationIncl, (e)=>setCostRationIncl(getCleanValue(e)))
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            gridColumn: "span 2"
                        },
                        children: getNumericInputField("cost-ratio-excl", "Cost Ratio (Excl.)", costRationExcl, (e)=>setCostRationExcl(getCleanValue(e)))
                    }),
                    getNumericInputField("nra", "NRA", nra, (e)=>setNra(getCleanValue(e))),
                    getNumericInputField("nta", "NTA", nta, (e)=>setNta(getCleanValue(e))),
                    getNumericInputField("ndv", "NDV", ndv, (e)=>setNdv(getCleanValue(e))),
                    getNumericInputField("average", "Average", average, (e)=>setAverage(getCleanValue(e)))
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    gridColumn: "span 3",
                    marginTop: "50px",
                    paddingBottom: "45px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-kpi-button",
                        onClick: handleCancel,
                        disabled: createKpiResult.loading || updateKpiResult.loading,
                        text: kpiInput === null || editable ? "Cancel" : "Close"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "save-kpi-button",
                        "data-testid": "save-kpi-button",
                        onClick: handleSubmit,
                        disabled: createKpiResult.loading || updateKpiResult.loading || !editable,
                        text: kpiInput === null ? "Create" : "Save"
                    })
                ]
            })
        ]
    });
};
var $462d626dabd1555d$export$2e2bcd8739ae039 = $462d626dabd1555d$var$KpiForm;

});


parcelRegister("5604T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e206fc673b8c35c0$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hsjD5 = parcelRequire("hsjD5");

var $b42dh = parcelRequire("b42dh");

var $chLJv = parcelRequire("chLJv");

var $a4SgC = parcelRequire("a4SgC");

var $ft8Mg = parcelRequire("ft8Mg");
const $e206fc673b8c35c0$var$AwardsTab = ({ stockId: stockId })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [allData, setAllData] = (0, $bh6RR.useState)([]);
    const [openAwardForm, setOpenAwardForm] = (0, $bh6RR.useState)(false);
    const [award, setAward] = (0, $bh6RR.useState)(null);
    const canCreate = (0, $dqRXb.canUserCreate)(state.user, (0, $gUBkJ.Types).Stock);
    const { data: data, loading: loading } = (0, $hjfla.useGetHistoryAwardsQuery)({
        fetchPolicy: "no-cache",
        variables: {
            stock_id: parseInt(stockId)
        }
    });
    const [deleteAward] = (0, $hjfla.useDeleteAwardMutation)();
    const createAwardSubscription = (0, $hjfla.useAwardCreatedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    const updateAwardSubscription = (0, $hjfla.useAwardUpdatedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    const deleteAwardSubscription = (0, $hjfla.useAwardDeletedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setAllData(data.result);
    }, [
        data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createAwardSubscription.data?.result) {
            const existing = allData.find((a)=>a.id === createAwardSubscription.data?.result.id);
            if (!existing) setAllData([
                createAwardSubscription.data.result,
                ...allData
            ]);
        }
        if (deleteAwardSubscription.data?.result) removeAward(deleteAwardSubscription.data.result);
        if (updateAwardSubscription.data?.result) {
            const updated = updateAwardSubscription.data?.result;
            const data = allData;
            const result = data.map((d)=>d.id === updated.id ? updated : d);
            setAllData(result);
        }
    }, [
        createAwardSubscription.data,
        updateAwardSubscription.data,
        deleteAwardSubscription.data
    ]);
    const handleClose = (saved, isNew, award)=>{
        if (saved && award) {
            if (isNew) setAllData([
                award,
                ...allData
            ]);
        }
        setAward(null);
        setOpenAwardForm(false);
    };
    const handleDetails = (rowData)=>{
        setAward(rowData);
        setOpenAwardForm(true);
    };
    const removeAward = (input)=>{
        const result = allData.filter((l)=>l.id !== input.id);
        setAllData(result);
    };
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete Award from ${(0, $hsjD5.renderDate)(rowData.date)}?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleDelete = (awardToDelete)=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteAward({
            variables: {
                id: awardToDelete.id
            },
            update () {
                removeAward(awardToDelete);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: `Award from ${(0, $hsjD5.renderDate)(awardToDelete.date)} deleted`
                    }
                });
            }
        }).catch((error)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            }));
    };
    const columns = [
        {
            title: "Details",
            sorting: false,
            width: 82
        },
        {
            title: "Date Day",
            field: "date",
            width: 182,
            type: "date",
            render: (rowData)=>(0, $hsjD5.renderDate)(rowData.date)
        },
        {
            title: "Award Type ",
            field: "type.name",
            width: 1307
        },
        {
            title: "Remove",
            sorting: false,
            width: 71
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            className: "print\\:w-full",
            children: [
                loading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $ft8Mg.default), {}) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    style: {
                        marginTop: "10px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
                        columns: columns,
                        data: allData,
                        loading: loading,
                        handleDetails: handleDetails,
                        handleRemove: handleRemove,
                        createButtonProps: {
                            id: "create-award-button",
                            onClick: ()=>setOpenAwardForm(true),
                            text: "Create",
                            disabled: !canCreate
                        },
                        maxHeight: 1050,
                        pageSize: 15
                    })
                }),
                openAwardForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $a4SgC.default), {
                    stockId: stockId,
                    awardInput: award,
                    handleClose: handleClose
                })
            ]
        })
    });
};
var $e206fc673b8c35c0$export$2e2bcd8739ae039 = $e206fc673b8c35c0$var$AwardsTab;

});
parcelRegister("a4SgC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a93974c08dc60be5$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $5PJ2i = parcelRequire("5PJ2i");

var $hjfla = parcelRequire("hjfla");

var $chLJv = parcelRequire("chLJv");

var $bSbwb = parcelRequire("bSbwb");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $dqRXb = parcelRequire("dqRXb");

var $6L9uu = parcelRequire("6L9uu");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $gFVvY = parcelRequire("gFVvY");

var $bilGR = parcelRequire("bilGR");

var $91340 = parcelRequire("91340");
const $a93974c08dc60be5$var$defaultErrorsObj = {
    type: null,
    dateStart: null
};
const $a93974c08dc60be5$var$errorTexts = {
    date: "Date is required!",
    type: "Award Type is required!"
};
const $a93974c08dc60be5$var$AwardForm = ({ stockId: stockId, awardInput: awardInput, handleClose: handleClose })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($a93974c08dc60be5$var$defaultErrorsObj);
    const [awardType, setAwardType] = (0, $bh6RR.useState)(awardInput?.type || null);
    const [dateStart, setDateStart] = (0, $bh6RR.useState)(awardInput ? (0, $gFVvY.parseDate)(awardInput.date) : new Date());
    const [editable, setEditable] = (0, $bh6RR.useState)(awardInput === null);
    const awardTypes = (0, $hjfla.useGetAwardTypesQuery)();
    const [createAward, createAwardResult] = (0, $hjfla.useCreateAwardMutation)();
    const [updateAward, updateAwardResult] = (0, $hjfla.useUpdateAwardMutation)();
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Stock);
    const handleAwardTypeChange = (_, newValue)=>{
        setFormErrors({
            ...formErrors,
            type: newValue ? null : $a93974c08dc60be5$var$errorTexts.type
        });
        setAwardType(newValue);
    };
    const handleDateChange = (input)=>{
        if (input) {
            if (!Number.isNaN(input.getDate())) setFormErrors({
                ...formErrors,
                dateStart: null
            });
        } else setFormErrors({
            ...formErrors,
            dateStart: $a93974c08dc60be5$var$errorTexts.date
        });
        setDateStart(input);
    };
    const handleCancel = ()=>{
        if (editable && awardInput !== null) {
            setAwardType(awardInput?.type || null);
            setDateStart((0, $gFVvY.parseDate)(awardInput.date));
            setFormErrors($a93974c08dc60be5$var$defaultErrorsObj);
            setEditable(false);
        } else handleClose(false);
    };
    const handleSubmit = ()=>{
        let hasErrors = false;
        const errors = {
            type: null,
            dateStart: null
        };
        if (!dateStart) {
            hasErrors = true;
            errors.dateStart = $a93974c08dc60be5$var$errorTexts.date;
        }
        if (!awardType) {
            hasErrors = true;
            errors.type = $a93974c08dc60be5$var$errorTexts.type;
        }
        if (hasErrors) setFormErrors(errors);
        else handleSave(awardInput === null ? "create" : "update");
    };
    const handleSave = (type)=>{
        if (type === "create") createAward({
            variables: {
                stock_id: stockId,
                input: {
                    type_id: awardType?.id,
                    date: dateStart.toString()
                }
            },
            update (_, { data: data }) {
                handleClose(true, true, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Award created"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
        else updateAward({
            variables: {
                id: awardInput?.id,
                input: {
                    type_id: awardType?.id,
                    date: dateStart.toString()
                }
            },
            update (_, { data: data }) {
                handleClose(true, false, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Award updated"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "dividend-dialog",
        width: 520,
        title: awardInput ? "Award Details" : "Create Award",
        onClose: handleClose,
        childrenSx: {
            px: "40px",
            py: "20px"
        },
        children: [
            awardInput && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    textAlign: "right",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "award-form-edit-button",
                    onClick: ()=>setEditable(true),
                    disabled: editable || !canEdit,
                    editButtonColor: editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                display: "flex",
                gap: "15px",
                sx: {
                    my: "20px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                        id: "award-type-autocomplete",
                        options: awardTypes.data?.result || [],
                        getOptionLabel: (option)=>option.name,
                        values: awardType,
                        onChange: handleAwardTypeChange,
                        errorMsg: formErrors.type,
                        label: "Award Type",
                        disabled: createAwardResult.loading || updateAwardResult.loading || !editable
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                            dateAdapter: (0, $1Dn8S.AdapterDateFns),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                id: "award-date-picker",
                                label: "Date",
                                value: dateStart,
                                disabled: createAwardResult.loading || updateAwardResult.loading || !editable,
                                onChange: (d)=>handleDateChange(d),
                                errorMsg: formErrors.dateStart
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    gridColumn: "span 3",
                    marginTop: "50px",
                    paddingBottom: "45px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-award-button",
                        onClick: handleCancel,
                        disabled: createAwardResult.loading || updateAwardResult.loading,
                        text: awardInput === null || editable ? "Cancel" : "Close"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "save-award-button",
                        "data-testid": "save-award-button",
                        onClick: handleSubmit,
                        disabled: createAwardResult.loading || updateAwardResult.loading,
                        text: awardInput === null ? "Create" : "Save"
                    })
                ]
            })
        ]
    });
};
var $a93974c08dc60be5$export$2e2bcd8739ae039 = $a93974c08dc60be5$var$AwardForm;

});


parcelRegister("kJTnB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b8e264ca3905280$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $chLJv = parcelRequire("chLJv");

var $b42dh = parcelRequire("b42dh");

var $9mpok = parcelRequire("9mpok");

var $ft8Mg = parcelRequire("ft8Mg");
const $3b8e264ca3905280$var$AllocationSectorTab = ({ stockId: stockId, companyName: companyName })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [allData, setAllData] = (0, $bh6RR.useState)([]);
    const [allocationSector, setAllocationSector] = (0, $bh6RR.useState)(null);
    const [openAllSectorForm, setOpenAllSectorForm] = (0, $bh6RR.useState)(false);
    const [deleteAllocationSector] = (0, $hjfla.useDeleteAllocationSectorMutation)();
    const canCreate = (0, $dqRXb.canUserCreate)(state.user, (0, $gUBkJ.Types).Stock);
    const createAllocationSectorSubscription = (0, $hjfla.useAllocationSectorCreatedSubscription)({
        variables: {
            stock_id: stockId
        }
    });
    const updateAllocationSectorSubscription = (0, $hjfla.useAllocationSectorUpdatedSubscription)({
        variables: {
            stock_id: stockId
        }
    });
    const deleteAllocationSecotrSubscription = (0, $hjfla.useAllocationSectorDeletedSubscription)({
        variables: {
            stock_id: stockId
        }
    });
    const { data: data, loading: loading } = (0, $hjfla.useGetAllocationSectorsQuery)({
        fetchPolicy: "no-cache",
        variables: {
            stock_id: parseInt(stockId)
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setAllData(data.result);
    }, [
        data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createAllocationSectorSubscription.data?.result) addAllSector(createAllocationSectorSubscription.data?.result);
        if (deleteAllocationSecotrSubscription.data?.result) removeAllocationSector(deleteAllocationSecotrSubscription.data.result);
        if (updateAllocationSectorSubscription.data?.result) updateAllSector(updateAllocationSectorSubscription.data?.result);
    }, [
        createAllocationSectorSubscription.data,
        updateAllocationSectorSubscription.data,
        deleteAllocationSecotrSubscription.data
    ]);
    const columns = [
        {
            title: "Details",
            sorting: false,
            width: 82
        },
        {
            title: "Date Year",
            field: "year",
            width: 100
        },
        {
            title: "Company Name",
            width: 900,
            render: ()=>companyName,
            sorting: false
        },
        {
            title: "ID Sector type",
            field: "sector_id",
            width: 273
        },
        {
            title: "Sector %",
            field: "value",
            width: 180
        },
        {
            title: "Remove",
            sorting: false
        }
    ];
    const handleDetails = (rowData)=>{
        setAllocationSector(rowData);
        setOpenAllSectorForm(true);
    };
    const removeAllocationSector = (input)=>{
        const result = allData.filter((l)=>l.id !== input.id);
        setAllData(result);
    };
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete sector allocation from ${rowData.year.toString()}?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleDelete = (allocationSector)=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteAllocationSector({
            variables: {
                id: allocationSector.id
            },
            update () {
                removeAllocationSector(allocationSector);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: `Sector allocation from ${allocationSector.year.toString()} deleted`
                    }
                });
            }
        }).catch((error)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            }));
    };
    const handleClose = (saved, isNew, allSectorInput)=>{
        if (saved && allSectorInput) {
            if (isNew) addAllSector(allSectorInput);
            else updateAllSector(allSectorInput);
        }
        setAllocationSector(null);
        setOpenAllSectorForm(false);
    };
    const addAllSector = (allSectorInput)=>setAllData([
            allSectorInput,
            ...allData
        ]);
    const updateAllSector = (allSectorInput)=>setAllData(allData.map((k)=>k.id === allSectorInput.id ? allSectorInput : k));
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            className: "print\\:w-full",
            children: [
                loading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $ft8Mg.default), {}) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    style: {
                        marginTop: "10px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
                        columns: columns,
                        data: allData,
                        loading: loading,
                        handleDetails: handleDetails,
                        handleRemove: handleRemove,
                        createButtonProps: {
                            id: "create-allocation-sector-button",
                            onClick: ()=>setOpenAllSectorForm(true),
                            text: "Create",
                            disabled: !canCreate
                        },
                        maxHeight: 800,
                        pageSize: 15
                    })
                }),
                openAllSectorForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $9mpok.default), {
                    stockId: stockId,
                    companyName: companyName,
                    handleClose: handleClose,
                    allSectorInput: allocationSector
                })
            ]
        })
    });
};
var $3b8e264ca3905280$export$2e2bcd8739ae039 = $3b8e264ca3905280$var$AllocationSectorTab;

});
parcelRegister("9mpok", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58de13078e37eefe$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $5PJ2i = parcelRequire("5PJ2i");

var $hjfla = parcelRequire("hjfla");

var $chLJv = parcelRequire("chLJv");

var $bSbwb = parcelRequire("bSbwb");

var $6L9uu = parcelRequire("6L9uu");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $dqRXb = parcelRequire("dqRXb");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $ehzwo = parcelRequire("ehzwo");

var $bilGR = parcelRequire("bilGR");
const $58de13078e37eefe$var$defaultErrorsObj = {
    sectorId: null,
    value: null,
    year: null
};
const $58de13078e37eefe$var$errorTexts = {
    sectorId: "Sector is required!",
    value: "Sector % is required!",
    year: "Year is required!"
};
const $58de13078e37eefe$var$AllocationSectorForm = ({ stockId: stockId, companyName: companyName, handleClose: handleClose, allSectorInput: allSectorInput })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($58de13078e37eefe$var$defaultErrorsObj);
    const [editable, setEditable] = (0, $bh6RR.useState)(allSectorInput === null);
    const [sectorId, setSectorId] = (0, $bh6RR.useState)(allSectorInput?.sector_id || null);
    const [sectorTypeOption, setSectorTypeOption] = (0, $bh6RR.useState)(null);
    const [sectorValue, setSectorValue] = (0, $bh6RR.useState)(allSectorInput?.value || null);
    const [sectorYear, setSectorYear] = (0, $bh6RR.useState)(allSectorInput?.year || null);
    const allSectors = (0, $hjfla.useSectorsQuery)();
    const [createAllSector, createAllSectorResult] = (0, $hjfla.useCreateAllocationSectorMutation)();
    const [updateAllSector, updateAllSectorResult] = (0, $hjfla.useUpdateAllocationSectorMutation)();
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Stock);
    (0, $bh6RR.useEffect)(()=>{
        if (allSectors.data && allSectors.data.result) {
            if (sectorId) setSectorTypeOption(allSectors.data.result.find((s)=>s?.id === sectorId) || null);
        }
    }, [
        allSectors
    ]);
    const handleSectorChange = (_, newValue)=>{
        setFormErrors({
            ...formErrors,
            sectorId: newValue ? null : $58de13078e37eefe$var$errorTexts.sectorId
        });
        setSectorTypeOption(newValue);
        setSectorId(newValue ? newValue.id : null);
    };
    const handleSectorValueChange = (e)=>{
        const value = e.currentTarget.value === "" ? null : Number(e.currentTarget.value);
        setFormErrors({
            ...formErrors,
            value: value ? null : $58de13078e37eefe$var$errorTexts.value
        });
        setSectorValue(value);
    };
    const handleSectorYearChange = (e)=>{
        const value = e.currentTarget.value === "" ? null : Number(e.currentTarget.value);
        setFormErrors({
            ...formErrors,
            year: value ? null : $58de13078e37eefe$var$errorTexts.year
        });
        setSectorYear(value);
    };
    const handleCancel = ()=>{
        if (editable && allSectorInput !== null) {
            setSectorId(allSectorInput?.sector_id || null);
            if (allSectors.data && allSectors.data.result) {
                if (allSectorInput?.sector_id) setSectorTypeOption(allSectors.data.result.find((s)=>s?.id === allSectorInput?.sector_id) || null);
            }
            setSectorValue(allSectorInput?.value || null);
            setSectorYear(allSectorInput?.year || null);
            setFormErrors($58de13078e37eefe$var$defaultErrorsObj);
            setEditable(false);
        } else handleClose(false);
    };
    const handleSubmit = ()=>{
        let hasErrors = false;
        const errors = {
            sectorId: null,
            value: null,
            year: null
        };
        if (!sectorId) {
            hasErrors = true;
            errors.sectorId = $58de13078e37eefe$var$errorTexts.sectorId;
        }
        if (!sectorValue) {
            hasErrors = true;
            errors.value = $58de13078e37eefe$var$errorTexts.value;
        }
        if (!sectorYear) {
            hasErrors = true;
            errors.year = $58de13078e37eefe$var$errorTexts.year;
        }
        if (hasErrors) setFormErrors(errors);
        else if (allSectorInput) updateAllSector({
            variables: {
                id: allSectorInput.id,
                input: getAllSectorInput()
            },
            update (_, { data: data }) {
                handleClose(true, false, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Allocation Sector Updated"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
        else createAllSector({
            variables: {
                stock_id: stockId,
                input: getAllSectorInput()
            },
            update (_, { data: data }) {
                handleClose(true, true, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Allocation Sector Created"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
    };
    const getAllSectorInput = ()=>({
            sector_id: sectorId,
            year: sectorYear,
            value: sectorValue
        });
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "allocation-sector-dialog",
        width: 690,
        title: allSectorInput ? "Allocation Sector Details" : "Create Allocation Sector",
        onClose: handleClose,
        childrenSx: {
            px: "40px",
            py: "20px"
        },
        children: [
            allSectorInput && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    textAlign: "right",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "allocation-sector-form-edit-button",
                    onClick: ()=>setEditable(true),
                    disabled: editable || !canEdit,
                    editButtonColor: editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    mt: "20px",
                    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                    gap: "24px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "allocation-sector-form-company",
                        label: "Company",
                        value: companyName,
                        disabled: true,
                        additionalStyle: {
                            gridColumn: "span 4"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                        id: "allocation-sector-autocomplete",
                        "data-testid": "allocation-sector-autocomplete",
                        label: "Sector Type",
                        options: allSectors.data?.result || [],
                        getOptionLabel: (option)=>option?.name,
                        values: sectorTypeOption,
                        onChange: handleSectorChange,
                        disabled: createAllSectorResult.loading || updateAllSectorResult.loading || !editable,
                        additionalStyle: {
                            gridColumn: "span 2"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: `allocation-sector-form-sector-value`,
                        "data-testid": `allocation-sector-form-sector-value`,
                        label: "Sector %",
                        type: "number",
                        value: sectorValue || "",
                        disabled: createAllSectorResult.loading || updateAllSectorResult.loading || !editable,
                        onChange: (e)=>handleSectorValueChange(e),
                        errorMsg: formErrors.value
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: `allocation-sector-form-sector-year`,
                        "data-testid": `allocation-sector-form-sector-year`,
                        label: "Date Year",
                        type: "number",
                        value: sectorYear || "",
                        disabled: createAllSectorResult.loading || updateAllSectorResult.loading || !editable,
                        onChange: (e)=>handleSectorYearChange(e),
                        errorMsg: formErrors.year
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    gridColumn: "span 3",
                    marginTop: "50px",
                    paddingBottom: "45px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-allocation-sector-button",
                        onClick: handleCancel,
                        disabled: createAllSectorResult.loading || updateAllSectorResult.loading,
                        text: allSectorInput === null || editable ? "Cancel" : "Close"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "save-allocation-sector-button",
                        onClick: handleSubmit,
                        disabled: createAllSectorResult.loading || updateAllSectorResult.loading || !editable,
                        text: allSectorInput === null ? "Create" : "Save"
                    })
                ]
            })
        ]
    });
};
var $58de13078e37eefe$export$2e2bcd8739ae039 = $58de13078e37eefe$var$AllocationSectorForm;

});


parcelRegister("LJwaH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b8dab91a5d6a40e$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $chLJv = parcelRequire("chLJv");

var $ft8Mg = parcelRequire("ft8Mg");

var $b42dh = parcelRequire("b42dh");

var $6L9uu = parcelRequire("6L9uu");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");

var $7caAd = parcelRequire("7caAd");
const $4b8dab91a5d6a40e$var$AllocationCountryTab = ({ stockId: stockId })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [date, setDate] = (0, $bh6RR.useState)(null);
    const [minDate, setMinDate] = (0, $bh6RR.useState)(new Date());
    const [maxDate, setMaxDate] = (0, $bh6RR.useState)(new Date());
    const [allData, setAllData] = (0, $bh6RR.useState)([]);
    const canCreate = (0, $dqRXb.canUserCreate)(state.user, (0, $gUBkJ.Types).Stock);
    const [fileteredData, setFileteredData] = (0, $bh6RR.useState)([]);
    const [openCountryForm, setOpenCountryForm] = (0, $bh6RR.useState)(false);
    const [allocationCountry, setAllocationCountry] = (0, $bh6RR.useState)(null);
    const [deleteAllocationCountry] = (0, $hjfla.useDeleteAllocationCountryMutation)();
    const { data: data, loading: loading } = (0, $hjfla.useGetHistoryAllocationCountriesQuery)({
        fetchPolicy: "no-cache",
        variables: {
            stock_id: parseInt(stockId)
        }
    });
    const createAllocationCountrySubscription = (0, $hjfla.useAllocationCountryCreatedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    const updateAllocationCountrySubscription = (0, $hjfla.useAllocationCountryUpdatedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    const deleteAllocationCountrySubscription = (0, $hjfla.useAllocationCountryDeletedSubscription)({
        variables: {
            stock_id: stockId || ""
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            const entities = data.result;
            setAllData(entities);
            setFileteredData(entities);
        }
    }, [
        data?.result
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const years = [
            ...new Set(allData.map((r)=>r?.year))
        ];
        if (allData.length > 0) {
            const min = new Date();
            min.setFullYear(Math.min(...years));
            const max = new Date();
            setMinDate(min);
            max.setFullYear(Math.max(...years));
            setMaxDate(max);
        }
    }, [
        allData
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createAllocationCountrySubscription.data?.result) addAllocationCountry(createAllocationCountrySubscription.data?.result);
        if (updateAllocationCountrySubscription.data?.result) updateAllocationCountry(updateAllocationCountrySubscription.data?.result);
        if (deleteAllocationCountrySubscription.data?.result) removeAllocationCountry(deleteAllocationCountrySubscription.data.result);
    }, [
        createAllocationCountrySubscription.data,
        updateAllocationCountrySubscription.data,
        deleteAllocationCountrySubscription.data
    ]);
    const columns = [
        {
            title: "Details",
            sorting: false,
            width: 81
        },
        {
            title: "Year",
            field: "year",
            width: 88,
            type: "numeric"
        },
        {
            title: "Country ",
            field: "country.name",
            width: 1154
        },
        {
            title: "Country %",
            field: "value",
            type: "numeric",
            width: 241
        },
        {
            title: "Remove",
            sorting: false,
            width: 71
        }
    ];
    const handleDateChange = (value)=>{
        const input = value;
        if (input) {
            if (!Number.isNaN(input.getDate())) setFileteredData(allData.filter((d)=>d.year === input.getFullYear()));
        } else setFileteredData(allData);
        setDate(input);
    };
    const handleClose = (saved, isNew, allocationCountryInput)=>{
        if (saved && allocationCountryInput) {
            if (isNew) addAllocationCountry(allocationCountryInput);
        }
        setAllocationCountry(null);
        setOpenCountryForm(false);
    };
    const handleDetails = (rowData)=>{
        setAllocationCountry(rowData);
        setOpenCountryForm(true);
    };
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete allocation country from ${rowData.year.toString()}?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const removeAllocationCountry = (input)=>{
        console.log("removeAllocationCountry: ", input);
        const result = allData.filter((l)=>l.id !== input.id);
        setAllData(result);
        setFileteredData(fileteredData.filter((l)=>l.id !== input.id));
    };
    const handleDelete = (allocationCountry)=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteAllocationCountry({
            variables: {
                id: allocationCountry.id
            },
            update () {
                removeAllocationCountry(allocationCountry);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: `Allocation country from ${allocationCountry.year.toString()} deleted`
                    }
                });
            }
        }).catch((error)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            }));
    };
    const addAllocationCountry = (input)=>{
        console.log("addAllocationCountry: ", input);
        const existing = allData.find((d)=>d.id === input.id);
        if (!existing) {
            setAllData([
                input,
                ...allData
            ]);
            if (date) {
                if (date.getFullYear() === input.year) setFileteredData([
                    input,
                    ...fileteredData
                ]);
            } else setFileteredData([
                input,
                ...fileteredData
            ]);
        }
    };
    const updateAllocationCountry = (input)=>{
        console.log("updateAllocationCountry: ", input);
        setAllData(allData.map((d)=>d.id === input.id ? input : d));
        if (date) {
            if (date.getFullYear() === input.year) {
                const exists = fileteredData.find((d)=>d.id === input.id);
                if (exists) setFileteredData(fileteredData.map((d)=>d.id === input.id ? input : d));
                else setFileteredData([
                    input,
                    ...fileteredData
                ]);
            }
        } else setFileteredData(fileteredData.map((d)=>d.id === input.id ? input : d));
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        children: [
            loading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $ft8Mg.default), {}) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "print\\:w-full",
                sx: {
                    pt: "25px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            position: "absolute",
                            pl: "25px"
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                            dateAdapter: (0, $1Dn8S.AdapterDateFns),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                id: "allocation-country-date-picker",
                                label: "Year",
                                value: date,
                                onChange: handleDateChange,
                                minDate: minDate,
                                maxDate: maxDate,
                                views: [
                                    "year"
                                ],
                                format: "yyyy"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
                        columns: columns,
                        data: fileteredData,
                        handleDetails: handleDetails,
                        handleRemove: handleRemove,
                        toolbarBackground: (0, $6L9uu.Colors).white,
                        createButtonProps: {
                            id: "create-allocation-country-button",
                            onClick: ()=>setOpenCountryForm(true),
                            text: "Create",
                            disabled: !canCreate
                        },
                        maxHeight: 600,
                        pageSize: 15
                    })
                ]
            }),
            openCountryForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $7caAd.default), {
                stockId: stockId,
                countryInput: allocationCountry,
                handleClose: handleClose
            })
        ]
    });
};
var $4b8dab91a5d6a40e$export$2e2bcd8739ae039 = $4b8dab91a5d6a40e$var$AllocationCountryTab;

});
parcelRegister("7caAd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a317f45330cbabf$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");

var $bSbwb = parcelRequire("bSbwb");

var $6L9uu = parcelRequire("6L9uu");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $dqRXb = parcelRequire("dqRXb");

var $bilGR = parcelRequire("bilGR");

var $ehzwo = parcelRequire("ehzwo");
const $6a317f45330cbabf$var$defaultErrorsObj = {
    country: null,
    percent: null,
    year: null
};
const $6a317f45330cbabf$var$errorTexts = {
    country: "Country is required!",
    percent: "Country percent is required!",
    year: "Year is required!"
};
const $6a317f45330cbabf$var$CountryForm = ({ stockId: stockId, handleClose: handleClose, countryInput: countryInput })=>{
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($6a317f45330cbabf$var$defaultErrorsObj);
    const [editable, setEditable] = (0, $bh6RR.useState)(countryInput === null);
    const [country, setCountry] = (0, $bh6RR.useState)(countryInput?.country || null);
    const [percent, setPercent] = (0, $bh6RR.useState)(countryInput?.value || null);
    const [year, setYear] = (0, $bh6RR.useState)(countryInput?.year || null);
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Stock);
    const countries = (0, $hjfla.useCountryNamesQuery)();
    const [createAllocationCountry, createAllocationCountryResult] = (0, $hjfla.useCreateAllocationCountryMutation)();
    const [updateAllocationCountry, updateAllocationCountryResult] = (0, $hjfla.useUpdateAllocationCountryMutation)();
    const handleCountryChange = (_, newValue)=>{
        setFormErrors({
            ...formErrors,
            country: newValue === null ? $6a317f45330cbabf$var$errorTexts.country : null
        });
        setCountry(newValue);
    };
    const handlePercentChange = (event)=>{
        const value = event.currentTarget.value === "" ? null : Number(event.currentTarget.value);
        setFormErrors({
            ...formErrors,
            percent: value === null ? $6a317f45330cbabf$var$errorTexts.percent : null
        });
        setPercent(value);
    };
    const handleYearChange = (event)=>{
        const value = event.currentTarget.value === "" ? null : Number(event.currentTarget.value);
        setFormErrors({
            ...formErrors,
            year: value === null ? $6a317f45330cbabf$var$errorTexts.year : null
        });
        setYear(value);
    };
    const handleCancel = ()=>{
        if (editable && countryInput !== null) {
            setCountry(countryInput?.country);
            setPercent(countryInput?.value);
            setFormErrors($6a317f45330cbabf$var$defaultErrorsObj);
            setEditable(false);
        } else handleClose(false);
    };
    const handleSubmit = ()=>{
        let hasErrors = false;
        const errors = {
            ...$6a317f45330cbabf$var$defaultErrorsObj
        };
        if (country === null) {
            hasErrors = true;
            errors.country = $6a317f45330cbabf$var$errorTexts.country;
        }
        if (percent === null) {
            hasErrors = true;
            errors.percent = $6a317f45330cbabf$var$errorTexts.percent;
        }
        if (percent === null) {
            hasErrors = true;
            errors.year = $6a317f45330cbabf$var$errorTexts.year;
        }
        if (hasErrors) setFormErrors(errors);
        else handleSave(countryInput === null ? "create" : "update");
    };
    const handleSave = (type)=>{
        const input = {
            country_id: country?.id,
            value: percent,
            year: year
        };
        if (type === "create") createAllocationCountry({
            variables: {
                stock_id: stockId,
                input: input
            },
            update (_, { data: data }) {
                handleClose(true, true, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Allocation country created"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
        else updateAllocationCountry({
            variables: {
                id: countryInput?.id,
                input: input
            },
            update (_, { data: data }) {
                handleClose(true, false, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Allocation country updated"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "allocation-country-dialog",
        width: 410,
        title: countryInput ? "Allocation Country Details" : "Create Allocation Country",
        onClose: handleClose,
        childrenSx: {
            px: "40px",
            py: "20px"
        },
        children: [
            countryInput && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    textAlign: "right",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "allocation-country-form-edit-button",
                    onClick: ()=>setEditable(true),
                    disabled: editable || !canEdit,
                    editButtonColor: editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    mt: "20px",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    gap: "24px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                        id: "countries-autocomplete",
                        "data-testid": "countries-autocomplete",
                        options: countries.data?.result || [],
                        getOptionLabel: (option)=>option?.name,
                        label: "Country",
                        values: country,
                        onChange: handleCountryChange,
                        disabled: countries.loading || !editable || createAllocationCountryResult.loading || updateAllocationCountryResult.loading,
                        errorMsg: formErrors.country,
                        additionalStyle: {
                            gridColumn: "span 2"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "percent-value",
                        "data-testid": "percent-value",
                        label: "Country%",
                        type: "number",
                        value: percent,
                        onChange: handlePercentChange,
                        disabled: countries.loading || !editable || createAllocationCountryResult.loading || updateAllocationCountryResult.loading,
                        errorMsg: formErrors.percent
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "year",
                        "data-testid": "year",
                        label: "Year",
                        type: "number",
                        value: year,
                        onChange: handleYearChange,
                        disabled: countries.loading || !editable || createAllocationCountryResult.loading || updateAllocationCountryResult.loading,
                        errorMsg: formErrors.year
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    gridColumn: "span 3",
                    marginTop: "50px",
                    paddingBottom: "45px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-allocation-country-button",
                        onClick: handleCancel,
                        disabled: createAllocationCountryResult.loading || updateAllocationCountryResult.loading,
                        text: countryInput === null || editable ? "Cancel" : "Close"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "save-allocation-country-button",
                        onClick: handleSubmit,
                        disabled: countries.loading || !editable || createAllocationCountryResult.loading || updateAllocationCountryResult.loading,
                        text: countryInput === null ? "Create" : "Save"
                    })
                ]
            })
        ]
    });
};
var $6a317f45330cbabf$export$2e2bcd8739ae039 = $6a317f45330cbabf$var$CountryForm;

});


parcelRegister("1rZiL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5943a79aa5f6b8de$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $aSMrn = parcelRequire("aSMrn");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $dqRXb = parcelRequire("dqRXb");

var $hsjD5 = parcelRequire("hsjD5");

var $6L9uu = parcelRequire("6L9uu");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");

var $ft8Mg = parcelRequire("ft8Mg");

var $b42dh = parcelRequire("b42dh");

var $239np = parcelRequire("239np");
const $5943a79aa5f6b8de$var$RecalcsTab = ({ stockId: stockId })=>{
    const [allData, setAllData] = (0, $bh6RR.useState)([]);
    const [openCreateRecalcForm, setOpenCreateRecalcForm] = (0, $bh6RR.useState)(false);
    const [historyRecalc, setHistoryRecalc] = (0, $bh6RR.useState)(null);
    const [recalcRollback] = (0, $hjfla.useRecalcRollbackMutation)();
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const canCreate = (0, $dqRXb.canUserCreate)(state.user, (0, $gUBkJ.Types).Stock);
    const createRecalcSubscription = (0, $hjfla.useHistoryRecalcCreatedSubscription)({
        variables: {
            stock_id: stockId
        }
    });
    const updateRecalcSubscription = (0, $hjfla.useHistoryRecalcUpdatedSubscription)({
        variables: {
            stock_id: stockId
        }
    });
    const { data: data, loading: loading } = (0, $hjfla.useGetHistoryRecalcsQuery)({
        fetchPolicy: "no-cache",
        variables: {
            stock_id: parseInt(stockId)
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setAllData(data.result);
    }, [
        data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createRecalcSubscription.data?.result) addHistoryRecalc(createRecalcSubscription.data?.result);
        if (updateRecalcSubscription.data?.result) {
            const updated = updateRecalcSubscription.data.result;
            updateHistoryRecalc(updated);
        }
    }, [
        createRecalcSubscription.data,
        updateRecalcSubscription.data
    ]);
    const handleRollback = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to rollback?`,
                agreeAction: executeRollback,
                params: rowData
            }
        });
    };
    const updateHistoryRecalc = (historyRecalc)=>{
        setAllData(allData.map((k)=>k.id === historyRecalc.id ? historyRecalc : k));
    };
    const executeRollback = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        recalcRollback({
            variables: {
                id: rowData.id
            },
            update (_, { data: data }) {
                updateHistoryRecalc(data);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Recalc Rollbacked Successfully"
                    }
                });
            }
        }).catch((error)=>dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: error.message,
                    autoHide: 6000
                }
            }));
    };
    const columns = [
        {
            title: "Details",
            sorting: false,
            width: 81
        },
        {
            title: "Start Day",
            field: "start_date",
            width: 133,
            type: "date",
            render: (rowData)=>(0, $hsjD5.renderDate)(rowData.start_date)
        },
        {
            title: "End Day",
            field: "end_date",
            width: 146,
            type: "date",
            render: (rowData)=>(0, $hsjD5.renderDate)(rowData.end_date)
        },
        {
            title: "Field ",
            field: "column_to_recalc",
            width: 624
        },
        {
            title: "Operator ",
            field: "operator.value",
            width: 137
        },
        {
            title: "Factor ",
            field: "value_to_calc_with",
            width: 127
        },
        {
            title: "RollBack",
            sorting: false,
            width: 72,
            // eslint-disable-next-line react/display-name
            render: (rowData)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                    style: {
                        height: "38px",
                        transform: "scaleX(-1)"
                    },
                    onClick: ()=>handleRollback(rowData),
                    disabled: rowData.is_rollbacked || !canCreate,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aSMrn.default), {
                        style: {
                            color: rowData.is_rollbacked || !canCreate ? (0, $6L9uu.Colors).dark_gray : (0, $6L9uu.Colors).skyBlue
                        }
                    })
                })
        }
    ];
    const handleClose = (saved, isNew, historyRecalcInput)=>{
        if (saved && historyRecalcInput) {
            if (isNew) addHistoryRecalc(historyRecalcInput);
        }
        setHistoryRecalc(null);
        setOpenCreateRecalcForm(false);
    };
    const addHistoryRecalc = (input)=>{
        const existing = allData.find((d)=>d.id === input.id);
        if (!existing) setAllData([
            input,
            ...allData
        ]);
    };
    const handleDetails = (rowData)=>{
        setHistoryRecalc(rowData);
        setOpenCreateRecalcForm(true);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        children: [
            loading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $ft8Mg.default), {}) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                className: "print\\:w-full",
                sx: {
                    pt: "25px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b42dh.default), {
                    columns: columns,
                    data: allData,
                    handleDetails: handleDetails,
                    handleRemove: ()=>true,
                    toolbarBackground: (0, $6L9uu.Colors).white,
                    createButtonProps: {
                        id: "create-recalc-button",
                        onClick: ()=>setOpenCreateRecalcForm(true),
                        text: "Create",
                        disabled: !canCreate
                    },
                    maxHeight: 600,
                    pageSize: 15
                })
            }),
            openCreateRecalcForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $239np.default), {
                stockId: stockId,
                handleClose: handleClose,
                historyRecalcInput: historyRecalc
            })
        ]
    });
};
var $5943a79aa5f6b8de$export$2e2bcd8739ae039 = $5943a79aa5f6b8de$var$RecalcsTab;

});
parcelRegister("aSMrn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ec485cffb079177$export$2e2bcd8739ae039; });

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $7ec485cffb079177$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z"
}), "Refresh");

});

parcelRegister("239np", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6edb9f78b1436a7$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $5PJ2i = parcelRequire("5PJ2i");

var $chLJv = parcelRequire("chLJv");

var $bSbwb = parcelRequire("bSbwb");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $dqRXb = parcelRequire("dqRXb");

var $6L9uu = parcelRequire("6L9uu");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $bilGR = parcelRequire("bilGR");

var $ehzwo = parcelRequire("ehzwo");

var $gFVvY = parcelRequire("gFVvY");

var $e4eIN = parcelRequire("e4eIN");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");

var $cxTnx = parcelRequire("cxTnx");

var $e2ibc = parcelRequire("e2ibc");
const $c6edb9f78b1436a7$var$defaultErrorsObj = {
    startDate: null,
    endDate: null,
    operator: null,
    field: null,
    factor: null,
    endDateAfterStart: null
};
const $c6edb9f78b1436a7$var$ErrorTexts = {
    startDate: "Start date required!",
    endDate: "End date required!",
    operator: "Operator is required",
    field: "Please select data to recalculate",
    factor: "Factor field is required",
    endDateAfterStart: "End date should be after start date"
};
const $c6edb9f78b1436a7$var$RecalcForm = ({ stockId: stockId, handleClose: handleClose, historyRecalcInput: historyRecalcInput })=>{
    const [startDate, setStartDate] = (0, $bh6RR.useState)(historyRecalcInput ? (0, $gFVvY.parseDate)(historyRecalcInput.start_date) : null);
    const [endDate, setEndDate] = (0, $bh6RR.useState)(historyRecalcInput ? (0, $gFVvY.parseDate)(historyRecalcInput.end_date) : null);
    const [field, setField] = (0, $bh6RR.useState)(historyRecalcInput?.column_to_recalc || null);
    const [factor, setFactor] = (0, $bh6RR.useState)(historyRecalcInput?.value_to_calc_with || null);
    const [operator, setOperator] = (0, $bh6RR.useState)(historyRecalcInput?.operator || null);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($c6edb9f78b1436a7$var$defaultErrorsObj);
    const [updateRecalc, updateRecalcResult] = (0, $hjfla.useUpdateHistoryRecalcMutation)();
    const [editable, setEditable] = (0, $bh6RR.useState)(historyRecalcInput === null);
    const [createdRecalc, createdRecalcResult] = (0, $hjfla.useCreateHistoryRecalcMutation)();
    const recalcOperators = (0, $hjfla.useGetRecalcOperatorsQuery)();
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).Stock);
    const handleCancel = ()=>{
        if (editable && historyRecalcInput !== null) {
            setStartDate((0, $gFVvY.parseDate)(historyRecalcInput.start_date));
            setEndDate((0, $gFVvY.parseDate)(historyRecalcInput.end_date));
            setFactor(historyRecalcInput?.value_to_calc_with || null);
            setField(historyRecalcInput?.column_to_recalc || null);
            setOperator(historyRecalcInput?.operator || null);
            setFormErrors($c6edb9f78b1436a7$var$defaultErrorsObj);
            setEditable(false);
        } else handleClose(false);
    };
    const handleStartDateChange = (dateInput)=>{
        let errors = formErrors;
        errors = {
            ...errors,
            startDate: null
        };
        if (dateInput) {
            if (endDate) {
                if (endDate < dateInput) errors = {
                    ...errors,
                    endDate: $c6edb9f78b1436a7$var$ErrorTexts.endDateAfterStart
                };
                else errors = {
                    ...errors,
                    endDate: null
                };
            }
        } else errors = {
            ...errors,
            startDate: $c6edb9f78b1436a7$var$ErrorTexts.startDate
        };
        setFormErrors(errors);
        setStartDate(dateInput);
    };
    const handleEndDateChange = (dateInput)=>{
        let errors = formErrors;
        errors = {
            ...errors,
            endDate: null
        };
        if (dateInput) {
            if (startDate) {
                if (dateInput.getTime() < startDate.getTime()) errors = {
                    ...errors,
                    endDate: $c6edb9f78b1436a7$var$ErrorTexts.endDateAfterStart
                };
            }
        } else errors = {
            ...errors,
            endDate: $c6edb9f78b1436a7$var$ErrorTexts.endDate
        };
        setFormErrors(errors);
        setEndDate(dateInput);
    };
    const handleFieldChange = (_, newValue)=>{
        setFormErrors({
            ...formErrors,
            field: newValue === null ? $c6edb9f78b1436a7$var$ErrorTexts.field : null
        });
        setField(newValue);
    };
    const handleOperatorChange = (_, newValue)=>{
        setFormErrors({
            ...formErrors,
            operator: newValue === null ? $c6edb9f78b1436a7$var$ErrorTexts.operator : null
        });
        setOperator(newValue);
    };
    const handleFactorChange = (e)=>{
        const value = e.currentTarget.value === "" ? null : Number(e.currentTarget.value);
        setFormErrors({
            ...formErrors,
            factor: value ? null : $c6edb9f78b1436a7$var$ErrorTexts.factor
        });
        setFactor(value);
    };
    const handleSubmit = ()=>{
        let hasErrors = false;
        const errors = {
            endDate: null,
            endDateAfterStart: null,
            factor: null,
            field: null,
            operator: null,
            startDate: null
        };
        if (!endDate) {
            hasErrors = true;
            errors.endDate = $c6edb9f78b1436a7$var$ErrorTexts.endDate;
        }
        if (!startDate) {
            hasErrors = true;
            errors.startDate = $c6edb9f78b1436a7$var$ErrorTexts.startDate;
        }
        if (startDate && endDate) {
            if (startDate > endDate) {
                hasErrors = true;
                errors.startDate = $c6edb9f78b1436a7$var$ErrorTexts.endDateAfterStart;
                errors.endDate = $c6edb9f78b1436a7$var$ErrorTexts.endDateAfterStart;
            }
        }
        if (!factor) {
            hasErrors = true;
            errors.factor = $c6edb9f78b1436a7$var$ErrorTexts.factor;
        }
        if (!field) {
            hasErrors = true;
            errors.field = $c6edb9f78b1436a7$var$ErrorTexts.field;
        }
        if (!operator) {
            hasErrors = true;
            errors.operator = $c6edb9f78b1436a7$var$ErrorTexts.operator;
        }
        if (hasErrors) setFormErrors(errors);
        else handleSave(historyRecalcInput === null ? "create" : "update");
    };
    const handleSave = (type)=>{
        if (type === "create") createdRecalc({
            variables: {
                stock_id: stockId,
                input: {
                    column_to_recalc: field,
                    operator_id: Number(operator?.id),
                    end_date: (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(endDate).utc(true).format((0, $e2ibc.DATE_TIME_FORMATS).DATE_DASHED),
                    start_date: (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(startDate).utc(true).format((0, $e2ibc.DATE_TIME_FORMATS).DATE_DASHED),
                    value_to_calc_with: Number(factor)
                }
            },
            update (_, { data: data }) {
                handleClose(true, true, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Recalc created"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
        else updateRecalc({
            variables: {
                id: historyRecalcInput?.id,
                stock_id: stockId,
                input: {
                    column_to_recalc: field,
                    end_date: (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(endDate).utc(true).format((0, $e2ibc.DATE_TIME_FORMATS).DATE_DASHED),
                    start_date: (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(startDate).utc(true).format((0, $e2ibc.DATE_TIME_FORMATS).DATE_DASHED),
                    operator_id: Number(operator?.id),
                    value_to_calc_with: Number(factor)
                }
            },
            update (_, { data: data }) {
                handleClose(true, false, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Recalc Updated"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "history-recalc-dialog",
        width: 410,
        title: historyRecalcInput ? "Recalc Details" : "Create Recalc",
        onClose: handleClose,
        childrenSx: {
            px: "40px",
            py: "20px"
        },
        children: [
            historyRecalcInput && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    textAlign: "right",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bSbwb.default), {
                    id: "allocation-country-form-edit-button",
                    onClick: ()=>setEditable(true),
                    disabled: editable || !canEdit,
                    editButtonColor: editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    mt: "20px",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    gap: "24px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $e4eIN.LocalizationProvider), {
                        dateAdapter: (0, $1Dn8S.AdapterDateFns),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                id: "history-recalc-start-date-picker",
                                label: "Start Date",
                                value: startDate,
                                ...endDate && {
                                    maxDate: endDate
                                },
                                disabled: createdRecalcResult.loading || updateRecalcResult.loading || !editable,
                                onChange: (d)=>handleStartDateChange(d),
                                errorMsg: formErrors.startDate
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                id: "history-recalc-end-date-picker",
                                label: "End Date",
                                value: endDate,
                                ...startDate && {
                                    minDate: startDate
                                },
                                disabled: createdRecalcResult.loading || updateRecalcResult.loading || !editable,
                                onChange: (d)=>handleEndDateChange(d),
                                errorMsg: formErrors.endDate
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                        id: "recalc-field-autocomplete",
                        "data-testid": "recalc-field-autocomplete",
                        options: [
                            "div_value",
                            "nav_epra",
                            "close_price",
                            "epra_shares"
                        ],
                        label: "Field",
                        values: field,
                        onChange: handleFieldChange,
                        disabled: createdRecalcResult.loading || updateRecalcResult.loading || !editable || historyRecalcInput !== null,
                        errorMsg: formErrors.field,
                        additionalStyle: {
                            gridColumn: "span 2"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                        id: "recalc-operator-autocomplete",
                        "data-testid": "recalc-operator-autocomplete",
                        options: recalcOperators.data?.result || [],
                        getOptionLabel: (option)=>option?.value,
                        label: "Operator",
                        values: operator,
                        onChange: handleOperatorChange,
                        disabled: createdRecalcResult.loading || updateRecalcResult.loading || !editable,
                        errorMsg: formErrors.operator
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "recalc-form-factor-value",
                        "data-testid": "recalc-form-factor-value",
                        label: "Factor",
                        value: factor || "",
                        onChange: (e)=>handleFactorChange(e),
                        type: "number",
                        disabled: createdRecalcResult.loading || updateRecalcResult.loading || !editable,
                        errorMsg: formErrors.factor
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    gridColumn: "span 3",
                    marginTop: "50px",
                    paddingBottom: "45px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-history-recalc-button",
                        onClick: handleCancel,
                        disabled: createdRecalcResult.loading || updateRecalcResult.loading,
                        text: historyRecalcInput === null || editable ? "Cancel" : "Close"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "save-allocation-country-button",
                        onClick: handleSubmit,
                        disabled: createdRecalcResult.loading || updateRecalcResult.loading || !editable,
                        text: historyRecalcInput === null ? "Create" : "Save"
                    })
                ]
            })
        ]
    });
};
var $c6edb9f78b1436a7$export$2e2bcd8739ae039 = $c6edb9f78b1436a7$var$RecalcForm;

});




parcelRegister("7btlA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce527b4c07afd265$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1Dn8S = parcelRequire("1Dn8S");

var $e4eIN = parcelRequire("e4eIN");

var $91340 = parcelRequire("91340");

var $chLJv = parcelRequire("chLJv");

var $1ZlXU = parcelRequire("1ZlXU");

var $cxTnx = parcelRequire("cxTnx");

var $hjfla = parcelRequire("hjfla");

var $d7fM7 = parcelRequire("d7fM7");

var $gSGmk = parcelRequire("gSGmk");

var $e2ibc = parcelRequire("e2ibc");

var $aHnVy = parcelRequire("aHnVy");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $6L9uu = parcelRequire("6L9uu");
const $ce527b4c07afd265$export$1067ba46601ca091 = {
    cacheDate: "Date is required"
};
const $ce527b4c07afd265$var$defaultErrorsObj = {
    cacheDate: null
};
const $ce527b4c07afd265$var$minAllowedDate = new Date(2000, 0, 1);
const $ce527b4c07afd265$var$GenerateCache = ()=>{
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [cacheDate, setCacheDate] = (0, $bh6RR.useState)(null);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($ce527b4c07afd265$var$defaultErrorsObj);
    const { data: data, loading: loading, startPolling: startPolling } = (0, $hjfla.useMsbReportsQuery)();
    const [reports, setReports] = (0, $bh6RR.useState)(data?.result || []);
    const [scheduleReport] = (0, $hjfla.useScheduleReportMutation)();
    (0, $bh6RR.useEffect)(()=>{
        startPolling(10000);
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (data?.result) setReports(data.result);
    }, [
        data?.result
    ]);
    const handleCacheDateChange = (value)=>{
        if (!value) setFormErrors({
            ...formErrors,
            cacheDate: $ce527b4c07afd265$export$1067ba46601ca091.cacheDate
        });
        else {
            setFormErrors({
                ...formErrors,
                cacheDate: null
            });
            setCacheDate(value);
        }
    };
    const submitForm = ()=>{
        const errors = {
            cacheDate: null
        };
        let hasErrors = false;
        if (!cacheDate) {
            hasErrors = true;
            errors.cacheDate = $ce527b4c07afd265$export$1067ba46601ca091.cacheDate;
        }
        if (hasErrors) setFormErrors({
            ...errors
        });
        else {
            const date = (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(cacheDate).utc(true).format("YYYY-MM-DD");
            const isLast = isLastWorkingDay();
            if (isLast) {
                if (canSchedule()) {
                    setCacheDate(null);
                    const input = {
                        report_date: date
                    };
                    scheduleReport({
                        variables: {
                            input: input
                        },
                        refetchQueries: [
                            {
                                query: (0, $hjfla.MsbReportsDocument),
                                variables: {}
                            }
                        ]
                    });
                    dispatch({
                        type: (0, $ayVxz.Actions).ShowMessage,
                        payload: {
                            severity: "success",
                            text: `Report for ${date} has been scheduled`
                        }
                    });
                } else dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "info",
                        text: `Report for ${date} is being generated`
                    }
                });
            } else dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "warning",
                    text: "You should select last working day of a past month"
                }
            });
        }
    };
    const canSchedule = ()=>{
        let result = true;
        const date = (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(cacheDate).utc(true).format("YYYY-MM-DD");
        const report = reports.find((r)=>r?.report_date === date && r.generation_end === null);
        if (report) result = false;
        return result;
    };
    const isLastWorkingDay = ()=>{
        const clonedDate = (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(cacheDate);
        const now = (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))();
        if (clonedDate.isAfter(now)) return false;
        const lastDayOfMonth = clonedDate.endOf("month");
        while((lastDayOfMonth.isoWeekday() >= 1 && lastDayOfMonth.isoWeekday() <= 5) === false)lastDayOfMonth.subtract(1, "day");
        const date = (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(cacheDate);
        const isSame = lastDayOfMonth.isSame(date, "day");
        return isSame;
    };
    const renderGenerationEnd = (rowData)=>rowData.generation_end ? (0, $gSGmk.formatDate)(rowData.generation_end, (0, $e2ibc.DATE_TIME_FORMATS).DATE_AND_TIME) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
            sx: {
                display: "flex",
                justifyContent: "center"
            },
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aHnVy.default), {
                color: (0, $6L9uu.Colors).gradient
            })
        });
    const columns = [
        {
            title: "Report Date",
            field: "report_date",
            type: "date",
            render: (rowData)=>(0, $gSGmk.formatDate)(rowData.report_date)
        },
        {
            title: "Generation Start",
            field: "generation_start",
            type: "date",
            render: (rowData)=>(0, $gSGmk.formatDate)(rowData.generation_start, (0, $e2ibc.DATE_TIME_FORMATS).DATE_AND_TIME)
        },
        {
            title: "Generation End",
            field: "generation_end",
            type: "date",
            render: renderGenerationEnd
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        className: "overviewPage",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            className: "print\\:w-full",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    sx: {
                        p: "30px 0px 0px 30px",
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                            dateAdapter: (0, $1Dn8S.AdapterDateFns),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                id: "generate-cache-date",
                                label: "Cache Date",
                                value: cacheDate,
                                onChange: handleCacheDateChange,
                                errorMsg: formErrors.cacheDate,
                                minDate: $ce527b4c07afd265$var$minAllowedDate
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                            id: "run-cache-button",
                            onClick: submitForm,
                            text: "Run Report"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                    columns: columns,
                    data: reports,
                    loading: loading,
                    hideSearch: true
                })
            ]
        })
    });
};
var $ce527b4c07afd265$export$2e2bcd8739ae039 = $ce527b4c07afd265$var$GenerateCache;

});
parcelRegister("aHnVy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ca07b0316e8108a$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $gnl98 = parcelRequire("gnl98");

var $Tem6I = parcelRequire("Tem6I");
var $7ca07b0316e8108a$var$__assign = undefined && undefined.__assign || function() {
    $7ca07b0316e8108a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7ca07b0316e8108a$var$__assign.apply(this, arguments);
};
var $7ca07b0316e8108a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
// 1.5 4.5 7.5
var $7ca07b0316e8108a$var$distance = [
    1,
    3,
    5
];
var $7ca07b0316e8108a$var$propagate = [
    (0, $Tem6I.createAnimation)("PropagateLoader", "25% {transform: translateX(-".concat($7ca07b0316e8108a$var$distance[0], "rem) scale(0.75)}\n    50% {transform: translateX(-").concat($7ca07b0316e8108a$var$distance[1], "rem) scale(0.6)}\n    75% {transform: translateX(-").concat($7ca07b0316e8108a$var$distance[2], "rem) scale(0.5)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-0"),
    (0, $Tem6I.createAnimation)("PropagateLoader", "25% {transform: translateX(-".concat($7ca07b0316e8108a$var$distance[0], "rem) scale(0.75)}\n    50% {transform: translateX(-").concat($7ca07b0316e8108a$var$distance[1], "rem) scale(0.6)}\n    75% {transform: translateX(-").concat($7ca07b0316e8108a$var$distance[1], "rem) scale(0.6)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-1"),
    (0, $Tem6I.createAnimation)("PropagateLoader", "25% {transform: translateX(-".concat($7ca07b0316e8108a$var$distance[0], "rem) scale(0.75)}\n    75% {transform: translateX(-").concat($7ca07b0316e8108a$var$distance[0], "rem) scale(0.75)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-2"),
    (0, $Tem6I.createAnimation)("PropagateLoader", "25% {transform: translateX(".concat($7ca07b0316e8108a$var$distance[0], "rem) scale(0.75)}\n    75% {transform: translateX(").concat($7ca07b0316e8108a$var$distance[0], "rem) scale(0.75)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-3"),
    (0, $Tem6I.createAnimation)("PropagateLoader", "25% {transform: translateX(".concat($7ca07b0316e8108a$var$distance[0], "rem) scale(0.75)}\n    50% {transform: translateX(").concat($7ca07b0316e8108a$var$distance[1], "rem) scale(0.6)}\n    75% {transform: translateX(").concat($7ca07b0316e8108a$var$distance[1], "rem) scale(0.6)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-4"),
    (0, $Tem6I.createAnimation)("PropagateLoader", "25% {transform: translateX(".concat($7ca07b0316e8108a$var$distance[0], "rem) scale(0.75)}\n    50% {transform: translateX(").concat($7ca07b0316e8108a$var$distance[1], "rem) scale(0.6)}\n    75% {transform: translateX(").concat($7ca07b0316e8108a$var$distance[2], "rem) scale(0.5)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-5")
];
function $7ca07b0316e8108a$var$PropagateLoader(_a) {
    var _b = _a.loading, loading = _b === void 0 ? true : _b, _c = _a.color, color = _c === void 0 ? "#000000" : _c, _d = _a.speedMultiplier, speedMultiplier = _d === void 0 ? 1 : _d, _e = _a.cssOverride, cssOverride = _e === void 0 ? {} : _e, _f = _a.size, size = _f === void 0 ? 15 : _f, additionalprops = $7ca07b0316e8108a$var$__rest(_a, [
        "loading",
        "color",
        "speedMultiplier",
        "cssOverride",
        "size"
    ]);
    var _g = (0, $gnl98.parseLengthAndUnit)(size), value = _g.value, unit = _g.unit;
    var wrapper = $7ca07b0316e8108a$var$__assign({
        display: "inherit",
        position: "relative"
    }, cssOverride);
    var style = function(i) {
        return {
            position: "absolute",
            fontSize: "".concat(value / 3).concat(unit),
            width: "".concat(value).concat(unit),
            height: "".concat(value).concat(unit),
            background: color,
            borderRadius: "50%",
            animation: "".concat($7ca07b0316e8108a$var$propagate[i], " ").concat(1.5 / speedMultiplier, "s infinite"),
            animationFillMode: "forwards"
        };
    };
    if (!loading) return null;
    return $bh6RR.createElement("span", $7ca07b0316e8108a$var$__assign({
        style: wrapper
    }, additionalprops), $bh6RR.createElement("span", {
        style: style(0)
    }), $bh6RR.createElement("span", {
        style: style(1)
    }), $bh6RR.createElement("span", {
        style: style(2)
    }), $bh6RR.createElement("span", {
        style: style(3)
    }), $bh6RR.createElement("span", {
        style: style(4)
    }), $bh6RR.createElement("span", {
        style: style(5)
    }));
}
var $7ca07b0316e8108a$export$2e2bcd8739ae039 = $7ca07b0316e8108a$var$PropagateLoader;

});
parcelRegister("gnl98", function(module, exports) {

$parcel$export(module.exports, "parseLengthAndUnit", function () { return $bebf328e7bf24afa$export$78b59f8245744464; });
var $bebf328e7bf24afa$var$cssUnit = {
    cm: true,
    mm: true,
    in: true,
    px: true,
    pt: true,
    pc: true,
    em: true,
    ex: true,
    ch: true,
    rem: true,
    vw: true,
    vh: true,
    vmin: true,
    vmax: true,
    "%": true
};
function $bebf328e7bf24afa$export$78b59f8245744464(size) {
    if (typeof size === "number") return {
        value: size,
        unit: "px"
    };
    var value;
    var valueString = (size.match(/^[0-9.]*/) || "").toString();
    if (valueString.includes(".")) value = parseFloat(valueString);
    else value = parseInt(valueString, 10);
    var unit = (size.match(/[^0-9]*$/) || "").toString();
    if ($bebf328e7bf24afa$var$cssUnit[unit]) return {
        value: value,
        unit: unit
    };
    console.warn("React Spinners: ".concat(size, " is not a valid css value. Defaulting to ").concat(value, "px."));
    return {
        value: value,
        unit: "px"
    };
}
function $bebf328e7bf24afa$export$55101aa37e5c1f8f(value) {
    var lengthWithunit = $bebf328e7bf24afa$export$78b59f8245744464(value);
    return "".concat(lengthWithunit.value).concat(lengthWithunit.unit);
}

});

parcelRegister("Tem6I", function(module, exports) {

$parcel$export(module.exports, "createAnimation", function () { return $0a6045e2d4227643$export$86bdb2b9e42f41bc; });
var $0a6045e2d4227643$export$86bdb2b9e42f41bc = function(loaderName, frames, suffix) {
    var animationName = "react-spinners-".concat(loaderName, "-").concat(suffix);
    if (typeof window == "undefined" || !window.document) return animationName;
    var styleEl = document.createElement("style");
    document.head.appendChild(styleEl);
    var styleSheet = styleEl.sheet;
    var keyFrames = "\n    @keyframes ".concat(animationName, " {\n      ").concat(frames, "\n    }\n  ");
    if (styleSheet) styleSheet.insertRule(keyFrames, 0);
    return animationName;
};

});



parcelRegister("fL4Kw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5d60a9c697bd4be$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");

var $bh6RR = parcelRequire("bh6RR");

var $j5ie7 = parcelRequire("j5ie7");

var $jmND0 = parcelRequire("jmND0");

var $iCV47 = parcelRequire("iCV47");

var $iKNNz = parcelRequire("iKNNz");

var $8JH44 = parcelRequire("8JH44");

var $eBMvL = parcelRequire("eBMvL");
const $b5d60a9c697bd4be$var$FtseInfoWrapper = ()=>{
    const [value, setValue] = (0, $bh6RR.useState)(0);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eBMvL.default), {
                value: value,
                handleChange: (_, newValue)=>setValue(newValue),
                type: "first",
                tabProps: [
                    {
                        id: "ftse",
                        title: "FTSE",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iKNNz)))
                    },
                    {
                        id: "ftse-fx",
                        title: "FTSE FX",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8JH44)))
                    }
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                        value: value,
                        index: 0,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $jmND0.default), {})
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                        value: value,
                        index: 1,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $iCV47.default), {})
                    })
                ]
            })
        ]
    });
};
var $b5d60a9c697bd4be$export$2e2bcd8739ae039 = $b5d60a9c697bd4be$var$FtseInfoWrapper;

});
parcelRegister("jmND0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $071d871a538549d7$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $2eJeT = parcelRequire("2eJeT");

var $hjfla = parcelRequire("hjfla");

var $e2ibc = parcelRequire("e2ibc");

var $d7fM7 = parcelRequire("d7fM7");

var $ayVxz = parcelRequire("ayVxz");

var $bu31C = parcelRequire("bu31C");

var $fE3vS = parcelRequire("fE3vS");

var $8d818 = parcelRequire("8d818");

var $9DjmB = parcelRequire("9DjmB");

var $jcp9V = parcelRequire("jcp9V");

var $chLJv = parcelRequire("chLJv");
const $071d871a538549d7$var$FtseList = ()=>{
    const { data: data, loading: loading } = (0, $hjfla.useGetFtseFilesQuery)();
    const [allData, setAllData] = (0, $bh6RR.useState)([]);
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [deleteFtseFile] = (0, $hjfla.useDeleteFtseFileMutation)();
    const [openCreateFtseForm, setOpenCreateFtseForm] = (0, $bh6RR.useState)(false);
    const [ftseFile, setFtseFile] = (0, $bh6RR.useState)(null);
    const [downloading, setDownloading] = (0, $bh6RR.useState)(false);
    const [openUpload, setOpenUpload] = (0, $bh6RR.useState)(false);
    const [openDownloadForm, setOpenDownloadForm] = (0, $bh6RR.useState)(false);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setAllData(data.result);
    }, [
        data
    ]);
    const formatDate = (rowData, name)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return rowData[name] ? // @ts-ignore
        (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(parseInt(rowData[name])).format((0, $e2ibc.DATE_TIME_FORMATS).DATE_AND_TIME) : "";
    };
    const remove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${rowData.name}?`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleDelete = (rowData)=>{
        if (!rowData.id) return;
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteFtseFile({
            variables: {
                id: rowData.id
            },
            update (cache) {
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        text: `Ftse File deleted ${rowData.name}`,
                        severity: "success"
                    }
                });
                const ftseFilesQuery = cache.readQuery({
                    query: (0, $hjfla.GetFtseFilesDocument)
                });
                if (ftseFilesQuery.result) {
                    const cacheFtseFileIndex = ftseFilesQuery.result.findIndex((c)=>c?.id === rowData.id);
                    if (cacheFtseFileIndex > -1) {
                        const data = ftseFilesQuery.result.filter(function(el) {
                            return el?.id !== rowData.id;
                        });
                        cache.writeQuery({
                            query: (0, $hjfla.GetFtseFilesDocument),
                            data: {
                                result: data
                            }
                        });
                    }
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: e.message,
                    severity: "error",
                    autoHide: 6000
                }
            });
        });
    };
    const handleClose = (saved, isNew, ftseFileInput)=>{
        if (saved && isNew) addFtseFile(ftseFileInput);
        setFtseFile(null);
        setOpenCreateFtseForm(false);
    };
    const addFtseFile = (input)=>{
        const existing = allData.find((ftse)=>ftse.id === input.id);
        if (!existing) setAllData([
            input,
            ...allData
        ]);
    };
    const handleDetails = (rowData)=>{
        setFtseFile(rowData);
        setOpenCreateFtseForm(true);
    };
    const handleDownload = ()=>{
        setOpenDownloadForm(true);
    };
    const columns = [
        {
            title: "Details",
            width: 60,
            sorting: false
        },
        {
            title: "File Name",
            field: "name",
            width: 106
        },
        {
            title: "File Type",
            field: "type.name",
            width: 136
        },
        {
            title: "Location on Server",
            field: "file_location",
            width: 500
        },
        {
            title: "Last Imported",
            field: "last_import",
            width: 185,
            type: "date",
            render: (rowData)=>formatDate(rowData, "last_import")
        },
        {
            title: "Last Successful Get",
            field: "last_get",
            width: 185,
            type: "date",
            render: (rowData)=>formatDate(rowData, "last_get")
        },
        {
            title: "Attempts",
            field: "attempt",
            width: 90
        },
        {
            title: "Remove",
            width: 71,
            sorting: false
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        className: "overviewPage",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "print\\:w-full",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                        columns: columns,
                        data: allData,
                        loading: loading,
                        handleDetails: handleDetails,
                        handleRemove: remove,
                        pageSize: 15,
                        rowsPerPageOptions: [
                            15,
                            25,
                            50,
                            100
                        ],
                        createButtonProps: {
                            id: "create-ftse-button",
                            onClick: ()=>setOpenCreateFtseForm(true),
                            text: "Create FTSE",
                            disabled: false
                        },
                        importButtonProps: {
                            id: "import-ftse-button",
                            onClick: ()=>setOpenUpload(true)
                        },
                        downloadButtonProps: {
                            id: "download-ftse-button",
                            // disabled: false,
                            onClick: ()=>handleDownload()
                        }
                    }),
                    openCreateFtseForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $fE3vS.default), {
                        handleClose: handleClose,
                        ftseFileInput: ftseFile
                    }),
                    openUpload && /*#__PURE__*/ (0, $ih19M.jsx)((0, $9DjmB.default), {
                        handleClose: ()=>setOpenUpload(false)
                    }),
                    openDownloadForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $jcp9V.default), {
                        handleClose: ()=>setOpenDownloadForm(false),
                        isLoading: (isLoading)=>setDownloading(isLoading)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
                loading: downloading
            })
        ]
    });
};
var $071d871a538549d7$export$2e2bcd8739ae039 = $071d871a538549d7$var$FtseList;

});
parcelRegister("fE3vS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80e4f999b40a8d6d$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $gDp1O = parcelRequire("gDp1O");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $hjfla = parcelRequire("hjfla");

var $gFVvY = parcelRequire("gFVvY");

var $ayVxz = parcelRequire("ayVxz");

var $9WP8Q = parcelRequire("9WP8Q");

var $bilGR = parcelRequire("bilGR");

var $6L9uu = parcelRequire("6L9uu");

var $5PJ2i = parcelRequire("5PJ2i");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $ehzwo = parcelRequire("ehzwo");
const $80e4f999b40a8d6d$var$defaultErrorsObj = {
    name: null,
    location_on_server: null,
    file_type: null
};
const $80e4f999b40a8d6d$var$errorTexts = {
    name: "Name is required",
    location_on_server: "Server path is required",
    file_type: "File type is required",
    existingName: "File with that name already exists"
};
const $80e4f999b40a8d6d$var$ftseFileForm = ({ handleClose: handleClose, ftseFileInput: ftseFileInput })=>{
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($80e4f999b40a8d6d$var$defaultErrorsObj);
    const [editable, setEditable] = (0, $bh6RR.useState)(ftseFileInput === null);
    const [name, setName] = (0, $bh6RR.useState)(ftseFileInput?.name || null);
    const [locationOnServer, setLocationOnServer] = (0, $bh6RR.useState)(ftseFileInput?.file_location || null);
    const [fileType, setFileType] = (0, $bh6RR.useState)(ftseFileInput?.type || null);
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const fileTypeOptions = (0, $hjfla.useGetFtseTypesQuery)();
    const [createFtseFile, createFtseFileResult] = (0, $hjfla.useCreateFtseFileMutation)();
    const [updateFtseFile, updateFtseFileResult] = (0, $hjfla.useUpdateFtseMutation)();
    const handleCancel = ()=>{
        if (editable && ftseFileInput !== null) {
            setName(ftseFileInput?.name);
            setLocationOnServer(ftseFileInput?.file_location);
            setFileType(ftseFileInput?.type || null);
            setFormErrors($80e4f999b40a8d6d$var$defaultErrorsObj);
            setEditable(false);
        } else handleClose(false);
    };
    const handleSubmit = ()=>{
        let hasErrors = false;
        const errors = {
            file_type: null,
            location_on_server: null,
            name: null
        };
        if (!name) {
            hasErrors = true;
            errors.name = $80e4f999b40a8d6d$var$errorTexts.name;
        }
        if (!fileType) {
            hasErrors = true;
            errors.file_type = $80e4f999b40a8d6d$var$errorTexts.file_type;
        }
        if (!locationOnServer) {
            hasErrors = true;
            errors.location_on_server = $80e4f999b40a8d6d$var$errorTexts.location_on_server;
        }
        if (hasErrors) setFormErrors(errors);
        else {
            const nameExists = (0, $gFVvY.sameFtseFileNameExists)(name, ftseFileInput?.id);
            if (nameExists) setFormErrors({
                ...formErrors,
                name: nameExists ? $80e4f999b40a8d6d$var$errorTexts.existingName : null
            });
            else handleSave(ftseFileInput === null ? "create" : "update");
        }
    };
    const handleSave = (type)=>{
        if (type === "create") createFtseFile({
            variables: {
                input: {
                    name: name,
                    file_type_id: Number(fileType?.id),
                    location_on_server: locationOnServer
                }
            },
            update (_, { data: data }) {
                handleClose(true, true, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Ftse file created"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
        else updateFtseFile({
            variables: {
                id: ftseFileInput?.id,
                input: {
                    name: name,
                    file_type_id: Number(fileType?.id),
                    location_on_server: locationOnServer
                }
            },
            update (_, { data: data }) {
                handleClose(true, false, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Ftse file updated"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
    };
    const handleFtseFileNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value) setFormErrors({
            ...formErrors,
            name: null
        });
        else setFormErrors({
            ...formErrors,
            name: $80e4f999b40a8d6d$var$errorTexts.name
        });
        setName(value);
    };
    const handleFileTypeChange = (_, newValue)=>{
        setFormErrors({
            ...formErrors,
            file_type: newValue === null ? $80e4f999b40a8d6d$var$errorTexts.file_type : null
        });
        setFileType(newValue);
    };
    const handleFtseFileLocationChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value) setFormErrors({
            ...formErrors,
            location_on_server: null
        });
        else setFormErrors({
            ...formErrors,
            location_on_server: $80e4f999b40a8d6d$var$errorTexts.location_on_server
        });
        setLocationOnServer(value);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "ftse-form-dialog-title",
        width: 689,
        title: ftseFileInput ? `${ftseFileInput.name} Details` : "Create FTSE file",
        children: [
            ftseFileInput && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    textAlign: "right",
                    marginRight: "15px",
                    marginTop: "10px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                    id: "ftse-form-edit-button",
                    "data-testid": "ftse-form-edit-button",
                    component: (0, $gDp1O.default),
                    onClick: ()=>setEditable(true),
                    disabled: editable,
                    sx: {
                        ...(0, $6L9uu.buttons).edit,
                        fontWeight: "bold"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $9WP8Q.default), {
                            sx: {
                                fontSize: "medium",
                                color: editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue,
                                marginRight: "3"
                            }
                        }),
                        "EDIT"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    m: "30px",
                    mt: "60px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "50px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "ftse-form-name",
                        label: "Title/Name of file",
                        value: name || "",
                        onChange: handleFtseFileNameChange,
                        errorMsg: formErrors.name,
                        disabled: !editable || createFtseFileResult.loading || updateFtseFileResult.loading
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "ftse-form-file-location",
                        label: "Location on server",
                        value: locationOnServer || "",
                        onChange: handleFtseFileLocationChange,
                        errorMsg: formErrors.location_on_server,
                        disabled: !editable || createFtseFileResult.loading || updateFtseFileResult.loading
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bilGR.default), {
                        id: "ftse-type-autocomplete",
                        label: "File Type",
                        options: fileTypeOptions.data?.result || [],
                        disabled: createFtseFileResult.loading || updateFtseFileResult.loading || !editable,
                        values: fileType,
                        onChange: handleFileTypeChange,
                        getOptionLabel: (option)=>option.name,
                        errorMsg: formErrors.file_type
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        className: "centralize",
                        sx: {
                            marginTop: "20px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                                id: "cancel-ftse-file-button",
                                "data-testid": "cancel-ftse-file-button",
                                disabled: createFtseFileResult.loading || updateFtseFileResult.loading,
                                onClick: handleCancel,
                                text: ftseFileInput === null || editable ? "Cancel" : "Close"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                                id: "save-ftse-file-button",
                                "data-testid": "save-ftse-file-button",
                                disabled: !editable || createFtseFileResult.loading || updateFtseFileResult.loading,
                                onClick: handleSubmit,
                                text: ftseFileInput === null ? "Create" : "Save"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $80e4f999b40a8d6d$export$2e2bcd8739ae039 = $80e4f999b40a8d6d$var$ftseFileForm;

});

parcelRegister("9DjmB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ae10ecdd5f5d859$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
parcelRequire("2shzp");
var $bRlFp = parcelRequire("bRlFp");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $6L9uu = parcelRequire("6L9uu");

var $b85VG = parcelRequire("b85VG");

var $5PJ2i = parcelRequire("5PJ2i");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $ehzwo = parcelRequire("ehzwo");

var $aM783 = parcelRequire("aM783");
function $3ae10ecdd5f5d859$export$2e2bcd8739ae039({ handleClose: handleClose }) {
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [files, setFiles] = (0, $bh6RR.useState)(null);
    const [fileNames, setFileNames] = (0, $bh6RR.useState)("");
    const [date, setDate] = (0, $bh6RR.useState)(null);
    const [dateError, setDateError] = (0, $bh6RR.useState)(null);
    async function getFileDate(file) {
        const reader = new FileReader();
        reader.readAsText(file);
        const result = await new Promise((resolve, reject)=>{
            reader.onload = function(event) {
                resolve(reader.result);
            };
        });
        return result.substring(0, 10);
    }
    const handleChange = async (event)=>{
        if (event && event.target && event.target.files) {
            const uploadFiles = Array.from(event.target.files);
            let fileDateString = "";
            for (const file of uploadFiles){
                const fileDate = await getFileDate(file);
                if (fileDateString && fileDateString.length > 0 && fileDateString !== fileDate) {
                    setDateError("Files should be only for one date");
                    fileDateString = null;
                    break;
                }
                fileDateString = fileDate;
                setDateError(null);
            }
            setDate(fileDateString);
            setFiles(uploadFiles);
            const names = uploadFiles.map((f)=>f.name).join(", ");
            setFileNames(names);
        } else {
            setFileNames("");
            setDate(null);
            setDateError(null);
        }
    };
    const handleImport = ()=>{
        if (files) {
            const formData = new FormData();
            files.forEach((file)=>{
                formData.append(file.name, file);
            });
            (0, $bRlFp.default)({
                method: "POST",
                url: `${"https://crm.epra.com/csvcollect"}/import`,
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `${localStorage.getItem((0, $aM783.AppConsts).AccessToken)}`
                }
            }).catch((e)=>{
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "error",
                        text: e.message
                    }
                });
            });
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "info",
                    text: `${files.length} File(s) import started`
                }
            });
            handleClose();
        }
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5PJ2i.default), {
        id: "ftse-upload-form-dialog",
        width: 380,
        title: "Import FTSE file",
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            sx: {
                display: "flex",
                flexDirection: "column",
                m: "30px",
                gap: "10px"
            },
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                    id: "ftse-upload-file",
                    label: "",
                    value: fileNames,
                    onChange: handleChange,
                    errorMsg: dateError,
                    disabled: true,
                    endAdornment: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            position: "relative",
                            bottom: "3px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                accept: ".csv",
                                id: "ftse-file",
                                type: "file",
                                onChange: handleChange,
                                style: {
                                    display: "none"
                                },
                                multiple: true
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                                htmlFor: "ftse-file",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b85VG.default), {
                                    style: {
                                        cursor: "pointer",
                                        paddingRight: "5%",
                                        paddingTop: "5px",
                                        color: (0, $6L9uu.Colors).main
                                    }
                                })
                            })
                        ]
                    })
                }),
                date && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    sx: {
                        position: "relative",
                        top: "2px",
                        left: "10px",
                        color: (0, $6L9uu.Colors).main
                    },
                    children: [
                        "File(s) date: ",
                        date
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize",
                    sx: {
                        gridColumn: "span 3",
                        marginBottom: "15px",
                        mt: "20px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                            id: "cancel-ftse-upload-button",
                            onClick: handleClose,
                            text: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                            id: "create-new-membership-button",
                            onClick: handleImport,
                            text: "Import"
                        })
                    ]
                })
            ]
        })
    });
}

});
parcelRegister("2shzp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("bRlFp")).default; });

var $bRlFp = parcelRequire("bRlFp");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $1c9bd35df1aeff0f$export$1c00760e9e5a4e95, AxiosError: $1c9bd35df1aeff0f$export$c1fbed17c2f6a328, CanceledError: $1c9bd35df1aeff0f$export$1ab0c6b20d94fa14, isCancel: $1c9bd35df1aeff0f$export$3b22524397b493c6, CancelToken: $1c9bd35df1aeff0f$export$fd08e3cb425f0d61, VERSION: $1c9bd35df1aeff0f$export$a4ad2735b021c132, all: $1c9bd35df1aeff0f$export$84bf76cd7afc7469, Cancel: $1c9bd35df1aeff0f$export$848c9b7ead0df967, isAxiosError: $1c9bd35df1aeff0f$export$fbafdbe06a5b5a9a, spread: $1c9bd35df1aeff0f$export$3ae0fd4797ed47c8, toFormData: $1c9bd35df1aeff0f$export$10ae0d317ea97f8b, AxiosHeaders: $1c9bd35df1aeff0f$export$4e7d6ff0f3e6520, HttpStatusCode: $1c9bd35df1aeff0f$export$a972f69c851492b3, formToJSON: $1c9bd35df1aeff0f$export$86d7c59254d6a2c9, getAdapter: $1c9bd35df1aeff0f$export$17ddc20a97d669e2, mergeConfig: $1c9bd35df1aeff0f$export$7ec1ebcfa9d8bd6a } = (0, $bRlFp.default);

});
parcelRegister("bRlFp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a2573892eafc323$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");

var $djt5d = parcelRequire("djt5d");

var $6zSb1 = parcelRequire("6zSb1");

var $d0EKm = parcelRequire("d0EKm");

var $hqlPG = parcelRequire("hqlPG");

var $4bmvb = parcelRequire("4bmvb");

var $83xK9 = parcelRequire("83xK9");

var $2sjhC = parcelRequire("2sjhC");

var $ksuZT = parcelRequire("ksuZT");

var $50GW0 = parcelRequire("50GW0");

var $aewVa = parcelRequire("aewVa");

var $121rJ = parcelRequire("121rJ");

var $av9gA = parcelRequire("av9gA");

var $gNhGc = parcelRequire("gNhGc");

var $gbTL1 = parcelRequire("gbTL1");

var $enpjQ = parcelRequire("enpjQ");

var $jd7iQ = parcelRequire("jd7iQ");
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $8a2573892eafc323$var$createInstance(defaultConfig) {
    const context = new (0, $6zSb1.default)(defaultConfig);
    const instance = (0, $djt5d.default)((0, $6zSb1.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $2bBga.default).extend(instance, (0, $6zSb1.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $2bBga.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $8a2573892eafc323$var$createInstance((0, $d0EKm.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $8a2573892eafc323$var$axios = $8a2573892eafc323$var$createInstance((0, $hqlPG.default));
// Expose Axios class to allow class inheritance
$8a2573892eafc323$var$axios.Axios = (0, $6zSb1.default);
// Expose Cancel & CancelToken
$8a2573892eafc323$var$axios.CanceledError = (0, $83xK9.default);
$8a2573892eafc323$var$axios.CancelToken = (0, $2sjhC.default);
$8a2573892eafc323$var$axios.isCancel = (0, $ksuZT.default);
$8a2573892eafc323$var$axios.VERSION = (0, $50GW0.VERSION);
$8a2573892eafc323$var$axios.toFormData = (0, $aewVa.default);
// Expose AxiosError class
$8a2573892eafc323$var$axios.AxiosError = (0, $121rJ.default);
// alias for CanceledError for backward compatibility
$8a2573892eafc323$var$axios.Cancel = $8a2573892eafc323$var$axios.CanceledError;
// Expose all/spread
$8a2573892eafc323$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$8a2573892eafc323$var$axios.spread = (0, $av9gA.default);
// Expose isAxiosError
$8a2573892eafc323$var$axios.isAxiosError = (0, $gNhGc.default);
// Expose mergeConfig
$8a2573892eafc323$var$axios.mergeConfig = (0, $d0EKm.default);
$8a2573892eafc323$var$axios.AxiosHeaders = (0, $gbTL1.default);
$8a2573892eafc323$var$axios.formToJSON = (thing)=>(0, $4bmvb.default)((0, $2bBga.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$8a2573892eafc323$var$axios.getAdapter = (0, $enpjQ.default).getAdapter;
$8a2573892eafc323$var$axios.HttpStatusCode = (0, $jd7iQ.default);
$8a2573892eafc323$var$axios.default = $8a2573892eafc323$var$axios;
var // this module should only have a default export
$8a2573892eafc323$export$2e2bcd8739ae039 = $8a2573892eafc323$var$axios;

});
parcelRegister("2bBga", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $197982d8c7a73e5f$export$2e2bcd8739ae039; });

var $djt5d = parcelRequire("djt5d");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $197982d8c7a73e5f$var$toString } = Object.prototype;
const { getPrototypeOf: $197982d8c7a73e5f$var$getPrototypeOf } = Object;
const $197982d8c7a73e5f$var$kindOf = ((cache)=>(thing)=>{
        const str = $197982d8c7a73e5f$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $197982d8c7a73e5f$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$197982d8c7a73e5f$var$kindOf(thing) === type;
};
const $197982d8c7a73e5f$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $197982d8c7a73e5f$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $197982d8c7a73e5f$var$isUndefined = $197982d8c7a73e5f$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $197982d8c7a73e5f$var$isBuffer(val) {
    return val !== null && !$197982d8c7a73e5f$var$isUndefined(val) && val.constructor !== null && !$197982d8c7a73e5f$var$isUndefined(val.constructor) && $197982d8c7a73e5f$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $197982d8c7a73e5f$var$isArrayBuffer = $197982d8c7a73e5f$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $197982d8c7a73e5f$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $197982d8c7a73e5f$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $197982d8c7a73e5f$var$isString = $197982d8c7a73e5f$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $197982d8c7a73e5f$var$isFunction = $197982d8c7a73e5f$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $197982d8c7a73e5f$var$isNumber = $197982d8c7a73e5f$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $197982d8c7a73e5f$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $197982d8c7a73e5f$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $197982d8c7a73e5f$var$isPlainObject = (val)=>{
    if ($197982d8c7a73e5f$var$kindOf(val) !== "object") return false;
    const prototype = $197982d8c7a73e5f$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $197982d8c7a73e5f$var$isDate = $197982d8c7a73e5f$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $197982d8c7a73e5f$var$isFile = $197982d8c7a73e5f$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $197982d8c7a73e5f$var$isBlob = $197982d8c7a73e5f$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $197982d8c7a73e5f$var$isFileList = $197982d8c7a73e5f$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $197982d8c7a73e5f$var$isStream = (val)=>$197982d8c7a73e5f$var$isObject(val) && $197982d8c7a73e5f$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $197982d8c7a73e5f$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $197982d8c7a73e5f$var$isFunction(thing.append) && ((kind = $197982d8c7a73e5f$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $197982d8c7a73e5f$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $197982d8c7a73e5f$var$isURLSearchParams = $197982d8c7a73e5f$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $197982d8c7a73e5f$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $197982d8c7a73e5f$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($197982d8c7a73e5f$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $197982d8c7a73e5f$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $197982d8c7a73e5f$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $197982d8c7a73e5f$var$isContextDefined = (context)=>!$197982d8c7a73e5f$var$isUndefined(context) && context !== $197982d8c7a73e5f$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $197982d8c7a73e5f$var$merge() {
    const { caseless: caseless } = $197982d8c7a73e5f$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $197982d8c7a73e5f$var$findKey(result, key) || key;
        if ($197982d8c7a73e5f$var$isPlainObject(result[targetKey]) && $197982d8c7a73e5f$var$isPlainObject(val)) result[targetKey] = $197982d8c7a73e5f$var$merge(result[targetKey], val);
        else if ($197982d8c7a73e5f$var$isPlainObject(val)) result[targetKey] = $197982d8c7a73e5f$var$merge({}, val);
        else if ($197982d8c7a73e5f$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $197982d8c7a73e5f$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $197982d8c7a73e5f$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $197982d8c7a73e5f$var$forEach(b, (val, key)=>{
        if (thisArg && $197982d8c7a73e5f$var$isFunction(val)) a[key] = (0, $djt5d.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $197982d8c7a73e5f$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $197982d8c7a73e5f$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $197982d8c7a73e5f$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $197982d8c7a73e5f$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $197982d8c7a73e5f$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $197982d8c7a73e5f$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($197982d8c7a73e5f$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$197982d8c7a73e5f$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $197982d8c7a73e5f$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $197982d8c7a73e5f$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $197982d8c7a73e5f$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $197982d8c7a73e5f$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $197982d8c7a73e5f$var$isHTMLForm = $197982d8c7a73e5f$var$kindOfTest("HTMLFormElement");
const $197982d8c7a73e5f$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $197982d8c7a73e5f$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $197982d8c7a73e5f$var$isRegExp = $197982d8c7a73e5f$var$kindOfTest("RegExp");
const $197982d8c7a73e5f$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $197982d8c7a73e5f$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $197982d8c7a73e5f$var$freezeMethods = (obj)=>{
    $197982d8c7a73e5f$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($197982d8c7a73e5f$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$197982d8c7a73e5f$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $197982d8c7a73e5f$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $197982d8c7a73e5f$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $197982d8c7a73e5f$var$noop = ()=>{};
const $197982d8c7a73e5f$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $197982d8c7a73e5f$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $197982d8c7a73e5f$var$DIGIT = "0123456789";
const $197982d8c7a73e5f$var$ALPHABET = {
    DIGIT: $197982d8c7a73e5f$var$DIGIT,
    ALPHA: $197982d8c7a73e5f$var$ALPHA,
    ALPHA_DIGIT: $197982d8c7a73e5f$var$ALPHA + $197982d8c7a73e5f$var$ALPHA.toUpperCase() + $197982d8c7a73e5f$var$DIGIT
};
const $197982d8c7a73e5f$var$generateString = (size = 16, alphabet = $197982d8c7a73e5f$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $197982d8c7a73e5f$var$isSpecCompliantForm(thing) {
    return !!(thing && $197982d8c7a73e5f$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $197982d8c7a73e5f$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($197982d8c7a73e5f$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $197982d8c7a73e5f$var$isArray(source) ? [] : {};
                $197982d8c7a73e5f$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$197982d8c7a73e5f$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $197982d8c7a73e5f$var$isAsyncFn = $197982d8c7a73e5f$var$kindOfTest("AsyncFunction");
const $197982d8c7a73e5f$var$isThenable = (thing)=>thing && ($197982d8c7a73e5f$var$isObject(thing) || $197982d8c7a73e5f$var$isFunction(thing)) && $197982d8c7a73e5f$var$isFunction(thing.then) && $197982d8c7a73e5f$var$isFunction(thing.catch);
var $197982d8c7a73e5f$export$2e2bcd8739ae039 = {
    isArray: $197982d8c7a73e5f$var$isArray,
    isArrayBuffer: $197982d8c7a73e5f$var$isArrayBuffer,
    isBuffer: $197982d8c7a73e5f$var$isBuffer,
    isFormData: $197982d8c7a73e5f$var$isFormData,
    isArrayBufferView: $197982d8c7a73e5f$var$isArrayBufferView,
    isString: $197982d8c7a73e5f$var$isString,
    isNumber: $197982d8c7a73e5f$var$isNumber,
    isBoolean: $197982d8c7a73e5f$var$isBoolean,
    isObject: $197982d8c7a73e5f$var$isObject,
    isPlainObject: $197982d8c7a73e5f$var$isPlainObject,
    isUndefined: $197982d8c7a73e5f$var$isUndefined,
    isDate: $197982d8c7a73e5f$var$isDate,
    isFile: $197982d8c7a73e5f$var$isFile,
    isBlob: $197982d8c7a73e5f$var$isBlob,
    isRegExp: $197982d8c7a73e5f$var$isRegExp,
    isFunction: $197982d8c7a73e5f$var$isFunction,
    isStream: $197982d8c7a73e5f$var$isStream,
    isURLSearchParams: $197982d8c7a73e5f$var$isURLSearchParams,
    isTypedArray: $197982d8c7a73e5f$var$isTypedArray,
    isFileList: $197982d8c7a73e5f$var$isFileList,
    forEach: $197982d8c7a73e5f$var$forEach,
    merge: $197982d8c7a73e5f$var$merge,
    extend: $197982d8c7a73e5f$var$extend,
    trim: $197982d8c7a73e5f$var$trim,
    stripBOM: $197982d8c7a73e5f$var$stripBOM,
    inherits: $197982d8c7a73e5f$var$inherits,
    toFlatObject: $197982d8c7a73e5f$var$toFlatObject,
    kindOf: $197982d8c7a73e5f$var$kindOf,
    kindOfTest: $197982d8c7a73e5f$var$kindOfTest,
    endsWith: $197982d8c7a73e5f$var$endsWith,
    toArray: $197982d8c7a73e5f$var$toArray,
    forEachEntry: $197982d8c7a73e5f$var$forEachEntry,
    matchAll: $197982d8c7a73e5f$var$matchAll,
    isHTMLForm: $197982d8c7a73e5f$var$isHTMLForm,
    hasOwnProperty: $197982d8c7a73e5f$var$hasOwnProperty,
    hasOwnProp: $197982d8c7a73e5f$var$hasOwnProperty,
    reduceDescriptors: $197982d8c7a73e5f$var$reduceDescriptors,
    freezeMethods: $197982d8c7a73e5f$var$freezeMethods,
    toObjectSet: $197982d8c7a73e5f$var$toObjectSet,
    toCamelCase: $197982d8c7a73e5f$var$toCamelCase,
    noop: $197982d8c7a73e5f$var$noop,
    toFiniteNumber: $197982d8c7a73e5f$var$toFiniteNumber,
    findKey: $197982d8c7a73e5f$var$findKey,
    global: $197982d8c7a73e5f$var$_global,
    isContextDefined: $197982d8c7a73e5f$var$isContextDefined,
    ALPHABET: $197982d8c7a73e5f$var$ALPHABET,
    generateString: $197982d8c7a73e5f$var$generateString,
    isSpecCompliantForm: $197982d8c7a73e5f$var$isSpecCompliantForm,
    toJSONObject: $197982d8c7a73e5f$var$toJSONObject,
    isAsyncFn: $197982d8c7a73e5f$var$isAsyncFn,
    isThenable: $197982d8c7a73e5f$var$isThenable
};

});
parcelRegister("djt5d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b139c02a8c43d26$export$2e2bcd8739ae039; });
"use strict";
function $9b139c02a8c43d26$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("6zSb1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ca0095817960ee3$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");

var $2RNjJ = parcelRequire("2RNjJ");

var $5Dm7L = parcelRequire("5Dm7L");

var $eQ5d8 = parcelRequire("eQ5d8");

var $d0EKm = parcelRequire("d0EKm");

var $1ZTQa = parcelRequire("1ZTQa");

var $6zj0X = parcelRequire("6zj0X");

var $gbTL1 = parcelRequire("gbTL1");
"use strict";
const $4ca0095817960ee3$var$validators = (0, $6zj0X.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $4ca0095817960ee3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $5Dm7L.default)(),
            response: new (0, $5Dm7L.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                if (!err.stack) err.stack = stack;
                else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $d0EKm.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $6zj0X.default).assertOptions(transitional, {
            silentJSONParsing: $4ca0095817960ee3$var$validators.transitional($4ca0095817960ee3$var$validators.boolean),
            forcedJSONParsing: $4ca0095817960ee3$var$validators.transitional($4ca0095817960ee3$var$validators.boolean),
            clarifyTimeoutError: $4ca0095817960ee3$var$validators.transitional($4ca0095817960ee3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $2bBga.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $6zj0X.default).assertOptions(paramsSerializer, {
                encode: $4ca0095817960ee3$var$validators.function,
                serialize: $4ca0095817960ee3$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $2bBga.default).merge(headers.common, headers[config.method]);
        headers && (0, $2bBga.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $gbTL1.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $eQ5d8.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $eQ5d8.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $d0EKm.default)(this.defaults, config);
        const fullPath = (0, $1ZTQa.default)(config.baseURL, config.url);
        return (0, $2RNjJ.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $2bBga.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $4ca0095817960ee3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $d0EKm.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $2bBga.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $d0EKm.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $4ca0095817960ee3$var$Axios.prototype[method] = generateHTTPMethod();
    $4ca0095817960ee3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $4ca0095817960ee3$export$2e2bcd8739ae039 = $4ca0095817960ee3$var$Axios;

});
parcelRegister("2RNjJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2166c96446d6ea30$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");

var $hz3Ym = parcelRequire("hz3Ym");
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $2166c96446d6ea30$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $2166c96446d6ea30$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $2166c96446d6ea30$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $2bBga.default).isURLSearchParams(params) ? params.toString() : new (0, $hz3Ym.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

});
parcelRegister("hz3Ym", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc98c96c287b2efc$export$2e2bcd8739ae039; });

var $aewVa = parcelRequire("aewVa");
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $cc98c96c287b2efc$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $cc98c96c287b2efc$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $aewVa.default)(params, this, options);
}
const $cc98c96c287b2efc$var$prototype = $cc98c96c287b2efc$var$AxiosURLSearchParams.prototype;
$cc98c96c287b2efc$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$cc98c96c287b2efc$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $cc98c96c287b2efc$var$encode);
    } : $cc98c96c287b2efc$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $cc98c96c287b2efc$export$2e2bcd8739ae039 = $cc98c96c287b2efc$var$AxiosURLSearchParams;

});
parcelRegister("aewVa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7734bfa34e03fc2a$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");

var $121rJ = parcelRequire("121rJ");

var $1gvAv = parcelRequire("1gvAv");

var $ihoyg = parcelRequire("ihoyg");
var $7734bfa34e03fc2a$require$Buffer = $ihoyg.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $7734bfa34e03fc2a$var$isVisitable(thing) {
    return (0, $2bBga.default).isPlainObject(thing) || (0, $2bBga.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $7734bfa34e03fc2a$var$removeBrackets(key) {
    return (0, $2bBga.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $7734bfa34e03fc2a$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $7734bfa34e03fc2a$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $7734bfa34e03fc2a$var$isFlatArray(arr) {
    return (0, $2bBga.default).isArray(arr) && !arr.some($7734bfa34e03fc2a$var$isVisitable);
}
const $7734bfa34e03fc2a$var$predicates = (0, $2bBga.default).toFlatObject((0, $2bBga.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $7734bfa34e03fc2a$var$toFormData(obj, formData, options) {
    if (!(0, $2bBga.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $1gvAv.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $2bBga.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $2bBga.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $2bBga.default).isSpecCompliantForm(formData);
    if (!(0, $2bBga.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $2bBga.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $2bBga.default).isBlob(value)) throw new (0, $121rJ.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, $2bBga.default).isArrayBuffer(value) || (0, $2bBga.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $7734bfa34e03fc2a$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $2bBga.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $2bBga.default).isArray(value) && $7734bfa34e03fc2a$var$isFlatArray(value) || ((0, $2bBga.default).isFileList(value) || (0, $2bBga.default).endsWith(key, "[]")) && (arr = (0, $2bBga.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $7734bfa34e03fc2a$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $2bBga.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $7734bfa34e03fc2a$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($7734bfa34e03fc2a$var$isVisitable(value)) return true;
        formData.append($7734bfa34e03fc2a$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($7734bfa34e03fc2a$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $7734bfa34e03fc2a$var$isVisitable
    });
    function build(value, path) {
        if ((0, $2bBga.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $2bBga.default).forEach(value, function each(el, key) {
            const result = !((0, $2bBga.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $2bBga.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $2bBga.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $7734bfa34e03fc2a$export$2e2bcd8739ae039 = $7734bfa34e03fc2a$var$toFormData;

});
parcelRegister("121rJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c07198b07c857d4$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $0c07198b07c857d4$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $2bBga.default).inherits($0c07198b07c857d4$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $2bBga.default).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $0c07198b07c857d4$var$prototype = $0c07198b07c857d4$var$AxiosError.prototype;
const $0c07198b07c857d4$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $0c07198b07c857d4$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($0c07198b07c857d4$var$AxiosError, $0c07198b07c857d4$var$descriptors);
Object.defineProperty($0c07198b07c857d4$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$0c07198b07c857d4$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($0c07198b07c857d4$var$prototype);
    (0, $2bBga.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $0c07198b07c857d4$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $0c07198b07c857d4$export$2e2bcd8739ae039 = $0c07198b07c857d4$var$AxiosError;

});

parcelRegister("1gvAv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ebfc9c247e7035c$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $0ebfc9c247e7035c$export$2e2bcd8739ae039 = null;

});




parcelRegister("5Dm7L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41a1c1ac65ef962e$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");
"use strict";
class $41a1c1ac65ef962e$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $2bBga.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $41a1c1ac65ef962e$export$2e2bcd8739ae039 = $41a1c1ac65ef962e$var$InterceptorManager;

});

parcelRegister("eQ5d8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acd9f6ce0996c2c9$export$2e2bcd8739ae039; });

var $bhEpd = parcelRequire("bhEpd");

var $ksuZT = parcelRequire("ksuZT");

var $hqlPG = parcelRequire("hqlPG");

var $83xK9 = parcelRequire("83xK9");

var $gbTL1 = parcelRequire("gbTL1");

var $enpjQ = parcelRequire("enpjQ");
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $acd9f6ce0996c2c9$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $83xK9.default)(null, config);
}
function $acd9f6ce0996c2c9$export$2e2bcd8739ae039(config) {
    $acd9f6ce0996c2c9$var$throwIfCancellationRequested(config);
    config.headers = (0, $gbTL1.default).from(config.headers);
    // Transform request data
    config.data = (0, $bhEpd.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $enpjQ.default).getAdapter(config.adapter || (0, $hqlPG.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $acd9f6ce0996c2c9$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $bhEpd.default).call(config, config.transformResponse, response);
        response.headers = (0, $gbTL1.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $ksuZT.default)(reason)) {
            $acd9f6ce0996c2c9$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $bhEpd.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $gbTL1.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("bhEpd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83709ffa15cc9b1e$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");

var $hqlPG = parcelRequire("hqlPG");

var $gbTL1 = parcelRequire("gbTL1");
"use strict";
function $83709ffa15cc9b1e$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $hqlPG.default);
    const context = response || config;
    const headers = (0, $gbTL1.default).from(context.headers);
    let data = context.data;
    (0, $2bBga.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("hqlPG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $caf5cce0e605762b$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");

var $121rJ = parcelRequire("121rJ");

var $2wfLM = parcelRequire("2wfLM");

var $aewVa = parcelRequire("aewVa");

var $5tcKT = parcelRequire("5tcKT");

var $d5Oi9 = parcelRequire("d5Oi9");

var $4bmvb = parcelRequire("4bmvb");
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $caf5cce0e605762b$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $2bBga.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $2bBga.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $caf5cce0e605762b$var$defaults = {
    transitional: (0, $2wfLM.default),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $2bBga.default).isObject(data);
            if (isObjectPayload && (0, $2bBga.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $2bBga.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $4bmvb.default)(data)) : data;
            if ((0, $2bBga.default).isArrayBuffer(data) || (0, $2bBga.default).isBuffer(data) || (0, $2bBga.default).isStream(data) || (0, $2bBga.default).isFile(data) || (0, $2bBga.default).isBlob(data)) return data;
            if ((0, $2bBga.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $2bBga.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $5tcKT.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $2bBga.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $aewVa.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $caf5cce0e605762b$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $caf5cce0e605762b$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $2bBga.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $121rJ.default).from(e, (0, $121rJ.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $d5Oi9.default).classes.FormData,
        Blob: (0, $d5Oi9.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $2bBga.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $caf5cce0e605762b$var$defaults.headers[method] = {};
});
var $caf5cce0e605762b$export$2e2bcd8739ae039 = $caf5cce0e605762b$var$defaults;

});
parcelRegister("2wfLM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d5acd6ee4a1e450$export$2e2bcd8739ae039; });
"use strict";
var $1d5acd6ee4a1e450$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("5tcKT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fb98e26853e5168$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");

var $aewVa = parcelRequire("aewVa");

var $d5Oi9 = parcelRequire("d5Oi9");
"use strict";
function $3fb98e26853e5168$export$2e2bcd8739ae039(data, options) {
    return (0, $aewVa.default)(data, new (0, $d5Oi9.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $d5Oi9.default).isNode && (0, $2bBga.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("d5Oi9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9882c0e358a1bf43$export$2e2bcd8739ae039; });

var $hdo0R = parcelRequire("hdo0R");

var $fd0Wi = parcelRequire("fd0Wi");
var $9882c0e358a1bf43$export$2e2bcd8739ae039 = {
    ...$fd0Wi,
    ...(0, $hdo0R.default)
};

});
parcelRegister("hdo0R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c88647090d2a1f73$export$2e2bcd8739ae039; });

var $9matH = parcelRequire("9matH");

var $eN04z = parcelRequire("eN04z");

var $2J1oD = parcelRequire("2J1oD");
var $c88647090d2a1f73$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9matH.default,
        FormData: $eN04z.default,
        Blob: $2J1oD.default
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

});
parcelRegister("9matH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cfe4bd5b8086c37$export$2e2bcd8739ae039; });

var $hz3Ym = parcelRequire("hz3Ym");
"use strict";
var $6cfe4bd5b8086c37$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $hz3Ym.default);

});

parcelRegister("eN04z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac45b2bd873143e7$export$2e2bcd8739ae039; });
"use strict";
var $ac45b2bd873143e7$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;

});

parcelRegister("2J1oD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fc0de09c1be870f$export$2e2bcd8739ae039; });
"use strict";
var $1fc0de09c1be870f$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;

});


parcelRegister("fd0Wi", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $b128cc6d9193e875$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $b128cc6d9193e875$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $b128cc6d9193e875$export$c81692cf5af97dac; });
const $b128cc6d9193e875$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $b128cc6d9193e875$export$c0bcc9250309d66 = ((product)=>{
    return $b128cc6d9193e875$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $b128cc6d9193e875$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();

});



parcelRegister("4bmvb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30b9a4ee1106a4de$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $30b9a4ee1106a4de$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $2bBga.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $30b9a4ee1106a4de$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $30b9a4ee1106a4de$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $2bBga.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $2bBga.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $2bBga.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $2bBga.default).isArray(target[name])) target[name] = $30b9a4ee1106a4de$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $2bBga.default).isFormData(formData) && (0, $2bBga.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $2bBga.default).forEachEntry(formData, (name, value)=>{
            buildPath($30b9a4ee1106a4de$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $30b9a4ee1106a4de$export$2e2bcd8739ae039 = $30b9a4ee1106a4de$var$formDataToJSON;

});


parcelRegister("gbTL1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc98ecaa632caed0$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");

var $9cPEm = parcelRequire("9cPEm");
"use strict";
const $bc98ecaa632caed0$var$$internals = Symbol("internals");
function $bc98ecaa632caed0$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $bc98ecaa632caed0$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $2bBga.default).isArray(value) ? value.map($bc98ecaa632caed0$var$normalizeValue) : String(value);
}
function $bc98ecaa632caed0$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $bc98ecaa632caed0$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $bc98ecaa632caed0$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $2bBga.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $2bBga.default).isString(value)) return;
    if ((0, $2bBga.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $2bBga.default).isRegExp(filter)) return filter.test(value);
}
function $bc98ecaa632caed0$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $bc98ecaa632caed0$var$buildAccessors(obj, header) {
    const accessorName = (0, $2bBga.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $bc98ecaa632caed0$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $bc98ecaa632caed0$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $2bBga.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $bc98ecaa632caed0$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $2bBga.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $2bBga.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $2bBga.default).isString(header) && (header = header.trim()) && !$bc98ecaa632caed0$var$isValidHeaderName(header)) setHeaders((0, $9cPEm.default)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $bc98ecaa632caed0$var$normalizeHeader(header);
        if (header) {
            const key = (0, $2bBga.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $bc98ecaa632caed0$var$parseTokens(value);
                if ((0, $2bBga.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $2bBga.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $bc98ecaa632caed0$var$normalizeHeader(header);
        if (header) {
            const key = (0, $2bBga.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $bc98ecaa632caed0$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $bc98ecaa632caed0$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $2bBga.default).findKey(self, _header);
                if (key && (!matcher || $bc98ecaa632caed0$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $2bBga.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $bc98ecaa632caed0$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $2bBga.default).forEach(this, (value, header)=>{
            const key = (0, $2bBga.default).findKey(headers, header);
            if (key) {
                self[key] = $bc98ecaa632caed0$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $bc98ecaa632caed0$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $bc98ecaa632caed0$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $2bBga.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $2bBga.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$bc98ecaa632caed0$var$$internals] = this[$bc98ecaa632caed0$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $bc98ecaa632caed0$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $bc98ecaa632caed0$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $2bBga.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$bc98ecaa632caed0$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $2bBga.default).reduceDescriptors($bc98ecaa632caed0$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $2bBga.default).freezeMethods($bc98ecaa632caed0$var$AxiosHeaders);
var $bc98ecaa632caed0$export$2e2bcd8739ae039 = $bc98ecaa632caed0$var$AxiosHeaders;

});
parcelRegister("9cPEm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b3d4ca234f68ddb$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $6b3d4ca234f68ddb$var$ignoreDuplicateOf = (0, $2bBga.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $6b3d4ca234f68ddb$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $6b3d4ca234f68ddb$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

});



parcelRegister("ksuZT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee4e77981fc99baa$export$2e2bcd8739ae039; });
"use strict";
function $ee4e77981fc99baa$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("83xK9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dd8c74561f08d70$export$2e2bcd8739ae039; });

var $121rJ = parcelRequire("121rJ");

var $2bBga = parcelRequire("2bBga");
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $5dd8c74561f08d70$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $121rJ.default).call(this, message == null ? "canceled" : message, (0, $121rJ.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $2bBga.default).inherits($5dd8c74561f08d70$var$CanceledError, (0, $121rJ.default), {
    __CANCEL__: true
});
var $5dd8c74561f08d70$export$2e2bcd8739ae039 = $5dd8c74561f08d70$var$CanceledError;

});

parcelRegister("enpjQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a776da890889b002$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");

var $1gvAv = parcelRequire("1gvAv");

var $9VVcb = parcelRequire("9VVcb");

var $121rJ = parcelRequire("121rJ");
const $a776da890889b002$var$knownAdapters = {
    http: (0, $1gvAv.default),
    xhr: (0, $9VVcb.default)
};
(0, $2bBga.default).forEach($a776da890889b002$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $a776da890889b002$var$renderReason = (reason)=>`- ${reason}`;
const $a776da890889b002$var$isResolvedHandle = (adapter)=>(0, $2bBga.default).isFunction(adapter) || adapter === null || adapter === false;
var $a776da890889b002$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $2bBga.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$a776da890889b002$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $a776da890889b002$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $121rJ.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($a776da890889b002$var$renderReason).join("\n") : " " + $a776da890889b002$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $121rJ.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $a776da890889b002$var$knownAdapters
};

});
parcelRegister("9VVcb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73b5cdc05ac72ecf$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");

var $1TQad = parcelRequire("1TQad");

var $kTwUV = parcelRequire("kTwUV");

var $2RNjJ = parcelRequire("2RNjJ");

var $1ZTQa = parcelRequire("1ZTQa");

var $g3yOT = parcelRequire("g3yOT");

var $2wfLM = parcelRequire("2wfLM");

var $121rJ = parcelRequire("121rJ");

var $83xK9 = parcelRequire("83xK9");

var $8wMQb = parcelRequire("8wMQb");

var $d5Oi9 = parcelRequire("d5Oi9");

var $gbTL1 = parcelRequire("gbTL1");

var $5OiBb = parcelRequire("5OiBb");
"use strict";
function $73b5cdc05ac72ecf$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $5OiBb.default)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $73b5cdc05ac72ecf$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $73b5cdc05ac72ecf$export$2e2bcd8739ae039 = $73b5cdc05ac72ecf$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $gbTL1.default).from(config.headers).normalize();
        let { responseType: responseType, withXSRFToken: withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $2bBga.default).isFormData(requestData)) {
            if ((0, $d5Oi9.default).hasStandardBrowserEnv || (0, $d5Oi9.default).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $1ZTQa.default)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $2RNjJ.default)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $gbTL1.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $1TQad.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $121rJ.default)("Request aborted", (0, $121rJ.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $121rJ.default)("Network Error", (0, $121rJ.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $2wfLM.default);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $121rJ.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $121rJ.default).ETIMEDOUT : (0, $121rJ.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $d5Oi9.default).hasStandardBrowserEnv) {
            withXSRFToken && (0, $2bBga.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, $g3yOT.default)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, $kTwUV.default).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $2bBga.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $2bBga.default).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $73b5cdc05ac72ecf$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $73b5cdc05ac72ecf$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $83xK9.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $8wMQb.default)(fullPath);
        if (protocol && (0, $d5Oi9.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $121rJ.default)("Unsupported protocol " + protocol + ":", (0, $121rJ.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("1TQad", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1623641cb5783008$export$2e2bcd8739ae039; });

var $121rJ = parcelRequire("121rJ");
"use strict";
function $1623641cb5783008$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $121rJ.default)("Request failed with status code " + response.status, [
        (0, $121rJ.default).ERR_BAD_REQUEST,
        (0, $121rJ.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("kTwUV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3627a5d0641603b$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");

var $d5Oi9 = parcelRequire("d5Oi9");
var $f3627a5d0641603b$export$2e2bcd8739ae039 = (0, $d5Oi9.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $2bBga.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $2bBga.default).isString(path) && cookie.push("path=" + path);
        (0, $2bBga.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("1ZTQa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1746cdb16526768b$export$2e2bcd8739ae039; });

var $iUwU6 = parcelRequire("iUwU6");

var $91vFE = parcelRequire("91vFE");
"use strict";
function $1746cdb16526768b$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $iUwU6.default)(requestedURL)) return (0, $91vFE.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("iUwU6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc46faf754468a20$export$2e2bcd8739ae039; });
"use strict";
function $dc46faf754468a20$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("91vFE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $691cc630f9ef56b2$export$2e2bcd8739ae039; });
"use strict";
function $691cc630f9ef56b2$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

});


parcelRegister("g3yOT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb07efa23107e01d$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");

var $d5Oi9 = parcelRequire("d5Oi9");
"use strict";
var $bb07efa23107e01d$export$2e2bcd8739ae039 = (0, $d5Oi9.default).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $2bBga.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("8wMQb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6357329dd8712192$export$2e2bcd8739ae039; });
"use strict";
function $6357329dd8712192$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

});

parcelRegister("5OiBb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43b00c9657a44656$export$2e2bcd8739ae039; });
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $43b00c9657a44656$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $43b00c9657a44656$export$2e2bcd8739ae039 = $43b00c9657a44656$var$speedometer;

});




parcelRegister("d0EKm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $978ae1e75118f535$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");

var $gbTL1 = parcelRequire("gbTL1");
"use strict";
const $978ae1e75118f535$var$headersToObject = (thing)=>thing instanceof (0, $gbTL1.default) ? thing.toJSON() : thing;
function $978ae1e75118f535$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $2bBga.default).isPlainObject(target) && (0, $2bBga.default).isPlainObject(source)) return (0, $2bBga.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $2bBga.default).isPlainObject(source)) return (0, $2bBga.default).merge({}, source);
        else if ((0, $2bBga.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $2bBga.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $2bBga.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $2bBga.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $2bBga.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $2bBga.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($978ae1e75118f535$var$headersToObject(a), $978ae1e75118f535$var$headersToObject(b), true)
    };
    (0, $2bBga.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $2bBga.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});

parcelRegister("6zj0X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c84c2d525dc977b$export$2e2bcd8739ae039; });

var $50GW0 = parcelRequire("50GW0");

var $121rJ = parcelRequire("121rJ");
"use strict";
const $4c84c2d525dc977b$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $4c84c2d525dc977b$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $4c84c2d525dc977b$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $4c84c2d525dc977b$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $50GW0.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $121rJ.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $121rJ.default).ERR_DEPRECATED);
        if (version && !$4c84c2d525dc977b$var$deprecatedWarnings[opt]) {
            $4c84c2d525dc977b$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $4c84c2d525dc977b$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $121rJ.default)("options must be an object", (0, $121rJ.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $121rJ.default)("option " + opt + " must be " + result, (0, $121rJ.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $121rJ.default)("Unknown option " + opt, (0, $121rJ.default).ERR_BAD_OPTION);
    }
}
var $4c84c2d525dc977b$export$2e2bcd8739ae039 = {
    assertOptions: $4c84c2d525dc977b$var$assertOptions,
    validators: $4c84c2d525dc977b$var$validators
};

});
parcelRegister("50GW0", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $3a5e41bf204d513a$export$a4ad2735b021c132; });
const $3a5e41bf204d513a$export$a4ad2735b021c132 = "1.6.7";

});



parcelRegister("2sjhC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c9d2783569136b3$export$2e2bcd8739ae039; });

var $83xK9 = parcelRequire("83xK9");
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $1c9d2783569136b3$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $83xK9.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $1c9d2783569136b3$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $1c9d2783569136b3$export$2e2bcd8739ae039 = $1c9d2783569136b3$var$CancelToken;

});

parcelRegister("av9gA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a53fcc4fd1591ba$export$2e2bcd8739ae039; });
"use strict";
function $7a53fcc4fd1591ba$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("gNhGc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c39eefbf2d152c6a$export$2e2bcd8739ae039; });

var $2bBga = parcelRequire("2bBga");
"use strict";
function $c39eefbf2d152c6a$export$2e2bcd8739ae039(payload) {
    return (0, $2bBga.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("jd7iQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfc4e5689184d2bd$export$2e2bcd8739ae039; });
const $dfc4e5689184d2bd$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($dfc4e5689184d2bd$var$HttpStatusCode).forEach(([key, value])=>{
    $dfc4e5689184d2bd$var$HttpStatusCode[value] = key;
});
var $dfc4e5689184d2bd$export$2e2bcd8739ae039 = $dfc4e5689184d2bd$var$HttpStatusCode;

});




parcelRegister("jcp9V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc75bf2296c6e61a$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");

var $1Dn8S = parcelRequire("1Dn8S");

var $ayVxz = parcelRequire("ayVxz");

var $bu31C = parcelRequire("bu31C");
parcelRequire("2shzp");
var $bRlFp = parcelRequire("bRlFp");

var $358bY = parcelRequire("358bY");

var $91340 = parcelRequire("91340");

var $e4eIN = parcelRequire("e4eIN");

var $5PJ2i = parcelRequire("5PJ2i");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $aM783 = parcelRequire("aM783");

var $eldXE = parcelRequire("eldXE");

const $fc75bf2296c6e61a$var$defaultErrorsObj = {
    downloadDate: null,
    downloadDateInvalidDate: null
};
const $fc75bf2296c6e61a$var$errorTexts = {
    downloadDate: "Download Date is required",
    downloadDateInvalidDate: "Invalid Date Format"
};
const $fc75bf2296c6e61a$var$minDate = new Date(2000, 0, 1);
const $fc75bf2296c6e61a$var$downloadMinDateMessage = `date should be after ${$fc75bf2296c6e61a$var$minDate}`;
const $fc75bf2296c6e61a$var$FtseDownloadForm = ({ handleClose: handleClose, isLoading: isLoading })=>{
    const [downloadDate, setDownloadDate] = (0, $bh6RR.useState)(new Date());
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($fc75bf2296c6e61a$var$defaultErrorsObj);
    const [downloadLatest, setDownloadLatest] = (0, $bh6RR.useState)(false);
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const handleCancel = ()=>{
        setDownloadDate(null);
        handleClose();
    };
    const getPureDate = (date)=>{
        const getMonthWithTwoDigit = (date)=>{
            return ("0" + (date?.getMonth() + 1)).slice(-2);
        };
        const getDateWithTwoDigit = (date)=>{
            return ("0" + date?.getDate()).slice(-2);
        };
        const pureDate = `${date?.getFullYear()}-${getMonthWithTwoDigit(date)}-${getDateWithTwoDigit(date)}`;
        return pureDate;
    };
    const handleDownload = ()=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `'Are you sure you want to download FTSE files ( on your computer ) for ${getPureDate(downloadDate)} ?'`,
                agreeAction: downloadFiles
            }
        });
    };
    const downloadFiles = async ()=>{
        const pureDate = getPureDate(downloadDate);
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        isLoading(true);
        (0, $bRlFp.default)({
            url: `${"https://crm.epra.com/csvcollect"}/downloadFiles?date=${pureDate}&latest=${downloadLatest}`,
            method: "GET",
            responseType: "blob",
            headers: {
                Authorization: `${localStorage.getItem((0, $aM783.AppConsts).AccessToken)}`
            }
        }).then((response)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($358bY))).saveAs(response.data, `ftse-${pureDate}`);
            isLoading(false);
        }).catch((e)=>{
            isLoading(false);
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
    };
    const handleDownloadDateChange = (value)=>{
        if (value) {
            if (value < new Date($fc75bf2296c6e61a$var$minDate)) $fc75bf2296c6e61a$var$errorTexts.downloadDate = $fc75bf2296c6e61a$var$downloadMinDateMessage;
            else if ($fc75bf2296c6e61a$var$errorTexts.downloadDate === $fc75bf2296c6e61a$var$downloadMinDateMessage) $fc75bf2296c6e61a$var$errorTexts.downloadDate = null;
            setFormErrors({
                ...formErrors,
                downloadDate: null
            });
        } else setFormErrors({
            ...formErrors,
            downloadDate: $fc75bf2296c6e61a$var$errorTexts.downloadDate
        });
        setDownloadDate(value);
    };
    const handleSubmit = ()=>{
        const errors = {
            downloadDate: null,
            downloadDateInvalidDate: null
        };
        let hasErrors = false;
        if (!downloadDate) {
            hasErrors = true;
            errors.downloadDate = $fc75bf2296c6e61a$var$errorTexts.downloadDate;
        } else if (!Date.parse(downloadDate.toString())) {
            hasErrors = true;
            errors.downloadDate = $fc75bf2296c6e61a$var$errorTexts.downloadDateInvalidDate;
        }
        if (hasErrors) setFormErrors(errors);
        else {
            handleDownload();
            handleClose();
        }
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5PJ2i.default), {
        id: "ftse-files-download-form",
        width: 375,
        title: "Download FTSE Files",
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            className: "ftse-download-container",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                    dateAdapter: (0, $1Dn8S.AdapterDateFns),
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                        id: "start-date-picker",
                        label: "Download Date",
                        value: downloadDate,
                        onChange: (date)=>handleDownloadDateChange(date),
                        minDate: $fc75bf2296c6e61a$var$minDate,
                        sx: {
                            width: "100%"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $eldXE.default), {
                    id: "latest-files",
                    label: "Get Latest",
                    value: downloadLatest,
                    onChange: ()=>setDownloadLatest(!downloadLatest)
                }, "latest-files"),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "centralize ftse-download-container__actions",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                            id: "cancel-download-button",
                            onClick: handleCancel,
                            text: "Close"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                            id: "save-download-button",
                            onClick: handleSubmit,
                            text: "Submit"
                        })
                    ]
                })
            ]
        })
    });
};
var $fc75bf2296c6e61a$export$2e2bcd8739ae039 = $fc75bf2296c6e61a$var$FtseDownloadForm;

});


parcelRegister("iCV47", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b17754db0da9afb0$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");
var $lC4lc = parcelRequire("lC4lc");

var $2eJeT = parcelRequire("2eJeT");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $6L9uu = parcelRequire("6L9uu");

var $d7fM7 = parcelRequire("d7fM7");

var $e2ibc = parcelRequire("e2ibc");

var $e4eIN = parcelRequire("e4eIN");

var $91340 = parcelRequire("91340");

var $1Dn8S = parcelRequire("1Dn8S");
const $b17754db0da9afb0$var$dateFormat = "dd/MM/yyyy";
const $b17754db0da9afb0$var$FtseFxList = ()=>{
    const [date, setDate] = (0, $bh6RR.useState)(null);
    const [getFtseFxData, { data: data, loading: loading }] = (0, $hjfla.useGetLatestFxDataLazyQuery)({
        fetchPolicy: "no-cache"
    });
    (0, $bh6RR.useEffect)(()=>{
        getFtseFxData();
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (date) getFtseFxData({
            variables: {
                date: (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(date).format("YYYY-MM-DD")
            }
        });
        else getFtseFxData();
    }, [
        date
    ]);
    const renderDate = (rowData, date)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return rowData[date] ? // @ts-ignore
        (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(parseInt(rowData[date])).format((0, $e2ibc.DATE_TIME_FORMATS).DATE_AND_TIME_AM_PM) : "";
    };
    const columns = [
        {
            title: "Date",
            field: "date",
            sorting: false,
            render: (rowData)=>renderDate(rowData, "date"),
            width: 430
        },
        {
            title: "Currency Code",
            field: "currency.code",
            width: 430
        },
        {
            title: "Currency Id",
            field: "currency.id",
            width: 430
        },
        {
            title: "Rate Value",
            field: "rate",
            width: 430,
            sorting: false
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        children: loading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
            sx: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: (0, $6L9uu.Colors).main,
                marginTop: "14%"
            },
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lC4lc.default), {
                color: "inherit"
            })
        }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
            className: "overviewPage",
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                className: "print\\:w-full",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                    columns: columns,
                    data: data?.result || [],
                    loading: loading,
                    pageSize: 15,
                    additionalFilters: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                        dateAdapter: (0, $1Dn8S.AdapterDateFns),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                            id: "ftse-fx-date-picker",
                            label: "Date",
                            value: date,
                            clearable: true,
                            onChange: (value)=>setDate(value),
                            format: $b17754db0da9afb0$var$dateFormat
                        })
                    })
                })
            })
        })
    });
};
var $b17754db0da9afb0$export$2e2bcd8739ae039 = $b17754db0da9afb0$var$FtseFxList;

});

parcelRegister("iKNNz", function(module, exports) {
"use strict";
"use client";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $da7326d7583c736d$var$_createSvgIcon = $2ZnTs((parcelRequire("lpAdr")));

var $ih19M = parcelRequire("ih19M");
var $da7326d7583c736d$var$_default = module.exports.default = (0, $da7326d7583c736d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M10 20h4V4h-4zm-6 0h4v-8H4zM16 9v11h4V9z"
}), "Equalizer");

});

parcelRegister("8JH44", function(module, exports) {
"use strict";
"use client";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65c3ee75a8a3ffcc$var$_createSvgIcon = $2ZnTs((parcelRequire("lpAdr")));

var $ih19M = parcelRequire("ih19M");
var $65c3ee75a8a3ffcc$var$_default = module.exports.default = (0, $65c3ee75a8a3ffcc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10m2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99m0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99z"
}), "PieChart");

});


parcelRegister("H2UE0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e3cf993546df315$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");

var $bh6RR = parcelRequire("bh6RR");

var $j5ie7 = parcelRequire("j5ie7");

var $j1aJU = parcelRequire("j1aJU");

var $fxDtx = parcelRequire("fxDtx");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $ffIgp = parcelRequire("ffIgp");

var $hpf1K = parcelRequire("hpf1K");

var $eBMvL = parcelRequire("eBMvL");
const $7e3cf993546df315$var$EtfsInfoWrapper = ()=>{
    const location = (0, $99w1R.useLocation)();
    const locationState = location.state;
    const indexOfActiveTab = locationState?.indexOfActiveTab != null ? locationState.indexOfActiveTab : 0;
    const [value, setValue] = (0, $bh6RR.useState)(indexOfActiveTab);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eBMvL.default), {
                value: value,
                handleChange: (_, newValue)=>setValue(newValue),
                type: "first",
                tabProps: [
                    {
                        id: "etf",
                        title: "ETF",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($j1aJU)))
                    },
                    {
                        id: "values",
                        title: "Values",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fxDtx)))
                    }
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                        value: value,
                        index: 0,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ffIgp.default), {
                            indexOfActiveTab: value
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $j5ie7.default), {
                        value: value,
                        index: 1,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $hpf1K.default), {
                            indexOfActiveTab: value
                        })
                    })
                ]
            })
        ]
    });
};
var $7e3cf993546df315$export$2e2bcd8739ae039 = $7e3cf993546df315$var$EtfsInfoWrapper;

});
parcelRegister("j1aJU", function(module, exports) {
"use strict";
"use client";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd8670f0a1465004$var$_createSvgIcon = $2ZnTs((parcelRequire("lpAdr")));

var $ih19M = parcelRequire("ih19M");
var $dd8670f0a1465004$var$_default = module.exports.default = (0, $dd8670f0a1465004$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2m-9-1c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m13-6v11c0 1.1-.9 2-2 2H4v-2h17V7z"
}), "Payments");

});

parcelRegister("fxDtx", function(module, exports) {
"use strict";
"use client";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5088f1ab9f1c5fc$var$_createSvgIcon = $2ZnTs((parcelRequire("lpAdr")));

var $ih19M = parcelRequire("ih19M");
var $b5088f1ab9f1c5fc$var$_default = module.exports.default = (0, $b5088f1ab9f1c5fc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "m21.9 8.89-1.05-4.37c-.22-.9-1-1.52-1.91-1.52H5.05c-.9 0-1.69.63-1.9 1.52L2.1 8.89c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6.94c.09-.09.2-.18.28-.28.64-.82.87-1.87.62-2.89m-2.99-3.9 1.05 4.37c.1.42.01.84-.25 1.17-.14.18-.44.47-.94.47-.61 0-1.14-.49-1.21-1.14L16.98 5zM13 5h1.96l.54 4.52c.05.39-.07.78-.33 1.07-.22.26-.54.41-.95.41-.67 0-1.22-.59-1.22-1.31zM8.49 9.52 9.04 5H11v4.69c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41-.25-.29-.37-.68-.33-1.07m-4.45-.16L5.05 5h1.97l-.58 4.86c-.08.65-.6 1.14-1.21 1.14-.49 0-.8-.29-.93-.47-.27-.32-.36-.75-.26-1.17M5 19v-6.03c.08.01.15.03.23.03.87 0 1.66-.36 2.24-.95.6.6 1.4.95 2.31.95.87 0 1.65-.36 2.23-.93.59.57 1.39.93 2.29.93.84 0 1.64-.35 2.24-.95.58.59 1.37.95 2.24.95.08 0 .15-.02.23-.03V19z"
}), "Storefront");

});

parcelRegister("ffIgp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f437173ed2c6820$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $lZnEL = parcelRequire("lZnEL");

var $2eJeT = parcelRequire("2eJeT");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $gUBkJ = parcelRequire("gUBkJ");

var $hjfla = parcelRequire("hjfla");

var $e2ibc = parcelRequire("e2ibc");

var $dqRXb = parcelRequire("dqRXb");

var $hsjD5 = parcelRequire("hsjD5");

var $6L9uu = parcelRequire("6L9uu");

var $d7fM7 = parcelRequire("d7fM7");

var $3Rfss = parcelRequire("3Rfss");
const $4f437173ed2c6820$var$EtfList = ({ indexOfActiveTab: indexOfActiveTab })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const { data: data, loading: loading } = (0, $hjfla.useGetEtfsQuery)();
    const [allData, setAllData] = (0, $bh6RR.useState)([]);
    const [openForm, setOpenForm] = (0, $bh6RR.useState)(false);
    const [etf, setEtf] = (0, $bh6RR.useState)(null);
    const [deleteEtf] = (0, $hjfla.useDeleteEtfMutation)();
    const canCreate = (0, $dqRXb.canUserCreate)(state.user, (0, $gUBkJ.Types).ETF);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) setAllData(data.result);
    }, [
        data
    ]);
    const formatDate = (rowData, name)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return rowData[name] ? // @ts-ignore
        (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(parseInt(rowData[name])).format((0, $e2ibc.DATE_TIME_FORMATS).DATE) : "";
    };
    const renderHistoryColumn = (rowData)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: rowData.id,
            onClick: ()=>handleHistory(rowData),
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lZnEL.default), {
                sx: {
                    ...(0, $hsjD5.iconStyle),
                    color: (0, $6L9uu.Colors).skyBlue
                },
                children: "history"
            })
        });
    const handleHistory = (rowData)=>{
        navigate(`/etfs/${rowData.id}`, {
            state: {
                ...rowData,
                indexOfActiveTab: indexOfActiveTab
            }
        });
    };
    const handleRemove = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).ShowConfirmation,
            payload: {
                text: `Are you sure you want to delete ${rowData.name} etf??`,
                agreeAction: handleDelete,
                params: rowData
            }
        });
    };
    const handleDelete = (rowData)=>{
        dispatch({
            type: (0, $ayVxz.Actions).HideConfirmation
        });
        deleteEtf({
            variables: {
                id: rowData.id
            },
            update (cache) {
                const etfsQuery = cache.readQuery({
                    query: (0, $hjfla.GetEtfsDocument)
                });
                if (etfsQuery.result) {
                    const cachedEtf = etfsQuery.result.findIndex((e)=>e?.id === rowData.id);
                    if (cachedEtf > -1) {
                        const data = etfsQuery.result.filter((e)=>e?.id !== rowData.id);
                        cache.writeQuery({
                            query: (0, $hjfla.GetEtfsDocument),
                            data: {
                                result: data
                            }
                        });
                    }
                }
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    text: e.message,
                    severity: "error"
                }
            });
        });
        dispatch({
            type: (0, $ayVxz.Actions).ShowMessage,
            payload: {
                text: `${rowData.name} etf deleted`,
                severity: "success"
            }
        });
    };
    const columns = [
        {
            title: "Details",
            width: 60,
            sorting: false
        },
        {
            title: "History",
            width: 60,
            sorting: false,
            render: renderHistoryColumn
        },
        {
            title: "Launch Date",
            field: "launch_date",
            width: 120,
            type: "date",
            render: (rowData)=>formatDate(rowData, "launch_date")
        },
        {
            title: "Provider",
            field: "provider",
            width: 265
        },
        {
            title: "Name",
            field: "name",
            width: 655
        },
        {
            title: "Benchmark name",
            field: "identifier",
            width: 490
        },
        {
            title: "Remove",
            width: 71,
            sorting: false
        }
    ];
    const handleDetails = (rowData)=>{
        setEtf(rowData);
        setOpenForm(true);
    };
    const handleClose = (saved, isNew, etfInput)=>{
        if (saved && isNew) addEtfDocument(etfInput);
        setEtf(null);
        setOpenForm(false);
    };
    const addEtfDocument = (etfInput)=>{
        const existing = allData.find((d)=>d.id === etfInput.id);
        if (!existing) setAllData([
            etfInput,
            ...allData
        ]);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        className: "overviewPage",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
            className: "print\\:w-full",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                    columns: columns,
                    data: allData,
                    loading: loading,
                    handleDetails: handleDetails,
                    handleRemove: handleRemove,
                    pageSize: 15,
                    createButtonProps: {
                        id: "create-etf-button",
                        onClick: ()=>setOpenForm(true),
                        text: "Create ETF",
                        disabled: !canCreate
                    }
                }),
                openForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $3Rfss.default), {
                    handleClose: handleClose,
                    etfInput: etf
                })
            ]
        })
    });
};
var $4f437173ed2c6820$export$2e2bcd8739ae039 = $4f437173ed2c6820$var$EtfList;

});
parcelRegister("3Rfss", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $653094d5b5eb82ba$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $gDp1O = parcelRequire("gDp1O");

var $6L9uu = parcelRequire("6L9uu");

var $hjfla = parcelRequire("hjfla");

var $9WP8Q = parcelRequire("9WP8Q");

var $gFVvY = parcelRequire("gFVvY");

var $1Dn8S = parcelRequire("1Dn8S");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $dqRXb = parcelRequire("dqRXb");

var $gUBkJ = parcelRequire("gUBkJ");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $ehzwo = parcelRequire("ehzwo");

var $5PJ2i = parcelRequire("5PJ2i");

var $e4eIN = parcelRequire("e4eIN");

var $91340 = parcelRequire("91340");
const $653094d5b5eb82ba$var$defaultErrorsObj = {
    launchDate: null,
    name: null,
    benchMarkName: null,
    provider: null
};
const $653094d5b5eb82ba$var$errorTexts = {
    launchDate: "Launch Date is required!",
    provider: "Provider is required!",
    name: "Name is required!",
    benchmark: "Benchmark Name is required!"
};
const $653094d5b5eb82ba$var$EtfForm = ({ handleClose: handleClose, etfInput: etfInput })=>{
    const [editable, setEditable] = (0, $bh6RR.useState)(etfInput === null);
    const [launchDate, setlaunchDate] = (0, $bh6RR.useState)(etfInput ? (0, $gFVvY.parseDate)(etfInput.launch_date) : new Date());
    const [provider, setProvider] = (0, $bh6RR.useState)(etfInput?.provider || null);
    const [name, setName] = (0, $bh6RR.useState)(etfInput?.name || null);
    const [benchmark, setBenchmark] = (0, $bh6RR.useState)(etfInput?.identifier || null);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($653094d5b5eb82ba$var$defaultErrorsObj);
    const [createEtf, createEtfResult] = (0, $hjfla.useAddEtfMutation)();
    const [updateEtf, updateEtfResult] = (0, $hjfla.useUpdateEtfMutation)();
    const { dispatch: dispatch, state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const canEdit = (0, $dqRXb.canUserEdit)(state.user, (0, $gUBkJ.Types).ETF);
    const handleCancel = ()=>{
        if (editable && etfInput !== null) {
            setlaunchDate((0, $gFVvY.parseDate)(etfInput.launch_date));
            setProvider(etfInput.provider || null);
            setName(etfInput.name || null);
            setBenchmark(etfInput.identifier || null);
            setFormErrors($653094d5b5eb82ba$var$defaultErrorsObj);
            setEditable(false);
        } else handleClose(false);
    };
    const handleDateChange = (input)=>{
        if (input) {
            if (!Number.isNaN(input.getDate())) setFormErrors({
                ...formErrors,
                launchDate: null
            });
        } else setFormErrors({
            ...formErrors,
            launchDate: $653094d5b5eb82ba$var$errorTexts.launchDate
        });
        setlaunchDate(input);
    };
    const handleProviderChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value && value.length > 0) setFormErrors({
            ...formErrors,
            provider: null
        });
        else setFormErrors({
            ...formErrors,
            provider: $653094d5b5eb82ba$var$errorTexts.provider
        });
        setProvider(value);
    };
    const handleNameChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value && value.length > 0) setFormErrors({
            ...formErrors,
            name: null
        });
        else setFormErrors({
            ...formErrors,
            name: $653094d5b5eb82ba$var$errorTexts.name
        });
        setName(value);
    };
    const handleBenchmarkChange = (event)=>{
        const { value: value } = event.currentTarget;
        if (value && value.length > 0) setFormErrors({
            ...formErrors,
            benchMarkName: null
        });
        else setFormErrors({
            ...formErrors,
            benchMarkName: $653094d5b5eb82ba$var$errorTexts.benchmark
        });
        setBenchmark(value);
    };
    const handleSubmit = ()=>{
        let hasErrors = false;
        const errors = {
            benchMarkName: null,
            launchDate: null,
            name: null,
            provider: null
        };
        if (!launchDate) {
            hasErrors = true;
            errors.launchDate = $653094d5b5eb82ba$var$errorTexts.launchDate;
        }
        if (!benchmark || benchmark.length === 0) {
            hasErrors = true;
            errors.benchMarkName = $653094d5b5eb82ba$var$errorTexts.benchmark;
        }
        if (!provider || provider.length === 0) {
            hasErrors = true;
            errors.provider = $653094d5b5eb82ba$var$errorTexts.provider;
        }
        if (!name || name.length === 0) {
            hasErrors = true;
            errors.name = $653094d5b5eb82ba$var$errorTexts.name;
        }
        if (hasErrors) setFormErrors(errors);
        else handleSave(etfInput === null ? "create" : "update");
    };
    const handleSave = (type)=>{
        const input = {
            name: name,
            provider: provider,
            launch_date: launchDate.toString(),
            identifier: benchmark
        };
        if (type === "create") createEtf({
            variables: {
                input: input
            },
            update (_, { data: data }) {
                const newEtf = data?.result;
                handleClose(true, true, newEtf);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: `Etf ${newEtf.name} created`
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        });
        else updateEtf({
            variables: {
                id: etfInput?.id,
                input: input
            },
            update (_, { data: data }) {
                handleClose(true, false, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Etf Updated"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "etf-form",
        width: 690,
        title: etfInput ? "Etf Details" : "Create ETF",
        children: [
            etfInput && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    textAlign: "right",
                    marginRight: "15px",
                    marginTop: "10px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                    id: "ftse-form-edit-button",
                    "data-testid": "ftse-form-edit-button",
                    component: (0, $gDp1O.default),
                    onClick: ()=>setEditable(true),
                    disabled: editable || !canEdit,
                    sx: {
                        ...(0, $6L9uu.buttons).edit,
                        fontWeight: "bold"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $9WP8Q.default), {
                            sx: {
                                fontSize: "medium",
                                color: editable || !canEdit ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue,
                                marginRight: "3"
                            }
                        }),
                        "EDIT"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    m: "42px",
                    mt: "60px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "40px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                        dateAdapter: (0, $1Dn8S.AdapterDateFns),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                            id: "etf-date-picker",
                            label: "ETF Launch Date",
                            value: launchDate,
                            format: "dd/MM/yyyy",
                            errorMsg: formErrors.launchDate,
                            clearable: true,
                            onChange: (d)=>handleDateChange(d),
                            disabled: !editable || createEtfResult.loading || updateEtfResult.loading,
                            sx: {
                                width: "200px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "etf-provider",
                        label: "ETF Provider",
                        value: provider,
                        onChange: handleProviderChange,
                        errorMsg: formErrors.provider,
                        disabled: !editable || createEtfResult.loading || updateEtfResult.loading
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "etf-name",
                        label: "ETF Name",
                        value: name,
                        onChange: handleNameChange,
                        errorMsg: formErrors.name,
                        disabled: !editable || createEtfResult.loading || updateEtfResult.loading
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "etf-benchmark",
                        label: "ETF Benchmark",
                        value: benchmark,
                        onChange: handleBenchmarkChange,
                        errorMsg: formErrors.benchMarkName,
                        disabled: !editable || createEtfResult.loading || updateEtfResult.loading
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        className: "centralize",
                        sx: {
                            marginTop: "20px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                                id: "cancel-etf-button",
                                "data-testid": "cancel-etf-button",
                                disabled: createEtfResult.loading || updateEtfResult.loading,
                                onClick: handleCancel,
                                text: etfInput === null || editable ? "Cancel" : "Close"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                                id: "save-etf-button",
                                "data-testid": "save-etf-button",
                                disabled: !editable || createEtfResult.loading || updateEtfResult.loading,
                                onClick: handleSubmit,
                                text: etfInput === null ? "Create" : "Save"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $653094d5b5eb82ba$export$2e2bcd8739ae039 = $653094d5b5eb82ba$var$EtfForm;

});


parcelRegister("hpf1K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7b3c54134be2cd2$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $lZnEL = parcelRequire("lZnEL");

var $2eJeT = parcelRequire("2eJeT");

var $hjfla = parcelRequire("hjfla");

var $e4eIN = parcelRequire("e4eIN");

var $6L9uu = parcelRequire("6L9uu");

var $d7fM7 = parcelRequire("d7fM7");

var $hsjD5 = parcelRequire("hsjD5");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");
const $f7b3c54134be2cd2$var$dateFormat = "dd/MM/yyyy";
const $f7b3c54134be2cd2$var$EtfValuesList = ({ indexOfActiveTab: indexOfActiveTab })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const [date, setDate] = (0, $bh6RR.useState)(null);
    const [getEtfValues, { data: data, loading: loading }] = (0, $hjfla.useGetEtfsWithValuesLazyQuery)({
        fetchPolicy: "no-cache"
    });
    (0, $bh6RR.useEffect)(()=>{
        getEtfValues();
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (date) getEtfValues({
            variables: {
                date: (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(date).format("YYYY-MM-DD")
            }
        });
        else getEtfValues();
    }, [
        date
    ]);
    const formatDate = (rowData, name)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return rowData[name] ? (0, $hsjD5.renderDateString)(rowData[name]) : "";
    };
    const renderHistoryColumn = (rowData)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
            id: rowData.id,
            onClick: ()=>handleHistory(rowData),
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lZnEL.default), {
                sx: {
                    ...(0, $hsjD5.iconStyle),
                    color: (0, $6L9uu.Colors).skyBlue
                },
                children: "history"
            })
        });
    const columns = [
        {
            title: "Details",
            width: 60,
            sorting: false
        },
        {
            title: "History",
            width: 60,
            sorting: false,
            render: renderHistoryColumn
        },
        {
            title: "Date",
            field: "date",
            width: 97,
            type: "date",
            render: (rowData)=>formatDate(rowData, "date")
        },
        {
            title: "Provider",
            field: "etf.provider",
            width: 101
        },
        {
            title: "Name",
            field: "etf.name",
            width: 273
        },
        {
            title: "Benchmark name",
            field: "etf.identifier",
            width: 273
        },
        {
            title: "AUM(min)USD",
            field: "aum",
            width: 120
        },
        {
            title: "ETF 1yr total return %",
            field: "total_return_one_year",
            width: 175
        },
        {
            title: "Index 1 yr total return %",
            field: "index_total_return_one_year",
            width: 180
        },
        {
            title: "ETF 3 yr total return %",
            field: "total_return_three_year",
            width: 175
        },
        {
            title: "Index 3 yr total return %",
            field: "index_total_return_three_year",
            width: 180
        }
    ];
    const handleHistory = (rowData)=>{
        navigate(`/etfs/${rowData.etf.id}`, {
            state: {
                ...rowData.etf,
                indexOfActiveTab: indexOfActiveTab
            }
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        className: "overviewPage",
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
            className: "print\\:w-full",
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                columns: columns,
                data: data?.result || [],
                loading: loading,
                handleDetails: ()=>true,
                handleRemove: ()=>null,
                pageSize: 15,
                additionalFilters: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                    dateAdapter: (0, $1Dn8S.AdapterDateFns),
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                        id: "etf-values-date-picker",
                        label: "Date",
                        value: date,
                        clearable: true,
                        onChange: (value)=>setDate(value),
                        format: $f7b3c54134be2cd2$var$dateFormat
                    })
                })
            })
        })
    });
};
var $f7b3c54134be2cd2$export$2e2bcd8739ae039 = $f7b3c54134be2cd2$var$EtfValuesList;

});


parcelRegister("4GxAn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e39ad966737f06f$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $d7fM7 = parcelRequire("d7fM7");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $ahwrv = parcelRequire("ahwrv");

var $b1v75 = parcelRequire("b1v75");

var $hsjD5 = parcelRequire("hsjD5");

var $chLJv = parcelRequire("chLJv");

var $e4eIN = parcelRequire("e4eIN");

var $2eJeT = parcelRequire("2eJeT");

var $e2ibc = parcelRequire("e2ibc");

var $daKAK = parcelRequire("daKAK");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");

var $1nz6D = parcelRequire("1nz6D");
const $6e39ad966737f06f$var$minDate = new Date(2000, 0, 1);
const $6e39ad966737f06f$var$EtfHistory = ()=>{
    const location = (0, $99w1R.useLocation)();
    const navigate = (0, $99w1R.useNavigate)();
    const locationState = location.state;
    const locationElements = location.pathname.split("/").filter((e)=>e);
    const [etfValues, setEtfValues] = (0, $bh6RR.useState)([]);
    const { data: data, loading: loading } = (0, $hjfla.useGetEtfValuesQuery)({
        variables: {
            etf_id: parseInt(locationElements[locationElements.length - 1])
        },
        fetchPolicy: "no-cache"
    });
    const [getEtf, etfData] = (0, $hjfla.useGetEtfLazyQuery)();
    const [etf, setEtf] = (0, $bh6RR.useState)(location.state || null);
    const [etfValue, setEtfValue] = (0, $bh6RR.useState)(null);
    const [openForm, setOpenForm] = (0, $bh6RR.useState)(false);
    const [filteredData, setFilteredData] = (0, $bh6RR.useState)([]);
    const [startDate, setStartDate] = (0, $bh6RR.useState)(null);
    const [endDate, setEndDate] = (0, $bh6RR.useState)(null);
    const createEtfValueSubscription = (0, $hjfla.useEtfValueCreatedSubscription)({
        variables: {
            etf_id: etf?.id || ""
        }
    });
    const updateEtfValueSubscription = (0, $hjfla.useEtfValueUpdatedSubscription)({
        variables: {
            etf_id: etf?.id || ""
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        if (!etf) getEtf({
            variables: {
                id: locationElements[locationElements.length - 1]
            }
        });
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (createEtfValueSubscription.data && createEtfValueSubscription.data?.result) addEtfValueDocument(createEtfValueSubscription.data.result);
        if (updateEtfValueSubscription.data && updateEtfValueSubscription.data?.result) {
            const updated = updateEtfValueSubscription.data?.result;
            setEtfValues(etfValues.map((v)=>v.id === updated.id ? updated : v));
            let includeInFiltered = true;
            const currentStartDate = startDate ? (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT))).utc(new Date(startDate.toISOString().split("T")[0])) : null;
            const currentEndDate = endDate ? (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT))).utc(new Date(endDate.toISOString().split("T")[0])) : null;
            if (currentStartDate) includeInFiltered = (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT))).utc(updated.date).isSameOrAfter((0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(currentStartDate));
            if (includeInFiltered && currentEndDate) includeInFiltered = (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT))).utc(updated.date).isSameOrBefore(currentEndDate);
            if (includeInFiltered) setFilteredData(filteredData.map((v)=>v.id === updated.id ? updated : v));
            else setFilteredData(filteredData.filter((v)=>v.id !== updated.id));
        }
    }, [
        createEtfValueSubscription.data,
        updateEtfValueSubscription.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (etfData.data && etfData.data.result) setEtf(etfData.data.result);
    }, [
        etfData
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (data && data.result) {
            setEtfValues(data.result);
            setFilteredData(data.result);
        }
    }, [
        data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        let filterByDate = etfValues;
        const currentStartDate = startDate ? (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT))).utc(new Date(startDate.toISOString().split("T")[0])) : null;
        const currentEndDate = endDate ? (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT))).utc(new Date(endDate.toISOString().split("T")[0])) : null;
        if (currentStartDate) filterByDate = filterByDate.filter((v)=>(0, (/*@__PURE__*/$parcel$interopDefault($2eJeT))).utc(v.date).isSameOrAfter((0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(currentStartDate)));
        if (currentEndDate) filterByDate = filterByDate.filter((v)=>(0, (/*@__PURE__*/$parcel$interopDefault($2eJeT))).utc(v.date).isSameOrBefore(currentEndDate));
        setFilteredData(filterByDate);
    }, [
        startDate,
        endDate
    ]);
    const columns = [
        {
            title: "Details",
            width: 60,
            sorting: false
        },
        {
            title: "Date",
            width: 118,
            render: (rowData)=>(0, $hsjD5.renderDateString)(rowData.date)
        },
        {
            title: "Provider",
            width: 177,
            field: "etf.provider"
        },
        {
            title: "Name",
            width: 454,
            field: "etf.name"
        },
        {
            title: "Benchmark name",
            width: 279,
            field: "etf.identifier"
        },
        {
            title: "AUM(mln)USD",
            width: 144,
            field: "aum"
        },
        {
            title: "ETF 1yr total return %",
            width: 164,
            field: "total_return_one_year"
        },
        {
            title: "Index 1yr total return %",
            width: 164,
            field: "index_total_return_one_year"
        },
        {
            title: "Etf 3yr total return %",
            width: 164,
            field: "total_return_three_year"
        },
        {
            title: "Index 3yr total return %",
            width: 164,
            field: "index_total_return_three_year"
        }
    ];
    const handleToEtfValuesOverview = ()=>{
        navigate((0, $b1v75.AuthRoutes).Etfs, {
            state: {
                ...locationState || 0
            }
        });
    };
    const handleDetails = (rowData)=>{
        setEtfValue(rowData);
        setOpenForm(true);
    };
    const handleClose = (saved, isNew, etfValue)=>{
        if (saved && isNew) addEtfValueDocument(etfValue);
        setEtfValue(null);
        setOpenForm(false);
    };
    const addEtfValueDocument = (etfValue)=>{
        const existing = etfValues.find((v)=>v.id === etfValue.id);
        if (!existing) setEtfValues([
            etfValue,
            ...etfValues
        ]);
        let addToFiltered = true;
        if (startDate) {
            const momentStart = (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT))).utc(startDate.toISOString().split("T")[0]);
            addToFiltered = (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT))).utc(etfValue.date).isSameOrAfter((0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(momentStart));
        }
        if (addToFiltered && endDate) {
            const momentEnd = (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT))).utc(endDate.toISOString().split("T")[0]);
            addToFiltered = (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT))).utc(etfValue.date).isSameOrBefore((0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(momentEnd));
        }
        if (addToFiltered) setFilteredData([
            etfValue,
            ...filteredData
        ]);
    };
    const handleExport = ()=>{
        const fileName = `${locationState?.name || "ETF Values"}${startDate ? ` from ${(0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(startDate).format("YYYY_MM_DD")}` : ""}${endDate ? ` until ${(0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(endDate).format("YYYY_MM_DD")}` : ""}`;
        const csvData = filteredData.map((r)=>({
                Date: (0, (/*@__PURE__*/$parcel$interopDefault($2eJeT)))(parseInt(r.date)).format((0, $e2ibc.DATE_TIME_FORMATS).DATE_AND_TIME),
                Provider: r.etf.provider,
                Name: r.etf.name,
                "Benchmark name": r.etf.identifier,
                "AUM(min)USD": r.aum,
                "ETF 1yr total return %": r.total_return_one_year,
                "Index 1yr total return %": r.index_total_return_one_year,
                "Etf 3yr total return %": r.total_return_three_year,
                "Index 3yr total return %": r.index_total_return_three_year
            }));
        (0, $daKAK.exportDataAsExcel)(csvData, fileName);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ahwrv.default), {
                handleToOverview: handleToEtfValuesOverview,
                navName: (0, $b1v75.RouteNames).EtfValues,
                children: etf?.name || ""
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                className: "overviewPage",
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                    className: "print\\:w-full",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $d7fM7.default), {
                            columns: columns,
                            data: filteredData || [],
                            loading: loading,
                            handleDetails: handleDetails,
                            handleRemove: ()=>console.log("Hello"),
                            pageSize: 15,
                            createButtonProps: {
                                id: "create-etf-with-values-button",
                                onClick: ()=>setOpenForm(true),
                                text: "Create",
                                disabled: false
                            },
                            exportButtonProps: {
                                id: "export-history-etfs-button",
                                onClick: ()=>handleExport()
                            },
                            importButtonProps: {
                                id: "import-history-etfs-button",
                                onClick: ()=>true
                            },
                            additionalFilters: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                                sx: {
                                    display: "flex",
                                    gap: "15px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                                        dateAdapter: (0, $1Dn8S.AdapterDateFns),
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                            id: "start-date-picker",
                                            label: "Start Date",
                                            clearable: true,
                                            minDate: $6e39ad966737f06f$var$minDate,
                                            maxDate: endDate || new Date(),
                                            value: startDate,
                                            onChange: (value)=>setStartDate(value)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                                        dateAdapter: (0, $1Dn8S.AdapterDateFns),
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                                            id: "end-date-picker",
                                            label: "End Date",
                                            clearable: true,
                                            minDate: startDate || $6e39ad966737f06f$var$minDate,
                                            maxDate: endDate || new Date(),
                                            value: endDate,
                                            onChange: (value)=>setEndDate(value)
                                        })
                                    })
                                ]
                            })
                        }),
                        openForm && /*#__PURE__*/ (0, $ih19M.jsx)((0, $1nz6D.default), {
                            handleClose: handleClose,
                            etf: etf,
                            etfValueInput: etfValue
                        })
                    ]
                })
            })
        ]
    });
};
var $6e39ad966737f06f$export$2e2bcd8739ae039 = $6e39ad966737f06f$var$EtfHistory;

});
parcelRegister("1nz6D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4895a05c05be2a1c$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hjfla = parcelRequire("hjfla");

var $chLJv = parcelRequire("chLJv");
var $idMAb = parcelRequire("idMAb");
var $gDp1O = parcelRequire("gDp1O");

var $6L9uu = parcelRequire("6L9uu");

var $e4eIN = parcelRequire("e4eIN");

var $9WP8Q = parcelRequire("9WP8Q");

var $gFVvY = parcelRequire("gFVvY");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $5PJ2i = parcelRequire("5PJ2i");

var $d13i8 = parcelRequire("d13i8");

var $1ZlXU = parcelRequire("1ZlXU");

var $1Dn8S = parcelRequire("1Dn8S");

var $91340 = parcelRequire("91340");

var $ehzwo = parcelRequire("ehzwo");
const $4895a05c05be2a1c$var$defaultErrorsObj = {
    createDate: null,
    returnOneYear: null,
    aum: null,
    indexReturnOneYear: null
};
const $4895a05c05be2a1c$var$errorTexts = {
    createDate: "Create date is required!",
    returnOneYear: "Total return is required!",
    indexReturnOneYear: "Index Total return is required!",
    aum: "AUM is required!"
};
const $4895a05c05be2a1c$var$EtfValueForm = ({ handleClose: handleClose, etf: etf, etfValueInput: etfValueInput })=>{
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const [editable, setEditable] = (0, $bh6RR.useState)(etfValueInput === null);
    const [formErrors, setFormErrors] = (0, $bh6RR.useState)($4895a05c05be2a1c$var$defaultErrorsObj);
    const [createdDate, setCreatedDate] = (0, $bh6RR.useState)(etfValueInput ? new Date(etfValueInput.date) : new Date());
    const [returnOneYear, setReturnOneYear] = (0, $bh6RR.useState)(etfValueInput?.total_return_one_year || "");
    const [aum, setAum] = (0, $bh6RR.useState)(etfValueInput?.aum || "");
    const [indexReturnOneYear, setIndexReturnOneYear] = (0, $bh6RR.useState)(etfValueInput?.index_total_return_one_year || "");
    const [returnThreeYear, setReturnThreeYear] = (0, $bh6RR.useState)(etfValueInput?.total_return_three_year || "");
    const [indexReturnThreeYear, setIndexReturnThreeYear] = (0, $bh6RR.useState)(etfValueInput?.index_total_return_three_year || "");
    const [addEtfValue, addEtfValueResult] = (0, $hjfla.useAddEtfValueMutation)();
    const [updateEtfValue, updateEtfValueResult] = (0, $hjfla.useUpdateEtfValueMutation)();
    const handleCancel = ()=>{
        if (editable && etfValueInput !== null) {
            setCreatedDate(new Date(etfValueInput.date));
            setReturnOneYear(etfValueInput.total_return_one_year);
            setAum(etfValueInput.aum);
            setIndexReturnOneYear(etfValueInput.index_total_return_one_year);
            setReturnThreeYear(etfValueInput.total_return_three_year || "");
            setIndexReturnThreeYear(etfValueInput.total_return_three_year || "");
            setFormErrors($4895a05c05be2a1c$var$defaultErrorsObj);
            setEditable(false);
        } else handleClose(false);
    };
    const handleDateChange = (input)=>{
        if (input) {
            if (!Number.isNaN(input.getDate())) setFormErrors({
                ...formErrors,
                createDate: null
            });
        } else setFormErrors({
            ...formErrors,
            createDate: $4895a05c05be2a1c$var$errorTexts.createDate
        });
        setCreatedDate(input);
    };
    const handleReturnOneYearChange = (e)=>{
        const value = e.currentTarget.value === "" ? null : Number(e.currentTarget.value);
        setFormErrors({
            ...formErrors,
            returnOneYear: value ? null : $4895a05c05be2a1c$var$errorTexts.returnOneYear
        });
        setReturnOneYear(value || "");
    };
    const handleReturnThreeYearChange = (e)=>{
        const value = e.currentTarget.value === "" ? null : Number(e.currentTarget.value);
        setReturnThreeYear(value || "");
    };
    const handleIndexReturnOneYearChange = (e)=>{
        const value = e.currentTarget.value === "" ? null : Number(e.currentTarget.value);
        setFormErrors({
            ...formErrors,
            indexReturnOneYear: value ? null : $4895a05c05be2a1c$var$errorTexts.indexReturnOneYear
        });
        setIndexReturnOneYear(value || "");
    };
    const handleIndexReturnThreeYearChange = (e)=>{
        const value = e.currentTarget.value === "" ? null : Number(e.currentTarget.value);
        setIndexReturnThreeYear(value || "");
    };
    const handleAumChange = (e)=>{
        const value = e.currentTarget.value === "" ? null : Number(e.currentTarget.value);
        setFormErrors({
            ...formErrors,
            aum: value ? null : $4895a05c05be2a1c$var$errorTexts.aum
        });
        setAum(value || "");
    };
    const handleSubmit = ()=>{
        let hasErrors = false;
        const errors = {
            returnOneYear: null,
            aum: null,
            createDate: null,
            indexReturnOneYear: null
        };
        if (!createdDate) {
            hasErrors = true;
            errors.createDate = $4895a05c05be2a1c$var$errorTexts.createDate;
        }
        if (returnOneYear === "" || Number.isNaN(returnOneYear)) {
            hasErrors = true;
            errors.returnOneYear = $4895a05c05be2a1c$var$errorTexts.returnOneYear;
        }
        if (aum === "" || Number.isNaN(aum)) {
            hasErrors = true;
            errors.aum = $4895a05c05be2a1c$var$errorTexts.aum;
        }
        if (indexReturnOneYear === "" || Number.isNaN(indexReturnOneYear)) {
            hasErrors = true;
            errors.indexReturnOneYear = $4895a05c05be2a1c$var$errorTexts.indexReturnOneYear;
        }
        if (hasErrors) setFormErrors(errors);
        else handleSave(etfValueInput === null ? "create" : "update");
    };
    const handleSave = (type)=>{
        const input = {
            date: createdDate.toString(),
            aum: aum,
            index_total_return_one_year: indexReturnOneYear,
            total_return_one_year: returnOneYear,
            index_total_return_three_year: (0, $gFVvY.getNullableNumberInput)(indexReturnThreeYear.toString()),
            total_return_three_year: (0, $gFVvY.getNullableNumberInput)(returnThreeYear.toString())
        };
        if (type === "create") addEtfValue({
            variables: {
                etf_id: etf.id,
                input: input
            },
            update (_, { data: data }) {
                const newValue = data?.result;
                handleClose(true, true, newValue);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: `Etf value added for ${newValue.date}`
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message,
                    autoHide: 6000
                }
            });
        });
        else updateEtfValue({
            variables: {
                id: etfValueInput?.id,
                input: input
            },
            update (_, { data: data }) {
                handleClose(true, false, data?.result);
                dispatch({
                    type: (0, $ayVxz.Actions).ShowMessage,
                    payload: {
                        severity: "success",
                        text: "Etf Value updated"
                    }
                });
            }
        }).catch((e)=>{
            dispatch({
                type: (0, $ayVxz.Actions).ShowMessage,
                payload: {
                    severity: "error",
                    text: e.message
                }
            });
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $5PJ2i.default), {
        id: "etf-value-form",
        width: 690,
        title: etfValueInput ? "Etf Value Details" : "Create ETF Value",
        children: [
            etfValueInput && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    textAlign: "right",
                    marginRight: "15px",
                    marginTop: "10px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $idMAb.default), {
                    id: "ftse-form-edit-button",
                    "data-testid": "ftse-form-edit-button",
                    component: (0, $gDp1O.default),
                    onClick: ()=>setEditable(true),
                    disabled: editable,
                    sx: {
                        ...(0, $6L9uu.buttons).edit,
                        fontWeight: "bold"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $9WP8Q.default), {
                            sx: {
                                fontSize: "medium",
                                color: editable ? (0, $6L9uu.Colors).gray : (0, $6L9uu.Colors).skyBlue,
                                marginRight: "3"
                            }
                        }),
                        "EDIT"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
                    gap: "35px",
                    m: "42px",
                    gridTemplateRows: "max-content"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                        dateAdapter: (0, $1Dn8S.AdapterDateFns),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                            id: "etf-date-picker",
                            label: "ETF Launch Date",
                            value: (0, $gFVvY.parseDate)(etf.launch_date),
                            disabled: true,
                            format: "dd/MM/yyyy",
                            clearable: true,
                            onChange: ()=>true,
                            sx: {
                                gridColumn: "span 6"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "etf-provider",
                        label: "ETF Provider",
                        value: etf.provider,
                        disabled: true,
                        required: true,
                        additionalStyle: {
                            gridColumn: "span 12"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "etf-name",
                        label: "ETF Name",
                        value: etf.name,
                        disabled: true,
                        required: true,
                        additionalStyle: {
                            gridColumn: "span 12"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "etf-benchmark",
                        label: "Benchmark Name",
                        required: true,
                        value: etf.identifier,
                        disabled: true,
                        additionalStyle: {
                            gridColumn: "span 12"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        sx: {
                            color: (0, $6L9uu.Colors).main,
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                            gridColumn: "span 12",
                            mb: "10px"
                        },
                        children: "ETF VALUE"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $e4eIN.LocalizationProvider), {
                        dateAdapter: (0, $1Dn8S.AdapterDateFns),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $91340.default), {
                            id: "etf-value-date-picker",
                            label: "Created Date",
                            value: createdDate,
                            disabled: !editable || addEtfValueResult.loading || updateEtfValueResult.loading,
                            format: "dd/MM/yyyy",
                            clearable: true,
                            onChange: (d)=>handleDateChange(d),
                            errorMsg: formErrors.createDate,
                            sx: {
                                gridColumn: "span 6",
                                mb: "10px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "value-aum",
                        label: "Asset Under Management USD",
                        required: true,
                        value: aum,
                        type: "number",
                        onChange: (e)=>handleAumChange(e),
                        disabled: !editable || addEtfValueResult.loading || updateEtfValueResult.loading,
                        errorMsg: formErrors.aum,
                        additionalStyle: {
                            gridColumn: "span 6"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "value-one-year-return",
                        label: "ETF 1yr total return %",
                        required: true,
                        type: "number",
                        value: returnOneYear,
                        onChange: (e)=>handleReturnOneYearChange(e),
                        disabled: !editable || addEtfValueResult.loading || updateEtfValueResult.loading,
                        errorMsg: formErrors.returnOneYear,
                        additionalStyle: {
                            gridColumn: "span 6"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "value-index-one-year-return",
                        label: "Index 1yr total return %",
                        required: true,
                        type: "number",
                        value: indexReturnOneYear,
                        onChange: (e)=>handleIndexReturnOneYearChange(e),
                        disabled: !editable || addEtfValueResult.loading || updateEtfValueResult.loading,
                        errorMsg: formErrors.indexReturnOneYear,
                        additionalStyle: {
                            gridColumn: "span 6"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "value-three-year-return",
                        label: "ETF 3yr total return %",
                        value: returnThreeYear,
                        type: "number",
                        required: true,
                        onChange: (e)=>handleReturnThreeYearChange(e),
                        disabled: !editable || addEtfValueResult.loading || updateEtfValueResult.loading,
                        additionalStyle: {
                            gridColumn: "span 6"
                        }
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $ehzwo.default), {
                        id: "value-index-three-year-return",
                        label: "Index 3yr total return %",
                        value: indexReturnThreeYear,
                        type: "number",
                        onChange: (e)=>handleIndexReturnThreeYearChange(e),
                        disabled: !editable || addEtfValueResult.loading || updateEtfValueResult.loading,
                        additionalStyle: {
                            gridColumn: "span 6"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                className: "centralize",
                sx: {
                    marginTop: "50px",
                    mb: "50px"
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $d13i8.default), {
                        id: "cancel-etf-value-button",
                        "data-testid": "cancel-etf-value-button",
                        disabled: addEtfValueResult.loading || updateEtfValueResult.loading,
                        onClick: handleCancel,
                        text: etfValueInput === null || editable ? "Cancel" : "Close"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1ZlXU.default), {
                        id: "save-etf-value-button",
                        "data-testid": "save-etf-value-button",
                        disabled: !editable || addEtfValueResult.loading || updateEtfValueResult.loading,
                        onClick: handleSubmit,
                        text: etfValueInput === null ? "Create" : "Save"
                    })
                ]
            })
        ]
    });
};
var $4895a05c05be2a1c$export$2e2bcd8739ae039 = $4895a05c05be2a1c$var$EtfValueForm;

});


parcelRegister("lB0Ec", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("b6BCP").then(()=>parcelRequire("jIZSw"));

});

parcelRegister("1C9E3", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("jAwyO").then(()=>parcelRequire("8S5xT"));

});

parcelRegister("hWn17", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("dmxXW").then(()=>parcelRequire("eNgIK"));

});

parcelRegister("e7VFN", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("cCN1W").then(()=>parcelRequire("hH6Pg"));

});

parcelRegister("ew2iK", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("5WBjo").then(()=>parcelRequire("98DU8"));

});




var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $10WBQ = parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $bu31C = parcelRequire("bu31C");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
function $460ce94dc26906c4$var$e(e) {
    this.message = e;
}
$460ce94dc26906c4$var$e.prototype = new Error, $460ce94dc26906c4$var$e.prototype.name = "InvalidCharacterError";
var $460ce94dc26906c4$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $460ce94dc26906c4$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $460ce94dc26906c4$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($460ce94dc26906c4$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $460ce94dc26906c4$var$r(t);
    }
}
function $460ce94dc26906c4$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $460ce94dc26906c4$var$o(e, r) {
    if ("string" != typeof e) throw new $460ce94dc26906c4$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($460ce94dc26906c4$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $460ce94dc26906c4$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$460ce94dc26906c4$export$b9721ef022f71a68.prototype = new Error, $460ce94dc26906c4$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $460ce94dc26906c4$export$2e2bcd8739ae039 = $460ce94dc26906c4$var$o;



var $bu31C = parcelRequire("bu31C");

var $aM783 = parcelRequire("aM783");

var $ayVxz = parcelRequire("ayVxz");

var $8d818 = parcelRequire("8d818");
const $0e3217453550f778$var$Auth = (props)=>{
    const [waitAuthCheck, setWaitAuthCheck] = (0, $bh6RR.useState)(true);
    const { dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    (0, $bh6RR.useEffect)(()=>{
        const token = localStorage.getItem((0, $aM783.AppConsts).AccessToken);
        if (!token) // context remove user
        dispatch({
            type: (0, $ayVxz.Actions).RemoveUser
        });
        else {
            const decoded = (0, $460ce94dc26906c4$export$2e2bcd8739ae039)(token);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            const { role: role } = decoded;
            const now = new Date().getTime() / 1000;
            if (decoded.exp < now) {
                // if is not valid -> context remove user
                localStorage.removeItem((0, $aM783.AppConsts).AccessToken);
                dispatch({
                    type: (0, $ayVxz.Actions).RemoveUser
                });
            } else {
                const roles = [];
                if (role) {
                    if (typeof role === "string" || role instanceof String) roles.push(role);
                    else role.map((r)=>roles.push(r));
                }
                dispatch({
                    type: (0, $ayVxz.Actions).SetUser,
                    payload: {
                        data: {
                            id: decoded.id,
                            username: decoded.username,
                            roles: decoded.roles,
                            first_name: "",
                            last_name: "",
                            password: ""
                        },
                        token: token
                    }
                });
            }
        }
        setWaitAuthCheck(false);
    }, []);
    return waitAuthCheck ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d818.default), {
        loading: waitAuthCheck
    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $bh6RR.Fragment), {
        children: props.children
    });
};
var $0e3217453550f778$export$2e2bcd8739ae039 = $0e3217453550f778$var$Auth;



var $ih19M = parcelRequire("ih19M");


var $bh6RR = parcelRequire("bh6RR");

var $99w1R = parcelRequire("99w1R");parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");

var $aM783 = parcelRequire("aM783");

var $b1v75 = parcelRequire("b1v75");

var $chLJv = parcelRequire("chLJv");
var $lC4lc = parcelRequire("lC4lc");
const $58748985749d7181$var$AuthRoute = ({ Component: Component, isPublic: isPublic, requiredRole: requiredRole })=>{
    const { state: state, dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const location = (0, $99w1R.useLocation)();
    const navigate = (0, $99w1R.useNavigate)();
    const redirectToSignIn = ()=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Navigate), {
            to: {
                pathname: (0, $b1v75.PublicRoutes).Login
            },
            replace: true,
            state: {
                path: location.pathname
            }
        });
    const navigateToLogin = ()=>{
        if (!isPublic) navigate((0, $b1v75.PublicRoutes).Login, {
            state: {
                path: location.pathname
            }
        });
    };
    (0, $bh6RR.useEffect)(()=>{
        const token = localStorage.getItem((0, $aM783.AppConsts).AccessToken);
        if (!token) {
            dispatch({
                type: (0, $ayVxz.Actions).RemoveUser
            });
            navigateToLogin();
        } else {
            const decoded = (0, $460ce94dc26906c4$export$2e2bcd8739ae039)(token);
            const now = new Date().getTime() / 1000;
            if (decoded.exp < now) {
                localStorage.removeItem((0, $aM783.AppConsts).AccessToken);
                dispatch({
                    type: (0, $ayVxz.Actions).RemoveUser
                });
                navigateToLogin();
            }
        }
    }, [
        location
    ]);
    const isAuthed = isPublic ? true : state.user.token !== null;
    const userRoles = state.user.data ? state.user.data.roles : [];
    const accessGranted = requiredRole ? userRoles.includes(requiredRole) : true;
    const renderComponent = ()=>{
        // Check if Component is a lazy component (LazyExoticComponent has _payload property)
        const isLazyComponent = Component && typeof Component === "object" && "_payload" in Component;
        const componentElement = /*#__PURE__*/ (0, $ih19M.jsx)(Component, {});
        // Wrap lazy components in Suspense, regular components can also be wrapped safely
        if (isLazyComponent) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $bh6RR.Suspense), {
            fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lC4lc.default), {})
            }),
            children: componentElement
        });
        return componentElement;
    };
    return isAuthed ? accessGranted ? renderComponent() : redirectToSignIn() : redirectToSignIn();
};
var $58748985749d7181$export$2e2bcd8739ae039 = $58748985749d7181$var$AuthRoute;



var $b1v75 = parcelRequire("b1v75");

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");
parcelRequire("bh6RR");


var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");



var $1mHbS = parcelRequire("1mHbS");

var $fwLjQ = parcelRequire("fwLjQ");

var $jIarf = parcelRequire("jIarf");

var $ih19M = parcelRequire("ih19M");
function $d05793fc0c5d61ec$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $4WYaH.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $d05793fc0c5d61ec$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $fwLjQ.default)();
    const theme = $bh6RR.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $d05793fc0c5d61ec$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $jIarf.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1mHbS.default).Provider, {
        value: theme,
        children: children
    });
}
var $d05793fc0c5d61ec$export$2e2bcd8739ae039 = $d05793fc0c5d61ec$var$ThemeProvider;


var $fwLjQ = parcelRequire("fwLjQ");

parcelRequire("fPZvG");
var $k0FAg = parcelRequire("k0FAg");

var $hDooL = parcelRequire("hDooL");

var $ih19M = parcelRequire("ih19M");
"use client";
const $8071c4251b77a7d7$var$EMPTY_THEME = {};
function $8071c4251b77a7d7$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $bh6RR.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $4WYaH.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $4WYaH.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $4WYaH.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $8071c4251b77a7d7$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $hDooL.default)($8071c4251b77a7d7$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $fwLjQ.default)() || $8071c4251b77a7d7$var$EMPTY_THEME;
    const engineTheme = $8071c4251b77a7d7$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $8071c4251b77a7d7$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $d05793fc0c5d61ec$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $k0FAg.T).Provider, {
            value: engineTheme,
            children: children
        })
    });
}
var $8071c4251b77a7d7$export$2e2bcd8739ae039 = $8071c4251b77a7d7$var$ThemeProvider;



var $wllwT = parcelRequire("wllwT");

var $ih19M = parcelRequire("ih19M");
"use client";
const $82ee3221eaadbd63$var$_excluded = [
    "theme"
];
function $82ee3221eaadbd63$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $hCIyK.default)(_ref, $82ee3221eaadbd63$var$_excluded);
    const scopedTheme = themeInput[0, $wllwT.default];
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8071c4251b77a7d7$export$2e2bcd8739ae039), (0, $4WYaH.default)({}, props, {
        themeId: scopedTheme ? (0, $wllwT.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}



var $6L9uu = parcelRequire("6L9uu");

var $chLJv = parcelRequire("chLJv");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
var $4fae9887581a8845$exports = {};
$4fae9887581a8845$exports = new URL("logo_white.6fc7eb81.svg", import.meta.url).toString();



var $bu31C = parcelRequire("bu31C");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $b1v75 = parcelRequire("b1v75");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $chLJv = parcelRequire("chLJv");
var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $bLFa3 = parcelRequire("bLFa3");

var $7J7Kn = parcelRequire("7J7Kn");



var $cG3EF = parcelRequire("cG3EF");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $aEoM0 = parcelRequire("aEoM0");

var $jg59e = parcelRequire("jg59e");

var $iWGrV = parcelRequire("iWGrV");

var $erAkb = parcelRequire("erAkb");

var $goHq9 = parcelRequire("goHq9");

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $e46df656ff3b9df7$export$5682c366c0c669d9(slot) {
    return (0, $XybB6.default)("MuiListItem", slot);
}
const $e46df656ff3b9df7$var$listItemClasses = (0, $igcUF.default)("MuiListItem", [
    "root",
    "container",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "padding",
    "button",
    "secondaryAction",
    "selected"
]);
var $e46df656ff3b9df7$export$2e2bcd8739ae039 = $e46df656ff3b9df7$var$listItemClasses;



var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $fa79bb8eebf9c8d2$export$c09531d8563c67a5(slot) {
    return (0, $XybB6.default)("MuiListItemButton", slot);
}
const $fa79bb8eebf9c8d2$var$listItemButtonClasses = (0, $igcUF.default)("MuiListItemButton", [
    "root",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $fa79bb8eebf9c8d2$export$2e2bcd8739ae039 = $fa79bb8eebf9c8d2$var$listItemButtonClasses;



var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $goHq9 = parcelRequire("goHq9");

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $d3666f4383d3a06f$export$ccdb26aeba48a86e(slot) {
    return (0, $XybB6.default)("MuiListItemSecondaryAction", slot);
}
const $d3666f4383d3a06f$var$listItemSecondaryActionClasses = (0, $igcUF.default)("MuiListItemSecondaryAction", [
    "root",
    "disableGutters"
]);
var $d3666f4383d3a06f$export$2e2bcd8739ae039 = $d3666f4383d3a06f$var$listItemSecondaryActionClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $57fbffc9565e8bee$var$_excluded = [
    "className"
];
const $57fbffc9565e8bee$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $d3666f4383d3a06f$export$ccdb26aeba48a86e), classes);
};
const $57fbffc9565e8bee$var$ListItemSecondaryActionRoot = (0, $g4l1t.default)("div", {
    name: "MuiListItemSecondaryAction",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        position: "absolute",
        right: 16,
        top: "50%",
        transform: "translateY(-50%)"
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $57fbffc9565e8bee$var$ListItemSecondaryAction = /*#__PURE__*/ $bh6RR.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiListItemSecondaryAction"
    });
    const { className: className } = props, other = (0, $hCIyK.default)(props, $57fbffc9565e8bee$var$_excluded);
    const context = $bh6RR.useContext((0, $goHq9.default));
    const ownerState = (0, $4WYaH.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $57fbffc9565e8bee$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($57fbffc9565e8bee$var$ListItemSecondaryActionRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$57fbffc9565e8bee$var$ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
var $57fbffc9565e8bee$export$2e2bcd8739ae039 = $57fbffc9565e8bee$var$ListItemSecondaryAction;



var $ih19M = parcelRequire("ih19M");
"use client";
const $b01e1a0b62498cf8$var$_excluded = [
    "className"
], $b01e1a0b62498cf8$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $b01e1a0b62498cf8$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $b01e1a0b62498cf8$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            !disablePadding && "padding",
            divider && "divider",
            disabled && "disabled",
            button && "button",
            alignItems === "flex-start" && "alignItemsFlexStart",
            hasSecondaryAction && "secondaryAction",
            selected && "selected"
        ],
        container: [
            "container"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $e46df656ff3b9df7$export$5682c366c0c669d9), classes);
};
const $b01e1a0b62498cf8$export$aed538f7519abe89 = (0, $g4l1t.default)("div", {
    name: "MuiListItem",
    slot: "Root",
    overridesResolver: $b01e1a0b62498cf8$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "left"
    }, !ownerState.disablePadding && (0, $4WYaH.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $fa79bb8eebf9c8d2$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $e46df656ff3b9df7$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $e46df656ff3b9df7$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cG3EF.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $e46df656ff3b9df7$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cG3EF.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $e46df656ff3b9df7$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.button && {
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $e46df656ff3b9df7$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $cG3EF.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cG3EF.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $b01e1a0b62498cf8$var$ListItemContainer = (0, $g4l1t.default)("li", {
    name: "MuiListItem",
    slot: "Container",
    overridesResolver: (props, styles)=>styles.container
})({
    position: "relative"
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $b01e1a0b62498cf8$var$ListItem = /*#__PURE__*/ $bh6RR.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiListItem"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = "li", ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $hCIyK.default)(props.ContainerProps, $b01e1a0b62498cf8$var$_excluded), other = (0, $hCIyK.default)(props, $b01e1a0b62498cf8$var$_excluded2);
    const context = $bh6RR.useContext((0, $goHq9.default));
    const childContext = $bh6RR.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $bh6RR.useRef(null);
    (0, $iWGrV.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $bh6RR.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $jg59e.default)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    const ownerState = (0, $4WYaH.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $b01e1a0b62498cf8$var$useUtilityClasses(ownerState);
    const handleRef = (0, $erAkb.default)(listItemRef, ref);
    const Root = slots.root || components.Root || $b01e1a0b62498cf8$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $aPsoC.default)((0, $e46df656ff3b9df7$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $aEoM0.default);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $goHq9.default).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $ih19M.jsxs)($b01e1a0b62498cf8$var$ListItemContainer, (0, $4WYaH.default)({
                as: ContainerComponent,
                className: (0, $aPsoC.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)(Root, (0, $4WYaH.default)({}, rootProps, !(0, $bLFa3.isHostComponent)(Root) && {
                        as: Component,
                        ownerState: (0, $4WYaH.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $goHq9.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)(Root, (0, $4WYaH.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $bLFa3.isHostComponent)(Root) && {
            ownerState: (0, $4WYaH.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $ih19M.jsx)((0, $57fbffc9565e8bee$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $b01e1a0b62498cf8$export$2e2bcd8739ae039 = $b01e1a0b62498cf8$var$ListItem;


var $35wch = parcelRequire("35wch");
var $aitry = parcelRequire("aitry");

var $lGCck = parcelRequire("lGCck");

var $6L9uu = parcelRequire("6L9uu");
const $b2540f35ed96ba8e$var$useStyles = (0, $lGCck.default)(()=>{
    return {
        item: {
            height: 39,
            width: 166,
            paddingRight: 12,
            paddingLeft: 15,
            "&$selected": {
                height: 41,
                backgroundColor: (0, $6L9uu.Colors).third,
                borderRadius: "0px 100px 100px 0px",
                "&:hover": {
                    height: 41,
                    backgroundColor: (0, $6L9uu.Colors).third,
                    borderRadius: "0px 100px 100px 0px"
                }
            },
            "&:hover": {
                height: 39,
                backgroundColor: (0, $6L9uu.Colors).third,
                borderRadius: "0px 100px 100px 0px"
            }
        },
        itemClosed: {
            height: 32,
            width: 32,
            marginLeft: 14,
            marginTop: 3.5,
            marginBottom: 3.5,
            "&$selected": {
                backgroundColor: (0, $6L9uu.Colors).third,
                borderRadius: "100px",
                "&:hover": {
                    backgroundColor: (0, $6L9uu.Colors).third,
                    borderRadius: "100px"
                }
            },
            "&:hover": {
                backgroundColor: (0, $6L9uu.Colors).third,
                borderRadius: "100px"
            }
        },
        nestedItem: {
            height: 28,
            width: 166,
            paddingRight: 12,
            paddingLeft: 15,
            "&$selected": {
                height: 28,
                backgroundColor: (0, $6L9uu.Colors).third,
                borderRadius: "0px 100px 100px 0px",
                "&:hover": {
                    height: 28,
                    backgroundColor: (0, $6L9uu.Colors).third,
                    borderRadius: "0px 100px 100px 0px"
                }
            },
            "&:hover": {
                height: 28,
                backgroundColor: (0, $6L9uu.Colors).third,
                borderRadius: "0px 100px 100px 0px"
            }
        },
        nestedItemClosed: {
            height: 28,
            width: 32,
            marginLeft: 14,
            marginTop: 3.5,
            marginBottom: 3.5,
            "&$selected": {
                backgroundColor: (0, $6L9uu.Colors).third,
                borderRadius: "100px",
                "&:hover": {
                    backgroundColor: (0, $6L9uu.Colors).third,
                    borderRadius: "100px"
                }
            },
            "&:hover": {
                backgroundColor: (0, $6L9uu.Colors).third,
                borderRadius: "100px"
            }
        }
    };
});
const $b2540f35ed96ba8e$var$NavItem = (props)=>{
    const { route: route, handleSelectedChanged: handleSelectedChanged, selected: selected, open: open, nested: nested } = props;
    const itemClick = (e, path)=>{
        e.stopPropagation();
        handleSelectedChanged(path);
    };
    const getId = ()=>`${route.name.replaceAll(" ", "-")}-Button`;
    const isSelected = ()=>selected == route.path;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $b01e1a0b62498cf8$export$2e2bcd8739ae039), {
        id: getId(),
        "data-testid": getId(),
        selected: isSelected(),
        sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: open ? "left" : "center",
            height: nested ? "28px" : isSelected() && open ? "42px" : !open ? "32px" : "40px",
            paddingX: open ? "14px" : "12px",
            paddingLeft: nested && open ? "40px" : open ? "14px" : "12px",
            marginRight: "14px",
            marginY: !open ? "4px" : 0,
            cursor: "pointer",
            "&.Mui-selected, &:hover": {
                backgroundColor: (0, $6L9uu.Colors).third,
                borderRadius: open ? "0px 100px 100px 0px" : "100px"
            }
        },
        disableGutters: true,
        onClick: (e)=>itemClick(e, route.path),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $35wch.default), {
                component: route.icon,
                sx: {
                    color: "common.white"
                }
            }),
            open && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                sx: {
                    color: (0, $6L9uu.Colors).white,
                    margin: 0,
                    marginLeft: "8px",
                    fontWeight: 400
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), {
                    style: {
                        fontSize: nested ? "12px" : "1rem"
                    },
                    children: route.name
                })
            })
        ]
    }, route.name);
};
var $b2540f35ed96ba8e$export$2e2bcd8739ae039 = $b2540f35ed96ba8e$var$NavItem;



var $6L9uu = parcelRequire("6L9uu");

var $ih19M = parcelRequire("ih19M");

var $ePpmI = parcelRequire("ePpmI");
parcelRequire("bh6RR");

var $6L9uu = parcelRequire("6L9uu");
const $ab5065636f25ce73$var$NavDivider = ({ open: open })=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePpmI.default), {
        sx: {
            backgroundColor: (0, $6L9uu.Colors).third,
            marginLeft: open ? "14px" : "-2px",
            marginRight: open ? 0 : "-2px"
        }
    });
};
var $ab5065636f25ce73$export$2e2bcd8739ae039 = $ab5065636f25ce73$var$NavDivider;



var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $aPsoC = parcelRequire("aPsoC");


var $7ARPd = parcelRequire("7ARPd");

var $edgJc = parcelRequire("edgJc");


var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $4SKzm = parcelRequire("4SKzm");

var $6SHzw = parcelRequire("6SHzw");

var $8gyMY = parcelRequire("8gyMY");

var $erAkb = parcelRequire("erAkb");

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $aa6491b166a27fad$export$5162da8f798e0959(slot) {
    return (0, $XybB6.default)("MuiCollapse", slot);
}
const $aa6491b166a27fad$var$collapseClasses = (0, $igcUF.default)("MuiCollapse", [
    "root",
    "horizontal",
    "vertical",
    "entered",
    "hidden",
    "wrapper",
    "wrapperInner"
]);
var $aa6491b166a27fad$export$2e2bcd8739ae039 = $aa6491b166a27fad$var$collapseClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $740bd5479384010b$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $740bd5479384010b$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${orientation}`
        ],
        entered: [
            "entered"
        ],
        hidden: [
            "hidden"
        ],
        wrapper: [
            "wrapper",
            `${orientation}`
        ],
        wrapperInner: [
            "wrapperInner",
            `${orientation}`
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $aa6491b166a27fad$export$5162da8f798e0959), classes);
};
const $740bd5479384010b$var$CollapseRoot = (0, $g4l1t.default)("div", {
    name: "MuiCollapse",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === "entered" && styles.entered,
            ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        height: 0,
        overflow: "hidden",
        transition: theme.transitions.create("height")
    }, ownerState.orientation === "horizontal" && {
        height: "auto",
        width: 0,
        transition: theme.transitions.create("width")
    }, ownerState.state === "entered" && (0, $4WYaH.default)({
        height: "auto",
        overflow: "visible"
    }, ownerState.orientation === "horizontal" && {
        width: "auto"
    }), ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && {
        visibility: "hidden"
    }));
const $740bd5479384010b$var$CollapseWrapper = (0, $g4l1t.default)("div", {
    name: "MuiCollapse",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: "flex",
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
const $740bd5479384010b$var$CollapseWrapperInner = (0, $g4l1t.default)("div", {
    name: "MuiCollapse",
    slot: "WrapperInner",
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $740bd5479384010b$var$Collapse = /*#__PURE__*/ $bh6RR.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiCollapse"
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = "0px", component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = "vertical", style: style, timeout: timeout = (0, $4SKzm.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $7ARPd.default) } = props, other = (0, $hCIyK.default)(props, $740bd5479384010b$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $740bd5479384010b$var$useUtilityClasses(ownerState);
    const theme = (0, $8gyMY.default)();
    const timer = (0, $edgJc.default)();
    const wrapperRef = $bh6RR.useRef(null);
    const autoTransitionDuration = $bh6RR.useRef();
    const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === "horizontal";
    const size = isHorizontal ? "width" : "height";
    const nodeRef = $bh6RR.useRef(null);
    const handleRef = (0, $erAkb.default)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? "clientWidth" : "clientHeight"] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = "absolute";
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = "";
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $6SHzw.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        if (timeout === "auto") {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $6SHzw.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        if (timeout === "auto") {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $ih19M.jsx)($740bd5479384010b$var$CollapseRoot, (0, $4WYaH.default)({
                as: component,
                className: (0, $aPsoC.default)(classes.root, className, {
                    "entered": classes.entered,
                    "exited": !inProp && collapsedSize === "0px" && classes.hidden
                }[state]),
                style: (0, $4WYaH.default)({
                    [isHorizontal ? "minWidth" : "minHeight"]: collapsedSize
                }, style),
                ref: handleRef
            }, childProps, {
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: (0, $4WYaH.default)({}, ownerState, {
                    state: state
                }),
                children: /*#__PURE__*/ (0, $ih19M.jsx)($740bd5479384010b$var$CollapseWrapper, {
                    ownerState: (0, $4WYaH.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)($740bd5479384010b$var$CollapseWrapperInner, {
                        ownerState: (0, $4WYaH.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$740bd5479384010b$var$Collapse.muiSupportAuto = true;
var $740bd5479384010b$export$2e2bcd8739ae039 = $740bd5479384010b$var$Collapse;


var $17TrO = parcelRequire("17TrO");
var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $aitry = parcelRequire("aitry");

var $goHq9 = parcelRequire("goHq9");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $dQhw4 = parcelRequire("dQhw4");

var $ih19M = parcelRequire("ih19M");
"use client";
const $3f5925dd58c3e26e$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $3f5925dd58c3e26e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $dQhw4.getListItemTextUtilityClass), classes);
};
const $3f5925dd58c3e26e$var$ListItemTextRoot = (0, $g4l1t.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $dQhw4.default).primary}`]: styles.primary
            },
            {
                [`& .${(0, $dQhw4.default).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $4WYaH.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $3f5925dd58c3e26e$var$ListItemText = /*#__PURE__*/ $bh6RR.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $hCIyK.default)(props, $3f5925dd58c3e26e$var$_excluded);
    const { dense: dense } = $bh6RR.useContext((0, $goHq9.default));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $4WYaH.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $3f5925dd58c3e26e$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $aitry.default) && !disableTypography) primary = /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), (0, $4WYaH.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $aitry.default) && !disableTypography) secondary = /*#__PURE__*/ (0, $ih19M.jsx)((0, $aitry.default), (0, $4WYaH.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $ih19M.jsxs)($3f5925dd58c3e26e$var$ListItemTextRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $3f5925dd58c3e26e$export$2e2bcd8739ae039 = $3f5925dd58c3e26e$var$ListItemText;


var $35wch = parcelRequire("35wch");

var $fQfP9 = parcelRequire("fQfP9");
var $3OBHq = parcelRequire("3OBHq");
const $fe5091616e61e343$var$GroupItemsLink = (props)=>{
    const { route: route, handleSelectedChanged: handleSelectedChanged, selected: selected, open: open } = props;
    //const classes = useStyles();
    const [openSubroutes, setOpenSubroutes] = (0, $bh6RR.useState)(false);
    const handleClick = (e)=>{
        e.stopPropagation();
        setOpenSubroutes(!openSubroutes);
    };
    const getId = ()=>`${route.name.replaceAll(" ", "-")}-Button`;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $b01e1a0b62498cf8$export$2e2bcd8739ae039), {
                id: getId(),
                "data-testid": getId(),
                button: true,
                onClick: (e)=>handleClick(e),
                disableGutters: true,
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: open ? "left" : "center",
                    height: "40px",
                    paddingLeft: open ? "14px" : 0
                },
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $35wch.default), {
                        component: route.icon,
                        sx: {
                            color: "common.white"
                        }
                    }),
                    open && /*#__PURE__*/ (0, $ih19M.jsx)((0, $3f5925dd58c3e26e$export$2e2bcd8739ae039), {
                        id: route.name,
                        style: {
                            color: (0, $6L9uu.Colors).white,
                            margin: "8px"
                        },
                        primary: route.name
                    }),
                    open ? openSubroutes ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $fQfP9.default), {
                        style: {
                            color: (0, $6L9uu.Colors).white
                        }
                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $3OBHq.default), {
                        style: {
                            color: (0, $6L9uu.Colors).white
                        }
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $ab5065636f25ce73$export$2e2bcd8739ae039), {
                open: open
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $740bd5479384010b$export$2e2bcd8739ae039), {
                in: openSubroutes,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $17TrO.default), {
                    component: "div",
                    disablePadding: true,
                    children: route.subRoutes?.map((sr)=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $b2540f35ed96ba8e$export$2e2bcd8739ae039), {
                                    handleSelectedChanged: handleSelectedChanged,
                                    selected: selected,
                                    open: open,
                                    route: sr,
                                    nested: true
                                }, sr.id),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $ab5065636f25ce73$export$2e2bcd8739ae039), {
                                    open: open
                                })
                            ]
                        }, sr.name + sr.id))
                })
            })
        ]
    });
};
var $fe5091616e61e343$export$2e2bcd8739ae039 = $fe5091616e61e343$var$GroupItemsLink;




var $bu31C = parcelRequire("bu31C");

var $chLJv = parcelRequire("chLJv");

const $f693df3f18fd5181$var$ListItemLink = (props)=>{
    const { route: route, selected: selected, open: open, userRoles: userRoles, handleSelectedChanged: handleSelectedChanged } = props;
    const { state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const hasAccess = route.requiredRole ? userRoles?.includes(route.requiredRole) : true;
    const appRoutes = [];
    state.routes.forEach((r)=>{
        r.subRoutes ? r.subRoutes.forEach((sr)=>appRoutes.push(sr)) : appRoutes.push(r);
    });
    const routes = appRoutes.filter((r)=>r.showInNav).map((re)=>re.path);
    if (!hasAccess) return null;
    const showTopDivider = (route)=>{
        const { path: path } = route;
        if (open && path && path !== selected && routes.indexOf(path) === 0 || !open && path && routes.indexOf(path) === 0) return divider();
        const subRouteIndex = route.subRoutes?.findIndex((r)=>r.path === selected);
        if (open && !route.path && subRouteIndex === 0) return divider();
    };
    const showBottomDivider = (route)=>{
        const { path: path } = route;
        if (!open && path) return divider();
        if (path && path !== selected && routes.indexOf(selected) - 1 !== routes.indexOf(path) || path && path !== selected && routes.indexOf(path) === routes.length - 2) return divider();
    };
    const divider = ()=>{
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ab5065636f25ce73$export$2e2bcd8739ae039), {
            open: open
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
        sx: {
            marginRight: "14px",
            marginLeft: !open ? "14px" : 0
        },
        children: [
            showTopDivider(route),
            route.type === (0, $b1v75.NavElements).Group ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $fe5091616e61e343$export$2e2bcd8739ae039), {
                handleSelectedChanged: handleSelectedChanged,
                open: open,
                route: route,
                selected: selected
            }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $b2540f35ed96ba8e$export$2e2bcd8739ae039), {
                handleSelectedChanged: handleSelectedChanged,
                selected: selected,
                open: open,
                route: route
            }, route.id),
            showBottomDivider(route)
        ]
    });
};
var $f693df3f18fd5181$export$2e2bcd8739ae039 = $f693df3f18fd5181$var$ListItemLink;



var $hjfla = parcelRequire("hjfla");

var $ayVxz = parcelRequire("ayVxz");

var $6L9uu = parcelRequire("6L9uu");

var $gFVvY = parcelRequire("gFVvY");

var $aM783 = parcelRequire("aM783");

var $chLJv = parcelRequire("chLJv");
var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");


var $7J7Kn = parcelRequire("7J7Kn");

var $cXsrx = parcelRequire("cXsrx");

var $hVuP7 = parcelRequire("hVuP7");

var $iTI7v = parcelRequire("iTI7v");

var $fGH8N = parcelRequire("fGH8N");

var $8gyMY = parcelRequire("8gyMY");

var $cNBED = parcelRequire("cNBED");

var $g4l1t = parcelRequire("g4l1t");

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $6ed8c3e00b3be6b4$export$b801318a856c9cd2(slot) {
    return (0, $XybB6.default)("MuiDrawer", slot);
}
const $6ed8c3e00b3be6b4$var$drawerClasses = (0, $igcUF.default)("MuiDrawer", [
    "root",
    "docked",
    "paper",
    "paperAnchorLeft",
    "paperAnchorRight",
    "paperAnchorTop",
    "paperAnchorBottom",
    "paperAnchorDockedLeft",
    "paperAnchorDockedRight",
    "paperAnchorDockedTop",
    "paperAnchorDockedBottom",
    "modal"
]);
var $6ed8c3e00b3be6b4$export$2e2bcd8739ae039 = $6ed8c3e00b3be6b4$var$drawerClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $647db7f93e4c52c9$var$_excluded = [
    "BackdropProps"
], $647db7f93e4c52c9$var$_excluded2 = [
    "anchor",
    "BackdropProps",
    "children",
    "className",
    "elevation",
    "hideBackdrop",
    "ModalProps",
    "onClose",
    "open",
    "PaperProps",
    "SlideProps",
    "TransitionComponent",
    "transitionDuration",
    "variant"
];
const $647db7f93e4c52c9$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === "permanent" || ownerState.variant === "persistent") && styles.docked,
        styles.modal
    ];
};
const $647db7f93e4c52c9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        docked: [
            (variant === "permanent" || variant === "persistent") && "docked"
        ],
        modal: [
            "modal"
        ],
        paper: [
            "paper",
            `paperAnchor${(0, $fGH8N.default)(anchor)}`,
            variant !== "temporary" && `paperAnchorDocked${(0, $fGH8N.default)(anchor)}`
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $6ed8c3e00b3be6b4$export$b801318a856c9cd2), classes);
};
const $647db7f93e4c52c9$var$DrawerRoot = (0, $g4l1t.default)((0, $cXsrx.default), {
    name: "MuiDrawer",
    slot: "Root",
    overridesResolver: $647db7f93e4c52c9$var$overridesResolver
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    }));
const $647db7f93e4c52c9$var$DrawerDockedRoot = (0, $g4l1t.default)("div", {
    shouldForwardProp: (0, $g4l1t.rootShouldForwardProp),
    name: "MuiDrawer",
    slot: "Docked",
    skipVariantsResolver: false,
    overridesResolver: $647db7f93e4c52c9$var$overridesResolver
})({
    flex: "0 0 auto"
});
const $647db7f93e4c52c9$var$DrawerPaper = (0, $g4l1t.default)((0, $iTI7v.default), {
    name: "MuiDrawer",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $fGH8N.default)(ownerState.anchor)}`],
            ownerState.variant !== "temporary" && styles[`paperAnchorDocked${(0, $fGH8N.default)(ownerState.anchor)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        flex: "1 0 auto",
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        // temporary style
        position: "fixed",
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0
    }, ownerState.anchor === "left" && {
        left: 0
    }, ownerState.anchor === "top" && {
        top: 0,
        left: 0,
        right: 0,
        height: "auto",
        maxHeight: "100%"
    }, ownerState.anchor === "right" && {
        right: 0
    }, ownerState.anchor === "bottom" && {
        top: "auto",
        left: 0,
        bottom: 0,
        right: 0,
        height: "auto",
        maxHeight: "100%"
    }, ownerState.anchor === "left" && ownerState.variant !== "temporary" && {
        borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "top" && ownerState.variant !== "temporary" && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "right" && ownerState.variant !== "temporary" && {
        borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "bottom" && ownerState.variant !== "temporary" && {
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $647db7f93e4c52c9$var$oppositeDirection = {
    left: "right",
    right: "left",
    top: "down",
    bottom: "up"
};
function $647db7f93e4c52c9$export$2a62b49acb270576(anchor) {
    return [
        "left",
        "right"
    ].indexOf(anchor) !== -1;
}
function $647db7f93e4c52c9$export$830f4f08342d299e(theme, anchor) {
    return theme.direction === "rtl" && $647db7f93e4c52c9$export$2a62b49acb270576(anchor) ? $647db7f93e4c52c9$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $647db7f93e4c52c9$var$Drawer = /*#__PURE__*/ $bh6RR.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiDrawer"
    });
    const theme = (0, $8gyMY.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = "left", BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $hVuP7.default), transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = "temporary" } = props, ModalProps = (0, $hCIyK.default)(props.ModalProps, $647db7f93e4c52c9$var$_excluded), other = (0, $hCIyK.default)(props, $647db7f93e4c52c9$var$_excluded2);
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $bh6RR.useRef(false);
    $bh6RR.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $647db7f93e4c52c9$export$830f4f08342d299e(theme, anchorProp);
    const anchor = anchorProp;
    const ownerState = (0, $4WYaH.default)({}, props, {
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant
    }, other);
    const classes = $647db7f93e4c52c9$var$useUtilityClasses(ownerState);
    const drawer = /*#__PURE__*/ (0, $ih19M.jsx)($647db7f93e4c52c9$var$DrawerPaper, (0, $4WYaH.default)({
        elevation: variant === "temporary" ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, $aPsoC.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        children: children
    }));
    if (variant === "permanent") return /*#__PURE__*/ (0, $ih19M.jsx)($647db7f93e4c52c9$var$DrawerDockedRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: drawer
    }));
    const slidingDrawer = /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
        in: open,
        direction: $647db7f93e4c52c9$var$oppositeDirection[anchorInvariant],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps, {
        children: drawer
    }));
    if (variant === "persistent") return /*#__PURE__*/ (0, $ih19M.jsx)($647db7f93e4c52c9$var$DrawerDockedRoot, (0, $4WYaH.default)({
        className: (0, $aPsoC.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: slidingDrawer
    }));
    // variant === temporary
    return /*#__PURE__*/ (0, $ih19M.jsx)($647db7f93e4c52c9$var$DrawerRoot, (0, $4WYaH.default)({
        BackdropProps: (0, $4WYaH.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration: transitionDuration
        }),
        className: (0, $aPsoC.default)(classes.root, classes.modal, className),
        open: open,
        ownerState: ownerState,
        onClose: onClose,
        hideBackdrop: hideBackdrop,
        ref: ref
    }, other, ModalProps, {
        children: slidingDrawer
    }));
});
var $647db7f93e4c52c9$export$2e2bcd8739ae039 = $647db7f93e4c52c9$var$Drawer;


var $17TrO = parcelRequire("17TrO");
var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $edgJc = parcelRequire("edgJc");


var $95U3o = parcelRequire("95U3o");

var $7J7Kn = parcelRequire("7J7Kn");

var $cG3EF = parcelRequire("cG3EF");

var $g4l1t = parcelRequire("g4l1t");

var $8gyMY = parcelRequire("8gyMY");

var $cNBED = parcelRequire("cNBED");

var $fGH8N = parcelRequire("fGH8N");

var $clZiP = parcelRequire("clZiP");

var $9tY0V = parcelRequire("9tY0V");

var $8M7SI = parcelRequire("8M7SI");

var $erAkb = parcelRequire("erAkb");

var $5R8eh = parcelRequire("5R8eh");

var $kVG1h = parcelRequire("kVG1h");

var $82V4F = parcelRequire("82V4F");

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $70aa0907006accc9$export$837848f5f6cee923(slot) {
    return (0, $XybB6.default)("MuiTooltip", slot);
}
const $70aa0907006accc9$var$tooltipClasses = (0, $igcUF.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $70aa0907006accc9$export$2e2bcd8739ae039 = $70aa0907006accc9$var$tooltipClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $d53a5c2058f97940$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $d53a5c2058f97940$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $d53a5c2058f97940$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $fGH8N.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $70aa0907006accc9$export$837848f5f6cee923), classes);
};
const $d53a5c2058f97940$var$TooltipPopper = (0, $g4l1t.default)((0, $9tY0V.default), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $4WYaH.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $70aa0907006accc9$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $70aa0907006accc9$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $70aa0907006accc9$export$2e2bcd8739ae039).arrow}`]: (0, $4WYaH.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $70aa0907006accc9$export$2e2bcd8739ae039).arrow}`]: (0, $4WYaH.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $d53a5c2058f97940$var$TooltipTooltip = (0, $g4l1t.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $fGH8N.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $4WYaH.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $cG3EF.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$d53a5c2058f97940$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $70aa0907006accc9$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $4WYaH.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $4WYaH.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $4WYaH.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $70aa0907006accc9$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $4WYaH.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $4WYaH.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $4WYaH.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $70aa0907006accc9$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $4WYaH.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $70aa0907006accc9$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $4WYaH.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $d53a5c2058f97940$var$TooltipArrow = (0, $g4l1t.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $cG3EF.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $d53a5c2058f97940$var$hystersisOpen = false;
const $d53a5c2058f97940$var$hystersisTimer = new (0, $edgJc.Timeout)();
let $d53a5c2058f97940$var$cursorPosition = {
    x: 0,
    y: 0
};
function $d53a5c2058f97940$export$b9ee5a7ace0541f8() {
    $d53a5c2058f97940$var$hystersisOpen = false;
    $d53a5c2058f97940$var$hystersisTimer.clear();
}
function $d53a5c2058f97940$var$composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $d53a5c2058f97940$var$Tooltip = /*#__PURE__*/ $bh6RR.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $clZiP.default), TransitionProps: TransitionProps } = props, other = (0, $hCIyK.default)(props, $d53a5c2058f97940$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $bh6RR.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $8gyMY.default)();
    const isRtl = theme.direction === "rtl";
    const [childNode, setChildNode] = $bh6RR.useState();
    const [arrowRef, setArrowRef] = $bh6RR.useState(null);
    const ignoreNonTouchEvents = $bh6RR.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $edgJc.default)();
    const enterTimer = (0, $edgJc.default)();
    const leaveTimer = (0, $edgJc.default)();
    const touchTimer = (0, $edgJc.default)();
    const [openState, setOpenState] = (0, $82V4F.default)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $5R8eh.default)(idProp);
    const prevUserSelect = $bh6RR.useRef();
    const stopTouchInteraction = (0, $8M7SI.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $bh6RR.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $d53a5c2058f97940$var$hystersisTimer.clear();
        $d53a5c2058f97940$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $8M7SI.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $d53a5c2058f97940$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $d53a5c2058f97940$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $d53a5c2058f97940$var$hystersisOpen && enterNextDelay) enterTimer.start($d53a5c2058f97940$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $kVG1h.default)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $bh6RR.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $bh6RR.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $erAkb.default)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $bh6RR.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $d53a5c2058f97940$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $4WYaH.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $aPsoC.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $d53a5c2058f97940$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $d53a5c2058f97940$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $d53a5c2058f97940$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $d53a5c2058f97940$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $bh6RR.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $4WYaH.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $4WYaH.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $d53a5c2058f97940$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $d53a5c2058f97940$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $clZiP.default);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $d53a5c2058f97940$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $d53a5c2058f97940$var$TooltipArrow;
    const popperProps = (0, $95U3o.appendOwnerState)(PopperComponent, (0, $4WYaH.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $aPsoC.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $95U3o.appendOwnerState)(TransitionComponent, (0, $4WYaH.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $95U3o.appendOwnerState)(TooltipComponent, (0, $4WYaH.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $aPsoC.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $95U3o.appendOwnerState)(ArrowComponent, (0, $4WYaH.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $aPsoC.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ $bh6RR.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ih19M.jsx)(PopperComponent, (0, $4WYaH.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $9tY0V.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $d53a5c2058f97940$var$cursorPosition.y,
                            left: $d53a5c2058f97940$var$cursorPosition.x,
                            right: $d53a5c2058f97940$var$cursorPosition.x,
                            bottom: $d53a5c2058f97940$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)(TooltipComponent, (0, $4WYaH.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ih19M.jsx)(ArrowComponent, (0, $4WYaH.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $d53a5c2058f97940$export$2e2bcd8739ae039 = $d53a5c2058f97940$var$Tooltip;



var $4VYKF = parcelRequire("4VYKF");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $abfa4fecf9d71d37$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M10.09 15.59 11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
}), "ExitToApp");


const $5de5501f04689371$var$openDrawerWidth = 180;
const $5de5501f04689371$var$closedDrawerWidth = 60;
const $5de5501f04689371$var$openedMixin = (theme)=>({
        width: $5de5501f04689371$var$openDrawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        }),
        background: `linear-gradient(${theme.palette.primary.main}, ${theme.palette.primary.light})`,
        overflowX: "hidden",
        border: "none"
    });
const $5de5501f04689371$var$closedMixin = (theme)=>({
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        background: `linear-gradient(${theme.palette.primary.main}, ${theme.palette.primary.light})`,
        overflowX: "hidden",
        width: $5de5501f04689371$var$closedDrawerWidth,
        border: "none"
    });
const $5de5501f04689371$var$Navigation = ()=>{
    const { state: state, dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const client = (0, $4VYKF.useApolloClient)();
    const createCompanySubscription = (0, $hjfla.useCompanyCreatedSubscription)();
    const updateCompanySubscription = (0, $hjfla.useCompanyUpdatedSubscription)();
    const deleteCompanySubscription = (0, $hjfla.useCompanyDeletedSubscription)();
    const createContactSubscription = (0, $hjfla.useContactCreatedSubscription)();
    const updateContactSubscription = (0, $hjfla.useContactUpdatedSubscription)();
    const deleteContactSubscription = (0, $hjfla.useContactDeletedSubscription)();
    const createProductSubscription = (0, $hjfla.useProductCreatedSubscription)();
    const updateProductSubscription = (0, $hjfla.useProductUpdatedSubscription)();
    const deleteProductSubscription = (0, $hjfla.useProductDeletedSubscription)();
    const deleteMembershipSubscription = (0, $hjfla.useMembershipDeletedSubscription)();
    const createMembershipSubscription = (0, $hjfla.useMembershipCreatedSubscription)();
    const updateMembershipSubscription = (0, $hjfla.useMembershipUpdatedSubscription)();
    const commentAddedSubscription = (0, $hjfla.useCommentAddedSubscription)();
    const commentDeletedSubscription = (0, $hjfla.useCommentDeletedSubscription)();
    const createInvoiceSubscription = (0, $hjfla.useInvoiceCreatedSubscription)();
    const updateInvoiceSubscription = (0, $hjfla.useInvoiceUpdatedSubscription)();
    const deleteInvoiceSubscription = (0, $hjfla.useInvoiceDeletedSubscription)();
    const updateUserSubscription = (0, $hjfla.useUserUpdatedSubscription)();
    const deleteUserSubscription = (0, $hjfla.useUserDeletedSubscription)();
    const createUserSubscription = (0, $hjfla.useUserCreatedSubscription)();
    const userRoleRemovedSubscription = (0, $hjfla.useUserRoleRemovedSubscription)();
    const deleteInterestSubscription = (0, $hjfla.useInterestDeletedSubscription)();
    const deleteTemplateSubscription = (0, $hjfla.useTemplateDeletedSubscription)();
    const createTemplateSubscription = (0, $hjfla.useTemplateCreatedSubscription)();
    const updateTemplateSubscription = (0, $hjfla.useTemplateUpdatedSubscription)();
    const deleteRecipientListSubscription = (0, $hjfla.useRecipientListDeletedSubscription)();
    const createRecipientListSubscription = (0, $hjfla.useRecipientListCreatedSubscription)();
    const updateRecipientListSubscription = (0, $hjfla.useRecipientListUpdatedSubscription)();
    const createSchedulerSubscription = (0, $hjfla.useSchedulerCreatedSubscription)();
    const deleteSchedulerSubscription = (0, $hjfla.useSchedulerDeletedSubscription)();
    const updateSchedulerSubscription = (0, $hjfla.useSchedulerUpdatedSubscription)();
    const deleteEventSubscription = (0, $hjfla.useEventDeletedSubscription)();
    const createdEventSubscription = (0, $hjfla.useEventCreatedSubscription)();
    const updateEventSubscription = (0, $hjfla.useEventUpdatedSubscription)();
    const createStockSubscription = (0, $hjfla.useStockCreatedSubscription)();
    const createIndexSubscription = (0, $hjfla.useIndexCreatedSubscription)();
    const deleteIndexSubscription = (0, $hjfla.useIndexDeletedSubscription)();
    const updateIndexSubscription = (0, $hjfla.useIndexUpdatedSubscription)();
    const deleteIndexSerieSubscription = (0, $hjfla.useIndexSerieDeletedSubscription)();
    const createIndexSerieSubscription = (0, $hjfla.useIndexSerieCreatedSubscription)();
    const updateIndexSerieSubscription = (0, $hjfla.useIndexSerieUpdatedSubscription)();
    const createEtfSubscription = (0, $hjfla.useEtfCreatedSubscription)();
    const updateEtfSubscription = (0, $hjfla.useEtfUpdatedSubscription)();
    const deleteEtfSubscription = (0, $hjfla.useEtfDeletedSubscription)();
    const createFtseFileSubscription = (0, $hjfla.useFtseFileCreatedSubscription)();
    const deleteFtseFileSubscription = (0, $hjfla.useFtseFileDeletedSubscription)();
    const updateFtseFileSubscription = (0, $hjfla.useFtseFileUpdatedSubscription)();
    const updateFtseConfigurationSubscription = (0, $hjfla.useFtseConfigurationUpdatedSubscription)();
    const createSiteSectionSubscription = (0, $hjfla.useSiteSectionCreatedSubscription)();
    const deleteSiteSectionSubscription = (0, $hjfla.useSiteSectionDeletedSubscription)();
    const updateSiteSectionSubscription = (0, $hjfla.useSiteSectionUpdatedSubscription)();
    const deleteDocumentSubscription = (0, $hjfla.useDocumentDeletedSubscription)();
    const updateDocumentSubscription = (0, $hjfla.useDocumentUpdatedSubscription)();
    const createDocumentSubscription = (0, $hjfla.useDocumentCreatedSubscription)();
    const appRoutes = [];
    state.routes.forEach((r)=>{
        r.subRoutes ? r.subRoutes.forEach((sr)=>appRoutes.push(sr)) : appRoutes.push(r);
    });
    const routes = appRoutes.filter((r)=>r.showInNav).map((re)=>re.path);
    // const classes = useStyles();
    const [open, setOpen] = (0, $bh6RR.useState)(true);
    const [prevOpenState, setPrevOpenState] = (0, $bh6RR.useState)(false);
    const location = (0, $99w1R.useLocation)();
    const navigate = (0, $99w1R.useNavigate)();
    const locationElements = location.pathname.split("/").filter((e)=>e);
    const locationName = "/" + locationElements[0];
    const routeIndex = routes.indexOf(locationName) < 0 ? 0 : routes.indexOf(locationName);
    const [selected, setSelected] = (0, $bh6RR.useState)(routes[routeIndex]);
    (0, $bh6RR.useEffect)(()=>{
        if (createCompanySubscription.data?.result) (0, $gFVvY.addCompanyToCache)(createCompanySubscription.data.result);
        if (updateCompanySubscription.data?.result) (0, $gFVvY.updateCompanyInCache)(updateCompanySubscription.data?.result);
    }, [
        createCompanySubscription.data,
        updateCompanySubscription.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (deleteCompanySubscription.data?.result) (0, $gFVvY.removeCompanyFromCache)(deleteCompanySubscription.data.result);
    }, [
        deleteCompanySubscription.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (deleteContactSubscription.data?.result) (0, $gFVvY.removeContactFromCache)(deleteContactSubscription.data.result);
    }, [
        deleteContactSubscription
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createTemplateSubscription.data?.result) (0, $gFVvY.addTemplateInCache)(createTemplateSubscription.data.result);
        if (updateTemplateSubscription.data?.result) (0, $gFVvY.updateTemplateInCache)(updateTemplateSubscription.data?.result);
    }, [
        createTemplateSubscription,
        updateTemplateSubscription
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (deleteTemplateSubscription.data?.result) (0, $gFVvY.removeTemplateFromCache)(deleteTemplateSubscription.data.result);
    }, [
        deleteTemplateSubscription
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (deleteMembershipSubscription.data?.result) (0, $gFVvY.removeMembershipFromCache)(deleteMembershipSubscription.data.result);
    }, [
        deleteMembershipSubscription
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createContactSubscription.data?.result) (0, $gFVvY.addContactToCache)(createContactSubscription.data?.result);
        if (updateContactSubscription.data?.result) (0, $gFVvY.updateContactInCache)(updateContactSubscription.data.result);
    }, [
        createContactSubscription.data,
        updateContactSubscription.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createDocumentSubscription.data?.result) (0, $gFVvY.addDocumentInCache)(createDocumentSubscription.data?.result);
        if (updateDocumentSubscription.data?.result) (0, $gFVvY.updateDocumentInCache)(updateDocumentSubscription.data.result);
        if (deleteDocumentSubscription.data?.result) (0, $gFVvY.removeDocumentFromCache)(deleteDocumentSubscription.data?.result);
    }, [
        deleteDocumentSubscription,
        updateDocumentSubscription,
        createDocumentSubscription
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createProductSubscription.data?.result) (0, $gFVvY.addProductToCache)(createProductSubscription.data.result);
        if (updateProductSubscription.data?.result) (0, $gFVvY.updateProductInCache)(updateProductSubscription.data.result);
        if (deleteProductSubscription.data?.result) (0, $gFVvY.removeProductFromCache)(deleteProductSubscription.data.result);
    }, [
        createProductSubscription.data,
        updateProductSubscription.data,
        deleteProductSubscription.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createMembershipSubscription.data?.result) (0, $gFVvY.addMembershipToCache)(createMembershipSubscription.data.result);
        if (updateMembershipSubscription.data?.result) (0, $gFVvY.updateMembershipInCache)(updateMembershipSubscription.data?.result);
        if (commentAddedSubscription.data?.result) (0, $gFVvY.updateMembershipInCache)(commentAddedSubscription.data?.result);
        if (commentDeletedSubscription.data) (0, $gFVvY.updateMembershipInCache)(commentDeletedSubscription.data?.result);
    }, [
        createMembershipSubscription.data,
        updateMembershipSubscription.data,
        commentAddedSubscription.data,
        commentDeletedSubscription.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createInvoiceSubscription.data?.result) (0, $gFVvY.addInvoiceInCache)(createInvoiceSubscription.data?.result);
        if (updateInvoiceSubscription.data?.result) (0, $gFVvY.updateInvoiceInCache)(updateInvoiceSubscription.data?.result);
        if (deleteInvoiceSubscription.data?.result) (0, $gFVvY.removeInvoiceFromCache)(deleteInvoiceSubscription.data?.result);
    }, [
        createInvoiceSubscription.data,
        updateInvoiceSubscription.data,
        deleteInvoiceSubscription.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createUserSubscription.data?.result) (0, $gFVvY.createUserToCache)(createUserSubscription.data.result);
        if (updateUserSubscription.data?.result) (0, $gFVvY.updateUserInCache)(updateUserSubscription.data?.result);
        if (deleteUserSubscription.data?.result) (0, $gFVvY.removeUserFromCache)(deleteUserSubscription.data.result);
    }, [
        updateUserSubscription.data,
        createUserSubscription.data,
        deleteUserSubscription.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (userRoleRemovedSubscription.data?.result) //Works faster than updateUserInCache
        (0, $gFVvY.createUserToCache)(userRoleRemovedSubscription.data?.result);
    }, [
        userRoleRemovedSubscription.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (deleteInterestSubscription.data?.result) (0, $gFVvY.remoteInterestInCache)(deleteInterestSubscription.data.result);
    }, [
        deleteInterestSubscription.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (deleteSchedulerSubscription.data?.result) (0, $gFVvY.removeSchedulerFromCache)(deleteSchedulerSubscription.data?.result.id);
        if (createSchedulerSubscription.data?.result) (0, $gFVvY.addSchedulerToCache)(createSchedulerSubscription.data?.result);
        if (updateSchedulerSubscription.data?.result) (0, $gFVvY.updateSchedulerInCache)(updateSchedulerSubscription.data?.result);
    }, [
        createSchedulerSubscription.data,
        deleteSchedulerSubscription.data,
        updateSchedulerSubscription.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createdEventSubscription.data?.result) (0, $gFVvY.addEventToCache)(createdEventSubscription.data?.result);
        if (updateEventSubscription.data?.result) (0, $gFVvY.updateEventInCache)(updateEventSubscription.data?.result);
        if (deleteEventSubscription.data?.result) (0, $gFVvY.removeEventFromCache)(deleteEventSubscription.data?.result.id);
    }, [
        deleteEventSubscription.data,
        createdEventSubscription.data,
        updateEventSubscription.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (deleteRecipientListSubscription.data?.result) (0, $gFVvY.removeRecipientListFromCache)(deleteRecipientListSubscription.data?.result.id);
        if (createRecipientListSubscription.data?.result) (0, $gFVvY.addRecipientListInCache)(createRecipientListSubscription.data?.result);
        if (updateRecipientListSubscription.data?.result) (0, $gFVvY.updateRecipientListInCache)(updateRecipientListSubscription.data?.result);
    }, [
        deleteRecipientListSubscription.data,
        createRecipientListSubscription.data,
        updateRecipientListSubscription.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createStockSubscription.data?.result) (0, $gFVvY.addStockInCache)(createStockSubscription.data?.result);
    }, [
        createStockSubscription.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createIndexSubscription.data?.result) (0, $gFVvY.addIndexInCache)(createIndexSubscription.data.result);
        if (deleteIndexSubscription.data?.result) (0, $gFVvY.removeIndexFromCache)(deleteIndexSubscription.data?.result);
        if (updateIndexSubscription.data?.result) (0, $gFVvY.updateIndexInCache)(updateIndexSubscription.data?.result);
    }, [
        createIndexSubscription.data,
        deleteIndexSubscription.data,
        updateIndexSubscription.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createIndexSerieSubscription.data?.result) (0, $gFVvY.addIndexSerieInCache)(createIndexSerieSubscription.data.result);
        if (updateIndexSerieSubscription.data?.result) (0, $gFVvY.updateIndexSerieInCache)(updateIndexSerieSubscription.data.result);
        if (deleteIndexSerieSubscription.data?.result) (0, $gFVvY.removeIndexSerieFromCache)(deleteIndexSerieSubscription.data?.result);
    }, [
        deleteIndexSerieSubscription.data,
        createIndexSerieSubscription,
        updateIndexSerieSubscription
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createFtseFileSubscription.data?.result) (0, $gFVvY.addFtseFileInCache)(createFtseFileSubscription.data.result);
        if (deleteFtseFileSubscription.data?.result) (0, $gFVvY.removeFtseFileFromCache)(deleteFtseFileSubscription.data.result);
        if (updateFtseFileSubscription.data?.result) (0, $gFVvY.updateFtseFileInCache)(updateFtseFileSubscription.data.result);
    }, [
        createFtseFileSubscription.data,
        deleteFtseFileSubscription.data,
        updateFtseFileSubscription.data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createEtfSubscription.data?.result) (0, $gFVvY.addEtfInCache)(createEtfSubscription.data.result);
        if (updateEtfSubscription.data?.result) (0, $gFVvY.updateEtfInCache)(updateEtfSubscription.data.result);
        if (deleteEtfSubscription.data?.result) (0, $gFVvY.removeEtfFromChache)(deleteEtfSubscription.data?.result);
    }, [
        createEtfSubscription,
        updateEtfSubscription,
        deleteEtfSubscription
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createSiteSectionSubscription.data?.result) (0, $gFVvY.addSiteSectionInCache)(createSiteSectionSubscription.data.result);
        if (updateSiteSectionSubscription.data?.result) (0, $gFVvY.updateSiteSectionInCache)(updateSiteSectionSubscription.data.result);
        if (deleteSiteSectionSubscription.data?.result) (0, $gFVvY.removeSiteSectionFromCache)(deleteSiteSectionSubscription.data?.result);
    }, [
        createSiteSectionSubscription,
        updateSiteSectionSubscription,
        deleteSiteSectionSubscription
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (updateFtseConfigurationSubscription.data?.result) (0, $gFVvY.updateFtseConfigurationInCache)(updateFtseConfigurationSubscription.data.result);
    }, [
        updateFtseConfigurationSubscription
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (createProductSubscription.data?.result) (0, $gFVvY.addProductToCache)(createProductSubscription.data.result);
        if (updateProductSubscription.data?.result) (0, $gFVvY.updateProductInCache)(updateProductSubscription.data.result);
        if (deleteProductSubscription.data?.result) (0, $gFVvY.removeProductFromCache)(deleteProductSubscription.data.result);
    }, [
        createProductSubscription.data,
        updateProductSubscription.data,
        deleteProductSubscription.data
    ]);
    if (routes[routeIndex] !== selected) setSelected(routes[routeIndex]);
    if (routes[routeIndex] !== selected) setSelected(routes[routeIndex]);
    const handleDrawerMove = ()=>{
        if (prevOpenState == open) {
            setPrevOpenState(!open);
            setOpen(open);
        } else {
            setPrevOpenState(open);
            setOpen(!open);
        }
    };
    const handleSelectedChanged = (path)=>{
        navigate(path);
        setSelected(path);
    };
    const handleLogout = (e)=>{
        e.stopPropagation();
        client.cache.reset();
        localStorage.removeItem((0, $aM783.AppConsts).AccessToken);
        dispatch({
            type: (0, $ayVxz.Actions).RemoveUser
        });
    // history('/login');
    };
    const onHover = (isEnter)=>{
        if (isEnter) {
            if (!open) setOpen(true);
        } else if (prevOpenState) setOpen(false);
    };
    return state.user.data ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
        sx: {
            display: "flex"
        },
        id: "navigation-container",
        //className={classes.root}
        onClick: handleDrawerMove,
        onMouseLeave: ()=>onHover(false),
        onMouseEnter: ()=>onHover(true),
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $647db7f93e4c52c9$export$2e2bcd8739ae039), {
            variant: "permanent",
            sx: (theme)=>({
                    width: $5de5501f04689371$var$openDrawerWidth,
                    flexShrink: 0,
                    whiteSpace: "nowrap",
                    boxSizing: "border-box",
                    ...open && {
                        ...$5de5501f04689371$var$openedMixin(theme),
                        "& .MuiDrawer-paper": $5de5501f04689371$var$openedMixin(theme)
                    },
                    ...!open && {
                        ...$5de5501f04689371$var$closedMixin(theme),
                        "& .MuiDrawer-paper": $5de5501f04689371$var$closedMixin(theme)
                    }
                }),
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                    sx: {
                        height: "145px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                        id: "epra-logo",
                        component: "img",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4fae9887581a8845$exports))),
                        sx: open ? {
                            width: "60px",
                            transition: "all 0.25s linear",
                            transformOrigin: "bottom left"
                        } : {
                            width: "32px",
                            transition: "all 0.25s linear",
                            transformOrigin: "bottom left"
                        },
                        alt: "logo"
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $17TrO.default), {
                    id: "navigation-items",
                    disablePadding: true,
                    sx: {
                        display: "flex",
                        flexFlow: "column",
                        height: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                            sx: {
                                flexGrow: 1
                            },
                            children: state.routes.filter((r)=>r.showInNav).map((route)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $f693df3f18fd5181$export$2e2bcd8739ae039), {
                                    route: route,
                                    selected: selected,
                                    open: open,
                                    userRoles: state.user.data?.roles,
                                    handleSelectedChanged: handleSelectedChanged
                                }, route.name))
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $b01e1a0b62498cf8$export$2e2bcd8739ae039), {
                            id: "Logout-Button",
                            disableGutters: true,
                            onClick: (e)=>handleLogout(e),
                            button: true,
                            sx: {
                                flexGrow: 0,
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $d53a5c2058f97940$export$2e2bcd8739ae039), {
                                    title: "logout",
                                    arrow: true,
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $abfa4fecf9d71d37$export$2e2bcd8739ae039), {
                                        sx: {
                                            color: "common.white"
                                        }
                                    })
                                }),
                                open && /*#__PURE__*/ (0, $ih19M.jsx)((0, $chLJv.default), {
                                    sx: {
                                        color: (0, $6L9uu.Colors).white,
                                        margin: "2px",
                                        fontWeight: 400
                                    },
                                    children: "Logout"
                                })
                            ]
                        }, "logout")
                    ]
                })
            ]
        })
    }) : null;
};
var $5de5501f04689371$export$2e2bcd8739ae039 = $5de5501f04689371$var$Navigation;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $7ITag = parcelRequire("7ITag");

var $7J7Kn = parcelRequire("7J7Kn");

var $bh6RR = parcelRequire("bh6RR");


var $7TDiU = parcelRequire("7TDiU");
var $5EGAX = parcelRequire("5EGAX");
var $fpwfv = parcelRequire("fpwfv");

var $ih19M = parcelRequire("ih19M");
"use client";
function $1a226f09e382fa75$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $1a226f09e382fa75$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/base-ui/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base-ui/react-click-away-listener/components-api/#click-away-listener)
 */ function $1a226f09e382fa75$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = "onClick", onClickAway: onClickAway, touchEvent: touchEvent = "onTouchEnd" } = props;
    const movedRef = $bh6RR.useRef(false);
    const nodeRef = $bh6RR.useRef(null);
    const activatedRef = $bh6RR.useRef(false);
    const syntheticEventRef = $bh6RR.useRef(false);
    $bh6RR.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $fpwfv.default)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $5EGAX.default)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $7TDiU.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || "clientX" in event && $1a226f09e382fa75$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $bh6RR.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $1a226f09e382fa75$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $7TDiU.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $bh6RR.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $1a226f09e382fa75$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $7TDiU.default)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($bh6RR.Fragment, {
        children: /*#__PURE__*/ $bh6RR.cloneElement(children, childrenProps)
    });
}



var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");

var $5EGAX = parcelRequire("5EGAX");
var $edgJc = parcelRequire("edgJc");

var $kLmLK = parcelRequire("kLmLK");
"use client";
function $92425eaecdf7cf40$export$1c97ac2c9a6e7c09(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $edgJc.default)();
    $bh6RR.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, "escapeKeyDown");
            }
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $5EGAX.default)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $5EGAX.default)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, "timeout");
        });
    });
    $bh6RR.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, "clickaway");
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $bh6RR.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $bh6RR.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return ()=>{
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $4WYaH.default)({}, (0, $kLmLK.extractEventHandlers)(parameters), (0, $kLmLK.extractEventHandlers)(externalProps));
        return (0, $4WYaH.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: "presentation"
        }, externalProps, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}



var $g4l1t = parcelRequire("g4l1t");

var $8gyMY = parcelRequire("8gyMY");

var $cNBED = parcelRequire("cNBED");

var $fGH8N = parcelRequire("fGH8N");

var $clZiP = parcelRequire("clZiP");

var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $cG3EF = parcelRequire("cG3EF");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $iTI7v = parcelRequire("iTI7v");

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $6ddd018859a12cc3$export$def81488db1a3216(slot) {
    return (0, $XybB6.default)("MuiSnackbarContent", slot);
}
const $6ddd018859a12cc3$var$snackbarContentClasses = (0, $igcUF.default)("MuiSnackbarContent", [
    "root",
    "message",
    "action"
]);
var $6ddd018859a12cc3$export$2e2bcd8739ae039 = $6ddd018859a12cc3$var$snackbarContentClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $44d068f752203b9d$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $44d068f752203b9d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        action: [
            "action"
        ],
        message: [
            "message"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $6ddd018859a12cc3$export$def81488db1a3216), classes);
};
const $44d068f752203b9d$var$SnackbarContentRoot = (0, $g4l1t.default)((0, $iTI7v.default), {
    name: "MuiSnackbarContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === "light" ? 0.8 : 0.98;
    const backgroundColor = (0, $cG3EF.emphasize)(theme.palette.background.default, emphasis);
    return (0, $4WYaH.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up("sm")]: {
            flexGrow: "initial",
            minWidth: 288
        }
    });
});
const $44d068f752203b9d$var$SnackbarContentMessage = (0, $g4l1t.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0"
});
const $44d068f752203b9d$var$SnackbarContentAction = (0, $g4l1t.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    paddingLeft: 16,
    marginRight: -8
});
const $44d068f752203b9d$var$SnackbarContent = /*#__PURE__*/ $bh6RR.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiSnackbarContent"
    });
    const { action: action, className: className, message: message, role: role = "alert" } = props, other = (0, $hCIyK.default)(props, $44d068f752203b9d$var$_excluded);
    const ownerState = props;
    const classes = $44d068f752203b9d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsxs)($44d068f752203b9d$var$SnackbarContentRoot, (0, $4WYaH.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $aPsoC.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($44d068f752203b9d$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $ih19M.jsx)($44d068f752203b9d$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $44d068f752203b9d$export$2e2bcd8739ae039 = $44d068f752203b9d$var$SnackbarContent;



var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $3e76348ed9749f45$export$6cb096457f5926f4(slot) {
    return (0, $XybB6.default)("MuiSnackbar", slot);
}
const $3e76348ed9749f45$var$snackbarClasses = (0, $igcUF.default)("MuiSnackbar", [
    "root",
    "anchorOriginTopCenter",
    "anchorOriginBottomCenter",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft"
]);
var $3e76348ed9749f45$export$2e2bcd8739ae039 = $3e76348ed9749f45$var$snackbarClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $e0a5be5f1b0e6199$var$_excluded = [
    "onEnter",
    "onExited"
], $e0a5be5f1b0e6199$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $e0a5be5f1b0e6199$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            "root",
            `anchorOrigin${(0, $fGH8N.default)(anchorOrigin.vertical)}${(0, $fGH8N.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $3e76348ed9749f45$export$6cb096457f5926f4), classes);
};
const $e0a5be5f1b0e6199$var$SnackbarRoot = (0, $g4l1t.default)("div", {
    name: "MuiSnackbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $fGH8N.default)(ownerState.anchorOrigin.vertical)}${(0, $fGH8N.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
    };
    return (0, $4WYaH.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: "fixed",
        display: "flex",
        left: 8,
        right: 8,
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.anchorOrigin.vertical === "top" ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === "left" && {
        justifyContent: "flex-start"
    }, ownerState.anchorOrigin.horizontal === "right" && {
        justifyContent: "flex-end"
    }, {
        [theme.breakpoints.up("sm")]: (0, $4WYaH.default)({}, ownerState.anchorOrigin.vertical === "top" ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === "center" && center, ownerState.anchorOrigin.horizontal === "left" && {
            left: 24,
            right: "auto"
        }, ownerState.anchorOrigin.horizontal === "right" && {
            right: 24,
            left: "auto"
        })
    });
});
const $e0a5be5f1b0e6199$var$Snackbar = /*#__PURE__*/ $bh6RR.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiSnackbar"
    });
    const theme = (0, $8gyMY.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: "bottom",
        horizontal: "left"
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, open: open, TransitionComponent: TransitionComponent = (0, $clZiP.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $hCIyK.default)(props.TransitionProps, $e0a5be5f1b0e6199$var$_excluded), other = (0, $hCIyK.default)(props, $e0a5be5f1b0e6199$var$_excluded2);
    const ownerState = (0, $4WYaH.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $e0a5be5f1b0e6199$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $92425eaecdf7cf40$export$1c97ac2c9a6e7c09)((0, $4WYaH.default)({}, ownerState));
    const [exited, setExited] = $bh6RR.useState(true);
    const rootProps = (0, $7ITag.useSlotProps)({
        elementType: $e0a5be5f1b0e6199$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1a226f09e382fa75$export$58385c17fee43f89), (0, $4WYaH.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)($e0a5be5f1b0e6199$var$SnackbarRoot, (0, $4WYaH.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $ih19M.jsx)(TransitionComponent, (0, $4WYaH.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === "top" ? "down" : "up",
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $ih19M.jsx)((0, $44d068f752203b9d$export$2e2bcd8739ae039), (0, $4WYaH.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $e0a5be5f1b0e6199$export$2e2bcd8739ae039 = $e0a5be5f1b0e6199$var$Snackbar;



var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $cG3EF = parcelRequire("cG3EF");

var $6S0MN = parcelRequire("6S0MN");
var $g4l1t = parcelRequire("g4l1t");

var $25BP8 = parcelRequire("25BP8");

var $fGH8N = parcelRequire("fGH8N");

var $iTI7v = parcelRequire("iTI7v");

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $3f9e69e4a5e37666$export$69aecd24bc2cf7e3(slot) {
    return (0, $XybB6.default)("MuiAlert", slot);
}
const $3f9e69e4a5e37666$var$alertClasses = (0, $igcUF.default)("MuiAlert", [
    "root",
    "action",
    "icon",
    "message",
    "filled",
    "colorSuccess",
    "colorInfo",
    "colorWarning",
    "colorError",
    "filledSuccess",
    "filledInfo",
    "filledWarning",
    "filledError",
    "outlined",
    "outlinedSuccess",
    "outlinedInfo",
    "outlinedWarning",
    "outlinedError",
    "standard",
    "standardSuccess",
    "standardInfo",
    "standardWarning",
    "standardError"
]);
var $3f9e69e4a5e37666$export$2e2bcd8739ae039 = $3f9e69e4a5e37666$var$alertClasses;



var $am7GZ = parcelRequire("am7GZ");
parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $69783730d64dd996$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined");


parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $f07270c865ae61ce$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined");


parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $f1c321308a0c1c67$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");


parcelRequire("bh6RR");

var $7B0TL = parcelRequire("7B0TL");

var $ih19M = parcelRequire("ih19M");
"use client";
var $67b53be57bfcc810$export$2e2bcd8739ae039 = (0, $7B0TL.default)(/*#__PURE__*/ (0, $ih19M.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");



var $9Nyb2 = parcelRequire("9Nyb2");

var $ih19M = parcelRequire("ih19M");
"use client";
const $8e112c98121a019d$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $8e112c98121a019d$var$useThemeProps = (0, $6S0MN.createUseThemeProps)("MuiAlert");
const $8e112c98121a019d$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $fGH8N.default)(color || severity)}`,
            `${variant}${(0, $fGH8N.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            "icon"
        ],
        message: [
            "message"
        ],
        action: [
            "action"
        ]
    };
    return (0, $7J7Kn.default)(slots, (0, $3f9e69e4a5e37666$export$69aecd24bc2cf7e3), classes);
};
const $8e112c98121a019d$var$AlertRoot = (0, $g4l1t.default)((0, $iTI7v.default), {
    name: "MuiAlert",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $fGH8N.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme })=>{
    const getColor = theme.palette.mode === "light" ? (0, $cG3EF.darken) : (0, $cG3EF.lighten);
    const getBackgroundColor = theme.palette.mode === "light" ? (0, $cG3EF.lighten) : (0, $cG3EF.darken);
    return (0, $4WYaH.default)({}, theme.typography.body2, {
        backgroundColor: "transparent",
        display: "flex",
        padding: "6px 16px",
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "standard"
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $3f9e69e4a5e37666$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "outlined"
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $3f9e69e4a5e37666$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.dark).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "filled"
                    },
                    style: (0, $4WYaH.default)({
                        fontWeight: theme.typography.fontWeightMedium
                    }, theme.vars ? {
                        color: theme.vars.palette.Alert[`${color}FilledColor`],
                        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                    } : {
                        backgroundColor: theme.palette.mode === "dark" ? theme.palette[color].dark : theme.palette[color].main,
                        color: theme.palette.getContrastText(theme.palette[color].main)
                    })
                }))
        ]
    });
});
const $8e112c98121a019d$var$AlertIcon = (0, $g4l1t.default)("div", {
    name: "MuiAlert",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: "7px 0",
    display: "flex",
    fontSize: 22,
    opacity: 0.9
});
const $8e112c98121a019d$var$AlertMessage = (0, $g4l1t.default)("div", {
    name: "MuiAlert",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0",
    minWidth: 0,
    overflow: "auto"
});
const $8e112c98121a019d$var$AlertAction = (0, $g4l1t.default)("div", {
    name: "MuiAlert",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "flex-start",
    padding: "4px 0 0 16px",
    marginLeft: "auto",
    marginRight: -8
});
const $8e112c98121a019d$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $ih19M.jsx)((0, $69783730d64dd996$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $ih19M.jsx)((0, $f07270c865ae61ce$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $ih19M.jsx)((0, $f1c321308a0c1c67$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $ih19M.jsx)((0, $67b53be57bfcc810$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $8e112c98121a019d$var$Alert = /*#__PURE__*/ $bh6RR.forwardRef(function Alert(inProps, ref) {
    const props = $8e112c98121a019d$var$useThemeProps({
        props: inProps,
        name: "MuiAlert"
    });
    const { action: action, children: children, className: className, closeText: closeText = "Close", color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $8e112c98121a019d$var$defaultIconMapping, onClose: onClose, role: role = "alert", severity: severity = "success", slotProps: slotProps = {}, slots: slots = {}, variant: variant = "standard" } = props, other = (0, $hCIyK.default)(props, $8e112c98121a019d$var$_excluded);
    const ownerState = (0, $4WYaH.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    });
    const classes = $8e112c98121a019d$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, $4WYaH.default)({
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon
        }, slots),
        slotProps: (0, $4WYaH.default)({}, componentsProps, slotProps)
    };
    const [CloseButtonSlot, closeButtonProps] = (0, $25BP8.default)("closeButton", {
        elementType: (0, $am7GZ.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $25BP8.default)("closeIcon", {
        elementType: (0, $9Nyb2.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)($8e112c98121a019d$var$AlertRoot, (0, $4WYaH.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $ih19M.jsx)($8e112c98121a019d$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $8e112c98121a019d$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $ih19M.jsx)($8e112c98121a019d$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $ih19M.jsx)($8e112c98121a019d$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $ih19M.jsx)($8e112c98121a019d$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $ih19M.jsx)(CloseButtonSlot, (0, $4WYaH.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)(CloseIconSlot, (0, $4WYaH.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $8e112c98121a019d$export$2e2bcd8739ae039 = $8e112c98121a019d$var$Alert;



var $bu31C = parcelRequire("bu31C");

var $ayVxz = parcelRequire("ayVxz");
const $2ede171af289ecae$var$Alert = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(function Alert(props, ref) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8e112c98121a019d$export$2e2bcd8739ae039), {
        elevation: 6,
        ref: ref,
        variant: "filled",
        ...props
    });
});
const $2ede171af289ecae$var$Message = ()=>{
    const { state: state, dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const handleClose = (_, reason)=>{
        if (reason !== "clickaway") dispatch({
            type: (0, $ayVxz.Actions).HideMessage
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e0a5be5f1b0e6199$export$2e2bcd8739ae039), {
        open: state.message.open,
        autoHideDuration: state.message.autoHide,
        onClose: handleClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)($2ede171af289ecae$var$Alert, {
            id: "alert-message",
            onClose: ()=>dispatch({
                    type: (0, $ayVxz.Actions).HideMessage
                }),
            severity: state.message.severity ?? "success",
            sx: {
                cursor: "pointer"
            },
            children: state.message.text
        })
    });
};
var $2ede171af289ecae$export$2e2bcd8739ae039 = $2ede171af289ecae$var$Message;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bu31C = parcelRequire("bu31C");

var $6L9uu = parcelRequire("6L9uu");

var $ayVxz = parcelRequire("ayVxz");

var $idMAb = parcelRequire("idMAb");
var $7opAt = parcelRequire("7opAt");
var $fl7Qe = parcelRequire("fl7Qe");
var $8ECDX = parcelRequire("8ECDX");
var $hCIyK = parcelRequire("hCIyK");

var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $aPsoC = parcelRequire("aPsoC");

var $7J7Kn = parcelRequire("7J7Kn");

var $g4l1t = parcelRequire("g4l1t");

var $cNBED = parcelRequire("cNBED");

var $aitry = parcelRequire("aitry");

var $igcUF = parcelRequire("igcUF");

var $XybB6 = parcelRequire("XybB6");
function $debff1adc6f62c48$export$d9c6dc45f75b0e4f(slot) {
    return (0, $XybB6.default)("MuiDialogContentText", slot);
}
const $debff1adc6f62c48$var$dialogContentTextClasses = (0, $igcUF.default)("MuiDialogContentText", [
    "root"
]);
var $debff1adc6f62c48$export$2e2bcd8739ae039 = $debff1adc6f62c48$var$dialogContentTextClasses;



var $ih19M = parcelRequire("ih19M");
"use client";
const $31543ddde024914d$var$_excluded = [
    "children",
    "className"
];
const $31543ddde024914d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    const composedClasses = (0, $7J7Kn.default)(slots, (0, $debff1adc6f62c48$export$d9c6dc45f75b0e4f), classes);
    return (0, $4WYaH.default)({}, classes, composedClasses);
};
const $31543ddde024914d$var$DialogContentTextRoot = (0, $g4l1t.default)((0, $aitry.default), {
    shouldForwardProp: (prop)=>(0, $g4l1t.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiDialogContentText",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $31543ddde024914d$var$DialogContentText = /*#__PURE__*/ $bh6RR.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiDialogContentText"
    });
    const { className: className } = props, ownerState = (0, $hCIyK.default)(props, $31543ddde024914d$var$_excluded);
    const classes = $31543ddde024914d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ih19M.jsx)($31543ddde024914d$var$DialogContentTextRoot, (0, $4WYaH.default)({
        component: "p",
        variant: "body1",
        color: "text.secondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $aPsoC.default)(classes.root, className)
    }, props, {
        classes: classes
    }));
});
var $31543ddde024914d$export$2e2bcd8739ae039 = $31543ddde024914d$var$DialogContentText;


var $3q83T = parcelRequire("3q83T");
var $ePCTs = parcelRequire("ePCTs");
const $a485679c9e5fd690$var$Confirmation = ()=>{
    const { state: state, dispatch: dispatch } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const handleAgree = ()=>{
        if (state.confirmation.agreeAction) state.confirmation.agreeAction(state.confirmation.params);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $7opAt.default), {
        id: "alert-dialog",
        open: state.confirmation.open,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        BackdropProps: {
            style: {
                background: (0, $6L9uu.Colors).modalBackground
            }
        },
        children: [
            state.confirmation.title && /*#__PURE__*/ (0, $ih19M.jsx)((0, $3q83T.default), {
                id: "alert-dialog-title",
                style: {
                    borderBottom: "1px solid " + (0, $6L9uu.Colors).skyBlue,
                    textAlign: "center",
                    paddingTop: "15px",
                    paddingBottom: "13px"
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    style: {
                        margin: "auto",
                        color: (0, $6L9uu.Colors).skyBlue,
                        letterSpacing: "-0.01px",
                        fontSize: "22px",
                        lineHeight: "33px",
                        opacity: "1px",
                        fontWeight: "bold",
                        width: "100%"
                    },
                    children: state.confirmation.title
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8ECDX.default), {
                style: {
                    marginTop: 44,
                    marginLeft: 61,
                    marginRight: 60
                },
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $31543ddde024914d$export$2e2bcd8739ae039), {
                    id: "alert-dialog-description",
                    style: {
                        color: "#12497F"
                    },
                    children: state.confirmation.text
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $fl7Qe.default), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ePCTs.default), {
                    container: true,
                    style: {
                        marginTop: "32px",
                        marginBottom: "44px"
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ePCTs.default), {
                        item: true,
                        xs: 12,
                        style: {
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                                id: "no-dialog-button",
                                variant: "outlined",
                                onClick: ()=>dispatch({
                                        type: (0, $ayVxz.Actions).HideConfirmation
                                    }),
                                children: "No"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $idMAb.default), {
                                id: "yes-dialog-button",
                                onClick: handleAgree,
                                autoFocus: true,
                                variant: "contained",
                                children: "Yes"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $a485679c9e5fd690$export$2e2bcd8739ae039 = $a485679c9e5fd690$var$Confirmation;


function $16e924f086a574be$export$86fbec116b87613f() {
    const { state: state } = (0, $bh6RR.useContext)((0, $bu31C.AppContext));
    const appRoutes = [];
    state.routes.forEach((r)=>{
        r.subRoutes ? r.subRoutes.forEach((sr)=>appRoutes.push(sr)) : appRoutes.push(r);
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $82ee3221eaadbd63$export$2e2bcd8739ae039), {
        theme: (0, $6L9uu.buildTheme)(),
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bu31C.AppProvider), {
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e3217453550f778$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $10WBQ.BrowserRouter), {
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $chLJv.default), {
                        sx: {
                            display: "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $5de5501f04689371$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $99w1R.Routes), {
                                children: [
                                    appRoutes.map((r, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                                            path: r.path,
                                            element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $58748985749d7181$export$2e2bcd8739ae039), {
                                                isPublic: r.isPublic,
                                                requiredRole: r.requiredRole,
                                                Component: r.Component
                                            })
                                        }, index)),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Navigate), {
                                            to: (0, $b1v75.AuthRoutes).Home
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2ede171af289ecae$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $a485679c9e5fd690$export$2e2bcd8739ae039), {})
                        ]
                    })
                })
            })
        })
    });
}



var $l73V3 = parcelRequire("l73V3");
parcelRequire("cGdze");
var $kJ26n = parcelRequire("kJ26n");

var $8Qw6M = parcelRequire("8Qw6M");

var $lj0SF = parcelRequire("lj0SF");
var $a1cb493b688bbf07$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0, $lj0SF.getApolloContext)();
    var parentContext = $8Qw6M.useContext(ApolloContext);
    var context = $8Qw6M.useMemo(function() {
        return (0, $l73V3.__assign)((0, $l73V3.__assign)({}, parentContext), {
            client: client || parentContext.client
        });
    }, [
        parentContext,
        client
    ]);
    (0, $kJ26n.invariant)(context.client, 46);
    return $8Qw6M.createElement(ApolloContext.Provider, {
        value: context
    }, children);
};



var $dHPFu = parcelRequire("dHPFu");
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
"use strict";

var $6afFj = parcelRequire("6afFj");
var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $6afFj.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $6afFj.hydrateRoot;



var $4WYaH = parcelRequire("4WYaH");

var $bh6RR = parcelRequire("bh6RR");


var $cNBED = parcelRequire("cNBED");

var $9fFmW = parcelRequire("9fFmW");

var $ih19M = parcelRequire("ih19M");
"use client";
const $db4ccd4732c544e1$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $4WYaH.default)({
        WebkitFontSmoothing: "antialiased",
        // Antialiasing.
        MozOsxFontSmoothing: "grayscale",
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: "border-box",
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: "100%"
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $db4ccd4732c544e1$export$32180ef41b15b513 = (theme)=>(0, $4WYaH.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $db4ccd4732c544e1$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, "")] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $4WYaH.default)({
        html: $db4ccd4732c544e1$export$c0bb0b647f701bb5(theme, enableColorScheme),
        "*, *::before, *::after": {
            boxSizing: "inherit"
        },
        "strong, b": {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $4WYaH.default)({
            margin: 0
        }, $db4ccd4732c544e1$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $db4ccd4732c544e1$var$CssBaseline(inProps) {
    const props = (0, $cNBED.default)({
        props: inProps,
        name: "MuiCssBaseline"
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $ih19M.jsxs)($bh6RR.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $9fFmW.default), {
                styles: (theme)=>$db4ccd4732c544e1$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $db4ccd4732c544e1$export$2e2bcd8739ae039 = $db4ccd4732c544e1$var$CssBaseline;


const $d0bb92445f8cf837$var$container = document.getElementById("app");
const $d0bb92445f8cf837$var$root = (0, $6fc264ec92100d3a$export$882461b6382ed46c)($d0bb92445f8cf837$var$container);
$d0bb92445f8cf837$var$root.render(/*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).StrictMode, {
    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $a1cb493b688bbf07$export$c16b04c8a9956446), {
        client: (0, $dHPFu.default),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $db4ccd4732c544e1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $16e924f086a574be$export$86fbec116b87613f), {})
        ]
    })
}));


//# sourceMappingURL=index.00331147.js.map
